/******/ (function(modules) { // webpackBootstrap
/******/ 	// install a JSONP callback for chunk loading
/******/ 	var parentJsonpFunction = window["webpackJsonp"];
/******/ 	window["webpackJsonp"] = function webpackJsonpCallback(chunkIds, moreModules) {
/******/ 		// add "moreModules" to the modules object,
/******/ 		// then flag all "chunkIds" as loaded and fire callback
/******/ 		var moduleId, chunkId, i = 0, callbacks = [];
/******/ 		for(;i < chunkIds.length; i++) {
/******/ 			chunkId = chunkIds[i];
/******/ 			if(installedChunks[chunkId])
/******/ 				callbacks.push.apply(callbacks, installedChunks[chunkId]);
/******/ 			installedChunks[chunkId] = 0;
/******/ 		}
/******/ 		for(moduleId in moreModules) {
/******/ 			var _m = moreModules[moduleId];
/******/
/******/ 			// Check if module is deduplicated
/******/ 			switch(typeof _m) {
/******/ 			case "object":
/******/ 				// Module can be created from a template
/******/ 				modules[moduleId] = (function(_m) {
/******/ 					var args = _m.slice(1), templateId = _m[0];
/******/ 					return function (a,b,c) {
/******/ 						modules[templateId].apply(this, [a,b,c].concat(args));
/******/ 					};
/******/ 				}(_m));
/******/ 				break;
/******/ 			case "function":
/******/ 				// Normal module
/******/ 				modules[moduleId] = _m;
/******/ 				break;
/******/ 			default:
/******/ 				// Module is a copy of another module
/******/ 				modules[moduleId] = modules[_m];
/******/ 				break;
/******/ 			}
/******/ 		}
/******/ 		if(parentJsonpFunction) parentJsonpFunction(chunkIds, moreModules);
/******/ 		while(callbacks.length)
/******/ 			callbacks.shift().call(null, __webpack_require__);
/******/
/******/ 	};
/******/
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// object to store loaded and loading chunks
/******/ 	// "0" means "already loaded"
/******/ 	// Array means "loading", array contains callbacks
/******/ 	var installedChunks = {
/******/ 		0:0
/******/ 	};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/ 	// This file contains only the entry chunk.
/******/ 	// The chunk loading function for additional chunks
/******/ 	__webpack_require__.e = function requireEnsure(chunkId, callback) {
/******/ 		// "0" is the signal for "already loaded"
/******/ 		if(installedChunks[chunkId] === 0)
/******/ 			return callback.call(null, __webpack_require__);
/******/
/******/ 		// an array means "currently loading".
/******/ 		if(installedChunks[chunkId] !== undefined) {
/******/ 			installedChunks[chunkId].push(callback);
/******/ 		} else {
/******/ 			// start chunk loading
/******/ 			installedChunks[chunkId] = [callback];
/******/ 			var head = document.getElementsByTagName('head')[0];
/******/ 			var script = document.createElement('script');
/******/ 			script.type = 'text/javascript';
/******/ 			script.charset = 'utf-8';
/******/ 			script.async = true;
/******/
/******/ 			script.src = __webpack_require__.p + "static/js/" + ({"1":"designer_dependencies","2":"./Dashboard","3":"health_care_directive"}[chunkId]||chunkId) + "." + {"1":"474aa8c4","2":"ffccbc8e","3":"c545ce49"}[chunkId] + ".chunk.js";
/******/ 			head.appendChild(script);
/******/ 		}
/******/ 	};
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ((function(modules) {
	// Check all modules for deduplicated modules
	for(var i in modules) {
		if(Object.prototype.hasOwnProperty.call(modules, i)) {
			switch(typeof modules[i]) {
			case "function": break;
			case "object":
				// Module can be created from a template
				modules[i] = (function(_m) {
					var args = _m.slice(1), fn = modules[_m[0]];
					return function (a,b,c) {
						fn.apply(this, [a,b,c].concat(args));
					};
				}(modules[i]));
				break;
			default:
				// Module is a copy of another module
				modules[i] = modules[modules[i]];
				break;
			}
		}
	}
	return modules;
}([
/* 0 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(544);
	__webpack_require__(341);
	module.exports = __webpack_require__(1167);


/***/ },
/* 1 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	if (true) {
	  module.exports = __webpack_require__(1356);
	} else {
	  module.exports = require('./cjs/react.development.js');
	}


/***/ },
/* 2 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = requiredArgs;
	
	function requiredArgs(required, args) {
	  if (args.length < required) {
	    throw new TypeError(required + ' argument' + (required > 1 ? 's' : '') + ' required, but only ' + args.length + ' present');
	  }
	}
	
	module.exports = exports.default;

/***/ },
/* 3 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = toDate;
	
	var _index = _interopRequireDefault(__webpack_require__(2));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name toDate
	 * @category Common Helpers
	 * @summary Convert the given argument to an instance of Date.
	 *
	 * @description
	 * Convert the given argument to an instance of Date.
	 *
	 * If the argument is an instance of Date, the function returns its clone.
	 *
	 * If the argument is a number, it is treated as a timestamp.
	 *
	 * If the argument is none of the above, the function returns Invalid Date.
	 *
	 * **Note**: *all* Date arguments passed to any *date-fns* function is processed by `toDate`.
	 *
	 * @param {Date|Number} argument - the value to convert
	 * @returns {Date} the parsed date in the local time zone
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // Clone the date:
	 * const result = toDate(new Date(2014, 1, 11, 11, 30, 30))
	 * //=> Tue Feb 11 2014 11:30:30
	 *
	 * @example
	 * // Convert the timestamp to date:
	 * const result = toDate(1392098430000)
	 * //=> Tue Feb 11 2014 11:30:30
	 */
	function toDate(argument) {
	  (0, _index.default)(1, arguments);
	  var argStr = Object.prototype.toString.call(argument); // Clone the date
	
	  if (argument instanceof Date || typeof argument === 'object' && argStr === '[object Date]') {
	    // Prevent the date to lose the milliseconds when passed to new Date() in IE10
	    return new Date(argument.getTime());
	  } else if (typeof argument === 'number' || argStr === '[object Number]') {
	    return new Date(argument);
	  } else {
	    if ((typeof argument === 'string' || argStr === '[object String]') && typeof console !== 'undefined') {
	      // eslint-disable-next-line no-console
	      console.warn("Starting with v2.0.0-beta.1 date-fns doesn't accept strings as arguments. Please use `parseISO` to parse strings. See: https://git.io/fjule"); // eslint-disable-next-line no-console
	
	      console.warn(new Error().stack);
	    }
	
	    return new Date(NaN);
	  }
	}
	
	module.exports = exports.default;

/***/ },
/* 4 */
/***/ function(module, exports, __webpack_require__) {

	var global = __webpack_require__(17);
	var core = __webpack_require__(54);
	var hide = __webpack_require__(40);
	var redefine = __webpack_require__(41);
	var ctx = __webpack_require__(55);
	var PROTOTYPE = 'prototype';
	
	var $export = function (type, name, source) {
	  var IS_FORCED = type & $export.F;
	  var IS_GLOBAL = type & $export.G;
	  var IS_STATIC = type & $export.S;
	  var IS_PROTO = type & $export.P;
	  var IS_BIND = type & $export.B;
	  var target = IS_GLOBAL ? global : IS_STATIC ? global[name] || (global[name] = {}) : (global[name] || {})[PROTOTYPE];
	  var exports = IS_GLOBAL ? core : core[name] || (core[name] = {});
	  var expProto = exports[PROTOTYPE] || (exports[PROTOTYPE] = {});
	  var key, own, out, exp;
	  if (IS_GLOBAL) source = name;
	  for (key in source) {
	    // contains in native
	    own = !IS_FORCED && target && target[key] !== undefined;
	    // export native or passed
	    out = (own ? target : source)[key];
	    // bind timers to global for call from export context
	    exp = IS_BIND && own ? ctx(out, global) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
	    // extend global
	    if (target) redefine(target, key, out, type & $export.U);
	    // export
	    if (exports[key] != out) hide(exports, key, exp);
	    if (IS_PROTO && expProto[key] != out) expProto[key] = out;
	  }
	};
	global.core = core;
	// type bitmap
	$export.F = 1;   // forced
	$export.G = 2;   // global
	$export.S = 4;   // static
	$export.P = 8;   // proto
	$export.B = 16;  // bind
	$export.W = 32;  // wrap
	$export.U = 64;  // safe
	$export.R = 128; // real proto method for `library`
	module.exports = $export;


/***/ },
/* 5 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	var createIconComponent = function createIconComponent(_ref) {
	  var content = _ref.content,
	      _ref$height = _ref.height,
	      height = _ref$height === void 0 ? '70' : _ref$height,
	      _ref$width = _ref.width,
	      width = _ref$width === void 0 ? '70' : _ref$width;
	  return function (props) {
	    return _react["default"].createElement("svg", _extends({}, props, {
	      className: "svg-icon ".concat(props.className !== '' ? props.className : ''),
	      viewBox: "0 0 ".concat(width, " ").concat(height)
	    }), content);
	  };
	};
	
	var _default = createIconComponent;
	exports["default"] = _default;

/***/ },
/* 6 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.VERIFY_EMAIL_ADDRESS = exports.CLEAR_FAILED_WEB_CART_BY_REF_NUM = exports.GET_REGULATED_WORD_LISTS = exports.GET_VERSION_INFO = exports.PROCESS_ELAVON_PAYMENT = exports.GET_ELAVON_TOKEN_BY_ITEM_GUIDS = exports.GET_ELAVON_TOKEN_BY_REF_NUM = exports.GET_FREQUENT_PAYOR_STATEMENT = exports.GET_FREQUENT_PAYOR_WEBCART_FROM_AMOUNT = exports.WEB_CART_GUIDS_TRANSACTION_WITH_FREQUENT_PAYOR = exports.WEB_CART_TRANSACTION_WITH_FREQUENT_PAYOR = exports.UPDATE_FREQUENT_PAYOR_ADDRESS = exports.GET_CURRENT_USER_FREQUENT_PAYOR_ACCOUNT = exports.SET_WEB_USER_ACCESS_LEVEL = exports.SET_XML_PAYROC_DELETE_PAYMENT_METHOD = exports.SET_XML_PAYROC_DEFAULT_PAYMENT_METHOD = exports.ADD_XML_PAYROC_PAYMENT_METHOD = exports.GET_XML_PAYROC_CUSTOMER = exports.GET_UCC_XML_USERS = exports.GET_HAS_FARM_BILL_SUBSCRIPTION = exports.GET_ACTIVE_DIRECTORY_LOGIN_CALLBACK = exports.GET_ACTIVE_DIRECTORY_REDIRECT = exports.GET_EPASS_LOGIN_CALLBACK = exports.UPDATE_DATA_REQUEST = exports.GET_MY_DATA_REQUESTS = exports.GET_DATA_REQUEST_WIZARDS = exports.DELETE_PAYROC_CUSTOMER_PAYMENT_SOURCE = exports.CREATE_PAYROC_CUSTOMER_PAYMENT_SOURCE = exports.CREATE_PAYROC_TRANSACTION = exports.GET_PAYROC_CUSTOMER = exports.UPDATE_WEB_USER = exports.GET_LIENS_SEARCH_WEB_CART = exports.GET_DASHBOARD_DATA = exports.SEARCH_UCC_INFO_REQ = exports.VERIFY_CERTIFICATE = exports.GET_AVAILABLE_PAYMENT_METHODS = exports.GET_REPORTS_BY_WEB_CART_REF_NUM = exports.GET_WEB_CART_BY_CERTIFICATION_ID = exports.CREATE_CERTIFICATION = exports.GET_CERTIFICATION_CONFIG = exports.GET_PAYPAL_PAYMENT_STATUS = exports.GET_ACCESS_ID_LOC_PAYMENT_STATUS = exports.GET_ACCESS_ID_CC_PAYMENT_STATUS = exports.GET_APOSTILLE_RECORD = exports.GET_HCDR_RECORD = exports.GET_AVAILABLE_LISTS = exports.GET_LOBBYIST_ENTITIES_BY_ID = exports.GET_LOBBYISTS_BY_SEARCH_AND_RANGE = exports.GET_RECORD_HISTORY = exports.GET_MERGE_CODES_BY_ARRAY = exports.GET_ALL_MERGE_CODES = exports.GET_DATA_TABLE_BY_ID = undefined;
	exports.GET_DATA_TABLES = exports.GET_SERVER_DATES = exports.CREATE_ACCESSIDLOC_PAYMENT = exports.CREATE_ACCESSIDCC_PAYMENT = exports.GET_PAYPAL_TOKEN = exports.GET_REPORT_BY_REPORT_OBJECT = exports.GET_REPORTS = exports.GET_REPORT_BY_JSON = exports.GET_REPORT_PREVIEW = exports.GET_NOTARY_RENEWAL_FORM_DEFINITION_ID = exports.GET_TRADEMARK_RENEWAL_FORM_DEFINITION_ID = exports.GET_LOBBYIST_RENEWAL_FORM_DEFINITION_ID = exports.GET_CHARITABLE_RENEWAL_FORM_DEFINITION_ID = exports.GET_CHARITABLE_AR_FORM_DEFINITION_ID = exports.GET_CONTRACTOR_RENEWAL_FORM_DEFINITION_ID = exports.GET_REINSTATEMENT_FORM_DEFINITION_ID = exports.GET_AR_FORM_ACCESS_LEVEL = exports.GET_AR_FORM_DEFINITION_ID = exports.GET_AVAILABLE_AMENDMENTS = exports.REVOKE_RECORD_ACCESS = exports.ACCEPT_RECORD_ACCESS_REQUEST = exports.REJECT_RECORD_ACCESS_REQUEST = exports.GET_USER_HAS_ALREADY_REQUESTED_WEB_USER_ACCESS = exports.REQUEST_RECORD_ACCESS = exports.GET_RECORD_HAS_ACTIVE_PIN = exports.GET_RECORD_HAS_OWNERS = exports.GET_WEB_USER_IS_RECORD_OWNER = exports.GET_WEB_USER_ACCESS_WITH_GENERIC_PIN = exports.GET_WEB_USER_ACCESS_WITH_PIN = exports.REQUEST_NEW_PIN = exports.GET_RECORD_PINS = exports.GET_WEB_USER_ACCESS_LIST = exports.GET_WEB_USER_RECORD = exports.SEARCH_BY_KEY = exports.BYPASS_PAYMENT = exports.POST_PAYMENT = exports.GET_WEB_USER_ACTIVE_CART = exports.REMOVE_FROM_WEB_CART_BY_GUID = exports.GET_WEB_CART_BY_REF_NUM = exports.GET_RECEIPT_ITEMS_BY_ADMENDMENT_NUM = exports.EXTEND_WEB_USER_SESSION = exports.GET_AUTH_STATE = exports.LOGOUT_WEB_USER = exports.LOGIN_APP_USER = exports.LOGIN_WEB_USER = exports.PARSE_PASSWORD_RESET_TOKEN = exports.CHANGE_PASSWORD = exports.SEND_FORGOT_USERNAME_EMAIL = exports.SEND_PASSWORD_RESET_EMAIL = exports.CREATE_WEB_USER = exports.UPDATE_APP_SETTING_BY_ID = exports.SAVE_APP_SETTING_BY_NAME = exports.GET_AVAILABLE_APP_SETTINGS = exports.GET_APP_SETTINGS_BY_NAME = exports.GET_APP_SETTING_BY_NAME = exports.GET_HOME_PAGE_STRUCTURE = exports.DELETE_RECORD_BY_ID = exports.LOAD_AMENDMENT_BY_ID = exports.LOAD_DRAFT_BY_ID = exports.DELETE_DRAFT_BY_ID = exports.SAVE_DRAFT = exports.GET_FILING_TYPE_IDS = exports.SAVE_SIGNATURE_BY_TOKEN_AND_CATEGORY = exports.RESEND_SIGNER_EMAIL = exports.GET_SIGNATURE_FORM_BY_TOKEN = exports.SET_SIGNER_EMAIL_BY_TOKEN = exports.GET_SIGNATURES_BY_GROUP_TOKEN = exports.SAVE_RECORD_WITH_SIGNATURES = exports.SAVE_RECORD = exports.GET_WORK_QUEUE_DESCRIPTION = exports.GET_WORK_QUEUE_ITEMS = exports.GET_BY_ID = exports.GET_REGISTERED_AGENT_BY_ID = exports.SEARCH_REGISTERED_AGENTS = exports.UPLOAD_FILES = exports.ARCHIVE_WIZARD = exports.CLONE_WIZARD = exports.SAVE_WIZARD = exports.LOAD_WIZARD_INJECT_METADATA = exports.LOAD_WIZARD_REVISION_STEPS_BY_ID = exports.LOAD_WIZARD_HISTORY_BY_ID = exports.LOAD_WIZARD_BY_ID = exports.VALIDATE = exports.GET_GROUP_ITEMS = exports.GET_LOOKUP_SUB_GROUPS = exports.GET_LOOKUP_GROUPS = exports.GET_ALL_WIZARDS = exports.GET_FILING_DETAILS = exports.GET_MY_RECEIPT_REPORT_DETAILS = exports.GET_MY_RECEIPTS_DETAILS = exports.GET_MY_RECEIPTS = exports.GET_FARM_BILL_RECORD_DETAILS = exports.GET_MY_RECORDS_DESCRIPTION = exports.GET_MY_RECORDS = exports.GET_SEARCH_DESCRIPTION = exports.SEARCH = exports.GET = exports.BASE_URL = exports.DEV_API_URL = exports.DEV_PORT = undefined;
	
	var _utilities = __webpack_require__(8);
	
	var _AuthActions = __webpack_require__(66);
	
	var _SearchActions = __webpack_require__(469);
	
	var _MyWorkQueueActions = __webpack_require__(463);
	
	var _MyRecordsActions = __webpack_require__(461);
	
	var _store = __webpack_require__(18);
	
	var _store2 = _interopRequireDefault(_store);
	
	var _uuid = __webpack_require__(1512);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var DEV_PORT = exports.DEV_PORT = 53013;
	var DEV_API_URL = exports.DEV_API_URL = ({"NODE_ENV":"production","BUILD_DATE":"2025-08-27T15:15:31.687Z","BUILD_NUMBER":"Not Provided","GIT_VERSION":"v1.3.0-381-ga81e29b08","GIT_COMMIT_HASH":"a81e29b085c9268ffd96c78eb734365802722741","GIT_BRANCH":"beta","PUBLIC_URL":"","STATE_ABBR":"MT","STATE_NAME":"Montana","STATE_ORG_TITLE":"Secretary of State","LOGIN_HEADER_IMG_PATH":"","HOME_IMG_FILENAME":"montana.jpg","FAVICON_FILE_NAME":"favicon.ico","ALLOW_E_SIGN_ON_CORRECTIONS":true,"THIRD_PARTY_SIGNING_ALLOWED":false,"MY_ACCOUNT_SAVE_AND_CLOSE_BUTTON":true,"IE_DEPRECATED_MESSAGE":"Internet Explorer is not supported. Please select a supported browser below to access this website.","ADDITIONAL_ROUTES":{"dataRequests":true,"farmBill":true,"apostille":true,"externalHelp":"https://sosmt.gov/business/help-center/","systemAdministration":[{"title":"Saved Payments","parameter":"saved-payments","componentName":"SavedPayments"}]},"SUBROUTES":[{"label":"Business","component":"Business","parameter":"business","myWorkQueueSearch":false,"sourceTypeId":54,"searchMustHaveOneOf":["FILING_TYPE_ID","STATUS_ID","STATE","search"],"serverWebSearchDescription":true,"serverWorkQueueDescription":true,"serverMyRecordsDescription":true,"searchPlaceholder":"Search by name or filing number (X########)","allowEmptySearchTerm":true,"requestCertificateAlternateLabel":"Request Information","fileAmendmentButtonLabel":"Filing Actions","advancedSearchParameters":[{"type":"radio","name":"QUERY_TYPE_ID","defaultValue":1010,"options":[{"value":1010,"label":"Starts with"},{"value":1011,"label":"Contains"},{"value":1012,"label":" Word Contains"}]},{"type":"serverSelect","name":"FILING_TYPE_ID","optionsSrc":"FILING_TYPES","label":"Entity Type","placeholder":"All","defaultValue":"0"},{"type":"serverSelect","name":"FILING_SUBTYPE_ID","optionsSrc":"FILING_SUBTYPES","label":"Entity Subtype","overrideSubOptionsSrcFromParameterName":"FILING_TYPE_ID","placeholder":"All","defaultValue":"0"},{"type":"serverSelect","name":"STATUS_ID","optionsSrc":"FILING_STATUS_WITHOUT_ALL","label":"Status","placeholder":"All","defaultValue":"0"},{"type":"serverSelect","name":"STATE","optionsSrc":"STATE","label":"State","placeholder":"All","defaultValue":""},{"type":"serverSelect","name":"COUNTY","optionsSrc":"COUNTY_SUBOPTION","label":"County","overrideSubOptionsSrcFromParameterName":"STATE","placeholder":"All","defaultValue":""},{"type":"checkbox","name":"CRA_SEARCH_YN","defaultValue":false,"label":"Search by Registered Agent PID"},{"type":"dateRange","name":"FILING_DATE","label":"Registration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}},{"type":"dateRange","name":"EXPIRATION_DATE","label":"Expiration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}}],"myRecordsFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Active"},{"value":2,"label":"Inactive"},{"value":3,"label":"Pending"}]},{"type":"dateRange","name":"DATE_RANGE","label":"Date range","defaultValue":{"start":null,"end":null}}],"myWorkQueueFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Approved"},{"value":2,"label":"Pending Online Payment"},{"value":3,"label":"Pending Review"},{"value":4,"label":"Needs Correction"},{"value":5,"label":"Rejected"},{"value":6,"label":"Draft"}]},{"type":"dateRange","name":"DATE_RANGE","label":"Date range","defaultValue":{"start":null,"end":null}}]},{"label":"Notary","component":"Notary","parameter":"notary","sourceTypeId":850,"myWorkQueueSearch":false,"allowEmptySearchTerm":true,"requestCertificateAlternateLabel":"Download Certificate","fileAmendmentButtonLabel":"Filing Actions","hideNameRequestCertificate":true,"hideAddressRequestCertificate":true,"hideRecordUserManagment":true,"searchPlaceholder":"Search by name or commission number","searchMustHaveOneOf":["CITY","search","SERVICE_TYPE"],"advancedParametersStartOpen":true,"searchIsSortable":true,"advancedSearchParameters":[{"type":"radio","name":"STARTS_WITH_YN","defaultValue":false,"options":[{"value":true,"label":"Starts with"},{"value":false,"label":"Contains"}]},{"type":"checkbox","name":"ACTIVE_ONLY_YN","defaultValue":true,"label":"Active entities only"},{"type":"text","name":"CITY","defaultValue":"","label":"City"},{"type":"select","name":"SERVICE_TYPE","label":"Special Services Offered","defaultValue":0,"options":[{"value":0,"label":"(N/A)"},{"value":6165,"label":"In-Person Electronic Notarization (IPEN)"},{"value":6166,"label":"Remote Online Notarization (RON)"},{"value":6167,"label":"Mobile Notary Services"},{"value":6168,"label":"Remote Ink Notarization (RIN)"}]}]},{"label":"Apostille","component":"Apostille","parameter":"apostille","sourceTypeId":720,"myRecordsSearch":false,"myWorkQueueSearch":false,"disabled":false,"allowedRoutes":["/forms-manager/","/queue/","/forms/"]},{"label":"Liens","component":"UCC","parameter":"ucc","sourceTypeId":1999,"myRecordsSearch":true,"myWorkQueueSearch":true,"fileAmendmentButtonLabel":"Filing Actions","searchPlaceholder":"Search by name or file number","disabled":false,"serverWebSearchDescription":true,"myRecordsDescription":"","workQueueDescription":"","searchDescription":"","hideRecordUserManagment":true,"searchLiensCheckout":false,"advancedSearchParameters":[{"type":"radio","name":"STARTS_WITH_YN","defaultValue":false,"options":[{"value":true,"label":"Starts with"},{"value":false,"label":"Contains"}]},{"type":"select","name":"STATUS","defaultValue":"ALL","label":"Status","options":[{"value":"ACTIVE_UNLAPSED","label":"Active (unlapsed)"},{"value":"ACTIVE_LAPSED_UNLAPSED","label":"Active (lapsed and unlapsed)"}]},{"type":"text","name":"EXCLUDE_VALUES","label":"Exclude Debtor Names (comma separated list of names to exclude)","defaultValue":""},{"type":"dateRange","name":"FILING_DATE","label":"Financing Statement Date","defaultValue":{"start":null,"end":null}},{"type":"dateRange","name":"LAPSE_DATE","label":"Lapse Date","defaultValue":{"start":null,"end":null}},{"type":"text","name":"CITY","label":"Debtor City","defaultValue":""}],"myRecordsFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Approved"},{"value":2,"label":"Pending Online Payment"},{"value":3,"label":"Pending Review"}]},{"type":"select","name":"TYPE","defaultValue":0,"label":"Lien Type","options":[{"value":0,"label":"All"},{"value":1,"label":"UCC"},{"value":2,"label":"EFS"},{"value":3,"label":"Title 71"}]}],"myWorkQueueFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Approved"},{"value":2,"label":"Pending Online Payment"},{"value":3,"label":"Pending Review"},{"value":4,"label":"Pending Print and Mail"},{"value":5,"label":"Rejected"},{"value":6,"label":"Draft"}]},{"type":"select","name":"TYPE","defaultValue":0,"label":"Lien Type","options":[{"value":0,"label":"All"},{"value":1,"label":"UCC"},{"value":2,"label":"EFS"},{"value":3,"label":"Title 71"}]}]},{"label":"Copy Request","component":"copies","parameter":"copies","sourceTypeId":2001,"myRecordsSearch":false,"myWorkQueueSearch":false,"disabled":false,"allowedRoutes":["/forms-manager/","/queue/","/forms/"]},{"label":"Trademark","component":"Trademark","parameter":"trademark","sourceTypeId":810,"showRequestCertificate":true,"searchMustHaveOneOf":["search","EXPIRATION_DATE","FILING_DATE"],"allowEmptySearchTerm":true,"requestCertificateAlternateLabel":"Request Information","fileAmendmentButtonLabel":"Filing Actions","advancedSearchParameters":[{"type":"radio","name":"QUERY_TYPE_ID","defaultValue":1010,"options":[{"value":1010,"label":"Starts with"},{"value":1011,"label":"Contains"},{"value":1012,"label":" Word Contains"}]},{"type":"checkbox","name":"OWNER_SEARCH_YN","defaultValue":false,"label":"Search owners"},{"type":"radio","name":"SERVICE_MARK_YN","label":"Mark Type","defaultValue":"","options":[{"value":"","label":"All Marks"},{"value":"Y","label":"Service Mark"},{"value":"N","label":"Trademark"}]},{"type":"serverSelect","name":"STATUS_ID","optionsSrc":"TYPE_V|TRADEMARK_STATUS_TYPE","label":"Status","placeholder":"All","defaultValue":"0"},{"type":"select","name":"DESIGN_TYPE_ID","options":[{"value":0,"label":"All"},{"value":990,"label":"Words Only"},{"value":991,"label":"Design Only"},{"value":992,"label":"Words and Design"}],"label":"Design Type","defaultValue":"0"},{"type":"dateRange","name":"FILING_DATE","label":"Registered Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}},{"type":"dateRange","name":"EXPIRATION_DATE","label":"Expiration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}}]},{"label":"Business Info Request","component":"InfoRequests","parameter":"info-request","sourceTypeId":167,"allowedRoutes":["/forms-manager/","/queue/","/forms/"]},{"label":"Data Requests","component":"DataRequests","parameter":"data-request","sourceTypeId":0,"allowedRoutes":["/forms-manager/"]},{"label":"CRA","component":"CRA","parameter":"cra","sourceTypeId":157,"myRecordsSearch":false,"searchPlaceholder":"Search by name or registered agent number","allowedRoutes":["/forms-manager/","/forms/","/records/","/queue/","/search/"],"allowEmptySearchTerm":true,"fileAmendmentButtonLabel":"Filing Actions","advancedSearchParameters":[{"type":"radio","name":"QUERY_TYPE_ID","defaultValue":1010,"options":[{"value":1010,"label":"Starts with"},{"value":1011,"label":"Contains"},{"value":1012,"label":" Word Contains"}]},{"type":"dateRange","name":"CRA_DATE","label":"Registration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}},{"type":"select","name":"STATUS_ID","label":"Status","defaultValue":0,"options":[{"value":0,"label":"All"},{"value":121,"label":"Active"},{"value":122,"label":"Inactive"}]},{"type":"select","name":"AGENT_TYPE_ID","label":"Agent Type","defaultValue":0,"options":[{"value":0,"label":"All"},{"value":460,"label":"Registered Agent"},{"value":461,"label":"Commercial Registered Agent"}]}]},{"label":"Farm Bill","component":"FarmBill","parameter":"farm-bill","path":"/lists/farm-bill","sourceTypeId":0,"myRecordsSearch":false,"allowedRules":["/search/"],"disabled":true,"searchDescription":"To perform a search, enter a debtor name. Your search results may include: exact debtor name, variations of that name and any filing that includes your search criteria. Punctuation is ignored.\n\nYou can click on \"Advanced\" to refine your search. Under “Advanced” you can search by crop, year, county and SSN/FEIN. As a registered Farm Bill Buyer with the Montana Secretary of State’s office it is important to maintain the confidentiality of the information contained within the Farm Bill Master List. The Farm Bill Master List reflects personal data, such as Social Security Numbers, which are a key piece of personal identifiable information to assist you in determining the existence of a lien against a specific debtor. The distribution of this information beyond its intended purpose is strictly prohibited.\n\nThe debtor's tax identification number has been hidden for confidentiality reasons. You may continue to search on a tax ID number and return debtors that match your search criteria. The SSN/FEIN must be entered without dashes or spaces.","searchMustHaveOneOf":["search","UCC_FARM_PRODUCT_ID","COUNTY"],"searchPlaceholder":"Search by debtor name","advancedSearchParameters":[{"type":"ServerMultiComplete","label":"Product code name(s)","name":"UCC_FARM_PRODUCT_ID","defaultValue":"","optionsSrc":"UCC_FARM_PRODUCT_V"},{"type":"MultiComplete","label":"Year or Range of Years","name":"YEAR_NUM","optionsSrc":"years","startYear":"1968","defaultValue":[],"preMergeOptions":[{"value":"ALL","label":"All"}]},{"type":"serverSelect","label":"State","name":"STATE","defaultValue":"MONTANA","optionsSrc":"STATE"},{"type":"ServerMultiComplete","label":"County","name":"COUNTY","defaultValue":[],"optionsSrc":"COUNTY","overrideSubOptionsSrcFromParameterName":"STATE"},{"type":"checkbox","name":"TIN_SEARCH_YN","defaultValue":false,"label":"Tax Identification Number Search"},{"type":"checkbox","name":"TIN_SORT_YN","defaultValue":false,"label":"Unique ID Sort"}]}],"SYSTEM_NICKNAME":"Online Services Portal","PAYMENT_METHODS":[{"type":"bypass"},{"type":"iTransact"}],"PAYMENT_ALLOW_AMEX":true,"SYSTEM_ID_LABEL":"System Id","DOUBLE_COLUMN_PUBLIC_LOGIN":true,"INTERNAL_USER_MANAGEMENT":true,"ALLOW_PUBLIC_JSON_IMPORT":false,"MAX_FILE_UPLOAD_SIZE":10000000,"REFUND_TEXT":"","RETURN_TO_HOME_ON_LOGOUT":true,"CURRENT_SOS_NAME":"Christi Jacobsen","LOGO_FILENAME":"mt-sos-logo.png","LOGO_ALT":"Christi Jacobsen, Montana Secretary of State","LOGO_FULL_WIDTH":true,"HOME_HIDE_AUTH_HINT":true,"HOME_TITLE":"Montana Secretary of State","CUSTOM_TAB_TITLE":"Official Montana","HOME_SUBTITLE":"Online Business Services","ENTITY_NAME_CONSENT_DESCRIPTION":"","ALLOW_USER_PROFILE_EDITING":true,"COMPARE_FOREIGN_NAME_IN_ENTITY_NAME_VALIDATION":true,"FOREIGN_NAME_FIELD_NAME":"KIMA_PARENT_NAME_INFO","LOGIN_TITLE":"Montana Secretary of State Online Filing Portal Login","PUBLIC_LOGIN_LABEL":"Username","REVERSE_LOGIN_COLUMNS":true,"LOGIN_SEAL_FILENAME":"seal_white.png","SEPARATE_USERNAME_AND_EMAIL":true,"CREATE_ACCOUNT_BUTTON_ALIGN_LEFT":true,"CREATE_ACCOUNT_BUTTON_TEXT":"CREATE AN ACCOUNT","PASSWORD_CUSTOM_ERROR_TEXT":"The password must meet all requirements","ACCOUNT_CREATED_MESSAGE":"Please check your email to verify your account to login and allow a few minutes for this message to arrive. Check your junk/spam folders if you do not find the email in your inbox.","PUBLIC_LOGIN_PLACEHOLDER":" ","DISABLE_DEFAULT_PAYMENT_RADIO":true,"CUSTOM_RESET_PASSWORD_ERROR_MESSAGE":"Username invalid - no account found","PUBLIC_LOGIN_CREATE_DESCRIPTION":"### Existing User:\n\n  - Enter your username and password to login.  \n\n\n  #### - OR -  \n\n\n\n  - Forgot password? Click 'Reset Password' and follow the prompts.\n  - Forgot username? Click 'Forgot Username' and follow the prompts.  \n\n\n  ### New User:\n  ","LOGIN_HELP_LINK":"https://sosmt.gov/business/how-do-i/","LOGIN_HELP_LINK_TEXT":"Need Help?","FORGOT_USERNAME_TEXT":"Forgot Username?","LOGIN_ACTIVE_DIRECTORY_TEXT":"State User Login","MULTIPLE_LOGIN_METHODS":true,"HAS_ACTIVE_DIRECTORY_LOGIN":true,"RESET_PASSWORD_WITH_USERNAME":true,"DOWNLOAD_LINK":true,"SHOW_USERNAME_ACCOUNT_CREATE":true,"SHOW_SCROLL_DOWN_ARROW":true,"SHOW_ADDRESS_ACCOUNT_CREATE":true,"TWO_COLUMN_ACCOUNT_CREATE":true,"RESET_PASSWORD_TIP":"A link to change your password has been sent to your email. Please allow a few minutes for this message to arrive. Please check your junk/spam folders if you do not find the email in your inbox.","FORGOT_PASSWORD_LINK_TEXT":"Reset Password","PHONE_NUMBER_OPTIONAL_ACCOUNT_CREATE":true,"SHOW_REQUIRED_INDICATOR_ACCOUNT_CREATE":true,"PASSWORD_REQUIREMENTS_ACCOUNT_CREATE":"\n    <ul>\n      <li>MUST contain at least 8 characters (12+ recommended)</li>\n      <li>MUST contain at least one uppercase letter.</li>\n      <li>MUST contain at least one lowercase letter.</li>\n      <li>MUST contain at least one number.</li>\n      <li>MUST contain at least one special character (!”#$%&'()*+,-./:;<=>?</li>\n    </ul>\n  ","ALLOW_CERTIFICATION_REQUEST":true,"ALLOW_PUBLIC_CERTIFICATE_REQUEST":true,"ALLOW_COPY_REQUEST":false,"ALLOW_CORRECTION_STYLING":true,"HIDE_DEPRECATION_WARNING":false,"AMEND_ROUTE_PUBLIC":true,"SEAL_FILENAME":"seal.png","SHOPPING_CART":true,"ALLOW_PAYMENT_UPDATE_WITH_EMPTY_CART":true,"RA_EMAIL":true,"RA_WEBSITE":true,"RA_NO_DEFAULT_TYPE":true,"RA_ADDRESS_LABEL":"Street Address","RA_TYPE_SELECTION_DEFAULT":true,"RA_DEFAULT_TYPE":"460","RA_OVERRIDE_TYPE_WITH_DEFAULT":true,"RA_PRINCIPAL_ADDRESS_AMS":true,"UPLOAD_AND_SUBMIT_HIDE_IF_ONE_OPTION":true,"PAYMENT_PROCESSING_MESSAGE":"Your payment is processing - Do not close your browser or click the back button","CHECKOUT_BUTTON_WHEN_PROCESSING_TEXT":"Processing","EFS_CROP_PICKER_NONE_LABEL":"Lien Duration","DISALLOWED_WIZARD_PIECES":["FormationLocale"],"REPEATER_SHOW_EDIT_BUTTON":true,"DATA_REQUEST_PAGE_TITLE":"Data Requests and Subscriptions","DATA_REQUEST_SIDEBAR_LABEL":"Data Requests & Subscriptions","LOGIN_REDIRECTS_TO_EPASS":false,"LOGIN_REDIRECTS_TO_ACTIVE_DIRECTORY":true,"LOGIN_ACTIVE_DIRECTORY_LINK":true,"FETCH_EDIT_USER_LINK":false,"LISTS_FETCH_AVAILABLE_LISTS":true,"POST_WIZARD_SUBMIT_REDIRECT_URL":"/","PIN_REQUEST_ATTESTATIONS":true,"PIN_REQUEST_DESCRIPTION":"Click **Request PIN** to have a new PIN sent to the account holder's email address on file.","OWNERSHIP_REQUEST_DESCRIPTION":"To become an **authorized user** of this record, a current **AUTHORIZED USER** will need to grant you access. To request access, click **Request Access** below.","PIN_REQUEST_SUCCESS_MESSAGE":"The PIN you have requested for this entity has been sent to the email associated with your user account.  You should receive the PIN in approximately 3-5 minutes, depending on your email service provider.","APOSTILLE_HEADER_LABEL":"Verification Information","APOSTILLE_NUMBER_LABEL":"Apostille/Authentication","APOSTILLE_CITY_STATE_OVERRIDE":"HELENA, MT","APOSTILLE_FILING_DATE_LABEL":"Issue Date","APOSTILLE_CITY_STATE_IN_CERTIFIED":true,"NOTARY_EXISTING_FILING":true,"ALLOW_REVOKE_OWN_ACCESS_ONLY":false,"HIDE_CANCEL_ON_ONETIME_DATA_REQUESTS":true,"DATA_REQUESTS_IN_SHOPPING_CART":true,"WQ_ALLOW_EDIT_PENDING_PAYMENT":true,"WQ_CONFIRM_ON_DELETE":true,"WQ_DELETE_CONFIRM_MESSAGE":"Deleting this filing will forfeit any money already paid to the Secretary of State. This action is permanent and cannot be undone, are you sure you would like to delete?","PASS_ITEM_GUIDS_ON_CHECKOUT":true,"FORM_REVISION_HISTORY":true,"CHECKOUT_DISCLAIMER":"By entering your credit card and/or checking account information you (i) state that **you are an authorized user** of the credit card and/or electronic check and that the associated information entered (e.g., account holder name, account number, billing address) is accurate, (ii) **you authorize payment processor to charge the amount you have requested** to your credit card and/or funding account, and (iii) **acknowledge if a charge is declined or reversed you may also be assessed a customary charge** by the payment processor for such transactions.","FARM_BILL_SEARCH_CONFIDENTIAL":"As a registered Farm Bill Buyer with the Montana Secretary of State’s office it is important to maintain the confidentiality of the information contained within the Farm Bill Master List. The Farm Bill Master List reflects personal data, such as Social Security Numbers, which are a key piece of personal identifiable information to assist you in determining the existence of a lien against a specific debtor. The distribution of this information beyond its intended purpose is strictly prohibited.\n\n**The debtor's tax identification number has been hidden for confidentiality reasons. You may continue to search on a tax ID number and return debtors that match your search criteria. The SSN/FEIN must be entered without dashes or spaces.  If you need access to the tax identification number to clearly identify the debtor, please contact the UCC unit at (406) 444-3665.**","VIEW_HISTORY_BUTTON_ALT_TEXT":"View Filings","WIZARD_ERROR_TITLE_MESSAGE":"Form Error","FARM_BILL_SEARCH_INTERACTIVE":true,"USE_FARM_BILL_API":true,"DISALLOW_ASSIGN_SELF_AS_RA":true,"DISALLOW_ASSIGN_SELF_AS_PRINCIPAL":true,"USE_TRADEMARK_OWNER_VALIDATION":true,"USE_ALTERNATIVE_FOREIGN_ADDRESS_LABELS":true,"MY_RECEIPTS_FILTER":[{"type":"dateRange","name":"DATE_RANGE","label":"Date range","defaultValue":{"start":null,"end":null}},{"type":"text","name":"REF_NUM","defaultValue":"","label":"Reference Number"},{"type":"text","name":"RECEIPT_NUM","defaultValue":"","label":"Receipt Id"},{"type":"text","name":"AMOUNT","defaultValue":"","label":"Amount"},{"type":"select","name":"TYPE","defaultValue":"","label":"Payment Type","options":[{"value":"","label":"All"},{"value":"CC","label":"Credit Card"},{"value":"Check","label":"Check"}]}],"MY_RECEIPTS_SHOW_IN_SIDEBAR":true,"SHOW_MY_RECEIPTS_HELPER_TEXT":true,"MY_RECEIPTS_HELPER_LABEL":"About Receipt Search","MY_RECEIPTS_HELPER_TEXT":"You can search for receipts based on their descriptions, including the items paid for on the receipt. Use the filters to search for or filter specific information.","FARM_BILL_SUBLINK":{"label":"Farm Bill","component":"FarmBill","parameter":"farm-bill","path":"/lists/farm-bill","sourceTypeId":0,"myRecordsSearch":false,"allowedRules":["/search/"],"disabled":true,"searchDescription":"To perform a search, enter a debtor name. Your search results may include: exact debtor name, variations of that name and any filing that includes your search criteria. Punctuation is ignored.\n\nYou can click on \"Advanced\" to refine your search. Under “Advanced” you can search by crop, year, county and SSN/FEIN. As a registered Farm Bill Buyer with the Montana Secretary of State’s office it is important to maintain the confidentiality of the information contained within the Farm Bill Master List. The Farm Bill Master List reflects personal data, such as Social Security Numbers, which are a key piece of personal identifiable information to assist you in determining the existence of a lien against a specific debtor. The distribution of this information beyond its intended purpose is strictly prohibited.\n\nThe debtor's tax identification number has been hidden for confidentiality reasons. You may continue to search on a tax ID number and return debtors that match your search criteria. The SSN/FEIN must be entered without dashes or spaces.","searchMustHaveOneOf":["search","UCC_FARM_PRODUCT_ID","COUNTY"],"searchPlaceholder":"Search by debtor name","advancedSearchParameters":[{"type":"ServerMultiComplete","label":"Product code name(s)","name":"UCC_FARM_PRODUCT_ID","defaultValue":"","optionsSrc":"UCC_FARM_PRODUCT_V"},{"type":"MultiComplete","label":"Year or Range of Years","name":"YEAR_NUM","optionsSrc":"years","startYear":"1968","defaultValue":[],"preMergeOptions":[{"value":"ALL","label":"All"}]},{"type":"serverSelect","label":"State","name":"STATE","defaultValue":"MONTANA","optionsSrc":"STATE"},{"type":"ServerMultiComplete","label":"County","name":"COUNTY","defaultValue":[],"optionsSrc":"COUNTY","overrideSubOptionsSrcFromParameterName":"STATE"},{"type":"checkbox","name":"TIN_SEARCH_YN","defaultValue":false,"label":"Tax Identification Number Search"},{"type":"checkbox","name":"TIN_SORT_YN","defaultValue":false,"label":"Unique ID Sort"}]},"ALLOW_ADDRESS_VALIDATION_BYPASS_OPTION":true,"DEFAULT_ADDRESS_VALIDATION_BYPASS_OPTION_CHECKED":true}).DEV_API_URL;
	var BASE_URL = exports.BASE_URL = DEV_API_URL ? DEV_API_URL : ({"NODE_ENV":"production","BUILD_DATE":"2025-08-27T15:15:31.687Z","BUILD_NUMBER":"Not Provided","GIT_VERSION":"v1.3.0-381-ga81e29b08","GIT_COMMIT_HASH":"a81e29b085c9268ffd96c78eb734365802722741","GIT_BRANCH":"beta","PUBLIC_URL":"","STATE_ABBR":"MT","STATE_NAME":"Montana","STATE_ORG_TITLE":"Secretary of State","LOGIN_HEADER_IMG_PATH":"","HOME_IMG_FILENAME":"montana.jpg","FAVICON_FILE_NAME":"favicon.ico","ALLOW_E_SIGN_ON_CORRECTIONS":true,"THIRD_PARTY_SIGNING_ALLOWED":false,"MY_ACCOUNT_SAVE_AND_CLOSE_BUTTON":true,"IE_DEPRECATED_MESSAGE":"Internet Explorer is not supported. Please select a supported browser below to access this website.","ADDITIONAL_ROUTES":{"dataRequests":true,"farmBill":true,"apostille":true,"externalHelp":"https://sosmt.gov/business/help-center/","systemAdministration":[{"title":"Saved Payments","parameter":"saved-payments","componentName":"SavedPayments"}]},"SUBROUTES":[{"label":"Business","component":"Business","parameter":"business","myWorkQueueSearch":false,"sourceTypeId":54,"searchMustHaveOneOf":["FILING_TYPE_ID","STATUS_ID","STATE","search"],"serverWebSearchDescription":true,"serverWorkQueueDescription":true,"serverMyRecordsDescription":true,"searchPlaceholder":"Search by name or filing number (X########)","allowEmptySearchTerm":true,"requestCertificateAlternateLabel":"Request Information","fileAmendmentButtonLabel":"Filing Actions","advancedSearchParameters":[{"type":"radio","name":"QUERY_TYPE_ID","defaultValue":1010,"options":[{"value":1010,"label":"Starts with"},{"value":1011,"label":"Contains"},{"value":1012,"label":" Word Contains"}]},{"type":"serverSelect","name":"FILING_TYPE_ID","optionsSrc":"FILING_TYPES","label":"Entity Type","placeholder":"All","defaultValue":"0"},{"type":"serverSelect","name":"FILING_SUBTYPE_ID","optionsSrc":"FILING_SUBTYPES","label":"Entity Subtype","overrideSubOptionsSrcFromParameterName":"FILING_TYPE_ID","placeholder":"All","defaultValue":"0"},{"type":"serverSelect","name":"STATUS_ID","optionsSrc":"FILING_STATUS_WITHOUT_ALL","label":"Status","placeholder":"All","defaultValue":"0"},{"type":"serverSelect","name":"STATE","optionsSrc":"STATE","label":"State","placeholder":"All","defaultValue":""},{"type":"serverSelect","name":"COUNTY","optionsSrc":"COUNTY_SUBOPTION","label":"County","overrideSubOptionsSrcFromParameterName":"STATE","placeholder":"All","defaultValue":""},{"type":"checkbox","name":"CRA_SEARCH_YN","defaultValue":false,"label":"Search by Registered Agent PID"},{"type":"dateRange","name":"FILING_DATE","label":"Registration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}},{"type":"dateRange","name":"EXPIRATION_DATE","label":"Expiration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}}],"myRecordsFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Active"},{"value":2,"label":"Inactive"},{"value":3,"label":"Pending"}]},{"type":"dateRange","name":"DATE_RANGE","label":"Date range","defaultValue":{"start":null,"end":null}}],"myWorkQueueFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Approved"},{"value":2,"label":"Pending Online Payment"},{"value":3,"label":"Pending Review"},{"value":4,"label":"Needs Correction"},{"value":5,"label":"Rejected"},{"value":6,"label":"Draft"}]},{"type":"dateRange","name":"DATE_RANGE","label":"Date range","defaultValue":{"start":null,"end":null}}]},{"label":"Notary","component":"Notary","parameter":"notary","sourceTypeId":850,"myWorkQueueSearch":false,"allowEmptySearchTerm":true,"requestCertificateAlternateLabel":"Download Certificate","fileAmendmentButtonLabel":"Filing Actions","hideNameRequestCertificate":true,"hideAddressRequestCertificate":true,"hideRecordUserManagment":true,"searchPlaceholder":"Search by name or commission number","searchMustHaveOneOf":["CITY","search","SERVICE_TYPE"],"advancedParametersStartOpen":true,"searchIsSortable":true,"advancedSearchParameters":[{"type":"radio","name":"STARTS_WITH_YN","defaultValue":false,"options":[{"value":true,"label":"Starts with"},{"value":false,"label":"Contains"}]},{"type":"checkbox","name":"ACTIVE_ONLY_YN","defaultValue":true,"label":"Active entities only"},{"type":"text","name":"CITY","defaultValue":"","label":"City"},{"type":"select","name":"SERVICE_TYPE","label":"Special Services Offered","defaultValue":0,"options":[{"value":0,"label":"(N/A)"},{"value":6165,"label":"In-Person Electronic Notarization (IPEN)"},{"value":6166,"label":"Remote Online Notarization (RON)"},{"value":6167,"label":"Mobile Notary Services"},{"value":6168,"label":"Remote Ink Notarization (RIN)"}]}]},{"label":"Apostille","component":"Apostille","parameter":"apostille","sourceTypeId":720,"myRecordsSearch":false,"myWorkQueueSearch":false,"disabled":false,"allowedRoutes":["/forms-manager/","/queue/","/forms/"]},{"label":"Liens","component":"UCC","parameter":"ucc","sourceTypeId":1999,"myRecordsSearch":true,"myWorkQueueSearch":true,"fileAmendmentButtonLabel":"Filing Actions","searchPlaceholder":"Search by name or file number","disabled":false,"serverWebSearchDescription":true,"myRecordsDescription":"","workQueueDescription":"","searchDescription":"","hideRecordUserManagment":true,"searchLiensCheckout":false,"advancedSearchParameters":[{"type":"radio","name":"STARTS_WITH_YN","defaultValue":false,"options":[{"value":true,"label":"Starts with"},{"value":false,"label":"Contains"}]},{"type":"select","name":"STATUS","defaultValue":"ALL","label":"Status","options":[{"value":"ACTIVE_UNLAPSED","label":"Active (unlapsed)"},{"value":"ACTIVE_LAPSED_UNLAPSED","label":"Active (lapsed and unlapsed)"}]},{"type":"text","name":"EXCLUDE_VALUES","label":"Exclude Debtor Names (comma separated list of names to exclude)","defaultValue":""},{"type":"dateRange","name":"FILING_DATE","label":"Financing Statement Date","defaultValue":{"start":null,"end":null}},{"type":"dateRange","name":"LAPSE_DATE","label":"Lapse Date","defaultValue":{"start":null,"end":null}},{"type":"text","name":"CITY","label":"Debtor City","defaultValue":""}],"myRecordsFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Approved"},{"value":2,"label":"Pending Online Payment"},{"value":3,"label":"Pending Review"}]},{"type":"select","name":"TYPE","defaultValue":0,"label":"Lien Type","options":[{"value":0,"label":"All"},{"value":1,"label":"UCC"},{"value":2,"label":"EFS"},{"value":3,"label":"Title 71"}]}],"myWorkQueueFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Approved"},{"value":2,"label":"Pending Online Payment"},{"value":3,"label":"Pending Review"},{"value":4,"label":"Pending Print and Mail"},{"value":5,"label":"Rejected"},{"value":6,"label":"Draft"}]},{"type":"select","name":"TYPE","defaultValue":0,"label":"Lien Type","options":[{"value":0,"label":"All"},{"value":1,"label":"UCC"},{"value":2,"label":"EFS"},{"value":3,"label":"Title 71"}]}]},{"label":"Copy Request","component":"copies","parameter":"copies","sourceTypeId":2001,"myRecordsSearch":false,"myWorkQueueSearch":false,"disabled":false,"allowedRoutes":["/forms-manager/","/queue/","/forms/"]},{"label":"Trademark","component":"Trademark","parameter":"trademark","sourceTypeId":810,"showRequestCertificate":true,"searchMustHaveOneOf":["search","EXPIRATION_DATE","FILING_DATE"],"allowEmptySearchTerm":true,"requestCertificateAlternateLabel":"Request Information","fileAmendmentButtonLabel":"Filing Actions","advancedSearchParameters":[{"type":"radio","name":"QUERY_TYPE_ID","defaultValue":1010,"options":[{"value":1010,"label":"Starts with"},{"value":1011,"label":"Contains"},{"value":1012,"label":" Word Contains"}]},{"type":"checkbox","name":"OWNER_SEARCH_YN","defaultValue":false,"label":"Search owners"},{"type":"radio","name":"SERVICE_MARK_YN","label":"Mark Type","defaultValue":"","options":[{"value":"","label":"All Marks"},{"value":"Y","label":"Service Mark"},{"value":"N","label":"Trademark"}]},{"type":"serverSelect","name":"STATUS_ID","optionsSrc":"TYPE_V|TRADEMARK_STATUS_TYPE","label":"Status","placeholder":"All","defaultValue":"0"},{"type":"select","name":"DESIGN_TYPE_ID","options":[{"value":0,"label":"All"},{"value":990,"label":"Words Only"},{"value":991,"label":"Design Only"},{"value":992,"label":"Words and Design"}],"label":"Design Type","defaultValue":"0"},{"type":"dateRange","name":"FILING_DATE","label":"Registered Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}},{"type":"dateRange","name":"EXPIRATION_DATE","label":"Expiration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}}]},{"label":"Business Info Request","component":"InfoRequests","parameter":"info-request","sourceTypeId":167,"allowedRoutes":["/forms-manager/","/queue/","/forms/"]},{"label":"Data Requests","component":"DataRequests","parameter":"data-request","sourceTypeId":0,"allowedRoutes":["/forms-manager/"]},{"label":"CRA","component":"CRA","parameter":"cra","sourceTypeId":157,"myRecordsSearch":false,"searchPlaceholder":"Search by name or registered agent number","allowedRoutes":["/forms-manager/","/forms/","/records/","/queue/","/search/"],"allowEmptySearchTerm":true,"fileAmendmentButtonLabel":"Filing Actions","advancedSearchParameters":[{"type":"radio","name":"QUERY_TYPE_ID","defaultValue":1010,"options":[{"value":1010,"label":"Starts with"},{"value":1011,"label":"Contains"},{"value":1012,"label":" Word Contains"}]},{"type":"dateRange","name":"CRA_DATE","label":"Registration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}},{"type":"select","name":"STATUS_ID","label":"Status","defaultValue":0,"options":[{"value":0,"label":"All"},{"value":121,"label":"Active"},{"value":122,"label":"Inactive"}]},{"type":"select","name":"AGENT_TYPE_ID","label":"Agent Type","defaultValue":0,"options":[{"value":0,"label":"All"},{"value":460,"label":"Registered Agent"},{"value":461,"label":"Commercial Registered Agent"}]}]},{"label":"Farm Bill","component":"FarmBill","parameter":"farm-bill","path":"/lists/farm-bill","sourceTypeId":0,"myRecordsSearch":false,"allowedRules":["/search/"],"disabled":true,"searchDescription":"To perform a search, enter a debtor name. Your search results may include: exact debtor name, variations of that name and any filing that includes your search criteria. Punctuation is ignored.\n\nYou can click on \"Advanced\" to refine your search. Under “Advanced” you can search by crop, year, county and SSN/FEIN. As a registered Farm Bill Buyer with the Montana Secretary of State’s office it is important to maintain the confidentiality of the information contained within the Farm Bill Master List. The Farm Bill Master List reflects personal data, such as Social Security Numbers, which are a key piece of personal identifiable information to assist you in determining the existence of a lien against a specific debtor. The distribution of this information beyond its intended purpose is strictly prohibited.\n\nThe debtor's tax identification number has been hidden for confidentiality reasons. You may continue to search on a tax ID number and return debtors that match your search criteria. The SSN/FEIN must be entered without dashes or spaces.","searchMustHaveOneOf":["search","UCC_FARM_PRODUCT_ID","COUNTY"],"searchPlaceholder":"Search by debtor name","advancedSearchParameters":[{"type":"ServerMultiComplete","label":"Product code name(s)","name":"UCC_FARM_PRODUCT_ID","defaultValue":"","optionsSrc":"UCC_FARM_PRODUCT_V"},{"type":"MultiComplete","label":"Year or Range of Years","name":"YEAR_NUM","optionsSrc":"years","startYear":"1968","defaultValue":[],"preMergeOptions":[{"value":"ALL","label":"All"}]},{"type":"serverSelect","label":"State","name":"STATE","defaultValue":"MONTANA","optionsSrc":"STATE"},{"type":"ServerMultiComplete","label":"County","name":"COUNTY","defaultValue":[],"optionsSrc":"COUNTY","overrideSubOptionsSrcFromParameterName":"STATE"},{"type":"checkbox","name":"TIN_SEARCH_YN","defaultValue":false,"label":"Tax Identification Number Search"},{"type":"checkbox","name":"TIN_SORT_YN","defaultValue":false,"label":"Unique ID Sort"}]}],"SYSTEM_NICKNAME":"Online Services Portal","PAYMENT_METHODS":[{"type":"bypass"},{"type":"iTransact"}],"PAYMENT_ALLOW_AMEX":true,"SYSTEM_ID_LABEL":"System Id","DOUBLE_COLUMN_PUBLIC_LOGIN":true,"INTERNAL_USER_MANAGEMENT":true,"ALLOW_PUBLIC_JSON_IMPORT":false,"MAX_FILE_UPLOAD_SIZE":10000000,"REFUND_TEXT":"","RETURN_TO_HOME_ON_LOGOUT":true,"CURRENT_SOS_NAME":"Christi Jacobsen","LOGO_FILENAME":"mt-sos-logo.png","LOGO_ALT":"Christi Jacobsen, Montana Secretary of State","LOGO_FULL_WIDTH":true,"HOME_HIDE_AUTH_HINT":true,"HOME_TITLE":"Montana Secretary of State","CUSTOM_TAB_TITLE":"Official Montana","HOME_SUBTITLE":"Online Business Services","ENTITY_NAME_CONSENT_DESCRIPTION":"","ALLOW_USER_PROFILE_EDITING":true,"COMPARE_FOREIGN_NAME_IN_ENTITY_NAME_VALIDATION":true,"FOREIGN_NAME_FIELD_NAME":"KIMA_PARENT_NAME_INFO","LOGIN_TITLE":"Montana Secretary of State Online Filing Portal Login","PUBLIC_LOGIN_LABEL":"Username","REVERSE_LOGIN_COLUMNS":true,"LOGIN_SEAL_FILENAME":"seal_white.png","SEPARATE_USERNAME_AND_EMAIL":true,"CREATE_ACCOUNT_BUTTON_ALIGN_LEFT":true,"CREATE_ACCOUNT_BUTTON_TEXT":"CREATE AN ACCOUNT","PASSWORD_CUSTOM_ERROR_TEXT":"The password must meet all requirements","ACCOUNT_CREATED_MESSAGE":"Please check your email to verify your account to login and allow a few minutes for this message to arrive. Check your junk/spam folders if you do not find the email in your inbox.","PUBLIC_LOGIN_PLACEHOLDER":" ","DISABLE_DEFAULT_PAYMENT_RADIO":true,"CUSTOM_RESET_PASSWORD_ERROR_MESSAGE":"Username invalid - no account found","PUBLIC_LOGIN_CREATE_DESCRIPTION":"### Existing User:\n\n  - Enter your username and password to login.  \n\n\n  #### - OR -  \n\n\n\n  - Forgot password? Click 'Reset Password' and follow the prompts.\n  - Forgot username? Click 'Forgot Username' and follow the prompts.  \n\n\n  ### New User:\n  ","LOGIN_HELP_LINK":"https://sosmt.gov/business/how-do-i/","LOGIN_HELP_LINK_TEXT":"Need Help?","FORGOT_USERNAME_TEXT":"Forgot Username?","LOGIN_ACTIVE_DIRECTORY_TEXT":"State User Login","MULTIPLE_LOGIN_METHODS":true,"HAS_ACTIVE_DIRECTORY_LOGIN":true,"RESET_PASSWORD_WITH_USERNAME":true,"DOWNLOAD_LINK":true,"SHOW_USERNAME_ACCOUNT_CREATE":true,"SHOW_SCROLL_DOWN_ARROW":true,"SHOW_ADDRESS_ACCOUNT_CREATE":true,"TWO_COLUMN_ACCOUNT_CREATE":true,"RESET_PASSWORD_TIP":"A link to change your password has been sent to your email. Please allow a few minutes for this message to arrive. Please check your junk/spam folders if you do not find the email in your inbox.","FORGOT_PASSWORD_LINK_TEXT":"Reset Password","PHONE_NUMBER_OPTIONAL_ACCOUNT_CREATE":true,"SHOW_REQUIRED_INDICATOR_ACCOUNT_CREATE":true,"PASSWORD_REQUIREMENTS_ACCOUNT_CREATE":"\n    <ul>\n      <li>MUST contain at least 8 characters (12+ recommended)</li>\n      <li>MUST contain at least one uppercase letter.</li>\n      <li>MUST contain at least one lowercase letter.</li>\n      <li>MUST contain at least one number.</li>\n      <li>MUST contain at least one special character (!”#$%&'()*+,-./:;<=>?</li>\n    </ul>\n  ","ALLOW_CERTIFICATION_REQUEST":true,"ALLOW_PUBLIC_CERTIFICATE_REQUEST":true,"ALLOW_COPY_REQUEST":false,"ALLOW_CORRECTION_STYLING":true,"HIDE_DEPRECATION_WARNING":false,"AMEND_ROUTE_PUBLIC":true,"SEAL_FILENAME":"seal.png","SHOPPING_CART":true,"ALLOW_PAYMENT_UPDATE_WITH_EMPTY_CART":true,"RA_EMAIL":true,"RA_WEBSITE":true,"RA_NO_DEFAULT_TYPE":true,"RA_ADDRESS_LABEL":"Street Address","RA_TYPE_SELECTION_DEFAULT":true,"RA_DEFAULT_TYPE":"460","RA_OVERRIDE_TYPE_WITH_DEFAULT":true,"RA_PRINCIPAL_ADDRESS_AMS":true,"UPLOAD_AND_SUBMIT_HIDE_IF_ONE_OPTION":true,"PAYMENT_PROCESSING_MESSAGE":"Your payment is processing - Do not close your browser or click the back button","CHECKOUT_BUTTON_WHEN_PROCESSING_TEXT":"Processing","EFS_CROP_PICKER_NONE_LABEL":"Lien Duration","DISALLOWED_WIZARD_PIECES":["FormationLocale"],"REPEATER_SHOW_EDIT_BUTTON":true,"DATA_REQUEST_PAGE_TITLE":"Data Requests and Subscriptions","DATA_REQUEST_SIDEBAR_LABEL":"Data Requests & Subscriptions","LOGIN_REDIRECTS_TO_EPASS":false,"LOGIN_REDIRECTS_TO_ACTIVE_DIRECTORY":true,"LOGIN_ACTIVE_DIRECTORY_LINK":true,"FETCH_EDIT_USER_LINK":false,"LISTS_FETCH_AVAILABLE_LISTS":true,"POST_WIZARD_SUBMIT_REDIRECT_URL":"/","PIN_REQUEST_ATTESTATIONS":true,"PIN_REQUEST_DESCRIPTION":"Click **Request PIN** to have a new PIN sent to the account holder's email address on file.","OWNERSHIP_REQUEST_DESCRIPTION":"To become an **authorized user** of this record, a current **AUTHORIZED USER** will need to grant you access. To request access, click **Request Access** below.","PIN_REQUEST_SUCCESS_MESSAGE":"The PIN you have requested for this entity has been sent to the email associated with your user account.  You should receive the PIN in approximately 3-5 minutes, depending on your email service provider.","APOSTILLE_HEADER_LABEL":"Verification Information","APOSTILLE_NUMBER_LABEL":"Apostille/Authentication","APOSTILLE_CITY_STATE_OVERRIDE":"HELENA, MT","APOSTILLE_FILING_DATE_LABEL":"Issue Date","APOSTILLE_CITY_STATE_IN_CERTIFIED":true,"NOTARY_EXISTING_FILING":true,"ALLOW_REVOKE_OWN_ACCESS_ONLY":false,"HIDE_CANCEL_ON_ONETIME_DATA_REQUESTS":true,"DATA_REQUESTS_IN_SHOPPING_CART":true,"WQ_ALLOW_EDIT_PENDING_PAYMENT":true,"WQ_CONFIRM_ON_DELETE":true,"WQ_DELETE_CONFIRM_MESSAGE":"Deleting this filing will forfeit any money already paid to the Secretary of State. This action is permanent and cannot be undone, are you sure you would like to delete?","PASS_ITEM_GUIDS_ON_CHECKOUT":true,"FORM_REVISION_HISTORY":true,"CHECKOUT_DISCLAIMER":"By entering your credit card and/or checking account information you (i) state that **you are an authorized user** of the credit card and/or electronic check and that the associated information entered (e.g., account holder name, account number, billing address) is accurate, (ii) **you authorize payment processor to charge the amount you have requested** to your credit card and/or funding account, and (iii) **acknowledge if a charge is declined or reversed you may also be assessed a customary charge** by the payment processor for such transactions.","FARM_BILL_SEARCH_CONFIDENTIAL":"As a registered Farm Bill Buyer with the Montana Secretary of State’s office it is important to maintain the confidentiality of the information contained within the Farm Bill Master List. The Farm Bill Master List reflects personal data, such as Social Security Numbers, which are a key piece of personal identifiable information to assist you in determining the existence of a lien against a specific debtor. The distribution of this information beyond its intended purpose is strictly prohibited.\n\n**The debtor's tax identification number has been hidden for confidentiality reasons. You may continue to search on a tax ID number and return debtors that match your search criteria. The SSN/FEIN must be entered without dashes or spaces.  If you need access to the tax identification number to clearly identify the debtor, please contact the UCC unit at (406) 444-3665.**","VIEW_HISTORY_BUTTON_ALT_TEXT":"View Filings","WIZARD_ERROR_TITLE_MESSAGE":"Form Error","FARM_BILL_SEARCH_INTERACTIVE":true,"USE_FARM_BILL_API":true,"DISALLOW_ASSIGN_SELF_AS_RA":true,"DISALLOW_ASSIGN_SELF_AS_PRINCIPAL":true,"USE_TRADEMARK_OWNER_VALIDATION":true,"USE_ALTERNATIVE_FOREIGN_ADDRESS_LABELS":true,"MY_RECEIPTS_FILTER":[{"type":"dateRange","name":"DATE_RANGE","label":"Date range","defaultValue":{"start":null,"end":null}},{"type":"text","name":"REF_NUM","defaultValue":"","label":"Reference Number"},{"type":"text","name":"RECEIPT_NUM","defaultValue":"","label":"Receipt Id"},{"type":"text","name":"AMOUNT","defaultValue":"","label":"Amount"},{"type":"select","name":"TYPE","defaultValue":"","label":"Payment Type","options":[{"value":"","label":"All"},{"value":"CC","label":"Credit Card"},{"value":"Check","label":"Check"}]}],"MY_RECEIPTS_SHOW_IN_SIDEBAR":true,"SHOW_MY_RECEIPTS_HELPER_TEXT":true,"MY_RECEIPTS_HELPER_LABEL":"About Receipt Search","MY_RECEIPTS_HELPER_TEXT":"You can search for receipts based on their descriptions, including the items paid for on the receipt. Use the filters to search for or filter specific information.","FARM_BILL_SUBLINK":{"label":"Farm Bill","component":"FarmBill","parameter":"farm-bill","path":"/lists/farm-bill","sourceTypeId":0,"myRecordsSearch":false,"allowedRules":["/search/"],"disabled":true,"searchDescription":"To perform a search, enter a debtor name. Your search results may include: exact debtor name, variations of that name and any filing that includes your search criteria. Punctuation is ignored.\n\nYou can click on \"Advanced\" to refine your search. Under “Advanced” you can search by crop, year, county and SSN/FEIN. As a registered Farm Bill Buyer with the Montana Secretary of State’s office it is important to maintain the confidentiality of the information contained within the Farm Bill Master List. The Farm Bill Master List reflects personal data, such as Social Security Numbers, which are a key piece of personal identifiable information to assist you in determining the existence of a lien against a specific debtor. The distribution of this information beyond its intended purpose is strictly prohibited.\n\nThe debtor's tax identification number has been hidden for confidentiality reasons. You may continue to search on a tax ID number and return debtors that match your search criteria. The SSN/FEIN must be entered without dashes or spaces.","searchMustHaveOneOf":["search","UCC_FARM_PRODUCT_ID","COUNTY"],"searchPlaceholder":"Search by debtor name","advancedSearchParameters":[{"type":"ServerMultiComplete","label":"Product code name(s)","name":"UCC_FARM_PRODUCT_ID","defaultValue":"","optionsSrc":"UCC_FARM_PRODUCT_V"},{"type":"MultiComplete","label":"Year or Range of Years","name":"YEAR_NUM","optionsSrc":"years","startYear":"1968","defaultValue":[],"preMergeOptions":[{"value":"ALL","label":"All"}]},{"type":"serverSelect","label":"State","name":"STATE","defaultValue":"MONTANA","optionsSrc":"STATE"},{"type":"ServerMultiComplete","label":"County","name":"COUNTY","defaultValue":[],"optionsSrc":"COUNTY","overrideSubOptionsSrcFromParameterName":"STATE"},{"type":"checkbox","name":"TIN_SEARCH_YN","defaultValue":false,"label":"Tax Identification Number Search"},{"type":"checkbox","name":"TIN_SORT_YN","defaultValue":false,"label":"Unique ID Sort"}]},"ALLOW_ADDRESS_VALIDATION_BYPASS_OPTION":true,"DEFAULT_ADDRESS_VALIDATION_BYPASS_OPTION_CHECKED":true}).API_PROXY ? 'http://' + ({"NODE_ENV":"production","BUILD_DATE":"2025-08-27T15:15:31.687Z","BUILD_NUMBER":"Not Provided","GIT_VERSION":"v1.3.0-381-ga81e29b08","GIT_COMMIT_HASH":"a81e29b085c9268ffd96c78eb734365802722741","GIT_BRANCH":"beta","PUBLIC_URL":"","STATE_ABBR":"MT","STATE_NAME":"Montana","STATE_ORG_TITLE":"Secretary of State","LOGIN_HEADER_IMG_PATH":"","HOME_IMG_FILENAME":"montana.jpg","FAVICON_FILE_NAME":"favicon.ico","ALLOW_E_SIGN_ON_CORRECTIONS":true,"THIRD_PARTY_SIGNING_ALLOWED":false,"MY_ACCOUNT_SAVE_AND_CLOSE_BUTTON":true,"IE_DEPRECATED_MESSAGE":"Internet Explorer is not supported. Please select a supported browser below to access this website.","ADDITIONAL_ROUTES":{"dataRequests":true,"farmBill":true,"apostille":true,"externalHelp":"https://sosmt.gov/business/help-center/","systemAdministration":[{"title":"Saved Payments","parameter":"saved-payments","componentName":"SavedPayments"}]},"SUBROUTES":[{"label":"Business","component":"Business","parameter":"business","myWorkQueueSearch":false,"sourceTypeId":54,"searchMustHaveOneOf":["FILING_TYPE_ID","STATUS_ID","STATE","search"],"serverWebSearchDescription":true,"serverWorkQueueDescription":true,"serverMyRecordsDescription":true,"searchPlaceholder":"Search by name or filing number (X########)","allowEmptySearchTerm":true,"requestCertificateAlternateLabel":"Request Information","fileAmendmentButtonLabel":"Filing Actions","advancedSearchParameters":[{"type":"radio","name":"QUERY_TYPE_ID","defaultValue":1010,"options":[{"value":1010,"label":"Starts with"},{"value":1011,"label":"Contains"},{"value":1012,"label":" Word Contains"}]},{"type":"serverSelect","name":"FILING_TYPE_ID","optionsSrc":"FILING_TYPES","label":"Entity Type","placeholder":"All","defaultValue":"0"},{"type":"serverSelect","name":"FILING_SUBTYPE_ID","optionsSrc":"FILING_SUBTYPES","label":"Entity Subtype","overrideSubOptionsSrcFromParameterName":"FILING_TYPE_ID","placeholder":"All","defaultValue":"0"},{"type":"serverSelect","name":"STATUS_ID","optionsSrc":"FILING_STATUS_WITHOUT_ALL","label":"Status","placeholder":"All","defaultValue":"0"},{"type":"serverSelect","name":"STATE","optionsSrc":"STATE","label":"State","placeholder":"All","defaultValue":""},{"type":"serverSelect","name":"COUNTY","optionsSrc":"COUNTY_SUBOPTION","label":"County","overrideSubOptionsSrcFromParameterName":"STATE","placeholder":"All","defaultValue":""},{"type":"checkbox","name":"CRA_SEARCH_YN","defaultValue":false,"label":"Search by Registered Agent PID"},{"type":"dateRange","name":"FILING_DATE","label":"Registration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}},{"type":"dateRange","name":"EXPIRATION_DATE","label":"Expiration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}}],"myRecordsFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Active"},{"value":2,"label":"Inactive"},{"value":3,"label":"Pending"}]},{"type":"dateRange","name":"DATE_RANGE","label":"Date range","defaultValue":{"start":null,"end":null}}],"myWorkQueueFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Approved"},{"value":2,"label":"Pending Online Payment"},{"value":3,"label":"Pending Review"},{"value":4,"label":"Needs Correction"},{"value":5,"label":"Rejected"},{"value":6,"label":"Draft"}]},{"type":"dateRange","name":"DATE_RANGE","label":"Date range","defaultValue":{"start":null,"end":null}}]},{"label":"Notary","component":"Notary","parameter":"notary","sourceTypeId":850,"myWorkQueueSearch":false,"allowEmptySearchTerm":true,"requestCertificateAlternateLabel":"Download Certificate","fileAmendmentButtonLabel":"Filing Actions","hideNameRequestCertificate":true,"hideAddressRequestCertificate":true,"hideRecordUserManagment":true,"searchPlaceholder":"Search by name or commission number","searchMustHaveOneOf":["CITY","search","SERVICE_TYPE"],"advancedParametersStartOpen":true,"searchIsSortable":true,"advancedSearchParameters":[{"type":"radio","name":"STARTS_WITH_YN","defaultValue":false,"options":[{"value":true,"label":"Starts with"},{"value":false,"label":"Contains"}]},{"type":"checkbox","name":"ACTIVE_ONLY_YN","defaultValue":true,"label":"Active entities only"},{"type":"text","name":"CITY","defaultValue":"","label":"City"},{"type":"select","name":"SERVICE_TYPE","label":"Special Services Offered","defaultValue":0,"options":[{"value":0,"label":"(N/A)"},{"value":6165,"label":"In-Person Electronic Notarization (IPEN)"},{"value":6166,"label":"Remote Online Notarization (RON)"},{"value":6167,"label":"Mobile Notary Services"},{"value":6168,"label":"Remote Ink Notarization (RIN)"}]}]},{"label":"Apostille","component":"Apostille","parameter":"apostille","sourceTypeId":720,"myRecordsSearch":false,"myWorkQueueSearch":false,"disabled":false,"allowedRoutes":["/forms-manager/","/queue/","/forms/"]},{"label":"Liens","component":"UCC","parameter":"ucc","sourceTypeId":1999,"myRecordsSearch":true,"myWorkQueueSearch":true,"fileAmendmentButtonLabel":"Filing Actions","searchPlaceholder":"Search by name or file number","disabled":false,"serverWebSearchDescription":true,"myRecordsDescription":"","workQueueDescription":"","searchDescription":"","hideRecordUserManagment":true,"searchLiensCheckout":false,"advancedSearchParameters":[{"type":"radio","name":"STARTS_WITH_YN","defaultValue":false,"options":[{"value":true,"label":"Starts with"},{"value":false,"label":"Contains"}]},{"type":"select","name":"STATUS","defaultValue":"ALL","label":"Status","options":[{"value":"ACTIVE_UNLAPSED","label":"Active (unlapsed)"},{"value":"ACTIVE_LAPSED_UNLAPSED","label":"Active (lapsed and unlapsed)"}]},{"type":"text","name":"EXCLUDE_VALUES","label":"Exclude Debtor Names (comma separated list of names to exclude)","defaultValue":""},{"type":"dateRange","name":"FILING_DATE","label":"Financing Statement Date","defaultValue":{"start":null,"end":null}},{"type":"dateRange","name":"LAPSE_DATE","label":"Lapse Date","defaultValue":{"start":null,"end":null}},{"type":"text","name":"CITY","label":"Debtor City","defaultValue":""}],"myRecordsFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Approved"},{"value":2,"label":"Pending Online Payment"},{"value":3,"label":"Pending Review"}]},{"type":"select","name":"TYPE","defaultValue":0,"label":"Lien Type","options":[{"value":0,"label":"All"},{"value":1,"label":"UCC"},{"value":2,"label":"EFS"},{"value":3,"label":"Title 71"}]}],"myWorkQueueFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Approved"},{"value":2,"label":"Pending Online Payment"},{"value":3,"label":"Pending Review"},{"value":4,"label":"Pending Print and Mail"},{"value":5,"label":"Rejected"},{"value":6,"label":"Draft"}]},{"type":"select","name":"TYPE","defaultValue":0,"label":"Lien Type","options":[{"value":0,"label":"All"},{"value":1,"label":"UCC"},{"value":2,"label":"EFS"},{"value":3,"label":"Title 71"}]}]},{"label":"Copy Request","component":"copies","parameter":"copies","sourceTypeId":2001,"myRecordsSearch":false,"myWorkQueueSearch":false,"disabled":false,"allowedRoutes":["/forms-manager/","/queue/","/forms/"]},{"label":"Trademark","component":"Trademark","parameter":"trademark","sourceTypeId":810,"showRequestCertificate":true,"searchMustHaveOneOf":["search","EXPIRATION_DATE","FILING_DATE"],"allowEmptySearchTerm":true,"requestCertificateAlternateLabel":"Request Information","fileAmendmentButtonLabel":"Filing Actions","advancedSearchParameters":[{"type":"radio","name":"QUERY_TYPE_ID","defaultValue":1010,"options":[{"value":1010,"label":"Starts with"},{"value":1011,"label":"Contains"},{"value":1012,"label":" Word Contains"}]},{"type":"checkbox","name":"OWNER_SEARCH_YN","defaultValue":false,"label":"Search owners"},{"type":"radio","name":"SERVICE_MARK_YN","label":"Mark Type","defaultValue":"","options":[{"value":"","label":"All Marks"},{"value":"Y","label":"Service Mark"},{"value":"N","label":"Trademark"}]},{"type":"serverSelect","name":"STATUS_ID","optionsSrc":"TYPE_V|TRADEMARK_STATUS_TYPE","label":"Status","placeholder":"All","defaultValue":"0"},{"type":"select","name":"DESIGN_TYPE_ID","options":[{"value":0,"label":"All"},{"value":990,"label":"Words Only"},{"value":991,"label":"Design Only"},{"value":992,"label":"Words and Design"}],"label":"Design Type","defaultValue":"0"},{"type":"dateRange","name":"FILING_DATE","label":"Registered Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}},{"type":"dateRange","name":"EXPIRATION_DATE","label":"Expiration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}}]},{"label":"Business Info Request","component":"InfoRequests","parameter":"info-request","sourceTypeId":167,"allowedRoutes":["/forms-manager/","/queue/","/forms/"]},{"label":"Data Requests","component":"DataRequests","parameter":"data-request","sourceTypeId":0,"allowedRoutes":["/forms-manager/"]},{"label":"CRA","component":"CRA","parameter":"cra","sourceTypeId":157,"myRecordsSearch":false,"searchPlaceholder":"Search by name or registered agent number","allowedRoutes":["/forms-manager/","/forms/","/records/","/queue/","/search/"],"allowEmptySearchTerm":true,"fileAmendmentButtonLabel":"Filing Actions","advancedSearchParameters":[{"type":"radio","name":"QUERY_TYPE_ID","defaultValue":1010,"options":[{"value":1010,"label":"Starts with"},{"value":1011,"label":"Contains"},{"value":1012,"label":" Word Contains"}]},{"type":"dateRange","name":"CRA_DATE","label":"Registration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}},{"type":"select","name":"STATUS_ID","label":"Status","defaultValue":0,"options":[{"value":0,"label":"All"},{"value":121,"label":"Active"},{"value":122,"label":"Inactive"}]},{"type":"select","name":"AGENT_TYPE_ID","label":"Agent Type","defaultValue":0,"options":[{"value":0,"label":"All"},{"value":460,"label":"Registered Agent"},{"value":461,"label":"Commercial Registered Agent"}]}]},{"label":"Farm Bill","component":"FarmBill","parameter":"farm-bill","path":"/lists/farm-bill","sourceTypeId":0,"myRecordsSearch":false,"allowedRules":["/search/"],"disabled":true,"searchDescription":"To perform a search, enter a debtor name. Your search results may include: exact debtor name, variations of that name and any filing that includes your search criteria. Punctuation is ignored.\n\nYou can click on \"Advanced\" to refine your search. Under “Advanced” you can search by crop, year, county and SSN/FEIN. As a registered Farm Bill Buyer with the Montana Secretary of State’s office it is important to maintain the confidentiality of the information contained within the Farm Bill Master List. The Farm Bill Master List reflects personal data, such as Social Security Numbers, which are a key piece of personal identifiable information to assist you in determining the existence of a lien against a specific debtor. The distribution of this information beyond its intended purpose is strictly prohibited.\n\nThe debtor's tax identification number has been hidden for confidentiality reasons. You may continue to search on a tax ID number and return debtors that match your search criteria. The SSN/FEIN must be entered without dashes or spaces.","searchMustHaveOneOf":["search","UCC_FARM_PRODUCT_ID","COUNTY"],"searchPlaceholder":"Search by debtor name","advancedSearchParameters":[{"type":"ServerMultiComplete","label":"Product code name(s)","name":"UCC_FARM_PRODUCT_ID","defaultValue":"","optionsSrc":"UCC_FARM_PRODUCT_V"},{"type":"MultiComplete","label":"Year or Range of Years","name":"YEAR_NUM","optionsSrc":"years","startYear":"1968","defaultValue":[],"preMergeOptions":[{"value":"ALL","label":"All"}]},{"type":"serverSelect","label":"State","name":"STATE","defaultValue":"MONTANA","optionsSrc":"STATE"},{"type":"ServerMultiComplete","label":"County","name":"COUNTY","defaultValue":[],"optionsSrc":"COUNTY","overrideSubOptionsSrcFromParameterName":"STATE"},{"type":"checkbox","name":"TIN_SEARCH_YN","defaultValue":false,"label":"Tax Identification Number Search"},{"type":"checkbox","name":"TIN_SORT_YN","defaultValue":false,"label":"Unique ID Sort"}]}],"SYSTEM_NICKNAME":"Online Services Portal","PAYMENT_METHODS":[{"type":"bypass"},{"type":"iTransact"}],"PAYMENT_ALLOW_AMEX":true,"SYSTEM_ID_LABEL":"System Id","DOUBLE_COLUMN_PUBLIC_LOGIN":true,"INTERNAL_USER_MANAGEMENT":true,"ALLOW_PUBLIC_JSON_IMPORT":false,"MAX_FILE_UPLOAD_SIZE":10000000,"REFUND_TEXT":"","RETURN_TO_HOME_ON_LOGOUT":true,"CURRENT_SOS_NAME":"Christi Jacobsen","LOGO_FILENAME":"mt-sos-logo.png","LOGO_ALT":"Christi Jacobsen, Montana Secretary of State","LOGO_FULL_WIDTH":true,"HOME_HIDE_AUTH_HINT":true,"HOME_TITLE":"Montana Secretary of State","CUSTOM_TAB_TITLE":"Official Montana","HOME_SUBTITLE":"Online Business Services","ENTITY_NAME_CONSENT_DESCRIPTION":"","ALLOW_USER_PROFILE_EDITING":true,"COMPARE_FOREIGN_NAME_IN_ENTITY_NAME_VALIDATION":true,"FOREIGN_NAME_FIELD_NAME":"KIMA_PARENT_NAME_INFO","LOGIN_TITLE":"Montana Secretary of State Online Filing Portal Login","PUBLIC_LOGIN_LABEL":"Username","REVERSE_LOGIN_COLUMNS":true,"LOGIN_SEAL_FILENAME":"seal_white.png","SEPARATE_USERNAME_AND_EMAIL":true,"CREATE_ACCOUNT_BUTTON_ALIGN_LEFT":true,"CREATE_ACCOUNT_BUTTON_TEXT":"CREATE AN ACCOUNT","PASSWORD_CUSTOM_ERROR_TEXT":"The password must meet all requirements","ACCOUNT_CREATED_MESSAGE":"Please check your email to verify your account to login and allow a few minutes for this message to arrive. Check your junk/spam folders if you do not find the email in your inbox.","PUBLIC_LOGIN_PLACEHOLDER":" ","DISABLE_DEFAULT_PAYMENT_RADIO":true,"CUSTOM_RESET_PASSWORD_ERROR_MESSAGE":"Username invalid - no account found","PUBLIC_LOGIN_CREATE_DESCRIPTION":"### Existing User:\n\n  - Enter your username and password to login.  \n\n\n  #### - OR -  \n\n\n\n  - Forgot password? Click 'Reset Password' and follow the prompts.\n  - Forgot username? Click 'Forgot Username' and follow the prompts.  \n\n\n  ### New User:\n  ","LOGIN_HELP_LINK":"https://sosmt.gov/business/how-do-i/","LOGIN_HELP_LINK_TEXT":"Need Help?","FORGOT_USERNAME_TEXT":"Forgot Username?","LOGIN_ACTIVE_DIRECTORY_TEXT":"State User Login","MULTIPLE_LOGIN_METHODS":true,"HAS_ACTIVE_DIRECTORY_LOGIN":true,"RESET_PASSWORD_WITH_USERNAME":true,"DOWNLOAD_LINK":true,"SHOW_USERNAME_ACCOUNT_CREATE":true,"SHOW_SCROLL_DOWN_ARROW":true,"SHOW_ADDRESS_ACCOUNT_CREATE":true,"TWO_COLUMN_ACCOUNT_CREATE":true,"RESET_PASSWORD_TIP":"A link to change your password has been sent to your email. Please allow a few minutes for this message to arrive. Please check your junk/spam folders if you do not find the email in your inbox.","FORGOT_PASSWORD_LINK_TEXT":"Reset Password","PHONE_NUMBER_OPTIONAL_ACCOUNT_CREATE":true,"SHOW_REQUIRED_INDICATOR_ACCOUNT_CREATE":true,"PASSWORD_REQUIREMENTS_ACCOUNT_CREATE":"\n    <ul>\n      <li>MUST contain at least 8 characters (12+ recommended)</li>\n      <li>MUST contain at least one uppercase letter.</li>\n      <li>MUST contain at least one lowercase letter.</li>\n      <li>MUST contain at least one number.</li>\n      <li>MUST contain at least one special character (!”#$%&'()*+,-./:;<=>?</li>\n    </ul>\n  ","ALLOW_CERTIFICATION_REQUEST":true,"ALLOW_PUBLIC_CERTIFICATE_REQUEST":true,"ALLOW_COPY_REQUEST":false,"ALLOW_CORRECTION_STYLING":true,"HIDE_DEPRECATION_WARNING":false,"AMEND_ROUTE_PUBLIC":true,"SEAL_FILENAME":"seal.png","SHOPPING_CART":true,"ALLOW_PAYMENT_UPDATE_WITH_EMPTY_CART":true,"RA_EMAIL":true,"RA_WEBSITE":true,"RA_NO_DEFAULT_TYPE":true,"RA_ADDRESS_LABEL":"Street Address","RA_TYPE_SELECTION_DEFAULT":true,"RA_DEFAULT_TYPE":"460","RA_OVERRIDE_TYPE_WITH_DEFAULT":true,"RA_PRINCIPAL_ADDRESS_AMS":true,"UPLOAD_AND_SUBMIT_HIDE_IF_ONE_OPTION":true,"PAYMENT_PROCESSING_MESSAGE":"Your payment is processing - Do not close your browser or click the back button","CHECKOUT_BUTTON_WHEN_PROCESSING_TEXT":"Processing","EFS_CROP_PICKER_NONE_LABEL":"Lien Duration","DISALLOWED_WIZARD_PIECES":["FormationLocale"],"REPEATER_SHOW_EDIT_BUTTON":true,"DATA_REQUEST_PAGE_TITLE":"Data Requests and Subscriptions","DATA_REQUEST_SIDEBAR_LABEL":"Data Requests & Subscriptions","LOGIN_REDIRECTS_TO_EPASS":false,"LOGIN_REDIRECTS_TO_ACTIVE_DIRECTORY":true,"LOGIN_ACTIVE_DIRECTORY_LINK":true,"FETCH_EDIT_USER_LINK":false,"LISTS_FETCH_AVAILABLE_LISTS":true,"POST_WIZARD_SUBMIT_REDIRECT_URL":"/","PIN_REQUEST_ATTESTATIONS":true,"PIN_REQUEST_DESCRIPTION":"Click **Request PIN** to have a new PIN sent to the account holder's email address on file.","OWNERSHIP_REQUEST_DESCRIPTION":"To become an **authorized user** of this record, a current **AUTHORIZED USER** will need to grant you access. To request access, click **Request Access** below.","PIN_REQUEST_SUCCESS_MESSAGE":"The PIN you have requested for this entity has been sent to the email associated with your user account.  You should receive the PIN in approximately 3-5 minutes, depending on your email service provider.","APOSTILLE_HEADER_LABEL":"Verification Information","APOSTILLE_NUMBER_LABEL":"Apostille/Authentication","APOSTILLE_CITY_STATE_OVERRIDE":"HELENA, MT","APOSTILLE_FILING_DATE_LABEL":"Issue Date","APOSTILLE_CITY_STATE_IN_CERTIFIED":true,"NOTARY_EXISTING_FILING":true,"ALLOW_REVOKE_OWN_ACCESS_ONLY":false,"HIDE_CANCEL_ON_ONETIME_DATA_REQUESTS":true,"DATA_REQUESTS_IN_SHOPPING_CART":true,"WQ_ALLOW_EDIT_PENDING_PAYMENT":true,"WQ_CONFIRM_ON_DELETE":true,"WQ_DELETE_CONFIRM_MESSAGE":"Deleting this filing will forfeit any money already paid to the Secretary of State. This action is permanent and cannot be undone, are you sure you would like to delete?","PASS_ITEM_GUIDS_ON_CHECKOUT":true,"FORM_REVISION_HISTORY":true,"CHECKOUT_DISCLAIMER":"By entering your credit card and/or checking account information you (i) state that **you are an authorized user** of the credit card and/or electronic check and that the associated information entered (e.g., account holder name, account number, billing address) is accurate, (ii) **you authorize payment processor to charge the amount you have requested** to your credit card and/or funding account, and (iii) **acknowledge if a charge is declined or reversed you may also be assessed a customary charge** by the payment processor for such transactions.","FARM_BILL_SEARCH_CONFIDENTIAL":"As a registered Farm Bill Buyer with the Montana Secretary of State’s office it is important to maintain the confidentiality of the information contained within the Farm Bill Master List. The Farm Bill Master List reflects personal data, such as Social Security Numbers, which are a key piece of personal identifiable information to assist you in determining the existence of a lien against a specific debtor. The distribution of this information beyond its intended purpose is strictly prohibited.\n\n**The debtor's tax identification number has been hidden for confidentiality reasons. You may continue to search on a tax ID number and return debtors that match your search criteria. The SSN/FEIN must be entered without dashes or spaces.  If you need access to the tax identification number to clearly identify the debtor, please contact the UCC unit at (406) 444-3665.**","VIEW_HISTORY_BUTTON_ALT_TEXT":"View Filings","WIZARD_ERROR_TITLE_MESSAGE":"Form Error","FARM_BILL_SEARCH_INTERACTIVE":true,"USE_FARM_BILL_API":true,"DISALLOW_ASSIGN_SELF_AS_RA":true,"DISALLOW_ASSIGN_SELF_AS_PRINCIPAL":true,"USE_TRADEMARK_OWNER_VALIDATION":true,"USE_ALTERNATIVE_FOREIGN_ADDRESS_LABELS":true,"MY_RECEIPTS_FILTER":[{"type":"dateRange","name":"DATE_RANGE","label":"Date range","defaultValue":{"start":null,"end":null}},{"type":"text","name":"REF_NUM","defaultValue":"","label":"Reference Number"},{"type":"text","name":"RECEIPT_NUM","defaultValue":"","label":"Receipt Id"},{"type":"text","name":"AMOUNT","defaultValue":"","label":"Amount"},{"type":"select","name":"TYPE","defaultValue":"","label":"Payment Type","options":[{"value":"","label":"All"},{"value":"CC","label":"Credit Card"},{"value":"Check","label":"Check"}]}],"MY_RECEIPTS_SHOW_IN_SIDEBAR":true,"SHOW_MY_RECEIPTS_HELPER_TEXT":true,"MY_RECEIPTS_HELPER_LABEL":"About Receipt Search","MY_RECEIPTS_HELPER_TEXT":"You can search for receipts based on their descriptions, including the items paid for on the receipt. Use the filters to search for or filter specific information.","FARM_BILL_SUBLINK":{"label":"Farm Bill","component":"FarmBill","parameter":"farm-bill","path":"/lists/farm-bill","sourceTypeId":0,"myRecordsSearch":false,"allowedRules":["/search/"],"disabled":true,"searchDescription":"To perform a search, enter a debtor name. Your search results may include: exact debtor name, variations of that name and any filing that includes your search criteria. Punctuation is ignored.\n\nYou can click on \"Advanced\" to refine your search. Under “Advanced” you can search by crop, year, county and SSN/FEIN. As a registered Farm Bill Buyer with the Montana Secretary of State’s office it is important to maintain the confidentiality of the information contained within the Farm Bill Master List. The Farm Bill Master List reflects personal data, such as Social Security Numbers, which are a key piece of personal identifiable information to assist you in determining the existence of a lien against a specific debtor. The distribution of this information beyond its intended purpose is strictly prohibited.\n\nThe debtor's tax identification number has been hidden for confidentiality reasons. You may continue to search on a tax ID number and return debtors that match your search criteria. The SSN/FEIN must be entered without dashes or spaces.","searchMustHaveOneOf":["search","UCC_FARM_PRODUCT_ID","COUNTY"],"searchPlaceholder":"Search by debtor name","advancedSearchParameters":[{"type":"ServerMultiComplete","label":"Product code name(s)","name":"UCC_FARM_PRODUCT_ID","defaultValue":"","optionsSrc":"UCC_FARM_PRODUCT_V"},{"type":"MultiComplete","label":"Year or Range of Years","name":"YEAR_NUM","optionsSrc":"years","startYear":"1968","defaultValue":[],"preMergeOptions":[{"value":"ALL","label":"All"}]},{"type":"serverSelect","label":"State","name":"STATE","defaultValue":"MONTANA","optionsSrc":"STATE"},{"type":"ServerMultiComplete","label":"County","name":"COUNTY","defaultValue":[],"optionsSrc":"COUNTY","overrideSubOptionsSrcFromParameterName":"STATE"},{"type":"checkbox","name":"TIN_SEARCH_YN","defaultValue":false,"label":"Tax Identification Number Search"},{"type":"checkbox","name":"TIN_SORT_YN","defaultValue":false,"label":"Unique ID Sort"}]},"ALLOW_ADDRESS_VALIDATION_BYPASS_OPTION":true,"DEFAULT_ADDRESS_VALIDATION_BYPASS_OPTION_CHECKED":true}).PROXY_URL :  false ? 'http://localhost:' + DEV_PORT : '';
	
	// const setAppError = (error) => ({
	//   type: "SET_APP_ERROR",
	//   errorType: 'danger',
	//   error
	// })
	
	// const handleErrors = (response) => (
	//   new Promise((resolve, reject) => {
	//     console.log(response);
	//     if(response.ok){
	//       resolve(response)
	//     }else{
	//       // store.dispatch(setAppError())
	//       // console.log("Got an error");
	//       reject(response)
	//     }
	//   })
	// )
	//
	// const catchErrors = response => {
	//   store.dispatch(setAppError("It looks we can't reach the server right now. Check your internet connection and try again later."))
	//   if(process.env.NODE_ENV !== "test"){console.error(response)}
	// }
	
	var handleCustomHeaders = function handleCustomHeaders(response) {
	  try {
	    // Handle authorization headers
	    var timeout = response.headers.get('session-timeout');
	    if (timeout) {
	      timeout = parseInt(timeout, 10);
	      if (timeout) {
	        (0, _AuthActions.setAuthTimeout)(timeout);
	      }
	    }
	
	    // Handle search cache invalidation
	    var invalidateSearchCache = response.headers.get('invalidate-search-cache');
	    if (invalidateSearchCache) {
	      if (invalidateSearchCache === 'all') {
	        (0, _SearchActions.invalidateAllCategoryCaches)()(_store2.default.dispatch, _store2.default.getState);
	      }
	    }
	
	    // Handle work queue cache invalidation
	    var invalidateWorkQueueCache = response.headers.get('invalidate-work-queue-cache');
	    if (invalidateWorkQueueCache) {
	      if (invalidateWorkQueueCache === 'all') {
	        (0, _MyWorkQueueActions.invalidateAllCategoryCaches)()(_store2.default.dispatch, _store2.default.getState);
	      }
	    }
	
	    // Handle work queue cache invalidation
	    var invalidateMyRecordsCache = response.headers.get('invalidate-my-records-cache');
	    if (invalidateMyRecordsCache) {
	      if (invalidateMyRecordsCache === 'all') {
	        (0, _MyRecordsActions.invalidateAllCategoryCaches)()(_store2.default.dispatch, _store2.default.getState);
	      }
	    }
	  } catch (e) {
	    console.error(e);
	  }
	};
	
	var parseResponse = function parseResponse(response) {
	  return new Promise(function (resolve, reject) {
	    var contentType = response.headers.get('content-type') || '';
	    var responseIsJson = contentType.toLowerCase().includes('application/json');
	
	    handleCustomHeaders(response);
	
	    if (response.status === 403) {
	      (0, _utilities.handleForbiddenResponse)();
	    }
	
	    if (response.status === 503) {
	      (0, _utilities.handleOfflineResponse)();
	    }
	
	    if (response.status === 204) {
	      response.text().then(resolve);
	      return;
	    }
	
	    if (response.status === 200) {
	      if (responseIsJson) {
	        response.json().then(resolve);
	        return;
	      } else {
	        response.text().then(resolve);
	        return;
	      }
	    }
	
	    if (response.status !== 200) {
	      //       console.warn(
	      // `The requested route responded with an unhandled status: \
	      // ${response.status} (${response.statusText}). If this is unexpected, \
	      // check the controller method for route: ${response.url}.`
	      //       )
	      if (responseIsJson) {
	        response.text().then(function (text) {
	          try {
	            var parsed = JSON.parse(text);
	            if (response.ok) {
	              resolve(parsed);
	            } else {
	              reject(parsed);
	            }
	          } catch (e) {
	            console.warn('The server responded with a content-type of "' + contentType + '" but json parsing failed. The response will be returned as plain text. For performance reasons, if the response body is not json, content-type should be set to "text/plain". Check the controller method for route: ' + response.url);
	            reject(text);
	          }
	        });
	        return;
	      } else {
	        response.text().then(function (text) {
	          if (response.ok) {
	            resolve(text);
	          } else {
	            reject(text);
	          }
	        });
	      }
	    }
	  });
	};
	
	var fetchAndCatch = function fetchAndCatch(props, callback, errorCallback) {
	  var auth = {};
	  var AUTH = localStorage.getItem('WEB_USER_AUTHENTICATION');
	  auth = AUTH && AUTH !== 'undefined' ? JSON.parse(AUTH) : {};
	  var request = void 0;
	  switch (props.method) {
	    case 'PUT':
	    case 'POST':
	      request = {
	        method: props.method,
	        headers: new Headers(Object.assign({
	          'content-type': 'application/json',
	          Authorization: auth.ID
	        }, props.headers)),
	        body: props.body ? props.body : JSON.stringify({})
	      };
	      break;
	    case 'GET':
	    default:
	      request = {
	        method: 'GET',
	        headers: new Headers(Object.assign({
	          Authorization: auth.ID
	        }, props.headers))
	      };
	  }
	  if (props.cookies) {
	    request.credentials = 'include';
	  }
	  if (props.getSignal && window.AbortController) {
	    var controller = new AbortController();
	    request.signal = controller.signal;
	    props.getSignal(controller);
	  }
	  fetch('' + BASE_URL + props.url, request)
	  // .then(handleErrors)
	  .then(function (response) {
	    // debugger;
	    if (props.raw) {
	      return response;
	    } else {
	      return parseResponse(response);
	    }
	  }).then(function (response) {
	    callback(response, props);
	  }).catch(function (err) {
	    if (errorCallback) {
	      errorCallback(err);
	    } else {
	      callback(err);
	      console.warn('The request for route: ' + props.url + ' did not provide an error callback. The success callback was used instead.');
	    }
	  });
	};
	
	var GET = exports.GET = function GET(url, callback, errorCallback) {
	  fetchAndCatch({
	    url: url,
	    method: 'GET'
	  }, callback, errorCallback);
	};
	
	var SEARCH = exports.SEARCH = function SEARCH(payload, category, callback, errorCallback) {
	  var print = payload.PRINT;
	  delete payload.PRINT;
	  fetchAndCatch({
	    url: '/api/Records/' + category + 'search' + (print ? '?print=true' : ''),
	    method: 'POST',
	    body: JSON.stringify(payload)
	  }, callback, errorCallback);
	};
	
	var GET_SEARCH_DESCRIPTION = exports.GET_SEARCH_DESCRIPTION = function GET_SEARCH_DESCRIPTION(category, callback) {
	  fetchAndCatch({
	    url: '/api/search/description/' + category,
	    method: 'GET'
	  }, callback);
	};
	
	var GET_MY_RECORDS = exports.GET_MY_RECORDS = function GET_MY_RECORDS(category, parameters, requestId, callback, errorCallback) {
	  fetchAndCatch({
	    url: '/api/Records/GetMyRecords/' + category,
	    method: 'POST',
	    auth: true,
	    body: JSON.stringify(parameters),
	    requestId: requestId
	  }, callback, errorCallback);
	};
	
	var GET_MY_RECORDS_DESCRIPTION = exports.GET_MY_RECORDS_DESCRIPTION = function GET_MY_RECORDS_DESCRIPTION(category, callback) {
	  fetchAndCatch({
	    url: '/api/MyRecords/description/' + category,
	    method: 'GET'
	  }, callback);
	};
	
	var GET_FARM_BILL_RECORD_DETAILS = exports.GET_FARM_BILL_RECORD_DETAILS = function GET_FARM_BILL_RECORD_DETAILS(category, parameters, requestId, getSignal, callback, errorCallback) {
	  fetchAndCatch({
	    url: '/api/FilingDetail/' + category,
	    method: 'POST',
	    auth: true,
	    body: JSON.stringify(parameters),
	    requestId: requestId,
	    getSignal: getSignal
	  }, callback, errorCallback);
	};
	
	var GET_MY_RECEIPTS = exports.GET_MY_RECEIPTS = function GET_MY_RECEIPTS(requestId, parameters, callback, errorCallback) {
	  fetchAndCatch({
	    url: '/api/Receipts/getMyReceipts',
	    method: 'POST',
	    auth: true,
	    body: JSON.stringify(parameters),
	    requestId: requestId
	  }, callback, errorCallback);
	};
	
	var GET_MY_RECEIPTS_DETAILS = exports.GET_MY_RECEIPTS_DETAILS = function GET_MY_RECEIPTS_DETAILS(requestId, receiptId, callback, errorCallback) {
	  fetchAndCatch({
	    url: '/api/receipts/getreceipt/' + receiptId,
	    method: 'GET',
	    auth: true,
	    requestId: requestId
	  }, callback, errorCallback);
	};
	
	var GET_MY_RECEIPT_REPORT_DETAILS = exports.GET_MY_RECEIPT_REPORT_DETAILS = function GET_MY_RECEIPT_REPORT_DETAILS(requestId, parameters, callback, errorCallback) {
	  fetchAndCatch({
	    url: '/api/receipts/getFormDefinitionId',
	    method: 'POST',
	    auth: true,
	    body: JSON.stringify(parameters),
	    requestId: requestId
	  }, callback, errorCallback);
	};
	
	var GET_FILING_DETAILS = exports.GET_FILING_DETAILS = function GET_FILING_DETAILS(category, recordId, isPublicView, getSignal, callback, errorCallback) {
	  fetchAndCatch({
	    url: '/api/FilingDetail/' + category + '/' + recordId + '/' + isPublicView,
	    method: 'GET',
	    getSignal: getSignal
	  }, callback, errorCallback);
	};
	
	var GET_ALL_WIZARDS = exports.GET_ALL_WIZARDS = function GET_ALL_WIZARDS(category, callback) {
	  fetchAndCatch({
	    url: '/api/FormDefinition/' + (category ? 'category/' + category : ''),
	    method: 'GET'
	  }, callback);
	};
	
	var GET_LOOKUP_GROUPS = exports.GET_LOOKUP_GROUPS = function GET_LOOKUP_GROUPS(type, callback) {
	  fetchAndCatch({
	    url: '/api/LookupGroup/' + type,
	    method: 'GET'
	  }, callback);
	};
	
	var GET_LOOKUP_SUB_GROUPS = exports.GET_LOOKUP_SUB_GROUPS = function GET_LOOKUP_SUB_GROUPS(id, callback) {
	  fetchAndCatch({
	    url: '/api/LookupSubGroup/' + id,
	    method: 'GET'
	  }, callback);
	};
	
	var GET_GROUP_ITEMS = exports.GET_GROUP_ITEMS = function GET_GROUP_ITEMS(groupId, callback) {
	  var payload = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : undefined;
	
	  var query = _store2.default.getState().router.location.search || '';
	  fetchAndCatch({
	    url: '/api/GroupItems/' + groupId + query,
	    method: (true) && !groupId.includes('/') ? 'POST' : 'GET',
	    body: JSON.stringify(payload)
	  }, callback);
	};
	
	var VALIDATE = exports.VALIDATE = function VALIDATE(type, payload, callback, errorCallback) {
	  fetchAndCatch({
	    url: '/api/Validation',
	    method: 'POST',
	    body: JSON.stringify({ type: type, payload: payload })
	  }, callback, errorCallback);
	};
	
	var LOAD_WIZARD_BY_ID = exports.LOAD_WIZARD_BY_ID = function LOAD_WIZARD_BY_ID(formDefinitionId, callback) {
	  fetchAndCatch({
	    url: '/api/FormDefinition/GetWizard/' + formDefinitionId,
	    method: 'GET'
	  }, callback);
	};
	
	var LOAD_WIZARD_HISTORY_BY_ID = exports.LOAD_WIZARD_HISTORY_BY_ID = function LOAD_WIZARD_HISTORY_BY_ID(formDefinitionId, callback, errorCallback) {
	  fetchAndCatch({
	    url: '/api/FormDefinition/GetWizardHistory/' + formDefinitionId,
	    method: 'GET'
	  }, callback, errorCallback);
	};
	
	var LOAD_WIZARD_REVISION_STEPS_BY_ID = exports.LOAD_WIZARD_REVISION_STEPS_BY_ID = function LOAD_WIZARD_REVISION_STEPS_BY_ID(formDefinitionId, revisionId, callback, errorCallback) {
	  fetchAndCatch({
	    url: '/api/FormDefinition/GetWizardRevisionSteps/' + formDefinitionId + '/' + revisionId,
	    method: 'GET'
	  }, callback, errorCallback);
	};
	
	var LOAD_WIZARD_INJECT_METADATA = exports.LOAD_WIZARD_INJECT_METADATA = function LOAD_WIZARD_INJECT_METADATA(formDefinitionId) {
	  var amendmentNum = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'null';
	  var isExistingFiling = arguments[2];
	  var callback = arguments[3];
	  var errorCallback = arguments[4];
	
	  var query = _store2.default.getState().router.location.search || '';
	  var isExistingFilingParam =  true ? '/' + isExistingFiling : '';
	  fetchAndCatch({
	    url: '/api/FormDefinition/GetWizardInjectMetadata/' + formDefinitionId + '/' + amendmentNum + query + isExistingFilingParam,
	    method: 'GET'
	  }, callback, errorCallback);
	};
	
	var SAVE_WIZARD = exports.SAVE_WIZARD = function SAVE_WIZARD(wizard, callback, errorCallback) {
	  // console.log(wizard)
	  fetchAndCatch({
	    url: '/api/FormDefinition/',
	    method: 'POST',
	    body: JSON.stringify(wizard),
	    auth: true
	  }, callback, errorCallback);
	};
	
	var CLONE_WIZARD = exports.CLONE_WIZARD = function CLONE_WIZARD(formDefinitionId, payload, callback, errorCallback) {
	  fetchAndCatch({
	    url: '/api/FormDefinition/clone/' + formDefinitionId,
	    method: 'POST',
	    body: JSON.stringify(payload),
	    auth: true
	  }, callback, errorCallback);
	};
	
	var ARCHIVE_WIZARD = exports.ARCHIVE_WIZARD = function ARCHIVE_WIZARD(formDefinitionId, payload, callback, errorCallback) {
	  fetchAndCatch({
	    url: '/api/FormDefinition/archive/' + formDefinitionId,
	    method: 'POST',
	    body: JSON.stringify(payload),
	    auth: true
	  }, callback, errorCallback);
	};
	
	var getFormDataObject = function getFormDataObject(files) {
	  var payload = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	  var fileObject = new FormData();
	  // console.log(files)
	  Object.keys(files).forEach(function (key) {
	    // console.log(key, files[key])
	    fileObject.append('file', files[key]);
	  });
	  Object.keys(payload).forEach(function (key) {
	    fileObject.append(key, payload[key]);
	  });
	  // console.log("fileObject", fileObject.getAll("file"));
	  return fileObject;
	};
	
	var UPLOAD_FILES = exports.UPLOAD_FILES = function UPLOAD_FILES(files, payload, onProgress) {
	  var opts = {};
	  opts.body = getFormDataObject(files, payload);
	  var AUTH = localStorage.getItem('WEB_USER_AUTHENTICATION');
	  var auth = AUTH && AUTH !== 'undefined' ? JSON.parse(AUTH) : {};
	  return new Promise(function (res, rej) {
	    var xhr = new XMLHttpRequest();
	    xhr.open('POST', BASE_URL + '/api/FileUpload');
	    xhr.setRequestHeader('Authorization', auth.ID);
	    xhr.onload = function (e) {
	      return res(e.target.responseText);
	    };
	    xhr.onerror = rej;
	    if (xhr.upload && onProgress) xhr.upload.onprogress = onProgress;
	    //xhr.addEventListener("progress", onProgress)
	    xhr.send(opts.body);
	  });
	};
	
	var SEARCH_REGISTERED_AGENTS = exports.SEARCH_REGISTERED_AGENTS = function SEARCH_REGISTERED_AGENTS(payload, callback) {
	  fetchAndCatch({
	    url: '/api/RA',
	    method: 'POST',
	    body: JSON.stringify(payload)
	  }, callback);
	};
	
	var GET_REGISTERED_AGENT_BY_ID = exports.GET_REGISTERED_AGENT_BY_ID = function GET_REGISTERED_AGENT_BY_ID(id, callback) {
	  fetchAndCatch({
	    url: '/api/RA/' + id,
	    method: 'GET'
	  }, callback);
	};
	var GET_BY_ID = exports.GET_BY_ID = function GET_BY_ID(searchType, idAndQuery, callback, errorCallback) {
	  fetchAndCatch({
	    url: '/api/Search/' + searchType + '/' + idAndQuery,
	    method: 'GET'
	  }, callback, errorCallback);
	};
	
	var GET_WORK_QUEUE_ITEMS = exports.GET_WORK_QUEUE_ITEMS = function GET_WORK_QUEUE_ITEMS(category, parameters, requestId, callback, errorCallback) {
	  fetchAndCatch({
	    url: '/api/WorkQueue/' + category,
	    method: 'POST',
	    auth: true,
	    body: JSON.stringify(parameters),
	    requestId: requestId
	  }, callback, errorCallback);
	};
	
	var GET_WORK_QUEUE_DESCRIPTION = exports.GET_WORK_QUEUE_DESCRIPTION = function GET_WORK_QUEUE_DESCRIPTION(category, callback) {
	  fetchAndCatch({
	    url: '/api/WorkQueue/description/' + category,
	    method: 'GET'
	  }, callback);
	};
	
	var SAVE_RECORD = exports.SAVE_RECORD = function SAVE_RECORD(json, category, mode, isCorrection, callback, errorCallback) {
	  fetchAndCatch({
	    url: '/api/' + category + '/' + mode + (isCorrection ? '/correct' : ''),
	    method: 'POST',
	    body: JSON.stringify({ json: JSON.stringify(json) }),
	    auth: true
	  }, callback, errorCallback);
	};
	
	var SAVE_RECORD_WITH_SIGNATURES = function SAVE_RECORD_WITH_SIGNATURES(json, category, isCorrection, callback, errorCallback) {
	  var _json$extraPayload = json.extraPayload,
	      extraPayload = _json$extraPayload === undefined ? {} : _json$extraPayload,
	      payload = _objectWithoutProperties(json, ['extraPayload']);
	
	  fetchAndCatch({
	    url: '/api/Signature/' + category + (isCorrection ? '/correct' : ''),
	    method: 'POST',
	    body: JSON.stringify(Object.assign({ json: JSON.stringify(payload) }, extraPayload))
	  }, callback, errorCallback);
	};
	
	exports.SAVE_RECORD_WITH_SIGNATURES = SAVE_RECORD_WITH_SIGNATURES;
	var GET_SIGNATURES_BY_GROUP_TOKEN = exports.GET_SIGNATURES_BY_GROUP_TOKEN = function GET_SIGNATURES_BY_GROUP_TOKEN(groupToken, callback, errorCallback) {
	  fetchAndCatch({
	    url: '/api/Signature/' + groupToken,
	    method: 'GET'
	  }, callback, errorCallback);
	};
	
	var SET_SIGNER_EMAIL_BY_TOKEN = exports.SET_SIGNER_EMAIL_BY_TOKEN = function SET_SIGNER_EMAIL_BY_TOKEN(_ref, callback, errorCallback) {
	  var SIGNER_EMAIL = _ref.SIGNER_EMAIL,
	      TOKEN = _ref.TOKEN;
	
	  fetchAndCatch({
	    url: '/api/Signature/update-email/' + TOKEN,
	    method: 'POST',
	    body: JSON.stringify({ SIGNER_EMAIL: SIGNER_EMAIL })
	  }, callback, errorCallback);
	};
	
	var GET_SIGNATURE_FORM_BY_TOKEN = exports.GET_SIGNATURE_FORM_BY_TOKEN = function GET_SIGNATURE_FORM_BY_TOKEN(token, callback, errorCallback) {
	  fetchAndCatch({
	    url: '/api/Signature/form/' + token,
	    method: 'GET'
	  }, callback, errorCallback);
	};
	
	var RESEND_SIGNER_EMAIL = exports.RESEND_SIGNER_EMAIL = function RESEND_SIGNER_EMAIL(token, callback, errorCallback) {
	  fetchAndCatch({
	    url: '/api/signature/resend-email/' + token,
	    method: 'GET'
	  }, callback, errorCallback);
	};
	
	var SAVE_SIGNATURE_BY_TOKEN_AND_CATEGORY = exports.SAVE_SIGNATURE_BY_TOKEN_AND_CATEGORY = function SAVE_SIGNATURE_BY_TOKEN_AND_CATEGORY(_ref2, callback, errorCallback) {
	  var token = _ref2.token,
	      category = _ref2.category,
	      payload = _ref2.payload;
	
	  fetchAndCatch({
	    url: '/api/Signature/' + token + '/' + category,
	    method: 'POST',
	    body: JSON.stringify(payload)
	  }, callback, errorCallback);
	};
	
	var GET_FILING_TYPE_IDS = exports.GET_FILING_TYPE_IDS = function GET_FILING_TYPE_IDS(callback) {
	  fetchAndCatch({
	    url: '/api/FilingType',
	    method: 'GET'
	  }, callback);
	};
	
	var SAVE_DRAFT = exports.SAVE_DRAFT = function SAVE_DRAFT(payload, callback) {
	  fetchAndCatch({
	    url: '/api/Draft',
	    method: 'POST',
	    body: JSON.stringify(payload),
	    auth: true
	  }, callback);
	};
	
	var DELETE_DRAFT_BY_ID = exports.DELETE_DRAFT_BY_ID = function DELETE_DRAFT_BY_ID(draftId, callback) {
	  fetchAndCatch({
	    url: '/api/WorkQueue/DeleteDraft/' + draftId,
	    method: 'POST',
	    auth: true
	  }, callback);
	};
	
	var LOAD_DRAFT_BY_ID = exports.LOAD_DRAFT_BY_ID = function LOAD_DRAFT_BY_ID(draftId, callback, errorCallback) {
	  fetchAndCatch({
	    url: '/api/Draft/' + draftId,
	    method: 'GET',
	    auth: true
	  }, callback, errorCallback);
	};
	
	var LOAD_AMENDMENT_BY_ID = exports.LOAD_AMENDMENT_BY_ID = function LOAD_AMENDMENT_BY_ID(amendmentNum, category, mode, isCorrection, accessLevel, callback, errorCallback) {
	  fetchAndCatch({
	    url: '/api/' + category + '/' + mode + '/' + amendmentNum + '/' + isCorrection + '/' + (accessLevel ? accessLevel : ''),
	    method: 'GET',
	    auth: true
	  }, callback, errorCallback);
	};
	
	var DELETE_RECORD_BY_ID = exports.DELETE_RECORD_BY_ID = function DELETE_RECORD_BY_ID(draftId, category, callback, errorCallback) {
	  fetchAndCatch({
	    url: '/api/WorkQueue/DeleteRecord/' + category + '/' + draftId,
	    method: 'POST',
	    auth: true
	  }, callback, errorCallback);
	};
	
	var GET_HOME_PAGE_STRUCTURE = exports.GET_HOME_PAGE_STRUCTURE = function GET_HOME_PAGE_STRUCTURE(callback, errorCallback) {
	  fetchAndCatch({
	    url: '/api/home?id=' + (0, _uuid.v4)(),
	    method: 'GET'
	  }, callback, errorCallback);
	};
	
	var GET_APP_SETTING_BY_NAME = exports.GET_APP_SETTING_BY_NAME = function GET_APP_SETTING_BY_NAME(name, callback, errorCallback) {
	  fetchAndCatch({
	    url: '/api/AppSetting/' + name,
	    method: 'GET'
	  }, callback, errorCallback);
	};
	
	var GET_APP_SETTINGS_BY_NAME = exports.GET_APP_SETTINGS_BY_NAME = function GET_APP_SETTINGS_BY_NAME(settingNames, callback, errorCallback) {
	  fetchAndCatch({
	    url: '/api/AppSetting/getSettingsByName',
	    method: 'POST',
	    body: JSON.stringify(settingNames)
	  }, callback, errorCallback);
	};
	
	var GET_AVAILABLE_APP_SETTINGS = exports.GET_AVAILABLE_APP_SETTINGS = function GET_AVAILABLE_APP_SETTINGS(callback, errorCallback) {
	  fetchAndCatch({
	    url: '/api/AppSetting/getAvailableAppSettings',
	    method: 'GET'
	  }, callback, errorCallback);
	};
	
	var SAVE_APP_SETTING_BY_NAME = exports.SAVE_APP_SETTING_BY_NAME = function SAVE_APP_SETTING_BY_NAME(payload, callback) {
	  fetchAndCatch({
	    url: '/api/AppSetting',
	    method: 'POST',
	    body: JSON.stringify(payload),
	    auth: true
	  }, callback);
	};
	
	var UPDATE_APP_SETTING_BY_ID = exports.UPDATE_APP_SETTING_BY_ID = function UPDATE_APP_SETTING_BY_ID(id, payload, callback, errorCallback) {
	  fetchAndCatch({
	    url: '/api/AppSetting/' + id,
	    method: 'POST',
	    body: JSON.stringify(payload)
	  }, callback, errorCallback);
	};
	
	var CREATE_WEB_USER = exports.CREATE_WEB_USER = function CREATE_WEB_USER(payload, callback, errorCallback) {
	  fetchAndCatch({
	    url: '/api/Auth/createWebUser',
	    method: 'POST',
	    body: JSON.stringify(payload)
	  }, callback, errorCallback);
	};
	
	var SEND_PASSWORD_RESET_EMAIL = exports.SEND_PASSWORD_RESET_EMAIL = function SEND_PASSWORD_RESET_EMAIL(payload, callback, errorCallback) {
	  fetchAndCatch({
	    url: '/api/Auth/sendPasswordReset',
	    method: 'POST',
	    body: JSON.stringify(payload)
	  }, callback, errorCallback);
	};
	
	var SEND_FORGOT_USERNAME_EMAIL = exports.SEND_FORGOT_USERNAME_EMAIL = function SEND_FORGOT_USERNAME_EMAIL(payload, callback, errorCallback) {
	  fetchAndCatch({
	    url: '/api/Auth/sendForgotUsername',
	    method: 'POST',
	    body: JSON.stringify(payload)
	  }, callback, errorCallback);
	};
	
	var CHANGE_PASSWORD = exports.CHANGE_PASSWORD = function CHANGE_PASSWORD(payload, callback, errorCallback) {
	  fetchAndCatch({
	    url: '/api/Auth/changePassword',
	    method: 'POST',
	    body: JSON.stringify(payload)
	  }, callback, errorCallback);
	};
	
	var PARSE_PASSWORD_RESET_TOKEN = exports.PARSE_PASSWORD_RESET_TOKEN = function PARSE_PASSWORD_RESET_TOKEN(token, callback, errorCallback) {
	  fetchAndCatch({
	    url: '/api/Auth/parseResetToken',
	    method: 'POST',
	    body: JSON.stringify({ token: token })
	  }, callback, errorCallback);
	};
	
	var LOGIN_WEB_USER = exports.LOGIN_WEB_USER = function LOGIN_WEB_USER(payload, callback, errorCallback) {
	  fetchAndCatch({
	    url: '/api/Auth/login',
	    method: 'POST',
	    body: JSON.stringify(payload)
	  }, callback, errorCallback);
	};
	
	var LOGIN_APP_USER = exports.LOGIN_APP_USER = function LOGIN_APP_USER(payload, callback, errorCallback) {
	  fetchAndCatch({
	    url: '/api/Auth/app_login',
	    method: 'POST',
	    body: JSON.stringify(payload)
	  }, callback, errorCallback);
	};
	
	var LOGOUT_WEB_USER = exports.LOGOUT_WEB_USER = function LOGOUT_WEB_USER(callback) {
	  fetchAndCatch({
	    url: '/api/Auth/logout',
	    method: 'GET',
	    auth: true
	  }, callback);
	};
	
	var GET_AUTH_STATE = exports.GET_AUTH_STATE = function GET_AUTH_STATE(callback) {
	  fetchAndCatch({
	    url: '/api/Auth',
	    method: 'GET',
	    auth: true
	  }, callback);
	};
	
	var EXTEND_WEB_USER_SESSION = exports.EXTEND_WEB_USER_SESSION = function EXTEND_WEB_USER_SESSION(staleToken, callback) {
	  fetchAndCatch({
	    url: '/api/Auth/extend?staletoken=' + staleToken,
	    method: 'GET',
	    auth: true
	  }, callback);
	};
	
	var GET_RECEIPT_ITEMS_BY_ADMENDMENT_NUM = exports.GET_RECEIPT_ITEMS_BY_ADMENDMENT_NUM = function GET_RECEIPT_ITEMS_BY_ADMENDMENT_NUM(amendmentNum, category, correctionMode, callback, errorCallback) {
	  // console.log(amendmentNum);
	  fetchAndCatch({
	    url: '/api/' + category + '/getWebCart/' + amendmentNum + '/' + correctionMode,
	    method: 'GET',
	    auth: true
	  }, callback, errorCallback);
	};
	
	var GET_WEB_CART_BY_REF_NUM = exports.GET_WEB_CART_BY_REF_NUM = function GET_WEB_CART_BY_REF_NUM(refNum, callback, errorCallback) {
	  fetchAndCatch({
	    url: '/api/Payment/getWebCart/' + refNum,
	    method: 'GET',
	    auth: false
	  }, callback, errorCallback);
	};
	
	var REMOVE_FROM_WEB_CART_BY_GUID = exports.REMOVE_FROM_WEB_CART_BY_GUID = function REMOVE_FROM_WEB_CART_BY_GUID(guid, callback, errorCallback) {
	  fetchAndCatch({
	    url: '/api/Payment/removeFromCart/' + guid,
	    method: 'GET',
	    auth: true
	  }, callback, errorCallback);
	};
	
	var GET_WEB_USER_ACTIVE_CART = exports.GET_WEB_USER_ACTIVE_CART = function GET_WEB_USER_ACTIVE_CART(callback, errorCallback) {
	  fetchAndCatch({
	    url: '/api/Payment/getWebUserActiveCart',
	    method: 'GET',
	    auth: false
	  }, callback, errorCallback);
	};
	
	var POST_PAYMENT = exports.POST_PAYMENT = function POST_PAYMENT(payload, category, callback) {
	  fetchAndCatch({
	    url: '/api/' + category + '/getWebCart',
	    method: 'POST',
	    body: JSON.stringify(Object.assign({ type: 'CREDIT' }, payload)),
	    auth: true
	  }, callback);
	};
	
	var BYPASS_PAYMENT = exports.BYPASS_PAYMENT = function BYPASS_PAYMENT(payload, callback, errorCallback) {
	  fetchAndCatch({
	    url: '/api/payment/activate',
	    method: 'POST',
	    body: JSON.stringify(payload),
	    auth: true
	  }, callback, errorCallback);
	};
	
	var SEARCH_BY_KEY = exports.SEARCH_BY_KEY = function SEARCH_BY_KEY(searchTypeKey, payload, callback, errorCallback) {
	  fetchAndCatch({
	    url: '/api/Search/' + searchTypeKey,
	    method: 'POST',
	    body: JSON.stringify(payload),
	    auth: true
	  }, callback, errorCallback);
	};
	
	var GET_WEB_USER_RECORD = exports.GET_WEB_USER_RECORD = function GET_WEB_USER_RECORD(payload, callback) {
	  fetchAndCatch({
	    url: '/api/WebUserRecord',
	    method: 'POST',
	    auth: true,
	    body: JSON.stringify(payload)
	  }, callback);
	};
	
	var GET_WEB_USER_ACCESS_LIST = exports.GET_WEB_USER_ACCESS_LIST = function GET_WEB_USER_ACCESS_LIST() {
	  var category = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'business';
	  var sourceId = arguments[1];
	  var callback = arguments[2];
	
	  fetchAndCatch({
	    url: '/api/WebUserAccess/' + (0, _utilities.getSourceTypeId)(category) + '/' + sourceId,
	    method: 'GET',
	    auth: true
	  }, callback);
	};
	
	var GET_RECORD_PINS = exports.GET_RECORD_PINS = function GET_RECORD_PINS() {
	  var category = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'business';
	  var sourceId = arguments[1];
	  var callback = arguments[2];
	
	  fetchAndCatch({
	    url: '/api/Pin/' + (0, _utilities.getSourceTypeId)(category) + '/' + sourceId,
	    method: 'GET',
	    auth: true
	  }, callback);
	};
	
	var REQUEST_NEW_PIN = exports.REQUEST_NEW_PIN = function REQUEST_NEW_PIN() {
	  var category = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'business';
	  var sourceId = arguments[1];
	  var callback = arguments[2];
	  var errorCallback = arguments[3];
	
	  fetchAndCatch({
	    url: '/api/Pin',
	    method: 'POST',
	    auth: true,
	    body: JSON.stringify({ SOURCE_TYPE_ID: (0, _utilities.getSourceTypeId)(category), SOURCE_ID: sourceId })
	  }, callback, errorCallback);
	};
	
	var GET_WEB_USER_ACCESS_WITH_PIN = exports.GET_WEB_USER_ACCESS_WITH_PIN = function GET_WEB_USER_ACCESS_WITH_PIN(payload, callback, errorCallback) {
	  fetchAndCatch({
	    url: '/api/Pin/validatePin',
	    method: 'POST',
	    auth: true,
	    body: JSON.stringify(payload)
	  }, callback, errorCallback);
	};
	
	var GET_WEB_USER_ACCESS_WITH_GENERIC_PIN = exports.GET_WEB_USER_ACCESS_WITH_GENERIC_PIN = function GET_WEB_USER_ACCESS_WITH_GENERIC_PIN(pin, callback, errorCallback) {
	  fetchAndCatch({
	    url: '/api/Pin/validateGenericPin/' + pin,
	    method: 'GET',
	    auth: true
	  }, callback, errorCallback);
	};
	
	var GET_WEB_USER_IS_RECORD_OWNER = exports.GET_WEB_USER_IS_RECORD_OWNER = function GET_WEB_USER_IS_RECORD_OWNER() {
	  var category = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'business';
	  var sourceId = arguments[1];
	  var callback = arguments[2];
	
	  fetchAndCatch({
	    url: '/api/WebUserAccess/GET_USER_IS_OWNER',
	    method: 'POST',
	    auth: true,
	    body: JSON.stringify({ SOURCE_TYPE_ID: (0, _utilities.getSourceTypeId)(category), SOURCE_ID: sourceId })
	  }, callback);
	};
	
	var GET_RECORD_HAS_OWNERS = exports.GET_RECORD_HAS_OWNERS = function GET_RECORD_HAS_OWNERS() {
	  var category = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'business';
	  var sourceId = arguments[1];
	  var callback = arguments[2];
	
	  fetchAndCatch({
	    url: '/api/WebUserAccess/GET_RECORD_HAS_OWNERS',
	    method: 'POST',
	    auth: true,
	    body: JSON.stringify({ SOURCE_TYPE_ID: (0, _utilities.getSourceTypeId)(category), SOURCE_ID: sourceId })
	  }, callback);
	};
	
	var GET_RECORD_HAS_ACTIVE_PIN = exports.GET_RECORD_HAS_ACTIVE_PIN = function GET_RECORD_HAS_ACTIVE_PIN() {
	  var category = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'business';
	  var sourceId = arguments[1];
	  var callback = arguments[2];
	
	  fetchAndCatch({
	    url: '/api/Pin/GET_RECORD_HAS_ACTIVE_PIN',
	    method: 'POST',
	    auth: true,
	    body: JSON.stringify({ SOURCE_TYPE_ID: (0, _utilities.getSourceTypeId)(category), SOURCE_ID: sourceId })
	  }, callback);
	};
	
	var REQUEST_RECORD_ACCESS = exports.REQUEST_RECORD_ACCESS = function REQUEST_RECORD_ACCESS() {
	  var category = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'business';
	  var sourceId = arguments[1];
	  var callback = arguments[2];
	
	  fetchAndCatch({
	    url: '/api/WebUserAccess/REQUEST_RECORD_ACCESS',
	    method: 'POST',
	    auth: true,
	    body: JSON.stringify({ SOURCE_TYPE_ID: (0, _utilities.getSourceTypeId)(category), SOURCE_ID: sourceId })
	  }, callback);
	};
	
	var GET_USER_HAS_ALREADY_REQUESTED_WEB_USER_ACCESS = exports.GET_USER_HAS_ALREADY_REQUESTED_WEB_USER_ACCESS = function GET_USER_HAS_ALREADY_REQUESTED_WEB_USER_ACCESS() {
	  var category = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'business';
	  var sourceId = arguments[1];
	  var callback = arguments[2];
	
	  fetchAndCatch({
	    url: '/api/WebUserAccess/GET_USER_HAS_ALREADY_REQUESTED',
	    method: 'POST',
	    auth: true,
	    body: JSON.stringify({ SOURCE_TYPE_ID: (0, _utilities.getSourceTypeId)(category), SOURCE_ID: sourceId })
	  }, callback);
	};
	
	var REJECT_RECORD_ACCESS_REQUEST = exports.REJECT_RECORD_ACCESS_REQUEST = function REJECT_RECORD_ACCESS_REQUEST(webUserAccessId, callback) {
	  fetchAndCatch({
	    url: '/api/WebUserAccess/REJECT_RECORD_ACCESS_REQUEST',
	    method: 'POST',
	    auth: true,
	    body: JSON.stringify({ WEB_USER_ACCESS_ID: webUserAccessId })
	  }, callback);
	};
	
	var ACCEPT_RECORD_ACCESS_REQUEST = exports.ACCEPT_RECORD_ACCESS_REQUEST = function ACCEPT_RECORD_ACCESS_REQUEST(webUserAccessId, callback) {
	  fetchAndCatch({
	    url: '/api/WebUserAccess/ACCEPT_RECORD_ACCESS_REQUEST',
	    method: 'POST',
	    auth: true,
	    body: JSON.stringify({ WEB_USER_ACCESS_ID: webUserAccessId })
	  }, callback);
	};
	
	var REVOKE_RECORD_ACCESS = exports.REVOKE_RECORD_ACCESS = function REVOKE_RECORD_ACCESS(webUserAccessId, callback) {
	  fetchAndCatch({
	    url: '/api/WebUserAccess/REVOKE_RECORD_ACCESS',
	    method: 'POST',
	    auth: true,
	    body: JSON.stringify({ WEB_USER_ACCESS_ID: webUserAccessId })
	  }, callback);
	};
	
	var GET_AVAILABLE_AMENDMENTS = exports.GET_AVAILABLE_AMENDMENTS = function GET_AVAILABLE_AMENDMENTS(filingNum, category, callback, errorCallback) {
	  fetchAndCatch({
	    url: '/api/Amendment/GetAvailable' + category + 'Amendments/' + filingNum,
	    method: 'GET',
	    auth: true
	  }, callback, errorCallback);
	};
	
	var GET_AR_FORM_DEFINITION_ID = exports.GET_AR_FORM_DEFINITION_ID = function GET_AR_FORM_DEFINITION_ID(filingNum, callback, errorCallback) {
	  fetchAndCatch({
	    url: '/api/Amendment/GetARFormDefinitionId/' + filingNum,
	    method: 'GET'
	  }, callback, errorCallback);
	};
	
	var GET_AR_FORM_ACCESS_LEVEL = exports.GET_AR_FORM_ACCESS_LEVEL = function GET_AR_FORM_ACCESS_LEVEL(filingNum, callback, errorCallback) {
	  fetchAndCatch({
	    url: '/api/Amendment/GetARFormAccessLevel/' + filingNum,
	    method: 'GET'
	  }, callback, errorCallback);
	};
	
	var GET_REINSTATEMENT_FORM_DEFINITION_ID = exports.GET_REINSTATEMENT_FORM_DEFINITION_ID = function GET_REINSTATEMENT_FORM_DEFINITION_ID(filingNum, callback, errorCallback) {
	  fetchAndCatch({
	    url: '/api/Amendment/GetReinstatementFormDefinitionId/' + filingNum,
	    method: 'GET'
	  }, callback, errorCallback);
	};
	
	var GET_CONTRACTOR_RENEWAL_FORM_DEFINITION_ID = exports.GET_CONTRACTOR_RENEWAL_FORM_DEFINITION_ID = function GET_CONTRACTOR_RENEWAL_FORM_DEFINITION_ID(filingNum, callback, errorCallback) {
	  fetchAndCatch({
	    url: '/api/Amendment/GetContractorRenewalFormDefinitionId/' + filingNum,
	    method: 'GET'
	  }, callback, errorCallback);
	};
	
	var GET_CHARITABLE_AR_FORM_DEFINITION_ID = exports.GET_CHARITABLE_AR_FORM_DEFINITION_ID = function GET_CHARITABLE_AR_FORM_DEFINITION_ID(filingNum, callback, errorCallback) {
	  fetchAndCatch({
	    url: '/api/Amendment/GetCharitableARFormDefinitionId/' + filingNum,
	    method: 'GET'
	  }, callback, errorCallback);
	};
	
	var GET_CHARITABLE_RENEWAL_FORM_DEFINITION_ID = exports.GET_CHARITABLE_RENEWAL_FORM_DEFINITION_ID = function GET_CHARITABLE_RENEWAL_FORM_DEFINITION_ID(filingNum, callback, errorCallback) {
	  fetchAndCatch({
	    url: '/api/Amendment/GetCharitableRenewalFormDefinitionId/' + filingNum,
	    method: 'GET'
	  }, callback, errorCallback);
	};
	
	var GET_LOBBYIST_RENEWAL_FORM_DEFINITION_ID = exports.GET_LOBBYIST_RENEWAL_FORM_DEFINITION_ID = function GET_LOBBYIST_RENEWAL_FORM_DEFINITION_ID(filingNum, callback, errorCallback) {
	  fetchAndCatch({
	    url: '/api/Amendment/GetLobbyistRenewalFormDefinitionId/' + filingNum,
	    method: 'GET'
	  }, callback, errorCallback);
	};
	
	var GET_TRADEMARK_RENEWAL_FORM_DEFINITION_ID = exports.GET_TRADEMARK_RENEWAL_FORM_DEFINITION_ID = function GET_TRADEMARK_RENEWAL_FORM_DEFINITION_ID(filingNum, callback, errorCallback) {
	  fetchAndCatch({
	    url: '/api/Amendment/GetTrademarkRenewalFormDefinitionId/' + filingNum,
	    method: 'GET'
	  }, callback, errorCallback);
	};
	
	var GET_NOTARY_RENEWAL_FORM_DEFINITION_ID = exports.GET_NOTARY_RENEWAL_FORM_DEFINITION_ID = function GET_NOTARY_RENEWAL_FORM_DEFINITION_ID(filingNum, callback, errorCallback) {
	  fetchAndCatch({
	    url: '/api/Amendment/GetNotaryRenewalFormDefinitionId/' + filingNum,
	    method: 'GET'
	  }, callback, errorCallback);
	};
	
	var GET_REPORT_PREVIEW = exports.GET_REPORT_PREVIEW = function GET_REPORT_PREVIEW(payload, callback, errorCallback) {
	  fetchAndCatch({
	    url: '/api/Report',
	    method: 'POST',
	    auth: true,
	    raw: true,
	    body: JSON.stringify(payload)
	  }, callback, errorCallback);
	};
	
	var GET_REPORT_BY_JSON = exports.GET_REPORT_BY_JSON = function GET_REPORT_BY_JSON(payload, callback, errorCallback) {
	  fetchAndCatch({
	    url: '/api/Report',
	    method: 'POST',
	    auth: true,
	    raw: true,
	    body: JSON.stringify(payload)
	  }, callback, errorCallback);
	};
	
	var GET_REPORTS = exports.GET_REPORTS = function GET_REPORTS(formDefinitionId, record_num, callback, errorCallback) {
	  fetchAndCatch({
	    url: '/api/Report/' + formDefinitionId + '/' + record_num,
	    method: 'GET'
	  }, callback, errorCallback);
	};
	
	var GET_REPORT_BY_REPORT_OBJECT = exports.GET_REPORT_BY_REPORT_OBJECT = function GET_REPORT_BY_REPORT_OBJECT(payload, callback, errorCallback) {
	  fetchAndCatch({
	    url: '/api/Report/getbyreportobject',
	    method: 'POST',
	    raw: true,
	    body: JSON.stringify(payload)
	  }, callback, errorCallback);
	};
	
	var GET_PAYPAL_TOKEN = exports.GET_PAYPAL_TOKEN = function GET_PAYPAL_TOKEN(refNum, callback, errorCallback) {
	  fetchAndCatch({
	    url: '/api/Payment/getPaypalToken/' + refNum,
	    method: 'GET'
	  }, callback, errorCallback);
	};
	
	var CREATE_ACCESSIDCC_PAYMENT = exports.CREATE_ACCESSIDCC_PAYMENT = function CREATE_ACCESSIDCC_PAYMENT(payload, callback, errorCallback) {
	  fetchAndCatch({
	    url: '/api/Payment/CreateAccessIDCCPayment',
	    method: 'POST',
	    body: JSON.stringify(payload)
	  }, callback, errorCallback);
	};
	
	var CREATE_ACCESSIDLOC_PAYMENT = exports.CREATE_ACCESSIDLOC_PAYMENT = function CREATE_ACCESSIDLOC_PAYMENT(payload, callback, errorCallback) {
	  fetchAndCatch({
	    url: '/api/Payment/CreateAccessIDLOCPayment',
	    method: 'POST',
	    body: JSON.stringify(payload)
	  }, callback, errorCallback);
	};
	
	var GET_SERVER_DATES = exports.GET_SERVER_DATES = function GET_SERVER_DATES(callback, errorCallback) {
	  fetchAndCatch({
	    url: '/api/Date',
	    method: 'GET'
	  }, callback, errorCallback);
	};
	
	var GET_DATA_TABLES = exports.GET_DATA_TABLES = function GET_DATA_TABLES(callback, errorCallback) {
	  fetchAndCatch({
	    url: '/api/DataTable',
	    method: 'GET'
	  }, callback, errorCallback);
	};
	
	var GET_DATA_TABLE_BY_ID = exports.GET_DATA_TABLE_BY_ID = function GET_DATA_TABLE_BY_ID(id) {
	  var metadata = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	  var callback = arguments[2];
	  var errorCallback = arguments[3];
	
	  fetchAndCatch({
	    url: '/api/DataTable/GetById/' + id,
	    method: 'POST',
	    body: JSON.stringify(metadata),
	    auth: true
	  }, callback, errorCallback);
	};
	
	var GET_ALL_MERGE_CODES = exports.GET_ALL_MERGE_CODES = function GET_ALL_MERGE_CODES(callback, errorCallback) {
	  fetchAndCatch({
	    url: '/api/MergeCode/GetList',
	    method: 'GET',
	    auth: true
	  }, callback, errorCallback);
	};
	
	var GET_MERGE_CODES_BY_ARRAY = exports.GET_MERGE_CODES_BY_ARRAY = function GET_MERGE_CODES_BY_ARRAY(mergeCodes, metaData, callback, errorCallback) {
	  fetchAndCatch({
	    url: '/api/MergeCode/getValues',
	    method: 'POST',
	    body: JSON.stringify({
	      mergeCodes: mergeCodes,
	      metaData: metaData
	    }),
	    auth: true
	  }, callback, errorCallback);
	};
	
	var GET_RECORD_HISTORY = exports.GET_RECORD_HISTORY = function GET_RECORD_HISTORY(category, amendmentNum, callback, errorCallback) {
	  fetchAndCatch({
	    url: '/api/History/' + category + '/' + amendmentNum,
	    method: 'GET',
	    auth: true
	  }, callback, errorCallback);
	};
	
	var GET_LOBBYISTS_BY_SEARCH_AND_RANGE = exports.GET_LOBBYISTS_BY_SEARCH_AND_RANGE = function GET_LOBBYISTS_BY_SEARCH_AND_RANGE(year, searchValue, callback, errorCallback) {
	  fetchAndCatch({
	    url: '/api/list/search',
	    method: 'POST',
	    body: JSON.stringify({
	      YEAR: year,
	      SEARCH_VALUE: searchValue
	    })
	  }, callback, errorCallback);
	};
	
	var GET_LOBBYIST_ENTITIES_BY_ID = exports.GET_LOBBYIST_ENTITIES_BY_ID = function GET_LOBBYIST_ENTITIES_BY_ID(lobbyistId, year, callback, errorCallback) {
	  fetchAndCatch({
	    url: '/api/list/getEntitiesByID/' + lobbyistId + '/' + year,
	    method: 'get'
	  }, callback, errorCallback);
	};
	
	var GET_AVAILABLE_LISTS = exports.GET_AVAILABLE_LISTS = function GET_AVAILABLE_LISTS(callback, errorCallback) {
	  fetchAndCatch({
	    url: '/api/list/getAvailableLists',
	    method: 'get'
	  }, callback, errorCallback);
	};
	
	var GET_HCDR_RECORD = exports.GET_HCDR_RECORD = function GET_HCDR_RECORD(payload, callback, errorCallback) {
	  fetchAndCatch({
	    url: '/api/records/hcdrsearch',
	    method: 'POST',
	    body: JSON.stringify(payload)
	  }, callback, errorCallback);
	};
	
	var GET_APOSTILLE_RECORD = exports.GET_APOSTILLE_RECORD = function GET_APOSTILLE_RECORD(payload, callback, errorCallback) {
	  fetchAndCatch({
	    url: '/api/records/apostillesearch',
	    method: 'POST',
	    body: JSON.stringify(payload)
	  }, callback, errorCallback);
	};
	
	var GET_ACCESS_ID_CC_PAYMENT_STATUS = exports.GET_ACCESS_ID_CC_PAYMENT_STATUS = function GET_ACCESS_ID_CC_PAYMENT_STATUS(token, callback, errorCallback) {
	  fetchAndCatch({
	    url: '/api/payment/getAccessIDCCPaymentStatus/' + token,
	    method: 'GET'
	  }, callback, errorCallback);
	};
	
	var GET_ACCESS_ID_LOC_PAYMENT_STATUS = exports.GET_ACCESS_ID_LOC_PAYMENT_STATUS = function GET_ACCESS_ID_LOC_PAYMENT_STATUS(token, callback, errorCallback) {
	  fetchAndCatch({
	    url: '/api/payment/getAccessIDLOCPaymentStatus/' + token,
	    method: 'GET'
	  }, callback, errorCallback);
	};
	
	var GET_PAYPAL_PAYMENT_STATUS = exports.GET_PAYPAL_PAYMENT_STATUS = function GET_PAYPAL_PAYMENT_STATUS(token, callback, errorCallback) {
	  fetchAndCatch({
	    url: '/api/payment/getPaypalPaymentStatus/' + token,
	    method: 'GET'
	  }, callback, errorCallback);
	};
	
	var GET_CERTIFICATION_CONFIG = exports.GET_CERTIFICATION_CONFIG = function GET_CERTIFICATION_CONFIG(category, filingId, callback, errorCallback) {
	  fetchAndCatch({
	    url: '/api/Certification/getCertificationConfig/' + category + '/' + filingId,
	    method: 'GET'
	  }, callback, errorCallback);
	};
	
	var CREATE_CERTIFICATION = exports.CREATE_CERTIFICATION = function CREATE_CERTIFICATION(payload, callback, errorCallback) {
	  fetchAndCatch({
	    url: '/api/Certification',
	    method: 'POST',
	    body: JSON.stringify(payload)
	  }, callback, errorCallback);
	};
	
	var GET_WEB_CART_BY_CERTIFICATION_ID = exports.GET_WEB_CART_BY_CERTIFICATION_ID = function GET_WEB_CART_BY_CERTIFICATION_ID(certificationId, callback, errorCallback) {
	  fetchAndCatch({
	    url: '/api/Certification/getWebCart/' + certificationId,
	    method: 'GET'
	  }, callback, errorCallback);
	};
	
	var GET_REPORTS_BY_WEB_CART_REF_NUM = exports.GET_REPORTS_BY_WEB_CART_REF_NUM = function GET_REPORTS_BY_WEB_CART_REF_NUM(refNum, callback, errorCallback) {
	  fetchAndCatch({
	    url: '/api/Report/GetReportsByCartRefNum/' + refNum,
	    method: 'GET'
	  }, callback, errorCallback);
	};
	
	var GET_AVAILABLE_PAYMENT_METHODS = exports.GET_AVAILABLE_PAYMENT_METHODS = function GET_AVAILABLE_PAYMENT_METHODS(refNum, callback, errorCallback) {
	  fetchAndCatch({
	    url: '/api/Payment/getPaymentMethodStatus/' + refNum,
	    method: 'GET'
	  }, callback, errorCallback);
	};
	
	var VERIFY_CERTIFICATE = exports.VERIFY_CERTIFICATE = function VERIFY_CERTIFICATE(ref_num, category, callback, errorCallback) {
	  fetchAndCatch({
	    url: '/api/certification/verifyCertificate/' + ref_num + (category ? '?category=' + category : ''),
	    method: 'GET'
	  }, callback, errorCallback);
	};
	
	var SEARCH_UCC_INFO_REQ = exports.SEARCH_UCC_INFO_REQ = function SEARCH_UCC_INFO_REQ(payload, callback, errorCallback) {
	  fetchAndCatch({
	    url: '/api/records/uccinforeqsearch',
	    method: 'POST',
	    body: JSON.stringify(payload)
	  }, callback, errorCallback);
	};
	
	var GET_DASHBOARD_DATA = exports.GET_DASHBOARD_DATA = function GET_DASHBOARD_DATA(payload, callback, errorCallback) {
	  fetchAndCatch({
	    url: '/api/DashboardTile/getData',
	    method: 'POST',
	    body: JSON.stringify(payload)
	  }, callback, errorCallback);
	};
	
	var GET_LIENS_SEARCH_WEB_CART = exports.GET_LIENS_SEARCH_WEB_CART = function GET_LIENS_SEARCH_WEB_CART(payload, callback, errorCallback) {
	  fetchAndCatch({
	    url: '/api/copies/premium',
	    method: 'POST',
	    body: JSON.stringify(payload)
	  }, callback, errorCallback);
	};
	
	var UPDATE_WEB_USER = exports.UPDATE_WEB_USER = function UPDATE_WEB_USER(payload, callback, errorCallback) {
	  fetchAndCatch({
	    url: '/api/auth/updateWebUser',
	    method: 'POST',
	    body: JSON.stringify(payload)
	  }, callback, errorCallback);
	};
	
	var GET_PAYROC_CUSTOMER = exports.GET_PAYROC_CUSTOMER = function GET_PAYROC_CUSTOMER(callback, errorCallback) {
	  fetchAndCatch({
	    url: '/api/Payment/PayrocCustomerGet',
	    method: 'GET'
	  }, callback, errorCallback);
	};
	
	var CREATE_PAYROC_TRANSACTION = exports.CREATE_PAYROC_TRANSACTION = function CREATE_PAYROC_TRANSACTION(payload, callback, errorCallback) {
	  fetchAndCatch({
	    url: '/api/Payment/PayrocTransactionCreate',
	    method: 'POST',
	    body: JSON.stringify(payload)
	  }, callback, errorCallback);
	};
	
	var CREATE_PAYROC_CUSTOMER_PAYMENT_SOURCE = exports.CREATE_PAYROC_CUSTOMER_PAYMENT_SOURCE = function CREATE_PAYROC_CUSTOMER_PAYMENT_SOURCE(payload, callback, errorCallback) {
	  fetchAndCatch({
	    url: '/api/Payment/PayrocAddPaymentSource',
	    method: 'POST',
	    body: JSON.stringify(payload)
	  }, callback, errorCallback);
	};
	
	var DELETE_PAYROC_CUSTOMER_PAYMENT_SOURCE = exports.DELETE_PAYROC_CUSTOMER_PAYMENT_SOURCE = function DELETE_PAYROC_CUSTOMER_PAYMENT_SOURCE(id, callback, errorCallback) {
	  fetchAndCatch({
	    url: '/api/Payment/PayrocDeletePaymentSource',
	    method: 'POST',
	    body: JSON.stringify({ id: id })
	  }, callback, errorCallback);
	};
	
	var GET_DATA_REQUEST_WIZARDS = exports.GET_DATA_REQUEST_WIZARDS = function GET_DATA_REQUEST_WIZARDS(callback, errorCallback) {
	  fetchAndCatch({
	    url: '/api/Data-Request/GetDataRequestDefinitions',
	    method: 'GET'
	  }, callback, errorCallback);
	};
	
	var GET_MY_DATA_REQUESTS = exports.GET_MY_DATA_REQUESTS = function GET_MY_DATA_REQUESTS(callback, errorCallback) {
	  fetchAndCatch({
	    url: '/api/Data-Request/GetList',
	    method: 'GET'
	  }, callback, errorCallback);
	};
	
	var UPDATE_DATA_REQUEST = exports.UPDATE_DATA_REQUEST = function UPDATE_DATA_REQUEST(payload, callback, errorCallback) {
	  fetchAndCatch({
	    url: '/api/data-request/Update',
	    method: 'POST',
	    body: JSON.stringify(payload)
	  }, callback, errorCallback);
	};
	
	var GET_EPASS_LOGIN_CALLBACK = exports.GET_EPASS_LOGIN_CALLBACK = function GET_EPASS_LOGIN_CALLBACK(callback, errorCallback) {
	  fetchAndCatch({
	    url: '/api/Epass/ProcessLogin',
	    method: 'GET',
	    cookies: true
	  }, callback, errorCallback);
	};
	
	var GET_ACTIVE_DIRECTORY_REDIRECT = exports.GET_ACTIVE_DIRECTORY_REDIRECT = function GET_ACTIVE_DIRECTORY_REDIRECT(callback, errorCallback) {
	  fetchAndCatch({
	    url: '/api/auth/activedirectory_authorize_redirect',
	    method: 'GET'
	  }, callback, errorCallback);
	};
	
	var GET_ACTIVE_DIRECTORY_LOGIN_CALLBACK = exports.GET_ACTIVE_DIRECTORY_LOGIN_CALLBACK = function GET_ACTIVE_DIRECTORY_LOGIN_CALLBACK(payload, callback, errorCallback) {
	  fetchAndCatch({
	    url: '/api/auth/activedirectory_login',
	    method: 'POST',
	    body: JSON.stringify(payload)
	  }, callback, errorCallback);
	};
	
	var GET_HAS_FARM_BILL_SUBSCRIPTION = exports.GET_HAS_FARM_BILL_SUBSCRIPTION = function GET_HAS_FARM_BILL_SUBSCRIPTION(callback, errorCallback) {
	  fetchAndCatch({
	    url: '/api/list/getHasFarmBillSubscription',
	    method: 'GET'
	  }, callback, errorCallback);
	};
	
	var GET_UCC_XML_USERS = exports.GET_UCC_XML_USERS = function GET_UCC_XML_USERS(callback, errorCallback) {
	  fetchAndCatch({
	    url: '/api/customerprofile/getlist',
	    method: 'GET'
	  }, callback, errorCallback);
	};
	
	var GET_XML_PAYROC_CUSTOMER = exports.GET_XML_PAYROC_CUSTOMER = function GET_XML_PAYROC_CUSTOMER(profileId, callback, errorCallback) {
	  fetchAndCatch({
	    url: '/api/customerprofile/PayrocCustomerGet/' + profileId,
	    method: 'GET'
	  }, callback, errorCallback);
	};
	
	var ADD_XML_PAYROC_PAYMENT_METHOD = exports.ADD_XML_PAYROC_PAYMENT_METHOD = function ADD_XML_PAYROC_PAYMENT_METHOD(_ref3, callback, errorCallback) {
	  var profileId = _ref3.profileId,
	      token = _ref3.token;
	
	  fetchAndCatch({
	    url: '/api/customerprofile/PayrocAddPaymentSource',
	    method: 'POST',
	    body: JSON.stringify({ profileId: profileId, token: token })
	  }, callback, errorCallback);
	};
	
	var SET_XML_PAYROC_DEFAULT_PAYMENT_METHOD = exports.SET_XML_PAYROC_DEFAULT_PAYMENT_METHOD = function SET_XML_PAYROC_DEFAULT_PAYMENT_METHOD(_ref4, callback, errorCallback) {
	  var profileId = _ref4.profileId,
	      paySourceNum = _ref4.paySourceNum;
	
	  fetchAndCatch({
	    url: '/api/customerprofile/PayrocSetDefaultPaymentSource',
	    method: 'POST',
	    body: JSON.stringify({ profileId: profileId, paySourceNum: paySourceNum })
	  }, callback, errorCallback);
	};
	
	var SET_XML_PAYROC_DELETE_PAYMENT_METHOD = exports.SET_XML_PAYROC_DELETE_PAYMENT_METHOD = function SET_XML_PAYROC_DELETE_PAYMENT_METHOD(_ref5, callback, errorCallback) {
	  var profileId = _ref5.profileId,
	      paySourceNum = _ref5.paySourceNum;
	
	  fetchAndCatch({
	    url: '/api/customerprofile/PayrocDeletePaymentSource',
	    method: 'POST',
	    body: JSON.stringify({ profileId: profileId, paySourceNum: paySourceNum })
	  }, callback, errorCallback);
	};
	
	var SET_WEB_USER_ACCESS_LEVEL = exports.SET_WEB_USER_ACCESS_LEVEL = function SET_WEB_USER_ACCESS_LEVEL(payload, callback, errorCallback) {
	  fetchAndCatch({
	    url: '/api/WebUserAccess/SET_ACCESS_LEVEL',
	    method: 'POST',
	    body: JSON.stringify(payload)
	  }, callback, errorCallback);
	};
	
	var GET_CURRENT_USER_FREQUENT_PAYOR_ACCOUNT = exports.GET_CURRENT_USER_FREQUENT_PAYOR_ACCOUNT = function GET_CURRENT_USER_FREQUENT_PAYOR_ACCOUNT(callback, errorCallback) {
	  fetchAndCatch({
	    url: '/api/web-user/-/frequent-payor',
	    method: 'GET'
	  }, callback, errorCallback);
	};
	
	var UPDATE_FREQUENT_PAYOR_ADDRESS = exports.UPDATE_FREQUENT_PAYOR_ADDRESS = function UPDATE_FREQUENT_PAYOR_ADDRESS(payload, callback, errorCallback) {
	  fetchAndCatch({
	    url: '/api/web-user/updateAddress/frequent-payor',
	    method: 'POST',
	    body: JSON.stringify(payload)
	  }, callback, errorCallback);
	};
	
	var WEB_CART_TRANSACTION_WITH_FREQUENT_PAYOR = exports.WEB_CART_TRANSACTION_WITH_FREQUENT_PAYOR = function WEB_CART_TRANSACTION_WITH_FREQUENT_PAYOR(refNum, callback, errorCallback) {
	  fetchAndCatch({
	    url: '/api/Payment/payWithFrequentPayor/' + refNum,
	    method: 'POST'
	  }, callback, errorCallback);
	};
	
	var WEB_CART_GUIDS_TRANSACTION_WITH_FREQUENT_PAYOR = exports.WEB_CART_GUIDS_TRANSACTION_WITH_FREQUENT_PAYOR = function WEB_CART_GUIDS_TRANSACTION_WITH_FREQUENT_PAYOR(payload, callback, errorCallback) {
	  fetchAndCatch({
	    url: '/api/Payment/payWithFrequentPayor',
	    method: 'POST',
	    body: JSON.stringify(payload),
	    auth: true
	  }, callback, errorCallback);
	};
	
	var GET_FREQUENT_PAYOR_WEBCART_FROM_AMOUNT = exports.GET_FREQUENT_PAYOR_WEBCART_FROM_AMOUNT = function GET_FREQUENT_PAYOR_WEBCART_FROM_AMOUNT(amount, callback, errorCallback) {
	  fetchAndCatch({
	    url: '/api/frequent-payor/getWebCart/' + amount * 100,
	    method: 'GET'
	  }, callback, errorCallback);
	};
	
	var GET_FREQUENT_PAYOR_STATEMENT = exports.GET_FREQUENT_PAYOR_STATEMENT = function GET_FREQUENT_PAYOR_STATEMENT(date, callback, errorCallback) {
	  fetchAndCatch({
	    url: '/api/report/frequentPayorStatement?date=' + date,
	    method: 'GET',
	    raw: true
	  }, callback, errorCallback);
	};
	
	var GET_ELAVON_TOKEN_BY_REF_NUM = exports.GET_ELAVON_TOKEN_BY_REF_NUM = function GET_ELAVON_TOKEN_BY_REF_NUM(refNum, callback, errorCallback) {
	  fetchAndCatch({
	    url: '/api/Payment/getElavonToken/' + refNum,
	    method: 'POST'
	  }, callback, errorCallback);
	};
	
	var GET_ELAVON_TOKEN_BY_ITEM_GUIDS = exports.GET_ELAVON_TOKEN_BY_ITEM_GUIDS = function GET_ELAVON_TOKEN_BY_ITEM_GUIDS(payload, callback, errorCallback) {
	  fetchAndCatch({
	    url: '/api/Payment/getElavonToken',
	    method: 'POST',
	    body: JSON.stringify(payload),
	    auth: true
	  }, callback, errorCallback);
	};
	
	var PROCESS_ELAVON_PAYMENT = exports.PROCESS_ELAVON_PAYMENT = function PROCESS_ELAVON_PAYMENT(body, callback, errorCallback) {
	  fetchAndCatch({
	    url: '/api/Payment/elavonactivate',
	    method: 'POST',
	    body: JSON.stringify(body)
	  }, callback, errorCallback);
	};
	
	var GET_VERSION_INFO = exports.GET_VERSION_INFO = function GET_VERSION_INFO(callback, errorCallback) {
	  fetchAndCatch({
	    url: '/api/VersionInfo',
	    method: 'GET'
	  }, callback, errorCallback);
	};
	
	var GET_REGULATED_WORD_LISTS = exports.GET_REGULATED_WORD_LISTS = function GET_REGULATED_WORD_LISTS(callback, errorCallback) {
	  fetchAndCatch({
	    url: '/api/RegulatedWord'
	  }, callback, errorCallback);
	};
	
	var CLEAR_FAILED_WEB_CART_BY_REF_NUM = exports.CLEAR_FAILED_WEB_CART_BY_REF_NUM = function CLEAR_FAILED_WEB_CART_BY_REF_NUM(refNum, callback, errorCallback) {
	  fetchAndCatch({
	    url: '/api/Payment/clearFailedCart/' + refNum,
	    method: 'POST'
	  }, callback, errorCallback);
	};
	
	var VERIFY_EMAIL_ADDRESS = exports.VERIFY_EMAIL_ADDRESS = function VERIFY_EMAIL_ADDRESS(payload, callback, errorCallback) {
	  fetchAndCatch({
	    url: '/api/auth/parseEmailVerifyToken',
	    method: 'POST',
	    body: JSON.stringify(payload)
	  }, callback, errorCallback);
	};

/***/ },
/* 7 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(37);
	
	exports.__esModule = true;
	
	var _Provider = _interopRequireDefault(__webpack_require__(1330));
	
	exports.Provider = _Provider["default"];
	
	var _connectAdvanced = _interopRequireDefault(__webpack_require__(513));
	
	exports.connectAdvanced = _connectAdvanced["default"];
	
	var _Context = __webpack_require__(104);
	
	exports.ReactReduxContext = _Context.ReactReduxContext;
	
	var _connect = _interopRequireDefault(__webpack_require__(1331));
	
	exports.connect = _connect["default"];
	
	var _useDispatch = __webpack_require__(1337);
	
	exports.useDispatch = _useDispatch.useDispatch;
	exports.createDispatchHook = _useDispatch.createDispatchHook;
	
	var _useSelector = __webpack_require__(1338);
	
	exports.useSelector = _useSelector.useSelector;
	exports.createSelectorHook = _useSelector.createSelectorHook;
	
	var _useStore = __webpack_require__(516);
	
	exports.useStore = _useStore.useStore;
	exports.createStoreHook = _useStore.createStoreHook;
	
	var _batch = __webpack_require__(517);
	
	var _reactBatchedUpdates = __webpack_require__(1340);
	
	exports.batch = _reactBatchedUpdates.unstable_batchedUpdates;
	
	var _shallowEqual = _interopRequireDefault(__webpack_require__(518));
	
	exports.shallowEqual = _shallowEqual["default"];
	(0, _batch.setBatch)(_reactBatchedUpdates.unstable_batchedUpdates);

/***/ },
/* 8 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getHumanReadableValueByField = exports.hydrateSublinkFunctions = exports.coerceType = exports.getRequiredAppSettingNames = exports.getFieldsByFieldIds = exports.getFirstFocusableScopedElement = exports.formatSignaturesForServer = exports.getHydratedFields = exports.getFieldByKey = exports.testRepeaterConstraints = exports.convertRepeaterRowsToColumnsObject = exports.getControlIsRenderable = exports.calculateReceiptItemContainersTotal = exports.calculateReceiptItemsTotal = exports.getAuthRedirectUrl = exports.handleOfflineResponse = exports.handleForbiddenResponse = exports.getUniqueJSONvalues = exports.getSourceTypeId = exports.getNumBusinessRules = exports.readFileAsText = exports.selectUserGroupByGroupId = exports.noop = exports.getOrderedResultsByCategory = exports.truncateText = exports.getFieldsWithChangedValues = exports.FormattedAddress = exports.getCurrentWizardAmendmentNum = exports.getCurrentWizardMetaData = exports.objectToArray = exports.getFreshValueFromStoreByFieldId = exports.getFieldsByType = exports.getSelectedOptionFromField = exports.lowercaseFirstLetter = exports.notNullOrUndefined = exports.getSanitizedLocalStorageValue = exports.parseUrlQuery = exports.SUBROUTES_OBJ = exports.SUBROUTES = exports.theme = undefined;
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _store = __webpack_require__(18);
	
	var _store2 = _interopRequireDefault(_store);
	
	var _selectOptions = __webpack_require__(68);
	
	var _orderBy = __webpack_require__(103);
	
	var _orderBy2 = _interopRequireDefault(_orderBy);
	
	var _deepEqual = __webpack_require__(65);
	
	var _deepEqual2 = _interopRequireDefault(_deepEqual);
	
	var _AuthActions = __webpack_require__(66);
	
	var _actions = __webpack_require__(29);
	
	var _wizardUtilities = __webpack_require__(52);
	
	var _businessRules = __webpack_require__(198);
	
	var _WizardClasses = __webpack_require__(35);
	
	var WIZARD_CLASSES = _interopRequireWildcard(_WizardClasses);
	
	var _index = __webpack_require__(1276);
	
	var _index2 = _interopRequireDefault(_index);
	
	var _default = __webpack_require__(1413);
	
	var _default2 = _interopRequireDefault(_default);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var themeOverride = __webpack_require__(1414);
	
	var theme = exports.theme = Object.assign({}, _default2.default, themeOverride);
	
	var SUBROUTES = exports.SUBROUTES = Array.isArray(([{"label":"Business","component":"Business","parameter":"business","myWorkQueueSearch":false,"sourceTypeId":54,"searchMustHaveOneOf":["FILING_TYPE_ID","STATUS_ID","STATE","search"],"serverWebSearchDescription":true,"serverWorkQueueDescription":true,"serverMyRecordsDescription":true,"searchPlaceholder":"Search by name or filing number (X########)","allowEmptySearchTerm":true,"requestCertificateAlternateLabel":"Request Information","fileAmendmentButtonLabel":"Filing Actions","advancedSearchParameters":[{"type":"radio","name":"QUERY_TYPE_ID","defaultValue":1010,"options":[{"value":1010,"label":"Starts with"},{"value":1011,"label":"Contains"},{"value":1012,"label":" Word Contains"}]},{"type":"serverSelect","name":"FILING_TYPE_ID","optionsSrc":"FILING_TYPES","label":"Entity Type","placeholder":"All","defaultValue":"0"},{"type":"serverSelect","name":"FILING_SUBTYPE_ID","optionsSrc":"FILING_SUBTYPES","label":"Entity Subtype","overrideSubOptionsSrcFromParameterName":"FILING_TYPE_ID","placeholder":"All","defaultValue":"0"},{"type":"serverSelect","name":"STATUS_ID","optionsSrc":"FILING_STATUS_WITHOUT_ALL","label":"Status","placeholder":"All","defaultValue":"0"},{"type":"serverSelect","name":"STATE","optionsSrc":"STATE","label":"State","placeholder":"All","defaultValue":""},{"type":"serverSelect","name":"COUNTY","optionsSrc":"COUNTY_SUBOPTION","label":"County","overrideSubOptionsSrcFromParameterName":"STATE","placeholder":"All","defaultValue":""},{"type":"checkbox","name":"CRA_SEARCH_YN","defaultValue":false,"label":"Search by Registered Agent PID"},{"type":"dateRange","name":"FILING_DATE","label":"Registration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}},{"type":"dateRange","name":"EXPIRATION_DATE","label":"Expiration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}}],"myRecordsFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Active"},{"value":2,"label":"Inactive"},{"value":3,"label":"Pending"}]},{"type":"dateRange","name":"DATE_RANGE","label":"Date range","defaultValue":{"start":null,"end":null}}],"myWorkQueueFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Approved"},{"value":2,"label":"Pending Online Payment"},{"value":3,"label":"Pending Review"},{"value":4,"label":"Needs Correction"},{"value":5,"label":"Rejected"},{"value":6,"label":"Draft"}]},{"type":"dateRange","name":"DATE_RANGE","label":"Date range","defaultValue":{"start":null,"end":null}}]},{"label":"Notary","component":"Notary","parameter":"notary","sourceTypeId":850,"myWorkQueueSearch":false,"allowEmptySearchTerm":true,"requestCertificateAlternateLabel":"Download Certificate","fileAmendmentButtonLabel":"Filing Actions","hideNameRequestCertificate":true,"hideAddressRequestCertificate":true,"hideRecordUserManagment":true,"searchPlaceholder":"Search by name or commission number","searchMustHaveOneOf":["CITY","search","SERVICE_TYPE"],"advancedParametersStartOpen":true,"searchIsSortable":true,"advancedSearchParameters":[{"type":"radio","name":"STARTS_WITH_YN","defaultValue":false,"options":[{"value":true,"label":"Starts with"},{"value":false,"label":"Contains"}]},{"type":"checkbox","name":"ACTIVE_ONLY_YN","defaultValue":true,"label":"Active entities only"},{"type":"text","name":"CITY","defaultValue":"","label":"City"},{"type":"select","name":"SERVICE_TYPE","label":"Special Services Offered","defaultValue":0,"options":[{"value":0,"label":"(N/A)"},{"value":6165,"label":"In-Person Electronic Notarization (IPEN)"},{"value":6166,"label":"Remote Online Notarization (RON)"},{"value":6167,"label":"Mobile Notary Services"},{"value":6168,"label":"Remote Ink Notarization (RIN)"}]}]},{"label":"Apostille","component":"Apostille","parameter":"apostille","sourceTypeId":720,"myRecordsSearch":false,"myWorkQueueSearch":false,"disabled":false,"allowedRoutes":["/forms-manager/","/queue/","/forms/"]},{"label":"Liens","component":"UCC","parameter":"ucc","sourceTypeId":1999,"myRecordsSearch":true,"myWorkQueueSearch":true,"fileAmendmentButtonLabel":"Filing Actions","searchPlaceholder":"Search by name or file number","disabled":false,"serverWebSearchDescription":true,"myRecordsDescription":"","workQueueDescription":"","searchDescription":"","hideRecordUserManagment":true,"searchLiensCheckout":false,"advancedSearchParameters":[{"type":"radio","name":"STARTS_WITH_YN","defaultValue":false,"options":[{"value":true,"label":"Starts with"},{"value":false,"label":"Contains"}]},{"type":"select","name":"STATUS","defaultValue":"ALL","label":"Status","options":[{"value":"ACTIVE_UNLAPSED","label":"Active (unlapsed)"},{"value":"ACTIVE_LAPSED_UNLAPSED","label":"Active (lapsed and unlapsed)"}]},{"type":"text","name":"EXCLUDE_VALUES","label":"Exclude Debtor Names (comma separated list of names to exclude)","defaultValue":""},{"type":"dateRange","name":"FILING_DATE","label":"Financing Statement Date","defaultValue":{"start":null,"end":null}},{"type":"dateRange","name":"LAPSE_DATE","label":"Lapse Date","defaultValue":{"start":null,"end":null}},{"type":"text","name":"CITY","label":"Debtor City","defaultValue":""}],"myRecordsFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Approved"},{"value":2,"label":"Pending Online Payment"},{"value":3,"label":"Pending Review"}]},{"type":"select","name":"TYPE","defaultValue":0,"label":"Lien Type","options":[{"value":0,"label":"All"},{"value":1,"label":"UCC"},{"value":2,"label":"EFS"},{"value":3,"label":"Title 71"}]}],"myWorkQueueFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Approved"},{"value":2,"label":"Pending Online Payment"},{"value":3,"label":"Pending Review"},{"value":4,"label":"Pending Print and Mail"},{"value":5,"label":"Rejected"},{"value":6,"label":"Draft"}]},{"type":"select","name":"TYPE","defaultValue":0,"label":"Lien Type","options":[{"value":0,"label":"All"},{"value":1,"label":"UCC"},{"value":2,"label":"EFS"},{"value":3,"label":"Title 71"}]}]},{"label":"Copy Request","component":"copies","parameter":"copies","sourceTypeId":2001,"myRecordsSearch":false,"myWorkQueueSearch":false,"disabled":false,"allowedRoutes":["/forms-manager/","/queue/","/forms/"]},{"label":"Trademark","component":"Trademark","parameter":"trademark","sourceTypeId":810,"showRequestCertificate":true,"searchMustHaveOneOf":["search","EXPIRATION_DATE","FILING_DATE"],"allowEmptySearchTerm":true,"requestCertificateAlternateLabel":"Request Information","fileAmendmentButtonLabel":"Filing Actions","advancedSearchParameters":[{"type":"radio","name":"QUERY_TYPE_ID","defaultValue":1010,"options":[{"value":1010,"label":"Starts with"},{"value":1011,"label":"Contains"},{"value":1012,"label":" Word Contains"}]},{"type":"checkbox","name":"OWNER_SEARCH_YN","defaultValue":false,"label":"Search owners"},{"type":"radio","name":"SERVICE_MARK_YN","label":"Mark Type","defaultValue":"","options":[{"value":"","label":"All Marks"},{"value":"Y","label":"Service Mark"},{"value":"N","label":"Trademark"}]},{"type":"serverSelect","name":"STATUS_ID","optionsSrc":"TYPE_V|TRADEMARK_STATUS_TYPE","label":"Status","placeholder":"All","defaultValue":"0"},{"type":"select","name":"DESIGN_TYPE_ID","options":[{"value":0,"label":"All"},{"value":990,"label":"Words Only"},{"value":991,"label":"Design Only"},{"value":992,"label":"Words and Design"}],"label":"Design Type","defaultValue":"0"},{"type":"dateRange","name":"FILING_DATE","label":"Registered Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}},{"type":"dateRange","name":"EXPIRATION_DATE","label":"Expiration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}}]},{"label":"Business Info Request","component":"InfoRequests","parameter":"info-request","sourceTypeId":167,"allowedRoutes":["/forms-manager/","/queue/","/forms/"]},{"label":"Data Requests","component":"DataRequests","parameter":"data-request","sourceTypeId":0,"allowedRoutes":["/forms-manager/"]},{"label":"CRA","component":"CRA","parameter":"cra","sourceTypeId":157,"myRecordsSearch":false,"searchPlaceholder":"Search by name or registered agent number","allowedRoutes":["/forms-manager/","/forms/","/records/","/queue/","/search/"],"allowEmptySearchTerm":true,"fileAmendmentButtonLabel":"Filing Actions","advancedSearchParameters":[{"type":"radio","name":"QUERY_TYPE_ID","defaultValue":1010,"options":[{"value":1010,"label":"Starts with"},{"value":1011,"label":"Contains"},{"value":1012,"label":" Word Contains"}]},{"type":"dateRange","name":"CRA_DATE","label":"Registration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}},{"type":"select","name":"STATUS_ID","label":"Status","defaultValue":0,"options":[{"value":0,"label":"All"},{"value":121,"label":"Active"},{"value":122,"label":"Inactive"}]},{"type":"select","name":"AGENT_TYPE_ID","label":"Agent Type","defaultValue":0,"options":[{"value":0,"label":"All"},{"value":460,"label":"Registered Agent"},{"value":461,"label":"Commercial Registered Agent"}]}]},{"label":"Farm Bill","component":"FarmBill","parameter":"farm-bill","path":"/lists/farm-bill","sourceTypeId":0,"myRecordsSearch":false,"allowedRules":["/search/"],"disabled":true,"searchDescription":"To perform a search, enter a debtor name. Your search results may include: exact debtor name, variations of that name and any filing that includes your search criteria. Punctuation is ignored.\n\nYou can click on \"Advanced\" to refine your search. Under “Advanced” you can search by crop, year, county and SSN/FEIN. As a registered Farm Bill Buyer with the Montana Secretary of State’s office it is important to maintain the confidentiality of the information contained within the Farm Bill Master List. The Farm Bill Master List reflects personal data, such as Social Security Numbers, which are a key piece of personal identifiable information to assist you in determining the existence of a lien against a specific debtor. The distribution of this information beyond its intended purpose is strictly prohibited.\n\nThe debtor's tax identification number has been hidden for confidentiality reasons. You may continue to search on a tax ID number and return debtors that match your search criteria. The SSN/FEIN must be entered without dashes or spaces.","searchMustHaveOneOf":["search","UCC_FARM_PRODUCT_ID","COUNTY"],"searchPlaceholder":"Search by debtor name","advancedSearchParameters":[{"type":"ServerMultiComplete","label":"Product code name(s)","name":"UCC_FARM_PRODUCT_ID","defaultValue":"","optionsSrc":"UCC_FARM_PRODUCT_V"},{"type":"MultiComplete","label":"Year or Range of Years","name":"YEAR_NUM","optionsSrc":"years","startYear":"1968","defaultValue":[],"preMergeOptions":[{"value":"ALL","label":"All"}]},{"type":"serverSelect","label":"State","name":"STATE","defaultValue":"MONTANA","optionsSrc":"STATE"},{"type":"ServerMultiComplete","label":"County","name":"COUNTY","defaultValue":[],"optionsSrc":"COUNTY","overrideSubOptionsSrcFromParameterName":"STATE"},{"type":"checkbox","name":"TIN_SEARCH_YN","defaultValue":false,"label":"Tax Identification Number Search"},{"type":"checkbox","name":"TIN_SORT_YN","defaultValue":false,"label":"Unique ID Sort"}]}])) ? ([{"label":"Business","component":"Business","parameter":"business","myWorkQueueSearch":false,"sourceTypeId":54,"searchMustHaveOneOf":["FILING_TYPE_ID","STATUS_ID","STATE","search"],"serverWebSearchDescription":true,"serverWorkQueueDescription":true,"serverMyRecordsDescription":true,"searchPlaceholder":"Search by name or filing number (X########)","allowEmptySearchTerm":true,"requestCertificateAlternateLabel":"Request Information","fileAmendmentButtonLabel":"Filing Actions","advancedSearchParameters":[{"type":"radio","name":"QUERY_TYPE_ID","defaultValue":1010,"options":[{"value":1010,"label":"Starts with"},{"value":1011,"label":"Contains"},{"value":1012,"label":" Word Contains"}]},{"type":"serverSelect","name":"FILING_TYPE_ID","optionsSrc":"FILING_TYPES","label":"Entity Type","placeholder":"All","defaultValue":"0"},{"type":"serverSelect","name":"FILING_SUBTYPE_ID","optionsSrc":"FILING_SUBTYPES","label":"Entity Subtype","overrideSubOptionsSrcFromParameterName":"FILING_TYPE_ID","placeholder":"All","defaultValue":"0"},{"type":"serverSelect","name":"STATUS_ID","optionsSrc":"FILING_STATUS_WITHOUT_ALL","label":"Status","placeholder":"All","defaultValue":"0"},{"type":"serverSelect","name":"STATE","optionsSrc":"STATE","label":"State","placeholder":"All","defaultValue":""},{"type":"serverSelect","name":"COUNTY","optionsSrc":"COUNTY_SUBOPTION","label":"County","overrideSubOptionsSrcFromParameterName":"STATE","placeholder":"All","defaultValue":""},{"type":"checkbox","name":"CRA_SEARCH_YN","defaultValue":false,"label":"Search by Registered Agent PID"},{"type":"dateRange","name":"FILING_DATE","label":"Registration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}},{"type":"dateRange","name":"EXPIRATION_DATE","label":"Expiration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}}],"myRecordsFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Active"},{"value":2,"label":"Inactive"},{"value":3,"label":"Pending"}]},{"type":"dateRange","name":"DATE_RANGE","label":"Date range","defaultValue":{"start":null,"end":null}}],"myWorkQueueFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Approved"},{"value":2,"label":"Pending Online Payment"},{"value":3,"label":"Pending Review"},{"value":4,"label":"Needs Correction"},{"value":5,"label":"Rejected"},{"value":6,"label":"Draft"}]},{"type":"dateRange","name":"DATE_RANGE","label":"Date range","defaultValue":{"start":null,"end":null}}]},{"label":"Notary","component":"Notary","parameter":"notary","sourceTypeId":850,"myWorkQueueSearch":false,"allowEmptySearchTerm":true,"requestCertificateAlternateLabel":"Download Certificate","fileAmendmentButtonLabel":"Filing Actions","hideNameRequestCertificate":true,"hideAddressRequestCertificate":true,"hideRecordUserManagment":true,"searchPlaceholder":"Search by name or commission number","searchMustHaveOneOf":["CITY","search","SERVICE_TYPE"],"advancedParametersStartOpen":true,"searchIsSortable":true,"advancedSearchParameters":[{"type":"radio","name":"STARTS_WITH_YN","defaultValue":false,"options":[{"value":true,"label":"Starts with"},{"value":false,"label":"Contains"}]},{"type":"checkbox","name":"ACTIVE_ONLY_YN","defaultValue":true,"label":"Active entities only"},{"type":"text","name":"CITY","defaultValue":"","label":"City"},{"type":"select","name":"SERVICE_TYPE","label":"Special Services Offered","defaultValue":0,"options":[{"value":0,"label":"(N/A)"},{"value":6165,"label":"In-Person Electronic Notarization (IPEN)"},{"value":6166,"label":"Remote Online Notarization (RON)"},{"value":6167,"label":"Mobile Notary Services"},{"value":6168,"label":"Remote Ink Notarization (RIN)"}]}]},{"label":"Apostille","component":"Apostille","parameter":"apostille","sourceTypeId":720,"myRecordsSearch":false,"myWorkQueueSearch":false,"disabled":false,"allowedRoutes":["/forms-manager/","/queue/","/forms/"]},{"label":"Liens","component":"UCC","parameter":"ucc","sourceTypeId":1999,"myRecordsSearch":true,"myWorkQueueSearch":true,"fileAmendmentButtonLabel":"Filing Actions","searchPlaceholder":"Search by name or file number","disabled":false,"serverWebSearchDescription":true,"myRecordsDescription":"","workQueueDescription":"","searchDescription":"","hideRecordUserManagment":true,"searchLiensCheckout":false,"advancedSearchParameters":[{"type":"radio","name":"STARTS_WITH_YN","defaultValue":false,"options":[{"value":true,"label":"Starts with"},{"value":false,"label":"Contains"}]},{"type":"select","name":"STATUS","defaultValue":"ALL","label":"Status","options":[{"value":"ACTIVE_UNLAPSED","label":"Active (unlapsed)"},{"value":"ACTIVE_LAPSED_UNLAPSED","label":"Active (lapsed and unlapsed)"}]},{"type":"text","name":"EXCLUDE_VALUES","label":"Exclude Debtor Names (comma separated list of names to exclude)","defaultValue":""},{"type":"dateRange","name":"FILING_DATE","label":"Financing Statement Date","defaultValue":{"start":null,"end":null}},{"type":"dateRange","name":"LAPSE_DATE","label":"Lapse Date","defaultValue":{"start":null,"end":null}},{"type":"text","name":"CITY","label":"Debtor City","defaultValue":""}],"myRecordsFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Approved"},{"value":2,"label":"Pending Online Payment"},{"value":3,"label":"Pending Review"}]},{"type":"select","name":"TYPE","defaultValue":0,"label":"Lien Type","options":[{"value":0,"label":"All"},{"value":1,"label":"UCC"},{"value":2,"label":"EFS"},{"value":3,"label":"Title 71"}]}],"myWorkQueueFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Approved"},{"value":2,"label":"Pending Online Payment"},{"value":3,"label":"Pending Review"},{"value":4,"label":"Pending Print and Mail"},{"value":5,"label":"Rejected"},{"value":6,"label":"Draft"}]},{"type":"select","name":"TYPE","defaultValue":0,"label":"Lien Type","options":[{"value":0,"label":"All"},{"value":1,"label":"UCC"},{"value":2,"label":"EFS"},{"value":3,"label":"Title 71"}]}]},{"label":"Copy Request","component":"copies","parameter":"copies","sourceTypeId":2001,"myRecordsSearch":false,"myWorkQueueSearch":false,"disabled":false,"allowedRoutes":["/forms-manager/","/queue/","/forms/"]},{"label":"Trademark","component":"Trademark","parameter":"trademark","sourceTypeId":810,"showRequestCertificate":true,"searchMustHaveOneOf":["search","EXPIRATION_DATE","FILING_DATE"],"allowEmptySearchTerm":true,"requestCertificateAlternateLabel":"Request Information","fileAmendmentButtonLabel":"Filing Actions","advancedSearchParameters":[{"type":"radio","name":"QUERY_TYPE_ID","defaultValue":1010,"options":[{"value":1010,"label":"Starts with"},{"value":1011,"label":"Contains"},{"value":1012,"label":" Word Contains"}]},{"type":"checkbox","name":"OWNER_SEARCH_YN","defaultValue":false,"label":"Search owners"},{"type":"radio","name":"SERVICE_MARK_YN","label":"Mark Type","defaultValue":"","options":[{"value":"","label":"All Marks"},{"value":"Y","label":"Service Mark"},{"value":"N","label":"Trademark"}]},{"type":"serverSelect","name":"STATUS_ID","optionsSrc":"TYPE_V|TRADEMARK_STATUS_TYPE","label":"Status","placeholder":"All","defaultValue":"0"},{"type":"select","name":"DESIGN_TYPE_ID","options":[{"value":0,"label":"All"},{"value":990,"label":"Words Only"},{"value":991,"label":"Design Only"},{"value":992,"label":"Words and Design"}],"label":"Design Type","defaultValue":"0"},{"type":"dateRange","name":"FILING_DATE","label":"Registered Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}},{"type":"dateRange","name":"EXPIRATION_DATE","label":"Expiration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}}]},{"label":"Business Info Request","component":"InfoRequests","parameter":"info-request","sourceTypeId":167,"allowedRoutes":["/forms-manager/","/queue/","/forms/"]},{"label":"Data Requests","component":"DataRequests","parameter":"data-request","sourceTypeId":0,"allowedRoutes":["/forms-manager/"]},{"label":"CRA","component":"CRA","parameter":"cra","sourceTypeId":157,"myRecordsSearch":false,"searchPlaceholder":"Search by name or registered agent number","allowedRoutes":["/forms-manager/","/forms/","/records/","/queue/","/search/"],"allowEmptySearchTerm":true,"fileAmendmentButtonLabel":"Filing Actions","advancedSearchParameters":[{"type":"radio","name":"QUERY_TYPE_ID","defaultValue":1010,"options":[{"value":1010,"label":"Starts with"},{"value":1011,"label":"Contains"},{"value":1012,"label":" Word Contains"}]},{"type":"dateRange","name":"CRA_DATE","label":"Registration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}},{"type":"select","name":"STATUS_ID","label":"Status","defaultValue":0,"options":[{"value":0,"label":"All"},{"value":121,"label":"Active"},{"value":122,"label":"Inactive"}]},{"type":"select","name":"AGENT_TYPE_ID","label":"Agent Type","defaultValue":0,"options":[{"value":0,"label":"All"},{"value":460,"label":"Registered Agent"},{"value":461,"label":"Commercial Registered Agent"}]}]},{"label":"Farm Bill","component":"FarmBill","parameter":"farm-bill","path":"/lists/farm-bill","sourceTypeId":0,"myRecordsSearch":false,"allowedRules":["/search/"],"disabled":true,"searchDescription":"To perform a search, enter a debtor name. Your search results may include: exact debtor name, variations of that name and any filing that includes your search criteria. Punctuation is ignored.\n\nYou can click on \"Advanced\" to refine your search. Under “Advanced” you can search by crop, year, county and SSN/FEIN. As a registered Farm Bill Buyer with the Montana Secretary of State’s office it is important to maintain the confidentiality of the information contained within the Farm Bill Master List. The Farm Bill Master List reflects personal data, such as Social Security Numbers, which are a key piece of personal identifiable information to assist you in determining the existence of a lien against a specific debtor. The distribution of this information beyond its intended purpose is strictly prohibited.\n\nThe debtor's tax identification number has been hidden for confidentiality reasons. You may continue to search on a tax ID number and return debtors that match your search criteria. The SSN/FEIN must be entered without dashes or spaces.","searchMustHaveOneOf":["search","UCC_FARM_PRODUCT_ID","COUNTY"],"searchPlaceholder":"Search by debtor name","advancedSearchParameters":[{"type":"ServerMultiComplete","label":"Product code name(s)","name":"UCC_FARM_PRODUCT_ID","defaultValue":"","optionsSrc":"UCC_FARM_PRODUCT_V"},{"type":"MultiComplete","label":"Year or Range of Years","name":"YEAR_NUM","optionsSrc":"years","startYear":"1968","defaultValue":[],"preMergeOptions":[{"value":"ALL","label":"All"}]},{"type":"serverSelect","label":"State","name":"STATE","defaultValue":"MONTANA","optionsSrc":"STATE"},{"type":"ServerMultiComplete","label":"County","name":"COUNTY","defaultValue":[],"optionsSrc":"COUNTY","overrideSubOptionsSrcFromParameterName":"STATE"},{"type":"checkbox","name":"TIN_SEARCH_YN","defaultValue":false,"label":"Tax Identification Number Search"},{"type":"checkbox","name":"TIN_SORT_YN","defaultValue":false,"label":"Unique ID Sort"}]}]) : [];
	
	var SUBROUTES_OBJ = exports.SUBROUTES_OBJ = SUBROUTES.reduce(function (obj, route) {
	  return Object.assign({}, obj, _defineProperty({}, route.parameter, route));
	}, {});
	
	var parseUrlQuery = exports.parseUrlQuery = function parseUrlQuery(input) {
	  var props = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	  try {
	    var search = input.split("?");
	    search = search.slice(1).join('?');
	    var partsArray = search ? search.split("&") : [];
	    var output = {};
	    partsArray.forEach(function (part) {
	      var pair = part.split("=");
	      output[pair[0]] = decodeURIComponent(pair.slice(1).join('='));
	    });
	    return output;
	  } catch (e) {
	    console.error(e);
	    return props.failType !== undefined ? props.failType : {};
	  }
	};
	
	var getSanitizedLocalStorageValue = exports.getSanitizedLocalStorageValue = function getSanitizedLocalStorageValue(key, parse) {
	  var value = localStorage.getItem(key);
	  return value !== '' && value !== 'undefined' && value !== 'null' && value !== undefined ? parse ? JSON.parse(value) : value : null;
	};
	
	var notNullOrUndefined = exports.notNullOrUndefined = function notNullOrUndefined(value) {
	  return value !== null && value !== undefined;
	};
	
	var lowercaseFirstLetter = exports.lowercaseFirstLetter = function lowercaseFirstLetter() {
	  var string = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
	  return string.charAt(0).toLowerCase() + string.slice(1);
	};
	
	var getSelectedOptionFromField = exports.getSelectedOptionFromField = function getSelectedOptionFromField(field, valueIfNotFound) {
	  var selected = ((field || {}).options || []).find(function (option) {
	    return field.value == option.value;
	  });
	  return selected ? selected : valueIfNotFound;
	};
	
	var getFieldsByType = exports.getFieldsByType = function getFieldsByType(type, fields) {
	  var returnType = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'array';
	
	  var fieldArray = [];
	  var fieldObject = {};
	  var push = function push(field) {
	    if (returnType === 'array') fieldArray.push(field);else fieldObject[field.fieldId] = field;
	  };
	  Object.keys(fields).forEach(function (fieldId) {
	    if (Array.isArray(type)) {
	      if (type.includes(fields[fieldId].type)) {
	        push(fields[fieldId]);
	      }
	    } else {
	      if (fields[fieldId].type === type) {
	        push(fields[fieldId]);
	      }
	    }
	  });
	  switch (returnType) {
	    case 'array':
	      return fieldArray.length > 0 ? fieldArray : null;
	    case 'object':
	      return Object.keys(fieldObject) > 0 ? fieldObject : null;
	    default:
	      console.warn('"' + returnType + '" is not a valid return type. Valid return types are "array" and "object"');
	      return null;
	  }
	};
	
	var getFreshValueFromStoreByFieldId = exports.getFreshValueFromStoreByFieldId = function getFreshValueFromStoreByFieldId(fieldId) {
	  return _store2.default.getState().wizard.wizard.fields[fieldId].value;
	};
	
	var objectToArray = exports.objectToArray = function objectToArray() {
	  var obj = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	  if (options.persistKey === true) {
	    return Object.keys(obj).map(function (key) {
	      return _defineProperty({}, key, obj[key]);
	    });
	  } else {
	    return Object.keys(obj).map(function (key) {
	      return obj[key];
	    });
	  }
	};
	
	var getCurrentWizardMetaData = exports.getCurrentWizardMetaData = function getCurrentWizardMetaData() {
	  return _store2.default.getState().wizard.wizard.meta;
	};
	
	var getCurrentWizardAmendmentNum = exports.getCurrentWizardAmendmentNum = function getCurrentWizardAmendmentNum() {
	  return _store2.default.getState().wizard.wizard.amendmentNum;
	};
	
	var FormattedAddress = exports.FormattedAddress = function FormattedAddress(_ref2) {
	  var value = _ref2.value,
	      showCounty = _ref2.showCounty,
	      showCountry = _ref2.showCountry,
	      _ref2$className = _ref2.className,
	      className = _ref2$className === undefined ? '' : _ref2$className;
	
	  if (value) {
	    var country = (0, _selectOptions.getCountryOptions)().find(function (option) {
	      return option.value === value.COUNTRY;
	    });
	    return _react2.default.createElement(
	      'span',
	      { className: className },
	      value.ADDR1,
	      ' ',
	      _react2.default.createElement('br', null),
	      value.ADDR2,
	      value.ADDR2 !== "" && value.ADDR2 ? _react2.default.createElement('br', null) : null,
	      value.ADDR3,
	      value.ADDR3 !== "" && value.ADDR3 ? _react2.default.createElement('br', null) : null,
	      value.COUNTRY.toLowerCase() === "united states" && value.ADDR1 !== "" ? (value.CITY || '').trim() + ', ' + value.STATE + " " + value.POSTAL_CODE : null,
	      value.COUNTRY === "" ? _react2.default.createElement('br', null) : null,
	      value.COUNTY !== "" && value.COUNTY && value.COUNTRY !== "" && value.COUNTRY ? _react2.default.createElement('br', null) : null,
	      value.COUNTY !== "" && value.COUNTY && showCounty ? value.COUNTY + ", " : null,
	      showCountry && value.COUNTRY !== "" && value.COUNTRY && value.COUNTRY !== 'United States' ? country ? country.label : null : null
	    );
	  } else {
	    return null;
	  }
	};
	
	var getFieldsWithChangedValues = exports.getFieldsWithChangedValues = function getFieldsWithChangedValues() {
	  var _store$getState$wizar = _store2.default.getState().wizard,
	      originalByFieldId = _store$getState$wizar.diff.originalByFieldId,
	      fields = _store$getState$wizar.wizard.fields;
	
	  return Object.keys(fields).reduce(function (filtered, fieldId) {
	    if (fields[fieldId].parent.type.toUpperCase() !== 'REPEATER' && !(0, _deepEqual2.default)(fields[fieldId].value, originalByFieldId[fieldId])) {
	      return [].concat(_toConsumableArray(filtered), [fields[fieldId]]);
	    } else {
	      return filtered;
	    }
	  }, []);
	};
	
	var truncateText = exports.truncateText = function truncateText(string, maxLength) {
	  var ellipsis = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
	
	  if (string.length <= maxLength) {
	    return string;
	  } else {
	    return string.slice(0, maxLength) + (ellipsis ? '...' : '');
	  }
	};
	
	var getOrderedResultsByCategory = exports.getOrderedResultsByCategory = function getOrderedResultsByCategory(category, items, templates) {
	  if (items[category]) {
	    return {
	      template: templates[category],
	      rows: (0, _orderBy2.default)(Object.keys(items[category]).map(function (rowId) {
	        return items[category][rowId];
	      }), ['SORT_INDEX'], ['asc'])
	    };
	  } else {
	    return { template: [], rows: [] };
	  }
	};
	
	var noop = exports.noop = function noop() {};
	
	var selectUserGroupByGroupId = exports.selectUserGroupByGroupId = function selectUserGroupByGroupId(groupId) {
	  return _AuthActions.getUserGroup[groupId];
	};
	
	var readFileAsText = exports.readFileAsText = function readFileAsText(e) {
	  return new Promise(function (resolve, reject) {
	    var reader = new FileReader();
	    reader.onload = function () {
	      resolve(JSON.parse(reader.result));
	    };
	    reader.readAsText(e.target.files[0]);
	  });
	};
	
	var getNumBusinessRules = exports.getNumBusinessRules = function getNumBusinessRules(rules) {
	  var allRules = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _businessRules.BUSINESS_RULES;
	  return rules.reduce(function (count, rule) {
	    if (!allRules[rule.fn].excludeFromCount) {
	      return count + 1;
	    } else {
	      return count;
	    }
	  }, 0);
	};
	
	var getSourceTypeId = exports.getSourceTypeId = function getSourceTypeId(category) {
	  return SUBROUTES.find(function (x) {
	    return x.parameter == category;
	  }).sourceTypeId;
	};
	
	var randomWords = {
	  colors: ["Red", "Blue", "Green", "Yellow", "Orange", "Purple", "Pink", "Silver"],
	  animals: ["Giraffe", "Elephant", "Cat", "Puppy", "Unicorn", "Panther", "Mammoth", "Snake", "Dragon", "Chicken", "Lasagna", "Meatloaf", "Cupcake", "Cookie"],
	  occupations: ["Bakers", "Chefs", "Smithies", "Movers", "Keepers", "Designers", "Dancers", "Actors", "Preachers", "Managers", "Magicians", "Horticulturalists"]
	};
	
	var getRandomWordByType = function getRandomWordByType(type) {
	  return randomWords[type][Math.floor(Math.random() * randomWords[type].length)];
	};
	
	var getUniqueJSONValuesByFieldName = function getUniqueJSONValuesByFieldName(fieldName, json) {
	  if (json.FIELD_VALUES[fieldName] && typeof json.FIELD_VALUES[fieldName] === 'string') {
	    var uniqueName = getRandomWordByType('colors') + ' ' + getRandomWordByType('animals') + ' ' + getRandomWordByType('occupations');
	    if (json.FIELD_VALUES[fieldName].includes('[ID]')) {
	      var val1 = json.FIELD_VALUES[fieldName].replace(/\[ID\]/g, uniqueName);
	      json.FIELD_VALUES[fieldName] = val1;
	    }
	  }
	  return json;
	};
	
	var getUniqueJSONvalues = exports.getUniqueJSONvalues = function getUniqueJSONvalues(json) {
	  if (json.FIELD_VALUES.ENTITY_NAME_INFO && _typeof(json.FIELD_VALUES.ENTITY_NAME_INFO) === 'object') {
	    var uniqueName = getRandomWordByType('colors') + ' ' + getRandomWordByType('animals') + ' ' + getRandomWordByType('occupations');
	    if (json.FIELD_VALUES.ENTITY_NAME_INFO.val1.includes('[ID]')) {
	      var val1 = json.FIELD_VALUES.ENTITY_NAME_INFO.val1.replace(/\[ID\]/g, uniqueName);
	      json.FIELD_VALUES.ENTITY_NAME_INFO = Object.assign({}, json.FIELD_VALUES.ENTITY_NAME_INFO, {
	        val1: val1,
	        val2: val1
	      });
	    }
	  }
	  json = getUniqueJSONValuesByFieldName('ENTITY_NAME', json);
	  json = getUniqueJSONValuesByFieldName('TRADEMARK_NAME', json);
	  return json;
	};
	
	var handleForbiddenResponse = exports.handleForbiddenResponse = function handleForbiddenResponse() {
	  //Redirects to auth route if not already on an auth route.
	  //Returns boolean of whether or not it redirected.
	  var pathname = _store.history.location.pathname;
	  if (pathname !== 'admin' && pathname !== 'auth') {
	    _store.history.replace(getAuthRedirectUrl(_store.history.location));
	    _store2.default.dispatch((0, _AuthActions.clearLocalUser)());
	    return true;
	  } else {
	    return false;
	  }
	};
	
	var handleOfflineResponse = exports.handleOfflineResponse = function handleOfflineResponse() {
	  _store2.default.dispatch((0, _actions.setOffline)(true));
	  _store2.default.dispatch((0, _AuthActions.clearLocalUser)());
	};
	
	var getAuthRedirectUrl = exports.getAuthRedirectUrl = function getAuthRedirectUrl(location) {
	  var lastUsersGroup = getSanitizedLocalStorageValue("LAST_USERS_GROUP");
	  lastUsersGroup = lastUsersGroup ? JSON.parse(lastUsersGroup) : lastUsersGroup;
	  return '/' + (lastUsersGroup === "ADMIN" || lastUsersGroup === "ADMIN_WEB" ? "admin" : "auth") + '?from=' + encodeURI(location.pathname) + (location.search ? "&search=" : "") + location.search;
	};
	
	var calculateReceiptItemsTotal = exports.calculateReceiptItemsTotal = function calculateReceiptItemsTotal() {
	  var receiptItems = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	  return Array.isArray(receiptItems) && receiptItems.length > 0 ? receiptItems.reduce(function (accumulator, currentVal) {
	    return accumulator + currentVal.LINE_TOTAL;
	  }, 0) : 0;
	};
	
	var calculateReceiptItemContainersTotal = exports.calculateReceiptItemContainersTotal = function calculateReceiptItemContainersTotal() {
	  var receiptItemContainers = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	  return Array.isArray(receiptItemContainers) && receiptItemContainers.reduce(function (t, container) {
	    return (container.RECEIPT_ITEM_WEB_LIST.length > 0 ? container.RECEIPT_ITEM_WEB_LIST.reduce(function (accumulator, currentVal) {
	      return accumulator + currentVal.LINE_TOTAL;
	    }, 0) : 0) + t;
	  }, 0);
	};
	
	var getControlIsRenderable = exports.getControlIsRenderable = function getControlIsRenderable(address, fields) {
	  if (!address || !fields) return false;
	  if (address.parent.type === 'OPTION') {
	    var parent = fields[address.parent.id];
	    if (!parent) return false;
	    var selected = getSelectedOptionFromField(parent, null);
	    if (!selected) return false;
	    if (!selected.fields.includes(address.fieldId)) return false;
	  }
	  if (address.parent.type === 'CHECKBOX') {
	    var _parent = fields[address.parent.id];
	    if (!_parent) return false;
	    var _selected = _parent.value === true ? _parent.checkedFields : _parent.uncheckedFields;
	    if (!_selected) return false;
	
	    if (!_selected.includes(address.fieldId)) return false;
	  }
	  if (!(0, _wizardUtilities.resolveFieldConditions)(address.conditions, fields, address.conditionsOperator)) return false;
	  return true;
	};
	
	var convertRepeaterRowsToColumnsObject = exports.convertRepeaterRowsToColumnsObject = function convertRepeaterRowsToColumnsObject(template, rows) {
	  return template.reduce(function (obj, fieldId) {
	    return Object.assign({}, obj, _defineProperty({}, fieldId, rows.map(function (row) {
	      return row[fieldId];
	    })));
	  }, {});
	};
	
	var testRepeaterConstraints = exports.testRepeaterConstraints = function testRepeaterConstraints(constraints, rows, fields) {
	  return constraints.map(function (constraint) {
	    var hashTable = rows.map(function (row) {
	      return constraint.fields.reduce(function (hash, fieldId) {
	        var fieldObj = fields[fieldId] || {};
	        var field = WIZARD_CLASSES[fieldObj.fieldClass];
	        if (field) {
	          var instance = Object.assign({}, fieldObj, { value: row[fieldId] });
	          var compValue = new field(instance).getCompareValue(instance);
	          if ((typeof compValue === 'undefined' ? 'undefined' : _typeof(compValue)) === 'object') {
	            return hash + (0, _index2.default)(compValue);
	          } else {
	            return hash + compValue;
	          }
	        } else {
	          return hash;
	        }
	      }, "");
	    });
	    hashTable.sort();
	    return !getArrayHasDuplicates(hashTable);
	  });
	};
	
	var getArrayHasDuplicates = function getArrayHasDuplicates(arr) {
	  for (var i = 0; i < arr.length - 1; i++) {
	    if (arr[i] === arr[i + 1]) return true;
	  }
	  return false;
	};
	
	var getFieldByKey = exports.getFieldByKey = function getFieldByKey(keyValue, key) {
	  var fields = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	  var returnType = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 'object';
	
	  if (returnType === 'array') {
	    return Object.entries(fields).reduce(function (arr, _ref3) {
	      var _ref4 = _slicedToArray(_ref3, 2),
	          k = _ref4[0],
	          v = _ref4[1];
	
	      return v[key] === keyValue ? [].concat(_toConsumableArray(arr), [v]) : arr;
	    }, []);
	  } else {
	    return Object.entries(fields).reduce(function (obj, _ref5) {
	      var _ref6 = _slicedToArray(_ref5, 2),
	          k = _ref6[0],
	          v = _ref6[1];
	
	      return v[key] == keyValue ? Object.assign({}, obj, _defineProperty({}, k, v)) : obj;
	    }, {});
	  }
	};
	
	var getHydratedFields = exports.getHydratedFields = function getHydratedFields(row, template, fields) {
	  return Object.entries(fields).reduce(function (obj, _ref7) {
	    var _ref8 = _slicedToArray(_ref7, 2),
	        fieldId = _ref8[0],
	        field = _ref8[1];
	
	    if (template.includes(fieldId)) {
	      return Object.assign({}, obj, _defineProperty({}, fieldId, Object.assign({}, field, {
	        value: row[fieldId]
	      })));
	    }
	    return Object.assign({}, obj, _defineProperty({}, fieldId, field));
	  }, {});
	};
	
	var formatSignaturesForServer = function formatSignaturesForServer(signatures) {
	  return signatures.map(function (_ref9) {
	    var ROW_ID = _ref9._rowId,
	        EMAIL = _ref9['~~SIGNER_EMAIL_FH42JAD8942KDW~~'],
	        SIGNER_NAME = _ref9['~~SIGNER_NAME_JHEK12LKHK12KJ~~'],
	        sig = _objectWithoutProperties(_ref9, ['_rowId', '~~SIGNER_EMAIL_FH42JAD8942KDW~~', '~~SIGNER_NAME_JHEK12LKHK12KJ~~']);
	
	    return Object.assign({
	      ROW_ID: ROW_ID,
	      SIGNER_NAME: new WIZARD_CLASSES.FullName({ value: SIGNER_NAME }).getHumanReadableValue({ value: SIGNER_NAME }, SIGNER_NAME),
	      EMAIL: EMAIL
	    }, sig);
	  });
	};
	
	exports.formatSignaturesForServer = formatSignaturesForServer;
	var getFirstFocusableScopedElement = exports.getFirstFocusableScopedElement = function getFirstFocusableScopedElement() {
	  var scope = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
	  var postScope = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
	
	  var focusableSelectors = ['button', '[href]', 'input', 'select', 'textarea', '[tabindex]:not([tabindex="-1"])'].map(function (x) {
	    return scope + ' ' + x + postScope;
	  }).join(', ');
	  var focusables = document.querySelectorAll(focusableSelectors);
	  return focusables[0];
	};
	
	var getFieldsByFieldIds = exports.getFieldsByFieldIds = function getFieldsByFieldIds(fieldIds, fields) {
	  return fieldIds.reduce(function (obj, fieldId) {
	    obj[fieldId] = fields[fieldId];
	    return obj;
	  }, {});
	};
	
	var getRequiredAppSettingNames = exports.getRequiredAppSettingNames = function getRequiredAppSettingNames(fields) {
	  return fields.reduce(function (settingNames, field) {
	    Object.values(field.logicNodes).forEach(function (node) {
	      if (node.type === 'booleanAppSetting') {
	        if (node.inputData.booleanAppSetting.booleanAppSetting) {
	          settingNames.push(node.inputData.booleanAppSetting.booleanAppSetting);
	        }
	      }
	      if (node.type === 'stringAppSetting') {
	        if (node.inputData.stringAppSetting.stringAppSetting) {
	          settingNames.push(node.inputData.stringAppSetting.stringAppSetting);
	        }
	      }
	    });
	    return settingNames;
	  }, []);
	};
	
	var coerceType = exports.coerceType = function coerceType(value, defaultValue) {
	  if ((typeof value === 'undefined' ? 'undefined' : _typeof(value)) !== (typeof defaultValue === 'undefined' ? 'undefined' : _typeof(defaultValue))) {
	    return defaultValue;
	  } else {
	    return value;
	  }
	};
	
	var hydrateSublinkFunctions = exports.hydrateSublinkFunctions = function hydrateSublinkFunctions(rawSublink) {
	  var sublink = Object.assign({}, rawSublink);
	  if (rawSublink.advancedSearchParameters) {
	    sublink.advancedSearchParameters = rawSublink.advancedSearchParameters.map(function (rawParam) {
	      var param = Object.assign({}, rawParam);
	      if (typeof rawParam.getProps === 'string') {
	        // eslint-disable-next-line no-new-func
	        param.getProps = new Function('values', rawParam.getProps);
	      }
	      if (typeof rawParam.setValue === 'string') {
	        // eslint-disable-next-line no-new-func
	        param.setValue = new Function('value', rawParam.setValue);
	      }
	      return param;
	    });
	  }
	  if (typeof rawSublink.searchRequirementsAreSatisfied === 'string') {
	    // eslint-disable-next-line no-new-func
	    sublink.searchRequirementsAreSatisfied = new Function('search', 'values', sublink.searchRequirementsAreSatisfied);
	  }
	  return sublink;
	};
	
	var getHumanReadableValueByField = exports.getHumanReadableValueByField = function getHumanReadableValueByField(field) {
	  return new WIZARD_CLASSES[field.fieldClass](field).getHumanReadableValue(field, field.value);
	};

/***/ },
/* 9 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = toInteger;
	
	function toInteger(dirtyNumber) {
	  if (dirtyNumber === null || dirtyNumber === true || dirtyNumber === false) {
	    return NaN;
	  }
	
	  var number = Number(dirtyNumber);
	
	  if (isNaN(number)) {
	    return number;
	  }
	
	  return number < 0 ? Math.ceil(number) : Math.floor(number);
	}
	
	module.exports = exports.default;

/***/ },
/* 10 */
/***/ function(module, exports) {

	/*
		MIT License http://www.opensource.org/licenses/mit-license.php
		Author Tobias Koppers @sokra
	*/
	// css base code, injected by the css-loader
	module.exports = function() {
		var list = [];
	
		// return the list of modules as css string
		list.toString = function toString() {
			var result = [];
			for(var i = 0; i < this.length; i++) {
				var item = this[i];
				if(item[2]) {
					result.push("@media " + item[2] + "{" + item[1] + "}");
				} else {
					result.push(item[1]);
				}
			}
			return result.join("");
		};
	
		// import a list of modules into the list
		list.i = function(modules, mediaQuery) {
			if(typeof modules === "string")
				modules = [[null, modules, ""]];
			var alreadyImportedModules = {};
			for(var i = 0; i < this.length; i++) {
				var id = this[i][0];
				if(typeof id === "number")
					alreadyImportedModules[id] = true;
			}
			for(i = 0; i < modules.length; i++) {
				var item = modules[i];
				// skip already imported module
				// this implementation is not 100% perfect for weird media query combinations
				//  when a module is imported multiple times with different media queries.
				//  I hope this will never occur (Hey this way we have smaller bundles)
				if(typeof item[0] !== "number" || !alreadyImportedModules[item[0]]) {
					if(mediaQuery && !item[2]) {
						item[2] = mediaQuery;
					} else if(mediaQuery) {
						item[2] = "(" + item[2] + ") and (" + mediaQuery + ")";
					}
					list.push(item);
				}
			}
		};
		return list;
	};


/***/ },
/* 11 */
/***/ function(module, exports, __webpack_require__) {

	/*
		MIT License http://www.opensource.org/licenses/mit-license.php
		Author Tobias Koppers @sokra
	*/
	var stylesInDom = {},
		memoize = function(fn) {
			var memo;
			return function () {
				if (typeof memo === "undefined") memo = fn.apply(this, arguments);
				return memo;
			};
		},
		isOldIE = memoize(function() {
			return /msie [6-9]\b/.test(window.navigator.userAgent.toLowerCase());
		}),
		getHeadElement = memoize(function () {
			return document.head || document.getElementsByTagName("head")[0];
		}),
		singletonElement = null,
		singletonCounter = 0,
		styleElementsInsertedAtTop = [];
	
	module.exports = function(list, options) {
		if(false) {
			if(typeof document !== "object") throw new Error("The style-loader cannot be used in a non-browser environment");
		}
	
		options = options || {};
		// Force single-tag solution on IE6-9, which has a hard limit on the # of <style>
		// tags it will allow on a page
		if (typeof options.singleton === "undefined") options.singleton = isOldIE();
	
		// By default, add <style> tags to the bottom of <head>.
		if (typeof options.insertAt === "undefined") options.insertAt = "bottom";
	
		var styles = listToStyles(list);
		addStylesToDom(styles, options);
	
		return function update(newList) {
			var mayRemove = [];
			for(var i = 0; i < styles.length; i++) {
				var item = styles[i];
				var domStyle = stylesInDom[item.id];
				domStyle.refs--;
				mayRemove.push(domStyle);
			}
			if(newList) {
				var newStyles = listToStyles(newList);
				addStylesToDom(newStyles, options);
			}
			for(var i = 0; i < mayRemove.length; i++) {
				var domStyle = mayRemove[i];
				if(domStyle.refs === 0) {
					for(var j = 0; j < domStyle.parts.length; j++)
						domStyle.parts[j]();
					delete stylesInDom[domStyle.id];
				}
			}
		};
	}
	
	function addStylesToDom(styles, options) {
		for(var i = 0; i < styles.length; i++) {
			var item = styles[i];
			var domStyle = stylesInDom[item.id];
			if(domStyle) {
				domStyle.refs++;
				for(var j = 0; j < domStyle.parts.length; j++) {
					domStyle.parts[j](item.parts[j]);
				}
				for(; j < item.parts.length; j++) {
					domStyle.parts.push(addStyle(item.parts[j], options));
				}
			} else {
				var parts = [];
				for(var j = 0; j < item.parts.length; j++) {
					parts.push(addStyle(item.parts[j], options));
				}
				stylesInDom[item.id] = {id: item.id, refs: 1, parts: parts};
			}
		}
	}
	
	function listToStyles(list) {
		var styles = [];
		var newStyles = {};
		for(var i = 0; i < list.length; i++) {
			var item = list[i];
			var id = item[0];
			var css = item[1];
			var media = item[2];
			var sourceMap = item[3];
			var part = {css: css, media: media, sourceMap: sourceMap};
			if(!newStyles[id])
				styles.push(newStyles[id] = {id: id, parts: [part]});
			else
				newStyles[id].parts.push(part);
		}
		return styles;
	}
	
	function insertStyleElement(options, styleElement) {
		var head = getHeadElement();
		var lastStyleElementInsertedAtTop = styleElementsInsertedAtTop[styleElementsInsertedAtTop.length - 1];
		if (options.insertAt === "top") {
			if(!lastStyleElementInsertedAtTop) {
				head.insertBefore(styleElement, head.firstChild);
			} else if(lastStyleElementInsertedAtTop.nextSibling) {
				head.insertBefore(styleElement, lastStyleElementInsertedAtTop.nextSibling);
			} else {
				head.appendChild(styleElement);
			}
			styleElementsInsertedAtTop.push(styleElement);
		} else if (options.insertAt === "bottom") {
			head.appendChild(styleElement);
		} else {
			throw new Error("Invalid value for parameter 'insertAt'. Must be 'top' or 'bottom'.");
		}
	}
	
	function removeStyleElement(styleElement) {
		styleElement.parentNode.removeChild(styleElement);
		var idx = styleElementsInsertedAtTop.indexOf(styleElement);
		if(idx >= 0) {
			styleElementsInsertedAtTop.splice(idx, 1);
		}
	}
	
	function createStyleElement(options) {
		var styleElement = document.createElement("style");
		styleElement.type = "text/css";
		insertStyleElement(options, styleElement);
		return styleElement;
	}
	
	function createLinkElement(options) {
		var linkElement = document.createElement("link");
		linkElement.rel = "stylesheet";
		insertStyleElement(options, linkElement);
		return linkElement;
	}
	
	function addStyle(obj, options) {
		var styleElement, update, remove;
	
		if (options.singleton) {
			var styleIndex = singletonCounter++;
			styleElement = singletonElement || (singletonElement = createStyleElement(options));
			update = applyToSingletonTag.bind(null, styleElement, styleIndex, false);
			remove = applyToSingletonTag.bind(null, styleElement, styleIndex, true);
		} else if(obj.sourceMap &&
			typeof URL === "function" &&
			typeof URL.createObjectURL === "function" &&
			typeof URL.revokeObjectURL === "function" &&
			typeof Blob === "function" &&
			typeof btoa === "function") {
			styleElement = createLinkElement(options);
			update = updateLink.bind(null, styleElement);
			remove = function() {
				removeStyleElement(styleElement);
				if(styleElement.href)
					URL.revokeObjectURL(styleElement.href);
			};
		} else {
			styleElement = createStyleElement(options);
			update = applyToTag.bind(null, styleElement);
			remove = function() {
				removeStyleElement(styleElement);
			};
		}
	
		update(obj);
	
		return function updateStyle(newObj) {
			if(newObj) {
				if(newObj.css === obj.css && newObj.media === obj.media && newObj.sourceMap === obj.sourceMap)
					return;
				update(obj = newObj);
			} else {
				remove();
			}
		};
	}
	
	var replaceText = (function () {
		var textStore = [];
	
		return function (index, replacement) {
			textStore[index] = replacement;
			return textStore.filter(Boolean).join('\n');
		};
	})();
	
	function applyToSingletonTag(styleElement, index, remove, obj) {
		var css = remove ? "" : obj.css;
	
		if (styleElement.styleSheet) {
			styleElement.styleSheet.cssText = replaceText(index, css);
		} else {
			var cssNode = document.createTextNode(css);
			var childNodes = styleElement.childNodes;
			if (childNodes[index]) styleElement.removeChild(childNodes[index]);
			if (childNodes.length) {
				styleElement.insertBefore(cssNode, childNodes[index]);
			} else {
				styleElement.appendChild(cssNode);
			}
		}
	}
	
	function applyToTag(styleElement, obj) {
		var css = obj.css;
		var media = obj.media;
	
		if(media) {
			styleElement.setAttribute("media", media)
		}
	
		if(styleElement.styleSheet) {
			styleElement.styleSheet.cssText = css;
		} else {
			while(styleElement.firstChild) {
				styleElement.removeChild(styleElement.firstChild);
			}
			styleElement.appendChild(document.createTextNode(css));
		}
	}
	
	function updateLink(linkElement, obj) {
		var css = obj.css;
		var sourceMap = obj.sourceMap;
	
		if(sourceMap) {
			// http://stackoverflow.com/a/26603875
			css += "\n/*# sourceMappingURL=data:application/json;base64," + btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap)))) + " */";
		}
	
		var blob = new Blob([css], { type: "text/css" });
	
		var oldSrc = linkElement.href;
	
		linkElement.href = URL.createObjectURL(blob);
	
		if(oldSrc)
			URL.revokeObjectURL(oldSrc);
	}


/***/ },
/* 12 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactPortal = __webpack_require__(1326);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	exports.default = function (_ref) {
	  var children = _ref.children,
	      isOpened = _ref.isOpened,
	      props = _objectWithoutProperties(_ref, ['children', 'isOpened']);
	
	  if (!isOpened) return null;
	
	  return _react2.default.createElement(
	    _reactPortal.Portal,
	    props,
	    children
	  );
	};

/***/ },
/* 13 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.ControlledModal = exports.DialogInput = exports.DialogButton = exports.ConfirmDialog = exports.Modal = undefined;
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(70);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _focusTrapReact = __webpack_require__(193);
	
	var _focusTrapReact2 = _interopRequireDefault(_focusTrapReact);
	
	var _shortid = __webpack_require__(22);
	
	var _shortid2 = _interopRequireDefault(_shortid);
	
	__webpack_require__(1450);
	
	var _propTypes = __webpack_require__(20);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _Portal = __webpack_require__(12);
	
	var _Portal2 = _interopRequireDefault(_Portal);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Modal = exports.Modal = function (_Component) {
	  _inherits(Modal, _Component);
	
	  function Modal(props) {
	    _classCallCheck(this, Modal);
	
	    var _this = _possibleConstructorReturn(this, (Modal.__proto__ || Object.getPrototypeOf(Modal)).call(this));
	
	    _this.closeModal = function (callback, noSave) {
	      if (_this.props.save && !noSave) {
	        _this.props.save();
	      }
	      _this.setState({
	        shadeAnimationClass: 'fadeOut',
	        modalAnimationClass: 'fadeOutDown',
	        closing: true
	      });
	      _this.closeCallback = callback;
	    };
	
	    _this.cancelModal = function () {
	      if (_this.props.cancel) {
	        _this.props.cancel();
	      }
	      _this.setState({
	        shadeAnimationClass: 'fadeOut',
	        modalAnimationClass: 'fadeOutDown',
	        closing: true
	      });
	    };
	
	    _this.transitionOver = function () {
	      if (_this.state.closing) {
	        _this.setState({ closing: false });
	        _this.props.closeModal();
	        if (typeof _this.closeCallback === 'function') {
	          _this.closeCallback();
	        }
	      }
	    };
	
	    _this.state = {
	      shadeAnimationClass: 'fadeIn',
	      modalAnimationClass: props.disableEntranceAnimation ? '' : 'fadeInUp',
	      closing: false
	    };
	    _this.id = _shortid2.default.generate();
	    return _this;
	  }
	
	  _createClass(Modal, [{
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _props = this.props,
	          _props$modalSize = _props.modalSize,
	          modalSize = _props$modalSize === undefined ? '' : _props$modalSize,
	          _props$headerType = _props.headerType,
	          headerType = _props$headerType === undefined ? '' : _props$headerType,
	          title = _props.title,
	          cancelButton = _props.cancelButton,
	          _props$cancelButtonTe = _props.cancelButtonText,
	          cancelButtonText = _props$cancelButtonTe === undefined ? 'Cancel' : _props$cancelButtonTe,
	          saveAndCloseButton = _props.saveAndCloseButton,
	          saveButton = _props.saveButton,
	          children = _props.children,
	          hideHeader = _props.hideHeader,
	          noBackground = _props.noBackground,
	          _props$modalStyle = _props.modalStyle,
	          modalStyle = _props$modalStyle === undefined ? {} : _props$modalStyle,
	          _props$modalBodyClass = _props.modalBodyClassName,
	          modalBodyClassName = _props$modalBodyClass === undefined ? '' : _props$modalBodyClass,
	          rootClassName = _props.rootClassName,
	          autoHeight = _props.autoHeight,
	          closeButton = _props.closeButton,
	          _props$bodyColor = _props.bodyColor,
	          bodyColor = _props$bodyColor === undefined ? '' : _props$bodyColor,
	          save = _props.save,
	          containingElement = _props.containingElement;
	
	
	      var modalElement = _react2.default.createElement(
	        'div',
	        {
	          className: 'modal-wrapper ' + modalSize + ' ' + rootClassName,
	          'aria-labelledby': 'title-' + this.id
	        },
	        _react2.default.createElement(
	          _focusTrapReact2.default,
	          {
	            focusTrapOptions: { clickOutsideDeactivates: true },
	            className: 'modal animated fast-animation ' + this.state.modalAnimationClass + ' ' + modalSize + ' ' + (noBackground ? ' no-background' : '') + ' ' + modalBodyClassName + ' ' + (hideHeader ? 'hide-header' : '') + ' ' + (autoHeight ? 'auto-height' : '') + ' ' + bodyColor,
	            style: modalStyle,
	            role: 'dialog'
	          },
	          !hideHeader && _react2.default.createElement(
	            'div',
	            { className: 'header ' + headerType },
	            _react2.default.createElement(
	              'span',
	              { className: 'title', id: 'title-' + this.id },
	              title
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'button-group' },
	              cancelButton && _react2.default.createElement(
	                'button',
	                { onClick: this.cancelModal, className: 'btn btn-primary' },
	                _react2.default.createElement(
	                  'span',
	                  { className: 'text' },
	                  cancelButtonText
	                )
	              ),
	              saveAndCloseButton && _react2.default.createElement(
	                'button',
	                { onClick: this.closeModal, className: 'btn btn-secondary' },
	                _react2.default.createElement(
	                  'span',
	                  { className: 'text' },
	                  'Save & Close'
	                )
	              ),
	              saveButton && _react2.default.createElement(
	                'button',
	                {
	                  onClick: function onClick() {
	                    save(function () {
	                      _this2.closeModal(undefined, true);
	                    });
	                  },
	                  className: 'btn btn-secondary'
	                },
	                _react2.default.createElement(
	                  'span',
	                  { className: 'text' },
	                  'Save & Close'
	                )
	              ),
	              closeButton && _react2.default.createElement(
	                'button',
	                { className: 'close-button', onClick: this.closeModal, 'aria-label': 'Close' },
	                _react2.default.createElement('span', { className: 'icon icon-cross', 'aria-hidden': 'true' })
	              )
	            )
	          ),
	          (hideHeader || noBackground) && _react2.default.createElement(
	            'button',
	            { className: 'no-background-close', onClick: this.closeModal, 'aria-label': 'Close' },
	            _react2.default.createElement('span', { 'aria-hidden': 'true', className: 'icon icon-cross' })
	          ),
	          typeof children === 'function' ? children({ closeModal: this.closeModal }) : children
	        ),
	        _react2.default.createElement('div', {
	          className: 'shade animated fast-animation ' + this.state.shadeAnimationClass,
	          onAnimationEnd: this.transitionOver,
	          onClick: this.cancelModal
	        })
	      );
	
	      // if a containing element was specified, insert modal into the target element
	      if (containingElement) {
	        var targetParentElement = undefined;
	
	        if (typeof containingElement === 'string') {
	          targetParentElement = document.querySelector(containingElement);
	        } else if ((typeof containingElement === 'undefined' ? 'undefined' : _typeof(containingElement)) === 'object' && containingElement instanceof Node) {
	          targetParentElement = containingElement;
	        }
	
	        if (targetParentElement !== undefined && targetParentElement !== null) {
	          return _reactDom2.default.createPortal(modalElement, targetParentElement);
	        } else {
	          console.error('The "containingElement" argument provided is invalid:', containingElement);
	        }
	      } else {
	        return modalElement;
	      }
	    }
	  }]);
	
	  return Modal;
	}(_react.Component);
	
	Modal.propTypes = {
	  modalSize: _propTypes2.default.string,
	  headerType: _propTypes2.default.string,
	  title: _propTypes2.default.string,
	  cancelButton: _propTypes2.default.bool,
	  cancelButtonText: _propTypes2.default.string,
	  saveAndCloseButton: _propTypes2.default.bool,
	  saveButton: _propTypes2.default.bool,
	  children: _propTypes2.default.oneOfType([_propTypes2.default.node, _propTypes2.default.func]),
	  hideHeader: _propTypes2.default.bool,
	  noBackground: _propTypes2.default.bool,
	  modalStyle: _propTypes2.default.object,
	  modalBodyClassName: _propTypes2.default.string,
	  rootClassName: _propTypes2.default.string,
	  autoHeight: _propTypes2.default.bool,
	  closeButton: _propTypes2.default.bool,
	  bodyColor: _propTypes2.default.string,
	  save: _propTypes2.default.func,
	  containingElement: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.object])
	};
	
	var ConfirmDialog = exports.ConfirmDialog = function (_Component2) {
	  _inherits(ConfirmDialog, _Component2);
	
	  function ConfirmDialog() {
	    _classCallCheck(this, ConfirmDialog);
	
	    var _this3 = _possibleConstructorReturn(this, (ConfirmDialog.__proto__ || Object.getPrototypeOf(ConfirmDialog)).call(this));
	
	    _this3.componentDidMount = function () {
	      var _this3$props$inputs = _this3.props.inputs,
	          inputs = _this3$props$inputs === undefined ? [] : _this3$props$inputs;
	
	      if (inputs.length > 0) {
	        _this3.inputRefs.input0.focus();
	      }
	    };
	
	    _this3.closeModal = function (callback) {
	      _this3.modal.closeModal(function () {
	        if (_this3.props.onModalClosed) {
	          _this3.props.onModalClosed();
	        }
	        if (callback) {
	          callback();
	        }
	      });
	    };
	
	    _this3.getInputObject = function () {
	      var values = {};
	      Object.keys(_this3.inputRefs).forEach(function (ref, i) {
	        if (ref.includes('input')) {
	          var value = _this3.inputRefs['input' + i].getValue();
	          values[value.name] = value.value;
	        }
	      });
	      return values;
	    };
	
	    _this3.submit = function () {
	      var _this3$props$buttons = _this3.props.buttons,
	          buttons = _this3$props$buttons === undefined ? [] : _this3$props$buttons;
	
	      buttons.forEach(function (button, i) {
	        if (button.submit) {
	          _this3.buttonRefs['button' + i].handleClick();
	          return;
	        }
	      });
	    };
	
	    _this3.inputRefs = {};
	    _this3.buttonRefs = {};
	    return _this3;
	  }
	
	  _createClass(ConfirmDialog, [{
	    key: 'render',
	    value: function render() {
	      var _this4 = this;
	
	      var _props2 = this.props,
	          title = _props2.title,
	          children = _props2.children,
	          closeModal = _props2.closeModal,
	          message = _props2.message,
	          _props2$buttons = _props2.buttons,
	          buttons = _props2$buttons === undefined ? [] : _props2$buttons,
	          _props2$inputs = _props2.inputs,
	          inputs = _props2$inputs === undefined ? [] : _props2$inputs,
	          sizeOverride = _props2.sizeOverride,
	          leftAligned = _props2.leftAligned,
	          props = _objectWithoutProperties(_props2, ['title', 'children', 'closeModal', 'message', 'buttons', 'inputs', 'sizeOverride', 'leftAligned']);
	
	      return _react2.default.createElement(
	        Modal,
	        Object.assign({
	          modalSize: sizeOverride || 'toast',
	          title: title,
	          hideHeader: true,
	          closeModal: closeModal,
	          ref: function ref(modal) {
	            _this4.modal = modal;
	          }
	        }, props),
	        _react2.default.createElement(
	          _focusTrapReact2.default,
	          {
	            focusTrapOptions: { clickOutsideDeactivates: true },
	            className: 'modal-body',
	            active: inputs.length > 0 || buttons.length > 0 ? undefined : false
	          },
	          _react2.default.createElement(
	            'span',
	            { className: 'toast-message', style: leftAligned ? { textAlign: 'left' } : undefined },
	            message
	          ),
	          children,
	          _react2.default.createElement(
	            'div',
	            { className: 'button-wrapper', style: { paddingTop: 0 } },
	            inputs.map(function (input, i) {
	              return _react2.default.createElement(DialogInput, Object.assign({}, input, { ref: function ref(_ref) {
	                  return _this4.inputRefs['input' + i] = _ref;
	                }, submit: _this4.submit, key: i }));
	            })
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'button-wrapper' },
	            buttons.map(function (button, i) {
	              return _react2.default.createElement(DialogButton, Object.assign({}, button, {
	                closeModal: _this4.closeModal,
	                getInputObject: _this4.getInputObject,
	                ref: function ref(_ref2) {
	                  return _this4.buttonRefs['button' + i] = _ref2;
	                },
	                key: i
	              }));
	            })
	          )
	        )
	      );
	    }
	  }]);
	
	  return ConfirmDialog;
	}(_react.Component);
	
	var DialogButton = exports.DialogButton = function (_Component3) {
	  _inherits(DialogButton, _Component3);
	
	  function DialogButton() {
	    var _ref3;
	
	    var _temp, _this5, _ret;
	
	    _classCallCheck(this, DialogButton);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this5 = _possibleConstructorReturn(this, (_ref3 = DialogButton.__proto__ || Object.getPrototypeOf(DialogButton)).call.apply(_ref3, [this].concat(args))), _this5), _this5.handleClick = function () {
	      if (_this5.props.fireAfterClose) {
	        _this5.props.closeModal(function () {
	          _this5.clickEventHandler();
	        });
	      } else {
	        _this5.clickEventHandler();
	      }
	    }, _this5.clickEventHandler = function () {
	      if (_this5.props.closeModal && !_this5.props.fireAfterClose) {
	        _this5.props.closeModal();
	      }
	      if (_this5.props.customClickHandler) {
	        if (_this5.props.onClick) {
	          _this5.props.onClick();
	        }
	      } else {
	        if (_this5.props.onClick) {
	          _this5.props.onClick(_this5.props.getInputObject());
	        }
	      }
	    }, _temp), _possibleConstructorReturn(_this5, _ret);
	  }
	
	  _createClass(DialogButton, [{
	    key: 'render',
	    value: function render() {
	      var _props3 = this.props,
	          label = _props3.label,
	          _props3$className = _props3.className,
	          className = _props3$className === undefined ? 'btn-primary' : _props3$className,
	          disabled = _props3.disabled;
	
	      return _react2.default.createElement(
	        'button',
	        { disabled: disabled, className: 'btn ' + className, onClick: this.handleClick },
	        label
	      );
	    }
	  }]);
	
	  return DialogButton;
	}(_react.Component);
	
	var DialogInput = exports.DialogInput = function (_Component4) {
	  _inherits(DialogInput, _Component4);
	
	  function DialogInput() {
	    var _ref4;
	
	    var _temp2, _this6, _ret2;
	
	    _classCallCheck(this, DialogInput);
	
	    for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
	      args[_key2] = arguments[_key2];
	    }
	
	    return _ret2 = (_temp2 = (_this6 = _possibleConstructorReturn(this, (_ref4 = DialogInput.__proto__ || Object.getPrototypeOf(DialogInput)).call.apply(_ref4, [this].concat(args))), _this6), _this6.getValue = function () {
	      return { name: _this6.props.name, value: _this6.input.value };
	    }, _this6.setValue = function (value) {
	      _this6.input.value = value;
	    }, _this6.focus = function () {
	      _this6.input.focus();
	    }, _this6.checkForSubmit = function (_ref5) {
	      var charCode = _ref5.charCode;
	
	      if (charCode === 13) {
	        _this6.props.submit();
	      }
	    }, _this6.getFieldType = function () {
	      var _this6$props = _this6.props,
	          _this6$props$type = _this6$props.type,
	          type = _this6$props$type === undefined ? 'text' : _this6$props$type,
	          _this6$props$classNam = _this6$props.className,
	          className = _this6$props$classNam === undefined ? '' : _this6$props$classNam,
	          _this6$props$style = _this6$props.style,
	          style = _this6$props$style === undefined ? {} : _this6$props$style,
	          _this6$props$placehol = _this6$props.placeholder,
	          placeholder = _this6$props$placehol === undefined ? '' : _this6$props$placehol;
	
	      switch (type) {
	        case 'text':
	        default:
	          return _react2.default.createElement(
	            'div',
	            { className: 'text-wrapper ' + className, style: style },
	            _react2.default.createElement('input', {
	              type: 'text',
	              placeholder: placeholder,
	              onKeyPress: _this6.checkForSubmit,
	              ref: function ref(input) {
	                _this6.input = input;
	              }
	            })
	          );
	      }
	    }, _temp2), _possibleConstructorReturn(_this6, _ret2);
	  }
	
	  _createClass(DialogInput, [{
	    key: 'render',
	    value: function render() {
	      var _props$label = this.props.label,
	          label = _props$label === undefined ? '' : _props$label;
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'field dialog-input' },
	        _react2.default.createElement(
	          'label',
	          { className: 'field-label' },
	          label
	        ),
	        this.getFieldType()
	      );
	    }
	  }]);
	
	  return DialogInput;
	}(_react.Component);
	
	var ControlledModal = function ControlledModal(_ref6) {
	  var initialIsOpen = _ref6.isOpen,
	      onModalClosed = _ref6.onModalClosed,
	      onRequestModalClose = _ref6.onRequestModalClose,
	      children = _ref6.children,
	      title = _ref6.title,
	      _ref6$size = _ref6.size,
	      size = _ref6$size === undefined ? 'small' : _ref6$size,
	      _ref6$closeButton = _ref6.closeButton,
	      closeButton = _ref6$closeButton === undefined ? true : _ref6$closeButton,
	      _ref6$autoHeight = _ref6.autoHeight,
	      autoHeight = _ref6$autoHeight === undefined ? true : _ref6$autoHeight,
	      _ref6$noSaveOnClose = _ref6.noSaveOnClose,
	      noSaveOnClose = _ref6$noSaveOnClose === undefined ? false : _ref6$noSaveOnClose,
	      restProps = _objectWithoutProperties(_ref6, ['isOpen', 'onModalClosed', 'onRequestModalClose', 'children', 'title', 'size', 'closeButton', 'autoHeight', 'noSaveOnClose']);
	
	  var _React$useState = _react2.default.useState(initialIsOpen),
	      _React$useState2 = _slicedToArray(_React$useState, 2),
	      isOpen = _React$useState2[0],
	      setIsOpen = _React$useState2[1];
	
	  var modal = _react2.default.useRef();
	
	  _react2.default.useEffect(function () {
	    if (initialIsOpen && !isOpen) {
	      setIsOpen(true);
	    } else if (!initialIsOpen && isOpen) {
	      modal.current.closeModal(function () {
	        setIsOpen(false);
	      }, noSaveOnClose);
	    }
	  }, [initialIsOpen]);
	
	  return _react2.default.createElement(
	    _Portal2.default,
	    { isOpened: isOpen },
	    _react2.default.createElement(
	      Modal,
	      Object.assign({
	        title: title,
	        closeModal: function closeModal() {
	          setIsOpen(false);
	          onModalClosed();
	        },
	        modalSize: size,
	        closeButton: closeButton,
	        autoHeight: autoHeight,
	        ref: modal
	      }, restProps),
	      children
	    )
	  );
	};
	exports.ControlledModal = ControlledModal;
	ControlledModal.propTypes = {
	  isOpen: _propTypes2.default.bool.isRequired,
	  onModalClosed: _propTypes2.default.func.isRequired,
	  onRequestModalClose: _propTypes2.default.func,
	  children: _propTypes2.default.oneOfType([_propTypes2.default.node, _propTypes2.default.func])
	};

/***/ },
/* 14 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.TimeInput = exports.MINUTE_OPTIONS = exports.HOUR_OPTIONS = exports.NameOrg = exports.FullNameDisplay = exports.FullName = exports.ConfirmFields = exports.DateInput = exports.Checkbox = exports.RadioInput = exports.Select = exports.TextArea = exports.TextInput = undefined;
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRadioGroup = __webpack_require__(1168);
	
	var _reactDatepicker = __webpack_require__(1290);
	
	var _reactDatepicker2 = _interopRequireDefault(_reactDatepicker);
	
	var _format = __webpack_require__(33);
	
	var _format2 = _interopRequireDefault(_format);
	
	var _isDate = __webpack_require__(274);
	
	var _isDate2 = _interopRequireDefault(_isDate);
	
	var _isValid = __webpack_require__(43);
	
	var _isValid2 = _interopRequireDefault(_isValid);
	
	var _Field = __webpack_require__(25);
	
	var _Tooltip = __webpack_require__(305);
	
	var _Tooltip2 = _interopRequireDefault(_Tooltip);
	
	var _Portal = __webpack_require__(12);
	
	var _Portal2 = _interopRequireDefault(_Portal);
	
	var _shortid = __webpack_require__(22);
	
	var _shortid2 = _interopRequireDefault(_shortid);
	
	var _calendar = __webpack_require__(221);
	
	var _calendar2 = _interopRequireDefault(_calendar);
	
	var _MountDetector = __webpack_require__(299);
	
	var _MountDetector2 = _interopRequireDefault(_MountDetector);
	
	__webpack_require__(1026);
	
	var _utilities = __webpack_require__(8);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var DEFAULT_INPUT_MAX_LENGTH = ({"NODE_ENV":"production","BUILD_DATE":"2025-08-27T15:15:31.687Z","BUILD_NUMBER":"Not Provided","GIT_VERSION":"v1.3.0-381-ga81e29b08","GIT_COMMIT_HASH":"a81e29b085c9268ffd96c78eb734365802722741","GIT_BRANCH":"beta","PUBLIC_URL":"","STATE_ABBR":"MT","STATE_NAME":"Montana","STATE_ORG_TITLE":"Secretary of State","LOGIN_HEADER_IMG_PATH":"","HOME_IMG_FILENAME":"montana.jpg","FAVICON_FILE_NAME":"favicon.ico","ALLOW_E_SIGN_ON_CORRECTIONS":true,"THIRD_PARTY_SIGNING_ALLOWED":false,"MY_ACCOUNT_SAVE_AND_CLOSE_BUTTON":true,"IE_DEPRECATED_MESSAGE":"Internet Explorer is not supported. Please select a supported browser below to access this website.","ADDITIONAL_ROUTES":{"dataRequests":true,"farmBill":true,"apostille":true,"externalHelp":"https://sosmt.gov/business/help-center/","systemAdministration":[{"title":"Saved Payments","parameter":"saved-payments","componentName":"SavedPayments"}]},"SUBROUTES":[{"label":"Business","component":"Business","parameter":"business","myWorkQueueSearch":false,"sourceTypeId":54,"searchMustHaveOneOf":["FILING_TYPE_ID","STATUS_ID","STATE","search"],"serverWebSearchDescription":true,"serverWorkQueueDescription":true,"serverMyRecordsDescription":true,"searchPlaceholder":"Search by name or filing number (X########)","allowEmptySearchTerm":true,"requestCertificateAlternateLabel":"Request Information","fileAmendmentButtonLabel":"Filing Actions","advancedSearchParameters":[{"type":"radio","name":"QUERY_TYPE_ID","defaultValue":1010,"options":[{"value":1010,"label":"Starts with"},{"value":1011,"label":"Contains"},{"value":1012,"label":" Word Contains"}]},{"type":"serverSelect","name":"FILING_TYPE_ID","optionsSrc":"FILING_TYPES","label":"Entity Type","placeholder":"All","defaultValue":"0"},{"type":"serverSelect","name":"FILING_SUBTYPE_ID","optionsSrc":"FILING_SUBTYPES","label":"Entity Subtype","overrideSubOptionsSrcFromParameterName":"FILING_TYPE_ID","placeholder":"All","defaultValue":"0"},{"type":"serverSelect","name":"STATUS_ID","optionsSrc":"FILING_STATUS_WITHOUT_ALL","label":"Status","placeholder":"All","defaultValue":"0"},{"type":"serverSelect","name":"STATE","optionsSrc":"STATE","label":"State","placeholder":"All","defaultValue":""},{"type":"serverSelect","name":"COUNTY","optionsSrc":"COUNTY_SUBOPTION","label":"County","overrideSubOptionsSrcFromParameterName":"STATE","placeholder":"All","defaultValue":""},{"type":"checkbox","name":"CRA_SEARCH_YN","defaultValue":false,"label":"Search by Registered Agent PID"},{"type":"dateRange","name":"FILING_DATE","label":"Registration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}},{"type":"dateRange","name":"EXPIRATION_DATE","label":"Expiration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}}],"myRecordsFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Active"},{"value":2,"label":"Inactive"},{"value":3,"label":"Pending"}]},{"type":"dateRange","name":"DATE_RANGE","label":"Date range","defaultValue":{"start":null,"end":null}}],"myWorkQueueFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Approved"},{"value":2,"label":"Pending Online Payment"},{"value":3,"label":"Pending Review"},{"value":4,"label":"Needs Correction"},{"value":5,"label":"Rejected"},{"value":6,"label":"Draft"}]},{"type":"dateRange","name":"DATE_RANGE","label":"Date range","defaultValue":{"start":null,"end":null}}]},{"label":"Notary","component":"Notary","parameter":"notary","sourceTypeId":850,"myWorkQueueSearch":false,"allowEmptySearchTerm":true,"requestCertificateAlternateLabel":"Download Certificate","fileAmendmentButtonLabel":"Filing Actions","hideNameRequestCertificate":true,"hideAddressRequestCertificate":true,"hideRecordUserManagment":true,"searchPlaceholder":"Search by name or commission number","searchMustHaveOneOf":["CITY","search","SERVICE_TYPE"],"advancedParametersStartOpen":true,"searchIsSortable":true,"advancedSearchParameters":[{"type":"radio","name":"STARTS_WITH_YN","defaultValue":false,"options":[{"value":true,"label":"Starts with"},{"value":false,"label":"Contains"}]},{"type":"checkbox","name":"ACTIVE_ONLY_YN","defaultValue":true,"label":"Active entities only"},{"type":"text","name":"CITY","defaultValue":"","label":"City"},{"type":"select","name":"SERVICE_TYPE","label":"Special Services Offered","defaultValue":0,"options":[{"value":0,"label":"(N/A)"},{"value":6165,"label":"In-Person Electronic Notarization (IPEN)"},{"value":6166,"label":"Remote Online Notarization (RON)"},{"value":6167,"label":"Mobile Notary Services"},{"value":6168,"label":"Remote Ink Notarization (RIN)"}]}]},{"label":"Apostille","component":"Apostille","parameter":"apostille","sourceTypeId":720,"myRecordsSearch":false,"myWorkQueueSearch":false,"disabled":false,"allowedRoutes":["/forms-manager/","/queue/","/forms/"]},{"label":"Liens","component":"UCC","parameter":"ucc","sourceTypeId":1999,"myRecordsSearch":true,"myWorkQueueSearch":true,"fileAmendmentButtonLabel":"Filing Actions","searchPlaceholder":"Search by name or file number","disabled":false,"serverWebSearchDescription":true,"myRecordsDescription":"","workQueueDescription":"","searchDescription":"","hideRecordUserManagment":true,"searchLiensCheckout":false,"advancedSearchParameters":[{"type":"radio","name":"STARTS_WITH_YN","defaultValue":false,"options":[{"value":true,"label":"Starts with"},{"value":false,"label":"Contains"}]},{"type":"select","name":"STATUS","defaultValue":"ALL","label":"Status","options":[{"value":"ACTIVE_UNLAPSED","label":"Active (unlapsed)"},{"value":"ACTIVE_LAPSED_UNLAPSED","label":"Active (lapsed and unlapsed)"}]},{"type":"text","name":"EXCLUDE_VALUES","label":"Exclude Debtor Names (comma separated list of names to exclude)","defaultValue":""},{"type":"dateRange","name":"FILING_DATE","label":"Financing Statement Date","defaultValue":{"start":null,"end":null}},{"type":"dateRange","name":"LAPSE_DATE","label":"Lapse Date","defaultValue":{"start":null,"end":null}},{"type":"text","name":"CITY","label":"Debtor City","defaultValue":""}],"myRecordsFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Approved"},{"value":2,"label":"Pending Online Payment"},{"value":3,"label":"Pending Review"}]},{"type":"select","name":"TYPE","defaultValue":0,"label":"Lien Type","options":[{"value":0,"label":"All"},{"value":1,"label":"UCC"},{"value":2,"label":"EFS"},{"value":3,"label":"Title 71"}]}],"myWorkQueueFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Approved"},{"value":2,"label":"Pending Online Payment"},{"value":3,"label":"Pending Review"},{"value":4,"label":"Pending Print and Mail"},{"value":5,"label":"Rejected"},{"value":6,"label":"Draft"}]},{"type":"select","name":"TYPE","defaultValue":0,"label":"Lien Type","options":[{"value":0,"label":"All"},{"value":1,"label":"UCC"},{"value":2,"label":"EFS"},{"value":3,"label":"Title 71"}]}]},{"label":"Copy Request","component":"copies","parameter":"copies","sourceTypeId":2001,"myRecordsSearch":false,"myWorkQueueSearch":false,"disabled":false,"allowedRoutes":["/forms-manager/","/queue/","/forms/"]},{"label":"Trademark","component":"Trademark","parameter":"trademark","sourceTypeId":810,"showRequestCertificate":true,"searchMustHaveOneOf":["search","EXPIRATION_DATE","FILING_DATE"],"allowEmptySearchTerm":true,"requestCertificateAlternateLabel":"Request Information","fileAmendmentButtonLabel":"Filing Actions","advancedSearchParameters":[{"type":"radio","name":"QUERY_TYPE_ID","defaultValue":1010,"options":[{"value":1010,"label":"Starts with"},{"value":1011,"label":"Contains"},{"value":1012,"label":" Word Contains"}]},{"type":"checkbox","name":"OWNER_SEARCH_YN","defaultValue":false,"label":"Search owners"},{"type":"radio","name":"SERVICE_MARK_YN","label":"Mark Type","defaultValue":"","options":[{"value":"","label":"All Marks"},{"value":"Y","label":"Service Mark"},{"value":"N","label":"Trademark"}]},{"type":"serverSelect","name":"STATUS_ID","optionsSrc":"TYPE_V|TRADEMARK_STATUS_TYPE","label":"Status","placeholder":"All","defaultValue":"0"},{"type":"select","name":"DESIGN_TYPE_ID","options":[{"value":0,"label":"All"},{"value":990,"label":"Words Only"},{"value":991,"label":"Design Only"},{"value":992,"label":"Words and Design"}],"label":"Design Type","defaultValue":"0"},{"type":"dateRange","name":"FILING_DATE","label":"Registered Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}},{"type":"dateRange","name":"EXPIRATION_DATE","label":"Expiration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}}]},{"label":"Business Info Request","component":"InfoRequests","parameter":"info-request","sourceTypeId":167,"allowedRoutes":["/forms-manager/","/queue/","/forms/"]},{"label":"Data Requests","component":"DataRequests","parameter":"data-request","sourceTypeId":0,"allowedRoutes":["/forms-manager/"]},{"label":"CRA","component":"CRA","parameter":"cra","sourceTypeId":157,"myRecordsSearch":false,"searchPlaceholder":"Search by name or registered agent number","allowedRoutes":["/forms-manager/","/forms/","/records/","/queue/","/search/"],"allowEmptySearchTerm":true,"fileAmendmentButtonLabel":"Filing Actions","advancedSearchParameters":[{"type":"radio","name":"QUERY_TYPE_ID","defaultValue":1010,"options":[{"value":1010,"label":"Starts with"},{"value":1011,"label":"Contains"},{"value":1012,"label":" Word Contains"}]},{"type":"dateRange","name":"CRA_DATE","label":"Registration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}},{"type":"select","name":"STATUS_ID","label":"Status","defaultValue":0,"options":[{"value":0,"label":"All"},{"value":121,"label":"Active"},{"value":122,"label":"Inactive"}]},{"type":"select","name":"AGENT_TYPE_ID","label":"Agent Type","defaultValue":0,"options":[{"value":0,"label":"All"},{"value":460,"label":"Registered Agent"},{"value":461,"label":"Commercial Registered Agent"}]}]},{"label":"Farm Bill","component":"FarmBill","parameter":"farm-bill","path":"/lists/farm-bill","sourceTypeId":0,"myRecordsSearch":false,"allowedRules":["/search/"],"disabled":true,"searchDescription":"To perform a search, enter a debtor name. Your search results may include: exact debtor name, variations of that name and any filing that includes your search criteria. Punctuation is ignored.\n\nYou can click on \"Advanced\" to refine your search. Under “Advanced” you can search by crop, year, county and SSN/FEIN. As a registered Farm Bill Buyer with the Montana Secretary of State’s office it is important to maintain the confidentiality of the information contained within the Farm Bill Master List. The Farm Bill Master List reflects personal data, such as Social Security Numbers, which are a key piece of personal identifiable information to assist you in determining the existence of a lien against a specific debtor. The distribution of this information beyond its intended purpose is strictly prohibited.\n\nThe debtor's tax identification number has been hidden for confidentiality reasons. You may continue to search on a tax ID number and return debtors that match your search criteria. The SSN/FEIN must be entered without dashes or spaces.","searchMustHaveOneOf":["search","UCC_FARM_PRODUCT_ID","COUNTY"],"searchPlaceholder":"Search by debtor name","advancedSearchParameters":[{"type":"ServerMultiComplete","label":"Product code name(s)","name":"UCC_FARM_PRODUCT_ID","defaultValue":"","optionsSrc":"UCC_FARM_PRODUCT_V"},{"type":"MultiComplete","label":"Year or Range of Years","name":"YEAR_NUM","optionsSrc":"years","startYear":"1968","defaultValue":[],"preMergeOptions":[{"value":"ALL","label":"All"}]},{"type":"serverSelect","label":"State","name":"STATE","defaultValue":"MONTANA","optionsSrc":"STATE"},{"type":"ServerMultiComplete","label":"County","name":"COUNTY","defaultValue":[],"optionsSrc":"COUNTY","overrideSubOptionsSrcFromParameterName":"STATE"},{"type":"checkbox","name":"TIN_SEARCH_YN","defaultValue":false,"label":"Tax Identification Number Search"},{"type":"checkbox","name":"TIN_SORT_YN","defaultValue":false,"label":"Unique ID Sort"}]}],"SYSTEM_NICKNAME":"Online Services Portal","PAYMENT_METHODS":[{"type":"bypass"},{"type":"iTransact"}],"PAYMENT_ALLOW_AMEX":true,"SYSTEM_ID_LABEL":"System Id","DOUBLE_COLUMN_PUBLIC_LOGIN":true,"INTERNAL_USER_MANAGEMENT":true,"ALLOW_PUBLIC_JSON_IMPORT":false,"MAX_FILE_UPLOAD_SIZE":10000000,"REFUND_TEXT":"","RETURN_TO_HOME_ON_LOGOUT":true,"CURRENT_SOS_NAME":"Christi Jacobsen","LOGO_FILENAME":"mt-sos-logo.png","LOGO_ALT":"Christi Jacobsen, Montana Secretary of State","LOGO_FULL_WIDTH":true,"HOME_HIDE_AUTH_HINT":true,"HOME_TITLE":"Montana Secretary of State","CUSTOM_TAB_TITLE":"Official Montana","HOME_SUBTITLE":"Online Business Services","ENTITY_NAME_CONSENT_DESCRIPTION":"","ALLOW_USER_PROFILE_EDITING":true,"COMPARE_FOREIGN_NAME_IN_ENTITY_NAME_VALIDATION":true,"FOREIGN_NAME_FIELD_NAME":"KIMA_PARENT_NAME_INFO","LOGIN_TITLE":"Montana Secretary of State Online Filing Portal Login","PUBLIC_LOGIN_LABEL":"Username","REVERSE_LOGIN_COLUMNS":true,"LOGIN_SEAL_FILENAME":"seal_white.png","SEPARATE_USERNAME_AND_EMAIL":true,"CREATE_ACCOUNT_BUTTON_ALIGN_LEFT":true,"CREATE_ACCOUNT_BUTTON_TEXT":"CREATE AN ACCOUNT","PASSWORD_CUSTOM_ERROR_TEXT":"The password must meet all requirements","ACCOUNT_CREATED_MESSAGE":"Please check your email to verify your account to login and allow a few minutes for this message to arrive. Check your junk/spam folders if you do not find the email in your inbox.","PUBLIC_LOGIN_PLACEHOLDER":" ","DISABLE_DEFAULT_PAYMENT_RADIO":true,"CUSTOM_RESET_PASSWORD_ERROR_MESSAGE":"Username invalid - no account found","PUBLIC_LOGIN_CREATE_DESCRIPTION":"### Existing User:\n\n  - Enter your username and password to login.  \n\n\n  #### - OR -  \n\n\n\n  - Forgot password? Click 'Reset Password' and follow the prompts.\n  - Forgot username? Click 'Forgot Username' and follow the prompts.  \n\n\n  ### New User:\n  ","LOGIN_HELP_LINK":"https://sosmt.gov/business/how-do-i/","LOGIN_HELP_LINK_TEXT":"Need Help?","FORGOT_USERNAME_TEXT":"Forgot Username?","LOGIN_ACTIVE_DIRECTORY_TEXT":"State User Login","MULTIPLE_LOGIN_METHODS":true,"HAS_ACTIVE_DIRECTORY_LOGIN":true,"RESET_PASSWORD_WITH_USERNAME":true,"DOWNLOAD_LINK":true,"SHOW_USERNAME_ACCOUNT_CREATE":true,"SHOW_SCROLL_DOWN_ARROW":true,"SHOW_ADDRESS_ACCOUNT_CREATE":true,"TWO_COLUMN_ACCOUNT_CREATE":true,"RESET_PASSWORD_TIP":"A link to change your password has been sent to your email. Please allow a few minutes for this message to arrive. Please check your junk/spam folders if you do not find the email in your inbox.","FORGOT_PASSWORD_LINK_TEXT":"Reset Password","PHONE_NUMBER_OPTIONAL_ACCOUNT_CREATE":true,"SHOW_REQUIRED_INDICATOR_ACCOUNT_CREATE":true,"PASSWORD_REQUIREMENTS_ACCOUNT_CREATE":"\n    <ul>\n      <li>MUST contain at least 8 characters (12+ recommended)</li>\n      <li>MUST contain at least one uppercase letter.</li>\n      <li>MUST contain at least one lowercase letter.</li>\n      <li>MUST contain at least one number.</li>\n      <li>MUST contain at least one special character (!”#$%&'()*+,-./:;<=>?</li>\n    </ul>\n  ","ALLOW_CERTIFICATION_REQUEST":true,"ALLOW_PUBLIC_CERTIFICATE_REQUEST":true,"ALLOW_COPY_REQUEST":false,"ALLOW_CORRECTION_STYLING":true,"HIDE_DEPRECATION_WARNING":false,"AMEND_ROUTE_PUBLIC":true,"SEAL_FILENAME":"seal.png","SHOPPING_CART":true,"ALLOW_PAYMENT_UPDATE_WITH_EMPTY_CART":true,"RA_EMAIL":true,"RA_WEBSITE":true,"RA_NO_DEFAULT_TYPE":true,"RA_ADDRESS_LABEL":"Street Address","RA_TYPE_SELECTION_DEFAULT":true,"RA_DEFAULT_TYPE":"460","RA_OVERRIDE_TYPE_WITH_DEFAULT":true,"RA_PRINCIPAL_ADDRESS_AMS":true,"UPLOAD_AND_SUBMIT_HIDE_IF_ONE_OPTION":true,"PAYMENT_PROCESSING_MESSAGE":"Your payment is processing - Do not close your browser or click the back button","CHECKOUT_BUTTON_WHEN_PROCESSING_TEXT":"Processing","EFS_CROP_PICKER_NONE_LABEL":"Lien Duration","DISALLOWED_WIZARD_PIECES":["FormationLocale"],"REPEATER_SHOW_EDIT_BUTTON":true,"DATA_REQUEST_PAGE_TITLE":"Data Requests and Subscriptions","DATA_REQUEST_SIDEBAR_LABEL":"Data Requests & Subscriptions","LOGIN_REDIRECTS_TO_EPASS":false,"LOGIN_REDIRECTS_TO_ACTIVE_DIRECTORY":true,"LOGIN_ACTIVE_DIRECTORY_LINK":true,"FETCH_EDIT_USER_LINK":false,"LISTS_FETCH_AVAILABLE_LISTS":true,"POST_WIZARD_SUBMIT_REDIRECT_URL":"/","PIN_REQUEST_ATTESTATIONS":true,"PIN_REQUEST_DESCRIPTION":"Click **Request PIN** to have a new PIN sent to the account holder's email address on file.","OWNERSHIP_REQUEST_DESCRIPTION":"To become an **authorized user** of this record, a current **AUTHORIZED USER** will need to grant you access. To request access, click **Request Access** below.","PIN_REQUEST_SUCCESS_MESSAGE":"The PIN you have requested for this entity has been sent to the email associated with your user account.  You should receive the PIN in approximately 3-5 minutes, depending on your email service provider.","APOSTILLE_HEADER_LABEL":"Verification Information","APOSTILLE_NUMBER_LABEL":"Apostille/Authentication","APOSTILLE_CITY_STATE_OVERRIDE":"HELENA, MT","APOSTILLE_FILING_DATE_LABEL":"Issue Date","APOSTILLE_CITY_STATE_IN_CERTIFIED":true,"NOTARY_EXISTING_FILING":true,"ALLOW_REVOKE_OWN_ACCESS_ONLY":false,"HIDE_CANCEL_ON_ONETIME_DATA_REQUESTS":true,"DATA_REQUESTS_IN_SHOPPING_CART":true,"WQ_ALLOW_EDIT_PENDING_PAYMENT":true,"WQ_CONFIRM_ON_DELETE":true,"WQ_DELETE_CONFIRM_MESSAGE":"Deleting this filing will forfeit any money already paid to the Secretary of State. This action is permanent and cannot be undone, are you sure you would like to delete?","PASS_ITEM_GUIDS_ON_CHECKOUT":true,"FORM_REVISION_HISTORY":true,"CHECKOUT_DISCLAIMER":"By entering your credit card and/or checking account information you (i) state that **you are an authorized user** of the credit card and/or electronic check and that the associated information entered (e.g., account holder name, account number, billing address) is accurate, (ii) **you authorize payment processor to charge the amount you have requested** to your credit card and/or funding account, and (iii) **acknowledge if a charge is declined or reversed you may also be assessed a customary charge** by the payment processor for such transactions.","FARM_BILL_SEARCH_CONFIDENTIAL":"As a registered Farm Bill Buyer with the Montana Secretary of State’s office it is important to maintain the confidentiality of the information contained within the Farm Bill Master List. The Farm Bill Master List reflects personal data, such as Social Security Numbers, which are a key piece of personal identifiable information to assist you in determining the existence of a lien against a specific debtor. The distribution of this information beyond its intended purpose is strictly prohibited.\n\n**The debtor's tax identification number has been hidden for confidentiality reasons. You may continue to search on a tax ID number and return debtors that match your search criteria. The SSN/FEIN must be entered without dashes or spaces.  If you need access to the tax identification number to clearly identify the debtor, please contact the UCC unit at (406) 444-3665.**","VIEW_HISTORY_BUTTON_ALT_TEXT":"View Filings","WIZARD_ERROR_TITLE_MESSAGE":"Form Error","FARM_BILL_SEARCH_INTERACTIVE":true,"USE_FARM_BILL_API":true,"DISALLOW_ASSIGN_SELF_AS_RA":true,"DISALLOW_ASSIGN_SELF_AS_PRINCIPAL":true,"USE_TRADEMARK_OWNER_VALIDATION":true,"USE_ALTERNATIVE_FOREIGN_ADDRESS_LABELS":true,"MY_RECEIPTS_FILTER":[{"type":"dateRange","name":"DATE_RANGE","label":"Date range","defaultValue":{"start":null,"end":null}},{"type":"text","name":"REF_NUM","defaultValue":"","label":"Reference Number"},{"type":"text","name":"RECEIPT_NUM","defaultValue":"","label":"Receipt Id"},{"type":"text","name":"AMOUNT","defaultValue":"","label":"Amount"},{"type":"select","name":"TYPE","defaultValue":"","label":"Payment Type","options":[{"value":"","label":"All"},{"value":"CC","label":"Credit Card"},{"value":"Check","label":"Check"}]}],"MY_RECEIPTS_SHOW_IN_SIDEBAR":true,"SHOW_MY_RECEIPTS_HELPER_TEXT":true,"MY_RECEIPTS_HELPER_LABEL":"About Receipt Search","MY_RECEIPTS_HELPER_TEXT":"You can search for receipts based on their descriptions, including the items paid for on the receipt. Use the filters to search for or filter specific information.","FARM_BILL_SUBLINK":{"label":"Farm Bill","component":"FarmBill","parameter":"farm-bill","path":"/lists/farm-bill","sourceTypeId":0,"myRecordsSearch":false,"allowedRules":["/search/"],"disabled":true,"searchDescription":"To perform a search, enter a debtor name. Your search results may include: exact debtor name, variations of that name and any filing that includes your search criteria. Punctuation is ignored.\n\nYou can click on \"Advanced\" to refine your search. Under “Advanced” you can search by crop, year, county and SSN/FEIN. As a registered Farm Bill Buyer with the Montana Secretary of State’s office it is important to maintain the confidentiality of the information contained within the Farm Bill Master List. The Farm Bill Master List reflects personal data, such as Social Security Numbers, which are a key piece of personal identifiable information to assist you in determining the existence of a lien against a specific debtor. The distribution of this information beyond its intended purpose is strictly prohibited.\n\nThe debtor's tax identification number has been hidden for confidentiality reasons. You may continue to search on a tax ID number and return debtors that match your search criteria. The SSN/FEIN must be entered without dashes or spaces.","searchMustHaveOneOf":["search","UCC_FARM_PRODUCT_ID","COUNTY"],"searchPlaceholder":"Search by debtor name","advancedSearchParameters":[{"type":"ServerMultiComplete","label":"Product code name(s)","name":"UCC_FARM_PRODUCT_ID","defaultValue":"","optionsSrc":"UCC_FARM_PRODUCT_V"},{"type":"MultiComplete","label":"Year or Range of Years","name":"YEAR_NUM","optionsSrc":"years","startYear":"1968","defaultValue":[],"preMergeOptions":[{"value":"ALL","label":"All"}]},{"type":"serverSelect","label":"State","name":"STATE","defaultValue":"MONTANA","optionsSrc":"STATE"},{"type":"ServerMultiComplete","label":"County","name":"COUNTY","defaultValue":[],"optionsSrc":"COUNTY","overrideSubOptionsSrcFromParameterName":"STATE"},{"type":"checkbox","name":"TIN_SEARCH_YN","defaultValue":false,"label":"Tax Identification Number Search"},{"type":"checkbox","name":"TIN_SORT_YN","defaultValue":false,"label":"Unique ID Sort"}]},"ALLOW_ADDRESS_VALIDATION_BYPASS_OPTION":true,"DEFAULT_ADDRESS_VALIDATION_BYPASS_OPTION_CHECKED":true}).DEFAULT_INPUT_MAX_LENGTH;
	
	var TextInput = exports.TextInput = function (_Component) {
	  _inherits(TextInput, _Component);
	
	  function TextInput(props) {
	    _classCallCheck(this, TextInput);
	
	    var _this = _possibleConstructorReturn(this, (TextInput.__proto__ || Object.getPrototypeOf(TextInput)).call(this, props));
	
	    _this.hasCharacterLimitMask = function () {
	      return _this.props.mask.length === 0 ? false : _this.props.mask[0].fn === 'maxStringLength';
	    };
	
	    _this.setFieldValue = function (e) {
	      var value = e.target.value;
	      if (!_this.hasCharacterLimitMask()) {
	        value = value.slice(0, DEFAULT_INPUT_MAX_LENGTH || 256);
	      }
	      _this.props.onChange(value, e);
	      _this.preserveCursor();
	    };
	
	    _this.triggerBlur = function (e) {
	      if (_this.props.onBlur) {
	        var value = e.target.value;
	        if (!_this.hasCharacterLimitMask()) {
	          value = value.slice(0, DEFAULT_INPUT_MAX_LENGTH || 256);
	        }
	        _this.props.onBlur(value, e);
	      }
	    };
	
	    _this.onKeyPress = function (e) {
	      if (_this.props.onKeyPress) {
	        _this.props.onKeyPress(e);
	      }
	    };
	
	    _this.focus = function () {
	      _this.input.focus();
	    };
	
	    _this.blur = function () {
	      _this.input.blur();
	    };
	
	    _this.state = { selectionStart: null };
	    return _this;
	  }
	
	  _createClass(TextInput, [{
	    key: 'preserveCursor',
	    value: function preserveCursor() {
	      this.setState({ selectionStart: this.input.selectionStart });
	    }
	  }, {
	    key: 'setCursor',
	    value: function setCursor() {
	      this.input.setSelectionRange(this.state.selectionStart, this.state.selectionStart);
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate(prevProps) {
	      if (!this.props.mask.length && this.props.value !== prevProps.value && !this.props.disableSelectionRestoration) {
	        this.setCursor();
	      }
	      if (this.props.mask.length && this.props.value.length > 0 && this.props.value !== prevProps.value) {
	        this.setFieldValue({ target: { value: this.props.value } });
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _props = this.props,
	          onKeyPress = _props.onKeyPress,
	          onFocus = _props.onFocus,
	          _props$className = _props.className,
	          className = _props$className === undefined ? '' : _props$className,
	          _props$validityClass = _props.validityClass,
	          validityClass = _props$validityClass === undefined ? '' : _props$validityClass,
	          width = _props.width,
	          name = _props.name,
	          autoComplete = _props.autoComplete,
	          disabled = _props.disabled,
	          index = _props.index,
	          value = _props.value,
	          placeholder = _props.placeholder,
	          maxLength = _props.maxLength,
	          _props$textAlignment = _props.textAlignment,
	          textAlignment = _props$textAlignment === undefined ? 'left' : _props$textAlignment,
	          passwordMask = _props.passwordMask,
	          onClick = _props.onClick,
	          required = _props.required,
	          _props$fieldId = _props.fieldId,
	          fieldId = _props$fieldId === undefined ? '' : _props$fieldId,
	          ariaLabel = _props.ariaLabel,
	          tabIndex = _props.tabIndex,
	          isValid = _props.isValid,
	          _props$style = _props.style,
	          style = _props$style === undefined ? {} : _props$style;
	
	      var inputType = passwordMask ? 'password' : 'text';
	      return _react2.default.createElement(
	        'div',
	        { className: 'text-wrapper ' + className + ' ' + validityClass, style: { width: width } },
	        _react2.default.createElement('input', {
	          type: inputType,
	          onKeyPress: onKeyPress,
	          onChange: this.setFieldValue,
	          onClick: onClick ? onClick : null,
	          onBlur: this.triggerBlur,
	          onFocus: onFocus,
	          name: name,
	          autoComplete: autoComplete,
	          disabled: disabled,
	          'data-index': index,
	          value: value ? value : '',
	          placeholder: placeholder,
	          'aria-required': required,
	          'aria-label': ariaLabel,
	          'aria-describedby': 'field-description-' + fieldId + ' field-error-' + fieldId,
	          'aria-invalid': isValid === false,
	          id: fieldId ? 'field-' + fieldId : undefined,
	          maxLength: maxLength,
	          style: Object.assign({ textAlign: textAlignment }, style),
	          tabIndex: tabIndex,
	          ref: function ref(input) {
	            _this2.input = input;
	          }
	        })
	      );
	    }
	  }]);
	
	  return TextInput;
	}(_react.Component);
	
	TextInput.defaultProps = {
	  mask: [],
	  onBlur: function onBlur() {}
	};
	
	var TextArea = exports.TextArea = function (_Component2) {
	  _inherits(TextArea, _Component2);
	
	  function TextArea() {
	    var _ref;
	
	    var _temp, _this3, _ret;
	
	    _classCallCheck(this, TextArea);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this3 = _possibleConstructorReturn(this, (_ref = TextArea.__proto__ || Object.getPrototypeOf(TextArea)).call.apply(_ref, [this].concat(args))), _this3), _this3.hasCharacterLimitMask = function () {
	      return _this3.props.mask.length === 0 ? false : _this3.props.mask[0].fn === 'maxStringLength';
	    }, _this3.setFieldValue = function (e) {
	      var value = e.target.value;
	      if (!_this3.hasCharacterLimitMask()) {
	        value = value.slice(0, 1000);
	      }
	      _this3.props.onChange(value, e);
	    }, _this3.triggerBlur = function (e) {
	      if (_this3.props.onBlur) {
	        var value = e.target.value;
	        if (!_this3.hasCharacterLimitMask()) {
	          value = value.slice(0, 1000);
	        }
	        _this3.props.onBlur(value, e);
	      }
	    }, _this3.focus = function () {
	      _this3.input.focus();
	    }, _temp), _possibleConstructorReturn(_this3, _ret);
	  }
	
	  _createClass(TextArea, [{
	    key: 'render',
	    value: function render() {
	      var _this4 = this;
	
	      var props = this.props;
	      return _react2.default.createElement(
	        'div',
	        {
	          className: 'text-wrapper ' + props.className + ' ' + props.validityClass,
	          style: { width: props.width }
	        },
	        _react2.default.createElement('textarea', {
	          id: 'field-' + props.fieldId,
	          rows: props.rows,
	          onChange: this.setFieldValue,
	          onBlur: this.triggerBlur,
	          onFocus: this.props.onFocus,
	          name: props.name,
	          autoComplete: props.autoComplete,
	          disabled: props.disabled,
	          'data-index': props.index,
	          value: props.value,
	          placeholder: props.placeholder
	          // required={props.required}
	          , 'aria-describedby': 'field-description-' + props.fieldId + ' field-error-' + props.fieldId,
	          'aria-required': props.required,
	          'aria-invalid': props.isValid === false,
	          ref: function ref(input) {
	            _this4.input = input;
	          }
	        })
	      );
	    }
	  }]);
	
	  return TextArea;
	}(_react.Component);
	
	TextArea.defaultProps = {
	  mask: []
	};
	
	var Select = exports.Select = function (_Component3) {
	  _inherits(Select, _Component3);
	
	  function Select(props) {
	    _classCallCheck(this, Select);
	
	    var _this5 = _possibleConstructorReturn(this, (Select.__proto__ || Object.getPrototypeOf(Select)).call(this, props));
	
	    _this5.setFieldValue = function (e) {
	      var selectedIndex = _this5.props.options.findIndex(function (option) {
	        return option.value === e.target.value;
	      });
	      _this5.props.onChange(e.target.value, e, { selectedIndex: selectedIndex });
	    };
	
	    _this5.triggerBlur = function (e) {
	      if (_this5.props.onBlur) {
	        if (_this5.props.bubbleEvents) {
	          _this5.props.onBlur(e);
	        } else {
	          _this5.props.onBlur(e.target.value);
	        }
	      }
	    };
	
	    _this5.focus = function () {
	      _this5.input.focus();
	    };
	
	    _this5.getOptionStructure = function () {
	      var _this5$props = _this5.props,
	          options = _this5$props.options,
	          optionGroups = _this5$props.optionGroups;
	
	      var groupsObj = {};
	      var structure = [];
	
	      options.forEach(function (opt, i) {
	        var isInOptGroup = optionGroups.reduce(function (bool, optg) {
	          if (i >= optg.start && i <= optg.end) {
	            return true;
	          }
	          return bool;
	        }, false);
	        if (isInOptGroup) {
	          var group = optionGroups.find(function (optg) {
	            return i >= optg.start && i <= optg.end;
	          });
	          groupsObj = Object.assign({}, groupsObj, _defineProperty({}, group.id, Object.assign({}, group, groupsObj[group.id], {
	            options: [].concat(_toConsumableArray((groupsObj[group.id] || {}).options || {}), [Object.assign({}, opt)])
	          })));
	          if (!structure.find(function (x) {
	            return x.type === 'group' && x.id === group.id;
	          })) {
	            structure.push({ type: 'group', id: group.id });
	          }
	        } else {
	          structure.push(Object.assign({}, opt, { type: 'option' }));
	        }
	      });
	      var combinedStrucuture = structure.map(function (x) {
	        if (x.type === 'option') {
	          return x;
	        } else {
	          return Object.assign({}, x, groupsObj[x.id]);
	        }
	      });
	      return combinedStrucuture;
	    };
	
	    _this5.id = props.fieldId || _shortid2.default.generate();
	    return _this5;
	  }
	
	  _createClass(Select, [{
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate(prevProps) {
	      if (this.props.options.length !== prevProps.options.length) {
	        this.setFieldValue({ target: { value: this.props.value } });
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this6 = this;
	
	      var _props2 = this.props,
	          _props2$className = _props2.className,
	          className = _props2$className === undefined ? '' : _props2$className,
	          _props2$validityClass = _props2.validityClass,
	          validityClass = _props2$validityClass === undefined ? '' : _props2$validityClass,
	          name = _props2.name,
	          _props2$value = _props2.value,
	          value = _props2$value === undefined ? '' : _props2$value,
	          width = _props2.width,
	          _props2$options = _props2.options,
	          options = _props2$options === undefined ? [] : _props2$options,
	          optionGroups = _props2.optionGroups,
	          disabled = _props2.disabled,
	          fieldId = _props2.fieldId,
	          required = _props2.required,
	          ariaLabel = _props2.ariaLabel,
	          tabIndex = _props2.tabIndex,
	          isValid = _props2.isValid;
	
	      return _react2.default.createElement(
	        'select',
	        {
	          className: 'text-wrapper ' + className + ' ' + validityClass,
	          value: value ? value.toString() : value,
	          disabled: disabled,
	          'aria-required': required,
	          'aria-label': ariaLabel,
	          'aria-describedby': 'field-description-' + fieldId + ' field-error-' + fieldId,
	          'aria-invalid': isValid === false,
	          name: name,
	          onChange: this.setFieldValue,
	          onBlur: this.triggerBlur,
	          style: { width: width },
	          id: 'field-' + fieldId,
	          tabIndex: tabIndex,
	          ref: function ref(input) {
	            _this6.input = input;
	          }
	        },
	        optionGroups ? this.getOptionStructure().map(function (x, i) {
	          if (x.type === 'option') {
	            return _react2.default.createElement(
	              'option',
	              { value: x.value.toString(), disabled: x.disabled, hidden: x.hidden, key: i },
	              x.label
	            );
	          } else {
	            return _react2.default.createElement(
	              'optgroup',
	              { label: x.label, key: i },
	              x.options.map(function (opt, k) {
	                return _react2.default.createElement(
	                  'option',
	                  { value: opt.value.toString(), key: k },
	                  opt.label
	                );
	              })
	            );
	          }
	        }) : options.map(function (option, i) {
	          return _react2.default.createElement(
	            'option',
	            { disabled: option.disabled, value: option.value.toString(), hidden: option.hidden, key: i },
	            option.label
	          );
	        })
	      );
	    }
	  }]);
	
	  return Select;
	}(_react.Component);
	
	var RadioInput = exports.RadioInput = function (_Component4) {
	  _inherits(RadioInput, _Component4);
	
	  function RadioInput(props) {
	    _classCallCheck(this, RadioInput);
	
	    var _this7 = _possibleConstructorReturn(this, (RadioInput.__proto__ || Object.getPrototypeOf(RadioInput)).call(this, props));
	
	    _this7.focus = function () {
	      _this7.radio.focus();
	    };
	
	    _this7.setFieldValue = function (e) {
	      var selectedIndex = _this7.props.options.findIndex(function (option) {
	        return option.value === e;
	      });
	      _this7.props.onChange(e, { target: { value: e, name: _this7.props.name } }, { selectedIndex: selectedIndex });
	    };
	
	    _this7.setRef = function (radio) {
	      _this7.radio = radio;
	    };
	
	    _this7.id = props.fieldId || _shortid2.default.generate();
	    return _this7;
	  }
	
	  _createClass(RadioInput, [{
	    key: 'render',
	    value: function render() {
	      var _this8 = this;
	
	      var _props3 = this.props,
	          _props3$value = _props3.value,
	          value = _props3$value === undefined ? '' : _props3$value,
	          disabled = _props3.disabled,
	          _props3$options = _props3.options,
	          options = _props3$options === undefined ? [] : _props3$options,
	          name = _props3.name,
	          leftAlign = _props3.leftAlign,
	          fieldId = _props3.fieldId,
	          label = _props3.label,
	          required = _props3.required,
	          tabIndex = _props3.tabIndex,
	          isValid = _props3.isValid;
	
	      return _react2.default.createElement(
	        'fieldset',
	        { 'aria-required': required },
	        _react2.default.createElement(
	          'legend',
	          { className: 'visually-hidden' },
	          label
	        ),
	        _react2.default.createElement(
	          _reactRadioGroup.RadioGroup,
	          {
	            id: 'field-' + fieldId,
	            name: name,
	            selectedValue: value.toString(),
	            className: 'radio-group ' + (disabled ? 'disabled' : ''),
	            onChange: this.setFieldValue,
	            tabIndex: tabIndex,
	            'aria-describedby': 'field-description-' + fieldId + ' field-error-' + fieldId,
	            'aria-invalid': isValid === false
	          },
	          options.map(function (option, i) {
	            return _react2.default.createElement(
	              'div',
	              { className: 'option-wrapper ' + (leftAlign ? 'left-align' : ''), key: i },
	              _react2.default.createElement(_reactRadioGroup.Radio, {
	                innerRef: function innerRef(ref) {
	                  if (i === 0) {
	                    _this8.setRef(ref);
	                  }
	                },
	                name: _this8.id,
	                id: _this8.id + i,
	                value: option.value.toString(),
	                disabled: disabled,
	                tabIndex: tabIndex,
	                key: i
	              }),
	              _react2.default.createElement(
	                'label',
	                { className: 'field-label radio-label', htmlFor: _this8.id + i },
	                option.label
	              )
	            );
	          })
	        )
	      );
	    }
	  }]);
	
	  return RadioInput;
	}(_react.Component);
	
	var Checkbox = exports.Checkbox = function (_Component5) {
	  _inherits(Checkbox, _Component5);
	
	  function Checkbox() {
	    var _ref2;
	
	    var _temp2, _this9, _ret2;
	
	    _classCallCheck(this, Checkbox);
	
	    for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
	      args[_key2] = arguments[_key2];
	    }
	
	    return _ret2 = (_temp2 = (_this9 = _possibleConstructorReturn(this, (_ref2 = Checkbox.__proto__ || Object.getPrototypeOf(Checkbox)).call.apply(_ref2, [this].concat(args))), _this9), _this9.setFieldValue = function (e) {
	      _this9.props.onChange(e.target.checked, e);
	    }, _this9.focus = function () {
	      _this9.check.focus();
	    }, _temp2), _possibleConstructorReturn(_this9, _ret2);
	  }
	
	  _createClass(Checkbox, [{
	    key: 'render',
	    value: function render() {
	      var _this10 = this;
	
	      var _props4 = this.props,
	          name = _props4.name,
	          value = _props4.value,
	          _props4$label = _props4.label,
	          label = _props4$label === undefined ? '' : _props4$label,
	          required = _props4.required,
	          disabled = _props4.disabled,
	          tooltip = _props4.tooltip,
	          _props4$fieldId = _props4.fieldId,
	          fieldId = _props4$fieldId === undefined ? '' : _props4$fieldId,
	          tabIndex = _props4.tabIndex,
	          isValid = _props4.isValid;
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'checkbox-wrapper' },
	        _react2.default.createElement('input', {
	          id: fieldId ? 'field-' + fieldId : undefined,
	          name: name,
	          type: 'checkbox',
	          disabled: disabled,
	          onChange: this.setFieldValue,
	          checked: value,
	          'aria-label': label ? label : undefined,
	          'aria-required': required,
	          'aria-describedby': 'field-description-' + fieldId + ' field-error-' + fieldId,
	          'aria-invalid': isValid === false,
	          tabIndex: tabIndex,
	          ref: function ref(check) {
	            _this10.check = check;
	          }
	          // aria-labelledby={fieldId ? `label-${fieldId}` : undefined}
	        }),
	        _react2.default.createElement('label', { className: 'checkbox-box', htmlFor: fieldId ? 'field-' + fieldId : undefined }),
	        _react2.default.createElement(
	          'label',
	          {
	            className: 'checkbox-label',
	            htmlFor: fieldId ? 'field-' + fieldId : undefined,
	            id: fieldId ? 'label-' + fieldId : undefined
	          },
	          label,
	          required ? _react2.default.createElement(
	            'span',
	            { className: 'required' },
	            '*'
	          ) : null,
	          tooltip !== '' && tooltip ? _react2.default.createElement(_Tooltip2.default, { tooltip: tooltip }) : null
	        )
	      );
	    }
	  }]);
	
	  return Checkbox;
	}(_react.Component);
	
	var DateInput = exports.DateInput = function (_Component6) {
	  _inherits(DateInput, _Component6);
	
	  function DateInput() {
	    var _ref3;
	
	    var _temp3, _this11, _ret3;
	
	    _classCallCheck(this, DateInput);
	
	    for (var _len3 = arguments.length, args = Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
	      args[_key3] = arguments[_key3];
	    }
	
	    return _ret3 = (_temp3 = (_this11 = _possibleConstructorReturn(this, (_ref3 = DateInput.__proto__ || Object.getPrototypeOf(DateInput)).call.apply(_ref3, [this].concat(args))), _this11), _this11.state = {
	      open: false
	    }, _this11.pickDate = function (e, _, skipClose) {
	      if (!skipClose) {
	        _this11.closePicker();
	      }
	      var isDateObject = (0, _isDate2.default)(e);
	      var value = isDateObject ? (0, _format2.default)(e, 'MM/dd/yyyy') : e;
	      _this11.props.onChange(value, { target: { value: value, name: _this11.props.name } });
	      if (_this11.props.onButtonClicked) {
	        _this11.props.onButtonClicked(value);
	      }
	    }, _this11.setFieldValue = function () {
	      var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
	      var e = arguments[1];
	
	      var v = value.replace(/\D/g, '');
	      if (v.length >= 5) {
	        v = v.slice(0, 2) + '/' + v.slice(2, 4) + '/' + v.slice(4);
	      } else if (v.length >= 3) {
	        v = v.slice(0, 2) + '/' + v.slice(2);
	      }
	      v = v.slice(0, 10);
	      _this11.props.onChange(v, e);
	    }, _this11.handleBlur = function (value, e) {
	      if (value && value.length >= 10 && (0, _isValid2.default)(new Date(value))) {
	        if (_this11.props.onBlur) {
	          _this11.props.onBlur((0, _format2.default)(new Date(value), 'MM/dd/yyyy'), e);
	        }
	      } else {
	        _this11.props.onChange(null, e);
	        if (_this11.props.onBlur) {
	          _this11.props.onBlur(null, e);
	        }
	      }
	    }, _this11.openPicker = function () {
	      _this11.textInput.blur();
	      _this11.setState({
	        open: true
	      });
	      if (_this11.props.onPickerOpened) _this11.props.onPickerOpened();
	    }, _this11.closePicker = function () {
	      _this11.textInput.focus();
	      _this11.setState({
	        open: false
	      });
	      if (_this11.props.onPickerClosed) _this11.props.onPickerClosed();
	    }, _this11.setToday = function () {
	      var today = void 0;
	      var stateTimeZone = ({"NODE_ENV":"production","BUILD_DATE":"2025-08-27T15:15:31.687Z","BUILD_NUMBER":"Not Provided","GIT_VERSION":"v1.3.0-381-ga81e29b08","GIT_COMMIT_HASH":"a81e29b085c9268ffd96c78eb734365802722741","GIT_BRANCH":"beta","PUBLIC_URL":"","STATE_ABBR":"MT","STATE_NAME":"Montana","STATE_ORG_TITLE":"Secretary of State","LOGIN_HEADER_IMG_PATH":"","HOME_IMG_FILENAME":"montana.jpg","FAVICON_FILE_NAME":"favicon.ico","ALLOW_E_SIGN_ON_CORRECTIONS":true,"THIRD_PARTY_SIGNING_ALLOWED":false,"MY_ACCOUNT_SAVE_AND_CLOSE_BUTTON":true,"IE_DEPRECATED_MESSAGE":"Internet Explorer is not supported. Please select a supported browser below to access this website.","ADDITIONAL_ROUTES":{"dataRequests":true,"farmBill":true,"apostille":true,"externalHelp":"https://sosmt.gov/business/help-center/","systemAdministration":[{"title":"Saved Payments","parameter":"saved-payments","componentName":"SavedPayments"}]},"SUBROUTES":[{"label":"Business","component":"Business","parameter":"business","myWorkQueueSearch":false,"sourceTypeId":54,"searchMustHaveOneOf":["FILING_TYPE_ID","STATUS_ID","STATE","search"],"serverWebSearchDescription":true,"serverWorkQueueDescription":true,"serverMyRecordsDescription":true,"searchPlaceholder":"Search by name or filing number (X########)","allowEmptySearchTerm":true,"requestCertificateAlternateLabel":"Request Information","fileAmendmentButtonLabel":"Filing Actions","advancedSearchParameters":[{"type":"radio","name":"QUERY_TYPE_ID","defaultValue":1010,"options":[{"value":1010,"label":"Starts with"},{"value":1011,"label":"Contains"},{"value":1012,"label":" Word Contains"}]},{"type":"serverSelect","name":"FILING_TYPE_ID","optionsSrc":"FILING_TYPES","label":"Entity Type","placeholder":"All","defaultValue":"0"},{"type":"serverSelect","name":"FILING_SUBTYPE_ID","optionsSrc":"FILING_SUBTYPES","label":"Entity Subtype","overrideSubOptionsSrcFromParameterName":"FILING_TYPE_ID","placeholder":"All","defaultValue":"0"},{"type":"serverSelect","name":"STATUS_ID","optionsSrc":"FILING_STATUS_WITHOUT_ALL","label":"Status","placeholder":"All","defaultValue":"0"},{"type":"serverSelect","name":"STATE","optionsSrc":"STATE","label":"State","placeholder":"All","defaultValue":""},{"type":"serverSelect","name":"COUNTY","optionsSrc":"COUNTY_SUBOPTION","label":"County","overrideSubOptionsSrcFromParameterName":"STATE","placeholder":"All","defaultValue":""},{"type":"checkbox","name":"CRA_SEARCH_YN","defaultValue":false,"label":"Search by Registered Agent PID"},{"type":"dateRange","name":"FILING_DATE","label":"Registration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}},{"type":"dateRange","name":"EXPIRATION_DATE","label":"Expiration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}}],"myRecordsFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Active"},{"value":2,"label":"Inactive"},{"value":3,"label":"Pending"}]},{"type":"dateRange","name":"DATE_RANGE","label":"Date range","defaultValue":{"start":null,"end":null}}],"myWorkQueueFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Approved"},{"value":2,"label":"Pending Online Payment"},{"value":3,"label":"Pending Review"},{"value":4,"label":"Needs Correction"},{"value":5,"label":"Rejected"},{"value":6,"label":"Draft"}]},{"type":"dateRange","name":"DATE_RANGE","label":"Date range","defaultValue":{"start":null,"end":null}}]},{"label":"Notary","component":"Notary","parameter":"notary","sourceTypeId":850,"myWorkQueueSearch":false,"allowEmptySearchTerm":true,"requestCertificateAlternateLabel":"Download Certificate","fileAmendmentButtonLabel":"Filing Actions","hideNameRequestCertificate":true,"hideAddressRequestCertificate":true,"hideRecordUserManagment":true,"searchPlaceholder":"Search by name or commission number","searchMustHaveOneOf":["CITY","search","SERVICE_TYPE"],"advancedParametersStartOpen":true,"searchIsSortable":true,"advancedSearchParameters":[{"type":"radio","name":"STARTS_WITH_YN","defaultValue":false,"options":[{"value":true,"label":"Starts with"},{"value":false,"label":"Contains"}]},{"type":"checkbox","name":"ACTIVE_ONLY_YN","defaultValue":true,"label":"Active entities only"},{"type":"text","name":"CITY","defaultValue":"","label":"City"},{"type":"select","name":"SERVICE_TYPE","label":"Special Services Offered","defaultValue":0,"options":[{"value":0,"label":"(N/A)"},{"value":6165,"label":"In-Person Electronic Notarization (IPEN)"},{"value":6166,"label":"Remote Online Notarization (RON)"},{"value":6167,"label":"Mobile Notary Services"},{"value":6168,"label":"Remote Ink Notarization (RIN)"}]}]},{"label":"Apostille","component":"Apostille","parameter":"apostille","sourceTypeId":720,"myRecordsSearch":false,"myWorkQueueSearch":false,"disabled":false,"allowedRoutes":["/forms-manager/","/queue/","/forms/"]},{"label":"Liens","component":"UCC","parameter":"ucc","sourceTypeId":1999,"myRecordsSearch":true,"myWorkQueueSearch":true,"fileAmendmentButtonLabel":"Filing Actions","searchPlaceholder":"Search by name or file number","disabled":false,"serverWebSearchDescription":true,"myRecordsDescription":"","workQueueDescription":"","searchDescription":"","hideRecordUserManagment":true,"searchLiensCheckout":false,"advancedSearchParameters":[{"type":"radio","name":"STARTS_WITH_YN","defaultValue":false,"options":[{"value":true,"label":"Starts with"},{"value":false,"label":"Contains"}]},{"type":"select","name":"STATUS","defaultValue":"ALL","label":"Status","options":[{"value":"ACTIVE_UNLAPSED","label":"Active (unlapsed)"},{"value":"ACTIVE_LAPSED_UNLAPSED","label":"Active (lapsed and unlapsed)"}]},{"type":"text","name":"EXCLUDE_VALUES","label":"Exclude Debtor Names (comma separated list of names to exclude)","defaultValue":""},{"type":"dateRange","name":"FILING_DATE","label":"Financing Statement Date","defaultValue":{"start":null,"end":null}},{"type":"dateRange","name":"LAPSE_DATE","label":"Lapse Date","defaultValue":{"start":null,"end":null}},{"type":"text","name":"CITY","label":"Debtor City","defaultValue":""}],"myRecordsFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Approved"},{"value":2,"label":"Pending Online Payment"},{"value":3,"label":"Pending Review"}]},{"type":"select","name":"TYPE","defaultValue":0,"label":"Lien Type","options":[{"value":0,"label":"All"},{"value":1,"label":"UCC"},{"value":2,"label":"EFS"},{"value":3,"label":"Title 71"}]}],"myWorkQueueFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Approved"},{"value":2,"label":"Pending Online Payment"},{"value":3,"label":"Pending Review"},{"value":4,"label":"Pending Print and Mail"},{"value":5,"label":"Rejected"},{"value":6,"label":"Draft"}]},{"type":"select","name":"TYPE","defaultValue":0,"label":"Lien Type","options":[{"value":0,"label":"All"},{"value":1,"label":"UCC"},{"value":2,"label":"EFS"},{"value":3,"label":"Title 71"}]}]},{"label":"Copy Request","component":"copies","parameter":"copies","sourceTypeId":2001,"myRecordsSearch":false,"myWorkQueueSearch":false,"disabled":false,"allowedRoutes":["/forms-manager/","/queue/","/forms/"]},{"label":"Trademark","component":"Trademark","parameter":"trademark","sourceTypeId":810,"showRequestCertificate":true,"searchMustHaveOneOf":["search","EXPIRATION_DATE","FILING_DATE"],"allowEmptySearchTerm":true,"requestCertificateAlternateLabel":"Request Information","fileAmendmentButtonLabel":"Filing Actions","advancedSearchParameters":[{"type":"radio","name":"QUERY_TYPE_ID","defaultValue":1010,"options":[{"value":1010,"label":"Starts with"},{"value":1011,"label":"Contains"},{"value":1012,"label":" Word Contains"}]},{"type":"checkbox","name":"OWNER_SEARCH_YN","defaultValue":false,"label":"Search owners"},{"type":"radio","name":"SERVICE_MARK_YN","label":"Mark Type","defaultValue":"","options":[{"value":"","label":"All Marks"},{"value":"Y","label":"Service Mark"},{"value":"N","label":"Trademark"}]},{"type":"serverSelect","name":"STATUS_ID","optionsSrc":"TYPE_V|TRADEMARK_STATUS_TYPE","label":"Status","placeholder":"All","defaultValue":"0"},{"type":"select","name":"DESIGN_TYPE_ID","options":[{"value":0,"label":"All"},{"value":990,"label":"Words Only"},{"value":991,"label":"Design Only"},{"value":992,"label":"Words and Design"}],"label":"Design Type","defaultValue":"0"},{"type":"dateRange","name":"FILING_DATE","label":"Registered Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}},{"type":"dateRange","name":"EXPIRATION_DATE","label":"Expiration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}}]},{"label":"Business Info Request","component":"InfoRequests","parameter":"info-request","sourceTypeId":167,"allowedRoutes":["/forms-manager/","/queue/","/forms/"]},{"label":"Data Requests","component":"DataRequests","parameter":"data-request","sourceTypeId":0,"allowedRoutes":["/forms-manager/"]},{"label":"CRA","component":"CRA","parameter":"cra","sourceTypeId":157,"myRecordsSearch":false,"searchPlaceholder":"Search by name or registered agent number","allowedRoutes":["/forms-manager/","/forms/","/records/","/queue/","/search/"],"allowEmptySearchTerm":true,"fileAmendmentButtonLabel":"Filing Actions","advancedSearchParameters":[{"type":"radio","name":"QUERY_TYPE_ID","defaultValue":1010,"options":[{"value":1010,"label":"Starts with"},{"value":1011,"label":"Contains"},{"value":1012,"label":" Word Contains"}]},{"type":"dateRange","name":"CRA_DATE","label":"Registration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}},{"type":"select","name":"STATUS_ID","label":"Status","defaultValue":0,"options":[{"value":0,"label":"All"},{"value":121,"label":"Active"},{"value":122,"label":"Inactive"}]},{"type":"select","name":"AGENT_TYPE_ID","label":"Agent Type","defaultValue":0,"options":[{"value":0,"label":"All"},{"value":460,"label":"Registered Agent"},{"value":461,"label":"Commercial Registered Agent"}]}]},{"label":"Farm Bill","component":"FarmBill","parameter":"farm-bill","path":"/lists/farm-bill","sourceTypeId":0,"myRecordsSearch":false,"allowedRules":["/search/"],"disabled":true,"searchDescription":"To perform a search, enter a debtor name. Your search results may include: exact debtor name, variations of that name and any filing that includes your search criteria. Punctuation is ignored.\n\nYou can click on \"Advanced\" to refine your search. Under “Advanced” you can search by crop, year, county and SSN/FEIN. As a registered Farm Bill Buyer with the Montana Secretary of State’s office it is important to maintain the confidentiality of the information contained within the Farm Bill Master List. The Farm Bill Master List reflects personal data, such as Social Security Numbers, which are a key piece of personal identifiable information to assist you in determining the existence of a lien against a specific debtor. The distribution of this information beyond its intended purpose is strictly prohibited.\n\nThe debtor's tax identification number has been hidden for confidentiality reasons. You may continue to search on a tax ID number and return debtors that match your search criteria. The SSN/FEIN must be entered without dashes or spaces.","searchMustHaveOneOf":["search","UCC_FARM_PRODUCT_ID","COUNTY"],"searchPlaceholder":"Search by debtor name","advancedSearchParameters":[{"type":"ServerMultiComplete","label":"Product code name(s)","name":"UCC_FARM_PRODUCT_ID","defaultValue":"","optionsSrc":"UCC_FARM_PRODUCT_V"},{"type":"MultiComplete","label":"Year or Range of Years","name":"YEAR_NUM","optionsSrc":"years","startYear":"1968","defaultValue":[],"preMergeOptions":[{"value":"ALL","label":"All"}]},{"type":"serverSelect","label":"State","name":"STATE","defaultValue":"MONTANA","optionsSrc":"STATE"},{"type":"ServerMultiComplete","label":"County","name":"COUNTY","defaultValue":[],"optionsSrc":"COUNTY","overrideSubOptionsSrcFromParameterName":"STATE"},{"type":"checkbox","name":"TIN_SEARCH_YN","defaultValue":false,"label":"Tax Identification Number Search"},{"type":"checkbox","name":"TIN_SORT_YN","defaultValue":false,"label":"Unique ID Sort"}]}],"SYSTEM_NICKNAME":"Online Services Portal","PAYMENT_METHODS":[{"type":"bypass"},{"type":"iTransact"}],"PAYMENT_ALLOW_AMEX":true,"SYSTEM_ID_LABEL":"System Id","DOUBLE_COLUMN_PUBLIC_LOGIN":true,"INTERNAL_USER_MANAGEMENT":true,"ALLOW_PUBLIC_JSON_IMPORT":false,"MAX_FILE_UPLOAD_SIZE":10000000,"REFUND_TEXT":"","RETURN_TO_HOME_ON_LOGOUT":true,"CURRENT_SOS_NAME":"Christi Jacobsen","LOGO_FILENAME":"mt-sos-logo.png","LOGO_ALT":"Christi Jacobsen, Montana Secretary of State","LOGO_FULL_WIDTH":true,"HOME_HIDE_AUTH_HINT":true,"HOME_TITLE":"Montana Secretary of State","CUSTOM_TAB_TITLE":"Official Montana","HOME_SUBTITLE":"Online Business Services","ENTITY_NAME_CONSENT_DESCRIPTION":"","ALLOW_USER_PROFILE_EDITING":true,"COMPARE_FOREIGN_NAME_IN_ENTITY_NAME_VALIDATION":true,"FOREIGN_NAME_FIELD_NAME":"KIMA_PARENT_NAME_INFO","LOGIN_TITLE":"Montana Secretary of State Online Filing Portal Login","PUBLIC_LOGIN_LABEL":"Username","REVERSE_LOGIN_COLUMNS":true,"LOGIN_SEAL_FILENAME":"seal_white.png","SEPARATE_USERNAME_AND_EMAIL":true,"CREATE_ACCOUNT_BUTTON_ALIGN_LEFT":true,"CREATE_ACCOUNT_BUTTON_TEXT":"CREATE AN ACCOUNT","PASSWORD_CUSTOM_ERROR_TEXT":"The password must meet all requirements","ACCOUNT_CREATED_MESSAGE":"Please check your email to verify your account to login and allow a few minutes for this message to arrive. Check your junk/spam folders if you do not find the email in your inbox.","PUBLIC_LOGIN_PLACEHOLDER":" ","DISABLE_DEFAULT_PAYMENT_RADIO":true,"CUSTOM_RESET_PASSWORD_ERROR_MESSAGE":"Username invalid - no account found","PUBLIC_LOGIN_CREATE_DESCRIPTION":"### Existing User:\n\n  - Enter your username and password to login.  \n\n\n  #### - OR -  \n\n\n\n  - Forgot password? Click 'Reset Password' and follow the prompts.\n  - Forgot username? Click 'Forgot Username' and follow the prompts.  \n\n\n  ### New User:\n  ","LOGIN_HELP_LINK":"https://sosmt.gov/business/how-do-i/","LOGIN_HELP_LINK_TEXT":"Need Help?","FORGOT_USERNAME_TEXT":"Forgot Username?","LOGIN_ACTIVE_DIRECTORY_TEXT":"State User Login","MULTIPLE_LOGIN_METHODS":true,"HAS_ACTIVE_DIRECTORY_LOGIN":true,"RESET_PASSWORD_WITH_USERNAME":true,"DOWNLOAD_LINK":true,"SHOW_USERNAME_ACCOUNT_CREATE":true,"SHOW_SCROLL_DOWN_ARROW":true,"SHOW_ADDRESS_ACCOUNT_CREATE":true,"TWO_COLUMN_ACCOUNT_CREATE":true,"RESET_PASSWORD_TIP":"A link to change your password has been sent to your email. Please allow a few minutes for this message to arrive. Please check your junk/spam folders if you do not find the email in your inbox.","FORGOT_PASSWORD_LINK_TEXT":"Reset Password","PHONE_NUMBER_OPTIONAL_ACCOUNT_CREATE":true,"SHOW_REQUIRED_INDICATOR_ACCOUNT_CREATE":true,"PASSWORD_REQUIREMENTS_ACCOUNT_CREATE":"\n    <ul>\n      <li>MUST contain at least 8 characters (12+ recommended)</li>\n      <li>MUST contain at least one uppercase letter.</li>\n      <li>MUST contain at least one lowercase letter.</li>\n      <li>MUST contain at least one number.</li>\n      <li>MUST contain at least one special character (!”#$%&'()*+,-./:;<=>?</li>\n    </ul>\n  ","ALLOW_CERTIFICATION_REQUEST":true,"ALLOW_PUBLIC_CERTIFICATE_REQUEST":true,"ALLOW_COPY_REQUEST":false,"ALLOW_CORRECTION_STYLING":true,"HIDE_DEPRECATION_WARNING":false,"AMEND_ROUTE_PUBLIC":true,"SEAL_FILENAME":"seal.png","SHOPPING_CART":true,"ALLOW_PAYMENT_UPDATE_WITH_EMPTY_CART":true,"RA_EMAIL":true,"RA_WEBSITE":true,"RA_NO_DEFAULT_TYPE":true,"RA_ADDRESS_LABEL":"Street Address","RA_TYPE_SELECTION_DEFAULT":true,"RA_DEFAULT_TYPE":"460","RA_OVERRIDE_TYPE_WITH_DEFAULT":true,"RA_PRINCIPAL_ADDRESS_AMS":true,"UPLOAD_AND_SUBMIT_HIDE_IF_ONE_OPTION":true,"PAYMENT_PROCESSING_MESSAGE":"Your payment is processing - Do not close your browser or click the back button","CHECKOUT_BUTTON_WHEN_PROCESSING_TEXT":"Processing","EFS_CROP_PICKER_NONE_LABEL":"Lien Duration","DISALLOWED_WIZARD_PIECES":["FormationLocale"],"REPEATER_SHOW_EDIT_BUTTON":true,"DATA_REQUEST_PAGE_TITLE":"Data Requests and Subscriptions","DATA_REQUEST_SIDEBAR_LABEL":"Data Requests & Subscriptions","LOGIN_REDIRECTS_TO_EPASS":false,"LOGIN_REDIRECTS_TO_ACTIVE_DIRECTORY":true,"LOGIN_ACTIVE_DIRECTORY_LINK":true,"FETCH_EDIT_USER_LINK":false,"LISTS_FETCH_AVAILABLE_LISTS":true,"POST_WIZARD_SUBMIT_REDIRECT_URL":"/","PIN_REQUEST_ATTESTATIONS":true,"PIN_REQUEST_DESCRIPTION":"Click **Request PIN** to have a new PIN sent to the account holder's email address on file.","OWNERSHIP_REQUEST_DESCRIPTION":"To become an **authorized user** of this record, a current **AUTHORIZED USER** will need to grant you access. To request access, click **Request Access** below.","PIN_REQUEST_SUCCESS_MESSAGE":"The PIN you have requested for this entity has been sent to the email associated with your user account.  You should receive the PIN in approximately 3-5 minutes, depending on your email service provider.","APOSTILLE_HEADER_LABEL":"Verification Information","APOSTILLE_NUMBER_LABEL":"Apostille/Authentication","APOSTILLE_CITY_STATE_OVERRIDE":"HELENA, MT","APOSTILLE_FILING_DATE_LABEL":"Issue Date","APOSTILLE_CITY_STATE_IN_CERTIFIED":true,"NOTARY_EXISTING_FILING":true,"ALLOW_REVOKE_OWN_ACCESS_ONLY":false,"HIDE_CANCEL_ON_ONETIME_DATA_REQUESTS":true,"DATA_REQUESTS_IN_SHOPPING_CART":true,"WQ_ALLOW_EDIT_PENDING_PAYMENT":true,"WQ_CONFIRM_ON_DELETE":true,"WQ_DELETE_CONFIRM_MESSAGE":"Deleting this filing will forfeit any money already paid to the Secretary of State. This action is permanent and cannot be undone, are you sure you would like to delete?","PASS_ITEM_GUIDS_ON_CHECKOUT":true,"FORM_REVISION_HISTORY":true,"CHECKOUT_DISCLAIMER":"By entering your credit card and/or checking account information you (i) state that **you are an authorized user** of the credit card and/or electronic check and that the associated information entered (e.g., account holder name, account number, billing address) is accurate, (ii) **you authorize payment processor to charge the amount you have requested** to your credit card and/or funding account, and (iii) **acknowledge if a charge is declined or reversed you may also be assessed a customary charge** by the payment processor for such transactions.","FARM_BILL_SEARCH_CONFIDENTIAL":"As a registered Farm Bill Buyer with the Montana Secretary of State’s office it is important to maintain the confidentiality of the information contained within the Farm Bill Master List. The Farm Bill Master List reflects personal data, such as Social Security Numbers, which are a key piece of personal identifiable information to assist you in determining the existence of a lien against a specific debtor. The distribution of this information beyond its intended purpose is strictly prohibited.\n\n**The debtor's tax identification number has been hidden for confidentiality reasons. You may continue to search on a tax ID number and return debtors that match your search criteria. The SSN/FEIN must be entered without dashes or spaces.  If you need access to the tax identification number to clearly identify the debtor, please contact the UCC unit at (406) 444-3665.**","VIEW_HISTORY_BUTTON_ALT_TEXT":"View Filings","WIZARD_ERROR_TITLE_MESSAGE":"Form Error","FARM_BILL_SEARCH_INTERACTIVE":true,"USE_FARM_BILL_API":true,"DISALLOW_ASSIGN_SELF_AS_RA":true,"DISALLOW_ASSIGN_SELF_AS_PRINCIPAL":true,"USE_TRADEMARK_OWNER_VALIDATION":true,"USE_ALTERNATIVE_FOREIGN_ADDRESS_LABELS":true,"MY_RECEIPTS_FILTER":[{"type":"dateRange","name":"DATE_RANGE","label":"Date range","defaultValue":{"start":null,"end":null}},{"type":"text","name":"REF_NUM","defaultValue":"","label":"Reference Number"},{"type":"text","name":"RECEIPT_NUM","defaultValue":"","label":"Receipt Id"},{"type":"text","name":"AMOUNT","defaultValue":"","label":"Amount"},{"type":"select","name":"TYPE","defaultValue":"","label":"Payment Type","options":[{"value":"","label":"All"},{"value":"CC","label":"Credit Card"},{"value":"Check","label":"Check"}]}],"MY_RECEIPTS_SHOW_IN_SIDEBAR":true,"SHOW_MY_RECEIPTS_HELPER_TEXT":true,"MY_RECEIPTS_HELPER_LABEL":"About Receipt Search","MY_RECEIPTS_HELPER_TEXT":"You can search for receipts based on their descriptions, including the items paid for on the receipt. Use the filters to search for or filter specific information.","FARM_BILL_SUBLINK":{"label":"Farm Bill","component":"FarmBill","parameter":"farm-bill","path":"/lists/farm-bill","sourceTypeId":0,"myRecordsSearch":false,"allowedRules":["/search/"],"disabled":true,"searchDescription":"To perform a search, enter a debtor name. Your search results may include: exact debtor name, variations of that name and any filing that includes your search criteria. Punctuation is ignored.\n\nYou can click on \"Advanced\" to refine your search. Under “Advanced” you can search by crop, year, county and SSN/FEIN. As a registered Farm Bill Buyer with the Montana Secretary of State’s office it is important to maintain the confidentiality of the information contained within the Farm Bill Master List. The Farm Bill Master List reflects personal data, such as Social Security Numbers, which are a key piece of personal identifiable information to assist you in determining the existence of a lien against a specific debtor. The distribution of this information beyond its intended purpose is strictly prohibited.\n\nThe debtor's tax identification number has been hidden for confidentiality reasons. You may continue to search on a tax ID number and return debtors that match your search criteria. The SSN/FEIN must be entered without dashes or spaces.","searchMustHaveOneOf":["search","UCC_FARM_PRODUCT_ID","COUNTY"],"searchPlaceholder":"Search by debtor name","advancedSearchParameters":[{"type":"ServerMultiComplete","label":"Product code name(s)","name":"UCC_FARM_PRODUCT_ID","defaultValue":"","optionsSrc":"UCC_FARM_PRODUCT_V"},{"type":"MultiComplete","label":"Year or Range of Years","name":"YEAR_NUM","optionsSrc":"years","startYear":"1968","defaultValue":[],"preMergeOptions":[{"value":"ALL","label":"All"}]},{"type":"serverSelect","label":"State","name":"STATE","defaultValue":"MONTANA","optionsSrc":"STATE"},{"type":"ServerMultiComplete","label":"County","name":"COUNTY","defaultValue":[],"optionsSrc":"COUNTY","overrideSubOptionsSrcFromParameterName":"STATE"},{"type":"checkbox","name":"TIN_SEARCH_YN","defaultValue":false,"label":"Tax Identification Number Search"},{"type":"checkbox","name":"TIN_SORT_YN","defaultValue":false,"label":"Unique ID Sort"}]},"ALLOW_ADDRESS_VALIDATION_BYPASS_OPTION":true,"DEFAULT_ADDRESS_VALIDATION_BYPASS_OPTION_CHECKED":true}).STATE_TIMEZONE;
	      if (stateTimeZone) {
	        var localDate = new Date();
	        var stateLocalString = localDate.toLocaleString('en-US', { timeZone: stateTimeZone });
	        today = (0, _format2.default)(new Date(stateLocalString), 'MM/dd/yyyy');
	      } else {
	        today = (0, _format2.default)(new Date(), 'MM/dd/yyyy');
	      }
	      _this11.props.onChange(today, { target: { value: today, name: _this11.props.name } });
	      if (_this11.props.onButtonClicked) {
	        _this11.props.onButtonClicked(today);
	      }
	    }, _this11.focusDatePicker = function () {
	      var input = document.querySelector('.react-datepicker__input-container input');
	      if (input) {
	        input.focus();
	      }
	    }, _this11.checkForCalendarEscape = function (e) {
	      if (e.keyCode === 27) {
	        _this11.closePicker();
	      }
	    }, _this11.handleMonthChange = function (date) {
	      _this11.datePicker.setPreSelection(date);
	    }, _this11.handleYearChange = function (date) {
	      _this11.datePicker.setPreSelection(date);
	    }, _this11.focusPreSelection = function () {
	      var preSelection = document.querySelector('.react-datepicker__day--keyboard-selected');
	      if (preSelection) {
	        preSelection.focus();
	      }
	    }, _this11.getSanitizedDates = function (value) {
	      var inputValue = value && (0, _isValid2.default)(new Date(value)) ? (0, _format2.default)(new Date(value), 'MM/dd/yyyy') : value;
	      var date = value && (0, _isValid2.default)(new Date(value)) ? new Date(value) : null;
	      return [date, inputValue];
	    }, _temp3), _possibleConstructorReturn(_this11, _ret3);
	  }
	
	  _createClass(DateInput, [{
	    key: 'render',
	    value: function render() {
	      var _this12 = this;
	
	      var _props5 = this.props,
	          _props5$value = _props5.value,
	          value = _props5$value === undefined ? '' : _props5$value,
	          _props5$className = _props5.className,
	          className = _props5$className === undefined ? '' : _props5$className,
	          _props5$validityClass = _props5.validityClass,
	          validityClass = _props5$validityClass === undefined ? '' : _props5$validityClass,
	          disabled = _props5.disabled,
	          isFirst = _props5.isFirst,
	          minDate = _props5.minDate,
	          maxDate = _props5.maxDate,
	          width = _props5.width,
	          fieldId = _props5.fieldId,
	          required = _props5.required,
	          todayButton = _props5.todayButton,
	          tabIndex = _props5.tabIndex,
	          ariaLabel = _props5.ariaLabel,
	          buttonClassName = _props5.buttonClassName,
	          inputDisabled = _props5.inputDisabled;
	
	      var stringValue = typeof value === 'string' ? value : "";
	      var isFullDate = stringValue.length === 10;
	
	      var _ref4 = isFullDate ? this.getSanitizedDates(value) : ["", stringValue],
	          _ref5 = _slicedToArray(_ref4, 2),
	          date = _ref5[0],
	          inputValue = _ref5[1];
	
	      var _ref6 = isFullDate ? minDate ? this.getSanitizedDates(minDate) : [undefined] : "",
	          _ref7 = _slicedToArray(_ref6, 1),
	          sanitizedMinDate = _ref7[0];
	
	      var _ref8 = isFullDate ? maxDate ? this.getSanitizedDates(maxDate) : [undefined] : "",
	          _ref9 = _slicedToArray(_ref8, 1),
	          sanitizedMaxDate = _ref9[0];
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'date-picker-component', style: { position: 'relative' } },
	        _react2.default.createElement(
	          _Field.DumbField,
	          {
	            hideLabel: true,
	            width: width,
	            className: 'no-padding date-picker-input ' + validityClass,
	            fieldId: 'date-' + fieldId
	          },
	          _react2.default.createElement(TextInput, {
	            fieldId: 'date-' + fieldId,
	            className: 'date-input ' + className,
	            placeholder: 'MM/DD/YYYY',
	            onChange: this.setFieldValue,
	            value: inputValue,
	            width: '100%',
	            onBlur: this.handleBlur,
	            ref: function ref(_ref10) {
	              _this12.textInput = _ref10;
	            },
	            disabled: disabled || inputDisabled,
	            required: required,
	            tabIndex: tabIndex,
	            ariaLabel: ariaLabel,
	            disableSelectionRestoration: true
	          })
	        ),
	        todayButton && _react2.default.createElement(
	          'button',
	          {
	            type: 'button',
	            disabled: disabled,
	            className: 'btn btn-primary btn-raised picker-button text-button ' + buttonClassName,
	            onClick: this.setToday,
	            tabIndex: tabIndex,
	            'aria-label': 'Enter today\'s date for: ' + ariaLabel
	          },
	          'Today'
	        ),
	        _react2.default.createElement(
	          'button',
	          {
	            type: 'button',
	            disabled: disabled,
	            className: 'btn btn-primary btn-raised picker-button ' + buttonClassName,
	            'aria-label': 'Open calendar widget for: ' + ariaLabel,
	            onClick: this.openPicker,
	            tabIndex: tabIndex
	          },
	          _react2.default.createElement(_calendar2.default, null)
	        ),
	        _react2.default.createElement(
	          _Portal2.default,
	          { isOpened: this.state.open },
	          _react2.default.createElement(
	            'div',
	            { className: 'react-datepicker-portal', onKeyDown: this.checkForCalendarEscape },
	            _react2.default.createElement(
	              _reactDatepicker2.default,
	              {
	                inline: true,
	                customInput: _react2.default.createElement('input', { type: 'text', value: inputValue }),
	                onChange: this.pickDate,
	                dateFormat: 'M/dd/yyyy',
	                selected: date,
	                calendarClassName: 'date-pop-in-down',
	                disabled: disabled,
	                showYearDropdown: true,
	                showMonthDropdown: true,
	                dropdownMode: 'select',
	                onMonthChange: this.handleMonthChange,
	                onYearChange: this.handleYearChange,
	                placeholderText: 'MM/DD/YYYY',
	                autoFocus: isFirst ? true : false,
	                minDate: sanitizedMinDate,
	                maxDate: sanitizedMaxDate,
	                ref: function ref(datePicker) {
	                  return _this12.datePicker = datePicker;
	                }
	              },
	              _react2.default.createElement(_MountDetector2.default, { onMounted: this.focusPreSelection })
	            ),
	            _react2.default.createElement('div', {
	              className: 'shade animated fadeIn extra-fast-animation',
	              onClick: this.closePicker
	            }),
	            _react2.default.createElement(_MountDetector2.default, { onMounted: this.focusDatePicker })
	          )
	        )
	      );
	    }
	  }]);
	
	  return DateInput;
	}(_react.Component);
	
	var ConfirmFields = exports.ConfirmFields = function (_Component7) {
	  _inherits(ConfirmFields, _Component7);
	
	  function ConfirmFields() {
	    _classCallCheck(this, ConfirmFields);
	
	    var _this13 = _possibleConstructorReturn(this, (ConfirmFields.__proto__ || Object.getPrototypeOf(ConfirmFields)).call(this));
	
	    _this13.focus = function () {
	      _this13.firstInput.focus();
	    };
	
	    _this13.setFieldVal1 = function (value, e) {
	      _this13.props.onChange({ val1: value, val2: _this13.props.value.val2 }, e);
	    };
	
	    _this13.setFieldVal2 = function (value, e) {
	      _this13.props.onChange({ val1: _this13.props.value.val1, val2: value }, e);
	    };
	
	    _this13.handleFirstFocus = function (e) {
	      _this13.setState({ masked: false });
	    };
	
	    _this13.handleFirstBlur = function (e) {
	      _this13.props.onBlur(Object.assign({}, _this13.props.value, { val1: _this13.props.value.val1.trim() }), e, null, true, {
	        subField: 'first'
	      });
	    };
	
	    _this13.handleSecondFocus = function (e) {
	      _this13.setState({ masked: true });
	    };
	
	    _this13.handleSecondBlur = function (e) {
	      _this13.setState({ masked: false });
	      _this13.props.onBlur({
	        val1: _this13.props.value.val1.trim(),
	        val2: _this13.props.value.val2.trim()
	      }, e, null, true, { subField: 'second' });
	    };
	
	    _this13.getMasked = function (value) {
	      var vals = value.split(' ');
	      for (var i = 0; i < vals.length; i++) {
	        vals[i] = vals[i].replace(/./g, '•');
	      }
	      return vals.join(' ');
	    };
	
	    _this13.state = { masked: false };
	    return _this13;
	  }
	
	  _createClass(ConfirmFields, [{
	    key: 'render',
	    value: function render() {
	      var _this14 = this;
	
	      var _props6 = this.props,
	          value = _props6.value,
	          name = _props6.name,
	          required = _props6.required,
	          label = _props6.label,
	          description = _props6.description,
	          tooltip = _props6.tooltip,
	          disabled = _props6.disabled,
	          placeholder = _props6.placeholder,
	          width = _props6.width,
	          isValid = _props6.isValid,
	          confirmFieldLabel = _props6.confirmFieldLabel,
	          fieldId = _props6.fieldId,
	          _props6$match = _props6.match,
	          match = _props6$match === undefined ? null : _props6$match,
	          maskTopField = _props6.maskTopField;
	
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          _Field.DumbField,
	          {
	            type: 'text',
	            required: required,
	            label: label,
	            description: description,
	            tooltip: tooltip,
	            errorMessage: '',
	            hideLabel: false,
	            fieldId: 'field1-' + fieldId
	          },
	          _react2.default.createElement(TextInput, {
	            fieldId: 'field1-' + fieldId,
	            value: maskTopField ? this.state.masked ? this.getMasked(value.val1) : value.val1 : value.val1,
	            onChange: this.setFieldVal1,
	            onBlur: this.handleFirstBlur,
	            onFocus: this.handleFirstFocus,
	            name: name,
	            disabled: disabled,
	            placeholder: placeholder,
	            required: required,
	            width: width,
	            validityClass: (0, _Field.getValidityClass)(isValid),
	            ref: function ref(firstInput) {
	              _this14.firstInput = firstInput;
	            }
	          })
	        ),
	        _react2.default.createElement(
	          _Field.DumbField,
	          {
	            type: 'text',
	            required: required,
	            label: confirmFieldLabel,
	            description: '',
	            errorMessage: '',
	            hideLabel: false,
	            fieldId: 'field2-' + fieldId
	          },
	          _react2.default.createElement(TextInput, {
	            fieldId: 'field2-' + fieldId,
	            value: value.val2,
	            onChange: this.setFieldVal2,
	            onBlur: this.handleSecondBlur,
	            onFocus: this.handleSecondFocus,
	            name: name,
	            disabled: disabled,
	            placeholder: placeholder,
	            required: required,
	            width: width,
	            validityClass: (0, _Field.getValidityClass)(isValid === false ? false : match)
	          })
	        )
	      );
	    }
	  }]);
	
	  return ConfirmFields;
	}(_react.Component);
	
	var FullName = exports.FullName = function (_Component8) {
	  _inherits(FullName, _Component8);
	
	  function FullName() {
	    var _ref11;
	
	    var _temp4, _this15, _ret4;
	
	    _classCallCheck(this, FullName);
	
	    for (var _len4 = arguments.length, args = Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
	      args[_key4] = arguments[_key4];
	    }
	
	    return _ret4 = (_temp4 = (_this15 = _possibleConstructorReturn(this, (_ref11 = FullName.__proto__ || Object.getPrototypeOf(FullName)).call.apply(_ref11, [this].concat(args))), _this15), _this15.onChange = function (value, e) {
	      _this15.props.onChange(Object.assign({}, _this15.props.value, _defineProperty({}, e.target.name, value)), e);
	    }, _this15.onBlur = function (value, e) {
	      _this15.props.onBlur(_this15.props.value, e);
	    }, _this15.focus = function () {
	      _this15.fName.focus();
	    }, _temp4), _possibleConstructorReturn(_this15, _ret4);
	  }
	
	  _createClass(FullName, [{
	    key: 'render',
	    value: function render() {
	      var _this16 = this;
	
	      var _props7 = this.props,
	          value = _props7.value,
	          required = _props7.required,
	          isValid = _props7.isValid,
	          disabled = _props7.disabled,
	          suffix = _props7.suffix,
	          fieldId = _props7.fieldId,
	          onlyRequireLastName = _props7.onlyRequireLastName,
	          _props7$classNameMap = _props7.classNameMap,
	          classNameMap = _props7$classNameMap === undefined ? {} : _props7$classNameMap;
	
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'row' },
	        _react2.default.createElement(
	          'div',
	          { className: classNameMap.firstName || "col-sm-5 col-md-4 col-lg-3" },
	          _react2.default.createElement(
	            _Field.DumbField,
	            {
	              label: 'First Name',
	              required: required && !onlyRequireLastName,
	              description: '',
	              fieldId: 'firstname-' + fieldId
	            },
	            _react2.default.createElement(TextInput, {
	              autoComplete: 'given-name',
	              fieldId: 'firstname-' + fieldId,
	              value: value.FIRST_NAME,
	              onChange: this.onChange,
	              onBlur: _utilities.noop,
	              name: 'FIRST_NAME',
	              required: required,
	              disabled: disabled,
	              width: '100%',
	              validityClass: isValid || !onlyRequireLastName ? (0, _Field.getValidityClass)(isValid) : onlyRequireLastName ? (0, _Field.getValidityClass)(null) : (0, _Field.getValidityClass)(isValid),
	              ref: function ref(fName) {
	                _this16.fName = fName;
	              }
	            })
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: classNameMap.middleName || "col-sm-4 col-md-3 col-lg-2" },
	          _react2.default.createElement(
	            _Field.DumbField,
	            { label: 'Middle/Initial', description: '', fieldId: 'middle-' + fieldId },
	            _react2.default.createElement(TextInput, {
	              autoComplete: 'additional-name',
	              fieldId: 'middle-' + fieldId,
	              value: value.MIDDLE_NAME,
	              onChange: this.onChange,
	              onBlur: _utilities.noop,
	              name: 'MIDDLE_NAME',
	              required: required,
	              disabled: disabled,
	              width: '100%',
	              validityClass: isValid ? (0, _Field.getValidityClass)(isValid) : (0, _Field.getValidityClass)(null)
	            })
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: classNameMap.lastName || "col-sm-5 col-md-4 col-lg-3" },
	          _react2.default.createElement(
	            _Field.DumbField,
	            {
	              label: 'Last Name',
	              required: required,
	              description: '',
	              fieldId: 'lastname-' + fieldId
	            },
	            _react2.default.createElement(TextInput, {
	              autoComplete: 'family-name',
	              fieldId: 'lastname-' + fieldId,
	              value: value.LAST_NAME,
	              onChange: this.onChange,
	              onBlur: this.onBlur,
	              name: 'LAST_NAME',
	              required: required,
	              disabled: disabled,
	              width: '100%',
	              validityClass: (0, _Field.getValidityClass)(isValid)
	            })
	          )
	        ),
	        suffix && _react2.default.createElement(
	          'div',
	          { className: classNameMap.suffix || "col-sm-4 col-md-3 col-lg-2" },
	          _react2.default.createElement(
	            _Field.DumbField,
	            { label: 'Suffix', description: '', fieldId: 'suffix-' + fieldId },
	            _react2.default.createElement(TextInput, {
	              autoComplete: 'honorific-suffix',
	              fieldId: 'suffix-' + fieldId,
	              value: value.SUFFIX,
	              onChange: this.onChange,
	              onBlur: this.onBlur,
	              name: 'SUFFIX',
	              disabled: disabled,
	              width: '100%',
	              validityClass: isValid ? (0, _Field.getValidityClass)(isValid) : (0, _Field.getValidityClass)(null)
	            })
	          )
	        )
	      );
	    }
	  }]);
	
	  return FullName;
	}(_react.Component);
	
	var FullNameDisplay = exports.FullNameDisplay = function FullNameDisplay(_ref12) {
	  var value = _ref12.value;
	  return value.FIRST_NAME + (value.MIDDLE_NAME !== '' ? ' ' + value.MIDDLE_NAME + ' ' : ' ') + value.LAST_NAME + (value.SUFFIX ? ' ' + value.SUFFIX : '');
	};
	
	var NameOrg = exports.NameOrg = function (_Component9) {
	  _inherits(NameOrg, _Component9);
	
	  function NameOrg() {
	    var _ref13;
	
	    var _temp5, _this17, _ret5;
	
	    _classCallCheck(this, NameOrg);
	
	    for (var _len5 = arguments.length, args = Array(_len5), _key5 = 0; _key5 < _len5; _key5++) {
	      args[_key5] = arguments[_key5];
	    }
	
	    return _ret5 = (_temp5 = (_this17 = _possibleConstructorReturn(this, (_ref13 = NameOrg.__proto__ || Object.getPrototypeOf(NameOrg)).call.apply(_ref13, [this].concat(args))), _this17), _this17.setFieldValue = function (value, e) {
	      var val = Object.assign({}, _this17.props.value, _defineProperty({}, e.target.name, value));
	      _this17.props.onChange(val, { target: { name: _this17.props.name, value: val } });
	    }, _this17.onBlur = function (value, e) {
	      _this17.props.onBlur(_this17.props.value, e);
	    }, _this17.setNameValue = function (value, e) {
	      _this17.props.onChange(value, e);
	    }, _this17.focus = function () {
	      _this17.orgCheck.focus();
	    }, _temp5), _possibleConstructorReturn(_this17, _ret5);
	  }
	
	  _createClass(NameOrg, [{
	    key: 'render',
	    value: function render() {
	      var _this18 = this;
	
	      var _props8 = this.props,
	          value = _props8.value,
	          required = _props8.required,
	          disabled = _props8.disabled,
	          checkboxLabel = _props8.checkboxLabel,
	          fieldId = _props8.fieldId,
	          tooltip = _props8.tooltip;
	
	      var isOrganization = value.ORG_YN === 'N' || value.ORG_YN === false ? false : true;
	      return _react2.default.createElement(
	        'div',
	        { className: 'name-org-control' },
	        _react2.default.createElement(Checkbox, {
	          fieldId: fieldId,
	          value: isOrganization,
	          name: 'ORG_YN',
	          disabled: disabled,
	          label: !checkboxLabel ? 'This entity is an organization' : checkboxLabel,
	          tooltip: tooltip,
	          onChange: this.setFieldValue,
	          onBlur: this.onBlur,
	          ref: function ref(orgCheck) {
	            _this18.orgCheck = orgCheck;
	          }
	        }),
	        isOrganization ? _react2.default.createElement(
	          _Field.DumbField,
	          {
	            label: 'Organization',
	            required: required,
	            description: '',
	            fieldId: 'name-org-' + fieldId
	          },
	          _react2.default.createElement(TextInput, Object.assign({}, this.props, {
	            autoComplete: 'organization',
	            fieldId: 'name-org-' + fieldId,
	            value: value.ORG_NAME,
	            name: 'ORG_NAME',
	            onChange: this.setFieldValue,
	            onBlur: this.onBlur
	          }))
	        ) : _react2.default.createElement(FullName, Object.assign({}, this.props, { onChange: this.setNameValue, onBlur: this.onBlur }))
	      );
	    }
	  }]);
	
	  return NameOrg;
	}(_react.Component);
	
	var HOUR_OPTIONS = exports.HOUR_OPTIONS = [{ value: '', label: '--' }].concat(_toConsumableArray(Array(12).fill(null).map(function (_, i) {
	  return { value: i + 1, label: i + 1 };
	})));
	
	var MINUTE_OPTIONS = exports.MINUTE_OPTIONS = [{ value: '', label: '--' }].concat(_toConsumableArray(Array(60).fill(null).map(function (_, i) {
	  var time = i.toString().length > 1 ? i : '0' + i;
	  return { value: time, label: time };
	})));
	
	var TimeInput = exports.TimeInput = function (_Component10) {
	  _inherits(TimeInput, _Component10);
	
	  function TimeInput() {
	    var _ref14;
	
	    var _temp6, _this19, _ret6;
	
	    _classCallCheck(this, TimeInput);
	
	    for (var _len6 = arguments.length, args = Array(_len6), _key6 = 0; _key6 < _len6; _key6++) {
	      args[_key6] = arguments[_key6];
	    }
	
	    return _ret6 = (_temp6 = (_this19 = _possibleConstructorReturn(this, (_ref14 = TimeInput.__proto__ || Object.getPrototypeOf(TimeInput)).call.apply(_ref14, [this].concat(args))), _this19), _this19.getPeriod = function (v) {
	      return v.split(' ')[1];
	    }, _this19.getHour = function (v) {
	      return v.search(':') >= 0 ? v.split(':')[0] : '';
	    }, _this19.getMinutes = function (v) {
	      return (v.split(':')[1] || ' ').split(' ')[0];
	    }, _this19.onHourChange = function (hour) {
	      var value = _this19.props.value;
	
	      var period = _this19.getPeriod(value);
	      var minutes = _this19.getMinutes(value);
	      _this19.props.onChange(hour + ':' + minutes + ' ' + period);
	    }, _this19.onMinutesChange = function (minutes) {
	      var value = _this19.props.value;
	
	      var period = _this19.getPeriod(value);
	      var hour = _this19.getHour(value);
	      _this19.props.onChange(hour + ':' + minutes + ' ' + period);
	    }, _this19.onPeriodChange = function (value, splitValue, e) {
	      _this19.props.onChange(splitValue[0] + ' ' + value, e);
	    }, _this19.onBlur = function (splitValue, e) {
	      _this19.props.onBlur(_this19.props.value, e, undefined, true);
	    }, _temp6), _possibleConstructorReturn(_this19, _ret6);
	  }
	
	  _createClass(TimeInput, [{
	    key: 'render',
	    value: function render() {
	      var _this20 = this;
	
	      var _props9 = this.props,
	          fieldId = _props9.fieldId,
	          value = _props9.value,
	          disabled = _props9.disabled,
	          isValid = _props9.isValid;
	
	      var splitValue = value.split(' ');
	      return _react2.default.createElement(
	        'div',
	        { className: 'flex-row time-input' },
	        _react2.default.createElement(
	          _Field.DumbField,
	          { fieldId: 'time-' + fieldId },
	          _react2.default.createElement(Select, {
	            ariaLabel: 'Hour',
	            disabled: disabled,
	            width: '60px',
	            fieldId: 'time-hours-' + fieldId,
	            value: this.getHour(value),
	            options: HOUR_OPTIONS,
	            validityClass: (0, _Field.getValidityClass)(isValid),
	            onChange: function onChange(v, e) {
	              _this20.onHourChange(v);
	            },
	            onBlur: function onBlur(v, e) {
	              _this20.onBlur(splitValue, e);
	            }
	          })
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'colon' },
	          ' : '
	        ),
	        _react2.default.createElement(
	          _Field.DumbField,
	          { fieldId: 'time-' + fieldId },
	          _react2.default.createElement(Select, {
	            ariaLabel: 'Hour',
	            disabled: disabled,
	            width: '60px',
	            fieldId: 'time-minutes-' + fieldId,
	            value: this.getMinutes(value),
	            options: MINUTE_OPTIONS,
	            validityClass: (0, _Field.getValidityClass)(isValid),
	            onChange: function onChange(v, e) {
	              _this20.onMinutesChange(v);
	            },
	            onBlur: function onBlur(v, e) {
	              _this20.onBlur(splitValue, e);
	            }
	          })
	        ),
	        _react2.default.createElement(
	          _Field.DumbField,
	          { className: 'period-select', fieldId: 'period-' + fieldId },
	          _react2.default.createElement(Select, {
	            ariaLabel: 'Time period',
	            disabled: disabled,
	            fieldId: 'period-' + fieldId,
	            value: splitValue[1],
	            validityClass: (0, _Field.getValidityClass)(isValid),
	            options: [{ value: 'am', label: 'am' }, { value: 'pm', label: 'pm' }],
	            onChange: function onChange(v, e) {
	              _this20.onPeriodChange(v, splitValue);
	            },
	            onBlur: function onBlur(v, e) {
	              _this20.onBlur(splitValue, e);
	            }
	          })
	        )
	      );
	    }
	  }]);
	
	  return TimeInput;
	}(_react.Component);

/***/ },
/* 15 */
/***/ function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(23);
	module.exports = function (it) {
	  if (!isObject(it)) throw TypeError(it + ' is not an object!');
	  return it;
	};


/***/ },
/* 16 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
			value: true
	});
	exports.Spinner = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	__webpack_require__(1448);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Spinner = exports.Spinner = function Spinner(_ref) {
			var _ref$className = _ref.className,
			    className = _ref$className === undefined ? "" : _ref$className,
			    _ref$size = _ref.size,
			    size = _ref$size === undefined ? "" : _ref$size,
			    _ref$color = _ref.color,
			    color = _ref$color === undefined ? '' : _ref$color,
			    _ref$themeColor = _ref.themeColor,
			    themeColor = _ref$themeColor === undefined ? '' : _ref$themeColor,
			    linear = _ref.linear;
			return _react2.default.createElement(
					'div',
					{ className: 'orbit-loader ' + className + ' ' + size + ' ' + themeColor + ' ' + (linear ? 'linear' : '') },
					_react2.default.createElement('div', { className: 'top', style: { background: color } }),
					_react2.default.createElement('div', { className: 'right', style: { background: color } }),
					_react2.default.createElement('div', { className: 'bottom', style: { background: color } }),
					_react2.default.createElement('div', { className: 'left', style: { background: color } })
			);
	};

/***/ },
/* 17 */
/***/ function(module, exports) {

	// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
	var global = module.exports = typeof window != 'undefined' && window.Math == Math
	  ? window : typeof self != 'undefined' && self.Math == Math ? self
	  // eslint-disable-next-line no-new-func
	  : Function('return this')();
	if (typeof __g == 'number') __g = global; // eslint-disable-line no-undef


/***/ },
/* 18 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.history = exports.resolveFieldEngine = exports.resolveFieldLogic = undefined;
	
	var _redux = __webpack_require__(321);
	
	var _reduxThunk = __webpack_require__(1363);
	
	var _reduxThunk2 = _interopRequireDefault(_reduxThunk);
	
	var _searchReducer = __webpack_require__(1135);
	
	var _searchReducer2 = _interopRequireDefault(_searchReducer);
	
	var _FormManagerReducer = __webpack_require__(1100);
	
	var _FormManagerReducer2 = _interopRequireDefault(_FormManagerReducer);
	
	var _WizardReducer = __webpack_require__(1153);
	
	var _WizardReducer2 = _interopRequireDefault(_WizardReducer);
	
	var _DesignerReducer = __webpack_require__(1075);
	
	var _DesignerReducer2 = _interopRequireDefault(_DesignerReducer);
	
	var _FormsReducer = __webpack_require__(1102);
	
	var _FormsReducer2 = _interopRequireDefault(_FormsReducer);
	
	var _MyRecordsReducer = __webpack_require__(1116);
	
	var _MyRecordsReducer2 = _interopRequireDefault(_MyRecordsReducer);
	
	var _MyReceiptsReducer = __webpack_require__(1113);
	
	var _MyReceiptsReducer2 = _interopRequireDefault(_MyReceiptsReducer);
	
	var _MyWorkQueueReducer = __webpack_require__(1122);
	
	var _MyWorkQueueReducer2 = _interopRequireDefault(_MyWorkQueueReducer);
	
	var _HomeReducer = __webpack_require__(1105);
	
	var _HomeReducer2 = _interopRequireDefault(_HomeReducer);
	
	var _AuthReducer = __webpack_require__(1045);
	
	var _AuthReducer2 = _interopRequireDefault(_AuthReducer);
	
	var _AppSettingsReducer = __webpack_require__(1055);
	
	var _AppSettingsReducer2 = _interopRequireDefault(_AppSettingsReducer);
	
	var _AppSettingTypesReducer = __webpack_require__(1054);
	
	var _AppSettingTypesReducer2 = _interopRequireDefault(_AppSettingTypesReducer);
	
	var _connectedReactRouter = __webpack_require__(350);
	
	var _history = __webpack_require__(288);
	
	var _resolveFieldLogic = __webpack_require__(478);
	
	var _resolveFieldLogic2 = _interopRequireDefault(_resolveFieldLogic);
	
	var _localStorage = __webpack_require__(59);
	
	var _localStorage2 = _interopRequireDefault(_localStorage);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var resolveFieldLogic = exports.resolveFieldLogic = _resolveFieldLogic2.default;
	var resolveFieldEngine = exports.resolveFieldEngine = _resolveFieldLogic.engine;
	var history = exports.history = (0, _history.createBrowserHistory)();
	var routeMiddleware = (0, _connectedReactRouter.routerMiddleware)(history);
	var connectedRouter = (0, _connectedReactRouter.connectRouter)(history);
	var DEPRECATE_IE = ({"NODE_ENV":"production","BUILD_DATE":"2025-08-27T15:15:31.687Z","BUILD_NUMBER":"Not Provided","GIT_VERSION":"v1.3.0-381-ga81e29b08","GIT_COMMIT_HASH":"a81e29b085c9268ffd96c78eb734365802722741","GIT_BRANCH":"beta","PUBLIC_URL":"","STATE_ABBR":"MT","STATE_NAME":"Montana","STATE_ORG_TITLE":"Secretary of State","LOGIN_HEADER_IMG_PATH":"","HOME_IMG_FILENAME":"montana.jpg","FAVICON_FILE_NAME":"favicon.ico","ALLOW_E_SIGN_ON_CORRECTIONS":true,"THIRD_PARTY_SIGNING_ALLOWED":false,"MY_ACCOUNT_SAVE_AND_CLOSE_BUTTON":true,"IE_DEPRECATED_MESSAGE":"Internet Explorer is not supported. Please select a supported browser below to access this website.","ADDITIONAL_ROUTES":{"dataRequests":true,"farmBill":true,"apostille":true,"externalHelp":"https://sosmt.gov/business/help-center/","systemAdministration":[{"title":"Saved Payments","parameter":"saved-payments","componentName":"SavedPayments"}]},"SUBROUTES":[{"label":"Business","component":"Business","parameter":"business","myWorkQueueSearch":false,"sourceTypeId":54,"searchMustHaveOneOf":["FILING_TYPE_ID","STATUS_ID","STATE","search"],"serverWebSearchDescription":true,"serverWorkQueueDescription":true,"serverMyRecordsDescription":true,"searchPlaceholder":"Search by name or filing number (X########)","allowEmptySearchTerm":true,"requestCertificateAlternateLabel":"Request Information","fileAmendmentButtonLabel":"Filing Actions","advancedSearchParameters":[{"type":"radio","name":"QUERY_TYPE_ID","defaultValue":1010,"options":[{"value":1010,"label":"Starts with"},{"value":1011,"label":"Contains"},{"value":1012,"label":" Word Contains"}]},{"type":"serverSelect","name":"FILING_TYPE_ID","optionsSrc":"FILING_TYPES","label":"Entity Type","placeholder":"All","defaultValue":"0"},{"type":"serverSelect","name":"FILING_SUBTYPE_ID","optionsSrc":"FILING_SUBTYPES","label":"Entity Subtype","overrideSubOptionsSrcFromParameterName":"FILING_TYPE_ID","placeholder":"All","defaultValue":"0"},{"type":"serverSelect","name":"STATUS_ID","optionsSrc":"FILING_STATUS_WITHOUT_ALL","label":"Status","placeholder":"All","defaultValue":"0"},{"type":"serverSelect","name":"STATE","optionsSrc":"STATE","label":"State","placeholder":"All","defaultValue":""},{"type":"serverSelect","name":"COUNTY","optionsSrc":"COUNTY_SUBOPTION","label":"County","overrideSubOptionsSrcFromParameterName":"STATE","placeholder":"All","defaultValue":""},{"type":"checkbox","name":"CRA_SEARCH_YN","defaultValue":false,"label":"Search by Registered Agent PID"},{"type":"dateRange","name":"FILING_DATE","label":"Registration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}},{"type":"dateRange","name":"EXPIRATION_DATE","label":"Expiration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}}],"myRecordsFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Active"},{"value":2,"label":"Inactive"},{"value":3,"label":"Pending"}]},{"type":"dateRange","name":"DATE_RANGE","label":"Date range","defaultValue":{"start":null,"end":null}}],"myWorkQueueFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Approved"},{"value":2,"label":"Pending Online Payment"},{"value":3,"label":"Pending Review"},{"value":4,"label":"Needs Correction"},{"value":5,"label":"Rejected"},{"value":6,"label":"Draft"}]},{"type":"dateRange","name":"DATE_RANGE","label":"Date range","defaultValue":{"start":null,"end":null}}]},{"label":"Notary","component":"Notary","parameter":"notary","sourceTypeId":850,"myWorkQueueSearch":false,"allowEmptySearchTerm":true,"requestCertificateAlternateLabel":"Download Certificate","fileAmendmentButtonLabel":"Filing Actions","hideNameRequestCertificate":true,"hideAddressRequestCertificate":true,"hideRecordUserManagment":true,"searchPlaceholder":"Search by name or commission number","searchMustHaveOneOf":["CITY","search","SERVICE_TYPE"],"advancedParametersStartOpen":true,"searchIsSortable":true,"advancedSearchParameters":[{"type":"radio","name":"STARTS_WITH_YN","defaultValue":false,"options":[{"value":true,"label":"Starts with"},{"value":false,"label":"Contains"}]},{"type":"checkbox","name":"ACTIVE_ONLY_YN","defaultValue":true,"label":"Active entities only"},{"type":"text","name":"CITY","defaultValue":"","label":"City"},{"type":"select","name":"SERVICE_TYPE","label":"Special Services Offered","defaultValue":0,"options":[{"value":0,"label":"(N/A)"},{"value":6165,"label":"In-Person Electronic Notarization (IPEN)"},{"value":6166,"label":"Remote Online Notarization (RON)"},{"value":6167,"label":"Mobile Notary Services"},{"value":6168,"label":"Remote Ink Notarization (RIN)"}]}]},{"label":"Apostille","component":"Apostille","parameter":"apostille","sourceTypeId":720,"myRecordsSearch":false,"myWorkQueueSearch":false,"disabled":false,"allowedRoutes":["/forms-manager/","/queue/","/forms/"]},{"label":"Liens","component":"UCC","parameter":"ucc","sourceTypeId":1999,"myRecordsSearch":true,"myWorkQueueSearch":true,"fileAmendmentButtonLabel":"Filing Actions","searchPlaceholder":"Search by name or file number","disabled":false,"serverWebSearchDescription":true,"myRecordsDescription":"","workQueueDescription":"","searchDescription":"","hideRecordUserManagment":true,"searchLiensCheckout":false,"advancedSearchParameters":[{"type":"radio","name":"STARTS_WITH_YN","defaultValue":false,"options":[{"value":true,"label":"Starts with"},{"value":false,"label":"Contains"}]},{"type":"select","name":"STATUS","defaultValue":"ALL","label":"Status","options":[{"value":"ACTIVE_UNLAPSED","label":"Active (unlapsed)"},{"value":"ACTIVE_LAPSED_UNLAPSED","label":"Active (lapsed and unlapsed)"}]},{"type":"text","name":"EXCLUDE_VALUES","label":"Exclude Debtor Names (comma separated list of names to exclude)","defaultValue":""},{"type":"dateRange","name":"FILING_DATE","label":"Financing Statement Date","defaultValue":{"start":null,"end":null}},{"type":"dateRange","name":"LAPSE_DATE","label":"Lapse Date","defaultValue":{"start":null,"end":null}},{"type":"text","name":"CITY","label":"Debtor City","defaultValue":""}],"myRecordsFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Approved"},{"value":2,"label":"Pending Online Payment"},{"value":3,"label":"Pending Review"}]},{"type":"select","name":"TYPE","defaultValue":0,"label":"Lien Type","options":[{"value":0,"label":"All"},{"value":1,"label":"UCC"},{"value":2,"label":"EFS"},{"value":3,"label":"Title 71"}]}],"myWorkQueueFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Approved"},{"value":2,"label":"Pending Online Payment"},{"value":3,"label":"Pending Review"},{"value":4,"label":"Pending Print and Mail"},{"value":5,"label":"Rejected"},{"value":6,"label":"Draft"}]},{"type":"select","name":"TYPE","defaultValue":0,"label":"Lien Type","options":[{"value":0,"label":"All"},{"value":1,"label":"UCC"},{"value":2,"label":"EFS"},{"value":3,"label":"Title 71"}]}]},{"label":"Copy Request","component":"copies","parameter":"copies","sourceTypeId":2001,"myRecordsSearch":false,"myWorkQueueSearch":false,"disabled":false,"allowedRoutes":["/forms-manager/","/queue/","/forms/"]},{"label":"Trademark","component":"Trademark","parameter":"trademark","sourceTypeId":810,"showRequestCertificate":true,"searchMustHaveOneOf":["search","EXPIRATION_DATE","FILING_DATE"],"allowEmptySearchTerm":true,"requestCertificateAlternateLabel":"Request Information","fileAmendmentButtonLabel":"Filing Actions","advancedSearchParameters":[{"type":"radio","name":"QUERY_TYPE_ID","defaultValue":1010,"options":[{"value":1010,"label":"Starts with"},{"value":1011,"label":"Contains"},{"value":1012,"label":" Word Contains"}]},{"type":"checkbox","name":"OWNER_SEARCH_YN","defaultValue":false,"label":"Search owners"},{"type":"radio","name":"SERVICE_MARK_YN","label":"Mark Type","defaultValue":"","options":[{"value":"","label":"All Marks"},{"value":"Y","label":"Service Mark"},{"value":"N","label":"Trademark"}]},{"type":"serverSelect","name":"STATUS_ID","optionsSrc":"TYPE_V|TRADEMARK_STATUS_TYPE","label":"Status","placeholder":"All","defaultValue":"0"},{"type":"select","name":"DESIGN_TYPE_ID","options":[{"value":0,"label":"All"},{"value":990,"label":"Words Only"},{"value":991,"label":"Design Only"},{"value":992,"label":"Words and Design"}],"label":"Design Type","defaultValue":"0"},{"type":"dateRange","name":"FILING_DATE","label":"Registered Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}},{"type":"dateRange","name":"EXPIRATION_DATE","label":"Expiration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}}]},{"label":"Business Info Request","component":"InfoRequests","parameter":"info-request","sourceTypeId":167,"allowedRoutes":["/forms-manager/","/queue/","/forms/"]},{"label":"Data Requests","component":"DataRequests","parameter":"data-request","sourceTypeId":0,"allowedRoutes":["/forms-manager/"]},{"label":"CRA","component":"CRA","parameter":"cra","sourceTypeId":157,"myRecordsSearch":false,"searchPlaceholder":"Search by name or registered agent number","allowedRoutes":["/forms-manager/","/forms/","/records/","/queue/","/search/"],"allowEmptySearchTerm":true,"fileAmendmentButtonLabel":"Filing Actions","advancedSearchParameters":[{"type":"radio","name":"QUERY_TYPE_ID","defaultValue":1010,"options":[{"value":1010,"label":"Starts with"},{"value":1011,"label":"Contains"},{"value":1012,"label":" Word Contains"}]},{"type":"dateRange","name":"CRA_DATE","label":"Registration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}},{"type":"select","name":"STATUS_ID","label":"Status","defaultValue":0,"options":[{"value":0,"label":"All"},{"value":121,"label":"Active"},{"value":122,"label":"Inactive"}]},{"type":"select","name":"AGENT_TYPE_ID","label":"Agent Type","defaultValue":0,"options":[{"value":0,"label":"All"},{"value":460,"label":"Registered Agent"},{"value":461,"label":"Commercial Registered Agent"}]}]},{"label":"Farm Bill","component":"FarmBill","parameter":"farm-bill","path":"/lists/farm-bill","sourceTypeId":0,"myRecordsSearch":false,"allowedRules":["/search/"],"disabled":true,"searchDescription":"To perform a search, enter a debtor name. Your search results may include: exact debtor name, variations of that name and any filing that includes your search criteria. Punctuation is ignored.\n\nYou can click on \"Advanced\" to refine your search. Under “Advanced” you can search by crop, year, county and SSN/FEIN. As a registered Farm Bill Buyer with the Montana Secretary of State’s office it is important to maintain the confidentiality of the information contained within the Farm Bill Master List. The Farm Bill Master List reflects personal data, such as Social Security Numbers, which are a key piece of personal identifiable information to assist you in determining the existence of a lien against a specific debtor. The distribution of this information beyond its intended purpose is strictly prohibited.\n\nThe debtor's tax identification number has been hidden for confidentiality reasons. You may continue to search on a tax ID number and return debtors that match your search criteria. The SSN/FEIN must be entered without dashes or spaces.","searchMustHaveOneOf":["search","UCC_FARM_PRODUCT_ID","COUNTY"],"searchPlaceholder":"Search by debtor name","advancedSearchParameters":[{"type":"ServerMultiComplete","label":"Product code name(s)","name":"UCC_FARM_PRODUCT_ID","defaultValue":"","optionsSrc":"UCC_FARM_PRODUCT_V"},{"type":"MultiComplete","label":"Year or Range of Years","name":"YEAR_NUM","optionsSrc":"years","startYear":"1968","defaultValue":[],"preMergeOptions":[{"value":"ALL","label":"All"}]},{"type":"serverSelect","label":"State","name":"STATE","defaultValue":"MONTANA","optionsSrc":"STATE"},{"type":"ServerMultiComplete","label":"County","name":"COUNTY","defaultValue":[],"optionsSrc":"COUNTY","overrideSubOptionsSrcFromParameterName":"STATE"},{"type":"checkbox","name":"TIN_SEARCH_YN","defaultValue":false,"label":"Tax Identification Number Search"},{"type":"checkbox","name":"TIN_SORT_YN","defaultValue":false,"label":"Unique ID Sort"}]}],"SYSTEM_NICKNAME":"Online Services Portal","PAYMENT_METHODS":[{"type":"bypass"},{"type":"iTransact"}],"PAYMENT_ALLOW_AMEX":true,"SYSTEM_ID_LABEL":"System Id","DOUBLE_COLUMN_PUBLIC_LOGIN":true,"INTERNAL_USER_MANAGEMENT":true,"ALLOW_PUBLIC_JSON_IMPORT":false,"MAX_FILE_UPLOAD_SIZE":10000000,"REFUND_TEXT":"","RETURN_TO_HOME_ON_LOGOUT":true,"CURRENT_SOS_NAME":"Christi Jacobsen","LOGO_FILENAME":"mt-sos-logo.png","LOGO_ALT":"Christi Jacobsen, Montana Secretary of State","LOGO_FULL_WIDTH":true,"HOME_HIDE_AUTH_HINT":true,"HOME_TITLE":"Montana Secretary of State","CUSTOM_TAB_TITLE":"Official Montana","HOME_SUBTITLE":"Online Business Services","ENTITY_NAME_CONSENT_DESCRIPTION":"","ALLOW_USER_PROFILE_EDITING":true,"COMPARE_FOREIGN_NAME_IN_ENTITY_NAME_VALIDATION":true,"FOREIGN_NAME_FIELD_NAME":"KIMA_PARENT_NAME_INFO","LOGIN_TITLE":"Montana Secretary of State Online Filing Portal Login","PUBLIC_LOGIN_LABEL":"Username","REVERSE_LOGIN_COLUMNS":true,"LOGIN_SEAL_FILENAME":"seal_white.png","SEPARATE_USERNAME_AND_EMAIL":true,"CREATE_ACCOUNT_BUTTON_ALIGN_LEFT":true,"CREATE_ACCOUNT_BUTTON_TEXT":"CREATE AN ACCOUNT","PASSWORD_CUSTOM_ERROR_TEXT":"The password must meet all requirements","ACCOUNT_CREATED_MESSAGE":"Please check your email to verify your account to login and allow a few minutes for this message to arrive. Check your junk/spam folders if you do not find the email in your inbox.","PUBLIC_LOGIN_PLACEHOLDER":" ","DISABLE_DEFAULT_PAYMENT_RADIO":true,"CUSTOM_RESET_PASSWORD_ERROR_MESSAGE":"Username invalid - no account found","PUBLIC_LOGIN_CREATE_DESCRIPTION":"### Existing User:\n\n  - Enter your username and password to login.  \n\n\n  #### - OR -  \n\n\n\n  - Forgot password? Click 'Reset Password' and follow the prompts.\n  - Forgot username? Click 'Forgot Username' and follow the prompts.  \n\n\n  ### New User:\n  ","LOGIN_HELP_LINK":"https://sosmt.gov/business/how-do-i/","LOGIN_HELP_LINK_TEXT":"Need Help?","FORGOT_USERNAME_TEXT":"Forgot Username?","LOGIN_ACTIVE_DIRECTORY_TEXT":"State User Login","MULTIPLE_LOGIN_METHODS":true,"HAS_ACTIVE_DIRECTORY_LOGIN":true,"RESET_PASSWORD_WITH_USERNAME":true,"DOWNLOAD_LINK":true,"SHOW_USERNAME_ACCOUNT_CREATE":true,"SHOW_SCROLL_DOWN_ARROW":true,"SHOW_ADDRESS_ACCOUNT_CREATE":true,"TWO_COLUMN_ACCOUNT_CREATE":true,"RESET_PASSWORD_TIP":"A link to change your password has been sent to your email. Please allow a few minutes for this message to arrive. Please check your junk/spam folders if you do not find the email in your inbox.","FORGOT_PASSWORD_LINK_TEXT":"Reset Password","PHONE_NUMBER_OPTIONAL_ACCOUNT_CREATE":true,"SHOW_REQUIRED_INDICATOR_ACCOUNT_CREATE":true,"PASSWORD_REQUIREMENTS_ACCOUNT_CREATE":"\n    <ul>\n      <li>MUST contain at least 8 characters (12+ recommended)</li>\n      <li>MUST contain at least one uppercase letter.</li>\n      <li>MUST contain at least one lowercase letter.</li>\n      <li>MUST contain at least one number.</li>\n      <li>MUST contain at least one special character (!”#$%&'()*+,-./:;<=>?</li>\n    </ul>\n  ","ALLOW_CERTIFICATION_REQUEST":true,"ALLOW_PUBLIC_CERTIFICATE_REQUEST":true,"ALLOW_COPY_REQUEST":false,"ALLOW_CORRECTION_STYLING":true,"HIDE_DEPRECATION_WARNING":false,"AMEND_ROUTE_PUBLIC":true,"SEAL_FILENAME":"seal.png","SHOPPING_CART":true,"ALLOW_PAYMENT_UPDATE_WITH_EMPTY_CART":true,"RA_EMAIL":true,"RA_WEBSITE":true,"RA_NO_DEFAULT_TYPE":true,"RA_ADDRESS_LABEL":"Street Address","RA_TYPE_SELECTION_DEFAULT":true,"RA_DEFAULT_TYPE":"460","RA_OVERRIDE_TYPE_WITH_DEFAULT":true,"RA_PRINCIPAL_ADDRESS_AMS":true,"UPLOAD_AND_SUBMIT_HIDE_IF_ONE_OPTION":true,"PAYMENT_PROCESSING_MESSAGE":"Your payment is processing - Do not close your browser or click the back button","CHECKOUT_BUTTON_WHEN_PROCESSING_TEXT":"Processing","EFS_CROP_PICKER_NONE_LABEL":"Lien Duration","DISALLOWED_WIZARD_PIECES":["FormationLocale"],"REPEATER_SHOW_EDIT_BUTTON":true,"DATA_REQUEST_PAGE_TITLE":"Data Requests and Subscriptions","DATA_REQUEST_SIDEBAR_LABEL":"Data Requests & Subscriptions","LOGIN_REDIRECTS_TO_EPASS":false,"LOGIN_REDIRECTS_TO_ACTIVE_DIRECTORY":true,"LOGIN_ACTIVE_DIRECTORY_LINK":true,"FETCH_EDIT_USER_LINK":false,"LISTS_FETCH_AVAILABLE_LISTS":true,"POST_WIZARD_SUBMIT_REDIRECT_URL":"/","PIN_REQUEST_ATTESTATIONS":true,"PIN_REQUEST_DESCRIPTION":"Click **Request PIN** to have a new PIN sent to the account holder's email address on file.","OWNERSHIP_REQUEST_DESCRIPTION":"To become an **authorized user** of this record, a current **AUTHORIZED USER** will need to grant you access. To request access, click **Request Access** below.","PIN_REQUEST_SUCCESS_MESSAGE":"The PIN you have requested for this entity has been sent to the email associated with your user account.  You should receive the PIN in approximately 3-5 minutes, depending on your email service provider.","APOSTILLE_HEADER_LABEL":"Verification Information","APOSTILLE_NUMBER_LABEL":"Apostille/Authentication","APOSTILLE_CITY_STATE_OVERRIDE":"HELENA, MT","APOSTILLE_FILING_DATE_LABEL":"Issue Date","APOSTILLE_CITY_STATE_IN_CERTIFIED":true,"NOTARY_EXISTING_FILING":true,"ALLOW_REVOKE_OWN_ACCESS_ONLY":false,"HIDE_CANCEL_ON_ONETIME_DATA_REQUESTS":true,"DATA_REQUESTS_IN_SHOPPING_CART":true,"WQ_ALLOW_EDIT_PENDING_PAYMENT":true,"WQ_CONFIRM_ON_DELETE":true,"WQ_DELETE_CONFIRM_MESSAGE":"Deleting this filing will forfeit any money already paid to the Secretary of State. This action is permanent and cannot be undone, are you sure you would like to delete?","PASS_ITEM_GUIDS_ON_CHECKOUT":true,"FORM_REVISION_HISTORY":true,"CHECKOUT_DISCLAIMER":"By entering your credit card and/or checking account information you (i) state that **you are an authorized user** of the credit card and/or electronic check and that the associated information entered (e.g., account holder name, account number, billing address) is accurate, (ii) **you authorize payment processor to charge the amount you have requested** to your credit card and/or funding account, and (iii) **acknowledge if a charge is declined or reversed you may also be assessed a customary charge** by the payment processor for such transactions.","FARM_BILL_SEARCH_CONFIDENTIAL":"As a registered Farm Bill Buyer with the Montana Secretary of State’s office it is important to maintain the confidentiality of the information contained within the Farm Bill Master List. The Farm Bill Master List reflects personal data, such as Social Security Numbers, which are a key piece of personal identifiable information to assist you in determining the existence of a lien against a specific debtor. The distribution of this information beyond its intended purpose is strictly prohibited.\n\n**The debtor's tax identification number has been hidden for confidentiality reasons. You may continue to search on a tax ID number and return debtors that match your search criteria. The SSN/FEIN must be entered without dashes or spaces.  If you need access to the tax identification number to clearly identify the debtor, please contact the UCC unit at (406) 444-3665.**","VIEW_HISTORY_BUTTON_ALT_TEXT":"View Filings","WIZARD_ERROR_TITLE_MESSAGE":"Form Error","FARM_BILL_SEARCH_INTERACTIVE":true,"USE_FARM_BILL_API":true,"DISALLOW_ASSIGN_SELF_AS_RA":true,"DISALLOW_ASSIGN_SELF_AS_PRINCIPAL":true,"USE_TRADEMARK_OWNER_VALIDATION":true,"USE_ALTERNATIVE_FOREIGN_ADDRESS_LABELS":true,"MY_RECEIPTS_FILTER":[{"type":"dateRange","name":"DATE_RANGE","label":"Date range","defaultValue":{"start":null,"end":null}},{"type":"text","name":"REF_NUM","defaultValue":"","label":"Reference Number"},{"type":"text","name":"RECEIPT_NUM","defaultValue":"","label":"Receipt Id"},{"type":"text","name":"AMOUNT","defaultValue":"","label":"Amount"},{"type":"select","name":"TYPE","defaultValue":"","label":"Payment Type","options":[{"value":"","label":"All"},{"value":"CC","label":"Credit Card"},{"value":"Check","label":"Check"}]}],"MY_RECEIPTS_SHOW_IN_SIDEBAR":true,"SHOW_MY_RECEIPTS_HELPER_TEXT":true,"MY_RECEIPTS_HELPER_LABEL":"About Receipt Search","MY_RECEIPTS_HELPER_TEXT":"You can search for receipts based on their descriptions, including the items paid for on the receipt. Use the filters to search for or filter specific information.","FARM_BILL_SUBLINK":{"label":"Farm Bill","component":"FarmBill","parameter":"farm-bill","path":"/lists/farm-bill","sourceTypeId":0,"myRecordsSearch":false,"allowedRules":["/search/"],"disabled":true,"searchDescription":"To perform a search, enter a debtor name. Your search results may include: exact debtor name, variations of that name and any filing that includes your search criteria. Punctuation is ignored.\n\nYou can click on \"Advanced\" to refine your search. Under “Advanced” you can search by crop, year, county and SSN/FEIN. As a registered Farm Bill Buyer with the Montana Secretary of State’s office it is important to maintain the confidentiality of the information contained within the Farm Bill Master List. The Farm Bill Master List reflects personal data, such as Social Security Numbers, which are a key piece of personal identifiable information to assist you in determining the existence of a lien against a specific debtor. The distribution of this information beyond its intended purpose is strictly prohibited.\n\nThe debtor's tax identification number has been hidden for confidentiality reasons. You may continue to search on a tax ID number and return debtors that match your search criteria. The SSN/FEIN must be entered without dashes or spaces.","searchMustHaveOneOf":["search","UCC_FARM_PRODUCT_ID","COUNTY"],"searchPlaceholder":"Search by debtor name","advancedSearchParameters":[{"type":"ServerMultiComplete","label":"Product code name(s)","name":"UCC_FARM_PRODUCT_ID","defaultValue":"","optionsSrc":"UCC_FARM_PRODUCT_V"},{"type":"MultiComplete","label":"Year or Range of Years","name":"YEAR_NUM","optionsSrc":"years","startYear":"1968","defaultValue":[],"preMergeOptions":[{"value":"ALL","label":"All"}]},{"type":"serverSelect","label":"State","name":"STATE","defaultValue":"MONTANA","optionsSrc":"STATE"},{"type":"ServerMultiComplete","label":"County","name":"COUNTY","defaultValue":[],"optionsSrc":"COUNTY","overrideSubOptionsSrcFromParameterName":"STATE"},{"type":"checkbox","name":"TIN_SEARCH_YN","defaultValue":false,"label":"Tax Identification Number Search"},{"type":"checkbox","name":"TIN_SORT_YN","defaultValue":false,"label":"Unique ID Sort"}]},"ALLOW_ADDRESS_VALIDATION_BYPASS_OPTION":true,"DEFAULT_ADDRESS_VALIDATION_BYPASS_OPTION_CHECKED":true}).DEPRECATE_IE;
	var DEPRECATE_NON_CHROMIUM_EDGE = ({"NODE_ENV":"production","BUILD_DATE":"2025-08-27T15:15:31.687Z","BUILD_NUMBER":"Not Provided","GIT_VERSION":"v1.3.0-381-ga81e29b08","GIT_COMMIT_HASH":"a81e29b085c9268ffd96c78eb734365802722741","GIT_BRANCH":"beta","PUBLIC_URL":"","STATE_ABBR":"MT","STATE_NAME":"Montana","STATE_ORG_TITLE":"Secretary of State","LOGIN_HEADER_IMG_PATH":"","HOME_IMG_FILENAME":"montana.jpg","FAVICON_FILE_NAME":"favicon.ico","ALLOW_E_SIGN_ON_CORRECTIONS":true,"THIRD_PARTY_SIGNING_ALLOWED":false,"MY_ACCOUNT_SAVE_AND_CLOSE_BUTTON":true,"IE_DEPRECATED_MESSAGE":"Internet Explorer is not supported. Please select a supported browser below to access this website.","ADDITIONAL_ROUTES":{"dataRequests":true,"farmBill":true,"apostille":true,"externalHelp":"https://sosmt.gov/business/help-center/","systemAdministration":[{"title":"Saved Payments","parameter":"saved-payments","componentName":"SavedPayments"}]},"SUBROUTES":[{"label":"Business","component":"Business","parameter":"business","myWorkQueueSearch":false,"sourceTypeId":54,"searchMustHaveOneOf":["FILING_TYPE_ID","STATUS_ID","STATE","search"],"serverWebSearchDescription":true,"serverWorkQueueDescription":true,"serverMyRecordsDescription":true,"searchPlaceholder":"Search by name or filing number (X########)","allowEmptySearchTerm":true,"requestCertificateAlternateLabel":"Request Information","fileAmendmentButtonLabel":"Filing Actions","advancedSearchParameters":[{"type":"radio","name":"QUERY_TYPE_ID","defaultValue":1010,"options":[{"value":1010,"label":"Starts with"},{"value":1011,"label":"Contains"},{"value":1012,"label":" Word Contains"}]},{"type":"serverSelect","name":"FILING_TYPE_ID","optionsSrc":"FILING_TYPES","label":"Entity Type","placeholder":"All","defaultValue":"0"},{"type":"serverSelect","name":"FILING_SUBTYPE_ID","optionsSrc":"FILING_SUBTYPES","label":"Entity Subtype","overrideSubOptionsSrcFromParameterName":"FILING_TYPE_ID","placeholder":"All","defaultValue":"0"},{"type":"serverSelect","name":"STATUS_ID","optionsSrc":"FILING_STATUS_WITHOUT_ALL","label":"Status","placeholder":"All","defaultValue":"0"},{"type":"serverSelect","name":"STATE","optionsSrc":"STATE","label":"State","placeholder":"All","defaultValue":""},{"type":"serverSelect","name":"COUNTY","optionsSrc":"COUNTY_SUBOPTION","label":"County","overrideSubOptionsSrcFromParameterName":"STATE","placeholder":"All","defaultValue":""},{"type":"checkbox","name":"CRA_SEARCH_YN","defaultValue":false,"label":"Search by Registered Agent PID"},{"type":"dateRange","name":"FILING_DATE","label":"Registration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}},{"type":"dateRange","name":"EXPIRATION_DATE","label":"Expiration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}}],"myRecordsFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Active"},{"value":2,"label":"Inactive"},{"value":3,"label":"Pending"}]},{"type":"dateRange","name":"DATE_RANGE","label":"Date range","defaultValue":{"start":null,"end":null}}],"myWorkQueueFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Approved"},{"value":2,"label":"Pending Online Payment"},{"value":3,"label":"Pending Review"},{"value":4,"label":"Needs Correction"},{"value":5,"label":"Rejected"},{"value":6,"label":"Draft"}]},{"type":"dateRange","name":"DATE_RANGE","label":"Date range","defaultValue":{"start":null,"end":null}}]},{"label":"Notary","component":"Notary","parameter":"notary","sourceTypeId":850,"myWorkQueueSearch":false,"allowEmptySearchTerm":true,"requestCertificateAlternateLabel":"Download Certificate","fileAmendmentButtonLabel":"Filing Actions","hideNameRequestCertificate":true,"hideAddressRequestCertificate":true,"hideRecordUserManagment":true,"searchPlaceholder":"Search by name or commission number","searchMustHaveOneOf":["CITY","search","SERVICE_TYPE"],"advancedParametersStartOpen":true,"searchIsSortable":true,"advancedSearchParameters":[{"type":"radio","name":"STARTS_WITH_YN","defaultValue":false,"options":[{"value":true,"label":"Starts with"},{"value":false,"label":"Contains"}]},{"type":"checkbox","name":"ACTIVE_ONLY_YN","defaultValue":true,"label":"Active entities only"},{"type":"text","name":"CITY","defaultValue":"","label":"City"},{"type":"select","name":"SERVICE_TYPE","label":"Special Services Offered","defaultValue":0,"options":[{"value":0,"label":"(N/A)"},{"value":6165,"label":"In-Person Electronic Notarization (IPEN)"},{"value":6166,"label":"Remote Online Notarization (RON)"},{"value":6167,"label":"Mobile Notary Services"},{"value":6168,"label":"Remote Ink Notarization (RIN)"}]}]},{"label":"Apostille","component":"Apostille","parameter":"apostille","sourceTypeId":720,"myRecordsSearch":false,"myWorkQueueSearch":false,"disabled":false,"allowedRoutes":["/forms-manager/","/queue/","/forms/"]},{"label":"Liens","component":"UCC","parameter":"ucc","sourceTypeId":1999,"myRecordsSearch":true,"myWorkQueueSearch":true,"fileAmendmentButtonLabel":"Filing Actions","searchPlaceholder":"Search by name or file number","disabled":false,"serverWebSearchDescription":true,"myRecordsDescription":"","workQueueDescription":"","searchDescription":"","hideRecordUserManagment":true,"searchLiensCheckout":false,"advancedSearchParameters":[{"type":"radio","name":"STARTS_WITH_YN","defaultValue":false,"options":[{"value":true,"label":"Starts with"},{"value":false,"label":"Contains"}]},{"type":"select","name":"STATUS","defaultValue":"ALL","label":"Status","options":[{"value":"ACTIVE_UNLAPSED","label":"Active (unlapsed)"},{"value":"ACTIVE_LAPSED_UNLAPSED","label":"Active (lapsed and unlapsed)"}]},{"type":"text","name":"EXCLUDE_VALUES","label":"Exclude Debtor Names (comma separated list of names to exclude)","defaultValue":""},{"type":"dateRange","name":"FILING_DATE","label":"Financing Statement Date","defaultValue":{"start":null,"end":null}},{"type":"dateRange","name":"LAPSE_DATE","label":"Lapse Date","defaultValue":{"start":null,"end":null}},{"type":"text","name":"CITY","label":"Debtor City","defaultValue":""}],"myRecordsFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Approved"},{"value":2,"label":"Pending Online Payment"},{"value":3,"label":"Pending Review"}]},{"type":"select","name":"TYPE","defaultValue":0,"label":"Lien Type","options":[{"value":0,"label":"All"},{"value":1,"label":"UCC"},{"value":2,"label":"EFS"},{"value":3,"label":"Title 71"}]}],"myWorkQueueFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Approved"},{"value":2,"label":"Pending Online Payment"},{"value":3,"label":"Pending Review"},{"value":4,"label":"Pending Print and Mail"},{"value":5,"label":"Rejected"},{"value":6,"label":"Draft"}]},{"type":"select","name":"TYPE","defaultValue":0,"label":"Lien Type","options":[{"value":0,"label":"All"},{"value":1,"label":"UCC"},{"value":2,"label":"EFS"},{"value":3,"label":"Title 71"}]}]},{"label":"Copy Request","component":"copies","parameter":"copies","sourceTypeId":2001,"myRecordsSearch":false,"myWorkQueueSearch":false,"disabled":false,"allowedRoutes":["/forms-manager/","/queue/","/forms/"]},{"label":"Trademark","component":"Trademark","parameter":"trademark","sourceTypeId":810,"showRequestCertificate":true,"searchMustHaveOneOf":["search","EXPIRATION_DATE","FILING_DATE"],"allowEmptySearchTerm":true,"requestCertificateAlternateLabel":"Request Information","fileAmendmentButtonLabel":"Filing Actions","advancedSearchParameters":[{"type":"radio","name":"QUERY_TYPE_ID","defaultValue":1010,"options":[{"value":1010,"label":"Starts with"},{"value":1011,"label":"Contains"},{"value":1012,"label":" Word Contains"}]},{"type":"checkbox","name":"OWNER_SEARCH_YN","defaultValue":false,"label":"Search owners"},{"type":"radio","name":"SERVICE_MARK_YN","label":"Mark Type","defaultValue":"","options":[{"value":"","label":"All Marks"},{"value":"Y","label":"Service Mark"},{"value":"N","label":"Trademark"}]},{"type":"serverSelect","name":"STATUS_ID","optionsSrc":"TYPE_V|TRADEMARK_STATUS_TYPE","label":"Status","placeholder":"All","defaultValue":"0"},{"type":"select","name":"DESIGN_TYPE_ID","options":[{"value":0,"label":"All"},{"value":990,"label":"Words Only"},{"value":991,"label":"Design Only"},{"value":992,"label":"Words and Design"}],"label":"Design Type","defaultValue":"0"},{"type":"dateRange","name":"FILING_DATE","label":"Registered Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}},{"type":"dateRange","name":"EXPIRATION_DATE","label":"Expiration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}}]},{"label":"Business Info Request","component":"InfoRequests","parameter":"info-request","sourceTypeId":167,"allowedRoutes":["/forms-manager/","/queue/","/forms/"]},{"label":"Data Requests","component":"DataRequests","parameter":"data-request","sourceTypeId":0,"allowedRoutes":["/forms-manager/"]},{"label":"CRA","component":"CRA","parameter":"cra","sourceTypeId":157,"myRecordsSearch":false,"searchPlaceholder":"Search by name or registered agent number","allowedRoutes":["/forms-manager/","/forms/","/records/","/queue/","/search/"],"allowEmptySearchTerm":true,"fileAmendmentButtonLabel":"Filing Actions","advancedSearchParameters":[{"type":"radio","name":"QUERY_TYPE_ID","defaultValue":1010,"options":[{"value":1010,"label":"Starts with"},{"value":1011,"label":"Contains"},{"value":1012,"label":" Word Contains"}]},{"type":"dateRange","name":"CRA_DATE","label":"Registration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}},{"type":"select","name":"STATUS_ID","label":"Status","defaultValue":0,"options":[{"value":0,"label":"All"},{"value":121,"label":"Active"},{"value":122,"label":"Inactive"}]},{"type":"select","name":"AGENT_TYPE_ID","label":"Agent Type","defaultValue":0,"options":[{"value":0,"label":"All"},{"value":460,"label":"Registered Agent"},{"value":461,"label":"Commercial Registered Agent"}]}]},{"label":"Farm Bill","component":"FarmBill","parameter":"farm-bill","path":"/lists/farm-bill","sourceTypeId":0,"myRecordsSearch":false,"allowedRules":["/search/"],"disabled":true,"searchDescription":"To perform a search, enter a debtor name. Your search results may include: exact debtor name, variations of that name and any filing that includes your search criteria. Punctuation is ignored.\n\nYou can click on \"Advanced\" to refine your search. Under “Advanced” you can search by crop, year, county and SSN/FEIN. As a registered Farm Bill Buyer with the Montana Secretary of State’s office it is important to maintain the confidentiality of the information contained within the Farm Bill Master List. The Farm Bill Master List reflects personal data, such as Social Security Numbers, which are a key piece of personal identifiable information to assist you in determining the existence of a lien against a specific debtor. The distribution of this information beyond its intended purpose is strictly prohibited.\n\nThe debtor's tax identification number has been hidden for confidentiality reasons. You may continue to search on a tax ID number and return debtors that match your search criteria. The SSN/FEIN must be entered without dashes or spaces.","searchMustHaveOneOf":["search","UCC_FARM_PRODUCT_ID","COUNTY"],"searchPlaceholder":"Search by debtor name","advancedSearchParameters":[{"type":"ServerMultiComplete","label":"Product code name(s)","name":"UCC_FARM_PRODUCT_ID","defaultValue":"","optionsSrc":"UCC_FARM_PRODUCT_V"},{"type":"MultiComplete","label":"Year or Range of Years","name":"YEAR_NUM","optionsSrc":"years","startYear":"1968","defaultValue":[],"preMergeOptions":[{"value":"ALL","label":"All"}]},{"type":"serverSelect","label":"State","name":"STATE","defaultValue":"MONTANA","optionsSrc":"STATE"},{"type":"ServerMultiComplete","label":"County","name":"COUNTY","defaultValue":[],"optionsSrc":"COUNTY","overrideSubOptionsSrcFromParameterName":"STATE"},{"type":"checkbox","name":"TIN_SEARCH_YN","defaultValue":false,"label":"Tax Identification Number Search"},{"type":"checkbox","name":"TIN_SORT_YN","defaultValue":false,"label":"Unique ID Sort"}]}],"SYSTEM_NICKNAME":"Online Services Portal","PAYMENT_METHODS":[{"type":"bypass"},{"type":"iTransact"}],"PAYMENT_ALLOW_AMEX":true,"SYSTEM_ID_LABEL":"System Id","DOUBLE_COLUMN_PUBLIC_LOGIN":true,"INTERNAL_USER_MANAGEMENT":true,"ALLOW_PUBLIC_JSON_IMPORT":false,"MAX_FILE_UPLOAD_SIZE":10000000,"REFUND_TEXT":"","RETURN_TO_HOME_ON_LOGOUT":true,"CURRENT_SOS_NAME":"Christi Jacobsen","LOGO_FILENAME":"mt-sos-logo.png","LOGO_ALT":"Christi Jacobsen, Montana Secretary of State","LOGO_FULL_WIDTH":true,"HOME_HIDE_AUTH_HINT":true,"HOME_TITLE":"Montana Secretary of State","CUSTOM_TAB_TITLE":"Official Montana","HOME_SUBTITLE":"Online Business Services","ENTITY_NAME_CONSENT_DESCRIPTION":"","ALLOW_USER_PROFILE_EDITING":true,"COMPARE_FOREIGN_NAME_IN_ENTITY_NAME_VALIDATION":true,"FOREIGN_NAME_FIELD_NAME":"KIMA_PARENT_NAME_INFO","LOGIN_TITLE":"Montana Secretary of State Online Filing Portal Login","PUBLIC_LOGIN_LABEL":"Username","REVERSE_LOGIN_COLUMNS":true,"LOGIN_SEAL_FILENAME":"seal_white.png","SEPARATE_USERNAME_AND_EMAIL":true,"CREATE_ACCOUNT_BUTTON_ALIGN_LEFT":true,"CREATE_ACCOUNT_BUTTON_TEXT":"CREATE AN ACCOUNT","PASSWORD_CUSTOM_ERROR_TEXT":"The password must meet all requirements","ACCOUNT_CREATED_MESSAGE":"Please check your email to verify your account to login and allow a few minutes for this message to arrive. Check your junk/spam folders if you do not find the email in your inbox.","PUBLIC_LOGIN_PLACEHOLDER":" ","DISABLE_DEFAULT_PAYMENT_RADIO":true,"CUSTOM_RESET_PASSWORD_ERROR_MESSAGE":"Username invalid - no account found","PUBLIC_LOGIN_CREATE_DESCRIPTION":"### Existing User:\n\n  - Enter your username and password to login.  \n\n\n  #### - OR -  \n\n\n\n  - Forgot password? Click 'Reset Password' and follow the prompts.\n  - Forgot username? Click 'Forgot Username' and follow the prompts.  \n\n\n  ### New User:\n  ","LOGIN_HELP_LINK":"https://sosmt.gov/business/how-do-i/","LOGIN_HELP_LINK_TEXT":"Need Help?","FORGOT_USERNAME_TEXT":"Forgot Username?","LOGIN_ACTIVE_DIRECTORY_TEXT":"State User Login","MULTIPLE_LOGIN_METHODS":true,"HAS_ACTIVE_DIRECTORY_LOGIN":true,"RESET_PASSWORD_WITH_USERNAME":true,"DOWNLOAD_LINK":true,"SHOW_USERNAME_ACCOUNT_CREATE":true,"SHOW_SCROLL_DOWN_ARROW":true,"SHOW_ADDRESS_ACCOUNT_CREATE":true,"TWO_COLUMN_ACCOUNT_CREATE":true,"RESET_PASSWORD_TIP":"A link to change your password has been sent to your email. Please allow a few minutes for this message to arrive. Please check your junk/spam folders if you do not find the email in your inbox.","FORGOT_PASSWORD_LINK_TEXT":"Reset Password","PHONE_NUMBER_OPTIONAL_ACCOUNT_CREATE":true,"SHOW_REQUIRED_INDICATOR_ACCOUNT_CREATE":true,"PASSWORD_REQUIREMENTS_ACCOUNT_CREATE":"\n    <ul>\n      <li>MUST contain at least 8 characters (12+ recommended)</li>\n      <li>MUST contain at least one uppercase letter.</li>\n      <li>MUST contain at least one lowercase letter.</li>\n      <li>MUST contain at least one number.</li>\n      <li>MUST contain at least one special character (!”#$%&'()*+,-./:;<=>?</li>\n    </ul>\n  ","ALLOW_CERTIFICATION_REQUEST":true,"ALLOW_PUBLIC_CERTIFICATE_REQUEST":true,"ALLOW_COPY_REQUEST":false,"ALLOW_CORRECTION_STYLING":true,"HIDE_DEPRECATION_WARNING":false,"AMEND_ROUTE_PUBLIC":true,"SEAL_FILENAME":"seal.png","SHOPPING_CART":true,"ALLOW_PAYMENT_UPDATE_WITH_EMPTY_CART":true,"RA_EMAIL":true,"RA_WEBSITE":true,"RA_NO_DEFAULT_TYPE":true,"RA_ADDRESS_LABEL":"Street Address","RA_TYPE_SELECTION_DEFAULT":true,"RA_DEFAULT_TYPE":"460","RA_OVERRIDE_TYPE_WITH_DEFAULT":true,"RA_PRINCIPAL_ADDRESS_AMS":true,"UPLOAD_AND_SUBMIT_HIDE_IF_ONE_OPTION":true,"PAYMENT_PROCESSING_MESSAGE":"Your payment is processing - Do not close your browser or click the back button","CHECKOUT_BUTTON_WHEN_PROCESSING_TEXT":"Processing","EFS_CROP_PICKER_NONE_LABEL":"Lien Duration","DISALLOWED_WIZARD_PIECES":["FormationLocale"],"REPEATER_SHOW_EDIT_BUTTON":true,"DATA_REQUEST_PAGE_TITLE":"Data Requests and Subscriptions","DATA_REQUEST_SIDEBAR_LABEL":"Data Requests & Subscriptions","LOGIN_REDIRECTS_TO_EPASS":false,"LOGIN_REDIRECTS_TO_ACTIVE_DIRECTORY":true,"LOGIN_ACTIVE_DIRECTORY_LINK":true,"FETCH_EDIT_USER_LINK":false,"LISTS_FETCH_AVAILABLE_LISTS":true,"POST_WIZARD_SUBMIT_REDIRECT_URL":"/","PIN_REQUEST_ATTESTATIONS":true,"PIN_REQUEST_DESCRIPTION":"Click **Request PIN** to have a new PIN sent to the account holder's email address on file.","OWNERSHIP_REQUEST_DESCRIPTION":"To become an **authorized user** of this record, a current **AUTHORIZED USER** will need to grant you access. To request access, click **Request Access** below.","PIN_REQUEST_SUCCESS_MESSAGE":"The PIN you have requested for this entity has been sent to the email associated with your user account.  You should receive the PIN in approximately 3-5 minutes, depending on your email service provider.","APOSTILLE_HEADER_LABEL":"Verification Information","APOSTILLE_NUMBER_LABEL":"Apostille/Authentication","APOSTILLE_CITY_STATE_OVERRIDE":"HELENA, MT","APOSTILLE_FILING_DATE_LABEL":"Issue Date","APOSTILLE_CITY_STATE_IN_CERTIFIED":true,"NOTARY_EXISTING_FILING":true,"ALLOW_REVOKE_OWN_ACCESS_ONLY":false,"HIDE_CANCEL_ON_ONETIME_DATA_REQUESTS":true,"DATA_REQUESTS_IN_SHOPPING_CART":true,"WQ_ALLOW_EDIT_PENDING_PAYMENT":true,"WQ_CONFIRM_ON_DELETE":true,"WQ_DELETE_CONFIRM_MESSAGE":"Deleting this filing will forfeit any money already paid to the Secretary of State. This action is permanent and cannot be undone, are you sure you would like to delete?","PASS_ITEM_GUIDS_ON_CHECKOUT":true,"FORM_REVISION_HISTORY":true,"CHECKOUT_DISCLAIMER":"By entering your credit card and/or checking account information you (i) state that **you are an authorized user** of the credit card and/or electronic check and that the associated information entered (e.g., account holder name, account number, billing address) is accurate, (ii) **you authorize payment processor to charge the amount you have requested** to your credit card and/or funding account, and (iii) **acknowledge if a charge is declined or reversed you may also be assessed a customary charge** by the payment processor for such transactions.","FARM_BILL_SEARCH_CONFIDENTIAL":"As a registered Farm Bill Buyer with the Montana Secretary of State’s office it is important to maintain the confidentiality of the information contained within the Farm Bill Master List. The Farm Bill Master List reflects personal data, such as Social Security Numbers, which are a key piece of personal identifiable information to assist you in determining the existence of a lien against a specific debtor. The distribution of this information beyond its intended purpose is strictly prohibited.\n\n**The debtor's tax identification number has been hidden for confidentiality reasons. You may continue to search on a tax ID number and return debtors that match your search criteria. The SSN/FEIN must be entered without dashes or spaces.  If you need access to the tax identification number to clearly identify the debtor, please contact the UCC unit at (406) 444-3665.**","VIEW_HISTORY_BUTTON_ALT_TEXT":"View Filings","WIZARD_ERROR_TITLE_MESSAGE":"Form Error","FARM_BILL_SEARCH_INTERACTIVE":true,"USE_FARM_BILL_API":true,"DISALLOW_ASSIGN_SELF_AS_RA":true,"DISALLOW_ASSIGN_SELF_AS_PRINCIPAL":true,"USE_TRADEMARK_OWNER_VALIDATION":true,"USE_ALTERNATIVE_FOREIGN_ADDRESS_LABELS":true,"MY_RECEIPTS_FILTER":[{"type":"dateRange","name":"DATE_RANGE","label":"Date range","defaultValue":{"start":null,"end":null}},{"type":"text","name":"REF_NUM","defaultValue":"","label":"Reference Number"},{"type":"text","name":"RECEIPT_NUM","defaultValue":"","label":"Receipt Id"},{"type":"text","name":"AMOUNT","defaultValue":"","label":"Amount"},{"type":"select","name":"TYPE","defaultValue":"","label":"Payment Type","options":[{"value":"","label":"All"},{"value":"CC","label":"Credit Card"},{"value":"Check","label":"Check"}]}],"MY_RECEIPTS_SHOW_IN_SIDEBAR":true,"SHOW_MY_RECEIPTS_HELPER_TEXT":true,"MY_RECEIPTS_HELPER_LABEL":"About Receipt Search","MY_RECEIPTS_HELPER_TEXT":"You can search for receipts based on their descriptions, including the items paid for on the receipt. Use the filters to search for or filter specific information.","FARM_BILL_SUBLINK":{"label":"Farm Bill","component":"FarmBill","parameter":"farm-bill","path":"/lists/farm-bill","sourceTypeId":0,"myRecordsSearch":false,"allowedRules":["/search/"],"disabled":true,"searchDescription":"To perform a search, enter a debtor name. Your search results may include: exact debtor name, variations of that name and any filing that includes your search criteria. Punctuation is ignored.\n\nYou can click on \"Advanced\" to refine your search. Under “Advanced” you can search by crop, year, county and SSN/FEIN. As a registered Farm Bill Buyer with the Montana Secretary of State’s office it is important to maintain the confidentiality of the information contained within the Farm Bill Master List. The Farm Bill Master List reflects personal data, such as Social Security Numbers, which are a key piece of personal identifiable information to assist you in determining the existence of a lien against a specific debtor. The distribution of this information beyond its intended purpose is strictly prohibited.\n\nThe debtor's tax identification number has been hidden for confidentiality reasons. You may continue to search on a tax ID number and return debtors that match your search criteria. The SSN/FEIN must be entered without dashes or spaces.","searchMustHaveOneOf":["search","UCC_FARM_PRODUCT_ID","COUNTY"],"searchPlaceholder":"Search by debtor name","advancedSearchParameters":[{"type":"ServerMultiComplete","label":"Product code name(s)","name":"UCC_FARM_PRODUCT_ID","defaultValue":"","optionsSrc":"UCC_FARM_PRODUCT_V"},{"type":"MultiComplete","label":"Year or Range of Years","name":"YEAR_NUM","optionsSrc":"years","startYear":"1968","defaultValue":[],"preMergeOptions":[{"value":"ALL","label":"All"}]},{"type":"serverSelect","label":"State","name":"STATE","defaultValue":"MONTANA","optionsSrc":"STATE"},{"type":"ServerMultiComplete","label":"County","name":"COUNTY","defaultValue":[],"optionsSrc":"COUNTY","overrideSubOptionsSrcFromParameterName":"STATE"},{"type":"checkbox","name":"TIN_SEARCH_YN","defaultValue":false,"label":"Tax Identification Number Search"},{"type":"checkbox","name":"TIN_SORT_YN","defaultValue":false,"label":"Unique ID Sort"}]},"ALLOW_ADDRESS_VALIDATION_BYPASS_OPTION":true,"DEFAULT_ADDRESS_VALIDATION_BYPASS_OPTION_CHECKED":true}).DEPRECATE_NON_CHROMIUM_EDGE;
	
	var getIsUnsupportedBrowser = function getIsUnsupportedBrowser() {
	  var checks = [];
	  if (DEPRECATE_IE) {
	    checks.push(!!window.MSInputMethodContext && !!document.documentMode);
	  }
	  if (DEPRECATE_NON_CHROMIUM_EDGE) {
	    checks.push(navigator.userAgent.indexOf('Edge') !== -1);
	  }
	  return checks.length ? checks.some(function (x) {
	    return x;
	  }) : false;
	};
	
	var initialState = {
	  sidebarCollapsed: false,
	  isMobile: document.body.clientWidth < 600 ? true : false,
	  sidebarShown: false,
	  overrideSidebarResizing: false,
	  showLogin: false,
	  appError: false,
	  toastError: '',
	  toastSuccess: '',
	  appSettings: {},
	  currentCategory: '',
	  cartQuantity: 0,
	  isUnsupportedBrowser: getIsUnsupportedBrowser(),
	  announcerMessages: [],
	  stateUser: false
	};
	
	var appReducer = function appReducer() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	  var action = arguments[1];
	
	  switch (action.type) {
	    case 'RESET_APP_STATE':
	      return initialState;
	    case 'TOGGLE_SIDEBAR_COLLAPSE':
	      return Object.assign({}, state, { sidebarCollapsed: action.collapse });
	    case 'TOGGLE_MOBILE_STATE':
	      return Object.assign({}, state, { isMobile: action.isMobile });
	    case 'TOGGLE_SIDEBAR_SHOW':
	      return Object.assign({}, state, { sidebarShown: action.sidebarShown });
	    case 'OVERRIDE_SIDEBAR_RESIZING':
	      return Object.assign({}, state, { overrideSidebarResizing: action.overrideSidebarResizing });
	    case 'TOGGLE_SHOW_LOGIN':
	      return Object.assign({}, state, { showLogin: action.showLogin });
	    case 'SET_STATE_USER':
	      return Object.assign({}, state, { stateUser: action.stateUser });
	    case 'SET_APP_ERROR':
	      return Object.assign({}, state, {
	        appError: {
	          type: action.errorType,
	          error: action.error,
	          show: action.show === false ? false : true
	        }
	      });
	    case 'CLEAR_APP_ERROR':
	      return Object.assign({}, state, { appError: false });
	    case 'SET_APP_SETTINGS':
	      return Object.assign({}, state, { appSettings: action.appSettings });
	    case 'SET_ERROR_TOAST':
	      return Object.assign({}, state, { toastError: action.error });
	    case 'CLEAR_ERROR_TOAST':
	      return Object.assign({}, state, { toastError: '' });
	    case 'SET_SUCCESS_TOAST':
	      return Object.assign({}, state, { toastSuccess: action.success });
	    case 'CLEAR_SUCCESS_TOAST':
	      return Object.assign({}, state, { toastSuccess: '' });
	    case 'SET_OFFLINE':
	      return Object.assign({}, state, {
	        appSettings: Object.assign({}, action.appSettings, { WEBSITE_PORTAL_OFFLINE_YN: action.offline })
	      });
	    case 'SET_CURRENT_CATEGORY':
	      var userCache = _localStorage2.default.get('USER_CACHE') || {};
	      var auth = store.getState().auth;
	      if (auth.loggedIn) {
	        _localStorage2.default.set('USER_CACHE', Object.assign({}, userCache, _defineProperty({}, auth.WEB_USER_ID, action.category)));
	      }
	      return Object.assign({}, state, { currentCategory: action.category });
	    case 'SET_CART_QUANTITY':
	      return Object.assign({}, state, { cartQuantity: action.quantity });
	    case 'CLEAR_CART_QUANTITY':
	      return Object.assign({}, state, { cartQuantity: 0 });
	    case 'SET_UNSUPPORTED_BROWSER':
	      return Object.assign({}, state, { isUnsupportedBrowser: action.isUnsupportedBrowser });
	    case 'ANNOUNCE':
	      return Object.assign({}, state, { announcerMessages: [].concat(_toConsumableArray(state.announcerMessages), [action.message]) });
	    default:
	      return state;
	  }
	};
	
	var composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || _redux.compose;
	
	var store = (0, _redux.createStore)((0, _redux.combineReducers)({
	  router: connectedRouter,
	  app: appReducer,
	  search: _searchReducer2.default,
	  formManager: _FormManagerReducer2.default,
	  forms: _FormsReducer2.default,
	  wizard: _WizardReducer2.default,
	  designer: _DesignerReducer2.default,
	  myRecords: _MyRecordsReducer2.default,
	  myReceipts: _MyReceiptsReducer2.default,
	  queue: _MyWorkQueueReducer2.default,
	  auth: _AuthReducer2.default,
	  home: _HomeReducer2.default,
	  appSettings: _AppSettingsReducer2.default,
	  appSettingTypes: _AppSettingTypesReducer2.default
	}), composeEnhancers((0, _redux.applyMiddleware)(_reduxThunk2.default, routeMiddleware)));
	
	exports.default = store;

/***/ },
/* 19 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Triangle = exports.FlexWrapper = exports.Footer = exports.Body = exports.Drawer = exports.SidebarNav = exports.Content = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(7);
	
	var _reactRouterDom = __webpack_require__(30);
	
	var _actions = __webpack_require__(29);
	
	var _Login = __webpack_require__(302);
	
	var _Login2 = _interopRequireDefault(_Login);
	
	var _AuthTimer = __webpack_require__(1137);
	
	var _AuthTimer2 = _interopRequireDefault(_AuthTimer);
	
	var _Portal = __webpack_require__(12);
	
	var _Portal2 = _interopRequireDefault(_Portal);
	
	__webpack_require__(1467);
	
	var _elementResizeDetector = __webpack_require__(1014);
	
	var _elementResizeDetector2 = _interopRequireDefault(_elementResizeDetector);
	
	var _focusTrapReact = __webpack_require__(193);
	
	var _focusTrapReact2 = _interopRequireDefault(_focusTrapReact);
	
	var _FloatingMenu = __webpack_require__(86);
	
	var _FloatingMenu2 = _interopRequireDefault(_FloatingMenu);
	
	var _hamburger = __webpack_require__(571);
	
	var _hamburger2 = _interopRequireDefault(_hamburger);
	
	var _store = __webpack_require__(18);
	
	var _caretLeft = __webpack_require__(222);
	
	var _caretLeft2 = _interopRequireDefault(_caretLeft);
	
	var _crossHeavy = __webpack_require__(51);
	
	var _crossHeavy2 = _interopRequireDefault(_crossHeavy);
	
	var _Cart = __webpack_require__(1056);
	
	var _Cart2 = _interopRequireDefault(_Cart);
	
	var _reactHelmet = __webpack_require__(209);
	
	var _App = __webpack_require__(118);
	
	var _SkipLink = __webpack_require__(1144);
	
	var _SkipLink2 = _interopRequireDefault(_SkipLink);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// import { DISABLE_AUTH_CHECK } from '../../App'
	var resizeDetector = (0, _elementResizeDetector2.default)();
	var STATE_ABBR = ("MT");
	STATE_ABBR = STATE_ABBR.toUpperCase();
	var LOGO_FILENAME = ("mt-sos-logo.png");
	var SEAL_FILENAME = ("seal.png");
	var Logo = __webpack_require__(216)("./" + STATE_ABBR + (LOGO_FILENAME ? '/' + LOGO_FILENAME : SEAL_FILENAME ? '/' + SEAL_FILENAME : "/seal.svg"));
	var LOGO_ALT = ("Christi Jacobsen, Montana Secretary of State") || ("Montana") + ' ' + ("Secretary of State");
	var FOOTER_LINKS = ({"NODE_ENV":"production","BUILD_DATE":"2025-08-27T15:15:31.687Z","BUILD_NUMBER":"Not Provided","GIT_VERSION":"v1.3.0-381-ga81e29b08","GIT_COMMIT_HASH":"a81e29b085c9268ffd96c78eb734365802722741","GIT_BRANCH":"beta","PUBLIC_URL":"","STATE_ABBR":"MT","STATE_NAME":"Montana","STATE_ORG_TITLE":"Secretary of State","LOGIN_HEADER_IMG_PATH":"","HOME_IMG_FILENAME":"montana.jpg","FAVICON_FILE_NAME":"favicon.ico","ALLOW_E_SIGN_ON_CORRECTIONS":true,"THIRD_PARTY_SIGNING_ALLOWED":false,"MY_ACCOUNT_SAVE_AND_CLOSE_BUTTON":true,"IE_DEPRECATED_MESSAGE":"Internet Explorer is not supported. Please select a supported browser below to access this website.","ADDITIONAL_ROUTES":{"dataRequests":true,"farmBill":true,"apostille":true,"externalHelp":"https://sosmt.gov/business/help-center/","systemAdministration":[{"title":"Saved Payments","parameter":"saved-payments","componentName":"SavedPayments"}]},"SUBROUTES":[{"label":"Business","component":"Business","parameter":"business","myWorkQueueSearch":false,"sourceTypeId":54,"searchMustHaveOneOf":["FILING_TYPE_ID","STATUS_ID","STATE","search"],"serverWebSearchDescription":true,"serverWorkQueueDescription":true,"serverMyRecordsDescription":true,"searchPlaceholder":"Search by name or filing number (X########)","allowEmptySearchTerm":true,"requestCertificateAlternateLabel":"Request Information","fileAmendmentButtonLabel":"Filing Actions","advancedSearchParameters":[{"type":"radio","name":"QUERY_TYPE_ID","defaultValue":1010,"options":[{"value":1010,"label":"Starts with"},{"value":1011,"label":"Contains"},{"value":1012,"label":" Word Contains"}]},{"type":"serverSelect","name":"FILING_TYPE_ID","optionsSrc":"FILING_TYPES","label":"Entity Type","placeholder":"All","defaultValue":"0"},{"type":"serverSelect","name":"FILING_SUBTYPE_ID","optionsSrc":"FILING_SUBTYPES","label":"Entity Subtype","overrideSubOptionsSrcFromParameterName":"FILING_TYPE_ID","placeholder":"All","defaultValue":"0"},{"type":"serverSelect","name":"STATUS_ID","optionsSrc":"FILING_STATUS_WITHOUT_ALL","label":"Status","placeholder":"All","defaultValue":"0"},{"type":"serverSelect","name":"STATE","optionsSrc":"STATE","label":"State","placeholder":"All","defaultValue":""},{"type":"serverSelect","name":"COUNTY","optionsSrc":"COUNTY_SUBOPTION","label":"County","overrideSubOptionsSrcFromParameterName":"STATE","placeholder":"All","defaultValue":""},{"type":"checkbox","name":"CRA_SEARCH_YN","defaultValue":false,"label":"Search by Registered Agent PID"},{"type":"dateRange","name":"FILING_DATE","label":"Registration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}},{"type":"dateRange","name":"EXPIRATION_DATE","label":"Expiration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}}],"myRecordsFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Active"},{"value":2,"label":"Inactive"},{"value":3,"label":"Pending"}]},{"type":"dateRange","name":"DATE_RANGE","label":"Date range","defaultValue":{"start":null,"end":null}}],"myWorkQueueFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Approved"},{"value":2,"label":"Pending Online Payment"},{"value":3,"label":"Pending Review"},{"value":4,"label":"Needs Correction"},{"value":5,"label":"Rejected"},{"value":6,"label":"Draft"}]},{"type":"dateRange","name":"DATE_RANGE","label":"Date range","defaultValue":{"start":null,"end":null}}]},{"label":"Notary","component":"Notary","parameter":"notary","sourceTypeId":850,"myWorkQueueSearch":false,"allowEmptySearchTerm":true,"requestCertificateAlternateLabel":"Download Certificate","fileAmendmentButtonLabel":"Filing Actions","hideNameRequestCertificate":true,"hideAddressRequestCertificate":true,"hideRecordUserManagment":true,"searchPlaceholder":"Search by name or commission number","searchMustHaveOneOf":["CITY","search","SERVICE_TYPE"],"advancedParametersStartOpen":true,"searchIsSortable":true,"advancedSearchParameters":[{"type":"radio","name":"STARTS_WITH_YN","defaultValue":false,"options":[{"value":true,"label":"Starts with"},{"value":false,"label":"Contains"}]},{"type":"checkbox","name":"ACTIVE_ONLY_YN","defaultValue":true,"label":"Active entities only"},{"type":"text","name":"CITY","defaultValue":"","label":"City"},{"type":"select","name":"SERVICE_TYPE","label":"Special Services Offered","defaultValue":0,"options":[{"value":0,"label":"(N/A)"},{"value":6165,"label":"In-Person Electronic Notarization (IPEN)"},{"value":6166,"label":"Remote Online Notarization (RON)"},{"value":6167,"label":"Mobile Notary Services"},{"value":6168,"label":"Remote Ink Notarization (RIN)"}]}]},{"label":"Apostille","component":"Apostille","parameter":"apostille","sourceTypeId":720,"myRecordsSearch":false,"myWorkQueueSearch":false,"disabled":false,"allowedRoutes":["/forms-manager/","/queue/","/forms/"]},{"label":"Liens","component":"UCC","parameter":"ucc","sourceTypeId":1999,"myRecordsSearch":true,"myWorkQueueSearch":true,"fileAmendmentButtonLabel":"Filing Actions","searchPlaceholder":"Search by name or file number","disabled":false,"serverWebSearchDescription":true,"myRecordsDescription":"","workQueueDescription":"","searchDescription":"","hideRecordUserManagment":true,"searchLiensCheckout":false,"advancedSearchParameters":[{"type":"radio","name":"STARTS_WITH_YN","defaultValue":false,"options":[{"value":true,"label":"Starts with"},{"value":false,"label":"Contains"}]},{"type":"select","name":"STATUS","defaultValue":"ALL","label":"Status","options":[{"value":"ACTIVE_UNLAPSED","label":"Active (unlapsed)"},{"value":"ACTIVE_LAPSED_UNLAPSED","label":"Active (lapsed and unlapsed)"}]},{"type":"text","name":"EXCLUDE_VALUES","label":"Exclude Debtor Names (comma separated list of names to exclude)","defaultValue":""},{"type":"dateRange","name":"FILING_DATE","label":"Financing Statement Date","defaultValue":{"start":null,"end":null}},{"type":"dateRange","name":"LAPSE_DATE","label":"Lapse Date","defaultValue":{"start":null,"end":null}},{"type":"text","name":"CITY","label":"Debtor City","defaultValue":""}],"myRecordsFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Approved"},{"value":2,"label":"Pending Online Payment"},{"value":3,"label":"Pending Review"}]},{"type":"select","name":"TYPE","defaultValue":0,"label":"Lien Type","options":[{"value":0,"label":"All"},{"value":1,"label":"UCC"},{"value":2,"label":"EFS"},{"value":3,"label":"Title 71"}]}],"myWorkQueueFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Approved"},{"value":2,"label":"Pending Online Payment"},{"value":3,"label":"Pending Review"},{"value":4,"label":"Pending Print and Mail"},{"value":5,"label":"Rejected"},{"value":6,"label":"Draft"}]},{"type":"select","name":"TYPE","defaultValue":0,"label":"Lien Type","options":[{"value":0,"label":"All"},{"value":1,"label":"UCC"},{"value":2,"label":"EFS"},{"value":3,"label":"Title 71"}]}]},{"label":"Copy Request","component":"copies","parameter":"copies","sourceTypeId":2001,"myRecordsSearch":false,"myWorkQueueSearch":false,"disabled":false,"allowedRoutes":["/forms-manager/","/queue/","/forms/"]},{"label":"Trademark","component":"Trademark","parameter":"trademark","sourceTypeId":810,"showRequestCertificate":true,"searchMustHaveOneOf":["search","EXPIRATION_DATE","FILING_DATE"],"allowEmptySearchTerm":true,"requestCertificateAlternateLabel":"Request Information","fileAmendmentButtonLabel":"Filing Actions","advancedSearchParameters":[{"type":"radio","name":"QUERY_TYPE_ID","defaultValue":1010,"options":[{"value":1010,"label":"Starts with"},{"value":1011,"label":"Contains"},{"value":1012,"label":" Word Contains"}]},{"type":"checkbox","name":"OWNER_SEARCH_YN","defaultValue":false,"label":"Search owners"},{"type":"radio","name":"SERVICE_MARK_YN","label":"Mark Type","defaultValue":"","options":[{"value":"","label":"All Marks"},{"value":"Y","label":"Service Mark"},{"value":"N","label":"Trademark"}]},{"type":"serverSelect","name":"STATUS_ID","optionsSrc":"TYPE_V|TRADEMARK_STATUS_TYPE","label":"Status","placeholder":"All","defaultValue":"0"},{"type":"select","name":"DESIGN_TYPE_ID","options":[{"value":0,"label":"All"},{"value":990,"label":"Words Only"},{"value":991,"label":"Design Only"},{"value":992,"label":"Words and Design"}],"label":"Design Type","defaultValue":"0"},{"type":"dateRange","name":"FILING_DATE","label":"Registered Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}},{"type":"dateRange","name":"EXPIRATION_DATE","label":"Expiration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}}]},{"label":"Business Info Request","component":"InfoRequests","parameter":"info-request","sourceTypeId":167,"allowedRoutes":["/forms-manager/","/queue/","/forms/"]},{"label":"Data Requests","component":"DataRequests","parameter":"data-request","sourceTypeId":0,"allowedRoutes":["/forms-manager/"]},{"label":"CRA","component":"CRA","parameter":"cra","sourceTypeId":157,"myRecordsSearch":false,"searchPlaceholder":"Search by name or registered agent number","allowedRoutes":["/forms-manager/","/forms/","/records/","/queue/","/search/"],"allowEmptySearchTerm":true,"fileAmendmentButtonLabel":"Filing Actions","advancedSearchParameters":[{"type":"radio","name":"QUERY_TYPE_ID","defaultValue":1010,"options":[{"value":1010,"label":"Starts with"},{"value":1011,"label":"Contains"},{"value":1012,"label":" Word Contains"}]},{"type":"dateRange","name":"CRA_DATE","label":"Registration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}},{"type":"select","name":"STATUS_ID","label":"Status","defaultValue":0,"options":[{"value":0,"label":"All"},{"value":121,"label":"Active"},{"value":122,"label":"Inactive"}]},{"type":"select","name":"AGENT_TYPE_ID","label":"Agent Type","defaultValue":0,"options":[{"value":0,"label":"All"},{"value":460,"label":"Registered Agent"},{"value":461,"label":"Commercial Registered Agent"}]}]},{"label":"Farm Bill","component":"FarmBill","parameter":"farm-bill","path":"/lists/farm-bill","sourceTypeId":0,"myRecordsSearch":false,"allowedRules":["/search/"],"disabled":true,"searchDescription":"To perform a search, enter a debtor name. Your search results may include: exact debtor name, variations of that name and any filing that includes your search criteria. Punctuation is ignored.\n\nYou can click on \"Advanced\" to refine your search. Under “Advanced” you can search by crop, year, county and SSN/FEIN. As a registered Farm Bill Buyer with the Montana Secretary of State’s office it is important to maintain the confidentiality of the information contained within the Farm Bill Master List. The Farm Bill Master List reflects personal data, such as Social Security Numbers, which are a key piece of personal identifiable information to assist you in determining the existence of a lien against a specific debtor. The distribution of this information beyond its intended purpose is strictly prohibited.\n\nThe debtor's tax identification number has been hidden for confidentiality reasons. You may continue to search on a tax ID number and return debtors that match your search criteria. The SSN/FEIN must be entered without dashes or spaces.","searchMustHaveOneOf":["search","UCC_FARM_PRODUCT_ID","COUNTY"],"searchPlaceholder":"Search by debtor name","advancedSearchParameters":[{"type":"ServerMultiComplete","label":"Product code name(s)","name":"UCC_FARM_PRODUCT_ID","defaultValue":"","optionsSrc":"UCC_FARM_PRODUCT_V"},{"type":"MultiComplete","label":"Year or Range of Years","name":"YEAR_NUM","optionsSrc":"years","startYear":"1968","defaultValue":[],"preMergeOptions":[{"value":"ALL","label":"All"}]},{"type":"serverSelect","label":"State","name":"STATE","defaultValue":"MONTANA","optionsSrc":"STATE"},{"type":"ServerMultiComplete","label":"County","name":"COUNTY","defaultValue":[],"optionsSrc":"COUNTY","overrideSubOptionsSrcFromParameterName":"STATE"},{"type":"checkbox","name":"TIN_SEARCH_YN","defaultValue":false,"label":"Tax Identification Number Search"},{"type":"checkbox","name":"TIN_SORT_YN","defaultValue":false,"label":"Unique ID Sort"}]}],"SYSTEM_NICKNAME":"Online Services Portal","PAYMENT_METHODS":[{"type":"bypass"},{"type":"iTransact"}],"PAYMENT_ALLOW_AMEX":true,"SYSTEM_ID_LABEL":"System Id","DOUBLE_COLUMN_PUBLIC_LOGIN":true,"INTERNAL_USER_MANAGEMENT":true,"ALLOW_PUBLIC_JSON_IMPORT":false,"MAX_FILE_UPLOAD_SIZE":10000000,"REFUND_TEXT":"","RETURN_TO_HOME_ON_LOGOUT":true,"CURRENT_SOS_NAME":"Christi Jacobsen","LOGO_FILENAME":"mt-sos-logo.png","LOGO_ALT":"Christi Jacobsen, Montana Secretary of State","LOGO_FULL_WIDTH":true,"HOME_HIDE_AUTH_HINT":true,"HOME_TITLE":"Montana Secretary of State","CUSTOM_TAB_TITLE":"Official Montana","HOME_SUBTITLE":"Online Business Services","ENTITY_NAME_CONSENT_DESCRIPTION":"","ALLOW_USER_PROFILE_EDITING":true,"COMPARE_FOREIGN_NAME_IN_ENTITY_NAME_VALIDATION":true,"FOREIGN_NAME_FIELD_NAME":"KIMA_PARENT_NAME_INFO","LOGIN_TITLE":"Montana Secretary of State Online Filing Portal Login","PUBLIC_LOGIN_LABEL":"Username","REVERSE_LOGIN_COLUMNS":true,"LOGIN_SEAL_FILENAME":"seal_white.png","SEPARATE_USERNAME_AND_EMAIL":true,"CREATE_ACCOUNT_BUTTON_ALIGN_LEFT":true,"CREATE_ACCOUNT_BUTTON_TEXT":"CREATE AN ACCOUNT","PASSWORD_CUSTOM_ERROR_TEXT":"The password must meet all requirements","ACCOUNT_CREATED_MESSAGE":"Please check your email to verify your account to login and allow a few minutes for this message to arrive. Check your junk/spam folders if you do not find the email in your inbox.","PUBLIC_LOGIN_PLACEHOLDER":" ","DISABLE_DEFAULT_PAYMENT_RADIO":true,"CUSTOM_RESET_PASSWORD_ERROR_MESSAGE":"Username invalid - no account found","PUBLIC_LOGIN_CREATE_DESCRIPTION":"### Existing User:\n\n  - Enter your username and password to login.  \n\n\n  #### - OR -  \n\n\n\n  - Forgot password? Click 'Reset Password' and follow the prompts.\n  - Forgot username? Click 'Forgot Username' and follow the prompts.  \n\n\n  ### New User:\n  ","LOGIN_HELP_LINK":"https://sosmt.gov/business/how-do-i/","LOGIN_HELP_LINK_TEXT":"Need Help?","FORGOT_USERNAME_TEXT":"Forgot Username?","LOGIN_ACTIVE_DIRECTORY_TEXT":"State User Login","MULTIPLE_LOGIN_METHODS":true,"HAS_ACTIVE_DIRECTORY_LOGIN":true,"RESET_PASSWORD_WITH_USERNAME":true,"DOWNLOAD_LINK":true,"SHOW_USERNAME_ACCOUNT_CREATE":true,"SHOW_SCROLL_DOWN_ARROW":true,"SHOW_ADDRESS_ACCOUNT_CREATE":true,"TWO_COLUMN_ACCOUNT_CREATE":true,"RESET_PASSWORD_TIP":"A link to change your password has been sent to your email. Please allow a few minutes for this message to arrive. Please check your junk/spam folders if you do not find the email in your inbox.","FORGOT_PASSWORD_LINK_TEXT":"Reset Password","PHONE_NUMBER_OPTIONAL_ACCOUNT_CREATE":true,"SHOW_REQUIRED_INDICATOR_ACCOUNT_CREATE":true,"PASSWORD_REQUIREMENTS_ACCOUNT_CREATE":"\n    <ul>\n      <li>MUST contain at least 8 characters (12+ recommended)</li>\n      <li>MUST contain at least one uppercase letter.</li>\n      <li>MUST contain at least one lowercase letter.</li>\n      <li>MUST contain at least one number.</li>\n      <li>MUST contain at least one special character (!”#$%&'()*+,-./:;<=>?</li>\n    </ul>\n  ","ALLOW_CERTIFICATION_REQUEST":true,"ALLOW_PUBLIC_CERTIFICATE_REQUEST":true,"ALLOW_COPY_REQUEST":false,"ALLOW_CORRECTION_STYLING":true,"HIDE_DEPRECATION_WARNING":false,"AMEND_ROUTE_PUBLIC":true,"SEAL_FILENAME":"seal.png","SHOPPING_CART":true,"ALLOW_PAYMENT_UPDATE_WITH_EMPTY_CART":true,"RA_EMAIL":true,"RA_WEBSITE":true,"RA_NO_DEFAULT_TYPE":true,"RA_ADDRESS_LABEL":"Street Address","RA_TYPE_SELECTION_DEFAULT":true,"RA_DEFAULT_TYPE":"460","RA_OVERRIDE_TYPE_WITH_DEFAULT":true,"RA_PRINCIPAL_ADDRESS_AMS":true,"UPLOAD_AND_SUBMIT_HIDE_IF_ONE_OPTION":true,"PAYMENT_PROCESSING_MESSAGE":"Your payment is processing - Do not close your browser or click the back button","CHECKOUT_BUTTON_WHEN_PROCESSING_TEXT":"Processing","EFS_CROP_PICKER_NONE_LABEL":"Lien Duration","DISALLOWED_WIZARD_PIECES":["FormationLocale"],"REPEATER_SHOW_EDIT_BUTTON":true,"DATA_REQUEST_PAGE_TITLE":"Data Requests and Subscriptions","DATA_REQUEST_SIDEBAR_LABEL":"Data Requests & Subscriptions","LOGIN_REDIRECTS_TO_EPASS":false,"LOGIN_REDIRECTS_TO_ACTIVE_DIRECTORY":true,"LOGIN_ACTIVE_DIRECTORY_LINK":true,"FETCH_EDIT_USER_LINK":false,"LISTS_FETCH_AVAILABLE_LISTS":true,"POST_WIZARD_SUBMIT_REDIRECT_URL":"/","PIN_REQUEST_ATTESTATIONS":true,"PIN_REQUEST_DESCRIPTION":"Click **Request PIN** to have a new PIN sent to the account holder's email address on file.","OWNERSHIP_REQUEST_DESCRIPTION":"To become an **authorized user** of this record, a current **AUTHORIZED USER** will need to grant you access. To request access, click **Request Access** below.","PIN_REQUEST_SUCCESS_MESSAGE":"The PIN you have requested for this entity has been sent to the email associated with your user account.  You should receive the PIN in approximately 3-5 minutes, depending on your email service provider.","APOSTILLE_HEADER_LABEL":"Verification Information","APOSTILLE_NUMBER_LABEL":"Apostille/Authentication","APOSTILLE_CITY_STATE_OVERRIDE":"HELENA, MT","APOSTILLE_FILING_DATE_LABEL":"Issue Date","APOSTILLE_CITY_STATE_IN_CERTIFIED":true,"NOTARY_EXISTING_FILING":true,"ALLOW_REVOKE_OWN_ACCESS_ONLY":false,"HIDE_CANCEL_ON_ONETIME_DATA_REQUESTS":true,"DATA_REQUESTS_IN_SHOPPING_CART":true,"WQ_ALLOW_EDIT_PENDING_PAYMENT":true,"WQ_CONFIRM_ON_DELETE":true,"WQ_DELETE_CONFIRM_MESSAGE":"Deleting this filing will forfeit any money already paid to the Secretary of State. This action is permanent and cannot be undone, are you sure you would like to delete?","PASS_ITEM_GUIDS_ON_CHECKOUT":true,"FORM_REVISION_HISTORY":true,"CHECKOUT_DISCLAIMER":"By entering your credit card and/or checking account information you (i) state that **you are an authorized user** of the credit card and/or electronic check and that the associated information entered (e.g., account holder name, account number, billing address) is accurate, (ii) **you authorize payment processor to charge the amount you have requested** to your credit card and/or funding account, and (iii) **acknowledge if a charge is declined or reversed you may also be assessed a customary charge** by the payment processor for such transactions.","FARM_BILL_SEARCH_CONFIDENTIAL":"As a registered Farm Bill Buyer with the Montana Secretary of State’s office it is important to maintain the confidentiality of the information contained within the Farm Bill Master List. The Farm Bill Master List reflects personal data, such as Social Security Numbers, which are a key piece of personal identifiable information to assist you in determining the existence of a lien against a specific debtor. The distribution of this information beyond its intended purpose is strictly prohibited.\n\n**The debtor's tax identification number has been hidden for confidentiality reasons. You may continue to search on a tax ID number and return debtors that match your search criteria. The SSN/FEIN must be entered without dashes or spaces.  If you need access to the tax identification number to clearly identify the debtor, please contact the UCC unit at (406) 444-3665.**","VIEW_HISTORY_BUTTON_ALT_TEXT":"View Filings","WIZARD_ERROR_TITLE_MESSAGE":"Form Error","FARM_BILL_SEARCH_INTERACTIVE":true,"USE_FARM_BILL_API":true,"DISALLOW_ASSIGN_SELF_AS_RA":true,"DISALLOW_ASSIGN_SELF_AS_PRINCIPAL":true,"USE_TRADEMARK_OWNER_VALIDATION":true,"USE_ALTERNATIVE_FOREIGN_ADDRESS_LABELS":true,"MY_RECEIPTS_FILTER":[{"type":"dateRange","name":"DATE_RANGE","label":"Date range","defaultValue":{"start":null,"end":null}},{"type":"text","name":"REF_NUM","defaultValue":"","label":"Reference Number"},{"type":"text","name":"RECEIPT_NUM","defaultValue":"","label":"Receipt Id"},{"type":"text","name":"AMOUNT","defaultValue":"","label":"Amount"},{"type":"select","name":"TYPE","defaultValue":"","label":"Payment Type","options":[{"value":"","label":"All"},{"value":"CC","label":"Credit Card"},{"value":"Check","label":"Check"}]}],"MY_RECEIPTS_SHOW_IN_SIDEBAR":true,"SHOW_MY_RECEIPTS_HELPER_TEXT":true,"MY_RECEIPTS_HELPER_LABEL":"About Receipt Search","MY_RECEIPTS_HELPER_TEXT":"You can search for receipts based on their descriptions, including the items paid for on the receipt. Use the filters to search for or filter specific information.","FARM_BILL_SUBLINK":{"label":"Farm Bill","component":"FarmBill","parameter":"farm-bill","path":"/lists/farm-bill","sourceTypeId":0,"myRecordsSearch":false,"allowedRules":["/search/"],"disabled":true,"searchDescription":"To perform a search, enter a debtor name. Your search results may include: exact debtor name, variations of that name and any filing that includes your search criteria. Punctuation is ignored.\n\nYou can click on \"Advanced\" to refine your search. Under “Advanced” you can search by crop, year, county and SSN/FEIN. As a registered Farm Bill Buyer with the Montana Secretary of State’s office it is important to maintain the confidentiality of the information contained within the Farm Bill Master List. The Farm Bill Master List reflects personal data, such as Social Security Numbers, which are a key piece of personal identifiable information to assist you in determining the existence of a lien against a specific debtor. The distribution of this information beyond its intended purpose is strictly prohibited.\n\nThe debtor's tax identification number has been hidden for confidentiality reasons. You may continue to search on a tax ID number and return debtors that match your search criteria. The SSN/FEIN must be entered without dashes or spaces.","searchMustHaveOneOf":["search","UCC_FARM_PRODUCT_ID","COUNTY"],"searchPlaceholder":"Search by debtor name","advancedSearchParameters":[{"type":"ServerMultiComplete","label":"Product code name(s)","name":"UCC_FARM_PRODUCT_ID","defaultValue":"","optionsSrc":"UCC_FARM_PRODUCT_V"},{"type":"MultiComplete","label":"Year or Range of Years","name":"YEAR_NUM","optionsSrc":"years","startYear":"1968","defaultValue":[],"preMergeOptions":[{"value":"ALL","label":"All"}]},{"type":"serverSelect","label":"State","name":"STATE","defaultValue":"MONTANA","optionsSrc":"STATE"},{"type":"ServerMultiComplete","label":"County","name":"COUNTY","defaultValue":[],"optionsSrc":"COUNTY","overrideSubOptionsSrcFromParameterName":"STATE"},{"type":"checkbox","name":"TIN_SEARCH_YN","defaultValue":false,"label":"Tax Identification Number Search"},{"type":"checkbox","name":"TIN_SORT_YN","defaultValue":false,"label":"Unique ID Sort"}]},"ALLOW_ADDRESS_VALIDATION_BYPASS_OPTION":true,"DEFAULT_ADDRESS_VALIDATION_BYPASS_OPTION_CHECKED":true}).FOOTER_LINKS;
	var LOGO_LINK_URL = ({"NODE_ENV":"production","BUILD_DATE":"2025-08-27T15:15:31.687Z","BUILD_NUMBER":"Not Provided","GIT_VERSION":"v1.3.0-381-ga81e29b08","GIT_COMMIT_HASH":"a81e29b085c9268ffd96c78eb734365802722741","GIT_BRANCH":"beta","PUBLIC_URL":"","STATE_ABBR":"MT","STATE_NAME":"Montana","STATE_ORG_TITLE":"Secretary of State","LOGIN_HEADER_IMG_PATH":"","HOME_IMG_FILENAME":"montana.jpg","FAVICON_FILE_NAME":"favicon.ico","ALLOW_E_SIGN_ON_CORRECTIONS":true,"THIRD_PARTY_SIGNING_ALLOWED":false,"MY_ACCOUNT_SAVE_AND_CLOSE_BUTTON":true,"IE_DEPRECATED_MESSAGE":"Internet Explorer is not supported. Please select a supported browser below to access this website.","ADDITIONAL_ROUTES":{"dataRequests":true,"farmBill":true,"apostille":true,"externalHelp":"https://sosmt.gov/business/help-center/","systemAdministration":[{"title":"Saved Payments","parameter":"saved-payments","componentName":"SavedPayments"}]},"SUBROUTES":[{"label":"Business","component":"Business","parameter":"business","myWorkQueueSearch":false,"sourceTypeId":54,"searchMustHaveOneOf":["FILING_TYPE_ID","STATUS_ID","STATE","search"],"serverWebSearchDescription":true,"serverWorkQueueDescription":true,"serverMyRecordsDescription":true,"searchPlaceholder":"Search by name or filing number (X########)","allowEmptySearchTerm":true,"requestCertificateAlternateLabel":"Request Information","fileAmendmentButtonLabel":"Filing Actions","advancedSearchParameters":[{"type":"radio","name":"QUERY_TYPE_ID","defaultValue":1010,"options":[{"value":1010,"label":"Starts with"},{"value":1011,"label":"Contains"},{"value":1012,"label":" Word Contains"}]},{"type":"serverSelect","name":"FILING_TYPE_ID","optionsSrc":"FILING_TYPES","label":"Entity Type","placeholder":"All","defaultValue":"0"},{"type":"serverSelect","name":"FILING_SUBTYPE_ID","optionsSrc":"FILING_SUBTYPES","label":"Entity Subtype","overrideSubOptionsSrcFromParameterName":"FILING_TYPE_ID","placeholder":"All","defaultValue":"0"},{"type":"serverSelect","name":"STATUS_ID","optionsSrc":"FILING_STATUS_WITHOUT_ALL","label":"Status","placeholder":"All","defaultValue":"0"},{"type":"serverSelect","name":"STATE","optionsSrc":"STATE","label":"State","placeholder":"All","defaultValue":""},{"type":"serverSelect","name":"COUNTY","optionsSrc":"COUNTY_SUBOPTION","label":"County","overrideSubOptionsSrcFromParameterName":"STATE","placeholder":"All","defaultValue":""},{"type":"checkbox","name":"CRA_SEARCH_YN","defaultValue":false,"label":"Search by Registered Agent PID"},{"type":"dateRange","name":"FILING_DATE","label":"Registration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}},{"type":"dateRange","name":"EXPIRATION_DATE","label":"Expiration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}}],"myRecordsFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Active"},{"value":2,"label":"Inactive"},{"value":3,"label":"Pending"}]},{"type":"dateRange","name":"DATE_RANGE","label":"Date range","defaultValue":{"start":null,"end":null}}],"myWorkQueueFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Approved"},{"value":2,"label":"Pending Online Payment"},{"value":3,"label":"Pending Review"},{"value":4,"label":"Needs Correction"},{"value":5,"label":"Rejected"},{"value":6,"label":"Draft"}]},{"type":"dateRange","name":"DATE_RANGE","label":"Date range","defaultValue":{"start":null,"end":null}}]},{"label":"Notary","component":"Notary","parameter":"notary","sourceTypeId":850,"myWorkQueueSearch":false,"allowEmptySearchTerm":true,"requestCertificateAlternateLabel":"Download Certificate","fileAmendmentButtonLabel":"Filing Actions","hideNameRequestCertificate":true,"hideAddressRequestCertificate":true,"hideRecordUserManagment":true,"searchPlaceholder":"Search by name or commission number","searchMustHaveOneOf":["CITY","search","SERVICE_TYPE"],"advancedParametersStartOpen":true,"searchIsSortable":true,"advancedSearchParameters":[{"type":"radio","name":"STARTS_WITH_YN","defaultValue":false,"options":[{"value":true,"label":"Starts with"},{"value":false,"label":"Contains"}]},{"type":"checkbox","name":"ACTIVE_ONLY_YN","defaultValue":true,"label":"Active entities only"},{"type":"text","name":"CITY","defaultValue":"","label":"City"},{"type":"select","name":"SERVICE_TYPE","label":"Special Services Offered","defaultValue":0,"options":[{"value":0,"label":"(N/A)"},{"value":6165,"label":"In-Person Electronic Notarization (IPEN)"},{"value":6166,"label":"Remote Online Notarization (RON)"},{"value":6167,"label":"Mobile Notary Services"},{"value":6168,"label":"Remote Ink Notarization (RIN)"}]}]},{"label":"Apostille","component":"Apostille","parameter":"apostille","sourceTypeId":720,"myRecordsSearch":false,"myWorkQueueSearch":false,"disabled":false,"allowedRoutes":["/forms-manager/","/queue/","/forms/"]},{"label":"Liens","component":"UCC","parameter":"ucc","sourceTypeId":1999,"myRecordsSearch":true,"myWorkQueueSearch":true,"fileAmendmentButtonLabel":"Filing Actions","searchPlaceholder":"Search by name or file number","disabled":false,"serverWebSearchDescription":true,"myRecordsDescription":"","workQueueDescription":"","searchDescription":"","hideRecordUserManagment":true,"searchLiensCheckout":false,"advancedSearchParameters":[{"type":"radio","name":"STARTS_WITH_YN","defaultValue":false,"options":[{"value":true,"label":"Starts with"},{"value":false,"label":"Contains"}]},{"type":"select","name":"STATUS","defaultValue":"ALL","label":"Status","options":[{"value":"ACTIVE_UNLAPSED","label":"Active (unlapsed)"},{"value":"ACTIVE_LAPSED_UNLAPSED","label":"Active (lapsed and unlapsed)"}]},{"type":"text","name":"EXCLUDE_VALUES","label":"Exclude Debtor Names (comma separated list of names to exclude)","defaultValue":""},{"type":"dateRange","name":"FILING_DATE","label":"Financing Statement Date","defaultValue":{"start":null,"end":null}},{"type":"dateRange","name":"LAPSE_DATE","label":"Lapse Date","defaultValue":{"start":null,"end":null}},{"type":"text","name":"CITY","label":"Debtor City","defaultValue":""}],"myRecordsFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Approved"},{"value":2,"label":"Pending Online Payment"},{"value":3,"label":"Pending Review"}]},{"type":"select","name":"TYPE","defaultValue":0,"label":"Lien Type","options":[{"value":0,"label":"All"},{"value":1,"label":"UCC"},{"value":2,"label":"EFS"},{"value":3,"label":"Title 71"}]}],"myWorkQueueFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Approved"},{"value":2,"label":"Pending Online Payment"},{"value":3,"label":"Pending Review"},{"value":4,"label":"Pending Print and Mail"},{"value":5,"label":"Rejected"},{"value":6,"label":"Draft"}]},{"type":"select","name":"TYPE","defaultValue":0,"label":"Lien Type","options":[{"value":0,"label":"All"},{"value":1,"label":"UCC"},{"value":2,"label":"EFS"},{"value":3,"label":"Title 71"}]}]},{"label":"Copy Request","component":"copies","parameter":"copies","sourceTypeId":2001,"myRecordsSearch":false,"myWorkQueueSearch":false,"disabled":false,"allowedRoutes":["/forms-manager/","/queue/","/forms/"]},{"label":"Trademark","component":"Trademark","parameter":"trademark","sourceTypeId":810,"showRequestCertificate":true,"searchMustHaveOneOf":["search","EXPIRATION_DATE","FILING_DATE"],"allowEmptySearchTerm":true,"requestCertificateAlternateLabel":"Request Information","fileAmendmentButtonLabel":"Filing Actions","advancedSearchParameters":[{"type":"radio","name":"QUERY_TYPE_ID","defaultValue":1010,"options":[{"value":1010,"label":"Starts with"},{"value":1011,"label":"Contains"},{"value":1012,"label":" Word Contains"}]},{"type":"checkbox","name":"OWNER_SEARCH_YN","defaultValue":false,"label":"Search owners"},{"type":"radio","name":"SERVICE_MARK_YN","label":"Mark Type","defaultValue":"","options":[{"value":"","label":"All Marks"},{"value":"Y","label":"Service Mark"},{"value":"N","label":"Trademark"}]},{"type":"serverSelect","name":"STATUS_ID","optionsSrc":"TYPE_V|TRADEMARK_STATUS_TYPE","label":"Status","placeholder":"All","defaultValue":"0"},{"type":"select","name":"DESIGN_TYPE_ID","options":[{"value":0,"label":"All"},{"value":990,"label":"Words Only"},{"value":991,"label":"Design Only"},{"value":992,"label":"Words and Design"}],"label":"Design Type","defaultValue":"0"},{"type":"dateRange","name":"FILING_DATE","label":"Registered Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}},{"type":"dateRange","name":"EXPIRATION_DATE","label":"Expiration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}}]},{"label":"Business Info Request","component":"InfoRequests","parameter":"info-request","sourceTypeId":167,"allowedRoutes":["/forms-manager/","/queue/","/forms/"]},{"label":"Data Requests","component":"DataRequests","parameter":"data-request","sourceTypeId":0,"allowedRoutes":["/forms-manager/"]},{"label":"CRA","component":"CRA","parameter":"cra","sourceTypeId":157,"myRecordsSearch":false,"searchPlaceholder":"Search by name or registered agent number","allowedRoutes":["/forms-manager/","/forms/","/records/","/queue/","/search/"],"allowEmptySearchTerm":true,"fileAmendmentButtonLabel":"Filing Actions","advancedSearchParameters":[{"type":"radio","name":"QUERY_TYPE_ID","defaultValue":1010,"options":[{"value":1010,"label":"Starts with"},{"value":1011,"label":"Contains"},{"value":1012,"label":" Word Contains"}]},{"type":"dateRange","name":"CRA_DATE","label":"Registration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}},{"type":"select","name":"STATUS_ID","label":"Status","defaultValue":0,"options":[{"value":0,"label":"All"},{"value":121,"label":"Active"},{"value":122,"label":"Inactive"}]},{"type":"select","name":"AGENT_TYPE_ID","label":"Agent Type","defaultValue":0,"options":[{"value":0,"label":"All"},{"value":460,"label":"Registered Agent"},{"value":461,"label":"Commercial Registered Agent"}]}]},{"label":"Farm Bill","component":"FarmBill","parameter":"farm-bill","path":"/lists/farm-bill","sourceTypeId":0,"myRecordsSearch":false,"allowedRules":["/search/"],"disabled":true,"searchDescription":"To perform a search, enter a debtor name. Your search results may include: exact debtor name, variations of that name and any filing that includes your search criteria. Punctuation is ignored.\n\nYou can click on \"Advanced\" to refine your search. Under “Advanced” you can search by crop, year, county and SSN/FEIN. As a registered Farm Bill Buyer with the Montana Secretary of State’s office it is important to maintain the confidentiality of the information contained within the Farm Bill Master List. The Farm Bill Master List reflects personal data, such as Social Security Numbers, which are a key piece of personal identifiable information to assist you in determining the existence of a lien against a specific debtor. The distribution of this information beyond its intended purpose is strictly prohibited.\n\nThe debtor's tax identification number has been hidden for confidentiality reasons. You may continue to search on a tax ID number and return debtors that match your search criteria. The SSN/FEIN must be entered without dashes or spaces.","searchMustHaveOneOf":["search","UCC_FARM_PRODUCT_ID","COUNTY"],"searchPlaceholder":"Search by debtor name","advancedSearchParameters":[{"type":"ServerMultiComplete","label":"Product code name(s)","name":"UCC_FARM_PRODUCT_ID","defaultValue":"","optionsSrc":"UCC_FARM_PRODUCT_V"},{"type":"MultiComplete","label":"Year or Range of Years","name":"YEAR_NUM","optionsSrc":"years","startYear":"1968","defaultValue":[],"preMergeOptions":[{"value":"ALL","label":"All"}]},{"type":"serverSelect","label":"State","name":"STATE","defaultValue":"MONTANA","optionsSrc":"STATE"},{"type":"ServerMultiComplete","label":"County","name":"COUNTY","defaultValue":[],"optionsSrc":"COUNTY","overrideSubOptionsSrcFromParameterName":"STATE"},{"type":"checkbox","name":"TIN_SEARCH_YN","defaultValue":false,"label":"Tax Identification Number Search"},{"type":"checkbox","name":"TIN_SORT_YN","defaultValue":false,"label":"Unique ID Sort"}]}],"SYSTEM_NICKNAME":"Online Services Portal","PAYMENT_METHODS":[{"type":"bypass"},{"type":"iTransact"}],"PAYMENT_ALLOW_AMEX":true,"SYSTEM_ID_LABEL":"System Id","DOUBLE_COLUMN_PUBLIC_LOGIN":true,"INTERNAL_USER_MANAGEMENT":true,"ALLOW_PUBLIC_JSON_IMPORT":false,"MAX_FILE_UPLOAD_SIZE":10000000,"REFUND_TEXT":"","RETURN_TO_HOME_ON_LOGOUT":true,"CURRENT_SOS_NAME":"Christi Jacobsen","LOGO_FILENAME":"mt-sos-logo.png","LOGO_ALT":"Christi Jacobsen, Montana Secretary of State","LOGO_FULL_WIDTH":true,"HOME_HIDE_AUTH_HINT":true,"HOME_TITLE":"Montana Secretary of State","CUSTOM_TAB_TITLE":"Official Montana","HOME_SUBTITLE":"Online Business Services","ENTITY_NAME_CONSENT_DESCRIPTION":"","ALLOW_USER_PROFILE_EDITING":true,"COMPARE_FOREIGN_NAME_IN_ENTITY_NAME_VALIDATION":true,"FOREIGN_NAME_FIELD_NAME":"KIMA_PARENT_NAME_INFO","LOGIN_TITLE":"Montana Secretary of State Online Filing Portal Login","PUBLIC_LOGIN_LABEL":"Username","REVERSE_LOGIN_COLUMNS":true,"LOGIN_SEAL_FILENAME":"seal_white.png","SEPARATE_USERNAME_AND_EMAIL":true,"CREATE_ACCOUNT_BUTTON_ALIGN_LEFT":true,"CREATE_ACCOUNT_BUTTON_TEXT":"CREATE AN ACCOUNT","PASSWORD_CUSTOM_ERROR_TEXT":"The password must meet all requirements","ACCOUNT_CREATED_MESSAGE":"Please check your email to verify your account to login and allow a few minutes for this message to arrive. Check your junk/spam folders if you do not find the email in your inbox.","PUBLIC_LOGIN_PLACEHOLDER":" ","DISABLE_DEFAULT_PAYMENT_RADIO":true,"CUSTOM_RESET_PASSWORD_ERROR_MESSAGE":"Username invalid - no account found","PUBLIC_LOGIN_CREATE_DESCRIPTION":"### Existing User:\n\n  - Enter your username and password to login.  \n\n\n  #### - OR -  \n\n\n\n  - Forgot password? Click 'Reset Password' and follow the prompts.\n  - Forgot username? Click 'Forgot Username' and follow the prompts.  \n\n\n  ### New User:\n  ","LOGIN_HELP_LINK":"https://sosmt.gov/business/how-do-i/","LOGIN_HELP_LINK_TEXT":"Need Help?","FORGOT_USERNAME_TEXT":"Forgot Username?","LOGIN_ACTIVE_DIRECTORY_TEXT":"State User Login","MULTIPLE_LOGIN_METHODS":true,"HAS_ACTIVE_DIRECTORY_LOGIN":true,"RESET_PASSWORD_WITH_USERNAME":true,"DOWNLOAD_LINK":true,"SHOW_USERNAME_ACCOUNT_CREATE":true,"SHOW_SCROLL_DOWN_ARROW":true,"SHOW_ADDRESS_ACCOUNT_CREATE":true,"TWO_COLUMN_ACCOUNT_CREATE":true,"RESET_PASSWORD_TIP":"A link to change your password has been sent to your email. Please allow a few minutes for this message to arrive. Please check your junk/spam folders if you do not find the email in your inbox.","FORGOT_PASSWORD_LINK_TEXT":"Reset Password","PHONE_NUMBER_OPTIONAL_ACCOUNT_CREATE":true,"SHOW_REQUIRED_INDICATOR_ACCOUNT_CREATE":true,"PASSWORD_REQUIREMENTS_ACCOUNT_CREATE":"\n    <ul>\n      <li>MUST contain at least 8 characters (12+ recommended)</li>\n      <li>MUST contain at least one uppercase letter.</li>\n      <li>MUST contain at least one lowercase letter.</li>\n      <li>MUST contain at least one number.</li>\n      <li>MUST contain at least one special character (!”#$%&'()*+,-./:;<=>?</li>\n    </ul>\n  ","ALLOW_CERTIFICATION_REQUEST":true,"ALLOW_PUBLIC_CERTIFICATE_REQUEST":true,"ALLOW_COPY_REQUEST":false,"ALLOW_CORRECTION_STYLING":true,"HIDE_DEPRECATION_WARNING":false,"AMEND_ROUTE_PUBLIC":true,"SEAL_FILENAME":"seal.png","SHOPPING_CART":true,"ALLOW_PAYMENT_UPDATE_WITH_EMPTY_CART":true,"RA_EMAIL":true,"RA_WEBSITE":true,"RA_NO_DEFAULT_TYPE":true,"RA_ADDRESS_LABEL":"Street Address","RA_TYPE_SELECTION_DEFAULT":true,"RA_DEFAULT_TYPE":"460","RA_OVERRIDE_TYPE_WITH_DEFAULT":true,"RA_PRINCIPAL_ADDRESS_AMS":true,"UPLOAD_AND_SUBMIT_HIDE_IF_ONE_OPTION":true,"PAYMENT_PROCESSING_MESSAGE":"Your payment is processing - Do not close your browser or click the back button","CHECKOUT_BUTTON_WHEN_PROCESSING_TEXT":"Processing","EFS_CROP_PICKER_NONE_LABEL":"Lien Duration","DISALLOWED_WIZARD_PIECES":["FormationLocale"],"REPEATER_SHOW_EDIT_BUTTON":true,"DATA_REQUEST_PAGE_TITLE":"Data Requests and Subscriptions","DATA_REQUEST_SIDEBAR_LABEL":"Data Requests & Subscriptions","LOGIN_REDIRECTS_TO_EPASS":false,"LOGIN_REDIRECTS_TO_ACTIVE_DIRECTORY":true,"LOGIN_ACTIVE_DIRECTORY_LINK":true,"FETCH_EDIT_USER_LINK":false,"LISTS_FETCH_AVAILABLE_LISTS":true,"POST_WIZARD_SUBMIT_REDIRECT_URL":"/","PIN_REQUEST_ATTESTATIONS":true,"PIN_REQUEST_DESCRIPTION":"Click **Request PIN** to have a new PIN sent to the account holder's email address on file.","OWNERSHIP_REQUEST_DESCRIPTION":"To become an **authorized user** of this record, a current **AUTHORIZED USER** will need to grant you access. To request access, click **Request Access** below.","PIN_REQUEST_SUCCESS_MESSAGE":"The PIN you have requested for this entity has been sent to the email associated with your user account.  You should receive the PIN in approximately 3-5 minutes, depending on your email service provider.","APOSTILLE_HEADER_LABEL":"Verification Information","APOSTILLE_NUMBER_LABEL":"Apostille/Authentication","APOSTILLE_CITY_STATE_OVERRIDE":"HELENA, MT","APOSTILLE_FILING_DATE_LABEL":"Issue Date","APOSTILLE_CITY_STATE_IN_CERTIFIED":true,"NOTARY_EXISTING_FILING":true,"ALLOW_REVOKE_OWN_ACCESS_ONLY":false,"HIDE_CANCEL_ON_ONETIME_DATA_REQUESTS":true,"DATA_REQUESTS_IN_SHOPPING_CART":true,"WQ_ALLOW_EDIT_PENDING_PAYMENT":true,"WQ_CONFIRM_ON_DELETE":true,"WQ_DELETE_CONFIRM_MESSAGE":"Deleting this filing will forfeit any money already paid to the Secretary of State. This action is permanent and cannot be undone, are you sure you would like to delete?","PASS_ITEM_GUIDS_ON_CHECKOUT":true,"FORM_REVISION_HISTORY":true,"CHECKOUT_DISCLAIMER":"By entering your credit card and/or checking account information you (i) state that **you are an authorized user** of the credit card and/or electronic check and that the associated information entered (e.g., account holder name, account number, billing address) is accurate, (ii) **you authorize payment processor to charge the amount you have requested** to your credit card and/or funding account, and (iii) **acknowledge if a charge is declined or reversed you may also be assessed a customary charge** by the payment processor for such transactions.","FARM_BILL_SEARCH_CONFIDENTIAL":"As a registered Farm Bill Buyer with the Montana Secretary of State’s office it is important to maintain the confidentiality of the information contained within the Farm Bill Master List. The Farm Bill Master List reflects personal data, such as Social Security Numbers, which are a key piece of personal identifiable information to assist you in determining the existence of a lien against a specific debtor. The distribution of this information beyond its intended purpose is strictly prohibited.\n\n**The debtor's tax identification number has been hidden for confidentiality reasons. You may continue to search on a tax ID number and return debtors that match your search criteria. The SSN/FEIN must be entered without dashes or spaces.  If you need access to the tax identification number to clearly identify the debtor, please contact the UCC unit at (406) 444-3665.**","VIEW_HISTORY_BUTTON_ALT_TEXT":"View Filings","WIZARD_ERROR_TITLE_MESSAGE":"Form Error","FARM_BILL_SEARCH_INTERACTIVE":true,"USE_FARM_BILL_API":true,"DISALLOW_ASSIGN_SELF_AS_RA":true,"DISALLOW_ASSIGN_SELF_AS_PRINCIPAL":true,"USE_TRADEMARK_OWNER_VALIDATION":true,"USE_ALTERNATIVE_FOREIGN_ADDRESS_LABELS":true,"MY_RECEIPTS_FILTER":[{"type":"dateRange","name":"DATE_RANGE","label":"Date range","defaultValue":{"start":null,"end":null}},{"type":"text","name":"REF_NUM","defaultValue":"","label":"Reference Number"},{"type":"text","name":"RECEIPT_NUM","defaultValue":"","label":"Receipt Id"},{"type":"text","name":"AMOUNT","defaultValue":"","label":"Amount"},{"type":"select","name":"TYPE","defaultValue":"","label":"Payment Type","options":[{"value":"","label":"All"},{"value":"CC","label":"Credit Card"},{"value":"Check","label":"Check"}]}],"MY_RECEIPTS_SHOW_IN_SIDEBAR":true,"SHOW_MY_RECEIPTS_HELPER_TEXT":true,"MY_RECEIPTS_HELPER_LABEL":"About Receipt Search","MY_RECEIPTS_HELPER_TEXT":"You can search for receipts based on their descriptions, including the items paid for on the receipt. Use the filters to search for or filter specific information.","FARM_BILL_SUBLINK":{"label":"Farm Bill","component":"FarmBill","parameter":"farm-bill","path":"/lists/farm-bill","sourceTypeId":0,"myRecordsSearch":false,"allowedRules":["/search/"],"disabled":true,"searchDescription":"To perform a search, enter a debtor name. Your search results may include: exact debtor name, variations of that name and any filing that includes your search criteria. Punctuation is ignored.\n\nYou can click on \"Advanced\" to refine your search. Under “Advanced” you can search by crop, year, county and SSN/FEIN. As a registered Farm Bill Buyer with the Montana Secretary of State’s office it is important to maintain the confidentiality of the information contained within the Farm Bill Master List. The Farm Bill Master List reflects personal data, such as Social Security Numbers, which are a key piece of personal identifiable information to assist you in determining the existence of a lien against a specific debtor. The distribution of this information beyond its intended purpose is strictly prohibited.\n\nThe debtor's tax identification number has been hidden for confidentiality reasons. You may continue to search on a tax ID number and return debtors that match your search criteria. The SSN/FEIN must be entered without dashes or spaces.","searchMustHaveOneOf":["search","UCC_FARM_PRODUCT_ID","COUNTY"],"searchPlaceholder":"Search by debtor name","advancedSearchParameters":[{"type":"ServerMultiComplete","label":"Product code name(s)","name":"UCC_FARM_PRODUCT_ID","defaultValue":"","optionsSrc":"UCC_FARM_PRODUCT_V"},{"type":"MultiComplete","label":"Year or Range of Years","name":"YEAR_NUM","optionsSrc":"years","startYear":"1968","defaultValue":[],"preMergeOptions":[{"value":"ALL","label":"All"}]},{"type":"serverSelect","label":"State","name":"STATE","defaultValue":"MONTANA","optionsSrc":"STATE"},{"type":"ServerMultiComplete","label":"County","name":"COUNTY","defaultValue":[],"optionsSrc":"COUNTY","overrideSubOptionsSrcFromParameterName":"STATE"},{"type":"checkbox","name":"TIN_SEARCH_YN","defaultValue":false,"label":"Tax Identification Number Search"},{"type":"checkbox","name":"TIN_SORT_YN","defaultValue":false,"label":"Unique ID Sort"}]},"ALLOW_ADDRESS_VALIDATION_BYPASS_OPTION":true,"DEFAULT_ADDRESS_VALIDATION_BYPASS_OPTION_CHECKED":true}).LOGO_LINK_URL || '/';
	var SHOPPING_CART = (true);
	var LOGO_FULL_WIDTH = (true);
	
	var Content = exports.Content = function Content(_ref) {
	  var children = _ref.children,
	      subLinks = _ref.subLinks,
	      sidebarCollapsed = _ref.sidebarCollapsed,
	      isMobile = _ref.isMobile,
	      currentPath = _ref.currentPath,
	      currentRoute = _ref.currentRoute,
	      hideAppShell = _ref.hideAppShell,
	      hideSidebar = _ref.hideSidebar;
	
	  return _react2.default.createElement(
	    'div',
	    {
	      className: 'content ' + (sidebarCollapsed ? 'sidebar-collapsed ' : ' ') + ' ' + (isMobile ? 'mobile' : '') + ' ' + (hideAppShell ? 'no-shell' : '')
	    },
	    hideAppShell ? _react2.default.createElement(
	      _reactHelmet.Helmet,
	      null,
	      _react2.default.createElement(
	        'style',
	        { type: 'text/css' },
	        'header.main-header, nav.sidebar, footer, .skip-link{\n              display: none !important;\n            }'
	      )
	    ) : null,
	    hideSidebar ? _react2.default.createElement(
	      _reactHelmet.Helmet,
	      null,
	      _react2.default.createElement(
	        'style',
	        { type: 'text/css' },
	        'nav.sidebar{\n              display: none !important;\n            }'
	      )
	    ) : null,
	    _react2.default.createElement(Header, { subLinks: subLinks, currentPath: currentPath, currentRoute: currentRoute }),
	    _react2.default.createElement(
	      'div',
	      {
	        className: 'body-wrapper ' + (sidebarCollapsed ? 'sidebar-collapsed ' : ' ') + (isMobile ? 'mobile' : '')
	      },
	      children
	    )
	  );
	};
	exports.Content = Content = (0, _reactRedux.connect)(function (state) {
	  return {
	    sidebarCollapsed: state.app.sidebarCollapsed,
	    isMobile: state.app.isMobile,
	    sidebarShown: state.app.sidebarShown
	  };
	})(Content);
	
	var Header = function (_Component) {
	  _inherits(Header, _Component);
	
	  function Header() {
	    var _ref2;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, Header);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref2 = Header.__proto__ || Object.getPrototypeOf(Header)).call.apply(_ref2, [this].concat(args))), _this), _this.state = {
	      sublinkMenuOpen: false,
	      sublinkMenuAnchor: null,
	      sublinkMenuVisible: false
	    }, _this.componentWillMount = function () {
	      window.addEventListener('resize', _this.toggleMenuType);
	    }, _this.componentDidMount = function () {
	      _this.toggleMenuType();
	    }, _this.componentDidUpdate = function (prevProps) {
	      if (_this.props.currentPath !== prevProps.currentPath) {
	        _this.toggleMenuType();
	      }
	    }, _this.componentWillUnmount = function () {
	      window.removeEventListener('resize', _this.toggleMenuType);
	    }, _this.toggleMenuType = function (e) {
	      var headerHeight = _this.header.offsetHeight;
	      var navHeight = _this.navLinks.offsetHeight;
	      if (navHeight > headerHeight) {
	        if (_this.state.sublinkMenuVisible === false) {
	          _this.setState({
	            sublinkMenuVisible: true
	          });
	        }
	      } else {
	        if (_this.state.sublinkMenuVisible === true) {
	          _this.setState({
	            sublinkMenuVisible: false
	          });
	        }
	      }
	    }, _this.toggleSidebarShow = function () {
	      _this.props.toggleSidebarShow(true);
	      document.body.style.overflow = 'hidden';
	    }, _this.openSublinkMenu = function () {
	      _this.setState({ sublinkMenuOpen: true, sublinkMenuAnchor: _this.sublinkMenuButton });
	    }, _this.closeSublinkMenu = function () {
	      _this.setState({ sublinkMenuOpen: false });
	    }, _this.navigate = function (link) {
	      _store.history.push(link.value);
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(Header, [{
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _props = this.props,
	          isMobile = _props.isMobile,
	          sidebarShown = _props.sidebarShown,
	          _props$subLinks = _props.subLinks,
	          subLinks = _props$subLinks === undefined ? [] : _props$subLinks,
	          currentPath = _props.currentPath;
	
	      var linkSplit = currentPath ? currentPath.split('/') : [];
	      var currentSublink = _App.SUBROUTES_OBJ[linkSplit[linkSplit.length - 1]] || {};
	      return _react2.default.createElement(
	        'header',
	        { className: 'main-header ' + (isMobile ? "mobile" : ""), ref: function ref(r) {
	            _this2.header = r;
	          } },
	        !isMobile && _react2.default.createElement(
	          'a',
	          { className: 'child-focus', tabIndex: '2', href: LOGO_LINK_URL, 'aria-label': ("Montana") + ' ' + ("Secretary of State") },
	          _react2.default.createElement(
	            'div',
	            { className: "branding " + (sidebarShown ? "show" : "") },
	            LOGO_FILENAME ? _react2.default.createElement(
	              'div',
	              { className: 'logo-wrapper ' + (LOGO_FULL_WIDTH ? 'full-width' : '') },
	              _react2.default.createElement('img', { src: Logo, alt: LOGO_ALT })
	            ) : _react2.default.createElement(
	              _react2.default.Fragment,
	              null,
	              _react2.default.createElement('img', { src: Logo, alt: LOGO_ALT }),
	              _react2.default.createElement(
	                'span',
	                { className: 'title-container' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'statetitle' },
	                  ("Montana")
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'subtext' },
	                  ("Secretary of State")
	                )
	              )
	            )
	          )
	        ),
	        isMobile ? _react2.default.createElement(
	          'button',
	          { tabIndex: '2', className: 'sidebar-toggle', onClick: this.toggleSidebarShow, 'aria-label': 'Show/hide menu', 'aria-expanded': this.props.sidebarShown },
	          _react2.default.createElement(
	            'div',
	            { className: 'center' },
	            _react2.default.createElement(_hamburger2.default, null)
	          )
	        ) : null,
	        _react2.default.createElement(
	          'nav',
	          { className: 'sublinks-wrapper' },
	          _react2.default.createElement(
	            'div',
	            { className: 'sublinks', ref: function ref(r) {
	                _this2.navLinks = r;
	              } },
	            _react2.default.createElement('div', { className: 'wrap-enforcer' }),
	            _react2.default.createElement(
	              'div',
	              { className: 'force-wrap ' + (this.state.sublinkMenuVisible ? 'hidden' : '') },
	              subLinks.map(function (link, i) {
	                return _react2.default.createElement(
	                  _reactRouterDom.NavLink,
	                  { to: link.path, className: 'sublink', exact: true, activeClassName: 'active', key: i },
	                  link.label
	                );
	              })
	            ),
	            _react2.default.createElement(
	              'button',
	              {
	                onClick: this.openSublinkMenu,
	                className: 'more-button ' + (this.state.sublinkMenuVisible ? '' : 'hidden'),
	                ref: function ref(r) {
	                  _this2.sublinkMenuButton = r;
	                },
	                'aria-label': 'Pick a category'
	              },
	              currentSublink.label,
	              ' ',
	              _react2.default.createElement('div', { className: 'triangle' })
	            ),
	            _react2.default.createElement(_FloatingMenu2.default, {
	              className: 'home-icon-menu',
	              isOpen: this.state.sublinkMenuOpen,
	              alignTo: this.state.sublinkMenuAnchor,
	              align: 'right',
	              offsetTop: 32,
	              onRequestClose: this.closeSublinkMenu,
	              options: subLinks.map(function (link) {
	                return { value: link.path, label: link.label, onClick: _this2.navigate };
	              })
	            })
	          )
	        ),
	        SHOPPING_CART && _react2.default.createElement(_Cart2.default, null),
	        _react2.default.createElement(_Login2.default, null),
	        _react2.default.createElement(_AuthTimer2.default, null)
	      );
	    }
	  }]);
	
	  return Header;
	}(_react.Component);
	
	Header = (0, _reactRedux.connect)(function (state) {
	  return {
	    isMobile: state.app.isMobile,
	    sidebarShown: state.app.sidebarShown,
	    param: state.router.location.pathname.split('/')[state.router.location.pathname.split('/').length - 1]
	  };
	}, { toggleSidebarShow: _actions.toggleSidebarShow })(Header);
	
	var SidebarNav = exports.SidebarNav = function (_Component2) {
	  _inherits(SidebarNav, _Component2);
	
	  function SidebarNav() {
	    var _ref3;
	
	    var _temp2, _this3, _ret2;
	
	    _classCallCheck(this, SidebarNav);
	
	    for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
	      args[_key2] = arguments[_key2];
	    }
	
	    return _ret2 = (_temp2 = (_this3 = _possibleConstructorReturn(this, (_ref3 = SidebarNav.__proto__ || Object.getPrototypeOf(SidebarNav)).call.apply(_ref3, [this].concat(args))), _this3), _this3.componentWillMount = function () {
	      window.addEventListener('resize', _this3.toggleSidebarCollapse);
	    }, _this3.componentDidMount = function () {
	      _this3.toggleSidebarCollapse();
	    }, _this3.componentWillUnmount = function () {
	      window.removeEventListener('resize', _this3.toggleSidebarCollapse);
	    }, _this3.toggleSidebarCollapse = function () {
	      if (_this3.props.shouldControlSidebarSize) {
	        if (document.body.clientWidth < 600) {
	          _this3.props.toggleMobileState(true);
	          _this3.props.toggleSidebarCollapse(false);
	        } else if (document.body.clientWidth < 900) {
	          _this3.props.toggleSidebarCollapse(true);
	          _this3.props.toggleMobileState(false);
	        } else {
	          _this3.props.toggleSidebarCollapse(false);
	          _this3.props.toggleMobileState(false);
	        }
	      }
	    }, _this3.toggleSidebarShow = function () {
	      _this3.props.toggleSidebarShow(false);
	      document.body.style.overflow = '';
	    }, _this3.blurOut = function () {
	      setTimeout(function () {
	        if (!_this3.sidebarWrapper.contains(document.activeElement)) {
	          _this3.toggleSidebarShow();
	        }
	      });
	    }, _this3.portalTarget = document.getElementById("sidebar-navigation"), _temp2), _possibleConstructorReturn(_this3, _ret2);
	  }
	
	  _createClass(SidebarNav, [{
	    key: 'render',
	    value: function render() {
	      var _this4 = this;
	
	      var _props2 = this.props,
	          links = _props2.links,
	          collapsed = _props2.collapsed,
	          isMobile = _props2.isMobile,
	          sidebarShown = _props2.sidebarShown,
	          loggedIn = _props2.loggedIn,
	          userGroup = _props2.userGroup,
	          siteOffline = _props2.siteOffline;
	
	      return _react2.default.createElement(
	        _Portal2.default,
	        { isOpened: true, node: this.portalTarget },
	        _react2.default.createElement(_SkipLink2.default, null),
	        _react2.default.createElement(
	          'div',
	          { ref: function ref(_ref4) {
	              _this4.sidebarWrapper = _ref4;
	            } },
	          _react2.default.createElement(
	            'nav',
	            { onBlur: this.blurOut, className: "sidebar " + (collapsed ? "collapsed " : " ") + (isMobile ? "mobile " : " ") + (sidebarShown ? "show" : "") },
	            isMobile && _react2.default.createElement(
	              'div',
	              { className: "branding " + (sidebarShown ? "show" : "") },
	              LOGO_FILENAME ? _react2.default.createElement(
	                'div',
	                { className: 'logo-wrapper' },
	                _react2.default.createElement('img', { src: Logo, alt: LOGO_ALT })
	              ) : _react2.default.createElement(
	                _react2.default.Fragment,
	                null,
	                _react2.default.createElement('img', { src: Logo, alt: LOGO_ALT }),
	                _react2.default.createElement(
	                  'span',
	                  { className: 'title-container' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'statetitle' },
	                    ("Montana")
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'subtext' },
	                    ("Secretary of State")
	                  )
	                )
	              )
	            ),
	            links.map(function (link, i) {
	              if (link.includeInSidebar) {
	                var isPdf = false;
	                if (link.link.endsWith('.pdf')) {
	                  isPdf = true;
	                }
	                var renderedLink = _react2.default.createElement(SidebarLink, Object.assign({}, link, { onClick: isMobile ? _this4.toggleSidebarShow : undefined, hiddenText: isPdf ? "PDF" : null, key: i }));
	                if (link.authOnly || link.alwaysShowInSidebar) {
	                  if (loggedIn || link.alwaysShowInSidebar) {
	                    if (link.allowedUserGroups) {
	                      if (link.allowedUserGroups.includes(userGroup) || link.alwaysShowInSidebar) {
	                        return siteOffline ? link.linkAvailableOffline ? renderedLink : null : renderedLink;
	                      } else {
	                        return null;
	                      }
	                    } else {
	                      return siteOffline ? link.linkAvailableOffline ? renderedLink : null : renderedLink;
	                    }
	                  } else {
	                    return null;
	                  }
	                } else {
	                  return siteOffline ? link.linkAvailableOffline ? renderedLink : null : renderedLink;
	                }
	              } else {
	                return null;
	              }
	            })
	          ),
	          sidebarShown ? _react2.default.createElement('div', { className: 'sidebar-shade animated fadeIn extra-fast-animation', onClick: this.toggleSidebarShow }) : null
	        )
	      );
	    }
	  }]);
	
	  return SidebarNav;
	}(_react.Component);
	
	exports.SidebarNav = SidebarNav = (0, _reactRedux.connect)(function (state) {
	  return {
	    collapsed: state.app.sidebarCollapsed,
	    location: state.router.location,
	    isMobile: state.app.isMobile,
	    sidebarShown: state.app.sidebarShown,
	    shouldControlSidebarSize: !state.app.overrideSidebarResizing,
	    loggedIn: state.auth.loggedIn,
	    userGroup: state.auth.USER_GROUP,
	    siteOffline: state.app.appSettings.WEBSITE_PORTAL_OFFLINE_YN === true
	  };
	}, { toggleSidebarCollapse: _actions.toggleSidebarCollapse, toggleMobileState: _actions.toggleMobileState, toggleSidebarShow: _actions.toggleSidebarShow })(SidebarNav);
	
	var SidebarLink = function SidebarLink(_ref5) {
	  var label = _ref5.label,
	      link = _ref5.link,
	      icon = _ref5.icon,
	      exact = _ref5.exact,
	      linkExact = _ref5.linkExact,
	      _ref5$numAlerts = _ref5.numAlerts,
	      numAlerts = _ref5$numAlerts === undefined ? 0 : _ref5$numAlerts,
	      isActive = _ref5.isActive,
	      onClick = _ref5.onClick,
	      onBlur = _ref5.onBlur,
	      hiddenText = _ref5.hiddenText,
	      external = _ref5.external;
	  return external ? _react2.default.createElement(
	    'a',
	    {
	      href: link,
	      target: '_blank',
	      rel: 'noopener noreferrer'
	    },
	    numAlerts > 0 ? _react2.default.createElement(Alert, { number: numAlerts }) : null,
	    icon && icon,
	    ' ',
	    _react2.default.createElement(
	      'span',
	      { className: 'label' },
	      label
	    ),
	    _react2.default.createElement(
	      'span',
	      { className: 'visually-hidden' },
	      hiddenText
	    )
	  ) : _react2.default.createElement(
	    _reactRouterDom.NavLink,
	    {
	      to: link,
	      exact: linkExact === false || linkExact === true ? linkExact : exact,
	      isActive: isActive,
	      activeClassName: 'active',
	      onClick: onClick,
	      onBlur: onBlur
	    },
	    numAlerts > 0 ? _react2.default.createElement(Alert, { number: numAlerts }) : null,
	    icon && icon,
	    ' ',
	    _react2.default.createElement(
	      'span',
	      { className: 'label' },
	      label
	    )
	  );
	};
	
	var Alert = function Alert(_ref6) {
	  var number = _ref6.number;
	  return _react2.default.createElement(
	    'div',
	    { className: 'badge sidebar-alert' },
	    number
	  );
	};
	
	var Drawer = exports.Drawer = function (_Component3) {
	  _inherits(Drawer, _Component3);
	
	  function Drawer() {
	    var _ref7;
	
	    var _temp3, _this5, _ret3;
	
	    _classCallCheck(this, Drawer);
	
	    for (var _len3 = arguments.length, args = Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
	      args[_key3] = arguments[_key3];
	    }
	
	    return _ret3 = (_temp3 = (_this5 = _possibleConstructorReturn(this, (_ref7 = Drawer.__proto__ || Object.getPrototypeOf(Drawer)).call.apply(_ref7, [this].concat(args))), _this5), _this5.state = {
	      render: _this5.props.show || false,
	      closing: false
	    }, _this5.componentWillReceiveProps = function (nextProps) {
	      if (!_this5.props.show && nextProps.show === true) {
	        _this5.setState({
	          render: true,
	          closing: false
	        }, function () {
	          _this5.innerWrapper.focus();
	        });
	      }
	      if (_this5.props.show === true && !nextProps.show) {
	        _this5.setState({
	          closing: true
	        });
	      }
	    }, _this5.onSidebarDismiss = function () {
	      if (_this5.props.onSidebarDismiss) {
	        _this5.props.onSidebarDismiss();
	      }
	    }, _this5.onAnimationEnd = function () {
	      if (_this5.props.show === false) {
	        _this5.setState({
	          render: false,
	          closing: false
	        });
	      }
	    }, _temp3), _possibleConstructorReturn(_this5, _ret3);
	  }
	
	  _createClass(Drawer, [{
	    key: 'render',
	    value: function render() {
	      var _this6 = this;
	
	      var _props3 = this.props,
	          _props3$show = _props3.show,
	          show = _props3$show === undefined ? false : _props3$show,
	          children = _props3.children,
	          _props3$title = _props3.title,
	          title = _props3$title === undefined ? "" : _props3$title,
	          subtitle = _props3.subtitle,
	          isMobile = _props3.isMobile,
	          scrollable = _props3.scrollable,
	          showCloseButton = _props3.showCloseButton,
	          alwaysShowClosebutton = _props3.alwaysShowClosebutton,
	          ariaCloseLabel = _props3.ariaCloseLabel;
	
	      var titleArray = title ? title.split("||") : [];
	      return this.state.render ? _react2.default.createElement(
	        _focusTrapReact2.default,
	        {
	          focusTrapOptions: { clickOutsideDeactivates: true },
	          active: show && !this.state.closing,
	          className: 'drawer ' + (show ? "show" : "") + ' ' + (isMobile ? "mobile" : "") + ' ' + (this.state.closing ? "closing" : ""),
	          onAnimationEnd: this.onAnimationEnd,
	          'aria-hidden': !show,
	          'aria-live': 'polite',
	          role: 'complementary'
	        },
	        _react2.default.createElement(
	          'div',
	          { className: 'drawer-inner-wrapper', tabIndex: '-1', ref: function ref(r) {
	              return _this6.innerWrapper = r;
	            } },
	          title ? _react2.default.createElement(
	            'div',
	            { className: 'title-box' },
	            _react2.default.createElement(
	              'h4',
	              null,
	              titleArray.length !== null ? titleArray[0] : "undefined"
	            ),
	            _react2.default.createElement(
	              'p',
	              null,
	              subtitle
	            ),
	            isMobile ? _react2.default.createElement(
	              'button',
	              {
	                className: 'sidebar-dismiss',
	                onClick: this.onSidebarDismiss
	              },
	              _react2.default.createElement(
	                'div',
	                { className: 'center' },
	                _react2.default.createElement(_caretLeft2.default, null)
	              )
	            ) : null,
	            (!isMobile || alwaysShowClosebutton) && showCloseButton ? _react2.default.createElement(
	              'button',
	              { className: 'close-button', onClick: this.onSidebarDismiss, 'aria-label': ariaCloseLabel || "Close" },
	              _react2.default.createElement(
	                'div',
	                { className: 'center' },
	                _react2.default.createElement(_crossHeavy2.default, null)
	              )
	            ) : null
	          ) : null,
	          _react2.default.createElement(
	            'div',
	            { className: 'scrollable-drawer-wrapper' },
	            _react2.default.createElement(
	              'div',
	              { className: "inner-drawer " + (scrollable ? "scrollable" : "") },
	              children
	            )
	          )
	        )
	      ) : null;
	    }
	  }]);
	
	  return Drawer;
	}(_react.Component);
	
	exports.Drawer = Drawer = (0, _reactRedux.connect)(function (state) {
	  return {
	    isMobile: state.app.isMobile
	  };
	})(Drawer);
	
	var Body = exports.Body = function (_Component4) {
	  _inherits(Body, _Component4);
	
	  function Body() {
	    var _ref8;
	
	    var _temp4, _this7, _ret4;
	
	    _classCallCheck(this, Body);
	
	    for (var _len4 = arguments.length, args = Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
	      args[_key4] = arguments[_key4];
	    }
	
	    return _ret4 = (_temp4 = (_this7 = _possibleConstructorReturn(this, (_ref8 = Body.__proto__ || Object.getPrototypeOf(Body)).call.apply(_ref8, [this].concat(args))), _this7), _this7.componentDidMount = function () {
	      if (_this7.props.onResize) resizeDetector.listenTo(_this7.body, _this7.onResize);
	    }, _this7.componentWillUnmount = function () {
	      if (_this7.props.onResize) resizeDetector.removeListener(_this7.body, _this7.onResize);
	    }, _this7.onResize = function (body) {
	      _this7.props.onResize({
	        width: body.offsetWidth,
	        height: body.offsetHeight
	      });
	    }, _temp4), _possibleConstructorReturn(_this7, _ret4);
	  }
	
	  _createClass(Body, [{
	    key: 'render',
	    value: function render() {
	      var _this8 = this;
	
	      var _props4 = this.props,
	          _props4$className = _props4.className,
	          className = _props4$className === undefined ? "" : _props4$className,
	          _props4$showDrawer = _props4.showDrawer,
	          showDrawer = _props4$showDrawer === undefined ? false : _props4$showDrawer,
	          children = _props4.children,
	          isMobile = _props4.isMobile,
	          _props4$appError = _props4.appError,
	          appError = _props4$appError === undefined ? {} : _props4$appError,
	          _props4$style = _props4.style,
	          style = _props4$style === undefined ? {} : _props4$style,
	          backgroundThemeColor = _props4.backgroundThemeColor,
	          innerRef = _props4.innerRef,
	          hiddenTitle = _props4.hiddenTitle;
	
	      return _react2.default.createElement(
	        'main',
	        {
	          ref: function ref(_ref9) {
	            _this8.body = _ref9;
	            if (innerRef) {
	              innerRef(_ref9);
	            }
	          },
	          className: 'body container-fluid ' + (className ? className : "") + ' ' + (showDrawer ? "drawer-shown" : "") + ' ' + (isMobile ? "mobile" : "") + ' ' + (backgroundThemeColor ? backgroundThemeColor : ''),
	          style: style
	        },
	        hiddenTitle ? _react2.default.createElement(
	          'h1',
	          { className: 'visually-hidden' },
	          hiddenTitle
	        ) : null,
	        appError.show ? _react2.default.createElement(AppError, appError) : null,
	        children
	      );
	    }
	  }]);
	
	  return Body;
	}(_react.Component);
	
	exports.Body = Body = (0, _reactRedux.connect)(function (state) {
	  return {
	    isMobile: state.app.isMobile,
	    appError: state.app.appError
	  };
	})(Body);
	
	var AppError = function (_Component5) {
	  _inherits(AppError, _Component5);
	
	  function AppError() {
	    _classCallCheck(this, AppError);
	
	    return _possibleConstructorReturn(this, (AppError.__proto__ || Object.getPrototypeOf(AppError)).apply(this, arguments));
	  }
	
	  _createClass(AppError, [{
	    key: 'render',
	    value: function render() {
	      var _props5 = this.props,
	          _props5$error = _props5.error,
	          error = _props5$error === undefined ? "Oops, something went wrong. Refresh your page and try again." : _props5$error,
	          _props5$type = _props5.type,
	          type = _props5$type === undefined ? "danger" : _props5$type;
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'app-error ' + type + ' animated fadeIn fast-animation' },
	        error,
	        _react2.default.createElement(
	          'button',
	          { onClick: this.props.clearAppError },
	          _react2.default.createElement('span', { className: 'icon icon-cross' })
	        )
	      );
	    }
	  }]);
	
	  return AppError;
	}(_react.Component);
	
	AppError = (0, _reactRedux.connect)(null, { clearAppError: _actions.clearAppError })(AppError);
	
	var Footer = exports.Footer = function (_Component6) {
	  _inherits(Footer, _Component6);
	
	  function Footer() {
	    _classCallCheck(this, Footer);
	
	    return _possibleConstructorReturn(this, (Footer.__proto__ || Object.getPrototypeOf(Footer)).apply(this, arguments));
	  }
	
	  _createClass(Footer, [{
	    key: 'render',
	    value: function render() {
	      var _props6 = this.props,
	          children = _props6.children,
	          copyright = _props6.copyright,
	          isMobile = _props6.isMobile,
	          sidebarCollapsed = _props6.sidebarCollapsed;
	
	      var date = new Date();
	      return _react2.default.createElement(
	        'footer',
	        { className: (isMobile ? "mobile " : " ") + (sidebarCollapsed ? "collapsed" : "") },
	        copyright ? _react2.default.createElement(
	          'span',
	          { className: 'copyright' },
	          '\xA9 ',
	          date.getFullYear(),
	          ' ',
	          copyright
	        ) : null,
	        children ? children : null,
	        FOOTER_LINKS !== false && Array.isArray(FOOTER_LINKS) ? _react2.default.createElement(
	          'ul',
	          { className: 'links' },
	          FOOTER_LINKS.map(function (link, i) {
	            return _react2.default.createElement(
	              'li',
	              { key: i },
	              _react2.default.createElement(
	                'a',
	                { href: link.link, key: i },
	                link.label
	              ),
	              i !== FOOTER_LINKS.length - 1 ? _react2.default.createElement(
	                'span',
	                { className: 'divider', key: i + link.label },
	                '|'
	              ) : null
	            );
	          })
	        ) : null
	      );
	    }
	  }]);
	
	  return Footer;
	}(_react.Component);
	
	exports.Footer = Footer = (0, _reactRedux.connect)(function (state) {
	  return {
	    isMobile: state.app.isMobile,
	    sidebarCollapsed: state.app.sidebarCollapsed
	  };
	})(Footer);
	
	var FlexWrapper = exports.FlexWrapper = function FlexWrapper(_ref10) {
	  var children = _ref10.children,
	      justifyContent = _ref10.justifyContent,
	      direction = _ref10.direction;
	  return _react2.default.createElement(
	    'div',
	    { className: 'flex-wrapper', style: {
	        justifyContent: justifyContent ? justifyContent : "",
	        flexDirection: direction ? direction : ""
	      } },
	    children
	  );
	};
	
	var Triangle = exports.Triangle = function Triangle(_ref11) {
	  var _ref11$direction = _ref11.direction,
	      direction = _ref11$direction === undefined ? 'down' : _ref11$direction,
	      _ref11$className = _ref11.className,
	      className = _ref11$className === undefined ? '' : _ref11$className;
	  return _react2.default.createElement('div', { className: 'triangle ' + direction + ' ' + className });
	};

/***/ },
/* 20 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	if (false) {
	  var ReactIs = require('react-is');
	
	  // By explicitly using `prop-types` you are opting into new development behavior.
	  // http://fb.me/prop-types-in-prod
	  var throwOnDirectAccess = true;
	  module.exports = require('./factoryWithTypeCheckers')(ReactIs.isElement, throwOnDirectAccess);
	} else {
	  // By explicitly using `prop-types` you are opting into new production behavior.
	  // http://fb.me/prop-types-in-prod
	  module.exports = __webpack_require__(1287)();
	}


/***/ },
/* 21 */
/***/ function(module, exports) {

	module.exports = function (exec) {
	  try {
	    return !!exec();
	  } catch (e) {
	    return true;
	  }
	};


/***/ },
/* 22 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _generate2 = __webpack_require__(1275);
	
	var _generate3 = _interopRequireDefault(_generate2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var shortid = {
	  generate: function generate() {
	    return (0, _generate3.default)("0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ-", 8);
	  }
	};
	
	exports.default = shortid;

/***/ },
/* 23 */
/***/ function(module, exports) {

	module.exports = function (it) {
	  return typeof it === 'object' ? it !== null : typeof it === 'function';
	};


/***/ },
/* 24 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactMarkdown = __webpack_require__(510);
	
	var _reactMarkdown2 = _interopRequireDefault(_reactMarkdown);
	
	var _reactRouterDom = __webpack_require__(30);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Markdown = function (_React$Component) {
	  _inherits(Markdown, _React$Component);
	
	  function Markdown() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, Markdown);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Markdown.__proto__ || Object.getPrototypeOf(Markdown)).call.apply(_ref, [this].concat(args))), _this), _this.getLinkTarget = function (_ref2) {
	      var href = _ref2.href,
	          children = _ref2.children;
	
	      var target = 'blank';
	
	      if (href.slice(0, 7).toLowerCase() === 'mailto:') {
	        target = 'blank';
	      }
	
	      var newChildren = children.map(function (child) {
	        if (typeof child === 'string') {
	          if (child.includes('>>>')) {
	            target = '';
	            return child.replace('>>>', '');
	          }
	          return child;
	        }
	        return child;
	      });
	
	      var useNativeLink = href.slice(0, 5).includes('http');
	
	      return { target: target, children: newChildren, useNativeLink: useNativeLink };
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(Markdown, [{
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _props = this.props,
	          source = _props.source,
	          _props$className = _props.className,
	          className = _props$className === undefined ? '' : _props$className,
	          style = _props.style,
	          id = _props.id;
	
	      return _react2.default.createElement(_reactMarkdown2.default, {
	        source: source,
	        className: className,
	        renderers: {
	          root: function root(_ref3) {
	            var children = _ref3.children;
	            return _react2.default.createElement(
	              'div',
	              { className: className, id: id, style: style },
	              children
	            );
	          },
	          link: function link(props) {
	            var _getLinkTarget = _this2.getLinkTarget({
	              children: props.children,
	              href: props.href
	            }),
	                target = _getLinkTarget.target,
	                children = _getLinkTarget.children,
	                useNativeLink = _getLinkTarget.useNativeLink;
	
	            return useNativeLink ? _react2.default.createElement(
	              'a',
	              { href: props.href, target: target },
	              children
	            ) : _react2.default.createElement(
	              _reactRouterDom.Link,
	              { to: props.href, target: target },
	              children
	            );
	          },
	          code: function code(props) {
	            return _react2.default.createElement(
	              'pre',
	              null,
	              props.value
	            );
	          }
	        }
	      });
	    }
	  }]);
	
	  return Markdown;
	}(_react2.default.Component);
	
	exports.default = Markdown;

/***/ },
/* 25 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.InfoMessage = exports.getValidityClass = exports.DumbField = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _WizardClasses = __webpack_require__(35);
	
	var WizardClasses = _interopRequireWildcard(_WizardClasses);
	
	var _reactRedux = __webpack_require__(7);
	
	var _Markdown = __webpack_require__(24);
	
	var _Markdown2 = _interopRequireDefault(_Markdown);
	
	var _Form = __webpack_require__(14);
	
	var _FileUpload = __webpack_require__(473);
	
	var _FileUpload2 = _interopRequireDefault(_FileUpload);
	
	var _AddressBlock = __webpack_require__(102);
	
	var _AddressBlock2 = _interopRequireDefault(_AddressBlock);
	
	var _Repeater = __webpack_require__(474);
	
	var _Repeater2 = _interopRequireDefault(_Repeater);
	
	var _ServerControls = __webpack_require__(475);
	
	var _ServerControls2 = _interopRequireDefault(_ServerControls);
	
	var _RegisteredAgentSearch = __webpack_require__(1163);
	
	var _RegisteredAgentSearch2 = _interopRequireDefault(_RegisteredAgentSearch);
	
	var _NameQualifiedOrg = __webpack_require__(1161);
	
	var _NameQualifiedOrg2 = _interopRequireDefault(_NameQualifiedOrg);
	
	var _SearchControl = __webpack_require__(307);
	
	var _SearchControl2 = _interopRequireDefault(_SearchControl);
	
	var _Summary = __webpack_require__(476);
	
	var _Summary2 = _interopRequireDefault(_Summary);
	
	var _UploadAccumulator = __webpack_require__(199);
	
	var _UploadAccumulator2 = _interopRequireDefault(_UploadAccumulator);
	
	var _UploadAndSubmit = __webpack_require__(1165);
	
	var _UploadAndSubmit2 = _interopRequireDefault(_UploadAndSubmit);
	
	var _Signatures = __webpack_require__(1164);
	
	var _Signatures2 = _interopRequireDefault(_Signatures);
	
	var _FormationLocale = __webpack_require__(1158);
	
	var _FormationLocale2 = _interopRequireDefault(_FormationLocale);
	
	var _EntityNameSearch = __webpack_require__(1157);
	
	var _EntityNameSearch2 = _interopRequireDefault(_EntityNameSearch);
	
	var _DateRange = __webpack_require__(306);
	
	var _DateRange2 = _interopRequireDefault(_DateRange);
	
	var _DataTable = __webpack_require__(1155);
	
	var _DataTable2 = _interopRequireDefault(_DataTable);
	
	var _Paragraph = __webpack_require__(1162);
	
	var _Paragraph2 = _interopRequireDefault(_Paragraph);
	
	var _UCCSearch = __webpack_require__(477);
	
	var _UCCSearch2 = _interopRequireDefault(_UCCSearch);
	
	var _LocalSelect = __webpack_require__(1160);
	
	var _LocalSelect2 = _interopRequireDefault(_LocalSelect);
	
	var _MultiComplete = __webpack_require__(120);
	
	var _MultiComplete2 = _interopRequireDefault(_MultiComplete);
	
	var _EFSCropPicker = __webpack_require__(1156);
	
	var _EFSCropPicker2 = _interopRequireDefault(_EFSCropPicker);
	
	var _WizardActions = __webpack_require__(36);
	
	var _validate = __webpack_require__(45);
	
	var _reactTooltip = __webpack_require__(78);
	
	var _reactTooltip2 = _interopRequireDefault(_reactTooltip);
	
	var _utilities = __webpack_require__(8);
	
	var _wizardUtilities = __webpack_require__(52);
	
	var _revert = __webpack_require__(227);
	
	var _revert2 = _interopRequireDefault(_revert);
	
	var _crossHeavy = __webpack_require__(51);
	
	var _crossHeavy2 = _interopRequireDefault(_crossHeavy);
	
	var _Tooltip = __webpack_require__(305);
	
	var _Tooltip2 = _interopRequireDefault(_Tooltip);
	
	var _resolveFieldLogic = __webpack_require__(478);
	
	var _resolveFieldLogic2 = _interopRequireDefault(_resolveFieldLogic);
	
	__webpack_require__(1025);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Field = function (_Component) {
	  _inherits(Field, _Component);
	
	  function Field() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, Field);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Field.__proto__ || Object.getPrototypeOf(Field)).call.apply(_ref, [this].concat(args))), _this), _this.handleFieldChange = function (value, e, extraPayload, overrideSetValue) {
	      var options = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {};
	
	      value = (0, _validate.maskValue)(value, _this.props.field.mask);
	      _this.props.validateAndSetFieldAttributes({ fieldId: _this.props.field.fieldId, event: "onChange", value: value, setValue: true, extraPayload: extraPayload });
	      if (options.triggerOnAdvanceValidation) {
	        _this.props.validateAndSetFieldAttributes({ fieldId: _this.props.field.fieldId, event: "onAdvance", value: value, setValue: false, extraPayload: extraPayload });
	      }
	    }, _this.handleFieldBlur = function (value, e, extraPayload, overrideSetValue) {
	      var options = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {};
	
	      _this.props.validateAndSetFieldAttributes({ fieldId: _this.props.field.fieldId, event: "onBlur", value: value, setValue: overrideSetValue ? true : false, extraPayload: extraPayload, options: options });
	    }, _this.getField = function (field) {
	      var _this$props = _this.props,
	          fields = _this$props.fields,
	          isFirst = _this$props.isFirst,
	          readOnly = _this$props.readOnly,
	          correctionMode = _this$props.correctionMode,
	          repeaterEditing = _this$props.repeaterEditing;
	
	      var events = {
	        onChange: _this.handleFieldChange,
	        onBlur: _this.handleFieldBlur
	      };
	      var isValid = _this.props.isValid === true || _this.props.isValid === false ? _this.props.isValid : field.isValid;
	      var value = _this.props.value ? _this.props.value : field.value;
	      var attributes = {
	        value: value,
	        validityClass: getValidityClass(field.isValid),
	        isValid: isValid,
	        isFirst: isFirst,
	        disabled: readOnly ? true : correctionMode && field.disabledDuringCorrection || field.disabled || repeaterEditing && field.disabledDuringEdit
	      };
	      switch (_this.props.type ? _this.props.type : field.type) {
	        case "text":
	        case "number":
	          return _react2.default.createElement(_Form.TextInput, Object.assign({}, events, field, attributes));
	        case "textArea":
	          return _react2.default.createElement(_Form.TextArea, Object.assign({}, events, field, attributes));
	        case "select":
	          return _react2.default.createElement(_Form.Select, Object.assign({}, events, field, attributes));
	        case "radio":
	          return _react2.default.createElement(_Form.RadioInput, Object.assign({}, events, field, attributes));
	        case "checkbox":
	          return _react2.default.createElement(_Form.Checkbox, Object.assign({}, events, field, attributes));
	        case "dependentSelect":
	          var selectedOption = field.options.find(function (option) {
	            return option.value == field.value;
	          });
	          return _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(_Form.Select, Object.assign({}, events, field, { options: field.options }, attributes)),
	            selectedOption ? selectedOption.fields.map(function (subFieldId) {
	              if (fields[subFieldId]) {
	                return fields[subFieldId].active && _react2.default.createElement(
	                  'div',
	                  { className: 'dependent-field', key: subFieldId },
	                  _react2.default.createElement(SubField, { field: fields[subFieldId], key: subFieldId })
	                );
	              } else {
	                console.warn('Attempted to render subfield of DependentSelect "' + field.label + '" with subFieldId ' + subFieldId + ', but got null.');
	                return null;
	              }
	            }) : null
	          );
	        case "dependentRadio":
	          var selectedIndex = field.options.findIndex(function (option) {
	            return option.value.toString() === field.value.toString();
	          });
	          return _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(_Form.RadioInput, Object.assign({}, events, field, attributes)),
	            selectedIndex >= 0 ? field.options[selectedIndex].fields.map(function (subFieldId) {
	              if (fields[subFieldId]) {
	                return fields[subFieldId].active && _react2.default.createElement(
	                  'div',
	                  { className: 'dependent-field', key: subFieldId },
	                  _react2.default.createElement(SubField, { field: fields[subFieldId], key: subFieldId })
	                );
	              } else {
	                console.warn('Attempted to render subfield of DependentRadio "' + field.label + '" with subFieldId ' + subFieldId + ', but got null.');
	                return null;
	              }
	            }) : null
	          );
	        case 'dependentCheck':
	          var fieldGroup = field.value ? "checkedFields" : "uncheckedFields";
	          return _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(_Form.Checkbox, Object.assign({}, events, field, attributes)),
	            field[fieldGroup].map(function (subFieldId) {
	              if (fields[subFieldId]) {
	                return fields[subFieldId].active && _react2.default.createElement(
	                  'div',
	                  { className: 'dependent-field', key: subFieldId },
	                  _react2.default.createElement(SubField, { field: fields[subFieldId], key: subFieldId })
	                );
	              } else {
	                console.warn('Attempted to render subfield of DependentCheck "' + field.label + '" with subFieldId ' + subFieldId + ', but got null.');
	                return null;
	              }
	            })
	          );
	        case "confirmFields":
	          return _react2.default.createElement(_Form.ConfirmFields, Object.assign({}, events, field, attributes));
	        case "addressBlock":
	          return _react2.default.createElement(_AddressBlock2.default, Object.assign({}, events, field, attributes));
	        case "repeater":
	          return _react2.default.createElement(_Repeater2.default, Object.assign({}, events, field, attributes));
	        case "paragraph":
	          return _react2.default.createElement(_Paragraph2.default, Object.assign({}, events, field, attributes));
	        case 'DataTable':
	          return _react2.default.createElement(_DataTable2.default, Object.assign({}, events, field, attributes));
	        case "serverSelect":
	        case "serverRadio":
	          return _react2.default.createElement(_ServerControls2.default, Object.assign({}, events, field, attributes));
	        case "date":
	          return _react2.default.createElement(
	            'div',
	            { className: 'row' },
	            _react2.default.createElement(
	              'div',
	              { className: 'col-lg-4 col-md-7 col-sm-12' },
	              _react2.default.createElement(_Form.DateInput, Object.assign({}, events, field, attributes, { className: "w" + field.width.replace('%', '') }))
	            )
	          );
	        case "DateRange":
	          return _react2.default.createElement(_DateRange2.default, Object.assign({}, events, field, attributes));
	        case "TimeInput":
	          return _react2.default.createElement(_Form.TimeInput, Object.assign({}, events, field, attributes));
	        case "file":
	          return _react2.default.createElement(_FileUpload2.default, Object.assign({}, events, field, attributes));
	        case "registeredAgentSearch":
	          return _react2.default.createElement(_RegisteredAgentSearch2.default, Object.assign({}, events, field, attributes));
	        case "Summary":
	          return _react2.default.createElement(_Summary2.default, field);
	        case "FullName":
	          return _react2.default.createElement(_Form.FullName, Object.assign({}, events, field, attributes));
	        case "NameOrg":
	          return _react2.default.createElement(_Form.NameOrg, Object.assign({}, events, field, attributes));
	        case "NameQualifiedOrg":
	          return _react2.default.createElement(_NameQualifiedOrg2.default, Object.assign({}, events, field, attributes));
	        case "UploadPlaceholder":
	          return _react2.default.createElement('div', null);
	        case "UploadAccumulator":
	          return _react2.default.createElement(_UploadAccumulator2.default, Object.assign({}, events, field, attributes));
	        case "UploadAndSubmit":
	          return _react2.default.createElement(_UploadAndSubmit2.default, Object.assign({}, events, field, attributes));
	        case "SearchControl":
	          return _react2.default.createElement(_SearchControl2.default, Object.assign({}, events, field, attributes));
	        case "Signatures":
	          return _react2.default.createElement(_Signatures2.default, Object.assign({}, events, field, attributes));
	        case "FormationLocale":
	          return _react2.default.createElement(_FormationLocale2.default, Object.assign({}, events, field, attributes));
	        case "EntityNameSearch":
	          return _react2.default.createElement(_EntityNameSearch2.default, Object.assign({}, events, field, attributes));
	        case "UCCSearch":
	          return _react2.default.createElement(_UCCSearch2.default, Object.assign({}, events, field, attributes));
	        case "LocalSelect":
	          return _react2.default.createElement(_LocalSelect2.default, Object.assign({}, events, field, attributes));
	        case "MultiComplete":
	          return _react2.default.createElement(_MultiComplete2.default, Object.assign({}, events, field, attributes));
	        case "ServerMultiComplete":
	          return _react2.default.createElement(_ServerControls2.default, Object.assign({}, events, field, attributes));
	        case "EFSCropPicker":
	          return _react2.default.createElement(_EFSCropPicker2.default, Object.assign({}, events, field, attributes));
	        default:
	          console.warn("Looks like you attempted to render an invalid field. Check the \"type\" attribute to make sure that it returns a valid field type.", field);
	          return _react2.default.createElement(
	            'div',
	            null,
	            'Not a valid field'
	          );
	      }
	    }, _this.revert = function () {
	      // console.log(this.props);
	      _this.handleFieldChange(_this.props.originalValue, {}, {});
	    }, _this.getVisibilityFromConditions = function () {
	      var conditions = _this.props.field.conditions;
	      if (conditions && !_this.props.bypassConditionCheck) {
	        return (0, _wizardUtilities.resolveFieldConditions)(conditions, _this.props.fields, _this.props.field.conditionsOperator);
	      } else {
	        return true;
	      }
	    }, _this.compareValues = function (originalValue, currentValue) {
	      return WizardClasses[_this.props.field.fieldClass].compareValues(originalValue, currentValue);
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(Field, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          originalValue = _props.originalValue,
	          showDiff = _props.showDiff,
	          preview = _props.preview,
	          field = _props.field,
	          bypassLogicResolution = _props.bypassLogicResolution;
	
	      var calculatedField = bypassLogicResolution ? field : (0, _resolveFieldLogic2.default)(field, { isRenderingFieldInRepeater: field.parent.type === "REPEATER" });
	      var active = calculatedField.active,
	          label = calculatedField.label,
	          tooltip = calculatedField.tooltip,
	          ownsLabel = calculatedField.ownsLabel,
	          hideLabel = calculatedField.hideLabel,
	          ownsTooltip = calculatedField.ownsTooltip,
	          hideTooltip = calculatedField.hideTooltip,
	          type = calculatedField.type,
	          required = calculatedField.required,
	          errorMessage = calculatedField.errorMessage,
	          description = calculatedField.description,
	          value = calculatedField.value,
	          parent = calculatedField.parent,
	          delegateErrorsToChildren = calculatedField.delegateErrorsToChildren,
	          excludeFromDiff = calculatedField.excludeFromDiff,
	          alwaysShowDescription = calculatedField.alwaysShowDescription,
	          infoMessage = calculatedField.infoMessage,
	          allowInfoMessage = calculatedField.allowInfoMessage,
	          disabled = calculatedField.disabled;
	
	      var currentValueIsDifferent = !showDiff ? false : excludeFromDiff ? false : this.compareValues(originalValue, this.props.value ? this.props.value : value);
	      return _react2.default.createElement(
	        FieldErrorBoundary,
	        { field: field },
	        this.getVisibilityFromConditions() && active && _react2.default.createElement(
	          DumbField,
	          {
	            fieldId: field.fieldId,
	            label: label,
	            tooltip: tooltip,
	            ownsLabel: ownsLabel,
	            ownsTooltip: ownsTooltip,
	            hideLabel: hideLabel,
	            hideTooltip: hideTooltip,
	            type: type,
	            required: required ? required : required,
	            description: description,
	            errorMessage: errorMessage,
	            currentValueIsDifferent: currentValueIsDifferent && showDiff && parent.type !== 'REPEATER' && parent.type !== 'STATIC' && !preview,
	            revert: this.revert,
	            delegateErrorsToChildren: delegateErrorsToChildren,
	            alwaysShowDescription: alwaysShowDescription,
	            infoMessage: allowInfoMessage && infoMessage,
	            disabled: disabled
	          },
	          this.getField(calculatedField)
	        )
	      );
	    }
	  }]);
	
	  return Field;
	}(_react.Component);
	
	exports.default = (0, _reactRedux.connect)(function (state, props) {
	  return {
	    fields: state.wizard.wizard.fields,
	    hasOriginalValue: Object.hasOwnProperty(state.wizard.diff.original),
	    originalValue: (0, _utilities.notNullOrUndefined)(props.originalValue) ? props.originalValue : state.wizard.diff.originalByFieldId[props.field.fieldId],
	    mode: state.wizard.mode,
	    preview: state.wizard.preview,
	    showDiff: state.wizard.showDiff,
	    readOnly: state.wizard.readOnly,
	    correctionMode: state.wizard.correctionMode,
	    repeaterEditing: state.wizard.repeaterEditing
	  };
	}, { validateAndSetFieldAttributes: _WizardActions.validateAndSetFieldAttributes })(Field);
	var DumbField = exports.DumbField = function DumbField(_ref2) {
	  var children = _ref2.children,
	      type = _ref2.type,
	      required = _ref2.required,
	      _ref2$label = _ref2.label,
	      label = _ref2$label === undefined ? '' : _ref2$label,
	      tooltip = _ref2.tooltip,
	      description = _ref2.description,
	      errorMessage = _ref2.errorMessage,
	      ownsLabel = _ref2.ownsLabel,
	      hideLabel = _ref2.hideLabel,
	      ownsTooltip = _ref2.ownsTooltip,
	      hideTooltip = _ref2.hideTooltip,
	      _ref2$className = _ref2.className,
	      className = _ref2$className === undefined ? '' : _ref2$className,
	      currentValueIsDifferent = _ref2.currentValueIsDifferent,
	      revert = _ref2.revert,
	      delegateErrorsToChildren = _ref2.delegateErrorsToChildren,
	      infoMessage = _ref2.infoMessage,
	      alwaysShowDescription = _ref2.alwaysShowDescription,
	      _ref2$fieldId = _ref2.fieldId,
	      fieldId = _ref2$fieldId === undefined ? '' : _ref2$fieldId,
	      disabled = _ref2.disabled;
	
	  var renderedTooltip = tooltip !== '' && tooltip && !hideTooltip && !ownsTooltip ? _react2.default.createElement(_Tooltip2.default, { tooltip: tooltip }) : null;
	  return _react2.default.createElement(
	    'div',
	    { className: 'field ' + (currentValueIsDifferent ? 'changed' : '') + ' ' + className },
	    currentValueIsDifferent && !disabled ? _react2.default.createElement(
	      'button',
	      {
	        className: 'field-revert',
	        'data-for': 'revert-' + fieldId,
	        'data-tip': 'Revert',
	        onClick: revert,
	        type: 'button'
	      },
	      _react2.default.createElement(_revert2.default, null),
	      _react2.default.createElement(_reactTooltip2.default, { effect: 'solid', place: 'left', id: 'revert-' + fieldId })
	    ) : null,
	    !ownsLabel && !hideLabel ? _react2.default.createElement(
	      'label',
	      { className: 'field-label ', htmlFor: fieldId ? 'field-' + fieldId : undefined },
	      _react2.default.createElement(
	        'span',
	        { className: 'label-text ' },
	        label,
	        required && label !== '' ? _react2.default.createElement(
	          'span',
	          { className: 'required', 'aria-hidden': true },
	          '*'
	        ) : null
	      ),
	      renderedTooltip
	    ) : renderedTooltip,
	    description !== '' && description && (!hideLabel || alwaysShowDescription) ? _react2.default.createElement(_Markdown2.default, {
	      className: 'description',
	      source: description,
	      escapeHtml: true,
	      id: fieldId ? 'field-description-' + fieldId : undefined
	    }) : null,
	    children,
	    errorMessage !== '' && Array.isArray(errorMessage) && !delegateErrorsToChildren ? errorMessage.map(function (error, i) {
	      if (error !== '') {
	        return _react2.default.createElement(
	          'p',
	          {
	            role: 'alert',
	            key: i,
	            className: 'field-error animated fadeIn fast-animation',
	            id: fieldId ? 'field-error-' + fieldId : undefined
	          },
	          error
	        );
	      } else return null;
	    }) : null,
	    infoMessage && !delegateErrorsToChildren && _react2.default.createElement(
	      InfoMessage,
	      null,
	      infoMessage
	    )
	  );
	};
	
	var getValidityClass = exports.getValidityClass = function getValidityClass(isValid) {
	  if (isValid === false) {
	    return "invalid";
	  } else if (isValid === true) {
	    return "valid";
	  } else {
	    return "";
	  }
	};
	
	var SubField = function (_Component2) {
	  _inherits(SubField, _Component2);
	
	  function SubField() {
	    _classCallCheck(this, SubField);
	
	    return _possibleConstructorReturn(this, (SubField.__proto__ || Object.getPrototypeOf(SubField)).apply(this, arguments));
	  }
	
	  _createClass(SubField, [{
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(Field, this.props);
	    }
	  }]);
	
	  return SubField;
	}(_react.Component);
	
	SubField = (0, _reactRedux.connect)(function (state, props) {
	  return {
	    fields: state.wizard.wizard.fields,
	    originalValue: state.wizard.diff.originalByFieldId[props.field.fieldId],
	    mode: state.wizard.mode,
	    readOnly: state.wizard.readOnly
	  };
	}, { validateAndSetFieldAttributes: _WizardActions.validateAndSetFieldAttributes })(SubField);
	
	var InfoMessage = exports.InfoMessage = function InfoMessage(_ref3) {
	  var children = _ref3.children;
	  return _react2.default.createElement(
	    'div',
	    { className: 'info-message' },
	    _react2.default.createElement('div', { className: 'icon-wrapper' }),
	    children
	  );
	};
	
	var FieldErrorBoundary = function (_React$Component) {
	  _inherits(FieldErrorBoundary, _React$Component);
	
	  function FieldErrorBoundary() {
	    var _ref4;
	
	    var _temp2, _this3, _ret2;
	
	    _classCallCheck(this, FieldErrorBoundary);
	
	    for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
	      args[_key2] = arguments[_key2];
	    }
	
	    return _ret2 = (_temp2 = (_this3 = _possibleConstructorReturn(this, (_ref4 = FieldErrorBoundary.__proto__ || Object.getPrototypeOf(FieldErrorBoundary)).call.apply(_ref4, [this].concat(args))), _this3), _this3.state = { hasError: false }, _this3.componentDidCatch = function (error, info) {
	      _this3.setState({ hasError: true });
	      console.error("Something went wrong while trying to render the following component: ", _this3.props.field);
	    }, _temp2), _possibleConstructorReturn(_this3, _ret2);
	  }
	
	  _createClass(FieldErrorBoundary, [{
	    key: 'render',
	    value: function render() {
	      var children = this.props.children;
	
	      return this.state.hasError ? _react2.default.createElement(
	        'div',
	        { className: '__crash-error' },
	        _react2.default.createElement(_crossHeavy2.default, null),
	        ' Something went wrong with this field.'
	      ) : children;
	    }
	  }]);
	
	  return FieldErrorBoundary;
	}(_react2.default.Component);

/***/ },
/* 26 */
/***/ function(module, exports, __webpack_require__) {

	var store = __webpack_require__(134)('wks');
	var uid = __webpack_require__(96);
	var Symbol = __webpack_require__(17).Symbol;
	var USE_SYMBOL = typeof Symbol == 'function';
	
	var $exports = module.exports = function (name) {
	  return store[name] || (store[name] =
	    USE_SYMBOL && Symbol[name] || (USE_SYMBOL ? Symbol : uid)('Symbol.' + name));
	};
	
	$exports.store = store;


/***/ },
/* 27 */
/***/ function(module, exports, __webpack_require__) {

	// 7.1.15 ToLength
	var toInteger = __webpack_require__(57);
	var min = Math.min;
	module.exports = function (it) {
	  return it > 0 ? min(toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
	};


/***/ },
/* 28 */
/***/ function(module, exports, __webpack_require__) {

	// Thank's IE8 for his funny defineProperty
	module.exports = !__webpack_require__(21)(function () {
	  return Object.defineProperty({}, 'a', { get: function () { return 7; } }).a != 7;
	});


/***/ },
/* 29 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getAndSetCartQuantity = exports.clearCartQuantity = exports.setCartQuantity = exports.resetFullAppState = exports.announce = exports.setOffline = exports.clearSuccessToast = exports.setSuccessToast = exports.clearErrorToast = exports.setErrorToast = exports.clearAppError = exports.setStateUser = exports.toggleLoginModal = exports.getState = exports.overrideSidebarResizing = exports.toggleSidebarShow = exports.toggleMobileState = exports.toggleSidebarCollapse = exports.initializeApp = exports.setAppSettings = exports.setSelectedDetails = undefined;
	
	var _requests = __webpack_require__(6);
	
	var api = _interopRequireWildcard(_requests);
	
	var _selectOptions = __webpack_require__(68);
	
	var _localStorage = __webpack_require__(59);
	
	var _localStorage2 = _interopRequireDefault(_localStorage);
	
	var _store = __webpack_require__(18);
	
	var _store2 = _interopRequireDefault(_store);
	
	var _shortid = __webpack_require__(22);
	
	var _shortid2 = _interopRequireDefault(_shortid);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var setSelectedDetails = exports.setSelectedDetails = function setSelectedDetails(details) {
	  return {
	    type: "SET_SELECTED_DETAILS",
	    details: details
	  };
	};
	
	var setAppSettings = exports.setAppSettings = function setAppSettings(appSettings) {
	  return {
	    type: "SET_APP_SETTINGS",
	    appSettings: appSettings
	  };
	};
	
	var logInitializationError = function logInitializationError(key, err) {
	  console.groupCollapsed("%cInitialization Error", 'color: rgb(240, 128, 128);');
	  console.warn('During initialization, the app setting: "' + key + '" failed with the attached error.');
	  console.error(err);
	  console.groupEnd();
	};
	
	var initializeApp = exports.initializeApp = function initializeApp() {
	  return function (dispatch, getState) {
	    // get all of the app_settings. To get a new setting add it to the 'keys' array
	    var keys = ['USE_LDAP_AUTHENTICATION_YN', 'WEBSITE_PORTAL_OFFLINE_YN'];
	    if (false) {
	      keys.push('EPASS_ACCOUNT_EDIT_URL');
	    }
	    var promises = keys.map(function (key) {
	      return new Promise(function (resolve) {
	        api.GET_APP_SETTING_BY_NAME(key, function (data) {
	          if (data !== null) {
	            resolve(data);
	          } else {
	            logInitializationError(key, "App setting not found.");
	          }
	        }, function (err) {
	          logInitializationError(key, err);
	          resolve(null);
	        });
	      });
	    });
	    promises.push(new Promise(function (resolve, reject) {
	      api.GET_GROUP_ITEMS('COUNTRY', function (countries) {
	        (0, _selectOptions.setCountryOptions)(countries.options);
	        resolve();
	      });
	    }));
	
	    Promise.all(promises).then(function (responses) {
	      var app_settings = responses.filter(function (x) {
	        return x;
	      }).reduce(function (accum, curr, currIdx, arr) {
	        return accum = Object.assign({}, accum, _defineProperty({}, curr.NAME, transformAppSettingValue(curr.VALUE)));
	      }, {});
	      dispatch(setAppSettings(app_settings));
	    });
	  };
	};
	
	var transformAppSettingValue = function transformAppSettingValue(value) {
	  switch (value) {
	    case 'Y':
	      return true;
	    case 'N':
	      return false;
	    default:
	      return value;
	  }
	};
	
	var toggleSidebarCollapse = exports.toggleSidebarCollapse = function toggleSidebarCollapse(collapse) {
	  return {
	    type: "TOGGLE_SIDEBAR_COLLAPSE",
	    collapse: collapse
	  };
	};
	
	var toggleMobileState = exports.toggleMobileState = function toggleMobileState(isMobile) {
	  return {
	    type: "TOGGLE_MOBILE_STATE",
	    isMobile: isMobile
	  };
	};
	
	var toggleSidebarShow = exports.toggleSidebarShow = function toggleSidebarShow(sidebarShown) {
	  return {
	    type: "TOGGLE_SIDEBAR_SHOW",
	    sidebarShown: sidebarShown
	  };
	};
	
	var overrideSidebarResizing = exports.overrideSidebarResizing = function overrideSidebarResizing(_overrideSidebarResizing) {
	  return {
	    type: "OVERRIDE_SIDEBAR_RESIZING",
	    overrideSidebarResizing: _overrideSidebarResizing
	  };
	};
	
	var getState = exports.getState = function getState() {
	  return function (dispatch, getState) {
	    return getState();
	  };
	};
	
	var toggleLoginModal = exports.toggleLoginModal = function toggleLoginModal(showLogin) {
	  return {
	    type: "TOGGLE_SHOW_LOGIN",
	    showLogin: showLogin
	  };
	};
	
	var setStateUser = exports.setStateUser = function setStateUser(stateUser) {
	  return {
	    type: "SET_STATE_USER",
	    stateUser: stateUser
	  };
	};
	
	var clearAppError = exports.clearAppError = function clearAppError() {
	  return {
	    type: "CLEAR_APP_ERROR"
	  };
	};
	
	var setErrorToast = exports.setErrorToast = function setErrorToast(error) {
	  return {
	    type: "SET_ERROR_TOAST",
	    error: error
	  };
	};
	
	var clearErrorToast = exports.clearErrorToast = function clearErrorToast() {
	  return {
	    type: 'CLEAR_ERROR_TOAST'
	  };
	};
	
	var setSuccessToast = exports.setSuccessToast = function setSuccessToast(success) {
	  return {
	    type: "SET_SUCCESS_TOAST",
	    success: success
	  };
	};
	
	var clearSuccessToast = exports.clearSuccessToast = function clearSuccessToast() {
	  return {
	    type: 'CLEAR_SUCCESS_TOAST'
	  };
	};
	
	var setOffline = exports.setOffline = function setOffline(offline) {
	  return {
	    type: 'SET_OFFLINE',
	    offline: offline
	  };
	};
	
	var announce = exports.announce = function announce(message) {
	  return {
	    type: 'ANNOUNCE',
	    message: message
	  };
	};
	
	var resetFullAppState = exports.resetFullAppState = function resetFullAppState() {
	  return function (dispatch) {
	    dispatch({ type: "@@SEARCH_RESET_STATE" });
	    dispatch({ type: "@@fm/RESET_STATE" });
	    dispatch({ type: "@@DESIGNER_RESET_STATE" });
	    dispatch({ type: "RESET_WIZARD_STATE" });
	    // dispatch({type: "@@h/RESET_STATE"})
	    dispatch({ type: "RESET_WORK_QUEUE_STATE" });
	    dispatch({ type: "@@mr/RESET_STATE" });
	  };
	};
	
	var setCartQuantity = exports.setCartQuantity = function setCartQuantity(quantity) {
	  return function (dispatch) {
	    _localStorage2.default.set('CART_QUANTITY', { quantity: quantity, trigger: _shortid2.default.generate() });
	    dispatch({
	      type: 'SET_CART_QUANTITY',
	      quantity: quantity
	    });
	  };
	};
	
	var clearCartQuantity = exports.clearCartQuantity = function clearCartQuantity() {
	  return {
	    type: 'CLEAR_CART_QUANTITY'
	  };
	};
	
	var getAndSetCartQuantity = exports.getAndSetCartQuantity = function getAndSetCartQuantity() {
	  return function (dispatch) {
	    if (true) {
	      api.GET_WEB_USER_ACTIVE_CART(function (cart) {
	        dispatch(setCartQuantity(cart.RECEIPT_ITEM_CONTAINER_WEB_LIST.filter(function (x) {
	          return !x.IS_FREE;
	        }).length));
	      }, function (err) {
	        return console.error;
	      });
	    }
	  };
	};
	
	_localStorage2.default.on('CART_QUANTITY', function (value) {
	  if (value && value.quantity && _store2.default.getState().app.cartQuantity !== value.quantity) {
	    _store2.default.dispatch(setCartQuantity(value.quantity));
	  }
	});

/***/ },
/* 30 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	if (true) {
	  module.exports = __webpack_require__(1341);
	} else {
	  module.exports = require("./cjs/react-router-dom.js");
	}


/***/ },
/* 31 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {/*!
	 * The buffer module from node.js, for the browser.
	 *
	 * @author   Feross Aboukhadijeh <http://feross.org>
	 * @license  MIT
	 */
	/* eslint-disable no-proto */
	
	'use strict'
	
	var base64 = __webpack_require__(614)
	var ieee754 = __webpack_require__(1044)
	var isArray = __webpack_require__(481)
	
	exports.Buffer = Buffer
	exports.SlowBuffer = SlowBuffer
	exports.INSPECT_MAX_BYTES = 50
	
	/**
	 * If `Buffer.TYPED_ARRAY_SUPPORT`:
	 *   === true    Use Uint8Array implementation (fastest)
	 *   === false   Use Object implementation (most compatible, even IE6)
	 *
	 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
	 * Opera 11.6+, iOS 4.2+.
	 *
	 * Due to various browser bugs, sometimes the Object implementation will be used even
	 * when the browser supports typed arrays.
	 *
	 * Note:
	 *
	 *   - Firefox 4-29 lacks support for adding new properties to `Uint8Array` instances,
	 *     See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438.
	 *
	 *   - Chrome 9-10 is missing the `TypedArray.prototype.subarray` function.
	 *
	 *   - IE10 has a broken `TypedArray.prototype.subarray` function which returns arrays of
	 *     incorrect length in some situations.
	
	 * We detect these buggy browsers and set `Buffer.TYPED_ARRAY_SUPPORT` to `false` so they
	 * get the Object implementation, which is slower but behaves correctly.
	 */
	Buffer.TYPED_ARRAY_SUPPORT = global.TYPED_ARRAY_SUPPORT !== undefined
	  ? global.TYPED_ARRAY_SUPPORT
	  : typedArraySupport()
	
	/*
	 * Export kMaxLength after typed array support is determined.
	 */
	exports.kMaxLength = kMaxLength()
	
	function typedArraySupport () {
	  try {
	    var arr = new Uint8Array(1)
	    arr.__proto__ = {__proto__: Uint8Array.prototype, foo: function () { return 42 }}
	    return arr.foo() === 42 && // typed array instances can be augmented
	        typeof arr.subarray === 'function' && // chrome 9-10 lack `subarray`
	        arr.subarray(1, 1).byteLength === 0 // ie10 has broken `subarray`
	  } catch (e) {
	    return false
	  }
	}
	
	function kMaxLength () {
	  return Buffer.TYPED_ARRAY_SUPPORT
	    ? 0x7fffffff
	    : 0x3fffffff
	}
	
	function createBuffer (that, length) {
	  if (kMaxLength() < length) {
	    throw new RangeError('Invalid typed array length')
	  }
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    // Return an augmented `Uint8Array` instance, for best performance
	    that = new Uint8Array(length)
	    that.__proto__ = Buffer.prototype
	  } else {
	    // Fallback: Return an object instance of the Buffer class
	    if (that === null) {
	      that = new Buffer(length)
	    }
	    that.length = length
	  }
	
	  return that
	}
	
	/**
	 * The Buffer constructor returns instances of `Uint8Array` that have their
	 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
	 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
	 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
	 * returns a single octet.
	 *
	 * The `Uint8Array` prototype remains unmodified.
	 */
	
	function Buffer (arg, encodingOrOffset, length) {
	  if (!Buffer.TYPED_ARRAY_SUPPORT && !(this instanceof Buffer)) {
	    return new Buffer(arg, encodingOrOffset, length)
	  }
	
	  // Common case.
	  if (typeof arg === 'number') {
	    if (typeof encodingOrOffset === 'string') {
	      throw new Error(
	        'If encoding is specified then the first argument must be a string'
	      )
	    }
	    return allocUnsafe(this, arg)
	  }
	  return from(this, arg, encodingOrOffset, length)
	}
	
	Buffer.poolSize = 8192 // not used by this implementation
	
	// TODO: Legacy, not needed anymore. Remove in next major version.
	Buffer._augment = function (arr) {
	  arr.__proto__ = Buffer.prototype
	  return arr
	}
	
	function from (that, value, encodingOrOffset, length) {
	  if (typeof value === 'number') {
	    throw new TypeError('"value" argument must not be a number')
	  }
	
	  if (typeof ArrayBuffer !== 'undefined' && value instanceof ArrayBuffer) {
	    return fromArrayBuffer(that, value, encodingOrOffset, length)
	  }
	
	  if (typeof value === 'string') {
	    return fromString(that, value, encodingOrOffset)
	  }
	
	  return fromObject(that, value)
	}
	
	/**
	 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
	 * if value is a number.
	 * Buffer.from(str[, encoding])
	 * Buffer.from(array)
	 * Buffer.from(buffer)
	 * Buffer.from(arrayBuffer[, byteOffset[, length]])
	 **/
	Buffer.from = function (value, encodingOrOffset, length) {
	  return from(null, value, encodingOrOffset, length)
	}
	
	if (Buffer.TYPED_ARRAY_SUPPORT) {
	  Buffer.prototype.__proto__ = Uint8Array.prototype
	  Buffer.__proto__ = Uint8Array
	  if (typeof Symbol !== 'undefined' && Symbol.species &&
	      Buffer[Symbol.species] === Buffer) {
	    // Fix subarray() in ES2016. See: https://github.com/feross/buffer/pull/97
	    Object.defineProperty(Buffer, Symbol.species, {
	      value: null,
	      configurable: true
	    })
	  }
	}
	
	function assertSize (size) {
	  if (typeof size !== 'number') {
	    throw new TypeError('"size" argument must be a number')
	  } else if (size < 0) {
	    throw new RangeError('"size" argument must not be negative')
	  }
	}
	
	function alloc (that, size, fill, encoding) {
	  assertSize(size)
	  if (size <= 0) {
	    return createBuffer(that, size)
	  }
	  if (fill !== undefined) {
	    // Only pay attention to encoding if it's a string. This
	    // prevents accidentally sending in a number that would
	    // be interpretted as a start offset.
	    return typeof encoding === 'string'
	      ? createBuffer(that, size).fill(fill, encoding)
	      : createBuffer(that, size).fill(fill)
	  }
	  return createBuffer(that, size)
	}
	
	/**
	 * Creates a new filled Buffer instance.
	 * alloc(size[, fill[, encoding]])
	 **/
	Buffer.alloc = function (size, fill, encoding) {
	  return alloc(null, size, fill, encoding)
	}
	
	function allocUnsafe (that, size) {
	  assertSize(size)
	  that = createBuffer(that, size < 0 ? 0 : checked(size) | 0)
	  if (!Buffer.TYPED_ARRAY_SUPPORT) {
	    for (var i = 0; i < size; ++i) {
	      that[i] = 0
	    }
	  }
	  return that
	}
	
	/**
	 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
	 * */
	Buffer.allocUnsafe = function (size) {
	  return allocUnsafe(null, size)
	}
	/**
	 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
	 */
	Buffer.allocUnsafeSlow = function (size) {
	  return allocUnsafe(null, size)
	}
	
	function fromString (that, string, encoding) {
	  if (typeof encoding !== 'string' || encoding === '') {
	    encoding = 'utf8'
	  }
	
	  if (!Buffer.isEncoding(encoding)) {
	    throw new TypeError('"encoding" must be a valid string encoding')
	  }
	
	  var length = byteLength(string, encoding) | 0
	  that = createBuffer(that, length)
	
	  var actual = that.write(string, encoding)
	
	  if (actual !== length) {
	    // Writing a hex string, for example, that contains invalid characters will
	    // cause everything after the first invalid character to be ignored. (e.g.
	    // 'abxxcd' will be treated as 'ab')
	    that = that.slice(0, actual)
	  }
	
	  return that
	}
	
	function fromArrayLike (that, array) {
	  var length = array.length < 0 ? 0 : checked(array.length) | 0
	  that = createBuffer(that, length)
	  for (var i = 0; i < length; i += 1) {
	    that[i] = array[i] & 255
	  }
	  return that
	}
	
	function fromArrayBuffer (that, array, byteOffset, length) {
	  array.byteLength // this throws if `array` is not a valid ArrayBuffer
	
	  if (byteOffset < 0 || array.byteLength < byteOffset) {
	    throw new RangeError('\'offset\' is out of bounds')
	  }
	
	  if (array.byteLength < byteOffset + (length || 0)) {
	    throw new RangeError('\'length\' is out of bounds')
	  }
	
	  if (byteOffset === undefined && length === undefined) {
	    array = new Uint8Array(array)
	  } else if (length === undefined) {
	    array = new Uint8Array(array, byteOffset)
	  } else {
	    array = new Uint8Array(array, byteOffset, length)
	  }
	
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    // Return an augmented `Uint8Array` instance, for best performance
	    that = array
	    that.__proto__ = Buffer.prototype
	  } else {
	    // Fallback: Return an object instance of the Buffer class
	    that = fromArrayLike(that, array)
	  }
	  return that
	}
	
	function fromObject (that, obj) {
	  if (Buffer.isBuffer(obj)) {
	    var len = checked(obj.length) | 0
	    that = createBuffer(that, len)
	
	    if (that.length === 0) {
	      return that
	    }
	
	    obj.copy(that, 0, 0, len)
	    return that
	  }
	
	  if (obj) {
	    if ((typeof ArrayBuffer !== 'undefined' &&
	        obj.buffer instanceof ArrayBuffer) || 'length' in obj) {
	      if (typeof obj.length !== 'number' || isnan(obj.length)) {
	        return createBuffer(that, 0)
	      }
	      return fromArrayLike(that, obj)
	    }
	
	    if (obj.type === 'Buffer' && isArray(obj.data)) {
	      return fromArrayLike(that, obj.data)
	    }
	  }
	
	  throw new TypeError('First argument must be a string, Buffer, ArrayBuffer, Array, or array-like object.')
	}
	
	function checked (length) {
	  // Note: cannot use `length < kMaxLength()` here because that fails when
	  // length is NaN (which is otherwise coerced to zero.)
	  if (length >= kMaxLength()) {
	    throw new RangeError('Attempt to allocate Buffer larger than maximum ' +
	                         'size: 0x' + kMaxLength().toString(16) + ' bytes')
	  }
	  return length | 0
	}
	
	function SlowBuffer (length) {
	  if (+length != length) { // eslint-disable-line eqeqeq
	    length = 0
	  }
	  return Buffer.alloc(+length)
	}
	
	Buffer.isBuffer = function isBuffer (b) {
	  return !!(b != null && b._isBuffer)
	}
	
	Buffer.compare = function compare (a, b) {
	  if (!Buffer.isBuffer(a) || !Buffer.isBuffer(b)) {
	    throw new TypeError('Arguments must be Buffers')
	  }
	
	  if (a === b) return 0
	
	  var x = a.length
	  var y = b.length
	
	  for (var i = 0, len = Math.min(x, y); i < len; ++i) {
	    if (a[i] !== b[i]) {
	      x = a[i]
	      y = b[i]
	      break
	    }
	  }
	
	  if (x < y) return -1
	  if (y < x) return 1
	  return 0
	}
	
	Buffer.isEncoding = function isEncoding (encoding) {
	  switch (String(encoding).toLowerCase()) {
	    case 'hex':
	    case 'utf8':
	    case 'utf-8':
	    case 'ascii':
	    case 'latin1':
	    case 'binary':
	    case 'base64':
	    case 'ucs2':
	    case 'ucs-2':
	    case 'utf16le':
	    case 'utf-16le':
	      return true
	    default:
	      return false
	  }
	}
	
	Buffer.concat = function concat (list, length) {
	  if (!isArray(list)) {
	    throw new TypeError('"list" argument must be an Array of Buffers')
	  }
	
	  if (list.length === 0) {
	    return Buffer.alloc(0)
	  }
	
	  var i
	  if (length === undefined) {
	    length = 0
	    for (i = 0; i < list.length; ++i) {
	      length += list[i].length
	    }
	  }
	
	  var buffer = Buffer.allocUnsafe(length)
	  var pos = 0
	  for (i = 0; i < list.length; ++i) {
	    var buf = list[i]
	    if (!Buffer.isBuffer(buf)) {
	      throw new TypeError('"list" argument must be an Array of Buffers')
	    }
	    buf.copy(buffer, pos)
	    pos += buf.length
	  }
	  return buffer
	}
	
	function byteLength (string, encoding) {
	  if (Buffer.isBuffer(string)) {
	    return string.length
	  }
	  if (typeof ArrayBuffer !== 'undefined' && typeof ArrayBuffer.isView === 'function' &&
	      (ArrayBuffer.isView(string) || string instanceof ArrayBuffer)) {
	    return string.byteLength
	  }
	  if (typeof string !== 'string') {
	    string = '' + string
	  }
	
	  var len = string.length
	  if (len === 0) return 0
	
	  // Use a for loop to avoid recursion
	  var loweredCase = false
	  for (;;) {
	    switch (encoding) {
	      case 'ascii':
	      case 'latin1':
	      case 'binary':
	        return len
	      case 'utf8':
	      case 'utf-8':
	      case undefined:
	        return utf8ToBytes(string).length
	      case 'ucs2':
	      case 'ucs-2':
	      case 'utf16le':
	      case 'utf-16le':
	        return len * 2
	      case 'hex':
	        return len >>> 1
	      case 'base64':
	        return base64ToBytes(string).length
	      default:
	        if (loweredCase) return utf8ToBytes(string).length // assume utf8
	        encoding = ('' + encoding).toLowerCase()
	        loweredCase = true
	    }
	  }
	}
	Buffer.byteLength = byteLength
	
	function slowToString (encoding, start, end) {
	  var loweredCase = false
	
	  // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
	  // property of a typed array.
	
	  // This behaves neither like String nor Uint8Array in that we set start/end
	  // to their upper/lower bounds if the value passed is out of range.
	  // undefined is handled specially as per ECMA-262 6th Edition,
	  // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
	  if (start === undefined || start < 0) {
	    start = 0
	  }
	  // Return early if start > this.length. Done here to prevent potential uint32
	  // coercion fail below.
	  if (start > this.length) {
	    return ''
	  }
	
	  if (end === undefined || end > this.length) {
	    end = this.length
	  }
	
	  if (end <= 0) {
	    return ''
	  }
	
	  // Force coersion to uint32. This will also coerce falsey/NaN values to 0.
	  end >>>= 0
	  start >>>= 0
	
	  if (end <= start) {
	    return ''
	  }
	
	  if (!encoding) encoding = 'utf8'
	
	  while (true) {
	    switch (encoding) {
	      case 'hex':
	        return hexSlice(this, start, end)
	
	      case 'utf8':
	      case 'utf-8':
	        return utf8Slice(this, start, end)
	
	      case 'ascii':
	        return asciiSlice(this, start, end)
	
	      case 'latin1':
	      case 'binary':
	        return latin1Slice(this, start, end)
	
	      case 'base64':
	        return base64Slice(this, start, end)
	
	      case 'ucs2':
	      case 'ucs-2':
	      case 'utf16le':
	      case 'utf-16le':
	        return utf16leSlice(this, start, end)
	
	      default:
	        if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding)
	        encoding = (encoding + '').toLowerCase()
	        loweredCase = true
	    }
	  }
	}
	
	// The property is used by `Buffer.isBuffer` and `is-buffer` (in Safari 5-7) to detect
	// Buffer instances.
	Buffer.prototype._isBuffer = true
	
	function swap (b, n, m) {
	  var i = b[n]
	  b[n] = b[m]
	  b[m] = i
	}
	
	Buffer.prototype.swap16 = function swap16 () {
	  var len = this.length
	  if (len % 2 !== 0) {
	    throw new RangeError('Buffer size must be a multiple of 16-bits')
	  }
	  for (var i = 0; i < len; i += 2) {
	    swap(this, i, i + 1)
	  }
	  return this
	}
	
	Buffer.prototype.swap32 = function swap32 () {
	  var len = this.length
	  if (len % 4 !== 0) {
	    throw new RangeError('Buffer size must be a multiple of 32-bits')
	  }
	  for (var i = 0; i < len; i += 4) {
	    swap(this, i, i + 3)
	    swap(this, i + 1, i + 2)
	  }
	  return this
	}
	
	Buffer.prototype.swap64 = function swap64 () {
	  var len = this.length
	  if (len % 8 !== 0) {
	    throw new RangeError('Buffer size must be a multiple of 64-bits')
	  }
	  for (var i = 0; i < len; i += 8) {
	    swap(this, i, i + 7)
	    swap(this, i + 1, i + 6)
	    swap(this, i + 2, i + 5)
	    swap(this, i + 3, i + 4)
	  }
	  return this
	}
	
	Buffer.prototype.toString = function toString () {
	  var length = this.length | 0
	  if (length === 0) return ''
	  if (arguments.length === 0) return utf8Slice(this, 0, length)
	  return slowToString.apply(this, arguments)
	}
	
	Buffer.prototype.equals = function equals (b) {
	  if (!Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer')
	  if (this === b) return true
	  return Buffer.compare(this, b) === 0
	}
	
	Buffer.prototype.inspect = function inspect () {
	  var str = ''
	  var max = exports.INSPECT_MAX_BYTES
	  if (this.length > 0) {
	    str = this.toString('hex', 0, max).match(/.{2}/g).join(' ')
	    if (this.length > max) str += ' ... '
	  }
	  return '<Buffer ' + str + '>'
	}
	
	Buffer.prototype.compare = function compare (target, start, end, thisStart, thisEnd) {
	  if (!Buffer.isBuffer(target)) {
	    throw new TypeError('Argument must be a Buffer')
	  }
	
	  if (start === undefined) {
	    start = 0
	  }
	  if (end === undefined) {
	    end = target ? target.length : 0
	  }
	  if (thisStart === undefined) {
	    thisStart = 0
	  }
	  if (thisEnd === undefined) {
	    thisEnd = this.length
	  }
	
	  if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) {
	    throw new RangeError('out of range index')
	  }
	
	  if (thisStart >= thisEnd && start >= end) {
	    return 0
	  }
	  if (thisStart >= thisEnd) {
	    return -1
	  }
	  if (start >= end) {
	    return 1
	  }
	
	  start >>>= 0
	  end >>>= 0
	  thisStart >>>= 0
	  thisEnd >>>= 0
	
	  if (this === target) return 0
	
	  var x = thisEnd - thisStart
	  var y = end - start
	  var len = Math.min(x, y)
	
	  var thisCopy = this.slice(thisStart, thisEnd)
	  var targetCopy = target.slice(start, end)
	
	  for (var i = 0; i < len; ++i) {
	    if (thisCopy[i] !== targetCopy[i]) {
	      x = thisCopy[i]
	      y = targetCopy[i]
	      break
	    }
	  }
	
	  if (x < y) return -1
	  if (y < x) return 1
	  return 0
	}
	
	// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
	// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
	//
	// Arguments:
	// - buffer - a Buffer to search
	// - val - a string, Buffer, or number
	// - byteOffset - an index into `buffer`; will be clamped to an int32
	// - encoding - an optional encoding, relevant is val is a string
	// - dir - true for indexOf, false for lastIndexOf
	function bidirectionalIndexOf (buffer, val, byteOffset, encoding, dir) {
	  // Empty buffer means no match
	  if (buffer.length === 0) return -1
	
	  // Normalize byteOffset
	  if (typeof byteOffset === 'string') {
	    encoding = byteOffset
	    byteOffset = 0
	  } else if (byteOffset > 0x7fffffff) {
	    byteOffset = 0x7fffffff
	  } else if (byteOffset < -0x80000000) {
	    byteOffset = -0x80000000
	  }
	  byteOffset = +byteOffset  // Coerce to Number.
	  if (isNaN(byteOffset)) {
	    // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
	    byteOffset = dir ? 0 : (buffer.length - 1)
	  }
	
	  // Normalize byteOffset: negative offsets start from the end of the buffer
	  if (byteOffset < 0) byteOffset = buffer.length + byteOffset
	  if (byteOffset >= buffer.length) {
	    if (dir) return -1
	    else byteOffset = buffer.length - 1
	  } else if (byteOffset < 0) {
	    if (dir) byteOffset = 0
	    else return -1
	  }
	
	  // Normalize val
	  if (typeof val === 'string') {
	    val = Buffer.from(val, encoding)
	  }
	
	  // Finally, search either indexOf (if dir is true) or lastIndexOf
	  if (Buffer.isBuffer(val)) {
	    // Special case: looking for empty string/buffer always fails
	    if (val.length === 0) {
	      return -1
	    }
	    return arrayIndexOf(buffer, val, byteOffset, encoding, dir)
	  } else if (typeof val === 'number') {
	    val = val & 0xFF // Search for a byte value [0-255]
	    if (Buffer.TYPED_ARRAY_SUPPORT &&
	        typeof Uint8Array.prototype.indexOf === 'function') {
	      if (dir) {
	        return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset)
	      } else {
	        return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset)
	      }
	    }
	    return arrayIndexOf(buffer, [ val ], byteOffset, encoding, dir)
	  }
	
	  throw new TypeError('val must be string, number or Buffer')
	}
	
	function arrayIndexOf (arr, val, byteOffset, encoding, dir) {
	  var indexSize = 1
	  var arrLength = arr.length
	  var valLength = val.length
	
	  if (encoding !== undefined) {
	    encoding = String(encoding).toLowerCase()
	    if (encoding === 'ucs2' || encoding === 'ucs-2' ||
	        encoding === 'utf16le' || encoding === 'utf-16le') {
	      if (arr.length < 2 || val.length < 2) {
	        return -1
	      }
	      indexSize = 2
	      arrLength /= 2
	      valLength /= 2
	      byteOffset /= 2
	    }
	  }
	
	  function read (buf, i) {
	    if (indexSize === 1) {
	      return buf[i]
	    } else {
	      return buf.readUInt16BE(i * indexSize)
	    }
	  }
	
	  var i
	  if (dir) {
	    var foundIndex = -1
	    for (i = byteOffset; i < arrLength; i++) {
	      if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
	        if (foundIndex === -1) foundIndex = i
	        if (i - foundIndex + 1 === valLength) return foundIndex * indexSize
	      } else {
	        if (foundIndex !== -1) i -= i - foundIndex
	        foundIndex = -1
	      }
	    }
	  } else {
	    if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength
	    for (i = byteOffset; i >= 0; i--) {
	      var found = true
	      for (var j = 0; j < valLength; j++) {
	        if (read(arr, i + j) !== read(val, j)) {
	          found = false
	          break
	        }
	      }
	      if (found) return i
	    }
	  }
	
	  return -1
	}
	
	Buffer.prototype.includes = function includes (val, byteOffset, encoding) {
	  return this.indexOf(val, byteOffset, encoding) !== -1
	}
	
	Buffer.prototype.indexOf = function indexOf (val, byteOffset, encoding) {
	  return bidirectionalIndexOf(this, val, byteOffset, encoding, true)
	}
	
	Buffer.prototype.lastIndexOf = function lastIndexOf (val, byteOffset, encoding) {
	  return bidirectionalIndexOf(this, val, byteOffset, encoding, false)
	}
	
	function hexWrite (buf, string, offset, length) {
	  offset = Number(offset) || 0
	  var remaining = buf.length - offset
	  if (!length) {
	    length = remaining
	  } else {
	    length = Number(length)
	    if (length > remaining) {
	      length = remaining
	    }
	  }
	
	  // must be an even number of digits
	  var strLen = string.length
	  if (strLen % 2 !== 0) throw new TypeError('Invalid hex string')
	
	  if (length > strLen / 2) {
	    length = strLen / 2
	  }
	  for (var i = 0; i < length; ++i) {
	    var parsed = parseInt(string.substr(i * 2, 2), 16)
	    if (isNaN(parsed)) return i
	    buf[offset + i] = parsed
	  }
	  return i
	}
	
	function utf8Write (buf, string, offset, length) {
	  return blitBuffer(utf8ToBytes(string, buf.length - offset), buf, offset, length)
	}
	
	function asciiWrite (buf, string, offset, length) {
	  return blitBuffer(asciiToBytes(string), buf, offset, length)
	}
	
	function latin1Write (buf, string, offset, length) {
	  return asciiWrite(buf, string, offset, length)
	}
	
	function base64Write (buf, string, offset, length) {
	  return blitBuffer(base64ToBytes(string), buf, offset, length)
	}
	
	function ucs2Write (buf, string, offset, length) {
	  return blitBuffer(utf16leToBytes(string, buf.length - offset), buf, offset, length)
	}
	
	Buffer.prototype.write = function write (string, offset, length, encoding) {
	  // Buffer#write(string)
	  if (offset === undefined) {
	    encoding = 'utf8'
	    length = this.length
	    offset = 0
	  // Buffer#write(string, encoding)
	  } else if (length === undefined && typeof offset === 'string') {
	    encoding = offset
	    length = this.length
	    offset = 0
	  // Buffer#write(string, offset[, length][, encoding])
	  } else if (isFinite(offset)) {
	    offset = offset | 0
	    if (isFinite(length)) {
	      length = length | 0
	      if (encoding === undefined) encoding = 'utf8'
	    } else {
	      encoding = length
	      length = undefined
	    }
	  // legacy write(string, encoding, offset, length) - remove in v0.13
	  } else {
	    throw new Error(
	      'Buffer.write(string, encoding, offset[, length]) is no longer supported'
	    )
	  }
	
	  var remaining = this.length - offset
	  if (length === undefined || length > remaining) length = remaining
	
	  if ((string.length > 0 && (length < 0 || offset < 0)) || offset > this.length) {
	    throw new RangeError('Attempt to write outside buffer bounds')
	  }
	
	  if (!encoding) encoding = 'utf8'
	
	  var loweredCase = false
	  for (;;) {
	    switch (encoding) {
	      case 'hex':
	        return hexWrite(this, string, offset, length)
	
	      case 'utf8':
	      case 'utf-8':
	        return utf8Write(this, string, offset, length)
	
	      case 'ascii':
	        return asciiWrite(this, string, offset, length)
	
	      case 'latin1':
	      case 'binary':
	        return latin1Write(this, string, offset, length)
	
	      case 'base64':
	        // Warning: maxLength not taken into account in base64Write
	        return base64Write(this, string, offset, length)
	
	      case 'ucs2':
	      case 'ucs-2':
	      case 'utf16le':
	      case 'utf-16le':
	        return ucs2Write(this, string, offset, length)
	
	      default:
	        if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding)
	        encoding = ('' + encoding).toLowerCase()
	        loweredCase = true
	    }
	  }
	}
	
	Buffer.prototype.toJSON = function toJSON () {
	  return {
	    type: 'Buffer',
	    data: Array.prototype.slice.call(this._arr || this, 0)
	  }
	}
	
	function base64Slice (buf, start, end) {
	  if (start === 0 && end === buf.length) {
	    return base64.fromByteArray(buf)
	  } else {
	    return base64.fromByteArray(buf.slice(start, end))
	  }
	}
	
	function utf8Slice (buf, start, end) {
	  end = Math.min(buf.length, end)
	  var res = []
	
	  var i = start
	  while (i < end) {
	    var firstByte = buf[i]
	    var codePoint = null
	    var bytesPerSequence = (firstByte > 0xEF) ? 4
	      : (firstByte > 0xDF) ? 3
	      : (firstByte > 0xBF) ? 2
	      : 1
	
	    if (i + bytesPerSequence <= end) {
	      var secondByte, thirdByte, fourthByte, tempCodePoint
	
	      switch (bytesPerSequence) {
	        case 1:
	          if (firstByte < 0x80) {
	            codePoint = firstByte
	          }
	          break
	        case 2:
	          secondByte = buf[i + 1]
	          if ((secondByte & 0xC0) === 0x80) {
	            tempCodePoint = (firstByte & 0x1F) << 0x6 | (secondByte & 0x3F)
	            if (tempCodePoint > 0x7F) {
	              codePoint = tempCodePoint
	            }
	          }
	          break
	        case 3:
	          secondByte = buf[i + 1]
	          thirdByte = buf[i + 2]
	          if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
	            tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | (thirdByte & 0x3F)
	            if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) {
	              codePoint = tempCodePoint
	            }
	          }
	          break
	        case 4:
	          secondByte = buf[i + 1]
	          thirdByte = buf[i + 2]
	          fourthByte = buf[i + 3]
	          if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
	            tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | (fourthByte & 0x3F)
	            if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) {
	              codePoint = tempCodePoint
	            }
	          }
	      }
	    }
	
	    if (codePoint === null) {
	      // we did not generate a valid codePoint so insert a
	      // replacement char (U+FFFD) and advance only 1 byte
	      codePoint = 0xFFFD
	      bytesPerSequence = 1
	    } else if (codePoint > 0xFFFF) {
	      // encode to utf16 (surrogate pair dance)
	      codePoint -= 0x10000
	      res.push(codePoint >>> 10 & 0x3FF | 0xD800)
	      codePoint = 0xDC00 | codePoint & 0x3FF
	    }
	
	    res.push(codePoint)
	    i += bytesPerSequence
	  }
	
	  return decodeCodePointsArray(res)
	}
	
	// Based on http://stackoverflow.com/a/22747272/680742, the browser with
	// the lowest limit is Chrome, with 0x10000 args.
	// We go 1 magnitude less, for safety
	var MAX_ARGUMENTS_LENGTH = 0x1000
	
	function decodeCodePointsArray (codePoints) {
	  var len = codePoints.length
	  if (len <= MAX_ARGUMENTS_LENGTH) {
	    return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
	  }
	
	  // Decode in chunks to avoid "call stack size exceeded".
	  var res = ''
	  var i = 0
	  while (i < len) {
	    res += String.fromCharCode.apply(
	      String,
	      codePoints.slice(i, i += MAX_ARGUMENTS_LENGTH)
	    )
	  }
	  return res
	}
	
	function asciiSlice (buf, start, end) {
	  var ret = ''
	  end = Math.min(buf.length, end)
	
	  for (var i = start; i < end; ++i) {
	    ret += String.fromCharCode(buf[i] & 0x7F)
	  }
	  return ret
	}
	
	function latin1Slice (buf, start, end) {
	  var ret = ''
	  end = Math.min(buf.length, end)
	
	  for (var i = start; i < end; ++i) {
	    ret += String.fromCharCode(buf[i])
	  }
	  return ret
	}
	
	function hexSlice (buf, start, end) {
	  var len = buf.length
	
	  if (!start || start < 0) start = 0
	  if (!end || end < 0 || end > len) end = len
	
	  var out = ''
	  for (var i = start; i < end; ++i) {
	    out += toHex(buf[i])
	  }
	  return out
	}
	
	function utf16leSlice (buf, start, end) {
	  var bytes = buf.slice(start, end)
	  var res = ''
	  for (var i = 0; i < bytes.length; i += 2) {
	    res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256)
	  }
	  return res
	}
	
	Buffer.prototype.slice = function slice (start, end) {
	  var len = this.length
	  start = ~~start
	  end = end === undefined ? len : ~~end
	
	  if (start < 0) {
	    start += len
	    if (start < 0) start = 0
	  } else if (start > len) {
	    start = len
	  }
	
	  if (end < 0) {
	    end += len
	    if (end < 0) end = 0
	  } else if (end > len) {
	    end = len
	  }
	
	  if (end < start) end = start
	
	  var newBuf
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    newBuf = this.subarray(start, end)
	    newBuf.__proto__ = Buffer.prototype
	  } else {
	    var sliceLen = end - start
	    newBuf = new Buffer(sliceLen, undefined)
	    for (var i = 0; i < sliceLen; ++i) {
	      newBuf[i] = this[i + start]
	    }
	  }
	
	  return newBuf
	}
	
	/*
	 * Need to make sure that buffer isn't trying to write out of bounds.
	 */
	function checkOffset (offset, ext, length) {
	  if ((offset % 1) !== 0 || offset < 0) throw new RangeError('offset is not uint')
	  if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length')
	}
	
	Buffer.prototype.readUIntLE = function readUIntLE (offset, byteLength, noAssert) {
	  offset = offset | 0
	  byteLength = byteLength | 0
	  if (!noAssert) checkOffset(offset, byteLength, this.length)
	
	  var val = this[offset]
	  var mul = 1
	  var i = 0
	  while (++i < byteLength && (mul *= 0x100)) {
	    val += this[offset + i] * mul
	  }
	
	  return val
	}
	
	Buffer.prototype.readUIntBE = function readUIntBE (offset, byteLength, noAssert) {
	  offset = offset | 0
	  byteLength = byteLength | 0
	  if (!noAssert) {
	    checkOffset(offset, byteLength, this.length)
	  }
	
	  var val = this[offset + --byteLength]
	  var mul = 1
	  while (byteLength > 0 && (mul *= 0x100)) {
	    val += this[offset + --byteLength] * mul
	  }
	
	  return val
	}
	
	Buffer.prototype.readUInt8 = function readUInt8 (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 1, this.length)
	  return this[offset]
	}
	
	Buffer.prototype.readUInt16LE = function readUInt16LE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 2, this.length)
	  return this[offset] | (this[offset + 1] << 8)
	}
	
	Buffer.prototype.readUInt16BE = function readUInt16BE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 2, this.length)
	  return (this[offset] << 8) | this[offset + 1]
	}
	
	Buffer.prototype.readUInt32LE = function readUInt32LE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 4, this.length)
	
	  return ((this[offset]) |
	      (this[offset + 1] << 8) |
	      (this[offset + 2] << 16)) +
	      (this[offset + 3] * 0x1000000)
	}
	
	Buffer.prototype.readUInt32BE = function readUInt32BE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 4, this.length)
	
	  return (this[offset] * 0x1000000) +
	    ((this[offset + 1] << 16) |
	    (this[offset + 2] << 8) |
	    this[offset + 3])
	}
	
	Buffer.prototype.readIntLE = function readIntLE (offset, byteLength, noAssert) {
	  offset = offset | 0
	  byteLength = byteLength | 0
	  if (!noAssert) checkOffset(offset, byteLength, this.length)
	
	  var val = this[offset]
	  var mul = 1
	  var i = 0
	  while (++i < byteLength && (mul *= 0x100)) {
	    val += this[offset + i] * mul
	  }
	  mul *= 0x80
	
	  if (val >= mul) val -= Math.pow(2, 8 * byteLength)
	
	  return val
	}
	
	Buffer.prototype.readIntBE = function readIntBE (offset, byteLength, noAssert) {
	  offset = offset | 0
	  byteLength = byteLength | 0
	  if (!noAssert) checkOffset(offset, byteLength, this.length)
	
	  var i = byteLength
	  var mul = 1
	  var val = this[offset + --i]
	  while (i > 0 && (mul *= 0x100)) {
	    val += this[offset + --i] * mul
	  }
	  mul *= 0x80
	
	  if (val >= mul) val -= Math.pow(2, 8 * byteLength)
	
	  return val
	}
	
	Buffer.prototype.readInt8 = function readInt8 (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 1, this.length)
	  if (!(this[offset] & 0x80)) return (this[offset])
	  return ((0xff - this[offset] + 1) * -1)
	}
	
	Buffer.prototype.readInt16LE = function readInt16LE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 2, this.length)
	  var val = this[offset] | (this[offset + 1] << 8)
	  return (val & 0x8000) ? val | 0xFFFF0000 : val
	}
	
	Buffer.prototype.readInt16BE = function readInt16BE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 2, this.length)
	  var val = this[offset + 1] | (this[offset] << 8)
	  return (val & 0x8000) ? val | 0xFFFF0000 : val
	}
	
	Buffer.prototype.readInt32LE = function readInt32LE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 4, this.length)
	
	  return (this[offset]) |
	    (this[offset + 1] << 8) |
	    (this[offset + 2] << 16) |
	    (this[offset + 3] << 24)
	}
	
	Buffer.prototype.readInt32BE = function readInt32BE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 4, this.length)
	
	  return (this[offset] << 24) |
	    (this[offset + 1] << 16) |
	    (this[offset + 2] << 8) |
	    (this[offset + 3])
	}
	
	Buffer.prototype.readFloatLE = function readFloatLE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 4, this.length)
	  return ieee754.read(this, offset, true, 23, 4)
	}
	
	Buffer.prototype.readFloatBE = function readFloatBE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 4, this.length)
	  return ieee754.read(this, offset, false, 23, 4)
	}
	
	Buffer.prototype.readDoubleLE = function readDoubleLE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 8, this.length)
	  return ieee754.read(this, offset, true, 52, 8)
	}
	
	Buffer.prototype.readDoubleBE = function readDoubleBE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 8, this.length)
	  return ieee754.read(this, offset, false, 52, 8)
	}
	
	function checkInt (buf, value, offset, ext, max, min) {
	  if (!Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance')
	  if (value > max || value < min) throw new RangeError('"value" argument is out of bounds')
	  if (offset + ext > buf.length) throw new RangeError('Index out of range')
	}
	
	Buffer.prototype.writeUIntLE = function writeUIntLE (value, offset, byteLength, noAssert) {
	  value = +value
	  offset = offset | 0
	  byteLength = byteLength | 0
	  if (!noAssert) {
	    var maxBytes = Math.pow(2, 8 * byteLength) - 1
	    checkInt(this, value, offset, byteLength, maxBytes, 0)
	  }
	
	  var mul = 1
	  var i = 0
	  this[offset] = value & 0xFF
	  while (++i < byteLength && (mul *= 0x100)) {
	    this[offset + i] = (value / mul) & 0xFF
	  }
	
	  return offset + byteLength
	}
	
	Buffer.prototype.writeUIntBE = function writeUIntBE (value, offset, byteLength, noAssert) {
	  value = +value
	  offset = offset | 0
	  byteLength = byteLength | 0
	  if (!noAssert) {
	    var maxBytes = Math.pow(2, 8 * byteLength) - 1
	    checkInt(this, value, offset, byteLength, maxBytes, 0)
	  }
	
	  var i = byteLength - 1
	  var mul = 1
	  this[offset + i] = value & 0xFF
	  while (--i >= 0 && (mul *= 0x100)) {
	    this[offset + i] = (value / mul) & 0xFF
	  }
	
	  return offset + byteLength
	}
	
	Buffer.prototype.writeUInt8 = function writeUInt8 (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 1, 0xff, 0)
	  if (!Buffer.TYPED_ARRAY_SUPPORT) value = Math.floor(value)
	  this[offset] = (value & 0xff)
	  return offset + 1
	}
	
	function objectWriteUInt16 (buf, value, offset, littleEndian) {
	  if (value < 0) value = 0xffff + value + 1
	  for (var i = 0, j = Math.min(buf.length - offset, 2); i < j; ++i) {
	    buf[offset + i] = (value & (0xff << (8 * (littleEndian ? i : 1 - i)))) >>>
	      (littleEndian ? i : 1 - i) * 8
	  }
	}
	
	Buffer.prototype.writeUInt16LE = function writeUInt16LE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value & 0xff)
	    this[offset + 1] = (value >>> 8)
	  } else {
	    objectWriteUInt16(this, value, offset, true)
	  }
	  return offset + 2
	}
	
	Buffer.prototype.writeUInt16BE = function writeUInt16BE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value >>> 8)
	    this[offset + 1] = (value & 0xff)
	  } else {
	    objectWriteUInt16(this, value, offset, false)
	  }
	  return offset + 2
	}
	
	function objectWriteUInt32 (buf, value, offset, littleEndian) {
	  if (value < 0) value = 0xffffffff + value + 1
	  for (var i = 0, j = Math.min(buf.length - offset, 4); i < j; ++i) {
	    buf[offset + i] = (value >>> (littleEndian ? i : 3 - i) * 8) & 0xff
	  }
	}
	
	Buffer.prototype.writeUInt32LE = function writeUInt32LE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset + 3] = (value >>> 24)
	    this[offset + 2] = (value >>> 16)
	    this[offset + 1] = (value >>> 8)
	    this[offset] = (value & 0xff)
	  } else {
	    objectWriteUInt32(this, value, offset, true)
	  }
	  return offset + 4
	}
	
	Buffer.prototype.writeUInt32BE = function writeUInt32BE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value >>> 24)
	    this[offset + 1] = (value >>> 16)
	    this[offset + 2] = (value >>> 8)
	    this[offset + 3] = (value & 0xff)
	  } else {
	    objectWriteUInt32(this, value, offset, false)
	  }
	  return offset + 4
	}
	
	Buffer.prototype.writeIntLE = function writeIntLE (value, offset, byteLength, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) {
	    var limit = Math.pow(2, 8 * byteLength - 1)
	
	    checkInt(this, value, offset, byteLength, limit - 1, -limit)
	  }
	
	  var i = 0
	  var mul = 1
	  var sub = 0
	  this[offset] = value & 0xFF
	  while (++i < byteLength && (mul *= 0x100)) {
	    if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) {
	      sub = 1
	    }
	    this[offset + i] = ((value / mul) >> 0) - sub & 0xFF
	  }
	
	  return offset + byteLength
	}
	
	Buffer.prototype.writeIntBE = function writeIntBE (value, offset, byteLength, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) {
	    var limit = Math.pow(2, 8 * byteLength - 1)
	
	    checkInt(this, value, offset, byteLength, limit - 1, -limit)
	  }
	
	  var i = byteLength - 1
	  var mul = 1
	  var sub = 0
	  this[offset + i] = value & 0xFF
	  while (--i >= 0 && (mul *= 0x100)) {
	    if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) {
	      sub = 1
	    }
	    this[offset + i] = ((value / mul) >> 0) - sub & 0xFF
	  }
	
	  return offset + byteLength
	}
	
	Buffer.prototype.writeInt8 = function writeInt8 (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 1, 0x7f, -0x80)
	  if (!Buffer.TYPED_ARRAY_SUPPORT) value = Math.floor(value)
	  if (value < 0) value = 0xff + value + 1
	  this[offset] = (value & 0xff)
	  return offset + 1
	}
	
	Buffer.prototype.writeInt16LE = function writeInt16LE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value & 0xff)
	    this[offset + 1] = (value >>> 8)
	  } else {
	    objectWriteUInt16(this, value, offset, true)
	  }
	  return offset + 2
	}
	
	Buffer.prototype.writeInt16BE = function writeInt16BE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value >>> 8)
	    this[offset + 1] = (value & 0xff)
	  } else {
	    objectWriteUInt16(this, value, offset, false)
	  }
	  return offset + 2
	}
	
	Buffer.prototype.writeInt32LE = function writeInt32LE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value & 0xff)
	    this[offset + 1] = (value >>> 8)
	    this[offset + 2] = (value >>> 16)
	    this[offset + 3] = (value >>> 24)
	  } else {
	    objectWriteUInt32(this, value, offset, true)
	  }
	  return offset + 4
	}
	
	Buffer.prototype.writeInt32BE = function writeInt32BE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000)
	  if (value < 0) value = 0xffffffff + value + 1
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value >>> 24)
	    this[offset + 1] = (value >>> 16)
	    this[offset + 2] = (value >>> 8)
	    this[offset + 3] = (value & 0xff)
	  } else {
	    objectWriteUInt32(this, value, offset, false)
	  }
	  return offset + 4
	}
	
	function checkIEEE754 (buf, value, offset, ext, max, min) {
	  if (offset + ext > buf.length) throw new RangeError('Index out of range')
	  if (offset < 0) throw new RangeError('Index out of range')
	}
	
	function writeFloat (buf, value, offset, littleEndian, noAssert) {
	  if (!noAssert) {
	    checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -3.4028234663852886e+38)
	  }
	  ieee754.write(buf, value, offset, littleEndian, 23, 4)
	  return offset + 4
	}
	
	Buffer.prototype.writeFloatLE = function writeFloatLE (value, offset, noAssert) {
	  return writeFloat(this, value, offset, true, noAssert)
	}
	
	Buffer.prototype.writeFloatBE = function writeFloatBE (value, offset, noAssert) {
	  return writeFloat(this, value, offset, false, noAssert)
	}
	
	function writeDouble (buf, value, offset, littleEndian, noAssert) {
	  if (!noAssert) {
	    checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -1.7976931348623157E+308)
	  }
	  ieee754.write(buf, value, offset, littleEndian, 52, 8)
	  return offset + 8
	}
	
	Buffer.prototype.writeDoubleLE = function writeDoubleLE (value, offset, noAssert) {
	  return writeDouble(this, value, offset, true, noAssert)
	}
	
	Buffer.prototype.writeDoubleBE = function writeDoubleBE (value, offset, noAssert) {
	  return writeDouble(this, value, offset, false, noAssert)
	}
	
	// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
	Buffer.prototype.copy = function copy (target, targetStart, start, end) {
	  if (!start) start = 0
	  if (!end && end !== 0) end = this.length
	  if (targetStart >= target.length) targetStart = target.length
	  if (!targetStart) targetStart = 0
	  if (end > 0 && end < start) end = start
	
	  // Copy 0 bytes; we're done
	  if (end === start) return 0
	  if (target.length === 0 || this.length === 0) return 0
	
	  // Fatal error conditions
	  if (targetStart < 0) {
	    throw new RangeError('targetStart out of bounds')
	  }
	  if (start < 0 || start >= this.length) throw new RangeError('sourceStart out of bounds')
	  if (end < 0) throw new RangeError('sourceEnd out of bounds')
	
	  // Are we oob?
	  if (end > this.length) end = this.length
	  if (target.length - targetStart < end - start) {
	    end = target.length - targetStart + start
	  }
	
	  var len = end - start
	  var i
	
	  if (this === target && start < targetStart && targetStart < end) {
	    // descending copy from end
	    for (i = len - 1; i >= 0; --i) {
	      target[i + targetStart] = this[i + start]
	    }
	  } else if (len < 1000 || !Buffer.TYPED_ARRAY_SUPPORT) {
	    // ascending copy from start
	    for (i = 0; i < len; ++i) {
	      target[i + targetStart] = this[i + start]
	    }
	  } else {
	    Uint8Array.prototype.set.call(
	      target,
	      this.subarray(start, start + len),
	      targetStart
	    )
	  }
	
	  return len
	}
	
	// Usage:
	//    buffer.fill(number[, offset[, end]])
	//    buffer.fill(buffer[, offset[, end]])
	//    buffer.fill(string[, offset[, end]][, encoding])
	Buffer.prototype.fill = function fill (val, start, end, encoding) {
	  // Handle string cases:
	  if (typeof val === 'string') {
	    if (typeof start === 'string') {
	      encoding = start
	      start = 0
	      end = this.length
	    } else if (typeof end === 'string') {
	      encoding = end
	      end = this.length
	    }
	    if (val.length === 1) {
	      var code = val.charCodeAt(0)
	      if (code < 256) {
	        val = code
	      }
	    }
	    if (encoding !== undefined && typeof encoding !== 'string') {
	      throw new TypeError('encoding must be a string')
	    }
	    if (typeof encoding === 'string' && !Buffer.isEncoding(encoding)) {
	      throw new TypeError('Unknown encoding: ' + encoding)
	    }
	  } else if (typeof val === 'number') {
	    val = val & 255
	  }
	
	  // Invalid ranges are not set to a default, so can range check early.
	  if (start < 0 || this.length < start || this.length < end) {
	    throw new RangeError('Out of range index')
	  }
	
	  if (end <= start) {
	    return this
	  }
	
	  start = start >>> 0
	  end = end === undefined ? this.length : end >>> 0
	
	  if (!val) val = 0
	
	  var i
	  if (typeof val === 'number') {
	    for (i = start; i < end; ++i) {
	      this[i] = val
	    }
	  } else {
	    var bytes = Buffer.isBuffer(val)
	      ? val
	      : utf8ToBytes(new Buffer(val, encoding).toString())
	    var len = bytes.length
	    for (i = 0; i < end - start; ++i) {
	      this[i + start] = bytes[i % len]
	    }
	  }
	
	  return this
	}
	
	// HELPER FUNCTIONS
	// ================
	
	var INVALID_BASE64_RE = /[^+\/0-9A-Za-z-_]/g
	
	function base64clean (str) {
	  // Node strips out invalid characters like \n and \t from the string, base64-js does not
	  str = stringtrim(str).replace(INVALID_BASE64_RE, '')
	  // Node converts strings with length < 2 to ''
	  if (str.length < 2) return ''
	  // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
	  while (str.length % 4 !== 0) {
	    str = str + '='
	  }
	  return str
	}
	
	function stringtrim (str) {
	  if (str.trim) return str.trim()
	  return str.replace(/^\s+|\s+$/g, '')
	}
	
	function toHex (n) {
	  if (n < 16) return '0' + n.toString(16)
	  return n.toString(16)
	}
	
	function utf8ToBytes (string, units) {
	  units = units || Infinity
	  var codePoint
	  var length = string.length
	  var leadSurrogate = null
	  var bytes = []
	
	  for (var i = 0; i < length; ++i) {
	    codePoint = string.charCodeAt(i)
	
	    // is surrogate component
	    if (codePoint > 0xD7FF && codePoint < 0xE000) {
	      // last char was a lead
	      if (!leadSurrogate) {
	        // no lead yet
	        if (codePoint > 0xDBFF) {
	          // unexpected trail
	          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
	          continue
	        } else if (i + 1 === length) {
	          // unpaired lead
	          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
	          continue
	        }
	
	        // valid lead
	        leadSurrogate = codePoint
	
	        continue
	      }
	
	      // 2 leads in a row
	      if (codePoint < 0xDC00) {
	        if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
	        leadSurrogate = codePoint
	        continue
	      }
	
	      // valid surrogate pair
	      codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000
	    } else if (leadSurrogate) {
	      // valid bmp char, but last char was a lead
	      if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
	    }
	
	    leadSurrogate = null
	
	    // encode utf8
	    if (codePoint < 0x80) {
	      if ((units -= 1) < 0) break
	      bytes.push(codePoint)
	    } else if (codePoint < 0x800) {
	      if ((units -= 2) < 0) break
	      bytes.push(
	        codePoint >> 0x6 | 0xC0,
	        codePoint & 0x3F | 0x80
	      )
	    } else if (codePoint < 0x10000) {
	      if ((units -= 3) < 0) break
	      bytes.push(
	        codePoint >> 0xC | 0xE0,
	        codePoint >> 0x6 & 0x3F | 0x80,
	        codePoint & 0x3F | 0x80
	      )
	    } else if (codePoint < 0x110000) {
	      if ((units -= 4) < 0) break
	      bytes.push(
	        codePoint >> 0x12 | 0xF0,
	        codePoint >> 0xC & 0x3F | 0x80,
	        codePoint >> 0x6 & 0x3F | 0x80,
	        codePoint & 0x3F | 0x80
	      )
	    } else {
	      throw new Error('Invalid code point')
	    }
	  }
	
	  return bytes
	}
	
	function asciiToBytes (str) {
	  var byteArray = []
	  for (var i = 0; i < str.length; ++i) {
	    // Node's code seems to be doing this and not & 0x7F..
	    byteArray.push(str.charCodeAt(i) & 0xFF)
	  }
	  return byteArray
	}
	
	function utf16leToBytes (str, units) {
	  var c, hi, lo
	  var byteArray = []
	  for (var i = 0; i < str.length; ++i) {
	    if ((units -= 2) < 0) break
	
	    c = str.charCodeAt(i)
	    hi = c >> 8
	    lo = c % 256
	    byteArray.push(lo)
	    byteArray.push(hi)
	  }
	
	  return byteArray
	}
	
	function base64ToBytes (str) {
	  return base64.toByteArray(base64clean(str))
	}
	
	function blitBuffer (src, dst, offset, length) {
	  for (var i = 0; i < length; ++i) {
	    if ((i + offset >= dst.length) || (i >= src.length)) break
	    dst[i + offset] = src[i]
	  }
	  return i
	}
	
	function isnan (val) {
	  return val !== val // eslint-disable-line no-self-compare
	}
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 32 */
/***/ function(module, exports, __webpack_require__) {

	var anObject = __webpack_require__(15);
	var IE8_DOM_DEFINE = __webpack_require__(361);
	var toPrimitive = __webpack_require__(64);
	var dP = Object.defineProperty;
	
	exports.f = __webpack_require__(28) ? Object.defineProperty : function defineProperty(O, P, Attributes) {
	  anObject(O);
	  P = toPrimitive(P, true);
	  anObject(Attributes);
	  if (IE8_DOM_DEFINE) try {
	    return dP(O, P, Attributes);
	  } catch (e) { /* empty */ }
	  if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported!');
	  if ('value' in Attributes) O[P] = Attributes.value;
	  return O;
	};


/***/ },
/* 33 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = format;
	
	var _index = _interopRequireDefault(__webpack_require__(43));
	
	var _index2 = _interopRequireDefault(__webpack_require__(115));
	
	var _index3 = _interopRequireDefault(__webpack_require__(143));
	
	var _index4 = _interopRequireDefault(__webpack_require__(3));
	
	var _index5 = _interopRequireDefault(__webpack_require__(893));
	
	var _index6 = _interopRequireDefault(__webpack_require__(392));
	
	var _index7 = _interopRequireDefault(__webpack_require__(73));
	
	var _index8 = __webpack_require__(396);
	
	var _index9 = _interopRequireDefault(__webpack_require__(9));
	
	var _index10 = _interopRequireDefault(__webpack_require__(2));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// This RegExp consists of three parts separated by `|`:
	// - [yYQqMLwIdDecihHKkms]o matches any available ordinal number token
	//   (one of the certain letters followed by `o`)
	// - (\w)\1* matches any sequences of the same letter
	// - '' matches two quote characters in a row
	// - '(''|[^'])+('|$) matches anything surrounded by two quote characters ('),
	//   except a single quote symbol, which ends the sequence.
	//   Two quote characters do not end the sequence.
	//   If there is no matching single quote
	//   then the sequence will continue until the end of the string.
	// - . matches any single character unmatched by previous parts of the RegExps
	var formattingTokensRegExp = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g; // This RegExp catches symbols escaped by quotes, and also
	// sequences of symbols P, p, and the combinations like `PPPPPPPppppp`
	
	var longFormattingTokensRegExp = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g;
	var escapedStringRegExp = /^'([^]*?)'?$/;
	var doubleQuoteRegExp = /''/g;
	var unescapedLatinCharacterRegExp = /[a-zA-Z]/;
	/**
	 * @name format
	 * @category Common Helpers
	 * @summary Format the date.
	 *
	 * @description
	 * Return the formatted date string in the given format. The result may vary by locale.
	 *
	 * > ⚠️ Please note that the `format` tokens differ from Moment.js and other libraries.
	 * > See: https://git.io/fxCyr
	 *
	 * The characters wrapped between two single quotes characters (') are escaped.
	 * Two single quotes in a row, whether inside or outside a quoted sequence, represent a 'real' single quote.
	 * (see the last example)
	 *
	 * Format of the string is based on Unicode Technical Standard #35:
	 * https://www.unicode.org/reports/tr35/tr35-dates.html#Date_Field_Symbol_Table
	 * with a few additions (see note 7 below the table).
	 *
	 * Accepted patterns:
	 * | Unit                            | Pattern | Result examples                   | Notes |
	 * |---------------------------------|---------|-----------------------------------|-------|
	 * | Era                             | G..GGG  | AD, BC                            |       |
	 * |                                 | GGGG    | Anno Domini, Before Christ        | 2     |
	 * |                                 | GGGGG   | A, B                              |       |
	 * | Calendar year                   | y       | 44, 1, 1900, 2017                 | 5     |
	 * |                                 | yo      | 44th, 1st, 0th, 17th              | 5,7   |
	 * |                                 | yy      | 44, 01, 00, 17                    | 5     |
	 * |                                 | yyy     | 044, 001, 1900, 2017              | 5     |
	 * |                                 | yyyy    | 0044, 0001, 1900, 2017            | 5     |
	 * |                                 | yyyyy   | ...                               | 3,5   |
	 * | Local week-numbering year       | Y       | 44, 1, 1900, 2017                 | 5     |
	 * |                                 | Yo      | 44th, 1st, 1900th, 2017th         | 5,7   |
	 * |                                 | YY      | 44, 01, 00, 17                    | 5,8   |
	 * |                                 | YYY     | 044, 001, 1900, 2017              | 5     |
	 * |                                 | YYYY    | 0044, 0001, 1900, 2017            | 5,8   |
	 * |                                 | YYYYY   | ...                               | 3,5   |
	 * | ISO week-numbering year         | R       | -43, 0, 1, 1900, 2017             | 5,7   |
	 * |                                 | RR      | -43, 00, 01, 1900, 2017           | 5,7   |
	 * |                                 | RRR     | -043, 000, 001, 1900, 2017        | 5,7   |
	 * |                                 | RRRR    | -0043, 0000, 0001, 1900, 2017     | 5,7   |
	 * |                                 | RRRRR   | ...                               | 3,5,7 |
	 * | Extended year                   | u       | -43, 0, 1, 1900, 2017             | 5     |
	 * |                                 | uu      | -43, 01, 1900, 2017               | 5     |
	 * |                                 | uuu     | -043, 001, 1900, 2017             | 5     |
	 * |                                 | uuuu    | -0043, 0001, 1900, 2017           | 5     |
	 * |                                 | uuuuu   | ...                               | 3,5   |
	 * | Quarter (formatting)            | Q       | 1, 2, 3, 4                        |       |
	 * |                                 | Qo      | 1st, 2nd, 3rd, 4th                | 7     |
	 * |                                 | QQ      | 01, 02, 03, 04                    |       |
	 * |                                 | QQQ     | Q1, Q2, Q3, Q4                    |       |
	 * |                                 | QQQQ    | 1st quarter, 2nd quarter, ...     | 2     |
	 * |                                 | QQQQQ   | 1, 2, 3, 4                        | 4     |
	 * | Quarter (stand-alone)           | q       | 1, 2, 3, 4                        |       |
	 * |                                 | qo      | 1st, 2nd, 3rd, 4th                | 7     |
	 * |                                 | qq      | 01, 02, 03, 04                    |       |
	 * |                                 | qqq     | Q1, Q2, Q3, Q4                    |       |
	 * |                                 | qqqq    | 1st quarter, 2nd quarter, ...     | 2     |
	 * |                                 | qqqqq   | 1, 2, 3, 4                        | 4     |
	 * | Month (formatting)              | M       | 1, 2, ..., 12                     |       |
	 * |                                 | Mo      | 1st, 2nd, ..., 12th               | 7     |
	 * |                                 | MM      | 01, 02, ..., 12                   |       |
	 * |                                 | MMM     | Jan, Feb, ..., Dec                |       |
	 * |                                 | MMMM    | January, February, ..., December  | 2     |
	 * |                                 | MMMMM   | J, F, ..., D                      |       |
	 * | Month (stand-alone)             | L       | 1, 2, ..., 12                     |       |
	 * |                                 | Lo      | 1st, 2nd, ..., 12th               | 7     |
	 * |                                 | LL      | 01, 02, ..., 12                   |       |
	 * |                                 | LLL     | Jan, Feb, ..., Dec                |       |
	 * |                                 | LLLL    | January, February, ..., December  | 2     |
	 * |                                 | LLLLL   | J, F, ..., D                      |       |
	 * | Local week of year              | w       | 1, 2, ..., 53                     |       |
	 * |                                 | wo      | 1st, 2nd, ..., 53th               | 7     |
	 * |                                 | ww      | 01, 02, ..., 53                   |       |
	 * | ISO week of year                | I       | 1, 2, ..., 53                     | 7     |
	 * |                                 | Io      | 1st, 2nd, ..., 53th               | 7     |
	 * |                                 | II      | 01, 02, ..., 53                   | 7     |
	 * | Day of month                    | d       | 1, 2, ..., 31                     |       |
	 * |                                 | do      | 1st, 2nd, ..., 31st               | 7     |
	 * |                                 | dd      | 01, 02, ..., 31                   |       |
	 * | Day of year                     | D       | 1, 2, ..., 365, 366               | 9     |
	 * |                                 | Do      | 1st, 2nd, ..., 365th, 366th       | 7     |
	 * |                                 | DD      | 01, 02, ..., 365, 366             | 9     |
	 * |                                 | DDD     | 001, 002, ..., 365, 366           |       |
	 * |                                 | DDDD    | ...                               | 3     |
	 * | Day of week (formatting)        | E..EEE  | Mon, Tue, Wed, ..., Su            |       |
	 * |                                 | EEEE    | Monday, Tuesday, ..., Sunday      | 2     |
	 * |                                 | EEEEE   | M, T, W, T, F, S, S               |       |
	 * |                                 | EEEEEE  | Mo, Tu, We, Th, Fr, Su, Sa        |       |
	 * | ISO day of week (formatting)    | i       | 1, 2, 3, ..., 7                   | 7     |
	 * |                                 | io      | 1st, 2nd, ..., 7th                | 7     |
	 * |                                 | ii      | 01, 02, ..., 07                   | 7     |
	 * |                                 | iii     | Mon, Tue, Wed, ..., Su            | 7     |
	 * |                                 | iiii    | Monday, Tuesday, ..., Sunday      | 2,7   |
	 * |                                 | iiiii   | M, T, W, T, F, S, S               | 7     |
	 * |                                 | iiiiii  | Mo, Tu, We, Th, Fr, Su, Sa        | 7     |
	 * | Local day of week (formatting)  | e       | 2, 3, 4, ..., 1                   |       |
	 * |                                 | eo      | 2nd, 3rd, ..., 1st                | 7     |
	 * |                                 | ee      | 02, 03, ..., 01                   |       |
	 * |                                 | eee     | Mon, Tue, Wed, ..., Su            |       |
	 * |                                 | eeee    | Monday, Tuesday, ..., Sunday      | 2     |
	 * |                                 | eeeee   | M, T, W, T, F, S, S               |       |
	 * |                                 | eeeeee  | Mo, Tu, We, Th, Fr, Su, Sa        |       |
	 * | Local day of week (stand-alone) | c       | 2, 3, 4, ..., 1                   |       |
	 * |                                 | co      | 2nd, 3rd, ..., 1st                | 7     |
	 * |                                 | cc      | 02, 03, ..., 01                   |       |
	 * |                                 | ccc     | Mon, Tue, Wed, ..., Su            |       |
	 * |                                 | cccc    | Monday, Tuesday, ..., Sunday      | 2     |
	 * |                                 | ccccc   | M, T, W, T, F, S, S               |       |
	 * |                                 | cccccc  | Mo, Tu, We, Th, Fr, Su, Sa        |       |
	 * | AM, PM                          | a..aaa  | AM, PM                            |       |
	 * |                                 | aaaa    | a.m., p.m.                        | 2     |
	 * |                                 | aaaaa   | a, p                              |       |
	 * | AM, PM, noon, midnight          | b..bbb  | AM, PM, noon, midnight            |       |
	 * |                                 | bbbb    | a.m., p.m., noon, midnight        | 2     |
	 * |                                 | bbbbb   | a, p, n, mi                       |       |
	 * | Flexible day period             | B..BBB  | at night, in the morning, ...     |       |
	 * |                                 | BBBB    | at night, in the morning, ...     | 2     |
	 * |                                 | BBBBB   | at night, in the morning, ...     |       |
	 * | Hour [1-12]                     | h       | 1, 2, ..., 11, 12                 |       |
	 * |                                 | ho      | 1st, 2nd, ..., 11th, 12th         | 7     |
	 * |                                 | hh      | 01, 02, ..., 11, 12               |       |
	 * | Hour [0-23]                     | H       | 0, 1, 2, ..., 23                  |       |
	 * |                                 | Ho      | 0th, 1st, 2nd, ..., 23rd          | 7     |
	 * |                                 | HH      | 00, 01, 02, ..., 23               |       |
	 * | Hour [0-11]                     | K       | 1, 2, ..., 11, 0                  |       |
	 * |                                 | Ko      | 1st, 2nd, ..., 11th, 0th          | 7     |
	 * |                                 | KK      | 01, 02, ..., 11, 00               |       |
	 * | Hour [1-24]                     | k       | 24, 1, 2, ..., 23                 |       |
	 * |                                 | ko      | 24th, 1st, 2nd, ..., 23rd         | 7     |
	 * |                                 | kk      | 24, 01, 02, ..., 23               |       |
	 * | Minute                          | m       | 0, 1, ..., 59                     |       |
	 * |                                 | mo      | 0th, 1st, ..., 59th               | 7     |
	 * |                                 | mm      | 00, 01, ..., 59                   |       |
	 * | Second                          | s       | 0, 1, ..., 59                     |       |
	 * |                                 | so      | 0th, 1st, ..., 59th               | 7     |
	 * |                                 | ss      | 00, 01, ..., 59                   |       |
	 * | Fraction of second              | S       | 0, 1, ..., 9                      |       |
	 * |                                 | SS      | 00, 01, ..., 99                   |       |
	 * |                                 | SSS     | 000, 0001, ..., 999               |       |
	 * |                                 | SSSS    | ...                               | 3     |
	 * | Timezone (ISO-8601 w/ Z)        | X       | -08, +0530, Z                     |       |
	 * |                                 | XX      | -0800, +0530, Z                   |       |
	 * |                                 | XXX     | -08:00, +05:30, Z                 |       |
	 * |                                 | XXXX    | -0800, +0530, Z, +123456          | 2     |
	 * |                                 | XXXXX   | -08:00, +05:30, Z, +12:34:56      |       |
	 * | Timezone (ISO-8601 w/o Z)       | x       | -08, +0530, +00                   |       |
	 * |                                 | xx      | -0800, +0530, +0000               |       |
	 * |                                 | xxx     | -08:00, +05:30, +00:00            | 2     |
	 * |                                 | xxxx    | -0800, +0530, +0000, +123456      |       |
	 * |                                 | xxxxx   | -08:00, +05:30, +00:00, +12:34:56 |       |
	 * | Timezone (GMT)                  | O...OOO | GMT-8, GMT+5:30, GMT+0            |       |
	 * |                                 | OOOO    | GMT-08:00, GMT+05:30, GMT+00:00   | 2     |
	 * | Timezone (specific non-locat.)  | z...zzz | GMT-8, GMT+5:30, GMT+0            | 6     |
	 * |                                 | zzzz    | GMT-08:00, GMT+05:30, GMT+00:00   | 2,6   |
	 * | Seconds timestamp               | t       | 512969520                         | 7     |
	 * |                                 | tt      | ...                               | 3,7   |
	 * | Milliseconds timestamp          | T       | 512969520900                      | 7     |
	 * |                                 | TT      | ...                               | 3,7   |
	 * | Long localized date             | P       | 05/29/1453                        | 7     |
	 * |                                 | PP      | May 29, 1453                      | 7     |
	 * |                                 | PPP     | May 29th, 1453                    | 7     |
	 * |                                 | PPPP    | Sunday, May 29th, 1453            | 2,7   |
	 * | Long localized time             | p       | 12:00 AM                          | 7     |
	 * |                                 | pp      | 12:00:00 AM                       | 7     |
	 * |                                 | ppp     | 12:00:00 AM GMT+2                 | 7     |
	 * |                                 | pppp    | 12:00:00 AM GMT+02:00             | 2,7   |
	 * | Combination of date and time    | Pp      | 05/29/1453, 12:00 AM              | 7     |
	 * |                                 | PPpp    | May 29, 1453, 12:00:00 AM         | 7     |
	 * |                                 | PPPppp  | May 29th, 1453 at ...             | 7     |
	 * |                                 | PPPPpppp| Sunday, May 29th, 1453 at ...     | 2,7   |
	 * Notes:
	 * 1. "Formatting" units (e.g. formatting quarter) in the default en-US locale
	 *    are the same as "stand-alone" units, but are different in some languages.
	 *    "Formatting" units are declined according to the rules of the language
	 *    in the context of a date. "Stand-alone" units are always nominative singular:
	 *
	 *    `format(new Date(2017, 10, 6), 'do LLLL', {locale: cs}) //=> '6. listopad'`
	 *
	 *    `format(new Date(2017, 10, 6), 'do MMMM', {locale: cs}) //=> '6. listopadu'`
	 *
	 * 2. Any sequence of the identical letters is a pattern, unless it is escaped by
	 *    the single quote characters (see below).
	 *    If the sequence is longer than listed in table (e.g. `EEEEEEEEEEE`)
	 *    the output will be the same as default pattern for this unit, usually
	 *    the longest one (in case of ISO weekdays, `EEEE`). Default patterns for units
	 *    are marked with "2" in the last column of the table.
	 *
	 *    `format(new Date(2017, 10, 6), 'MMM') //=> 'Nov'`
	 *
	 *    `format(new Date(2017, 10, 6), 'MMMM') //=> 'November'`
	 *
	 *    `format(new Date(2017, 10, 6), 'MMMMM') //=> 'N'`
	 *
	 *    `format(new Date(2017, 10, 6), 'MMMMMM') //=> 'November'`
	 *
	 *    `format(new Date(2017, 10, 6), 'MMMMMMM') //=> 'November'`
	 *
	 * 3. Some patterns could be unlimited length (such as `yyyyyyyy`).
	 *    The output will be padded with zeros to match the length of the pattern.
	 *
	 *    `format(new Date(2017, 10, 6), 'yyyyyyyy') //=> '00002017'`
	 *
	 * 4. `QQQQQ` and `qqqqq` could be not strictly numerical in some locales.
	 *    These tokens represent the shortest form of the quarter.
	 *
	 * 5. The main difference between `y` and `u` patterns are B.C. years:
	 *
	 *    | Year | `y` | `u` |
	 *    |------|-----|-----|
	 *    | AC 1 |   1 |   1 |
	 *    | BC 1 |   1 |   0 |
	 *    | BC 2 |   2 |  -1 |
	 *
	 *    Also `yy` always returns the last two digits of a year,
	 *    while `uu` pads single digit years to 2 characters and returns other years unchanged:
	 *
	 *    | Year | `yy` | `uu` |
	 *    |------|------|------|
	 *    | 1    |   01 |   01 |
	 *    | 14   |   14 |   14 |
	 *    | 376  |   76 |  376 |
	 *    | 1453 |   53 | 1453 |
	 *
	 *    The same difference is true for local and ISO week-numbering years (`Y` and `R`),
	 *    except local week-numbering years are dependent on `options.weekStartsOn`
	 *    and `options.firstWeekContainsDate` (compare [getISOWeekYear]{@link https://date-fns.org/docs/getISOWeekYear}
	 *    and [getWeekYear]{@link https://date-fns.org/docs/getWeekYear}).
	 *
	 * 6. Specific non-location timezones are currently unavailable in `date-fns`,
	 *    so right now these tokens fall back to GMT timezones.
	 *
	 * 7. These patterns are not in the Unicode Technical Standard #35:
	 *    - `i`: ISO day of week
	 *    - `I`: ISO week of year
	 *    - `R`: ISO week-numbering year
	 *    - `t`: seconds timestamp
	 *    - `T`: milliseconds timestamp
	 *    - `o`: ordinal number modifier
	 *    - `P`: long localized date
	 *    - `p`: long localized time
	 *
	 * 8. `YY` and `YYYY` tokens represent week-numbering years but they are often confused with years.
	 *    You should enable `options.useAdditionalWeekYearTokens` to use them. See: https://git.io/fxCyr
	 *
	 * 9. `D` and `DD` tokens represent days of the year but they are ofthen confused with days of the month.
	 *    You should enable `options.useAdditionalDayOfYearTokens` to use them. See: https://git.io/fxCyr
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * - The second argument is now required for the sake of explicitness.
	 *
	 *   ```javascript
	 *   // Before v2.0.0
	 *   format(new Date(2016, 0, 1))
	 *
	 *   // v2.0.0 onward
	 *   format(new Date(2016, 0, 1), "yyyy-MM-dd'T'HH:mm:ss.SSSxxx")
	 *   ```
	 *
	 * - New format string API for `format` function
	 *   which is based on [Unicode Technical Standard #35](https://www.unicode.org/reports/tr35/tr35-dates.html#Date_Field_Symbol_Table).
	 *   See [this post](https://blog.date-fns.org/post/unicode-tokens-in-date-fns-v2-sreatyki91jg) for more details.
	 *
	 * - Characters are now escaped using single quote symbols (`'`) instead of square brackets.
	 *
	 * @param {Date|Number} date - the original date
	 * @param {String} format - the string of tokens
	 * @param {Object} [options] - an object with options.
	 * @param {Locale} [options.locale=defaultLocale] - the locale object. See [Locale]{@link https://date-fns.org/docs/Locale}
	 * @param {0|1|2|3|4|5|6} [options.weekStartsOn=0] - the index of the first day of the week (0 - Sunday)
	 * @param {Number} [options.firstWeekContainsDate=1] - the day of January, which is
	 * @param {Boolean} [options.useAdditionalWeekYearTokens=false] - if true, allows usage of the week-numbering year tokens `YY` and `YYYY`;
	 *   see: https://git.io/fxCyr
	 * @param {Boolean} [options.useAdditionalDayOfYearTokens=false] - if true, allows usage of the day of year tokens `D` and `DD`;
	 *   see: https://git.io/fxCyr
	 * @returns {String} the formatted date string
	 * @throws {TypeError} 2 arguments required
	 * @throws {RangeError} `date` must not be Invalid Date
	 * @throws {RangeError} `options.locale` must contain `localize` property
	 * @throws {RangeError} `options.locale` must contain `formatLong` property
	 * @throws {RangeError} `options.weekStartsOn` must be between 0 and 6
	 * @throws {RangeError} `options.firstWeekContainsDate` must be between 1 and 7
	 * @throws {RangeError} use `yyyy` instead of `YYYY` for formatting years; see: https://git.io/fxCyr
	 * @throws {RangeError} use `yy` instead of `YY` for formatting years; see: https://git.io/fxCyr
	 * @throws {RangeError} use `d` instead of `D` for formatting days of the month; see: https://git.io/fxCyr
	 * @throws {RangeError} use `dd` instead of `DD` for formatting days of the month; see: https://git.io/fxCyr
	 * @throws {RangeError} format string contains an unescaped latin alphabet character
	 *
	 * @example
	 * // Represent 11 February 2014 in middle-endian format:
	 * var result = format(new Date(2014, 1, 11), 'MM/dd/yyyy')
	 * //=> '02/11/2014'
	 *
	 * @example
	 * // Represent 2 July 2014 in Esperanto:
	 * import { eoLocale } from 'date-fns/locale/eo'
	 * var result = format(new Date(2014, 6, 2), "do 'de' MMMM yyyy", {
	 *   locale: eoLocale
	 * })
	 * //=> '2-a de julio 2014'
	 *
	 * @example
	 * // Escape string by single quote characters:
	 * var result = format(new Date(2014, 6, 2, 15), "h 'o''clock'")
	 * //=> "3 o'clock"
	 */
	
	function format(dirtyDate, dirtyFormatStr, dirtyOptions) {
	  (0, _index10.default)(2, arguments);
	  var formatStr = String(dirtyFormatStr);
	  var options = dirtyOptions || {};
	  var locale = options.locale || _index2.default;
	  var localeFirstWeekContainsDate = locale.options && locale.options.firstWeekContainsDate;
	  var defaultFirstWeekContainsDate = localeFirstWeekContainsDate == null ? 1 : (0, _index9.default)(localeFirstWeekContainsDate);
	  var firstWeekContainsDate = options.firstWeekContainsDate == null ? defaultFirstWeekContainsDate : (0, _index9.default)(options.firstWeekContainsDate); // Test if weekStartsOn is between 1 and 7 _and_ is not NaN
	
	  if (!(firstWeekContainsDate >= 1 && firstWeekContainsDate <= 7)) {
	    throw new RangeError('firstWeekContainsDate must be between 1 and 7 inclusively');
	  }
	
	  var localeWeekStartsOn = locale.options && locale.options.weekStartsOn;
	  var defaultWeekStartsOn = localeWeekStartsOn == null ? 0 : (0, _index9.default)(localeWeekStartsOn);
	  var weekStartsOn = options.weekStartsOn == null ? defaultWeekStartsOn : (0, _index9.default)(options.weekStartsOn); // Test if weekStartsOn is between 0 and 6 _and_ is not NaN
	
	  if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) {
	    throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
	  }
	
	  if (!locale.localize) {
	    throw new RangeError('locale must contain localize property');
	  }
	
	  if (!locale.formatLong) {
	    throw new RangeError('locale must contain formatLong property');
	  }
	
	  var originalDate = (0, _index4.default)(dirtyDate);
	
	  if (!(0, _index.default)(originalDate)) {
	    throw new RangeError('Invalid time value');
	  } // Convert the date in system timezone to the same date in UTC+00:00 timezone.
	  // This ensures that when UTC functions will be implemented, locales will be compatible with them.
	  // See an issue about UTC functions: https://github.com/date-fns/date-fns/issues/376
	
	
	  var timezoneOffset = (0, _index7.default)(originalDate);
	  var utcDate = (0, _index3.default)(originalDate, timezoneOffset);
	  var formatterOptions = {
	    firstWeekContainsDate: firstWeekContainsDate,
	    weekStartsOn: weekStartsOn,
	    locale: locale,
	    _originalDate: originalDate
	  };
	  var result = formatStr.match(longFormattingTokensRegExp).map(function (substring) {
	    var firstCharacter = substring[0];
	
	    if (firstCharacter === 'p' || firstCharacter === 'P') {
	      var longFormatter = _index6.default[firstCharacter];
	      return longFormatter(substring, locale.formatLong, formatterOptions);
	    }
	
	    return substring;
	  }).join('').match(formattingTokensRegExp).map(function (substring) {
	    // Replace two single quote characters with one single quote character
	    if (substring === "''") {
	      return "'";
	    }
	
	    var firstCharacter = substring[0];
	
	    if (firstCharacter === "'") {
	      return cleanEscapedString(substring);
	    }
	
	    var formatter = _index5.default[firstCharacter];
	
	    if (formatter) {
	      if (!options.useAdditionalWeekYearTokens && (0, _index8.isProtectedWeekYearToken)(substring)) {
	        (0, _index8.throwProtectedError)(substring);
	      }
	
	      if (!options.useAdditionalDayOfYearTokens && (0, _index8.isProtectedDayOfYearToken)(substring)) {
	        (0, _index8.throwProtectedError)(substring);
	      }
	
	      return formatter(utcDate, substring, locale.localize, formatterOptions);
	    }
	
	    if (firstCharacter.match(unescapedLatinCharacterRegExp)) {
	      throw new RangeError('Format string contains an unescaped latin alphabet character `' + firstCharacter + '`');
	    }
	
	    return substring;
	  }).join('');
	  return result;
	}
	
	function cleanEscapedString(input) {
	  return input.match(escapedStringRegExp)[1].replace(doubleQuoteRegExp, "'");
	}
	
	module.exports = exports.default;

/***/ },
/* 34 */
/***/ function(module, exports, __webpack_require__) {

	// 7.1.13 ToObject(argument)
	var defined = __webpack_require__(62);
	module.exports = function (it) {
	  return Object(defined(it));
	};


/***/ },
/* 35 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.EFSCropPicker = exports.ServerMultiComplete = exports.MultiComplete = exports.UCCSearch = exports.FormationLocale = exports.Signatures = exports.UploadAndSubmit = exports.Summary = exports.NameSearch = exports.DataTable = exports.Repeater = exports.Paragraph = exports.ServerRadio = exports.ServerSelect = exports.RegisteredAgentSearch = exports.resolveAgentMailingAddress = exports.getRegisteredAgentValueObject = exports.DependentCheck = exports.LocalSelect = exports.DependentSelect = exports.DependentRadio = exports.SearchControl = exports.NameQualifiedOrg = exports.NameOrg = exports.FullName = exports.AddressBlock = exports.getAddressObject = exports.EntityNameSearch = exports.ConfirmFields = exports.UploadAccumulator = exports.UploadPlaceholder = exports.FileUpload = exports.Select = exports.Radio = exports.TimeInput = exports.DateRange = exports.DateInput = exports.Checkbox = exports.TextArea = exports.Field = exports.Confirm = exports.Section = exports.Step = undefined;
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	exports.CreateInstancesFromJson = CreateInstancesFromJson;
	
	var _shortid = __webpack_require__(22);
	
	var _shortid2 = _interopRequireDefault(_shortid);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _store = __webpack_require__(18);
	
	var _store2 = _interopRequireDefault(_store);
	
	var _deepEqual = __webpack_require__(65);
	
	var _deepEqual2 = _interopRequireDefault(_deepEqual);
	
	var _deepCopy = __webpack_require__(284);
	
	var _deepCopy2 = _interopRequireDefault(_deepCopy);
	
	var _WizardClasses = __webpack_require__(35);
	
	var WizardClasses = _interopRequireWildcard(_WizardClasses);
	
	var _selectOptions = __webpack_require__(68);
	
	var _UploadAccumulator = __webpack_require__(199);
	
	var _UCCSearch = __webpack_require__(477);
	
	var _Markdown = __webpack_require__(24);
	
	var _Markdown2 = _interopRequireDefault(_Markdown);
	
	var _utilities = __webpack_require__(8);
	
	var _businessRules = __webpack_require__(198);
	
	var _wizardUtilities = __webpack_require__(52);
	
	var _format = __webpack_require__(33);
	
	var _format2 = _interopRequireDefault(_format);
	
	var _isValid = __webpack_require__(43);
	
	var _isValid2 = _interopRequireDefault(_isValid);
	
	var _parseISO = __webpack_require__(280);
	
	var _parseISO2 = _interopRequireDefault(_parseISO);
	
	var _requests = __webpack_require__(6);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var Step = exports.Step = function Step() {
	  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	  _classCallCheck(this, Step);
	
	  this.classType = "Step";
	  this.stepId = props.stepId || _shortid2.default.generate();
	  this.templateId = props.templateId || "";
	  this.title = props.title || "New Step";
	  this.active = props.active || false;
	  this.includeInSummary = props.includeInSummary === false ? false : true;
	  this.isValid = props.valid || null;
	  this.help = props.help || "";
	  this.sectionOrder = props.sectionOrder || [];
	  this.hideStepOnForm = props.hideStepOnForm || false;
	};
	
	var Section = exports.Section = function Section() {
	  var section = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	  _classCallCheck(this, Section);
	
	  this.sectionId = section.sectionId || _shortid2.default.generate();
	  this.title = section.title === undefined ? "New Section" : section.title;
	  this.description = section.description || "";
	  this.type = section.type || "custom";
	  this.fields = section.fields || [];
	  this.stepId = section.stepId || null;
	  this.fieldOrder = section.fieldOrder || [];
	  this.hideSectionOnForm = section.hideSectionOnForm || false;
	  this.hideTitleOnForm = section.hideTitleOnForm || false;
	  this.showSubHeader = section.showSubHeader || false;
	  this.subHeaderLabel = section.subHeaderLabel || "";
	  this.allowPageBreak = section.allowPageBreak || false;
	};
	
	var Confirm = exports.Confirm = function (_Section) {
	  _inherits(Confirm, _Section);
	
	  function Confirm() {
	    var section = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	    _classCallCheck(this, Confirm);
	
	    var _this = _possibleConstructorReturn(this, (Confirm.__proto__ || Object.getPrototypeOf(Confirm)).call(this, section));
	
	    _this.type = section.type || "confirm";
	    return _this;
	  }
	
	  return Confirm;
	}(Section);
	
	var Field = exports.Field = function () {
	  function Field() {
	    var field = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	    _classCallCheck(this, Field);
	
	    this.fieldId = field.fieldId || _shortid2.default.generate();
	    this.name = field.name || "FIELD_NAME_" + _shortid2.default.generate().toUpperCase();
	    this.label = field.label ? field.label : field.label === '' ? '' : 'New Field';
	    this.shortLabel = field.shortLabel ? field.shortLabel : '';
	    this.description = field.description || "";
	    this.tooltip = field.tooltip || "";
	    this.type = field.type || "text";
	    this.fieldClass = "Field";
	    this.width = field.width || "60%";
	    this.includeInSummary = field.includeInSummary === false ? false : true;
	    this.placeholder = field.placeholder || "";
	    this.value = typeof field.value === "number" ? field.value.toString() : field.value || "";
	    this.validation = field.validation || { onChange: [], onBlur: [], onAdvance: [] };
	    this.errorMessage = field.errorMessage || "";
	    this.infoMessage = field.infoMessage || "";
	    this.allowInfoMessage = field.allowInfoMessage === false ? false : true;
	    this.mask = field.mask || [];
	    this.isValid = field.isValid || null;
	    this.required = field.required || false;
	    this.disabled = field.disabled || false;
	    this.disabledDuringCorrection = field.disabledDuringCorrection || false;
	    this.disabledDuringEdit = field.disabledDuringEdit || false;
	    this.active = field.active === false ? false : true;
	    this.selectedIndex = field.selectedIndex || 0;
	    this.inheritValueFrom = field.inheritValueFrom || null;
	    this.ownsLabel = field.ownsLabel === true ? true : false;
	    this.hideLabel = field.hideLabel === true ? true : false;
	    this.options = field.options || null;
	    if (this.type === "number") {
	      this.mask = field.mask || [{ fn: "onlyNumbers" }];
	      this.allowedRules = ["notEmptyOrNull", "numberGreaterThan", "numberLessThan"];
	    }
	    this.businessRules = field.businessRules || [];
	    this.allowedRules = ['notEmptyOrNull', 'validFeinNum', 'validPhoneNumber', 'validPhoneNumberIfPresent', 'numberGreaterThan', 'numberLessThan', 'validZipCode', 'validSocial', 'isValidEmailFormat', 'onlyNumbers', 'maxCharacters', 'minCharacters', 'checkForRegulatedWords', 'customBusinessRules'];
	    this.allowedMasks = ['phone', 'onlyNumbers', 'fein', 'currency', 'maxStringLength', 'zipCode', 'social'];
	    this.allowedRepeaterConstraints = this.type === 'text' ? ['mustBeLessThanOrEqualToColumn', 'xMayNotEqualY'] : [];
	    this.parent = field.parent || null;
	    this.defaultValue = field.defaultValue || '';
	    this.textAlignment = field.textAlignment || 'left';
	    this.alwaysIncludeInSummary = field.alwaysIncludeInSummary || false;
	    this.passwordMask = field.passwordMask || false;
	    this.hideFieldOnForm = field.hideFieldOnForm || false;
	    this.hideLabelOnForm = field.hideLabelOnForm || false;
	    this.formDisplayType = field.formDisplayType || 'default';
	    this.dynamic = field.dynamic || false;
	    this.excludeFromDiff = field.excludeFromDiff || false;
	    this.internalReviewRequiredIfChanged = field.internalReviewRequiredIfChanged || false;
	    this.conditions = field.conditions ? field.conditions.length > 0 ? field.conditions : null : null;
	    this.conditionsOperator = field.conditionsOperator || 'and';
	    this.logicNodes = field.logicNodes || {};
	    this.logicComments = field.logicComments || {};
	    this.redact = field.redact || false;
	    this.encrypt = field.encrypt || false;
	    this.prepopulationDisabled = field.prepopulationDisabled || false;
	    this.allowCorrectionPopulation = field.allowCorrectionPopulation || false;
	    this.repeaterConstraints = field.repeaterConstraints || [];
	    this.isStaticField = field.isStaticField || false;
	    this.frColumnWidth = field.frColumnWidth || 20;
	    this.frEnableWidth = field.frEnableWidth || false;
	    this.hideInRepeaterGrid = field.hideInRepeaterGrid || false;
	    this.breakFieldInside = field.breakFieldInside || false;
	    this.getGroupItemsOnLoad = field.getGroupItemsOnLoad || false;
	  }
	
	  _createClass(Field, [{
	    key: 'getConfirmFieldProps',
	    value: function getConfirmFieldProps() {
	      return [{ label: this.label, value: this.value }];
	    }
	  }, {
	    key: 'getKeyValuePairs',
	    value: function getKeyValuePairs(field) {
	      return [{ name: field.name, value: typeof field.value === 'string' ? field.type === "paragraph" ? field.value.replace(/\s*$/, "") : field.value.trim() : field.value }];
	    }
	  }, {
	    key: 'getCompareValue',
	    value: function getCompareValue() {
	      var field = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	      return field.value;
	    }
	  }, {
	    key: 'getHumanReadableValue',
	    value: function getHumanReadableValue(field, value) {
	      return value;
	    }
	  }], [{
	    key: 'compareValues',
	    value: function compareValues(originalValue, currentValue) {
	      return !(0, _deepEqual2.default)(originalValue, currentValue);
	    }
	  }]);
	
	  return Field;
	}();
	
	var TextArea = exports.TextArea = function (_Field) {
	  _inherits(TextArea, _Field);
	
	  function TextArea() {
	    var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	    _classCallCheck(this, TextArea);
	
	    var _this2 = _possibleConstructorReturn(this, (TextArea.__proto__ || Object.getPrototypeOf(TextArea)).call(this, props));
	
	    _this2.type = "textArea";
	    _this2.fieldClass = "TextArea";
	    _this2.rows = props.rows || 5;
	    return _this2;
	  }
	
	  return TextArea;
	}(Field);
	
	var Checkbox = exports.Checkbox = function (_Field2) {
	  _inherits(Checkbox, _Field2);
	
	  function Checkbox() {
	    var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	    _classCallCheck(this, Checkbox);
	
	    var _this3 = _possibleConstructorReturn(this, (Checkbox.__proto__ || Object.getPrototypeOf(Checkbox)).call(this, props));
	
	    _this3.value = props.value === 'Y' || props.value === true ? true : false;
	    _this3.type = "checkbox";
	    _this3.fieldClass = "Checkbox";
	    _this3.label = props.label || "New Checkbox";
	    _this3.ownsLabel = true;
	    _this3.hideLabel = true;
	    _this3.alwaysShowDescription = true;
	    _this3.allowedRules = ["mustBeTrue", 'customBusinessRules'];
	    _this3.allowedRepeaterConstraints = ["minNumberChecked", "minNumberUnchecked"];
	    return _this3;
	  }
	
	  _createClass(Checkbox, [{
	    key: 'getConfirmFieldProps',
	    value: function getConfirmFieldProps() {
	      return [{ label: this.label, value: this.value === true ? "Yes" : "No" }];
	    }
	  }, {
	    key: 'getHumanReadableValue',
	    value: function getHumanReadableValue(field, value) {
	      return value ? "Yes" : "No";
	    }
	  }]);
	
	  return Checkbox;
	}(Field);
	
	var DateInput = exports.DateInput = function (_Field3) {
	  _inherits(DateInput, _Field3);
	
	  function DateInput() {
	    var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	    _classCallCheck(this, DateInput);
	
	    var _this4 = _possibleConstructorReturn(this, (DateInput.__proto__ || Object.getPrototypeOf(DateInput)).call(this, props));
	
	    _this4.value = props.value || null;
	    _this4.type = props.type || 'date';
	    _this4.fieldClass = 'DateInput';
	    _this4.width = props.width || '30%';
	    _this4.allowedRules = ['notEmptyOrNull', 'enforceMaxDaysBeforeToday', 'enforceMaxDaysAfterToday', 'enforceMinDaysBeforeToday', 'enforceMinDaysAfterToday', 'enforceMaxMonthsBeforeToday', 'enforceMaxMonthsAfterToday', 'enforceMinMonthsBeforeToday', 'enforceMinMonthsAfterToday', 'minDate', 'maxDate', 'customBusinessRules'];
	    _this4.todayButton = props.todayButton === false ? false : true;
	    return _this4;
	  }
	
	  _createClass(DateInput, [{
	    key: 'getDateString',
	    value: function getDateString() {
	      return (0, _format2.default)(this.value, 'MM/dd/yyyy HH:mm:ss.sss');
	    }
	  }, {
	    key: 'getConfirmFieldProps',
	    value: function getConfirmFieldProps() {
	      return [{ label: this.label, value: (0, _format2.default)(this.value, 'MM/dd/yyyy') }];
	    }
	  }, {
	    key: 'getHumanReadableValue',
	    value: function getHumanReadableValue(field, value) {
	      return value ? (0, _format2.default)(new Date(value), 'MM/dd/yyyy') : value;
	    }
	  }, {
	    key: 'getKeyValuePairs',
	    value: function getKeyValuePairs(field) {
	      return [{
	        name: field.name,
	        value: field.value ? (0, _format2.default)(new Date(field.value), 'MM/dd/yyyy') : field.value
	      }];
	    }
	  }]);
	
	  return DateInput;
	}(Field);
	
	var DateRange = exports.DateRange = function (_DateInput) {
	  _inherits(DateRange, _DateInput);
	
	  function DateRange() {
	    var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	    _classCallCheck(this, DateRange);
	
	    var _this5 = _possibleConstructorReturn(this, (DateRange.__proto__ || Object.getPrototypeOf(DateRange)).call(this, props));
	
	    _this5.type = 'DateRange';
	    _this5.fieldClass = 'DateRange';
	    _this5.value = props.value ? { start: props.value.start, end: props.value.end } : { start: null, end: null };
	    _this5.allowedRules = ['dateRangeRequired', 'minDateRange', 'maxDateRange', 'customBusinessRules'];
	    _this5.label = props.label || 'Date Range';
	    _this5.startLabel = props.startLabel || 'Start date';
	    _this5.endLabel = props.endLabel || 'End date';
	    _this5.hideLabel = true;
	    _this5.ownsLabel = true;
	    _this5.todayButton = props.todayButton === false ? false : true;
	    return _this5;
	  }
	
	  _createClass(DateRange, [{
	    key: 'getHumanReadableValue',
	    value: function getHumanReadableValue(field, value) {
	      return (value.start ? (0, _format2.default)(new Date(value.start), "M/d/yyyy") : "None") + ' - ' + (value.end ? (0, _format2.default)(new Date(value.end), "M/d/yyyy") : "None");
	    }
	  }, {
	    key: 'getKeyValuePairs',
	    value: function getKeyValuePairs(field) {
	      return [{ name: field.name, value: {
	          start: field.value.start ? (0, _format2.default)(new Date(field.value.start), 'MM/dd/yyyy') : field.value.end,
	          end: field.value.end ? (0, _format2.default)(new Date(field.value.end), 'MM/dd/yyyy') : field.value.end
	        } }];
	    }
	  }]);
	
	  return DateRange;
	}(DateInput);
	
	var TimeInput = exports.TimeInput = function (_Field4) {
	  _inherits(TimeInput, _Field4);
	
	  function TimeInput() {
	    var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	    _classCallCheck(this, TimeInput);
	
	    var _this6 = _possibleConstructorReturn(this, (TimeInput.__proto__ || Object.getPrototypeOf(TimeInput)).call(this, props));
	
	    _this6.type = 'TimeInput';
	    _this6.fieldClass = 'TimeInput';
	    _this6.value = props.value && props.value.length >= 7 ? props.value : (props.defaultTime || '') + ' ' + (props.defaultPeriod || 'am');
	    _this6.label = props.label || 'Time';
	    _this6.allowedRules = ['timeRequired', 'customBusinessRules'];
	    _this6.allowedMasks = [];
	    _this6.mask = [];
	    _this6.defaultTime = props.defaultTime || null;
	    _this6.defaultPeriod = props.defaultPeriod || null;
	    return _this6;
	  }
	
	  return TimeInput;
	}(Field);
	
	var Radio = exports.Radio = function (_Field5) {
	  _inherits(Radio, _Field5);
	
	  function Radio() {
	    var radio = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	    _classCallCheck(this, Radio);
	
	    var _this7 = _possibleConstructorReturn(this, (Radio.__proto__ || Object.getPrototypeOf(Radio)).call(this, radio));
	
	    _this7.type = "radio";
	    _this7.fieldClass = "Radio";
	    _this7.options = radio.options || [{ value: "option1", label: "Option 1" }];
	    _this7.value = _this7.options.find(function (option) {
	      return option.value === _this7.value;
	    }) && radio.value !== undefined ? radio.value : "default";
	    _this7.allowedRules = ["mustBeSelected", 'customBusinessRules'];
	    _this7.allowedRepeaterConstraints = ["maxNumberOfSelectedOption", "minNumberOfSelectedOption", "xMayNotEqualY"];
	    return _this7;
	  }
	
	  _createClass(Radio, [{
	    key: 'getConfirmFieldProps',
	    value: function getConfirmFieldProps() {
	      return [{ label: this.label, value: this.options[this.selectedIndex ? this.selectedIndex : 0].label }];
	    }
	  }, {
	    key: 'getHumanReadableValue',
	    value: function getHumanReadableValue(field, value) {
	      var selectedOption = field.options.find(function (option) {
	        return option.value === value;
	      });
	      return selectedOption ? selectedOption.label : "";
	    }
	  }, {
	    key: 'getKeyValuePairs',
	    value: function getKeyValuePairs(field) {
	      var value = field.value;
	      if (value === 'default' || !field.options.find(function (opt) {
	        return opt.value === value;
	      })) {
	        value = '';
	      }
	      return [{ name: field.name, value: value }];
	    }
	  }]);
	
	  return Radio;
	}(Field);
	
	var Select = exports.Select = function (_Radio) {
	  _inherits(Select, _Radio);
	
	  function Select() {
	    var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	    _classCallCheck(this, Select);
	
	    var _this8 = _possibleConstructorReturn(this, (Select.__proto__ || Object.getPrototypeOf(Select)).call(this, props));
	
	    _this8.type = "select";
	    _this8.fieldClass = "Select";
	    _this8.value = props.value || (_this8.options.find(function (option) {
	      return option.value === _this8.value;
	    }) && props.value ? props.value : "default");
	    _this8.options = props.options || [{ value: "default", label: "[Select An Option]" }, { value: "option1", label: "Option 1" }];
	    _this8.allowedRules = ["mustBeSelected", 'customBusinessRules'];
	    _this8.optionGroups = props.optionGroups || null;
	    return _this8;
	  }
	
	  _createClass(Select, [{
	    key: 'getConfirmFieldProps',
	    value: function getConfirmFieldProps() {
	      return [{ label: this.label, value: this.options[this.selectedIndex ? this.selectedIndex : 0].label }];
	    }
	  }, {
	    key: 'getHumanReadableValue',
	    value: function getHumanReadableValue(field, value) {
	      var selectedOption = field.options.find(function (option) {
	        return option.value === value;
	      });
	      return selectedOption ? selectedOption.label : "";
	    }
	  }]);
	
	  return Select;
	}(Radio);
	
	var FileUpload = exports.FileUpload = function (_Field6) {
	  _inherits(FileUpload, _Field6);
	
	  function FileUpload() {
	    var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	    _classCallCheck(this, FileUpload);
	
	    var _this9 = _possibleConstructorReturn(this, (FileUpload.__proto__ || Object.getPrototypeOf(FileUpload)).call(this, props));
	
	    _this9.resolveBusinessRules = function (rules) {
	      return rules.map(function (rule) {
	        return Object.assign({}, rule, {
	          fn: rule.fn === 'uploadRequired' ? 'uploadImmediatelyRequired' : rule.fn
	        });
	      });
	    };
	
	    _this9.type = 'file';
	    _this9.fieldClass = 'FileUpload';
	    _this9.value = props.value || [];
	    _this9.metadata = props.metadata || {};
	    _this9.accept = props.accept !== undefined ? props.accept : '.pdf';
	    _this9.requireInternalReview = props.requireInternalReview || false;
	    _this9.sortOrder = props.sortOrder || 0;
	    _this9.imageTypeId = props.imageTypeId || '';
	    _this9.multiple = props.multiple || false;
	    _this9.allowedRules = ['uploadImmediatelyRequired', 'customBusinessRules'];
	    _this9.businessRules = _this9.resolveBusinessRules(props.businessRules || []);
	    return _this9;
	  }
	
	  _createClass(FileUpload, [{
	    key: 'getHumanReadableValue',
	    value: function getHumanReadableValue(field, value) {
	      return _react2.default.createElement(
	        'span',
	        null,
	        value.filter(function (x) {
	          return x.status === 'success';
	        }).map(function (file, i) {
	          return _react2.default.createElement(
	            _react2.default.Fragment,
	            { key: i },
	            _react2.default.createElement(
	              'span',
	              { key: file.queueId },
	              ({"NODE_ENV":"production","BUILD_DATE":"2025-08-27T15:15:31.687Z","BUILD_NUMBER":"Not Provided","GIT_VERSION":"v1.3.0-381-ga81e29b08","GIT_COMMIT_HASH":"a81e29b085c9268ffd96c78eb734365802722741","GIT_BRANCH":"beta","PUBLIC_URL":"","STATE_ABBR":"MT","STATE_NAME":"Montana","STATE_ORG_TITLE":"Secretary of State","LOGIN_HEADER_IMG_PATH":"","HOME_IMG_FILENAME":"montana.jpg","FAVICON_FILE_NAME":"favicon.ico","ALLOW_E_SIGN_ON_CORRECTIONS":true,"THIRD_PARTY_SIGNING_ALLOWED":false,"MY_ACCOUNT_SAVE_AND_CLOSE_BUTTON":true,"IE_DEPRECATED_MESSAGE":"Internet Explorer is not supported. Please select a supported browser below to access this website.","ADDITIONAL_ROUTES":{"dataRequests":true,"farmBill":true,"apostille":true,"externalHelp":"https://sosmt.gov/business/help-center/","systemAdministration":[{"title":"Saved Payments","parameter":"saved-payments","componentName":"SavedPayments"}]},"SUBROUTES":[{"label":"Business","component":"Business","parameter":"business","myWorkQueueSearch":false,"sourceTypeId":54,"searchMustHaveOneOf":["FILING_TYPE_ID","STATUS_ID","STATE","search"],"serverWebSearchDescription":true,"serverWorkQueueDescription":true,"serverMyRecordsDescription":true,"searchPlaceholder":"Search by name or filing number (X########)","allowEmptySearchTerm":true,"requestCertificateAlternateLabel":"Request Information","fileAmendmentButtonLabel":"Filing Actions","advancedSearchParameters":[{"type":"radio","name":"QUERY_TYPE_ID","defaultValue":1010,"options":[{"value":1010,"label":"Starts with"},{"value":1011,"label":"Contains"},{"value":1012,"label":" Word Contains"}]},{"type":"serverSelect","name":"FILING_TYPE_ID","optionsSrc":"FILING_TYPES","label":"Entity Type","placeholder":"All","defaultValue":"0"},{"type":"serverSelect","name":"FILING_SUBTYPE_ID","optionsSrc":"FILING_SUBTYPES","label":"Entity Subtype","overrideSubOptionsSrcFromParameterName":"FILING_TYPE_ID","placeholder":"All","defaultValue":"0"},{"type":"serverSelect","name":"STATUS_ID","optionsSrc":"FILING_STATUS_WITHOUT_ALL","label":"Status","placeholder":"All","defaultValue":"0"},{"type":"serverSelect","name":"STATE","optionsSrc":"STATE","label":"State","placeholder":"All","defaultValue":""},{"type":"serverSelect","name":"COUNTY","optionsSrc":"COUNTY_SUBOPTION","label":"County","overrideSubOptionsSrcFromParameterName":"STATE","placeholder":"All","defaultValue":""},{"type":"checkbox","name":"CRA_SEARCH_YN","defaultValue":false,"label":"Search by Registered Agent PID"},{"type":"dateRange","name":"FILING_DATE","label":"Registration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}},{"type":"dateRange","name":"EXPIRATION_DATE","label":"Expiration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}}],"myRecordsFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Active"},{"value":2,"label":"Inactive"},{"value":3,"label":"Pending"}]},{"type":"dateRange","name":"DATE_RANGE","label":"Date range","defaultValue":{"start":null,"end":null}}],"myWorkQueueFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Approved"},{"value":2,"label":"Pending Online Payment"},{"value":3,"label":"Pending Review"},{"value":4,"label":"Needs Correction"},{"value":5,"label":"Rejected"},{"value":6,"label":"Draft"}]},{"type":"dateRange","name":"DATE_RANGE","label":"Date range","defaultValue":{"start":null,"end":null}}]},{"label":"Notary","component":"Notary","parameter":"notary","sourceTypeId":850,"myWorkQueueSearch":false,"allowEmptySearchTerm":true,"requestCertificateAlternateLabel":"Download Certificate","fileAmendmentButtonLabel":"Filing Actions","hideNameRequestCertificate":true,"hideAddressRequestCertificate":true,"hideRecordUserManagment":true,"searchPlaceholder":"Search by name or commission number","searchMustHaveOneOf":["CITY","search","SERVICE_TYPE"],"advancedParametersStartOpen":true,"searchIsSortable":true,"advancedSearchParameters":[{"type":"radio","name":"STARTS_WITH_YN","defaultValue":false,"options":[{"value":true,"label":"Starts with"},{"value":false,"label":"Contains"}]},{"type":"checkbox","name":"ACTIVE_ONLY_YN","defaultValue":true,"label":"Active entities only"},{"type":"text","name":"CITY","defaultValue":"","label":"City"},{"type":"select","name":"SERVICE_TYPE","label":"Special Services Offered","defaultValue":0,"options":[{"value":0,"label":"(N/A)"},{"value":6165,"label":"In-Person Electronic Notarization (IPEN)"},{"value":6166,"label":"Remote Online Notarization (RON)"},{"value":6167,"label":"Mobile Notary Services"},{"value":6168,"label":"Remote Ink Notarization (RIN)"}]}]},{"label":"Apostille","component":"Apostille","parameter":"apostille","sourceTypeId":720,"myRecordsSearch":false,"myWorkQueueSearch":false,"disabled":false,"allowedRoutes":["/forms-manager/","/queue/","/forms/"]},{"label":"Liens","component":"UCC","parameter":"ucc","sourceTypeId":1999,"myRecordsSearch":true,"myWorkQueueSearch":true,"fileAmendmentButtonLabel":"Filing Actions","searchPlaceholder":"Search by name or file number","disabled":false,"serverWebSearchDescription":true,"myRecordsDescription":"","workQueueDescription":"","searchDescription":"","hideRecordUserManagment":true,"searchLiensCheckout":false,"advancedSearchParameters":[{"type":"radio","name":"STARTS_WITH_YN","defaultValue":false,"options":[{"value":true,"label":"Starts with"},{"value":false,"label":"Contains"}]},{"type":"select","name":"STATUS","defaultValue":"ALL","label":"Status","options":[{"value":"ACTIVE_UNLAPSED","label":"Active (unlapsed)"},{"value":"ACTIVE_LAPSED_UNLAPSED","label":"Active (lapsed and unlapsed)"}]},{"type":"text","name":"EXCLUDE_VALUES","label":"Exclude Debtor Names (comma separated list of names to exclude)","defaultValue":""},{"type":"dateRange","name":"FILING_DATE","label":"Financing Statement Date","defaultValue":{"start":null,"end":null}},{"type":"dateRange","name":"LAPSE_DATE","label":"Lapse Date","defaultValue":{"start":null,"end":null}},{"type":"text","name":"CITY","label":"Debtor City","defaultValue":""}],"myRecordsFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Approved"},{"value":2,"label":"Pending Online Payment"},{"value":3,"label":"Pending Review"}]},{"type":"select","name":"TYPE","defaultValue":0,"label":"Lien Type","options":[{"value":0,"label":"All"},{"value":1,"label":"UCC"},{"value":2,"label":"EFS"},{"value":3,"label":"Title 71"}]}],"myWorkQueueFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Approved"},{"value":2,"label":"Pending Online Payment"},{"value":3,"label":"Pending Review"},{"value":4,"label":"Pending Print and Mail"},{"value":5,"label":"Rejected"},{"value":6,"label":"Draft"}]},{"type":"select","name":"TYPE","defaultValue":0,"label":"Lien Type","options":[{"value":0,"label":"All"},{"value":1,"label":"UCC"},{"value":2,"label":"EFS"},{"value":3,"label":"Title 71"}]}]},{"label":"Copy Request","component":"copies","parameter":"copies","sourceTypeId":2001,"myRecordsSearch":false,"myWorkQueueSearch":false,"disabled":false,"allowedRoutes":["/forms-manager/","/queue/","/forms/"]},{"label":"Trademark","component":"Trademark","parameter":"trademark","sourceTypeId":810,"showRequestCertificate":true,"searchMustHaveOneOf":["search","EXPIRATION_DATE","FILING_DATE"],"allowEmptySearchTerm":true,"requestCertificateAlternateLabel":"Request Information","fileAmendmentButtonLabel":"Filing Actions","advancedSearchParameters":[{"type":"radio","name":"QUERY_TYPE_ID","defaultValue":1010,"options":[{"value":1010,"label":"Starts with"},{"value":1011,"label":"Contains"},{"value":1012,"label":" Word Contains"}]},{"type":"checkbox","name":"OWNER_SEARCH_YN","defaultValue":false,"label":"Search owners"},{"type":"radio","name":"SERVICE_MARK_YN","label":"Mark Type","defaultValue":"","options":[{"value":"","label":"All Marks"},{"value":"Y","label":"Service Mark"},{"value":"N","label":"Trademark"}]},{"type":"serverSelect","name":"STATUS_ID","optionsSrc":"TYPE_V|TRADEMARK_STATUS_TYPE","label":"Status","placeholder":"All","defaultValue":"0"},{"type":"select","name":"DESIGN_TYPE_ID","options":[{"value":0,"label":"All"},{"value":990,"label":"Words Only"},{"value":991,"label":"Design Only"},{"value":992,"label":"Words and Design"}],"label":"Design Type","defaultValue":"0"},{"type":"dateRange","name":"FILING_DATE","label":"Registered Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}},{"type":"dateRange","name":"EXPIRATION_DATE","label":"Expiration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}}]},{"label":"Business Info Request","component":"InfoRequests","parameter":"info-request","sourceTypeId":167,"allowedRoutes":["/forms-manager/","/queue/","/forms/"]},{"label":"Data Requests","component":"DataRequests","parameter":"data-request","sourceTypeId":0,"allowedRoutes":["/forms-manager/"]},{"label":"CRA","component":"CRA","parameter":"cra","sourceTypeId":157,"myRecordsSearch":false,"searchPlaceholder":"Search by name or registered agent number","allowedRoutes":["/forms-manager/","/forms/","/records/","/queue/","/search/"],"allowEmptySearchTerm":true,"fileAmendmentButtonLabel":"Filing Actions","advancedSearchParameters":[{"type":"radio","name":"QUERY_TYPE_ID","defaultValue":1010,"options":[{"value":1010,"label":"Starts with"},{"value":1011,"label":"Contains"},{"value":1012,"label":" Word Contains"}]},{"type":"dateRange","name":"CRA_DATE","label":"Registration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}},{"type":"select","name":"STATUS_ID","label":"Status","defaultValue":0,"options":[{"value":0,"label":"All"},{"value":121,"label":"Active"},{"value":122,"label":"Inactive"}]},{"type":"select","name":"AGENT_TYPE_ID","label":"Agent Type","defaultValue":0,"options":[{"value":0,"label":"All"},{"value":460,"label":"Registered Agent"},{"value":461,"label":"Commercial Registered Agent"}]}]},{"label":"Farm Bill","component":"FarmBill","parameter":"farm-bill","path":"/lists/farm-bill","sourceTypeId":0,"myRecordsSearch":false,"allowedRules":["/search/"],"disabled":true,"searchDescription":"To perform a search, enter a debtor name. Your search results may include: exact debtor name, variations of that name and any filing that includes your search criteria. Punctuation is ignored.\n\nYou can click on \"Advanced\" to refine your search. Under “Advanced” you can search by crop, year, county and SSN/FEIN. As a registered Farm Bill Buyer with the Montana Secretary of State’s office it is important to maintain the confidentiality of the information contained within the Farm Bill Master List. The Farm Bill Master List reflects personal data, such as Social Security Numbers, which are a key piece of personal identifiable information to assist you in determining the existence of a lien against a specific debtor. The distribution of this information beyond its intended purpose is strictly prohibited.\n\nThe debtor's tax identification number has been hidden for confidentiality reasons. You may continue to search on a tax ID number and return debtors that match your search criteria. The SSN/FEIN must be entered without dashes or spaces.","searchMustHaveOneOf":["search","UCC_FARM_PRODUCT_ID","COUNTY"],"searchPlaceholder":"Search by debtor name","advancedSearchParameters":[{"type":"ServerMultiComplete","label":"Product code name(s)","name":"UCC_FARM_PRODUCT_ID","defaultValue":"","optionsSrc":"UCC_FARM_PRODUCT_V"},{"type":"MultiComplete","label":"Year or Range of Years","name":"YEAR_NUM","optionsSrc":"years","startYear":"1968","defaultValue":[],"preMergeOptions":[{"value":"ALL","label":"All"}]},{"type":"serverSelect","label":"State","name":"STATE","defaultValue":"MONTANA","optionsSrc":"STATE"},{"type":"ServerMultiComplete","label":"County","name":"COUNTY","defaultValue":[],"optionsSrc":"COUNTY","overrideSubOptionsSrcFromParameterName":"STATE"},{"type":"checkbox","name":"TIN_SEARCH_YN","defaultValue":false,"label":"Tax Identification Number Search"},{"type":"checkbox","name":"TIN_SORT_YN","defaultValue":false,"label":"Unique ID Sort"}]}],"SYSTEM_NICKNAME":"Online Services Portal","PAYMENT_METHODS":[{"type":"bypass"},{"type":"iTransact"}],"PAYMENT_ALLOW_AMEX":true,"SYSTEM_ID_LABEL":"System Id","DOUBLE_COLUMN_PUBLIC_LOGIN":true,"INTERNAL_USER_MANAGEMENT":true,"ALLOW_PUBLIC_JSON_IMPORT":false,"MAX_FILE_UPLOAD_SIZE":10000000,"REFUND_TEXT":"","RETURN_TO_HOME_ON_LOGOUT":true,"CURRENT_SOS_NAME":"Christi Jacobsen","LOGO_FILENAME":"mt-sos-logo.png","LOGO_ALT":"Christi Jacobsen, Montana Secretary of State","LOGO_FULL_WIDTH":true,"HOME_HIDE_AUTH_HINT":true,"HOME_TITLE":"Montana Secretary of State","CUSTOM_TAB_TITLE":"Official Montana","HOME_SUBTITLE":"Online Business Services","ENTITY_NAME_CONSENT_DESCRIPTION":"","ALLOW_USER_PROFILE_EDITING":true,"COMPARE_FOREIGN_NAME_IN_ENTITY_NAME_VALIDATION":true,"FOREIGN_NAME_FIELD_NAME":"KIMA_PARENT_NAME_INFO","LOGIN_TITLE":"Montana Secretary of State Online Filing Portal Login","PUBLIC_LOGIN_LABEL":"Username","REVERSE_LOGIN_COLUMNS":true,"LOGIN_SEAL_FILENAME":"seal_white.png","SEPARATE_USERNAME_AND_EMAIL":true,"CREATE_ACCOUNT_BUTTON_ALIGN_LEFT":true,"CREATE_ACCOUNT_BUTTON_TEXT":"CREATE AN ACCOUNT","PASSWORD_CUSTOM_ERROR_TEXT":"The password must meet all requirements","ACCOUNT_CREATED_MESSAGE":"Please check your email to verify your account to login and allow a few minutes for this message to arrive. Check your junk/spam folders if you do not find the email in your inbox.","PUBLIC_LOGIN_PLACEHOLDER":" ","DISABLE_DEFAULT_PAYMENT_RADIO":true,"CUSTOM_RESET_PASSWORD_ERROR_MESSAGE":"Username invalid - no account found","PUBLIC_LOGIN_CREATE_DESCRIPTION":"### Existing User:\n\n  - Enter your username and password to login.  \n\n\n  #### - OR -  \n\n\n\n  - Forgot password? Click 'Reset Password' and follow the prompts.\n  - Forgot username? Click 'Forgot Username' and follow the prompts.  \n\n\n  ### New User:\n  ","LOGIN_HELP_LINK":"https://sosmt.gov/business/how-do-i/","LOGIN_HELP_LINK_TEXT":"Need Help?","FORGOT_USERNAME_TEXT":"Forgot Username?","LOGIN_ACTIVE_DIRECTORY_TEXT":"State User Login","MULTIPLE_LOGIN_METHODS":true,"HAS_ACTIVE_DIRECTORY_LOGIN":true,"RESET_PASSWORD_WITH_USERNAME":true,"DOWNLOAD_LINK":true,"SHOW_USERNAME_ACCOUNT_CREATE":true,"SHOW_SCROLL_DOWN_ARROW":true,"SHOW_ADDRESS_ACCOUNT_CREATE":true,"TWO_COLUMN_ACCOUNT_CREATE":true,"RESET_PASSWORD_TIP":"A link to change your password has been sent to your email. Please allow a few minutes for this message to arrive. Please check your junk/spam folders if you do not find the email in your inbox.","FORGOT_PASSWORD_LINK_TEXT":"Reset Password","PHONE_NUMBER_OPTIONAL_ACCOUNT_CREATE":true,"SHOW_REQUIRED_INDICATOR_ACCOUNT_CREATE":true,"PASSWORD_REQUIREMENTS_ACCOUNT_CREATE":"\n    <ul>\n      <li>MUST contain at least 8 characters (12+ recommended)</li>\n      <li>MUST contain at least one uppercase letter.</li>\n      <li>MUST contain at least one lowercase letter.</li>\n      <li>MUST contain at least one number.</li>\n      <li>MUST contain at least one special character (!”#$%&'()*+,-./:;<=>?</li>\n    </ul>\n  ","ALLOW_CERTIFICATION_REQUEST":true,"ALLOW_PUBLIC_CERTIFICATE_REQUEST":true,"ALLOW_COPY_REQUEST":false,"ALLOW_CORRECTION_STYLING":true,"HIDE_DEPRECATION_WARNING":false,"AMEND_ROUTE_PUBLIC":true,"SEAL_FILENAME":"seal.png","SHOPPING_CART":true,"ALLOW_PAYMENT_UPDATE_WITH_EMPTY_CART":true,"RA_EMAIL":true,"RA_WEBSITE":true,"RA_NO_DEFAULT_TYPE":true,"RA_ADDRESS_LABEL":"Street Address","RA_TYPE_SELECTION_DEFAULT":true,"RA_DEFAULT_TYPE":"460","RA_OVERRIDE_TYPE_WITH_DEFAULT":true,"RA_PRINCIPAL_ADDRESS_AMS":true,"UPLOAD_AND_SUBMIT_HIDE_IF_ONE_OPTION":true,"PAYMENT_PROCESSING_MESSAGE":"Your payment is processing - Do not close your browser or click the back button","CHECKOUT_BUTTON_WHEN_PROCESSING_TEXT":"Processing","EFS_CROP_PICKER_NONE_LABEL":"Lien Duration","DISALLOWED_WIZARD_PIECES":["FormationLocale"],"REPEATER_SHOW_EDIT_BUTTON":true,"DATA_REQUEST_PAGE_TITLE":"Data Requests and Subscriptions","DATA_REQUEST_SIDEBAR_LABEL":"Data Requests & Subscriptions","LOGIN_REDIRECTS_TO_EPASS":false,"LOGIN_REDIRECTS_TO_ACTIVE_DIRECTORY":true,"LOGIN_ACTIVE_DIRECTORY_LINK":true,"FETCH_EDIT_USER_LINK":false,"LISTS_FETCH_AVAILABLE_LISTS":true,"POST_WIZARD_SUBMIT_REDIRECT_URL":"/","PIN_REQUEST_ATTESTATIONS":true,"PIN_REQUEST_DESCRIPTION":"Click **Request PIN** to have a new PIN sent to the account holder's email address on file.","OWNERSHIP_REQUEST_DESCRIPTION":"To become an **authorized user** of this record, a current **AUTHORIZED USER** will need to grant you access. To request access, click **Request Access** below.","PIN_REQUEST_SUCCESS_MESSAGE":"The PIN you have requested for this entity has been sent to the email associated with your user account.  You should receive the PIN in approximately 3-5 minutes, depending on your email service provider.","APOSTILLE_HEADER_LABEL":"Verification Information","APOSTILLE_NUMBER_LABEL":"Apostille/Authentication","APOSTILLE_CITY_STATE_OVERRIDE":"HELENA, MT","APOSTILLE_FILING_DATE_LABEL":"Issue Date","APOSTILLE_CITY_STATE_IN_CERTIFIED":true,"NOTARY_EXISTING_FILING":true,"ALLOW_REVOKE_OWN_ACCESS_ONLY":false,"HIDE_CANCEL_ON_ONETIME_DATA_REQUESTS":true,"DATA_REQUESTS_IN_SHOPPING_CART":true,"WQ_ALLOW_EDIT_PENDING_PAYMENT":true,"WQ_CONFIRM_ON_DELETE":true,"WQ_DELETE_CONFIRM_MESSAGE":"Deleting this filing will forfeit any money already paid to the Secretary of State. This action is permanent and cannot be undone, are you sure you would like to delete?","PASS_ITEM_GUIDS_ON_CHECKOUT":true,"FORM_REVISION_HISTORY":true,"CHECKOUT_DISCLAIMER":"By entering your credit card and/or checking account information you (i) state that **you are an authorized user** of the credit card and/or electronic check and that the associated information entered (e.g., account holder name, account number, billing address) is accurate, (ii) **you authorize payment processor to charge the amount you have requested** to your credit card and/or funding account, and (iii) **acknowledge if a charge is declined or reversed you may also be assessed a customary charge** by the payment processor for such transactions.","FARM_BILL_SEARCH_CONFIDENTIAL":"As a registered Farm Bill Buyer with the Montana Secretary of State’s office it is important to maintain the confidentiality of the information contained within the Farm Bill Master List. The Farm Bill Master List reflects personal data, such as Social Security Numbers, which are a key piece of personal identifiable information to assist you in determining the existence of a lien against a specific debtor. The distribution of this information beyond its intended purpose is strictly prohibited.\n\n**The debtor's tax identification number has been hidden for confidentiality reasons. You may continue to search on a tax ID number and return debtors that match your search criteria. The SSN/FEIN must be entered without dashes or spaces.  If you need access to the tax identification number to clearly identify the debtor, please contact the UCC unit at (406) 444-3665.**","VIEW_HISTORY_BUTTON_ALT_TEXT":"View Filings","WIZARD_ERROR_TITLE_MESSAGE":"Form Error","FARM_BILL_SEARCH_INTERACTIVE":true,"USE_FARM_BILL_API":true,"DISALLOW_ASSIGN_SELF_AS_RA":true,"DISALLOW_ASSIGN_SELF_AS_PRINCIPAL":true,"USE_TRADEMARK_OWNER_VALIDATION":true,"USE_ALTERNATIVE_FOREIGN_ADDRESS_LABELS":true,"MY_RECEIPTS_FILTER":[{"type":"dateRange","name":"DATE_RANGE","label":"Date range","defaultValue":{"start":null,"end":null}},{"type":"text","name":"REF_NUM","defaultValue":"","label":"Reference Number"},{"type":"text","name":"RECEIPT_NUM","defaultValue":"","label":"Receipt Id"},{"type":"text","name":"AMOUNT","defaultValue":"","label":"Amount"},{"type":"select","name":"TYPE","defaultValue":"","label":"Payment Type","options":[{"value":"","label":"All"},{"value":"CC","label":"Credit Card"},{"value":"Check","label":"Check"}]}],"MY_RECEIPTS_SHOW_IN_SIDEBAR":true,"SHOW_MY_RECEIPTS_HELPER_TEXT":true,"MY_RECEIPTS_HELPER_LABEL":"About Receipt Search","MY_RECEIPTS_HELPER_TEXT":"You can search for receipts based on their descriptions, including the items paid for on the receipt. Use the filters to search for or filter specific information.","FARM_BILL_SUBLINK":{"label":"Farm Bill","component":"FarmBill","parameter":"farm-bill","path":"/lists/farm-bill","sourceTypeId":0,"myRecordsSearch":false,"allowedRules":["/search/"],"disabled":true,"searchDescription":"To perform a search, enter a debtor name. Your search results may include: exact debtor name, variations of that name and any filing that includes your search criteria. Punctuation is ignored.\n\nYou can click on \"Advanced\" to refine your search. Under “Advanced” you can search by crop, year, county and SSN/FEIN. As a registered Farm Bill Buyer with the Montana Secretary of State’s office it is important to maintain the confidentiality of the information contained within the Farm Bill Master List. The Farm Bill Master List reflects personal data, such as Social Security Numbers, which are a key piece of personal identifiable information to assist you in determining the existence of a lien against a specific debtor. The distribution of this information beyond its intended purpose is strictly prohibited.\n\nThe debtor's tax identification number has been hidden for confidentiality reasons. You may continue to search on a tax ID number and return debtors that match your search criteria. The SSN/FEIN must be entered without dashes or spaces.","searchMustHaveOneOf":["search","UCC_FARM_PRODUCT_ID","COUNTY"],"searchPlaceholder":"Search by debtor name","advancedSearchParameters":[{"type":"ServerMultiComplete","label":"Product code name(s)","name":"UCC_FARM_PRODUCT_ID","defaultValue":"","optionsSrc":"UCC_FARM_PRODUCT_V"},{"type":"MultiComplete","label":"Year or Range of Years","name":"YEAR_NUM","optionsSrc":"years","startYear":"1968","defaultValue":[],"preMergeOptions":[{"value":"ALL","label":"All"}]},{"type":"serverSelect","label":"State","name":"STATE","defaultValue":"MONTANA","optionsSrc":"STATE"},{"type":"ServerMultiComplete","label":"County","name":"COUNTY","defaultValue":[],"optionsSrc":"COUNTY","overrideSubOptionsSrcFromParameterName":"STATE"},{"type":"checkbox","name":"TIN_SEARCH_YN","defaultValue":false,"label":"Tax Identification Number Search"},{"type":"checkbox","name":"TIN_SORT_YN","defaultValue":false,"label":"Unique ID Sort"}]},"ALLOW_ADDRESS_VALIDATION_BYPASS_OPTION":true,"DEFAULT_ADDRESS_VALIDATION_BYPASS_OPTION_CHECKED":true}).WIZARD_UPLOADS_DOWNLOADABLE ? _react2.default.createElement(
	                'a',
	                { download: true, href: _requests.BASE_URL + '/api/FileUpload/' + file.guid },
	                file.filename
	              ) : file.filename
	            ),
	            value.length - 1 !== i && _react2.default.createElement('br', null)
	          );
	        })
	      );
	    }
	  }, {
	    key: 'getConfirmFieldProps',
	    value: function getConfirmFieldProps() {
	      return [{ label: this.label, value: this.value.filename }];
	    }
	  }, {
	    key: 'getKeyValuePairs',
	    value: function getKeyValuePairs(field) {
	      return [{
	        name: field.name,
	        value: field.value && Array.isArray(field.value) ? field.value.filter(function (x) {
	          return x.status === 'success';
	        }) : field.value
	      }];
	    }
	  }]);
	
	  return FileUpload;
	}(Field);
	
	var UploadPlaceholder = exports.UploadPlaceholder = function (_FileUpload) {
	  _inherits(UploadPlaceholder, _FileUpload);
	
	  function UploadPlaceholder() {
	    var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	    _classCallCheck(this, UploadPlaceholder);
	
	    var _this10 = _possibleConstructorReturn(this, (UploadPlaceholder.__proto__ || Object.getPrototypeOf(UploadPlaceholder)).call(this, props));
	
	    _this10.type = "UploadPlaceholder";
	    _this10.fieldClass = "UploadPlaceholder";
	    _this10.value = props.value || null;
	    _this10.requireInternalReview = props.requireInternalReview || false;
	    _this10.allowedRules = ['uploadRequired', 'customBusinessRules'];
	    _this10.includeInSummary = false;
	    _this10.businessRules = props.businessRules || [];
	    return _this10;
	  }
	
	  _createClass(UploadPlaceholder, [{
	    key: 'getHumanReadableValue',
	    value: function getHumanReadableValue(field, value) {
	      return field.description;
	    }
	  }]);
	
	  return UploadPlaceholder;
	}(FileUpload);
	
	var UploadAccumulator = exports.UploadAccumulator = function (_Field7) {
	  _inherits(UploadAccumulator, _Field7);
	
	  function UploadAccumulator() {
	    var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	    _classCallCheck(this, UploadAccumulator);
	
	    var _this11 = _possibleConstructorReturn(this, (UploadAccumulator.__proto__ || Object.getPrototypeOf(UploadAccumulator)).call(this, props));
	
	    _this11.type = "UploadAccumulator";
	    _this11.fieldClass = "UploadAccumulator";
	    _this11.value = props.value || {};
	    _this11.businessRules = [{ fn: 'enforceUploadPlaceholderRules', ruleId: 'enforceUploadPlaceholderRules', props: {} }];
	    _this11.delegateErrorsToChildren = true;
	    _this11.instructions = props.instructions || '';
	    return _this11;
	  }
	
	  _createClass(UploadAccumulator, [{
	    key: 'getHumanReadableValue',
	    value: function getHumanReadableValue(field, value) {
	      return _react2.default.createElement(
	        'span',
	        null,
	        Object.keys(value).reduce(function (array, currentFieldId) {
	          return [].concat(_toConsumableArray(array), _toConsumableArray(value[currentFieldId]));
	        }, []).map(function (file) {
	          return _react2.default.createElement(
	            'span',
	            { className: 'file', key: file.queueId },
	            file.filename
	          );
	        })
	      );
	    }
	  }]);
	
	  return UploadAccumulator;
	}(Field);
	
	var ConfirmFields = exports.ConfirmFields = function (_Field8) {
	  _inherits(ConfirmFields, _Field8);
	
	  function ConfirmFields() {
	    var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	    _classCallCheck(this, ConfirmFields);
	
	    var _this12 = _possibleConstructorReturn(this, (ConfirmFields.__proto__ || Object.getPrototypeOf(ConfirmFields)).call(this, props));
	
	    _this12.confirmFieldId = props.confirmFieldId || _shortid2.default.generate();
	    _this12.type = 'confirmFields';
	    _this12.fieldClass = 'ConfirmFields';
	    _this12.match = props.match || null;
	    _this12.value = props.value || { val1: '', val2: '' };
	    _this12.label = props.label || 'New Confirm Field';
	    _this12.ownsLabel = true;
	    _this12.hideLabel = true;
	    _this12.allowedRules = ['notEmptyOrNull', 'valuesMatch', 'noRegulatedWords', 'hasNameEnding', 'nameNotTaken', 'isValidName', 'isValidEmailFormat', 'checkForRegulatedWords', 'customBusinessRules'];
	    _this12.allowedMasks = ['onlyAscii'];
	    _this12.confirmFieldLabel = props.confirmFieldLabel || '';
	    _this12.maskTopField = props.maskTopField === false ? false : true;
	    return _this12;
	  }
	
	  _createClass(ConfirmFields, [{
	    key: 'getKeyValuePairs',
	    value: function getKeyValuePairs(field) {
	      return [{ name: field.name, value: field.value.val1.trim() }];
	    }
	  }, {
	    key: 'getConfirmFieldProps',
	    value: function getConfirmFieldProps() {
	      return [{ label: this.fields[0].label, value: this.value.val1 }];
	    }
	  }, {
	    key: 'getHumanReadableValue',
	    value: function getHumanReadableValue(field, value) {
	      return value.val1;
	    }
	  }]);
	
	  return ConfirmFields;
	}(Field);
	
	var getEntityNameSearchValueObject = function getEntityNameSearchValueObject(_ref) {
	  var reservedYN = _ref.reservedYN,
	      rest = _objectWithoutProperties(_ref, ['reservedYN']);
	
	  return Object.assign({
	    val1: '',
	    val2: '',
	    reservedYN: reservedYN || '',
	    additionalYN: '',
	    consentYN: '',
	    reservedNameId: '',
	    additionalNameId: '',
	    numConsents: '',
	    reservedNum: '',
	    reservedName: '',
	    additionalMode: 'trade'
	  }, rest);
	};
	
	var EntityNameSearch = exports.EntityNameSearch = function (_Field9) {
	  _inherits(EntityNameSearch, _Field9);
	
	  function EntityNameSearch() {
	    var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	    _classCallCheck(this, EntityNameSearch);
	
	    var _this13 = _possibleConstructorReturn(this, (EntityNameSearch.__proto__ || Object.getPrototypeOf(EntityNameSearch)).call(this, props));
	
	    _this13.type = 'EntityNameSearch';
	    _this13.fieldClass = 'EntityNameSearch';
	    _this13.label = props.label ? props.label : props.label === '' ? '' : 'Entity name';
	    _this13.hideLabel = true;
	    _this13.value = Object.assign({}, getEntityNameSearchValueObject(Object.assign({}, props.value, {
	      reservedYN: (props.value || {}).reservedYN || props.defaultReservedValue
	    }))) || getEntityNameSearchValueObject({ reservedYN: props.defaultReservedValue });
	    _this13.allowedRules = ['validateEntityNameFields', 'checkForRegulatedWords', 'customBusinessRules', 'nameNotTaken'];
	    _this13.allowedMasks = ['onlyAsciiConfirmFields'];
	    _this13.mask = props.mask || [{ fn: 'onlyAsciiConfirmFields', props: {} }];
	    _this13.delegateErrorsToChildren = true;
	    _this13.metadata = props.metadata || {};
	    _this13.requireSupportingDocument = props.requireSupportingDocument === 'Y' ? 'Y' : 'N';
	    //Reserved name props
	    _this13.hideReserved = props.hideReserved || false;
	    _this13.reservedLabel = props.reservedLabel || 'A previously filed reserved name will be used for this filing.';
	    _this13.allowReservedNameEditing = props.allowReservedNameEditing || false;
	    _this13.defaultReservedValue = props.defaultReservedValue !== undefined ? props.defaultReservedValue : undefined;
	    //Entity name props
	    _this13.nameLabel = props.nameLabel || 'Business name';
	    _this13.nameDescription = props.nameDescription || '';
	    _this13.nameConfirmLabel = props.nameConfirmLabel || 'Confirm business name';
	    _this13.nameWidth = props.nameWidth || '40%';
	    _this13.nameMatch = props.match || null;
	    //Additional name props
	    _this13.additionalName = props.additionalName || '';
	    _this13.hideAdditionalName = props.hideAdditionalName || false;
	    _this13.additionalLabel = props.additionalLabel || 'Trade name';
	    _this13.additionalDescription = props.additionalDescription || '';
	    //Consent props
	    _this13.hideConsent = props.hideConsent || false;
	    _this13.consentLabel = props.consentLabel || 'Consent to use name';
	    _this13.consentDescription = props.consentDescription || '';
	    _this13.tradeOptionLabel1 = props.tradeOptionLabel1 || 'It is not known if a trade name is needed.';
	    _this13.tradeOptionLabel2 = props.tradeOptionLabel2 || 'A trade name is needed because the name is not in the required form or is deceptively similar to another name and a Trade Name Registration has been filed.';
	    _this13.consentOptionLabel1 = props.consentOptionLabel1 || 'It is not known if consent to use the name is needed from a business registered in [State].';
	    _this13.consentOptionLabel2 = props.consentOptionLabel2 || 'Consent to use the name was obtained because the business name is in conflict with a name registered in [State].';
	    _this13.consentInstructions = props.consentInstructions || '';
	    _this13.hideNumConsent = props.hideNumConsent || false;
	    _this13.selectedAdditionalNameCache = props.selectedAdditionalNameCache || '';
	    return _this13;
	  }
	
	  _createClass(EntityNameSearch, [{
	    key: 'getHumanReadableValue',
	    value: function getHumanReadableValue(field, value) {
	      if (value.reservedYN === 'N' || field.hideReserved) {
	        if (value.additionalYN === 'Y') {
	          return _react2.default.createElement(
	            'span',
	            null,
	            value.val1,
	            _react2.default.createElement('br', null),
	            _react2.default.createElement(
	              'span',
	              { className: 'indented' },
	              'transacting business in ',
	              ("Montana"),
	              ' under the name of'
	            ),
	            _react2.default.createElement('br', null),
	            value.additionalName
	          );
	        } else {
	          return value.val1;
	        }
	      } else {
	        if (({"NODE_ENV":"production","BUILD_DATE":"2025-08-27T15:15:31.687Z","BUILD_NUMBER":"Not Provided","GIT_VERSION":"v1.3.0-381-ga81e29b08","GIT_COMMIT_HASH":"a81e29b085c9268ffd96c78eb734365802722741","GIT_BRANCH":"beta","PUBLIC_URL":"","STATE_ABBR":"MT","STATE_NAME":"Montana","STATE_ORG_TITLE":"Secretary of State","LOGIN_HEADER_IMG_PATH":"","HOME_IMG_FILENAME":"montana.jpg","FAVICON_FILE_NAME":"favicon.ico","ALLOW_E_SIGN_ON_CORRECTIONS":true,"THIRD_PARTY_SIGNING_ALLOWED":false,"MY_ACCOUNT_SAVE_AND_CLOSE_BUTTON":true,"IE_DEPRECATED_MESSAGE":"Internet Explorer is not supported. Please select a supported browser below to access this website.","ADDITIONAL_ROUTES":{"dataRequests":true,"farmBill":true,"apostille":true,"externalHelp":"https://sosmt.gov/business/help-center/","systemAdministration":[{"title":"Saved Payments","parameter":"saved-payments","componentName":"SavedPayments"}]},"SUBROUTES":[{"label":"Business","component":"Business","parameter":"business","myWorkQueueSearch":false,"sourceTypeId":54,"searchMustHaveOneOf":["FILING_TYPE_ID","STATUS_ID","STATE","search"],"serverWebSearchDescription":true,"serverWorkQueueDescription":true,"serverMyRecordsDescription":true,"searchPlaceholder":"Search by name or filing number (X########)","allowEmptySearchTerm":true,"requestCertificateAlternateLabel":"Request Information","fileAmendmentButtonLabel":"Filing Actions","advancedSearchParameters":[{"type":"radio","name":"QUERY_TYPE_ID","defaultValue":1010,"options":[{"value":1010,"label":"Starts with"},{"value":1011,"label":"Contains"},{"value":1012,"label":" Word Contains"}]},{"type":"serverSelect","name":"FILING_TYPE_ID","optionsSrc":"FILING_TYPES","label":"Entity Type","placeholder":"All","defaultValue":"0"},{"type":"serverSelect","name":"FILING_SUBTYPE_ID","optionsSrc":"FILING_SUBTYPES","label":"Entity Subtype","overrideSubOptionsSrcFromParameterName":"FILING_TYPE_ID","placeholder":"All","defaultValue":"0"},{"type":"serverSelect","name":"STATUS_ID","optionsSrc":"FILING_STATUS_WITHOUT_ALL","label":"Status","placeholder":"All","defaultValue":"0"},{"type":"serverSelect","name":"STATE","optionsSrc":"STATE","label":"State","placeholder":"All","defaultValue":""},{"type":"serverSelect","name":"COUNTY","optionsSrc":"COUNTY_SUBOPTION","label":"County","overrideSubOptionsSrcFromParameterName":"STATE","placeholder":"All","defaultValue":""},{"type":"checkbox","name":"CRA_SEARCH_YN","defaultValue":false,"label":"Search by Registered Agent PID"},{"type":"dateRange","name":"FILING_DATE","label":"Registration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}},{"type":"dateRange","name":"EXPIRATION_DATE","label":"Expiration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}}],"myRecordsFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Active"},{"value":2,"label":"Inactive"},{"value":3,"label":"Pending"}]},{"type":"dateRange","name":"DATE_RANGE","label":"Date range","defaultValue":{"start":null,"end":null}}],"myWorkQueueFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Approved"},{"value":2,"label":"Pending Online Payment"},{"value":3,"label":"Pending Review"},{"value":4,"label":"Needs Correction"},{"value":5,"label":"Rejected"},{"value":6,"label":"Draft"}]},{"type":"dateRange","name":"DATE_RANGE","label":"Date range","defaultValue":{"start":null,"end":null}}]},{"label":"Notary","component":"Notary","parameter":"notary","sourceTypeId":850,"myWorkQueueSearch":false,"allowEmptySearchTerm":true,"requestCertificateAlternateLabel":"Download Certificate","fileAmendmentButtonLabel":"Filing Actions","hideNameRequestCertificate":true,"hideAddressRequestCertificate":true,"hideRecordUserManagment":true,"searchPlaceholder":"Search by name or commission number","searchMustHaveOneOf":["CITY","search","SERVICE_TYPE"],"advancedParametersStartOpen":true,"searchIsSortable":true,"advancedSearchParameters":[{"type":"radio","name":"STARTS_WITH_YN","defaultValue":false,"options":[{"value":true,"label":"Starts with"},{"value":false,"label":"Contains"}]},{"type":"checkbox","name":"ACTIVE_ONLY_YN","defaultValue":true,"label":"Active entities only"},{"type":"text","name":"CITY","defaultValue":"","label":"City"},{"type":"select","name":"SERVICE_TYPE","label":"Special Services Offered","defaultValue":0,"options":[{"value":0,"label":"(N/A)"},{"value":6165,"label":"In-Person Electronic Notarization (IPEN)"},{"value":6166,"label":"Remote Online Notarization (RON)"},{"value":6167,"label":"Mobile Notary Services"},{"value":6168,"label":"Remote Ink Notarization (RIN)"}]}]},{"label":"Apostille","component":"Apostille","parameter":"apostille","sourceTypeId":720,"myRecordsSearch":false,"myWorkQueueSearch":false,"disabled":false,"allowedRoutes":["/forms-manager/","/queue/","/forms/"]},{"label":"Liens","component":"UCC","parameter":"ucc","sourceTypeId":1999,"myRecordsSearch":true,"myWorkQueueSearch":true,"fileAmendmentButtonLabel":"Filing Actions","searchPlaceholder":"Search by name or file number","disabled":false,"serverWebSearchDescription":true,"myRecordsDescription":"","workQueueDescription":"","searchDescription":"","hideRecordUserManagment":true,"searchLiensCheckout":false,"advancedSearchParameters":[{"type":"radio","name":"STARTS_WITH_YN","defaultValue":false,"options":[{"value":true,"label":"Starts with"},{"value":false,"label":"Contains"}]},{"type":"select","name":"STATUS","defaultValue":"ALL","label":"Status","options":[{"value":"ACTIVE_UNLAPSED","label":"Active (unlapsed)"},{"value":"ACTIVE_LAPSED_UNLAPSED","label":"Active (lapsed and unlapsed)"}]},{"type":"text","name":"EXCLUDE_VALUES","label":"Exclude Debtor Names (comma separated list of names to exclude)","defaultValue":""},{"type":"dateRange","name":"FILING_DATE","label":"Financing Statement Date","defaultValue":{"start":null,"end":null}},{"type":"dateRange","name":"LAPSE_DATE","label":"Lapse Date","defaultValue":{"start":null,"end":null}},{"type":"text","name":"CITY","label":"Debtor City","defaultValue":""}],"myRecordsFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Approved"},{"value":2,"label":"Pending Online Payment"},{"value":3,"label":"Pending Review"}]},{"type":"select","name":"TYPE","defaultValue":0,"label":"Lien Type","options":[{"value":0,"label":"All"},{"value":1,"label":"UCC"},{"value":2,"label":"EFS"},{"value":3,"label":"Title 71"}]}],"myWorkQueueFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Approved"},{"value":2,"label":"Pending Online Payment"},{"value":3,"label":"Pending Review"},{"value":4,"label":"Pending Print and Mail"},{"value":5,"label":"Rejected"},{"value":6,"label":"Draft"}]},{"type":"select","name":"TYPE","defaultValue":0,"label":"Lien Type","options":[{"value":0,"label":"All"},{"value":1,"label":"UCC"},{"value":2,"label":"EFS"},{"value":3,"label":"Title 71"}]}]},{"label":"Copy Request","component":"copies","parameter":"copies","sourceTypeId":2001,"myRecordsSearch":false,"myWorkQueueSearch":false,"disabled":false,"allowedRoutes":["/forms-manager/","/queue/","/forms/"]},{"label":"Trademark","component":"Trademark","parameter":"trademark","sourceTypeId":810,"showRequestCertificate":true,"searchMustHaveOneOf":["search","EXPIRATION_DATE","FILING_DATE"],"allowEmptySearchTerm":true,"requestCertificateAlternateLabel":"Request Information","fileAmendmentButtonLabel":"Filing Actions","advancedSearchParameters":[{"type":"radio","name":"QUERY_TYPE_ID","defaultValue":1010,"options":[{"value":1010,"label":"Starts with"},{"value":1011,"label":"Contains"},{"value":1012,"label":" Word Contains"}]},{"type":"checkbox","name":"OWNER_SEARCH_YN","defaultValue":false,"label":"Search owners"},{"type":"radio","name":"SERVICE_MARK_YN","label":"Mark Type","defaultValue":"","options":[{"value":"","label":"All Marks"},{"value":"Y","label":"Service Mark"},{"value":"N","label":"Trademark"}]},{"type":"serverSelect","name":"STATUS_ID","optionsSrc":"TYPE_V|TRADEMARK_STATUS_TYPE","label":"Status","placeholder":"All","defaultValue":"0"},{"type":"select","name":"DESIGN_TYPE_ID","options":[{"value":0,"label":"All"},{"value":990,"label":"Words Only"},{"value":991,"label":"Design Only"},{"value":992,"label":"Words and Design"}],"label":"Design Type","defaultValue":"0"},{"type":"dateRange","name":"FILING_DATE","label":"Registered Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}},{"type":"dateRange","name":"EXPIRATION_DATE","label":"Expiration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}}]},{"label":"Business Info Request","component":"InfoRequests","parameter":"info-request","sourceTypeId":167,"allowedRoutes":["/forms-manager/","/queue/","/forms/"]},{"label":"Data Requests","component":"DataRequests","parameter":"data-request","sourceTypeId":0,"allowedRoutes":["/forms-manager/"]},{"label":"CRA","component":"CRA","parameter":"cra","sourceTypeId":157,"myRecordsSearch":false,"searchPlaceholder":"Search by name or registered agent number","allowedRoutes":["/forms-manager/","/forms/","/records/","/queue/","/search/"],"allowEmptySearchTerm":true,"fileAmendmentButtonLabel":"Filing Actions","advancedSearchParameters":[{"type":"radio","name":"QUERY_TYPE_ID","defaultValue":1010,"options":[{"value":1010,"label":"Starts with"},{"value":1011,"label":"Contains"},{"value":1012,"label":" Word Contains"}]},{"type":"dateRange","name":"CRA_DATE","label":"Registration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}},{"type":"select","name":"STATUS_ID","label":"Status","defaultValue":0,"options":[{"value":0,"label":"All"},{"value":121,"label":"Active"},{"value":122,"label":"Inactive"}]},{"type":"select","name":"AGENT_TYPE_ID","label":"Agent Type","defaultValue":0,"options":[{"value":0,"label":"All"},{"value":460,"label":"Registered Agent"},{"value":461,"label":"Commercial Registered Agent"}]}]},{"label":"Farm Bill","component":"FarmBill","parameter":"farm-bill","path":"/lists/farm-bill","sourceTypeId":0,"myRecordsSearch":false,"allowedRules":["/search/"],"disabled":true,"searchDescription":"To perform a search, enter a debtor name. Your search results may include: exact debtor name, variations of that name and any filing that includes your search criteria. Punctuation is ignored.\n\nYou can click on \"Advanced\" to refine your search. Under “Advanced” you can search by crop, year, county and SSN/FEIN. As a registered Farm Bill Buyer with the Montana Secretary of State’s office it is important to maintain the confidentiality of the information contained within the Farm Bill Master List. The Farm Bill Master List reflects personal data, such as Social Security Numbers, which are a key piece of personal identifiable information to assist you in determining the existence of a lien against a specific debtor. The distribution of this information beyond its intended purpose is strictly prohibited.\n\nThe debtor's tax identification number has been hidden for confidentiality reasons. You may continue to search on a tax ID number and return debtors that match your search criteria. The SSN/FEIN must be entered without dashes or spaces.","searchMustHaveOneOf":["search","UCC_FARM_PRODUCT_ID","COUNTY"],"searchPlaceholder":"Search by debtor name","advancedSearchParameters":[{"type":"ServerMultiComplete","label":"Product code name(s)","name":"UCC_FARM_PRODUCT_ID","defaultValue":"","optionsSrc":"UCC_FARM_PRODUCT_V"},{"type":"MultiComplete","label":"Year or Range of Years","name":"YEAR_NUM","optionsSrc":"years","startYear":"1968","defaultValue":[],"preMergeOptions":[{"value":"ALL","label":"All"}]},{"type":"serverSelect","label":"State","name":"STATE","defaultValue":"MONTANA","optionsSrc":"STATE"},{"type":"ServerMultiComplete","label":"County","name":"COUNTY","defaultValue":[],"optionsSrc":"COUNTY","overrideSubOptionsSrcFromParameterName":"STATE"},{"type":"checkbox","name":"TIN_SEARCH_YN","defaultValue":false,"label":"Tax Identification Number Search"},{"type":"checkbox","name":"TIN_SORT_YN","defaultValue":false,"label":"Unique ID Sort"}]}],"SYSTEM_NICKNAME":"Online Services Portal","PAYMENT_METHODS":[{"type":"bypass"},{"type":"iTransact"}],"PAYMENT_ALLOW_AMEX":true,"SYSTEM_ID_LABEL":"System Id","DOUBLE_COLUMN_PUBLIC_LOGIN":true,"INTERNAL_USER_MANAGEMENT":true,"ALLOW_PUBLIC_JSON_IMPORT":false,"MAX_FILE_UPLOAD_SIZE":10000000,"REFUND_TEXT":"","RETURN_TO_HOME_ON_LOGOUT":true,"CURRENT_SOS_NAME":"Christi Jacobsen","LOGO_FILENAME":"mt-sos-logo.png","LOGO_ALT":"Christi Jacobsen, Montana Secretary of State","LOGO_FULL_WIDTH":true,"HOME_HIDE_AUTH_HINT":true,"HOME_TITLE":"Montana Secretary of State","CUSTOM_TAB_TITLE":"Official Montana","HOME_SUBTITLE":"Online Business Services","ENTITY_NAME_CONSENT_DESCRIPTION":"","ALLOW_USER_PROFILE_EDITING":true,"COMPARE_FOREIGN_NAME_IN_ENTITY_NAME_VALIDATION":true,"FOREIGN_NAME_FIELD_NAME":"KIMA_PARENT_NAME_INFO","LOGIN_TITLE":"Montana Secretary of State Online Filing Portal Login","PUBLIC_LOGIN_LABEL":"Username","REVERSE_LOGIN_COLUMNS":true,"LOGIN_SEAL_FILENAME":"seal_white.png","SEPARATE_USERNAME_AND_EMAIL":true,"CREATE_ACCOUNT_BUTTON_ALIGN_LEFT":true,"CREATE_ACCOUNT_BUTTON_TEXT":"CREATE AN ACCOUNT","PASSWORD_CUSTOM_ERROR_TEXT":"The password must meet all requirements","ACCOUNT_CREATED_MESSAGE":"Please check your email to verify your account to login and allow a few minutes for this message to arrive. Check your junk/spam folders if you do not find the email in your inbox.","PUBLIC_LOGIN_PLACEHOLDER":" ","DISABLE_DEFAULT_PAYMENT_RADIO":true,"CUSTOM_RESET_PASSWORD_ERROR_MESSAGE":"Username invalid - no account found","PUBLIC_LOGIN_CREATE_DESCRIPTION":"### Existing User:\n\n  - Enter your username and password to login.  \n\n\n  #### - OR -  \n\n\n\n  - Forgot password? Click 'Reset Password' and follow the prompts.\n  - Forgot username? Click 'Forgot Username' and follow the prompts.  \n\n\n  ### New User:\n  ","LOGIN_HELP_LINK":"https://sosmt.gov/business/how-do-i/","LOGIN_HELP_LINK_TEXT":"Need Help?","FORGOT_USERNAME_TEXT":"Forgot Username?","LOGIN_ACTIVE_DIRECTORY_TEXT":"State User Login","MULTIPLE_LOGIN_METHODS":true,"HAS_ACTIVE_DIRECTORY_LOGIN":true,"RESET_PASSWORD_WITH_USERNAME":true,"DOWNLOAD_LINK":true,"SHOW_USERNAME_ACCOUNT_CREATE":true,"SHOW_SCROLL_DOWN_ARROW":true,"SHOW_ADDRESS_ACCOUNT_CREATE":true,"TWO_COLUMN_ACCOUNT_CREATE":true,"RESET_PASSWORD_TIP":"A link to change your password has been sent to your email. Please allow a few minutes for this message to arrive. Please check your junk/spam folders if you do not find the email in your inbox.","FORGOT_PASSWORD_LINK_TEXT":"Reset Password","PHONE_NUMBER_OPTIONAL_ACCOUNT_CREATE":true,"SHOW_REQUIRED_INDICATOR_ACCOUNT_CREATE":true,"PASSWORD_REQUIREMENTS_ACCOUNT_CREATE":"\n    <ul>\n      <li>MUST contain at least 8 characters (12+ recommended)</li>\n      <li>MUST contain at least one uppercase letter.</li>\n      <li>MUST contain at least one lowercase letter.</li>\n      <li>MUST contain at least one number.</li>\n      <li>MUST contain at least one special character (!”#$%&'()*+,-./:;<=>?</li>\n    </ul>\n  ","ALLOW_CERTIFICATION_REQUEST":true,"ALLOW_PUBLIC_CERTIFICATE_REQUEST":true,"ALLOW_COPY_REQUEST":false,"ALLOW_CORRECTION_STYLING":true,"HIDE_DEPRECATION_WARNING":false,"AMEND_ROUTE_PUBLIC":true,"SEAL_FILENAME":"seal.png","SHOPPING_CART":true,"ALLOW_PAYMENT_UPDATE_WITH_EMPTY_CART":true,"RA_EMAIL":true,"RA_WEBSITE":true,"RA_NO_DEFAULT_TYPE":true,"RA_ADDRESS_LABEL":"Street Address","RA_TYPE_SELECTION_DEFAULT":true,"RA_DEFAULT_TYPE":"460","RA_OVERRIDE_TYPE_WITH_DEFAULT":true,"RA_PRINCIPAL_ADDRESS_AMS":true,"UPLOAD_AND_SUBMIT_HIDE_IF_ONE_OPTION":true,"PAYMENT_PROCESSING_MESSAGE":"Your payment is processing - Do not close your browser or click the back button","CHECKOUT_BUTTON_WHEN_PROCESSING_TEXT":"Processing","EFS_CROP_PICKER_NONE_LABEL":"Lien Duration","DISALLOWED_WIZARD_PIECES":["FormationLocale"],"REPEATER_SHOW_EDIT_BUTTON":true,"DATA_REQUEST_PAGE_TITLE":"Data Requests and Subscriptions","DATA_REQUEST_SIDEBAR_LABEL":"Data Requests & Subscriptions","LOGIN_REDIRECTS_TO_EPASS":false,"LOGIN_REDIRECTS_TO_ACTIVE_DIRECTORY":true,"LOGIN_ACTIVE_DIRECTORY_LINK":true,"FETCH_EDIT_USER_LINK":false,"LISTS_FETCH_AVAILABLE_LISTS":true,"POST_WIZARD_SUBMIT_REDIRECT_URL":"/","PIN_REQUEST_ATTESTATIONS":true,"PIN_REQUEST_DESCRIPTION":"Click **Request PIN** to have a new PIN sent to the account holder's email address on file.","OWNERSHIP_REQUEST_DESCRIPTION":"To become an **authorized user** of this record, a current **AUTHORIZED USER** will need to grant you access. To request access, click **Request Access** below.","PIN_REQUEST_SUCCESS_MESSAGE":"The PIN you have requested for this entity has been sent to the email associated with your user account.  You should receive the PIN in approximately 3-5 minutes, depending on your email service provider.","APOSTILLE_HEADER_LABEL":"Verification Information","APOSTILLE_NUMBER_LABEL":"Apostille/Authentication","APOSTILLE_CITY_STATE_OVERRIDE":"HELENA, MT","APOSTILLE_FILING_DATE_LABEL":"Issue Date","APOSTILLE_CITY_STATE_IN_CERTIFIED":true,"NOTARY_EXISTING_FILING":true,"ALLOW_REVOKE_OWN_ACCESS_ONLY":false,"HIDE_CANCEL_ON_ONETIME_DATA_REQUESTS":true,"DATA_REQUESTS_IN_SHOPPING_CART":true,"WQ_ALLOW_EDIT_PENDING_PAYMENT":true,"WQ_CONFIRM_ON_DELETE":true,"WQ_DELETE_CONFIRM_MESSAGE":"Deleting this filing will forfeit any money already paid to the Secretary of State. This action is permanent and cannot be undone, are you sure you would like to delete?","PASS_ITEM_GUIDS_ON_CHECKOUT":true,"FORM_REVISION_HISTORY":true,"CHECKOUT_DISCLAIMER":"By entering your credit card and/or checking account information you (i) state that **you are an authorized user** of the credit card and/or electronic check and that the associated information entered (e.g., account holder name, account number, billing address) is accurate, (ii) **you authorize payment processor to charge the amount you have requested** to your credit card and/or funding account, and (iii) **acknowledge if a charge is declined or reversed you may also be assessed a customary charge** by the payment processor for such transactions.","FARM_BILL_SEARCH_CONFIDENTIAL":"As a registered Farm Bill Buyer with the Montana Secretary of State’s office it is important to maintain the confidentiality of the information contained within the Farm Bill Master List. The Farm Bill Master List reflects personal data, such as Social Security Numbers, which are a key piece of personal identifiable information to assist you in determining the existence of a lien against a specific debtor. The distribution of this information beyond its intended purpose is strictly prohibited.\n\n**The debtor's tax identification number has been hidden for confidentiality reasons. You may continue to search on a tax ID number and return debtors that match your search criteria. The SSN/FEIN must be entered without dashes or spaces.  If you need access to the tax identification number to clearly identify the debtor, please contact the UCC unit at (406) 444-3665.**","VIEW_HISTORY_BUTTON_ALT_TEXT":"View Filings","WIZARD_ERROR_TITLE_MESSAGE":"Form Error","FARM_BILL_SEARCH_INTERACTIVE":true,"USE_FARM_BILL_API":true,"DISALLOW_ASSIGN_SELF_AS_RA":true,"DISALLOW_ASSIGN_SELF_AS_PRINCIPAL":true,"USE_TRADEMARK_OWNER_VALIDATION":true,"USE_ALTERNATIVE_FOREIGN_ADDRESS_LABELS":true,"MY_RECEIPTS_FILTER":[{"type":"dateRange","name":"DATE_RANGE","label":"Date range","defaultValue":{"start":null,"end":null}},{"type":"text","name":"REF_NUM","defaultValue":"","label":"Reference Number"},{"type":"text","name":"RECEIPT_NUM","defaultValue":"","label":"Receipt Id"},{"type":"text","name":"AMOUNT","defaultValue":"","label":"Amount"},{"type":"select","name":"TYPE","defaultValue":"","label":"Payment Type","options":[{"value":"","label":"All"},{"value":"CC","label":"Credit Card"},{"value":"Check","label":"Check"}]}],"MY_RECEIPTS_SHOW_IN_SIDEBAR":true,"SHOW_MY_RECEIPTS_HELPER_TEXT":true,"MY_RECEIPTS_HELPER_LABEL":"About Receipt Search","MY_RECEIPTS_HELPER_TEXT":"You can search for receipts based on their descriptions, including the items paid for on the receipt. Use the filters to search for or filter specific information.","FARM_BILL_SUBLINK":{"label":"Farm Bill","component":"FarmBill","parameter":"farm-bill","path":"/lists/farm-bill","sourceTypeId":0,"myRecordsSearch":false,"allowedRules":["/search/"],"disabled":true,"searchDescription":"To perform a search, enter a debtor name. Your search results may include: exact debtor name, variations of that name and any filing that includes your search criteria. Punctuation is ignored.\n\nYou can click on \"Advanced\" to refine your search. Under “Advanced” you can search by crop, year, county and SSN/FEIN. As a registered Farm Bill Buyer with the Montana Secretary of State’s office it is important to maintain the confidentiality of the information contained within the Farm Bill Master List. The Farm Bill Master List reflects personal data, such as Social Security Numbers, which are a key piece of personal identifiable information to assist you in determining the existence of a lien against a specific debtor. The distribution of this information beyond its intended purpose is strictly prohibited.\n\nThe debtor's tax identification number has been hidden for confidentiality reasons. You may continue to search on a tax ID number and return debtors that match your search criteria. The SSN/FEIN must be entered without dashes or spaces.","searchMustHaveOneOf":["search","UCC_FARM_PRODUCT_ID","COUNTY"],"searchPlaceholder":"Search by debtor name","advancedSearchParameters":[{"type":"ServerMultiComplete","label":"Product code name(s)","name":"UCC_FARM_PRODUCT_ID","defaultValue":"","optionsSrc":"UCC_FARM_PRODUCT_V"},{"type":"MultiComplete","label":"Year or Range of Years","name":"YEAR_NUM","optionsSrc":"years","startYear":"1968","defaultValue":[],"preMergeOptions":[{"value":"ALL","label":"All"}]},{"type":"serverSelect","label":"State","name":"STATE","defaultValue":"MONTANA","optionsSrc":"STATE"},{"type":"ServerMultiComplete","label":"County","name":"COUNTY","defaultValue":[],"optionsSrc":"COUNTY","overrideSubOptionsSrcFromParameterName":"STATE"},{"type":"checkbox","name":"TIN_SEARCH_YN","defaultValue":false,"label":"Tax Identification Number Search"},{"type":"checkbox","name":"TIN_SORT_YN","defaultValue":false,"label":"Unique ID Sort"}]},"ALLOW_ADDRESS_VALIDATION_BYPASS_OPTION":true,"DEFAULT_ADDRESS_VALIDATION_BYPASS_OPTION_CHECKED":true}).ALLOW_RESERVED_NAME_OVERRIDE) {
	          var isReservedNameChanged = value.reservedName !== value.val1;
	          if (isReservedNameChanged) {
	            return value.reservedNum + ' - ' + value.val1;
	          }
	        }
	        return value.reservedNum + ' - ' + value.reservedName;
	      }
	    }
	  }, {
	    key: 'getKeyValuePairs',
	    value: function getKeyValuePairs(field) {
	      return [{
	        name: field.name,
	        value: Object.assign({}, field.value, { val1: field.value.val1.trim(), val2: field.value.val2.trim() })
	      }];
	    }
	  }]);
	
	  return EntityNameSearch;
	}(Field);
	
	var getAddressObject = exports.getAddressObject = function getAddressObject() {
	  var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	  return {
	    ADDR1: (0, _utilities.coerceType)(value.ADDR1 || '', ''),
	    ADDR2: (0, _utilities.coerceType)(value.ADDR2 || '', ''),
	    ADDR3: (0, _utilities.coerceType)(value.ADDR3 || '', ''),
	    CITY: (0, _utilities.coerceType)(value.CITY || '', ''),
	    STATE: (0, _utilities.coerceType)(value.STATE || '', ''),
	    COUNTY: (0, _utilities.coerceType)(value.COUNTY || '', ''),
	    COUNTRY: (0, _utilities.coerceType)(({"NODE_ENV":"production","BUILD_DATE":"2025-08-27T15:15:31.687Z","BUILD_NUMBER":"Not Provided","GIT_VERSION":"v1.3.0-381-ga81e29b08","GIT_COMMIT_HASH":"a81e29b085c9268ffd96c78eb734365802722741","GIT_BRANCH":"beta","PUBLIC_URL":"","STATE_ABBR":"MT","STATE_NAME":"Montana","STATE_ORG_TITLE":"Secretary of State","LOGIN_HEADER_IMG_PATH":"","HOME_IMG_FILENAME":"montana.jpg","FAVICON_FILE_NAME":"favicon.ico","ALLOW_E_SIGN_ON_CORRECTIONS":true,"THIRD_PARTY_SIGNING_ALLOWED":false,"MY_ACCOUNT_SAVE_AND_CLOSE_BUTTON":true,"IE_DEPRECATED_MESSAGE":"Internet Explorer is not supported. Please select a supported browser below to access this website.","ADDITIONAL_ROUTES":{"dataRequests":true,"farmBill":true,"apostille":true,"externalHelp":"https://sosmt.gov/business/help-center/","systemAdministration":[{"title":"Saved Payments","parameter":"saved-payments","componentName":"SavedPayments"}]},"SUBROUTES":[{"label":"Business","component":"Business","parameter":"business","myWorkQueueSearch":false,"sourceTypeId":54,"searchMustHaveOneOf":["FILING_TYPE_ID","STATUS_ID","STATE","search"],"serverWebSearchDescription":true,"serverWorkQueueDescription":true,"serverMyRecordsDescription":true,"searchPlaceholder":"Search by name or filing number (X########)","allowEmptySearchTerm":true,"requestCertificateAlternateLabel":"Request Information","fileAmendmentButtonLabel":"Filing Actions","advancedSearchParameters":[{"type":"radio","name":"QUERY_TYPE_ID","defaultValue":1010,"options":[{"value":1010,"label":"Starts with"},{"value":1011,"label":"Contains"},{"value":1012,"label":" Word Contains"}]},{"type":"serverSelect","name":"FILING_TYPE_ID","optionsSrc":"FILING_TYPES","label":"Entity Type","placeholder":"All","defaultValue":"0"},{"type":"serverSelect","name":"FILING_SUBTYPE_ID","optionsSrc":"FILING_SUBTYPES","label":"Entity Subtype","overrideSubOptionsSrcFromParameterName":"FILING_TYPE_ID","placeholder":"All","defaultValue":"0"},{"type":"serverSelect","name":"STATUS_ID","optionsSrc":"FILING_STATUS_WITHOUT_ALL","label":"Status","placeholder":"All","defaultValue":"0"},{"type":"serverSelect","name":"STATE","optionsSrc":"STATE","label":"State","placeholder":"All","defaultValue":""},{"type":"serverSelect","name":"COUNTY","optionsSrc":"COUNTY_SUBOPTION","label":"County","overrideSubOptionsSrcFromParameterName":"STATE","placeholder":"All","defaultValue":""},{"type":"checkbox","name":"CRA_SEARCH_YN","defaultValue":false,"label":"Search by Registered Agent PID"},{"type":"dateRange","name":"FILING_DATE","label":"Registration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}},{"type":"dateRange","name":"EXPIRATION_DATE","label":"Expiration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}}],"myRecordsFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Active"},{"value":2,"label":"Inactive"},{"value":3,"label":"Pending"}]},{"type":"dateRange","name":"DATE_RANGE","label":"Date range","defaultValue":{"start":null,"end":null}}],"myWorkQueueFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Approved"},{"value":2,"label":"Pending Online Payment"},{"value":3,"label":"Pending Review"},{"value":4,"label":"Needs Correction"},{"value":5,"label":"Rejected"},{"value":6,"label":"Draft"}]},{"type":"dateRange","name":"DATE_RANGE","label":"Date range","defaultValue":{"start":null,"end":null}}]},{"label":"Notary","component":"Notary","parameter":"notary","sourceTypeId":850,"myWorkQueueSearch":false,"allowEmptySearchTerm":true,"requestCertificateAlternateLabel":"Download Certificate","fileAmendmentButtonLabel":"Filing Actions","hideNameRequestCertificate":true,"hideAddressRequestCertificate":true,"hideRecordUserManagment":true,"searchPlaceholder":"Search by name or commission number","searchMustHaveOneOf":["CITY","search","SERVICE_TYPE"],"advancedParametersStartOpen":true,"searchIsSortable":true,"advancedSearchParameters":[{"type":"radio","name":"STARTS_WITH_YN","defaultValue":false,"options":[{"value":true,"label":"Starts with"},{"value":false,"label":"Contains"}]},{"type":"checkbox","name":"ACTIVE_ONLY_YN","defaultValue":true,"label":"Active entities only"},{"type":"text","name":"CITY","defaultValue":"","label":"City"},{"type":"select","name":"SERVICE_TYPE","label":"Special Services Offered","defaultValue":0,"options":[{"value":0,"label":"(N/A)"},{"value":6165,"label":"In-Person Electronic Notarization (IPEN)"},{"value":6166,"label":"Remote Online Notarization (RON)"},{"value":6167,"label":"Mobile Notary Services"},{"value":6168,"label":"Remote Ink Notarization (RIN)"}]}]},{"label":"Apostille","component":"Apostille","parameter":"apostille","sourceTypeId":720,"myRecordsSearch":false,"myWorkQueueSearch":false,"disabled":false,"allowedRoutes":["/forms-manager/","/queue/","/forms/"]},{"label":"Liens","component":"UCC","parameter":"ucc","sourceTypeId":1999,"myRecordsSearch":true,"myWorkQueueSearch":true,"fileAmendmentButtonLabel":"Filing Actions","searchPlaceholder":"Search by name or file number","disabled":false,"serverWebSearchDescription":true,"myRecordsDescription":"","workQueueDescription":"","searchDescription":"","hideRecordUserManagment":true,"searchLiensCheckout":false,"advancedSearchParameters":[{"type":"radio","name":"STARTS_WITH_YN","defaultValue":false,"options":[{"value":true,"label":"Starts with"},{"value":false,"label":"Contains"}]},{"type":"select","name":"STATUS","defaultValue":"ALL","label":"Status","options":[{"value":"ACTIVE_UNLAPSED","label":"Active (unlapsed)"},{"value":"ACTIVE_LAPSED_UNLAPSED","label":"Active (lapsed and unlapsed)"}]},{"type":"text","name":"EXCLUDE_VALUES","label":"Exclude Debtor Names (comma separated list of names to exclude)","defaultValue":""},{"type":"dateRange","name":"FILING_DATE","label":"Financing Statement Date","defaultValue":{"start":null,"end":null}},{"type":"dateRange","name":"LAPSE_DATE","label":"Lapse Date","defaultValue":{"start":null,"end":null}},{"type":"text","name":"CITY","label":"Debtor City","defaultValue":""}],"myRecordsFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Approved"},{"value":2,"label":"Pending Online Payment"},{"value":3,"label":"Pending Review"}]},{"type":"select","name":"TYPE","defaultValue":0,"label":"Lien Type","options":[{"value":0,"label":"All"},{"value":1,"label":"UCC"},{"value":2,"label":"EFS"},{"value":3,"label":"Title 71"}]}],"myWorkQueueFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Approved"},{"value":2,"label":"Pending Online Payment"},{"value":3,"label":"Pending Review"},{"value":4,"label":"Pending Print and Mail"},{"value":5,"label":"Rejected"},{"value":6,"label":"Draft"}]},{"type":"select","name":"TYPE","defaultValue":0,"label":"Lien Type","options":[{"value":0,"label":"All"},{"value":1,"label":"UCC"},{"value":2,"label":"EFS"},{"value":3,"label":"Title 71"}]}]},{"label":"Copy Request","component":"copies","parameter":"copies","sourceTypeId":2001,"myRecordsSearch":false,"myWorkQueueSearch":false,"disabled":false,"allowedRoutes":["/forms-manager/","/queue/","/forms/"]},{"label":"Trademark","component":"Trademark","parameter":"trademark","sourceTypeId":810,"showRequestCertificate":true,"searchMustHaveOneOf":["search","EXPIRATION_DATE","FILING_DATE"],"allowEmptySearchTerm":true,"requestCertificateAlternateLabel":"Request Information","fileAmendmentButtonLabel":"Filing Actions","advancedSearchParameters":[{"type":"radio","name":"QUERY_TYPE_ID","defaultValue":1010,"options":[{"value":1010,"label":"Starts with"},{"value":1011,"label":"Contains"},{"value":1012,"label":" Word Contains"}]},{"type":"checkbox","name":"OWNER_SEARCH_YN","defaultValue":false,"label":"Search owners"},{"type":"radio","name":"SERVICE_MARK_YN","label":"Mark Type","defaultValue":"","options":[{"value":"","label":"All Marks"},{"value":"Y","label":"Service Mark"},{"value":"N","label":"Trademark"}]},{"type":"serverSelect","name":"STATUS_ID","optionsSrc":"TYPE_V|TRADEMARK_STATUS_TYPE","label":"Status","placeholder":"All","defaultValue":"0"},{"type":"select","name":"DESIGN_TYPE_ID","options":[{"value":0,"label":"All"},{"value":990,"label":"Words Only"},{"value":991,"label":"Design Only"},{"value":992,"label":"Words and Design"}],"label":"Design Type","defaultValue":"0"},{"type":"dateRange","name":"FILING_DATE","label":"Registered Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}},{"type":"dateRange","name":"EXPIRATION_DATE","label":"Expiration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}}]},{"label":"Business Info Request","component":"InfoRequests","parameter":"info-request","sourceTypeId":167,"allowedRoutes":["/forms-manager/","/queue/","/forms/"]},{"label":"Data Requests","component":"DataRequests","parameter":"data-request","sourceTypeId":0,"allowedRoutes":["/forms-manager/"]},{"label":"CRA","component":"CRA","parameter":"cra","sourceTypeId":157,"myRecordsSearch":false,"searchPlaceholder":"Search by name or registered agent number","allowedRoutes":["/forms-manager/","/forms/","/records/","/queue/","/search/"],"allowEmptySearchTerm":true,"fileAmendmentButtonLabel":"Filing Actions","advancedSearchParameters":[{"type":"radio","name":"QUERY_TYPE_ID","defaultValue":1010,"options":[{"value":1010,"label":"Starts with"},{"value":1011,"label":"Contains"},{"value":1012,"label":" Word Contains"}]},{"type":"dateRange","name":"CRA_DATE","label":"Registration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}},{"type":"select","name":"STATUS_ID","label":"Status","defaultValue":0,"options":[{"value":0,"label":"All"},{"value":121,"label":"Active"},{"value":122,"label":"Inactive"}]},{"type":"select","name":"AGENT_TYPE_ID","label":"Agent Type","defaultValue":0,"options":[{"value":0,"label":"All"},{"value":460,"label":"Registered Agent"},{"value":461,"label":"Commercial Registered Agent"}]}]},{"label":"Farm Bill","component":"FarmBill","parameter":"farm-bill","path":"/lists/farm-bill","sourceTypeId":0,"myRecordsSearch":false,"allowedRules":["/search/"],"disabled":true,"searchDescription":"To perform a search, enter a debtor name. Your search results may include: exact debtor name, variations of that name and any filing that includes your search criteria. Punctuation is ignored.\n\nYou can click on \"Advanced\" to refine your search. Under “Advanced” you can search by crop, year, county and SSN/FEIN. As a registered Farm Bill Buyer with the Montana Secretary of State’s office it is important to maintain the confidentiality of the information contained within the Farm Bill Master List. The Farm Bill Master List reflects personal data, such as Social Security Numbers, which are a key piece of personal identifiable information to assist you in determining the existence of a lien against a specific debtor. The distribution of this information beyond its intended purpose is strictly prohibited.\n\nThe debtor's tax identification number has been hidden for confidentiality reasons. You may continue to search on a tax ID number and return debtors that match your search criteria. The SSN/FEIN must be entered without dashes or spaces.","searchMustHaveOneOf":["search","UCC_FARM_PRODUCT_ID","COUNTY"],"searchPlaceholder":"Search by debtor name","advancedSearchParameters":[{"type":"ServerMultiComplete","label":"Product code name(s)","name":"UCC_FARM_PRODUCT_ID","defaultValue":"","optionsSrc":"UCC_FARM_PRODUCT_V"},{"type":"MultiComplete","label":"Year or Range of Years","name":"YEAR_NUM","optionsSrc":"years","startYear":"1968","defaultValue":[],"preMergeOptions":[{"value":"ALL","label":"All"}]},{"type":"serverSelect","label":"State","name":"STATE","defaultValue":"MONTANA","optionsSrc":"STATE"},{"type":"ServerMultiComplete","label":"County","name":"COUNTY","defaultValue":[],"optionsSrc":"COUNTY","overrideSubOptionsSrcFromParameterName":"STATE"},{"type":"checkbox","name":"TIN_SEARCH_YN","defaultValue":false,"label":"Tax Identification Number Search"},{"type":"checkbox","name":"TIN_SORT_YN","defaultValue":false,"label":"Unique ID Sort"}]}],"SYSTEM_NICKNAME":"Online Services Portal","PAYMENT_METHODS":[{"type":"bypass"},{"type":"iTransact"}],"PAYMENT_ALLOW_AMEX":true,"SYSTEM_ID_LABEL":"System Id","DOUBLE_COLUMN_PUBLIC_LOGIN":true,"INTERNAL_USER_MANAGEMENT":true,"ALLOW_PUBLIC_JSON_IMPORT":false,"MAX_FILE_UPLOAD_SIZE":10000000,"REFUND_TEXT":"","RETURN_TO_HOME_ON_LOGOUT":true,"CURRENT_SOS_NAME":"Christi Jacobsen","LOGO_FILENAME":"mt-sos-logo.png","LOGO_ALT":"Christi Jacobsen, Montana Secretary of State","LOGO_FULL_WIDTH":true,"HOME_HIDE_AUTH_HINT":true,"HOME_TITLE":"Montana Secretary of State","CUSTOM_TAB_TITLE":"Official Montana","HOME_SUBTITLE":"Online Business Services","ENTITY_NAME_CONSENT_DESCRIPTION":"","ALLOW_USER_PROFILE_EDITING":true,"COMPARE_FOREIGN_NAME_IN_ENTITY_NAME_VALIDATION":true,"FOREIGN_NAME_FIELD_NAME":"KIMA_PARENT_NAME_INFO","LOGIN_TITLE":"Montana Secretary of State Online Filing Portal Login","PUBLIC_LOGIN_LABEL":"Username","REVERSE_LOGIN_COLUMNS":true,"LOGIN_SEAL_FILENAME":"seal_white.png","SEPARATE_USERNAME_AND_EMAIL":true,"CREATE_ACCOUNT_BUTTON_ALIGN_LEFT":true,"CREATE_ACCOUNT_BUTTON_TEXT":"CREATE AN ACCOUNT","PASSWORD_CUSTOM_ERROR_TEXT":"The password must meet all requirements","ACCOUNT_CREATED_MESSAGE":"Please check your email to verify your account to login and allow a few minutes for this message to arrive. Check your junk/spam folders if you do not find the email in your inbox.","PUBLIC_LOGIN_PLACEHOLDER":" ","DISABLE_DEFAULT_PAYMENT_RADIO":true,"CUSTOM_RESET_PASSWORD_ERROR_MESSAGE":"Username invalid - no account found","PUBLIC_LOGIN_CREATE_DESCRIPTION":"### Existing User:\n\n  - Enter your username and password to login.  \n\n\n  #### - OR -  \n\n\n\n  - Forgot password? Click 'Reset Password' and follow the prompts.\n  - Forgot username? Click 'Forgot Username' and follow the prompts.  \n\n\n  ### New User:\n  ","LOGIN_HELP_LINK":"https://sosmt.gov/business/how-do-i/","LOGIN_HELP_LINK_TEXT":"Need Help?","FORGOT_USERNAME_TEXT":"Forgot Username?","LOGIN_ACTIVE_DIRECTORY_TEXT":"State User Login","MULTIPLE_LOGIN_METHODS":true,"HAS_ACTIVE_DIRECTORY_LOGIN":true,"RESET_PASSWORD_WITH_USERNAME":true,"DOWNLOAD_LINK":true,"SHOW_USERNAME_ACCOUNT_CREATE":true,"SHOW_SCROLL_DOWN_ARROW":true,"SHOW_ADDRESS_ACCOUNT_CREATE":true,"TWO_COLUMN_ACCOUNT_CREATE":true,"RESET_PASSWORD_TIP":"A link to change your password has been sent to your email. Please allow a few minutes for this message to arrive. Please check your junk/spam folders if you do not find the email in your inbox.","FORGOT_PASSWORD_LINK_TEXT":"Reset Password","PHONE_NUMBER_OPTIONAL_ACCOUNT_CREATE":true,"SHOW_REQUIRED_INDICATOR_ACCOUNT_CREATE":true,"PASSWORD_REQUIREMENTS_ACCOUNT_CREATE":"\n    <ul>\n      <li>MUST contain at least 8 characters (12+ recommended)</li>\n      <li>MUST contain at least one uppercase letter.</li>\n      <li>MUST contain at least one lowercase letter.</li>\n      <li>MUST contain at least one number.</li>\n      <li>MUST contain at least one special character (!”#$%&'()*+,-./:;<=>?</li>\n    </ul>\n  ","ALLOW_CERTIFICATION_REQUEST":true,"ALLOW_PUBLIC_CERTIFICATE_REQUEST":true,"ALLOW_COPY_REQUEST":false,"ALLOW_CORRECTION_STYLING":true,"HIDE_DEPRECATION_WARNING":false,"AMEND_ROUTE_PUBLIC":true,"SEAL_FILENAME":"seal.png","SHOPPING_CART":true,"ALLOW_PAYMENT_UPDATE_WITH_EMPTY_CART":true,"RA_EMAIL":true,"RA_WEBSITE":true,"RA_NO_DEFAULT_TYPE":true,"RA_ADDRESS_LABEL":"Street Address","RA_TYPE_SELECTION_DEFAULT":true,"RA_DEFAULT_TYPE":"460","RA_OVERRIDE_TYPE_WITH_DEFAULT":true,"RA_PRINCIPAL_ADDRESS_AMS":true,"UPLOAD_AND_SUBMIT_HIDE_IF_ONE_OPTION":true,"PAYMENT_PROCESSING_MESSAGE":"Your payment is processing - Do not close your browser or click the back button","CHECKOUT_BUTTON_WHEN_PROCESSING_TEXT":"Processing","EFS_CROP_PICKER_NONE_LABEL":"Lien Duration","DISALLOWED_WIZARD_PIECES":["FormationLocale"],"REPEATER_SHOW_EDIT_BUTTON":true,"DATA_REQUEST_PAGE_TITLE":"Data Requests and Subscriptions","DATA_REQUEST_SIDEBAR_LABEL":"Data Requests & Subscriptions","LOGIN_REDIRECTS_TO_EPASS":false,"LOGIN_REDIRECTS_TO_ACTIVE_DIRECTORY":true,"LOGIN_ACTIVE_DIRECTORY_LINK":true,"FETCH_EDIT_USER_LINK":false,"LISTS_FETCH_AVAILABLE_LISTS":true,"POST_WIZARD_SUBMIT_REDIRECT_URL":"/","PIN_REQUEST_ATTESTATIONS":true,"PIN_REQUEST_DESCRIPTION":"Click **Request PIN** to have a new PIN sent to the account holder's email address on file.","OWNERSHIP_REQUEST_DESCRIPTION":"To become an **authorized user** of this record, a current **AUTHORIZED USER** will need to grant you access. To request access, click **Request Access** below.","PIN_REQUEST_SUCCESS_MESSAGE":"The PIN you have requested for this entity has been sent to the email associated with your user account.  You should receive the PIN in approximately 3-5 minutes, depending on your email service provider.","APOSTILLE_HEADER_LABEL":"Verification Information","APOSTILLE_NUMBER_LABEL":"Apostille/Authentication","APOSTILLE_CITY_STATE_OVERRIDE":"HELENA, MT","APOSTILLE_FILING_DATE_LABEL":"Issue Date","APOSTILLE_CITY_STATE_IN_CERTIFIED":true,"NOTARY_EXISTING_FILING":true,"ALLOW_REVOKE_OWN_ACCESS_ONLY":false,"HIDE_CANCEL_ON_ONETIME_DATA_REQUESTS":true,"DATA_REQUESTS_IN_SHOPPING_CART":true,"WQ_ALLOW_EDIT_PENDING_PAYMENT":true,"WQ_CONFIRM_ON_DELETE":true,"WQ_DELETE_CONFIRM_MESSAGE":"Deleting this filing will forfeit any money already paid to the Secretary of State. This action is permanent and cannot be undone, are you sure you would like to delete?","PASS_ITEM_GUIDS_ON_CHECKOUT":true,"FORM_REVISION_HISTORY":true,"CHECKOUT_DISCLAIMER":"By entering your credit card and/or checking account information you (i) state that **you are an authorized user** of the credit card and/or electronic check and that the associated information entered (e.g., account holder name, account number, billing address) is accurate, (ii) **you authorize payment processor to charge the amount you have requested** to your credit card and/or funding account, and (iii) **acknowledge if a charge is declined or reversed you may also be assessed a customary charge** by the payment processor for such transactions.","FARM_BILL_SEARCH_CONFIDENTIAL":"As a registered Farm Bill Buyer with the Montana Secretary of State’s office it is important to maintain the confidentiality of the information contained within the Farm Bill Master List. The Farm Bill Master List reflects personal data, such as Social Security Numbers, which are a key piece of personal identifiable information to assist you in determining the existence of a lien against a specific debtor. The distribution of this information beyond its intended purpose is strictly prohibited.\n\n**The debtor's tax identification number has been hidden for confidentiality reasons. You may continue to search on a tax ID number and return debtors that match your search criteria. The SSN/FEIN must be entered without dashes or spaces.  If you need access to the tax identification number to clearly identify the debtor, please contact the UCC unit at (406) 444-3665.**","VIEW_HISTORY_BUTTON_ALT_TEXT":"View Filings","WIZARD_ERROR_TITLE_MESSAGE":"Form Error","FARM_BILL_SEARCH_INTERACTIVE":true,"USE_FARM_BILL_API":true,"DISALLOW_ASSIGN_SELF_AS_RA":true,"DISALLOW_ASSIGN_SELF_AS_PRINCIPAL":true,"USE_TRADEMARK_OWNER_VALIDATION":true,"USE_ALTERNATIVE_FOREIGN_ADDRESS_LABELS":true,"MY_RECEIPTS_FILTER":[{"type":"dateRange","name":"DATE_RANGE","label":"Date range","defaultValue":{"start":null,"end":null}},{"type":"text","name":"REF_NUM","defaultValue":"","label":"Reference Number"},{"type":"text","name":"RECEIPT_NUM","defaultValue":"","label":"Receipt Id"},{"type":"text","name":"AMOUNT","defaultValue":"","label":"Amount"},{"type":"select","name":"TYPE","defaultValue":"","label":"Payment Type","options":[{"value":"","label":"All"},{"value":"CC","label":"Credit Card"},{"value":"Check","label":"Check"}]}],"MY_RECEIPTS_SHOW_IN_SIDEBAR":true,"SHOW_MY_RECEIPTS_HELPER_TEXT":true,"MY_RECEIPTS_HELPER_LABEL":"About Receipt Search","MY_RECEIPTS_HELPER_TEXT":"You can search for receipts based on their descriptions, including the items paid for on the receipt. Use the filters to search for or filter specific information.","FARM_BILL_SUBLINK":{"label":"Farm Bill","component":"FarmBill","parameter":"farm-bill","path":"/lists/farm-bill","sourceTypeId":0,"myRecordsSearch":false,"allowedRules":["/search/"],"disabled":true,"searchDescription":"To perform a search, enter a debtor name. Your search results may include: exact debtor name, variations of that name and any filing that includes your search criteria. Punctuation is ignored.\n\nYou can click on \"Advanced\" to refine your search. Under “Advanced” you can search by crop, year, county and SSN/FEIN. As a registered Farm Bill Buyer with the Montana Secretary of State’s office it is important to maintain the confidentiality of the information contained within the Farm Bill Master List. The Farm Bill Master List reflects personal data, such as Social Security Numbers, which are a key piece of personal identifiable information to assist you in determining the existence of a lien against a specific debtor. The distribution of this information beyond its intended purpose is strictly prohibited.\n\nThe debtor's tax identification number has been hidden for confidentiality reasons. You may continue to search on a tax ID number and return debtors that match your search criteria. The SSN/FEIN must be entered without dashes or spaces.","searchMustHaveOneOf":["search","UCC_FARM_PRODUCT_ID","COUNTY"],"searchPlaceholder":"Search by debtor name","advancedSearchParameters":[{"type":"ServerMultiComplete","label":"Product code name(s)","name":"UCC_FARM_PRODUCT_ID","defaultValue":"","optionsSrc":"UCC_FARM_PRODUCT_V"},{"type":"MultiComplete","label":"Year or Range of Years","name":"YEAR_NUM","optionsSrc":"years","startYear":"1968","defaultValue":[],"preMergeOptions":[{"value":"ALL","label":"All"}]},{"type":"serverSelect","label":"State","name":"STATE","defaultValue":"MONTANA","optionsSrc":"STATE"},{"type":"ServerMultiComplete","label":"County","name":"COUNTY","defaultValue":[],"optionsSrc":"COUNTY","overrideSubOptionsSrcFromParameterName":"STATE"},{"type":"checkbox","name":"TIN_SEARCH_YN","defaultValue":false,"label":"Tax Identification Number Search"},{"type":"checkbox","name":"TIN_SORT_YN","defaultValue":false,"label":"Unique ID Sort"}]},"ALLOW_ADDRESS_VALIDATION_BYPASS_OPTION":true,"DEFAULT_ADDRESS_VALIDATION_BYPASS_OPTION_CHECKED":true}).ALLOW_EMPTY_COUNTRY ? value.COUNTRY : value.COUNTRY || 'United States', 'United States'),
	    POSTAL_CODE: (0, _utilities.coerceType)(value.POSTAL_CODE || '', '')
	  };
	};
	
	var AddressBlock = exports.AddressBlock = function (_Field10) {
	  _inherits(AddressBlock, _Field10);
	
	  function AddressBlock() {
	    var block = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	    _classCallCheck(this, AddressBlock);
	
	    var _this14 = _possibleConstructorReturn(this, (AddressBlock.__proto__ || Object.getPrototypeOf(AddressBlock)).call(this, block));
	
	    _this14.type = 'addressBlock';
	    _this14.fieldClass = 'AddressBlock';
	    _this14.label = block.label || 'Address';
	    _this14.value = block.value ? getAddressObject(block.value) : getAddressObject();
	    if (_this14.value.COUNTRY === '' && !({"NODE_ENV":"production","BUILD_DATE":"2025-08-27T15:15:31.687Z","BUILD_NUMBER":"Not Provided","GIT_VERSION":"v1.3.0-381-ga81e29b08","GIT_COMMIT_HASH":"a81e29b085c9268ffd96c78eb734365802722741","GIT_BRANCH":"beta","PUBLIC_URL":"","STATE_ABBR":"MT","STATE_NAME":"Montana","STATE_ORG_TITLE":"Secretary of State","LOGIN_HEADER_IMG_PATH":"","HOME_IMG_FILENAME":"montana.jpg","FAVICON_FILE_NAME":"favicon.ico","ALLOW_E_SIGN_ON_CORRECTIONS":true,"THIRD_PARTY_SIGNING_ALLOWED":false,"MY_ACCOUNT_SAVE_AND_CLOSE_BUTTON":true,"IE_DEPRECATED_MESSAGE":"Internet Explorer is not supported. Please select a supported browser below to access this website.","ADDITIONAL_ROUTES":{"dataRequests":true,"farmBill":true,"apostille":true,"externalHelp":"https://sosmt.gov/business/help-center/","systemAdministration":[{"title":"Saved Payments","parameter":"saved-payments","componentName":"SavedPayments"}]},"SUBROUTES":[{"label":"Business","component":"Business","parameter":"business","myWorkQueueSearch":false,"sourceTypeId":54,"searchMustHaveOneOf":["FILING_TYPE_ID","STATUS_ID","STATE","search"],"serverWebSearchDescription":true,"serverWorkQueueDescription":true,"serverMyRecordsDescription":true,"searchPlaceholder":"Search by name or filing number (X########)","allowEmptySearchTerm":true,"requestCertificateAlternateLabel":"Request Information","fileAmendmentButtonLabel":"Filing Actions","advancedSearchParameters":[{"type":"radio","name":"QUERY_TYPE_ID","defaultValue":1010,"options":[{"value":1010,"label":"Starts with"},{"value":1011,"label":"Contains"},{"value":1012,"label":" Word Contains"}]},{"type":"serverSelect","name":"FILING_TYPE_ID","optionsSrc":"FILING_TYPES","label":"Entity Type","placeholder":"All","defaultValue":"0"},{"type":"serverSelect","name":"FILING_SUBTYPE_ID","optionsSrc":"FILING_SUBTYPES","label":"Entity Subtype","overrideSubOptionsSrcFromParameterName":"FILING_TYPE_ID","placeholder":"All","defaultValue":"0"},{"type":"serverSelect","name":"STATUS_ID","optionsSrc":"FILING_STATUS_WITHOUT_ALL","label":"Status","placeholder":"All","defaultValue":"0"},{"type":"serverSelect","name":"STATE","optionsSrc":"STATE","label":"State","placeholder":"All","defaultValue":""},{"type":"serverSelect","name":"COUNTY","optionsSrc":"COUNTY_SUBOPTION","label":"County","overrideSubOptionsSrcFromParameterName":"STATE","placeholder":"All","defaultValue":""},{"type":"checkbox","name":"CRA_SEARCH_YN","defaultValue":false,"label":"Search by Registered Agent PID"},{"type":"dateRange","name":"FILING_DATE","label":"Registration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}},{"type":"dateRange","name":"EXPIRATION_DATE","label":"Expiration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}}],"myRecordsFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Active"},{"value":2,"label":"Inactive"},{"value":3,"label":"Pending"}]},{"type":"dateRange","name":"DATE_RANGE","label":"Date range","defaultValue":{"start":null,"end":null}}],"myWorkQueueFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Approved"},{"value":2,"label":"Pending Online Payment"},{"value":3,"label":"Pending Review"},{"value":4,"label":"Needs Correction"},{"value":5,"label":"Rejected"},{"value":6,"label":"Draft"}]},{"type":"dateRange","name":"DATE_RANGE","label":"Date range","defaultValue":{"start":null,"end":null}}]},{"label":"Notary","component":"Notary","parameter":"notary","sourceTypeId":850,"myWorkQueueSearch":false,"allowEmptySearchTerm":true,"requestCertificateAlternateLabel":"Download Certificate","fileAmendmentButtonLabel":"Filing Actions","hideNameRequestCertificate":true,"hideAddressRequestCertificate":true,"hideRecordUserManagment":true,"searchPlaceholder":"Search by name or commission number","searchMustHaveOneOf":["CITY","search","SERVICE_TYPE"],"advancedParametersStartOpen":true,"searchIsSortable":true,"advancedSearchParameters":[{"type":"radio","name":"STARTS_WITH_YN","defaultValue":false,"options":[{"value":true,"label":"Starts with"},{"value":false,"label":"Contains"}]},{"type":"checkbox","name":"ACTIVE_ONLY_YN","defaultValue":true,"label":"Active entities only"},{"type":"text","name":"CITY","defaultValue":"","label":"City"},{"type":"select","name":"SERVICE_TYPE","label":"Special Services Offered","defaultValue":0,"options":[{"value":0,"label":"(N/A)"},{"value":6165,"label":"In-Person Electronic Notarization (IPEN)"},{"value":6166,"label":"Remote Online Notarization (RON)"},{"value":6167,"label":"Mobile Notary Services"},{"value":6168,"label":"Remote Ink Notarization (RIN)"}]}]},{"label":"Apostille","component":"Apostille","parameter":"apostille","sourceTypeId":720,"myRecordsSearch":false,"myWorkQueueSearch":false,"disabled":false,"allowedRoutes":["/forms-manager/","/queue/","/forms/"]},{"label":"Liens","component":"UCC","parameter":"ucc","sourceTypeId":1999,"myRecordsSearch":true,"myWorkQueueSearch":true,"fileAmendmentButtonLabel":"Filing Actions","searchPlaceholder":"Search by name or file number","disabled":false,"serverWebSearchDescription":true,"myRecordsDescription":"","workQueueDescription":"","searchDescription":"","hideRecordUserManagment":true,"searchLiensCheckout":false,"advancedSearchParameters":[{"type":"radio","name":"STARTS_WITH_YN","defaultValue":false,"options":[{"value":true,"label":"Starts with"},{"value":false,"label":"Contains"}]},{"type":"select","name":"STATUS","defaultValue":"ALL","label":"Status","options":[{"value":"ACTIVE_UNLAPSED","label":"Active (unlapsed)"},{"value":"ACTIVE_LAPSED_UNLAPSED","label":"Active (lapsed and unlapsed)"}]},{"type":"text","name":"EXCLUDE_VALUES","label":"Exclude Debtor Names (comma separated list of names to exclude)","defaultValue":""},{"type":"dateRange","name":"FILING_DATE","label":"Financing Statement Date","defaultValue":{"start":null,"end":null}},{"type":"dateRange","name":"LAPSE_DATE","label":"Lapse Date","defaultValue":{"start":null,"end":null}},{"type":"text","name":"CITY","label":"Debtor City","defaultValue":""}],"myRecordsFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Approved"},{"value":2,"label":"Pending Online Payment"},{"value":3,"label":"Pending Review"}]},{"type":"select","name":"TYPE","defaultValue":0,"label":"Lien Type","options":[{"value":0,"label":"All"},{"value":1,"label":"UCC"},{"value":2,"label":"EFS"},{"value":3,"label":"Title 71"}]}],"myWorkQueueFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Approved"},{"value":2,"label":"Pending Online Payment"},{"value":3,"label":"Pending Review"},{"value":4,"label":"Pending Print and Mail"},{"value":5,"label":"Rejected"},{"value":6,"label":"Draft"}]},{"type":"select","name":"TYPE","defaultValue":0,"label":"Lien Type","options":[{"value":0,"label":"All"},{"value":1,"label":"UCC"},{"value":2,"label":"EFS"},{"value":3,"label":"Title 71"}]}]},{"label":"Copy Request","component":"copies","parameter":"copies","sourceTypeId":2001,"myRecordsSearch":false,"myWorkQueueSearch":false,"disabled":false,"allowedRoutes":["/forms-manager/","/queue/","/forms/"]},{"label":"Trademark","component":"Trademark","parameter":"trademark","sourceTypeId":810,"showRequestCertificate":true,"searchMustHaveOneOf":["search","EXPIRATION_DATE","FILING_DATE"],"allowEmptySearchTerm":true,"requestCertificateAlternateLabel":"Request Information","fileAmendmentButtonLabel":"Filing Actions","advancedSearchParameters":[{"type":"radio","name":"QUERY_TYPE_ID","defaultValue":1010,"options":[{"value":1010,"label":"Starts with"},{"value":1011,"label":"Contains"},{"value":1012,"label":" Word Contains"}]},{"type":"checkbox","name":"OWNER_SEARCH_YN","defaultValue":false,"label":"Search owners"},{"type":"radio","name":"SERVICE_MARK_YN","label":"Mark Type","defaultValue":"","options":[{"value":"","label":"All Marks"},{"value":"Y","label":"Service Mark"},{"value":"N","label":"Trademark"}]},{"type":"serverSelect","name":"STATUS_ID","optionsSrc":"TYPE_V|TRADEMARK_STATUS_TYPE","label":"Status","placeholder":"All","defaultValue":"0"},{"type":"select","name":"DESIGN_TYPE_ID","options":[{"value":0,"label":"All"},{"value":990,"label":"Words Only"},{"value":991,"label":"Design Only"},{"value":992,"label":"Words and Design"}],"label":"Design Type","defaultValue":"0"},{"type":"dateRange","name":"FILING_DATE","label":"Registered Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}},{"type":"dateRange","name":"EXPIRATION_DATE","label":"Expiration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}}]},{"label":"Business Info Request","component":"InfoRequests","parameter":"info-request","sourceTypeId":167,"allowedRoutes":["/forms-manager/","/queue/","/forms/"]},{"label":"Data Requests","component":"DataRequests","parameter":"data-request","sourceTypeId":0,"allowedRoutes":["/forms-manager/"]},{"label":"CRA","component":"CRA","parameter":"cra","sourceTypeId":157,"myRecordsSearch":false,"searchPlaceholder":"Search by name or registered agent number","allowedRoutes":["/forms-manager/","/forms/","/records/","/queue/","/search/"],"allowEmptySearchTerm":true,"fileAmendmentButtonLabel":"Filing Actions","advancedSearchParameters":[{"type":"radio","name":"QUERY_TYPE_ID","defaultValue":1010,"options":[{"value":1010,"label":"Starts with"},{"value":1011,"label":"Contains"},{"value":1012,"label":" Word Contains"}]},{"type":"dateRange","name":"CRA_DATE","label":"Registration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}},{"type":"select","name":"STATUS_ID","label":"Status","defaultValue":0,"options":[{"value":0,"label":"All"},{"value":121,"label":"Active"},{"value":122,"label":"Inactive"}]},{"type":"select","name":"AGENT_TYPE_ID","label":"Agent Type","defaultValue":0,"options":[{"value":0,"label":"All"},{"value":460,"label":"Registered Agent"},{"value":461,"label":"Commercial Registered Agent"}]}]},{"label":"Farm Bill","component":"FarmBill","parameter":"farm-bill","path":"/lists/farm-bill","sourceTypeId":0,"myRecordsSearch":false,"allowedRules":["/search/"],"disabled":true,"searchDescription":"To perform a search, enter a debtor name. Your search results may include: exact debtor name, variations of that name and any filing that includes your search criteria. Punctuation is ignored.\n\nYou can click on \"Advanced\" to refine your search. Under “Advanced” you can search by crop, year, county and SSN/FEIN. As a registered Farm Bill Buyer with the Montana Secretary of State’s office it is important to maintain the confidentiality of the information contained within the Farm Bill Master List. The Farm Bill Master List reflects personal data, such as Social Security Numbers, which are a key piece of personal identifiable information to assist you in determining the existence of a lien against a specific debtor. The distribution of this information beyond its intended purpose is strictly prohibited.\n\nThe debtor's tax identification number has been hidden for confidentiality reasons. You may continue to search on a tax ID number and return debtors that match your search criteria. The SSN/FEIN must be entered without dashes or spaces.","searchMustHaveOneOf":["search","UCC_FARM_PRODUCT_ID","COUNTY"],"searchPlaceholder":"Search by debtor name","advancedSearchParameters":[{"type":"ServerMultiComplete","label":"Product code name(s)","name":"UCC_FARM_PRODUCT_ID","defaultValue":"","optionsSrc":"UCC_FARM_PRODUCT_V"},{"type":"MultiComplete","label":"Year or Range of Years","name":"YEAR_NUM","optionsSrc":"years","startYear":"1968","defaultValue":[],"preMergeOptions":[{"value":"ALL","label":"All"}]},{"type":"serverSelect","label":"State","name":"STATE","defaultValue":"MONTANA","optionsSrc":"STATE"},{"type":"ServerMultiComplete","label":"County","name":"COUNTY","defaultValue":[],"optionsSrc":"COUNTY","overrideSubOptionsSrcFromParameterName":"STATE"},{"type":"checkbox","name":"TIN_SEARCH_YN","defaultValue":false,"label":"Tax Identification Number Search"},{"type":"checkbox","name":"TIN_SORT_YN","defaultValue":false,"label":"Unique ID Sort"}]}],"SYSTEM_NICKNAME":"Online Services Portal","PAYMENT_METHODS":[{"type":"bypass"},{"type":"iTransact"}],"PAYMENT_ALLOW_AMEX":true,"SYSTEM_ID_LABEL":"System Id","DOUBLE_COLUMN_PUBLIC_LOGIN":true,"INTERNAL_USER_MANAGEMENT":true,"ALLOW_PUBLIC_JSON_IMPORT":false,"MAX_FILE_UPLOAD_SIZE":10000000,"REFUND_TEXT":"","RETURN_TO_HOME_ON_LOGOUT":true,"CURRENT_SOS_NAME":"Christi Jacobsen","LOGO_FILENAME":"mt-sos-logo.png","LOGO_ALT":"Christi Jacobsen, Montana Secretary of State","LOGO_FULL_WIDTH":true,"HOME_HIDE_AUTH_HINT":true,"HOME_TITLE":"Montana Secretary of State","CUSTOM_TAB_TITLE":"Official Montana","HOME_SUBTITLE":"Online Business Services","ENTITY_NAME_CONSENT_DESCRIPTION":"","ALLOW_USER_PROFILE_EDITING":true,"COMPARE_FOREIGN_NAME_IN_ENTITY_NAME_VALIDATION":true,"FOREIGN_NAME_FIELD_NAME":"KIMA_PARENT_NAME_INFO","LOGIN_TITLE":"Montana Secretary of State Online Filing Portal Login","PUBLIC_LOGIN_LABEL":"Username","REVERSE_LOGIN_COLUMNS":true,"LOGIN_SEAL_FILENAME":"seal_white.png","SEPARATE_USERNAME_AND_EMAIL":true,"CREATE_ACCOUNT_BUTTON_ALIGN_LEFT":true,"CREATE_ACCOUNT_BUTTON_TEXT":"CREATE AN ACCOUNT","PASSWORD_CUSTOM_ERROR_TEXT":"The password must meet all requirements","ACCOUNT_CREATED_MESSAGE":"Please check your email to verify your account to login and allow a few minutes for this message to arrive. Check your junk/spam folders if you do not find the email in your inbox.","PUBLIC_LOGIN_PLACEHOLDER":" ","DISABLE_DEFAULT_PAYMENT_RADIO":true,"CUSTOM_RESET_PASSWORD_ERROR_MESSAGE":"Username invalid - no account found","PUBLIC_LOGIN_CREATE_DESCRIPTION":"### Existing User:\n\n  - Enter your username and password to login.  \n\n\n  #### - OR -  \n\n\n\n  - Forgot password? Click 'Reset Password' and follow the prompts.\n  - Forgot username? Click 'Forgot Username' and follow the prompts.  \n\n\n  ### New User:\n  ","LOGIN_HELP_LINK":"https://sosmt.gov/business/how-do-i/","LOGIN_HELP_LINK_TEXT":"Need Help?","FORGOT_USERNAME_TEXT":"Forgot Username?","LOGIN_ACTIVE_DIRECTORY_TEXT":"State User Login","MULTIPLE_LOGIN_METHODS":true,"HAS_ACTIVE_DIRECTORY_LOGIN":true,"RESET_PASSWORD_WITH_USERNAME":true,"DOWNLOAD_LINK":true,"SHOW_USERNAME_ACCOUNT_CREATE":true,"SHOW_SCROLL_DOWN_ARROW":true,"SHOW_ADDRESS_ACCOUNT_CREATE":true,"TWO_COLUMN_ACCOUNT_CREATE":true,"RESET_PASSWORD_TIP":"A link to change your password has been sent to your email. Please allow a few minutes for this message to arrive. Please check your junk/spam folders if you do not find the email in your inbox.","FORGOT_PASSWORD_LINK_TEXT":"Reset Password","PHONE_NUMBER_OPTIONAL_ACCOUNT_CREATE":true,"SHOW_REQUIRED_INDICATOR_ACCOUNT_CREATE":true,"PASSWORD_REQUIREMENTS_ACCOUNT_CREATE":"\n    <ul>\n      <li>MUST contain at least 8 characters (12+ recommended)</li>\n      <li>MUST contain at least one uppercase letter.</li>\n      <li>MUST contain at least one lowercase letter.</li>\n      <li>MUST contain at least one number.</li>\n      <li>MUST contain at least one special character (!”#$%&'()*+,-./:;<=>?</li>\n    </ul>\n  ","ALLOW_CERTIFICATION_REQUEST":true,"ALLOW_PUBLIC_CERTIFICATE_REQUEST":true,"ALLOW_COPY_REQUEST":false,"ALLOW_CORRECTION_STYLING":true,"HIDE_DEPRECATION_WARNING":false,"AMEND_ROUTE_PUBLIC":true,"SEAL_FILENAME":"seal.png","SHOPPING_CART":true,"ALLOW_PAYMENT_UPDATE_WITH_EMPTY_CART":true,"RA_EMAIL":true,"RA_WEBSITE":true,"RA_NO_DEFAULT_TYPE":true,"RA_ADDRESS_LABEL":"Street Address","RA_TYPE_SELECTION_DEFAULT":true,"RA_DEFAULT_TYPE":"460","RA_OVERRIDE_TYPE_WITH_DEFAULT":true,"RA_PRINCIPAL_ADDRESS_AMS":true,"UPLOAD_AND_SUBMIT_HIDE_IF_ONE_OPTION":true,"PAYMENT_PROCESSING_MESSAGE":"Your payment is processing - Do not close your browser or click the back button","CHECKOUT_BUTTON_WHEN_PROCESSING_TEXT":"Processing","EFS_CROP_PICKER_NONE_LABEL":"Lien Duration","DISALLOWED_WIZARD_PIECES":["FormationLocale"],"REPEATER_SHOW_EDIT_BUTTON":true,"DATA_REQUEST_PAGE_TITLE":"Data Requests and Subscriptions","DATA_REQUEST_SIDEBAR_LABEL":"Data Requests & Subscriptions","LOGIN_REDIRECTS_TO_EPASS":false,"LOGIN_REDIRECTS_TO_ACTIVE_DIRECTORY":true,"LOGIN_ACTIVE_DIRECTORY_LINK":true,"FETCH_EDIT_USER_LINK":false,"LISTS_FETCH_AVAILABLE_LISTS":true,"POST_WIZARD_SUBMIT_REDIRECT_URL":"/","PIN_REQUEST_ATTESTATIONS":true,"PIN_REQUEST_DESCRIPTION":"Click **Request PIN** to have a new PIN sent to the account holder's email address on file.","OWNERSHIP_REQUEST_DESCRIPTION":"To become an **authorized user** of this record, a current **AUTHORIZED USER** will need to grant you access. To request access, click **Request Access** below.","PIN_REQUEST_SUCCESS_MESSAGE":"The PIN you have requested for this entity has been sent to the email associated with your user account.  You should receive the PIN in approximately 3-5 minutes, depending on your email service provider.","APOSTILLE_HEADER_LABEL":"Verification Information","APOSTILLE_NUMBER_LABEL":"Apostille/Authentication","APOSTILLE_CITY_STATE_OVERRIDE":"HELENA, MT","APOSTILLE_FILING_DATE_LABEL":"Issue Date","APOSTILLE_CITY_STATE_IN_CERTIFIED":true,"NOTARY_EXISTING_FILING":true,"ALLOW_REVOKE_OWN_ACCESS_ONLY":false,"HIDE_CANCEL_ON_ONETIME_DATA_REQUESTS":true,"DATA_REQUESTS_IN_SHOPPING_CART":true,"WQ_ALLOW_EDIT_PENDING_PAYMENT":true,"WQ_CONFIRM_ON_DELETE":true,"WQ_DELETE_CONFIRM_MESSAGE":"Deleting this filing will forfeit any money already paid to the Secretary of State. This action is permanent and cannot be undone, are you sure you would like to delete?","PASS_ITEM_GUIDS_ON_CHECKOUT":true,"FORM_REVISION_HISTORY":true,"CHECKOUT_DISCLAIMER":"By entering your credit card and/or checking account information you (i) state that **you are an authorized user** of the credit card and/or electronic check and that the associated information entered (e.g., account holder name, account number, billing address) is accurate, (ii) **you authorize payment processor to charge the amount you have requested** to your credit card and/or funding account, and (iii) **acknowledge if a charge is declined or reversed you may also be assessed a customary charge** by the payment processor for such transactions.","FARM_BILL_SEARCH_CONFIDENTIAL":"As a registered Farm Bill Buyer with the Montana Secretary of State’s office it is important to maintain the confidentiality of the information contained within the Farm Bill Master List. The Farm Bill Master List reflects personal data, such as Social Security Numbers, which are a key piece of personal identifiable information to assist you in determining the existence of a lien against a specific debtor. The distribution of this information beyond its intended purpose is strictly prohibited.\n\n**The debtor's tax identification number has been hidden for confidentiality reasons. You may continue to search on a tax ID number and return debtors that match your search criteria. The SSN/FEIN must be entered without dashes or spaces.  If you need access to the tax identification number to clearly identify the debtor, please contact the UCC unit at (406) 444-3665.**","VIEW_HISTORY_BUTTON_ALT_TEXT":"View Filings","WIZARD_ERROR_TITLE_MESSAGE":"Form Error","FARM_BILL_SEARCH_INTERACTIVE":true,"USE_FARM_BILL_API":true,"DISALLOW_ASSIGN_SELF_AS_RA":true,"DISALLOW_ASSIGN_SELF_AS_PRINCIPAL":true,"USE_TRADEMARK_OWNER_VALIDATION":true,"USE_ALTERNATIVE_FOREIGN_ADDRESS_LABELS":true,"MY_RECEIPTS_FILTER":[{"type":"dateRange","name":"DATE_RANGE","label":"Date range","defaultValue":{"start":null,"end":null}},{"type":"text","name":"REF_NUM","defaultValue":"","label":"Reference Number"},{"type":"text","name":"RECEIPT_NUM","defaultValue":"","label":"Receipt Id"},{"type":"text","name":"AMOUNT","defaultValue":"","label":"Amount"},{"type":"select","name":"TYPE","defaultValue":"","label":"Payment Type","options":[{"value":"","label":"All"},{"value":"CC","label":"Credit Card"},{"value":"Check","label":"Check"}]}],"MY_RECEIPTS_SHOW_IN_SIDEBAR":true,"SHOW_MY_RECEIPTS_HELPER_TEXT":true,"MY_RECEIPTS_HELPER_LABEL":"About Receipt Search","MY_RECEIPTS_HELPER_TEXT":"You can search for receipts based on their descriptions, including the items paid for on the receipt. Use the filters to search for or filter specific information.","FARM_BILL_SUBLINK":{"label":"Farm Bill","component":"FarmBill","parameter":"farm-bill","path":"/lists/farm-bill","sourceTypeId":0,"myRecordsSearch":false,"allowedRules":["/search/"],"disabled":true,"searchDescription":"To perform a search, enter a debtor name. Your search results may include: exact debtor name, variations of that name and any filing that includes your search criteria. Punctuation is ignored.\n\nYou can click on \"Advanced\" to refine your search. Under “Advanced” you can search by crop, year, county and SSN/FEIN. As a registered Farm Bill Buyer with the Montana Secretary of State’s office it is important to maintain the confidentiality of the information contained within the Farm Bill Master List. The Farm Bill Master List reflects personal data, such as Social Security Numbers, which are a key piece of personal identifiable information to assist you in determining the existence of a lien against a specific debtor. The distribution of this information beyond its intended purpose is strictly prohibited.\n\nThe debtor's tax identification number has been hidden for confidentiality reasons. You may continue to search on a tax ID number and return debtors that match your search criteria. The SSN/FEIN must be entered without dashes or spaces.","searchMustHaveOneOf":["search","UCC_FARM_PRODUCT_ID","COUNTY"],"searchPlaceholder":"Search by debtor name","advancedSearchParameters":[{"type":"ServerMultiComplete","label":"Product code name(s)","name":"UCC_FARM_PRODUCT_ID","defaultValue":"","optionsSrc":"UCC_FARM_PRODUCT_V"},{"type":"MultiComplete","label":"Year or Range of Years","name":"YEAR_NUM","optionsSrc":"years","startYear":"1968","defaultValue":[],"preMergeOptions":[{"value":"ALL","label":"All"}]},{"type":"serverSelect","label":"State","name":"STATE","defaultValue":"MONTANA","optionsSrc":"STATE"},{"type":"ServerMultiComplete","label":"County","name":"COUNTY","defaultValue":[],"optionsSrc":"COUNTY","overrideSubOptionsSrcFromParameterName":"STATE"},{"type":"checkbox","name":"TIN_SEARCH_YN","defaultValue":false,"label":"Tax Identification Number Search"},{"type":"checkbox","name":"TIN_SORT_YN","defaultValue":false,"label":"Unique ID Sort"}]},"ALLOW_ADDRESS_VALIDATION_BYPASS_OPTION":true,"DEFAULT_ADDRESS_VALIDATION_BYPASS_OPTION_CHECKED":true}).ALLOW_EMPTY_COUNTRY) _this14.value.COUNTRY = 'United States';
	    _this14.showCityStateZip = block.showCityStateZip === false ? false : true;
	    _this14.showCounty = block.showCounty === true ? true : false;
	    _this14.showCountry = block.showCountry === true ? true : false;
	    _this14.disableState = block.disableState === true ? true : false;
	    _this14.disableCountry = block.disableCountry === true ? true : false;
	    _this14.hideAttention = block.hideAttention === true ? true : false;
	    _this14.feedback = block.feedback || null;
	    _this14.bubbleEvents = true;
	    _this14.hideLabel = true;
	    _this14.defaultState = block.defaultState || '';
	    _this14.allowedRules = ['addressIsRequired', 'addressIsValid', 'partialAddressNotAllowed', 'poBoxNotAllowed', 'checkForRegulatedWords', 'customBusinessRules'];
	    _this14.allowedMasks = ['addressUpperCase'];
	    _this14.allowedRepeaterConstraints = ['atLeastSomeStateMustBe'];
	    _this14.autoPopulateFromAMS = block.autoPopulateFromAMS || false;
	    _this14.excludeCurrentState = block.excludeCurrentState || false;
	    _this14.bypassMessage = block.bypassMessage || null;
	    _this14.primarybypassMessage = block.primarybypassMessage || null;
	    _this14.mailbypassMessage = block.mailbypassMessage || null;
	    return _this14;
	  }
	
	  _createClass(AddressBlock, [{
	    key: 'formatAddress',
	    value: function formatAddress(value, field) {
	      var country = (0, _selectOptions.getCountryOptions)().find(function (option) {
	        return option.value === value.COUNTRY;
	      });
	      var DISPLAY_FULL_FOREIGN_ADDR = ({"NODE_ENV":"production","BUILD_DATE":"2025-08-27T15:15:31.687Z","BUILD_NUMBER":"Not Provided","GIT_VERSION":"v1.3.0-381-ga81e29b08","GIT_COMMIT_HASH":"a81e29b085c9268ffd96c78eb734365802722741","GIT_BRANCH":"beta","PUBLIC_URL":"","STATE_ABBR":"MT","STATE_NAME":"Montana","STATE_ORG_TITLE":"Secretary of State","LOGIN_HEADER_IMG_PATH":"","HOME_IMG_FILENAME":"montana.jpg","FAVICON_FILE_NAME":"favicon.ico","ALLOW_E_SIGN_ON_CORRECTIONS":true,"THIRD_PARTY_SIGNING_ALLOWED":false,"MY_ACCOUNT_SAVE_AND_CLOSE_BUTTON":true,"IE_DEPRECATED_MESSAGE":"Internet Explorer is not supported. Please select a supported browser below to access this website.","ADDITIONAL_ROUTES":{"dataRequests":true,"farmBill":true,"apostille":true,"externalHelp":"https://sosmt.gov/business/help-center/","systemAdministration":[{"title":"Saved Payments","parameter":"saved-payments","componentName":"SavedPayments"}]},"SUBROUTES":[{"label":"Business","component":"Business","parameter":"business","myWorkQueueSearch":false,"sourceTypeId":54,"searchMustHaveOneOf":["FILING_TYPE_ID","STATUS_ID","STATE","search"],"serverWebSearchDescription":true,"serverWorkQueueDescription":true,"serverMyRecordsDescription":true,"searchPlaceholder":"Search by name or filing number (X########)","allowEmptySearchTerm":true,"requestCertificateAlternateLabel":"Request Information","fileAmendmentButtonLabel":"Filing Actions","advancedSearchParameters":[{"type":"radio","name":"QUERY_TYPE_ID","defaultValue":1010,"options":[{"value":1010,"label":"Starts with"},{"value":1011,"label":"Contains"},{"value":1012,"label":" Word Contains"}]},{"type":"serverSelect","name":"FILING_TYPE_ID","optionsSrc":"FILING_TYPES","label":"Entity Type","placeholder":"All","defaultValue":"0"},{"type":"serverSelect","name":"FILING_SUBTYPE_ID","optionsSrc":"FILING_SUBTYPES","label":"Entity Subtype","overrideSubOptionsSrcFromParameterName":"FILING_TYPE_ID","placeholder":"All","defaultValue":"0"},{"type":"serverSelect","name":"STATUS_ID","optionsSrc":"FILING_STATUS_WITHOUT_ALL","label":"Status","placeholder":"All","defaultValue":"0"},{"type":"serverSelect","name":"STATE","optionsSrc":"STATE","label":"State","placeholder":"All","defaultValue":""},{"type":"serverSelect","name":"COUNTY","optionsSrc":"COUNTY_SUBOPTION","label":"County","overrideSubOptionsSrcFromParameterName":"STATE","placeholder":"All","defaultValue":""},{"type":"checkbox","name":"CRA_SEARCH_YN","defaultValue":false,"label":"Search by Registered Agent PID"},{"type":"dateRange","name":"FILING_DATE","label":"Registration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}},{"type":"dateRange","name":"EXPIRATION_DATE","label":"Expiration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}}],"myRecordsFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Active"},{"value":2,"label":"Inactive"},{"value":3,"label":"Pending"}]},{"type":"dateRange","name":"DATE_RANGE","label":"Date range","defaultValue":{"start":null,"end":null}}],"myWorkQueueFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Approved"},{"value":2,"label":"Pending Online Payment"},{"value":3,"label":"Pending Review"},{"value":4,"label":"Needs Correction"},{"value":5,"label":"Rejected"},{"value":6,"label":"Draft"}]},{"type":"dateRange","name":"DATE_RANGE","label":"Date range","defaultValue":{"start":null,"end":null}}]},{"label":"Notary","component":"Notary","parameter":"notary","sourceTypeId":850,"myWorkQueueSearch":false,"allowEmptySearchTerm":true,"requestCertificateAlternateLabel":"Download Certificate","fileAmendmentButtonLabel":"Filing Actions","hideNameRequestCertificate":true,"hideAddressRequestCertificate":true,"hideRecordUserManagment":true,"searchPlaceholder":"Search by name or commission number","searchMustHaveOneOf":["CITY","search","SERVICE_TYPE"],"advancedParametersStartOpen":true,"searchIsSortable":true,"advancedSearchParameters":[{"type":"radio","name":"STARTS_WITH_YN","defaultValue":false,"options":[{"value":true,"label":"Starts with"},{"value":false,"label":"Contains"}]},{"type":"checkbox","name":"ACTIVE_ONLY_YN","defaultValue":true,"label":"Active entities only"},{"type":"text","name":"CITY","defaultValue":"","label":"City"},{"type":"select","name":"SERVICE_TYPE","label":"Special Services Offered","defaultValue":0,"options":[{"value":0,"label":"(N/A)"},{"value":6165,"label":"In-Person Electronic Notarization (IPEN)"},{"value":6166,"label":"Remote Online Notarization (RON)"},{"value":6167,"label":"Mobile Notary Services"},{"value":6168,"label":"Remote Ink Notarization (RIN)"}]}]},{"label":"Apostille","component":"Apostille","parameter":"apostille","sourceTypeId":720,"myRecordsSearch":false,"myWorkQueueSearch":false,"disabled":false,"allowedRoutes":["/forms-manager/","/queue/","/forms/"]},{"label":"Liens","component":"UCC","parameter":"ucc","sourceTypeId":1999,"myRecordsSearch":true,"myWorkQueueSearch":true,"fileAmendmentButtonLabel":"Filing Actions","searchPlaceholder":"Search by name or file number","disabled":false,"serverWebSearchDescription":true,"myRecordsDescription":"","workQueueDescription":"","searchDescription":"","hideRecordUserManagment":true,"searchLiensCheckout":false,"advancedSearchParameters":[{"type":"radio","name":"STARTS_WITH_YN","defaultValue":false,"options":[{"value":true,"label":"Starts with"},{"value":false,"label":"Contains"}]},{"type":"select","name":"STATUS","defaultValue":"ALL","label":"Status","options":[{"value":"ACTIVE_UNLAPSED","label":"Active (unlapsed)"},{"value":"ACTIVE_LAPSED_UNLAPSED","label":"Active (lapsed and unlapsed)"}]},{"type":"text","name":"EXCLUDE_VALUES","label":"Exclude Debtor Names (comma separated list of names to exclude)","defaultValue":""},{"type":"dateRange","name":"FILING_DATE","label":"Financing Statement Date","defaultValue":{"start":null,"end":null}},{"type":"dateRange","name":"LAPSE_DATE","label":"Lapse Date","defaultValue":{"start":null,"end":null}},{"type":"text","name":"CITY","label":"Debtor City","defaultValue":""}],"myRecordsFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Approved"},{"value":2,"label":"Pending Online Payment"},{"value":3,"label":"Pending Review"}]},{"type":"select","name":"TYPE","defaultValue":0,"label":"Lien Type","options":[{"value":0,"label":"All"},{"value":1,"label":"UCC"},{"value":2,"label":"EFS"},{"value":3,"label":"Title 71"}]}],"myWorkQueueFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Approved"},{"value":2,"label":"Pending Online Payment"},{"value":3,"label":"Pending Review"},{"value":4,"label":"Pending Print and Mail"},{"value":5,"label":"Rejected"},{"value":6,"label":"Draft"}]},{"type":"select","name":"TYPE","defaultValue":0,"label":"Lien Type","options":[{"value":0,"label":"All"},{"value":1,"label":"UCC"},{"value":2,"label":"EFS"},{"value":3,"label":"Title 71"}]}]},{"label":"Copy Request","component":"copies","parameter":"copies","sourceTypeId":2001,"myRecordsSearch":false,"myWorkQueueSearch":false,"disabled":false,"allowedRoutes":["/forms-manager/","/queue/","/forms/"]},{"label":"Trademark","component":"Trademark","parameter":"trademark","sourceTypeId":810,"showRequestCertificate":true,"searchMustHaveOneOf":["search","EXPIRATION_DATE","FILING_DATE"],"allowEmptySearchTerm":true,"requestCertificateAlternateLabel":"Request Information","fileAmendmentButtonLabel":"Filing Actions","advancedSearchParameters":[{"type":"radio","name":"QUERY_TYPE_ID","defaultValue":1010,"options":[{"value":1010,"label":"Starts with"},{"value":1011,"label":"Contains"},{"value":1012,"label":" Word Contains"}]},{"type":"checkbox","name":"OWNER_SEARCH_YN","defaultValue":false,"label":"Search owners"},{"type":"radio","name":"SERVICE_MARK_YN","label":"Mark Type","defaultValue":"","options":[{"value":"","label":"All Marks"},{"value":"Y","label":"Service Mark"},{"value":"N","label":"Trademark"}]},{"type":"serverSelect","name":"STATUS_ID","optionsSrc":"TYPE_V|TRADEMARK_STATUS_TYPE","label":"Status","placeholder":"All","defaultValue":"0"},{"type":"select","name":"DESIGN_TYPE_ID","options":[{"value":0,"label":"All"},{"value":990,"label":"Words Only"},{"value":991,"label":"Design Only"},{"value":992,"label":"Words and Design"}],"label":"Design Type","defaultValue":"0"},{"type":"dateRange","name":"FILING_DATE","label":"Registered Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}},{"type":"dateRange","name":"EXPIRATION_DATE","label":"Expiration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}}]},{"label":"Business Info Request","component":"InfoRequests","parameter":"info-request","sourceTypeId":167,"allowedRoutes":["/forms-manager/","/queue/","/forms/"]},{"label":"Data Requests","component":"DataRequests","parameter":"data-request","sourceTypeId":0,"allowedRoutes":["/forms-manager/"]},{"label":"CRA","component":"CRA","parameter":"cra","sourceTypeId":157,"myRecordsSearch":false,"searchPlaceholder":"Search by name or registered agent number","allowedRoutes":["/forms-manager/","/forms/","/records/","/queue/","/search/"],"allowEmptySearchTerm":true,"fileAmendmentButtonLabel":"Filing Actions","advancedSearchParameters":[{"type":"radio","name":"QUERY_TYPE_ID","defaultValue":1010,"options":[{"value":1010,"label":"Starts with"},{"value":1011,"label":"Contains"},{"value":1012,"label":" Word Contains"}]},{"type":"dateRange","name":"CRA_DATE","label":"Registration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}},{"type":"select","name":"STATUS_ID","label":"Status","defaultValue":0,"options":[{"value":0,"label":"All"},{"value":121,"label":"Active"},{"value":122,"label":"Inactive"}]},{"type":"select","name":"AGENT_TYPE_ID","label":"Agent Type","defaultValue":0,"options":[{"value":0,"label":"All"},{"value":460,"label":"Registered Agent"},{"value":461,"label":"Commercial Registered Agent"}]}]},{"label":"Farm Bill","component":"FarmBill","parameter":"farm-bill","path":"/lists/farm-bill","sourceTypeId":0,"myRecordsSearch":false,"allowedRules":["/search/"],"disabled":true,"searchDescription":"To perform a search, enter a debtor name. Your search results may include: exact debtor name, variations of that name and any filing that includes your search criteria. Punctuation is ignored.\n\nYou can click on \"Advanced\" to refine your search. Under “Advanced” you can search by crop, year, county and SSN/FEIN. As a registered Farm Bill Buyer with the Montana Secretary of State’s office it is important to maintain the confidentiality of the information contained within the Farm Bill Master List. The Farm Bill Master List reflects personal data, such as Social Security Numbers, which are a key piece of personal identifiable information to assist you in determining the existence of a lien against a specific debtor. The distribution of this information beyond its intended purpose is strictly prohibited.\n\nThe debtor's tax identification number has been hidden for confidentiality reasons. You may continue to search on a tax ID number and return debtors that match your search criteria. The SSN/FEIN must be entered without dashes or spaces.","searchMustHaveOneOf":["search","UCC_FARM_PRODUCT_ID","COUNTY"],"searchPlaceholder":"Search by debtor name","advancedSearchParameters":[{"type":"ServerMultiComplete","label":"Product code name(s)","name":"UCC_FARM_PRODUCT_ID","defaultValue":"","optionsSrc":"UCC_FARM_PRODUCT_V"},{"type":"MultiComplete","label":"Year or Range of Years","name":"YEAR_NUM","optionsSrc":"years","startYear":"1968","defaultValue":[],"preMergeOptions":[{"value":"ALL","label":"All"}]},{"type":"serverSelect","label":"State","name":"STATE","defaultValue":"MONTANA","optionsSrc":"STATE"},{"type":"ServerMultiComplete","label":"County","name":"COUNTY","defaultValue":[],"optionsSrc":"COUNTY","overrideSubOptionsSrcFromParameterName":"STATE"},{"type":"checkbox","name":"TIN_SEARCH_YN","defaultValue":false,"label":"Tax Identification Number Search"},{"type":"checkbox","name":"TIN_SORT_YN","defaultValue":false,"label":"Unique ID Sort"}]}],"SYSTEM_NICKNAME":"Online Services Portal","PAYMENT_METHODS":[{"type":"bypass"},{"type":"iTransact"}],"PAYMENT_ALLOW_AMEX":true,"SYSTEM_ID_LABEL":"System Id","DOUBLE_COLUMN_PUBLIC_LOGIN":true,"INTERNAL_USER_MANAGEMENT":true,"ALLOW_PUBLIC_JSON_IMPORT":false,"MAX_FILE_UPLOAD_SIZE":10000000,"REFUND_TEXT":"","RETURN_TO_HOME_ON_LOGOUT":true,"CURRENT_SOS_NAME":"Christi Jacobsen","LOGO_FILENAME":"mt-sos-logo.png","LOGO_ALT":"Christi Jacobsen, Montana Secretary of State","LOGO_FULL_WIDTH":true,"HOME_HIDE_AUTH_HINT":true,"HOME_TITLE":"Montana Secretary of State","CUSTOM_TAB_TITLE":"Official Montana","HOME_SUBTITLE":"Online Business Services","ENTITY_NAME_CONSENT_DESCRIPTION":"","ALLOW_USER_PROFILE_EDITING":true,"COMPARE_FOREIGN_NAME_IN_ENTITY_NAME_VALIDATION":true,"FOREIGN_NAME_FIELD_NAME":"KIMA_PARENT_NAME_INFO","LOGIN_TITLE":"Montana Secretary of State Online Filing Portal Login","PUBLIC_LOGIN_LABEL":"Username","REVERSE_LOGIN_COLUMNS":true,"LOGIN_SEAL_FILENAME":"seal_white.png","SEPARATE_USERNAME_AND_EMAIL":true,"CREATE_ACCOUNT_BUTTON_ALIGN_LEFT":true,"CREATE_ACCOUNT_BUTTON_TEXT":"CREATE AN ACCOUNT","PASSWORD_CUSTOM_ERROR_TEXT":"The password must meet all requirements","ACCOUNT_CREATED_MESSAGE":"Please check your email to verify your account to login and allow a few minutes for this message to arrive. Check your junk/spam folders if you do not find the email in your inbox.","PUBLIC_LOGIN_PLACEHOLDER":" ","DISABLE_DEFAULT_PAYMENT_RADIO":true,"CUSTOM_RESET_PASSWORD_ERROR_MESSAGE":"Username invalid - no account found","PUBLIC_LOGIN_CREATE_DESCRIPTION":"### Existing User:\n\n  - Enter your username and password to login.  \n\n\n  #### - OR -  \n\n\n\n  - Forgot password? Click 'Reset Password' and follow the prompts.\n  - Forgot username? Click 'Forgot Username' and follow the prompts.  \n\n\n  ### New User:\n  ","LOGIN_HELP_LINK":"https://sosmt.gov/business/how-do-i/","LOGIN_HELP_LINK_TEXT":"Need Help?","FORGOT_USERNAME_TEXT":"Forgot Username?","LOGIN_ACTIVE_DIRECTORY_TEXT":"State User Login","MULTIPLE_LOGIN_METHODS":true,"HAS_ACTIVE_DIRECTORY_LOGIN":true,"RESET_PASSWORD_WITH_USERNAME":true,"DOWNLOAD_LINK":true,"SHOW_USERNAME_ACCOUNT_CREATE":true,"SHOW_SCROLL_DOWN_ARROW":true,"SHOW_ADDRESS_ACCOUNT_CREATE":true,"TWO_COLUMN_ACCOUNT_CREATE":true,"RESET_PASSWORD_TIP":"A link to change your password has been sent to your email. Please allow a few minutes for this message to arrive. Please check your junk/spam folders if you do not find the email in your inbox.","FORGOT_PASSWORD_LINK_TEXT":"Reset Password","PHONE_NUMBER_OPTIONAL_ACCOUNT_CREATE":true,"SHOW_REQUIRED_INDICATOR_ACCOUNT_CREATE":true,"PASSWORD_REQUIREMENTS_ACCOUNT_CREATE":"\n    <ul>\n      <li>MUST contain at least 8 characters (12+ recommended)</li>\n      <li>MUST contain at least one uppercase letter.</li>\n      <li>MUST contain at least one lowercase letter.</li>\n      <li>MUST contain at least one number.</li>\n      <li>MUST contain at least one special character (!”#$%&'()*+,-./:;<=>?</li>\n    </ul>\n  ","ALLOW_CERTIFICATION_REQUEST":true,"ALLOW_PUBLIC_CERTIFICATE_REQUEST":true,"ALLOW_COPY_REQUEST":false,"ALLOW_CORRECTION_STYLING":true,"HIDE_DEPRECATION_WARNING":false,"AMEND_ROUTE_PUBLIC":true,"SEAL_FILENAME":"seal.png","SHOPPING_CART":true,"ALLOW_PAYMENT_UPDATE_WITH_EMPTY_CART":true,"RA_EMAIL":true,"RA_WEBSITE":true,"RA_NO_DEFAULT_TYPE":true,"RA_ADDRESS_LABEL":"Street Address","RA_TYPE_SELECTION_DEFAULT":true,"RA_DEFAULT_TYPE":"460","RA_OVERRIDE_TYPE_WITH_DEFAULT":true,"RA_PRINCIPAL_ADDRESS_AMS":true,"UPLOAD_AND_SUBMIT_HIDE_IF_ONE_OPTION":true,"PAYMENT_PROCESSING_MESSAGE":"Your payment is processing - Do not close your browser or click the back button","CHECKOUT_BUTTON_WHEN_PROCESSING_TEXT":"Processing","EFS_CROP_PICKER_NONE_LABEL":"Lien Duration","DISALLOWED_WIZARD_PIECES":["FormationLocale"],"REPEATER_SHOW_EDIT_BUTTON":true,"DATA_REQUEST_PAGE_TITLE":"Data Requests and Subscriptions","DATA_REQUEST_SIDEBAR_LABEL":"Data Requests & Subscriptions","LOGIN_REDIRECTS_TO_EPASS":false,"LOGIN_REDIRECTS_TO_ACTIVE_DIRECTORY":true,"LOGIN_ACTIVE_DIRECTORY_LINK":true,"FETCH_EDIT_USER_LINK":false,"LISTS_FETCH_AVAILABLE_LISTS":true,"POST_WIZARD_SUBMIT_REDIRECT_URL":"/","PIN_REQUEST_ATTESTATIONS":true,"PIN_REQUEST_DESCRIPTION":"Click **Request PIN** to have a new PIN sent to the account holder's email address on file.","OWNERSHIP_REQUEST_DESCRIPTION":"To become an **authorized user** of this record, a current **AUTHORIZED USER** will need to grant you access. To request access, click **Request Access** below.","PIN_REQUEST_SUCCESS_MESSAGE":"The PIN you have requested for this entity has been sent to the email associated with your user account.  You should receive the PIN in approximately 3-5 minutes, depending on your email service provider.","APOSTILLE_HEADER_LABEL":"Verification Information","APOSTILLE_NUMBER_LABEL":"Apostille/Authentication","APOSTILLE_CITY_STATE_OVERRIDE":"HELENA, MT","APOSTILLE_FILING_DATE_LABEL":"Issue Date","APOSTILLE_CITY_STATE_IN_CERTIFIED":true,"NOTARY_EXISTING_FILING":true,"ALLOW_REVOKE_OWN_ACCESS_ONLY":false,"HIDE_CANCEL_ON_ONETIME_DATA_REQUESTS":true,"DATA_REQUESTS_IN_SHOPPING_CART":true,"WQ_ALLOW_EDIT_PENDING_PAYMENT":true,"WQ_CONFIRM_ON_DELETE":true,"WQ_DELETE_CONFIRM_MESSAGE":"Deleting this filing will forfeit any money already paid to the Secretary of State. This action is permanent and cannot be undone, are you sure you would like to delete?","PASS_ITEM_GUIDS_ON_CHECKOUT":true,"FORM_REVISION_HISTORY":true,"CHECKOUT_DISCLAIMER":"By entering your credit card and/or checking account information you (i) state that **you are an authorized user** of the credit card and/or electronic check and that the associated information entered (e.g., account holder name, account number, billing address) is accurate, (ii) **you authorize payment processor to charge the amount you have requested** to your credit card and/or funding account, and (iii) **acknowledge if a charge is declined or reversed you may also be assessed a customary charge** by the payment processor for such transactions.","FARM_BILL_SEARCH_CONFIDENTIAL":"As a registered Farm Bill Buyer with the Montana Secretary of State’s office it is important to maintain the confidentiality of the information contained within the Farm Bill Master List. The Farm Bill Master List reflects personal data, such as Social Security Numbers, which are a key piece of personal identifiable information to assist you in determining the existence of a lien against a specific debtor. The distribution of this information beyond its intended purpose is strictly prohibited.\n\n**The debtor's tax identification number has been hidden for confidentiality reasons. You may continue to search on a tax ID number and return debtors that match your search criteria. The SSN/FEIN must be entered without dashes or spaces.  If you need access to the tax identification number to clearly identify the debtor, please contact the UCC unit at (406) 444-3665.**","VIEW_HISTORY_BUTTON_ALT_TEXT":"View Filings","WIZARD_ERROR_TITLE_MESSAGE":"Form Error","FARM_BILL_SEARCH_INTERACTIVE":true,"USE_FARM_BILL_API":true,"DISALLOW_ASSIGN_SELF_AS_RA":true,"DISALLOW_ASSIGN_SELF_AS_PRINCIPAL":true,"USE_TRADEMARK_OWNER_VALIDATION":true,"USE_ALTERNATIVE_FOREIGN_ADDRESS_LABELS":true,"MY_RECEIPTS_FILTER":[{"type":"dateRange","name":"DATE_RANGE","label":"Date range","defaultValue":{"start":null,"end":null}},{"type":"text","name":"REF_NUM","defaultValue":"","label":"Reference Number"},{"type":"text","name":"RECEIPT_NUM","defaultValue":"","label":"Receipt Id"},{"type":"text","name":"AMOUNT","defaultValue":"","label":"Amount"},{"type":"select","name":"TYPE","defaultValue":"","label":"Payment Type","options":[{"value":"","label":"All"},{"value":"CC","label":"Credit Card"},{"value":"Check","label":"Check"}]}],"MY_RECEIPTS_SHOW_IN_SIDEBAR":true,"SHOW_MY_RECEIPTS_HELPER_TEXT":true,"MY_RECEIPTS_HELPER_LABEL":"About Receipt Search","MY_RECEIPTS_HELPER_TEXT":"You can search for receipts based on their descriptions, including the items paid for on the receipt. Use the filters to search for or filter specific information.","FARM_BILL_SUBLINK":{"label":"Farm Bill","component":"FarmBill","parameter":"farm-bill","path":"/lists/farm-bill","sourceTypeId":0,"myRecordsSearch":false,"allowedRules":["/search/"],"disabled":true,"searchDescription":"To perform a search, enter a debtor name. Your search results may include: exact debtor name, variations of that name and any filing that includes your search criteria. Punctuation is ignored.\n\nYou can click on \"Advanced\" to refine your search. Under “Advanced” you can search by crop, year, county and SSN/FEIN. As a registered Farm Bill Buyer with the Montana Secretary of State’s office it is important to maintain the confidentiality of the information contained within the Farm Bill Master List. The Farm Bill Master List reflects personal data, such as Social Security Numbers, which are a key piece of personal identifiable information to assist you in determining the existence of a lien against a specific debtor. The distribution of this information beyond its intended purpose is strictly prohibited.\n\nThe debtor's tax identification number has been hidden for confidentiality reasons. You may continue to search on a tax ID number and return debtors that match your search criteria. The SSN/FEIN must be entered without dashes or spaces.","searchMustHaveOneOf":["search","UCC_FARM_PRODUCT_ID","COUNTY"],"searchPlaceholder":"Search by debtor name","advancedSearchParameters":[{"type":"ServerMultiComplete","label":"Product code name(s)","name":"UCC_FARM_PRODUCT_ID","defaultValue":"","optionsSrc":"UCC_FARM_PRODUCT_V"},{"type":"MultiComplete","label":"Year or Range of Years","name":"YEAR_NUM","optionsSrc":"years","startYear":"1968","defaultValue":[],"preMergeOptions":[{"value":"ALL","label":"All"}]},{"type":"serverSelect","label":"State","name":"STATE","defaultValue":"MONTANA","optionsSrc":"STATE"},{"type":"ServerMultiComplete","label":"County","name":"COUNTY","defaultValue":[],"optionsSrc":"COUNTY","overrideSubOptionsSrcFromParameterName":"STATE"},{"type":"checkbox","name":"TIN_SEARCH_YN","defaultValue":false,"label":"Tax Identification Number Search"},{"type":"checkbox","name":"TIN_SORT_YN","defaultValue":false,"label":"Unique ID Sort"}]},"ALLOW_ADDRESS_VALIDATION_BYPASS_OPTION":true,"DEFAULT_ADDRESS_VALIDATION_BYPASS_OPTION_CHECKED":true}).DISPLAY_FULL_FOREIGN_ADDR;
	      return _react2.default.createElement(
	        'span',
	        null,
	        DISPLAY_FULL_FOREIGN_ADDR && field.showCountry && value.COUNTRY !== '' && value.COUNTRY !== 'United States' ? country ? country.label : null : null,
	        DISPLAY_FULL_FOREIGN_ADDR && field.showCountry && value.COUNTRY !== '' && value.COUNTRY !== 'United States' ? _react2.default.createElement('br', null) : null,
	        value.ADDR1,
	        ' ',
	        _react2.default.createElement('br', null),
	        value.ADDR2,
	        value.ADDR2 ? _react2.default.createElement('br', null) : null,
	        value.ADDR3,
	        value.ADDR3 ? _react2.default.createElement('br', null) : null,
	        (DISPLAY_FULL_FOREIGN_ADDR || value.COUNTRY === 'United States') && value.ADDR1 !== '' ? value.CITY + ', ' + value.STATE + ' ' + value.POSTAL_CODE : null,
	        value.COUNTRY === '' ? _react2.default.createElement('br', null) : null,
	        value.COUNTY !== '' && value.COUNTRY !== '' ? _react2.default.createElement('br', null) : null,
	        value.COUNTY !== '' && field.showCounty ? value.COUNTY + ', ' : null,
	        !DISPLAY_FULL_FOREIGN_ADDR && field.showCountry && value.COUNTRY !== '' && value.COUNTRY !== 'United States' ? country ? country.label : null : null
	      );
	    }
	  }, {
	    key: 'getConfirmFieldProps',
	    value: function getConfirmFieldProps() {
	      return [{ label: this.label, value: this.formatAddress(this.value) }];
	    }
	  }, {
	    key: 'getHumanReadableValue',
	    value: function getHumanReadableValue(field, value) {
	      return this.formatAddress(value, field);
	    }
	  }, {
	    key: 'getKeyValuePairs',
	    value: function getKeyValuePairs(field) {
	      var value = Object.assign({}, field.value);
	      var isForeign = (value.COUNTRY === null ? '' : value.COUNTRY).toLowerCase() !== 'united states';
	      var showCityStateZipOnForeignAddress = ({"NODE_ENV":"production","BUILD_DATE":"2025-08-27T15:15:31.687Z","BUILD_NUMBER":"Not Provided","GIT_VERSION":"v1.3.0-381-ga81e29b08","GIT_COMMIT_HASH":"a81e29b085c9268ffd96c78eb734365802722741","GIT_BRANCH":"beta","PUBLIC_URL":"","STATE_ABBR":"MT","STATE_NAME":"Montana","STATE_ORG_TITLE":"Secretary of State","LOGIN_HEADER_IMG_PATH":"","HOME_IMG_FILENAME":"montana.jpg","FAVICON_FILE_NAME":"favicon.ico","ALLOW_E_SIGN_ON_CORRECTIONS":true,"THIRD_PARTY_SIGNING_ALLOWED":false,"MY_ACCOUNT_SAVE_AND_CLOSE_BUTTON":true,"IE_DEPRECATED_MESSAGE":"Internet Explorer is not supported. Please select a supported browser below to access this website.","ADDITIONAL_ROUTES":{"dataRequests":true,"farmBill":true,"apostille":true,"externalHelp":"https://sosmt.gov/business/help-center/","systemAdministration":[{"title":"Saved Payments","parameter":"saved-payments","componentName":"SavedPayments"}]},"SUBROUTES":[{"label":"Business","component":"Business","parameter":"business","myWorkQueueSearch":false,"sourceTypeId":54,"searchMustHaveOneOf":["FILING_TYPE_ID","STATUS_ID","STATE","search"],"serverWebSearchDescription":true,"serverWorkQueueDescription":true,"serverMyRecordsDescription":true,"searchPlaceholder":"Search by name or filing number (X########)","allowEmptySearchTerm":true,"requestCertificateAlternateLabel":"Request Information","fileAmendmentButtonLabel":"Filing Actions","advancedSearchParameters":[{"type":"radio","name":"QUERY_TYPE_ID","defaultValue":1010,"options":[{"value":1010,"label":"Starts with"},{"value":1011,"label":"Contains"},{"value":1012,"label":" Word Contains"}]},{"type":"serverSelect","name":"FILING_TYPE_ID","optionsSrc":"FILING_TYPES","label":"Entity Type","placeholder":"All","defaultValue":"0"},{"type":"serverSelect","name":"FILING_SUBTYPE_ID","optionsSrc":"FILING_SUBTYPES","label":"Entity Subtype","overrideSubOptionsSrcFromParameterName":"FILING_TYPE_ID","placeholder":"All","defaultValue":"0"},{"type":"serverSelect","name":"STATUS_ID","optionsSrc":"FILING_STATUS_WITHOUT_ALL","label":"Status","placeholder":"All","defaultValue":"0"},{"type":"serverSelect","name":"STATE","optionsSrc":"STATE","label":"State","placeholder":"All","defaultValue":""},{"type":"serverSelect","name":"COUNTY","optionsSrc":"COUNTY_SUBOPTION","label":"County","overrideSubOptionsSrcFromParameterName":"STATE","placeholder":"All","defaultValue":""},{"type":"checkbox","name":"CRA_SEARCH_YN","defaultValue":false,"label":"Search by Registered Agent PID"},{"type":"dateRange","name":"FILING_DATE","label":"Registration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}},{"type":"dateRange","name":"EXPIRATION_DATE","label":"Expiration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}}],"myRecordsFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Active"},{"value":2,"label":"Inactive"},{"value":3,"label":"Pending"}]},{"type":"dateRange","name":"DATE_RANGE","label":"Date range","defaultValue":{"start":null,"end":null}}],"myWorkQueueFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Approved"},{"value":2,"label":"Pending Online Payment"},{"value":3,"label":"Pending Review"},{"value":4,"label":"Needs Correction"},{"value":5,"label":"Rejected"},{"value":6,"label":"Draft"}]},{"type":"dateRange","name":"DATE_RANGE","label":"Date range","defaultValue":{"start":null,"end":null}}]},{"label":"Notary","component":"Notary","parameter":"notary","sourceTypeId":850,"myWorkQueueSearch":false,"allowEmptySearchTerm":true,"requestCertificateAlternateLabel":"Download Certificate","fileAmendmentButtonLabel":"Filing Actions","hideNameRequestCertificate":true,"hideAddressRequestCertificate":true,"hideRecordUserManagment":true,"searchPlaceholder":"Search by name or commission number","searchMustHaveOneOf":["CITY","search","SERVICE_TYPE"],"advancedParametersStartOpen":true,"searchIsSortable":true,"advancedSearchParameters":[{"type":"radio","name":"STARTS_WITH_YN","defaultValue":false,"options":[{"value":true,"label":"Starts with"},{"value":false,"label":"Contains"}]},{"type":"checkbox","name":"ACTIVE_ONLY_YN","defaultValue":true,"label":"Active entities only"},{"type":"text","name":"CITY","defaultValue":"","label":"City"},{"type":"select","name":"SERVICE_TYPE","label":"Special Services Offered","defaultValue":0,"options":[{"value":0,"label":"(N/A)"},{"value":6165,"label":"In-Person Electronic Notarization (IPEN)"},{"value":6166,"label":"Remote Online Notarization (RON)"},{"value":6167,"label":"Mobile Notary Services"},{"value":6168,"label":"Remote Ink Notarization (RIN)"}]}]},{"label":"Apostille","component":"Apostille","parameter":"apostille","sourceTypeId":720,"myRecordsSearch":false,"myWorkQueueSearch":false,"disabled":false,"allowedRoutes":["/forms-manager/","/queue/","/forms/"]},{"label":"Liens","component":"UCC","parameter":"ucc","sourceTypeId":1999,"myRecordsSearch":true,"myWorkQueueSearch":true,"fileAmendmentButtonLabel":"Filing Actions","searchPlaceholder":"Search by name or file number","disabled":false,"serverWebSearchDescription":true,"myRecordsDescription":"","workQueueDescription":"","searchDescription":"","hideRecordUserManagment":true,"searchLiensCheckout":false,"advancedSearchParameters":[{"type":"radio","name":"STARTS_WITH_YN","defaultValue":false,"options":[{"value":true,"label":"Starts with"},{"value":false,"label":"Contains"}]},{"type":"select","name":"STATUS","defaultValue":"ALL","label":"Status","options":[{"value":"ACTIVE_UNLAPSED","label":"Active (unlapsed)"},{"value":"ACTIVE_LAPSED_UNLAPSED","label":"Active (lapsed and unlapsed)"}]},{"type":"text","name":"EXCLUDE_VALUES","label":"Exclude Debtor Names (comma separated list of names to exclude)","defaultValue":""},{"type":"dateRange","name":"FILING_DATE","label":"Financing Statement Date","defaultValue":{"start":null,"end":null}},{"type":"dateRange","name":"LAPSE_DATE","label":"Lapse Date","defaultValue":{"start":null,"end":null}},{"type":"text","name":"CITY","label":"Debtor City","defaultValue":""}],"myRecordsFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Approved"},{"value":2,"label":"Pending Online Payment"},{"value":3,"label":"Pending Review"}]},{"type":"select","name":"TYPE","defaultValue":0,"label":"Lien Type","options":[{"value":0,"label":"All"},{"value":1,"label":"UCC"},{"value":2,"label":"EFS"},{"value":3,"label":"Title 71"}]}],"myWorkQueueFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Approved"},{"value":2,"label":"Pending Online Payment"},{"value":3,"label":"Pending Review"},{"value":4,"label":"Pending Print and Mail"},{"value":5,"label":"Rejected"},{"value":6,"label":"Draft"}]},{"type":"select","name":"TYPE","defaultValue":0,"label":"Lien Type","options":[{"value":0,"label":"All"},{"value":1,"label":"UCC"},{"value":2,"label":"EFS"},{"value":3,"label":"Title 71"}]}]},{"label":"Copy Request","component":"copies","parameter":"copies","sourceTypeId":2001,"myRecordsSearch":false,"myWorkQueueSearch":false,"disabled":false,"allowedRoutes":["/forms-manager/","/queue/","/forms/"]},{"label":"Trademark","component":"Trademark","parameter":"trademark","sourceTypeId":810,"showRequestCertificate":true,"searchMustHaveOneOf":["search","EXPIRATION_DATE","FILING_DATE"],"allowEmptySearchTerm":true,"requestCertificateAlternateLabel":"Request Information","fileAmendmentButtonLabel":"Filing Actions","advancedSearchParameters":[{"type":"radio","name":"QUERY_TYPE_ID","defaultValue":1010,"options":[{"value":1010,"label":"Starts with"},{"value":1011,"label":"Contains"},{"value":1012,"label":" Word Contains"}]},{"type":"checkbox","name":"OWNER_SEARCH_YN","defaultValue":false,"label":"Search owners"},{"type":"radio","name":"SERVICE_MARK_YN","label":"Mark Type","defaultValue":"","options":[{"value":"","label":"All Marks"},{"value":"Y","label":"Service Mark"},{"value":"N","label":"Trademark"}]},{"type":"serverSelect","name":"STATUS_ID","optionsSrc":"TYPE_V|TRADEMARK_STATUS_TYPE","label":"Status","placeholder":"All","defaultValue":"0"},{"type":"select","name":"DESIGN_TYPE_ID","options":[{"value":0,"label":"All"},{"value":990,"label":"Words Only"},{"value":991,"label":"Design Only"},{"value":992,"label":"Words and Design"}],"label":"Design Type","defaultValue":"0"},{"type":"dateRange","name":"FILING_DATE","label":"Registered Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}},{"type":"dateRange","name":"EXPIRATION_DATE","label":"Expiration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}}]},{"label":"Business Info Request","component":"InfoRequests","parameter":"info-request","sourceTypeId":167,"allowedRoutes":["/forms-manager/","/queue/","/forms/"]},{"label":"Data Requests","component":"DataRequests","parameter":"data-request","sourceTypeId":0,"allowedRoutes":["/forms-manager/"]},{"label":"CRA","component":"CRA","parameter":"cra","sourceTypeId":157,"myRecordsSearch":false,"searchPlaceholder":"Search by name or registered agent number","allowedRoutes":["/forms-manager/","/forms/","/records/","/queue/","/search/"],"allowEmptySearchTerm":true,"fileAmendmentButtonLabel":"Filing Actions","advancedSearchParameters":[{"type":"radio","name":"QUERY_TYPE_ID","defaultValue":1010,"options":[{"value":1010,"label":"Starts with"},{"value":1011,"label":"Contains"},{"value":1012,"label":" Word Contains"}]},{"type":"dateRange","name":"CRA_DATE","label":"Registration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}},{"type":"select","name":"STATUS_ID","label":"Status","defaultValue":0,"options":[{"value":0,"label":"All"},{"value":121,"label":"Active"},{"value":122,"label":"Inactive"}]},{"type":"select","name":"AGENT_TYPE_ID","label":"Agent Type","defaultValue":0,"options":[{"value":0,"label":"All"},{"value":460,"label":"Registered Agent"},{"value":461,"label":"Commercial Registered Agent"}]}]},{"label":"Farm Bill","component":"FarmBill","parameter":"farm-bill","path":"/lists/farm-bill","sourceTypeId":0,"myRecordsSearch":false,"allowedRules":["/search/"],"disabled":true,"searchDescription":"To perform a search, enter a debtor name. Your search results may include: exact debtor name, variations of that name and any filing that includes your search criteria. Punctuation is ignored.\n\nYou can click on \"Advanced\" to refine your search. Under “Advanced” you can search by crop, year, county and SSN/FEIN. As a registered Farm Bill Buyer with the Montana Secretary of State’s office it is important to maintain the confidentiality of the information contained within the Farm Bill Master List. The Farm Bill Master List reflects personal data, such as Social Security Numbers, which are a key piece of personal identifiable information to assist you in determining the existence of a lien against a specific debtor. The distribution of this information beyond its intended purpose is strictly prohibited.\n\nThe debtor's tax identification number has been hidden for confidentiality reasons. You may continue to search on a tax ID number and return debtors that match your search criteria. The SSN/FEIN must be entered without dashes or spaces.","searchMustHaveOneOf":["search","UCC_FARM_PRODUCT_ID","COUNTY"],"searchPlaceholder":"Search by debtor name","advancedSearchParameters":[{"type":"ServerMultiComplete","label":"Product code name(s)","name":"UCC_FARM_PRODUCT_ID","defaultValue":"","optionsSrc":"UCC_FARM_PRODUCT_V"},{"type":"MultiComplete","label":"Year or Range of Years","name":"YEAR_NUM","optionsSrc":"years","startYear":"1968","defaultValue":[],"preMergeOptions":[{"value":"ALL","label":"All"}]},{"type":"serverSelect","label":"State","name":"STATE","defaultValue":"MONTANA","optionsSrc":"STATE"},{"type":"ServerMultiComplete","label":"County","name":"COUNTY","defaultValue":[],"optionsSrc":"COUNTY","overrideSubOptionsSrcFromParameterName":"STATE"},{"type":"checkbox","name":"TIN_SEARCH_YN","defaultValue":false,"label":"Tax Identification Number Search"},{"type":"checkbox","name":"TIN_SORT_YN","defaultValue":false,"label":"Unique ID Sort"}]}],"SYSTEM_NICKNAME":"Online Services Portal","PAYMENT_METHODS":[{"type":"bypass"},{"type":"iTransact"}],"PAYMENT_ALLOW_AMEX":true,"SYSTEM_ID_LABEL":"System Id","DOUBLE_COLUMN_PUBLIC_LOGIN":true,"INTERNAL_USER_MANAGEMENT":true,"ALLOW_PUBLIC_JSON_IMPORT":false,"MAX_FILE_UPLOAD_SIZE":10000000,"REFUND_TEXT":"","RETURN_TO_HOME_ON_LOGOUT":true,"CURRENT_SOS_NAME":"Christi Jacobsen","LOGO_FILENAME":"mt-sos-logo.png","LOGO_ALT":"Christi Jacobsen, Montana Secretary of State","LOGO_FULL_WIDTH":true,"HOME_HIDE_AUTH_HINT":true,"HOME_TITLE":"Montana Secretary of State","CUSTOM_TAB_TITLE":"Official Montana","HOME_SUBTITLE":"Online Business Services","ENTITY_NAME_CONSENT_DESCRIPTION":"","ALLOW_USER_PROFILE_EDITING":true,"COMPARE_FOREIGN_NAME_IN_ENTITY_NAME_VALIDATION":true,"FOREIGN_NAME_FIELD_NAME":"KIMA_PARENT_NAME_INFO","LOGIN_TITLE":"Montana Secretary of State Online Filing Portal Login","PUBLIC_LOGIN_LABEL":"Username","REVERSE_LOGIN_COLUMNS":true,"LOGIN_SEAL_FILENAME":"seal_white.png","SEPARATE_USERNAME_AND_EMAIL":true,"CREATE_ACCOUNT_BUTTON_ALIGN_LEFT":true,"CREATE_ACCOUNT_BUTTON_TEXT":"CREATE AN ACCOUNT","PASSWORD_CUSTOM_ERROR_TEXT":"The password must meet all requirements","ACCOUNT_CREATED_MESSAGE":"Please check your email to verify your account to login and allow a few minutes for this message to arrive. Check your junk/spam folders if you do not find the email in your inbox.","PUBLIC_LOGIN_PLACEHOLDER":" ","DISABLE_DEFAULT_PAYMENT_RADIO":true,"CUSTOM_RESET_PASSWORD_ERROR_MESSAGE":"Username invalid - no account found","PUBLIC_LOGIN_CREATE_DESCRIPTION":"### Existing User:\n\n  - Enter your username and password to login.  \n\n\n  #### - OR -  \n\n\n\n  - Forgot password? Click 'Reset Password' and follow the prompts.\n  - Forgot username? Click 'Forgot Username' and follow the prompts.  \n\n\n  ### New User:\n  ","LOGIN_HELP_LINK":"https://sosmt.gov/business/how-do-i/","LOGIN_HELP_LINK_TEXT":"Need Help?","FORGOT_USERNAME_TEXT":"Forgot Username?","LOGIN_ACTIVE_DIRECTORY_TEXT":"State User Login","MULTIPLE_LOGIN_METHODS":true,"HAS_ACTIVE_DIRECTORY_LOGIN":true,"RESET_PASSWORD_WITH_USERNAME":true,"DOWNLOAD_LINK":true,"SHOW_USERNAME_ACCOUNT_CREATE":true,"SHOW_SCROLL_DOWN_ARROW":true,"SHOW_ADDRESS_ACCOUNT_CREATE":true,"TWO_COLUMN_ACCOUNT_CREATE":true,"RESET_PASSWORD_TIP":"A link to change your password has been sent to your email. Please allow a few minutes for this message to arrive. Please check your junk/spam folders if you do not find the email in your inbox.","FORGOT_PASSWORD_LINK_TEXT":"Reset Password","PHONE_NUMBER_OPTIONAL_ACCOUNT_CREATE":true,"SHOW_REQUIRED_INDICATOR_ACCOUNT_CREATE":true,"PASSWORD_REQUIREMENTS_ACCOUNT_CREATE":"\n    <ul>\n      <li>MUST contain at least 8 characters (12+ recommended)</li>\n      <li>MUST contain at least one uppercase letter.</li>\n      <li>MUST contain at least one lowercase letter.</li>\n      <li>MUST contain at least one number.</li>\n      <li>MUST contain at least one special character (!”#$%&'()*+,-./:;<=>?</li>\n    </ul>\n  ","ALLOW_CERTIFICATION_REQUEST":true,"ALLOW_PUBLIC_CERTIFICATE_REQUEST":true,"ALLOW_COPY_REQUEST":false,"ALLOW_CORRECTION_STYLING":true,"HIDE_DEPRECATION_WARNING":false,"AMEND_ROUTE_PUBLIC":true,"SEAL_FILENAME":"seal.png","SHOPPING_CART":true,"ALLOW_PAYMENT_UPDATE_WITH_EMPTY_CART":true,"RA_EMAIL":true,"RA_WEBSITE":true,"RA_NO_DEFAULT_TYPE":true,"RA_ADDRESS_LABEL":"Street Address","RA_TYPE_SELECTION_DEFAULT":true,"RA_DEFAULT_TYPE":"460","RA_OVERRIDE_TYPE_WITH_DEFAULT":true,"RA_PRINCIPAL_ADDRESS_AMS":true,"UPLOAD_AND_SUBMIT_HIDE_IF_ONE_OPTION":true,"PAYMENT_PROCESSING_MESSAGE":"Your payment is processing - Do not close your browser or click the back button","CHECKOUT_BUTTON_WHEN_PROCESSING_TEXT":"Processing","EFS_CROP_PICKER_NONE_LABEL":"Lien Duration","DISALLOWED_WIZARD_PIECES":["FormationLocale"],"REPEATER_SHOW_EDIT_BUTTON":true,"DATA_REQUEST_PAGE_TITLE":"Data Requests and Subscriptions","DATA_REQUEST_SIDEBAR_LABEL":"Data Requests & Subscriptions","LOGIN_REDIRECTS_TO_EPASS":false,"LOGIN_REDIRECTS_TO_ACTIVE_DIRECTORY":true,"LOGIN_ACTIVE_DIRECTORY_LINK":true,"FETCH_EDIT_USER_LINK":false,"LISTS_FETCH_AVAILABLE_LISTS":true,"POST_WIZARD_SUBMIT_REDIRECT_URL":"/","PIN_REQUEST_ATTESTATIONS":true,"PIN_REQUEST_DESCRIPTION":"Click **Request PIN** to have a new PIN sent to the account holder's email address on file.","OWNERSHIP_REQUEST_DESCRIPTION":"To become an **authorized user** of this record, a current **AUTHORIZED USER** will need to grant you access. To request access, click **Request Access** below.","PIN_REQUEST_SUCCESS_MESSAGE":"The PIN you have requested for this entity has been sent to the email associated with your user account.  You should receive the PIN in approximately 3-5 minutes, depending on your email service provider.","APOSTILLE_HEADER_LABEL":"Verification Information","APOSTILLE_NUMBER_LABEL":"Apostille/Authentication","APOSTILLE_CITY_STATE_OVERRIDE":"HELENA, MT","APOSTILLE_FILING_DATE_LABEL":"Issue Date","APOSTILLE_CITY_STATE_IN_CERTIFIED":true,"NOTARY_EXISTING_FILING":true,"ALLOW_REVOKE_OWN_ACCESS_ONLY":false,"HIDE_CANCEL_ON_ONETIME_DATA_REQUESTS":true,"DATA_REQUESTS_IN_SHOPPING_CART":true,"WQ_ALLOW_EDIT_PENDING_PAYMENT":true,"WQ_CONFIRM_ON_DELETE":true,"WQ_DELETE_CONFIRM_MESSAGE":"Deleting this filing will forfeit any money already paid to the Secretary of State. This action is permanent and cannot be undone, are you sure you would like to delete?","PASS_ITEM_GUIDS_ON_CHECKOUT":true,"FORM_REVISION_HISTORY":true,"CHECKOUT_DISCLAIMER":"By entering your credit card and/or checking account information you (i) state that **you are an authorized user** of the credit card and/or electronic check and that the associated information entered (e.g., account holder name, account number, billing address) is accurate, (ii) **you authorize payment processor to charge the amount you have requested** to your credit card and/or funding account, and (iii) **acknowledge if a charge is declined or reversed you may also be assessed a customary charge** by the payment processor for such transactions.","FARM_BILL_SEARCH_CONFIDENTIAL":"As a registered Farm Bill Buyer with the Montana Secretary of State’s office it is important to maintain the confidentiality of the information contained within the Farm Bill Master List. The Farm Bill Master List reflects personal data, such as Social Security Numbers, which are a key piece of personal identifiable information to assist you in determining the existence of a lien against a specific debtor. The distribution of this information beyond its intended purpose is strictly prohibited.\n\n**The debtor's tax identification number has been hidden for confidentiality reasons. You may continue to search on a tax ID number and return debtors that match your search criteria. The SSN/FEIN must be entered without dashes or spaces.  If you need access to the tax identification number to clearly identify the debtor, please contact the UCC unit at (406) 444-3665.**","VIEW_HISTORY_BUTTON_ALT_TEXT":"View Filings","WIZARD_ERROR_TITLE_MESSAGE":"Form Error","FARM_BILL_SEARCH_INTERACTIVE":true,"USE_FARM_BILL_API":true,"DISALLOW_ASSIGN_SELF_AS_RA":true,"DISALLOW_ASSIGN_SELF_AS_PRINCIPAL":true,"USE_TRADEMARK_OWNER_VALIDATION":true,"USE_ALTERNATIVE_FOREIGN_ADDRESS_LABELS":true,"MY_RECEIPTS_FILTER":[{"type":"dateRange","name":"DATE_RANGE","label":"Date range","defaultValue":{"start":null,"end":null}},{"type":"text","name":"REF_NUM","defaultValue":"","label":"Reference Number"},{"type":"text","name":"RECEIPT_NUM","defaultValue":"","label":"Receipt Id"},{"type":"text","name":"AMOUNT","defaultValue":"","label":"Amount"},{"type":"select","name":"TYPE","defaultValue":"","label":"Payment Type","options":[{"value":"","label":"All"},{"value":"CC","label":"Credit Card"},{"value":"Check","label":"Check"}]}],"MY_RECEIPTS_SHOW_IN_SIDEBAR":true,"SHOW_MY_RECEIPTS_HELPER_TEXT":true,"MY_RECEIPTS_HELPER_LABEL":"About Receipt Search","MY_RECEIPTS_HELPER_TEXT":"You can search for receipts based on their descriptions, including the items paid for on the receipt. Use the filters to search for or filter specific information.","FARM_BILL_SUBLINK":{"label":"Farm Bill","component":"FarmBill","parameter":"farm-bill","path":"/lists/farm-bill","sourceTypeId":0,"myRecordsSearch":false,"allowedRules":["/search/"],"disabled":true,"searchDescription":"To perform a search, enter a debtor name. Your search results may include: exact debtor name, variations of that name and any filing that includes your search criteria. Punctuation is ignored.\n\nYou can click on \"Advanced\" to refine your search. Under “Advanced” you can search by crop, year, county and SSN/FEIN. As a registered Farm Bill Buyer with the Montana Secretary of State’s office it is important to maintain the confidentiality of the information contained within the Farm Bill Master List. The Farm Bill Master List reflects personal data, such as Social Security Numbers, which are a key piece of personal identifiable information to assist you in determining the existence of a lien against a specific debtor. The distribution of this information beyond its intended purpose is strictly prohibited.\n\nThe debtor's tax identification number has been hidden for confidentiality reasons. You may continue to search on a tax ID number and return debtors that match your search criteria. The SSN/FEIN must be entered without dashes or spaces.","searchMustHaveOneOf":["search","UCC_FARM_PRODUCT_ID","COUNTY"],"searchPlaceholder":"Search by debtor name","advancedSearchParameters":[{"type":"ServerMultiComplete","label":"Product code name(s)","name":"UCC_FARM_PRODUCT_ID","defaultValue":"","optionsSrc":"UCC_FARM_PRODUCT_V"},{"type":"MultiComplete","label":"Year or Range of Years","name":"YEAR_NUM","optionsSrc":"years","startYear":"1968","defaultValue":[],"preMergeOptions":[{"value":"ALL","label":"All"}]},{"type":"serverSelect","label":"State","name":"STATE","defaultValue":"MONTANA","optionsSrc":"STATE"},{"type":"ServerMultiComplete","label":"County","name":"COUNTY","defaultValue":[],"optionsSrc":"COUNTY","overrideSubOptionsSrcFromParameterName":"STATE"},{"type":"checkbox","name":"TIN_SEARCH_YN","defaultValue":false,"label":"Tax Identification Number Search"},{"type":"checkbox","name":"TIN_SORT_YN","defaultValue":false,"label":"Unique ID Sort"}]},"ALLOW_ADDRESS_VALIDATION_BYPASS_OPTION":true,"DEFAULT_ADDRESS_VALIDATION_BYPASS_OPTION_CHECKED":true}).USE_CITY_STATE_ON_FOREIGN_ADDRESS;
	      if (isForeign) {
	        value = Object.assign({}, value, {
	          STATE: showCityStateZipOnForeignAddress ? (value.STATE || '').trim() : '',
	          CITY: showCityStateZipOnForeignAddress ? (value.CITY || '').trim() : '',
	          POSTAL_CODE: showCityStateZipOnForeignAddress ? (value.POSTAL_CODE || '').trim() : ''
	        });
	      } else {
	        value = Object.assign({}, value, {
	          ADDR1: (value.ADDR1 || '').trim(),
	          ADDR2: (value.ADDR2 || '').trim(),
	          ADDR3: (value.ADDR3 || '').trim(),
	          CITY: (value.CITY || '').trim(),
	          STATE: value.STATE === '' ? field.defaultState : value.STATE
	        });
	      }
	      return [{ name: field.name, value: value }];
	    }
	  }]);
	
	  return AddressBlock;
	}(Field);
	
	var FullName = exports.FullName = function (_Field11) {
	  _inherits(FullName, _Field11);
	
	  function FullName() {
	    var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	    _classCallCheck(this, FullName);
	
	    var _this15 = _possibleConstructorReturn(this, (FullName.__proto__ || Object.getPrototypeOf(FullName)).call(this, props));
	
	    _this15.type = "FullName";
	    _this15.fieldClass = "FullName";
	    _this15.label = props.label || "Full Name";
	    _this15.hideLabel = true;
	    _this15.value = props.value || { FIRST_NAME: "", MIDDLE_NAME: "", LAST_NAME: "", SUFFIX: "" };
	    _this15.middleInitial = props.middleInitial || false;
	    _this15.suffix = props.suffix || false;
	    _this15.allowedRules = ["nameRequired", 'checkForRegulatedWords', 'customBusinessRules'];
	    _this15.onlyRequireLastName = props.onlyRequireLastName || false;
	    return _this15;
	  }
	
	  _createClass(FullName, [{
	    key: 'getConfirmFieldProps',
	    value: function getConfirmFieldProps() {
	      return [{ label: "First Name", value: this.value.FIRST_NAME }, { label: "Middle Name", value: this.value.MIDDLE_NAME }, { label: "Last Name", value: this.value.LAST_NAME }];
	    }
	  }, {
	    key: 'getHumanReadableValue',
	    value: function getHumanReadableValue(field, value) {
	      return value.FIRST_NAME + (value.MIDDLE_NAME !== "" ? " " + value.MIDDLE_NAME + " " : " ") + value.LAST_NAME + (value.SUFFIX ? ' ' + value.SUFFIX : '');
	    }
	  }]);
	
	  return FullName;
	}(Field);
	
	var getNameOrgObject = function getNameOrgObject() {
	  var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	  var defaultIsOrg = arguments[1];
	  return {
	    ORG_YN: value.ORG_YN !== undefined ? value.ORG_YN : defaultIsOrg,
	    FIRST_NAME: value.FIRST_NAME || "",
	    MIDDLE_NAME: value.MIDDLE_NAME || "",
	    LAST_NAME: value.LAST_NAME || "",
	    ORG_NAME: value.ORG_NAME || "",
	    SUFFIX: value.SUFFIX || ""
	  };
	};
	
	var NameOrg = exports.NameOrg = function (_FullName) {
	  _inherits(NameOrg, _FullName);
	
	  function NameOrg() {
	    var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	    _classCallCheck(this, NameOrg);
	
	    var _this16 = _possibleConstructorReturn(this, (NameOrg.__proto__ || Object.getPrototypeOf(NameOrg)).call(this, props));
	
	    _this16.type = "NameOrg";
	    _this16.fieldClass = "NameOrg";
	    _this16.label = props.label || "Name of individual or organization";
	    _this16.hideLabel = true;
	    _this16.defaultIsOrg = props.defaultIsOrg || false;
	    _this16.value = props.value ? getNameOrgObject(props.value) : getNameOrgObject({}, _this16.defaultIsOrg);
	    _this16.allowedRules = ["nameOrgRequired", 'checkForRegulatedWords', 'customBusinessRules'];
	    _this16.checkboxLabel = props.checkboxLabel || "";
	    _this16.onlyRequireLastName = props.onlyRequireLastName || false;
	    _this16.ownsTooltip = true;
	    return _this16;
	  }
	
	  _createClass(NameOrg, [{
	    key: 'getConfirmFieldProps',
	    value: function getConfirmFieldProps() {
	      if (this.value.ORG_YN) {
	        return [{ label: "Organization", value: this.value.ORG_NAME }];
	      } else {
	        return [{ label: "First Name", value: this.value.FIRST_NAME }, { label: "Middle Name", value: this.value.MIDDLE_NAME }, { label: "Last Name", value: this.value.LAST_NAME }];
	      }
	    }
	  }, {
	    key: 'getCompareValue',
	    value: function getCompareValue() {
	      var field = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	      var _field$value = field.value,
	          value = _field$value === undefined ? {} : _field$value;
	
	      var isOrganization = value.ORG_YN === 'N' || value.ORG_YN === false ? false : true;
	      return isOrganization ? value.ORG_NAME : {
	        FIRST_NAME: value.FIRST_NAME,
	        LAST_NAME: value.LAST_NAME,
	        MIDDLE_NAME: value.MIDDLE_NAME,
	        SUFFIX: value.SUFFIX
	      };
	    }
	  }, {
	    key: 'getHumanReadableValue',
	    value: function getHumanReadableValue(field, value) {
	      var isOrganization = value.ORG_YN === 'N' || value.ORG_YN === false ? false : true;
	      if (isOrganization) {
	        return value.ORG_NAME;
	      } else {
	        return value.FIRST_NAME + ' ' + (value.MIDDLE_NAME !== '' ? value.MIDDLE_NAME + ' ' : '') + value.LAST_NAME + (value.SUFFIX ? ' ' + value.SUFFIX : '');
	      }
	    }
	  }, {
	    key: 'getKeyValuePairs',
	    value: function getKeyValuePairs(field) {
	      var ORG_YN = field.value.ORG_YN === false || field.value.ORG_YN === 'N' ? 'N' : 'Y';
	      return [{
	        name: field.name,
	        value: Object.assign({}, field.value, {
	          ORG_YN: ORG_YN,
	          ORG_NAME: ORG_YN === 'Y' ? field.value.ORG_NAME : '',
	          FIRST_NAME: ORG_YN === 'N' ? field.value.FIRST_NAME : '',
	          MIDDLE_NAME: ORG_YN === 'N' ? field.value.MIDDLE_NAME : '',
	          LAST_NAME: ORG_YN === 'N' ? field.value.LAST_NAME : '',
	          SUFFIX: ORG_YN === 'N' ? field.value.SUFFIX : ''
	        })
	      }];
	    }
	  }]);
	
	  return NameOrg;
	}(FullName);
	
	var getNameQualifiedOrgObject = function getNameQualifiedOrgObject() {
	  return { FIRST_NAME: "", MIDDLE_NAME: "", LAST_NAME: "", SUFFIX: "", ORG_NAME: "", ORG_TYPE: "", SELECTED: null, SOURCE_ID: 0, SEARCH_TYPE: "", SOURCE_TYPE_ID: 54 };
	};
	
	var NameQualifiedOrg = exports.NameQualifiedOrg = function (_NameOrg) {
	  _inherits(NameQualifiedOrg, _NameOrg);
	
	  function NameQualifiedOrg() {
	    var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	    _classCallCheck(this, NameQualifiedOrg);
	
	    var _this17 = _possibleConstructorReturn(this, (NameQualifiedOrg.__proto__ || Object.getPrototypeOf(NameQualifiedOrg)).call(this, props));
	
	    _this17.type = "NameQualifiedOrg";
	    _this17.fieldClass = "NameQualifiedOrg";
	    _this17.label = props.label || "Name of individual or organization";
	    _this17.hideLabel = false;
	    _this17.value = props.value ? Object.assign({}, getNameQualifiedOrgObject(), props.value) : getNameQualifiedOrgObject();
	    _this17.allowedRules = ["nameQualifiedOrgRequired", 'checkForRegulatedWords', 'customBusinessRules'];
	    _this17.suffix = props.suffix || false;
	    _this17.checkboxLabel = props.checkboxLabel || "";
	    _this17.individualLabel = props.individualLabel || props.individualLabel === "" ? props.individualLabel : "Individual";
	    _this17.qualifiedLabel = props.qualifiedLabel || props.qualifiedLabel === "" ? props.qualifiedLabel : "Qualified Organization";
	    _this17.unqualifiedLabel = props.unqualifiedLabel || props.unqualifiedLabel === "" ? props.unqualifiedLabel : "Unqualified Organization";
	    _this17.qualifiedPlaceholder = props.qualifiedPlaceholder || "(Search by name of organization)";
	    _this17.unqualifiedPlaceholder = props.unqualifiedPlaceholder || "";
	    _this17.modalTitle = props.modalTitle || "";
	    _this17.metadata = props.metadata || {};
	    _this17.value = Object.assign({}, _this17.value, { ORG_TYPE: _this17.getValueOrDefaultOrgType(_this17) }) || getNameQualifiedOrgObject();
	    _this17.searchType = props.searchType || '';
	    _this17.additionalParameters = props.additionalParameters || {};
	    _this17.parameterFields = props.parameterFields || [];
	    return _this17;
	  }
	
	  _createClass(NameQualifiedOrg, [{
	    key: 'getCompareValue',
	    value: function getCompareValue() {
	      var field = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	      var value = field.value;
	
	      switch (value.ORG_TYPE) {
	        case '0':
	        case 0:
	          return {
	            ORG_TYPE: value.ORG_TYPE,
	            FIRST_NAME: value.FIRST_NAME,
	            LAST_NAME: value.LAST_NAME,
	            MIDDLE_NAME: value.MIDDLE_NAME,
	            SUFFIX: value.SUFFIX
	          };
	        case '1':
	        case 1:
	          return {
	            ORG_TYPE: value.ORG_TYPE,
	            SELECTED: value.SELECTED,
	            SOURCE_ID: value.SOURCE_ID,
	            ORG_NAME: value.ORG_NAME
	          };
	        case '2':
	        case 2:
	          return {
	            ORG_TYPE: value.ORG_TYPE,
	            ORG_NAME: value.ORG_NAME,
	            SELECTED: value.SELECTED,
	            SOURCE_ID: value.SOURCE_ID
	          };
	        default:
	          return value;
	      }
	    }
	  }, {
	    key: 'getValueOrDefaultOrgType',
	    value: function getValueOrDefaultOrgType(props) {
	      var orgType = props.value.ORG_TYPE.toString();
	      var labelArray = [props.individualLabel, props.qualifiedLabel, props.unqualifiedLabel];
	      var selectedValueExists = labelArray.reduce(function (exists, label, index) {
	        if (orgType === index.toString() && label !== "") {
	          return true;
	        } else {
	          return exists;
	        }
	      }, false);
	      if (selectedValueExists) {
	        return orgType;
	      } else {
	        return "";
	      }
	    }
	  }, {
	    key: 'getHumanReadableValue',
	    value: function getHumanReadableValue(field, value) {
	      switch (value.ORG_TYPE) {
	        case "0":
	          return value.FIRST_NAME + (value.MIDDLE_NAME !== "" ? " " + value.MIDDLE_NAME + " " : " ") + value.LAST_NAME + (value.SUFFIX ? ' ' + value.SUFFIX : '');
	        case "1":
	          if (value.SELECTED) {
	            return _react2.default.createElement(HumanReadableResultCard, { value: value.SELECTED });
	          }
	          break;
	        case "2":
	          return value.ORG_NAME;
	      }
	    }
	  }, {
	    key: 'getHumanReadableSignatureValue',
	    value: function getHumanReadableSignatureValue(field, value) {
	      switch (value.ORG_TYPE) {
	        case "0":
	          return value.FIRST_NAME + (value.MIDDLE_NAME !== "" ? " " + value.MIDDLE_NAME + " " : " ") + value.LAST_NAME + (value.SUFFIX ? ' ' + value.SUFFIX : '');
	        case "1":
	          if (value.SELECTED) {
	            return value.SELECTED.HEADER1;
	          }
	          break;
	        case "2":
	          return value.ORG_NAME;
	      }
	    }
	  }, {
	    key: 'getKeyValuePairs',
	    value: function getKeyValuePairs(field) {
	      return [{ name: field.name,
	        value: Object.assign({}, field.value, {
	          SOURCE_ID: field.value.SELECTED && field.value.SELECTED.SOURCE_ID || 0,
	          ORG_YN: field.value.ORG_TYPE === "1" || field.value.ORG_TYPE === "2",
	          ORG_NAME: field.value.ORG_TYPE === "1" ? field.value.SELECTED.HEADER1 : field.value.ORG_NAME,
	          FIRST_NAME: field.value.ORG_TYPE === "0" ? field.value.FIRST_NAME : "",
	          MIDDLE_NAME: field.value.ORG_TYPE === "0" ? field.value.MIDDLE_NAME : "",
	          LAST_NAME: field.value.ORG_TYPE === "0" ? field.value.LAST_NAME : "",
	          SUFFIX: field.value.ORG_TYPE === "0" ? field.value.SUFFIX : ""
	        }) }];
	    }
	  }]);
	
	  return NameQualifiedOrg;
	}(NameOrg);
	
	var HumanReadableResultCard = function HumanReadableResultCard(_ref2) {
	  var value = _ref2.value;
	  return _react2.default.createElement(
	    'span',
	    { className: 'flex-column hr-result' },
	    _react2.default.createElement(
	      'span',
	      { className: 'h1' },
	      value.HEADER1
	    ),
	    value.HEADER2 && _react2.default.createElement(
	      'span',
	      null,
	      value.HEADER2
	    ),
	    value.SECTIONS && value.SECTIONS.map(function (section, i) {
	      return _react2.default.createElement(
	        'span',
	        { className: 'flex-column', key: i },
	        section.label && _react2.default.createElement(
	          'span',
	          { className: 'label' },
	          section.label
	        ),
	        section.lines && section.lines.map(function (_ref3, k) {
	          var line = _ref3.line;
	          return _react2.default.createElement(
	            'span',
	            { className: 'result-value', key: k },
	            line
	          );
	        })
	      );
	    })
	  );
	};
	
	var SearchControl = exports.SearchControl = function (_Field12) {
	  _inherits(SearchControl, _Field12);
	
	  function SearchControl() {
	    var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	    _classCallCheck(this, SearchControl);
	
	    var _this18 = _possibleConstructorReturn(this, (SearchControl.__proto__ || Object.getPrototypeOf(SearchControl)).call(this, props));
	
	    _initialiseProps.call(_this18);
	
	    _this18.metadata = props.metadata || {};
	    _this18.multiSelect = props.multiSelect || false;
	    _this18.calculateInitialValue(props);
	    _this18.type = "SearchControl";
	    _this18.fieldClass = "SearchControl";
	    _this18.modalTitle = props.modalTitle || "";
	    _this18.allowedRules = ["searchItemRequired", 'customBusinessRules'];
	    _this18.searchType = props.searchType || '';
	    _this18.additionalParameters = props.additionalParameters || {};
	    _this18.parameterFields = props.parameterFields || [];
	    return _this18;
	  }
	
	  _createClass(SearchControl, [{
	    key: 'getHumanReadableValue',
	    value: function getHumanReadableValue(field, value) {
	      if (field.multiSelect) {
	        return value.map(function (result, i) {
	          return _react2.default.createElement(
	            'div',
	            { key: i, style: { marginBottom: 10, padding: 0 } },
	            _react2.default.createElement(HumanReadableResultCard, { value: result })
	          );
	        });
	      } else {
	        return value ? _react2.default.createElement(HumanReadableResultCard, { value: value }) : "";
	      }
	    }
	  }, {
	    key: 'getKeyValuePairs',
	    value: function getKeyValuePairs(field) {
	      return [{
	        name: field.name,
	        value: field.value
	      }];
	    }
	  }]);
	
	  return SearchControl;
	}(Field);
	
	var _initialiseProps = function _initialiseProps() {
	  var _this39 = this;
	
	  this.calculateInitialValue = function (props) {
	    if (props.value) {
	      if (_this39.multiSelect) {
	        if (Array.isArray(props.value)) {
	          _this39.value = props.value;
	        } else {
	          _this39.value = [];
	        }
	      } else {
	        if (Array.isArray(props.value)) {
	          _this39.value = null;
	        } else {
	          _this39.value = props.value;
	        }
	      }
	    } else {
	      if (_this39.multiSelect) {
	        _this39.value = [];
	      } else {
	        _this39.value = null;
	      }
	    }
	  };
	};
	
	var DependentRadio = exports.DependentRadio = function (_Field13) {
	  _inherits(DependentRadio, _Field13);
	
	  function DependentRadio() {
	    var radio = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	    _classCallCheck(this, DependentRadio);
	
	    var _this19 = _possibleConstructorReturn(this, (DependentRadio.__proto__ || Object.getPrototypeOf(DependentRadio)).call(this, radio));
	
	    _this19.type = "dependentRadio";
	    _this19.fieldClass = "DependentRadio";
	    _this19.hasOptionFields = true;
	    _this19.options = radio.options || [{ value: "option1", label: "Option 1", fields: [] }, { value: "option2", label: "Option 2", fields: [] }];
	    _this19.value = radio.value || (_this19.options.find(function (option) {
	      return option.value === _this19.value;
	    }) && radio.value ? radio.value : "0");
	    _this19.selectedIndex = radio.selectedIndex || null;
	    _this19.label = radio.label || "New Dependent Radio";
	    _this19.allowedRules = ["mustBeSelected", 'customBusinessRules'];
	    return _this19;
	  }
	
	  _createClass(DependentRadio, [{
	    key: 'getConfirmFieldProps',
	    value: function getConfirmFieldProps() {
	      var confirmFields = [];
	      var selectedOption = this.selectedIndex ? this.selectedIndex : 0;
	      confirmFields.push({ label: this.label, value: this.options[selectedOption].label });
	      for (var i = 0; i < this.options[selectedOption].fields.length; i++) {
	        confirmFields.push({ label: this.options[selectedOption].fields[i].label, value: this.options[selectedOption].fields[i].getConfirmFieldProps()[0].value });
	      }
	      return confirmFields;
	    }
	  }, {
	    key: 'getHumanReadableValue',
	    value: function getHumanReadableValue(field, value) {
	      var selectedOption = field.options.find(function (option) {
	        return option.value.toString() === value.toString();
	      });
	      return selectedOption ? selectedOption.label : "";
	    }
	  }, {
	    key: 'getKeyValuePairs',
	    value: function getKeyValuePairs(field) {
	      var value = field.value;
	      if (value === 'default' || !field.options.find(function (opt) {
	        return opt.value === value;
	      })) {
	        value = '';
	      }
	      return [{ name: field.name, value: value }];
	    }
	  }]);
	
	  return DependentRadio;
	}(Field);
	
	var DependentSelect = exports.DependentSelect = function (_Field14) {
	  _inherits(DependentSelect, _Field14);
	
	  function DependentSelect() {
	    var select = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	    _classCallCheck(this, DependentSelect);
	
	    var _this20 = _possibleConstructorReturn(this, (DependentSelect.__proto__ || Object.getPrototypeOf(DependentSelect)).call(this, select));
	
	    _this20.type = "dependentSelect";
	    _this20.fieldClass = "DependentSelect";
	    _this20.hasOptionFields = true;
	    _this20.options = select.options || [{ value: "default", label: "[Select an Option]", fields: [] }, { value: "option1", label: "Option 1", fields: [] }];
	    _this20.value = select.value || (_this20.options.find(function (option) {
	      return option.value === _this20.value;
	    }) && select.value ? select.value : "0");
	    _this20.selectedIndex = select.selectedIndex || 0;
	    _this20.label = select.label || "New Dependent Dropdown";
	    _this20.allowedRules = ["mustBeSelected", 'customBusinessRules'];
	    return _this20;
	  }
	
	  _createClass(DependentSelect, [{
	    key: 'getConfirmFieldProps',
	    value: function getConfirmFieldProps() {
	      var confirmFields = [];
	      var selectedOption = this.selectedIndex ? this.selectedIndex : 0;
	      confirmFields.push({ label: this.label, value: this.options[selectedOption].label });
	      for (var i = 0; i < this.options[selectedOption].fields.length; i++) {
	        confirmFields.push({ label: this.options[selectedOption].fields[i].label, value: this.options[selectedOption].fields[i].getConfirmFieldProps()[0].value });
	      }
	      return confirmFields;
	    }
	  }, {
	    key: 'getHumanReadableValue',
	    value: function getHumanReadableValue(field, value) {
	      var selectedOption = field.options.find(function (option) {
	        return option.value.toString() === value.toString();
	      });
	      return selectedOption ? selectedOption.label : "";
	    }
	  }, {
	    key: 'getKeyValuePairs',
	    value: function getKeyValuePairs(field) {
	      var value = field.value;
	      if (value === 'default' || !field.options.find(function (opt) {
	        return opt.value === value;
	      })) {
	        value = '';
	      }
	      return [{ name: field.name, value: value }];
	    }
	  }]);
	
	  return DependentSelect;
	}(Field);
	
	var LocalSelect = exports.LocalSelect = function (_Select) {
	  _inherits(LocalSelect, _Select);
	
	  function LocalSelect() {
	    var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	    _classCallCheck(this, LocalSelect);
	
	    var _this21 = _possibleConstructorReturn(this, (LocalSelect.__proto__ || Object.getPrototypeOf(LocalSelect)).call(this, props));
	
	    _this21.type = 'LocalSelect';
	    _this21.fieldClass = 'LocalSelect';
	    _this21.options = props.options || [];
	    _this21.srcRepeater = props.srcRepeater || '';
	    _this21.srcField = props.srcField || '';
	    _this21.width = props.width || '30%';
	    _this21.allowedRules = ['mustSelectLocalSelect', 'customBusinessRules'];
	    return _this21;
	  }
	
	  _createClass(LocalSelect, [{
	    key: 'getHumanReadableValue',
	    value: function getHumanReadableValue(field, value) {
	      var fields = _store2.default.getState().wizard.wizard.fields;
	      var srcRepeater = field.srcRepeater ? fields[field.srcRepeater] : null;
	      var srcField = field.srcField ? fields[field.srcField] : null;
	      if (srcRepeater && srcField) {
	        var row = srcRepeater.value.find(function (row) {
	          return row._rowId === value;
	        });
	        if (row) {
	          return new WizardClasses[srcField.fieldClass]().getHumanReadableValue(srcField, row[srcField.fieldId]);
	        }
	      }
	      return '';
	    }
	  }, {
	    key: 'getKeyValuePairs',
	    value: function getKeyValuePairs(field) {
	      var fields = _store2.default.getState().wizard.wizard.fields;
	      var srcRepeater = field.srcRepeater ? fields[field.srcRepeater] : null;
	      var srcField = field.srcField ? fields[field.srcField] : null;
	      var value = '';
	      var meta = {};
	      var rowIndex = null;
	      if (srcRepeater && srcField) {
	        var foundIndex = srcRepeater.value.findIndex(function (row) {
	          return row._rowId === field.value;
	        });
	        var row = srcRepeater.value[foundIndex];
	        if (row) {
	          var kvPair = new WizardClasses[srcField.fieldClass]().getKeyValuePairs(Object.assign({}, srcField, { value: row[srcField.fieldId] }))[0];
	          rowIndex = foundIndex;
	          value = kvPair.value;
	          meta = { displayValue: new WizardClasses[srcField.fieldClass]().getHumanReadableValue(Object.assign({}, srcField, { value: row[srcField.fieldId] }), row[srcField.fieldId]) };
	        }
	      }
	      return [{ value: { value: value, rowIndex: rowIndex }, name: field.name, meta: meta }];
	    }
	  }]);
	
	  return LocalSelect;
	}(Select);
	
	var DependentCheck = exports.DependentCheck = function (_Field15) {
	  _inherits(DependentCheck, _Field15);
	
	  function DependentCheck() {
	    var check = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	    _classCallCheck(this, DependentCheck);
	
	    var _this22 = _possibleConstructorReturn(this, (DependentCheck.__proto__ || Object.getPrototypeOf(DependentCheck)).call(this, check));
	
	    _this22.type = "dependentCheck";
	    _this22.fieldClass = "DependentCheck";
	    _this22.value = check.value || false;
	    _this22.label = check.label || "New Dependent Check";
	    _this22.checkedFields = check.checkedFields || [];
	    _this22.uncheckedFields = check.uncheckedFields || [];
	    _this22.hasCheckFields = true;
	    _this22.hideLabel = true;
	    _this22.allowedRules = ["mustBeTrue", 'customBusinessRules'];
	    return _this22;
	  }
	
	  _createClass(DependentCheck, [{
	    key: 'getConfirmFieldProps',
	    value: function getConfirmFieldProps() {
	      var kvPairs = [];
	      kvPairs.push({ label: this.label, value: this.value === true ? "Yes" : "No" });
	      if (this.value === true) {
	        for (var i = 0; i < this.checkedFields.length; i++) {
	          kvPairs.push({ label: this.checkedFields[i].label, value: this.checkedFields[i].getConfirmFieldProps()[0].value });
	        }
	      } else {
	        for (var _i = 0; _i < this.uncheckedFields.length; _i++) {
	          kvPairs.push({ label: this.uncheckedFields[_i].label, value: this.uncheckedFields[_i].getConfirmFieldProps()[0].value });
	        }
	      }
	      return kvPairs;
	    }
	  }, {
	    key: 'getHumanReadableValue',
	    value: function getHumanReadableValue(field, value) {
	      return value ? "Yes" : "No";
	    }
	  }]);
	
	  return DependentCheck;
	}(Field);
	
	var RA_OVERRIDE_TYPE_WITH_DEFAULT = (true);
	
	var getRegisteredAgentValueObject = exports.getRegisteredAgentValueObject = function getRegisteredAgentValueObject() {
	  var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : { MAIL_ADDR: {} };
	  return Object.assign({
	    INDIVIDUAL_YN: value.INDIVIDUAL_YN || 'y',
	    NEW: value.NEW || false,
	    TYPE_ID: RA_OVERRIDE_TYPE_WITH_DEFAULT ? ("460") : value.TYPE_ID || ( true ? '' : process.env.RA_DEFAULT_TYPE || '461'),
	    CRA_ID: value.CRA_ID || '0',
	    FIRST_NAME: value.FIRST_NAME || '',
	    MIDDLE_NAME: value.MIDDLE_NAME || '',
	    LAST_NAME: value.LAST_NAME || '',
	    SUFFIX: value.SUFFIX || '',
	    ORGANIZATION: value.ORGANIZATION || null
	  }, getAddressObject(value), {
	    MAIL_ADDR: getAddressObject(value.MAIL_ADDR),
	    SELECTED: value.SELECTED || null
	  },  true ? { EMAIL: value.EMAIL || '' } : {},  true ? { WEBSITE: value.WEBSITE || '' } : {});
	};
	
	var resolveAgentMailingAddress = exports.resolveAgentMailingAddress = function resolveAgentMailingAddress(value) {
	  return Object.assign({}, value && value.MAIL_ADDR || getRegisteredAgentValueObject().MAIL_ADDR, {
	    STATE: value && value.MAIL_ADDR && value.MAIL_ADDR.STATE || ({"NODE_ENV":"production","BUILD_DATE":"2025-08-27T15:15:31.687Z","BUILD_NUMBER":"Not Provided","GIT_VERSION":"v1.3.0-381-ga81e29b08","GIT_COMMIT_HASH":"a81e29b085c9268ffd96c78eb734365802722741","GIT_BRANCH":"beta","PUBLIC_URL":"","STATE_ABBR":"MT","STATE_NAME":"Montana","STATE_ORG_TITLE":"Secretary of State","LOGIN_HEADER_IMG_PATH":"","HOME_IMG_FILENAME":"montana.jpg","FAVICON_FILE_NAME":"favicon.ico","ALLOW_E_SIGN_ON_CORRECTIONS":true,"THIRD_PARTY_SIGNING_ALLOWED":false,"MY_ACCOUNT_SAVE_AND_CLOSE_BUTTON":true,"IE_DEPRECATED_MESSAGE":"Internet Explorer is not supported. Please select a supported browser below to access this website.","ADDITIONAL_ROUTES":{"dataRequests":true,"farmBill":true,"apostille":true,"externalHelp":"https://sosmt.gov/business/help-center/","systemAdministration":[{"title":"Saved Payments","parameter":"saved-payments","componentName":"SavedPayments"}]},"SUBROUTES":[{"label":"Business","component":"Business","parameter":"business","myWorkQueueSearch":false,"sourceTypeId":54,"searchMustHaveOneOf":["FILING_TYPE_ID","STATUS_ID","STATE","search"],"serverWebSearchDescription":true,"serverWorkQueueDescription":true,"serverMyRecordsDescription":true,"searchPlaceholder":"Search by name or filing number (X########)","allowEmptySearchTerm":true,"requestCertificateAlternateLabel":"Request Information","fileAmendmentButtonLabel":"Filing Actions","advancedSearchParameters":[{"type":"radio","name":"QUERY_TYPE_ID","defaultValue":1010,"options":[{"value":1010,"label":"Starts with"},{"value":1011,"label":"Contains"},{"value":1012,"label":" Word Contains"}]},{"type":"serverSelect","name":"FILING_TYPE_ID","optionsSrc":"FILING_TYPES","label":"Entity Type","placeholder":"All","defaultValue":"0"},{"type":"serverSelect","name":"FILING_SUBTYPE_ID","optionsSrc":"FILING_SUBTYPES","label":"Entity Subtype","overrideSubOptionsSrcFromParameterName":"FILING_TYPE_ID","placeholder":"All","defaultValue":"0"},{"type":"serverSelect","name":"STATUS_ID","optionsSrc":"FILING_STATUS_WITHOUT_ALL","label":"Status","placeholder":"All","defaultValue":"0"},{"type":"serverSelect","name":"STATE","optionsSrc":"STATE","label":"State","placeholder":"All","defaultValue":""},{"type":"serverSelect","name":"COUNTY","optionsSrc":"COUNTY_SUBOPTION","label":"County","overrideSubOptionsSrcFromParameterName":"STATE","placeholder":"All","defaultValue":""},{"type":"checkbox","name":"CRA_SEARCH_YN","defaultValue":false,"label":"Search by Registered Agent PID"},{"type":"dateRange","name":"FILING_DATE","label":"Registration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}},{"type":"dateRange","name":"EXPIRATION_DATE","label":"Expiration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}}],"myRecordsFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Active"},{"value":2,"label":"Inactive"},{"value":3,"label":"Pending"}]},{"type":"dateRange","name":"DATE_RANGE","label":"Date range","defaultValue":{"start":null,"end":null}}],"myWorkQueueFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Approved"},{"value":2,"label":"Pending Online Payment"},{"value":3,"label":"Pending Review"},{"value":4,"label":"Needs Correction"},{"value":5,"label":"Rejected"},{"value":6,"label":"Draft"}]},{"type":"dateRange","name":"DATE_RANGE","label":"Date range","defaultValue":{"start":null,"end":null}}]},{"label":"Notary","component":"Notary","parameter":"notary","sourceTypeId":850,"myWorkQueueSearch":false,"allowEmptySearchTerm":true,"requestCertificateAlternateLabel":"Download Certificate","fileAmendmentButtonLabel":"Filing Actions","hideNameRequestCertificate":true,"hideAddressRequestCertificate":true,"hideRecordUserManagment":true,"searchPlaceholder":"Search by name or commission number","searchMustHaveOneOf":["CITY","search","SERVICE_TYPE"],"advancedParametersStartOpen":true,"searchIsSortable":true,"advancedSearchParameters":[{"type":"radio","name":"STARTS_WITH_YN","defaultValue":false,"options":[{"value":true,"label":"Starts with"},{"value":false,"label":"Contains"}]},{"type":"checkbox","name":"ACTIVE_ONLY_YN","defaultValue":true,"label":"Active entities only"},{"type":"text","name":"CITY","defaultValue":"","label":"City"},{"type":"select","name":"SERVICE_TYPE","label":"Special Services Offered","defaultValue":0,"options":[{"value":0,"label":"(N/A)"},{"value":6165,"label":"In-Person Electronic Notarization (IPEN)"},{"value":6166,"label":"Remote Online Notarization (RON)"},{"value":6167,"label":"Mobile Notary Services"},{"value":6168,"label":"Remote Ink Notarization (RIN)"}]}]},{"label":"Apostille","component":"Apostille","parameter":"apostille","sourceTypeId":720,"myRecordsSearch":false,"myWorkQueueSearch":false,"disabled":false,"allowedRoutes":["/forms-manager/","/queue/","/forms/"]},{"label":"Liens","component":"UCC","parameter":"ucc","sourceTypeId":1999,"myRecordsSearch":true,"myWorkQueueSearch":true,"fileAmendmentButtonLabel":"Filing Actions","searchPlaceholder":"Search by name or file number","disabled":false,"serverWebSearchDescription":true,"myRecordsDescription":"","workQueueDescription":"","searchDescription":"","hideRecordUserManagment":true,"searchLiensCheckout":false,"advancedSearchParameters":[{"type":"radio","name":"STARTS_WITH_YN","defaultValue":false,"options":[{"value":true,"label":"Starts with"},{"value":false,"label":"Contains"}]},{"type":"select","name":"STATUS","defaultValue":"ALL","label":"Status","options":[{"value":"ACTIVE_UNLAPSED","label":"Active (unlapsed)"},{"value":"ACTIVE_LAPSED_UNLAPSED","label":"Active (lapsed and unlapsed)"}]},{"type":"text","name":"EXCLUDE_VALUES","label":"Exclude Debtor Names (comma separated list of names to exclude)","defaultValue":""},{"type":"dateRange","name":"FILING_DATE","label":"Financing Statement Date","defaultValue":{"start":null,"end":null}},{"type":"dateRange","name":"LAPSE_DATE","label":"Lapse Date","defaultValue":{"start":null,"end":null}},{"type":"text","name":"CITY","label":"Debtor City","defaultValue":""}],"myRecordsFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Approved"},{"value":2,"label":"Pending Online Payment"},{"value":3,"label":"Pending Review"}]},{"type":"select","name":"TYPE","defaultValue":0,"label":"Lien Type","options":[{"value":0,"label":"All"},{"value":1,"label":"UCC"},{"value":2,"label":"EFS"},{"value":3,"label":"Title 71"}]}],"myWorkQueueFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Approved"},{"value":2,"label":"Pending Online Payment"},{"value":3,"label":"Pending Review"},{"value":4,"label":"Pending Print and Mail"},{"value":5,"label":"Rejected"},{"value":6,"label":"Draft"}]},{"type":"select","name":"TYPE","defaultValue":0,"label":"Lien Type","options":[{"value":0,"label":"All"},{"value":1,"label":"UCC"},{"value":2,"label":"EFS"},{"value":3,"label":"Title 71"}]}]},{"label":"Copy Request","component":"copies","parameter":"copies","sourceTypeId":2001,"myRecordsSearch":false,"myWorkQueueSearch":false,"disabled":false,"allowedRoutes":["/forms-manager/","/queue/","/forms/"]},{"label":"Trademark","component":"Trademark","parameter":"trademark","sourceTypeId":810,"showRequestCertificate":true,"searchMustHaveOneOf":["search","EXPIRATION_DATE","FILING_DATE"],"allowEmptySearchTerm":true,"requestCertificateAlternateLabel":"Request Information","fileAmendmentButtonLabel":"Filing Actions","advancedSearchParameters":[{"type":"radio","name":"QUERY_TYPE_ID","defaultValue":1010,"options":[{"value":1010,"label":"Starts with"},{"value":1011,"label":"Contains"},{"value":1012,"label":" Word Contains"}]},{"type":"checkbox","name":"OWNER_SEARCH_YN","defaultValue":false,"label":"Search owners"},{"type":"radio","name":"SERVICE_MARK_YN","label":"Mark Type","defaultValue":"","options":[{"value":"","label":"All Marks"},{"value":"Y","label":"Service Mark"},{"value":"N","label":"Trademark"}]},{"type":"serverSelect","name":"STATUS_ID","optionsSrc":"TYPE_V|TRADEMARK_STATUS_TYPE","label":"Status","placeholder":"All","defaultValue":"0"},{"type":"select","name":"DESIGN_TYPE_ID","options":[{"value":0,"label":"All"},{"value":990,"label":"Words Only"},{"value":991,"label":"Design Only"},{"value":992,"label":"Words and Design"}],"label":"Design Type","defaultValue":"0"},{"type":"dateRange","name":"FILING_DATE","label":"Registered Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}},{"type":"dateRange","name":"EXPIRATION_DATE","label":"Expiration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}}]},{"label":"Business Info Request","component":"InfoRequests","parameter":"info-request","sourceTypeId":167,"allowedRoutes":["/forms-manager/","/queue/","/forms/"]},{"label":"Data Requests","component":"DataRequests","parameter":"data-request","sourceTypeId":0,"allowedRoutes":["/forms-manager/"]},{"label":"CRA","component":"CRA","parameter":"cra","sourceTypeId":157,"myRecordsSearch":false,"searchPlaceholder":"Search by name or registered agent number","allowedRoutes":["/forms-manager/","/forms/","/records/","/queue/","/search/"],"allowEmptySearchTerm":true,"fileAmendmentButtonLabel":"Filing Actions","advancedSearchParameters":[{"type":"radio","name":"QUERY_TYPE_ID","defaultValue":1010,"options":[{"value":1010,"label":"Starts with"},{"value":1011,"label":"Contains"},{"value":1012,"label":" Word Contains"}]},{"type":"dateRange","name":"CRA_DATE","label":"Registration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}},{"type":"select","name":"STATUS_ID","label":"Status","defaultValue":0,"options":[{"value":0,"label":"All"},{"value":121,"label":"Active"},{"value":122,"label":"Inactive"}]},{"type":"select","name":"AGENT_TYPE_ID","label":"Agent Type","defaultValue":0,"options":[{"value":0,"label":"All"},{"value":460,"label":"Registered Agent"},{"value":461,"label":"Commercial Registered Agent"}]}]},{"label":"Farm Bill","component":"FarmBill","parameter":"farm-bill","path":"/lists/farm-bill","sourceTypeId":0,"myRecordsSearch":false,"allowedRules":["/search/"],"disabled":true,"searchDescription":"To perform a search, enter a debtor name. Your search results may include: exact debtor name, variations of that name and any filing that includes your search criteria. Punctuation is ignored.\n\nYou can click on \"Advanced\" to refine your search. Under “Advanced” you can search by crop, year, county and SSN/FEIN. As a registered Farm Bill Buyer with the Montana Secretary of State’s office it is important to maintain the confidentiality of the information contained within the Farm Bill Master List. The Farm Bill Master List reflects personal data, such as Social Security Numbers, which are a key piece of personal identifiable information to assist you in determining the existence of a lien against a specific debtor. The distribution of this information beyond its intended purpose is strictly prohibited.\n\nThe debtor's tax identification number has been hidden for confidentiality reasons. You may continue to search on a tax ID number and return debtors that match your search criteria. The SSN/FEIN must be entered without dashes or spaces.","searchMustHaveOneOf":["search","UCC_FARM_PRODUCT_ID","COUNTY"],"searchPlaceholder":"Search by debtor name","advancedSearchParameters":[{"type":"ServerMultiComplete","label":"Product code name(s)","name":"UCC_FARM_PRODUCT_ID","defaultValue":"","optionsSrc":"UCC_FARM_PRODUCT_V"},{"type":"MultiComplete","label":"Year or Range of Years","name":"YEAR_NUM","optionsSrc":"years","startYear":"1968","defaultValue":[],"preMergeOptions":[{"value":"ALL","label":"All"}]},{"type":"serverSelect","label":"State","name":"STATE","defaultValue":"MONTANA","optionsSrc":"STATE"},{"type":"ServerMultiComplete","label":"County","name":"COUNTY","defaultValue":[],"optionsSrc":"COUNTY","overrideSubOptionsSrcFromParameterName":"STATE"},{"type":"checkbox","name":"TIN_SEARCH_YN","defaultValue":false,"label":"Tax Identification Number Search"},{"type":"checkbox","name":"TIN_SORT_YN","defaultValue":false,"label":"Unique ID Sort"}]}],"SYSTEM_NICKNAME":"Online Services Portal","PAYMENT_METHODS":[{"type":"bypass"},{"type":"iTransact"}],"PAYMENT_ALLOW_AMEX":true,"SYSTEM_ID_LABEL":"System Id","DOUBLE_COLUMN_PUBLIC_LOGIN":true,"INTERNAL_USER_MANAGEMENT":true,"ALLOW_PUBLIC_JSON_IMPORT":false,"MAX_FILE_UPLOAD_SIZE":10000000,"REFUND_TEXT":"","RETURN_TO_HOME_ON_LOGOUT":true,"CURRENT_SOS_NAME":"Christi Jacobsen","LOGO_FILENAME":"mt-sos-logo.png","LOGO_ALT":"Christi Jacobsen, Montana Secretary of State","LOGO_FULL_WIDTH":true,"HOME_HIDE_AUTH_HINT":true,"HOME_TITLE":"Montana Secretary of State","CUSTOM_TAB_TITLE":"Official Montana","HOME_SUBTITLE":"Online Business Services","ENTITY_NAME_CONSENT_DESCRIPTION":"","ALLOW_USER_PROFILE_EDITING":true,"COMPARE_FOREIGN_NAME_IN_ENTITY_NAME_VALIDATION":true,"FOREIGN_NAME_FIELD_NAME":"KIMA_PARENT_NAME_INFO","LOGIN_TITLE":"Montana Secretary of State Online Filing Portal Login","PUBLIC_LOGIN_LABEL":"Username","REVERSE_LOGIN_COLUMNS":true,"LOGIN_SEAL_FILENAME":"seal_white.png","SEPARATE_USERNAME_AND_EMAIL":true,"CREATE_ACCOUNT_BUTTON_ALIGN_LEFT":true,"CREATE_ACCOUNT_BUTTON_TEXT":"CREATE AN ACCOUNT","PASSWORD_CUSTOM_ERROR_TEXT":"The password must meet all requirements","ACCOUNT_CREATED_MESSAGE":"Please check your email to verify your account to login and allow a few minutes for this message to arrive. Check your junk/spam folders if you do not find the email in your inbox.","PUBLIC_LOGIN_PLACEHOLDER":" ","DISABLE_DEFAULT_PAYMENT_RADIO":true,"CUSTOM_RESET_PASSWORD_ERROR_MESSAGE":"Username invalid - no account found","PUBLIC_LOGIN_CREATE_DESCRIPTION":"### Existing User:\n\n  - Enter your username and password to login.  \n\n\n  #### - OR -  \n\n\n\n  - Forgot password? Click 'Reset Password' and follow the prompts.\n  - Forgot username? Click 'Forgot Username' and follow the prompts.  \n\n\n  ### New User:\n  ","LOGIN_HELP_LINK":"https://sosmt.gov/business/how-do-i/","LOGIN_HELP_LINK_TEXT":"Need Help?","FORGOT_USERNAME_TEXT":"Forgot Username?","LOGIN_ACTIVE_DIRECTORY_TEXT":"State User Login","MULTIPLE_LOGIN_METHODS":true,"HAS_ACTIVE_DIRECTORY_LOGIN":true,"RESET_PASSWORD_WITH_USERNAME":true,"DOWNLOAD_LINK":true,"SHOW_USERNAME_ACCOUNT_CREATE":true,"SHOW_SCROLL_DOWN_ARROW":true,"SHOW_ADDRESS_ACCOUNT_CREATE":true,"TWO_COLUMN_ACCOUNT_CREATE":true,"RESET_PASSWORD_TIP":"A link to change your password has been sent to your email. Please allow a few minutes for this message to arrive. Please check your junk/spam folders if you do not find the email in your inbox.","FORGOT_PASSWORD_LINK_TEXT":"Reset Password","PHONE_NUMBER_OPTIONAL_ACCOUNT_CREATE":true,"SHOW_REQUIRED_INDICATOR_ACCOUNT_CREATE":true,"PASSWORD_REQUIREMENTS_ACCOUNT_CREATE":"\n    <ul>\n      <li>MUST contain at least 8 characters (12+ recommended)</li>\n      <li>MUST contain at least one uppercase letter.</li>\n      <li>MUST contain at least one lowercase letter.</li>\n      <li>MUST contain at least one number.</li>\n      <li>MUST contain at least one special character (!”#$%&'()*+,-./:;<=>?</li>\n    </ul>\n  ","ALLOW_CERTIFICATION_REQUEST":true,"ALLOW_PUBLIC_CERTIFICATE_REQUEST":true,"ALLOW_COPY_REQUEST":false,"ALLOW_CORRECTION_STYLING":true,"HIDE_DEPRECATION_WARNING":false,"AMEND_ROUTE_PUBLIC":true,"SEAL_FILENAME":"seal.png","SHOPPING_CART":true,"ALLOW_PAYMENT_UPDATE_WITH_EMPTY_CART":true,"RA_EMAIL":true,"RA_WEBSITE":true,"RA_NO_DEFAULT_TYPE":true,"RA_ADDRESS_LABEL":"Street Address","RA_TYPE_SELECTION_DEFAULT":true,"RA_DEFAULT_TYPE":"460","RA_OVERRIDE_TYPE_WITH_DEFAULT":true,"RA_PRINCIPAL_ADDRESS_AMS":true,"UPLOAD_AND_SUBMIT_HIDE_IF_ONE_OPTION":true,"PAYMENT_PROCESSING_MESSAGE":"Your payment is processing - Do not close your browser or click the back button","CHECKOUT_BUTTON_WHEN_PROCESSING_TEXT":"Processing","EFS_CROP_PICKER_NONE_LABEL":"Lien Duration","DISALLOWED_WIZARD_PIECES":["FormationLocale"],"REPEATER_SHOW_EDIT_BUTTON":true,"DATA_REQUEST_PAGE_TITLE":"Data Requests and Subscriptions","DATA_REQUEST_SIDEBAR_LABEL":"Data Requests & Subscriptions","LOGIN_REDIRECTS_TO_EPASS":false,"LOGIN_REDIRECTS_TO_ACTIVE_DIRECTORY":true,"LOGIN_ACTIVE_DIRECTORY_LINK":true,"FETCH_EDIT_USER_LINK":false,"LISTS_FETCH_AVAILABLE_LISTS":true,"POST_WIZARD_SUBMIT_REDIRECT_URL":"/","PIN_REQUEST_ATTESTATIONS":true,"PIN_REQUEST_DESCRIPTION":"Click **Request PIN** to have a new PIN sent to the account holder's email address on file.","OWNERSHIP_REQUEST_DESCRIPTION":"To become an **authorized user** of this record, a current **AUTHORIZED USER** will need to grant you access. To request access, click **Request Access** below.","PIN_REQUEST_SUCCESS_MESSAGE":"The PIN you have requested for this entity has been sent to the email associated with your user account.  You should receive the PIN in approximately 3-5 minutes, depending on your email service provider.","APOSTILLE_HEADER_LABEL":"Verification Information","APOSTILLE_NUMBER_LABEL":"Apostille/Authentication","APOSTILLE_CITY_STATE_OVERRIDE":"HELENA, MT","APOSTILLE_FILING_DATE_LABEL":"Issue Date","APOSTILLE_CITY_STATE_IN_CERTIFIED":true,"NOTARY_EXISTING_FILING":true,"ALLOW_REVOKE_OWN_ACCESS_ONLY":false,"HIDE_CANCEL_ON_ONETIME_DATA_REQUESTS":true,"DATA_REQUESTS_IN_SHOPPING_CART":true,"WQ_ALLOW_EDIT_PENDING_PAYMENT":true,"WQ_CONFIRM_ON_DELETE":true,"WQ_DELETE_CONFIRM_MESSAGE":"Deleting this filing will forfeit any money already paid to the Secretary of State. This action is permanent and cannot be undone, are you sure you would like to delete?","PASS_ITEM_GUIDS_ON_CHECKOUT":true,"FORM_REVISION_HISTORY":true,"CHECKOUT_DISCLAIMER":"By entering your credit card and/or checking account information you (i) state that **you are an authorized user** of the credit card and/or electronic check and that the associated information entered (e.g., account holder name, account number, billing address) is accurate, (ii) **you authorize payment processor to charge the amount you have requested** to your credit card and/or funding account, and (iii) **acknowledge if a charge is declined or reversed you may also be assessed a customary charge** by the payment processor for such transactions.","FARM_BILL_SEARCH_CONFIDENTIAL":"As a registered Farm Bill Buyer with the Montana Secretary of State’s office it is important to maintain the confidentiality of the information contained within the Farm Bill Master List. The Farm Bill Master List reflects personal data, such as Social Security Numbers, which are a key piece of personal identifiable information to assist you in determining the existence of a lien against a specific debtor. The distribution of this information beyond its intended purpose is strictly prohibited.\n\n**The debtor's tax identification number has been hidden for confidentiality reasons. You may continue to search on a tax ID number and return debtors that match your search criteria. The SSN/FEIN must be entered without dashes or spaces.  If you need access to the tax identification number to clearly identify the debtor, please contact the UCC unit at (406) 444-3665.**","VIEW_HISTORY_BUTTON_ALT_TEXT":"View Filings","WIZARD_ERROR_TITLE_MESSAGE":"Form Error","FARM_BILL_SEARCH_INTERACTIVE":true,"USE_FARM_BILL_API":true,"DISALLOW_ASSIGN_SELF_AS_RA":true,"DISALLOW_ASSIGN_SELF_AS_PRINCIPAL":true,"USE_TRADEMARK_OWNER_VALIDATION":true,"USE_ALTERNATIVE_FOREIGN_ADDRESS_LABELS":true,"MY_RECEIPTS_FILTER":[{"type":"dateRange","name":"DATE_RANGE","label":"Date range","defaultValue":{"start":null,"end":null}},{"type":"text","name":"REF_NUM","defaultValue":"","label":"Reference Number"},{"type":"text","name":"RECEIPT_NUM","defaultValue":"","label":"Receipt Id"},{"type":"text","name":"AMOUNT","defaultValue":"","label":"Amount"},{"type":"select","name":"TYPE","defaultValue":"","label":"Payment Type","options":[{"value":"","label":"All"},{"value":"CC","label":"Credit Card"},{"value":"Check","label":"Check"}]}],"MY_RECEIPTS_SHOW_IN_SIDEBAR":true,"SHOW_MY_RECEIPTS_HELPER_TEXT":true,"MY_RECEIPTS_HELPER_LABEL":"About Receipt Search","MY_RECEIPTS_HELPER_TEXT":"You can search for receipts based on their descriptions, including the items paid for on the receipt. Use the filters to search for or filter specific information.","FARM_BILL_SUBLINK":{"label":"Farm Bill","component":"FarmBill","parameter":"farm-bill","path":"/lists/farm-bill","sourceTypeId":0,"myRecordsSearch":false,"allowedRules":["/search/"],"disabled":true,"searchDescription":"To perform a search, enter a debtor name. Your search results may include: exact debtor name, variations of that name and any filing that includes your search criteria. Punctuation is ignored.\n\nYou can click on \"Advanced\" to refine your search. Under “Advanced” you can search by crop, year, county and SSN/FEIN. As a registered Farm Bill Buyer with the Montana Secretary of State’s office it is important to maintain the confidentiality of the information contained within the Farm Bill Master List. The Farm Bill Master List reflects personal data, such as Social Security Numbers, which are a key piece of personal identifiable information to assist you in determining the existence of a lien against a specific debtor. The distribution of this information beyond its intended purpose is strictly prohibited.\n\nThe debtor's tax identification number has been hidden for confidentiality reasons. You may continue to search on a tax ID number and return debtors that match your search criteria. The SSN/FEIN must be entered without dashes or spaces.","searchMustHaveOneOf":["search","UCC_FARM_PRODUCT_ID","COUNTY"],"searchPlaceholder":"Search by debtor name","advancedSearchParameters":[{"type":"ServerMultiComplete","label":"Product code name(s)","name":"UCC_FARM_PRODUCT_ID","defaultValue":"","optionsSrc":"UCC_FARM_PRODUCT_V"},{"type":"MultiComplete","label":"Year or Range of Years","name":"YEAR_NUM","optionsSrc":"years","startYear":"1968","defaultValue":[],"preMergeOptions":[{"value":"ALL","label":"All"}]},{"type":"serverSelect","label":"State","name":"STATE","defaultValue":"MONTANA","optionsSrc":"STATE"},{"type":"ServerMultiComplete","label":"County","name":"COUNTY","defaultValue":[],"optionsSrc":"COUNTY","overrideSubOptionsSrcFromParameterName":"STATE"},{"type":"checkbox","name":"TIN_SEARCH_YN","defaultValue":false,"label":"Tax Identification Number Search"},{"type":"checkbox","name":"TIN_SORT_YN","defaultValue":false,"label":"Unique ID Sort"}]},"ALLOW_ADDRESS_VALIDATION_BYPASS_OPTION":true,"DEFAULT_ADDRESS_VALIDATION_BYPASS_OPTION_CHECKED":true}).RA_MAILING_DEFAULT_STATE || ''
	  });
	};
	var RA_TYPE_SELECTION_DEFAULT = (true);
	
	var RegisteredAgentSearch = exports.RegisteredAgentSearch = function (_AddressBlock) {
	  _inherits(RegisteredAgentSearch, _AddressBlock);
	
	  function RegisteredAgentSearch() {
	    var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	    _classCallCheck(this, RegisteredAgentSearch);
	
	    var _this23 = _possibleConstructorReturn(this, (RegisteredAgentSearch.__proto__ || Object.getPrototypeOf(RegisteredAgentSearch)).call(this, props));
	
	    _this23.getByType = function (type, value) {
	      switch (type) {
	        case 'address':
	          return value ? _react2.default.createElement(_utilities.FormattedAddress, { value: value, className: 'value' }) : "None";
	        case 'h1':
	          return _react2.default.createElement(
	            'span',
	            { className: 'primary' },
	            value
	          );
	        case 'h2':
	          return _react2.default.createElement(
	            'span',
	            { className: 'secondary' },
	            value
	          );
	        case 'subtitle':
	          return _react2.default.createElement(
	            'span',
	            { className: 'subtitle' },
	            value
	          );
	        case 'line':
	          return _react2.default.createElement(
	            'span',
	            { className: '' },
	            value
	          );
	        default:
	          return _react2.default.createElement(
	            'span',
	            null,
	            value
	          );
	      }
	    };
	
	    _this23.type = "registeredAgentSearch";
	    _this23.fieldClass = "RegisteredAgentSearch";
	    _this23.value = Object.assign({}, getRegisteredAgentValueObject(props.value), {
	      MAIL_ADDR: resolveAgentMailingAddress(props.value)
	    });
	    if (_this23.value.MAIL_ADDR.COUNTRY === '') _this23.value.MAIL_ADDR.COUNTRY = 'United States';
	    _this23.selected = props.selected || null;
	    _this23.label = props.label || "Registered Agent";
	    _this23.sectionLabel = props.sectionLabel || '';
	    _this23.hideLabel = true;
	    _this23.hideTooltip = true;
	    _this23.showCounty = false;
	    _this23.showCountry = false;
	    _this23.disableState = props.disableState === false ? false : true;
	    _this23.disableMailingState = props.disableMailingState || false;
	    _this23.searchPlaceholder = props.searchPlaceholder || "(Search by name of individual or organization)";
	    _this23.showMailingAddress = props.showMailingAddress || false;
	    _this23.agentSelected = props.agentSelected || false;
	    _this23.allowedRules = ["registeredAgentIsRequired", "registeredAgentNotSoS", "registeredAgentAddressIsValid", "poBoxNotAllowed", 'checkForRegulatedWords', 'customBusinessRules'];
	    _this23.allowedMasks = ["addressUpperCase"];
	    _this23.defaultState = ({"NODE_ENV":"production","BUILD_DATE":"2025-08-27T15:15:31.687Z","BUILD_NUMBER":"Not Provided","GIT_VERSION":"v1.3.0-381-ga81e29b08","GIT_COMMIT_HASH":"a81e29b085c9268ffd96c78eb734365802722741","GIT_BRANCH":"beta","PUBLIC_URL":"","STATE_ABBR":"MT","STATE_NAME":"Montana","STATE_ORG_TITLE":"Secretary of State","LOGIN_HEADER_IMG_PATH":"","HOME_IMG_FILENAME":"montana.jpg","FAVICON_FILE_NAME":"favicon.ico","ALLOW_E_SIGN_ON_CORRECTIONS":true,"THIRD_PARTY_SIGNING_ALLOWED":false,"MY_ACCOUNT_SAVE_AND_CLOSE_BUTTON":true,"IE_DEPRECATED_MESSAGE":"Internet Explorer is not supported. Please select a supported browser below to access this website.","ADDITIONAL_ROUTES":{"dataRequests":true,"farmBill":true,"apostille":true,"externalHelp":"https://sosmt.gov/business/help-center/","systemAdministration":[{"title":"Saved Payments","parameter":"saved-payments","componentName":"SavedPayments"}]},"SUBROUTES":[{"label":"Business","component":"Business","parameter":"business","myWorkQueueSearch":false,"sourceTypeId":54,"searchMustHaveOneOf":["FILING_TYPE_ID","STATUS_ID","STATE","search"],"serverWebSearchDescription":true,"serverWorkQueueDescription":true,"serverMyRecordsDescription":true,"searchPlaceholder":"Search by name or filing number (X########)","allowEmptySearchTerm":true,"requestCertificateAlternateLabel":"Request Information","fileAmendmentButtonLabel":"Filing Actions","advancedSearchParameters":[{"type":"radio","name":"QUERY_TYPE_ID","defaultValue":1010,"options":[{"value":1010,"label":"Starts with"},{"value":1011,"label":"Contains"},{"value":1012,"label":" Word Contains"}]},{"type":"serverSelect","name":"FILING_TYPE_ID","optionsSrc":"FILING_TYPES","label":"Entity Type","placeholder":"All","defaultValue":"0"},{"type":"serverSelect","name":"FILING_SUBTYPE_ID","optionsSrc":"FILING_SUBTYPES","label":"Entity Subtype","overrideSubOptionsSrcFromParameterName":"FILING_TYPE_ID","placeholder":"All","defaultValue":"0"},{"type":"serverSelect","name":"STATUS_ID","optionsSrc":"FILING_STATUS_WITHOUT_ALL","label":"Status","placeholder":"All","defaultValue":"0"},{"type":"serverSelect","name":"STATE","optionsSrc":"STATE","label":"State","placeholder":"All","defaultValue":""},{"type":"serverSelect","name":"COUNTY","optionsSrc":"COUNTY_SUBOPTION","label":"County","overrideSubOptionsSrcFromParameterName":"STATE","placeholder":"All","defaultValue":""},{"type":"checkbox","name":"CRA_SEARCH_YN","defaultValue":false,"label":"Search by Registered Agent PID"},{"type":"dateRange","name":"FILING_DATE","label":"Registration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}},{"type":"dateRange","name":"EXPIRATION_DATE","label":"Expiration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}}],"myRecordsFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Active"},{"value":2,"label":"Inactive"},{"value":3,"label":"Pending"}]},{"type":"dateRange","name":"DATE_RANGE","label":"Date range","defaultValue":{"start":null,"end":null}}],"myWorkQueueFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Approved"},{"value":2,"label":"Pending Online Payment"},{"value":3,"label":"Pending Review"},{"value":4,"label":"Needs Correction"},{"value":5,"label":"Rejected"},{"value":6,"label":"Draft"}]},{"type":"dateRange","name":"DATE_RANGE","label":"Date range","defaultValue":{"start":null,"end":null}}]},{"label":"Notary","component":"Notary","parameter":"notary","sourceTypeId":850,"myWorkQueueSearch":false,"allowEmptySearchTerm":true,"requestCertificateAlternateLabel":"Download Certificate","fileAmendmentButtonLabel":"Filing Actions","hideNameRequestCertificate":true,"hideAddressRequestCertificate":true,"hideRecordUserManagment":true,"searchPlaceholder":"Search by name or commission number","searchMustHaveOneOf":["CITY","search","SERVICE_TYPE"],"advancedParametersStartOpen":true,"searchIsSortable":true,"advancedSearchParameters":[{"type":"radio","name":"STARTS_WITH_YN","defaultValue":false,"options":[{"value":true,"label":"Starts with"},{"value":false,"label":"Contains"}]},{"type":"checkbox","name":"ACTIVE_ONLY_YN","defaultValue":true,"label":"Active entities only"},{"type":"text","name":"CITY","defaultValue":"","label":"City"},{"type":"select","name":"SERVICE_TYPE","label":"Special Services Offered","defaultValue":0,"options":[{"value":0,"label":"(N/A)"},{"value":6165,"label":"In-Person Electronic Notarization (IPEN)"},{"value":6166,"label":"Remote Online Notarization (RON)"},{"value":6167,"label":"Mobile Notary Services"},{"value":6168,"label":"Remote Ink Notarization (RIN)"}]}]},{"label":"Apostille","component":"Apostille","parameter":"apostille","sourceTypeId":720,"myRecordsSearch":false,"myWorkQueueSearch":false,"disabled":false,"allowedRoutes":["/forms-manager/","/queue/","/forms/"]},{"label":"Liens","component":"UCC","parameter":"ucc","sourceTypeId":1999,"myRecordsSearch":true,"myWorkQueueSearch":true,"fileAmendmentButtonLabel":"Filing Actions","searchPlaceholder":"Search by name or file number","disabled":false,"serverWebSearchDescription":true,"myRecordsDescription":"","workQueueDescription":"","searchDescription":"","hideRecordUserManagment":true,"searchLiensCheckout":false,"advancedSearchParameters":[{"type":"radio","name":"STARTS_WITH_YN","defaultValue":false,"options":[{"value":true,"label":"Starts with"},{"value":false,"label":"Contains"}]},{"type":"select","name":"STATUS","defaultValue":"ALL","label":"Status","options":[{"value":"ACTIVE_UNLAPSED","label":"Active (unlapsed)"},{"value":"ACTIVE_LAPSED_UNLAPSED","label":"Active (lapsed and unlapsed)"}]},{"type":"text","name":"EXCLUDE_VALUES","label":"Exclude Debtor Names (comma separated list of names to exclude)","defaultValue":""},{"type":"dateRange","name":"FILING_DATE","label":"Financing Statement Date","defaultValue":{"start":null,"end":null}},{"type":"dateRange","name":"LAPSE_DATE","label":"Lapse Date","defaultValue":{"start":null,"end":null}},{"type":"text","name":"CITY","label":"Debtor City","defaultValue":""}],"myRecordsFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Approved"},{"value":2,"label":"Pending Online Payment"},{"value":3,"label":"Pending Review"}]},{"type":"select","name":"TYPE","defaultValue":0,"label":"Lien Type","options":[{"value":0,"label":"All"},{"value":1,"label":"UCC"},{"value":2,"label":"EFS"},{"value":3,"label":"Title 71"}]}],"myWorkQueueFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Approved"},{"value":2,"label":"Pending Online Payment"},{"value":3,"label":"Pending Review"},{"value":4,"label":"Pending Print and Mail"},{"value":5,"label":"Rejected"},{"value":6,"label":"Draft"}]},{"type":"select","name":"TYPE","defaultValue":0,"label":"Lien Type","options":[{"value":0,"label":"All"},{"value":1,"label":"UCC"},{"value":2,"label":"EFS"},{"value":3,"label":"Title 71"}]}]},{"label":"Copy Request","component":"copies","parameter":"copies","sourceTypeId":2001,"myRecordsSearch":false,"myWorkQueueSearch":false,"disabled":false,"allowedRoutes":["/forms-manager/","/queue/","/forms/"]},{"label":"Trademark","component":"Trademark","parameter":"trademark","sourceTypeId":810,"showRequestCertificate":true,"searchMustHaveOneOf":["search","EXPIRATION_DATE","FILING_DATE"],"allowEmptySearchTerm":true,"requestCertificateAlternateLabel":"Request Information","fileAmendmentButtonLabel":"Filing Actions","advancedSearchParameters":[{"type":"radio","name":"QUERY_TYPE_ID","defaultValue":1010,"options":[{"value":1010,"label":"Starts with"},{"value":1011,"label":"Contains"},{"value":1012,"label":" Word Contains"}]},{"type":"checkbox","name":"OWNER_SEARCH_YN","defaultValue":false,"label":"Search owners"},{"type":"radio","name":"SERVICE_MARK_YN","label":"Mark Type","defaultValue":"","options":[{"value":"","label":"All Marks"},{"value":"Y","label":"Service Mark"},{"value":"N","label":"Trademark"}]},{"type":"serverSelect","name":"STATUS_ID","optionsSrc":"TYPE_V|TRADEMARK_STATUS_TYPE","label":"Status","placeholder":"All","defaultValue":"0"},{"type":"select","name":"DESIGN_TYPE_ID","options":[{"value":0,"label":"All"},{"value":990,"label":"Words Only"},{"value":991,"label":"Design Only"},{"value":992,"label":"Words and Design"}],"label":"Design Type","defaultValue":"0"},{"type":"dateRange","name":"FILING_DATE","label":"Registered Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}},{"type":"dateRange","name":"EXPIRATION_DATE","label":"Expiration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}}]},{"label":"Business Info Request","component":"InfoRequests","parameter":"info-request","sourceTypeId":167,"allowedRoutes":["/forms-manager/","/queue/","/forms/"]},{"label":"Data Requests","component":"DataRequests","parameter":"data-request","sourceTypeId":0,"allowedRoutes":["/forms-manager/"]},{"label":"CRA","component":"CRA","parameter":"cra","sourceTypeId":157,"myRecordsSearch":false,"searchPlaceholder":"Search by name or registered agent number","allowedRoutes":["/forms-manager/","/forms/","/records/","/queue/","/search/"],"allowEmptySearchTerm":true,"fileAmendmentButtonLabel":"Filing Actions","advancedSearchParameters":[{"type":"radio","name":"QUERY_TYPE_ID","defaultValue":1010,"options":[{"value":1010,"label":"Starts with"},{"value":1011,"label":"Contains"},{"value":1012,"label":" Word Contains"}]},{"type":"dateRange","name":"CRA_DATE","label":"Registration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}},{"type":"select","name":"STATUS_ID","label":"Status","defaultValue":0,"options":[{"value":0,"label":"All"},{"value":121,"label":"Active"},{"value":122,"label":"Inactive"}]},{"type":"select","name":"AGENT_TYPE_ID","label":"Agent Type","defaultValue":0,"options":[{"value":0,"label":"All"},{"value":460,"label":"Registered Agent"},{"value":461,"label":"Commercial Registered Agent"}]}]},{"label":"Farm Bill","component":"FarmBill","parameter":"farm-bill","path":"/lists/farm-bill","sourceTypeId":0,"myRecordsSearch":false,"allowedRules":["/search/"],"disabled":true,"searchDescription":"To perform a search, enter a debtor name. Your search results may include: exact debtor name, variations of that name and any filing that includes your search criteria. Punctuation is ignored.\n\nYou can click on \"Advanced\" to refine your search. Under “Advanced” you can search by crop, year, county and SSN/FEIN. As a registered Farm Bill Buyer with the Montana Secretary of State’s office it is important to maintain the confidentiality of the information contained within the Farm Bill Master List. The Farm Bill Master List reflects personal data, such as Social Security Numbers, which are a key piece of personal identifiable information to assist you in determining the existence of a lien against a specific debtor. The distribution of this information beyond its intended purpose is strictly prohibited.\n\nThe debtor's tax identification number has been hidden for confidentiality reasons. You may continue to search on a tax ID number and return debtors that match your search criteria. The SSN/FEIN must be entered without dashes or spaces.","searchMustHaveOneOf":["search","UCC_FARM_PRODUCT_ID","COUNTY"],"searchPlaceholder":"Search by debtor name","advancedSearchParameters":[{"type":"ServerMultiComplete","label":"Product code name(s)","name":"UCC_FARM_PRODUCT_ID","defaultValue":"","optionsSrc":"UCC_FARM_PRODUCT_V"},{"type":"MultiComplete","label":"Year or Range of Years","name":"YEAR_NUM","optionsSrc":"years","startYear":"1968","defaultValue":[],"preMergeOptions":[{"value":"ALL","label":"All"}]},{"type":"serverSelect","label":"State","name":"STATE","defaultValue":"MONTANA","optionsSrc":"STATE"},{"type":"ServerMultiComplete","label":"County","name":"COUNTY","defaultValue":[],"optionsSrc":"COUNTY","overrideSubOptionsSrcFromParameterName":"STATE"},{"type":"checkbox","name":"TIN_SEARCH_YN","defaultValue":false,"label":"Tax Identification Number Search"},{"type":"checkbox","name":"TIN_SORT_YN","defaultValue":false,"label":"Unique ID Sort"}]}],"SYSTEM_NICKNAME":"Online Services Portal","PAYMENT_METHODS":[{"type":"bypass"},{"type":"iTransact"}],"PAYMENT_ALLOW_AMEX":true,"SYSTEM_ID_LABEL":"System Id","DOUBLE_COLUMN_PUBLIC_LOGIN":true,"INTERNAL_USER_MANAGEMENT":true,"ALLOW_PUBLIC_JSON_IMPORT":false,"MAX_FILE_UPLOAD_SIZE":10000000,"REFUND_TEXT":"","RETURN_TO_HOME_ON_LOGOUT":true,"CURRENT_SOS_NAME":"Christi Jacobsen","LOGO_FILENAME":"mt-sos-logo.png","LOGO_ALT":"Christi Jacobsen, Montana Secretary of State","LOGO_FULL_WIDTH":true,"HOME_HIDE_AUTH_HINT":true,"HOME_TITLE":"Montana Secretary of State","CUSTOM_TAB_TITLE":"Official Montana","HOME_SUBTITLE":"Online Business Services","ENTITY_NAME_CONSENT_DESCRIPTION":"","ALLOW_USER_PROFILE_EDITING":true,"COMPARE_FOREIGN_NAME_IN_ENTITY_NAME_VALIDATION":true,"FOREIGN_NAME_FIELD_NAME":"KIMA_PARENT_NAME_INFO","LOGIN_TITLE":"Montana Secretary of State Online Filing Portal Login","PUBLIC_LOGIN_LABEL":"Username","REVERSE_LOGIN_COLUMNS":true,"LOGIN_SEAL_FILENAME":"seal_white.png","SEPARATE_USERNAME_AND_EMAIL":true,"CREATE_ACCOUNT_BUTTON_ALIGN_LEFT":true,"CREATE_ACCOUNT_BUTTON_TEXT":"CREATE AN ACCOUNT","PASSWORD_CUSTOM_ERROR_TEXT":"The password must meet all requirements","ACCOUNT_CREATED_MESSAGE":"Please check your email to verify your account to login and allow a few minutes for this message to arrive. Check your junk/spam folders if you do not find the email in your inbox.","PUBLIC_LOGIN_PLACEHOLDER":" ","DISABLE_DEFAULT_PAYMENT_RADIO":true,"CUSTOM_RESET_PASSWORD_ERROR_MESSAGE":"Username invalid - no account found","PUBLIC_LOGIN_CREATE_DESCRIPTION":"### Existing User:\n\n  - Enter your username and password to login.  \n\n\n  #### - OR -  \n\n\n\n  - Forgot password? Click 'Reset Password' and follow the prompts.\n  - Forgot username? Click 'Forgot Username' and follow the prompts.  \n\n\n  ### New User:\n  ","LOGIN_HELP_LINK":"https://sosmt.gov/business/how-do-i/","LOGIN_HELP_LINK_TEXT":"Need Help?","FORGOT_USERNAME_TEXT":"Forgot Username?","LOGIN_ACTIVE_DIRECTORY_TEXT":"State User Login","MULTIPLE_LOGIN_METHODS":true,"HAS_ACTIVE_DIRECTORY_LOGIN":true,"RESET_PASSWORD_WITH_USERNAME":true,"DOWNLOAD_LINK":true,"SHOW_USERNAME_ACCOUNT_CREATE":true,"SHOW_SCROLL_DOWN_ARROW":true,"SHOW_ADDRESS_ACCOUNT_CREATE":true,"TWO_COLUMN_ACCOUNT_CREATE":true,"RESET_PASSWORD_TIP":"A link to change your password has been sent to your email. Please allow a few minutes for this message to arrive. Please check your junk/spam folders if you do not find the email in your inbox.","FORGOT_PASSWORD_LINK_TEXT":"Reset Password","PHONE_NUMBER_OPTIONAL_ACCOUNT_CREATE":true,"SHOW_REQUIRED_INDICATOR_ACCOUNT_CREATE":true,"PASSWORD_REQUIREMENTS_ACCOUNT_CREATE":"\n    <ul>\n      <li>MUST contain at least 8 characters (12+ recommended)</li>\n      <li>MUST contain at least one uppercase letter.</li>\n      <li>MUST contain at least one lowercase letter.</li>\n      <li>MUST contain at least one number.</li>\n      <li>MUST contain at least one special character (!”#$%&'()*+,-./:;<=>?</li>\n    </ul>\n  ","ALLOW_CERTIFICATION_REQUEST":true,"ALLOW_PUBLIC_CERTIFICATE_REQUEST":true,"ALLOW_COPY_REQUEST":false,"ALLOW_CORRECTION_STYLING":true,"HIDE_DEPRECATION_WARNING":false,"AMEND_ROUTE_PUBLIC":true,"SEAL_FILENAME":"seal.png","SHOPPING_CART":true,"ALLOW_PAYMENT_UPDATE_WITH_EMPTY_CART":true,"RA_EMAIL":true,"RA_WEBSITE":true,"RA_NO_DEFAULT_TYPE":true,"RA_ADDRESS_LABEL":"Street Address","RA_TYPE_SELECTION_DEFAULT":true,"RA_DEFAULT_TYPE":"460","RA_OVERRIDE_TYPE_WITH_DEFAULT":true,"RA_PRINCIPAL_ADDRESS_AMS":true,"UPLOAD_AND_SUBMIT_HIDE_IF_ONE_OPTION":true,"PAYMENT_PROCESSING_MESSAGE":"Your payment is processing - Do not close your browser or click the back button","CHECKOUT_BUTTON_WHEN_PROCESSING_TEXT":"Processing","EFS_CROP_PICKER_NONE_LABEL":"Lien Duration","DISALLOWED_WIZARD_PIECES":["FormationLocale"],"REPEATER_SHOW_EDIT_BUTTON":true,"DATA_REQUEST_PAGE_TITLE":"Data Requests and Subscriptions","DATA_REQUEST_SIDEBAR_LABEL":"Data Requests & Subscriptions","LOGIN_REDIRECTS_TO_EPASS":false,"LOGIN_REDIRECTS_TO_ACTIVE_DIRECTORY":true,"LOGIN_ACTIVE_DIRECTORY_LINK":true,"FETCH_EDIT_USER_LINK":false,"LISTS_FETCH_AVAILABLE_LISTS":true,"POST_WIZARD_SUBMIT_REDIRECT_URL":"/","PIN_REQUEST_ATTESTATIONS":true,"PIN_REQUEST_DESCRIPTION":"Click **Request PIN** to have a new PIN sent to the account holder's email address on file.","OWNERSHIP_REQUEST_DESCRIPTION":"To become an **authorized user** of this record, a current **AUTHORIZED USER** will need to grant you access. To request access, click **Request Access** below.","PIN_REQUEST_SUCCESS_MESSAGE":"The PIN you have requested for this entity has been sent to the email associated with your user account.  You should receive the PIN in approximately 3-5 minutes, depending on your email service provider.","APOSTILLE_HEADER_LABEL":"Verification Information","APOSTILLE_NUMBER_LABEL":"Apostille/Authentication","APOSTILLE_CITY_STATE_OVERRIDE":"HELENA, MT","APOSTILLE_FILING_DATE_LABEL":"Issue Date","APOSTILLE_CITY_STATE_IN_CERTIFIED":true,"NOTARY_EXISTING_FILING":true,"ALLOW_REVOKE_OWN_ACCESS_ONLY":false,"HIDE_CANCEL_ON_ONETIME_DATA_REQUESTS":true,"DATA_REQUESTS_IN_SHOPPING_CART":true,"WQ_ALLOW_EDIT_PENDING_PAYMENT":true,"WQ_CONFIRM_ON_DELETE":true,"WQ_DELETE_CONFIRM_MESSAGE":"Deleting this filing will forfeit any money already paid to the Secretary of State. This action is permanent and cannot be undone, are you sure you would like to delete?","PASS_ITEM_GUIDS_ON_CHECKOUT":true,"FORM_REVISION_HISTORY":true,"CHECKOUT_DISCLAIMER":"By entering your credit card and/or checking account information you (i) state that **you are an authorized user** of the credit card and/or electronic check and that the associated information entered (e.g., account holder name, account number, billing address) is accurate, (ii) **you authorize payment processor to charge the amount you have requested** to your credit card and/or funding account, and (iii) **acknowledge if a charge is declined or reversed you may also be assessed a customary charge** by the payment processor for such transactions.","FARM_BILL_SEARCH_CONFIDENTIAL":"As a registered Farm Bill Buyer with the Montana Secretary of State’s office it is important to maintain the confidentiality of the information contained within the Farm Bill Master List. The Farm Bill Master List reflects personal data, such as Social Security Numbers, which are a key piece of personal identifiable information to assist you in determining the existence of a lien against a specific debtor. The distribution of this information beyond its intended purpose is strictly prohibited.\n\n**The debtor's tax identification number has been hidden for confidentiality reasons. You may continue to search on a tax ID number and return debtors that match your search criteria. The SSN/FEIN must be entered without dashes or spaces.  If you need access to the tax identification number to clearly identify the debtor, please contact the UCC unit at (406) 444-3665.**","VIEW_HISTORY_BUTTON_ALT_TEXT":"View Filings","WIZARD_ERROR_TITLE_MESSAGE":"Form Error","FARM_BILL_SEARCH_INTERACTIVE":true,"USE_FARM_BILL_API":true,"DISALLOW_ASSIGN_SELF_AS_RA":true,"DISALLOW_ASSIGN_SELF_AS_PRINCIPAL":true,"USE_TRADEMARK_OWNER_VALIDATION":true,"USE_ALTERNATIVE_FOREIGN_ADDRESS_LABELS":true,"MY_RECEIPTS_FILTER":[{"type":"dateRange","name":"DATE_RANGE","label":"Date range","defaultValue":{"start":null,"end":null}},{"type":"text","name":"REF_NUM","defaultValue":"","label":"Reference Number"},{"type":"text","name":"RECEIPT_NUM","defaultValue":"","label":"Receipt Id"},{"type":"text","name":"AMOUNT","defaultValue":"","label":"Amount"},{"type":"select","name":"TYPE","defaultValue":"","label":"Payment Type","options":[{"value":"","label":"All"},{"value":"CC","label":"Credit Card"},{"value":"Check","label":"Check"}]}],"MY_RECEIPTS_SHOW_IN_SIDEBAR":true,"SHOW_MY_RECEIPTS_HELPER_TEXT":true,"MY_RECEIPTS_HELPER_LABEL":"About Receipt Search","MY_RECEIPTS_HELPER_TEXT":"You can search for receipts based on their descriptions, including the items paid for on the receipt. Use the filters to search for or filter specific information.","FARM_BILL_SUBLINK":{"label":"Farm Bill","component":"FarmBill","parameter":"farm-bill","path":"/lists/farm-bill","sourceTypeId":0,"myRecordsSearch":false,"allowedRules":["/search/"],"disabled":true,"searchDescription":"To perform a search, enter a debtor name. Your search results may include: exact debtor name, variations of that name and any filing that includes your search criteria. Punctuation is ignored.\n\nYou can click on \"Advanced\" to refine your search. Under “Advanced” you can search by crop, year, county and SSN/FEIN. As a registered Farm Bill Buyer with the Montana Secretary of State’s office it is important to maintain the confidentiality of the information contained within the Farm Bill Master List. The Farm Bill Master List reflects personal data, such as Social Security Numbers, which are a key piece of personal identifiable information to assist you in determining the existence of a lien against a specific debtor. The distribution of this information beyond its intended purpose is strictly prohibited.\n\nThe debtor's tax identification number has been hidden for confidentiality reasons. You may continue to search on a tax ID number and return debtors that match your search criteria. The SSN/FEIN must be entered without dashes or spaces.","searchMustHaveOneOf":["search","UCC_FARM_PRODUCT_ID","COUNTY"],"searchPlaceholder":"Search by debtor name","advancedSearchParameters":[{"type":"ServerMultiComplete","label":"Product code name(s)","name":"UCC_FARM_PRODUCT_ID","defaultValue":"","optionsSrc":"UCC_FARM_PRODUCT_V"},{"type":"MultiComplete","label":"Year or Range of Years","name":"YEAR_NUM","optionsSrc":"years","startYear":"1968","defaultValue":[],"preMergeOptions":[{"value":"ALL","label":"All"}]},{"type":"serverSelect","label":"State","name":"STATE","defaultValue":"MONTANA","optionsSrc":"STATE"},{"type":"ServerMultiComplete","label":"County","name":"COUNTY","defaultValue":[],"optionsSrc":"COUNTY","overrideSubOptionsSrcFromParameterName":"STATE"},{"type":"checkbox","name":"TIN_SEARCH_YN","defaultValue":false,"label":"Tax Identification Number Search"},{"type":"checkbox","name":"TIN_SORT_YN","defaultValue":false,"label":"Unique ID Sort"}]},"ALLOW_ADDRESS_VALIDATION_BYPASS_OPTION":true,"DEFAULT_ADDRESS_VALIDATION_BYPASS_OPTION_CHECKED":true}).RA_MAILING_DEFAULT_STATE || props.defaultState || '';
	    _this23.defaultMailState = ({"NODE_ENV":"production","BUILD_DATE":"2025-08-27T15:15:31.687Z","BUILD_NUMBER":"Not Provided","GIT_VERSION":"v1.3.0-381-ga81e29b08","GIT_COMMIT_HASH":"a81e29b085c9268ffd96c78eb734365802722741","GIT_BRANCH":"beta","PUBLIC_URL":"","STATE_ABBR":"MT","STATE_NAME":"Montana","STATE_ORG_TITLE":"Secretary of State","LOGIN_HEADER_IMG_PATH":"","HOME_IMG_FILENAME":"montana.jpg","FAVICON_FILE_NAME":"favicon.ico","ALLOW_E_SIGN_ON_CORRECTIONS":true,"THIRD_PARTY_SIGNING_ALLOWED":false,"MY_ACCOUNT_SAVE_AND_CLOSE_BUTTON":true,"IE_DEPRECATED_MESSAGE":"Internet Explorer is not supported. Please select a supported browser below to access this website.","ADDITIONAL_ROUTES":{"dataRequests":true,"farmBill":true,"apostille":true,"externalHelp":"https://sosmt.gov/business/help-center/","systemAdministration":[{"title":"Saved Payments","parameter":"saved-payments","componentName":"SavedPayments"}]},"SUBROUTES":[{"label":"Business","component":"Business","parameter":"business","myWorkQueueSearch":false,"sourceTypeId":54,"searchMustHaveOneOf":["FILING_TYPE_ID","STATUS_ID","STATE","search"],"serverWebSearchDescription":true,"serverWorkQueueDescription":true,"serverMyRecordsDescription":true,"searchPlaceholder":"Search by name or filing number (X########)","allowEmptySearchTerm":true,"requestCertificateAlternateLabel":"Request Information","fileAmendmentButtonLabel":"Filing Actions","advancedSearchParameters":[{"type":"radio","name":"QUERY_TYPE_ID","defaultValue":1010,"options":[{"value":1010,"label":"Starts with"},{"value":1011,"label":"Contains"},{"value":1012,"label":" Word Contains"}]},{"type":"serverSelect","name":"FILING_TYPE_ID","optionsSrc":"FILING_TYPES","label":"Entity Type","placeholder":"All","defaultValue":"0"},{"type":"serverSelect","name":"FILING_SUBTYPE_ID","optionsSrc":"FILING_SUBTYPES","label":"Entity Subtype","overrideSubOptionsSrcFromParameterName":"FILING_TYPE_ID","placeholder":"All","defaultValue":"0"},{"type":"serverSelect","name":"STATUS_ID","optionsSrc":"FILING_STATUS_WITHOUT_ALL","label":"Status","placeholder":"All","defaultValue":"0"},{"type":"serverSelect","name":"STATE","optionsSrc":"STATE","label":"State","placeholder":"All","defaultValue":""},{"type":"serverSelect","name":"COUNTY","optionsSrc":"COUNTY_SUBOPTION","label":"County","overrideSubOptionsSrcFromParameterName":"STATE","placeholder":"All","defaultValue":""},{"type":"checkbox","name":"CRA_SEARCH_YN","defaultValue":false,"label":"Search by Registered Agent PID"},{"type":"dateRange","name":"FILING_DATE","label":"Registration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}},{"type":"dateRange","name":"EXPIRATION_DATE","label":"Expiration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}}],"myRecordsFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Active"},{"value":2,"label":"Inactive"},{"value":3,"label":"Pending"}]},{"type":"dateRange","name":"DATE_RANGE","label":"Date range","defaultValue":{"start":null,"end":null}}],"myWorkQueueFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Approved"},{"value":2,"label":"Pending Online Payment"},{"value":3,"label":"Pending Review"},{"value":4,"label":"Needs Correction"},{"value":5,"label":"Rejected"},{"value":6,"label":"Draft"}]},{"type":"dateRange","name":"DATE_RANGE","label":"Date range","defaultValue":{"start":null,"end":null}}]},{"label":"Notary","component":"Notary","parameter":"notary","sourceTypeId":850,"myWorkQueueSearch":false,"allowEmptySearchTerm":true,"requestCertificateAlternateLabel":"Download Certificate","fileAmendmentButtonLabel":"Filing Actions","hideNameRequestCertificate":true,"hideAddressRequestCertificate":true,"hideRecordUserManagment":true,"searchPlaceholder":"Search by name or commission number","searchMustHaveOneOf":["CITY","search","SERVICE_TYPE"],"advancedParametersStartOpen":true,"searchIsSortable":true,"advancedSearchParameters":[{"type":"radio","name":"STARTS_WITH_YN","defaultValue":false,"options":[{"value":true,"label":"Starts with"},{"value":false,"label":"Contains"}]},{"type":"checkbox","name":"ACTIVE_ONLY_YN","defaultValue":true,"label":"Active entities only"},{"type":"text","name":"CITY","defaultValue":"","label":"City"},{"type":"select","name":"SERVICE_TYPE","label":"Special Services Offered","defaultValue":0,"options":[{"value":0,"label":"(N/A)"},{"value":6165,"label":"In-Person Electronic Notarization (IPEN)"},{"value":6166,"label":"Remote Online Notarization (RON)"},{"value":6167,"label":"Mobile Notary Services"},{"value":6168,"label":"Remote Ink Notarization (RIN)"}]}]},{"label":"Apostille","component":"Apostille","parameter":"apostille","sourceTypeId":720,"myRecordsSearch":false,"myWorkQueueSearch":false,"disabled":false,"allowedRoutes":["/forms-manager/","/queue/","/forms/"]},{"label":"Liens","component":"UCC","parameter":"ucc","sourceTypeId":1999,"myRecordsSearch":true,"myWorkQueueSearch":true,"fileAmendmentButtonLabel":"Filing Actions","searchPlaceholder":"Search by name or file number","disabled":false,"serverWebSearchDescription":true,"myRecordsDescription":"","workQueueDescription":"","searchDescription":"","hideRecordUserManagment":true,"searchLiensCheckout":false,"advancedSearchParameters":[{"type":"radio","name":"STARTS_WITH_YN","defaultValue":false,"options":[{"value":true,"label":"Starts with"},{"value":false,"label":"Contains"}]},{"type":"select","name":"STATUS","defaultValue":"ALL","label":"Status","options":[{"value":"ACTIVE_UNLAPSED","label":"Active (unlapsed)"},{"value":"ACTIVE_LAPSED_UNLAPSED","label":"Active (lapsed and unlapsed)"}]},{"type":"text","name":"EXCLUDE_VALUES","label":"Exclude Debtor Names (comma separated list of names to exclude)","defaultValue":""},{"type":"dateRange","name":"FILING_DATE","label":"Financing Statement Date","defaultValue":{"start":null,"end":null}},{"type":"dateRange","name":"LAPSE_DATE","label":"Lapse Date","defaultValue":{"start":null,"end":null}},{"type":"text","name":"CITY","label":"Debtor City","defaultValue":""}],"myRecordsFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Approved"},{"value":2,"label":"Pending Online Payment"},{"value":3,"label":"Pending Review"}]},{"type":"select","name":"TYPE","defaultValue":0,"label":"Lien Type","options":[{"value":0,"label":"All"},{"value":1,"label":"UCC"},{"value":2,"label":"EFS"},{"value":3,"label":"Title 71"}]}],"myWorkQueueFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Approved"},{"value":2,"label":"Pending Online Payment"},{"value":3,"label":"Pending Review"},{"value":4,"label":"Pending Print and Mail"},{"value":5,"label":"Rejected"},{"value":6,"label":"Draft"}]},{"type":"select","name":"TYPE","defaultValue":0,"label":"Lien Type","options":[{"value":0,"label":"All"},{"value":1,"label":"UCC"},{"value":2,"label":"EFS"},{"value":3,"label":"Title 71"}]}]},{"label":"Copy Request","component":"copies","parameter":"copies","sourceTypeId":2001,"myRecordsSearch":false,"myWorkQueueSearch":false,"disabled":false,"allowedRoutes":["/forms-manager/","/queue/","/forms/"]},{"label":"Trademark","component":"Trademark","parameter":"trademark","sourceTypeId":810,"showRequestCertificate":true,"searchMustHaveOneOf":["search","EXPIRATION_DATE","FILING_DATE"],"allowEmptySearchTerm":true,"requestCertificateAlternateLabel":"Request Information","fileAmendmentButtonLabel":"Filing Actions","advancedSearchParameters":[{"type":"radio","name":"QUERY_TYPE_ID","defaultValue":1010,"options":[{"value":1010,"label":"Starts with"},{"value":1011,"label":"Contains"},{"value":1012,"label":" Word Contains"}]},{"type":"checkbox","name":"OWNER_SEARCH_YN","defaultValue":false,"label":"Search owners"},{"type":"radio","name":"SERVICE_MARK_YN","label":"Mark Type","defaultValue":"","options":[{"value":"","label":"All Marks"},{"value":"Y","label":"Service Mark"},{"value":"N","label":"Trademark"}]},{"type":"serverSelect","name":"STATUS_ID","optionsSrc":"TYPE_V|TRADEMARK_STATUS_TYPE","label":"Status","placeholder":"All","defaultValue":"0"},{"type":"select","name":"DESIGN_TYPE_ID","options":[{"value":0,"label":"All"},{"value":990,"label":"Words Only"},{"value":991,"label":"Design Only"},{"value":992,"label":"Words and Design"}],"label":"Design Type","defaultValue":"0"},{"type":"dateRange","name":"FILING_DATE","label":"Registered Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}},{"type":"dateRange","name":"EXPIRATION_DATE","label":"Expiration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}}]},{"label":"Business Info Request","component":"InfoRequests","parameter":"info-request","sourceTypeId":167,"allowedRoutes":["/forms-manager/","/queue/","/forms/"]},{"label":"Data Requests","component":"DataRequests","parameter":"data-request","sourceTypeId":0,"allowedRoutes":["/forms-manager/"]},{"label":"CRA","component":"CRA","parameter":"cra","sourceTypeId":157,"myRecordsSearch":false,"searchPlaceholder":"Search by name or registered agent number","allowedRoutes":["/forms-manager/","/forms/","/records/","/queue/","/search/"],"allowEmptySearchTerm":true,"fileAmendmentButtonLabel":"Filing Actions","advancedSearchParameters":[{"type":"radio","name":"QUERY_TYPE_ID","defaultValue":1010,"options":[{"value":1010,"label":"Starts with"},{"value":1011,"label":"Contains"},{"value":1012,"label":" Word Contains"}]},{"type":"dateRange","name":"CRA_DATE","label":"Registration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}},{"type":"select","name":"STATUS_ID","label":"Status","defaultValue":0,"options":[{"value":0,"label":"All"},{"value":121,"label":"Active"},{"value":122,"label":"Inactive"}]},{"type":"select","name":"AGENT_TYPE_ID","label":"Agent Type","defaultValue":0,"options":[{"value":0,"label":"All"},{"value":460,"label":"Registered Agent"},{"value":461,"label":"Commercial Registered Agent"}]}]},{"label":"Farm Bill","component":"FarmBill","parameter":"farm-bill","path":"/lists/farm-bill","sourceTypeId":0,"myRecordsSearch":false,"allowedRules":["/search/"],"disabled":true,"searchDescription":"To perform a search, enter a debtor name. Your search results may include: exact debtor name, variations of that name and any filing that includes your search criteria. Punctuation is ignored.\n\nYou can click on \"Advanced\" to refine your search. Under “Advanced” you can search by crop, year, county and SSN/FEIN. As a registered Farm Bill Buyer with the Montana Secretary of State’s office it is important to maintain the confidentiality of the information contained within the Farm Bill Master List. The Farm Bill Master List reflects personal data, such as Social Security Numbers, which are a key piece of personal identifiable information to assist you in determining the existence of a lien against a specific debtor. The distribution of this information beyond its intended purpose is strictly prohibited.\n\nThe debtor's tax identification number has been hidden for confidentiality reasons. You may continue to search on a tax ID number and return debtors that match your search criteria. The SSN/FEIN must be entered without dashes or spaces.","searchMustHaveOneOf":["search","UCC_FARM_PRODUCT_ID","COUNTY"],"searchPlaceholder":"Search by debtor name","advancedSearchParameters":[{"type":"ServerMultiComplete","label":"Product code name(s)","name":"UCC_FARM_PRODUCT_ID","defaultValue":"","optionsSrc":"UCC_FARM_PRODUCT_V"},{"type":"MultiComplete","label":"Year or Range of Years","name":"YEAR_NUM","optionsSrc":"years","startYear":"1968","defaultValue":[],"preMergeOptions":[{"value":"ALL","label":"All"}]},{"type":"serverSelect","label":"State","name":"STATE","defaultValue":"MONTANA","optionsSrc":"STATE"},{"type":"ServerMultiComplete","label":"County","name":"COUNTY","defaultValue":[],"optionsSrc":"COUNTY","overrideSubOptionsSrcFromParameterName":"STATE"},{"type":"checkbox","name":"TIN_SEARCH_YN","defaultValue":false,"label":"Tax Identification Number Search"},{"type":"checkbox","name":"TIN_SORT_YN","defaultValue":false,"label":"Unique ID Sort"}]}],"SYSTEM_NICKNAME":"Online Services Portal","PAYMENT_METHODS":[{"type":"bypass"},{"type":"iTransact"}],"PAYMENT_ALLOW_AMEX":true,"SYSTEM_ID_LABEL":"System Id","DOUBLE_COLUMN_PUBLIC_LOGIN":true,"INTERNAL_USER_MANAGEMENT":true,"ALLOW_PUBLIC_JSON_IMPORT":false,"MAX_FILE_UPLOAD_SIZE":10000000,"REFUND_TEXT":"","RETURN_TO_HOME_ON_LOGOUT":true,"CURRENT_SOS_NAME":"Christi Jacobsen","LOGO_FILENAME":"mt-sos-logo.png","LOGO_ALT":"Christi Jacobsen, Montana Secretary of State","LOGO_FULL_WIDTH":true,"HOME_HIDE_AUTH_HINT":true,"HOME_TITLE":"Montana Secretary of State","CUSTOM_TAB_TITLE":"Official Montana","HOME_SUBTITLE":"Online Business Services","ENTITY_NAME_CONSENT_DESCRIPTION":"","ALLOW_USER_PROFILE_EDITING":true,"COMPARE_FOREIGN_NAME_IN_ENTITY_NAME_VALIDATION":true,"FOREIGN_NAME_FIELD_NAME":"KIMA_PARENT_NAME_INFO","LOGIN_TITLE":"Montana Secretary of State Online Filing Portal Login","PUBLIC_LOGIN_LABEL":"Username","REVERSE_LOGIN_COLUMNS":true,"LOGIN_SEAL_FILENAME":"seal_white.png","SEPARATE_USERNAME_AND_EMAIL":true,"CREATE_ACCOUNT_BUTTON_ALIGN_LEFT":true,"CREATE_ACCOUNT_BUTTON_TEXT":"CREATE AN ACCOUNT","PASSWORD_CUSTOM_ERROR_TEXT":"The password must meet all requirements","ACCOUNT_CREATED_MESSAGE":"Please check your email to verify your account to login and allow a few minutes for this message to arrive. Check your junk/spam folders if you do not find the email in your inbox.","PUBLIC_LOGIN_PLACEHOLDER":" ","DISABLE_DEFAULT_PAYMENT_RADIO":true,"CUSTOM_RESET_PASSWORD_ERROR_MESSAGE":"Username invalid - no account found","PUBLIC_LOGIN_CREATE_DESCRIPTION":"### Existing User:\n\n  - Enter your username and password to login.  \n\n\n  #### - OR -  \n\n\n\n  - Forgot password? Click 'Reset Password' and follow the prompts.\n  - Forgot username? Click 'Forgot Username' and follow the prompts.  \n\n\n  ### New User:\n  ","LOGIN_HELP_LINK":"https://sosmt.gov/business/how-do-i/","LOGIN_HELP_LINK_TEXT":"Need Help?","FORGOT_USERNAME_TEXT":"Forgot Username?","LOGIN_ACTIVE_DIRECTORY_TEXT":"State User Login","MULTIPLE_LOGIN_METHODS":true,"HAS_ACTIVE_DIRECTORY_LOGIN":true,"RESET_PASSWORD_WITH_USERNAME":true,"DOWNLOAD_LINK":true,"SHOW_USERNAME_ACCOUNT_CREATE":true,"SHOW_SCROLL_DOWN_ARROW":true,"SHOW_ADDRESS_ACCOUNT_CREATE":true,"TWO_COLUMN_ACCOUNT_CREATE":true,"RESET_PASSWORD_TIP":"A link to change your password has been sent to your email. Please allow a few minutes for this message to arrive. Please check your junk/spam folders if you do not find the email in your inbox.","FORGOT_PASSWORD_LINK_TEXT":"Reset Password","PHONE_NUMBER_OPTIONAL_ACCOUNT_CREATE":true,"SHOW_REQUIRED_INDICATOR_ACCOUNT_CREATE":true,"PASSWORD_REQUIREMENTS_ACCOUNT_CREATE":"\n    <ul>\n      <li>MUST contain at least 8 characters (12+ recommended)</li>\n      <li>MUST contain at least one uppercase letter.</li>\n      <li>MUST contain at least one lowercase letter.</li>\n      <li>MUST contain at least one number.</li>\n      <li>MUST contain at least one special character (!”#$%&'()*+,-./:;<=>?</li>\n    </ul>\n  ","ALLOW_CERTIFICATION_REQUEST":true,"ALLOW_PUBLIC_CERTIFICATE_REQUEST":true,"ALLOW_COPY_REQUEST":false,"ALLOW_CORRECTION_STYLING":true,"HIDE_DEPRECATION_WARNING":false,"AMEND_ROUTE_PUBLIC":true,"SEAL_FILENAME":"seal.png","SHOPPING_CART":true,"ALLOW_PAYMENT_UPDATE_WITH_EMPTY_CART":true,"RA_EMAIL":true,"RA_WEBSITE":true,"RA_NO_DEFAULT_TYPE":true,"RA_ADDRESS_LABEL":"Street Address","RA_TYPE_SELECTION_DEFAULT":true,"RA_DEFAULT_TYPE":"460","RA_OVERRIDE_TYPE_WITH_DEFAULT":true,"RA_PRINCIPAL_ADDRESS_AMS":true,"UPLOAD_AND_SUBMIT_HIDE_IF_ONE_OPTION":true,"PAYMENT_PROCESSING_MESSAGE":"Your payment is processing - Do not close your browser or click the back button","CHECKOUT_BUTTON_WHEN_PROCESSING_TEXT":"Processing","EFS_CROP_PICKER_NONE_LABEL":"Lien Duration","DISALLOWED_WIZARD_PIECES":["FormationLocale"],"REPEATER_SHOW_EDIT_BUTTON":true,"DATA_REQUEST_PAGE_TITLE":"Data Requests and Subscriptions","DATA_REQUEST_SIDEBAR_LABEL":"Data Requests & Subscriptions","LOGIN_REDIRECTS_TO_EPASS":false,"LOGIN_REDIRECTS_TO_ACTIVE_DIRECTORY":true,"LOGIN_ACTIVE_DIRECTORY_LINK":true,"FETCH_EDIT_USER_LINK":false,"LISTS_FETCH_AVAILABLE_LISTS":true,"POST_WIZARD_SUBMIT_REDIRECT_URL":"/","PIN_REQUEST_ATTESTATIONS":true,"PIN_REQUEST_DESCRIPTION":"Click **Request PIN** to have a new PIN sent to the account holder's email address on file.","OWNERSHIP_REQUEST_DESCRIPTION":"To become an **authorized user** of this record, a current **AUTHORIZED USER** will need to grant you access. To request access, click **Request Access** below.","PIN_REQUEST_SUCCESS_MESSAGE":"The PIN you have requested for this entity has been sent to the email associated with your user account.  You should receive the PIN in approximately 3-5 minutes, depending on your email service provider.","APOSTILLE_HEADER_LABEL":"Verification Information","APOSTILLE_NUMBER_LABEL":"Apostille/Authentication","APOSTILLE_CITY_STATE_OVERRIDE":"HELENA, MT","APOSTILLE_FILING_DATE_LABEL":"Issue Date","APOSTILLE_CITY_STATE_IN_CERTIFIED":true,"NOTARY_EXISTING_FILING":true,"ALLOW_REVOKE_OWN_ACCESS_ONLY":false,"HIDE_CANCEL_ON_ONETIME_DATA_REQUESTS":true,"DATA_REQUESTS_IN_SHOPPING_CART":true,"WQ_ALLOW_EDIT_PENDING_PAYMENT":true,"WQ_CONFIRM_ON_DELETE":true,"WQ_DELETE_CONFIRM_MESSAGE":"Deleting this filing will forfeit any money already paid to the Secretary of State. This action is permanent and cannot be undone, are you sure you would like to delete?","PASS_ITEM_GUIDS_ON_CHECKOUT":true,"FORM_REVISION_HISTORY":true,"CHECKOUT_DISCLAIMER":"By entering your credit card and/or checking account information you (i) state that **you are an authorized user** of the credit card and/or electronic check and that the associated information entered (e.g., account holder name, account number, billing address) is accurate, (ii) **you authorize payment processor to charge the amount you have requested** to your credit card and/or funding account, and (iii) **acknowledge if a charge is declined or reversed you may also be assessed a customary charge** by the payment processor for such transactions.","FARM_BILL_SEARCH_CONFIDENTIAL":"As a registered Farm Bill Buyer with the Montana Secretary of State’s office it is important to maintain the confidentiality of the information contained within the Farm Bill Master List. The Farm Bill Master List reflects personal data, such as Social Security Numbers, which are a key piece of personal identifiable information to assist you in determining the existence of a lien against a specific debtor. The distribution of this information beyond its intended purpose is strictly prohibited.\n\n**The debtor's tax identification number has been hidden for confidentiality reasons. You may continue to search on a tax ID number and return debtors that match your search criteria. The SSN/FEIN must be entered without dashes or spaces.  If you need access to the tax identification number to clearly identify the debtor, please contact the UCC unit at (406) 444-3665.**","VIEW_HISTORY_BUTTON_ALT_TEXT":"View Filings","WIZARD_ERROR_TITLE_MESSAGE":"Form Error","FARM_BILL_SEARCH_INTERACTIVE":true,"USE_FARM_BILL_API":true,"DISALLOW_ASSIGN_SELF_AS_RA":true,"DISALLOW_ASSIGN_SELF_AS_PRINCIPAL":true,"USE_TRADEMARK_OWNER_VALIDATION":true,"USE_ALTERNATIVE_FOREIGN_ADDRESS_LABELS":true,"MY_RECEIPTS_FILTER":[{"type":"dateRange","name":"DATE_RANGE","label":"Date range","defaultValue":{"start":null,"end":null}},{"type":"text","name":"REF_NUM","defaultValue":"","label":"Reference Number"},{"type":"text","name":"RECEIPT_NUM","defaultValue":"","label":"Receipt Id"},{"type":"text","name":"AMOUNT","defaultValue":"","label":"Amount"},{"type":"select","name":"TYPE","defaultValue":"","label":"Payment Type","options":[{"value":"","label":"All"},{"value":"CC","label":"Credit Card"},{"value":"Check","label":"Check"}]}],"MY_RECEIPTS_SHOW_IN_SIDEBAR":true,"SHOW_MY_RECEIPTS_HELPER_TEXT":true,"MY_RECEIPTS_HELPER_LABEL":"About Receipt Search","MY_RECEIPTS_HELPER_TEXT":"You can search for receipts based on their descriptions, including the items paid for on the receipt. Use the filters to search for or filter specific information.","FARM_BILL_SUBLINK":{"label":"Farm Bill","component":"FarmBill","parameter":"farm-bill","path":"/lists/farm-bill","sourceTypeId":0,"myRecordsSearch":false,"allowedRules":["/search/"],"disabled":true,"searchDescription":"To perform a search, enter a debtor name. Your search results may include: exact debtor name, variations of that name and any filing that includes your search criteria. Punctuation is ignored.\n\nYou can click on \"Advanced\" to refine your search. Under “Advanced” you can search by crop, year, county and SSN/FEIN. As a registered Farm Bill Buyer with the Montana Secretary of State’s office it is important to maintain the confidentiality of the information contained within the Farm Bill Master List. The Farm Bill Master List reflects personal data, such as Social Security Numbers, which are a key piece of personal identifiable information to assist you in determining the existence of a lien against a specific debtor. The distribution of this information beyond its intended purpose is strictly prohibited.\n\nThe debtor's tax identification number has been hidden for confidentiality reasons. You may continue to search on a tax ID number and return debtors that match your search criteria. The SSN/FEIN must be entered without dashes or spaces.","searchMustHaveOneOf":["search","UCC_FARM_PRODUCT_ID","COUNTY"],"searchPlaceholder":"Search by debtor name","advancedSearchParameters":[{"type":"ServerMultiComplete","label":"Product code name(s)","name":"UCC_FARM_PRODUCT_ID","defaultValue":"","optionsSrc":"UCC_FARM_PRODUCT_V"},{"type":"MultiComplete","label":"Year or Range of Years","name":"YEAR_NUM","optionsSrc":"years","startYear":"1968","defaultValue":[],"preMergeOptions":[{"value":"ALL","label":"All"}]},{"type":"serverSelect","label":"State","name":"STATE","defaultValue":"MONTANA","optionsSrc":"STATE"},{"type":"ServerMultiComplete","label":"County","name":"COUNTY","defaultValue":[],"optionsSrc":"COUNTY","overrideSubOptionsSrcFromParameterName":"STATE"},{"type":"checkbox","name":"TIN_SEARCH_YN","defaultValue":false,"label":"Tax Identification Number Search"},{"type":"checkbox","name":"TIN_SORT_YN","defaultValue":false,"label":"Unique ID Sort"}]},"ALLOW_ADDRESS_VALIDATION_BYPASS_OPTION":true,"DEFAULT_ADDRESS_VALIDATION_BYPASS_OPTION_CHECKED":true}).RA_MAILING_DEFAULT_STATE || props.defaultMailState || '';
	    _this23.addingAgent = props.addingAgent || false;
	    _this23.allowInfoMessage = false;
	    _this23.agentType1Label = props.agentType1Label || '';
	    _this23.agentType2Label = props.agentType2Label || '';
	    _this23.modalOrgLabel = props.modalOrgLabel || '';
	    _this23.modalShowSuffix = props.modalShowSuffix || false;
	    _this23.typeSelectionDisabled = props.typeSelectionDisabled ? props.typeSelectionDisabled : RA_TYPE_SELECTION_DEFAULT || false;
	    // this.template = props.template || [];
	    return _this23;
	  }
	
	  _createClass(RegisteredAgentSearch, [{
	    key: 'formatAddress',
	    value: function formatAddress(value) {
	      return _react2.default.createElement(
	        'span',
	        null,
	        value.ADDR1,
	        value.ADDR1 !== "" ? _react2.default.createElement('br', null) : null,
	        value.ADDR2,
	        value.ADDR2 !== "" ? _react2.default.createElement('br', null) : null,
	        value.ADDR3,
	        value.ADDR3 !== "" ? _react2.default.createElement('br', null) : null,
	        value.CITY + (value.CITY !== "" && (value.STATE !== "" || value.POSTAL_CODE !== "") ? ', ' : "") + value.STATE + (value.STATE !== "" && value.POSTAL_CODE !== "" ? ', ' : "") + value.POSTAL_CODE,
	        value.CITY != "" || value.STATE != "" || value.POSTAL_CODE != "" ? _react2.default.createElement('br', null) : null,
	        this.showCounty && value.COUNTY !== "" ? value.COUNTY : null,
	        value.COUNTY !== "" ? _react2.default.createElement('br', null) : null,
	        this.showCountry && value.COUNTRY !== "" ? value.COUNTRY : null
	      );
	    }
	  }, {
	    key: 'getHumanReadableValue',
	    value: function getHumanReadableValue(field, value) {
	      var _this24 = this;
	
	      return value.CRA_ID.toString() !== "0" && value.SELECTED ? value.SELECTED ? _react2.default.createElement(
	        'span',
	        { className: 'confirm-result' },
	        _react2.default.createElement(
	          'span',
	          { className: 'row' },
	          this.getByType("h1", value.SELECTED.HEADER1)
	        ),
	        _react2.default.createElement(
	          'span',
	          { className: 'row' },
	          this.getByType("subtitle", value.SELECTED.HEADER2)
	        ),
	        value.SELECTED.SECTIONS.map(function (section, i) {
	          return _react2.default.createElement(
	            _react2.default.Fragment,
	            { key: i },
	            _react2.default.createElement(
	              'span',
	              { className: 'row' },
	              _this24.getByType('h2', section.label)
	            ),
	            section.lines && section.lines.map(function (_ref4, j) {
	              var line = _ref4.line;
	              return _react2.default.createElement(
	                'span',
	                { className: 'row', key: j },
	                _this24.getByType("line", line)
	              );
	            })
	          );
	        })
	      ) : null : value.ORGANIZATION || value.FIRST_NAME || value.MIDDLE_NAME || value.LAST_NAME || value.SUFFIX ? _react2.default.createElement(
	        'span',
	        { className: 'confirm-result' },
	        _react2.default.createElement(
	          'span',
	          { className: 'row' },
	          'Noncommercial Agent'
	        ),
	        _react2.default.createElement(
	          'span',
	          { className: 'row' },
	          value.INDIVIDUAL_YN === "y" || value.INDIVIDUAL_YN === true ? value.FIRST_NAME + (value.MIDDLE_NAME !== "" ? ' ' + value.MIDDLE_NAME + ' ' : " ") + value.LAST_NAME + (value.SUFFIX ? ' ' + value.SUFFIX : '') : _react2.default.createElement(
	            _react2.default.Fragment,
	            null,
	            value.ORGANIZATION.HEADER1,
	            value.ORGANIZATION.HEADER2 && _react2.default.createElement(
	              _react2.default.Fragment,
	              null,
	              _react2.default.createElement('br', null),
	              value.ORGANIZATION.HEADER2
	            )
	          )
	        ),
	        field.showMailingAddress && _react2.default.createElement(
	          'span',
	          { className: 'row secondary' },
	          'Physical Address:'
	        ),
	        _react2.default.createElement(
	          'span',
	          { className: 'row' },
	          this.formatAddress(value)
	        ),
	        field.showMailingAddress && _react2.default.createElement(
	          _react2.default.Fragment,
	          null,
	          _react2.default.createElement(
	            'span',
	            { className: 'row secondary' },
	            'Mailing Address:'
	          ),
	          _react2.default.createElement(
	            'span',
	            { className: 'row' },
	            this.formatAddress(value.MAIL_ADDR)
	          )
	        )
	      ) : _react2.default.createElement(
	        'span',
	        null,
	        _react2.default.createElement(
	          'span',
	          null,
	          'None'
	        )
	      );
	    }
	  }, {
	    key: 'getKeyValuePairs',
	    value: function getKeyValuePairs(field) {
	      return [{ name: field.name, value: Object.assign({}, field.value, { SOURCE_ID: field.value.SELECTED && field.value.SELECTED.SOURCE_ID || 0 }) }];
	    }
	  }]);
	
	  return RegisteredAgentSearch;
	}(AddressBlock);
	
	var ServerSelect = exports.ServerSelect = function (_Select2) {
	  _inherits(ServerSelect, _Select2);
	
	  function ServerSelect() {
	    var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	    _classCallCheck(this, ServerSelect);
	
	    var _this25 = _possibleConstructorReturn(this, (ServerSelect.__proto__ || Object.getPrototypeOf(ServerSelect)).call(this, props));
	
	    _this25.type = "serverSelect";
	    _this25.fieldClass = "ServerSelect";
	    _this25.controlType = "select";
	    _this25.srcHandler = props.srcHandler || null;
	    _this25.placeholder = props.placeholder || "None";
	    _this25.value = props.value || "0";
	    _this25.selectedOptionLabel = props.selectedOptionLabel || _this25.value;
	    _this25.optionsSrc = props.optionsSrc || "0";
	    _this25.subOptionsSrc = props.subOptionsSrc || "";
	    _this25.optionsSrcOverride = props.optionsSrcOverride || '';
	    _this25.subOptionsSrcOverride = props.subOptionsSrcOverride || '';
	    _this25.lastSeenOptionsSrcOverride = props.lastSeenOptionsSrcOverride || '';
	    _this25.lastSeenSubOptionsSrcOverride = props.lastSeenSubOptionsSrcOverride || '';
	    _this25.allowedRules = ["mustBeSelected", 'customBusinessRules'];
	    _this25.optionsFetched = props.optionsFetched || false;
	    return _this25;
	  }
	
	  _createClass(ServerSelect, [{
	    key: 'getKeyValuePairs',
	    value: function getKeyValuePairs(field) {
	      var selectedOption = field.options.find(function (opt) {
	        return opt.value === field.value;
	      });
	      var displayValue = selectedOption ? selectedOption.label : undefined;
	      return [{ name: field.name, value: field.value, meta: { displayValue: displayValue } }];
	    }
	  }]);
	
	  return ServerSelect;
	}(Select);
	
	var ServerRadio = exports.ServerRadio = function (_ServerSelect) {
	  _inherits(ServerRadio, _ServerSelect);
	
	  function ServerRadio() {
	    var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	    _classCallCheck(this, ServerRadio);
	
	    var _this26 = _possibleConstructorReturn(this, (ServerRadio.__proto__ || Object.getPrototypeOf(ServerRadio)).call(this, props));
	
	    _this26.type = "serverRadio";
	    _this26.controlType = "radio";
	    _this26.fieldClass = "ServerRadio";
	    _this26.options = props.options || [{ value: "option1value", label: "Option 1" }];
	    _this26.allowedRules = ["mustBeSelected", 'customBusinessRules'];
	    return _this26;
	  }
	
	  _createClass(ServerRadio, [{
	    key: 'getKeyValuePairs',
	    value: function getKeyValuePairs(field) {
	      var selectedOption = field.options.find(function (opt) {
	        return opt.value === field.value;
	      });
	      var displayValue = selectedOption ? selectedOption.label : undefined;
	      return [{ name: field.name, value: field.value, meta: { displayValue: displayValue } }];
	    }
	  }]);
	
	  return ServerRadio;
	}(ServerSelect);
	
	var Paragraph = exports.Paragraph = function (_Field16) {
	  _inherits(Paragraph, _Field16);
	
	  function Paragraph() {
	    var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	    _classCallCheck(this, Paragraph);
	
	    var _this27 = _possibleConstructorReturn(this, (Paragraph.__proto__ || Object.getPrototypeOf(Paragraph)).call(this, props));
	
	    _this27.getHumanReadableValue = function (field, value) {
	      return _react2.default.createElement(_Markdown2.default, { source: value, className: 'markdown' });
	    };
	
	    _this27.type = "paragraph";
	    _this27.fieldClass = "Paragraph";
	    _this27.value = props.value || "Lorum ipsum delorum...";
	    _this27.textAlign = props.textAlign || "left";
	    _this27.webVisible = props.webVisible === false ? false : true;
	    _this27.isValid = true;
	    _this27.label = "";
	    _this27.width = props.width || "100%";
	    _this27.confirm = false;
	    _this27.hideLabel = true;
	    _this27.displayType = props.displayType || 'markdown';
	    _this27.codes = props.codes || {};
	    _this27.scrollable = props.scrollable || false;
	    _this27.maxHeight = props.maxHeight || 300;
	    return _this27;
	  }
	
	  return Paragraph;
	}(Field);
	
	var repeaterRowValidationRule = { fn: 'validateRepeaterFields', ruleId: 'validateRepeaterFields', props: {} };
	
	var Repeater = exports.Repeater = function (_Field17) {
	  _inherits(Repeater, _Field17);
	
	  function Repeater() {
	    var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	    _classCallCheck(this, Repeater);
	
	    var _this28 = _possibleConstructorReturn(this, (Repeater.__proto__ || Object.getPrototypeOf(Repeater)).call(this, props));
	
	    _this28.resolveBusinessRules = function (rules) {
	      if (rules) {
	        return rules;
	      } else {
	        return [repeaterRowValidationRule];
	      }
	    };
	
	    _this28.getFieldsSnapshot = function (fields, row) {
	      return Object.assign({}, fields, Object.keys(row).reduce(function (obj, fieldId) {
	        return Object.assign({}, obj, _defineProperty({}, fieldId, Object.assign({}, fields[fieldId], {
	          value: row[fieldId]
	        })));
	      }, {}));
	    };
	
	    _this28.getFormattedRows = function (rows, fields) {
	      // This next variable is confusingly named, but it's just to preserve the meta rows in the value output itself
	      var metaRowsForValue = [];
	      var metaRows = [];
	      var ROWS = rows.map(function (row, i) {
	        var value = {};
	        var meta = {};
	        var snapshot = _this28.getFieldsSnapshot(fields, row);
	        Object.keys(row).filter(function (key) {
	          return key.charAt(0) !== '_';
	        }).forEach(function (fieldId) {
	          var tempField = fields[fieldId];
	          if ((0, _wizardUtilities.resolveFieldConditions)(tempField.conditions, snapshot, tempField.conditionsOperator)) {
	            var kvPair = new WizardClasses[fields[fieldId].fieldClass]().getKeyValuePairs(Object.assign({}, fields[fieldId], {
	              value: row[fieldId]
	            }))[0];
	            value[fields[fieldId].name] = kvPair.value;
	            meta[fields[fieldId].name] = kvPair.meta;
	          }
	        });
	        var statusId = row._statusId ? row._statusId : row._statusId === 0 ? 0 : 1;
	        value._statusId = statusId;
	        // This is to store metadata about the row in the value for this row
	        var rowMeta = Object.keys(row).reduce(function (obj, key) {
	          //if(key.charAt(0) === "_"){
	          if (key === '_statusId' || key === '_rowId' || key === '_original' || key === '_partyId') {
	            obj[key] = row[key];
	          }
	          return obj;
	        }, {});
	        metaRowsForValue.push(rowMeta);
	        metaRows.push(meta);
	        return value;
	      });
	
	      return { ROWS: ROWS, metaRows: metaRows, metaRowsForValue: metaRowsForValue };
	    };
	
	    _this28.type = 'repeater';
	    _this28.fieldClass = 'Repeater';
	    _this28.label = props.label || '';
	    _this28.template = props.template || [];
	    _this28.value = props.value || [];
	    _this28.metadata = props.metadata || {};
	    _this28.hideLabel = true;
	    _this28.ownsTooltip = true;
	    _this28.allowedRules = ['repeaterMinRows', 'repeaterMaxRows', 'mayOnlyAddAdditionalRows', 'repeaterColumnsMustBeUnique', 'enforceRepeaterChildConstraints', 'mustHaveSameNumRowsAs', 'validateRepeaterFields', 'minRepeaterEdit', 'minRepeaterDelete', 'customBusinessRules'];
	    _this28.businessRules = props.businessRules ? _this28.resolveBusinessRules(props.businessRules) : [repeaterRowValidationRule];
	    _this28.rowErrors = props.rowErrors || null;
	    _this28.emptyRepeaterLabel = props.emptyRepeaterLabel || '';
	    _this28.displayType = props.displayType || '';
	    _this28.disableAdding = props.disableAdding || false;
	    _this28.disableCloning = props.disableCloning || false;
	    _this28.disableDeleting = props.disableDeleting || false;
	    _this28.disableEditing = props.disableEditing || false;
	    _this28.printMailRequiredIf = props.printMailRequiredIf || 'never';
	    _this28.trackChanges = props.trackChanges || false;
	    _this28.showChangesOnForm = props.showChangesOnForm || false;
	    _this28.hideChangesStylingOnForm = props.hideChangesStylingOnForm || false;
	    _this28.hideDeletedRowsOnForm = props.hideDeletedRowsOnForm || false;
	    _this28.customDeleteLabel = props.customDeleteLabel || "";
	    _this28.noDeletedStyling = props.noDeletedStyling || false;
	    _this28.showChangesOnSummary = props.showChangesOnSummary === false ? false : true;
	    _this28.noDeletedStylingOnSummary = props.noDeletedStylingOnSummary || false;
	    return _this28;
	  }
	
	  _createClass(Repeater, [{
	    key: 'getConfirmFieldProps',
	    value: function getConfirmFieldProps() {
	      return [{ label: this.label, value: this.value }];
	    }
	  }, {
	    key: 'getKeyValuePairs',
	    value: function getKeyValuePairs(field, fields) {
	      var _getFormattedRows = this.getFormattedRows(field.value, fields),
	          ROWS = _getFormattedRows.ROWS,
	          metaRows = _getFormattedRows.metaRows,
	          metaRowsForValue = _getFormattedRows.metaRowsForValue;
	
	      var originalFormattedRows = this.getFormattedRows(_store2.default.getState().wizard.diff.originalByFieldId[field.fieldId] || [], fields);
	      var meta = {
	        original: {
	          ROWS: originalFormattedRows.ROWS,
	          ROWS_META: originalFormattedRows.metaRowsForValue
	        },
	        metaRows: metaRows,
	        originalMetaRows: this.getFormattedRows(_store2.default.getState().wizard.diff.originalByFieldId[field.fieldId] || [], fields).metaRows
	      };
	      return [{
	        name: field.name,
	        value: { ROWS: ROWS, METADATA: field.metadata, ROWS_META: metaRowsForValue },
	        meta: meta
	      }];
	    }
	  }], [{
	    key: 'getPublicProperties',
	    value: function getPublicProperties(rows) {
	      return rows.map(function (row) {
	        return Object.entries(row).reduce(function (obj, _ref5) {
	          var _ref6 = _slicedToArray(_ref5, 2),
	              key = _ref6[0],
	              value = _ref6[1];
	
	          if (key.charAt(0) !== "_") obj[key] = value;
	          return obj;
	        }, {});
	      });
	    }
	  }, {
	    key: 'compareValues',
	    value: function compareValues(originalValue, currentValue) {
	      return !(0, _deepEqual2.default)(this.getPublicProperties(originalValue), this.getPublicProperties(currentValue));
	    }
	  }]);
	
	  return Repeater;
	}(Field);
	
	var DataTable = exports.DataTable = function (_Field18) {
	  _inherits(DataTable, _Field18);
	
	  function DataTable() {
	    var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	    _classCallCheck(this, DataTable);
	
	    var _this29 = _possibleConstructorReturn(this, (DataTable.__proto__ || Object.getPrototypeOf(DataTable)).call(this, props));
	
	    _this29.getHumanReadableValue = function () {
	      return null;
	    };
	
	    _this29.type = 'DataTable';
	    _this29.fieldClass = 'DataTable';
	    _this29.value = props.value || { template: [], rows: [] };
	    _this29.dataSrc = props.dataSrc || '';
	    _this29.includeInSummary = props.includeInSummary === true ? true : false;
	    _this29.propagateValueToServer = props.propagateValueToServer || false;
	    _this29.formDisplayType = props.formDisplayType || 'newLine';
	    return _this29;
	  }
	
	  _createClass(DataTable, [{
	    key: 'getKeyValuePairs',
	    value: function getKeyValuePairs(field, fields) {
	      if (field.propagateValueToServer) {
	        return [{ name: field.name, value: field.value }];
	      } else {
	        return [{ name: field.name, value: null }];
	      }
	    }
	  }]);
	
	  return DataTable;
	}(Field);
	
	var NameSearch = exports.NameSearch = function (_ConfirmFields) {
	  _inherits(NameSearch, _ConfirmFields);
	
	  function NameSearch() {
	    var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	    _classCallCheck(this, NameSearch);
	
	    var _this30 = _possibleConstructorReturn(this, (NameSearch.__proto__ || Object.getPrototypeOf(NameSearch)).call(this, props));
	
	    _this30.type = "nameSearch";
	    return _this30;
	  }
	
	  return NameSearch;
	}(ConfirmFields);
	
	var Summary = exports.Summary = function (_Field19) {
	  _inherits(Summary, _Field19);
	
	  function Summary() {
	    var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	    _classCallCheck(this, Summary);
	
	    var _this31 = _possibleConstructorReturn(this, (Summary.__proto__ || Object.getPrototypeOf(Summary)).call(this, props));
	
	    _this31.type = "Summary";
	    _this31.fieldClass = "Summary";
	    _this31.confirm = false;
	    _this31.hideLabel = true;
	    _this31.allowedRules = [];
	    _this31.includeInSummary = false;
	    return _this31;
	  }
	
	  return Summary;
	}(Field);
	
	var getUploadAndSubmitValue = function getUploadAndSubmitValue() {
	  return { method: 'online', files: {}, signers: [], attestations: [] };
	};
	
	var UploadAndSubmit = exports.UploadAndSubmit = function (_Field20) {
	  _inherits(UploadAndSubmit, _Field20);
	
	  function UploadAndSubmit() {
	    var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	    _classCallCheck(this, UploadAndSubmit);
	
	    var _this32 = _possibleConstructorReturn(this, (UploadAndSubmit.__proto__ || Object.getPrototypeOf(UploadAndSubmit)).call(this, props));
	
	    _this32.type = 'UploadAndSubmit';
	    _this32.label = 'Upload & Submit';
	    _this32.fieldClass = 'UploadAndSubmit';
	    _this32.name = props.name || 'UPLOADS';
	    _this32.confirm = false;
	    _this32.hideLabel = true;
	    _this32.allowedRules = ['enforceUploadPlaceholderRules', 'validateRepeaterFields', 'customBusinessRules'];
	    _this32.value = Object.assign({}, getUploadAndSubmitValue(), props.value);
	    _this32.viewOnly = props.viewOnly || false;
	    _this32.businessRules = [{ fn: 'enforceUploadPlaceholderRules', ruleId: 'enforceUploadPlaceholderRules', props: {} }, {
	      fn: 'validateThirdPartySignaturesRepeater',
	      ruleId: 'validateThirdPartySignaturesRepeater',
	      props: {}
	    }];
	    _this32.delegateErrorsToChildren = true;
	    _this32.onlineInstructions = props.onlineInstructions || '';
	    _this32.mailInstructions = props.mailInstructions || '';
	    _this32.signerInstructions = props.signerInstructions || '';
	    _this32.allowOnline = props.allowOnline === false ? false : true;
	    _this32.allowPrint = props.allowPrint === false ? false : true;
	    _this32.allowSigners = props.allowSigners === false ? false : true;
	    _this32.includeInSummary = false;
	    _this32.excludeFromDiff = true;
	    _this32.hideFieldOnForm = true;
	    _this32.onlineTabLabel = props.onlineTabLabel || '';
	    _this32.printTabLabel = props.printTabLabel || '';
	    _this32.signerTabLabel = props.signerTabLabel || '';
	    _this32.onlineButtonLabel = props.onlineButtonLabel || '';
	    _this32.printButtonLabel = props.printButtonLabel || '';
	    _this32.signerButtonLabel = props.signerButtonLabel || '';
	    _this32.template = props.template || [];
	    _this32.allowMultipleSigners = props.allowMultipleSigners || false;
	    _this32.signerAttestations = props.signerAttestations || [];
	    _this32.signatureTextLabel = props.signatureTextLabel || '';
	    _this32.signatureDateLabel = props.signatureDateLabel || '';
	    _this32.showSignatureAttestations = props.showSignatureAttestations || false;
	    return _this32;
	  }
	
	  _createClass(UploadAndSubmit, [{
	    key: 'getKeyValuePairs',
	    value: function getKeyValuePairs(field, fields) {
	      var files = {};
	      var allowedFiles = (0, _UploadAccumulator.getUploadsFromFields)(fields).map(function (field) {
	        return field.fieldId;
	      });
	      Object.keys(field.value.files || {}).filter(function (fieldId) {
	        return allowedFiles.includes(fieldId);
	      }) //Skip any deleted repeater rows
	      .forEach(function (fieldId) {
	        files[fieldId] = field.value.files[fieldId].map(function (file) {
	          var newFile = Object.assign({}, file, {
	            filename: file.filename,
	            type: file.type
	          });
	          delete newFile.file;
	          return newFile;
	        }).filter(function (file) {
	          return file.status === 'success';
	        }).filter(function (file) {
	          return file;
	        });
	      });
	      return [{
	        name: field.name,
	        value: Object.assign({}, field.value, {
	          files: files,
	          method: _store2.default.getState().wizard.requirePrintMailMethod.size > 0 ? 'mail' : field.value.method
	        })
	      }];
	    }
	  }, {
	    key: 'getHumanReadableValue',
	    value: function getHumanReadableValue(field, value) {
	      return value.method === 'online' ? 'Pay & File Online' : 'Print & Mail';
	    }
	  }]);
	
	  return UploadAndSubmit;
	}(Field);
	
	var Signatures = exports.Signatures = function (_Field21) {
	  _inherits(Signatures, _Field21);
	
	  function Signatures() {
	    var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	    _classCallCheck(this, Signatures);
	
	    var _this33 = _possibleConstructorReturn(this, (Signatures.__proto__ || Object.getPrototypeOf(Signatures)).call(this, props));
	
	    _this33.type = "Signatures";
	    _this33.fieldClass = "Signatures";
	    _this33.label = props.label || "Signatures";
	    _this33.name = props.name || "SIGNATURES";
	    _this33.hideLabel = true;
	    _this33.value = props.value || (({"NODE_ENV":"production","BUILD_DATE":"2025-08-27T15:15:31.687Z","BUILD_NUMBER":"Not Provided","GIT_VERSION":"v1.3.0-381-ga81e29b08","GIT_COMMIT_HASH":"a81e29b085c9268ffd96c78eb734365802722741","GIT_BRANCH":"beta","PUBLIC_URL":"","STATE_ABBR":"MT","STATE_NAME":"Montana","STATE_ORG_TITLE":"Secretary of State","LOGIN_HEADER_IMG_PATH":"","HOME_IMG_FILENAME":"montana.jpg","FAVICON_FILE_NAME":"favicon.ico","ALLOW_E_SIGN_ON_CORRECTIONS":true,"THIRD_PARTY_SIGNING_ALLOWED":false,"MY_ACCOUNT_SAVE_AND_CLOSE_BUTTON":true,"IE_DEPRECATED_MESSAGE":"Internet Explorer is not supported. Please select a supported browser below to access this website.","ADDITIONAL_ROUTES":{"dataRequests":true,"farmBill":true,"apostille":true,"externalHelp":"https://sosmt.gov/business/help-center/","systemAdministration":[{"title":"Saved Payments","parameter":"saved-payments","componentName":"SavedPayments"}]},"SUBROUTES":[{"label":"Business","component":"Business","parameter":"business","myWorkQueueSearch":false,"sourceTypeId":54,"searchMustHaveOneOf":["FILING_TYPE_ID","STATUS_ID","STATE","search"],"serverWebSearchDescription":true,"serverWorkQueueDescription":true,"serverMyRecordsDescription":true,"searchPlaceholder":"Search by name or filing number (X########)","allowEmptySearchTerm":true,"requestCertificateAlternateLabel":"Request Information","fileAmendmentButtonLabel":"Filing Actions","advancedSearchParameters":[{"type":"radio","name":"QUERY_TYPE_ID","defaultValue":1010,"options":[{"value":1010,"label":"Starts with"},{"value":1011,"label":"Contains"},{"value":1012,"label":" Word Contains"}]},{"type":"serverSelect","name":"FILING_TYPE_ID","optionsSrc":"FILING_TYPES","label":"Entity Type","placeholder":"All","defaultValue":"0"},{"type":"serverSelect","name":"FILING_SUBTYPE_ID","optionsSrc":"FILING_SUBTYPES","label":"Entity Subtype","overrideSubOptionsSrcFromParameterName":"FILING_TYPE_ID","placeholder":"All","defaultValue":"0"},{"type":"serverSelect","name":"STATUS_ID","optionsSrc":"FILING_STATUS_WITHOUT_ALL","label":"Status","placeholder":"All","defaultValue":"0"},{"type":"serverSelect","name":"STATE","optionsSrc":"STATE","label":"State","placeholder":"All","defaultValue":""},{"type":"serverSelect","name":"COUNTY","optionsSrc":"COUNTY_SUBOPTION","label":"County","overrideSubOptionsSrcFromParameterName":"STATE","placeholder":"All","defaultValue":""},{"type":"checkbox","name":"CRA_SEARCH_YN","defaultValue":false,"label":"Search by Registered Agent PID"},{"type":"dateRange","name":"FILING_DATE","label":"Registration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}},{"type":"dateRange","name":"EXPIRATION_DATE","label":"Expiration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}}],"myRecordsFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Active"},{"value":2,"label":"Inactive"},{"value":3,"label":"Pending"}]},{"type":"dateRange","name":"DATE_RANGE","label":"Date range","defaultValue":{"start":null,"end":null}}],"myWorkQueueFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Approved"},{"value":2,"label":"Pending Online Payment"},{"value":3,"label":"Pending Review"},{"value":4,"label":"Needs Correction"},{"value":5,"label":"Rejected"},{"value":6,"label":"Draft"}]},{"type":"dateRange","name":"DATE_RANGE","label":"Date range","defaultValue":{"start":null,"end":null}}]},{"label":"Notary","component":"Notary","parameter":"notary","sourceTypeId":850,"myWorkQueueSearch":false,"allowEmptySearchTerm":true,"requestCertificateAlternateLabel":"Download Certificate","fileAmendmentButtonLabel":"Filing Actions","hideNameRequestCertificate":true,"hideAddressRequestCertificate":true,"hideRecordUserManagment":true,"searchPlaceholder":"Search by name or commission number","searchMustHaveOneOf":["CITY","search","SERVICE_TYPE"],"advancedParametersStartOpen":true,"searchIsSortable":true,"advancedSearchParameters":[{"type":"radio","name":"STARTS_WITH_YN","defaultValue":false,"options":[{"value":true,"label":"Starts with"},{"value":false,"label":"Contains"}]},{"type":"checkbox","name":"ACTIVE_ONLY_YN","defaultValue":true,"label":"Active entities only"},{"type":"text","name":"CITY","defaultValue":"","label":"City"},{"type":"select","name":"SERVICE_TYPE","label":"Special Services Offered","defaultValue":0,"options":[{"value":0,"label":"(N/A)"},{"value":6165,"label":"In-Person Electronic Notarization (IPEN)"},{"value":6166,"label":"Remote Online Notarization (RON)"},{"value":6167,"label":"Mobile Notary Services"},{"value":6168,"label":"Remote Ink Notarization (RIN)"}]}]},{"label":"Apostille","component":"Apostille","parameter":"apostille","sourceTypeId":720,"myRecordsSearch":false,"myWorkQueueSearch":false,"disabled":false,"allowedRoutes":["/forms-manager/","/queue/","/forms/"]},{"label":"Liens","component":"UCC","parameter":"ucc","sourceTypeId":1999,"myRecordsSearch":true,"myWorkQueueSearch":true,"fileAmendmentButtonLabel":"Filing Actions","searchPlaceholder":"Search by name or file number","disabled":false,"serverWebSearchDescription":true,"myRecordsDescription":"","workQueueDescription":"","searchDescription":"","hideRecordUserManagment":true,"searchLiensCheckout":false,"advancedSearchParameters":[{"type":"radio","name":"STARTS_WITH_YN","defaultValue":false,"options":[{"value":true,"label":"Starts with"},{"value":false,"label":"Contains"}]},{"type":"select","name":"STATUS","defaultValue":"ALL","label":"Status","options":[{"value":"ACTIVE_UNLAPSED","label":"Active (unlapsed)"},{"value":"ACTIVE_LAPSED_UNLAPSED","label":"Active (lapsed and unlapsed)"}]},{"type":"text","name":"EXCLUDE_VALUES","label":"Exclude Debtor Names (comma separated list of names to exclude)","defaultValue":""},{"type":"dateRange","name":"FILING_DATE","label":"Financing Statement Date","defaultValue":{"start":null,"end":null}},{"type":"dateRange","name":"LAPSE_DATE","label":"Lapse Date","defaultValue":{"start":null,"end":null}},{"type":"text","name":"CITY","label":"Debtor City","defaultValue":""}],"myRecordsFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Approved"},{"value":2,"label":"Pending Online Payment"},{"value":3,"label":"Pending Review"}]},{"type":"select","name":"TYPE","defaultValue":0,"label":"Lien Type","options":[{"value":0,"label":"All"},{"value":1,"label":"UCC"},{"value":2,"label":"EFS"},{"value":3,"label":"Title 71"}]}],"myWorkQueueFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Approved"},{"value":2,"label":"Pending Online Payment"},{"value":3,"label":"Pending Review"},{"value":4,"label":"Pending Print and Mail"},{"value":5,"label":"Rejected"},{"value":6,"label":"Draft"}]},{"type":"select","name":"TYPE","defaultValue":0,"label":"Lien Type","options":[{"value":0,"label":"All"},{"value":1,"label":"UCC"},{"value":2,"label":"EFS"},{"value":3,"label":"Title 71"}]}]},{"label":"Copy Request","component":"copies","parameter":"copies","sourceTypeId":2001,"myRecordsSearch":false,"myWorkQueueSearch":false,"disabled":false,"allowedRoutes":["/forms-manager/","/queue/","/forms/"]},{"label":"Trademark","component":"Trademark","parameter":"trademark","sourceTypeId":810,"showRequestCertificate":true,"searchMustHaveOneOf":["search","EXPIRATION_DATE","FILING_DATE"],"allowEmptySearchTerm":true,"requestCertificateAlternateLabel":"Request Information","fileAmendmentButtonLabel":"Filing Actions","advancedSearchParameters":[{"type":"radio","name":"QUERY_TYPE_ID","defaultValue":1010,"options":[{"value":1010,"label":"Starts with"},{"value":1011,"label":"Contains"},{"value":1012,"label":" Word Contains"}]},{"type":"checkbox","name":"OWNER_SEARCH_YN","defaultValue":false,"label":"Search owners"},{"type":"radio","name":"SERVICE_MARK_YN","label":"Mark Type","defaultValue":"","options":[{"value":"","label":"All Marks"},{"value":"Y","label":"Service Mark"},{"value":"N","label":"Trademark"}]},{"type":"serverSelect","name":"STATUS_ID","optionsSrc":"TYPE_V|TRADEMARK_STATUS_TYPE","label":"Status","placeholder":"All","defaultValue":"0"},{"type":"select","name":"DESIGN_TYPE_ID","options":[{"value":0,"label":"All"},{"value":990,"label":"Words Only"},{"value":991,"label":"Design Only"},{"value":992,"label":"Words and Design"}],"label":"Design Type","defaultValue":"0"},{"type":"dateRange","name":"FILING_DATE","label":"Registered Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}},{"type":"dateRange","name":"EXPIRATION_DATE","label":"Expiration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}}]},{"label":"Business Info Request","component":"InfoRequests","parameter":"info-request","sourceTypeId":167,"allowedRoutes":["/forms-manager/","/queue/","/forms/"]},{"label":"Data Requests","component":"DataRequests","parameter":"data-request","sourceTypeId":0,"allowedRoutes":["/forms-manager/"]},{"label":"CRA","component":"CRA","parameter":"cra","sourceTypeId":157,"myRecordsSearch":false,"searchPlaceholder":"Search by name or registered agent number","allowedRoutes":["/forms-manager/","/forms/","/records/","/queue/","/search/"],"allowEmptySearchTerm":true,"fileAmendmentButtonLabel":"Filing Actions","advancedSearchParameters":[{"type":"radio","name":"QUERY_TYPE_ID","defaultValue":1010,"options":[{"value":1010,"label":"Starts with"},{"value":1011,"label":"Contains"},{"value":1012,"label":" Word Contains"}]},{"type":"dateRange","name":"CRA_DATE","label":"Registration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}},{"type":"select","name":"STATUS_ID","label":"Status","defaultValue":0,"options":[{"value":0,"label":"All"},{"value":121,"label":"Active"},{"value":122,"label":"Inactive"}]},{"type":"select","name":"AGENT_TYPE_ID","label":"Agent Type","defaultValue":0,"options":[{"value":0,"label":"All"},{"value":460,"label":"Registered Agent"},{"value":461,"label":"Commercial Registered Agent"}]}]},{"label":"Farm Bill","component":"FarmBill","parameter":"farm-bill","path":"/lists/farm-bill","sourceTypeId":0,"myRecordsSearch":false,"allowedRules":["/search/"],"disabled":true,"searchDescription":"To perform a search, enter a debtor name. Your search results may include: exact debtor name, variations of that name and any filing that includes your search criteria. Punctuation is ignored.\n\nYou can click on \"Advanced\" to refine your search. Under “Advanced” you can search by crop, year, county and SSN/FEIN. As a registered Farm Bill Buyer with the Montana Secretary of State’s office it is important to maintain the confidentiality of the information contained within the Farm Bill Master List. The Farm Bill Master List reflects personal data, such as Social Security Numbers, which are a key piece of personal identifiable information to assist you in determining the existence of a lien against a specific debtor. The distribution of this information beyond its intended purpose is strictly prohibited.\n\nThe debtor's tax identification number has been hidden for confidentiality reasons. You may continue to search on a tax ID number and return debtors that match your search criteria. The SSN/FEIN must be entered without dashes or spaces.","searchMustHaveOneOf":["search","UCC_FARM_PRODUCT_ID","COUNTY"],"searchPlaceholder":"Search by debtor name","advancedSearchParameters":[{"type":"ServerMultiComplete","label":"Product code name(s)","name":"UCC_FARM_PRODUCT_ID","defaultValue":"","optionsSrc":"UCC_FARM_PRODUCT_V"},{"type":"MultiComplete","label":"Year or Range of Years","name":"YEAR_NUM","optionsSrc":"years","startYear":"1968","defaultValue":[],"preMergeOptions":[{"value":"ALL","label":"All"}]},{"type":"serverSelect","label":"State","name":"STATE","defaultValue":"MONTANA","optionsSrc":"STATE"},{"type":"ServerMultiComplete","label":"County","name":"COUNTY","defaultValue":[],"optionsSrc":"COUNTY","overrideSubOptionsSrcFromParameterName":"STATE"},{"type":"checkbox","name":"TIN_SEARCH_YN","defaultValue":false,"label":"Tax Identification Number Search"},{"type":"checkbox","name":"TIN_SORT_YN","defaultValue":false,"label":"Unique ID Sort"}]}],"SYSTEM_NICKNAME":"Online Services Portal","PAYMENT_METHODS":[{"type":"bypass"},{"type":"iTransact"}],"PAYMENT_ALLOW_AMEX":true,"SYSTEM_ID_LABEL":"System Id","DOUBLE_COLUMN_PUBLIC_LOGIN":true,"INTERNAL_USER_MANAGEMENT":true,"ALLOW_PUBLIC_JSON_IMPORT":false,"MAX_FILE_UPLOAD_SIZE":10000000,"REFUND_TEXT":"","RETURN_TO_HOME_ON_LOGOUT":true,"CURRENT_SOS_NAME":"Christi Jacobsen","LOGO_FILENAME":"mt-sos-logo.png","LOGO_ALT":"Christi Jacobsen, Montana Secretary of State","LOGO_FULL_WIDTH":true,"HOME_HIDE_AUTH_HINT":true,"HOME_TITLE":"Montana Secretary of State","CUSTOM_TAB_TITLE":"Official Montana","HOME_SUBTITLE":"Online Business Services","ENTITY_NAME_CONSENT_DESCRIPTION":"","ALLOW_USER_PROFILE_EDITING":true,"COMPARE_FOREIGN_NAME_IN_ENTITY_NAME_VALIDATION":true,"FOREIGN_NAME_FIELD_NAME":"KIMA_PARENT_NAME_INFO","LOGIN_TITLE":"Montana Secretary of State Online Filing Portal Login","PUBLIC_LOGIN_LABEL":"Username","REVERSE_LOGIN_COLUMNS":true,"LOGIN_SEAL_FILENAME":"seal_white.png","SEPARATE_USERNAME_AND_EMAIL":true,"CREATE_ACCOUNT_BUTTON_ALIGN_LEFT":true,"CREATE_ACCOUNT_BUTTON_TEXT":"CREATE AN ACCOUNT","PASSWORD_CUSTOM_ERROR_TEXT":"The password must meet all requirements","ACCOUNT_CREATED_MESSAGE":"Please check your email to verify your account to login and allow a few minutes for this message to arrive. Check your junk/spam folders if you do not find the email in your inbox.","PUBLIC_LOGIN_PLACEHOLDER":" ","DISABLE_DEFAULT_PAYMENT_RADIO":true,"CUSTOM_RESET_PASSWORD_ERROR_MESSAGE":"Username invalid - no account found","PUBLIC_LOGIN_CREATE_DESCRIPTION":"### Existing User:\n\n  - Enter your username and password to login.  \n\n\n  #### - OR -  \n\n\n\n  - Forgot password? Click 'Reset Password' and follow the prompts.\n  - Forgot username? Click 'Forgot Username' and follow the prompts.  \n\n\n  ### New User:\n  ","LOGIN_HELP_LINK":"https://sosmt.gov/business/how-do-i/","LOGIN_HELP_LINK_TEXT":"Need Help?","FORGOT_USERNAME_TEXT":"Forgot Username?","LOGIN_ACTIVE_DIRECTORY_TEXT":"State User Login","MULTIPLE_LOGIN_METHODS":true,"HAS_ACTIVE_DIRECTORY_LOGIN":true,"RESET_PASSWORD_WITH_USERNAME":true,"DOWNLOAD_LINK":true,"SHOW_USERNAME_ACCOUNT_CREATE":true,"SHOW_SCROLL_DOWN_ARROW":true,"SHOW_ADDRESS_ACCOUNT_CREATE":true,"TWO_COLUMN_ACCOUNT_CREATE":true,"RESET_PASSWORD_TIP":"A link to change your password has been sent to your email. Please allow a few minutes for this message to arrive. Please check your junk/spam folders if you do not find the email in your inbox.","FORGOT_PASSWORD_LINK_TEXT":"Reset Password","PHONE_NUMBER_OPTIONAL_ACCOUNT_CREATE":true,"SHOW_REQUIRED_INDICATOR_ACCOUNT_CREATE":true,"PASSWORD_REQUIREMENTS_ACCOUNT_CREATE":"\n    <ul>\n      <li>MUST contain at least 8 characters (12+ recommended)</li>\n      <li>MUST contain at least one uppercase letter.</li>\n      <li>MUST contain at least one lowercase letter.</li>\n      <li>MUST contain at least one number.</li>\n      <li>MUST contain at least one special character (!”#$%&'()*+,-./:;<=>?</li>\n    </ul>\n  ","ALLOW_CERTIFICATION_REQUEST":true,"ALLOW_PUBLIC_CERTIFICATE_REQUEST":true,"ALLOW_COPY_REQUEST":false,"ALLOW_CORRECTION_STYLING":true,"HIDE_DEPRECATION_WARNING":false,"AMEND_ROUTE_PUBLIC":true,"SEAL_FILENAME":"seal.png","SHOPPING_CART":true,"ALLOW_PAYMENT_UPDATE_WITH_EMPTY_CART":true,"RA_EMAIL":true,"RA_WEBSITE":true,"RA_NO_DEFAULT_TYPE":true,"RA_ADDRESS_LABEL":"Street Address","RA_TYPE_SELECTION_DEFAULT":true,"RA_DEFAULT_TYPE":"460","RA_OVERRIDE_TYPE_WITH_DEFAULT":true,"RA_PRINCIPAL_ADDRESS_AMS":true,"UPLOAD_AND_SUBMIT_HIDE_IF_ONE_OPTION":true,"PAYMENT_PROCESSING_MESSAGE":"Your payment is processing - Do not close your browser or click the back button","CHECKOUT_BUTTON_WHEN_PROCESSING_TEXT":"Processing","EFS_CROP_PICKER_NONE_LABEL":"Lien Duration","DISALLOWED_WIZARD_PIECES":["FormationLocale"],"REPEATER_SHOW_EDIT_BUTTON":true,"DATA_REQUEST_PAGE_TITLE":"Data Requests and Subscriptions","DATA_REQUEST_SIDEBAR_LABEL":"Data Requests & Subscriptions","LOGIN_REDIRECTS_TO_EPASS":false,"LOGIN_REDIRECTS_TO_ACTIVE_DIRECTORY":true,"LOGIN_ACTIVE_DIRECTORY_LINK":true,"FETCH_EDIT_USER_LINK":false,"LISTS_FETCH_AVAILABLE_LISTS":true,"POST_WIZARD_SUBMIT_REDIRECT_URL":"/","PIN_REQUEST_ATTESTATIONS":true,"PIN_REQUEST_DESCRIPTION":"Click **Request PIN** to have a new PIN sent to the account holder's email address on file.","OWNERSHIP_REQUEST_DESCRIPTION":"To become an **authorized user** of this record, a current **AUTHORIZED USER** will need to grant you access. To request access, click **Request Access** below.","PIN_REQUEST_SUCCESS_MESSAGE":"The PIN you have requested for this entity has been sent to the email associated with your user account.  You should receive the PIN in approximately 3-5 minutes, depending on your email service provider.","APOSTILLE_HEADER_LABEL":"Verification Information","APOSTILLE_NUMBER_LABEL":"Apostille/Authentication","APOSTILLE_CITY_STATE_OVERRIDE":"HELENA, MT","APOSTILLE_FILING_DATE_LABEL":"Issue Date","APOSTILLE_CITY_STATE_IN_CERTIFIED":true,"NOTARY_EXISTING_FILING":true,"ALLOW_REVOKE_OWN_ACCESS_ONLY":false,"HIDE_CANCEL_ON_ONETIME_DATA_REQUESTS":true,"DATA_REQUESTS_IN_SHOPPING_CART":true,"WQ_ALLOW_EDIT_PENDING_PAYMENT":true,"WQ_CONFIRM_ON_DELETE":true,"WQ_DELETE_CONFIRM_MESSAGE":"Deleting this filing will forfeit any money already paid to the Secretary of State. This action is permanent and cannot be undone, are you sure you would like to delete?","PASS_ITEM_GUIDS_ON_CHECKOUT":true,"FORM_REVISION_HISTORY":true,"CHECKOUT_DISCLAIMER":"By entering your credit card and/or checking account information you (i) state that **you are an authorized user** of the credit card and/or electronic check and that the associated information entered (e.g., account holder name, account number, billing address) is accurate, (ii) **you authorize payment processor to charge the amount you have requested** to your credit card and/or funding account, and (iii) **acknowledge if a charge is declined or reversed you may also be assessed a customary charge** by the payment processor for such transactions.","FARM_BILL_SEARCH_CONFIDENTIAL":"As a registered Farm Bill Buyer with the Montana Secretary of State’s office it is important to maintain the confidentiality of the information contained within the Farm Bill Master List. The Farm Bill Master List reflects personal data, such as Social Security Numbers, which are a key piece of personal identifiable information to assist you in determining the existence of a lien against a specific debtor. The distribution of this information beyond its intended purpose is strictly prohibited.\n\n**The debtor's tax identification number has been hidden for confidentiality reasons. You may continue to search on a tax ID number and return debtors that match your search criteria. The SSN/FEIN must be entered without dashes or spaces.  If you need access to the tax identification number to clearly identify the debtor, please contact the UCC unit at (406) 444-3665.**","VIEW_HISTORY_BUTTON_ALT_TEXT":"View Filings","WIZARD_ERROR_TITLE_MESSAGE":"Form Error","FARM_BILL_SEARCH_INTERACTIVE":true,"USE_FARM_BILL_API":true,"DISALLOW_ASSIGN_SELF_AS_RA":true,"DISALLOW_ASSIGN_SELF_AS_PRINCIPAL":true,"USE_TRADEMARK_OWNER_VALIDATION":true,"USE_ALTERNATIVE_FOREIGN_ADDRESS_LABELS":true,"MY_RECEIPTS_FILTER":[{"type":"dateRange","name":"DATE_RANGE","label":"Date range","defaultValue":{"start":null,"end":null}},{"type":"text","name":"REF_NUM","defaultValue":"","label":"Reference Number"},{"type":"text","name":"RECEIPT_NUM","defaultValue":"","label":"Receipt Id"},{"type":"text","name":"AMOUNT","defaultValue":"","label":"Amount"},{"type":"select","name":"TYPE","defaultValue":"","label":"Payment Type","options":[{"value":"","label":"All"},{"value":"CC","label":"Credit Card"},{"value":"Check","label":"Check"}]}],"MY_RECEIPTS_SHOW_IN_SIDEBAR":true,"SHOW_MY_RECEIPTS_HELPER_TEXT":true,"MY_RECEIPTS_HELPER_LABEL":"About Receipt Search","MY_RECEIPTS_HELPER_TEXT":"You can search for receipts based on their descriptions, including the items paid for on the receipt. Use the filters to search for or filter specific information.","FARM_BILL_SUBLINK":{"label":"Farm Bill","component":"FarmBill","parameter":"farm-bill","path":"/lists/farm-bill","sourceTypeId":0,"myRecordsSearch":false,"allowedRules":["/search/"],"disabled":true,"searchDescription":"To perform a search, enter a debtor name. Your search results may include: exact debtor name, variations of that name and any filing that includes your search criteria. Punctuation is ignored.\n\nYou can click on \"Advanced\" to refine your search. Under “Advanced” you can search by crop, year, county and SSN/FEIN. As a registered Farm Bill Buyer with the Montana Secretary of State’s office it is important to maintain the confidentiality of the information contained within the Farm Bill Master List. The Farm Bill Master List reflects personal data, such as Social Security Numbers, which are a key piece of personal identifiable information to assist you in determining the existence of a lien against a specific debtor. The distribution of this information beyond its intended purpose is strictly prohibited.\n\nThe debtor's tax identification number has been hidden for confidentiality reasons. You may continue to search on a tax ID number and return debtors that match your search criteria. The SSN/FEIN must be entered without dashes or spaces.","searchMustHaveOneOf":["search","UCC_FARM_PRODUCT_ID","COUNTY"],"searchPlaceholder":"Search by debtor name","advancedSearchParameters":[{"type":"ServerMultiComplete","label":"Product code name(s)","name":"UCC_FARM_PRODUCT_ID","defaultValue":"","optionsSrc":"UCC_FARM_PRODUCT_V"},{"type":"MultiComplete","label":"Year or Range of Years","name":"YEAR_NUM","optionsSrc":"years","startYear":"1968","defaultValue":[],"preMergeOptions":[{"value":"ALL","label":"All"}]},{"type":"serverSelect","label":"State","name":"STATE","defaultValue":"MONTANA","optionsSrc":"STATE"},{"type":"ServerMultiComplete","label":"County","name":"COUNTY","defaultValue":[],"optionsSrc":"COUNTY","overrideSubOptionsSrcFromParameterName":"STATE"},{"type":"checkbox","name":"TIN_SEARCH_YN","defaultValue":false,"label":"Tax Identification Number Search"},{"type":"checkbox","name":"TIN_SORT_YN","defaultValue":false,"label":"Unique ID Sort"}]},"ALLOW_ADDRESS_VALIDATION_BYPASS_OPTION":true,"DEFAULT_ADDRESS_VALIDATION_BYPASS_OPTION_CHECKED":true}).SIGNATURE_DEFAULT_DATE ? [{ name: '', sig: '', date: (0, _format2.default)(new Date(), 'MM/dd/yyyy') }] : []);
	    _this33.srcRepeater = props.srcRepeater || '';
	    _this33.srcField = props.srcField || '';
	    _this33.delegateErrorsToChildren = true;
	    _this33.emptyText = props.emptyText || '';
	    _this33.allowedRules = ['allSignaturesRequired', 'minRequiredSignatures', 'enforceSignatureDateRange', 'checkForRegulatedWords', 'customBusinessRules', 'signaturesMinLength'];
	    _this33.requireWebFileIfMultiple = props.requireWebFileIfMultiple || false;
	    _this33.multiple = props.multiple === false ? false : true;
	    _this33.todayButton = props.todayButton === false ? false : true;
	    _this33.showCapacity = props.showCapacity || false;
	    _this33.showOnBehalfOf = props.showOnBehalfOf === false ? false : true;
	    _this33.capacityFreeText = props.capacityFreeText || false;
	    _this33.allowedMasks = ["onlyLetters"];
	    return _this33;
	  }
	
	  _createClass(Signatures, [{
	    key: 'getKeyValuePairs',
	    value: function getKeyValuePairs(field, fields) {
	      if (field.multiple) {
	        var currentRepeaterRows = (fields[field.srcRepeater] || {}).value;
	        if (field.value.length === currentRepeaterRows.length) {
	          return [{ name: field.name, value: field.value }];
	        } else {
	          var value = currentRepeaterRows.map(function (c, i) {
	            return field.value[i] ? field.value[i] : { sig: '', date: null };
	          });
	          return [{ name: field.name, value: value }];
	        }
	      } else {
	        return [{ name: field.name, value: field.value }];
	      }
	    }
	  }]);
	
	  return Signatures;
	}(Field);
	
	var getFormationLocaleValueObject = function getFormationLocaleValueObject() {
	  return { FORMATION_TYPE: '', STATE: '', COUNTRY: '', OTHER: '' };
	};
	
	var FormationLocale = exports.FormationLocale = function (_Field22) {
	  _inherits(FormationLocale, _Field22);
	
	  function FormationLocale() {
	    var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	    _classCallCheck(this, FormationLocale);
	
	    var _this34 = _possibleConstructorReturn(this, (FormationLocale.__proto__ || Object.getPrototypeOf(FormationLocale)).call(this, props));
	
	    _this34.getHumanReadableValue = function (field, value) {
	      switch (value.FORMATION_TYPE) {
	        case 'STATE':
	          return value.STATE;
	        case 'COUNTRY':
	          return value.COUNTRY;
	        case 'OTHER':
	          return value.OTHER;
	      }
	    };
	
	    _this34.getKeyValuePairs = function (field, fields) {
	      return [{ name: field.name, value: { FORMATION_TYPE: field.value.FORMATION_TYPE, FORMATION_LOCALE: field.value[field.value.FORMATION_TYPE] } }];
	    };
	
	    _this34.type = 'FormationLocale';
	    _this34.fieldClass = 'FormationLocale';
	    _this34.label = props.label || 'Formation Locale';
	    _this34.name = props.name || 'FORMATION_INFO';
	    _this34.value = props.value || getFormationLocaleValueObject();
	    _this34.allowedRules = ['formationLocaleRequired', 'checkForRegulatedWords', 'customBusinessRules'];
	    _this34.excludeCurrentState = props.excludeCurrentState || false;
	    return _this34;
	  }
	
	  return FormationLocale;
	}(Field);
	
	var getUCCSearchValue = function getUCCSearchValue() {
	  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	  return {
	    SEARCH_REQUEST_TYPE: props.SEARCH_REQUEST_TYPE || 'LIST_ONLY',
	    SEARCH_LAST_NAME: props.SEARCH_LAST_NAME || '',
	    SEARCH_FIRST_NAME: props.SEARCH_FIRST_NAME || '',
	    SEARCH_MIDDLE_NAME: props.SEARCH_MIDDLE_NAME || '',
	    SEARCH_CITY: props.SEARCH_CITY || '',
	    SEARCH_SUFFIX: props.SEARCH_SUFFIX || '',
	    SEARCH_STATE: props.SEARCH_STATE || '',
	    SEARCH_ORG_NAME: props.SEARCH_ORG_NAME || '',
	    SEARCH_UCC_NUM: props.SEARCH_UCC_NUM || '',
	    SEC_PARTY_SEARCH_YN: props.SEC_PARTY_SEARCH_YN || false,
	    SEARCH_LAPSED: props.SEARCH_LAPSED || false,
	    SEARCH_UCC: props.SEARCH_UCC || false,
	    SEARCH_GOV: props.SEARCH_GOV || false,
	    SEARCH_EFS: props.SEARCH_EFS || false,
	    SEARCH_CROP_LIEN: props.SEARCH_CROP_LIEN || false,
	    SEARCH_AG_LIEN: props.SEARCH_AG_LIEN || false,
	    IS_PARTIAL: props.IS_PARTIAL || false,
	    IS_ORG: props.IS_ORG || false,
	    SEARCH_TYPE: props.SEARCH_TYPE || 'DEBTOR',
	    BEGIN_DATE: props.BEGIN_DATE || ''
	  };
	};
	
	var UCCSearch = exports.UCCSearch = function (_Field23) {
	  _inherits(UCCSearch, _Field23);
	
	  function UCCSearch() {
	    var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	    _classCallCheck(this, UCCSearch);
	
	    var _this35 = _possibleConstructorReturn(this, (UCCSearch.__proto__ || Object.getPrototypeOf(UCCSearch)).call(this, props));
	
	    _this35.getHumanReadableValue = function (field, value) {
	      return field.value.cache ? _react2.default.createElement(
	        _react2.default.Fragment,
	        null,
	        _react2.default.createElement(_UCCSearch.UCCSearchDisplay, { value: value.search, uccMode: field.uccMode }),
	        _react2.default.createElement(
	          'div',
	          { style: { width: '100%', overflowX: 'auto', padding: 0 } },
	          _react2.default.createElement(
	            'table',
	            { className: 'styled-table' },
	            _react2.default.createElement(
	              'thead',
	              null,
	              _react2.default.createElement(
	                'tr',
	                null,
	                field.value.cache.template.map(function (_ref7, i) {
	                  var label = _ref7.label;
	                  return _react2.default.createElement(
	                    'th',
	                    { key: i },
	                    label
	                  );
	                })
	              )
	            ),
	            _react2.default.createElement(
	              'tbody',
	              null,
	              field.value.cache.rows.map(function (row, i) {
	                return _react2.default.createElement(
	                  'tr',
	                  { key: i },
	                  row.map(function (cell, i) {
	                    return _react2.default.createElement(
	                      'td',
	                      { key: i },
	                      cell
	                    );
	                  })
	                );
	              })
	            )
	          )
	        )
	      ) : null;
	    };
	
	    _this35.getKeyValuePairs = function (field) {
	      var isOrg = field.value.search.IS_ORG === 'true' || field.value.search.IS_ORG === true;
	      return [{
	        name: field.name,
	        value: Object.assign({}, field.value, {
	          search: Object.assign({}, field.value.search, {
	            SEARCH_LAST_NAME: isOrg ? '' : field.value.search.SEARCH_LAST_NAME,
	            SEARCH_FIRST_NAME: isOrg ? '' : field.value.search.SEARCH_FIRST_NAME,
	            SEARCH_MIDDLE_NAME: isOrg ? '' : field.value.search.SEARCH_MIDDLE_NAME,
	            SEARCH_SUFFIX: isOrg ? '' : field.value.search.SEARCH_SUFFIX,
	            SEARCH_ORG_NAME: isOrg ? field.value.search.SEARCH_ORG_NAME : ''
	          }),
	          SEARCH_MODE: field.uccMode,
	          SEC_PARTY_SEARCH_YN: false
	        })
	      }];
	    };
	
	    _this35.type = 'UCCSearch';
	    _this35.fieldClass = 'UCCSearch';
	    _this35.allowedRules = ['uccSearchRequired', 'atLeastOneUccSearchResultIsRequired', 'customBusinessRules'];
	    _this35.allowedMasks = [];
	    _this35.label = '';
	    _this35.value = props.value && _typeof(props.value) === 'object' ? { cache: props.value.cache, ids: props.value.ids, search: getUCCSearchValue(props.value.search) } : { cache: null, ids: null, search: getUCCSearchValue() };
	    _this35.uccMode = props.uccMode || 11;
	    _this35.displaySearchTypeOnForm = props.displaySearchTypeOnForm !== undefined ? props.displaySearchTypeOnForm : ({"NODE_ENV":"production","BUILD_DATE":"2025-08-27T15:15:31.687Z","BUILD_NUMBER":"Not Provided","GIT_VERSION":"v1.3.0-381-ga81e29b08","GIT_COMMIT_HASH":"a81e29b085c9268ffd96c78eb734365802722741","GIT_BRANCH":"beta","PUBLIC_URL":"","STATE_ABBR":"MT","STATE_NAME":"Montana","STATE_ORG_TITLE":"Secretary of State","LOGIN_HEADER_IMG_PATH":"","HOME_IMG_FILENAME":"montana.jpg","FAVICON_FILE_NAME":"favicon.ico","ALLOW_E_SIGN_ON_CORRECTIONS":true,"THIRD_PARTY_SIGNING_ALLOWED":false,"MY_ACCOUNT_SAVE_AND_CLOSE_BUTTON":true,"IE_DEPRECATED_MESSAGE":"Internet Explorer is not supported. Please select a supported browser below to access this website.","ADDITIONAL_ROUTES":{"dataRequests":true,"farmBill":true,"apostille":true,"externalHelp":"https://sosmt.gov/business/help-center/","systemAdministration":[{"title":"Saved Payments","parameter":"saved-payments","componentName":"SavedPayments"}]},"SUBROUTES":[{"label":"Business","component":"Business","parameter":"business","myWorkQueueSearch":false,"sourceTypeId":54,"searchMustHaveOneOf":["FILING_TYPE_ID","STATUS_ID","STATE","search"],"serverWebSearchDescription":true,"serverWorkQueueDescription":true,"serverMyRecordsDescription":true,"searchPlaceholder":"Search by name or filing number (X########)","allowEmptySearchTerm":true,"requestCertificateAlternateLabel":"Request Information","fileAmendmentButtonLabel":"Filing Actions","advancedSearchParameters":[{"type":"radio","name":"QUERY_TYPE_ID","defaultValue":1010,"options":[{"value":1010,"label":"Starts with"},{"value":1011,"label":"Contains"},{"value":1012,"label":" Word Contains"}]},{"type":"serverSelect","name":"FILING_TYPE_ID","optionsSrc":"FILING_TYPES","label":"Entity Type","placeholder":"All","defaultValue":"0"},{"type":"serverSelect","name":"FILING_SUBTYPE_ID","optionsSrc":"FILING_SUBTYPES","label":"Entity Subtype","overrideSubOptionsSrcFromParameterName":"FILING_TYPE_ID","placeholder":"All","defaultValue":"0"},{"type":"serverSelect","name":"STATUS_ID","optionsSrc":"FILING_STATUS_WITHOUT_ALL","label":"Status","placeholder":"All","defaultValue":"0"},{"type":"serverSelect","name":"STATE","optionsSrc":"STATE","label":"State","placeholder":"All","defaultValue":""},{"type":"serverSelect","name":"COUNTY","optionsSrc":"COUNTY_SUBOPTION","label":"County","overrideSubOptionsSrcFromParameterName":"STATE","placeholder":"All","defaultValue":""},{"type":"checkbox","name":"CRA_SEARCH_YN","defaultValue":false,"label":"Search by Registered Agent PID"},{"type":"dateRange","name":"FILING_DATE","label":"Registration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}},{"type":"dateRange","name":"EXPIRATION_DATE","label":"Expiration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}}],"myRecordsFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Active"},{"value":2,"label":"Inactive"},{"value":3,"label":"Pending"}]},{"type":"dateRange","name":"DATE_RANGE","label":"Date range","defaultValue":{"start":null,"end":null}}],"myWorkQueueFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Approved"},{"value":2,"label":"Pending Online Payment"},{"value":3,"label":"Pending Review"},{"value":4,"label":"Needs Correction"},{"value":5,"label":"Rejected"},{"value":6,"label":"Draft"}]},{"type":"dateRange","name":"DATE_RANGE","label":"Date range","defaultValue":{"start":null,"end":null}}]},{"label":"Notary","component":"Notary","parameter":"notary","sourceTypeId":850,"myWorkQueueSearch":false,"allowEmptySearchTerm":true,"requestCertificateAlternateLabel":"Download Certificate","fileAmendmentButtonLabel":"Filing Actions","hideNameRequestCertificate":true,"hideAddressRequestCertificate":true,"hideRecordUserManagment":true,"searchPlaceholder":"Search by name or commission number","searchMustHaveOneOf":["CITY","search","SERVICE_TYPE"],"advancedParametersStartOpen":true,"searchIsSortable":true,"advancedSearchParameters":[{"type":"radio","name":"STARTS_WITH_YN","defaultValue":false,"options":[{"value":true,"label":"Starts with"},{"value":false,"label":"Contains"}]},{"type":"checkbox","name":"ACTIVE_ONLY_YN","defaultValue":true,"label":"Active entities only"},{"type":"text","name":"CITY","defaultValue":"","label":"City"},{"type":"select","name":"SERVICE_TYPE","label":"Special Services Offered","defaultValue":0,"options":[{"value":0,"label":"(N/A)"},{"value":6165,"label":"In-Person Electronic Notarization (IPEN)"},{"value":6166,"label":"Remote Online Notarization (RON)"},{"value":6167,"label":"Mobile Notary Services"},{"value":6168,"label":"Remote Ink Notarization (RIN)"}]}]},{"label":"Apostille","component":"Apostille","parameter":"apostille","sourceTypeId":720,"myRecordsSearch":false,"myWorkQueueSearch":false,"disabled":false,"allowedRoutes":["/forms-manager/","/queue/","/forms/"]},{"label":"Liens","component":"UCC","parameter":"ucc","sourceTypeId":1999,"myRecordsSearch":true,"myWorkQueueSearch":true,"fileAmendmentButtonLabel":"Filing Actions","searchPlaceholder":"Search by name or file number","disabled":false,"serverWebSearchDescription":true,"myRecordsDescription":"","workQueueDescription":"","searchDescription":"","hideRecordUserManagment":true,"searchLiensCheckout":false,"advancedSearchParameters":[{"type":"radio","name":"STARTS_WITH_YN","defaultValue":false,"options":[{"value":true,"label":"Starts with"},{"value":false,"label":"Contains"}]},{"type":"select","name":"STATUS","defaultValue":"ALL","label":"Status","options":[{"value":"ACTIVE_UNLAPSED","label":"Active (unlapsed)"},{"value":"ACTIVE_LAPSED_UNLAPSED","label":"Active (lapsed and unlapsed)"}]},{"type":"text","name":"EXCLUDE_VALUES","label":"Exclude Debtor Names (comma separated list of names to exclude)","defaultValue":""},{"type":"dateRange","name":"FILING_DATE","label":"Financing Statement Date","defaultValue":{"start":null,"end":null}},{"type":"dateRange","name":"LAPSE_DATE","label":"Lapse Date","defaultValue":{"start":null,"end":null}},{"type":"text","name":"CITY","label":"Debtor City","defaultValue":""}],"myRecordsFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Approved"},{"value":2,"label":"Pending Online Payment"},{"value":3,"label":"Pending Review"}]},{"type":"select","name":"TYPE","defaultValue":0,"label":"Lien Type","options":[{"value":0,"label":"All"},{"value":1,"label":"UCC"},{"value":2,"label":"EFS"},{"value":3,"label":"Title 71"}]}],"myWorkQueueFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Approved"},{"value":2,"label":"Pending Online Payment"},{"value":3,"label":"Pending Review"},{"value":4,"label":"Pending Print and Mail"},{"value":5,"label":"Rejected"},{"value":6,"label":"Draft"}]},{"type":"select","name":"TYPE","defaultValue":0,"label":"Lien Type","options":[{"value":0,"label":"All"},{"value":1,"label":"UCC"},{"value":2,"label":"EFS"},{"value":3,"label":"Title 71"}]}]},{"label":"Copy Request","component":"copies","parameter":"copies","sourceTypeId":2001,"myRecordsSearch":false,"myWorkQueueSearch":false,"disabled":false,"allowedRoutes":["/forms-manager/","/queue/","/forms/"]},{"label":"Trademark","component":"Trademark","parameter":"trademark","sourceTypeId":810,"showRequestCertificate":true,"searchMustHaveOneOf":["search","EXPIRATION_DATE","FILING_DATE"],"allowEmptySearchTerm":true,"requestCertificateAlternateLabel":"Request Information","fileAmendmentButtonLabel":"Filing Actions","advancedSearchParameters":[{"type":"radio","name":"QUERY_TYPE_ID","defaultValue":1010,"options":[{"value":1010,"label":"Starts with"},{"value":1011,"label":"Contains"},{"value":1012,"label":" Word Contains"}]},{"type":"checkbox","name":"OWNER_SEARCH_YN","defaultValue":false,"label":"Search owners"},{"type":"radio","name":"SERVICE_MARK_YN","label":"Mark Type","defaultValue":"","options":[{"value":"","label":"All Marks"},{"value":"Y","label":"Service Mark"},{"value":"N","label":"Trademark"}]},{"type":"serverSelect","name":"STATUS_ID","optionsSrc":"TYPE_V|TRADEMARK_STATUS_TYPE","label":"Status","placeholder":"All","defaultValue":"0"},{"type":"select","name":"DESIGN_TYPE_ID","options":[{"value":0,"label":"All"},{"value":990,"label":"Words Only"},{"value":991,"label":"Design Only"},{"value":992,"label":"Words and Design"}],"label":"Design Type","defaultValue":"0"},{"type":"dateRange","name":"FILING_DATE","label":"Registered Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}},{"type":"dateRange","name":"EXPIRATION_DATE","label":"Expiration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}}]},{"label":"Business Info Request","component":"InfoRequests","parameter":"info-request","sourceTypeId":167,"allowedRoutes":["/forms-manager/","/queue/","/forms/"]},{"label":"Data Requests","component":"DataRequests","parameter":"data-request","sourceTypeId":0,"allowedRoutes":["/forms-manager/"]},{"label":"CRA","component":"CRA","parameter":"cra","sourceTypeId":157,"myRecordsSearch":false,"searchPlaceholder":"Search by name or registered agent number","allowedRoutes":["/forms-manager/","/forms/","/records/","/queue/","/search/"],"allowEmptySearchTerm":true,"fileAmendmentButtonLabel":"Filing Actions","advancedSearchParameters":[{"type":"radio","name":"QUERY_TYPE_ID","defaultValue":1010,"options":[{"value":1010,"label":"Starts with"},{"value":1011,"label":"Contains"},{"value":1012,"label":" Word Contains"}]},{"type":"dateRange","name":"CRA_DATE","label":"Registration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}},{"type":"select","name":"STATUS_ID","label":"Status","defaultValue":0,"options":[{"value":0,"label":"All"},{"value":121,"label":"Active"},{"value":122,"label":"Inactive"}]},{"type":"select","name":"AGENT_TYPE_ID","label":"Agent Type","defaultValue":0,"options":[{"value":0,"label":"All"},{"value":460,"label":"Registered Agent"},{"value":461,"label":"Commercial Registered Agent"}]}]},{"label":"Farm Bill","component":"FarmBill","parameter":"farm-bill","path":"/lists/farm-bill","sourceTypeId":0,"myRecordsSearch":false,"allowedRules":["/search/"],"disabled":true,"searchDescription":"To perform a search, enter a debtor name. Your search results may include: exact debtor name, variations of that name and any filing that includes your search criteria. Punctuation is ignored.\n\nYou can click on \"Advanced\" to refine your search. Under “Advanced” you can search by crop, year, county and SSN/FEIN. As a registered Farm Bill Buyer with the Montana Secretary of State’s office it is important to maintain the confidentiality of the information contained within the Farm Bill Master List. The Farm Bill Master List reflects personal data, such as Social Security Numbers, which are a key piece of personal identifiable information to assist you in determining the existence of a lien against a specific debtor. The distribution of this information beyond its intended purpose is strictly prohibited.\n\nThe debtor's tax identification number has been hidden for confidentiality reasons. You may continue to search on a tax ID number and return debtors that match your search criteria. The SSN/FEIN must be entered without dashes or spaces.","searchMustHaveOneOf":["search","UCC_FARM_PRODUCT_ID","COUNTY"],"searchPlaceholder":"Search by debtor name","advancedSearchParameters":[{"type":"ServerMultiComplete","label":"Product code name(s)","name":"UCC_FARM_PRODUCT_ID","defaultValue":"","optionsSrc":"UCC_FARM_PRODUCT_V"},{"type":"MultiComplete","label":"Year or Range of Years","name":"YEAR_NUM","optionsSrc":"years","startYear":"1968","defaultValue":[],"preMergeOptions":[{"value":"ALL","label":"All"}]},{"type":"serverSelect","label":"State","name":"STATE","defaultValue":"MONTANA","optionsSrc":"STATE"},{"type":"ServerMultiComplete","label":"County","name":"COUNTY","defaultValue":[],"optionsSrc":"COUNTY","overrideSubOptionsSrcFromParameterName":"STATE"},{"type":"checkbox","name":"TIN_SEARCH_YN","defaultValue":false,"label":"Tax Identification Number Search"},{"type":"checkbox","name":"TIN_SORT_YN","defaultValue":false,"label":"Unique ID Sort"}]}],"SYSTEM_NICKNAME":"Online Services Portal","PAYMENT_METHODS":[{"type":"bypass"},{"type":"iTransact"}],"PAYMENT_ALLOW_AMEX":true,"SYSTEM_ID_LABEL":"System Id","DOUBLE_COLUMN_PUBLIC_LOGIN":true,"INTERNAL_USER_MANAGEMENT":true,"ALLOW_PUBLIC_JSON_IMPORT":false,"MAX_FILE_UPLOAD_SIZE":10000000,"REFUND_TEXT":"","RETURN_TO_HOME_ON_LOGOUT":true,"CURRENT_SOS_NAME":"Christi Jacobsen","LOGO_FILENAME":"mt-sos-logo.png","LOGO_ALT":"Christi Jacobsen, Montana Secretary of State","LOGO_FULL_WIDTH":true,"HOME_HIDE_AUTH_HINT":true,"HOME_TITLE":"Montana Secretary of State","CUSTOM_TAB_TITLE":"Official Montana","HOME_SUBTITLE":"Online Business Services","ENTITY_NAME_CONSENT_DESCRIPTION":"","ALLOW_USER_PROFILE_EDITING":true,"COMPARE_FOREIGN_NAME_IN_ENTITY_NAME_VALIDATION":true,"FOREIGN_NAME_FIELD_NAME":"KIMA_PARENT_NAME_INFO","LOGIN_TITLE":"Montana Secretary of State Online Filing Portal Login","PUBLIC_LOGIN_LABEL":"Username","REVERSE_LOGIN_COLUMNS":true,"LOGIN_SEAL_FILENAME":"seal_white.png","SEPARATE_USERNAME_AND_EMAIL":true,"CREATE_ACCOUNT_BUTTON_ALIGN_LEFT":true,"CREATE_ACCOUNT_BUTTON_TEXT":"CREATE AN ACCOUNT","PASSWORD_CUSTOM_ERROR_TEXT":"The password must meet all requirements","ACCOUNT_CREATED_MESSAGE":"Please check your email to verify your account to login and allow a few minutes for this message to arrive. Check your junk/spam folders if you do not find the email in your inbox.","PUBLIC_LOGIN_PLACEHOLDER":" ","DISABLE_DEFAULT_PAYMENT_RADIO":true,"CUSTOM_RESET_PASSWORD_ERROR_MESSAGE":"Username invalid - no account found","PUBLIC_LOGIN_CREATE_DESCRIPTION":"### Existing User:\n\n  - Enter your username and password to login.  \n\n\n  #### - OR -  \n\n\n\n  - Forgot password? Click 'Reset Password' and follow the prompts.\n  - Forgot username? Click 'Forgot Username' and follow the prompts.  \n\n\n  ### New User:\n  ","LOGIN_HELP_LINK":"https://sosmt.gov/business/how-do-i/","LOGIN_HELP_LINK_TEXT":"Need Help?","FORGOT_USERNAME_TEXT":"Forgot Username?","LOGIN_ACTIVE_DIRECTORY_TEXT":"State User Login","MULTIPLE_LOGIN_METHODS":true,"HAS_ACTIVE_DIRECTORY_LOGIN":true,"RESET_PASSWORD_WITH_USERNAME":true,"DOWNLOAD_LINK":true,"SHOW_USERNAME_ACCOUNT_CREATE":true,"SHOW_SCROLL_DOWN_ARROW":true,"SHOW_ADDRESS_ACCOUNT_CREATE":true,"TWO_COLUMN_ACCOUNT_CREATE":true,"RESET_PASSWORD_TIP":"A link to change your password has been sent to your email. Please allow a few minutes for this message to arrive. Please check your junk/spam folders if you do not find the email in your inbox.","FORGOT_PASSWORD_LINK_TEXT":"Reset Password","PHONE_NUMBER_OPTIONAL_ACCOUNT_CREATE":true,"SHOW_REQUIRED_INDICATOR_ACCOUNT_CREATE":true,"PASSWORD_REQUIREMENTS_ACCOUNT_CREATE":"\n    <ul>\n      <li>MUST contain at least 8 characters (12+ recommended)</li>\n      <li>MUST contain at least one uppercase letter.</li>\n      <li>MUST contain at least one lowercase letter.</li>\n      <li>MUST contain at least one number.</li>\n      <li>MUST contain at least one special character (!”#$%&'()*+,-./:;<=>?</li>\n    </ul>\n  ","ALLOW_CERTIFICATION_REQUEST":true,"ALLOW_PUBLIC_CERTIFICATE_REQUEST":true,"ALLOW_COPY_REQUEST":false,"ALLOW_CORRECTION_STYLING":true,"HIDE_DEPRECATION_WARNING":false,"AMEND_ROUTE_PUBLIC":true,"SEAL_FILENAME":"seal.png","SHOPPING_CART":true,"ALLOW_PAYMENT_UPDATE_WITH_EMPTY_CART":true,"RA_EMAIL":true,"RA_WEBSITE":true,"RA_NO_DEFAULT_TYPE":true,"RA_ADDRESS_LABEL":"Street Address","RA_TYPE_SELECTION_DEFAULT":true,"RA_DEFAULT_TYPE":"460","RA_OVERRIDE_TYPE_WITH_DEFAULT":true,"RA_PRINCIPAL_ADDRESS_AMS":true,"UPLOAD_AND_SUBMIT_HIDE_IF_ONE_OPTION":true,"PAYMENT_PROCESSING_MESSAGE":"Your payment is processing - Do not close your browser or click the back button","CHECKOUT_BUTTON_WHEN_PROCESSING_TEXT":"Processing","EFS_CROP_PICKER_NONE_LABEL":"Lien Duration","DISALLOWED_WIZARD_PIECES":["FormationLocale"],"REPEATER_SHOW_EDIT_BUTTON":true,"DATA_REQUEST_PAGE_TITLE":"Data Requests and Subscriptions","DATA_REQUEST_SIDEBAR_LABEL":"Data Requests & Subscriptions","LOGIN_REDIRECTS_TO_EPASS":false,"LOGIN_REDIRECTS_TO_ACTIVE_DIRECTORY":true,"LOGIN_ACTIVE_DIRECTORY_LINK":true,"FETCH_EDIT_USER_LINK":false,"LISTS_FETCH_AVAILABLE_LISTS":true,"POST_WIZARD_SUBMIT_REDIRECT_URL":"/","PIN_REQUEST_ATTESTATIONS":true,"PIN_REQUEST_DESCRIPTION":"Click **Request PIN** to have a new PIN sent to the account holder's email address on file.","OWNERSHIP_REQUEST_DESCRIPTION":"To become an **authorized user** of this record, a current **AUTHORIZED USER** will need to grant you access. To request access, click **Request Access** below.","PIN_REQUEST_SUCCESS_MESSAGE":"The PIN you have requested for this entity has been sent to the email associated with your user account.  You should receive the PIN in approximately 3-5 minutes, depending on your email service provider.","APOSTILLE_HEADER_LABEL":"Verification Information","APOSTILLE_NUMBER_LABEL":"Apostille/Authentication","APOSTILLE_CITY_STATE_OVERRIDE":"HELENA, MT","APOSTILLE_FILING_DATE_LABEL":"Issue Date","APOSTILLE_CITY_STATE_IN_CERTIFIED":true,"NOTARY_EXISTING_FILING":true,"ALLOW_REVOKE_OWN_ACCESS_ONLY":false,"HIDE_CANCEL_ON_ONETIME_DATA_REQUESTS":true,"DATA_REQUESTS_IN_SHOPPING_CART":true,"WQ_ALLOW_EDIT_PENDING_PAYMENT":true,"WQ_CONFIRM_ON_DELETE":true,"WQ_DELETE_CONFIRM_MESSAGE":"Deleting this filing will forfeit any money already paid to the Secretary of State. This action is permanent and cannot be undone, are you sure you would like to delete?","PASS_ITEM_GUIDS_ON_CHECKOUT":true,"FORM_REVISION_HISTORY":true,"CHECKOUT_DISCLAIMER":"By entering your credit card and/or checking account information you (i) state that **you are an authorized user** of the credit card and/or electronic check and that the associated information entered (e.g., account holder name, account number, billing address) is accurate, (ii) **you authorize payment processor to charge the amount you have requested** to your credit card and/or funding account, and (iii) **acknowledge if a charge is declined or reversed you may also be assessed a customary charge** by the payment processor for such transactions.","FARM_BILL_SEARCH_CONFIDENTIAL":"As a registered Farm Bill Buyer with the Montana Secretary of State’s office it is important to maintain the confidentiality of the information contained within the Farm Bill Master List. The Farm Bill Master List reflects personal data, such as Social Security Numbers, which are a key piece of personal identifiable information to assist you in determining the existence of a lien against a specific debtor. The distribution of this information beyond its intended purpose is strictly prohibited.\n\n**The debtor's tax identification number has been hidden for confidentiality reasons. You may continue to search on a tax ID number and return debtors that match your search criteria. The SSN/FEIN must be entered without dashes or spaces.  If you need access to the tax identification number to clearly identify the debtor, please contact the UCC unit at (406) 444-3665.**","VIEW_HISTORY_BUTTON_ALT_TEXT":"View Filings","WIZARD_ERROR_TITLE_MESSAGE":"Form Error","FARM_BILL_SEARCH_INTERACTIVE":true,"USE_FARM_BILL_API":true,"DISALLOW_ASSIGN_SELF_AS_RA":true,"DISALLOW_ASSIGN_SELF_AS_PRINCIPAL":true,"USE_TRADEMARK_OWNER_VALIDATION":true,"USE_ALTERNATIVE_FOREIGN_ADDRESS_LABELS":true,"MY_RECEIPTS_FILTER":[{"type":"dateRange","name":"DATE_RANGE","label":"Date range","defaultValue":{"start":null,"end":null}},{"type":"text","name":"REF_NUM","defaultValue":"","label":"Reference Number"},{"type":"text","name":"RECEIPT_NUM","defaultValue":"","label":"Receipt Id"},{"type":"text","name":"AMOUNT","defaultValue":"","label":"Amount"},{"type":"select","name":"TYPE","defaultValue":"","label":"Payment Type","options":[{"value":"","label":"All"},{"value":"CC","label":"Credit Card"},{"value":"Check","label":"Check"}]}],"MY_RECEIPTS_SHOW_IN_SIDEBAR":true,"SHOW_MY_RECEIPTS_HELPER_TEXT":true,"MY_RECEIPTS_HELPER_LABEL":"About Receipt Search","MY_RECEIPTS_HELPER_TEXT":"You can search for receipts based on their descriptions, including the items paid for on the receipt. Use the filters to search for or filter specific information.","FARM_BILL_SUBLINK":{"label":"Farm Bill","component":"FarmBill","parameter":"farm-bill","path":"/lists/farm-bill","sourceTypeId":0,"myRecordsSearch":false,"allowedRules":["/search/"],"disabled":true,"searchDescription":"To perform a search, enter a debtor name. Your search results may include: exact debtor name, variations of that name and any filing that includes your search criteria. Punctuation is ignored.\n\nYou can click on \"Advanced\" to refine your search. Under “Advanced” you can search by crop, year, county and SSN/FEIN. As a registered Farm Bill Buyer with the Montana Secretary of State’s office it is important to maintain the confidentiality of the information contained within the Farm Bill Master List. The Farm Bill Master List reflects personal data, such as Social Security Numbers, which are a key piece of personal identifiable information to assist you in determining the existence of a lien against a specific debtor. The distribution of this information beyond its intended purpose is strictly prohibited.\n\nThe debtor's tax identification number has been hidden for confidentiality reasons. You may continue to search on a tax ID number and return debtors that match your search criteria. The SSN/FEIN must be entered without dashes or spaces.","searchMustHaveOneOf":["search","UCC_FARM_PRODUCT_ID","COUNTY"],"searchPlaceholder":"Search by debtor name","advancedSearchParameters":[{"type":"ServerMultiComplete","label":"Product code name(s)","name":"UCC_FARM_PRODUCT_ID","defaultValue":"","optionsSrc":"UCC_FARM_PRODUCT_V"},{"type":"MultiComplete","label":"Year or Range of Years","name":"YEAR_NUM","optionsSrc":"years","startYear":"1968","defaultValue":[],"preMergeOptions":[{"value":"ALL","label":"All"}]},{"type":"serverSelect","label":"State","name":"STATE","defaultValue":"MONTANA","optionsSrc":"STATE"},{"type":"ServerMultiComplete","label":"County","name":"COUNTY","defaultValue":[],"optionsSrc":"COUNTY","overrideSubOptionsSrcFromParameterName":"STATE"},{"type":"checkbox","name":"TIN_SEARCH_YN","defaultValue":false,"label":"Tax Identification Number Search"},{"type":"checkbox","name":"TIN_SORT_YN","defaultValue":false,"label":"Unique ID Sort"}]},"ALLOW_ADDRESS_VALIDATION_BYPASS_OPTION":true,"DEFAULT_ADDRESS_VALIDATION_BYPASS_OPTION_CHECKED":true}).UCC_SEARCH_ALLOW_SEARCH_TYPE === true ? true : false;
	    _this35.skipResultSelection = props.skipResultSelection || false;
	    return _this35;
	  }
	
	  return UCCSearch;
	}(Field);
	
	var MultiComplete = exports.MultiComplete = function (_Field24) {
	  _inherits(MultiComplete, _Field24);
	
	  function MultiComplete() {
	    var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	    _classCallCheck(this, MultiComplete);
	
	    var _this36 = _possibleConstructorReturn(this, (MultiComplete.__proto__ || Object.getPrototypeOf(MultiComplete)).call(this, props));
	
	    _this36.getHumanReadableValue = function (field, value) {
	      return value.map(function (v) {
	        return (field.options.find(function (option) {
	          return option.value === v;
	        }) || {}).label || v;
	      }).join(field.stackedSummary ? ',\n' : ', ');
	    };
	
	    _this36.type = 'MultiComplete';
	    _this36.fieldClass = 'MultiComplete';
	    _this36.allowedRules = ['minMultiComplete', 'customBusinessRules'];
	    _this36.options = props.options || [];
	    _this36.value = props.value || [];
	    _this36.maxRows = props.maxRows || null;
	    _this36.width = props.width || '40%';
	    _this36.ownsLabel = true;
	    _this36.stackedSummary = props.stackedSummary ? props.stackedSummary : false;
	    _this36.leaveOpenOnSelect = props.leaveOpenOnSelect || false;
	    _this36.allowedRepeaterConstraints = ["maxNumberOfSelectedOption", "minNumberOfSelectedOption"];
	    return _this36;
	  }
	
	  return MultiComplete;
	}(Field);
	
	var ServerMultiComplete = exports.ServerMultiComplete = function (_ServerSelect2) {
	  _inherits(ServerMultiComplete, _ServerSelect2);
	
	  function ServerMultiComplete() {
	    var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	    _classCallCheck(this, ServerMultiComplete);
	
	    var _this37 = _possibleConstructorReturn(this, (ServerMultiComplete.__proto__ || Object.getPrototypeOf(ServerMultiComplete)).call(this, props));
	
	    _this37.getHumanReadableValue = function (field, value) {
	      return value.map(function (v) {
	        return (field.options.find(function (option) {
	          return option.value === v;
	        }) || {}).label || v;
	      }).join(field.stackedSummary ? ',\n' : ', ');
	    };
	
	    _this37.getKeyValuePairs = function (field, value) {
	      var displayValue = field.value.map(function (v) {
	        return (field.options.find(function (o) {
	          return o.value === v;
	        }) || {}).label || '';
	      }).filter(function (x) {
	        return x !== '';
	      }).join(', ');
	      return [{ name: field.name, value: field.value, meta: { displayValue: displayValue } }];
	    };
	
	    _this37.type = 'ServerMultiComplete';
	    _this37.fieldClass = 'ServerMultiComplete';
	    _this37.allowedRules = ['minMultiComplete', 'customBusinessRules'];
	    _this37.options = props.options || [];
	    _this37.value = props.value || [];
	    _this37.maxRows = props.maxRows || null;
	    _this37.width = props.width || '40%';
	    _this37.controlType = 'ServerMultiComplete';
	    _this37.ownsLabel = true;
	    _this37.stackedSummary = props.stackedSummary ? props.stackedSummary : false;
	    _this37.leaveOpenOnSelect = props.leaveOpenOnSelect || false;
	    return _this37;
	  }
	
	  return ServerMultiComplete;
	}(ServerSelect);
	
	var getEfsCropPickerValue = function getEfsCropPickerValue() {
	  var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	  return {
	    yearType: value.yearType || 'all',
	    startYear: value.startYear || '',
	    endYear: value.endYear || '',
	    years: value.years || []
	  };
	};
	
	var EFSCropPicker = exports.EFSCropPicker = function (_Field25) {
	  _inherits(EFSCropPicker, _Field25);
	
	  function EFSCropPicker() {
	    var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	    _classCallCheck(this, EFSCropPicker);
	
	    var _this38 = _possibleConstructorReturn(this, (EFSCropPicker.__proto__ || Object.getPrototypeOf(EFSCropPicker)).call(this, props));
	
	    _this38.getHumanReadableValue = function (field, value) {
	      switch (value.yearType) {
	        case 'all':
	          return 'All years';
	        case 'none':
	          return ("Lien Duration") || 'None';
	        case 'duration':
	          return value.startYear + ' - ' + value.endYear;
	        case 'arbitrary':
	          return value.years.join(', ');
	        default:
	          return '';
	      }
	    };
	
	    _this38.type = 'EFSCropPicker';
	    _this38.fieldClass = 'EFSCropPicker';
	    _this38.label = props.label || 'Crop years';
	    _this38.allowedRules = ['efsRequired', 'checkForRegulatedWords', 'customBusinessRules'];
	    _this38.allowedMasks = [];
	    _this38.value = getEfsCropPickerValue(props.value);
	    _this38.ownsLabel = true;
	    return _this38;
	  }
	
	  return EFSCropPicker;
	}(Field);
	
	function CreateInstancesFromJson(json, preloadedData) {
	  var props = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	
	  var parsed = { stepOrder: json.stepOrder, steps: {}, sections: {}, fields: {} };
	
	  var repairedJson = repairJson((0, _deepCopy2.default)(json));
	  if (!(0, _deepEqual2.default)(repairedJson.fields, json.fields) || !(0, _deepEqual2.default)(repairedJson.sections, json.sections) || !(0, _deepEqual2.default)(repairedJson.steps, json.steps)) {
	    console.warn("While populating this wizard some extraneous ids were found and removed.");
	  }
	  json = repairedJson;
	
	  Object.keys(json.steps).forEach(function (stepId) {
	    parsed.steps[stepId] = new Step(json.steps[stepId]);
	  });
	  Object.keys(json.sections).forEach(function (sectionId) {
	    parsed.sections[sectionId] = new Section(json.sections[sectionId]);
	  });
	  //let fields = Object.keys(json.fields).map((id)=>(json.fields[id]));
	  Object.keys(json.fields).forEach(function (fieldId) {
	    parsed.fields[fieldId] = getFieldClass(json.fields[fieldId], preloadedData, json.fields, props);
	  });
	  Object.keys(parsed.fields).forEach(function (fieldId) {
	    parsed.fields[fieldId] = postParseProcess(parsed.fields[fieldId], parsed.fields, json.fields[fieldId]);
	  });
	  return parsed;
	}
	
	function getFieldClass(field) {
	  var preloadedData = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	  var _Object$assign3;
	
	  var fields = arguments[2];
	  var props = arguments[3];
	
	  var valueIsDerivedFromFieldId = field.disabled && !field.hideFieldOnForm;
	  var valueSource = valueIsDerivedFromFieldId ? field.fieldId : field.name;
	  var altValueSource = valueIsDerivedFromFieldId ? field.name : field.fieldId;
	  var propExists = (preloadedData[valueSource] !== undefined || preloadedData[altValueSource] !== undefined) && (!field.prepopulationDisabled || field.allowCorrectionPopulation && props.correctionMode || props.forceAllowPrepopulation);
	  var derivedValue = valueIsDerivedFromFieldId ? preloadedData[field.fieldId] !== undefined ? preloadedData[field.fieldId] : preloadedData[field.name] : preloadedData[field.name];
	  if (propExists) {
	    field.value = derivedValue;
	  }
	  switch (field.type) {
	    case "text":
	    case "number":
	      return new Field(field);
	    case "textArea":
	      return new TextArea(field);
	    case "paragraph":
	      field.codes = getMergeCodesFromString(field.value);
	      return new Paragraph(field);
	    case "file":
	      return new FileUpload(field);
	    case "checkbox":
	      return new Checkbox(field);
	    case "date":
	      var parsedDate = field.value ? (0, _parseISO2.default)(field.value) : null;
	      if (parsedDate && (0, _isValid2.default)(new Date(parsedDate))) {
	        field.value = (0, _format2.default)(parsedDate, "MM/dd/yyyy");
	      }
	      return new DateInput(field);
	    case "DateRange":
	      return new DateRange(field);
	    case 'TimeInput':
	      return new TimeInput(field);
	    case "radio":
	      field.selectedIndex = field.options.findIndex(function (option) {
	        return option.value === field.value;
	      });
	      field.value = (field.value !== undefined ? field.value : '').toString();
	      return new Radio(field);
	    case "select":
	      field.selectedIndex = field.options.findIndex(function (option) {
	        return option.value === field.value;
	      });
	      field.value = (field.value || "").toString();
	      return new Select(field);
	    case "confirmFields":
	      if (propExists) {
	        field.value = { val1: derivedValue, val2: derivedValue };
	      }
	      return new ConfirmFields(field);
	    case "addressBlock":
	      return new AddressBlock(field);
	    case "dependentRadio":
	      field.selectedIndex = field.options.findIndex(function (option) {
	        return option.value === field.value;
	      });
	      field.value = field.value.toString();
	      return new DependentRadio(field);
	    case "dependentSelect":
	      field.selectedIndex = field.options.findIndex(function (option) {
	        return option.value === field.value;
	      });
	      field.value = field.value.toString();
	      return new DependentSelect(field);
	    case "dependentCheck":
	      return new DependentCheck(field);
	    case "registeredAgentSearch":
	      if (field.value) {
	        field.selected = field.value.selected;
	        delete field.value.selected;
	      }
	      return new RegisteredAgentSearch(field);
	    case "serverSelect":
	      field.selectedIndex = field.options.findIndex(function (option) {
	        return option.value === field.value;
	      });
	      field.value = (field.value || "").toString();
	      return new ServerSelect(field);
	    case "serverRadio":
	      field.selectedIndex = field.options.findIndex(function (option) {
	        return option.value === field.value;
	      });
	      field.value = field.value.toString();
	      return new ServerRadio(field);
	    case "DataTable":
	      return new DataTable(field);
	    case "repeater":
	      {
	        if (propExists) {
	          var rows = [];
	          var value = field.value.ROWS || [];
	          value.forEach(function (row) {
	            var newRow = {};
	            var rowSnapshot = field.template.reduce(function (obj, key) {
	              return Object.assign({}, obj, _defineProperty({}, key, row[fields[key].name]));
	            }, {});
	            var snapshot = new Repeater().getFieldsSnapshot(fields, rowSnapshot);
	            field.template.forEach(function (fieldId) {
	              var fieldClass = fields[fieldId];
	              var cellName = fieldClass.name;
	              newRow[fieldId] = fieldClass ? fieldClass.prepopulationDisabled && !props.forceAllowPrepopulation && !(fieldClass.allowCorrectionPopulation && props.correctionMode) ? getFieldClass(Object.assign({}, fieldClass), {}, fields, props).value : getFieldClass(Object.assign({}, fieldClass, (0, _wizardUtilities.resolveFieldConditions)(fields[fieldId].conditions, snapshot, fields[fieldId].conditionsOperator) ? { value: row[cellName] } : {}), {}, fields, props).value : row[cellName];
	            });
	            newRow._statusId = row._statusId ? row._statusId : 0;
	            newRow._rowId = _shortid2.default.generate();
	            newRow._original = true;
	            newRow = Object.assign({}, newRow, Object.keys(row).reduce(function (obj, key) {
	              //if(key.charAt(0) === "_"){
	              if (key === '_statusId' || key === '_rowId' || key === '_original' || key === '_partyId') {
	                obj[key] = row[key];
	              }
	              return obj;
	            }, {}));
	            rows.push(newRow);
	          });
	          field.value = rows;
	        }
	        return new Repeater(field);
	      }
	    case "nameSearch":
	      if (propExists) {
	        field.value = { val1: derivedValue[0], val2: derivedValue[0] };
	      }
	      return new NameSearch(field);
	    case "Summary":
	      return new Summary(field);
	    case "FullName":
	      return new FullName(field);
	    case "NameOrg":
	      field.value = field.value ? Object.assign({}, field.value, { ORG_YN: typeof field.value.ORG_YN === "string" ? field.value.ORG_YN === "Y" ? true : false : field.value.ORG_YN }) : undefined;
	      return new NameOrg(field);
	    case "NameQualifiedOrg":
	      field.value = field.value ? Object.assign({}, getNameQualifiedOrgObject(), field.value, { ORG_YN: field.value.ORG_YN === "Y" ? true : false }) : getNameQualifiedOrgObject();
	      // field.selected = field.value.selected;
	      // delete field.value.selected;
	      return new NameQualifiedOrg(field);
	    case "SearchControl":
	      return new SearchControl(field);
	    case "UploadPlaceholder":
	      return new UploadPlaceholder(field);
	    case "UploadAccumulator":
	      return new UploadAccumulator(field);
	    case "UploadAndSubmit":
	      return new UploadAndSubmit(field);
	    case "Signatures":
	      if (props.clearSignatures) {
	        field.value = new Signatures().value;
	      }
	      return new Signatures(field);
	    case "FormationLocale":
	      field.value = Object.assign({}, getFormationLocaleValueObject(), (_Object$assign3 = {}, _defineProperty(_Object$assign3, field.value.FORMATION_TYPE, field.value.FORMATION_LOCALE), _defineProperty(_Object$assign3, 'FORMATION_TYPE', field.value.FORMATION_TYPE), _Object$assign3));
	      return new FormationLocale(field);
	    case "EntityNameSearch":
	      return new EntityNameSearch(field);
	    case "UCCSearch":
	      return new UCCSearch(field);
	    case "LocalSelect":
	      return new LocalSelect(Object.assign({}, field, { value: (field.value || {}).value || '' }));
	    case "MultiComplete":
	      return new MultiComplete(field);
	    case "ServerMultiComplete":
	      return new ServerMultiComplete(field);
	    case "EFSCropPicker":
	      return new EFSCropPicker(field);
	    default:
	      return new Field(field);
	  }
	}
	
	var postParseProcess = function postParseProcess(field, fields, originalField) {
	  switch (field.type) {
	    case 'LocalSelect':
	      if (field.value) {
	        var srcRepeater = fields[field.srcRepeater];
	        var srcField = fields[field.srcField];
	        if (srcRepeater && srcField && _typeof(originalField.value) === 'object') {
	          return Object.assign({}, field, { value: srcRepeater.value[originalField.value.rowIndex] ? srcRepeater.value[originalField.value.rowIndex]._rowId : '' });
	        } else {
	          return field;
	        }
	      } else {
	        return field;
	      }
	    default:
	      return field;
	  }
	};
	
	var repairJson = function repairJson(_ref8) {
	  var steps = _ref8.steps,
	      sections = _ref8.sections,
	      fields = _ref8.fields,
	      stepOrder = _ref8.stepOrder;
	
	  // Purge undefined sections
	  Object.keys(steps).forEach(function (stepId) {
	    var step = steps[stepId];
	    step.sectionOrder = step.sectionOrder.filter(function (sectionId) {
	      return sections[sectionId];
	    });
	    steps[stepId] = step;
	  });
	  // Purge undefined fields
	  Object.keys(sections).forEach(function (sectionId) {
	    var section = sections[sectionId];
	    section.fieldOrder = section.fieldOrder.filter(function (fieldId) {
	      return fields[fieldId];
	    });
	    sections[sectionId] = section;
	    // Fix fields whose parents are a section, but are incorrectly classified.
	    section.fieldOrder.forEach(function (fieldId) {
	      var field = fields[fieldId];
	      var fieldParentType = ((field.parent || {}).type || "").toUpperCase();
	      if (fieldParentType !== 'SECTION') {
	        console.warn('While populating this wizard the following field with an incorrectly classified parent, was identified and corrected.', field);
	        fields = Object.assign({}, fields, _defineProperty({}, fieldId, Object.assign({}, field, {
	          parent: Object.assign({}, field.parent, {
	            type: 'SECTION',
	            id: sectionId
	          })
	        })));
	      }
	    });
	  });
	  // Purge undefined subfields
	  Object.keys(fields).forEach(function (fieldId) {
	    var field = fields[fieldId];
	    if (field.hasOptionFields) {
	      field.options = field.options.map(function (option) {
	        option.fields = option.fields.filter(function (subfieldId) {
	          return fields[subfieldId];
	        });
	        return option;
	      });
	    }
	    if (field.hasCheckFields) {
	      field.checkedFields = field.checkedFields.filter(function (subfieldId) {
	        return fields[subfieldId];
	      });
	      field.uncheckedFields = field.uncheckedFields.filter(function (subfieldId) {
	        return fields[subfieldId];
	      });
	    }
	    if (field.template) {
	      field.template = field.template.filter(function (subfieldId) {
	        return fields[subfieldId];
	      });
	    }
	    fields[fieldId] = field;
	  });
	  // Purge unrenderable fields
	  var renderableFields = stepOrder.reduce(function (newSections, stepId) {
	    return [].concat(_toConsumableArray(newSections), _toConsumableArray(steps[stepId].sectionOrder));
	  }, []).reduce(function (newfields, sectionId) {
	    return [].concat(_toConsumableArray(newfields), _toConsumableArray(sections[sectionId].fieldOrder));
	  }, []);
	  fields = Object.keys(fields).reduce(function (newFields, fieldId) {
	    var parentType = fields[fieldId].parent.type.toUpperCase();
	    if (parentType !== 'SECTION') {
	      return Object.assign({}, newFields, _defineProperty({}, fieldId, fields[fieldId]));
	    } else {
	      if (renderableFields.includes(fieldId)) {
	        return Object.assign({}, newFields, _defineProperty({}, fieldId, fields[fieldId]));
	      } else {
	        console.warn('Purged extraneous field with id: ' + fieldId + ', of type: ' + fields[fieldId].type + ', and labeled: "' + fields[fieldId].label + '"');
	        return newFields;
	      }
	    }
	  }, {});
	  // Purge broken/null business rules
	  fields = Object.keys(fields).reduce(function (newFields, fieldId) {
	    var field = Object.assign({}, fields[fieldId], {
	      businessRules: fields[fieldId].businessRules.filter(function (br) {
	        return br && _businessRules.BUSINESS_RULES[br.fn];
	      })
	    });
	    if (fields[fieldId].businessRules.length > field.businessRules.length) {
	      console.warn('At least one corrupt business rule was identified and removed from field with label: ' + field.label);
	    }
	    return Object.assign({}, newFields, _defineProperty({}, fieldId, field));
	  }, {});
	
	  // Fix fields whose parents are repeaters, but are incorrectly classified.
	  Object.keys(fields).forEach(function (fieldId) {
	    var field = fields[fieldId];
	    if (field) {
	      var fieldType = field.type.toUpperCase();
	      if (fieldType === 'REPEATER') {
	        field.template.forEach(function (subfieldId) {
	          var subfield = fields[subfieldId];
	          if (subfield) {
	            if (subfield.parent.type !== 'REPEATER') {
	              var tempType = subfield.parent.type;
	              fields[subfieldId].parent.type = 'REPEATER';
	              console.warn('The following field had its parent type corrected from: ' + tempType + ', to: REPEATER', fields[subfieldId]);
	            }
	            if (subfield.parent.id !== field.fieldId) {
	              var tempId = subfield.parent.id;
	              fields[subfieldId].parent.id = field.fieldId;
	              console.warn('The following field had its parent id corrected from: ' + tempId + ', to: ' + field.fieldId, fields[subfieldId]);
	            }
	          }
	        });
	      }
	    }
	  }, {});
	
	  //Purge fields whose parents no longer exist
	  fields = Object.keys(fields).reduce(function (newFields, fieldId) {
	    var field = fields[fieldId];
	    var parentId = field.parent.id;
	    var parentType = field.parent.type.toUpperCase();
	    var parentExists = false;
	    switch (parentType) {
	      case 'SECTION':
	        parentExists = sections[parentId] ? true : false;
	        break;
	      case 'STATIC':
	        parentExists = true;
	        break;
	      case 'OPTION':
	      case 'CHECKBOX':
	      case 'REPEATER':
	      default:
	        parentExists = fields[parentId] ? true : false;
	    }
	    if (parentExists) {
	      return Object.assign({}, newFields, _defineProperty({}, fieldId, field));
	    } else {
	      console.warn("The following field was purged from this wizard, because its parent no longer exists.", field);
	      return newFields;
	    }
	  }, {});
	
	  return { steps: steps, sections: sections, fields: fields };
	};
	
	var getMergeCodesFromString = function getMergeCodesFromString() {
	  var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
	
	  if (typeof value !== 'string') {
	    return {};
	  }
	  var codes = value.match(/{{(.*?)}}/g);
	  return Array.isArray(codes) ? codes.reduce(function (obj, code) {
	    return Object.assign({}, obj, _defineProperty({}, code, true));
	  }, {}) : {};
	};

/***/ },
/* 36 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.resolveWizardAttributesLogic = exports.createFieldOverridesCollection = exports.updateWizardMeta = exports.setGenericSuccess = exports.setWizardSignatureErrors = exports.resetWizardSignatureValues = exports.setWizardSignatureValues = exports.setWizardLoadFailed = exports.createEncryptionCollection = exports.createMetaCollection = exports.buildFieldNameMap = exports.setWizardSubmitting = exports.setWizardSubmitted = exports.reconstructWizardWithValues = exports.spreadWizardAttributes = exports.removeRequirePrintMailMethod = exports.addRequirePrintMailMethod = exports.calculateInternalReview = exports.addInfoMessage = exports.clearInfoMessages = exports.getWebUserRecordByType = exports.setUploading = exports.resetWizardState = exports.saveDraft = exports.toggleSavingDraft = exports.setDraftId = exports.toggleHelpModal = exports.saveRecordWithSignatures = exports.saveRecord = exports.getGroupItemsAndSetFieldOptions = exports.getGroupItems = exports.validateFieldArray = exports.validateAllSteps = exports.buildFullWizardFieldIdList = exports.buildFieldIdList = exports.validateAndSetActiveStep = exports.setTargetStep = exports.setActiveStep = exports.toggleValidating = exports.validateAndSetFieldAttributes = exports.setWizardAttributes = exports.setStepAttributes = exports.setFieldAttributes = exports.fetchAndPopulateSignatures = exports.fetchAndPopulateReadOnlyWizard = exports.fetchAndPopulateAmendment = exports.fetchAndPopulateDraft = exports.fetchAndPopulateWizard = exports.setRepeaterEditing = exports.setWizardErrorMessage = exports.toggleWizardLoading = exports.populateWizard = undefined;
	
	var _regenerator = __webpack_require__(162);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _requests = __webpack_require__(6);
	
	var api = _interopRequireWildcard(_requests);
	
	var _WizardClasses = __webpack_require__(35);
	
	var WizardClasses = _interopRequireWildcard(_WizardClasses);
	
	var _validate = __webpack_require__(45);
	
	var _store = __webpack_require__(18);
	
	var _store2 = _interopRequireDefault(_store);
	
	var _deepEqual = __webpack_require__(65);
	
	var _deepEqual2 = _interopRequireDefault(_deepEqual);
	
	var _utilities = __webpack_require__(8);
	
	var _wizardUtilities = __webpack_require__(52);
	
	var _AppSettingActions = __webpack_require__(1053);
	
	var _x2js = __webpack_require__(155);
	
	var _x2js2 = _interopRequireDefault(_x2js);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	var xml2Json = new _x2js2.default();
	var CreateInstancesFromJson = WizardClasses.CreateInstancesFromJson;
	var populateWizard = exports.populateWizard = function populateWizard(wizard) {
	  return Object.assign({
	    type: 'POPULATE_WIZARD'
	  }, wizard);
	};
	
	var toggleWizardLoading = exports.toggleWizardLoading = function toggleWizardLoading(loading) {
	  return {
	    type: 'TOGGLE_WIZARD_LOADING',
	    loading: loading
	  };
	};
	
	var setWizardErrorMessage = exports.setWizardErrorMessage = function setWizardErrorMessage(message, title) {
	  return {
	    type: 'SET_WIZARD_ERROR_MESSAGE',
	    message: message,
	    title: title
	  };
	};
	
	var setRepeaterEditing = exports.setRepeaterEditing = function setRepeaterEditing(repeaterEditing) {
	  return {
	    type: 'SET_REPEATER_EDITING',
	    repeaterEditing: repeaterEditing
	  };
	};
	
	var fetchAndPopulateWizard = exports.fetchAndPopulateWizard = function fetchAndPopulateWizard(formDefinitionId, callback) {
	  return function (dispatch, getState) {
	    dispatch(toggleWizardLoading(true));
	    api.LOAD_WIZARD_INJECT_METADATA(formDefinitionId, null, false, function (data) {
	      var preloadedData = data.FIELD_VALUES || {};
	      var parsedWizard = CreateInstancesFromJson(JSON.parse(data.STEPS_JSON), preloadedData);
	      var meta = xml2Json.xml2js(data.METADATA) ? xml2Json.xml2js(data.METADATA).METADATA : {};
	      prefetchRequiredData(parsedWizard.fields).then(function (fields) {
	        return preFetchMergeCodes(fields, meta);
	      }).then(function (fields) {
	        dispatch(populateWizard({
	          formDefinitionId: formDefinitionId,
	          title: data.TITLE,
	          stepOrder: parsedWizard.stepOrder,
	          steps: parsedWizard.steps,
	          sections: parsedWizard.sections,
	          fields: fields,
	          description: data.DESCR,
	          sourceId: data.SOURCE_ID,
	          meta: meta,
	          draftId: false,
	          mode: data.MODE,
	          category: data.CATEGORY,
	          docTitleSrc: data.DOC_TITLE_SRC,
	          docId: data.DOC_ID,
	          formTitle: data.FORM_TITLE,
	          internalReviewRequired: data.INTERNAL_REVIEW_REQUIRED_YN,
	          requirePrintMailMethod: data.PRINT_MAIL_REQUIRED_YN,
	          onlyRenderChangedFieldsOnForm: data.ONLY_SHOW_CHANGED_FIELDS_ON_FORM_YN,
	          noLoginRequired: data.PUBLIC_YN,
	          feeDescription: data.FEE_DESCR,
	          draftsDisabled: data.DRAFTS_DISABLED,
	          thirdPartySigningAllowed: data.AUTHORIZED_THIRD_PARTY_YN,
	          globalVariables: data.GLOBAL_VARIABLES ? JSON.parse(data.GLOBAL_VARIABLES) : undefined,
	          wizardAttributesLogic: data.WIZARD_ATTRIBUTES_LOGIC ? JSON.parse(data.WIZARD_ATTRIBUTES_LOGIC) : undefined
	        }));
	        if (callback) {
	          callback();
	        }
	      });
	    }, function (err) {
	      console.error(err);
	      dispatch(setWizardErrorMessage(err.message || null, err.title));
	      dispatch(setWizardLoadFailed(true));
	      dispatch(toggleWizardLoading(false));
	    });
	  };
	};
	
	var fetchAndPopulateDraft = exports.fetchAndPopulateDraft = function fetchAndPopulateDraft(draftId) {
	  return function (dispatch) {
	    dispatch(toggleWizardLoading(true));
	    api.LOAD_DRAFT_BY_ID(draftId, function (data) {
	      var record = data.DRAFT;
	      api.LOAD_WIZARD_INJECT_METADATA(record.FORM_DEFINITION_ID, record.AMENDMENT_NUM, true, function (wizard) {
	        var steps = JSON.parse(wizard.STEPS_JSON);
	        var draft = JSON.parse(record.WIZARD_JSON);
	        var wizardState = JSON.parse(record.WIZARD_STATE);
	        var parsedWizard = CreateInstancesFromJson(steps, draft.FIELD_VALUES, {
	          forceAllowPrepopulation: true
	        });
	        var meta = xml2Json.xml2js(wizard.METADATA) ? xml2Json.xml2js(wizard.METADATA).METADATA : {};
	        prefetchRequiredData(parsedWizard.fields).then(function (fields) {
	          return preFetchMergeCodes(fields, meta);
	        }).then(function (fields) {
	          dispatch(populateWizard(Object.assign({}, wizardState, {
	            title: wizard.TITLE,
	            stepOrder: parsedWizard.stepOrder,
	            steps: parsedWizard.steps,
	            sections: parsedWizard.sections,
	            fields: fields,
	            description: wizard.DESCR,
	            sourceId: wizard.SOURCE_ID,
	            meta: meta,
	            docTitleSrc: wizard.DOC_TITLE_SRC,
	            draftId: draftId,
	            amendmentNum: wizardState.wizard.amendmentNum,
	            docId: parsedWizard.docId,
	            original: wizardState.diff.original,
	            originalByFieldId: wizardState.diff.originalByFieldId,
	            formTitle: wizard.FORM_TITLE,
	            internalReviewRequired: wizard.INTERNAL_REVIEW_REQUIRED_YN,
	            requirePrintMailMethod: data.PRINT_MAIL_REQUIRED_YN,
	            onlyRenderChangedFieldsOnForm: wizard.ONLY_SHOW_CHANGED_FIELDS_ON_FORM_YN,
	            formDefinitionId: record.FORM_DEFINITION_ID,
	            category: record.CATEGORY,
	            noLoginRequired: record.PUBLIC_YN,
	            feeDescription: wizard.FEE_DESCR,
	            draftsDisabled: wizard.DRAFTS_DISABLED,
	            thirdPartySigningAllowed: wizard.AUTHORIZED_THIRD_PARTY_YN,
	            globalVariables: wizard.GLOBAL_VARIABLES ? JSON.parse(wizard.GLOBAL_VARIABLES) : undefined,
	            wizardAttributesLogic: data.WIZARD_ATTRIBUTES_LOGIC ? JSON.parse(data.WIZARD_ATTRIBUTES_LOGIC) : undefined
	          })));
	        });
	      }, function (err) {
	        console.error(err);
	        dispatch(setWizardErrorMessage(err.message || null, err.title));
	        dispatch(setWizardLoadFailed(true));
	        dispatch(toggleWizardLoading(false));
	      });
	    }, function (err) {
	      console.error(err);
	      dispatch(setWizardErrorMessage(err.message || null, err.title));
	      dispatch(setWizardLoadFailed(true));
	      dispatch(toggleWizardLoading(false));
	    });
	  };
	};
	
	var fetchAndPopulateAmendment = exports.fetchAndPopulateAmendment = function fetchAndPopulateAmendment(_ref) {
	  var formDefinitionId = _ref.formDefinitionId,
	      amendmentNum = _ref.amendmentNum,
	      _ref$correctionMode = _ref.correctionMode,
	      correctionMode = _ref$correctionMode === undefined ? false : _ref$correctionMode;
	  return function (dispatch) {
	    dispatch(toggleWizardLoading(true));
	    api.LOAD_WIZARD_INJECT_METADATA(formDefinitionId, amendmentNum, false, function (wizard) {
	      var accessLevel = ({"NODE_ENV":"production","BUILD_DATE":"2025-08-27T15:15:31.687Z","BUILD_NUMBER":"Not Provided","GIT_VERSION":"v1.3.0-381-ga81e29b08","GIT_COMMIT_HASH":"a81e29b085c9268ffd96c78eb734365802722741","GIT_BRANCH":"beta","PUBLIC_URL":"","STATE_ABBR":"MT","STATE_NAME":"Montana","STATE_ORG_TITLE":"Secretary of State","LOGIN_HEADER_IMG_PATH":"","HOME_IMG_FILENAME":"montana.jpg","FAVICON_FILE_NAME":"favicon.ico","ALLOW_E_SIGN_ON_CORRECTIONS":true,"THIRD_PARTY_SIGNING_ALLOWED":false,"MY_ACCOUNT_SAVE_AND_CLOSE_BUTTON":true,"IE_DEPRECATED_MESSAGE":"Internet Explorer is not supported. Please select a supported browser below to access this website.","ADDITIONAL_ROUTES":{"dataRequests":true,"farmBill":true,"apostille":true,"externalHelp":"https://sosmt.gov/business/help-center/","systemAdministration":[{"title":"Saved Payments","parameter":"saved-payments","componentName":"SavedPayments"}]},"SUBROUTES":[{"label":"Business","component":"Business","parameter":"business","myWorkQueueSearch":false,"sourceTypeId":54,"searchMustHaveOneOf":["FILING_TYPE_ID","STATUS_ID","STATE","search"],"serverWebSearchDescription":true,"serverWorkQueueDescription":true,"serverMyRecordsDescription":true,"searchPlaceholder":"Search by name or filing number (X########)","allowEmptySearchTerm":true,"requestCertificateAlternateLabel":"Request Information","fileAmendmentButtonLabel":"Filing Actions","advancedSearchParameters":[{"type":"radio","name":"QUERY_TYPE_ID","defaultValue":1010,"options":[{"value":1010,"label":"Starts with"},{"value":1011,"label":"Contains"},{"value":1012,"label":" Word Contains"}]},{"type":"serverSelect","name":"FILING_TYPE_ID","optionsSrc":"FILING_TYPES","label":"Entity Type","placeholder":"All","defaultValue":"0"},{"type":"serverSelect","name":"FILING_SUBTYPE_ID","optionsSrc":"FILING_SUBTYPES","label":"Entity Subtype","overrideSubOptionsSrcFromParameterName":"FILING_TYPE_ID","placeholder":"All","defaultValue":"0"},{"type":"serverSelect","name":"STATUS_ID","optionsSrc":"FILING_STATUS_WITHOUT_ALL","label":"Status","placeholder":"All","defaultValue":"0"},{"type":"serverSelect","name":"STATE","optionsSrc":"STATE","label":"State","placeholder":"All","defaultValue":""},{"type":"serverSelect","name":"COUNTY","optionsSrc":"COUNTY_SUBOPTION","label":"County","overrideSubOptionsSrcFromParameterName":"STATE","placeholder":"All","defaultValue":""},{"type":"checkbox","name":"CRA_SEARCH_YN","defaultValue":false,"label":"Search by Registered Agent PID"},{"type":"dateRange","name":"FILING_DATE","label":"Registration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}},{"type":"dateRange","name":"EXPIRATION_DATE","label":"Expiration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}}],"myRecordsFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Active"},{"value":2,"label":"Inactive"},{"value":3,"label":"Pending"}]},{"type":"dateRange","name":"DATE_RANGE","label":"Date range","defaultValue":{"start":null,"end":null}}],"myWorkQueueFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Approved"},{"value":2,"label":"Pending Online Payment"},{"value":3,"label":"Pending Review"},{"value":4,"label":"Needs Correction"},{"value":5,"label":"Rejected"},{"value":6,"label":"Draft"}]},{"type":"dateRange","name":"DATE_RANGE","label":"Date range","defaultValue":{"start":null,"end":null}}]},{"label":"Notary","component":"Notary","parameter":"notary","sourceTypeId":850,"myWorkQueueSearch":false,"allowEmptySearchTerm":true,"requestCertificateAlternateLabel":"Download Certificate","fileAmendmentButtonLabel":"Filing Actions","hideNameRequestCertificate":true,"hideAddressRequestCertificate":true,"hideRecordUserManagment":true,"searchPlaceholder":"Search by name or commission number","searchMustHaveOneOf":["CITY","search","SERVICE_TYPE"],"advancedParametersStartOpen":true,"searchIsSortable":true,"advancedSearchParameters":[{"type":"radio","name":"STARTS_WITH_YN","defaultValue":false,"options":[{"value":true,"label":"Starts with"},{"value":false,"label":"Contains"}]},{"type":"checkbox","name":"ACTIVE_ONLY_YN","defaultValue":true,"label":"Active entities only"},{"type":"text","name":"CITY","defaultValue":"","label":"City"},{"type":"select","name":"SERVICE_TYPE","label":"Special Services Offered","defaultValue":0,"options":[{"value":0,"label":"(N/A)"},{"value":6165,"label":"In-Person Electronic Notarization (IPEN)"},{"value":6166,"label":"Remote Online Notarization (RON)"},{"value":6167,"label":"Mobile Notary Services"},{"value":6168,"label":"Remote Ink Notarization (RIN)"}]}]},{"label":"Apostille","component":"Apostille","parameter":"apostille","sourceTypeId":720,"myRecordsSearch":false,"myWorkQueueSearch":false,"disabled":false,"allowedRoutes":["/forms-manager/","/queue/","/forms/"]},{"label":"Liens","component":"UCC","parameter":"ucc","sourceTypeId":1999,"myRecordsSearch":true,"myWorkQueueSearch":true,"fileAmendmentButtonLabel":"Filing Actions","searchPlaceholder":"Search by name or file number","disabled":false,"serverWebSearchDescription":true,"myRecordsDescription":"","workQueueDescription":"","searchDescription":"","hideRecordUserManagment":true,"searchLiensCheckout":false,"advancedSearchParameters":[{"type":"radio","name":"STARTS_WITH_YN","defaultValue":false,"options":[{"value":true,"label":"Starts with"},{"value":false,"label":"Contains"}]},{"type":"select","name":"STATUS","defaultValue":"ALL","label":"Status","options":[{"value":"ACTIVE_UNLAPSED","label":"Active (unlapsed)"},{"value":"ACTIVE_LAPSED_UNLAPSED","label":"Active (lapsed and unlapsed)"}]},{"type":"text","name":"EXCLUDE_VALUES","label":"Exclude Debtor Names (comma separated list of names to exclude)","defaultValue":""},{"type":"dateRange","name":"FILING_DATE","label":"Financing Statement Date","defaultValue":{"start":null,"end":null}},{"type":"dateRange","name":"LAPSE_DATE","label":"Lapse Date","defaultValue":{"start":null,"end":null}},{"type":"text","name":"CITY","label":"Debtor City","defaultValue":""}],"myRecordsFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Approved"},{"value":2,"label":"Pending Online Payment"},{"value":3,"label":"Pending Review"}]},{"type":"select","name":"TYPE","defaultValue":0,"label":"Lien Type","options":[{"value":0,"label":"All"},{"value":1,"label":"UCC"},{"value":2,"label":"EFS"},{"value":3,"label":"Title 71"}]}],"myWorkQueueFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Approved"},{"value":2,"label":"Pending Online Payment"},{"value":3,"label":"Pending Review"},{"value":4,"label":"Pending Print and Mail"},{"value":5,"label":"Rejected"},{"value":6,"label":"Draft"}]},{"type":"select","name":"TYPE","defaultValue":0,"label":"Lien Type","options":[{"value":0,"label":"All"},{"value":1,"label":"UCC"},{"value":2,"label":"EFS"},{"value":3,"label":"Title 71"}]}]},{"label":"Copy Request","component":"copies","parameter":"copies","sourceTypeId":2001,"myRecordsSearch":false,"myWorkQueueSearch":false,"disabled":false,"allowedRoutes":["/forms-manager/","/queue/","/forms/"]},{"label":"Trademark","component":"Trademark","parameter":"trademark","sourceTypeId":810,"showRequestCertificate":true,"searchMustHaveOneOf":["search","EXPIRATION_DATE","FILING_DATE"],"allowEmptySearchTerm":true,"requestCertificateAlternateLabel":"Request Information","fileAmendmentButtonLabel":"Filing Actions","advancedSearchParameters":[{"type":"radio","name":"QUERY_TYPE_ID","defaultValue":1010,"options":[{"value":1010,"label":"Starts with"},{"value":1011,"label":"Contains"},{"value":1012,"label":" Word Contains"}]},{"type":"checkbox","name":"OWNER_SEARCH_YN","defaultValue":false,"label":"Search owners"},{"type":"radio","name":"SERVICE_MARK_YN","label":"Mark Type","defaultValue":"","options":[{"value":"","label":"All Marks"},{"value":"Y","label":"Service Mark"},{"value":"N","label":"Trademark"}]},{"type":"serverSelect","name":"STATUS_ID","optionsSrc":"TYPE_V|TRADEMARK_STATUS_TYPE","label":"Status","placeholder":"All","defaultValue":"0"},{"type":"select","name":"DESIGN_TYPE_ID","options":[{"value":0,"label":"All"},{"value":990,"label":"Words Only"},{"value":991,"label":"Design Only"},{"value":992,"label":"Words and Design"}],"label":"Design Type","defaultValue":"0"},{"type":"dateRange","name":"FILING_DATE","label":"Registered Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}},{"type":"dateRange","name":"EXPIRATION_DATE","label":"Expiration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}}]},{"label":"Business Info Request","component":"InfoRequests","parameter":"info-request","sourceTypeId":167,"allowedRoutes":["/forms-manager/","/queue/","/forms/"]},{"label":"Data Requests","component":"DataRequests","parameter":"data-request","sourceTypeId":0,"allowedRoutes":["/forms-manager/"]},{"label":"CRA","component":"CRA","parameter":"cra","sourceTypeId":157,"myRecordsSearch":false,"searchPlaceholder":"Search by name or registered agent number","allowedRoutes":["/forms-manager/","/forms/","/records/","/queue/","/search/"],"allowEmptySearchTerm":true,"fileAmendmentButtonLabel":"Filing Actions","advancedSearchParameters":[{"type":"radio","name":"QUERY_TYPE_ID","defaultValue":1010,"options":[{"value":1010,"label":"Starts with"},{"value":1011,"label":"Contains"},{"value":1012,"label":" Word Contains"}]},{"type":"dateRange","name":"CRA_DATE","label":"Registration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}},{"type":"select","name":"STATUS_ID","label":"Status","defaultValue":0,"options":[{"value":0,"label":"All"},{"value":121,"label":"Active"},{"value":122,"label":"Inactive"}]},{"type":"select","name":"AGENT_TYPE_ID","label":"Agent Type","defaultValue":0,"options":[{"value":0,"label":"All"},{"value":460,"label":"Registered Agent"},{"value":461,"label":"Commercial Registered Agent"}]}]},{"label":"Farm Bill","component":"FarmBill","parameter":"farm-bill","path":"/lists/farm-bill","sourceTypeId":0,"myRecordsSearch":false,"allowedRules":["/search/"],"disabled":true,"searchDescription":"To perform a search, enter a debtor name. Your search results may include: exact debtor name, variations of that name and any filing that includes your search criteria. Punctuation is ignored.\n\nYou can click on \"Advanced\" to refine your search. Under “Advanced” you can search by crop, year, county and SSN/FEIN. As a registered Farm Bill Buyer with the Montana Secretary of State’s office it is important to maintain the confidentiality of the information contained within the Farm Bill Master List. The Farm Bill Master List reflects personal data, such as Social Security Numbers, which are a key piece of personal identifiable information to assist you in determining the existence of a lien against a specific debtor. The distribution of this information beyond its intended purpose is strictly prohibited.\n\nThe debtor's tax identification number has been hidden for confidentiality reasons. You may continue to search on a tax ID number and return debtors that match your search criteria. The SSN/FEIN must be entered without dashes or spaces.","searchMustHaveOneOf":["search","UCC_FARM_PRODUCT_ID","COUNTY"],"searchPlaceholder":"Search by debtor name","advancedSearchParameters":[{"type":"ServerMultiComplete","label":"Product code name(s)","name":"UCC_FARM_PRODUCT_ID","defaultValue":"","optionsSrc":"UCC_FARM_PRODUCT_V"},{"type":"MultiComplete","label":"Year or Range of Years","name":"YEAR_NUM","optionsSrc":"years","startYear":"1968","defaultValue":[],"preMergeOptions":[{"value":"ALL","label":"All"}]},{"type":"serverSelect","label":"State","name":"STATE","defaultValue":"MONTANA","optionsSrc":"STATE"},{"type":"ServerMultiComplete","label":"County","name":"COUNTY","defaultValue":[],"optionsSrc":"COUNTY","overrideSubOptionsSrcFromParameterName":"STATE"},{"type":"checkbox","name":"TIN_SEARCH_YN","defaultValue":false,"label":"Tax Identification Number Search"},{"type":"checkbox","name":"TIN_SORT_YN","defaultValue":false,"label":"Unique ID Sort"}]}],"SYSTEM_NICKNAME":"Online Services Portal","PAYMENT_METHODS":[{"type":"bypass"},{"type":"iTransact"}],"PAYMENT_ALLOW_AMEX":true,"SYSTEM_ID_LABEL":"System Id","DOUBLE_COLUMN_PUBLIC_LOGIN":true,"INTERNAL_USER_MANAGEMENT":true,"ALLOW_PUBLIC_JSON_IMPORT":false,"MAX_FILE_UPLOAD_SIZE":10000000,"REFUND_TEXT":"","RETURN_TO_HOME_ON_LOGOUT":true,"CURRENT_SOS_NAME":"Christi Jacobsen","LOGO_FILENAME":"mt-sos-logo.png","LOGO_ALT":"Christi Jacobsen, Montana Secretary of State","LOGO_FULL_WIDTH":true,"HOME_HIDE_AUTH_HINT":true,"HOME_TITLE":"Montana Secretary of State","CUSTOM_TAB_TITLE":"Official Montana","HOME_SUBTITLE":"Online Business Services","ENTITY_NAME_CONSENT_DESCRIPTION":"","ALLOW_USER_PROFILE_EDITING":true,"COMPARE_FOREIGN_NAME_IN_ENTITY_NAME_VALIDATION":true,"FOREIGN_NAME_FIELD_NAME":"KIMA_PARENT_NAME_INFO","LOGIN_TITLE":"Montana Secretary of State Online Filing Portal Login","PUBLIC_LOGIN_LABEL":"Username","REVERSE_LOGIN_COLUMNS":true,"LOGIN_SEAL_FILENAME":"seal_white.png","SEPARATE_USERNAME_AND_EMAIL":true,"CREATE_ACCOUNT_BUTTON_ALIGN_LEFT":true,"CREATE_ACCOUNT_BUTTON_TEXT":"CREATE AN ACCOUNT","PASSWORD_CUSTOM_ERROR_TEXT":"The password must meet all requirements","ACCOUNT_CREATED_MESSAGE":"Please check your email to verify your account to login and allow a few minutes for this message to arrive. Check your junk/spam folders if you do not find the email in your inbox.","PUBLIC_LOGIN_PLACEHOLDER":" ","DISABLE_DEFAULT_PAYMENT_RADIO":true,"CUSTOM_RESET_PASSWORD_ERROR_MESSAGE":"Username invalid - no account found","PUBLIC_LOGIN_CREATE_DESCRIPTION":"### Existing User:\n\n  - Enter your username and password to login.  \n\n\n  #### - OR -  \n\n\n\n  - Forgot password? Click 'Reset Password' and follow the prompts.\n  - Forgot username? Click 'Forgot Username' and follow the prompts.  \n\n\n  ### New User:\n  ","LOGIN_HELP_LINK":"https://sosmt.gov/business/how-do-i/","LOGIN_HELP_LINK_TEXT":"Need Help?","FORGOT_USERNAME_TEXT":"Forgot Username?","LOGIN_ACTIVE_DIRECTORY_TEXT":"State User Login","MULTIPLE_LOGIN_METHODS":true,"HAS_ACTIVE_DIRECTORY_LOGIN":true,"RESET_PASSWORD_WITH_USERNAME":true,"DOWNLOAD_LINK":true,"SHOW_USERNAME_ACCOUNT_CREATE":true,"SHOW_SCROLL_DOWN_ARROW":true,"SHOW_ADDRESS_ACCOUNT_CREATE":true,"TWO_COLUMN_ACCOUNT_CREATE":true,"RESET_PASSWORD_TIP":"A link to change your password has been sent to your email. Please allow a few minutes for this message to arrive. Please check your junk/spam folders if you do not find the email in your inbox.","FORGOT_PASSWORD_LINK_TEXT":"Reset Password","PHONE_NUMBER_OPTIONAL_ACCOUNT_CREATE":true,"SHOW_REQUIRED_INDICATOR_ACCOUNT_CREATE":true,"PASSWORD_REQUIREMENTS_ACCOUNT_CREATE":"\n    <ul>\n      <li>MUST contain at least 8 characters (12+ recommended)</li>\n      <li>MUST contain at least one uppercase letter.</li>\n      <li>MUST contain at least one lowercase letter.</li>\n      <li>MUST contain at least one number.</li>\n      <li>MUST contain at least one special character (!”#$%&'()*+,-./:;<=>?</li>\n    </ul>\n  ","ALLOW_CERTIFICATION_REQUEST":true,"ALLOW_PUBLIC_CERTIFICATE_REQUEST":true,"ALLOW_COPY_REQUEST":false,"ALLOW_CORRECTION_STYLING":true,"HIDE_DEPRECATION_WARNING":false,"AMEND_ROUTE_PUBLIC":true,"SEAL_FILENAME":"seal.png","SHOPPING_CART":true,"ALLOW_PAYMENT_UPDATE_WITH_EMPTY_CART":true,"RA_EMAIL":true,"RA_WEBSITE":true,"RA_NO_DEFAULT_TYPE":true,"RA_ADDRESS_LABEL":"Street Address","RA_TYPE_SELECTION_DEFAULT":true,"RA_DEFAULT_TYPE":"460","RA_OVERRIDE_TYPE_WITH_DEFAULT":true,"RA_PRINCIPAL_ADDRESS_AMS":true,"UPLOAD_AND_SUBMIT_HIDE_IF_ONE_OPTION":true,"PAYMENT_PROCESSING_MESSAGE":"Your payment is processing - Do not close your browser or click the back button","CHECKOUT_BUTTON_WHEN_PROCESSING_TEXT":"Processing","EFS_CROP_PICKER_NONE_LABEL":"Lien Duration","DISALLOWED_WIZARD_PIECES":["FormationLocale"],"REPEATER_SHOW_EDIT_BUTTON":true,"DATA_REQUEST_PAGE_TITLE":"Data Requests and Subscriptions","DATA_REQUEST_SIDEBAR_LABEL":"Data Requests & Subscriptions","LOGIN_REDIRECTS_TO_EPASS":false,"LOGIN_REDIRECTS_TO_ACTIVE_DIRECTORY":true,"LOGIN_ACTIVE_DIRECTORY_LINK":true,"FETCH_EDIT_USER_LINK":false,"LISTS_FETCH_AVAILABLE_LISTS":true,"POST_WIZARD_SUBMIT_REDIRECT_URL":"/","PIN_REQUEST_ATTESTATIONS":true,"PIN_REQUEST_DESCRIPTION":"Click **Request PIN** to have a new PIN sent to the account holder's email address on file.","OWNERSHIP_REQUEST_DESCRIPTION":"To become an **authorized user** of this record, a current **AUTHORIZED USER** will need to grant you access. To request access, click **Request Access** below.","PIN_REQUEST_SUCCESS_MESSAGE":"The PIN you have requested for this entity has been sent to the email associated with your user account.  You should receive the PIN in approximately 3-5 minutes, depending on your email service provider.","APOSTILLE_HEADER_LABEL":"Verification Information","APOSTILLE_NUMBER_LABEL":"Apostille/Authentication","APOSTILLE_CITY_STATE_OVERRIDE":"HELENA, MT","APOSTILLE_FILING_DATE_LABEL":"Issue Date","APOSTILLE_CITY_STATE_IN_CERTIFIED":true,"NOTARY_EXISTING_FILING":true,"ALLOW_REVOKE_OWN_ACCESS_ONLY":false,"HIDE_CANCEL_ON_ONETIME_DATA_REQUESTS":true,"DATA_REQUESTS_IN_SHOPPING_CART":true,"WQ_ALLOW_EDIT_PENDING_PAYMENT":true,"WQ_CONFIRM_ON_DELETE":true,"WQ_DELETE_CONFIRM_MESSAGE":"Deleting this filing will forfeit any money already paid to the Secretary of State. This action is permanent and cannot be undone, are you sure you would like to delete?","PASS_ITEM_GUIDS_ON_CHECKOUT":true,"FORM_REVISION_HISTORY":true,"CHECKOUT_DISCLAIMER":"By entering your credit card and/or checking account information you (i) state that **you are an authorized user** of the credit card and/or electronic check and that the associated information entered (e.g., account holder name, account number, billing address) is accurate, (ii) **you authorize payment processor to charge the amount you have requested** to your credit card and/or funding account, and (iii) **acknowledge if a charge is declined or reversed you may also be assessed a customary charge** by the payment processor for such transactions.","FARM_BILL_SEARCH_CONFIDENTIAL":"As a registered Farm Bill Buyer with the Montana Secretary of State’s office it is important to maintain the confidentiality of the information contained within the Farm Bill Master List. The Farm Bill Master List reflects personal data, such as Social Security Numbers, which are a key piece of personal identifiable information to assist you in determining the existence of a lien against a specific debtor. The distribution of this information beyond its intended purpose is strictly prohibited.\n\n**The debtor's tax identification number has been hidden for confidentiality reasons. You may continue to search on a tax ID number and return debtors that match your search criteria. The SSN/FEIN must be entered without dashes or spaces.  If you need access to the tax identification number to clearly identify the debtor, please contact the UCC unit at (406) 444-3665.**","VIEW_HISTORY_BUTTON_ALT_TEXT":"View Filings","WIZARD_ERROR_TITLE_MESSAGE":"Form Error","FARM_BILL_SEARCH_INTERACTIVE":true,"USE_FARM_BILL_API":true,"DISALLOW_ASSIGN_SELF_AS_RA":true,"DISALLOW_ASSIGN_SELF_AS_PRINCIPAL":true,"USE_TRADEMARK_OWNER_VALIDATION":true,"USE_ALTERNATIVE_FOREIGN_ADDRESS_LABELS":true,"MY_RECEIPTS_FILTER":[{"type":"dateRange","name":"DATE_RANGE","label":"Date range","defaultValue":{"start":null,"end":null}},{"type":"text","name":"REF_NUM","defaultValue":"","label":"Reference Number"},{"type":"text","name":"RECEIPT_NUM","defaultValue":"","label":"Receipt Id"},{"type":"text","name":"AMOUNT","defaultValue":"","label":"Amount"},{"type":"select","name":"TYPE","defaultValue":"","label":"Payment Type","options":[{"value":"","label":"All"},{"value":"CC","label":"Credit Card"},{"value":"Check","label":"Check"}]}],"MY_RECEIPTS_SHOW_IN_SIDEBAR":true,"SHOW_MY_RECEIPTS_HELPER_TEXT":true,"MY_RECEIPTS_HELPER_LABEL":"About Receipt Search","MY_RECEIPTS_HELPER_TEXT":"You can search for receipts based on their descriptions, including the items paid for on the receipt. Use the filters to search for or filter specific information.","FARM_BILL_SUBLINK":{"label":"Farm Bill","component":"FarmBill","parameter":"farm-bill","path":"/lists/farm-bill","sourceTypeId":0,"myRecordsSearch":false,"allowedRules":["/search/"],"disabled":true,"searchDescription":"To perform a search, enter a debtor name. Your search results may include: exact debtor name, variations of that name and any filing that includes your search criteria. Punctuation is ignored.\n\nYou can click on \"Advanced\" to refine your search. Under “Advanced” you can search by crop, year, county and SSN/FEIN. As a registered Farm Bill Buyer with the Montana Secretary of State’s office it is important to maintain the confidentiality of the information contained within the Farm Bill Master List. The Farm Bill Master List reflects personal data, such as Social Security Numbers, which are a key piece of personal identifiable information to assist you in determining the existence of a lien against a specific debtor. The distribution of this information beyond its intended purpose is strictly prohibited.\n\nThe debtor's tax identification number has been hidden for confidentiality reasons. You may continue to search on a tax ID number and return debtors that match your search criteria. The SSN/FEIN must be entered without dashes or spaces.","searchMustHaveOneOf":["search","UCC_FARM_PRODUCT_ID","COUNTY"],"searchPlaceholder":"Search by debtor name","advancedSearchParameters":[{"type":"ServerMultiComplete","label":"Product code name(s)","name":"UCC_FARM_PRODUCT_ID","defaultValue":"","optionsSrc":"UCC_FARM_PRODUCT_V"},{"type":"MultiComplete","label":"Year or Range of Years","name":"YEAR_NUM","optionsSrc":"years","startYear":"1968","defaultValue":[],"preMergeOptions":[{"value":"ALL","label":"All"}]},{"type":"serverSelect","label":"State","name":"STATE","defaultValue":"MONTANA","optionsSrc":"STATE"},{"type":"ServerMultiComplete","label":"County","name":"COUNTY","defaultValue":[],"optionsSrc":"COUNTY","overrideSubOptionsSrcFromParameterName":"STATE"},{"type":"checkbox","name":"TIN_SEARCH_YN","defaultValue":false,"label":"Tax Identification Number Search"},{"type":"checkbox","name":"TIN_SORT_YN","defaultValue":false,"label":"Unique ID Sort"}]},"ALLOW_ADDRESS_VALIDATION_BYPASS_OPTION":true,"DEFAULT_ADDRESS_VALIDATION_BYPASS_OPTION_CHECKED":true}).ALLOW_SHOW_AR_WHEN_LOGGED_IN && wizard.PX_WUAL_TYPE_ID ? wizard.PX_WUAL_TYPE_ID : null;
	      api.LOAD_AMENDMENT_BY_ID(amendmentNum, wizard.CATEGORY, wizard.MODE, correctionMode, accessLevel, function () {
	        var _ref2 = _asyncToGenerator(_regenerator2.default.mark(function _callee(amendment) {
	          var steps, amendmentValues, parsedWizard, meta, prevFields, _JSON$parse, formValues, DYNAMIC_DATA, previousWizard;
	
	          return _regenerator2.default.wrap(function _callee$(_context) {
	            while (1) {
	              switch (_context.prev = _context.next) {
	                case 0:
	                  steps = JSON.parse(wizard.STEPS_JSON);
	                  amendmentValues = Object.assign({}, wizard.FIELD_VALUES || {}, JSON.parse(amendment.JSON).FIELD_VALUES);
	                  parsedWizard = CreateInstancesFromJson(steps, amendmentValues, {
	                    clearSignatures: correctionMode,
	                    correctionMode: correctionMode
	                  });
	                  // console.log(parsedWizard);
	
	                  meta = xml2Json.xml2js(wizard.METADATA) ? xml2Json.xml2js(wizard.METADATA).METADATA : {};
	                  prevFields = null;
	
	                  if (!amendment.PREV_JSON) {
	                    _context.next = 15;
	                    break;
	                  }
	
	                  _JSON$parse = JSON.parse(amendment.PREV_JSON), formValues = _JSON$parse.FIELD_VALUES, DYNAMIC_DATA = _JSON$parse.METADATA.DYNAMIC_DATA;
	                  previousWizard = CreateInstancesFromJson(steps, Object.assign({}, DYNAMIC_DATA, formValues), { forceAllowPrepopulation: true });
	                  _context.t0 = preFetchMergeCodes;
	                  _context.next = 11;
	                  return prefetchRequiredData(previousWizard.fields);
	
	                case 11:
	                  _context.t1 = _context.sent;
	                  _context.next = 14;
	                  return (0, _context.t0)(_context.t1);
	
	                case 14:
	                  prevFields = _context.sent;
	
	                case 15:
	                  prefetchRequiredData(parsedWizard.fields).then(function (fields) {
	                    return preFetchMergeCodes(fields, meta);
	                  }).then(function (fields) {
	                    var original = getOriginalValues(prevFields || fields);
	                    var originalByFieldId = getOriginalByFieldId(prevFields || fields);
	                    var fieldsRequirePrintMailMethod = calculatePrintMailMethod(fields);
	                    dispatch(populateWizard({
	                      formDefinitionId: formDefinitionId,
	                      title: wizard.TITLE,
	                      stepOrder: parsedWizard.stepOrder,
	                      steps: parsedWizard.steps,
	                      sections: parsedWizard.sections,
	                      fields: fields,
	                      description: wizard.DESCR,
	                      sourceId: wizard.SOURCE_ID,
	                      amendmentNum: amendmentNum,
	                      draftId: false,
	                      category: wizard.CATEGORY,
	                      meta: meta,
	                      docTitleSrc: wizard.DOC_TITLE_SRC,
	                      mode: wizard.MODE,
	                      original: original,
	                      originalByFieldId: originalByFieldId,
	                      docId: parsedWizard.docId,
	                      correctionMode: correctionMode,
	                      showDiff: amendment.SHOW_DIFF_YN,
	                      formTitle: wizard.FORM_TITLE,
	                      internalReviewRequired: meta.INTERNAL_REVIEW_REQUIRED_YN || wizard.INTERNAL_REVIEW_REQUIRED_YN,
	                      onlyRenderChangedFieldsOnForm: wizard.ONLY_SHOW_CHANGED_FIELDS_ON_FORM_YN,
	                      requirePrintMailMethod: amendment.PRINT_MAIL_REQUIRED_YN,
	                      fieldsRequirePrintMailMethod: fieldsRequirePrintMailMethod,
	                      noLoginRequired: wizard.PUBLIC_YN,
	                      feeDescription: wizard.FEE_DESCR,
	                      canChangeCorrectionEntryType: amendment.CAN_CHANGE_CORRECTION_ENTRY_TYPE,
	                      draftsDisabled: wizard.DRAFTS_DISABLED,
	                      thirdPartySigningAllowed: wizard.AUTHORIZED_THIRD_PARTY_YN,
	                      globalVariables: wizard.GLOBAL_VARIABLES ? JSON.parse(wizard.GLOBAL_VARIABLES) : undefined,
	                      wizardAttributesLogic: wizard.WIZARD_ATTRIBUTES_LOGIC ? JSON.parse(wizard.WIZARD_ATTRIBUTES_LOGIC) : undefined
	                    }));
	                  });
	
	                case 16:
	                case 'end':
	                  return _context.stop();
	              }
	            }
	          }, _callee, undefined);
	        }));
	
	        return function (_x) {
	          return _ref2.apply(this, arguments);
	        };
	      }(), function (err) {
	        console.error(err);
	        dispatch(setWizardErrorMessage(err.message || null, err.title));
	        dispatch(setWizardLoadFailed(true));
	        dispatch(toggleWizardLoading(false));
	      });
	    }, function (err) {
	      console.error(err);
	      dispatch(setWizardErrorMessage(err.message || null, err.title));
	      dispatch(setWizardLoadFailed(true));
	      dispatch(toggleWizardLoading(false));
	    });
	  };
	};
	
	var fetchAndPopulateReadOnlyWizard = exports.fetchAndPopulateReadOnlyWizard = function fetchAndPopulateReadOnlyWizard(_ref3) {
	  var formDefinitionId = _ref3.formDefinitionId,
	      amendmentNum = _ref3.amendmentNum;
	  return function (dispatch) {
	    dispatch(toggleWizardLoading(true));
	    api.LOAD_WIZARD_INJECT_METADATA(formDefinitionId, amendmentNum, true, function (wizard) {
	      var accessLevel = ({"NODE_ENV":"production","BUILD_DATE":"2025-08-27T15:15:31.687Z","BUILD_NUMBER":"Not Provided","GIT_VERSION":"v1.3.0-381-ga81e29b08","GIT_COMMIT_HASH":"a81e29b085c9268ffd96c78eb734365802722741","GIT_BRANCH":"beta","PUBLIC_URL":"","STATE_ABBR":"MT","STATE_NAME":"Montana","STATE_ORG_TITLE":"Secretary of State","LOGIN_HEADER_IMG_PATH":"","HOME_IMG_FILENAME":"montana.jpg","FAVICON_FILE_NAME":"favicon.ico","ALLOW_E_SIGN_ON_CORRECTIONS":true,"THIRD_PARTY_SIGNING_ALLOWED":false,"MY_ACCOUNT_SAVE_AND_CLOSE_BUTTON":true,"IE_DEPRECATED_MESSAGE":"Internet Explorer is not supported. Please select a supported browser below to access this website.","ADDITIONAL_ROUTES":{"dataRequests":true,"farmBill":true,"apostille":true,"externalHelp":"https://sosmt.gov/business/help-center/","systemAdministration":[{"title":"Saved Payments","parameter":"saved-payments","componentName":"SavedPayments"}]},"SUBROUTES":[{"label":"Business","component":"Business","parameter":"business","myWorkQueueSearch":false,"sourceTypeId":54,"searchMustHaveOneOf":["FILING_TYPE_ID","STATUS_ID","STATE","search"],"serverWebSearchDescription":true,"serverWorkQueueDescription":true,"serverMyRecordsDescription":true,"searchPlaceholder":"Search by name or filing number (X########)","allowEmptySearchTerm":true,"requestCertificateAlternateLabel":"Request Information","fileAmendmentButtonLabel":"Filing Actions","advancedSearchParameters":[{"type":"radio","name":"QUERY_TYPE_ID","defaultValue":1010,"options":[{"value":1010,"label":"Starts with"},{"value":1011,"label":"Contains"},{"value":1012,"label":" Word Contains"}]},{"type":"serverSelect","name":"FILING_TYPE_ID","optionsSrc":"FILING_TYPES","label":"Entity Type","placeholder":"All","defaultValue":"0"},{"type":"serverSelect","name":"FILING_SUBTYPE_ID","optionsSrc":"FILING_SUBTYPES","label":"Entity Subtype","overrideSubOptionsSrcFromParameterName":"FILING_TYPE_ID","placeholder":"All","defaultValue":"0"},{"type":"serverSelect","name":"STATUS_ID","optionsSrc":"FILING_STATUS_WITHOUT_ALL","label":"Status","placeholder":"All","defaultValue":"0"},{"type":"serverSelect","name":"STATE","optionsSrc":"STATE","label":"State","placeholder":"All","defaultValue":""},{"type":"serverSelect","name":"COUNTY","optionsSrc":"COUNTY_SUBOPTION","label":"County","overrideSubOptionsSrcFromParameterName":"STATE","placeholder":"All","defaultValue":""},{"type":"checkbox","name":"CRA_SEARCH_YN","defaultValue":false,"label":"Search by Registered Agent PID"},{"type":"dateRange","name":"FILING_DATE","label":"Registration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}},{"type":"dateRange","name":"EXPIRATION_DATE","label":"Expiration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}}],"myRecordsFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Active"},{"value":2,"label":"Inactive"},{"value":3,"label":"Pending"}]},{"type":"dateRange","name":"DATE_RANGE","label":"Date range","defaultValue":{"start":null,"end":null}}],"myWorkQueueFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Approved"},{"value":2,"label":"Pending Online Payment"},{"value":3,"label":"Pending Review"},{"value":4,"label":"Needs Correction"},{"value":5,"label":"Rejected"},{"value":6,"label":"Draft"}]},{"type":"dateRange","name":"DATE_RANGE","label":"Date range","defaultValue":{"start":null,"end":null}}]},{"label":"Notary","component":"Notary","parameter":"notary","sourceTypeId":850,"myWorkQueueSearch":false,"allowEmptySearchTerm":true,"requestCertificateAlternateLabel":"Download Certificate","fileAmendmentButtonLabel":"Filing Actions","hideNameRequestCertificate":true,"hideAddressRequestCertificate":true,"hideRecordUserManagment":true,"searchPlaceholder":"Search by name or commission number","searchMustHaveOneOf":["CITY","search","SERVICE_TYPE"],"advancedParametersStartOpen":true,"searchIsSortable":true,"advancedSearchParameters":[{"type":"radio","name":"STARTS_WITH_YN","defaultValue":false,"options":[{"value":true,"label":"Starts with"},{"value":false,"label":"Contains"}]},{"type":"checkbox","name":"ACTIVE_ONLY_YN","defaultValue":true,"label":"Active entities only"},{"type":"text","name":"CITY","defaultValue":"","label":"City"},{"type":"select","name":"SERVICE_TYPE","label":"Special Services Offered","defaultValue":0,"options":[{"value":0,"label":"(N/A)"},{"value":6165,"label":"In-Person Electronic Notarization (IPEN)"},{"value":6166,"label":"Remote Online Notarization (RON)"},{"value":6167,"label":"Mobile Notary Services"},{"value":6168,"label":"Remote Ink Notarization (RIN)"}]}]},{"label":"Apostille","component":"Apostille","parameter":"apostille","sourceTypeId":720,"myRecordsSearch":false,"myWorkQueueSearch":false,"disabled":false,"allowedRoutes":["/forms-manager/","/queue/","/forms/"]},{"label":"Liens","component":"UCC","parameter":"ucc","sourceTypeId":1999,"myRecordsSearch":true,"myWorkQueueSearch":true,"fileAmendmentButtonLabel":"Filing Actions","searchPlaceholder":"Search by name or file number","disabled":false,"serverWebSearchDescription":true,"myRecordsDescription":"","workQueueDescription":"","searchDescription":"","hideRecordUserManagment":true,"searchLiensCheckout":false,"advancedSearchParameters":[{"type":"radio","name":"STARTS_WITH_YN","defaultValue":false,"options":[{"value":true,"label":"Starts with"},{"value":false,"label":"Contains"}]},{"type":"select","name":"STATUS","defaultValue":"ALL","label":"Status","options":[{"value":"ACTIVE_UNLAPSED","label":"Active (unlapsed)"},{"value":"ACTIVE_LAPSED_UNLAPSED","label":"Active (lapsed and unlapsed)"}]},{"type":"text","name":"EXCLUDE_VALUES","label":"Exclude Debtor Names (comma separated list of names to exclude)","defaultValue":""},{"type":"dateRange","name":"FILING_DATE","label":"Financing Statement Date","defaultValue":{"start":null,"end":null}},{"type":"dateRange","name":"LAPSE_DATE","label":"Lapse Date","defaultValue":{"start":null,"end":null}},{"type":"text","name":"CITY","label":"Debtor City","defaultValue":""}],"myRecordsFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Approved"},{"value":2,"label":"Pending Online Payment"},{"value":3,"label":"Pending Review"}]},{"type":"select","name":"TYPE","defaultValue":0,"label":"Lien Type","options":[{"value":0,"label":"All"},{"value":1,"label":"UCC"},{"value":2,"label":"EFS"},{"value":3,"label":"Title 71"}]}],"myWorkQueueFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Approved"},{"value":2,"label":"Pending Online Payment"},{"value":3,"label":"Pending Review"},{"value":4,"label":"Pending Print and Mail"},{"value":5,"label":"Rejected"},{"value":6,"label":"Draft"}]},{"type":"select","name":"TYPE","defaultValue":0,"label":"Lien Type","options":[{"value":0,"label":"All"},{"value":1,"label":"UCC"},{"value":2,"label":"EFS"},{"value":3,"label":"Title 71"}]}]},{"label":"Copy Request","component":"copies","parameter":"copies","sourceTypeId":2001,"myRecordsSearch":false,"myWorkQueueSearch":false,"disabled":false,"allowedRoutes":["/forms-manager/","/queue/","/forms/"]},{"label":"Trademark","component":"Trademark","parameter":"trademark","sourceTypeId":810,"showRequestCertificate":true,"searchMustHaveOneOf":["search","EXPIRATION_DATE","FILING_DATE"],"allowEmptySearchTerm":true,"requestCertificateAlternateLabel":"Request Information","fileAmendmentButtonLabel":"Filing Actions","advancedSearchParameters":[{"type":"radio","name":"QUERY_TYPE_ID","defaultValue":1010,"options":[{"value":1010,"label":"Starts with"},{"value":1011,"label":"Contains"},{"value":1012,"label":" Word Contains"}]},{"type":"checkbox","name":"OWNER_SEARCH_YN","defaultValue":false,"label":"Search owners"},{"type":"radio","name":"SERVICE_MARK_YN","label":"Mark Type","defaultValue":"","options":[{"value":"","label":"All Marks"},{"value":"Y","label":"Service Mark"},{"value":"N","label":"Trademark"}]},{"type":"serverSelect","name":"STATUS_ID","optionsSrc":"TYPE_V|TRADEMARK_STATUS_TYPE","label":"Status","placeholder":"All","defaultValue":"0"},{"type":"select","name":"DESIGN_TYPE_ID","options":[{"value":0,"label":"All"},{"value":990,"label":"Words Only"},{"value":991,"label":"Design Only"},{"value":992,"label":"Words and Design"}],"label":"Design Type","defaultValue":"0"},{"type":"dateRange","name":"FILING_DATE","label":"Registered Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}},{"type":"dateRange","name":"EXPIRATION_DATE","label":"Expiration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}}]},{"label":"Business Info Request","component":"InfoRequests","parameter":"info-request","sourceTypeId":167,"allowedRoutes":["/forms-manager/","/queue/","/forms/"]},{"label":"Data Requests","component":"DataRequests","parameter":"data-request","sourceTypeId":0,"allowedRoutes":["/forms-manager/"]},{"label":"CRA","component":"CRA","parameter":"cra","sourceTypeId":157,"myRecordsSearch":false,"searchPlaceholder":"Search by name or registered agent number","allowedRoutes":["/forms-manager/","/forms/","/records/","/queue/","/search/"],"allowEmptySearchTerm":true,"fileAmendmentButtonLabel":"Filing Actions","advancedSearchParameters":[{"type":"radio","name":"QUERY_TYPE_ID","defaultValue":1010,"options":[{"value":1010,"label":"Starts with"},{"value":1011,"label":"Contains"},{"value":1012,"label":" Word Contains"}]},{"type":"dateRange","name":"CRA_DATE","label":"Registration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}},{"type":"select","name":"STATUS_ID","label":"Status","defaultValue":0,"options":[{"value":0,"label":"All"},{"value":121,"label":"Active"},{"value":122,"label":"Inactive"}]},{"type":"select","name":"AGENT_TYPE_ID","label":"Agent Type","defaultValue":0,"options":[{"value":0,"label":"All"},{"value":460,"label":"Registered Agent"},{"value":461,"label":"Commercial Registered Agent"}]}]},{"label":"Farm Bill","component":"FarmBill","parameter":"farm-bill","path":"/lists/farm-bill","sourceTypeId":0,"myRecordsSearch":false,"allowedRules":["/search/"],"disabled":true,"searchDescription":"To perform a search, enter a debtor name. Your search results may include: exact debtor name, variations of that name and any filing that includes your search criteria. Punctuation is ignored.\n\nYou can click on \"Advanced\" to refine your search. Under “Advanced” you can search by crop, year, county and SSN/FEIN. As a registered Farm Bill Buyer with the Montana Secretary of State’s office it is important to maintain the confidentiality of the information contained within the Farm Bill Master List. The Farm Bill Master List reflects personal data, such as Social Security Numbers, which are a key piece of personal identifiable information to assist you in determining the existence of a lien against a specific debtor. The distribution of this information beyond its intended purpose is strictly prohibited.\n\nThe debtor's tax identification number has been hidden for confidentiality reasons. You may continue to search on a tax ID number and return debtors that match your search criteria. The SSN/FEIN must be entered without dashes or spaces.","searchMustHaveOneOf":["search","UCC_FARM_PRODUCT_ID","COUNTY"],"searchPlaceholder":"Search by debtor name","advancedSearchParameters":[{"type":"ServerMultiComplete","label":"Product code name(s)","name":"UCC_FARM_PRODUCT_ID","defaultValue":"","optionsSrc":"UCC_FARM_PRODUCT_V"},{"type":"MultiComplete","label":"Year or Range of Years","name":"YEAR_NUM","optionsSrc":"years","startYear":"1968","defaultValue":[],"preMergeOptions":[{"value":"ALL","label":"All"}]},{"type":"serverSelect","label":"State","name":"STATE","defaultValue":"MONTANA","optionsSrc":"STATE"},{"type":"ServerMultiComplete","label":"County","name":"COUNTY","defaultValue":[],"optionsSrc":"COUNTY","overrideSubOptionsSrcFromParameterName":"STATE"},{"type":"checkbox","name":"TIN_SEARCH_YN","defaultValue":false,"label":"Tax Identification Number Search"},{"type":"checkbox","name":"TIN_SORT_YN","defaultValue":false,"label":"Unique ID Sort"}]}],"SYSTEM_NICKNAME":"Online Services Portal","PAYMENT_METHODS":[{"type":"bypass"},{"type":"iTransact"}],"PAYMENT_ALLOW_AMEX":true,"SYSTEM_ID_LABEL":"System Id","DOUBLE_COLUMN_PUBLIC_LOGIN":true,"INTERNAL_USER_MANAGEMENT":true,"ALLOW_PUBLIC_JSON_IMPORT":false,"MAX_FILE_UPLOAD_SIZE":10000000,"REFUND_TEXT":"","RETURN_TO_HOME_ON_LOGOUT":true,"CURRENT_SOS_NAME":"Christi Jacobsen","LOGO_FILENAME":"mt-sos-logo.png","LOGO_ALT":"Christi Jacobsen, Montana Secretary of State","LOGO_FULL_WIDTH":true,"HOME_HIDE_AUTH_HINT":true,"HOME_TITLE":"Montana Secretary of State","CUSTOM_TAB_TITLE":"Official Montana","HOME_SUBTITLE":"Online Business Services","ENTITY_NAME_CONSENT_DESCRIPTION":"","ALLOW_USER_PROFILE_EDITING":true,"COMPARE_FOREIGN_NAME_IN_ENTITY_NAME_VALIDATION":true,"FOREIGN_NAME_FIELD_NAME":"KIMA_PARENT_NAME_INFO","LOGIN_TITLE":"Montana Secretary of State Online Filing Portal Login","PUBLIC_LOGIN_LABEL":"Username","REVERSE_LOGIN_COLUMNS":true,"LOGIN_SEAL_FILENAME":"seal_white.png","SEPARATE_USERNAME_AND_EMAIL":true,"CREATE_ACCOUNT_BUTTON_ALIGN_LEFT":true,"CREATE_ACCOUNT_BUTTON_TEXT":"CREATE AN ACCOUNT","PASSWORD_CUSTOM_ERROR_TEXT":"The password must meet all requirements","ACCOUNT_CREATED_MESSAGE":"Please check your email to verify your account to login and allow a few minutes for this message to arrive. Check your junk/spam folders if you do not find the email in your inbox.","PUBLIC_LOGIN_PLACEHOLDER":" ","DISABLE_DEFAULT_PAYMENT_RADIO":true,"CUSTOM_RESET_PASSWORD_ERROR_MESSAGE":"Username invalid - no account found","PUBLIC_LOGIN_CREATE_DESCRIPTION":"### Existing User:\n\n  - Enter your username and password to login.  \n\n\n  #### - OR -  \n\n\n\n  - Forgot password? Click 'Reset Password' and follow the prompts.\n  - Forgot username? Click 'Forgot Username' and follow the prompts.  \n\n\n  ### New User:\n  ","LOGIN_HELP_LINK":"https://sosmt.gov/business/how-do-i/","LOGIN_HELP_LINK_TEXT":"Need Help?","FORGOT_USERNAME_TEXT":"Forgot Username?","LOGIN_ACTIVE_DIRECTORY_TEXT":"State User Login","MULTIPLE_LOGIN_METHODS":true,"HAS_ACTIVE_DIRECTORY_LOGIN":true,"RESET_PASSWORD_WITH_USERNAME":true,"DOWNLOAD_LINK":true,"SHOW_USERNAME_ACCOUNT_CREATE":true,"SHOW_SCROLL_DOWN_ARROW":true,"SHOW_ADDRESS_ACCOUNT_CREATE":true,"TWO_COLUMN_ACCOUNT_CREATE":true,"RESET_PASSWORD_TIP":"A link to change your password has been sent to your email. Please allow a few minutes for this message to arrive. Please check your junk/spam folders if you do not find the email in your inbox.","FORGOT_PASSWORD_LINK_TEXT":"Reset Password","PHONE_NUMBER_OPTIONAL_ACCOUNT_CREATE":true,"SHOW_REQUIRED_INDICATOR_ACCOUNT_CREATE":true,"PASSWORD_REQUIREMENTS_ACCOUNT_CREATE":"\n    <ul>\n      <li>MUST contain at least 8 characters (12+ recommended)</li>\n      <li>MUST contain at least one uppercase letter.</li>\n      <li>MUST contain at least one lowercase letter.</li>\n      <li>MUST contain at least one number.</li>\n      <li>MUST contain at least one special character (!”#$%&'()*+,-./:;<=>?</li>\n    </ul>\n  ","ALLOW_CERTIFICATION_REQUEST":true,"ALLOW_PUBLIC_CERTIFICATE_REQUEST":true,"ALLOW_COPY_REQUEST":false,"ALLOW_CORRECTION_STYLING":true,"HIDE_DEPRECATION_WARNING":false,"AMEND_ROUTE_PUBLIC":true,"SEAL_FILENAME":"seal.png","SHOPPING_CART":true,"ALLOW_PAYMENT_UPDATE_WITH_EMPTY_CART":true,"RA_EMAIL":true,"RA_WEBSITE":true,"RA_NO_DEFAULT_TYPE":true,"RA_ADDRESS_LABEL":"Street Address","RA_TYPE_SELECTION_DEFAULT":true,"RA_DEFAULT_TYPE":"460","RA_OVERRIDE_TYPE_WITH_DEFAULT":true,"RA_PRINCIPAL_ADDRESS_AMS":true,"UPLOAD_AND_SUBMIT_HIDE_IF_ONE_OPTION":true,"PAYMENT_PROCESSING_MESSAGE":"Your payment is processing - Do not close your browser or click the back button","CHECKOUT_BUTTON_WHEN_PROCESSING_TEXT":"Processing","EFS_CROP_PICKER_NONE_LABEL":"Lien Duration","DISALLOWED_WIZARD_PIECES":["FormationLocale"],"REPEATER_SHOW_EDIT_BUTTON":true,"DATA_REQUEST_PAGE_TITLE":"Data Requests and Subscriptions","DATA_REQUEST_SIDEBAR_LABEL":"Data Requests & Subscriptions","LOGIN_REDIRECTS_TO_EPASS":false,"LOGIN_REDIRECTS_TO_ACTIVE_DIRECTORY":true,"LOGIN_ACTIVE_DIRECTORY_LINK":true,"FETCH_EDIT_USER_LINK":false,"LISTS_FETCH_AVAILABLE_LISTS":true,"POST_WIZARD_SUBMIT_REDIRECT_URL":"/","PIN_REQUEST_ATTESTATIONS":true,"PIN_REQUEST_DESCRIPTION":"Click **Request PIN** to have a new PIN sent to the account holder's email address on file.","OWNERSHIP_REQUEST_DESCRIPTION":"To become an **authorized user** of this record, a current **AUTHORIZED USER** will need to grant you access. To request access, click **Request Access** below.","PIN_REQUEST_SUCCESS_MESSAGE":"The PIN you have requested for this entity has been sent to the email associated with your user account.  You should receive the PIN in approximately 3-5 minutes, depending on your email service provider.","APOSTILLE_HEADER_LABEL":"Verification Information","APOSTILLE_NUMBER_LABEL":"Apostille/Authentication","APOSTILLE_CITY_STATE_OVERRIDE":"HELENA, MT","APOSTILLE_FILING_DATE_LABEL":"Issue Date","APOSTILLE_CITY_STATE_IN_CERTIFIED":true,"NOTARY_EXISTING_FILING":true,"ALLOW_REVOKE_OWN_ACCESS_ONLY":false,"HIDE_CANCEL_ON_ONETIME_DATA_REQUESTS":true,"DATA_REQUESTS_IN_SHOPPING_CART":true,"WQ_ALLOW_EDIT_PENDING_PAYMENT":true,"WQ_CONFIRM_ON_DELETE":true,"WQ_DELETE_CONFIRM_MESSAGE":"Deleting this filing will forfeit any money already paid to the Secretary of State. This action is permanent and cannot be undone, are you sure you would like to delete?","PASS_ITEM_GUIDS_ON_CHECKOUT":true,"FORM_REVISION_HISTORY":true,"CHECKOUT_DISCLAIMER":"By entering your credit card and/or checking account information you (i) state that **you are an authorized user** of the credit card and/or electronic check and that the associated information entered (e.g., account holder name, account number, billing address) is accurate, (ii) **you authorize payment processor to charge the amount you have requested** to your credit card and/or funding account, and (iii) **acknowledge if a charge is declined or reversed you may also be assessed a customary charge** by the payment processor for such transactions.","FARM_BILL_SEARCH_CONFIDENTIAL":"As a registered Farm Bill Buyer with the Montana Secretary of State’s office it is important to maintain the confidentiality of the information contained within the Farm Bill Master List. The Farm Bill Master List reflects personal data, such as Social Security Numbers, which are a key piece of personal identifiable information to assist you in determining the existence of a lien against a specific debtor. The distribution of this information beyond its intended purpose is strictly prohibited.\n\n**The debtor's tax identification number has been hidden for confidentiality reasons. You may continue to search on a tax ID number and return debtors that match your search criteria. The SSN/FEIN must be entered without dashes or spaces.  If you need access to the tax identification number to clearly identify the debtor, please contact the UCC unit at (406) 444-3665.**","VIEW_HISTORY_BUTTON_ALT_TEXT":"View Filings","WIZARD_ERROR_TITLE_MESSAGE":"Form Error","FARM_BILL_SEARCH_INTERACTIVE":true,"USE_FARM_BILL_API":true,"DISALLOW_ASSIGN_SELF_AS_RA":true,"DISALLOW_ASSIGN_SELF_AS_PRINCIPAL":true,"USE_TRADEMARK_OWNER_VALIDATION":true,"USE_ALTERNATIVE_FOREIGN_ADDRESS_LABELS":true,"MY_RECEIPTS_FILTER":[{"type":"dateRange","name":"DATE_RANGE","label":"Date range","defaultValue":{"start":null,"end":null}},{"type":"text","name":"REF_NUM","defaultValue":"","label":"Reference Number"},{"type":"text","name":"RECEIPT_NUM","defaultValue":"","label":"Receipt Id"},{"type":"text","name":"AMOUNT","defaultValue":"","label":"Amount"},{"type":"select","name":"TYPE","defaultValue":"","label":"Payment Type","options":[{"value":"","label":"All"},{"value":"CC","label":"Credit Card"},{"value":"Check","label":"Check"}]}],"MY_RECEIPTS_SHOW_IN_SIDEBAR":true,"SHOW_MY_RECEIPTS_HELPER_TEXT":true,"MY_RECEIPTS_HELPER_LABEL":"About Receipt Search","MY_RECEIPTS_HELPER_TEXT":"You can search for receipts based on their descriptions, including the items paid for on the receipt. Use the filters to search for or filter specific information.","FARM_BILL_SUBLINK":{"label":"Farm Bill","component":"FarmBill","parameter":"farm-bill","path":"/lists/farm-bill","sourceTypeId":0,"myRecordsSearch":false,"allowedRules":["/search/"],"disabled":true,"searchDescription":"To perform a search, enter a debtor name. Your search results may include: exact debtor name, variations of that name and any filing that includes your search criteria. Punctuation is ignored.\n\nYou can click on \"Advanced\" to refine your search. Under “Advanced” you can search by crop, year, county and SSN/FEIN. As a registered Farm Bill Buyer with the Montana Secretary of State’s office it is important to maintain the confidentiality of the information contained within the Farm Bill Master List. The Farm Bill Master List reflects personal data, such as Social Security Numbers, which are a key piece of personal identifiable information to assist you in determining the existence of a lien against a specific debtor. The distribution of this information beyond its intended purpose is strictly prohibited.\n\nThe debtor's tax identification number has been hidden for confidentiality reasons. You may continue to search on a tax ID number and return debtors that match your search criteria. The SSN/FEIN must be entered without dashes or spaces.","searchMustHaveOneOf":["search","UCC_FARM_PRODUCT_ID","COUNTY"],"searchPlaceholder":"Search by debtor name","advancedSearchParameters":[{"type":"ServerMultiComplete","label":"Product code name(s)","name":"UCC_FARM_PRODUCT_ID","defaultValue":"","optionsSrc":"UCC_FARM_PRODUCT_V"},{"type":"MultiComplete","label":"Year or Range of Years","name":"YEAR_NUM","optionsSrc":"years","startYear":"1968","defaultValue":[],"preMergeOptions":[{"value":"ALL","label":"All"}]},{"type":"serverSelect","label":"State","name":"STATE","defaultValue":"MONTANA","optionsSrc":"STATE"},{"type":"ServerMultiComplete","label":"County","name":"COUNTY","defaultValue":[],"optionsSrc":"COUNTY","overrideSubOptionsSrcFromParameterName":"STATE"},{"type":"checkbox","name":"TIN_SEARCH_YN","defaultValue":false,"label":"Tax Identification Number Search"},{"type":"checkbox","name":"TIN_SORT_YN","defaultValue":false,"label":"Unique ID Sort"}]},"ALLOW_ADDRESS_VALIDATION_BYPASS_OPTION":true,"DEFAULT_ADDRESS_VALIDATION_BYPASS_OPTION_CHECKED":true}).ALLOW_SHOW_AR_WHEN_LOGGED_IN && wizard.PX_WUAL_TYPE_ID ? wizard.PX_WUAL_TYPE_ID : null;
	      api.LOAD_AMENDMENT_BY_ID(amendmentNum, wizard.CATEGORY, 'filing', false, accessLevel, function () {
	        var _ref4 = _asyncToGenerator(_regenerator2.default.mark(function _callee2(amendment) {
	          var steps, precalculatedValues, _JSON$parse2, formValues, DYNAMIC_DATA, parsedWizard, prevFields, _JSON$parse3, _formValues, _DYNAMIC_DATA, previousWizard, meta;
	
	          return _regenerator2.default.wrap(function _callee2$(_context2) {
	            while (1) {
	              switch (_context2.prev = _context2.next) {
	                case 0:
	                  steps = JSON.parse(wizard.STEPS_JSON);
	                  precalculatedValues = amendment.PRECALCULATED_VALUES ? JSON.parse(amendment.PRECALCULATED_VALUES) : {};
	                  _JSON$parse2 = JSON.parse(amendment.JSON), formValues = _JSON$parse2.FIELD_VALUES, DYNAMIC_DATA = _JSON$parse2.METADATA.DYNAMIC_DATA;
	                  parsedWizard = CreateInstancesFromJson(steps, Object.assign({}, precalculatedValues, DYNAMIC_DATA, formValues), { forceAllowPrepopulation: true });
	                  prevFields = null;
	
	                  if (!amendment.PREV_JSON) {
	                    _context2.next = 15;
	                    break;
	                  }
	
	                  _JSON$parse3 = JSON.parse(amendment.PREV_JSON), _formValues = _JSON$parse3.FIELD_VALUES, _DYNAMIC_DATA = _JSON$parse3.METADATA.DYNAMIC_DATA;
	                  previousWizard = CreateInstancesFromJson(steps, Object.assign({}, precalculatedValues, _DYNAMIC_DATA, _formValues), { forceAllowPrepopulation: true });
	                  _context2.t0 = preFetchMergeCodes;
	                  _context2.next = 11;
	                  return prefetchRequiredData(previousWizard.fields);
	
	                case 11:
	                  _context2.t1 = _context2.sent;
	                  _context2.next = 14;
	                  return (0, _context2.t0)(_context2.t1);
	
	                case 14:
	                  prevFields = _context2.sent;
	
	                case 15:
	                  meta = xml2Json.xml2js(wizard.METADATA) ? xml2Json.xml2js(wizard.METADATA).METADATA : {};
	
	                  prefetchRequiredData(parsedWizard.fields).then(function (fields) {
	                    return preFetchMergeCodes(fields, meta);
	                  }).then(function (fields) {
	                    var original = getOriginalValues(prevFields || fields);
	                    var originalByFieldId = getOriginalByFieldId(prevFields || fields);
	                    var fieldsRequirePrintMailMethod = calculatePrintMailMethod(fields);
	                    dispatch(populateWizard({
	                      formDefinitionId: formDefinitionId,
	                      title: wizard.TITLE,
	                      stepOrder: parsedWizard.stepOrder,
	                      steps: parsedWizard.steps,
	                      sections: parsedWizard.sections,
	                      fields: fields,
	                      description: wizard.DESCR,
	                      sourceId: wizard.SOURCE_ID,
	                      amendmentNum: amendmentNum,
	                      original: original,
	                      originalByFieldId: originalByFieldId,
	                      readOnly: true,
	                      meta: meta,
	                      docTitleSrc: wizard.DOC_TITLE_SRC,
	                      draftId: false,
	                      docId: parsedWizard.docId,
	                      category: wizard.CATEGORY,
	                      mode: wizard.MODE,
	                      correctionMode: true,
	                      formTitle: wizard.FORM_TITLE,
	                      internalReviewRequired: wizard.INTERNAL_REVIEW_REQUIRED_YN,
	                      requirePrintMailMethod: wizard.PRINT_MAIL_REQUIRED_YN,
	                      fieldsRequirePrintMailMethod: fieldsRequirePrintMailMethod,
	                      onlyRenderChangedFieldsOnForm: wizard.ONLY_SHOW_CHANGED_FIELDS_ON_FORM_YN,
	                      noLoginRequired: wizard.PUBLIC_YN,
	                      feeDescription: wizard.FEE_DESCR,
	                      canChangeEntryType: amendment.CAN_CHANGE_ENTRY_TYPE_YN,
	                      draftsDisabled: wizard.DRAFTS_DISABLED,
	                      thirdPartySigningAllowed: wizard.AUTHORIZED_THIRD_PARTY_YN,
	                      globalVariables: wizard.GLOBAL_VARIABLES ? JSON.parse(wizard.GLOBAL_VARIABLES) : undefined,
	                      wizardAttributesLogic: wizard.WIZARD_ATTRIBUTES_LOGIC ? JSON.parse(wizard.WIZARD_ATTRIBUTES_LOGIC) : undefined
	                    }));
	                  });
	
	                case 17:
	                case 'end':
	                  return _context2.stop();
	              }
	            }
	          }, _callee2, undefined);
	        }));
	
	        return function (_x2) {
	          return _ref4.apply(this, arguments);
	        };
	      }(), function (err) {
	        console.error(err);
	        dispatch(setWizardErrorMessage(err.message || null, err.title));
	        dispatch(setWizardLoadFailed(true));
	        dispatch(toggleWizardLoading(false));
	      });
	    }, function (err) {
	      console.error(err);
	      dispatch(setWizardErrorMessage(err.message || null, err.title));
	      dispatch(setWizardLoadFailed(true));
	      dispatch(toggleWizardLoading(false));
	    });
	  };
	};
	
	var fetchAndPopulateSignatures = exports.fetchAndPopulateSignatures = function fetchAndPopulateSignatures(token) {
	  return function (dispatch) {
	    dispatch(toggleWizardLoading(true));
	    api.GET_SIGNATURE_FORM_BY_TOKEN(token, function (_ref5) {
	      var amendment = _ref5.AMENDMENT,
	          wizard = _ref5.FORM_DEFINITION,
	          signature = _ref5.SIGNATURE;
	
	      if (signature.SIGNED_DATE !== null) {
	        dispatch(toggleWizardLoading());
	        dispatch(setGenericSuccess({
	          title: 'Successfully submitted',
	          message: 'Your signature was successfully saved. You may now safely close your browser window.'
	        }));
	      } else {
	        var steps = JSON.parse(wizard.STEPS_JSON);
	        var amendmentValues = JSON.parse(amendment.WIZARD_JSON).FIELD_VALUES;
	        var parsedWizard = CreateInstancesFromJson(steps, amendmentValues);
	        var meta = xml2Json.xml2js(wizard.METADATA) ? xml2Json.xml2js(wizard.METADATA).METADATA : {};
	        prefetchRequiredData(parsedWizard.fields).then(function (fields) {
	          return preFetchMergeCodes(fields, meta);
	        }).then(function (fields) {
	          var original = getOriginalValues(fields);
	          var originalByFieldId = getOriginalByFieldId(fields);
	          var fieldsRequirePrintMailMethod = calculatePrintMailMethod(fields);
	          dispatch(populateWizard({
	            formDefinitionId: wizard.FORM_DEFINITION_ID,
	            title: wizard.TITLE,
	            stepOrder: parsedWizard.stepOrder,
	            steps: parsedWizard.steps,
	            sections: parsedWizard.sections,
	            fields: fields,
	            description: wizard.DESCR,
	            sourceId: wizard.SOURCE_ID,
	            amendmentNum: amendment.AMENDMENT_NUM,
	            draftId: false,
	            category: wizard.CATEGORY,
	            meta: meta,
	            docTitleSrc: wizard.DOC_TITLE_SRC,
	            mode: 'signature',
	            original: original,
	            originalByFieldId: originalByFieldId,
	            docId: parsedWizard.docId,
	            correctionMode: false,
	            showDiff: amendment.SHOW_DIFF_YN,
	            formTitle: wizard.FORM_TITLE,
	            internalReviewRequired: meta.INTERNAL_REVIEW_REQUIRED_YN || wizard.INTERNAL_REVIEW_REQUIRED_YN,
	            onlyRenderChangedFieldsOnForm: wizard.ONLY_SHOW_CHANGED_FIELDS_ON_FORM_YN,
	            requirePrintMailMethod: amendment.PRINT_MAIL_REQUIRED_YN,
	            fieldsRequirePrintMailMethod: fieldsRequirePrintMailMethod,
	            noLoginRequired: true,
	            feeDescription: wizard.FEE_DESCR,
	            canChangeCorrectionEntryType: amendment.CAN_CHANGE_CORRECTION_ENTRY_TYPE,
	            draftsDisabled: true,
	            globalVariables: wizard.GLOBAL_VARIABLES ? JSON.parse(wizard.GLOBAL_VARIABLES) : undefined,
	            wizardAttributesLogic: wizard.WIZARD_ATTRIBUTES_LOGIC ? JSON.parse(wizard.WIZARD_ATTRIBUTES_LOGIC) : undefined,
	            signature: Object.assign({}, signature, {
	              SIGNATURE_JSON: JSON.parse(signature.SIGNATURE_JSON)
	            })
	          }));
	          dispatch(resetWizardSignatureValues());
	        });
	      }
	    }, function (err) {
	      console.error(err);
	      dispatch(setWizardErrorMessage(err.message || null, err.title));
	      dispatch(setWizardLoadFailed(true));
	      dispatch(toggleWizardLoading(false));
	    });
	  };
	};
	
	var calculatePrintMailMethod = function calculatePrintMailMethod(fields) {
	  var requirePrintMailMethod = new Set();
	  var fieldsArray = Object.keys(fields).map(function (fieldId) {
	    return fields[fieldId];
	  });
	  fieldsArray.forEach(function (field) {
	    switch (field.type) {
	      case 'repeater':
	        switch (field.printMailRequiredIf) {
	          case '>1':
	            if (field.value.length > 1) requirePrintMailMethod.add(field.fieldId);
	            break;
	          case '>2':
	            if (field.value.length > 2) requirePrintMailMethod.add(field.fieldId);
	            break;
	        }
	        break;
	      default:
	    }
	  });
	  return requirePrintMailMethod;
	};
	
	var getOriginalValues = function getOriginalValues(fields) {
	  var originalValues = {};
	  Object.keys(fields).forEach(function (fieldId) {
	    return originalValues[fields[fieldId].name] = fields[fieldId].value;
	  });
	  return originalValues;
	};
	var getOriginalByFieldId = function getOriginalByFieldId(fields) {
	  var originalValues = {};
	  Object.keys(fields).forEach(function (fieldId) {
	    originalValues[fieldId] = fields[fieldId].value;
	  });
	  return originalValues;
	};
	
	var prefetchRequiredData = function prefetchRequiredData(fields) {
	  return new Promise(function (resolve, reject) {
	    var fieldsArray = (0, _utilities.objectToArray)(fields);
	    var promises = [];
	    fieldsArray.forEach(function (field) {
	      var promise = getPromiseByFieldType(field, fields);
	      if (promise) {
	        promises.push(promise);
	      }
	    });
	    var requiredAppSettingNames = (0, _utilities.getRequiredAppSettingNames)(fieldsArray);
	    if (requiredAppSettingNames.length) {
	      promises.push(new Promise(function (resolve, reject) {
	        (0, _AppSettingActions.getAppSettingsByName)(requiredAppSettingNames, function () {
	          resolve(null);
	        }, function () {
	          resolve(null);
	        });
	      }));
	    }
	    Promise.all(promises).then(function (results) {
	      var newFields = Object.assign({}, fields);
	      results.filter(function (x) {
	        return x;
	      }).forEach(function (f) {
	        newFields = Object.assign({}, newFields, _defineProperty({}, f.fieldId, f));
	      });
	      resolve(newFields);
	    });
	  });
	};
	
	var GROUP_ITEMS_PROMISE_CACHE = {};
	var GROUP_SUB_ITEMS_PROMISE_CACHE = {};
	
	var getPromiseByFieldType = function getPromiseByFieldType(field, fields) {
	  switch (field.type) {
	    case 'serverRadio':
	    case 'serverSelect':
	    case 'ServerMultiComplete':
	      var optionsSrcOverride = field.optionsSrcOverride ? fields[field.optionsSrcOverride].value : field.optionsSrc;
	
	      var subOptionsSrcOverride = field.subOptionsSrcOverride ? fields[field.subOptionsSrcOverride].value : field.subOptionsSrc;
	
	      var urlQuery = window.location.search;
	
	      var pendingPromise = subOptionsSrcOverride ? GROUP_SUB_ITEMS_PROMISE_CACHE[optionsSrcOverride + subOptionsSrcOverride + urlQuery] : GROUP_ITEMS_PROMISE_CACHE[optionsSrcOverride + urlQuery];
	      if (pendingPromise) {
	        return new Promise(function (resolve, reject) {
	          pendingPromise.then(function (response) {
	            if (Array.isArray(response)) {
	              resolve(Object.assign({}, field, { options: response, optionsFetched: true }), response);
	            } else {
	              resolve(Object.assign({}, field, {
	                options: response.options,
	                optionGroups: response.optionGroups,
	                optionsFetched: true
	              }), response);
	            }
	          });
	        });
	      } else {
	        var innerResolver = void 0;
	        var innerPromise = new Promise(function (resolve, reject) {
	          innerResolver = resolve;
	        });
	        var cachePromise = new Promise(function (res, rej) {
	          getGroupItems(optionsSrcOverride, subOptionsSrcOverride).then(function (response) {
	            if (innerResolver) {
	              if (Array.isArray(response)) {
	                innerResolver(Object.assign({}, field, { options: response, optionsFetched: true }));
	              } else {
	                innerResolver(Object.assign({}, field, {
	                  options: response.options,
	                  optionGroups: response.optionGroups,
	                  optionsFetched: true
	                }));
	              }
	            }
	            res(response);
	          }).catch(function (err) {
	            console.error(err);
	            innerResolver(field);
	          });
	        });
	        if (subOptionsSrcOverride) {
	          GROUP_SUB_ITEMS_PROMISE_CACHE[optionsSrcOverride + subOptionsSrcOverride + urlQuery] = cachePromise;
	        } else {
	          GROUP_ITEMS_PROMISE_CACHE[optionsSrcOverride + urlQuery] = cachePromise;
	        }
	        return innerPromise;
	      }
	    case 'NameQualifiedOrg':
	      return new Promise(function (res, rej) {
	        var sourceId = field.value.SELECTED && field.value.SELECTED.SOURCE_ID || field.value.SOURCE_ID || 0;
	        if (sourceId) {
	          api.GET_BY_ID(field.searchType || 'ACTIVE_FILINGS', sourceId, function (SELECTED) {
	            res(Object.assign({}, field, { value: Object.assign({}, field.value, { SELECTED: SELECTED }) }));
	          }, function (err) {
	            console.warn('The value for field, ' + field.fieldId + ':' + field.name + ', could not be prefetched.');
	            res(field);
	          });
	        } else {
	          res(field);
	        }
	      });
	    case 'SearchControl':
	      return new Promise(function (res, rej) {
	        var sourceId = field.value ? field.value.SOURCE_ID : field.SOURCE_ID;
	        var SEARCH_TYPE = field.searchType || 'ACTIVE_FILINGS';
	        if (field.multiSelect) {
	          var promises = field.value.map(function (result) {
	            return new Promise(function (resolve, reject) {
	              api.GET_BY_ID(SEARCH_TYPE, result.SOURCE_ID, resolve, reject);
	            });
	          });
	          Promise.all(promises).then(function (values) {
	            res(Object.assign({}, field, { value: values }));
	          }).catch(function (err) {
	            console.error(err);
	            res(field);
	          });
	        } else {
	          if (sourceId) {
	            api.GET_BY_ID(SEARCH_TYPE, sourceId, function (SELECTED) {
	              res(Object.assign({}, field, { value: SELECTED }));
	            }, function (err) {
	              console.warn('The value for field, ' + field.fieldId + ':' + field.name + ', could not be prefetched.');
	              res(err.message === 'No Active Agent Found.' ? Object.assign({}, field, { value: '' }) : field);
	            });
	          } else {
	            res(field);
	          }
	        }
	      });
	    case 'registeredAgentSearch':
	      return new Promise(function (res, rej) {
	        var sourceId = field.value.SELECTED && field.value.SELECTED.SOURCE_ID;
	        if (sourceId) {
	          api.GET_BY_ID('ACTIVE_CRAS', sourceId, function (SELECTED) {
	            res(Object.assign({}, field, { value: Object.assign({}, field.value, { SELECTED: SELECTED }) }));
	          }, function (err) {
	            console.warn('The value for field, ' + field.fieldId + ':' + field.name + ', could not be prefetched.');
	            res(err.message === 'No Active Agent Found.' ? Object.assign({}, field, { value: '' }) : field);
	          });
	        } else {
	          res(field);
	        }
	      });
	    case 'repeater':
	      var allRowPromises = field.value.map(function (row, i) {
	        return new Promise(function (resolve, reject) {
	          var subPromises = [];
	          Object.keys(row).forEach(function (fieldId) {
	            var p = getPromiseByFieldType(Object.assign({}, fields[fieldId], { value: row[fieldId] }), fields);
	            if (p) {
	              subPromises.push(p);
	            }
	          });
	          Promise.all(subPromises).then(function (cells) {
	            var newRow = Object.assign({}, row);
	            cells.forEach(function (cell) {
	              newRow = Object.assign({}, newRow, _defineProperty({}, cell.fieldId, cell.value));
	            });
	            resolve(newRow);
	          });
	        });
	      });
	      return new Promise(function (resolve, reject) {
	        Promise.all(allRowPromises).then(function (rows) {
	          resolve(Object.assign({}, field, {
	            value: rows
	          }));
	        });
	      });
	    case 'DataTable':
	      return new Promise(function (resolve, reject) {
	        api.GET_DATA_TABLE_BY_ID(field.dataSrc, field.metadata, function (table) {
	          // console.log(table);
	          resolve(Object.assign({}, field, { value: { template: table.TEMPLATE, rows: table.ROWS } }));
	        }, function (err) {
	          resolve(field);
	        });
	      });
	    default:
	      return;
	  }
	};
	
	var preFetchMergeCodes = function preFetchMergeCodes(fields, metaData) {
	  return new Promise(function (resolve, reject) {
	    var paragraphFields = (0, _utilities.getFieldsByType)('paragraph', fields);
	    if (paragraphFields === null) {
	      resolve(fields);
	    }
	    var allFieldMergeCodes = paragraphFields.reduce(function (obj, field) {
	      return Object.assign({}, obj, field.codes);
	    }, {});
	    var codes = Object.keys(allFieldMergeCodes).map(function (k) {
	      return k.replace('{{', '').replace('}}', '');
	    });
	    if (codes.length > 0) {
	      getMergeCodesByArray(codes, metaData).then(function (codeValues) {
	        var mergedFields = Object.keys(fields).reduce(function (obj, fieldId) {
	          var field = fields[fieldId];
	          if (field.type === 'paragraph') {
	            var value = field.value;
	            codeValues.forEach(function (code) {
	              value = value.replace(new RegExp('{{' + code.CODE + '}}', 'g'), code.VALUE);
	            });
	            return Object.assign({}, obj, _defineProperty({}, fieldId, Object.assign({}, field, {
	              value: value
	            })));
	          } else {
	            return Object.assign({}, obj, _defineProperty({}, fieldId, field));
	          }
	        }, {});
	        resolve(mergedFields);
	      }).catch(function (err) {
	        console.error(err);
	        resolve(fields);
	      });
	    } else {
	      resolve(fields);
	    }
	  });
	};
	
	var getMergeCodesByArray = function getMergeCodesByArray(codes, metaData) {
	  return new Promise(function (resolve, reject) {
	    api.GET_MERGE_CODES_BY_ARRAY(codes, metaData, function (values) {
	      resolve(values);
	    });
	  });
	};
	
	var setFieldAttributes = exports.setFieldAttributes = function setFieldAttributes(_ref6) {
	  var fieldId = _ref6.fieldId,
	      payload = _ref6.payload;
	  return {
	    type: 'SET_FIELD_ATTRIBUTES',
	    fieldId: fieldId,
	    payload: payload
	  };
	};
	
	var setStepAttributes = exports.setStepAttributes = function setStepAttributes(_ref7) {
	  var stepId = _ref7.stepId,
	      payload = _ref7.payload;
	  return {
	    type: 'SET_STEP_ATTRIBUTES',
	    stepId: stepId,
	    payload: payload
	  };
	};
	
	var setWizardAttributes = exports.setWizardAttributes = function setWizardAttributes(payload) {
	  return {
	    type: 'SET_WIZARD_ATTRIBUTES',
	    payload: payload
	  };
	};
	
	var validateAndSetFieldAttributes = exports.validateAndSetFieldAttributes = function validateAndSetFieldAttributes(_ref8, callback) {
	  var fieldId = _ref8.fieldId,
	      event = _ref8.event,
	      extraPayload = _ref8.extraPayload,
	      value = _ref8.value,
	      setValue = _ref8.setValue,
	      options = _ref8.options;
	  return function (dispatch, getState) {
	    var wizardFields = getState().wizard.wizard.fields;
	    var rawField = wizardFields[fieldId];
	    var field = (0, _store.resolveFieldLogic)(rawField, options);
	    if (setValue) {
	      dispatch(setFieldAttributes({ fieldId: fieldId, payload: Object.assign({ value: value }, extraPayload) }));
	    }
	    var hasBusinessRules = field.businessRules.length !== 0;
	    var conditionsSatsified = field.conditions ? (0, _wizardUtilities.resolveFieldConditions)(field.conditions, wizardFields, field.conditionsOperator) : true;
	    // let fieldIsEnabled = !field.disabled;
	    var fieldIsActive = field.active;
	    if (fieldIsActive && hasBusinessRules && conditionsSatsified) {
	      var newPayload = Object.assign({
	        value: value
	      }, extraPayload);
	      (0, _validate.loopThroughRules)({ businessRules: field.businessRules, value: value, field: field, event: event, options: options }, function (validation) {
	        //console.log(validation)
	        var hasBusinessRules = validation.valids.length !== 0;
	        var validationSetValue = (validation.payload || {}).setValue;
	        // let fieldIsEnabled = !field.disabled;
	        if (hasBusinessRules) {
	          newPayload.isValid = validation.valids.every(function (valid) {
	            return valid === true;
	          });
	          newPayload.errorMessage = validation.errors;
	          if (setValue === false || validationSetValue === false) {
	            delete newPayload.value;
	            delete newPayload.setValue;
	          }
	          newPayload = Object.assign({}, newPayload, validation.payload);
	        } else {
	          newPayload.isValid = null;
	          newPayload.errorMessage = validation.errors;
	          if (setValue === false || validationSetValue === false) {
	            delete newPayload.value;
	            delete newPayload.setValue;
	          }
	          newPayload = Object.assign({}, newPayload, validation.payload);
	        }
	        dispatch(setFieldAttributes({ fieldId: fieldId, payload: newPayload }));
	        if (callback) {
	          callback(newPayload);
	        }
	      });
	    } else if (setValue) {
	      dispatch(setFieldAttributes({
	        fieldId: fieldId,
	        payload: Object.assign({ value: value }, extraPayload, { isValid: null, errorMessage: [] })
	      }));
	      if (callback) {
	        callback(Object.assign({ value: value }, extraPayload, { isValid: null, errorMessage: [] }));
	      }
	    } else {
	      dispatch(setFieldAttributes({
	        fieldId: fieldId,
	        payload: { isValid: null, errorMessage: [] }
	      }));
	      if (callback) {
	        callback({ isValid: true, errorMessage: [] });
	      }
	    }
	  };
	};
	
	var toggleValidating = exports.toggleValidating = function toggleValidating(validating) {
	  return {
	    type: 'TOGGLE_VALIDATING',
	    validating: validating
	  };
	};
	
	var setActiveStep = exports.setActiveStep = function setActiveStep(activeStep) {
	  return {
	    type: 'SET_ACTIVE_WIZARD_STEP',
	    activeStep: activeStep
	  };
	};
	
	var setTargetStep = exports.setTargetStep = function setTargetStep(targetStep) {
	  return {
	    type: 'SET_TARGET_STEP',
	    targetStep: targetStep
	  };
	};
	
	var validateAndSetActiveStep = exports.validateAndSetActiveStep = function validateAndSetActiveStep(activeStep) {
	  return function (dispatch, getState) {
	    dispatch(toggleValidating(true));
	    var currentStep = getState().wizard.activeStep;
	    validateStep(currentStep, function (stepIsValid) {
	      // if(stepIsValid || activeStep < currentStep){
	      if (getState().wizard.infoMessages.length > 0) {
	        dispatch(setTargetStep(activeStep));
	      } else {
	        dispatch(setActiveStep(activeStep));
	      }
	      // }
	    });
	  };
	};
	
	var buildFieldIdList = exports.buildFieldIdList = function buildFieldIdList(fieldIds) {
	  var fieldList = [].concat(_toConsumableArray(fieldIds));
	  var fields = _store2.default.getState().wizard.wizard.fields;
	  var loopThroughFieldIds = function loopThroughFieldIds(fieldIds) {
	    fieldIds.forEach(function (fieldId) {
	      var field = fields[fieldId];
	      var selectedIndex = field.selectedIndex;
	      if (field.hasOptionFields) {
	        selectedIndex = field.options.findIndex(function (option) {
	          return option.value.toString() === field.value.toString();
	        });
	        if ((selectedIndex || selectedIndex === 0) && selectedIndex !== -1) {
	          var subFieldIds = field.options[selectedIndex] ? field.options[selectedIndex].fields : [];
	          fieldList = [].concat(_toConsumableArray(fieldList), _toConsumableArray(buildFieldIdList(subFieldIds)));
	        }
	      }
	      if (field.hasCheckFields) {
	        var fieldGroup = field.value ? 'checkedFields' : 'uncheckedFields';
	        var _subFieldIds = field[fieldGroup];
	        fieldList = [].concat(_toConsumableArray(fieldList), _toConsumableArray(buildFieldIdList(_subFieldIds)));
	      }
	    });
	  };
	  loopThroughFieldIds(fieldIds);
	  fieldList = fieldList.filter(function (fieldId) {
	    var field = fields[fieldId];
	    var isDependentSubfield = field.parent.type === 'OPTION' || field.parent.type === 'CHECKBOX';
	    var conditionsResolved = field.conditions ? (0, _wizardUtilities.resolveFieldConditions)(field.conditions, fields, field.conditionsOperator) : true;
	
	    if (isDependentSubfield) {
	      var parentField = fields[field.parent.id];
	      var parentConditionsResolved = parentField.conditions ? (0, _wizardUtilities.resolveFieldConditions)(parentField.conditions, fields, parentField.conditionsOperator) : true;
	      return conditionsResolved && parentConditionsResolved;
	    } else {
	      return conditionsResolved;
	    }
	  });
	  return fieldList;
	};
	
	var buildFullWizardFieldIdList = exports.buildFullWizardFieldIdList = function buildFullWizardFieldIdList() {
	  var stepIds = _store2.default.getState().wizard.wizard.stepOrder;
	  var fields = [];
	
	  stepIds.forEach(function (stepId, id) {
	    var sectionIds = _store2.default.getState().wizard.wizard.steps[stepId].sectionOrder;
	    var sections = _store2.default.getState().wizard.wizard.sections;
	
	    sectionIds.forEach(function (sectionId) {
	      var section = sections[sectionId];
	      fields = [].concat(_toConsumableArray(fields), _toConsumableArray(section.fieldOrder));
	    });
	  });
	  fields = buildFieldIdList(fields);
	  return fields;
	};
	
	var fireGlobalBusinessRules = function fireGlobalBusinessRules() {
	  var businessRules = (_store2.default.getState().wizard.wizard.globalVariables || {}).businessRule || {
	    order: [],
	    variables: {}
	  };
	  return businessRules.order.reduce(function (obj, ruleId) {
	    var rule = businessRules.variables[ruleId];
	    var result = _store.resolveFieldEngine.resolveRootNode(rule.nodes);
	    if (!result.isValid) {
	      obj.isValid = false;
	      if (result.errorMessage) {
	        obj.errorMessages.push(result.errorMessage);
	      }
	    }
	    return obj;
	  }, { isValid: true, errorMessages: [] });
	};
	
	var validateAllSteps = exports.validateAllSteps = function validateAllSteps(callback) {
	  var stepIds = _store2.default.getState().wizard.wizard.stepOrder;
	  var stepPromises = [];
	  stepIds.forEach(function (stepId, i) {
	    stepPromises[i] = new Promise(function (resolve, reject) {
	      validateStep(i, function (stepIsValid) {
	        resolve(stepIsValid);
	      });
	    });
	  });
	  Promise.all(stepPromises).then(function (values) {
	    var globalBusinessRuleResults = fireGlobalBusinessRules();
	    var isValid = values.every(function (valid) {
	      return valid === true;
	    }) && globalBusinessRuleResults.isValid;
	    callback(isValid, globalBusinessRuleResults.errorMessages);
	  });
	};
	
	var validateStep = function validateStep(stepId, callback) {
	  var wizard = _store2.default.getState().wizard.wizard;
	  var step = wizard.steps[wizard.stepOrder[stepId]];
	  var sections = wizard.sections;
	  var stepFields = [];
	
	  step.sectionOrder.forEach(function (sectionId) {
	    var fieldIds = sections[sectionId].fieldOrder;
	    stepFields = [].concat(_toConsumableArray(stepFields), _toConsumableArray(buildFieldIdList(fieldIds)));
	  });
	  validateFieldArray(stepFields, function (isValid) {
	    _store2.default.dispatch(setStepAttributes({ stepId: wizard.stepOrder[stepId], payload: { isValid: isValid } }));
	    _store2.default.dispatch(toggleValidating(false));
	    callback(isValid);
	  });
	};
	
	var validateFieldArray = exports.validateFieldArray = function validateFieldArray(fieldArray, callback, options) {
	  var fieldPromises = [];
	  var fields = _store2.default.getState().wizard.wizard.fields;
	
	  var _loop = function _loop(i) {
	    fieldPromises[i] = new Promise(function (resolve, reject) {
	      _store2.default.dispatch(validateAndSetFieldAttributes({
	        fieldId: fields[fieldArray[i]].fieldId,
	        event: 'onAdvance',
	        setValue: false,
	        value: fields[fieldArray[i]].value,
	        options: options
	      }, function (valid) {
	        resolve(valid.isValid);
	      }));
	    });
	  };
	
	  for (var i = 0; i < fieldArray.length; i++) {
	    _loop(i);
	  }
	  Promise.all(fieldPromises).then(function (values) {
	    var isValid = values.every(function (valid) {
	      return valid === true || valid === null;
	    });
	    callback(isValid);
	  });
	};
	
	var getGroupItems = exports.getGroupItems = function getGroupItems(optionsSrc, subOptionsSrc) {
	  return new Promise(function (resolve, reject) {
	    var meta = _store2.default.getState().wizard.wizard.meta;
	    var payload = Object.assign({}, meta);
	    api.GET_GROUP_ITEMS(optionsSrc + (subOptionsSrc !== '' && subOptionsSrc !== undefined ? '/' + subOptionsSrc : ''), function (res) {
	      if (Array.isArray(res)) {
	        resolve(res.map(function (option) {
	          return Object.assign({}, option, { value: option.value.toString() });
	        }));
	      } else {
	        resolve({
	          options: res.options.map(function (option) {
	            return Object.assign({}, option, { value: option.value.toString() });
	          }),
	          optionGroups: res.optionGroups
	        });
	      }
	    }, { payload: payload });
	  });
	};
	
	var getGroupItemsAndSetFieldOptions = exports.getGroupItemsAndSetFieldOptions = function getGroupItemsAndSetFieldOptions(fieldId, providedField, callback) {
	  return function (dispatch, getState) {
	    var fields = getState().wizard.wizard.fields;
	    var field = providedField || fields[fieldId];
	
	    var optionsSrcOverride = field.optionsSrcOverride ? fields[field.optionsSrcOverride].value : field.optionsSrc;
	
	    var subOptionsSrcOverride = field.subOptionsSrcOverride ? fields[field.subOptionsSrcOverride].value : field.subOptionsSrc;
	
	    if (field.optionsSrcOverride) {
	      dispatch(setFieldAttributes({
	        fieldId: fieldId,
	        payload: { lastSeenOptionsSrcOverride: optionsSrcOverride }
	      }));
	    }
	
	    if (field.subOptionsSrcOverride) {
	      dispatch(setFieldAttributes({
	        fieldId: fieldId,
	        payload: { lastSeenSubOptionsSrcOverride: subOptionsSrcOverride }
	      }));
	    }
	
	    getGroupItems(optionsSrcOverride, subOptionsSrcOverride).then(function (res) {
	      if (Array.isArray(res)) {
	        if (callback) {
	          callback(res);
	        } else {
	          dispatch(setFieldAttributes({ fieldId: fieldId, payload: { options: res, optionsFetched: true } }));
	        }
	      } else {
	        if (callback) {
	          callback(res.options, res.optionGroups);
	        } else {
	          dispatch(setFieldAttributes({
	            fieldId: fieldId,
	            payload: { options: res.options, optionGroups: res.optionGroups, optionsFetched: true }
	          }));
	        }
	      }
	    });
	  };
	};
	
	var saveRecord = exports.saveRecord = function saveRecord(payload, category, mode, isCorrection, callback, errorCallback) {
	  return function (dispatch, getState) {
	    dispatch(toggleValidating(true));
	    api.SAVE_RECORD(payload, category, mode, isCorrection, function (response) {
	      //console.log(response)
	      dispatch(setWizardAttributes({ amendmentNum: response }));
	      dispatch(toggleValidating(false));
	      callback(response);
	    }, function (e) {
	      dispatch(toggleValidating(false));
	      errorCallback(e);
	    });
	  };
	};
	
	var saveRecordWithSignatures = exports.saveRecordWithSignatures = function saveRecordWithSignatures(payload, category, mode, isCorrection, callback, errorCallback) {
	  return function (dispatch, getState) {
	    dispatch(toggleValidating(true));
	    api.SAVE_RECORD_WITH_SIGNATURES(payload, category, isCorrection, function (response) {
	      dispatch(setWizardAttributes({ amendmentNum: response }));
	      dispatch(toggleValidating(false));
	      callback(response);
	    }, function (e) {
	      dispatch(toggleValidating(false));
	      errorCallback(e);
	    });
	  };
	};
	
	var toggleHelpModal = exports.toggleHelpModal = function toggleHelpModal(helpShown) {
	  return {
	    type: 'TOGGLE_HELP_MODAL',
	    helpShown: helpShown
	  };
	};
	
	var setDraftId = exports.setDraftId = function setDraftId(draftId) {
	  return {
	    type: 'SET_DRAFT_ID',
	    draftId: draftId
	  };
	};
	
	var toggleSavingDraft = exports.toggleSavingDraft = function toggleSavingDraft(savingDraft) {
	  return {
	    type: 'TOGGLE_SAVING_DRAFT',
	    savingDraft: savingDraft
	  };
	};
	
	var saveDraft = exports.saveDraft = function saveDraft(draft, callback) {
	  return function (dispatch) {
	    dispatch(toggleSavingDraft(true));
	    api.SAVE_DRAFT(draft, function (draftId) {
	      dispatch(setDraftId(draftId));
	      dispatch(toggleSavingDraft(false));
	      if (callback) callback();
	    });
	  };
	};
	
	var resetWizardState = exports.resetWizardState = function resetWizardState() {
	  return {
	    type: 'RESET_WIZARD_STATE'
	  };
	};
	
	var setUploading = exports.setUploading = function setUploading(uploading) {
	  return {
	    type: 'SET_UPLOADING',
	    uploading: uploading
	  };
	};
	
	var getWebUserRecordByType = exports.getWebUserRecordByType = function getWebUserRecordByType(searchType, callback) {
	  return function (dispatch) {
	    api.GET_WEB_USER_RECORD({ searchType: searchType, metadata: _store2.default.getState().wizard.wizard.meta, correctionMode: _store2.default.getState().wizard.correctionMode }, function (data) {
	      if (callback) {
	        callback(data);
	      }
	    });
	  };
	};
	
	var clearInfoMessages = exports.clearInfoMessages = function clearInfoMessages() {
	  return {
	    type: 'CLEAR_INFO_MESSAGES'
	  };
	};
	
	var addInfoMessage = exports.addInfoMessage = function addInfoMessage(message) {
	  return {
	    type: 'ADD_INFO_MESSAGE',
	    message: message
	  };
	};
	
	var calculateInternalReview = exports.calculateInternalReview = function calculateInternalReview() {
	  return function (dispatch, getState) {
	    var state = getState().wizard;
	    var wizard = state.wizard;
	    if (wizard.internalReviewRequired === true) {
	      return true;
	    } else {
	      // console.log(getFieldsWithChangedValues())
	      return (0, _utilities.getFieldsWithChangedValues)().filter(function (field) {
	        return field.internalReviewRequiredIfChanged;
	      }).length > 0 || wizard.internalReviewRequiredSet.size > 0;
	    }
	  };
	};
	
	var addRequirePrintMailMethod = exports.addRequirePrintMailMethod = function addRequirePrintMailMethod(fieldId) {
	  return {
	    type: 'ADD_REQUIRE_PRINT_MAIL_METHOD',
	    fieldId: fieldId
	  };
	};
	
	var removeRequirePrintMailMethod = exports.removeRequirePrintMailMethod = function removeRequirePrintMailMethod(fieldId) {
	  return {
	    type: 'REMOVE_REQUIRE_PRINT_MAIL_METHOD',
	    fieldId: fieldId
	  };
	};
	
	var spreadWizardAttributes = exports.spreadWizardAttributes = function spreadWizardAttributes(payload) {
	  return {
	    type: 'SPREAD_WIZARD_ATTRIBUTES',
	    payload: payload
	  };
	};
	
	var reconstructWizardWithValues = exports.reconstructWizardWithValues = function reconstructWizardWithValues(fieldValues) {
	  return function (dispatch, getState) {
	    var wizard = getState().wizard.wizard;
	    var parsedWizard = CreateInstancesFromJson({
	      stepOrder: wizard.stepOrder,
	      steps: wizard.steps,
	      sections: wizard.sections,
	      fields: wizard.fields
	    }, fieldValues);
	    prefetchRequiredData(parsedWizard.fields).then(preFetchMergeCodes).then(function (fields) {
	      dispatch(spreadWizardAttributes(Object.assign({}, parsedWizard, { fields: fields })));
	    });
	  };
	};
	
	var setWizardSubmitted = exports.setWizardSubmitted = function setWizardSubmitted(submitted) {
	  return {
	    type: 'SET_SUBMITTED',
	    submitted: submitted
	  };
	};
	
	var setWizardSubmitting = exports.setWizardSubmitting = function setWizardSubmitting(submitting) {
	  return {
	    type: 'SET_SUBMITTING',
	    submitting: submitting
	  };
	};
	
	var buildFieldNameMap = exports.buildFieldNameMap = function buildFieldNameMap(fieldIds, fields) {
	  return fieldIds.reduce(function (obj, fieldId) {
	    var field = fields[fieldId];
	    var fieldName = field.name;
	    obj[fieldName] = (obj[fieldName] || 0) + 1;
	    return obj;
	  }, {});
	};
	
	var createMetaCollection = exports.createMetaCollection = function createMetaCollection(FIELD_META, wizard, filteredFieldIds) {
	  var fieldNameMap = buildFieldNameMap(filteredFieldIds, wizard.wizard.fields);
	
	  return filteredFieldIds.reduce(function (meta, key) {
	    var field = wizard.wizard.fields[key];
	    var fieldNameIsNotUnique = fieldNameMap[field.name] > 1;
	    var needsUniqueFieldName = field.disabled && !field.hideFieldOnForm && fieldNameIsNotUnique;
	    var metaKey = needsUniqueFieldName ? field.fieldId : field.name;
	    return Object.assign({}, meta, _defineProperty({}, metaKey, Object.assign({}, FIELD_META[metaKey] || {}, {
	      hasChanged: (wizard.diff.original || {}).hasOwnProperty(field.name) ? WizardClasses[field.fieldClass].compareValues(wizard.diff.original[field.name], field.value) : null,
	      fieldType: field.type,
	      fieldNameIsUnique: !fieldNameIsNotUnique
	    })));
	  }, {});
	};
	
	var getParentKey = function getParentKey(field, wizard) {
	  var parent = wizard.wizard.fields[field.parent.id];
	  var needsUniqueFieldName = parent.disabled && !parent.hideFieldOnForm;
	  return needsUniqueFieldName ? parent.fieldId : parent.name;
	};
	
	var createEncryptionCollection = exports.createEncryptionCollection = function createEncryptionCollection(wizard) {
	  return Object.keys(wizard.wizard.fields).reduce(function (arr, key) {
	    var field = wizard.wizard.fields[key];
	    if (field.encrypt) {
	      var needsUniqueFieldName = field.disabled && !field.hideFieldOnForm;
	      var uniqueKey = needsUniqueFieldName ? field.fieldId : field.name;
	      var parentKey = field.parent.type.toUpperCase() === 'REPEATER' ? getParentKey(field, wizard) : null;
	      return [].concat(_toConsumableArray(arr), [{ key: uniqueKey, parentType: field.parent.type, parentKey: parentKey }]);
	    } else {
	      return arr;
	    }
	  }, []);
	};
	
	var setWizardLoadFailed = exports.setWizardLoadFailed = function setWizardLoadFailed(wizardLoadFailed) {
	  return {
	    type: 'SET_WIZARD_LOAD_FAILED',
	    wizardLoadFailed: wizardLoadFailed
	  };
	};
	
	var setWizardSignatureValues = exports.setWizardSignatureValues = function setWizardSignatureValues(signatureValues) {
	  return {
	    type: 'SET_WIZARD_SIGNATURE_VALUES',
	    signatureValues: signatureValues
	  };
	};
	
	var resetWizardSignatureValues = exports.resetWizardSignatureValues = function resetWizardSignatureValues(signatureValues) {
	  return {
	    type: 'RESET_WIZARD_SIGNATURE_VALUES',
	    signatureValues: signatureValues
	  };
	};
	
	var setWizardSignatureErrors = exports.setWizardSignatureErrors = function setWizardSignatureErrors(signatureErrors) {
	  return {
	    type: 'SET_WIZARD_SIGNATURE_ERRORS',
	    signatureErrors: signatureErrors
	  };
	};
	
	var setGenericSuccess = exports.setGenericSuccess = function setGenericSuccess(message) {
	  return {
	    type: 'SET_GENERIC_SUCCESS',
	    message: message
	  };
	};
	
	var updateWizardMeta = exports.updateWizardMeta = function updateWizardMeta(newMeta) {
	  return {
	    type: 'UPDATE_WIZARD_META',
	    newMeta: newMeta
	  };
	};
	
	var createFieldOverridesCollection = exports.createFieldOverridesCollection = function createFieldOverridesCollection(wizard) {
	  return Object.values(wizard.wizard.fields).reduce(function (obj, field) {
	    obj[field.fieldId] = Object.entries((0, _store.resolveFieldLogic)(field)).reduce(function (obj, _ref9) {
	      var _ref10 = _slicedToArray(_ref9, 2),
	          key = _ref10[0],
	          value = _ref10[1];
	
	      if (!(0, _deepEqual2.default)(field[key], value)) {
	        obj[key] = value;
	      }
	      return obj;
	    }, {});
	    return obj;
	  }, {});
	};
	
	var resolveWizardAttributesLogic = exports.resolveWizardAttributesLogic = function resolveWizardAttributesLogic() {
	  return function (dispatch, getState) {
	    var wizard = _store2.default.getState().wizard.wizard;
	    var wizardOverrides = Object.keys(wizard.wizardAttributesLogic.nodes).length > 0 ? _store.resolveFieldEngine.resolveRootNode(wizard.wizardAttributesLogic.nodes, {
	      onlyResolveConnected: true
	    }) : {};
	    return Object.assign({}, wizard, wizardOverrides);
	  };
	};

/***/ },
/* 37 */
/***/ function(module, exports) {

	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : {
	    "default": obj
	  };
	}
	
	module.exports = _interopRequireDefault;
	module.exports["default"] = module.exports, module.exports.__esModule = true;

/***/ },
/* 38 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _createIconComponent = _interopRequireDefault(__webpack_require__(5));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	var IconCaretDown = (0, _createIconComponent["default"])({
	  content: _react["default"].createElement("g", null, _react["default"].createElement("path", {
	    d: "M57.49 21.6a3.85 3.85 0 0 0-5.44 0l-17 17-17-17a3.85 3.85 0 0 0-5.45 0 3.85 3.85 0 0 0 0 5.45L35 49.54l22.5-22.48a3.85 3.85 0 0 0-.01-5.46z"
	  })),
	  height: undefined,
	  width: undefined
	});
	IconCaretDown.displayName = 'IconCaretDown';
	var _default = IconCaretDown;
	exports["default"] = _default;

/***/ },
/* 39 */
/***/ function(module, exports) {

	module.exports = function (it) {
	  if (typeof it != 'function') throw TypeError(it + ' is not a function!');
	  return it;
	};


/***/ },
/* 40 */
/***/ function(module, exports, __webpack_require__) {

	var dP = __webpack_require__(32);
	var createDesc = __webpack_require__(92);
	module.exports = __webpack_require__(28) ? function (object, key, value) {
	  return dP.f(object, key, createDesc(1, value));
	} : function (object, key, value) {
	  object[key] = value;
	  return object;
	};


/***/ },
/* 41 */
/***/ function(module, exports, __webpack_require__) {

	var global = __webpack_require__(17);
	var hide = __webpack_require__(40);
	var has = __webpack_require__(46);
	var SRC = __webpack_require__(96)('src');
	var $toString = __webpack_require__(632);
	var TO_STRING = 'toString';
	var TPL = ('' + $toString).split(TO_STRING);
	
	__webpack_require__(54).inspectSource = function (it) {
	  return $toString.call(it);
	};
	
	(module.exports = function (O, key, val, safe) {
	  var isFunction = typeof val == 'function';
	  if (isFunction) has(val, 'name') || hide(val, 'name', key);
	  if (O[key] === val) return;
	  if (isFunction) has(val, SRC) || hide(val, SRC, O[key] ? '' + O[key] : TPL.join(String(key)));
	  if (O === global) {
	    O[key] = val;
	  } else if (!safe) {
	    delete O[key];
	    hide(O, key, val);
	  } else if (O[key]) {
	    O[key] = val;
	  } else {
	    hide(O, key, val);
	  }
	// add fake Function#toString for correct work wrapped methods / constructors with methods like LoDash isNative
	})(Function.prototype, TO_STRING, function toString() {
	  return typeof this == 'function' && this[SRC] || $toString.call(this);
	});


/***/ },
/* 42 */
/***/ function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(4);
	var fails = __webpack_require__(21);
	var defined = __webpack_require__(62);
	var quot = /"/g;
	// B.2.3.2.1 CreateHTML(string, tag, attribute, value)
	var createHTML = function (string, tag, attribute, value) {
	  var S = String(defined(string));
	  var p1 = '<' + tag;
	  if (attribute !== '') p1 += ' ' + attribute + '="' + String(value).replace(quot, '&quot;') + '"';
	  return p1 + '>' + S + '</' + tag + '>';
	};
	module.exports = function (NAME, exec) {
	  var O = {};
	  O[NAME] = exec(createHTML);
	  $export($export.P + $export.F * fails(function () {
	    var test = ''[NAME]('"');
	    return test !== test.toLowerCase() || test.split('"').length > 3;
	  }), 'String', O);
	};


/***/ },
/* 43 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isValid;
	
	var _index = _interopRequireDefault(__webpack_require__(3));
	
	var _index2 = _interopRequireDefault(__webpack_require__(2));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name isValid
	 * @category Common Helpers
	 * @summary Is the given date valid?
	 *
	 * @description
	 * Returns false if argument is Invalid Date and true otherwise.
	 * Argument is converted to Date using `toDate`. See [toDate]{@link https://date-fns.org/docs/toDate}
	 * Invalid Date is a Date, whose time value is NaN.
	 *
	 * Time value of Date: http://es5.github.io/#x15.9.1.1
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * - Now `isValid` doesn't throw an exception
	 *   if the first argument is not an instance of Date.
	 *   Instead, argument is converted beforehand using `toDate`.
	 *
	 *   Examples:
	 *
	 *   | `isValid` argument        | Before v2.0.0 | v2.0.0 onward |
	 *   |---------------------------|---------------|---------------|
	 *   | `new Date()`              | `true`        | `true`        |
	 *   | `new Date('2016-01-01')`  | `true`        | `true`        |
	 *   | `new Date('')`            | `false`       | `false`       |
	 *   | `new Date(1488370835081)` | `true`        | `true`        |
	 *   | `new Date(NaN)`           | `false`       | `false`       |
	 *   | `'2016-01-01'`            | `TypeError`   | `false`       |
	 *   | `''`                      | `TypeError`   | `false`       |
	 *   | `1488370835081`           | `TypeError`   | `true`        |
	 *   | `NaN`                     | `TypeError`   | `false`       |
	 *
	 *   We introduce this change to make *date-fns* consistent with ECMAScript behavior
	 *   that try to coerce arguments to the expected type
	 *   (which is also the case with other *date-fns* functions).
	 *
	 * @param {*} date - the date to check
	 * @returns {Boolean} the date is valid
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // For the valid date:
	 * var result = isValid(new Date(2014, 1, 31))
	 * //=> true
	 *
	 * @example
	 * // For the value, convertable into a date:
	 * var result = isValid(1393804800000)
	 * //=> true
	 *
	 * @example
	 * // For the invalid date:
	 * var result = isValid(new Date(''))
	 * //=> false
	 */
	function isValid(dirtyDate) {
	  (0, _index2.default)(1, arguments);
	  var date = (0, _index.default)(dirtyDate);
	  return !isNaN(date);
	}
	
	module.exports = exports.default;

/***/ },
/* 44 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.setOptionsCacheById = exports.setOptionsCache = exports.setGlobalVariables = exports.auditWizard = exports.setAuditError = exports.setAuditLogs = exports.setHoverId = exports.deleteStep = exports.deleteSection = exports.reorderSection = exports.recalculateStepOrder = exports.reorderStep = exports.reorderField = exports.addNestedFieldOption = exports.addRepeaterSubfield = exports.addCheckSubfield = exports.addOptionSubfield = exports.toggleValidationEditor = exports.resetDesignerState = exports.setDirty = exports.saveWizard = exports.setRevisionHistory = exports.loadWizardRevisionHistory = exports.setCurrentRevisionId = exports.setFormDefinitionId = exports.togglePreview = exports.addFieldAbove = exports.addFieldUnder = exports.addField = exports.addSection = exports.addStep = exports.setActiveStep = exports.subSelect = exports.select = exports.selectRepeaterSubField = exports.selectCheckSubField = exports.selectOptionSubField = exports.selectField = exports.setDesignerLoading = exports.loadWizardById = exports.setWizardCategory = exports.populateDesigner = exports.populateDesignerSteps = undefined;
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _requests = __webpack_require__(6);
	
	var api = _interopRequireWildcard(_requests);
	
	var _WizardClasses = __webpack_require__(35);
	
	var _WizardActions = __webpack_require__(36);
	
	var _Auditor = __webpack_require__(450);
	
	var _debounce = __webpack_require__(495);
	
	var _debounce2 = _interopRequireDefault(_debounce);
	
	var _x2js = __webpack_require__(155);
	
	var _x2js2 = _interopRequireDefault(_x2js);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	var xml2Json = new _x2js2.default();
	
	var populateDesignerSteps = exports.populateDesignerSteps = function populateDesignerSteps(data, parsedWizard) {
	  if (!parsedWizard) {
	    parsedWizard = (0, _WizardClasses.CreateInstancesFromJson)(JSON.parse(data));
	  }
	  return {
	    type: 'POPULATE_DESIGNER_STEPS',
	    stepOrder: parsedWizard.stepOrder,
	    steps: parsedWizard.steps,
	    sections: parsedWizard.sections,
	    fields: parsedWizard.fields
	  };
	};
	
	var populateDesigner = exports.populateDesigner = function populateDesigner(data, parsedWizard) {
	  if (!parsedWizard) {
	    parsedWizard = (0, _WizardClasses.CreateInstancesFromJson)(JSON.parse(data.STEPS_JSON));
	  }
	
	  return {
	    type: 'POPULATE_DESIGNER',
	    stepOrder: parsedWizard.stepOrder,
	    steps: parsedWizard.steps,
	    sections: parsedWizard.sections,
	    fields: parsedWizard.fields,
	    title: data.TITLE,
	    formDefinitionId: data.FORM_DEFINITION_ID,
	    category: data.CATEGORY,
	    description: data.DESCR,
	    lastModifiedDate: data.LAST_MODIFIED_DATE,
	    lastModifiedName: data.LAST_MODIFIED_BY_NAME,
	    sourceId: data.SOURCE_ID,
	    abbreviation: data.ABBREVIATION ? data.ABBREVIATION : '',
	    meta: xml2Json.xml2js(data.METADATA) ? xml2Json.xml2js(data.METADATA).METADATA : {},
	    mode: data.MODE,
	    docTitleSrc: data.DOC_TITLE_SRC ? data.DOC_TITLE_SRC : '',
	    docId: data.DOC_ID ? data.DOC_ID : '',
	    formTitle: data.FORM_TITLE ? data.FORM_TITLE : '',
	    internalReviewRequired: data.INTERNAL_REVIEW_REQUIRED_YN,
	    onlyRenderChangedFieldsOnForm: data.ONLY_SHOW_CHANGED_FIELDS_ON_FORM_YN,
	    noLoginRequired: data.PUBLIC_YN,
	    notAvailableOnline: data.NOT_AVAILABLE_ONLINE_YN,
	    feeDescription: data.FEE_DESCR,
	    webUserAccessLevelTypeId: data.PX_WUAL_TYPE_ID,
	    webUserAccessLevelAfterActivation: data.AX_WUAL_TYPE_ID,
	    draftsDisabled: data.DRAFTS_DISABLED,
	    globalVariables: data.GLOBAL_VARIABLES ? JSON.parse(data.GLOBAL_VARIABLES) : undefined,
	    wizardAttributesLogic: data.WIZARD_ATTRIBUTES_LOGIC ? JSON.parse(data.WIZARD_ATTRIBUTES_LOGIC) : undefined
	  };
	};
	
	var setWizardCategory = exports.setWizardCategory = function setWizardCategory(category) {
	  return {
	    type: '@@ds/SET_WIZARD_CATEGORY',
	    category: category
	  };
	};
	
	var loadWizardById = exports.loadWizardById = function loadWizardById(formDefinitionId, callback) {
	  return function (dispatch) {
	    dispatch(setDesignerLoading(true));
	    api.LOAD_WIZARD_BY_ID(formDefinitionId, function (data) {
	      var parsedWizard = (0, _WizardClasses.CreateInstancesFromJson)(JSON.parse(data.STEPS_JSON));
	      dispatch(populateDesigner(data, parsedWizard));
	      dispatch(populateServerOptionsCache(parsedWizard.fields));
	      dispatch(auditWizard());
	      if (callback) {
	        callback();
	      }
	    });
	  };
	};
	
	var populateServerOptionsCache = function populateServerOptionsCache(fields) {
	  return function (dispatch) {
	    var fieldPromises = Object.values(fields).filter(function (_ref) {
	      var type = _ref.type;
	      return ['serverSelect', 'serverRadio'].includes(type);
	    }).map(function (_ref2) {
	      var optionsSrc = _ref2.optionsSrc,
	          subOptionsSrc = _ref2.subOptionsSrc;
	      return new Promise(function (resolve, reject) {
	        (0, _WizardActions.getGroupItems)(optionsSrc, subOptionsSrc).then(function (res) {
	          var options = void 0;
	          if ((typeof res === 'undefined' ? 'undefined' : _typeof(res)) === 'object') {
	            options = res.options;
	          } else {
	            options = res;
	          }
	          resolve({
	            options: options,
	            optionsSrc: optionsSrc,
	            subOptionsSrc: subOptionsSrc
	          });
	        });
	      });
	    });
	
	    Promise.all(fieldPromises).then(function (values) {
	      var serverOptionsCache = values.reduce(function (obj, _ref3) {
	        var options = _ref3.options,
	            optionsSrc = _ref3.optionsSrc,
	            subOptionsSrc = _ref3.subOptionsSrc;
	
	        obj[optionsSrc + '/' + subOptionsSrc] = options;
	        return obj;
	      }, {});
	      dispatch(setOptionsCache(serverOptionsCache));
	    });
	  };
	};
	
	var setDesignerLoading = exports.setDesignerLoading = function setDesignerLoading(loading) {
	  return {
	    type: '@@ds/SET_LOADING',
	    loading: loading
	  };
	};
	
	var selectField = exports.selectField = function selectField(stepIndex, sectionIndex, fieldIndex, fieldType) {
	  return {
	    type: 'SELECT_FIELD',
	    stepIndex: stepIndex,
	    sectionIndex: sectionIndex,
	    fieldIndex: fieldIndex,
	    fieldType: fieldType
	  };
	};
	
	var selectOptionSubField = exports.selectOptionSubField = function selectOptionSubField(stepIndex, sectionIndex, fieldIndex, fieldType, optionIndex, subFieldIndex) {
	  return {
	    type: 'SELECT_OPTION_SUB_FIELD',
	    stepIndex: stepIndex,
	    sectionIndex: sectionIndex,
	    fieldIndex: fieldIndex,
	    fieldType: fieldType,
	    optionIndex: optionIndex,
	    subFieldIndex: subFieldIndex
	  };
	};
	
	var selectCheckSubField = exports.selectCheckSubField = function selectCheckSubField(stepIndex, sectionIndex, fieldIndex, fieldType, checkType, subFieldIndex) {
	  return {
	    type: 'SELECT_CHECK_SUB_FIELD',
	    stepIndex: stepIndex,
	    sectionIndex: sectionIndex,
	    fieldIndex: fieldIndex,
	    fieldType: fieldType,
	    checkType: checkType,
	    subFieldIndex: subFieldIndex
	  };
	};
	
	var selectRepeaterSubField = exports.selectRepeaterSubField = function selectRepeaterSubField(stepIndex, sectionIndex, fieldIndex, fieldType, subFieldIndex) {
	  return {
	    type: 'SELECT_REPEATER_SUB_FIELD',
	    stepIndex: stepIndex,
	    sectionIndex: sectionIndex,
	    fieldIndex: fieldIndex,
	    fieldType: fieldType,
	    subFieldIndex: subFieldIndex
	  };
	};
	
	var select = exports.select = function select(_ref4) {
	  var type = _ref4.type,
	      id = _ref4.id;
	  return {
	    type: 'SELECT',
	    selectType: type,
	    id: id
	  };
	};
	
	var subSelect = exports.subSelect = function subSelect(_ref5) {
	  var type = _ref5.type,
	      id = _ref5.id;
	  return {
	    type: 'SUB_SELECT',
	    selectType: type,
	    id: id
	  };
	};
	
	var setActiveStep = exports.setActiveStep = function setActiveStep(stepIndex) {
	  return {
	    type: 'SET_ACTIVE_STEP',
	    stepIndex: stepIndex
	  };
	};
	
	var addStep = exports.addStep = function addStep() {
	  return {
	    type: 'ADD_STEP'
	  };
	};
	
	var addSection = exports.addSection = function addSection() {
	  return {
	    type: 'ADD_SECTION'
	  };
	};
	
	var addField = exports.addField = function addField(sectionId, fieldClass, properties) {
	  return {
	    type: 'ADD_FIELD',
	    sectionId: sectionId,
	    fieldClass: fieldClass,
	    properties: properties
	  };
	};
	
	var addFieldUnder = exports.addFieldUnder = function addFieldUnder(fieldId, sectionId, fieldClass, properties) {
	  return {
	    type: 'ADD_FIELD_UNDER',
	    fieldId: fieldId,
	    sectionId: sectionId,
	    fieldClass: fieldClass,
	    properties: properties
	  };
	};
	
	var addFieldAbove = exports.addFieldAbove = function addFieldAbove(fieldId, sectionId, fieldClass, properties) {
	  return {
	    type: 'ADD_FIELD_ABOVE',
	    fieldId: fieldId,
	    sectionId: sectionId,
	    fieldClass: fieldClass,
	    properties: properties
	  };
	};
	
	var togglePreview = exports.togglePreview = function togglePreview(previewing) {
	  return {
	    type: 'TOGGLE_PREVIEW',
	    previewing: previewing
	  };
	};
	
	var setFormDefinitionId = exports.setFormDefinitionId = function setFormDefinitionId(formDefinitionId) {
	  return {
	    type: 'SET_FORM_DEFINITION_ID',
	    formDefinitionId: formDefinitionId
	  };
	};
	
	var setCurrentRevisionId = exports.setCurrentRevisionId = function setCurrentRevisionId(currentRevisionId) {
	  return {
	    type: 'SET_CURRENT_REVISION_ID',
	    currentRevisionId: currentRevisionId
	  };
	};
	
	var loadWizardRevisionHistory = exports.loadWizardRevisionHistory = function loadWizardRevisionHistory(formDefinitionId, callback, errorCallback) {
	  return function (dispatch) {
	    var revisionList = [];
	    api.LOAD_WIZARD_HISTORY_BY_ID(formDefinitionId, function (data) {
	      var jsonString = JSON.stringify(data);
	      revisionList = JSON.parse(jsonString);
	      var currentRevisionID = revisionList.sort(function (a, b) {
	        return b.REVISION_ID - a.REVISION_ID;
	      })[0].REVISION_ID;
	      dispatch(setCurrentRevisionId(currentRevisionID));
	      dispatch(setRevisionHistory(revisionList));
	      if (callback) {
	        callback(revisionList);
	      }
	    }, errorCallback);
	  };
	};
	
	var setRevisionHistory = exports.setRevisionHistory = function setRevisionHistory(revisionList) {
	  return {
	    type: 'SET_WIZARD_REVISION_HISTORY',
	    revisionList: revisionList
	  };
	};
	
	var saveWizard = exports.saveWizard = function saveWizard(wizard, callback, errorCallback) {
	  return function (dispatch) {
	    api.SAVE_WIZARD(wizard, function (formDefinitionId) {
	      dispatch(setFormDefinitionId(formDefinitionId));
	      dispatch(setDirty(false));
	      callback(formDefinitionId);
	    }, errorCallback);
	  };
	};
	
	var setDirty = exports.setDirty = function setDirty(dirty) {
	  return {
	    type: 'SET_DIRTY',
	    dirty: dirty
	  };
	};
	
	var resetDesignerState = exports.resetDesignerState = function resetDesignerState() {
	  return {
	    type: 'RESET_DESIGNER_STATE'
	  };
	};
	
	var toggleValidationEditor = exports.toggleValidationEditor = function toggleValidationEditor(value) {
	  return {
	    type: 'TOGGLE_VALIDATION_EDITOR',
	    value: value
	  };
	};
	
	var addOptionSubfield = exports.addOptionSubfield = function addOptionSubfield(_ref6) {
	  var fieldId = _ref6.fieldId,
	      optionIndex = _ref6.optionIndex,
	      fieldClass = _ref6.fieldClass,
	      properties = _ref6.properties,
	      direction = _ref6.direction;
	  return {
	    type: 'ADD_OPTION_SUBFIELD',
	    fieldId: fieldId,
	    optionIndex: optionIndex,
	    fieldClass: fieldClass,
	    properties: properties,
	    direction: direction
	  };
	};
	
	var addCheckSubfield = exports.addCheckSubfield = function addCheckSubfield(_ref7) {
	  var fieldId = _ref7.fieldId,
	      checkType = _ref7.checkType,
	      fieldClass = _ref7.fieldClass,
	      properties = _ref7.properties,
	      direction = _ref7.direction;
	  return {
	    type: 'ADD_CHECK_SUBFIELD',
	    fieldId: fieldId,
	    checkType: checkType,
	    fieldClass: fieldClass,
	    properties: properties,
	    direction: direction
	  };
	};
	
	var addRepeaterSubfield = exports.addRepeaterSubfield = function addRepeaterSubfield(_ref8) {
	  var fieldId = _ref8.fieldId,
	      fieldClass = _ref8.fieldClass,
	      properties = _ref8.properties,
	      direction = _ref8.direction;
	  return {
	    type: 'ADD_REPEATER_SUBFIELD',
	    fieldId: fieldId,
	    fieldClass: fieldClass,
	    properties: properties,
	    direction: direction
	  };
	};
	
	var addNestedFieldOption = exports.addNestedFieldOption = function addNestedFieldOption(fieldId) {
	  return {
	    type: 'ADD_NESTED_FIELD_OPTION',
	    fieldId: fieldId
	  };
	};
	
	var reorderField = exports.reorderField = function reorderField(_ref9) {
	  var direction = _ref9.direction,
	      fieldId = _ref9.fieldId;
	  return {
	    type: 'REORDER_FIELD',
	    direction: direction,
	    fieldId: fieldId
	  };
	};
	
	var reorderStep = exports.reorderStep = function reorderStep(_ref10) {
	  var direction = _ref10.direction,
	      stepId = _ref10.stepId,
	      stepIndex = _ref10.stepIndex;
	  return {
	    type: 'REORDER_STEP',
	    direction: direction,
	    stepId: stepId,
	    stepIndex: stepIndex
	  };
	};
	
	var recalculateStepOrder = exports.recalculateStepOrder = function recalculateStepOrder(_ref11) {
	  var reorderedStep = _ref11.reorderedStep,
	      displacedStep = _ref11.displacedStep,
	      placeBefore = _ref11.placeBefore;
	  return {
	    type: 'RECALCULATE_STEP_ORDER',
	    reorderedStep: reorderedStep,
	    displacedStep: displacedStep,
	    placeBefore: placeBefore
	  };
	};
	
	var reorderSection = exports.reorderSection = function reorderSection(_ref12) {
	  var direction = _ref12.direction,
	      sectionId = _ref12.sectionId,
	      sectionIndex = _ref12.sectionIndex;
	  return {
	    type: 'REORDER_SECTION',
	    direction: direction,
	    sectionId: sectionId,
	    sectionIndex: sectionIndex
	  };
	};
	
	var deleteSection = exports.deleteSection = function deleteSection(sectionId) {
	  return {
	    type: 'DELETE_SECTION',
	    sectionId: sectionId
	  };
	};
	
	var deleteStep = exports.deleteStep = function deleteStep(sectionId) {
	  return {
	    type: 'DELETE_SECTION',
	    sectionId: sectionId
	  };
	};
	
	var setHoverId = exports.setHoverId = function setHoverId(hoverId) {
	  return {
	    type: 'SET_HOVER_ID',
	    hoverId: hoverId
	  };
	};
	
	var setAuditLogs = exports.setAuditLogs = function setAuditLogs(auditLogs) {
	  return {
	    type: '@@ds/SET_AUDIT_LOGS',
	    auditLogs: auditLogs
	  };
	};
	
	var setAuditError = exports.setAuditError = function setAuditError(auditError) {
	  return {
	    type: '@@ds/SET_AUDIT_ERROR',
	    auditError: auditError
	  };
	};
	
	var audit = function audit(dispatch, getState) {
	  var audit = new _Auditor.Auditor(getState().designer);
	  audit.startAudit();
	  dispatch(setAuditLogs(audit.logs));
	};
	
	var debouncedAudit = (0, _debounce2.default)(audit, 400, {
	  leading: true
	});
	
	var auditWizard = exports.auditWizard = function auditWizard() {
	  return function (dispatch, getState) {
	    try {
	      debouncedAudit(dispatch, getState);
	    } catch (e) {
	      console.error(e);
	      dispatch(setAuditLogs([]));
	      dispatch(setAuditError(true));
	    }
	  };
	};
	
	var setGlobalVariables = exports.setGlobalVariables = function setGlobalVariables(globalVariables) {
	  return {
	    type: '@@ds/SET_GLOBAL_VARIABLES',
	    globalVariables: globalVariables
	  };
	};
	
	var setOptionsCache = exports.setOptionsCache = function setOptionsCache(serverOptionsCache) {
	  return {
	    type: '@@ds/SET_OPTIONS_CACHE',
	    serverOptionsCache: serverOptionsCache
	  };
	};
	
	var setOptionsCacheById = exports.setOptionsCacheById = function setOptionsCacheById(id, options) {
	  return {
	    type: '@@ds/SET_OPTIONS_CACHE_BY_ID',
	    id: id,
	    options: options
	  };
	};

/***/ },
/* 45 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.maskValue = exports.MASK = exports.loopThroughRules = exports.VALIDATE = undefined;
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _requests = __webpack_require__(6);
	
	var api = _interopRequireWildcard(_requests);
	
	var _businessRules = __webpack_require__(198);
	
	var _store = __webpack_require__(18);
	
	var _store2 = _interopRequireDefault(_store);
	
	var _UploadAccumulator = __webpack_require__(199);
	
	var _utilities = __webpack_require__(8);
	
	var _repeaterConstraints = __webpack_require__(308);
	
	var _wizardUtilities = __webpack_require__(52);
	
	var _startOfDay = __webpack_require__(116);
	
	var _startOfDay2 = _interopRequireDefault(_startOfDay);
	
	var _differenceInDays = __webpack_require__(139);
	
	var _differenceInDays2 = _interopRequireDefault(_differenceInDays);
	
	var _differenceInMonths = __webpack_require__(140);
	
	var _differenceInMonths2 = _interopRequireDefault(_differenceInMonths);
	
	var _isAfter = __webpack_require__(186);
	
	var _isAfter2 = _interopRequireDefault(_isAfter);
	
	var _isBefore = __webpack_require__(187);
	
	var _isBefore2 = _interopRequireDefault(_isBefore);
	
	var _WizardActions = __webpack_require__(36);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	/*
	This file contains validation objects for validating field inputs.
	These validators can be used for both inline, tab-off, and server validation.
	To define a new validator, adhere to the following function structure:
	
	[Validator Name]: ([Field Value], [Field Type], [{Object containing properties needed by the validation function}]) => {
	  return ([Boolean: TRUE for passed validation, FALSE for failed validation], [optional string: A human-readable error message to be returned to the user.])
	}
	
	As described above, validators should always be pure functions, and should only return
	either [true] or [false] with an optional error message if applicable. If you intend the
	validation to transform the input value in some way, use the Mask() object.
	
	Mask() functions may call Validate() functions, but Validate() functions should never
	call Mask() functions. This ensures that when calling a Validate() function you may always
	safely expect a boolean response.
	
	*/
	
	var valueIsNotEmptyOrNull = function valueIsNotEmptyOrNull(value) {
	  return value !== '' && value !== null && value !== undefined && (typeof value === 'undefined' ? 'undefined' : _typeof(value)) !== 'object' || value === 0 || value === '0';
	};
	
	var valueIsPossiblyValidZip = function valueIsPossiblyValidZip(value) {
	  try {
	    return valueIsNotEmptyOrNull(value) && String(value).length >= 5;
	  } catch (e) {
	    console.warn(e);
	    return false;
	  }
	};
	
	var sanitizeNumber = function sanitizeNumber(value) {
	  var returnVal = void 0;
	  returnVal = value.toString();
	  if (returnVal.includes('.') && returnVal.split('.').length <= 2) {
	    try {
	      returnVal = Number.parseFloat(value.toString().replace(/,/g, '').replace(/\$/g, '').replace(/ /g, ''), 10);
	    } catch (e) {
	      returnVal = value;
	    } finally {
	      return returnVal;
	    }
	  } else {
	    try {
	      returnVal = Number.parseInt(value.toString().replace(/,/g, '').replace(/\$/g, '').replace(/ /g, ''), 10);
	    } catch (e) {
	      returnVal = value;
	    } finally {
	      return returnVal;
	    }
	  }
	};
	
	var getTrimmedValue = function getTrimmedValue() {
	  var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
	  return !value ? '' : value.trim();
	};
	
	var valueIsANumber = function valueIsANumber(value) {
	  return !!/^-?[\d.]+(?:e-?\d+)?$/.test(value);
	};
	
	var emptyExceptDefaultState = function emptyExceptDefaultState(value, field) {
	  for (var key in value) {
	    if (key != 'STATE' && key != 'COUNTRY' && valueIsNotEmptyOrNull(getTrimmedValue(value[key]))) {
	      return false;
	    }
	  }
	  if (getTrimmedValue(value.STATE) === field.defaultState) {
	    return true;
	  }
	};
	
	var VALIDATE = exports.VALIDATE = {
	  notEmptyOrNull: function notEmptyOrNull(value, field) {
	    var props = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	    var callback = arguments[3];
	
	    //checks that the input is not empty.
	    var testValue = value;
	    if (field.type === 'confirmFields') {
	      testValue = value.val1;
	    }
	    if (valueIsNotEmptyOrNull(testValue)) {
	      callback(true, '');
	    } else {
	      callback(false, props.errorMessage && props.errorMessage !== '' ? props.errorMessage : 'This field is required.');
	    }
	  },
	  mustBeSelected: function mustBeSelected(value, field) {
	    var props = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	    var callback = arguments[3];
	
	    var selectedOptionExists = field.options.find(function (option) {
	      return option.value.toString() === value.toString();
	    });
	    if (value === 'default' || !selectedOptionExists) {
	      callback(false, props.errorMessage && props.errorMessage !== '' ? props.errorMessage : 'This field is required.');
	    } else {
	      callback(true, '');
	    }
	  },
	  numberLessThan: function numberLessThan(value, field) {
	    var props = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	    var callback = arguments[3];
	
	    if (value) {
	      //Checks that a given number is less than, but not equal to, a number provided on the "max" property of the props object.
	      var sanitizedNumber = sanitizeNumber(value);
	      if (!valueIsANumber(sanitizedNumber)) {
	        callback(false, 'Please provide a valid number to continue.');
	      } else if (sanitizedNumber <= props.max) {
	        callback(true, '');
	      } else {
	        callback(false, props.errorMessage && props.errorMessage !== '' ? props.errorMessage : 'This number must be less than ' + props.max + '.');
	      }
	    } else {
	      callback(null, '');
	    }
	  },
	  numberGreaterThan: function numberGreaterThan(value, field) {
	    var props = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	    var callback = arguments[3];
	
	    if (value) {
	      var sanitizedNumber = sanitizeNumber(value);
	      if (!valueIsANumber(sanitizedNumber)) {
	        callback(false, 'Please provide a valid number to continue.');
	      } else if (sanitizedNumber >= props.min) {
	        callback(true, '');
	      } else {
	        callback(false, props.errorMessage && props.errorMessage !== '' ? props.errorMessage : 'This number must be greater than ' + props.min + '.');
	      }
	    } else {
	      callback(null, '');
	    }
	  },
	  mustBeTrue: function mustBeTrue(value, field) {
	    var props = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	    var callback = arguments[3];
	
	    //Checks that the given value is true. This is a "truthy" check, so the value may be either a string or boolean true.
	    //You may include a custom error message on the props object
	    if (value === true || value === 'true') {
	      callback(true, '');
	    } else {
	      callback(false, props.errorMessage && props.errorMessage !== '' ? props.errorMessage : 'This field must be checked');
	    }
	  },
	  valuesMatch: function valuesMatch(value, field) {
	    var props = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	    var callback = arguments[3];
	
	    //Checks that two given values match each other. The value should be an object with 'val1' and 'val2' properties.
	    //This is not a truthy check. The datatypes of the two values MUST match.
	    //By default this validator is case-sensitive, but you can pass "caseSensitive: false" on the props parameter to deactivate the case-sensitivity
	    var newValue = Object.assign({}, value);
	    newValue.val1 = value.val1.trim();
	    newValue.val2 = value.val2.trim();
	    if (props.caseSensitive === false) {
	      newValue.val1 = value.val1.toLowercase();
	      newValue.val2 = value.val2.toLowercase();
	    }
	    if (newValue.val1 === newValue.val2) {
	      callback(true, '');
	    } else {
	      callback(false, props.errorMessage && props.errorMessage !== '' ? props.errorMessage : 'These two fields must match exactly');
	    }
	  },
	  mustNotEqualString: function mustNotEqualString(value, field) {
	    var props = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	    var callback = arguments[3];
	
	    //Checks that the given value does not equal a given string. The string must be passed on the props object under the "string" property
	    //Because this validator is so dynamic, it is recommended that you pass in a custom errorMessage on the "errorMessage" property of the props object
	    //By default this validator is case-sensitive, but you can pass "caseSensitive: false" on the props parameter to deactivate the case-sensitivity
	    value = value.trim();
	    if (props.caseSensitive === false) {
	      value = value.toLowerCase();
	    }
	    if (value === props.string) {
	      callback(false, props.errorMessage || props.string + ' is not a valid input.');
	    } else {
	      callback(true, '');
	    }
	  },
	  mailingAddressIsRequired: function mailingAddressIsRequired(value, field) {
	    var props = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	    var callback = arguments[3];
	
	    VALIDATE.addressIsRequired(value.MAIL_ADDR, field, props, callback);
	  },
	  addressIsRequired: function addressIsRequired(value, field) {
	    var props = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	    var callback = arguments[3];
	
	    var isForeign = value.COUNTRY.toLowerCase() !== 'united states';
	    if (!valueIsNotEmptyOrNull(getTrimmedValue(value.COUNTRY))) {
	      callback(false, 'Please select a valid country.');
	    }
	    if (isForeign) {
	      if (valueIsNotEmptyOrNull(getTrimmedValue(value.ADDR1))) {
	        callback(true, '');
	      } else {
	        callback(false, props.errorMessage || 'Address 1 is required');
	      }
	    } else {
	      if (valueIsNotEmptyOrNull(getTrimmedValue(field.defaultState)) && !value.STATE) {
	        value.STATE = field.defaultState;
	      }
	
	      if (valueIsNotEmptyOrNull(getTrimmedValue(value.ADDR1)) && valueIsNotEmptyOrNull(getTrimmedValue(value.CITY)) && valueIsNotEmptyOrNull(getTrimmedValue(value.STATE)) && valueIsPossiblyValidZip(getTrimmedValue(value.POSTAL_CODE))) {
	        callback(true, '');
	      } else {
	        callback(false, props.errorMessage || 'Please provide a full address to continue.');
	      }
	    }
	  },
	  mailingAddressIsValid: function mailingAddressIsValid(value, field) {
	    var props = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	    var callback = arguments[3];
	
	    VALIDATE.addressIsValid(value.MAIL_ADDR, field, props, callback);
	  },
	  addressIsValid: function addressIsValid(value, field) {
	    var props = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	    var callback = arguments[3];
	
	    var isCompleteAddress = valueIsNotEmptyOrNull(getTrimmedValue(value.ADDR1)) && (valueIsNotEmptyOrNull(getTrimmedValue(value.CITY)) && valueIsNotEmptyOrNull(getTrimmedValue(value.STATE)) || valueIsNotEmptyOrNull(getTrimmedValue(value.POSTAL_CODE)));
	
	    var isModified = valueIsNotEmptyOrNull(getTrimmedValue(value.ADDR1)) || valueIsNotEmptyOrNull(getTrimmedValue(value.CITY)) || valueIsNotEmptyOrNull(getTrimmedValue(value.POSTAL_CODE));
	
	    var stateNotReplaceable = field.defaultState && field.disableState;
	    var allowAddressValidationBypass = (props.allowAddressValidationBypass || props.allowAgentAddressMailValidationBypass || props.allowAgentAddressPrimaryValidationBypass) && (true);
	    var isBypassAcknowledged = value.MAIL_ADDR_BYPASS_YN === 'Y';
	    if (value.COUNTRY.toLowerCase() === 'united states') {
	      if (!isCompleteAddress && isModified) {
	        callback(false, props.errorMessage || 'Please provide a complete address.');
	      } else if (!isModified || isBypassAcknowledged && allowAddressValidationBypass) {
	        callback(true, '', {
	          value: Object.assign({}, value),
	          confirmed: true
	        });
	      } else {
	        api.VALIDATE('address', value, function (data) {
	          // console.log(data);
	          if (data.valid) {
	            var correctedState = (data.payload.corrected || {}).STATE;
	            if (field.disableState && value.STATE !== correctedState) {
	              callback(false, 'Provided ZIP code is not valid in the selected state of ' + value.STATE, {
	                value: Object.assign({}, value, data.payload.corrected, {
	                  STATE: stateNotReplaceable ? value.STATE : data.payload.corrected.STATE
	                }),
	                infoMessage: data.payload.feedback.join('\n')
	              });
	            } else {
	              callback(true, '', {
	                value: Object.assign({}, value, data.payload.corrected, {
	                  STATE: stateNotReplaceable ? value.STATE : data.payload.corrected.STATE
	                }),
	                infoMessage: data.payload.feedback.join('\n')
	              });
	            }
	          } else {
	            callback(false, data.error, {
	              value: Object.assign({}, value, data.payload.corrected, {
	                STATE: stateNotReplaceable ? value.STATE : data.payload.corrected.STATE
	              }),
	              infoMessage: null
	            });
	          }
	        }, function (err) {
	          callback(false, 'Something went wrong while validating your address. If this problem persists, please contact customer support.');
	        });
	      }
	    } else {
	      callback(true, '');
	    }
	  },
	  partialMailingAddressNotAllowed: function partialMailingAddressNotAllowed(value, field) {
	    var props = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	    var callback = arguments[3];
	
	    VALIDATE.partialAddressNotAllowed(value.MAIL_ADDR, field, props, callback);
	  },
	  partialAddressNotAllowed: function partialAddressNotAllowed(value, field) {
	    var props = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	    var callback = arguments[3];
	
	    var addr1IsEmpty = {
	      value: !valueIsNotEmptyOrNull(getTrimmedValue(value.ADDR1)),
	      name: 'Address 1'
	    };
	    var cityIsEmpty = { value: !valueIsNotEmptyOrNull(getTrimmedValue(value.CITY)), name: 'City' };
	    var stateIsEmpty = {
	      value: !valueIsNotEmptyOrNull(getTrimmedValue(value.STATE)),
	      name: 'State'
	    };
	    var postalIsEmpty = {
	      value: !valueIsNotEmptyOrNull(getTrimmedValue(value.POSTAL_CODE)),
	      name: 'ZIP code'
	    };
	    var anyEmpty = addr1IsEmpty.value || cityIsEmpty.value || stateIsEmpty.value || postalIsEmpty.value;
	    var allEmpty = addr1IsEmpty.value && cityIsEmpty.value && stateIsEmpty.value && postalIsEmpty.value;
	    // If there's a default state, consider the address empty/valid.
	    if (emptyExceptDefaultState(value, field)) {
	      callback(null, '');
	    } else if (value.COUNTRY.toLowerCase() === 'united states' || value.COUNTRY.toLowerCase() === 'usa') {
	      if (allEmpty) {
	        callback(null, '');
	      } else if (!anyEmpty) {
	        callback(true, '');
	      } else {
	        var fields = [addr1IsEmpty, cityIsEmpty, stateIsEmpty, postalIsEmpty];
	        var numEmpties = 0;
	        fields.forEach(function (field) {
	          if (field.value) {
	            numEmpties++;
	          }
	        });
	        var empties = fields.filter(function (field) {
	          return field.value;
	        });
	
	        if (numEmpties > 2) {
	          var error = '';
	          empties.forEach(function (empty, i) {
	            error = '' + error + (i === empties.length - 1 ? 'and ' + empty.name + ' are required.' : empty.name + ', ');
	          });
	          callback(false, props.errorMessage || 'Please provide a complete address, ' + error);
	        } else if (numEmpties === 2) {
	          callback(false, props.errorMessage || 'Please provide a complete address, ' + empties[0].name + ' and ' + empties[1].name + ' are required.');
	        } else if (numEmpties === 1) {
	          callback(false, props.errorMessage || 'Please provide a complete address, ' + empties[0].name + ' is required.');
	        } else {
	          callback(true, '');
	        }
	      }
	    } else {
	      //Foreign
	      if (addr1IsEmpty.value) {
	        callback(false, 'Please provide a value in Address 1');
	      } else {
	        callback(true, '');
	      }
	    }
	  },
	  registeredAgentAddressIsValid: function registeredAgentAddressIsValid(value, field) {
	    var props = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	    var callback = arguments[3];
	
	    if (value.TYPE_ID.toString() === '460' && value.CRA_ID.toString() === '0' && field.addingAgent) {
	      var validatePrincipleAgainstAMS = props.principalAddressAMS || (true);
	      var validateMailingAddress = props.mailingAddressRequired;
	      var isIndividual = value.INDIVIDUAL_YN.toUpperCase() == 'Y';
	      var hasInputFirstAndLastNames = valueIsNotEmptyOrNull(value.FIRST_NAME) && valueIsNotEmptyOrNull(value.LAST_NAME);
	      var hasSelectedOrganization = value.ORGANIZATION ? value.ORGANIZATION.SOURCE_ID !== 0 && value.ORGANIZATION !== null : false;
	      var hasInputAddress = valueIsNotEmptyOrNull(getTrimmedValue(value.ADDR1)) && valueIsNotEmptyOrNull(getTrimmedValue(value.CITY)) && valueIsNotEmptyOrNull(getTrimmedValue(value.STATE)) && valueIsNotEmptyOrNull(getTrimmedValue(value.POSTAL_CODE));
	      var hasInputMailingAddress = valueIsNotEmptyOrNull(getTrimmedValue(value.MAIL_ADDR.ADDR1)) && valueIsNotEmptyOrNull(getTrimmedValue(value.MAIL_ADDR.CITY)) && valueIsNotEmptyOrNull(getTrimmedValue(value.MAIL_ADDR.STATE)) && valueIsNotEmptyOrNull(getTrimmedValue(value.MAIL_ADDR.POSTAL_CODE));
	      var validateMailAddressRA = function validateMailAddressRA() {
	        if (validateMailingAddress || validatePrincipleAgainstAMS) {
	          if (hasInputMailingAddress) {
	            var promises = [];
	            if (validateMailingAddress) {
	              promises.push(new Promise(function (resolve) {
	                VALIDATE.addressIsValid(value.MAIL_ADDR, field, props, function (isValid, error, payload) {
	                  resolve({ isValid: isValid, error: error, payload: payload, id: "mailing" });
	                });
	              }));
	            }
	            if (validatePrincipleAgainstAMS) {
	              promises.push(new Promise(function (resolve) {
	                VALIDATE.addressIsValid(value, field, props, function (isValid, error, payload) {
	                  resolve({ isValid: isValid, error: error, payload: payload, id: "principle" });
	                });
	              }));
	            }
	            Promise.all(promises).then(function (returnedAddresses) {
	              var mailAddress = returnedAddresses.find(function (a) {
	                return a.id === "mailing";
	              });
	              var principleAddress = returnedAddresses.find(function (a) {
	                return a.id === "principle";
	              });
	              var payload = mailAddress ? mailAddress.payload : null;
	              var principlePayload = principleAddress ? principleAddress.payload : null;
	              if (payload && payload.value) {
	                var newState = mailAddress.payload.value.STATE;
	                payload = {
	                  value: Object.assign({}, value, principlePayload && principlePayload.value ? {
	                    ADDR1: principlePayload.value.ADDR1,
	                    ADDR2: principlePayload.value.ADDR2,
	                    ADDR3: principlePayload.value.ADDR3,
	                    CITY: principlePayload.value.CITY,
	                    STATE: principlePayload.value.STATE,
	                    COUNTRY: principlePayload.value.COUNTRY,
	                    COUNTY: principlePayload.value.COUNTY,
	                    POSTAL_CODE: principlePayload.value.POSTAL_CODE
	                  } : {}, {
	                    MAIL_ADDR: {
	                      ADDR1: mailAddress.payload.value.ADDR1,
	                      ADDR2: mailAddress.payload.value.ADDR2,
	                      ADDR3: mailAddress.payload.value.ADDR3,
	                      CITY: mailAddress.payload.value.CITY,
	                      STATE: ({"NODE_ENV":"production","BUILD_DATE":"2025-08-27T15:15:31.687Z","BUILD_NUMBER":"Not Provided","GIT_VERSION":"v1.3.0-381-ga81e29b08","GIT_COMMIT_HASH":"a81e29b085c9268ffd96c78eb734365802722741","GIT_BRANCH":"beta","PUBLIC_URL":"","STATE_ABBR":"MT","STATE_NAME":"Montana","STATE_ORG_TITLE":"Secretary of State","LOGIN_HEADER_IMG_PATH":"","HOME_IMG_FILENAME":"montana.jpg","FAVICON_FILE_NAME":"favicon.ico","ALLOW_E_SIGN_ON_CORRECTIONS":true,"THIRD_PARTY_SIGNING_ALLOWED":false,"MY_ACCOUNT_SAVE_AND_CLOSE_BUTTON":true,"IE_DEPRECATED_MESSAGE":"Internet Explorer is not supported. Please select a supported browser below to access this website.","ADDITIONAL_ROUTES":{"dataRequests":true,"farmBill":true,"apostille":true,"externalHelp":"https://sosmt.gov/business/help-center/","systemAdministration":[{"title":"Saved Payments","parameter":"saved-payments","componentName":"SavedPayments"}]},"SUBROUTES":[{"label":"Business","component":"Business","parameter":"business","myWorkQueueSearch":false,"sourceTypeId":54,"searchMustHaveOneOf":["FILING_TYPE_ID","STATUS_ID","STATE","search"],"serverWebSearchDescription":true,"serverWorkQueueDescription":true,"serverMyRecordsDescription":true,"searchPlaceholder":"Search by name or filing number (X########)","allowEmptySearchTerm":true,"requestCertificateAlternateLabel":"Request Information","fileAmendmentButtonLabel":"Filing Actions","advancedSearchParameters":[{"type":"radio","name":"QUERY_TYPE_ID","defaultValue":1010,"options":[{"value":1010,"label":"Starts with"},{"value":1011,"label":"Contains"},{"value":1012,"label":" Word Contains"}]},{"type":"serverSelect","name":"FILING_TYPE_ID","optionsSrc":"FILING_TYPES","label":"Entity Type","placeholder":"All","defaultValue":"0"},{"type":"serverSelect","name":"FILING_SUBTYPE_ID","optionsSrc":"FILING_SUBTYPES","label":"Entity Subtype","overrideSubOptionsSrcFromParameterName":"FILING_TYPE_ID","placeholder":"All","defaultValue":"0"},{"type":"serverSelect","name":"STATUS_ID","optionsSrc":"FILING_STATUS_WITHOUT_ALL","label":"Status","placeholder":"All","defaultValue":"0"},{"type":"serverSelect","name":"STATE","optionsSrc":"STATE","label":"State","placeholder":"All","defaultValue":""},{"type":"serverSelect","name":"COUNTY","optionsSrc":"COUNTY_SUBOPTION","label":"County","overrideSubOptionsSrcFromParameterName":"STATE","placeholder":"All","defaultValue":""},{"type":"checkbox","name":"CRA_SEARCH_YN","defaultValue":false,"label":"Search by Registered Agent PID"},{"type":"dateRange","name":"FILING_DATE","label":"Registration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}},{"type":"dateRange","name":"EXPIRATION_DATE","label":"Expiration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}}],"myRecordsFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Active"},{"value":2,"label":"Inactive"},{"value":3,"label":"Pending"}]},{"type":"dateRange","name":"DATE_RANGE","label":"Date range","defaultValue":{"start":null,"end":null}}],"myWorkQueueFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Approved"},{"value":2,"label":"Pending Online Payment"},{"value":3,"label":"Pending Review"},{"value":4,"label":"Needs Correction"},{"value":5,"label":"Rejected"},{"value":6,"label":"Draft"}]},{"type":"dateRange","name":"DATE_RANGE","label":"Date range","defaultValue":{"start":null,"end":null}}]},{"label":"Notary","component":"Notary","parameter":"notary","sourceTypeId":850,"myWorkQueueSearch":false,"allowEmptySearchTerm":true,"requestCertificateAlternateLabel":"Download Certificate","fileAmendmentButtonLabel":"Filing Actions","hideNameRequestCertificate":true,"hideAddressRequestCertificate":true,"hideRecordUserManagment":true,"searchPlaceholder":"Search by name or commission number","searchMustHaveOneOf":["CITY","search","SERVICE_TYPE"],"advancedParametersStartOpen":true,"searchIsSortable":true,"advancedSearchParameters":[{"type":"radio","name":"STARTS_WITH_YN","defaultValue":false,"options":[{"value":true,"label":"Starts with"},{"value":false,"label":"Contains"}]},{"type":"checkbox","name":"ACTIVE_ONLY_YN","defaultValue":true,"label":"Active entities only"},{"type":"text","name":"CITY","defaultValue":"","label":"City"},{"type":"select","name":"SERVICE_TYPE","label":"Special Services Offered","defaultValue":0,"options":[{"value":0,"label":"(N/A)"},{"value":6165,"label":"In-Person Electronic Notarization (IPEN)"},{"value":6166,"label":"Remote Online Notarization (RON)"},{"value":6167,"label":"Mobile Notary Services"},{"value":6168,"label":"Remote Ink Notarization (RIN)"}]}]},{"label":"Apostille","component":"Apostille","parameter":"apostille","sourceTypeId":720,"myRecordsSearch":false,"myWorkQueueSearch":false,"disabled":false,"allowedRoutes":["/forms-manager/","/queue/","/forms/"]},{"label":"Liens","component":"UCC","parameter":"ucc","sourceTypeId":1999,"myRecordsSearch":true,"myWorkQueueSearch":true,"fileAmendmentButtonLabel":"Filing Actions","searchPlaceholder":"Search by name or file number","disabled":false,"serverWebSearchDescription":true,"myRecordsDescription":"","workQueueDescription":"","searchDescription":"","hideRecordUserManagment":true,"searchLiensCheckout":false,"advancedSearchParameters":[{"type":"radio","name":"STARTS_WITH_YN","defaultValue":false,"options":[{"value":true,"label":"Starts with"},{"value":false,"label":"Contains"}]},{"type":"select","name":"STATUS","defaultValue":"ALL","label":"Status","options":[{"value":"ACTIVE_UNLAPSED","label":"Active (unlapsed)"},{"value":"ACTIVE_LAPSED_UNLAPSED","label":"Active (lapsed and unlapsed)"}]},{"type":"text","name":"EXCLUDE_VALUES","label":"Exclude Debtor Names (comma separated list of names to exclude)","defaultValue":""},{"type":"dateRange","name":"FILING_DATE","label":"Financing Statement Date","defaultValue":{"start":null,"end":null}},{"type":"dateRange","name":"LAPSE_DATE","label":"Lapse Date","defaultValue":{"start":null,"end":null}},{"type":"text","name":"CITY","label":"Debtor City","defaultValue":""}],"myRecordsFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Approved"},{"value":2,"label":"Pending Online Payment"},{"value":3,"label":"Pending Review"}]},{"type":"select","name":"TYPE","defaultValue":0,"label":"Lien Type","options":[{"value":0,"label":"All"},{"value":1,"label":"UCC"},{"value":2,"label":"EFS"},{"value":3,"label":"Title 71"}]}],"myWorkQueueFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Approved"},{"value":2,"label":"Pending Online Payment"},{"value":3,"label":"Pending Review"},{"value":4,"label":"Pending Print and Mail"},{"value":5,"label":"Rejected"},{"value":6,"label":"Draft"}]},{"type":"select","name":"TYPE","defaultValue":0,"label":"Lien Type","options":[{"value":0,"label":"All"},{"value":1,"label":"UCC"},{"value":2,"label":"EFS"},{"value":3,"label":"Title 71"}]}]},{"label":"Copy Request","component":"copies","parameter":"copies","sourceTypeId":2001,"myRecordsSearch":false,"myWorkQueueSearch":false,"disabled":false,"allowedRoutes":["/forms-manager/","/queue/","/forms/"]},{"label":"Trademark","component":"Trademark","parameter":"trademark","sourceTypeId":810,"showRequestCertificate":true,"searchMustHaveOneOf":["search","EXPIRATION_DATE","FILING_DATE"],"allowEmptySearchTerm":true,"requestCertificateAlternateLabel":"Request Information","fileAmendmentButtonLabel":"Filing Actions","advancedSearchParameters":[{"type":"radio","name":"QUERY_TYPE_ID","defaultValue":1010,"options":[{"value":1010,"label":"Starts with"},{"value":1011,"label":"Contains"},{"value":1012,"label":" Word Contains"}]},{"type":"checkbox","name":"OWNER_SEARCH_YN","defaultValue":false,"label":"Search owners"},{"type":"radio","name":"SERVICE_MARK_YN","label":"Mark Type","defaultValue":"","options":[{"value":"","label":"All Marks"},{"value":"Y","label":"Service Mark"},{"value":"N","label":"Trademark"}]},{"type":"serverSelect","name":"STATUS_ID","optionsSrc":"TYPE_V|TRADEMARK_STATUS_TYPE","label":"Status","placeholder":"All","defaultValue":"0"},{"type":"select","name":"DESIGN_TYPE_ID","options":[{"value":0,"label":"All"},{"value":990,"label":"Words Only"},{"value":991,"label":"Design Only"},{"value":992,"label":"Words and Design"}],"label":"Design Type","defaultValue":"0"},{"type":"dateRange","name":"FILING_DATE","label":"Registered Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}},{"type":"dateRange","name":"EXPIRATION_DATE","label":"Expiration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}}]},{"label":"Business Info Request","component":"InfoRequests","parameter":"info-request","sourceTypeId":167,"allowedRoutes":["/forms-manager/","/queue/","/forms/"]},{"label":"Data Requests","component":"DataRequests","parameter":"data-request","sourceTypeId":0,"allowedRoutes":["/forms-manager/"]},{"label":"CRA","component":"CRA","parameter":"cra","sourceTypeId":157,"myRecordsSearch":false,"searchPlaceholder":"Search by name or registered agent number","allowedRoutes":["/forms-manager/","/forms/","/records/","/queue/","/search/"],"allowEmptySearchTerm":true,"fileAmendmentButtonLabel":"Filing Actions","advancedSearchParameters":[{"type":"radio","name":"QUERY_TYPE_ID","defaultValue":1010,"options":[{"value":1010,"label":"Starts with"},{"value":1011,"label":"Contains"},{"value":1012,"label":" Word Contains"}]},{"type":"dateRange","name":"CRA_DATE","label":"Registration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}},{"type":"select","name":"STATUS_ID","label":"Status","defaultValue":0,"options":[{"value":0,"label":"All"},{"value":121,"label":"Active"},{"value":122,"label":"Inactive"}]},{"type":"select","name":"AGENT_TYPE_ID","label":"Agent Type","defaultValue":0,"options":[{"value":0,"label":"All"},{"value":460,"label":"Registered Agent"},{"value":461,"label":"Commercial Registered Agent"}]}]},{"label":"Farm Bill","component":"FarmBill","parameter":"farm-bill","path":"/lists/farm-bill","sourceTypeId":0,"myRecordsSearch":false,"allowedRules":["/search/"],"disabled":true,"searchDescription":"To perform a search, enter a debtor name. Your search results may include: exact debtor name, variations of that name and any filing that includes your search criteria. Punctuation is ignored.\n\nYou can click on \"Advanced\" to refine your search. Under “Advanced” you can search by crop, year, county and SSN/FEIN. As a registered Farm Bill Buyer with the Montana Secretary of State’s office it is important to maintain the confidentiality of the information contained within the Farm Bill Master List. The Farm Bill Master List reflects personal data, such as Social Security Numbers, which are a key piece of personal identifiable information to assist you in determining the existence of a lien against a specific debtor. The distribution of this information beyond its intended purpose is strictly prohibited.\n\nThe debtor's tax identification number has been hidden for confidentiality reasons. You may continue to search on a tax ID number and return debtors that match your search criteria. The SSN/FEIN must be entered without dashes or spaces.","searchMustHaveOneOf":["search","UCC_FARM_PRODUCT_ID","COUNTY"],"searchPlaceholder":"Search by debtor name","advancedSearchParameters":[{"type":"ServerMultiComplete","label":"Product code name(s)","name":"UCC_FARM_PRODUCT_ID","defaultValue":"","optionsSrc":"UCC_FARM_PRODUCT_V"},{"type":"MultiComplete","label":"Year or Range of Years","name":"YEAR_NUM","optionsSrc":"years","startYear":"1968","defaultValue":[],"preMergeOptions":[{"value":"ALL","label":"All"}]},{"type":"serverSelect","label":"State","name":"STATE","defaultValue":"MONTANA","optionsSrc":"STATE"},{"type":"ServerMultiComplete","label":"County","name":"COUNTY","defaultValue":[],"optionsSrc":"COUNTY","overrideSubOptionsSrcFromParameterName":"STATE"},{"type":"checkbox","name":"TIN_SEARCH_YN","defaultValue":false,"label":"Tax Identification Number Search"},{"type":"checkbox","name":"TIN_SORT_YN","defaultValue":false,"label":"Unique ID Sort"}]}],"SYSTEM_NICKNAME":"Online Services Portal","PAYMENT_METHODS":[{"type":"bypass"},{"type":"iTransact"}],"PAYMENT_ALLOW_AMEX":true,"SYSTEM_ID_LABEL":"System Id","DOUBLE_COLUMN_PUBLIC_LOGIN":true,"INTERNAL_USER_MANAGEMENT":true,"ALLOW_PUBLIC_JSON_IMPORT":false,"MAX_FILE_UPLOAD_SIZE":10000000,"REFUND_TEXT":"","RETURN_TO_HOME_ON_LOGOUT":true,"CURRENT_SOS_NAME":"Christi Jacobsen","LOGO_FILENAME":"mt-sos-logo.png","LOGO_ALT":"Christi Jacobsen, Montana Secretary of State","LOGO_FULL_WIDTH":true,"HOME_HIDE_AUTH_HINT":true,"HOME_TITLE":"Montana Secretary of State","CUSTOM_TAB_TITLE":"Official Montana","HOME_SUBTITLE":"Online Business Services","ENTITY_NAME_CONSENT_DESCRIPTION":"","ALLOW_USER_PROFILE_EDITING":true,"COMPARE_FOREIGN_NAME_IN_ENTITY_NAME_VALIDATION":true,"FOREIGN_NAME_FIELD_NAME":"KIMA_PARENT_NAME_INFO","LOGIN_TITLE":"Montana Secretary of State Online Filing Portal Login","PUBLIC_LOGIN_LABEL":"Username","REVERSE_LOGIN_COLUMNS":true,"LOGIN_SEAL_FILENAME":"seal_white.png","SEPARATE_USERNAME_AND_EMAIL":true,"CREATE_ACCOUNT_BUTTON_ALIGN_LEFT":true,"CREATE_ACCOUNT_BUTTON_TEXT":"CREATE AN ACCOUNT","PASSWORD_CUSTOM_ERROR_TEXT":"The password must meet all requirements","ACCOUNT_CREATED_MESSAGE":"Please check your email to verify your account to login and allow a few minutes for this message to arrive. Check your junk/spam folders if you do not find the email in your inbox.","PUBLIC_LOGIN_PLACEHOLDER":" ","DISABLE_DEFAULT_PAYMENT_RADIO":true,"CUSTOM_RESET_PASSWORD_ERROR_MESSAGE":"Username invalid - no account found","PUBLIC_LOGIN_CREATE_DESCRIPTION":"### Existing User:\n\n  - Enter your username and password to login.  \n\n\n  #### - OR -  \n\n\n\n  - Forgot password? Click 'Reset Password' and follow the prompts.\n  - Forgot username? Click 'Forgot Username' and follow the prompts.  \n\n\n  ### New User:\n  ","LOGIN_HELP_LINK":"https://sosmt.gov/business/how-do-i/","LOGIN_HELP_LINK_TEXT":"Need Help?","FORGOT_USERNAME_TEXT":"Forgot Username?","LOGIN_ACTIVE_DIRECTORY_TEXT":"State User Login","MULTIPLE_LOGIN_METHODS":true,"HAS_ACTIVE_DIRECTORY_LOGIN":true,"RESET_PASSWORD_WITH_USERNAME":true,"DOWNLOAD_LINK":true,"SHOW_USERNAME_ACCOUNT_CREATE":true,"SHOW_SCROLL_DOWN_ARROW":true,"SHOW_ADDRESS_ACCOUNT_CREATE":true,"TWO_COLUMN_ACCOUNT_CREATE":true,"RESET_PASSWORD_TIP":"A link to change your password has been sent to your email. Please allow a few minutes for this message to arrive. Please check your junk/spam folders if you do not find the email in your inbox.","FORGOT_PASSWORD_LINK_TEXT":"Reset Password","PHONE_NUMBER_OPTIONAL_ACCOUNT_CREATE":true,"SHOW_REQUIRED_INDICATOR_ACCOUNT_CREATE":true,"PASSWORD_REQUIREMENTS_ACCOUNT_CREATE":"\n    <ul>\n      <li>MUST contain at least 8 characters (12+ recommended)</li>\n      <li>MUST contain at least one uppercase letter.</li>\n      <li>MUST contain at least one lowercase letter.</li>\n      <li>MUST contain at least one number.</li>\n      <li>MUST contain at least one special character (!”#$%&'()*+,-./:;<=>?</li>\n    </ul>\n  ","ALLOW_CERTIFICATION_REQUEST":true,"ALLOW_PUBLIC_CERTIFICATE_REQUEST":true,"ALLOW_COPY_REQUEST":false,"ALLOW_CORRECTION_STYLING":true,"HIDE_DEPRECATION_WARNING":false,"AMEND_ROUTE_PUBLIC":true,"SEAL_FILENAME":"seal.png","SHOPPING_CART":true,"ALLOW_PAYMENT_UPDATE_WITH_EMPTY_CART":true,"RA_EMAIL":true,"RA_WEBSITE":true,"RA_NO_DEFAULT_TYPE":true,"RA_ADDRESS_LABEL":"Street Address","RA_TYPE_SELECTION_DEFAULT":true,"RA_DEFAULT_TYPE":"460","RA_OVERRIDE_TYPE_WITH_DEFAULT":true,"RA_PRINCIPAL_ADDRESS_AMS":true,"UPLOAD_AND_SUBMIT_HIDE_IF_ONE_OPTION":true,"PAYMENT_PROCESSING_MESSAGE":"Your payment is processing - Do not close your browser or click the back button","CHECKOUT_BUTTON_WHEN_PROCESSING_TEXT":"Processing","EFS_CROP_PICKER_NONE_LABEL":"Lien Duration","DISALLOWED_WIZARD_PIECES":["FormationLocale"],"REPEATER_SHOW_EDIT_BUTTON":true,"DATA_REQUEST_PAGE_TITLE":"Data Requests and Subscriptions","DATA_REQUEST_SIDEBAR_LABEL":"Data Requests & Subscriptions","LOGIN_REDIRECTS_TO_EPASS":false,"LOGIN_REDIRECTS_TO_ACTIVE_DIRECTORY":true,"LOGIN_ACTIVE_DIRECTORY_LINK":true,"FETCH_EDIT_USER_LINK":false,"LISTS_FETCH_AVAILABLE_LISTS":true,"POST_WIZARD_SUBMIT_REDIRECT_URL":"/","PIN_REQUEST_ATTESTATIONS":true,"PIN_REQUEST_DESCRIPTION":"Click **Request PIN** to have a new PIN sent to the account holder's email address on file.","OWNERSHIP_REQUEST_DESCRIPTION":"To become an **authorized user** of this record, a current **AUTHORIZED USER** will need to grant you access. To request access, click **Request Access** below.","PIN_REQUEST_SUCCESS_MESSAGE":"The PIN you have requested for this entity has been sent to the email associated with your user account.  You should receive the PIN in approximately 3-5 minutes, depending on your email service provider.","APOSTILLE_HEADER_LABEL":"Verification Information","APOSTILLE_NUMBER_LABEL":"Apostille/Authentication","APOSTILLE_CITY_STATE_OVERRIDE":"HELENA, MT","APOSTILLE_FILING_DATE_LABEL":"Issue Date","APOSTILLE_CITY_STATE_IN_CERTIFIED":true,"NOTARY_EXISTING_FILING":true,"ALLOW_REVOKE_OWN_ACCESS_ONLY":false,"HIDE_CANCEL_ON_ONETIME_DATA_REQUESTS":true,"DATA_REQUESTS_IN_SHOPPING_CART":true,"WQ_ALLOW_EDIT_PENDING_PAYMENT":true,"WQ_CONFIRM_ON_DELETE":true,"WQ_DELETE_CONFIRM_MESSAGE":"Deleting this filing will forfeit any money already paid to the Secretary of State. This action is permanent and cannot be undone, are you sure you would like to delete?","PASS_ITEM_GUIDS_ON_CHECKOUT":true,"FORM_REVISION_HISTORY":true,"CHECKOUT_DISCLAIMER":"By entering your credit card and/or checking account information you (i) state that **you are an authorized user** of the credit card and/or electronic check and that the associated information entered (e.g., account holder name, account number, billing address) is accurate, (ii) **you authorize payment processor to charge the amount you have requested** to your credit card and/or funding account, and (iii) **acknowledge if a charge is declined or reversed you may also be assessed a customary charge** by the payment processor for such transactions.","FARM_BILL_SEARCH_CONFIDENTIAL":"As a registered Farm Bill Buyer with the Montana Secretary of State’s office it is important to maintain the confidentiality of the information contained within the Farm Bill Master List. The Farm Bill Master List reflects personal data, such as Social Security Numbers, which are a key piece of personal identifiable information to assist you in determining the existence of a lien against a specific debtor. The distribution of this information beyond its intended purpose is strictly prohibited.\n\n**The debtor's tax identification number has been hidden for confidentiality reasons. You may continue to search on a tax ID number and return debtors that match your search criteria. The SSN/FEIN must be entered without dashes or spaces.  If you need access to the tax identification number to clearly identify the debtor, please contact the UCC unit at (406) 444-3665.**","VIEW_HISTORY_BUTTON_ALT_TEXT":"View Filings","WIZARD_ERROR_TITLE_MESSAGE":"Form Error","FARM_BILL_SEARCH_INTERACTIVE":true,"USE_FARM_BILL_API":true,"DISALLOW_ASSIGN_SELF_AS_RA":true,"DISALLOW_ASSIGN_SELF_AS_PRINCIPAL":true,"USE_TRADEMARK_OWNER_VALIDATION":true,"USE_ALTERNATIVE_FOREIGN_ADDRESS_LABELS":true,"MY_RECEIPTS_FILTER":[{"type":"dateRange","name":"DATE_RANGE","label":"Date range","defaultValue":{"start":null,"end":null}},{"type":"text","name":"REF_NUM","defaultValue":"","label":"Reference Number"},{"type":"text","name":"RECEIPT_NUM","defaultValue":"","label":"Receipt Id"},{"type":"text","name":"AMOUNT","defaultValue":"","label":"Amount"},{"type":"select","name":"TYPE","defaultValue":"","label":"Payment Type","options":[{"value":"","label":"All"},{"value":"CC","label":"Credit Card"},{"value":"Check","label":"Check"}]}],"MY_RECEIPTS_SHOW_IN_SIDEBAR":true,"SHOW_MY_RECEIPTS_HELPER_TEXT":true,"MY_RECEIPTS_HELPER_LABEL":"About Receipt Search","MY_RECEIPTS_HELPER_TEXT":"You can search for receipts based on their descriptions, including the items paid for on the receipt. Use the filters to search for or filter specific information.","FARM_BILL_SUBLINK":{"label":"Farm Bill","component":"FarmBill","parameter":"farm-bill","path":"/lists/farm-bill","sourceTypeId":0,"myRecordsSearch":false,"allowedRules":["/search/"],"disabled":true,"searchDescription":"To perform a search, enter a debtor name. Your search results may include: exact debtor name, variations of that name and any filing that includes your search criteria. Punctuation is ignored.\n\nYou can click on \"Advanced\" to refine your search. Under “Advanced” you can search by crop, year, county and SSN/FEIN. As a registered Farm Bill Buyer with the Montana Secretary of State’s office it is important to maintain the confidentiality of the information contained within the Farm Bill Master List. The Farm Bill Master List reflects personal data, such as Social Security Numbers, which are a key piece of personal identifiable information to assist you in determining the existence of a lien against a specific debtor. The distribution of this information beyond its intended purpose is strictly prohibited.\n\nThe debtor's tax identification number has been hidden for confidentiality reasons. You may continue to search on a tax ID number and return debtors that match your search criteria. The SSN/FEIN must be entered without dashes or spaces.","searchMustHaveOneOf":["search","UCC_FARM_PRODUCT_ID","COUNTY"],"searchPlaceholder":"Search by debtor name","advancedSearchParameters":[{"type":"ServerMultiComplete","label":"Product code name(s)","name":"UCC_FARM_PRODUCT_ID","defaultValue":"","optionsSrc":"UCC_FARM_PRODUCT_V"},{"type":"MultiComplete","label":"Year or Range of Years","name":"YEAR_NUM","optionsSrc":"years","startYear":"1968","defaultValue":[],"preMergeOptions":[{"value":"ALL","label":"All"}]},{"type":"serverSelect","label":"State","name":"STATE","defaultValue":"MONTANA","optionsSrc":"STATE"},{"type":"ServerMultiComplete","label":"County","name":"COUNTY","defaultValue":[],"optionsSrc":"COUNTY","overrideSubOptionsSrcFromParameterName":"STATE"},{"type":"checkbox","name":"TIN_SEARCH_YN","defaultValue":false,"label":"Tax Identification Number Search"},{"type":"checkbox","name":"TIN_SORT_YN","defaultValue":false,"label":"Unique ID Sort"}]},"ALLOW_ADDRESS_VALIDATION_BYPASS_OPTION":true,"DEFAULT_ADDRESS_VALIDATION_BYPASS_OPTION_CHECKED":true}).RA_MAILING_STATE_DISABLED ? value.MAIL_ADDR.STATE : newState,
	                      COUNTRY: mailAddress.payload.value.COUNTRY,
	                      COUNTY: mailAddress.payload.value.COUNTY,
	                      POSTAL_CODE: mailAddress.payload.value.POSTAL_CODE
	                    }
	                  })
	                };
	                if (({"NODE_ENV":"production","BUILD_DATE":"2025-08-27T15:15:31.687Z","BUILD_NUMBER":"Not Provided","GIT_VERSION":"v1.3.0-381-ga81e29b08","GIT_COMMIT_HASH":"a81e29b085c9268ffd96c78eb734365802722741","GIT_BRANCH":"beta","PUBLIC_URL":"","STATE_ABBR":"MT","STATE_NAME":"Montana","STATE_ORG_TITLE":"Secretary of State","LOGIN_HEADER_IMG_PATH":"","HOME_IMG_FILENAME":"montana.jpg","FAVICON_FILE_NAME":"favicon.ico","ALLOW_E_SIGN_ON_CORRECTIONS":true,"THIRD_PARTY_SIGNING_ALLOWED":false,"MY_ACCOUNT_SAVE_AND_CLOSE_BUTTON":true,"IE_DEPRECATED_MESSAGE":"Internet Explorer is not supported. Please select a supported browser below to access this website.","ADDITIONAL_ROUTES":{"dataRequests":true,"farmBill":true,"apostille":true,"externalHelp":"https://sosmt.gov/business/help-center/","systemAdministration":[{"title":"Saved Payments","parameter":"saved-payments","componentName":"SavedPayments"}]},"SUBROUTES":[{"label":"Business","component":"Business","parameter":"business","myWorkQueueSearch":false,"sourceTypeId":54,"searchMustHaveOneOf":["FILING_TYPE_ID","STATUS_ID","STATE","search"],"serverWebSearchDescription":true,"serverWorkQueueDescription":true,"serverMyRecordsDescription":true,"searchPlaceholder":"Search by name or filing number (X########)","allowEmptySearchTerm":true,"requestCertificateAlternateLabel":"Request Information","fileAmendmentButtonLabel":"Filing Actions","advancedSearchParameters":[{"type":"radio","name":"QUERY_TYPE_ID","defaultValue":1010,"options":[{"value":1010,"label":"Starts with"},{"value":1011,"label":"Contains"},{"value":1012,"label":" Word Contains"}]},{"type":"serverSelect","name":"FILING_TYPE_ID","optionsSrc":"FILING_TYPES","label":"Entity Type","placeholder":"All","defaultValue":"0"},{"type":"serverSelect","name":"FILING_SUBTYPE_ID","optionsSrc":"FILING_SUBTYPES","label":"Entity Subtype","overrideSubOptionsSrcFromParameterName":"FILING_TYPE_ID","placeholder":"All","defaultValue":"0"},{"type":"serverSelect","name":"STATUS_ID","optionsSrc":"FILING_STATUS_WITHOUT_ALL","label":"Status","placeholder":"All","defaultValue":"0"},{"type":"serverSelect","name":"STATE","optionsSrc":"STATE","label":"State","placeholder":"All","defaultValue":""},{"type":"serverSelect","name":"COUNTY","optionsSrc":"COUNTY_SUBOPTION","label":"County","overrideSubOptionsSrcFromParameterName":"STATE","placeholder":"All","defaultValue":""},{"type":"checkbox","name":"CRA_SEARCH_YN","defaultValue":false,"label":"Search by Registered Agent PID"},{"type":"dateRange","name":"FILING_DATE","label":"Registration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}},{"type":"dateRange","name":"EXPIRATION_DATE","label":"Expiration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}}],"myRecordsFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Active"},{"value":2,"label":"Inactive"},{"value":3,"label":"Pending"}]},{"type":"dateRange","name":"DATE_RANGE","label":"Date range","defaultValue":{"start":null,"end":null}}],"myWorkQueueFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Approved"},{"value":2,"label":"Pending Online Payment"},{"value":3,"label":"Pending Review"},{"value":4,"label":"Needs Correction"},{"value":5,"label":"Rejected"},{"value":6,"label":"Draft"}]},{"type":"dateRange","name":"DATE_RANGE","label":"Date range","defaultValue":{"start":null,"end":null}}]},{"label":"Notary","component":"Notary","parameter":"notary","sourceTypeId":850,"myWorkQueueSearch":false,"allowEmptySearchTerm":true,"requestCertificateAlternateLabel":"Download Certificate","fileAmendmentButtonLabel":"Filing Actions","hideNameRequestCertificate":true,"hideAddressRequestCertificate":true,"hideRecordUserManagment":true,"searchPlaceholder":"Search by name or commission number","searchMustHaveOneOf":["CITY","search","SERVICE_TYPE"],"advancedParametersStartOpen":true,"searchIsSortable":true,"advancedSearchParameters":[{"type":"radio","name":"STARTS_WITH_YN","defaultValue":false,"options":[{"value":true,"label":"Starts with"},{"value":false,"label":"Contains"}]},{"type":"checkbox","name":"ACTIVE_ONLY_YN","defaultValue":true,"label":"Active entities only"},{"type":"text","name":"CITY","defaultValue":"","label":"City"},{"type":"select","name":"SERVICE_TYPE","label":"Special Services Offered","defaultValue":0,"options":[{"value":0,"label":"(N/A)"},{"value":6165,"label":"In-Person Electronic Notarization (IPEN)"},{"value":6166,"label":"Remote Online Notarization (RON)"},{"value":6167,"label":"Mobile Notary Services"},{"value":6168,"label":"Remote Ink Notarization (RIN)"}]}]},{"label":"Apostille","component":"Apostille","parameter":"apostille","sourceTypeId":720,"myRecordsSearch":false,"myWorkQueueSearch":false,"disabled":false,"allowedRoutes":["/forms-manager/","/queue/","/forms/"]},{"label":"Liens","component":"UCC","parameter":"ucc","sourceTypeId":1999,"myRecordsSearch":true,"myWorkQueueSearch":true,"fileAmendmentButtonLabel":"Filing Actions","searchPlaceholder":"Search by name or file number","disabled":false,"serverWebSearchDescription":true,"myRecordsDescription":"","workQueueDescription":"","searchDescription":"","hideRecordUserManagment":true,"searchLiensCheckout":false,"advancedSearchParameters":[{"type":"radio","name":"STARTS_WITH_YN","defaultValue":false,"options":[{"value":true,"label":"Starts with"},{"value":false,"label":"Contains"}]},{"type":"select","name":"STATUS","defaultValue":"ALL","label":"Status","options":[{"value":"ACTIVE_UNLAPSED","label":"Active (unlapsed)"},{"value":"ACTIVE_LAPSED_UNLAPSED","label":"Active (lapsed and unlapsed)"}]},{"type":"text","name":"EXCLUDE_VALUES","label":"Exclude Debtor Names (comma separated list of names to exclude)","defaultValue":""},{"type":"dateRange","name":"FILING_DATE","label":"Financing Statement Date","defaultValue":{"start":null,"end":null}},{"type":"dateRange","name":"LAPSE_DATE","label":"Lapse Date","defaultValue":{"start":null,"end":null}},{"type":"text","name":"CITY","label":"Debtor City","defaultValue":""}],"myRecordsFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Approved"},{"value":2,"label":"Pending Online Payment"},{"value":3,"label":"Pending Review"}]},{"type":"select","name":"TYPE","defaultValue":0,"label":"Lien Type","options":[{"value":0,"label":"All"},{"value":1,"label":"UCC"},{"value":2,"label":"EFS"},{"value":3,"label":"Title 71"}]}],"myWorkQueueFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Approved"},{"value":2,"label":"Pending Online Payment"},{"value":3,"label":"Pending Review"},{"value":4,"label":"Pending Print and Mail"},{"value":5,"label":"Rejected"},{"value":6,"label":"Draft"}]},{"type":"select","name":"TYPE","defaultValue":0,"label":"Lien Type","options":[{"value":0,"label":"All"},{"value":1,"label":"UCC"},{"value":2,"label":"EFS"},{"value":3,"label":"Title 71"}]}]},{"label":"Copy Request","component":"copies","parameter":"copies","sourceTypeId":2001,"myRecordsSearch":false,"myWorkQueueSearch":false,"disabled":false,"allowedRoutes":["/forms-manager/","/queue/","/forms/"]},{"label":"Trademark","component":"Trademark","parameter":"trademark","sourceTypeId":810,"showRequestCertificate":true,"searchMustHaveOneOf":["search","EXPIRATION_DATE","FILING_DATE"],"allowEmptySearchTerm":true,"requestCertificateAlternateLabel":"Request Information","fileAmendmentButtonLabel":"Filing Actions","advancedSearchParameters":[{"type":"radio","name":"QUERY_TYPE_ID","defaultValue":1010,"options":[{"value":1010,"label":"Starts with"},{"value":1011,"label":"Contains"},{"value":1012,"label":" Word Contains"}]},{"type":"checkbox","name":"OWNER_SEARCH_YN","defaultValue":false,"label":"Search owners"},{"type":"radio","name":"SERVICE_MARK_YN","label":"Mark Type","defaultValue":"","options":[{"value":"","label":"All Marks"},{"value":"Y","label":"Service Mark"},{"value":"N","label":"Trademark"}]},{"type":"serverSelect","name":"STATUS_ID","optionsSrc":"TYPE_V|TRADEMARK_STATUS_TYPE","label":"Status","placeholder":"All","defaultValue":"0"},{"type":"select","name":"DESIGN_TYPE_ID","options":[{"value":0,"label":"All"},{"value":990,"label":"Words Only"},{"value":991,"label":"Design Only"},{"value":992,"label":"Words and Design"}],"label":"Design Type","defaultValue":"0"},{"type":"dateRange","name":"FILING_DATE","label":"Registered Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}},{"type":"dateRange","name":"EXPIRATION_DATE","label":"Expiration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}}]},{"label":"Business Info Request","component":"InfoRequests","parameter":"info-request","sourceTypeId":167,"allowedRoutes":["/forms-manager/","/queue/","/forms/"]},{"label":"Data Requests","component":"DataRequests","parameter":"data-request","sourceTypeId":0,"allowedRoutes":["/forms-manager/"]},{"label":"CRA","component":"CRA","parameter":"cra","sourceTypeId":157,"myRecordsSearch":false,"searchPlaceholder":"Search by name or registered agent number","allowedRoutes":["/forms-manager/","/forms/","/records/","/queue/","/search/"],"allowEmptySearchTerm":true,"fileAmendmentButtonLabel":"Filing Actions","advancedSearchParameters":[{"type":"radio","name":"QUERY_TYPE_ID","defaultValue":1010,"options":[{"value":1010,"label":"Starts with"},{"value":1011,"label":"Contains"},{"value":1012,"label":" Word Contains"}]},{"type":"dateRange","name":"CRA_DATE","label":"Registration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}},{"type":"select","name":"STATUS_ID","label":"Status","defaultValue":0,"options":[{"value":0,"label":"All"},{"value":121,"label":"Active"},{"value":122,"label":"Inactive"}]},{"type":"select","name":"AGENT_TYPE_ID","label":"Agent Type","defaultValue":0,"options":[{"value":0,"label":"All"},{"value":460,"label":"Registered Agent"},{"value":461,"label":"Commercial Registered Agent"}]}]},{"label":"Farm Bill","component":"FarmBill","parameter":"farm-bill","path":"/lists/farm-bill","sourceTypeId":0,"myRecordsSearch":false,"allowedRules":["/search/"],"disabled":true,"searchDescription":"To perform a search, enter a debtor name. Your search results may include: exact debtor name, variations of that name and any filing that includes your search criteria. Punctuation is ignored.\n\nYou can click on \"Advanced\" to refine your search. Under “Advanced” you can search by crop, year, county and SSN/FEIN. As a registered Farm Bill Buyer with the Montana Secretary of State’s office it is important to maintain the confidentiality of the information contained within the Farm Bill Master List. The Farm Bill Master List reflects personal data, such as Social Security Numbers, which are a key piece of personal identifiable information to assist you in determining the existence of a lien against a specific debtor. The distribution of this information beyond its intended purpose is strictly prohibited.\n\nThe debtor's tax identification number has been hidden for confidentiality reasons. You may continue to search on a tax ID number and return debtors that match your search criteria. The SSN/FEIN must be entered without dashes or spaces.","searchMustHaveOneOf":["search","UCC_FARM_PRODUCT_ID","COUNTY"],"searchPlaceholder":"Search by debtor name","advancedSearchParameters":[{"type":"ServerMultiComplete","label":"Product code name(s)","name":"UCC_FARM_PRODUCT_ID","defaultValue":"","optionsSrc":"UCC_FARM_PRODUCT_V"},{"type":"MultiComplete","label":"Year or Range of Years","name":"YEAR_NUM","optionsSrc":"years","startYear":"1968","defaultValue":[],"preMergeOptions":[{"value":"ALL","label":"All"}]},{"type":"serverSelect","label":"State","name":"STATE","defaultValue":"MONTANA","optionsSrc":"STATE"},{"type":"ServerMultiComplete","label":"County","name":"COUNTY","defaultValue":[],"optionsSrc":"COUNTY","overrideSubOptionsSrcFromParameterName":"STATE"},{"type":"checkbox","name":"TIN_SEARCH_YN","defaultValue":false,"label":"Tax Identification Number Search"},{"type":"checkbox","name":"TIN_SORT_YN","defaultValue":false,"label":"Unique ID Sort"}]}],"SYSTEM_NICKNAME":"Online Services Portal","PAYMENT_METHODS":[{"type":"bypass"},{"type":"iTransact"}],"PAYMENT_ALLOW_AMEX":true,"SYSTEM_ID_LABEL":"System Id","DOUBLE_COLUMN_PUBLIC_LOGIN":true,"INTERNAL_USER_MANAGEMENT":true,"ALLOW_PUBLIC_JSON_IMPORT":false,"MAX_FILE_UPLOAD_SIZE":10000000,"REFUND_TEXT":"","RETURN_TO_HOME_ON_LOGOUT":true,"CURRENT_SOS_NAME":"Christi Jacobsen","LOGO_FILENAME":"mt-sos-logo.png","LOGO_ALT":"Christi Jacobsen, Montana Secretary of State","LOGO_FULL_WIDTH":true,"HOME_HIDE_AUTH_HINT":true,"HOME_TITLE":"Montana Secretary of State","CUSTOM_TAB_TITLE":"Official Montana","HOME_SUBTITLE":"Online Business Services","ENTITY_NAME_CONSENT_DESCRIPTION":"","ALLOW_USER_PROFILE_EDITING":true,"COMPARE_FOREIGN_NAME_IN_ENTITY_NAME_VALIDATION":true,"FOREIGN_NAME_FIELD_NAME":"KIMA_PARENT_NAME_INFO","LOGIN_TITLE":"Montana Secretary of State Online Filing Portal Login","PUBLIC_LOGIN_LABEL":"Username","REVERSE_LOGIN_COLUMNS":true,"LOGIN_SEAL_FILENAME":"seal_white.png","SEPARATE_USERNAME_AND_EMAIL":true,"CREATE_ACCOUNT_BUTTON_ALIGN_LEFT":true,"CREATE_ACCOUNT_BUTTON_TEXT":"CREATE AN ACCOUNT","PASSWORD_CUSTOM_ERROR_TEXT":"The password must meet all requirements","ACCOUNT_CREATED_MESSAGE":"Please check your email to verify your account to login and allow a few minutes for this message to arrive. Check your junk/spam folders if you do not find the email in your inbox.","PUBLIC_LOGIN_PLACEHOLDER":" ","DISABLE_DEFAULT_PAYMENT_RADIO":true,"CUSTOM_RESET_PASSWORD_ERROR_MESSAGE":"Username invalid - no account found","PUBLIC_LOGIN_CREATE_DESCRIPTION":"### Existing User:\n\n  - Enter your username and password to login.  \n\n\n  #### - OR -  \n\n\n\n  - Forgot password? Click 'Reset Password' and follow the prompts.\n  - Forgot username? Click 'Forgot Username' and follow the prompts.  \n\n\n  ### New User:\n  ","LOGIN_HELP_LINK":"https://sosmt.gov/business/how-do-i/","LOGIN_HELP_LINK_TEXT":"Need Help?","FORGOT_USERNAME_TEXT":"Forgot Username?","LOGIN_ACTIVE_DIRECTORY_TEXT":"State User Login","MULTIPLE_LOGIN_METHODS":true,"HAS_ACTIVE_DIRECTORY_LOGIN":true,"RESET_PASSWORD_WITH_USERNAME":true,"DOWNLOAD_LINK":true,"SHOW_USERNAME_ACCOUNT_CREATE":true,"SHOW_SCROLL_DOWN_ARROW":true,"SHOW_ADDRESS_ACCOUNT_CREATE":true,"TWO_COLUMN_ACCOUNT_CREATE":true,"RESET_PASSWORD_TIP":"A link to change your password has been sent to your email. Please allow a few minutes for this message to arrive. Please check your junk/spam folders if you do not find the email in your inbox.","FORGOT_PASSWORD_LINK_TEXT":"Reset Password","PHONE_NUMBER_OPTIONAL_ACCOUNT_CREATE":true,"SHOW_REQUIRED_INDICATOR_ACCOUNT_CREATE":true,"PASSWORD_REQUIREMENTS_ACCOUNT_CREATE":"\n    <ul>\n      <li>MUST contain at least 8 characters (12+ recommended)</li>\n      <li>MUST contain at least one uppercase letter.</li>\n      <li>MUST contain at least one lowercase letter.</li>\n      <li>MUST contain at least one number.</li>\n      <li>MUST contain at least one special character (!”#$%&'()*+,-./:;<=>?</li>\n    </ul>\n  ","ALLOW_CERTIFICATION_REQUEST":true,"ALLOW_PUBLIC_CERTIFICATE_REQUEST":true,"ALLOW_COPY_REQUEST":false,"ALLOW_CORRECTION_STYLING":true,"HIDE_DEPRECATION_WARNING":false,"AMEND_ROUTE_PUBLIC":true,"SEAL_FILENAME":"seal.png","SHOPPING_CART":true,"ALLOW_PAYMENT_UPDATE_WITH_EMPTY_CART":true,"RA_EMAIL":true,"RA_WEBSITE":true,"RA_NO_DEFAULT_TYPE":true,"RA_ADDRESS_LABEL":"Street Address","RA_TYPE_SELECTION_DEFAULT":true,"RA_DEFAULT_TYPE":"460","RA_OVERRIDE_TYPE_WITH_DEFAULT":true,"RA_PRINCIPAL_ADDRESS_AMS":true,"UPLOAD_AND_SUBMIT_HIDE_IF_ONE_OPTION":true,"PAYMENT_PROCESSING_MESSAGE":"Your payment is processing - Do not close your browser or click the back button","CHECKOUT_BUTTON_WHEN_PROCESSING_TEXT":"Processing","EFS_CROP_PICKER_NONE_LABEL":"Lien Duration","DISALLOWED_WIZARD_PIECES":["FormationLocale"],"REPEATER_SHOW_EDIT_BUTTON":true,"DATA_REQUEST_PAGE_TITLE":"Data Requests and Subscriptions","DATA_REQUEST_SIDEBAR_LABEL":"Data Requests & Subscriptions","LOGIN_REDIRECTS_TO_EPASS":false,"LOGIN_REDIRECTS_TO_ACTIVE_DIRECTORY":true,"LOGIN_ACTIVE_DIRECTORY_LINK":true,"FETCH_EDIT_USER_LINK":false,"LISTS_FETCH_AVAILABLE_LISTS":true,"POST_WIZARD_SUBMIT_REDIRECT_URL":"/","PIN_REQUEST_ATTESTATIONS":true,"PIN_REQUEST_DESCRIPTION":"Click **Request PIN** to have a new PIN sent to the account holder's email address on file.","OWNERSHIP_REQUEST_DESCRIPTION":"To become an **authorized user** of this record, a current **AUTHORIZED USER** will need to grant you access. To request access, click **Request Access** below.","PIN_REQUEST_SUCCESS_MESSAGE":"The PIN you have requested for this entity has been sent to the email associated with your user account.  You should receive the PIN in approximately 3-5 minutes, depending on your email service provider.","APOSTILLE_HEADER_LABEL":"Verification Information","APOSTILLE_NUMBER_LABEL":"Apostille/Authentication","APOSTILLE_CITY_STATE_OVERRIDE":"HELENA, MT","APOSTILLE_FILING_DATE_LABEL":"Issue Date","APOSTILLE_CITY_STATE_IN_CERTIFIED":true,"NOTARY_EXISTING_FILING":true,"ALLOW_REVOKE_OWN_ACCESS_ONLY":false,"HIDE_CANCEL_ON_ONETIME_DATA_REQUESTS":true,"DATA_REQUESTS_IN_SHOPPING_CART":true,"WQ_ALLOW_EDIT_PENDING_PAYMENT":true,"WQ_CONFIRM_ON_DELETE":true,"WQ_DELETE_CONFIRM_MESSAGE":"Deleting this filing will forfeit any money already paid to the Secretary of State. This action is permanent and cannot be undone, are you sure you would like to delete?","PASS_ITEM_GUIDS_ON_CHECKOUT":true,"FORM_REVISION_HISTORY":true,"CHECKOUT_DISCLAIMER":"By entering your credit card and/or checking account information you (i) state that **you are an authorized user** of the credit card and/or electronic check and that the associated information entered (e.g., account holder name, account number, billing address) is accurate, (ii) **you authorize payment processor to charge the amount you have requested** to your credit card and/or funding account, and (iii) **acknowledge if a charge is declined or reversed you may also be assessed a customary charge** by the payment processor for such transactions.","FARM_BILL_SEARCH_CONFIDENTIAL":"As a registered Farm Bill Buyer with the Montana Secretary of State’s office it is important to maintain the confidentiality of the information contained within the Farm Bill Master List. The Farm Bill Master List reflects personal data, such as Social Security Numbers, which are a key piece of personal identifiable information to assist you in determining the existence of a lien against a specific debtor. The distribution of this information beyond its intended purpose is strictly prohibited.\n\n**The debtor's tax identification number has been hidden for confidentiality reasons. You may continue to search on a tax ID number and return debtors that match your search criteria. The SSN/FEIN must be entered without dashes or spaces.  If you need access to the tax identification number to clearly identify the debtor, please contact the UCC unit at (406) 444-3665.**","VIEW_HISTORY_BUTTON_ALT_TEXT":"View Filings","WIZARD_ERROR_TITLE_MESSAGE":"Form Error","FARM_BILL_SEARCH_INTERACTIVE":true,"USE_FARM_BILL_API":true,"DISALLOW_ASSIGN_SELF_AS_RA":true,"DISALLOW_ASSIGN_SELF_AS_PRINCIPAL":true,"USE_TRADEMARK_OWNER_VALIDATION":true,"USE_ALTERNATIVE_FOREIGN_ADDRESS_LABELS":true,"MY_RECEIPTS_FILTER":[{"type":"dateRange","name":"DATE_RANGE","label":"Date range","defaultValue":{"start":null,"end":null}},{"type":"text","name":"REF_NUM","defaultValue":"","label":"Reference Number"},{"type":"text","name":"RECEIPT_NUM","defaultValue":"","label":"Receipt Id"},{"type":"text","name":"AMOUNT","defaultValue":"","label":"Amount"},{"type":"select","name":"TYPE","defaultValue":"","label":"Payment Type","options":[{"value":"","label":"All"},{"value":"CC","label":"Credit Card"},{"value":"Check","label":"Check"}]}],"MY_RECEIPTS_SHOW_IN_SIDEBAR":true,"SHOW_MY_RECEIPTS_HELPER_TEXT":true,"MY_RECEIPTS_HELPER_LABEL":"About Receipt Search","MY_RECEIPTS_HELPER_TEXT":"You can search for receipts based on their descriptions, including the items paid for on the receipt. Use the filters to search for or filter specific information.","FARM_BILL_SUBLINK":{"label":"Farm Bill","component":"FarmBill","parameter":"farm-bill","path":"/lists/farm-bill","sourceTypeId":0,"myRecordsSearch":false,"allowedRules":["/search/"],"disabled":true,"searchDescription":"To perform a search, enter a debtor name. Your search results may include: exact debtor name, variations of that name and any filing that includes your search criteria. Punctuation is ignored.\n\nYou can click on \"Advanced\" to refine your search. Under “Advanced” you can search by crop, year, county and SSN/FEIN. As a registered Farm Bill Buyer with the Montana Secretary of State’s office it is important to maintain the confidentiality of the information contained within the Farm Bill Master List. The Farm Bill Master List reflects personal data, such as Social Security Numbers, which are a key piece of personal identifiable information to assist you in determining the existence of a lien against a specific debtor. The distribution of this information beyond its intended purpose is strictly prohibited.\n\nThe debtor's tax identification number has been hidden for confidentiality reasons. You may continue to search on a tax ID number and return debtors that match your search criteria. The SSN/FEIN must be entered without dashes or spaces.","searchMustHaveOneOf":["search","UCC_FARM_PRODUCT_ID","COUNTY"],"searchPlaceholder":"Search by debtor name","advancedSearchParameters":[{"type":"ServerMultiComplete","label":"Product code name(s)","name":"UCC_FARM_PRODUCT_ID","defaultValue":"","optionsSrc":"UCC_FARM_PRODUCT_V"},{"type":"MultiComplete","label":"Year or Range of Years","name":"YEAR_NUM","optionsSrc":"years","startYear":"1968","defaultValue":[],"preMergeOptions":[{"value":"ALL","label":"All"}]},{"type":"serverSelect","label":"State","name":"STATE","defaultValue":"MONTANA","optionsSrc":"STATE"},{"type":"ServerMultiComplete","label":"County","name":"COUNTY","defaultValue":[],"optionsSrc":"COUNTY","overrideSubOptionsSrcFromParameterName":"STATE"},{"type":"checkbox","name":"TIN_SEARCH_YN","defaultValue":false,"label":"Tax Identification Number Search"},{"type":"checkbox","name":"TIN_SORT_YN","defaultValue":false,"label":"Unique ID Sort"}]},"ALLOW_ADDRESS_VALIDATION_BYPASS_OPTION":true,"DEFAULT_ADDRESS_VALIDATION_BYPASS_OPTION_CHECKED":true}).RA_MAILING_STATE_DISABLED && value.MAIL_ADDR.STATE !== newState) {
	                  callback(false, 'Provided ZIP code is not valid in the selected state of ' + value.MAIL_ADDR.STATE, payload);
	                }
	              }
	              if ((validateMailingAddress ? mailAddress.isValid : true) && (validatePrincipleAgainstAMS ? principleAddress.isValid : true)) {
	                callback(true, '', payload);
	              } else {
	                var messages = [];
	                //If these error messages change or become dynamic AddressBlock.js ShowAddressValidationBypass must be updated
	                if (validateMailingAddress && !mailAddress.isValid) {
	                  messages.push('Mailing address must be a valid address to continue.');
	                }
	                if (validatePrincipleAgainstAMS && !principleAddress.isValid) {
	                  messages.push('Street address must be a valid address to continue.');
	                }
	                callback(false, messages.join("\n"));
	              }
	            });
	          } else {
	            callback(false, 'A mailing address is required.');
	          }
	        } else {
	          callback(true, '');
	        }
	      };
	
	      if (isIndividual) {
	        if (hasInputAddress && hasInputFirstAndLastNames) {
	          validateMailAddressRA();
	        } else if (hasInputAddress && !hasInputFirstAndLastNames) {
	          callback(false, 'Please provide the first and last name of the registered agent to continue.');
	        } else if (!hasInputAddress && hasInputFirstAndLastNames) {
	          callback(false, props.errorMessage || 'Please provide the full address of the registered agent to continue.');
	        } else {
	          callback(false, 'Provide the name and address of the registered agent to continue.');
	        }
	      } else if (!isIndividual) {
	        if (hasInputAddress && hasSelectedOrganization) {
	          // VALIDATE.addressIsValid(
	          // 	value,
	          // 	field,
	          // 	props,
	          // 	(isValid, error, payload) => {
	          // 		//console.log('Got: ', isValid, error, payload);
	          // 		callback(isValid, error, payload);
	          // 	}
	          // );
	          validateMailAddressRA();
	        } else if (!hasInputAddress && hasSelectedOrganization) {
	          callback(false, props.errorMessage || 'Please provide the full address of the registered agent to continue');
	        } else if (hasInputAddress && !hasSelectedOrganization) {
	          callback(false, 'Please provide the name of the registered agent organization to continue.');
	        } else {
	          callback(false, 'Please provide the registered agent organization name and address to continue.');
	        }
	      }
	    } else if (value.CRA_ID !== '0' && value.CRA_ID !== 0) {
	      callback(true, '');
	    } else {
	      callback(true, '');
	    }
	  },
	  registeredAgentIsRequired: function registeredAgentIsRequired(value, field) {
	    var props = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	    var callback = arguments[3];
	
	    var isNonCommercial = value.TYPE_ID.toString() === '460';
	    var craId = value.CRA_ID.toString();
	    var hasSelectedRa = craId !== '0' && craId !== '' && craId;
	    var isIndividual = value.INDIVIDUAL_YN.toUpperCase() == 'Y';
	    var hasInputFirstAndLastNames = valueIsNotEmptyOrNull(value.FIRST_NAME) && valueIsNotEmptyOrNull(value.LAST_NAME);
	    var hasSelectedOrganization = value.ORGANIZATION ? value.ORGANIZATION.SOURCE_ID !== 0 && value.ORGANIZATION !== null : false;
	    var regex = /(.{1,}?)@(.{1,}?)\.(.{1,})/g;
	    var hasInputValidEmail =  true ? valueIsNotEmptyOrNull(value.EMAIL) && regex.test(value.EMAIL) : true;
	    var hasInputAddress = valueIsNotEmptyOrNull(getTrimmedValue(value.ADDR1)) && valueIsNotEmptyOrNull(getTrimmedValue(value.CITY)) && valueIsNotEmptyOrNull(getTrimmedValue(value.STATE)) && valueIsNotEmptyOrNull(getTrimmedValue(value.POSTAL_CODE));
	
	    var isValid = null;
	    var errorMessage = [];
	
	    var setCallback = function setCallback(valid, err) {
	      if (!valid) {
	        isValid = valid;
	        errorMessage.push(err);
	      } else if (isValid === null && valid === true) {
	        isValid = valid;
	      }
	    };
	
	    if (isNonCommercial) {
	      if (hasSelectedRa) {
	        setCallback(true, '');
	      } else if (!value.NEW && !value.SELECTED && !field.addingAgent) {
	        // this checks for a case the MT had where the user entered a new RA, but the NEW field was false which resulted in the image generated showing "No Agent"
	        setCallback(false, props.errorMessage || 'Select an existing registered agent or fill out the fields above to create a new registered agent before continuing.');
	      } else if (isIndividual) {
	        if (hasInputAddress && hasInputFirstAndLastNames && hasInputValidEmail) {
	          setCallback(true, '');
	        }
	        if (!hasInputAddress) {
	          setCallback(false, 'Please provide the full address of the registered agent to continue.');
	        }
	        if (!hasInputFirstAndLastNames) {
	          setCallback(false, 'Please provide the first and last names of the registered agent to continue.');
	        }
	        if (field.addingAgent && !hasInputValidEmail) {
	          setCallback(false, 'Input a valid email to continue.');
	        }
	      } else if (!isIndividual) {
	        if (hasInputAddress && hasSelectedOrganization && hasInputValidEmail) {
	          setCallback(true, '');
	        }
	        if (!hasInputAddress) {
	          setCallback(false, 'Please provide the full address of the registered agent to continue.');
	        }
	        if (!hasSelectedOrganization) {
	          setCallback(false, 'Please provide the name of the registered agent organization to continue.');
	        }
	        if (field.addingAgent && !hasInputValidEmail) {
	          setCallback(false, 'Input a valid email to continue.');
	        }
	      } else {
	        setCallback(false, props.errorMessage || 'Select an existing registered agent or fill out the fields above to create a new registered agent before continuing.');
	      }
	    } else {
	      if (hasSelectedRa) {
	        setCallback(true, '');
	      } else {
	        setCallback(false, props.errorMessage || 'Select a registered agent to continue.');
	      }
	    }
	    callback(isValid, errorMessage.join('\n'));
	  },
	  registeredAgentNotSoS: function registeredAgentNotSoS(value, field) {
	    var props = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	    var callback = arguments[3];
	
	    var craId = value.CRA_ID.toString();
	    if (craId === '1') {
	      callback(false, 'Secretary of State cannot be used as a registered agent. Select a different agent.');
	    } else {
	      callback(true, '');
	    }
	  },
	  noRegulatedWords: function noRegulatedWords(value, field) {
	    var props = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	    var callback = arguments[3];
	
	    //Test that a given value does not contain regulated words surrounded by whitespace.
	    var metadata = _store2.default.getState().wizard.wizard.meta;
	    var filingTypeIdSrcField = _store2.default.getState().wizard.wizard.fields[props.filingTypeId];
	    var filingTypeIdVal = filingTypeIdSrcField ? filingTypeIdSrcField.value : null;
	    var _metadata$FILING_TYPE = metadata.FILING_TYPE_ID,
	        FILING_TYPE_ID = _metadata$FILING_TYPE === undefined ? 0 : _metadata$FILING_TYPE;
	
	    var filingTypeId = filingTypeIdVal && filingTypeIdVal !== '0' ? filingTypeIdVal : FILING_TYPE_ID;
	    if (filingTypeId === 0) {
	      callback(false, 'Business rule failed because no FILING_TYPE_ID found in MetaData.');
	    } else if (value.val1 === '') {
	      callback(false, 'Please provide a name');
	    } else {
	      api.VALIDATE('RegulatedWords', {
	        FILING_NAME: typeof value.val1 === 'string' ? value.val1 : value,
	        FILING_TYPE_ID: filingTypeId
	      }, function (data) {
	        if (data.valid) {
	          callback(true, '');
	        } else {
	          callback(false, data.error);
	        }
	      });
	    }
	  },
	  hasNameEnding: function hasNameEnding(value, field) {
	    var props = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	    var callback = arguments[3];
	
	    //Tests that the given value contains the designation appropriate for the entity type. (LLC, LLP, CO, etc...)
	    var metadata = _store2.default.getState().wizard.wizard.meta;
	    var filingTypeIdSrcField = _store2.default.getState().wizard.wizard.fields[props.filingTypeId];
	    var filingTypeIdVal = filingTypeIdSrcField ? filingTypeIdSrcField.value : null;
	    var _metadata$FILING_TYPE2 = metadata.FILING_TYPE_ID,
	        FILING_TYPE_ID = _metadata$FILING_TYPE2 === undefined ? 0 : _metadata$FILING_TYPE2;
	
	    var filingTypeId = filingTypeIdVal && filingTypeIdVal !== '0' ? filingTypeIdVal : FILING_TYPE_ID;
	    if (filingTypeId === 0) {
	      callback(false, 'Business rule failed because no FILING_TYPE_ID found in MetaData.');
	    } else {
	      var payload = {};
	      if (typeof value.val1 === 'string') {
	        //If this is a confirm field
	        payload = { FILING_NAME: value.val1, FILING_TYPE_ID: filingTypeId };
	      } else {
	        payload = { FILING_NAME: value, FILING_TYPE_ID: filingTypeId };
	      }
	
	      if (payload.FILING_NAME === '' || payload.FILING_TYPE_ID === 0) {
	        callback(true, '');
	      } else {
	        api.VALIDATE('NameDesignation', payload, function (data) {
	          if (data.valid) {
	            callback(true, '');
	          } else {
	            callback(false, props.errorMessage ? props.errorMessage : data.error);
	          }
	        });
	      }
	    }
	  },
	  isValidName: function isValidName(value, field) {
	    var props = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	    var callback = arguments[3];
	
	    //Tests that the given value contains the designation appropriate for the entity type. (LLC, LLP, CO, etc...)
	    var metadata = _store2.default.getState().wizard.wizard.meta;
	    var filingTypeIdSrcField = _store2.default.getState().wizard.wizard.fields[props.filingTypeId];
	    var filingTypeIdVal = filingTypeIdSrcField ? filingTypeIdSrcField.value : null;
	    var _metadata$FILING_TYPE3 = metadata.FILING_TYPE_ID,
	        FILING_TYPE_ID = _metadata$FILING_TYPE3 === undefined ? 0 : _metadata$FILING_TYPE3;
	
	    var filingTypeId = filingTypeIdVal && filingTypeIdVal !== '0' ? filingTypeIdVal : FILING_TYPE_ID;
	    if (filingTypeId === 0) {
	      callback(false, 'Business rule failed because no FILING_TYPE_ID found in MetaData.');
	    } else {
	      var payload = {};
	      var subFilingTypeIdSrcField = _store2.default.getState().wizard.wizard.fields[props.filingSubtypeId];
	      var subFilingTypeIdVal = subFilingTypeIdSrcField ? subFilingTypeIdSrcField.value : null;
	      if (typeof value.val1 === 'string') {
	        //If this is a confirm field
	        payload = Object.assign({}, metadata, {
	          FILING_NAME: value.val1,
	          FIELD_NAME: field.name,
	          RESERVED_FILING_ID: value.reservedNameId,
	          FILING_TYPE_ID: filingTypeId,
	          FILING_SUBTYPE_ID: subFilingTypeIdVal || 0,
	          ADDITIONAL_MODE: field.hideAdditionalName ? null : value.additionalMode || null
	        });
	      } else {
	        payload = Object.assign({}, metadata, {
	          FILING_NAME: value,
	          FIELD_NAME: field.name,
	          RESERVED_FILING_ID: value.reservedNameId,
	          FILING_TYPE_ID: filingTypeId,
	          FILING_SUBTYPE_ID: props.filingSubtypeId || 0,
	          ADDITIONAL_MODE: field.hideAdditionalName ? null : value.additionalMode
	        });
	      }
	      if (payload.FILING_NAME === '' || payload.FILING_TYPE_ID === 0) {
	        callback(true, '', { infoMessage: '', requireSupportingDocument: false });
	      } else {
	        api.VALIDATE('ValidEntityName', payload, function (data) {
	          // if(data.payload){
	          // 	if(data.payload.INTERNAL_REVIEW_REQUIRED){
	          // 		store.dispatch({
	          // 			type: 'ADD_INTERNAL_REVIEW_REQUIRED',
	          // 			fieldId: field.fieldId
	          // 		})
	          // 	}else{
	          // 		store.dispatch({
	          // 			type: 'REMOVE_INTERNAL_REVIEW_REQUIRED',
	          // 			fieldId: field.fieldId
	          // 		})
	          // 	}
	          // }
	          if (data.valid) {
	            // console.log(data);
	            callback(true, '', {
	              infoMessage: data.payload.INFO_MESSAGE,
	              requireSupportingDocument: data.requireSupportingDocument === true ? 'Y' : 'N'
	            });
	          } else {
	            callback(false, props.errorMessage ? props.errorMessage : data.error, {
	              infoMessage: '',
	              requireSupportingDocument: data.requireSupportingDocument === true ? 'Y' : 'N'
	            });
	          }
	        });
	      }
	    }
	  },
	  repeaterMinRows: function repeaterMinRows(value, field) {
	    var props = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	    var callback = arguments[3];
	
	    var numRows = field.trackChanges ? value.filter(function (row) {
	      return row._statusId !== 3;
	    }).length : value.length;
	    if (numRows >= props.minRows) {
	      callback(true, '');
	    } else {
	      if (props.noRowsIsValid && numRows === 0) {
	        callback(null, '');
	      } else {
	        callback(false, props.errorMessage || 'You must add at least ' + props.minRows + ' ' + (props.minRows === 1 ? 'entry' : 'entries') + '.');
	      }
	    }
	  },
	  repeaterMaxRows: function repeaterMaxRows(value, field) {
	    var props = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	    var callback = arguments[3];
	
	    var numRows = field.trackChanges ? value.filter(function (row) {
	      return row._statusId !== 3;
	    }).length : value.length;
	    if (numRows <= props.maxRows) {
	      callback(true, '');
	    } else {
	      callback(false, props.errorMessage || 'You may not add more than ' + props.maxRows + ' entries.');
	    }
	  },
	  validateRepeaterFields: function validateRepeaterFields(value, field) {
	    var props = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	    var callback = arguments[3];
	
	    var fields = _store2.default.getState().wizard.wizard.fields;
	    var rowValids = value.map(function (row, rowIndex) {
	      var isExempt = props.skipDeletedRows ? row._statusId === 3 : false;
	      var template = field.template;
	
	      return new Promise(function (rowResolve) {
	        if (isExempt) {
	          rowResolve(template.map(function (fieldId) {
	            return { isValid: null, valids: [], errors: [], fieldId: fieldId };
	          }));
	        } else {
	          var cellValids = template.map(function (fieldId) {
	            var hydratedFields = (0, _utilities.getHydratedFields)(row, template, fields);
	            var field = (0, _store.resolveFieldLogic)(fields[fieldId], { fields: hydratedFields, currentRepeaterRowIndex: rowIndex });
	            var conditionsResolved = (0, _wizardUtilities.resolveFieldConditions)(field.conditions, hydratedFields, field.conditionsOperator);
	            if (conditionsResolved && field.active) {
	              return new Promise(function (resolve) {
	                loopThroughRules({
	                  businessRules: field.businessRules,
	                  value: row[fieldId],
	                  field: Object.assign({}, field, { value: row[fieldId] }),
	                  event: 'onAdvance',
	                  options: { currentRepeaterRowIndex: rowIndex }
	                }, function (validation) {
	                  resolve(Object.assign({}, validation, { fieldId: field.fieldId }));
	                });
	              });
	            }
	            return null;
	          }).filter(function (x) {
	            return x;
	          });
	          Promise.all(cellValids).then(function (valids) {
	            rowResolve(valids);
	          });
	        }
	      });
	    });
	    Promise.all(rowValids).then(function (valids) {
	      var fullValids = valids.map(function (row) {
	        return row.reduce(function (obj, cell) {
	          return Object.assign({}, obj, {
	            rowValid: obj.rowValid === false ? false : !cell.valids.includes(false),
	            cellValids: Object.assign({}, obj.cellValids, _defineProperty({}, cell.fieldId, {
	              isValid: cell.valids.every(function (valid) {
	                return valid !== false;
	              }),
	              errors: cell.errors
	            }))
	          });
	        }, { rowValid: true, cellValids: {} });
	      });
	      var allRowsValid = fullValids.every(function (row) {
	        return row.rowValid;
	      });
	      if (allRowsValid) {
	        callback(true, '', { rowErrors: null });
	      } else {
	        callback(false, 'Please review your entries for errors.', { rowErrors: fullValids });
	      }
	    });
	  },
	  validateThirdPartySignaturesRepeater: function validateThirdPartySignaturesRepeater(value, field) {
	    var props = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	    var callback = arguments[3];
	
	    if (value.method === 'signer') {
	      VALIDATE.validateRepeaterFields(value.signers || [], field, props, callback);
	    } else {
	      callback(null, '');
	    }
	  },
	  nameNotTaken: function nameNotTaken(value, field) {
	    var props = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	    var callback = arguments[3];
	
	    if (value.val1 === '') {
	      callback(true, '', { infoMessage: '', requireSupportingDocument: false });
	    } else {
	      var RECORD_NUM = (0, _utilities.getCurrentWizardAmendmentNum)();
	      var RECORD_ID = field.allowReservedNameEditing ? value.reservedNameId : 0;
	      var filingTypeIdSrcField = _store2.default.getState().wizard.wizard.fields[props.filingTypeId];
	      var metadata = _store2.default.getState().wizard.wizard.meta;
	      var _metadata = metadata,
	          _metadata$FILING_TYPE4 = _metadata.FILING_TYPE_ID,
	          defaultFilingTypeId = _metadata$FILING_TYPE4 === undefined ? 0 : _metadata$FILING_TYPE4;
	
	      var FILING_TYPE_ID = filingTypeIdSrcField ? filingTypeIdSrcField.value : defaultFilingTypeId;
	      if (_store2.default.getState().wizard.wizard.category === "trademark" && (true)) {
	        var TRADEMARK_NAME = value.val1;
	        metadata = Object.assign({}, metadata, { TRADEMARK_NAME: TRADEMARK_NAME });
	        _store2.default.dispatch((0, _WizardActions.updateWizardMeta)(metadata));
	
	        var applicantTypeID = _store2.default.getState().wizard.wizard.fields[metadata.APPLICANT_TYPE_ID_FIELD].value || "0";
	        var trademarkApplicantSelectedOwner = _store2.default.getState().wizard.wizard.fields[metadata.SELECTED_OWNER_NAME_FIELD].value;
	        var trademarkApplicantFilingID = trademarkApplicantSelectedOwner ? trademarkApplicantSelectedOwner.SOURCE_ID : "0";
	        var trademarkApplicantFilingTypeID = trademarkApplicantSelectedOwner ? trademarkApplicantSelectedOwner.FILING_TYPE_ID : "0";
	        var serviceMarkYN = _store2.default.getState().wizard.wizard.fields[metadata.SERVICE_MARK_YN_FIELD].value;
	
	        if (applicantTypeID !== "0") {
	          metadata = Object.assign({}, metadata, { TRADEMARK_APPLICANT_TYPE_ID: applicantTypeID });
	          _store2.default.dispatch((0, _WizardActions.updateWizardMeta)(metadata));
	        }
	        if (applicantTypeID === "818" && trademarkApplicantFilingID !== "0") {
	          metadata = Object.assign({}, metadata, { TRADEMARK_APPLICANT_FILING_ID: trademarkApplicantFilingID });
	          _store2.default.dispatch((0, _WizardActions.updateWizardMeta)(metadata));
	        }
	        if (applicantTypeID === "818" && trademarkApplicantFilingTypeID !== "0") {
	          metadata = Object.assign({}, metadata, { TRADEMARK_APPLICANT_FILING_TYPE_ID: trademarkApplicantFilingTypeID });
	          _store2.default.dispatch((0, _WizardActions.updateWizardMeta)(metadata));
	        }
	        if (serviceMarkYN) {
	          metadata = Object.assign({}, metadata, { SERVICE_MARK_YN: serviceMarkYN });
	          _store2.default.dispatch((0, _WizardActions.updateWizardMeta)(metadata));
	        }
	      }
	      var payload = Object.assign({}, metadata, {
	        FILING_NAME: value.val1,
	        RESERVED_FILING_ID: value.reservedNameId,
	        RECORD_NUM: RECORD_NUM === 0 ? '' : RECORD_NUM,
	        RECORD_ID: RECORD_ID,
	        FIELD_NAME: field.name,
	        CORRECTION_YN: _store2.default.getState().wizard.correctionMode,
	        FILING_TYPE_ID: FILING_TYPE_ID
	      });
	
	      if (true) {
	        var state = _store2.default.getState();
	        var fields = state.wizard.wizard.fields;
	        var foreignNameField = Object.values(fields).find(function (f) {
	          return f.name === ("KIMA_PARENT_NAME_INFO");
	        });
	        if (foreignNameField) {
	          payload["FOREIGN_NAME"] = foreignNameField.value.val1;
	        }
	      }
	
	      api.VALIDATE('NameLookup', payload, function (data) {
	        if (data.valid) {
	          callback(true, '', {
	            infoMessage: data.payload.INFO_MESSAGE,
	            requireSupportingDocument: data.requireSupportingDocument === true ? 'Y' : 'N'
	          });
	        } else {
	          callback(false, props.errorMessage ? props.errorMessage : data.error, {
	            infoMessage: '',
	            requireSupportingDocument: data.requireSupportingDocument === true ? 'Y' : 'N'
	          });
	        }
	      });
	    }
	  },
	  nameRequired: function nameRequired(value, field) {
	    var props = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	    var callback = arguments[3];
	
	    if ((valueIsNotEmptyOrNull(value.FIRST_NAME) || props.onlyLastNameRequired) && valueIsNotEmptyOrNull(value.LAST_NAME)) {
	      callback(true, '');
	    } else {
	      callback(false, props.errorMessage !== '' ? props.errorMessage : props.onlyLastNameRequired ? 'Last name is required.' : 'First and last name are required.');
	    }
	  },
	  nameOrgRequired: function nameOrgRequired(value, field) {
	    var props = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	    var callback = arguments[3];
	
	    var isOrganization = field.type === 'NameQualifiedOrg' ? value.ORG_TYPE.toString() === '2' : value.ORG_YN;
	    if (isOrganization) {
	      if (valueIsNotEmptyOrNull(value.ORG_NAME)) {
	        callback(true, '');
	      } else {
	        callback(false, 'Organization is required');
	      }
	    } else {
	      VALIDATE['nameRequired'](value, field, props, function (isValid, error) {
	        callback(isValid, error);
	      });
	    }
	  },
	  nameQualifiedOrgRequired: function nameQualifiedOrgRequired(value, field) {
	    var props = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	    var callback = arguments[3];
	
	    if (value.ORG_TYPE.toString() === '1') {
	      if (value.SELECTED) {
	        callback(true, '');
	      } else {
	        callback(false, 'An item from the search must be selected');
	      }
	    } else {
	      VALIDATE['nameOrgRequired'](value, field, props, function (isValid, error) {
	        callback(isValid, error);
	      });
	    }
	  },
	  searchItemRequired: function searchItemRequired(value, field) {
	    var props = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	    var callback = arguments[3];
	
	    if (field.multiSelect ? value.length : value) {
	      callback(true, '');
	    } else {
	      callback(false, props.errorMessage || 'An item from the search must be selected');
	    }
	  },
	  validFeinNum: function validFeinNum(value, field) {
	    var props = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	    var callback = arguments[3];
	
	    if (!valueIsNotEmptyOrNull(value)) {
	      callback(null, '');
	    } else {
	      var isValidFein = /^(0[1-9]|[1-9]\d)-\d{7}$/.test(value) && value.length === 10;
	      if (isValidFein) {
	        callback(true, '');
	      } else {
	        callback(false, props.errorMessage !== '' ? props.errorMessage : 'Please provide a properly formatted FEIN number to continue.');
	      }
	    }
	  },
	  validPhoneNumber: function validPhoneNumber(value, field) {
	    var props = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	    var callback = arguments[3];
	
	    var isValidPhoneNumber = /\([2-9]\d{2}\) [2-9]\d{2}-\d{4}/.test(value) && value.length === 14;
	    if (isValidPhoneNumber) {
	      callback(true, '');
	    } else {
	      callback(false, props.errorMessage !== '' ? props.errorMessage : 'Provide a valid 10-digit phone number to continue.');
	    }
	  },
	  validPhoneNumberIfPresent: function validPhoneNumberIfPresent(value, field) {
	    var props = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	    var callback = arguments[3];
	
	    if (value && typeof value === 'string' && value.length > 0) {
	      var isValidPhoneNumber = /\([2-9]\d{2}\) [2-9]\d{2}-\d{4}/.test(value) && value.length === 14;
	      if (isValidPhoneNumber) {
	        callback(true, '');
	      } else {
	        callback(false, props.errorMessage !== '' ? props.errorMessage : 'Provide a valid 10-digit phone number to continue.');
	      }
	    } else {
	      callback(null, '');
	    }
	  },
	  enforceMaxDaysAfterToday: function enforceMaxDaysAfterToday(value, field) {
	    var props = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	    var callback = arguments[3];
	
	    if (field.maxAfterToday === '' || value === null || value === '') {
	      callback(null, '');
	    } else {
	      var date = (0, _startOfDay2.default)(new Date(value));
	      var today = void 0;
	      var stateTimeZone = ({"NODE_ENV":"production","BUILD_DATE":"2025-08-27T15:15:31.687Z","BUILD_NUMBER":"Not Provided","GIT_VERSION":"v1.3.0-381-ga81e29b08","GIT_COMMIT_HASH":"a81e29b085c9268ffd96c78eb734365802722741","GIT_BRANCH":"beta","PUBLIC_URL":"","STATE_ABBR":"MT","STATE_NAME":"Montana","STATE_ORG_TITLE":"Secretary of State","LOGIN_HEADER_IMG_PATH":"","HOME_IMG_FILENAME":"montana.jpg","FAVICON_FILE_NAME":"favicon.ico","ALLOW_E_SIGN_ON_CORRECTIONS":true,"THIRD_PARTY_SIGNING_ALLOWED":false,"MY_ACCOUNT_SAVE_AND_CLOSE_BUTTON":true,"IE_DEPRECATED_MESSAGE":"Internet Explorer is not supported. Please select a supported browser below to access this website.","ADDITIONAL_ROUTES":{"dataRequests":true,"farmBill":true,"apostille":true,"externalHelp":"https://sosmt.gov/business/help-center/","systemAdministration":[{"title":"Saved Payments","parameter":"saved-payments","componentName":"SavedPayments"}]},"SUBROUTES":[{"label":"Business","component":"Business","parameter":"business","myWorkQueueSearch":false,"sourceTypeId":54,"searchMustHaveOneOf":["FILING_TYPE_ID","STATUS_ID","STATE","search"],"serverWebSearchDescription":true,"serverWorkQueueDescription":true,"serverMyRecordsDescription":true,"searchPlaceholder":"Search by name or filing number (X########)","allowEmptySearchTerm":true,"requestCertificateAlternateLabel":"Request Information","fileAmendmentButtonLabel":"Filing Actions","advancedSearchParameters":[{"type":"radio","name":"QUERY_TYPE_ID","defaultValue":1010,"options":[{"value":1010,"label":"Starts with"},{"value":1011,"label":"Contains"},{"value":1012,"label":" Word Contains"}]},{"type":"serverSelect","name":"FILING_TYPE_ID","optionsSrc":"FILING_TYPES","label":"Entity Type","placeholder":"All","defaultValue":"0"},{"type":"serverSelect","name":"FILING_SUBTYPE_ID","optionsSrc":"FILING_SUBTYPES","label":"Entity Subtype","overrideSubOptionsSrcFromParameterName":"FILING_TYPE_ID","placeholder":"All","defaultValue":"0"},{"type":"serverSelect","name":"STATUS_ID","optionsSrc":"FILING_STATUS_WITHOUT_ALL","label":"Status","placeholder":"All","defaultValue":"0"},{"type":"serverSelect","name":"STATE","optionsSrc":"STATE","label":"State","placeholder":"All","defaultValue":""},{"type":"serverSelect","name":"COUNTY","optionsSrc":"COUNTY_SUBOPTION","label":"County","overrideSubOptionsSrcFromParameterName":"STATE","placeholder":"All","defaultValue":""},{"type":"checkbox","name":"CRA_SEARCH_YN","defaultValue":false,"label":"Search by Registered Agent PID"},{"type":"dateRange","name":"FILING_DATE","label":"Registration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}},{"type":"dateRange","name":"EXPIRATION_DATE","label":"Expiration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}}],"myRecordsFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Active"},{"value":2,"label":"Inactive"},{"value":3,"label":"Pending"}]},{"type":"dateRange","name":"DATE_RANGE","label":"Date range","defaultValue":{"start":null,"end":null}}],"myWorkQueueFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Approved"},{"value":2,"label":"Pending Online Payment"},{"value":3,"label":"Pending Review"},{"value":4,"label":"Needs Correction"},{"value":5,"label":"Rejected"},{"value":6,"label":"Draft"}]},{"type":"dateRange","name":"DATE_RANGE","label":"Date range","defaultValue":{"start":null,"end":null}}]},{"label":"Notary","component":"Notary","parameter":"notary","sourceTypeId":850,"myWorkQueueSearch":false,"allowEmptySearchTerm":true,"requestCertificateAlternateLabel":"Download Certificate","fileAmendmentButtonLabel":"Filing Actions","hideNameRequestCertificate":true,"hideAddressRequestCertificate":true,"hideRecordUserManagment":true,"searchPlaceholder":"Search by name or commission number","searchMustHaveOneOf":["CITY","search","SERVICE_TYPE"],"advancedParametersStartOpen":true,"searchIsSortable":true,"advancedSearchParameters":[{"type":"radio","name":"STARTS_WITH_YN","defaultValue":false,"options":[{"value":true,"label":"Starts with"},{"value":false,"label":"Contains"}]},{"type":"checkbox","name":"ACTIVE_ONLY_YN","defaultValue":true,"label":"Active entities only"},{"type":"text","name":"CITY","defaultValue":"","label":"City"},{"type":"select","name":"SERVICE_TYPE","label":"Special Services Offered","defaultValue":0,"options":[{"value":0,"label":"(N/A)"},{"value":6165,"label":"In-Person Electronic Notarization (IPEN)"},{"value":6166,"label":"Remote Online Notarization (RON)"},{"value":6167,"label":"Mobile Notary Services"},{"value":6168,"label":"Remote Ink Notarization (RIN)"}]}]},{"label":"Apostille","component":"Apostille","parameter":"apostille","sourceTypeId":720,"myRecordsSearch":false,"myWorkQueueSearch":false,"disabled":false,"allowedRoutes":["/forms-manager/","/queue/","/forms/"]},{"label":"Liens","component":"UCC","parameter":"ucc","sourceTypeId":1999,"myRecordsSearch":true,"myWorkQueueSearch":true,"fileAmendmentButtonLabel":"Filing Actions","searchPlaceholder":"Search by name or file number","disabled":false,"serverWebSearchDescription":true,"myRecordsDescription":"","workQueueDescription":"","searchDescription":"","hideRecordUserManagment":true,"searchLiensCheckout":false,"advancedSearchParameters":[{"type":"radio","name":"STARTS_WITH_YN","defaultValue":false,"options":[{"value":true,"label":"Starts with"},{"value":false,"label":"Contains"}]},{"type":"select","name":"STATUS","defaultValue":"ALL","label":"Status","options":[{"value":"ACTIVE_UNLAPSED","label":"Active (unlapsed)"},{"value":"ACTIVE_LAPSED_UNLAPSED","label":"Active (lapsed and unlapsed)"}]},{"type":"text","name":"EXCLUDE_VALUES","label":"Exclude Debtor Names (comma separated list of names to exclude)","defaultValue":""},{"type":"dateRange","name":"FILING_DATE","label":"Financing Statement Date","defaultValue":{"start":null,"end":null}},{"type":"dateRange","name":"LAPSE_DATE","label":"Lapse Date","defaultValue":{"start":null,"end":null}},{"type":"text","name":"CITY","label":"Debtor City","defaultValue":""}],"myRecordsFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Approved"},{"value":2,"label":"Pending Online Payment"},{"value":3,"label":"Pending Review"}]},{"type":"select","name":"TYPE","defaultValue":0,"label":"Lien Type","options":[{"value":0,"label":"All"},{"value":1,"label":"UCC"},{"value":2,"label":"EFS"},{"value":3,"label":"Title 71"}]}],"myWorkQueueFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Approved"},{"value":2,"label":"Pending Online Payment"},{"value":3,"label":"Pending Review"},{"value":4,"label":"Pending Print and Mail"},{"value":5,"label":"Rejected"},{"value":6,"label":"Draft"}]},{"type":"select","name":"TYPE","defaultValue":0,"label":"Lien Type","options":[{"value":0,"label":"All"},{"value":1,"label":"UCC"},{"value":2,"label":"EFS"},{"value":3,"label":"Title 71"}]}]},{"label":"Copy Request","component":"copies","parameter":"copies","sourceTypeId":2001,"myRecordsSearch":false,"myWorkQueueSearch":false,"disabled":false,"allowedRoutes":["/forms-manager/","/queue/","/forms/"]},{"label":"Trademark","component":"Trademark","parameter":"trademark","sourceTypeId":810,"showRequestCertificate":true,"searchMustHaveOneOf":["search","EXPIRATION_DATE","FILING_DATE"],"allowEmptySearchTerm":true,"requestCertificateAlternateLabel":"Request Information","fileAmendmentButtonLabel":"Filing Actions","advancedSearchParameters":[{"type":"radio","name":"QUERY_TYPE_ID","defaultValue":1010,"options":[{"value":1010,"label":"Starts with"},{"value":1011,"label":"Contains"},{"value":1012,"label":" Word Contains"}]},{"type":"checkbox","name":"OWNER_SEARCH_YN","defaultValue":false,"label":"Search owners"},{"type":"radio","name":"SERVICE_MARK_YN","label":"Mark Type","defaultValue":"","options":[{"value":"","label":"All Marks"},{"value":"Y","label":"Service Mark"},{"value":"N","label":"Trademark"}]},{"type":"serverSelect","name":"STATUS_ID","optionsSrc":"TYPE_V|TRADEMARK_STATUS_TYPE","label":"Status","placeholder":"All","defaultValue":"0"},{"type":"select","name":"DESIGN_TYPE_ID","options":[{"value":0,"label":"All"},{"value":990,"label":"Words Only"},{"value":991,"label":"Design Only"},{"value":992,"label":"Words and Design"}],"label":"Design Type","defaultValue":"0"},{"type":"dateRange","name":"FILING_DATE","label":"Registered Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}},{"type":"dateRange","name":"EXPIRATION_DATE","label":"Expiration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}}]},{"label":"Business Info Request","component":"InfoRequests","parameter":"info-request","sourceTypeId":167,"allowedRoutes":["/forms-manager/","/queue/","/forms/"]},{"label":"Data Requests","component":"DataRequests","parameter":"data-request","sourceTypeId":0,"allowedRoutes":["/forms-manager/"]},{"label":"CRA","component":"CRA","parameter":"cra","sourceTypeId":157,"myRecordsSearch":false,"searchPlaceholder":"Search by name or registered agent number","allowedRoutes":["/forms-manager/","/forms/","/records/","/queue/","/search/"],"allowEmptySearchTerm":true,"fileAmendmentButtonLabel":"Filing Actions","advancedSearchParameters":[{"type":"radio","name":"QUERY_TYPE_ID","defaultValue":1010,"options":[{"value":1010,"label":"Starts with"},{"value":1011,"label":"Contains"},{"value":1012,"label":" Word Contains"}]},{"type":"dateRange","name":"CRA_DATE","label":"Registration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}},{"type":"select","name":"STATUS_ID","label":"Status","defaultValue":0,"options":[{"value":0,"label":"All"},{"value":121,"label":"Active"},{"value":122,"label":"Inactive"}]},{"type":"select","name":"AGENT_TYPE_ID","label":"Agent Type","defaultValue":0,"options":[{"value":0,"label":"All"},{"value":460,"label":"Registered Agent"},{"value":461,"label":"Commercial Registered Agent"}]}]},{"label":"Farm Bill","component":"FarmBill","parameter":"farm-bill","path":"/lists/farm-bill","sourceTypeId":0,"myRecordsSearch":false,"allowedRules":["/search/"],"disabled":true,"searchDescription":"To perform a search, enter a debtor name. Your search results may include: exact debtor name, variations of that name and any filing that includes your search criteria. Punctuation is ignored.\n\nYou can click on \"Advanced\" to refine your search. Under “Advanced” you can search by crop, year, county and SSN/FEIN. As a registered Farm Bill Buyer with the Montana Secretary of State’s office it is important to maintain the confidentiality of the information contained within the Farm Bill Master List. The Farm Bill Master List reflects personal data, such as Social Security Numbers, which are a key piece of personal identifiable information to assist you in determining the existence of a lien against a specific debtor. The distribution of this information beyond its intended purpose is strictly prohibited.\n\nThe debtor's tax identification number has been hidden for confidentiality reasons. You may continue to search on a tax ID number and return debtors that match your search criteria. The SSN/FEIN must be entered without dashes or spaces.","searchMustHaveOneOf":["search","UCC_FARM_PRODUCT_ID","COUNTY"],"searchPlaceholder":"Search by debtor name","advancedSearchParameters":[{"type":"ServerMultiComplete","label":"Product code name(s)","name":"UCC_FARM_PRODUCT_ID","defaultValue":"","optionsSrc":"UCC_FARM_PRODUCT_V"},{"type":"MultiComplete","label":"Year or Range of Years","name":"YEAR_NUM","optionsSrc":"years","startYear":"1968","defaultValue":[],"preMergeOptions":[{"value":"ALL","label":"All"}]},{"type":"serverSelect","label":"State","name":"STATE","defaultValue":"MONTANA","optionsSrc":"STATE"},{"type":"ServerMultiComplete","label":"County","name":"COUNTY","defaultValue":[],"optionsSrc":"COUNTY","overrideSubOptionsSrcFromParameterName":"STATE"},{"type":"checkbox","name":"TIN_SEARCH_YN","defaultValue":false,"label":"Tax Identification Number Search"},{"type":"checkbox","name":"TIN_SORT_YN","defaultValue":false,"label":"Unique ID Sort"}]}],"SYSTEM_NICKNAME":"Online Services Portal","PAYMENT_METHODS":[{"type":"bypass"},{"type":"iTransact"}],"PAYMENT_ALLOW_AMEX":true,"SYSTEM_ID_LABEL":"System Id","DOUBLE_COLUMN_PUBLIC_LOGIN":true,"INTERNAL_USER_MANAGEMENT":true,"ALLOW_PUBLIC_JSON_IMPORT":false,"MAX_FILE_UPLOAD_SIZE":10000000,"REFUND_TEXT":"","RETURN_TO_HOME_ON_LOGOUT":true,"CURRENT_SOS_NAME":"Christi Jacobsen","LOGO_FILENAME":"mt-sos-logo.png","LOGO_ALT":"Christi Jacobsen, Montana Secretary of State","LOGO_FULL_WIDTH":true,"HOME_HIDE_AUTH_HINT":true,"HOME_TITLE":"Montana Secretary of State","CUSTOM_TAB_TITLE":"Official Montana","HOME_SUBTITLE":"Online Business Services","ENTITY_NAME_CONSENT_DESCRIPTION":"","ALLOW_USER_PROFILE_EDITING":true,"COMPARE_FOREIGN_NAME_IN_ENTITY_NAME_VALIDATION":true,"FOREIGN_NAME_FIELD_NAME":"KIMA_PARENT_NAME_INFO","LOGIN_TITLE":"Montana Secretary of State Online Filing Portal Login","PUBLIC_LOGIN_LABEL":"Username","REVERSE_LOGIN_COLUMNS":true,"LOGIN_SEAL_FILENAME":"seal_white.png","SEPARATE_USERNAME_AND_EMAIL":true,"CREATE_ACCOUNT_BUTTON_ALIGN_LEFT":true,"CREATE_ACCOUNT_BUTTON_TEXT":"CREATE AN ACCOUNT","PASSWORD_CUSTOM_ERROR_TEXT":"The password must meet all requirements","ACCOUNT_CREATED_MESSAGE":"Please check your email to verify your account to login and allow a few minutes for this message to arrive. Check your junk/spam folders if you do not find the email in your inbox.","PUBLIC_LOGIN_PLACEHOLDER":" ","DISABLE_DEFAULT_PAYMENT_RADIO":true,"CUSTOM_RESET_PASSWORD_ERROR_MESSAGE":"Username invalid - no account found","PUBLIC_LOGIN_CREATE_DESCRIPTION":"### Existing User:\n\n  - Enter your username and password to login.  \n\n\n  #### - OR -  \n\n\n\n  - Forgot password? Click 'Reset Password' and follow the prompts.\n  - Forgot username? Click 'Forgot Username' and follow the prompts.  \n\n\n  ### New User:\n  ","LOGIN_HELP_LINK":"https://sosmt.gov/business/how-do-i/","LOGIN_HELP_LINK_TEXT":"Need Help?","FORGOT_USERNAME_TEXT":"Forgot Username?","LOGIN_ACTIVE_DIRECTORY_TEXT":"State User Login","MULTIPLE_LOGIN_METHODS":true,"HAS_ACTIVE_DIRECTORY_LOGIN":true,"RESET_PASSWORD_WITH_USERNAME":true,"DOWNLOAD_LINK":true,"SHOW_USERNAME_ACCOUNT_CREATE":true,"SHOW_SCROLL_DOWN_ARROW":true,"SHOW_ADDRESS_ACCOUNT_CREATE":true,"TWO_COLUMN_ACCOUNT_CREATE":true,"RESET_PASSWORD_TIP":"A link to change your password has been sent to your email. Please allow a few minutes for this message to arrive. Please check your junk/spam folders if you do not find the email in your inbox.","FORGOT_PASSWORD_LINK_TEXT":"Reset Password","PHONE_NUMBER_OPTIONAL_ACCOUNT_CREATE":true,"SHOW_REQUIRED_INDICATOR_ACCOUNT_CREATE":true,"PASSWORD_REQUIREMENTS_ACCOUNT_CREATE":"\n    <ul>\n      <li>MUST contain at least 8 characters (12+ recommended)</li>\n      <li>MUST contain at least one uppercase letter.</li>\n      <li>MUST contain at least one lowercase letter.</li>\n      <li>MUST contain at least one number.</li>\n      <li>MUST contain at least one special character (!”#$%&'()*+,-./:;<=>?</li>\n    </ul>\n  ","ALLOW_CERTIFICATION_REQUEST":true,"ALLOW_PUBLIC_CERTIFICATE_REQUEST":true,"ALLOW_COPY_REQUEST":false,"ALLOW_CORRECTION_STYLING":true,"HIDE_DEPRECATION_WARNING":false,"AMEND_ROUTE_PUBLIC":true,"SEAL_FILENAME":"seal.png","SHOPPING_CART":true,"ALLOW_PAYMENT_UPDATE_WITH_EMPTY_CART":true,"RA_EMAIL":true,"RA_WEBSITE":true,"RA_NO_DEFAULT_TYPE":true,"RA_ADDRESS_LABEL":"Street Address","RA_TYPE_SELECTION_DEFAULT":true,"RA_DEFAULT_TYPE":"460","RA_OVERRIDE_TYPE_WITH_DEFAULT":true,"RA_PRINCIPAL_ADDRESS_AMS":true,"UPLOAD_AND_SUBMIT_HIDE_IF_ONE_OPTION":true,"PAYMENT_PROCESSING_MESSAGE":"Your payment is processing - Do not close your browser or click the back button","CHECKOUT_BUTTON_WHEN_PROCESSING_TEXT":"Processing","EFS_CROP_PICKER_NONE_LABEL":"Lien Duration","DISALLOWED_WIZARD_PIECES":["FormationLocale"],"REPEATER_SHOW_EDIT_BUTTON":true,"DATA_REQUEST_PAGE_TITLE":"Data Requests and Subscriptions","DATA_REQUEST_SIDEBAR_LABEL":"Data Requests & Subscriptions","LOGIN_REDIRECTS_TO_EPASS":false,"LOGIN_REDIRECTS_TO_ACTIVE_DIRECTORY":true,"LOGIN_ACTIVE_DIRECTORY_LINK":true,"FETCH_EDIT_USER_LINK":false,"LISTS_FETCH_AVAILABLE_LISTS":true,"POST_WIZARD_SUBMIT_REDIRECT_URL":"/","PIN_REQUEST_ATTESTATIONS":true,"PIN_REQUEST_DESCRIPTION":"Click **Request PIN** to have a new PIN sent to the account holder's email address on file.","OWNERSHIP_REQUEST_DESCRIPTION":"To become an **authorized user** of this record, a current **AUTHORIZED USER** will need to grant you access. To request access, click **Request Access** below.","PIN_REQUEST_SUCCESS_MESSAGE":"The PIN you have requested for this entity has been sent to the email associated with your user account.  You should receive the PIN in approximately 3-5 minutes, depending on your email service provider.","APOSTILLE_HEADER_LABEL":"Verification Information","APOSTILLE_NUMBER_LABEL":"Apostille/Authentication","APOSTILLE_CITY_STATE_OVERRIDE":"HELENA, MT","APOSTILLE_FILING_DATE_LABEL":"Issue Date","APOSTILLE_CITY_STATE_IN_CERTIFIED":true,"NOTARY_EXISTING_FILING":true,"ALLOW_REVOKE_OWN_ACCESS_ONLY":false,"HIDE_CANCEL_ON_ONETIME_DATA_REQUESTS":true,"DATA_REQUESTS_IN_SHOPPING_CART":true,"WQ_ALLOW_EDIT_PENDING_PAYMENT":true,"WQ_CONFIRM_ON_DELETE":true,"WQ_DELETE_CONFIRM_MESSAGE":"Deleting this filing will forfeit any money already paid to the Secretary of State. This action is permanent and cannot be undone, are you sure you would like to delete?","PASS_ITEM_GUIDS_ON_CHECKOUT":true,"FORM_REVISION_HISTORY":true,"CHECKOUT_DISCLAIMER":"By entering your credit card and/or checking account information you (i) state that **you are an authorized user** of the credit card and/or electronic check and that the associated information entered (e.g., account holder name, account number, billing address) is accurate, (ii) **you authorize payment processor to charge the amount you have requested** to your credit card and/or funding account, and (iii) **acknowledge if a charge is declined or reversed you may also be assessed a customary charge** by the payment processor for such transactions.","FARM_BILL_SEARCH_CONFIDENTIAL":"As a registered Farm Bill Buyer with the Montana Secretary of State’s office it is important to maintain the confidentiality of the information contained within the Farm Bill Master List. The Farm Bill Master List reflects personal data, such as Social Security Numbers, which are a key piece of personal identifiable information to assist you in determining the existence of a lien against a specific debtor. The distribution of this information beyond its intended purpose is strictly prohibited.\n\n**The debtor's tax identification number has been hidden for confidentiality reasons. You may continue to search on a tax ID number and return debtors that match your search criteria. The SSN/FEIN must be entered without dashes or spaces.  If you need access to the tax identification number to clearly identify the debtor, please contact the UCC unit at (406) 444-3665.**","VIEW_HISTORY_BUTTON_ALT_TEXT":"View Filings","WIZARD_ERROR_TITLE_MESSAGE":"Form Error","FARM_BILL_SEARCH_INTERACTIVE":true,"USE_FARM_BILL_API":true,"DISALLOW_ASSIGN_SELF_AS_RA":true,"DISALLOW_ASSIGN_SELF_AS_PRINCIPAL":true,"USE_TRADEMARK_OWNER_VALIDATION":true,"USE_ALTERNATIVE_FOREIGN_ADDRESS_LABELS":true,"MY_RECEIPTS_FILTER":[{"type":"dateRange","name":"DATE_RANGE","label":"Date range","defaultValue":{"start":null,"end":null}},{"type":"text","name":"REF_NUM","defaultValue":"","label":"Reference Number"},{"type":"text","name":"RECEIPT_NUM","defaultValue":"","label":"Receipt Id"},{"type":"text","name":"AMOUNT","defaultValue":"","label":"Amount"},{"type":"select","name":"TYPE","defaultValue":"","label":"Payment Type","options":[{"value":"","label":"All"},{"value":"CC","label":"Credit Card"},{"value":"Check","label":"Check"}]}],"MY_RECEIPTS_SHOW_IN_SIDEBAR":true,"SHOW_MY_RECEIPTS_HELPER_TEXT":true,"MY_RECEIPTS_HELPER_LABEL":"About Receipt Search","MY_RECEIPTS_HELPER_TEXT":"You can search for receipts based on their descriptions, including the items paid for on the receipt. Use the filters to search for or filter specific information.","FARM_BILL_SUBLINK":{"label":"Farm Bill","component":"FarmBill","parameter":"farm-bill","path":"/lists/farm-bill","sourceTypeId":0,"myRecordsSearch":false,"allowedRules":["/search/"],"disabled":true,"searchDescription":"To perform a search, enter a debtor name. Your search results may include: exact debtor name, variations of that name and any filing that includes your search criteria. Punctuation is ignored.\n\nYou can click on \"Advanced\" to refine your search. Under “Advanced” you can search by crop, year, county and SSN/FEIN. As a registered Farm Bill Buyer with the Montana Secretary of State’s office it is important to maintain the confidentiality of the information contained within the Farm Bill Master List. The Farm Bill Master List reflects personal data, such as Social Security Numbers, which are a key piece of personal identifiable information to assist you in determining the existence of a lien against a specific debtor. The distribution of this information beyond its intended purpose is strictly prohibited.\n\nThe debtor's tax identification number has been hidden for confidentiality reasons. You may continue to search on a tax ID number and return debtors that match your search criteria. The SSN/FEIN must be entered without dashes or spaces.","searchMustHaveOneOf":["search","UCC_FARM_PRODUCT_ID","COUNTY"],"searchPlaceholder":"Search by debtor name","advancedSearchParameters":[{"type":"ServerMultiComplete","label":"Product code name(s)","name":"UCC_FARM_PRODUCT_ID","defaultValue":"","optionsSrc":"UCC_FARM_PRODUCT_V"},{"type":"MultiComplete","label":"Year or Range of Years","name":"YEAR_NUM","optionsSrc":"years","startYear":"1968","defaultValue":[],"preMergeOptions":[{"value":"ALL","label":"All"}]},{"type":"serverSelect","label":"State","name":"STATE","defaultValue":"MONTANA","optionsSrc":"STATE"},{"type":"ServerMultiComplete","label":"County","name":"COUNTY","defaultValue":[],"optionsSrc":"COUNTY","overrideSubOptionsSrcFromParameterName":"STATE"},{"type":"checkbox","name":"TIN_SEARCH_YN","defaultValue":false,"label":"Tax Identification Number Search"},{"type":"checkbox","name":"TIN_SORT_YN","defaultValue":false,"label":"Unique ID Sort"}]},"ALLOW_ADDRESS_VALIDATION_BYPASS_OPTION":true,"DEFAULT_ADDRESS_VALIDATION_BYPASS_OPTION_CHECKED":true}).STATE_TIMEZONE;
	      if (stateTimeZone) {
	        var localDate = new Date();
	        var stateLocalString = localDate.toLocaleString('en-US', { timeZone: stateTimeZone });
	        today = (0, _startOfDay2.default)(new Date(stateLocalString));
	      } else {
	        today = (0, _startOfDay2.default)(new Date());
	      }
	
	      var daysAfterToday = (0, _differenceInDays2.default)(date, today);
	      if (daysAfterToday <= props.maxAfterToday) {
	        callback(true, '');
	      } else {
	        callback(false, props.errorMessage !== '' ? props.errorMessage : 'Selected date is outside valid range.');
	      }
	    }
	  },
	  enforceMaxDaysBeforeToday: function enforceMaxDaysBeforeToday(value, field) {
	    var props = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	    var callback = arguments[3];
	
	    if (field.maxBeforeToday == '' || value === null || value === '') {
	      callback(null, '');
	    } else {
	      var date = (0, _startOfDay2.default)(new Date(value));
	      var now = void 0;
	      var stateTimeZone = ({"NODE_ENV":"production","BUILD_DATE":"2025-08-27T15:15:31.687Z","BUILD_NUMBER":"Not Provided","GIT_VERSION":"v1.3.0-381-ga81e29b08","GIT_COMMIT_HASH":"a81e29b085c9268ffd96c78eb734365802722741","GIT_BRANCH":"beta","PUBLIC_URL":"","STATE_ABBR":"MT","STATE_NAME":"Montana","STATE_ORG_TITLE":"Secretary of State","LOGIN_HEADER_IMG_PATH":"","HOME_IMG_FILENAME":"montana.jpg","FAVICON_FILE_NAME":"favicon.ico","ALLOW_E_SIGN_ON_CORRECTIONS":true,"THIRD_PARTY_SIGNING_ALLOWED":false,"MY_ACCOUNT_SAVE_AND_CLOSE_BUTTON":true,"IE_DEPRECATED_MESSAGE":"Internet Explorer is not supported. Please select a supported browser below to access this website.","ADDITIONAL_ROUTES":{"dataRequests":true,"farmBill":true,"apostille":true,"externalHelp":"https://sosmt.gov/business/help-center/","systemAdministration":[{"title":"Saved Payments","parameter":"saved-payments","componentName":"SavedPayments"}]},"SUBROUTES":[{"label":"Business","component":"Business","parameter":"business","myWorkQueueSearch":false,"sourceTypeId":54,"searchMustHaveOneOf":["FILING_TYPE_ID","STATUS_ID","STATE","search"],"serverWebSearchDescription":true,"serverWorkQueueDescription":true,"serverMyRecordsDescription":true,"searchPlaceholder":"Search by name or filing number (X########)","allowEmptySearchTerm":true,"requestCertificateAlternateLabel":"Request Information","fileAmendmentButtonLabel":"Filing Actions","advancedSearchParameters":[{"type":"radio","name":"QUERY_TYPE_ID","defaultValue":1010,"options":[{"value":1010,"label":"Starts with"},{"value":1011,"label":"Contains"},{"value":1012,"label":" Word Contains"}]},{"type":"serverSelect","name":"FILING_TYPE_ID","optionsSrc":"FILING_TYPES","label":"Entity Type","placeholder":"All","defaultValue":"0"},{"type":"serverSelect","name":"FILING_SUBTYPE_ID","optionsSrc":"FILING_SUBTYPES","label":"Entity Subtype","overrideSubOptionsSrcFromParameterName":"FILING_TYPE_ID","placeholder":"All","defaultValue":"0"},{"type":"serverSelect","name":"STATUS_ID","optionsSrc":"FILING_STATUS_WITHOUT_ALL","label":"Status","placeholder":"All","defaultValue":"0"},{"type":"serverSelect","name":"STATE","optionsSrc":"STATE","label":"State","placeholder":"All","defaultValue":""},{"type":"serverSelect","name":"COUNTY","optionsSrc":"COUNTY_SUBOPTION","label":"County","overrideSubOptionsSrcFromParameterName":"STATE","placeholder":"All","defaultValue":""},{"type":"checkbox","name":"CRA_SEARCH_YN","defaultValue":false,"label":"Search by Registered Agent PID"},{"type":"dateRange","name":"FILING_DATE","label":"Registration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}},{"type":"dateRange","name":"EXPIRATION_DATE","label":"Expiration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}}],"myRecordsFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Active"},{"value":2,"label":"Inactive"},{"value":3,"label":"Pending"}]},{"type":"dateRange","name":"DATE_RANGE","label":"Date range","defaultValue":{"start":null,"end":null}}],"myWorkQueueFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Approved"},{"value":2,"label":"Pending Online Payment"},{"value":3,"label":"Pending Review"},{"value":4,"label":"Needs Correction"},{"value":5,"label":"Rejected"},{"value":6,"label":"Draft"}]},{"type":"dateRange","name":"DATE_RANGE","label":"Date range","defaultValue":{"start":null,"end":null}}]},{"label":"Notary","component":"Notary","parameter":"notary","sourceTypeId":850,"myWorkQueueSearch":false,"allowEmptySearchTerm":true,"requestCertificateAlternateLabel":"Download Certificate","fileAmendmentButtonLabel":"Filing Actions","hideNameRequestCertificate":true,"hideAddressRequestCertificate":true,"hideRecordUserManagment":true,"searchPlaceholder":"Search by name or commission number","searchMustHaveOneOf":["CITY","search","SERVICE_TYPE"],"advancedParametersStartOpen":true,"searchIsSortable":true,"advancedSearchParameters":[{"type":"radio","name":"STARTS_WITH_YN","defaultValue":false,"options":[{"value":true,"label":"Starts with"},{"value":false,"label":"Contains"}]},{"type":"checkbox","name":"ACTIVE_ONLY_YN","defaultValue":true,"label":"Active entities only"},{"type":"text","name":"CITY","defaultValue":"","label":"City"},{"type":"select","name":"SERVICE_TYPE","label":"Special Services Offered","defaultValue":0,"options":[{"value":0,"label":"(N/A)"},{"value":6165,"label":"In-Person Electronic Notarization (IPEN)"},{"value":6166,"label":"Remote Online Notarization (RON)"},{"value":6167,"label":"Mobile Notary Services"},{"value":6168,"label":"Remote Ink Notarization (RIN)"}]}]},{"label":"Apostille","component":"Apostille","parameter":"apostille","sourceTypeId":720,"myRecordsSearch":false,"myWorkQueueSearch":false,"disabled":false,"allowedRoutes":["/forms-manager/","/queue/","/forms/"]},{"label":"Liens","component":"UCC","parameter":"ucc","sourceTypeId":1999,"myRecordsSearch":true,"myWorkQueueSearch":true,"fileAmendmentButtonLabel":"Filing Actions","searchPlaceholder":"Search by name or file number","disabled":false,"serverWebSearchDescription":true,"myRecordsDescription":"","workQueueDescription":"","searchDescription":"","hideRecordUserManagment":true,"searchLiensCheckout":false,"advancedSearchParameters":[{"type":"radio","name":"STARTS_WITH_YN","defaultValue":false,"options":[{"value":true,"label":"Starts with"},{"value":false,"label":"Contains"}]},{"type":"select","name":"STATUS","defaultValue":"ALL","label":"Status","options":[{"value":"ACTIVE_UNLAPSED","label":"Active (unlapsed)"},{"value":"ACTIVE_LAPSED_UNLAPSED","label":"Active (lapsed and unlapsed)"}]},{"type":"text","name":"EXCLUDE_VALUES","label":"Exclude Debtor Names (comma separated list of names to exclude)","defaultValue":""},{"type":"dateRange","name":"FILING_DATE","label":"Financing Statement Date","defaultValue":{"start":null,"end":null}},{"type":"dateRange","name":"LAPSE_DATE","label":"Lapse Date","defaultValue":{"start":null,"end":null}},{"type":"text","name":"CITY","label":"Debtor City","defaultValue":""}],"myRecordsFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Approved"},{"value":2,"label":"Pending Online Payment"},{"value":3,"label":"Pending Review"}]},{"type":"select","name":"TYPE","defaultValue":0,"label":"Lien Type","options":[{"value":0,"label":"All"},{"value":1,"label":"UCC"},{"value":2,"label":"EFS"},{"value":3,"label":"Title 71"}]}],"myWorkQueueFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Approved"},{"value":2,"label":"Pending Online Payment"},{"value":3,"label":"Pending Review"},{"value":4,"label":"Pending Print and Mail"},{"value":5,"label":"Rejected"},{"value":6,"label":"Draft"}]},{"type":"select","name":"TYPE","defaultValue":0,"label":"Lien Type","options":[{"value":0,"label":"All"},{"value":1,"label":"UCC"},{"value":2,"label":"EFS"},{"value":3,"label":"Title 71"}]}]},{"label":"Copy Request","component":"copies","parameter":"copies","sourceTypeId":2001,"myRecordsSearch":false,"myWorkQueueSearch":false,"disabled":false,"allowedRoutes":["/forms-manager/","/queue/","/forms/"]},{"label":"Trademark","component":"Trademark","parameter":"trademark","sourceTypeId":810,"showRequestCertificate":true,"searchMustHaveOneOf":["search","EXPIRATION_DATE","FILING_DATE"],"allowEmptySearchTerm":true,"requestCertificateAlternateLabel":"Request Information","fileAmendmentButtonLabel":"Filing Actions","advancedSearchParameters":[{"type":"radio","name":"QUERY_TYPE_ID","defaultValue":1010,"options":[{"value":1010,"label":"Starts with"},{"value":1011,"label":"Contains"},{"value":1012,"label":" Word Contains"}]},{"type":"checkbox","name":"OWNER_SEARCH_YN","defaultValue":false,"label":"Search owners"},{"type":"radio","name":"SERVICE_MARK_YN","label":"Mark Type","defaultValue":"","options":[{"value":"","label":"All Marks"},{"value":"Y","label":"Service Mark"},{"value":"N","label":"Trademark"}]},{"type":"serverSelect","name":"STATUS_ID","optionsSrc":"TYPE_V|TRADEMARK_STATUS_TYPE","label":"Status","placeholder":"All","defaultValue":"0"},{"type":"select","name":"DESIGN_TYPE_ID","options":[{"value":0,"label":"All"},{"value":990,"label":"Words Only"},{"value":991,"label":"Design Only"},{"value":992,"label":"Words and Design"}],"label":"Design Type","defaultValue":"0"},{"type":"dateRange","name":"FILING_DATE","label":"Registered Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}},{"type":"dateRange","name":"EXPIRATION_DATE","label":"Expiration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}}]},{"label":"Business Info Request","component":"InfoRequests","parameter":"info-request","sourceTypeId":167,"allowedRoutes":["/forms-manager/","/queue/","/forms/"]},{"label":"Data Requests","component":"DataRequests","parameter":"data-request","sourceTypeId":0,"allowedRoutes":["/forms-manager/"]},{"label":"CRA","component":"CRA","parameter":"cra","sourceTypeId":157,"myRecordsSearch":false,"searchPlaceholder":"Search by name or registered agent number","allowedRoutes":["/forms-manager/","/forms/","/records/","/queue/","/search/"],"allowEmptySearchTerm":true,"fileAmendmentButtonLabel":"Filing Actions","advancedSearchParameters":[{"type":"radio","name":"QUERY_TYPE_ID","defaultValue":1010,"options":[{"value":1010,"label":"Starts with"},{"value":1011,"label":"Contains"},{"value":1012,"label":" Word Contains"}]},{"type":"dateRange","name":"CRA_DATE","label":"Registration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}},{"type":"select","name":"STATUS_ID","label":"Status","defaultValue":0,"options":[{"value":0,"label":"All"},{"value":121,"label":"Active"},{"value":122,"label":"Inactive"}]},{"type":"select","name":"AGENT_TYPE_ID","label":"Agent Type","defaultValue":0,"options":[{"value":0,"label":"All"},{"value":460,"label":"Registered Agent"},{"value":461,"label":"Commercial Registered Agent"}]}]},{"label":"Farm Bill","component":"FarmBill","parameter":"farm-bill","path":"/lists/farm-bill","sourceTypeId":0,"myRecordsSearch":false,"allowedRules":["/search/"],"disabled":true,"searchDescription":"To perform a search, enter a debtor name. Your search results may include: exact debtor name, variations of that name and any filing that includes your search criteria. Punctuation is ignored.\n\nYou can click on \"Advanced\" to refine your search. Under “Advanced” you can search by crop, year, county and SSN/FEIN. As a registered Farm Bill Buyer with the Montana Secretary of State’s office it is important to maintain the confidentiality of the information contained within the Farm Bill Master List. The Farm Bill Master List reflects personal data, such as Social Security Numbers, which are a key piece of personal identifiable information to assist you in determining the existence of a lien against a specific debtor. The distribution of this information beyond its intended purpose is strictly prohibited.\n\nThe debtor's tax identification number has been hidden for confidentiality reasons. You may continue to search on a tax ID number and return debtors that match your search criteria. The SSN/FEIN must be entered without dashes or spaces.","searchMustHaveOneOf":["search","UCC_FARM_PRODUCT_ID","COUNTY"],"searchPlaceholder":"Search by debtor name","advancedSearchParameters":[{"type":"ServerMultiComplete","label":"Product code name(s)","name":"UCC_FARM_PRODUCT_ID","defaultValue":"","optionsSrc":"UCC_FARM_PRODUCT_V"},{"type":"MultiComplete","label":"Year or Range of Years","name":"YEAR_NUM","optionsSrc":"years","startYear":"1968","defaultValue":[],"preMergeOptions":[{"value":"ALL","label":"All"}]},{"type":"serverSelect","label":"State","name":"STATE","defaultValue":"MONTANA","optionsSrc":"STATE"},{"type":"ServerMultiComplete","label":"County","name":"COUNTY","defaultValue":[],"optionsSrc":"COUNTY","overrideSubOptionsSrcFromParameterName":"STATE"},{"type":"checkbox","name":"TIN_SEARCH_YN","defaultValue":false,"label":"Tax Identification Number Search"},{"type":"checkbox","name":"TIN_SORT_YN","defaultValue":false,"label":"Unique ID Sort"}]}],"SYSTEM_NICKNAME":"Online Services Portal","PAYMENT_METHODS":[{"type":"bypass"},{"type":"iTransact"}],"PAYMENT_ALLOW_AMEX":true,"SYSTEM_ID_LABEL":"System Id","DOUBLE_COLUMN_PUBLIC_LOGIN":true,"INTERNAL_USER_MANAGEMENT":true,"ALLOW_PUBLIC_JSON_IMPORT":false,"MAX_FILE_UPLOAD_SIZE":10000000,"REFUND_TEXT":"","RETURN_TO_HOME_ON_LOGOUT":true,"CURRENT_SOS_NAME":"Christi Jacobsen","LOGO_FILENAME":"mt-sos-logo.png","LOGO_ALT":"Christi Jacobsen, Montana Secretary of State","LOGO_FULL_WIDTH":true,"HOME_HIDE_AUTH_HINT":true,"HOME_TITLE":"Montana Secretary of State","CUSTOM_TAB_TITLE":"Official Montana","HOME_SUBTITLE":"Online Business Services","ENTITY_NAME_CONSENT_DESCRIPTION":"","ALLOW_USER_PROFILE_EDITING":true,"COMPARE_FOREIGN_NAME_IN_ENTITY_NAME_VALIDATION":true,"FOREIGN_NAME_FIELD_NAME":"KIMA_PARENT_NAME_INFO","LOGIN_TITLE":"Montana Secretary of State Online Filing Portal Login","PUBLIC_LOGIN_LABEL":"Username","REVERSE_LOGIN_COLUMNS":true,"LOGIN_SEAL_FILENAME":"seal_white.png","SEPARATE_USERNAME_AND_EMAIL":true,"CREATE_ACCOUNT_BUTTON_ALIGN_LEFT":true,"CREATE_ACCOUNT_BUTTON_TEXT":"CREATE AN ACCOUNT","PASSWORD_CUSTOM_ERROR_TEXT":"The password must meet all requirements","ACCOUNT_CREATED_MESSAGE":"Please check your email to verify your account to login and allow a few minutes for this message to arrive. Check your junk/spam folders if you do not find the email in your inbox.","PUBLIC_LOGIN_PLACEHOLDER":" ","DISABLE_DEFAULT_PAYMENT_RADIO":true,"CUSTOM_RESET_PASSWORD_ERROR_MESSAGE":"Username invalid - no account found","PUBLIC_LOGIN_CREATE_DESCRIPTION":"### Existing User:\n\n  - Enter your username and password to login.  \n\n\n  #### - OR -  \n\n\n\n  - Forgot password? Click 'Reset Password' and follow the prompts.\n  - Forgot username? Click 'Forgot Username' and follow the prompts.  \n\n\n  ### New User:\n  ","LOGIN_HELP_LINK":"https://sosmt.gov/business/how-do-i/","LOGIN_HELP_LINK_TEXT":"Need Help?","FORGOT_USERNAME_TEXT":"Forgot Username?","LOGIN_ACTIVE_DIRECTORY_TEXT":"State User Login","MULTIPLE_LOGIN_METHODS":true,"HAS_ACTIVE_DIRECTORY_LOGIN":true,"RESET_PASSWORD_WITH_USERNAME":true,"DOWNLOAD_LINK":true,"SHOW_USERNAME_ACCOUNT_CREATE":true,"SHOW_SCROLL_DOWN_ARROW":true,"SHOW_ADDRESS_ACCOUNT_CREATE":true,"TWO_COLUMN_ACCOUNT_CREATE":true,"RESET_PASSWORD_TIP":"A link to change your password has been sent to your email. Please allow a few minutes for this message to arrive. Please check your junk/spam folders if you do not find the email in your inbox.","FORGOT_PASSWORD_LINK_TEXT":"Reset Password","PHONE_NUMBER_OPTIONAL_ACCOUNT_CREATE":true,"SHOW_REQUIRED_INDICATOR_ACCOUNT_CREATE":true,"PASSWORD_REQUIREMENTS_ACCOUNT_CREATE":"\n    <ul>\n      <li>MUST contain at least 8 characters (12+ recommended)</li>\n      <li>MUST contain at least one uppercase letter.</li>\n      <li>MUST contain at least one lowercase letter.</li>\n      <li>MUST contain at least one number.</li>\n      <li>MUST contain at least one special character (!”#$%&'()*+,-./:;<=>?</li>\n    </ul>\n  ","ALLOW_CERTIFICATION_REQUEST":true,"ALLOW_PUBLIC_CERTIFICATE_REQUEST":true,"ALLOW_COPY_REQUEST":false,"ALLOW_CORRECTION_STYLING":true,"HIDE_DEPRECATION_WARNING":false,"AMEND_ROUTE_PUBLIC":true,"SEAL_FILENAME":"seal.png","SHOPPING_CART":true,"ALLOW_PAYMENT_UPDATE_WITH_EMPTY_CART":true,"RA_EMAIL":true,"RA_WEBSITE":true,"RA_NO_DEFAULT_TYPE":true,"RA_ADDRESS_LABEL":"Street Address","RA_TYPE_SELECTION_DEFAULT":true,"RA_DEFAULT_TYPE":"460","RA_OVERRIDE_TYPE_WITH_DEFAULT":true,"RA_PRINCIPAL_ADDRESS_AMS":true,"UPLOAD_AND_SUBMIT_HIDE_IF_ONE_OPTION":true,"PAYMENT_PROCESSING_MESSAGE":"Your payment is processing - Do not close your browser or click the back button","CHECKOUT_BUTTON_WHEN_PROCESSING_TEXT":"Processing","EFS_CROP_PICKER_NONE_LABEL":"Lien Duration","DISALLOWED_WIZARD_PIECES":["FormationLocale"],"REPEATER_SHOW_EDIT_BUTTON":true,"DATA_REQUEST_PAGE_TITLE":"Data Requests and Subscriptions","DATA_REQUEST_SIDEBAR_LABEL":"Data Requests & Subscriptions","LOGIN_REDIRECTS_TO_EPASS":false,"LOGIN_REDIRECTS_TO_ACTIVE_DIRECTORY":true,"LOGIN_ACTIVE_DIRECTORY_LINK":true,"FETCH_EDIT_USER_LINK":false,"LISTS_FETCH_AVAILABLE_LISTS":true,"POST_WIZARD_SUBMIT_REDIRECT_URL":"/","PIN_REQUEST_ATTESTATIONS":true,"PIN_REQUEST_DESCRIPTION":"Click **Request PIN** to have a new PIN sent to the account holder's email address on file.","OWNERSHIP_REQUEST_DESCRIPTION":"To become an **authorized user** of this record, a current **AUTHORIZED USER** will need to grant you access. To request access, click **Request Access** below.","PIN_REQUEST_SUCCESS_MESSAGE":"The PIN you have requested for this entity has been sent to the email associated with your user account.  You should receive the PIN in approximately 3-5 minutes, depending on your email service provider.","APOSTILLE_HEADER_LABEL":"Verification Information","APOSTILLE_NUMBER_LABEL":"Apostille/Authentication","APOSTILLE_CITY_STATE_OVERRIDE":"HELENA, MT","APOSTILLE_FILING_DATE_LABEL":"Issue Date","APOSTILLE_CITY_STATE_IN_CERTIFIED":true,"NOTARY_EXISTING_FILING":true,"ALLOW_REVOKE_OWN_ACCESS_ONLY":false,"HIDE_CANCEL_ON_ONETIME_DATA_REQUESTS":true,"DATA_REQUESTS_IN_SHOPPING_CART":true,"WQ_ALLOW_EDIT_PENDING_PAYMENT":true,"WQ_CONFIRM_ON_DELETE":true,"WQ_DELETE_CONFIRM_MESSAGE":"Deleting this filing will forfeit any money already paid to the Secretary of State. This action is permanent and cannot be undone, are you sure you would like to delete?","PASS_ITEM_GUIDS_ON_CHECKOUT":true,"FORM_REVISION_HISTORY":true,"CHECKOUT_DISCLAIMER":"By entering your credit card and/or checking account information you (i) state that **you are an authorized user** of the credit card and/or electronic check and that the associated information entered (e.g., account holder name, account number, billing address) is accurate, (ii) **you authorize payment processor to charge the amount you have requested** to your credit card and/or funding account, and (iii) **acknowledge if a charge is declined or reversed you may also be assessed a customary charge** by the payment processor for such transactions.","FARM_BILL_SEARCH_CONFIDENTIAL":"As a registered Farm Bill Buyer with the Montana Secretary of State’s office it is important to maintain the confidentiality of the information contained within the Farm Bill Master List. The Farm Bill Master List reflects personal data, such as Social Security Numbers, which are a key piece of personal identifiable information to assist you in determining the existence of a lien against a specific debtor. The distribution of this information beyond its intended purpose is strictly prohibited.\n\n**The debtor's tax identification number has been hidden for confidentiality reasons. You may continue to search on a tax ID number and return debtors that match your search criteria. The SSN/FEIN must be entered without dashes or spaces.  If you need access to the tax identification number to clearly identify the debtor, please contact the UCC unit at (406) 444-3665.**","VIEW_HISTORY_BUTTON_ALT_TEXT":"View Filings","WIZARD_ERROR_TITLE_MESSAGE":"Form Error","FARM_BILL_SEARCH_INTERACTIVE":true,"USE_FARM_BILL_API":true,"DISALLOW_ASSIGN_SELF_AS_RA":true,"DISALLOW_ASSIGN_SELF_AS_PRINCIPAL":true,"USE_TRADEMARK_OWNER_VALIDATION":true,"USE_ALTERNATIVE_FOREIGN_ADDRESS_LABELS":true,"MY_RECEIPTS_FILTER":[{"type":"dateRange","name":"DATE_RANGE","label":"Date range","defaultValue":{"start":null,"end":null}},{"type":"text","name":"REF_NUM","defaultValue":"","label":"Reference Number"},{"type":"text","name":"RECEIPT_NUM","defaultValue":"","label":"Receipt Id"},{"type":"text","name":"AMOUNT","defaultValue":"","label":"Amount"},{"type":"select","name":"TYPE","defaultValue":"","label":"Payment Type","options":[{"value":"","label":"All"},{"value":"CC","label":"Credit Card"},{"value":"Check","label":"Check"}]}],"MY_RECEIPTS_SHOW_IN_SIDEBAR":true,"SHOW_MY_RECEIPTS_HELPER_TEXT":true,"MY_RECEIPTS_HELPER_LABEL":"About Receipt Search","MY_RECEIPTS_HELPER_TEXT":"You can search for receipts based on their descriptions, including the items paid for on the receipt. Use the filters to search for or filter specific information.","FARM_BILL_SUBLINK":{"label":"Farm Bill","component":"FarmBill","parameter":"farm-bill","path":"/lists/farm-bill","sourceTypeId":0,"myRecordsSearch":false,"allowedRules":["/search/"],"disabled":true,"searchDescription":"To perform a search, enter a debtor name. Your search results may include: exact debtor name, variations of that name and any filing that includes your search criteria. Punctuation is ignored.\n\nYou can click on \"Advanced\" to refine your search. Under “Advanced” you can search by crop, year, county and SSN/FEIN. As a registered Farm Bill Buyer with the Montana Secretary of State’s office it is important to maintain the confidentiality of the information contained within the Farm Bill Master List. The Farm Bill Master List reflects personal data, such as Social Security Numbers, which are a key piece of personal identifiable information to assist you in determining the existence of a lien against a specific debtor. The distribution of this information beyond its intended purpose is strictly prohibited.\n\nThe debtor's tax identification number has been hidden for confidentiality reasons. You may continue to search on a tax ID number and return debtors that match your search criteria. The SSN/FEIN must be entered without dashes or spaces.","searchMustHaveOneOf":["search","UCC_FARM_PRODUCT_ID","COUNTY"],"searchPlaceholder":"Search by debtor name","advancedSearchParameters":[{"type":"ServerMultiComplete","label":"Product code name(s)","name":"UCC_FARM_PRODUCT_ID","defaultValue":"","optionsSrc":"UCC_FARM_PRODUCT_V"},{"type":"MultiComplete","label":"Year or Range of Years","name":"YEAR_NUM","optionsSrc":"years","startYear":"1968","defaultValue":[],"preMergeOptions":[{"value":"ALL","label":"All"}]},{"type":"serverSelect","label":"State","name":"STATE","defaultValue":"MONTANA","optionsSrc":"STATE"},{"type":"ServerMultiComplete","label":"County","name":"COUNTY","defaultValue":[],"optionsSrc":"COUNTY","overrideSubOptionsSrcFromParameterName":"STATE"},{"type":"checkbox","name":"TIN_SEARCH_YN","defaultValue":false,"label":"Tax Identification Number Search"},{"type":"checkbox","name":"TIN_SORT_YN","defaultValue":false,"label":"Unique ID Sort"}]},"ALLOW_ADDRESS_VALIDATION_BYPASS_OPTION":true,"DEFAULT_ADDRESS_VALIDATION_BYPASS_OPTION_CHECKED":true}).STATE_TIMEZONE;
	      if (stateTimeZone) {
	        var localDate = new Date();
	        var stateLocalString = localDate.toLocaleString('en-US', { timeZone: stateTimeZone });
	        now = (0, _startOfDay2.default)(new Date(stateLocalString));
	      } else {
	        now = (0, _startOfDay2.default)(new Date());
	      }
	
	      var daysBeforeToday = (0, _differenceInDays2.default)(now, date);
	      if (daysBeforeToday <= props.maxBeforeToday) {
	        callback(true, '');
	      } else {
	        callback(false, props.errorMessage !== '' ? props.errorMessage : 'Selected date is outside valid range.');
	      }
	    }
	  },
	  enforceMaxMonthsAfterToday: function enforceMaxMonthsAfterToday(value, field) {
	    var props = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	    var callback = arguments[3];
	
	    if (field.maxAfterToday === '' || value === null || value === '') {
	      callback(null, '');
	    } else {
	      var date = (0, _startOfDay2.default)(new Date(value));
	      var today = (0, _startOfDay2.default)(new Date());
	      var monthsAfterToday = (0, _differenceInMonths2.default)(date, today);
	      if (monthsAfterToday <= props.maxAfterToday) {
	        callback(true, '');
	      } else {
	        callback(false, props.errorMessage !== '' ? props.errorMessage : 'Selected date is outside valid range.');
	      }
	    }
	  },
	  enforceMaxMonthsBeforeToday: function enforceMaxMonthsBeforeToday(value, field) {
	    var props = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	    var callback = arguments[3];
	
	    if (field.maxBeforeToday == '' || value === null || value === '') {
	      callback(null, '');
	    } else {
	      var date = (0, _startOfDay2.default)(new Date(value));
	      var now = (0, _startOfDay2.default)(new Date());
	      var monthsBeforeToday = (0, _differenceInMonths2.default)(now, date);
	      if (monthsBeforeToday <= props.maxBeforeToday) {
	        callback(true, '');
	      } else {
	        callback(false, props.errorMessage !== '' ? props.errorMessage : 'Selected date is outside valid range.');
	      }
	    }
	  },
	  enforceMinDaysBeforeToday: function enforceMinDaysBeforeToday(value, field) {
	    var props = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	    var callback = arguments[3];
	
	    if (field.minBeforeToday == '' || value === null || value === '') {
	      callback(null, '');
	    } else {
	      var date = (0, _startOfDay2.default)(new Date(value));
	      var now = (0, _startOfDay2.default)(new Date());
	      var daysBeforeToday = (0, _differenceInDays2.default)(now, date);
	      if (daysBeforeToday >= props.minBeforeToday) {
	        callback(true, '');
	      } else {
	        callback(false, props.errorMessage !== '' ? props.errorMessage : 'Selected date is outside valid range.');
	      }
	    }
	  },
	  enforceMinDaysAfterToday: function enforceMinDaysAfterToday(value, field) {
	    var props = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	    var callback = arguments[3];
	
	    if (field.minAfterToday === '' || value === null || value === '') {
	      callback(null, '');
	    } else {
	      var date = (0, _startOfDay2.default)(new Date(value));
	      var today = (0, _startOfDay2.default)(new Date());
	      var daysAfterToday = (0, _differenceInDays2.default)(date, today);
	      if (daysAfterToday >= props.minAfterToday) {
	        callback(true, '');
	      } else {
	        callback(false, props.errorMessage !== '' ? props.errorMessage : 'Selected date is outside valid range.');
	      }
	    }
	  },
	  enforceMinMonthsAfterToday: function enforceMinMonthsAfterToday(value, field) {
	    var props = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	    var callback = arguments[3];
	
	    if (field.minAfterToday === '' || value === null || value === '') {
	      callback(null, '');
	    } else {
	      var date = (0, _startOfDay2.default)(new Date(value));
	      var today = (0, _startOfDay2.default)(new Date());
	      var monthsAfterToday = (0, _differenceInMonths2.default)(date, today);
	      if (monthsAfterToday >= props.minAfterToday) {
	        callback(true, '');
	      } else {
	        callback(false, props.errorMessage !== '' ? props.errorMessage : 'Selected date is outside valid range.');
	      }
	    }
	  },
	  enforceMinMonthsBeforeToday: function enforceMinMonthsBeforeToday(value, field) {
	    var props = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	    var callback = arguments[3];
	
	    if (field.minBeforeToday == '' || value === null || value === '') {
	      callback(null, '');
	    } else {
	      var date = (0, _startOfDay2.default)(new Date(value));
	      var now = (0, _startOfDay2.default)(new Date());
	      var daysBeforeToday = (0, _differenceInMonths2.default)(now, date);
	      if (daysBeforeToday >= props.minBeforeToday) {
	        callback(true, '');
	      } else {
	        callback(false, props.errorMessage !== '' ? props.errorMessage : 'Selected date is outside valid range.');
	      }
	    }
	  },
	  enforceSignatureDateRange: function enforceSignatureDateRange(value, field) {
	    var props = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	    var callback = arguments[3];
	    var _ref = arguments[4];
	    var event = _ref.event,
	        subField = _ref.subField;
	
	    var rules = ['enforceMaxDaysBeforeToday', 'enforceMaxDaysAfterToday'];
	
	    var rowPromises = value.map(function (row) {
	      return new Promise(function (resolve) {
	        var rulePromises = rules.map(function (ruleId) {
	          return new Promise(function (subResolve) {
	            getIsValid(ruleId, row.date, field, props, function (isValid, errorMessage) {
	              subResolve({ ruleId: ruleId, isValid: isValid, errorMessage: errorMessage });
	            });
	          });
	        });
	        Promise.all(rulePromises).then(function (ruleResolves) {
	          var bothValid = !ruleResolves.some(function (result) {
	            return result.isValid === false;
	          });
	          var errorMessage = !bothValid ? ruleResolves.find(function (result) {
	            return result.isValid === false;
	          }).errorMessage : '';
	          resolve({ ruleResolves: ruleResolves, bothValid: bothValid, errorMessage: errorMessage });
	        });
	      });
	    });
	    Promise.all(rowPromises).then(function (rowResolves) {
	      var allValid = !rowResolves.some(function (result) {
	        return result.bothValid === false;
	      });
	      callback(allValid, rowResolves);
	    });
	  },
	  validZipCode: function validZipCode(value, field) {
	    var props = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	    var callback = arguments[3];
	
	    var isZipCode = value === '' ? true : false;
	    isZipCode = /(^\d{5}$)|(^\d{5}-\d{4}$)/.test(value) && (value.length === 10 || value.length === 5);
	    if (isZipCode) {
	      callback(true, '');
	    } else {
	      callback(false, props.errorMessage !== '' ? props.errorMessage : 'Correct this field to continue');
	    }
	  },
	  validAddressZipCode: function validAddressZipCode(value, field) {
	    var props = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	    var callback = arguments[3];
	
	    var newValue = value.POSTAL_CODE;
	    var isZipCode = /(^\d{5}$)|(^\d{5}-\d{4}$)/.test(newValue) && (newValue.length === 10 || newValue.length === 5);
	    if (isZipCode) {
	      callback(true, '');
	    } else {
	      callback(false, props.errorMessage !== '' ? props.errorMessage : 'Correct this field to continue');
	    }
	  },
	  validSocial: function validSocial(value, field) {
	    var props = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	    var callback = arguments[3];
	
	    if (!valueIsNotEmptyOrNull(value)) {
	      callback(null, '');
	    } else {
	      var isValidSocial = /^(?!219-09-9999|078-05-1120)(?!666|000|9\d{2})\d{3}-(?!00)\d{2}-(?!0{4})\d{4}$/.test(value) && value.length === 11;
	      if (isValidSocial) {
	        callback(true, '');
	      } else {
	        callback(false, props.errorMessage !== '' ? props.errorMessage : 'Please provide a properly formatted Social Security Number to continue');
	      }
	    }
	  },
	  enforceUploadPlaceholderRules: function enforceUploadPlaceholderRules(value, field) {
	    var props = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	    var callback = arguments[3];
	
	    var valueMethod = _store2.default.getState().wizard.requirePrintMailMethod.size > 0 ? 'mail' : value.method;
	    var method = field.type === 'UploadAndSubmit' && valueMethod ? valueMethod : null;
	    if (method === 'mail') {
	      callback(true, '');
	    } else {
	      var uploadPlaceholders = (0, _UploadAccumulator.getUploadsFromFields)(_store2.default.getState().wizard.wizard.fields);
	      var computedValue = (field.type === 'UploadAndSubmit' ? value.files : value) || {};
	      if (({"NODE_ENV":"production","BUILD_DATE":"2025-08-27T15:15:31.687Z","BUILD_NUMBER":"Not Provided","GIT_VERSION":"v1.3.0-381-ga81e29b08","GIT_COMMIT_HASH":"a81e29b085c9268ffd96c78eb734365802722741","GIT_BRANCH":"beta","PUBLIC_URL":"","STATE_ABBR":"MT","STATE_NAME":"Montana","STATE_ORG_TITLE":"Secretary of State","LOGIN_HEADER_IMG_PATH":"","HOME_IMG_FILENAME":"montana.jpg","FAVICON_FILE_NAME":"favicon.ico","ALLOW_E_SIGN_ON_CORRECTIONS":true,"THIRD_PARTY_SIGNING_ALLOWED":false,"MY_ACCOUNT_SAVE_AND_CLOSE_BUTTON":true,"IE_DEPRECATED_MESSAGE":"Internet Explorer is not supported. Please select a supported browser below to access this website.","ADDITIONAL_ROUTES":{"dataRequests":true,"farmBill":true,"apostille":true,"externalHelp":"https://sosmt.gov/business/help-center/","systemAdministration":[{"title":"Saved Payments","parameter":"saved-payments","componentName":"SavedPayments"}]},"SUBROUTES":[{"label":"Business","component":"Business","parameter":"business","myWorkQueueSearch":false,"sourceTypeId":54,"searchMustHaveOneOf":["FILING_TYPE_ID","STATUS_ID","STATE","search"],"serverWebSearchDescription":true,"serverWorkQueueDescription":true,"serverMyRecordsDescription":true,"searchPlaceholder":"Search by name or filing number (X########)","allowEmptySearchTerm":true,"requestCertificateAlternateLabel":"Request Information","fileAmendmentButtonLabel":"Filing Actions","advancedSearchParameters":[{"type":"radio","name":"QUERY_TYPE_ID","defaultValue":1010,"options":[{"value":1010,"label":"Starts with"},{"value":1011,"label":"Contains"},{"value":1012,"label":" Word Contains"}]},{"type":"serverSelect","name":"FILING_TYPE_ID","optionsSrc":"FILING_TYPES","label":"Entity Type","placeholder":"All","defaultValue":"0"},{"type":"serverSelect","name":"FILING_SUBTYPE_ID","optionsSrc":"FILING_SUBTYPES","label":"Entity Subtype","overrideSubOptionsSrcFromParameterName":"FILING_TYPE_ID","placeholder":"All","defaultValue":"0"},{"type":"serverSelect","name":"STATUS_ID","optionsSrc":"FILING_STATUS_WITHOUT_ALL","label":"Status","placeholder":"All","defaultValue":"0"},{"type":"serverSelect","name":"STATE","optionsSrc":"STATE","label":"State","placeholder":"All","defaultValue":""},{"type":"serverSelect","name":"COUNTY","optionsSrc":"COUNTY_SUBOPTION","label":"County","overrideSubOptionsSrcFromParameterName":"STATE","placeholder":"All","defaultValue":""},{"type":"checkbox","name":"CRA_SEARCH_YN","defaultValue":false,"label":"Search by Registered Agent PID"},{"type":"dateRange","name":"FILING_DATE","label":"Registration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}},{"type":"dateRange","name":"EXPIRATION_DATE","label":"Expiration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}}],"myRecordsFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Active"},{"value":2,"label":"Inactive"},{"value":3,"label":"Pending"}]},{"type":"dateRange","name":"DATE_RANGE","label":"Date range","defaultValue":{"start":null,"end":null}}],"myWorkQueueFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Approved"},{"value":2,"label":"Pending Online Payment"},{"value":3,"label":"Pending Review"},{"value":4,"label":"Needs Correction"},{"value":5,"label":"Rejected"},{"value":6,"label":"Draft"}]},{"type":"dateRange","name":"DATE_RANGE","label":"Date range","defaultValue":{"start":null,"end":null}}]},{"label":"Notary","component":"Notary","parameter":"notary","sourceTypeId":850,"myWorkQueueSearch":false,"allowEmptySearchTerm":true,"requestCertificateAlternateLabel":"Download Certificate","fileAmendmentButtonLabel":"Filing Actions","hideNameRequestCertificate":true,"hideAddressRequestCertificate":true,"hideRecordUserManagment":true,"searchPlaceholder":"Search by name or commission number","searchMustHaveOneOf":["CITY","search","SERVICE_TYPE"],"advancedParametersStartOpen":true,"searchIsSortable":true,"advancedSearchParameters":[{"type":"radio","name":"STARTS_WITH_YN","defaultValue":false,"options":[{"value":true,"label":"Starts with"},{"value":false,"label":"Contains"}]},{"type":"checkbox","name":"ACTIVE_ONLY_YN","defaultValue":true,"label":"Active entities only"},{"type":"text","name":"CITY","defaultValue":"","label":"City"},{"type":"select","name":"SERVICE_TYPE","label":"Special Services Offered","defaultValue":0,"options":[{"value":0,"label":"(N/A)"},{"value":6165,"label":"In-Person Electronic Notarization (IPEN)"},{"value":6166,"label":"Remote Online Notarization (RON)"},{"value":6167,"label":"Mobile Notary Services"},{"value":6168,"label":"Remote Ink Notarization (RIN)"}]}]},{"label":"Apostille","component":"Apostille","parameter":"apostille","sourceTypeId":720,"myRecordsSearch":false,"myWorkQueueSearch":false,"disabled":false,"allowedRoutes":["/forms-manager/","/queue/","/forms/"]},{"label":"Liens","component":"UCC","parameter":"ucc","sourceTypeId":1999,"myRecordsSearch":true,"myWorkQueueSearch":true,"fileAmendmentButtonLabel":"Filing Actions","searchPlaceholder":"Search by name or file number","disabled":false,"serverWebSearchDescription":true,"myRecordsDescription":"","workQueueDescription":"","searchDescription":"","hideRecordUserManagment":true,"searchLiensCheckout":false,"advancedSearchParameters":[{"type":"radio","name":"STARTS_WITH_YN","defaultValue":false,"options":[{"value":true,"label":"Starts with"},{"value":false,"label":"Contains"}]},{"type":"select","name":"STATUS","defaultValue":"ALL","label":"Status","options":[{"value":"ACTIVE_UNLAPSED","label":"Active (unlapsed)"},{"value":"ACTIVE_LAPSED_UNLAPSED","label":"Active (lapsed and unlapsed)"}]},{"type":"text","name":"EXCLUDE_VALUES","label":"Exclude Debtor Names (comma separated list of names to exclude)","defaultValue":""},{"type":"dateRange","name":"FILING_DATE","label":"Financing Statement Date","defaultValue":{"start":null,"end":null}},{"type":"dateRange","name":"LAPSE_DATE","label":"Lapse Date","defaultValue":{"start":null,"end":null}},{"type":"text","name":"CITY","label":"Debtor City","defaultValue":""}],"myRecordsFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Approved"},{"value":2,"label":"Pending Online Payment"},{"value":3,"label":"Pending Review"}]},{"type":"select","name":"TYPE","defaultValue":0,"label":"Lien Type","options":[{"value":0,"label":"All"},{"value":1,"label":"UCC"},{"value":2,"label":"EFS"},{"value":3,"label":"Title 71"}]}],"myWorkQueueFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Approved"},{"value":2,"label":"Pending Online Payment"},{"value":3,"label":"Pending Review"},{"value":4,"label":"Pending Print and Mail"},{"value":5,"label":"Rejected"},{"value":6,"label":"Draft"}]},{"type":"select","name":"TYPE","defaultValue":0,"label":"Lien Type","options":[{"value":0,"label":"All"},{"value":1,"label":"UCC"},{"value":2,"label":"EFS"},{"value":3,"label":"Title 71"}]}]},{"label":"Copy Request","component":"copies","parameter":"copies","sourceTypeId":2001,"myRecordsSearch":false,"myWorkQueueSearch":false,"disabled":false,"allowedRoutes":["/forms-manager/","/queue/","/forms/"]},{"label":"Trademark","component":"Trademark","parameter":"trademark","sourceTypeId":810,"showRequestCertificate":true,"searchMustHaveOneOf":["search","EXPIRATION_DATE","FILING_DATE"],"allowEmptySearchTerm":true,"requestCertificateAlternateLabel":"Request Information","fileAmendmentButtonLabel":"Filing Actions","advancedSearchParameters":[{"type":"radio","name":"QUERY_TYPE_ID","defaultValue":1010,"options":[{"value":1010,"label":"Starts with"},{"value":1011,"label":"Contains"},{"value":1012,"label":" Word Contains"}]},{"type":"checkbox","name":"OWNER_SEARCH_YN","defaultValue":false,"label":"Search owners"},{"type":"radio","name":"SERVICE_MARK_YN","label":"Mark Type","defaultValue":"","options":[{"value":"","label":"All Marks"},{"value":"Y","label":"Service Mark"},{"value":"N","label":"Trademark"}]},{"type":"serverSelect","name":"STATUS_ID","optionsSrc":"TYPE_V|TRADEMARK_STATUS_TYPE","label":"Status","placeholder":"All","defaultValue":"0"},{"type":"select","name":"DESIGN_TYPE_ID","options":[{"value":0,"label":"All"},{"value":990,"label":"Words Only"},{"value":991,"label":"Design Only"},{"value":992,"label":"Words and Design"}],"label":"Design Type","defaultValue":"0"},{"type":"dateRange","name":"FILING_DATE","label":"Registered Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}},{"type":"dateRange","name":"EXPIRATION_DATE","label":"Expiration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}}]},{"label":"Business Info Request","component":"InfoRequests","parameter":"info-request","sourceTypeId":167,"allowedRoutes":["/forms-manager/","/queue/","/forms/"]},{"label":"Data Requests","component":"DataRequests","parameter":"data-request","sourceTypeId":0,"allowedRoutes":["/forms-manager/"]},{"label":"CRA","component":"CRA","parameter":"cra","sourceTypeId":157,"myRecordsSearch":false,"searchPlaceholder":"Search by name or registered agent number","allowedRoutes":["/forms-manager/","/forms/","/records/","/queue/","/search/"],"allowEmptySearchTerm":true,"fileAmendmentButtonLabel":"Filing Actions","advancedSearchParameters":[{"type":"radio","name":"QUERY_TYPE_ID","defaultValue":1010,"options":[{"value":1010,"label":"Starts with"},{"value":1011,"label":"Contains"},{"value":1012,"label":" Word Contains"}]},{"type":"dateRange","name":"CRA_DATE","label":"Registration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}},{"type":"select","name":"STATUS_ID","label":"Status","defaultValue":0,"options":[{"value":0,"label":"All"},{"value":121,"label":"Active"},{"value":122,"label":"Inactive"}]},{"type":"select","name":"AGENT_TYPE_ID","label":"Agent Type","defaultValue":0,"options":[{"value":0,"label":"All"},{"value":460,"label":"Registered Agent"},{"value":461,"label":"Commercial Registered Agent"}]}]},{"label":"Farm Bill","component":"FarmBill","parameter":"farm-bill","path":"/lists/farm-bill","sourceTypeId":0,"myRecordsSearch":false,"allowedRules":["/search/"],"disabled":true,"searchDescription":"To perform a search, enter a debtor name. Your search results may include: exact debtor name, variations of that name and any filing that includes your search criteria. Punctuation is ignored.\n\nYou can click on \"Advanced\" to refine your search. Under “Advanced” you can search by crop, year, county and SSN/FEIN. As a registered Farm Bill Buyer with the Montana Secretary of State’s office it is important to maintain the confidentiality of the information contained within the Farm Bill Master List. The Farm Bill Master List reflects personal data, such as Social Security Numbers, which are a key piece of personal identifiable information to assist you in determining the existence of a lien against a specific debtor. The distribution of this information beyond its intended purpose is strictly prohibited.\n\nThe debtor's tax identification number has been hidden for confidentiality reasons. You may continue to search on a tax ID number and return debtors that match your search criteria. The SSN/FEIN must be entered without dashes or spaces.","searchMustHaveOneOf":["search","UCC_FARM_PRODUCT_ID","COUNTY"],"searchPlaceholder":"Search by debtor name","advancedSearchParameters":[{"type":"ServerMultiComplete","label":"Product code name(s)","name":"UCC_FARM_PRODUCT_ID","defaultValue":"","optionsSrc":"UCC_FARM_PRODUCT_V"},{"type":"MultiComplete","label":"Year or Range of Years","name":"YEAR_NUM","optionsSrc":"years","startYear":"1968","defaultValue":[],"preMergeOptions":[{"value":"ALL","label":"All"}]},{"type":"serverSelect","label":"State","name":"STATE","defaultValue":"MONTANA","optionsSrc":"STATE"},{"type":"ServerMultiComplete","label":"County","name":"COUNTY","defaultValue":[],"optionsSrc":"COUNTY","overrideSubOptionsSrcFromParameterName":"STATE"},{"type":"checkbox","name":"TIN_SEARCH_YN","defaultValue":false,"label":"Tax Identification Number Search"},{"type":"checkbox","name":"TIN_SORT_YN","defaultValue":false,"label":"Unique ID Sort"}]}],"SYSTEM_NICKNAME":"Online Services Portal","PAYMENT_METHODS":[{"type":"bypass"},{"type":"iTransact"}],"PAYMENT_ALLOW_AMEX":true,"SYSTEM_ID_LABEL":"System Id","DOUBLE_COLUMN_PUBLIC_LOGIN":true,"INTERNAL_USER_MANAGEMENT":true,"ALLOW_PUBLIC_JSON_IMPORT":false,"MAX_FILE_UPLOAD_SIZE":10000000,"REFUND_TEXT":"","RETURN_TO_HOME_ON_LOGOUT":true,"CURRENT_SOS_NAME":"Christi Jacobsen","LOGO_FILENAME":"mt-sos-logo.png","LOGO_ALT":"Christi Jacobsen, Montana Secretary of State","LOGO_FULL_WIDTH":true,"HOME_HIDE_AUTH_HINT":true,"HOME_TITLE":"Montana Secretary of State","CUSTOM_TAB_TITLE":"Official Montana","HOME_SUBTITLE":"Online Business Services","ENTITY_NAME_CONSENT_DESCRIPTION":"","ALLOW_USER_PROFILE_EDITING":true,"COMPARE_FOREIGN_NAME_IN_ENTITY_NAME_VALIDATION":true,"FOREIGN_NAME_FIELD_NAME":"KIMA_PARENT_NAME_INFO","LOGIN_TITLE":"Montana Secretary of State Online Filing Portal Login","PUBLIC_LOGIN_LABEL":"Username","REVERSE_LOGIN_COLUMNS":true,"LOGIN_SEAL_FILENAME":"seal_white.png","SEPARATE_USERNAME_AND_EMAIL":true,"CREATE_ACCOUNT_BUTTON_ALIGN_LEFT":true,"CREATE_ACCOUNT_BUTTON_TEXT":"CREATE AN ACCOUNT","PASSWORD_CUSTOM_ERROR_TEXT":"The password must meet all requirements","ACCOUNT_CREATED_MESSAGE":"Please check your email to verify your account to login and allow a few minutes for this message to arrive. Check your junk/spam folders if you do not find the email in your inbox.","PUBLIC_LOGIN_PLACEHOLDER":" ","DISABLE_DEFAULT_PAYMENT_RADIO":true,"CUSTOM_RESET_PASSWORD_ERROR_MESSAGE":"Username invalid - no account found","PUBLIC_LOGIN_CREATE_DESCRIPTION":"### Existing User:\n\n  - Enter your username and password to login.  \n\n\n  #### - OR -  \n\n\n\n  - Forgot password? Click 'Reset Password' and follow the prompts.\n  - Forgot username? Click 'Forgot Username' and follow the prompts.  \n\n\n  ### New User:\n  ","LOGIN_HELP_LINK":"https://sosmt.gov/business/how-do-i/","LOGIN_HELP_LINK_TEXT":"Need Help?","FORGOT_USERNAME_TEXT":"Forgot Username?","LOGIN_ACTIVE_DIRECTORY_TEXT":"State User Login","MULTIPLE_LOGIN_METHODS":true,"HAS_ACTIVE_DIRECTORY_LOGIN":true,"RESET_PASSWORD_WITH_USERNAME":true,"DOWNLOAD_LINK":true,"SHOW_USERNAME_ACCOUNT_CREATE":true,"SHOW_SCROLL_DOWN_ARROW":true,"SHOW_ADDRESS_ACCOUNT_CREATE":true,"TWO_COLUMN_ACCOUNT_CREATE":true,"RESET_PASSWORD_TIP":"A link to change your password has been sent to your email. Please allow a few minutes for this message to arrive. Please check your junk/spam folders if you do not find the email in your inbox.","FORGOT_PASSWORD_LINK_TEXT":"Reset Password","PHONE_NUMBER_OPTIONAL_ACCOUNT_CREATE":true,"SHOW_REQUIRED_INDICATOR_ACCOUNT_CREATE":true,"PASSWORD_REQUIREMENTS_ACCOUNT_CREATE":"\n    <ul>\n      <li>MUST contain at least 8 characters (12+ recommended)</li>\n      <li>MUST contain at least one uppercase letter.</li>\n      <li>MUST contain at least one lowercase letter.</li>\n      <li>MUST contain at least one number.</li>\n      <li>MUST contain at least one special character (!”#$%&'()*+,-./:;<=>?</li>\n    </ul>\n  ","ALLOW_CERTIFICATION_REQUEST":true,"ALLOW_PUBLIC_CERTIFICATE_REQUEST":true,"ALLOW_COPY_REQUEST":false,"ALLOW_CORRECTION_STYLING":true,"HIDE_DEPRECATION_WARNING":false,"AMEND_ROUTE_PUBLIC":true,"SEAL_FILENAME":"seal.png","SHOPPING_CART":true,"ALLOW_PAYMENT_UPDATE_WITH_EMPTY_CART":true,"RA_EMAIL":true,"RA_WEBSITE":true,"RA_NO_DEFAULT_TYPE":true,"RA_ADDRESS_LABEL":"Street Address","RA_TYPE_SELECTION_DEFAULT":true,"RA_DEFAULT_TYPE":"460","RA_OVERRIDE_TYPE_WITH_DEFAULT":true,"RA_PRINCIPAL_ADDRESS_AMS":true,"UPLOAD_AND_SUBMIT_HIDE_IF_ONE_OPTION":true,"PAYMENT_PROCESSING_MESSAGE":"Your payment is processing - Do not close your browser or click the back button","CHECKOUT_BUTTON_WHEN_PROCESSING_TEXT":"Processing","EFS_CROP_PICKER_NONE_LABEL":"Lien Duration","DISALLOWED_WIZARD_PIECES":["FormationLocale"],"REPEATER_SHOW_EDIT_BUTTON":true,"DATA_REQUEST_PAGE_TITLE":"Data Requests and Subscriptions","DATA_REQUEST_SIDEBAR_LABEL":"Data Requests & Subscriptions","LOGIN_REDIRECTS_TO_EPASS":false,"LOGIN_REDIRECTS_TO_ACTIVE_DIRECTORY":true,"LOGIN_ACTIVE_DIRECTORY_LINK":true,"FETCH_EDIT_USER_LINK":false,"LISTS_FETCH_AVAILABLE_LISTS":true,"POST_WIZARD_SUBMIT_REDIRECT_URL":"/","PIN_REQUEST_ATTESTATIONS":true,"PIN_REQUEST_DESCRIPTION":"Click **Request PIN** to have a new PIN sent to the account holder's email address on file.","OWNERSHIP_REQUEST_DESCRIPTION":"To become an **authorized user** of this record, a current **AUTHORIZED USER** will need to grant you access. To request access, click **Request Access** below.","PIN_REQUEST_SUCCESS_MESSAGE":"The PIN you have requested for this entity has been sent to the email associated with your user account.  You should receive the PIN in approximately 3-5 minutes, depending on your email service provider.","APOSTILLE_HEADER_LABEL":"Verification Information","APOSTILLE_NUMBER_LABEL":"Apostille/Authentication","APOSTILLE_CITY_STATE_OVERRIDE":"HELENA, MT","APOSTILLE_FILING_DATE_LABEL":"Issue Date","APOSTILLE_CITY_STATE_IN_CERTIFIED":true,"NOTARY_EXISTING_FILING":true,"ALLOW_REVOKE_OWN_ACCESS_ONLY":false,"HIDE_CANCEL_ON_ONETIME_DATA_REQUESTS":true,"DATA_REQUESTS_IN_SHOPPING_CART":true,"WQ_ALLOW_EDIT_PENDING_PAYMENT":true,"WQ_CONFIRM_ON_DELETE":true,"WQ_DELETE_CONFIRM_MESSAGE":"Deleting this filing will forfeit any money already paid to the Secretary of State. This action is permanent and cannot be undone, are you sure you would like to delete?","PASS_ITEM_GUIDS_ON_CHECKOUT":true,"FORM_REVISION_HISTORY":true,"CHECKOUT_DISCLAIMER":"By entering your credit card and/or checking account information you (i) state that **you are an authorized user** of the credit card and/or electronic check and that the associated information entered (e.g., account holder name, account number, billing address) is accurate, (ii) **you authorize payment processor to charge the amount you have requested** to your credit card and/or funding account, and (iii) **acknowledge if a charge is declined or reversed you may also be assessed a customary charge** by the payment processor for such transactions.","FARM_BILL_SEARCH_CONFIDENTIAL":"As a registered Farm Bill Buyer with the Montana Secretary of State’s office it is important to maintain the confidentiality of the information contained within the Farm Bill Master List. The Farm Bill Master List reflects personal data, such as Social Security Numbers, which are a key piece of personal identifiable information to assist you in determining the existence of a lien against a specific debtor. The distribution of this information beyond its intended purpose is strictly prohibited.\n\n**The debtor's tax identification number has been hidden for confidentiality reasons. You may continue to search on a tax ID number and return debtors that match your search criteria. The SSN/FEIN must be entered without dashes or spaces.  If you need access to the tax identification number to clearly identify the debtor, please contact the UCC unit at (406) 444-3665.**","VIEW_HISTORY_BUTTON_ALT_TEXT":"View Filings","WIZARD_ERROR_TITLE_MESSAGE":"Form Error","FARM_BILL_SEARCH_INTERACTIVE":true,"USE_FARM_BILL_API":true,"DISALLOW_ASSIGN_SELF_AS_RA":true,"DISALLOW_ASSIGN_SELF_AS_PRINCIPAL":true,"USE_TRADEMARK_OWNER_VALIDATION":true,"USE_ALTERNATIVE_FOREIGN_ADDRESS_LABELS":true,"MY_RECEIPTS_FILTER":[{"type":"dateRange","name":"DATE_RANGE","label":"Date range","defaultValue":{"start":null,"end":null}},{"type":"text","name":"REF_NUM","defaultValue":"","label":"Reference Number"},{"type":"text","name":"RECEIPT_NUM","defaultValue":"","label":"Receipt Id"},{"type":"text","name":"AMOUNT","defaultValue":"","label":"Amount"},{"type":"select","name":"TYPE","defaultValue":"","label":"Payment Type","options":[{"value":"","label":"All"},{"value":"CC","label":"Credit Card"},{"value":"Check","label":"Check"}]}],"MY_RECEIPTS_SHOW_IN_SIDEBAR":true,"SHOW_MY_RECEIPTS_HELPER_TEXT":true,"MY_RECEIPTS_HELPER_LABEL":"About Receipt Search","MY_RECEIPTS_HELPER_TEXT":"You can search for receipts based on their descriptions, including the items paid for on the receipt. Use the filters to search for or filter specific information.","FARM_BILL_SUBLINK":{"label":"Farm Bill","component":"FarmBill","parameter":"farm-bill","path":"/lists/farm-bill","sourceTypeId":0,"myRecordsSearch":false,"allowedRules":["/search/"],"disabled":true,"searchDescription":"To perform a search, enter a debtor name. Your search results may include: exact debtor name, variations of that name and any filing that includes your search criteria. Punctuation is ignored.\n\nYou can click on \"Advanced\" to refine your search. Under “Advanced” you can search by crop, year, county and SSN/FEIN. As a registered Farm Bill Buyer with the Montana Secretary of State’s office it is important to maintain the confidentiality of the information contained within the Farm Bill Master List. The Farm Bill Master List reflects personal data, such as Social Security Numbers, which are a key piece of personal identifiable information to assist you in determining the existence of a lien against a specific debtor. The distribution of this information beyond its intended purpose is strictly prohibited.\n\nThe debtor's tax identification number has been hidden for confidentiality reasons. You may continue to search on a tax ID number and return debtors that match your search criteria. The SSN/FEIN must be entered without dashes or spaces.","searchMustHaveOneOf":["search","UCC_FARM_PRODUCT_ID","COUNTY"],"searchPlaceholder":"Search by debtor name","advancedSearchParameters":[{"type":"ServerMultiComplete","label":"Product code name(s)","name":"UCC_FARM_PRODUCT_ID","defaultValue":"","optionsSrc":"UCC_FARM_PRODUCT_V"},{"type":"MultiComplete","label":"Year or Range of Years","name":"YEAR_NUM","optionsSrc":"years","startYear":"1968","defaultValue":[],"preMergeOptions":[{"value":"ALL","label":"All"}]},{"type":"serverSelect","label":"State","name":"STATE","defaultValue":"MONTANA","optionsSrc":"STATE"},{"type":"ServerMultiComplete","label":"County","name":"COUNTY","defaultValue":[],"optionsSrc":"COUNTY","overrideSubOptionsSrcFromParameterName":"STATE"},{"type":"checkbox","name":"TIN_SEARCH_YN","defaultValue":false,"label":"Tax Identification Number Search"},{"type":"checkbox","name":"TIN_SORT_YN","defaultValue":false,"label":"Unique ID Sort"}]},"ALLOW_ADDRESS_VALIDATION_BYPASS_OPTION":true,"DEFAULT_ADDRESS_VALIDATION_BYPASS_OPTION_CHECKED":true}).PREVENT_WIZARD_SUBMISSION_WITH_UPLOAD_FAILURE) {
	        uploadPlaceholders.map(function (placeholder) {
	          if (computedValue[placeholder.fieldId] && computedValue[placeholder.fieldId].find(function (file) {
	            return file.status === 'failed';
	          })) {
	            callback(false, 'At least one upload failed');
	          }
	        });
	      }
	      var rulePromises = uploadPlaceholders.map(function (placeholder) {
	        return new Promise(function (resolve) {
	          loopThroughRules({
	            businessRules: placeholder.businessRules,
	            value: computedValue[placeholder.fieldId],
	            field: placeholder,
	            event: 'deferred'
	          }, function (validation) {
	            resolve(Object.assign({}, validation, { fieldId: placeholder.fieldId }));
	          });
	        });
	      });
	      Promise.all(rulePromises).then(function (values) {
	        var allValid = values.reduce(function (isValid, currentVal) {
	          if (currentVal.valids.includes(false)) {
	            return false;
	          } else {
	            return isValid;
	          }
	        }, true);
	        var validations = values.reduce(function (valueObject, currentVal) {
	          valueObject[currentVal.fieldId] = Object.assign({}, currentVal, {
	            isValid: !currentVal.valids.includes(false)
	          });
	          return valueObject;
	        }, {});
	        callback(allValid, validations);
	      });
	    }
	  },
	  uploadRequired: function uploadRequired(value, field) {
	    var props = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	    var callback = arguments[3];
	
	    if (!Array.isArray(value)) {
	      callback(false, 'Upload is required');
	    } else {
	      var atLeastOneUploadSucceeded = value.find(function (file) {
	        return file.status === 'success';
	      });
	      if (value.length > 0 && atLeastOneUploadSucceeded) {
	        callback(true, '');
	      } else {
	        callback(false, 'Upload is required');
	      }
	    }
	  },
	  uploadImmediatelyRequired: function uploadImmediatelyRequired(value, field) {
	    var props = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	    var callback = arguments[3];
	
	    if (!Array.isArray(value)) {
	      callback(false, 'Upload is required');
	    } else {
	      var atLeastOneUploadSucceeded = value.find(function (file) {
	        return file.status === 'success';
	      });
	      if (value.length > 0 && atLeastOneUploadSucceeded) {
	        callback(true, '');
	      } else {
	        callback(false, 'Upload is required');
	      }
	    }
	  },
	  allSignaturesRequired: function allSignaturesRequired(value, field) {
	    var props = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	    var callback = arguments[3];
	
	    var fields = _store2.default.getState().wizard.wizard.fields;
	    var printMailRequired = _store2.default.getState().wizard.requirePrintMailMethod.size > 0;
	    var srcRepeater = fields[field.srcRepeater] ? fields[field.srcRepeater] : null;
	    if (!printMailRequired) {
	      if (field.multiple) {
	        if (srcRepeater) {
	          if (srcRepeater.value.length === value.length) {
	            var allSignaturesFilled = value.length > 0 ? value.every(function (signature) {
	              return valueIsNotEmptyOrNull(signature.sig) && valueIsNotEmptyOrNull(signature.date) && (field.showCapacity ? valueIsNotEmptyOrNull(signature.capacity) : true);
	            }) : true;
	            if (allSignaturesFilled) {
	              callback(true, '');
	            } else {
	              callback(false, 'All signatures are required.');
	            }
	          } else {
	            callback(false, 'All signatures are required.');
	          }
	        } else {
	          callback(false, '');
	        }
	      } else {
	        if (value.length === 0) {
	          callback(false, 'All signature fields are required.');
	        } else {
	          if (valueIsNotEmptyOrNull(value[0].sig) && valueIsNotEmptyOrNull(value[0].date) && (field.showCapacity ? valueIsNotEmptyOrNull(value[0].capacity) && (value[0].capacity !== 'self' ? valueIsNotEmptyOrNull(value[0].behalf) : true) : true)) {
	            callback(true, '');
	          } else {
	            callback(false, 'All signature fields are required.');
	          }
	        }
	      }
	    } else {
	      callback(null, '');
	    }
	  },
	  minRequiredSignatures: function minRequiredSignatures(value, field) {
	    var props = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	    var callback = arguments[3];
	
	    var fields = _store2.default.getState().wizard.wizard.fields;
	    var srcRepeater = fields[field.srcRepeater] ? fields[field.srcRepeater] : null;
	    var minRequiredSignatures = props.minRequiredSignatures;
	    var signatureCount = 0;
	    var signatureFieldsComplete = true;
	    if (field.multiple) {
	      if (srcRepeater) {
	        if (srcRepeater.value.length === value.length && value.length > 0) {
	          value.forEach(function (signature) {
	            if (valueIsNotEmptyOrNull(signature.sig) && valueIsNotEmptyOrNull(signature.date) && (field.showCapacity ? valueIsNotEmptyOrNull(signature.capacity) : true)) {
	              signatureCount++;
	              signatureFieldsComplete = true;
	            } else {
	              signatureFieldsComplete = false;
	            }
	          });
	
	          if (signatureCount >= minRequiredSignatures) {
	            callback(true, '');
	          } else if (!signatureFieldsComplete) {
	            callback(false, 'All signature fields are required.');
	          } else {
	            callback(false, 'At least ' + minRequiredSignatures + ' signature' + (minRequiredSignatures > 1 ? 's' : '') + ' required.');
	          }
	        } else {
	          callback(false, 'At least ' + minRequiredSignatures + ' signature' + (minRequiredSignatures > 1 ? 's' : '') + ' required');
	        }
	      } else {
	        callback(false, 'This repeater has been configured incorrectly');
	      }
	    } else {
	      if (value.length === 0) {
	        callback(false, 'All signature fields are required.');
	      } else {
	        if (valueIsNotEmptyOrNull(value[0].sig) && valueIsNotEmptyOrNull(value[0].date) && (field.showCapacity ? valueIsNotEmptyOrNull(value[0].capacity) && (value[0].capacity !== 'self' ? valueIsNotEmptyOrNull(value[0].behalf) : true) : true)) {
	          callback(true, '');
	        } else {
	          callback(false, 'All signature fields are required.');
	        }
	      }
	    }
	  },
	  signaturesMinLength: function signaturesMinLength(value, field) {
	    var props = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	    var callback = arguments[3];
	
	    var isSignatureMinLength = true;
	
	    if (field.multiple) {
	      value.forEach(function (signature) {
	        if (signature.sig.length < props.signaturesMinLength && valueIsNotEmptyOrNull(signature.sig) || signature.behalf.length < props.signaturesMinLength && valueIsNotEmptyOrNull(signature.behalf)) {
	          isSignatureMinLength = false;
	        }
	      });
	
	      if (isSignatureMinLength === false) {
	        callback(false, props.errorMessage !== '' ? props.errorMessage : 'Signatures do not meet the minimum length requirement.');
	      } else {
	        callback(true, '');
	      }
	    } else {
	      if (valueIsNotEmptyOrNull(value[0].sig) || valueIsNotEmptyOrNull(value[0].behalf)) {
	        if (value[0].sig.length < props.signaturesMinLength && valueIsNotEmptyOrNull(value[0].sig) || value[0].behalf.length < props.signaturesMinLength && valueIsNotEmptyOrNull(value[0].behalf)) {
	          callback(false, props.errorMessage !== '' ? props.errorMessage : 'Signatures do not meet the minimum length requirement.');
	        } else {
	          callback(true, '');
	        }
	      } else {
	        callback(null, '');
	      }
	    }
	  },
	  formationLocaleRequired: function formationLocaleRequired(value, field) {
	    var props = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	    var callback = arguments[3];
	
	    if (valueIsNotEmptyOrNull(value.FORMATION_TYPE)) {
	      if (valueIsNotEmptyOrNull(value[value.FORMATION_TYPE])) {
	        callback(true, '');
	      } else {
	        callback(false, props.errorMessage || 'Formation locale is required');
	      }
	    } else {
	      callback(false, props.errorMessage || 'Formation locale is required');
	    }
	  },
	  validateEntityNameFields: function validateEntityNameFields(value, field) {
	    var props = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	    var callback = arguments[3];
	    var _ref2 = arguments[4];
	    var event = _ref2.event,
	        subField = _ref2.subField;
	
	    var onFirstBlurRules = ['entityNameNotTaken', 'entityIsValidName', 'entityNameRequired', 'customBusinessRules'];
	    var onSecondBlurRules = ['entityNameNotTaken', 'entityValuesMatch', 'entityNameRequired', 'entityIsValidName', 'customBusinessRules'];
	    var onBlurRules = [].concat(onFirstBlurRules, ['entityValuesMatch']);
	    var rules = [].concat(_toConsumableArray(Object.keys(props).filter(function (ruleId) {
	      return ruleId !== 'filingTypeId' && ruleId !== 'filingSubtypeId';
	    })), _toConsumableArray(onBlurRules), ['mustSelectReservedOption', 'mustSelectAdditionalOption', 'mustSelectConsentOption']);
	    var executableRules = rules;
	    if (event === 'onBlur') {
	      if (subField === 'first') executableRules = onFirstBlurRules;
	      if (subField === 'second') executableRules = onSecondBlurRules;
	    }
	    var removableRules = [];
	    if (value.additionalYN === 'Y') {
	      removableRules.push('entityIsValidName');
	      removableRules.push('entityNameNotTaken');
	    }
	    if (props.disableNameNotTakenCheck) {
	      removableRules.push('entityNameNotTaken');
	    }
	    executableRules = executableRules.filter(function (ruleId) {
	      return !removableRules.includes(ruleId);
	    });
	
	    var customRules = undefined;
	
	    var fieldRules = field.businessRules.find(function (rule) {
	      return rule.fn === 'customBusinessRules';
	    });
	
	    // if fields are populated
	    if (fieldRules && fieldRules.props && fieldRules.props.rules) {
	      customRules = fieldRules.props.rules;
	    }
	
	    var rulePromises = executableRules.map(function (ruleId) {
	      return new Promise(function (resolve) {
	        getIsValid(ruleId, value, field, { filingTypeId: props.filingTypeId, filingSubtypeId: props.filingSubtypeId, rules: customRules }, function (isValid, errorMessage, payload) {
	          resolve({ ruleId: ruleId, isValid: isValid, errorMessage: errorMessage, payload: payload });
	        });
	      });
	    });
	    Promise.all(rulePromises).then(function (values) {
	      var allValid = !values.some(function (result) {
	        return result.isValid === false;
	      });
	      var errors = values.reduce(function (obj, current) {
	        return Object.assign({}, obj, _defineProperty({}, current.ruleId, { isValid: current.isValid, errorMessage: [current.errorMessage] }));
	      }, {});
	      var payloads = values.reduce(function (obj) {
	        var current = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	        return Object.assign({}, obj, current.payload);
	      }, {});
	      if (event === 'onBlur' && subField === 'first' && allValid) {
	        payloads.nameMatch = null;
	      }
	      payloads.setValue = false;
	      callback(allValid, errors, payloads);
	    });
	  },
	  mustSelectReservedOption: function mustSelectReservedOption(value, field) {
	    var props = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	    var callback = arguments[3];
	
	    if (value.reservedYN === 'Y' || value.reservedYN === 'N' || field.hideReserved) {
	      callback(true, '');
	    } else {
	      callback(false, 'This field is required.');
	    }
	  },
	  mustSelectReservedName: function mustSelectReservedName(value, field) {
	    var props = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	    var callback = arguments[3];
	
	    var resNameCheckOuter = [];
	    api.GET_WEB_USER_RECORD({
	      searchType: 'RESERVED_NAME',
	      metadata: _store2.default.getState().wizard.wizard.meta,
	      correctionMode: _store2.default.getState().wizard.correctionMode
	    }, function (resNameCheck) {
	      if (callback) {
	        resNameCheckOuter = (resNameCheck && Array.isArray(resNameCheck) ? resNameCheck : []).map(function (name) {
	          return {
	            value: name.SOURCE_ID,
	            label: '' + name.NAME,
	            num: name.SOURCE_NUM,
	            name: name.NAME
	          };
	        });
	      }
	      if (value.reservedYN === 'Y') {
	        if (valueIsNotEmptyOrNull(value.reservedNameId) && resNameCheckOuter.length > 0 && resNameCheckOuter.some(function (item) {
	          return item.value === Number(value.reservedNameId);
	        })) {
	          callback(true, '');
	        } else {
	          callback(false, 'Please select a reserved name with which you wish to file.');
	        }
	      } else {
	        callback(null, '');
	      }
	    });
	  },
	  entityNameRequired: function entityNameRequired(value, field) {
	    var props = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	    var callback = arguments[3];
	
	    if (value.reservedYN === 'N' || field.hideReserved || field.allowReservedNameEditing && value.reservedYN === 'Y') {
	      if (valueIsNotEmptyOrNull(value.val1)) {
	        callback(true, '');
	      } else {
	        callback(false, 'Please provide the entity name to continue.');
	      }
	    } else {
	      callback(null, '');
	    }
	  },
	  mustSelectAdditionalOption: function mustSelectAdditionalOption(value, field) {
	    var props = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	    var callback = arguments[3];
	
	    if ((value.reservedYN === 'N' || field.hideReserved) && !field.hideAdditionalName) {
	      if (value.additionalYN === 'Y' || value.additionalYN === 'N') {
	        callback(true, '');
	      } else {
	        callback(false, 'This field is required.');
	      }
	    } else {
	      callback(null, '');
	    }
	  },
	  mustSelectAdditionalName: function mustSelectAdditionalName(value, field) {
	    var props = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	    var callback = arguments[3];
	
	    if ((value.reservedYN === 'N' || field.hideReserved) && value.additionalYN == 'Y') {
	      if (valueIsNotEmptyOrNull(value.additionalNameId)) {
	        callback(true, '');
	      } else {
	        callback(false, 'Please select a name to continue.');
	      }
	    } else {
	      callback(null, '');
	    }
	  },
	  mustSelectConsentOption: function mustSelectConsentOption(value, field) {
	    var props = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	    var callback = arguments[3];
	
	    if (!field.hideConsent && (value.reservedYN === 'N' || field.hideReserved) && (value.additionalYN === 'N' || field.hideAdditionalName)) {
	      if (value.consentYN === 'Y' || value.consentYN === 'N') {
	        callback(true, '');
	      } else {
	        callback(false, 'This field is required.');
	      }
	    } else {
	      callback(null, '');
	    }
	  },
	  numConsentsRequired: function numConsentsRequired(value, field) {
	    var props = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	    var callback = arguments[3];
	
	    if ((value.reservedYN === 'N' || field.hideReserved) && (value.additionalYN === 'N' || field.hideAdditionalName) && value.consentYN === 'Y' && !field.hideNumConsent) {
	      if (valueIsNotEmptyOrNull(value.numConsents) && valueIsANumber(value.numConsents)) {
	        if (value.numConsents <= 100) {
	          callback(true, '');
	        } else {
	          callback(false, 'The number of consents cannot exceed 100.');
	        }
	      } else {
	        callback(false, 'Please provide the number of consents to continue.');
	      }
	    } else {
	      callback(null, '');
	    }
	  },
	  entityValuesMatch: function entityValuesMatch(value, field) {
	    var props = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	    var callback = arguments[3];
	
	    if (value.reservedYN === 'N' || field.hideReserved) {
	      VALIDATE.valuesMatch(value, field, props, function (isValid, errorMessage) {
	        callback(isValid, errorMessage, { nameMatch: isValid });
	      });
	    } else {
	      callback(null, '');
	    }
	  },
	  entityNameNotTaken: function entityNameNotTaken(value, field) {
	    var props = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	    var callback = arguments[3];
	
	    if ((value.reservedYN === 'N' || field.hideReserved || field.allowReservedNameEditing) && value.consentYN !== 'Y') {
	      VALIDATE.nameNotTaken(value, field, props, function (isValid, errorMessage) {
	        callback(isValid, errorMessage);
	      });
	    } else {
	      callback(null, '');
	    }
	  },
	  enitityHasNameEnding: function enitityHasNameEnding(value, field) {
	    var props = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	    var callback = arguments[3];
	
	    if (value.reservedYN === 'N' || field.hideReserved) {
	      VALIDATE.hasNameEnding(value, field, props, function (isValid, errorMessage) {
	        callback(isValid, errorMessage);
	      });
	    } else {
	      callback(null, '');
	    }
	  },
	  entityNoRegulatedWords: function entityNoRegulatedWords(value, field) {
	    var props = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	    var callback = arguments[3];
	
	    if (value.reservedYN === 'N' || field.hideReserved) {
	      VALIDATE.noRegulatedWords(value, field, props, function (isValid, errorMessage) {
	        callback(isValid, errorMessage);
	      });
	    } else {
	      callback(null, '');
	    }
	  },
	  entityIsValidName: function entityIsValidName(value, field) {
	    var props = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	    var callback = arguments[3];
	
	    if (value.reservedYN === 'N' || field.hideReserved || field.allowReservedNameEditing && value.reservedYN === 'Y') {
	      VALIDATE.isValidName(value, field, props, function (isValid, errorMessage, payload) {
	        callback(isValid, errorMessage, payload);
	      });
	    } else {
	      callback(null, '');
	    }
	  },
	  mailingPoBoxNotAllowed: function mailingPoBoxNotAllowed(value, field) {
	    var props = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	    var callback = arguments[3];
	
	    VALIDATE.poBoxNotAllowed(value.MAIL_ADDR, field, props, callback);
	  },
	  poBoxNotAllowed: function poBoxNotAllowed(value, field) {
	    var props = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	    var callback = arguments[3];
	
	    var poBoxRegex = /\b(?:p\.?\s*o\.?|post\s+office)(\s+)?(?:box|b|[0-9]*)?\b.*/i;
	    var pmbRegex = /\b(?:p(?:ersonal)?\.?\s*[m](?:ail)?\s*b(?:[o]x)?).*/i; //Personal Mail Box pattern
	    if (emptyExceptDefaultState(value, field)) {
	      callback(null, '');
	    } else if (poBoxRegex.test(value.ADDR1) || poBoxRegex.test(value.ADDR2) || poBoxRegex.test(value.ADDR3) || pmbRegex.test(value.ADDR1) || pmbRegex.test(value.ADDR2) || pmbRegex.test(value.ADDR3) || value.ADDR1.toLowerCase().startsWith('box ') || value.ADDR2.toLowerCase().startsWith('box ') || value.ADDR3.toLowerCase().startsWith('box ')) {
	      callback(false, props.errorMessage || 'Address may not contain a PO Box');
	    } else {
	      callback(true, '');
	    }
	  },
	  dateRangeRequired: function dateRangeRequired(value, field) {
	    var props = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	    var callback = arguments[3];
	
	    if (valueIsNotEmptyOrNull(value.start) && valueIsNotEmptyOrNull(value.end)) {
	      callback(true, '');
	    } else {
	      callback(false, props.errorMessage || 'A date range is required.');
	    }
	  },
	  minDate: function minDate(value, field) {
	    var props = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	    var callback = arguments[3];
	
	    if (props.minDateOptions !== 'custom') {
	      api.VALIDATE('MinServerDate', {
	        value: value,
	        source: props.minDateOptions,
	        metadata: _store2.default.getState().wizard.wizard.meta
	      }, function (valid) {
	        callback(valid.valid, valid.error);
	      });
	    } else {
	      if ((0, _isAfter2.default)(new Date(value), new Date(props.customMinDate))) {
	        callback(true, '');
	      } else {
	        callback(false, props.errorMessage || 'Please select a date after ' + props.customMinDate);
	      }
	    }
	  },
	  maxDate: function maxDate(value, field) {
	    var props = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	    var callback = arguments[3];
	
	    if (props.maxDateOptions !== 'custom') {
	      api.VALIDATE('MaxServerDate', {
	        value: value,
	        source: props.maxDateOptions,
	        metadata: _store2.default.getState().wizard.wizard.meta
	      }, function (valid) {
	        callback(valid.valid, valid.error);
	      });
	    } else {
	      if ((0, _isBefore2.default)(new Date(value), new Date(props.customMaxDate))) {
	        callback(true, '');
	      } else {
	        callback(false, props.errorMessage || 'Please select a date before ' + props.customMaxDate);
	      }
	    }
	  },
	  minDateRange: function minDateRange(value, field) {
	    var props = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	    var callback = arguments[3];
	
	    if (props.minDateOptions !== 'custom') {
	      api.VALIDATE('MinServerDate', {
	        value: value.start,
	        source: props.minDateOptions,
	        metadata: _store2.default.getState().wizard.wizard.meta
	      }, function (valid) {
	        callback(valid.valid, valid.error);
	      });
	    } else if ((0, _isAfter2.default)(new Date(value.start), new Date(props.customMinDate))) {
	      callback(true, '');
	    } else {
	      callback(false, props.errorMessage || 'Please select a date after ' + props.customMinDate);
	    }
	  },
	  maxDateRange: function maxDateRange(value, field) {
	    var props = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	    var callback = arguments[3];
	
	    if (props.minDateOptions !== 'custom') {
	      api.VALIDATE('MaxServerDate', {
	        value: value.end,
	        source: props.minDateOptions,
	        metadata: _store2.default.getState().wizard.wizard.meta
	      }, function (valid) {
	        callback(valid.valid, valid.error);
	      });
	    } else if ((0, _isBefore2.default)(new Date(value.end), new Date(props.customMaxDate))) {
	      callback(true, '');
	    } else {
	      callback(false, props.errorMessage || 'Please select a date before ' + props.customMaxDate);
	    }
	  },
	  repeaterColumnsMustBeUnique: function repeaterColumnsMustBeUnique(value, field) {
	    var props = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	    var callback = arguments[3];
	
	    var constraints = props.constraints;
	    var rows = field.value.filter(function (row) {
	      return row._statusId !== 3;
	    });
	    var fields = _store2.default.getState().wizard.wizard.fields;
	    var results = (0, _utilities.testRepeaterConstraints)(constraints, rows, fields);
	    var errors = results.reduce(function (errs, result, i) {
	      if (result === false) {
	        var constraint = constraints[i];
	        var constFields = constraint.fields.map(function (fieldId) {
	          return fields[fieldId] ? fields[fieldId].shortLabel || fields[fieldId].label : null;
	        }).filter(function (x) {
	          return x;
	        });
	        return [].concat(_toConsumableArray(errs), [constraint.errorMessage || 'At least one of the following fields must be unique: ' + constFields.join(', ') + '. \n']);
	      }
	      return errs;
	    }, []);
	    var isValid = results.every(function (t) {
	      return t === true;
	    });
	    callback(isValid, errors);
	  },
	  isValidEmailFormat: function isValidEmailFormat(value, field) {
	    var props = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	    var callback = arguments[3];
	
	    // base regex retrieved from https://regexr.com/2rhq7
	    var regex = /^[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?!.*@)(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?$/gi;
	    var sanitizedValue = ((field.type === 'confirmFields' ? value.val1 : value) || '').trim();
	    if (valueIsNotEmptyOrNull(sanitizedValue)) {
	      var isValid = regex.test(sanitizedValue) && !sanitizedValue.includes(' ');
	      if (isValid) {
	        callback(true, '');
	      } else {
	        callback(false, props.errorMessage || 'Please enter a properly formatted email address.');
	      }
	    } else {
	      callback(null, '');
	    }
	  },
	  timeRequired: function timeRequired(value, field) {
	    var props = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	    var callback = arguments[3];
	
	    if (value.length >= 7) {
	      callback(true, '');
	    } else {
	      callback(false, props.errorMessage || 'This field is required.');
	    }
	  },
	  uccSearchRequired: function uccSearchRequired(value, field) {
	    var props = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	    var callback = arguments[3];
	
	    var UCC4Satisfied = field.uccMode.toString() === '4' ? value.search.SEARCH_UCC || value.search.SEARCH_GOV || value.search.SEARCH_EFS || value.search.SEARCH_CROP_LIEN || value.search.SEARCH_AG_LIEN : true;
	    var commonFieldCheck = (value.search.IS_ORG === true || value.search.IS_ORG === 'true' ? value.search.SEARCH_ORG_NAME : ({"NODE_ENV":"production","BUILD_DATE":"2025-08-27T15:15:31.687Z","BUILD_NUMBER":"Not Provided","GIT_VERSION":"v1.3.0-381-ga81e29b08","GIT_COMMIT_HASH":"a81e29b085c9268ffd96c78eb734365802722741","GIT_BRANCH":"beta","PUBLIC_URL":"","STATE_ABBR":"MT","STATE_NAME":"Montana","STATE_ORG_TITLE":"Secretary of State","LOGIN_HEADER_IMG_PATH":"","HOME_IMG_FILENAME":"montana.jpg","FAVICON_FILE_NAME":"favicon.ico","ALLOW_E_SIGN_ON_CORRECTIONS":true,"THIRD_PARTY_SIGNING_ALLOWED":false,"MY_ACCOUNT_SAVE_AND_CLOSE_BUTTON":true,"IE_DEPRECATED_MESSAGE":"Internet Explorer is not supported. Please select a supported browser below to access this website.","ADDITIONAL_ROUTES":{"dataRequests":true,"farmBill":true,"apostille":true,"externalHelp":"https://sosmt.gov/business/help-center/","systemAdministration":[{"title":"Saved Payments","parameter":"saved-payments","componentName":"SavedPayments"}]},"SUBROUTES":[{"label":"Business","component":"Business","parameter":"business","myWorkQueueSearch":false,"sourceTypeId":54,"searchMustHaveOneOf":["FILING_TYPE_ID","STATUS_ID","STATE","search"],"serverWebSearchDescription":true,"serverWorkQueueDescription":true,"serverMyRecordsDescription":true,"searchPlaceholder":"Search by name or filing number (X########)","allowEmptySearchTerm":true,"requestCertificateAlternateLabel":"Request Information","fileAmendmentButtonLabel":"Filing Actions","advancedSearchParameters":[{"type":"radio","name":"QUERY_TYPE_ID","defaultValue":1010,"options":[{"value":1010,"label":"Starts with"},{"value":1011,"label":"Contains"},{"value":1012,"label":" Word Contains"}]},{"type":"serverSelect","name":"FILING_TYPE_ID","optionsSrc":"FILING_TYPES","label":"Entity Type","placeholder":"All","defaultValue":"0"},{"type":"serverSelect","name":"FILING_SUBTYPE_ID","optionsSrc":"FILING_SUBTYPES","label":"Entity Subtype","overrideSubOptionsSrcFromParameterName":"FILING_TYPE_ID","placeholder":"All","defaultValue":"0"},{"type":"serverSelect","name":"STATUS_ID","optionsSrc":"FILING_STATUS_WITHOUT_ALL","label":"Status","placeholder":"All","defaultValue":"0"},{"type":"serverSelect","name":"STATE","optionsSrc":"STATE","label":"State","placeholder":"All","defaultValue":""},{"type":"serverSelect","name":"COUNTY","optionsSrc":"COUNTY_SUBOPTION","label":"County","overrideSubOptionsSrcFromParameterName":"STATE","placeholder":"All","defaultValue":""},{"type":"checkbox","name":"CRA_SEARCH_YN","defaultValue":false,"label":"Search by Registered Agent PID"},{"type":"dateRange","name":"FILING_DATE","label":"Registration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}},{"type":"dateRange","name":"EXPIRATION_DATE","label":"Expiration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}}],"myRecordsFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Active"},{"value":2,"label":"Inactive"},{"value":3,"label":"Pending"}]},{"type":"dateRange","name":"DATE_RANGE","label":"Date range","defaultValue":{"start":null,"end":null}}],"myWorkQueueFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Approved"},{"value":2,"label":"Pending Online Payment"},{"value":3,"label":"Pending Review"},{"value":4,"label":"Needs Correction"},{"value":5,"label":"Rejected"},{"value":6,"label":"Draft"}]},{"type":"dateRange","name":"DATE_RANGE","label":"Date range","defaultValue":{"start":null,"end":null}}]},{"label":"Notary","component":"Notary","parameter":"notary","sourceTypeId":850,"myWorkQueueSearch":false,"allowEmptySearchTerm":true,"requestCertificateAlternateLabel":"Download Certificate","fileAmendmentButtonLabel":"Filing Actions","hideNameRequestCertificate":true,"hideAddressRequestCertificate":true,"hideRecordUserManagment":true,"searchPlaceholder":"Search by name or commission number","searchMustHaveOneOf":["CITY","search","SERVICE_TYPE"],"advancedParametersStartOpen":true,"searchIsSortable":true,"advancedSearchParameters":[{"type":"radio","name":"STARTS_WITH_YN","defaultValue":false,"options":[{"value":true,"label":"Starts with"},{"value":false,"label":"Contains"}]},{"type":"checkbox","name":"ACTIVE_ONLY_YN","defaultValue":true,"label":"Active entities only"},{"type":"text","name":"CITY","defaultValue":"","label":"City"},{"type":"select","name":"SERVICE_TYPE","label":"Special Services Offered","defaultValue":0,"options":[{"value":0,"label":"(N/A)"},{"value":6165,"label":"In-Person Electronic Notarization (IPEN)"},{"value":6166,"label":"Remote Online Notarization (RON)"},{"value":6167,"label":"Mobile Notary Services"},{"value":6168,"label":"Remote Ink Notarization (RIN)"}]}]},{"label":"Apostille","component":"Apostille","parameter":"apostille","sourceTypeId":720,"myRecordsSearch":false,"myWorkQueueSearch":false,"disabled":false,"allowedRoutes":["/forms-manager/","/queue/","/forms/"]},{"label":"Liens","component":"UCC","parameter":"ucc","sourceTypeId":1999,"myRecordsSearch":true,"myWorkQueueSearch":true,"fileAmendmentButtonLabel":"Filing Actions","searchPlaceholder":"Search by name or file number","disabled":false,"serverWebSearchDescription":true,"myRecordsDescription":"","workQueueDescription":"","searchDescription":"","hideRecordUserManagment":true,"searchLiensCheckout":false,"advancedSearchParameters":[{"type":"radio","name":"STARTS_WITH_YN","defaultValue":false,"options":[{"value":true,"label":"Starts with"},{"value":false,"label":"Contains"}]},{"type":"select","name":"STATUS","defaultValue":"ALL","label":"Status","options":[{"value":"ACTIVE_UNLAPSED","label":"Active (unlapsed)"},{"value":"ACTIVE_LAPSED_UNLAPSED","label":"Active (lapsed and unlapsed)"}]},{"type":"text","name":"EXCLUDE_VALUES","label":"Exclude Debtor Names (comma separated list of names to exclude)","defaultValue":""},{"type":"dateRange","name":"FILING_DATE","label":"Financing Statement Date","defaultValue":{"start":null,"end":null}},{"type":"dateRange","name":"LAPSE_DATE","label":"Lapse Date","defaultValue":{"start":null,"end":null}},{"type":"text","name":"CITY","label":"Debtor City","defaultValue":""}],"myRecordsFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Approved"},{"value":2,"label":"Pending Online Payment"},{"value":3,"label":"Pending Review"}]},{"type":"select","name":"TYPE","defaultValue":0,"label":"Lien Type","options":[{"value":0,"label":"All"},{"value":1,"label":"UCC"},{"value":2,"label":"EFS"},{"value":3,"label":"Title 71"}]}],"myWorkQueueFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Approved"},{"value":2,"label":"Pending Online Payment"},{"value":3,"label":"Pending Review"},{"value":4,"label":"Pending Print and Mail"},{"value":5,"label":"Rejected"},{"value":6,"label":"Draft"}]},{"type":"select","name":"TYPE","defaultValue":0,"label":"Lien Type","options":[{"value":0,"label":"All"},{"value":1,"label":"UCC"},{"value":2,"label":"EFS"},{"value":3,"label":"Title 71"}]}]},{"label":"Copy Request","component":"copies","parameter":"copies","sourceTypeId":2001,"myRecordsSearch":false,"myWorkQueueSearch":false,"disabled":false,"allowedRoutes":["/forms-manager/","/queue/","/forms/"]},{"label":"Trademark","component":"Trademark","parameter":"trademark","sourceTypeId":810,"showRequestCertificate":true,"searchMustHaveOneOf":["search","EXPIRATION_DATE","FILING_DATE"],"allowEmptySearchTerm":true,"requestCertificateAlternateLabel":"Request Information","fileAmendmentButtonLabel":"Filing Actions","advancedSearchParameters":[{"type":"radio","name":"QUERY_TYPE_ID","defaultValue":1010,"options":[{"value":1010,"label":"Starts with"},{"value":1011,"label":"Contains"},{"value":1012,"label":" Word Contains"}]},{"type":"checkbox","name":"OWNER_SEARCH_YN","defaultValue":false,"label":"Search owners"},{"type":"radio","name":"SERVICE_MARK_YN","label":"Mark Type","defaultValue":"","options":[{"value":"","label":"All Marks"},{"value":"Y","label":"Service Mark"},{"value":"N","label":"Trademark"}]},{"type":"serverSelect","name":"STATUS_ID","optionsSrc":"TYPE_V|TRADEMARK_STATUS_TYPE","label":"Status","placeholder":"All","defaultValue":"0"},{"type":"select","name":"DESIGN_TYPE_ID","options":[{"value":0,"label":"All"},{"value":990,"label":"Words Only"},{"value":991,"label":"Design Only"},{"value":992,"label":"Words and Design"}],"label":"Design Type","defaultValue":"0"},{"type":"dateRange","name":"FILING_DATE","label":"Registered Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}},{"type":"dateRange","name":"EXPIRATION_DATE","label":"Expiration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}}]},{"label":"Business Info Request","component":"InfoRequests","parameter":"info-request","sourceTypeId":167,"allowedRoutes":["/forms-manager/","/queue/","/forms/"]},{"label":"Data Requests","component":"DataRequests","parameter":"data-request","sourceTypeId":0,"allowedRoutes":["/forms-manager/"]},{"label":"CRA","component":"CRA","parameter":"cra","sourceTypeId":157,"myRecordsSearch":false,"searchPlaceholder":"Search by name or registered agent number","allowedRoutes":["/forms-manager/","/forms/","/records/","/queue/","/search/"],"allowEmptySearchTerm":true,"fileAmendmentButtonLabel":"Filing Actions","advancedSearchParameters":[{"type":"radio","name":"QUERY_TYPE_ID","defaultValue":1010,"options":[{"value":1010,"label":"Starts with"},{"value":1011,"label":"Contains"},{"value":1012,"label":" Word Contains"}]},{"type":"dateRange","name":"CRA_DATE","label":"Registration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}},{"type":"select","name":"STATUS_ID","label":"Status","defaultValue":0,"options":[{"value":0,"label":"All"},{"value":121,"label":"Active"},{"value":122,"label":"Inactive"}]},{"type":"select","name":"AGENT_TYPE_ID","label":"Agent Type","defaultValue":0,"options":[{"value":0,"label":"All"},{"value":460,"label":"Registered Agent"},{"value":461,"label":"Commercial Registered Agent"}]}]},{"label":"Farm Bill","component":"FarmBill","parameter":"farm-bill","path":"/lists/farm-bill","sourceTypeId":0,"myRecordsSearch":false,"allowedRules":["/search/"],"disabled":true,"searchDescription":"To perform a search, enter a debtor name. Your search results may include: exact debtor name, variations of that name and any filing that includes your search criteria. Punctuation is ignored.\n\nYou can click on \"Advanced\" to refine your search. Under “Advanced” you can search by crop, year, county and SSN/FEIN. As a registered Farm Bill Buyer with the Montana Secretary of State’s office it is important to maintain the confidentiality of the information contained within the Farm Bill Master List. The Farm Bill Master List reflects personal data, such as Social Security Numbers, which are a key piece of personal identifiable information to assist you in determining the existence of a lien against a specific debtor. The distribution of this information beyond its intended purpose is strictly prohibited.\n\nThe debtor's tax identification number has been hidden for confidentiality reasons. You may continue to search on a tax ID number and return debtors that match your search criteria. The SSN/FEIN must be entered without dashes or spaces.","searchMustHaveOneOf":["search","UCC_FARM_PRODUCT_ID","COUNTY"],"searchPlaceholder":"Search by debtor name","advancedSearchParameters":[{"type":"ServerMultiComplete","label":"Product code name(s)","name":"UCC_FARM_PRODUCT_ID","defaultValue":"","optionsSrc":"UCC_FARM_PRODUCT_V"},{"type":"MultiComplete","label":"Year or Range of Years","name":"YEAR_NUM","optionsSrc":"years","startYear":"1968","defaultValue":[],"preMergeOptions":[{"value":"ALL","label":"All"}]},{"type":"serverSelect","label":"State","name":"STATE","defaultValue":"MONTANA","optionsSrc":"STATE"},{"type":"ServerMultiComplete","label":"County","name":"COUNTY","defaultValue":[],"optionsSrc":"COUNTY","overrideSubOptionsSrcFromParameterName":"STATE"},{"type":"checkbox","name":"TIN_SEARCH_YN","defaultValue":false,"label":"Tax Identification Number Search"},{"type":"checkbox","name":"TIN_SORT_YN","defaultValue":false,"label":"Unique ID Sort"}]}],"SYSTEM_NICKNAME":"Online Services Portal","PAYMENT_METHODS":[{"type":"bypass"},{"type":"iTransact"}],"PAYMENT_ALLOW_AMEX":true,"SYSTEM_ID_LABEL":"System Id","DOUBLE_COLUMN_PUBLIC_LOGIN":true,"INTERNAL_USER_MANAGEMENT":true,"ALLOW_PUBLIC_JSON_IMPORT":false,"MAX_FILE_UPLOAD_SIZE":10000000,"REFUND_TEXT":"","RETURN_TO_HOME_ON_LOGOUT":true,"CURRENT_SOS_NAME":"Christi Jacobsen","LOGO_FILENAME":"mt-sos-logo.png","LOGO_ALT":"Christi Jacobsen, Montana Secretary of State","LOGO_FULL_WIDTH":true,"HOME_HIDE_AUTH_HINT":true,"HOME_TITLE":"Montana Secretary of State","CUSTOM_TAB_TITLE":"Official Montana","HOME_SUBTITLE":"Online Business Services","ENTITY_NAME_CONSENT_DESCRIPTION":"","ALLOW_USER_PROFILE_EDITING":true,"COMPARE_FOREIGN_NAME_IN_ENTITY_NAME_VALIDATION":true,"FOREIGN_NAME_FIELD_NAME":"KIMA_PARENT_NAME_INFO","LOGIN_TITLE":"Montana Secretary of State Online Filing Portal Login","PUBLIC_LOGIN_LABEL":"Username","REVERSE_LOGIN_COLUMNS":true,"LOGIN_SEAL_FILENAME":"seal_white.png","SEPARATE_USERNAME_AND_EMAIL":true,"CREATE_ACCOUNT_BUTTON_ALIGN_LEFT":true,"CREATE_ACCOUNT_BUTTON_TEXT":"CREATE AN ACCOUNT","PASSWORD_CUSTOM_ERROR_TEXT":"The password must meet all requirements","ACCOUNT_CREATED_MESSAGE":"Please check your email to verify your account to login and allow a few minutes for this message to arrive. Check your junk/spam folders if you do not find the email in your inbox.","PUBLIC_LOGIN_PLACEHOLDER":" ","DISABLE_DEFAULT_PAYMENT_RADIO":true,"CUSTOM_RESET_PASSWORD_ERROR_MESSAGE":"Username invalid - no account found","PUBLIC_LOGIN_CREATE_DESCRIPTION":"### Existing User:\n\n  - Enter your username and password to login.  \n\n\n  #### - OR -  \n\n\n\n  - Forgot password? Click 'Reset Password' and follow the prompts.\n  - Forgot username? Click 'Forgot Username' and follow the prompts.  \n\n\n  ### New User:\n  ","LOGIN_HELP_LINK":"https://sosmt.gov/business/how-do-i/","LOGIN_HELP_LINK_TEXT":"Need Help?","FORGOT_USERNAME_TEXT":"Forgot Username?","LOGIN_ACTIVE_DIRECTORY_TEXT":"State User Login","MULTIPLE_LOGIN_METHODS":true,"HAS_ACTIVE_DIRECTORY_LOGIN":true,"RESET_PASSWORD_WITH_USERNAME":true,"DOWNLOAD_LINK":true,"SHOW_USERNAME_ACCOUNT_CREATE":true,"SHOW_SCROLL_DOWN_ARROW":true,"SHOW_ADDRESS_ACCOUNT_CREATE":true,"TWO_COLUMN_ACCOUNT_CREATE":true,"RESET_PASSWORD_TIP":"A link to change your password has been sent to your email. Please allow a few minutes for this message to arrive. Please check your junk/spam folders if you do not find the email in your inbox.","FORGOT_PASSWORD_LINK_TEXT":"Reset Password","PHONE_NUMBER_OPTIONAL_ACCOUNT_CREATE":true,"SHOW_REQUIRED_INDICATOR_ACCOUNT_CREATE":true,"PASSWORD_REQUIREMENTS_ACCOUNT_CREATE":"\n    <ul>\n      <li>MUST contain at least 8 characters (12+ recommended)</li>\n      <li>MUST contain at least one uppercase letter.</li>\n      <li>MUST contain at least one lowercase letter.</li>\n      <li>MUST contain at least one number.</li>\n      <li>MUST contain at least one special character (!”#$%&'()*+,-./:;<=>?</li>\n    </ul>\n  ","ALLOW_CERTIFICATION_REQUEST":true,"ALLOW_PUBLIC_CERTIFICATE_REQUEST":true,"ALLOW_COPY_REQUEST":false,"ALLOW_CORRECTION_STYLING":true,"HIDE_DEPRECATION_WARNING":false,"AMEND_ROUTE_PUBLIC":true,"SEAL_FILENAME":"seal.png","SHOPPING_CART":true,"ALLOW_PAYMENT_UPDATE_WITH_EMPTY_CART":true,"RA_EMAIL":true,"RA_WEBSITE":true,"RA_NO_DEFAULT_TYPE":true,"RA_ADDRESS_LABEL":"Street Address","RA_TYPE_SELECTION_DEFAULT":true,"RA_DEFAULT_TYPE":"460","RA_OVERRIDE_TYPE_WITH_DEFAULT":true,"RA_PRINCIPAL_ADDRESS_AMS":true,"UPLOAD_AND_SUBMIT_HIDE_IF_ONE_OPTION":true,"PAYMENT_PROCESSING_MESSAGE":"Your payment is processing - Do not close your browser or click the back button","CHECKOUT_BUTTON_WHEN_PROCESSING_TEXT":"Processing","EFS_CROP_PICKER_NONE_LABEL":"Lien Duration","DISALLOWED_WIZARD_PIECES":["FormationLocale"],"REPEATER_SHOW_EDIT_BUTTON":true,"DATA_REQUEST_PAGE_TITLE":"Data Requests and Subscriptions","DATA_REQUEST_SIDEBAR_LABEL":"Data Requests & Subscriptions","LOGIN_REDIRECTS_TO_EPASS":false,"LOGIN_REDIRECTS_TO_ACTIVE_DIRECTORY":true,"LOGIN_ACTIVE_DIRECTORY_LINK":true,"FETCH_EDIT_USER_LINK":false,"LISTS_FETCH_AVAILABLE_LISTS":true,"POST_WIZARD_SUBMIT_REDIRECT_URL":"/","PIN_REQUEST_ATTESTATIONS":true,"PIN_REQUEST_DESCRIPTION":"Click **Request PIN** to have a new PIN sent to the account holder's email address on file.","OWNERSHIP_REQUEST_DESCRIPTION":"To become an **authorized user** of this record, a current **AUTHORIZED USER** will need to grant you access. To request access, click **Request Access** below.","PIN_REQUEST_SUCCESS_MESSAGE":"The PIN you have requested for this entity has been sent to the email associated with your user account.  You should receive the PIN in approximately 3-5 minutes, depending on your email service provider.","APOSTILLE_HEADER_LABEL":"Verification Information","APOSTILLE_NUMBER_LABEL":"Apostille/Authentication","APOSTILLE_CITY_STATE_OVERRIDE":"HELENA, MT","APOSTILLE_FILING_DATE_LABEL":"Issue Date","APOSTILLE_CITY_STATE_IN_CERTIFIED":true,"NOTARY_EXISTING_FILING":true,"ALLOW_REVOKE_OWN_ACCESS_ONLY":false,"HIDE_CANCEL_ON_ONETIME_DATA_REQUESTS":true,"DATA_REQUESTS_IN_SHOPPING_CART":true,"WQ_ALLOW_EDIT_PENDING_PAYMENT":true,"WQ_CONFIRM_ON_DELETE":true,"WQ_DELETE_CONFIRM_MESSAGE":"Deleting this filing will forfeit any money already paid to the Secretary of State. This action is permanent and cannot be undone, are you sure you would like to delete?","PASS_ITEM_GUIDS_ON_CHECKOUT":true,"FORM_REVISION_HISTORY":true,"CHECKOUT_DISCLAIMER":"By entering your credit card and/or checking account information you (i) state that **you are an authorized user** of the credit card and/or electronic check and that the associated information entered (e.g., account holder name, account number, billing address) is accurate, (ii) **you authorize payment processor to charge the amount you have requested** to your credit card and/or funding account, and (iii) **acknowledge if a charge is declined or reversed you may also be assessed a customary charge** by the payment processor for such transactions.","FARM_BILL_SEARCH_CONFIDENTIAL":"As a registered Farm Bill Buyer with the Montana Secretary of State’s office it is important to maintain the confidentiality of the information contained within the Farm Bill Master List. The Farm Bill Master List reflects personal data, such as Social Security Numbers, which are a key piece of personal identifiable information to assist you in determining the existence of a lien against a specific debtor. The distribution of this information beyond its intended purpose is strictly prohibited.\n\n**The debtor's tax identification number has been hidden for confidentiality reasons. You may continue to search on a tax ID number and return debtors that match your search criteria. The SSN/FEIN must be entered without dashes or spaces.  If you need access to the tax identification number to clearly identify the debtor, please contact the UCC unit at (406) 444-3665.**","VIEW_HISTORY_BUTTON_ALT_TEXT":"View Filings","WIZARD_ERROR_TITLE_MESSAGE":"Form Error","FARM_BILL_SEARCH_INTERACTIVE":true,"USE_FARM_BILL_API":true,"DISALLOW_ASSIGN_SELF_AS_RA":true,"DISALLOW_ASSIGN_SELF_AS_PRINCIPAL":true,"USE_TRADEMARK_OWNER_VALIDATION":true,"USE_ALTERNATIVE_FOREIGN_ADDRESS_LABELS":true,"MY_RECEIPTS_FILTER":[{"type":"dateRange","name":"DATE_RANGE","label":"Date range","defaultValue":{"start":null,"end":null}},{"type":"text","name":"REF_NUM","defaultValue":"","label":"Reference Number"},{"type":"text","name":"RECEIPT_NUM","defaultValue":"","label":"Receipt Id"},{"type":"text","name":"AMOUNT","defaultValue":"","label":"Amount"},{"type":"select","name":"TYPE","defaultValue":"","label":"Payment Type","options":[{"value":"","label":"All"},{"value":"CC","label":"Credit Card"},{"value":"Check","label":"Check"}]}],"MY_RECEIPTS_SHOW_IN_SIDEBAR":true,"SHOW_MY_RECEIPTS_HELPER_TEXT":true,"MY_RECEIPTS_HELPER_LABEL":"About Receipt Search","MY_RECEIPTS_HELPER_TEXT":"You can search for receipts based on their descriptions, including the items paid for on the receipt. Use the filters to search for or filter specific information.","FARM_BILL_SUBLINK":{"label":"Farm Bill","component":"FarmBill","parameter":"farm-bill","path":"/lists/farm-bill","sourceTypeId":0,"myRecordsSearch":false,"allowedRules":["/search/"],"disabled":true,"searchDescription":"To perform a search, enter a debtor name. Your search results may include: exact debtor name, variations of that name and any filing that includes your search criteria. Punctuation is ignored.\n\nYou can click on \"Advanced\" to refine your search. Under “Advanced” you can search by crop, year, county and SSN/FEIN. As a registered Farm Bill Buyer with the Montana Secretary of State’s office it is important to maintain the confidentiality of the information contained within the Farm Bill Master List. The Farm Bill Master List reflects personal data, such as Social Security Numbers, which are a key piece of personal identifiable information to assist you in determining the existence of a lien against a specific debtor. The distribution of this information beyond its intended purpose is strictly prohibited.\n\nThe debtor's tax identification number has been hidden for confidentiality reasons. You may continue to search on a tax ID number and return debtors that match your search criteria. The SSN/FEIN must be entered without dashes or spaces.","searchMustHaveOneOf":["search","UCC_FARM_PRODUCT_ID","COUNTY"],"searchPlaceholder":"Search by debtor name","advancedSearchParameters":[{"type":"ServerMultiComplete","label":"Product code name(s)","name":"UCC_FARM_PRODUCT_ID","defaultValue":"","optionsSrc":"UCC_FARM_PRODUCT_V"},{"type":"MultiComplete","label":"Year or Range of Years","name":"YEAR_NUM","optionsSrc":"years","startYear":"1968","defaultValue":[],"preMergeOptions":[{"value":"ALL","label":"All"}]},{"type":"serverSelect","label":"State","name":"STATE","defaultValue":"MONTANA","optionsSrc":"STATE"},{"type":"ServerMultiComplete","label":"County","name":"COUNTY","defaultValue":[],"optionsSrc":"COUNTY","overrideSubOptionsSrcFromParameterName":"STATE"},{"type":"checkbox","name":"TIN_SEARCH_YN","defaultValue":false,"label":"Tax Identification Number Search"},{"type":"checkbox","name":"TIN_SORT_YN","defaultValue":false,"label":"Unique ID Sort"}]},"ALLOW_ADDRESS_VALIDATION_BYPASS_OPTION":true,"DEFAULT_ADDRESS_VALIDATION_BYPASS_OPTION_CHECKED":true}).UCC_SEARCH_ONLY_REQUIRE_LAST_NAME ? value.search.SEARCH_LAST_NAME : value.search.SEARCH_FIRST_NAME && value.search.SEARCH_LAST_NAME) && UCC4Satisfied;
	    var checkCommonFields = function checkCommonFields(value) {
	      if (value.cache && commonFieldCheck) {
	        callback(true, '');
	      } else {
	        var errorMessage = [];
	        if (!value.cache) {
	          errorMessage.push('You must execute a search.');
	        }
	        if (value.search.IS_ORG === true || value.search.IS_ORG === 'true') {
	          if (!value.search.SEARCH_ORG_NAME) {
	            errorMessage.push('Organization name is required.');
	          }
	        } else {
	          if (({"NODE_ENV":"production","BUILD_DATE":"2025-08-27T15:15:31.687Z","BUILD_NUMBER":"Not Provided","GIT_VERSION":"v1.3.0-381-ga81e29b08","GIT_COMMIT_HASH":"a81e29b085c9268ffd96c78eb734365802722741","GIT_BRANCH":"beta","PUBLIC_URL":"","STATE_ABBR":"MT","STATE_NAME":"Montana","STATE_ORG_TITLE":"Secretary of State","LOGIN_HEADER_IMG_PATH":"","HOME_IMG_FILENAME":"montana.jpg","FAVICON_FILE_NAME":"favicon.ico","ALLOW_E_SIGN_ON_CORRECTIONS":true,"THIRD_PARTY_SIGNING_ALLOWED":false,"MY_ACCOUNT_SAVE_AND_CLOSE_BUTTON":true,"IE_DEPRECATED_MESSAGE":"Internet Explorer is not supported. Please select a supported browser below to access this website.","ADDITIONAL_ROUTES":{"dataRequests":true,"farmBill":true,"apostille":true,"externalHelp":"https://sosmt.gov/business/help-center/","systemAdministration":[{"title":"Saved Payments","parameter":"saved-payments","componentName":"SavedPayments"}]},"SUBROUTES":[{"label":"Business","component":"Business","parameter":"business","myWorkQueueSearch":false,"sourceTypeId":54,"searchMustHaveOneOf":["FILING_TYPE_ID","STATUS_ID","STATE","search"],"serverWebSearchDescription":true,"serverWorkQueueDescription":true,"serverMyRecordsDescription":true,"searchPlaceholder":"Search by name or filing number (X########)","allowEmptySearchTerm":true,"requestCertificateAlternateLabel":"Request Information","fileAmendmentButtonLabel":"Filing Actions","advancedSearchParameters":[{"type":"radio","name":"QUERY_TYPE_ID","defaultValue":1010,"options":[{"value":1010,"label":"Starts with"},{"value":1011,"label":"Contains"},{"value":1012,"label":" Word Contains"}]},{"type":"serverSelect","name":"FILING_TYPE_ID","optionsSrc":"FILING_TYPES","label":"Entity Type","placeholder":"All","defaultValue":"0"},{"type":"serverSelect","name":"FILING_SUBTYPE_ID","optionsSrc":"FILING_SUBTYPES","label":"Entity Subtype","overrideSubOptionsSrcFromParameterName":"FILING_TYPE_ID","placeholder":"All","defaultValue":"0"},{"type":"serverSelect","name":"STATUS_ID","optionsSrc":"FILING_STATUS_WITHOUT_ALL","label":"Status","placeholder":"All","defaultValue":"0"},{"type":"serverSelect","name":"STATE","optionsSrc":"STATE","label":"State","placeholder":"All","defaultValue":""},{"type":"serverSelect","name":"COUNTY","optionsSrc":"COUNTY_SUBOPTION","label":"County","overrideSubOptionsSrcFromParameterName":"STATE","placeholder":"All","defaultValue":""},{"type":"checkbox","name":"CRA_SEARCH_YN","defaultValue":false,"label":"Search by Registered Agent PID"},{"type":"dateRange","name":"FILING_DATE","label":"Registration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}},{"type":"dateRange","name":"EXPIRATION_DATE","label":"Expiration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}}],"myRecordsFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Active"},{"value":2,"label":"Inactive"},{"value":3,"label":"Pending"}]},{"type":"dateRange","name":"DATE_RANGE","label":"Date range","defaultValue":{"start":null,"end":null}}],"myWorkQueueFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Approved"},{"value":2,"label":"Pending Online Payment"},{"value":3,"label":"Pending Review"},{"value":4,"label":"Needs Correction"},{"value":5,"label":"Rejected"},{"value":6,"label":"Draft"}]},{"type":"dateRange","name":"DATE_RANGE","label":"Date range","defaultValue":{"start":null,"end":null}}]},{"label":"Notary","component":"Notary","parameter":"notary","sourceTypeId":850,"myWorkQueueSearch":false,"allowEmptySearchTerm":true,"requestCertificateAlternateLabel":"Download Certificate","fileAmendmentButtonLabel":"Filing Actions","hideNameRequestCertificate":true,"hideAddressRequestCertificate":true,"hideRecordUserManagment":true,"searchPlaceholder":"Search by name or commission number","searchMustHaveOneOf":["CITY","search","SERVICE_TYPE"],"advancedParametersStartOpen":true,"searchIsSortable":true,"advancedSearchParameters":[{"type":"radio","name":"STARTS_WITH_YN","defaultValue":false,"options":[{"value":true,"label":"Starts with"},{"value":false,"label":"Contains"}]},{"type":"checkbox","name":"ACTIVE_ONLY_YN","defaultValue":true,"label":"Active entities only"},{"type":"text","name":"CITY","defaultValue":"","label":"City"},{"type":"select","name":"SERVICE_TYPE","label":"Special Services Offered","defaultValue":0,"options":[{"value":0,"label":"(N/A)"},{"value":6165,"label":"In-Person Electronic Notarization (IPEN)"},{"value":6166,"label":"Remote Online Notarization (RON)"},{"value":6167,"label":"Mobile Notary Services"},{"value":6168,"label":"Remote Ink Notarization (RIN)"}]}]},{"label":"Apostille","component":"Apostille","parameter":"apostille","sourceTypeId":720,"myRecordsSearch":false,"myWorkQueueSearch":false,"disabled":false,"allowedRoutes":["/forms-manager/","/queue/","/forms/"]},{"label":"Liens","component":"UCC","parameter":"ucc","sourceTypeId":1999,"myRecordsSearch":true,"myWorkQueueSearch":true,"fileAmendmentButtonLabel":"Filing Actions","searchPlaceholder":"Search by name or file number","disabled":false,"serverWebSearchDescription":true,"myRecordsDescription":"","workQueueDescription":"","searchDescription":"","hideRecordUserManagment":true,"searchLiensCheckout":false,"advancedSearchParameters":[{"type":"radio","name":"STARTS_WITH_YN","defaultValue":false,"options":[{"value":true,"label":"Starts with"},{"value":false,"label":"Contains"}]},{"type":"select","name":"STATUS","defaultValue":"ALL","label":"Status","options":[{"value":"ACTIVE_UNLAPSED","label":"Active (unlapsed)"},{"value":"ACTIVE_LAPSED_UNLAPSED","label":"Active (lapsed and unlapsed)"}]},{"type":"text","name":"EXCLUDE_VALUES","label":"Exclude Debtor Names (comma separated list of names to exclude)","defaultValue":""},{"type":"dateRange","name":"FILING_DATE","label":"Financing Statement Date","defaultValue":{"start":null,"end":null}},{"type":"dateRange","name":"LAPSE_DATE","label":"Lapse Date","defaultValue":{"start":null,"end":null}},{"type":"text","name":"CITY","label":"Debtor City","defaultValue":""}],"myRecordsFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Approved"},{"value":2,"label":"Pending Online Payment"},{"value":3,"label":"Pending Review"}]},{"type":"select","name":"TYPE","defaultValue":0,"label":"Lien Type","options":[{"value":0,"label":"All"},{"value":1,"label":"UCC"},{"value":2,"label":"EFS"},{"value":3,"label":"Title 71"}]}],"myWorkQueueFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Approved"},{"value":2,"label":"Pending Online Payment"},{"value":3,"label":"Pending Review"},{"value":4,"label":"Pending Print and Mail"},{"value":5,"label":"Rejected"},{"value":6,"label":"Draft"}]},{"type":"select","name":"TYPE","defaultValue":0,"label":"Lien Type","options":[{"value":0,"label":"All"},{"value":1,"label":"UCC"},{"value":2,"label":"EFS"},{"value":3,"label":"Title 71"}]}]},{"label":"Copy Request","component":"copies","parameter":"copies","sourceTypeId":2001,"myRecordsSearch":false,"myWorkQueueSearch":false,"disabled":false,"allowedRoutes":["/forms-manager/","/queue/","/forms/"]},{"label":"Trademark","component":"Trademark","parameter":"trademark","sourceTypeId":810,"showRequestCertificate":true,"searchMustHaveOneOf":["search","EXPIRATION_DATE","FILING_DATE"],"allowEmptySearchTerm":true,"requestCertificateAlternateLabel":"Request Information","fileAmendmentButtonLabel":"Filing Actions","advancedSearchParameters":[{"type":"radio","name":"QUERY_TYPE_ID","defaultValue":1010,"options":[{"value":1010,"label":"Starts with"},{"value":1011,"label":"Contains"},{"value":1012,"label":" Word Contains"}]},{"type":"checkbox","name":"OWNER_SEARCH_YN","defaultValue":false,"label":"Search owners"},{"type":"radio","name":"SERVICE_MARK_YN","label":"Mark Type","defaultValue":"","options":[{"value":"","label":"All Marks"},{"value":"Y","label":"Service Mark"},{"value":"N","label":"Trademark"}]},{"type":"serverSelect","name":"STATUS_ID","optionsSrc":"TYPE_V|TRADEMARK_STATUS_TYPE","label":"Status","placeholder":"All","defaultValue":"0"},{"type":"select","name":"DESIGN_TYPE_ID","options":[{"value":0,"label":"All"},{"value":990,"label":"Words Only"},{"value":991,"label":"Design Only"},{"value":992,"label":"Words and Design"}],"label":"Design Type","defaultValue":"0"},{"type":"dateRange","name":"FILING_DATE","label":"Registered Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}},{"type":"dateRange","name":"EXPIRATION_DATE","label":"Expiration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}}]},{"label":"Business Info Request","component":"InfoRequests","parameter":"info-request","sourceTypeId":167,"allowedRoutes":["/forms-manager/","/queue/","/forms/"]},{"label":"Data Requests","component":"DataRequests","parameter":"data-request","sourceTypeId":0,"allowedRoutes":["/forms-manager/"]},{"label":"CRA","component":"CRA","parameter":"cra","sourceTypeId":157,"myRecordsSearch":false,"searchPlaceholder":"Search by name or registered agent number","allowedRoutes":["/forms-manager/","/forms/","/records/","/queue/","/search/"],"allowEmptySearchTerm":true,"fileAmendmentButtonLabel":"Filing Actions","advancedSearchParameters":[{"type":"radio","name":"QUERY_TYPE_ID","defaultValue":1010,"options":[{"value":1010,"label":"Starts with"},{"value":1011,"label":"Contains"},{"value":1012,"label":" Word Contains"}]},{"type":"dateRange","name":"CRA_DATE","label":"Registration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}},{"type":"select","name":"STATUS_ID","label":"Status","defaultValue":0,"options":[{"value":0,"label":"All"},{"value":121,"label":"Active"},{"value":122,"label":"Inactive"}]},{"type":"select","name":"AGENT_TYPE_ID","label":"Agent Type","defaultValue":0,"options":[{"value":0,"label":"All"},{"value":460,"label":"Registered Agent"},{"value":461,"label":"Commercial Registered Agent"}]}]},{"label":"Farm Bill","component":"FarmBill","parameter":"farm-bill","path":"/lists/farm-bill","sourceTypeId":0,"myRecordsSearch":false,"allowedRules":["/search/"],"disabled":true,"searchDescription":"To perform a search, enter a debtor name. Your search results may include: exact debtor name, variations of that name and any filing that includes your search criteria. Punctuation is ignored.\n\nYou can click on \"Advanced\" to refine your search. Under “Advanced” you can search by crop, year, county and SSN/FEIN. As a registered Farm Bill Buyer with the Montana Secretary of State’s office it is important to maintain the confidentiality of the information contained within the Farm Bill Master List. The Farm Bill Master List reflects personal data, such as Social Security Numbers, which are a key piece of personal identifiable information to assist you in determining the existence of a lien against a specific debtor. The distribution of this information beyond its intended purpose is strictly prohibited.\n\nThe debtor's tax identification number has been hidden for confidentiality reasons. You may continue to search on a tax ID number and return debtors that match your search criteria. The SSN/FEIN must be entered without dashes or spaces.","searchMustHaveOneOf":["search","UCC_FARM_PRODUCT_ID","COUNTY"],"searchPlaceholder":"Search by debtor name","advancedSearchParameters":[{"type":"ServerMultiComplete","label":"Product code name(s)","name":"UCC_FARM_PRODUCT_ID","defaultValue":"","optionsSrc":"UCC_FARM_PRODUCT_V"},{"type":"MultiComplete","label":"Year or Range of Years","name":"YEAR_NUM","optionsSrc":"years","startYear":"1968","defaultValue":[],"preMergeOptions":[{"value":"ALL","label":"All"}]},{"type":"serverSelect","label":"State","name":"STATE","defaultValue":"MONTANA","optionsSrc":"STATE"},{"type":"ServerMultiComplete","label":"County","name":"COUNTY","defaultValue":[],"optionsSrc":"COUNTY","overrideSubOptionsSrcFromParameterName":"STATE"},{"type":"checkbox","name":"TIN_SEARCH_YN","defaultValue":false,"label":"Tax Identification Number Search"},{"type":"checkbox","name":"TIN_SORT_YN","defaultValue":false,"label":"Unique ID Sort"}]}],"SYSTEM_NICKNAME":"Online Services Portal","PAYMENT_METHODS":[{"type":"bypass"},{"type":"iTransact"}],"PAYMENT_ALLOW_AMEX":true,"SYSTEM_ID_LABEL":"System Id","DOUBLE_COLUMN_PUBLIC_LOGIN":true,"INTERNAL_USER_MANAGEMENT":true,"ALLOW_PUBLIC_JSON_IMPORT":false,"MAX_FILE_UPLOAD_SIZE":10000000,"REFUND_TEXT":"","RETURN_TO_HOME_ON_LOGOUT":true,"CURRENT_SOS_NAME":"Christi Jacobsen","LOGO_FILENAME":"mt-sos-logo.png","LOGO_ALT":"Christi Jacobsen, Montana Secretary of State","LOGO_FULL_WIDTH":true,"HOME_HIDE_AUTH_HINT":true,"HOME_TITLE":"Montana Secretary of State","CUSTOM_TAB_TITLE":"Official Montana","HOME_SUBTITLE":"Online Business Services","ENTITY_NAME_CONSENT_DESCRIPTION":"","ALLOW_USER_PROFILE_EDITING":true,"COMPARE_FOREIGN_NAME_IN_ENTITY_NAME_VALIDATION":true,"FOREIGN_NAME_FIELD_NAME":"KIMA_PARENT_NAME_INFO","LOGIN_TITLE":"Montana Secretary of State Online Filing Portal Login","PUBLIC_LOGIN_LABEL":"Username","REVERSE_LOGIN_COLUMNS":true,"LOGIN_SEAL_FILENAME":"seal_white.png","SEPARATE_USERNAME_AND_EMAIL":true,"CREATE_ACCOUNT_BUTTON_ALIGN_LEFT":true,"CREATE_ACCOUNT_BUTTON_TEXT":"CREATE AN ACCOUNT","PASSWORD_CUSTOM_ERROR_TEXT":"The password must meet all requirements","ACCOUNT_CREATED_MESSAGE":"Please check your email to verify your account to login and allow a few minutes for this message to arrive. Check your junk/spam folders if you do not find the email in your inbox.","PUBLIC_LOGIN_PLACEHOLDER":" ","DISABLE_DEFAULT_PAYMENT_RADIO":true,"CUSTOM_RESET_PASSWORD_ERROR_MESSAGE":"Username invalid - no account found","PUBLIC_LOGIN_CREATE_DESCRIPTION":"### Existing User:\n\n  - Enter your username and password to login.  \n\n\n  #### - OR -  \n\n\n\n  - Forgot password? Click 'Reset Password' and follow the prompts.\n  - Forgot username? Click 'Forgot Username' and follow the prompts.  \n\n\n  ### New User:\n  ","LOGIN_HELP_LINK":"https://sosmt.gov/business/how-do-i/","LOGIN_HELP_LINK_TEXT":"Need Help?","FORGOT_USERNAME_TEXT":"Forgot Username?","LOGIN_ACTIVE_DIRECTORY_TEXT":"State User Login","MULTIPLE_LOGIN_METHODS":true,"HAS_ACTIVE_DIRECTORY_LOGIN":true,"RESET_PASSWORD_WITH_USERNAME":true,"DOWNLOAD_LINK":true,"SHOW_USERNAME_ACCOUNT_CREATE":true,"SHOW_SCROLL_DOWN_ARROW":true,"SHOW_ADDRESS_ACCOUNT_CREATE":true,"TWO_COLUMN_ACCOUNT_CREATE":true,"RESET_PASSWORD_TIP":"A link to change your password has been sent to your email. Please allow a few minutes for this message to arrive. Please check your junk/spam folders if you do not find the email in your inbox.","FORGOT_PASSWORD_LINK_TEXT":"Reset Password","PHONE_NUMBER_OPTIONAL_ACCOUNT_CREATE":true,"SHOW_REQUIRED_INDICATOR_ACCOUNT_CREATE":true,"PASSWORD_REQUIREMENTS_ACCOUNT_CREATE":"\n    <ul>\n      <li>MUST contain at least 8 characters (12+ recommended)</li>\n      <li>MUST contain at least one uppercase letter.</li>\n      <li>MUST contain at least one lowercase letter.</li>\n      <li>MUST contain at least one number.</li>\n      <li>MUST contain at least one special character (!”#$%&'()*+,-./:;<=>?</li>\n    </ul>\n  ","ALLOW_CERTIFICATION_REQUEST":true,"ALLOW_PUBLIC_CERTIFICATE_REQUEST":true,"ALLOW_COPY_REQUEST":false,"ALLOW_CORRECTION_STYLING":true,"HIDE_DEPRECATION_WARNING":false,"AMEND_ROUTE_PUBLIC":true,"SEAL_FILENAME":"seal.png","SHOPPING_CART":true,"ALLOW_PAYMENT_UPDATE_WITH_EMPTY_CART":true,"RA_EMAIL":true,"RA_WEBSITE":true,"RA_NO_DEFAULT_TYPE":true,"RA_ADDRESS_LABEL":"Street Address","RA_TYPE_SELECTION_DEFAULT":true,"RA_DEFAULT_TYPE":"460","RA_OVERRIDE_TYPE_WITH_DEFAULT":true,"RA_PRINCIPAL_ADDRESS_AMS":true,"UPLOAD_AND_SUBMIT_HIDE_IF_ONE_OPTION":true,"PAYMENT_PROCESSING_MESSAGE":"Your payment is processing - Do not close your browser or click the back button","CHECKOUT_BUTTON_WHEN_PROCESSING_TEXT":"Processing","EFS_CROP_PICKER_NONE_LABEL":"Lien Duration","DISALLOWED_WIZARD_PIECES":["FormationLocale"],"REPEATER_SHOW_EDIT_BUTTON":true,"DATA_REQUEST_PAGE_TITLE":"Data Requests and Subscriptions","DATA_REQUEST_SIDEBAR_LABEL":"Data Requests & Subscriptions","LOGIN_REDIRECTS_TO_EPASS":false,"LOGIN_REDIRECTS_TO_ACTIVE_DIRECTORY":true,"LOGIN_ACTIVE_DIRECTORY_LINK":true,"FETCH_EDIT_USER_LINK":false,"LISTS_FETCH_AVAILABLE_LISTS":true,"POST_WIZARD_SUBMIT_REDIRECT_URL":"/","PIN_REQUEST_ATTESTATIONS":true,"PIN_REQUEST_DESCRIPTION":"Click **Request PIN** to have a new PIN sent to the account holder's email address on file.","OWNERSHIP_REQUEST_DESCRIPTION":"To become an **authorized user** of this record, a current **AUTHORIZED USER** will need to grant you access. To request access, click **Request Access** below.","PIN_REQUEST_SUCCESS_MESSAGE":"The PIN you have requested for this entity has been sent to the email associated with your user account.  You should receive the PIN in approximately 3-5 minutes, depending on your email service provider.","APOSTILLE_HEADER_LABEL":"Verification Information","APOSTILLE_NUMBER_LABEL":"Apostille/Authentication","APOSTILLE_CITY_STATE_OVERRIDE":"HELENA, MT","APOSTILLE_FILING_DATE_LABEL":"Issue Date","APOSTILLE_CITY_STATE_IN_CERTIFIED":true,"NOTARY_EXISTING_FILING":true,"ALLOW_REVOKE_OWN_ACCESS_ONLY":false,"HIDE_CANCEL_ON_ONETIME_DATA_REQUESTS":true,"DATA_REQUESTS_IN_SHOPPING_CART":true,"WQ_ALLOW_EDIT_PENDING_PAYMENT":true,"WQ_CONFIRM_ON_DELETE":true,"WQ_DELETE_CONFIRM_MESSAGE":"Deleting this filing will forfeit any money already paid to the Secretary of State. This action is permanent and cannot be undone, are you sure you would like to delete?","PASS_ITEM_GUIDS_ON_CHECKOUT":true,"FORM_REVISION_HISTORY":true,"CHECKOUT_DISCLAIMER":"By entering your credit card and/or checking account information you (i) state that **you are an authorized user** of the credit card and/or electronic check and that the associated information entered (e.g., account holder name, account number, billing address) is accurate, (ii) **you authorize payment processor to charge the amount you have requested** to your credit card and/or funding account, and (iii) **acknowledge if a charge is declined or reversed you may also be assessed a customary charge** by the payment processor for such transactions.","FARM_BILL_SEARCH_CONFIDENTIAL":"As a registered Farm Bill Buyer with the Montana Secretary of State’s office it is important to maintain the confidentiality of the information contained within the Farm Bill Master List. The Farm Bill Master List reflects personal data, such as Social Security Numbers, which are a key piece of personal identifiable information to assist you in determining the existence of a lien against a specific debtor. The distribution of this information beyond its intended purpose is strictly prohibited.\n\n**The debtor's tax identification number has been hidden for confidentiality reasons. You may continue to search on a tax ID number and return debtors that match your search criteria. The SSN/FEIN must be entered without dashes or spaces.  If you need access to the tax identification number to clearly identify the debtor, please contact the UCC unit at (406) 444-3665.**","VIEW_HISTORY_BUTTON_ALT_TEXT":"View Filings","WIZARD_ERROR_TITLE_MESSAGE":"Form Error","FARM_BILL_SEARCH_INTERACTIVE":true,"USE_FARM_BILL_API":true,"DISALLOW_ASSIGN_SELF_AS_RA":true,"DISALLOW_ASSIGN_SELF_AS_PRINCIPAL":true,"USE_TRADEMARK_OWNER_VALIDATION":true,"USE_ALTERNATIVE_FOREIGN_ADDRESS_LABELS":true,"MY_RECEIPTS_FILTER":[{"type":"dateRange","name":"DATE_RANGE","label":"Date range","defaultValue":{"start":null,"end":null}},{"type":"text","name":"REF_NUM","defaultValue":"","label":"Reference Number"},{"type":"text","name":"RECEIPT_NUM","defaultValue":"","label":"Receipt Id"},{"type":"text","name":"AMOUNT","defaultValue":"","label":"Amount"},{"type":"select","name":"TYPE","defaultValue":"","label":"Payment Type","options":[{"value":"","label":"All"},{"value":"CC","label":"Credit Card"},{"value":"Check","label":"Check"}]}],"MY_RECEIPTS_SHOW_IN_SIDEBAR":true,"SHOW_MY_RECEIPTS_HELPER_TEXT":true,"MY_RECEIPTS_HELPER_LABEL":"About Receipt Search","MY_RECEIPTS_HELPER_TEXT":"You can search for receipts based on their descriptions, including the items paid for on the receipt. Use the filters to search for or filter specific information.","FARM_BILL_SUBLINK":{"label":"Farm Bill","component":"FarmBill","parameter":"farm-bill","path":"/lists/farm-bill","sourceTypeId":0,"myRecordsSearch":false,"allowedRules":["/search/"],"disabled":true,"searchDescription":"To perform a search, enter a debtor name. Your search results may include: exact debtor name, variations of that name and any filing that includes your search criteria. Punctuation is ignored.\n\nYou can click on \"Advanced\" to refine your search. Under “Advanced” you can search by crop, year, county and SSN/FEIN. As a registered Farm Bill Buyer with the Montana Secretary of State’s office it is important to maintain the confidentiality of the information contained within the Farm Bill Master List. The Farm Bill Master List reflects personal data, such as Social Security Numbers, which are a key piece of personal identifiable information to assist you in determining the existence of a lien against a specific debtor. The distribution of this information beyond its intended purpose is strictly prohibited.\n\nThe debtor's tax identification number has been hidden for confidentiality reasons. You may continue to search on a tax ID number and return debtors that match your search criteria. The SSN/FEIN must be entered without dashes or spaces.","searchMustHaveOneOf":["search","UCC_FARM_PRODUCT_ID","COUNTY"],"searchPlaceholder":"Search by debtor name","advancedSearchParameters":[{"type":"ServerMultiComplete","label":"Product code name(s)","name":"UCC_FARM_PRODUCT_ID","defaultValue":"","optionsSrc":"UCC_FARM_PRODUCT_V"},{"type":"MultiComplete","label":"Year or Range of Years","name":"YEAR_NUM","optionsSrc":"years","startYear":"1968","defaultValue":[],"preMergeOptions":[{"value":"ALL","label":"All"}]},{"type":"serverSelect","label":"State","name":"STATE","defaultValue":"MONTANA","optionsSrc":"STATE"},{"type":"ServerMultiComplete","label":"County","name":"COUNTY","defaultValue":[],"optionsSrc":"COUNTY","overrideSubOptionsSrcFromParameterName":"STATE"},{"type":"checkbox","name":"TIN_SEARCH_YN","defaultValue":false,"label":"Tax Identification Number Search"},{"type":"checkbox","name":"TIN_SORT_YN","defaultValue":false,"label":"Unique ID Sort"}]},"ALLOW_ADDRESS_VALIDATION_BYPASS_OPTION":true,"DEFAULT_ADDRESS_VALIDATION_BYPASS_OPTION_CHECKED":true}).UCC_SEARCH_ONLY_REQUIRE_LAST_NAME ? !value.search.SEARCH_LAST_NAME : !value.search.SEARCH_FIRST_NAME || !value.search.SEARCH_LAST_NAME) {
	            errorMessage.push(({"NODE_ENV":"production","BUILD_DATE":"2025-08-27T15:15:31.687Z","BUILD_NUMBER":"Not Provided","GIT_VERSION":"v1.3.0-381-ga81e29b08","GIT_COMMIT_HASH":"a81e29b085c9268ffd96c78eb734365802722741","GIT_BRANCH":"beta","PUBLIC_URL":"","STATE_ABBR":"MT","STATE_NAME":"Montana","STATE_ORG_TITLE":"Secretary of State","LOGIN_HEADER_IMG_PATH":"","HOME_IMG_FILENAME":"montana.jpg","FAVICON_FILE_NAME":"favicon.ico","ALLOW_E_SIGN_ON_CORRECTIONS":true,"THIRD_PARTY_SIGNING_ALLOWED":false,"MY_ACCOUNT_SAVE_AND_CLOSE_BUTTON":true,"IE_DEPRECATED_MESSAGE":"Internet Explorer is not supported. Please select a supported browser below to access this website.","ADDITIONAL_ROUTES":{"dataRequests":true,"farmBill":true,"apostille":true,"externalHelp":"https://sosmt.gov/business/help-center/","systemAdministration":[{"title":"Saved Payments","parameter":"saved-payments","componentName":"SavedPayments"}]},"SUBROUTES":[{"label":"Business","component":"Business","parameter":"business","myWorkQueueSearch":false,"sourceTypeId":54,"searchMustHaveOneOf":["FILING_TYPE_ID","STATUS_ID","STATE","search"],"serverWebSearchDescription":true,"serverWorkQueueDescription":true,"serverMyRecordsDescription":true,"searchPlaceholder":"Search by name or filing number (X########)","allowEmptySearchTerm":true,"requestCertificateAlternateLabel":"Request Information","fileAmendmentButtonLabel":"Filing Actions","advancedSearchParameters":[{"type":"radio","name":"QUERY_TYPE_ID","defaultValue":1010,"options":[{"value":1010,"label":"Starts with"},{"value":1011,"label":"Contains"},{"value":1012,"label":" Word Contains"}]},{"type":"serverSelect","name":"FILING_TYPE_ID","optionsSrc":"FILING_TYPES","label":"Entity Type","placeholder":"All","defaultValue":"0"},{"type":"serverSelect","name":"FILING_SUBTYPE_ID","optionsSrc":"FILING_SUBTYPES","label":"Entity Subtype","overrideSubOptionsSrcFromParameterName":"FILING_TYPE_ID","placeholder":"All","defaultValue":"0"},{"type":"serverSelect","name":"STATUS_ID","optionsSrc":"FILING_STATUS_WITHOUT_ALL","label":"Status","placeholder":"All","defaultValue":"0"},{"type":"serverSelect","name":"STATE","optionsSrc":"STATE","label":"State","placeholder":"All","defaultValue":""},{"type":"serverSelect","name":"COUNTY","optionsSrc":"COUNTY_SUBOPTION","label":"County","overrideSubOptionsSrcFromParameterName":"STATE","placeholder":"All","defaultValue":""},{"type":"checkbox","name":"CRA_SEARCH_YN","defaultValue":false,"label":"Search by Registered Agent PID"},{"type":"dateRange","name":"FILING_DATE","label":"Registration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}},{"type":"dateRange","name":"EXPIRATION_DATE","label":"Expiration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}}],"myRecordsFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Active"},{"value":2,"label":"Inactive"},{"value":3,"label":"Pending"}]},{"type":"dateRange","name":"DATE_RANGE","label":"Date range","defaultValue":{"start":null,"end":null}}],"myWorkQueueFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Approved"},{"value":2,"label":"Pending Online Payment"},{"value":3,"label":"Pending Review"},{"value":4,"label":"Needs Correction"},{"value":5,"label":"Rejected"},{"value":6,"label":"Draft"}]},{"type":"dateRange","name":"DATE_RANGE","label":"Date range","defaultValue":{"start":null,"end":null}}]},{"label":"Notary","component":"Notary","parameter":"notary","sourceTypeId":850,"myWorkQueueSearch":false,"allowEmptySearchTerm":true,"requestCertificateAlternateLabel":"Download Certificate","fileAmendmentButtonLabel":"Filing Actions","hideNameRequestCertificate":true,"hideAddressRequestCertificate":true,"hideRecordUserManagment":true,"searchPlaceholder":"Search by name or commission number","searchMustHaveOneOf":["CITY","search","SERVICE_TYPE"],"advancedParametersStartOpen":true,"searchIsSortable":true,"advancedSearchParameters":[{"type":"radio","name":"STARTS_WITH_YN","defaultValue":false,"options":[{"value":true,"label":"Starts with"},{"value":false,"label":"Contains"}]},{"type":"checkbox","name":"ACTIVE_ONLY_YN","defaultValue":true,"label":"Active entities only"},{"type":"text","name":"CITY","defaultValue":"","label":"City"},{"type":"select","name":"SERVICE_TYPE","label":"Special Services Offered","defaultValue":0,"options":[{"value":0,"label":"(N/A)"},{"value":6165,"label":"In-Person Electronic Notarization (IPEN)"},{"value":6166,"label":"Remote Online Notarization (RON)"},{"value":6167,"label":"Mobile Notary Services"},{"value":6168,"label":"Remote Ink Notarization (RIN)"}]}]},{"label":"Apostille","component":"Apostille","parameter":"apostille","sourceTypeId":720,"myRecordsSearch":false,"myWorkQueueSearch":false,"disabled":false,"allowedRoutes":["/forms-manager/","/queue/","/forms/"]},{"label":"Liens","component":"UCC","parameter":"ucc","sourceTypeId":1999,"myRecordsSearch":true,"myWorkQueueSearch":true,"fileAmendmentButtonLabel":"Filing Actions","searchPlaceholder":"Search by name or file number","disabled":false,"serverWebSearchDescription":true,"myRecordsDescription":"","workQueueDescription":"","searchDescription":"","hideRecordUserManagment":true,"searchLiensCheckout":false,"advancedSearchParameters":[{"type":"radio","name":"STARTS_WITH_YN","defaultValue":false,"options":[{"value":true,"label":"Starts with"},{"value":false,"label":"Contains"}]},{"type":"select","name":"STATUS","defaultValue":"ALL","label":"Status","options":[{"value":"ACTIVE_UNLAPSED","label":"Active (unlapsed)"},{"value":"ACTIVE_LAPSED_UNLAPSED","label":"Active (lapsed and unlapsed)"}]},{"type":"text","name":"EXCLUDE_VALUES","label":"Exclude Debtor Names (comma separated list of names to exclude)","defaultValue":""},{"type":"dateRange","name":"FILING_DATE","label":"Financing Statement Date","defaultValue":{"start":null,"end":null}},{"type":"dateRange","name":"LAPSE_DATE","label":"Lapse Date","defaultValue":{"start":null,"end":null}},{"type":"text","name":"CITY","label":"Debtor City","defaultValue":""}],"myRecordsFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Approved"},{"value":2,"label":"Pending Online Payment"},{"value":3,"label":"Pending Review"}]},{"type":"select","name":"TYPE","defaultValue":0,"label":"Lien Type","options":[{"value":0,"label":"All"},{"value":1,"label":"UCC"},{"value":2,"label":"EFS"},{"value":3,"label":"Title 71"}]}],"myWorkQueueFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Approved"},{"value":2,"label":"Pending Online Payment"},{"value":3,"label":"Pending Review"},{"value":4,"label":"Pending Print and Mail"},{"value":5,"label":"Rejected"},{"value":6,"label":"Draft"}]},{"type":"select","name":"TYPE","defaultValue":0,"label":"Lien Type","options":[{"value":0,"label":"All"},{"value":1,"label":"UCC"},{"value":2,"label":"EFS"},{"value":3,"label":"Title 71"}]}]},{"label":"Copy Request","component":"copies","parameter":"copies","sourceTypeId":2001,"myRecordsSearch":false,"myWorkQueueSearch":false,"disabled":false,"allowedRoutes":["/forms-manager/","/queue/","/forms/"]},{"label":"Trademark","component":"Trademark","parameter":"trademark","sourceTypeId":810,"showRequestCertificate":true,"searchMustHaveOneOf":["search","EXPIRATION_DATE","FILING_DATE"],"allowEmptySearchTerm":true,"requestCertificateAlternateLabel":"Request Information","fileAmendmentButtonLabel":"Filing Actions","advancedSearchParameters":[{"type":"radio","name":"QUERY_TYPE_ID","defaultValue":1010,"options":[{"value":1010,"label":"Starts with"},{"value":1011,"label":"Contains"},{"value":1012,"label":" Word Contains"}]},{"type":"checkbox","name":"OWNER_SEARCH_YN","defaultValue":false,"label":"Search owners"},{"type":"radio","name":"SERVICE_MARK_YN","label":"Mark Type","defaultValue":"","options":[{"value":"","label":"All Marks"},{"value":"Y","label":"Service Mark"},{"value":"N","label":"Trademark"}]},{"type":"serverSelect","name":"STATUS_ID","optionsSrc":"TYPE_V|TRADEMARK_STATUS_TYPE","label":"Status","placeholder":"All","defaultValue":"0"},{"type":"select","name":"DESIGN_TYPE_ID","options":[{"value":0,"label":"All"},{"value":990,"label":"Words Only"},{"value":991,"label":"Design Only"},{"value":992,"label":"Words and Design"}],"label":"Design Type","defaultValue":"0"},{"type":"dateRange","name":"FILING_DATE","label":"Registered Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}},{"type":"dateRange","name":"EXPIRATION_DATE","label":"Expiration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}}]},{"label":"Business Info Request","component":"InfoRequests","parameter":"info-request","sourceTypeId":167,"allowedRoutes":["/forms-manager/","/queue/","/forms/"]},{"label":"Data Requests","component":"DataRequests","parameter":"data-request","sourceTypeId":0,"allowedRoutes":["/forms-manager/"]},{"label":"CRA","component":"CRA","parameter":"cra","sourceTypeId":157,"myRecordsSearch":false,"searchPlaceholder":"Search by name or registered agent number","allowedRoutes":["/forms-manager/","/forms/","/records/","/queue/","/search/"],"allowEmptySearchTerm":true,"fileAmendmentButtonLabel":"Filing Actions","advancedSearchParameters":[{"type":"radio","name":"QUERY_TYPE_ID","defaultValue":1010,"options":[{"value":1010,"label":"Starts with"},{"value":1011,"label":"Contains"},{"value":1012,"label":" Word Contains"}]},{"type":"dateRange","name":"CRA_DATE","label":"Registration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}},{"type":"select","name":"STATUS_ID","label":"Status","defaultValue":0,"options":[{"value":0,"label":"All"},{"value":121,"label":"Active"},{"value":122,"label":"Inactive"}]},{"type":"select","name":"AGENT_TYPE_ID","label":"Agent Type","defaultValue":0,"options":[{"value":0,"label":"All"},{"value":460,"label":"Registered Agent"},{"value":461,"label":"Commercial Registered Agent"}]}]},{"label":"Farm Bill","component":"FarmBill","parameter":"farm-bill","path":"/lists/farm-bill","sourceTypeId":0,"myRecordsSearch":false,"allowedRules":["/search/"],"disabled":true,"searchDescription":"To perform a search, enter a debtor name. Your search results may include: exact debtor name, variations of that name and any filing that includes your search criteria. Punctuation is ignored.\n\nYou can click on \"Advanced\" to refine your search. Under “Advanced” you can search by crop, year, county and SSN/FEIN. As a registered Farm Bill Buyer with the Montana Secretary of State’s office it is important to maintain the confidentiality of the information contained within the Farm Bill Master List. The Farm Bill Master List reflects personal data, such as Social Security Numbers, which are a key piece of personal identifiable information to assist you in determining the existence of a lien against a specific debtor. The distribution of this information beyond its intended purpose is strictly prohibited.\n\nThe debtor's tax identification number has been hidden for confidentiality reasons. You may continue to search on a tax ID number and return debtors that match your search criteria. The SSN/FEIN must be entered without dashes or spaces.","searchMustHaveOneOf":["search","UCC_FARM_PRODUCT_ID","COUNTY"],"searchPlaceholder":"Search by debtor name","advancedSearchParameters":[{"type":"ServerMultiComplete","label":"Product code name(s)","name":"UCC_FARM_PRODUCT_ID","defaultValue":"","optionsSrc":"UCC_FARM_PRODUCT_V"},{"type":"MultiComplete","label":"Year or Range of Years","name":"YEAR_NUM","optionsSrc":"years","startYear":"1968","defaultValue":[],"preMergeOptions":[{"value":"ALL","label":"All"}]},{"type":"serverSelect","label":"State","name":"STATE","defaultValue":"MONTANA","optionsSrc":"STATE"},{"type":"ServerMultiComplete","label":"County","name":"COUNTY","defaultValue":[],"optionsSrc":"COUNTY","overrideSubOptionsSrcFromParameterName":"STATE"},{"type":"checkbox","name":"TIN_SEARCH_YN","defaultValue":false,"label":"Tax Identification Number Search"},{"type":"checkbox","name":"TIN_SORT_YN","defaultValue":false,"label":"Unique ID Sort"}]}],"SYSTEM_NICKNAME":"Online Services Portal","PAYMENT_METHODS":[{"type":"bypass"},{"type":"iTransact"}],"PAYMENT_ALLOW_AMEX":true,"SYSTEM_ID_LABEL":"System Id","DOUBLE_COLUMN_PUBLIC_LOGIN":true,"INTERNAL_USER_MANAGEMENT":true,"ALLOW_PUBLIC_JSON_IMPORT":false,"MAX_FILE_UPLOAD_SIZE":10000000,"REFUND_TEXT":"","RETURN_TO_HOME_ON_LOGOUT":true,"CURRENT_SOS_NAME":"Christi Jacobsen","LOGO_FILENAME":"mt-sos-logo.png","LOGO_ALT":"Christi Jacobsen, Montana Secretary of State","LOGO_FULL_WIDTH":true,"HOME_HIDE_AUTH_HINT":true,"HOME_TITLE":"Montana Secretary of State","CUSTOM_TAB_TITLE":"Official Montana","HOME_SUBTITLE":"Online Business Services","ENTITY_NAME_CONSENT_DESCRIPTION":"","ALLOW_USER_PROFILE_EDITING":true,"COMPARE_FOREIGN_NAME_IN_ENTITY_NAME_VALIDATION":true,"FOREIGN_NAME_FIELD_NAME":"KIMA_PARENT_NAME_INFO","LOGIN_TITLE":"Montana Secretary of State Online Filing Portal Login","PUBLIC_LOGIN_LABEL":"Username","REVERSE_LOGIN_COLUMNS":true,"LOGIN_SEAL_FILENAME":"seal_white.png","SEPARATE_USERNAME_AND_EMAIL":true,"CREATE_ACCOUNT_BUTTON_ALIGN_LEFT":true,"CREATE_ACCOUNT_BUTTON_TEXT":"CREATE AN ACCOUNT","PASSWORD_CUSTOM_ERROR_TEXT":"The password must meet all requirements","ACCOUNT_CREATED_MESSAGE":"Please check your email to verify your account to login and allow a few minutes for this message to arrive. Check your junk/spam folders if you do not find the email in your inbox.","PUBLIC_LOGIN_PLACEHOLDER":" ","DISABLE_DEFAULT_PAYMENT_RADIO":true,"CUSTOM_RESET_PASSWORD_ERROR_MESSAGE":"Username invalid - no account found","PUBLIC_LOGIN_CREATE_DESCRIPTION":"### Existing User:\n\n  - Enter your username and password to login.  \n\n\n  #### - OR -  \n\n\n\n  - Forgot password? Click 'Reset Password' and follow the prompts.\n  - Forgot username? Click 'Forgot Username' and follow the prompts.  \n\n\n  ### New User:\n  ","LOGIN_HELP_LINK":"https://sosmt.gov/business/how-do-i/","LOGIN_HELP_LINK_TEXT":"Need Help?","FORGOT_USERNAME_TEXT":"Forgot Username?","LOGIN_ACTIVE_DIRECTORY_TEXT":"State User Login","MULTIPLE_LOGIN_METHODS":true,"HAS_ACTIVE_DIRECTORY_LOGIN":true,"RESET_PASSWORD_WITH_USERNAME":true,"DOWNLOAD_LINK":true,"SHOW_USERNAME_ACCOUNT_CREATE":true,"SHOW_SCROLL_DOWN_ARROW":true,"SHOW_ADDRESS_ACCOUNT_CREATE":true,"TWO_COLUMN_ACCOUNT_CREATE":true,"RESET_PASSWORD_TIP":"A link to change your password has been sent to your email. Please allow a few minutes for this message to arrive. Please check your junk/spam folders if you do not find the email in your inbox.","FORGOT_PASSWORD_LINK_TEXT":"Reset Password","PHONE_NUMBER_OPTIONAL_ACCOUNT_CREATE":true,"SHOW_REQUIRED_INDICATOR_ACCOUNT_CREATE":true,"PASSWORD_REQUIREMENTS_ACCOUNT_CREATE":"\n    <ul>\n      <li>MUST contain at least 8 characters (12+ recommended)</li>\n      <li>MUST contain at least one uppercase letter.</li>\n      <li>MUST contain at least one lowercase letter.</li>\n      <li>MUST contain at least one number.</li>\n      <li>MUST contain at least one special character (!”#$%&'()*+,-./:;<=>?</li>\n    </ul>\n  ","ALLOW_CERTIFICATION_REQUEST":true,"ALLOW_PUBLIC_CERTIFICATE_REQUEST":true,"ALLOW_COPY_REQUEST":false,"ALLOW_CORRECTION_STYLING":true,"HIDE_DEPRECATION_WARNING":false,"AMEND_ROUTE_PUBLIC":true,"SEAL_FILENAME":"seal.png","SHOPPING_CART":true,"ALLOW_PAYMENT_UPDATE_WITH_EMPTY_CART":true,"RA_EMAIL":true,"RA_WEBSITE":true,"RA_NO_DEFAULT_TYPE":true,"RA_ADDRESS_LABEL":"Street Address","RA_TYPE_SELECTION_DEFAULT":true,"RA_DEFAULT_TYPE":"460","RA_OVERRIDE_TYPE_WITH_DEFAULT":true,"RA_PRINCIPAL_ADDRESS_AMS":true,"UPLOAD_AND_SUBMIT_HIDE_IF_ONE_OPTION":true,"PAYMENT_PROCESSING_MESSAGE":"Your payment is processing - Do not close your browser or click the back button","CHECKOUT_BUTTON_WHEN_PROCESSING_TEXT":"Processing","EFS_CROP_PICKER_NONE_LABEL":"Lien Duration","DISALLOWED_WIZARD_PIECES":["FormationLocale"],"REPEATER_SHOW_EDIT_BUTTON":true,"DATA_REQUEST_PAGE_TITLE":"Data Requests and Subscriptions","DATA_REQUEST_SIDEBAR_LABEL":"Data Requests & Subscriptions","LOGIN_REDIRECTS_TO_EPASS":false,"LOGIN_REDIRECTS_TO_ACTIVE_DIRECTORY":true,"LOGIN_ACTIVE_DIRECTORY_LINK":true,"FETCH_EDIT_USER_LINK":false,"LISTS_FETCH_AVAILABLE_LISTS":true,"POST_WIZARD_SUBMIT_REDIRECT_URL":"/","PIN_REQUEST_ATTESTATIONS":true,"PIN_REQUEST_DESCRIPTION":"Click **Request PIN** to have a new PIN sent to the account holder's email address on file.","OWNERSHIP_REQUEST_DESCRIPTION":"To become an **authorized user** of this record, a current **AUTHORIZED USER** will need to grant you access. To request access, click **Request Access** below.","PIN_REQUEST_SUCCESS_MESSAGE":"The PIN you have requested for this entity has been sent to the email associated with your user account.  You should receive the PIN in approximately 3-5 minutes, depending on your email service provider.","APOSTILLE_HEADER_LABEL":"Verification Information","APOSTILLE_NUMBER_LABEL":"Apostille/Authentication","APOSTILLE_CITY_STATE_OVERRIDE":"HELENA, MT","APOSTILLE_FILING_DATE_LABEL":"Issue Date","APOSTILLE_CITY_STATE_IN_CERTIFIED":true,"NOTARY_EXISTING_FILING":true,"ALLOW_REVOKE_OWN_ACCESS_ONLY":false,"HIDE_CANCEL_ON_ONETIME_DATA_REQUESTS":true,"DATA_REQUESTS_IN_SHOPPING_CART":true,"WQ_ALLOW_EDIT_PENDING_PAYMENT":true,"WQ_CONFIRM_ON_DELETE":true,"WQ_DELETE_CONFIRM_MESSAGE":"Deleting this filing will forfeit any money already paid to the Secretary of State. This action is permanent and cannot be undone, are you sure you would like to delete?","PASS_ITEM_GUIDS_ON_CHECKOUT":true,"FORM_REVISION_HISTORY":true,"CHECKOUT_DISCLAIMER":"By entering your credit card and/or checking account information you (i) state that **you are an authorized user** of the credit card and/or electronic check and that the associated information entered (e.g., account holder name, account number, billing address) is accurate, (ii) **you authorize payment processor to charge the amount you have requested** to your credit card and/or funding account, and (iii) **acknowledge if a charge is declined or reversed you may also be assessed a customary charge** by the payment processor for such transactions.","FARM_BILL_SEARCH_CONFIDENTIAL":"As a registered Farm Bill Buyer with the Montana Secretary of State’s office it is important to maintain the confidentiality of the information contained within the Farm Bill Master List. The Farm Bill Master List reflects personal data, such as Social Security Numbers, which are a key piece of personal identifiable information to assist you in determining the existence of a lien against a specific debtor. The distribution of this information beyond its intended purpose is strictly prohibited.\n\n**The debtor's tax identification number has been hidden for confidentiality reasons. You may continue to search on a tax ID number and return debtors that match your search criteria. The SSN/FEIN must be entered without dashes or spaces.  If you need access to the tax identification number to clearly identify the debtor, please contact the UCC unit at (406) 444-3665.**","VIEW_HISTORY_BUTTON_ALT_TEXT":"View Filings","WIZARD_ERROR_TITLE_MESSAGE":"Form Error","FARM_BILL_SEARCH_INTERACTIVE":true,"USE_FARM_BILL_API":true,"DISALLOW_ASSIGN_SELF_AS_RA":true,"DISALLOW_ASSIGN_SELF_AS_PRINCIPAL":true,"USE_TRADEMARK_OWNER_VALIDATION":true,"USE_ALTERNATIVE_FOREIGN_ADDRESS_LABELS":true,"MY_RECEIPTS_FILTER":[{"type":"dateRange","name":"DATE_RANGE","label":"Date range","defaultValue":{"start":null,"end":null}},{"type":"text","name":"REF_NUM","defaultValue":"","label":"Reference Number"},{"type":"text","name":"RECEIPT_NUM","defaultValue":"","label":"Receipt Id"},{"type":"text","name":"AMOUNT","defaultValue":"","label":"Amount"},{"type":"select","name":"TYPE","defaultValue":"","label":"Payment Type","options":[{"value":"","label":"All"},{"value":"CC","label":"Credit Card"},{"value":"Check","label":"Check"}]}],"MY_RECEIPTS_SHOW_IN_SIDEBAR":true,"SHOW_MY_RECEIPTS_HELPER_TEXT":true,"MY_RECEIPTS_HELPER_LABEL":"About Receipt Search","MY_RECEIPTS_HELPER_TEXT":"You can search for receipts based on their descriptions, including the items paid for on the receipt. Use the filters to search for or filter specific information.","FARM_BILL_SUBLINK":{"label":"Farm Bill","component":"FarmBill","parameter":"farm-bill","path":"/lists/farm-bill","sourceTypeId":0,"myRecordsSearch":false,"allowedRules":["/search/"],"disabled":true,"searchDescription":"To perform a search, enter a debtor name. Your search results may include: exact debtor name, variations of that name and any filing that includes your search criteria. Punctuation is ignored.\n\nYou can click on \"Advanced\" to refine your search. Under “Advanced” you can search by crop, year, county and SSN/FEIN. As a registered Farm Bill Buyer with the Montana Secretary of State’s office it is important to maintain the confidentiality of the information contained within the Farm Bill Master List. The Farm Bill Master List reflects personal data, such as Social Security Numbers, which are a key piece of personal identifiable information to assist you in determining the existence of a lien against a specific debtor. The distribution of this information beyond its intended purpose is strictly prohibited.\n\nThe debtor's tax identification number has been hidden for confidentiality reasons. You may continue to search on a tax ID number and return debtors that match your search criteria. The SSN/FEIN must be entered without dashes or spaces.","searchMustHaveOneOf":["search","UCC_FARM_PRODUCT_ID","COUNTY"],"searchPlaceholder":"Search by debtor name","advancedSearchParameters":[{"type":"ServerMultiComplete","label":"Product code name(s)","name":"UCC_FARM_PRODUCT_ID","defaultValue":"","optionsSrc":"UCC_FARM_PRODUCT_V"},{"type":"MultiComplete","label":"Year or Range of Years","name":"YEAR_NUM","optionsSrc":"years","startYear":"1968","defaultValue":[],"preMergeOptions":[{"value":"ALL","label":"All"}]},{"type":"serverSelect","label":"State","name":"STATE","defaultValue":"MONTANA","optionsSrc":"STATE"},{"type":"ServerMultiComplete","label":"County","name":"COUNTY","defaultValue":[],"optionsSrc":"COUNTY","overrideSubOptionsSrcFromParameterName":"STATE"},{"type":"checkbox","name":"TIN_SEARCH_YN","defaultValue":false,"label":"Tax Identification Number Search"},{"type":"checkbox","name":"TIN_SORT_YN","defaultValue":false,"label":"Unique ID Sort"}]},"ALLOW_ADDRESS_VALIDATION_BYPASS_OPTION":true,"DEFAULT_ADDRESS_VALIDATION_BYPASS_OPTION_CHECKED":true}).UCC_SEARCH_ONLY_REQUIRE_LAST_NAME ? 'A last name must be entered' : 'First and last name are required.');
	          }
	        }
	        if (!UCC4Satisfied) {
	          errorMessage.push('At least one of the UCC 4 search types must be selected.');
	        }
	        callback(false, errorMessage.join('\n'));
	      }
	    };
	    if (({"NODE_ENV":"production","BUILD_DATE":"2025-08-27T15:15:31.687Z","BUILD_NUMBER":"Not Provided","GIT_VERSION":"v1.3.0-381-ga81e29b08","GIT_COMMIT_HASH":"a81e29b085c9268ffd96c78eb734365802722741","GIT_BRANCH":"beta","PUBLIC_URL":"","STATE_ABBR":"MT","STATE_NAME":"Montana","STATE_ORG_TITLE":"Secretary of State","LOGIN_HEADER_IMG_PATH":"","HOME_IMG_FILENAME":"montana.jpg","FAVICON_FILE_NAME":"favicon.ico","ALLOW_E_SIGN_ON_CORRECTIONS":true,"THIRD_PARTY_SIGNING_ALLOWED":false,"MY_ACCOUNT_SAVE_AND_CLOSE_BUTTON":true,"IE_DEPRECATED_MESSAGE":"Internet Explorer is not supported. Please select a supported browser below to access this website.","ADDITIONAL_ROUTES":{"dataRequests":true,"farmBill":true,"apostille":true,"externalHelp":"https://sosmt.gov/business/help-center/","systemAdministration":[{"title":"Saved Payments","parameter":"saved-payments","componentName":"SavedPayments"}]},"SUBROUTES":[{"label":"Business","component":"Business","parameter":"business","myWorkQueueSearch":false,"sourceTypeId":54,"searchMustHaveOneOf":["FILING_TYPE_ID","STATUS_ID","STATE","search"],"serverWebSearchDescription":true,"serverWorkQueueDescription":true,"serverMyRecordsDescription":true,"searchPlaceholder":"Search by name or filing number (X########)","allowEmptySearchTerm":true,"requestCertificateAlternateLabel":"Request Information","fileAmendmentButtonLabel":"Filing Actions","advancedSearchParameters":[{"type":"radio","name":"QUERY_TYPE_ID","defaultValue":1010,"options":[{"value":1010,"label":"Starts with"},{"value":1011,"label":"Contains"},{"value":1012,"label":" Word Contains"}]},{"type":"serverSelect","name":"FILING_TYPE_ID","optionsSrc":"FILING_TYPES","label":"Entity Type","placeholder":"All","defaultValue":"0"},{"type":"serverSelect","name":"FILING_SUBTYPE_ID","optionsSrc":"FILING_SUBTYPES","label":"Entity Subtype","overrideSubOptionsSrcFromParameterName":"FILING_TYPE_ID","placeholder":"All","defaultValue":"0"},{"type":"serverSelect","name":"STATUS_ID","optionsSrc":"FILING_STATUS_WITHOUT_ALL","label":"Status","placeholder":"All","defaultValue":"0"},{"type":"serverSelect","name":"STATE","optionsSrc":"STATE","label":"State","placeholder":"All","defaultValue":""},{"type":"serverSelect","name":"COUNTY","optionsSrc":"COUNTY_SUBOPTION","label":"County","overrideSubOptionsSrcFromParameterName":"STATE","placeholder":"All","defaultValue":""},{"type":"checkbox","name":"CRA_SEARCH_YN","defaultValue":false,"label":"Search by Registered Agent PID"},{"type":"dateRange","name":"FILING_DATE","label":"Registration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}},{"type":"dateRange","name":"EXPIRATION_DATE","label":"Expiration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}}],"myRecordsFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Active"},{"value":2,"label":"Inactive"},{"value":3,"label":"Pending"}]},{"type":"dateRange","name":"DATE_RANGE","label":"Date range","defaultValue":{"start":null,"end":null}}],"myWorkQueueFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Approved"},{"value":2,"label":"Pending Online Payment"},{"value":3,"label":"Pending Review"},{"value":4,"label":"Needs Correction"},{"value":5,"label":"Rejected"},{"value":6,"label":"Draft"}]},{"type":"dateRange","name":"DATE_RANGE","label":"Date range","defaultValue":{"start":null,"end":null}}]},{"label":"Notary","component":"Notary","parameter":"notary","sourceTypeId":850,"myWorkQueueSearch":false,"allowEmptySearchTerm":true,"requestCertificateAlternateLabel":"Download Certificate","fileAmendmentButtonLabel":"Filing Actions","hideNameRequestCertificate":true,"hideAddressRequestCertificate":true,"hideRecordUserManagment":true,"searchPlaceholder":"Search by name or commission number","searchMustHaveOneOf":["CITY","search","SERVICE_TYPE"],"advancedParametersStartOpen":true,"searchIsSortable":true,"advancedSearchParameters":[{"type":"radio","name":"STARTS_WITH_YN","defaultValue":false,"options":[{"value":true,"label":"Starts with"},{"value":false,"label":"Contains"}]},{"type":"checkbox","name":"ACTIVE_ONLY_YN","defaultValue":true,"label":"Active entities only"},{"type":"text","name":"CITY","defaultValue":"","label":"City"},{"type":"select","name":"SERVICE_TYPE","label":"Special Services Offered","defaultValue":0,"options":[{"value":0,"label":"(N/A)"},{"value":6165,"label":"In-Person Electronic Notarization (IPEN)"},{"value":6166,"label":"Remote Online Notarization (RON)"},{"value":6167,"label":"Mobile Notary Services"},{"value":6168,"label":"Remote Ink Notarization (RIN)"}]}]},{"label":"Apostille","component":"Apostille","parameter":"apostille","sourceTypeId":720,"myRecordsSearch":false,"myWorkQueueSearch":false,"disabled":false,"allowedRoutes":["/forms-manager/","/queue/","/forms/"]},{"label":"Liens","component":"UCC","parameter":"ucc","sourceTypeId":1999,"myRecordsSearch":true,"myWorkQueueSearch":true,"fileAmendmentButtonLabel":"Filing Actions","searchPlaceholder":"Search by name or file number","disabled":false,"serverWebSearchDescription":true,"myRecordsDescription":"","workQueueDescription":"","searchDescription":"","hideRecordUserManagment":true,"searchLiensCheckout":false,"advancedSearchParameters":[{"type":"radio","name":"STARTS_WITH_YN","defaultValue":false,"options":[{"value":true,"label":"Starts with"},{"value":false,"label":"Contains"}]},{"type":"select","name":"STATUS","defaultValue":"ALL","label":"Status","options":[{"value":"ACTIVE_UNLAPSED","label":"Active (unlapsed)"},{"value":"ACTIVE_LAPSED_UNLAPSED","label":"Active (lapsed and unlapsed)"}]},{"type":"text","name":"EXCLUDE_VALUES","label":"Exclude Debtor Names (comma separated list of names to exclude)","defaultValue":""},{"type":"dateRange","name":"FILING_DATE","label":"Financing Statement Date","defaultValue":{"start":null,"end":null}},{"type":"dateRange","name":"LAPSE_DATE","label":"Lapse Date","defaultValue":{"start":null,"end":null}},{"type":"text","name":"CITY","label":"Debtor City","defaultValue":""}],"myRecordsFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Approved"},{"value":2,"label":"Pending Online Payment"},{"value":3,"label":"Pending Review"}]},{"type":"select","name":"TYPE","defaultValue":0,"label":"Lien Type","options":[{"value":0,"label":"All"},{"value":1,"label":"UCC"},{"value":2,"label":"EFS"},{"value":3,"label":"Title 71"}]}],"myWorkQueueFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Approved"},{"value":2,"label":"Pending Online Payment"},{"value":3,"label":"Pending Review"},{"value":4,"label":"Pending Print and Mail"},{"value":5,"label":"Rejected"},{"value":6,"label":"Draft"}]},{"type":"select","name":"TYPE","defaultValue":0,"label":"Lien Type","options":[{"value":0,"label":"All"},{"value":1,"label":"UCC"},{"value":2,"label":"EFS"},{"value":3,"label":"Title 71"}]}]},{"label":"Copy Request","component":"copies","parameter":"copies","sourceTypeId":2001,"myRecordsSearch":false,"myWorkQueueSearch":false,"disabled":false,"allowedRoutes":["/forms-manager/","/queue/","/forms/"]},{"label":"Trademark","component":"Trademark","parameter":"trademark","sourceTypeId":810,"showRequestCertificate":true,"searchMustHaveOneOf":["search","EXPIRATION_DATE","FILING_DATE"],"allowEmptySearchTerm":true,"requestCertificateAlternateLabel":"Request Information","fileAmendmentButtonLabel":"Filing Actions","advancedSearchParameters":[{"type":"radio","name":"QUERY_TYPE_ID","defaultValue":1010,"options":[{"value":1010,"label":"Starts with"},{"value":1011,"label":"Contains"},{"value":1012,"label":" Word Contains"}]},{"type":"checkbox","name":"OWNER_SEARCH_YN","defaultValue":false,"label":"Search owners"},{"type":"radio","name":"SERVICE_MARK_YN","label":"Mark Type","defaultValue":"","options":[{"value":"","label":"All Marks"},{"value":"Y","label":"Service Mark"},{"value":"N","label":"Trademark"}]},{"type":"serverSelect","name":"STATUS_ID","optionsSrc":"TYPE_V|TRADEMARK_STATUS_TYPE","label":"Status","placeholder":"All","defaultValue":"0"},{"type":"select","name":"DESIGN_TYPE_ID","options":[{"value":0,"label":"All"},{"value":990,"label":"Words Only"},{"value":991,"label":"Design Only"},{"value":992,"label":"Words and Design"}],"label":"Design Type","defaultValue":"0"},{"type":"dateRange","name":"FILING_DATE","label":"Registered Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}},{"type":"dateRange","name":"EXPIRATION_DATE","label":"Expiration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}}]},{"label":"Business Info Request","component":"InfoRequests","parameter":"info-request","sourceTypeId":167,"allowedRoutes":["/forms-manager/","/queue/","/forms/"]},{"label":"Data Requests","component":"DataRequests","parameter":"data-request","sourceTypeId":0,"allowedRoutes":["/forms-manager/"]},{"label":"CRA","component":"CRA","parameter":"cra","sourceTypeId":157,"myRecordsSearch":false,"searchPlaceholder":"Search by name or registered agent number","allowedRoutes":["/forms-manager/","/forms/","/records/","/queue/","/search/"],"allowEmptySearchTerm":true,"fileAmendmentButtonLabel":"Filing Actions","advancedSearchParameters":[{"type":"radio","name":"QUERY_TYPE_ID","defaultValue":1010,"options":[{"value":1010,"label":"Starts with"},{"value":1011,"label":"Contains"},{"value":1012,"label":" Word Contains"}]},{"type":"dateRange","name":"CRA_DATE","label":"Registration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}},{"type":"select","name":"STATUS_ID","label":"Status","defaultValue":0,"options":[{"value":0,"label":"All"},{"value":121,"label":"Active"},{"value":122,"label":"Inactive"}]},{"type":"select","name":"AGENT_TYPE_ID","label":"Agent Type","defaultValue":0,"options":[{"value":0,"label":"All"},{"value":460,"label":"Registered Agent"},{"value":461,"label":"Commercial Registered Agent"}]}]},{"label":"Farm Bill","component":"FarmBill","parameter":"farm-bill","path":"/lists/farm-bill","sourceTypeId":0,"myRecordsSearch":false,"allowedRules":["/search/"],"disabled":true,"searchDescription":"To perform a search, enter a debtor name. Your search results may include: exact debtor name, variations of that name and any filing that includes your search criteria. Punctuation is ignored.\n\nYou can click on \"Advanced\" to refine your search. Under “Advanced” you can search by crop, year, county and SSN/FEIN. As a registered Farm Bill Buyer with the Montana Secretary of State’s office it is important to maintain the confidentiality of the information contained within the Farm Bill Master List. The Farm Bill Master List reflects personal data, such as Social Security Numbers, which are a key piece of personal identifiable information to assist you in determining the existence of a lien against a specific debtor. The distribution of this information beyond its intended purpose is strictly prohibited.\n\nThe debtor's tax identification number has been hidden for confidentiality reasons. You may continue to search on a tax ID number and return debtors that match your search criteria. The SSN/FEIN must be entered without dashes or spaces.","searchMustHaveOneOf":["search","UCC_FARM_PRODUCT_ID","COUNTY"],"searchPlaceholder":"Search by debtor name","advancedSearchParameters":[{"type":"ServerMultiComplete","label":"Product code name(s)","name":"UCC_FARM_PRODUCT_ID","defaultValue":"","optionsSrc":"UCC_FARM_PRODUCT_V"},{"type":"MultiComplete","label":"Year or Range of Years","name":"YEAR_NUM","optionsSrc":"years","startYear":"1968","defaultValue":[],"preMergeOptions":[{"value":"ALL","label":"All"}]},{"type":"serverSelect","label":"State","name":"STATE","defaultValue":"MONTANA","optionsSrc":"STATE"},{"type":"ServerMultiComplete","label":"County","name":"COUNTY","defaultValue":[],"optionsSrc":"COUNTY","overrideSubOptionsSrcFromParameterName":"STATE"},{"type":"checkbox","name":"TIN_SEARCH_YN","defaultValue":false,"label":"Tax Identification Number Search"},{"type":"checkbox","name":"TIN_SORT_YN","defaultValue":false,"label":"Unique ID Sort"}]}],"SYSTEM_NICKNAME":"Online Services Portal","PAYMENT_METHODS":[{"type":"bypass"},{"type":"iTransact"}],"PAYMENT_ALLOW_AMEX":true,"SYSTEM_ID_LABEL":"System Id","DOUBLE_COLUMN_PUBLIC_LOGIN":true,"INTERNAL_USER_MANAGEMENT":true,"ALLOW_PUBLIC_JSON_IMPORT":false,"MAX_FILE_UPLOAD_SIZE":10000000,"REFUND_TEXT":"","RETURN_TO_HOME_ON_LOGOUT":true,"CURRENT_SOS_NAME":"Christi Jacobsen","LOGO_FILENAME":"mt-sos-logo.png","LOGO_ALT":"Christi Jacobsen, Montana Secretary of State","LOGO_FULL_WIDTH":true,"HOME_HIDE_AUTH_HINT":true,"HOME_TITLE":"Montana Secretary of State","CUSTOM_TAB_TITLE":"Official Montana","HOME_SUBTITLE":"Online Business Services","ENTITY_NAME_CONSENT_DESCRIPTION":"","ALLOW_USER_PROFILE_EDITING":true,"COMPARE_FOREIGN_NAME_IN_ENTITY_NAME_VALIDATION":true,"FOREIGN_NAME_FIELD_NAME":"KIMA_PARENT_NAME_INFO","LOGIN_TITLE":"Montana Secretary of State Online Filing Portal Login","PUBLIC_LOGIN_LABEL":"Username","REVERSE_LOGIN_COLUMNS":true,"LOGIN_SEAL_FILENAME":"seal_white.png","SEPARATE_USERNAME_AND_EMAIL":true,"CREATE_ACCOUNT_BUTTON_ALIGN_LEFT":true,"CREATE_ACCOUNT_BUTTON_TEXT":"CREATE AN ACCOUNT","PASSWORD_CUSTOM_ERROR_TEXT":"The password must meet all requirements","ACCOUNT_CREATED_MESSAGE":"Please check your email to verify your account to login and allow a few minutes for this message to arrive. Check your junk/spam folders if you do not find the email in your inbox.","PUBLIC_LOGIN_PLACEHOLDER":" ","DISABLE_DEFAULT_PAYMENT_RADIO":true,"CUSTOM_RESET_PASSWORD_ERROR_MESSAGE":"Username invalid - no account found","PUBLIC_LOGIN_CREATE_DESCRIPTION":"### Existing User:\n\n  - Enter your username and password to login.  \n\n\n  #### - OR -  \n\n\n\n  - Forgot password? Click 'Reset Password' and follow the prompts.\n  - Forgot username? Click 'Forgot Username' and follow the prompts.  \n\n\n  ### New User:\n  ","LOGIN_HELP_LINK":"https://sosmt.gov/business/how-do-i/","LOGIN_HELP_LINK_TEXT":"Need Help?","FORGOT_USERNAME_TEXT":"Forgot Username?","LOGIN_ACTIVE_DIRECTORY_TEXT":"State User Login","MULTIPLE_LOGIN_METHODS":true,"HAS_ACTIVE_DIRECTORY_LOGIN":true,"RESET_PASSWORD_WITH_USERNAME":true,"DOWNLOAD_LINK":true,"SHOW_USERNAME_ACCOUNT_CREATE":true,"SHOW_SCROLL_DOWN_ARROW":true,"SHOW_ADDRESS_ACCOUNT_CREATE":true,"TWO_COLUMN_ACCOUNT_CREATE":true,"RESET_PASSWORD_TIP":"A link to change your password has been sent to your email. Please allow a few minutes for this message to arrive. Please check your junk/spam folders if you do not find the email in your inbox.","FORGOT_PASSWORD_LINK_TEXT":"Reset Password","PHONE_NUMBER_OPTIONAL_ACCOUNT_CREATE":true,"SHOW_REQUIRED_INDICATOR_ACCOUNT_CREATE":true,"PASSWORD_REQUIREMENTS_ACCOUNT_CREATE":"\n    <ul>\n      <li>MUST contain at least 8 characters (12+ recommended)</li>\n      <li>MUST contain at least one uppercase letter.</li>\n      <li>MUST contain at least one lowercase letter.</li>\n      <li>MUST contain at least one number.</li>\n      <li>MUST contain at least one special character (!”#$%&'()*+,-./:;<=>?</li>\n    </ul>\n  ","ALLOW_CERTIFICATION_REQUEST":true,"ALLOW_PUBLIC_CERTIFICATE_REQUEST":true,"ALLOW_COPY_REQUEST":false,"ALLOW_CORRECTION_STYLING":true,"HIDE_DEPRECATION_WARNING":false,"AMEND_ROUTE_PUBLIC":true,"SEAL_FILENAME":"seal.png","SHOPPING_CART":true,"ALLOW_PAYMENT_UPDATE_WITH_EMPTY_CART":true,"RA_EMAIL":true,"RA_WEBSITE":true,"RA_NO_DEFAULT_TYPE":true,"RA_ADDRESS_LABEL":"Street Address","RA_TYPE_SELECTION_DEFAULT":true,"RA_DEFAULT_TYPE":"460","RA_OVERRIDE_TYPE_WITH_DEFAULT":true,"RA_PRINCIPAL_ADDRESS_AMS":true,"UPLOAD_AND_SUBMIT_HIDE_IF_ONE_OPTION":true,"PAYMENT_PROCESSING_MESSAGE":"Your payment is processing - Do not close your browser or click the back button","CHECKOUT_BUTTON_WHEN_PROCESSING_TEXT":"Processing","EFS_CROP_PICKER_NONE_LABEL":"Lien Duration","DISALLOWED_WIZARD_PIECES":["FormationLocale"],"REPEATER_SHOW_EDIT_BUTTON":true,"DATA_REQUEST_PAGE_TITLE":"Data Requests and Subscriptions","DATA_REQUEST_SIDEBAR_LABEL":"Data Requests & Subscriptions","LOGIN_REDIRECTS_TO_EPASS":false,"LOGIN_REDIRECTS_TO_ACTIVE_DIRECTORY":true,"LOGIN_ACTIVE_DIRECTORY_LINK":true,"FETCH_EDIT_USER_LINK":false,"LISTS_FETCH_AVAILABLE_LISTS":true,"POST_WIZARD_SUBMIT_REDIRECT_URL":"/","PIN_REQUEST_ATTESTATIONS":true,"PIN_REQUEST_DESCRIPTION":"Click **Request PIN** to have a new PIN sent to the account holder's email address on file.","OWNERSHIP_REQUEST_DESCRIPTION":"To become an **authorized user** of this record, a current **AUTHORIZED USER** will need to grant you access. To request access, click **Request Access** below.","PIN_REQUEST_SUCCESS_MESSAGE":"The PIN you have requested for this entity has been sent to the email associated with your user account.  You should receive the PIN in approximately 3-5 minutes, depending on your email service provider.","APOSTILLE_HEADER_LABEL":"Verification Information","APOSTILLE_NUMBER_LABEL":"Apostille/Authentication","APOSTILLE_CITY_STATE_OVERRIDE":"HELENA, MT","APOSTILLE_FILING_DATE_LABEL":"Issue Date","APOSTILLE_CITY_STATE_IN_CERTIFIED":true,"NOTARY_EXISTING_FILING":true,"ALLOW_REVOKE_OWN_ACCESS_ONLY":false,"HIDE_CANCEL_ON_ONETIME_DATA_REQUESTS":true,"DATA_REQUESTS_IN_SHOPPING_CART":true,"WQ_ALLOW_EDIT_PENDING_PAYMENT":true,"WQ_CONFIRM_ON_DELETE":true,"WQ_DELETE_CONFIRM_MESSAGE":"Deleting this filing will forfeit any money already paid to the Secretary of State. This action is permanent and cannot be undone, are you sure you would like to delete?","PASS_ITEM_GUIDS_ON_CHECKOUT":true,"FORM_REVISION_HISTORY":true,"CHECKOUT_DISCLAIMER":"By entering your credit card and/or checking account information you (i) state that **you are an authorized user** of the credit card and/or electronic check and that the associated information entered (e.g., account holder name, account number, billing address) is accurate, (ii) **you authorize payment processor to charge the amount you have requested** to your credit card and/or funding account, and (iii) **acknowledge if a charge is declined or reversed you may also be assessed a customary charge** by the payment processor for such transactions.","FARM_BILL_SEARCH_CONFIDENTIAL":"As a registered Farm Bill Buyer with the Montana Secretary of State’s office it is important to maintain the confidentiality of the information contained within the Farm Bill Master List. The Farm Bill Master List reflects personal data, such as Social Security Numbers, which are a key piece of personal identifiable information to assist you in determining the existence of a lien against a specific debtor. The distribution of this information beyond its intended purpose is strictly prohibited.\n\n**The debtor's tax identification number has been hidden for confidentiality reasons. You may continue to search on a tax ID number and return debtors that match your search criteria. The SSN/FEIN must be entered without dashes or spaces.  If you need access to the tax identification number to clearly identify the debtor, please contact the UCC unit at (406) 444-3665.**","VIEW_HISTORY_BUTTON_ALT_TEXT":"View Filings","WIZARD_ERROR_TITLE_MESSAGE":"Form Error","FARM_BILL_SEARCH_INTERACTIVE":true,"USE_FARM_BILL_API":true,"DISALLOW_ASSIGN_SELF_AS_RA":true,"DISALLOW_ASSIGN_SELF_AS_PRINCIPAL":true,"USE_TRADEMARK_OWNER_VALIDATION":true,"USE_ALTERNATIVE_FOREIGN_ADDRESS_LABELS":true,"MY_RECEIPTS_FILTER":[{"type":"dateRange","name":"DATE_RANGE","label":"Date range","defaultValue":{"start":null,"end":null}},{"type":"text","name":"REF_NUM","defaultValue":"","label":"Reference Number"},{"type":"text","name":"RECEIPT_NUM","defaultValue":"","label":"Receipt Id"},{"type":"text","name":"AMOUNT","defaultValue":"","label":"Amount"},{"type":"select","name":"TYPE","defaultValue":"","label":"Payment Type","options":[{"value":"","label":"All"},{"value":"CC","label":"Credit Card"},{"value":"Check","label":"Check"}]}],"MY_RECEIPTS_SHOW_IN_SIDEBAR":true,"SHOW_MY_RECEIPTS_HELPER_TEXT":true,"MY_RECEIPTS_HELPER_LABEL":"About Receipt Search","MY_RECEIPTS_HELPER_TEXT":"You can search for receipts based on their descriptions, including the items paid for on the receipt. Use the filters to search for or filter specific information.","FARM_BILL_SUBLINK":{"label":"Farm Bill","component":"FarmBill","parameter":"farm-bill","path":"/lists/farm-bill","sourceTypeId":0,"myRecordsSearch":false,"allowedRules":["/search/"],"disabled":true,"searchDescription":"To perform a search, enter a debtor name. Your search results may include: exact debtor name, variations of that name and any filing that includes your search criteria. Punctuation is ignored.\n\nYou can click on \"Advanced\" to refine your search. Under “Advanced” you can search by crop, year, county and SSN/FEIN. As a registered Farm Bill Buyer with the Montana Secretary of State’s office it is important to maintain the confidentiality of the information contained within the Farm Bill Master List. The Farm Bill Master List reflects personal data, such as Social Security Numbers, which are a key piece of personal identifiable information to assist you in determining the existence of a lien against a specific debtor. The distribution of this information beyond its intended purpose is strictly prohibited.\n\nThe debtor's tax identification number has been hidden for confidentiality reasons. You may continue to search on a tax ID number and return debtors that match your search criteria. The SSN/FEIN must be entered without dashes or spaces.","searchMustHaveOneOf":["search","UCC_FARM_PRODUCT_ID","COUNTY"],"searchPlaceholder":"Search by debtor name","advancedSearchParameters":[{"type":"ServerMultiComplete","label":"Product code name(s)","name":"UCC_FARM_PRODUCT_ID","defaultValue":"","optionsSrc":"UCC_FARM_PRODUCT_V"},{"type":"MultiComplete","label":"Year or Range of Years","name":"YEAR_NUM","optionsSrc":"years","startYear":"1968","defaultValue":[],"preMergeOptions":[{"value":"ALL","label":"All"}]},{"type":"serverSelect","label":"State","name":"STATE","defaultValue":"MONTANA","optionsSrc":"STATE"},{"type":"ServerMultiComplete","label":"County","name":"COUNTY","defaultValue":[],"optionsSrc":"COUNTY","overrideSubOptionsSrcFromParameterName":"STATE"},{"type":"checkbox","name":"TIN_SEARCH_YN","defaultValue":false,"label":"Tax Identification Number Search"},{"type":"checkbox","name":"TIN_SORT_YN","defaultValue":false,"label":"Unique ID Sort"}]},"ALLOW_ADDRESS_VALIDATION_BYPASS_OPTION":true,"DEFAULT_ADDRESS_VALIDATION_BYPASS_OPTION_CHECKED":true}).UCC_SEARCH_ALLOW_SEARCH_TYPE) {
	      if (value.cache && (value.search.SEARCH_TYPE === 'UCC_NUM' ? value.SEARCH_UCC_NUM !== '' : commonFieldCheck)) {
	        callback(true, '');
	      } else {
	        var errorMessage = [];
	        if (value.search.SEARCH_TYPE === 'UCC_NUM') {
	          if (!value.cache) {
	            errorMessage.push('You must execute a search.');
	          }
	          if (!value.search.SEARCH_UCC_NUM) {
	            errorMessage.push('File number is required.');
	          }
	          callback(false, errorMessage.join('\n'));
	        } else {
	          checkCommonFields(value);
	        }
	      }
	    } else {
	      checkCommonFields(value);
	    }
	  },
	  atLeastOneUccSearchResultIsRequired: function atLeastOneUccSearchResultIsRequired(value, field) {
	    var props = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	    var callback = arguments[3];
	
	    var isPartial = value.IS_PARTIAL;
	    var lengthIsSatisfied = value.cache && value.cache.rows.length > 0;
	    var defaultErrorMessage = 'Search must return at least one result.';
	    var checkLength = function checkLength() {
	      if (props.onlyRequireWhenExists) {
	        if (!lengthIsSatisfied && isPartial) {
	          callback(false, props.errorMessage || defaultErrorMessage);
	        } else {
	          callback(true, '');
	        }
	      } else {
	        if (lengthIsSatisfied) {
	          callback(true, '');
	        } else {
	          callback(false, props.errorMessage || defaultErrorMessage);
	        }
	      }
	    };
	    if (props.onlyAppliesToFileNumber) {
	      if (value.search.SEARCH_TYPE !== 'UCC_NUM') {
	        callback(null, '');
	      } else {
	        checkLength();
	      }
	    } else {
	      checkLength();
	    }
	  },
	  mustSelectLocalSelect: function mustSelectLocalSelect(value, field) {
	    var props = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	    var callback = arguments[3];
	
	    var fields = _store2.default.getState().wizard.wizard.fields;
	    var srcRepeater = fields[field.srcRepeater];
	    var srcField = fields[field.srcField];
	    if (srcRepeater && srcField) {
	      if (valueIsNotEmptyOrNull(value)) {
	        var valueExists = srcRepeater.value.find(function (row) {
	          return row._rowId === value;
	        });
	        if (valueExists) {
	          callback(true, '');
	        } else {
	          callback(false, props.errorMessage || 'Select an option to continue.');
	        }
	      } else {
	        callback(false, props.errorMessage || 'Select an option to continue.');
	      }
	    } else {
	      callback(false, 'You must assign a Source Repeater and a Source Field to use this control.');
	    }
	  },
	  enforceRepeaterChildConstraints: function enforceRepeaterChildConstraints(value, field) {
	    var props = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	    var callback = arguments[3];
	
	    if (value.length > 0) {
	      var fields = _store2.default.getState().wizard.wizard.fields;
	      var columns = field.template.map(function (fieldId) {
	        return fields[fieldId];
	      });
	      (0, _repeaterConstraints.validateRepeaterConstraints)(columns, field).then(function (resolutions) {
	        var isValids = resolutions.map(function (r) {
	          return r.isValid;
	        });
	        var errors = resolutions.map(function (r) {
	          return r.errorMessage;
	        }).join('\n');
	        if (isValids.some(function (v) {
	          return v === false;
	        })) {
	          callback(false, errors);
	        } else if (isValids.some(function (v) {
	          return v === true;
	        })) {
	          callback(true, '');
	        } else {
	          callback(null, '');
	        }
	      });
	    } else {
	      callback(null);
	    }
	  },
	  minMultiComplete: function minMultiComplete(value, field) {
	    var props = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	    var callback = arguments[3];
	
	    if (value.length >= props.min) {
	      callback(true, '');
	    } else {
	      callback(false, props.errorMessage || 'You must select at least ' + props.min + ' to continue.');
	    }
	  },
	  efsRequired: function efsRequired(value, field) {
	    var props = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	    var callback = arguments[3];
	
	    if (value.yearType) {
	      switch (value.yearType) {
	        case 'duration':
	          if (value.startYear && value.endYear) callback(true, '');else callback(false, props.durationErrorMessage || 'Select a start and end year to continue.');
	          break;
	        case 'arbitrary':
	          if (value.years.length > 0) callback(true, '');else callback(false, props.arbitraryErrorMessage || 'Select at least one year to continue.');
	          break;
	        case 'all':
	        case 'none':
	        default:
	          callback(true, '');
	      }
	    } else {
	      callback(false, props.errorMessage || 'Select a crop year to continue.');
	    }
	  },
	  mayOnlyAddAdditionalRows: function mayOnlyAddAdditionalRows(value, field) {
	    var props = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	    var callback = arguments[3];
	
	    var original = _store2.default.getState().wizard.diff.originalByFieldId[field.fieldId];
	    var prevNumRows = original ? original.length : 0;
	    var numRows = value.length;
	    if (numRows <= prevNumRows + props.numRows) {
	      callback(true, '');
	    } else {
	      callback(false, props.errorMessage || 'You may not add more than ' + (prevNumRows + props.numRows) + ' row(s).');
	    }
	  },
	  mustHaveSameNumRowsAs: function mustHaveSameNumRowsAs(value, field) {
	    var props = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	    var callback = arguments[3];
	    var repeater = props.repeater;
	
	    if (repeater) {
	      var otherRepeater = _store2.default.getState().wizard.wizard.fields[repeater];
	      if (otherRepeater) {
	        if (otherRepeater.value.length === field.value.length) {
	          callback(true, '');
	        } else {
	          callback(false, props.errorMessage || 'You must provide exactly ' + otherRepeater.value.length + ' row(s).');
	        }
	      } else {
	        callback(null, '');
	      }
	    } else {
	      callback(false, 'This business rule failed because a repeater was not selected.');
	    }
	  },
	  onlyNumbers: function onlyNumbers(value, field) {
	    var props = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	    var callback = arguments[3];
	
	    if (!valueIsNotEmptyOrNull(value)) {
	      callback(null, '');
	    } else if (props.allowCommas ? !/^((\d+|\d{1,3}(,\d{3})*)(\.\d+)?|\.\d+)$/.test(value) : /\D+/g.test(value)) {
	      callback(false, props.errorMessage || 'This field must only contain numbers.');
	    } else {
	      callback(true, '');
	    }
	  },
	  maxCharacters: function maxCharacters(value, field) {
	    var props = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	    var callback = arguments[3];
	
	    if (valueIsNotEmptyOrNull(value)) {
	      if (value.length > props.maxCharacters) {
	        callback(false, props.errorMessage || 'This field may not contain more than ' + props.maxCharacters + ' character(s).');
	      } else {
	        callback(true);
	      }
	    } else {
	      callback(null);
	    }
	  },
	  minCharacters: function minCharacters(value, field) {
	    var props = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	    var callback = arguments[3];
	
	    if (valueIsNotEmptyOrNull(value)) {
	      if (value.length < props.minCharacters) {
	        callback(false, props.errorMessage || 'This field must contain at least ' + props.minCharacters + ' character(s).');
	      } else {
	        callback(true);
	      }
	    } else {
	      callback(null);
	    }
	  },
	  minRepeaterEdit: function minRepeaterEdit(value, field) {
	    var props = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	    var callback = arguments[3];
	
	    var edited = value.filter(function (r) {
	      return r._statusId === 2;
	    });
	    if (edited.length < props.minRows) {
	      callback(false, 'You must edit at least ' + props.minRows + ' row(s) to continue.');
	    } else {
	      callback(true, '');
	    }
	  },
	  minRepeaterDelete: function minRepeaterDelete(value, field) {
	    var props = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	    var callback = arguments[3];
	
	    var deleted = value.filter(function (r) {
	      return r._statusId === 3;
	    });
	    if ((props.disableIfOne ? value.length >= 1 : true) && deleted.length < props.minRows) {
	      callback(false, props.errorMessage || 'You must delete at least ' + props.minRows + ' row(s) to continue.');
	    } else {
	      callback(true, '');
	    }
	  },
	  checkForRegulatedWords: function checkForRegulatedWords(value, field) {
	    var props = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	    var callback = arguments[3];
	
	    var promises = props.regulatedWordLists.map(function (category) {
	      return new Promise(function (resolve, reject) {
	        api.VALIDATE("TriggerWords", {
	          CATEGORY: category,
	          VALUE: value,
	          FIELD_TYPE: field.type
	        }, function (response) {
	          return resolve(response);
	        }, function (err) {
	          return reject(err);
	        });
	      });
	    });
	
	    Promise.all(promises).then(function (responses) {
	      var isValid = responses.every(function (res) {
	        return res.valid !== false;
	      });
	      var errorMessage = responses.filter(function (res) {
	        return res.error;
	      }).map(function (res) {
	        return res.error;
	      }).join("\n");
	      var infoMessage = responses.filter(function (res) {
	        return res.payload.INFO_MESSAGE;
	      }).map(function (res) {
	        return res.payload.INFO_MESSAGE;
	      }).join("\n");
	      var triggerInternalReview = responses.some(function (res) {
	        return res.payload.TRIGGER_INTERNAL_REVIEW;
	      });
	      if (triggerInternalReview) {
	        _store2.default.dispatch({
	          type: 'ADD_INTERNAL_REVIEW_REQUIRED',
	          fieldId: field.fieldId
	        });
	      } else {
	        _store2.default.dispatch({
	          type: 'REMOVE_INTERNAL_REVIEW_REQUIRED',
	          fieldId: field.fieldId
	        });
	      }
	      callback(isValid, errorMessage, { infoMessage: infoMessage });
	    });
	  },
	  customBusinessRules: function customBusinessRules(value, field) {
	    var props = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	    var callback = arguments[3];
	    var options = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {};
	
	    if (props.rules && props.rules.length) {
	      var ruleResults = props.rules.map(function (rule) {
	        return _store.resolveFieldEngine.resolveRootNode(rule.logicNodes, { context: options });
	      });
	      callback(ruleResults.every(function (res) {
	        return res.isValid;
	      }), ruleResults.filter(function (res) {
	        return res.isValid === false;
	      }).map(function (res) {
	        return res.errorMessage;
	      }).join("\n"));
	    } else {
	      callback(null, '');
	    }
	  }
	};
	
	var getIsValid = function getIsValid(fn, value, field, props, callback, options) {
	  var validateFunction = VALIDATE[fn];
	  if (validateFunction) {
	    VALIDATE[fn](value, field, props, function (valid, errorMessage, payload) {
	      callback(valid, errorMessage, payload);
	    }, options);
	  } else {
	    callback(null, "");
	  }
	};
	
	var loopThroughRules = exports.loopThroughRules = function loopThroughRules(_ref3, callback) {
	  var businessRules = _ref3.businessRules,
	      value = _ref3.value,
	      field = _ref3.field,
	      event = _ref3.event,
	      options = _ref3.options;
	
	  var validation = {
	    valids: [],
	    errors: [],
	    payload: {}
	  };
	  var promises = [];
	  for (var i = 0; i < businessRules.length; i++) {
	    var rule = businessRules[i];
	    promises[i] = new Promise(function (resolve, reject) {
	      if (_businessRules.BUSINESS_RULES[rule.fn][event] === true) {
	        getIsValid(rule.fn, value, field, rule.props, function (valid, errorMessage, payload) {
	          if (valid === true || valid === false) {
	            validation.valids.push(valid);
	          }
	          validation.errors.push(errorMessage);
	          validation.payload = Object.assign({}, validation.payload, payload);
	          resolve('Returned');
	        }, Object.assign({ event: event }, options));
	      } else {
	        resolve();
	      }
	    });
	  }
	
	  Promise.all(promises).then(function (values) {
	    callback(validation);
	  });
	};
	
	var MASK = exports.MASK = {
	  onlyNumbers: function onlyNumbers(value) {
	    var props = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	    //Tests that the value contains only numbers, and returns the value minus letters if not
	    if (value === '') {
	      return value;
	    } else {
	      var sanitizedValue = value;
	      if (props.allowDecimal && value.includes('.')) {
	        var segments = value.split('.');
	        if (props.commas) {
	          segments[0] = segments[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
	          sanitizedValue = segments[0] + '.' + segments.slice(1).join('');
	        } else {
	          segments = segments.map(function (seg) {
	            return seg.replace(/\D+/g, '');
	          });
	          sanitizedValue = segments[0].replace(/\D+/g, '') + '.' + segments.slice(1).join('');
	        }
	      } else {
	        sanitizedValue = value.replace(/\D+/g, '');
	        if (props.leadingZerosAllowed === false) {
	          sanitizedValue = parseInt(sanitizedValue === '' ? 0 : sanitizedValue, 10).toString();
	        }
	        if (props.commas) {
	          sanitizedValue = sanitizedValue.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
	        }
	      }
	      return sanitizedValue;
	    }
	  },
	  phone: function phone(value, props) {
	    var x = value.replace(/\D/g, '').match(/(\d{0,3})(\d{0,3})(\d{0,4})/);
	    value = !x[2] ? x[1] : '(' + x[1] + ') ' + x[2] + (x[3] ? '-' + x[3] : '');
	    return value;
	  },
	  social: function social(value, props) {
	    var val = value.replace(/\D/g, '');
	    var newVal = '';
	    if (val.length > 4) {
	      value = val;
	    }
	    if (val.length > 3 && val.length < 6) {
	      newVal += val.substr(0, 3) + '-';
	      val = val.substr(3);
	    }
	    if (val.length > 5) {
	      newVal += val.substr(0, 3) + '-';
	      newVal += val.substr(3, 2) + '-';
	      val = val.substr(5);
	    }
	    newVal += val;
	    value = newVal.substring(0, 11);
	    return value;
	  },
	  fein: function fein(value) {
	    var props = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	    var val = value.replace(/\D+/g, '').split('');
	    var newVal = void 0;
	    if (val.length > 2) {
	      newVal = val.slice(0, 2).join('') + '-' + val.slice(2, 9).join('');
	    } else {
	      newVal = val.join('');
	    }
	    return newVal;
	  },
	  currency: function currency(value) {
	    var props = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	    var hasDecimal = value.split('.').length > 1;
	    if (value === '$' || value === '$ ' || value === ' ') {
	      return '';
	    }
	    if (hasDecimal) {
	      var segments = value.split('.');
	      var extraSegements = segments.slice(2);
	      var seg1 = segments[0].replace(/\D/g, '').replace(/$ /g, '').replace(/$/g, '').replace(/ /g, '');
	      var seg2 = segments[1];
	      if (extraSegements) {
	        seg2 += extraSegements.join();
	      }
	      seg2 = seg2.replace(/\D/g, '').replace(/$ /g, '').replace(/$/g, '').replace(/ /g, '');
	      if (props.commas) {
	        seg1 = seg1.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
	      }
	      return '$' + seg1 + '.' + seg2;
	    } else {
	      var sanitized = value.replace(/\D/g, '').replace(/$ /g, '').replace(/$/g, '').replace(/ /g, '');
	      if (props.commas) {
	        sanitized = sanitized.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
	      }
	      return '$' + sanitized;
	    }
	  },
	  // onlyLetters: (value, field, props = {}) => {
	  onlyLetters: function onlyLetters(value) {
	    var props = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	    if (Array.isArray(value)) {
	      return value.map(function (v) {
	        return MASK.onlyLettersSignature(v, props);
	      });
	    } else if (value.sig !== undefined) {
	      return MASK.onlyLettersSignature(value, props);
	    }
	    var valueToReturn = '';
	    var originalValue = value.split("");
	    originalValue.forEach(removeProhibitedCharacters);
	    function removeProhibitedCharacters(item) {
	      var trimmedAllowedSpecialCharacters = props.allowedSpecialCharacters.replace(/\s/g, '');
	      if (trimmedAllowedSpecialCharacters.includes(item)) {
	        valueToReturn = valueToReturn + item;
	      } else {
	        valueToReturn = valueToReturn + item.replace(/[^a-zA-Z\s]/g, '');
	      }
	    }
	    return value.replace(value, valueToReturn);
	
	    // if (props.allowedSpecialCharacters.trim.includes(value)){
	    //   return value
	    // }
	    // else{
	    //   return value.replace(/[^a-zA-Z\s]/g, '')
	    // }
	  },
	  onlyLettersSignature: function onlyLettersSignature(value, props) {
	    var newVal = Object.assign({}, value);
	    newVal.sig = MASK.onlyLetters(newVal.sig || "", props);
	    newVal.behalf = MASK.onlyLetters(newVal.behalf || "", props);
	    return newVal;
	  },
	  maxStringLength: function maxStringLength(value) {
	    var props = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	    return value.slice(0, props.max);
	  },
	  zipCode: function zipCode(value) {
	    var props = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	    var val = value.replace(/\D+/g, '').split('');
	    if (val.length > 5) {
	      val = val.slice(0, 5).join('') + '-' + val.slice(5, 9).join('');
	    } else {
	      val = val.join('');
	    }
	    return val;
	  },
	  addressZipCode: function addressZipCode(value) {
	    var props = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	    var newVal = Object.assign({}, value);
	    newVal.POSTAL_CODE = MASK.zipCode(newVal.POSTAL_CODE);
	    return newVal;
	  },
	  onlyAscii: function onlyAscii(value) {
	    var props = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	    if (typeof value.val1 === 'string' || typeof value.val2 === 'string') {
	      return MASK.onlyAsciiConfirmFields(value, props);
	    } else {
	      return value.replace(/[^\x20-\x7e]/g, '');
	    }
	  },
	  onlyAsciiConfirmFields: function onlyAsciiConfirmFields(value) {
	    var props = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	    return Object.assign({}, value, {
	      val1: MASK.onlyAscii(value.val1, props),
	      val2: MASK.onlyAscii(value.val2, props)
	    });
	  },
	  allUpperCase: function allUpperCase() {
	    var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
	    var props = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	    return (value === null ? '' : value).toUpperCase();
	  },
	  addressUpperCase: function addressUpperCase(value) {
	    var props = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	    var newVal = Object.assign({}, value);
	    newVal.ADDR1 = MASK.allUpperCase(newVal.ADDR1);
	    newVal.ADDR2 = MASK.allUpperCase(newVal.ADDR2);
	    newVal.ADDR3 = MASK.allUpperCase(newVal.ADDR3);
	    newVal.CITY = MASK.allUpperCase(newVal.CITY);
	    newVal.STATE = MASK.allUpperCase(newVal.STATE);
	    newVal.POSTAL_CODE = MASK.allUpperCase(newVal.POSTAL_CODE);
	    if (newVal.MAIL_ADDR) {
	      newVal.MAIL_ADDR.ADDR1 = MASK.allUpperCase(newVal.MAIL_ADDR.ADDR1);
	      newVal.MAIL_ADDR.ADDR2 = MASK.allUpperCase(newVal.MAIL_ADDR.ADDR2);
	      newVal.MAIL_ADDR.ADDR3 = MASK.allUpperCase(newVal.MAIL_ADDR.ADDR3);
	      newVal.MAIL_ADDR.CITY = MASK.allUpperCase(newVal.MAIL_ADDR.CITY);
	      newVal.MAIL_ADDR.STATE = MASK.allUpperCase(newVal.MAIL_ADDR.STATE);
	      newVal.MAIL_ADDR.POSTAL_CODE = MASK.allUpperCase(newVal.MAIL_ADDR.POSTAL_CODE);
	    }
	    return newVal;
	  },
	  time: function time(value) {
	    var props = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	    var splitValue = value.split(' ');
	    var time = splitValue[0].replace(':', '');
	    var period = splitValue[1];
	    // const masked = time.replace(/^(0?[1-9]|1[012]):[0-5][0-9]$/g, '')
	    var masked = '';
	    if (time[0] == '0' || time[0] == '1') {
	      masked += time[0];
	    } else {
	      masked += '';
	    }
	    if (time[0] == '0') {
	      masked += ['1', '2', '3', '4', '5', '6', '7', '8', '9'].includes(time[1]) ? time[1] : '';
	    }
	    if (time[0] == '1') {
	      masked += ['1', '2'].includes(time[1]) ? time[1] : '';
	    }
	    if (masked.length === 2) {
	      masked += ['0', '1', '2', '3', '4', '5'].includes(time[2]) ? ':' + time[2] : '';
	    }
	    if (masked.length === 4) {
	      masked += ['1', '2', '3', '4', '5', '6', '7', '8', '9', '0'].includes(time[3]) ? time[3] : '';
	    }
	
	    return props.justTime ? masked : masked + ' ' + period;
	  }
	};
	
	var maskValue = exports.maskValue = function maskValue(value, mask) {
	  for (var i = 0; i < mask.length; i++) {
	    value = MASK[mask[i].fn](value, mask[i].props);
	  }
	  return value;
	};

/***/ },
/* 46 */
/***/ function(module, exports) {

	var hasOwnProperty = {}.hasOwnProperty;
	module.exports = function (it, key) {
	  return hasOwnProperty.call(it, key);
	};


/***/ },
/* 47 */
/***/ function(module, exports, __webpack_require__) {

	var pIE = __webpack_require__(133);
	var createDesc = __webpack_require__(92);
	var toIObject = __webpack_require__(49);
	var toPrimitive = __webpack_require__(64);
	var has = __webpack_require__(46);
	var IE8_DOM_DEFINE = __webpack_require__(361);
	var gOPD = Object.getOwnPropertyDescriptor;
	
	exports.f = __webpack_require__(28) ? gOPD : function getOwnPropertyDescriptor(O, P) {
	  O = toIObject(O);
	  P = toPrimitive(P, true);
	  if (IE8_DOM_DEFINE) try {
	    return gOPD(O, P);
	  } catch (e) { /* empty */ }
	  if (has(O, P)) return createDesc(!pIE.f.call(O, P), O[P]);
	};


/***/ },
/* 48 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.2.9 / 15.2.3.2 Object.getPrototypeOf(O)
	var has = __webpack_require__(46);
	var toObject = __webpack_require__(34);
	var IE_PROTO = __webpack_require__(251)('IE_PROTO');
	var ObjectProto = Object.prototype;
	
	module.exports = Object.getPrototypeOf || function (O) {
	  O = toObject(O);
	  if (has(O, IE_PROTO)) return O[IE_PROTO];
	  if (typeof O.constructor == 'function' && O instanceof O.constructor) {
	    return O.constructor.prototype;
	  } return O instanceof Object ? ObjectProto : null;
	};


/***/ },
/* 49 */
/***/ function(module, exports, __webpack_require__) {

	// to indexed object, toObject with fallback for non-array-like ES3 strings
	var IObject = __webpack_require__(132);
	var defined = __webpack_require__(62);
	module.exports = function (it) {
	  return IObject(defined(it));
	};


/***/ },
/* 50 */
/***/ function(module, exports) {

	'use strict'
	
	module.exports = whitespace
	
	var fromCode = String.fromCharCode
	var re = /\s/
	
	// Check if the given character code, or the character code at the first
	// character, is a whitespace character.
	function whitespace(character) {
	  return re.test(
	    typeof character === 'number' ? fromCode(character) : character.charAt(0)
	  )
	}


/***/ },
/* 51 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _createIconComponent = _interopRequireDefault(__webpack_require__(5));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	var IconCrossHeavy = (0, _createIconComponent["default"])({
	  content: _react["default"].createElement("g", null, _react["default"].createElement("path", {
	    d: "M39.95 35l23.16-23.16a3.5 3.5 0 0 0-4.95-5L35 30.05 11.84 6.89a3.5 3.5 0 0 0-4.95 5L30.05 35 6.89 58.16a3.5 3.5 0 1 0 4.95 5L35 39.95l23.16 23.16a3.5 3.5 0 1 0 4.95-5z"
	  })),
	  height: undefined,
	  width: undefined
	});
	IconCrossHeavy.displayName = 'IconCrossHeavy';
	var _default = IconCrossHeavy;
	exports["default"] = _default;

/***/ },
/* 52 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var isBefore = __webpack_require__(605);
	var isAfter = __webpack_require__(604);
	var addMonths = __webpack_require__(602);
	var isToday = __webpack_require__(607);
	
	var conditionIsSatisfied = function conditionIsSatisfied(condition, parent) {
		switch (condition.parentType) {
			case 'text':
			case 'textArea':
				if (getEqualityByComparator((parent.value !== undefined && typeof parent.value === "string" ? parent.value : '').trim().length, 0, condition.comparator)) return false;
				break;
			case 'checkbox':
				var parentValue = parent.value === true || parent.value === 'true' ? true : false;
				var conditionValue = condition.value === true || condition.value === 'true' ? true : false;
				if (getEqualityByComparator(parentValue, conditionValue, condition.comparator)) return false;
				break;
			case 'select':
			case 'radio':
			case 'dependentSelect':
			case 'dependentRadio':
			case 'serverSelect':
			case 'serverRadio':
			case 'date':
				if (getEqualityByComparator(parent.value, condition.value, condition.comparator)) return false;
				break;
			case 'EntityNameSearch':
				switch (condition.subFieldId) {
					case 'reservedYN':
						if (!parent.hideReserved) {
							if (getEqualityByComparator(parent.value[condition.subFieldId], condition.value, condition.comparator)) return false;
						} else return false;
						break;
					case 'additionalYN':
						if ((parent.value.reservedYN === 'N' || parent.hideReserved) && !parent.hideAdditionalName) {
							if (getEqualityByComparator(parent.value[condition.subFieldId], condition.value, condition.comparator)) return false;
						} else return false;
						break;
					case 'consentYN':
						if ((parent.value.reservedYN === 'N' || parent.hideReserved) && (parent.value.additionalYN === 'N' || parent.hideAdditionalName) && !parent.hideConsent) {
							if (getEqualityByComparator(parent.value[condition.subFieldId], condition.value, condition.comparator)) return false;
						} else return false;
						break;
					case 'requireSupportingDocument':
						if (getEqualityByComparator(parent.requireSupportingDocument, condition.value, condition.comparator)) return false;
						break;
				}
				break;
			case 'NameQualifiedOrg':
				if (getEqualityByComparator(((parent.value || {}).ORG_TYPE || "").toString(), condition.value.toString(), condition.comparator)) return false;
				break;
			case 'UploadAndSubmit':
				if (getEqualityByComparator((parent.value || {}).method, condition.value, condition.comparator)) return false;
				break;
			case 'registeredAgentSearch':
				if (getEqualityByComparator(((parent.value || {}).TYPE_ID || "").toString(), condition.value.toString(), condition.comparator)) return false;
				break;
			case 'addressBlock':
				if (getEqualityByComparator((parent.value || {}).STATE || "", condition.value, condition.comparator)) return false;
				break;
		}
		return true;
	};
	
	var getEqualityByComparator = function getEqualityByComparator(left, right) {
		var comparator = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '=';
	
		switch (comparator) {
			case '!=':
				return left === right;
			case '<p':
				if (!left) return true;
	
				var date = new Date(left);
	
				if (isToday(date)) return false;
				if (isAfter(new Date(), date)) return true;
	
				switch (right) {
					case '6m':
					default:
						return !isBefore(date, addMonths(new Date(), 6));
				}
			case '=':
			default:
				return left !== right;
		}
	};
	
	var resolveFieldConditions = function resolveFieldConditions(conditions, fields) {
		var operator = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'and';
	
		if (conditions) {
			for (var i = 0; i < conditions.length; i++) {
				var condition = conditions[i];
				var parent = fields[condition.parentId];
				if (condition.parentId !== '' && parent) {
					if (operator === 'or') {
						var parentConditions = fields[condition.parentId].conditions;
						var parentConditionsSatisfied = parentConditions ? resolveFieldConditions(parentConditions, fields, fields[condition.parentId].conditionsOperator) : true;
						var satisfied = conditionIsSatisfied(condition, parent);
						if (satisfied && parentConditionsSatisfied) return true;
					} else {
						var _parentConditions = fields[condition.parentId].conditions;
						var _parentConditionsSatisfied = _parentConditions ? resolveFieldConditions(_parentConditions, fields, fields[condition.parentId].conditionsOperator) : true;
						if (!_parentConditionsSatisfied) return false;
						if (!conditionIsSatisfied(condition, parent)) return false;
					}
				}
			}
			if (operator === 'and') {
				return true;
			} else {
				return false;
			}
		}
		return true;
	};
	
	exports.resolveFieldConditions = resolveFieldConditions;


/***/ },
/* 53 */
/***/ function(module, exports) {

	var toString = {}.toString;
	
	module.exports = function (it) {
	  return toString.call(it).slice(8, -1);
	};


/***/ },
/* 54 */
/***/ function(module, exports) {

	var core = module.exports = { version: '2.6.11' };
	if (typeof __e == 'number') __e = core; // eslint-disable-line no-undef


/***/ },
/* 55 */
/***/ function(module, exports, __webpack_require__) {

	// optional / simple context binding
	var aFunction = __webpack_require__(39);
	module.exports = function (fn, that, length) {
	  aFunction(fn);
	  if (that === undefined) return fn;
	  switch (length) {
	    case 1: return function (a) {
	      return fn.call(that, a);
	    };
	    case 2: return function (a, b) {
	      return fn.call(that, a, b);
	    };
	    case 3: return function (a, b, c) {
	      return fn.call(that, a, b, c);
	    };
	  }
	  return function (/* ...args */) {
	    return fn.apply(that, arguments);
	  };
	};


/***/ },
/* 56 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var fails = __webpack_require__(21);
	
	module.exports = function (method, arg) {
	  return !!method && fails(function () {
	    // eslint-disable-next-line no-useless-call
	    arg ? method.call(null, function () { /* empty */ }, 1) : method.call(null);
	  });
	};


/***/ },
/* 57 */
/***/ function(module, exports) {

	// 7.1.4 ToInteger
	var ceil = Math.ceil;
	var floor = Math.floor;
	module.exports = function (it) {
	  return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
	};


/***/ },
/* 58 */
/***/ function(module, exports) {

	if (typeof Object.create === 'function') {
	  // implementation from standard node.js 'util' module
	  module.exports = function inherits(ctor, superCtor) {
	    if (superCtor) {
	      ctor.super_ = superCtor
	      ctor.prototype = Object.create(superCtor.prototype, {
	        constructor: {
	          value: ctor,
	          enumerable: false,
	          writable: true,
	          configurable: true
	        }
	      })
	    }
	  };
	} else {
	  // old school shim for old browsers
	  module.exports = function inherits(ctor, superCtor) {
	    if (superCtor) {
	      ctor.super_ = superCtor
	      var TempCtor = function () {}
	      TempCtor.prototype = superCtor.prototype
	      ctor.prototype = new TempCtor()
	      ctor.prototype.constructor = ctor
	    }
	  }
	}


/***/ },
/* 59 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {'use strict';
	
	var stub = __webpack_require__(1180);
	var tracking = __webpack_require__(1181);
	var ls = 'localStorage' in global && global.localStorage ? global.localStorage : stub;
	
	function accessor (key, value) {
	  if (arguments.length === 1) {
	    return get(key);
	  }
	  return set(key, value);
	}
	
	function get (key) {
	  return JSON.parse(ls.getItem(key));
	}
	
	function set (key, value) {
	  try {
	    ls.setItem(key, JSON.stringify(value));
	    return true;
	  } catch (e) {
	    return false;
	  }
	}
	
	function remove (key) {
	  return ls.removeItem(key);
	}
	
	function clear () {
	  return ls.clear();
	}
	
	accessor.set = set;
	accessor.get = get;
	accessor.remove = remove;
	accessor.clear = clear;
	accessor.on = tracking.on;
	accessor.off = tracking.off;
	
	module.exports = accessor;
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 60 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _createIconComponent = _interopRequireDefault(__webpack_require__(5));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	var IconTrash = (0, _createIconComponent["default"])({
	  content: _react["default"].createElement("g", null, _react["default"].createElement("path", {
	    d: "M47.75 57.3a1.6 1.6 0 0 0 1.6-1.6v-28a1.6 1.6 0 1 0-3.2 0v28a1.6 1.6 0 0 0 1.6 1.6zM39.25 57.3a1.6 1.6 0 0 0 1.6-1.6v-28a1.6 1.6 0 1 0-3.2 0v28a1.6 1.6 0 0 0 1.6 1.6zM30.75 57.3a1.6 1.6 0 0 0 1.6-1.6v-28a1.6 1.6 0 1 0-3.2 0v28a1.6 1.6 0 0 0 1.6 1.6zM22.25 57.3a1.6 1.6 0 0 0 1.6-1.6v-28a1.6 1.6 0 1 0-3.2 0v28a1.6 1.6 0 0 0 1.6 1.6z"
	  }), _react["default"].createElement("path", {
	    d: "M54.06 11.85h-9.54V10.4a4.77 4.77 0 0 0-4.77-4.77h-9.5a4.77 4.77 0 0 0-4.77 4.77v1.44h-9.54a6.54 6.54 0 0 0-6.54 6.54v3A1.6 1.6 0 0 0 11 23h2.65v34.7a5.94 5.94 0 0 0 5.93 5.93h30.84a5.94 5.94 0 0 0 5.93-5.93V23H59a1.6 1.6 0 0 0 1.6-1.6v-3a6.54 6.54 0 0 0-6.54-6.55zm-.91 45.85a2.74 2.74 0 0 1-2.73 2.73H19.58a2.74 2.74 0 0 1-2.73-2.73V23h36.3zM12.6 18.38A3.34 3.34 0 0 1 15.94 15h38.12a3.34 3.34 0 0 1 3.34 3.34v1.38H12.6zm16.08-8a1.57 1.57 0 0 1 1.57-1.57h9.5a1.57 1.57 0 0 1 1.57 1.57v1.44H28.68z"
	  })),
	  height: undefined,
	  width: undefined
	});
	IconTrash.displayName = 'IconTrash';
	var _default = IconTrash;
	exports["default"] = _default;

/***/ },
/* 61 */
/***/ function(module, exports, __webpack_require__) {

	// 0 -> Array#forEach
	// 1 -> Array#map
	// 2 -> Array#filter
	// 3 -> Array#some
	// 4 -> Array#every
	// 5 -> Array#find
	// 6 -> Array#findIndex
	var ctx = __webpack_require__(55);
	var IObject = __webpack_require__(132);
	var toObject = __webpack_require__(34);
	var toLength = __webpack_require__(27);
	var asc = __webpack_require__(235);
	module.exports = function (TYPE, $create) {
	  var IS_MAP = TYPE == 1;
	  var IS_FILTER = TYPE == 2;
	  var IS_SOME = TYPE == 3;
	  var IS_EVERY = TYPE == 4;
	  var IS_FIND_INDEX = TYPE == 6;
	  var NO_HOLES = TYPE == 5 || IS_FIND_INDEX;
	  var create = $create || asc;
	  return function ($this, callbackfn, that) {
	    var O = toObject($this);
	    var self = IObject(O);
	    var f = ctx(callbackfn, that, 3);
	    var length = toLength(self.length);
	    var index = 0;
	    var result = IS_MAP ? create($this, length) : IS_FILTER ? create($this, 0) : undefined;
	    var val, res;
	    for (;length > index; index++) if (NO_HOLES || index in self) {
	      val = self[index];
	      res = f(val, index, O);
	      if (TYPE) {
	        if (IS_MAP) result[index] = res;   // map
	        else if (res) switch (TYPE) {
	          case 3: return true;             // some
	          case 5: return val;              // find
	          case 6: return index;            // findIndex
	          case 2: result.push(val);        // filter
	        } else if (IS_EVERY) return false; // every
	      }
	    }
	    return IS_FIND_INDEX ? -1 : IS_SOME || IS_EVERY ? IS_EVERY : result;
	  };
	};


/***/ },
/* 62 */
/***/ function(module, exports) {

	// 7.2.1 RequireObjectCoercible(argument)
	module.exports = function (it) {
	  if (it == undefined) throw TypeError("Can't call method on  " + it);
	  return it;
	};


/***/ },
/* 63 */
/***/ function(module, exports, __webpack_require__) {

	// most Object methods by ES6 should accept primitives
	var $export = __webpack_require__(4);
	var core = __webpack_require__(54);
	var fails = __webpack_require__(21);
	module.exports = function (KEY, exec) {
	  var fn = (core.Object || {})[KEY] || Object[KEY];
	  var exp = {};
	  exp[KEY] = exec(fn);
	  $export($export.S + $export.F * fails(function () { fn(1); }), 'Object', exp);
	};


/***/ },
/* 64 */
/***/ function(module, exports, __webpack_require__) {

	// 7.1.1 ToPrimitive(input [, PreferredType])
	var isObject = __webpack_require__(23);
	// instead of the ES6 spec version, we didn't implement @@toPrimitive case
	// and the second argument - flag - preferred type is a string
	module.exports = function (it, S) {
	  if (!isObject(it)) return it;
	  var fn, val;
	  if (S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
	  if (typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it))) return val;
	  if (!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
	  throw TypeError("Can't convert object to primitive value");
	};


/***/ },
/* 65 */
/***/ function(module, exports, __webpack_require__) {

	var objectKeys = __webpack_require__(504);
	var isArguments = __webpack_require__(1170);
	var is = __webpack_require__(1277);
	var isRegex = __webpack_require__(1175);
	var flags = __webpack_require__(1367);
	var isDate = __webpack_require__(1172);
	
	var getTime = Date.prototype.getTime;
	
	function deepEqual(actual, expected, options) {
	  var opts = options || {};
	
	  // 7.1. All identical values are equivalent, as determined by ===.
	  if (opts.strict ? is(actual, expected) : actual === expected) {
	    return true;
	  }
	
	  // 7.3. Other pairs that do not both pass typeof value == 'object', equivalence is determined by ==.
	  if (!actual || !expected || (typeof actual !== 'object' && typeof expected !== 'object')) {
	    return opts.strict ? is(actual, expected) : actual == expected;
	  }
	
	  /*
	   * 7.4. For all other Object pairs, including Array objects, equivalence is
	   * determined by having the same number of owned properties (as verified
	   * with Object.prototype.hasOwnProperty.call), the same set of keys
	   * (although not necessarily the same order), equivalent values for every
	   * corresponding key, and an identical 'prototype' property. Note: this
	   * accounts for both named and indexed properties on Arrays.
	   */
	  // eslint-disable-next-line no-use-before-define
	  return objEquiv(actual, expected, opts);
	}
	
	function isUndefinedOrNull(value) {
	  return value === null || value === undefined;
	}
	
	function isBuffer(x) {
	  if (!x || typeof x !== 'object' || typeof x.length !== 'number') {
	    return false;
	  }
	  if (typeof x.copy !== 'function' || typeof x.slice !== 'function') {
	    return false;
	  }
	  if (x.length > 0 && typeof x[0] !== 'number') {
	    return false;
	  }
	  return true;
	}
	
	function objEquiv(a, b, opts) {
	  /* eslint max-statements: [2, 50] */
	  var i, key;
	  if (typeof a !== typeof b) { return false; }
	  if (isUndefinedOrNull(a) || isUndefinedOrNull(b)) { return false; }
	
	  // an identical 'prototype' property.
	  if (a.prototype !== b.prototype) { return false; }
	
	  if (isArguments(a) !== isArguments(b)) { return false; }
	
	  var aIsRegex = isRegex(a);
	  var bIsRegex = isRegex(b);
	  if (aIsRegex !== bIsRegex) { return false; }
	  if (aIsRegex || bIsRegex) {
	    return a.source === b.source && flags(a) === flags(b);
	  }
	
	  if (isDate(a) && isDate(b)) {
	    return getTime.call(a) === getTime.call(b);
	  }
	
	  var aIsBuffer = isBuffer(a);
	  var bIsBuffer = isBuffer(b);
	  if (aIsBuffer !== bIsBuffer) { return false; }
	  if (aIsBuffer || bIsBuffer) { // && would work too, because both are true or both false here
	    if (a.length !== b.length) { return false; }
	    for (i = 0; i < a.length; i++) {
	      if (a[i] !== b[i]) { return false; }
	    }
	    return true;
	  }
	
	  if (typeof a !== typeof b) { return false; }
	
	  try {
	    var ka = objectKeys(a);
	    var kb = objectKeys(b);
	  } catch (e) { // happens when one is a string literal and the other isn't
	    return false;
	  }
	  // having the same number of owned properties (keys incorporates hasOwnProperty)
	  if (ka.length !== kb.length) { return false; }
	
	  // the same set of keys (although not necessarily the same order),
	  ka.sort();
	  kb.sort();
	  // ~~~cheap key test
	  for (i = ka.length - 1; i >= 0; i--) {
	    if (ka[i] != kb[i]) { return false; }
	  }
	  // equivalent values for every corresponding key, and ~~~possibly expensive deep test
	  for (i = ka.length - 1; i >= 0; i--) {
	    key = ka[i];
	    if (!deepEqual(a[key], b[key], opts)) { return false; }
	  }
	
	  return true;
	}
	
	module.exports = deepEqual;


/***/ },
/* 66 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.skipAuthCheck = exports.setAuthTimeout = exports.attachEventCheck = exports.detachEventCheck = exports.extendUserSession = exports.setExpiration = exports.loginAppUser = exports.clearLocalUser = exports.logoutEpassUser = exports.logoutWebUser = exports.clearUser = exports.unregisterAuthPoll = exports.registerAuthPoll = exports.getAuthState = exports.setAuthAttribute = exports.spreadAuthAttributes = exports.getUserGroup = exports.storeAndDispatchLoginResponse = exports.loginWebUser = undefined;
	
	var _requests = __webpack_require__(6);
	
	var api = _interopRequireWildcard(_requests);
	
	var _store = __webpack_require__(18);
	
	var _store2 = _interopRequireDefault(_store);
	
	var _localStorage = __webpack_require__(59);
	
	var _localStorage2 = _interopRequireDefault(_localStorage);
	
	var _shortid = __webpack_require__(22);
	
	var _shortid2 = _interopRequireDefault(_shortid);
	
	var _actions = __webpack_require__(29);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	////////////////////////
	///////////////////////////////////////////////////////
	///////////////////////////////////////////
	
	////////////////////////////////////////////////////////////////
	////////////////////////////////////////////////////
	//////////
	
	var loginWebUser = exports.loginWebUser = function loginWebUser(credentials, callback) {
	  return function (dispatch) {
	    api.LOGIN_WEB_USER(credentials, function (response) {
	      storeAndDispatchLoginResponse(response, dispatch);
	      dispatch((0, _actions.getAndSetCartQuantity)());
	      // dispatch(registerAuthPoll())
	      callback(true);
	    }, function (err) {
	      // if(err.code === 'auth/invalidLogin')
	      callback(false, err.message || 'The username or password you provided was incorrect. Please try again.');
	    });
	  };
	};
	
	var storeAndDispatchLoginResponse = exports.storeAndDispatchLoginResponse = function storeAndDispatchLoginResponse(response, dispatch) {
	  var webUser = response.Item1;
	  var webUserAuthentication = response.Item2;
	  // if(process.env.NODE_ENV !== 'test'){console.log(response)}
	  localStorage.setItem('WEB_USER', JSON.stringify(webUser));
	  localStorage.setItem('WEB_USER_AUTHENTICATION', JSON.stringify(webUserAuthentication));
	  localStorage.setItem('LAST_USERS_GROUP', JSON.stringify(getUserGroup[webUser.USER_TYPE_ID]));
	  var loginObj = {
	    initialAuthCheck: false,
	    FIRST_NAME: webUser.FIRST_NAME,
	    MIDDLE_NAME: webUser.MIDDLE_NAME,
	    LAST_NAME: webUser.LAST_NAME,
	    ORG_NAME: webUser.ORG_NAME,
	    BUSINESS_NAME: webUser.BUSINESS_NAME,
	    WEB_USER_ID: webUser.WEB_USER_ID,
	    USERNAME: webUser.USERNAME,
	    EMAIL: webUser.EMAIL,
	    ADDR1: webUser.ADDR1,
	    ADDR2: webUser.ADDR2,
	    ADDR3: webUser.ADDR3,
	    CITY: webUser.CITY,
	    STATE: webUser.STATE,
	    POSTAL_CODE: webUser.POSTAL_CODE,
	    COUNTRY: webUser.COUNTRY,
	    USER_GROUP: getUserGroup[webUser.USER_TYPE_ID],
	    isFrequentPayor: webUser.IS_FREQUENT_PAYOR_YN,
	    loggedIn: true,
	    trigger: _shortid2.default.generate(),
	    PHONE: webUser.PHONE
	  };
	  dispatch(spreadAuthAttributes(loginObj));
	  var cachedCategory = getCategoryCache(webUser.WEB_USER_ID);
	  if (cachedCategory) {
	    dispatch({ type: 'SET_CURRENT_CATEGORY', category: cachedCategory });
	  }
	  dispatch((0, _actions.getAndSetCartQuantity)());
	  _localStorage2.default.set('EVENT_LOGIN', loginObj);
	};
	
	var getCategoryCache = function getCategoryCache(WEB_USER_ID) {
	  var userCache = _localStorage2.default.get('USER_CACHE');
	  if (userCache) {
	    return userCache[WEB_USER_ID];
	  }
	};
	
	var getUserGroup = exports.getUserGroup = {
	  0: 'PUBLIC',
	  1: 'WEB',
	  2: 'ADMIN',
	  3: 'ADMIN_WEB',
	  4: 'ADMIN_RO'
	};
	
	var spreadAuthAttributes = exports.spreadAuthAttributes = function spreadAuthAttributes(payload) {
	  return {
	    type: 'SPREAD_AUTH_ATTRIBUTES',
	    payload: payload
	  };
	};
	
	var setAuthAttribute = exports.setAuthAttribute = function setAuthAttribute(attribute, value) {
	  return {
	    type: 'SET_AUTH_ATTRIBUTE',
	    attribute: attribute,
	    value: value
	  };
	};
	
	var getAuthState = exports.getAuthState = function getAuthState(callback) {
	  return function (dispatch, getState) {
	    dispatch(setAuthAttribute('checkingAuthState', true));
	    var WEB_USER = localStorage.getItem('WEB_USER');
	    var webUser = WEB_USER && WEB_USER !== 'undefined' ? JSON.parse(WEB_USER) : {};
	    api.GET_AUTH_STATE(function (response) {
	      if (response !== false && response !== 'false') {
	        if (callback) {
	          callback(true, dispatch);
	        }
	        var authObj = Object.assign({}, response.VALUE, {
	          checkingAuthState: false,
	          loggedIn: true,
	          FIRST_NAME: webUser.FIRST_NAME,
	          MIDDLE_NAME: webUser.MIDDLE_NAME,
	          LAST_NAME: webUser.LAST_NAME,
	          BUSINESS_NAME: webUser.BUSINESS_NAME,
	          WEB_USER_ID: webUser.WEB_USER_ID,
	          USER_GROUP: getUserGroup[webUser.USER_TYPE_ID],
	          USERNAME: webUser.USERNAME,
	          PHONE: webUser.PHONE,
	          isFrequentPayor: webUser.IS_FREQUENT_PAYOR_YN,
	          initialAuthCheck: false,
	          trigger: _shortid2.default.generate()
	        });
	        dispatch(spreadAuthAttributes(authObj));
	        var location = getState().router.location;
	        if (location.pathname === '/auth' || location.pathname === '/admin') {
	          var from = location.search ? new RegExp(/from=(.*?)(&|$)/g).exec(location.search) || [] : '/';
	          var search = location.search ? new RegExp(/search=(.*?)$/g).exec(location.search) || [] : '/';
	          _store.history.replace('' + (from[1] || '') + (search[1] || ''));
	        }
	        // dispatch(registerAuthPoll())
	        _localStorage2.default.set('EVENT_LOGIN', authObj);
	        if (true) {
	          dispatch((0, _actions.getAndSetCartQuantity)());
	        }
	      } else {
	        if (callback) {
	          callback(false, dispatch);
	        }
	        dispatch(spreadAuthAttributes({
	          checkingAuthState: false,
	          initialAuthCheck: false,
	          loggedIn: false
	        }));
	        dispatch(clearUser());
	        // unregisterAuthPoll()
	      }
	    }, function (err) {
	      dispatch(spreadAuthAttributes({
	        checkingAuthState: false,
	        initialAuthCheck: false,
	        loggedIn: false
	      }));
	      dispatch(clearUser());
	    });
	  };
	};
	
	var registerAuthPoll = exports.registerAuthPoll = function registerAuthPoll() {
	  return function (dispatch) {
	    if (!window.AUTH_POLL) {
	      window.AUTH_POLL = setInterval(function () {
	        dispatch(getAuthState());
	      }, 60000);
	    }
	  };
	};
	
	var unregisterAuthPoll = exports.unregisterAuthPoll = function unregisterAuthPoll() {
	  clearInterval(window.AUTH_POLL);
	  delete window.AUTH_POLL;
	};
	
	var clearUser = exports.clearUser = function clearUser() {
	  return {
	    type: 'CLEAR_USER'
	  };
	};
	
	var logoutWebUser = exports.logoutWebUser = function logoutWebUser(broadcast) {
	  return function (dispatch) {
	    if (true) {
	      _store.history.push('/');
	    }
	    api.LOGOUT_WEB_USER(function (response) {
	      if (response === true) {
	        clearLocalUser(broadcast);
	        detachEventCheck();
	        _localStorage2.default.set('EVENT_LOGOUT', _shortid2.default.generate());
	        if (false) {
	          logoutEpassUser();
	        }
	        // unregisterAuthPoll()
	      }
	    });
	  };
	};
	
	var logoutEpassUser = exports.logoutEpassUser = function logoutEpassUser() {
	  window.location.href = api.BASE_URL + '/api/Logout.epass';
	};
	
	var clearLocalUser = exports.clearLocalUser = function clearLocalUser(broadcast) {
	  window.ALLOW_BYPASS_WIZARD_PROMPT = true;
	  localStorage.removeItem('WEB_USER');
	  localStorage.removeItem('WEB_USER_AUTHENTICATION');
	  localStorage.setItem('AUTH_TIMER', 0);
	//////////////////////////
	///////////////////////////////////
	//////////////////////////////////////////////////////////////////
	/////////////////////////
	/////////////////////////////////////////////////
	/////////////////////////////
	/////
	///
	////////////
	  if (true) {
	    var _userIsLoggedIn = _store2.default.getState().auth.loggedIn;
	    if (_userIsLoggedIn) {
	      localStorage.removeItem('ACTIVE_DIRECTORY_RETURN_URL');
	      _store.history.replace("/");
	    }
	  }
	  clearLocalUserState();
	  if (broadcast) {
	    _localStorage2.default.set('EVENT_LOGOUT', _shortid2.default.generate());
	  }
	  window.ALLOW_BYPASS_WIZARD_PROMPT = false;
	};
	
	var clearLocalUserState = function clearLocalUserState() {
	  clearTimeout(window.AUTH_TIMER);
	  window.AUTH_TIMER = null;
	  clearTimeout(window.EVENT_CHECK_TIMER);
	  window.EVENT_CHECK_TIMER = null;
	  _store2.default.dispatch(clearUser());
	  _store2.default.dispatch((0, _actions.resetFullAppState)());
	};
	
	var loginAppUser = exports.loginAppUser = function loginAppUser(credentials, callback) {
	  return function (dispatch) {
	    api.LOGIN_APP_USER(credentials, function (response) {
	      storeAndDispatchLoginResponse(response, dispatch);
	      dispatch((0, _actions.getAndSetCartQuantity)());
	      callback(true);
	    }, function (err) {
	      callback(false, err.message || 'Invalid Login');
	    });
	  };
	};
	
	var setExpiration = exports.setExpiration = function setExpiration(expires) {
	  return {
	    type: 'SET_EXPIRATION',
	    expires: expires
	  };
	};
	
	var extendUserSession = exports.extendUserSession = function extendUserSession() {
	  return function (dispatch) {
	    dispatch(setExpiration(null));
	////////////////////////////
	///////////////////////////////////////////////////////////////////////////
	//////////////////////////////////////////
	/////////////////////////////////////////////////////////////////
	///////
	//////////////
	    detachEventCheck();
	////////////////////////////
	    api.EXTEND_WEB_USER_SESSION(null, function () {});
	//////////////
	  };
	};
	
	var handleAuthTimeout = function handleAuthTimeout() {
	  _store2.default.dispatch(setExpiration(30));
	};
	
	var handleUserAction = function handleUserAction() {
	  // console.log("Handled user action")
	  detachEventCheck();
	  _store2.default.dispatch(extendUserSession());
	};
	
	var detachEventCheck = exports.detachEventCheck = function detachEventCheck() {
	  document.removeEventListener('click', handleUserAction);
	  document.removeEventListener('keydown', handleUserAction);
	  document.removeEventListener('mousemove', handleUserAction);
	};
	
	var attachEventCheck = exports.attachEventCheck = function attachEventCheck() {
	  // console.log("Started listening");
	  document.addEventListener('click', handleUserAction);
	  document.addEventListener('keydown', handleUserAction);
	  document.addEventListener('mousemove', handleUserAction);
	};
	
	var setAuthTimers = function setAuthTimers(paddedTimeout, eventCheckTimeout) {
	  _store2.default.dispatch(setExpiration(null));
	  clearTimeout(window.AUTH_TIMER);
	  clearTimeout(window.EVENT_CHECK_TIMER);
	  window.AUTH_TIMER = window.setTimeout(handleAuthTimeout, paddedTimeout);
	  if (eventCheckTimeout > 0) {
	    window.EVENT_CHECK_TIMER = window.setTimeout(attachEventCheck, eventCheckTimeout);
	  }
	  localStorage.setItem('AUTH_TIMEOUT', paddedTimeout);
	};
	
	var setAuthTimeout = exports.setAuthTimeout = function setAuthTimeout(timeout) {
	  var paddedTimeout = timeout - 60000;
	  var eventCheckTimeout = paddedTimeout - 300000;
	  // console.log("Timeout got set", paddedTimeout, eventCheckTimeout);
	  if (paddedTimeout > 0) {
	    setAuthTimers(paddedTimeout, eventCheckTimeout);
	    _localStorage2.default.set('EVENT_SET_TIMEOUT', { paddedTimeout: paddedTimeout, eventCheckTimeout: eventCheckTimeout, trigger: _shortid2.default.generate() });
	  }
	};
	
	_localStorage2.default.on('EVENT_SET_TIMEOUT', function (value) {
	  // console.log(Date.now(), "Synced timeout");
	  detachEventCheck();
	  setAuthTimers(value.paddedTimeout, value.eventCheckTimeout);
	});
	
	_localStorage2.default.on('EVENT_LOGIN', function (value) {
	  // console.log(Date.now(), "Synced login", value);
	  _store2.default.dispatch(spreadAuthAttributes(value));
	});
	
	_localStorage2.default.on('EVENT_LOGOUT', function () {
	  // console.log(Date.now(), "Synced logout");
	  detachEventCheck();
	  clearLocalUserState();
	});
	
	var skipAuthCheck = exports.skipAuthCheck = function skipAuthCheck() {
	  return function (dispatch) {
	    dispatch(spreadAuthAttributes({
	      initialAuthCheck: false
	    }));
	  };
	};

/***/ },
/* 67 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.PaymentButton = exports.Checkout = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(7);
	
	var _Loaders = __webpack_require__(16);
	
	var _requests = __webpack_require__(6);
	
	var _actions = __webpack_require__(29);
	
	var _utilities = __webpack_require__(8);
	
	var _lockSolid = __webpack_require__(336);
	
	var _lockSolid2 = _interopRequireDefault(_lockSolid);
	
	var _crossHeavy = __webpack_require__(51);
	
	var _crossHeavy2 = _interopRequireDefault(_crossHeavy);
	
	var _creditCardSolid = __webpack_require__(158);
	
	var _creditCardSolid2 = _interopRequireDefault(_creditCardSolid);
	
	var _bankSolid = __webpack_require__(220);
	
	var _bankSolid2 = _interopRequireDefault(_bankSolid);
	
	var _plusHeavy = __webpack_require__(128);
	
	var _plusHeavy2 = _interopRequireDefault(_plusHeavy);
	
	var _trash = __webpack_require__(60);
	
	var _trash2 = _interopRequireDefault(_trash);
	
	var _caretLeft = __webpack_require__(222);
	
	var _caretLeft2 = _interopRequireDefault(_caretLeft);
	
	var _store = __webpack_require__(18);
	
	var _Form = __webpack_require__(14);
	
	var _Modal = __webpack_require__(13);
	
	var _Portal = __webpack_require__(12);
	
	var _Portal2 = _interopRequireDefault(_Portal);
	
	var _FrequentPayor = __webpack_require__(457);
	
	var _Elavon = __webpack_require__(1091);
	
	var _NativeCheckout = __webpack_require__(1061);
	
	var _NativeCheckout2 = _interopRequireDefault(_NativeCheckout);
	
	__webpack_require__(1434);
	
	var _Markdown = __webpack_require__(24);
	
	var _Markdown2 = _interopRequireDefault(_Markdown);
	
	var _requests2 = __webpack_require__(6);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	// import { } from 'react-router-dom';
	// import paypal from '../../common/img/paypal.svg';
	
	
	var PAYMENT_METHODS = ([{"type":"bypass"},{"type":"iTransact"}]);
	var PAYMENT_BYPASS_SIMULATES_PAYPAL_CALLBACK = ({"NODE_ENV":"production","BUILD_DATE":"2025-08-27T15:15:31.687Z","BUILD_NUMBER":"Not Provided","GIT_VERSION":"v1.3.0-381-ga81e29b08","GIT_COMMIT_HASH":"a81e29b085c9268ffd96c78eb734365802722741","GIT_BRANCH":"beta","PUBLIC_URL":"","STATE_ABBR":"MT","STATE_NAME":"Montana","STATE_ORG_TITLE":"Secretary of State","LOGIN_HEADER_IMG_PATH":"","HOME_IMG_FILENAME":"montana.jpg","FAVICON_FILE_NAME":"favicon.ico","ALLOW_E_SIGN_ON_CORRECTIONS":true,"THIRD_PARTY_SIGNING_ALLOWED":false,"MY_ACCOUNT_SAVE_AND_CLOSE_BUTTON":true,"IE_DEPRECATED_MESSAGE":"Internet Explorer is not supported. Please select a supported browser below to access this website.","ADDITIONAL_ROUTES":{"dataRequests":true,"farmBill":true,"apostille":true,"externalHelp":"https://sosmt.gov/business/help-center/","systemAdministration":[{"title":"Saved Payments","parameter":"saved-payments","componentName":"SavedPayments"}]},"SUBROUTES":[{"label":"Business","component":"Business","parameter":"business","myWorkQueueSearch":false,"sourceTypeId":54,"searchMustHaveOneOf":["FILING_TYPE_ID","STATUS_ID","STATE","search"],"serverWebSearchDescription":true,"serverWorkQueueDescription":true,"serverMyRecordsDescription":true,"searchPlaceholder":"Search by name or filing number (X########)","allowEmptySearchTerm":true,"requestCertificateAlternateLabel":"Request Information","fileAmendmentButtonLabel":"Filing Actions","advancedSearchParameters":[{"type":"radio","name":"QUERY_TYPE_ID","defaultValue":1010,"options":[{"value":1010,"label":"Starts with"},{"value":1011,"label":"Contains"},{"value":1012,"label":" Word Contains"}]},{"type":"serverSelect","name":"FILING_TYPE_ID","optionsSrc":"FILING_TYPES","label":"Entity Type","placeholder":"All","defaultValue":"0"},{"type":"serverSelect","name":"FILING_SUBTYPE_ID","optionsSrc":"FILING_SUBTYPES","label":"Entity Subtype","overrideSubOptionsSrcFromParameterName":"FILING_TYPE_ID","placeholder":"All","defaultValue":"0"},{"type":"serverSelect","name":"STATUS_ID","optionsSrc":"FILING_STATUS_WITHOUT_ALL","label":"Status","placeholder":"All","defaultValue":"0"},{"type":"serverSelect","name":"STATE","optionsSrc":"STATE","label":"State","placeholder":"All","defaultValue":""},{"type":"serverSelect","name":"COUNTY","optionsSrc":"COUNTY_SUBOPTION","label":"County","overrideSubOptionsSrcFromParameterName":"STATE","placeholder":"All","defaultValue":""},{"type":"checkbox","name":"CRA_SEARCH_YN","defaultValue":false,"label":"Search by Registered Agent PID"},{"type":"dateRange","name":"FILING_DATE","label":"Registration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}},{"type":"dateRange","name":"EXPIRATION_DATE","label":"Expiration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}}],"myRecordsFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Active"},{"value":2,"label":"Inactive"},{"value":3,"label":"Pending"}]},{"type":"dateRange","name":"DATE_RANGE","label":"Date range","defaultValue":{"start":null,"end":null}}],"myWorkQueueFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Approved"},{"value":2,"label":"Pending Online Payment"},{"value":3,"label":"Pending Review"},{"value":4,"label":"Needs Correction"},{"value":5,"label":"Rejected"},{"value":6,"label":"Draft"}]},{"type":"dateRange","name":"DATE_RANGE","label":"Date range","defaultValue":{"start":null,"end":null}}]},{"label":"Notary","component":"Notary","parameter":"notary","sourceTypeId":850,"myWorkQueueSearch":false,"allowEmptySearchTerm":true,"requestCertificateAlternateLabel":"Download Certificate","fileAmendmentButtonLabel":"Filing Actions","hideNameRequestCertificate":true,"hideAddressRequestCertificate":true,"hideRecordUserManagment":true,"searchPlaceholder":"Search by name or commission number","searchMustHaveOneOf":["CITY","search","SERVICE_TYPE"],"advancedParametersStartOpen":true,"searchIsSortable":true,"advancedSearchParameters":[{"type":"radio","name":"STARTS_WITH_YN","defaultValue":false,"options":[{"value":true,"label":"Starts with"},{"value":false,"label":"Contains"}]},{"type":"checkbox","name":"ACTIVE_ONLY_YN","defaultValue":true,"label":"Active entities only"},{"type":"text","name":"CITY","defaultValue":"","label":"City"},{"type":"select","name":"SERVICE_TYPE","label":"Special Services Offered","defaultValue":0,"options":[{"value":0,"label":"(N/A)"},{"value":6165,"label":"In-Person Electronic Notarization (IPEN)"},{"value":6166,"label":"Remote Online Notarization (RON)"},{"value":6167,"label":"Mobile Notary Services"},{"value":6168,"label":"Remote Ink Notarization (RIN)"}]}]},{"label":"Apostille","component":"Apostille","parameter":"apostille","sourceTypeId":720,"myRecordsSearch":false,"myWorkQueueSearch":false,"disabled":false,"allowedRoutes":["/forms-manager/","/queue/","/forms/"]},{"label":"Liens","component":"UCC","parameter":"ucc","sourceTypeId":1999,"myRecordsSearch":true,"myWorkQueueSearch":true,"fileAmendmentButtonLabel":"Filing Actions","searchPlaceholder":"Search by name or file number","disabled":false,"serverWebSearchDescription":true,"myRecordsDescription":"","workQueueDescription":"","searchDescription":"","hideRecordUserManagment":true,"searchLiensCheckout":false,"advancedSearchParameters":[{"type":"radio","name":"STARTS_WITH_YN","defaultValue":false,"options":[{"value":true,"label":"Starts with"},{"value":false,"label":"Contains"}]},{"type":"select","name":"STATUS","defaultValue":"ALL","label":"Status","options":[{"value":"ACTIVE_UNLAPSED","label":"Active (unlapsed)"},{"value":"ACTIVE_LAPSED_UNLAPSED","label":"Active (lapsed and unlapsed)"}]},{"type":"text","name":"EXCLUDE_VALUES","label":"Exclude Debtor Names (comma separated list of names to exclude)","defaultValue":""},{"type":"dateRange","name":"FILING_DATE","label":"Financing Statement Date","defaultValue":{"start":null,"end":null}},{"type":"dateRange","name":"LAPSE_DATE","label":"Lapse Date","defaultValue":{"start":null,"end":null}},{"type":"text","name":"CITY","label":"Debtor City","defaultValue":""}],"myRecordsFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Approved"},{"value":2,"label":"Pending Online Payment"},{"value":3,"label":"Pending Review"}]},{"type":"select","name":"TYPE","defaultValue":0,"label":"Lien Type","options":[{"value":0,"label":"All"},{"value":1,"label":"UCC"},{"value":2,"label":"EFS"},{"value":3,"label":"Title 71"}]}],"myWorkQueueFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Approved"},{"value":2,"label":"Pending Online Payment"},{"value":3,"label":"Pending Review"},{"value":4,"label":"Pending Print and Mail"},{"value":5,"label":"Rejected"},{"value":6,"label":"Draft"}]},{"type":"select","name":"TYPE","defaultValue":0,"label":"Lien Type","options":[{"value":0,"label":"All"},{"value":1,"label":"UCC"},{"value":2,"label":"EFS"},{"value":3,"label":"Title 71"}]}]},{"label":"Copy Request","component":"copies","parameter":"copies","sourceTypeId":2001,"myRecordsSearch":false,"myWorkQueueSearch":false,"disabled":false,"allowedRoutes":["/forms-manager/","/queue/","/forms/"]},{"label":"Trademark","component":"Trademark","parameter":"trademark","sourceTypeId":810,"showRequestCertificate":true,"searchMustHaveOneOf":["search","EXPIRATION_DATE","FILING_DATE"],"allowEmptySearchTerm":true,"requestCertificateAlternateLabel":"Request Information","fileAmendmentButtonLabel":"Filing Actions","advancedSearchParameters":[{"type":"radio","name":"QUERY_TYPE_ID","defaultValue":1010,"options":[{"value":1010,"label":"Starts with"},{"value":1011,"label":"Contains"},{"value":1012,"label":" Word Contains"}]},{"type":"checkbox","name":"OWNER_SEARCH_YN","defaultValue":false,"label":"Search owners"},{"type":"radio","name":"SERVICE_MARK_YN","label":"Mark Type","defaultValue":"","options":[{"value":"","label":"All Marks"},{"value":"Y","label":"Service Mark"},{"value":"N","label":"Trademark"}]},{"type":"serverSelect","name":"STATUS_ID","optionsSrc":"TYPE_V|TRADEMARK_STATUS_TYPE","label":"Status","placeholder":"All","defaultValue":"0"},{"type":"select","name":"DESIGN_TYPE_ID","options":[{"value":0,"label":"All"},{"value":990,"label":"Words Only"},{"value":991,"label":"Design Only"},{"value":992,"label":"Words and Design"}],"label":"Design Type","defaultValue":"0"},{"type":"dateRange","name":"FILING_DATE","label":"Registered Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}},{"type":"dateRange","name":"EXPIRATION_DATE","label":"Expiration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}}]},{"label":"Business Info Request","component":"InfoRequests","parameter":"info-request","sourceTypeId":167,"allowedRoutes":["/forms-manager/","/queue/","/forms/"]},{"label":"Data Requests","component":"DataRequests","parameter":"data-request","sourceTypeId":0,"allowedRoutes":["/forms-manager/"]},{"label":"CRA","component":"CRA","parameter":"cra","sourceTypeId":157,"myRecordsSearch":false,"searchPlaceholder":"Search by name or registered agent number","allowedRoutes":["/forms-manager/","/forms/","/records/","/queue/","/search/"],"allowEmptySearchTerm":true,"fileAmendmentButtonLabel":"Filing Actions","advancedSearchParameters":[{"type":"radio","name":"QUERY_TYPE_ID","defaultValue":1010,"options":[{"value":1010,"label":"Starts with"},{"value":1011,"label":"Contains"},{"value":1012,"label":" Word Contains"}]},{"type":"dateRange","name":"CRA_DATE","label":"Registration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}},{"type":"select","name":"STATUS_ID","label":"Status","defaultValue":0,"options":[{"value":0,"label":"All"},{"value":121,"label":"Active"},{"value":122,"label":"Inactive"}]},{"type":"select","name":"AGENT_TYPE_ID","label":"Agent Type","defaultValue":0,"options":[{"value":0,"label":"All"},{"value":460,"label":"Registered Agent"},{"value":461,"label":"Commercial Registered Agent"}]}]},{"label":"Farm Bill","component":"FarmBill","parameter":"farm-bill","path":"/lists/farm-bill","sourceTypeId":0,"myRecordsSearch":false,"allowedRules":["/search/"],"disabled":true,"searchDescription":"To perform a search, enter a debtor name. Your search results may include: exact debtor name, variations of that name and any filing that includes your search criteria. Punctuation is ignored.\n\nYou can click on \"Advanced\" to refine your search. Under “Advanced” you can search by crop, year, county and SSN/FEIN. As a registered Farm Bill Buyer with the Montana Secretary of State’s office it is important to maintain the confidentiality of the information contained within the Farm Bill Master List. The Farm Bill Master List reflects personal data, such as Social Security Numbers, which are a key piece of personal identifiable information to assist you in determining the existence of a lien against a specific debtor. The distribution of this information beyond its intended purpose is strictly prohibited.\n\nThe debtor's tax identification number has been hidden for confidentiality reasons. You may continue to search on a tax ID number and return debtors that match your search criteria. The SSN/FEIN must be entered without dashes or spaces.","searchMustHaveOneOf":["search","UCC_FARM_PRODUCT_ID","COUNTY"],"searchPlaceholder":"Search by debtor name","advancedSearchParameters":[{"type":"ServerMultiComplete","label":"Product code name(s)","name":"UCC_FARM_PRODUCT_ID","defaultValue":"","optionsSrc":"UCC_FARM_PRODUCT_V"},{"type":"MultiComplete","label":"Year or Range of Years","name":"YEAR_NUM","optionsSrc":"years","startYear":"1968","defaultValue":[],"preMergeOptions":[{"value":"ALL","label":"All"}]},{"type":"serverSelect","label":"State","name":"STATE","defaultValue":"MONTANA","optionsSrc":"STATE"},{"type":"ServerMultiComplete","label":"County","name":"COUNTY","defaultValue":[],"optionsSrc":"COUNTY","overrideSubOptionsSrcFromParameterName":"STATE"},{"type":"checkbox","name":"TIN_SEARCH_YN","defaultValue":false,"label":"Tax Identification Number Search"},{"type":"checkbox","name":"TIN_SORT_YN","defaultValue":false,"label":"Unique ID Sort"}]}],"SYSTEM_NICKNAME":"Online Services Portal","PAYMENT_METHODS":[{"type":"bypass"},{"type":"iTransact"}],"PAYMENT_ALLOW_AMEX":true,"SYSTEM_ID_LABEL":"System Id","DOUBLE_COLUMN_PUBLIC_LOGIN":true,"INTERNAL_USER_MANAGEMENT":true,"ALLOW_PUBLIC_JSON_IMPORT":false,"MAX_FILE_UPLOAD_SIZE":10000000,"REFUND_TEXT":"","RETURN_TO_HOME_ON_LOGOUT":true,"CURRENT_SOS_NAME":"Christi Jacobsen","LOGO_FILENAME":"mt-sos-logo.png","LOGO_ALT":"Christi Jacobsen, Montana Secretary of State","LOGO_FULL_WIDTH":true,"HOME_HIDE_AUTH_HINT":true,"HOME_TITLE":"Montana Secretary of State","CUSTOM_TAB_TITLE":"Official Montana","HOME_SUBTITLE":"Online Business Services","ENTITY_NAME_CONSENT_DESCRIPTION":"","ALLOW_USER_PROFILE_EDITING":true,"COMPARE_FOREIGN_NAME_IN_ENTITY_NAME_VALIDATION":true,"FOREIGN_NAME_FIELD_NAME":"KIMA_PARENT_NAME_INFO","LOGIN_TITLE":"Montana Secretary of State Online Filing Portal Login","PUBLIC_LOGIN_LABEL":"Username","REVERSE_LOGIN_COLUMNS":true,"LOGIN_SEAL_FILENAME":"seal_white.png","SEPARATE_USERNAME_AND_EMAIL":true,"CREATE_ACCOUNT_BUTTON_ALIGN_LEFT":true,"CREATE_ACCOUNT_BUTTON_TEXT":"CREATE AN ACCOUNT","PASSWORD_CUSTOM_ERROR_TEXT":"The password must meet all requirements","ACCOUNT_CREATED_MESSAGE":"Please check your email to verify your account to login and allow a few minutes for this message to arrive. Check your junk/spam folders if you do not find the email in your inbox.","PUBLIC_LOGIN_PLACEHOLDER":" ","DISABLE_DEFAULT_PAYMENT_RADIO":true,"CUSTOM_RESET_PASSWORD_ERROR_MESSAGE":"Username invalid - no account found","PUBLIC_LOGIN_CREATE_DESCRIPTION":"### Existing User:\n\n  - Enter your username and password to login.  \n\n\n  #### - OR -  \n\n\n\n  - Forgot password? Click 'Reset Password' and follow the prompts.\n  - Forgot username? Click 'Forgot Username' and follow the prompts.  \n\n\n  ### New User:\n  ","LOGIN_HELP_LINK":"https://sosmt.gov/business/how-do-i/","LOGIN_HELP_LINK_TEXT":"Need Help?","FORGOT_USERNAME_TEXT":"Forgot Username?","LOGIN_ACTIVE_DIRECTORY_TEXT":"State User Login","MULTIPLE_LOGIN_METHODS":true,"HAS_ACTIVE_DIRECTORY_LOGIN":true,"RESET_PASSWORD_WITH_USERNAME":true,"DOWNLOAD_LINK":true,"SHOW_USERNAME_ACCOUNT_CREATE":true,"SHOW_SCROLL_DOWN_ARROW":true,"SHOW_ADDRESS_ACCOUNT_CREATE":true,"TWO_COLUMN_ACCOUNT_CREATE":true,"RESET_PASSWORD_TIP":"A link to change your password has been sent to your email. Please allow a few minutes for this message to arrive. Please check your junk/spam folders if you do not find the email in your inbox.","FORGOT_PASSWORD_LINK_TEXT":"Reset Password","PHONE_NUMBER_OPTIONAL_ACCOUNT_CREATE":true,"SHOW_REQUIRED_INDICATOR_ACCOUNT_CREATE":true,"PASSWORD_REQUIREMENTS_ACCOUNT_CREATE":"\n    <ul>\n      <li>MUST contain at least 8 characters (12+ recommended)</li>\n      <li>MUST contain at least one uppercase letter.</li>\n      <li>MUST contain at least one lowercase letter.</li>\n      <li>MUST contain at least one number.</li>\n      <li>MUST contain at least one special character (!”#$%&'()*+,-./:;<=>?</li>\n    </ul>\n  ","ALLOW_CERTIFICATION_REQUEST":true,"ALLOW_PUBLIC_CERTIFICATE_REQUEST":true,"ALLOW_COPY_REQUEST":false,"ALLOW_CORRECTION_STYLING":true,"HIDE_DEPRECATION_WARNING":false,"AMEND_ROUTE_PUBLIC":true,"SEAL_FILENAME":"seal.png","SHOPPING_CART":true,"ALLOW_PAYMENT_UPDATE_WITH_EMPTY_CART":true,"RA_EMAIL":true,"RA_WEBSITE":true,"RA_NO_DEFAULT_TYPE":true,"RA_ADDRESS_LABEL":"Street Address","RA_TYPE_SELECTION_DEFAULT":true,"RA_DEFAULT_TYPE":"460","RA_OVERRIDE_TYPE_WITH_DEFAULT":true,"RA_PRINCIPAL_ADDRESS_AMS":true,"UPLOAD_AND_SUBMIT_HIDE_IF_ONE_OPTION":true,"PAYMENT_PROCESSING_MESSAGE":"Your payment is processing - Do not close your browser or click the back button","CHECKOUT_BUTTON_WHEN_PROCESSING_TEXT":"Processing","EFS_CROP_PICKER_NONE_LABEL":"Lien Duration","DISALLOWED_WIZARD_PIECES":["FormationLocale"],"REPEATER_SHOW_EDIT_BUTTON":true,"DATA_REQUEST_PAGE_TITLE":"Data Requests and Subscriptions","DATA_REQUEST_SIDEBAR_LABEL":"Data Requests & Subscriptions","LOGIN_REDIRECTS_TO_EPASS":false,"LOGIN_REDIRECTS_TO_ACTIVE_DIRECTORY":true,"LOGIN_ACTIVE_DIRECTORY_LINK":true,"FETCH_EDIT_USER_LINK":false,"LISTS_FETCH_AVAILABLE_LISTS":true,"POST_WIZARD_SUBMIT_REDIRECT_URL":"/","PIN_REQUEST_ATTESTATIONS":true,"PIN_REQUEST_DESCRIPTION":"Click **Request PIN** to have a new PIN sent to the account holder's email address on file.","OWNERSHIP_REQUEST_DESCRIPTION":"To become an **authorized user** of this record, a current **AUTHORIZED USER** will need to grant you access. To request access, click **Request Access** below.","PIN_REQUEST_SUCCESS_MESSAGE":"The PIN you have requested for this entity has been sent to the email associated with your user account.  You should receive the PIN in approximately 3-5 minutes, depending on your email service provider.","APOSTILLE_HEADER_LABEL":"Verification Information","APOSTILLE_NUMBER_LABEL":"Apostille/Authentication","APOSTILLE_CITY_STATE_OVERRIDE":"HELENA, MT","APOSTILLE_FILING_DATE_LABEL":"Issue Date","APOSTILLE_CITY_STATE_IN_CERTIFIED":true,"NOTARY_EXISTING_FILING":true,"ALLOW_REVOKE_OWN_ACCESS_ONLY":false,"HIDE_CANCEL_ON_ONETIME_DATA_REQUESTS":true,"DATA_REQUESTS_IN_SHOPPING_CART":true,"WQ_ALLOW_EDIT_PENDING_PAYMENT":true,"WQ_CONFIRM_ON_DELETE":true,"WQ_DELETE_CONFIRM_MESSAGE":"Deleting this filing will forfeit any money already paid to the Secretary of State. This action is permanent and cannot be undone, are you sure you would like to delete?","PASS_ITEM_GUIDS_ON_CHECKOUT":true,"FORM_REVISION_HISTORY":true,"CHECKOUT_DISCLAIMER":"By entering your credit card and/or checking account information you (i) state that **you are an authorized user** of the credit card and/or electronic check and that the associated information entered (e.g., account holder name, account number, billing address) is accurate, (ii) **you authorize payment processor to charge the amount you have requested** to your credit card and/or funding account, and (iii) **acknowledge if a charge is declined or reversed you may also be assessed a customary charge** by the payment processor for such transactions.","FARM_BILL_SEARCH_CONFIDENTIAL":"As a registered Farm Bill Buyer with the Montana Secretary of State’s office it is important to maintain the confidentiality of the information contained within the Farm Bill Master List. The Farm Bill Master List reflects personal data, such as Social Security Numbers, which are a key piece of personal identifiable information to assist you in determining the existence of a lien against a specific debtor. The distribution of this information beyond its intended purpose is strictly prohibited.\n\n**The debtor's tax identification number has been hidden for confidentiality reasons. You may continue to search on a tax ID number and return debtors that match your search criteria. The SSN/FEIN must be entered without dashes or spaces.  If you need access to the tax identification number to clearly identify the debtor, please contact the UCC unit at (406) 444-3665.**","VIEW_HISTORY_BUTTON_ALT_TEXT":"View Filings","WIZARD_ERROR_TITLE_MESSAGE":"Form Error","FARM_BILL_SEARCH_INTERACTIVE":true,"USE_FARM_BILL_API":true,"DISALLOW_ASSIGN_SELF_AS_RA":true,"DISALLOW_ASSIGN_SELF_AS_PRINCIPAL":true,"USE_TRADEMARK_OWNER_VALIDATION":true,"USE_ALTERNATIVE_FOREIGN_ADDRESS_LABELS":true,"MY_RECEIPTS_FILTER":[{"type":"dateRange","name":"DATE_RANGE","label":"Date range","defaultValue":{"start":null,"end":null}},{"type":"text","name":"REF_NUM","defaultValue":"","label":"Reference Number"},{"type":"text","name":"RECEIPT_NUM","defaultValue":"","label":"Receipt Id"},{"type":"text","name":"AMOUNT","defaultValue":"","label":"Amount"},{"type":"select","name":"TYPE","defaultValue":"","label":"Payment Type","options":[{"value":"","label":"All"},{"value":"CC","label":"Credit Card"},{"value":"Check","label":"Check"}]}],"MY_RECEIPTS_SHOW_IN_SIDEBAR":true,"SHOW_MY_RECEIPTS_HELPER_TEXT":true,"MY_RECEIPTS_HELPER_LABEL":"About Receipt Search","MY_RECEIPTS_HELPER_TEXT":"You can search for receipts based on their descriptions, including the items paid for on the receipt. Use the filters to search for or filter specific information.","FARM_BILL_SUBLINK":{"label":"Farm Bill","component":"FarmBill","parameter":"farm-bill","path":"/lists/farm-bill","sourceTypeId":0,"myRecordsSearch":false,"allowedRules":["/search/"],"disabled":true,"searchDescription":"To perform a search, enter a debtor name. Your search results may include: exact debtor name, variations of that name and any filing that includes your search criteria. Punctuation is ignored.\n\nYou can click on \"Advanced\" to refine your search. Under “Advanced” you can search by crop, year, county and SSN/FEIN. As a registered Farm Bill Buyer with the Montana Secretary of State’s office it is important to maintain the confidentiality of the information contained within the Farm Bill Master List. The Farm Bill Master List reflects personal data, such as Social Security Numbers, which are a key piece of personal identifiable information to assist you in determining the existence of a lien against a specific debtor. The distribution of this information beyond its intended purpose is strictly prohibited.\n\nThe debtor's tax identification number has been hidden for confidentiality reasons. You may continue to search on a tax ID number and return debtors that match your search criteria. The SSN/FEIN must be entered without dashes or spaces.","searchMustHaveOneOf":["search","UCC_FARM_PRODUCT_ID","COUNTY"],"searchPlaceholder":"Search by debtor name","advancedSearchParameters":[{"type":"ServerMultiComplete","label":"Product code name(s)","name":"UCC_FARM_PRODUCT_ID","defaultValue":"","optionsSrc":"UCC_FARM_PRODUCT_V"},{"type":"MultiComplete","label":"Year or Range of Years","name":"YEAR_NUM","optionsSrc":"years","startYear":"1968","defaultValue":[],"preMergeOptions":[{"value":"ALL","label":"All"}]},{"type":"serverSelect","label":"State","name":"STATE","defaultValue":"MONTANA","optionsSrc":"STATE"},{"type":"ServerMultiComplete","label":"County","name":"COUNTY","defaultValue":[],"optionsSrc":"COUNTY","overrideSubOptionsSrcFromParameterName":"STATE"},{"type":"checkbox","name":"TIN_SEARCH_YN","defaultValue":false,"label":"Tax Identification Number Search"},{"type":"checkbox","name":"TIN_SORT_YN","defaultValue":false,"label":"Unique ID Sort"}]},"ALLOW_ADDRESS_VALIDATION_BYPASS_OPTION":true,"DEFAULT_ADDRESS_VALIDATION_BYPASS_OPTION_CHECKED":true}).PAYMENT_BYPASS_SIMULATES_PAYPAL_CALLBACK;
	var SHOPPING_CART = (true);
	var CHECKOUT_DISCLAIMER = ("By entering your credit card and/or checking account information you (i) state that **you are an authorized user** of the credit card and/or electronic check and that the associated information entered (e.g., account holder name, account number, billing address) is accurate, (ii) **you authorize payment processor to charge the amount you have requested** to your credit card and/or funding account, and (iii) **acknowledge if a charge is declined or reversed you may also be assessed a customary charge** by the payment processor for such transactions.");
	var PASS_ITEM_GUIDS_ON_CHECKOUT = (true);
	var ALLOW_PAYMENT_UPDATE_WITH_EMPTY_CART = (true);
	var PAYMENT_PROCESSING_MESSAGE = ("Your payment is processing - Do not close your browser or click the back button");
	var CHECKOUT_BUTTON_WHEN_PROCESSING_TEXT = ("Processing");
	
	var ConnectedCheckout = function (_Component) {
	  _inherits(ConnectedCheckout, _Component);
	
	  function ConnectedCheckout() {
	    _classCallCheck(this, ConnectedCheckout);
	
	    var _this = _possibleConstructorReturn(this, (ConnectedCheckout.__proto__ || Object.getPrototypeOf(ConnectedCheckout)).call(this));
	
	    _this.componentDidMount = function () {
	      _this.getAvailablePaymentMethods();
	    };
	
	    _this.getAvailablePaymentMethods = function () {
	      if (!_this.props.availableMethods) {
	        (0, _requests.GET_AVAILABLE_PAYMENT_METHODS)(_this.props.refNum, function (availableMethods) {
	          _this.setState({ availableMethods: availableMethods, loading: false });
	        }, function (err) {
	          _this.setState({ loading: false });
	        });
	      } else {
	        _this.setState({ loading: false, availableMethods: _this.props.availableMethods });
	      }
	    };
	
	    _this.payWithCreditCard = function () {
	      (0, _requests.POST_PAYMENT)({
	        amendmentNum: _this.props.amendmentNum,
	        formDefinitionId: _this.props.formDefinitionId,
	        correctionMode: _this.props.correctionMode || false
	      }, _this.props.category, function (response) {
	        _this.props.redirectToReceipt(0);
	      });
	    };
	
	    _this.state = {
	      paymentSuccessful: false,
	      loading: true,
	      SECURETOKEN: '',
	      SECURETOKENID: '',
	      BASEPAYMENTURL: '',
	      availableMethods: null
	    };
	    return _this;
	  }
	
	  _createClass(ConnectedCheckout, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          cancelCheckout = _props.cancelCheckout,
	          _props$receiptItems = _props.receiptItems,
	          receiptItems = _props$receiptItems === undefined ? [] : _props$receiptItems,
	          receiptItemContainers = _props.receiptItemContainers,
	          refNum = _props.refNum,
	          _redirectToReceipt = _props.redirectToReceipt,
	          ignoreAvailability = _props.ignoreAvailability,
	          onReceiptItemContainerRemoved = _props.onReceiptItemContainerRemoved,
	          setCartQuantity = _props.setCartQuantity,
	          skipCartQuantityUpdate = _props.skipCartQuantityUpdate,
	          onCartRefresh = _props.onCartRefresh;
	
	      var total = receiptItemContainers ? (0, _utilities.calculateReceiptItemContainersTotal)(receiptItemContainers) : (0, _utilities.calculateReceiptItemsTotal)(receiptItems);
	
	      return _react2.default.createElement(Checkout, {
	        onRequestModalClose: cancelCheckout,
	        receiptItems: receiptItems,
	        receiptItemContainers: receiptItemContainers,
	        total: total,
	        refNum: refNum,
	        payWithCreditCard: this.payWithCreditCard,
	        redirectToReceipt: function redirectToReceipt(refNum) {
	          _redirectToReceipt(refNum);
	          if (!skipCartQuantityUpdate) {
	            setCartQuantity(0);
	          }
	        },
	        loading: this.state.loading,
	        methods: PAYMENT_METHODS,
	        availableMethods: this.state.availableMethods,
	        ignoreAvailability: ignoreAvailability,
	        onReceiptItemContainerRemoved: onReceiptItemContainerRemoved,
	        onCartRefresh: onCartRefresh
	      });
	    }
	  }]);
	
	  return ConnectedCheckout;
	}(_react.Component);
	
	exports.default = (0, _reactRedux.connect)(null, { setCartQuantity: _actions.setCartQuantity })(ConnectedCheckout);
	
	var Checkout = exports.Checkout = function (_React$Component) {
	  _inherits(Checkout, _React$Component);
	
	  function Checkout() {
	    var _ref;
	
	    var _temp, _this2, _ret;
	
	    _classCallCheck(this, Checkout);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this2 = _possibleConstructorReturn(this, (_ref = Checkout.__proto__ || Object.getPrototypeOf(Checkout)).call.apply(_ref, [this].concat(args))), _this2), _this2.state = {
	      paymentClicked: false,
	      paypalParams: { SECURETOKEN: '', SECURETOKENID: '', BASEPAYMENTURL: '', PAYMENT_URL: '' },
	      prePaymentError: false,
	      prePaymentErrorMessage: null,
	      iTransactIsLoaded: true,
	      isAddingFrequentPayorFunds: false,
	      deletedGuids: [],
	      nativeCheckoutActive: false,
	      nativeError: null
	    }, _this2.getPaypalToken = function () {
	      (0, _requests.GET_PAYPAL_TOKEN)(_this2.props.refNum, function (_ref2) {
	        var SECURETOKEN = _ref2.SECURETOKEN,
	            SECURETOKENID = _ref2.SECURETOKENID,
	            BASEPAYMENTURL = _ref2.BASEPAYMENTURL,
	            PAYMENT_URL = _ref2.PAYMENT_URL;
	
	        _this2.setState({
	          paypalParams: {
	            SECURETOKEN: SECURETOKEN,
	            SECURETOKENID: SECURETOKENID,
	            BASEPAYMENTURL: BASEPAYMENTURL,
	            PAYMENT_URL: PAYMENT_URL
	          }
	        }, function () {
	          _this2.paypalSubmit.click();
	        });
	      }, function (err) {
	        _this2.setState({
	          prePaymentError: true,
	          paymentClicked: false,
	          prePaymentErrorMessage: err.message
	        });
	      });
	    }, _this2.startAccessIDCCPayment = function () {
	      (0, _requests.CREATE_ACCESSIDCC_PAYMENT)({
	        ITEMIDS: _this2.getFilteredReceiptItemContainers(_this2.props.receiptItemContainers).map(function (container) {
	          return container.GUID;
	        })
	      }, function (_ref3) {
	        var SECURETOKEN = _ref3.SECURETOKEN,
	            SECURETOKENID = _ref3.SECURETOKENID,
	            BASEPAYMENTURL = _ref3.BASEPAYMENTURL;
	
	        _this2.setState({
	          paypalParams: {
	            SECURETOKEN: SECURETOKEN,
	            SECURETOKENID: SECURETOKENID,
	            BASEPAYMENTURL: BASEPAYMENTURL
	          }
	        }, function () {
	          _this2.accessIDCCSubmit.click();
	        });
	      }, function (err) {
	        _this2.setState({
	          prePaymentError: true,
	          paymentClicked: false,
	          prePaymentErrorMessage: err.message
	        });
	      });
	    }, _this2.startAccessIDLOCPayment = function () {
	      (0, _requests.CREATE_ACCESSIDLOC_PAYMENT)({
	        ITEMIDS: _this2.getFilteredReceiptItemContainers(_this2.props.receiptItemContainers).map(function (container) {
	          return container.GUID;
	        })
	      }, function (_ref4) {
	        var SECURETOKEN = _ref4.SECURETOKEN,
	            SECURETOKENID = _ref4.SECURETOKENID,
	            BASEPAYMENTURL = _ref4.BASEPAYMENTURL;
	
	        _this2.setState({
	          paypalParams: {
	            SECURETOKEN: SECURETOKEN,
	            SECURETOKENID: SECURETOKENID,
	            BASEPAYMENTURL: BASEPAYMENTURL
	          }
	        }, function () {
	          _this2.accessIDLOCSubmit.click();
	        });
	      }, function (err) {
	        _this2.setState({
	          prePaymentError: true,
	          paymentClicked: false,
	          prePaymentErrorMessage: err.message
	        });
	      });
	    }, _this2.submitElavonCheckout = function (values) {
	      (0, _Elavon.submitElavonCheckout)(values, PASS_ITEM_GUIDS_ON_CHECKOUT ? _this2.getFilteredReceiptItemContainers(_this2.props.receiptItemContainers).map(function (container) {
	        return container.GUID;
	      }) : _this2.props.refNum).then(_this2.props.redirectToReceipt).catch(function (err) {
	        _this2.setState({
	          paymentClicked: false,
	          nativeError: _react2.default.createElement(
	            _react2.default.Fragment,
	            null,
	            err.errorCode ? _react2.default.createElement(
	              'strong',
	              null,
	              err.errorCode,
	              ' -'
	            ) : null,
	            err.errorMessage || err.message || 'Something went wrong while processing this payment. Please try again later.'
	          )
	        });
	      });
	    }, _this2.togglePaymentClicked = function () {
	      _this2.setState({ paymentClicked: true });
	    }, _this2.startPayment = function (method) {
	      _this2.togglePaymentClicked();
	      method();
	    }, _this2.bypassPayment = function () {
	      (0, _requests.BYPASS_PAYMENT)(PASS_ITEM_GUIDS_ON_CHECKOUT ? {
	        ITEMIDS: _this2.getFilteredReceiptItemContainers(_this2.props.receiptItemContainers).map(function (container) {
	          return container.GUID;
	        })
	      } : {
	        SECURETOKENID: _this2.props.refNum
	      }, function (refNum) {
	        if (PAYMENT_BYPASS_SIMULATES_PAYPAL_CALLBACK) {
	          window.ALLOW_BYPASS_WIZARD_PROMPT = true;
	          _store.history.push('/processpayment/paypal?SECURETOKENID=' + (refNum || _this2.props.refNum));
	        } else {
	          _this2.props.redirectToReceipt(refNum);
	        }
	      }, function (err) {
	        _this2.setState({
	          prePaymentError: true,
	          prePaymentErrorMessage: err.message,
	          paymentClicked: false
	        });
	        console.error(err, 'nice try.');
	      });
	    }, _this2.payWithFrequentPayor = function () {
	      if (PASS_ITEM_GUIDS_ON_CHECKOUT) {
	        (0, _requests2.WEB_CART_GUIDS_TRANSACTION_WITH_FREQUENT_PAYOR)({
	          ITEMIDS: _this2.getFilteredReceiptItemContainers(_this2.props.receiptItemContainers).map(function (container) {
	            return container.GUID;
	          })
	        }, function (refNum) {
	          _this2.props.redirectToReceipt(refNum);
	        }, function (err) {
	          _this2.setState({
	            prePaymentError: true,
	            prePaymentErrorMessage: err.message,
	            paymentClicked: false
	          });
	          console.error(err);
	        });
	      } else {
	        (0, _requests.WEB_CART_TRANSACTION_WITH_FREQUENT_PAYOR)(_this2.props.refNum, function () {
	          _this2.props.redirectToReceipt();
	        }, function (err) {
	          _this2.setState({
	            prePaymentError: true,
	            prePaymentErrorMessage: err.message,
	            paymentClicked: false
	          });
	          console.error(err);
	        });
	      }
	    }, _this2.setTransactLoaded = function () {
	      return _this2.setState({ iTransactIsLoaded: true });
	    }, _this2.registerSubmodule = function (module) {
	      return _this2.setState(function (state) {
	        return { registeredSubmodules: [].concat(_toConsumableArray(state.registeredSubmodules), [module]) };
	      });
	    }, _this2.removeItemFromCart = function (guid) {
	      var deletedGuids = _this2.state.deletedGuids;
	      _this2.setState(function (state) {
	        return {
	          deletedGuids: [].concat(_toConsumableArray(state.deletedGuids), [guid])
	        };
	      });
	      (0, _requests.REMOVE_FROM_WEB_CART_BY_GUID)(guid, function (success) {
	        _this2.props.setCartQuantity(_this2.getNumReceiptItemContainers());
	        if (typeof _this2.props.onCartRefresh === 'function') {
	          _this2.props.onCartRefresh();
	        }
	        if (typeof _this2.props.onReceiptItemContainerRemoved === 'function') {
	          _this2.props.onReceiptItemContainerRemoved(guid);
	        }
	      }, function (err) {
	        console.error(err);
	        if (typeof _this2.props.onCartRefresh === 'function') {
	          _this2.props.onCartRefresh();
	        } else {
	          _this2.setState({ deletedGuids: deletedGuids });
	        }
	      });
	    }, _this2.getFilteredReceiptItemContainers = function (items) {
	      return items ? items.filter(function (x) {
	        return !_this2.state.deletedGuids.includes(x.GUID);
	      }) : [];
	    }, _this2.getNumReceiptItemContainers = function () {
	      return _this2.getFilteredReceiptItemContainers(_this2.props.receiptItemContainers.filter(function (x) {
	        return !x.IS_FREE;
	      })).length;
	    }, _this2.setPrepaymentError = function (prePaymentError) {
	      return _this2.setState({ prePaymentError: prePaymentError });
	    }, _this2.nativeCheckoutCallbackHandler = null, _this2.registerNativeCallbackHandler = function (handler) {
	      if (typeof handler !== 'function') {
	        throw new Error('The handler you attempted to register is not a function.');
	      } else {
	        _this2.nativeCheckoutCallbackHandler = handler;
	      }
	    }, _this2.handleNativeCallback = function (values) {
	      _this2.setState({ paymentClicked: true, nativeError: null });
	      _this2.nativeCheckoutCallbackHandler(values);
	    }, _temp), _possibleConstructorReturn(_this2, _ret);
	  }
	
	  _createClass(Checkout, [{
	    key: 'render',
	    value: function render() {
	      var _this3 = this;
	
	      var _props2 = this.props,
	          _props2$receiptItems = _props2.receiptItems,
	          receiptItems = _props2$receiptItems === undefined ? [] : _props2$receiptItems,
	          allReceiptItemContainers = _props2.receiptItemContainers,
	          _props2$total = _props2.total,
	          rawTotal = _props2$total === undefined ? 0 : _props2$total,
	          onRequestModalClose = _props2.onRequestModalClose,
	          loading = _props2.loading,
	          availableMethods = _props2.availableMethods,
	          _props2$methods = _props2.methods,
	          methods = _props2$methods === undefined ? [] : _props2$methods,
	          refNum = _props2.refNum,
	          ignoreAvailability = _props2.ignoreAvailability,
	          isFrequentPayor = _props2.isFrequentPayor,
	          loggedIn = _props2.loggedIn;
	
	      var receiptItemContainers = this.getFilteredReceiptItemContainers(allReceiptItemContainers);
	      var hasRenderableItems = allReceiptItemContainers ? !!receiptItemContainers.length : !!receiptItems.length;
	      var allowPaymentUpdateAndHideCheckout = !hasRenderableItems && ALLOW_PAYMENT_UPDATE_WITH_EMPTY_CART;
	      var total = rawTotal;
	      if (receiptItemContainers.length < (allReceiptItemContainers || []).length) {
	        total = (0, _utilities.calculateReceiptItemContainersTotal)(receiptItemContainers);
	      }
	      var paymentButtonsDisabled = this.state.paymentClicked || this.state.nativeCheckoutActive;
	      var displayShoppingCart = SHOPPING_CART === true && loggedIn === true;
	      return _react2.default.createElement(
	        'div',
	        { className: 'checkout', 'aria-busy': loading },
	        _react2.default.createElement(
	          'div',
	          { className: 'header' },
	          _react2.default.createElement('span', { className: 'icon icon-cart' }),
	          _react2.default.createElement(
	            'span',
	            { className: 'title' },
	            displayShoppingCart ? 'Cart' : 'Checkout'
	          ),
	          _react2.default.createElement(
	            'button',
	            {
	              type: 'button',
	              className: 'close ' + (displayShoppingCart ? 'close-text' : ''),
	              onClick: !this.state.paymentClicked ? onRequestModalClose : null,
	              disabled: this.state.paymentClicked
	            },
	            displayShoppingCart ? 'Close Cart' : _react2.default.createElement('span', { className: 'icon icon-cross' })
	          )
	        ),
	        loading ? _react2.default.createElement(_Loaders.Spinner, { color: '#7792d0', className: 'checkout-loader', size: 'small' }) : _react2.default.createElement(
	          _NativeCheckout2.default,
	          {
	            active: this.state.nativeCheckoutActive,
	            disabled: this.state.paymentClicked,
	            error: this.state.nativeError,
	            processing: this.state.paymentClicked,
	            onDeactivateRequested: function onDeactivateRequested() {
	              return _this3.setState({ nativeCheckoutActive: false });
	            },
	            onSubmit: this.handleNativeCallback
	          },
	          _react2.default.createElement(
	            _react2.default.Fragment,
	            null,
	            _react2.default.createElement(
	              'div',
	              { className: 'line-items' },
	              allReceiptItemContainers ? receiptItemContainers.length ? receiptItemContainers.map(function (itemContainer, i) {
	                return !itemContainer.IS_FREE ? _react2.default.createElement(ItemContainer, {
	                  mainItem: itemContainer.RECEIPT_ITEM_WEB_LIST[0],
	                  receiptItems: itemContainer.RECEIPT_ITEM_WEB_LIST.slice(1),
	                  onRemoveRequested: function onRemoveRequested() {
	                    return _this3.removeItemFromCart(itemContainer.GUID);
	                  },
	                  disabled: paymentButtonsDisabled,
	                  key: itemContainer.GUID
	                }) : null;
	              }) : _react2.default.createElement(
	                'p',
	                { className: 'cart-empty-hint' },
	                'There are no items in your cart'
	              ) : receiptItems.length ? receiptItems.map(function (item, i) {
	                return _react2.default.createElement(LineItem, {
	                  product: item.DESCR_DISPLAY ? item.DESCR_DISPLAY : item.DESCR,
	                  price: item.LINE_TOTAL.toFixed(2),
	                  key: item.REF_NUM + i
	                });
	              }) : _react2.default.createElement(
	                'p',
	                { className: 'cart-empty-hint' },
	                'There are no items in your cart'
	              )
	            ),
	            hasRenderableItems ? _react2.default.createElement(
	              'div',
	              { className: 'subtotals' },
	              _react2.default.createElement(SubTotal, { label: 'Total:', price: '$' + Number(total).toFixed(2), total: true })
	            ) : null,
	            this.state.prePaymentErrorMessage && _react2.default.createElement(
	              'p',
	              { className: 'method-error' },
	              this.state.prePaymentErrorMessage
	            ),
	            hasRenderableItems || allowPaymentUpdateAndHideCheckout ? availableMethods !== null ? methods.map(function (method) {
	              if (availableMethods[method.type] === true || ignoreAvailability) {
	                switch (method.type) {
	                  case 'paypal':
	                    return _react2.default.createElement(
	                      'form',
	                      {
	                        method: 'POST',
	                        action: _this3.state.paypalParams.PAYMENT_URL,
	                        key: method.type + 'frm'
	                      },
	                      _react2.default.createElement('input', {
	                        type: 'hidden',
	                        name: 'SECURETOKENID',
	                        value: _this3.state.paypalParams.SECURETOKENID,
	                        readOnly: true
	                      }),
	                      _react2.default.createElement('input', {
	                        type: 'hidden',
	                        name: 'SECURETOKEN',
	                        value: _this3.state.paypalParams.SECURETOKEN,
	                        readOnly: true
	                      }),
	                      _react2.default.createElement('input', { type: 'hidden', name: 'ECHODATA', value: 'user', readOnly: true }),
	                      _react2.default.createElement('input', {
	                        type: 'hidden',
	                        name: 'USER1',
	                        value: JSON.stringify({
	                          ORIGIN: _requests.BASE_URL,
	                          BASE_URL: _requests.BASE_URL,
	                          ENV: ("production")
	                        }),
	                        readOnly: true
	                      }),
	                      _react2.default.createElement(
	                        PaymentButton,
	                        {
	                          onClick: function onClick() {
	                            _this3.startPayment(_this3.getPaypalToken);
	                          },
	                          disabled: paymentButtonsDisabled,
	                          error: _this3.state.prePaymentError
	                        },
	                        'Pay with Credit Card'
	                      ),
	                      _react2.default.createElement('button', {
	                        ref: function ref(r) {
	                          _this3.paypalSubmit = r;
	                        },
	                        style: { display: 'none' },
	                        type: 'submit'
	                      })
	                    );
	                  case 'accessIDCC':
	                    return _react2.default.createElement(
	                      _react2.default.Fragment,
	                      null,
	                      _react2.default.createElement(
	                        'form',
	                        {
	                          method: 'POST',
	                          action: _this3.state.paypalParams.BASEPAYMENTURL,
	                          key: method.type + 'frm'
	                        },
	                        _react2.default.createElement(
	                          PaymentButton,
	                          {
	                            onClick: function onClick() {
	                              _this3.startPayment(_this3.startAccessIDCCPayment);
	                            },
	                            disabled: paymentButtonsDisabled,
	                            error: _this3.state.prePaymentError
	                          },
	                          'Pay with Credit Card'
	                        ),
	                        _react2.default.createElement('button', {
	                          ref: function ref(r) {
	                            _this3.accessIDCCSubmit = r;
	                          },
	                          style: { display: 'none' },
	                          type: 'submit'
	                        })
	                      )
	                    );
	                  case 'accessIDLOC':
	                    return _react2.default.createElement(
	                      'form',
	                      {
	                        method: 'POST',
	                        action: _this3.state.paypalParams.BASEPAYMENTURL,
	                        key: method.type + 'frm'
	                      },
	                      _react2.default.createElement(
	                        PaymentButton,
	                        {
	                          onClick: function onClick() {
	                            _this3.startPayment(_this3.startAccessIDLOCPayment);
	                          },
	                          disabled: paymentButtonsDisabled,
	                          error: _this3.state.prePaymentError
	                        },
	                        'Pay with Tyler Idaho'
	                      ),
	                      _react2.default.createElement('button', {
	                        ref: function ref(r) {
	                          _this3.accessIDLOCSubmit = r;
	                        },
	                        style: { display: 'none' },
	                        type: 'submit'
	                      }),
	                      CHECKOUT_DISCLAIMER && _react2.default.createElement(_Markdown2.default, { source: CHECKOUT_DISCLAIMER, className: 'markdown' })
	                    );
	                  case 'iTransact':
	                    return _react2.default.createElement(
	                      'form',
	                      { key: 'iTransact' },
	                      _react2.default.createElement(ITransact, {
	                        refNum: refNum,
	                        onComplete: _this3.props.redirectToReceipt,
	                        receiptItemGuids: _this3.getFilteredReceiptItemContainers(_this3.props.receiptItemContainers).map(function (container) {
	                          return container.GUID;
	                        }),
	                        hideCheckout: allowPaymentUpdateAndHideCheckout
	                      })
	                    );
	                  case 'bypass':
	                    return _react2.default.createElement(
	                      PaymentButton,
	                      {
	                        onClick: function onClick() {
	                          _this3.startPayment(_this3.bypassPayment);
	                        },
	                        error: _this3.state.prePaymentError,
	                        disabled: paymentButtonsDisabled,
	                        key: method.type
	                      },
	                      'Bypass Checkout (Dev-only)'
	                    );
	                  case 'frequentPayor':
	                    return isFrequentPayor ? _react2.default.createElement(_FrequentPayor.FrequentPayorCheckoutSection, {
	                      key: method.type,
	                      total: total,
	                      disabled: paymentButtonsDisabled,
	                      error: _this3.state.prePaymentError,
	                      errorMessage: _this3.state.prePaymentErrorMessage,
	                      onPaymentRequested: function onPaymentRequested() {
	                        return _this3.startPayment(_this3.payWithFrequentPayor);
	                      }
	                    }) : null;
	                  case 'elavon':
	                    return _react2.default.createElement(
	                      'form',
	                      { key: 'elavon' },
	                      method.method === 'lightbox' ? _react2.default.createElement(_Elavon.ElavonCheckoutSection, {
	                        refNum: refNum,
	                        onComplete: _this3.props.redirectToReceipt,
	                        onPrePaymentError: function onPrePaymentError(err) {
	                          return _this3.setPrepaymentError(err.errorMessage);
	                        },
	                        error: _this3.state.prePaymentError
	                      }) : null,
	                      method.method === 'checkout' ? _react2.default.createElement(
	                        _Elavon.ElavonProvider,
	                        { method: 'checkout' },
	                        function (elavonLoaded) {
	                          return _react2.default.createElement(
	                            PaymentButton,
	                            {
	                              bypassLoadingStyles: true,
	                              onClick: function onClick() {
	                                _this3.registerNativeCallbackHandler(_this3.submitElavonCheckout);
	                                _this3.setState({ nativeCheckoutActive: true });
	                              },
	                              disabled: paymentButtonsDisabled || !elavonLoaded,
	                              error: _this3.state.prePaymentError
	                            },
	                            'Pay with Credit Card'
	                          );
	                        }
	                      ) : null
	                    );
	                  default:
	                    return _react2.default.createElement(
	                      PaymentButton,
	                      {
	                        onClick: function onClick() {
	                          _this3.startPayment(_this3.bypassPayment);
	                        },
	                        disabled: paymentButtonsDisabled,
	                        error: _this3.state.prePaymentError,
	                        key: method.type
	                      },
	                      'Payment (demo)'
	                    );
	                }
	              } else {
	                return availableMethods[method.type] ? availableMethods[method.type] === 'hide' ? null : _react2.default.createElement(
	                  'p',
	                  { className: 'method-error' },
	                  availableMethods[method.type]
	                ) : null;
	              }
	            }) : _react2.default.createElement(
	              'p',
	              { className: 'method-error' },
	              'There are currently no online payment methods available.'
	            ) : null,
	            displayShoppingCart && hasRenderableItems ? _react2.default.createElement(
	              'div',
	              { className: 'flex-row continue-section' },
	              _react2.default.createElement(
	                'button',
	                {
	                  className: 'continue-button',
	                  disabled: paymentButtonsDisabled,
	                  onClick: !this.state.paymentClicked ? onRequestModalClose : null
	                },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'flex-center' },
	                  _react2.default.createElement(_caretLeft2.default, null),
	                  ' File/Order Additional Items'
	                )
	              )
	            ) : null
	          )
	        )
	      );
	    }
	  }]);
	
	  return Checkout;
	}(_react2.default.Component);
	
	exports.Checkout = Checkout = (0, _reactRedux.connect)(function (state) {
	  return { isFrequentPayor: state.auth.isFrequentPayor, loggedIn: state.auth.loggedIn };
	}, {
	  setCartQuantity: _actions.setCartQuantity
	})(Checkout);
	
	var ItemContainer = function ItemContainer(_ref5) {
	  var _ref5$mainItem = _ref5.mainItem,
	      mainItem = _ref5$mainItem === undefined ? {} : _ref5$mainItem,
	      receiptItems = _ref5.receiptItems,
	      onRemoveRequested = _ref5.onRemoveRequested,
	      disabled = _ref5.disabled;
	
	  return _react2.default.createElement(
	    'div',
	    { className: 'flex-row align-center line-item-container' },
	    _react2.default.createElement(
	      'div',
	      { className: 'buttons-wrapper' },
	      _react2.default.createElement(
	        'button',
	        {
	          disabled: disabled,
	          className: 'remove-item-button',
	          onClick: onRemoveRequested,
	          'aria-label': 'Remove ' + (mainItem.DESCR_DISPLAY ? mainItem.DESCR_DISPLAY : mainItem.DESCR) + ' from the cart.'
	        },
	        _react2.default.createElement(_crossHeavy2.default, null)
	      )
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'flex-column line-item-column' },
	      _react2.default.createElement(LineItem, {
	        product: mainItem.DESCR_DISPLAY ? mainItem.DESCR_DISPLAY : mainItem.DESCR,
	        price: Number(mainItem.LINE_TOTAL).toFixed(2),
	        deletable: true
	      }),
	      receiptItems.map(function (item, i) {
	        return _react2.default.createElement(LineItem, {
	          product: item.DESCR_DISPLAY ? item.DESCR_DISPLAY : item.DESCR,
	          price: Number(item.LINE_TOTAL).toFixed(2),
	          key: item.REF_NUM + i,
	          deletable: true,
	          subline: true
	        });
	      })
	    )
	  );
	};
	
	var LineItem = function LineItem(_ref6) {
	  var product = _ref6.product,
	      price = _ref6.price,
	      _ref6$details = _ref6.details,
	      details = _ref6$details === undefined ? [] : _ref6$details,
	      deletable = _ref6.deletable,
	      subline = _ref6.subline;
	  return _react2.default.createElement(
	    'div',
	    { className: 'line-item ' + (subline ? 'subline' : '') },
	    _react2.default.createElement(
	      'div',
	      { className: 'row' },
	      _react2.default.createElement(
	        'div',
	        { className: 'col-9' },
	        _react2.default.createElement(
	          'span',
	          { className: 'product ' + (deletable ? 'deletable' : '') },
	          product
	        ),
	        details.map(function (detail, i) {
	          return _react2.default.createElement(
	            'span',
	            { className: 'detail', key: i },
	            detail
	          );
	        })
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'col-3' },
	        _react2.default.createElement(
	          'span',
	          { className: 'price' },
	          '$',
	          price
	        )
	      )
	    )
	  );
	};
	
	var SubTotal = function SubTotal(_ref7) {
	  var label = _ref7.label,
	      price = _ref7.price,
	      total = _ref7.total;
	  return _react2.default.createElement(
	    'div',
	    { className: 'row subtotal ' + (total ? 'total' : '') },
	    _react2.default.createElement(
	      'div',
	      { className: 'col-8' },
	      _react2.default.createElement(
	        'span',
	        { className: 'label' },
	        label
	      )
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'col-4' },
	      _react2.default.createElement(
	        'span',
	        { className: 'price' },
	        price
	      )
	    )
	  );
	};
	
	var PaymentButton = exports.PaymentButton = function (_Component2) {
	  _inherits(PaymentButton, _Component2);
	
	  function PaymentButton() {
	    var _ref8;
	
	    var _temp2, _this4, _ret2;
	
	    _classCallCheck(this, PaymentButton);
	
	    for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
	      args[_key2] = arguments[_key2];
	    }
	
	    return _ret2 = (_temp2 = (_this4 = _possibleConstructorReturn(this, (_ref8 = PaymentButton.__proto__ || Object.getPrototypeOf(PaymentButton)).call.apply(_ref8, [this].concat(args))), _this4), _this4.state = {
	      loading: false,
	      error: false
	    }, _this4.componentWillReceiveProps = function (nextProps) {
	      if (_this4.state.loading && nextProps.error) {
	        _this4.setState({
	          loading: false,
	          error: true
	        });
	      }
	    }, _this4.onClick = function () {
	      if (!_this4.props.bypassLoadingStyles) {
	        _this4.setState({
	          loading: true,
	          error: false
	        });
	      }
	      _this4.props.onClick();
	    }, _temp2), _possibleConstructorReturn(_this4, _ret2);
	  }
	
	  _createClass(PaymentButton, [{
	    key: 'render',
	    value: function render() {
	      var _props3 = this.props,
	          children = _props3.children,
	          disabled = _props3.disabled,
	          loading = _props3.loading,
	          disableErrorHandling = _props3.disableErrorHandling,
	          forceShowError = _props3.forceShowError,
	          _props3$className = _props3.className,
	          className = _props3$className === undefined ? '' : _props3$className,
	          style = _props3.style;
	
	      var hasError = forceShowError || this.state.error;
	      var checkoutButtonText = CHECKOUT_BUTTON_WHEN_PROCESSING_TEXT && loading ? CHECKOUT_BUTTON_WHEN_PROCESSING_TEXT : children;
	      return _react2.default.createElement(
	        'button',
	        {
	          type: 'button',
	          className: 'payment-button btn-3d button ' + (hasError && !disableErrorHandling ? 'danger' : '') + ' ' + (disabled === false ? '' : 'disabled') + ' ' + className,
	          onClick: this.onClick,
	          disabled: disabled || hasError && !disableErrorHandling,
	          style: style,
	          'aria-busy': (loading || this.state.loading) && !forceShowError
	        },
	        _react2.default.createElement(
	          'div',
	          { className: 'center' },
	          (this.state.loading || loading) && !forceShowError ? _react2.default.createElement(_Loaders.Spinner, { className: 'loader', size: 'small', linear: true, color: 'currentColor' }) : hasError && !disableErrorHandling ? _react2.default.createElement(_crossHeavy2.default, null) : _react2.default.createElement(_lockSolid2.default, null),
	          _react2.default.createElement(
	            'span',
	            { className: 'label' },
	            hasError && !disableErrorHandling ? 'Something went wrong' : checkoutButtonText
	          ),
	          (loading || this.state.loading) && _react2.default.createElement(
	            'span',
	            { role: 'alert', className: 'visually-hidden' },
	            '"Your payment is processing, please wait."'
	          )
	        )
	      );
	    }
	  }]);
	
	  return PaymentButton;
	}(_react.Component);
	
	var ITransact = function (_React$Component2) {
	  _inherits(ITransact, _React$Component2);
	
	  function ITransact() {
	    var _ref9;
	
	    var _temp3, _this5, _ret3;
	
	    _classCallCheck(this, ITransact);
	
	    for (var _len3 = arguments.length, args = Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
	      args[_key3] = arguments[_key3];
	    }
	
	    return _ret3 = (_temp3 = (_this5 = _possibleConstructorReturn(this, (_ref9 = ITransact.__proto__ || Object.getPrototypeOf(ITransact)).call.apply(_ref9, [this].concat(args))), _this5), _initialiseProps.call(_this5), _temp3), _possibleConstructorReturn(_this5, _ret3);
	  }
	
	  _createClass(ITransact, [{
	    key: 'render',
	    value: function render() {
	      var _this6 = this;
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'itransact-checkout' },
	        this.state.loaded ? _react2.default.createElement(
	          _react2.default.Fragment,
	          null,
	          this.state.customer && !this.state.skipStoredPayments && _react2.default.createElement(
	            _react2.default.Fragment,
	            null,
	            _react2.default.createElement(
	              'p',
	              null,
	              this.state.additionalText || 'Select or add a payment method to checkout.'
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'wizard' },
	              _react2.default.createElement(_Form.RadioInput, {
	                value: this.state.selectedSource,
	                onChange: function onChange(selectedSource) {
	                  return _this6.setState({ selectedSource: selectedSource });
	                },
	                options: this.state.customer.payment_sources.map(function (source) {
	                  return {
	                    value: source.id,
	                    label: source.type === 'ach' ? _react2.default.createElement(
	                      'span',
	                      { className: 'label-wrapper' },
	                      _react2.default.createElement(_bankSolid2.default, null),
	                      (source.savings_account === 'true' ? 'Savings' : 'Checking') + ' ****' + source.last_four_digits,
	                      _react2.default.createElement(
	                        'button',
	                        {
	                          className: 'trash-button',
	                          type: 'button',
	                          onClick: function onClick() {
	                            return _this6.startDelete(source.id);
	                          },
	                          disabled: _this6.state.processingPayment
	                        },
	                        _react2.default.createElement(_trash2.default, null)
	                      )
	                    ) : _react2.default.createElement(
	                      'span',
	                      { className: 'label-wrapper' },
	                      _react2.default.createElement(_creditCardSolid2.default, null),
	                      source.brand.charAt(0).toUpperCase() + source.brand.slice(1) + ' ****' + source.last_four_digits,
	                      _react2.default.createElement(
	                        'button',
	                        {
	                          className: 'trash-button',
	                          type: 'button',
	                          onClick: function onClick() {
	                            return _this6.startDelete(source.id);
	                          },
	                          disabled: _this6.state.processingPayment
	                        },
	                        _react2.default.createElement(_trash2.default, null)
	                      )
	                    )
	                  };
	                })
	              })
	            )
	          ),
	          !this.state.skipStoredPayments && _react2.default.createElement(
	            'button',
	            {
	              type: 'button',
	              className: 'new-payment-btn',
	              disabled: this.state.reloadingPayment || this.state.processingPayment,
	              onClick: this.openItransact
	            },
	            _react2.default.createElement(
	              'div',
	              { className: 'flex-center' },
	              this.state.reloadingPayment ? _react2.default.createElement(
	                _react2.default.Fragment,
	                null,
	                _react2.default.createElement(_Loaders.Spinner, { size: 'small', color: 'rgba(255,255,255,.6)' }),
	                ' Adding Payment Method'
	              ) : _react2.default.createElement(
	                _react2.default.Fragment,
	                null,
	                _react2.default.createElement(_plusHeavy2.default, null),
	                ' Add New Payment Method'
	              )
	            )
	          ),
	          this.state.error && _react2.default.createElement(
	            'p',
	            { className: 'payment-error', role: 'alert' },
	            _react2.default.createElement(_crossHeavy2.default, null),
	            ' ',
	            _react2.default.createElement(
	              'span',
	              null,
	              this.state.error
	            )
	          ),
	          (this.state.selectedSource || this.state.skipStoredPayments) && !this.props.hideCheckout && _react2.default.createElement(
	            PaymentButton,
	            {
	              onClick: function onClick() {
	                return _this6.state.skipStoredPayments ? _this6.openItransact() : _this6.startTransaction(_this6.state.selectedSource);
	              },
	              disabled: !this.state.loaded || !this.state.selectedSource && !this.state.skipStoredPayments || this.state.processingPayment,
	              error: this.state.prePaymentError,
	              disableErrorHandling: true,
	              bypassLoadingStyles: true,
	              loading: this.state.processingPayment
	            },
	            'Checkout'
	          ),
	          PAYMENT_PROCESSING_MESSAGE && this.state.processingPayment && _react2.default.createElement(
	            'div',
	            { className: 'payment-processing' },
	            PAYMENT_PROCESSING_MESSAGE
	          ),
	          this.state.description && _react2.default.createElement(_Markdown2.default, { source: this.state.description, className: 'markdown cart-description' }),
	          CHECKOUT_DISCLAIMER && _react2.default.createElement(_Markdown2.default, { source: CHECKOUT_DISCLAIMER, className: 'markdown' })
	        ) : _react2.default.createElement(_Loaders.Spinner, { color: '#7792d0', className: 'checkout-loader', size: 'small' }),
	        _react2.default.createElement(
	          _Portal2.default,
	          { isOpened: this.state.deletingPaymentType },
	          _react2.default.createElement(_Modal.ConfirmDialog, {
	            closeModal: this.toggleDeleting,
	            onModalClosed: function onModalClosed() {},
	            message: 'Are you sure you want to delete this payment method? Any active subscriptions using this payment method will be canceled. This cannot be undone.',
	            buttons: [{ label: 'No', onClick: function onClick() {}, className: 'btn-default' }, {
	              label: 'Yes',
	              onClick: this.deletePaymentType,
	              className: 'btn-danger'
	            }],
	            modalStyle: { borderRadius: 3 }
	          })
	        )
	      );
	    }
	  }]);
	
	  return ITransact;
	}(_react2.default.Component);
	
	var _initialiseProps = function _initialiseProps() {
	  var _this7 = this;
	
	  this.state = {
	    loaded: false,
	    token: null,
	    customer: null,
	    allowAddNewPaymentSource: true,
	    selectedSource: '',
	    deletingPaymentType: false,
	    reloadingPayment: false,
	    processingPayment: false,
	    checkoutButtonText: '',
	    modalTitle: '',
	    modalDescr: '',
	    additionalText: '',
	    apiUsername: '',
	    achEnabled: false,
	    error: null,
	    description: null,
	    skipStoredPayments: false
	  };
	  this.script = null;
	
	  this.componentDidMount = function () {
	    var promises = [];
	    if (!window.iTransact) {
	      _this7.script = document.createElement('script');
	      _this7.script.type = 'text/javascript';
	      _this7.script.src = 'https://js.itransact.com/itransact.js';
	      document.head.appendChild(_this7.script);
	      promises.push(new Promise(function (resolve, reject) {
	        _this7.script.onload = function (e) {
	          resolve();
	        };
	      }));
	    }
	    promises.push(new Promise(function (resolve, reject) {
	      (0, _requests.GET_PAYROC_CUSTOMER)(function (customer) {
	        // console.log(customer)
	        if (customer) {
	          _this7.setState({
	            customer: customer,
	            selectedSource: customer.payment_sources.length && !(true) ? customer.payment_sources[0].id : ''
	          });
	        }
	        resolve(customer);
	      }, function (err) {
	        console.error(err);
	        reject(err.message);
	      });
	    }));
	    promises.push(PASS_ITEM_GUIDS_ON_CHECKOUT ? new Promise(function (resolve, reject) {
	      (0, _requests.GET_WEB_USER_ACTIVE_CART)(function (cart) {
	        if (cart) {
	          _this7.setState({
	            checkoutButtonText: cart.WEB_CART_ADDITIONAL_PROPS.CHECKOUT_BUTTON_TEXT ? cart.WEB_CART_ADDITIONAL_PROPS.CHECKOUT_BUTTON_TEXT : 'Continue',
	            modalTitle: cart.WEB_CART_ADDITIONAL_PROPS.MODAL_TITLE ? cart.WEB_CART_ADDITIONAL_PROPS.MODAL_TITLE : 'Checkout',
	            modalDescr: cart.WEB_CART_ADDITIONAL_PROPS.MODAL_DESCR ? cart.WEB_CART_ADDITIONAL_PROPS.MODAL_DESCR : 'Enter billing address and payment information to proceed',
	            achEnabled: cart.WEB_CART_ADDITIONAL_PROPS.ACH_ENABLED_YN,
	            additionalText: cart.WEB_CART_ADDITIONAL_PROPS.CHECKOUT_SLIDER_ADDITIONAL_TEXT,
	            description: cart.WEB_CART_ADDITIONAL_PROPS.ITRANSACT_DESCRIPTION || null,
	            skipStoredPayments: cart.WEB_CART_ADDITIONAL_PROPS.SKIP_STORED_PAYMENTS || false
	          });
	        }
	        resolve(cart);
	      }, function (err) {
	        console.error(err);
	        reject(err.message);
	      });
	    }) : new Promise(function (resolve, reject) {
	      (0, _requests.GET_WEB_CART_BY_REF_NUM)(_this7.props.refNum, function (cart) {
	        if (cart) {
	          _this7.setState({
	            checkoutButtonText: cart.WEB_CART_ADDITIONAL_PROPS.CHECKOUT_BUTTON_TEXT ? cart.WEB_CART_ADDITIONAL_PROPS.CHECKOUT_BUTTON_TEXT : 'Continue',
	            modalTitle: cart.WEB_CART_ADDITIONAL_PROPS.MODAL_TITLE ? cart.WEB_CART_ADDITIONAL_PROPS.MODAL_TITLE : 'Checkout',
	            modalDescr: cart.WEB_CART_ADDITIONAL_PROPS.MODAL_DESCR ? cart.WEB_CART_ADDITIONAL_PROPS.MODAL_DESCR : 'Enter billing address and payment information to proceed',
	            achEnabled: cart.WEB_CART_ADDITIONAL_PROPS.ACH_ENABLED_YN,
	            additionalText: cart.WEB_CART_ADDITIONAL_PROPS.CHECKOUT_SLIDER_ADDITIONAL_TEXT,
	            description: cart.WEB_CART_ADDITIONAL_PROPS.ITRANSACT_DESCRIPTION || null,
	            skipStoredPayments: cart.WEB_CART_ADDITIONAL_PROPS.SKIP_STORED_PAYMENTS || false
	          });
	        }
	        resolve(cart);
	      }, function (err) {
	        console.error(err);
	        reject(err.message);
	      });
	    }));
	    promises.push(new Promise(function (resolve, reject) {
	      (0, _requests.GET_APP_SETTING_BY_NAME)('PAYROC_API_USERNAME', function (setting) {
	        if (setting) {
	          _this7.setState({
	            apiUsername: setting.VALUE
	          });
	        }
	        resolve(setting);
	      }, function (err) {
	        console.error(err);
	        reject(err.message);
	      });
	    }));
	    Promise.all(promises).then(function () {
	      _this7.setState({ loaded: true });
	    }).catch(function (err) {
	      _this7.setState({ error: err });
	    });
	  };
	
	  this.openItransact = function () {
	    if (!_this7.state.error) _this7.setState({ error: null });
	    var handler = window.iTransact.Checkout.init({
	      apiUsername: _this7.state.apiUsername,
	      name: _this7.state.modalTitle,
	      description: _this7.state.modalDescr,
	      panelButtonText: _this7.state.checkoutButtonText,
	      billingAddress: true,
	      ach: _this7.state.achEnabled,
	      onToken: function onToken(data, args) {
	        _this7.setState({ token: data.token, reloadingPayment: true });
	        (0, _requests.CREATE_PAYROC_CUSTOMER_PAYMENT_SOURCE)({
	          token: data.token,
	          address: args
	        }, function (result) {
	          if (_this7.state.skipStoredPayments) {
	            _this7.startTransaction(result.payment_sources[0].id, result.id);
	          } else {
	            if (result) {
	              (0, _requests.GET_PAYROC_CUSTOMER)(function (customer) {
	                if (customer) {
	                  _this7.setState({
	                    customer: customer,
	                    reloadingPayment: false,
	                    selectedSource: (customer.payment_sources[customer.payment_sources.length - 1] || {}).id || ''
	                  });
	                }
	              }, function (err) {
	                console.error(err);
	                _this7.setState({ reloadingPayment: false, error: err.message });
	              });
	            }
	          }
	        });
	      }
	    });
	    handler.render({
	      amount: _this7.props.amount
	    });
	  };
	
	  this.startTransaction = function (cardId, customerId) {
	    _this7.setState({ error: null, processingPayment: true });
	    (0, _requests.CREATE_PAYROC_TRANSACTION)({
	      id: cardId,
	      customerId: customerId,
	      ITEMIDS: _this7.props.receiptItemGuids,
	      REF_NUM: _this7.props.refNum
	    }, function (success) {
	      if (success) {
	        _this7.props.onComplete(PASS_ITEM_GUIDS_ON_CHECKOUT ? success : null);
	      }
	    }, function (err) {
	      console.error(err);
	      _this7.setState({ error: err.message, processingPayment: false });
	    });
	  };
	
	  this.startDelete = function (id) {
	    _this7.setState({ deletingId: id });
	    _this7.toggleDeleting();
	  };
	
	  this.deletePaymentType = function () {
	    (0, _requests.DELETE_PAYROC_CUSTOMER_PAYMENT_SOURCE)(_this7.state.deletingId, function () {
	      _this7.setState(function (state) {
	        var index = state.customer.payment_sources.findIndex(function (s) {
	          return state.deletingId === s.id;
	        });
	        return {
	          customer: Object.assign({}, state.customer, {
	            payment_sources: [].concat(_toConsumableArray(state.customer.payment_sources.slice(0, index)), _toConsumableArray(state.customer.payment_sources.slice(index + 1)))
	          }),
	          selectedSource: state.selectedSource === state.deletingId ? '' : state.selectedSource
	        };
	      });
	    }, function (err) {
	      console.error(err);
	      _this7.setState({ error: err.message });
	    });
	  };
	
	  this.toggleDeleting = function () {
	    return _this7.setState(function (s) {
	      return { deletingPaymentType: !s.deletingPaymentType };
	    });
	  };
	};

/***/ },
/* 68 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var CACHE = {
	  countries: []
	};
	
	var setCountryOptions = exports.setCountryOptions = function setCountryOptions(countries) {
	  CACHE.countries = countries;
	};
	
	var getCountryOptions = exports.getCountryOptions = function getCountryOptions() {
	  return CACHE.countries;
	};
	
	var rawStates = ["AK", "AL", "AR", "AS", "AZ", "CA", "CO", "CT", "DC", "DE", "FL", "FM", "GA", "GU", "HI", "IA", "ID", "IL", "IN", "KS", "KY", "LA", "MA", "ME", "MD", "MH", "MI", "MN", "MO", "MS", "MT", "NC", "ND", "NE", "NH", "NJ", "NM", "NV", "NY", "MP", "OH", "OK", "OR", "PA", "PR", "PW", "RI", "SC", "SD", "TX", "TN", "UT", "VA", "VI", "VT", "WA", "WI", "WV", "WY"];
	
	var inflate = function inflate() {
	  return rawStates.map(function (state) {
	    return { value: state, label: state };
	  });
	};
	var inflated = inflate();
	
	var stateOptions = exports.stateOptions = inflated;
	
	var STATE_ABBR = ("MT");
	
	var filteredStateOptions = exports.filteredStateOptions = inflated.filter(function (_ref) {
	  var value = _ref.value;
	  return value !== STATE_ABBR;
	});
	
	var getStateOptions = exports.getStateOptions = function getStateOptions() {
	  return stateOptions;
	};

/***/ },
/* 69 */
/***/ function(module, exports, __webpack_require__) {

	var freeGlobal = __webpack_require__(489);
	
	/** Detect free variable `self`. */
	var freeSelf = typeof self == 'object' && self && self.Object === Object && self;
	
	/** Used as a reference to the global object. */
	var root = freeGlobal || freeSelf || Function('return this')();
	
	module.exports = root;


/***/ },
/* 70 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	function checkDCE() {
	  /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */
	  if (
	    typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' ||
	    typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function'
	  ) {
	    return;
	  }
	  if (false) {
	    // This branch is unreachable because this function is only called
	    // in production, but the condition is true only in development.
	    // Therefore if the branch is still here, dead code elimination wasn't
	    // properly applied.
	    // Don't change the message. React DevTools relies on it. Also make sure
	    // this message doesn't occur elsewhere in this function, or it will cause
	    // a false positive.
	    throw new Error('^_^');
	  }
	  try {
	    // Verify that the code above has been dead code eliminated (DCE'd).
	    __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE(checkDCE);
	  } catch (err) {
	    // DevTools shouldn't crash React, no matter what.
	    // We should still report in case we break this code.
	    console.error(err);
	  }
	}
	
	if (true) {
	  // DCE check should happen before ReactDOM bundle executes so that
	  // DevTools can report bad minification during injection.
	  checkDCE();
	  module.exports = __webpack_require__(1292);
	} else {
	  module.exports = require('./cjs/react-dom.development.js');
	}


/***/ },
/* 71 */
/***/ function(module, exports, __webpack_require__) {

	var Map = __webpack_require__(383);
	var $export = __webpack_require__(4);
	var shared = __webpack_require__(134)('metadata');
	var store = shared.store || (shared.store = new (__webpack_require__(387))());
	
	var getOrCreateMetadataMap = function (target, targetKey, create) {
	  var targetMetadata = store.get(target);
	  if (!targetMetadata) {
	    if (!create) return undefined;
	    store.set(target, targetMetadata = new Map());
	  }
	  var keyMetadata = targetMetadata.get(targetKey);
	  if (!keyMetadata) {
	    if (!create) return undefined;
	    targetMetadata.set(targetKey, keyMetadata = new Map());
	  } return keyMetadata;
	};
	var ordinaryHasOwnMetadata = function (MetadataKey, O, P) {
	  var metadataMap = getOrCreateMetadataMap(O, P, false);
	  return metadataMap === undefined ? false : metadataMap.has(MetadataKey);
	};
	var ordinaryGetOwnMetadata = function (MetadataKey, O, P) {
	  var metadataMap = getOrCreateMetadataMap(O, P, false);
	  return metadataMap === undefined ? undefined : metadataMap.get(MetadataKey);
	};
	var ordinaryDefineOwnMetadata = function (MetadataKey, MetadataValue, O, P) {
	  getOrCreateMetadataMap(O, P, true).set(MetadataKey, MetadataValue);
	};
	var ordinaryOwnMetadataKeys = function (target, targetKey) {
	  var metadataMap = getOrCreateMetadataMap(target, targetKey, false);
	  var keys = [];
	  if (metadataMap) metadataMap.forEach(function (_, key) { keys.push(key); });
	  return keys;
	};
	var toMetaKey = function (it) {
	  return it === undefined || typeof it == 'symbol' ? it : String(it);
	};
	var exp = function (O) {
	  $export($export.S, 'Reflect', O);
	};
	
	module.exports = {
	  store: store,
	  map: getOrCreateMetadataMap,
	  has: ordinaryHasOwnMetadata,
	  get: ordinaryGetOwnMetadata,
	  set: ordinaryDefineOwnMetadata,
	  keys: ordinaryOwnMetadataKeys,
	  key: toMetaKey,
	  exp: exp
	};


/***/ },
/* 72 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	if (__webpack_require__(28)) {
	  var LIBRARY = __webpack_require__(82);
	  var global = __webpack_require__(17);
	  var fails = __webpack_require__(21);
	  var $export = __webpack_require__(4);
	  var $typed = __webpack_require__(177);
	  var $buffer = __webpack_require__(256);
	  var ctx = __webpack_require__(55);
	  var anInstance = __webpack_require__(87);
	  var propertyDesc = __webpack_require__(92);
	  var hide = __webpack_require__(40);
	  var redefineAll = __webpack_require__(93);
	  var toInteger = __webpack_require__(57);
	  var toLength = __webpack_require__(27);
	  var toIndex = __webpack_require__(381);
	  var toAbsoluteIndex = __webpack_require__(95);
	  var toPrimitive = __webpack_require__(64);
	  var has = __webpack_require__(46);
	  var classof = __webpack_require__(107);
	  var isObject = __webpack_require__(23);
	  var toObject = __webpack_require__(34);
	  var isArrayIter = __webpack_require__(242);
	  var create = __webpack_require__(89);
	  var getPrototypeOf = __webpack_require__(48);
	  var gOPN = __webpack_require__(90).f;
	  var getIterFn = __webpack_require__(258);
	  var uid = __webpack_require__(96);
	  var wks = __webpack_require__(26);
	  var createArrayMethod = __webpack_require__(61);
	  var createArrayIncludes = __webpack_require__(165);
	  var speciesConstructor = __webpack_require__(135);
	  var ArrayIterators = __webpack_require__(259);
	  var Iterators = __webpack_require__(108);
	  var $iterDetect = __webpack_require__(170);
	  var setSpecies = __webpack_require__(94);
	  var arrayFill = __webpack_require__(234);
	  var arrayCopyWithin = __webpack_require__(353);
	  var $DP = __webpack_require__(32);
	  var $GOPD = __webpack_require__(47);
	  var dP = $DP.f;
	  var gOPD = $GOPD.f;
	  var RangeError = global.RangeError;
	  var TypeError = global.TypeError;
	  var Uint8Array = global.Uint8Array;
	  var ARRAY_BUFFER = 'ArrayBuffer';
	  var SHARED_BUFFER = 'Shared' + ARRAY_BUFFER;
	  var BYTES_PER_ELEMENT = 'BYTES_PER_ELEMENT';
	  var PROTOTYPE = 'prototype';
	  var ArrayProto = Array[PROTOTYPE];
	  var $ArrayBuffer = $buffer.ArrayBuffer;
	  var $DataView = $buffer.DataView;
	  var arrayForEach = createArrayMethod(0);
	  var arrayFilter = createArrayMethod(2);
	  var arraySome = createArrayMethod(3);
	  var arrayEvery = createArrayMethod(4);
	  var arrayFind = createArrayMethod(5);
	  var arrayFindIndex = createArrayMethod(6);
	  var arrayIncludes = createArrayIncludes(true);
	  var arrayIndexOf = createArrayIncludes(false);
	  var arrayValues = ArrayIterators.values;
	  var arrayKeys = ArrayIterators.keys;
	  var arrayEntries = ArrayIterators.entries;
	  var arrayLastIndexOf = ArrayProto.lastIndexOf;
	  var arrayReduce = ArrayProto.reduce;
	  var arrayReduceRight = ArrayProto.reduceRight;
	  var arrayJoin = ArrayProto.join;
	  var arraySort = ArrayProto.sort;
	  var arraySlice = ArrayProto.slice;
	  var arrayToString = ArrayProto.toString;
	  var arrayToLocaleString = ArrayProto.toLocaleString;
	  var ITERATOR = wks('iterator');
	  var TAG = wks('toStringTag');
	  var TYPED_CONSTRUCTOR = uid('typed_constructor');
	  var DEF_CONSTRUCTOR = uid('def_constructor');
	  var ALL_CONSTRUCTORS = $typed.CONSTR;
	  var TYPED_ARRAY = $typed.TYPED;
	  var VIEW = $typed.VIEW;
	  var WRONG_LENGTH = 'Wrong length!';
	
	  var $map = createArrayMethod(1, function (O, length) {
	    return allocate(speciesConstructor(O, O[DEF_CONSTRUCTOR]), length);
	  });
	
	  var LITTLE_ENDIAN = fails(function () {
	    // eslint-disable-next-line no-undef
	    return new Uint8Array(new Uint16Array([1]).buffer)[0] === 1;
	  });
	
	  var FORCED_SET = !!Uint8Array && !!Uint8Array[PROTOTYPE].set && fails(function () {
	    new Uint8Array(1).set({});
	  });
	
	  var toOffset = function (it, BYTES) {
	    var offset = toInteger(it);
	    if (offset < 0 || offset % BYTES) throw RangeError('Wrong offset!');
	    return offset;
	  };
	
	  var validate = function (it) {
	    if (isObject(it) && TYPED_ARRAY in it) return it;
	    throw TypeError(it + ' is not a typed array!');
	  };
	
	  var allocate = function (C, length) {
	    if (!(isObject(C) && TYPED_CONSTRUCTOR in C)) {
	      throw TypeError('It is not a typed array constructor!');
	    } return new C(length);
	  };
	
	  var speciesFromList = function (O, list) {
	    return fromList(speciesConstructor(O, O[DEF_CONSTRUCTOR]), list);
	  };
	
	  var fromList = function (C, list) {
	    var index = 0;
	    var length = list.length;
	    var result = allocate(C, length);
	    while (length > index) result[index] = list[index++];
	    return result;
	  };
	
	  var addGetter = function (it, key, internal) {
	    dP(it, key, { get: function () { return this._d[internal]; } });
	  };
	
	  var $from = function from(source /* , mapfn, thisArg */) {
	    var O = toObject(source);
	    var aLen = arguments.length;
	    var mapfn = aLen > 1 ? arguments[1] : undefined;
	    var mapping = mapfn !== undefined;
	    var iterFn = getIterFn(O);
	    var i, length, values, result, step, iterator;
	    if (iterFn != undefined && !isArrayIter(iterFn)) {
	      for (iterator = iterFn.call(O), values = [], i = 0; !(step = iterator.next()).done; i++) {
	        values.push(step.value);
	      } O = values;
	    }
	    if (mapping && aLen > 2) mapfn = ctx(mapfn, arguments[2], 2);
	    for (i = 0, length = toLength(O.length), result = allocate(this, length); length > i; i++) {
	      result[i] = mapping ? mapfn(O[i], i) : O[i];
	    }
	    return result;
	  };
	
	  var $of = function of(/* ...items */) {
	    var index = 0;
	    var length = arguments.length;
	    var result = allocate(this, length);
	    while (length > index) result[index] = arguments[index++];
	    return result;
	  };
	
	  // iOS Safari 6.x fails here
	  var TO_LOCALE_BUG = !!Uint8Array && fails(function () { arrayToLocaleString.call(new Uint8Array(1)); });
	
	  var $toLocaleString = function toLocaleString() {
	    return arrayToLocaleString.apply(TO_LOCALE_BUG ? arraySlice.call(validate(this)) : validate(this), arguments);
	  };
	
	  var proto = {
	    copyWithin: function copyWithin(target, start /* , end */) {
	      return arrayCopyWithin.call(validate(this), target, start, arguments.length > 2 ? arguments[2] : undefined);
	    },
	    every: function every(callbackfn /* , thisArg */) {
	      return arrayEvery(validate(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined);
	    },
	    fill: function fill(value /* , start, end */) { // eslint-disable-line no-unused-vars
	      return arrayFill.apply(validate(this), arguments);
	    },
	    filter: function filter(callbackfn /* , thisArg */) {
	      return speciesFromList(this, arrayFilter(validate(this), callbackfn,
	        arguments.length > 1 ? arguments[1] : undefined));
	    },
	    find: function find(predicate /* , thisArg */) {
	      return arrayFind(validate(this), predicate, arguments.length > 1 ? arguments[1] : undefined);
	    },
	    findIndex: function findIndex(predicate /* , thisArg */) {
	      return arrayFindIndex(validate(this), predicate, arguments.length > 1 ? arguments[1] : undefined);
	    },
	    forEach: function forEach(callbackfn /* , thisArg */) {
	      arrayForEach(validate(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined);
	    },
	    indexOf: function indexOf(searchElement /* , fromIndex */) {
	      return arrayIndexOf(validate(this), searchElement, arguments.length > 1 ? arguments[1] : undefined);
	    },
	    includes: function includes(searchElement /* , fromIndex */) {
	      return arrayIncludes(validate(this), searchElement, arguments.length > 1 ? arguments[1] : undefined);
	    },
	    join: function join(separator) { // eslint-disable-line no-unused-vars
	      return arrayJoin.apply(validate(this), arguments);
	    },
	    lastIndexOf: function lastIndexOf(searchElement /* , fromIndex */) { // eslint-disable-line no-unused-vars
	      return arrayLastIndexOf.apply(validate(this), arguments);
	    },
	    map: function map(mapfn /* , thisArg */) {
	      return $map(validate(this), mapfn, arguments.length > 1 ? arguments[1] : undefined);
	    },
	    reduce: function reduce(callbackfn /* , initialValue */) { // eslint-disable-line no-unused-vars
	      return arrayReduce.apply(validate(this), arguments);
	    },
	    reduceRight: function reduceRight(callbackfn /* , initialValue */) { // eslint-disable-line no-unused-vars
	      return arrayReduceRight.apply(validate(this), arguments);
	    },
	    reverse: function reverse() {
	      var that = this;
	      var length = validate(that).length;
	      var middle = Math.floor(length / 2);
	      var index = 0;
	      var value;
	      while (index < middle) {
	        value = that[index];
	        that[index++] = that[--length];
	        that[length] = value;
	      } return that;
	    },
	    some: function some(callbackfn /* , thisArg */) {
	      return arraySome(validate(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined);
	    },
	    sort: function sort(comparefn) {
	      return arraySort.call(validate(this), comparefn);
	    },
	    subarray: function subarray(begin, end) {
	      var O = validate(this);
	      var length = O.length;
	      var $begin = toAbsoluteIndex(begin, length);
	      return new (speciesConstructor(O, O[DEF_CONSTRUCTOR]))(
	        O.buffer,
	        O.byteOffset + $begin * O.BYTES_PER_ELEMENT,
	        toLength((end === undefined ? length : toAbsoluteIndex(end, length)) - $begin)
	      );
	    }
	  };
	
	  var $slice = function slice(start, end) {
	    return speciesFromList(this, arraySlice.call(validate(this), start, end));
	  };
	
	  var $set = function set(arrayLike /* , offset */) {
	    validate(this);
	    var offset = toOffset(arguments[1], 1);
	    var length = this.length;
	    var src = toObject(arrayLike);
	    var len = toLength(src.length);
	    var index = 0;
	    if (len + offset > length) throw RangeError(WRONG_LENGTH);
	    while (index < len) this[offset + index] = src[index++];
	  };
	
	  var $iterators = {
	    entries: function entries() {
	      return arrayEntries.call(validate(this));
	    },
	    keys: function keys() {
	      return arrayKeys.call(validate(this));
	    },
	    values: function values() {
	      return arrayValues.call(validate(this));
	    }
	  };
	
	  var isTAIndex = function (target, key) {
	    return isObject(target)
	      && target[TYPED_ARRAY]
	      && typeof key != 'symbol'
	      && key in target
	      && String(+key) == String(key);
	  };
	  var $getDesc = function getOwnPropertyDescriptor(target, key) {
	    return isTAIndex(target, key = toPrimitive(key, true))
	      ? propertyDesc(2, target[key])
	      : gOPD(target, key);
	  };
	  var $setDesc = function defineProperty(target, key, desc) {
	    if (isTAIndex(target, key = toPrimitive(key, true))
	      && isObject(desc)
	      && has(desc, 'value')
	      && !has(desc, 'get')
	      && !has(desc, 'set')
	      // TODO: add validation descriptor w/o calling accessors
	      && !desc.configurable
	      && (!has(desc, 'writable') || desc.writable)
	      && (!has(desc, 'enumerable') || desc.enumerable)
	    ) {
	      target[key] = desc.value;
	      return target;
	    } return dP(target, key, desc);
	  };
	
	  if (!ALL_CONSTRUCTORS) {
	    $GOPD.f = $getDesc;
	    $DP.f = $setDesc;
	  }
	
	  $export($export.S + $export.F * !ALL_CONSTRUCTORS, 'Object', {
	    getOwnPropertyDescriptor: $getDesc,
	    defineProperty: $setDesc
	  });
	
	  if (fails(function () { arrayToString.call({}); })) {
	    arrayToString = arrayToLocaleString = function toString() {
	      return arrayJoin.call(this);
	    };
	  }
	
	  var $TypedArrayPrototype$ = redefineAll({}, proto);
	  redefineAll($TypedArrayPrototype$, $iterators);
	  hide($TypedArrayPrototype$, ITERATOR, $iterators.values);
	  redefineAll($TypedArrayPrototype$, {
	    slice: $slice,
	    set: $set,
	    constructor: function () { /* noop */ },
	    toString: arrayToString,
	    toLocaleString: $toLocaleString
	  });
	  addGetter($TypedArrayPrototype$, 'buffer', 'b');
	  addGetter($TypedArrayPrototype$, 'byteOffset', 'o');
	  addGetter($TypedArrayPrototype$, 'byteLength', 'l');
	  addGetter($TypedArrayPrototype$, 'length', 'e');
	  dP($TypedArrayPrototype$, TAG, {
	    get: function () { return this[TYPED_ARRAY]; }
	  });
	
	  // eslint-disable-next-line max-statements
	  module.exports = function (KEY, BYTES, wrapper, CLAMPED) {
	    CLAMPED = !!CLAMPED;
	    var NAME = KEY + (CLAMPED ? 'Clamped' : '') + 'Array';
	    var GETTER = 'get' + KEY;
	    var SETTER = 'set' + KEY;
	    var TypedArray = global[NAME];
	    var Base = TypedArray || {};
	    var TAC = TypedArray && getPrototypeOf(TypedArray);
	    var FORCED = !TypedArray || !$typed.ABV;
	    var O = {};
	    var TypedArrayPrototype = TypedArray && TypedArray[PROTOTYPE];
	    var getter = function (that, index) {
	      var data = that._d;
	      return data.v[GETTER](index * BYTES + data.o, LITTLE_ENDIAN);
	    };
	    var setter = function (that, index, value) {
	      var data = that._d;
	      if (CLAMPED) value = (value = Math.round(value)) < 0 ? 0 : value > 0xff ? 0xff : value & 0xff;
	      data.v[SETTER](index * BYTES + data.o, value, LITTLE_ENDIAN);
	    };
	    var addElement = function (that, index) {
	      dP(that, index, {
	        get: function () {
	          return getter(this, index);
	        },
	        set: function (value) {
	          return setter(this, index, value);
	        },
	        enumerable: true
	      });
	    };
	    if (FORCED) {
	      TypedArray = wrapper(function (that, data, $offset, $length) {
	        anInstance(that, TypedArray, NAME, '_d');
	        var index = 0;
	        var offset = 0;
	        var buffer, byteLength, length, klass;
	        if (!isObject(data)) {
	          length = toIndex(data);
	          byteLength = length * BYTES;
	          buffer = new $ArrayBuffer(byteLength);
	        } else if (data instanceof $ArrayBuffer || (klass = classof(data)) == ARRAY_BUFFER || klass == SHARED_BUFFER) {
	          buffer = data;
	          offset = toOffset($offset, BYTES);
	          var $len = data.byteLength;
	          if ($length === undefined) {
	            if ($len % BYTES) throw RangeError(WRONG_LENGTH);
	            byteLength = $len - offset;
	            if (byteLength < 0) throw RangeError(WRONG_LENGTH);
	          } else {
	            byteLength = toLength($length) * BYTES;
	            if (byteLength + offset > $len) throw RangeError(WRONG_LENGTH);
	          }
	          length = byteLength / BYTES;
	        } else if (TYPED_ARRAY in data) {
	          return fromList(TypedArray, data);
	        } else {
	          return $from.call(TypedArray, data);
	        }
	        hide(that, '_d', {
	          b: buffer,
	          o: offset,
	          l: byteLength,
	          e: length,
	          v: new $DataView(buffer)
	        });
	        while (index < length) addElement(that, index++);
	      });
	      TypedArrayPrototype = TypedArray[PROTOTYPE] = create($TypedArrayPrototype$);
	      hide(TypedArrayPrototype, 'constructor', TypedArray);
	    } else if (!fails(function () {
	      TypedArray(1);
	    }) || !fails(function () {
	      new TypedArray(-1); // eslint-disable-line no-new
	    }) || !$iterDetect(function (iter) {
	      new TypedArray(); // eslint-disable-line no-new
	      new TypedArray(null); // eslint-disable-line no-new
	      new TypedArray(1.5); // eslint-disable-line no-new
	      new TypedArray(iter); // eslint-disable-line no-new
	    }, true)) {
	      TypedArray = wrapper(function (that, data, $offset, $length) {
	        anInstance(that, TypedArray, NAME);
	        var klass;
	        // `ws` module bug, temporarily remove validation length for Uint8Array
	        // https://github.com/websockets/ws/pull/645
	        if (!isObject(data)) return new Base(toIndex(data));
	        if (data instanceof $ArrayBuffer || (klass = classof(data)) == ARRAY_BUFFER || klass == SHARED_BUFFER) {
	          return $length !== undefined
	            ? new Base(data, toOffset($offset, BYTES), $length)
	            : $offset !== undefined
	              ? new Base(data, toOffset($offset, BYTES))
	              : new Base(data);
	        }
	        if (TYPED_ARRAY in data) return fromList(TypedArray, data);
	        return $from.call(TypedArray, data);
	      });
	      arrayForEach(TAC !== Function.prototype ? gOPN(Base).concat(gOPN(TAC)) : gOPN(Base), function (key) {
	        if (!(key in TypedArray)) hide(TypedArray, key, Base[key]);
	      });
	      TypedArray[PROTOTYPE] = TypedArrayPrototype;
	      if (!LIBRARY) TypedArrayPrototype.constructor = TypedArray;
	    }
	    var $nativeIterator = TypedArrayPrototype[ITERATOR];
	    var CORRECT_ITER_NAME = !!$nativeIterator
	      && ($nativeIterator.name == 'values' || $nativeIterator.name == undefined);
	    var $iterator = $iterators.values;
	    hide(TypedArray, TYPED_CONSTRUCTOR, true);
	    hide(TypedArrayPrototype, TYPED_ARRAY, NAME);
	    hide(TypedArrayPrototype, VIEW, true);
	    hide(TypedArrayPrototype, DEF_CONSTRUCTOR, TypedArray);
	
	    if (CLAMPED ? new TypedArray(1)[TAG] != NAME : !(TAG in TypedArrayPrototype)) {
	      dP(TypedArrayPrototype, TAG, {
	        get: function () { return NAME; }
	      });
	    }
	
	    O[NAME] = TypedArray;
	
	    $export($export.G + $export.W + $export.F * (TypedArray != Base), O);
	
	    $export($export.S, NAME, {
	      BYTES_PER_ELEMENT: BYTES
	    });
	
	    $export($export.S + $export.F * fails(function () { Base.of.call(TypedArray, 1); }), NAME, {
	      from: $from,
	      of: $of
	    });
	
	    if (!(BYTES_PER_ELEMENT in TypedArrayPrototype)) hide(TypedArrayPrototype, BYTES_PER_ELEMENT, BYTES);
	
	    $export($export.P, NAME, proto);
	
	    setSpecies(NAME);
	
	    $export($export.P + $export.F * FORCED_SET, NAME, { set: $set });
	
	    $export($export.P + $export.F * !CORRECT_ITER_NAME, NAME, $iterators);
	
	    if (!LIBRARY && TypedArrayPrototype.toString != arrayToString) TypedArrayPrototype.toString = arrayToString;
	
	    $export($export.P + $export.F * fails(function () {
	      new TypedArray(1).slice();
	    }), NAME, { slice: $slice });
	
	    $export($export.P + $export.F * (fails(function () {
	      return [1, 2].toLocaleString() != new TypedArray([1, 2]).toLocaleString();
	    }) || !fails(function () {
	      TypedArrayPrototype.toLocaleString.call([1, 2]);
	    })), NAME, { toLocaleString: $toLocaleString });
	
	    Iterators[NAME] = CORRECT_ITER_NAME ? $nativeIterator : $iterator;
	    if (!LIBRARY && !CORRECT_ITER_NAME) hide(TypedArrayPrototype, ITERATOR, $iterator);
	  };
	} else module.exports = function () { /* empty */ };


/***/ },
/* 73 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = getTimezoneOffsetInMilliseconds;
	var MILLISECONDS_IN_MINUTE = 60000;
	
	function getDateMillisecondsPart(date) {
	  return date.getTime() % MILLISECONDS_IN_MINUTE;
	}
	/**
	 * Google Chrome as of 67.0.3396.87 introduced timezones with offset that includes seconds.
	 * They usually appear for dates that denote time before the timezones were introduced
	 * (e.g. for 'Europe/Prague' timezone the offset is GMT+00:57:44 before 1 October 1891
	 * and GMT+01:00:00 after that date)
	 *
	 * Date#getTimezoneOffset returns the offset in minutes and would return 57 for the example above,
	 * which would lead to incorrect calculations.
	 *
	 * This function returns the timezone offset in milliseconds that takes seconds in account.
	 */
	
	
	function getTimezoneOffsetInMilliseconds(dirtyDate) {
	  var date = new Date(dirtyDate.getTime());
	  var baseTimezoneOffset = Math.ceil(date.getTimezoneOffset());
	  date.setSeconds(0, 0);
	  var hasNegativeUTCOffset = baseTimezoneOffset > 0;
	  var millisecondsPartOfTimezoneOffset = hasNegativeUTCOffset ? (MILLISECONDS_IN_MINUTE + getDateMillisecondsPart(date)) % MILLISECONDS_IN_MINUTE : getDateMillisecondsPart(date);
	  return baseTimezoneOffset * MILLISECONDS_IN_MINUTE + millisecondsPartOfTimezoneOffset;
	}
	
	module.exports = exports.default;

/***/ },
/* 74 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = addDays;
	
	var _index = _interopRequireDefault(__webpack_require__(9));
	
	var _index2 = _interopRequireDefault(__webpack_require__(3));
	
	var _index3 = _interopRequireDefault(__webpack_require__(2));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name addDays
	 * @category Day Helpers
	 * @summary Add the specified number of days to the given date.
	 *
	 * @description
	 * Add the specified number of days to the given date.
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} date - the date to be changed
	 * @param {Number} amount - the amount of days to be added. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
	 * @returns {Date} the new date with the days added
	 * @throws {TypeError} 2 arguments required
	 *
	 * @example
	 * // Add 10 days to 1 September 2014:
	 * var result = addDays(new Date(2014, 8, 1), 10)
	 * //=> Thu Sep 11 2014 00:00:00
	 */
	function addDays(dirtyDate, dirtyAmount) {
	  (0, _index3.default)(2, arguments);
	  var date = (0, _index2.default)(dirtyDate);
	  var amount = (0, _index.default)(dirtyAmount);
	
	  if (isNaN(amount)) {
	    return new Date(NaN);
	  }
	
	  if (!amount) {
	    // If 0 days, no-op to avoid changing times in the hour before end of DST
	    return date;
	  }
	
	  date.setDate(date.getDate() + amount);
	  return date;
	}
	
	module.exports = exports.default;

/***/ },
/* 75 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = startOfWeek;
	
	var _index = _interopRequireDefault(__webpack_require__(3));
	
	var _index2 = _interopRequireDefault(__webpack_require__(9));
	
	var _index3 = _interopRequireDefault(__webpack_require__(2));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name startOfWeek
	 * @category Week Helpers
	 * @summary Return the start of a week for the given date.
	 *
	 * @description
	 * Return the start of a week for the given date.
	 * The result will be in the local timezone.
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} date - the original date
	 * @param {Object} [options] - an object with options.
	 * @param {Locale} [options.locale=defaultLocale] - the locale object. See [Locale]{@link https://date-fns.org/docs/Locale}
	 * @param {0|1|2|3|4|5|6} [options.weekStartsOn=0] - the index of the first day of the week (0 - Sunday)
	 * @returns {Date} the start of a week
	 * @throws {TypeError} 1 argument required
	 * @throws {RangeError} `options.weekStartsOn` must be between 0 and 6
	 *
	 * @example
	 * // The start of a week for 2 September 2014 11:55:00:
	 * var result = startOfWeek(new Date(2014, 8, 2, 11, 55, 0))
	 * //=> Sun Aug 31 2014 00:00:00
	 *
	 * @example
	 * // If the week starts on Monday, the start of the week for 2 September 2014 11:55:00:
	 * var result = startOfWeek(new Date(2014, 8, 2, 11, 55, 0), { weekStartsOn: 1 })
	 * //=> Mon Sep 01 2014 00:00:00
	 */
	function startOfWeek(dirtyDate, dirtyOptions) {
	  (0, _index3.default)(1, arguments);
	  var options = dirtyOptions || {};
	  var locale = options.locale;
	  var localeWeekStartsOn = locale && locale.options && locale.options.weekStartsOn;
	  var defaultWeekStartsOn = localeWeekStartsOn == null ? 0 : (0, _index2.default)(localeWeekStartsOn);
	  var weekStartsOn = options.weekStartsOn == null ? defaultWeekStartsOn : (0, _index2.default)(options.weekStartsOn); // Test if weekStartsOn is between 0 and 6 _and_ is not NaN
	
	  if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) {
	    throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
	  }
	
	  var date = (0, _index.default)(dirtyDate);
	  var day = date.getDay();
	  var diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;
	  date.setDate(date.getDate() - diff);
	  date.setHours(0, 0, 0, 0);
	  return date;
	}
	
	module.exports = exports.default;

/***/ },
/* 76 */
/***/ function(module, exports) {

	/**
	 * Checks if `value` is classified as an `Array` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
	 * @example
	 *
	 * _.isArray([1, 2, 3]);
	 * // => true
	 *
	 * _.isArray(document.body.children);
	 * // => false
	 *
	 * _.isArray('abc');
	 * // => false
	 *
	 * _.isArray(_.noop);
	 * // => false
	 */
	var isArray = Array.isArray;
	
	module.exports = isArray;


/***/ },
/* 77 */
/***/ function(module, exports) {

	// shim for using process in browser
	var process = module.exports = {};
	
	// cached from whatever global is present so that test runners that stub it
	// don't break things.  But we need to wrap it in a try catch in case it is
	// wrapped in strict mode code which doesn't define any globals.  It's inside a
	// function because try/catches deoptimize in certain engines.
	
	var cachedSetTimeout;
	var cachedClearTimeout;
	
	function defaultSetTimout() {
	    throw new Error('setTimeout has not been defined');
	}
	function defaultClearTimeout () {
	    throw new Error('clearTimeout has not been defined');
	}
	(function () {
	    try {
	        if (typeof setTimeout === 'function') {
	            cachedSetTimeout = setTimeout;
	        } else {
	            cachedSetTimeout = defaultSetTimout;
	        }
	    } catch (e) {
	        cachedSetTimeout = defaultSetTimout;
	    }
	    try {
	        if (typeof clearTimeout === 'function') {
	            cachedClearTimeout = clearTimeout;
	        } else {
	            cachedClearTimeout = defaultClearTimeout;
	        }
	    } catch (e) {
	        cachedClearTimeout = defaultClearTimeout;
	    }
	} ())
	function runTimeout(fun) {
	    if (cachedSetTimeout === setTimeout) {
	        //normal enviroments in sane situations
	        return setTimeout(fun, 0);
	    }
	    // if setTimeout wasn't available but was latter defined
	    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
	        cachedSetTimeout = setTimeout;
	        return setTimeout(fun, 0);
	    }
	    try {
	        // when when somebody has screwed with setTimeout but no I.E. maddness
	        return cachedSetTimeout(fun, 0);
	    } catch(e){
	        try {
	            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
	            return cachedSetTimeout.call(null, fun, 0);
	        } catch(e){
	            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
	            return cachedSetTimeout.call(this, fun, 0);
	        }
	    }
	
	
	}
	function runClearTimeout(marker) {
	    if (cachedClearTimeout === clearTimeout) {
	        //normal enviroments in sane situations
	        return clearTimeout(marker);
	    }
	    // if clearTimeout wasn't available but was latter defined
	    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
	        cachedClearTimeout = clearTimeout;
	        return clearTimeout(marker);
	    }
	    try {
	        // when when somebody has screwed with setTimeout but no I.E. maddness
	        return cachedClearTimeout(marker);
	    } catch (e){
	        try {
	            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
	            return cachedClearTimeout.call(null, marker);
	        } catch (e){
	            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
	            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
	            return cachedClearTimeout.call(this, marker);
	        }
	    }
	
	
	
	}
	var queue = [];
	var draining = false;
	var currentQueue;
	var queueIndex = -1;
	
	function cleanUpNextTick() {
	    if (!draining || !currentQueue) {
	        return;
	    }
	    draining = false;
	    if (currentQueue.length) {
	        queue = currentQueue.concat(queue);
	    } else {
	        queueIndex = -1;
	    }
	    if (queue.length) {
	        drainQueue();
	    }
	}
	
	function drainQueue() {
	    if (draining) {
	        return;
	    }
	    var timeout = runTimeout(cleanUpNextTick);
	    draining = true;
	
	    var len = queue.length;
	    while(len) {
	        currentQueue = queue;
	        queue = [];
	        while (++queueIndex < len) {
	            if (currentQueue) {
	                currentQueue[queueIndex].run();
	            }
	        }
	        queueIndex = -1;
	        len = queue.length;
	    }
	    currentQueue = null;
	    draining = false;
	    runClearTimeout(timeout);
	}
	
	process.nextTick = function (fun) {
	    var args = new Array(arguments.length - 1);
	    if (arguments.length > 1) {
	        for (var i = 1; i < arguments.length; i++) {
	            args[i - 1] = arguments[i];
	        }
	    }
	    queue.push(new Item(fun, args));
	    if (queue.length === 1 && !draining) {
	        runTimeout(drainQueue);
	    }
	};
	
	// v8 likes predictible objects
	function Item(fun, array) {
	    this.fun = fun;
	    this.array = array;
	}
	Item.prototype.run = function () {
	    this.fun.apply(null, this.array);
	};
	process.title = 'browser';
	process.browser = true;
	process.env = {};
	process.argv = [];
	process.version = ''; // empty string to avoid regexp issues
	process.versions = {};
	
	function noop() {}
	
	process.on = noop;
	process.addListener = noop;
	process.once = noop;
	process.off = noop;
	process.removeListener = noop;
	process.removeAllListeners = noop;
	process.emit = noop;
	process.prependListener = noop;
	process.prependOnceListener = noop;
	
	process.listeners = function (name) { return [] }
	
	process.binding = function (name) {
	    throw new Error('process.binding is not supported');
	};
	
	process.cwd = function () { return '/' };
	process.chdir = function (dir) {
	    throw new Error('process.chdir is not supported');
	};
	process.umask = function() { return 0; };


/***/ },
/* 78 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _class2, _temp;
	
	/* Decoraters */
	
	
	/* Utils */
	
	
	/* CSS */
	
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(20);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactDom = __webpack_require__(70);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _classnames = __webpack_require__(349);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _staticMethods = __webpack_require__(1348);
	
	var _staticMethods2 = _interopRequireDefault(_staticMethods);
	
	var _windowListener = __webpack_require__(1350);
	
	var _windowListener2 = _interopRequireDefault(_windowListener);
	
	var _customEvent = __webpack_require__(1345);
	
	var _customEvent2 = _interopRequireDefault(_customEvent);
	
	var _isCapture = __webpack_require__(1347);
	
	var _isCapture2 = _interopRequireDefault(_isCapture);
	
	var _getEffect = __webpack_require__(1346);
	
	var _getEffect2 = _interopRequireDefault(_getEffect);
	
	var _trackRemoval = __webpack_require__(1349);
	
	var _trackRemoval2 = _interopRequireDefault(_trackRemoval);
	
	var _getPosition = __webpack_require__(1353);
	
	var _getPosition2 = _interopRequireDefault(_getPosition);
	
	var _getTipContent = __webpack_require__(1354);
	
	var _getTipContent2 = _interopRequireDefault(_getTipContent);
	
	var _aria = __webpack_require__(1352);
	
	var _nodeListToArray = __webpack_require__(1355);
	
	var _nodeListToArray2 = _interopRequireDefault(_nodeListToArray);
	
	var _style = __webpack_require__(1351);
	
	var _style2 = _interopRequireDefault(_style);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ReactTooltip = (0, _staticMethods2.default)(_class = (0, _windowListener2.default)(_class = (0, _customEvent2.default)(_class = (0, _isCapture2.default)(_class = (0, _getEffect2.default)(_class = (0, _trackRemoval2.default)(_class = (_temp = _class2 = function (_Component) {
	  _inherits(ReactTooltip, _Component);
	
	  function ReactTooltip(props) {
	    _classCallCheck(this, ReactTooltip);
	
	    var _this = _possibleConstructorReturn(this, (ReactTooltip.__proto__ || Object.getPrototypeOf(ReactTooltip)).call(this, props));
	
	    _this.state = {
	      place: 'top', // Direction of tooltip
	      type: 'dark', // Color theme of tooltip
	      effect: 'float', // float or fixed
	      show: false,
	      border: false,
	      placeholder: '',
	      offset: {},
	      extraClass: '',
	      html: false,
	      delayHide: 0,
	      delayShow: 0,
	      event: props.event || null,
	      eventOff: props.eventOff || null,
	      currentEvent: null, // Current mouse event
	      currentTarget: null, // Current target of mouse event
	      ariaProps: (0, _aria.parseAria)(props), // aria- and role attributes
	      isEmptyTip: false,
	      disable: false
	    };
	
	    _this.bind(['showTooltip', 'updateTooltip', 'hideTooltip', 'globalRebuild', 'globalShow', 'globalHide', 'onWindowResize']);
	
	    _this.mount = true;
	    _this.delayShowLoop = null;
	    _this.delayHideLoop = null;
	    _this.intervalUpdateContent = null;
	    return _this;
	  }
	
	  /**
	   * For unify the bind and unbind listener
	   */
	
	
	  _createClass(ReactTooltip, [{
	    key: 'bind',
	    value: function bind(methodArray) {
	      var _this2 = this;
	
	      methodArray.forEach(function (method) {
	        _this2[method] = _this2[method].bind(_this2);
	      });
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _props = this.props,
	          insecure = _props.insecure,
	          resizeHide = _props.resizeHide;
	
	      if (insecure) {
	        this.setStyleHeader(); // Set the style to the <link>
	      }
	      this.bindListener(); // Bind listener for tooltip
	      this.bindWindowEvents(resizeHide); // Bind global event for static method
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(props) {
	      var ariaProps = this.state.ariaProps;
	
	      var newAriaProps = (0, _aria.parseAria)(props);
	
	      var isChanged = Object.keys(newAriaProps).some(function (props) {
	        return newAriaProps[props] !== ariaProps[props];
	      });
	      if (isChanged) {
	        this.setState({ ariaProps: newAriaProps });
	      }
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      this.mount = false;
	
	      this.clearTimer();
	
	      this.unbindListener();
	      this.removeScrollListener();
	      this.unbindWindowEvents();
	    }
	
	    /**
	     * Pick out corresponded target elements
	     */
	
	  }, {
	    key: 'getTargetArray',
	    value: function getTargetArray(id) {
	      var targetArray = void 0;
	      if (!id) {
	        targetArray = document.querySelectorAll('[data-tip]:not([data-for])');
	      } else {
	        var escaped = id.replace(/\\/g, '\\\\').replace(/"/g, '\\"');
	        targetArray = document.querySelectorAll('[data-tip][data-for="' + escaped + '"]');
	      }
	      // targetArray is a NodeList, convert it to a real array
	      return (0, _nodeListToArray2.default)(targetArray);
	    }
	
	    /**
	     * Bind listener to the target elements
	     * These listeners used to trigger showing or hiding the tooltip
	     */
	
	  }, {
	    key: 'bindListener',
	    value: function bindListener() {
	      var _this3 = this;
	
	      var _props2 = this.props,
	          id = _props2.id,
	          globalEventOff = _props2.globalEventOff;
	
	      var targetArray = this.getTargetArray(id);
	
	      targetArray.forEach(function (target) {
	        var isCaptureMode = _this3.isCapture(target);
	        var effect = _this3.getEffect(target);
	        if (target.getAttribute('currentItem') === null) {
	          target.setAttribute('currentItem', 'false');
	        }
	        _this3.unbindBasicListener(target);
	
	        if (_this3.isCustomEvent(target)) {
	          _this3.customBindListener(target);
	          return;
	        }
	
	        target.addEventListener('mouseenter', _this3.showTooltip, isCaptureMode);
	        if (effect === 'float') {
	          target.addEventListener('mousemove', _this3.updateTooltip, isCaptureMode);
	        }
	        target.addEventListener('mouseleave', _this3.hideTooltip, isCaptureMode);
	      });
	
	      // Global event to hide tooltip
	      if (globalEventOff) {
	        window.removeEventListener(globalEventOff, this.hideTooltip);
	        window.addEventListener(globalEventOff, this.hideTooltip, false);
	      }
	
	      // Track removal of targetArray elements from DOM
	      this.bindRemovalTracker();
	    }
	
	    /**
	     * Unbind listeners on target elements
	     */
	
	  }, {
	    key: 'unbindListener',
	    value: function unbindListener() {
	      var _this4 = this;
	
	      var _props3 = this.props,
	          id = _props3.id,
	          globalEventOff = _props3.globalEventOff;
	
	      var targetArray = this.getTargetArray(id);
	      targetArray.forEach(function (target) {
	        _this4.unbindBasicListener(target);
	        if (_this4.isCustomEvent(target)) _this4.customUnbindListener(target);
	      });
	
	      if (globalEventOff) window.removeEventListener(globalEventOff, this.hideTooltip);
	      this.unbindRemovalTracker();
	    }
	
	    /**
	     * Invoke this before bind listener and ummount the compont
	     * it is necessary to invloke this even when binding custom event
	     * so that the tooltip can switch between custom and default listener
	     */
	
	  }, {
	    key: 'unbindBasicListener',
	    value: function unbindBasicListener(target) {
	      var isCaptureMode = this.isCapture(target);
	      target.removeEventListener('mouseenter', this.showTooltip, isCaptureMode);
	      target.removeEventListener('mousemove', this.updateTooltip, isCaptureMode);
	      target.removeEventListener('mouseleave', this.hideTooltip, isCaptureMode);
	    }
	
	    /**
	     * When mouse enter, show the tooltip
	     */
	
	  }, {
	    key: 'showTooltip',
	    value: function showTooltip(e, isGlobalCall) {
	      var _this5 = this;
	
	      if (isGlobalCall) {
	        // Don't trigger other elements belongs to other ReactTooltip
	        var targetArray = this.getTargetArray(this.props.id);
	        var isMyElement = targetArray.some(function (ele) {
	          return ele === e.currentTarget;
	        });
	        if (!isMyElement || this.state.show) return;
	      }
	      // Get the tooltip content
	      // calculate in this phrase so that tip width height can be detected
	      var _props4 = this.props,
	          children = _props4.children,
	          multiline = _props4.multiline,
	          getContent = _props4.getContent;
	
	      var originTooltip = e.currentTarget.getAttribute('data-tip');
	      var isMultiline = e.currentTarget.getAttribute('data-multiline') || multiline || false;
	
	      // Generate tootlip content
	      var content = void 0;
	      if (getContent) {
	        if (Array.isArray(getContent)) {
	          content = getContent[0] && getContent[0]();
	        } else {
	          content = getContent();
	        }
	      }
	      var placeholder = (0, _getTipContent2.default)(originTooltip, children, content, isMultiline);
	      var isEmptyTip = typeof placeholder === 'string' && placeholder === '' || placeholder === null;
	
	      // If it is focus event or called by ReactTooltip.show, switch to `solid` effect
	      var switchToSolid = e instanceof window.FocusEvent || isGlobalCall;
	
	      // if it need to skip adding hide listener to scroll
	      var scrollHide = true;
	      if (e.currentTarget.getAttribute('data-scroll-hide')) {
	        scrollHide = e.currentTarget.getAttribute('data-scroll-hide') === 'true';
	      } else if (this.props.scrollHide != null) {
	        scrollHide = this.props.scrollHide;
	      }
	
	      // To prevent previously created timers from triggering
	      this.clearTimer();
	
	      this.setState({
	        placeholder: placeholder,
	        isEmptyTip: isEmptyTip,
	        place: e.currentTarget.getAttribute('data-place') || this.props.place || 'top',
	        type: e.currentTarget.getAttribute('data-type') || this.props.type || 'dark',
	        effect: switchToSolid && 'solid' || this.getEffect(e.currentTarget),
	        offset: e.currentTarget.getAttribute('data-offset') || this.props.offset || {},
	        html: e.currentTarget.getAttribute('data-html') ? e.currentTarget.getAttribute('data-html') === 'true' : this.props.html || false,
	        delayShow: e.currentTarget.getAttribute('data-delay-show') || this.props.delayShow || 0,
	        delayHide: e.currentTarget.getAttribute('data-delay-hide') || this.props.delayHide || 0,
	        border: e.currentTarget.getAttribute('data-border') ? e.currentTarget.getAttribute('data-border') === 'true' : this.props.border || false,
	        extraClass: e.currentTarget.getAttribute('data-class') || this.props.class || this.props.className || '',
	        disable: e.currentTarget.getAttribute('data-tip-disable') ? e.currentTarget.getAttribute('data-tip-disable') === 'true' : this.props.disable || false
	      }, function () {
	        if (scrollHide) _this5.addScrollListener(e);
	        _this5.updateTooltip(e);
	
	        if (getContent && Array.isArray(getContent)) {
	          _this5.intervalUpdateContent = setInterval(function () {
	            if (_this5.mount) {
	              var _getContent = _this5.props.getContent;
	
	              var _placeholder = (0, _getTipContent2.default)(originTooltip, _getContent[0](), isMultiline);
	              var _isEmptyTip = typeof _placeholder === 'string' && _placeholder === '';
	              _this5.setState({
	                placeholder: _placeholder,
	                isEmptyTip: _isEmptyTip
	              });
	            }
	          }, getContent[1]);
	        }
	      });
	    }
	
	    /**
	     * When mouse hover, updatetooltip
	     */
	
	  }, {
	    key: 'updateTooltip',
	    value: function updateTooltip(e) {
	      var _this6 = this;
	
	      var _state = this.state,
	          delayShow = _state.delayShow,
	          show = _state.show,
	          isEmptyTip = _state.isEmptyTip,
	          disable = _state.disable;
	      var afterShow = this.props.afterShow;
	      var placeholder = this.state.placeholder;
	
	      var delayTime = show ? 0 : parseInt(delayShow, 10);
	      var eventTarget = e.currentTarget;
	
	      if (isEmptyTip || disable) return; // if the tooltip is empty, disable the tooltip
	      var updateState = function updateState() {
	        if (Array.isArray(placeholder) && placeholder.length > 0 || placeholder) {
	          (function () {
	            var isInvisible = !_this6.state.show;
	            _this6.setState({
	              currentEvent: e,
	              currentTarget: eventTarget,
	              show: true
	            }, function () {
	              _this6.updatePosition();
	              if (isInvisible && afterShow) afterShow();
	            });
	          })();
	        }
	      };
	
	      clearTimeout(this.delayShowLoop);
	      if (delayShow) {
	        this.delayShowLoop = setTimeout(updateState, delayTime);
	      } else {
	        updateState();
	      }
	    }
	
	    /**
	     * When mouse leave, hide tooltip
	     */
	
	  }, {
	    key: 'hideTooltip',
	    value: function hideTooltip(e, hasTarget) {
	      var _this7 = this;
	
	      var _state2 = this.state,
	          delayHide = _state2.delayHide,
	          isEmptyTip = _state2.isEmptyTip,
	          disable = _state2.disable;
	      var afterHide = this.props.afterHide;
	
	      if (!this.mount) return;
	      if (isEmptyTip || disable) return; // if the tooltip is empty, disable the tooltip
	      if (hasTarget) {
	        // Don't trigger other elements belongs to other ReactTooltip
	        var targetArray = this.getTargetArray(this.props.id);
	        var isMyElement = targetArray.some(function (ele) {
	          return ele === e.currentTarget;
	        });
	        if (!isMyElement || !this.state.show) return;
	      }
	      var resetState = function resetState() {
	        var isVisible = _this7.state.show;
	        _this7.setState({
	          show: false
	        }, function () {
	          _this7.removeScrollListener();
	          if (isVisible && afterHide) afterHide();
	        });
	      };
	
	      this.clearTimer();
	      if (delayHide) {
	        this.delayHideLoop = setTimeout(resetState, parseInt(delayHide, 10));
	      } else {
	        resetState();
	      }
	    }
	
	    /**
	     * Add scroll eventlistener when tooltip show
	     * automatically hide the tooltip when scrolling
	     */
	
	  }, {
	    key: 'addScrollListener',
	    value: function addScrollListener(e) {
	      var isCaptureMode = this.isCapture(e.currentTarget);
	      window.addEventListener('scroll', this.hideTooltip, isCaptureMode);
	    }
	  }, {
	    key: 'removeScrollListener',
	    value: function removeScrollListener() {
	      window.removeEventListener('scroll', this.hideTooltip);
	    }
	
	    // Calculation the position
	
	  }, {
	    key: 'updatePosition',
	    value: function updatePosition() {
	      var _this8 = this;
	
	      var _state3 = this.state,
	          currentEvent = _state3.currentEvent,
	          currentTarget = _state3.currentTarget,
	          place = _state3.place,
	          effect = _state3.effect,
	          offset = _state3.offset;
	
	      var node = _reactDom2.default.findDOMNode(this);
	      var result = (0, _getPosition2.default)(currentEvent, currentTarget, node, place, effect, offset);
	
	      if (result.isNewState) {
	        // Switch to reverse placement
	        return this.setState(result.newState, function () {
	          _this8.updatePosition();
	        });
	      }
	      // Set tooltip position
	      node.style.left = result.position.left + 'px';
	      node.style.top = result.position.top + 'px';
	    }
	
	    /**
	     * Set style tag in header
	     * in this way we can insert default css
	     */
	
	  }, {
	    key: 'setStyleHeader',
	    value: function setStyleHeader() {
	      if (!document.getElementsByTagName('head')[0].querySelector('style[id="react-tooltip"]')) {
	        var tag = document.createElement('style');
	        tag.id = 'react-tooltip';
	        tag.innerHTML = _style2.default;
	        document.getElementsByTagName('head')[0].appendChild(tag);
	      }
	    }
	
	    /**
	     * CLear all kinds of timeout of interval
	     */
	
	  }, {
	    key: 'clearTimer',
	    value: function clearTimer() {
	      clearTimeout(this.delayShowLoop);
	      clearTimeout(this.delayHideLoop);
	      clearInterval(this.intervalUpdateContent);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _state4 = this.state,
	          placeholder = _state4.placeholder,
	          extraClass = _state4.extraClass,
	          html = _state4.html,
	          ariaProps = _state4.ariaProps,
	          disable = _state4.disable,
	          isEmptyTip = _state4.isEmptyTip;
	
	      var tooltipClass = (0, _classnames2.default)('__react_component_tooltip', { 'show': this.state.show && !disable && !isEmptyTip }, { 'border': this.state.border }, { 'place-top': this.state.place === 'top' }, { 'place-bottom': this.state.place === 'bottom' }, { 'place-left': this.state.place === 'left' }, { 'place-right': this.state.place === 'right' }, { 'type-dark': this.state.type === 'dark' }, { 'type-success': this.state.type === 'success' }, { 'type-warning': this.state.type === 'warning' }, { 'type-error': this.state.type === 'error' }, { 'type-info': this.state.type === 'info' }, { 'type-light': this.state.type === 'light' });
	
	      var Wrapper = this.props.wrapper;
	      if (ReactTooltip.supportedWrappers.indexOf(Wrapper) < 0) {
	        Wrapper = ReactTooltip.defaultProps.wrapper;
	      }
	
	      if (html) {
	        return _react2.default.createElement(Wrapper, _extends({ className: tooltipClass + ' ' + extraClass
	        }, ariaProps, {
	          'data-id': 'tooltip',
	          dangerouslySetInnerHTML: { __html: placeholder } }));
	      } else {
	        return _react2.default.createElement(
	          Wrapper,
	          _extends({ className: tooltipClass + ' ' + extraClass
	          }, ariaProps, {
	            'data-id': 'tooltip' }),
	          placeholder
	        );
	      }
	    }
	  }]);
	
	  return ReactTooltip;
	}(_react.Component), _class2.propTypes = {
	  children: _propTypes2.default.any,
	  place: _propTypes2.default.string,
	  type: _propTypes2.default.string,
	  effect: _propTypes2.default.string,
	  offset: _propTypes2.default.object,
	  multiline: _propTypes2.default.bool,
	  border: _propTypes2.default.bool,
	  insecure: _propTypes2.default.bool,
	  class: _propTypes2.default.string,
	  className: _propTypes2.default.string,
	  id: _propTypes2.default.string,
	  html: _propTypes2.default.bool,
	  delayHide: _propTypes2.default.number,
	  delayShow: _propTypes2.default.number,
	  event: _propTypes2.default.string,
	  eventOff: _propTypes2.default.string,
	  watchWindow: _propTypes2.default.bool,
	  isCapture: _propTypes2.default.bool,
	  globalEventOff: _propTypes2.default.string,
	  getContent: _propTypes2.default.any,
	  afterShow: _propTypes2.default.func,
	  afterHide: _propTypes2.default.func,
	  disable: _propTypes2.default.bool,
	  scrollHide: _propTypes2.default.bool,
	  resizeHide: _propTypes2.default.bool,
	  wrapper: _propTypes2.default.string
	}, _class2.defaultProps = {
	  insecure: true,
	  resizeHide: true,
	  wrapper: 'div'
	}, _class2.supportedWrappers = ['div', 'span'], _temp)) || _class) || _class) || _class) || _class) || _class) || _class;
	
	/* export default not fit for standalone, it will exports {default:...} */
	
	
	module.exports = ReactTooltip;

/***/ },
/* 79 */
/***/ function(module, exports) {

	module.exports = extend
	
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	
	function extend() {
	    var target = {}
	
	    for (var i = 0; i < arguments.length; i++) {
	        var source = arguments[i]
	
	        for (var key in source) {
	            if (hasOwnProperty.call(source, key)) {
	                target[key] = source[key]
	            }
	        }
	    }
	
	    return target
	}


/***/ },
/* 80 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _createIconComponent = _interopRequireDefault(__webpack_require__(5));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	var IconCaretUp = (0, _createIconComponent["default"])({
	  content: _react["default"].createElement("g", null, _react["default"].createElement("path", {
	    d: "M12.51 48.4a3.85 3.85 0 0 0 5.44 0l17-17 17 17a3.85 3.85 0 0 0 5.45 0 3.85 3.85 0 0 0 0-5.45L35 20.46 12.5 42.94a3.85 3.85 0 0 0 .01 5.46z"
	  })),
	  height: undefined,
	  width: undefined
	});
	IconCaretUp.displayName = 'IconCaretUp';
	var _default = IconCaretUp;
	exports["default"] = _default;

/***/ },
/* 81 */
/***/ function(module, exports, __webpack_require__) {

	// 22.1.3.31 Array.prototype[@@unscopables]
	var UNSCOPABLES = __webpack_require__(26)('unscopables');
	var ArrayProto = Array.prototype;
	if (ArrayProto[UNSCOPABLES] == undefined) __webpack_require__(40)(ArrayProto, UNSCOPABLES, {});
	module.exports = function (key) {
	  ArrayProto[UNSCOPABLES][key] = true;
	};


/***/ },
/* 82 */
/***/ function(module, exports) {

	module.exports = false;


/***/ },
/* 83 */
/***/ function(module, exports, __webpack_require__) {

	var META = __webpack_require__(96)('meta');
	var isObject = __webpack_require__(23);
	var has = __webpack_require__(46);
	var setDesc = __webpack_require__(32).f;
	var id = 0;
	var isExtensible = Object.isExtensible || function () {
	  return true;
	};
	var FREEZE = !__webpack_require__(21)(function () {
	  return isExtensible(Object.preventExtensions({}));
	});
	var setMeta = function (it) {
	  setDesc(it, META, { value: {
	    i: 'O' + ++id, // object ID
	    w: {}          // weak collections IDs
	  } });
	};
	var fastKey = function (it, create) {
	  // return primitive with prefix
	  if (!isObject(it)) return typeof it == 'symbol' ? it : (typeof it == 'string' ? 'S' : 'P') + it;
	  if (!has(it, META)) {
	    // can't set metadata to uncaught frozen object
	    if (!isExtensible(it)) return 'F';
	    // not necessary to add metadata
	    if (!create) return 'E';
	    // add missing metadata
	    setMeta(it);
	  // return object ID
	  } return it[META].i;
	};
	var getWeak = function (it, create) {
	  if (!has(it, META)) {
	    // can't set metadata to uncaught frozen object
	    if (!isExtensible(it)) return true;
	    // not necessary to add metadata
	    if (!create) return false;
	    // add missing metadata
	    setMeta(it);
	  // return hash weak collections IDs
	  } return it[META].w;
	};
	// add metadata on freeze-family methods calling
	var onFreeze = function (it) {
	  if (FREEZE && meta.NEED && isExtensible(it) && !has(it, META)) setMeta(it);
	  return it;
	};
	var meta = module.exports = {
	  KEY: META,
	  NEED: false,
	  fastKey: fastKey,
	  getWeak: getWeak,
	  onFreeze: onFreeze
	};


/***/ },
/* 84 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = differenceInCalendarDays;
	
	var _index = _interopRequireDefault(__webpack_require__(73));
	
	var _index2 = _interopRequireDefault(__webpack_require__(116));
	
	var _index3 = _interopRequireDefault(__webpack_require__(2));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MILLISECONDS_IN_DAY = 86400000;
	/**
	 * @name differenceInCalendarDays
	 * @category Day Helpers
	 * @summary Get the number of calendar days between the given dates.
	 *
	 * @description
	 * Get the number of calendar days between the given dates. This means that the times are removed
	 * from the dates and then the difference in days is calculated.
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} dateLeft - the later date
	 * @param {Date|Number} dateRight - the earlier date
	 * @returns {Number} the number of calendar days
	 * @throws {TypeError} 2 arguments required
	 *
	 * @example
	 * // How many calendar days are between
	 * // 2 July 2011 23:00:00 and 2 July 2012 00:00:00?
	 * var result = differenceInCalendarDays(
	 *   new Date(2012, 6, 2, 0, 0),
	 *   new Date(2011, 6, 2, 23, 0)
	 * )
	 * //=> 366
	 * // How many calendar days are between
	 * // 2 July 2011 23:59:00 and 3 July 2011 00:01:00?
	 * var result = differenceInCalendarDays(
	 *   new Date(2011, 6, 3, 0, 1),
	 *   new Date(2011, 6, 2, 23, 59)
	 * )
	 * //=> 1
	 */
	
	function differenceInCalendarDays(dirtyDateLeft, dirtyDateRight) {
	  (0, _index3.default)(2, arguments);
	  var startOfDayLeft = (0, _index2.default)(dirtyDateLeft);
	  var startOfDayRight = (0, _index2.default)(dirtyDateRight);
	  var timestampLeft = startOfDayLeft.getTime() - (0, _index.default)(startOfDayLeft);
	  var timestampRight = startOfDayRight.getTime() - (0, _index.default)(startOfDayRight); // Round the number of days to the nearest integer
	  // because the number of milliseconds in a day is not constant
	  // (e.g. it's different in the day of the daylight saving time clock shift)
	
	  return Math.round((timestampLeft - timestampRight) / MILLISECONDS_IN_DAY);
	}
	
	module.exports = exports.default;

/***/ },
/* 85 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.DragState = exports.useDragStore = exports.DragProvider = undefined;
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var dragContext = _react2.default.createContext();
	var initialState = {
	  isDragging: false,
	  draggingId: null,
	  draggingType: null,
	  dragData: null
	};
	
	var useDragState = function useDragState() {
	  var _React$useState = _react2.default.useState(initialState),
	      _React$useState2 = _slicedToArray(_React$useState, 2),
	      dragState = _React$useState2[0],
	      setDragState = _React$useState2[1];
	
	  return [dragState, {
	    startDrag: function startDrag(_ref) {
	      var id = _ref.id,
	          data = _ref.data,
	          type = _ref.type;
	
	      var newState = Object.assign({}, dragState, {
	        isDragging: true,
	        draggingId: id,
	        dragData: data,
	        draggingType: type
	      });
	      setDragState(newState);
	      return newState;
	    },
	    stopDrag: function stopDrag() {
	      var newState = Object.assign({}, dragState, {
	        isDragging: false,
	        dragData: null,
	        draggingId: null,
	        draggingType: null
	      });
	      setDragState(newState);
	      return newState;
	    }
	  }];
	};
	
	var DragProvider = exports.DragProvider = function DragProvider(_ref2) {
	  var children = _ref2.children;
	
	  var _useDragState = useDragState(),
	      _useDragState2 = _slicedToArray(_useDragState, 2),
	      dragState = _useDragState2[0],
	      dragFunctions = _useDragState2[1];
	
	  return _react2.default.createElement(
	    dragContext.Provider,
	    {
	      value: {
	        state: dragState,
	        dispatch: dragFunctions
	      }
	    },
	    children
	  );
	};
	
	var useDragStore = exports.useDragStore = function useDragStore() {
	  var dragStore = _react2.default.useContext(dragContext);
	  return dragStore;
	};
	
	var DragState = exports.DragState = function DragState(_ref3) {
	  var children = _ref3.children;
	
	  var dragStore = useDragStore();
	  return children(dragStore.state);
	};

/***/ },
/* 86 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Portal = __webpack_require__(12);
	
	var _Portal2 = _interopRequireDefault(_Portal);
	
	var _reactOnclickoutside = __webpack_require__(153);
	
	var _reactOnclickoutside2 = _interopRequireDefault(_reactOnclickoutside);
	
	var _focusTrapReact = __webpack_require__(193);
	
	var _focusTrapReact2 = _interopRequireDefault(_focusTrapReact);
	
	__webpack_require__(1440);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var FloatingMenu = function (_Component) {
	  _inherits(FloatingMenu, _Component);
	
	  function FloatingMenu(props) {
	    _classCallCheck(this, FloatingMenu);
	
	    var _this = _possibleConstructorReturn(this, (FloatingMenu.__proto__ || Object.getPrototypeOf(FloatingMenu)).call(this, props));
	
	    _this.componentWillReceiveProps = function (nextProps) {
	      if (_this.props.isOpen === false && nextProps.isOpen === true) {
	        _this.setState({
	          animation: nextProps.animationDirection === 'right' ? 'materialZoomInRight' : 'materialZoomIn',
	          closing: false
	        });
	      }
	    };
	
	    _this.requestClose = function () {
	      _this.setState({
	        animation: _this.props.animationDirection === 'right' ? 'materialZoomOutRight' : 'materialZoomOut',
	        closing: true
	      });
	    };
	
	    _this.state = {
	      animation: props.animationDirection === 'right' ? 'materialZoomInRight' : 'materialZoomIn',
	      closing: false
	    };
	    return _this;
	  }
	
	  _createClass(FloatingMenu, [{
	    key: 'render',
	
	    // getLeftValue = el => {
	    //   const pageWidth = window.innerWidth || document.body.clientWidth;
	    //   const leftPlusWidth = el.left + el.width;
	    //   console.log(pageWidth, leftPlusWidth);
	    //   if(leftPlusWidth > pageWidth){
	    //     return el - (leftPlusWidth - pageWidth)
	    //   }
	    //   return el.left
	    // }
	    value: function render() {
	      var _props = this.props,
	          _props$options = _props.options,
	          options = _props$options === undefined ? [] : _props$options,
	          alignTo = _props.alignTo,
	          align = _props.align,
	          alignScreenRight = _props.alignScreenRight,
	          isOpen = _props.isOpen,
	          onRequestClose = _props.onRequestClose,
	          className = _props.className,
	          _props$offsetTop = _props.offsetTop,
	          offsetTop = _props$offsetTop === undefined ? 0 : _props$offsetTop,
	          _props$offsetRight = _props.offsetRight,
	          offsetRight = _props$offsetRight === undefined ? 0 : _props$offsetRight;
	
	      var alignElement = alignTo ? alignTo.getBoundingClientRect() : null;
	      var menuStyle = alignElement ? {
	        left: alignScreenRight ? 'auto' : align === "right" ? alignElement.right - alignElement.width : alignElement.left,
	        right: alignScreenRight ? 0 + offsetRight : 'auto',
	        top: alignElement.top + offsetTop
	      } : {};
	      return _react2.default.createElement(
	        _Portal2.default,
	        { isOpened: isOpen },
	        _react2.default.createElement(MenuBody, {
	          animation: this.state.animation,
	          options: options,
	          className: className,
	          menuStyle: menuStyle,
	          requestClose: this.requestClose,
	          onMenuClosed: onRequestClose,
	          closing: this.state.closing
	        })
	      );
	    }
	  }]);
	
	  return FloatingMenu;
	}(_react.Component);
	
	exports.default = FloatingMenu;
	
	var MenuBody = function (_Component2) {
	  _inherits(MenuBody, _Component2);
	
	  function MenuBody() {
	    var _ref;
	
	    var _temp, _this2, _ret;
	
	    _classCallCheck(this, MenuBody);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this2 = _possibleConstructorReturn(this, (_ref = MenuBody.__proto__ || Object.getPrototypeOf(MenuBody)).call.apply(_ref, [this].concat(args))), _this2), _this2.state = {
	      activeItemIndex: 0
	    }, _this2.handleClickOutside = function () {
	      _this2.props.requestClose();
	    }, _this2.handleAnimationEnd = function () {
	      if (_this2.props.closing) {
	        _this2.props.onMenuClosed();
	      }
	    }, _this2.onItemClick = function (option) {
	      if (option.onClick) {
	        option.onClick(option);
	      }
	      _this2.props.requestClose();
	    }, _this2.unfocusAll = function () {
	      if (document.activeElement.tagName === 'BUTTON') {
	        document.activeElement.blur();
	      }
	    }, _this2.handleKeyDown = function (e) {
	      if (e.keyCode === 27) {
	        _this2.props.requestClose();
	      } else if (e.keyCode === 38) {
	        if (_this2.state.activeItemIndex > 0) {
	          _this2.setState(function (state) {
	            return {
	              activeItemIndex: state.activeItemIndex - 1
	            };
	          }, function () {
	            var focusable = document.getElementById('floating-menu-index-' + _this2.state.activeItemIndex);
	            if (focusable) {
	              focusable.focus();
	            }
	          });
	        }
	      } else if (e.keyCode === 40) {
	        if (_this2.state.activeItemIndex < _this2.props.options.length - 1) {
	          _this2.setState(function (state) {
	            return {
	              activeItemIndex: state.activeItemIndex + 1
	            };
	          }, function () {
	            var focusable = document.getElementById('floating-menu-index-' + _this2.state.activeItemIndex);
	            if (focusable) {
	              focusable.focus();
	            }
	          });
	        }
	      }
	    }, _temp), _possibleConstructorReturn(_this2, _ret);
	  }
	
	  _createClass(MenuBody, [{
	    key: 'render',
	    value: function render() {
	      var _this3 = this;
	
	      var _props2 = this.props,
	          menuStyle = _props2.menuStyle,
	          options = _props2.options,
	          animation = _props2.animation,
	          _props2$className = _props2.className,
	          className = _props2$className === undefined ? '' : _props2$className;
	
	      return _react2.default.createElement(
	        _focusTrapReact2.default,
	        {
	          focusTrapOptions: { clickOutsideDeactivates: true },
	          className: 'floating-menu ' + animation + ' ' + className,
	          onAnimationEnd: this.handleAnimationEnd,
	          style: menuStyle,
	          onKeyDown: this.handleKeyDown,
	          role: 'menu',
	          'aria-activedescendant': 'floating-menu-index-' + this.state.activeItemIndex
	        },
	        options.map(function (option, i) {
	          return _react2.default.createElement(MenuItem, Object.assign({}, option, {
	            onMouseEnter: _this3.unfocusAll,
	            onClick: function onClick() {
	              _this3.onItemClick(option);
	            },
	            index: i,
	            key: i
	          }));
	        })
	      );
	    }
	  }]);
	
	  return MenuBody;
	}(_react.Component);
	
	MenuBody = (0, _reactOnclickoutside2.default)(MenuBody);
	
	var MenuItem = function MenuItem(_ref2) {
	  var _ref2$label = _ref2.label,
	      label = _ref2$label === undefined ? '' : _ref2$label,
	      onClick = _ref2.onClick,
	      onMouseEnter = _ref2.onMouseEnter,
	      href = _ref2.href,
	      target = _ref2.target,
	      index = _ref2.index;
	  return href ? _react2.default.createElement(
	    'a',
	    { className: 'menu-item', href: href, onMouseEnter: onMouseEnter, target: target, id: 'floating-menu-index-' + index, role: 'menuitem' },
	    label
	  ) : _react2.default.createElement(
	    'button',
	    { className: 'menu-item', onClick: onClick, onMouseEnter: onMouseEnter, id: 'floating-menu-index-' + index, role: 'menuitem' },
	    label
	  );
	};

/***/ },
/* 87 */
/***/ function(module, exports) {

	module.exports = function (it, Constructor, name, forbiddenField) {
	  if (!(it instanceof Constructor) || (forbiddenField !== undefined && forbiddenField in it)) {
	    throw TypeError(name + ': incorrect invocation!');
	  } return it;
	};


/***/ },
/* 88 */
/***/ function(module, exports, __webpack_require__) {

	var ctx = __webpack_require__(55);
	var call = __webpack_require__(364);
	var isArrayIter = __webpack_require__(242);
	var anObject = __webpack_require__(15);
	var toLength = __webpack_require__(27);
	var getIterFn = __webpack_require__(258);
	var BREAK = {};
	var RETURN = {};
	var exports = module.exports = function (iterable, entries, fn, that, ITERATOR) {
	  var iterFn = ITERATOR ? function () { return iterable; } : getIterFn(iterable);
	  var f = ctx(fn, that, entries ? 2 : 1);
	  var index = 0;
	  var length, step, iterator, result;
	  if (typeof iterFn != 'function') throw TypeError(iterable + ' is not iterable!');
	  // fast case for arrays with default iterator
	  if (isArrayIter(iterFn)) for (length = toLength(iterable.length); length > index; index++) {
	    result = entries ? f(anObject(step = iterable[index])[0], step[1]) : f(iterable[index]);
	    if (result === BREAK || result === RETURN) return result;
	  } else for (iterator = iterFn.call(iterable); !(step = iterator.next()).done;) {
	    result = call(iterator, f, step.value, entries);
	    if (result === BREAK || result === RETURN) return result;
	  }
	};
	exports.BREAK = BREAK;
	exports.RETURN = RETURN;


/***/ },
/* 89 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
	var anObject = __webpack_require__(15);
	var dPs = __webpack_require__(370);
	var enumBugKeys = __webpack_require__(238);
	var IE_PROTO = __webpack_require__(251)('IE_PROTO');
	var Empty = function () { /* empty */ };
	var PROTOTYPE = 'prototype';
	
	// Create object with fake `null` prototype: use iframe Object with cleared prototype
	var createDict = function () {
	  // Thrash, waste and sodomy: IE GC bug
	  var iframe = __webpack_require__(237)('iframe');
	  var i = enumBugKeys.length;
	  var lt = '<';
	  var gt = '>';
	  var iframeDocument;
	  iframe.style.display = 'none';
	  __webpack_require__(240).appendChild(iframe);
	  iframe.src = 'javascript:'; // eslint-disable-line no-script-url
	  // createDict = iframe.contentWindow.Object;
	  // html.removeChild(iframe);
	  iframeDocument = iframe.contentWindow.document;
	  iframeDocument.open();
	  iframeDocument.write(lt + 'script' + gt + 'document.F=Object' + lt + '/script' + gt);
	  iframeDocument.close();
	  createDict = iframeDocument.F;
	  while (i--) delete createDict[PROTOTYPE][enumBugKeys[i]];
	  return createDict();
	};
	
	module.exports = Object.create || function create(O, Properties) {
	  var result;
	  if (O !== null) {
	    Empty[PROTOTYPE] = anObject(O);
	    result = new Empty();
	    Empty[PROTOTYPE] = null;
	    // add "__proto__" for Object.getPrototypeOf polyfill
	    result[IE_PROTO] = O;
	  } else result = createDict();
	  return Properties === undefined ? result : dPs(result, Properties);
	};


/***/ },
/* 90 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.2.7 / 15.2.3.4 Object.getOwnPropertyNames(O)
	var $keys = __webpack_require__(372);
	var hiddenKeys = __webpack_require__(238).concat('length', 'prototype');
	
	exports.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
	  return $keys(O, hiddenKeys);
	};


/***/ },
/* 91 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.2.14 / 15.2.3.14 Object.keys(O)
	var $keys = __webpack_require__(372);
	var enumBugKeys = __webpack_require__(238);
	
	module.exports = Object.keys || function keys(O) {
	  return $keys(O, enumBugKeys);
	};


/***/ },
/* 92 */
/***/ function(module, exports) {

	module.exports = function (bitmap, value) {
	  return {
	    enumerable: !(bitmap & 1),
	    configurable: !(bitmap & 2),
	    writable: !(bitmap & 4),
	    value: value
	  };
	};


/***/ },
/* 93 */
/***/ function(module, exports, __webpack_require__) {

	var redefine = __webpack_require__(41);
	module.exports = function (target, src, safe) {
	  for (var key in src) redefine(target, key, src[key], safe);
	  return target;
	};


/***/ },
/* 94 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var global = __webpack_require__(17);
	var dP = __webpack_require__(32);
	var DESCRIPTORS = __webpack_require__(28);
	var SPECIES = __webpack_require__(26)('species');
	
	module.exports = function (KEY) {
	  var C = global[KEY];
	  if (DESCRIPTORS && C && !C[SPECIES]) dP.f(C, SPECIES, {
	    configurable: true,
	    get: function () { return this; }
	  });
	};


/***/ },
/* 95 */
/***/ function(module, exports, __webpack_require__) {

	var toInteger = __webpack_require__(57);
	var max = Math.max;
	var min = Math.min;
	module.exports = function (index, length) {
	  index = toInteger(index);
	  return index < 0 ? max(index + length, 0) : min(index, length);
	};


/***/ },
/* 96 */
/***/ function(module, exports) {

	var id = 0;
	var px = Math.random();
	module.exports = function (key) {
	  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
	};


/***/ },
/* 97 */
/***/ function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(23);
	module.exports = function (it, TYPE) {
	  if (!isObject(it) || it._t !== TYPE) throw TypeError('Incompatible receiver, ' + TYPE + ' required!');
	  return it;
	};


/***/ },
/* 98 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = compareAsc;
	
	var _index = _interopRequireDefault(__webpack_require__(3));
	
	var _index2 = _interopRequireDefault(__webpack_require__(2));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name compareAsc
	 * @category Common Helpers
	 * @summary Compare the two dates and return -1, 0 or 1.
	 *
	 * @description
	 * Compare the two dates and return 1 if the first date is after the second,
	 * -1 if the first date is before the second or 0 if dates are equal.
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} dateLeft - the first date to compare
	 * @param {Date|Number} dateRight - the second date to compare
	 * @returns {Number} the result of the comparison
	 * @throws {TypeError} 2 arguments required
	 *
	 * @example
	 * // Compare 11 February 1987 and 10 July 1989:
	 * var result = compareAsc(new Date(1987, 1, 11), new Date(1989, 6, 10))
	 * //=> -1
	 *
	 * @example
	 * // Sort the array of dates:
	 * var result = [
	 *   new Date(1995, 6, 2),
	 *   new Date(1987, 1, 11),
	 *   new Date(1989, 6, 10)
	 * ].sort(compareAsc)
	 * //=> [
	 * //   Wed Feb 11 1987 00:00:00,
	 * //   Mon Jul 10 1989 00:00:00,
	 * //   Sun Jul 02 1995 00:00:00
	 * // ]
	 */
	function compareAsc(dirtyDateLeft, dirtyDateRight) {
	  (0, _index2.default)(2, arguments);
	  var dateLeft = (0, _index.default)(dirtyDateLeft);
	  var dateRight = (0, _index.default)(dirtyDateRight);
	  var diff = dateLeft.getTime() - dateRight.getTime();
	
	  if (diff < 0) {
	    return -1;
	  } else if (diff > 0) {
	    return 1; // Return 0 if diff is 0; return NaN if diff is NaN
	  } else {
	    return diff;
	  }
	}
	
	module.exports = exports.default;

/***/ },
/* 99 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = startOfISOWeek;
	
	var _index = _interopRequireDefault(__webpack_require__(75));
	
	var _index2 = _interopRequireDefault(__webpack_require__(2));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name startOfISOWeek
	 * @category ISO Week Helpers
	 * @summary Return the start of an ISO week for the given date.
	 *
	 * @description
	 * Return the start of an ISO week for the given date.
	 * The result will be in the local timezone.
	 *
	 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} date - the original date
	 * @returns {Date} the start of an ISO week
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // The start of an ISO week for 2 September 2014 11:55:00:
	 * var result = startOfISOWeek(new Date(2014, 8, 2, 11, 55, 0))
	 * //=> Mon Sep 01 2014 00:00:00
	 */
	function startOfISOWeek(dirtyDate) {
	  (0, _index2.default)(1, arguments);
	  return (0, _index.default)(dirtyDate, {
	    weekStartsOn: 1
	  });
	}
	
	module.exports = exports.default;

/***/ },
/* 100 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _DragContext = __webpack_require__(85);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	exports.default = function (_ref) {
	  var children = _ref.children,
	      onDragEnter = _ref.onDragEnter,
	      onDragExit = _ref.onDragExit,
	      onDrop = _ref.onDrop,
	      onDropAccepted = _ref.onDropAccepted,
	      disabled = _ref.disabled,
	      accepts = _ref.accepts,
	      rest = _objectWithoutProperties(_ref, ['children', 'onDragEnter', 'onDragExit', 'onDrop', 'onDropAccepted', 'disabled', 'accepts']);
	
	  var _useDragStore = (0, _DragContext.useDragStore)(),
	      state = _useDragStore.state;
	
	  var getIsAccepted = function getIsAccepted() {
	    var isAccepted = false;
	    if (accepts) {
	      if (Array.isArray(accepts)) {
	        if (accepts.includes(state.draggingType)) {
	          isAccepted = true;
	        }
	      } else {
	        if (state.draggingType === accepts) {
	          isAccepted = true;
	        }
	      }
	    } else {
	      isAccepted = true;
	    }
	    return isAccepted;
	  };
	
	  var handleDragEnter = function handleDragEnter() {
	    var isAccepted = getIsAccepted();
	    if (onDragEnter) {
	      onDragEnter(state.dragData, isAccepted);
	    }
	  };
	
	  var handleDragExit = function handleDragExit() {
	    var isAccepted = getIsAccepted();
	    if (onDragExit) {
	      onDragExit(state.dragData, isAccepted);
	    }
	  };
	
	  var handleDrop = function handleDrop() {
	    if (onDrop) {
	      onDrop(state.dragData);
	    }
	    var isAccepted = getIsAccepted();
	    if (isAccepted && onDropAccepted) {
	      onDropAccepted(state.dragData);
	    }
	  };
	
	  return _react2.default.createElement(
	    'div',
	    Object.assign({}, rest, {
	      onMouseEnter: state.isDragging && !disabled ? handleDragEnter : undefined,
	      onMouseLeave: state.isDragging && !disabled ? handleDragExit : undefined,
	      onMouseUp: state.isDragging && !disabled ? handleDrop : undefined
	    }),
	    children
	  );
	};

/***/ },
/* 101 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _focusTrapReact = __webpack_require__(193);
	
	var _focusTrapReact2 = _interopRequireDefault(_focusTrapReact);
	
	__webpack_require__(1469);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var SlidingPanel = function (_Component) {
	  _inherits(SlidingPanel, _Component);
	
	  function SlidingPanel() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, SlidingPanel);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = SlidingPanel.__proto__ || Object.getPrototypeOf(SlidingPanel)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      shadeAnimationClass: "fadeIn",
	      sliderAnimationClass: "slideInRight",
	      closing: false
	    }, _this.closingCallback = null, _this.closeSlider = function (callback) {
	      _this.setState({
	        shadeAnimationClass: "fadeOut",
	        sliderAnimationClass: "slideOutRight",
	        closing: true
	      });
	      _this.closingCallback = callback;
	    }, _this.transitionOver = function () {
	      if (_this.state.closing) {
	        _this.setState({ closing: false });
	        _this.props.closeSlider();
	        if (_this.closingCallback) {
	          _this.closingCallback();
	        }
	      }
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(SlidingPanel, [{
	    key: "render",
	    value: function render() {
	      var _props = this.props,
	          children = _props.children,
	          closeOnShadeClick = _props.closeOnShadeClick,
	          ariaLabel = _props.ariaLabel;
	
	      return _react2.default.createElement(
	        "aside",
	        { className: "sliding-panel-wrapper", "aria-label": ariaLabel },
	        _react2.default.createElement(
	          _focusTrapReact2.default,
	          {
	            focusTrapOptions: { clickOutsideDeactivates: true },
	            className: "sliding-panel animated fast-animation " + this.state.sliderAnimationClass,
	            id: "sliding-panel-scrollable",
	            role: "dialog",
	            "aria-label": "Your cart"
	          },
	          children
	        ),
	        _react2.default.createElement("div", {
	          className: "shade animated fast-animation " + this.state.shadeAnimationClass,
	          onAnimationEnd: this.transitionOver,
	          onClick: closeOnShadeClick !== false ? this.closeSlider : null
	        })
	      );
	    }
	  }]);
	
	  return SlidingPanel;
	}(_react.Component);
	
	exports.default = SlidingPanel;

/***/ },
/* 102 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.AddressBlock = undefined;
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(7);
	
	var _utilities = __webpack_require__(8);
	
	var _Field = __webpack_require__(25);
	
	var _Form = __webpack_require__(14);
	
	var _selectOptions = __webpack_require__(68);
	
	var _Portal = __webpack_require__(12);
	
	var _Portal2 = _interopRequireDefault(_Portal);
	
	var _Modal = __webpack_require__(13);
	
	var _AddressSelector = __webpack_require__(1154);
	
	var _AddressSelector2 = _interopRequireDefault(_AddressSelector);
	
	var _reactTooltip = __webpack_require__(78);
	
	var _reactTooltip2 = _interopRequireDefault(_reactTooltip);
	
	var _documentClone = __webpack_require__(331);
	
	var _documentClone2 = _interopRequireDefault(_documentClone);
	
	var _requests = __webpack_require__(6);
	
	var _validate = __webpack_require__(45);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var AddressBlock = exports.AddressBlock = function (_Component) {
	  _inherits(AddressBlock, _Component);
	
	  function AddressBlock(props) {
	    _classCallCheck(this, AddressBlock);
	
	    var _this = _possibleConstructorReturn(this, (AddressBlock.__proto__ || Object.getPrototypeOf(AddressBlock)).call(this, props));
	
	    _this.componentDidMount = function () {
	      if (_this.props.isFirst) {
	        _this.focus();
	      }
	    };
	
	    _this.setFieldValue = function (value, e) {
	      var val = Object.assign({}, _this.props.value);
	      val[e.target.name] = value;
	      _this.props.onChange(val, { target: { name: _this.props.name, value: val } });
	    };
	
	    _this.handleFieldBlur = function () {
	      // this.props.onBlur(this.props.value)
	    };
	
	    _this.toggleAddressSelect = function () {
	      _this.setState(function (state) {
	        return { modalOpen: !state.modalOpen };
	      });
	    };
	
	    _this.copyAddress = function (selectedAddress) {
	      _this.modal.closeModal();
	      var newAddress = Object.assign({}, selectedAddress);
	      if (_this.props.disableState) {
	        newAddress = Object.assign({}, newAddress, { STATE: _this.props.defaultState });
	      }
	      _this.props.onChange(newAddress, {});
	    };
	
	    _this.focus = function () {
	      _this.addr1.focus();
	    };
	
	    _this.handleStateBlur = function () {
	      if (_this.props.autoPopulateFromAMS && _this.props.value.STATE && _this.props.value.CITY && !_this.props.value.POSTAL_CODE) {
	        _this.populateAddressFromAMS();
	      }
	    };
	
	    _this.handleZipBlur = function () {
	      if (_this.props.autoPopulateFromAMS && _this.props.value.POSTAL_CODE && (!_this.props.value.STATE || !_this.props.value.CITY)) {
	        _this.populateAddressFromAMS();
	      }
	    };
	
	    _this.populateAddressFromAMS = function () {
	      (0, _requests.VALIDATE)('address', _this.props.value, function (data) {
	        var corrected = data.payload.corrected || {};
	        var newAddress = _this.props.value;
	        var update = false;
	        if (!_this.props.value.STATE && _this.props.value.STATE !== corrected.STATE && !_this.props.disableState) {
	          newAddress = Object.assign({}, newAddress, { STATE: corrected.STATE });
	          update = true;
	        }
	        if (!_this.props.value.CITY && _this.props.value.CITY !== corrected.CITY) {
	          newAddress = Object.assign({}, newAddress, { CITY: corrected.CITY });
	          update = true;
	        }
	        if (_this.props.value.POSTAL_CODE !== corrected.POSTAL_CODE && !_this.props.value.POSTAL_CODE) {
	          newAddress = Object.assign({}, newAddress, { POSTAL_CODE: corrected.POSTAL_CODE });
	          update = true;
	        }
	        if (update) {
	          _this.props.onChange(newAddress);
	        }
	      });
	    };
	
	    _this.setBypassChecked = function (checked) {
	      _this.setState({ isBypassAcknowledged: checked });
	      var _this$props = _this.props,
	          value = _this$props.value,
	          onChange = _this$props.onChange,
	          name = _this$props.name;
	
	      var updatedValue = Object.assign({}, value, { MAIL_ADDR_BYPASS_YN: checked ? 'Y' : 'N' });
	      onChange(updatedValue, { target: { name: name, value: updatedValue } });
	      _this.props.onChange(updatedValue, { target: { name: name, value: updatedValue } });
	    };
	
	    _this.state = {
	      modalOpen: false,
	      isBypassAcknowledged: props.value.MAIL_ADDR_BYPASS_YN === "Y"
	    };
	    return _this;
	  }
	
	  _createClass(AddressBlock, [{
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _props = this.props,
	          fieldId = _props.fieldId,
	          address1Label = _props.address1Label,
	          required = _props.required,
	          value = _props.value,
	          isValid = _props.isValid,
	          disableCountry = _props.disableCountry,
	          hideAttention = _props.hideAttention,
	          showCounty = _props.showCounty,
	          showCountry = _props.showCountry,
	          showCityStateZip = _props.showCityStateZip,
	          _props$showAddress = _props.showAddress3,
	          showAddress3 = _props$showAddress === undefined ? true : _props$showAddress,
	          disableState = _props.disableState,
	          disabled = _props.disabled,
	          hasAddresses = _props.hasAddresses,
	          allowSelection = _props.allowSelection,
	          singleColSize = _props.singleColSize,
	          _props$triColSizes = _props.triColSizes,
	          triColSizes = _props$triColSizes === undefined ? {} : _props$triColSizes,
	          excludeCurrentState = _props.excludeCurrentState,
	          _props$classNames = _props.classNames,
	          classNames = _props$classNames === undefined ? {} : _props$classNames,
	          defaultState = _props.defaultState,
	          bypassMessage = _props.bypassMessage,
	          primarybypassMessage = _props.primarybypassMessage,
	          mailbypassMessage = _props.mailbypassMessage;
	
	      var isValidClass = (0, _Field.getValidityClass)(isValid);
	
	      var valueIsNotEmptyOrNull = function valueIsNotEmptyOrNull(value) {
	        return value !== '' && value !== null && value !== undefined && (typeof value === 'undefined' ? 'undefined' : _typeof(value)) !== 'object' || value === 0 || value === '0';
	      };
	
	      var getTrimmedValue = function getTrimmedValue() {
	        var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
	        return !value ? '' : value.trim();
	      };
	
	      if (value.STATE == '' && defaultState !== '' && value.COUNTRY == '') {
	        value.COUNTRY = 'United States';
	      }
	      var isForeign = value.COUNTRY.toLowerCase() !== 'united states' && value.COUNTRY.toLowerCase() !== 'usa';
	
	      if (value.COUNTRY.toLowerCase() === 'united states') {
	        value.COUNTRY = 'United States';
	      }
	      var label = this.props.label || 'Address';
	      var showCityStateZipOnForeignAddress = ({"NODE_ENV":"production","BUILD_DATE":"2025-08-27T15:15:31.687Z","BUILD_NUMBER":"Not Provided","GIT_VERSION":"v1.3.0-381-ga81e29b08","GIT_COMMIT_HASH":"a81e29b085c9268ffd96c78eb734365802722741","GIT_BRANCH":"beta","PUBLIC_URL":"","STATE_ABBR":"MT","STATE_NAME":"Montana","STATE_ORG_TITLE":"Secretary of State","LOGIN_HEADER_IMG_PATH":"","HOME_IMG_FILENAME":"montana.jpg","FAVICON_FILE_NAME":"favicon.ico","ALLOW_E_SIGN_ON_CORRECTIONS":true,"THIRD_PARTY_SIGNING_ALLOWED":false,"MY_ACCOUNT_SAVE_AND_CLOSE_BUTTON":true,"IE_DEPRECATED_MESSAGE":"Internet Explorer is not supported. Please select a supported browser below to access this website.","ADDITIONAL_ROUTES":{"dataRequests":true,"farmBill":true,"apostille":true,"externalHelp":"https://sosmt.gov/business/help-center/","systemAdministration":[{"title":"Saved Payments","parameter":"saved-payments","componentName":"SavedPayments"}]},"SUBROUTES":[{"label":"Business","component":"Business","parameter":"business","myWorkQueueSearch":false,"sourceTypeId":54,"searchMustHaveOneOf":["FILING_TYPE_ID","STATUS_ID","STATE","search"],"serverWebSearchDescription":true,"serverWorkQueueDescription":true,"serverMyRecordsDescription":true,"searchPlaceholder":"Search by name or filing number (X########)","allowEmptySearchTerm":true,"requestCertificateAlternateLabel":"Request Information","fileAmendmentButtonLabel":"Filing Actions","advancedSearchParameters":[{"type":"radio","name":"QUERY_TYPE_ID","defaultValue":1010,"options":[{"value":1010,"label":"Starts with"},{"value":1011,"label":"Contains"},{"value":1012,"label":" Word Contains"}]},{"type":"serverSelect","name":"FILING_TYPE_ID","optionsSrc":"FILING_TYPES","label":"Entity Type","placeholder":"All","defaultValue":"0"},{"type":"serverSelect","name":"FILING_SUBTYPE_ID","optionsSrc":"FILING_SUBTYPES","label":"Entity Subtype","overrideSubOptionsSrcFromParameterName":"FILING_TYPE_ID","placeholder":"All","defaultValue":"0"},{"type":"serverSelect","name":"STATUS_ID","optionsSrc":"FILING_STATUS_WITHOUT_ALL","label":"Status","placeholder":"All","defaultValue":"0"},{"type":"serverSelect","name":"STATE","optionsSrc":"STATE","label":"State","placeholder":"All","defaultValue":""},{"type":"serverSelect","name":"COUNTY","optionsSrc":"COUNTY_SUBOPTION","label":"County","overrideSubOptionsSrcFromParameterName":"STATE","placeholder":"All","defaultValue":""},{"type":"checkbox","name":"CRA_SEARCH_YN","defaultValue":false,"label":"Search by Registered Agent PID"},{"type":"dateRange","name":"FILING_DATE","label":"Registration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}},{"type":"dateRange","name":"EXPIRATION_DATE","label":"Expiration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}}],"myRecordsFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Active"},{"value":2,"label":"Inactive"},{"value":3,"label":"Pending"}]},{"type":"dateRange","name":"DATE_RANGE","label":"Date range","defaultValue":{"start":null,"end":null}}],"myWorkQueueFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Approved"},{"value":2,"label":"Pending Online Payment"},{"value":3,"label":"Pending Review"},{"value":4,"label":"Needs Correction"},{"value":5,"label":"Rejected"},{"value":6,"label":"Draft"}]},{"type":"dateRange","name":"DATE_RANGE","label":"Date range","defaultValue":{"start":null,"end":null}}]},{"label":"Notary","component":"Notary","parameter":"notary","sourceTypeId":850,"myWorkQueueSearch":false,"allowEmptySearchTerm":true,"requestCertificateAlternateLabel":"Download Certificate","fileAmendmentButtonLabel":"Filing Actions","hideNameRequestCertificate":true,"hideAddressRequestCertificate":true,"hideRecordUserManagment":true,"searchPlaceholder":"Search by name or commission number","searchMustHaveOneOf":["CITY","search","SERVICE_TYPE"],"advancedParametersStartOpen":true,"searchIsSortable":true,"advancedSearchParameters":[{"type":"radio","name":"STARTS_WITH_YN","defaultValue":false,"options":[{"value":true,"label":"Starts with"},{"value":false,"label":"Contains"}]},{"type":"checkbox","name":"ACTIVE_ONLY_YN","defaultValue":true,"label":"Active entities only"},{"type":"text","name":"CITY","defaultValue":"","label":"City"},{"type":"select","name":"SERVICE_TYPE","label":"Special Services Offered","defaultValue":0,"options":[{"value":0,"label":"(N/A)"},{"value":6165,"label":"In-Person Electronic Notarization (IPEN)"},{"value":6166,"label":"Remote Online Notarization (RON)"},{"value":6167,"label":"Mobile Notary Services"},{"value":6168,"label":"Remote Ink Notarization (RIN)"}]}]},{"label":"Apostille","component":"Apostille","parameter":"apostille","sourceTypeId":720,"myRecordsSearch":false,"myWorkQueueSearch":false,"disabled":false,"allowedRoutes":["/forms-manager/","/queue/","/forms/"]},{"label":"Liens","component":"UCC","parameter":"ucc","sourceTypeId":1999,"myRecordsSearch":true,"myWorkQueueSearch":true,"fileAmendmentButtonLabel":"Filing Actions","searchPlaceholder":"Search by name or file number","disabled":false,"serverWebSearchDescription":true,"myRecordsDescription":"","workQueueDescription":"","searchDescription":"","hideRecordUserManagment":true,"searchLiensCheckout":false,"advancedSearchParameters":[{"type":"radio","name":"STARTS_WITH_YN","defaultValue":false,"options":[{"value":true,"label":"Starts with"},{"value":false,"label":"Contains"}]},{"type":"select","name":"STATUS","defaultValue":"ALL","label":"Status","options":[{"value":"ACTIVE_UNLAPSED","label":"Active (unlapsed)"},{"value":"ACTIVE_LAPSED_UNLAPSED","label":"Active (lapsed and unlapsed)"}]},{"type":"text","name":"EXCLUDE_VALUES","label":"Exclude Debtor Names (comma separated list of names to exclude)","defaultValue":""},{"type":"dateRange","name":"FILING_DATE","label":"Financing Statement Date","defaultValue":{"start":null,"end":null}},{"type":"dateRange","name":"LAPSE_DATE","label":"Lapse Date","defaultValue":{"start":null,"end":null}},{"type":"text","name":"CITY","label":"Debtor City","defaultValue":""}],"myRecordsFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Approved"},{"value":2,"label":"Pending Online Payment"},{"value":3,"label":"Pending Review"}]},{"type":"select","name":"TYPE","defaultValue":0,"label":"Lien Type","options":[{"value":0,"label":"All"},{"value":1,"label":"UCC"},{"value":2,"label":"EFS"},{"value":3,"label":"Title 71"}]}],"myWorkQueueFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Approved"},{"value":2,"label":"Pending Online Payment"},{"value":3,"label":"Pending Review"},{"value":4,"label":"Pending Print and Mail"},{"value":5,"label":"Rejected"},{"value":6,"label":"Draft"}]},{"type":"select","name":"TYPE","defaultValue":0,"label":"Lien Type","options":[{"value":0,"label":"All"},{"value":1,"label":"UCC"},{"value":2,"label":"EFS"},{"value":3,"label":"Title 71"}]}]},{"label":"Copy Request","component":"copies","parameter":"copies","sourceTypeId":2001,"myRecordsSearch":false,"myWorkQueueSearch":false,"disabled":false,"allowedRoutes":["/forms-manager/","/queue/","/forms/"]},{"label":"Trademark","component":"Trademark","parameter":"trademark","sourceTypeId":810,"showRequestCertificate":true,"searchMustHaveOneOf":["search","EXPIRATION_DATE","FILING_DATE"],"allowEmptySearchTerm":true,"requestCertificateAlternateLabel":"Request Information","fileAmendmentButtonLabel":"Filing Actions","advancedSearchParameters":[{"type":"radio","name":"QUERY_TYPE_ID","defaultValue":1010,"options":[{"value":1010,"label":"Starts with"},{"value":1011,"label":"Contains"},{"value":1012,"label":" Word Contains"}]},{"type":"checkbox","name":"OWNER_SEARCH_YN","defaultValue":false,"label":"Search owners"},{"type":"radio","name":"SERVICE_MARK_YN","label":"Mark Type","defaultValue":"","options":[{"value":"","label":"All Marks"},{"value":"Y","label":"Service Mark"},{"value":"N","label":"Trademark"}]},{"type":"serverSelect","name":"STATUS_ID","optionsSrc":"TYPE_V|TRADEMARK_STATUS_TYPE","label":"Status","placeholder":"All","defaultValue":"0"},{"type":"select","name":"DESIGN_TYPE_ID","options":[{"value":0,"label":"All"},{"value":990,"label":"Words Only"},{"value":991,"label":"Design Only"},{"value":992,"label":"Words and Design"}],"label":"Design Type","defaultValue":"0"},{"type":"dateRange","name":"FILING_DATE","label":"Registered Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}},{"type":"dateRange","name":"EXPIRATION_DATE","label":"Expiration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}}]},{"label":"Business Info Request","component":"InfoRequests","parameter":"info-request","sourceTypeId":167,"allowedRoutes":["/forms-manager/","/queue/","/forms/"]},{"label":"Data Requests","component":"DataRequests","parameter":"data-request","sourceTypeId":0,"allowedRoutes":["/forms-manager/"]},{"label":"CRA","component":"CRA","parameter":"cra","sourceTypeId":157,"myRecordsSearch":false,"searchPlaceholder":"Search by name or registered agent number","allowedRoutes":["/forms-manager/","/forms/","/records/","/queue/","/search/"],"allowEmptySearchTerm":true,"fileAmendmentButtonLabel":"Filing Actions","advancedSearchParameters":[{"type":"radio","name":"QUERY_TYPE_ID","defaultValue":1010,"options":[{"value":1010,"label":"Starts with"},{"value":1011,"label":"Contains"},{"value":1012,"label":" Word Contains"}]},{"type":"dateRange","name":"CRA_DATE","label":"Registration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}},{"type":"select","name":"STATUS_ID","label":"Status","defaultValue":0,"options":[{"value":0,"label":"All"},{"value":121,"label":"Active"},{"value":122,"label":"Inactive"}]},{"type":"select","name":"AGENT_TYPE_ID","label":"Agent Type","defaultValue":0,"options":[{"value":0,"label":"All"},{"value":460,"label":"Registered Agent"},{"value":461,"label":"Commercial Registered Agent"}]}]},{"label":"Farm Bill","component":"FarmBill","parameter":"farm-bill","path":"/lists/farm-bill","sourceTypeId":0,"myRecordsSearch":false,"allowedRules":["/search/"],"disabled":true,"searchDescription":"To perform a search, enter a debtor name. Your search results may include: exact debtor name, variations of that name and any filing that includes your search criteria. Punctuation is ignored.\n\nYou can click on \"Advanced\" to refine your search. Under “Advanced” you can search by crop, year, county and SSN/FEIN. As a registered Farm Bill Buyer with the Montana Secretary of State’s office it is important to maintain the confidentiality of the information contained within the Farm Bill Master List. The Farm Bill Master List reflects personal data, such as Social Security Numbers, which are a key piece of personal identifiable information to assist you in determining the existence of a lien against a specific debtor. The distribution of this information beyond its intended purpose is strictly prohibited.\n\nThe debtor's tax identification number has been hidden for confidentiality reasons. You may continue to search on a tax ID number and return debtors that match your search criteria. The SSN/FEIN must be entered without dashes or spaces.","searchMustHaveOneOf":["search","UCC_FARM_PRODUCT_ID","COUNTY"],"searchPlaceholder":"Search by debtor name","advancedSearchParameters":[{"type":"ServerMultiComplete","label":"Product code name(s)","name":"UCC_FARM_PRODUCT_ID","defaultValue":"","optionsSrc":"UCC_FARM_PRODUCT_V"},{"type":"MultiComplete","label":"Year or Range of Years","name":"YEAR_NUM","optionsSrc":"years","startYear":"1968","defaultValue":[],"preMergeOptions":[{"value":"ALL","label":"All"}]},{"type":"serverSelect","label":"State","name":"STATE","defaultValue":"MONTANA","optionsSrc":"STATE"},{"type":"ServerMultiComplete","label":"County","name":"COUNTY","defaultValue":[],"optionsSrc":"COUNTY","overrideSubOptionsSrcFromParameterName":"STATE"},{"type":"checkbox","name":"TIN_SEARCH_YN","defaultValue":false,"label":"Tax Identification Number Search"},{"type":"checkbox","name":"TIN_SORT_YN","defaultValue":false,"label":"Unique ID Sort"}]}],"SYSTEM_NICKNAME":"Online Services Portal","PAYMENT_METHODS":[{"type":"bypass"},{"type":"iTransact"}],"PAYMENT_ALLOW_AMEX":true,"SYSTEM_ID_LABEL":"System Id","DOUBLE_COLUMN_PUBLIC_LOGIN":true,"INTERNAL_USER_MANAGEMENT":true,"ALLOW_PUBLIC_JSON_IMPORT":false,"MAX_FILE_UPLOAD_SIZE":10000000,"REFUND_TEXT":"","RETURN_TO_HOME_ON_LOGOUT":true,"CURRENT_SOS_NAME":"Christi Jacobsen","LOGO_FILENAME":"mt-sos-logo.png","LOGO_ALT":"Christi Jacobsen, Montana Secretary of State","LOGO_FULL_WIDTH":true,"HOME_HIDE_AUTH_HINT":true,"HOME_TITLE":"Montana Secretary of State","CUSTOM_TAB_TITLE":"Official Montana","HOME_SUBTITLE":"Online Business Services","ENTITY_NAME_CONSENT_DESCRIPTION":"","ALLOW_USER_PROFILE_EDITING":true,"COMPARE_FOREIGN_NAME_IN_ENTITY_NAME_VALIDATION":true,"FOREIGN_NAME_FIELD_NAME":"KIMA_PARENT_NAME_INFO","LOGIN_TITLE":"Montana Secretary of State Online Filing Portal Login","PUBLIC_LOGIN_LABEL":"Username","REVERSE_LOGIN_COLUMNS":true,"LOGIN_SEAL_FILENAME":"seal_white.png","SEPARATE_USERNAME_AND_EMAIL":true,"CREATE_ACCOUNT_BUTTON_ALIGN_LEFT":true,"CREATE_ACCOUNT_BUTTON_TEXT":"CREATE AN ACCOUNT","PASSWORD_CUSTOM_ERROR_TEXT":"The password must meet all requirements","ACCOUNT_CREATED_MESSAGE":"Please check your email to verify your account to login and allow a few minutes for this message to arrive. Check your junk/spam folders if you do not find the email in your inbox.","PUBLIC_LOGIN_PLACEHOLDER":" ","DISABLE_DEFAULT_PAYMENT_RADIO":true,"CUSTOM_RESET_PASSWORD_ERROR_MESSAGE":"Username invalid - no account found","PUBLIC_LOGIN_CREATE_DESCRIPTION":"### Existing User:\n\n  - Enter your username and password to login.  \n\n\n  #### - OR -  \n\n\n\n  - Forgot password? Click 'Reset Password' and follow the prompts.\n  - Forgot username? Click 'Forgot Username' and follow the prompts.  \n\n\n  ### New User:\n  ","LOGIN_HELP_LINK":"https://sosmt.gov/business/how-do-i/","LOGIN_HELP_LINK_TEXT":"Need Help?","FORGOT_USERNAME_TEXT":"Forgot Username?","LOGIN_ACTIVE_DIRECTORY_TEXT":"State User Login","MULTIPLE_LOGIN_METHODS":true,"HAS_ACTIVE_DIRECTORY_LOGIN":true,"RESET_PASSWORD_WITH_USERNAME":true,"DOWNLOAD_LINK":true,"SHOW_USERNAME_ACCOUNT_CREATE":true,"SHOW_SCROLL_DOWN_ARROW":true,"SHOW_ADDRESS_ACCOUNT_CREATE":true,"TWO_COLUMN_ACCOUNT_CREATE":true,"RESET_PASSWORD_TIP":"A link to change your password has been sent to your email. Please allow a few minutes for this message to arrive. Please check your junk/spam folders if you do not find the email in your inbox.","FORGOT_PASSWORD_LINK_TEXT":"Reset Password","PHONE_NUMBER_OPTIONAL_ACCOUNT_CREATE":true,"SHOW_REQUIRED_INDICATOR_ACCOUNT_CREATE":true,"PASSWORD_REQUIREMENTS_ACCOUNT_CREATE":"\n    <ul>\n      <li>MUST contain at least 8 characters (12+ recommended)</li>\n      <li>MUST contain at least one uppercase letter.</li>\n      <li>MUST contain at least one lowercase letter.</li>\n      <li>MUST contain at least one number.</li>\n      <li>MUST contain at least one special character (!”#$%&'()*+,-./:;<=>?</li>\n    </ul>\n  ","ALLOW_CERTIFICATION_REQUEST":true,"ALLOW_PUBLIC_CERTIFICATE_REQUEST":true,"ALLOW_COPY_REQUEST":false,"ALLOW_CORRECTION_STYLING":true,"HIDE_DEPRECATION_WARNING":false,"AMEND_ROUTE_PUBLIC":true,"SEAL_FILENAME":"seal.png","SHOPPING_CART":true,"ALLOW_PAYMENT_UPDATE_WITH_EMPTY_CART":true,"RA_EMAIL":true,"RA_WEBSITE":true,"RA_NO_DEFAULT_TYPE":true,"RA_ADDRESS_LABEL":"Street Address","RA_TYPE_SELECTION_DEFAULT":true,"RA_DEFAULT_TYPE":"460","RA_OVERRIDE_TYPE_WITH_DEFAULT":true,"RA_PRINCIPAL_ADDRESS_AMS":true,"UPLOAD_AND_SUBMIT_HIDE_IF_ONE_OPTION":true,"PAYMENT_PROCESSING_MESSAGE":"Your payment is processing - Do not close your browser or click the back button","CHECKOUT_BUTTON_WHEN_PROCESSING_TEXT":"Processing","EFS_CROP_PICKER_NONE_LABEL":"Lien Duration","DISALLOWED_WIZARD_PIECES":["FormationLocale"],"REPEATER_SHOW_EDIT_BUTTON":true,"DATA_REQUEST_PAGE_TITLE":"Data Requests and Subscriptions","DATA_REQUEST_SIDEBAR_LABEL":"Data Requests & Subscriptions","LOGIN_REDIRECTS_TO_EPASS":false,"LOGIN_REDIRECTS_TO_ACTIVE_DIRECTORY":true,"LOGIN_ACTIVE_DIRECTORY_LINK":true,"FETCH_EDIT_USER_LINK":false,"LISTS_FETCH_AVAILABLE_LISTS":true,"POST_WIZARD_SUBMIT_REDIRECT_URL":"/","PIN_REQUEST_ATTESTATIONS":true,"PIN_REQUEST_DESCRIPTION":"Click **Request PIN** to have a new PIN sent to the account holder's email address on file.","OWNERSHIP_REQUEST_DESCRIPTION":"To become an **authorized user** of this record, a current **AUTHORIZED USER** will need to grant you access. To request access, click **Request Access** below.","PIN_REQUEST_SUCCESS_MESSAGE":"The PIN you have requested for this entity has been sent to the email associated with your user account.  You should receive the PIN in approximately 3-5 minutes, depending on your email service provider.","APOSTILLE_HEADER_LABEL":"Verification Information","APOSTILLE_NUMBER_LABEL":"Apostille/Authentication","APOSTILLE_CITY_STATE_OVERRIDE":"HELENA, MT","APOSTILLE_FILING_DATE_LABEL":"Issue Date","APOSTILLE_CITY_STATE_IN_CERTIFIED":true,"NOTARY_EXISTING_FILING":true,"ALLOW_REVOKE_OWN_ACCESS_ONLY":false,"HIDE_CANCEL_ON_ONETIME_DATA_REQUESTS":true,"DATA_REQUESTS_IN_SHOPPING_CART":true,"WQ_ALLOW_EDIT_PENDING_PAYMENT":true,"WQ_CONFIRM_ON_DELETE":true,"WQ_DELETE_CONFIRM_MESSAGE":"Deleting this filing will forfeit any money already paid to the Secretary of State. This action is permanent and cannot be undone, are you sure you would like to delete?","PASS_ITEM_GUIDS_ON_CHECKOUT":true,"FORM_REVISION_HISTORY":true,"CHECKOUT_DISCLAIMER":"By entering your credit card and/or checking account information you (i) state that **you are an authorized user** of the credit card and/or electronic check and that the associated information entered (e.g., account holder name, account number, billing address) is accurate, (ii) **you authorize payment processor to charge the amount you have requested** to your credit card and/or funding account, and (iii) **acknowledge if a charge is declined or reversed you may also be assessed a customary charge** by the payment processor for such transactions.","FARM_BILL_SEARCH_CONFIDENTIAL":"As a registered Farm Bill Buyer with the Montana Secretary of State’s office it is important to maintain the confidentiality of the information contained within the Farm Bill Master List. The Farm Bill Master List reflects personal data, such as Social Security Numbers, which are a key piece of personal identifiable information to assist you in determining the existence of a lien against a specific debtor. The distribution of this information beyond its intended purpose is strictly prohibited.\n\n**The debtor's tax identification number has been hidden for confidentiality reasons. You may continue to search on a tax ID number and return debtors that match your search criteria. The SSN/FEIN must be entered without dashes or spaces.  If you need access to the tax identification number to clearly identify the debtor, please contact the UCC unit at (406) 444-3665.**","VIEW_HISTORY_BUTTON_ALT_TEXT":"View Filings","WIZARD_ERROR_TITLE_MESSAGE":"Form Error","FARM_BILL_SEARCH_INTERACTIVE":true,"USE_FARM_BILL_API":true,"DISALLOW_ASSIGN_SELF_AS_RA":true,"DISALLOW_ASSIGN_SELF_AS_PRINCIPAL":true,"USE_TRADEMARK_OWNER_VALIDATION":true,"USE_ALTERNATIVE_FOREIGN_ADDRESS_LABELS":true,"MY_RECEIPTS_FILTER":[{"type":"dateRange","name":"DATE_RANGE","label":"Date range","defaultValue":{"start":null,"end":null}},{"type":"text","name":"REF_NUM","defaultValue":"","label":"Reference Number"},{"type":"text","name":"RECEIPT_NUM","defaultValue":"","label":"Receipt Id"},{"type":"text","name":"AMOUNT","defaultValue":"","label":"Amount"},{"type":"select","name":"TYPE","defaultValue":"","label":"Payment Type","options":[{"value":"","label":"All"},{"value":"CC","label":"Credit Card"},{"value":"Check","label":"Check"}]}],"MY_RECEIPTS_SHOW_IN_SIDEBAR":true,"SHOW_MY_RECEIPTS_HELPER_TEXT":true,"MY_RECEIPTS_HELPER_LABEL":"About Receipt Search","MY_RECEIPTS_HELPER_TEXT":"You can search for receipts based on their descriptions, including the items paid for on the receipt. Use the filters to search for or filter specific information.","FARM_BILL_SUBLINK":{"label":"Farm Bill","component":"FarmBill","parameter":"farm-bill","path":"/lists/farm-bill","sourceTypeId":0,"myRecordsSearch":false,"allowedRules":["/search/"],"disabled":true,"searchDescription":"To perform a search, enter a debtor name. Your search results may include: exact debtor name, variations of that name and any filing that includes your search criteria. Punctuation is ignored.\n\nYou can click on \"Advanced\" to refine your search. Under “Advanced” you can search by crop, year, county and SSN/FEIN. As a registered Farm Bill Buyer with the Montana Secretary of State’s office it is important to maintain the confidentiality of the information contained within the Farm Bill Master List. The Farm Bill Master List reflects personal data, such as Social Security Numbers, which are a key piece of personal identifiable information to assist you in determining the existence of a lien against a specific debtor. The distribution of this information beyond its intended purpose is strictly prohibited.\n\nThe debtor's tax identification number has been hidden for confidentiality reasons. You may continue to search on a tax ID number and return debtors that match your search criteria. The SSN/FEIN must be entered without dashes or spaces.","searchMustHaveOneOf":["search","UCC_FARM_PRODUCT_ID","COUNTY"],"searchPlaceholder":"Search by debtor name","advancedSearchParameters":[{"type":"ServerMultiComplete","label":"Product code name(s)","name":"UCC_FARM_PRODUCT_ID","defaultValue":"","optionsSrc":"UCC_FARM_PRODUCT_V"},{"type":"MultiComplete","label":"Year or Range of Years","name":"YEAR_NUM","optionsSrc":"years","startYear":"1968","defaultValue":[],"preMergeOptions":[{"value":"ALL","label":"All"}]},{"type":"serverSelect","label":"State","name":"STATE","defaultValue":"MONTANA","optionsSrc":"STATE"},{"type":"ServerMultiComplete","label":"County","name":"COUNTY","defaultValue":[],"optionsSrc":"COUNTY","overrideSubOptionsSrcFromParameterName":"STATE"},{"type":"checkbox","name":"TIN_SEARCH_YN","defaultValue":false,"label":"Tax Identification Number Search"},{"type":"checkbox","name":"TIN_SORT_YN","defaultValue":false,"label":"Unique ID Sort"}]},"ALLOW_ADDRESS_VALIDATION_BYPASS_OPTION":true,"DEFAULT_ADDRESS_VALIDATION_BYPASS_OPTION_CHECKED":true}).USE_CITY_STATE_ON_FOREIGN_ADDRESS;
	      var showAltForeignAddressLabel = (true);
	      var countries = (0, _selectOptions.getCountryOptions)();
	      if (!countries.some(function (country) {
	        return country.value === value.COUNTRY;
	      })) {
	        value.COUNTRY = '';
	      }
	
	      if ((value.STATE === '' || value.STATE === null) && (defaultState !== '' || defaultState !== null)) {
	        value.STATE = defaultState;
	      }
	
	      var SHOW_ALT_ADDR3_LABEL = ({"NODE_ENV":"production","BUILD_DATE":"2025-08-27T15:15:31.687Z","BUILD_NUMBER":"Not Provided","GIT_VERSION":"v1.3.0-381-ga81e29b08","GIT_COMMIT_HASH":"a81e29b085c9268ffd96c78eb734365802722741","GIT_BRANCH":"beta","PUBLIC_URL":"","STATE_ABBR":"MT","STATE_NAME":"Montana","STATE_ORG_TITLE":"Secretary of State","LOGIN_HEADER_IMG_PATH":"","HOME_IMG_FILENAME":"montana.jpg","FAVICON_FILE_NAME":"favicon.ico","ALLOW_E_SIGN_ON_CORRECTIONS":true,"THIRD_PARTY_SIGNING_ALLOWED":false,"MY_ACCOUNT_SAVE_AND_CLOSE_BUTTON":true,"IE_DEPRECATED_MESSAGE":"Internet Explorer is not supported. Please select a supported browser below to access this website.","ADDITIONAL_ROUTES":{"dataRequests":true,"farmBill":true,"apostille":true,"externalHelp":"https://sosmt.gov/business/help-center/","systemAdministration":[{"title":"Saved Payments","parameter":"saved-payments","componentName":"SavedPayments"}]},"SUBROUTES":[{"label":"Business","component":"Business","parameter":"business","myWorkQueueSearch":false,"sourceTypeId":54,"searchMustHaveOneOf":["FILING_TYPE_ID","STATUS_ID","STATE","search"],"serverWebSearchDescription":true,"serverWorkQueueDescription":true,"serverMyRecordsDescription":true,"searchPlaceholder":"Search by name or filing number (X########)","allowEmptySearchTerm":true,"requestCertificateAlternateLabel":"Request Information","fileAmendmentButtonLabel":"Filing Actions","advancedSearchParameters":[{"type":"radio","name":"QUERY_TYPE_ID","defaultValue":1010,"options":[{"value":1010,"label":"Starts with"},{"value":1011,"label":"Contains"},{"value":1012,"label":" Word Contains"}]},{"type":"serverSelect","name":"FILING_TYPE_ID","optionsSrc":"FILING_TYPES","label":"Entity Type","placeholder":"All","defaultValue":"0"},{"type":"serverSelect","name":"FILING_SUBTYPE_ID","optionsSrc":"FILING_SUBTYPES","label":"Entity Subtype","overrideSubOptionsSrcFromParameterName":"FILING_TYPE_ID","placeholder":"All","defaultValue":"0"},{"type":"serverSelect","name":"STATUS_ID","optionsSrc":"FILING_STATUS_WITHOUT_ALL","label":"Status","placeholder":"All","defaultValue":"0"},{"type":"serverSelect","name":"STATE","optionsSrc":"STATE","label":"State","placeholder":"All","defaultValue":""},{"type":"serverSelect","name":"COUNTY","optionsSrc":"COUNTY_SUBOPTION","label":"County","overrideSubOptionsSrcFromParameterName":"STATE","placeholder":"All","defaultValue":""},{"type":"checkbox","name":"CRA_SEARCH_YN","defaultValue":false,"label":"Search by Registered Agent PID"},{"type":"dateRange","name":"FILING_DATE","label":"Registration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}},{"type":"dateRange","name":"EXPIRATION_DATE","label":"Expiration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}}],"myRecordsFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Active"},{"value":2,"label":"Inactive"},{"value":3,"label":"Pending"}]},{"type":"dateRange","name":"DATE_RANGE","label":"Date range","defaultValue":{"start":null,"end":null}}],"myWorkQueueFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Approved"},{"value":2,"label":"Pending Online Payment"},{"value":3,"label":"Pending Review"},{"value":4,"label":"Needs Correction"},{"value":5,"label":"Rejected"},{"value":6,"label":"Draft"}]},{"type":"dateRange","name":"DATE_RANGE","label":"Date range","defaultValue":{"start":null,"end":null}}]},{"label":"Notary","component":"Notary","parameter":"notary","sourceTypeId":850,"myWorkQueueSearch":false,"allowEmptySearchTerm":true,"requestCertificateAlternateLabel":"Download Certificate","fileAmendmentButtonLabel":"Filing Actions","hideNameRequestCertificate":true,"hideAddressRequestCertificate":true,"hideRecordUserManagment":true,"searchPlaceholder":"Search by name or commission number","searchMustHaveOneOf":["CITY","search","SERVICE_TYPE"],"advancedParametersStartOpen":true,"searchIsSortable":true,"advancedSearchParameters":[{"type":"radio","name":"STARTS_WITH_YN","defaultValue":false,"options":[{"value":true,"label":"Starts with"},{"value":false,"label":"Contains"}]},{"type":"checkbox","name":"ACTIVE_ONLY_YN","defaultValue":true,"label":"Active entities only"},{"type":"text","name":"CITY","defaultValue":"","label":"City"},{"type":"select","name":"SERVICE_TYPE","label":"Special Services Offered","defaultValue":0,"options":[{"value":0,"label":"(N/A)"},{"value":6165,"label":"In-Person Electronic Notarization (IPEN)"},{"value":6166,"label":"Remote Online Notarization (RON)"},{"value":6167,"label":"Mobile Notary Services"},{"value":6168,"label":"Remote Ink Notarization (RIN)"}]}]},{"label":"Apostille","component":"Apostille","parameter":"apostille","sourceTypeId":720,"myRecordsSearch":false,"myWorkQueueSearch":false,"disabled":false,"allowedRoutes":["/forms-manager/","/queue/","/forms/"]},{"label":"Liens","component":"UCC","parameter":"ucc","sourceTypeId":1999,"myRecordsSearch":true,"myWorkQueueSearch":true,"fileAmendmentButtonLabel":"Filing Actions","searchPlaceholder":"Search by name or file number","disabled":false,"serverWebSearchDescription":true,"myRecordsDescription":"","workQueueDescription":"","searchDescription":"","hideRecordUserManagment":true,"searchLiensCheckout":false,"advancedSearchParameters":[{"type":"radio","name":"STARTS_WITH_YN","defaultValue":false,"options":[{"value":true,"label":"Starts with"},{"value":false,"label":"Contains"}]},{"type":"select","name":"STATUS","defaultValue":"ALL","label":"Status","options":[{"value":"ACTIVE_UNLAPSED","label":"Active (unlapsed)"},{"value":"ACTIVE_LAPSED_UNLAPSED","label":"Active (lapsed and unlapsed)"}]},{"type":"text","name":"EXCLUDE_VALUES","label":"Exclude Debtor Names (comma separated list of names to exclude)","defaultValue":""},{"type":"dateRange","name":"FILING_DATE","label":"Financing Statement Date","defaultValue":{"start":null,"end":null}},{"type":"dateRange","name":"LAPSE_DATE","label":"Lapse Date","defaultValue":{"start":null,"end":null}},{"type":"text","name":"CITY","label":"Debtor City","defaultValue":""}],"myRecordsFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Approved"},{"value":2,"label":"Pending Online Payment"},{"value":3,"label":"Pending Review"}]},{"type":"select","name":"TYPE","defaultValue":0,"label":"Lien Type","options":[{"value":0,"label":"All"},{"value":1,"label":"UCC"},{"value":2,"label":"EFS"},{"value":3,"label":"Title 71"}]}],"myWorkQueueFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Approved"},{"value":2,"label":"Pending Online Payment"},{"value":3,"label":"Pending Review"},{"value":4,"label":"Pending Print and Mail"},{"value":5,"label":"Rejected"},{"value":6,"label":"Draft"}]},{"type":"select","name":"TYPE","defaultValue":0,"label":"Lien Type","options":[{"value":0,"label":"All"},{"value":1,"label":"UCC"},{"value":2,"label":"EFS"},{"value":3,"label":"Title 71"}]}]},{"label":"Copy Request","component":"copies","parameter":"copies","sourceTypeId":2001,"myRecordsSearch":false,"myWorkQueueSearch":false,"disabled":false,"allowedRoutes":["/forms-manager/","/queue/","/forms/"]},{"label":"Trademark","component":"Trademark","parameter":"trademark","sourceTypeId":810,"showRequestCertificate":true,"searchMustHaveOneOf":["search","EXPIRATION_DATE","FILING_DATE"],"allowEmptySearchTerm":true,"requestCertificateAlternateLabel":"Request Information","fileAmendmentButtonLabel":"Filing Actions","advancedSearchParameters":[{"type":"radio","name":"QUERY_TYPE_ID","defaultValue":1010,"options":[{"value":1010,"label":"Starts with"},{"value":1011,"label":"Contains"},{"value":1012,"label":" Word Contains"}]},{"type":"checkbox","name":"OWNER_SEARCH_YN","defaultValue":false,"label":"Search owners"},{"type":"radio","name":"SERVICE_MARK_YN","label":"Mark Type","defaultValue":"","options":[{"value":"","label":"All Marks"},{"value":"Y","label":"Service Mark"},{"value":"N","label":"Trademark"}]},{"type":"serverSelect","name":"STATUS_ID","optionsSrc":"TYPE_V|TRADEMARK_STATUS_TYPE","label":"Status","placeholder":"All","defaultValue":"0"},{"type":"select","name":"DESIGN_TYPE_ID","options":[{"value":0,"label":"All"},{"value":990,"label":"Words Only"},{"value":991,"label":"Design Only"},{"value":992,"label":"Words and Design"}],"label":"Design Type","defaultValue":"0"},{"type":"dateRange","name":"FILING_DATE","label":"Registered Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}},{"type":"dateRange","name":"EXPIRATION_DATE","label":"Expiration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}}]},{"label":"Business Info Request","component":"InfoRequests","parameter":"info-request","sourceTypeId":167,"allowedRoutes":["/forms-manager/","/queue/","/forms/"]},{"label":"Data Requests","component":"DataRequests","parameter":"data-request","sourceTypeId":0,"allowedRoutes":["/forms-manager/"]},{"label":"CRA","component":"CRA","parameter":"cra","sourceTypeId":157,"myRecordsSearch":false,"searchPlaceholder":"Search by name or registered agent number","allowedRoutes":["/forms-manager/","/forms/","/records/","/queue/","/search/"],"allowEmptySearchTerm":true,"fileAmendmentButtonLabel":"Filing Actions","advancedSearchParameters":[{"type":"radio","name":"QUERY_TYPE_ID","defaultValue":1010,"options":[{"value":1010,"label":"Starts with"},{"value":1011,"label":"Contains"},{"value":1012,"label":" Word Contains"}]},{"type":"dateRange","name":"CRA_DATE","label":"Registration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}},{"type":"select","name":"STATUS_ID","label":"Status","defaultValue":0,"options":[{"value":0,"label":"All"},{"value":121,"label":"Active"},{"value":122,"label":"Inactive"}]},{"type":"select","name":"AGENT_TYPE_ID","label":"Agent Type","defaultValue":0,"options":[{"value":0,"label":"All"},{"value":460,"label":"Registered Agent"},{"value":461,"label":"Commercial Registered Agent"}]}]},{"label":"Farm Bill","component":"FarmBill","parameter":"farm-bill","path":"/lists/farm-bill","sourceTypeId":0,"myRecordsSearch":false,"allowedRules":["/search/"],"disabled":true,"searchDescription":"To perform a search, enter a debtor name. Your search results may include: exact debtor name, variations of that name and any filing that includes your search criteria. Punctuation is ignored.\n\nYou can click on \"Advanced\" to refine your search. Under “Advanced” you can search by crop, year, county and SSN/FEIN. As a registered Farm Bill Buyer with the Montana Secretary of State’s office it is important to maintain the confidentiality of the information contained within the Farm Bill Master List. The Farm Bill Master List reflects personal data, such as Social Security Numbers, which are a key piece of personal identifiable information to assist you in determining the existence of a lien against a specific debtor. The distribution of this information beyond its intended purpose is strictly prohibited.\n\nThe debtor's tax identification number has been hidden for confidentiality reasons. You may continue to search on a tax ID number and return debtors that match your search criteria. The SSN/FEIN must be entered without dashes or spaces.","searchMustHaveOneOf":["search","UCC_FARM_PRODUCT_ID","COUNTY"],"searchPlaceholder":"Search by debtor name","advancedSearchParameters":[{"type":"ServerMultiComplete","label":"Product code name(s)","name":"UCC_FARM_PRODUCT_ID","defaultValue":"","optionsSrc":"UCC_FARM_PRODUCT_V"},{"type":"MultiComplete","label":"Year or Range of Years","name":"YEAR_NUM","optionsSrc":"years","startYear":"1968","defaultValue":[],"preMergeOptions":[{"value":"ALL","label":"All"}]},{"type":"serverSelect","label":"State","name":"STATE","defaultValue":"MONTANA","optionsSrc":"STATE"},{"type":"ServerMultiComplete","label":"County","name":"COUNTY","defaultValue":[],"optionsSrc":"COUNTY","overrideSubOptionsSrcFromParameterName":"STATE"},{"type":"checkbox","name":"TIN_SEARCH_YN","defaultValue":false,"label":"Tax Identification Number Search"},{"type":"checkbox","name":"TIN_SORT_YN","defaultValue":false,"label":"Unique ID Sort"}]}],"SYSTEM_NICKNAME":"Online Services Portal","PAYMENT_METHODS":[{"type":"bypass"},{"type":"iTransact"}],"PAYMENT_ALLOW_AMEX":true,"SYSTEM_ID_LABEL":"System Id","DOUBLE_COLUMN_PUBLIC_LOGIN":true,"INTERNAL_USER_MANAGEMENT":true,"ALLOW_PUBLIC_JSON_IMPORT":false,"MAX_FILE_UPLOAD_SIZE":10000000,"REFUND_TEXT":"","RETURN_TO_HOME_ON_LOGOUT":true,"CURRENT_SOS_NAME":"Christi Jacobsen","LOGO_FILENAME":"mt-sos-logo.png","LOGO_ALT":"Christi Jacobsen, Montana Secretary of State","LOGO_FULL_WIDTH":true,"HOME_HIDE_AUTH_HINT":true,"HOME_TITLE":"Montana Secretary of State","CUSTOM_TAB_TITLE":"Official Montana","HOME_SUBTITLE":"Online Business Services","ENTITY_NAME_CONSENT_DESCRIPTION":"","ALLOW_USER_PROFILE_EDITING":true,"COMPARE_FOREIGN_NAME_IN_ENTITY_NAME_VALIDATION":true,"FOREIGN_NAME_FIELD_NAME":"KIMA_PARENT_NAME_INFO","LOGIN_TITLE":"Montana Secretary of State Online Filing Portal Login","PUBLIC_LOGIN_LABEL":"Username","REVERSE_LOGIN_COLUMNS":true,"LOGIN_SEAL_FILENAME":"seal_white.png","SEPARATE_USERNAME_AND_EMAIL":true,"CREATE_ACCOUNT_BUTTON_ALIGN_LEFT":true,"CREATE_ACCOUNT_BUTTON_TEXT":"CREATE AN ACCOUNT","PASSWORD_CUSTOM_ERROR_TEXT":"The password must meet all requirements","ACCOUNT_CREATED_MESSAGE":"Please check your email to verify your account to login and allow a few minutes for this message to arrive. Check your junk/spam folders if you do not find the email in your inbox.","PUBLIC_LOGIN_PLACEHOLDER":" ","DISABLE_DEFAULT_PAYMENT_RADIO":true,"CUSTOM_RESET_PASSWORD_ERROR_MESSAGE":"Username invalid - no account found","PUBLIC_LOGIN_CREATE_DESCRIPTION":"### Existing User:\n\n  - Enter your username and password to login.  \n\n\n  #### - OR -  \n\n\n\n  - Forgot password? Click 'Reset Password' and follow the prompts.\n  - Forgot username? Click 'Forgot Username' and follow the prompts.  \n\n\n  ### New User:\n  ","LOGIN_HELP_LINK":"https://sosmt.gov/business/how-do-i/","LOGIN_HELP_LINK_TEXT":"Need Help?","FORGOT_USERNAME_TEXT":"Forgot Username?","LOGIN_ACTIVE_DIRECTORY_TEXT":"State User Login","MULTIPLE_LOGIN_METHODS":true,"HAS_ACTIVE_DIRECTORY_LOGIN":true,"RESET_PASSWORD_WITH_USERNAME":true,"DOWNLOAD_LINK":true,"SHOW_USERNAME_ACCOUNT_CREATE":true,"SHOW_SCROLL_DOWN_ARROW":true,"SHOW_ADDRESS_ACCOUNT_CREATE":true,"TWO_COLUMN_ACCOUNT_CREATE":true,"RESET_PASSWORD_TIP":"A link to change your password has been sent to your email. Please allow a few minutes for this message to arrive. Please check your junk/spam folders if you do not find the email in your inbox.","FORGOT_PASSWORD_LINK_TEXT":"Reset Password","PHONE_NUMBER_OPTIONAL_ACCOUNT_CREATE":true,"SHOW_REQUIRED_INDICATOR_ACCOUNT_CREATE":true,"PASSWORD_REQUIREMENTS_ACCOUNT_CREATE":"\n    <ul>\n      <li>MUST contain at least 8 characters (12+ recommended)</li>\n      <li>MUST contain at least one uppercase letter.</li>\n      <li>MUST contain at least one lowercase letter.</li>\n      <li>MUST contain at least one number.</li>\n      <li>MUST contain at least one special character (!”#$%&'()*+,-./:;<=>?</li>\n    </ul>\n  ","ALLOW_CERTIFICATION_REQUEST":true,"ALLOW_PUBLIC_CERTIFICATE_REQUEST":true,"ALLOW_COPY_REQUEST":false,"ALLOW_CORRECTION_STYLING":true,"HIDE_DEPRECATION_WARNING":false,"AMEND_ROUTE_PUBLIC":true,"SEAL_FILENAME":"seal.png","SHOPPING_CART":true,"ALLOW_PAYMENT_UPDATE_WITH_EMPTY_CART":true,"RA_EMAIL":true,"RA_WEBSITE":true,"RA_NO_DEFAULT_TYPE":true,"RA_ADDRESS_LABEL":"Street Address","RA_TYPE_SELECTION_DEFAULT":true,"RA_DEFAULT_TYPE":"460","RA_OVERRIDE_TYPE_WITH_DEFAULT":true,"RA_PRINCIPAL_ADDRESS_AMS":true,"UPLOAD_AND_SUBMIT_HIDE_IF_ONE_OPTION":true,"PAYMENT_PROCESSING_MESSAGE":"Your payment is processing - Do not close your browser or click the back button","CHECKOUT_BUTTON_WHEN_PROCESSING_TEXT":"Processing","EFS_CROP_PICKER_NONE_LABEL":"Lien Duration","DISALLOWED_WIZARD_PIECES":["FormationLocale"],"REPEATER_SHOW_EDIT_BUTTON":true,"DATA_REQUEST_PAGE_TITLE":"Data Requests and Subscriptions","DATA_REQUEST_SIDEBAR_LABEL":"Data Requests & Subscriptions","LOGIN_REDIRECTS_TO_EPASS":false,"LOGIN_REDIRECTS_TO_ACTIVE_DIRECTORY":true,"LOGIN_ACTIVE_DIRECTORY_LINK":true,"FETCH_EDIT_USER_LINK":false,"LISTS_FETCH_AVAILABLE_LISTS":true,"POST_WIZARD_SUBMIT_REDIRECT_URL":"/","PIN_REQUEST_ATTESTATIONS":true,"PIN_REQUEST_DESCRIPTION":"Click **Request PIN** to have a new PIN sent to the account holder's email address on file.","OWNERSHIP_REQUEST_DESCRIPTION":"To become an **authorized user** of this record, a current **AUTHORIZED USER** will need to grant you access. To request access, click **Request Access** below.","PIN_REQUEST_SUCCESS_MESSAGE":"The PIN you have requested for this entity has been sent to the email associated with your user account.  You should receive the PIN in approximately 3-5 minutes, depending on your email service provider.","APOSTILLE_HEADER_LABEL":"Verification Information","APOSTILLE_NUMBER_LABEL":"Apostille/Authentication","APOSTILLE_CITY_STATE_OVERRIDE":"HELENA, MT","APOSTILLE_FILING_DATE_LABEL":"Issue Date","APOSTILLE_CITY_STATE_IN_CERTIFIED":true,"NOTARY_EXISTING_FILING":true,"ALLOW_REVOKE_OWN_ACCESS_ONLY":false,"HIDE_CANCEL_ON_ONETIME_DATA_REQUESTS":true,"DATA_REQUESTS_IN_SHOPPING_CART":true,"WQ_ALLOW_EDIT_PENDING_PAYMENT":true,"WQ_CONFIRM_ON_DELETE":true,"WQ_DELETE_CONFIRM_MESSAGE":"Deleting this filing will forfeit any money already paid to the Secretary of State. This action is permanent and cannot be undone, are you sure you would like to delete?","PASS_ITEM_GUIDS_ON_CHECKOUT":true,"FORM_REVISION_HISTORY":true,"CHECKOUT_DISCLAIMER":"By entering your credit card and/or checking account information you (i) state that **you are an authorized user** of the credit card and/or electronic check and that the associated information entered (e.g., account holder name, account number, billing address) is accurate, (ii) **you authorize payment processor to charge the amount you have requested** to your credit card and/or funding account, and (iii) **acknowledge if a charge is declined or reversed you may also be assessed a customary charge** by the payment processor for such transactions.","FARM_BILL_SEARCH_CONFIDENTIAL":"As a registered Farm Bill Buyer with the Montana Secretary of State’s office it is important to maintain the confidentiality of the information contained within the Farm Bill Master List. The Farm Bill Master List reflects personal data, such as Social Security Numbers, which are a key piece of personal identifiable information to assist you in determining the existence of a lien against a specific debtor. The distribution of this information beyond its intended purpose is strictly prohibited.\n\n**The debtor's tax identification number has been hidden for confidentiality reasons. You may continue to search on a tax ID number and return debtors that match your search criteria. The SSN/FEIN must be entered without dashes or spaces.  If you need access to the tax identification number to clearly identify the debtor, please contact the UCC unit at (406) 444-3665.**","VIEW_HISTORY_BUTTON_ALT_TEXT":"View Filings","WIZARD_ERROR_TITLE_MESSAGE":"Form Error","FARM_BILL_SEARCH_INTERACTIVE":true,"USE_FARM_BILL_API":true,"DISALLOW_ASSIGN_SELF_AS_RA":true,"DISALLOW_ASSIGN_SELF_AS_PRINCIPAL":true,"USE_TRADEMARK_OWNER_VALIDATION":true,"USE_ALTERNATIVE_FOREIGN_ADDRESS_LABELS":true,"MY_RECEIPTS_FILTER":[{"type":"dateRange","name":"DATE_RANGE","label":"Date range","defaultValue":{"start":null,"end":null}},{"type":"text","name":"REF_NUM","defaultValue":"","label":"Reference Number"},{"type":"text","name":"RECEIPT_NUM","defaultValue":"","label":"Receipt Id"},{"type":"text","name":"AMOUNT","defaultValue":"","label":"Amount"},{"type":"select","name":"TYPE","defaultValue":"","label":"Payment Type","options":[{"value":"","label":"All"},{"value":"CC","label":"Credit Card"},{"value":"Check","label":"Check"}]}],"MY_RECEIPTS_SHOW_IN_SIDEBAR":true,"SHOW_MY_RECEIPTS_HELPER_TEXT":true,"MY_RECEIPTS_HELPER_LABEL":"About Receipt Search","MY_RECEIPTS_HELPER_TEXT":"You can search for receipts based on their descriptions, including the items paid for on the receipt. Use the filters to search for or filter specific information.","FARM_BILL_SUBLINK":{"label":"Farm Bill","component":"FarmBill","parameter":"farm-bill","path":"/lists/farm-bill","sourceTypeId":0,"myRecordsSearch":false,"allowedRules":["/search/"],"disabled":true,"searchDescription":"To perform a search, enter a debtor name. Your search results may include: exact debtor name, variations of that name and any filing that includes your search criteria. Punctuation is ignored.\n\nYou can click on \"Advanced\" to refine your search. Under “Advanced” you can search by crop, year, county and SSN/FEIN. As a registered Farm Bill Buyer with the Montana Secretary of State’s office it is important to maintain the confidentiality of the information contained within the Farm Bill Master List. The Farm Bill Master List reflects personal data, such as Social Security Numbers, which are a key piece of personal identifiable information to assist you in determining the existence of a lien against a specific debtor. The distribution of this information beyond its intended purpose is strictly prohibited.\n\nThe debtor's tax identification number has been hidden for confidentiality reasons. You may continue to search on a tax ID number and return debtors that match your search criteria. The SSN/FEIN must be entered without dashes or spaces.","searchMustHaveOneOf":["search","UCC_FARM_PRODUCT_ID","COUNTY"],"searchPlaceholder":"Search by debtor name","advancedSearchParameters":[{"type":"ServerMultiComplete","label":"Product code name(s)","name":"UCC_FARM_PRODUCT_ID","defaultValue":"","optionsSrc":"UCC_FARM_PRODUCT_V"},{"type":"MultiComplete","label":"Year or Range of Years","name":"YEAR_NUM","optionsSrc":"years","startYear":"1968","defaultValue":[],"preMergeOptions":[{"value":"ALL","label":"All"}]},{"type":"serverSelect","label":"State","name":"STATE","defaultValue":"MONTANA","optionsSrc":"STATE"},{"type":"ServerMultiComplete","label":"County","name":"COUNTY","defaultValue":[],"optionsSrc":"COUNTY","overrideSubOptionsSrcFromParameterName":"STATE"},{"type":"checkbox","name":"TIN_SEARCH_YN","defaultValue":false,"label":"Tax Identification Number Search"},{"type":"checkbox","name":"TIN_SORT_YN","defaultValue":false,"label":"Unique ID Sort"}]},"ALLOW_ADDRESS_VALIDATION_BYPASS_OPTION":true,"DEFAULT_ADDRESS_VALIDATION_BYPASS_OPTION_CHECKED":true}).SHOW_ALT_ADDR3_LABEL;
	      var ALLOW_ADDRESS_VALIDATION_BYPASS_OPTION = (true);
	
	      var stdBypass = ALLOW_ADDRESS_VALIDATION_BYPASS_OPTION && this.props.businessRules ? this.props.businessRules.find(function (rule) {
	        return rule.fn === "addressIsValid";
	      }) ? this.props.businessRules.find(function (rule) {
	        return rule.fn === "addressIsValid";
	      }).props.allowAddressValidationBypass : false : false;
	
	      var RegisteredAgentMailBypass = ALLOW_ADDRESS_VALIDATION_BYPASS_OPTION && this.props.businessRules ? this.props.businessRules.find(function (rule) {
	        return rule.fn === "registeredAgentAddressIsValid";
	      }) ? this.props.businessRules.find(function (rule) {
	        return rule.fn === "registeredAgentAddressIsValid";
	      }).props.allowAgentAddressMailValidationBypass : false : false;
	      var RegisteredAgentPrimaryBypass = ALLOW_ADDRESS_VALIDATION_BYPASS_OPTION && this.props.businessRules ? this.props.businessRules.find(function (rule) {
	        return rule.fn === "registeredAgentAddressIsValid";
	      }) ? this.props.businessRules.find(function (rule) {
	        return rule.fn === "registeredAgentAddressIsValid";
	      }).props.allowAgentAddressPrimaryValidationBypass : false : false;
	
	      var ShowAddressValidationBypass = ALLOW_ADDRESS_VALIDATION_BYPASS_OPTION && valueIsNotEmptyOrNull(getTrimmedValue(value.ADDR1)) && valueIsNotEmptyOrNull(getTrimmedValue(value.CITY)) && valueIsNotEmptyOrNull(getTrimmedValue(value.STATE)) && valueIsNotEmptyOrNull(getTrimmedValue(value.POSTAL_CODE)) && (value.MAIL_ADDR_BYPASS_YN === 'Y' || isValid === false && stdBypass || isValid === false && RegisteredAgentPrimaryBypass && this.props.fieldId && this.props.fieldId.indexOf('_PRIMARY') !== -1 && this.props.errorMessage && this.props.errorMessage.some(function (message) {
	        return message.toLowerCase().includes("street");
	      }) || isValid === false && RegisteredAgentMailBypass && this.props.fieldId && this.props.fieldId.indexOf('_MAIL') !== -1 && this.props.errorMessage && this.props.errorMessage.some(function (message) {
	        return message.toLowerCase().includes("mailing");
	      }));
	
	      var getBypassMessage = ALLOW_ADDRESS_VALIDATION_BYPASS_OPTION && this.props.fieldId ? this.props.fieldId.indexOf('_PRIMARY') !== -1 ? primarybypassMessage || "I understand that my street address has failed validation. I certify that my address is entered correctly and wish to bypass validation." : this.props.fieldId.indexOf('_MAIL') !== -1 ? mailbypassMessage || "I understand that my mailing address has failed validation. I certify that my address is entered correctly and wish to bypass validation." : bypassMessage || "I understand that my mailing address has failed validation. I certify that my address is entered correctly and wish to bypass validation." : null;
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'address-block' },
	        _react2.default.createElement(
	          'div',
	          { className: 'row' },
	          _react2.default.createElement(
	            'div',
	            {
	              className: (singleColSize ? singleColSize : 'col-sm-9 col-md-8 col-lg-7') + ' flex-col'
	            },
	            _react2.default.createElement(
	              _Field.DumbField,
	              {
	                className: 'auto-width',
	                type: 'text',
	                required: required,
	                parentType: 'addressBlock',
	                label: address1Label ? address1Label : isForeign ? showAltForeignAddressLabel ? 'Address 1 (house/building number and street name)' : 'Address 1' : 'Address',
	                fieldId: 'address1-' + fieldId
	              },
	              _react2.default.createElement(
	                'div',
	                { className: 'row-wrapper' },
	                _react2.default.createElement(_Form.TextInput, {
	                  fieldId: 'address1-' + fieldId,
	                  onChange: this.setFieldValue,
	                  onBlur: this.handleFieldBlur,
	                  autoComplete: 'address-line1',
	                  name: 'ADDR1',
	                  value: value.ADDR1,
	                  disabled: disabled,
	                  required: true,
	                  validityClass: isValidClass,
	                  isValid: isValid,
	                  ref: function ref(addr1) {
	                    _this2.addr1 = addr1;
	                  },
	                  ariaLabel: label + ': Address Line 1'
	                }),
	                allowSelection !== false && _react2.default.createElement(
	                  'button',
	                  {
	                    type: 'button',
	                    className: 'btn btn-raised btn-primary copy-button',
	                    disabled: !hasAddresses || disabled,
	                    onClick: this.toggleAddressSelect,
	                    'data-tip': 'Copy from',
	                    'data-for': 'copy-' + fieldId,
	                    'aria-label': 'Copy address from'
	                  },
	                  _react2.default.createElement(_documentClone2.default, null)
	                ),
	                _react2.default.createElement(_reactTooltip2.default, { effect: 'solid', place: 'top', id: 'copy-' + fieldId })
	              )
	            ),
	            _react2.default.createElement(
	              _Portal2.default,
	              { isOpened: this.state.modalOpen },
	              _react2.default.createElement(
	                _Modal.Modal,
	                {
	                  title: 'Select an Address',
	                  closeModal: this.toggleAddressSelect,
	                  modalSize: 'small',
	                  closeButton: true,
	                  autoHeight: true,
	                  ref: function ref(modal) {
	                    _this2.modal = modal;
	                  }
	                },
	                _react2.default.createElement(_AddressSelector2.default, { onSelect: this.copyAddress, fieldId: fieldId })
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'row' },
	          _react2.default.createElement(
	            'div',
	            { className: '' + (singleColSize ? singleColSize : 'col-sm-9 col-md-8 col-lg-7') },
	            _react2.default.createElement(
	              _Field.DumbField,
	              {
	                type: 'text',
	                required: false,
	                parentType: 'addressBlock',
	                label: isForeign ? showAltForeignAddressLabel ? 'Address 2 (city, state/province, postal code)' : 'Address 2' : 'STE/APT/FL',
	                fieldId: 'address2-' + fieldId
	              },
	              _react2.default.createElement(_Form.TextInput, {
	                onChange: this.setFieldValue,
	                onBlur: this.handleFieldBlur,
	                autoComplete: 'address-line2',
	                name: 'ADDR2',
	                value: value.ADDR2,
	                disabled: disabled,
	                required: false,
	                width: '100%',
	                validityClass: isValidClass,
	                isValid: isValid,
	                fieldId: 'address2-' + fieldId,
	                ariaLabel: label + ': ' + (isForeign ? 'Address line 2' : 'STE/APT/FL')
	              })
	            )
	          )
	        ),
	        showAddress3 && !hideAttention && _react2.default.createElement(
	          'div',
	          { className: 'row' },
	          _react2.default.createElement(
	            'div',
	            { className: '' + (singleColSize ? singleColSize : 'col-sm-9 col-md-8 col-lg-7') },
	            _react2.default.createElement(
	              _Field.DumbField,
	              {
	                type: 'text',
	                required: false,
	                parentType: 'addressBlock',
	                label: isForeign ? showAltForeignAddressLabel ? 'Address 3 (attention line)' : 'Address 3' : SHOW_ALT_ADDR3_LABEL ? 'Address Continued (if needed)' : 'Attention',
	                fieldId: 'address3-' + fieldId
	              },
	              _react2.default.createElement(_Form.TextInput, {
	                onChange: this.setFieldValue,
	                onBlur: this.handleFieldBlur,
	                autoComplete: 'address-level4',
	                name: 'ADDR3',
	                value: value.ADDR3,
	                disabled: disabled,
	                required: false,
	                width: '100%',
	                validityClass: isValidClass,
	                isValid: isValid,
	                fieldId: 'address3-' + fieldId,
	                ariaLabel: label + ': ' + (isForeign ? 'Address line 3' : SHOW_ALT_ADDR3_LABEL ? 'Address Continued (if needed)' : 'Attention')
	              })
	            )
	          )
	        ),
	        showCityStateZip ? (isForeign && showCityStateZipOnForeignAddress || !isForeign) && _react2.default.createElement(
	          'div',
	          { className: 'row' },
	          _react2.default.createElement(
	            'div',
	            {
	              className: triColSizes.CITY ? triColSizes.CITY : isForeign ? 'col-sm-5 col-md-4 col-lg-2' : 'col-sm-5 col-md-4 col-lg-3'
	            },
	            _react2.default.createElement(
	              _Field.DumbField,
	              {
	                type: 'text',
	                required: required,
	                parentType: 'addressBlock',
	                label: 'City',
	                fieldId: 'addr-city-' + fieldId
	              },
	              _react2.default.createElement(_Form.TextInput, {
	                onChange: this.setFieldValue,
	                onBlur: this.handleFieldBlur,
	                autoComplete: 'address-level2',
	                name: 'CITY',
	                value: value.CITY,
	                disabled: disabled,
	                required: true,
	                width: '100%',
	                validityClass: isValidClass,
	                isValid: isValid,
	                fieldId: 'addr-city-' + fieldId,
	                ariaLabel: label + ': City'
	              })
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            {
	              className: triColSizes.STATE ? triColSizes.STATE : isForeign ? 'col-sm-3 col-md-3 col-lg-3' : 'col-sm-3 col-md-3 col-lg-2'
	            },
	            !isForeign ? _react2.default.createElement(
	              _Field.DumbField,
	              {
	                type: 'text',
	                required: required,
	                parentType: 'addressBlock',
	                label: 'State',
	                fieldId: 'addr-state-' + fieldId
	              },
	              _react2.default.createElement(_Form.Select, {
	                onChange: this.setFieldValue,
	                onBlur: function onBlur(e) {
	                  _this2.handleFieldBlur(e);
	                  _this2.handleStateBlur();
	                },
	                options: [{ value: '', label: '' }].concat(_toConsumableArray(excludeCurrentState ? _selectOptions.filteredStateOptions : _selectOptions.stateOptions)),
	                autoComplete: 'region',
	                name: 'STATE',
	                value: value.STATE,
	                required: true,
	                width: '100%',
	                validityClass: isValidClass,
	                isValid: isValid,
	                disabled: disabled === true ? true : disableState,
	                fieldId: 'addr-state-' + fieldId,
	                className: classNames.STATE,
	                ariaLabel: label + ': State'
	              })
	            ) : _react2.default.createElement(
	              _Field.DumbField,
	              {
	                type: 'text',
	                required: required,
	                parentType: 'addressBlock',
	                label: 'State/Province/Territory',
	                fieldId: 'addr-state-' + fieldId
	              },
	              _react2.default.createElement(_Form.TextInput, {
	                onChange: this.setFieldValue,
	                onBlur: this.handleFieldBlur,
	                autoComplete: 'address-level2',
	                name: 'STATE',
	                value: value.STATE,
	                disabled: disabled,
	                required: true,
	                width: '100%',
	                validityClass: isValidClass,
	                isValid: isValid,
	                fieldId: 'addr-state-' + fieldId,
	                ariaLabel: label + ': State/Province/Territory'
	              })
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: triColSizes.ZIP ? triColSizes.ZIP : 'col-sm-3 col-md-3 col-lg-2' },
	            _react2.default.createElement(
	              _Field.DumbField,
	              {
	                type: 'text',
	                required: required,
	                parentType: 'addressBlock',
	                label: isForeign ? 'ZIP/Postal code' : 'ZIP Code',
	                fieldId: 'addr-zip-' + fieldId
	              },
	              _react2.default.createElement(_Form.TextInput, {
	                onChange: isForeign ? this.setFieldValue : function (value, e) {
	                  return _this2.setFieldValue(_validate.MASK.zipCode(value), e);
	                },
	                onBlur: function onBlur(e) {
	                  _this2.handleFieldBlur(e);
	                  _this2.handleZipBlur();
	                },
	                name: 'POSTAL_CODE',
	                value: value.POSTAL_CODE,
	                autoComplete: 'postal-code',
	                disabled: disabled,
	                required: true,
	                width: '100%',
	                validityClass: isValidClass,
	                isValid: isValid,
	                fieldId: 'addr-zip-' + fieldId,
	                ariaLabel: label + ': ZIP code'
	              })
	            )
	          )
	        ) : null,
	        showCounty ? _react2.default.createElement(
	          'div',
	          { className: 'row' },
	          _react2.default.createElement(
	            'div',
	            { className: 'col-sm-7 col-md-6 col-lg-5' },
	            _react2.default.createElement(
	              _Field.DumbField,
	              {
	                type: 'text',
	                required: required,
	                parentType: 'addressBlock',
	                label: 'County',
	                fieldId: 'addr-county-' + fieldId
	              },
	              _react2.default.createElement(_Form.TextInput, {
	                onChange: this.setFieldValue,
	                onBlur: this.handleFieldBlur,
	                name: 'COUNTY',
	                value: value.COUNTY,
	                disabled: disabled,
	                required: true,
	                width: '100%',
	                validityClass: isValidClass,
	                isValid: isValid,
	                fieldId: 'addr-county-' + fieldId,
	                ariaLabel: label + ': County'
	              })
	            )
	          )
	        ) : null,
	        showCountry ? _react2.default.createElement(
	          'div',
	          { className: 'row' },
	          _react2.default.createElement(
	            'div',
	            { className: 'col-sm-7 col-md-6 col-lg-5' },
	            _react2.default.createElement(
	              _Field.DumbField,
	              {
	                type: 'text',
	                required: required,
	                parentType: 'addressBlock',
	                label: 'Country',
	                fieldId: 'addr-country-' + fieldId
	              },
	              _react2.default.createElement(_Form.Select, {
	                onChange: this.setFieldValue,
	                onBlur: this.handleFieldBlur,
	                options: (0, _selectOptions.getCountryOptions)(),
	                name: 'COUNTRY',
	                autoComplete: 'country',
	                value: value.COUNTRY,
	                required: true,
	                width: '100%',
	                validityClass: isValidClass,
	                isValid: isValid,
	                disabled: disabled === true ? true : disableCountry,
	                fieldId: 'addr-country-' + fieldId,
	                ariaLabel: label + ': country'
	              })
	            )
	          )
	        ) : null,
	        ShowAddressValidationBypass ? _react2.default.createElement(
	          'div',
	          { className: 'row' },
	          _react2.default.createElement(
	            'div',
	            { className: 'flex-row checkbox-padding top-box' },
	            _react2.default.createElement(_Form.Checkbox, {
	              fieldId: fieldId + '-bypass',
	              label: getBypassMessage,
	              name: 'MAIL_ADDR_BYPASS_YN',
	              onChange: this.setBypassChecked,
	              value: this.state.isBypassAcknowledged,
	              onBlur: this.handleFieldBlur,
	              disabled: disabled
	            })
	          )
	        ) : null
	      );
	    }
	  }]);
	
	  return AddressBlock;
	}(_react.Component);
	
	exports.default = (0, _reactRedux.connect)(function (state, props) {
	  return {
	    hasAddresses: ((0, _utilities.getFieldsByType)(['addressBlock', 'registeredAgentSearch'], state.wizard.wizard.fields) || []).reduce(function (ads, ad) {
	      if (ad.type === 'registeredAgentSearch') {
	        return [].concat(_toConsumableArray(ads), [Object.assign({}, ad, { fieldId: ad.fieldId + '_PRIMARY', value: { ADDR1: ad.value.ADDR1 } }), Object.assign({}, ad, { fieldId: ad.fieldId + '_MAIL', value: { ADDR1: ad.value.MAIL_ADDR.ADDR1 } })]);
	      } else {
	        return [].concat(_toConsumableArray(ads), [ad]);
	      }
	    }, []).filter(function (address) {
	      return address.parent.type !== 'REPEATER' && address.fieldId !== props.fieldId && address.value.ADDR1 !== '' && address.active;
	    }).filter(function (address) {
	      return (0, _utilities.getControlIsRenderable)(address, state.wizard.wizard.fields);
	    }).length > 0
	  };
	})(AddressBlock);

/***/ },
/* 103 */
/***/ function(module, exports, __webpack_require__) {

	var baseOrderBy = __webpack_require__(1209),
	    isArray = __webpack_require__(76);
	
	/**
	 * This method is like `_.sortBy` except that it allows specifying the sort
	 * orders of the iteratees to sort by. If `orders` is unspecified, all values
	 * are sorted in ascending order. Otherwise, specify an order of "desc" for
	 * descending or "asc" for ascending sort order of corresponding values.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Collection
	 * @param {Array|Object} collection The collection to iterate over.
	 * @param {Array[]|Function[]|Object[]|string[]} [iteratees=[_.identity]]
	 *  The iteratees to sort by.
	 * @param {string[]} [orders] The sort orders of `iteratees`.
	 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
	 * @returns {Array} Returns the new sorted array.
	 * @example
	 *
	 * var users = [
	 *   { 'user': 'fred',   'age': 48 },
	 *   { 'user': 'barney', 'age': 34 },
	 *   { 'user': 'fred',   'age': 40 },
	 *   { 'user': 'barney', 'age': 36 }
	 * ];
	 *
	 * // Sort by `user` in ascending order and by `age` in descending order.
	 * _.orderBy(users, ['user', 'age'], ['asc', 'desc']);
	 * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 40]]
	 */
	function orderBy(collection, iteratees, orders, guard) {
	  if (collection == null) {
	    return [];
	  }
	  if (!isArray(iteratees)) {
	    iteratees = iteratees == null ? [] : [iteratees];
	  }
	  orders = guard ? undefined : orders;
	  if (!isArray(orders)) {
	    orders = orders == null ? [] : [orders];
	  }
	  return baseOrderBy(collection, iteratees, orders);
	}
	
	module.exports = orderBy;


/***/ },
/* 104 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(37);
	
	exports.__esModule = true;
	exports["default"] = exports.ReactReduxContext = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var ReactReduxContext = /*#__PURE__*/_react["default"].createContext(null);
	
	exports.ReactReduxContext = ReactReduxContext;
	
	if (false) {
	  ReactReduxContext.displayName = 'ReactRedux';
	}
	
	var _default = ReactReduxContext;
	exports["default"] = _default;

/***/ },
/* 105 */
/***/ function(module, exports, __webpack_require__) {

	// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.
	
	// a duplex stream is just a stream that is both readable and writable.
	// Since JS doesn't have multiple prototypal inheritance, this class
	// prototypally inherits from Readable, and then parasitically from
	// Writable.
	
	'use strict';
	
	/*<replacement>*/
	
	var pna = __webpack_require__(208);
	/*</replacement>*/
	
	/*<replacement>*/
	var objectKeys = Object.keys || function (obj) {
	  var keys = [];
	  for (var key in obj) {
	    keys.push(key);
	  }return keys;
	};
	/*</replacement>*/
	
	module.exports = Duplex;
	
	/*<replacement>*/
	var util = Object.create(__webpack_require__(136));
	util.inherits = __webpack_require__(58);
	/*</replacement>*/
	
	var Readable = __webpack_require__(523);
	var Writable = __webpack_require__(319);
	
	util.inherits(Duplex, Readable);
	
	{
	  // avoid scope creep, the keys array can then be collected
	  var keys = objectKeys(Writable.prototype);
	  for (var v = 0; v < keys.length; v++) {
	    var method = keys[v];
	    if (!Duplex.prototype[method]) Duplex.prototype[method] = Writable.prototype[method];
	  }
	}
	
	function Duplex(options) {
	  if (!(this instanceof Duplex)) return new Duplex(options);
	
	  Readable.call(this, options);
	  Writable.call(this, options);
	
	  if (options && options.readable === false) this.readable = false;
	
	  if (options && options.writable === false) this.writable = false;
	
	  this.allowHalfOpen = true;
	  if (options && options.allowHalfOpen === false) this.allowHalfOpen = false;
	
	  this.once('end', onend);
	}
	
	Object.defineProperty(Duplex.prototype, 'writableHighWaterMark', {
	  // making it explicit this property is not enumerable
	  // because otherwise some prototype manipulation in
	  // userland will fail
	  enumerable: false,
	  get: function () {
	    return this._writableState.highWaterMark;
	  }
	});
	
	// the no-half-open enforcer
	function onend() {
	  // if we allow half-open state, or if the writable side ended,
	  // then we're ok.
	  if (this.allowHalfOpen || this._writableState.ended) return;
	
	  // no more data can be written.
	  // But allow more writes to happen in this tick.
	  pna.nextTick(onEndNT, this);
	}
	
	function onEndNT(self) {
	  self.end();
	}
	
	Object.defineProperty(Duplex.prototype, 'destroyed', {
	  get: function () {
	    if (this._readableState === undefined || this._writableState === undefined) {
	      return false;
	    }
	    return this._readableState.destroyed && this._writableState.destroyed;
	  },
	  set: function (value) {
	    // we ignore the value if the stream
	    // has not been initialized yet
	    if (this._readableState === undefined || this._writableState === undefined) {
	      return;
	    }
	
	    // backward compatibility, the user is explicitly
	    // managing destroyed
	    this._readableState.destroyed = value;
	    this._writableState.destroyed = value;
	  }
	});
	
	Duplex.prototype._destroy = function (err, cb) {
	  this.push(null);
	  this.end();
	
	  pna.nextTick(cb, err);
	};

/***/ },
/* 106 */
/***/ function(module, exports, __webpack_require__) {

	var _typeof = __webpack_require__(546)["default"];
	
	function _getRequireWildcardCache() {
	  if (typeof WeakMap !== "function") return null;
	  var cache = new WeakMap();
	
	  _getRequireWildcardCache = function _getRequireWildcardCache() {
	    return cache;
	  };
	
	  return cache;
	}
	
	function _interopRequireWildcard(obj) {
	  if (obj && obj.__esModule) {
	    return obj;
	  }
	
	  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
	    return {
	      "default": obj
	    };
	  }
	
	  var cache = _getRequireWildcardCache();
	
	  if (cache && cache.has(obj)) {
	    return cache.get(obj);
	  }
	
	  var newObj = {};
	  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
	
	  for (var key in obj) {
	    if (Object.prototype.hasOwnProperty.call(obj, key)) {
	      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
	
	      if (desc && (desc.get || desc.set)) {
	        Object.defineProperty(newObj, key, desc);
	      } else {
	        newObj[key] = obj[key];
	      }
	    }
	  }
	
	  newObj["default"] = obj;
	
	  if (cache) {
	    cache.set(obj, newObj);
	  }
	
	  return newObj;
	}
	
	module.exports = _interopRequireWildcard;
	module.exports["default"] = module.exports, module.exports.__esModule = true;

/***/ },
/* 107 */
/***/ function(module, exports, __webpack_require__) {

	// getting tag from 19.1.3.6 Object.prototype.toString()
	var cof = __webpack_require__(53);
	var TAG = __webpack_require__(26)('toStringTag');
	// ES3 wrong here
	var ARG = cof(function () { return arguments; }()) == 'Arguments';
	
	// fallback for IE11 Script Access Denied error
	var tryGet = function (it, key) {
	  try {
	    return it[key];
	  } catch (e) { /* empty */ }
	};
	
	module.exports = function (it) {
	  var O, T, B;
	  return it === undefined ? 'Undefined' : it === null ? 'Null'
	    // @@toStringTag case
	    : typeof (T = tryGet(O = Object(it), TAG)) == 'string' ? T
	    // builtinTag case
	    : ARG ? cof(O)
	    // ES3 arguments fallback
	    : (B = cof(O)) == 'Object' && typeof O.callee == 'function' ? 'Arguments' : B;
	};


/***/ },
/* 108 */
/***/ function(module, exports) {

	module.exports = {};


/***/ },
/* 109 */
/***/ function(module, exports, __webpack_require__) {

	var def = __webpack_require__(32).f;
	var has = __webpack_require__(46);
	var TAG = __webpack_require__(26)('toStringTag');
	
	module.exports = function (it, tag, stat) {
	  if (it && !has(it = stat ? it : it.prototype, TAG)) def(it, TAG, { configurable: true, value: tag });
	};


/***/ },
/* 110 */
/***/ function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(4);
	var defined = __webpack_require__(62);
	var fails = __webpack_require__(21);
	var spaces = __webpack_require__(254);
	var space = '[' + spaces + ']';
	var non = '\u200b\u0085';
	var ltrim = RegExp('^' + space + space + '*');
	var rtrim = RegExp(space + space + '*$');
	
	var exporter = function (KEY, exec, ALIAS) {
	  var exp = {};
	  var FORCE = fails(function () {
	    return !!spaces[KEY]() || non[KEY]() != non;
	  });
	  var fn = exp[KEY] = FORCE ? exec(trim) : spaces[KEY];
	  if (ALIAS) exp[ALIAS] = fn;
	  $export($export.P + $export.F * FORCE, 'String', exp);
	};
	
	// 1 -> String#trimLeft
	// 2 -> String#trimRight
	// 3 -> String#trim
	var trim = exporter.trim = function (string, TYPE) {
	  string = String(defined(string));
	  if (TYPE & 1) string = string.replace(ltrim, '');
	  if (TYPE & 2) string = string.replace(rtrim, '');
	  return string;
	};
	
	module.exports = exporter;


/***/ },
/* 111 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = addLeadingZeros;
	
	function addLeadingZeros(number, targetLength) {
	  var sign = number < 0 ? '-' : '';
	  var output = Math.abs(number).toString();
	
	  while (output.length < targetLength) {
	    output = '0' + output;
	  }
	
	  return sign + output;
	}
	
	module.exports = exports.default;

/***/ },
/* 112 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = addMonths;
	
	var _index = _interopRequireDefault(__webpack_require__(9));
	
	var _index2 = _interopRequireDefault(__webpack_require__(3));
	
	var _index3 = _interopRequireDefault(__webpack_require__(2));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name addMonths
	 * @category Month Helpers
	 * @summary Add the specified number of months to the given date.
	 *
	 * @description
	 * Add the specified number of months to the given date.
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} date - the date to be changed
	 * @param {Number} amount - the amount of months to be added. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
	 * @returns {Date} the new date with the months added
	 * @throws {TypeError} 2 arguments required
	 *
	 * @example
	 * // Add 5 months to 1 September 2014:
	 * var result = addMonths(new Date(2014, 8, 1), 5)
	 * //=> Sun Feb 01 2015 00:00:00
	 */
	function addMonths(dirtyDate, dirtyAmount) {
	  (0, _index3.default)(2, arguments);
	  var date = (0, _index2.default)(dirtyDate);
	  var amount = (0, _index.default)(dirtyAmount);
	
	  if (isNaN(amount)) {
	    return new Date(NaN);
	  }
	
	  if (!amount) {
	    // If 0 months, no-op to avoid changing times in the hour before end of DST
	    return date;
	  }
	
	  var dayOfMonth = date.getDate(); // The JS Date object supports date math by accepting out-of-bounds values for
	  // month, day, etc. For example, new Date(2020, 1, 0) returns 31 Dec 2019 and
	  // new Date(2020, 13, 1) returns 1 Feb 2021.  This is *almost* the behavior we
	  // want except that dates will wrap around the end of a month, meaning that
	  // new Date(2020, 13, 31) will return 3 Mar 2021 not 28 Feb 2021 as desired. So
	  // we'll default to the end of the desired month by adding 1 to the desired
	  // month and using a date of 0 to back up one day to the end of the desired
	  // month.
	
	  var endOfDesiredMonth = new Date(date.getTime());
	  endOfDesiredMonth.setMonth(date.getMonth() + amount + 1, 0);
	  var daysInMonth = endOfDesiredMonth.getDate();
	
	  if (dayOfMonth >= daysInMonth) {
	    // If we're already at the end of the month, then this is the correct date
	    // and we're done.
	    return endOfDesiredMonth;
	  } else {
	    // Otherwise, we now know that setting the original day-of-month value won't
	    // cause an overflow, so set the desired day-of-month. Note that we can't
	    // just set the date of `endOfDesiredMonth` because that object may have had
	    // its time changed in the unusual case where where a DST transition was on
	    // the last day of the month and its local time was in the hour skipped or
	    // repeated next to a DST transition.  So we use `date` instead which is
	    // guaranteed to still have the original time.
	    date.setFullYear(endOfDesiredMonth.getFullYear(), endOfDesiredMonth.getMonth(), dayOfMonth);
	    return date;
	  }
	}
	
	module.exports = exports.default;

/***/ },
/* 113 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = getISOWeekYear;
	
	var _index = _interopRequireDefault(__webpack_require__(3));
	
	var _index2 = _interopRequireDefault(__webpack_require__(99));
	
	var _index3 = _interopRequireDefault(__webpack_require__(2));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name getISOWeekYear
	 * @category ISO Week-Numbering Year Helpers
	 * @summary Get the ISO week-numbering year of the given date.
	 *
	 * @description
	 * Get the ISO week-numbering year of the given date,
	 * which always starts 3 days before the year's first Thursday.
	 *
	 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * - The function was renamed from `getISOYear` to `getISOWeekYear`.
	 *   "ISO week year" is short for [ISO week-numbering year](https://en.wikipedia.org/wiki/ISO_week_date).
	 *   This change makes the name consistent with
	 *   locale-dependent week-numbering year helpers, e.g., `getWeekYear`.
	 *
	 * @param {Date|Number} date - the given date
	 * @returns {Number} the ISO week-numbering year
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // Which ISO-week numbering year is 2 January 2005?
	 * var result = getISOWeekYear(new Date(2005, 0, 2))
	 * //=> 2004
	 */
	function getISOWeekYear(dirtyDate) {
	  (0, _index3.default)(1, arguments);
	  var date = (0, _index.default)(dirtyDate);
	  var year = date.getFullYear();
	  var fourthOfJanuaryOfNextYear = new Date(0);
	  fourthOfJanuaryOfNextYear.setFullYear(year + 1, 0, 4);
	  fourthOfJanuaryOfNextYear.setHours(0, 0, 0, 0);
	  var startOfNextYear = (0, _index2.default)(fourthOfJanuaryOfNextYear);
	  var fourthOfJanuaryOfThisYear = new Date(0);
	  fourthOfJanuaryOfThisYear.setFullYear(year, 0, 4);
	  fourthOfJanuaryOfThisYear.setHours(0, 0, 0, 0);
	  var startOfThisYear = (0, _index2.default)(fourthOfJanuaryOfThisYear);
	
	  if (date.getTime() >= startOfNextYear.getTime()) {
	    return year + 1;
	  } else if (date.getTime() >= startOfThisYear.getTime()) {
	    return year;
	  } else {
	    return year - 1;
	  }
	}
	
	module.exports = exports.default;

/***/ },
/* 114 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isSameDay;
	
	var _index = _interopRequireDefault(__webpack_require__(116));
	
	var _index2 = _interopRequireDefault(__webpack_require__(2));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name isSameDay
	 * @category Day Helpers
	 * @summary Are the given dates in the same day?
	 *
	 * @description
	 * Are the given dates in the same day?
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} dateLeft - the first date to check
	 * @param {Date|Number} dateRight - the second date to check
	 * @returns {Boolean} the dates are in the same day
	 * @throws {TypeError} 2 arguments required
	 *
	 * @example
	 * // Are 4 September 06:00:00 and 4 September 18:00:00 in the same day?
	 * var result = isSameDay(new Date(2014, 8, 4, 6, 0), new Date(2014, 8, 4, 18, 0))
	 * //=> true
	 */
	function isSameDay(dirtyDateLeft, dirtyDateRight) {
	  (0, _index2.default)(2, arguments);
	  var dateLeftStartOfDay = (0, _index.default)(dirtyDateLeft);
	  var dateRightStartOfDay = (0, _index.default)(dirtyDateRight);
	  return dateLeftStartOfDay.getTime() === dateRightStartOfDay.getTime();
	}
	
	module.exports = exports.default;

/***/ },
/* 115 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(983));
	
	var _index2 = _interopRequireDefault(__webpack_require__(984));
	
	var _index3 = _interopRequireDefault(__webpack_require__(985));
	
	var _index4 = _interopRequireDefault(__webpack_require__(986));
	
	var _index5 = _interopRequireDefault(__webpack_require__(987));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @type {Locale}
	 * @category Locales
	 * @summary English locale (United States).
	 * @language English
	 * @iso-639-2 eng
	 * @author Sasha Koss [@kossnocorp]{@link https://github.com/kossnocorp}
	 * @author Lesha Koss [@leshakoss]{@link https://github.com/leshakoss}
	 */
	var locale = {
	  code: 'en-US',
	  formatDistance: _index.default,
	  formatLong: _index2.default,
	  formatRelative: _index3.default,
	  localize: _index4.default,
	  match: _index5.default,
	  options: {
	    weekStartsOn: 0
	    /* Sunday */
	    ,
	    firstWeekContainsDate: 1
	  }
	};
	var _default = locale;
	exports.default = _default;
	module.exports = exports.default;

/***/ },
/* 116 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = startOfDay;
	
	var _index = _interopRequireDefault(__webpack_require__(3));
	
	var _index2 = _interopRequireDefault(__webpack_require__(2));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name startOfDay
	 * @category Day Helpers
	 * @summary Return the start of a day for the given date.
	 *
	 * @description
	 * Return the start of a day for the given date.
	 * The result will be in the local timezone.
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} date - the original date
	 * @returns {Date} the start of a day
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // The start of a day for 2 September 2014 11:55:00:
	 * var result = startOfDay(new Date(2014, 8, 2, 11, 55, 0))
	 * //=> Tue Sep 02 2014 00:00:00
	 */
	function startOfDay(dirtyDate) {
	  (0, _index2.default)(1, arguments);
	  var date = (0, _index.default)(dirtyDate);
	  date.setHours(0, 0, 0, 0);
	  return date;
	}
	
	module.exports = exports.default;

/***/ },
/* 117 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {'use strict';
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }
	
	var React = __webpack_require__(1);
	var React__default = _interopDefault(React);
	var PropTypes = _interopDefault(__webpack_require__(20));
	var ReactDOM = _interopDefault(__webpack_require__(70));
	
	/**
	 * Copyright (c) 2014-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	/**
	 * Similar to invariant but only logs a warning if the condition is not met.
	 * This can be used to log issues in development environments in critical
	 * paths. Removing the logging code for production environments will keep the
	 * same logic and follow the same code paths.
	 */
	
	var __DEV__ = ("production") !== 'production';
	
	/* eslint-disable no-restricted-globals, eqeqeq  */
	/**
	 * React currently throws a warning when using useLayoutEffect on the server.
	 * To get around it, we can conditionally useEffect on the server (no-op) and
	 * useLayoutEffect in the browser. We occasionally need useLayoutEffect to
	 * ensure we don't get a render flash for certain operations, but we may also
	 * need affected components to render on the server. One example is when setting
	 * a component's descendants to retrieve their index values.
	 *
	 * Important to note that using this hook as an escape hatch will break the
	 * eslint dependency warnings unless you rename the import to `useLayoutEffect`.
	 * Use sparingly only when the effect won't effect the rendered HTML to avoid
	 * any server/client mismatch.
	 *
	 * If a useLayoutEffect is needed and the result would create a mismatch, it's
	 * likely that the component in question shouldn't be rendered on the server at
	 * all, so a better approach would be to lazily render those in a parent
	 * component after client-side hydration.
	 *
	 * TODO: We are calling useLayoutEffect in a couple of places that will likely
	 * cause some issues for SSR users, whether the warning shows or not. Audit and
	 * fix these.
	 *
	 * https://gist.github.com/gaearon/e7d97cdf38a2907924ea12e4ebdf3c85
	 * https://github.com/reduxjs/react-redux/blob/master/src/utils/useIsomorphicLayoutEffect.js
	 *
	 * @param effect
	 * @param deps
	 */
	
	var useIsomorphicLayoutEffect = /*#__PURE__*/canUseDOM() ? React__default.useLayoutEffect : React__default.useEffect;
	
	if (false) {
	  // In CJS files, process.env.NODE_ENV is stripped from our build, but we need
	  // it to prevent style checks from clogging up user logs while testing.
	  // This is a workaround until we can tweak the build a bit to accommodate.
	  var _ref = typeof process !== "undefined" ? process : {
	    env: {
	      NODE_ENV: "development"
	    }
	  },
	      env = _ref.env;
	}
	/**
	 * Ponyfill for the global object in some environments.
	 *
	 * @link https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
	 */
	
	var ponyfillGlobal = typeof window != "undefined" && window.Math == Math ? window : typeof self != "undefined" && self.Math == Math ? self :
	/*#__PURE__*/
	// eslint-disable-next-line no-new-func
	Function("return this")();
	function canUseDOM() {
	  return !!(typeof window !== "undefined" && window.document && window.document.createElement);
	}
	
	if (false) ;
	
	if (false) ;
	
	if (false) ;
	
	/*
	 * Welcome to @reach/auto-id!
	
	 * Let's see if we can make sense of why this hook exists and its
	 * implementation.
	 *
	 * Some background:
	 *   1. Accessibiliy APIs rely heavily on element IDs
	 *   2. Requiring developers to put IDs on every element in Reach UI is both
	 *      cumbersome and error-prone
	 *   3. With a component model, we can generate IDs for them!
	 *
	 * Solution 1: Generate random IDs.
	 *
	 * This works great as long as you don't server render your app. When React (in
	 * the client) tries to reuse the markup from the server, the IDs won't match
	 * and React will then recreate the entire DOM tree.
	 *
	 * Solution 2: Increment an integer
	 *
	 * This sounds great. Since we're rendering the exact same tree on the server
	 * and client, we can increment a counter and get a deterministic result between
	 * client and server. Also, JS integers can go up to nine-quadrillion. I'm
	 * pretty sure the tab will be closed before an app never needs
	 * 10 quadrillion IDs!
	 *
	 * Problem solved, right?
	 *
	 * Ah, but there's a catch! React's concurrent rendering makes this approach
	 * non-deterministic. While the client and server will end up with the same
	 * elements in the end, depending on suspense boundaries (and possibly some user
	 * input during the initial render) the incrementing integers won't always match
	 * up.
	 *
	 * Solution 3: Don't use IDs at all on the server; patch after first render.
	 *
	 * What we've done here is solution 2 with some tricks. With this approach, the
	 * ID returned is an empty string on the first render. This way the server and
	 * client have the same markup no matter how wild the concurrent rendering may
	 * have gotten.
	 *
	 * After the render, we patch up the components with an incremented ID. This
	 * causes a double render on any components with `useId`. Shouldn't be a problem
	 * since the components using this hook should be small, and we're only updating
	 * the ID attribute on the DOM, nothing big is happening.
	 *
	 * It doesn't have to be an incremented number, though--we could do generate
	 * random strings instead, but incrementing a number is probably the cheapest
	 * thing we can do.
	 *
	 * Additionally, we only do this patchup on the very first client render ever.
	 * Any calls to `useId` that happen dynamically in the client will be
	 * populated immediately with a value. So, we only get the double render after
	 * server hydration and never again, SO BACK OFF ALRIGHT?
	 */
	var serverHandoffComplete = false;
	var id = 0;
	
	var genId = function genId() {
	  return ++id;
	};
	/**
	 * useId
	 *
	 * Autogenerate IDs to facilitate WAI-ARIA and server rendering.
	 *
	 * Note: The returned ID will initially be `null` and will update after a
	 * component mounts. Users may need to supply their own ID if they need
	 * consistent values for SSR.
	 *
	 * @see Docs https://reacttraining.com/reach-ui/auto-id
	 */
	
	
	var useId = function useId(idFromProps) {
	  /*
	   * If this instance isn't part of the initial render, we don't have to do the
	   * double render/patch-up dance. We can just generate the ID and return it.
	   */
	  var initialId = idFromProps || (serverHandoffComplete ? genId() : null);
	
	  var _useState = React.useState(initialId),
	      id = _useState[0],
	      setId = _useState[1];
	
	  useIsomorphicLayoutEffect(function () {
	    if (id === null) {
	      /*
	       * Patch the ID after render. We do this in `useLayoutEffect` to avoid any
	       * rendering flicker, though it'll make the first render slower (unlikely
	       * to matter, but you're welcome to measure your app and let us know if
	       * it's a problem).
	       */
	      setId(genId());
	    } // eslint-disable-next-line react-hooks/exhaustive-deps
	
	  }, []);
	  React.useEffect(function () {
	    if (serverHandoffComplete === false) {
	      /*
	       * Flag all future uses of `useId` to skip the update dance. This is in
	       * `useEffect` because it goes after `useLayoutEffect`, ensuring we don't
	       * accidentally bail out of the patch-up dance prematurely.
	       */
	      serverHandoffComplete = true;
	    }
	  }, []);
	  return id != null ? String(id) : undefined;
	};
	
	function styleInject(css, ref) {
	  if ( ref === void 0 ) ref = {};
	  var insertAt = ref.insertAt;
	
	  if (!css || typeof document === 'undefined') { return; }
	
	  var head = document.head || document.getElementsByTagName('head')[0];
	  var style = document.createElement('style');
	  style.type = 'text/css';
	
	  if (insertAt === 'top') {
	    if (head.firstChild) {
	      head.insertBefore(style, head.firstChild);
	    } else {
	      head.appendChild(style);
	    }
	  } else {
	    head.appendChild(style);
	  }
	
	  if (style.styleSheet) {
	    style.styleSheet.cssText = css;
	  } else {
	    style.appendChild(document.createTextNode(css));
	  }
	}
	
	var css = ".Stage_wrapper__1X5K_ {\n  width: 100%;\n  height: 100%;\n  min-height: 100px;\n  background-color: rgb(26, 28, 29);\n  background-image: linear-gradient(\n      0deg,\n      transparent 24%,\n      rgba(255, 255, 255, 0.04) 25%,\n      rgba(255, 255, 255, 0.04) 26%,\n      transparent 27%,\n      transparent 74%,\n      rgba(255, 255, 255, 0.04) 75%,\n      rgba(255, 255, 255, 0.04) 76%,\n      transparent 77%,\n      transparent\n    ),\n    linear-gradient(\n      90deg,\n      transparent 24%,\n      rgba(255, 255, 255, 0.04) 25%,\n      rgba(255, 255, 255, 0.04) 26%,\n      transparent 27%,\n      transparent 74%,\n      rgba(255, 255, 255, 0.04) 75%,\n      rgba(255, 255, 255, 0.04) 76%,\n      transparent 77%,\n      transparent\n    );\n  color: #000;\n  background-size: 30px 30px;\n  position: relative;\n  overflow: hidden;\n  -webkit-overflow-scrolling: touch;\n  font-family: Helvetica, sans-serif;\n  text-align: left;\n  line-height: 1;\n  outline: none !important;\n}\n.Stage_wrapper__1X5K_ * {\n  box-sizing: border-box;\n}\n.Stage_wrapper__1X5K_ input,\ntextarea,\nselect {\n  font-family: Helvetica, sans-serif;\n}\n.Stage_transformWrapper__3CfIp {\n  transform-origin: center center;\n  position: absolute;\n  left: 50%;\n  top: 50%;\n  width: 0px;\n  height: 0px;\n}\n.Stage_scaleWrapper__2Y7Ck {\n  position: absolute;\n  left: 0px;\n  top: 0px;\n  width: 0px;\n  height: 0px;\n}\n";
	var styles = { "wrapper": "Stage_wrapper__1X5K_", "transformWrapper": "Stage_transformWrapper__3CfIp", "scaleWrapper": "Stage_scaleWrapper__2Y7Ck" };
	styleInject(css);
	
	var canUseDOM$1 = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Portal = function (_React$Component) {
	  _inherits(Portal, _React$Component);
	
	  function Portal() {
	    _classCallCheck(this, Portal);
	
	    return _possibleConstructorReturn(this, (Portal.__proto__ || Object.getPrototypeOf(Portal)).apply(this, arguments));
	  }
	
	  _createClass(Portal, [{
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      if (this.defaultNode) {
	        document.body.removeChild(this.defaultNode);
	      }
	      this.defaultNode = null;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      if (!canUseDOM$1) {
	        return null;
	      }
	      if (!this.props.node && !this.defaultNode) {
	        this.defaultNode = document.createElement('div');
	        document.body.appendChild(this.defaultNode);
	      }
	      return ReactDOM.createPortal(this.props.children, this.props.node || this.defaultNode);
	    }
	  }]);
	
	  return Portal;
	}(React__default.Component);
	
	Portal.propTypes = {
	  children: PropTypes.node.isRequired,
	  node: PropTypes.any
	};
	
	var _createClass$1 = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck$1(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn$1(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits$1(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Portal$1 = function (_React$Component) {
	  _inherits$1(Portal, _React$Component);
	
	  function Portal() {
	    _classCallCheck$1(this, Portal);
	
	    return _possibleConstructorReturn$1(this, (Portal.__proto__ || Object.getPrototypeOf(Portal)).apply(this, arguments));
	  }
	
	  _createClass$1(Portal, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.renderPortal();
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate(props) {
	      this.renderPortal();
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      ReactDOM.unmountComponentAtNode(this.defaultNode || this.props.node);
	      if (this.defaultNode) {
	        document.body.removeChild(this.defaultNode);
	      }
	      this.defaultNode = null;
	      this.portal = null;
	    }
	  }, {
	    key: 'renderPortal',
	    value: function renderPortal(props) {
	      if (!this.props.node && !this.defaultNode) {
	        this.defaultNode = document.createElement('div');
	        document.body.appendChild(this.defaultNode);
	      }
	
	      var children = this.props.children;
	      // https://gist.github.com/jimfb/d99e0678e9da715ccf6454961ef04d1b
	      if (typeof this.props.children.type === 'function') {
	        children = React__default.cloneElement(this.props.children);
	      }
	
	      this.portal = ReactDOM.unstable_renderSubtreeIntoContainer(this, children, this.props.node || this.defaultNode);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return null;
	    }
	  }]);
	
	  return Portal;
	}(React__default.Component);
	
	
	Portal$1.propTypes = {
	  children: PropTypes.node.isRequired,
	  node: PropTypes.any
	};
	
	var Portal$2 = void 0;
	
	if (ReactDOM.createPortal) {
	  Portal$2 = Portal;
	} else {
	  Portal$2 = Portal$1;
	}
	
	var Portal$3 = Portal$2;
	
	var _createClass$2 = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck$2(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn$2(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits$2(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var KEYCODES = {
	  ESCAPE: 27
	};
	
	var PortalWithState = function (_React$Component) {
	  _inherits$2(PortalWithState, _React$Component);
	
	  function PortalWithState(props) {
	    _classCallCheck$2(this, PortalWithState);
	
	    var _this = _possibleConstructorReturn$2(this, (PortalWithState.__proto__ || Object.getPrototypeOf(PortalWithState)).call(this, props));
	
	    _this.portalNode = null;
	    _this.state = { active: !!props.defaultOpen };
	    _this.openPortal = _this.openPortal.bind(_this);
	    _this.closePortal = _this.closePortal.bind(_this);
	    _this.wrapWithPortal = _this.wrapWithPortal.bind(_this);
	    _this.handleOutsideMouseClick = _this.handleOutsideMouseClick.bind(_this);
	    _this.handleKeydown = _this.handleKeydown.bind(_this);
	    return _this;
	  }
	
	  _createClass$2(PortalWithState, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      if (this.props.closeOnEsc) {
	        document.addEventListener('keydown', this.handleKeydown);
	      }
	      if (this.props.closeOnOutsideClick) {
	        document.addEventListener('click', this.handleOutsideMouseClick);
	      }
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      if (this.props.closeOnEsc) {
	        document.removeEventListener('keydown', this.handleKeydown);
	      }
	      if (this.props.closeOnOutsideClick) {
	        document.removeEventListener('click', this.handleOutsideMouseClick);
	      }
	    }
	  }, {
	    key: 'openPortal',
	    value: function openPortal(e) {
	      if (this.state.active) {
	        return;
	      }
	      if (e && e.nativeEvent) {
	        e.nativeEvent.stopImmediatePropagation();
	      }
	      this.setState({ active: true }, this.props.onOpen);
	    }
	  }, {
	    key: 'closePortal',
	    value: function closePortal() {
	      if (!this.state.active) {
	        return;
	      }
	      this.setState({ active: false }, this.props.onClose);
	    }
	  }, {
	    key: 'wrapWithPortal',
	    value: function wrapWithPortal(children) {
	      var _this2 = this;
	
	      if (!this.state.active) {
	        return null;
	      }
	      return React__default.createElement(
	        Portal$3,
	        {
	          node: this.props.node,
	          key: 'react-portal',
	          ref: function ref(portalNode) {
	            return _this2.portalNode = portalNode;
	          }
	        },
	        children
	      );
	    }
	  }, {
	    key: 'handleOutsideMouseClick',
	    value: function handleOutsideMouseClick(e) {
	      if (!this.state.active) {
	        return;
	      }
	      var root = this.portalNode && (this.portalNode.props.node || this.portalNode.defaultNode);
	      if (!root || root.contains(e.target) || e.button && e.button !== 0) {
	        return;
	      }
	      this.closePortal();
	    }
	  }, {
	    key: 'handleKeydown',
	    value: function handleKeydown(e) {
	      if (e.keyCode === KEYCODES.ESCAPE && this.state.active) {
	        this.closePortal();
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return this.props.children({
	        openPortal: this.openPortal,
	        closePortal: this.closePortal,
	        portal: this.wrapWithPortal,
	        isOpen: this.state.active
	      });
	    }
	  }]);
	
	  return PortalWithState;
	}(React__default.Component);
	
	PortalWithState.propTypes = {
	  children: PropTypes.func.isRequired,
	  defaultOpen: PropTypes.bool,
	  node: PropTypes.any,
	  closeOnEsc: PropTypes.bool,
	  closeOnOutsideClick: PropTypes.bool,
	  onOpen: PropTypes.func,
	  onClose: PropTypes.func
	};
	
	PortalWithState.defaultProps = {
	  onOpen: function onOpen() {},
	  onClose: function onClose() {}
	};
	
	var css$1 = ".ContextMenu_menuWrapper__1BheJ{\n  position: fixed;\n  z-index: 9999;\n  background: rgba(29, 32, 34, 0.95);\n  border-radius: 5px;\n  box-shadow: 0px 6px 7px rgba(0,0,0,.3);\n  border: 1px solid rgba(0,0,0,.4);\n  font-size: 14px;\n  max-width: 300px;\n  min-width: 150px;\n  font-family: Helvetica, sans-serif;\n  line-height: 1.15;\n  outline: none;\n}\n@supports (backdrop-filter: blur(6px)){\n  .ContextMenu_menuWrapper__1BheJ{\n    backdrop-filter: blur(6px);\n    background: rgba(29, 32, 34, 0.8);\n  }\n}\n.ContextMenu_menuHeader__1Cw58{\n  padding: 5px;\n  border-bottom: 1px solid rgba(255,255,255,.1);\n  display: flex;\n  flex-direction: column;\n}\n.ContextMenu_menuLabel__158Pv{\n  margin: 0px;\n  color: #fff;\n  font-size: 16px;\n  font-weight: 600;\n}\n.ContextMenu_optionsWrapper__2YK_z{\n  max-height: 300px;\n  overflow-y: auto;\n  display: flex;\n  flex-direction: column;\n}\n.ContextMenu_menuFilter__1goBp{\n  border: none;\n  background: none;\n  height: 24px;\n  flex: 1 1 auto;\n  width: 100%;\n  outline: none;\n  color: #fff;\n}\n.ContextMenu_menuFilter__1goBp::placeholder{\n    font-style: italic;\n  }\n.ContextMenu_option__33MDL{\n  display: flex;\n  flex-direction: column;\n  flex-shrink: 0;\n  padding: 5px;\n  border-bottom: 1px solid rgba(255,255,255,.1);\n  color: #ffffff;\n}\n.ContextMenu_option__33MDL:last-child{\n    border-bottom: none;\n  }\n.ContextMenu_option__33MDL:hover{\n    background: rgba(255,255,255,.05);\n  }\n.ContextMenu_option__33MDL label{\n    margin-bottom: 5px;\n    user-select: none;\n  }\n.ContextMenu_option__33MDL label:last-child{\n      margin-bottom: 0px;\n    }\n.ContextMenu_option__33MDL p{\n    margin: 0px;\n    font-style: italic;\n    font-size: 12px;\n    color: rgb(182, 186, 194);\n    user-select: none;\n  }\n.ContextMenu_option__33MDL[data-selected=true]{\n    background: rgba(255,255,255,.05);\n  }\n.ContextMenu_emptyText__2rcXy{\n  color: #fff;\n  padding: 5px;\n}\n";
	var styles$1 = { "menuWrapper": "ContextMenu_menuWrapper__1BheJ", "menuHeader": "ContextMenu_menuHeader__1Cw58", "menuLabel": "ContextMenu_menuLabel__158Pv", "optionsWrapper": "ContextMenu_optionsWrapper__2YK_z", "menuFilter": "ContextMenu_menuFilter__1goBp", "option": "ContextMenu_option__33MDL", "emptyText": "ContextMenu_emptyText__2rcXy" };
	styleInject(css$1);
	
	/**
	 * The base implementation of `_.clamp` which doesn't coerce arguments.
	 *
	 * @private
	 * @param {number} number The number to clamp.
	 * @param {number} [lower] The lower bound.
	 * @param {number} upper The upper bound.
	 * @returns {number} Returns the clamped number.
	 */
	function baseClamp(number, lower, upper) {
	  if (number === number) {
	    if (upper !== undefined) {
	      number = number <= upper ? number : upper;
	    }
	    if (lower !== undefined) {
	      number = number >= lower ? number : lower;
	    }
	  }
	  return number;
	}
	
	var _baseClamp = baseClamp;
	
	/**
	 * Checks if `value` is the
	 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
	 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
	 * @example
	 *
	 * _.isObject({});
	 * // => true
	 *
	 * _.isObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isObject(_.noop);
	 * // => true
	 *
	 * _.isObject(null);
	 * // => false
	 */
	function isObject(value) {
	  var type = typeof value;
	  return value != null && (type == 'object' || type == 'function');
	}
	
	var isObject_1 = isObject;
	
	var commonjsGlobal = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};
	
	function createCommonjsModule(fn, module) {
		return module = { exports: {} }, fn(module, module.exports), module.exports;
	}
	
	/** Detect free variable `global` from Node.js. */
	var freeGlobal = typeof commonjsGlobal == 'object' && commonjsGlobal && commonjsGlobal.Object === Object && commonjsGlobal;
	
	var _freeGlobal = freeGlobal;
	
	/** Detect free variable `self`. */
	var freeSelf = typeof self == 'object' && self && self.Object === Object && self;
	
	/** Used as a reference to the global object. */
	var root = _freeGlobal || freeSelf || Function('return this')();
	
	var _root = root;
	
	/** Built-in value references. */
	var Symbol$1 = _root.Symbol;
	
	var _Symbol = Symbol$1;
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var nativeObjectToString = objectProto.toString;
	
	/** Built-in value references. */
	var symToStringTag = _Symbol ? _Symbol.toStringTag : undefined;
	
	/**
	 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @returns {string} Returns the raw `toStringTag`.
	 */
	function getRawTag(value) {
	  var isOwn = hasOwnProperty.call(value, symToStringTag),
	      tag = value[symToStringTag];
	
	  try {
	    value[symToStringTag] = undefined;
	  } catch (e) {}
	
	  var result = nativeObjectToString.call(value);
	  {
	    if (isOwn) {
	      value[symToStringTag] = tag;
	    } else {
	      delete value[symToStringTag];
	    }
	  }
	  return result;
	}
	
	var _getRawTag = getRawTag;
	
	/** Used for built-in method references. */
	var objectProto$1 = Object.prototype;
	
	/**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var nativeObjectToString$1 = objectProto$1.toString;
	
	/**
	 * Converts `value` to a string using `Object.prototype.toString`.
	 *
	 * @private
	 * @param {*} value The value to convert.
	 * @returns {string} Returns the converted string.
	 */
	function objectToString(value) {
	  return nativeObjectToString$1.call(value);
	}
	
	var _objectToString = objectToString;
	
	/** `Object#toString` result references. */
	var nullTag = '[object Null]',
	    undefinedTag = '[object Undefined]';
	
	/** Built-in value references. */
	var symToStringTag$1 = _Symbol ? _Symbol.toStringTag : undefined;
	
	/**
	 * The base implementation of `getTag` without fallbacks for buggy environments.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @returns {string} Returns the `toStringTag`.
	 */
	function baseGetTag(value) {
	  if (value == null) {
	    return value === undefined ? undefinedTag : nullTag;
	  }
	  return (symToStringTag$1 && symToStringTag$1 in Object(value))
	    ? _getRawTag(value)
	    : _objectToString(value);
	}
	
	var _baseGetTag = baseGetTag;
	
	/**
	 * Checks if `value` is object-like. A value is object-like if it's not `null`
	 * and has a `typeof` result of "object".
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
	 * @example
	 *
	 * _.isObjectLike({});
	 * // => true
	 *
	 * _.isObjectLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isObjectLike(_.noop);
	 * // => false
	 *
	 * _.isObjectLike(null);
	 * // => false
	 */
	function isObjectLike(value) {
	  return value != null && typeof value == 'object';
	}
	
	var isObjectLike_1 = isObjectLike;
	
	/** `Object#toString` result references. */
	var symbolTag = '[object Symbol]';
	
	/**
	 * Checks if `value` is classified as a `Symbol` primitive or object.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
	 * @example
	 *
	 * _.isSymbol(Symbol.iterator);
	 * // => true
	 *
	 * _.isSymbol('abc');
	 * // => false
	 */
	function isSymbol(value) {
	  return typeof value == 'symbol' ||
	    (isObjectLike_1(value) && _baseGetTag(value) == symbolTag);
	}
	
	var isSymbol_1 = isSymbol;
	
	/** Used as references for various `Number` constants. */
	var NAN = 0 / 0;
	
	/** Used to match leading and trailing whitespace. */
	var reTrim = /^\s+|\s+$/g;
	
	/** Used to detect bad signed hexadecimal string values. */
	var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
	
	/** Used to detect binary string values. */
	var reIsBinary = /^0b[01]+$/i;
	
	/** Used to detect octal string values. */
	var reIsOctal = /^0o[0-7]+$/i;
	
	/** Built-in method references without a dependency on `root`. */
	var freeParseInt = parseInt;
	
	/**
	 * Converts `value` to a number.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to process.
	 * @returns {number} Returns the number.
	 * @example
	 *
	 * _.toNumber(3.2);
	 * // => 3.2
	 *
	 * _.toNumber(Number.MIN_VALUE);
	 * // => 5e-324
	 *
	 * _.toNumber(Infinity);
	 * // => Infinity
	 *
	 * _.toNumber('3.2');
	 * // => 3.2
	 */
	function toNumber(value) {
	  if (typeof value == 'number') {
	    return value;
	  }
	  if (isSymbol_1(value)) {
	    return NAN;
	  }
	  if (isObject_1(value)) {
	    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
	    value = isObject_1(other) ? (other + '') : other;
	  }
	  if (typeof value != 'string') {
	    return value === 0 ? value : +value;
	  }
	  value = value.replace(reTrim, '');
	  var isBinary = reIsBinary.test(value);
	  return (isBinary || reIsOctal.test(value))
	    ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
	    : (reIsBadHex.test(value) ? NAN : +value);
	}
	
	var toNumber_1 = toNumber;
	
	/**
	 * Clamps `number` within the inclusive `lower` and `upper` bounds.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Number
	 * @param {number} number The number to clamp.
	 * @param {number} [lower] The lower bound.
	 * @param {number} upper The upper bound.
	 * @returns {number} Returns the clamped number.
	 * @example
	 *
	 * _.clamp(-10, -5, 5);
	 * // => -5
	 *
	 * _.clamp(10, -5, 5);
	 * // => 5
	 */
	function clamp(number, lower, upper) {
	  if (upper === undefined) {
	    upper = lower;
	    lower = undefined;
	  }
	  if (upper !== undefined) {
	    upper = toNumber_1(upper);
	    upper = upper === upper ? upper : 0;
	  }
	  if (lower !== undefined) {
	    lower = toNumber_1(lower);
	    lower = lower === lower ? lower : 0;
	  }
	  return _baseClamp(toNumber_1(number), lower, upper);
	}
	
	var clamp_1 = clamp;
	
	// This alphabet uses a-z A-Z 0-9 _- symbols.
	// Symbols are generated for smaller size.
	// -_zyxwvutsrqponmlkjihgfedcba9876543210ZYXWVUTSRQPONMLKJIHGFEDCBA
	var url = '-_';
	// Loop from 36 to 0 (from z to a and 9 to 0 in Base36).
	var i = 36;
	while (i--) {
	  // 36 is radix. Number.prototype.toString(36) returns number
	  // in Base36 representation. Base36 is like hex, but it uses 0–9 and a-z.
	  url += i.toString(36);
	}
	// Loop from 36 to 10 (from Z to A in Base36).
	i = 36;
	while (i-- - 10) {
	  url += i.toString(36).toUpperCase();
	}
	
	/**
	 * Generate URL-friendly unique ID. This method use non-secure predictable
	 * random generator with bigger collision probability.
	 *
	 * @param {number} [size=21] The number of symbols in ID.
	 *
	 * @return {string} Random string.
	 *
	 * @example
	 * const nanoid = require('nanoid/non-secure')
	 * model.id = nanoid() //=> "Uakgb_J5m9g-0JDMbcJqL"
	 *
	 * @name nonSecure
	 * @function
	 */
	var nonSecure = function (size) {
	  var id = '';
	  i = size || 21;
	  // Compact alternative for `for (var i = 0; i < size; i++)`
	  while (i--) {
	    // `| 0` is compact and faster alternative for `Math.floor()`
	    id += url[Math.random() * 64 | 0];
	  }
	  return id
	};
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {
	  return typeof obj;
	} : function (obj) {
	  return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
	};
	
	var classCallCheck = function (instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	};
	
	var createClass = function () {
	  function defineProperties(target, props) {
	    for (var i = 0; i < props.length; i++) {
	      var descriptor = props[i];
	      descriptor.enumerable = descriptor.enumerable || false;
	      descriptor.configurable = true;
	      if ("value" in descriptor) descriptor.writable = true;
	      Object.defineProperty(target, descriptor.key, descriptor);
	    }
	  }
	
	  return function (Constructor, protoProps, staticProps) {
	    if (protoProps) defineProperties(Constructor.prototype, protoProps);
	    if (staticProps) defineProperties(Constructor, staticProps);
	    return Constructor;
	  };
	}();
	
	var defineProperty = function (obj, key, value) {
	  if (key in obj) {
	    Object.defineProperty(obj, key, {
	      value: value,
	      enumerable: true,
	      configurable: true,
	      writable: true
	    });
	  } else {
	    obj[key] = value;
	  }
	
	  return obj;
	};
	
	var _extends = Object.assign || function (target) {
	  for (var i = 1; i < arguments.length; i++) {
	    var source = arguments[i];
	
	    for (var key in source) {
	      if (Object.prototype.hasOwnProperty.call(source, key)) {
	        target[key] = source[key];
	      }
	    }
	  }
	
	  return target;
	};
	
	var inherits = function (subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
	  }
	
	  subClass.prototype = Object.create(superClass && superClass.prototype, {
	    constructor: {
	      value: subClass,
	      enumerable: false,
	      writable: true,
	      configurable: true
	    }
	  });
	  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
	};
	
	var objectWithoutProperties = function (obj, keys) {
	  var target = {};
	
	  for (var i in obj) {
	    if (keys.indexOf(i) >= 0) continue;
	    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
	    target[i] = obj[i];
	  }
	
	  return target;
	};
	
	var possibleConstructorReturn = function (self, call) {
	  if (!self) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }
	
	  return call && (typeof call === "object" || typeof call === "function") ? call : self;
	};
	
	var slicedToArray = function () {
	  function sliceIterator(arr, i) {
	    var _arr = [];
	    var _n = true;
	    var _d = false;
	    var _e = undefined;
	
	    try {
	      for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
	        _arr.push(_s.value);
	
	        if (i && _arr.length === i) break;
	      }
	    } catch (err) {
	      _d = true;
	      _e = err;
	    } finally {
	      try {
	        if (!_n && _i["return"]) _i["return"]();
	      } finally {
	        if (_d) throw _e;
	      }
	    }
	
	    return _arr;
	  }
	
	  return function (arr, i) {
	    if (Array.isArray(arr)) {
	      return arr;
	    } else if (Symbol.iterator in Object(arr)) {
	      return sliceIterator(arr, i);
	    } else {
	      throw new TypeError("Invalid attempt to destructure non-iterable instance");
	    }
	  };
	}();
	
	var toConsumableArray = function (arr) {
	  if (Array.isArray(arr)) {
	    for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) arr2[i] = arr[i];
	
	    return arr2;
	  } else {
	    return Array.from(arr);
	  }
	};
	
	var ContextMenu = function ContextMenu(_ref) {
	  var x = _ref.x,
	      y = _ref.y,
	      _ref$options = _ref.options,
	      options = _ref$options === undefined ? [] : _ref$options,
	      onRequestClose = _ref.onRequestClose,
	      onOptionSelected = _ref.onOptionSelected,
	      label = _ref.label,
	      hideHeader = _ref.hideHeader,
	      hideFilter = _ref.hideFilter,
	      emptyText = _ref.emptyText;
	
	  var menuWrapper = React__default.useRef();
	  var menuOptionsWrapper = React__default.useRef();
	  var filterInput = React__default.useRef();
	
	  var _React$useState = React__default.useState(""),
	      _React$useState2 = slicedToArray(_React$useState, 2),
	      filter = _React$useState2[0],
	      setFilter = _React$useState2[1];
	
	  var _React$useState3 = React__default.useState(0),
	      _React$useState4 = slicedToArray(_React$useState3, 2),
	      menuWidth = _React$useState4[0],
	      setMenuWidth = _React$useState4[1];
	
	  var _React$useState5 = React__default.useState(0),
	      _React$useState6 = slicedToArray(_React$useState5, 2),
	      selectedIndex = _React$useState6[0],
	      setSelectedIndex = _React$useState6[1];
	
	  var menuId = React__default.useRef(nonSecure(10));
	
	  var handleOptionSelected = function handleOptionSelected(option) {
	    onOptionSelected(option);
	    onRequestClose();
	  };
	
	  var testClickOutside = React__default.useCallback(function (e) {
	    if (menuWrapper.current && !menuWrapper.current.contains(e.target)) {
	      onRequestClose();
	      document.removeEventListener("click", testClickOutside, { capture: true });
	      document.removeEventListener("contextmenu", testClickOutside, { capture: true });
	    }
	  }, [menuWrapper, onRequestClose]);
	
	  var testEscape = React__default.useCallback(function (e) {
	    if (e.keyCode === 27) {
	      onRequestClose();
	      document.removeEventListener("keydown", testEscape, { capture: true });
	    }
	  }, [onRequestClose]);
	
	  React__default.useEffect(function () {
	    if (filterInput.current) {
	      filterInput.current.focus();
	    }
	    setMenuWidth(menuWrapper.current.getBoundingClientRect().width);
	    document.addEventListener("keydown", testEscape, { capture: true });
	    document.addEventListener("click", testClickOutside, { capture: true });
	    document.addEventListener("contextmenu", testClickOutside, { capture: true });
	    return function () {
	      document.removeEventListener("click", testClickOutside, { capture: true });
	      document.removeEventListener("contextmenu", testClickOutside, { capture: true });
	      document.removeEventListener("keydown", testEscape, { capture: true });
	    };
	  }, [testClickOutside, testEscape]);
	
	  var filteredOptions = React__default.useMemo(function () {
	    if (!filter) return options;
	    var lowerFilter = filter.toLowerCase();
	    return options.filter(function (opt) {
	      return opt.label.toLowerCase().includes(lowerFilter);
	    });
	  }, [filter, options]);
	
	  var handleFilterChange = function handleFilterChange(e) {
	    var value = e.target.value;
	    setFilter(value);
	    setSelectedIndex(0);
	  };
	
	  var handleKeyDown = function handleKeyDown(e) {
	    // Up pressed
	    if (e.which === 38) {
	      e.preventDefault();
	      if (selectedIndex === null) {
	        setSelectedIndex(0);
	      } else if (selectedIndex > 0) {
	        setSelectedIndex(function (i) {
	          return i - 1;
	        });
	      }
	    }
	    // Down pressed
	    if (e.which === 40) {
	      e.preventDefault();
	      if (selectedIndex === null) {
	        setSelectedIndex(0);
	      } else if (selectedIndex < filteredOptions.length - 1) {
	        setSelectedIndex(function (i) {
	          return i + 1;
	        });
	      }
	    }
	    // Enter pressed
	    if (e.which === 13 && selectedIndex !== null) {
	      var option = filteredOptions[selectedIndex];
	      if (option) {
	        handleOptionSelected(option);
	      }
	    }
	  };
	
	  React__default.useEffect(function () {
	    if (hideFilter || hideHeader) {
	      menuWrapper.current.focus();
	    }
	  }, [hideFilter, hideHeader]);
	
	  React__default.useEffect(function () {
	    var menuOption = document.getElementById(menuId.current + "-" + selectedIndex);
	    if (menuOption) {
	      var menuRect = menuOptionsWrapper.current.getBoundingClientRect();
	      var optionRect = menuOption.getBoundingClientRect();
	      if (optionRect.y + optionRect.height > menuRect.y + menuRect.height || optionRect.y < menuRect.y) {
	        menuOption.scrollIntoView({ block: "nearest" });
	      }
	    }
	  }, [selectedIndex]);
	
	  return React__default.createElement(
	    "div",
	    {
	      className: styles$1.menuWrapper,
	      onMouseDown: function onMouseDown(e) {
	        return e.stopPropagation();
	      },
	      onKeyDown: handleKeyDown,
	      style: {
	        left: x,
	        top: y,
	        width: filter ? menuWidth : "auto"
	      },
	      ref: menuWrapper,
	      tabIndex: 0,
	      role: "menu",
	      "aria-activedescendant": menuId.current + "-" + selectedIndex
	    },
	    !hideHeader && (label ? true : !!options.length) ? React__default.createElement(
	      "div",
	      { className: styles$1.menuHeader },
	      React__default.createElement(
	        "label",
	        { className: styles$1.menuLabel },
	        label
	      ),
	      !hideFilter && options.length ? React__default.createElement("input", {
	        type: "text",
	        placeholder: "Filter options",
	        value: filter,
	        onChange: handleFilterChange,
	        className: styles$1.menuFilter,
	        autoFocus: true,
	        ref: filterInput
	      }) : null
	    ) : null,
	    React__default.createElement(
	      "div",
	      {
	        className: styles$1.optionsWrapper,
	        role: "menu",
	        ref: menuOptionsWrapper,
	        style: { maxHeight: clamp_1(window.innerHeight - y - 70, 10, 300) }
	      },
	      filteredOptions.map(function (option, i) {
	        return React__default.createElement(
	          ContextOption,
	          {
	            menuId: menuId.current,
	            selected: selectedIndex === i,
	            onClick: function onClick() {
	              return handleOptionSelected(option);
	            },
	            onMouseEnter: function onMouseEnter() {
	              return setSelectedIndex(null);
	            },
	            index: i,
	            key: option.value + i
	          },
	          React__default.createElement(
	            "label",
	            null,
	            option.label
	          ),
	          option.description ? React__default.createElement(
	            "p",
	            null,
	            option.description
	          ) : null
	        );
	      }),
	      !options.length ? React__default.createElement(
	        "span",
	        { className: styles$1.emptyText },
	        emptyText
	      ) : null
	    )
	  );
	};
	
	var ContextOption = function ContextOption(_ref2) {
	  var menuId = _ref2.menuId,
	      index = _ref2.index,
	      children = _ref2.children,
	      onClick = _ref2.onClick,
	      selected = _ref2.selected,
	      onMouseEnter = _ref2.onMouseEnter;
	
	  return React__default.createElement(
	    "div",
	    {
	      className: styles$1.option,
	      role: "menuitem",
	      onClick: onClick,
	      onMouseEnter: onMouseEnter,
	      "data-selected": selected,
	      id: menuId + "-" + index
	    },
	    children
	  );
	};
	
	var NodeTypesContext = React__default.createContext();
	var PortTypesContext = React__default.createContext();
	var NodeDispatchContext = React__default.createContext();
	var ConnectionRecalculateContext = React__default.createContext();
	var ContextContext = React__default.createContext();
	var StageContext = React__default.createContext();
	var CacheContext = React__default.createContext();
	var RecalculateStageRectContext = React__default.createContext();
	var EditorIdContext = React__default.createContext();
	
	var Draggable = (function (_ref) {
	  var children = _ref.children,
	      stageState = _ref.stageState,
	      stageRect = _ref.stageRect,
	      onDragDelayStart = _ref.onDragDelayStart,
	      onDragStart = _ref.onDragStart,
	      onDrag = _ref.onDrag,
	      onDragEnd = _ref.onDragEnd,
	      _onMouseDown = _ref.onMouseDown,
	      _onTouchStart = _ref.onTouchStart,
	      disabled = _ref.disabled,
	      _ref$delay = _ref.delay,
	      delay = _ref$delay === undefined ? 6 : _ref$delay,
	      innerRef = _ref.innerRef,
	      rest = objectWithoutProperties(_ref, ["children", "stageState", "stageRect", "onDragDelayStart", "onDragStart", "onDrag", "onDragEnd", "onMouseDown", "onTouchStart", "disabled", "delay", "innerRef"]);
	
	  var startCoordinates = React__default.useRef(null);
	  var offset = React__default.useRef();
	  var wrapper = React__default.useRef();
	
	  var byScale = function byScale(value) {
	    return 1 / stageState.scale * value;
	  };
	
	  var getScaledCoordinates = function getScaledCoordinates(e) {
	    var x = byScale(e.clientX - (stageRect ? stageRect.current.left : 0) - offset.current.x - (stageRect ? stageRect.current.width : 0) / 2) + byScale(stageState.translate.x);
	    var y = byScale(e.clientY - (stageRect ? stageRect.current.top : 0) - offset.current.y - (stageRect ? stageRect.current.height : 0) / 2) + byScale(stageState.translate.y);
	    return { x: x, y: y };
	  };
	
	  var updateCoordinates = function updateCoordinates(e) {
	    var coordinates = getScaledCoordinates(e);
	    if (onDrag) {
	      onDrag(coordinates, e);
	    }
	  };
	
	  var stopDrag = function stopDrag(e) {
	    var coordinates = getScaledCoordinates(e);
	    if (onDragEnd) {
	      onDragEnd(e, coordinates);
	    }
	    window.removeEventListener("mouseup", stopDrag);
	    window.removeEventListener("mousemove", updateCoordinates);
	  };
	
	  var startDrag = function startDrag(e) {
	    if (onDragStart) {
	      onDragStart(e);
	    }
	    var nodeRect = wrapper.current.getBoundingClientRect();
	    offset.current = {
	      x: startCoordinates.current.x - nodeRect.left,
	      y: startCoordinates.current.y - nodeRect.top
	    };
	    window.addEventListener("mouseup", stopDrag);
	    window.addEventListener("mousemove", updateCoordinates);
	  };
	
	  var checkDragDelay = function checkDragDelay(e) {
	    var x = void 0;
	    var y = void 0;
	    if ("ontouchstart" in window && e.touches) {
	      x = e.touches[0].clientX;
	      y = e.touches[0].clientY;
	    } else {
	      e.preventDefault();
	      x = e.clientX;
	      y = e.clientY;
	    }
	    var a = Math.abs(startCoordinates.current.x - x);
	    var b = Math.abs(startCoordinates.current.y - y);
	    var distance = Math.round(Math.sqrt(Math.pow(a, 2) + Math.pow(b, 2)));
	    var dragDistance = delay;
	    if (distance >= dragDistance) {
	      startDrag(e);
	      endDragDelay();
	    }
	  };
	
	  var endDragDelay = function endDragDelay() {
	    document.removeEventListener("mouseup", endDragDelay);
	    document.removeEventListener("mousemove", checkDragDelay);
	    startCoordinates.current = null;
	  };
	
	  var startDragDelay = function startDragDelay(e) {
	    if (onDragDelayStart) {
	      onDragDelayStart(e);
	    }
	    e.stopPropagation();
	    var x = void 0;
	    var y = void 0;
	    if ("ontouchstart" in window && e.touches) {
	      x = e.touches[0].clientX;
	      y = e.touches[0].clientY;
	    } else {
	      e.preventDefault();
	      x = e.clientX;
	      y = e.clientY;
	    }
	    startCoordinates.current = { x: x, y: y };
	    document.addEventListener("mouseup", endDragDelay);
	    document.addEventListener("mousemove", checkDragDelay);
	  };
	
	  return React__default.createElement(
	    "div",
	    _extends({
	      onMouseDown: function onMouseDown(e) {
	        if (!disabled) {
	          startDragDelay(e);
	        }
	        if (_onMouseDown) {
	          _onMouseDown(e);
	        }
	      },
	      onTouchStart: function onTouchStart(e) {
	        if (!disabled) {
	          startDragDelay(e);
	        }
	        if (_onTouchStart) {
	          _onTouchStart(e);
	        }
	      },
	      onDragStart: function onDragStart(e) {
	        e.preventDefault();
	        e.stopPropagation();
	      },
	      ref: function ref(_ref2) {
	        wrapper.current = _ref2;
	        if (innerRef) {
	          innerRef.current = _ref2;
	        }
	      }
	    }, rest),
	    children
	  );
	});
	
	/**
	 * A specialized version of `_.map` for arrays without support for iteratee
	 * shorthands.
	 *
	 * @private
	 * @param {Array} [array] The array to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Array} Returns the new mapped array.
	 */
	function arrayMap(array, iteratee) {
	  var index = -1,
	      length = array == null ? 0 : array.length,
	      result = Array(length);
	
	  while (++index < length) {
	    result[index] = iteratee(array[index], index, array);
	  }
	  return result;
	}
	
	var _arrayMap = arrayMap;
	
	/**
	 * Removes all key-value entries from the list cache.
	 *
	 * @private
	 * @name clear
	 * @memberOf ListCache
	 */
	function listCacheClear() {
	  this.__data__ = [];
	  this.size = 0;
	}
	
	var _listCacheClear = listCacheClear;
	
	/**
	 * Performs a
	 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	 * comparison between two values to determine if they are equivalent.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to compare.
	 * @param {*} other The other value to compare.
	 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	 * @example
	 *
	 * var object = { 'a': 1 };
	 * var other = { 'a': 1 };
	 *
	 * _.eq(object, object);
	 * // => true
	 *
	 * _.eq(object, other);
	 * // => false
	 *
	 * _.eq('a', 'a');
	 * // => true
	 *
	 * _.eq('a', Object('a'));
	 * // => false
	 *
	 * _.eq(NaN, NaN);
	 * // => true
	 */
	function eq(value, other) {
	  return value === other || (value !== value && other !== other);
	}
	
	var eq_1 = eq;
	
	/**
	 * Gets the index at which the `key` is found in `array` of key-value pairs.
	 *
	 * @private
	 * @param {Array} array The array to inspect.
	 * @param {*} key The key to search for.
	 * @returns {number} Returns the index of the matched value, else `-1`.
	 */
	function assocIndexOf(array, key) {
	  var length = array.length;
	  while (length--) {
	    if (eq_1(array[length][0], key)) {
	      return length;
	    }
	  }
	  return -1;
	}
	
	var _assocIndexOf = assocIndexOf;
	
	/** Used for built-in method references. */
	var arrayProto = Array.prototype;
	
	/** Built-in value references. */
	var splice = arrayProto.splice;
	
	/**
	 * Removes `key` and its value from the list cache.
	 *
	 * @private
	 * @name delete
	 * @memberOf ListCache
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function listCacheDelete(key) {
	  var data = this.__data__,
	      index = _assocIndexOf(data, key);
	
	  if (index < 0) {
	    return false;
	  }
	  var lastIndex = data.length - 1;
	  if (index == lastIndex) {
	    data.pop();
	  } else {
	    splice.call(data, index, 1);
	  }
	  --this.size;
	  return true;
	}
	
	var _listCacheDelete = listCacheDelete;
	
	/**
	 * Gets the list cache value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf ListCache
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function listCacheGet(key) {
	  var data = this.__data__,
	      index = _assocIndexOf(data, key);
	
	  return index < 0 ? undefined : data[index][1];
	}
	
	var _listCacheGet = listCacheGet;
	
	/**
	 * Checks if a list cache value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf ListCache
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function listCacheHas(key) {
	  return _assocIndexOf(this.__data__, key) > -1;
	}
	
	var _listCacheHas = listCacheHas;
	
	/**
	 * Sets the list cache `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf ListCache
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the list cache instance.
	 */
	function listCacheSet(key, value) {
	  var data = this.__data__,
	      index = _assocIndexOf(data, key);
	
	  if (index < 0) {
	    ++this.size;
	    data.push([key, value]);
	  } else {
	    data[index][1] = value;
	  }
	  return this;
	}
	
	var _listCacheSet = listCacheSet;
	
	/**
	 * Creates an list cache object.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function ListCache(entries) {
	  var index = -1,
	      length = entries == null ? 0 : entries.length;
	
	  this.clear();
	  while (++index < length) {
	    var entry = entries[index];
	    this.set(entry[0], entry[1]);
	  }
	}
	
	// Add methods to `ListCache`.
	ListCache.prototype.clear = _listCacheClear;
	ListCache.prototype['delete'] = _listCacheDelete;
	ListCache.prototype.get = _listCacheGet;
	ListCache.prototype.has = _listCacheHas;
	ListCache.prototype.set = _listCacheSet;
	
	var _ListCache = ListCache;
	
	/**
	 * Removes all key-value entries from the stack.
	 *
	 * @private
	 * @name clear
	 * @memberOf Stack
	 */
	function stackClear() {
	  this.__data__ = new _ListCache;
	  this.size = 0;
	}
	
	var _stackClear = stackClear;
	
	/**
	 * Removes `key` and its value from the stack.
	 *
	 * @private
	 * @name delete
	 * @memberOf Stack
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function stackDelete(key) {
	  var data = this.__data__,
	      result = data['delete'](key);
	
	  this.size = data.size;
	  return result;
	}
	
	var _stackDelete = stackDelete;
	
	/**
	 * Gets the stack value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf Stack
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function stackGet(key) {
	  return this.__data__.get(key);
	}
	
	var _stackGet = stackGet;
	
	/**
	 * Checks if a stack value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf Stack
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function stackHas(key) {
	  return this.__data__.has(key);
	}
	
	var _stackHas = stackHas;
	
	/** `Object#toString` result references. */
	var asyncTag = '[object AsyncFunction]',
	    funcTag = '[object Function]',
	    genTag = '[object GeneratorFunction]',
	    proxyTag = '[object Proxy]';
	
	/**
	 * Checks if `value` is classified as a `Function` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
	 * @example
	 *
	 * _.isFunction(_);
	 * // => true
	 *
	 * _.isFunction(/abc/);
	 * // => false
	 */
	function isFunction$1(value) {
	  if (!isObject_1(value)) {
	    return false;
	  }
	  // The use of `Object#toString` avoids issues with the `typeof` operator
	  // in Safari 9 which returns 'object' for typed arrays and other constructors.
	  var tag = _baseGetTag(value);
	  return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
	}
	
	var isFunction_1 = isFunction$1;
	
	/** Used to detect overreaching core-js shims. */
	var coreJsData = _root['__core-js_shared__'];
	
	var _coreJsData = coreJsData;
	
	/** Used to detect methods masquerading as native. */
	var maskSrcKey = (function() {
	  var uid = /[^.]+$/.exec(_coreJsData && _coreJsData.keys && _coreJsData.keys.IE_PROTO || '');
	  return uid ? ('Symbol(src)_1.' + uid) : '';
	}());
	
	/**
	 * Checks if `func` has its source masked.
	 *
	 * @private
	 * @param {Function} func The function to check.
	 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
	 */
	function isMasked(func) {
	  return !!maskSrcKey && (maskSrcKey in func);
	}
	
	var _isMasked = isMasked;
	
	/** Used for built-in method references. */
	var funcProto = Function.prototype;
	
	/** Used to resolve the decompiled source of functions. */
	var funcToString = funcProto.toString;
	
	/**
	 * Converts `func` to its source code.
	 *
	 * @private
	 * @param {Function} func The function to convert.
	 * @returns {string} Returns the source code.
	 */
	function toSource(func) {
	  if (func != null) {
	    try {
	      return funcToString.call(func);
	    } catch (e) {}
	    try {
	      return (func + '');
	    } catch (e) {}
	  }
	  return '';
	}
	
	var _toSource = toSource;
	
	/**
	 * Used to match `RegExp`
	 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
	 */
	var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
	
	/** Used to detect host constructors (Safari). */
	var reIsHostCtor = /^\[object .+?Constructor\]$/;
	
	/** Used for built-in method references. */
	var funcProto$1 = Function.prototype,
	    objectProto$2 = Object.prototype;
	
	/** Used to resolve the decompiled source of functions. */
	var funcToString$1 = funcProto$1.toString;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty$1 = objectProto$2.hasOwnProperty;
	
	/** Used to detect if a method is native. */
	var reIsNative = RegExp('^' +
	  funcToString$1.call(hasOwnProperty$1).replace(reRegExpChar, '\\$&')
	  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
	);
	
	/**
	 * The base implementation of `_.isNative` without bad shim checks.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a native function,
	 *  else `false`.
	 */
	function baseIsNative(value) {
	  if (!isObject_1(value) || _isMasked(value)) {
	    return false;
	  }
	  var pattern = isFunction_1(value) ? reIsNative : reIsHostCtor;
	  return pattern.test(_toSource(value));
	}
	
	var _baseIsNative = baseIsNative;
	
	/**
	 * Gets the value at `key` of `object`.
	 *
	 * @private
	 * @param {Object} [object] The object to query.
	 * @param {string} key The key of the property to get.
	 * @returns {*} Returns the property value.
	 */
	function getValue(object, key) {
	  return object == null ? undefined : object[key];
	}
	
	var _getValue = getValue;
	
	/**
	 * Gets the native function at `key` of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {string} key The key of the method to get.
	 * @returns {*} Returns the function if it's native, else `undefined`.
	 */
	function getNative(object, key) {
	  var value = _getValue(object, key);
	  return _baseIsNative(value) ? value : undefined;
	}
	
	var _getNative = getNative;
	
	/* Built-in method references that are verified to be native. */
	var Map = _getNative(_root, 'Map');
	
	var _Map = Map;
	
	/* Built-in method references that are verified to be native. */
	var nativeCreate = _getNative(Object, 'create');
	
	var _nativeCreate = nativeCreate;
	
	/**
	 * Removes all key-value entries from the hash.
	 *
	 * @private
	 * @name clear
	 * @memberOf Hash
	 */
	function hashClear() {
	  this.__data__ = _nativeCreate ? _nativeCreate(null) : {};
	  this.size = 0;
	}
	
	var _hashClear = hashClear;
	
	/**
	 * Removes `key` and its value from the hash.
	 *
	 * @private
	 * @name delete
	 * @memberOf Hash
	 * @param {Object} hash The hash to modify.
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function hashDelete(key) {
	  var result = this.has(key) && delete this.__data__[key];
	  this.size -= result ? 1 : 0;
	  return result;
	}
	
	var _hashDelete = hashDelete;
	
	/** Used to stand-in for `undefined` hash values. */
	var HASH_UNDEFINED = '__lodash_hash_undefined__';
	
	/** Used for built-in method references. */
	var objectProto$3 = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty$2 = objectProto$3.hasOwnProperty;
	
	/**
	 * Gets the hash value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf Hash
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function hashGet(key) {
	  var data = this.__data__;
	  if (_nativeCreate) {
	    var result = data[key];
	    return result === HASH_UNDEFINED ? undefined : result;
	  }
	  return hasOwnProperty$2.call(data, key) ? data[key] : undefined;
	}
	
	var _hashGet = hashGet;
	
	/** Used for built-in method references. */
	var objectProto$4 = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty$3 = objectProto$4.hasOwnProperty;
	
	/**
	 * Checks if a hash value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf Hash
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function hashHas(key) {
	  var data = this.__data__;
	  return _nativeCreate ? (data[key] !== undefined) : hasOwnProperty$3.call(data, key);
	}
	
	var _hashHas = hashHas;
	
	/** Used to stand-in for `undefined` hash values. */
	var HASH_UNDEFINED$1 = '__lodash_hash_undefined__';
	
	/**
	 * Sets the hash `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf Hash
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the hash instance.
	 */
	function hashSet(key, value) {
	  var data = this.__data__;
	  this.size += this.has(key) ? 0 : 1;
	  data[key] = (_nativeCreate && value === undefined) ? HASH_UNDEFINED$1 : value;
	  return this;
	}
	
	var _hashSet = hashSet;
	
	/**
	 * Creates a hash object.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function Hash(entries) {
	  var index = -1,
	      length = entries == null ? 0 : entries.length;
	
	  this.clear();
	  while (++index < length) {
	    var entry = entries[index];
	    this.set(entry[0], entry[1]);
	  }
	}
	
	// Add methods to `Hash`.
	Hash.prototype.clear = _hashClear;
	Hash.prototype['delete'] = _hashDelete;
	Hash.prototype.get = _hashGet;
	Hash.prototype.has = _hashHas;
	Hash.prototype.set = _hashSet;
	
	var _Hash = Hash;
	
	/**
	 * Removes all key-value entries from the map.
	 *
	 * @private
	 * @name clear
	 * @memberOf MapCache
	 */
	function mapCacheClear() {
	  this.size = 0;
	  this.__data__ = {
	    'hash': new _Hash,
	    'map': new (_Map || _ListCache),
	    'string': new _Hash
	  };
	}
	
	var _mapCacheClear = mapCacheClear;
	
	/**
	 * Checks if `value` is suitable for use as unique object key.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
	 */
	function isKeyable(value) {
	  var type = typeof value;
	  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
	    ? (value !== '__proto__')
	    : (value === null);
	}
	
	var _isKeyable = isKeyable;
	
	/**
	 * Gets the data for `map`.
	 *
	 * @private
	 * @param {Object} map The map to query.
	 * @param {string} key The reference key.
	 * @returns {*} Returns the map data.
	 */
	function getMapData(map, key) {
	  var data = map.__data__;
	  return _isKeyable(key)
	    ? data[typeof key == 'string' ? 'string' : 'hash']
	    : data.map;
	}
	
	var _getMapData = getMapData;
	
	/**
	 * Removes `key` and its value from the map.
	 *
	 * @private
	 * @name delete
	 * @memberOf MapCache
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function mapCacheDelete(key) {
	  var result = _getMapData(this, key)['delete'](key);
	  this.size -= result ? 1 : 0;
	  return result;
	}
	
	var _mapCacheDelete = mapCacheDelete;
	
	/**
	 * Gets the map value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf MapCache
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function mapCacheGet(key) {
	  return _getMapData(this, key).get(key);
	}
	
	var _mapCacheGet = mapCacheGet;
	
	/**
	 * Checks if a map value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf MapCache
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function mapCacheHas(key) {
	  return _getMapData(this, key).has(key);
	}
	
	var _mapCacheHas = mapCacheHas;
	
	/**
	 * Sets the map `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf MapCache
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the map cache instance.
	 */
	function mapCacheSet(key, value) {
	  var data = _getMapData(this, key),
	      size = data.size;
	
	  data.set(key, value);
	  this.size += data.size == size ? 0 : 1;
	  return this;
	}
	
	var _mapCacheSet = mapCacheSet;
	
	/**
	 * Creates a map cache object to store key-value pairs.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function MapCache(entries) {
	  var index = -1,
	      length = entries == null ? 0 : entries.length;
	
	  this.clear();
	  while (++index < length) {
	    var entry = entries[index];
	    this.set(entry[0], entry[1]);
	  }
	}
	
	// Add methods to `MapCache`.
	MapCache.prototype.clear = _mapCacheClear;
	MapCache.prototype['delete'] = _mapCacheDelete;
	MapCache.prototype.get = _mapCacheGet;
	MapCache.prototype.has = _mapCacheHas;
	MapCache.prototype.set = _mapCacheSet;
	
	var _MapCache = MapCache;
	
	/** Used as the size to enable large array optimizations. */
	var LARGE_ARRAY_SIZE = 200;
	
	/**
	 * Sets the stack `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf Stack
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the stack cache instance.
	 */
	function stackSet(key, value) {
	  var data = this.__data__;
	  if (data instanceof _ListCache) {
	    var pairs = data.__data__;
	    if (!_Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
	      pairs.push([key, value]);
	      this.size = ++data.size;
	      return this;
	    }
	    data = this.__data__ = new _MapCache(pairs);
	  }
	  data.set(key, value);
	  this.size = data.size;
	  return this;
	}
	
	var _stackSet = stackSet;
	
	/**
	 * Creates a stack cache object to store key-value pairs.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function Stack(entries) {
	  var data = this.__data__ = new _ListCache(entries);
	  this.size = data.size;
	}
	
	// Add methods to `Stack`.
	Stack.prototype.clear = _stackClear;
	Stack.prototype['delete'] = _stackDelete;
	Stack.prototype.get = _stackGet;
	Stack.prototype.has = _stackHas;
	Stack.prototype.set = _stackSet;
	
	var _Stack = Stack;
	
	/** Used to stand-in for `undefined` hash values. */
	var HASH_UNDEFINED$2 = '__lodash_hash_undefined__';
	
	/**
	 * Adds `value` to the array cache.
	 *
	 * @private
	 * @name add
	 * @memberOf SetCache
	 * @alias push
	 * @param {*} value The value to cache.
	 * @returns {Object} Returns the cache instance.
	 */
	function setCacheAdd(value) {
	  this.__data__.set(value, HASH_UNDEFINED$2);
	  return this;
	}
	
	var _setCacheAdd = setCacheAdd;
	
	/**
	 * Checks if `value` is in the array cache.
	 *
	 * @private
	 * @name has
	 * @memberOf SetCache
	 * @param {*} value The value to search for.
	 * @returns {number} Returns `true` if `value` is found, else `false`.
	 */
	function setCacheHas(value) {
	  return this.__data__.has(value);
	}
	
	var _setCacheHas = setCacheHas;
	
	/**
	 *
	 * Creates an array cache object to store unique values.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [values] The values to cache.
	 */
	function SetCache(values) {
	  var index = -1,
	      length = values == null ? 0 : values.length;
	
	  this.__data__ = new _MapCache;
	  while (++index < length) {
	    this.add(values[index]);
	  }
	}
	
	// Add methods to `SetCache`.
	SetCache.prototype.add = SetCache.prototype.push = _setCacheAdd;
	SetCache.prototype.has = _setCacheHas;
	
	var _SetCache = SetCache;
	
	/**
	 * A specialized version of `_.some` for arrays without support for iteratee
	 * shorthands.
	 *
	 * @private
	 * @param {Array} [array] The array to iterate over.
	 * @param {Function} predicate The function invoked per iteration.
	 * @returns {boolean} Returns `true` if any element passes the predicate check,
	 *  else `false`.
	 */
	function arraySome(array, predicate) {
	  var index = -1,
	      length = array == null ? 0 : array.length;
	
	  while (++index < length) {
	    if (predicate(array[index], index, array)) {
	      return true;
	    }
	  }
	  return false;
	}
	
	var _arraySome = arraySome;
	
	/**
	 * Checks if a `cache` value for `key` exists.
	 *
	 * @private
	 * @param {Object} cache The cache to query.
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function cacheHas(cache, key) {
	  return cache.has(key);
	}
	
	var _cacheHas = cacheHas;
	
	/** Used to compose bitmasks for value comparisons. */
	var COMPARE_PARTIAL_FLAG = 1,
	    COMPARE_UNORDERED_FLAG = 2;
	
	/**
	 * A specialized version of `baseIsEqualDeep` for arrays with support for
	 * partial deep comparisons.
	 *
	 * @private
	 * @param {Array} array The array to compare.
	 * @param {Array} other The other array to compare.
	 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	 * @param {Function} customizer The function to customize comparisons.
	 * @param {Function} equalFunc The function to determine equivalents of values.
	 * @param {Object} stack Tracks traversed `array` and `other` objects.
	 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
	 */
	function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
	  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
	      arrLength = array.length,
	      othLength = other.length;
	
	  if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
	    return false;
	  }
	  // Assume cyclic values are equal.
	  var stacked = stack.get(array);
	  if (stacked && stack.get(other)) {
	    return stacked == other;
	  }
	  var index = -1,
	      result = true,
	      seen = (bitmask & COMPARE_UNORDERED_FLAG) ? new _SetCache : undefined;
	
	  stack.set(array, other);
	  stack.set(other, array);
	
	  // Ignore non-index properties.
	  while (++index < arrLength) {
	    var arrValue = array[index],
	        othValue = other[index];
	
	    if (customizer) {
	      var compared = isPartial
	        ? customizer(othValue, arrValue, index, other, array, stack)
	        : customizer(arrValue, othValue, index, array, other, stack);
	    }
	    if (compared !== undefined) {
	      if (compared) {
	        continue;
	      }
	      result = false;
	      break;
	    }
	    // Recursively compare arrays (susceptible to call stack limits).
	    if (seen) {
	      if (!_arraySome(other, function(othValue, othIndex) {
	            if (!_cacheHas(seen, othIndex) &&
	                (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
	              return seen.push(othIndex);
	            }
	          })) {
	        result = false;
	        break;
	      }
	    } else if (!(
	          arrValue === othValue ||
	            equalFunc(arrValue, othValue, bitmask, customizer, stack)
	        )) {
	      result = false;
	      break;
	    }
	  }
	  stack['delete'](array);
	  stack['delete'](other);
	  return result;
	}
	
	var _equalArrays = equalArrays;
	
	/** Built-in value references. */
	var Uint8Array = _root.Uint8Array;
	
	var _Uint8Array = Uint8Array;
	
	/**
	 * Converts `map` to its key-value pairs.
	 *
	 * @private
	 * @param {Object} map The map to convert.
	 * @returns {Array} Returns the key-value pairs.
	 */
	function mapToArray(map) {
	  var index = -1,
	      result = Array(map.size);
	
	  map.forEach(function(value, key) {
	    result[++index] = [key, value];
	  });
	  return result;
	}
	
	var _mapToArray = mapToArray;
	
	/**
	 * Converts `set` to an array of its values.
	 *
	 * @private
	 * @param {Object} set The set to convert.
	 * @returns {Array} Returns the values.
	 */
	function setToArray(set) {
	  var index = -1,
	      result = Array(set.size);
	
	  set.forEach(function(value) {
	    result[++index] = value;
	  });
	  return result;
	}
	
	var _setToArray = setToArray;
	
	/** Used to compose bitmasks for value comparisons. */
	var COMPARE_PARTIAL_FLAG$1 = 1,
	    COMPARE_UNORDERED_FLAG$1 = 2;
	
	/** `Object#toString` result references. */
	var boolTag = '[object Boolean]',
	    dateTag = '[object Date]',
	    errorTag = '[object Error]',
	    mapTag = '[object Map]',
	    numberTag = '[object Number]',
	    regexpTag = '[object RegExp]',
	    setTag = '[object Set]',
	    stringTag = '[object String]',
	    symbolTag$1 = '[object Symbol]';
	
	var arrayBufferTag = '[object ArrayBuffer]',
	    dataViewTag = '[object DataView]';
	
	/** Used to convert symbols to primitives and strings. */
	var symbolProto = _Symbol ? _Symbol.prototype : undefined,
	    symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;
	
	/**
	 * A specialized version of `baseIsEqualDeep` for comparing objects of
	 * the same `toStringTag`.
	 *
	 * **Note:** This function only supports comparing values with tags of
	 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
	 *
	 * @private
	 * @param {Object} object The object to compare.
	 * @param {Object} other The other object to compare.
	 * @param {string} tag The `toStringTag` of the objects to compare.
	 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	 * @param {Function} customizer The function to customize comparisons.
	 * @param {Function} equalFunc The function to determine equivalents of values.
	 * @param {Object} stack Tracks traversed `object` and `other` objects.
	 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	 */
	function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
	  switch (tag) {
	    case dataViewTag:
	      if ((object.byteLength != other.byteLength) ||
	          (object.byteOffset != other.byteOffset)) {
	        return false;
	      }
	      object = object.buffer;
	      other = other.buffer;
	
	    case arrayBufferTag:
	      if ((object.byteLength != other.byteLength) ||
	          !equalFunc(new _Uint8Array(object), new _Uint8Array(other))) {
	        return false;
	      }
	      return true;
	
	    case boolTag:
	    case dateTag:
	    case numberTag:
	      // Coerce booleans to `1` or `0` and dates to milliseconds.
	      // Invalid dates are coerced to `NaN`.
	      return eq_1(+object, +other);
	
	    case errorTag:
	      return object.name == other.name && object.message == other.message;
	
	    case regexpTag:
	    case stringTag:
	      // Coerce regexes to strings and treat strings, primitives and objects,
	      // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
	      // for more details.
	      return object == (other + '');
	
	    case mapTag:
	      var convert = _mapToArray;
	
	    case setTag:
	      var isPartial = bitmask & COMPARE_PARTIAL_FLAG$1;
	      convert || (convert = _setToArray);
	
	      if (object.size != other.size && !isPartial) {
	        return false;
	      }
	      // Assume cyclic values are equal.
	      var stacked = stack.get(object);
	      if (stacked) {
	        return stacked == other;
	      }
	      bitmask |= COMPARE_UNORDERED_FLAG$1;
	
	      // Recursively compare objects (susceptible to call stack limits).
	      stack.set(object, other);
	      var result = _equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
	      stack['delete'](object);
	      return result;
	
	    case symbolTag$1:
	      if (symbolValueOf) {
	        return symbolValueOf.call(object) == symbolValueOf.call(other);
	      }
	  }
	  return false;
	}
	
	var _equalByTag = equalByTag;
	
	/**
	 * Appends the elements of `values` to `array`.
	 *
	 * @private
	 * @param {Array} array The array to modify.
	 * @param {Array} values The values to append.
	 * @returns {Array} Returns `array`.
	 */
	function arrayPush(array, values) {
	  var index = -1,
	      length = values.length,
	      offset = array.length;
	
	  while (++index < length) {
	    array[offset + index] = values[index];
	  }
	  return array;
	}
	
	var _arrayPush = arrayPush;
	
	/**
	 * Checks if `value` is classified as an `Array` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
	 * @example
	 *
	 * _.isArray([1, 2, 3]);
	 * // => true
	 *
	 * _.isArray(document.body.children);
	 * // => false
	 *
	 * _.isArray('abc');
	 * // => false
	 *
	 * _.isArray(_.noop);
	 * // => false
	 */
	var isArray = Array.isArray;
	
	var isArray_1 = isArray;
	
	/**
	 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
	 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
	 * symbols of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {Function} keysFunc The function to get the keys of `object`.
	 * @param {Function} symbolsFunc The function to get the symbols of `object`.
	 * @returns {Array} Returns the array of property names and symbols.
	 */
	function baseGetAllKeys(object, keysFunc, symbolsFunc) {
	  var result = keysFunc(object);
	  return isArray_1(object) ? result : _arrayPush(result, symbolsFunc(object));
	}
	
	var _baseGetAllKeys = baseGetAllKeys;
	
	/**
	 * A specialized version of `_.filter` for arrays without support for
	 * iteratee shorthands.
	 *
	 * @private
	 * @param {Array} [array] The array to iterate over.
	 * @param {Function} predicate The function invoked per iteration.
	 * @returns {Array} Returns the new filtered array.
	 */
	function arrayFilter(array, predicate) {
	  var index = -1,
	      length = array == null ? 0 : array.length,
	      resIndex = 0,
	      result = [];
	
	  while (++index < length) {
	    var value = array[index];
	    if (predicate(value, index, array)) {
	      result[resIndex++] = value;
	    }
	  }
	  return result;
	}
	
	var _arrayFilter = arrayFilter;
	
	/**
	 * This method returns a new empty array.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.13.0
	 * @category Util
	 * @returns {Array} Returns the new empty array.
	 * @example
	 *
	 * var arrays = _.times(2, _.stubArray);
	 *
	 * console.log(arrays);
	 * // => [[], []]
	 *
	 * console.log(arrays[0] === arrays[1]);
	 * // => false
	 */
	function stubArray() {
	  return [];
	}
	
	var stubArray_1 = stubArray;
	
	/** Used for built-in method references. */
	var objectProto$5 = Object.prototype;
	
	/** Built-in value references. */
	var propertyIsEnumerable = objectProto$5.propertyIsEnumerable;
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeGetSymbols = Object.getOwnPropertySymbols;
	
	/**
	 * Creates an array of the own enumerable symbols of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of symbols.
	 */
	var getSymbols = !nativeGetSymbols ? stubArray_1 : function(object) {
	  if (object == null) {
	    return [];
	  }
	  object = Object(object);
	  return _arrayFilter(nativeGetSymbols(object), function(symbol) {
	    return propertyIsEnumerable.call(object, symbol);
	  });
	};
	
	var _getSymbols = getSymbols;
	
	/**
	 * The base implementation of `_.times` without support for iteratee shorthands
	 * or max array length checks.
	 *
	 * @private
	 * @param {number} n The number of times to invoke `iteratee`.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Array} Returns the array of results.
	 */
	function baseTimes(n, iteratee) {
	  var index = -1,
	      result = Array(n);
	
	  while (++index < n) {
	    result[index] = iteratee(index);
	  }
	  return result;
	}
	
	var _baseTimes = baseTimes;
	
	/** `Object#toString` result references. */
	var argsTag = '[object Arguments]';
	
	/**
	 * The base implementation of `_.isArguments`.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
	 */
	function baseIsArguments(value) {
	  return isObjectLike_1(value) && _baseGetTag(value) == argsTag;
	}
	
	var _baseIsArguments = baseIsArguments;
	
	/** Used for built-in method references. */
	var objectProto$6 = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty$4 = objectProto$6.hasOwnProperty;
	
	/** Built-in value references. */
	var propertyIsEnumerable$1 = objectProto$6.propertyIsEnumerable;
	
	/**
	 * Checks if `value` is likely an `arguments` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
	 *  else `false`.
	 * @example
	 *
	 * _.isArguments(function() { return arguments; }());
	 * // => true
	 *
	 * _.isArguments([1, 2, 3]);
	 * // => false
	 */
	var isArguments = _baseIsArguments(function() { return arguments; }()) ? _baseIsArguments : function(value) {
	  return isObjectLike_1(value) && hasOwnProperty$4.call(value, 'callee') &&
	    !propertyIsEnumerable$1.call(value, 'callee');
	};
	
	var isArguments_1 = isArguments;
	
	/**
	 * This method returns `false`.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.13.0
	 * @category Util
	 * @returns {boolean} Returns `false`.
	 * @example
	 *
	 * _.times(2, _.stubFalse);
	 * // => [false, false]
	 */
	function stubFalse() {
	  return false;
	}
	
	var stubFalse_1 = stubFalse;
	
	var isBuffer_1 = createCommonjsModule(function (module, exports) {
	/** Detect free variable `exports`. */
	var freeExports = exports && !exports.nodeType && exports;
	
	/** Detect free variable `module`. */
	var freeModule = freeExports && 'object' == 'object' && module && !module.nodeType && module;
	
	/** Detect the popular CommonJS extension `module.exports`. */
	var moduleExports = freeModule && freeModule.exports === freeExports;
	
	/** Built-in value references. */
	var Buffer = moduleExports ? _root.Buffer : undefined;
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined;
	
	/**
	 * Checks if `value` is a buffer.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.3.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
	 * @example
	 *
	 * _.isBuffer(new Buffer(2));
	 * // => true
	 *
	 * _.isBuffer(new Uint8Array(2));
	 * // => false
	 */
	var isBuffer = nativeIsBuffer || stubFalse_1;
	
	module.exports = isBuffer;
	});
	
	/** Used as references for various `Number` constants. */
	var MAX_SAFE_INTEGER = 9007199254740991;
	
	/** Used to detect unsigned integer values. */
	var reIsUint = /^(?:0|[1-9]\d*)$/;
	
	/**
	 * Checks if `value` is a valid array-like index.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
	 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
	 */
	function isIndex(value, length) {
	  var type = typeof value;
	  length = length == null ? MAX_SAFE_INTEGER : length;
	
	  return !!length &&
	    (type == 'number' ||
	      (type != 'symbol' && reIsUint.test(value))) &&
	        (value > -1 && value % 1 == 0 && value < length);
	}
	
	var _isIndex = isIndex;
	
	/** Used as references for various `Number` constants. */
	var MAX_SAFE_INTEGER$1 = 9007199254740991;
	
	/**
	 * Checks if `value` is a valid array-like length.
	 *
	 * **Note:** This method is loosely based on
	 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
	 * @example
	 *
	 * _.isLength(3);
	 * // => true
	 *
	 * _.isLength(Number.MIN_VALUE);
	 * // => false
	 *
	 * _.isLength(Infinity);
	 * // => false
	 *
	 * _.isLength('3');
	 * // => false
	 */
	function isLength(value) {
	  return typeof value == 'number' &&
	    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER$1;
	}
	
	var isLength_1 = isLength;
	
	/** `Object#toString` result references. */
	var argsTag$1 = '[object Arguments]',
	    arrayTag = '[object Array]',
	    boolTag$1 = '[object Boolean]',
	    dateTag$1 = '[object Date]',
	    errorTag$1 = '[object Error]',
	    funcTag$1 = '[object Function]',
	    mapTag$1 = '[object Map]',
	    numberTag$1 = '[object Number]',
	    objectTag = '[object Object]',
	    regexpTag$1 = '[object RegExp]',
	    setTag$1 = '[object Set]',
	    stringTag$1 = '[object String]',
	    weakMapTag = '[object WeakMap]';
	
	var arrayBufferTag$1 = '[object ArrayBuffer]',
	    dataViewTag$1 = '[object DataView]',
	    float32Tag = '[object Float32Array]',
	    float64Tag = '[object Float64Array]',
	    int8Tag = '[object Int8Array]',
	    int16Tag = '[object Int16Array]',
	    int32Tag = '[object Int32Array]',
	    uint8Tag = '[object Uint8Array]',
	    uint8ClampedTag = '[object Uint8ClampedArray]',
	    uint16Tag = '[object Uint16Array]',
	    uint32Tag = '[object Uint32Array]';
	
	/** Used to identify `toStringTag` values of typed arrays. */
	var typedArrayTags = {};
	typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
	typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
	typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
	typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
	typedArrayTags[uint32Tag] = true;
	typedArrayTags[argsTag$1] = typedArrayTags[arrayTag] =
	typedArrayTags[arrayBufferTag$1] = typedArrayTags[boolTag$1] =
	typedArrayTags[dataViewTag$1] = typedArrayTags[dateTag$1] =
	typedArrayTags[errorTag$1] = typedArrayTags[funcTag$1] =
	typedArrayTags[mapTag$1] = typedArrayTags[numberTag$1] =
	typedArrayTags[objectTag] = typedArrayTags[regexpTag$1] =
	typedArrayTags[setTag$1] = typedArrayTags[stringTag$1] =
	typedArrayTags[weakMapTag] = false;
	
	/**
	 * The base implementation of `_.isTypedArray` without Node.js optimizations.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
	 */
	function baseIsTypedArray(value) {
	  return isObjectLike_1(value) &&
	    isLength_1(value.length) && !!typedArrayTags[_baseGetTag(value)];
	}
	
	var _baseIsTypedArray = baseIsTypedArray;
	
	/**
	 * The base implementation of `_.unary` without support for storing metadata.
	 *
	 * @private
	 * @param {Function} func The function to cap arguments for.
	 * @returns {Function} Returns the new capped function.
	 */
	function baseUnary(func) {
	  return function(value) {
	    return func(value);
	  };
	}
	
	var _baseUnary = baseUnary;
	
	var _nodeUtil = createCommonjsModule(function (module, exports) {
	/** Detect free variable `exports`. */
	var freeExports = exports && !exports.nodeType && exports;
	
	/** Detect free variable `module`. */
	var freeModule = freeExports && 'object' == 'object' && module && !module.nodeType && module;
	
	/** Detect the popular CommonJS extension `module.exports`. */
	var moduleExports = freeModule && freeModule.exports === freeExports;
	
	/** Detect free variable `process` from Node.js. */
	var freeProcess = moduleExports && _freeGlobal.process;
	
	/** Used to access faster Node.js helpers. */
	var nodeUtil = (function() {
	  try {
	    // Use `util.types` for Node.js 10+.
	    var types = freeModule && freeModule.require && freeModule.require('util').types;
	
	    if (types) {
	      return types;
	    }
	
	    // Legacy `process.binding('util')` for Node.js < 10.
	    return freeProcess && freeProcess.binding && freeProcess.binding('util');
	  } catch (e) {}
	}());
	
	module.exports = nodeUtil;
	});
	
	/* Node.js helper references. */
	var nodeIsTypedArray = _nodeUtil && _nodeUtil.isTypedArray;
	
	/**
	 * Checks if `value` is classified as a typed array.
	 *
	 * @static
	 * @memberOf _
	 * @since 3.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
	 * @example
	 *
	 * _.isTypedArray(new Uint8Array);
	 * // => true
	 *
	 * _.isTypedArray([]);
	 * // => false
	 */
	var isTypedArray = nodeIsTypedArray ? _baseUnary(nodeIsTypedArray) : _baseIsTypedArray;
	
	var isTypedArray_1 = isTypedArray;
	
	/** Used for built-in method references. */
	var objectProto$7 = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty$5 = objectProto$7.hasOwnProperty;
	
	/**
	 * Creates an array of the enumerable property names of the array-like `value`.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @param {boolean} inherited Specify returning inherited property names.
	 * @returns {Array} Returns the array of property names.
	 */
	function arrayLikeKeys(value, inherited) {
	  var isArr = isArray_1(value),
	      isArg = !isArr && isArguments_1(value),
	      isBuff = !isArr && !isArg && isBuffer_1(value),
	      isType = !isArr && !isArg && !isBuff && isTypedArray_1(value),
	      skipIndexes = isArr || isArg || isBuff || isType,
	      result = skipIndexes ? _baseTimes(value.length, String) : [],
	      length = result.length;
	
	  for (var key in value) {
	    if ((inherited || hasOwnProperty$5.call(value, key)) &&
	        !(skipIndexes && (
	           // Safari 9 has enumerable `arguments.length` in strict mode.
	           key == 'length' ||
	           // Node.js 0.10 has enumerable non-index properties on buffers.
	           (isBuff && (key == 'offset' || key == 'parent')) ||
	           // PhantomJS 2 has enumerable non-index properties on typed arrays.
	           (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
	           // Skip index properties.
	           _isIndex(key, length)
	        ))) {
	      result.push(key);
	    }
	  }
	  return result;
	}
	
	var _arrayLikeKeys = arrayLikeKeys;
	
	/** Used for built-in method references. */
	var objectProto$8 = Object.prototype;
	
	/**
	 * Checks if `value` is likely a prototype object.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
	 */
	function isPrototype(value) {
	  var Ctor = value && value.constructor,
	      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto$8;
	
	  return value === proto;
	}
	
	var _isPrototype = isPrototype;
	
	/**
	 * Creates a unary function that invokes `func` with its argument transformed.
	 *
	 * @private
	 * @param {Function} func The function to wrap.
	 * @param {Function} transform The argument transform.
	 * @returns {Function} Returns the new function.
	 */
	function overArg(func, transform) {
	  return function(arg) {
	    return func(transform(arg));
	  };
	}
	
	var _overArg = overArg;
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeKeys = _overArg(Object.keys, Object);
	
	var _nativeKeys = nativeKeys;
	
	/** Used for built-in method references. */
	var objectProto$9 = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty$6 = objectProto$9.hasOwnProperty;
	
	/**
	 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 */
	function baseKeys(object) {
	  if (!_isPrototype(object)) {
	    return _nativeKeys(object);
	  }
	  var result = [];
	  for (var key in Object(object)) {
	    if (hasOwnProperty$6.call(object, key) && key != 'constructor') {
	      result.push(key);
	    }
	  }
	  return result;
	}
	
	var _baseKeys = baseKeys;
	
	/**
	 * Checks if `value` is array-like. A value is considered array-like if it's
	 * not a function and has a `value.length` that's an integer greater than or
	 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
	 * @example
	 *
	 * _.isArrayLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isArrayLike(document.body.children);
	 * // => true
	 *
	 * _.isArrayLike('abc');
	 * // => true
	 *
	 * _.isArrayLike(_.noop);
	 * // => false
	 */
	function isArrayLike(value) {
	  return value != null && isLength_1(value.length) && !isFunction_1(value);
	}
	
	var isArrayLike_1 = isArrayLike;
	
	/**
	 * Creates an array of the own enumerable property names of `object`.
	 *
	 * **Note:** Non-object values are coerced to objects. See the
	 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
	 * for more details.
	 *
	 * @static
	 * @since 0.1.0
	 * @memberOf _
	 * @category Object
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 * @example
	 *
	 * function Foo() {
	 *   this.a = 1;
	 *   this.b = 2;
	 * }
	 *
	 * Foo.prototype.c = 3;
	 *
	 * _.keys(new Foo);
	 * // => ['a', 'b'] (iteration order is not guaranteed)
	 *
	 * _.keys('hi');
	 * // => ['0', '1']
	 */
	function keys(object) {
	  return isArrayLike_1(object) ? _arrayLikeKeys(object) : _baseKeys(object);
	}
	
	var keys_1 = keys;
	
	/**
	 * Creates an array of own enumerable property names and symbols of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names and symbols.
	 */
	function getAllKeys(object) {
	  return _baseGetAllKeys(object, keys_1, _getSymbols);
	}
	
	var _getAllKeys = getAllKeys;
	
	/** Used to compose bitmasks for value comparisons. */
	var COMPARE_PARTIAL_FLAG$2 = 1;
	
	/** Used for built-in method references. */
	var objectProto$a = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty$7 = objectProto$a.hasOwnProperty;
	
	/**
	 * A specialized version of `baseIsEqualDeep` for objects with support for
	 * partial deep comparisons.
	 *
	 * @private
	 * @param {Object} object The object to compare.
	 * @param {Object} other The other object to compare.
	 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	 * @param {Function} customizer The function to customize comparisons.
	 * @param {Function} equalFunc The function to determine equivalents of values.
	 * @param {Object} stack Tracks traversed `object` and `other` objects.
	 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	 */
	function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
	  var isPartial = bitmask & COMPARE_PARTIAL_FLAG$2,
	      objProps = _getAllKeys(object),
	      objLength = objProps.length,
	      othProps = _getAllKeys(other),
	      othLength = othProps.length;
	
	  if (objLength != othLength && !isPartial) {
	    return false;
	  }
	  var index = objLength;
	  while (index--) {
	    var key = objProps[index];
	    if (!(isPartial ? key in other : hasOwnProperty$7.call(other, key))) {
	      return false;
	    }
	  }
	  // Assume cyclic values are equal.
	  var stacked = stack.get(object);
	  if (stacked && stack.get(other)) {
	    return stacked == other;
	  }
	  var result = true;
	  stack.set(object, other);
	  stack.set(other, object);
	
	  var skipCtor = isPartial;
	  while (++index < objLength) {
	    key = objProps[index];
	    var objValue = object[key],
	        othValue = other[key];
	
	    if (customizer) {
	      var compared = isPartial
	        ? customizer(othValue, objValue, key, other, object, stack)
	        : customizer(objValue, othValue, key, object, other, stack);
	    }
	    // Recursively compare objects (susceptible to call stack limits).
	    if (!(compared === undefined
	          ? (objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack))
	          : compared
	        )) {
	      result = false;
	      break;
	    }
	    skipCtor || (skipCtor = key == 'constructor');
	  }
	  if (result && !skipCtor) {
	    var objCtor = object.constructor,
	        othCtor = other.constructor;
	
	    // Non `Object` object instances with different constructors are not equal.
	    if (objCtor != othCtor &&
	        ('constructor' in object && 'constructor' in other) &&
	        !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
	          typeof othCtor == 'function' && othCtor instanceof othCtor)) {
	      result = false;
	    }
	  }
	  stack['delete'](object);
	  stack['delete'](other);
	  return result;
	}
	
	var _equalObjects = equalObjects;
	
	/* Built-in method references that are verified to be native. */
	var DataView = _getNative(_root, 'DataView');
	
	var _DataView = DataView;
	
	/* Built-in method references that are verified to be native. */
	var Promise$1 = _getNative(_root, 'Promise');
	
	var _Promise = Promise$1;
	
	/* Built-in method references that are verified to be native. */
	var Set = _getNative(_root, 'Set');
	
	var _Set = Set;
	
	/* Built-in method references that are verified to be native. */
	var WeakMap = _getNative(_root, 'WeakMap');
	
	var _WeakMap = WeakMap;
	
	/** `Object#toString` result references. */
	var mapTag$2 = '[object Map]',
	    objectTag$1 = '[object Object]',
	    promiseTag = '[object Promise]',
	    setTag$2 = '[object Set]',
	    weakMapTag$1 = '[object WeakMap]';
	
	var dataViewTag$2 = '[object DataView]';
	
	/** Used to detect maps, sets, and weakmaps. */
	var dataViewCtorString = _toSource(_DataView),
	    mapCtorString = _toSource(_Map),
	    promiseCtorString = _toSource(_Promise),
	    setCtorString = _toSource(_Set),
	    weakMapCtorString = _toSource(_WeakMap);
	
	/**
	 * Gets the `toStringTag` of `value`.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @returns {string} Returns the `toStringTag`.
	 */
	var getTag = _baseGetTag;
	
	// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
	if ((_DataView && getTag(new _DataView(new ArrayBuffer(1))) != dataViewTag$2) ||
	    (_Map && getTag(new _Map) != mapTag$2) ||
	    (_Promise && getTag(_Promise.resolve()) != promiseTag) ||
	    (_Set && getTag(new _Set) != setTag$2) ||
	    (_WeakMap && getTag(new _WeakMap) != weakMapTag$1)) {
	  getTag = function(value) {
	    var result = _baseGetTag(value),
	        Ctor = result == objectTag$1 ? value.constructor : undefined,
	        ctorString = Ctor ? _toSource(Ctor) : '';
	
	    if (ctorString) {
	      switch (ctorString) {
	        case dataViewCtorString: return dataViewTag$2;
	        case mapCtorString: return mapTag$2;
	        case promiseCtorString: return promiseTag;
	        case setCtorString: return setTag$2;
	        case weakMapCtorString: return weakMapTag$1;
	      }
	    }
	    return result;
	  };
	}
	
	var _getTag = getTag;
	
	/** Used to compose bitmasks for value comparisons. */
	var COMPARE_PARTIAL_FLAG$3 = 1;
	
	/** `Object#toString` result references. */
	var argsTag$2 = '[object Arguments]',
	    arrayTag$1 = '[object Array]',
	    objectTag$2 = '[object Object]';
	
	/** Used for built-in method references. */
	var objectProto$b = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty$8 = objectProto$b.hasOwnProperty;
	
	/**
	 * A specialized version of `baseIsEqual` for arrays and objects which performs
	 * deep comparisons and tracks traversed objects enabling objects with circular
	 * references to be compared.
	 *
	 * @private
	 * @param {Object} object The object to compare.
	 * @param {Object} other The other object to compare.
	 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	 * @param {Function} customizer The function to customize comparisons.
	 * @param {Function} equalFunc The function to determine equivalents of values.
	 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
	 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	 */
	function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
	  var objIsArr = isArray_1(object),
	      othIsArr = isArray_1(other),
	      objTag = objIsArr ? arrayTag$1 : _getTag(object),
	      othTag = othIsArr ? arrayTag$1 : _getTag(other);
	
	  objTag = objTag == argsTag$2 ? objectTag$2 : objTag;
	  othTag = othTag == argsTag$2 ? objectTag$2 : othTag;
	
	  var objIsObj = objTag == objectTag$2,
	      othIsObj = othTag == objectTag$2,
	      isSameTag = objTag == othTag;
	
	  if (isSameTag && isBuffer_1(object)) {
	    if (!isBuffer_1(other)) {
	      return false;
	    }
	    objIsArr = true;
	    objIsObj = false;
	  }
	  if (isSameTag && !objIsObj) {
	    stack || (stack = new _Stack);
	    return (objIsArr || isTypedArray_1(object))
	      ? _equalArrays(object, other, bitmask, customizer, equalFunc, stack)
	      : _equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
	  }
	  if (!(bitmask & COMPARE_PARTIAL_FLAG$3)) {
	    var objIsWrapped = objIsObj && hasOwnProperty$8.call(object, '__wrapped__'),
	        othIsWrapped = othIsObj && hasOwnProperty$8.call(other, '__wrapped__');
	
	    if (objIsWrapped || othIsWrapped) {
	      var objUnwrapped = objIsWrapped ? object.value() : object,
	          othUnwrapped = othIsWrapped ? other.value() : other;
	
	      stack || (stack = new _Stack);
	      return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
	    }
	  }
	  if (!isSameTag) {
	    return false;
	  }
	  stack || (stack = new _Stack);
	  return _equalObjects(object, other, bitmask, customizer, equalFunc, stack);
	}
	
	var _baseIsEqualDeep = baseIsEqualDeep;
	
	/**
	 * The base implementation of `_.isEqual` which supports partial comparisons
	 * and tracks traversed objects.
	 *
	 * @private
	 * @param {*} value The value to compare.
	 * @param {*} other The other value to compare.
	 * @param {boolean} bitmask The bitmask flags.
	 *  1 - Unordered comparison
	 *  2 - Partial comparison
	 * @param {Function} [customizer] The function to customize comparisons.
	 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
	 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	 */
	function baseIsEqual(value, other, bitmask, customizer, stack) {
	  if (value === other) {
	    return true;
	  }
	  if (value == null || other == null || (!isObjectLike_1(value) && !isObjectLike_1(other))) {
	    return value !== value && other !== other;
	  }
	  return _baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
	}
	
	var _baseIsEqual = baseIsEqual;
	
	/** Used to compose bitmasks for value comparisons. */
	var COMPARE_PARTIAL_FLAG$4 = 1,
	    COMPARE_UNORDERED_FLAG$2 = 2;
	
	/**
	 * The base implementation of `_.isMatch` without support for iteratee shorthands.
	 *
	 * @private
	 * @param {Object} object The object to inspect.
	 * @param {Object} source The object of property values to match.
	 * @param {Array} matchData The property names, values, and compare flags to match.
	 * @param {Function} [customizer] The function to customize comparisons.
	 * @returns {boolean} Returns `true` if `object` is a match, else `false`.
	 */
	function baseIsMatch(object, source, matchData, customizer) {
	  var index = matchData.length,
	      length = index,
	      noCustomizer = !customizer;
	
	  if (object == null) {
	    return !length;
	  }
	  object = Object(object);
	  while (index--) {
	    var data = matchData[index];
	    if ((noCustomizer && data[2])
	          ? data[1] !== object[data[0]]
	          : !(data[0] in object)
	        ) {
	      return false;
	    }
	  }
	  while (++index < length) {
	    data = matchData[index];
	    var key = data[0],
	        objValue = object[key],
	        srcValue = data[1];
	
	    if (noCustomizer && data[2]) {
	      if (objValue === undefined && !(key in object)) {
	        return false;
	      }
	    } else {
	      var stack = new _Stack;
	      if (customizer) {
	        var result = customizer(objValue, srcValue, key, object, source, stack);
	      }
	      if (!(result === undefined
	            ? _baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG$4 | COMPARE_UNORDERED_FLAG$2, customizer, stack)
	            : result
	          )) {
	        return false;
	      }
	    }
	  }
	  return true;
	}
	
	var _baseIsMatch = baseIsMatch;
	
	/**
	 * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` if suitable for strict
	 *  equality comparisons, else `false`.
	 */
	function isStrictComparable(value) {
	  return value === value && !isObject_1(value);
	}
	
	var _isStrictComparable = isStrictComparable;
	
	/**
	 * Gets the property names, values, and compare flags of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the match data of `object`.
	 */
	function getMatchData(object) {
	  var result = keys_1(object),
	      length = result.length;
	
	  while (length--) {
	    var key = result[length],
	        value = object[key];
	
	    result[length] = [key, value, _isStrictComparable(value)];
	  }
	  return result;
	}
	
	var _getMatchData = getMatchData;
	
	/**
	 * A specialized version of `matchesProperty` for source values suitable
	 * for strict equality comparisons, i.e. `===`.
	 *
	 * @private
	 * @param {string} key The key of the property to get.
	 * @param {*} srcValue The value to match.
	 * @returns {Function} Returns the new spec function.
	 */
	function matchesStrictComparable(key, srcValue) {
	  return function(object) {
	    if (object == null) {
	      return false;
	    }
	    return object[key] === srcValue &&
	      (srcValue !== undefined || (key in Object(object)));
	  };
	}
	
	var _matchesStrictComparable = matchesStrictComparable;
	
	/**
	 * The base implementation of `_.matches` which doesn't clone `source`.
	 *
	 * @private
	 * @param {Object} source The object of property values to match.
	 * @returns {Function} Returns the new spec function.
	 */
	function baseMatches(source) {
	  var matchData = _getMatchData(source);
	  if (matchData.length == 1 && matchData[0][2]) {
	    return _matchesStrictComparable(matchData[0][0], matchData[0][1]);
	  }
	  return function(object) {
	    return object === source || _baseIsMatch(object, source, matchData);
	  };
	}
	
	var _baseMatches = baseMatches;
	
	/** Used to match property names within property paths. */
	var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
	    reIsPlainProp = /^\w*$/;
	
	/**
	 * Checks if `value` is a property name and not a property path.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @param {Object} [object] The object to query keys on.
	 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
	 */
	function isKey(value, object) {
	  if (isArray_1(value)) {
	    return false;
	  }
	  var type = typeof value;
	  if (type == 'number' || type == 'symbol' || type == 'boolean' ||
	      value == null || isSymbol_1(value)) {
	    return true;
	  }
	  return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
	    (object != null && value in Object(object));
	}
	
	var _isKey = isKey;
	
	/** Error message constants. */
	var FUNC_ERROR_TEXT = 'Expected a function';
	
	/**
	 * Creates a function that memoizes the result of `func`. If `resolver` is
	 * provided, it determines the cache key for storing the result based on the
	 * arguments provided to the memoized function. By default, the first argument
	 * provided to the memoized function is used as the map cache key. The `func`
	 * is invoked with the `this` binding of the memoized function.
	 *
	 * **Note:** The cache is exposed as the `cache` property on the memoized
	 * function. Its creation may be customized by replacing the `_.memoize.Cache`
	 * constructor with one whose instances implement the
	 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
	 * method interface of `clear`, `delete`, `get`, `has`, and `set`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Function
	 * @param {Function} func The function to have its output memoized.
	 * @param {Function} [resolver] The function to resolve the cache key.
	 * @returns {Function} Returns the new memoized function.
	 * @example
	 *
	 * var object = { 'a': 1, 'b': 2 };
	 * var other = { 'c': 3, 'd': 4 };
	 *
	 * var values = _.memoize(_.values);
	 * values(object);
	 * // => [1, 2]
	 *
	 * values(other);
	 * // => [3, 4]
	 *
	 * object.a = 2;
	 * values(object);
	 * // => [1, 2]
	 *
	 * // Modify the result cache.
	 * values.cache.set(object, ['a', 'b']);
	 * values(object);
	 * // => ['a', 'b']
	 *
	 * // Replace `_.memoize.Cache`.
	 * _.memoize.Cache = WeakMap;
	 */
	function memoize(func, resolver) {
	  if (typeof func != 'function' || (resolver != null && typeof resolver != 'function')) {
	    throw new TypeError(FUNC_ERROR_TEXT);
	  }
	  var memoized = function() {
	    var args = arguments,
	        key = resolver ? resolver.apply(this, args) : args[0],
	        cache = memoized.cache;
	
	    if (cache.has(key)) {
	      return cache.get(key);
	    }
	    var result = func.apply(this, args);
	    memoized.cache = cache.set(key, result) || cache;
	    return result;
	  };
	  memoized.cache = new (memoize.Cache || _MapCache);
	  return memoized;
	}
	
	// Expose `MapCache`.
	memoize.Cache = _MapCache;
	
	var memoize_1 = memoize;
	
	/** Used as the maximum memoize cache size. */
	var MAX_MEMOIZE_SIZE = 500;
	
	/**
	 * A specialized version of `_.memoize` which clears the memoized function's
	 * cache when it exceeds `MAX_MEMOIZE_SIZE`.
	 *
	 * @private
	 * @param {Function} func The function to have its output memoized.
	 * @returns {Function} Returns the new memoized function.
	 */
	function memoizeCapped(func) {
	  var result = memoize_1(func, function(key) {
	    if (cache.size === MAX_MEMOIZE_SIZE) {
	      cache.clear();
	    }
	    return key;
	  });
	
	  var cache = result.cache;
	  return result;
	}
	
	var _memoizeCapped = memoizeCapped;
	
	/** Used to match property names within property paths. */
	var rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
	
	/** Used to match backslashes in property paths. */
	var reEscapeChar = /\\(\\)?/g;
	
	/**
	 * Converts `string` to a property path array.
	 *
	 * @private
	 * @param {string} string The string to convert.
	 * @returns {Array} Returns the property path array.
	 */
	var stringToPath = _memoizeCapped(function(string) {
	  var result = [];
	  if (string.charCodeAt(0) === 46 /* . */) {
	    result.push('');
	  }
	  string.replace(rePropName, function(match, number, quote, subString) {
	    result.push(quote ? subString.replace(reEscapeChar, '$1') : (number || match));
	  });
	  return result;
	});
	
	var _stringToPath = stringToPath;
	
	/** Used as references for various `Number` constants. */
	var INFINITY = 1 / 0;
	
	/** Used to convert symbols to primitives and strings. */
	var symbolProto$1 = _Symbol ? _Symbol.prototype : undefined,
	    symbolToString = symbolProto$1 ? symbolProto$1.toString : undefined;
	
	/**
	 * The base implementation of `_.toString` which doesn't convert nullish
	 * values to empty strings.
	 *
	 * @private
	 * @param {*} value The value to process.
	 * @returns {string} Returns the string.
	 */
	function baseToString(value) {
	  // Exit early for strings to avoid a performance hit in some environments.
	  if (typeof value == 'string') {
	    return value;
	  }
	  if (isArray_1(value)) {
	    // Recursively convert values (susceptible to call stack limits).
	    return _arrayMap(value, baseToString) + '';
	  }
	  if (isSymbol_1(value)) {
	    return symbolToString ? symbolToString.call(value) : '';
	  }
	  var result = (value + '');
	  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
	}
	
	var _baseToString = baseToString;
	
	/**
	 * Converts `value` to a string. An empty string is returned for `null`
	 * and `undefined` values. The sign of `-0` is preserved.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to convert.
	 * @returns {string} Returns the converted string.
	 * @example
	 *
	 * _.toString(null);
	 * // => ''
	 *
	 * _.toString(-0);
	 * // => '-0'
	 *
	 * _.toString([1, 2, 3]);
	 * // => '1,2,3'
	 */
	function toString(value) {
	  return value == null ? '' : _baseToString(value);
	}
	
	var toString_1 = toString;
	
	/**
	 * Casts `value` to a path array if it's not one.
	 *
	 * @private
	 * @param {*} value The value to inspect.
	 * @param {Object} [object] The object to query keys on.
	 * @returns {Array} Returns the cast property path array.
	 */
	function castPath(value, object) {
	  if (isArray_1(value)) {
	    return value;
	  }
	  return _isKey(value, object) ? [value] : _stringToPath(toString_1(value));
	}
	
	var _castPath = castPath;
	
	/** Used as references for various `Number` constants. */
	var INFINITY$1 = 1 / 0;
	
	/**
	 * Converts `value` to a string key if it's not a string or symbol.
	 *
	 * @private
	 * @param {*} value The value to inspect.
	 * @returns {string|symbol} Returns the key.
	 */
	function toKey(value) {
	  if (typeof value == 'string' || isSymbol_1(value)) {
	    return value;
	  }
	  var result = (value + '');
	  return (result == '0' && (1 / value) == -INFINITY$1) ? '-0' : result;
	}
	
	var _toKey = toKey;
	
	/**
	 * The base implementation of `_.get` without support for default values.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {Array|string} path The path of the property to get.
	 * @returns {*} Returns the resolved value.
	 */
	function baseGet(object, path) {
	  path = _castPath(path, object);
	
	  var index = 0,
	      length = path.length;
	
	  while (object != null && index < length) {
	    object = object[_toKey(path[index++])];
	  }
	  return (index && index == length) ? object : undefined;
	}
	
	var _baseGet = baseGet;
	
	/**
	 * Gets the value at `path` of `object`. If the resolved value is
	 * `undefined`, the `defaultValue` is returned in its place.
	 *
	 * @static
	 * @memberOf _
	 * @since 3.7.0
	 * @category Object
	 * @param {Object} object The object to query.
	 * @param {Array|string} path The path of the property to get.
	 * @param {*} [defaultValue] The value returned for `undefined` resolved values.
	 * @returns {*} Returns the resolved value.
	 * @example
	 *
	 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
	 *
	 * _.get(object, 'a[0].b.c');
	 * // => 3
	 *
	 * _.get(object, ['a', '0', 'b', 'c']);
	 * // => 3
	 *
	 * _.get(object, 'a.b.c', 'default');
	 * // => 'default'
	 */
	function get$1(object, path, defaultValue) {
	  var result = object == null ? undefined : _baseGet(object, path);
	  return result === undefined ? defaultValue : result;
	}
	
	var get_1 = get$1;
	
	/**
	 * The base implementation of `_.hasIn` without support for deep paths.
	 *
	 * @private
	 * @param {Object} [object] The object to query.
	 * @param {Array|string} key The key to check.
	 * @returns {boolean} Returns `true` if `key` exists, else `false`.
	 */
	function baseHasIn(object, key) {
	  return object != null && key in Object(object);
	}
	
	var _baseHasIn = baseHasIn;
	
	/**
	 * Checks if `path` exists on `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {Array|string} path The path to check.
	 * @param {Function} hasFunc The function to check properties.
	 * @returns {boolean} Returns `true` if `path` exists, else `false`.
	 */
	function hasPath(object, path, hasFunc) {
	  path = _castPath(path, object);
	
	  var index = -1,
	      length = path.length,
	      result = false;
	
	  while (++index < length) {
	    var key = _toKey(path[index]);
	    if (!(result = object != null && hasFunc(object, key))) {
	      break;
	    }
	    object = object[key];
	  }
	  if (result || ++index != length) {
	    return result;
	  }
	  length = object == null ? 0 : object.length;
	  return !!length && isLength_1(length) && _isIndex(key, length) &&
	    (isArray_1(object) || isArguments_1(object));
	}
	
	var _hasPath = hasPath;
	
	/**
	 * Checks if `path` is a direct or inherited property of `object`.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Object
	 * @param {Object} object The object to query.
	 * @param {Array|string} path The path to check.
	 * @returns {boolean} Returns `true` if `path` exists, else `false`.
	 * @example
	 *
	 * var object = _.create({ 'a': _.create({ 'b': 2 }) });
	 *
	 * _.hasIn(object, 'a');
	 * // => true
	 *
	 * _.hasIn(object, 'a.b');
	 * // => true
	 *
	 * _.hasIn(object, ['a', 'b']);
	 * // => true
	 *
	 * _.hasIn(object, 'b');
	 * // => false
	 */
	function hasIn(object, path) {
	  return object != null && _hasPath(object, path, _baseHasIn);
	}
	
	var hasIn_1 = hasIn;
	
	/** Used to compose bitmasks for value comparisons. */
	var COMPARE_PARTIAL_FLAG$5 = 1,
	    COMPARE_UNORDERED_FLAG$3 = 2;
	
	/**
	 * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
	 *
	 * @private
	 * @param {string} path The path of the property to get.
	 * @param {*} srcValue The value to match.
	 * @returns {Function} Returns the new spec function.
	 */
	function baseMatchesProperty(path, srcValue) {
	  if (_isKey(path) && _isStrictComparable(srcValue)) {
	    return _matchesStrictComparable(_toKey(path), srcValue);
	  }
	  return function(object) {
	    var objValue = get_1(object, path);
	    return (objValue === undefined && objValue === srcValue)
	      ? hasIn_1(object, path)
	      : _baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG$5 | COMPARE_UNORDERED_FLAG$3);
	  };
	}
	
	var _baseMatchesProperty = baseMatchesProperty;
	
	/**
	 * This method returns the first argument it receives.
	 *
	 * @static
	 * @since 0.1.0
	 * @memberOf _
	 * @category Util
	 * @param {*} value Any value.
	 * @returns {*} Returns `value`.
	 * @example
	 *
	 * var object = { 'a': 1 };
	 *
	 * console.log(_.identity(object) === object);
	 * // => true
	 */
	function identity(value) {
	  return value;
	}
	
	var identity_1 = identity;
	
	/**
	 * The base implementation of `_.property` without support for deep paths.
	 *
	 * @private
	 * @param {string} key The key of the property to get.
	 * @returns {Function} Returns the new accessor function.
	 */
	function baseProperty(key) {
	  return function(object) {
	    return object == null ? undefined : object[key];
	  };
	}
	
	var _baseProperty = baseProperty;
	
	/**
	 * A specialized version of `baseProperty` which supports deep paths.
	 *
	 * @private
	 * @param {Array|string} path The path of the property to get.
	 * @returns {Function} Returns the new accessor function.
	 */
	function basePropertyDeep(path) {
	  return function(object) {
	    return _baseGet(object, path);
	  };
	}
	
	var _basePropertyDeep = basePropertyDeep;
	
	/**
	 * Creates a function that returns the value at `path` of a given object.
	 *
	 * @static
	 * @memberOf _
	 * @since 2.4.0
	 * @category Util
	 * @param {Array|string} path The path of the property to get.
	 * @returns {Function} Returns the new accessor function.
	 * @example
	 *
	 * var objects = [
	 *   { 'a': { 'b': 2 } },
	 *   { 'a': { 'b': 1 } }
	 * ];
	 *
	 * _.map(objects, _.property('a.b'));
	 * // => [2, 1]
	 *
	 * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
	 * // => [1, 2]
	 */
	function property(path) {
	  return _isKey(path) ? _baseProperty(_toKey(path)) : _basePropertyDeep(path);
	}
	
	var property_1 = property;
	
	/**
	 * The base implementation of `_.iteratee`.
	 *
	 * @private
	 * @param {*} [value=_.identity] The value to convert to an iteratee.
	 * @returns {Function} Returns the iteratee.
	 */
	function baseIteratee(value) {
	  // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
	  // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
	  if (typeof value == 'function') {
	    return value;
	  }
	  if (value == null) {
	    return identity_1;
	  }
	  if (typeof value == 'object') {
	    return isArray_1(value)
	      ? _baseMatchesProperty(value[0], value[1])
	      : _baseMatches(value);
	  }
	  return property_1(value);
	}
	
	var _baseIteratee = baseIteratee;
	
	/**
	 * Creates a base function for methods like `_.forIn` and `_.forOwn`.
	 *
	 * @private
	 * @param {boolean} [fromRight] Specify iterating from right to left.
	 * @returns {Function} Returns the new base function.
	 */
	function createBaseFor(fromRight) {
	  return function(object, iteratee, keysFunc) {
	    var index = -1,
	        iterable = Object(object),
	        props = keysFunc(object),
	        length = props.length;
	
	    while (length--) {
	      var key = props[fromRight ? length : ++index];
	      if (iteratee(iterable[key], key, iterable) === false) {
	        break;
	      }
	    }
	    return object;
	  };
	}
	
	var _createBaseFor = createBaseFor;
	
	/**
	 * The base implementation of `baseForOwn` which iterates over `object`
	 * properties returned by `keysFunc` and invokes `iteratee` for each property.
	 * Iteratee functions may exit iteration early by explicitly returning `false`.
	 *
	 * @private
	 * @param {Object} object The object to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @param {Function} keysFunc The function to get the keys of `object`.
	 * @returns {Object} Returns `object`.
	 */
	var baseFor = _createBaseFor();
	
	var _baseFor = baseFor;
	
	/**
	 * The base implementation of `_.forOwn` without support for iteratee shorthands.
	 *
	 * @private
	 * @param {Object} object The object to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Object} Returns `object`.
	 */
	function baseForOwn(object, iteratee) {
	  return object && _baseFor(object, iteratee, keys_1);
	}
	
	var _baseForOwn = baseForOwn;
	
	/**
	 * Creates a `baseEach` or `baseEachRight` function.
	 *
	 * @private
	 * @param {Function} eachFunc The function to iterate over a collection.
	 * @param {boolean} [fromRight] Specify iterating from right to left.
	 * @returns {Function} Returns the new base function.
	 */
	function createBaseEach(eachFunc, fromRight) {
	  return function(collection, iteratee) {
	    if (collection == null) {
	      return collection;
	    }
	    if (!isArrayLike_1(collection)) {
	      return eachFunc(collection, iteratee);
	    }
	    var length = collection.length,
	        index = fromRight ? length : -1,
	        iterable = Object(collection);
	
	    while ((fromRight ? index-- : ++index < length)) {
	      if (iteratee(iterable[index], index, iterable) === false) {
	        break;
	      }
	    }
	    return collection;
	  };
	}
	
	var _createBaseEach = createBaseEach;
	
	/**
	 * The base implementation of `_.forEach` without support for iteratee shorthands.
	 *
	 * @private
	 * @param {Array|Object} collection The collection to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Array|Object} Returns `collection`.
	 */
	var baseEach = _createBaseEach(_baseForOwn);
	
	var _baseEach = baseEach;
	
	/**
	 * The base implementation of `_.map` without support for iteratee shorthands.
	 *
	 * @private
	 * @param {Array|Object} collection The collection to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Array} Returns the new mapped array.
	 */
	function baseMap(collection, iteratee) {
	  var index = -1,
	      result = isArrayLike_1(collection) ? Array(collection.length) : [];
	
	  _baseEach(collection, function(value, key, collection) {
	    result[++index] = iteratee(value, key, collection);
	  });
	  return result;
	}
	
	var _baseMap = baseMap;
	
	/**
	 * The base implementation of `_.sortBy` which uses `comparer` to define the
	 * sort order of `array` and replaces criteria objects with their corresponding
	 * values.
	 *
	 * @private
	 * @param {Array} array The array to sort.
	 * @param {Function} comparer The function to define sort order.
	 * @returns {Array} Returns `array`.
	 */
	function baseSortBy(array, comparer) {
	  var length = array.length;
	
	  array.sort(comparer);
	  while (length--) {
	    array[length] = array[length].value;
	  }
	  return array;
	}
	
	var _baseSortBy = baseSortBy;
	
	/**
	 * Compares values to sort them in ascending order.
	 *
	 * @private
	 * @param {*} value The value to compare.
	 * @param {*} other The other value to compare.
	 * @returns {number} Returns the sort order indicator for `value`.
	 */
	function compareAscending(value, other) {
	  if (value !== other) {
	    var valIsDefined = value !== undefined,
	        valIsNull = value === null,
	        valIsReflexive = value === value,
	        valIsSymbol = isSymbol_1(value);
	
	    var othIsDefined = other !== undefined,
	        othIsNull = other === null,
	        othIsReflexive = other === other,
	        othIsSymbol = isSymbol_1(other);
	
	    if ((!othIsNull && !othIsSymbol && !valIsSymbol && value > other) ||
	        (valIsSymbol && othIsDefined && othIsReflexive && !othIsNull && !othIsSymbol) ||
	        (valIsNull && othIsDefined && othIsReflexive) ||
	        (!valIsDefined && othIsReflexive) ||
	        !valIsReflexive) {
	      return 1;
	    }
	    if ((!valIsNull && !valIsSymbol && !othIsSymbol && value < other) ||
	        (othIsSymbol && valIsDefined && valIsReflexive && !valIsNull && !valIsSymbol) ||
	        (othIsNull && valIsDefined && valIsReflexive) ||
	        (!othIsDefined && valIsReflexive) ||
	        !othIsReflexive) {
	      return -1;
	    }
	  }
	  return 0;
	}
	
	var _compareAscending = compareAscending;
	
	/**
	 * Used by `_.orderBy` to compare multiple properties of a value to another
	 * and stable sort them.
	 *
	 * If `orders` is unspecified, all values are sorted in ascending order. Otherwise,
	 * specify an order of "desc" for descending or "asc" for ascending sort order
	 * of corresponding values.
	 *
	 * @private
	 * @param {Object} object The object to compare.
	 * @param {Object} other The other object to compare.
	 * @param {boolean[]|string[]} orders The order to sort by for each property.
	 * @returns {number} Returns the sort order indicator for `object`.
	 */
	function compareMultiple(object, other, orders) {
	  var index = -1,
	      objCriteria = object.criteria,
	      othCriteria = other.criteria,
	      length = objCriteria.length,
	      ordersLength = orders.length;
	
	  while (++index < length) {
	    var result = _compareAscending(objCriteria[index], othCriteria[index]);
	    if (result) {
	      if (index >= ordersLength) {
	        return result;
	      }
	      var order = orders[index];
	      return result * (order == 'desc' ? -1 : 1);
	    }
	  }
	  // Fixes an `Array#sort` bug in the JS engine embedded in Adobe applications
	  // that causes it, under certain circumstances, to provide the same value for
	  // `object` and `other`. See https://github.com/jashkenas/underscore/pull/1247
	  // for more details.
	  //
	  // This also ensures a stable sort in V8 and other engines.
	  // See https://bugs.chromium.org/p/v8/issues/detail?id=90 for more details.
	  return object.index - other.index;
	}
	
	var _compareMultiple = compareMultiple;
	
	/**
	 * The base implementation of `_.orderBy` without param guards.
	 *
	 * @private
	 * @param {Array|Object} collection The collection to iterate over.
	 * @param {Function[]|Object[]|string[]} iteratees The iteratees to sort by.
	 * @param {string[]} orders The sort orders of `iteratees`.
	 * @returns {Array} Returns the new sorted array.
	 */
	function baseOrderBy(collection, iteratees, orders) {
	  var index = -1;
	  iteratees = _arrayMap(iteratees.length ? iteratees : [identity_1], _baseUnary(_baseIteratee));
	
	  var result = _baseMap(collection, function(value, key, collection) {
	    var criteria = _arrayMap(iteratees, function(iteratee) {
	      return iteratee(value);
	    });
	    return { 'criteria': criteria, 'index': ++index, 'value': value };
	  });
	
	  return _baseSortBy(result, function(object, other) {
	    return _compareMultiple(object, other, orders);
	  });
	}
	
	var _baseOrderBy = baseOrderBy;
	
	/**
	 * This method is like `_.sortBy` except that it allows specifying the sort
	 * orders of the iteratees to sort by. If `orders` is unspecified, all values
	 * are sorted in ascending order. Otherwise, specify an order of "desc" for
	 * descending or "asc" for ascending sort order of corresponding values.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Collection
	 * @param {Array|Object} collection The collection to iterate over.
	 * @param {Array[]|Function[]|Object[]|string[]} [iteratees=[_.identity]]
	 *  The iteratees to sort by.
	 * @param {string[]} [orders] The sort orders of `iteratees`.
	 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
	 * @returns {Array} Returns the new sorted array.
	 * @example
	 *
	 * var users = [
	 *   { 'user': 'fred',   'age': 48 },
	 *   { 'user': 'barney', 'age': 34 },
	 *   { 'user': 'fred',   'age': 40 },
	 *   { 'user': 'barney', 'age': 36 }
	 * ];
	 *
	 * // Sort by `user` in ascending order and by `age` in descending order.
	 * _.orderBy(users, ['user', 'age'], ['asc', 'desc']);
	 * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 40]]
	 */
	function orderBy(collection, iteratees, orders, guard) {
	  if (collection == null) {
	    return [];
	  }
	  if (!isArray_1(iteratees)) {
	    iteratees = iteratees == null ? [] : [iteratees];
	  }
	  orders = guard ? undefined : orders;
	  if (!isArray_1(orders)) {
	    orders = orders == null ? [] : [orders];
	  }
	  return _baseOrderBy(collection, iteratees, orders);
	}
	
	var orderBy_1 = orderBy;
	
	var STAGE_ID = '__node_editor_stage__';
	var DRAG_CONNECTION_ID = '__node_editor_drag_connection__';
	var CONNECTIONS_ID = '__node_editor_connections__';
	
	var Stage = function Stage(_ref) {
	  var scale = _ref.scale,
	      translate = _ref.translate,
	      editorId = _ref.editorId,
	      dispatchStageState = _ref.dispatchStageState,
	      children = _ref.children,
	      outerStageChildren = _ref.outerStageChildren,
	      numNodes = _ref.numNodes,
	      stageRef = _ref.stageRef,
	      spaceToPan = _ref.spaceToPan,
	      dispatchComments = _ref.dispatchComments,
	      disableComments = _ref.disableComments,
	      disablePan = _ref.disablePan,
	      disableZoom = _ref.disableZoom;
	
	  var nodeTypes = React__default.useContext(NodeTypesContext);
	  var dispatchNodes = React__default.useContext(NodeDispatchContext);
	  var wrapper = React__default.useRef();
	  var translateWrapper = React__default.useRef();
	
	  var _React$useState = React__default.useState(false),
	      _React$useState2 = slicedToArray(_React$useState, 2),
	      menuOpen = _React$useState2[0],
	      setMenuOpen = _React$useState2[1];
	
	  var _React$useState3 = React__default.useState({ x: 0, y: 0 }),
	      _React$useState4 = slicedToArray(_React$useState3, 2),
	      menuCoordinates = _React$useState4[0],
	      setMenuCoordinates = _React$useState4[1];
	
	  var dragData = React__default.useRef({ x: 0, y: 0 });
	
	  var _React$useState5 = React__default.useState(false),
	      _React$useState6 = slicedToArray(_React$useState5, 2),
	      spaceIsPressed = _React$useState6[0],
	      setSpaceIsPressed = _React$useState6[1];
	
	  var setStageRect = React__default.useCallback(function () {
	    stageRef.current = wrapper.current.getBoundingClientRect();
	  }, []);
	
	  React__default.useEffect(function () {
	    stageRef.current = wrapper.current.getBoundingClientRect();
	    window.addEventListener("resize", setStageRect);
	    return function () {
	      window.removeEventListener("resize", setStageRect);
	    };
	  }, [stageRef, setStageRect]);
	
	  var handleWheel = React__default.useCallback(function (e) {
	    if (e.target.nodeName === "TEXTAREA" || e.target.dataset.comment) {
	      if (e.target.clientHeight < e.target.scrollHeight) return;
	    }
	    e.preventDefault();
	    if (numNodes > 0) {
	      var delta = e.deltaY;
	      dispatchStageState(function (_ref2) {
	        var scale = _ref2.scale;
	        return {
	          type: "SET_SCALE",
	          scale: clamp_1(scale - clamp_1(delta, -10, 10) * 0.005, 0.1, 7)
	        };
	      });
	    }
	  }, [dispatchStageState, numNodes]);
	
	  var handleDragDelayStart = function handleDragDelayStart(e) {
	    wrapper.current.focus();
	  };
	
	  var handleDragStart = function handleDragStart(e) {
	    e.preventDefault();
	    dragData.current = {
	      x: e.clientX,
	      y: e.clientY
	    };
	  };
	
	  var handleMouseDrag = function handleMouseDrag(coords, e) {
	    var xDistance = dragData.current.x - e.clientX;
	    var yDistance = dragData.current.y - e.clientY;
	    translateWrapper.current.style.transform = "translate(" + -(translate.x + xDistance) + "px, " + -(translate.y + yDistance) + "px)";
	  };
	
	  var handleDragEnd = function handleDragEnd(e) {
	    var xDistance = dragData.current.x - e.clientX;
	    var yDistance = dragData.current.y - e.clientY;
	    dragData.current.x = e.clientX;
	    dragData.current.y = e.clientY;
	    dispatchStageState(function (_ref3) {
	      var tran = _ref3.translate;
	      return {
	        type: "SET_TRANSLATE",
	        translate: {
	          x: tran.x + xDistance,
	          y: tran.y + yDistance
	        }
	      };
	    });
	  };
	
	  var handleContextMenu = function handleContextMenu(e) {
	    e.preventDefault();
	    setMenuCoordinates({ x: e.clientX, y: e.clientY });
	    setMenuOpen(true);
	    return false;
	  };
	
	  var closeContextMenu = function closeContextMenu() {
	    setMenuOpen(false);
	  };
	
	  var byScale = function byScale(value) {
	    return 1 / scale * value;
	  };
	
	  var addNode = function addNode(_ref4) {
	    var node = _ref4.node,
	        internalType = _ref4.internalType;
	
	    var wrapperRect = wrapper.current.getBoundingClientRect();
	    var x = byScale(menuCoordinates.x - wrapperRect.x - wrapperRect.width / 2) + byScale(translate.x);
	    var y = byScale(menuCoordinates.y - wrapperRect.y - wrapperRect.height / 2) + byScale(translate.y);
	    if (internalType === "comment") {
	      dispatchComments({
	        type: "ADD_COMMENT",
	        x: x,
	        y: y
	      });
	    } else {
	      dispatchNodes({
	        type: "ADD_NODE",
	        x: x,
	        y: y,
	        nodeType: node.type
	      });
	    }
	  };
	
	  var handleDocumentKeyUp = function handleDocumentKeyUp(e) {
	    if (e.which === 32) {
	      setSpaceIsPressed(false);
	      document.removeEventListener("keyup", handleDocumentKeyUp);
	    }
	  };
	
	  var handleKeyDown = function handleKeyDown(e) {
	    if (e.which === 32 && document.activeElement === wrapper.current) {
	      e.preventDefault();
	      e.stopPropagation();
	      setSpaceIsPressed(true);
	      document.addEventListener("keyup", handleDocumentKeyUp);
	    }
	  };
	
	  var handleMouseEnter = function handleMouseEnter() {
	    if (!wrapper.current.contains(document.activeElement)) {
	      wrapper.current.focus();
	    }
	  };
	
	  React__default.useEffect(function () {
	    if (!disableZoom) {
	      var stageWrapper = wrapper.current;
	      stageWrapper.addEventListener("wheel", handleWheel);
	      return function () {
	        stageWrapper.removeEventListener("wheel", handleWheel);
	      };
	    }
	  }, [handleWheel, disableZoom]);
	
	  var menuOptions = React__default.useMemo(function () {
	    var options = orderBy_1(Object.values(nodeTypes).filter(function (node) {
	      return node.addable !== false;
	    }).map(function (node) {
	      return {
	        value: node.type,
	        label: node.label,
	        description: node.description,
	        sortIndex: node.sortIndex,
	        node: node
	      };
	    }), ["sortIndex", "label"]);
	    if (!disableComments) {
	      options.push({ value: "comment", label: "Comment", description: "A comment for documenting nodes", internalType: "comment" });
	    }
	    return options;
	  }, [nodeTypes, disableComments]);
	
	  return React__default.createElement(
	    Draggable,
	    {
	      id: "" + STAGE_ID + editorId,
	      className: styles.wrapper,
	      innerRef: wrapper,
	      onContextMenu: handleContextMenu,
	      onMouseEnter: handleMouseEnter,
	      onDragDelayStart: handleDragDelayStart,
	      onDragStart: handleDragStart,
	      onDrag: handleMouseDrag,
	      onDragEnd: handleDragEnd,
	      onKeyDown: handleKeyDown,
	      tabIndex: -1,
	      stageState: { scale: scale, translate: translate },
	      style: { cursor: spaceIsPressed && spaceToPan ? "grab" : "" },
	      disabled: disablePan || spaceToPan && !spaceIsPressed,
	      "data-flume-stage": true
	    },
	    menuOpen ? React__default.createElement(
	      Portal$3,
	      null,
	      React__default.createElement(ContextMenu, {
	        x: menuCoordinates.x,
	        y: menuCoordinates.y,
	        options: menuOptions,
	        onRequestClose: closeContextMenu,
	        onOptionSelected: addNode,
	        label: "Add Node"
	      })
	    ) : null,
	    React__default.createElement(
	      "div",
	      {
	        ref: translateWrapper,
	        className: styles.transformWrapper,
	        style: { transform: "translate(" + -translate.x + "px, " + -translate.y + "px)" }
	      },
	      React__default.createElement(
	        "div",
	        {
	          className: styles.scaleWrapper,
	          style: { transform: "scale(" + scale + ")" }
	        },
	        children
	      )
	    ),
	    outerStageChildren
	  );
	};
	
	var css$2 = ".Node_wrapper__3SmT7{\n  background: rgba(91, 96, 99, 0.9);\n  border-radius: 5px;\n  box-shadow: 0px 4px 8px rgba(0,0,0,.4);\n  position: absolute;\n  left: 0px;\n  top: 0px;\n  user-select: none;\n  display: flex;\n  flex-direction: column;\n  z-index: 1;\n  cursor: default;\n}\n.Node_label__3MmhF{\n  font-size: 13px;\n  text-transform: uppercase;\n  padding: 5px;\n  background: #464b4e;\n  border-radius: 5px 5px 0px 0px;\n  margin: 0px;\n  margin-bottom: 3px;\n  border-bottom: 1px solid rgba(0,0,0,.15);\n}\n";
	var styles$2 = { "wrapper": "Node_wrapper__3SmT7", "label": "Node_label__3MmhF" };
	styleInject(css$2);
	
	var css$3 = ".Connection_svg__-fKLY{\n  position: absolute;\n  left: 0px;\n  top: 0px;\n  pointer-events: none;\n  z-index: 0;\n  overflow: visible !important;\n}\n";
	var styles$3 = { "svg": "Connection_svg__-fKLY" };
	styleInject(css$3);
	
	var pi = Math.PI,
	    tau = 2 * pi,
	    epsilon = 1e-6,
	    tauEpsilon = tau - epsilon;
	
	function Path() {
	  this._x0 = this._y0 = // start of current subpath
	  this._x1 = this._y1 = null; // end of current subpath
	  this._ = "";
	}
	
	function path() {
	  return new Path;
	}
	
	Path.prototype = path.prototype = {
	  constructor: Path,
	  moveTo: function(x, y) {
	    this._ += "M" + (this._x0 = this._x1 = +x) + "," + (this._y0 = this._y1 = +y);
	  },
	  closePath: function() {
	    if (this._x1 !== null) {
	      this._x1 = this._x0, this._y1 = this._y0;
	      this._ += "Z";
	    }
	  },
	  lineTo: function(x, y) {
	    this._ += "L" + (this._x1 = +x) + "," + (this._y1 = +y);
	  },
	  quadraticCurveTo: function(x1, y1, x, y) {
	    this._ += "Q" + (+x1) + "," + (+y1) + "," + (this._x1 = +x) + "," + (this._y1 = +y);
	  },
	  bezierCurveTo: function(x1, y1, x2, y2, x, y) {
	    this._ += "C" + (+x1) + "," + (+y1) + "," + (+x2) + "," + (+y2) + "," + (this._x1 = +x) + "," + (this._y1 = +y);
	  },
	  arcTo: function(x1, y1, x2, y2, r) {
	    x1 = +x1, y1 = +y1, x2 = +x2, y2 = +y2, r = +r;
	    var x0 = this._x1,
	        y0 = this._y1,
	        x21 = x2 - x1,
	        y21 = y2 - y1,
	        x01 = x0 - x1,
	        y01 = y0 - y1,
	        l01_2 = x01 * x01 + y01 * y01;
	
	    // Is the radius negative? Error.
	    if (r < 0) throw new Error("negative radius: " + r);
	
	    // Is this path empty? Move to (x1,y1).
	    if (this._x1 === null) {
	      this._ += "M" + (this._x1 = x1) + "," + (this._y1 = y1);
	    }
	
	    // Or, is (x1,y1) coincident with (x0,y0)? Do nothing.
	    else if (!(l01_2 > epsilon));
	
	    // Or, are (x0,y0), (x1,y1) and (x2,y2) collinear?
	    // Equivalently, is (x1,y1) coincident with (x2,y2)?
	    // Or, is the radius zero? Line to (x1,y1).
	    else if (!(Math.abs(y01 * x21 - y21 * x01) > epsilon) || !r) {
	      this._ += "L" + (this._x1 = x1) + "," + (this._y1 = y1);
	    }
	
	    // Otherwise, draw an arc!
	    else {
	      var x20 = x2 - x0,
	          y20 = y2 - y0,
	          l21_2 = x21 * x21 + y21 * y21,
	          l20_2 = x20 * x20 + y20 * y20,
	          l21 = Math.sqrt(l21_2),
	          l01 = Math.sqrt(l01_2),
	          l = r * Math.tan((pi - Math.acos((l21_2 + l01_2 - l20_2) / (2 * l21 * l01))) / 2),
	          t01 = l / l01,
	          t21 = l / l21;
	
	      // If the start tangent is not coincident with (x0,y0), line to.
	      if (Math.abs(t01 - 1) > epsilon) {
	        this._ += "L" + (x1 + t01 * x01) + "," + (y1 + t01 * y01);
	      }
	
	      this._ += "A" + r + "," + r + ",0,0," + (+(y01 * x20 > x01 * y20)) + "," + (this._x1 = x1 + t21 * x21) + "," + (this._y1 = y1 + t21 * y21);
	    }
	  },
	  arc: function(x, y, r, a0, a1, ccw) {
	    x = +x, y = +y, r = +r, ccw = !!ccw;
	    var dx = r * Math.cos(a0),
	        dy = r * Math.sin(a0),
	        x0 = x + dx,
	        y0 = y + dy,
	        cw = 1 ^ ccw,
	        da = ccw ? a0 - a1 : a1 - a0;
	
	    // Is the radius negative? Error.
	    if (r < 0) throw new Error("negative radius: " + r);
	
	    // Is this path empty? Move to (x0,y0).
	    if (this._x1 === null) {
	      this._ += "M" + x0 + "," + y0;
	    }
	
	    // Or, is (x0,y0) not coincident with the previous point? Line to (x0,y0).
	    else if (Math.abs(this._x1 - x0) > epsilon || Math.abs(this._y1 - y0) > epsilon) {
	      this._ += "L" + x0 + "," + y0;
	    }
	
	    // Is this arc empty? We’re done.
	    if (!r) return;
	
	    // Does the angle go the wrong way? Flip the direction.
	    if (da < 0) da = da % tau + tau;
	
	    // Is this a complete circle? Draw two arcs to complete the circle.
	    if (da > tauEpsilon) {
	      this._ += "A" + r + "," + r + ",0,1," + cw + "," + (x - dx) + "," + (y - dy) + "A" + r + "," + r + ",0,1," + cw + "," + (this._x1 = x0) + "," + (this._y1 = y0);
	    }
	
	    // Is this arc non-empty? Draw an arc!
	    else if (da > epsilon) {
	      this._ += "A" + r + "," + r + ",0," + (+(da >= pi)) + "," + cw + "," + (this._x1 = x + r * Math.cos(a1)) + "," + (this._y1 = y + r * Math.sin(a1));
	    }
	  },
	  rect: function(x, y, w, h) {
	    this._ += "M" + (this._x0 = this._x1 = +x) + "," + (this._y0 = this._y1 = +y) + "h" + (+w) + "v" + (+h) + "h" + (-w) + "Z";
	  },
	  toString: function() {
	    return this._;
	  }
	};
	
	function constant(x) {
	  return function constant() {
	    return x;
	  };
	}
	
	var pi$1 = Math.PI;
	
	function Linear(context) {
	  this._context = context;
	}
	
	Linear.prototype = {
	  areaStart: function() {
	    this._line = 0;
	  },
	  areaEnd: function() {
	    this._line = NaN;
	  },
	  lineStart: function() {
	    this._point = 0;
	  },
	  lineEnd: function() {
	    if (this._line || (this._line !== 0 && this._point === 1)) this._context.closePath();
	    this._line = 1 - this._line;
	  },
	  point: function(x, y) {
	    x = +x, y = +y;
	    switch (this._point) {
	      case 0: this._point = 1; this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y); break;
	      case 1: this._point = 2; // proceed
	      default: this._context.lineTo(x, y); break;
	    }
	  }
	};
	
	function curveLinear(context) {
	  return new Linear(context);
	}
	
	function x(p) {
	  return p[0];
	}
	
	function y(p) {
	  return p[1];
	}
	
	function line() {
	  var x$$1 = x,
	      y$$1 = y,
	      defined = constant(true),
	      context = null,
	      curve = curveLinear,
	      output = null;
	
	  function line(data) {
	    var i,
	        n = data.length,
	        d,
	        defined0 = false,
	        buffer;
	
	    if (context == null) output = curve(buffer = path());
	
	    for (i = 0; i <= n; ++i) {
	      if (!(i < n && defined(d = data[i], i, data)) === defined0) {
	        if (defined0 = !defined0) output.lineStart();
	        else output.lineEnd();
	      }
	      if (defined0) output.point(+x$$1(d, i, data), +y$$1(d, i, data));
	    }
	
	    if (buffer) return output = null, buffer + "" || null;
	  }
	
	  line.x = function(_) {
	    return arguments.length ? (x$$1 = typeof _ === "function" ? _ : constant(+_), line) : x$$1;
	  };
	
	  line.y = function(_) {
	    return arguments.length ? (y$$1 = typeof _ === "function" ? _ : constant(+_), line) : y$$1;
	  };
	
	  line.defined = function(_) {
	    return arguments.length ? (defined = typeof _ === "function" ? _ : constant(!!_), line) : defined;
	  };
	
	  line.curve = function(_) {
	    return arguments.length ? (curve = _, context != null && (output = curve(context)), line) : curve;
	  };
	
	  line.context = function(_) {
	    return arguments.length ? (_ == null ? context = output = null : output = curve(context = _), line) : context;
	  };
	
	  return line;
	}
	
	function point(that, x, y) {
	  that._context.bezierCurveTo(
	    (2 * that._x0 + that._x1) / 3,
	    (2 * that._y0 + that._y1) / 3,
	    (that._x0 + 2 * that._x1) / 3,
	    (that._y0 + 2 * that._y1) / 3,
	    (that._x0 + 4 * that._x1 + x) / 6,
	    (that._y0 + 4 * that._y1 + y) / 6
	  );
	}
	
	function Basis(context) {
	  this._context = context;
	}
	
	Basis.prototype = {
	  areaStart: function() {
	    this._line = 0;
	  },
	  areaEnd: function() {
	    this._line = NaN;
	  },
	  lineStart: function() {
	    this._x0 = this._x1 =
	    this._y0 = this._y1 = NaN;
	    this._point = 0;
	  },
	  lineEnd: function() {
	    switch (this._point) {
	      case 3: point(this, this._x1, this._y1); // proceed
	      case 2: this._context.lineTo(this._x1, this._y1); break;
	    }
	    if (this._line || (this._line !== 0 && this._point === 1)) this._context.closePath();
	    this._line = 1 - this._line;
	  },
	  point: function(x, y) {
	    x = +x, y = +y;
	    switch (this._point) {
	      case 0: this._point = 1; this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y); break;
	      case 1: this._point = 2; break;
	      case 2: this._point = 3; this._context.lineTo((5 * this._x0 + this._x1) / 6, (5 * this._y0 + this._y1) / 6); // proceed
	      default: point(this, x, y); break;
	    }
	    this._x0 = this._x1, this._x1 = x;
	    this._y0 = this._y1, this._y1 = y;
	  }
	};
	
	function curveBasis(context) {
	  return new Basis(context);
	}
	
	function sign(x) {
	  return x < 0 ? -1 : 1;
	}
	
	// Calculate the slopes of the tangents (Hermite-type interpolation) based on
	// the following paper: Steffen, M. 1990. A Simple Method for Monotonic
	// Interpolation in One Dimension. Astronomy and Astrophysics, Vol. 239, NO.
	// NOV(II), P. 443, 1990.
	function slope3(that, x2, y2) {
	  var h0 = that._x1 - that._x0,
	      h1 = x2 - that._x1,
	      s0 = (that._y1 - that._y0) / (h0 || h1 < 0 && -0),
	      s1 = (y2 - that._y1) / (h1 || h0 < 0 && -0),
	      p = (s0 * h1 + s1 * h0) / (h0 + h1);
	  return (sign(s0) + sign(s1)) * Math.min(Math.abs(s0), Math.abs(s1), 0.5 * Math.abs(p)) || 0;
	}
	
	// Calculate a one-sided slope.
	function slope2(that, t) {
	  var h = that._x1 - that._x0;
	  return h ? (3 * (that._y1 - that._y0) / h - t) / 2 : t;
	}
	
	// According to https://en.wikipedia.org/wiki/Cubic_Hermite_spline#Representations
	// "you can express cubic Hermite interpolation in terms of cubic Bézier curves
	// with respect to the four values p0, p0 + m0 / 3, p1 - m1 / 3, p1".
	function point$3(that, t0, t1) {
	  var x0 = that._x0,
	      y0 = that._y0,
	      x1 = that._x1,
	      y1 = that._y1,
	      dx = (x1 - x0) / 3;
	  that._context.bezierCurveTo(x0 + dx, y0 + dx * t0, x1 - dx, y1 - dx * t1, x1, y1);
	}
	
	function MonotoneX(context) {
	  this._context = context;
	}
	
	MonotoneX.prototype = {
	  areaStart: function() {
	    this._line = 0;
	  },
	  areaEnd: function() {
	    this._line = NaN;
	  },
	  lineStart: function() {
	    this._x0 = this._x1 =
	    this._y0 = this._y1 =
	    this._t0 = NaN;
	    this._point = 0;
	  },
	  lineEnd: function() {
	    switch (this._point) {
	      case 2: this._context.lineTo(this._x1, this._y1); break;
	      case 3: point$3(this, this._t0, slope2(this, this._t0)); break;
	    }
	    if (this._line || (this._line !== 0 && this._point === 1)) this._context.closePath();
	    this._line = 1 - this._line;
	  },
	  point: function(x, y) {
	    var t1 = NaN;
	
	    x = +x, y = +y;
	    if (x === this._x1 && y === this._y1) return; // Ignore coincident points.
	    switch (this._point) {
	      case 0: this._point = 1; this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y); break;
	      case 1: this._point = 2; break;
	      case 2: this._point = 3; point$3(this, slope2(this, t1 = slope3(this, x, y)), t1); break;
	      default: point$3(this, this._t0, t1 = slope3(this, x, y)); break;
	    }
	
	    this._x0 = this._x1, this._x1 = x;
	    this._y0 = this._y1, this._y1 = y;
	    this._t0 = t1;
	  }
	};
	
	function MonotoneY(context) {
	  this._context = new ReflectContext(context);
	}
	
	(MonotoneY.prototype = Object.create(MonotoneX.prototype)).point = function(x, y) {
	  MonotoneX.prototype.point.call(this, y, x);
	};
	
	function ReflectContext(context) {
	  this._context = context;
	}
	
	ReflectContext.prototype = {
	  moveTo: function(x, y) { this._context.moveTo(y, x); },
	  closePath: function() { this._context.closePath(); },
	  lineTo: function(x, y) { this._context.lineTo(y, x); },
	  bezierCurveTo: function(x1, y1, x2, y2, x, y) { this._context.bezierCurveTo(y1, x1, y2, x2, y, x); }
	};
	
	var getPort = function getPort(nodeId, portName) {
	  var transputType = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "input";
	  return document.querySelector('[data-node-id="' + nodeId + '"] [data-port-name="' + portName + '"][data-port-transput-type="' + transputType + '"]');
	};
	
	var getPortRect = function getPortRect(nodeId, portName) {
	  var transputType = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "input";
	  var cache = arguments[3];
	
	  if (cache) {
	    var portCacheName = nodeId + portName + transputType;
	    var cachedPort = cache.current.ports[portCacheName];
	    if (cachedPort) {
	      return cachedPort.getBoundingClientRect();
	    } else {
	      var port = getPort(nodeId, portName, transputType);
	      cache.current.ports[portCacheName] = port;
	      return port && port.getBoundingClientRect();
	    }
	  } else {
	    var _port = getPort(nodeId, portName, transputType);
	    return _port && _port.getBoundingClientRect();
	  }
	};
	
	var calculateCurve = function calculateCurve(from, to) {
	  var length = to.x - from.x;
	  var thirdLength = length / 3;
	  var curve = line().curve(curveBasis)([[from.x, from.y], [from.x + thirdLength, from.y], [from.x + thirdLength * 2, to.y], [to.x, to.y]]);
	  return curve;
	};
	
	var deleteConnection = function deleteConnection(_ref3) {
	  var id = _ref3.id;
	
	  var line$$1 = document.querySelector('[data-connection-id="' + id + '"]');
	  if (line$$1) line$$1.parentNode.remove();
	};
	
	var deleteConnectionsByNodeId = function deleteConnectionsByNodeId(nodeId) {
	  var lines = document.querySelectorAll('[data-output-node-id="' + nodeId + '"], [data-input-node-id="' + nodeId + '"]');
	  var _iteratorNormalCompletion = true;
	  var _didIteratorError = false;
	  var _iteratorError = undefined;
	
	  try {
	    for (var _iterator = lines[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	      var _line = _step.value;
	
	      _line.parentNode.remove();
	    }
	  } catch (err) {
	    _didIteratorError = true;
	    _iteratorError = err;
	  } finally {
	    try {
	      if (!_iteratorNormalCompletion && _iterator.return) {
	        _iterator.return();
	      }
	    } finally {
	      if (_didIteratorError) {
	        throw _iteratorError;
	      }
	    }
	  }
	};
	
	var updateConnection = function updateConnection(_ref4) {
	  var line$$1 = _ref4.line,
	      from = _ref4.from,
	      to = _ref4.to;
	
	  line$$1.setAttribute("d", calculateCurve(from, to));
	};
	
	var createSVG = function createSVG(_ref5) {
	  var from = _ref5.from,
	      to = _ref5.to,
	      stage = _ref5.stage,
	      id = _ref5.id,
	      outputNodeId = _ref5.outputNodeId,
	      outputPortName = _ref5.outputPortName,
	      inputNodeId = _ref5.inputNodeId,
	      inputPortName = _ref5.inputPortName;
	
	  var svg = document.createElementNS("http://www.w3.org/2000/svg", "svg");
	  svg.setAttribute("class", styles$3.svg);
	  var path = document.createElementNS("http://www.w3.org/2000/svg", "path");
	  var curve = calculateCurve(from, to);
	  path.setAttribute("d", curve);
	  path.setAttribute("stroke", "rgb(185, 186, 189)");
	  path.setAttribute("stroke-width", "3");
	  path.setAttribute("stroke-linecap", "round");
	  path.setAttribute("fill", "none");
	  path.setAttribute("data-connection-id", id);
	  path.setAttribute("data-output-node-id", outputNodeId);
	  path.setAttribute("data-output-port-name", outputPortName);
	  path.setAttribute("data-input-node-id", inputNodeId);
	  path.setAttribute("data-input-port-name", inputPortName);
	  svg.appendChild(path);
	  stage.appendChild(svg);
	  return svg;
	};
	
	var getStageRef = function getStageRef(editorId) {
	  return document.getElementById('' + CONNECTIONS_ID + editorId);
	};
	
	var createConnections = function createConnections(nodes, _ref6, editorId) {
	  var scale = _ref6.scale,
	      stageId = _ref6.stageId;
	
	  var stageRef = getStageRef(editorId);
	  if (stageRef) {
	    var stage = stageRef.getBoundingClientRect();
	    var stageHalfWidth = stage.width / 2;
	    var stageHalfHeight = stage.height / 2;
	
	    var byScale = function byScale(value) {
	      return 1 / scale * value;
	    };
	
	    Object.values(nodes).forEach(function (node) {
	      if (node.connections && node.connections.inputs) {
	        Object.entries(node.connections.inputs).forEach(function (_ref7, k) {
	          var _ref8 = slicedToArray(_ref7, 2),
	              inputName = _ref8[0],
	              outputs = _ref8[1];
	
	          outputs.forEach(function (output) {
	            var fromPort = getPortRect(output.nodeId, output.portName, "output");
	            var toPort = getPortRect(node.id, inputName, "input");
	            var portHalf = fromPort ? fromPort.width / 2 : 0;
	            if (fromPort && toPort) {
	              var id = output.nodeId + output.portName + node.id + inputName;
	              var existingLine = document.querySelector('[data-connection-id="' + id + '"]');
	              if (existingLine) {
	                updateConnection({
	                  line: existingLine,
	                  from: {
	                    x: byScale(fromPort.x - stage.x + portHalf - stageHalfWidth),
	                    y: byScale(fromPort.y - stage.y + portHalf - stageHalfHeight)
	                  },
	                  to: {
	                    x: byScale(toPort.x - stage.x + portHalf - stageHalfWidth),
	                    y: byScale(toPort.y - stage.y + portHalf - stageHalfHeight)
	                  }
	                });
	              } else {
	                createSVG({
	                  id: id,
	                  outputNodeId: output.nodeId,
	                  outputPortName: output.portName,
	                  inputNodeId: node.id,
	                  inputPortName: inputName,
	                  from: {
	                    x: byScale(fromPort.x - stage.x + portHalf - stageHalfWidth),
	                    y: byScale(fromPort.y - stage.y + portHalf - stageHalfHeight)
	                  },
	                  to: {
	                    x: byScale(toPort.x - stage.x + portHalf - stageHalfWidth),
	                    y: byScale(toPort.y - stage.y + portHalf - stageHalfHeight)
	                  },
	                  stage: stageRef
	                });
	              }
	            }
	          });
	        });
	      }
	    });
	  }
	};
	
	var css$4 = ".IoPorts_wrapper__3d2hh{\n  display: flex;\n  flex-direction: column;\n  margin-top: auto;\n  width: 100%;\n  padding: 5px;\n}\n.IoPorts_inputs__2etkb{\n  display: flex;\n  flex-direction: column;\n  justify-content: flex-end;\n  width: 100%;\n  margin-bottom: 10px;\n}\n.IoPorts_inputs__2etkb:last-child{\n    margin-bottom: 0px;\n  }\n.IoPorts_inputs__2etkb .IoPorts_transput__1wbHA:first-child .IoPorts_portLabel__qOE7y, .IoPorts_inputs__2etkb .IoPorts_transput__1wbHA:first-child .IoPorts_port__1_a6J{\n        margin-top: 5px;\n      }\n.IoPorts_inputs__2etkb .IoPorts_transput__1wbHA:last-child .IoPorts_portLabel__qOE7y, .IoPorts_inputs__2etkb .IoPorts_transput__1wbHA:last-child .IoPorts_port__1_a6J{\n        margin-bottom: 5px;\n      }\n.IoPorts_outputs__3JGh-{\n  display: flex;\n  flex-direction: column;\n  margin-left: auto;\n  justify-content: flex-end;\n  align-items: flex-end;\n  width: 100%;\n}\n.IoPorts_outputs__3JGh- .IoPorts_transput__1wbHA:last-child .IoPorts_portLabel__qOE7y, .IoPorts_outputs__3JGh- .IoPorts_transput__1wbHA:last-child .IoPorts_port__1_a6J{\n        margin-bottom: 5px;\n      }\n.IoPorts_outputs__3JGh-:first-child{\n    margin-top: 5px;\n  }\n.IoPorts_transput__1wbHA{\n  display: flex;\n  align-items: center;\n  margin-top: 6px;\n  margin-bottom: 6px;\n}\n.IoPorts_transput__1wbHA:first-child{\n    margin-top: 0px;\n  }\n.IoPorts_transput__1wbHA[data-controlless=\"true\"]{\n    margin-top: 6px;\n    margin-bottom: 6px;\n  }\n.IoPorts_transput__1wbHA[data-controlless=\"true\"]:first-child{\n      margin-top: 0px;\n    }\n.IoPorts_transput__1wbHA[data-controlless=\"false\"]{\n    margin-top: 2px;\n    margin-bottom: 2px;\n  }\n.IoPorts_controls__1dKFt{\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n}\n.IoPorts_portLabel__qOE7y{\n  font-size: 13px;\n  font-weight: 400;\n}\n.IoPorts_port__1_a6J{\n  width: 12px;\n  height: 12px;\n  background: linear-gradient(to bottom, #acb1b4, #919699);\n  border-radius: 100%;\n  margin-right: 5px;\n  margin-left: -11px;\n  flex: 0 0 auto;\n  box-shadow: 0px 2px 1px 0px rgba(0,0,0,.6);\n}\n.IoPorts_port__1_a6J:last-child{\n    margin-right: -11px;\n    margin-left: 5px;\n  }\n.IoPorts_port__1_a6J[data-port-color=\"red\"]{\n    background: linear-gradient(to bottom, #fa4a6f, #c22e4d);\n  }\n.IoPorts_port__1_a6J[data-port-color=\"purple\"]{\n    background: linear-gradient(to bottom, #9e55fb, #6024b6);\n  }\n.IoPorts_port__1_a6J[data-port-color=\"blue\"]{\n    background: linear-gradient(to bottom, #4284f7, #2867d4);\n  }\n.IoPorts_port__1_a6J[data-port-color=\"green\"]{\n    background: linear-gradient(to bottom, #31dd9f, #11ad7a);\n  }\n.IoPorts_port__1_a6J[data-port-color=\"yellow\"]{\n    background: linear-gradient(to bottom, #d6bf47, #9d8923);\n  }\n.IoPorts_port__1_a6J[data-port-color=\"orange\"]{\n    background: linear-gradient(to bottom, #fa7841, #c94b23);\n  }\n.IoPorts_port__1_a6J[data-port-color=\"pink\"]{\n    background: linear-gradient(to bottom, #fe8aeb, #e046c3);\n  }\n";
	var styles$4 = { "wrapper": "IoPorts_wrapper__3d2hh", "inputs": "IoPorts_inputs__2etkb", "transput": "IoPorts_transput__1wbHA", "portLabel": "IoPorts_portLabel__qOE7y", "port": "IoPorts_port__1_a6J", "outputs": "IoPorts_outputs__3JGh-", "controls": "IoPorts_controls__1dKFt" };
	styleInject(css$4);
	
	var css$5 = ".Control_wrapper__VZIiC {\n  width: 100%;\n  padding-right: 3px;\n  padding-top: 3px;\n  padding-bottom: 5px;\n}\n.Control_label__1OX-Q {\n  font-size: 14px;\n}\n.Control_controlLabel__3ga2- {\n  font-size: 13px;\n  display: inline-block;\n  margin-left: 2px;\n}\n";
	var styles$5 = { "wrapper": "Control_wrapper__VZIiC", "label": "Control_label__1OX-Q", "controlLabel": "Control_controlLabel__3ga2-" };
	styleInject(css$5);
	
	var css$6 = ".Checkbox_wrapper__aSqyY{\n  display: flex;\n  align-items: center;\n}\n.Checkbox_checkbox__Qv5gn{\n  background: linear-gradient(to bottom, #5b5f62, #6f7477);\n  border: 1px solid #3c3e40;\n  border-radius: 4px;\n  margin-right: 8px;\n}\n.Checkbox_label__2RxP-{\n  padding-top: 2px;\n  font-size: 13px;\n}\n";
	var styles$6 = { "wrapper": "Checkbox_wrapper__aSqyY", "checkbox": "Checkbox_checkbox__Qv5gn", "label": "Checkbox_label__2RxP-" };
	styleInject(css$6);
	
	var Checkbox = function Checkbox(_ref) {
	  var label = _ref.label,
	      data = _ref.data,
	      _onChange = _ref.onChange;
	
	  var id = React__default.useRef(nonSecure(10));
	
	  return React__default.createElement(
	    "div",
	    { className: styles$6.wrapper },
	    React__default.createElement("input", {
	      className: styles$6.checkbox,
	      type: "checkbox",
	      id: id,
	      value: data,
	      checked: data,
	      onChange: function onChange(e) {
	        return _onChange(e.target.checked);
	      }
	    }),
	    React__default.createElement(
	      "label",
	      { className: styles$6.label, htmlFor: id },
	      label
	    )
	  );
	};
	
	var css$7 = ".TextInput_wrapper__tefOZ{\n  background: none;\n  border: none;\n}\n.TextInput_input__1QHwS{\n  background: linear-gradient(to bottom, #5b5f62, #6f7477);\n  width: 100%;\n  border: 1px solid #3c3e40;\n  border-radius: 4px;\n  font-size: 13px;\n  padding: 5px;\n  resize: vertical;\n  outline: none;\n}\n.TextInput_input__1QHwS::placeholder{\n    color: rgb(47, 49, 50);\n  }\n.TextInput_input__1QHwS:focus{\n    background: linear-gradient(to bottom, #676b6e, #75797c);\n  }\n";
	var styles$7 = { "wrapper": "TextInput_wrapper__tefOZ", "input": "TextInput_input__1QHwS" };
	styleInject(css$7);
	
	var TextInput = function TextInput(_ref) {
	  var placeholder = _ref.placeholder,
	      updateNodeConnections = _ref.updateNodeConnections,
	      _onChange = _ref.onChange,
	      data = _ref.data,
	      step = _ref.step,
	      type = _ref.type;
	
	  var numberInput = React__default.useRef();
	  var recalculateStageRect = React__default.useContext(RecalculateStageRectContext);
	
	  var handleDragEnd = function handleDragEnd() {
	    document.removeEventListener("mousemove", handleMouseMove);
	    document.removeEventListener("mouseup", handleDragEnd);
	  };
	
	  var handleMouseMove = function handleMouseMove(e) {
	    e.stopPropagation();
	    updateNodeConnections();
	  };
	
	  var handlePossibleResize = function handlePossibleResize(e) {
	    e.stopPropagation();
	    recalculateStageRect();
	    document.addEventListener("mousemove", handleMouseMove);
	    document.addEventListener("mouseup", handleDragEnd);
	  };
	
	  return React__default.createElement(
	    "div",
	    { className: styles$7.wrapper },
	    type === "number" ? React__default.createElement("input", {
	      onKeyDown: function onKeyDown(e) {
	        if (e.keyCode === 69) {
	          e.preventDefault();
	          return false;
	        }
	      },
	      onChange: function onChange(e) {
	        var inputValue = e.target.value.replace(/[^0-9.]+/g, '');
	        if (!!inputValue) {
	          var value = parseFloat(inputValue, 10);
	          if (Number.isNaN(value)) {
	            _onChange(0);
	          } else {
	            _onChange(value);
	            numberInput.current.value = value;
	          }
	        }
	      },
	      onBlur: function onBlur(e) {
	        if (!e.target.value) {
	          _onChange(0);
	          numberInput.current.value = 0;
	        }
	      },
	      step: step || "1",
	      onMouseDown: handlePossibleResize,
	      type: type || "text",
	      placeholder: placeholder,
	      className: styles$7.input,
	      defaultValue: data,
	      onDragStart: function onDragStart(e) {
	        return e.stopPropagation();
	      },
	      ref: numberInput
	    }) : React__default.createElement("textarea", {
	      onChange: function onChange(e) {
	        return _onChange(e.target.value);
	      },
	      onMouseDown: handlePossibleResize,
	      type: "text",
	      placeholder: placeholder,
	      className: styles$7.input,
	      value: data,
	      onDragStart: function onDragStart(e) {
	        return e.stopPropagation();
	      }
	    })
	  );
	};
	
	var css$8 = ".Select_wrapper__eAPoQ{\n  font-size: 14px;\n  padding: 3px 6px;\n  border-radius: 4px;\n  background: linear-gradient(to top, #5b5f62, #6f7477);\n  width: 100%;\n  border: 1px solid #3c3e40;\n  padding-right: 15px;\n  position: relative;\n}\n  .Select_wrapper__eAPoQ::after{\n    content: \"\";\n    position: absolute;\n    background: none;\n    right: 5px;\n    top: 8px;\n    width: 0;\n    height: 0;\n    border-style: solid;\n    border-width: 6px 5px 0 5px;\n    border-color: #191b1c transparent transparent transparent;\n  }\n  .Select_wrapper__eAPoQ:hover{\n    background: linear-gradient(to top, #63676a, #777b7e);\n  }\n.Select_chipWrapper__3hK2u{\n  font-size: 14px;\n  padding: 3px 6px;\n  border-radius: 4px;\n  background: linear-gradient(to top, #5b5f62, #6f7477);\n  border: 1px solid #3c3e40;\n  margin: 2px;\n  position: relative;\n}\n.Select_chipWrapper__3hK2u:hover .Select_deleteButton__1FnLK{\n  opacity: 1;\n}\n.Select_chipsWrapper__4Alw8{\n  display: flex;\n  flex-direction: column;\n  margin-bottom: 6px;\n}\n.Select_deleteButton__1FnLK{\n  position: absolute;\n  right: 0px;\n  top: 0px;\n  height: 100%;\n  width: 22px;\n  padding: 0px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  background: linear-gradient(to top, #5b5f62, #6f7477);\n  border-radius: 3px;\n  border: none;\n  font-weight: bold;\n  opacity: 0;\n}\n.Select_deleteButton__1FnLK:focus{\n  opacity: 1;\n}\n.Select_deleteButton__1FnLK:hover{\n  background: linear-gradient(to top, #64696c, #797f82);\n}\n.Select_selectedWrapper__SUs4D{\n  display: flex;\n  flex-direction: column;\n  border-radius: 4px;\n  background: linear-gradient(to top, #5b5f62, #6f7477);\n  width: 100%;\n  border: 1px solid #3c3e40;\n  font-size: 14px;\n  padding: 3px 6px;\n  padding-right: 15px;\n  position: relative;\n}\n.Select_selectedWrapper__SUs4D::after{\n    content: \"\";\n    position: absolute;\n    background: none;\n    right: 5px;\n    top: calc(50% - 4px);\n    width: 0;\n    height: 0;\n    border-style: solid;\n    border-width: 6px 5px 0 5px;\n    border-color: #191b1c transparent transparent transparent;\n  }\n.Select_selectedWrapper__SUs4D label{\n    margin: 0px;\n  }\n.Select_selectedWrapper__SUs4D p{\n    margin: 0px;\n    margin-top: 5px;\n    font-size: 12px;\n    font-style: italic;\n    color: rgb(50, 50, 50);\n  }\n";
	var styles$8 = { "wrapper": "Select_wrapper__eAPoQ", "chipWrapper": "Select_chipWrapper__3hK2u", "deleteButton": "Select_deleteButton__1FnLK", "chipsWrapper": "Select_chipsWrapper__4Alw8", "selectedWrapper": "Select_selectedWrapper__SUs4D" };
	styleInject(css$8);
	
	var MAX_LABEL_LENGTH = 50;
	
	var Select = function Select(_ref) {
	  var _ref$options = _ref.options,
	      options = _ref$options === undefined ? [] : _ref$options,
	      _ref$placeholder = _ref.placeholder,
	      placeholder = _ref$placeholder === undefined ? "[Select an option]" : _ref$placeholder,
	      onChange = _ref.onChange,
	      data = _ref.data,
	      allowMultiple = _ref.allowMultiple;
	
	  var _React$useState = React__default.useState(false),
	      _React$useState2 = slicedToArray(_React$useState, 2),
	      drawerOpen = _React$useState2[0],
	      setDrawerOpen = _React$useState2[1];
	
	  var _React$useState3 = React__default.useState({
	    x: 0,
	    y: 0
	  }),
	      _React$useState4 = slicedToArray(_React$useState3, 2),
	      drawerCoordinates = _React$useState4[0],
	      setDrawerCoordinates = _React$useState4[1];
	
	  var wrapper = React__default.useRef();
	
	  var closeDrawer = function closeDrawer() {
	    setDrawerOpen(false);
	  };
	
	  var openDrawer = function openDrawer() {
	    if (!drawerOpen) {
	      var wrapperRect = wrapper.current.getBoundingClientRect();
	      setDrawerCoordinates({
	        x: wrapperRect.x,
	        y: wrapperRect.y + wrapperRect.height
	      });
	      setDrawerOpen(true);
	    }
	  };
	
	  var handleOptionSelected = function handleOptionSelected(option) {
	    if (allowMultiple) {
	      onChange([].concat(toConsumableArray(data), [option.value]));
	    } else {
	      onChange(option.value);
	    }
	  };
	
	  var handleOptionDeleted = function handleOptionDeleted(optionIndex) {
	    onChange([].concat(toConsumableArray(data.slice(0, optionIndex)), toConsumableArray(data.slice(optionIndex + 1))));
	  };
	
	  var getFilteredOptions = function getFilteredOptions() {
	    return allowMultiple ? options.filter(function (opt) {
	      return !data.includes(opt.value);
	    }) : options;
	  };
	
	  var selectedOption = React__default.useMemo(function () {
	    var option = options.find(function (o) {
	      return o.value === data;
	    });
	    if (option) {
	      return _extends({}, option, {
	        label: option.label.length > MAX_LABEL_LENGTH ? option.label.slice(0, MAX_LABEL_LENGTH) + "..." : option.label
	      });
	    }
	  }, [options, data]);
	
	  return React__default.createElement(
	    React__default.Fragment,
	    null,
	    allowMultiple ? data.length ? React__default.createElement(
	      "div",
	      { className: styles$8.chipsWrapper },
	      data.map(function (val, i) {
	        var optLabel = (options.find(function (opt) {
	          return opt.value === val;
	        }) || {}).label || "";
	        return React__default.createElement(
	          OptionChip,
	          {
	            onRequestDelete: function onRequestDelete() {
	              return handleOptionDeleted(i);
	            },
	            key: val
	          },
	          optLabel
	        );
	      })
	    ) : null : data ? React__default.createElement(SelectedOption, {
	      wrapperRef: wrapper,
	      option: selectedOption,
	      onClick: openDrawer
	    }) : null,
	    (allowMultiple || !data) && React__default.createElement(
	      "div",
	      { className: styles$8.wrapper, ref: wrapper, onClick: openDrawer },
	      placeholder
	    ),
	    drawerOpen && React__default.createElement(
	      Portal$3,
	      null,
	      React__default.createElement(ContextMenu, {
	        x: drawerCoordinates.x,
	        y: drawerCoordinates.y,
	        emptyText: "There are no options",
	        options: getFilteredOptions(),
	        onOptionSelected: handleOptionSelected,
	        onRequestClose: closeDrawer
	      })
	    )
	  );
	};
	
	var SelectedOption = function SelectedOption(_ref2) {
	  var _ref2$option = _ref2.option;
	  _ref2$option = _ref2$option === undefined ? {} : _ref2$option;
	  var label = _ref2$option.label,
	      description = _ref2$option.description,
	      wrapperRef = _ref2.wrapperRef,
	      onClick = _ref2.onClick;
	  return React__default.createElement(
	    "div",
	    { className: styles$8.selectedWrapper, onClick: onClick, ref: wrapperRef },
	    React__default.createElement(
	      "label",
	      null,
	      label
	    ),
	    description ? React__default.createElement(
	      "p",
	      null,
	      description
	    ) : null
	  );
	};
	
	var OptionChip = function OptionChip(_ref3) {
	  var children = _ref3.children,
	      onRequestDelete = _ref3.onRequestDelete;
	  return React__default.createElement(
	    "div",
	    { className: styles$8.chipWrapper },
	    children,
	    React__default.createElement(
	      "button",
	      {
	        className: styles$8.deleteButton,
	        onMouseDown: function onMouseDown(e) {
	          e.stopPropagation();
	        },
	        onClick: onRequestDelete
	      },
	      "\u2715"
	    )
	  );
	};
	
	var Control = function Control(_ref) {
	  var type = _ref.type,
	      name = _ref.name,
	      nodeId = _ref.nodeId,
	      portName = _ref.portName,
	      label = _ref.label,
	      inputLabel = _ref.inputLabel,
	      data = _ref.data,
	      allData = _ref.allData,
	      render = _ref.render,
	      step = _ref.step,
	      _ref$options = _ref.options,
	      options = _ref$options === undefined ? [] : _ref$options,
	      placeholder = _ref.placeholder,
	      inputData = _ref.inputData,
	      triggerRecalculation = _ref.triggerRecalculation,
	      updateNodeConnections = _ref.updateNodeConnections,
	      getOptions = _ref.getOptions,
	      setValue = _ref.setValue,
	      defaultValue = _ref.defaultValue,
	      isMonoControl = _ref.isMonoControl;
	
	  var nodesDispatch = React__default.useContext(NodeDispatchContext);
	  var executionContext = React__default.useContext(ContextContext);
	
	  var calculatedLabel = isMonoControl ? inputLabel : label;
	
	  var onChange = function onChange(data) {
	    nodesDispatch({
	      type: "SET_PORT_DATA",
	      data: data,
	      nodeId: nodeId,
	      portName: portName,
	      controlName: name,
	      setValue: setValue
	    });
	    triggerRecalculation();
	  };
	
	  var getControlByType = function getControlByType(type) {
	    var commonProps = {
	      triggerRecalculation: triggerRecalculation,
	      updateNodeConnections: updateNodeConnections,
	      onChange: onChange,
	      data: data
	    };
	    switch (type) {
	      case "select":
	        return React__default.createElement(Select, _extends({}, commonProps, {
	          options: getOptions ? getOptions(inputData, executionContext) : options,
	          placeholder: placeholder
	        }));
	      case "text":
	        return React__default.createElement(TextInput, _extends({}, commonProps, { placeholder: placeholder }));
	      case "number":
	        return React__default.createElement(TextInput, _extends({}, commonProps, { step: step, type: "number", placeholder: placeholder }));
	      case "checkbox":
	        return React__default.createElement(Checkbox, _extends({}, commonProps, { label: calculatedLabel }));
	      case "multiselect":
	        return React__default.createElement(Select, _extends({
	          allowMultiple: true
	        }, commonProps, {
	          options: getOptions ? getOptions(inputData, executionContext) : options,
	          placeholder: placeholder,
	          label: label
	        }));
	      case "custom":
	        return render(data, onChange, executionContext, triggerRecalculation, {
	          label: label,
	          name: name,
	          portName: portName,
	          inputLabel: inputLabel,
	          defaultValue: defaultValue
	        }, allData);
	      default:
	        return React__default.createElement(
	          "div",
	          null,
	          "Control"
	        );
	    }
	  };
	
	  return React__default.createElement(
	    "div",
	    { className: styles$5.wrapper },
	    calculatedLabel && type !== "checkbox" && type !== "custom" && React__default.createElement(
	      "label",
	      { className: styles$5.controlLabel },
	      calculatedLabel
	    ),
	    getControlByType(type)
	  );
	};
	
	var Connection = function Connection(_ref) {
	  var from = _ref.from,
	      to = _ref.to,
	      id = _ref.id,
	      lineRef = _ref.lineRef,
	      outputNodeId = _ref.outputNodeId,
	      outputPortName = _ref.outputPortName,
	      inputNodeId = _ref.inputNodeId,
	      inputPortName = _ref.inputPortName;
	
	  var curve = calculateCurve(from, to);
	  return React__default.createElement(
	    "svg",
	    { className: styles$3.svg },
	    React__default.createElement("path", {
	      "data-connection-id": id,
	      "data-output-node-id": outputNodeId,
	      "data-output-port-name": outputPortName,
	      "data-input-node-id": inputNodeId,
	      "data-input-port-name": inputPortName,
	      stroke: "rgb(185, 186, 189)",
	      fill: "none",
	      strokeWidth: 3,
	      strokeLinecap: "round",
	      d: curve,
	      ref: lineRef
	    })
	  );
	};
	
	var usePrevious$1 = function usePrevious(value) {
	  var ref = React__default.useRef();
	  React__default.useEffect(function () {
	    ref.current = value;
	  });
	  return ref.current;
	};
	
	function useTransputs(transputsFn, transputType, nodeId, inputData, connections) {
	  var nodesDispatch = React__default.useContext(NodeDispatchContext);
	  var executionContext = React__default.useContext(ContextContext);
	
	  var transputs = React__default.useMemo(function () {
	    if (Array.isArray(transputsFn)) return transputsFn;
	    return transputsFn(inputData, connections, executionContext);
	  }, [transputsFn, inputData, connections, executionContext]);
	  var prevTransputs = usePrevious$1(transputs);
	
	  React__default.useEffect(function () {
	    if (!prevTransputs || Array.isArray(transputsFn)) return;
	
	    var _loop = function _loop(transput) {
	      var current = transputs.find(function (_ref) {
	        var name = _ref.name;
	        return transput.name === name;
	      });
	      if (!current) {
	        nodesDispatch({
	          type: 'DESTROY_TRANSPUT',
	          transputType: transputType,
	          transput: { nodeId: nodeId, portName: '' + transput.name }
	        });
	      }
	    };
	
	    var _iteratorNormalCompletion = true;
	    var _didIteratorError = false;
	    var _iteratorError = undefined;
	
	    try {
	      for (var _iterator = prevTransputs[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	        var transput = _step.value;
	
	        _loop(transput);
	      }
	    } catch (err) {
	      _didIteratorError = true;
	      _iteratorError = err;
	    } finally {
	      try {
	        if (!_iteratorNormalCompletion && _iterator.return) {
	          _iterator.return();
	        }
	      } finally {
	        if (_didIteratorError) {
	          throw _iteratorError;
	        }
	      }
	    }
	  }, [transputsFn, transputs, prevTransputs, nodesDispatch, nodeId, transputType]);
	
	  return transputs;
	}
	
	var IoPorts = function IoPorts(_ref2) {
	  var nodeId = _ref2.nodeId,
	      _ref2$inputs = _ref2.inputs,
	      inputs = _ref2$inputs === undefined ? [] : _ref2$inputs,
	      _ref2$outputs = _ref2.outputs,
	      outputs = _ref2$outputs === undefined ? [] : _ref2$outputs,
	      connections = _ref2.connections,
	      inputData = _ref2.inputData,
	      updateNodeConnections = _ref2.updateNodeConnections;
	
	  var inputTypes = React__default.useContext(PortTypesContext);
	  var triggerRecalculation = React__default.useContext(ConnectionRecalculateContext);
	  var resolvedInputs = useTransputs(inputs, 'input', nodeId, inputData, connections);
	  var resolvedOutputs = useTransputs(outputs, 'output', nodeId, inputData, connections);
	
	  return React__default.createElement(
	    "div",
	    { className: styles$4.wrapper },
	    resolvedInputs.length ? React__default.createElement(
	      "div",
	      { className: styles$4.inputs },
	      resolvedInputs.map(function (input) {
	        return React__default.createElement(Input, _extends({}, input, {
	          data: inputData[input.name] || {},
	          isConnected: !!connections.inputs[input.name],
	          triggerRecalculation: triggerRecalculation,
	          updateNodeConnections: updateNodeConnections,
	          inputTypes: inputTypes,
	          nodeId: nodeId,
	          inputData: inputData,
	          key: input.name
	        }));
	      })
	    ) : null,
	    !!resolvedOutputs.length && React__default.createElement(
	      "div",
	      { className: styles$4.outputs },
	      resolvedOutputs.map(function (output) {
	        return React__default.createElement(Output, _extends({}, output, {
	          triggerRecalculation: triggerRecalculation,
	          inputTypes: inputTypes,
	          nodeId: nodeId,
	          inputData: inputData,
	          portOnRight: true,
	          key: output.name
	        }));
	      })
	    )
	  );
	};
	
	var Input = function Input(_ref3) {
	  var type = _ref3.type,
	      label = _ref3.label,
	      name = _ref3.name,
	      nodeId = _ref3.nodeId,
	      data = _ref3.data,
	      localControls = _ref3.controls,
	      inputTypes = _ref3.inputTypes,
	      noControls = _ref3.noControls,
	      triggerRecalculation = _ref3.triggerRecalculation,
	      updateNodeConnections = _ref3.updateNodeConnections,
	      isConnected = _ref3.isConnected,
	      inputData = _ref3.inputData,
	      hidePort = _ref3.hidePort;
	
	  var _ref4 = inputTypes[type] || {},
	      defaultLabel = _ref4.label,
	      color = _ref4.color,
	      _ref4$controls = _ref4.controls,
	      defaultControls = _ref4$controls === undefined ? [] : _ref4$controls;
	
	  var prevConnected = usePrevious$1(isConnected);
	
	  var controls = localControls || defaultControls;
	
	  React__default.useEffect(function () {
	    if (isConnected !== prevConnected) {
	      triggerRecalculation();
	    }
	  }, [isConnected, prevConnected, triggerRecalculation]);
	
	  return React__default.createElement(
	    "div",
	    {
	      className: styles$4.transput,
	      "data-controlless": isConnected || noControls || !controls.length,
	      onDragStart: function onDragStart(e) {
	        e.preventDefault();
	        e.stopPropagation();
	      }
	    },
	    !hidePort ? React__default.createElement(Port, {
	      type: type,
	      color: color,
	      name: name,
	      nodeId: nodeId,
	      isInput: true,
	      triggerRecalculation: triggerRecalculation
	    }) : null,
	    (!controls.length || noControls || isConnected) && React__default.createElement(
	      "label",
	      { className: styles$4.portLabel },
	      label || defaultLabel
	    ),
	    !noControls && !isConnected ? React__default.createElement(
	      "div",
	      { className: styles$4.controls },
	      controls.map(function (control) {
	        return React__default.createElement(Control, _extends({}, control, {
	          nodeId: nodeId,
	          portName: name,
	          triggerRecalculation: triggerRecalculation,
	          updateNodeConnections: updateNodeConnections,
	          inputLabel: label,
	          data: data[control.name],
	          allData: data,
	          key: control.name,
	          inputData: inputData,
	          isMonoControl: controls.length === 1
	        }));
	      })
	    ) : null
	  );
	};
	
	var Output = function Output(_ref5) {
	  var label = _ref5.label,
	      name = _ref5.name,
	      nodeId = _ref5.nodeId,
	      type = _ref5.type,
	      inputTypes = _ref5.inputTypes,
	      triggerRecalculation = _ref5.triggerRecalculation;
	
	  var _ref6 = inputTypes[type] || {},
	      defaultLabel = _ref6.label,
	      color = _ref6.color;
	
	  return React__default.createElement(
	    "div",
	    {
	      className: styles$4.transput,
	      "data-controlless": true,
	      onDragStart: function onDragStart(e) {
	        e.preventDefault();
	        e.stopPropagation();
	      }
	    },
	    React__default.createElement(
	      "label",
	      { className: styles$4.portLabel },
	      label || defaultLabel
	    ),
	    React__default.createElement(Port, {
	      type: type,
	      name: name,
	      color: color,
	      nodeId: nodeId,
	      triggerRecalculation: triggerRecalculation
	    })
	  );
	};
	
	var Port = function Port(_ref7) {
	  var _ref7$color = _ref7.color,
	      color = _ref7$color === undefined ? "grey" : _ref7$color,
	      _ref7$name = _ref7.name,
	      name = _ref7$name === undefined ? "" : _ref7$name,
	      type = _ref7.type,
	      isInput = _ref7.isInput,
	      nodeId = _ref7.nodeId,
	      triggerRecalculation = _ref7.triggerRecalculation;
	
	  var nodesDispatch = React__default.useContext(NodeDispatchContext);
	  var stageState = React__default.useContext(StageContext);
	  var editorId = React__default.useContext(EditorIdContext);
	  var stageId = "" + STAGE_ID + editorId;
	  var inputTypes = React__default.useContext(PortTypesContext);
	
	  var _React$useState = React__default.useState(false),
	      _React$useState2 = slicedToArray(_React$useState, 2),
	      isDragging = _React$useState2[0],
	      setIsDragging = _React$useState2[1];
	
	  var _React$useState3 = React__default.useState({
	    x: 0,
	    y: 0
	  }),
	      _React$useState4 = slicedToArray(_React$useState3, 2),
	      dragStartCoordinates = _React$useState4[0],
	      setDragStartCoordinates = _React$useState4[1];
	
	  var dragStartCoordinatesCache = React__default.useRef(dragStartCoordinates);
	  var port = React__default.useRef();
	  var line = React__default.useRef();
	  var lineInToPort = React__default.useRef();
	
	  var byScale = function byScale(value) {
	    return 1 / stageState.scale * value;
	  };
	
	  var handleDrag = function handleDrag(e) {
	    var stage = document.getElementById(stageId).getBoundingClientRect();
	
	    if (isInput) {
	      var to = {
	        x: byScale(e.clientX - stage.x - stage.width / 2) + byScale(stageState.translate.x),
	        y: byScale(e.clientY - stage.y - stage.height / 2) + byScale(stageState.translate.y)
	      };
	      lineInToPort.current.setAttribute("d", calculateCurve(dragStartCoordinatesCache.current, to));
	    } else {
	      var _to = {
	        x: byScale(e.clientX - stage.x - stage.width / 2) + byScale(stageState.translate.x),
	        y: byScale(e.clientY - stage.y - stage.height / 2) + byScale(stageState.translate.y)
	      };
	      line.current.setAttribute("d", calculateCurve(dragStartCoordinatesCache.current, _to));
	    }
	  };
	
	  var handleDragEnd = function handleDragEnd(e) {
	    var droppedOnPort = !!e.target.dataset.portName;
	
	    if (isInput) {
	      var _lineInToPort$current = lineInToPort.current.dataset,
	          inputNodeId = _lineInToPort$current.inputNodeId,
	          inputPortName = _lineInToPort$current.inputPortName,
	          outputNodeId = _lineInToPort$current.outputNodeId,
	          outputPortName = _lineInToPort$current.outputPortName;
	
	      nodesDispatch({
	        type: "REMOVE_CONNECTION",
	        input: { nodeId: inputNodeId, portName: inputPortName },
	        output: { nodeId: outputNodeId, portName: outputPortName }
	      });
	      if (droppedOnPort) {
	        var _e$target$dataset = e.target.dataset,
	            connectToPortName = _e$target$dataset.portName,
	            connectToNodeId = _e$target$dataset.nodeId,
	            connectToPortType = _e$target$dataset.portType,
	            connectToTransputType = _e$target$dataset.portTransputType;
	
	        var isNotSameNode = outputNodeId !== connectToNodeId;
	        if (isNotSameNode && connectToTransputType !== "output") {
	          var inputWillAcceptConnection = inputTypes[connectToPortType].acceptTypes.includes(type);
	          if (inputWillAcceptConnection) {
	            nodesDispatch({
	              type: "ADD_CONNECTION",
	              input: { nodeId: connectToNodeId, portName: connectToPortName },
	              output: { nodeId: outputNodeId, portName: outputPortName }
	            });
	          }
	        }
	      }
	    } else {
	      if (droppedOnPort) {
	        var _e$target$dataset2 = e.target.dataset,
	            _inputPortName = _e$target$dataset2.portName,
	            _inputNodeId = _e$target$dataset2.nodeId,
	            inputNodeType = _e$target$dataset2.portType,
	            inputTransputType = _e$target$dataset2.portTransputType;
	
	        var _isNotSameNode = _inputNodeId !== nodeId;
	        if (_isNotSameNode && inputTransputType !== "output") {
	          var _inputWillAcceptConnection = inputTypes[inputNodeType].acceptTypes.includes(type);
	          if (_inputWillAcceptConnection) {
	            nodesDispatch({
	              type: "ADD_CONNECTION",
	              output: { nodeId: nodeId, portName: name },
	              input: { nodeId: _inputNodeId, portName: _inputPortName }
	            });
	            triggerRecalculation();
	          }
	        }
	      }
	    }
	    setIsDragging(false);
	    document.removeEventListener("mouseup", handleDragEnd);
	    document.removeEventListener("mousemove", handleDrag);
	  };
	
	  var handleDragStart = function handleDragStart(e) {
	    e.preventDefault();
	    e.stopPropagation();
	    var startPort = port.current.getBoundingClientRect();
	    var stage = document.getElementById(stageId).getBoundingClientRect();
	
	    if (isInput) {
	      lineInToPort.current = document.querySelector("[data-input-node-id=\"" + nodeId + "\"][data-input-port-name=\"" + name + "\"]");
	      var portIsConnected = !!lineInToPort.current;
	      if (portIsConnected) {
	        lineInToPort.current.parentNode.style.zIndex = 9999;
	        var outputPort = getPortRect(lineInToPort.current.dataset.outputNodeId, lineInToPort.current.dataset.outputPortName, "output");
	        var coordinates = {
	          x: byScale(outputPort.x - stage.x + outputPort.width / 2 - stage.width / 2) + byScale(stageState.translate.x),
	          y: byScale(outputPort.y - stage.y + outputPort.width / 2 - stage.height / 2) + byScale(stageState.translate.y)
	        };
	        setDragStartCoordinates(coordinates);
	        dragStartCoordinatesCache.current = coordinates;
	        setIsDragging(true);
	        document.addEventListener("mouseup", handleDragEnd);
	        document.addEventListener("mousemove", handleDrag);
	      }
	    } else {
	      var _coordinates = {
	        x: byScale(startPort.x - stage.x + startPort.width / 2 - stage.width / 2) + byScale(stageState.translate.x),
	        y: byScale(startPort.y - stage.y + startPort.width / 2 - stage.height / 2) + byScale(stageState.translate.y)
	      };
	      setDragStartCoordinates(_coordinates);
	      dragStartCoordinatesCache.current = _coordinates;
	      setIsDragging(true);
	      document.addEventListener("mouseup", handleDragEnd);
	      document.addEventListener("mousemove", handleDrag);
	    }
	  };
	
	  return React__default.createElement(
	    React__default.Fragment,
	    null,
	    React__default.createElement("div", {
	      style: { zIndex: 999 },
	      onMouseDown: handleDragStart,
	      className: styles$4.port,
	      "data-port-color": color,
	      "data-port-name": name,
	      "data-port-type": type,
	      "data-port-transput-type": isInput ? "input" : "output",
	      "data-node-id": nodeId,
	      onDragStart: function onDragStart(e) {
	        e.preventDefault();
	        e.stopPropagation();
	      },
	      ref: port
	    }),
	    isDragging && !isInput ? React__default.createElement(
	      Portal$3,
	      {
	        node: document.getElementById("" + DRAG_CONNECTION_ID + editorId)
	      },
	      React__default.createElement(Connection, {
	        from: dragStartCoordinates,
	        to: dragStartCoordinates,
	        lineRef: line
	      })
	    ) : null
	  );
	};
	
	var Node = function Node(_ref) {
	  var id = _ref.id,
	      width = _ref.width,
	      height = _ref.height,
	      x = _ref.x,
	      y = _ref.y,
	      _ref$delay = _ref.delay,
	      stageRect = _ref.stageRect,
	      connections = _ref.connections,
	      type = _ref.type,
	      inputData = _ref.inputData,
	      onDragStart = _ref.onDragStart,
	      onDragEnd = _ref.onDragEnd,
	      onDrag = _ref.onDrag;
	
	  var cache = React__default.useContext(CacheContext);
	  var nodeTypes = React__default.useContext(NodeTypesContext);
	  var nodesDispatch = React__default.useContext(NodeDispatchContext);
	  var stageState = React__default.useContext(StageContext);
	  var _nodeTypes$type = nodeTypes[type],
	      label = _nodeTypes$type.label,
	      deletable = _nodeTypes$type.deletable,
	      _nodeTypes$type$input = _nodeTypes$type.inputs,
	      inputs = _nodeTypes$type$input === undefined ? [] : _nodeTypes$type$input,
	      _nodeTypes$type$outpu = _nodeTypes$type.outputs,
	      outputs = _nodeTypes$type$outpu === undefined ? [] : _nodeTypes$type$outpu;
	
	
	  var nodeWrapper = React__default.useRef();
	
	  var _React$useState = React__default.useState(false),
	      _React$useState2 = slicedToArray(_React$useState, 2),
	      menuOpen = _React$useState2[0],
	      setMenuOpen = _React$useState2[1];
	
	  var _React$useState3 = React__default.useState({ x: 0, y: 0 }),
	      _React$useState4 = slicedToArray(_React$useState3, 2),
	      menuCoordinates = _React$useState4[0],
	      setMenuCoordinates = _React$useState4[1];
	
	  var byScale = function byScale(value) {
	    return 1 / stageState.scale * value;
	  };
	
	  var updateConnectionsByTransput = function updateConnectionsByTransput() {
	    var transput = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	    var isOutput = arguments[1];
	
	    Object.entries(transput).forEach(function (_ref2) {
	      var _ref3 = slicedToArray(_ref2, 2),
	          portName = _ref3[0],
	          outputs = _ref3[1];
	
	      outputs.forEach(function (output) {
	        var toRect = getPortRect(id, portName, isOutput ? "output" : "input", cache);
	        var fromRect = getPortRect(output.nodeId, output.portName, isOutput ? "input" : "output", cache);
	        var portHalf = fromRect.width / 2;
	        var combined = void 0;
	        if (isOutput) {
	          combined = id + portName + output.nodeId + output.portName;
	        } else {
	          combined = output.nodeId + output.portName + id + portName;
	        }
	        var cnx = void 0;
	        var cachedConnection = cache.current.connections[combined];
	        if (cachedConnection) {
	          cnx = cachedConnection;
	        } else {
	          cnx = document.querySelector("[data-connection-id=\"" + combined + "\"]");
	          cache.current.connections[combined] = cnx;
	        }
	        var from = {
	          x: byScale(toRect.x - stageRect.current.x + portHalf - stageRect.current.width / 2) + byScale(stageState.translate.x),
	          y: byScale(toRect.y - stageRect.current.y + portHalf - stageRect.current.height / 2) + byScale(stageState.translate.y)
	        };
	        var to = {
	          x: byScale(fromRect.x - stageRect.current.x + portHalf - stageRect.current.width / 2) + byScale(stageState.translate.x),
	          y: byScale(fromRect.y - stageRect.current.y + portHalf - stageRect.current.height / 2) + byScale(stageState.translate.y)
	        };
	        cnx.setAttribute("d", calculateCurve(from, to));
	      });
	    });
	  };
	
	  var updateNodeConnections = function updateNodeConnections() {
	    if (connections) {
	      updateConnectionsByTransput(connections.inputs);
	      updateConnectionsByTransput(connections.outputs, true);
	    }
	  };
	
	  var stopDrag = function stopDrag(e, coordinates) {
	    nodesDispatch(_extends({
	      type: "SET_NODE_COORDINATES"
	    }, coordinates, {
	      nodeId: id
	    }));
	  };
	
	  var handleDrag = function handleDrag(_ref4) {
	    var x = _ref4.x,
	        y = _ref4.y;
	
	    nodeWrapper.current.style.transform = "translate(" + x + "px," + y + "px)";
	    updateNodeConnections();
	  };
	
	  var startDrag = function startDrag(e) {
	    onDragStart();
	  };
	
	  var handleContextMenu = function handleContextMenu(e) {
	    e.preventDefault();
	    e.stopPropagation();
	    setMenuCoordinates({ x: e.clientX, y: e.clientY });
	    setMenuOpen(true);
	    return false;
	  };
	
	  var closeContextMenu = function closeContextMenu() {
	    setMenuOpen(false);
	  };
	
	  var handleMenuOption = function handleMenuOption(_ref5) {
	    var value = _ref5.value;
	
	    switch (value) {
	      case "deleteNode":
	        nodesDispatch({
	          type: "REMOVE_NODE",
	          nodeId: id
	        });
	        break;
	      default:
	        return;
	    }
	  };
	
	  return React__default.createElement(
	    Draggable,
	    {
	      className: styles$2.wrapper,
	      style: {
	        width: width,
	        transform: "translate(" + x + "px, " + y + "px)"
	      },
	      onDragStart: startDrag,
	      onDrag: handleDrag,
	      onDragEnd: stopDrag,
	      innerRef: nodeWrapper,
	      "data-node-id": id,
	      onContextMenu: handleContextMenu,
	      stageState: stageState,
	      stageRect: stageRect
	    },
	    React__default.createElement(
	      "h2",
	      { className: styles$2.label },
	      label
	    ),
	    React__default.createElement(IoPorts, {
	      nodeId: id,
	      inputs: inputs,
	      outputs: outputs,
	      connections: connections,
	      updateNodeConnections: updateNodeConnections,
	      inputData: inputData
	    }),
	    menuOpen ? React__default.createElement(
	      Portal$3,
	      null,
	      React__default.createElement(ContextMenu, {
	        x: menuCoordinates.x,
	        y: menuCoordinates.y,
	        options: [].concat(toConsumableArray(deletable !== false ? [{
	          label: "Delete Node",
	          value: "deleteNode",
	          description: "Deletes a node and all of its connections."
	        }] : [])),
	        onRequestClose: closeContextMenu,
	        onOptionSelected: handleMenuOption,
	        hideFilter: true,
	        label: "Node Options",
	        emptyText: "This node has no options."
	      })
	    ) : null
	  );
	};
	
	var css$9 = ".Comment_wrapper__1Pnbd {\n  position: absolute;\n  left: 0px;\n  top: 0px;\n  padding: 5px;\n  background: rgba(147, 154, 158, 0.7);\n  border-radius: 5px;\n  border-bottom-right-radius: 2px;\n  box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.2);\n  min-width: 80px;\n  font-size: 14px;\n  display: flex;\n  text-shadow: 0px 1px rgba(255,255,255,.1);\n  border: 1px solid rgba(168, 176, 181, 0.7);\n  user-select: none;\n}\n  .Comment_wrapper__1Pnbd[data-color=\"red\"]{\n    background: rgba(213, 84, 103, 0.65);\n    border-color: rgba(227, 85, 119, 0.65);\n  }\n  .Comment_wrapper__1Pnbd[data-color=\"purple\"]{\n    background: rgba(153, 83, 196, 0.65);\n    border-color: rgba(156, 85, 227, 0.65);\n  }\n  .Comment_wrapper__1Pnbd[data-color=\"blue\"]{\n    background: rgba(76, 142, 203, 0.65);\n    border-color: rgba(85, 159, 227, 0.65);\n  }\n  .Comment_wrapper__1Pnbd[data-color=\"green\"]{\n    background: rgba(70, 200, 130, 0.65);\n    border-color: rgba(85, 227, 150, 0.65);\n  }\n  .Comment_wrapper__1Pnbd[data-color=\"yellow\"]{\n    background: rgba(200, 167, 63, 0.65);\n    border-color: rgba(227, 213, 85, 0.65);\n  }\n  .Comment_wrapper__1Pnbd[data-color=\"orange\"]{\n    background: rgba(215, 123, 64, 0.65);\n    border-color: rgba(227, 149, 85, 0.65);\n  }\n  .Comment_wrapper__1Pnbd[data-color=\"pink\"]{\n    background: rgba(255, 102, 208, 0.65);\n    border-color: rgba(242, 131, 228, 0.65);\n  }\n.Comment_text__Ie2nX{\n  width: 100%;\n  height: 100%;\n  overflow: auto;\n  white-space: pre-wrap;\n  cursor: default;\n}\n.Comment_resizeThumb__20KWn {\n  width: 10px;\n  height: 10px;\n  border-radius: 4px 0px 4px 0px;\n  position: absolute;\n  right: 0px;\n  bottom: 0px;\n  overflow: hidden;\n  cursor: nwse-resize;\n}\n.Comment_resizeThumb__20KWn::before,\n  .Comment_resizeThumb__20KWn::after {\n    content: \"\";\n    position: absolute;\n    right: 0px;\n    top: 0px;\n    width: 250%;\n    height: 0px;\n    border-top: 1px solid rgba(0, 0, 0, 0.7);\n    border-bottom: 2px solid rgba(255, 255, 255, 0.7);\n    transform-origin: center right;\n    transform: rotate(-45deg) scale(0.5);\n  }\n.Comment_resizeThumb__20KWn::after {\n    transform: rotate(-45deg) translateY(3px) scale(0.5);\n  }\n.Comment_textarea__2Rze3 {\n  resize: none;\n  width: calc(100% + 2px);\n  height: calc(100% + 2px);\n  border-radius: 3px;\n  background: rgba(255,255,255,.1);\n  border: none;\n  outline: none;\n  margin: -2px;\n  margin-top: -1px;\n  padding-top: 0px;\n  font-size: 14px;\n}\n.Comment_textarea__2Rze3::placeholder{\n    color: rgba(0,0,0,.5);\n  }\n";
	var styles$9 = { "wrapper": "Comment_wrapper__1Pnbd", "text": "Comment_text__Ie2nX", "resizeThumb": "Comment_resizeThumb__20KWn", "textarea": "Comment_textarea__2Rze3" };
	styleInject(css$9);
	
	var css$a = ".ColorPicker_wrapper__1M1j2{\n  position: fixed;\n  z-index: 9999;\n  background: rgba(29, 32, 34, 0.95);\n  border-radius: 5px;\n  box-shadow: 0px 6px 7px rgba(0,0,0,.3);\n  border: 1px solid rgba(0,0,0,.4);\n  color: #fff;\n  display: flex;\n  width: 102px;\n  flex-wrap: wrap;\n  padding: 2px;\n}\n@supports (backdrop-filter: blur(6px)){\n  .ColorPicker_wrapper__1M1j2{\n    backdrop-filter: blur(6px);\n    background: rgba(29, 32, 34, 0.8);\n  }\n}\n.ColorPicker_colorButtonWrapper__1ijdj{\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  padding: 2px;\n}\n.ColorPicker_colorButton__1Qcuq{\n  border-radius: 3px;\n  border: none;\n  width: 20px;\n  height: 20px;\n  background: rgba(204, 204, 204, 1);\n}\n.ColorPicker_colorButton__1Qcuq[data-color=\"red\"]{\n    background: rgba(210, 101, 111, 1)\n  }\n.ColorPicker_colorButton__1Qcuq[data-color=\"purple\"]{\n    background: rgba(159, 101, 210, 1)\n  }\n.ColorPicker_colorButton__1Qcuq[data-color=\"blue\"]{\n    background: rgba(101, 151, 210, 1)\n  }\n.ColorPicker_colorButton__1Qcuq[data-color=\"green\"]{\n    background: rgba(101, 210, 168, 1)\n  }\n.ColorPicker_colorButton__1Qcuq[data-color=\"orange\"]{\n    background: rgba(210, 137, 101, 1)\n  }\n.ColorPicker_colorButton__1Qcuq[data-color=\"yellow\"]{\n    background: rgba(210, 196, 101, 1)\n  }\n.ColorPicker_colorButton__1Qcuq[data-color=\"pink\"]{\n    background: rgba(241, 124, 226, 1)\n  }\n.ColorPicker_colorButton__1Qcuq:hover{\n    opacity: .8;\n  }\n";
	var styles$a = { "wrapper": "ColorPicker_wrapper__1M1j2", "colorButtonWrapper": "ColorPicker_colorButtonWrapper__1ijdj", "colorButton": "ColorPicker_colorButton__1Qcuq" };
	styleInject(css$a);
	
	var define = function define(value, defaultValue) {
	  return value !== undefined ? value : defaultValue;
	};
	
	var buildControlType = function buildControlType(defaultConfig) {
	  var validate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function () {};
	  var setup = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : function () {
	    return {};
	  };
	  return function (config) {
	    validate(config);
	    return _extends({
	      type: defaultConfig.type,
	      label: define(config.label, defaultConfig.label || ""),
	      name: define(config.name, defaultConfig.name || ""),
	      defaultValue: define(config.defaultValue, defaultConfig.defaultValue),
	      setValue: define(config.setValue, undefined)
	    }, setup(config));
	  };
	};
	
	var Controls = {
	  text: buildControlType({
	    type: "text",
	    name: "text",
	    defaultValue: ""
	  }),
	  select: buildControlType({
	    type: "select",
	    name: "select",
	    options: [],
	    defaultValue: ""
	  }, function () {}, function (config) {
	    return {
	      options: define(config.options, []),
	      getOptions: define(config.getOptions, undefined),
	      placeholder: define(config.placeholder, undefined)
	    };
	  }),
	  number: buildControlType({
	    type: "number",
	    name: "number",
	    defaultValue: 0
	  }, function () {}, function (config) {
	    return {
	      step: define(config.step, undefined)
	    };
	  }),
	  checkbox: buildControlType({
	    type: "checkbox",
	    name: "checkbox",
	    defaultValue: false
	  }),
	  multiselect: buildControlType({
	    type: "multiselect",
	    name: "multiselect",
	    options: [],
	    defaultValue: []
	  }, function () {}, function (config) {
	    return {
	      options: define(config.options, []),
	      getOptions: define(config.getOptions, undefined),
	      placeholder: define(config.placeholder, undefined)
	    };
	  }),
	  custom: buildControlType({
	    type: "custom",
	    name: "custom",
	    render: function render() {},
	    defaultValue: undefined
	  }, function () {}, function (config) {
	    return {
	      render: define(config.render, function () {})
	    };
	  })
	};
	
	var Colors = {
	  yellow: "yellow",
	  orange: "orange",
	  red: "red",
	  pink: "pink",
	  purple: "purple",
	  blue: "blue",
	  green: "green",
	  grey: "grey"
	};
	
	var getPortBuilders = function getPortBuilders(ports) {
	  return Object.values(ports).reduce(function (obj, port) {
	    obj[port.type] = function () {
	      var config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	      return {
	        type: port.type,
	        name: config.name || port.name,
	        label: config.label || port.label,
	        noControls: define(config.noControls, false),
	        color: config.color || port.color,
	        hidePort: define(config.hidePort, port.hidePort),
	        controls: define(config.controls, port.controls)
	      };
	    };
	    return obj;
	  }, {});
	};
	
	var FlumeConfig = function () {
	  function FlumeConfig(config) {
	    classCallCheck(this, FlumeConfig);
	
	    if (config) {
	      this.nodeTypes = _extends({}, config.nodeTypes);
	      this.portTypes = _extends({}, config.portTypes);
	    } else {
	      this.nodeTypes = {};
	      this.portTypes = {};
	    }
	  }
	
	  createClass(FlumeConfig, [{
	    key: "addRootNodeType",
	    value: function addRootNodeType(config) {
	      this.addNodeType(_extends({}, config, {
	        root: true,
	        addable: false,
	        deletable: false
	      }));
	      return this;
	    }
	  }, {
	    key: "addNodeType",
	    value: function addNodeType(config) {
	      if ((typeof config === "undefined" ? "undefined" : _typeof(config)) !== "object" && config !== null) {
	        throw new Error("You must provide a configuration object when calling addNodeType.");
	      }
	      if (typeof config.type !== "string") {
	        throw new Error("Required key, \"type\" must be a string when calling addNodeType.");
	      }
	      if (typeof config.initialWidth !== "undefined" && typeof config.initialWidth !== "number") {
	        throw new Error("Optional key, \"initialWidth\" must be a number when calling addNodeType.");
	      }
	      if (this.nodeTypes[config.type] !== undefined) {
	        throw new Error("A node with type \"" + config.type + "\" has already been declared.");
	      }
	      var node = {
	        type: config.type,
	        label: define(config.label, ""),
	        description: define(config.description, ""),
	        addable: define(config.addable, true),
	        deletable: define(config.deletable, true)
	      };
	      if (config.initialWidth) {
	        node.initialWidth = config.initialWidth;
	      }
	      if (config.sortIndex !== undefined) {
	        node.sortIndex = config.sortIndex;
	      }
	      if (typeof config.inputs === "function") {
	        var inputs = config.inputs(getPortBuilders(this.portTypes));
	        if (!Array.isArray(inputs) && typeof config.inputs !== 'function') {
	          throw new Error("When providing a function to the \"inputs\" key, you must return either an array or a function.");
	        }
	        node.inputs = inputs;
	      } else if (config.inputs === undefined) {
	        node.inputs = [];
	      } else if (!Array.isArray(config.inputs)) {
	        throw new Error("Optional key, \"inputs\" must be an array.");
	      } else {
	        node.inputs = config.inputs;
	      }
	
	      if (typeof config.outputs === "function") {
	        var outputs = config.outputs(getPortBuilders(this.portTypes));
	        if (!Array.isArray(outputs) && typeof config.outputs !== 'function') {
	          throw new Error("When providing a function to the \"outputs\" key, you must return either an array or a function.");
	        }
	        node.outputs = outputs;
	      } else if (config.outputs === undefined) {
	        node.outputs = [];
	      } else if (config.outputs !== undefined && !Array.isArray(config.outputs)) {
	        throw new Error("Optional key, \"outputs\" must be an array.");
	      } else {
	        node.outputs = config.outputs;
	      }
	
	      if (config.root !== undefined) {
	        if (typeof config.root !== "boolean") {
	          throw new Error("Optional key, \"root\" must be a boolean.");
	        } else {
	          node.root = config.root;
	        }
	      }
	
	      this.nodeTypes[config.type] = node;
	      return this;
	    }
	  }, {
	    key: "removeNodeType",
	    value: function removeNodeType(type) {
	      if (!this.nodeTypes[type]) {
	        console.error("Non-existent node type \"" + type + "\" cannot be removed.");
	      } else {
	        var _nodeTypes = this.nodeTypes,
	            deleted = _nodeTypes[type],
	            nodeTypes = objectWithoutProperties(_nodeTypes, [type]);
	
	        this.nodeTypes = nodeTypes;
	      }
	      return this;
	    }
	  }, {
	    key: "addPortType",
	    value: function addPortType(config) {
	      if ((typeof config === "undefined" ? "undefined" : _typeof(config)) !== "object" && config !== null) {
	        throw new Error("You must provide a configuration object when calling addPortType");
	      }
	      if (typeof config.type !== "string") {
	        throw new Error("Required key, \"type\" must be a string when calling addPortType.");
	      }
	      if (this.portTypes[config.type] !== undefined) {
	        throw new Error("A port with type \"" + config.type + "\" has already been declared.");
	      }
	      if (typeof config.name !== "string") {
	        throw new Error("Required key, \"name\" must be a string when calling addPortType.");
	      }
	
	      var port = {
	        type: config.type,
	        name: config.name,
	        label: define(config.label, ""),
	        color: define(config.color, Colors.grey),
	        hidePort: define(config.hidePort, false)
	      };
	
	      if (config.acceptTypes === undefined) {
	        port.acceptTypes = [config.type];
	      } else if (!Array.isArray(config.acceptTypes)) {
	        throw new Error("Optional key, \"acceptTypes\" must be an array.");
	      } else {
	        port.acceptTypes = config.acceptTypes;
	      }
	
	      if (config.controls === undefined) {
	        port.controls = [];
	      } else if (!Array.isArray(config.controls)) {
	        throw new Error("Optional key, \"controls\" must be an array.");
	      } else {
	        port.controls = config.controls;
	      }
	
	      this.portTypes[config.type] = port;
	      return this;
	    }
	  }, {
	    key: "removePortType",
	    value: function removePortType(type) {
	      var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
	          _ref$skipDynamicNodes = _ref.skipDynamicNodesCheck,
	          skipDynamicNodesCheck = _ref$skipDynamicNodes === undefined ? false : _ref$skipDynamicNodes;
	
	      if (!this.portTypes[type]) {
	        console.error("Non-existent port type \"" + type + "\" cannot be removed.");
	      } else {
	        if (!skipDynamicNodesCheck) {
	          var dynamicNodes = Object.values(this.nodeTypes).filter(function (node) {
	            return typeof node.inputs === 'function' || typeof node.outputs === 'function';
	          });
	          if (dynamicNodes.length) {
	            console.warn("We've detected that one or more of your nodes is using dynamic inputs/outputs. This is a potentially dangerous operation as we are unable to detect if this portType is being used in one of those nodes. You can quiet this message by passing { skipDynamicNodesCheck: true } in as the second argument.");
	          }
	        }
	        var affectedNodes = Object.values(this.nodeTypes).filter(function (node) {
	          return Array.isArray(node.inputs) && node.inputs.find(function (p) {
	            return p.type === type;
	          }) || Array.isArray(node.outputs) && node.outputs.find(function (p) {
	            return p.type === type;
	          });
	        });
	        if (affectedNodes.length) {
	          throw new Error("Cannot delete port type \"" + type + "\" without first deleting all node types using these ports: [" + affectedNodes.map(function (n) {
	            return "" + n.type;
	          }).join(", ") + "]");
	        } else {
	          var _portTypes = this.portTypes,
	              deleted = _portTypes[type],
	              portTypes = objectWithoutProperties(_portTypes, [type]);
	
	          this.portTypes = portTypes;
	        }
	      }
	      return this;
	    }
	  }]);
	  return FlumeConfig;
	}();
	
	var ColorPicker = (function (_ref) {
	  var x = _ref.x,
	      y = _ref.y,
	      onColorPicked = _ref.onColorPicked,
	      onRequestClose = _ref.onRequestClose;
	
	  var wrapper = React__default.useRef();
	
	  var testClickOutside = React__default.useCallback(function (e) {
	    if (!wrapper.current.contains(e.target)) {
	      onRequestClose();
	      document.removeEventListener("click", testClickOutside);
	      document.removeEventListener("contextmenu", testClickOutside);
	    }
	  }, [wrapper, onRequestClose]);
	
	  var testEscape = React__default.useCallback(function (e) {
	    if (e.keyCode === 27) {
	      onRequestClose();
	      document.removeEventListener("keydown", testEscape);
	    }
	  }, [onRequestClose]);
	
	  React__default.useEffect(function () {
	    document.addEventListener("keydown", testEscape);
	    document.addEventListener("click", testClickOutside);
	    document.addEventListener("contextmenu", testClickOutside);
	    return function () {
	      document.removeEventListener("click", testClickOutside);
	      document.removeEventListener("contextmenu", testClickOutside);
	      document.removeEventListener("keydown", testEscape);
	    };
	  }, [testClickOutside, testEscape]);
	
	  return React__default.createElement(
	    "div",
	    {
	      ref: wrapper,
	      className: styles$a.wrapper,
	      style: {
	        left: x,
	        top: y
	      }
	    },
	    Object.values(Colors).map(function (color) {
	      return React__default.createElement(ColorButton, {
	        onSelected: function onSelected() {
	          onColorPicked(color);
	          onRequestClose();
	        },
	        color: color,
	        key: color
	      });
	    })
	  );
	});
	
	var ColorButton = function ColorButton(_ref2) {
	  var color = _ref2.color,
	      onSelected = _ref2.onSelected;
	  return React__default.createElement(
	    "div",
	    { className: styles$a.colorButtonWrapper },
	    React__default.createElement("button", {
	      className: styles$a.colorButton,
	      onClick: onSelected,
	      "data-color": color,
	      "aria-label": color
	    })
	  );
	};
	
	var Comment = (function (_ref) {
	  var dispatch = _ref.dispatch,
	      id = _ref.id,
	      x = _ref.x,
	      y = _ref.y,
	      width = _ref.width,
	      height = _ref.height,
	      color = _ref.color,
	      text = _ref.text,
	      stageRect = _ref.stageRect,
	      onDragStart = _ref.onDragStart,
	      isNew = _ref.isNew;
	
	  var stageState = React__default.useContext(StageContext);
	  var wrapper = React__default.useRef();
	  var textarea = React__default.useRef();
	
	  var _React$useState = React__default.useState(false),
	      _React$useState2 = slicedToArray(_React$useState, 2),
	      isEditing = _React$useState2[0],
	      setIsEditing = _React$useState2[1];
	
	  var _React$useState3 = React__default.useState(false),
	      _React$useState4 = slicedToArray(_React$useState3, 2),
	      isPickingColor = _React$useState4[0],
	      setIsPickingColor = _React$useState4[1];
	
	  var _React$useState5 = React__default.useState(false),
	      _React$useState6 = slicedToArray(_React$useState5, 2),
	      menuOpen = _React$useState6[0],
	      setMenuOpen = _React$useState6[1];
	
	  var _React$useState7 = React__default.useState({ x: 0, y: 0 }),
	      _React$useState8 = slicedToArray(_React$useState7, 2),
	      menuCoordinates = _React$useState8[0],
	      setMenuCoordinates = _React$useState8[1];
	
	  var _React$useState9 = React__default.useState({
	    x: 0,
	    y: 0
	  }),
	      _React$useState10 = slicedToArray(_React$useState9, 2),
	      colorPickerCoordinates = _React$useState10[0],
	      setColorPickerCoordinates = _React$useState10[1];
	
	  var handleContextMenu = function handleContextMenu(e) {
	    e.preventDefault();
	    e.stopPropagation();
	    setMenuCoordinates({ x: e.clientX, y: e.clientY });
	    setMenuOpen(true);
	    return false;
	  };
	
	  var closeContextMenu = function closeContextMenu() {
	    return setMenuOpen(false);
	  };
	
	  var startDrag = function startDrag(e) {
	    onDragStart();
	  };
	
	  var handleDrag = function handleDrag(_ref2) {
	    var x = _ref2.x,
	        y = _ref2.y;
	
	    wrapper.current.style.transform = "translate(" + x + "px," + y + "px)";
	  };
	
	  var handleDragEnd = function handleDragEnd(_, _ref3) {
	    var x = _ref3.x,
	        y = _ref3.y;
	
	    dispatch({
	      type: "SET_COMMENT_COORDINATES",
	      id: id,
	      x: x,
	      y: y
	    });
	  };
	
	  var handleResize = function handleResize(coordinates) {
	    var width = clamp_1(coordinates.x - x + 10, 80, 10000);
	    var height = clamp_1(coordinates.y - y + 10, 30, 10000);
	    wrapper.current.style.width = width + "px";
	    wrapper.current.style.height = height + "px";
	  };
	
	  var handleResizeEnd = function handleResizeEnd(_, coordinates) {
	    var width = clamp_1(coordinates.x - x + 10, 80, 10000);
	    var height = clamp_1(coordinates.y - y + 10, 30, 10000);
	    dispatch({
	      type: "SET_COMMENT_DIMENSIONS",
	      id: id,
	      width: width,
	      height: height
	    });
	  };
	
	  var handleMenuOption = function handleMenuOption(option, e) {
	    switch (option.value) {
	      case "edit":
	        startTextEdit();
	        break;
	      case "color":
	        setColorPickerCoordinates(menuCoordinates);
	        setIsPickingColor(true);
	        break;
	      case "delete":
	        dispatch({
	          type: "DELETE_COMMENT",
	          id: id
	        });
	        break;
	      default:
	    }
	  };
	
	  var startTextEdit = function startTextEdit() {
	    setIsEditing(true);
	  };
	
	  var endTextEdit = function endTextEdit() {
	    setIsEditing(false);
	  };
	
	  var handleTextChange = function handleTextChange(e) {
	    dispatch({
	      type: "SET_COMMENT_TEXT",
	      id: id,
	      text: e.target.value
	    });
	  };
	
	  var handleColorPicked = function handleColorPicked(color) {
	    dispatch({
	      type: "SET_COMMENT_COLOR",
	      id: id,
	      color: color
	    });
	  };
	
	  React__default.useEffect(function () {
	    if (isNew) {
	      setIsEditing(true);
	      dispatch({
	        type: "REMOVE_COMMENT_NEW",
	        id: id
	      });
	    }
	  }, [isNew, dispatch, id]);
	
	  return React__default.createElement(
	    Draggable,
	    {
	      innerRef: wrapper,
	      className: styles$9.wrapper,
	      style: {
	        transform: "translate(" + x + "px," + y + "px)",
	        width: width,
	        height: height,
	        zIndex: isEditing ? 999 : ""
	      },
	      stageState: stageState,
	      stageRect: stageRect,
	      onDragStart: startDrag,
	      onDrag: handleDrag,
	      onDragEnd: handleDragEnd,
	      onContextMenu: handleContextMenu,
	      onDoubleClick: startTextEdit,
	      onWheel: function onWheel(e) {
	        return e.stopPropagation();
	      },
	      "data-color": color
	    },
	    isEditing ? React__default.createElement("textarea", {
	      className: styles$9.textarea,
	      onChange: handleTextChange,
	      onMouseDown: function onMouseDown(e) {
	        return e.stopPropagation();
	      },
	      onBlur: endTextEdit,
	      placeholder: "Text of the comment...",
	      autoFocus: true,
	      value: text,
	      ref: textarea
	    }) : React__default.createElement(
	      "div",
	      { "data-comment": true, className: styles$9.text },
	      text
	    ),
	    React__default.createElement(Draggable, {
	      className: styles$9.resizeThumb,
	      stageState: stageState,
	      stageRect: stageRect,
	      onDrag: handleResize,
	      onDragEnd: handleResizeEnd
	    }),
	    menuOpen ? React__default.createElement(
	      Portal$3,
	      null,
	      React__default.createElement(ContextMenu, {
	        hideFilter: true,
	        label: "Comment Options",
	        x: menuCoordinates.x,
	        y: menuCoordinates.y,
	        options: [{
	          value: "edit",
	          label: "Edit Comment",
	          description: "Edit the text of the comment"
	        }, {
	          value: "color",
	          label: "Change Color",
	          description: "Change the color of the comment"
	        }, {
	          value: "delete",
	          label: "Delete Comment",
	          description: "Delete the comment"
	        }],
	        onRequestClose: closeContextMenu,
	        onOptionSelected: handleMenuOption
	      })
	    ) : null,
	    isPickingColor ? React__default.createElement(
	      Portal$3,
	      null,
	      React__default.createElement(ColorPicker, {
	        x: colorPickerCoordinates.x,
	        y: colorPickerCoordinates.y,
	        onRequestClose: function onRequestClose() {
	          return setIsPickingColor(false);
	        },
	        onColorPicked: handleColorPicked
	      })
	    ) : null
	  );
	});
	
	var css$b = ".Toaster_toaster__1eC3T{\n  position: absolute;\n  left: 0px;\n  bottom: 0px;\n  width: 100%;\n  height: 1px;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  padding-bottom: 15px;\n  box-shadow: 0px 5px 10px -2px rgba(0,0,0,.3);\n  pointer-events: none;\n}\n.Toaster_toast__3YHVS{\n  position: absolute;\n  left: calc(50% - 200px);\n  top: 0px;\n  pointer-events: all;\n  width: 400px;\n  padding: 10px;\n  padding-top: 7px;\n  padding-right: 16px;\n  border-radius: 6px;\n  background: rgba(231, 231, 231, 1);\n  border: 1px solid;\n  margin-bottom: 5px;\n  transition: transform 300ms;\n  flex: 0 0 auto;\n  animation: Toaster_fade-in__2526Y 150ms;\n  user-select: none;\n  font-size: 14px;\n  display: flex;\n  flex-direction: column;\n  will-change: transform;\n}\n.Toaster_toast__3YHVS[data-type=\"danger\"]{\n    background: rgb(255, 116, 137);\n    border-color: rgb(254, 99, 136);\n    color: rgb(66, 6, 20);\n  }\n.Toaster_toast__3YHVS[data-type=\"info\"]{\n    background: rgb(76, 193, 250);\n    border-color: rgb(103, 182, 255);\n    color: rgb(5, 36, 64);\n  }\n.Toaster_toast__3YHVS[data-type=\"success\"]{\n    background: rgb(81, 230, 150);\n    border-color: rgb(85, 227, 150);\n    color: rgb(7, 57, 30);\n  }\n.Toaster_toast__3YHVS[data-type=\"warning\"]{\n    background: rgb(245, 208, 93);\n    border-color: rgb(247, 235, 125);\n    color: rgb(83, 75, 8);\n  }\n.Toaster_toast__3YHVS[data-exiting=true]{\n    animation: Toaster_fade-out__2lM6E 150ms;\n    animation-fill-mode: forwards;\n  }\n.Toaster_toast__3YHVS p{\n  margin: 0px;\n}\n.Toaster_title__4InNr{\n  font-size: 16px;\n  font-weight: bold;\n  margin-bottom: 5px;\n}\n.Toaster_timer__3dGzF{\n  position: absolute;\n  bottom: -1px;\n  left: -1px;\n  width: calc(100% + 2px);\n  height: 3px;\n  background: rgba(0,0,0,.4);\n  transform-origin: left center;\n  animation: Toaster_timer__3dGzF 1000ms linear;\n  animation-fill-mode: forwards;\n  z-index: 9;\n}\n.Toaster_exitButton__1S_Ks{\n  position: absolute;\n  right: 0px;\n  top: 0px;\n  width: 20px;\n  height: 20px;\n  padding: 0px;\n  background: none;\n  border: none;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  font-size: 14px;\n  color: inherit;\n  opacity: .6;\n}\n.Toaster_exitButton__1S_Ks:hover{\n  opacity: .9;\n}\n\n@keyframes Toaster_fade-in__2526Y {\n  from{\n    opacity: 0;\n  }\n  to{\n    opacity: 1;\n  }\n}\n\n@keyframes Toaster_fade-out__2lM6E {\n  from{\n    opacity: 1;\n  }\n  to{\n    opacity: 0;\n  }\n}\n\n@keyframes Toaster_timer__3dGzF {\n  from{\n    transform: scaleX(1);\n  }\n  to{\n    transform: scaleX(0);\n  }\n}\n";
	var styles$b = { "toaster": "Toaster_toaster__1eC3T", "toast": "Toaster_toast__3YHVS", "fade-in": "Toaster_fade-in__2526Y", "fade-out": "Toaster_fade-out__2lM6E", "title": "Toaster_title__4InNr", "timer": "Toaster_timer__3dGzF", "exitButton": "Toaster_exitButton__1S_Ks" };
	styleInject(css$b);
	
	var Toaster = (function (_ref) {
	  var _ref$toasts = _ref.toasts,
	      toasts = _ref$toasts === undefined ? [] : _ref$toasts,
	      dispatchToasts = _ref.dispatchToasts;
	
	  var setHeight = React__default.useCallback(function (id, height) {
	    dispatchToasts({
	      type: "SET_HEIGHT",
	      id: id,
	      height: height
	    });
	  }, [dispatchToasts]);
	
	  var startExit = React__default.useCallback(function (id) {
	    dispatchToasts({
	      type: "SET_EXITING",
	      id: id
	    });
	  }, [dispatchToasts]);
	
	  var removeToast = React__default.useCallback(function (id) {
	    dispatchToasts({
	      type: "REMOVE_TOAST",
	      id: id
	    });
	  }, [dispatchToasts]);
	
	  return React__default.createElement(
	    "div",
	    { className: styles$b.toaster },
	    toasts.map(function (toast, i) {
	      return React__default.createElement(Toast, _extends({}, toast, {
	        onHeightReceived: setHeight,
	        onExitRequested: startExit,
	        onRemoveRequested: removeToast,
	        y: toasts.slice(0, i + 1).reduce(function (y, t) {
	          return t.height + y + 5;
	        }, 0),
	        key: toast.id
	      }));
	    })
	  );
	});
	
	var Toast = function Toast(_ref2) {
	  var id = _ref2.id,
	      title = _ref2.title,
	      message = _ref2.message,
	      duration = _ref2.duration,
	      type = _ref2.type,
	      exiting = _ref2.exiting,
	      y = _ref2.y,
	      onHeightReceived = _ref2.onHeightReceived,
	      onExitRequested = _ref2.onExitRequested,
	      onRemoveRequested = _ref2.onRemoveRequested;
	
	  var _React$useState = React__default.useState(false),
	      _React$useState2 = slicedToArray(_React$useState, 2),
	      paused = _React$useState2[0],
	      setPaused = _React$useState2[1];
	
	  var wrapper = React__default.useRef();
	  var timer = React__default.useRef();
	
	  var stopTimer = React__default.useCallback(function () {
	    setPaused(true);
	    clearTimeout(timer.current);
	  }, []);
	
	  var resumeTimer = React__default.useCallback(function () {
	    setPaused(false);
	    timer.current = setTimeout(function () {
	      return onExitRequested(id);
	    }, duration);
	  }, [id, duration, onExitRequested]);
	
	  React__default.useLayoutEffect(function () {
	    var _wrapper$current$getB = wrapper.current.getBoundingClientRect(),
	        height = _wrapper$current$getB.height;
	
	    onHeightReceived(id, height);
	  }, [onHeightReceived, id]);
	
	  React__default.useEffect(function () {
	    resumeTimer();
	    return stopTimer;
	  }, [resumeTimer, stopTimer]);
	
	  var handleAnimationEnd = function handleAnimationEnd() {
	    if (exiting) {
	      onRemoveRequested(id);
	    }
	  };
	
	  return React__default.createElement(
	    "div",
	    {
	      ref: wrapper,
	      className: styles$b.toast,
	      "data-type": type,
	      style: { transform: "translateY(-" + y + "px)" },
	      "data-exiting": exiting,
	      onAnimationEnd: handleAnimationEnd,
	      onMouseEnter: stopTimer,
	      onMouseLeave: resumeTimer,
	      role: "alert"
	    },
	    title ? React__default.createElement(
	      "span",
	      { className: styles$b.title },
	      title
	    ) : null,
	    React__default.createElement(
	      "p",
	      null,
	      message
	    ),
	    !paused && React__default.createElement("div", {
	      className: styles$b.timer,
	      style: { animationDuration: duration + "ms" },
	      onAnimationEnd: function onAnimationEnd(e) {
	        return e.stopPropagation();
	      }
	    }),
	    React__default.createElement(
	      "button",
	      { className: styles$b.exitButton, onClick: function onClick() {
	          stopTimer();
	          onExitRequested(id);
	        } },
	      "\u2715"
	    )
	  );
	};
	
	var css$c = ".Connections_svgWrapper__3mXcU{\n  position: absolute;\n  left: 0px;\n  height: 0px;\n}\n";
	var styles$c = { "svgWrapper": "Connections_svgWrapper__3mXcU" };
	styleInject(css$c);
	
	var Connections = function Connections(_ref) {
	  var nodes = _ref.nodes,
	      editorId = _ref.editorId;
	
	
	  return React__default.createElement('div', { className: styles$c.svgWrapper, id: '' + CONNECTIONS_ID + editorId });
	};
	
	var checkForCircularNodes = function checkForCircularNodes(nodes, startNodeId) {
	  var isCircular = false;
	  var walk = function walk(nodeId) {
	    var outputs = Object.values(nodes[nodeId].connections.outputs);
	    for (var i = 0; i < outputs.length; i++) {
	      if (isCircular) {
	        break;
	      }
	      var outputConnections = outputs[i];
	      for (var k = 0; k < outputConnections.length; k++) {
	        var connectedTo = outputConnections[k];
	        if (connectedTo.nodeId === startNodeId) {
	          isCircular = true;
	          break;
	        } else {
	          walk(connectedTo.nodeId);
	        }
	      }
	    }
	  };
	  walk(startNodeId);
	  return isCircular;
	};
	
	var addConnection = function addConnection(nodes, input, output, portTypes) {
	  var _babelHelpers$extends3;
	
	  var newNodes = _extends({}, nodes, (_babelHelpers$extends3 = {}, defineProperty(_babelHelpers$extends3, input.nodeId, _extends({}, nodes[input.nodeId], {
	    connections: _extends({}, nodes[input.nodeId].connections, {
	      inputs: _extends({}, nodes[input.nodeId].connections.inputs, defineProperty({}, input.portName, [].concat(toConsumableArray(nodes[input.nodeId].connections.inputs[input.portName] || []), [{
	        nodeId: output.nodeId,
	        portName: output.portName
	      }])))
	    })
	  })), defineProperty(_babelHelpers$extends3, output.nodeId, _extends({}, nodes[output.nodeId], {
	    connections: _extends({}, nodes[output.nodeId].connections, {
	      outputs: _extends({}, nodes[output.nodeId].connections.outputs, defineProperty({}, output.portName, [].concat(toConsumableArray(nodes[output.nodeId].connections.outputs[output.portName] || []), [{
	        nodeId: input.nodeId,
	        portName: input.portName
	      }])))
	    })
	  })), _babelHelpers$extends3));
	  return newNodes;
	};
	
	var removeConnection = function removeConnection(nodes, input, output) {
	  var _babelHelpers$extends5;
	
	  var inputNode = nodes[input.nodeId];
	  var _inputNode$connection = inputNode.connections.inputs,
	      removedInputPort = _inputNode$connection[input.portName],
	      newInputNodeConnectionsInputs = objectWithoutProperties(_inputNode$connection, [input.portName]);
	
	  var newInputNode = _extends({}, inputNode, {
	    connections: _extends({}, inputNode.connections, {
	      inputs: newInputNodeConnectionsInputs
	    })
	  });
	
	  var outputNode = nodes[output.nodeId];
	  var filteredOutputNodes = outputNode.connections.outputs[output.portName].filter(function (cnx) {
	    return cnx.nodeId === input.nodeId ? cnx.portName !== input.portName : true;
	  });
	  var newOutputNode = _extends({}, outputNode, {
	    connections: _extends({}, outputNode.connections, {
	      outputs: _extends({}, outputNode.connections.outputs, defineProperty({}, output.portName, filteredOutputNodes))
	    })
	  });
	
	  return _extends({}, nodes, (_babelHelpers$extends5 = {}, defineProperty(_babelHelpers$extends5, input.nodeId, newInputNode), defineProperty(_babelHelpers$extends5, output.nodeId, newOutputNode), _babelHelpers$extends5));
	};
	
	var getFilteredTransputs = function getFilteredTransputs(transputs, nodeId) {
	  return Object.entries(transputs).reduce(function (obj, _ref) {
	    var _ref2 = slicedToArray(_ref, 2),
	        portName = _ref2[0],
	        transput = _ref2[1];
	
	    var newTransputs = transput.filter(function (t) {
	      return t.nodeId !== nodeId;
	    });
	    if (newTransputs.length) {
	      obj[portName] = newTransputs;
	    }
	    return obj;
	  }, {});
	};
	
	var removeConnections = function removeConnections(connections, nodeId) {
	  return {
	    inputs: getFilteredTransputs(connections.inputs, nodeId),
	    outputs: getFilteredTransputs(connections.outputs, nodeId)
	  };
	};
	
	var removeNode = function removeNode(startNodes, nodeId) {
	  var deletedNode = startNodes[nodeId],
	      nodes = objectWithoutProperties(startNodes, [nodeId]);
	
	  nodes = Object.values(nodes).reduce(function (obj, node) {
	    obj[node.id] = _extends({}, node, {
	      connections: removeConnections(node.connections, nodeId)
	    });
	
	    return obj;
	  }, {});
	  deleteConnectionsByNodeId(nodeId);
	  return nodes;
	};
	
	var reconcileNodes = function reconcileNodes(initialNodes, nodeTypes, portTypes, context) {
	  var nodes = _extends({}, initialNodes);
	
	  // Delete extraneous nodes
	  var nodesToDelete = Object.values(nodes).map(function (node) {
	    return !nodeTypes[node.type] ? node.id : undefined;
	  }).filter(function (x) {
	    return x;
	  });
	
	  nodesToDelete.forEach(function (nodeId) {
	    nodes = nodesReducer(nodes, {
	      type: "REMOVE_NODE",
	      nodeId: nodeId
	    }, { nodeTypes: nodeTypes, portTypes: portTypes, context: context });
	  });
	
	  // Reconcile input data for each node
	  var reconciledNodes = Object.values(nodes).reduce(function (nodesObj, node) {
	    var nodeType = nodeTypes[node.type];
	    var defaultInputData = getDefaultData({ node: node, nodeType: nodeType, portTypes: portTypes, context: context });
	    var currentInputData = Object.entries(node.inputData).reduce(function (dataObj, _ref3) {
	      var _ref4 = slicedToArray(_ref3, 2),
	          key = _ref4[0],
	          data = _ref4[1];
	
	      if (defaultInputData[key] !== undefined) {
	        dataObj[key] = data;
	      }
	      return dataObj;
	    }, {});
	    var newInputData = _extends({}, defaultInputData, currentInputData);
	    nodesObj[node.id] = _extends({}, node, {
	      inputData: newInputData
	    });
	    return nodesObj;
	  }, {});
	
	  // Reconcile node attributes for each node
	  reconciledNodes = Object.values(reconciledNodes).reduce(function (nodesObj, node) {
	    var newNode = _extends({}, node);
	    var nodeType = nodeTypes[node.type];
	    if (nodeType.root !== node.root) {
	      if (nodeType.root && !node.root) {
	        newNode.root = nodeType.root;
	      } else if (!nodeType.root && node.root) {
	        delete newNode.root;
	      }
	    }
	    nodesObj[node.id] = newNode;
	    return nodesObj;
	  }, {});
	
	  return reconciledNodes;
	};
	
	var getInitialNodes = function getInitialNodes() {
	  var initialNodes = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	  var defaultNodes = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
	  var nodeTypes = arguments[2];
	  var portTypes = arguments[3];
	  var context = arguments[4];
	
	  var reconciledNodes = reconcileNodes(initialNodes, nodeTypes, portTypes, context);
	
	  return _extends({}, reconciledNodes, defaultNodes.reduce(function (nodes, dNode, i) {
	    var nodeNotAdded = !Object.values(initialNodes).find(function (n) {
	      return n.type === dNode.type;
	    });
	    if (nodeNotAdded) {
	      nodes = nodesReducer(nodes, {
	        type: "ADD_NODE",
	        id: "default-" + i,
	        defaultNode: true,
	        x: dNode.x || 0,
	        y: dNode.y || 0,
	        nodeType: dNode.type
	      }, { nodeTypes: nodeTypes, portTypes: portTypes, context: context });
	    }
	    return nodes;
	  }, {}));
	};
	
	var getDefaultData = function getDefaultData(_ref5) {
	  var node = _ref5.node,
	      nodeType = _ref5.nodeType,
	      portTypes = _ref5.portTypes,
	      context = _ref5.context;
	
	  var inputs = Array.isArray(nodeType.inputs) ? nodeType.inputs : nodeType.inputs(node.inputData, node.connections, context);
	  return inputs.reduce(function (obj, input) {
	    var inputType = portTypes[input.type];
	    obj[input.name || inputType.name] = (input.controls || inputType.controls || []).reduce(function (obj2, control) {
	      obj2[control.name] = control.defaultValue;
	      return obj2;
	    }, {});
	    return obj;
	  }, {});
	};
	
	var nodesReducer = function nodesReducer(nodes) {
	  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	  var _ref6 = arguments[2];
	  var nodeTypes = _ref6.nodeTypes,
	      portTypes = _ref6.portTypes,
	      cache = _ref6.cache,
	      circularBehavior = _ref6.circularBehavior,
	      context = _ref6.context;
	  var dispatchToasts = arguments[3];
	
	  switch (action.type) {
	    case "ADD_CONNECTION":
	      {
	        var input = action.input,
	            output = action.output;
	
	        var inputIsNotConnected = !nodes[input.nodeId].connections.inputs[input.portName];
	        if (inputIsNotConnected) {
	          var allowCircular = circularBehavior === "warn" || circularBehavior === "allow";
	          var newNodes = addConnection(nodes, input, output, portTypes);
	          var isCircular = checkForCircularNodes(newNodes, output.nodeId);
	          if (isCircular && !allowCircular) {
	            dispatchToasts({
	              type: "ADD_TOAST",
	              title: "Unable to connect",
	              message: "Connecting these nodes would result in an infinite loop.",
	              toastType: "warning",
	              duration: 5000
	            });
	            return nodes;
	          } else {
	            if (isCircular && circularBehavior === "warn") {
	              dispatchToasts({
	                type: "ADD_TOAST",
	                title: "Circular Connection Detected",
	                message: "Connecting these nodes has created an infinite loop.",
	                toastType: "warning",
	                duration: 5000
	              });
	            }
	            return newNodes;
	          }
	        } else return nodes;
	      }
	
	    case "REMOVE_CONNECTION":
	      {
	        var _input = action.input,
	            _output = action.output;
	
	        var id = _output.nodeId + _output.portName + _input.nodeId + _input.portName;
	        delete cache.current.connections[id];
	        deleteConnection({ id: id });
	        return removeConnection(nodes, _input, _output);
	      }
	
	    case "DESTROY_TRANSPUT":
	      {
	        var transput = action.transput,
	            transputType = action.transputType;
	
	        var portId = transput.nodeId + transput.portName + transputType;
	        delete cache.current.ports[portId];
	
	        var cnxType = transputType === 'input' ? 'inputs' : 'outputs';
	        var connections = nodes[transput.nodeId].connections[cnxType][transput.portName];
	        if (!connections || !connections.length) return nodes;
	
	        return connections.reduce(function (nodes, cnx) {
	          var _ref7 = transputType === 'input' ? [transput, cnx] : [cnx, transput],
	              _ref8 = slicedToArray(_ref7, 2),
	              input = _ref8[0],
	              output = _ref8[1];
	
	          var id = output.nodeId + output.portName + input.nodeId + input.portName;
	          delete cache.current.connections[id];
	          deleteConnection({ id: id });
	          return removeConnection(nodes, input, output);
	        }, nodes);
	      }
	
	    case "ADD_NODE":
	      {
	        var x = action.x,
	            y = action.y,
	            nodeType = action.nodeType,
	            _id = action.id,
	            defaultNode = action.defaultNode;
	
	        var newNodeId = _id || nonSecure(10);
	        var newNode = {
	          id: newNodeId,
	          x: x,
	          y: y,
	          type: nodeType,
	          width: nodeTypes[nodeType].initialWidth || 200,
	          connections: {
	            inputs: {},
	            outputs: {}
	          },
	          inputData: {}
	        };
	        newNode.inputData = getDefaultData({
	          node: newNode,
	          nodeType: nodeTypes[nodeType],
	          portTypes: portTypes,
	          context: context
	        });
	        if (defaultNode) {
	          newNode.defaultNode = true;
	        }
	        if (nodeTypes[nodeType].root) {
	          newNode.root = true;
	        }
	        return _extends({}, nodes, defineProperty({}, newNodeId, newNode));
	      }
	
	    case "REMOVE_NODE":
	      {
	        var nodeId = action.nodeId;
	
	        return removeNode(nodes, nodeId);
	      }
	
	    case "HYDRATE_DEFAULT_NODES":
	      {
	        var _newNodes = _extends({}, nodes);
	        for (var key in _newNodes) {
	          if (_newNodes[key].defaultNode) {
	            var _newNodeId = nonSecure(10);
	            var _newNodes$key = _newNodes[key],
	                _id2 = _newNodes$key.id,
	                _defaultNode = _newNodes$key.defaultNode,
	                node = objectWithoutProperties(_newNodes$key, ["id", "defaultNode"]);
	
	            _newNodes[_newNodeId] = _extends({}, node, { id: _newNodeId });
	            delete _newNodes[key];
	          }
	        }
	        return _newNodes;
	      }
	
	    case "SET_PORT_DATA":
	      {
	        var _nodeId = action.nodeId,
	            portName = action.portName,
	            controlName = action.controlName,
	            data = action.data,
	            setValue = action.setValue;
	
	        var newData = _extends({}, nodes[_nodeId].inputData, defineProperty({}, portName, _extends({}, nodes[_nodeId].inputData[portName], defineProperty({}, controlName, data))));
	        if (setValue) {
	          newData = setValue(newData, nodes[_nodeId].inputData);
	        }
	        return _extends({}, nodes, defineProperty({}, _nodeId, _extends({}, nodes[_nodeId], {
	          inputData: newData
	        })));
	      }
	
	    case "SET_NODE_COORDINATES":
	      {
	        var _x4 = action.x,
	            _y = action.y,
	            _nodeId2 = action.nodeId;
	
	        return _extends({}, nodes, defineProperty({}, _nodeId2, _extends({}, nodes[_nodeId2], {
	          x: _x4,
	          y: _y
	        })));
	      }
	
	    default:
	      return nodes;
	  }
	};
	
	var connectNodesReducer = function connectNodesReducer(reducer, environment, dispatchToasts) {
	  return function (state, action) {
	    return reducer(state, action, environment, dispatchToasts);
	  };
	};
	
	var setComment = function setComment(comments, id, merge) {
	  return _extends({}, comments, defineProperty({}, id, _extends({}, comments[id], merge)));
	};
	
	var commentsReducer = (function () {
	  var comments = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	  var action = arguments[1];
	
	  switch (action.type) {
	    case "ADD_COMMENT":
	      {
	        var _comment = {
	          id: nonSecure(10),
	          text: "",
	          x: action.x,
	          y: action.y,
	          width: 200,
	          height: 30,
	          color: "blue",
	          isNew: true
	        };
	        return _extends({}, comments, defineProperty({}, _comment.id, _comment));
	      }
	    case "REMOVE_COMMENT_NEW":
	      var _comments$action$id = comments[action.id],
	          toDelete = _comments$action$id.isNew,
	          comment = objectWithoutProperties(_comments$action$id, ["isNew"]);
	
	      return _extends({}, comments, defineProperty({}, action.id, comment));
	    case "SET_COMMENT_COORDINATES":
	      {
	        return setComment(comments, action.id, { x: action.x, y: action.y });
	      }
	    case "SET_COMMENT_DIMENSIONS":
	      {
	        return setComment(comments, action.id, {
	          width: action.width,
	          height: action.height
	        });
	      }
	    case "SET_COMMENT_TEXT":
	      {
	        return setComment(comments, action.id, { text: action.text });
	      }
	    case "SET_COMMENT_COLOR":
	      {
	        return setComment(comments, action.id, { color: action.color });
	      }
	    case "DELETE_COMMENT":
	      {
	        var _toDelete = comments[action.id],
	            newComments = objectWithoutProperties(comments, [action.id]);
	
	        return newComments;
	      }
	    default:
	      return comments;
	  }
	});
	
	var toastsReducer = (function () {
	  var toasts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	  var action = arguments[1];
	
	  switch (action.type) {
	    case "ADD_TOAST":
	      return [{
	        id: nonSecure(5),
	        title: action.title,
	        message: action.message,
	        type: action.toastType || 'info',
	        duration: action.duration || 10000,
	        height: 0,
	        exiting: false
	      }].concat(toConsumableArray(toasts));
	    case "SET_HEIGHT":
	      {
	        var index = toasts.findIndex(function (t) {
	          return t.id === action.id;
	        });
	        return [].concat(toConsumableArray(toasts.slice(0, index)), [_extends({}, toasts[index], {
	          height: action.height
	        })], toConsumableArray(toasts.slice(index + 1)));
	      }
	    case "SET_EXITING":
	      {
	        var _index = toasts.findIndex(function (t) {
	          return t.id === action.id;
	        });
	        return [].concat(toConsumableArray(toasts.slice(0, _index)), [_extends({}, toasts[_index], {
	          exiting: true
	        })], toConsumableArray(toasts.slice(_index + 1)));
	      }
	    case "REMOVE_TOAST":
	      {
	        var _index2 = toasts.findIndex(function (t) {
	          return t.id === action.id;
	        });
	        return [].concat(toConsumableArray(toasts.slice(0, _index2)), toConsumableArray(toasts.slice(_index2 + 1)));
	      }
	    default:
	      return toasts;
	  }
	});
	
	var stageReducer = (function (state, incomingAction) {
	  var action = typeof incomingAction === 'function' ? incomingAction(state) : incomingAction;
	  switch (action.type) {
	    case 'SET_SCALE':
	      return _extends({}, state, { scale: action.scale });
	    case 'SET_TRANSLATE':
	      return _extends({}, state, { translate: action.translate });
	    default:
	      return state;
	  }
	});
	
	var Cache = function Cache() {
	  classCallCheck(this, Cache);
	
	  this.ports = {};
	  this.connections = {};
	};
	
	var css$d = ".styles_dragWrapper__1P7RD{\n  z-index: 9999;\n  position: absolute;\n  left: 0px;\n  top: 0px;\n}\n.styles_debugWrapper__2OSbY{\n  display: flex;\n  position: absolute;\n  left: 10px;\n  bottom: 10px;\n  gap: 15px;\n}\n";
	var styles$d = { "dragWrapper": "styles_dragWrapper__1P7RD", "debugWrapper": "styles_debugWrapper__2OSbY" };
	styleInject(css$d);
	
	var LoopError = function (_Error) {
	  inherits(LoopError, _Error);
	
	  function LoopError(message, code) {
	    classCallCheck(this, LoopError);
	
	    var _this = possibleConstructorReturn(this, (LoopError.__proto__ || Object.getPrototypeOf(LoopError)).call(this, message));
	
	    _this.code = code;
	    return _this;
	  }
	
	  return LoopError;
	}(Error);
	
	LoopError.maxLoopsExceeded = 1;
	
	
	var RootEngine = function () {
	  function RootEngine(config, resolveInputControls, fireNodeFunction) {
	    var _this2 = this;
	
	    classCallCheck(this, RootEngine);
	
	    this.resetLoops = function (maxLoops) {
	      _this2.maxLoops = maxLoops !== undefined ? maxLoops : 1000;
	      _this2.loops = 0;
	    };
	
	    this.checkLoops = function () {
	      if (_this2.maxLoops >= 0 && _this2.loops > _this2.maxLoops) {
	        throw new LoopError("Max loop count exceeded.", LoopError.maxLoopsExceeded);
	      } else {
	        _this2.loops++;
	      }
	    };
	
	    this.getRootNode = function (nodes) {
	      var roots = Object.values(nodes).filter(function (n) {
	        return n.root;
	      });
	      if (roots.length > 1) {
	        throw new Error("The root engine must not be called with more than one root node.");
	      }
	      return roots[0];
	    };
	
	    this.reduceRootInputs = function (inputs, callback) {
	      return Object.entries(inputs).reduce(function (obj, _ref) {
	        var _ref2 = slicedToArray(_ref, 2),
	            inputName = _ref2[0],
	            connection = _ref2[1];
	
	        var input = callback(inputName, connection);
	        obj[input.name] = input.value;
	        return obj;
	      }, {});
	    };
	
	    this.resolveInputValues = function (node, nodeType, nodes, context) {
	      var inputs = nodeType.inputs;
	      if (typeof inputs === 'function') {
	        inputs = inputs(node.inputData, node.connections, context);
	      }
	      return inputs.reduce(function (obj, input) {
	        var inputConnections = node.connections.inputs[input.name] || [];
	        if (inputConnections.length > 0) {
	          obj[input.name] = _this2.getValueOfConnection(inputConnections[0], nodes, context);
	        } else {
	          obj[input.name] = _this2.resolveInputControls(input.type, node.inputData[input.name] || {}, context);
	        }
	        return obj;
	      }, {});
	    };
	
	    this.getValueOfConnection = function (connection, nodes, context) {
	      _this2.checkLoops();
	      var outputNode = nodes[connection.nodeId];
	      var outputNodeType = _this2.config.nodeTypes[outputNode.type];
	      var inputValues = _this2.resolveInputValues(outputNode, outputNodeType, nodes, context);
	      var outputResult = _this2.fireNodeFunction(outputNode, inputValues, outputNodeType, context)[connection.portName];
	      return outputResult;
	    };
	
	    this.config = config;
	    this.fireNodeFunction = fireNodeFunction;
	    this.resolveInputControls = resolveInputControls;
	    this.loops = 0;
	    this.maxLoops = 1000;
	  }
	
	  createClass(RootEngine, [{
	    key: "resolveRootNode",
	    value: function resolveRootNode(nodes) {
	      var _this3 = this;
	
	      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	      var rootNode = options.rootNodeId ? nodes[options.rootNodeId] : this.getRootNode(nodes);
	      if (rootNode) {
	        var inputs = this.config.nodeTypes[rootNode.type].inputs;
	        if (typeof inputs === 'function') {
	          inputs = inputs(rootNode.inputData, rootNode.connections, options.context);
	        }
	        var controlValues = inputs.reduce(function (obj, input) {
	          obj[input.name] = _this3.resolveInputControls(input.type, rootNode.inputData[input.name] || {}, options.context);
	          return obj;
	        }, {});
	        var inputValues = this.reduceRootInputs(rootNode.connections.inputs, function (inputName, connection) {
	          _this3.resetLoops(options.maxLoops);
	          var value = void 0;
	          try {
	            value = _this3.getValueOfConnection(connection[0], nodes, options.context);
	          } catch (e) {
	            if (e.code === LoopError.maxLoopsExceeded) {
	              console.error(e.message + " Circular nodes detected in " + inputName + " port.");
	            } else {
	              console.error(e);
	            }
	          } finally {
	            return {
	              name: inputName,
	              value: value
	            };
	          }
	        });
	        if (options.onlyResolveConnected) {
	          return inputValues;
	        } else {
	          return _extends({}, controlValues, inputValues);
	        }
	      } else {
	        console.error("A root node was not found. The Root Engine requires that exactly one node be marked as the root node.");
	        return {};
	      }
	    }
	  }]);
	  return RootEngine;
	}();
	
	var defaultContext = {};
	
	exports.NodeEditor = function NodeEditor(_ref, ref) {
	  var initialComments = _ref.comments,
	      initialNodes = _ref.nodes,
	      _ref$nodeTypes = _ref.nodeTypes,
	      nodeTypes = _ref$nodeTypes === undefined ? {} : _ref$nodeTypes,
	      _ref$portTypes = _ref.portTypes,
	      portTypes = _ref$portTypes === undefined ? {} : _ref$portTypes,
	      _ref$defaultNodes = _ref.defaultNodes,
	      defaultNodes = _ref$defaultNodes === undefined ? [] : _ref$defaultNodes,
	      _ref$context = _ref.context,
	      context = _ref$context === undefined ? defaultContext : _ref$context,
	      onChange = _ref.onChange,
	      onCommentsChange = _ref.onCommentsChange,
	      initialScale = _ref.initialScale,
	      _ref$spaceToPan = _ref.spaceToPan,
	      spaceToPan = _ref$spaceToPan === undefined ? false : _ref$spaceToPan,
	      _ref$hideComments = _ref.hideComments,
	      hideComments = _ref$hideComments === undefined ? false : _ref$hideComments,
	      _ref$disableComments = _ref.disableComments,
	      disableComments = _ref$disableComments === undefined ? false : _ref$disableComments,
	      _ref$disableZoom = _ref.disableZoom,
	      disableZoom = _ref$disableZoom === undefined ? false : _ref$disableZoom,
	      _ref$disablePan = _ref.disablePan,
	      disablePan = _ref$disablePan === undefined ? false : _ref$disablePan,
	      circularBehavior = _ref.circularBehavior,
	      debug = _ref.debug;
	
	  var editorId = useId();
	  var cache = React__default.useRef(new Cache());
	  var stage = React__default.useRef();
	
	  var _React$useState = React__default.useState(),
	      _React$useState2 = slicedToArray(_React$useState, 2),
	      sideEffectToasts = _React$useState2[0],
	      setSideEffectToasts = _React$useState2[1];
	
	  var _React$useReducer = React__default.useReducer(toastsReducer, []),
	      _React$useReducer2 = slicedToArray(_React$useReducer, 2),
	      toasts = _React$useReducer2[0],
	      dispatchToasts = _React$useReducer2[1];
	
	  var _React$useReducer3 = React__default.useReducer(connectNodesReducer(nodesReducer, { nodeTypes: nodeTypes, portTypes: portTypes, cache: cache, circularBehavior: circularBehavior, context: context }, setSideEffectToasts), {}, function () {
	    return getInitialNodes(initialNodes, defaultNodes, nodeTypes, portTypes, context);
	  }),
	      _React$useReducer4 = slicedToArray(_React$useReducer3, 2),
	      nodes = _React$useReducer4[0],
	      dispatchNodes = _React$useReducer4[1];
	
	  var _React$useReducer5 = React__default.useReducer(commentsReducer, initialComments || {}),
	      _React$useReducer6 = slicedToArray(_React$useReducer5, 2),
	      comments = _React$useReducer6[0],
	      dispatchComments = _React$useReducer6[1];
	
	  React__default.useEffect(function () {
	    dispatchNodes({ type: "HYDRATE_DEFAULT_NODES" });
	  }, []);
	
	  var _React$useState3 = React__default.useState(true),
	      _React$useState4 = slicedToArray(_React$useState3, 2),
	      shouldRecalculateConnections = _React$useState4[0],
	      setShouldRecalculateConnections = _React$useState4[1];
	
	  var _React$useReducer7 = React__default.useReducer(stageReducer, {
	    scale: typeof initialScale === "number" ? clamp_1(initialScale, 0.1, 7) : 1,
	    translate: { x: 0, y: 0 }
	  }),
	      _React$useReducer8 = slicedToArray(_React$useReducer7, 2),
	      stageState = _React$useReducer8[0],
	      dispatchStageState = _React$useReducer8[1];
	
	  var recalculateConnections = React__default.useCallback(function () {
	    createConnections(nodes, stageState, editorId);
	  }, [nodes, editorId, stageState]);
	
	  var recalculateStageRect = function recalculateStageRect() {
	    stage.current = document.getElementById("" + STAGE_ID + editorId).getBoundingClientRect();
	  };
	
	  React__default.useLayoutEffect(function () {
	    if (shouldRecalculateConnections) {
	      recalculateConnections();
	      setShouldRecalculateConnections(false);
	    }
	  }, [shouldRecalculateConnections, recalculateConnections]);
	
	  var triggerRecalculation = function triggerRecalculation() {
	    setShouldRecalculateConnections(true);
	  };
	
	  React__default.useImperativeHandle(ref, function () {
	    return {
	      getNodes: function getNodes() {
	        return nodes;
	      },
	      getComments: function getComments() {
	        return comments;
	      }
	    };
	  });
	
	  var previousNodes = usePrevious$1(nodes);
	
	  React__default.useEffect(function () {
	    if (previousNodes && onChange && nodes !== previousNodes) {
	      onChange(nodes);
	    }
	  }, [nodes, previousNodes, onChange]);
	
	  var previousComments = usePrevious$1(comments);
	
	  React__default.useEffect(function () {
	    if (previousComments && onCommentsChange && comments !== previousComments) {
	      onCommentsChange(comments);
	    }
	  }, [comments, previousComments, onCommentsChange]);
	
	  React__default.useEffect(function () {
	    if (sideEffectToasts) {
	      dispatchToasts(sideEffectToasts);
	      setSideEffectToasts(null);
	    }
	  }, [sideEffectToasts]);
	
	  return React__default.createElement(
	    PortTypesContext.Provider,
	    { value: portTypes },
	    React__default.createElement(
	      NodeTypesContext.Provider,
	      { value: nodeTypes },
	      React__default.createElement(
	        NodeDispatchContext.Provider,
	        { value: dispatchNodes },
	        React__default.createElement(
	          ConnectionRecalculateContext.Provider,
	          { value: triggerRecalculation },
	          React__default.createElement(
	            ContextContext.Provider,
	            { value: context },
	            React__default.createElement(
	              StageContext.Provider,
	              { value: stageState },
	              React__default.createElement(
	                CacheContext.Provider,
	                { value: cache },
	                React__default.createElement(
	                  EditorIdContext.Provider,
	                  { value: editorId },
	                  React__default.createElement(
	                    RecalculateStageRectContext.Provider,
	                    {
	                      value: recalculateStageRect
	                    },
	                    React__default.createElement(
	                      Stage,
	                      {
	                        editorId: editorId,
	                        scale: stageState.scale,
	                        translate: stageState.translate,
	                        spaceToPan: spaceToPan,
	                        disablePan: disablePan,
	                        disableZoom: disableZoom,
	                        dispatchStageState: dispatchStageState,
	                        dispatchComments: dispatchComments,
	                        disableComments: disableComments || hideComments,
	                        stageRef: stage,
	                        numNodes: Object.keys(nodes).length,
	                        outerStageChildren: React__default.createElement(
	                          React__default.Fragment,
	                          null,
	                          debug && React__default.createElement(
	                            "div",
	                            { className: styles$d.debugWrapper },
	                            React__default.createElement(
	                              "button",
	                              {
	                                className: styles$d.debugButton,
	                                onClick: function onClick() {
	                                  return console.log(nodes);
	                                }
	                              },
	                              "Log Nodes"
	                            ),
	                            React__default.createElement(
	                              "button",
	                              {
	                                className: styles$d.debugButton,
	                                onClick: function onClick() {
	                                  return console.log(JSON.stringify(nodes));
	                                }
	                              },
	                              "Export Nodes"
	                            ),
	                            React__default.createElement(
	                              "button",
	                              {
	                                className: styles$d.debugButton,
	                                onClick: function onClick() {
	                                  return console.log(comments);
	                                }
	                              },
	                              "Log Comments"
	                            )
	                          ),
	                          React__default.createElement(Toaster, {
	                            toasts: toasts,
	                            dispatchToasts: dispatchToasts
	                          })
	                        )
	                      },
	                      !hideComments && Object.values(comments).map(function (comment) {
	                        return React__default.createElement(Comment, _extends({}, comment, {
	                          stageRect: stage,
	                          dispatch: dispatchComments,
	                          onDragStart: recalculateStageRect,
	                          key: comment.id
	                        }));
	                      }),
	                      Object.values(nodes).map(function (node) {
	                        return React__default.createElement(Node, _extends({}, node, {
	                          stageRect: stage,
	                          onDragEnd: triggerRecalculation,
	                          onDragStart: recalculateStageRect,
	                          key: node.id
	                        }));
	                      }),
	                      React__default.createElement(Connections, { nodes: nodes, editorId: editorId }),
	                      React__default.createElement("div", {
	                        className: styles$d.dragWrapper,
	                        id: "" + DRAG_CONNECTION_ID + editorId
	                      })
	                    )
	                  )
	                )
	              )
	            )
	          )
	        )
	      )
	    )
	  );
	};
	exports.NodeEditor = React__default.forwardRef(exports.NodeEditor);
	var useRootEngine = function useRootEngine(nodes, engine, context) {
	  return Object.keys(nodes).length ? engine.resolveRootNode(nodes, { context: context }) : {};
	};
	
	exports.useRootEngine = useRootEngine;
	exports.FlumeConfig = FlumeConfig;
	exports.Controls = Controls;
	exports.Colors = Colors;
	exports.RootEngine = RootEngine;
	//# sourceMappingURL=index.js.map
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 118 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.routes = exports.SUBROUTES_OBJ = exports.SUBROUTES = exports.ADDITIONAL_ROUTES = exports.DISABLE_AUTH_CHECK = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(7);
	
	var _reactRouterDom = __webpack_require__(30);
	
	__webpack_require__(1027);
	
	__webpack_require__(1426);
	
	__webpack_require__(1428);
	
	__webpack_require__(1427);
	
	__webpack_require__(1024);
	
	var _utilities = __webpack_require__(8);
	
	var _Shell = __webpack_require__(19);
	
	var _Home = __webpack_require__(297);
	
	var _Home2 = _interopRequireDefault(_Home);
	
	var _Search = __webpack_require__(468);
	
	var _Search2 = _interopRequireDefault(_Search);
	
	var _PrintResults = __webpack_require__(1125);
	
	var _PrintResults2 = _interopRequireDefault(_PrintResults);
	
	var _Lists = __webpack_require__(1109);
	
	var _Lists2 = _interopRequireDefault(_Lists);
	
	var _List = __webpack_require__(1108);
	
	var _FormManager = __webpack_require__(1099);
	
	var _FormManager2 = _interopRequireDefault(_FormManager);
	
	var _Forms = __webpack_require__(296);
	
	var _Forms2 = _interopRequireDefault(_Forms);
	
	var _DeferredDesigner = __webpack_require__(1074);
	
	var _DeferredDesigner2 = _interopRequireDefault(_DeferredDesigner);
	
	var _Wizard = __webpack_require__(472);
	
	var _MyRecords = __webpack_require__(1115);
	
	var _MyRecords2 = _interopRequireDefault(_MyRecords);
	
	var _MyWorkQueue = __webpack_require__(1121);
	
	var _MyWorkQueue2 = _interopRequireDefault(_MyWorkQueue);
	
	var _ReceiptPage = __webpack_require__(1063);
	
	var _ReceiptPage2 = _interopRequireDefault(_ReceiptPage);
	
	var _Error = __webpack_require__(1060);
	
	var _Error2 = _interopRequireDefault(_Error);
	
	var _DeferredDashboard = __webpack_require__(1065);
	
	var _DeferredDashboard2 = _interopRequireDefault(_DeferredDashboard);
	
	var _LoginRedirector = __webpack_require__(148);
	
	var _LoginRedirector2 = _interopRequireDefault(_LoginRedirector);
	
	var _Login = __webpack_require__(302);
	
	var _ChangePassword = __webpack_require__(1138);
	
	var _ChangePassword2 = _interopRequireDefault(_ChangePassword);
	
	var _VerifyEmailAddress = __webpack_require__(1141);
	
	var _VerifyEmailAddress2 = _interopRequireDefault(_VerifyEmailAddress);
	
	var _AuthActions = __webpack_require__(66);
	
	var _actions = __webpack_require__(29);
	
	var _Migrate = __webpack_require__(1110);
	
	var _Migrate2 = _interopRequireDefault(_Migrate);
	
	var _home = __webpack_require__(335);
	
	var _home2 = _interopRequireDefault(_home);
	
	var _gauge = __webpack_require__(570);
	
	var _gauge2 = _interopRequireDefault(_gauge);
	
	var _database = __webpack_require__(330);
	
	var _database2 = _interopRequireDefault(_database);
	
	var _searchThin = __webpack_require__(228);
	
	var _searchThin2 = _interopRequireDefault(_searchThin);
	
	var _documentClone = __webpack_require__(331);
	
	var _documentClone2 = _interopRequireDefault(_documentClone);
	
	var _bulletList = __webpack_require__(552);
	
	var _bulletList2 = _interopRequireDefault(_bulletList);
	
	var _document = __webpack_require__(126);
	
	var _document2 = _interopRequireDefault(_document);
	
	var _fileBox = __webpack_require__(334);
	
	var _fileBox2 = _interopRequireDefault(_fileBox);
	
	var _fileBoxTime = __webpack_require__(568);
	
	var _fileBoxTime2 = _interopRequireDefault(_fileBoxTime);
	
	var _gears = __webpack_require__(225);
	
	var _gears2 = _interopRequireDefault(_gears);
	
	var _questionMark = __webpack_require__(584);
	
	var _questionMark2 = _interopRequireDefault(_questionMark);
	
	var _reactHelmet = __webpack_require__(209);
	
	var _DeferredHealthCareDirective = __webpack_require__(1103);
	
	var _DeferredHealthCareDirective2 = _interopRequireDefault(_DeferredHealthCareDirective);
	
	var _NotFound = __webpack_require__(464);
	
	var _NotFound2 = _interopRequireDefault(_NotFound);
	
	var _VerifyCertificate = __webpack_require__(1058);
	
	var _VerifyCertificate2 = _interopRequireDefault(_VerifyCertificate);
	
	var _Toast = __webpack_require__(1148);
	
	var _Toast2 = _interopRequireDefault(_Toast);
	
	var _PaymentCallback = __webpack_require__(119);
	
	var _PaymentCallback2 = _interopRequireDefault(_PaymentCallback);
	
	var _PinsPage = __webpack_require__(1118);
	
	var _PinsPage2 = _interopRequireDefault(_PinsPage);
	
	var _DataRequests = __webpack_require__(1067);
	
	var _DataRequests2 = _interopRequireDefault(_DataRequests);
	
	var _EpassCallback = __webpack_require__(1092);
	
	var _EpassCallback2 = _interopRequireDefault(_EpassCallback);
	
	var _EpassRedirector = __webpack_require__(1094);
	
	var _EpassRedirector2 = _interopRequireDefault(_EpassRedirector);
	
	var _EpassLogout = __webpack_require__(1093);
	
	var _EpassLogout2 = _interopRequireDefault(_EpassLogout);
	
	var _ActiveDirectoryCallback = __webpack_require__(1047);
	
	var _ActiveDirectoryCallback2 = _interopRequireDefault(_ActiveDirectoryCallback);
	
	var _ActiveDirectoryRedirector = __webpack_require__(1049);
	
	var _ActiveDirectoryRedirector2 = _interopRequireDefault(_ActiveDirectoryRedirector);
	
	var _ActiveDirectoryLogout = __webpack_require__(1048);
	
	var _ActiveDirectoryLogout2 = _interopRequireDefault(_ActiveDirectoryLogout);
	
	var _FarmBill = __webpack_require__(1096);
	
	var _FarmBill2 = _interopRequireDefault(_FarmBill);
	
	var _SystemAdmin = __webpack_require__(1145);
	
	var _SystemAdmin2 = _interopRequireDefault(_SystemAdmin);
	
	var _ApostilleVerification = __webpack_require__(1052);
	
	var _ApostilleVerification2 = _interopRequireDefault(_ApostilleVerification);
	
	var _ManageSignatures = __webpack_require__(1143);
	
	var _ManageSignatures2 = _interopRequireDefault(_ManageSignatures);
	
	var _Version = __webpack_require__(1151);
	
	var _Version2 = _interopRequireDefault(_Version);
	
	var _UnsupportedBrowser = __webpack_require__(1149);
	
	var _UnsupportedBrowser2 = _interopRequireDefault(_UnsupportedBrowser);
	
	var _Announcer = __webpack_require__(1051);
	
	var _Announcer2 = _interopRequireDefault(_Announcer);
	
	var _MyReceipts = __webpack_require__(1112);
	
	var _MyReceipts2 = _interopRequireDefault(_MyReceipts);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	// import Designer2 from 'components/Designer2/Designer2'
	
	// import Dashboard from 'components/Dashboard/Dashboard'
	
	// import SearchDocsIcon from '@tecuity/sos-icons/react/search-docs'
	// import RSSIcon from '@tecuity/sos-icons/react/rss'
	
	
	var OktaCallback = void 0,
	    OktaRedirector = void 0;
	////////////////////////
	/////////////////////////////////////////////////////////////////
	/////////////////////////////////////////////////////////////////////
	//////////
	
	var DISABLE_AUTH_CHECK = exports.DISABLE_AUTH_CHECK = ("production") == 'development' && false;
	
	var ADDITIONAL_ROUTES = exports.ADDITIONAL_ROUTES = ({"dataRequests":true,"farmBill":true,"apostille":true,"externalHelp":"https://sosmt.gov/business/help-center/","systemAdministration":[{"title":"Saved Payments","parameter":"saved-payments","componentName":"SavedPayments"}]}) || {};
	
	var SUBROUTES = exports.SUBROUTES = Array.isArray(([{"label":"Business","component":"Business","parameter":"business","myWorkQueueSearch":false,"sourceTypeId":54,"searchMustHaveOneOf":["FILING_TYPE_ID","STATUS_ID","STATE","search"],"serverWebSearchDescription":true,"serverWorkQueueDescription":true,"serverMyRecordsDescription":true,"searchPlaceholder":"Search by name or filing number (X########)","allowEmptySearchTerm":true,"requestCertificateAlternateLabel":"Request Information","fileAmendmentButtonLabel":"Filing Actions","advancedSearchParameters":[{"type":"radio","name":"QUERY_TYPE_ID","defaultValue":1010,"options":[{"value":1010,"label":"Starts with"},{"value":1011,"label":"Contains"},{"value":1012,"label":" Word Contains"}]},{"type":"serverSelect","name":"FILING_TYPE_ID","optionsSrc":"FILING_TYPES","label":"Entity Type","placeholder":"All","defaultValue":"0"},{"type":"serverSelect","name":"FILING_SUBTYPE_ID","optionsSrc":"FILING_SUBTYPES","label":"Entity Subtype","overrideSubOptionsSrcFromParameterName":"FILING_TYPE_ID","placeholder":"All","defaultValue":"0"},{"type":"serverSelect","name":"STATUS_ID","optionsSrc":"FILING_STATUS_WITHOUT_ALL","label":"Status","placeholder":"All","defaultValue":"0"},{"type":"serverSelect","name":"STATE","optionsSrc":"STATE","label":"State","placeholder":"All","defaultValue":""},{"type":"serverSelect","name":"COUNTY","optionsSrc":"COUNTY_SUBOPTION","label":"County","overrideSubOptionsSrcFromParameterName":"STATE","placeholder":"All","defaultValue":""},{"type":"checkbox","name":"CRA_SEARCH_YN","defaultValue":false,"label":"Search by Registered Agent PID"},{"type":"dateRange","name":"FILING_DATE","label":"Registration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}},{"type":"dateRange","name":"EXPIRATION_DATE","label":"Expiration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}}],"myRecordsFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Active"},{"value":2,"label":"Inactive"},{"value":3,"label":"Pending"}]},{"type":"dateRange","name":"DATE_RANGE","label":"Date range","defaultValue":{"start":null,"end":null}}],"myWorkQueueFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Approved"},{"value":2,"label":"Pending Online Payment"},{"value":3,"label":"Pending Review"},{"value":4,"label":"Needs Correction"},{"value":5,"label":"Rejected"},{"value":6,"label":"Draft"}]},{"type":"dateRange","name":"DATE_RANGE","label":"Date range","defaultValue":{"start":null,"end":null}}]},{"label":"Notary","component":"Notary","parameter":"notary","sourceTypeId":850,"myWorkQueueSearch":false,"allowEmptySearchTerm":true,"requestCertificateAlternateLabel":"Download Certificate","fileAmendmentButtonLabel":"Filing Actions","hideNameRequestCertificate":true,"hideAddressRequestCertificate":true,"hideRecordUserManagment":true,"searchPlaceholder":"Search by name or commission number","searchMustHaveOneOf":["CITY","search","SERVICE_TYPE"],"advancedParametersStartOpen":true,"searchIsSortable":true,"advancedSearchParameters":[{"type":"radio","name":"STARTS_WITH_YN","defaultValue":false,"options":[{"value":true,"label":"Starts with"},{"value":false,"label":"Contains"}]},{"type":"checkbox","name":"ACTIVE_ONLY_YN","defaultValue":true,"label":"Active entities only"},{"type":"text","name":"CITY","defaultValue":"","label":"City"},{"type":"select","name":"SERVICE_TYPE","label":"Special Services Offered","defaultValue":0,"options":[{"value":0,"label":"(N/A)"},{"value":6165,"label":"In-Person Electronic Notarization (IPEN)"},{"value":6166,"label":"Remote Online Notarization (RON)"},{"value":6167,"label":"Mobile Notary Services"},{"value":6168,"label":"Remote Ink Notarization (RIN)"}]}]},{"label":"Apostille","component":"Apostille","parameter":"apostille","sourceTypeId":720,"myRecordsSearch":false,"myWorkQueueSearch":false,"disabled":false,"allowedRoutes":["/forms-manager/","/queue/","/forms/"]},{"label":"Liens","component":"UCC","parameter":"ucc","sourceTypeId":1999,"myRecordsSearch":true,"myWorkQueueSearch":true,"fileAmendmentButtonLabel":"Filing Actions","searchPlaceholder":"Search by name or file number","disabled":false,"serverWebSearchDescription":true,"myRecordsDescription":"","workQueueDescription":"","searchDescription":"","hideRecordUserManagment":true,"searchLiensCheckout":false,"advancedSearchParameters":[{"type":"radio","name":"STARTS_WITH_YN","defaultValue":false,"options":[{"value":true,"label":"Starts with"},{"value":false,"label":"Contains"}]},{"type":"select","name":"STATUS","defaultValue":"ALL","label":"Status","options":[{"value":"ACTIVE_UNLAPSED","label":"Active (unlapsed)"},{"value":"ACTIVE_LAPSED_UNLAPSED","label":"Active (lapsed and unlapsed)"}]},{"type":"text","name":"EXCLUDE_VALUES","label":"Exclude Debtor Names (comma separated list of names to exclude)","defaultValue":""},{"type":"dateRange","name":"FILING_DATE","label":"Financing Statement Date","defaultValue":{"start":null,"end":null}},{"type":"dateRange","name":"LAPSE_DATE","label":"Lapse Date","defaultValue":{"start":null,"end":null}},{"type":"text","name":"CITY","label":"Debtor City","defaultValue":""}],"myRecordsFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Approved"},{"value":2,"label":"Pending Online Payment"},{"value":3,"label":"Pending Review"}]},{"type":"select","name":"TYPE","defaultValue":0,"label":"Lien Type","options":[{"value":0,"label":"All"},{"value":1,"label":"UCC"},{"value":2,"label":"EFS"},{"value":3,"label":"Title 71"}]}],"myWorkQueueFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Approved"},{"value":2,"label":"Pending Online Payment"},{"value":3,"label":"Pending Review"},{"value":4,"label":"Pending Print and Mail"},{"value":5,"label":"Rejected"},{"value":6,"label":"Draft"}]},{"type":"select","name":"TYPE","defaultValue":0,"label":"Lien Type","options":[{"value":0,"label":"All"},{"value":1,"label":"UCC"},{"value":2,"label":"EFS"},{"value":3,"label":"Title 71"}]}]},{"label":"Copy Request","component":"copies","parameter":"copies","sourceTypeId":2001,"myRecordsSearch":false,"myWorkQueueSearch":false,"disabled":false,"allowedRoutes":["/forms-manager/","/queue/","/forms/"]},{"label":"Trademark","component":"Trademark","parameter":"trademark","sourceTypeId":810,"showRequestCertificate":true,"searchMustHaveOneOf":["search","EXPIRATION_DATE","FILING_DATE"],"allowEmptySearchTerm":true,"requestCertificateAlternateLabel":"Request Information","fileAmendmentButtonLabel":"Filing Actions","advancedSearchParameters":[{"type":"radio","name":"QUERY_TYPE_ID","defaultValue":1010,"options":[{"value":1010,"label":"Starts with"},{"value":1011,"label":"Contains"},{"value":1012,"label":" Word Contains"}]},{"type":"checkbox","name":"OWNER_SEARCH_YN","defaultValue":false,"label":"Search owners"},{"type":"radio","name":"SERVICE_MARK_YN","label":"Mark Type","defaultValue":"","options":[{"value":"","label":"All Marks"},{"value":"Y","label":"Service Mark"},{"value":"N","label":"Trademark"}]},{"type":"serverSelect","name":"STATUS_ID","optionsSrc":"TYPE_V|TRADEMARK_STATUS_TYPE","label":"Status","placeholder":"All","defaultValue":"0"},{"type":"select","name":"DESIGN_TYPE_ID","options":[{"value":0,"label":"All"},{"value":990,"label":"Words Only"},{"value":991,"label":"Design Only"},{"value":992,"label":"Words and Design"}],"label":"Design Type","defaultValue":"0"},{"type":"dateRange","name":"FILING_DATE","label":"Registered Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}},{"type":"dateRange","name":"EXPIRATION_DATE","label":"Expiration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}}]},{"label":"Business Info Request","component":"InfoRequests","parameter":"info-request","sourceTypeId":167,"allowedRoutes":["/forms-manager/","/queue/","/forms/"]},{"label":"Data Requests","component":"DataRequests","parameter":"data-request","sourceTypeId":0,"allowedRoutes":["/forms-manager/"]},{"label":"CRA","component":"CRA","parameter":"cra","sourceTypeId":157,"myRecordsSearch":false,"searchPlaceholder":"Search by name or registered agent number","allowedRoutes":["/forms-manager/","/forms/","/records/","/queue/","/search/"],"allowEmptySearchTerm":true,"fileAmendmentButtonLabel":"Filing Actions","advancedSearchParameters":[{"type":"radio","name":"QUERY_TYPE_ID","defaultValue":1010,"options":[{"value":1010,"label":"Starts with"},{"value":1011,"label":"Contains"},{"value":1012,"label":" Word Contains"}]},{"type":"dateRange","name":"CRA_DATE","label":"Registration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}},{"type":"select","name":"STATUS_ID","label":"Status","defaultValue":0,"options":[{"value":0,"label":"All"},{"value":121,"label":"Active"},{"value":122,"label":"Inactive"}]},{"type":"select","name":"AGENT_TYPE_ID","label":"Agent Type","defaultValue":0,"options":[{"value":0,"label":"All"},{"value":460,"label":"Registered Agent"},{"value":461,"label":"Commercial Registered Agent"}]}]},{"label":"Farm Bill","component":"FarmBill","parameter":"farm-bill","path":"/lists/farm-bill","sourceTypeId":0,"myRecordsSearch":false,"allowedRules":["/search/"],"disabled":true,"searchDescription":"To perform a search, enter a debtor name. Your search results may include: exact debtor name, variations of that name and any filing that includes your search criteria. Punctuation is ignored.\n\nYou can click on \"Advanced\" to refine your search. Under “Advanced” you can search by crop, year, county and SSN/FEIN. As a registered Farm Bill Buyer with the Montana Secretary of State’s office it is important to maintain the confidentiality of the information contained within the Farm Bill Master List. The Farm Bill Master List reflects personal data, such as Social Security Numbers, which are a key piece of personal identifiable information to assist you in determining the existence of a lien against a specific debtor. The distribution of this information beyond its intended purpose is strictly prohibited.\n\nThe debtor's tax identification number has been hidden for confidentiality reasons. You may continue to search on a tax ID number and return debtors that match your search criteria. The SSN/FEIN must be entered without dashes or spaces.","searchMustHaveOneOf":["search","UCC_FARM_PRODUCT_ID","COUNTY"],"searchPlaceholder":"Search by debtor name","advancedSearchParameters":[{"type":"ServerMultiComplete","label":"Product code name(s)","name":"UCC_FARM_PRODUCT_ID","defaultValue":"","optionsSrc":"UCC_FARM_PRODUCT_V"},{"type":"MultiComplete","label":"Year or Range of Years","name":"YEAR_NUM","optionsSrc":"years","startYear":"1968","defaultValue":[],"preMergeOptions":[{"value":"ALL","label":"All"}]},{"type":"serverSelect","label":"State","name":"STATE","defaultValue":"MONTANA","optionsSrc":"STATE"},{"type":"ServerMultiComplete","label":"County","name":"COUNTY","defaultValue":[],"optionsSrc":"COUNTY","overrideSubOptionsSrcFromParameterName":"STATE"},{"type":"checkbox","name":"TIN_SEARCH_YN","defaultValue":false,"label":"Tax Identification Number Search"},{"type":"checkbox","name":"TIN_SORT_YN","defaultValue":false,"label":"Unique ID Sort"}]}])) ? ([{"label":"Business","component":"Business","parameter":"business","myWorkQueueSearch":false,"sourceTypeId":54,"searchMustHaveOneOf":["FILING_TYPE_ID","STATUS_ID","STATE","search"],"serverWebSearchDescription":true,"serverWorkQueueDescription":true,"serverMyRecordsDescription":true,"searchPlaceholder":"Search by name or filing number (X########)","allowEmptySearchTerm":true,"requestCertificateAlternateLabel":"Request Information","fileAmendmentButtonLabel":"Filing Actions","advancedSearchParameters":[{"type":"radio","name":"QUERY_TYPE_ID","defaultValue":1010,"options":[{"value":1010,"label":"Starts with"},{"value":1011,"label":"Contains"},{"value":1012,"label":" Word Contains"}]},{"type":"serverSelect","name":"FILING_TYPE_ID","optionsSrc":"FILING_TYPES","label":"Entity Type","placeholder":"All","defaultValue":"0"},{"type":"serverSelect","name":"FILING_SUBTYPE_ID","optionsSrc":"FILING_SUBTYPES","label":"Entity Subtype","overrideSubOptionsSrcFromParameterName":"FILING_TYPE_ID","placeholder":"All","defaultValue":"0"},{"type":"serverSelect","name":"STATUS_ID","optionsSrc":"FILING_STATUS_WITHOUT_ALL","label":"Status","placeholder":"All","defaultValue":"0"},{"type":"serverSelect","name":"STATE","optionsSrc":"STATE","label":"State","placeholder":"All","defaultValue":""},{"type":"serverSelect","name":"COUNTY","optionsSrc":"COUNTY_SUBOPTION","label":"County","overrideSubOptionsSrcFromParameterName":"STATE","placeholder":"All","defaultValue":""},{"type":"checkbox","name":"CRA_SEARCH_YN","defaultValue":false,"label":"Search by Registered Agent PID"},{"type":"dateRange","name":"FILING_DATE","label":"Registration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}},{"type":"dateRange","name":"EXPIRATION_DATE","label":"Expiration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}}],"myRecordsFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Active"},{"value":2,"label":"Inactive"},{"value":3,"label":"Pending"}]},{"type":"dateRange","name":"DATE_RANGE","label":"Date range","defaultValue":{"start":null,"end":null}}],"myWorkQueueFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Approved"},{"value":2,"label":"Pending Online Payment"},{"value":3,"label":"Pending Review"},{"value":4,"label":"Needs Correction"},{"value":5,"label":"Rejected"},{"value":6,"label":"Draft"}]},{"type":"dateRange","name":"DATE_RANGE","label":"Date range","defaultValue":{"start":null,"end":null}}]},{"label":"Notary","component":"Notary","parameter":"notary","sourceTypeId":850,"myWorkQueueSearch":false,"allowEmptySearchTerm":true,"requestCertificateAlternateLabel":"Download Certificate","fileAmendmentButtonLabel":"Filing Actions","hideNameRequestCertificate":true,"hideAddressRequestCertificate":true,"hideRecordUserManagment":true,"searchPlaceholder":"Search by name or commission number","searchMustHaveOneOf":["CITY","search","SERVICE_TYPE"],"advancedParametersStartOpen":true,"searchIsSortable":true,"advancedSearchParameters":[{"type":"radio","name":"STARTS_WITH_YN","defaultValue":false,"options":[{"value":true,"label":"Starts with"},{"value":false,"label":"Contains"}]},{"type":"checkbox","name":"ACTIVE_ONLY_YN","defaultValue":true,"label":"Active entities only"},{"type":"text","name":"CITY","defaultValue":"","label":"City"},{"type":"select","name":"SERVICE_TYPE","label":"Special Services Offered","defaultValue":0,"options":[{"value":0,"label":"(N/A)"},{"value":6165,"label":"In-Person Electronic Notarization (IPEN)"},{"value":6166,"label":"Remote Online Notarization (RON)"},{"value":6167,"label":"Mobile Notary Services"},{"value":6168,"label":"Remote Ink Notarization (RIN)"}]}]},{"label":"Apostille","component":"Apostille","parameter":"apostille","sourceTypeId":720,"myRecordsSearch":false,"myWorkQueueSearch":false,"disabled":false,"allowedRoutes":["/forms-manager/","/queue/","/forms/"]},{"label":"Liens","component":"UCC","parameter":"ucc","sourceTypeId":1999,"myRecordsSearch":true,"myWorkQueueSearch":true,"fileAmendmentButtonLabel":"Filing Actions","searchPlaceholder":"Search by name or file number","disabled":false,"serverWebSearchDescription":true,"myRecordsDescription":"","workQueueDescription":"","searchDescription":"","hideRecordUserManagment":true,"searchLiensCheckout":false,"advancedSearchParameters":[{"type":"radio","name":"STARTS_WITH_YN","defaultValue":false,"options":[{"value":true,"label":"Starts with"},{"value":false,"label":"Contains"}]},{"type":"select","name":"STATUS","defaultValue":"ALL","label":"Status","options":[{"value":"ACTIVE_UNLAPSED","label":"Active (unlapsed)"},{"value":"ACTIVE_LAPSED_UNLAPSED","label":"Active (lapsed and unlapsed)"}]},{"type":"text","name":"EXCLUDE_VALUES","label":"Exclude Debtor Names (comma separated list of names to exclude)","defaultValue":""},{"type":"dateRange","name":"FILING_DATE","label":"Financing Statement Date","defaultValue":{"start":null,"end":null}},{"type":"dateRange","name":"LAPSE_DATE","label":"Lapse Date","defaultValue":{"start":null,"end":null}},{"type":"text","name":"CITY","label":"Debtor City","defaultValue":""}],"myRecordsFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Approved"},{"value":2,"label":"Pending Online Payment"},{"value":3,"label":"Pending Review"}]},{"type":"select","name":"TYPE","defaultValue":0,"label":"Lien Type","options":[{"value":0,"label":"All"},{"value":1,"label":"UCC"},{"value":2,"label":"EFS"},{"value":3,"label":"Title 71"}]}],"myWorkQueueFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Approved"},{"value":2,"label":"Pending Online Payment"},{"value":3,"label":"Pending Review"},{"value":4,"label":"Pending Print and Mail"},{"value":5,"label":"Rejected"},{"value":6,"label":"Draft"}]},{"type":"select","name":"TYPE","defaultValue":0,"label":"Lien Type","options":[{"value":0,"label":"All"},{"value":1,"label":"UCC"},{"value":2,"label":"EFS"},{"value":3,"label":"Title 71"}]}]},{"label":"Copy Request","component":"copies","parameter":"copies","sourceTypeId":2001,"myRecordsSearch":false,"myWorkQueueSearch":false,"disabled":false,"allowedRoutes":["/forms-manager/","/queue/","/forms/"]},{"label":"Trademark","component":"Trademark","parameter":"trademark","sourceTypeId":810,"showRequestCertificate":true,"searchMustHaveOneOf":["search","EXPIRATION_DATE","FILING_DATE"],"allowEmptySearchTerm":true,"requestCertificateAlternateLabel":"Request Information","fileAmendmentButtonLabel":"Filing Actions","advancedSearchParameters":[{"type":"radio","name":"QUERY_TYPE_ID","defaultValue":1010,"options":[{"value":1010,"label":"Starts with"},{"value":1011,"label":"Contains"},{"value":1012,"label":" Word Contains"}]},{"type":"checkbox","name":"OWNER_SEARCH_YN","defaultValue":false,"label":"Search owners"},{"type":"radio","name":"SERVICE_MARK_YN","label":"Mark Type","defaultValue":"","options":[{"value":"","label":"All Marks"},{"value":"Y","label":"Service Mark"},{"value":"N","label":"Trademark"}]},{"type":"serverSelect","name":"STATUS_ID","optionsSrc":"TYPE_V|TRADEMARK_STATUS_TYPE","label":"Status","placeholder":"All","defaultValue":"0"},{"type":"select","name":"DESIGN_TYPE_ID","options":[{"value":0,"label":"All"},{"value":990,"label":"Words Only"},{"value":991,"label":"Design Only"},{"value":992,"label":"Words and Design"}],"label":"Design Type","defaultValue":"0"},{"type":"dateRange","name":"FILING_DATE","label":"Registered Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}},{"type":"dateRange","name":"EXPIRATION_DATE","label":"Expiration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}}]},{"label":"Business Info Request","component":"InfoRequests","parameter":"info-request","sourceTypeId":167,"allowedRoutes":["/forms-manager/","/queue/","/forms/"]},{"label":"Data Requests","component":"DataRequests","parameter":"data-request","sourceTypeId":0,"allowedRoutes":["/forms-manager/"]},{"label":"CRA","component":"CRA","parameter":"cra","sourceTypeId":157,"myRecordsSearch":false,"searchPlaceholder":"Search by name or registered agent number","allowedRoutes":["/forms-manager/","/forms/","/records/","/queue/","/search/"],"allowEmptySearchTerm":true,"fileAmendmentButtonLabel":"Filing Actions","advancedSearchParameters":[{"type":"radio","name":"QUERY_TYPE_ID","defaultValue":1010,"options":[{"value":1010,"label":"Starts with"},{"value":1011,"label":"Contains"},{"value":1012,"label":" Word Contains"}]},{"type":"dateRange","name":"CRA_DATE","label":"Registration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}},{"type":"select","name":"STATUS_ID","label":"Status","defaultValue":0,"options":[{"value":0,"label":"All"},{"value":121,"label":"Active"},{"value":122,"label":"Inactive"}]},{"type":"select","name":"AGENT_TYPE_ID","label":"Agent Type","defaultValue":0,"options":[{"value":0,"label":"All"},{"value":460,"label":"Registered Agent"},{"value":461,"label":"Commercial Registered Agent"}]}]},{"label":"Farm Bill","component":"FarmBill","parameter":"farm-bill","path":"/lists/farm-bill","sourceTypeId":0,"myRecordsSearch":false,"allowedRules":["/search/"],"disabled":true,"searchDescription":"To perform a search, enter a debtor name. Your search results may include: exact debtor name, variations of that name and any filing that includes your search criteria. Punctuation is ignored.\n\nYou can click on \"Advanced\" to refine your search. Under “Advanced” you can search by crop, year, county and SSN/FEIN. As a registered Farm Bill Buyer with the Montana Secretary of State’s office it is important to maintain the confidentiality of the information contained within the Farm Bill Master List. The Farm Bill Master List reflects personal data, such as Social Security Numbers, which are a key piece of personal identifiable information to assist you in determining the existence of a lien against a specific debtor. The distribution of this information beyond its intended purpose is strictly prohibited.\n\nThe debtor's tax identification number has been hidden for confidentiality reasons. You may continue to search on a tax ID number and return debtors that match your search criteria. The SSN/FEIN must be entered without dashes or spaces.","searchMustHaveOneOf":["search","UCC_FARM_PRODUCT_ID","COUNTY"],"searchPlaceholder":"Search by debtor name","advancedSearchParameters":[{"type":"ServerMultiComplete","label":"Product code name(s)","name":"UCC_FARM_PRODUCT_ID","defaultValue":"","optionsSrc":"UCC_FARM_PRODUCT_V"},{"type":"MultiComplete","label":"Year or Range of Years","name":"YEAR_NUM","optionsSrc":"years","startYear":"1968","defaultValue":[],"preMergeOptions":[{"value":"ALL","label":"All"}]},{"type":"serverSelect","label":"State","name":"STATE","defaultValue":"MONTANA","optionsSrc":"STATE"},{"type":"ServerMultiComplete","label":"County","name":"COUNTY","defaultValue":[],"optionsSrc":"COUNTY","overrideSubOptionsSrcFromParameterName":"STATE"},{"type":"checkbox","name":"TIN_SEARCH_YN","defaultValue":false,"label":"Tax Identification Number Search"},{"type":"checkbox","name":"TIN_SORT_YN","defaultValue":false,"label":"Unique ID Sort"}]}]) : [];
	var constructSubroutes = function constructSubroutes(path) {
	  return SUBROUTES.filter(function (route) {
	    if (route.allowedRoutes) {
	      return route.allowedRoutes.includes(path);
	    }
	    return route.disabled !== true;
	  }).map(function (route) {
	    return (0, _utilities.hydrateSublinkFunctions)(Object.assign({}, route, {
	      path: path + route.parameter
	    }));
	  });
	};
	
	var SUBROUTES_OBJ = exports.SUBROUTES_OBJ = SUBROUTES.reduce(function (obj, route) {
	  return Object.assign({}, obj, _defineProperty({}, route.parameter, route));
	}, {});
	
	var routes = exports.routes = [{
	  label: 'Home',
	  title: 'Online Business Services',
	  includeInSidebar: true,
	  icon: _react2.default.createElement(_home2.default, null),
	  component: _Home2.default,
	  exact: true,
	  link: '/',
	  path: '/',
	  subLinks: [],
	  linkAvailableOffline: true
	}].concat(_toConsumableArray(ADDITIONAL_ROUTES.dashboard ? [{
	  label: 'Dashboard',
	  title: 'Dashboard',
	  includeInSidebar: true,
	  icon: _react2.default.createElement(_gauge2.default, null),
	  component: _DeferredDashboard2.default,
	  exact: true,
	  // collapseSidebar: true,
	  link: '/dashboard',
	  path: '/dashboard',
	  subLinks: [],
	  authOnly: true,
	  allowedUserGroups: ['ADMIN', 'ADMIN_WEB']
	}] : []), [{
	  label: 'Search',
	  title: 'Search',
	  includeInSidebar: true,
	  icon: _react2.default.createElement(_searchThin2.default, null),
	  component: _Search2.default,
	  link: '/search',
	  path: '/search/:subParam?',
	  subLinks: constructSubroutes('/search/'),
	  linkAvailableOffline: true
	}, {
	  label: 'Print Results',
	  title: 'Print Results',
	  includeInSidebar: false,
	  component: _PrintResults2.default,
	  link: '/print-results',
	  path: '/print-results',
	  linkAvailableOffline: true,
	  hideAppShell: true
	}, {
	  label: 'Forms',
	  title: 'Forms',
	  includeInSidebar: true,
	  icon: _react2.default.createElement(_documentClone2.default, null),
	  component: _Forms2.default,
	  path: '/forms/:category?',
	  link: '/forms',
	  exact: true,
	  linkExact: false,
	  // isActive: (match, location) => location.pathname.includes('/forms'),
	  subLinks: constructSubroutes('/forms/'),
	  allowedUserGroups: ['ADMIN', 'ADMIN_WEB', 'WEB']
	}, {
	  label: 'Wizard Filing',
	  title: 'File',
	  includeInSidebar: false,
	  icon: _react2.default.createElement(_documentClone2.default, null),
	  component: _Wizard.ConnectedWizard,
	  path: '/forms/new/:formDefinitionId',
	  link: '/forms/0',
	  subLinks: [],
	  authOnly: false,
	  allowedUserGroups: ['ADMIN_WEB', 'WEB']
	}, {
	  label: 'Wizard Sign',
	  title: 'Sign',
	  includeInSidebar: false,
	  icon: _react2.default.createElement(_documentClone2.default, null),
	  component: _Wizard.SignaturesWizard,
	  path: '/forms/sign/:token',
	  link: '/forms/0',
	  subLinks: [],
	  authOnly: false
	}], _toConsumableArray(ADDITIONAL_ROUTES.lists !== false ? [{
	  label: 'Lists',
	  title: 'Lists',
	  includeInSidebar: true,
	  component: _Lists2.default,
	  icon: _react2.default.createElement(_bulletList2.default, null),
	  path: '/lists',
	  link: '/lists',
	  exact: true,
	  subLinks: [],
	  linkAvailableOffline: true
	}] : []), [{
	  label: 'Registered Lobbyists',
	  title: 'Registered Lobbyists',
	  includeInSidebar: false,
	  component: _List.LobbyistList,
	  icon: _react2.default.createElement(_bulletList2.default, null),
	  path: '/lists/lobbyist',
	  link: '/lists/lobbyist?rangeid=1',
	  subLinks: []
	}, {
	  label: 'My Work Queue',
	  title: 'My Work Queue',
	  includeInSidebar: true,
	  component: _MyWorkQueue2.default,
	  icon: _react2.default.createElement(_fileBoxTime2.default, null),
	  link: '/queue',
	  path: '/queue/:category?',
	  subLinks: constructSubroutes('/queue/'),
	  authOnly: true,
	  allowedUserGroups: ['ADMIN_WEB', 'WEB']
	}, {
	  label: 'My Receipts',
	  title: 'My Receipts',
	  includeInSidebar: (true) || false,
	  component: _MyReceipts2.default,
	  icon: _react2.default.createElement(_document2.default, null),
	  link: '/myreceipts',
	  path: '/myreceipts',
	  authOnly: true,
	  allowedUserGroups: ['ADMIN_WEB', 'WEB']
	}, {
	  label: 'My Records',
	  title: 'My Records',
	  includeInSidebar: true,
	  icon: _react2.default.createElement(_fileBox2.default, null),
	  link: '/records',
	  path: '/records/:subParam?',
	  component: _MyRecords2.default,
	  subLinks: constructSubroutes('/records/'),
	  allowedUserGroups: ['ADMIN_WEB', 'WEB'],
	  // numAlerts: 1,
	  authOnly: true
	}], _toConsumableArray(ADDITIONAL_ROUTES.dataRequests ? [{
	  label: ("Data Requests & Subscriptions") || 'Data Requests',
	  title: ("Data Requests & Subscriptions") || 'Data Requests',
	  includeInSidebar: true,
	  icon: _react2.default.createElement(_database2.default, null),
	  component: _DataRequests2.default,
	  path: '/data-requests',
	  link: '/data-requests',
	  authOnly: true,
	  alwaysShowInSidebar: ({"NODE_ENV":"production","BUILD_DATE":"2025-08-27T15:15:31.687Z","BUILD_NUMBER":"Not Provided","GIT_VERSION":"v1.3.0-381-ga81e29b08","GIT_COMMIT_HASH":"a81e29b085c9268ffd96c78eb734365802722741","GIT_BRANCH":"beta","PUBLIC_URL":"","STATE_ABBR":"MT","STATE_NAME":"Montana","STATE_ORG_TITLE":"Secretary of State","LOGIN_HEADER_IMG_PATH":"","HOME_IMG_FILENAME":"montana.jpg","FAVICON_FILE_NAME":"favicon.ico","ALLOW_E_SIGN_ON_CORRECTIONS":true,"THIRD_PARTY_SIGNING_ALLOWED":false,"MY_ACCOUNT_SAVE_AND_CLOSE_BUTTON":true,"IE_DEPRECATED_MESSAGE":"Internet Explorer is not supported. Please select a supported browser below to access this website.","ADDITIONAL_ROUTES":{"dataRequests":true,"farmBill":true,"apostille":true,"externalHelp":"https://sosmt.gov/business/help-center/","systemAdministration":[{"title":"Saved Payments","parameter":"saved-payments","componentName":"SavedPayments"}]},"SUBROUTES":[{"label":"Business","component":"Business","parameter":"business","myWorkQueueSearch":false,"sourceTypeId":54,"searchMustHaveOneOf":["FILING_TYPE_ID","STATUS_ID","STATE","search"],"serverWebSearchDescription":true,"serverWorkQueueDescription":true,"serverMyRecordsDescription":true,"searchPlaceholder":"Search by name or filing number (X########)","allowEmptySearchTerm":true,"requestCertificateAlternateLabel":"Request Information","fileAmendmentButtonLabel":"Filing Actions","advancedSearchParameters":[{"type":"radio","name":"QUERY_TYPE_ID","defaultValue":1010,"options":[{"value":1010,"label":"Starts with"},{"value":1011,"label":"Contains"},{"value":1012,"label":" Word Contains"}]},{"type":"serverSelect","name":"FILING_TYPE_ID","optionsSrc":"FILING_TYPES","label":"Entity Type","placeholder":"All","defaultValue":"0"},{"type":"serverSelect","name":"FILING_SUBTYPE_ID","optionsSrc":"FILING_SUBTYPES","label":"Entity Subtype","overrideSubOptionsSrcFromParameterName":"FILING_TYPE_ID","placeholder":"All","defaultValue":"0"},{"type":"serverSelect","name":"STATUS_ID","optionsSrc":"FILING_STATUS_WITHOUT_ALL","label":"Status","placeholder":"All","defaultValue":"0"},{"type":"serverSelect","name":"STATE","optionsSrc":"STATE","label":"State","placeholder":"All","defaultValue":""},{"type":"serverSelect","name":"COUNTY","optionsSrc":"COUNTY_SUBOPTION","label":"County","overrideSubOptionsSrcFromParameterName":"STATE","placeholder":"All","defaultValue":""},{"type":"checkbox","name":"CRA_SEARCH_YN","defaultValue":false,"label":"Search by Registered Agent PID"},{"type":"dateRange","name":"FILING_DATE","label":"Registration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}},{"type":"dateRange","name":"EXPIRATION_DATE","label":"Expiration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}}],"myRecordsFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Active"},{"value":2,"label":"Inactive"},{"value":3,"label":"Pending"}]},{"type":"dateRange","name":"DATE_RANGE","label":"Date range","defaultValue":{"start":null,"end":null}}],"myWorkQueueFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Approved"},{"value":2,"label":"Pending Online Payment"},{"value":3,"label":"Pending Review"},{"value":4,"label":"Needs Correction"},{"value":5,"label":"Rejected"},{"value":6,"label":"Draft"}]},{"type":"dateRange","name":"DATE_RANGE","label":"Date range","defaultValue":{"start":null,"end":null}}]},{"label":"Notary","component":"Notary","parameter":"notary","sourceTypeId":850,"myWorkQueueSearch":false,"allowEmptySearchTerm":true,"requestCertificateAlternateLabel":"Download Certificate","fileAmendmentButtonLabel":"Filing Actions","hideNameRequestCertificate":true,"hideAddressRequestCertificate":true,"hideRecordUserManagment":true,"searchPlaceholder":"Search by name or commission number","searchMustHaveOneOf":["CITY","search","SERVICE_TYPE"],"advancedParametersStartOpen":true,"searchIsSortable":true,"advancedSearchParameters":[{"type":"radio","name":"STARTS_WITH_YN","defaultValue":false,"options":[{"value":true,"label":"Starts with"},{"value":false,"label":"Contains"}]},{"type":"checkbox","name":"ACTIVE_ONLY_YN","defaultValue":true,"label":"Active entities only"},{"type":"text","name":"CITY","defaultValue":"","label":"City"},{"type":"select","name":"SERVICE_TYPE","label":"Special Services Offered","defaultValue":0,"options":[{"value":0,"label":"(N/A)"},{"value":6165,"label":"In-Person Electronic Notarization (IPEN)"},{"value":6166,"label":"Remote Online Notarization (RON)"},{"value":6167,"label":"Mobile Notary Services"},{"value":6168,"label":"Remote Ink Notarization (RIN)"}]}]},{"label":"Apostille","component":"Apostille","parameter":"apostille","sourceTypeId":720,"myRecordsSearch":false,"myWorkQueueSearch":false,"disabled":false,"allowedRoutes":["/forms-manager/","/queue/","/forms/"]},{"label":"Liens","component":"UCC","parameter":"ucc","sourceTypeId":1999,"myRecordsSearch":true,"myWorkQueueSearch":true,"fileAmendmentButtonLabel":"Filing Actions","searchPlaceholder":"Search by name or file number","disabled":false,"serverWebSearchDescription":true,"myRecordsDescription":"","workQueueDescription":"","searchDescription":"","hideRecordUserManagment":true,"searchLiensCheckout":false,"advancedSearchParameters":[{"type":"radio","name":"STARTS_WITH_YN","defaultValue":false,"options":[{"value":true,"label":"Starts with"},{"value":false,"label":"Contains"}]},{"type":"select","name":"STATUS","defaultValue":"ALL","label":"Status","options":[{"value":"ACTIVE_UNLAPSED","label":"Active (unlapsed)"},{"value":"ACTIVE_LAPSED_UNLAPSED","label":"Active (lapsed and unlapsed)"}]},{"type":"text","name":"EXCLUDE_VALUES","label":"Exclude Debtor Names (comma separated list of names to exclude)","defaultValue":""},{"type":"dateRange","name":"FILING_DATE","label":"Financing Statement Date","defaultValue":{"start":null,"end":null}},{"type":"dateRange","name":"LAPSE_DATE","label":"Lapse Date","defaultValue":{"start":null,"end":null}},{"type":"text","name":"CITY","label":"Debtor City","defaultValue":""}],"myRecordsFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Approved"},{"value":2,"label":"Pending Online Payment"},{"value":3,"label":"Pending Review"}]},{"type":"select","name":"TYPE","defaultValue":0,"label":"Lien Type","options":[{"value":0,"label":"All"},{"value":1,"label":"UCC"},{"value":2,"label":"EFS"},{"value":3,"label":"Title 71"}]}],"myWorkQueueFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Approved"},{"value":2,"label":"Pending Online Payment"},{"value":3,"label":"Pending Review"},{"value":4,"label":"Pending Print and Mail"},{"value":5,"label":"Rejected"},{"value":6,"label":"Draft"}]},{"type":"select","name":"TYPE","defaultValue":0,"label":"Lien Type","options":[{"value":0,"label":"All"},{"value":1,"label":"UCC"},{"value":2,"label":"EFS"},{"value":3,"label":"Title 71"}]}]},{"label":"Copy Request","component":"copies","parameter":"copies","sourceTypeId":2001,"myRecordsSearch":false,"myWorkQueueSearch":false,"disabled":false,"allowedRoutes":["/forms-manager/","/queue/","/forms/"]},{"label":"Trademark","component":"Trademark","parameter":"trademark","sourceTypeId":810,"showRequestCertificate":true,"searchMustHaveOneOf":["search","EXPIRATION_DATE","FILING_DATE"],"allowEmptySearchTerm":true,"requestCertificateAlternateLabel":"Request Information","fileAmendmentButtonLabel":"Filing Actions","advancedSearchParameters":[{"type":"radio","name":"QUERY_TYPE_ID","defaultValue":1010,"options":[{"value":1010,"label":"Starts with"},{"value":1011,"label":"Contains"},{"value":1012,"label":" Word Contains"}]},{"type":"checkbox","name":"OWNER_SEARCH_YN","defaultValue":false,"label":"Search owners"},{"type":"radio","name":"SERVICE_MARK_YN","label":"Mark Type","defaultValue":"","options":[{"value":"","label":"All Marks"},{"value":"Y","label":"Service Mark"},{"value":"N","label":"Trademark"}]},{"type":"serverSelect","name":"STATUS_ID","optionsSrc":"TYPE_V|TRADEMARK_STATUS_TYPE","label":"Status","placeholder":"All","defaultValue":"0"},{"type":"select","name":"DESIGN_TYPE_ID","options":[{"value":0,"label":"All"},{"value":990,"label":"Words Only"},{"value":991,"label":"Design Only"},{"value":992,"label":"Words and Design"}],"label":"Design Type","defaultValue":"0"},{"type":"dateRange","name":"FILING_DATE","label":"Registered Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}},{"type":"dateRange","name":"EXPIRATION_DATE","label":"Expiration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}}]},{"label":"Business Info Request","component":"InfoRequests","parameter":"info-request","sourceTypeId":167,"allowedRoutes":["/forms-manager/","/queue/","/forms/"]},{"label":"Data Requests","component":"DataRequests","parameter":"data-request","sourceTypeId":0,"allowedRoutes":["/forms-manager/"]},{"label":"CRA","component":"CRA","parameter":"cra","sourceTypeId":157,"myRecordsSearch":false,"searchPlaceholder":"Search by name or registered agent number","allowedRoutes":["/forms-manager/","/forms/","/records/","/queue/","/search/"],"allowEmptySearchTerm":true,"fileAmendmentButtonLabel":"Filing Actions","advancedSearchParameters":[{"type":"radio","name":"QUERY_TYPE_ID","defaultValue":1010,"options":[{"value":1010,"label":"Starts with"},{"value":1011,"label":"Contains"},{"value":1012,"label":" Word Contains"}]},{"type":"dateRange","name":"CRA_DATE","label":"Registration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}},{"type":"select","name":"STATUS_ID","label":"Status","defaultValue":0,"options":[{"value":0,"label":"All"},{"value":121,"label":"Active"},{"value":122,"label":"Inactive"}]},{"type":"select","name":"AGENT_TYPE_ID","label":"Agent Type","defaultValue":0,"options":[{"value":0,"label":"All"},{"value":460,"label":"Registered Agent"},{"value":461,"label":"Commercial Registered Agent"}]}]},{"label":"Farm Bill","component":"FarmBill","parameter":"farm-bill","path":"/lists/farm-bill","sourceTypeId":0,"myRecordsSearch":false,"allowedRules":["/search/"],"disabled":true,"searchDescription":"To perform a search, enter a debtor name. Your search results may include: exact debtor name, variations of that name and any filing that includes your search criteria. Punctuation is ignored.\n\nYou can click on \"Advanced\" to refine your search. Under “Advanced” you can search by crop, year, county and SSN/FEIN. As a registered Farm Bill Buyer with the Montana Secretary of State’s office it is important to maintain the confidentiality of the information contained within the Farm Bill Master List. The Farm Bill Master List reflects personal data, such as Social Security Numbers, which are a key piece of personal identifiable information to assist you in determining the existence of a lien against a specific debtor. The distribution of this information beyond its intended purpose is strictly prohibited.\n\nThe debtor's tax identification number has been hidden for confidentiality reasons. You may continue to search on a tax ID number and return debtors that match your search criteria. The SSN/FEIN must be entered without dashes or spaces.","searchMustHaveOneOf":["search","UCC_FARM_PRODUCT_ID","COUNTY"],"searchPlaceholder":"Search by debtor name","advancedSearchParameters":[{"type":"ServerMultiComplete","label":"Product code name(s)","name":"UCC_FARM_PRODUCT_ID","defaultValue":"","optionsSrc":"UCC_FARM_PRODUCT_V"},{"type":"MultiComplete","label":"Year or Range of Years","name":"YEAR_NUM","optionsSrc":"years","startYear":"1968","defaultValue":[],"preMergeOptions":[{"value":"ALL","label":"All"}]},{"type":"serverSelect","label":"State","name":"STATE","defaultValue":"MONTANA","optionsSrc":"STATE"},{"type":"ServerMultiComplete","label":"County","name":"COUNTY","defaultValue":[],"optionsSrc":"COUNTY","overrideSubOptionsSrcFromParameterName":"STATE"},{"type":"checkbox","name":"TIN_SEARCH_YN","defaultValue":false,"label":"Tax Identification Number Search"},{"type":"checkbox","name":"TIN_SORT_YN","defaultValue":false,"label":"Unique ID Sort"}]}],"SYSTEM_NICKNAME":"Online Services Portal","PAYMENT_METHODS":[{"type":"bypass"},{"type":"iTransact"}],"PAYMENT_ALLOW_AMEX":true,"SYSTEM_ID_LABEL":"System Id","DOUBLE_COLUMN_PUBLIC_LOGIN":true,"INTERNAL_USER_MANAGEMENT":true,"ALLOW_PUBLIC_JSON_IMPORT":false,"MAX_FILE_UPLOAD_SIZE":10000000,"REFUND_TEXT":"","RETURN_TO_HOME_ON_LOGOUT":true,"CURRENT_SOS_NAME":"Christi Jacobsen","LOGO_FILENAME":"mt-sos-logo.png","LOGO_ALT":"Christi Jacobsen, Montana Secretary of State","LOGO_FULL_WIDTH":true,"HOME_HIDE_AUTH_HINT":true,"HOME_TITLE":"Montana Secretary of State","CUSTOM_TAB_TITLE":"Official Montana","HOME_SUBTITLE":"Online Business Services","ENTITY_NAME_CONSENT_DESCRIPTION":"","ALLOW_USER_PROFILE_EDITING":true,"COMPARE_FOREIGN_NAME_IN_ENTITY_NAME_VALIDATION":true,"FOREIGN_NAME_FIELD_NAME":"KIMA_PARENT_NAME_INFO","LOGIN_TITLE":"Montana Secretary of State Online Filing Portal Login","PUBLIC_LOGIN_LABEL":"Username","REVERSE_LOGIN_COLUMNS":true,"LOGIN_SEAL_FILENAME":"seal_white.png","SEPARATE_USERNAME_AND_EMAIL":true,"CREATE_ACCOUNT_BUTTON_ALIGN_LEFT":true,"CREATE_ACCOUNT_BUTTON_TEXT":"CREATE AN ACCOUNT","PASSWORD_CUSTOM_ERROR_TEXT":"The password must meet all requirements","ACCOUNT_CREATED_MESSAGE":"Please check your email to verify your account to login and allow a few minutes for this message to arrive. Check your junk/spam folders if you do not find the email in your inbox.","PUBLIC_LOGIN_PLACEHOLDER":" ","DISABLE_DEFAULT_PAYMENT_RADIO":true,"CUSTOM_RESET_PASSWORD_ERROR_MESSAGE":"Username invalid - no account found","PUBLIC_LOGIN_CREATE_DESCRIPTION":"### Existing User:\n\n  - Enter your username and password to login.  \n\n\n  #### - OR -  \n\n\n\n  - Forgot password? Click 'Reset Password' and follow the prompts.\n  - Forgot username? Click 'Forgot Username' and follow the prompts.  \n\n\n  ### New User:\n  ","LOGIN_HELP_LINK":"https://sosmt.gov/business/how-do-i/","LOGIN_HELP_LINK_TEXT":"Need Help?","FORGOT_USERNAME_TEXT":"Forgot Username?","LOGIN_ACTIVE_DIRECTORY_TEXT":"State User Login","MULTIPLE_LOGIN_METHODS":true,"HAS_ACTIVE_DIRECTORY_LOGIN":true,"RESET_PASSWORD_WITH_USERNAME":true,"DOWNLOAD_LINK":true,"SHOW_USERNAME_ACCOUNT_CREATE":true,"SHOW_SCROLL_DOWN_ARROW":true,"SHOW_ADDRESS_ACCOUNT_CREATE":true,"TWO_COLUMN_ACCOUNT_CREATE":true,"RESET_PASSWORD_TIP":"A link to change your password has been sent to your email. Please allow a few minutes for this message to arrive. Please check your junk/spam folders if you do not find the email in your inbox.","FORGOT_PASSWORD_LINK_TEXT":"Reset Password","PHONE_NUMBER_OPTIONAL_ACCOUNT_CREATE":true,"SHOW_REQUIRED_INDICATOR_ACCOUNT_CREATE":true,"PASSWORD_REQUIREMENTS_ACCOUNT_CREATE":"\n    <ul>\n      <li>MUST contain at least 8 characters (12+ recommended)</li>\n      <li>MUST contain at least one uppercase letter.</li>\n      <li>MUST contain at least one lowercase letter.</li>\n      <li>MUST contain at least one number.</li>\n      <li>MUST contain at least one special character (!”#$%&'()*+,-./:;<=>?</li>\n    </ul>\n  ","ALLOW_CERTIFICATION_REQUEST":true,"ALLOW_PUBLIC_CERTIFICATE_REQUEST":true,"ALLOW_COPY_REQUEST":false,"ALLOW_CORRECTION_STYLING":true,"HIDE_DEPRECATION_WARNING":false,"AMEND_ROUTE_PUBLIC":true,"SEAL_FILENAME":"seal.png","SHOPPING_CART":true,"ALLOW_PAYMENT_UPDATE_WITH_EMPTY_CART":true,"RA_EMAIL":true,"RA_WEBSITE":true,"RA_NO_DEFAULT_TYPE":true,"RA_ADDRESS_LABEL":"Street Address","RA_TYPE_SELECTION_DEFAULT":true,"RA_DEFAULT_TYPE":"460","RA_OVERRIDE_TYPE_WITH_DEFAULT":true,"RA_PRINCIPAL_ADDRESS_AMS":true,"UPLOAD_AND_SUBMIT_HIDE_IF_ONE_OPTION":true,"PAYMENT_PROCESSING_MESSAGE":"Your payment is processing - Do not close your browser or click the back button","CHECKOUT_BUTTON_WHEN_PROCESSING_TEXT":"Processing","EFS_CROP_PICKER_NONE_LABEL":"Lien Duration","DISALLOWED_WIZARD_PIECES":["FormationLocale"],"REPEATER_SHOW_EDIT_BUTTON":true,"DATA_REQUEST_PAGE_TITLE":"Data Requests and Subscriptions","DATA_REQUEST_SIDEBAR_LABEL":"Data Requests & Subscriptions","LOGIN_REDIRECTS_TO_EPASS":false,"LOGIN_REDIRECTS_TO_ACTIVE_DIRECTORY":true,"LOGIN_ACTIVE_DIRECTORY_LINK":true,"FETCH_EDIT_USER_LINK":false,"LISTS_FETCH_AVAILABLE_LISTS":true,"POST_WIZARD_SUBMIT_REDIRECT_URL":"/","PIN_REQUEST_ATTESTATIONS":true,"PIN_REQUEST_DESCRIPTION":"Click **Request PIN** to have a new PIN sent to the account holder's email address on file.","OWNERSHIP_REQUEST_DESCRIPTION":"To become an **authorized user** of this record, a current **AUTHORIZED USER** will need to grant you access. To request access, click **Request Access** below.","PIN_REQUEST_SUCCESS_MESSAGE":"The PIN you have requested for this entity has been sent to the email associated with your user account.  You should receive the PIN in approximately 3-5 minutes, depending on your email service provider.","APOSTILLE_HEADER_LABEL":"Verification Information","APOSTILLE_NUMBER_LABEL":"Apostille/Authentication","APOSTILLE_CITY_STATE_OVERRIDE":"HELENA, MT","APOSTILLE_FILING_DATE_LABEL":"Issue Date","APOSTILLE_CITY_STATE_IN_CERTIFIED":true,"NOTARY_EXISTING_FILING":true,"ALLOW_REVOKE_OWN_ACCESS_ONLY":false,"HIDE_CANCEL_ON_ONETIME_DATA_REQUESTS":true,"DATA_REQUESTS_IN_SHOPPING_CART":true,"WQ_ALLOW_EDIT_PENDING_PAYMENT":true,"WQ_CONFIRM_ON_DELETE":true,"WQ_DELETE_CONFIRM_MESSAGE":"Deleting this filing will forfeit any money already paid to the Secretary of State. This action is permanent and cannot be undone, are you sure you would like to delete?","PASS_ITEM_GUIDS_ON_CHECKOUT":true,"FORM_REVISION_HISTORY":true,"CHECKOUT_DISCLAIMER":"By entering your credit card and/or checking account information you (i) state that **you are an authorized user** of the credit card and/or electronic check and that the associated information entered (e.g., account holder name, account number, billing address) is accurate, (ii) **you authorize payment processor to charge the amount you have requested** to your credit card and/or funding account, and (iii) **acknowledge if a charge is declined or reversed you may also be assessed a customary charge** by the payment processor for such transactions.","FARM_BILL_SEARCH_CONFIDENTIAL":"As a registered Farm Bill Buyer with the Montana Secretary of State’s office it is important to maintain the confidentiality of the information contained within the Farm Bill Master List. The Farm Bill Master List reflects personal data, such as Social Security Numbers, which are a key piece of personal identifiable information to assist you in determining the existence of a lien against a specific debtor. The distribution of this information beyond its intended purpose is strictly prohibited.\n\n**The debtor's tax identification number has been hidden for confidentiality reasons. You may continue to search on a tax ID number and return debtors that match your search criteria. The SSN/FEIN must be entered without dashes or spaces.  If you need access to the tax identification number to clearly identify the debtor, please contact the UCC unit at (406) 444-3665.**","VIEW_HISTORY_BUTTON_ALT_TEXT":"View Filings","WIZARD_ERROR_TITLE_MESSAGE":"Form Error","FARM_BILL_SEARCH_INTERACTIVE":true,"USE_FARM_BILL_API":true,"DISALLOW_ASSIGN_SELF_AS_RA":true,"DISALLOW_ASSIGN_SELF_AS_PRINCIPAL":true,"USE_TRADEMARK_OWNER_VALIDATION":true,"USE_ALTERNATIVE_FOREIGN_ADDRESS_LABELS":true,"MY_RECEIPTS_FILTER":[{"type":"dateRange","name":"DATE_RANGE","label":"Date range","defaultValue":{"start":null,"end":null}},{"type":"text","name":"REF_NUM","defaultValue":"","label":"Reference Number"},{"type":"text","name":"RECEIPT_NUM","defaultValue":"","label":"Receipt Id"},{"type":"text","name":"AMOUNT","defaultValue":"","label":"Amount"},{"type":"select","name":"TYPE","defaultValue":"","label":"Payment Type","options":[{"value":"","label":"All"},{"value":"CC","label":"Credit Card"},{"value":"Check","label":"Check"}]}],"MY_RECEIPTS_SHOW_IN_SIDEBAR":true,"SHOW_MY_RECEIPTS_HELPER_TEXT":true,"MY_RECEIPTS_HELPER_LABEL":"About Receipt Search","MY_RECEIPTS_HELPER_TEXT":"You can search for receipts based on their descriptions, including the items paid for on the receipt. Use the filters to search for or filter specific information.","FARM_BILL_SUBLINK":{"label":"Farm Bill","component":"FarmBill","parameter":"farm-bill","path":"/lists/farm-bill","sourceTypeId":0,"myRecordsSearch":false,"allowedRules":["/search/"],"disabled":true,"searchDescription":"To perform a search, enter a debtor name. Your search results may include: exact debtor name, variations of that name and any filing that includes your search criteria. Punctuation is ignored.\n\nYou can click on \"Advanced\" to refine your search. Under “Advanced” you can search by crop, year, county and SSN/FEIN. As a registered Farm Bill Buyer with the Montana Secretary of State’s office it is important to maintain the confidentiality of the information contained within the Farm Bill Master List. The Farm Bill Master List reflects personal data, such as Social Security Numbers, which are a key piece of personal identifiable information to assist you in determining the existence of a lien against a specific debtor. The distribution of this information beyond its intended purpose is strictly prohibited.\n\nThe debtor's tax identification number has been hidden for confidentiality reasons. You may continue to search on a tax ID number and return debtors that match your search criteria. The SSN/FEIN must be entered without dashes or spaces.","searchMustHaveOneOf":["search","UCC_FARM_PRODUCT_ID","COUNTY"],"searchPlaceholder":"Search by debtor name","advancedSearchParameters":[{"type":"ServerMultiComplete","label":"Product code name(s)","name":"UCC_FARM_PRODUCT_ID","defaultValue":"","optionsSrc":"UCC_FARM_PRODUCT_V"},{"type":"MultiComplete","label":"Year or Range of Years","name":"YEAR_NUM","optionsSrc":"years","startYear":"1968","defaultValue":[],"preMergeOptions":[{"value":"ALL","label":"All"}]},{"type":"serverSelect","label":"State","name":"STATE","defaultValue":"MONTANA","optionsSrc":"STATE"},{"type":"ServerMultiComplete","label":"County","name":"COUNTY","defaultValue":[],"optionsSrc":"COUNTY","overrideSubOptionsSrcFromParameterName":"STATE"},{"type":"checkbox","name":"TIN_SEARCH_YN","defaultValue":false,"label":"Tax Identification Number Search"},{"type":"checkbox","name":"TIN_SORT_YN","defaultValue":false,"label":"Unique ID Sort"}]},"ALLOW_ADDRESS_VALIDATION_BYPASS_OPTION":true,"DEFAULT_ADDRESS_VALIDATION_BYPASS_OPTION_CHECKED":true}).DATA_REQUEST_ALWAYS_SHOW_IN_SIDEBAR || false,
	  allowedUserGroups: ['ADMIN_WEB', 'WEB']
	  // subLinks: constructSubroutes('/data-requests/')
	}] : []), [{
	  label: 'Forms Manager',
	  title: 'Forms Manager',
	  includeInSidebar: true,
	  icon: _react2.default.createElement(_documentClone2.default, null),
	  component: _FormManager2.default,
	  exact: true,
	  linkExact: false,
	  path: '/forms-manager/:category?',
	  link: '/forms-manager',
	  subLinks: constructSubroutes('/forms-manager/'),
	  authOnly: true,
	  allowedUserGroups: ['ADMIN', 'ADMIN_WEB']
	}, {
	  label: 'Form Designer',
	  title: 'Edit',
	  includeInSidebar: false,
	  icon: _react2.default.createElement(_documentClone2.default, null),
	  component: _DeferredDesigner2.default,
	  path: '/forms-manager/edit/:formDefinitionId',
	  link: '/forms-manager/edit/0',
	  subLinks: [],
	  collapseSidebar: true,
	  authOnly: true,
	  allowedUserGroups: ['ADMIN', 'ADMIN_WEB']
	}], _toConsumableArray(ADDITIONAL_ROUTES.systemAdministration !== undefined ? [{
	  label: 'System Administration',
	  title: 'System Administration',
	  includeInSidebar: true,
	  icon: _react2.default.createElement(_gears2.default, null),
	  component: _SystemAdmin2.default,
	  path: '/system-admin/:parameter?',
	  link: '/system-admin',
	  subLinks: [],
	  authOnly: true,
	  allowedUserGroups: ['ADMIN', 'ADMIN_WEB']
	}] : []), [{
	  label: 'Receipt',
	  title: 'Payment Successful',
	  includeInSidebar: false,
	  iconClass: '',
	  component: _ReceiptPage2.default,
	  path: '/receipt',
	  link: '/receipt',
	  subLinks: []
	  // authOnly: true
	}, {
	  label: 'Signatures Manager',
	  title: 'Signatures Manager',
	  includeInSidebar: false,
	  iconClass: '',
	  component: _ManageSignatures2.default,
	  path: '/signatures/:groupToken',
	  link: '/signatures/:groupToken',
	  subLinks: []
	}, {
	  label: 'PaymentCallback',
	  title: 'Processing Payment',
	  includeInSidebar: false,
	  iconClass: '',
	  component: _PaymentCallback2.default,
	  path: '/processpayment/:method',
	  link: '/processpayment',
	  subLinks: []
	  // authOnly: true
	}, {
	  label: 'Payment Error',
	  title: 'Error Processing Payment',
	  includeInSidebar: false,
	  component: _Error2.default,
	  path: '/paymenterror/:method',
	  link: '/paymenterror/:method',
	  subLinks: [],
	  authOnly: false
	}, {
	  label: 'Draft',
	  title: 'Draft',
	  includeInSidebar: false,
	  iconClass: '',
	  component: _Wizard.DraftEditor,
	  path: '/draft/:draftId',
	  link: '/draft',
	  subLinks: [],
	  authOnly: true,
	  allowedUserGroups: ['ADMIN_WEB', 'WEB']
	}, {
	  label: 'Correction',
	  title: 'Correction',
	  includeInSidebar: false,
	  iconClass: '',
	  component: _Wizard.CorrectionEditor,
	  path: '/correct/:formDefinitionId/:amendmentNum',
	  link: '/correct',
	  subLinks: [],
	  authOnly: true,
	  allowedUserGroups: ['ADMIN_WEB', 'WEB']
	}, {
	  label: 'Amend',
	  title: 'Amend',
	  includeInSidebar: false,
	  iconClass: '',
	  component: _Wizard.AmendmentEditor,
	  path: '/amend/:formDefinitionId/:amendmentNum',
	  link: '/amend',
	  subLinks: [],
	  authOnly:  true ? false : true,
	  allowedUserGroups: ['ADMIN_WEB', 'WEB']
	}, {
	  label: 'ChangePassword',
	  includeInSidebar: false,
	  iconClass: '',
	  component: _ChangePassword2.default,
	  path: '/passwordreset',
	  link: '/passwordreset',
	  subLinks: [],
	  authOnly: false
	}, {
	  label: 'VerifyEmailAddress',
	  includeInSidebar: false,
	  iconClass: '',
	  component: _VerifyEmailAddress2.default,
	  path: '/emailVerification',
	  link: '/emailVerification',
	  subLinks: [],
	  authOnly: false
	}, {
	  label: 'LoginRedirector',
	  title: 'Login',
	  includeInSidebar: false,
	  iconClass: '',
	  component:  false ? _EpassRedirector2.default : ({"NODE_ENV":"production","BUILD_DATE":"2025-08-27T15:15:31.687Z","BUILD_NUMBER":"Not Provided","GIT_VERSION":"v1.3.0-381-ga81e29b08","GIT_COMMIT_HASH":"a81e29b085c9268ffd96c78eb734365802722741","GIT_BRANCH":"beta","PUBLIC_URL":"","STATE_ABBR":"MT","STATE_NAME":"Montana","STATE_ORG_TITLE":"Secretary of State","LOGIN_HEADER_IMG_PATH":"","HOME_IMG_FILENAME":"montana.jpg","FAVICON_FILE_NAME":"favicon.ico","ALLOW_E_SIGN_ON_CORRECTIONS":true,"THIRD_PARTY_SIGNING_ALLOWED":false,"MY_ACCOUNT_SAVE_AND_CLOSE_BUTTON":true,"IE_DEPRECATED_MESSAGE":"Internet Explorer is not supported. Please select a supported browser below to access this website.","ADDITIONAL_ROUTES":{"dataRequests":true,"farmBill":true,"apostille":true,"externalHelp":"https://sosmt.gov/business/help-center/","systemAdministration":[{"title":"Saved Payments","parameter":"saved-payments","componentName":"SavedPayments"}]},"SUBROUTES":[{"label":"Business","component":"Business","parameter":"business","myWorkQueueSearch":false,"sourceTypeId":54,"searchMustHaveOneOf":["FILING_TYPE_ID","STATUS_ID","STATE","search"],"serverWebSearchDescription":true,"serverWorkQueueDescription":true,"serverMyRecordsDescription":true,"searchPlaceholder":"Search by name or filing number (X########)","allowEmptySearchTerm":true,"requestCertificateAlternateLabel":"Request Information","fileAmendmentButtonLabel":"Filing Actions","advancedSearchParameters":[{"type":"radio","name":"QUERY_TYPE_ID","defaultValue":1010,"options":[{"value":1010,"label":"Starts with"},{"value":1011,"label":"Contains"},{"value":1012,"label":" Word Contains"}]},{"type":"serverSelect","name":"FILING_TYPE_ID","optionsSrc":"FILING_TYPES","label":"Entity Type","placeholder":"All","defaultValue":"0"},{"type":"serverSelect","name":"FILING_SUBTYPE_ID","optionsSrc":"FILING_SUBTYPES","label":"Entity Subtype","overrideSubOptionsSrcFromParameterName":"FILING_TYPE_ID","placeholder":"All","defaultValue":"0"},{"type":"serverSelect","name":"STATUS_ID","optionsSrc":"FILING_STATUS_WITHOUT_ALL","label":"Status","placeholder":"All","defaultValue":"0"},{"type":"serverSelect","name":"STATE","optionsSrc":"STATE","label":"State","placeholder":"All","defaultValue":""},{"type":"serverSelect","name":"COUNTY","optionsSrc":"COUNTY_SUBOPTION","label":"County","overrideSubOptionsSrcFromParameterName":"STATE","placeholder":"All","defaultValue":""},{"type":"checkbox","name":"CRA_SEARCH_YN","defaultValue":false,"label":"Search by Registered Agent PID"},{"type":"dateRange","name":"FILING_DATE","label":"Registration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}},{"type":"dateRange","name":"EXPIRATION_DATE","label":"Expiration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}}],"myRecordsFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Active"},{"value":2,"label":"Inactive"},{"value":3,"label":"Pending"}]},{"type":"dateRange","name":"DATE_RANGE","label":"Date range","defaultValue":{"start":null,"end":null}}],"myWorkQueueFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Approved"},{"value":2,"label":"Pending Online Payment"},{"value":3,"label":"Pending Review"},{"value":4,"label":"Needs Correction"},{"value":5,"label":"Rejected"},{"value":6,"label":"Draft"}]},{"type":"dateRange","name":"DATE_RANGE","label":"Date range","defaultValue":{"start":null,"end":null}}]},{"label":"Notary","component":"Notary","parameter":"notary","sourceTypeId":850,"myWorkQueueSearch":false,"allowEmptySearchTerm":true,"requestCertificateAlternateLabel":"Download Certificate","fileAmendmentButtonLabel":"Filing Actions","hideNameRequestCertificate":true,"hideAddressRequestCertificate":true,"hideRecordUserManagment":true,"searchPlaceholder":"Search by name or commission number","searchMustHaveOneOf":["CITY","search","SERVICE_TYPE"],"advancedParametersStartOpen":true,"searchIsSortable":true,"advancedSearchParameters":[{"type":"radio","name":"STARTS_WITH_YN","defaultValue":false,"options":[{"value":true,"label":"Starts with"},{"value":false,"label":"Contains"}]},{"type":"checkbox","name":"ACTIVE_ONLY_YN","defaultValue":true,"label":"Active entities only"},{"type":"text","name":"CITY","defaultValue":"","label":"City"},{"type":"select","name":"SERVICE_TYPE","label":"Special Services Offered","defaultValue":0,"options":[{"value":0,"label":"(N/A)"},{"value":6165,"label":"In-Person Electronic Notarization (IPEN)"},{"value":6166,"label":"Remote Online Notarization (RON)"},{"value":6167,"label":"Mobile Notary Services"},{"value":6168,"label":"Remote Ink Notarization (RIN)"}]}]},{"label":"Apostille","component":"Apostille","parameter":"apostille","sourceTypeId":720,"myRecordsSearch":false,"myWorkQueueSearch":false,"disabled":false,"allowedRoutes":["/forms-manager/","/queue/","/forms/"]},{"label":"Liens","component":"UCC","parameter":"ucc","sourceTypeId":1999,"myRecordsSearch":true,"myWorkQueueSearch":true,"fileAmendmentButtonLabel":"Filing Actions","searchPlaceholder":"Search by name or file number","disabled":false,"serverWebSearchDescription":true,"myRecordsDescription":"","workQueueDescription":"","searchDescription":"","hideRecordUserManagment":true,"searchLiensCheckout":false,"advancedSearchParameters":[{"type":"radio","name":"STARTS_WITH_YN","defaultValue":false,"options":[{"value":true,"label":"Starts with"},{"value":false,"label":"Contains"}]},{"type":"select","name":"STATUS","defaultValue":"ALL","label":"Status","options":[{"value":"ACTIVE_UNLAPSED","label":"Active (unlapsed)"},{"value":"ACTIVE_LAPSED_UNLAPSED","label":"Active (lapsed and unlapsed)"}]},{"type":"text","name":"EXCLUDE_VALUES","label":"Exclude Debtor Names (comma separated list of names to exclude)","defaultValue":""},{"type":"dateRange","name":"FILING_DATE","label":"Financing Statement Date","defaultValue":{"start":null,"end":null}},{"type":"dateRange","name":"LAPSE_DATE","label":"Lapse Date","defaultValue":{"start":null,"end":null}},{"type":"text","name":"CITY","label":"Debtor City","defaultValue":""}],"myRecordsFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Approved"},{"value":2,"label":"Pending Online Payment"},{"value":3,"label":"Pending Review"}]},{"type":"select","name":"TYPE","defaultValue":0,"label":"Lien Type","options":[{"value":0,"label":"All"},{"value":1,"label":"UCC"},{"value":2,"label":"EFS"},{"value":3,"label":"Title 71"}]}],"myWorkQueueFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Approved"},{"value":2,"label":"Pending Online Payment"},{"value":3,"label":"Pending Review"},{"value":4,"label":"Pending Print and Mail"},{"value":5,"label":"Rejected"},{"value":6,"label":"Draft"}]},{"type":"select","name":"TYPE","defaultValue":0,"label":"Lien Type","options":[{"value":0,"label":"All"},{"value":1,"label":"UCC"},{"value":2,"label":"EFS"},{"value":3,"label":"Title 71"}]}]},{"label":"Copy Request","component":"copies","parameter":"copies","sourceTypeId":2001,"myRecordsSearch":false,"myWorkQueueSearch":false,"disabled":false,"allowedRoutes":["/forms-manager/","/queue/","/forms/"]},{"label":"Trademark","component":"Trademark","parameter":"trademark","sourceTypeId":810,"showRequestCertificate":true,"searchMustHaveOneOf":["search","EXPIRATION_DATE","FILING_DATE"],"allowEmptySearchTerm":true,"requestCertificateAlternateLabel":"Request Information","fileAmendmentButtonLabel":"Filing Actions","advancedSearchParameters":[{"type":"radio","name":"QUERY_TYPE_ID","defaultValue":1010,"options":[{"value":1010,"label":"Starts with"},{"value":1011,"label":"Contains"},{"value":1012,"label":" Word Contains"}]},{"type":"checkbox","name":"OWNER_SEARCH_YN","defaultValue":false,"label":"Search owners"},{"type":"radio","name":"SERVICE_MARK_YN","label":"Mark Type","defaultValue":"","options":[{"value":"","label":"All Marks"},{"value":"Y","label":"Service Mark"},{"value":"N","label":"Trademark"}]},{"type":"serverSelect","name":"STATUS_ID","optionsSrc":"TYPE_V|TRADEMARK_STATUS_TYPE","label":"Status","placeholder":"All","defaultValue":"0"},{"type":"select","name":"DESIGN_TYPE_ID","options":[{"value":0,"label":"All"},{"value":990,"label":"Words Only"},{"value":991,"label":"Design Only"},{"value":992,"label":"Words and Design"}],"label":"Design Type","defaultValue":"0"},{"type":"dateRange","name":"FILING_DATE","label":"Registered Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}},{"type":"dateRange","name":"EXPIRATION_DATE","label":"Expiration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}}]},{"label":"Business Info Request","component":"InfoRequests","parameter":"info-request","sourceTypeId":167,"allowedRoutes":["/forms-manager/","/queue/","/forms/"]},{"label":"Data Requests","component":"DataRequests","parameter":"data-request","sourceTypeId":0,"allowedRoutes":["/forms-manager/"]},{"label":"CRA","component":"CRA","parameter":"cra","sourceTypeId":157,"myRecordsSearch":false,"searchPlaceholder":"Search by name or registered agent number","allowedRoutes":["/forms-manager/","/forms/","/records/","/queue/","/search/"],"allowEmptySearchTerm":true,"fileAmendmentButtonLabel":"Filing Actions","advancedSearchParameters":[{"type":"radio","name":"QUERY_TYPE_ID","defaultValue":1010,"options":[{"value":1010,"label":"Starts with"},{"value":1011,"label":"Contains"},{"value":1012,"label":" Word Contains"}]},{"type":"dateRange","name":"CRA_DATE","label":"Registration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}},{"type":"select","name":"STATUS_ID","label":"Status","defaultValue":0,"options":[{"value":0,"label":"All"},{"value":121,"label":"Active"},{"value":122,"label":"Inactive"}]},{"type":"select","name":"AGENT_TYPE_ID","label":"Agent Type","defaultValue":0,"options":[{"value":0,"label":"All"},{"value":460,"label":"Registered Agent"},{"value":461,"label":"Commercial Registered Agent"}]}]},{"label":"Farm Bill","component":"FarmBill","parameter":"farm-bill","path":"/lists/farm-bill","sourceTypeId":0,"myRecordsSearch":false,"allowedRules":["/search/"],"disabled":true,"searchDescription":"To perform a search, enter a debtor name. Your search results may include: exact debtor name, variations of that name and any filing that includes your search criteria. Punctuation is ignored.\n\nYou can click on \"Advanced\" to refine your search. Under “Advanced” you can search by crop, year, county and SSN/FEIN. As a registered Farm Bill Buyer with the Montana Secretary of State’s office it is important to maintain the confidentiality of the information contained within the Farm Bill Master List. The Farm Bill Master List reflects personal data, such as Social Security Numbers, which are a key piece of personal identifiable information to assist you in determining the existence of a lien against a specific debtor. The distribution of this information beyond its intended purpose is strictly prohibited.\n\nThe debtor's tax identification number has been hidden for confidentiality reasons. You may continue to search on a tax ID number and return debtors that match your search criteria. The SSN/FEIN must be entered without dashes or spaces.","searchMustHaveOneOf":["search","UCC_FARM_PRODUCT_ID","COUNTY"],"searchPlaceholder":"Search by debtor name","advancedSearchParameters":[{"type":"ServerMultiComplete","label":"Product code name(s)","name":"UCC_FARM_PRODUCT_ID","defaultValue":"","optionsSrc":"UCC_FARM_PRODUCT_V"},{"type":"MultiComplete","label":"Year or Range of Years","name":"YEAR_NUM","optionsSrc":"years","startYear":"1968","defaultValue":[],"preMergeOptions":[{"value":"ALL","label":"All"}]},{"type":"serverSelect","label":"State","name":"STATE","defaultValue":"MONTANA","optionsSrc":"STATE"},{"type":"ServerMultiComplete","label":"County","name":"COUNTY","defaultValue":[],"optionsSrc":"COUNTY","overrideSubOptionsSrcFromParameterName":"STATE"},{"type":"checkbox","name":"TIN_SEARCH_YN","defaultValue":false,"label":"Tax Identification Number Search"},{"type":"checkbox","name":"TIN_SORT_YN","defaultValue":false,"label":"Unique ID Sort"}]}],"SYSTEM_NICKNAME":"Online Services Portal","PAYMENT_METHODS":[{"type":"bypass"},{"type":"iTransact"}],"PAYMENT_ALLOW_AMEX":true,"SYSTEM_ID_LABEL":"System Id","DOUBLE_COLUMN_PUBLIC_LOGIN":true,"INTERNAL_USER_MANAGEMENT":true,"ALLOW_PUBLIC_JSON_IMPORT":false,"MAX_FILE_UPLOAD_SIZE":10000000,"REFUND_TEXT":"","RETURN_TO_HOME_ON_LOGOUT":true,"CURRENT_SOS_NAME":"Christi Jacobsen","LOGO_FILENAME":"mt-sos-logo.png","LOGO_ALT":"Christi Jacobsen, Montana Secretary of State","LOGO_FULL_WIDTH":true,"HOME_HIDE_AUTH_HINT":true,"HOME_TITLE":"Montana Secretary of State","CUSTOM_TAB_TITLE":"Official Montana","HOME_SUBTITLE":"Online Business Services","ENTITY_NAME_CONSENT_DESCRIPTION":"","ALLOW_USER_PROFILE_EDITING":true,"COMPARE_FOREIGN_NAME_IN_ENTITY_NAME_VALIDATION":true,"FOREIGN_NAME_FIELD_NAME":"KIMA_PARENT_NAME_INFO","LOGIN_TITLE":"Montana Secretary of State Online Filing Portal Login","PUBLIC_LOGIN_LABEL":"Username","REVERSE_LOGIN_COLUMNS":true,"LOGIN_SEAL_FILENAME":"seal_white.png","SEPARATE_USERNAME_AND_EMAIL":true,"CREATE_ACCOUNT_BUTTON_ALIGN_LEFT":true,"CREATE_ACCOUNT_BUTTON_TEXT":"CREATE AN ACCOUNT","PASSWORD_CUSTOM_ERROR_TEXT":"The password must meet all requirements","ACCOUNT_CREATED_MESSAGE":"Please check your email to verify your account to login and allow a few minutes for this message to arrive. Check your junk/spam folders if you do not find the email in your inbox.","PUBLIC_LOGIN_PLACEHOLDER":" ","DISABLE_DEFAULT_PAYMENT_RADIO":true,"CUSTOM_RESET_PASSWORD_ERROR_MESSAGE":"Username invalid - no account found","PUBLIC_LOGIN_CREATE_DESCRIPTION":"### Existing User:\n\n  - Enter your username and password to login.  \n\n\n  #### - OR -  \n\n\n\n  - Forgot password? Click 'Reset Password' and follow the prompts.\n  - Forgot username? Click 'Forgot Username' and follow the prompts.  \n\n\n  ### New User:\n  ","LOGIN_HELP_LINK":"https://sosmt.gov/business/how-do-i/","LOGIN_HELP_LINK_TEXT":"Need Help?","FORGOT_USERNAME_TEXT":"Forgot Username?","LOGIN_ACTIVE_DIRECTORY_TEXT":"State User Login","MULTIPLE_LOGIN_METHODS":true,"HAS_ACTIVE_DIRECTORY_LOGIN":true,"RESET_PASSWORD_WITH_USERNAME":true,"DOWNLOAD_LINK":true,"SHOW_USERNAME_ACCOUNT_CREATE":true,"SHOW_SCROLL_DOWN_ARROW":true,"SHOW_ADDRESS_ACCOUNT_CREATE":true,"TWO_COLUMN_ACCOUNT_CREATE":true,"RESET_PASSWORD_TIP":"A link to change your password has been sent to your email. Please allow a few minutes for this message to arrive. Please check your junk/spam folders if you do not find the email in your inbox.","FORGOT_PASSWORD_LINK_TEXT":"Reset Password","PHONE_NUMBER_OPTIONAL_ACCOUNT_CREATE":true,"SHOW_REQUIRED_INDICATOR_ACCOUNT_CREATE":true,"PASSWORD_REQUIREMENTS_ACCOUNT_CREATE":"\n    <ul>\n      <li>MUST contain at least 8 characters (12+ recommended)</li>\n      <li>MUST contain at least one uppercase letter.</li>\n      <li>MUST contain at least one lowercase letter.</li>\n      <li>MUST contain at least one number.</li>\n      <li>MUST contain at least one special character (!”#$%&'()*+,-./:;<=>?</li>\n    </ul>\n  ","ALLOW_CERTIFICATION_REQUEST":true,"ALLOW_PUBLIC_CERTIFICATE_REQUEST":true,"ALLOW_COPY_REQUEST":false,"ALLOW_CORRECTION_STYLING":true,"HIDE_DEPRECATION_WARNING":false,"AMEND_ROUTE_PUBLIC":true,"SEAL_FILENAME":"seal.png","SHOPPING_CART":true,"ALLOW_PAYMENT_UPDATE_WITH_EMPTY_CART":true,"RA_EMAIL":true,"RA_WEBSITE":true,"RA_NO_DEFAULT_TYPE":true,"RA_ADDRESS_LABEL":"Street Address","RA_TYPE_SELECTION_DEFAULT":true,"RA_DEFAULT_TYPE":"460","RA_OVERRIDE_TYPE_WITH_DEFAULT":true,"RA_PRINCIPAL_ADDRESS_AMS":true,"UPLOAD_AND_SUBMIT_HIDE_IF_ONE_OPTION":true,"PAYMENT_PROCESSING_MESSAGE":"Your payment is processing - Do not close your browser or click the back button","CHECKOUT_BUTTON_WHEN_PROCESSING_TEXT":"Processing","EFS_CROP_PICKER_NONE_LABEL":"Lien Duration","DISALLOWED_WIZARD_PIECES":["FormationLocale"],"REPEATER_SHOW_EDIT_BUTTON":true,"DATA_REQUEST_PAGE_TITLE":"Data Requests and Subscriptions","DATA_REQUEST_SIDEBAR_LABEL":"Data Requests & Subscriptions","LOGIN_REDIRECTS_TO_EPASS":false,"LOGIN_REDIRECTS_TO_ACTIVE_DIRECTORY":true,"LOGIN_ACTIVE_DIRECTORY_LINK":true,"FETCH_EDIT_USER_LINK":false,"LISTS_FETCH_AVAILABLE_LISTS":true,"POST_WIZARD_SUBMIT_REDIRECT_URL":"/","PIN_REQUEST_ATTESTATIONS":true,"PIN_REQUEST_DESCRIPTION":"Click **Request PIN** to have a new PIN sent to the account holder's email address on file.","OWNERSHIP_REQUEST_DESCRIPTION":"To become an **authorized user** of this record, a current **AUTHORIZED USER** will need to grant you access. To request access, click **Request Access** below.","PIN_REQUEST_SUCCESS_MESSAGE":"The PIN you have requested for this entity has been sent to the email associated with your user account.  You should receive the PIN in approximately 3-5 minutes, depending on your email service provider.","APOSTILLE_HEADER_LABEL":"Verification Information","APOSTILLE_NUMBER_LABEL":"Apostille/Authentication","APOSTILLE_CITY_STATE_OVERRIDE":"HELENA, MT","APOSTILLE_FILING_DATE_LABEL":"Issue Date","APOSTILLE_CITY_STATE_IN_CERTIFIED":true,"NOTARY_EXISTING_FILING":true,"ALLOW_REVOKE_OWN_ACCESS_ONLY":false,"HIDE_CANCEL_ON_ONETIME_DATA_REQUESTS":true,"DATA_REQUESTS_IN_SHOPPING_CART":true,"WQ_ALLOW_EDIT_PENDING_PAYMENT":true,"WQ_CONFIRM_ON_DELETE":true,"WQ_DELETE_CONFIRM_MESSAGE":"Deleting this filing will forfeit any money already paid to the Secretary of State. This action is permanent and cannot be undone, are you sure you would like to delete?","PASS_ITEM_GUIDS_ON_CHECKOUT":true,"FORM_REVISION_HISTORY":true,"CHECKOUT_DISCLAIMER":"By entering your credit card and/or checking account information you (i) state that **you are an authorized user** of the credit card and/or electronic check and that the associated information entered (e.g., account holder name, account number, billing address) is accurate, (ii) **you authorize payment processor to charge the amount you have requested** to your credit card and/or funding account, and (iii) **acknowledge if a charge is declined or reversed you may also be assessed a customary charge** by the payment processor for such transactions.","FARM_BILL_SEARCH_CONFIDENTIAL":"As a registered Farm Bill Buyer with the Montana Secretary of State’s office it is important to maintain the confidentiality of the information contained within the Farm Bill Master List. The Farm Bill Master List reflects personal data, such as Social Security Numbers, which are a key piece of personal identifiable information to assist you in determining the existence of a lien against a specific debtor. The distribution of this information beyond its intended purpose is strictly prohibited.\n\n**The debtor's tax identification number has been hidden for confidentiality reasons. You may continue to search on a tax ID number and return debtors that match your search criteria. The SSN/FEIN must be entered without dashes or spaces.  If you need access to the tax identification number to clearly identify the debtor, please contact the UCC unit at (406) 444-3665.**","VIEW_HISTORY_BUTTON_ALT_TEXT":"View Filings","WIZARD_ERROR_TITLE_MESSAGE":"Form Error","FARM_BILL_SEARCH_INTERACTIVE":true,"USE_FARM_BILL_API":true,"DISALLOW_ASSIGN_SELF_AS_RA":true,"DISALLOW_ASSIGN_SELF_AS_PRINCIPAL":true,"USE_TRADEMARK_OWNER_VALIDATION":true,"USE_ALTERNATIVE_FOREIGN_ADDRESS_LABELS":true,"MY_RECEIPTS_FILTER":[{"type":"dateRange","name":"DATE_RANGE","label":"Date range","defaultValue":{"start":null,"end":null}},{"type":"text","name":"REF_NUM","defaultValue":"","label":"Reference Number"},{"type":"text","name":"RECEIPT_NUM","defaultValue":"","label":"Receipt Id"},{"type":"text","name":"AMOUNT","defaultValue":"","label":"Amount"},{"type":"select","name":"TYPE","defaultValue":"","label":"Payment Type","options":[{"value":"","label":"All"},{"value":"CC","label":"Credit Card"},{"value":"Check","label":"Check"}]}],"MY_RECEIPTS_SHOW_IN_SIDEBAR":true,"SHOW_MY_RECEIPTS_HELPER_TEXT":true,"MY_RECEIPTS_HELPER_LABEL":"About Receipt Search","MY_RECEIPTS_HELPER_TEXT":"You can search for receipts based on their descriptions, including the items paid for on the receipt. Use the filters to search for or filter specific information.","FARM_BILL_SUBLINK":{"label":"Farm Bill","component":"FarmBill","parameter":"farm-bill","path":"/lists/farm-bill","sourceTypeId":0,"myRecordsSearch":false,"allowedRules":["/search/"],"disabled":true,"searchDescription":"To perform a search, enter a debtor name. Your search results may include: exact debtor name, variations of that name and any filing that includes your search criteria. Punctuation is ignored.\n\nYou can click on \"Advanced\" to refine your search. Under “Advanced” you can search by crop, year, county and SSN/FEIN. As a registered Farm Bill Buyer with the Montana Secretary of State’s office it is important to maintain the confidentiality of the information contained within the Farm Bill Master List. The Farm Bill Master List reflects personal data, such as Social Security Numbers, which are a key piece of personal identifiable information to assist you in determining the existence of a lien against a specific debtor. The distribution of this information beyond its intended purpose is strictly prohibited.\n\nThe debtor's tax identification number has been hidden for confidentiality reasons. You may continue to search on a tax ID number and return debtors that match your search criteria. The SSN/FEIN must be entered without dashes or spaces.","searchMustHaveOneOf":["search","UCC_FARM_PRODUCT_ID","COUNTY"],"searchPlaceholder":"Search by debtor name","advancedSearchParameters":[{"type":"ServerMultiComplete","label":"Product code name(s)","name":"UCC_FARM_PRODUCT_ID","defaultValue":"","optionsSrc":"UCC_FARM_PRODUCT_V"},{"type":"MultiComplete","label":"Year or Range of Years","name":"YEAR_NUM","optionsSrc":"years","startYear":"1968","defaultValue":[],"preMergeOptions":[{"value":"ALL","label":"All"}]},{"type":"serverSelect","label":"State","name":"STATE","defaultValue":"MONTANA","optionsSrc":"STATE"},{"type":"ServerMultiComplete","label":"County","name":"COUNTY","defaultValue":[],"optionsSrc":"COUNTY","overrideSubOptionsSrcFromParameterName":"STATE"},{"type":"checkbox","name":"TIN_SEARCH_YN","defaultValue":false,"label":"Tax Identification Number Search"},{"type":"checkbox","name":"TIN_SORT_YN","defaultValue":false,"label":"Unique ID Sort"}]},"ALLOW_ADDRESS_VALIDATION_BYPASS_OPTION":true,"DEFAULT_ADDRESS_VALIDATION_BYPASS_OPTION_CHECKED":true}).HAS_OKTA_LOGIN ? OktaRedirector :  true ? _ActiveDirectoryRedirector2.default : _LoginRedirector2.default,
	  path: '/auth/:returnPath?',
	  link: '/auth',
	  subLinks: [],
	  authOnly: false
	}, {
	  label: 'AdminLogin',
	  title: 'Admin Login',
	  includeInSidebar: false,
	  iconClass: '',
	  component: _Login.AdminLoginPage,
	  path: '/admin',
	  link: '/admin',
	  sublinks: [],
	  authOnly: false
	},
	// {
	//   label: "Reset Password",
	//   title: "Reset Password",
	//   includeInSidebar: false,
	//   iconClass: "",
	//   component: ResetPassword,
	//   path: '/passwordreset',
	//   link: '/passwordreset',
	//   sublinks: [],
	//   authOnly: false
	// },
	{
	  label: 'ReadOnlyWizard',
	  includeInSidebar: false,
	  iconClass: '',
	  component: _Wizard.ReadOnlyWizard,
	  path: '/view/:formDefinitionId/:amendmentNum',
	  link: '/view',
	  subLinks: [],
	  authOnly: true,
	  allowedUserGroups: ['ADMIN_WEB', 'WEB']
	}, {
	  label: 'Wizard Migration Tool',
	  title: 'Migrate',
	  includeInSidebar: false,
	  iconClass: '',
	  component: _Migrate2.default,
	  path: '/migrate',
	  link: '/migrate',
	  sublinks: [],
	  authOnly: true,
	  allowedUserGroups: ['ADMIN', 'ADMIN_WEB']
	}, {
	  label: 'Verify Certificates',
	  title: 'Verify Certificates',
	  includeInSidebar: false,
	  iconClass: '',
	  component: _VerifyCertificate2.default,
	  path: '/verifycertificate',
	  link: '/verifycertificate',
	  sublinks: [],
	  authOnly: false
	}, {
	  label: 'Epass Login',
	  title: 'Epass Login',
	  includeInSidebar: false,
	  iconClass: '',
	  component: _EpassCallback2.default,
	  path: '/epass-callback',
	  link: '/epass-callback',
	  sublinks: [],
	  authOnly: false
	}, {
	  label: 'Epass Logout',
	  title: 'Epass Logout',
	  includeInSidebar: false,
	  iconClass: '',
	  component: _EpassLogout2.default,
	  path: '/epass-logout',
	  link: '/epass-logout',
	  sublinks: [],
	  authOnly: false
	}, {
	  label: 'Active Directory Login',
	  title: 'Active Directory Login',
	  includeInSidebar: false,
	  iconClass: '',
	  component: _ActiveDirectoryCallback2.default,
	  path: '/activedirectory-callback',
	  link: '/activedirectory-callback',
	  sublinks: [],
	  authOnly: false
	}, {
	  label: 'Active Directory Logout',
	  title: 'Active Directory Logout',
	  includeInSidebar: false,
	  iconClass: '',
	  component: _ActiveDirectoryLogout2.default,
	  path: '/activedirectory-logout',
	  link: '/activedirectory-logout',
	  sublinks: [],
	  authOnly: false
	}], _toConsumableArray(({"NODE_ENV":"production","BUILD_DATE":"2025-08-27T15:15:31.687Z","BUILD_NUMBER":"Not Provided","GIT_VERSION":"v1.3.0-381-ga81e29b08","GIT_COMMIT_HASH":"a81e29b085c9268ffd96c78eb734365802722741","GIT_BRANCH":"beta","PUBLIC_URL":"","STATE_ABBR":"MT","STATE_NAME":"Montana","STATE_ORG_TITLE":"Secretary of State","LOGIN_HEADER_IMG_PATH":"","HOME_IMG_FILENAME":"montana.jpg","FAVICON_FILE_NAME":"favicon.ico","ALLOW_E_SIGN_ON_CORRECTIONS":true,"THIRD_PARTY_SIGNING_ALLOWED":false,"MY_ACCOUNT_SAVE_AND_CLOSE_BUTTON":true,"IE_DEPRECATED_MESSAGE":"Internet Explorer is not supported. Please select a supported browser below to access this website.","ADDITIONAL_ROUTES":{"dataRequests":true,"farmBill":true,"apostille":true,"externalHelp":"https://sosmt.gov/business/help-center/","systemAdministration":[{"title":"Saved Payments","parameter":"saved-payments","componentName":"SavedPayments"}]},"SUBROUTES":[{"label":"Business","component":"Business","parameter":"business","myWorkQueueSearch":false,"sourceTypeId":54,"searchMustHaveOneOf":["FILING_TYPE_ID","STATUS_ID","STATE","search"],"serverWebSearchDescription":true,"serverWorkQueueDescription":true,"serverMyRecordsDescription":true,"searchPlaceholder":"Search by name or filing number (X########)","allowEmptySearchTerm":true,"requestCertificateAlternateLabel":"Request Information","fileAmendmentButtonLabel":"Filing Actions","advancedSearchParameters":[{"type":"radio","name":"QUERY_TYPE_ID","defaultValue":1010,"options":[{"value":1010,"label":"Starts with"},{"value":1011,"label":"Contains"},{"value":1012,"label":" Word Contains"}]},{"type":"serverSelect","name":"FILING_TYPE_ID","optionsSrc":"FILING_TYPES","label":"Entity Type","placeholder":"All","defaultValue":"0"},{"type":"serverSelect","name":"FILING_SUBTYPE_ID","optionsSrc":"FILING_SUBTYPES","label":"Entity Subtype","overrideSubOptionsSrcFromParameterName":"FILING_TYPE_ID","placeholder":"All","defaultValue":"0"},{"type":"serverSelect","name":"STATUS_ID","optionsSrc":"FILING_STATUS_WITHOUT_ALL","label":"Status","placeholder":"All","defaultValue":"0"},{"type":"serverSelect","name":"STATE","optionsSrc":"STATE","label":"State","placeholder":"All","defaultValue":""},{"type":"serverSelect","name":"COUNTY","optionsSrc":"COUNTY_SUBOPTION","label":"County","overrideSubOptionsSrcFromParameterName":"STATE","placeholder":"All","defaultValue":""},{"type":"checkbox","name":"CRA_SEARCH_YN","defaultValue":false,"label":"Search by Registered Agent PID"},{"type":"dateRange","name":"FILING_DATE","label":"Registration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}},{"type":"dateRange","name":"EXPIRATION_DATE","label":"Expiration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}}],"myRecordsFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Active"},{"value":2,"label":"Inactive"},{"value":3,"label":"Pending"}]},{"type":"dateRange","name":"DATE_RANGE","label":"Date range","defaultValue":{"start":null,"end":null}}],"myWorkQueueFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Approved"},{"value":2,"label":"Pending Online Payment"},{"value":3,"label":"Pending Review"},{"value":4,"label":"Needs Correction"},{"value":5,"label":"Rejected"},{"value":6,"label":"Draft"}]},{"type":"dateRange","name":"DATE_RANGE","label":"Date range","defaultValue":{"start":null,"end":null}}]},{"label":"Notary","component":"Notary","parameter":"notary","sourceTypeId":850,"myWorkQueueSearch":false,"allowEmptySearchTerm":true,"requestCertificateAlternateLabel":"Download Certificate","fileAmendmentButtonLabel":"Filing Actions","hideNameRequestCertificate":true,"hideAddressRequestCertificate":true,"hideRecordUserManagment":true,"searchPlaceholder":"Search by name or commission number","searchMustHaveOneOf":["CITY","search","SERVICE_TYPE"],"advancedParametersStartOpen":true,"searchIsSortable":true,"advancedSearchParameters":[{"type":"radio","name":"STARTS_WITH_YN","defaultValue":false,"options":[{"value":true,"label":"Starts with"},{"value":false,"label":"Contains"}]},{"type":"checkbox","name":"ACTIVE_ONLY_YN","defaultValue":true,"label":"Active entities only"},{"type":"text","name":"CITY","defaultValue":"","label":"City"},{"type":"select","name":"SERVICE_TYPE","label":"Special Services Offered","defaultValue":0,"options":[{"value":0,"label":"(N/A)"},{"value":6165,"label":"In-Person Electronic Notarization (IPEN)"},{"value":6166,"label":"Remote Online Notarization (RON)"},{"value":6167,"label":"Mobile Notary Services"},{"value":6168,"label":"Remote Ink Notarization (RIN)"}]}]},{"label":"Apostille","component":"Apostille","parameter":"apostille","sourceTypeId":720,"myRecordsSearch":false,"myWorkQueueSearch":false,"disabled":false,"allowedRoutes":["/forms-manager/","/queue/","/forms/"]},{"label":"Liens","component":"UCC","parameter":"ucc","sourceTypeId":1999,"myRecordsSearch":true,"myWorkQueueSearch":true,"fileAmendmentButtonLabel":"Filing Actions","searchPlaceholder":"Search by name or file number","disabled":false,"serverWebSearchDescription":true,"myRecordsDescription":"","workQueueDescription":"","searchDescription":"","hideRecordUserManagment":true,"searchLiensCheckout":false,"advancedSearchParameters":[{"type":"radio","name":"STARTS_WITH_YN","defaultValue":false,"options":[{"value":true,"label":"Starts with"},{"value":false,"label":"Contains"}]},{"type":"select","name":"STATUS","defaultValue":"ALL","label":"Status","options":[{"value":"ACTIVE_UNLAPSED","label":"Active (unlapsed)"},{"value":"ACTIVE_LAPSED_UNLAPSED","label":"Active (lapsed and unlapsed)"}]},{"type":"text","name":"EXCLUDE_VALUES","label":"Exclude Debtor Names (comma separated list of names to exclude)","defaultValue":""},{"type":"dateRange","name":"FILING_DATE","label":"Financing Statement Date","defaultValue":{"start":null,"end":null}},{"type":"dateRange","name":"LAPSE_DATE","label":"Lapse Date","defaultValue":{"start":null,"end":null}},{"type":"text","name":"CITY","label":"Debtor City","defaultValue":""}],"myRecordsFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Approved"},{"value":2,"label":"Pending Online Payment"},{"value":3,"label":"Pending Review"}]},{"type":"select","name":"TYPE","defaultValue":0,"label":"Lien Type","options":[{"value":0,"label":"All"},{"value":1,"label":"UCC"},{"value":2,"label":"EFS"},{"value":3,"label":"Title 71"}]}],"myWorkQueueFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Approved"},{"value":2,"label":"Pending Online Payment"},{"value":3,"label":"Pending Review"},{"value":4,"label":"Pending Print and Mail"},{"value":5,"label":"Rejected"},{"value":6,"label":"Draft"}]},{"type":"select","name":"TYPE","defaultValue":0,"label":"Lien Type","options":[{"value":0,"label":"All"},{"value":1,"label":"UCC"},{"value":2,"label":"EFS"},{"value":3,"label":"Title 71"}]}]},{"label":"Copy Request","component":"copies","parameter":"copies","sourceTypeId":2001,"myRecordsSearch":false,"myWorkQueueSearch":false,"disabled":false,"allowedRoutes":["/forms-manager/","/queue/","/forms/"]},{"label":"Trademark","component":"Trademark","parameter":"trademark","sourceTypeId":810,"showRequestCertificate":true,"searchMustHaveOneOf":["search","EXPIRATION_DATE","FILING_DATE"],"allowEmptySearchTerm":true,"requestCertificateAlternateLabel":"Request Information","fileAmendmentButtonLabel":"Filing Actions","advancedSearchParameters":[{"type":"radio","name":"QUERY_TYPE_ID","defaultValue":1010,"options":[{"value":1010,"label":"Starts with"},{"value":1011,"label":"Contains"},{"value":1012,"label":" Word Contains"}]},{"type":"checkbox","name":"OWNER_SEARCH_YN","defaultValue":false,"label":"Search owners"},{"type":"radio","name":"SERVICE_MARK_YN","label":"Mark Type","defaultValue":"","options":[{"value":"","label":"All Marks"},{"value":"Y","label":"Service Mark"},{"value":"N","label":"Trademark"}]},{"type":"serverSelect","name":"STATUS_ID","optionsSrc":"TYPE_V|TRADEMARK_STATUS_TYPE","label":"Status","placeholder":"All","defaultValue":"0"},{"type":"select","name":"DESIGN_TYPE_ID","options":[{"value":0,"label":"All"},{"value":990,"label":"Words Only"},{"value":991,"label":"Design Only"},{"value":992,"label":"Words and Design"}],"label":"Design Type","defaultValue":"0"},{"type":"dateRange","name":"FILING_DATE","label":"Registered Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}},{"type":"dateRange","name":"EXPIRATION_DATE","label":"Expiration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}}]},{"label":"Business Info Request","component":"InfoRequests","parameter":"info-request","sourceTypeId":167,"allowedRoutes":["/forms-manager/","/queue/","/forms/"]},{"label":"Data Requests","component":"DataRequests","parameter":"data-request","sourceTypeId":0,"allowedRoutes":["/forms-manager/"]},{"label":"CRA","component":"CRA","parameter":"cra","sourceTypeId":157,"myRecordsSearch":false,"searchPlaceholder":"Search by name or registered agent number","allowedRoutes":["/forms-manager/","/forms/","/records/","/queue/","/search/"],"allowEmptySearchTerm":true,"fileAmendmentButtonLabel":"Filing Actions","advancedSearchParameters":[{"type":"radio","name":"QUERY_TYPE_ID","defaultValue":1010,"options":[{"value":1010,"label":"Starts with"},{"value":1011,"label":"Contains"},{"value":1012,"label":" Word Contains"}]},{"type":"dateRange","name":"CRA_DATE","label":"Registration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}},{"type":"select","name":"STATUS_ID","label":"Status","defaultValue":0,"options":[{"value":0,"label":"All"},{"value":121,"label":"Active"},{"value":122,"label":"Inactive"}]},{"type":"select","name":"AGENT_TYPE_ID","label":"Agent Type","defaultValue":0,"options":[{"value":0,"label":"All"},{"value":460,"label":"Registered Agent"},{"value":461,"label":"Commercial Registered Agent"}]}]},{"label":"Farm Bill","component":"FarmBill","parameter":"farm-bill","path":"/lists/farm-bill","sourceTypeId":0,"myRecordsSearch":false,"allowedRules":["/search/"],"disabled":true,"searchDescription":"To perform a search, enter a debtor name. Your search results may include: exact debtor name, variations of that name and any filing that includes your search criteria. Punctuation is ignored.\n\nYou can click on \"Advanced\" to refine your search. Under “Advanced” you can search by crop, year, county and SSN/FEIN. As a registered Farm Bill Buyer with the Montana Secretary of State’s office it is important to maintain the confidentiality of the information contained within the Farm Bill Master List. The Farm Bill Master List reflects personal data, such as Social Security Numbers, which are a key piece of personal identifiable information to assist you in determining the existence of a lien against a specific debtor. The distribution of this information beyond its intended purpose is strictly prohibited.\n\nThe debtor's tax identification number has been hidden for confidentiality reasons. You may continue to search on a tax ID number and return debtors that match your search criteria. The SSN/FEIN must be entered without dashes or spaces.","searchMustHaveOneOf":["search","UCC_FARM_PRODUCT_ID","COUNTY"],"searchPlaceholder":"Search by debtor name","advancedSearchParameters":[{"type":"ServerMultiComplete","label":"Product code name(s)","name":"UCC_FARM_PRODUCT_ID","defaultValue":"","optionsSrc":"UCC_FARM_PRODUCT_V"},{"type":"MultiComplete","label":"Year or Range of Years","name":"YEAR_NUM","optionsSrc":"years","startYear":"1968","defaultValue":[],"preMergeOptions":[{"value":"ALL","label":"All"}]},{"type":"serverSelect","label":"State","name":"STATE","defaultValue":"MONTANA","optionsSrc":"STATE"},{"type":"ServerMultiComplete","label":"County","name":"COUNTY","defaultValue":[],"optionsSrc":"COUNTY","overrideSubOptionsSrcFromParameterName":"STATE"},{"type":"checkbox","name":"TIN_SEARCH_YN","defaultValue":false,"label":"Tax Identification Number Search"},{"type":"checkbox","name":"TIN_SORT_YN","defaultValue":false,"label":"Unique ID Sort"}]}],"SYSTEM_NICKNAME":"Online Services Portal","PAYMENT_METHODS":[{"type":"bypass"},{"type":"iTransact"}],"PAYMENT_ALLOW_AMEX":true,"SYSTEM_ID_LABEL":"System Id","DOUBLE_COLUMN_PUBLIC_LOGIN":true,"INTERNAL_USER_MANAGEMENT":true,"ALLOW_PUBLIC_JSON_IMPORT":false,"MAX_FILE_UPLOAD_SIZE":10000000,"REFUND_TEXT":"","RETURN_TO_HOME_ON_LOGOUT":true,"CURRENT_SOS_NAME":"Christi Jacobsen","LOGO_FILENAME":"mt-sos-logo.png","LOGO_ALT":"Christi Jacobsen, Montana Secretary of State","LOGO_FULL_WIDTH":true,"HOME_HIDE_AUTH_HINT":true,"HOME_TITLE":"Montana Secretary of State","CUSTOM_TAB_TITLE":"Official Montana","HOME_SUBTITLE":"Online Business Services","ENTITY_NAME_CONSENT_DESCRIPTION":"","ALLOW_USER_PROFILE_EDITING":true,"COMPARE_FOREIGN_NAME_IN_ENTITY_NAME_VALIDATION":true,"FOREIGN_NAME_FIELD_NAME":"KIMA_PARENT_NAME_INFO","LOGIN_TITLE":"Montana Secretary of State Online Filing Portal Login","PUBLIC_LOGIN_LABEL":"Username","REVERSE_LOGIN_COLUMNS":true,"LOGIN_SEAL_FILENAME":"seal_white.png","SEPARATE_USERNAME_AND_EMAIL":true,"CREATE_ACCOUNT_BUTTON_ALIGN_LEFT":true,"CREATE_ACCOUNT_BUTTON_TEXT":"CREATE AN ACCOUNT","PASSWORD_CUSTOM_ERROR_TEXT":"The password must meet all requirements","ACCOUNT_CREATED_MESSAGE":"Please check your email to verify your account to login and allow a few minutes for this message to arrive. Check your junk/spam folders if you do not find the email in your inbox.","PUBLIC_LOGIN_PLACEHOLDER":" ","DISABLE_DEFAULT_PAYMENT_RADIO":true,"CUSTOM_RESET_PASSWORD_ERROR_MESSAGE":"Username invalid - no account found","PUBLIC_LOGIN_CREATE_DESCRIPTION":"### Existing User:\n\n  - Enter your username and password to login.  \n\n\n  #### - OR -  \n\n\n\n  - Forgot password? Click 'Reset Password' and follow the prompts.\n  - Forgot username? Click 'Forgot Username' and follow the prompts.  \n\n\n  ### New User:\n  ","LOGIN_HELP_LINK":"https://sosmt.gov/business/how-do-i/","LOGIN_HELP_LINK_TEXT":"Need Help?","FORGOT_USERNAME_TEXT":"Forgot Username?","LOGIN_ACTIVE_DIRECTORY_TEXT":"State User Login","MULTIPLE_LOGIN_METHODS":true,"HAS_ACTIVE_DIRECTORY_LOGIN":true,"RESET_PASSWORD_WITH_USERNAME":true,"DOWNLOAD_LINK":true,"SHOW_USERNAME_ACCOUNT_CREATE":true,"SHOW_SCROLL_DOWN_ARROW":true,"SHOW_ADDRESS_ACCOUNT_CREATE":true,"TWO_COLUMN_ACCOUNT_CREATE":true,"RESET_PASSWORD_TIP":"A link to change your password has been sent to your email. Please allow a few minutes for this message to arrive. Please check your junk/spam folders if you do not find the email in your inbox.","FORGOT_PASSWORD_LINK_TEXT":"Reset Password","PHONE_NUMBER_OPTIONAL_ACCOUNT_CREATE":true,"SHOW_REQUIRED_INDICATOR_ACCOUNT_CREATE":true,"PASSWORD_REQUIREMENTS_ACCOUNT_CREATE":"\n    <ul>\n      <li>MUST contain at least 8 characters (12+ recommended)</li>\n      <li>MUST contain at least one uppercase letter.</li>\n      <li>MUST contain at least one lowercase letter.</li>\n      <li>MUST contain at least one number.</li>\n      <li>MUST contain at least one special character (!”#$%&'()*+,-./:;<=>?</li>\n    </ul>\n  ","ALLOW_CERTIFICATION_REQUEST":true,"ALLOW_PUBLIC_CERTIFICATE_REQUEST":true,"ALLOW_COPY_REQUEST":false,"ALLOW_CORRECTION_STYLING":true,"HIDE_DEPRECATION_WARNING":false,"AMEND_ROUTE_PUBLIC":true,"SEAL_FILENAME":"seal.png","SHOPPING_CART":true,"ALLOW_PAYMENT_UPDATE_WITH_EMPTY_CART":true,"RA_EMAIL":true,"RA_WEBSITE":true,"RA_NO_DEFAULT_TYPE":true,"RA_ADDRESS_LABEL":"Street Address","RA_TYPE_SELECTION_DEFAULT":true,"RA_DEFAULT_TYPE":"460","RA_OVERRIDE_TYPE_WITH_DEFAULT":true,"RA_PRINCIPAL_ADDRESS_AMS":true,"UPLOAD_AND_SUBMIT_HIDE_IF_ONE_OPTION":true,"PAYMENT_PROCESSING_MESSAGE":"Your payment is processing - Do not close your browser or click the back button","CHECKOUT_BUTTON_WHEN_PROCESSING_TEXT":"Processing","EFS_CROP_PICKER_NONE_LABEL":"Lien Duration","DISALLOWED_WIZARD_PIECES":["FormationLocale"],"REPEATER_SHOW_EDIT_BUTTON":true,"DATA_REQUEST_PAGE_TITLE":"Data Requests and Subscriptions","DATA_REQUEST_SIDEBAR_LABEL":"Data Requests & Subscriptions","LOGIN_REDIRECTS_TO_EPASS":false,"LOGIN_REDIRECTS_TO_ACTIVE_DIRECTORY":true,"LOGIN_ACTIVE_DIRECTORY_LINK":true,"FETCH_EDIT_USER_LINK":false,"LISTS_FETCH_AVAILABLE_LISTS":true,"POST_WIZARD_SUBMIT_REDIRECT_URL":"/","PIN_REQUEST_ATTESTATIONS":true,"PIN_REQUEST_DESCRIPTION":"Click **Request PIN** to have a new PIN sent to the account holder's email address on file.","OWNERSHIP_REQUEST_DESCRIPTION":"To become an **authorized user** of this record, a current **AUTHORIZED USER** will need to grant you access. To request access, click **Request Access** below.","PIN_REQUEST_SUCCESS_MESSAGE":"The PIN you have requested for this entity has been sent to the email associated with your user account.  You should receive the PIN in approximately 3-5 minutes, depending on your email service provider.","APOSTILLE_HEADER_LABEL":"Verification Information","APOSTILLE_NUMBER_LABEL":"Apostille/Authentication","APOSTILLE_CITY_STATE_OVERRIDE":"HELENA, MT","APOSTILLE_FILING_DATE_LABEL":"Issue Date","APOSTILLE_CITY_STATE_IN_CERTIFIED":true,"NOTARY_EXISTING_FILING":true,"ALLOW_REVOKE_OWN_ACCESS_ONLY":false,"HIDE_CANCEL_ON_ONETIME_DATA_REQUESTS":true,"DATA_REQUESTS_IN_SHOPPING_CART":true,"WQ_ALLOW_EDIT_PENDING_PAYMENT":true,"WQ_CONFIRM_ON_DELETE":true,"WQ_DELETE_CONFIRM_MESSAGE":"Deleting this filing will forfeit any money already paid to the Secretary of State. This action is permanent and cannot be undone, are you sure you would like to delete?","PASS_ITEM_GUIDS_ON_CHECKOUT":true,"FORM_REVISION_HISTORY":true,"CHECKOUT_DISCLAIMER":"By entering your credit card and/or checking account information you (i) state that **you are an authorized user** of the credit card and/or electronic check and that the associated information entered (e.g., account holder name, account number, billing address) is accurate, (ii) **you authorize payment processor to charge the amount you have requested** to your credit card and/or funding account, and (iii) **acknowledge if a charge is declined or reversed you may also be assessed a customary charge** by the payment processor for such transactions.","FARM_BILL_SEARCH_CONFIDENTIAL":"As a registered Farm Bill Buyer with the Montana Secretary of State’s office it is important to maintain the confidentiality of the information contained within the Farm Bill Master List. The Farm Bill Master List reflects personal data, such as Social Security Numbers, which are a key piece of personal identifiable information to assist you in determining the existence of a lien against a specific debtor. The distribution of this information beyond its intended purpose is strictly prohibited.\n\n**The debtor's tax identification number has been hidden for confidentiality reasons. You may continue to search on a tax ID number and return debtors that match your search criteria. The SSN/FEIN must be entered without dashes or spaces.  If you need access to the tax identification number to clearly identify the debtor, please contact the UCC unit at (406) 444-3665.**","VIEW_HISTORY_BUTTON_ALT_TEXT":"View Filings","WIZARD_ERROR_TITLE_MESSAGE":"Form Error","FARM_BILL_SEARCH_INTERACTIVE":true,"USE_FARM_BILL_API":true,"DISALLOW_ASSIGN_SELF_AS_RA":true,"DISALLOW_ASSIGN_SELF_AS_PRINCIPAL":true,"USE_TRADEMARK_OWNER_VALIDATION":true,"USE_ALTERNATIVE_FOREIGN_ADDRESS_LABELS":true,"MY_RECEIPTS_FILTER":[{"type":"dateRange","name":"DATE_RANGE","label":"Date range","defaultValue":{"start":null,"end":null}},{"type":"text","name":"REF_NUM","defaultValue":"","label":"Reference Number"},{"type":"text","name":"RECEIPT_NUM","defaultValue":"","label":"Receipt Id"},{"type":"text","name":"AMOUNT","defaultValue":"","label":"Amount"},{"type":"select","name":"TYPE","defaultValue":"","label":"Payment Type","options":[{"value":"","label":"All"},{"value":"CC","label":"Credit Card"},{"value":"Check","label":"Check"}]}],"MY_RECEIPTS_SHOW_IN_SIDEBAR":true,"SHOW_MY_RECEIPTS_HELPER_TEXT":true,"MY_RECEIPTS_HELPER_LABEL":"About Receipt Search","MY_RECEIPTS_HELPER_TEXT":"You can search for receipts based on their descriptions, including the items paid for on the receipt. Use the filters to search for or filter specific information.","FARM_BILL_SUBLINK":{"label":"Farm Bill","component":"FarmBill","parameter":"farm-bill","path":"/lists/farm-bill","sourceTypeId":0,"myRecordsSearch":false,"allowedRules":["/search/"],"disabled":true,"searchDescription":"To perform a search, enter a debtor name. Your search results may include: exact debtor name, variations of that name and any filing that includes your search criteria. Punctuation is ignored.\n\nYou can click on \"Advanced\" to refine your search. Under “Advanced” you can search by crop, year, county and SSN/FEIN. As a registered Farm Bill Buyer with the Montana Secretary of State’s office it is important to maintain the confidentiality of the information contained within the Farm Bill Master List. The Farm Bill Master List reflects personal data, such as Social Security Numbers, which are a key piece of personal identifiable information to assist you in determining the existence of a lien against a specific debtor. The distribution of this information beyond its intended purpose is strictly prohibited.\n\nThe debtor's tax identification number has been hidden for confidentiality reasons. You may continue to search on a tax ID number and return debtors that match your search criteria. The SSN/FEIN must be entered without dashes or spaces.","searchMustHaveOneOf":["search","UCC_FARM_PRODUCT_ID","COUNTY"],"searchPlaceholder":"Search by debtor name","advancedSearchParameters":[{"type":"ServerMultiComplete","label":"Product code name(s)","name":"UCC_FARM_PRODUCT_ID","defaultValue":"","optionsSrc":"UCC_FARM_PRODUCT_V"},{"type":"MultiComplete","label":"Year or Range of Years","name":"YEAR_NUM","optionsSrc":"years","startYear":"1968","defaultValue":[],"preMergeOptions":[{"value":"ALL","label":"All"}]},{"type":"serverSelect","label":"State","name":"STATE","defaultValue":"MONTANA","optionsSrc":"STATE"},{"type":"ServerMultiComplete","label":"County","name":"COUNTY","defaultValue":[],"optionsSrc":"COUNTY","overrideSubOptionsSrcFromParameterName":"STATE"},{"type":"checkbox","name":"TIN_SEARCH_YN","defaultValue":false,"label":"Tax Identification Number Search"},{"type":"checkbox","name":"TIN_SORT_YN","defaultValue":false,"label":"Unique ID Sort"}]},"ALLOW_ADDRESS_VALIDATION_BYPASS_OPTION":true,"DEFAULT_ADDRESS_VALIDATION_BYPASS_OPTION_CHECKED":true}).HAS_OKTA_LOGIN ? [{
	  label: 'Okta Callback',
	  title: 'Okta Callback',
	  includeInSidebar: false,
	  iconClass: '',
	  component: OktaCallback,
	  path: '/okta-callback',
	  link: '/okta-callback',
	  sublinks: [],
	  authOnly: false
	}] : []), _toConsumableArray(ADDITIONAL_ROUTES.farmBill ? [{
	  label: 'Farm Bill',
	  title: 'Farm Bill Search',
	  path: '/lists/:subParam',
	  link: '/lists/:subParam',
	  component: _FarmBill2.default,
	  subLinks: [({"label":"Farm Bill","component":"FarmBill","parameter":"farm-bill","path":"/lists/farm-bill","sourceTypeId":0,"myRecordsSearch":false,"allowedRules":["/search/"],"disabled":true,"searchDescription":"To perform a search, enter a debtor name. Your search results may include: exact debtor name, variations of that name and any filing that includes your search criteria. Punctuation is ignored.\n\nYou can click on \"Advanced\" to refine your search. Under “Advanced” you can search by crop, year, county and SSN/FEIN. As a registered Farm Bill Buyer with the Montana Secretary of State’s office it is important to maintain the confidentiality of the information contained within the Farm Bill Master List. The Farm Bill Master List reflects personal data, such as Social Security Numbers, which are a key piece of personal identifiable information to assist you in determining the existence of a lien against a specific debtor. The distribution of this information beyond its intended purpose is strictly prohibited.\n\nThe debtor's tax identification number has been hidden for confidentiality reasons. You may continue to search on a tax ID number and return debtors that match your search criteria. The SSN/FEIN must be entered without dashes or spaces.","searchMustHaveOneOf":["search","UCC_FARM_PRODUCT_ID","COUNTY"],"searchPlaceholder":"Search by debtor name","advancedSearchParameters":[{"type":"ServerMultiComplete","label":"Product code name(s)","name":"UCC_FARM_PRODUCT_ID","defaultValue":"","optionsSrc":"UCC_FARM_PRODUCT_V"},{"type":"MultiComplete","label":"Year or Range of Years","name":"YEAR_NUM","optionsSrc":"years","startYear":"1968","defaultValue":[],"preMergeOptions":[{"value":"ALL","label":"All"}]},{"type":"serverSelect","label":"State","name":"STATE","defaultValue":"MONTANA","optionsSrc":"STATE"},{"type":"ServerMultiComplete","label":"County","name":"COUNTY","defaultValue":[],"optionsSrc":"COUNTY","overrideSubOptionsSrcFromParameterName":"STATE"},{"type":"checkbox","name":"TIN_SEARCH_YN","defaultValue":false,"label":"Tax Identification Number Search"},{"type":"checkbox","name":"TIN_SORT_YN","defaultValue":false,"label":"Unique ID Sort"}]})],
	  authOnly: true,
	  allowedUserGroups: ['ADMIN', 'ADMIN_WEB', 'WEB']
	}] : []), _toConsumableArray(ADDITIONAL_ROUTES.externalHelp !== undefined && ADDITIONAL_ROUTES.externalHelp !== false ? [{
	  label: 'Help',
	  title: 'Help',
	  path: ADDITIONAL_ROUTES.externalHelp,
	  link: ADDITIONAL_ROUTES.externalHelp,
	  authOnly: false,
	  includeInSidebar: true,
	  linkAvailableOffline: true,
	  external: true,
	  icon: _react2.default.createElement(_questionMark2.default, null)
	}] : []), _toConsumableArray(ADDITIONAL_ROUTES.genericPins ? [{
	  label: 'Enter PIN',
	  title: 'Enter PIN',
	  includeInSidebar: false,
	  iconClass: '',
	  component: _PinsPage2.default,
	  path: '/pins',
	  link: 'pins',
	  sublinks: '',
	  authOnly: false,
	  codeSplit: true
	}] : []), _toConsumableArray( false ? [{
	  label: 'Sandbox',
	  title: 'Sandbox',
	  includeInSidebar: true,
	  icon: _react2.default.createElement(_gears2.default, null),
	  component: Sandbox,
	  path: '/sandbox',
	  link: '/sandbox',
	  codeSplit: true,
	  collapseSidebar: true,
	  linkAvailableOffline: true
	}] : []), _toConsumableArray(ADDITIONAL_ROUTES.healthCareDirective ? [{
	  label: 'Health Care Directive',
	  title: 'Health Care Directive',
	  includeInSidebar: false,
	  component: _DeferredHealthCareDirective2.default,
	  path: '/hcdr',
	  link: '/hcdr',
	  codeSplit: true,
	  collapseSidebar: false
	}] : []), _toConsumableArray(ADDITIONAL_ROUTES.apostille ? [{
	  label: 'Apostille Verification',
	  title: 'Apostille Verification',
	  includeInSidebar: false,
	  component: _ApostilleVerification2.default,
	  path: '/apostille',
	  link: '/apostille',
	  codeSplit: true,
	  collapseSidebar: false
	}] : []), [{
	  label: 'Version',
	  title: 'Version',
	  includeInSidebar: false,
	  path: '/version',
	  link: '/version',
	  authOnly: false,
	  component: _Version2.default
	}]);
	
	var App = function (_Component) {
	  _inherits(App, _Component);
	
	  function App() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, App);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = App.__proto__ || Object.getPrototypeOf(App)).call.apply(_ref, [this].concat(args))), _this), _this.componentDidMount = function () {
	      var skipAuthCheck = ((0, _utilities.parseUrlQuery)(_this.props.location.search || '?') || {}).skipAuthCheck;
	      if (!skipAuthCheck) {
	        _this.props.getAuthState();
	      } else {
	        _this.props.skipAuthCheck();
	      }
	      // this.props.registerAuthPoll()
	      _this.props.initializeApp();
	    }, _this.componentWillReceiveProps = function (nextProps) {
	      var mobileLocationHasChanged = nextProps.isMobile && _this.props.location.pathname !== nextProps.location.pathname;
	      if (mobileLocationHasChanged) {
	        document.body.scrollTop = document.documentElement.scrollTop = 0;
	      }
	    }, _this.componentDidCatch = function (err) {
	      switch (err.name) {
	        case 'AuthSdkError':
	          _this.setState({ showBrowserUpgradeMessage: true });
	          break;
	        default:
	      }
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(App, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          location = _props.location,
	          loggedIn = _props.loggedIn,
	          userGroup = _props.userGroup,
	          siteOffline = _props.siteOffline,
	          isUnsupportedBrowser = _props.isUnsupportedBrowser;
	
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'App ' + (isUnsupportedBrowser ? 'unsupported-browser' : '') },
	        _react2.default.createElement(_Shell.SidebarNav, { links: routes, location: location }),
	        _react2.default.createElement(
	          _reactRouterDom.Switch,
	          null,
	          routes.map(function (route, i) {
	            return _react2.default.createElement(_reactRouterDom.Route, {
	              path: route.path,
	              exact: route.exact,
	              render: function render(props) {
	                var renderedComponent = _react2.default.createElement(
	                  _Shell.Content,
	                  {
	                    currentPath: location.pathname,
	                    links: routes,
	                    currentRoute: route,
	                    subLinks: route.subLinks,
	                    authOnly: route.authOnly,
	                    sidebarCollapsed: route.collapseSidebar,
	                    hideAppShell: route.hideAppShell,
	                    hideSidebar: route.hideSidebar
	                  },
	                  _react2.default.createElement(
	                    _reactHelmet.Helmet,
	                    null,
	                    _react2.default.createElement(
	                      'title',
	                      null,
	                      (route.title || '') + ' | ' + (("Official Montana") || ("Montana")) + ' ' + ("Secretary of State")
	                    )
	                  ),
	                  _react2.default.createElement(route.component, Object.assign({}, props, { sublinks: route.subLinks }))
	                );
	                if (route.authOnly) {
	                  if (siteOffline) {
	                    return _react2.default.createElement(_reactRouterDom.Redirect, { to: '/' });
	                  }
	                  if (loggedIn) {
	                    if (route.allowedUserGroups) {
	                      if (route.allowedUserGroups.includes(userGroup)) {
	                        return renderedComponent;
	                      } else {
	                        return _react2.default.createElement(_reactRouterDom.Redirect, { to: '/' });
	                      }
	                    } else {
	                      return renderedComponent;
	                    }
	                  } else {
	                    return _react2.default.createElement(
	                      _Shell.Content,
	                      {
	                        currentPath: location.pathname,
	                        sidebarCollapsed: route.collapseSidebar,
	                        hideAppShell: route.hideAppShell,
	                        hideSidebar: route.hideSidebar
	                      },
	                      _react2.default.createElement(
	                        _reactHelmet.Helmet,
	                        null,
	                        _react2.default.createElement(
	                          'title',
	                          null,
	                          (route.title || '') + ' | ' + ("Montana") + ' ' + ("Secretary of State")
	                        )
	                      ),
	                      _react2.default.createElement(_LoginRedirector.LoginRedirectSwitch, { location: location })
	                    );
	                  }
	                } else {
	                  return renderedComponent;
	                }
	              },
	              key: i
	            });
	          }),
	          _react2.default.createElement(_reactRouterDom.Route, {
	            render: function render(props) {
	              return _react2.default.createElement(
	                _Shell.Content,
	                {
	                  currentPath: location.pathname,
	                  links: routes,
	                  currentRoute: {},
	                  subLinks: [],
	                  authOnly: false,
	                  sidebarCollapsed: false
	                },
	                _react2.default.createElement(
	                  _reactHelmet.Helmet,
	                  null,
	                  _react2.default.createElement(
	                    'title',
	                    null,
	                    '404 Not Found | ' + ("Montana") + ' ' + ("Secretary of State")
	                  )
	                ),
	                _react2.default.createElement(_NotFound2.default, null)
	              );
	            }
	          })
	        ),
	        _react2.default.createElement(_Toast2.default, {
	          danger: !!this.props.toastError,
	          success: !!this.props.toastSuccess,
	          message: this.props.toastError || this.props.toastSuccess
	        }),
	        _react2.default.createElement(_Shell.Footer, { copyright: ("MT") + ' Secretary of State' }),
	        isUnsupportedBrowser && _react2.default.createElement(_UnsupportedBrowser2.default, null),
	        _react2.default.createElement(_Announcer2.default, null)
	      );
	    }
	  }]);
	
	  return App;
	}(_react.Component);
	
	exports.default = (0, _reactRedux.connect)(function (state) {
	  return {
	    loggedIn: state.auth.loggedIn,
	    userGroup: state.auth.USER_GROUP,
	    isMobile: state.app.isMobile,
	    toastError: state.app.toastError,
	    toastSuccess: state.app.toastSuccess,
	    siteOffline: state.app.appSettings.WEBSITE_PORTAL_OFFLINE_YN === true,
	    isUnsupportedBrowser: state.app.isUnsupportedBrowser
	  };
	}, { getAuthState: _AuthActions.getAuthState, initializeApp: _actions.initializeApp, registerAuthPoll: _AuthActions.registerAuthPoll, skipAuthCheck: _AuthActions.skipAuthCheck })(App);

/***/ },
/* 119 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.PaymentError = undefined;
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Shell = __webpack_require__(19);
	
	var _utilities = __webpack_require__(8);
	
	var _Loaders = __webpack_require__(16);
	
	var _crossHeavy = __webpack_require__(51);
	
	var _crossHeavy2 = _interopRequireDefault(_crossHeavy);
	
	var _actions = __webpack_require__(29);
	
	var _requests = __webpack_require__(6);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var PaymentCallback = function (_React$Component) {
	  _inherits(PaymentCallback, _React$Component);
	
	  function PaymentCallback() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, PaymentCallback);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = PaymentCallback.__proto__ || Object.getPrototypeOf(PaymentCallback)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      error: false,
	      errorMessage: null
	    }, _this.componentDidMount = function () {
	      var method = _this.props.match.params.method;
	
	      if (method) {
	        _this.processByMethod(method);
	      }
	    }, _this.toggleError = function (errorMessage) {
	      _this.setState({ error: true, errorMessage: errorMessage || null });
	    }, _this.processByMethod = function (method) {
	      switch (method.toLowerCase()) {
	        case "accessidcc":
	          _this.getAccessIDCCPaymentStatus();
	          break;
	        case "accessidloc":
	          _this.getAccessIDLOCPaymentStatus();
	          break;
	        case "paypal":
	          _this.getPaypalPaymentStatus();
	          break;
	        default:
	      }
	    }, _this.getAccessIDCCPaymentStatus = function () {
	      var _parseUrlQuery = (0, _utilities.parseUrlQuery)(_this.props.location.search),
	          token = _parseUrlQuery.token;
	
	      if (token) {
	        _this.props.history.replace(_this.props.location.pathname);
	      }
	      (0, _requests.GET_ACCESS_ID_CC_PAYMENT_STATUS)(token, function (_ref2) {
	        var SECURETOKENID = _ref2.SECURETOKENID;
	
	        if (SECURETOKENID) {
	          (0, _actions.setCartQuantity)(0);
	          _this.redirectToReceipt(SECURETOKENID);
	        } else {
	          _this.redirectToQueue();
	        }
	      }, function (err) {
	        console.error(err);
	        _this.toggleError(err.message);
	      });
	    }, _this.getAccessIDLOCPaymentStatus = function () {
	      var _parseUrlQuery2 = (0, _utilities.parseUrlQuery)(_this.props.location.search),
	          token = _parseUrlQuery2.token;
	
	      if (token) {
	        _this.props.history.replace(_this.props.location.pathname);
	      }
	      (0, _requests.GET_ACCESS_ID_LOC_PAYMENT_STATUS)(token, function (_ref3) {
	        var SECURETOKENID = _ref3.SECURETOKENID;
	
	        if (SECURETOKENID) {
	          (0, _actions.setCartQuantity)(0);
	          _this.redirectToReceipt(SECURETOKENID);
	        } else {
	          _this.redirectToQueue();
	        }
	      }, function (err) {
	        console.error(err);
	        _this.toggleError(err.message);
	      });
	    }, _this.getPaypalPaymentStatus = function () {
	      var _parseUrlQuery3 = (0, _utilities.parseUrlQuery)(_this.props.location.search),
	          SECURETOKENID = _parseUrlQuery3.SECURETOKENID;
	
	      if (SECURETOKENID) {
	        _this.props.history.replace(_this.props.location.pathname);
	      }
	      (0, _requests.GET_PAYPAL_PAYMENT_STATUS)(SECURETOKENID, function () {
	        _this.redirectToReceipt(SECURETOKENID);
	      }, function (err) {
	        console.error(err);
	        _this.toggleError(err.message);
	      });
	    }, _this.handlePaypalPayment = function () {
	      var _parseUrlQuery4 = (0, _utilities.parseUrlQuery)(_this.props.location.search),
	          SECURETOKENID = _parseUrlQuery4.SECURETOKENID;
	
	      _this.redirectToReceipt(SECURETOKENID);
	    }, _this.redirectToQueue = function () {
	      _this.props.history.replace("/queue/business");
	    }, _this.redirectToReceipt = function (refNum) {
	      _this.props.history.replace("/receipt?ref=" + refNum);
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(PaymentCallback, [{
	    key: "render",
	    value: function render() {
	      return _react2.default.createElement(
	        _Shell.Body,
	        { className: "login-redirector payment-callback" },
	        this.state.error ? _react2.default.createElement(
	          PaymentError,
	          null,
	          this.state.errorMessage
	        ) : _react2.default.createElement(
	          "div",
	          { className: "flex-column animated fadeIn delay" },
	          _react2.default.createElement(_Loaders.Spinner, { className: "page-loader", size: "medium", themeColor: "secondary" }),
	          _react2.default.createElement(
	            "h1",
	            { className: "message" },
	            "Processing your payment"
	          )
	        )
	      );
	    }
	  }]);
	
	  return PaymentCallback;
	}(_react2.default.Component);
	
	exports.default = PaymentCallback;
	var PaymentError = exports.PaymentError = function PaymentError(_ref4) {
	  var children = _ref4.children,
	      errorCode = _ref4.errorCode,
	      errorMessage = _ref4.errorMessage,
	      errorTitle = _ref4.errorTitle;
	  return _react2.default.createElement(
	    "div",
	    { className: "flex-column" },
	    _react2.default.createElement(_crossHeavy2.default, { className: "text-danger" }),
	    _react2.default.createElement(
	      "h1",
	      { className: "message text-danger" },
	      errorTitle || 'Something went wrong'
	    ),
	    (typeof children === "undefined" ? "undefined" : _typeof(children)) === 'object' ? _react2.default.createElement(
	      "div",
	      { className: "text-danger pre-wrap" },
	      children || "An error has occurred while trying to process your payment."
	    ) : _react2.default.createElement(
	      "p",
	      { className: "text-danger pre-wrap" },
	      children || "An error has occurred while trying to process your payment."
	    ),
	    (errorCode || errorMessage) && _react2.default.createElement(
	      "p",
	      { className: "text-danger" },
	      _react2.default.createElement(
	        "strong",
	        null,
	        "Code ",
	        errorCode
	      ),
	      " : ",
	      errorMessage
	    )
	  );
	};

/***/ },
/* 120 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(7);
	
	var _downshift = __webpack_require__(1007);
	
	var _downshift2 = _interopRequireDefault(_downshift);
	
	var _caretDown = __webpack_require__(38);
	
	var _caretDown2 = _interopRequireDefault(_caretDown);
	
	var _Portal = __webpack_require__(12);
	
	var _Portal2 = _interopRequireDefault(_Portal);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var MultiComplete = function (_React$Component) {
	  _inherits(MultiComplete, _React$Component);
	
	  function MultiComplete() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, MultiComplete);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = MultiComplete.__proto__ || Object.getPrototypeOf(MultiComplete)).call.apply(_ref, [this].concat(args))), _this), _this.updateMenuOnNextValueChange = false, _this.componentDidUpdate = function (prevProps) {
	      if (_this.updateMenuOnNextValueChange && prevProps.value.length !== _this.props.value.length && _this.menu && _this.menu.updateMenuPosition) {
	        _this.menu.updateMenuPosition();
	      }
	    }, _this.componentDidMount = function () {
	      if (_this.props.options.length > 0 && _this.props.parent && _this.props.parent.type !== "REPEATER") {
	        _this.props.onChange(_this.props.value.filter(function (value) {
	          return _this.props.options.some(function (option) {
	            return option.value === value;
	          });
	        }));
	      }
	    }, _this.addSelection = function (options) {
	      _this.props.onChange([].concat(_toConsumableArray(_this.props.value), [options.value]));
	    }, _this.remove = function (i) {
	      _this.props.onChange([].concat(_toConsumableArray(_this.props.value.slice(0, i)), _toConsumableArray(_this.props.value.slice(i + 1))));
	    }, _this.handleEnterKey = function (e) {
	      if (e.key === 'Enter') {
	        e.preventDefault();
	      }
	    }, _this.stateReducer = function (dstate, changes) {
	      switch (changes.type) {
	        case _downshift2.default.stateChangeTypes.clickItem:
	          if (_this.props.leaveOpenOnSelect) {
	            _this.updateMenuOnNextValueChange = true;
	            return Object.assign({}, changes, {
	              isOpen: true
	            });
	          }
	          return changes;
	        default:
	          return changes;
	      }
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(MultiComplete, [{
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _props = this.props,
	          value = _props.value,
	          options = _props.options,
	          width = _props.width,
	          label = _props.label,
	          placeholder = _props.placeholder,
	          required = _props.required,
	          maxRows = _props.maxRows,
	          disabled = _props.disabled,
	          ariaLabel = _props.ariaLabel,
	          isMobile = _props.isMobile;
	
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          _downshift2.default,
	          {
	            onChange: this.addSelection,
	            stateReducer: this.stateReducer,
	            itemToString: function itemToString() {
	              return '';
	            }
	          },
	          function (_ref2) {
	            var getInputProps = _ref2.getInputProps,
	                getItemProps = _ref2.getItemProps,
	                getLabelProps = _ref2.getLabelProps,
	                getMenuProps = _ref2.getMenuProps,
	                getToggleButtonProps = _ref2.getToggleButtonProps,
	                isOpen = _ref2.isOpen,
	                inputValue = _ref2.inputValue,
	                highlightedIndex = _ref2.highlightedIndex,
	                selectedItem = _ref2.selectedItem;
	
	            return _react2.default.createElement(
	              'div',
	              { className: 'multi-complete' },
	              _react2.default.createElement(
	                'label',
	                Object.assign({ className: 'field-label' }, getLabelProps()),
	                label,
	                required && label !== '' && _react2.default.createElement(
	                  'span',
	                  { className: 'required', 'aria-hidden': true },
	                  '*'
	                )
	              ),
	              value.length > 0 && _react2.default.createElement(
	                'div',
	                { className: 'tags-wrapper' },
	                value.map(function (v, i) {
	                  return _react2.default.createElement(
	                    Tag,
	                    {
	                      onClick: function onClick(e) {
	                        _this2.remove(i);
	                      },
	                      key: '' + v + i,
	                      disabled: _this2.props.disabled
	                    },
	                    (options.find(function (o) {
	                      return o.value === v;
	                    }) || {}).label || v
	                  );
	                })
	              ),
	              (!maxRows || value.length < maxRows) && _react2.default.createElement(
	                'div',
	                { className: 'multi-input-wrapper', style: { width: width } },
	                _react2.default.createElement('input', Object.assign({
	                  type: 'text'
	                }, getInputProps({
	                  ref: function ref(r) {
	                    return _this2.inputRef = r;
	                  },
	                  placeholder: placeholder,
	                  onKeyDown: _this2.handleEnterKey,
	                  disabled: disabled
	                }), {
	                  'aria-label': ariaLabel
	                })),
	                _react2.default.createElement(
	                  'button',
	                  getToggleButtonProps({
	                    className: 'menu-button ' + (isOpen ? 'open' : ''),
	                    disabled: disabled
	                  }),
	                  _react2.default.createElement(_caretDown2.default, null)
	                )
	              ),
	              _react2.default.createElement(
	                _Portal2.default,
	                { isOpened: true },
	                _react2.default.createElement(Menu, {
	                  isOpen: isOpen,
	                  getMenuProps: getMenuProps,
	                  getItemProps: getItemProps,
	                  inputValue: inputValue,
	                  highlightedIndex: highlightedIndex,
	                  options: options.filter(function (o) {
	                    return !value.includes(o.value);
	                  }),
	                  isMobile: isMobile,
	                  getInputRef: function getInputRef() {
	                    return _this2.inputRef;
	                  },
	                  ref: function ref(r) {
	                    return _this2.menu = r;
	                  }
	                })
	              )
	            );
	          }
	        )
	      );
	    }
	  }]);
	
	  return MultiComplete;
	}(_react2.default.Component);
	
	exports.default = (0, _reactRedux.connect)(function (state) {
	  return {
	    isMobile: state.app.isMobile
	  };
	})(MultiComplete);
	
	var Menu = function (_React$Component2) {
	  _inherits(Menu, _React$Component2);
	
	  function Menu() {
	    var _ref3;
	
	    var _temp2, _this3, _ret2;
	
	    _classCallCheck(this, Menu);
	
	    for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
	      args[_key2] = arguments[_key2];
	    }
	
	    return _ret2 = (_temp2 = (_this3 = _possibleConstructorReturn(this, (_ref3 = Menu.__proto__ || Object.getPrototypeOf(Menu)).call.apply(_ref3, [this].concat(args))), _this3), _this3.state = {
	      isOpen: false,
	      anchor: null
	    }, _this3.componentDidUpdate = function (prevProps) {
	      if (_this3.props.isOpen !== prevProps.isOpen) {
	        if (_this3.props.isOpen) {
	          _this3.attachScrollListener();
	        } else {
	          _this3.detachScrollListener();
	        }
	        _this3.setState({ isOpen: _this3.props.isOpen, anchor: _this3.getAnchor() });
	      }
	    }, _this3.componentWillUnmount = function () {
	      return _this3.detachScrollListener();
	    }, _this3.attachScrollListener = function () {
	      var scrollWrapper = _this3.props.isMobile ? window : document.getElementById('wizard-body-scroll-container');
	      if (scrollWrapper) {
	        _this3.scrollWrapper = scrollWrapper;
	        scrollWrapper.addEventListener('scroll', _this3.updateMenuPosition);
	      }
	    }, _this3.updateMenuPosition = function () {
	      return _this3.setState({ anchor: _this3.getAnchor() });
	    }, _this3.detachScrollListener = function () {
	      if (_this3.scrollWrapper) {
	        _this3.scrollWrapper.removeEventListener('scroll', _this3.updateMenuPosition);
	      }
	    }, _this3.getAnchor = function () {
	      return _this3.props.getInputRef().getBoundingClientRect();
	    }, _this3.calculateHeight = function () {
	      return _this3.state.anchor.bottom + 240 > window.innerHeight - 50 ? 240 - (_this3.state.anchor.bottom + 240 - window.innerHeight) - 50 : 240;
	    }, _temp2), _possibleConstructorReturn(_this3, _ret2);
	  }
	
	  _createClass(Menu, [{
	    key: 'render',
	    value: function render() {
	      var _props2 = this.props,
	          getMenuProps = _props2.getMenuProps,
	          getItemProps = _props2.getItemProps,
	          inputValue = _props2.inputValue,
	          options = _props2.options,
	          highlightedIndex = _props2.highlightedIndex;
	
	      return this.state.isOpen && _react2.default.createElement(
	        'ul',
	        getMenuProps({
	          className: 'multi-complete-menu',
	          style: {
	            left: this.state.anchor.left + 3,
	            top: this.state.anchor.bottom - 4,
	            minWidth: this.state.anchor.width - 6,
	            maxHeight: this.calculateHeight()
	          }
	        }),
	        options.filter(function (opt) {
	          return opt.label.toLowerCase().includes(inputValue.toLowerCase());
	        }).map(function (opt, i) {
	          return _react2.default.createElement(
	            'li',
	            getItemProps({
	              item: opt,
	              key: opt.value,
	              className: highlightedIndex === i ? 'highlighted' : ''
	            }),
	            opt.label
	          );
	        })
	      );
	    }
	  }]);
	
	  return Menu;
	}(_react2.default.Component);
	
	var Tag = function Tag(_ref4) {
	  var children = _ref4.children,
	      onClick = _ref4.onClick,
	      disabled = _ref4.disabled;
	  return _react2.default.createElement(
	    'div',
	    { className: 'multi-tag' },
	    _react2.default.createElement(
	      'button',
	      {
	        className: 'remove-button',
	        onClick: onClick,
	        'aria-label': 'Unselect ' + children.toString(),
	        disabled: disabled
	      },
	      '\u2715'
	    ),
	    children
	  );
	};

/***/ },
/* 121 */
/***/ function(module, exports, __webpack_require__) {

	var Symbol = __webpack_require__(202),
	    getRawTag = __webpack_require__(1226),
	    objectToString = __webpack_require__(1253);
	
	/** `Object#toString` result references. */
	var nullTag = '[object Null]',
	    undefinedTag = '[object Undefined]';
	
	/** Built-in value references. */
	var symToStringTag = Symbol ? Symbol.toStringTag : undefined;
	
	/**
	 * The base implementation of `getTag` without fallbacks for buggy environments.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @returns {string} Returns the `toStringTag`.
	 */
	function baseGetTag(value) {
	  if (value == null) {
	    return value === undefined ? undefinedTag : nullTag;
	  }
	  return (symToStringTag && symToStringTag in Object(value))
	    ? getRawTag(value)
	    : objectToString(value);
	}
	
	module.exports = baseGetTag;


/***/ },
/* 122 */
/***/ function(module, exports, __webpack_require__) {

	var baseIsNative = __webpack_require__(1202),
	    getValue = __webpack_require__(1229);
	
	/**
	 * Gets the native function at `key` of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {string} key The key of the method to get.
	 * @returns {*} Returns the function if it's native, else `undefined`.
	 */
	function getNative(object, key) {
	  var value = getValue(object, key);
	  return baseIsNative(value) ? value : undefined;
	}
	
	module.exports = getNative;


/***/ },
/* 123 */
/***/ function(module, exports) {

	/**
	 * Checks if `value` is object-like. A value is object-like if it's not `null`
	 * and has a `typeof` result of "object".
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
	 * @example
	 *
	 * _.isObjectLike({});
	 * // => true
	 *
	 * _.isObjectLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isObjectLike(_.noop);
	 * // => false
	 *
	 * _.isObjectLike(null);
	 * // => false
	 */
	function isObjectLike(value) {
	  return value != null && typeof value == 'object';
	}
	
	module.exports = isObjectLike;


/***/ },
/* 124 */
/***/ function(module, exports) {

	
	exports = module.exports = trim;
	
	function trim(str){
	  return str.replace(/^\s*|\s*$/g, '');
	}
	
	exports.left = function(str){
	  return str.replace(/^\s*/, '');
	};
	
	exports.right = function(str){
	  return str.replace(/\s*$/, '');
	};


/***/ },
/* 125 */
/***/ function(module, exports) {

	function _extends() {
	  module.exports = _extends = Object.assign || function (target) {
	    for (var i = 1; i < arguments.length; i++) {
	      var source = arguments[i];
	
	      for (var key in source) {
	        if (Object.prototype.hasOwnProperty.call(source, key)) {
	          target[key] = source[key];
	        }
	      }
	    }
	
	    return target;
	  };
	
	  module.exports["default"] = module.exports, module.exports.__esModule = true;
	  return _extends.apply(this, arguments);
	}
	
	module.exports = _extends;
	module.exports["default"] = module.exports, module.exports.__esModule = true;

/***/ },
/* 126 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _createIconComponent = _interopRequireDefault(__webpack_require__(5));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	var IconDocument = (0, _createIconComponent["default"])({
	  content: _react["default"].createElement("g", null, _react["default"].createElement("path", {
	    d: "M47.29 28.1H22.13a1.28 1.28 0 0 0 0 2.56h25.16a1.28 1.28 0 0 0 0-2.56zM47.29 45.86H22.13a1.28 1.28 0 0 0 0 2.56h25.16a1.28 1.28 0 0 0 0-2.56zM22.13 22h20.76a1.28 1.28 0 1 0 0-2.56H22.13a1.28 1.28 0 0 0 0 2.56zM47.29 37.05H22.13a1.28 1.28 0 0 0 0 2.56h25.16a1.28 1.28 0 0 0 0-2.56z"
	  }), _react["default"].createElement("path", {
	    d: "M55 59.3V10.87a3 3 0 0 0-3-3H17.95a3 3 0 0 0-3 3v48.26a3 3 0 0 0 3 3H53a3 3 0 0 0 2-2.83zm-3 .25H17.95a.43.43 0 0 1-.43-.42V10.87a.43.43 0 0 1 .43-.43h34.1a.43.43 0 0 1 .42.43v48.26a.43.43 0 0 1-.42.42z"
	  })),
	  height: undefined,
	  width: undefined
	});
	IconDocument.displayName = 'IconDocument';
	var _default = IconDocument;
	exports["default"] = _default;

/***/ },
/* 127 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _createIconComponent = _interopRequireDefault(__webpack_require__(5));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	var IconDownloadBox = (0, _createIconComponent["default"])({
	  content: _react["default"].createElement("g", null, _react["default"].createElement("path", {
	    d: "M25.71 26.5a1.54 1.54 0 0 0 0 2.19l8.2 8.2a1.56 1.56 0 0 0 1.09.46 1.51 1.51 0 0 0 1.09-.46l8.2-8.2a1.55 1.55 0 1 0-2.19-2.19l-5.55 5.55V5.51a1.55 1.55 0 1 0-3.09 0v26.54L27.9 26.5a1.54 1.54 0 0 0-2.19 0zm0 0"
	  }), _react["default"].createElement("path", {
	    d: "M60.27 39.17L54.89 19.7a1.57 1.57 0 0 0-.85-1l-.15-.07a1.58 1.58 0 0 0-.64-.14h-9.7a1.55 1.55 0 0 0 0 3.09h8.66l4.55 16.47h-12a1.54 1.54 0 0 0-1.55 1.55V41a3.71 3.71 0 0 1-3.71 3.71H30A3.71 3.71 0 0 1 26.33 41v-1.4a1.54 1.54 0 0 0-1.55-1.55H13.23l4.57-16.5h8.66a1.55 1.55 0 0 0 0-3.09h-9.71a1.58 1.58 0 0 0-.64.14l-.15.07a1.53 1.53 0 0 0-.85 1L9.73 39.13a1.72 1.72 0 0 0-.06.41v8.12a11.17 11.17 0 0 0 11.15 11.16h28.36a11.17 11.17 0 0 0 11.15-11.16v-8.08a1.2 1.2 0 0 0-.06-.41zm-3 8.5a8.07 8.07 0 0 1-8.06 8.06H20.82a8.07 8.07 0 0 1-8.06-8.06v-6.52h10.5a6.81 6.81 0 0 0 6.8 6.64h9.44a6.81 6.81 0 0 0 6.8-6.64h11v6.52zm0 0"
	  })),
	  height: undefined,
	  width: undefined
	});
	IconDownloadBox.displayName = 'IconDownloadBox';
	var _default = IconDownloadBox;
	exports["default"] = _default;

/***/ },
/* 128 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _createIconComponent = _interopRequireDefault(__webpack_require__(5));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	var IconPlusHeavy = (0, _createIconComponent["default"])({
	  content: _react["default"].createElement("g", null, _react["default"].createElement("path", {
	    d: "M35 64.64a5.34 5.34 0 0 1-5.34-5.34V10.7a5.34 5.34 0 1 1 10.68 0v48.6A5.34 5.34 0 0 1 35 64.64z"
	  }), _react["default"].createElement("path", {
	    d: "M59.3 40.34H10.7a5.34 5.34 0 1 1 0-10.68h48.6a5.34 5.34 0 1 1 0 10.68z"
	  })),
	  height: undefined,
	  width: undefined
	});
	IconPlusHeavy.displayName = 'IconPlusHeavy';
	var _default = IconPlusHeavy;
	exports["default"] = _default;

/***/ },
/* 129 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _createIconComponent = _interopRequireDefault(__webpack_require__(5));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	var IconSearchHeavy = (0, _createIconComponent["default"])({
	  content: _react["default"].createElement("g", null, _react["default"].createElement("path", {
	    d: "M30.4 52.86a23.09 23.09 0 1 1 23.09-23.1 23.12 23.12 0 0 1-23.09 23.1zm0-38.46a15.37 15.37 0 1 0 15.37 15.36A15.39 15.39 0 0 0 30.4 14.39z"
	  }), _react["default"].createElement("path", {
	    d: "M58.83 63.33a3.85 3.85 0 0 1-2.73-1.13L40.61 46.7a3.86 3.86 0 1 1 5.46-5.46l15.49 15.5a3.86 3.86 0 0 1-2.73 6.59z"
	  })),
	  height: undefined,
	  width: undefined
	});
	IconSearchHeavy.displayName = 'IconSearchHeavy';
	var _default = IconSearchHeavy;
	exports["default"] = _default;

/***/ },
/* 130 */
/***/ function(module, exports, __webpack_require__) {

	var getTimezoneOffsetInMilliseconds = __webpack_require__(601)
	var isDate = __webpack_require__(606)
	
	var MILLISECONDS_IN_HOUR = 3600000
	var MILLISECONDS_IN_MINUTE = 60000
	var DEFAULT_ADDITIONAL_DIGITS = 2
	
	var parseTokenDateTimeDelimeter = /[T ]/
	var parseTokenPlainTime = /:/
	
	// year tokens
	var parseTokenYY = /^(\d{2})$/
	var parseTokensYYY = [
	  /^([+-]\d{2})$/, // 0 additional digits
	  /^([+-]\d{3})$/, // 1 additional digit
	  /^([+-]\d{4})$/ // 2 additional digits
	]
	
	var parseTokenYYYY = /^(\d{4})/
	var parseTokensYYYYY = [
	  /^([+-]\d{4})/, // 0 additional digits
	  /^([+-]\d{5})/, // 1 additional digit
	  /^([+-]\d{6})/ // 2 additional digits
	]
	
	// date tokens
	var parseTokenMM = /^-(\d{2})$/
	var parseTokenDDD = /^-?(\d{3})$/
	var parseTokenMMDD = /^-?(\d{2})-?(\d{2})$/
	var parseTokenWww = /^-?W(\d{2})$/
	var parseTokenWwwD = /^-?W(\d{2})-?(\d{1})$/
	
	// time tokens
	var parseTokenHH = /^(\d{2}([.,]\d*)?)$/
	var parseTokenHHMM = /^(\d{2}):?(\d{2}([.,]\d*)?)$/
	var parseTokenHHMMSS = /^(\d{2}):?(\d{2}):?(\d{2}([.,]\d*)?)$/
	
	// timezone tokens
	var parseTokenTimezone = /([Z+-].*)$/
	var parseTokenTimezoneZ = /^(Z)$/
	var parseTokenTimezoneHH = /^([+-])(\d{2})$/
	var parseTokenTimezoneHHMM = /^([+-])(\d{2}):?(\d{2})$/
	
	/**
	 * @category Common Helpers
	 * @summary Convert the given argument to an instance of Date.
	 *
	 * @description
	 * Convert the given argument to an instance of Date.
	 *
	 * If the argument is an instance of Date, the function returns its clone.
	 *
	 * If the argument is a number, it is treated as a timestamp.
	 *
	 * If an argument is a string, the function tries to parse it.
	 * Function accepts complete ISO 8601 formats as well as partial implementations.
	 * ISO 8601: http://en.wikipedia.org/wiki/ISO_8601
	 *
	 * If all above fails, the function passes the given argument to Date constructor.
	 *
	 * @param {Date|String|Number} argument - the value to convert
	 * @param {Object} [options] - the object with options
	 * @param {0 | 1 | 2} [options.additionalDigits=2] - the additional number of digits in the extended year format
	 * @returns {Date} the parsed date in the local time zone
	 *
	 * @example
	 * // Convert string '2014-02-11T11:30:30' to date:
	 * var result = parse('2014-02-11T11:30:30')
	 * //=> Tue Feb 11 2014 11:30:30
	 *
	 * @example
	 * // Parse string '+02014101',
	 * // if the additional number of digits in the extended year format is 1:
	 * var result = parse('+02014101', {additionalDigits: 1})
	 * //=> Fri Apr 11 2014 00:00:00
	 */
	function parse (argument, dirtyOptions) {
	  if (isDate(argument)) {
	    // Prevent the date to lose the milliseconds when passed to new Date() in IE10
	    return new Date(argument.getTime())
	  } else if (typeof argument !== 'string') {
	    return new Date(argument)
	  }
	
	  var options = dirtyOptions || {}
	  var additionalDigits = options.additionalDigits
	  if (additionalDigits == null) {
	    additionalDigits = DEFAULT_ADDITIONAL_DIGITS
	  } else {
	    additionalDigits = Number(additionalDigits)
	  }
	
	  var dateStrings = splitDateString(argument)
	
	  var parseYearResult = parseYear(dateStrings.date, additionalDigits)
	  var year = parseYearResult.year
	  var restDateString = parseYearResult.restDateString
	
	  var date = parseDate(restDateString, year)
	
	  if (date) {
	    var timestamp = date.getTime()
	    var time = 0
	    var offset
	
	    if (dateStrings.time) {
	      time = parseTime(dateStrings.time)
	    }
	
	    if (dateStrings.timezone) {
	      offset = parseTimezone(dateStrings.timezone) * MILLISECONDS_IN_MINUTE
	    } else {
	      var fullTime = timestamp + time
	      var fullTimeDate = new Date(fullTime)
	
	      offset = getTimezoneOffsetInMilliseconds(fullTimeDate)
	
	      // Adjust time when it's coming from DST
	      var fullTimeDateNextDay = new Date(fullTime)
	      fullTimeDateNextDay.setDate(fullTimeDate.getDate() + 1)
	      var offsetDiff =
	        getTimezoneOffsetInMilliseconds(fullTimeDateNextDay) -
	        getTimezoneOffsetInMilliseconds(fullTimeDate)
	      if (offsetDiff > 0) {
	        offset += offsetDiff
	      }
	    }
	
	    return new Date(timestamp + time + offset)
	  } else {
	    return new Date(argument)
	  }
	}
	
	function splitDateString (dateString) {
	  var dateStrings = {}
	  var array = dateString.split(parseTokenDateTimeDelimeter)
	  var timeString
	
	  if (parseTokenPlainTime.test(array[0])) {
	    dateStrings.date = null
	    timeString = array[0]
	  } else {
	    dateStrings.date = array[0]
	    timeString = array[1]
	  }
	
	  if (timeString) {
	    var token = parseTokenTimezone.exec(timeString)
	    if (token) {
	      dateStrings.time = timeString.replace(token[1], '')
	      dateStrings.timezone = token[1]
	    } else {
	      dateStrings.time = timeString
	    }
	  }
	
	  return dateStrings
	}
	
	function parseYear (dateString, additionalDigits) {
	  var parseTokenYYY = parseTokensYYY[additionalDigits]
	  var parseTokenYYYYY = parseTokensYYYYY[additionalDigits]
	
	  var token
	
	  // YYYY or ±YYYYY
	  token = parseTokenYYYY.exec(dateString) || parseTokenYYYYY.exec(dateString)
	  if (token) {
	    var yearString = token[1]
	    return {
	      year: parseInt(yearString, 10),
	      restDateString: dateString.slice(yearString.length)
	    }
	  }
	
	  // YY or ±YYY
	  token = parseTokenYY.exec(dateString) || parseTokenYYY.exec(dateString)
	  if (token) {
	    var centuryString = token[1]
	    return {
	      year: parseInt(centuryString, 10) * 100,
	      restDateString: dateString.slice(centuryString.length)
	    }
	  }
	
	  // Invalid ISO-formatted year
	  return {
	    year: null
	  }
	}
	
	function parseDate (dateString, year) {
	  // Invalid ISO-formatted year
	  if (year === null) {
	    return null
	  }
	
	  var token
	  var date
	  var month
	  var week
	
	  // YYYY
	  if (dateString.length === 0) {
	    date = new Date(0)
	    date.setUTCFullYear(year)
	    return date
	  }
	
	  // YYYY-MM
	  token = parseTokenMM.exec(dateString)
	  if (token) {
	    date = new Date(0)
	    month = parseInt(token[1], 10) - 1
	    date.setUTCFullYear(year, month)
	    return date
	  }
	
	  // YYYY-DDD or YYYYDDD
	  token = parseTokenDDD.exec(dateString)
	  if (token) {
	    date = new Date(0)
	    var dayOfYear = parseInt(token[1], 10)
	    date.setUTCFullYear(year, 0, dayOfYear)
	    return date
	  }
	
	  // YYYY-MM-DD or YYYYMMDD
	  token = parseTokenMMDD.exec(dateString)
	  if (token) {
	    date = new Date(0)
	    month = parseInt(token[1], 10) - 1
	    var day = parseInt(token[2], 10)
	    date.setUTCFullYear(year, month, day)
	    return date
	  }
	
	  // YYYY-Www or YYYYWww
	  token = parseTokenWww.exec(dateString)
	  if (token) {
	    week = parseInt(token[1], 10) - 1
	    return dayOfISOYear(year, week)
	  }
	
	  // YYYY-Www-D or YYYYWwwD
	  token = parseTokenWwwD.exec(dateString)
	  if (token) {
	    week = parseInt(token[1], 10) - 1
	    var dayOfWeek = parseInt(token[2], 10) - 1
	    return dayOfISOYear(year, week, dayOfWeek)
	  }
	
	  // Invalid ISO-formatted date
	  return null
	}
	
	function parseTime (timeString) {
	  var token
	  var hours
	  var minutes
	
	  // hh
	  token = parseTokenHH.exec(timeString)
	  if (token) {
	    hours = parseFloat(token[1].replace(',', '.'))
	    return (hours % 24) * MILLISECONDS_IN_HOUR
	  }
	
	  // hh:mm or hhmm
	  token = parseTokenHHMM.exec(timeString)
	  if (token) {
	    hours = parseInt(token[1], 10)
	    minutes = parseFloat(token[2].replace(',', '.'))
	    return (hours % 24) * MILLISECONDS_IN_HOUR +
	      minutes * MILLISECONDS_IN_MINUTE
	  }
	
	  // hh:mm:ss or hhmmss
	  token = parseTokenHHMMSS.exec(timeString)
	  if (token) {
	    hours = parseInt(token[1], 10)
	    minutes = parseInt(token[2], 10)
	    var seconds = parseFloat(token[3].replace(',', '.'))
	    return (hours % 24) * MILLISECONDS_IN_HOUR +
	      minutes * MILLISECONDS_IN_MINUTE +
	      seconds * 1000
	  }
	
	  // Invalid ISO-formatted time
	  return null
	}
	
	function parseTimezone (timezoneString) {
	  var token
	  var absoluteOffset
	
	  // Z
	  token = parseTokenTimezoneZ.exec(timezoneString)
	  if (token) {
	    return 0
	  }
	
	  // ±hh
	  token = parseTokenTimezoneHH.exec(timezoneString)
	  if (token) {
	    absoluteOffset = parseInt(token[2], 10) * 60
	    return (token[1] === '+') ? -absoluteOffset : absoluteOffset
	  }
	
	  // ±hh:mm or ±hhmm
	  token = parseTokenTimezoneHHMM.exec(timezoneString)
	  if (token) {
	    absoluteOffset = parseInt(token[2], 10) * 60 + parseInt(token[3], 10)
	    return (token[1] === '+') ? -absoluteOffset : absoluteOffset
	  }
	
	  return 0
	}
	
	function dayOfISOYear (isoYear, week, day) {
	  week = week || 0
	  day = day || 0
	  var date = new Date(0)
	  date.setUTCFullYear(isoYear, 0, 4)
	  var fourthOfJanuaryDay = date.getUTCDay() || 7
	  var diff = week * 7 + day + 1 - fourthOfJanuaryDay
	  date.setUTCDate(date.getUTCDate() + diff)
	  return date
	}
	
	module.exports = parse


/***/ },
/* 131 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// 21.2.5.3 get RegExp.prototype.flags
	var anObject = __webpack_require__(15);
	module.exports = function () {
	  var that = anObject(this);
	  var result = '';
	  if (that.global) result += 'g';
	  if (that.ignoreCase) result += 'i';
	  if (that.multiline) result += 'm';
	  if (that.unicode) result += 'u';
	  if (that.sticky) result += 'y';
	  return result;
	};


/***/ },
/* 132 */
/***/ function(module, exports, __webpack_require__) {

	// fallback for non-array-like ES3 and non-enumerable old V8 strings
	var cof = __webpack_require__(53);
	// eslint-disable-next-line no-prototype-builtins
	module.exports = Object('z').propertyIsEnumerable(0) ? Object : function (it) {
	  return cof(it) == 'String' ? it.split('') : Object(it);
	};


/***/ },
/* 133 */
/***/ function(module, exports) {

	exports.f = {}.propertyIsEnumerable;


/***/ },
/* 134 */
/***/ function(module, exports, __webpack_require__) {

	var core = __webpack_require__(54);
	var global = __webpack_require__(17);
	var SHARED = '__core-js_shared__';
	var store = global[SHARED] || (global[SHARED] = {});
	
	(module.exports = function (key, value) {
	  return store[key] || (store[key] = value !== undefined ? value : {});
	})('versions', []).push({
	  version: core.version,
	  mode: __webpack_require__(82) ? 'pure' : 'global',
	  copyright: '© 2019 Denis Pushkarev (zloirock.ru)'
	});


/***/ },
/* 135 */
/***/ function(module, exports, __webpack_require__) {

	// 7.3.20 SpeciesConstructor(O, defaultConstructor)
	var anObject = __webpack_require__(15);
	var aFunction = __webpack_require__(39);
	var SPECIES = __webpack_require__(26)('species');
	module.exports = function (O, D) {
	  var C = anObject(O).constructor;
	  var S;
	  return C === undefined || (S = anObject(C)[SPECIES]) == undefined ? D : aFunction(S);
	};


/***/ },
/* 136 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Buffer) {// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.
	
	// NOTE: These type checking functions intentionally don't use `instanceof`
	// because it is fragile and can be easily faked with `Object.create()`.
	
	function isArray(arg) {
	  if (Array.isArray) {
	    return Array.isArray(arg);
	  }
	  return objectToString(arg) === '[object Array]';
	}
	exports.isArray = isArray;
	
	function isBoolean(arg) {
	  return typeof arg === 'boolean';
	}
	exports.isBoolean = isBoolean;
	
	function isNull(arg) {
	  return arg === null;
	}
	exports.isNull = isNull;
	
	function isNullOrUndefined(arg) {
	  return arg == null;
	}
	exports.isNullOrUndefined = isNullOrUndefined;
	
	function isNumber(arg) {
	  return typeof arg === 'number';
	}
	exports.isNumber = isNumber;
	
	function isString(arg) {
	  return typeof arg === 'string';
	}
	exports.isString = isString;
	
	function isSymbol(arg) {
	  return typeof arg === 'symbol';
	}
	exports.isSymbol = isSymbol;
	
	function isUndefined(arg) {
	  return arg === void 0;
	}
	exports.isUndefined = isUndefined;
	
	function isRegExp(re) {
	  return objectToString(re) === '[object RegExp]';
	}
	exports.isRegExp = isRegExp;
	
	function isObject(arg) {
	  return typeof arg === 'object' && arg !== null;
	}
	exports.isObject = isObject;
	
	function isDate(d) {
	  return objectToString(d) === '[object Date]';
	}
	exports.isDate = isDate;
	
	function isError(e) {
	  return (objectToString(e) === '[object Error]' || e instanceof Error);
	}
	exports.isError = isError;
	
	function isFunction(arg) {
	  return typeof arg === 'function';
	}
	exports.isFunction = isFunction;
	
	function isPrimitive(arg) {
	  return arg === null ||
	         typeof arg === 'boolean' ||
	         typeof arg === 'number' ||
	         typeof arg === 'string' ||
	         typeof arg === 'symbol' ||  // ES6 symbol
	         typeof arg === 'undefined';
	}
	exports.isPrimitive = isPrimitive;
	
	exports.isBuffer = Buffer.isBuffer;
	
	function objectToString(o) {
	  return Object.prototype.toString.call(o);
	}
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(31).Buffer))

/***/ },
/* 137 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = addMilliseconds;
	
	var _index = _interopRequireDefault(__webpack_require__(9));
	
	var _index2 = _interopRequireDefault(__webpack_require__(3));
	
	var _index3 = _interopRequireDefault(__webpack_require__(2));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name addMilliseconds
	 * @category Millisecond Helpers
	 * @summary Add the specified number of milliseconds to the given date.
	 *
	 * @description
	 * Add the specified number of milliseconds to the given date.
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} date - the date to be changed
	 * @param {Number} amount - the amount of milliseconds to be added. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
	 * @returns {Date} the new date with the milliseconds added
	 * @throws {TypeError} 2 arguments required
	 *
	 * @example
	 * // Add 750 milliseconds to 10 July 2014 12:45:30.000:
	 * var result = addMilliseconds(new Date(2014, 6, 10, 12, 45, 30, 0), 750)
	 * //=> Thu Jul 10 2014 12:45:30.750
	 */
	function addMilliseconds(dirtyDate, dirtyAmount) {
	  (0, _index3.default)(2, arguments);
	  var timestamp = (0, _index2.default)(dirtyDate).getTime();
	  var amount = (0, _index.default)(dirtyAmount);
	  return new Date(timestamp + amount);
	}
	
	module.exports = exports.default;

/***/ },
/* 138 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = addWeeks;
	
	var _index = _interopRequireDefault(__webpack_require__(9));
	
	var _index2 = _interopRequireDefault(__webpack_require__(74));
	
	var _index3 = _interopRequireDefault(__webpack_require__(2));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name addWeeks
	 * @category Week Helpers
	 * @summary Add the specified number of weeks to the given date.
	 *
	 * @description
	 * Add the specified number of week to the given date.
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} date - the date to be changed
	 * @param {Number} amount - the amount of weeks to be added. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
	 * @returns {Date} the new date with the weeks added
	 * @throws {TypeError} 2 arguments required
	 *
	 * @example
	 * // Add 4 weeks to 1 September 2014:
	 * var result = addWeeks(new Date(2014, 8, 1), 4)
	 * //=> Mon Sep 29 2014 00:00:00
	 */
	function addWeeks(dirtyDate, dirtyAmount) {
	  (0, _index3.default)(2, arguments);
	  var amount = (0, _index.default)(dirtyAmount);
	  var days = amount * 7;
	  return (0, _index2.default)(dirtyDate, days);
	}
	
	module.exports = exports.default;

/***/ },
/* 139 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = differenceInDays;
	
	var _index = _interopRequireDefault(__webpack_require__(3));
	
	var _index2 = _interopRequireDefault(__webpack_require__(84));
	
	var _index3 = _interopRequireDefault(__webpack_require__(2));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// Like `compareAsc` but uses local time not UTC, which is needed
	// for accurate equality comparisons of UTC timestamps that end up
	// having the same representation in local time, e.g. one hour before
	// DST ends vs. the instant that DST ends.
	function compareLocalAsc(dateLeft, dateRight) {
	  var diff = dateLeft.getFullYear() - dateRight.getFullYear() || dateLeft.getMonth() - dateRight.getMonth() || dateLeft.getDate() - dateRight.getDate() || dateLeft.getHours() - dateRight.getHours() || dateLeft.getMinutes() - dateRight.getMinutes() || dateLeft.getSeconds() - dateRight.getSeconds() || dateLeft.getMilliseconds() - dateRight.getMilliseconds();
	
	  if (diff < 0) {
	    return -1;
	  } else if (diff > 0) {
	    return 1; // Return 0 if diff is 0; return NaN if diff is NaN
	  } else {
	    return diff;
	  }
	}
	/**
	 * @name differenceInDays
	 * @category Day Helpers
	 * @summary Get the number of full days between the given dates.
	 *
	 * @description
	 * Get the number of full day periods between two dates. Fractional days are
	 * truncated towards zero.
	 *
	 * One "full day" is the distance between a local time in one day to the same
	 * local time on the next or previous day. A full day can sometimes be less than
	 * or more than 24 hours if a daylight savings change happens between two dates.
	 *
	 * To ignore DST and only measure exact 24-hour periods, use this instead:
	 * `Math.floor(differenceInHours(dateLeft, dateRight)/24)|0`.
	 *
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} dateLeft - the later date
	 * @param {Date|Number} dateRight - the earlier date
	 * @returns {Number} the number of full days according to the local timezone
	 * @throws {TypeError} 2 arguments required
	 *
	 * @example
	 * // How many full days are between
	 * // 2 July 2011 23:00:00 and 2 July 2012 00:00:00?
	 * var result = differenceInDays(
	 *   new Date(2012, 6, 2, 0, 0),
	 *   new Date(2011, 6, 2, 23, 0)
	 * )
	 * //=> 365
	 * // How many full days are between
	 * // 2 July 2011 23:59:00 and 3 July 2011 00:01:00?
	 * var result = differenceInDays(
	 *   new Date(2011, 6, 3, 0, 1),
	 *   new Date(2011, 6, 2, 23, 59)
	 * )
	 * //=> 0
	 * // How many full days are between
	 * // 1 March 2020 0:00 and 1 June 2020 0:00 ?
	 * // Note: because local time is used, the
	 * // result will always be 92 days, even in
	 * // time zones where DST starts and the
	 * // period has only 92*24-1 hours.
	 * var result = differenceInDays(
	 *   new Date(2020, 5, 1),
	 *   new Date(2020, 2, 1)
	 * )
	//=> 92
	 */
	
	
	function differenceInDays(dirtyDateLeft, dirtyDateRight) {
	  (0, _index3.default)(2, arguments);
	  var dateLeft = (0, _index.default)(dirtyDateLeft);
	  var dateRight = (0, _index.default)(dirtyDateRight);
	  var sign = compareLocalAsc(dateLeft, dateRight);
	  var difference = Math.abs((0, _index2.default)(dateLeft, dateRight));
	  dateLeft.setDate(dateLeft.getDate() - sign * difference); // Math.abs(diff in full days - diff in calendar days) === 1 if last calendar day is not full
	  // If so, result must be decreased by 1 in absolute value
	
	  var isLastDayNotFull = compareLocalAsc(dateLeft, dateRight) === -sign;
	  var result = sign * (difference - isLastDayNotFull); // Prevent negative zero
	
	  return result === 0 ? 0 : result;
	}
	
	module.exports = exports.default;

/***/ },
/* 140 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = differenceInMonths;
	
	var _index = _interopRequireDefault(__webpack_require__(3));
	
	var _index2 = _interopRequireDefault(__webpack_require__(264));
	
	var _index3 = _interopRequireDefault(__webpack_require__(98));
	
	var _index4 = _interopRequireDefault(__webpack_require__(2));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name differenceInMonths
	 * @category Month Helpers
	 * @summary Get the number of full months between the given dates.
	 *
	 * @description
	 * Get the number of full months between the given dates.
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} dateLeft - the later date
	 * @param {Date|Number} dateRight - the earlier date
	 * @returns {Number} the number of full months
	 * @throws {TypeError} 2 arguments required
	 *
	 * @example
	 * // How many full months are between 31 January 2014 and 1 September 2014?
	 * var result = differenceInMonths(new Date(2014, 8, 1), new Date(2014, 0, 31))
	 * //=> 7
	 */
	function differenceInMonths(dirtyDateLeft, dirtyDateRight) {
	  (0, _index4.default)(2, arguments);
	  var dateLeft = (0, _index.default)(dirtyDateLeft);
	  var dateRight = (0, _index.default)(dirtyDateRight);
	  var sign = (0, _index3.default)(dateLeft, dateRight);
	  var difference = Math.abs((0, _index2.default)(dateLeft, dateRight));
	  dateLeft.setMonth(dateLeft.getMonth() - sign * difference); // Math.abs(diff in full months - diff in calendar months) === 1 if last calendar month is not full
	  // If so, result must be decreased by 1 in absolute value
	
	  var isLastMonthNotFull = (0, _index3.default)(dateLeft, dateRight) === -sign;
	  var result = sign * (difference - isLastMonthNotFull); // Prevent negative zero
	
	  return result === 0 ? 0 : result;
	}
	
	module.exports = exports.default;

/***/ },
/* 141 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = startOfISOWeekYear;
	
	var _index = _interopRequireDefault(__webpack_require__(113));
	
	var _index2 = _interopRequireDefault(__webpack_require__(99));
	
	var _index3 = _interopRequireDefault(__webpack_require__(2));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name startOfISOWeekYear
	 * @category ISO Week-Numbering Year Helpers
	 * @summary Return the start of an ISO week-numbering year for the given date.
	 *
	 * @description
	 * Return the start of an ISO week-numbering year,
	 * which always starts 3 days before the year's first Thursday.
	 * The result will be in the local timezone.
	 *
	 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} date - the original date
	 * @returns {Date} the start of an ISO week-numbering year
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // The start of an ISO week-numbering year for 2 July 2005:
	 * var result = startOfISOWeekYear(new Date(2005, 6, 2))
	 * //=> Mon Jan 03 2005 00:00:00
	 */
	function startOfISOWeekYear(dirtyDate) {
	  (0, _index3.default)(1, arguments);
	  var year = (0, _index.default)(dirtyDate);
	  var fourthOfJanuary = new Date(0);
	  fourthOfJanuary.setFullYear(year, 0, 4);
	  fourthOfJanuary.setHours(0, 0, 0, 0);
	  var date = (0, _index2.default)(fourthOfJanuary);
	  return date;
	}
	
	module.exports = exports.default;

/***/ },
/* 142 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = startOfMonth;
	
	var _index = _interopRequireDefault(__webpack_require__(3));
	
	var _index2 = _interopRequireDefault(__webpack_require__(2));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name startOfMonth
	 * @category Month Helpers
	 * @summary Return the start of a month for the given date.
	 *
	 * @description
	 * Return the start of a month for the given date.
	 * The result will be in the local timezone.
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} date - the original date
	 * @returns {Date} the start of a month
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // The start of a month for 2 September 2014 11:55:00:
	 * var result = startOfMonth(new Date(2014, 8, 2, 11, 55, 0))
	 * //=> Mon Sep 01 2014 00:00:00
	 */
	function startOfMonth(dirtyDate) {
	  (0, _index2.default)(1, arguments);
	  var date = (0, _index.default)(dirtyDate);
	  date.setDate(1);
	  date.setHours(0, 0, 0, 0);
	  return date;
	}
	
	module.exports = exports.default;

/***/ },
/* 143 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = subMilliseconds;
	
	var _index = _interopRequireDefault(__webpack_require__(9));
	
	var _index2 = _interopRequireDefault(__webpack_require__(137));
	
	var _index3 = _interopRequireDefault(__webpack_require__(2));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name subMilliseconds
	 * @category Millisecond Helpers
	 * @summary Subtract the specified number of milliseconds from the given date.
	 *
	 * @description
	 * Subtract the specified number of milliseconds from the given date.
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} date - the date to be changed
	 * @param {Number} amount - the amount of milliseconds to be subtracted. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
	 * @returns {Date} the new date with the milliseconds subtracted
	 * @throws {TypeError} 2 arguments required
	 *
	 * @example
	 * // Subtract 750 milliseconds from 10 July 2014 12:45:30.000:
	 * var result = subMilliseconds(new Date(2014, 6, 10, 12, 45, 30, 0), 750)
	 * //=> Thu Jul 10 2014 12:45:29.250
	 */
	function subMilliseconds(dirtyDate, dirtyAmount) {
	  (0, _index3.default)(2, arguments);
	  var amount = (0, _index.default)(dirtyAmount);
	  return (0, _index2.default)(dirtyDate, -amount);
	}
	
	module.exports = exports.default;

/***/ },
/* 144 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.usePrevious = exports.useList = exports.useAppSetting = undefined;
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _requests = __webpack_require__(6);
	
	var api = _interopRequireWildcard(_requests);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	var appSettingCache = {};
	var useAppSetting = exports.useAppSetting = function useAppSetting(name) {
	  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
	      cache = _ref.cache;
	
	  var _React$useState = _react2.default.useState(null),
	      _React$useState2 = _slicedToArray(_React$useState, 2),
	      setting = _React$useState2[0],
	      setSetting = _React$useState2[1];
	
	  var _React$useState3 = _react2.default.useState(false),
	      _React$useState4 = _slicedToArray(_React$useState3, 2),
	      error = _React$useState4[0],
	      setError = _React$useState4[1];
	
	  var _React$useState5 = _react2.default.useState(true),
	      _React$useState6 = _slicedToArray(_React$useState5, 2),
	      loading = _React$useState6[0],
	      setLoading = _React$useState6[1];
	
	  var isPending = _react2.default.useRef(false);
	
	  _react2.default.useEffect(function () {
	    if (!isPending.current) {
	      if (cache ? !appSettingCache[name] : true) {
	        isPending.current = true;
	        setError(false);
	        setSetting(null);
	        setLoading(true);
	        api.GET_APP_SETTING_BY_NAME(name, function (setting) {
	          if (setting) {
	            appSettingCache[name] = setting;
	            isPending.current = false;
	            setSetting(setting);
	            setLoading(false);
	          }
	        }, function (err) {
	          console.error(err);
	          setError(err);
	          setLoading(false);
	        });
	      } else {
	        setLoading(false);
	        setError(false);
	        setSetting(appSettingCache[name]);
	      }
	    }
	  }, [name]);
	
	  return {
	    loading: loading,
	    error: error,
	    setting: setting
	  };
	};
	
	var useList = exports.useList = function useList(initial) {
	  var _React$useState7 = _react2.default.useState(function () {
	    if (Array.isArray(initial)) {
	      return initial;
	    } else {
	      throw new Error('The initial value for useList must be an array.');
	    }
	  }),
	      _React$useState8 = _slicedToArray(_React$useState7, 2),
	      list = _React$useState8[0],
	      setList = _React$useState8[1];
	
	  var push = function push(item) {
	    setList(function (l) {
	      return [].concat(_toConsumableArray(l), [item]);
	    });
	  };
	
	  var pop = function pop(item) {
	    setList(function (l) {
	      return [item].concat(_toConsumableArray(l));
	    });
	  };
	
	  var addAtIndex = function addAtIndex(item, index) {
	    setList(function (l) {
	      return [].concat(_toConsumableArray(l.slice(0, index)), [item], _toConsumableArray(l.slice(index)));
	    });
	  };
	
	  var removeAtIndex = function removeAtIndex(index) {
	    setList(function (l) {
	      return [].concat(_toConsumableArray(l.slice(0, index)), _toConsumableArray(l.slice(index + 1)));
	    });
	  };
	
	  var replaceAtIndex = function replaceAtIndex(item, index) {
	    setList(function (l) {
	      return [].concat(_toConsumableArray(l.slice(0, index)), [item], _toConsumableArray(l.slice(index + 1)));
	    });
	  };
	
	  return [list, { push: push, pop: pop, removeAtIndex: removeAtIndex, addAtIndex: addAtIndex, replaceAtIndex: replaceAtIndex }];
	};
	
	var usePrevious = exports.usePrevious = function usePrevious(value) {
	  var ref = _react2.default.useRef();
	
	  _react2.default.useEffect(function () {
	    ref.current = value;
	  }, [value]);
	
	  return ref.current;
	};

/***/ },
/* 145 */,
/* 146 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.defaultFieldNodes = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _flume = __webpack_require__(117);
	
	var _utilities = __webpack_require__(8);
	
	var _format = __webpack_require__(33);
	
	var _format2 = _interopRequireDefault(_format);
	
	var _store = __webpack_require__(18);
	
	var _store2 = _interopRequireDefault(_store);
	
	var _ValidationEditor = __webpack_require__(453);
	
	var _ValidationEditor2 = _interopRequireDefault(_ValidationEditor);
	
	var _CalendarInput = __webpack_require__(1070);
	
	var _CalendarInput2 = _interopRequireDefault(_CalendarInput);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	var getFieldOptionsByType = function getFieldOptionsByType() {
	  var types = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	  var context = arguments[1];
	  return ((0, _utilities.getFieldsByType)(types, _store2.default.getState().designer.wizard.fields) || []).filter(function (field) {
	    var isNotHostField = context.allowCurrentField ? true : context.hostFieldId !== field.fieldId;
	    var parentIsNotRepeater = field.parent.type.toUpperCase() !== 'REPEATER';
	    if (context.allowCurrentRepeaterFields) {
	      var isInCurrentRepeater = field.parent.id === context.parentFieldId;
	      return isNotHostField && (parentIsNotRepeater ? true : isInCurrentRepeater);
	    } else {
	      return isNotHostField && parentIsNotRepeater;
	    }
	  }).map(function (field) {
	    return {
	      label: field.label || 'Unlabeled Field',
	      value: field.fieldId,
	      description: field.name + ' - ' + field.fieldClass
	    };
	  });
	};
	
	var config = new _flume.FlumeConfig();
	config.addPortType({
	  type: 'string',
	  label: 'Text',
	  name: 'string',
	  color: _flume.Colors.green,
	  controls: [_flume.Controls.text({ name: 'string' })]
	}).addPortType({
	  type: 'number',
	  label: 'Number',
	  name: 'number',
	  color: _flume.Colors.red,
	  controls: [_flume.Controls.number({ name: 'number' })]
	}).addPortType({
	  type: 'boolean',
	  label: 'True/False',
	  name: 'boolean',
	  color: _flume.Colors.blue,
	  controls: [_flume.Controls.checkbox({ name: 'boolean', label: 'True/False' })]
	}).addPortType({
	  type: 'fieldId',
	  label: 'Field',
	  name: 'fieldId',
	  color: _flume.Colors.grey,
	  controls: [_flume.Controls.select({
	    name: 'fieldId',
	    placeholder: '[Pick a Field]',
	    getOptions: function getOptions(_, context) {
	      var fields = _store2.default.getState().designer.wizard.fields;
	      var options = Object.values(fields).filter(function (field) {
	        return context.hostFieldId !== field.fieldId && field.parent.type.toUpperCase() !== 'REPEATER';
	      }).map(function (field) {
	        return {
	          label: field.label || 'Unlabeled Field',
	          value: field.fieldId,
	          description: field.name + ' - ' + field.fieldClass
	        };
	      });
	      return options;
	    }
	  })]
	}).addPortType({
	  type: 'optionFieldId',
	  label: 'Field',
	  name: 'optionFieldId',
	  color: _flume.Colors.grey,
	  hidePort: true,
	  controls: [_flume.Controls.select({
	    name: 'optionFieldId',
	    placeholder: '[Select a Field]',
	    setValue: function setValue(newData, oldData) {
	      if (newData.optionFieldId.optionFieldId !== oldData.optionFieldId.optionFieldId) {
	        return Object.assign({}, newData, {
	          fieldOptionValues: Object.assign({}, newData.fieldOptionValues, {
	            values: []
	          })
	        });
	      } else {
	        return newData;
	      }
	    },
	    getOptions: function getOptions(_, context) {
	      var options = getFieldOptionsByType(['select', 'radio', 'serverSelect', 'serverRadio', 'MultiComplete', 'ServerMultiComplete'], context);
	      return options;
	    }
	  })]
	}).addPortType({
	  type: 'fieldOptionValues',
	  label: 'Selected Option(s)',
	  name: 'fieldOptionValues',
	  color: _flume.Colors.yellow,
	  hidePort: true,
	  controls: [_flume.Controls.multiselect({
	    name: 'values',
	    label: 'Possible Values',
	    getOptions: function getOptions(inputData) {
	      var fieldId = inputData.optionFieldId.optionFieldId;
	      var field = _store2.default.getState().designer.wizard.fields[fieldId];
	      if (!field) return [];
	
	      var options = field.options;
	
	      if (['serverSelect', 'serverRadio'].includes(field.type)) {
	        var serverOptionsCache = _store2.default.getState().designer.serverOptionsCache;
	        var cachedOptions = serverOptionsCache[field.optionsSrc + '/' + field.subOptionsSrc];
	        options = [{ value: '', label: '[No Selection]' }].concat(_toConsumableArray(cachedOptions || []));
	      }
	
	      return options.map(function (option) {
	        return {
	          label: option.label,
	          value: option.value,
	          description: option.value
	        };
	      });
	    }
	  })]
	}).addPortType({
	  type: 'checkboxFieldId',
	  label: 'Field',
	  name: 'checkboxFieldId',
	  color: _flume.Colors.grey,
	  hidePort: true,
	  controls: [_flume.Controls.select({
	    name: 'checkboxFieldId',
	    placeholder: '[Select a Field]',
	    getOptions: function getOptions(_, context) {
	      var options = getFieldOptionsByType(['checkbox', 'dependentCheck'], context);
	      return options;
	    }
	  })]
	}).addPortType({
	  type: 'textboxFieldId',
	  label: 'Field',
	  name: 'textboxFieldId',
	  color: _flume.Colors.grey,
	  hidePort: true,
	  controls: [_flume.Controls.select({
	    name: 'textboxFieldId',
	    placeholder: '[Select a Field]',
	    getOptions: function getOptions(_, context) {
	      var options = getFieldOptionsByType(['text', 'textArea'], context);
	      return options;
	    }
	  })]
	}).addPortType({
	  type: 'uploadAndSubmitFieldId',
	  label: 'Field',
	  name: 'uploadAndSubmitFieldId',
	  color: _flume.Colors.grey,
	  hidePort: true,
	  controls: [_flume.Controls.select({
	    name: 'uploadAndSubmitFieldId',
	    placeholder: '[Select a Field]',
	    getOptions: function getOptions(_, context) {
	      var options = getFieldOptionsByType(['UploadAndSubmit'], context);
	      return options;
	    }
	  })]
	}).addPortType({
	  type: 'uploadFieldId',
	  label: 'Field',
	  name: 'uploadFieldId',
	  color: _flume.Colors.grey,
	  hidePort: true,
	  controls: [_flume.Controls.select({
	    name: 'uploadFieldId',
	    placeholder: '[Select a Field]',
	    getOptions: function getOptions(_, context) {
	      var options = getFieldOptionsByType(['file'], context);
	      return options;
	    }
	  })]
	}).addPortType({
	  type: 'dateFieldId',
	  label: 'Date Field',
	  name: 'dateFieldId',
	  color: _flume.Colors.grey,
	  hidePort: true,
	  controls: [_flume.Controls.select({
	    name: 'dateFieldId',
	    placeholder: '[Select a Field]',
	    getOptions: function getOptions(_, context) {
	      var options = getFieldOptionsByType(['date'], context);
	      return options;
	    }
	  })]
	}).addPortType({
	  type: 'entityNameFieldId',
	  label: 'Entity Name Field',
	  name: 'entityNameFieldId',
	  color: _flume.Colors.grey,
	  hidePort: true,
	  controls: [_flume.Controls.select({
	    name: 'entityNameFieldId',
	    placeholder: '[Select a Field]',
	    getOptions: function getOptions(_, context) {
	      var options = getFieldOptionsByType(['EntityNameSearch'], context);
	      return options;
	    }
	  })]
	}).addPortType({
	  type: 'nameQualifiedOrgFieldId',
	  label: 'Name Qualified Org Field',
	  name: 'nameQualifiedOrgFieldId',
	  color: _flume.Colors.grey,
	  hidePort: true,
	  controls: [_flume.Controls.select({
	    name: 'nameQualifiedOrgFieldId',
	    placeholder: '[Select a Field]',
	    getOptions: function getOptions(_, context) {
	      var options = getFieldOptionsByType(['NameQualifiedOrg'], context);
	      return options;
	    }
	  })]
	}).addPortType({
	  type: 'repeaterFieldId',
	  label: 'Repeater',
	  name: 'repeaterFieldId',
	  color: _flume.Colors.grey,
	  hidePort: true,
	  controls: [_flume.Controls.select({
	    name: 'repeaterFieldId',
	    placeholder: '[Select a Field]',
	    getOptions: function getOptions(_, context) {
	      var options = getFieldOptionsByType(['repeater'], context);
	      return options;
	    }
	  })]
	}).addPortType({
	  type: 'formationLocaleFieldId',
	  label: 'Formation Locale Field',
	  name: 'formationLocaleFieldId',
	  color: _flume.Colors.grey,
	  hidePort: true,
	  controls: [_flume.Controls.select({
	    name: 'formationLocaleFieldId',
	    placeholder: '[Select a Field]',
	    getOptions: function getOptions(_, context) {
	      var options = getFieldOptionsByType(['FormationLocale'], context);
	      return options;
	    }
	  })]
	}).addPortType({
	  type: 'checkboxState',
	  label: 'Checkbox State',
	  name: 'checkboxState',
	  hidePort: true,
	  controls: [_flume.Controls.select({
	    name: 'checkboxState',
	    placeholder: '[Checked or Unchecked]',
	    options: [{ value: 'checked', label: 'Checked' }, { value: 'unchecked', label: 'Unchecked' }],
	    defaultValue: 'checked'
	  })]
	}).addPortType({
	  type: 'businessRules',
	  label: 'Business Rules',
	  name: 'businessRules',
	  color: _flume.Colors.purple,
	  controls: [_flume.Controls.custom({
	    name: 'businessRules',
	    defaultValue: [],
	    label: 'Business Rules',
	    render: function render(data, onChange, context) {
	      return _react2.default.createElement(_ValidationEditor2.default, {
	        field: Object.assign({}, context.field, {
	          businessRules: data
	        }),
	        numRules: (0, _utilities.getNumBusinessRules)(data),
	        handleChange: function handleChange(_, rules) {
	          return onChange(rules);
	        },
	        buttonClassName: 'btn flume-button'
	      });
	    }
	  })]
	}).addPortType({
	  type: 'booleanAppSetting',
	  label: 'True/False App Setting',
	  name: 'booleanAppSetting',
	  hidePort: true,
	  controls: [_flume.Controls.select({
	    name: 'booleanAppSetting',
	    defaultValue: '',
	    label: 'True/False App Setting',
	    getOptions: function getOptions() {
	      var types = _store2.default.getState().appSettingTypes.boolean || [];
	      return types.map(function (type) {
	        return {
	          value: type.NAME,
	          label: type.NAME,
	          description: type.DESCR
	        };
	      });
	    }
	  })]
	}).addPortType({
	  type: 'stringAppSetting',
	  label: 'Text App Setting',
	  name: 'stringAppSetting',
	  hidePort: true,
	  controls: [_flume.Controls.select({
	    name: 'stringAppSetting',
	    defaultValue: '',
	    label: 'Text App Setting',
	    getOptions: function getOptions() {
	      var types = _store2.default.getState().appSettingTypes.string || [];
	      return types.map(function (type) {
	        return {
	          value: type.NAME,
	          label: type.NAME,
	          description: type.DESCR
	        };
	      });
	    }
	  })]
	}).addPortType({
	  type: 'numberAppSetting',
	  label: 'Number App Setting',
	  name: 'numberAppSetting',
	  hidePort: true,
	  controls: [_flume.Controls.select({
	    name: 'numberAppSetting',
	    defaultValue: '',
	    label: 'Number App Setting',
	    getOptions: function getOptions() {
	      var types = _store2.default.getState().appSettingTypes.number || [];
	      return types.map(function (type) {
	        return {
	          value: type.NAME,
	          label: type.NAME,
	          description: type.DESCR
	        };
	      });
	    }
	  })]
	}).addPortType({
	  type: 'date',
	  label: 'Date',
	  name: 'date',
	  color: _flume.Colors.pink,
	  controls: [_flume.Controls.custom({
	    name: 'date',
	    defaultValue: (0, _format2.default)(new Date(), 'MM/dd/yyyy'),
	    label: 'Date',
	    render: function render(data, onChange, context, triggerRecalculation, control) {
	      return _react2.default.createElement(
	        'div',
	        { onMouseDown: function onMouseDown(e) {
	            return e.stopPropagation();
	          } },
	        _react2.default.createElement(_CalendarInput2.default, {
	          label: control.inputLabel,
	          value: data,
	          onChange: onChange,
	          inputDisabled: true
	        })
	      );
	    }
	  })]
	}).addPortType({
	  type: 'globalBoolean',
	  name: 'globalBoolean',
	  label: 'Global True/False Variable',
	  controls: [_flume.Controls.select({
	    label: 'Global Variable',
	    name: 'globalBoolean',
	    placeholder: '[Pick a Variable]',
	    getOptions: function getOptions(_, context) {
	      var booleans = _store2.default.getState().designer.wizard.globalVariables.boolean;
	      return booleans.order.filter(function (id) {
	        return context.currentId !== id;
	      }).map(function (id) {
	        return {
	          label: booleans.variables[id].label || 'Unlabeled Variable',
	          value: id
	        };
	      });
	    }
	  })]
	}).addPortType({
	  type: 'globalString',
	  name: 'globalString',
	  label: 'Global Text Variable',
	  controls: [_flume.Controls.select({
	    label: 'Global Variable',
	    name: 'globalString',
	    placeholder: '[Pick a Variable]',
	    getOptions: function getOptions(_, context) {
	      var strings = _store2.default.getState().designer.wizard.globalVariables.string;
	      return strings.order.filter(function (id) {
	        return context.currentId !== id;
	      }).map(function (id) {
	        return {
	          label: strings.variables[id].label || 'Unlabeled Variable',
	          value: id
	        };
	      });
	    }
	  })]
	}).addPortType({
	  type: 'globalNumber',
	  name: 'globalNumber',
	  label: 'Global Number Variable',
	  controls: [_flume.Controls.select({
	    label: 'Global Variable',
	    name: 'globalNumber',
	    placeholder: '[Pick a Variable]',
	    getOptions: function getOptions(_, context) {
	      var numbers = _store2.default.getState().designer.wizard.globalVariables.number;
	      return numbers.order.filter(function (id) {
	        return context.currentId !== id;
	      }).map(function (id) {
	        return {
	          label: numbers.variables[id].label || 'Unlabeled Variable',
	          value: id
	        };
	      });
	    }
	  })]
	}).addNodeType({
	  type: 'output',
	  label: 'Field Attributes',
	  addable: false,
	  deletable: false,
	  initialWidth: 200,
	  root: true,
	  inputs: function inputs(ports) {
	    return [ports.string({ name: 'label', label: 'Label', noControls: true }), ports.string({ name: 'description', label: 'Description', noControls: true }), ports.string({ name: 'tooltip', label: 'Tooltip', noControls: true }), ports.boolean({ name: 'active', label: 'Visible', noControls: true }), ports.boolean({ name: 'disabled', label: 'Disabled', noControls: true }), ports.boolean({
	      name: 'disabledDuringCorrection',
	      label: 'Disabled During Corrections',
	      noControls: true
	    }), ports.boolean({ name: 'required', label: 'Show Required Indicator', noControls: true }), ports.boolean({
	      name: 'includeInSummary',
	      label: 'Include in Summary',
	      noControls: true
	    }), ports.boolean({
	      name: 'hideFieldOnForm',
	      label: 'Hide Field on Form',
	      noControls: true
	    }), ports.boolean({
	      name: 'hideLabelOnForm',
	      label: 'Hide Label on Form',
	      noControls: true
	    }), ports.boolean({
	      name: 'dynamic',
	      label: 'Dynamic Data',
	      noControls: true
	    }), ports.boolean({
	      name: 'redact',
	      label: 'Redact',
	      noControls: true
	    }), ports.businessRules({ name: 'businessRules', label: 'Business Rules', noControls: true })];
	  }
	}).addNodeType({
	  type: 'booleanOutput',
	  label: 'True/False Variable',
	  initialWidth: 170,
	  root: true,
	  addable: false,
	  deletable: false,
	  inputs: function inputs(ports) {
	    return [ports.boolean({ name: 'value' })];
	  }
	}).addNodeType({
	  type: 'stringOutput',
	  label: 'Text Variable',
	  initialWidth: 170,
	  root: true,
	  addable: false,
	  deletable: false,
	  inputs: function inputs(ports) {
	    return [ports.string({ name: 'value' })];
	  }
	}).addNodeType({
	  type: 'numberOutput',
	  label: 'Number Variable',
	  initialWidth: 170,
	  root: true,
	  addable: false,
	  deletable: false,
	  inputs: function inputs(ports) {
	    return [ports.number({ name: 'value' })];
	  }
	}).addNodeType({
	  type: 'businessRuleOutput',
	  label: 'Business Rule',
	  initialWidth: 170,
	  root: true,
	  addable: false,
	  deletable: false,
	  inputs: function inputs(ports) {
	    return [ports.boolean({ name: 'isValid', label: 'Is Valid' }), ports.string({ name: 'errorMessage', label: 'Error Message' })];
	  }
	}).addNodeType({
	  type: 'wizardAttributesOutput',
	  label: 'Wizard Attributes',
	  initialWidth: 170,
	  root: true,
	  addable: false,
	  deletable: false,
	  inputs: function inputs(ports) {
	    return [ports.string({
	      name: 'formTitle',
	      label: 'Form Title',
	      noControls: true
	    }), ports.string({
	      name: 'feeDescription',
	      label: 'Fee Description',
	      noControls: true
	    }), ports.boolean({
	      name: 'internalReviewRequired',
	      label: 'Internal review is required',
	      noControls: true
	    })];
	  }
	}).addNodeType({
	  type: 'field',
	  label: 'Field',
	  description: 'Represents a field in the wizard',
	  initialWidth: 210,
	  sortIndex: 0,
	  inputs: function inputs(ports) {
	    return [ports.fieldId({ hidePort: true })];
	  },
	  outputs: function outputs(ports) {
	    return [ports.string({ name: 'label', label: 'Label' }), ports.string({ name: 'description', label: 'Description' }), ports.string({ name: 'tooltip', label: 'Tooltip' }), ports.boolean({ name: 'active', label: 'Visible' }), ports.boolean({ name: 'disabled', label: 'Disabled' }), ports.boolean({
	      name: 'disabledDuringCorrection',
	      label: 'Disabled During Corrections'
	    }), ports.boolean({ name: 'required', label: 'Show Required Indicator' }), ports.boolean({
	      name: 'includeInSummary',
	      label: 'Include in Summary'
	    }), ports.boolean({
	      name: 'hideFieldOnForm',
	      label: 'Hide Field on Form'
	    }), ports.boolean({
	      name: 'hideLabelOnForm',
	      label: 'Hide Label on Form'
	    }), ports.boolean({
	      name: 'dynamic',
	      label: 'Dynamic Data'
	    }), ports.boolean({
	      name: 'redact',
	      label: 'Redact'
	    })];
	  }
	}).addNodeType({
	  type: 'valueEqualsOneOfOptions',
	  label: 'Equals or includes one of options',
	  description: 'Outputs if a value equals or includes one of options',
	  initialWidth: 210,
	  sortIndex: 1,
	  inputs: function inputs(ports) {
	    return [ports.optionFieldId(), ports.fieldOptionValues()];
	  },
	  outputs: function outputs(ports) {
	    return [ports.boolean({ name: 'result' })];
	  }
	}).addNodeType({
	  type: 'checkboxIsInState',
	  label: 'Checkbox is in State',
	  description: 'Outputs if a checkbox is checked or unchecked',
	  initialWidth: 210,
	  sortIndex: 2,
	  inputs: function inputs(ports) {
	    return [ports.checkboxFieldId(), ports.checkboxState()];
	  },
	  outputs: function outputs(ports) {
	    return [ports.boolean({ name: 'result' })];
	  }
	}).addNodeType({
	  type: 'textbox',
	  label: 'Textbox',
	  description: 'Represents a textbox in the Wizard',
	  initialWidth: 210,
	  sortIndex: 3,
	  inputs: function inputs(ports) {
	    return [ports.textboxFieldId()];
	  },
	  outputs: function outputs(ports) {
	    return [ports.string({ name: 'value', label: 'Current Value' }), ports.number({ name: 'charCount', label: 'Character Count' })];
	  }
	}).addNodeType({
	  type: 'uploadAndSubmit',
	  label: 'Upload and Submit',
	  description: 'Represents an upload & submit control in the Wizard',
	  initialWidth: 210,
	  sortIndex: 4,
	  inputs: function inputs(ports) {
	    return [ports.uploadAndSubmitFieldId()];
	  },
	  outputs: function outputs(ports) {
	    return [ports.boolean({ name: 'isOnline', label: 'Is Filing Online' }), ports.boolean({ name: 'isMailing', label: 'Is Printing & Mailing' }), ports.boolean({ name: 'isSignatures', label: 'Is Sending for Signatures' })];
	  }
	}).addNodeType({
	  type: 'file',
	  label: 'File Upload',
	  description: 'Represents an upload control in the Wizard',
	  initialWidth: 210,
	  sortIndex: 4.1,
	  inputs: function inputs(ports) {
	    return [ports.uploadFieldId()];
	  },
	  outputs: function outputs(ports) {
	    return [ports.number({ name: 'numAttachments', label: 'Number of Attachments' })];
	  }
	}).addNodeType({
	  type: 'dateInput',
	  label: 'Date Input',
	  description: 'Outputs a date',
	  initialWidth: 210,
	  sortIndex: 5,
	  inputs: function inputs(ports) {
	    return [ports.dateFieldId()];
	  },
	  outputs: function outputs(ports) {
	    return [ports.date({ name: 'date', label: 'Date' })];
	  }
	}).addNodeType({
	  type: 'entityNameField',
	  label: 'Entity Name Field',
	  description: 'Outputs attributes of an entity name field.',
	  initialWidth: 210,
	  sortIndex: 5,
	  inputs: function inputs(ports) {
	    return [ports.entityNameFieldId()];
	  },
	  outputs: function outputs(ports) {
	    return [ports.boolean({ name: 'isReserved', label: 'Is Reserved Name' }), ports.string({ name: 'reservedName', label: 'Reserved Name' }), ports.string({ name: 'entityName', label: 'Entered Entity Name' }), ports.string({ name: 'confirmedEntityName', label: 'Confirmed Entity Name' }), ports.boolean({ name: 'additionalNameNeeded', label: 'Additional Name Needed' }), ports.string({ name: 'additionalName', label: 'Additional Name' }), ports.boolean({ name: 'consentNeeded', label: 'Consent Needed' }), ports.number({ name: 'numConsents', label: 'Number of Consents' })];
	  }
	}).addNodeType({
	  type: 'nameQualifiedOrgField',
	  label: 'Name Qualified Org Field',
	  description: 'Outputs attributes of a name qualified org field.',
	  initialWidth: 210,
	  sortIndex: 5.1,
	  inputs: function inputs(ports) {
	    return [ports.nameQualifiedOrgFieldId()];
	  },
	  outputs: function outputs(ports) {
	    return [ports.boolean({ name: 'isIndividual', label: 'Is Individual' }), ports.string({ name: 'firstName', label: 'Individual First Name' }), ports.string({ name: 'middleName', label: 'Individual Middle/Initial' }), ports.string({ name: 'lastName', label: 'Individual Last Name' }), ports.boolean({ name: 'isQualifiedOrg', label: 'Is Qualified Org' }), ports.boolean({ name: 'hasSelectedQualifiedOrg', label: 'Has Selected Qualified Org' }), ports.boolean({ name: 'isUnqualifiedOrg', label: 'Is Unqualified Org' }), ports.string({ name: 'unqualifiedOrg', label: 'Unqualified Org' })];
	  }
	}).addNodeType({
	  type: 'repeater',
	  label: 'Repeater',
	  description: 'Outputs attributes of a repeater.',
	  initialWidth: 210,
	  sortIndex: 5.2,
	  inputs: function inputs(ports) {
	    return [ports.repeaterFieldId()];
	  },
	  outputs: function outputs(ports) {
	    return [ports.number({ name: 'numRows', label: 'Number of rows' })];
	  }
	}).addNodeType({
	  type: 'formationLocaleField',
	  label: 'Formation Locale Field',
	  description: 'Outputs attributes of a formation locale field.',
	  initialWidth: 210,
	  sortIndex: 5.3,
	  inputs: function inputs(ports) {
	    return [ports.formationLocaleFieldId()];
	  },
	  outputs: function outputs(ports) {
	    return [ports.boolean({ name: 'isStateType', label: 'Selected "United States"' }), ports.boolean({ name: 'isCountryType', label: 'Selected "Country"' }), ports.boolean({ name: 'isOtherType', label: 'Selected "Other Jurisdiction' }), ports.string({ name: 'STATE', label: 'State' }), ports.string({ name: 'COUNTRY', label: 'Country' }), ports.string({ name: 'OTHER', label: 'Other Jurisdiction' })];
	  }
	}).addNodeType({
	  type: 'user',
	  label: 'Current User',
	  description: 'Outputs attributes of the current user',
	  initialWidth: 140,
	  sortIndex: 6,
	  outputs: function outputs(ports) {
	    return [ports.boolean({ name: 'isLoggedIn', label: 'Is Logged-in' }), ports.boolean({ name: 'isAdmin', label: 'Is Admin' }), ports.string({ name: 'firstName', label: 'First Name' }), ports.string({ name: 'lastName', label: 'Last Name' }), ports.string({ name: 'email', label: 'Email' })];
	  }
	}).addNodeType({
	  type: 'businessRules',
	  label: 'Business Rules',
	  description: 'Outputs a set of business rules for the current field',
	  initialWidth: 200,
	  sortIndex: 7,
	  inputs: function inputs(ports) {
	    return [ports.businessRules()];
	  },
	  outputs: function outputs(ports) {
	    return [ports.businessRules()];
	  }
	}).addNodeType({
	  type: 'businessRulesSwitch',
	  label: 'Business Rules Switch',
	  description: 'Outputs a set of business rules based on a true/false',
	  initialWidth: 200,
	  sortIndex: 8,
	  inputs: function inputs(ports) {
	    return [ports.boolean({ name: 'test' }), ports.businessRules({ name: 'rules1' }), ports.businessRules({ name: 'rules2' })];
	  },
	  outputs: function outputs(ports) {
	    return [ports.businessRules()];
	  }
	}).addNodeType({
	  type: 'metadataValue',
	  label: 'Metadata Value',
	  description: 'Outputs a specified value from the metadata',
	  initialWidth: 200,
	  sortIndex: 8.1,
	  inputs: function inputs(ports) {
	    return [ports.string({ name: 'key', label: 'Metadata key' })];
	  },
	  outputs: function outputs(ports) {
	    return [ports.string({ name: 'value', label: 'Metadata value' })];
	  }
	}).addNodeType({
	  type: 'booleanAppSetting',
	  label: 'True/False App Setting',
	  description: 'Outputs the value of a true/false app setting',
	  initialWidth: 200,
	  sortIndex: 9,
	  inputs: function inputs(ports) {
	    return [ports.booleanAppSetting()];
	  },
	  outputs: function outputs(ports) {
	    return [ports.boolean({ name: 'value' })];
	  }
	}).addNodeType({
	  type: 'stringAppSetting',
	  label: 'Text App Setting',
	  description: 'Outputs the value of a text app setting',
	  initialWidth: 200,
	  sortIndex: 10,
	  inputs: function inputs(ports) {
	    return [ports.stringAppSetting()];
	  },
	  outputs: function outputs(ports) {
	    return [ports.string({ name: 'value' })];
	  }
	}).addNodeType({
	  type: 'numberAppSetting',
	  label: 'Number App Setting',
	  description: 'Outputs the value of a number app setting',
	  initialWidth: 200,
	  sortIndex: 11,
	  inputs: function inputs(ports) {
	    return [ports.numberAppSetting()];
	  },
	  outputs: function outputs(ports) {
	    return [ports.number({ name: 'value' })];
	  }
	}).addNodeType({
	  type: 'globalBoolean',
	  label: 'Global True/False Variable',
	  description: 'Outputs the value of a global true/false variable',
	  initialWidth: 200,
	  sortIndex: 12,
	  inputs: function inputs(ports) {
	    return [ports.globalBoolean({ hidePort: true })];
	  },
	  outputs: function outputs(ports) {
	    return [ports.boolean({ name: 'value' })];
	  }
	}).addNodeType({
	  type: 'globalString',
	  label: 'Global Text Variable',
	  description: 'Outputs the value of a global text variable',
	  initialWidth: 200,
	  sortIndex: 13,
	  inputs: function inputs(ports) {
	    return [ports.globalString({ hidePort: true })];
	  },
	  outputs: function outputs(ports) {
	    return [ports.string({ name: 'value' })];
	  }
	}).addNodeType({
	  type: 'globalNumber',
	  label: 'Global Number Variable',
	  description: 'Outputs the value of a global number variable',
	  initialWidth: 200,
	  sortIndex: 14,
	  inputs: function inputs(ports) {
	    return [ports.globalNumber({ hidePort: true })];
	  },
	  outputs: function outputs(ports) {
	    return [ports.number({ name: 'value' })];
	  }
	}).addNodeType({
	  type: 'wizardSettings',
	  label: 'Wizard Settings',
	  description: 'Outputs settings of the current wizard',
	  initialWidth: 180,
	  sortIndex: 15,
	  outputs: function outputs(ports) {
	    return [ports.string({ name: 'title', label: 'Title' }), ports.string({ name: 'description', label: 'Description' }), ports.string({ name: 'formTitle', label: 'Form Title' }), ports.string({ name: 'feeDescription', label: 'Fee Description' })];
	  }
	}).addNodeType({
	  type: 'boolean',
	  label: 'True/False',
	  description: 'A boolean value of true or false',
	  initialWidth: 150,
	  sortIndex: 20,
	  inputs: function inputs(ports) {
	    return [ports.boolean()];
	  },
	  outputs: function outputs(ports) {
	    return [ports.boolean()];
	  }
	}).addNodeType({
	  type: 'and',
	  label: 'And',
	  description: "Outputs true if two provided True/False's are true",
	  initialWidth: 150,
	  sortIndex: 21,
	  inputs: function inputs(ports) {
	    return [ports.boolean({ name: 'bool1' }), ports.boolean({ name: 'bool2' })];
	  },
	  outputs: function outputs(ports) {
	    return [ports.boolean({ name: 'result' })];
	  }
	}).addNodeType({
	  type: 'or',
	  label: 'Or',
	  description: 'Outputs true if either provided True/False is true',
	  initialWidth: 150,
	  sortIndex: 22,
	  inputs: function inputs(ports) {
	    return [ports.boolean({ name: 'bool1' }), ports.boolean({ name: 'bool2' })];
	  },
	  outputs: function outputs(ports) {
	    return [ports.boolean({ name: 'result' })];
	  }
	}).addNodeType({
	  type: 'reverseBoolean',
	  label: 'Reverse True/False',
	  description: 'Reverses a True/False',
	  initialWidth: 150,
	  sortIndex: 23,
	  inputs: function inputs(ports) {
	    return [ports.boolean()];
	  },
	  outputs: function outputs(ports) {
	    return [ports.boolean({ name: 'result' })];
	  }
	}).addNodeType({
	  type: 'string',
	  label: 'Text',
	  description: 'A string of text',
	  initialWidth: 200,
	  sortIndex: 30,
	  inputs: function inputs(ports) {
	    return [ports.string()];
	  },
	  outputs: function outputs(ports) {
	    return [ports.string()];
	  }
	}).addNodeType({
	  type: 'stringSwitch',
	  label: 'Text Switch',
	  description: 'Returns a string of text based on a true/false',
	  initialWidth: 170,
	  sortIndex: 31,
	  inputs: function inputs(ports) {
	    return [ports.boolean({ name: 'test' }), ports.string({ name: 'stringIfTrue', label: 'Text if true' }), ports.string({ name: 'stringIfFalse', label: 'Text if false' })];
	  },
	  outputs: function outputs(ports) {
	    return [ports.string({ name: 'result', label: 'Text' })];
	  }
	}).addNodeType({
	  type: 'stringJoin',
	  label: 'Join Text',
	  description: 'Combines two strings of text into one string.',
	  initialWidth: 170,
	  sortIndex: 32,
	  inputs: function inputs(ports) {
	    return [ports.string({ name: 'string1', label: 'First half of the text' }), ports.string({ name: 'string2', label: 'Second half of the text' })];
	  },
	  outputs: function outputs(ports) {
	    return [ports.string({ name: 'result', label: 'Text' })];
	  }
	}).addNodeType({
	  type: 'stringEquals',
	  label: 'Text Equals',
	  description: 'Outputs if text equals another string of text.',
	  initialWidth: 170,
	  sortIndex: 33,
	  inputs: function inputs(ports) {
	    return [ports.string({ name: 'string1', label: 'First Text' }), ports.string({ name: 'string2', label: 'Second Text' }), ports.boolean({ name: 'caseSensitive', label: 'Case Sensitive' })];
	  },
	  outputs: function outputs(ports) {
	    return [ports.boolean({ name: 'result' })];
	  }
	}).addNodeType({
	  type: 'stringContains',
	  label: 'Text Contains',
	  description: 'Outputs if text contains another string of text.',
	  initialWidth: 170,
	  sortIndex: 33,
	  inputs: function inputs(ports) {
	    return [ports.string({ name: 'string1', label: 'Containing text' }), ports.string({ name: 'string2', label: 'Text to look for' }), ports.boolean({ name: 'caseSensitive', label: 'Case Sensitive' })];
	  },
	  outputs: function outputs(ports) {
	    return [ports.boolean({ name: 'result' })];
	  }
	}).addNodeType({
	  type: 'stringRegex',
	  label: 'Text Matches Regex',
	  description: 'Outputs if text matches a regex string.',
	  initialWidth: 170,
	  sortIndex: 34,
	  inputs: function inputs(ports) {
	    return [ports.string({ name: 'string', label: 'Text to check' }), ports.string({ name: 'regex', label: 'Regex' }), ports.string({ name: 'flags', label: 'Flags' })];
	  },
	  outputs: function outputs(ports) {
	    return [ports.boolean({ name: 'result' })];
	  }
	}).addNodeType({
	  type: 'number',
	  label: 'Number',
	  description: 'An integer or float',
	  initialWidth: 150,
	  sortIndex: 40,
	  inputs: function inputs(ports) {
	    return [ports.number()];
	  },
	  outputs: function outputs(ports) {
	    return [ports.number()];
	  }
	}).addNodeType({
	  type: 'addNumbers',
	  label: 'Add Numbers',
	  description: 'Add together two numbers',
	  initialWidth: 150,
	  sortIndex: 41,
	  inputs: function inputs(ports) {
	    return [ports.number({ name: 'num1' }), ports.number({ name: 'num2' })];
	  },
	  outputs: function outputs(ports) {
	    return [ports.number({ name: 'result' })];
	  }
	}).addNodeType({
	  type: 'subtractNumbers',
	  label: 'Subtract Numbers',
	  description: 'Subtract one number from another',
	  initialWidth: 150,
	  sortIndex: 42,
	  inputs: function inputs(ports) {
	    return [ports.number({ name: 'num1' }), ports.number({ name: 'num2' })];
	  },
	  outputs: function outputs(ports) {
	    return [ports.number({ name: 'result' })];
	  }
	}).addNodeType({
	  type: 'multiplyNumbers',
	  label: 'Multiply Numbers',
	  description: 'Multiply one number by another',
	  initialWidth: 150,
	  sortIndex: 43,
	  inputs: function inputs(ports) {
	    return [ports.number({ name: 'num1' }), ports.number({ name: 'num2' })];
	  },
	  outputs: function outputs(ports) {
	    return [ports.number({ name: 'result' })];
	  }
	}).addNodeType({
	  type: 'divideNumbers',
	  label: 'Divide Numbers',
	  description: 'Divide one number by another',
	  initialWidth: 150,
	  sortIndex: 44,
	  inputs: function inputs(ports) {
	    return [ports.number({ name: 'num1' }), ports.number({ name: 'num2' })];
	  },
	  outputs: function outputs(ports) {
	    return [ports.number({ name: 'result' })];
	  }
	}).addNodeType({
	  type: 'greaterThanNumber',
	  label: 'Greater Than',
	  description: 'Outputs if one number is greater than another',
	  initialWidth: 150,
	  sortIndex: 45,
	  inputs: function inputs(ports) {
	    return [ports.number({ name: 'num1', label: 'Number to compare' }), ports.number({ name: 'num2', label: 'Is greater than' })];
	  },
	  outputs: function outputs(ports) {
	    return [ports.boolean({ name: 'result' })];
	  }
	}).addNodeType({
	  type: 'lessThanNumber',
	  label: 'Less Than',
	  description: 'Outputs if one number is less than another',
	  initialWidth: 150,
	  sortIndex: 46,
	  inputs: function inputs(ports) {
	    return [ports.number({ name: 'num1', label: 'Number to compare' }), ports.number({ name: 'num2', label: 'Is less than' })];
	  },
	  outputs: function outputs(ports) {
	    return [ports.boolean({ name: 'result' })];
	  }
	}).addNodeType({
	  type: 'numbersEqual',
	  label: 'Number Equals',
	  description: 'Outputs if one number equals another number',
	  initialWidth: 150,
	  sortIndex: 47,
	  inputs: function inputs(ports) {
	    return [ports.number({ name: 'num1' }), ports.number({ name: 'num2' })];
	  },
	  outputs: function outputs(ports) {
	    return [ports.boolean({ name: 'result' })];
	  }
	}).addNodeType({
	  type: 'numberToString',
	  label: 'Number To Text',
	  description: 'Converts a number to text',
	  initialWidth: 150,
	  sortIndex: 48,
	  inputs: function inputs(ports) {
	    return [ports.number({ name: 'num' })];
	  },
	  outputs: function outputs(ports) {
	    return [ports.string({ name: 'result' })];
	  }
	}).addNodeType({
	  type: 'stringToNumber',
	  label: 'Text To Number',
	  description: 'Attempts to convert text to a number. Defaults to 0 if conversion fails.',
	  initialWidth: 160,
	  sortIndex: 48,
	  inputs: function inputs(ports) {
	    return [ports.string({ name: 'string' })];
	  },
	  outputs: function outputs(ports) {
	    return [ports.number({ name: 'result' }), ports.boolean({ name: 'succeeded', label: 'Conversion Succeeded' })];
	  }
	}).addNodeType({
	  type: 'date',
	  label: 'Date',
	  description: 'Outputs a date',
	  initialWidth: 160,
	  sortIndex: 50,
	  inputs: function inputs(ports) {
	    return [ports.date()];
	  },
	  outputs: function outputs(ports) {
	    return [ports.date()];
	  }
	}).addNodeType({
	  type: 'isBeforeDate',
	  label: 'Is Before Date',
	  description: 'Outputs if a date is before another date',
	  initialWidth: 160,
	  sortIndex: 51,
	  inputs: function inputs(ports) {
	    return [ports.date({ name: 'date', label: 'Date to Compare' }), ports.date({ name: 'isBeforeDate', label: 'Date is Before' })];
	  },
	  outputs: function outputs(ports) {
	    return [ports.boolean({ name: 'result' })];
	  }
	}).addNodeType({
	  type: 'isAfterDate',
	  label: 'Is After Date',
	  description: 'Outputs if a date is after another date',
	  initialWidth: 160,
	  sortIndex: 52,
	  inputs: function inputs(ports) {
	    return [ports.date({ name: 'date', label: 'Date to Compare' }), ports.date({ name: 'isAfterDate', label: 'Date is After' })];
	  },
	  outputs: function outputs(ports) {
	    return [ports.boolean({ name: 'result' })];
	  }
	}).addNodeType({
	  type: 'datesEqual',
	  label: 'Dates equal',
	  description: 'Outputs if a date is the same as another date',
	  initialWidth: 160,
	  sortIndex: 53,
	  inputs: function inputs(ports) {
	    return [ports.date({ name: 'date1', label: 'Date' }), ports.date({ name: 'date2', label: 'Date' })];
	  },
	  outputs: function outputs(ports) {
	    return [ports.boolean({ name: 'result' })];
	  }
	});
	
	exports.default = config;
	var defaultFieldNodes = exports.defaultFieldNodes = [{
	  x: 355,
	  y: -190,
	  type: 'output',
	  width: 170
	}];

/***/ },
/* 147 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var FileDownloader = function (_Component) {
		_inherits(FileDownloader, _Component);
	
		function FileDownloader() {
			_classCallCheck(this, FileDownloader);
	
			var _this = _possibleConstructorReturn(this, (FileDownloader.__proto__ || Object.getPrototypeOf(FileDownloader)).call(this));
	
			_this.getURL = function () {
				var _this$props = _this.props,
				    fileString = _this$props.fileString,
				    _this$props$contentTy = _this$props.contentType,
				    contentType = _this$props$contentTy === undefined ? '' : _this$props$contentTy,
				    _this$props$charset = _this$props.charset,
				    charset = _this$props$charset === undefined ? 'utf-8' : _this$props$charset;
	
				return 'data:' + contentType + ';charset=' + charset + ',' + encodeURIComponent(fileString);
			};
	
			_this.download = function () {
				if (window.navigator.msSaveOrOpenBlob) {
					window.navigator.msSaveOrOpenBlob(_this.props.blob, _this.props.fileName);
				} else {
					_this.setState({
						mounted: true
					}, function () {
						_this.link.click();
						_this.setState({
							mounted: false
						});
					});
				}
			};
	
			_this.state = {
				mounted: false
			};
			return _this;
		}
	
		_createClass(FileDownloader, [{
			key: 'render',
			value: function render() {
				var _this2 = this;
	
				var _props = this.props,
				    _props$fileName = _props.fileName,
				    fileName = _props$fileName === undefined ? "downloaded" : _props$fileName,
				    href = _props.href;
	
				return this.state.mounted ? _react2.default.createElement('a', {
					href: href ? href : this.getURL(),
					ref: function ref(link) {
						_this2.link = link;
					},
					style: {
						visibility: 'hidden',
						opacity: 0,
						width: 1,
						height: 1,
						position: 'fixed',
						right: -1,
						bottom: -1
					},
					onClick: function onClick(e) {
						e.stopPropagation();
					},
					download: fileName
					// target="_blank"
				}) : null;
			}
		}]);
	
		return FileDownloader;
	}(_react.Component);
	
	exports.default = FileDownloader;

/***/ },
/* 148 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.InRouteRedirector = exports.LoginRedirectSwitch = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouterDom = __webpack_require__(30);
	
	var _reactRedux = __webpack_require__(7);
	
	var _redux = __webpack_require__(321);
	
	var _Shell = __webpack_require__(19);
	
	var _Login = __webpack_require__(302);
	
	var _utilities = __webpack_require__(8);
	
	var _Loaders = __webpack_require__(16);
	
	var _reactRouter = __webpack_require__(212);
	
	var _actions = __webpack_require__(29);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var LoginRedirector = function (_Component) {
	  _inherits(LoginRedirector, _Component);
	
	  function LoginRedirector() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, LoginRedirector);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = LoginRedirector.__proto__ || Object.getPrototypeOf(LoginRedirector)).call.apply(_ref, [this].concat(args))), _this), _this.redirect = function () {
	      var search = (0, _utilities.parseUrlQuery)(_this.props.location.search);
	      _this.props.history.replace((search.from || '/') + (search.search || ""));
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(LoginRedirector, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          checkingAuthState = _props.checkingAuthState,
	          location = _props.location;
	
	      return _react2.default.createElement(
	        _Shell.Body,
	        { className: 'login-redirector' },
	        checkingAuthState ? _react2.default.createElement(_Loaders.Spinner, { className: 'page-loader' }) : _react2.default.createElement(_Login.PublicLogin, { onLogin: this.redirect, location: location })
	      );
	    }
	  }]);
	
	  return LoginRedirector;
	}(_react.Component);
	
	exports.default = (0, _reactRedux.connect)(function (state) {
	  return {
	    checkingAuthState: state.auth.checkingAuthState
	  };
	})(LoginRedirector);
	var LoginRedirectSwitch = exports.LoginRedirectSwitch = function LoginRedirectSwitch(_ref2) {
	  var location = _ref2.location;
	
	  var dispatch = (0, _reactRedux.useDispatch)();
	  if (true) {
	    dispatch((0, _actions.toggleLoginModal)(true));
	    return null;
	  }
	  return _react2.default.createElement(_reactRouterDom.Redirect, { to: (0, _utilities.getAuthRedirectUrl)(location) });
	};
	
	var InRouteRedirector = exports.InRouteRedirector = function InRouteRedirector(_ref3) {
	  var location = _ref3.location,
	      loggedIn = _ref3.loggedIn;
	  return !loggedIn ? _react2.default.createElement(_reactRouterDom.Redirect, { to: (0, _utilities.getAuthRedirectUrl)(location) }) : null;
	};
	
	exports.InRouteRedirector = InRouteRedirector = (0, _redux.compose)(_reactRouter.withRouter, (0, _reactRedux.connect)(function (state) {
	  return {
	    loggedIn: state.auth.loggedIn
	  };
	}))(InRouteRedirector);

/***/ },
/* 149 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.FieldError = undefined;
	
	var _regenerator = __webpack_require__(162);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _requests = __webpack_require__(6);
	
	var _validate = __webpack_require__(45);
	
	var _AddressBlock = __webpack_require__(102);
	
	var _AddressBlock2 = _interopRequireDefault(_AddressBlock);
	
	var _WizardClasses = __webpack_require__(35);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var CreateAccountForm = function (_React$Component) {
	  _inherits(CreateAccountForm, _React$Component);
	
	  function CreateAccountForm() {
	    var _ref,
	        _this2 = this;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, CreateAccountForm);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = CreateAccountForm.__proto__ || Object.getPrototypeOf(CreateAccountForm)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      errors: {},
	      address:  true ? (0, _WizardClasses.getAddressObject)() : null,
	      emailValidationAttempts: 0
	    }, _this.checkEnter = function (e) {
	      if (e.charCode === 13) {
	        _this.validate();
	      }
	    }, _this.validateEmail = function (email) {
	      var regex = /^[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?!.*@)(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?$/gi;
	      return email.trim().length > 0 && regex.test(email);
	    }, _this.validate = _asyncToGenerator(_regenerator2.default.mark(function _callee() {
	      var emailValidationAttempts, account, errors;
	      return _regenerator2.default.wrap(function _callee$(_context) {
	        while (1) {
	          switch (_context.prev = _context.next) {
	            case 0:
	              emailValidationAttempts = _this.state.emailValidationAttempts;
	              account = {
	                firstName: _this.firstName.value,
	                middleName: _this.middleName.value,
	                lastName: _this.lastName.value,
	                orgName: ({"NODE_ENV":"production","BUILD_DATE":"2025-08-27T15:15:31.687Z","BUILD_NUMBER":"Not Provided","GIT_VERSION":"v1.3.0-381-ga81e29b08","GIT_COMMIT_HASH":"a81e29b085c9268ffd96c78eb734365802722741","GIT_BRANCH":"beta","PUBLIC_URL":"","STATE_ABBR":"MT","STATE_NAME":"Montana","STATE_ORG_TITLE":"Secretary of State","LOGIN_HEADER_IMG_PATH":"","HOME_IMG_FILENAME":"montana.jpg","FAVICON_FILE_NAME":"favicon.ico","ALLOW_E_SIGN_ON_CORRECTIONS":true,"THIRD_PARTY_SIGNING_ALLOWED":false,"MY_ACCOUNT_SAVE_AND_CLOSE_BUTTON":true,"IE_DEPRECATED_MESSAGE":"Internet Explorer is not supported. Please select a supported browser below to access this website.","ADDITIONAL_ROUTES":{"dataRequests":true,"farmBill":true,"apostille":true,"externalHelp":"https://sosmt.gov/business/help-center/","systemAdministration":[{"title":"Saved Payments","parameter":"saved-payments","componentName":"SavedPayments"}]},"SUBROUTES":[{"label":"Business","component":"Business","parameter":"business","myWorkQueueSearch":false,"sourceTypeId":54,"searchMustHaveOneOf":["FILING_TYPE_ID","STATUS_ID","STATE","search"],"serverWebSearchDescription":true,"serverWorkQueueDescription":true,"serverMyRecordsDescription":true,"searchPlaceholder":"Search by name or filing number (X########)","allowEmptySearchTerm":true,"requestCertificateAlternateLabel":"Request Information","fileAmendmentButtonLabel":"Filing Actions","advancedSearchParameters":[{"type":"radio","name":"QUERY_TYPE_ID","defaultValue":1010,"options":[{"value":1010,"label":"Starts with"},{"value":1011,"label":"Contains"},{"value":1012,"label":" Word Contains"}]},{"type":"serverSelect","name":"FILING_TYPE_ID","optionsSrc":"FILING_TYPES","label":"Entity Type","placeholder":"All","defaultValue":"0"},{"type":"serverSelect","name":"FILING_SUBTYPE_ID","optionsSrc":"FILING_SUBTYPES","label":"Entity Subtype","overrideSubOptionsSrcFromParameterName":"FILING_TYPE_ID","placeholder":"All","defaultValue":"0"},{"type":"serverSelect","name":"STATUS_ID","optionsSrc":"FILING_STATUS_WITHOUT_ALL","label":"Status","placeholder":"All","defaultValue":"0"},{"type":"serverSelect","name":"STATE","optionsSrc":"STATE","label":"State","placeholder":"All","defaultValue":""},{"type":"serverSelect","name":"COUNTY","optionsSrc":"COUNTY_SUBOPTION","label":"County","overrideSubOptionsSrcFromParameterName":"STATE","placeholder":"All","defaultValue":""},{"type":"checkbox","name":"CRA_SEARCH_YN","defaultValue":false,"label":"Search by Registered Agent PID"},{"type":"dateRange","name":"FILING_DATE","label":"Registration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}},{"type":"dateRange","name":"EXPIRATION_DATE","label":"Expiration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}}],"myRecordsFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Active"},{"value":2,"label":"Inactive"},{"value":3,"label":"Pending"}]},{"type":"dateRange","name":"DATE_RANGE","label":"Date range","defaultValue":{"start":null,"end":null}}],"myWorkQueueFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Approved"},{"value":2,"label":"Pending Online Payment"},{"value":3,"label":"Pending Review"},{"value":4,"label":"Needs Correction"},{"value":5,"label":"Rejected"},{"value":6,"label":"Draft"}]},{"type":"dateRange","name":"DATE_RANGE","label":"Date range","defaultValue":{"start":null,"end":null}}]},{"label":"Notary","component":"Notary","parameter":"notary","sourceTypeId":850,"myWorkQueueSearch":false,"allowEmptySearchTerm":true,"requestCertificateAlternateLabel":"Download Certificate","fileAmendmentButtonLabel":"Filing Actions","hideNameRequestCertificate":true,"hideAddressRequestCertificate":true,"hideRecordUserManagment":true,"searchPlaceholder":"Search by name or commission number","searchMustHaveOneOf":["CITY","search","SERVICE_TYPE"],"advancedParametersStartOpen":true,"searchIsSortable":true,"advancedSearchParameters":[{"type":"radio","name":"STARTS_WITH_YN","defaultValue":false,"options":[{"value":true,"label":"Starts with"},{"value":false,"label":"Contains"}]},{"type":"checkbox","name":"ACTIVE_ONLY_YN","defaultValue":true,"label":"Active entities only"},{"type":"text","name":"CITY","defaultValue":"","label":"City"},{"type":"select","name":"SERVICE_TYPE","label":"Special Services Offered","defaultValue":0,"options":[{"value":0,"label":"(N/A)"},{"value":6165,"label":"In-Person Electronic Notarization (IPEN)"},{"value":6166,"label":"Remote Online Notarization (RON)"},{"value":6167,"label":"Mobile Notary Services"},{"value":6168,"label":"Remote Ink Notarization (RIN)"}]}]},{"label":"Apostille","component":"Apostille","parameter":"apostille","sourceTypeId":720,"myRecordsSearch":false,"myWorkQueueSearch":false,"disabled":false,"allowedRoutes":["/forms-manager/","/queue/","/forms/"]},{"label":"Liens","component":"UCC","parameter":"ucc","sourceTypeId":1999,"myRecordsSearch":true,"myWorkQueueSearch":true,"fileAmendmentButtonLabel":"Filing Actions","searchPlaceholder":"Search by name or file number","disabled":false,"serverWebSearchDescription":true,"myRecordsDescription":"","workQueueDescription":"","searchDescription":"","hideRecordUserManagment":true,"searchLiensCheckout":false,"advancedSearchParameters":[{"type":"radio","name":"STARTS_WITH_YN","defaultValue":false,"options":[{"value":true,"label":"Starts with"},{"value":false,"label":"Contains"}]},{"type":"select","name":"STATUS","defaultValue":"ALL","label":"Status","options":[{"value":"ACTIVE_UNLAPSED","label":"Active (unlapsed)"},{"value":"ACTIVE_LAPSED_UNLAPSED","label":"Active (lapsed and unlapsed)"}]},{"type":"text","name":"EXCLUDE_VALUES","label":"Exclude Debtor Names (comma separated list of names to exclude)","defaultValue":""},{"type":"dateRange","name":"FILING_DATE","label":"Financing Statement Date","defaultValue":{"start":null,"end":null}},{"type":"dateRange","name":"LAPSE_DATE","label":"Lapse Date","defaultValue":{"start":null,"end":null}},{"type":"text","name":"CITY","label":"Debtor City","defaultValue":""}],"myRecordsFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Approved"},{"value":2,"label":"Pending Online Payment"},{"value":3,"label":"Pending Review"}]},{"type":"select","name":"TYPE","defaultValue":0,"label":"Lien Type","options":[{"value":0,"label":"All"},{"value":1,"label":"UCC"},{"value":2,"label":"EFS"},{"value":3,"label":"Title 71"}]}],"myWorkQueueFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Approved"},{"value":2,"label":"Pending Online Payment"},{"value":3,"label":"Pending Review"},{"value":4,"label":"Pending Print and Mail"},{"value":5,"label":"Rejected"},{"value":6,"label":"Draft"}]},{"type":"select","name":"TYPE","defaultValue":0,"label":"Lien Type","options":[{"value":0,"label":"All"},{"value":1,"label":"UCC"},{"value":2,"label":"EFS"},{"value":3,"label":"Title 71"}]}]},{"label":"Copy Request","component":"copies","parameter":"copies","sourceTypeId":2001,"myRecordsSearch":false,"myWorkQueueSearch":false,"disabled":false,"allowedRoutes":["/forms-manager/","/queue/","/forms/"]},{"label":"Trademark","component":"Trademark","parameter":"trademark","sourceTypeId":810,"showRequestCertificate":true,"searchMustHaveOneOf":["search","EXPIRATION_DATE","FILING_DATE"],"allowEmptySearchTerm":true,"requestCertificateAlternateLabel":"Request Information","fileAmendmentButtonLabel":"Filing Actions","advancedSearchParameters":[{"type":"radio","name":"QUERY_TYPE_ID","defaultValue":1010,"options":[{"value":1010,"label":"Starts with"},{"value":1011,"label":"Contains"},{"value":1012,"label":" Word Contains"}]},{"type":"checkbox","name":"OWNER_SEARCH_YN","defaultValue":false,"label":"Search owners"},{"type":"radio","name":"SERVICE_MARK_YN","label":"Mark Type","defaultValue":"","options":[{"value":"","label":"All Marks"},{"value":"Y","label":"Service Mark"},{"value":"N","label":"Trademark"}]},{"type":"serverSelect","name":"STATUS_ID","optionsSrc":"TYPE_V|TRADEMARK_STATUS_TYPE","label":"Status","placeholder":"All","defaultValue":"0"},{"type":"select","name":"DESIGN_TYPE_ID","options":[{"value":0,"label":"All"},{"value":990,"label":"Words Only"},{"value":991,"label":"Design Only"},{"value":992,"label":"Words and Design"}],"label":"Design Type","defaultValue":"0"},{"type":"dateRange","name":"FILING_DATE","label":"Registered Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}},{"type":"dateRange","name":"EXPIRATION_DATE","label":"Expiration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}}]},{"label":"Business Info Request","component":"InfoRequests","parameter":"info-request","sourceTypeId":167,"allowedRoutes":["/forms-manager/","/queue/","/forms/"]},{"label":"Data Requests","component":"DataRequests","parameter":"data-request","sourceTypeId":0,"allowedRoutes":["/forms-manager/"]},{"label":"CRA","component":"CRA","parameter":"cra","sourceTypeId":157,"myRecordsSearch":false,"searchPlaceholder":"Search by name or registered agent number","allowedRoutes":["/forms-manager/","/forms/","/records/","/queue/","/search/"],"allowEmptySearchTerm":true,"fileAmendmentButtonLabel":"Filing Actions","advancedSearchParameters":[{"type":"radio","name":"QUERY_TYPE_ID","defaultValue":1010,"options":[{"value":1010,"label":"Starts with"},{"value":1011,"label":"Contains"},{"value":1012,"label":" Word Contains"}]},{"type":"dateRange","name":"CRA_DATE","label":"Registration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}},{"type":"select","name":"STATUS_ID","label":"Status","defaultValue":0,"options":[{"value":0,"label":"All"},{"value":121,"label":"Active"},{"value":122,"label":"Inactive"}]},{"type":"select","name":"AGENT_TYPE_ID","label":"Agent Type","defaultValue":0,"options":[{"value":0,"label":"All"},{"value":460,"label":"Registered Agent"},{"value":461,"label":"Commercial Registered Agent"}]}]},{"label":"Farm Bill","component":"FarmBill","parameter":"farm-bill","path":"/lists/farm-bill","sourceTypeId":0,"myRecordsSearch":false,"allowedRules":["/search/"],"disabled":true,"searchDescription":"To perform a search, enter a debtor name. Your search results may include: exact debtor name, variations of that name and any filing that includes your search criteria. Punctuation is ignored.\n\nYou can click on \"Advanced\" to refine your search. Under “Advanced” you can search by crop, year, county and SSN/FEIN. As a registered Farm Bill Buyer with the Montana Secretary of State’s office it is important to maintain the confidentiality of the information contained within the Farm Bill Master List. The Farm Bill Master List reflects personal data, such as Social Security Numbers, which are a key piece of personal identifiable information to assist you in determining the existence of a lien against a specific debtor. The distribution of this information beyond its intended purpose is strictly prohibited.\n\nThe debtor's tax identification number has been hidden for confidentiality reasons. You may continue to search on a tax ID number and return debtors that match your search criteria. The SSN/FEIN must be entered without dashes or spaces.","searchMustHaveOneOf":["search","UCC_FARM_PRODUCT_ID","COUNTY"],"searchPlaceholder":"Search by debtor name","advancedSearchParameters":[{"type":"ServerMultiComplete","label":"Product code name(s)","name":"UCC_FARM_PRODUCT_ID","defaultValue":"","optionsSrc":"UCC_FARM_PRODUCT_V"},{"type":"MultiComplete","label":"Year or Range of Years","name":"YEAR_NUM","optionsSrc":"years","startYear":"1968","defaultValue":[],"preMergeOptions":[{"value":"ALL","label":"All"}]},{"type":"serverSelect","label":"State","name":"STATE","defaultValue":"MONTANA","optionsSrc":"STATE"},{"type":"ServerMultiComplete","label":"County","name":"COUNTY","defaultValue":[],"optionsSrc":"COUNTY","overrideSubOptionsSrcFromParameterName":"STATE"},{"type":"checkbox","name":"TIN_SEARCH_YN","defaultValue":false,"label":"Tax Identification Number Search"},{"type":"checkbox","name":"TIN_SORT_YN","defaultValue":false,"label":"Unique ID Sort"}]}],"SYSTEM_NICKNAME":"Online Services Portal","PAYMENT_METHODS":[{"type":"bypass"},{"type":"iTransact"}],"PAYMENT_ALLOW_AMEX":true,"SYSTEM_ID_LABEL":"System Id","DOUBLE_COLUMN_PUBLIC_LOGIN":true,"INTERNAL_USER_MANAGEMENT":true,"ALLOW_PUBLIC_JSON_IMPORT":false,"MAX_FILE_UPLOAD_SIZE":10000000,"REFUND_TEXT":"","RETURN_TO_HOME_ON_LOGOUT":true,"CURRENT_SOS_NAME":"Christi Jacobsen","LOGO_FILENAME":"mt-sos-logo.png","LOGO_ALT":"Christi Jacobsen, Montana Secretary of State","LOGO_FULL_WIDTH":true,"HOME_HIDE_AUTH_HINT":true,"HOME_TITLE":"Montana Secretary of State","CUSTOM_TAB_TITLE":"Official Montana","HOME_SUBTITLE":"Online Business Services","ENTITY_NAME_CONSENT_DESCRIPTION":"","ALLOW_USER_PROFILE_EDITING":true,"COMPARE_FOREIGN_NAME_IN_ENTITY_NAME_VALIDATION":true,"FOREIGN_NAME_FIELD_NAME":"KIMA_PARENT_NAME_INFO","LOGIN_TITLE":"Montana Secretary of State Online Filing Portal Login","PUBLIC_LOGIN_LABEL":"Username","REVERSE_LOGIN_COLUMNS":true,"LOGIN_SEAL_FILENAME":"seal_white.png","SEPARATE_USERNAME_AND_EMAIL":true,"CREATE_ACCOUNT_BUTTON_ALIGN_LEFT":true,"CREATE_ACCOUNT_BUTTON_TEXT":"CREATE AN ACCOUNT","PASSWORD_CUSTOM_ERROR_TEXT":"The password must meet all requirements","ACCOUNT_CREATED_MESSAGE":"Please check your email to verify your account to login and allow a few minutes for this message to arrive. Check your junk/spam folders if you do not find the email in your inbox.","PUBLIC_LOGIN_PLACEHOLDER":" ","DISABLE_DEFAULT_PAYMENT_RADIO":true,"CUSTOM_RESET_PASSWORD_ERROR_MESSAGE":"Username invalid - no account found","PUBLIC_LOGIN_CREATE_DESCRIPTION":"### Existing User:\n\n  - Enter your username and password to login.  \n\n\n  #### - OR -  \n\n\n\n  - Forgot password? Click 'Reset Password' and follow the prompts.\n  - Forgot username? Click 'Forgot Username' and follow the prompts.  \n\n\n  ### New User:\n  ","LOGIN_HELP_LINK":"https://sosmt.gov/business/how-do-i/","LOGIN_HELP_LINK_TEXT":"Need Help?","FORGOT_USERNAME_TEXT":"Forgot Username?","LOGIN_ACTIVE_DIRECTORY_TEXT":"State User Login","MULTIPLE_LOGIN_METHODS":true,"HAS_ACTIVE_DIRECTORY_LOGIN":true,"RESET_PASSWORD_WITH_USERNAME":true,"DOWNLOAD_LINK":true,"SHOW_USERNAME_ACCOUNT_CREATE":true,"SHOW_SCROLL_DOWN_ARROW":true,"SHOW_ADDRESS_ACCOUNT_CREATE":true,"TWO_COLUMN_ACCOUNT_CREATE":true,"RESET_PASSWORD_TIP":"A link to change your password has been sent to your email. Please allow a few minutes for this message to arrive. Please check your junk/spam folders if you do not find the email in your inbox.","FORGOT_PASSWORD_LINK_TEXT":"Reset Password","PHONE_NUMBER_OPTIONAL_ACCOUNT_CREATE":true,"SHOW_REQUIRED_INDICATOR_ACCOUNT_CREATE":true,"PASSWORD_REQUIREMENTS_ACCOUNT_CREATE":"\n    <ul>\n      <li>MUST contain at least 8 characters (12+ recommended)</li>\n      <li>MUST contain at least one uppercase letter.</li>\n      <li>MUST contain at least one lowercase letter.</li>\n      <li>MUST contain at least one number.</li>\n      <li>MUST contain at least one special character (!”#$%&'()*+,-./:;<=>?</li>\n    </ul>\n  ","ALLOW_CERTIFICATION_REQUEST":true,"ALLOW_PUBLIC_CERTIFICATE_REQUEST":true,"ALLOW_COPY_REQUEST":false,"ALLOW_CORRECTION_STYLING":true,"HIDE_DEPRECATION_WARNING":false,"AMEND_ROUTE_PUBLIC":true,"SEAL_FILENAME":"seal.png","SHOPPING_CART":true,"ALLOW_PAYMENT_UPDATE_WITH_EMPTY_CART":true,"RA_EMAIL":true,"RA_WEBSITE":true,"RA_NO_DEFAULT_TYPE":true,"RA_ADDRESS_LABEL":"Street Address","RA_TYPE_SELECTION_DEFAULT":true,"RA_DEFAULT_TYPE":"460","RA_OVERRIDE_TYPE_WITH_DEFAULT":true,"RA_PRINCIPAL_ADDRESS_AMS":true,"UPLOAD_AND_SUBMIT_HIDE_IF_ONE_OPTION":true,"PAYMENT_PROCESSING_MESSAGE":"Your payment is processing - Do not close your browser or click the back button","CHECKOUT_BUTTON_WHEN_PROCESSING_TEXT":"Processing","EFS_CROP_PICKER_NONE_LABEL":"Lien Duration","DISALLOWED_WIZARD_PIECES":["FormationLocale"],"REPEATER_SHOW_EDIT_BUTTON":true,"DATA_REQUEST_PAGE_TITLE":"Data Requests and Subscriptions","DATA_REQUEST_SIDEBAR_LABEL":"Data Requests & Subscriptions","LOGIN_REDIRECTS_TO_EPASS":false,"LOGIN_REDIRECTS_TO_ACTIVE_DIRECTORY":true,"LOGIN_ACTIVE_DIRECTORY_LINK":true,"FETCH_EDIT_USER_LINK":false,"LISTS_FETCH_AVAILABLE_LISTS":true,"POST_WIZARD_SUBMIT_REDIRECT_URL":"/","PIN_REQUEST_ATTESTATIONS":true,"PIN_REQUEST_DESCRIPTION":"Click **Request PIN** to have a new PIN sent to the account holder's email address on file.","OWNERSHIP_REQUEST_DESCRIPTION":"To become an **authorized user** of this record, a current **AUTHORIZED USER** will need to grant you access. To request access, click **Request Access** below.","PIN_REQUEST_SUCCESS_MESSAGE":"The PIN you have requested for this entity has been sent to the email associated with your user account.  You should receive the PIN in approximately 3-5 minutes, depending on your email service provider.","APOSTILLE_HEADER_LABEL":"Verification Information","APOSTILLE_NUMBER_LABEL":"Apostille/Authentication","APOSTILLE_CITY_STATE_OVERRIDE":"HELENA, MT","APOSTILLE_FILING_DATE_LABEL":"Issue Date","APOSTILLE_CITY_STATE_IN_CERTIFIED":true,"NOTARY_EXISTING_FILING":true,"ALLOW_REVOKE_OWN_ACCESS_ONLY":false,"HIDE_CANCEL_ON_ONETIME_DATA_REQUESTS":true,"DATA_REQUESTS_IN_SHOPPING_CART":true,"WQ_ALLOW_EDIT_PENDING_PAYMENT":true,"WQ_CONFIRM_ON_DELETE":true,"WQ_DELETE_CONFIRM_MESSAGE":"Deleting this filing will forfeit any money already paid to the Secretary of State. This action is permanent and cannot be undone, are you sure you would like to delete?","PASS_ITEM_GUIDS_ON_CHECKOUT":true,"FORM_REVISION_HISTORY":true,"CHECKOUT_DISCLAIMER":"By entering your credit card and/or checking account information you (i) state that **you are an authorized user** of the credit card and/or electronic check and that the associated information entered (e.g., account holder name, account number, billing address) is accurate, (ii) **you authorize payment processor to charge the amount you have requested** to your credit card and/or funding account, and (iii) **acknowledge if a charge is declined or reversed you may also be assessed a customary charge** by the payment processor for such transactions.","FARM_BILL_SEARCH_CONFIDENTIAL":"As a registered Farm Bill Buyer with the Montana Secretary of State’s office it is important to maintain the confidentiality of the information contained within the Farm Bill Master List. The Farm Bill Master List reflects personal data, such as Social Security Numbers, which are a key piece of personal identifiable information to assist you in determining the existence of a lien against a specific debtor. The distribution of this information beyond its intended purpose is strictly prohibited.\n\n**The debtor's tax identification number has been hidden for confidentiality reasons. You may continue to search on a tax ID number and return debtors that match your search criteria. The SSN/FEIN must be entered without dashes or spaces.  If you need access to the tax identification number to clearly identify the debtor, please contact the UCC unit at (406) 444-3665.**","VIEW_HISTORY_BUTTON_ALT_TEXT":"View Filings","WIZARD_ERROR_TITLE_MESSAGE":"Form Error","FARM_BILL_SEARCH_INTERACTIVE":true,"USE_FARM_BILL_API":true,"DISALLOW_ASSIGN_SELF_AS_RA":true,"DISALLOW_ASSIGN_SELF_AS_PRINCIPAL":true,"USE_TRADEMARK_OWNER_VALIDATION":true,"USE_ALTERNATIVE_FOREIGN_ADDRESS_LABELS":true,"MY_RECEIPTS_FILTER":[{"type":"dateRange","name":"DATE_RANGE","label":"Date range","defaultValue":{"start":null,"end":null}},{"type":"text","name":"REF_NUM","defaultValue":"","label":"Reference Number"},{"type":"text","name":"RECEIPT_NUM","defaultValue":"","label":"Receipt Id"},{"type":"text","name":"AMOUNT","defaultValue":"","label":"Amount"},{"type":"select","name":"TYPE","defaultValue":"","label":"Payment Type","options":[{"value":"","label":"All"},{"value":"CC","label":"Credit Card"},{"value":"Check","label":"Check"}]}],"MY_RECEIPTS_SHOW_IN_SIDEBAR":true,"SHOW_MY_RECEIPTS_HELPER_TEXT":true,"MY_RECEIPTS_HELPER_LABEL":"About Receipt Search","MY_RECEIPTS_HELPER_TEXT":"You can search for receipts based on their descriptions, including the items paid for on the receipt. Use the filters to search for or filter specific information.","FARM_BILL_SUBLINK":{"label":"Farm Bill","component":"FarmBill","parameter":"farm-bill","path":"/lists/farm-bill","sourceTypeId":0,"myRecordsSearch":false,"allowedRules":["/search/"],"disabled":true,"searchDescription":"To perform a search, enter a debtor name. Your search results may include: exact debtor name, variations of that name and any filing that includes your search criteria. Punctuation is ignored.\n\nYou can click on \"Advanced\" to refine your search. Under “Advanced” you can search by crop, year, county and SSN/FEIN. As a registered Farm Bill Buyer with the Montana Secretary of State’s office it is important to maintain the confidentiality of the information contained within the Farm Bill Master List. The Farm Bill Master List reflects personal data, such as Social Security Numbers, which are a key piece of personal identifiable information to assist you in determining the existence of a lien against a specific debtor. The distribution of this information beyond its intended purpose is strictly prohibited.\n\nThe debtor's tax identification number has been hidden for confidentiality reasons. You may continue to search on a tax ID number and return debtors that match your search criteria. The SSN/FEIN must be entered without dashes or spaces.","searchMustHaveOneOf":["search","UCC_FARM_PRODUCT_ID","COUNTY"],"searchPlaceholder":"Search by debtor name","advancedSearchParameters":[{"type":"ServerMultiComplete","label":"Product code name(s)","name":"UCC_FARM_PRODUCT_ID","defaultValue":"","optionsSrc":"UCC_FARM_PRODUCT_V"},{"type":"MultiComplete","label":"Year or Range of Years","name":"YEAR_NUM","optionsSrc":"years","startYear":"1968","defaultValue":[],"preMergeOptions":[{"value":"ALL","label":"All"}]},{"type":"serverSelect","label":"State","name":"STATE","defaultValue":"MONTANA","optionsSrc":"STATE"},{"type":"ServerMultiComplete","label":"County","name":"COUNTY","defaultValue":[],"optionsSrc":"COUNTY","overrideSubOptionsSrcFromParameterName":"STATE"},{"type":"checkbox","name":"TIN_SEARCH_YN","defaultValue":false,"label":"Tax Identification Number Search"},{"type":"checkbox","name":"TIN_SORT_YN","defaultValue":false,"label":"Unique ID Sort"}]},"ALLOW_ADDRESS_VALIDATION_BYPASS_OPTION":true,"DEFAULT_ADDRESS_VALIDATION_BYPASS_OPTION_CHECKED":true}).SHOW_ORG_NAME_ACCOUNT_CREATE ? _this.orgName.value : "",
	                username:  true ? _this.username.value : '',
	                email: _this.email.value || '',
	                phone: ({"NODE_ENV":"production","BUILD_DATE":"2025-08-27T15:15:31.687Z","BUILD_NUMBER":"Not Provided","GIT_VERSION":"v1.3.0-381-ga81e29b08","GIT_COMMIT_HASH":"a81e29b085c9268ffd96c78eb734365802722741","GIT_BRANCH":"beta","PUBLIC_URL":"","STATE_ABBR":"MT","STATE_NAME":"Montana","STATE_ORG_TITLE":"Secretary of State","LOGIN_HEADER_IMG_PATH":"","HOME_IMG_FILENAME":"montana.jpg","FAVICON_FILE_NAME":"favicon.ico","ALLOW_E_SIGN_ON_CORRECTIONS":true,"THIRD_PARTY_SIGNING_ALLOWED":false,"MY_ACCOUNT_SAVE_AND_CLOSE_BUTTON":true,"IE_DEPRECATED_MESSAGE":"Internet Explorer is not supported. Please select a supported browser below to access this website.","ADDITIONAL_ROUTES":{"dataRequests":true,"farmBill":true,"apostille":true,"externalHelp":"https://sosmt.gov/business/help-center/","systemAdministration":[{"title":"Saved Payments","parameter":"saved-payments","componentName":"SavedPayments"}]},"SUBROUTES":[{"label":"Business","component":"Business","parameter":"business","myWorkQueueSearch":false,"sourceTypeId":54,"searchMustHaveOneOf":["FILING_TYPE_ID","STATUS_ID","STATE","search"],"serverWebSearchDescription":true,"serverWorkQueueDescription":true,"serverMyRecordsDescription":true,"searchPlaceholder":"Search by name or filing number (X########)","allowEmptySearchTerm":true,"requestCertificateAlternateLabel":"Request Information","fileAmendmentButtonLabel":"Filing Actions","advancedSearchParameters":[{"type":"radio","name":"QUERY_TYPE_ID","defaultValue":1010,"options":[{"value":1010,"label":"Starts with"},{"value":1011,"label":"Contains"},{"value":1012,"label":" Word Contains"}]},{"type":"serverSelect","name":"FILING_TYPE_ID","optionsSrc":"FILING_TYPES","label":"Entity Type","placeholder":"All","defaultValue":"0"},{"type":"serverSelect","name":"FILING_SUBTYPE_ID","optionsSrc":"FILING_SUBTYPES","label":"Entity Subtype","overrideSubOptionsSrcFromParameterName":"FILING_TYPE_ID","placeholder":"All","defaultValue":"0"},{"type":"serverSelect","name":"STATUS_ID","optionsSrc":"FILING_STATUS_WITHOUT_ALL","label":"Status","placeholder":"All","defaultValue":"0"},{"type":"serverSelect","name":"STATE","optionsSrc":"STATE","label":"State","placeholder":"All","defaultValue":""},{"type":"serverSelect","name":"COUNTY","optionsSrc":"COUNTY_SUBOPTION","label":"County","overrideSubOptionsSrcFromParameterName":"STATE","placeholder":"All","defaultValue":""},{"type":"checkbox","name":"CRA_SEARCH_YN","defaultValue":false,"label":"Search by Registered Agent PID"},{"type":"dateRange","name":"FILING_DATE","label":"Registration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}},{"type":"dateRange","name":"EXPIRATION_DATE","label":"Expiration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}}],"myRecordsFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Active"},{"value":2,"label":"Inactive"},{"value":3,"label":"Pending"}]},{"type":"dateRange","name":"DATE_RANGE","label":"Date range","defaultValue":{"start":null,"end":null}}],"myWorkQueueFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Approved"},{"value":2,"label":"Pending Online Payment"},{"value":3,"label":"Pending Review"},{"value":4,"label":"Needs Correction"},{"value":5,"label":"Rejected"},{"value":6,"label":"Draft"}]},{"type":"dateRange","name":"DATE_RANGE","label":"Date range","defaultValue":{"start":null,"end":null}}]},{"label":"Notary","component":"Notary","parameter":"notary","sourceTypeId":850,"myWorkQueueSearch":false,"allowEmptySearchTerm":true,"requestCertificateAlternateLabel":"Download Certificate","fileAmendmentButtonLabel":"Filing Actions","hideNameRequestCertificate":true,"hideAddressRequestCertificate":true,"hideRecordUserManagment":true,"searchPlaceholder":"Search by name or commission number","searchMustHaveOneOf":["CITY","search","SERVICE_TYPE"],"advancedParametersStartOpen":true,"searchIsSortable":true,"advancedSearchParameters":[{"type":"radio","name":"STARTS_WITH_YN","defaultValue":false,"options":[{"value":true,"label":"Starts with"},{"value":false,"label":"Contains"}]},{"type":"checkbox","name":"ACTIVE_ONLY_YN","defaultValue":true,"label":"Active entities only"},{"type":"text","name":"CITY","defaultValue":"","label":"City"},{"type":"select","name":"SERVICE_TYPE","label":"Special Services Offered","defaultValue":0,"options":[{"value":0,"label":"(N/A)"},{"value":6165,"label":"In-Person Electronic Notarization (IPEN)"},{"value":6166,"label":"Remote Online Notarization (RON)"},{"value":6167,"label":"Mobile Notary Services"},{"value":6168,"label":"Remote Ink Notarization (RIN)"}]}]},{"label":"Apostille","component":"Apostille","parameter":"apostille","sourceTypeId":720,"myRecordsSearch":false,"myWorkQueueSearch":false,"disabled":false,"allowedRoutes":["/forms-manager/","/queue/","/forms/"]},{"label":"Liens","component":"UCC","parameter":"ucc","sourceTypeId":1999,"myRecordsSearch":true,"myWorkQueueSearch":true,"fileAmendmentButtonLabel":"Filing Actions","searchPlaceholder":"Search by name or file number","disabled":false,"serverWebSearchDescription":true,"myRecordsDescription":"","workQueueDescription":"","searchDescription":"","hideRecordUserManagment":true,"searchLiensCheckout":false,"advancedSearchParameters":[{"type":"radio","name":"STARTS_WITH_YN","defaultValue":false,"options":[{"value":true,"label":"Starts with"},{"value":false,"label":"Contains"}]},{"type":"select","name":"STATUS","defaultValue":"ALL","label":"Status","options":[{"value":"ACTIVE_UNLAPSED","label":"Active (unlapsed)"},{"value":"ACTIVE_LAPSED_UNLAPSED","label":"Active (lapsed and unlapsed)"}]},{"type":"text","name":"EXCLUDE_VALUES","label":"Exclude Debtor Names (comma separated list of names to exclude)","defaultValue":""},{"type":"dateRange","name":"FILING_DATE","label":"Financing Statement Date","defaultValue":{"start":null,"end":null}},{"type":"dateRange","name":"LAPSE_DATE","label":"Lapse Date","defaultValue":{"start":null,"end":null}},{"type":"text","name":"CITY","label":"Debtor City","defaultValue":""}],"myRecordsFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Approved"},{"value":2,"label":"Pending Online Payment"},{"value":3,"label":"Pending Review"}]},{"type":"select","name":"TYPE","defaultValue":0,"label":"Lien Type","options":[{"value":0,"label":"All"},{"value":1,"label":"UCC"},{"value":2,"label":"EFS"},{"value":3,"label":"Title 71"}]}],"myWorkQueueFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Approved"},{"value":2,"label":"Pending Online Payment"},{"value":3,"label":"Pending Review"},{"value":4,"label":"Pending Print and Mail"},{"value":5,"label":"Rejected"},{"value":6,"label":"Draft"}]},{"type":"select","name":"TYPE","defaultValue":0,"label":"Lien Type","options":[{"value":0,"label":"All"},{"value":1,"label":"UCC"},{"value":2,"label":"EFS"},{"value":3,"label":"Title 71"}]}]},{"label":"Copy Request","component":"copies","parameter":"copies","sourceTypeId":2001,"myRecordsSearch":false,"myWorkQueueSearch":false,"disabled":false,"allowedRoutes":["/forms-manager/","/queue/","/forms/"]},{"label":"Trademark","component":"Trademark","parameter":"trademark","sourceTypeId":810,"showRequestCertificate":true,"searchMustHaveOneOf":["search","EXPIRATION_DATE","FILING_DATE"],"allowEmptySearchTerm":true,"requestCertificateAlternateLabel":"Request Information","fileAmendmentButtonLabel":"Filing Actions","advancedSearchParameters":[{"type":"radio","name":"QUERY_TYPE_ID","defaultValue":1010,"options":[{"value":1010,"label":"Starts with"},{"value":1011,"label":"Contains"},{"value":1012,"label":" Word Contains"}]},{"type":"checkbox","name":"OWNER_SEARCH_YN","defaultValue":false,"label":"Search owners"},{"type":"radio","name":"SERVICE_MARK_YN","label":"Mark Type","defaultValue":"","options":[{"value":"","label":"All Marks"},{"value":"Y","label":"Service Mark"},{"value":"N","label":"Trademark"}]},{"type":"serverSelect","name":"STATUS_ID","optionsSrc":"TYPE_V|TRADEMARK_STATUS_TYPE","label":"Status","placeholder":"All","defaultValue":"0"},{"type":"select","name":"DESIGN_TYPE_ID","options":[{"value":0,"label":"All"},{"value":990,"label":"Words Only"},{"value":991,"label":"Design Only"},{"value":992,"label":"Words and Design"}],"label":"Design Type","defaultValue":"0"},{"type":"dateRange","name":"FILING_DATE","label":"Registered Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}},{"type":"dateRange","name":"EXPIRATION_DATE","label":"Expiration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}}]},{"label":"Business Info Request","component":"InfoRequests","parameter":"info-request","sourceTypeId":167,"allowedRoutes":["/forms-manager/","/queue/","/forms/"]},{"label":"Data Requests","component":"DataRequests","parameter":"data-request","sourceTypeId":0,"allowedRoutes":["/forms-manager/"]},{"label":"CRA","component":"CRA","parameter":"cra","sourceTypeId":157,"myRecordsSearch":false,"searchPlaceholder":"Search by name or registered agent number","allowedRoutes":["/forms-manager/","/forms/","/records/","/queue/","/search/"],"allowEmptySearchTerm":true,"fileAmendmentButtonLabel":"Filing Actions","advancedSearchParameters":[{"type":"radio","name":"QUERY_TYPE_ID","defaultValue":1010,"options":[{"value":1010,"label":"Starts with"},{"value":1011,"label":"Contains"},{"value":1012,"label":" Word Contains"}]},{"type":"dateRange","name":"CRA_DATE","label":"Registration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}},{"type":"select","name":"STATUS_ID","label":"Status","defaultValue":0,"options":[{"value":0,"label":"All"},{"value":121,"label":"Active"},{"value":122,"label":"Inactive"}]},{"type":"select","name":"AGENT_TYPE_ID","label":"Agent Type","defaultValue":0,"options":[{"value":0,"label":"All"},{"value":460,"label":"Registered Agent"},{"value":461,"label":"Commercial Registered Agent"}]}]},{"label":"Farm Bill","component":"FarmBill","parameter":"farm-bill","path":"/lists/farm-bill","sourceTypeId":0,"myRecordsSearch":false,"allowedRules":["/search/"],"disabled":true,"searchDescription":"To perform a search, enter a debtor name. Your search results may include: exact debtor name, variations of that name and any filing that includes your search criteria. Punctuation is ignored.\n\nYou can click on \"Advanced\" to refine your search. Under “Advanced” you can search by crop, year, county and SSN/FEIN. As a registered Farm Bill Buyer with the Montana Secretary of State’s office it is important to maintain the confidentiality of the information contained within the Farm Bill Master List. The Farm Bill Master List reflects personal data, such as Social Security Numbers, which are a key piece of personal identifiable information to assist you in determining the existence of a lien against a specific debtor. The distribution of this information beyond its intended purpose is strictly prohibited.\n\nThe debtor's tax identification number has been hidden for confidentiality reasons. You may continue to search on a tax ID number and return debtors that match your search criteria. The SSN/FEIN must be entered without dashes or spaces.","searchMustHaveOneOf":["search","UCC_FARM_PRODUCT_ID","COUNTY"],"searchPlaceholder":"Search by debtor name","advancedSearchParameters":[{"type":"ServerMultiComplete","label":"Product code name(s)","name":"UCC_FARM_PRODUCT_ID","defaultValue":"","optionsSrc":"UCC_FARM_PRODUCT_V"},{"type":"MultiComplete","label":"Year or Range of Years","name":"YEAR_NUM","optionsSrc":"years","startYear":"1968","defaultValue":[],"preMergeOptions":[{"value":"ALL","label":"All"}]},{"type":"serverSelect","label":"State","name":"STATE","defaultValue":"MONTANA","optionsSrc":"STATE"},{"type":"ServerMultiComplete","label":"County","name":"COUNTY","defaultValue":[],"optionsSrc":"COUNTY","overrideSubOptionsSrcFromParameterName":"STATE"},{"type":"checkbox","name":"TIN_SEARCH_YN","defaultValue":false,"label":"Tax Identification Number Search"},{"type":"checkbox","name":"TIN_SORT_YN","defaultValue":false,"label":"Unique ID Sort"}]}],"SYSTEM_NICKNAME":"Online Services Portal","PAYMENT_METHODS":[{"type":"bypass"},{"type":"iTransact"}],"PAYMENT_ALLOW_AMEX":true,"SYSTEM_ID_LABEL":"System Id","DOUBLE_COLUMN_PUBLIC_LOGIN":true,"INTERNAL_USER_MANAGEMENT":true,"ALLOW_PUBLIC_JSON_IMPORT":false,"MAX_FILE_UPLOAD_SIZE":10000000,"REFUND_TEXT":"","RETURN_TO_HOME_ON_LOGOUT":true,"CURRENT_SOS_NAME":"Christi Jacobsen","LOGO_FILENAME":"mt-sos-logo.png","LOGO_ALT":"Christi Jacobsen, Montana Secretary of State","LOGO_FULL_WIDTH":true,"HOME_HIDE_AUTH_HINT":true,"HOME_TITLE":"Montana Secretary of State","CUSTOM_TAB_TITLE":"Official Montana","HOME_SUBTITLE":"Online Business Services","ENTITY_NAME_CONSENT_DESCRIPTION":"","ALLOW_USER_PROFILE_EDITING":true,"COMPARE_FOREIGN_NAME_IN_ENTITY_NAME_VALIDATION":true,"FOREIGN_NAME_FIELD_NAME":"KIMA_PARENT_NAME_INFO","LOGIN_TITLE":"Montana Secretary of State Online Filing Portal Login","PUBLIC_LOGIN_LABEL":"Username","REVERSE_LOGIN_COLUMNS":true,"LOGIN_SEAL_FILENAME":"seal_white.png","SEPARATE_USERNAME_AND_EMAIL":true,"CREATE_ACCOUNT_BUTTON_ALIGN_LEFT":true,"CREATE_ACCOUNT_BUTTON_TEXT":"CREATE AN ACCOUNT","PASSWORD_CUSTOM_ERROR_TEXT":"The password must meet all requirements","ACCOUNT_CREATED_MESSAGE":"Please check your email to verify your account to login and allow a few minutes for this message to arrive. Check your junk/spam folders if you do not find the email in your inbox.","PUBLIC_LOGIN_PLACEHOLDER":" ","DISABLE_DEFAULT_PAYMENT_RADIO":true,"CUSTOM_RESET_PASSWORD_ERROR_MESSAGE":"Username invalid - no account found","PUBLIC_LOGIN_CREATE_DESCRIPTION":"### Existing User:\n\n  - Enter your username and password to login.  \n\n\n  #### - OR -  \n\n\n\n  - Forgot password? Click 'Reset Password' and follow the prompts.\n  - Forgot username? Click 'Forgot Username' and follow the prompts.  \n\n\n  ### New User:\n  ","LOGIN_HELP_LINK":"https://sosmt.gov/business/how-do-i/","LOGIN_HELP_LINK_TEXT":"Need Help?","FORGOT_USERNAME_TEXT":"Forgot Username?","LOGIN_ACTIVE_DIRECTORY_TEXT":"State User Login","MULTIPLE_LOGIN_METHODS":true,"HAS_ACTIVE_DIRECTORY_LOGIN":true,"RESET_PASSWORD_WITH_USERNAME":true,"DOWNLOAD_LINK":true,"SHOW_USERNAME_ACCOUNT_CREATE":true,"SHOW_SCROLL_DOWN_ARROW":true,"SHOW_ADDRESS_ACCOUNT_CREATE":true,"TWO_COLUMN_ACCOUNT_CREATE":true,"RESET_PASSWORD_TIP":"A link to change your password has been sent to your email. Please allow a few minutes for this message to arrive. Please check your junk/spam folders if you do not find the email in your inbox.","FORGOT_PASSWORD_LINK_TEXT":"Reset Password","PHONE_NUMBER_OPTIONAL_ACCOUNT_CREATE":true,"SHOW_REQUIRED_INDICATOR_ACCOUNT_CREATE":true,"PASSWORD_REQUIREMENTS_ACCOUNT_CREATE":"\n    <ul>\n      <li>MUST contain at least 8 characters (12+ recommended)</li>\n      <li>MUST contain at least one uppercase letter.</li>\n      <li>MUST contain at least one lowercase letter.</li>\n      <li>MUST contain at least one number.</li>\n      <li>MUST contain at least one special character (!”#$%&'()*+,-./:;<=>?</li>\n    </ul>\n  ","ALLOW_CERTIFICATION_REQUEST":true,"ALLOW_PUBLIC_CERTIFICATE_REQUEST":true,"ALLOW_COPY_REQUEST":false,"ALLOW_CORRECTION_STYLING":true,"HIDE_DEPRECATION_WARNING":false,"AMEND_ROUTE_PUBLIC":true,"SEAL_FILENAME":"seal.png","SHOPPING_CART":true,"ALLOW_PAYMENT_UPDATE_WITH_EMPTY_CART":true,"RA_EMAIL":true,"RA_WEBSITE":true,"RA_NO_DEFAULT_TYPE":true,"RA_ADDRESS_LABEL":"Street Address","RA_TYPE_SELECTION_DEFAULT":true,"RA_DEFAULT_TYPE":"460","RA_OVERRIDE_TYPE_WITH_DEFAULT":true,"RA_PRINCIPAL_ADDRESS_AMS":true,"UPLOAD_AND_SUBMIT_HIDE_IF_ONE_OPTION":true,"PAYMENT_PROCESSING_MESSAGE":"Your payment is processing - Do not close your browser or click the back button","CHECKOUT_BUTTON_WHEN_PROCESSING_TEXT":"Processing","EFS_CROP_PICKER_NONE_LABEL":"Lien Duration","DISALLOWED_WIZARD_PIECES":["FormationLocale"],"REPEATER_SHOW_EDIT_BUTTON":true,"DATA_REQUEST_PAGE_TITLE":"Data Requests and Subscriptions","DATA_REQUEST_SIDEBAR_LABEL":"Data Requests & Subscriptions","LOGIN_REDIRECTS_TO_EPASS":false,"LOGIN_REDIRECTS_TO_ACTIVE_DIRECTORY":true,"LOGIN_ACTIVE_DIRECTORY_LINK":true,"FETCH_EDIT_USER_LINK":false,"LISTS_FETCH_AVAILABLE_LISTS":true,"POST_WIZARD_SUBMIT_REDIRECT_URL":"/","PIN_REQUEST_ATTESTATIONS":true,"PIN_REQUEST_DESCRIPTION":"Click **Request PIN** to have a new PIN sent to the account holder's email address on file.","OWNERSHIP_REQUEST_DESCRIPTION":"To become an **authorized user** of this record, a current **AUTHORIZED USER** will need to grant you access. To request access, click **Request Access** below.","PIN_REQUEST_SUCCESS_MESSAGE":"The PIN you have requested for this entity has been sent to the email associated with your user account.  You should receive the PIN in approximately 3-5 minutes, depending on your email service provider.","APOSTILLE_HEADER_LABEL":"Verification Information","APOSTILLE_NUMBER_LABEL":"Apostille/Authentication","APOSTILLE_CITY_STATE_OVERRIDE":"HELENA, MT","APOSTILLE_FILING_DATE_LABEL":"Issue Date","APOSTILLE_CITY_STATE_IN_CERTIFIED":true,"NOTARY_EXISTING_FILING":true,"ALLOW_REVOKE_OWN_ACCESS_ONLY":false,"HIDE_CANCEL_ON_ONETIME_DATA_REQUESTS":true,"DATA_REQUESTS_IN_SHOPPING_CART":true,"WQ_ALLOW_EDIT_PENDING_PAYMENT":true,"WQ_CONFIRM_ON_DELETE":true,"WQ_DELETE_CONFIRM_MESSAGE":"Deleting this filing will forfeit any money already paid to the Secretary of State. This action is permanent and cannot be undone, are you sure you would like to delete?","PASS_ITEM_GUIDS_ON_CHECKOUT":true,"FORM_REVISION_HISTORY":true,"CHECKOUT_DISCLAIMER":"By entering your credit card and/or checking account information you (i) state that **you are an authorized user** of the credit card and/or electronic check and that the associated information entered (e.g., account holder name, account number, billing address) is accurate, (ii) **you authorize payment processor to charge the amount you have requested** to your credit card and/or funding account, and (iii) **acknowledge if a charge is declined or reversed you may also be assessed a customary charge** by the payment processor for such transactions.","FARM_BILL_SEARCH_CONFIDENTIAL":"As a registered Farm Bill Buyer with the Montana Secretary of State’s office it is important to maintain the confidentiality of the information contained within the Farm Bill Master List. The Farm Bill Master List reflects personal data, such as Social Security Numbers, which are a key piece of personal identifiable information to assist you in determining the existence of a lien against a specific debtor. The distribution of this information beyond its intended purpose is strictly prohibited.\n\n**The debtor's tax identification number has been hidden for confidentiality reasons. You may continue to search on a tax ID number and return debtors that match your search criteria. The SSN/FEIN must be entered without dashes or spaces.  If you need access to the tax identification number to clearly identify the debtor, please contact the UCC unit at (406) 444-3665.**","VIEW_HISTORY_BUTTON_ALT_TEXT":"View Filings","WIZARD_ERROR_TITLE_MESSAGE":"Form Error","FARM_BILL_SEARCH_INTERACTIVE":true,"USE_FARM_BILL_API":true,"DISALLOW_ASSIGN_SELF_AS_RA":true,"DISALLOW_ASSIGN_SELF_AS_PRINCIPAL":true,"USE_TRADEMARK_OWNER_VALIDATION":true,"USE_ALTERNATIVE_FOREIGN_ADDRESS_LABELS":true,"MY_RECEIPTS_FILTER":[{"type":"dateRange","name":"DATE_RANGE","label":"Date range","defaultValue":{"start":null,"end":null}},{"type":"text","name":"REF_NUM","defaultValue":"","label":"Reference Number"},{"type":"text","name":"RECEIPT_NUM","defaultValue":"","label":"Receipt Id"},{"type":"text","name":"AMOUNT","defaultValue":"","label":"Amount"},{"type":"select","name":"TYPE","defaultValue":"","label":"Payment Type","options":[{"value":"","label":"All"},{"value":"CC","label":"Credit Card"},{"value":"Check","label":"Check"}]}],"MY_RECEIPTS_SHOW_IN_SIDEBAR":true,"SHOW_MY_RECEIPTS_HELPER_TEXT":true,"MY_RECEIPTS_HELPER_LABEL":"About Receipt Search","MY_RECEIPTS_HELPER_TEXT":"You can search for receipts based on their descriptions, including the items paid for on the receipt. Use the filters to search for or filter specific information.","FARM_BILL_SUBLINK":{"label":"Farm Bill","component":"FarmBill","parameter":"farm-bill","path":"/lists/farm-bill","sourceTypeId":0,"myRecordsSearch":false,"allowedRules":["/search/"],"disabled":true,"searchDescription":"To perform a search, enter a debtor name. Your search results may include: exact debtor name, variations of that name and any filing that includes your search criteria. Punctuation is ignored.\n\nYou can click on \"Advanced\" to refine your search. Under “Advanced” you can search by crop, year, county and SSN/FEIN. As a registered Farm Bill Buyer with the Montana Secretary of State’s office it is important to maintain the confidentiality of the information contained within the Farm Bill Master List. The Farm Bill Master List reflects personal data, such as Social Security Numbers, which are a key piece of personal identifiable information to assist you in determining the existence of a lien against a specific debtor. The distribution of this information beyond its intended purpose is strictly prohibited.\n\nThe debtor's tax identification number has been hidden for confidentiality reasons. You may continue to search on a tax ID number and return debtors that match your search criteria. The SSN/FEIN must be entered without dashes or spaces.","searchMustHaveOneOf":["search","UCC_FARM_PRODUCT_ID","COUNTY"],"searchPlaceholder":"Search by debtor name","advancedSearchParameters":[{"type":"ServerMultiComplete","label":"Product code name(s)","name":"UCC_FARM_PRODUCT_ID","defaultValue":"","optionsSrc":"UCC_FARM_PRODUCT_V"},{"type":"MultiComplete","label":"Year or Range of Years","name":"YEAR_NUM","optionsSrc":"years","startYear":"1968","defaultValue":[],"preMergeOptions":[{"value":"ALL","label":"All"}]},{"type":"serverSelect","label":"State","name":"STATE","defaultValue":"MONTANA","optionsSrc":"STATE"},{"type":"ServerMultiComplete","label":"County","name":"COUNTY","defaultValue":[],"optionsSrc":"COUNTY","overrideSubOptionsSrcFromParameterName":"STATE"},{"type":"checkbox","name":"TIN_SEARCH_YN","defaultValue":false,"label":"Tax Identification Number Search"},{"type":"checkbox","name":"TIN_SORT_YN","defaultValue":false,"label":"Unique ID Sort"}]},"ALLOW_ADDRESS_VALIDATION_BYPASS_OPTION":true,"DEFAULT_ADDRESS_VALIDATION_BYPASS_OPTION_CHECKED":true}).HIDE_PHONE_ACCOUNT_CREATE ? '' : _this.phone.value,
	                address:  true ? _this.state.address : '',
	                password: _this.password.value,
	                confirmPassword: _this.confirmPassword.value
	              };
	              errors = {};
	
	              if (!account.firstName) {
	                errors.firstName = "First name is required";
	              }
	              if (!account.lastName) {
	                errors.lastName = "Last name is required";
	              }
	              if (!account.username && (true)) {
	                errors.username = "User name is required";
	              }
	
	              if (!(!account.email && !(true))) {
	                _context.next = 10;
	                break;
	              }
	
	              errors.email = "An email is required";
	              _context.next = 18;
	              break;
	
	            case 10:
	              if (_this.validateEmail(_this.email.value)) {
	                _context.next = 18;
	                break;
	              }
	
	              if (!({"NODE_ENV":"production","BUILD_DATE":"2025-08-27T15:15:31.687Z","BUILD_NUMBER":"Not Provided","GIT_VERSION":"v1.3.0-381-ga81e29b08","GIT_COMMIT_HASH":"a81e29b085c9268ffd96c78eb734365802722741","GIT_BRANCH":"beta","PUBLIC_URL":"","STATE_ABBR":"MT","STATE_NAME":"Montana","STATE_ORG_TITLE":"Secretary of State","LOGIN_HEADER_IMG_PATH":"","HOME_IMG_FILENAME":"montana.jpg","FAVICON_FILE_NAME":"favicon.ico","ALLOW_E_SIGN_ON_CORRECTIONS":true,"THIRD_PARTY_SIGNING_ALLOWED":false,"MY_ACCOUNT_SAVE_AND_CLOSE_BUTTON":true,"IE_DEPRECATED_MESSAGE":"Internet Explorer is not supported. Please select a supported browser below to access this website.","ADDITIONAL_ROUTES":{"dataRequests":true,"farmBill":true,"apostille":true,"externalHelp":"https://sosmt.gov/business/help-center/","systemAdministration":[{"title":"Saved Payments","parameter":"saved-payments","componentName":"SavedPayments"}]},"SUBROUTES":[{"label":"Business","component":"Business","parameter":"business","myWorkQueueSearch":false,"sourceTypeId":54,"searchMustHaveOneOf":["FILING_TYPE_ID","STATUS_ID","STATE","search"],"serverWebSearchDescription":true,"serverWorkQueueDescription":true,"serverMyRecordsDescription":true,"searchPlaceholder":"Search by name or filing number (X########)","allowEmptySearchTerm":true,"requestCertificateAlternateLabel":"Request Information","fileAmendmentButtonLabel":"Filing Actions","advancedSearchParameters":[{"type":"radio","name":"QUERY_TYPE_ID","defaultValue":1010,"options":[{"value":1010,"label":"Starts with"},{"value":1011,"label":"Contains"},{"value":1012,"label":" Word Contains"}]},{"type":"serverSelect","name":"FILING_TYPE_ID","optionsSrc":"FILING_TYPES","label":"Entity Type","placeholder":"All","defaultValue":"0"},{"type":"serverSelect","name":"FILING_SUBTYPE_ID","optionsSrc":"FILING_SUBTYPES","label":"Entity Subtype","overrideSubOptionsSrcFromParameterName":"FILING_TYPE_ID","placeholder":"All","defaultValue":"0"},{"type":"serverSelect","name":"STATUS_ID","optionsSrc":"FILING_STATUS_WITHOUT_ALL","label":"Status","placeholder":"All","defaultValue":"0"},{"type":"serverSelect","name":"STATE","optionsSrc":"STATE","label":"State","placeholder":"All","defaultValue":""},{"type":"serverSelect","name":"COUNTY","optionsSrc":"COUNTY_SUBOPTION","label":"County","overrideSubOptionsSrcFromParameterName":"STATE","placeholder":"All","defaultValue":""},{"type":"checkbox","name":"CRA_SEARCH_YN","defaultValue":false,"label":"Search by Registered Agent PID"},{"type":"dateRange","name":"FILING_DATE","label":"Registration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}},{"type":"dateRange","name":"EXPIRATION_DATE","label":"Expiration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}}],"myRecordsFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Active"},{"value":2,"label":"Inactive"},{"value":3,"label":"Pending"}]},{"type":"dateRange","name":"DATE_RANGE","label":"Date range","defaultValue":{"start":null,"end":null}}],"myWorkQueueFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Approved"},{"value":2,"label":"Pending Online Payment"},{"value":3,"label":"Pending Review"},{"value":4,"label":"Needs Correction"},{"value":5,"label":"Rejected"},{"value":6,"label":"Draft"}]},{"type":"dateRange","name":"DATE_RANGE","label":"Date range","defaultValue":{"start":null,"end":null}}]},{"label":"Notary","component":"Notary","parameter":"notary","sourceTypeId":850,"myWorkQueueSearch":false,"allowEmptySearchTerm":true,"requestCertificateAlternateLabel":"Download Certificate","fileAmendmentButtonLabel":"Filing Actions","hideNameRequestCertificate":true,"hideAddressRequestCertificate":true,"hideRecordUserManagment":true,"searchPlaceholder":"Search by name or commission number","searchMustHaveOneOf":["CITY","search","SERVICE_TYPE"],"advancedParametersStartOpen":true,"searchIsSortable":true,"advancedSearchParameters":[{"type":"radio","name":"STARTS_WITH_YN","defaultValue":false,"options":[{"value":true,"label":"Starts with"},{"value":false,"label":"Contains"}]},{"type":"checkbox","name":"ACTIVE_ONLY_YN","defaultValue":true,"label":"Active entities only"},{"type":"text","name":"CITY","defaultValue":"","label":"City"},{"type":"select","name":"SERVICE_TYPE","label":"Special Services Offered","defaultValue":0,"options":[{"value":0,"label":"(N/A)"},{"value":6165,"label":"In-Person Electronic Notarization (IPEN)"},{"value":6166,"label":"Remote Online Notarization (RON)"},{"value":6167,"label":"Mobile Notary Services"},{"value":6168,"label":"Remote Ink Notarization (RIN)"}]}]},{"label":"Apostille","component":"Apostille","parameter":"apostille","sourceTypeId":720,"myRecordsSearch":false,"myWorkQueueSearch":false,"disabled":false,"allowedRoutes":["/forms-manager/","/queue/","/forms/"]},{"label":"Liens","component":"UCC","parameter":"ucc","sourceTypeId":1999,"myRecordsSearch":true,"myWorkQueueSearch":true,"fileAmendmentButtonLabel":"Filing Actions","searchPlaceholder":"Search by name or file number","disabled":false,"serverWebSearchDescription":true,"myRecordsDescription":"","workQueueDescription":"","searchDescription":"","hideRecordUserManagment":true,"searchLiensCheckout":false,"advancedSearchParameters":[{"type":"radio","name":"STARTS_WITH_YN","defaultValue":false,"options":[{"value":true,"label":"Starts with"},{"value":false,"label":"Contains"}]},{"type":"select","name":"STATUS","defaultValue":"ALL","label":"Status","options":[{"value":"ACTIVE_UNLAPSED","label":"Active (unlapsed)"},{"value":"ACTIVE_LAPSED_UNLAPSED","label":"Active (lapsed and unlapsed)"}]},{"type":"text","name":"EXCLUDE_VALUES","label":"Exclude Debtor Names (comma separated list of names to exclude)","defaultValue":""},{"type":"dateRange","name":"FILING_DATE","label":"Financing Statement Date","defaultValue":{"start":null,"end":null}},{"type":"dateRange","name":"LAPSE_DATE","label":"Lapse Date","defaultValue":{"start":null,"end":null}},{"type":"text","name":"CITY","label":"Debtor City","defaultValue":""}],"myRecordsFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Approved"},{"value":2,"label":"Pending Online Payment"},{"value":3,"label":"Pending Review"}]},{"type":"select","name":"TYPE","defaultValue":0,"label":"Lien Type","options":[{"value":0,"label":"All"},{"value":1,"label":"UCC"},{"value":2,"label":"EFS"},{"value":3,"label":"Title 71"}]}],"myWorkQueueFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Approved"},{"value":2,"label":"Pending Online Payment"},{"value":3,"label":"Pending Review"},{"value":4,"label":"Pending Print and Mail"},{"value":5,"label":"Rejected"},{"value":6,"label":"Draft"}]},{"type":"select","name":"TYPE","defaultValue":0,"label":"Lien Type","options":[{"value":0,"label":"All"},{"value":1,"label":"UCC"},{"value":2,"label":"EFS"},{"value":3,"label":"Title 71"}]}]},{"label":"Copy Request","component":"copies","parameter":"copies","sourceTypeId":2001,"myRecordsSearch":false,"myWorkQueueSearch":false,"disabled":false,"allowedRoutes":["/forms-manager/","/queue/","/forms/"]},{"label":"Trademark","component":"Trademark","parameter":"trademark","sourceTypeId":810,"showRequestCertificate":true,"searchMustHaveOneOf":["search","EXPIRATION_DATE","FILING_DATE"],"allowEmptySearchTerm":true,"requestCertificateAlternateLabel":"Request Information","fileAmendmentButtonLabel":"Filing Actions","advancedSearchParameters":[{"type":"radio","name":"QUERY_TYPE_ID","defaultValue":1010,"options":[{"value":1010,"label":"Starts with"},{"value":1011,"label":"Contains"},{"value":1012,"label":" Word Contains"}]},{"type":"checkbox","name":"OWNER_SEARCH_YN","defaultValue":false,"label":"Search owners"},{"type":"radio","name":"SERVICE_MARK_YN","label":"Mark Type","defaultValue":"","options":[{"value":"","label":"All Marks"},{"value":"Y","label":"Service Mark"},{"value":"N","label":"Trademark"}]},{"type":"serverSelect","name":"STATUS_ID","optionsSrc":"TYPE_V|TRADEMARK_STATUS_TYPE","label":"Status","placeholder":"All","defaultValue":"0"},{"type":"select","name":"DESIGN_TYPE_ID","options":[{"value":0,"label":"All"},{"value":990,"label":"Words Only"},{"value":991,"label":"Design Only"},{"value":992,"label":"Words and Design"}],"label":"Design Type","defaultValue":"0"},{"type":"dateRange","name":"FILING_DATE","label":"Registered Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}},{"type":"dateRange","name":"EXPIRATION_DATE","label":"Expiration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}}]},{"label":"Business Info Request","component":"InfoRequests","parameter":"info-request","sourceTypeId":167,"allowedRoutes":["/forms-manager/","/queue/","/forms/"]},{"label":"Data Requests","component":"DataRequests","parameter":"data-request","sourceTypeId":0,"allowedRoutes":["/forms-manager/"]},{"label":"CRA","component":"CRA","parameter":"cra","sourceTypeId":157,"myRecordsSearch":false,"searchPlaceholder":"Search by name or registered agent number","allowedRoutes":["/forms-manager/","/forms/","/records/","/queue/","/search/"],"allowEmptySearchTerm":true,"fileAmendmentButtonLabel":"Filing Actions","advancedSearchParameters":[{"type":"radio","name":"QUERY_TYPE_ID","defaultValue":1010,"options":[{"value":1010,"label":"Starts with"},{"value":1011,"label":"Contains"},{"value":1012,"label":" Word Contains"}]},{"type":"dateRange","name":"CRA_DATE","label":"Registration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}},{"type":"select","name":"STATUS_ID","label":"Status","defaultValue":0,"options":[{"value":0,"label":"All"},{"value":121,"label":"Active"},{"value":122,"label":"Inactive"}]},{"type":"select","name":"AGENT_TYPE_ID","label":"Agent Type","defaultValue":0,"options":[{"value":0,"label":"All"},{"value":460,"label":"Registered Agent"},{"value":461,"label":"Commercial Registered Agent"}]}]},{"label":"Farm Bill","component":"FarmBill","parameter":"farm-bill","path":"/lists/farm-bill","sourceTypeId":0,"myRecordsSearch":false,"allowedRules":["/search/"],"disabled":true,"searchDescription":"To perform a search, enter a debtor name. Your search results may include: exact debtor name, variations of that name and any filing that includes your search criteria. Punctuation is ignored.\n\nYou can click on \"Advanced\" to refine your search. Under “Advanced” you can search by crop, year, county and SSN/FEIN. As a registered Farm Bill Buyer with the Montana Secretary of State’s office it is important to maintain the confidentiality of the information contained within the Farm Bill Master List. The Farm Bill Master List reflects personal data, such as Social Security Numbers, which are a key piece of personal identifiable information to assist you in determining the existence of a lien against a specific debtor. The distribution of this information beyond its intended purpose is strictly prohibited.\n\nThe debtor's tax identification number has been hidden for confidentiality reasons. You may continue to search on a tax ID number and return debtors that match your search criteria. The SSN/FEIN must be entered without dashes or spaces.","searchMustHaveOneOf":["search","UCC_FARM_PRODUCT_ID","COUNTY"],"searchPlaceholder":"Search by debtor name","advancedSearchParameters":[{"type":"ServerMultiComplete","label":"Product code name(s)","name":"UCC_FARM_PRODUCT_ID","defaultValue":"","optionsSrc":"UCC_FARM_PRODUCT_V"},{"type":"MultiComplete","label":"Year or Range of Years","name":"YEAR_NUM","optionsSrc":"years","startYear":"1968","defaultValue":[],"preMergeOptions":[{"value":"ALL","label":"All"}]},{"type":"serverSelect","label":"State","name":"STATE","defaultValue":"MONTANA","optionsSrc":"STATE"},{"type":"ServerMultiComplete","label":"County","name":"COUNTY","defaultValue":[],"optionsSrc":"COUNTY","overrideSubOptionsSrcFromParameterName":"STATE"},{"type":"checkbox","name":"TIN_SEARCH_YN","defaultValue":false,"label":"Tax Identification Number Search"},{"type":"checkbox","name":"TIN_SORT_YN","defaultValue":false,"label":"Unique ID Sort"}]}],"SYSTEM_NICKNAME":"Online Services Portal","PAYMENT_METHODS":[{"type":"bypass"},{"type":"iTransact"}],"PAYMENT_ALLOW_AMEX":true,"SYSTEM_ID_LABEL":"System Id","DOUBLE_COLUMN_PUBLIC_LOGIN":true,"INTERNAL_USER_MANAGEMENT":true,"ALLOW_PUBLIC_JSON_IMPORT":false,"MAX_FILE_UPLOAD_SIZE":10000000,"REFUND_TEXT":"","RETURN_TO_HOME_ON_LOGOUT":true,"CURRENT_SOS_NAME":"Christi Jacobsen","LOGO_FILENAME":"mt-sos-logo.png","LOGO_ALT":"Christi Jacobsen, Montana Secretary of State","LOGO_FULL_WIDTH":true,"HOME_HIDE_AUTH_HINT":true,"HOME_TITLE":"Montana Secretary of State","CUSTOM_TAB_TITLE":"Official Montana","HOME_SUBTITLE":"Online Business Services","ENTITY_NAME_CONSENT_DESCRIPTION":"","ALLOW_USER_PROFILE_EDITING":true,"COMPARE_FOREIGN_NAME_IN_ENTITY_NAME_VALIDATION":true,"FOREIGN_NAME_FIELD_NAME":"KIMA_PARENT_NAME_INFO","LOGIN_TITLE":"Montana Secretary of State Online Filing Portal Login","PUBLIC_LOGIN_LABEL":"Username","REVERSE_LOGIN_COLUMNS":true,"LOGIN_SEAL_FILENAME":"seal_white.png","SEPARATE_USERNAME_AND_EMAIL":true,"CREATE_ACCOUNT_BUTTON_ALIGN_LEFT":true,"CREATE_ACCOUNT_BUTTON_TEXT":"CREATE AN ACCOUNT","PASSWORD_CUSTOM_ERROR_TEXT":"The password must meet all requirements","ACCOUNT_CREATED_MESSAGE":"Please check your email to verify your account to login and allow a few minutes for this message to arrive. Check your junk/spam folders if you do not find the email in your inbox.","PUBLIC_LOGIN_PLACEHOLDER":" ","DISABLE_DEFAULT_PAYMENT_RADIO":true,"CUSTOM_RESET_PASSWORD_ERROR_MESSAGE":"Username invalid - no account found","PUBLIC_LOGIN_CREATE_DESCRIPTION":"### Existing User:\n\n  - Enter your username and password to login.  \n\n\n  #### - OR -  \n\n\n\n  - Forgot password? Click 'Reset Password' and follow the prompts.\n  - Forgot username? Click 'Forgot Username' and follow the prompts.  \n\n\n  ### New User:\n  ","LOGIN_HELP_LINK":"https://sosmt.gov/business/how-do-i/","LOGIN_HELP_LINK_TEXT":"Need Help?","FORGOT_USERNAME_TEXT":"Forgot Username?","LOGIN_ACTIVE_DIRECTORY_TEXT":"State User Login","MULTIPLE_LOGIN_METHODS":true,"HAS_ACTIVE_DIRECTORY_LOGIN":true,"RESET_PASSWORD_WITH_USERNAME":true,"DOWNLOAD_LINK":true,"SHOW_USERNAME_ACCOUNT_CREATE":true,"SHOW_SCROLL_DOWN_ARROW":true,"SHOW_ADDRESS_ACCOUNT_CREATE":true,"TWO_COLUMN_ACCOUNT_CREATE":true,"RESET_PASSWORD_TIP":"A link to change your password has been sent to your email. Please allow a few minutes for this message to arrive. Please check your junk/spam folders if you do not find the email in your inbox.","FORGOT_PASSWORD_LINK_TEXT":"Reset Password","PHONE_NUMBER_OPTIONAL_ACCOUNT_CREATE":true,"SHOW_REQUIRED_INDICATOR_ACCOUNT_CREATE":true,"PASSWORD_REQUIREMENTS_ACCOUNT_CREATE":"\n    <ul>\n      <li>MUST contain at least 8 characters (12+ recommended)</li>\n      <li>MUST contain at least one uppercase letter.</li>\n      <li>MUST contain at least one lowercase letter.</li>\n      <li>MUST contain at least one number.</li>\n      <li>MUST contain at least one special character (!”#$%&'()*+,-./:;<=>?</li>\n    </ul>\n  ","ALLOW_CERTIFICATION_REQUEST":true,"ALLOW_PUBLIC_CERTIFICATE_REQUEST":true,"ALLOW_COPY_REQUEST":false,"ALLOW_CORRECTION_STYLING":true,"HIDE_DEPRECATION_WARNING":false,"AMEND_ROUTE_PUBLIC":true,"SEAL_FILENAME":"seal.png","SHOPPING_CART":true,"ALLOW_PAYMENT_UPDATE_WITH_EMPTY_CART":true,"RA_EMAIL":true,"RA_WEBSITE":true,"RA_NO_DEFAULT_TYPE":true,"RA_ADDRESS_LABEL":"Street Address","RA_TYPE_SELECTION_DEFAULT":true,"RA_DEFAULT_TYPE":"460","RA_OVERRIDE_TYPE_WITH_DEFAULT":true,"RA_PRINCIPAL_ADDRESS_AMS":true,"UPLOAD_AND_SUBMIT_HIDE_IF_ONE_OPTION":true,"PAYMENT_PROCESSING_MESSAGE":"Your payment is processing - Do not close your browser or click the back button","CHECKOUT_BUTTON_WHEN_PROCESSING_TEXT":"Processing","EFS_CROP_PICKER_NONE_LABEL":"Lien Duration","DISALLOWED_WIZARD_PIECES":["FormationLocale"],"REPEATER_SHOW_EDIT_BUTTON":true,"DATA_REQUEST_PAGE_TITLE":"Data Requests and Subscriptions","DATA_REQUEST_SIDEBAR_LABEL":"Data Requests & Subscriptions","LOGIN_REDIRECTS_TO_EPASS":false,"LOGIN_REDIRECTS_TO_ACTIVE_DIRECTORY":true,"LOGIN_ACTIVE_DIRECTORY_LINK":true,"FETCH_EDIT_USER_LINK":false,"LISTS_FETCH_AVAILABLE_LISTS":true,"POST_WIZARD_SUBMIT_REDIRECT_URL":"/","PIN_REQUEST_ATTESTATIONS":true,"PIN_REQUEST_DESCRIPTION":"Click **Request PIN** to have a new PIN sent to the account holder's email address on file.","OWNERSHIP_REQUEST_DESCRIPTION":"To become an **authorized user** of this record, a current **AUTHORIZED USER** will need to grant you access. To request access, click **Request Access** below.","PIN_REQUEST_SUCCESS_MESSAGE":"The PIN you have requested for this entity has been sent to the email associated with your user account.  You should receive the PIN in approximately 3-5 minutes, depending on your email service provider.","APOSTILLE_HEADER_LABEL":"Verification Information","APOSTILLE_NUMBER_LABEL":"Apostille/Authentication","APOSTILLE_CITY_STATE_OVERRIDE":"HELENA, MT","APOSTILLE_FILING_DATE_LABEL":"Issue Date","APOSTILLE_CITY_STATE_IN_CERTIFIED":true,"NOTARY_EXISTING_FILING":true,"ALLOW_REVOKE_OWN_ACCESS_ONLY":false,"HIDE_CANCEL_ON_ONETIME_DATA_REQUESTS":true,"DATA_REQUESTS_IN_SHOPPING_CART":true,"WQ_ALLOW_EDIT_PENDING_PAYMENT":true,"WQ_CONFIRM_ON_DELETE":true,"WQ_DELETE_CONFIRM_MESSAGE":"Deleting this filing will forfeit any money already paid to the Secretary of State. This action is permanent and cannot be undone, are you sure you would like to delete?","PASS_ITEM_GUIDS_ON_CHECKOUT":true,"FORM_REVISION_HISTORY":true,"CHECKOUT_DISCLAIMER":"By entering your credit card and/or checking account information you (i) state that **you are an authorized user** of the credit card and/or electronic check and that the associated information entered (e.g., account holder name, account number, billing address) is accurate, (ii) **you authorize payment processor to charge the amount you have requested** to your credit card and/or funding account, and (iii) **acknowledge if a charge is declined or reversed you may also be assessed a customary charge** by the payment processor for such transactions.","FARM_BILL_SEARCH_CONFIDENTIAL":"As a registered Farm Bill Buyer with the Montana Secretary of State’s office it is important to maintain the confidentiality of the information contained within the Farm Bill Master List. The Farm Bill Master List reflects personal data, such as Social Security Numbers, which are a key piece of personal identifiable information to assist you in determining the existence of a lien against a specific debtor. The distribution of this information beyond its intended purpose is strictly prohibited.\n\n**The debtor's tax identification number has been hidden for confidentiality reasons. You may continue to search on a tax ID number and return debtors that match your search criteria. The SSN/FEIN must be entered without dashes or spaces.  If you need access to the tax identification number to clearly identify the debtor, please contact the UCC unit at (406) 444-3665.**","VIEW_HISTORY_BUTTON_ALT_TEXT":"View Filings","WIZARD_ERROR_TITLE_MESSAGE":"Form Error","FARM_BILL_SEARCH_INTERACTIVE":true,"USE_FARM_BILL_API":true,"DISALLOW_ASSIGN_SELF_AS_RA":true,"DISALLOW_ASSIGN_SELF_AS_PRINCIPAL":true,"USE_TRADEMARK_OWNER_VALIDATION":true,"USE_ALTERNATIVE_FOREIGN_ADDRESS_LABELS":true,"MY_RECEIPTS_FILTER":[{"type":"dateRange","name":"DATE_RANGE","label":"Date range","defaultValue":{"start":null,"end":null}},{"type":"text","name":"REF_NUM","defaultValue":"","label":"Reference Number"},{"type":"text","name":"RECEIPT_NUM","defaultValue":"","label":"Receipt Id"},{"type":"text","name":"AMOUNT","defaultValue":"","label":"Amount"},{"type":"select","name":"TYPE","defaultValue":"","label":"Payment Type","options":[{"value":"","label":"All"},{"value":"CC","label":"Credit Card"},{"value":"Check","label":"Check"}]}],"MY_RECEIPTS_SHOW_IN_SIDEBAR":true,"SHOW_MY_RECEIPTS_HELPER_TEXT":true,"MY_RECEIPTS_HELPER_LABEL":"About Receipt Search","MY_RECEIPTS_HELPER_TEXT":"You can search for receipts based on their descriptions, including the items paid for on the receipt. Use the filters to search for or filter specific information.","FARM_BILL_SUBLINK":{"label":"Farm Bill","component":"FarmBill","parameter":"farm-bill","path":"/lists/farm-bill","sourceTypeId":0,"myRecordsSearch":false,"allowedRules":["/search/"],"disabled":true,"searchDescription":"To perform a search, enter a debtor name. Your search results may include: exact debtor name, variations of that name and any filing that includes your search criteria. Punctuation is ignored.\n\nYou can click on \"Advanced\" to refine your search. Under “Advanced” you can search by crop, year, county and SSN/FEIN. As a registered Farm Bill Buyer with the Montana Secretary of State’s office it is important to maintain the confidentiality of the information contained within the Farm Bill Master List. The Farm Bill Master List reflects personal data, such as Social Security Numbers, which are a key piece of personal identifiable information to assist you in determining the existence of a lien against a specific debtor. The distribution of this information beyond its intended purpose is strictly prohibited.\n\nThe debtor's tax identification number has been hidden for confidentiality reasons. You may continue to search on a tax ID number and return debtors that match your search criteria. The SSN/FEIN must be entered without dashes or spaces.","searchMustHaveOneOf":["search","UCC_FARM_PRODUCT_ID","COUNTY"],"searchPlaceholder":"Search by debtor name","advancedSearchParameters":[{"type":"ServerMultiComplete","label":"Product code name(s)","name":"UCC_FARM_PRODUCT_ID","defaultValue":"","optionsSrc":"UCC_FARM_PRODUCT_V"},{"type":"MultiComplete","label":"Year or Range of Years","name":"YEAR_NUM","optionsSrc":"years","startYear":"1968","defaultValue":[],"preMergeOptions":[{"value":"ALL","label":"All"}]},{"type":"serverSelect","label":"State","name":"STATE","defaultValue":"MONTANA","optionsSrc":"STATE"},{"type":"ServerMultiComplete","label":"County","name":"COUNTY","defaultValue":[],"optionsSrc":"COUNTY","overrideSubOptionsSrcFromParameterName":"STATE"},{"type":"checkbox","name":"TIN_SEARCH_YN","defaultValue":false,"label":"Tax Identification Number Search"},{"type":"checkbox","name":"TIN_SORT_YN","defaultValue":false,"label":"Unique ID Sort"}]},"ALLOW_ADDRESS_VALIDATION_BYPASS_OPTION":true,"DEFAULT_ADDRESS_VALIDATION_BYPASS_OPTION_CHECKED":true}).VALIDATE_EMAIL_BEFORE_SENDING) {
	                _context.next = 17;
	                break;
	              }
	
	              _this.setState(function (state) {
	                return {
	                  errors: Object.assign({}, state.errors, {
	                    email: 'Invalid Format'
	                  }),
	                  emailValidationAttempts: state.emailValidationAttempts + 1
	                };
	              });
	
	              //Redirect to the home page if they put in a poorly formatted email address 4 times
	              if (emailValidationAttempts >= 3) {
	                window.location.href = '/';
	              }
	              return _context.abrupt('return');
	
	            case 17:
	              errors.email = "Must be a properly formatted email";
	
	            case 18:
	              _context.t0 = !({"NODE_ENV":"production","BUILD_DATE":"2025-08-27T15:15:31.687Z","BUILD_NUMBER":"Not Provided","GIT_VERSION":"v1.3.0-381-ga81e29b08","GIT_COMMIT_HASH":"a81e29b085c9268ffd96c78eb734365802722741","GIT_BRANCH":"beta","PUBLIC_URL":"","STATE_ABBR":"MT","STATE_NAME":"Montana","STATE_ORG_TITLE":"Secretary of State","LOGIN_HEADER_IMG_PATH":"","HOME_IMG_FILENAME":"montana.jpg","FAVICON_FILE_NAME":"favicon.ico","ALLOW_E_SIGN_ON_CORRECTIONS":true,"THIRD_PARTY_SIGNING_ALLOWED":false,"MY_ACCOUNT_SAVE_AND_CLOSE_BUTTON":true,"IE_DEPRECATED_MESSAGE":"Internet Explorer is not supported. Please select a supported browser below to access this website.","ADDITIONAL_ROUTES":{"dataRequests":true,"farmBill":true,"apostille":true,"externalHelp":"https://sosmt.gov/business/help-center/","systemAdministration":[{"title":"Saved Payments","parameter":"saved-payments","componentName":"SavedPayments"}]},"SUBROUTES":[{"label":"Business","component":"Business","parameter":"business","myWorkQueueSearch":false,"sourceTypeId":54,"searchMustHaveOneOf":["FILING_TYPE_ID","STATUS_ID","STATE","search"],"serverWebSearchDescription":true,"serverWorkQueueDescription":true,"serverMyRecordsDescription":true,"searchPlaceholder":"Search by name or filing number (X########)","allowEmptySearchTerm":true,"requestCertificateAlternateLabel":"Request Information","fileAmendmentButtonLabel":"Filing Actions","advancedSearchParameters":[{"type":"radio","name":"QUERY_TYPE_ID","defaultValue":1010,"options":[{"value":1010,"label":"Starts with"},{"value":1011,"label":"Contains"},{"value":1012,"label":" Word Contains"}]},{"type":"serverSelect","name":"FILING_TYPE_ID","optionsSrc":"FILING_TYPES","label":"Entity Type","placeholder":"All","defaultValue":"0"},{"type":"serverSelect","name":"FILING_SUBTYPE_ID","optionsSrc":"FILING_SUBTYPES","label":"Entity Subtype","overrideSubOptionsSrcFromParameterName":"FILING_TYPE_ID","placeholder":"All","defaultValue":"0"},{"type":"serverSelect","name":"STATUS_ID","optionsSrc":"FILING_STATUS_WITHOUT_ALL","label":"Status","placeholder":"All","defaultValue":"0"},{"type":"serverSelect","name":"STATE","optionsSrc":"STATE","label":"State","placeholder":"All","defaultValue":""},{"type":"serverSelect","name":"COUNTY","optionsSrc":"COUNTY_SUBOPTION","label":"County","overrideSubOptionsSrcFromParameterName":"STATE","placeholder":"All","defaultValue":""},{"type":"checkbox","name":"CRA_SEARCH_YN","defaultValue":false,"label":"Search by Registered Agent PID"},{"type":"dateRange","name":"FILING_DATE","label":"Registration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}},{"type":"dateRange","name":"EXPIRATION_DATE","label":"Expiration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}}],"myRecordsFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Active"},{"value":2,"label":"Inactive"},{"value":3,"label":"Pending"}]},{"type":"dateRange","name":"DATE_RANGE","label":"Date range","defaultValue":{"start":null,"end":null}}],"myWorkQueueFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Approved"},{"value":2,"label":"Pending Online Payment"},{"value":3,"label":"Pending Review"},{"value":4,"label":"Needs Correction"},{"value":5,"label":"Rejected"},{"value":6,"label":"Draft"}]},{"type":"dateRange","name":"DATE_RANGE","label":"Date range","defaultValue":{"start":null,"end":null}}]},{"label":"Notary","component":"Notary","parameter":"notary","sourceTypeId":850,"myWorkQueueSearch":false,"allowEmptySearchTerm":true,"requestCertificateAlternateLabel":"Download Certificate","fileAmendmentButtonLabel":"Filing Actions","hideNameRequestCertificate":true,"hideAddressRequestCertificate":true,"hideRecordUserManagment":true,"searchPlaceholder":"Search by name or commission number","searchMustHaveOneOf":["CITY","search","SERVICE_TYPE"],"advancedParametersStartOpen":true,"searchIsSortable":true,"advancedSearchParameters":[{"type":"radio","name":"STARTS_WITH_YN","defaultValue":false,"options":[{"value":true,"label":"Starts with"},{"value":false,"label":"Contains"}]},{"type":"checkbox","name":"ACTIVE_ONLY_YN","defaultValue":true,"label":"Active entities only"},{"type":"text","name":"CITY","defaultValue":"","label":"City"},{"type":"select","name":"SERVICE_TYPE","label":"Special Services Offered","defaultValue":0,"options":[{"value":0,"label":"(N/A)"},{"value":6165,"label":"In-Person Electronic Notarization (IPEN)"},{"value":6166,"label":"Remote Online Notarization (RON)"},{"value":6167,"label":"Mobile Notary Services"},{"value":6168,"label":"Remote Ink Notarization (RIN)"}]}]},{"label":"Apostille","component":"Apostille","parameter":"apostille","sourceTypeId":720,"myRecordsSearch":false,"myWorkQueueSearch":false,"disabled":false,"allowedRoutes":["/forms-manager/","/queue/","/forms/"]},{"label":"Liens","component":"UCC","parameter":"ucc","sourceTypeId":1999,"myRecordsSearch":true,"myWorkQueueSearch":true,"fileAmendmentButtonLabel":"Filing Actions","searchPlaceholder":"Search by name or file number","disabled":false,"serverWebSearchDescription":true,"myRecordsDescription":"","workQueueDescription":"","searchDescription":"","hideRecordUserManagment":true,"searchLiensCheckout":false,"advancedSearchParameters":[{"type":"radio","name":"STARTS_WITH_YN","defaultValue":false,"options":[{"value":true,"label":"Starts with"},{"value":false,"label":"Contains"}]},{"type":"select","name":"STATUS","defaultValue":"ALL","label":"Status","options":[{"value":"ACTIVE_UNLAPSED","label":"Active (unlapsed)"},{"value":"ACTIVE_LAPSED_UNLAPSED","label":"Active (lapsed and unlapsed)"}]},{"type":"text","name":"EXCLUDE_VALUES","label":"Exclude Debtor Names (comma separated list of names to exclude)","defaultValue":""},{"type":"dateRange","name":"FILING_DATE","label":"Financing Statement Date","defaultValue":{"start":null,"end":null}},{"type":"dateRange","name":"LAPSE_DATE","label":"Lapse Date","defaultValue":{"start":null,"end":null}},{"type":"text","name":"CITY","label":"Debtor City","defaultValue":""}],"myRecordsFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Approved"},{"value":2,"label":"Pending Online Payment"},{"value":3,"label":"Pending Review"}]},{"type":"select","name":"TYPE","defaultValue":0,"label":"Lien Type","options":[{"value":0,"label":"All"},{"value":1,"label":"UCC"},{"value":2,"label":"EFS"},{"value":3,"label":"Title 71"}]}],"myWorkQueueFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Approved"},{"value":2,"label":"Pending Online Payment"},{"value":3,"label":"Pending Review"},{"value":4,"label":"Pending Print and Mail"},{"value":5,"label":"Rejected"},{"value":6,"label":"Draft"}]},{"type":"select","name":"TYPE","defaultValue":0,"label":"Lien Type","options":[{"value":0,"label":"All"},{"value":1,"label":"UCC"},{"value":2,"label":"EFS"},{"value":3,"label":"Title 71"}]}]},{"label":"Copy Request","component":"copies","parameter":"copies","sourceTypeId":2001,"myRecordsSearch":false,"myWorkQueueSearch":false,"disabled":false,"allowedRoutes":["/forms-manager/","/queue/","/forms/"]},{"label":"Trademark","component":"Trademark","parameter":"trademark","sourceTypeId":810,"showRequestCertificate":true,"searchMustHaveOneOf":["search","EXPIRATION_DATE","FILING_DATE"],"allowEmptySearchTerm":true,"requestCertificateAlternateLabel":"Request Information","fileAmendmentButtonLabel":"Filing Actions","advancedSearchParameters":[{"type":"radio","name":"QUERY_TYPE_ID","defaultValue":1010,"options":[{"value":1010,"label":"Starts with"},{"value":1011,"label":"Contains"},{"value":1012,"label":" Word Contains"}]},{"type":"checkbox","name":"OWNER_SEARCH_YN","defaultValue":false,"label":"Search owners"},{"type":"radio","name":"SERVICE_MARK_YN","label":"Mark Type","defaultValue":"","options":[{"value":"","label":"All Marks"},{"value":"Y","label":"Service Mark"},{"value":"N","label":"Trademark"}]},{"type":"serverSelect","name":"STATUS_ID","optionsSrc":"TYPE_V|TRADEMARK_STATUS_TYPE","label":"Status","placeholder":"All","defaultValue":"0"},{"type":"select","name":"DESIGN_TYPE_ID","options":[{"value":0,"label":"All"},{"value":990,"label":"Words Only"},{"value":991,"label":"Design Only"},{"value":992,"label":"Words and Design"}],"label":"Design Type","defaultValue":"0"},{"type":"dateRange","name":"FILING_DATE","label":"Registered Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}},{"type":"dateRange","name":"EXPIRATION_DATE","label":"Expiration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}}]},{"label":"Business Info Request","component":"InfoRequests","parameter":"info-request","sourceTypeId":167,"allowedRoutes":["/forms-manager/","/queue/","/forms/"]},{"label":"Data Requests","component":"DataRequests","parameter":"data-request","sourceTypeId":0,"allowedRoutes":["/forms-manager/"]},{"label":"CRA","component":"CRA","parameter":"cra","sourceTypeId":157,"myRecordsSearch":false,"searchPlaceholder":"Search by name or registered agent number","allowedRoutes":["/forms-manager/","/forms/","/records/","/queue/","/search/"],"allowEmptySearchTerm":true,"fileAmendmentButtonLabel":"Filing Actions","advancedSearchParameters":[{"type":"radio","name":"QUERY_TYPE_ID","defaultValue":1010,"options":[{"value":1010,"label":"Starts with"},{"value":1011,"label":"Contains"},{"value":1012,"label":" Word Contains"}]},{"type":"dateRange","name":"CRA_DATE","label":"Registration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}},{"type":"select","name":"STATUS_ID","label":"Status","defaultValue":0,"options":[{"value":0,"label":"All"},{"value":121,"label":"Active"},{"value":122,"label":"Inactive"}]},{"type":"select","name":"AGENT_TYPE_ID","label":"Agent Type","defaultValue":0,"options":[{"value":0,"label":"All"},{"value":460,"label":"Registered Agent"},{"value":461,"label":"Commercial Registered Agent"}]}]},{"label":"Farm Bill","component":"FarmBill","parameter":"farm-bill","path":"/lists/farm-bill","sourceTypeId":0,"myRecordsSearch":false,"allowedRules":["/search/"],"disabled":true,"searchDescription":"To perform a search, enter a debtor name. Your search results may include: exact debtor name, variations of that name and any filing that includes your search criteria. Punctuation is ignored.\n\nYou can click on \"Advanced\" to refine your search. Under “Advanced” you can search by crop, year, county and SSN/FEIN. As a registered Farm Bill Buyer with the Montana Secretary of State’s office it is important to maintain the confidentiality of the information contained within the Farm Bill Master List. The Farm Bill Master List reflects personal data, such as Social Security Numbers, which are a key piece of personal identifiable information to assist you in determining the existence of a lien against a specific debtor. The distribution of this information beyond its intended purpose is strictly prohibited.\n\nThe debtor's tax identification number has been hidden for confidentiality reasons. You may continue to search on a tax ID number and return debtors that match your search criteria. The SSN/FEIN must be entered without dashes or spaces.","searchMustHaveOneOf":["search","UCC_FARM_PRODUCT_ID","COUNTY"],"searchPlaceholder":"Search by debtor name","advancedSearchParameters":[{"type":"ServerMultiComplete","label":"Product code name(s)","name":"UCC_FARM_PRODUCT_ID","defaultValue":"","optionsSrc":"UCC_FARM_PRODUCT_V"},{"type":"MultiComplete","label":"Year or Range of Years","name":"YEAR_NUM","optionsSrc":"years","startYear":"1968","defaultValue":[],"preMergeOptions":[{"value":"ALL","label":"All"}]},{"type":"serverSelect","label":"State","name":"STATE","defaultValue":"MONTANA","optionsSrc":"STATE"},{"type":"ServerMultiComplete","label":"County","name":"COUNTY","defaultValue":[],"optionsSrc":"COUNTY","overrideSubOptionsSrcFromParameterName":"STATE"},{"type":"checkbox","name":"TIN_SEARCH_YN","defaultValue":false,"label":"Tax Identification Number Search"},{"type":"checkbox","name":"TIN_SORT_YN","defaultValue":false,"label":"Unique ID Sort"}]}],"SYSTEM_NICKNAME":"Online Services Portal","PAYMENT_METHODS":[{"type":"bypass"},{"type":"iTransact"}],"PAYMENT_ALLOW_AMEX":true,"SYSTEM_ID_LABEL":"System Id","DOUBLE_COLUMN_PUBLIC_LOGIN":true,"INTERNAL_USER_MANAGEMENT":true,"ALLOW_PUBLIC_JSON_IMPORT":false,"MAX_FILE_UPLOAD_SIZE":10000000,"REFUND_TEXT":"","RETURN_TO_HOME_ON_LOGOUT":true,"CURRENT_SOS_NAME":"Christi Jacobsen","LOGO_FILENAME":"mt-sos-logo.png","LOGO_ALT":"Christi Jacobsen, Montana Secretary of State","LOGO_FULL_WIDTH":true,"HOME_HIDE_AUTH_HINT":true,"HOME_TITLE":"Montana Secretary of State","CUSTOM_TAB_TITLE":"Official Montana","HOME_SUBTITLE":"Online Business Services","ENTITY_NAME_CONSENT_DESCRIPTION":"","ALLOW_USER_PROFILE_EDITING":true,"COMPARE_FOREIGN_NAME_IN_ENTITY_NAME_VALIDATION":true,"FOREIGN_NAME_FIELD_NAME":"KIMA_PARENT_NAME_INFO","LOGIN_TITLE":"Montana Secretary of State Online Filing Portal Login","PUBLIC_LOGIN_LABEL":"Username","REVERSE_LOGIN_COLUMNS":true,"LOGIN_SEAL_FILENAME":"seal_white.png","SEPARATE_USERNAME_AND_EMAIL":true,"CREATE_ACCOUNT_BUTTON_ALIGN_LEFT":true,"CREATE_ACCOUNT_BUTTON_TEXT":"CREATE AN ACCOUNT","PASSWORD_CUSTOM_ERROR_TEXT":"The password must meet all requirements","ACCOUNT_CREATED_MESSAGE":"Please check your email to verify your account to login and allow a few minutes for this message to arrive. Check your junk/spam folders if you do not find the email in your inbox.","PUBLIC_LOGIN_PLACEHOLDER":" ","DISABLE_DEFAULT_PAYMENT_RADIO":true,"CUSTOM_RESET_PASSWORD_ERROR_MESSAGE":"Username invalid - no account found","PUBLIC_LOGIN_CREATE_DESCRIPTION":"### Existing User:\n\n  - Enter your username and password to login.  \n\n\n  #### - OR -  \n\n\n\n  - Forgot password? Click 'Reset Password' and follow the prompts.\n  - Forgot username? Click 'Forgot Username' and follow the prompts.  \n\n\n  ### New User:\n  ","LOGIN_HELP_LINK":"https://sosmt.gov/business/how-do-i/","LOGIN_HELP_LINK_TEXT":"Need Help?","FORGOT_USERNAME_TEXT":"Forgot Username?","LOGIN_ACTIVE_DIRECTORY_TEXT":"State User Login","MULTIPLE_LOGIN_METHODS":true,"HAS_ACTIVE_DIRECTORY_LOGIN":true,"RESET_PASSWORD_WITH_USERNAME":true,"DOWNLOAD_LINK":true,"SHOW_USERNAME_ACCOUNT_CREATE":true,"SHOW_SCROLL_DOWN_ARROW":true,"SHOW_ADDRESS_ACCOUNT_CREATE":true,"TWO_COLUMN_ACCOUNT_CREATE":true,"RESET_PASSWORD_TIP":"A link to change your password has been sent to your email. Please allow a few minutes for this message to arrive. Please check your junk/spam folders if you do not find the email in your inbox.","FORGOT_PASSWORD_LINK_TEXT":"Reset Password","PHONE_NUMBER_OPTIONAL_ACCOUNT_CREATE":true,"SHOW_REQUIRED_INDICATOR_ACCOUNT_CREATE":true,"PASSWORD_REQUIREMENTS_ACCOUNT_CREATE":"\n    <ul>\n      <li>MUST contain at least 8 characters (12+ recommended)</li>\n      <li>MUST contain at least one uppercase letter.</li>\n      <li>MUST contain at least one lowercase letter.</li>\n      <li>MUST contain at least one number.</li>\n      <li>MUST contain at least one special character (!”#$%&'()*+,-./:;<=>?</li>\n    </ul>\n  ","ALLOW_CERTIFICATION_REQUEST":true,"ALLOW_PUBLIC_CERTIFICATE_REQUEST":true,"ALLOW_COPY_REQUEST":false,"ALLOW_CORRECTION_STYLING":true,"HIDE_DEPRECATION_WARNING":false,"AMEND_ROUTE_PUBLIC":true,"SEAL_FILENAME":"seal.png","SHOPPING_CART":true,"ALLOW_PAYMENT_UPDATE_WITH_EMPTY_CART":true,"RA_EMAIL":true,"RA_WEBSITE":true,"RA_NO_DEFAULT_TYPE":true,"RA_ADDRESS_LABEL":"Street Address","RA_TYPE_SELECTION_DEFAULT":true,"RA_DEFAULT_TYPE":"460","RA_OVERRIDE_TYPE_WITH_DEFAULT":true,"RA_PRINCIPAL_ADDRESS_AMS":true,"UPLOAD_AND_SUBMIT_HIDE_IF_ONE_OPTION":true,"PAYMENT_PROCESSING_MESSAGE":"Your payment is processing - Do not close your browser or click the back button","CHECKOUT_BUTTON_WHEN_PROCESSING_TEXT":"Processing","EFS_CROP_PICKER_NONE_LABEL":"Lien Duration","DISALLOWED_WIZARD_PIECES":["FormationLocale"],"REPEATER_SHOW_EDIT_BUTTON":true,"DATA_REQUEST_PAGE_TITLE":"Data Requests and Subscriptions","DATA_REQUEST_SIDEBAR_LABEL":"Data Requests & Subscriptions","LOGIN_REDIRECTS_TO_EPASS":false,"LOGIN_REDIRECTS_TO_ACTIVE_DIRECTORY":true,"LOGIN_ACTIVE_DIRECTORY_LINK":true,"FETCH_EDIT_USER_LINK":false,"LISTS_FETCH_AVAILABLE_LISTS":true,"POST_WIZARD_SUBMIT_REDIRECT_URL":"/","PIN_REQUEST_ATTESTATIONS":true,"PIN_REQUEST_DESCRIPTION":"Click **Request PIN** to have a new PIN sent to the account holder's email address on file.","OWNERSHIP_REQUEST_DESCRIPTION":"To become an **authorized user** of this record, a current **AUTHORIZED USER** will need to grant you access. To request access, click **Request Access** below.","PIN_REQUEST_SUCCESS_MESSAGE":"The PIN you have requested for this entity has been sent to the email associated with your user account.  You should receive the PIN in approximately 3-5 minutes, depending on your email service provider.","APOSTILLE_HEADER_LABEL":"Verification Information","APOSTILLE_NUMBER_LABEL":"Apostille/Authentication","APOSTILLE_CITY_STATE_OVERRIDE":"HELENA, MT","APOSTILLE_FILING_DATE_LABEL":"Issue Date","APOSTILLE_CITY_STATE_IN_CERTIFIED":true,"NOTARY_EXISTING_FILING":true,"ALLOW_REVOKE_OWN_ACCESS_ONLY":false,"HIDE_CANCEL_ON_ONETIME_DATA_REQUESTS":true,"DATA_REQUESTS_IN_SHOPPING_CART":true,"WQ_ALLOW_EDIT_PENDING_PAYMENT":true,"WQ_CONFIRM_ON_DELETE":true,"WQ_DELETE_CONFIRM_MESSAGE":"Deleting this filing will forfeit any money already paid to the Secretary of State. This action is permanent and cannot be undone, are you sure you would like to delete?","PASS_ITEM_GUIDS_ON_CHECKOUT":true,"FORM_REVISION_HISTORY":true,"CHECKOUT_DISCLAIMER":"By entering your credit card and/or checking account information you (i) state that **you are an authorized user** of the credit card and/or electronic check and that the associated information entered (e.g., account holder name, account number, billing address) is accurate, (ii) **you authorize payment processor to charge the amount you have requested** to your credit card and/or funding account, and (iii) **acknowledge if a charge is declined or reversed you may also be assessed a customary charge** by the payment processor for such transactions.","FARM_BILL_SEARCH_CONFIDENTIAL":"As a registered Farm Bill Buyer with the Montana Secretary of State’s office it is important to maintain the confidentiality of the information contained within the Farm Bill Master List. The Farm Bill Master List reflects personal data, such as Social Security Numbers, which are a key piece of personal identifiable information to assist you in determining the existence of a lien against a specific debtor. The distribution of this information beyond its intended purpose is strictly prohibited.\n\n**The debtor's tax identification number has been hidden for confidentiality reasons. You may continue to search on a tax ID number and return debtors that match your search criteria. The SSN/FEIN must be entered without dashes or spaces.  If you need access to the tax identification number to clearly identify the debtor, please contact the UCC unit at (406) 444-3665.**","VIEW_HISTORY_BUTTON_ALT_TEXT":"View Filings","WIZARD_ERROR_TITLE_MESSAGE":"Form Error","FARM_BILL_SEARCH_INTERACTIVE":true,"USE_FARM_BILL_API":true,"DISALLOW_ASSIGN_SELF_AS_RA":true,"DISALLOW_ASSIGN_SELF_AS_PRINCIPAL":true,"USE_TRADEMARK_OWNER_VALIDATION":true,"USE_ALTERNATIVE_FOREIGN_ADDRESS_LABELS":true,"MY_RECEIPTS_FILTER":[{"type":"dateRange","name":"DATE_RANGE","label":"Date range","defaultValue":{"start":null,"end":null}},{"type":"text","name":"REF_NUM","defaultValue":"","label":"Reference Number"},{"type":"text","name":"RECEIPT_NUM","defaultValue":"","label":"Receipt Id"},{"type":"text","name":"AMOUNT","defaultValue":"","label":"Amount"},{"type":"select","name":"TYPE","defaultValue":"","label":"Payment Type","options":[{"value":"","label":"All"},{"value":"CC","label":"Credit Card"},{"value":"Check","label":"Check"}]}],"MY_RECEIPTS_SHOW_IN_SIDEBAR":true,"SHOW_MY_RECEIPTS_HELPER_TEXT":true,"MY_RECEIPTS_HELPER_LABEL":"About Receipt Search","MY_RECEIPTS_HELPER_TEXT":"You can search for receipts based on their descriptions, including the items paid for on the receipt. Use the filters to search for or filter specific information.","FARM_BILL_SUBLINK":{"label":"Farm Bill","component":"FarmBill","parameter":"farm-bill","path":"/lists/farm-bill","sourceTypeId":0,"myRecordsSearch":false,"allowedRules":["/search/"],"disabled":true,"searchDescription":"To perform a search, enter a debtor name. Your search results may include: exact debtor name, variations of that name and any filing that includes your search criteria. Punctuation is ignored.\n\nYou can click on \"Advanced\" to refine your search. Under “Advanced” you can search by crop, year, county and SSN/FEIN. As a registered Farm Bill Buyer with the Montana Secretary of State’s office it is important to maintain the confidentiality of the information contained within the Farm Bill Master List. The Farm Bill Master List reflects personal data, such as Social Security Numbers, which are a key piece of personal identifiable information to assist you in determining the existence of a lien against a specific debtor. The distribution of this information beyond its intended purpose is strictly prohibited.\n\nThe debtor's tax identification number has been hidden for confidentiality reasons. You may continue to search on a tax ID number and return debtors that match your search criteria. The SSN/FEIN must be entered without dashes or spaces.","searchMustHaveOneOf":["search","UCC_FARM_PRODUCT_ID","COUNTY"],"searchPlaceholder":"Search by debtor name","advancedSearchParameters":[{"type":"ServerMultiComplete","label":"Product code name(s)","name":"UCC_FARM_PRODUCT_ID","defaultValue":"","optionsSrc":"UCC_FARM_PRODUCT_V"},{"type":"MultiComplete","label":"Year or Range of Years","name":"YEAR_NUM","optionsSrc":"years","startYear":"1968","defaultValue":[],"preMergeOptions":[{"value":"ALL","label":"All"}]},{"type":"serverSelect","label":"State","name":"STATE","defaultValue":"MONTANA","optionsSrc":"STATE"},{"type":"ServerMultiComplete","label":"County","name":"COUNTY","defaultValue":[],"optionsSrc":"COUNTY","overrideSubOptionsSrcFromParameterName":"STATE"},{"type":"checkbox","name":"TIN_SEARCH_YN","defaultValue":false,"label":"Tax Identification Number Search"},{"type":"checkbox","name":"TIN_SORT_YN","defaultValue":false,"label":"Unique ID Sort"}]},"ALLOW_ADDRESS_VALIDATION_BYPASS_OPTION":true,"DEFAULT_ADDRESS_VALIDATION_BYPASS_OPTION_CHECKED":true}).HIDE_PHONE_ACCOUNT_CREATE && !(true);
	
	              if (!_context.t0) {
	                _context.next = 26;
	                break;
	              }
	
	              _context.t1 = !account.phone;
	
	              if (_context.t1) {
	                _context.next = 25;
	                break;
	              }
	
	              _context.next = 24;
	              return new Promise(function (resolve) {
	                return _validate.VALIDATE.validPhoneNumber(account.phone, {}, {}, function (isValid) {
	                  return resolve(isValid);
	                });
	              });
	
	            case 24:
	              _context.t1 = !_context.sent;
	
	            case 25:
	              _context.t0 = _context.t1;
	
	            case 26:
	              if (!_context.t0) {
	                _context.next = 28;
	                break;
	              }
	
	              errors.phone = "A phone number is required";
	
	            case 28:
	              if (!account.password) {
	                errors.password = "A password is required";
	              } else if (account.password.length < 8) {
	                errors.password = ("The password must meet all requirements") || "Password must be at least 8 characters";
	              }
	              if (account.password !== account.confirmPassword) {
	                errors.confirmPassword = "Passwords must match";
	              }
	              if (Object.keys(errors).length > 0) {
	                _this.setState({ errors: errors });
	              } else {
	                _this.setState({ errors: {} });
	                _this.createAccount(account);
	              }
	
	            case 31:
	            case 'end':
	              return _context.stop();
	          }
	        }
	      }, _callee, _this2);
	    })), _this.toLowercaseKeys = function (obj) {
	      return Object.keys(obj).reduce(function (newObj, key) {
	        newObj[key.toLowerCase()] = obj[key];
	        return newObj;
	      }, {});
	    }, _this.createAccount = function (account) {
	      account =  true ? Object.assign({}, account, _this.toLowercaseKeys(_this.state.address)) : account;
	      delete account.address;
	      console.log(account);
	      (0, _requests.CREATE_WEB_USER)(account, function (userId) {
	        _this.props.returnToLogin({
	          type: "success",
	          message: ("Please check your email to verify your account to login and allow a few minutes for this message to arrive. Check your junk/spam folders if you do not find the email in your inbox.") || "Your account was successfully created. Please login below."
	        });
	      }, function (err) {
	        _this.setState({
	          errors: {
	            global: err.message || "Something went wrong, try again later"
	          }
	        });
	      });
	    }, _this.setValue = function (value, key) {
	      _this.setState(function (state) {
	        return Object.assign({}, state, _defineProperty({}, key, value));
	      });
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(CreateAccountForm, [{
	    key: 'render',
	    value: function render() {
	      var _this3 = this;
	
	      var returnToLogin = this.props.returnToLogin;
	
	      return _react2.default.createElement(
	        'form',
	        { className: 'wizard login create-account' },
	        _react2.default.createElement(
	          'div',
	          { className: '' + ( true ? 'column-1' : '') },
	          _react2.default.createElement(
	            'div',
	            { className: 'name-wrapper' },
	            _react2.default.createElement(
	              'div',
	              { className: 'field' },
	              _react2.default.createElement(
	                'label',
	                { htmlFor: 'firstName', id: 'firstName-label' },
	                'First name',
	                (true) && _react2.default.createElement(
	                  'span',
	                  { style: { color: 'red' } },
	                  '*'
	                )
	              ),
	              _react2.default.createElement('input', {
	                type: 'text',
	                ref: function ref(_ref3) {
	                  _this3.firstName = _ref3;
	                },
	                onKeyDown: this.checkEnter,
	                placeholder: 'John',
	                id: 'firstName',
	                'aria-describedby': 'firstName-error',
	                'aria-invalid': !!this.state.errors.firstName,
	                'aria-labelledby': 'firstName-label'
	              }),
	              _react2.default.createElement(
	                FieldError,
	                { id: 'firstName-error' },
	                this.state.errors.firstName
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'field' },
	              _react2.default.createElement(
	                'label',
	                { htmlFor: 'middleName', id: 'middleName-label' },
	                'Middle name'
	              ),
	              _react2.default.createElement('input', {
	                type: 'text',
	                ref: function ref(_ref4) {
	                  _this3.middleName = _ref4;
	                },
	                onKeyDown: this.checkEnter,
	                placeholder: 'Paul',
	                id: 'middleName',
	                'aria-describedby': 'middleName-error',
	                'aria-labelledby': 'middleName-label'
	              })
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'field' },
	              _react2.default.createElement(
	                'label',
	                { htmlFor: 'lastName', id: 'lastName-label' },
	                'Last name',
	                (true) && _react2.default.createElement(
	                  'span',
	                  { style: { color: 'red' } },
	                  '*'
	                )
	              ),
	              _react2.default.createElement('input', {
	                type: 'text',
	                ref: function ref(_ref5) {
	                  _this3.lastName = _ref5;
	                },
	                onKeyDown: this.checkEnter,
	                placeholder: 'Doe',
	                id: 'lastName',
	                'aria-describedby': 'lastName-error',
	                'aria-invalid': !!this.state.errors.lastName,
	                'aria-labelledby': 'lastName-label'
	              }),
	              _react2.default.createElement(
	                FieldError,
	                { id: 'lastName-error' },
	                this.state.errors.lastName
	              )
	            )
	          ),
	          ({"NODE_ENV":"production","BUILD_DATE":"2025-08-27T15:15:31.687Z","BUILD_NUMBER":"Not Provided","GIT_VERSION":"v1.3.0-381-ga81e29b08","GIT_COMMIT_HASH":"a81e29b085c9268ffd96c78eb734365802722741","GIT_BRANCH":"beta","PUBLIC_URL":"","STATE_ABBR":"MT","STATE_NAME":"Montana","STATE_ORG_TITLE":"Secretary of State","LOGIN_HEADER_IMG_PATH":"","HOME_IMG_FILENAME":"montana.jpg","FAVICON_FILE_NAME":"favicon.ico","ALLOW_E_SIGN_ON_CORRECTIONS":true,"THIRD_PARTY_SIGNING_ALLOWED":false,"MY_ACCOUNT_SAVE_AND_CLOSE_BUTTON":true,"IE_DEPRECATED_MESSAGE":"Internet Explorer is not supported. Please select a supported browser below to access this website.","ADDITIONAL_ROUTES":{"dataRequests":true,"farmBill":true,"apostille":true,"externalHelp":"https://sosmt.gov/business/help-center/","systemAdministration":[{"title":"Saved Payments","parameter":"saved-payments","componentName":"SavedPayments"}]},"SUBROUTES":[{"label":"Business","component":"Business","parameter":"business","myWorkQueueSearch":false,"sourceTypeId":54,"searchMustHaveOneOf":["FILING_TYPE_ID","STATUS_ID","STATE","search"],"serverWebSearchDescription":true,"serverWorkQueueDescription":true,"serverMyRecordsDescription":true,"searchPlaceholder":"Search by name or filing number (X########)","allowEmptySearchTerm":true,"requestCertificateAlternateLabel":"Request Information","fileAmendmentButtonLabel":"Filing Actions","advancedSearchParameters":[{"type":"radio","name":"QUERY_TYPE_ID","defaultValue":1010,"options":[{"value":1010,"label":"Starts with"},{"value":1011,"label":"Contains"},{"value":1012,"label":" Word Contains"}]},{"type":"serverSelect","name":"FILING_TYPE_ID","optionsSrc":"FILING_TYPES","label":"Entity Type","placeholder":"All","defaultValue":"0"},{"type":"serverSelect","name":"FILING_SUBTYPE_ID","optionsSrc":"FILING_SUBTYPES","label":"Entity Subtype","overrideSubOptionsSrcFromParameterName":"FILING_TYPE_ID","placeholder":"All","defaultValue":"0"},{"type":"serverSelect","name":"STATUS_ID","optionsSrc":"FILING_STATUS_WITHOUT_ALL","label":"Status","placeholder":"All","defaultValue":"0"},{"type":"serverSelect","name":"STATE","optionsSrc":"STATE","label":"State","placeholder":"All","defaultValue":""},{"type":"serverSelect","name":"COUNTY","optionsSrc":"COUNTY_SUBOPTION","label":"County","overrideSubOptionsSrcFromParameterName":"STATE","placeholder":"All","defaultValue":""},{"type":"checkbox","name":"CRA_SEARCH_YN","defaultValue":false,"label":"Search by Registered Agent PID"},{"type":"dateRange","name":"FILING_DATE","label":"Registration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}},{"type":"dateRange","name":"EXPIRATION_DATE","label":"Expiration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}}],"myRecordsFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Active"},{"value":2,"label":"Inactive"},{"value":3,"label":"Pending"}]},{"type":"dateRange","name":"DATE_RANGE","label":"Date range","defaultValue":{"start":null,"end":null}}],"myWorkQueueFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Approved"},{"value":2,"label":"Pending Online Payment"},{"value":3,"label":"Pending Review"},{"value":4,"label":"Needs Correction"},{"value":5,"label":"Rejected"},{"value":6,"label":"Draft"}]},{"type":"dateRange","name":"DATE_RANGE","label":"Date range","defaultValue":{"start":null,"end":null}}]},{"label":"Notary","component":"Notary","parameter":"notary","sourceTypeId":850,"myWorkQueueSearch":false,"allowEmptySearchTerm":true,"requestCertificateAlternateLabel":"Download Certificate","fileAmendmentButtonLabel":"Filing Actions","hideNameRequestCertificate":true,"hideAddressRequestCertificate":true,"hideRecordUserManagment":true,"searchPlaceholder":"Search by name or commission number","searchMustHaveOneOf":["CITY","search","SERVICE_TYPE"],"advancedParametersStartOpen":true,"searchIsSortable":true,"advancedSearchParameters":[{"type":"radio","name":"STARTS_WITH_YN","defaultValue":false,"options":[{"value":true,"label":"Starts with"},{"value":false,"label":"Contains"}]},{"type":"checkbox","name":"ACTIVE_ONLY_YN","defaultValue":true,"label":"Active entities only"},{"type":"text","name":"CITY","defaultValue":"","label":"City"},{"type":"select","name":"SERVICE_TYPE","label":"Special Services Offered","defaultValue":0,"options":[{"value":0,"label":"(N/A)"},{"value":6165,"label":"In-Person Electronic Notarization (IPEN)"},{"value":6166,"label":"Remote Online Notarization (RON)"},{"value":6167,"label":"Mobile Notary Services"},{"value":6168,"label":"Remote Ink Notarization (RIN)"}]}]},{"label":"Apostille","component":"Apostille","parameter":"apostille","sourceTypeId":720,"myRecordsSearch":false,"myWorkQueueSearch":false,"disabled":false,"allowedRoutes":["/forms-manager/","/queue/","/forms/"]},{"label":"Liens","component":"UCC","parameter":"ucc","sourceTypeId":1999,"myRecordsSearch":true,"myWorkQueueSearch":true,"fileAmendmentButtonLabel":"Filing Actions","searchPlaceholder":"Search by name or file number","disabled":false,"serverWebSearchDescription":true,"myRecordsDescription":"","workQueueDescription":"","searchDescription":"","hideRecordUserManagment":true,"searchLiensCheckout":false,"advancedSearchParameters":[{"type":"radio","name":"STARTS_WITH_YN","defaultValue":false,"options":[{"value":true,"label":"Starts with"},{"value":false,"label":"Contains"}]},{"type":"select","name":"STATUS","defaultValue":"ALL","label":"Status","options":[{"value":"ACTIVE_UNLAPSED","label":"Active (unlapsed)"},{"value":"ACTIVE_LAPSED_UNLAPSED","label":"Active (lapsed and unlapsed)"}]},{"type":"text","name":"EXCLUDE_VALUES","label":"Exclude Debtor Names (comma separated list of names to exclude)","defaultValue":""},{"type":"dateRange","name":"FILING_DATE","label":"Financing Statement Date","defaultValue":{"start":null,"end":null}},{"type":"dateRange","name":"LAPSE_DATE","label":"Lapse Date","defaultValue":{"start":null,"end":null}},{"type":"text","name":"CITY","label":"Debtor City","defaultValue":""}],"myRecordsFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Approved"},{"value":2,"label":"Pending Online Payment"},{"value":3,"label":"Pending Review"}]},{"type":"select","name":"TYPE","defaultValue":0,"label":"Lien Type","options":[{"value":0,"label":"All"},{"value":1,"label":"UCC"},{"value":2,"label":"EFS"},{"value":3,"label":"Title 71"}]}],"myWorkQueueFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Approved"},{"value":2,"label":"Pending Online Payment"},{"value":3,"label":"Pending Review"},{"value":4,"label":"Pending Print and Mail"},{"value":5,"label":"Rejected"},{"value":6,"label":"Draft"}]},{"type":"select","name":"TYPE","defaultValue":0,"label":"Lien Type","options":[{"value":0,"label":"All"},{"value":1,"label":"UCC"},{"value":2,"label":"EFS"},{"value":3,"label":"Title 71"}]}]},{"label":"Copy Request","component":"copies","parameter":"copies","sourceTypeId":2001,"myRecordsSearch":false,"myWorkQueueSearch":false,"disabled":false,"allowedRoutes":["/forms-manager/","/queue/","/forms/"]},{"label":"Trademark","component":"Trademark","parameter":"trademark","sourceTypeId":810,"showRequestCertificate":true,"searchMustHaveOneOf":["search","EXPIRATION_DATE","FILING_DATE"],"allowEmptySearchTerm":true,"requestCertificateAlternateLabel":"Request Information","fileAmendmentButtonLabel":"Filing Actions","advancedSearchParameters":[{"type":"radio","name":"QUERY_TYPE_ID","defaultValue":1010,"options":[{"value":1010,"label":"Starts with"},{"value":1011,"label":"Contains"},{"value":1012,"label":" Word Contains"}]},{"type":"checkbox","name":"OWNER_SEARCH_YN","defaultValue":false,"label":"Search owners"},{"type":"radio","name":"SERVICE_MARK_YN","label":"Mark Type","defaultValue":"","options":[{"value":"","label":"All Marks"},{"value":"Y","label":"Service Mark"},{"value":"N","label":"Trademark"}]},{"type":"serverSelect","name":"STATUS_ID","optionsSrc":"TYPE_V|TRADEMARK_STATUS_TYPE","label":"Status","placeholder":"All","defaultValue":"0"},{"type":"select","name":"DESIGN_TYPE_ID","options":[{"value":0,"label":"All"},{"value":990,"label":"Words Only"},{"value":991,"label":"Design Only"},{"value":992,"label":"Words and Design"}],"label":"Design Type","defaultValue":"0"},{"type":"dateRange","name":"FILING_DATE","label":"Registered Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}},{"type":"dateRange","name":"EXPIRATION_DATE","label":"Expiration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}}]},{"label":"Business Info Request","component":"InfoRequests","parameter":"info-request","sourceTypeId":167,"allowedRoutes":["/forms-manager/","/queue/","/forms/"]},{"label":"Data Requests","component":"DataRequests","parameter":"data-request","sourceTypeId":0,"allowedRoutes":["/forms-manager/"]},{"label":"CRA","component":"CRA","parameter":"cra","sourceTypeId":157,"myRecordsSearch":false,"searchPlaceholder":"Search by name or registered agent number","allowedRoutes":["/forms-manager/","/forms/","/records/","/queue/","/search/"],"allowEmptySearchTerm":true,"fileAmendmentButtonLabel":"Filing Actions","advancedSearchParameters":[{"type":"radio","name":"QUERY_TYPE_ID","defaultValue":1010,"options":[{"value":1010,"label":"Starts with"},{"value":1011,"label":"Contains"},{"value":1012,"label":" Word Contains"}]},{"type":"dateRange","name":"CRA_DATE","label":"Registration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}},{"type":"select","name":"STATUS_ID","label":"Status","defaultValue":0,"options":[{"value":0,"label":"All"},{"value":121,"label":"Active"},{"value":122,"label":"Inactive"}]},{"type":"select","name":"AGENT_TYPE_ID","label":"Agent Type","defaultValue":0,"options":[{"value":0,"label":"All"},{"value":460,"label":"Registered Agent"},{"value":461,"label":"Commercial Registered Agent"}]}]},{"label":"Farm Bill","component":"FarmBill","parameter":"farm-bill","path":"/lists/farm-bill","sourceTypeId":0,"myRecordsSearch":false,"allowedRules":["/search/"],"disabled":true,"searchDescription":"To perform a search, enter a debtor name. Your search results may include: exact debtor name, variations of that name and any filing that includes your search criteria. Punctuation is ignored.\n\nYou can click on \"Advanced\" to refine your search. Under “Advanced” you can search by crop, year, county and SSN/FEIN. As a registered Farm Bill Buyer with the Montana Secretary of State’s office it is important to maintain the confidentiality of the information contained within the Farm Bill Master List. The Farm Bill Master List reflects personal data, such as Social Security Numbers, which are a key piece of personal identifiable information to assist you in determining the existence of a lien against a specific debtor. The distribution of this information beyond its intended purpose is strictly prohibited.\n\nThe debtor's tax identification number has been hidden for confidentiality reasons. You may continue to search on a tax ID number and return debtors that match your search criteria. The SSN/FEIN must be entered without dashes or spaces.","searchMustHaveOneOf":["search","UCC_FARM_PRODUCT_ID","COUNTY"],"searchPlaceholder":"Search by debtor name","advancedSearchParameters":[{"type":"ServerMultiComplete","label":"Product code name(s)","name":"UCC_FARM_PRODUCT_ID","defaultValue":"","optionsSrc":"UCC_FARM_PRODUCT_V"},{"type":"MultiComplete","label":"Year or Range of Years","name":"YEAR_NUM","optionsSrc":"years","startYear":"1968","defaultValue":[],"preMergeOptions":[{"value":"ALL","label":"All"}]},{"type":"serverSelect","label":"State","name":"STATE","defaultValue":"MONTANA","optionsSrc":"STATE"},{"type":"ServerMultiComplete","label":"County","name":"COUNTY","defaultValue":[],"optionsSrc":"COUNTY","overrideSubOptionsSrcFromParameterName":"STATE"},{"type":"checkbox","name":"TIN_SEARCH_YN","defaultValue":false,"label":"Tax Identification Number Search"},{"type":"checkbox","name":"TIN_SORT_YN","defaultValue":false,"label":"Unique ID Sort"}]}],"SYSTEM_NICKNAME":"Online Services Portal","PAYMENT_METHODS":[{"type":"bypass"},{"type":"iTransact"}],"PAYMENT_ALLOW_AMEX":true,"SYSTEM_ID_LABEL":"System Id","DOUBLE_COLUMN_PUBLIC_LOGIN":true,"INTERNAL_USER_MANAGEMENT":true,"ALLOW_PUBLIC_JSON_IMPORT":false,"MAX_FILE_UPLOAD_SIZE":10000000,"REFUND_TEXT":"","RETURN_TO_HOME_ON_LOGOUT":true,"CURRENT_SOS_NAME":"Christi Jacobsen","LOGO_FILENAME":"mt-sos-logo.png","LOGO_ALT":"Christi Jacobsen, Montana Secretary of State","LOGO_FULL_WIDTH":true,"HOME_HIDE_AUTH_HINT":true,"HOME_TITLE":"Montana Secretary of State","CUSTOM_TAB_TITLE":"Official Montana","HOME_SUBTITLE":"Online Business Services","ENTITY_NAME_CONSENT_DESCRIPTION":"","ALLOW_USER_PROFILE_EDITING":true,"COMPARE_FOREIGN_NAME_IN_ENTITY_NAME_VALIDATION":true,"FOREIGN_NAME_FIELD_NAME":"KIMA_PARENT_NAME_INFO","LOGIN_TITLE":"Montana Secretary of State Online Filing Portal Login","PUBLIC_LOGIN_LABEL":"Username","REVERSE_LOGIN_COLUMNS":true,"LOGIN_SEAL_FILENAME":"seal_white.png","SEPARATE_USERNAME_AND_EMAIL":true,"CREATE_ACCOUNT_BUTTON_ALIGN_LEFT":true,"CREATE_ACCOUNT_BUTTON_TEXT":"CREATE AN ACCOUNT","PASSWORD_CUSTOM_ERROR_TEXT":"The password must meet all requirements","ACCOUNT_CREATED_MESSAGE":"Please check your email to verify your account to login and allow a few minutes for this message to arrive. Check your junk/spam folders if you do not find the email in your inbox.","PUBLIC_LOGIN_PLACEHOLDER":" ","DISABLE_DEFAULT_PAYMENT_RADIO":true,"CUSTOM_RESET_PASSWORD_ERROR_MESSAGE":"Username invalid - no account found","PUBLIC_LOGIN_CREATE_DESCRIPTION":"### Existing User:\n\n  - Enter your username and password to login.  \n\n\n  #### - OR -  \n\n\n\n  - Forgot password? Click 'Reset Password' and follow the prompts.\n  - Forgot username? Click 'Forgot Username' and follow the prompts.  \n\n\n  ### New User:\n  ","LOGIN_HELP_LINK":"https://sosmt.gov/business/how-do-i/","LOGIN_HELP_LINK_TEXT":"Need Help?","FORGOT_USERNAME_TEXT":"Forgot Username?","LOGIN_ACTIVE_DIRECTORY_TEXT":"State User Login","MULTIPLE_LOGIN_METHODS":true,"HAS_ACTIVE_DIRECTORY_LOGIN":true,"RESET_PASSWORD_WITH_USERNAME":true,"DOWNLOAD_LINK":true,"SHOW_USERNAME_ACCOUNT_CREATE":true,"SHOW_SCROLL_DOWN_ARROW":true,"SHOW_ADDRESS_ACCOUNT_CREATE":true,"TWO_COLUMN_ACCOUNT_CREATE":true,"RESET_PASSWORD_TIP":"A link to change your password has been sent to your email. Please allow a few minutes for this message to arrive. Please check your junk/spam folders if you do not find the email in your inbox.","FORGOT_PASSWORD_LINK_TEXT":"Reset Password","PHONE_NUMBER_OPTIONAL_ACCOUNT_CREATE":true,"SHOW_REQUIRED_INDICATOR_ACCOUNT_CREATE":true,"PASSWORD_REQUIREMENTS_ACCOUNT_CREATE":"\n    <ul>\n      <li>MUST contain at least 8 characters (12+ recommended)</li>\n      <li>MUST contain at least one uppercase letter.</li>\n      <li>MUST contain at least one lowercase letter.</li>\n      <li>MUST contain at least one number.</li>\n      <li>MUST contain at least one special character (!”#$%&'()*+,-./:;<=>?</li>\n    </ul>\n  ","ALLOW_CERTIFICATION_REQUEST":true,"ALLOW_PUBLIC_CERTIFICATE_REQUEST":true,"ALLOW_COPY_REQUEST":false,"ALLOW_CORRECTION_STYLING":true,"HIDE_DEPRECATION_WARNING":false,"AMEND_ROUTE_PUBLIC":true,"SEAL_FILENAME":"seal.png","SHOPPING_CART":true,"ALLOW_PAYMENT_UPDATE_WITH_EMPTY_CART":true,"RA_EMAIL":true,"RA_WEBSITE":true,"RA_NO_DEFAULT_TYPE":true,"RA_ADDRESS_LABEL":"Street Address","RA_TYPE_SELECTION_DEFAULT":true,"RA_DEFAULT_TYPE":"460","RA_OVERRIDE_TYPE_WITH_DEFAULT":true,"RA_PRINCIPAL_ADDRESS_AMS":true,"UPLOAD_AND_SUBMIT_HIDE_IF_ONE_OPTION":true,"PAYMENT_PROCESSING_MESSAGE":"Your payment is processing - Do not close your browser or click the back button","CHECKOUT_BUTTON_WHEN_PROCESSING_TEXT":"Processing","EFS_CROP_PICKER_NONE_LABEL":"Lien Duration","DISALLOWED_WIZARD_PIECES":["FormationLocale"],"REPEATER_SHOW_EDIT_BUTTON":true,"DATA_REQUEST_PAGE_TITLE":"Data Requests and Subscriptions","DATA_REQUEST_SIDEBAR_LABEL":"Data Requests & Subscriptions","LOGIN_REDIRECTS_TO_EPASS":false,"LOGIN_REDIRECTS_TO_ACTIVE_DIRECTORY":true,"LOGIN_ACTIVE_DIRECTORY_LINK":true,"FETCH_EDIT_USER_LINK":false,"LISTS_FETCH_AVAILABLE_LISTS":true,"POST_WIZARD_SUBMIT_REDIRECT_URL":"/","PIN_REQUEST_ATTESTATIONS":true,"PIN_REQUEST_DESCRIPTION":"Click **Request PIN** to have a new PIN sent to the account holder's email address on file.","OWNERSHIP_REQUEST_DESCRIPTION":"To become an **authorized user** of this record, a current **AUTHORIZED USER** will need to grant you access. To request access, click **Request Access** below.","PIN_REQUEST_SUCCESS_MESSAGE":"The PIN you have requested for this entity has been sent to the email associated with your user account.  You should receive the PIN in approximately 3-5 minutes, depending on your email service provider.","APOSTILLE_HEADER_LABEL":"Verification Information","APOSTILLE_NUMBER_LABEL":"Apostille/Authentication","APOSTILLE_CITY_STATE_OVERRIDE":"HELENA, MT","APOSTILLE_FILING_DATE_LABEL":"Issue Date","APOSTILLE_CITY_STATE_IN_CERTIFIED":true,"NOTARY_EXISTING_FILING":true,"ALLOW_REVOKE_OWN_ACCESS_ONLY":false,"HIDE_CANCEL_ON_ONETIME_DATA_REQUESTS":true,"DATA_REQUESTS_IN_SHOPPING_CART":true,"WQ_ALLOW_EDIT_PENDING_PAYMENT":true,"WQ_CONFIRM_ON_DELETE":true,"WQ_DELETE_CONFIRM_MESSAGE":"Deleting this filing will forfeit any money already paid to the Secretary of State. This action is permanent and cannot be undone, are you sure you would like to delete?","PASS_ITEM_GUIDS_ON_CHECKOUT":true,"FORM_REVISION_HISTORY":true,"CHECKOUT_DISCLAIMER":"By entering your credit card and/or checking account information you (i) state that **you are an authorized user** of the credit card and/or electronic check and that the associated information entered (e.g., account holder name, account number, billing address) is accurate, (ii) **you authorize payment processor to charge the amount you have requested** to your credit card and/or funding account, and (iii) **acknowledge if a charge is declined or reversed you may also be assessed a customary charge** by the payment processor for such transactions.","FARM_BILL_SEARCH_CONFIDENTIAL":"As a registered Farm Bill Buyer with the Montana Secretary of State’s office it is important to maintain the confidentiality of the information contained within the Farm Bill Master List. The Farm Bill Master List reflects personal data, such as Social Security Numbers, which are a key piece of personal identifiable information to assist you in determining the existence of a lien against a specific debtor. The distribution of this information beyond its intended purpose is strictly prohibited.\n\n**The debtor's tax identification number has been hidden for confidentiality reasons. You may continue to search on a tax ID number and return debtors that match your search criteria. The SSN/FEIN must be entered without dashes or spaces.  If you need access to the tax identification number to clearly identify the debtor, please contact the UCC unit at (406) 444-3665.**","VIEW_HISTORY_BUTTON_ALT_TEXT":"View Filings","WIZARD_ERROR_TITLE_MESSAGE":"Form Error","FARM_BILL_SEARCH_INTERACTIVE":true,"USE_FARM_BILL_API":true,"DISALLOW_ASSIGN_SELF_AS_RA":true,"DISALLOW_ASSIGN_SELF_AS_PRINCIPAL":true,"USE_TRADEMARK_OWNER_VALIDATION":true,"USE_ALTERNATIVE_FOREIGN_ADDRESS_LABELS":true,"MY_RECEIPTS_FILTER":[{"type":"dateRange","name":"DATE_RANGE","label":"Date range","defaultValue":{"start":null,"end":null}},{"type":"text","name":"REF_NUM","defaultValue":"","label":"Reference Number"},{"type":"text","name":"RECEIPT_NUM","defaultValue":"","label":"Receipt Id"},{"type":"text","name":"AMOUNT","defaultValue":"","label":"Amount"},{"type":"select","name":"TYPE","defaultValue":"","label":"Payment Type","options":[{"value":"","label":"All"},{"value":"CC","label":"Credit Card"},{"value":"Check","label":"Check"}]}],"MY_RECEIPTS_SHOW_IN_SIDEBAR":true,"SHOW_MY_RECEIPTS_HELPER_TEXT":true,"MY_RECEIPTS_HELPER_LABEL":"About Receipt Search","MY_RECEIPTS_HELPER_TEXT":"You can search for receipts based on their descriptions, including the items paid for on the receipt. Use the filters to search for or filter specific information.","FARM_BILL_SUBLINK":{"label":"Farm Bill","component":"FarmBill","parameter":"farm-bill","path":"/lists/farm-bill","sourceTypeId":0,"myRecordsSearch":false,"allowedRules":["/search/"],"disabled":true,"searchDescription":"To perform a search, enter a debtor name. Your search results may include: exact debtor name, variations of that name and any filing that includes your search criteria. Punctuation is ignored.\n\nYou can click on \"Advanced\" to refine your search. Under “Advanced” you can search by crop, year, county and SSN/FEIN. As a registered Farm Bill Buyer with the Montana Secretary of State’s office it is important to maintain the confidentiality of the information contained within the Farm Bill Master List. The Farm Bill Master List reflects personal data, such as Social Security Numbers, which are a key piece of personal identifiable information to assist you in determining the existence of a lien against a specific debtor. The distribution of this information beyond its intended purpose is strictly prohibited.\n\nThe debtor's tax identification number has been hidden for confidentiality reasons. You may continue to search on a tax ID number and return debtors that match your search criteria. The SSN/FEIN must be entered without dashes or spaces.","searchMustHaveOneOf":["search","UCC_FARM_PRODUCT_ID","COUNTY"],"searchPlaceholder":"Search by debtor name","advancedSearchParameters":[{"type":"ServerMultiComplete","label":"Product code name(s)","name":"UCC_FARM_PRODUCT_ID","defaultValue":"","optionsSrc":"UCC_FARM_PRODUCT_V"},{"type":"MultiComplete","label":"Year or Range of Years","name":"YEAR_NUM","optionsSrc":"years","startYear":"1968","defaultValue":[],"preMergeOptions":[{"value":"ALL","label":"All"}]},{"type":"serverSelect","label":"State","name":"STATE","defaultValue":"MONTANA","optionsSrc":"STATE"},{"type":"ServerMultiComplete","label":"County","name":"COUNTY","defaultValue":[],"optionsSrc":"COUNTY","overrideSubOptionsSrcFromParameterName":"STATE"},{"type":"checkbox","name":"TIN_SEARCH_YN","defaultValue":false,"label":"Tax Identification Number Search"},{"type":"checkbox","name":"TIN_SORT_YN","defaultValue":false,"label":"Unique ID Sort"}]},"ALLOW_ADDRESS_VALIDATION_BYPASS_OPTION":true,"DEFAULT_ADDRESS_VALIDATION_BYPASS_OPTION_CHECKED":true}).SHOW_ORG_NAME_ACCOUNT_CREATE ? _react2.default.createElement(
	            'div',
	            { className: 'field' },
	            _react2.default.createElement(
	              'label',
	              { htmlFor: 'orgName', id: 'orgName-label' },
	              'Organization name'
	            ),
	            _react2.default.createElement('input', {
	              type: 'text',
	              ref: function ref(_ref6) {
	                _this3.orgName = _ref6;
	              },
	              onKeyDown: this.checkEnter,
	              placeholder: 'Your LLC',
	              id: 'orgName',
	              'aria-labelledby': 'orgName-label'
	            })
	          ) : null,
	           true ? _react2.default.createElement(
	            'div',
	            { className: 'field' },
	            _react2.default.createElement(
	              'label',
	              { htmlFor: 'username', id: 'username-label' },
	              'Username',
	              (true) && _react2.default.createElement(
	                'span',
	                { style: { color: 'red' } },
	                '*'
	              )
	            ),
	            _react2.default.createElement('input', {
	              type: 'text',
	              ref: function ref(_ref7) {
	                _this3.username = _ref7;
	              },
	              onKeyDown: this.checkEnter,
	              placeholder: 'username',
	              id: 'username',
	              'aria-labelledby': 'username-label'
	            })
	          ) : null,
	          _react2.default.createElement(
	            'div',
	            { className: 'field' },
	            _react2.default.createElement(
	              'label',
	              { htmlFor: 'email', id: 'email-label' },
	              'Email',
	              (true) && _react2.default.createElement(
	                'span',
	                { style: { color: 'red' } },
	                '*'
	              )
	            ),
	            _react2.default.createElement('input', {
	              type: 'text',
	              ref: function ref(_ref8) {
	                _this3.email = _ref8;
	              },
	              onKeyDown: this.checkEnter,
	              placeholder: 'example@email.com',
	              id: 'email',
	              'aria-describedby': 'email-error',
	              'aria-invalid': !!this.state.errors.email,
	              'aria-labelledby': 'email-label'
	            }),
	            _react2.default.createElement(
	              FieldError,
	              { id: 'email-error' },
	              this.state.errors.email
	            )
	          ),
	          ({"NODE_ENV":"production","BUILD_DATE":"2025-08-27T15:15:31.687Z","BUILD_NUMBER":"Not Provided","GIT_VERSION":"v1.3.0-381-ga81e29b08","GIT_COMMIT_HASH":"a81e29b085c9268ffd96c78eb734365802722741","GIT_BRANCH":"beta","PUBLIC_URL":"","STATE_ABBR":"MT","STATE_NAME":"Montana","STATE_ORG_TITLE":"Secretary of State","LOGIN_HEADER_IMG_PATH":"","HOME_IMG_FILENAME":"montana.jpg","FAVICON_FILE_NAME":"favicon.ico","ALLOW_E_SIGN_ON_CORRECTIONS":true,"THIRD_PARTY_SIGNING_ALLOWED":false,"MY_ACCOUNT_SAVE_AND_CLOSE_BUTTON":true,"IE_DEPRECATED_MESSAGE":"Internet Explorer is not supported. Please select a supported browser below to access this website.","ADDITIONAL_ROUTES":{"dataRequests":true,"farmBill":true,"apostille":true,"externalHelp":"https://sosmt.gov/business/help-center/","systemAdministration":[{"title":"Saved Payments","parameter":"saved-payments","componentName":"SavedPayments"}]},"SUBROUTES":[{"label":"Business","component":"Business","parameter":"business","myWorkQueueSearch":false,"sourceTypeId":54,"searchMustHaveOneOf":["FILING_TYPE_ID","STATUS_ID","STATE","search"],"serverWebSearchDescription":true,"serverWorkQueueDescription":true,"serverMyRecordsDescription":true,"searchPlaceholder":"Search by name or filing number (X########)","allowEmptySearchTerm":true,"requestCertificateAlternateLabel":"Request Information","fileAmendmentButtonLabel":"Filing Actions","advancedSearchParameters":[{"type":"radio","name":"QUERY_TYPE_ID","defaultValue":1010,"options":[{"value":1010,"label":"Starts with"},{"value":1011,"label":"Contains"},{"value":1012,"label":" Word Contains"}]},{"type":"serverSelect","name":"FILING_TYPE_ID","optionsSrc":"FILING_TYPES","label":"Entity Type","placeholder":"All","defaultValue":"0"},{"type":"serverSelect","name":"FILING_SUBTYPE_ID","optionsSrc":"FILING_SUBTYPES","label":"Entity Subtype","overrideSubOptionsSrcFromParameterName":"FILING_TYPE_ID","placeholder":"All","defaultValue":"0"},{"type":"serverSelect","name":"STATUS_ID","optionsSrc":"FILING_STATUS_WITHOUT_ALL","label":"Status","placeholder":"All","defaultValue":"0"},{"type":"serverSelect","name":"STATE","optionsSrc":"STATE","label":"State","placeholder":"All","defaultValue":""},{"type":"serverSelect","name":"COUNTY","optionsSrc":"COUNTY_SUBOPTION","label":"County","overrideSubOptionsSrcFromParameterName":"STATE","placeholder":"All","defaultValue":""},{"type":"checkbox","name":"CRA_SEARCH_YN","defaultValue":false,"label":"Search by Registered Agent PID"},{"type":"dateRange","name":"FILING_DATE","label":"Registration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}},{"type":"dateRange","name":"EXPIRATION_DATE","label":"Expiration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}}],"myRecordsFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Active"},{"value":2,"label":"Inactive"},{"value":3,"label":"Pending"}]},{"type":"dateRange","name":"DATE_RANGE","label":"Date range","defaultValue":{"start":null,"end":null}}],"myWorkQueueFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Approved"},{"value":2,"label":"Pending Online Payment"},{"value":3,"label":"Pending Review"},{"value":4,"label":"Needs Correction"},{"value":5,"label":"Rejected"},{"value":6,"label":"Draft"}]},{"type":"dateRange","name":"DATE_RANGE","label":"Date range","defaultValue":{"start":null,"end":null}}]},{"label":"Notary","component":"Notary","parameter":"notary","sourceTypeId":850,"myWorkQueueSearch":false,"allowEmptySearchTerm":true,"requestCertificateAlternateLabel":"Download Certificate","fileAmendmentButtonLabel":"Filing Actions","hideNameRequestCertificate":true,"hideAddressRequestCertificate":true,"hideRecordUserManagment":true,"searchPlaceholder":"Search by name or commission number","searchMustHaveOneOf":["CITY","search","SERVICE_TYPE"],"advancedParametersStartOpen":true,"searchIsSortable":true,"advancedSearchParameters":[{"type":"radio","name":"STARTS_WITH_YN","defaultValue":false,"options":[{"value":true,"label":"Starts with"},{"value":false,"label":"Contains"}]},{"type":"checkbox","name":"ACTIVE_ONLY_YN","defaultValue":true,"label":"Active entities only"},{"type":"text","name":"CITY","defaultValue":"","label":"City"},{"type":"select","name":"SERVICE_TYPE","label":"Special Services Offered","defaultValue":0,"options":[{"value":0,"label":"(N/A)"},{"value":6165,"label":"In-Person Electronic Notarization (IPEN)"},{"value":6166,"label":"Remote Online Notarization (RON)"},{"value":6167,"label":"Mobile Notary Services"},{"value":6168,"label":"Remote Ink Notarization (RIN)"}]}]},{"label":"Apostille","component":"Apostille","parameter":"apostille","sourceTypeId":720,"myRecordsSearch":false,"myWorkQueueSearch":false,"disabled":false,"allowedRoutes":["/forms-manager/","/queue/","/forms/"]},{"label":"Liens","component":"UCC","parameter":"ucc","sourceTypeId":1999,"myRecordsSearch":true,"myWorkQueueSearch":true,"fileAmendmentButtonLabel":"Filing Actions","searchPlaceholder":"Search by name or file number","disabled":false,"serverWebSearchDescription":true,"myRecordsDescription":"","workQueueDescription":"","searchDescription":"","hideRecordUserManagment":true,"searchLiensCheckout":false,"advancedSearchParameters":[{"type":"radio","name":"STARTS_WITH_YN","defaultValue":false,"options":[{"value":true,"label":"Starts with"},{"value":false,"label":"Contains"}]},{"type":"select","name":"STATUS","defaultValue":"ALL","label":"Status","options":[{"value":"ACTIVE_UNLAPSED","label":"Active (unlapsed)"},{"value":"ACTIVE_LAPSED_UNLAPSED","label":"Active (lapsed and unlapsed)"}]},{"type":"text","name":"EXCLUDE_VALUES","label":"Exclude Debtor Names (comma separated list of names to exclude)","defaultValue":""},{"type":"dateRange","name":"FILING_DATE","label":"Financing Statement Date","defaultValue":{"start":null,"end":null}},{"type":"dateRange","name":"LAPSE_DATE","label":"Lapse Date","defaultValue":{"start":null,"end":null}},{"type":"text","name":"CITY","label":"Debtor City","defaultValue":""}],"myRecordsFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Approved"},{"value":2,"label":"Pending Online Payment"},{"value":3,"label":"Pending Review"}]},{"type":"select","name":"TYPE","defaultValue":0,"label":"Lien Type","options":[{"value":0,"label":"All"},{"value":1,"label":"UCC"},{"value":2,"label":"EFS"},{"value":3,"label":"Title 71"}]}],"myWorkQueueFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Approved"},{"value":2,"label":"Pending Online Payment"},{"value":3,"label":"Pending Review"},{"value":4,"label":"Pending Print and Mail"},{"value":5,"label":"Rejected"},{"value":6,"label":"Draft"}]},{"type":"select","name":"TYPE","defaultValue":0,"label":"Lien Type","options":[{"value":0,"label":"All"},{"value":1,"label":"UCC"},{"value":2,"label":"EFS"},{"value":3,"label":"Title 71"}]}]},{"label":"Copy Request","component":"copies","parameter":"copies","sourceTypeId":2001,"myRecordsSearch":false,"myWorkQueueSearch":false,"disabled":false,"allowedRoutes":["/forms-manager/","/queue/","/forms/"]},{"label":"Trademark","component":"Trademark","parameter":"trademark","sourceTypeId":810,"showRequestCertificate":true,"searchMustHaveOneOf":["search","EXPIRATION_DATE","FILING_DATE"],"allowEmptySearchTerm":true,"requestCertificateAlternateLabel":"Request Information","fileAmendmentButtonLabel":"Filing Actions","advancedSearchParameters":[{"type":"radio","name":"QUERY_TYPE_ID","defaultValue":1010,"options":[{"value":1010,"label":"Starts with"},{"value":1011,"label":"Contains"},{"value":1012,"label":" Word Contains"}]},{"type":"checkbox","name":"OWNER_SEARCH_YN","defaultValue":false,"label":"Search owners"},{"type":"radio","name":"SERVICE_MARK_YN","label":"Mark Type","defaultValue":"","options":[{"value":"","label":"All Marks"},{"value":"Y","label":"Service Mark"},{"value":"N","label":"Trademark"}]},{"type":"serverSelect","name":"STATUS_ID","optionsSrc":"TYPE_V|TRADEMARK_STATUS_TYPE","label":"Status","placeholder":"All","defaultValue":"0"},{"type":"select","name":"DESIGN_TYPE_ID","options":[{"value":0,"label":"All"},{"value":990,"label":"Words Only"},{"value":991,"label":"Design Only"},{"value":992,"label":"Words and Design"}],"label":"Design Type","defaultValue":"0"},{"type":"dateRange","name":"FILING_DATE","label":"Registered Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}},{"type":"dateRange","name":"EXPIRATION_DATE","label":"Expiration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}}]},{"label":"Business Info Request","component":"InfoRequests","parameter":"info-request","sourceTypeId":167,"allowedRoutes":["/forms-manager/","/queue/","/forms/"]},{"label":"Data Requests","component":"DataRequests","parameter":"data-request","sourceTypeId":0,"allowedRoutes":["/forms-manager/"]},{"label":"CRA","component":"CRA","parameter":"cra","sourceTypeId":157,"myRecordsSearch":false,"searchPlaceholder":"Search by name or registered agent number","allowedRoutes":["/forms-manager/","/forms/","/records/","/queue/","/search/"],"allowEmptySearchTerm":true,"fileAmendmentButtonLabel":"Filing Actions","advancedSearchParameters":[{"type":"radio","name":"QUERY_TYPE_ID","defaultValue":1010,"options":[{"value":1010,"label":"Starts with"},{"value":1011,"label":"Contains"},{"value":1012,"label":" Word Contains"}]},{"type":"dateRange","name":"CRA_DATE","label":"Registration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}},{"type":"select","name":"STATUS_ID","label":"Status","defaultValue":0,"options":[{"value":0,"label":"All"},{"value":121,"label":"Active"},{"value":122,"label":"Inactive"}]},{"type":"select","name":"AGENT_TYPE_ID","label":"Agent Type","defaultValue":0,"options":[{"value":0,"label":"All"},{"value":460,"label":"Registered Agent"},{"value":461,"label":"Commercial Registered Agent"}]}]},{"label":"Farm Bill","component":"FarmBill","parameter":"farm-bill","path":"/lists/farm-bill","sourceTypeId":0,"myRecordsSearch":false,"allowedRules":["/search/"],"disabled":true,"searchDescription":"To perform a search, enter a debtor name. Your search results may include: exact debtor name, variations of that name and any filing that includes your search criteria. Punctuation is ignored.\n\nYou can click on \"Advanced\" to refine your search. Under “Advanced” you can search by crop, year, county and SSN/FEIN. As a registered Farm Bill Buyer with the Montana Secretary of State’s office it is important to maintain the confidentiality of the information contained within the Farm Bill Master List. The Farm Bill Master List reflects personal data, such as Social Security Numbers, which are a key piece of personal identifiable information to assist you in determining the existence of a lien against a specific debtor. The distribution of this information beyond its intended purpose is strictly prohibited.\n\nThe debtor's tax identification number has been hidden for confidentiality reasons. You may continue to search on a tax ID number and return debtors that match your search criteria. The SSN/FEIN must be entered without dashes or spaces.","searchMustHaveOneOf":["search","UCC_FARM_PRODUCT_ID","COUNTY"],"searchPlaceholder":"Search by debtor name","advancedSearchParameters":[{"type":"ServerMultiComplete","label":"Product code name(s)","name":"UCC_FARM_PRODUCT_ID","defaultValue":"","optionsSrc":"UCC_FARM_PRODUCT_V"},{"type":"MultiComplete","label":"Year or Range of Years","name":"YEAR_NUM","optionsSrc":"years","startYear":"1968","defaultValue":[],"preMergeOptions":[{"value":"ALL","label":"All"}]},{"type":"serverSelect","label":"State","name":"STATE","defaultValue":"MONTANA","optionsSrc":"STATE"},{"type":"ServerMultiComplete","label":"County","name":"COUNTY","defaultValue":[],"optionsSrc":"COUNTY","overrideSubOptionsSrcFromParameterName":"STATE"},{"type":"checkbox","name":"TIN_SEARCH_YN","defaultValue":false,"label":"Tax Identification Number Search"},{"type":"checkbox","name":"TIN_SORT_YN","defaultValue":false,"label":"Unique ID Sort"}]}],"SYSTEM_NICKNAME":"Online Services Portal","PAYMENT_METHODS":[{"type":"bypass"},{"type":"iTransact"}],"PAYMENT_ALLOW_AMEX":true,"SYSTEM_ID_LABEL":"System Id","DOUBLE_COLUMN_PUBLIC_LOGIN":true,"INTERNAL_USER_MANAGEMENT":true,"ALLOW_PUBLIC_JSON_IMPORT":false,"MAX_FILE_UPLOAD_SIZE":10000000,"REFUND_TEXT":"","RETURN_TO_HOME_ON_LOGOUT":true,"CURRENT_SOS_NAME":"Christi Jacobsen","LOGO_FILENAME":"mt-sos-logo.png","LOGO_ALT":"Christi Jacobsen, Montana Secretary of State","LOGO_FULL_WIDTH":true,"HOME_HIDE_AUTH_HINT":true,"HOME_TITLE":"Montana Secretary of State","CUSTOM_TAB_TITLE":"Official Montana","HOME_SUBTITLE":"Online Business Services","ENTITY_NAME_CONSENT_DESCRIPTION":"","ALLOW_USER_PROFILE_EDITING":true,"COMPARE_FOREIGN_NAME_IN_ENTITY_NAME_VALIDATION":true,"FOREIGN_NAME_FIELD_NAME":"KIMA_PARENT_NAME_INFO","LOGIN_TITLE":"Montana Secretary of State Online Filing Portal Login","PUBLIC_LOGIN_LABEL":"Username","REVERSE_LOGIN_COLUMNS":true,"LOGIN_SEAL_FILENAME":"seal_white.png","SEPARATE_USERNAME_AND_EMAIL":true,"CREATE_ACCOUNT_BUTTON_ALIGN_LEFT":true,"CREATE_ACCOUNT_BUTTON_TEXT":"CREATE AN ACCOUNT","PASSWORD_CUSTOM_ERROR_TEXT":"The password must meet all requirements","ACCOUNT_CREATED_MESSAGE":"Please check your email to verify your account to login and allow a few minutes for this message to arrive. Check your junk/spam folders if you do not find the email in your inbox.","PUBLIC_LOGIN_PLACEHOLDER":" ","DISABLE_DEFAULT_PAYMENT_RADIO":true,"CUSTOM_RESET_PASSWORD_ERROR_MESSAGE":"Username invalid - no account found","PUBLIC_LOGIN_CREATE_DESCRIPTION":"### Existing User:\n\n  - Enter your username and password to login.  \n\n\n  #### - OR -  \n\n\n\n  - Forgot password? Click 'Reset Password' and follow the prompts.\n  - Forgot username? Click 'Forgot Username' and follow the prompts.  \n\n\n  ### New User:\n  ","LOGIN_HELP_LINK":"https://sosmt.gov/business/how-do-i/","LOGIN_HELP_LINK_TEXT":"Need Help?","FORGOT_USERNAME_TEXT":"Forgot Username?","LOGIN_ACTIVE_DIRECTORY_TEXT":"State User Login","MULTIPLE_LOGIN_METHODS":true,"HAS_ACTIVE_DIRECTORY_LOGIN":true,"RESET_PASSWORD_WITH_USERNAME":true,"DOWNLOAD_LINK":true,"SHOW_USERNAME_ACCOUNT_CREATE":true,"SHOW_SCROLL_DOWN_ARROW":true,"SHOW_ADDRESS_ACCOUNT_CREATE":true,"TWO_COLUMN_ACCOUNT_CREATE":true,"RESET_PASSWORD_TIP":"A link to change your password has been sent to your email. Please allow a few minutes for this message to arrive. Please check your junk/spam folders if you do not find the email in your inbox.","FORGOT_PASSWORD_LINK_TEXT":"Reset Password","PHONE_NUMBER_OPTIONAL_ACCOUNT_CREATE":true,"SHOW_REQUIRED_INDICATOR_ACCOUNT_CREATE":true,"PASSWORD_REQUIREMENTS_ACCOUNT_CREATE":"\n    <ul>\n      <li>MUST contain at least 8 characters (12+ recommended)</li>\n      <li>MUST contain at least one uppercase letter.</li>\n      <li>MUST contain at least one lowercase letter.</li>\n      <li>MUST contain at least one number.</li>\n      <li>MUST contain at least one special character (!”#$%&'()*+,-./:;<=>?</li>\n    </ul>\n  ","ALLOW_CERTIFICATION_REQUEST":true,"ALLOW_PUBLIC_CERTIFICATE_REQUEST":true,"ALLOW_COPY_REQUEST":false,"ALLOW_CORRECTION_STYLING":true,"HIDE_DEPRECATION_WARNING":false,"AMEND_ROUTE_PUBLIC":true,"SEAL_FILENAME":"seal.png","SHOPPING_CART":true,"ALLOW_PAYMENT_UPDATE_WITH_EMPTY_CART":true,"RA_EMAIL":true,"RA_WEBSITE":true,"RA_NO_DEFAULT_TYPE":true,"RA_ADDRESS_LABEL":"Street Address","RA_TYPE_SELECTION_DEFAULT":true,"RA_DEFAULT_TYPE":"460","RA_OVERRIDE_TYPE_WITH_DEFAULT":true,"RA_PRINCIPAL_ADDRESS_AMS":true,"UPLOAD_AND_SUBMIT_HIDE_IF_ONE_OPTION":true,"PAYMENT_PROCESSING_MESSAGE":"Your payment is processing - Do not close your browser or click the back button","CHECKOUT_BUTTON_WHEN_PROCESSING_TEXT":"Processing","EFS_CROP_PICKER_NONE_LABEL":"Lien Duration","DISALLOWED_WIZARD_PIECES":["FormationLocale"],"REPEATER_SHOW_EDIT_BUTTON":true,"DATA_REQUEST_PAGE_TITLE":"Data Requests and Subscriptions","DATA_REQUEST_SIDEBAR_LABEL":"Data Requests & Subscriptions","LOGIN_REDIRECTS_TO_EPASS":false,"LOGIN_REDIRECTS_TO_ACTIVE_DIRECTORY":true,"LOGIN_ACTIVE_DIRECTORY_LINK":true,"FETCH_EDIT_USER_LINK":false,"LISTS_FETCH_AVAILABLE_LISTS":true,"POST_WIZARD_SUBMIT_REDIRECT_URL":"/","PIN_REQUEST_ATTESTATIONS":true,"PIN_REQUEST_DESCRIPTION":"Click **Request PIN** to have a new PIN sent to the account holder's email address on file.","OWNERSHIP_REQUEST_DESCRIPTION":"To become an **authorized user** of this record, a current **AUTHORIZED USER** will need to grant you access. To request access, click **Request Access** below.","PIN_REQUEST_SUCCESS_MESSAGE":"The PIN you have requested for this entity has been sent to the email associated with your user account.  You should receive the PIN in approximately 3-5 minutes, depending on your email service provider.","APOSTILLE_HEADER_LABEL":"Verification Information","APOSTILLE_NUMBER_LABEL":"Apostille/Authentication","APOSTILLE_CITY_STATE_OVERRIDE":"HELENA, MT","APOSTILLE_FILING_DATE_LABEL":"Issue Date","APOSTILLE_CITY_STATE_IN_CERTIFIED":true,"NOTARY_EXISTING_FILING":true,"ALLOW_REVOKE_OWN_ACCESS_ONLY":false,"HIDE_CANCEL_ON_ONETIME_DATA_REQUESTS":true,"DATA_REQUESTS_IN_SHOPPING_CART":true,"WQ_ALLOW_EDIT_PENDING_PAYMENT":true,"WQ_CONFIRM_ON_DELETE":true,"WQ_DELETE_CONFIRM_MESSAGE":"Deleting this filing will forfeit any money already paid to the Secretary of State. This action is permanent and cannot be undone, are you sure you would like to delete?","PASS_ITEM_GUIDS_ON_CHECKOUT":true,"FORM_REVISION_HISTORY":true,"CHECKOUT_DISCLAIMER":"By entering your credit card and/or checking account information you (i) state that **you are an authorized user** of the credit card and/or electronic check and that the associated information entered (e.g., account holder name, account number, billing address) is accurate, (ii) **you authorize payment processor to charge the amount you have requested** to your credit card and/or funding account, and (iii) **acknowledge if a charge is declined or reversed you may also be assessed a customary charge** by the payment processor for such transactions.","FARM_BILL_SEARCH_CONFIDENTIAL":"As a registered Farm Bill Buyer with the Montana Secretary of State’s office it is important to maintain the confidentiality of the information contained within the Farm Bill Master List. The Farm Bill Master List reflects personal data, such as Social Security Numbers, which are a key piece of personal identifiable information to assist you in determining the existence of a lien against a specific debtor. The distribution of this information beyond its intended purpose is strictly prohibited.\n\n**The debtor's tax identification number has been hidden for confidentiality reasons. You may continue to search on a tax ID number and return debtors that match your search criteria. The SSN/FEIN must be entered without dashes or spaces.  If you need access to the tax identification number to clearly identify the debtor, please contact the UCC unit at (406) 444-3665.**","VIEW_HISTORY_BUTTON_ALT_TEXT":"View Filings","WIZARD_ERROR_TITLE_MESSAGE":"Form Error","FARM_BILL_SEARCH_INTERACTIVE":true,"USE_FARM_BILL_API":true,"DISALLOW_ASSIGN_SELF_AS_RA":true,"DISALLOW_ASSIGN_SELF_AS_PRINCIPAL":true,"USE_TRADEMARK_OWNER_VALIDATION":true,"USE_ALTERNATIVE_FOREIGN_ADDRESS_LABELS":true,"MY_RECEIPTS_FILTER":[{"type":"dateRange","name":"DATE_RANGE","label":"Date range","defaultValue":{"start":null,"end":null}},{"type":"text","name":"REF_NUM","defaultValue":"","label":"Reference Number"},{"type":"text","name":"RECEIPT_NUM","defaultValue":"","label":"Receipt Id"},{"type":"text","name":"AMOUNT","defaultValue":"","label":"Amount"},{"type":"select","name":"TYPE","defaultValue":"","label":"Payment Type","options":[{"value":"","label":"All"},{"value":"CC","label":"Credit Card"},{"value":"Check","label":"Check"}]}],"MY_RECEIPTS_SHOW_IN_SIDEBAR":true,"SHOW_MY_RECEIPTS_HELPER_TEXT":true,"MY_RECEIPTS_HELPER_LABEL":"About Receipt Search","MY_RECEIPTS_HELPER_TEXT":"You can search for receipts based on their descriptions, including the items paid for on the receipt. Use the filters to search for or filter specific information.","FARM_BILL_SUBLINK":{"label":"Farm Bill","component":"FarmBill","parameter":"farm-bill","path":"/lists/farm-bill","sourceTypeId":0,"myRecordsSearch":false,"allowedRules":["/search/"],"disabled":true,"searchDescription":"To perform a search, enter a debtor name. Your search results may include: exact debtor name, variations of that name and any filing that includes your search criteria. Punctuation is ignored.\n\nYou can click on \"Advanced\" to refine your search. Under “Advanced” you can search by crop, year, county and SSN/FEIN. As a registered Farm Bill Buyer with the Montana Secretary of State’s office it is important to maintain the confidentiality of the information contained within the Farm Bill Master List. The Farm Bill Master List reflects personal data, such as Social Security Numbers, which are a key piece of personal identifiable information to assist you in determining the existence of a lien against a specific debtor. The distribution of this information beyond its intended purpose is strictly prohibited.\n\nThe debtor's tax identification number has been hidden for confidentiality reasons. You may continue to search on a tax ID number and return debtors that match your search criteria. The SSN/FEIN must be entered without dashes or spaces.","searchMustHaveOneOf":["search","UCC_FARM_PRODUCT_ID","COUNTY"],"searchPlaceholder":"Search by debtor name","advancedSearchParameters":[{"type":"ServerMultiComplete","label":"Product code name(s)","name":"UCC_FARM_PRODUCT_ID","defaultValue":"","optionsSrc":"UCC_FARM_PRODUCT_V"},{"type":"MultiComplete","label":"Year or Range of Years","name":"YEAR_NUM","optionsSrc":"years","startYear":"1968","defaultValue":[],"preMergeOptions":[{"value":"ALL","label":"All"}]},{"type":"serverSelect","label":"State","name":"STATE","defaultValue":"MONTANA","optionsSrc":"STATE"},{"type":"ServerMultiComplete","label":"County","name":"COUNTY","defaultValue":[],"optionsSrc":"COUNTY","overrideSubOptionsSrcFromParameterName":"STATE"},{"type":"checkbox","name":"TIN_SEARCH_YN","defaultValue":false,"label":"Tax Identification Number Search"},{"type":"checkbox","name":"TIN_SORT_YN","defaultValue":false,"label":"Unique ID Sort"}]},"ALLOW_ADDRESS_VALIDATION_BYPASS_OPTION":true,"DEFAULT_ADDRESS_VALIDATION_BYPASS_OPTION_CHECKED":true}).HIDE_PHONE_ACCOUNT_CREATE ? null : _react2.default.createElement(
	            'div',
	            { className: 'field' },
	            _react2.default.createElement(
	              'label',
	              { htmlFor: 'phone', id: 'phone-label' },
	              'Phone'
	            ),
	            _react2.default.createElement('input', {
	              type: 'text',
	              autoComplete: 'tel',
	              onChange: function onChange(e) {
	                return _this3.phone.value = _validate.MASK.phone(e.target.value);
	              },
	              ref: function ref(_ref9) {
	                _this3.phone = _ref9;
	              },
	              onKeyDown: this.checkEnter,
	              placeholder: '###-###-####',
	              id: 'phone',
	              'aria-describedby': 'phone-error',
	              'aria-invalid': !!this.state.errors.phone,
	              'aria-labelledby': 'phone-label'
	            }),
	            _react2.default.createElement(
	              FieldError,
	              { id: 'phone-error' },
	              this.state.errors.phone
	            )
	          ),
	           true ? _react2.default.createElement(
	            'div',
	            { className: 'wizard' },
	            _react2.default.createElement(_AddressBlock2.default, {
	              value: this.state.address,
	              onChange: function onChange(value) {
	                _this3.setValue(value, 'address');
	              },
	              width: '100%',
	              showCityStateZip: true,
	              allowSelection: false,
	              singleColSize: 'col-12',
	              showCountry: true,
	              hideAttention: true,
	              triColSizes: {
	                CITY: 'col-4',
	                STATE: 'col-4',
	                POSTAL_CODE: 'col-4',
	                ZIP: 'col-4'
	              }
	            }),
	            _react2.default.createElement(
	              FieldError,
	              { id: 'address-error' },
	              this.state.errors.address
	            )
	          ) : null
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: '' + ( true ? 'column-2' : '') },
	          _react2.default.createElement(
	            'div',
	            { className: 'field' },
	            _react2.default.createElement(
	              'label',
	              { htmlFor: 'password-field', id: 'password-label' },
	              'Password',
	              (true) && _react2.default.createElement(
	                'span',
	                { style: { color: 'red' } },
	                '*'
	              )
	            ),
	            _react2.default.createElement(
	              'span',
	              { className: 'description', id: 'password-description' },
	               true ? _react2.default.createElement('span', { dangerouslySetInnerHTML: { __html: ("\n    <ul>\n      <li>MUST contain at least 8 characters (12+ recommended)</li>\n      <li>MUST contain at least one uppercase letter.</li>\n      <li>MUST contain at least one lowercase letter.</li>\n      <li>MUST contain at least one number.</li>\n      <li>MUST contain at least one special character (!”#$%&'()*+,-./:;<=>?</li>\n    </ul>\n  ") } }) : 'Must be at least 8 characters'
	            ),
	            _react2.default.createElement('input', {
	              type: 'password',
	              ref: function ref(_ref10) {
	                _this3.password = _ref10;
	              },
	              onKeyDown: this.checkEnter,
	              placeholder: '',
	              id: 'password-field',
	              'aria-describedby': 'password-description . password-error',
	              'aria-invalid': !!this.state.errors.password,
	              'aria-labelledby': 'password-label'
	            }),
	            _react2.default.createElement(
	              FieldError,
	              { id: 'password-error' },
	              this.state.errors.password
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'field' },
	            _react2.default.createElement(
	              'label',
	              { htmlFor: 'confirm-password', id: 'confirm-label' },
	              'Confirm Password',
	              (true) && _react2.default.createElement(
	                'span',
	                { style: { color: 'red' } },
	                '*'
	              )
	            ),
	            _react2.default.createElement('input', {
	              type: 'password',
	              ref: function ref(_ref11) {
	                _this3.confirmPassword = _ref11;
	              },
	              onKeyDown: this.checkEnter,
	              placeholder: '',
	              id: 'confirm-password',
	              'aria-describedby': 'confirm-error',
	              'aria-invalid': !!this.state.errors.confirmPassword,
	              'aria-labelledby': 'confirm-label'
	            }),
	            _react2.default.createElement(
	              FieldError,
	              { id: 'confirm-error' },
	              this.state.errors.confirmPassword
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'button-wrapper create-wrapper' },
	            _react2.default.createElement(
	              'button',
	              {
	                type: 'button',
	                className: 'btn-raised btn-light-primary submit',
	                onClick: this.validate
	              },
	              'CREATE ACCOUNT'
	            ),
	            _react2.default.createElement(
	              FieldError,
	              { role: 'alert' },
	              this.state.errors.global
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'button-wrapper create-wrapper' },
	            _react2.default.createElement(
	              'button',
	              {
	                type: 'button',
	                className: 'create-account-button',
	                onClick: returnToLogin
	              },
	              'Login with existing account'
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return CreateAccountForm;
	}(_react2.default.Component);
	
	exports.default = CreateAccountForm;
	var FieldError = exports.FieldError = function FieldError(_ref12) {
	  var children = _ref12.children,
	      _ref12$id = _ref12.id,
	      id = _ref12$id === undefined ? "" : _ref12$id,
	      role = _ref12.role;
	  return children ? _react2.default.createElement(
	    'p',
	    { className: 'field-error animated fadeIn fast-animation', id: id, role: role },
	    children
	  ) : null;
	};

/***/ },
/* 150 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	__webpack_require__(1471);
	
	var _ActionButton = __webpack_require__(194);
	
	var _ActionButton2 = _interopRequireDefault(_ActionButton);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ALLOW_CORRECTION_STYLING = (true);
	
	var Table = function (_Component) {
	  _inherits(Table, _Component);
	
	  function Table() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, Table);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Table.__proto__ || Object.getPrototypeOf(Table)).call.apply(_ref, [this].concat(args))), _this), _this.onCellClick = function (rowIndex, rowId) {
	      if (_this.props.onCellClick) {
	        _this.props.onCellClick(rowIndex, rowId);
	      }
	    }, _this.getActionsFromMap = function () {
	      var type = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'default';
	      var row = arguments[1];
	      var _this$props$actionMap = _this.props.actionMap,
	          actionMap = _this$props$actionMap === undefined ? {} : _this$props$actionMap;
	
	      return typeof actionMap[type] === 'function' ? actionMap[type](row) : actionMap[type];
	    }, _this.highlightRowByIndex = function (index) {
	      _this.rowRefs[index].highlight();
	    }, _this.checkForClick = function (e) {
	      if (_this.props.sortable && (e.keyCode === 13 || e.keyCode === 32)) {
	        e.target.click();
	      }
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(Table, [{
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _props = this.props,
	          _props$actionCell = _props.actionCell,
	          actionCell = _props$actionCell === undefined ? false : _props$actionCell,
	          _props$actionCellClas = _props.actionCellClassName,
	          actionCellClassName = _props$actionCellClas === undefined ? '' : _props$actionCellClas,
	          _props$animated = _props.animated,
	          animated = _props$animated === undefined ? true : _props$animated,
	          _props$className = _props.className,
	          className = _props$className === undefined ? '' : _props$className,
	          interactive = _props.firstCellInteractive,
	          innerRef = _props.innerRef,
	          onHeaderLabelClicked = _props.onHeaderLabelClicked,
	          _props$rowCount = _props.rowCount,
	          rowCount = _props$rowCount === undefined ? false : _props$rowCount,
	          _props$rows = _props.rows,
	          rows = _props$rows === undefined ? [] : _props$rows,
	          selectedRowIndex = _props.selectedRowIndex,
	          sortable = _props.sortable,
	          sortBy = _props.sortBy,
	          _props$sortByDirectio = _props.sortByDirection,
	          sortByDirection = _props$sortByDirectio === undefined ? '' : _props$sortByDirectio,
	          _props$template = _props.template,
	          template = _props$template === undefined ? [] : _props$template,
	          _props$totalRows = _props.totalRows,
	          totalRows = _props$totalRows === undefined ? null : _props$totalRows;
	
	      var firstCellInteractive = interactive === false ? false : true;
	      return _react2.default.createElement(
	        _react2.default.Fragment,
	        null,
	        _react2.default.createElement(
	          'span',
	          { role: 'status', className: 'row-count' },
	          _react2.default.createElement(
	            'span',
	            { className: 'row-count-text' },
	            rowCount && rows.length > 0 ? 'Results: ' + (totalRows || rows.length) : ''
	          )
	        ),
	        _react2.default.createElement(
	          'table',
	          { ref: function ref(_ref3) {
	              return innerRef(_ref3);
	            }, className: 'div-table ' + className },
	          template && rows.length > 0 ? _react2.default.createElement(
	            'thead',
	            {
	              className: 'div-table-heading ' + (animated ? 'animated fadeIn fast-animation' : '')
	            },
	            _react2.default.createElement(
	              'tr',
	              null,
	              template.map(function (t, i) {
	                return _react2.default.createElement(
	                  'th',
	                  {
	                    className: 'div-table-head ' + (sortable ? 'sortable' : ''),
	                    key: i,
	                    onClick: function onClick(e) {
	                      return onHeaderLabelClicked ? onHeaderLabelClicked(e, t.id) : undefined;
	                    },
	                    tabIndex: sortable ? 0 : undefined,
	                    onKeyDown: _this2.checkForClick,
	                    'aria-sort': sortable && sortBy === t.id ? sortByDirection.toUpperCase() === 'DESC' ? 'descending' : 'ascending' : undefined
	                  },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'flex-row' },
	                    _react2.default.createElement(
	                      'span',
	                      { className: 'header-label' },
	                      t.label
	                    ),
	                    sortable ? _react2.default.createElement(SortIndicator, {
	                      sortByDirection: sortBy && sortBy === t.id ? sortByDirection.toUpperCase() : ''
	                    }) : null
	                  )
	                );
	              }),
	              actionCell ? _react2.default.createElement(
	                'th',
	                { className: 'div-table-head' },
	                'Actions'
	              ) : null
	            )
	          ) : null,
	          _react2.default.createElement(
	            'tbody',
	            { className: 'div-table-body' },
	            rows.map(function (row, i) {
	              var actions = _this2.getActionsFromMap(row.TYPE, row);
	              return _react2.default.createElement(Row, {
	                cells: row,
	                template: template,
	                selected: i === selectedRowIndex,
	                onCellClick: _this2.onCellClick,
	                alert: row.ALERT_YN
	                // id={row.ID}
	                // index={i}
	                , rowIndex: i + 1,
	                key: row.ID + i.toString(),
	                actionCellClassName: actionCellClassName,
	                firstCellInteractive: firstCellInteractive,
	                ref: function ref(_ref2) {
	                  _this2.rowRefs = [].concat(_toConsumableArray(_this2.rowRefs || []), [_ref2]);
	                },
	                actionCell: actionCell ? actions ? actions : _this2.getActionsFromMap('default') : null
	              });
	            })
	          )
	        )
	      );
	    }
	  }]);
	
	  return Table;
	}(_react.Component);
	
	Table.defaultProps = {
	  innerRef: function innerRef() {}
	};
	exports.default = Table;
	
	var Row = function (_React$Component) {
	  _inherits(Row, _React$Component);
	
	  function Row() {
	    var _ref4;
	
	    var _temp2, _this3, _ret2;
	
	    _classCallCheck(this, Row);
	
	    for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
	      args[_key2] = arguments[_key2];
	    }
	
	    return _ret2 = (_temp2 = (_this3 = _possibleConstructorReturn(this, (_ref4 = Row.__proto__ || Object.getPrototypeOf(Row)).call.apply(_ref4, [this].concat(args))), _this3), _this3.state = {
	      highlighted: false
	    }, _this3.highlight = function () {
	      _this3.setState({ highlighted: true });
	    }, _this3.checkForClick = function (e) {
	      var code = e.charCode || e.keyCode;
	      if (code === 32 || code === 13) {
	        var isActionButton = Array.from(e.target.parentElement.parentElement.classList).includes('action-button');
	        if (!isActionButton) {
	          e.preventDefault();
	          _this3.props.onCellClick(_this3.props.cells);
	        }
	      }
	    }, _temp2), _possibleConstructorReturn(_this3, _ret2);
	  }
	
	  _createClass(Row, [{
	    key: 'render',
	    value: function render() {
	      var _props2 = this.props,
	          label = _props2.label,
	          template = _props2.template,
	          cells = _props2.cells,
	          onCellClick = _props2.onCellClick,
	          selected = _props2.selected,
	          _props2$actionCell = _props2.actionCell,
	          actionCell = _props2$actionCell === undefined ? [] : _props2$actionCell,
	          actionCellClassName = _props2.actionCellClassName,
	          firstCellInteractive = _props2.firstCellInteractive;
	
	      return _react2.default.createElement(
	        'tr',
	        {
	          className: 'div-table-row ' + (selected ? 'selected' : '') + ' ' + (this.state.highlighted ? 'highlighted' : ''),
	          'aria-label': label,
	          onKeyPress: this.checkForClick
	        },
	        template.map(function (t, i) {
	          var isFirstInteractiveCell = firstCellInteractive && i === 0;
	
	          var cellContent = _react2.default.createElement(
	            _react2.default.Fragment,
	            null,
	            typeof t.render === 'function' ? _react2.default.createElement(
	              'span',
	              { className: 'cell' },
	              t.render(cells[t.id])
	            ) : Array.isArray(cells[t.id]) ? cells[t.id].map(function (cellData, j) {
	              return _react2.default.createElement(
	                'span',
	                { className: 'cell', key: j },
	                cellData
	              );
	            }) : _react2.default.createElement(
	              'span',
	              { className: 'cell ' + (cells[t.id] === 'Needs Correction' && ALLOW_CORRECTION_STYLING ? 'danger-text-bold' : '') },
	              cells[t.id]
	            ),
	            isFirstInteractiveCell && _react2.default.createElement('span', { className: 'icon icon-caret-right' })
	          );
	
	          return _react2.default.createElement(
	            'td',
	            {
	              className: 'div-table-cell ' + (selected ? 'selected' : '') + ' ' + (firstCellInteractive ? 'interactive' : ''),
	              onClick: function onClick() {
	                if (isFirstInteractiveCell) {
	                  onCellClick(cells);
	                }
	              },
	              key: i
	            },
	            cells.ALERT && i === 0 && _react2.default.createElement(
	              'div',
	              { className: 'badge row-alert', key: i },
	              '!'
	            ),
	            isFirstInteractiveCell ? _react2.default.createElement(
	              'div',
	              { role: 'button', tabIndex: 0, className: 'interactive-cell-button' },
	              cellContent
	            ) : cellContent
	          );
	        }),
	        actionCell ? _react2.default.createElement(
	          'td',
	          { className: 'div-table-cell no-padding ' + (selected ? 'selected' : '') + ' action-cell' },
	          _react2.default.createElement(
	            _ActionButton.ActionButtonGroup,
	            {
	              buttonSize: 'extra-small',
	              className: actionCellClassName + ' table-button'
	            },
	            cells.NO_ACTIONS !== true && actionCell.map(function (button, i) {
	              var isVisible = button.getIsVisible ? button.getIsVisible(cells) : true;
	              var label = typeof button.label === 'function' ? button.label(cells) : button.label;
	              var classes = typeof button.className === 'function' ? button.className(cells) : button.className;
	              if (isVisible) {
	                return _react2.default.createElement(_ActionButton2.default, Object.assign({
	                  hideLabel: true,
	                  tooltip: true
	                }, button, {
	                  label: label,
	                  className: classes,
	                  onClick: function onClick() {
	                    button.onClick(cells);
	                  },
	                  key: i,
	                  flex: true
	                }));
	              } else {
	                return null;
	              }
	            })
	          )
	        ) : null
	      );
	    }
	  }]);
	
	  return Row;
	}(_react2.default.Component);
	
	var SortIndicator = function SortIndicator(_ref5) {
	  var sortByDirection = _ref5.sortByDirection;
	  return _react2.default.createElement(
	    'div',
	    { className: 'sort-indicator-wrapper' },
	    _react2.default.createElement('div', {
	      className: 'sort-indicator ' + (sortByDirection ? sortByDirection === 'DESC' ? 'descending' : 'ascending' : '')
	    })
	  );
	};

/***/ },
/* 151 */
/***/ function(module, exports) {

	/**
	 * Checks if `value` is the
	 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
	 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
	 * @example
	 *
	 * _.isObject({});
	 * // => true
	 *
	 * _.isObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isObject(_.noop);
	 * // => true
	 *
	 * _.isObject(null);
	 * // => false
	 */
	function isObject(value) {
	  var type = typeof value;
	  return value != null && (type == 'object' || type == 'function');
	}
	
	module.exports = isObject;


/***/ },
/* 152 */
/***/ function(module, exports, __webpack_require__) {

	var baseGetTag = __webpack_require__(121),
	    isObjectLike = __webpack_require__(123);
	
	/** `Object#toString` result references. */
	var symbolTag = '[object Symbol]';
	
	/**
	 * Checks if `value` is classified as a `Symbol` primitive or object.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
	 * @example
	 *
	 * _.isSymbol(Symbol.iterator);
	 * // => true
	 *
	 * _.isSymbol('abc');
	 * // => false
	 */
	function isSymbol(value) {
	  return typeof value == 'symbol' ||
	    (isObjectLike(value) && baseGetTag(value) == symbolTag);
	}
	
	module.exports = isSymbol;


/***/ },
/* 153 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.IGNORE_CLASS_NAME = undefined;
	exports.default = onClickOutsideHOC;
	
	var _react = __webpack_require__(1);
	
	var _reactDom = __webpack_require__(70);
	
	var _generateOutsideCheck = __webpack_require__(1319);
	
	var _generateOutsideCheck2 = _interopRequireDefault(_generateOutsideCheck);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * A higher-order-component for handling onClickOutside for React components.
	 */
	var registeredComponents = [];
	var handlers = [];
	
	var touchEvents = ['touchstart', 'touchmove'];
	var IGNORE_CLASS_NAME = exports.IGNORE_CLASS_NAME = 'ignore-react-onclickoutside';
	
	/**
	 * This function generates the HOC function that you'll use
	 * in order to impart onOutsideClick listening to an
	 * arbitrary component. It gets called at the end of the
	 * bootstrapping code to yield an instance of the
	 * onClickOutsideHOC function defined inside setupHOC().
	 */
	function onClickOutsideHOC(WrappedComponent, config) {
	  var _class, _temp2;
	
	  return _temp2 = _class = function (_Component) {
	    _inherits(onClickOutside, _Component);
	
	    function onClickOutside() {
	      var _temp, _this, _ret;
	
	      _classCallCheck(this, onClickOutside);
	
	      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	        args[_key] = arguments[_key];
	      }
	
	      return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.__outsideClickHandler = null, _this.enableOnClickOutside = function () {
	        var fn = _this.__outsideClickHandler;
	        if (fn && typeof document !== 'undefined') {
	          var events = _this.props.eventTypes;
	          if (!events.forEach) {
	            events = [events];
	          }
	
	          events.forEach(function (eventName) {
	            var handlerOptions = null;
	            var isTouchEvent = touchEvents.indexOf(eventName) !== -1;
	
	            if (isTouchEvent) {
	              handlerOptions = { passive: !_this.props.preventDefault };
	            }
	
	            document.addEventListener(eventName, fn, handlerOptions);
	          });
	        }
	      }, _this.disableOnClickOutside = function () {
	        var fn = _this.__outsideClickHandler;
	        if (fn && typeof document !== 'undefined') {
	          var events = _this.props.eventTypes;
	          if (!events.forEach) {
	            events = [events];
	          }
	          events.forEach(function (eventName) {
	            return document.removeEventListener(eventName, fn);
	          });
	        }
	      }, _this.getRef = function (ref) {
	        return _this.instanceRef = ref;
	      }, _temp), _possibleConstructorReturn(_this, _ret);
	    }
	
	    /**
	     * Access the WrappedComponent's instance.
	     */
	    onClickOutside.prototype.getInstance = function getInstance() {
	      if (!WrappedComponent.prototype.isReactComponent) {
	        return this;
	      }
	      var ref = this.instanceRef;
	      return ref.getInstance ? ref.getInstance() : ref;
	    };
	
	    // this is given meaning in componentDidMount/componentDidUpdate
	
	
	    /**
	     * Add click listeners to the current document,
	     * linked to this component's state.
	     */
	    onClickOutside.prototype.componentDidMount = function componentDidMount() {
	      // If we are in an environment without a DOM such
	      // as shallow rendering or snapshots then we exit
	      // early to prevent any unhandled errors being thrown.
	      if (typeof document === 'undefined' || !document.createElement) {
	        return;
	      }
	
	      var instance = this.getInstance();
	
	      if (config && typeof config.handleClickOutside === 'function') {
	        this.__clickOutsideHandlerProp = config.handleClickOutside(instance);
	        if (typeof this.__clickOutsideHandlerProp !== 'function') {
	          throw new Error('WrappedComponent lacks a function for processing outside click events specified by the handleClickOutside config option.');
	        }
	      } else if (typeof instance.handleClickOutside === 'function') {
	        if (_react.Component.prototype.isPrototypeOf(instance)) {
	          this.__clickOutsideHandlerProp = instance.handleClickOutside.bind(instance);
	        } else {
	          this.__clickOutsideHandlerProp = instance.handleClickOutside;
	        }
	      } else if (typeof instance.props.handleClickOutside === 'function') {
	        this.__clickOutsideHandlerProp = instance.props.handleClickOutside;
	      } else {
	        throw new Error('WrappedComponent lacks a handleClickOutside(event) function for processing outside click events.');
	      }
	
	      // TODO: try to get rid of this, could be done with function ref, might be problematic for SFC though, they do not expose refs
	      if ((0, _reactDom.findDOMNode)(instance) === null) {
	        return;
	      }
	
	      this.addOutsideClickHandler();
	    };
	
	    /**
	    * Track for disableOnClickOutside props changes and enable/disable click outside
	    */
	
	
	    onClickOutside.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	      if (this.props.disableOnClickOutside && !nextProps.disableOnClickOutside) {
	        this.enableOnClickOutside();
	      } else if (!this.props.disableOnClickOutside && nextProps.disableOnClickOutside) {
	        this.disableOnClickOutside();
	      }
	    };
	
	    onClickOutside.prototype.componentDidUpdate = function componentDidUpdate() {
	      var componentNode = (0, _reactDom.findDOMNode)(this.getInstance());
	
	      if (componentNode === null && this.__outsideClickHandler) {
	        this.removeOutsideClickHandler();
	        return;
	      }
	
	      if (componentNode !== null && !this.__outsideClickHandler) {
	        this.addOutsideClickHandler();
	        return;
	      }
	    };
	
	    /**
	     * Remove all document's event listeners for this component
	     */
	
	
	    onClickOutside.prototype.componentWillUnmount = function componentWillUnmount() {
	      this.removeOutsideClickHandler();
	    };
	
	    /**
	     * Can be called to explicitly enable event listening
	     * for clicks and touches outside of this element.
	     */
	
	
	    /**
	     * Can be called to explicitly disable event listening
	     * for clicks and touches outside of this element.
	     */
	
	
	    onClickOutside.prototype.addOutsideClickHandler = function addOutsideClickHandler() {
	      var fn = this.__outsideClickHandler = (0, _generateOutsideCheck2.default)((0, _reactDom.findDOMNode)(this.getInstance()), this.__clickOutsideHandlerProp, this.props.outsideClickIgnoreClass, this.props.excludeScrollbar, this.props.preventDefault, this.props.stopPropagation);
	
	      var pos = registeredComponents.length;
	      registeredComponents.push(this);
	      handlers[pos] = fn;
	
	      // If there is a truthy disableOnClickOutside property for this
	      // component, don't immediately start listening for outside events.
	      if (!this.props.disableOnClickOutside) {
	        this.enableOnClickOutside();
	      }
	    };
	
	    onClickOutside.prototype.removeOutsideClickHandler = function removeOutsideClickHandler() {
	      this.disableOnClickOutside();
	      this.__outsideClickHandler = false;
	
	      var pos = registeredComponents.indexOf(this);
	
	      if (pos > -1) {
	        // clean up so we don't leak memory
	        if (handlers[pos]) {
	          handlers.splice(pos, 1);
	        }
	        registeredComponents.splice(pos, 1);
	      }
	    };
	
	    /**
	     * Pass-through render
	     */
	    onClickOutside.prototype.render = function render() {
	      var _this2 = this;
	
	      var props = Object.keys(this.props).filter(function (prop) {
	        return prop !== 'excludeScrollbar';
	      }).reduce(function (props, prop) {
	        props[prop] = _this2.props[prop];
	        return props;
	      }, {});
	
	      if (WrappedComponent.prototype.isReactComponent) {
	        props.ref = this.getRef;
	      } else {
	        props.wrappedRef = this.getRef;
	      }
	
	      props.disableOnClickOutside = this.disableOnClickOutside;
	      props.enableOnClickOutside = this.enableOnClickOutside;
	
	      return (0, _react.createElement)(WrappedComponent, props);
	    };
	
	    return onClickOutside;
	  }(_react.Component), _class.displayName = 'OnClickOutside(' + (WrappedComponent.displayName || WrappedComponent.name || 'Component') + ')', _class.defaultProps = {
	    eventTypes: ['mousedown', 'touchstart'],
	    excludeScrollbar: config && config.excludeScrollbar || false,
	    outsideClickIgnoreClass: IGNORE_CLASS_NAME,
	    preventDefault: false,
	    stopPropagation: false
	  }, _class.getClass = function () {
	    return WrappedComponent.getClass ? WrappedComponent.getClass() : WrappedComponent;
	  }, _temp2;
	}

/***/ },
/* 154 */
/***/ function(module, exports) {

	module.exports = function(module) {
		if(!module.webpackPolyfill) {
			module.deprecate = function() {};
			module.paths = [];
			// module.parent = undefined by default
			module.children = [];
			module.webpackPolyfill = 1;
		}
		return module;
	}


/***/ },
/* 155 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*
		Copyright 2015 Axinom
		Copyright 2011-2013 Abdulla Abdurakhmanov
		Original sources are available at https://code.google.com/p/x2js/
	
		Licensed under the Apache License, Version 2.0 (the "License");
		you may not use this file except in compliance with the License.
		You may obtain a copy of the License at
	
		http://www.apache.org/licenses/LICENSE-2.0
	
		Unless required by applicable law or agreed to in writing, software
		distributed under the License is distributed on an "AS IS" BASIS,
		WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
		See the License for the specific language governing permissions and
		limitations under the License.
	*/
	
	/*
		Supported export methods:
		* AMD
		* <script> (window.X2JS)
		* Node.js
	
		Limitations:
		* Attribute namespace prefixes are not parsed as such.
		* Overall the serialization/deserializaton code is "best effort" and not foolproof.
	*/
	
	// Module definition pattern used is returnExports from https://github.com/umdjs/umd
	(function (root, factory) {
		"use strict";
	
		/* global define */
		if (true) {
			// AMD. Register as an anonymous module.
			!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		} else if (typeof module === 'object' && module.exports) {
			// Node. Does not work with strict CommonJS, but only CommonJS-like
			// environments that support module.exports, like Node.
			module.exports = factory(require("xmldom").DOMParser);
		} else {
			// Browser globals (root is window)
			root.X2JS = factory();
		}
	})(this, function (CustomDOMParser) {
		"use strict";
	
		// We return a constructor that can be used to make X2JS instances.
		return function X2JS(config) {
			var VERSION = "3.4.0";
	
			config = config || {};
	
			function initConfigDefaults() {
				// If set to "property" then <element>_asArray will be created
				// to allow you to access any element as an array (even if there is only one of it).
				config.arrayAccessForm = config.arrayAccessForm || "none";
	
				// If "text" then <empty></empty> will be transformed to "".
				// If "object" then <empty></empty> will be transformed to {}.
				config.emptyNodeForm = config.emptyNodeForm || "text";
	
				// Function that will be called for each elements, if the function returns true, the element will be skipped
				// function(name, value) { return true; };
				config.jsAttributeFilter = config.jsAttributeFilter;
	
				// Function that will be called for each elements, the element value will be replaced by the returned value
				// function(name, value) { return parseFloat(value); };
				config.jsAttributeConverter = config.jsAttributeConverter;
	
				// Allows attribute values to be converted on the fly during parsing to objects.
				// 	"test": function(name, value) { return true; }
				//	"convert": function(name, value) { return parseFloat(value); };
				// convert() will be called for every attribute where test() returns true
				// and the return value from convert() will replace the original value of the attribute.
				config.attributeConverters = config.attributeConverters || [];
	
				// Any elements that match the paths here will have their text parsed
				// as an XML datetime value (2011-11-12T13:00:00-07:00 style).
				// The path can be a plain string (parent.child1.child2),
				// a regex (/.*\.child2/) or function(elementPath).
				config.datetimeAccessFormPaths = config.datetimeAccessFormPaths || [];
	
				// Any elements that match the paths listed here will be stored in JavaScript objects
				// as arrays even if there is only one of them. The path can be a plain string
				// (parent.child1.child2), a regex (/.*\.child2/) or function(elementName, elementPath).
				config.arrayAccessFormPaths = config.arrayAccessFormPaths || [];
	
	            // xmldom constructor arguments
	            // @see https://github.com/jindw/xmldom#api-reference
				config.xmldomOptions = config.xmldomOptions || {};
	
				// If true, a toString function is generated to print nodes containing text or cdata.
				// Useful if you want to accept both plain text and CData as equivalent inputs.
				if (config.enableToStringFunc === undefined) {
					config.enableToStringFunc = true;
				}
	
				// If true, empty text tags are ignored for elements with child nodes.
				if (config.skipEmptyTextNodesForObj === undefined) {
					config.skipEmptyTextNodesForObj = true;
				}
	
				// If true, whitespace is trimmed from text nodes.
				if (config.stripWhitespaces === undefined) {
					config.stripWhitespaces = true;
				}
	
				// If true, double quotes are used in generated XML.
				if (config.useDoubleQuotes === undefined) {
					config.useDoubleQuotes = true;
				}
	
				// If true, the root element of the XML document is ignored when converting to objects.
				// The result will directly have the root element's children as its own properties.
				if (config.ignoreRoot === undefined) {
					config.ignoreRoot = false;
				}
	
				// Whether XML characters in text are escaped when reading/writing XML.
				if (config.escapeMode === undefined) {
					config.escapeMode = true;
				}
	
				// Prefix to use for properties that are created to represent XML attributes.
				if (config.attributePrefix === undefined) {
					config.attributePrefix = "_";
				}
	
				// If true, empty elements will created as self closing elements (<element />)
				// If false, empty elements will be created with start and end tags (<element></element>)
				if (config.selfClosingElements === undefined) {
					config.selfClosingElements = true;
				}
	
				// If this property defined as false and an XML element has CData node ONLY, it will be converted to text without additional property "__cdata"
				if (config.keepCData === undefined) {
					config.keepCData = false;
				}
	
				// If this property defined as true, use { __text: 'abc' } over 'abc'
				if (config.keepText === undefined) {
					config.keepText = false;
				}
	
				// If true, will output dates in UTC
				if (config.jsDateUTC === undefined) {
					config.jsDateUTC = false;
				}
			}
	
			function initRequiredPolyfills() {
				function pad(number) {
					var r = String(number);
					if (r.length === 1) {
						r = '0' + r;
					}
					return r;
				}
				// Hello IE8-
				if (typeof String.prototype.trim !== 'function') {
					String.prototype.trim = function trim() {
						return this.replace(/^\s+|^\n+|(\s|\n)+$/g, '');
					};
				}
				if (typeof Date.prototype.toISOString !== 'function') {
					// Implementation from http://stackoverflow.com/questions/2573521/how-do-i-output-an-iso-8601-formatted-string-in-javascript
					Date.prototype.toISOString = function toISOString() {
						var MS_IN_S = 1000;
	
						return this.getUTCFullYear()
							+ '-' + pad(this.getUTCMonth() + 1)
							+ '-' + pad(this.getUTCDate())
							+ 'T' + pad(this.getUTCHours())
							+ ':' + pad(this.getUTCMinutes())
							+ ':' + pad(this.getUTCSeconds())
							+ '.' + String((this.getUTCMilliseconds() / MS_IN_S).toFixed(3)).slice(2, 5)
							+ 'Z';
					};
				}
			}
	
			initConfigDefaults();
			initRequiredPolyfills();
	
			var DOMNodeTypes = {
				"ELEMENT_NODE": 1,
				"TEXT_NODE": 3,
				"CDATA_SECTION_NODE": 4,
				"COMMENT_NODE": 8,
				"DOCUMENT_NODE": 9
			};
	
			function getDomNodeLocalName(domNode) {
				var localName = domNode.localName;
				if (localName == null) {
					// Yeah, this is IE!!
					localName = domNode.baseName;
				}
				if (localName == null || localName === "") {
					// ==="" is IE too
					localName = domNode.nodeName;
				}
				return localName;
			}
	
			function getDomNodeNamespacePrefix(node) {
				return node.prefix;
			}
	
			function escapeXmlChars(str) {
				if (typeof str === "string")
					return str.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;').replace(/'/g, '&#x27;');
				else
					return str;
			}
	
			function unescapeXmlChars(str) {
				return str.replace(/&lt;/g, '<').replace(/&gt;/g, '>').replace(/&quot;/g, '"').replace(/&#x27;/g, "'").replace(/&amp;/g, '&');
			}
	
			function ensureProperArrayAccessForm(element, childName, elementPath) {
				switch (config.arrayAccessForm) {
					case "property":
						if (!(element[childName] instanceof Array))
							element[childName + "_asArray"] = [element[childName]];
						else
							element[childName + "_asArray"] = element[childName];
						break;
				}
	
				if (!(element[childName] instanceof Array) && config.arrayAccessFormPaths.length > 0) {
					var match = false;
	
					for (var i = 0; i < config.arrayAccessFormPaths.length; i++) {
						var arrayPath = config.arrayAccessFormPaths[i];
						if (typeof arrayPath === "string") {
							if (arrayPath === elementPath) {
								match = true;
								break;
							}
						} else if (arrayPath instanceof RegExp) {
							if (arrayPath.test(elementPath)) {
								match = true;
								break;
							}
						} else if (typeof arrayPath === "function") {
							if (arrayPath(childName, elementPath)) {
								match = true;
								break;
							}
						}
					}
	
					if (match)
						element[childName] = [element[childName]];
				}
			}
	
			function xmlDateTimeToDate(prop) {
				// Implementation based up on http://stackoverflow.com/questions/8178598/xml-datetime-to-javascript-date-object
				// Improved to support full spec and optional parts
				var MINUTES_PER_HOUR = 60;
	
				var bits = prop.split(/[-T:+Z]/g);
	
				var d = new Date(bits[0], bits[1] - 1, bits[2]);
				var secondBits = bits[5].split("\.");
				d.setHours(bits[3], bits[4], secondBits[0]);
				if (secondBits.length > 1)
					d.setMilliseconds(secondBits[1]);
	
				// Get supplied time zone offset in minutes
				if (bits[6] && bits[7]) {
					var offsetMinutes = bits[6] * MINUTES_PER_HOUR + Number(bits[7]);
					var sign = /\d\d-\d\d:\d\d$/.test(prop) ? '-' : '+';
	
					// Apply the sign
					offsetMinutes = 0 + (sign === '-' ? -1 * offsetMinutes : offsetMinutes);
	
					// Apply offset and local timezone
					d.setMinutes(d.getMinutes() - offsetMinutes - d.getTimezoneOffset());
				} else if (prop.indexOf("Z", prop.length - 1) !== -1) {
					d = new Date(Date.UTC(d.getFullYear(), d.getMonth(), d.getDate(), d.getHours(), d.getMinutes(), d.getSeconds(), d.getMilliseconds()));
				}
	
				// d is now a local time equivalent to the supplied time
				return d;
			}
	
			function convertToDateIfRequired(value, childName, fullPath) {
				if (config.datetimeAccessFormPaths.length > 0) {
					var pathWithoutTextNode = fullPath.split("\.#")[0];
	
					for (var i = 0; i < config.datetimeAccessFormPaths.length; i++) {
						var candidatePath = config.datetimeAccessFormPaths[i];
						if (typeof candidatePath === "string") {
							if (candidatePath === pathWithoutTextNode)
								return xmlDateTimeToDate(value);
						} else if (candidatePath instanceof RegExp) {
							if (candidatePath.test(pathWithoutTextNode))
								return xmlDateTimeToDate(value);
						} else if (typeof candidatePath === "function") {
							if (candidatePath(pathWithoutTextNode))
								return xmlDateTimeToDate(value);
						}
					}
				}
	
				return value;
			}
	
			function deserializeRootElementChildren(rootElement) {
				var result = {};
				var children = rootElement.childNodes;
	
				// Alternative for firstElementChild which is not supported in some environments
				for (var i = 0; i < children.length; i++) {
					var child = children.item(i);
					if (child.nodeType === DOMNodeTypes.ELEMENT_NODE) {
						var childName = getDomNodeLocalName(child);
	
						if (config.ignoreRoot)
							result = deserializeDomChildren(child, childName);
						else
							result[childName] = deserializeDomChildren(child, childName);
					}
				}
	
				return result;
			}
	
			function deserializeElementChildren(element, elementPath) {
				var result = {};
				result.__cnt = 0;
	
				var nodeChildren = element.childNodes;
	
				// Child nodes.
				for (var iChild = 0; iChild < nodeChildren.length; iChild++) {
					var child = nodeChildren.item(iChild);
					var childName = getDomNodeLocalName(child);
	
					if (child.nodeType === DOMNodeTypes.COMMENT_NODE)
						continue;
	
					result.__cnt++;
	
					// We deliberately do not accept everything falsey here because
					// elements that resolve to empty string should still be preserved.
					if (result[childName] == null) {
						result[childName] = deserializeDomChildren(child, elementPath + "." + childName);
						ensureProperArrayAccessForm(result, childName, elementPath + "." + childName);
					} else {
						if (!(result[childName] instanceof Array)) {
							result[childName] = [result[childName]];
							ensureProperArrayAccessForm(result, childName, elementPath + "." + childName);
						}
	
						result[childName][result[childName].length] = deserializeDomChildren(child, elementPath + "." + childName);
					}
				}
	
				// Attributes
				for (var iAttribute = 0; iAttribute < element.attributes.length; iAttribute++) {
					var attribute = element.attributes.item(iAttribute);
					result.__cnt++;
	
					var adjustedValue = attribute.value;
					for (var iConverter = 0; iConverter < config.attributeConverters.length; iConverter++) {
						var converter = config.attributeConverters[iConverter];
						if (converter.test.call(null, attribute.name, attribute.value))
							adjustedValue = converter.convert.call(null, attribute.name, attribute.value);
					}
	
					result[config.attributePrefix + attribute.name] = adjustedValue;
				}
	
				// Node namespace prefix
				var namespacePrefix = getDomNodeNamespacePrefix(element);
				if (namespacePrefix) {
					result.__cnt++;
					result.__prefix = namespacePrefix;
				}
	
				if (result["#text"]) {
					result.__text = result["#text"];
	
					if (result.__text instanceof Array) {
						result.__text = result.__text.join("\n");
					}
	
					if (config.escapeMode)
						result.__text = unescapeXmlChars(result.__text);
	
					if (config.stripWhitespaces)
						result.__text = result.__text.trim();
	
					delete result["#text"];
	
					if (config.arrayAccessForm === "property")
						delete result["#text_asArray"];
	
					result.__text = convertToDateIfRequired(result.__text, "#text", elementPath + ".#text");
				}
	
				if (result.hasOwnProperty('#cdata-section')) {
					result.__cdata = result["#cdata-section"];
					delete result["#cdata-section"];
	
					if (config.arrayAccessForm === "property")
						delete result["#cdata-section_asArray"];
				}
	
				if (result.__cnt === 1 && result.__text && !config.keepText) {
					result = result.__text;
				} else if (result.__cnt === 0 && config.emptyNodeForm === "text") {
					result = '';
				} else if (result.__cnt > 1 && result.__text !== undefined && config.skipEmptyTextNodesForObj) {
					if (config.stripWhitespaces && result.__text === "" || result.__text.trim() === "") {
						delete result.__text;
					}
				}
				delete result.__cnt;
	
				/**
				 * We are checking if we are creating a __cdata property or if we just add the content of cdata inside result.
				 * But, if we have a property inside xml tag (<tag PROPERTY="1"></tag>), and a cdata inside, we can't ignore it.
				 * In this case we are keeping __cdata property.
				 */
				if (!config.keepCData && (!result.hasOwnProperty('__text') && result.hasOwnProperty('__cdata') && Object.keys(result).length === 1)) {
					return (result.__cdata ? result.__cdata : '');
				}
	
				if (config.enableToStringFunc && (result.__text || result.__cdata)) {
					result.toString = function toString() {
						return (this.__text ? this.__text : '') + (this.__cdata ? this.__cdata : '');
					};
				}
	
				return result;
			}
	
			function deserializeDomChildren(node, parentPath) {
				if (node.nodeType === DOMNodeTypes.DOCUMENT_NODE) {
					return deserializeRootElementChildren(node);
				} else if (node.nodeType === DOMNodeTypes.ELEMENT_NODE) {
					return deserializeElementChildren(node, parentPath);
				} else if (node.nodeType === DOMNodeTypes.TEXT_NODE || node.nodeType === DOMNodeTypes.CDATA_SECTION_NODE) {
					return node.nodeValue;
				} else {
					return null;
				}
			}
	
			function serializeStartTag(jsObject, elementName, attributeNames, selfClosing) {
				var resultStr = "<" + ((jsObject && jsObject.__prefix) ? (jsObject.__prefix + ":") : "") + elementName;
	
				if (attributeNames) {
					for (var i = 0; i < attributeNames.length; i++) {
						var attributeName = attributeNames[i];
						var attributeValue = jsObject[attributeName];
	
						if (config.escapeMode)
							attributeValue = escapeXmlChars(attributeValue);
	
						resultStr += " " + attributeName.substr(config.attributePrefix.length) + "=";
	
						if (config.useDoubleQuotes)
							resultStr += '"' + attributeValue + '"';
						else
							resultStr += "'" + attributeValue + "'";
					}
				}
	
				if (!selfClosing)
					resultStr += ">";
				else
					resultStr += " />";
	
				return resultStr;
			}
	
			function serializeEndTag(jsObject, elementName) {
				return "</" + ((jsObject && jsObject.__prefix) ? (jsObject.__prefix + ":") : "") + elementName + ">";
			}
	
			function endsWith(str, suffix) {
				return str.indexOf(suffix, str.length - suffix.length) !== -1;
			}
	
			function isSpecialProperty(jsonObj, propertyName) {
				if ((config.arrayAccessForm === "property" && endsWith(propertyName.toString(), ("_asArray")))
					|| propertyName.toString().indexOf(config.attributePrefix) === 0
					|| propertyName.toString().indexOf("__") === 0
					|| (jsonObj[propertyName] instanceof Function))
					return true;
				else
					return false;
			}
	
			function getDataElementCount(jsObject) {
				var count = 0;
	
				if (jsObject instanceof Object) {
					for (var propertyName in jsObject) {
						if (isSpecialProperty(jsObject, propertyName))
							continue;
	
						count++;
					}
				}
	
				return count;
			}
	
			function getDataAttributeNames(jsObject) {
				var names = [];
	
				if (jsObject instanceof Object) {
					for (var attributeName in jsObject) {
						if (attributeName.toString().indexOf("__") === -1
							&& attributeName.toString().indexOf(config.attributePrefix) === 0) {
							names.push(attributeName);
						}
					}
				}
	
				return names;
			}
	
			function serializeComplexTextNodeContents(textNode) {
				var result = "";
	
				if (textNode.__cdata) {
					result += "<![CDATA[" + textNode.__cdata + "]]>";
				}
	
				if (textNode.__text || typeof (textNode.__text) === 'number' || typeof (textNode.__text) === 'boolean') {
					if (config.escapeMode)
						result += escapeXmlChars(textNode.__text);
					else
						result += textNode.__text;
				}
	
				return result;
			}
	
			function serializeTextNodeContents(textNode) {
				var result = "";
	
				if (textNode instanceof Object) {
					result += serializeComplexTextNodeContents(textNode);
				} else if (textNode !== null) {
					if (config.escapeMode)
						result += escapeXmlChars(textNode);
					else
						result += textNode;
				}
	
				return result;
			}
	
			function serializeArray(elementArray, elementName, attributes) {
				var result = "";
	
				if (elementArray.length === 0) {
					result += serializeStartTag(elementArray, elementName, attributes, true);
				} else {
					for (var i = 0; i < elementArray.length; i++) {
						result += serializeJavaScriptObject(elementArray[i], elementName, getDataAttributeNames(elementArray[i]));
					}
				}
	
				return result;
			}
	
			function serializeJavaScriptObject(element, elementName, attributes) {
				var result = "";
	
				// Filter out elements
				if (config.jsAttributeFilter && config.jsAttributeFilter.call(null, elementName, element)) {
					return result;
				}
				// Convert element
				if (config.jsAttributeConverter) {
					element = config.jsAttributeConverter.call(null, elementName, element);
				}
				if ((element === undefined || element === null || element === '') && config.selfClosingElements) {
					result += serializeStartTag(element, elementName, attributes, true);
				} else if (typeof element === 'object') {
					if (Object.prototype.toString.call(element) === '[object Array]') {
						result += serializeArray(element, elementName, attributes);
					} else if (element instanceof Date) {
						result += serializeStartTag(element, elementName, attributes, false);
						// Serialize date
						result += config.jsDateUTC ? element.toUTCString() : element.toISOString();
						result += serializeEndTag(element, elementName);
					} else {
						var childElementCount = getDataElementCount(element);
						if (childElementCount > 0 || typeof (element.__text) === 'number' || typeof (element.__text) === 'boolean' || element.__text || element.__cdata) {
							result += serializeStartTag(element, elementName, attributes, false);
							result += serializeJavaScriptObjectChildren(element);
							result += serializeEndTag(element, elementName);
						} else if (config.selfClosingElements) {
							result += serializeStartTag(element, elementName, attributes, true);
						} else {
							result += serializeStartTag(element, elementName, attributes, false);
							result += serializeEndTag(element, elementName);
						}
					}
				} else {
					result += serializeStartTag(element, elementName, attributes, false);
					result += serializeTextNodeContents(element);
					result += serializeEndTag(element, elementName);
				}
	
				return result;
			}
	
			function serializeJavaScriptObjectChildren(jsObject) {
				var result = "";
	
				var elementCount = getDataElementCount(jsObject);
	
				if (elementCount > 0) {
					for (var elementName in jsObject) {
						if (isSpecialProperty(jsObject, elementName))
							continue;
	
						var element = jsObject[elementName];
						var attributes = getDataAttributeNames(element);
	
						result += serializeJavaScriptObject(element, elementName, attributes);
					}
				}
	
				result += serializeTextNodeContents(jsObject);
	
				return result;
			}
	
			function parseXml(xml) {
				if (xml === undefined) {
					return null;
				}
	
				if (typeof xml !== "string") {
					return null;
				}
	
				var parser = null;
				var domNode = null;
	
				if (CustomDOMParser) {
					// This branch is used for node.js, with the xmldom parser.
					parser = new CustomDOMParser(config.xmldomOptions);
	
					domNode = parser.parseFromString(xml, "text/xml");
				} else if (window && window.DOMParser) {
					parser = new window.DOMParser();
					var parsererrorNS = null;
	
					var isIEParser = window.ActiveXObject || "ActiveXObject" in window;
	
					// IE9+ now is here
					if (!isIEParser && document.all && !document.addEventListener) {
						try {
							parsererrorNS = parser.parseFromString("INVALID", "text/xml").childNodes[0].namespaceURI;
						} catch (err) {
							parsererrorNS = null;
						}
					}
	
					try {
						domNode = parser.parseFromString(xml, "text/xml");
						if (parsererrorNS !== null && domNode.getElementsByTagNameNS(parsererrorNS, "parsererror").length > 0) {
							domNode = null;
						}
					} catch (err) {
						domNode = null;
					}
				} else {
					// IE :(
					if (xml.indexOf("<?") === 0) {
						xml = xml.substr(xml.indexOf("?>") + 2);
					}
	
					/* global ActiveXObject */
					domNode = new ActiveXObject("Microsoft.XMLDOM");
					domNode.async = "false";
					domNode.loadXML(xml);
				}
	
				return domNode;
			}
	
			this.asArray = function asArray(prop) {
				if (prop === undefined || prop === null) {
					return [];
				} else if (prop instanceof Array) {
					return prop;
				} else {
					return [prop];
				}
			};
	
			this.toXmlDateTime = function toXmlDateTime(dt) {
				if (dt instanceof Date) {
					return dt.toISOString();
				} else if (typeof (dt) === 'number') {
					return new Date(dt).toISOString();
				} else {
					return null;
				}
			};
	
			this.asDateTime = function asDateTime(prop) {
				if (typeof (prop) === "string") {
					return xmlDateTimeToDate(prop);
				} else {
					return prop;
				}
			};
	
			/*
				Internally the logic works in a cycle:
				DOM->JS - implemented by custom logic (deserialization).
				JS->XML - implemented by custom logic (serialization).
				XML->DOM - implemented by browser.
			*/
	
			// Transformns an XML string into DOM-tree
			this.xml2dom = function xml2dom(xml) {
				return parseXml(xml);
			};
	
			// Transforms a DOM tree to JavaScript objects.
			this.dom2js = function dom2js(domNode) {
				return deserializeDomChildren(domNode, null);
			};
	
			// Transforms JavaScript objects to a DOM tree.
			this.js2dom = function js2dom(jsObject) {
				var xml = this.js2xml(jsObject);
				return parseXml(xml);
			};
	
			// Transformns an XML string into JavaScript objects.
			this.xml2js = function xml2js(xml) {
				var domNode = parseXml(xml);
				if (domNode != null)
					return this.dom2js(domNode);
				else
					return null;
			};
	
			// Transforms JavaScript objects into an XML string.
			this.js2xml = function js2xml(jsObject) {
				return serializeJavaScriptObjectChildren(jsObject);
			};
	
			this.getVersion = function getVersion() {
				return VERSION;
			};
		};
	});


/***/ },
/* 156 */
/***/ function(module, exports, __webpack_require__) {

	var setPrototypeOf = __webpack_require__(545);
	
	function _inheritsLoose(subClass, superClass) {
	  subClass.prototype = Object.create(superClass.prototype);
	  subClass.prototype.constructor = subClass;
	  setPrototypeOf(subClass, superClass);
	}
	
	module.exports = _inheritsLoose;
	module.exports["default"] = module.exports, module.exports.__esModule = true;

/***/ },
/* 157 */
/***/ function(module, exports) {

	function _objectWithoutPropertiesLoose(source, excluded) {
	  if (source == null) return {};
	  var target = {};
	  var sourceKeys = Object.keys(source);
	  var key, i;
	
	  for (i = 0; i < sourceKeys.length; i++) {
	    key = sourceKeys[i];
	    if (excluded.indexOf(key) >= 0) continue;
	    target[key] = source[key];
	  }
	
	  return target;
	}
	
	module.exports = _objectWithoutPropertiesLoose;
	module.exports["default"] = module.exports, module.exports.__esModule = true;

/***/ },
/* 158 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _createIconComponent = _interopRequireDefault(__webpack_require__(5));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	var IconCreditCardSolid = (0, _createIconComponent["default"])({
	  content: _react["default"].createElement("g", null, _react["default"].createElement("path", {
	    d: "M5.61 52.76a4.89 4.89 0 0 0 4.89 4.89h49a4.89 4.89 0 0 0 4.89-4.89V29.54H5.61zm39.77-5.63h11.14v3H45.38zm-14 0h11.11v3H31.35zM59.5 12.35h-49a4.89 4.89 0 0 0-4.89 4.89v3.89h58.78v-3.89a4.89 4.89 0 0 0-4.89-4.89z"
	  })),
	  height: undefined,
	  width: undefined
	});
	IconCreditCardSolid.displayName = 'IconCreditCardSolid';
	var _default = IconCreditCardSolid;
	exports["default"] = _default;

/***/ },
/* 159 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _createIconComponent = _interopRequireDefault(__webpack_require__(5));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	var IconDotMenu = (0, _createIconComponent["default"])({
	  content: _react["default"].createElement("g", null, _react["default"].createElement("circle", {
	    cx: "35",
	    cy: "35",
	    r: "5.99"
	  }), _react["default"].createElement("circle", {
	    cx: "35",
	    cy: "15.31",
	    r: "5.99"
	  }), _react["default"].createElement("circle", {
	    cx: "35",
	    cy: "54.69",
	    r: "5.99"
	  })),
	  height: undefined,
	  width: undefined
	});
	IconDotMenu.displayName = 'IconDotMenu';
	var _default = IconDotMenu;
	exports["default"] = _default;

/***/ },
/* 160 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _createIconComponent = _interopRequireDefault(__webpack_require__(5));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	var IconImport = (0, _createIconComponent["default"])({
	  content: _react["default"].createElement("g", null, _react["default"].createElement("path", {
	    d: "M53.27 19.67H42V25h8.59v31.2H19.42V25H28v-5.33H16.73A2.69 2.69 0 0 0 14 22.35v36.54a2.69 2.69 0 0 0 2.69 2.69h36.58A2.69 2.69 0 0 0 56 58.89V22.35a2.69 2.69 0 0 0-2.73-2.68z"
	  }), _react["default"].createElement("path", {
	    d: "M37.69 4.76a2.69 2.69 0 0 0-5.38 0v33.49L28 33.94l-1.66-1.66a2.69 2.69 0 1 0-3.8 3.8l5.65 5.65 4.9 4.9a2.46 2.46 0 0 0 .43.34 2.82 2.82 0 0 0 2.93 0 2.46 2.46 0 0 0 .43-.34l4.9-4.9 5.65-5.65a2.69 2.69 0 0 0-3.8-3.8L42 33.94l-4.3 4.3z"
	  })),
	  height: undefined,
	  width: undefined
	});
	IconImport.displayName = 'IconImport';
	var _default = IconImport;
	exports["default"] = _default;

/***/ },
/* 161 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _createIconComponent = _interopRequireDefault(__webpack_require__(5));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	var IconPencil = (0, _createIconComponent["default"])({
	  content: _react["default"].createElement("g", null, _react["default"].createElement("path", {
	    d: "M25.07 59.39H9.49V43.81l37.19-37.2 15.58 15.58zm-12.58-3h11.34L58 22.19 46.68 10.86 12.49 45z"
	  }), _react["default"].createElement("path", {
	    d: "M40.183 15.235l2.122-2.122L55.76 26.57l-2.122 2.12zM26.36 57.47h-3v-5.09h-6.75v-6.7h-5.37v-3h8.37v6.7h6.75v8.09z"
	  })),
	  height: undefined,
	  width: undefined
	});
	IconPencil.displayName = 'IconPencil';
	var _default = IconPencil;
	exports["default"] = _default;

/***/ },
/* 162 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(611);


/***/ },
/* 163 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Buffer) {module.exports = xor;
	function xor(a, b) {
	  var len = Math.min(a.length, b.length);
	  var out = new Buffer(len);
	  var i = -1;
	  while (++i < len) {
	    out.writeUInt8(a[i] ^ b[i], i);
	  }
	  return out;
	}
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(31).Buffer))

/***/ },
/* 164 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.routerActions = exports.goForward = exports.goBack = exports.go = exports.replace = exports.push = exports.CALL_HISTORY_METHOD = exports.onLocationChanged = exports.LOCATION_CHANGE = void 0;
	
	/**
	 * This action type will be dispatched when your history
	 * receives a location change.
	 */
	var LOCATION_CHANGE = '@@router/LOCATION_CHANGE';
	exports.LOCATION_CHANGE = LOCATION_CHANGE;
	
	var onLocationChanged = function onLocationChanged(location, action) {
	  var isFirstRendering = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
	  return {
	    type: LOCATION_CHANGE,
	    payload: {
	      location: location,
	      action: action,
	      isFirstRendering: isFirstRendering
	    }
	  };
	};
	/**
	 * This action type will be dispatched by the history actions below.
	 * If you're writing a middleware to watch for navigation events, be sure to
	 * look for actions of this type.
	 */
	
	
	exports.onLocationChanged = onLocationChanged;
	var CALL_HISTORY_METHOD = '@@router/CALL_HISTORY_METHOD';
	exports.CALL_HISTORY_METHOD = CALL_HISTORY_METHOD;
	
	var updateLocation = function updateLocation(method) {
	  return function () {
	    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return {
	      type: CALL_HISTORY_METHOD,
	      payload: {
	        method: method,
	        args: args
	      }
	    };
	  };
	};
	/**
	 * These actions correspond to the history API.
	 * The associated routerMiddleware will capture these events before they get to
	 * your reducer and reissue them as the matching function on your history.
	 */
	
	
	var push = updateLocation('push');
	exports.push = push;
	var replace = updateLocation('replace');
	exports.replace = replace;
	var go = updateLocation('go');
	exports.go = go;
	var goBack = updateLocation('goBack');
	exports.goBack = goBack;
	var goForward = updateLocation('goForward');
	exports.goForward = goForward;
	var routerActions = {
	  push: push,
	  replace: replace,
	  go: go,
	  goBack: goBack,
	  goForward: goForward
	};
	exports.routerActions = routerActions;

/***/ },
/* 165 */
/***/ function(module, exports, __webpack_require__) {

	// false -> Array#indexOf
	// true  -> Array#includes
	var toIObject = __webpack_require__(49);
	var toLength = __webpack_require__(27);
	var toAbsoluteIndex = __webpack_require__(95);
	module.exports = function (IS_INCLUDES) {
	  return function ($this, el, fromIndex) {
	    var O = toIObject($this);
	    var length = toLength(O.length);
	    var index = toAbsoluteIndex(fromIndex, length);
	    var value;
	    // Array#includes uses SameValueZero equality algorithm
	    // eslint-disable-next-line no-self-compare
	    if (IS_INCLUDES && el != el) while (length > index) {
	      value = O[index++];
	      // eslint-disable-next-line no-self-compare
	      if (value != value) return true;
	    // Array#indexOf ignores holes, Array#includes - not
	    } else for (;length > index; index++) if (IS_INCLUDES || index in O) {
	      if (O[index] === el) return IS_INCLUDES || index || 0;
	    } return !IS_INCLUDES && -1;
	  };
	};


/***/ },
/* 166 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var global = __webpack_require__(17);
	var $export = __webpack_require__(4);
	var redefine = __webpack_require__(41);
	var redefineAll = __webpack_require__(93);
	var meta = __webpack_require__(83);
	var forOf = __webpack_require__(88);
	var anInstance = __webpack_require__(87);
	var isObject = __webpack_require__(23);
	var fails = __webpack_require__(21);
	var $iterDetect = __webpack_require__(170);
	var setToStringTag = __webpack_require__(109);
	var inheritIfRequired = __webpack_require__(241);
	
	module.exports = function (NAME, wrapper, methods, common, IS_MAP, IS_WEAK) {
	  var Base = global[NAME];
	  var C = Base;
	  var ADDER = IS_MAP ? 'set' : 'add';
	  var proto = C && C.prototype;
	  var O = {};
	  var fixMethod = function (KEY) {
	    var fn = proto[KEY];
	    redefine(proto, KEY,
	      KEY == 'delete' ? function (a) {
	        return IS_WEAK && !isObject(a) ? false : fn.call(this, a === 0 ? 0 : a);
	      } : KEY == 'has' ? function has(a) {
	        return IS_WEAK && !isObject(a) ? false : fn.call(this, a === 0 ? 0 : a);
	      } : KEY == 'get' ? function get(a) {
	        return IS_WEAK && !isObject(a) ? undefined : fn.call(this, a === 0 ? 0 : a);
	      } : KEY == 'add' ? function add(a) { fn.call(this, a === 0 ? 0 : a); return this; }
	        : function set(a, b) { fn.call(this, a === 0 ? 0 : a, b); return this; }
	    );
	  };
	  if (typeof C != 'function' || !(IS_WEAK || proto.forEach && !fails(function () {
	    new C().entries().next();
	  }))) {
	    // create collection constructor
	    C = common.getConstructor(wrapper, NAME, IS_MAP, ADDER);
	    redefineAll(C.prototype, methods);
	    meta.NEED = true;
	  } else {
	    var instance = new C();
	    // early implementations not supports chaining
	    var HASNT_CHAINING = instance[ADDER](IS_WEAK ? {} : -0, 1) != instance;
	    // V8 ~  Chromium 40- weak-collections throws on primitives, but should return false
	    var THROWS_ON_PRIMITIVES = fails(function () { instance.has(1); });
	    // most early implementations doesn't supports iterables, most modern - not close it correctly
	    var ACCEPT_ITERABLES = $iterDetect(function (iter) { new C(iter); }); // eslint-disable-line no-new
	    // for early implementations -0 and +0 not the same
	    var BUGGY_ZERO = !IS_WEAK && fails(function () {
	      // V8 ~ Chromium 42- fails only with 5+ elements
	      var $instance = new C();
	      var index = 5;
	      while (index--) $instance[ADDER](index, index);
	      return !$instance.has(-0);
	    });
	    if (!ACCEPT_ITERABLES) {
	      C = wrapper(function (target, iterable) {
	        anInstance(target, C, NAME);
	        var that = inheritIfRequired(new Base(), target, C);
	        if (iterable != undefined) forOf(iterable, IS_MAP, that[ADDER], that);
	        return that;
	      });
	      C.prototype = proto;
	      proto.constructor = C;
	    }
	    if (THROWS_ON_PRIMITIVES || BUGGY_ZERO) {
	      fixMethod('delete');
	      fixMethod('has');
	      IS_MAP && fixMethod('get');
	    }
	    if (BUGGY_ZERO || HASNT_CHAINING) fixMethod(ADDER);
	    // weak collections should not contains .clear method
	    if (IS_WEAK && proto.clear) delete proto.clear;
	  }
	
	  setToStringTag(C, NAME);
	
	  O[NAME] = C;
	  $export($export.G + $export.W + $export.F * (C != Base), O);
	
	  if (!IS_WEAK) common.setStrong(C, NAME, IS_MAP);
	
	  return C;
	};


/***/ },
/* 167 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	__webpack_require__(384);
	var redefine = __webpack_require__(41);
	var hide = __webpack_require__(40);
	var fails = __webpack_require__(21);
	var defined = __webpack_require__(62);
	var wks = __webpack_require__(26);
	var regexpExec = __webpack_require__(249);
	
	var SPECIES = wks('species');
	
	var REPLACE_SUPPORTS_NAMED_GROUPS = !fails(function () {
	  // #replace needs built-in support for named groups.
	  // #match works fine because it just return the exec results, even if it has
	  // a "grops" property.
	  var re = /./;
	  re.exec = function () {
	    var result = [];
	    result.groups = { a: '7' };
	    return result;
	  };
	  return ''.replace(re, '$<a>') !== '7';
	});
	
	var SPLIT_WORKS_WITH_OVERWRITTEN_EXEC = (function () {
	  // Chrome 51 has a buggy "split" implementation when RegExp#exec !== nativeExec
	  var re = /(?:)/;
	  var originalExec = re.exec;
	  re.exec = function () { return originalExec.apply(this, arguments); };
	  var result = 'ab'.split(re);
	  return result.length === 2 && result[0] === 'a' && result[1] === 'b';
	})();
	
	module.exports = function (KEY, length, exec) {
	  var SYMBOL = wks(KEY);
	
	  var DELEGATES_TO_SYMBOL = !fails(function () {
	    // String methods call symbol-named RegEp methods
	    var O = {};
	    O[SYMBOL] = function () { return 7; };
	    return ''[KEY](O) != 7;
	  });
	
	  var DELEGATES_TO_EXEC = DELEGATES_TO_SYMBOL ? !fails(function () {
	    // Symbol-named RegExp methods call .exec
	    var execCalled = false;
	    var re = /a/;
	    re.exec = function () { execCalled = true; return null; };
	    if (KEY === 'split') {
	      // RegExp[@@split] doesn't call the regex's exec method, but first creates
	      // a new one. We need to return the patched regex when creating the new one.
	      re.constructor = {};
	      re.constructor[SPECIES] = function () { return re; };
	    }
	    re[SYMBOL]('');
	    return !execCalled;
	  }) : undefined;
	
	  if (
	    !DELEGATES_TO_SYMBOL ||
	    !DELEGATES_TO_EXEC ||
	    (KEY === 'replace' && !REPLACE_SUPPORTS_NAMED_GROUPS) ||
	    (KEY === 'split' && !SPLIT_WORKS_WITH_OVERWRITTEN_EXEC)
	  ) {
	    var nativeRegExpMethod = /./[SYMBOL];
	    var fns = exec(
	      defined,
	      SYMBOL,
	      ''[KEY],
	      function maybeCallNative(nativeMethod, regexp, str, arg2, forceStringMethod) {
	        if (regexp.exec === regexpExec) {
	          if (DELEGATES_TO_SYMBOL && !forceStringMethod) {
	            // The native String method already delegates to @@method (this
	            // polyfilled function), leasing to infinite recursion.
	            // We avoid it by directly calling the native @@method method.
	            return { done: true, value: nativeRegExpMethod.call(regexp, str, arg2) };
	          }
	          return { done: true, value: nativeMethod.call(str, regexp, arg2) };
	        }
	        return { done: false };
	      }
	    );
	    var strfn = fns[0];
	    var rxfn = fns[1];
	
	    redefine(String.prototype, KEY, strfn);
	    hide(RegExp.prototype, SYMBOL, length == 2
	      // 21.2.5.8 RegExp.prototype[@@replace](string, replaceValue)
	      // 21.2.5.11 RegExp.prototype[@@split](string, limit)
	      ? function (string, arg) { return rxfn.call(string, this, arg); }
	      // 21.2.5.6 RegExp.prototype[@@match](string)
	      // 21.2.5.9 RegExp.prototype[@@search](string)
	      : function (string) { return rxfn.call(string, this); }
	    );
	  }
	};


/***/ },
/* 168 */
/***/ function(module, exports, __webpack_require__) {

	// 7.2.2 IsArray(argument)
	var cof = __webpack_require__(53);
	module.exports = Array.isArray || function isArray(arg) {
	  return cof(arg) == 'Array';
	};


/***/ },
/* 169 */
/***/ function(module, exports, __webpack_require__) {

	// 7.2.8 IsRegExp(argument)
	var isObject = __webpack_require__(23);
	var cof = __webpack_require__(53);
	var MATCH = __webpack_require__(26)('match');
	module.exports = function (it) {
	  var isRegExp;
	  return isObject(it) && ((isRegExp = it[MATCH]) !== undefined ? !!isRegExp : cof(it) == 'RegExp');
	};


/***/ },
/* 170 */
/***/ function(module, exports, __webpack_require__) {

	var ITERATOR = __webpack_require__(26)('iterator');
	var SAFE_CLOSING = false;
	
	try {
	  var riter = [7][ITERATOR]();
	  riter['return'] = function () { SAFE_CLOSING = true; };
	  // eslint-disable-next-line no-throw-literal
	  Array.from(riter, function () { throw 2; });
	} catch (e) { /* empty */ }
	
	module.exports = function (exec, skipClosing) {
	  if (!skipClosing && !SAFE_CLOSING) return false;
	  var safe = false;
	  try {
	    var arr = [7];
	    var iter = arr[ITERATOR]();
	    iter.next = function () { return { done: safe = true }; };
	    arr[ITERATOR] = function () { return iter; };
	    exec(arr);
	  } catch (e) { /* empty */ }
	  return safe;
	};


/***/ },
/* 171 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// Forced replacement prototype accessors methods
	module.exports = __webpack_require__(82) || !__webpack_require__(21)(function () {
	  var K = Math.random();
	  // In FF throws only define methods
	  // eslint-disable-next-line no-undef, no-useless-call
	  __defineSetter__.call(null, K, function () { /* empty */ });
	  delete __webpack_require__(17)[K];
	});


/***/ },
/* 172 */
/***/ function(module, exports) {

	exports.f = Object.getOwnPropertySymbols;


/***/ },
/* 173 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var classof = __webpack_require__(107);
	var builtinExec = RegExp.prototype.exec;
	
	 // `RegExpExec` abstract operation
	// https://tc39.github.io/ecma262/#sec-regexpexec
	module.exports = function (R, S) {
	  var exec = R.exec;
	  if (typeof exec === 'function') {
	    var result = exec.call(R, S);
	    if (typeof result !== 'object') {
	      throw new TypeError('RegExp exec method returned something other than an Object or null');
	    }
	    return result;
	  }
	  if (classof(R) !== 'RegExp') {
	    throw new TypeError('RegExp#exec called on incompatible receiver');
	  }
	  return builtinExec.call(R, S);
	};


/***/ },
/* 174 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// https://tc39.github.io/proposal-setmap-offrom/
	var $export = __webpack_require__(4);
	var aFunction = __webpack_require__(39);
	var ctx = __webpack_require__(55);
	var forOf = __webpack_require__(88);
	
	module.exports = function (COLLECTION) {
	  $export($export.S, COLLECTION, { from: function from(source /* , mapFn, thisArg */) {
	    var mapFn = arguments[1];
	    var mapping, A, n, cb;
	    aFunction(this);
	    mapping = mapFn !== undefined;
	    if (mapping) aFunction(mapFn);
	    if (source == undefined) return new this();
	    A = [];
	    if (mapping) {
	      n = 0;
	      cb = ctx(mapFn, arguments[2], 2);
	      forOf(source, false, function (nextItem) {
	        A.push(cb(nextItem, n++));
	      });
	    } else {
	      forOf(source, false, A.push, A);
	    }
	    return new this(A);
	  } });
	};


/***/ },
/* 175 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// https://tc39.github.io/proposal-setmap-offrom/
	var $export = __webpack_require__(4);
	
	module.exports = function (COLLECTION) {
	  $export($export.S, COLLECTION, { of: function of() {
	    var length = arguments.length;
	    var A = new Array(length);
	    while (length--) A[length] = arguments[length];
	    return new this(A);
	  } });
	};


/***/ },
/* 176 */
/***/ function(module, exports, __webpack_require__) {

	var toInteger = __webpack_require__(57);
	var defined = __webpack_require__(62);
	// true  -> String#at
	// false -> String#codePointAt
	module.exports = function (TO_STRING) {
	  return function (that, pos) {
	    var s = String(defined(that));
	    var i = toInteger(pos);
	    var l = s.length;
	    var a, b;
	    if (i < 0 || i >= l) return TO_STRING ? '' : undefined;
	    a = s.charCodeAt(i);
	    return a < 0xd800 || a > 0xdbff || i + 1 === l || (b = s.charCodeAt(i + 1)) < 0xdc00 || b > 0xdfff
	      ? TO_STRING ? s.charAt(i) : a
	      : TO_STRING ? s.slice(i, i + 2) : (a - 0xd800 << 10) + (b - 0xdc00) + 0x10000;
	  };
	};


/***/ },
/* 177 */
/***/ function(module, exports, __webpack_require__) {

	var global = __webpack_require__(17);
	var hide = __webpack_require__(40);
	var uid = __webpack_require__(96);
	var TYPED = uid('typed_array');
	var VIEW = uid('view');
	var ABV = !!(global.ArrayBuffer && global.DataView);
	var CONSTR = ABV;
	var i = 0;
	var l = 9;
	var Typed;
	
	var TypedArrayConstructors = (
	  'Int8Array,Uint8Array,Uint8ClampedArray,Int16Array,Uint16Array,Int32Array,Uint32Array,Float32Array,Float64Array'
	).split(',');
	
	while (i < l) {
	  if (Typed = global[TypedArrayConstructors[i++]]) {
	    hide(Typed.prototype, TYPED, true);
	    hide(Typed.prototype, VIEW, true);
	  } else CONSTR = false;
	}
	
	module.exports = {
	  ABV: ABV,
	  CONSTR: CONSTR,
	  TYPED: TYPED,
	  VIEW: VIEW
	};


/***/ },
/* 178 */
/***/ function(module, exports, __webpack_require__) {

	var global = __webpack_require__(17);
	var navigator = global.navigator;
	
	module.exports = navigator && navigator.userAgent || '';


/***/ },
/* 179 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = startOfUTCISOWeek;
	
	var _index = _interopRequireDefault(__webpack_require__(3));
	
	var _index2 = _interopRequireDefault(__webpack_require__(2));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// This function will be a part of public API when UTC function will be implemented.
	// See issue: https://github.com/date-fns/date-fns/issues/376
	function startOfUTCISOWeek(dirtyDate) {
	  (0, _index2.default)(1, arguments);
	  var weekStartsOn = 1;
	  var date = (0, _index.default)(dirtyDate);
	  var day = date.getUTCDay();
	  var diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;
	  date.setUTCDate(date.getUTCDate() - diff);
	  date.setUTCHours(0, 0, 0, 0);
	  return date;
	}
	
	module.exports = exports.default;

/***/ },
/* 180 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = startOfUTCWeek;
	
	var _index = _interopRequireDefault(__webpack_require__(9));
	
	var _index2 = _interopRequireDefault(__webpack_require__(3));
	
	var _index3 = _interopRequireDefault(__webpack_require__(2));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// This function will be a part of public API when UTC function will be implemented.
	// See issue: https://github.com/date-fns/date-fns/issues/376
	function startOfUTCWeek(dirtyDate, dirtyOptions) {
	  (0, _index3.default)(1, arguments);
	  var options = dirtyOptions || {};
	  var locale = options.locale;
	  var localeWeekStartsOn = locale && locale.options && locale.options.weekStartsOn;
	  var defaultWeekStartsOn = localeWeekStartsOn == null ? 0 : (0, _index.default)(localeWeekStartsOn);
	  var weekStartsOn = options.weekStartsOn == null ? defaultWeekStartsOn : (0, _index.default)(options.weekStartsOn); // Test if weekStartsOn is between 0 and 6 _and_ is not NaN
	
	  if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) {
	    throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
	  }
	
	  var date = (0, _index2.default)(dirtyDate);
	  var day = date.getUTCDay();
	  var diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;
	  date.setUTCDate(date.getUTCDate() - diff);
	  date.setUTCHours(0, 0, 0, 0);
	  return date;
	}
	
	module.exports = exports.default;

/***/ },
/* 181 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = addHours;
	
	var _index = _interopRequireDefault(__webpack_require__(9));
	
	var _index2 = _interopRequireDefault(__webpack_require__(137));
	
	var _index3 = _interopRequireDefault(__webpack_require__(2));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MILLISECONDS_IN_HOUR = 3600000;
	/**
	 * @name addHours
	 * @category Hour Helpers
	 * @summary Add the specified number of hours to the given date.
	 *
	 * @description
	 * Add the specified number of hours to the given date.
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} date - the date to be changed
	 * @param {Number} amount - the amount of hours to be added. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
	 * @returns {Date} the new date with the hours added
	 * @throws {TypeError} 2 arguments required
	 *
	 * @example
	 * // Add 2 hours to 10 July 2014 23:00:00:
	 * var result = addHours(new Date(2014, 6, 10, 23, 0), 2)
	 * //=> Fri Jul 11 2014 01:00:00
	 */
	
	function addHours(dirtyDate, dirtyAmount) {
	  (0, _index3.default)(2, arguments);
	  var amount = (0, _index.default)(dirtyAmount);
	  return (0, _index2.default)(dirtyDate, amount * MILLISECONDS_IN_HOUR);
	}
	
	module.exports = exports.default;

/***/ },
/* 182 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = differenceInMilliseconds;
	
	var _index = _interopRequireDefault(__webpack_require__(3));
	
	var _index2 = _interopRequireDefault(__webpack_require__(2));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name differenceInMilliseconds
	 * @category Millisecond Helpers
	 * @summary Get the number of milliseconds between the given dates.
	 *
	 * @description
	 * Get the number of milliseconds between the given dates.
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} dateLeft - the later date
	 * @param {Date|Number} dateRight - the earlier date
	 * @returns {Number} the number of milliseconds
	 * @throws {TypeError} 2 arguments required
	 *
	 * @example
	 * // How many milliseconds are between
	 * // 2 July 2014 12:30:20.600 and 2 July 2014 12:30:21.700?
	 * var result = differenceInMilliseconds(
	 *   new Date(2014, 6, 2, 12, 30, 21, 700),
	 *   new Date(2014, 6, 2, 12, 30, 20, 600)
	 * )
	 * //=> 1100
	 */
	function differenceInMilliseconds(dirtyDateLeft, dirtyDateRight) {
	  (0, _index2.default)(2, arguments);
	  var dateLeft = (0, _index.default)(dirtyDateLeft);
	  var dateRight = (0, _index.default)(dirtyDateRight);
	  return dateLeft.getTime() - dateRight.getTime();
	}
	
	module.exports = exports.default;

/***/ },
/* 183 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = differenceInSeconds;
	
	var _index = _interopRequireDefault(__webpack_require__(182));
	
	var _index2 = _interopRequireDefault(__webpack_require__(2));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name differenceInSeconds
	 * @category Second Helpers
	 * @summary Get the number of seconds between the given dates.
	 *
	 * @description
	 * Get the number of seconds between the given dates.
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} dateLeft - the later date
	 * @param {Date|Number} dateRight - the earlier date
	 * @returns {Number} the number of seconds
	 * @throws {TypeError} 2 arguments required
	 *
	 * @example
	 * // How many seconds are between
	 * // 2 July 2014 12:30:07.999 and 2 July 2014 12:30:20.000?
	 * var result = differenceInSeconds(
	 *   new Date(2014, 6, 2, 12, 30, 20, 0),
	 *   new Date(2014, 6, 2, 12, 30, 7, 999)
	 * )
	 * //=> 12
	 */
	function differenceInSeconds(dirtyDateLeft, dirtyDateRight) {
	  (0, _index2.default)(2, arguments);
	  var diff = (0, _index.default)(dirtyDateLeft, dirtyDateRight) / 1000;
	  return diff > 0 ? Math.floor(diff) : Math.ceil(diff);
	}
	
	module.exports = exports.default;

/***/ },
/* 184 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = endOfDay;
	
	var _index = _interopRequireDefault(__webpack_require__(3));
	
	var _index2 = _interopRequireDefault(__webpack_require__(2));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name endOfDay
	 * @category Day Helpers
	 * @summary Return the end of a day for the given date.
	 *
	 * @description
	 * Return the end of a day for the given date.
	 * The result will be in the local timezone.
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} date - the original date
	 * @returns {Date} the end of a day
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // The end of a day for 2 September 2014 11:55:00:
	 * var result = endOfDay(new Date(2014, 8, 2, 11, 55, 0))
	 * //=> Tue Sep 02 2014 23:59:59.999
	 */
	function endOfDay(dirtyDate) {
	  (0, _index2.default)(1, arguments);
	  var date = (0, _index.default)(dirtyDate);
	  date.setHours(23, 59, 59, 999);
	  return date;
	}
	
	module.exports = exports.default;

/***/ },
/* 185 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = endOfMonth;
	
	var _index = _interopRequireDefault(__webpack_require__(3));
	
	var _index2 = _interopRequireDefault(__webpack_require__(2));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name endOfMonth
	 * @category Month Helpers
	 * @summary Return the end of a month for the given date.
	 *
	 * @description
	 * Return the end of a month for the given date.
	 * The result will be in the local timezone.
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} date - the original date
	 * @returns {Date} the end of a month
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // The end of a month for 2 September 2014 11:55:00:
	 * var result = endOfMonth(new Date(2014, 8, 2, 11, 55, 0))
	 * //=> Tue Sep 30 2014 23:59:59.999
	 */
	function endOfMonth(dirtyDate) {
	  (0, _index2.default)(1, arguments);
	  var date = (0, _index.default)(dirtyDate);
	  var month = date.getMonth();
	  date.setFullYear(date.getFullYear(), month + 1, 0);
	  date.setHours(23, 59, 59, 999);
	  return date;
	}
	
	module.exports = exports.default;

/***/ },
/* 186 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isAfter;
	
	var _index = _interopRequireDefault(__webpack_require__(3));
	
	var _index2 = _interopRequireDefault(__webpack_require__(2));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name isAfter
	 * @category Common Helpers
	 * @summary Is the first date after the second one?
	 *
	 * @description
	 * Is the first date after the second one?
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} date - the date that should be after the other one to return true
	 * @param {Date|Number} dateToCompare - the date to compare with
	 * @returns {Boolean} the first date is after the second date
	 * @throws {TypeError} 2 arguments required
	 *
	 * @example
	 * // Is 10 July 1989 after 11 February 1987?
	 * var result = isAfter(new Date(1989, 6, 10), new Date(1987, 1, 11))
	 * //=> true
	 */
	function isAfter(dirtyDate, dirtyDateToCompare) {
	  (0, _index2.default)(2, arguments);
	  var date = (0, _index.default)(dirtyDate);
	  var dateToCompare = (0, _index.default)(dirtyDateToCompare);
	  return date.getTime() > dateToCompare.getTime();
	}
	
	module.exports = exports.default;

/***/ },
/* 187 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isBefore;
	
	var _index = _interopRequireDefault(__webpack_require__(3));
	
	var _index2 = _interopRequireDefault(__webpack_require__(2));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name isBefore
	 * @category Common Helpers
	 * @summary Is the first date before the second one?
	 *
	 * @description
	 * Is the first date before the second one?
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} date - the date that should be before the other one to return true
	 * @param {Date|Number} dateToCompare - the date to compare with
	 * @returns {Boolean} the first date is before the second date
	 * @throws {TypeError} 2 arguments required
	 *
	 * @example
	 * // Is 10 July 1989 before 11 February 1987?
	 * var result = isBefore(new Date(1989, 6, 10), new Date(1987, 1, 11))
	 * //=> false
	 */
	function isBefore(dirtyDate, dirtyDateToCompare) {
	  (0, _index2.default)(2, arguments);
	  var date = (0, _index.default)(dirtyDate);
	  var dateToCompare = (0, _index.default)(dirtyDateToCompare);
	  return date.getTime() < dateToCompare.getTime();
	}
	
	module.exports = exports.default;

/***/ },
/* 188 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isWeekend;
	
	var _index = _interopRequireDefault(__webpack_require__(3));
	
	var _index2 = _interopRequireDefault(__webpack_require__(2));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name isWeekend
	 * @category Weekday Helpers
	 * @summary Does the given date fall on a weekend?
	 *
	 * @description
	 * Does the given date fall on a weekend?
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} date - the date to check
	 * @returns {Boolean} the date falls on a weekend
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // Does 5 October 2014 fall on a weekend?
	 * var result = isWeekend(new Date(2014, 9, 5))
	 * //=> true
	 */
	function isWeekend(dirtyDate) {
	  (0, _index2.default)(1, arguments);
	  var date = (0, _index.default)(dirtyDate);
	  var day = date.getDay();
	  return day === 0 || day === 6;
	}
	
	module.exports = exports.default;

/***/ },
/* 189 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = setMonth;
	
	var _index = _interopRequireDefault(__webpack_require__(9));
	
	var _index2 = _interopRequireDefault(__webpack_require__(3));
	
	var _index3 = _interopRequireDefault(__webpack_require__(408));
	
	var _index4 = _interopRequireDefault(__webpack_require__(2));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name setMonth
	 * @category Month Helpers
	 * @summary Set the month to the given date.
	 *
	 * @description
	 * Set the month to the given date.
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} date - the date to be changed
	 * @param {Number} month - the month of the new date
	 * @returns {Date} the new date with the month set
	 * @throws {TypeError} 2 arguments required
	 *
	 * @example
	 * // Set February to 1 September 2014:
	 * var result = setMonth(new Date(2014, 8, 1), 1)
	 * //=> Sat Feb 01 2014 00:00:00
	 */
	function setMonth(dirtyDate, dirtyMonth) {
	  (0, _index4.default)(2, arguments);
	  var date = (0, _index2.default)(dirtyDate);
	  var month = (0, _index.default)(dirtyMonth);
	  var year = date.getFullYear();
	  var day = date.getDate();
	  var dateWithDesiredMonth = new Date(0);
	  dateWithDesiredMonth.setFullYear(year, month, 15);
	  dateWithDesiredMonth.setHours(0, 0, 0, 0);
	  var daysInMonth = (0, _index3.default)(dateWithDesiredMonth); // Set the last day of the new month
	  // if the original date was the last day of the longer month
	
	  date.setMonth(month, Math.min(day, daysInMonth));
	  return date;
	}
	
	module.exports = exports.default;

/***/ },
/* 190 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = startOfQuarter;
	
	var _index = _interopRequireDefault(__webpack_require__(3));
	
	var _index2 = _interopRequireDefault(__webpack_require__(2));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name startOfQuarter
	 * @category Quarter Helpers
	 * @summary Return the start of a year quarter for the given date.
	 *
	 * @description
	 * Return the start of a year quarter for the given date.
	 * The result will be in the local timezone.
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} date - the original date
	 * @returns {Date} the start of a quarter
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // The start of a quarter for 2 September 2014 11:55:00:
	 * var result = startOfQuarter(new Date(2014, 8, 2, 11, 55, 0))
	 * //=> Tue Jul 01 2014 00:00:00
	 */
	function startOfQuarter(dirtyDate) {
	  (0, _index2.default)(1, arguments);
	  var date = (0, _index.default)(dirtyDate);
	  var currentMonth = date.getMonth();
	  var month = currentMonth - currentMonth % 3;
	  date.setMonth(month, 1);
	  date.setHours(0, 0, 0, 0);
	  return date;
	}
	
	module.exports = exports.default;

/***/ },
/* 191 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = startOfYear;
	
	var _index = _interopRequireDefault(__webpack_require__(3));
	
	var _index2 = _interopRequireDefault(__webpack_require__(2));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name startOfYear
	 * @category Year Helpers
	 * @summary Return the start of a year for the given date.
	 *
	 * @description
	 * Return the start of a year for the given date.
	 * The result will be in the local timezone.
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} date - the original date
	 * @returns {Date} the start of a year
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // The start of a year for 2 September 2014 11:55:00:
	 * var result = startOfYear(new Date(2014, 8, 2, 11, 55, 00))
	 * //=> Wed Jan 01 2014 00:00:00
	 */
	function startOfYear(dirtyDate) {
	  (0, _index2.default)(1, arguments);
	  var cleanDate = (0, _index.default)(dirtyDate);
	  var date = new Date(0);
	  date.setFullYear(cleanDate.getFullYear(), 0, 1);
	  date.setHours(0, 0, 0, 0);
	  return date;
	}
	
	module.exports = exports.default;

/***/ },
/* 192 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = subDays;
	
	var _index = _interopRequireDefault(__webpack_require__(9));
	
	var _index2 = _interopRequireDefault(__webpack_require__(74));
	
	var _index3 = _interopRequireDefault(__webpack_require__(2));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name subDays
	 * @category Day Helpers
	 * @summary Subtract the specified number of days from the given date.
	 *
	 * @description
	 * Subtract the specified number of days from the given date.
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} date - the date to be changed
	 * @param {Number} amount - the amount of days to be subtracted. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
	 * @returns {Date} the new date with the days subtracted
	 * @throws {TypeError} 2 arguments required
	 *
	 * @example
	 * // Subtract 10 days from 1 September 2014:
	 * var result = subDays(new Date(2014, 8, 1), 10)
	 * //=> Fri Aug 22 2014 00:00:00
	 */
	function subDays(dirtyDate, dirtyAmount) {
	  (0, _index3.default)(2, arguments);
	  var amount = (0, _index.default)(dirtyAmount);
	  return (0, _index2.default)(dirtyDate, -amount);
	}
	
	module.exports = exports.default;

/***/ },
/* 193 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var React = __webpack_require__(1);
	var createFocusTrap = __webpack_require__(1037);
	
	var checkedProps = ['active', 'paused', 'tag', 'focusTrapOptions', '_createFocusTrap'];
	
	var FocusTrap = function (_React$Component) {
	  _inherits(FocusTrap, _React$Component);
	
	  function FocusTrap(props) {
	    _classCallCheck(this, FocusTrap);
	
	    var _this = _possibleConstructorReturn(this, (FocusTrap.__proto__ || Object.getPrototypeOf(FocusTrap)).call(this, props));
	
	    _this.setNode = function (el) {
	      _this.node = el;
	    };
	
	    if (typeof document !== 'undefined') {
	      _this.previouslyFocusedElement = document.activeElement;
	    }
	    return _this;
	  }
	
	  _createClass(FocusTrap, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      // We need to hijack the returnFocusOnDeactivate option,
	      // because React can move focus into the element before we arrived at
	      // this lifecycle hook (e.g. with autoFocus inputs). So the component
	      // captures the previouslyFocusedElement in componentWillMount,
	      // then (optionally) returns focus to it in componentWillUnmount.
	      var specifiedFocusTrapOptions = this.props.focusTrapOptions;
	      var tailoredFocusTrapOptions = {
	        returnFocusOnDeactivate: false
	      };
	      for (var optionName in specifiedFocusTrapOptions) {
	        if (!specifiedFocusTrapOptions.hasOwnProperty(optionName)) continue;
	        if (optionName === 'returnFocusOnDeactivate') continue;
	        tailoredFocusTrapOptions[optionName] = specifiedFocusTrapOptions[optionName];
	      }
	
	      this.focusTrap = this.props._createFocusTrap(this.node, tailoredFocusTrapOptions);
	      if (this.props.active) {
	        this.focusTrap.activate();
	      }
	      if (this.props.paused) {
	        this.focusTrap.pause();
	      }
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate(prevProps) {
	      if (prevProps.active && !this.props.active) {
	        this.focusTrap.deactivate();
	      } else if (!prevProps.active && this.props.active) {
	        this.focusTrap.activate();
	      }
	
	      if (prevProps.paused && !this.props.paused) {
	        this.focusTrap.unpause();
	      } else if (!prevProps.paused && this.props.paused) {
	        this.focusTrap.pause();
	      }
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      this.focusTrap.deactivate();
	      if (this.props.focusTrapOptions.returnFocusOnDeactivate !== false && this.previouslyFocusedElement && this.previouslyFocusedElement.focus) {
	        this.previouslyFocusedElement.focus();
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var elementProps = {
	        ref: this.setNode
	      };
	
	      // This will get id, className, style, etc. -- arbitrary element props
	      for (var prop in this.props) {
	        if (!this.props.hasOwnProperty(prop)) continue;
	        if (checkedProps.indexOf(prop) !== -1) continue;
	        elementProps[prop] = this.props[prop];
	      }
	
	      return React.createElement(this.props.tag, elementProps, this.props.children);
	    }
	  }]);
	
	  return FocusTrap;
	}(React.Component);
	
	FocusTrap.defaultProps = {
	  active: true,
	  tag: 'div',
	  paused: false,
	  focusTrapOptions: {},
	  _createFocusTrap: createFocusTrap
	};
	
	module.exports = FocusTrap;

/***/ },
/* 194 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.ActionButtonGroup = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	__webpack_require__(1429);
	
	var _reactTooltip = __webpack_require__(78);
	
	var _reactTooltip2 = _interopRequireDefault(_reactTooltip);
	
	var _Loaders = __webpack_require__(16);
	
	var _shortid = __webpack_require__(22);
	
	var _shortid2 = _interopRequireDefault(_shortid);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ActionButton = function (_Component) {
	  _inherits(ActionButton, _Component);
	
	  function ActionButton() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, ActionButton);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = ActionButton.__proto__ || Object.getPrototypeOf(ActionButton)).call.apply(_ref, [this].concat(args))), _this), _this.tooltipId = _shortid2.default.generate(), _this.handleClick = function (e) {
	      e.stopPropagation();
	      _this.props.onClick(e);
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(ActionButton, [{
	    key: "render",
	    value: function render() {
	      var _props = this.props,
	          _props$iconClass = _props.iconClass,
	          iconClass = _props$iconClass === undefined ? "" : _props$iconClass,
	          label = _props.label,
	          _props$flex = _props.flex,
	          flex = _props$flex === undefined ? true : _props$flex,
	          _props$className = _props.className,
	          className = _props$className === undefined ? "" : _props$className,
	          _props$tooltip = _props.tooltip,
	          tooltip = _props$tooltip === undefined ? false : _props$tooltip,
	          _props$hideLabel = _props.hideLabel,
	          hideLabel = _props$hideLabel === undefined ? false : _props$hideLabel,
	          _props$style = _props.style,
	          style = _props$style === undefined ? "outer" : _props$style,
	          _props$disabled = _props.disabled,
	          disabled = _props$disabled === undefined ? false : _props$disabled,
	          children = _props.children,
	          loading = _props.loading;
	
	      return _react2.default.createElement(
	        "div",
	        {
	          className: "action-button " + (flex ? "flex" : "") + " " + className + " " + style,
	          "data-tip": typeof tooltip === 'string' ? tooltip : label,
	          "data-for": this.tooltipId
	          // data-delay-show={200}
	        },
	        _react2.default.createElement(
	          "span",
	          null,
	          _react2.default.createElement(
	            "button",
	            {
	              className: "action-icon " + iconClass + " " + style,
	              onClick: this.handleClick,
	              disabled: disabled,
	              "aria-label": label
	            },
	            !hideLabel && style === "inner" && label,
	            children && _react2.default.createElement(
	              "div",
	              { className: "inner-wrapper" },
	              loading ? _react2.default.createElement(_Loaders.Spinner, { size: "medium", linear: true, themeColor: "medium-neutral" }) : children
	            )
	          ),
	          !hideLabel && style === "outer" && _react2.default.createElement(
	            "span",
	            { className: "label" },
	            label
	          ),
	          tooltip && _react2.default.createElement(_reactTooltip2.default, { effect: "solid", id: this.tooltipId })
	        )
	      );
	    }
	  }]);
	
	  return ActionButton;
	}(_react.Component);
	
	exports.default = ActionButton;
	
	var ActionButtonGroup = exports.ActionButtonGroup = function (_Component2) {
	  _inherits(ActionButtonGroup, _Component2);
	
	  function ActionButtonGroup() {
	    _classCallCheck(this, ActionButtonGroup);
	
	    return _possibleConstructorReturn(this, (ActionButtonGroup.__proto__ || Object.getPrototypeOf(ActionButtonGroup)).apply(this, arguments));
	  }
	
	  _createClass(ActionButtonGroup, [{
	    key: "render",
	    value: function render() {
	      var _props2 = this.props,
	          _props2$className = _props2.className,
	          className = _props2$className === undefined ? "" : _props2$className,
	          _props2$buttonSize = _props2.buttonSize,
	          buttonSize = _props2$buttonSize === undefined ? "" : _props2$buttonSize,
	          children = _props2.children;
	
	      var numChildren = _react2.default.Children.toArray(children).length;
	      return numChildren > 0 ? _react2.default.createElement(
	        "div",
	        {
	          className: "action-button-group flex " + className + " " + buttonSize
	        },
	        children
	      ) : null;
	    }
	  }]);
	
	  return ActionButtonGroup;
	}(_react.Component);

/***/ },
/* 195 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	__webpack_require__(1441);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var STATE_ABBR = ("MT");
	STATE_ABBR = STATE_ABBR.toUpperCase();
	var SEAL_FILENAME = ("seal.png");
	var stateSeal = __webpack_require__(216)("./" + STATE_ABBR + (SEAL_FILENAME ? "/" + SEAL_FILENAME : "/seal.svg"));
	var isIE11 = !!window.MSInputMethodContext && !!document.documentMode;
	
	exports.default = function (_ref) {
	  var title = _ref.title,
	      seal = _ref.seal,
	      leftColumn = _ref.leftColumn,
	      rightColumn = _ref.rightColumn,
	      children = _ref.children;
	
	  var columnStyles = isIE11 ? { flex: '0 0 250px' } : undefined;
	  return _react2.default.createElement(
	    "div",
	    { className: "fc-login-wrapper wizard" },
	    _react2.default.createElement(
	      "div",
	      { className: "fc-header" },
	      seal && _react2.default.createElement("img", { src: stateSeal, alt: "State seal" }),
	      _react2.default.createElement(
	        "h2",
	        null,
	        title
	      )
	    ),
	    _react2.default.createElement(
	      "div",
	      { className: "fc-body" },
	      children ? children : _react2.default.createElement(
	        _react2.default.Fragment,
	        null,
	        _react2.default.createElement(
	          "div",
	          { className: "fc-column secondary", style: columnStyles },
	          leftColumn
	        ),
	        _react2.default.createElement(
	          "div",
	          { className: "fc-column", style: columnStyles },
	          rightColumn
	        )
	      )
	    )
	  );
	};

/***/ },
/* 196 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.setIcon = exports.setAndPushIcon = exports.toggleVisibility = exports.importToLast = exports.toggleImportDialog = exports.archiveWizard = exports.cloneWizard = exports.unpublishWizard = exports.publishWizardToEmptyCategory = exports.publishWizardToLast = exports.publishWizard = exports.deleteCategory = exports.addCategory = exports.setCategoryAbbreviation = exports.setCategoryTitle = exports.reorderCategory = exports.moveWizardToLast = exports.moveWizardToEmptyCategory = exports.setWasOver = exports.setIsOver = exports.moveWizard = exports.toggleSaving = exports.toggleDragging = exports.saveFormManagerStructure = exports.getAllWizards = exports.fetchStructure = exports.setActiveCategory = exports.setFilter = exports.populateStructure = exports.setAllWizards = exports.toggleFormManagerLoading = undefined;
	
	var _requests = __webpack_require__(6);
	
	var api = _interopRequireWildcard(_requests);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	var toggleFormManagerLoading = exports.toggleFormManagerLoading = function toggleFormManagerLoading(loading) {
	  return {
	    type: '@@fm/TOGGLE_LOADING',
	    loading: loading
	  };
	};
	
	var setAllWizards = exports.setAllWizards = function setAllWizards(wizards, category) {
	  return {
	    type: '@@fm/SET_ALL_WIZARDS',
	    wizards: wizards,
	    category: category
	  };
	};
	
	var populateStructure = exports.populateStructure = function populateStructure(payload) {
	  return {
	    type: '@@fm/POPULATE_STRUCTURE',
	    payload: payload
	  };
	};
	
	var setFilter = exports.setFilter = function setFilter(filter) {
	  return {
	    type: '@@fm/SET_FILTER',
	    filter: filter
	  };
	};
	
	var setActiveCategory = exports.setActiveCategory = function setActiveCategory(category) {
	  return {
	    type: '@@fm/SET_ACTIVE_CATEGORY',
	    category: category
	  };
	};
	
	var fetchStructure = exports.fetchStructure = function fetchStructure() {
	  return function (dispatch) {
	    api.GET_APP_SETTING_BY_NAME('FORM_MANAGER_STRUCTURE', function (structure) {
	      dispatch(populateStructure(Object.assign({}, JSON.parse(structure.VALUE), {
	        appSettingId: structure.APP_SETTING_ID
	      })));
	    });
	  };
	};
	
	var getAllWizards = exports.getAllWizards = function getAllWizards(category) {
	  return function (dispatch) {
	    new Promise(function (resolve) {
	      api.GET_ALL_WIZARDS(category, function (data) {
	        var wizards = data.reduce(function (obj, wizard) {
	          obj[wizard.FORM_DEFINITION_ID] = wizard;
	          return obj;
	        }, {});
	        dispatch(setAllWizards(wizards, category));
	      });
	    });
	  };
	};
	
	var saveFormManagerStructure = exports.saveFormManagerStructure = function saveFormManagerStructure(callback) {
	  return function (dispatch, getState) {
	    var formManager = getState().formManager;
	    api.UPDATE_APP_SETTING_BY_ID(formManager.appSettingId, {
	      NAME: 'FORM_MANAGER_STRUCTURE',
	      VALUE: JSON.stringify({
	        categoriesOrder: formManager.categoriesOrder,
	        categories: formManager.categories,
	        categoryIcons: formManager.categoryIcons
	      }),
	      CATEGORY: 'ADMIN',
	      DESCR: ''
	    }, function (data) {
	      callback(true);
	    });
	  };
	};
	
	var toggleDragging = exports.toggleDragging = function toggleDragging(dragging) {
	  return {
	    type: '@@fm/TOGGLE_DRAGGING',
	    dragging: dragging
	  };
	};
	
	var toggleSaving = exports.toggleSaving = function toggleSaving(saving) {
	  return {
	    type: '@@fm/TOGGLE_SAVING',
	    saving: saving
	  };
	};
	
	var moveWizard = exports.moveWizard = function moveWizard(_ref) {
	  var origin = _ref.origin,
	      target = _ref.target;
	  return function (dispatch) {
	    dispatch({
	      type: '@@fm/MOVE_WIZARD',
	      origin: origin,
	      target: target
	    });
	    dispatch(toggleSaving(true));
	    dispatch(saveFormManagerStructure(function (response) {
	      if (response === true) {
	        dispatch(toggleSaving(false));
	      }
	    }));
	  };
	};
	
	var setIsOver = exports.setIsOver = function setIsOver(isOver) {
	  return {
	    type: '@@fm/SET_ISOVER',
	    isOver: isOver
	  };
	};
	
	var setWasOver = exports.setWasOver = function setWasOver(wasOver) {
	  return {
	    type: '@@fm/SET_WASOVER',
	    wasOver: wasOver
	  };
	};
	
	var moveWizardToEmptyCategory = exports.moveWizardToEmptyCategory = function moveWizardToEmptyCategory(_ref2) {
	  var origin = _ref2.origin,
	      target = _ref2.target;
	  return function (dispatch) {
	    dispatch({
	      type: '@@fm/MOVE_WIZARD_TO_EMPTY_CATEGORY',
	      origin: origin,
	      target: target
	    });
	    dispatch(toggleSaving(true));
	    dispatch(saveFormManagerStructure(function (response) {
	      if (response === true) {
	        dispatch(toggleSaving(false));
	      }
	    }));
	  };
	};
	
	var moveWizardToLast = exports.moveWizardToLast = function moveWizardToLast(_ref3) {
	  var origin = _ref3.origin,
	      target = _ref3.target;
	  return function (dispatch) {
	    dispatch({
	      type: '@@fm/MOVE_WIZARD_TO_LAST',
	      origin: origin,
	      target: target
	    });
	    dispatch(toggleSaving(true));
	    dispatch(saveFormManagerStructure(function (response) {
	      if (response === true) {
	        dispatch(toggleSaving(false));
	      }
	    }));
	  };
	};
	
	var reorderCategory = exports.reorderCategory = function reorderCategory(_ref4) {
	  var direction = _ref4.direction,
	      categoryId = _ref4.categoryId,
	      categoryIndex = _ref4.categoryIndex;
	  return function (dispatch) {
	    dispatch({
	      type: '@@fm/REORDER_CATEGORY',
	      direction: direction,
	      categoryId: categoryId,
	      categoryIndex: categoryIndex
	    });
	    dispatch(toggleSaving(true));
	    dispatch(saveFormManagerStructure(function (response) {
	      if (response === true) {
	        dispatch(toggleSaving(false));
	      }
	    }));
	  };
	};
	
	var setCategoryTitle = exports.setCategoryTitle = function setCategoryTitle(_ref5) {
	  var title = _ref5.title,
	      categoryId = _ref5.categoryId;
	  return function (dispatch) {
	    dispatch({
	      type: '@@fm/SET_CATEGORY_TITLE',
	      categoryId: categoryId,
	      title: title
	    });
	    dispatch(toggleSaving(true));
	    dispatch(saveFormManagerStructure(function (response) {
	      if (response === true) {
	        dispatch(toggleSaving(false));
	      }
	    }));
	  };
	};
	
	var setCategoryAbbreviation = exports.setCategoryAbbreviation = function setCategoryAbbreviation(_ref6) {
	  var abbreviation = _ref6.abbreviation,
	      categoryId = _ref6.categoryId;
	  return function (dispatch) {
	    dispatch({
	      type: '@@fm/SET_CATEGORY_ABBREVIATION',
	      categoryId: categoryId,
	      abbreviation: abbreviation
	    });
	    dispatch(toggleSaving(true));
	    dispatch(saveFormManagerStructure(function (response) {
	      if (response === true) {
	        dispatch(toggleSaving(false));
	      }
	    }));
	  };
	};
	
	var addCategory = exports.addCategory = function addCategory() {
	  return function (dispatch) {
	    dispatch({
	      type: '@@fm/ADD_CATEGORY'
	    });
	    dispatch(toggleSaving(true));
	    dispatch(saveFormManagerStructure(function (response) {
	      if (response === true) {
	        dispatch(toggleSaving(false));
	      }
	    }));
	  };
	};
	
	var deleteCategory = exports.deleteCategory = function deleteCategory(_ref7) {
	  var categoryId = _ref7.categoryId,
	      categoryIndex = _ref7.categoryIndex;
	  return function (dispatch) {
	    dispatch({
	      type: '@@fm/DELETE_CATEGORY',
	      categoryId: categoryId,
	      categoryIndex: categoryIndex
	    });
	    dispatch(toggleSaving(true));
	    dispatch(saveFormManagerStructure(function (response) {
	      if (response === true) {
	        dispatch(toggleSaving(false));
	      }
	    }));
	  };
	};
	
	var publishWizard = exports.publishWizard = function publishWizard(_ref8) {
	  var origin = _ref8.origin,
	      target = _ref8.target;
	  return function (dispatch) {
	    dispatch({
	      type: '@@fm/PUBLISH_WIZARD',
	      origin: origin,
	      target: target
	    });
	    dispatch(toggleSaving(true));
	    dispatch(saveFormManagerStructure(function (response) {
	      if (response === true) {
	        dispatch(toggleSaving(false));
	      }
	    }));
	  };
	};
	
	var publishWizardToLast = exports.publishWizardToLast = function publishWizardToLast(_ref9) {
	  var origin = _ref9.origin,
	      target = _ref9.target;
	  return function (dispatch) {
	    dispatch({
	      type: '@@fm/PUBLISH_WIZARD_TO_LAST',
	      origin: origin,
	      target: target
	    });
	    dispatch(toggleSaving(true));
	    dispatch(saveFormManagerStructure(function (response) {
	      if (response === true) {
	        dispatch(toggleSaving(false));
	      }
	    }));
	  };
	};
	
	var publishWizardToEmptyCategory = exports.publishWizardToEmptyCategory = function publishWizardToEmptyCategory(_ref10) {
	  var origin = _ref10.origin,
	      target = _ref10.target;
	  return function (dispatch) {
	    dispatch({
	      type: '@@fm/PUBLISH_WIZARD_TO_EMPTY_CATEGORY',
	      origin: origin,
	      target: target
	    });
	    dispatch(toggleSaving(true));
	    dispatch(saveFormManagerStructure(function (response) {
	      if (response === true) {
	        dispatch(toggleSaving(false));
	      }
	    }));
	  };
	};
	
	var unpublishWizard = exports.unpublishWizard = function unpublishWizard(_ref11) {
	  var origin = _ref11.origin;
	  return function (dispatch) {
	    if (origin.categoryId !== 'uncategorized') {
	      dispatch({
	        type: '@@fm/UNPUBLISH_WIZARD',
	        origin: origin
	      });
	      dispatch(toggleSaving(true));
	      dispatch(saveFormManagerStructure(function (response) {
	        if (response === true) {
	          dispatch(toggleSaving(false));
	        }
	      }));
	    }
	  };
	};
	
	var cloneWizard = exports.cloneWizard = function cloneWizard(formDefinitionId, title) {
	  return function (dispatch, getState) {
	    var formManager = getState().formManager;
	    var wizard = formManager.wizards[formManager.activeCategory][formDefinitionId];
	    api.CLONE_WIZARD(formDefinitionId, {
	      TITLE: title === '' ? 'Copy of ' + wizard.TITLE : title,
	      DESCR: wizard.DESCR,
	      CATEGORY: wizard.CATEGORY
	    }, function (response) {
	      dispatch(getAllWizards(formManager.activeCategory));
	    });
	  };
	};
	
	var archiveWizard = exports.archiveWizard = function archiveWizard(formDefinitionId) {
	  return function (dispatch, getState) {
	    api.ARCHIVE_WIZARD(formDefinitionId, {}, function (response) {
	      dispatch(getAllWizards(getState().formManager.activeCategory));
	    });
	  };
	};
	
	var toggleImportDialog = exports.toggleImportDialog = function toggleImportDialog(isOpen) {
	  return {
	    type: '@@fm/TOGGLE_IMPORT_DIALOG',
	    isOpen: isOpen
	  };
	};
	
	var importToLast = exports.importToLast = function importToLast(_ref12, callback) {
	  var categoryId = _ref12.categoryId,
	      formDefinitionId = _ref12.formDefinitionId;
	  return function (dispatch) {
	    dispatch({
	      type: '@@fm/IMPORT_TO_LAST',
	      categoryId: categoryId,
	      formDefinitionId: formDefinitionId
	    });
	    dispatch(toggleSaving(true));
	    dispatch(saveFormManagerStructure(function (response) {
	      if (response === true) {
	        if (callback) {
	          callback();
	        }
	        dispatch(toggleSaving(false));
	      }
	    }));
	  };
	};
	
	var toggleVisibility = exports.toggleVisibility = function toggleVisibility(_ref13, callback) {
	  var on = _ref13.on,
	      categoryId = _ref13.categoryId;
	  return function (dispatch) {
	    dispatch({
	      type: '@@fm/TOGGLE_VISIBILITY',
	      on: on,
	      categoryId: categoryId
	    });
	    dispatch(toggleSaving(true));
	    dispatch(saveFormManagerStructure(function (response) {
	      if (response === true) {
	        if (callback) {
	          callback();
	        }
	        dispatch(toggleSaving(false));
	      }
	    }));
	  };
	};
	
	var setAndPushIcon = exports.setAndPushIcon = function setAndPushIcon(icon) {
	  return function (dispatch) {
	    dispatch(setIcon(icon));
	    dispatch(toggleSaving(true));
	    dispatch(saveFormManagerStructure(function (response) {
	      if (response === true) {
	        dispatch(toggleSaving(false));
	      }
	    }));
	  };
	};
	
	var setIcon = exports.setIcon = function setIcon(icon) {
	  return {
	    type: '@@fm/SET_ICON',
	    icon: icon
	  };
	};

/***/ },
/* 197 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Emptybox = function Emptybox(props) {
	  return _react2.default.createElement(
	    "svg",
	    Object.assign({ viewBox: "0 0 554.75 594.1" }, props),
	    _react2.default.createElement(
	      "title",
	      null,
	      "Empty Box"
	    ),
	    _react2.default.createElement(
	      "g",
	      { "data-name": "Layer 2" },
	      _react2.default.createElement(
	        "g",
	        { "data-name": "Layer 1" },
	        _react2.default.createElement("path", {
	          d: "M29.84 360h130.79a16.59 16.59 0 0 1 15.13 9.82l16 35.53a10 10 0 0 0 9.09 5.9h153.08a10 10 0 0 0 9.09-5.9l16-35.57a16.57 16.57 0 0 1 15.1-9.78h130.79a29.31 29.31 0 0 1 8.16 1.15L458.83 214A23.22 23.22 0 0 0 438 201.18H116.73A23.21 23.21 0 0 0 95.92 214l-14 27.7 2 .81a3.5 3.5 0 0 1-1.28 6.76 3.36 3.36 0 0 1-1.27-.24c-.88-.34-1.76-.7-2.63-1.06L21.68 361.09a29.68 29.68 0 0 1 8.16-1.09zm335.24-25a100.78 100.78 0 0 1-6.6 12.9 3.5 3.5 0 1 1-6-3.62 93.21 93.21 0 0 0 6.14-12 3.5 3.5 0 0 1 6.45 2.72zm6.17-33.83c.17 1.71.26 3.46.26 5.18a51.75 51.75 0 0 1-.39 6.34c-.14 1.13-.3 2.25-.48 3.34a3.51 3.51 0 0 1-3.45 2.93 3.79 3.79 0 0 1-.58-.05 3.5 3.5 0 0 1-2.88-4c.17-1 .31-2 .44-3a46 46 0 0 0 .34-5.49 44.81 44.81 0 0 0-.23-4.48 3.5 3.5 0 1 1 7-.7zM352 269.34a3.5 3.5 0 0 1 4.94.32 62.77 62.77 0 0 1 8.41 12.17 3.5 3.5 0 0 1-6.21 3.24 55.44 55.44 0 0 0-7.46-10.79 3.5 3.5 0 0 1 .32-4.94zm-5.41 89.45a3.5 3.5 0 0 1 .4 4.93c-3 3.55-6.31 7.07-9.81 10.47a3.54 3.54 0 0 1-2.44 1 3.45 3.45 0 0 1-2.51-1.06 3.49 3.49 0 0 1 .07-4.95c3.34-3.24 6.49-6.59 9.36-10a3.5 3.5 0 0 1 4.95-.39zm-21.82-107.74a3.51 3.51 0 0 1 4.68-1.63 100.23 100.23 0 0 1 12.57 7.2 3.5 3.5 0 0 1-2 6.4 3.47 3.47 0 0 1-2-.6 92.61 92.61 0 0 0-11.69-6.7 3.5 3.5 0 0 1-1.56-4.67zM323.12 382a3.5 3.5 0 0 1-.65 4.91 129.76 129.76 0 0 1-11.92 8.22 3.5 3.5 0 0 1-3.53-6 125.32 125.32 0 0 0 11.2-7.75 3.5 3.5 0 0 1 4.9.62zM293.2 241.71a3.51 3.51 0 0 1 4.12-2.75c4.78 1 9.46 2.11 13.9 3.44a3.5 3.5 0 1 1-2 6.71c-4.23-1.27-8.69-2.37-13.26-3.28a3.51 3.51 0 0 1-2.76-4.12zm-29.27-6.22c4.82.1 9.6.36 14.21.76a3.5 3.5 0 0 1-.3 7h-.31c-4.46-.4-9.08-.65-13.74-.74a3.5 3.5 0 0 1 .14-7zm-33.39 1.6c4.75-.53 9.5-.93 14.12-1.21a3.5 3.5 0 0 1 .42 7c-4.5.27-9.14.66-13.77 1.18h-.39a3.5 3.5 0 0 1-.38-7zm-32.9 5.44c4.64-1 9.31-1.92 13.88-2.72a3.5 3.5 0 0 1 1.2 6.9c-4.47.78-9.05 1.67-13.6 2.66a3.81 3.81 0 0 1-.74.08 3.5 3.5 0 0 1-.74-6.92zm-32 7.52c4.46-.8 9-1.81 13.37-3a3.5 3.5 0 0 1 1.82 6.76c-4.61 1.24-9.3 2.28-14 3.12a4.44 4.44 0 0 1-.62.05 3.5 3.5 0 0 1-.62-6.94zm-32.13 2.41c4.52.13 9.13.06 13.69-.22a3.5 3.5 0 1 1 .41 7c-3.2.19-6.44.29-9.64.29-1.55 0-3.12 0-4.66-.07a3.5 3.5 0 1 1 .2-7zm-36.13-1.8a3.5 3.5 0 0 1 4.24-2.55c4.39 1.09 8.91 2 13.41 2.68a3.5 3.5 0 0 1-.52 7 3.27 3.27 0 0 1-.54 0c-4.71-.72-9.44-1.67-14-2.81a3.51 3.51 0 0 1-2.59-4.32z",
	          fill: "#e6e6e6"
	        }),
	        _react2.default.createElement("path", {
	          d: "M554.75 389.48a32.8 32.8 0 0 0-4.65-16.84l-82.35-163.18A33.15 33.15 0 0 0 438 191.18H116.73A33.15 33.15 0 0 0 87 209.47l-14.18 28.08-1.31-.65a3.5 3.5 0 1 0-3.18 6.24l1.34.66-65 128.84A32.82 32.82 0 0 0 0 388.31V564.2a29.9 29.9 0 0 0 29.84 29.9h495.07a29.9 29.9 0 0 0 29.84-29.9v-102zm-10 174.72a19.89 19.89 0 0 1-19.84 19.9H29.84A19.89 19.89 0 0 1 10 564.2V389.86A19.9 19.9 0 0 1 29.84 370h130.79a6.58 6.58 0 0 1 6 3.91l16 35.54a20 20 0 0 0 18.21 11.8h153.09a20 20 0 0 0 18.21-11.8l16-35.58a6.56 6.56 0 0 1 6-3.87h130.77a19.9 19.9 0 0 1 19.84 19.91zM81.41 249a3.36 3.36 0 0 0 1.27.24 3.5 3.5 0 0 0 1.32-6.75l-2-.81 14-27.7a23.21 23.21 0 0 1 20.81-12.8H438A23.22 23.22 0 0 1 458.83 214l74.24 147.1a29.31 29.31 0 0 0-8.16-1.15H394.12a16.57 16.57 0 0 0-15.12 9.78l-16 35.57a10 10 0 0 1-9.09 5.9H200.82a10 10 0 0 1-9.09-5.9l-16-35.53a16.59 16.59 0 0 0-15.1-9.77H29.84a29.68 29.68 0 0 0-8.16 1.14L78.78 248c.87.31 1.75.67 2.63 1z",
	          fill: "#a8a8a8"
	        }),
	        _react2.default.createElement("path", {
	          d: "M544.75 389.86A19.9 19.9 0 0 0 524.91 370H394.12a6.56 6.56 0 0 0-6 3.87l-16 35.58a20 20 0 0 1-18.21 11.8H200.82a20 20 0 0 1-18.21-11.8l-16-35.54a6.58 6.58 0 0 0-6-3.91H29.84A19.9 19.9 0 0 0 10 389.86V564.2a19.89 19.89 0 0 0 19.84 19.9h495.07a19.89 19.89 0 0 0 19.84-19.9zM354.38 517.14a16.48 16.48 0 0 1-16.47 16.46H216.84a16.47 16.47 0 0 1-16.46-16.46v-33.07a16.48 16.48 0 0 1 16.46-16.47h121.07a16.49 16.49 0 0 1 16.47 16.47z",
	          fill: "#fff"
	        }),
	        _react2.default.createElement("rect", {
	          x: 210.38,
	          y: 477.6,
	          width: 134,
	          height: 46,
	          rx: 6.47,
	          fill: "#e6e6e6"
	        }),
	        _react2.default.createElement("path", {
	          d: "M337.91 467.6H216.84a16.48 16.48 0 0 0-16.46 16.47v33.07a16.47 16.47 0 0 0 16.46 16.46h121.07a16.48 16.48 0 0 0 16.47-16.46v-33.07a16.49 16.49 0 0 0-16.47-16.47zm6.47 49.54a6.48 6.48 0 0 1-6.47 6.46H216.84a6.47 6.47 0 0 1-6.46-6.46v-33.07a6.48 6.48 0 0 1 6.46-6.47h121.07a6.49 6.49 0 0 1 6.47 6.47z",
	          fill: "#a8a8a8"
	        }),
	        _react2.default.createElement("path", {
	          d: "M461.84 94.29c.27-2.12-3.61-5-9.22-5.76a20.39 20.39 0 0 0-2.45-.15 14.27 14.27 0 0 0-5.14.86c-1.65.64-2.66 1.57-2.79 2.53s.63 2.11 2.06 3.15a15.92 15.92 0 0 0 7.16 2.61c5.6.72 10.11-1.11 10.38-3.24z",
	          fill: "#fff"
	        }),
	        _react2.default.createElement("path", {
	          d: "M438.28 91.26c-.33 2.48 1 4.93 3.66 6.89a19.72 19.72 0 0 0 9 3.34 23.27 23.27 0 0 0 3 .2 18.18 18.18 0 0 0 6.22-1 13.29 13.29 0 0 0 6.5 2 7.63 7.63 0 0 0 5.11-1.81c2.91-2.54 3.33-6.94 1.49-11.54a19.78 19.78 0 0 0 2.09-9c.08-7.79-3.6-13.92-8.39-14h-.06c-4 0-7.28 4.26-8.29 10.21a7.57 7.57 0 0 0-9 7.86 18 18 0 0 0-6 1.12c-3.13 1.2-5.01 3.24-5.33 5.73zm24-11.11c.06-5.64 2.49-9.83 4.62-9.83 2.14 0 4.49 4.28 4.43 9.93s-2.49 9.83-4.63 9.83c-1 0-2-.91-2.84-2.47a16.12 16.12 0 0 1-1.6-7.46zm-10.8 17.38a15.92 15.92 0 0 1-7.16-2.61c-1.43-1-2.18-2.19-2.06-3.15s1.14-1.89 2.79-2.53a14.27 14.27 0 0 1 5.14-.86 20.39 20.39 0 0 1 2.45.15c5.61.73 9.49 3.64 9.22 5.76s-4.8 3.96-10.4 3.24z",
	          fill: "#a8a8a8"
	        }),
	        _react2.default.createElement("path", {
	          d: "M463.84 87.61c.84 1.56 1.88 2.46 2.84 2.47 2.14 0 4.56-4.19 4.63-9.83s-2.29-9.9-4.43-9.93c-2.13 0-4.56 4.19-4.62 9.83a16.12 16.12 0 0 0 1.58 7.46z",
	          fill: "#fff"
	        }),
	        _react2.default.createElement("path", {
	          d: "M111.47 31.39a3.54 3.54 0 0 0 1.41-.3c4.16-1.84 8.46-3.6 12.77-5.24a3.5 3.5 0 1 0-2.47-6.54c-4.44 1.68-8.86 3.49-13.13 5.38a3.5 3.5 0 0 0 1.42 6.7zM45 218.92a3.51 3.51 0 1 0-4.66 5.24 129 129 0 0 0 11.28 8.93 3.5 3.5 0 1 0 4-5.72A121.57 121.57 0 0 1 45 218.92zM55.79 66.38a3.5 3.5 0 0 0 2.29-.85q1.72-1.5 3.53-3c2.33-1.93 4.75-3.84 7.18-5.67a3.5 3.5 0 0 0-4.22-5.59c-2.51 1.9-5 3.87-7.42 5.86q-1.86 1.55-3.65 3.09a3.5 3.5 0 0 0 2.29 6.14zM82.33 46.82a3.37 3.37 0 0 0 1.85-.54c3.82-2.4 7.82-4.74 11.91-6.94a3.5 3.5 0 1 0-3.34-6.15 234.58 234.58 0 0 0-12.28 7.16 3.5 3.5 0 0 0 1.86 6.47zM30.74 89.33a3.44 3.44 0 0 0 2.16.75 3.5 3.5 0 0 0 2.75-1.33c2.74-3.48 5.75-7 9-10.35a3.5 3.5 0 0 0-5.09-4.81c-3.34 3.55-6.49 7.19-9.36 10.83a3.5 3.5 0 0 0 .54 4.91zM8.49 150.28h.16a3.5 3.5 0 0 0 3.49-3.35 84.32 84.32 0 0 1 1.66-13.33 3.5 3.5 0 0 0-6.86-1.4 92.1 92.1 0 0 0-1.79 14.42 3.49 3.49 0 0 0 3.34 3.66zM24.59 194.54a3.5 3.5 0 1 0-6 3.6A106.54 106.54 0 0 0 26.86 210a3.5 3.5 0 1 0 5.46-4.38 100.7 100.7 0 0 1-7.73-11.08zM9.3 162.25a3.5 3.5 0 0 0-2.83 4.07 92.76 92.76 0 0 0 3.72 14 3.51 3.51 0 0 0 3.3 2.34 3.57 3.57 0 0 0 1.16-.19 3.5 3.5 0 0 0 2.14-4.47 84.82 84.82 0 0 1-3.43-13 3.49 3.49 0 0 0-4.06-2.75zM14.65 118a3.39 3.39 0 0 0 1.35.27 3.49 3.49 0 0 0 3.23-2.14 112.23 112.23 0 0 1 6-12.14 3.5 3.5 0 1 0-6.06-3.49 114.07 114.07 0 0 0-6.42 12.92 3.5 3.5 0 0 0 1.9 4.58zM240.16 7c4.58 0 9.25.17 13.88.38h.16a3.5 3.5 0 0 0 .16-7C249.64.17 244.89 0 240.23 0a3.5 3.5 0 0 0 0 7zM398.58 42.06a235.7 235.7 0 0 1 12.22 6.4 3.46 3.46 0 0 0 1.72.45 3.5 3.5 0 0 0 1.72-6.55c-4-2.24-8.23-4.46-12.59-6.59a3.5 3.5 0 0 0-3.07 6.29zM426.59 58.38a130.67 130.67 0 0 1 10.74 8.39 3.5 3.5 0 1 0 4.61-5.27 138.74 138.74 0 0 0-11.32-8.84 3.5 3.5 0 0 0-4 5.72zM337.25 19.9c4.49 1.16 9 2.41 13.36 3.72a3.58 3.58 0 0 0 1 .15 3.5 3.5 0 0 0 1-6.85c-4.46-1.34-9-2.61-13.61-3.8a3.5 3.5 0 1 0-1.76 6.78zM142.41 20a3.45 3.45 0 0 0 1-.14c4.37-1.31 8.85-2.53 13.34-3.63a3.5 3.5 0 0 0-1.67-6.8c-4.6 1.13-9.2 2.38-13.67 3.72a3.5 3.5 0 0 0 1 6.85zM368.5 29.48c4.4 1.58 8.75 3.24 12.94 4.94a3.41 3.41 0 0 0 1.32.26 3.5 3.5 0 0 0 1.32-6.74c-4.28-1.74-8.73-3.44-13.23-5.05a3.5 3.5 0 0 0-2.35 6.59zM174.49 12.37a3.36 3.36 0 0 0 .63-.06c4.48-.81 9.08-1.53 13.68-2.16a3.5 3.5 0 0 0-1-6.94c-4.7.64-9.4 1.39-14 2.22a3.5 3.5 0 0 0 .62 6.94zM207.21 8.14h.28c4.55-.36 9.21-.64 13.84-.83a3.5 3.5 0 1 0-.28-7c-4.73.2-9.48.48-14.12.85a3.5 3.5 0 0 0 .28 7zM272.84 8.67c4.58.43 9.22.94 13.8 1.52a3.31 3.31 0 0 0 .44 0 3.5 3.5 0 0 0 .44-7c-4.65-.59-9.38-1.11-14-1.54a3.5 3.5 0 1 0-.64 7zM305.27 13c4.55.79 9.14 1.67 13.64 2.61a3.5 3.5 0 1 0 1.43-6.85c-4.58-1-9.25-1.85-13.87-2.66a3.5 3.5 0 1 0-1.2 6.9zM198.38 249.45a3.81 3.81 0 0 0 .74-.08c4.55-1 9.13-1.88 13.6-2.66a3.5 3.5 0 0 0-1.2-6.9c-4.57.8-9.24 1.71-13.88 2.72a3.5 3.5 0 0 0 .74 6.92zM263.79 242.49c4.66.09 9.28.34 13.74.74h.31a3.5 3.5 0 0 0 .3-7c-4.61-.4-9.39-.66-14.21-.76a3.5 3.5 0 0 0-.14 7zM230.92 244.07h.39c4.63-.52 9.27-.91 13.77-1.18a3.5 3.5 0 0 0-.42-7c-4.62.28-9.37.68-14.12 1.21a3.5 3.5 0 0 0 .38 7zM99.93 254.9c4.6 1.14 9.33 2.09 14 2.81a3.27 3.27 0 0 0 .54 0 3.5 3.5 0 0 0 .52-7c-4.5-.69-9-1.59-13.41-2.68a3.5 3.5 0 1 0-1.69 6.79zM296 245.83c4.57.91 9 2 13.26 3.28a3.5 3.5 0 1 0 2-6.71c-4.44-1.33-9.12-2.48-13.9-3.44a3.5 3.5 0 1 0-1.37 6.87zM133.31 259.45c1.54.05 3.11.07 4.66.07 3.2 0 6.44-.1 9.64-.29a3.5 3.5 0 1 0-.41-7c-4.56.28-9.17.35-13.69.22a3.5 3.5 0 1 0-.2 7zM166.26 257a4.44 4.44 0 0 0 .62-.05c4.65-.84 9.34-1.88 14-3.12a3.5 3.5 0 0 0-1.82-6.76c-4.41 1.18-8.91 2.19-13.37 3a3.5 3.5 0 0 0 .62 6.94zM364.28 301.85a44.81 44.81 0 0 1 .23 4.48 46 46 0 0 1-.34 5.49c-.13 1-.27 2.05-.44 3a3.5 3.5 0 0 0 2.88 4 3.79 3.79 0 0 0 .58.05 3.51 3.51 0 0 0 3.45-2.93c.18-1.09.34-2.21.48-3.34a51.75 51.75 0 0 0 .39-6.34c0-1.72-.09-3.47-.26-5.18a3.5 3.5 0 1 0-7 .7zM359.16 285.07a3.5 3.5 0 0 0 6.21-3.24 62.77 62.77 0 0 0-8.37-12.17 3.5 3.5 0 0 0-5.26 4.62 55.44 55.44 0 0 1 7.42 10.79zM363.22 330.4a3.51 3.51 0 0 0-4.59 1.86 93.21 93.21 0 0 1-6.14 12 3.5 3.5 0 1 0 6 3.62 100.78 100.78 0 0 0 6.6-12.9 3.49 3.49 0 0 0-1.87-4.58zM332.32 369.16a3.49 3.49 0 0 0-.07 4.95 3.45 3.45 0 0 0 2.51 1.06 3.54 3.54 0 0 0 2.44-1c3.5-3.4 6.8-6.92 9.81-10.47a3.5 3.5 0 0 0-5.33-4.53c-2.87 3.4-6.02 6.75-9.36 9.99zM305.77 393.83a3.49 3.49 0 0 0 4.78 1.25 129.76 129.76 0 0 0 11.92-8.22 3.5 3.5 0 0 0-4.25-5.57A125.32 125.32 0 0 1 307 389a3.49 3.49 0 0 0-1.23 4.83zM326.4 255.72a92.61 92.61 0 0 1 11.69 6.7 3.47 3.47 0 0 0 2 .6 3.5 3.5 0 0 0 2-6.4 100.23 100.23 0 0 0-12.57-7.2 3.5 3.5 0 1 0-3.05 6.3z",
	          fill: "#a8a8a8"
	        })
	      )
	    )
	  );
	};
	
	exports.default = Emptybox;

/***/ },
/* 198 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.BUSINESS_RULES = undefined;
	
	var _requests = __webpack_require__(6);
	
	var getProps = function getProps() {
	  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	  return Object.assign({
	    errorMessage: { type: "text", value: "", label: "Error Message" }
	  }, props);
	};
	
	var getDateOptions = function getDateOptions(callback) {
	  (0, _requests.GET_SERVER_DATES)(function (dates) {
	    callback(dates.map(function (date) {
	      return { value: date.ID, label: date.LABEL };
	    }));
	  }, function (err) {
	    console.error(err);
	    callback([]);
	  });
	};
	
	var BUSINESS_RULES = exports.BUSINESS_RULES = {
	  notEmptyOrNull: {
	    name: "Field cannot be empty",
	    fn: "notEmptyOrNull",
	    onAdvance: true,
	    onBlur: true,
	    props: getProps()
	  },
	  mustBeSelected: {
	    name: "Must select an option",
	    fn: "mustBeSelected",
	    onChange: true,
	    onAdvance: true,
	    props: getProps()
	  },
	  numberLessThan: {
	    name: "Number must be less than or equal to",
	    fn: "numberLessThan",
	    onChange: true,
	    onBlur: true,
	    onAdvance: true,
	    props: getProps({
	      max: { type: "float", value: 0, label: "Maximum Value" }
	    })
	  },
	  numberGreaterThan: {
	    name: "Number must be greater than or equal to",
	    fn: "numberGreaterThan",
	    onChange: true,
	    onBlur: true,
	    onAdvance: true,
	    props: getProps({
	      min: { type: "float", value: 0, label: "Minimum Value" }
	    })
	  },
	  mustBeTrue: {
	    name: "Field must be checked",
	    fn: "mustBeTrue",
	    onChange: true,
	    onAdvance: true,
	    props: getProps()
	  },
	  valuesMatch: {
	    name: "Fields must match",
	    fn: "valuesMatch",
	    onBlur: true,
	    onAdvance: true,
	    props: getProps({
	      caseSensitive: { type: "checkbox", value: true, label: "Case Sensitive" }
	    })
	  },
	  mustNotEqualString: {
	    name: "Field must not equal string",
	    fn: "mustNotEqualString",
	    onChange: true,
	    onAdvance: true,
	    props: getProps({
	      caseSensitive: { type: "checkbox", value: true, label: "Case Sensitive" }
	    })
	  },
	  addressIsRequired: {
	    name: "Full address is required",
	    fn: "addressIsRequired",
	    onAdvance: true,
	    props: getProps()
	  },
	  addressIsValid: {
	    name: "Must be a valid USPS address if entered",
	    fn: "addressIsValid",
	    onAdvance: true,
	    props: getProps(Object.assign({}, (true) && { allowAddressValidationBypass: {
	        type: "checkbox",
	        value: !!(true),
	        label: "Allow user to bypass address validation when invalid address is entered. NOTE: This is intended to be used for mailing addresses, and is tracked as such in the database."
	      } }))
	  },
	  partialAddressNotAllowed: {
	    name: "Partial addresses are not allowed",
	    description: "This rule has the effect of disallowing a partially completed address, but will allow an empty address. Cannot be used with AMS address validation rules.",
	    fn: "partialAddressNotAllowed",
	    onAdvance: true,
	    props: getProps()
	  },
	  registeredAgentAddressIsValid: {
	    name: "Agent name and Physical address is required if adding new agent",
	    fn: "registeredAgentAddressIsValid",
	    onAdvance: true,
	    props: getProps(Object.assign({
	      principalAddressAMS: {
	        type: "checkbox",
	        value: (true) || false,
	        label: "Require that the street address be a valid AMS address."
	      }
	    }, (true) && { allowAgentAddressPrimaryValidationBypass: {
	        type: "checkbox",
	        value: !!(true),
	        label: "Allow user to bypass street address validation when invalid address is entered."
	      } }, {
	      mailingAddressRequired: {
	        type: "checkbox",
	        value: false,
	        label: "Require that the mailing address be a valid AMS address."
	      }
	    }, (true) && { allowAgentAddressMailValidationBypass: {
	        type: "checkbox",
	        value: !!(true),
	        label: "Allow user to bypass mailing address validation when invalid address is entered."
	      } }))
	  },
	  registeredAgentIsRequired: {
	    name: "Registered agent is required",
	    fn: "registeredAgentIsRequired",
	    onAdvance: true,
	    props: getProps()
	  },
	  registeredAgentNotSoS: {
	    name: "Agent must not be the Secretary of State",
	    fn: "registeredAgentNotSoS",
	    onAdvance: true,
	    props: {}
	  },
	  noRegulatedWords: {
	    name: "Regulated words not allowed",
	    fn: "noRegulatedWords",
	    deprecated: true,
	    onBlur: true,
	    onAdvance: true,
	    props: getProps({
	      filingTypeId: {
	        type: "fieldSrc",
	        value: "",
	        label: "Override FILING_TYPE_ID with value from field:",
	        emptyOptionLabel: "[Use default FILING_TYPE_ID]"
	      }
	    })
	  },
	  hasNameEnding: {
	    name: "Must contain proper name designation",
	    fn: "hasNameEnding",
	    deprecated: true,
	    onBlur: true,
	    onAdvance: true,
	    props: getProps({
	      filingTypeId: {
	        type: "fieldSrc",
	        value: "",
	        label: "Override FILING_TYPE_ID with value from field:",
	        emptyOptionLabel: "[Use default FILING_TYPE_ID]"
	      }
	    })
	  },
	  nameNotTaken: {
	    name: "Name must be unique",
	    fn: "nameNotTaken",
	    onBlur: true,
	    onAdvance: true,
	    props: getProps()
	  },
	  repeaterMinRows: {
	    name: "Must add a minimum number of rows",
	    fn: "repeaterMinRows",
	    onAdvance: true,
	    props: getProps({
	      minRows: {
	        type: "range",
	        value: 0,
	        label: "Minimum Number of Rows",
	        minValue: 0,
	        maxValue: 50,
	        step: 1
	      },
	      noRowsIsValid: {
	        type: "checkbox",
	        value: false,
	        label: "The minimum rows are only required if at least one row has been added."
	      }
	    })
	  },
	  repeaterMaxRows: {
	    name: "Only allow a maximum number of rows",
	    fn: "repeaterMaxRows",
	    onAdvance: true,
	    props: getProps({
	      maxRows: {
	        type: "range",
	        value: 10,
	        label: "Maximum Number of Rows",
	        minValue: 0,
	        maxValue: 50,
	        step: 1
	      }
	    })
	  },
	  validateRepeaterFields: {
	    name: "Validate all repeater rows on advance",
	    fn: "validateRepeaterFields",
	    onAdvance: true,
	    props: {
	      skipDeletedRows: {
	        type: "checkbox",
	        value: false,
	        label: "Do not validate deleted rows"
	      }
	    }
	  },
	  validateThirdPartySignaturesRepeater: {
	    name: "Validate all 3rd party signature repeater rows on advance",
	    fn: "validateThirdPartySignaturesRepeater",
	    onAdvance: true,
	    props: {}
	  },
	  nameRequired: {
	    name: "Name is required",
	    fn: "nameRequired",
	    onBlur: true,
	    onAdvance: true,
	    props: getProps({
	      onlyLastNameRequired: {
	        type: "checkbox",
	        value: false,
	        label: "Only last name is required"
	      }
	    })
	  },
	  nameOrgRequired: {
	    name: "Must not be empty or null",
	    fn: "nameOrgRequired",
	    onBlur: true,
	    onAdvance: true,
	    props: getProps({
	      onlyLastNameRequired: {
	        type: "checkbox",
	        value: false,
	        label: "Only last name is required"
	      }
	    })
	  },
	  searchItemRequired: {
	    name: "Must select an item from the search",
	    fn: "searchItemRequired",
	    onBlur: true,
	    onAdvance: true,
	    props: getProps()
	  },
	  nameQualifiedOrgRequired: {
	    name: "Must not be empty or null",
	    fn: "nameQualifiedOrgRequired",
	    onBlur: true,
	    onAdvance: true,
	    props: getProps()
	  },
	  validFeinNum: {
	    name: "Must be a correctly formatted FEIN",
	    fn: "validFeinNum",
	    onBlur: true,
	    onAdvance: true,
	    props: getProps()
	  },
	  validPhoneNumber: {
	    name: "Must be a correctly formatted phone number",
	    fn: "validPhoneNumber",
	    onBlur: true,
	    onAdvance: true,
	    props: getProps()
	  },
	  validPhoneNumberIfPresent: {
	    name: "Must be a correctly formatted phone number if provided.",
	    fn: "validPhoneNumberIfPresent",
	    onBlur: true,
	    onAdvance: true,
	    props: getProps()
	  },
	  enforceMaxDaysBeforeToday: {
	    name: "Enforce max days before today",
	    fn: "enforceMaxDaysBeforeToday",
	    // onChange: true,
	    onBlur: true,
	    onAdvance: true,
	    props: getProps({
	      maxBeforeToday: {
	        type: "number",
	        value: 0,
	        label: "Max Days Before Today"
	      }
	    })
	  },
	  enforceMaxDaysAfterToday: {
	    name: "Enforce max days after today",
	    fn: "enforceMaxDaysAfterToday",
	    // onChange: true,
	    onBlur: true,
	    onAdvance: true,
	    props: getProps({
	      maxAfterToday: { type: "number", value: 0, label: "Max Days After Today" }
	    })
	  },
	  enforceMaxMonthsBeforeToday: {
	    name: "Enforce max months before today",
	    fn: "enforceMaxMonthsBeforeToday",
	    // onChange: true,
	    onBlur: true,
	    onAdvance: true,
	    props: getProps({
	      maxBeforeToday: {
	        type: "number",
	        value: 0,
	        label: "Max Months Before Today"
	      }
	    })
	  },
	  enforceMaxMonthsAfterToday: {
	    name: "Enforce max months after today",
	    fn: "enforceMaxMonthsAfterToday",
	    // onChange: true,
	    onBlur: true,
	    onAdvance: true,
	    props: getProps({
	      maxAfterToday: { type: "number", value: 0, label: "Max Months After Today" }
	    })
	  },
	  enforceMinDaysBeforeToday: {
	    name: "Enforce min days before today",
	    fn: "enforceMinDaysBeforeToday",
	    // onChange: true,
	    onBlur: true,
	    onAdvance: true,
	    props: getProps({
	      minBeforeToday: {
	        type: "number",
	        value: 0,
	        label: "Min Days Before Today"
	      }
	    })
	  },
	  enforceMinDaysAfterToday: {
	    name: "Enforce min days after today",
	    fn: "enforceMinDaysAfterToday",
	    // onChange: true,
	    onBlur: true,
	    onAdvance: true,
	    props: getProps({
	      minAfterToday: { type: "number", value: 0, label: "Min Days After Today" }
	    })
	  },
	  enforceMinMonthsBeforeToday: {
	    name: "Enforce min months before today",
	    fn: "enforceMinMonthsBeforeToday",
	    // onChange: true,
	    onBlur: true,
	    onAdvance: true,
	    props: getProps({
	      minBeforeToday: {
	        type: "number",
	        value: 0,
	        label: "Min Months Before Today"
	      }
	    })
	  },
	  enforceMinMonthsAfterToday: {
	    name: "Enforce min months after today",
	    fn: "enforceMinMonthsAfterToday",
	    // onChange: true,
	    onBlur: true,
	    onAdvance: true,
	    props: getProps({
	      minAfterToday: { type: "number", value: 0, label: "Min Months After Today" }
	    })
	  },
	  enforceSignatureDateRange: {
	    name: "Enforce max date range for signatures",
	    fn: "enforceSignatureDateRange",
	    // onChange: true,
	    onBlur: true,
	    onAdvance: true,
	    props: getProps({
	      maxAfterToday: {
	        type: "number",
	        value: 0,
	        label: "Max Days After Today"
	      },
	      maxBeforeToday: {
	        type: "number",
	        value: 0,
	        label: "Max Days Before Today"
	      }
	    })
	  },
	  dateRangeRequired: {
	    name: 'Date Range Required',
	    fn: 'dateRangeRequired',
	    onAdvance: true,
	    props: getProps()
	  },
	  minDate: {
	    name: "Minimum date",
	    fn: "minDate",
	    onBlur: true,
	    onAdvance: true,
	    props: getProps({
	      minDateOptions: {
	        type: "genericServerOptions",
	        value: "custom",
	        label: "Minimum date source",
	        staticOptions: [{ value: "custom", label: "Custom" }],
	        getOptionsFunction: getDateOptions
	      },
	      customMinDate: {
	        type: "date",
	        value: null,
	        label: "Custom minimum date",
	        getOptionsFunction: getDateOptions
	      }
	    })
	  },
	  maxDate: {
	    name: "Maximum date",
	    fn: "maxDate",
	    onAdvance: true,
	    props: getProps({
	      maxDateOptions: {
	        type: "genericServerOptions",
	        value: "custom",
	        label: "Maximum date source",
	        staticOptions: [{ value: "custom", label: "Custom" }]
	      },
	      customMaxDate: {
	        type: "date",
	        value: null,
	        label: "Custom maximum date"
	      }
	    })
	  },
	  minDateRange: {
	    name: "Minimum date",
	    fn: "minDateRange",
	    onAdvance: true,
	    props: getProps({
	      minDateOptions: {
	        type: "genericServerOptions",
	        value: "custom",
	        label: "Minimum date source",
	        staticOptions: [{ value: "custom", label: "Custom" }],
	        getOptionsFunction: getDateOptions
	      },
	      customMinDate: {
	        type: "date",
	        value: null,
	        label: "Custom minimum date",
	        getOptionsFunction: getDateOptions
	      }
	    })
	  },
	  maxDateRange: {
	    name: "Maximum date",
	    fn: "maxDateRange",
	    onAdvance: true,
	    props: getProps({
	      minDateOptions: {
	        type: "genericServerOptions",
	        value: "custom",
	        label: "Maximum date source",
	        staticOptions: [{ value: "custom", label: "Custom" }]
	      },
	      customMaxDate: {
	        type: "date",
	        value: null,
	        label: "Custom maximum date"
	      }
	    })
	  },
	  validZipCode: {
	    name: "Must be a correctly formatted Postal code",
	    fn: "validZipCode",
	    onBlur: true,
	    onAdvance: true,
	    props: getProps()
	  },
	  validAddressZipCode: {
	    name: "Must be a correctly formatted Postal code",
	    fn: "validAddressZipCode",
	    onAdvance: true,
	    props: getProps()
	  },
	  props: getProps({
	    maxAfterToday: { type: "number", value: 0, label: "Max Days After Today" }
	  }),
	  validSocial: {
	    name: "Must be a correctly formatted social security number",
	    fn: "validSocial",
	    onBlur: true,
	    onAdvance: true,
	    props: getProps()
	  },
	  enforceUploadPlaceholderRules: {
	    name: "Enforce Upload Placeholder Rules",
	    fn: "enforceUploadPlaceholderRules",
	    onAdvance: true,
	    props: {}
	  },
	  uploadRequired: {
	    name: "Upload is required",
	    fn: "uploadRequired",
	    deferred: true,
	    props: {}
	  },
	  uploadImmediatelyRequired: {
	    name: "Upload is required",
	    fn: "uploadImmediatelyRequired",
	    onAdvance: true,
	    onBlur: true,
	    props: {}
	  },
	  allSignaturesRequired: {
	    name: "All signatures are required",
	    fn: "allSignaturesRequired",
	    onAdvance: true,
	    props: getProps()
	  },
	  minRequiredSignatures: {
	    name: "A minimum number of signatures are required",
	    fn: "minRequiredSignatures",
	    onAdvance: true,
	    props: getProps({
	      minRequiredSignatures: {
	        type: "number",
	        value: 1,
	        label: "Minimum Required Signatures"
	      }
	    })
	  },
	  signaturesMinLength: {
	    name: "A minimum number of characters for signatures and behalf of are required",
	    fn: "signaturesMinLength",
	    onAdvance: true,
	    props: getProps({
	      signaturesMinLength: {
	        type: "number",
	        value: 3,
	        label: "Minimum length of signatures"
	      }
	    })
	  },
	  formationLocaleRequired: {
	    name: "Formation locale is required",
	    fn: "formationLocaleRequired",
	    onAdvance: true,
	    props: getProps()
	  },
	  validateEntityNameFields: {
	    name: "Validate Entity Name Fields",
	    fn: "validateEntityNameFields",
	    onAdvance: true,
	    onBlur: true,
	    props: {
	      mustSelectReservedName: {
	        type: "checkbox",
	        value: true,
	        label: "If filing with a reserved name, a name must be selected."
	      },
	      entityNameRequired: {
	        type: "checkbox",
	        value: true,
	        onBlur: true,
	        label: "If not using a reserved name, entity name is required."
	      },
	      mustSelectAdditionalName: {
	        type: "checkbox",
	        value: true,
	        label: "If filing Trade/Fictitious name, a name must be selected."
	      },
	      numConsentsRequired: {
	        type: "checkbox",
	        value: true,
	        label: "If consent required, must provide number of consents."
	      },
	      disableNameNotTakenCheck: {
	        type: "checkbox",
	        value: false,
	        label: "Disable name uniqueness check"
	      },
	      filingTypeId: {
	        type: "fieldSrc",
	        value: "",
	        label: "Override FILING_TYPE_ID with value from field:",
	        emptyOptionLabel: "[Use default FILING_TYPE_ID]"
	      },
	      filingSubtypeId: {
	        type: "fieldSrc",
	        value: "",
	        label: "Override FILING_SUBTYPE_ID with value from field:",
	        emptyOptionLabel: "[Use default FILING_SUBTYPE_ID (0)]"
	      }
	    }
	  },
	  poBoxNotAllowed: {
	    name: "PO Box Not Allowed",
	    fn: "poBoxNotAllowed",
	    onAdvance: true,
	    props: getProps()
	  },
	  isValidName: {
	    name: "Must be a valid entity name",
	    fn: "isValidName",
	    onAdvance: true,
	    onBlur: true,
	    props: getProps({
	      filingTypeId: {
	        type: "fieldSrc",
	        value: "",
	        label: "Override FILING_TYPE_ID with value from field:",
	        emptyOptionLabel: "[Use default FILING_TYPE_ID]"
	      },
	      filingSubtypeId: {
	        type: "fieldSrc",
	        value: "",
	        label: "Override FILING_SUBTYPE_ID with value from field:",
	        emptyOptionLabel: "[Use default FILING_SUBTYPE_ID]"
	      }
	    })
	  },
	  mailingAddressIsRequired: {
	    name: "Full mailing address is required",
	    fn: "mailingAddressIsRequired",
	    onAdvance: true,
	    props: getProps()
	  },
	  mailingAddressIsValid: {
	    name: "Mailing address must be a valid USPS address if add new agent",
	    fn: "mailingAddressIsValid",
	    onAdvance: true,
	    props: getProps()
	  },
	  partialMailingAddressNotAllowed: {
	    name: "Partial mailing addresses are not allowed",
	    description: "This rule has the effect of disallowing a partially completed address, but will allow an empty address. Cannot be used with AMS address validation rules.",
	    fn: "partialMailingAddressNotAllowed",
	    onAdvance: true,
	    props: getProps()
	  },
	  mailingPoBoxNotAllowed: {
	    name: "Mailing address PO Box not allowed",
	    fn: "mailingPoBoxNotAllowed",
	    onAdvance: true,
	    props: getProps()
	  },
	  repeaterColumnsMustBeUnique: {
	    name: "Repeater values must be unique",
	    fn: 'repeaterColumnsMustBeUnique',
	    onAdvance: true,
	    props: {
	      constraints: {
	        type: 'constraints',
	        value: []
	      }
	    }
	  },
	  isValidEmailFormat: {
	    name: "Must be a correctly formatted email address",
	    fn: "isValidEmailFormat",
	    onBlur: true,
	    onAdvance: true,
	    props: getProps()
	  },
	  timeRequired: {
	    name: "Time is required",
	    fn: 'timeRequired',
	    onBlur: true,
	    onAdvance: true,
	    props: getProps()
	  },
	  uccSearchRequired: {
	    fn: 'uccSearchRequired',
	    name: 'UCC search is required',
	    onAdvance: true,
	    props: {}
	  },
	  atLeastOneUccSearchResultIsRequired: {
	    fn: 'atLeastOneUccSearchResultIsRequired',
	    name: 'At least one search result is required',
	    onAdvance: true,
	    props: getProps({
	      onlyAppliesToFileNumber: {
	        type: 'checkbox',
	        label: 'Only applies to File Number search',
	        value: false
	      },
	      onlyRequireWhenExists: {
	        type: 'checkbox',
	        label: 'Only require when results exist',
	        value: false
	      }
	    })
	  },
	  mustSelectLocalSelect: {
	    fn: 'mustSelectLocalSelect',
	    name: 'Must select an option',
	    onAdvance: true,
	    onBlur: true,
	    props: getProps()
	  },
	  enforceRepeaterChildConstraints: {
	    fn: 'enforceRepeaterChildConstraints',
	    name: "Enforce column constraints",
	    onAdvance: true,
	    props: {}
	  },
	  minMultiComplete: {
	    fn: 'minMultiComplete',
	    name: 'A minimum number of selections is required',
	    onAdvance: true,
	    props: getProps({
	      min: {
	        type: 'range',
	        value: 1,
	        minValue: 1,
	        maxValue: 50,
	        step: 1
	      }
	    })
	  },
	  efsRequired: {
	    fn: 'efsRequired',
	    name: 'Must provide crop years',
	    onAdvance: true,
	    props: {
	      errorMessage: { type: "text", value: "", label: "Crop years error message" },
	      durationErrorMessage: { type: "text", value: "", label: "Specified year through duration error message" },
	      arbitraryErrorMessage: { type: "text", value: "", label: "Specified years error message" }
	    }
	  },
	  mayOnlyAddAdditionalRows: {
	    fn: 'mayOnlyAddAdditionalRows',
	    name: 'May only add X additional rows',
	    onAdvance: true,
	    props: getProps({
	      numRows: { type: 'range', value: 1, step: 1, minValue: 1, maxValue: 100, label: 'Number of additional rows' }
	    })
	  },
	  mustHaveSameNumRowsAs: {
	    fn: 'mustHaveSameNumRowsAs',
	    name: 'Must have the same number of rows as another repeater',
	    onAdvance: true,
	    props: getProps({
	      repeater: {
	        type: 'fieldSrc',
	        emptyOptionLabel: '[Select a repeater]',
	        value: "",
	        label: "Select a repeater",
	        props: { excludeSelf: true, allowedTypes: ['repeater'] }
	      }
	    })
	  },
	  onlyNumbers: {
	    fn: 'onlyNumbers',
	    name: 'Only allow numbers',
	    onAdvance: true,
	    onBlur: true,
	    props: getProps({
	      allowCommas: {
	        type: 'checkbox',
	        value: false,
	        label: "Allow Commas"
	      }
	    })
	  },
	  maxCharacters: {
	    fn: 'maxCharacters',
	    name: 'Only allow a maximum number of characters',
	    onAdvance: true,
	    onBlur: true,
	    props: getProps({
	      maxCharacters: {
	        label: "Maximum number of characters",
	        type: 'number',
	        value: 100
	      }
	    })
	  },
	  minCharacters: {
	    fn: 'minCharacters',
	    name: 'Require a minimum number of characters',
	    onAdvance: true,
	    onBlur: true,
	    props: getProps({
	      minCharacters: {
	        label: "Minimum number of characters",
	        type: 'number',
	        value: 100
	      }
	    })
	  },
	  minRepeaterEdit: {
	    fn: 'minRepeaterEdit',
	    name: 'Must edit at least X rows',
	    onAdvance: true,
	    props: getProps({
	      minRows: {
	        label: "Minimum number of edited rows",
	        type: 'number',
	        value: 1
	      }
	    })
	  },
	  minRepeaterDelete: {
	    fn: 'minRepeaterDelete',
	    name: 'Must delete at least X rows',
	    onAdvance: true,
	    props: getProps({
	      minRows: {
	        label: "Minimum number of deleted rows",
	        type: 'number',
	        value: 1
	      },
	      disableIfOne: {
	        label: "Disable this rule if only 1 row.",
	        type: "checkbox",
	        value: false
	      }
	    })
	  },
	  checkForRegulatedWords: {
	    fn: 'checkForRegulatedWords',
	    name: "Check for regulated words",
	    onAdvance: true,
	    props: getProps({
	      regulatedWordLists: {
	        label: "Select which word lists to check against for regulated words.",
	        type: 'regulatedWords',
	        value: []
	      }
	    })
	  },
	  customBusinessRules: {
	    fn: 'customBusinessRules',
	    name: "Custom business rules",
	    onAdvance: true,
	    props: {
	      rules: {
	        type: "customBusinessRules",
	        value: [],
	        allowCurrentRepeaterFields: false,
	        allowCurrentField: true
	      }
	    }
	  }
	};

/***/ },
/* 199 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getUploadsFromFields = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(7);
	
	var _utilities = __webpack_require__(8);
	
	var _FileUpload = __webpack_require__(473);
	
	var _FileUpload2 = _interopRequireDefault(_FileUpload);
	
	var _Field = __webpack_require__(25);
	
	var _orderBy = __webpack_require__(103);
	
	var _orderBy2 = _interopRequireDefault(_orderBy);
	
	var _store = __webpack_require__(18);
	
	var _store2 = _interopRequireDefault(_store);
	
	var _WizardActions = __webpack_require__(36);
	
	var _wizardUtilities = __webpack_require__(52);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	// import ReactMarkdown from 'components/Markdown/Markdown'
	
	
	var UploadAccumulator = function (_Component) {
	  _inherits(UploadAccumulator, _Component);
	
	  function UploadAccumulator() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, UploadAccumulator);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = UploadAccumulator.__proto__ || Object.getPrototypeOf(UploadAccumulator)).call.apply(_ref, [this].concat(args))), _this), _this.componentDidMount = function () {
	      if (!_this.props.viewOnly) _this.calculateQueue();
	    }, _this.componentDidUpdate = function (prevProps) {
	      if (!_this.props.viewOnly) {
	        if (_this.getCurrentQueueFromValueObject(_this.props.value).length > _this.getCurrentQueueFromValueObject(prevProps.value).length) {
	          _this.calculateQueue();
	        }
	      }
	    }, _this.calculateQueue = function () {
	      var uploadQueue = _this.getCurrentQueueFromValueObject(_this.props.value);
	      var numPending = _this.getNumByStatus(uploadQueue, 'pending');
	
	      if (!_this.props.uploading && numPending > 0) {
	        _this.props.setUploading(true);
	        _this.startQueue(uploadQueue);
	      }
	    }, _this.getNumByStatus = function (queue, status) {
	      return queue.reduce(function (num, file) {
	        return file.status === status ? num + 1 : num;
	      }, 0);
	    }, _this.startQueue = function (queue) {
	      queue = queue.filter(function (file) {
	        return file.status === 'pending';
	      }).slice(0, 6);
	
	      queue.forEach(function (fileObj) {
	        _this.props.onChange(_this.getUploadGroupByFieldId(fileObj.fieldId, fileObj.queueId, { status: 'uploading' }));
	      });
	      queue.forEach(function (fileObj) {
	        _this.startFileUpload(fileObj);
	      });
	    }, _this.startFileUpload = function (fileObj) {
	      // console.log("%c Started uploading: " + fileObj.file.name, 'background: rgb(0, 140, 255); padding: 2px; border-radius: 3px;')
	      _this.props.onChange(_this.getUploadGroupByFieldId(fileObj.fieldId, fileObj.queueId, { status: 'uploading' }));
	      (0, _FileUpload.uploadFile)(fileObj.file, { IMAGE_DATA_TYPE_ID: fileObj.imageTypeId, SORT_ORDER: fileObj.sortOrder }, function (e) {
	        if (e.lengthComputable) {
	          var progress = e.loaded / e.total * 100;
	          _this.props.onChange(_this.getUploadGroupByFieldId(fileObj.fieldId, fileObj.queueId, { progress: progress }));
	          // console.log("%c Successfully uploaded: " + fileObj.file.name, 'background: rgb(102, 213, 63); padding: 2px; border-radius: 3px;')
	        }
	      }, fileObj).then(function (guid) {
	        _this.props.onChange(_this.getUploadGroupByFieldId(fileObj.fieldId, fileObj.queueId, { status: 'success', guid: guid }));
	        _this.checkForAndRunNextItemInQueue();
	      }).catch(function (err) {
	        console.log("Got error: ", err);
	        _this.props.onChange(_this.getUploadGroupByFieldId(fileObj.fieldId, fileObj.queueId, { status: 'failed' }));
	        _this.checkForAndRunNextItemInQueue();
	      });
	    }, _this.checkForAndRunNextItemInQueue = function () {
	      var queue = _this.getCurrentQueueFromValueObject(getFreshValueFromStoreByParent(_this.props.parent, _this.props.fieldId));
	      var numPending = _this.getNumByStatus(queue, 'pending');
	      if (numPending > 0) {
	        _this.startFileUpload(_this.getNextItemInQueue(queue));
	      } else {
	        _this.props.setUploading(false);
	      }
	    }, _this.getNextItemInQueue = function (queue) {
	      return queue.find(function (file) {
	        return file.status === 'pending';
	      });
	    }, _this.getUploadGroupByFieldId = function (fieldId, queueId) {
	      var payload = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	
	      var freshValue = getFreshValueFromStoreByParent(_this.props.parent, _this.props.fieldId);
	      var fileIndex = freshValue[fieldId].findIndex(function (file) {
	        return file.queueId === queueId;
	      });
	      var file = Object.assign({}, freshValue[fieldId][fileIndex], payload);
	      var files = [].concat(_toConsumableArray(freshValue[fieldId].slice(0, fileIndex)), [file], _toConsumableArray(freshValue[fieldId].slice(fileIndex + 1)));
	      return Object.assign({}, freshValue, _defineProperty({}, fieldId, files));
	    }, _this.collectUpload = function (value, e) {
	      var fieldId = e.target.name;
	      _this.props.onChange(Object.assign({}, _this.props.value, _defineProperty({}, fieldId, value)), {});
	    }, _this.getFreshQueue = function () {
	      return _this.getCurrentQueueFromValueObject(getFreshValueFromStoreByParent(_this.props.parent, _this.props.fieldId));
	    }, _this.getCurrentQueueFromValueObject = function (value) {
	      var queue = Object.keys(value).reduce(function (array, fieldId) {
	        return [].concat(_toConsumableArray(array), _toConsumableArray(value[fieldId]));
	      }, []);
	      return (0, _orderBy2.default)(queue, ['queuePosition'], ['asc']);
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	  //Checks if the number of uploads has changed, and calculates a fresh queue if they have.
	
	  //Calculates a fresh queue and decides if the queue needs to start an upload session.
	
	  //Takes in a queue and a status and returns the number of files with the given status.
	
	  //Takes in a queue array, sets each file status to "uploading", and starts each upload.
	
	  //Takes in a file object and starts an upload.
	
	  //Gets a fresh queue, and checks if there's still files to upload. Starts the next item otherwise it closes the upload session.
	
	  //Returns the first item in the queue array with status, "pending"
	
	  //Takes in a fieldId, a queueId, and a payload object to be spread into the file with the given queueId, and returns the full value object.
	
	  //Updates the value object in the store with uploads from a FileUpload component.
	
	  //Returns a freshly constructed and sorted queue by getting the fresh value from the store.
	
	  //Takes in a value object and returns a sorted queue.
	
	
	  _createClass(UploadAccumulator, [{
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _props = this.props,
	          uploads = _props.uploads,
	          viewOnly = _props.viewOnly,
	          _props$value = _props.value,
	          value = _props$value === undefined ? {} : _props$value,
	          errorMessage = _props.errorMessage,
	          disabled = _props.disabled;
	
	      var errors = errorMessage ? errorMessage[0] : false;
	      return _react2.default.createElement(
	        'div',
	        null,
	        viewOnly ? _react2.default.createElement(
	          'div',
	          { className: 'block-wrapper' },
	          uploads.map(function (upload) {
	            return _react2.default.createElement(
	              'div',
	              { className: 'field', key: upload.fieldId },
	              _react2.default.createElement(
	                'span',
	                { className: 'field-label' },
	                upload.label
	              )
	            );
	          })
	        ) : _react2.default.createElement(
	          'div',
	          { className: 'block-wrapper' },
	          uploads.map(function (upload) {
	            return _react2.default.createElement(
	              _Field.DumbField,
	              Object.assign({}, upload, {
	                errorMessage: errors && errors[upload.fieldId] ? errors[upload.fieldId].errors : [],
	                isValid: errors && errors[upload.fieldId] ? errors[upload.fieldId].isValid : null,
	                description: ' ',
	                key: upload.fieldId
	              }),
	              _react2.default.createElement(_FileUpload2.default, Object.assign({}, upload, {
	                value: value[upload.fieldId],
	                onChange: _this2.collectUpload,
	                parent: { id: _this2.props.fieldId, type: 'UploadAccumulator' },
	                key: upload.fieldId,
	                disabled: disabled
	              }))
	            );
	          })
	        )
	      );
	    }
	  }]);
	
	  return UploadAccumulator;
	}(_react.Component);
	
	exports.default = (0, _reactRedux.connect)(function (state) {
	  return {
	    uploads: getUploadsFromFields(state.wizard.wizard.fields),
	    fields: state.wizard.wizard.fields,
	    uploading: state.wizard.uploading
	  };
	}, { setUploading: _WizardActions.setUploading })(UploadAccumulator);
	
	//Takes in the current fields object, and returns a filtered array of uploadPlaceholder fields.
	
	var getUploadsFromFields = exports.getUploadsFromFields = function getUploadsFromFields(fields) {
	  //Convert fields object to an array
	  var fieldsArray = Object.keys(fields).map(function (fieldId) {
	    return fields[fieldId];
	  });
	  //Filter out everything except upload placeholder that have satisified their conditions.
	  var uploadFields = fieldsArray.filter(function (field) {
	    return field.type === 'UploadPlaceholder' && field.active && (0, _wizardUtilities.resolveFieldConditions)(field.conditions, fields, field.conditionsOperator);
	  });
	  //Filter out dependent upload placeholders that aren't visible.
	  var filteredFields = uploadFields.filter(function (field) {
	    switch (field.parent.type.toUpperCase()) {
	      case 'SECTION':
	        return true;
	      case 'OPTION':
	        {
	          var parentField = fields[field.parent.id];
	          var selectedOption = (0, _utilities.getSelectedOptionFromField)(parentField, null);
	          if (selectedOption) {
	            var selectedOptionHasUploadPlaceholder = selectedOption.fields.find(function (fieldId) {
	              return fieldId === field.fieldId;
	            });
	            if (selectedOptionHasUploadPlaceholder) return true;else return false;
	          } else return false;
	        }
	      case 'CHECKBOX':
	        {
	          var _parentField = fields[field.parent.id];
	          var currentCheckboxValueFields = _parentField.value === true ? _parentField.checkedFields : _parentField.uncheckedFields;
	          var currentCheckStateHasUploadPlaceholder = currentCheckboxValueFields.find(function (fieldId) {
	            return fieldId === field.fieldId;
	          });
	          if (currentCheckStateHasUploadPlaceholder) return true;
	          return false;
	        }
	      case 'REPEATER':
	        {
	          var _parentField2 = fields[field.parent.id];
	          return _parentField2.active && (0, _wizardUtilities.resolveFieldConditions)(_parentField2.conditions, fields, _parentField2.conditionsOperator);
	        }
	      default:
	        return false;
	    }
	  });
	  //Find all upload placeholders that are children of repeaters.
	  var placeholdersInRepeaters = uploadFields.filter(function (field) {
	    return field.parent.type.toUpperCase() === 'REPEATER';
	  });
	  //Loop through each row of the parent repeater and return an array of dummy upload placeholders
	  var calculatedRepeaterPlaceholders = placeholdersInRepeaters.reduce(function (calculated, placeholder, i) {
	    var parent = fields[placeholder.parent.id];
	    return [].concat(_toConsumableArray(calculated), _toConsumableArray(parent.value.map(function (row, k) {
	      return Object.assign({}, placeholder, {
	        label: placeholder.label + ' for row number ' + (k + 1),
	        name: placeholder.name + row._rowId,
	        fieldId: placeholder.fieldId + row._rowId
	      });
	    })));
	  }, []);
	  //Combine the repeater placeholders with all the other placeholders
	  var combinedFields = [].concat(_toConsumableArray(filteredFields), _toConsumableArray(calculatedRepeaterPlaceholders));
	  return combinedFields;
	};
	
	var getFreshValueFromStoreByParent = function getFreshValueFromStoreByParent(parent, ownFieldId) {
	  if (parent.type === 'UploadAndSubmit') {
	    return _store2.default.getState().wizard.wizard.fields[parent.id].value.files;
	  } else {
	    return _store2.default.getState().wizard.wizard.fields[ownFieldId].value;
	  }
	};

/***/ },
/* 200 */
/***/ function(module, exports) {

	'use strict'
	
	module.exports = decimal
	
	// Check if the given character code, or the character code at the first
	// character, is decimal.
	function decimal(character) {
	  var code = typeof character === 'string' ? character.charCodeAt(0) : character
	
	  return code >= 48 && code <= 57 /* 0-9 */
	}


/***/ },
/* 201 */
/***/ function(module, exports, __webpack_require__) {

	var listCacheClear = __webpack_require__(1239),
	    listCacheDelete = __webpack_require__(1240),
	    listCacheGet = __webpack_require__(1241),
	    listCacheHas = __webpack_require__(1242),
	    listCacheSet = __webpack_require__(1243);
	
	/**
	 * Creates an list cache object.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function ListCache(entries) {
	  var index = -1,
	      length = entries == null ? 0 : entries.length;
	
	  this.clear();
	  while (++index < length) {
	    var entry = entries[index];
	    this.set(entry[0], entry[1]);
	  }
	}
	
	// Add methods to `ListCache`.
	ListCache.prototype.clear = listCacheClear;
	ListCache.prototype['delete'] = listCacheDelete;
	ListCache.prototype.get = listCacheGet;
	ListCache.prototype.has = listCacheHas;
	ListCache.prototype.set = listCacheSet;
	
	module.exports = ListCache;


/***/ },
/* 202 */
/***/ function(module, exports, __webpack_require__) {

	var root = __webpack_require__(69);
	
	/** Built-in value references. */
	var Symbol = root.Symbol;
	
	module.exports = Symbol;


/***/ },
/* 203 */
/***/ function(module, exports, __webpack_require__) {

	var eq = __webpack_require__(496);
	
	/**
	 * Gets the index at which the `key` is found in `array` of key-value pairs.
	 *
	 * @private
	 * @param {Array} array The array to inspect.
	 * @param {*} key The key to search for.
	 * @returns {number} Returns the index of the matched value, else `-1`.
	 */
	function assocIndexOf(array, key) {
	  var length = array.length;
	  while (length--) {
	    if (eq(array[length][0], key)) {
	      return length;
	    }
	  }
	  return -1;
	}
	
	module.exports = assocIndexOf;


/***/ },
/* 204 */
/***/ function(module, exports, __webpack_require__) {

	var isKeyable = __webpack_require__(1236);
	
	/**
	 * Gets the data for `map`.
	 *
	 * @private
	 * @param {Object} map The map to query.
	 * @param {string} key The reference key.
	 * @returns {*} Returns the map data.
	 */
	function getMapData(map, key) {
	  var data = map.__data__;
	  return isKeyable(key)
	    ? data[typeof key == 'string' ? 'string' : 'hash']
	    : data.map;
	}
	
	module.exports = getMapData;


/***/ },
/* 205 */
/***/ function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__(122);
	
	/* Built-in method references that are verified to be native. */
	var nativeCreate = getNative(Object, 'create');
	
	module.exports = nativeCreate;


/***/ },
/* 206 */
/***/ function(module, exports, __webpack_require__) {

	var isSymbol = __webpack_require__(152);
	
	/** Used as references for various `Number` constants. */
	var INFINITY = 1 / 0;
	
	/**
	 * Converts `value` to a string key if it's not a string or symbol.
	 *
	 * @private
	 * @param {*} value The value to inspect.
	 * @returns {string|symbol} Returns the key.
	 */
	function toKey(value) {
	  if (typeof value == 'string' || isSymbol(value)) {
	    return value;
	  }
	  var result = (value + '');
	  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
	}
	
	module.exports = toKey;


/***/ },
/* 207 */
/***/ function(module, exports) {

	/*
	object-assign
	(c) Sindre Sorhus
	@license MIT
	*/
	
	'use strict';
	/* eslint-disable no-unused-vars */
	var getOwnPropertySymbols = Object.getOwnPropertySymbols;
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	var propIsEnumerable = Object.prototype.propertyIsEnumerable;
	
	function toObject(val) {
		if (val === null || val === undefined) {
			throw new TypeError('Object.assign cannot be called with null or undefined');
		}
	
		return Object(val);
	}
	
	function shouldUseNative() {
		try {
			if (!Object.assign) {
				return false;
			}
	
			// Detect buggy property enumeration order in older V8 versions.
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=4118
			var test1 = new String('abc');  // eslint-disable-line no-new-wrappers
			test1[5] = 'de';
			if (Object.getOwnPropertyNames(test1)[0] === '5') {
				return false;
			}
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=3056
			var test2 = {};
			for (var i = 0; i < 10; i++) {
				test2['_' + String.fromCharCode(i)] = i;
			}
			var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
				return test2[n];
			});
			if (order2.join('') !== '0123456789') {
				return false;
			}
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=3056
			var test3 = {};
			'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
				test3[letter] = letter;
			});
			if (Object.keys(Object.assign({}, test3)).join('') !==
					'abcdefghijklmnopqrst') {
				return false;
			}
	
			return true;
		} catch (err) {
			// We don't expect any of the above to throw, but better to be safe.
			return false;
		}
	}
	
	module.exports = shouldUseNative() ? Object.assign : function (target, source) {
		var from;
		var to = toObject(target);
		var symbols;
	
		for (var s = 1; s < arguments.length; s++) {
			from = Object(arguments[s]);
	
			for (var key in from) {
				if (hasOwnProperty.call(from, key)) {
					to[key] = from[key];
				}
			}
	
			if (getOwnPropertySymbols) {
				symbols = getOwnPropertySymbols(from);
				for (var i = 0; i < symbols.length; i++) {
					if (propIsEnumerable.call(from, symbols[i])) {
						to[symbols[i]] = from[symbols[i]];
					}
				}
			}
		}
	
		return to;
	};


/***/ },
/* 208 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {'use strict';
	
	if (typeof process === 'undefined' ||
	    !process.version ||
	    process.version.indexOf('v0.') === 0 ||
	    process.version.indexOf('v1.') === 0 && process.version.indexOf('v1.8.') !== 0) {
	  module.exports = { nextTick: nextTick };
	} else {
	  module.exports = process
	}
	
	function nextTick(fn, arg1, arg2, arg3) {
	  if (typeof fn !== 'function') {
	    throw new TypeError('"callback" argument must be a function');
	  }
	  var len = arguments.length;
	  var args, i;
	  switch (len) {
	  case 0:
	  case 1:
	    return process.nextTick(fn);
	  case 2:
	    return process.nextTick(function afterTickOne() {
	      fn.call(null, arg1);
	    });
	  case 3:
	    return process.nextTick(function afterTickTwo() {
	      fn.call(null, arg1, arg2);
	    });
	  case 4:
	    return process.nextTick(function afterTickThree() {
	      fn.call(null, arg1, arg2, arg3);
	    });
	  default:
	    args = new Array(len - 1);
	    i = 0;
	    while (i < args.length) {
	      args[i++] = arguments[i];
	    }
	    return process.nextTick(function afterTick() {
	      fn.apply(null, args);
	    });
	  }
	}
	
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(77)))

/***/ },
/* 209 */
/***/ function(module, exports, __webpack_require__) {

	exports.__esModule = true;
	exports.Helmet = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(20);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactSideEffect = __webpack_require__(1344);
	
	var _reactSideEffect2 = _interopRequireDefault(_reactSideEffect);
	
	var _reactFastCompare = __webpack_require__(1293);
	
	var _reactFastCompare2 = _interopRequireDefault(_reactFastCompare);
	
	var _HelmetUtils = __webpack_require__(1294);
	
	var _HelmetConstants = __webpack_require__(508);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Helmet = function Helmet(Component) {
	    var _class, _temp;
	
	    return _temp = _class = function (_React$Component) {
	        _inherits(HelmetWrapper, _React$Component);
	
	        function HelmetWrapper() {
	            _classCallCheck(this, HelmetWrapper);
	
	            return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	        }
	
	        HelmetWrapper.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
	            return !(0, _reactFastCompare2.default)(this.props, nextProps);
	        };
	
	        HelmetWrapper.prototype.mapNestedChildrenToProps = function mapNestedChildrenToProps(child, nestedChildren) {
	            if (!nestedChildren) {
	                return null;
	            }
	
	            switch (child.type) {
	                case _HelmetConstants.TAG_NAMES.SCRIPT:
	                case _HelmetConstants.TAG_NAMES.NOSCRIPT:
	                    return {
	                        innerHTML: nestedChildren
	                    };
	
	                case _HelmetConstants.TAG_NAMES.STYLE:
	                    return {
	                        cssText: nestedChildren
	                    };
	            }
	
	            throw new Error("<" + child.type + " /> elements are self-closing and can not contain children. Refer to our API for more information.");
	        };
	
	        HelmetWrapper.prototype.flattenArrayTypeChildren = function flattenArrayTypeChildren(_ref) {
	            var _extends2;
	
	            var child = _ref.child,
	                arrayTypeChildren = _ref.arrayTypeChildren,
	                newChildProps = _ref.newChildProps,
	                nestedChildren = _ref.nestedChildren;
	
	            return _extends({}, arrayTypeChildren, (_extends2 = {}, _extends2[child.type] = [].concat(arrayTypeChildren[child.type] || [], [_extends({}, newChildProps, this.mapNestedChildrenToProps(child, nestedChildren))]), _extends2));
	        };
	
	        HelmetWrapper.prototype.mapObjectTypeChildren = function mapObjectTypeChildren(_ref2) {
	            var _extends3, _extends4;
	
	            var child = _ref2.child,
	                newProps = _ref2.newProps,
	                newChildProps = _ref2.newChildProps,
	                nestedChildren = _ref2.nestedChildren;
	
	            switch (child.type) {
	                case _HelmetConstants.TAG_NAMES.TITLE:
	                    return _extends({}, newProps, (_extends3 = {}, _extends3[child.type] = nestedChildren, _extends3.titleAttributes = _extends({}, newChildProps), _extends3));
	
	                case _HelmetConstants.TAG_NAMES.BODY:
	                    return _extends({}, newProps, {
	                        bodyAttributes: _extends({}, newChildProps)
	                    });
	
	                case _HelmetConstants.TAG_NAMES.HTML:
	                    return _extends({}, newProps, {
	                        htmlAttributes: _extends({}, newChildProps)
	                    });
	            }
	
	            return _extends({}, newProps, (_extends4 = {}, _extends4[child.type] = _extends({}, newChildProps), _extends4));
	        };
	
	        HelmetWrapper.prototype.mapArrayTypeChildrenToProps = function mapArrayTypeChildrenToProps(arrayTypeChildren, newProps) {
	            var newFlattenedProps = _extends({}, newProps);
	
	            Object.keys(arrayTypeChildren).forEach(function (arrayChildName) {
	                var _extends5;
	
	                newFlattenedProps = _extends({}, newFlattenedProps, (_extends5 = {}, _extends5[arrayChildName] = arrayTypeChildren[arrayChildName], _extends5));
	            });
	
	            return newFlattenedProps;
	        };
	
	        HelmetWrapper.prototype.warnOnInvalidChildren = function warnOnInvalidChildren(child, nestedChildren) {
	            if (false) {
	                if (!_HelmetConstants.VALID_TAG_NAMES.some(function (name) {
	                    return child.type === name;
	                })) {
	                    if (typeof child.type === "function") {
	                        return (0, _HelmetUtils.warn)("You may be attempting to nest <Helmet> components within each other, which is not allowed. Refer to our API for more information.");
	                    }
	
	                    return (0, _HelmetUtils.warn)("Only elements types " + _HelmetConstants.VALID_TAG_NAMES.join(", ") + " are allowed. Helmet does not support rendering <" + child.type + "> elements. Refer to our API for more information.");
	                }
	
	                if (nestedChildren && typeof nestedChildren !== "string" && (!Array.isArray(nestedChildren) || nestedChildren.some(function (nestedChild) {
	                    return typeof nestedChild !== "string";
	                }))) {
	                    throw new Error("Helmet expects a string as a child of <" + child.type + ">. Did you forget to wrap your children in braces? ( <" + child.type + ">{``}</" + child.type + "> ) Refer to our API for more information.");
	                }
	            }
	
	            return true;
	        };
	
	        HelmetWrapper.prototype.mapChildrenToProps = function mapChildrenToProps(children, newProps) {
	            var _this2 = this;
	
	            var arrayTypeChildren = {};
	
	            _react2.default.Children.forEach(children, function (child) {
	                if (!child || !child.props) {
	                    return;
	                }
	
	                var _child$props = child.props,
	                    nestedChildren = _child$props.children,
	                    childProps = _objectWithoutProperties(_child$props, ["children"]);
	
	                var newChildProps = (0, _HelmetUtils.convertReactPropstoHtmlAttributes)(childProps);
	
	                _this2.warnOnInvalidChildren(child, nestedChildren);
	
	                switch (child.type) {
	                    case _HelmetConstants.TAG_NAMES.LINK:
	                    case _HelmetConstants.TAG_NAMES.META:
	                    case _HelmetConstants.TAG_NAMES.NOSCRIPT:
	                    case _HelmetConstants.TAG_NAMES.SCRIPT:
	                    case _HelmetConstants.TAG_NAMES.STYLE:
	                        arrayTypeChildren = _this2.flattenArrayTypeChildren({
	                            child: child,
	                            arrayTypeChildren: arrayTypeChildren,
	                            newChildProps: newChildProps,
	                            nestedChildren: nestedChildren
	                        });
	                        break;
	
	                    default:
	                        newProps = _this2.mapObjectTypeChildren({
	                            child: child,
	                            newProps: newProps,
	                            newChildProps: newChildProps,
	                            nestedChildren: nestedChildren
	                        });
	                        break;
	                }
	            });
	
	            newProps = this.mapArrayTypeChildrenToProps(arrayTypeChildren, newProps);
	            return newProps;
	        };
	
	        HelmetWrapper.prototype.render = function render() {
	            var _props = this.props,
	                children = _props.children,
	                props = _objectWithoutProperties(_props, ["children"]);
	
	            var newProps = _extends({}, props);
	
	            if (children) {
	                newProps = this.mapChildrenToProps(children, newProps);
	            }
	
	            return _react2.default.createElement(Component, newProps);
	        };
	
	        _createClass(HelmetWrapper, null, [{
	            key: "canUseDOM",
	
	
	            // Component.peek comes from react-side-effect:
	            // For testing, you may use a static peek() method available on the returned component.
	            // It lets you get the current state without resetting the mounted instance stack.
	            // Don’t use it for anything other than testing.
	
	            /**
	             * @param {Object} base: {"target": "_blank", "href": "http://mysite.com/"}
	             * @param {Object} bodyAttributes: {"className": "root"}
	             * @param {String} defaultTitle: "Default Title"
	             * @param {Boolean} defer: true
	             * @param {Boolean} encodeSpecialCharacters: true
	             * @param {Object} htmlAttributes: {"lang": "en", "amp": undefined}
	             * @param {Array} link: [{"rel": "canonical", "href": "http://mysite.com/example"}]
	             * @param {Array} meta: [{"name": "description", "content": "Test description"}]
	             * @param {Array} noscript: [{"innerHTML": "<img src='http://mysite.com/js/test.js'"}]
	             * @param {Function} onChangeClientState: "(newState) => console.log(newState)"
	             * @param {Array} script: [{"type": "text/javascript", "src": "http://mysite.com/js/test.js"}]
	             * @param {Array} style: [{"type": "text/css", "cssText": "div { display: block; color: blue; }"}]
	             * @param {String} title: "Title"
	             * @param {Object} titleAttributes: {"itemprop": "name"}
	             * @param {String} titleTemplate: "MySite.com - %s"
	             */
	            set: function set(canUseDOM) {
	                Component.canUseDOM = canUseDOM;
	            }
	        }]);
	
	        return HelmetWrapper;
	    }(_react2.default.Component), _class.propTypes = {
	        base: _propTypes2.default.object,
	        bodyAttributes: _propTypes2.default.object,
	        children: _propTypes2.default.oneOfType([_propTypes2.default.arrayOf(_propTypes2.default.node), _propTypes2.default.node]),
	        defaultTitle: _propTypes2.default.string,
	        defer: _propTypes2.default.bool,
	        encodeSpecialCharacters: _propTypes2.default.bool,
	        htmlAttributes: _propTypes2.default.object,
	        link: _propTypes2.default.arrayOf(_propTypes2.default.object),
	        meta: _propTypes2.default.arrayOf(_propTypes2.default.object),
	        noscript: _propTypes2.default.arrayOf(_propTypes2.default.object),
	        onChangeClientState: _propTypes2.default.func,
	        script: _propTypes2.default.arrayOf(_propTypes2.default.object),
	        style: _propTypes2.default.arrayOf(_propTypes2.default.object),
	        title: _propTypes2.default.string,
	        titleAttributes: _propTypes2.default.object,
	        titleTemplate: _propTypes2.default.string
	    }, _class.defaultProps = {
	        defer: true,
	        encodeSpecialCharacters: true
	    }, _class.peek = Component.peek, _class.rewind = function () {
	        var mappedState = Component.rewind();
	        if (!mappedState) {
	            // provide fallback if mappedState is undefined
	            mappedState = (0, _HelmetUtils.mapStateOnServer)({
	                baseTag: [],
	                bodyAttributes: {},
	                encodeSpecialCharacters: true,
	                htmlAttributes: {},
	                linkTags: [],
	                metaTags: [],
	                noscriptTags: [],
	                scriptTags: [],
	                styleTags: [],
	                title: "",
	                titleAttributes: {}
	            });
	        }
	
	        return mappedState;
	    }, _temp;
	};
	
	var NullComponent = function NullComponent() {
	    return null;
	};
	
	var HelmetSideEffects = (0, _reactSideEffect2.default)(_HelmetUtils.reducePropsToState, _HelmetUtils.handleClientStateChange, _HelmetUtils.mapStateOnServer)(NullComponent);
	
	var HelmetExport = Helmet(HelmetSideEffects);
	HelmetExport.renderStatic = HelmetExport.rewind;
	
	exports.Helmet = HelmetExport;
	exports.default = HelmetExport;

/***/ },
/* 210 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _captialize = __webpack_require__(1304);
	
	Object.defineProperty(exports, 'captialize', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_captialize).default;
	  }
	});
	
	var _clamp = __webpack_require__(1305);
	
	Object.defineProperty(exports, 'clamp', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_clamp).default;
	  }
	});
	
	var _distanceTo = __webpack_require__(1306);
	
	Object.defineProperty(exports, 'distanceTo', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_distanceTo).default;
	  }
	});
	
	var _isDefined = __webpack_require__(1307);
	
	Object.defineProperty(exports, 'isDefined', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_isDefined).default;
	  }
	});
	
	var _isNumber = __webpack_require__(1308);
	
	Object.defineProperty(exports, 'isNumber', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_isNumber).default;
	  }
	});
	
	var _isObject = __webpack_require__(1309);
	
	Object.defineProperty(exports, 'isObject', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_isObject).default;
	  }
	});
	
	var _length = __webpack_require__(1310);
	
	Object.defineProperty(exports, 'length', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_length).default;
	  }
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	//# sourceMappingURL=index.js.map

/***/ },
/* 211 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	if (true) {
	  module.exports = __webpack_require__(1311);
	} else {
	  module.exports = require('./cjs/react-is.development.js');
	}


/***/ },
/* 212 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	if (true) {
	  module.exports = __webpack_require__(1342);
	} else {
	  module.exports = require("./cjs/react-router.js");
	}


/***/ },
/* 213 */
/***/ function(module, exports, __webpack_require__) {

	/* eslint-disable node/no-deprecated-api */
	var buffer = __webpack_require__(31)
	var Buffer = buffer.Buffer
	
	// alternative to using Object.keys for old browsers
	function copyProps (src, dst) {
	  for (var key in src) {
	    dst[key] = src[key]
	  }
	}
	if (Buffer.from && Buffer.alloc && Buffer.allocUnsafe && Buffer.allocUnsafeSlow) {
	  module.exports = buffer
	} else {
	  // Copy properties from require('buffer')
	  copyProps(buffer, exports)
	  exports.Buffer = SafeBuffer
	}
	
	function SafeBuffer (arg, encodingOrOffset, length) {
	  return Buffer(arg, encodingOrOffset, length)
	}
	
	// Copy static methods from Buffer
	copyProps(Buffer, SafeBuffer)
	
	SafeBuffer.from = function (arg, encodingOrOffset, length) {
	  if (typeof arg === 'number') {
	    throw new TypeError('Argument must not be a number')
	  }
	  return Buffer(arg, encodingOrOffset, length)
	}
	
	SafeBuffer.alloc = function (size, fill, encoding) {
	  if (typeof size !== 'number') {
	    throw new TypeError('Argument must be a number')
	  }
	  var buf = Buffer(size)
	  if (fill !== undefined) {
	    if (typeof encoding === 'string') {
	      buf.fill(fill, encoding)
	    } else {
	      buf.fill(fill)
	    }
	  } else {
	    buf.fill(0)
	  }
	  return buf
	}
	
	SafeBuffer.allocUnsafe = function (size) {
	  if (typeof size !== 'number') {
	    throw new TypeError('Argument must be a number')
	  }
	  return Buffer(size)
	}
	
	SafeBuffer.allocUnsafeSlow = function (size) {
	  if (typeof size !== 'number') {
	    throw new TypeError('Argument must be a number')
	  }
	  return buffer.SlowBuffer(size)
	}


/***/ },
/* 214 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var isProduction = ("production") === 'production';
	function warning(condition, message) {
	  if (!isProduction) {
	    if (condition) {
	      return;
	    }
	
	    var text = "Warning: " + message;
	
	    if (typeof console !== 'undefined') {
	      console.warn(text);
	    }
	
	    try {
	      throw Error(text);
	    } catch (x) {}
	  }
	}
	
	module.exports = warning;


/***/ },
/* 215 */
/***/ function(module, exports, __webpack_require__) {

	'use strict'
	
	module.exports = visit
	
	var visitParents = __webpack_require__(1489)
	
	var CONTINUE = visitParents.CONTINUE
	var SKIP = visitParents.SKIP
	var EXIT = visitParents.EXIT
	
	visit.CONTINUE = CONTINUE
	visit.SKIP = SKIP
	visit.EXIT = EXIT
	
	function visit(tree, test, visitor, reverse) {
	  if (typeof test === 'function' && typeof visitor !== 'function') {
	    reverse = visitor
	    visitor = test
	    test = null
	  }
	
	  visitParents(tree, test, overload, reverse)
	
	  function overload(node, parents) {
	    var parent = parents[parents.length - 1]
	    var index = parent ? parent.children.indexOf(node) : null
	    return visitor(node, index, parent)
	  }
	}


/***/ },
/* 216 */
/***/ function(module, exports, __webpack_require__) {

	var map = {
		"./CA/seal.png": 1499,
		"./CA/seal.svg": 1030,
		"./CA/seal_color.png": 1500,
		"./CA/seal_reversed.svg": 1031,
		"./CA/sos-logo.png": 1501,
		"./ID/seal.png": 1502,
		"./ID/seal.svg": 1032,
		"./ID/seal_color.png": 1503,
		"./ID/seal_reversed.svg": 1033,
		"./ID/sos-logo.png": 1504,
		"./MT/mt-sos-logo.png": 1505,
		"./MT/seal.png": 1506,
		"./MT/seal.svg": 1034,
		"./MT/seal_color.png": 1507,
		"./MT/seal_white.png": 1508,
		"./ND/seal.svg": 1035,
		"./SOS/seal.svg": 1036
	};
	function webpackContext(req) {
		return __webpack_require__(webpackContextResolve(req));
	};
	function webpackContextResolve(req) {
		return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
	};
	webpackContext.keys = function webpackContextKeys() {
		return Object.keys(map);
	};
	webpackContext.resolve = webpackContextResolve;
	module.exports = webpackContext;
	webpackContext.id = 216;


/***/ },
/* 217 */
/***/ function(module, exports) {

	function _assertThisInitialized(self) {
	  if (self === void 0) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }
	
	  return self;
	}
	
	module.exports = _assertThisInitialized;
	module.exports["default"] = module.exports, module.exports.__esModule = true;

/***/ },
/* 218 */
/***/ function(module, exports) {

	function _defineProperty(obj, key, value) {
	  if (key in obj) {
	    Object.defineProperty(obj, key, {
	      value: value,
	      enumerable: true,
	      configurable: true,
	      writable: true
	    });
	  } else {
	    obj[key] = value;
	  }
	
	  return obj;
	}
	
	module.exports = _defineProperty;
	module.exports["default"] = module.exports, module.exports.__esModule = true;

/***/ },
/* 219 */
/***/ function(module, exports, __webpack_require__) {

	Object.defineProperty(exports,"__esModule",{value:true});var _createIconComponent=__webpack_require__(328);var _createIconComponent2=_interopRequireDefault(_createIconComponent);var _react=__webpack_require__(1);var _react2=_interopRequireDefault(_react);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var IconDownloadBox=(0,_createIconComponent2.default)({content:_react2.default.createElement('g',null,_react2.default.createElement('path',{d:'M25.71 26.5a1.54 1.54 0 0 0 0 2.19l8.2 8.2a1.56 1.56 0 0 0 1.09.46 1.51 1.51 0 0 0 1.09-.46l8.2-8.2a1.55 1.55 0 1 0-2.19-2.19l-5.55 5.55V5.51a1.55 1.55 0 1 0-3.09 0v26.54L27.9 26.5a1.54 1.54 0 0 0-2.19 0zm0 0'}),_react2.default.createElement('path',{d:'M60.27 39.17L54.89 19.7a1.57 1.57 0 0 0-.85-1l-.15-.07a1.58 1.58 0 0 0-.64-.14h-9.7a1.55 1.55 0 0 0 0 3.09h8.66l4.55 16.47h-12a1.54 1.54 0 0 0-1.55 1.55V41a3.71 3.71 0 0 1-3.71 3.71H30A3.71 3.71 0 0 1 26.33 41v-1.4a1.54 1.54 0 0 0-1.55-1.55H13.23l4.57-16.5h8.66a1.55 1.55 0 0 0 0-3.09h-9.71a1.58 1.58 0 0 0-.64.14l-.15.07a1.53 1.53 0 0 0-.85 1L9.73 39.13a1.72 1.72 0 0 0-.06.41v8.12a11.17 11.17 0 0 0 11.15 11.16h28.36a11.17 11.17 0 0 0 11.15-11.16v-8.08a1.2 1.2 0 0 0-.06-.41zm-3 8.5a8.07 8.07 0 0 1-8.06 8.06H20.82a8.07 8.07 0 0 1-8.06-8.06v-6.52h10.5a6.81 6.81 0 0 0 6.8 6.64h9.44a6.81 6.81 0 0 0 6.8-6.64h11v6.52zm0 0'})),height:undefined,width:undefined});IconDownloadBox.displayName='IconDownloadBox';exports.default=IconDownloadBox;

/***/ },
/* 220 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _createIconComponent = _interopRequireDefault(__webpack_require__(5));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	var IconBankSolid = (0, _createIconComponent["default"])({
	  content: _react["default"].createElement("g", null, _react["default"].createElement("path", {
	    d: "M62.14 26.82a2.24 2.24 0 0 0 2.25-2.24V21a2.24 2.24 0 0 0-1.52-2.12l-24.32-8.32a11.06 11.06 0 0 0-7.1 0L7.13 18.84A2.24 2.24 0 0 0 5.61 21v3.62a2.24 2.24 0 0 0 2.25 2.24h2.84v23.32h-3a2.11 2.11 0 0 0-2.11 2.1v3.26a2.12 2.12 0 0 0 2.11 2.11h54.58a2.12 2.12 0 0 0 2.11-2.11v-3.26a2.11 2.11 0 0 0-2.11-2.1h-3V26.82zm-24.88 0v23.36h-4.52V26.82h4.52zm-17.8 0H24v23.36h-4.54zm31.08 23.36H46V26.82h4.52z"
	  })),
	  height: undefined,
	  width: undefined
	});
	IconBankSolid.displayName = 'IconBankSolid';
	var _default = IconBankSolid;
	exports["default"] = _default;

/***/ },
/* 221 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _createIconComponent = _interopRequireDefault(__webpack_require__(5));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	var IconCalendar = (0, _createIconComponent["default"])({
	  content: _react["default"].createElement("g", null, _react["default"].createElement("path", {
	    d: "M11.59 14.93a1.76 1.76 0 0 1 1.76-1.76h43.3a1.76 1.76 0 0 1 1.76 1.76v8.78H47.87V22a1.76 1.76 0 1 0-3.51 0v1.76H25.64V22a1.76 1.76 0 1 0-3.51 0v1.76H11.59v-8.83zM54.9 57.07a1.76 1.76 0 0 1-1.76 1.76H16.86a1.76 1.76 0 0 1-1.76-1.76V27.22h7V29a1.76 1.76 0 1 0 3.51 0v-1.78h18.75V29a1.76 1.76 0 1 0 3.51 0v-1.78h7v29.85zM9.84 27.22h1.76v29.85a5.27 5.27 0 0 0 5.27 5.27h36.27a5.27 5.27 0 0 0 5.27-5.27V27.22h1.76a1.76 1.76 0 0 0 1.76-1.76V14.93a5.27 5.27 0 0 0-5.27-5.27H13.35a5.27 5.27 0 0 0-5.27 5.27v10.54a1.76 1.76 0 0 0 1.76 1.76z"
	  }), _react["default"].createElement("path", {
	    d: "M46.12 37.76a1.76 1.76 0 1 0 0-3.51h-7A1.76 1.76 0 0 0 37.34 36v7a1.76 1.76 0 0 0 1.76 1.76h3.51a1.76 1.76 0 0 1 0 3.51H39.1a1.76 1.76 0 0 0 0 3.51h3.51a5.27 5.27 0 0 0 0-10.53h-1.76v-3.49zM28.33 46.26c1.83-1.15 4.33-2.72 4.33-6.75a5.27 5.27 0 0 0-10.53 0 1.76 1.76 0 0 0 3.51 0 1.76 1.76 0 1 1 3.51 0c0 2-.87 2.63-2.69 3.77S22.13 46 22.13 50a1.76 1.76 0 0 0 1.76 1.76h7a1.76 1.76 0 0 0 0-3.51H26a6 6 0 0 1 2.33-2z"
	  })),
	  height: undefined,
	  width: undefined
	});
	IconCalendar.displayName = 'IconCalendar';
	var _default = IconCalendar;
	exports["default"] = _default;

/***/ },
/* 222 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _createIconComponent = _interopRequireDefault(__webpack_require__(5));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	var IconCaretLeft = (0, _createIconComponent["default"])({
	  content: _react["default"].createElement("g", null, _react["default"].createElement("path", {
	    d: "M48.4 57.49a3.85 3.85 0 0 0 0-5.44l-17-17 17-17a3.85 3.85 0 0 0 0-5.45 3.85 3.85 0 0 0-5.45 0L20.46 35l22.48 22.5a3.85 3.85 0 0 0 5.46-.01z"
	  })),
	  height: undefined,
	  width: undefined
	});
	IconCaretLeft.displayName = 'IconCaretLeft';
	var _default = IconCaretLeft;
	exports["default"] = _default;

/***/ },
/* 223 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _createIconComponent = _interopRequireDefault(__webpack_require__(5));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	var IconCart = (0, _createIconComponent["default"])({
	  content: _react["default"].createElement("g", null, _react["default"].createElement("path", {
	    d: "M23.43 40.2h35.2L64.86 18H55.7L52.41 7.8l-13.73 4.45L40.56 18h-.65L36.52 7.8 22.8 12.25 24.68 18h-7.34l-1.52-6.09a6.76 6.76 0 0 0-6.48-5.2h-4.2v2.5h4.19a4.21 4.21 0 0 1 4.07 3.19l6.74 26.38a5.52 5.52 0 0 0-2.3 4.5 5.65 5.65 0 0 0 5.6 5.59h34.3v-2.55H23.43a3.06 3.06 0 0 1 0-6.12zM50.76 11l2.29 6.86h-9.91l-1.4-3.94zm-15.88 0l2.29 6.86h-9.91l-1.4-3.94zM18 20.38h43.56l-4.83 17.28H22.42zM46.57 52.66a5.34 5.34 0 0 0 0 10.68A5.29 5.29 0 0 0 51.91 58a5.37 5.37 0 0 0-5.34-5.34zm0 8.26a2.93 2.93 0 1 1 0-5.85A2.87 2.87 0 0 1 49.49 58a3 3 0 0 1-2.92 2.92zM27 52.66A5.34 5.34 0 1 0 32.33 58 5.37 5.37 0 0 0 27 52.66zm0 8.26A2.93 2.93 0 1 1 29.92 58 3 3 0 0 1 27 60.92z"
	  })),
	  height: undefined,
	  width: undefined
	});
	IconCart.displayName = 'IconCart';
	var _default = IconCart;
	exports["default"] = _default;

/***/ },
/* 224 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _createIconComponent = _interopRequireDefault(__webpack_require__(5));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	var IconCheck = (0, _createIconComponent["default"])({
	  content: _react["default"].createElement("g", null, _react["default"].createElement("path", {
	    d: "M63.62 20.72a3.36 3.36 0 0 0 .31-4.52 3.22 3.22 0 0 0-4.74-.2L27.86 47.34 14.13 33.61a3.22 3.22 0 0 0-4.74.19 3.36 3.36 0 0 0 .32 4.52l15.53 15.53a3.7 3.7 0 0 0 5.24 0z"
	  })),
	  height: undefined,
	  width: undefined
	});
	IconCheck.displayName = 'IconCheck';
	var _default = IconCheck;
	exports["default"] = _default;

/***/ },
/* 225 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _createIconComponent = _interopRequireDefault(__webpack_require__(5));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	var IconGears = (0, _createIconComponent["default"])({
	  content: _react["default"].createElement("g", null, _react["default"].createElement("path", {
	    d: "M34.44 8.62l-2.68 1.11a2.81 2.81 0 0 0-1.52 3.67l.69 1.67a17.08 17.08 0 0 0-3.53 3.53l-1.66-.69a2.81 2.81 0 0 0-3.67 1.52l-1.12 2.67a2.81 2.81 0 0 0 1.52 3.67l2.46 1a1.08 1.08 0 1 0 .82-2l-2.46-1a.65.65 0 0 1-.35-.84l1.12-2.68a.65.65 0 0 1 .35-.35.64.64 0 0 1 .49 0l2.46 1a1.08 1.08 0 0 0 1.31-.39 14.85 14.85 0 0 1 4.17-4.17 1.09 1.09 0 0 0 .42-1.34l-1-2.46a.65.65 0 0 1 .35-.84l2.68-1.11a.65.65 0 0 1 .84.35l1 2.46a1.07 1.07 0 0 0 1.22.65 15 15 0 0 1 5.89 0 1.1 1.1 0 0 0 1.22-.65l1-2.46a.65.65 0 0 1 .84-.35l2.7 1.14a.65.65 0 0 1 .35.35.64.64 0 0 1 0 .49l-1 2.46a1.08 1.08 0 0 0 .39 1.31 14.84 14.84 0 0 1 4.17 4.17 1.09 1.09 0 0 0 1.31.41l2.46-1a.64.64 0 0 1 .49 0 .65.65 0 0 1 .35.35l1.11 2.68a.65.65 0 0 1-.35.84l-2.46 1a1.08 1.08 0 0 0-.64 1.21 15 15 0 0 1 0 5.89 1.1 1.1 0 0 0 .65 1.22l2.46 1a.65.65 0 0 1 .35.84l-1.12 2.68a.65.65 0 0 1-.84.35l-2.46-1a1.08 1.08 0 0 0-1.31.39 14.85 14.85 0 0 1-4.17 4.17 1.09 1.09 0 0 0-.41 1.31l1 2.46a.65.65 0 0 1-.35.84l-2.68 1.16a.64.64 0 0 1-.49 0 .65.65 0 0 1-.35-.35l-1-2.46a1.08 1.08 0 1 0-2 .82l1 2.46A2.8 2.8 0 0 0 46 49.3a2.85 2.85 0 0 0 1.07.22 2.81 2.81 0 0 0 1.07-.22l2.68-1.11a2.81 2.81 0 0 0 1.52-3.67l-.69-1.66a17.1 17.1 0 0 0 3.53-3.53l1.66.69a2.81 2.81 0 0 0 3.66-1.52l1.12-2.68a2.81 2.81 0 0 0-1.52-3.67l-1.66-.69a17.29 17.29 0 0 0 0-5l1.66-.69a2.81 2.81 0 0 0 1.52-3.67l-1.11-2.68a2.81 2.81 0 0 0-3.67-1.52l-1.67.69a17 17 0 0 0-3.52-3.53l.69-1.66a2.81 2.81 0 0 0-1.52-3.67l-2.67-1.11a2.81 2.81 0 0 0-3.67 1.52l-.69 1.66a17.25 17.25 0 0 0-5 0l-.69-1.66a2.81 2.81 0 0 0-3.67-1.52zm0 0"
	  }), _react["default"].createElement("path", {
	    d: "M50.11 28.9a8.83 8.83 0 0 0-8.82-8.75h-.07A8.83 8.83 0 0 0 32.46 29a1.08 1.08 0 0 0 1.08 1.07A1.07 1.07 0 0 0 34.63 29a6.66 6.66 0 0 1 6.6-6.7 6.65 6.65 0 0 1 0 13.31 1.07 1.07 0 0 0-1.07 1.1 1.08 1.08 0 0 0 1.08 1.07A8.83 8.83 0 0 0 50 28.9zm0 0M23 61.59h2.1a2.35 2.35 0 0 0 2.34-2.34v-1.09a12.41 12.41 0 0 0 3-1.25l.77.77a2.34 2.34 0 0 0 1.65.69 2.29 2.29 0 0 0 1.65-.69L36 56.19a2.34 2.34 0 0 0 .69-1.65 2.29 2.29 0 0 0-.69-1.66l-.77-.77a12.41 12.41 0 0 0 1.25-3h1.08a2.35 2.35 0 0 0 2.34-2.34v-2.11a2.35 2.35 0 0 0-2.34-2.34h-1.07a12.42 12.42 0 0 0-1.25-3l.77-.77a2.34 2.34 0 0 0 .69-1.65 2.29 2.29 0 0 0-.7-1.66l-1.49-1.49a2.34 2.34 0 0 0-1.65-.69 2.29 2.29 0 0 0-1.65.69l-.77.77a12.43 12.43 0 0 0-3-1.25v-1.09a2.35 2.35 0 0 0-2.34-2.34H23a2.35 2.35 0 0 0-2.34 2.34v1.08a12.43 12.43 0 0 0-3 1.25l-.77-.77a2.34 2.34 0 0 0-1.65-.69 2.29 2.29 0 0 0-1.65.69l-1.49 1.49a2.35 2.35 0 0 0 0 3.31l.77.77a12.44 12.44 0 0 0-1.25 3h-1.11a2.35 2.35 0 0 0-2.34 2.34v2.11a2.35 2.35 0 0 0 2.34 2.34h1.08a12.43 12.43 0 0 0 1.25 3l-.77.77a2.35 2.35 0 0 0 0 3.31l1.49 1.49a2.34 2.34 0 0 0 1.65.69 2.3 2.3 0 0 0 1.65-.69l.77-.77a12.41 12.41 0 0 0 3 1.25v1.08A2.36 2.36 0 0 0 23 61.59zm-4.9-6.94a1.11 1.11 0 0 0-.6-.19 1.08 1.08 0 0 0-.77.32l-1.37 1.37a.16.16 0 0 1-.24 0l-1.49-1.49a.17.17 0 0 1 0-.24L15 53a1.08 1.08 0 0 0 .13-1.37 10.56 10.56 0 0 1-1.6-3.86 1.09 1.09 0 0 0-1.06-.88h-1.95a.17.17 0 0 1-.17-.18v-2.05a.17.17 0 0 1 .17-.18h1.94a1.08 1.08 0 0 0 1.06-.88 10.56 10.56 0 0 1 1.6-3.86 1.09 1.09 0 0 0-.12-1.36L13.62 37a.17.17 0 0 1 0-.24l1.49-1.49a.16.16 0 0 1 .24 0l1.37 1.39a1.08 1.08 0 0 0 1.37.13 10.57 10.57 0 0 1 3.86-1.6 1.09 1.09 0 0 0 .88-1.06V32.2A.17.17 0 0 1 23 32h2.11a.17.17 0 0 1 .17.18v1.94a1.08 1.08 0 0 0 .88 1.06A10.58 10.58 0 0 1 30 36.8a1.09 1.09 0 0 0 1.37-.13l1.37-1.37a.16.16 0 0 1 .24 0l1.49 1.49a.17.17 0 0 1 .06.12.17.17 0 0 1-.06.12l-1.35 1.37a1.08 1.08 0 0 0-.12 1.37 10.57 10.57 0 0 1 1.6 3.86 1.09 1.09 0 0 0 1.06.88h1.94a.17.17 0 0 1 .18.18v2.11a.17.17 0 0 1-.18.18h-1.95a1.08 1.08 0 0 0-1.06.88A10.56 10.56 0 0 1 33 51.7a1.09 1.09 0 0 0 .13 1.37l1.37 1.37a.16.16 0 0 1 0 .24L33 56.17a.16.16 0 0 1-.24 0l-1.37-1.37a1.08 1.08 0 0 0-1.39-.13 10.56 10.56 0 0 1-3.86 1.6 1.09 1.09 0 0 0-.88 1.06v1.94a.17.17 0 0 1-.17.18H23a.17.17 0 0 1-.18-.18v-1.94a1.08 1.08 0 0 0-.88-1.06 11 11 0 0 1-3.86-1.62zm0 0"
	  }), _react["default"].createElement("path", {
	    d: "M30.48 45.73A6.44 6.44 0 1 0 24 52.17a6.45 6.45 0 0 0 6.43-6.44zm-10.7 0A4.27 4.27 0 1 1 24 50a4.28 4.28 0 0 1-4.27-4.27zm0 0"
	  })),
	  height: undefined,
	  width: undefined
	});
	IconGears.displayName = 'IconGears';
	var _default = IconGears;
	exports["default"] = _default;

/***/ },
/* 226 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _createIconComponent = _interopRequireDefault(__webpack_require__(5));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	var IconHistory = (0, _createIconComponent["default"])({
	  content: _react["default"].createElement("g", null, _react["default"].createElement("path", {
	    d: "M61.23 46.74a29.62 29.62 0 0 0-38.31-39 34.77 34.77 0 0 0-8.16 4.46l-1.45 1.09.93-6.48a1.37 1.37 0 1 0-2.72-.39l-1.57 11a1.57 1.57 0 0 0 0 .27v.28L10 18l.05.11.08.13.1.13.11.11.16.13.13.08.14.06.2.06h10.52a1.37 1.37 0 1 0 0-2.75h-7.37l1.67-1.34a31.74 31.74 0 0 1 8.12-4.56A26.87 26.87 0 0 1 44 60.1 26.9 26.9 0 0 1 9 45.28a1.38 1.38 0 0 0-1.28-.86 1.38 1.38 0 0 0-1.22 1.89 29.61 29.61 0 0 0 54.73.43z"
	  }), _react["default"].createElement("path", {
	    d: "M33.38 35.07l.14-12.43a1.38 1.38 0 0 0-1.36-1.39 1.38 1.38 0 0 0-1.38 1.36l-.15 13.21V36a1.21 1.21 0 0 0 .08.42v.15a1.43 1.43 0 0 0 .24.34l.08.07a1.51 1.51 0 0 0 .33.23l.15.09 17.2 7.28a1.37 1.37 0 0 0 1.8-.73 1.38 1.38 0 0 0-.73-1.8z"
	  }), _react["default"].createElement("path", {
	    d: "M30.73 38.54",
	    fill: "none"
	  })),
	  height: undefined,
	  width: undefined
	});
	IconHistory.displayName = 'IconHistory';
	var _default = IconHistory;
	exports["default"] = _default;

/***/ },
/* 227 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _createIconComponent = _interopRequireDefault(__webpack_require__(5));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	var IconRevert = (0, _createIconComponent["default"])({
	  content: _react["default"].createElement("g", null, _react["default"].createElement("path", {
	    d: "M56 14H20.24l3.43-3.43a3 3 0 1 0-4.24-4.24l-8.55 8.55a3 3 0 0 0-.38.46c0 .07-.08.15-.12.22a3 3 0 0 0-.16.3 3 3 0 0 0-.09.3c0 .09-.06.17-.08.26a3 3 0 0 0 0 1.17c0 .09.05.17.08.26a3 3 0 0 0 .09.3 3 3 0 0 0 .16.3c0 .07.07.15.12.22a3 3 0 0 0 .38.46l8.55 8.55a3 3 0 0 0 4.24-4.24L20.24 20H53v32H20.27V39.7a3 3 0 1 0-6 0V55a3 3 0 0 0 3 3H56a3 3 0 0 0 3-3V17a3 3 0 0 0-3-3z"
	  })),
	  height: undefined,
	  width: undefined
	});
	IconRevert.displayName = 'IconRevert';
	var _default = IconRevert;
	exports["default"] = _default;

/***/ },
/* 228 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _createIconComponent = _interopRequireDefault(__webpack_require__(5));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	var IconSearchThin = (0, _createIconComponent["default"])({
	  content: _react["default"].createElement("g", null, _react["default"].createElement("path", {
	    d: "M46 44l1.08-1.39a20.86 20.86 0 0 0 4.4-12.87A21.13 21.13 0 1 0 41.9 47.4l1.36-.89L57.51 60.8a1.94 1.94 0 0 0 2.63 0 1.86 1.86 0 0 0 0-2.63zm-15.6 3.15a17.37 17.37 0 1 1 17.37-17.37A17.39 17.39 0 0 1 30.4 47.15z"
	  })),
	  height: undefined,
	  width: undefined
	});
	IconSearchThin.displayName = 'IconSearchThin';
	var _default = IconSearchThin;
	exports["default"] = _default;

/***/ },
/* 229 */
/***/ function(module, exports) {

	/**
	 * @copyright 2015, Andrey Popp <8mayday@gmail.com>
	 *
	 * The decorator may be used on classes or methods
	 * ```
	 * @autobind
	 * class FullBound {}
	 *
	 * class PartBound {
	 *   @autobind
	 *   method () {}
	 * }
	 * ```
	 */
	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	exports['default'] = autobind;
	
	function autobind() {
	  for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	    args[_key] = arguments[_key];
	  }
	
	  if (args.length === 1) {
	    return boundClass.apply(undefined, args);
	  } else {
	    return boundMethod.apply(undefined, args);
	  }
	}
	
	/**
	 * Use boundMethod to bind all methods on the target.prototype
	 */
	function boundClass(target) {
	  // (Using reflect to get all keys including symbols)
	  var keys = undefined;
	  // Use Reflect if exists
	  if (typeof Reflect !== 'undefined' && typeof Reflect.ownKeys === 'function') {
	    keys = Reflect.ownKeys(target.prototype);
	  } else {
	    keys = Object.getOwnPropertyNames(target.prototype);
	    // use symbols if support is provided
	    if (typeof Object.getOwnPropertySymbols === 'function') {
	      keys = keys.concat(Object.getOwnPropertySymbols(target.prototype));
	    }
	  }
	
	  keys.forEach(function (key) {
	    // Ignore special case target method
	    if (key === 'constructor') {
	      return;
	    }
	
	    var descriptor = Object.getOwnPropertyDescriptor(target.prototype, key);
	
	    // Only methods need binding
	    if (typeof descriptor.value === 'function') {
	      Object.defineProperty(target.prototype, key, boundMethod(target, key, descriptor));
	    }
	  });
	  return target;
	}
	
	/**
	 * Return a descriptor removing the value and returning a getter
	 * The getter will return a .bind version of the function
	 * and memoize the result against a symbol on the instance
	 */
	function boundMethod(target, key, descriptor) {
	  var fn = descriptor.value;
	
	  if (typeof fn !== 'function') {
	    throw new Error('@autobind decorator can only be applied to methods not: ' + typeof fn);
	  }
	
	  // In IE11 calling Object.defineProperty has a side-effect of evaluating the
	  // getter for the property which is being replaced. This causes infinite
	  // recursion and an "Out of stack space" error.
	  var definingProperty = false;
	
	  return {
	    configurable: true,
	    get: function get() {
	      if (definingProperty || this === target.prototype || this.hasOwnProperty(key)) {
	        return fn;
	      }
	
	      var boundFn = fn.bind(this);
	      definingProperty = true;
	      Object.defineProperty(this, key, {
	        value: boundFn,
	        configurable: true,
	        writable: true
	      });
	      definingProperty = false;
	      return boundFn;
	    }
	  };
	}
	module.exports = exports['default'];


/***/ },
/* 230 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Buffer) {var uint_max = Math.pow(2, 32);
	function fixup_uint32(x) {
	    var ret, x_pos;
	    ret = x > uint_max || x < 0 ? (x_pos = Math.abs(x) % uint_max, x < 0 ? uint_max - x_pos : x_pos) : x;
	    return ret;
	}
	function scrub_vec(v) {
	  var i, _i, _ref;
	  for (i = _i = 0, _ref = v.length; 0 <= _ref ? _i < _ref : _i > _ref; i = 0 <= _ref ? ++_i : --_i) {
	    v[i] = 0;
	  }
	  return false;
	}
	
	function Global() {
	  var i;
	  this.SBOX = [];
	  this.INV_SBOX = [];
	  this.SUB_MIX = (function() {
	    var _i, _results;
	    _results = [];
	    for (i = _i = 0; _i < 4; i = ++_i) {
	      _results.push([]);
	    }
	    return _results;
	  })();
	  this.INV_SUB_MIX = (function() {
	    var _i, _results;
	    _results = [];
	    for (i = _i = 0; _i < 4; i = ++_i) {
	      _results.push([]);
	    }
	    return _results;
	  })();
	  this.init();
	  this.RCON = [0x00, 0x01, 0x02, 0x04, 0x08, 0x10, 0x20, 0x40, 0x80, 0x1b, 0x36];
	}
	
	Global.prototype.init = function() {
	  var d, i, sx, t, x, x2, x4, x8, xi, _i;
	  d = (function() {
	    var _i, _results;
	    _results = [];
	    for (i = _i = 0; _i < 256; i = ++_i) {
	      if (i < 128) {
	        _results.push(i << 1);
	      } else {
	        _results.push((i << 1) ^ 0x11b);
	      }
	    }
	    return _results;
	  })();
	  x = 0;
	  xi = 0;
	  for (i = _i = 0; _i < 256; i = ++_i) {
	    sx = xi ^ (xi << 1) ^ (xi << 2) ^ (xi << 3) ^ (xi << 4);
	    sx = (sx >>> 8) ^ (sx & 0xff) ^ 0x63;
	    this.SBOX[x] = sx;
	    this.INV_SBOX[sx] = x;
	    x2 = d[x];
	    x4 = d[x2];
	    x8 = d[x4];
	    t = (d[sx] * 0x101) ^ (sx * 0x1010100);
	    this.SUB_MIX[0][x] = (t << 24) | (t >>> 8);
	    this.SUB_MIX[1][x] = (t << 16) | (t >>> 16);
	    this.SUB_MIX[2][x] = (t << 8) | (t >>> 24);
	    this.SUB_MIX[3][x] = t;
	    t = (x8 * 0x1010101) ^ (x4 * 0x10001) ^ (x2 * 0x101) ^ (x * 0x1010100);
	    this.INV_SUB_MIX[0][sx] = (t << 24) | (t >>> 8);
	    this.INV_SUB_MIX[1][sx] = (t << 16) | (t >>> 16);
	    this.INV_SUB_MIX[2][sx] = (t << 8) | (t >>> 24);
	    this.INV_SUB_MIX[3][sx] = t;
	    if (x === 0) {
	      x = xi = 1;
	    } else {
	      x = x2 ^ d[d[d[x8 ^ x2]]];
	      xi ^= d[d[xi]];
	    }
	  }
	  return true;
	};
	
	var G = new Global();
	
	
	AES.blockSize = 4 * 4;
	
	AES.prototype.blockSize = AES.blockSize;
	
	AES.keySize = 256 / 8;
	
	AES.prototype.keySize = AES.keySize;
	
	AES.ivSize = AES.blockSize;
	
	AES.prototype.ivSize = AES.ivSize;
	
	 function bufferToArray(buf) {
	  var len = buf.length/4;
	  var out = new Array(len);
	  var i = -1;
	  while (++i < len) {
	    out[i] = buf.readUInt32BE(i * 4);
	  }
	  return out;
	 }
	function AES(key) {
	  this._key = bufferToArray(key);
	  this._doReset();
	}
	
	AES.prototype._doReset = function() {
	  var invKsRow, keySize, keyWords, ksRow, ksRows, t, _i, _j;
	  keyWords = this._key;
	  keySize = keyWords.length;
	  this._nRounds = keySize + 6;
	  ksRows = (this._nRounds + 1) * 4;
	  this._keySchedule = [];
	  for (ksRow = _i = 0; 0 <= ksRows ? _i < ksRows : _i > ksRows; ksRow = 0 <= ksRows ? ++_i : --_i) {
	    this._keySchedule[ksRow] = ksRow < keySize ? keyWords[ksRow] : (t = this._keySchedule[ksRow - 1], (ksRow % keySize) === 0 ? (t = (t << 8) | (t >>> 24), t = (G.SBOX[t >>> 24] << 24) | (G.SBOX[(t >>> 16) & 0xff] << 16) | (G.SBOX[(t >>> 8) & 0xff] << 8) | G.SBOX[t & 0xff], t ^= G.RCON[(ksRow / keySize) | 0] << 24) : keySize > 6 && ksRow % keySize === 4 ? t = (G.SBOX[t >>> 24] << 24) | (G.SBOX[(t >>> 16) & 0xff] << 16) | (G.SBOX[(t >>> 8) & 0xff] << 8) | G.SBOX[t & 0xff] : void 0, this._keySchedule[ksRow - keySize] ^ t);
	  }
	  this._invKeySchedule = [];
	  for (invKsRow = _j = 0; 0 <= ksRows ? _j < ksRows : _j > ksRows; invKsRow = 0 <= ksRows ? ++_j : --_j) {
	    ksRow = ksRows - invKsRow;
	    t = this._keySchedule[ksRow - (invKsRow % 4 ? 0 : 4)];
	    this._invKeySchedule[invKsRow] = invKsRow < 4 || ksRow <= 4 ? t : G.INV_SUB_MIX[0][G.SBOX[t >>> 24]] ^ G.INV_SUB_MIX[1][G.SBOX[(t >>> 16) & 0xff]] ^ G.INV_SUB_MIX[2][G.SBOX[(t >>> 8) & 0xff]] ^ G.INV_SUB_MIX[3][G.SBOX[t & 0xff]];
	  }
	  return true;
	};
	
	AES.prototype.encryptBlock = function(M) {
	  M = bufferToArray(new Buffer(M));
	  var out = this._doCryptBlock(M, this._keySchedule, G.SUB_MIX, G.SBOX);
	  var buf = new Buffer(16);
	  buf.writeUInt32BE(out[0], 0);
	  buf.writeUInt32BE(out[1], 4);
	  buf.writeUInt32BE(out[2], 8);
	  buf.writeUInt32BE(out[3], 12);
	  return buf;
	};
	
	AES.prototype.decryptBlock = function(M) {
	  M = bufferToArray(new Buffer(M));
	  var temp = [M[3], M[1]];
	  M[1] = temp[0];
	  M[3] = temp[1];
	  var out = this._doCryptBlock(M, this._invKeySchedule, G.INV_SUB_MIX, G.INV_SBOX);
	  var buf = new Buffer(16);
	  buf.writeUInt32BE(out[0], 0);
	  buf.writeUInt32BE(out[3], 4);
	  buf.writeUInt32BE(out[2], 8);
	  buf.writeUInt32BE(out[1], 12);
	  return buf;
	};
	
	AES.prototype.scrub = function() {
	  scrub_vec(this._keySchedule);
	  scrub_vec(this._invKeySchedule);
	  scrub_vec(this._key);
	};
	
	AES.prototype._doCryptBlock = function(M, keySchedule, SUB_MIX, SBOX) {
	  var ksRow, round, s0, s1, s2, s3, t0, t1, t2, t3, _i, _ref;
	
	  s0 = M[0] ^ keySchedule[0];
	  s1 = M[1] ^ keySchedule[1];
	  s2 = M[2] ^ keySchedule[2];
	  s3 = M[3] ^ keySchedule[3];
	  ksRow = 4;
	  for (round = _i = 1, _ref = this._nRounds; 1 <= _ref ? _i < _ref : _i > _ref; round = 1 <= _ref ? ++_i : --_i) {
	    t0 = SUB_MIX[0][s0 >>> 24] ^ SUB_MIX[1][(s1 >>> 16) & 0xff] ^ SUB_MIX[2][(s2 >>> 8) & 0xff] ^ SUB_MIX[3][s3 & 0xff] ^ keySchedule[ksRow++];
	    t1 = SUB_MIX[0][s1 >>> 24] ^ SUB_MIX[1][(s2 >>> 16) & 0xff] ^ SUB_MIX[2][(s3 >>> 8) & 0xff] ^ SUB_MIX[3][s0 & 0xff] ^ keySchedule[ksRow++];
	    t2 = SUB_MIX[0][s2 >>> 24] ^ SUB_MIX[1][(s3 >>> 16) & 0xff] ^ SUB_MIX[2][(s0 >>> 8) & 0xff] ^ SUB_MIX[3][s1 & 0xff] ^ keySchedule[ksRow++];
	    t3 = SUB_MIX[0][s3 >>> 24] ^ SUB_MIX[1][(s0 >>> 16) & 0xff] ^ SUB_MIX[2][(s1 >>> 8) & 0xff] ^ SUB_MIX[3][s2 & 0xff] ^ keySchedule[ksRow++];
	    s0 = t0;
	    s1 = t1;
	    s2 = t2;
	    s3 = t3;
	  }
	  t0 = ((SBOX[s0 >>> 24] << 24) | (SBOX[(s1 >>> 16) & 0xff] << 16) | (SBOX[(s2 >>> 8) & 0xff] << 8) | SBOX[s3 & 0xff]) ^ keySchedule[ksRow++];
	  t1 = ((SBOX[s1 >>> 24] << 24) | (SBOX[(s2 >>> 16) & 0xff] << 16) | (SBOX[(s3 >>> 8) & 0xff] << 8) | SBOX[s0 & 0xff]) ^ keySchedule[ksRow++];
	  t2 = ((SBOX[s2 >>> 24] << 24) | (SBOX[(s3 >>> 16) & 0xff] << 16) | (SBOX[(s0 >>> 8) & 0xff] << 8) | SBOX[s1 & 0xff]) ^ keySchedule[ksRow++];
	  t3 = ((SBOX[s3 >>> 24] << 24) | (SBOX[(s0 >>> 16) & 0xff] << 16) | (SBOX[(s1 >>> 8) & 0xff] << 8) | SBOX[s2 & 0xff]) ^ keySchedule[ksRow++];
	  return [
	    fixup_uint32(t0),
	    fixup_uint32(t1),
	    fixup_uint32(t2),
	    fixup_uint32(t3)
	  ];
	
	};
	
	
	
	
	  exports.AES = AES;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(31).Buffer))

/***/ },
/* 231 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Buffer) {var Transform = __webpack_require__(1425).Transform;
	var inherits = __webpack_require__(58);
	
	module.exports = CipherBase;
	inherits(CipherBase, Transform);
	function CipherBase() {
	  Transform.call(this);
	}
	CipherBase.prototype.update = function (data, inputEnd, outputEnc) {
	  this.write(data, inputEnd);
	  var outData = new Buffer('');
	  var chunk;
	  while ((chunk = this.read())) {
	    outData = Buffer.concat([outData, chunk]);
	  }
	  if (outputEnc) {
	    outData = outData.toString(outputEnc);
	  }
	  return outData;
	};
	CipherBase.prototype.final = function (outputEnc) {
	  this.end();
	  var outData = new Buffer('');
	  var chunk;
	  while ((chunk = this.read())) {
	    outData = Buffer.concat([outData, chunk]);
	  }
	  if (outputEnc) {
	    outData = outData.toString(outputEnc);
	  }
	  return outData;
	};
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(31).Buffer))

/***/ },
/* 232 */
/***/ function(module, exports) {

	exports['aes-128-ecb'] = {
	  cipher: 'AES',
	  key: 128,
	  iv: 0,
	  mode: 'ECB',
	  type: 'block'
	};
	exports['aes-192-ecb'] = {
	  cipher: 'AES',
	  key: 192,
	  iv: 0,
	  mode: 'ECB',
	  type: 'block'
	};
	exports['aes-256-ecb'] = {
	  cipher: 'AES',
	  key: 256,
	  iv: 0,
	  mode: 'ECB',
	  type: 'block'
	};
	exports['aes-128-cbc'] = {
	  cipher: 'AES',
	  key: 128,
	  iv: 16,
	  mode: 'CBC',
	  type: 'block'
	};
	exports['aes-192-cbc'] = {
	  cipher: 'AES',
	  key: 192,
	  iv: 16,
	  mode: 'CBC',
	  type: 'block'
	};
	exports['aes-256-cbc'] = {
	  cipher: 'AES',
	  key: 256,
	  iv: 16,
	  mode: 'CBC',
	  type: 'block'
	};
	exports['aes128'] = exports['aes-128-cbc'];
	exports['aes192'] = exports['aes-192-cbc'];
	exports['aes256'] = exports['aes-256-cbc'];
	exports['aes-128-cfb'] = {
	  cipher: 'AES',
	  key: 128,
	  iv: 16,
	  mode: 'CFB',
	  type: 'stream'
	};
	exports['aes-192-cfb'] = {
	  cipher: 'AES',
	  key: 192,
	  iv: 16,
	  mode: 'CFB',
	  type: 'stream'
	};
	exports['aes-256-cfb'] = {
	  cipher: 'AES',
	  key: 256,
	  iv: 16,
	  mode: 'CFB',
	  type: 'stream'
	};
	exports['aes-128-ofb'] = {
	  cipher: 'AES',
	  key: 128,
	  iv: 16,
	  mode: 'OFB',
	  type: 'stream'
	};
	exports['aes-192-ofb'] = {
	  cipher: 'AES',
	  key: 192,
	  iv: 16,
	  mode: 'OFB',
	  type: 'stream'
	};
	exports['aes-256-ofb'] = {
	  cipher: 'AES',
	  key: 256,
	  iv: 16,
	  mode: 'OFB',
	  type: 'stream'
	};
	exports['aes-128-ctr'] = {
	  cipher: 'AES',
	  key: 128,
	  iv: 16,
	  mode: 'CTR',
	  type: 'stream'
	};
	exports['aes-192-ctr'] = {
	  cipher: 'AES',
	  key: 192,
	  iv: 16,
	  mode: 'CTR',
	  type: 'stream'
	};
	exports['aes-256-ctr'] = {
	  cipher: 'AES',
	  key: 256,
	  iv: 16,
	  mode: 'CTR',
	  type: 'stream'
	};

/***/ },
/* 233 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var at = __webpack_require__(176)(true);
	
	 // `AdvanceStringIndex` abstract operation
	// https://tc39.github.io/ecma262/#sec-advancestringindex
	module.exports = function (S, index, unicode) {
	  return index + (unicode ? at(S, index).length : 1);
	};


/***/ },
/* 234 */
/***/ function(module, exports, __webpack_require__) {

	// 22.1.3.6 Array.prototype.fill(value, start = 0, end = this.length)
	'use strict';
	var toObject = __webpack_require__(34);
	var toAbsoluteIndex = __webpack_require__(95);
	var toLength = __webpack_require__(27);
	module.exports = function fill(value /* , start = 0, end = @length */) {
	  var O = toObject(this);
	  var length = toLength(O.length);
	  var aLen = arguments.length;
	  var index = toAbsoluteIndex(aLen > 1 ? arguments[1] : undefined, length);
	  var end = aLen > 2 ? arguments[2] : undefined;
	  var endPos = end === undefined ? length : toAbsoluteIndex(end, length);
	  while (endPos > index) O[index++] = value;
	  return O;
	};


/***/ },
/* 235 */
/***/ function(module, exports, __webpack_require__) {

	// 9.4.2.3 ArraySpeciesCreate(originalArray, length)
	var speciesConstructor = __webpack_require__(628);
	
	module.exports = function (original, length) {
	  return new (speciesConstructor(original))(length);
	};


/***/ },
/* 236 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $defineProperty = __webpack_require__(32);
	var createDesc = __webpack_require__(92);
	
	module.exports = function (object, index, value) {
	  if (index in object) $defineProperty.f(object, index, createDesc(0, value));
	  else object[index] = value;
	};


/***/ },
/* 237 */
/***/ function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(23);
	var document = __webpack_require__(17).document;
	// typeof document.createElement is 'object' in old IE
	var is = isObject(document) && isObject(document.createElement);
	module.exports = function (it) {
	  return is ? document.createElement(it) : {};
	};


/***/ },
/* 238 */
/***/ function(module, exports) {

	// IE 8- don't enum bug keys
	module.exports = (
	  'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'
	).split(',');


/***/ },
/* 239 */
/***/ function(module, exports, __webpack_require__) {

	var MATCH = __webpack_require__(26)('match');
	module.exports = function (KEY) {
	  var re = /./;
	  try {
	    '/./'[KEY](re);
	  } catch (e) {
	    try {
	      re[MATCH] = false;
	      return !'/./'[KEY](re);
	    } catch (f) { /* empty */ }
	  } return true;
	};


/***/ },
/* 240 */
/***/ function(module, exports, __webpack_require__) {

	var document = __webpack_require__(17).document;
	module.exports = document && document.documentElement;


/***/ },
/* 241 */
/***/ function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(23);
	var setPrototypeOf = __webpack_require__(250).set;
	module.exports = function (that, target, C) {
	  var S = target.constructor;
	  var P;
	  if (S !== C && typeof S == 'function' && (P = S.prototype) !== C.prototype && isObject(P) && setPrototypeOf) {
	    setPrototypeOf(that, P);
	  } return that;
	};


/***/ },
/* 242 */
/***/ function(module, exports, __webpack_require__) {

	// check on default Array iterator
	var Iterators = __webpack_require__(108);
	var ITERATOR = __webpack_require__(26)('iterator');
	var ArrayProto = Array.prototype;
	
	module.exports = function (it) {
	  return it !== undefined && (Iterators.Array === it || ArrayProto[ITERATOR] === it);
	};


/***/ },
/* 243 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var create = __webpack_require__(89);
	var descriptor = __webpack_require__(92);
	var setToStringTag = __webpack_require__(109);
	var IteratorPrototype = {};
	
	// 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
	__webpack_require__(40)(IteratorPrototype, __webpack_require__(26)('iterator'), function () { return this; });
	
	module.exports = function (Constructor, NAME, next) {
	  Constructor.prototype = create(IteratorPrototype, { next: descriptor(1, next) });
	  setToStringTag(Constructor, NAME + ' Iterator');
	};


/***/ },
/* 244 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var LIBRARY = __webpack_require__(82);
	var $export = __webpack_require__(4);
	var redefine = __webpack_require__(41);
	var hide = __webpack_require__(40);
	var Iterators = __webpack_require__(108);
	var $iterCreate = __webpack_require__(243);
	var setToStringTag = __webpack_require__(109);
	var getPrototypeOf = __webpack_require__(48);
	var ITERATOR = __webpack_require__(26)('iterator');
	var BUGGY = !([].keys && 'next' in [].keys()); // Safari has buggy iterators w/o `next`
	var FF_ITERATOR = '@@iterator';
	var KEYS = 'keys';
	var VALUES = 'values';
	
	var returnThis = function () { return this; };
	
	module.exports = function (Base, NAME, Constructor, next, DEFAULT, IS_SET, FORCED) {
	  $iterCreate(Constructor, NAME, next);
	  var getMethod = function (kind) {
	    if (!BUGGY && kind in proto) return proto[kind];
	    switch (kind) {
	      case KEYS: return function keys() { return new Constructor(this, kind); };
	      case VALUES: return function values() { return new Constructor(this, kind); };
	    } return function entries() { return new Constructor(this, kind); };
	  };
	  var TAG = NAME + ' Iterator';
	  var DEF_VALUES = DEFAULT == VALUES;
	  var VALUES_BUG = false;
	  var proto = Base.prototype;
	  var $native = proto[ITERATOR] || proto[FF_ITERATOR] || DEFAULT && proto[DEFAULT];
	  var $default = $native || getMethod(DEFAULT);
	  var $entries = DEFAULT ? !DEF_VALUES ? $default : getMethod('entries') : undefined;
	  var $anyNative = NAME == 'Array' ? proto.entries || $native : $native;
	  var methods, key, IteratorPrototype;
	  // Fix native
	  if ($anyNative) {
	    IteratorPrototype = getPrototypeOf($anyNative.call(new Base()));
	    if (IteratorPrototype !== Object.prototype && IteratorPrototype.next) {
	      // Set @@toStringTag to native iterators
	      setToStringTag(IteratorPrototype, TAG, true);
	      // fix for some old engines
	      if (!LIBRARY && typeof IteratorPrototype[ITERATOR] != 'function') hide(IteratorPrototype, ITERATOR, returnThis);
	    }
	  }
	  // fix Array#{values, @@iterator}.name in V8 / FF
	  if (DEF_VALUES && $native && $native.name !== VALUES) {
	    VALUES_BUG = true;
	    $default = function values() { return $native.call(this); };
	  }
	  // Define iterator
	  if ((!LIBRARY || FORCED) && (BUGGY || VALUES_BUG || !proto[ITERATOR])) {
	    hide(proto, ITERATOR, $default);
	  }
	  // Plug for library
	  Iterators[NAME] = $default;
	  Iterators[TAG] = returnThis;
	  if (DEFAULT) {
	    methods = {
	      values: DEF_VALUES ? $default : getMethod(VALUES),
	      keys: IS_SET ? $default : getMethod(KEYS),
	      entries: $entries
	    };
	    if (FORCED) for (key in methods) {
	      if (!(key in proto)) redefine(proto, key, methods[key]);
	    } else $export($export.P + $export.F * (BUGGY || VALUES_BUG), NAME, methods);
	  }
	  return methods;
	};


/***/ },
/* 245 */
/***/ function(module, exports) {

	// 20.2.2.14 Math.expm1(x)
	var $expm1 = Math.expm1;
	module.exports = (!$expm1
	  // Old FF bug
	  || $expm1(10) > 22025.465794806719 || $expm1(10) < 22025.4657948067165168
	  // Tor Browser bug
	  || $expm1(-2e-17) != -2e-17
	) ? function expm1(x) {
	  return (x = +x) == 0 ? x : x > -1e-6 && x < 1e-6 ? x + x * x / 2 : Math.exp(x) - 1;
	} : $expm1;


/***/ },
/* 246 */
/***/ function(module, exports) {

	// 20.2.2.28 Math.sign(x)
	module.exports = Math.sign || function sign(x) {
	  // eslint-disable-next-line no-self-compare
	  return (x = +x) == 0 || x != x ? x : x < 0 ? -1 : 1;
	};


/***/ },
/* 247 */
/***/ function(module, exports, __webpack_require__) {

	var global = __webpack_require__(17);
	var macrotask = __webpack_require__(255).set;
	var Observer = global.MutationObserver || global.WebKitMutationObserver;
	var process = global.process;
	var Promise = global.Promise;
	var isNode = __webpack_require__(53)(process) == 'process';
	
	module.exports = function () {
	  var head, last, notify;
	
	  var flush = function () {
	    var parent, fn;
	    if (isNode && (parent = process.domain)) parent.exit();
	    while (head) {
	      fn = head.fn;
	      head = head.next;
	      try {
	        fn();
	      } catch (e) {
	        if (head) notify();
	        else last = undefined;
	        throw e;
	      }
	    } last = undefined;
	    if (parent) parent.enter();
	  };
	
	  // Node.js
	  if (isNode) {
	    notify = function () {
	      process.nextTick(flush);
	    };
	  // browsers with MutationObserver, except iOS Safari - https://github.com/zloirock/core-js/issues/339
	  } else if (Observer && !(global.navigator && global.navigator.standalone)) {
	    var toggle = true;
	    var node = document.createTextNode('');
	    new Observer(flush).observe(node, { characterData: true }); // eslint-disable-line no-new
	    notify = function () {
	      node.data = toggle = !toggle;
	    };
	  // environments with maybe non-completely correct, but existent Promise
	  } else if (Promise && Promise.resolve) {
	    // Promise.resolve without an argument throws an error in LG WebOS 2
	    var promise = Promise.resolve(undefined);
	    notify = function () {
	      promise.then(flush);
	    };
	  // for other environments - macrotask based on:
	  // - setImmediate
	  // - MessageChannel
	  // - window.postMessag
	  // - onreadystatechange
	  // - setTimeout
	  } else {
	    notify = function () {
	      // strange IE + webpack dev server bug - use .call(global)
	      macrotask.call(global, flush);
	    };
	  }
	
	  return function (fn) {
	    var task = { fn: fn, next: undefined };
	    if (last) last.next = task;
	    if (!head) {
	      head = task;
	      notify();
	    } last = task;
	  };
	};


/***/ },
/* 248 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// 25.4.1.5 NewPromiseCapability(C)
	var aFunction = __webpack_require__(39);
	
	function PromiseCapability(C) {
	  var resolve, reject;
	  this.promise = new C(function ($$resolve, $$reject) {
	    if (resolve !== undefined || reject !== undefined) throw TypeError('Bad Promise constructor');
	    resolve = $$resolve;
	    reject = $$reject;
	  });
	  this.resolve = aFunction(resolve);
	  this.reject = aFunction(reject);
	}
	
	module.exports.f = function (C) {
	  return new PromiseCapability(C);
	};


/***/ },
/* 249 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var regexpFlags = __webpack_require__(131);
	
	var nativeExec = RegExp.prototype.exec;
	// This always refers to the native implementation, because the
	// String#replace polyfill uses ./fix-regexp-well-known-symbol-logic.js,
	// which loads this file before patching the method.
	var nativeReplace = String.prototype.replace;
	
	var patchedExec = nativeExec;
	
	var LAST_INDEX = 'lastIndex';
	
	var UPDATES_LAST_INDEX_WRONG = (function () {
	  var re1 = /a/,
	      re2 = /b*/g;
	  nativeExec.call(re1, 'a');
	  nativeExec.call(re2, 'a');
	  return re1[LAST_INDEX] !== 0 || re2[LAST_INDEX] !== 0;
	})();
	
	// nonparticipating capturing group, copied from es5-shim's String#split patch.
	var NPCG_INCLUDED = /()??/.exec('')[1] !== undefined;
	
	var PATCH = UPDATES_LAST_INDEX_WRONG || NPCG_INCLUDED;
	
	if (PATCH) {
	  patchedExec = function exec(str) {
	    var re = this;
	    var lastIndex, reCopy, match, i;
	
	    if (NPCG_INCLUDED) {
	      reCopy = new RegExp('^' + re.source + '$(?!\\s)', regexpFlags.call(re));
	    }
	    if (UPDATES_LAST_INDEX_WRONG) lastIndex = re[LAST_INDEX];
	
	    match = nativeExec.call(re, str);
	
	    if (UPDATES_LAST_INDEX_WRONG && match) {
	      re[LAST_INDEX] = re.global ? match.index + match[0].length : lastIndex;
	    }
	    if (NPCG_INCLUDED && match && match.length > 1) {
	      // Fix browsers whose `exec` methods don't consistently return `undefined`
	      // for NPCG, like IE8. NOTE: This doesn' work for /(.?)?/
	      // eslint-disable-next-line no-loop-func
	      nativeReplace.call(match[0], reCopy, function () {
	        for (i = 1; i < arguments.length - 2; i++) {
	          if (arguments[i] === undefined) match[i] = undefined;
	        }
	      });
	    }
	
	    return match;
	  };
	}
	
	module.exports = patchedExec;


/***/ },
/* 250 */
/***/ function(module, exports, __webpack_require__) {

	// Works with __proto__ only. Old v8 can't work with null proto objects.
	/* eslint-disable no-proto */
	var isObject = __webpack_require__(23);
	var anObject = __webpack_require__(15);
	var check = function (O, proto) {
	  anObject(O);
	  if (!isObject(proto) && proto !== null) throw TypeError(proto + ": can't set as prototype!");
	};
	module.exports = {
	  set: Object.setPrototypeOf || ('__proto__' in {} ? // eslint-disable-line
	    function (test, buggy, set) {
	      try {
	        set = __webpack_require__(55)(Function.call, __webpack_require__(47).f(Object.prototype, '__proto__').set, 2);
	        set(test, []);
	        buggy = !(test instanceof Array);
	      } catch (e) { buggy = true; }
	      return function setPrototypeOf(O, proto) {
	        check(O, proto);
	        if (buggy) O.__proto__ = proto;
	        else set(O, proto);
	        return O;
	      };
	    }({}, false) : undefined),
	  check: check
	};


/***/ },
/* 251 */
/***/ function(module, exports, __webpack_require__) {

	var shared = __webpack_require__(134)('keys');
	var uid = __webpack_require__(96);
	module.exports = function (key) {
	  return shared[key] || (shared[key] = uid(key));
	};


/***/ },
/* 252 */
/***/ function(module, exports, __webpack_require__) {

	// helper for String#{startsWith, endsWith, includes}
	var isRegExp = __webpack_require__(169);
	var defined = __webpack_require__(62);
	
	module.exports = function (that, searchString, NAME) {
	  if (isRegExp(searchString)) throw TypeError('String#' + NAME + " doesn't accept regex!");
	  return String(defined(that));
	};


/***/ },
/* 253 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var toInteger = __webpack_require__(57);
	var defined = __webpack_require__(62);
	
	module.exports = function repeat(count) {
	  var str = String(defined(this));
	  var res = '';
	  var n = toInteger(count);
	  if (n < 0 || n == Infinity) throw RangeError("Count can't be negative");
	  for (;n > 0; (n >>>= 1) && (str += str)) if (n & 1) res += str;
	  return res;
	};


/***/ },
/* 254 */
/***/ function(module, exports) {

	module.exports = '\x09\x0A\x0B\x0C\x0D\x20\xA0\u1680\u180E\u2000\u2001\u2002\u2003' +
	  '\u2004\u2005\u2006\u2007\u2008\u2009\u200A\u202F\u205F\u3000\u2028\u2029\uFEFF';


/***/ },
/* 255 */
/***/ function(module, exports, __webpack_require__) {

	var ctx = __webpack_require__(55);
	var invoke = __webpack_require__(362);
	var html = __webpack_require__(240);
	var cel = __webpack_require__(237);
	var global = __webpack_require__(17);
	var process = global.process;
	var setTask = global.setImmediate;
	var clearTask = global.clearImmediate;
	var MessageChannel = global.MessageChannel;
	var Dispatch = global.Dispatch;
	var counter = 0;
	var queue = {};
	var ONREADYSTATECHANGE = 'onreadystatechange';
	var defer, channel, port;
	var run = function () {
	  var id = +this;
	  // eslint-disable-next-line no-prototype-builtins
	  if (queue.hasOwnProperty(id)) {
	    var fn = queue[id];
	    delete queue[id];
	    fn();
	  }
	};
	var listener = function (event) {
	  run.call(event.data);
	};
	// Node.js 0.9+ & IE10+ has setImmediate, otherwise:
	if (!setTask || !clearTask) {
	  setTask = function setImmediate(fn) {
	    var args = [];
	    var i = 1;
	    while (arguments.length > i) args.push(arguments[i++]);
	    queue[++counter] = function () {
	      // eslint-disable-next-line no-new-func
	      invoke(typeof fn == 'function' ? fn : Function(fn), args);
	    };
	    defer(counter);
	    return counter;
	  };
	  clearTask = function clearImmediate(id) {
	    delete queue[id];
	  };
	  // Node.js 0.8-
	  if (__webpack_require__(53)(process) == 'process') {
	    defer = function (id) {
	      process.nextTick(ctx(run, id, 1));
	    };
	  // Sphere (JS game engine) Dispatch API
	  } else if (Dispatch && Dispatch.now) {
	    defer = function (id) {
	      Dispatch.now(ctx(run, id, 1));
	    };
	  // Browsers with MessageChannel, includes WebWorkers
	  } else if (MessageChannel) {
	    channel = new MessageChannel();
	    port = channel.port2;
	    channel.port1.onmessage = listener;
	    defer = ctx(port.postMessage, port, 1);
	  // Browsers with postMessage, skip WebWorkers
	  // IE8 has postMessage, but it's sync & typeof its postMessage is 'object'
	  } else if (global.addEventListener && typeof postMessage == 'function' && !global.importScripts) {
	    defer = function (id) {
	      global.postMessage(id + '', '*');
	    };
	    global.addEventListener('message', listener, false);
	  // IE8-
	  } else if (ONREADYSTATECHANGE in cel('script')) {
	    defer = function (id) {
	      html.appendChild(cel('script'))[ONREADYSTATECHANGE] = function () {
	        html.removeChild(this);
	        run.call(id);
	      };
	    };
	  // Rest old browsers
	  } else {
	    defer = function (id) {
	      setTimeout(ctx(run, id, 1), 0);
	    };
	  }
	}
	module.exports = {
	  set: setTask,
	  clear: clearTask
	};


/***/ },
/* 256 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var global = __webpack_require__(17);
	var DESCRIPTORS = __webpack_require__(28);
	var LIBRARY = __webpack_require__(82);
	var $typed = __webpack_require__(177);
	var hide = __webpack_require__(40);
	var redefineAll = __webpack_require__(93);
	var fails = __webpack_require__(21);
	var anInstance = __webpack_require__(87);
	var toInteger = __webpack_require__(57);
	var toLength = __webpack_require__(27);
	var toIndex = __webpack_require__(381);
	var gOPN = __webpack_require__(90).f;
	var dP = __webpack_require__(32).f;
	var arrayFill = __webpack_require__(234);
	var setToStringTag = __webpack_require__(109);
	var ARRAY_BUFFER = 'ArrayBuffer';
	var DATA_VIEW = 'DataView';
	var PROTOTYPE = 'prototype';
	var WRONG_LENGTH = 'Wrong length!';
	var WRONG_INDEX = 'Wrong index!';
	var $ArrayBuffer = global[ARRAY_BUFFER];
	var $DataView = global[DATA_VIEW];
	var Math = global.Math;
	var RangeError = global.RangeError;
	// eslint-disable-next-line no-shadow-restricted-names
	var Infinity = global.Infinity;
	var BaseBuffer = $ArrayBuffer;
	var abs = Math.abs;
	var pow = Math.pow;
	var floor = Math.floor;
	var log = Math.log;
	var LN2 = Math.LN2;
	var BUFFER = 'buffer';
	var BYTE_LENGTH = 'byteLength';
	var BYTE_OFFSET = 'byteOffset';
	var $BUFFER = DESCRIPTORS ? '_b' : BUFFER;
	var $LENGTH = DESCRIPTORS ? '_l' : BYTE_LENGTH;
	var $OFFSET = DESCRIPTORS ? '_o' : BYTE_OFFSET;
	
	// IEEE754 conversions based on https://github.com/feross/ieee754
	function packIEEE754(value, mLen, nBytes) {
	  var buffer = new Array(nBytes);
	  var eLen = nBytes * 8 - mLen - 1;
	  var eMax = (1 << eLen) - 1;
	  var eBias = eMax >> 1;
	  var rt = mLen === 23 ? pow(2, -24) - pow(2, -77) : 0;
	  var i = 0;
	  var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
	  var e, m, c;
	  value = abs(value);
	  // eslint-disable-next-line no-self-compare
	  if (value != value || value === Infinity) {
	    // eslint-disable-next-line no-self-compare
	    m = value != value ? 1 : 0;
	    e = eMax;
	  } else {
	    e = floor(log(value) / LN2);
	    if (value * (c = pow(2, -e)) < 1) {
	      e--;
	      c *= 2;
	    }
	    if (e + eBias >= 1) {
	      value += rt / c;
	    } else {
	      value += rt * pow(2, 1 - eBias);
	    }
	    if (value * c >= 2) {
	      e++;
	      c /= 2;
	    }
	    if (e + eBias >= eMax) {
	      m = 0;
	      e = eMax;
	    } else if (e + eBias >= 1) {
	      m = (value * c - 1) * pow(2, mLen);
	      e = e + eBias;
	    } else {
	      m = value * pow(2, eBias - 1) * pow(2, mLen);
	      e = 0;
	    }
	  }
	  for (; mLen >= 8; buffer[i++] = m & 255, m /= 256, mLen -= 8);
	  e = e << mLen | m;
	  eLen += mLen;
	  for (; eLen > 0; buffer[i++] = e & 255, e /= 256, eLen -= 8);
	  buffer[--i] |= s * 128;
	  return buffer;
	}
	function unpackIEEE754(buffer, mLen, nBytes) {
	  var eLen = nBytes * 8 - mLen - 1;
	  var eMax = (1 << eLen) - 1;
	  var eBias = eMax >> 1;
	  var nBits = eLen - 7;
	  var i = nBytes - 1;
	  var s = buffer[i--];
	  var e = s & 127;
	  var m;
	  s >>= 7;
	  for (; nBits > 0; e = e * 256 + buffer[i], i--, nBits -= 8);
	  m = e & (1 << -nBits) - 1;
	  e >>= -nBits;
	  nBits += mLen;
	  for (; nBits > 0; m = m * 256 + buffer[i], i--, nBits -= 8);
	  if (e === 0) {
	    e = 1 - eBias;
	  } else if (e === eMax) {
	    return m ? NaN : s ? -Infinity : Infinity;
	  } else {
	    m = m + pow(2, mLen);
	    e = e - eBias;
	  } return (s ? -1 : 1) * m * pow(2, e - mLen);
	}
	
	function unpackI32(bytes) {
	  return bytes[3] << 24 | bytes[2] << 16 | bytes[1] << 8 | bytes[0];
	}
	function packI8(it) {
	  return [it & 0xff];
	}
	function packI16(it) {
	  return [it & 0xff, it >> 8 & 0xff];
	}
	function packI32(it) {
	  return [it & 0xff, it >> 8 & 0xff, it >> 16 & 0xff, it >> 24 & 0xff];
	}
	function packF64(it) {
	  return packIEEE754(it, 52, 8);
	}
	function packF32(it) {
	  return packIEEE754(it, 23, 4);
	}
	
	function addGetter(C, key, internal) {
	  dP(C[PROTOTYPE], key, { get: function () { return this[internal]; } });
	}
	
	function get(view, bytes, index, isLittleEndian) {
	  var numIndex = +index;
	  var intIndex = toIndex(numIndex);
	  if (intIndex + bytes > view[$LENGTH]) throw RangeError(WRONG_INDEX);
	  var store = view[$BUFFER]._b;
	  var start = intIndex + view[$OFFSET];
	  var pack = store.slice(start, start + bytes);
	  return isLittleEndian ? pack : pack.reverse();
	}
	function set(view, bytes, index, conversion, value, isLittleEndian) {
	  var numIndex = +index;
	  var intIndex = toIndex(numIndex);
	  if (intIndex + bytes > view[$LENGTH]) throw RangeError(WRONG_INDEX);
	  var store = view[$BUFFER]._b;
	  var start = intIndex + view[$OFFSET];
	  var pack = conversion(+value);
	  for (var i = 0; i < bytes; i++) store[start + i] = pack[isLittleEndian ? i : bytes - i - 1];
	}
	
	if (!$typed.ABV) {
	  $ArrayBuffer = function ArrayBuffer(length) {
	    anInstance(this, $ArrayBuffer, ARRAY_BUFFER);
	    var byteLength = toIndex(length);
	    this._b = arrayFill.call(new Array(byteLength), 0);
	    this[$LENGTH] = byteLength;
	  };
	
	  $DataView = function DataView(buffer, byteOffset, byteLength) {
	    anInstance(this, $DataView, DATA_VIEW);
	    anInstance(buffer, $ArrayBuffer, DATA_VIEW);
	    var bufferLength = buffer[$LENGTH];
	    var offset = toInteger(byteOffset);
	    if (offset < 0 || offset > bufferLength) throw RangeError('Wrong offset!');
	    byteLength = byteLength === undefined ? bufferLength - offset : toLength(byteLength);
	    if (offset + byteLength > bufferLength) throw RangeError(WRONG_LENGTH);
	    this[$BUFFER] = buffer;
	    this[$OFFSET] = offset;
	    this[$LENGTH] = byteLength;
	  };
	
	  if (DESCRIPTORS) {
	    addGetter($ArrayBuffer, BYTE_LENGTH, '_l');
	    addGetter($DataView, BUFFER, '_b');
	    addGetter($DataView, BYTE_LENGTH, '_l');
	    addGetter($DataView, BYTE_OFFSET, '_o');
	  }
	
	  redefineAll($DataView[PROTOTYPE], {
	    getInt8: function getInt8(byteOffset) {
	      return get(this, 1, byteOffset)[0] << 24 >> 24;
	    },
	    getUint8: function getUint8(byteOffset) {
	      return get(this, 1, byteOffset)[0];
	    },
	    getInt16: function getInt16(byteOffset /* , littleEndian */) {
	      var bytes = get(this, 2, byteOffset, arguments[1]);
	      return (bytes[1] << 8 | bytes[0]) << 16 >> 16;
	    },
	    getUint16: function getUint16(byteOffset /* , littleEndian */) {
	      var bytes = get(this, 2, byteOffset, arguments[1]);
	      return bytes[1] << 8 | bytes[0];
	    },
	    getInt32: function getInt32(byteOffset /* , littleEndian */) {
	      return unpackI32(get(this, 4, byteOffset, arguments[1]));
	    },
	    getUint32: function getUint32(byteOffset /* , littleEndian */) {
	      return unpackI32(get(this, 4, byteOffset, arguments[1])) >>> 0;
	    },
	    getFloat32: function getFloat32(byteOffset /* , littleEndian */) {
	      return unpackIEEE754(get(this, 4, byteOffset, arguments[1]), 23, 4);
	    },
	    getFloat64: function getFloat64(byteOffset /* , littleEndian */) {
	      return unpackIEEE754(get(this, 8, byteOffset, arguments[1]), 52, 8);
	    },
	    setInt8: function setInt8(byteOffset, value) {
	      set(this, 1, byteOffset, packI8, value);
	    },
	    setUint8: function setUint8(byteOffset, value) {
	      set(this, 1, byteOffset, packI8, value);
	    },
	    setInt16: function setInt16(byteOffset, value /* , littleEndian */) {
	      set(this, 2, byteOffset, packI16, value, arguments[2]);
	    },
	    setUint16: function setUint16(byteOffset, value /* , littleEndian */) {
	      set(this, 2, byteOffset, packI16, value, arguments[2]);
	    },
	    setInt32: function setInt32(byteOffset, value /* , littleEndian */) {
	      set(this, 4, byteOffset, packI32, value, arguments[2]);
	    },
	    setUint32: function setUint32(byteOffset, value /* , littleEndian */) {
	      set(this, 4, byteOffset, packI32, value, arguments[2]);
	    },
	    setFloat32: function setFloat32(byteOffset, value /* , littleEndian */) {
	      set(this, 4, byteOffset, packF32, value, arguments[2]);
	    },
	    setFloat64: function setFloat64(byteOffset, value /* , littleEndian */) {
	      set(this, 8, byteOffset, packF64, value, arguments[2]);
	    }
	  });
	} else {
	  if (!fails(function () {
	    $ArrayBuffer(1);
	  }) || !fails(function () {
	    new $ArrayBuffer(-1); // eslint-disable-line no-new
	  }) || fails(function () {
	    new $ArrayBuffer(); // eslint-disable-line no-new
	    new $ArrayBuffer(1.5); // eslint-disable-line no-new
	    new $ArrayBuffer(NaN); // eslint-disable-line no-new
	    return $ArrayBuffer.name != ARRAY_BUFFER;
	  })) {
	    $ArrayBuffer = function ArrayBuffer(length) {
	      anInstance(this, $ArrayBuffer);
	      return new BaseBuffer(toIndex(length));
	    };
	    var ArrayBufferProto = $ArrayBuffer[PROTOTYPE] = BaseBuffer[PROTOTYPE];
	    for (var keys = gOPN(BaseBuffer), j = 0, key; keys.length > j;) {
	      if (!((key = keys[j++]) in $ArrayBuffer)) hide($ArrayBuffer, key, BaseBuffer[key]);
	    }
	    if (!LIBRARY) ArrayBufferProto.constructor = $ArrayBuffer;
	  }
	  // iOS Safari 7.x bug
	  var view = new $DataView(new $ArrayBuffer(2));
	  var $setInt8 = $DataView[PROTOTYPE].setInt8;
	  view.setInt8(0, 2147483648);
	  view.setInt8(1, 2147483649);
	  if (view.getInt8(0) || !view.getInt8(1)) redefineAll($DataView[PROTOTYPE], {
	    setInt8: function setInt8(byteOffset, value) {
	      $setInt8.call(this, byteOffset, value << 24 >> 24);
	    },
	    setUint8: function setUint8(byteOffset, value) {
	      $setInt8.call(this, byteOffset, value << 24 >> 24);
	    }
	  }, true);
	}
	setToStringTag($ArrayBuffer, ARRAY_BUFFER);
	setToStringTag($DataView, DATA_VIEW);
	hide($DataView[PROTOTYPE], $typed.VIEW, true);
	exports[ARRAY_BUFFER] = $ArrayBuffer;
	exports[DATA_VIEW] = $DataView;


/***/ },
/* 257 */
/***/ function(module, exports, __webpack_require__) {

	var global = __webpack_require__(17);
	var core = __webpack_require__(54);
	var LIBRARY = __webpack_require__(82);
	var wksExt = __webpack_require__(382);
	var defineProperty = __webpack_require__(32).f;
	module.exports = function (name) {
	  var $Symbol = core.Symbol || (core.Symbol = LIBRARY ? {} : global.Symbol || {});
	  if (name.charAt(0) != '_' && !(name in $Symbol)) defineProperty($Symbol, name, { value: wksExt.f(name) });
	};


/***/ },
/* 258 */
/***/ function(module, exports, __webpack_require__) {

	var classof = __webpack_require__(107);
	var ITERATOR = __webpack_require__(26)('iterator');
	var Iterators = __webpack_require__(108);
	module.exports = __webpack_require__(54).getIteratorMethod = function (it) {
	  if (it != undefined) return it[ITERATOR]
	    || it['@@iterator']
	    || Iterators[classof(it)];
	};


/***/ },
/* 259 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var addToUnscopables = __webpack_require__(81);
	var step = __webpack_require__(365);
	var Iterators = __webpack_require__(108);
	var toIObject = __webpack_require__(49);
	
	// 22.1.3.4 Array.prototype.entries()
	// 22.1.3.13 Array.prototype.keys()
	// 22.1.3.29 Array.prototype.values()
	// 22.1.3.30 Array.prototype[@@iterator]()
	module.exports = __webpack_require__(244)(Array, 'Array', function (iterated, kind) {
	  this._t = toIObject(iterated); // target
	  this._i = 0;                   // next index
	  this._k = kind;                // kind
	// 22.1.5.2.1 %ArrayIteratorPrototype%.next()
	}, function () {
	  var O = this._t;
	  var kind = this._k;
	  var index = this._i++;
	  if (!O || index >= O.length) {
	    this._t = undefined;
	    return step(1);
	  }
	  if (kind == 'keys') return step(0, index);
	  if (kind == 'values') return step(0, O[index]);
	  return step(0, [index, O[index]]);
	}, 'values');
	
	// argumentsList[@@iterator] is %ArrayProto_values% (9.4.4.6, 9.4.4.7)
	Iterators.Arguments = Iterators.Array;
	
	addToUnscopables('keys');
	addToUnscopables('values');
	addToUnscopables('entries');


/***/ },
/* 260 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = getUTCWeekYear;
	
	var _index = _interopRequireDefault(__webpack_require__(9));
	
	var _index2 = _interopRequireDefault(__webpack_require__(3));
	
	var _index3 = _interopRequireDefault(__webpack_require__(180));
	
	var _index4 = _interopRequireDefault(__webpack_require__(2));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// This function will be a part of public API when UTC function will be implemented.
	// See issue: https://github.com/date-fns/date-fns/issues/376
	function getUTCWeekYear(dirtyDate, dirtyOptions) {
	  (0, _index4.default)(1, arguments);
	  var date = (0, _index2.default)(dirtyDate, dirtyOptions);
	  var year = date.getUTCFullYear();
	  var options = dirtyOptions || {};
	  var locale = options.locale;
	  var localeFirstWeekContainsDate = locale && locale.options && locale.options.firstWeekContainsDate;
	  var defaultFirstWeekContainsDate = localeFirstWeekContainsDate == null ? 1 : (0, _index.default)(localeFirstWeekContainsDate);
	  var firstWeekContainsDate = options.firstWeekContainsDate == null ? defaultFirstWeekContainsDate : (0, _index.default)(options.firstWeekContainsDate); // Test if weekStartsOn is between 1 and 7 _and_ is not NaN
	
	  if (!(firstWeekContainsDate >= 1 && firstWeekContainsDate <= 7)) {
	    throw new RangeError('firstWeekContainsDate must be between 1 and 7 inclusively');
	  }
	
	  var firstWeekOfNextYear = new Date(0);
	  firstWeekOfNextYear.setUTCFullYear(year + 1, 0, firstWeekContainsDate);
	  firstWeekOfNextYear.setUTCHours(0, 0, 0, 0);
	  var startOfNextYear = (0, _index3.default)(firstWeekOfNextYear, dirtyOptions);
	  var firstWeekOfThisYear = new Date(0);
	  firstWeekOfThisYear.setUTCFullYear(year, 0, firstWeekContainsDate);
	  firstWeekOfThisYear.setUTCHours(0, 0, 0, 0);
	  var startOfThisYear = (0, _index3.default)(firstWeekOfThisYear, dirtyOptions);
	
	  if (date.getTime() >= startOfNextYear.getTime()) {
	    return year + 1;
	  } else if (date.getTime() >= startOfThisYear.getTime()) {
	    return year;
	  } else {
	    return year - 1;
	  }
	}
	
	module.exports = exports.default;

/***/ },
/* 261 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = addMinutes;
	
	var _index = _interopRequireDefault(__webpack_require__(9));
	
	var _index2 = _interopRequireDefault(__webpack_require__(137));
	
	var _index3 = _interopRequireDefault(__webpack_require__(2));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MILLISECONDS_IN_MINUTE = 60000;
	/**
	 * @name addMinutes
	 * @category Minute Helpers
	 * @summary Add the specified number of minutes to the given date.
	 *
	 * @description
	 * Add the specified number of minutes to the given date.
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} date - the date to be changed
	 * @param {Number} amount - the amount of minutes to be added. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
	 * @returns {Date} the new date with the minutes added
	 * @throws {TypeError} 2 arguments required
	 *
	 * @example
	 * // Add 30 minutes to 10 July 2014 12:00:00:
	 * var result = addMinutes(new Date(2014, 6, 10, 12, 0), 30)
	 * //=> Thu Jul 10 2014 12:30:00
	 */
	
	function addMinutes(dirtyDate, dirtyAmount) {
	  (0, _index3.default)(2, arguments);
	  var amount = (0, _index.default)(dirtyAmount);
	  return (0, _index2.default)(dirtyDate, amount * MILLISECONDS_IN_MINUTE);
	}
	
	module.exports = exports.default;

/***/ },
/* 262 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = addQuarters;
	
	var _index = _interopRequireDefault(__webpack_require__(9));
	
	var _index2 = _interopRequireDefault(__webpack_require__(112));
	
	var _index3 = _interopRequireDefault(__webpack_require__(2));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name addQuarters
	 * @category Quarter Helpers
	 * @summary Add the specified number of year quarters to the given date.
	 *
	 * @description
	 * Add the specified number of year quarters to the given date.
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} date - the date to be changed
	 * @param {Number} amount - the amount of quarters to be added. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
	 * @returns {Date} the new date with the quarters added
	 * @throws {TypeError} 2 arguments required
	 *
	 * @example
	 * // Add 1 quarter to 1 September 2014:
	 * var result = addQuarters(new Date(2014, 8, 1), 1)
	 * //=> Mon Dec 01 2014 00:00:00
	 */
	function addQuarters(dirtyDate, dirtyAmount) {
	  (0, _index3.default)(2, arguments);
	  var amount = (0, _index.default)(dirtyAmount);
	  var months = amount * 3;
	  return (0, _index2.default)(dirtyDate, months);
	}
	
	module.exports = exports.default;

/***/ },
/* 263 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = addYears;
	
	var _index = _interopRequireDefault(__webpack_require__(9));
	
	var _index2 = _interopRequireDefault(__webpack_require__(112));
	
	var _index3 = _interopRequireDefault(__webpack_require__(2));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name addYears
	 * @category Year Helpers
	 * @summary Add the specified number of years to the given date.
	 *
	 * @description
	 * Add the specified number of years to the given date.
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} date - the date to be changed
	 * @param {Number} amount - the amount of years to be added. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
	 * @returns {Date} the new date with the years added
	 * @throws {TypeError} 2 arguments required
	 *
	 * @example
	 * // Add 5 years to 1 September 2014:
	 * var result = addYears(new Date(2014, 8, 1), 5)
	 * //=> Sun Sep 01 2019 00:00:00
	 */
	function addYears(dirtyDate, dirtyAmount) {
	  (0, _index3.default)(2, arguments);
	  var amount = (0, _index.default)(dirtyAmount);
	  return (0, _index2.default)(dirtyDate, amount * 12);
	}
	
	module.exports = exports.default;

/***/ },
/* 264 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = differenceInCalendarMonths;
	
	var _index = _interopRequireDefault(__webpack_require__(3));
	
	var _index2 = _interopRequireDefault(__webpack_require__(2));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name differenceInCalendarMonths
	 * @category Month Helpers
	 * @summary Get the number of calendar months between the given dates.
	 *
	 * @description
	 * Get the number of calendar months between the given dates.
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} dateLeft - the later date
	 * @param {Date|Number} dateRight - the earlier date
	 * @returns {Number} the number of calendar months
	 * @throws {TypeError} 2 arguments required
	 *
	 * @example
	 * // How many calendar months are between 31 January 2014 and 1 September 2014?
	 * var result = differenceInCalendarMonths(
	 *   new Date(2014, 8, 1),
	 *   new Date(2014, 0, 31)
	 * )
	 * //=> 8
	 */
	function differenceInCalendarMonths(dirtyDateLeft, dirtyDateRight) {
	  (0, _index2.default)(2, arguments);
	  var dateLeft = (0, _index.default)(dirtyDateLeft);
	  var dateRight = (0, _index.default)(dirtyDateRight);
	  var yearDiff = dateLeft.getFullYear() - dateRight.getFullYear();
	  var monthDiff = dateLeft.getMonth() - dateRight.getMonth();
	  return yearDiff * 12 + monthDiff;
	}
	
	module.exports = exports.default;

/***/ },
/* 265 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = differenceInCalendarWeeks;
	
	var _index = _interopRequireDefault(__webpack_require__(75));
	
	var _index2 = _interopRequireDefault(__webpack_require__(73));
	
	var _index3 = _interopRequireDefault(__webpack_require__(2));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MILLISECONDS_IN_WEEK = 604800000;
	/**
	 * @name differenceInCalendarWeeks
	 * @category Week Helpers
	 * @summary Get the number of calendar weeks between the given dates.
	 *
	 * @description
	 * Get the number of calendar weeks between the given dates.
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} dateLeft - the later date
	 * @param {Date|Number} dateRight - the earlier date
	 * @param {Object} [options] - an object with options.
	 * @param {Locale} [options.locale=defaultLocale] - the locale object. See [Locale]{@link https://date-fns.org/docs/Locale}
	 * @param {0|1|2|3|4|5|6} [options.weekStartsOn=0] - the index of the first day of the week (0 - Sunday)
	 * @returns {Number} the number of calendar weeks
	 * @throws {TypeError} 2 arguments required
	 * @throws {RangeError} `options.weekStartsOn` must be between 0 and 6
	 *
	 * @example
	 * // How many calendar weeks are between 5 July 2014 and 20 July 2014?
	 * var result = differenceInCalendarWeeks(
	 *   new Date(2014, 6, 20),
	 *   new Date(2014, 6, 5)
	 * )
	 * //=> 3
	 *
	 * @example
	 * // If the week starts on Monday,
	 * // how many calendar weeks are between 5 July 2014 and 20 July 2014?
	 * var result = differenceInCalendarWeeks(
	 *   new Date(2014, 6, 20),
	 *   new Date(2014, 6, 5),
	 *   { weekStartsOn: 1 }
	 * )
	 * //=> 2
	 */
	
	function differenceInCalendarWeeks(dirtyDateLeft, dirtyDateRight, dirtyOptions) {
	  (0, _index3.default)(2, arguments);
	  var startOfWeekLeft = (0, _index.default)(dirtyDateLeft, dirtyOptions);
	  var startOfWeekRight = (0, _index.default)(dirtyDateRight, dirtyOptions);
	  var timestampLeft = startOfWeekLeft.getTime() - (0, _index2.default)(startOfWeekLeft);
	  var timestampRight = startOfWeekRight.getTime() - (0, _index2.default)(startOfWeekRight); // Round the number of days to the nearest integer
	  // because the number of milliseconds in a week is not constant
	  // (e.g. it's different in the week of the daylight saving time clock shift)
	
	  return Math.round((timestampLeft - timestampRight) / MILLISECONDS_IN_WEEK);
	}
	
	module.exports = exports.default;

/***/ },
/* 266 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = differenceInCalendarYears;
	
	var _index = _interopRequireDefault(__webpack_require__(3));
	
	var _index2 = _interopRequireDefault(__webpack_require__(2));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name differenceInCalendarYears
	 * @category Year Helpers
	 * @summary Get the number of calendar years between the given dates.
	 *
	 * @description
	 * Get the number of calendar years between the given dates.
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} dateLeft - the later date
	 * @param {Date|Number} dateRight - the earlier date
	 * @returns {Number} the number of calendar years
	 * @throws {TypeError} 2 arguments required
	 *
	 * @example
	 * // How many calendar years are between 31 December 2013 and 11 February 2015?
	 * var result = differenceInCalendarYears(
	 *   new Date(2015, 1, 11),
	 *   new Date(2013, 11, 31)
	 * )
	 * //=> 2
	 */
	function differenceInCalendarYears(dirtyDateLeft, dirtyDateRight) {
	  (0, _index2.default)(2, arguments);
	  var dateLeft = (0, _index.default)(dirtyDateLeft);
	  var dateRight = (0, _index.default)(dirtyDateRight);
	  return dateLeft.getFullYear() - dateRight.getFullYear();
	}
	
	module.exports = exports.default;

/***/ },
/* 267 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = eachWeekendOfInterval;
	
	var _index = _interopRequireDefault(__webpack_require__(404));
	
	var _index2 = _interopRequireDefault(__webpack_require__(423));
	
	var _index3 = _interopRequireDefault(__webpack_require__(188));
	
	var _index4 = _interopRequireDefault(__webpack_require__(2));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name eachWeekendOfInterval
	 * @category Interval Helpers
	 * @summary List all the Saturdays and Sundays in the given date interval.
	 *
	 * @description
	 * Get all the Saturdays and Sundays in the given date interval.
	 *
	 * @param {Interval} interval - the given interval. See [Interval]{@link docs/types/Interval}
	 * @returns {Date[]} an array containing all the Saturdays and Sundays
	 * @throws {TypeError} 1 argument required
	 * @throws {RangeError} The start of an interval cannot be after its end
	 * @throws {RangeError} Date in interval cannot be `Invalid Date`
	 *
	 * @example
	 * // Lists all Saturdays and Sundays in the given date interval
	 * var result = eachWeekendOfInterval({
	 *   start: new Date(2018, 8, 17),
	 *   end: new Date(2018, 8, 30)
	 * })
	 * //=> [
	 * //   Sat Sep 22 2018 00:00:00,
	 * //   Sun Sep 23 2018 00:00:00,
	 * //   Sat Sep 29 2018 00:00:00,
	 * //   Sun Sep 30 2018 00:00:00
	 * // ]
	 */
	function eachWeekendOfInterval(interval) {
	  (0, _index4.default)(1, arguments);
	  var dateInterval = (0, _index.default)(interval);
	  var weekends = [];
	  var index = 0;
	
	  while (index < dateInterval.length) {
	    var date = dateInterval[index++];
	
	    if ((0, _index3.default)(date)) {
	      weekends.push(date);
	      if ((0, _index2.default)(date)) index = index + 5;
	    }
	  }
	
	  return weekends;
	}
	
	module.exports = exports.default;

/***/ },
/* 268 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = endOfWeek;
	
	var _index = _interopRequireDefault(__webpack_require__(3));
	
	var _index2 = _interopRequireDefault(__webpack_require__(9));
	
	var _index3 = _interopRequireDefault(__webpack_require__(2));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name endOfWeek
	 * @category Week Helpers
	 * @summary Return the end of a week for the given date.
	 *
	 * @description
	 * Return the end of a week for the given date.
	 * The result will be in the local timezone.
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} date - the original date
	 * @param {Object} [options] - an object with options.
	 * @param {Locale} [options.locale=defaultLocale] - the locale object. See [Locale]{@link https://date-fns.org/docs/Locale}
	 * @param {0|1|2|3|4|5|6} [options.weekStartsOn=0] - the index of the first day of the week (0 - Sunday)
	 * @returns {Date} the end of a week
	 * @throws {TypeError} 1 argument required
	 * @throws {RangeError} `options.weekStartsOn` must be between 0 and 6
	 *
	 * @example
	 * // The end of a week for 2 September 2014 11:55:00:
	 * var result = endOfWeek(new Date(2014, 8, 2, 11, 55, 0))
	 * //=> Sat Sep 06 2014 23:59:59.999
	 *
	 * @example
	 * // If the week starts on Monday, the end of the week for 2 September 2014 11:55:00:
	 * var result = endOfWeek(new Date(2014, 8, 2, 11, 55, 0), { weekStartsOn: 1 })
	 * //=> Sun Sep 07 2014 23:59:59.999
	 */
	function endOfWeek(dirtyDate, dirtyOptions) {
	  (0, _index3.default)(1, arguments);
	  var options = dirtyOptions || {};
	  var locale = options.locale;
	  var localeWeekStartsOn = locale && locale.options && locale.options.weekStartsOn;
	  var defaultWeekStartsOn = localeWeekStartsOn == null ? 0 : (0, _index2.default)(localeWeekStartsOn);
	  var weekStartsOn = options.weekStartsOn == null ? defaultWeekStartsOn : (0, _index2.default)(options.weekStartsOn); // Test if weekStartsOn is between 0 and 6 _and_ is not NaN
	
	  if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) {
	    throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
	  }
	
	  var date = (0, _index.default)(dirtyDate);
	  var day = date.getDay();
	  var diff = (day < weekStartsOn ? -7 : 0) + 6 - (day - weekStartsOn);
	  date.setDate(date.getDate() + diff);
	  date.setHours(23, 59, 59, 999);
	  return date;
	}
	
	module.exports = exports.default;

/***/ },
/* 269 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = getDate;
	
	var _index = _interopRequireDefault(__webpack_require__(3));
	
	var _index2 = _interopRequireDefault(__webpack_require__(2));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name getDate
	 * @category Day Helpers
	 * @summary Get the day of the month of the given date.
	 *
	 * @description
	 * Get the day of the month of the given date.
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} date - the given date
	 * @returns {Number} the day of month
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // Which day of the month is 29 February 2012?
	 * var result = getDate(new Date(2012, 1, 29))
	 * //=> 29
	 */
	function getDate(dirtyDate) {
	  (0, _index2.default)(1, arguments);
	  var date = (0, _index.default)(dirtyDate);
	  var dayOfMonth = date.getDate();
	  return dayOfMonth;
	}
	
	module.exports = exports.default;

/***/ },
/* 270 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = getDay;
	
	var _index = _interopRequireDefault(__webpack_require__(3));
	
	var _index2 = _interopRequireDefault(__webpack_require__(2));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name getDay
	 * @category Weekday Helpers
	 * @summary Get the day of the week of the given date.
	 *
	 * @description
	 * Get the day of the week of the given date.
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} date - the given date
	 * @returns {0|1|2|3|4|5|6} the day of week
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // Which day of the week is 29 February 2012?
	 * var result = getDay(new Date(2012, 1, 29))
	 * //=> 3
	 */
	function getDay(dirtyDate) {
	  (0, _index2.default)(1, arguments);
	  var date = (0, _index.default)(dirtyDate);
	  var day = date.getDay();
	  return day;
	}
	
	module.exports = exports.default;

/***/ },
/* 271 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = getQuarter;
	
	var _index = _interopRequireDefault(__webpack_require__(3));
	
	var _index2 = _interopRequireDefault(__webpack_require__(2));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name getQuarter
	 * @category Quarter Helpers
	 * @summary Get the year quarter of the given date.
	 *
	 * @description
	 * Get the year quarter of the given date.
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} date - the given date
	 * @returns {Number} the quarter
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // Which quarter is 2 July 2014?
	 * var result = getQuarter(new Date(2014, 6, 2))
	 * //=> 3
	 */
	function getQuarter(dirtyDate) {
	  (0, _index2.default)(1, arguments);
	  var date = (0, _index.default)(dirtyDate);
	  var quarter = Math.floor(date.getMonth() / 3) + 1;
	  return quarter;
	}
	
	module.exports = exports.default;

/***/ },
/* 272 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = getTime;
	
	var _index = _interopRequireDefault(__webpack_require__(3));
	
	var _index2 = _interopRequireDefault(__webpack_require__(2));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name getTime
	 * @category Timestamp Helpers
	 * @summary Get the milliseconds timestamp of the given date.
	 *
	 * @description
	 * Get the milliseconds timestamp of the given date.
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} date - the given date
	 * @returns {Number} the timestamp
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // Get the timestamp of 29 February 2012 11:45:05.123:
	 * var result = getTime(new Date(2012, 1, 29, 11, 45, 5, 123))
	 * //=> 1330515905123
	 */
	function getTime(dirtyDate) {
	  (0, _index2.default)(1, arguments);
	  var date = (0, _index.default)(dirtyDate);
	  var timestamp = date.getTime();
	  return timestamp;
	}
	
	module.exports = exports.default;

/***/ },
/* 273 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = getWeek;
	
	var _index = _interopRequireDefault(__webpack_require__(75));
	
	var _index2 = _interopRequireDefault(__webpack_require__(281));
	
	var _index3 = _interopRequireDefault(__webpack_require__(3));
	
	var _index4 = _interopRequireDefault(__webpack_require__(2));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MILLISECONDS_IN_WEEK = 604800000;
	/**
	 * @name getWeek
	 * @category Week Helpers
	 * @summary Get the local week index of the given date.
	 *
	 * @description
	 * Get the local week index of the given date.
	 * The exact calculation depends on the values of
	 * `options.weekStartsOn` (which is the index of the first day of the week)
	 * and `options.firstWeekContainsDate` (which is the day of January, which is always in
	 * the first week of the week-numbering year)
	 *
	 * Week numbering: https://en.wikipedia.org/wiki/Week#Week_numbering
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} date - the given date
	 * @param {Object} [options] - an object with options.
	 * @param {Locale} [options.locale=defaultLocale] - the locale object. See [Locale]{@link https://date-fns.org/docs/Locale}
	 * @param {0|1|2|3|4|5|6} [options.weekStartsOn=0] - the index of the first day of the week (0 - Sunday)
	 * @param {1|2|3|4|5|6|7} [options.firstWeekContainsDate=1] - the day of January, which is always in the first week of the year
	 * @returns {Number} the week
	 * @throws {TypeError} 1 argument required
	 * @throws {RangeError} `options.weekStartsOn` must be between 0 and 6
	 * @throws {RangeError} `options.firstWeekContainsDate` must be between 1 and 7
	 *
	 * @example
	 * // Which week of the local week numbering year is 2 January 2005 with default options?
	 * var result = getISOWeek(new Date(2005, 0, 2))
	 * //=> 2
	 *
	 * // Which week of the local week numbering year is 2 January 2005,
	 * // if Monday is the first day of the week,
	 * // and the first week of the year always contains 4 January?
	 * var result = getISOWeek(new Date(2005, 0, 2), {
	 *   weekStartsOn: 1,
	 *   firstWeekContainsDate: 4
	 * })
	 * //=> 53
	 */
	
	function getWeek(dirtyDate, options) {
	  (0, _index4.default)(1, arguments);
	  var date = (0, _index3.default)(dirtyDate);
	  var diff = (0, _index.default)(date, options).getTime() - (0, _index2.default)(date, options).getTime(); // Round the number of days to the nearest integer
	  // because the number of milliseconds in a week is not constant
	  // (e.g. it's different in the week of the daylight saving time clock shift)
	
	  return Math.round(diff / MILLISECONDS_IN_WEEK) + 1;
	}
	
	module.exports = exports.default;

/***/ },
/* 274 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isDate;
	
	var _index = _interopRequireDefault(__webpack_require__(2));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name isDate
	 * @category Common Helpers
	 * @summary Is the given value a date?
	 *
	 * @description
	 * Returns true if the given value is an instance of Date. The function works for dates transferred across iframes.
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {*} value - the value to check
	 * @returns {boolean} true if the given value is a date
	 * @throws {TypeError} 1 arguments required
	 *
	 * @example
	 * // For a valid date:
	 * var result = isDate(new Date())
	 * //=> true
	 *
	 * @example
	 * // For an invalid date:
	 * var result = isDate(new Date(NaN))
	 * //=> true
	 *
	 * @example
	 * // For some value:
	 * var result = isDate('2014-02-31')
	 * //=> false
	 *
	 * @example
	 * // For an object:
	 * var result = isDate({})
	 * //=> false
	 */
	function isDate(value) {
	  (0, _index.default)(1, arguments);
	  return value instanceof Date || typeof value === 'object' && Object.prototype.toString.call(value) === '[object Date]';
	}
	
	module.exports = exports.default;

/***/ },
/* 275 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isEqual;
	
	var _index = _interopRequireDefault(__webpack_require__(3));
	
	var _index2 = _interopRequireDefault(__webpack_require__(2));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name isEqual
	 * @category Common Helpers
	 * @summary Are the given dates equal?
	 *
	 * @description
	 * Are the given dates equal?
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} dateLeft - the first date to compare
	 * @param {Date|Number} dateRight - the second date to compare
	 * @returns {Boolean} the dates are equal
	 * @throws {TypeError} 2 arguments required
	 *
	 * @example
	 * // Are 2 July 2014 06:30:45.000 and 2 July 2014 06:30:45.500 equal?
	 * var result = isEqual(
	 *   new Date(2014, 6, 2, 6, 30, 45, 0),
	 *   new Date(2014, 6, 2, 6, 30, 45, 500)
	 * )
	 * //=> false
	 */
	function isEqual(dirtyLeftDate, dirtyRightDate) {
	  (0, _index2.default)(2, arguments);
	  var dateLeft = (0, _index.default)(dirtyLeftDate);
	  var dateRight = (0, _index.default)(dirtyRightDate);
	  return dateLeft.getTime() === dateRight.getTime();
	}
	
	module.exports = exports.default;

/***/ },
/* 276 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isSameMonth;
	
	var _index = _interopRequireDefault(__webpack_require__(3));
	
	var _index2 = _interopRequireDefault(__webpack_require__(2));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name isSameMonth
	 * @category Month Helpers
	 * @summary Are the given dates in the same month?
	 *
	 * @description
	 * Are the given dates in the same month?
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} dateLeft - the first date to check
	 * @param {Date|Number} dateRight - the second date to check
	 * @returns {Boolean} the dates are in the same month
	 * @throws {TypeError} 2 arguments required
	 *
	 * @example
	 * // Are 2 September 2014 and 25 September 2014 in the same month?
	 * var result = isSameMonth(new Date(2014, 8, 2), new Date(2014, 8, 25))
	 * //=> true
	 */
	function isSameMonth(dirtyDateLeft, dirtyDateRight) {
	  (0, _index2.default)(2, arguments);
	  var dateLeft = (0, _index.default)(dirtyDateLeft);
	  var dateRight = (0, _index.default)(dirtyDateRight);
	  return dateLeft.getFullYear() === dateRight.getFullYear() && dateLeft.getMonth() === dateRight.getMonth();
	}
	
	module.exports = exports.default;

/***/ },
/* 277 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isSameQuarter;
	
	var _index = _interopRequireDefault(__webpack_require__(190));
	
	var _index2 = _interopRequireDefault(__webpack_require__(2));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name isSameQuarter
	 * @category Quarter Helpers
	 * @summary Are the given dates in the same year quarter?
	 *
	 * @description
	 * Are the given dates in the same year quarter?
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} dateLeft - the first date to check
	 * @param {Date|Number} dateRight - the second date to check
	 * @returns {Boolean} the dates are in the same quarter
	 * @throws {TypeError} 2 arguments required
	 *
	 * @example
	 * // Are 1 January 2014 and 8 March 2014 in the same quarter?
	 * var result = isSameQuarter(new Date(2014, 0, 1), new Date(2014, 2, 8))
	 * //=> true
	 */
	function isSameQuarter(dirtyDateLeft, dirtyDateRight) {
	  (0, _index2.default)(2, arguments);
	  var dateLeftStartOfQuarter = (0, _index.default)(dirtyDateLeft);
	  var dateRightStartOfQuarter = (0, _index.default)(dirtyDateRight);
	  return dateLeftStartOfQuarter.getTime() === dateRightStartOfQuarter.getTime();
	}
	
	module.exports = exports.default;

/***/ },
/* 278 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isSameWeek;
	
	var _index = _interopRequireDefault(__webpack_require__(75));
	
	var _index2 = _interopRequireDefault(__webpack_require__(2));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name isSameWeek
	 * @category Week Helpers
	 * @summary Are the given dates in the same week?
	 *
	 * @description
	 * Are the given dates in the same week?
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} dateLeft - the first date to check
	 * @param {Date|Number} dateRight - the second date to check
	 * @param {Object} [options] - an object with options.
	 * @param {Locale} [options.locale=defaultLocale] - the locale object. See [Locale]{@link https://date-fns.org/docs/Locale}
	 * @param {0|1|2|3|4|5|6} [options.weekStartsOn=0] - the index of the first day of the week (0 - Sunday)
	 * @returns {Boolean} the dates are in the same week
	 * @throws {TypeError} 2 arguments required
	 * @throws {RangeError} `options.weekStartsOn` must be between 0 and 6
	 *
	 * @example
	 * // Are 31 August 2014 and 4 September 2014 in the same week?
	 * var result = isSameWeek(new Date(2014, 7, 31), new Date(2014, 8, 4))
	 * //=> true
	 *
	 * @example
	 * // If week starts with Monday,
	 * // are 31 August 2014 and 4 September 2014 in the same week?
	 * var result = isSameWeek(new Date(2014, 7, 31), new Date(2014, 8, 4), {
	 *   weekStartsOn: 1
	 * })
	 * //=> false
	 */
	function isSameWeek(dirtyDateLeft, dirtyDateRight, dirtyOptions) {
	  (0, _index2.default)(2, arguments);
	  var dateLeftStartOfWeek = (0, _index.default)(dirtyDateLeft, dirtyOptions);
	  var dateRightStartOfWeek = (0, _index.default)(dirtyDateRight, dirtyOptions);
	  return dateLeftStartOfWeek.getTime() === dateRightStartOfWeek.getTime();
	}
	
	module.exports = exports.default;

/***/ },
/* 279 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isSameYear;
	
	var _index = _interopRequireDefault(__webpack_require__(3));
	
	var _index2 = _interopRequireDefault(__webpack_require__(2));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name isSameYear
	 * @category Year Helpers
	 * @summary Are the given dates in the same year?
	 *
	 * @description
	 * Are the given dates in the same year?
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} dateLeft - the first date to check
	 * @param {Date|Number} dateRight - the second date to check
	 * @returns {Boolean} the dates are in the same year
	 * @throws {TypeError} 2 arguments required
	 *
	 * @example
	 * // Are 2 September 2014 and 25 September 2014 in the same year?
	 * var result = isSameYear(new Date(2014, 8, 2), new Date(2014, 8, 25))
	 * //=> true
	 */
	function isSameYear(dirtyDateLeft, dirtyDateRight) {
	  (0, _index2.default)(2, arguments);
	  var dateLeft = (0, _index.default)(dirtyDateLeft);
	  var dateRight = (0, _index.default)(dirtyDateRight);
	  return dateLeft.getFullYear() === dateRight.getFullYear();
	}
	
	module.exports = exports.default;

/***/ },
/* 280 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = parseISO;
	
	var _index = _interopRequireDefault(__webpack_require__(9));
	
	var _index2 = _interopRequireDefault(__webpack_require__(2));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MILLISECONDS_IN_HOUR = 3600000;
	var MILLISECONDS_IN_MINUTE = 60000;
	var DEFAULT_ADDITIONAL_DIGITS = 2;
	var patterns = {
	  dateTimeDelimiter: /[T ]/,
	  timeZoneDelimiter: /[Z ]/i,
	  timezone: /([Z+-].*)$/
	};
	var dateRegex = /^-?(?:(\d{3})|(\d{2})(?:-?(\d{2}))?|W(\d{2})(?:-?(\d{1}))?|)$/;
	var timeRegex = /^(\d{2}(?:[.,]\d*)?)(?::?(\d{2}(?:[.,]\d*)?))?(?::?(\d{2}(?:[.,]\d*)?))?$/;
	var timezoneRegex = /^([+-])(\d{2})(?::?(\d{2}))?$/;
	/**
	 * @name parseISO
	 * @category Common Helpers
	 * @summary Parse ISO string
	 *
	 * @description
	 * Parse the given string in ISO 8601 format and return an instance of Date.
	 *
	 * Function accepts complete ISO 8601 formats as well as partial implementations.
	 * ISO 8601: http://en.wikipedia.org/wiki/ISO_8601
	 *
	 * If the argument isn't a string, the function cannot parse the string or
	 * the values are invalid, it returns Invalid Date.
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * - The previous `parse` implementation was renamed to `parseISO`.
	 *
	 *   ```javascript
	 *   // Before v2.0.0
	 *   parse('2016-01-01')
	 *
	 *   // v2.0.0 onward
	 *   parseISO('2016-01-01')
	 *   ```
	 *
	 * - `parseISO` now validates separate date and time values in ISO-8601 strings
	 *   and returns `Invalid Date` if the date is invalid.
	 *
	 *   ```javascript
	 *   parseISO('2018-13-32')
	 *   //=> Invalid Date
	 *   ```
	 *
	 * - `parseISO` now doesn't fall back to `new Date` constructor
	 *   if it fails to parse a string argument. Instead, it returns `Invalid Date`.
	 *
	 * @param {String} argument - the value to convert
	 * @param {Object} [options] - an object with options.
	 * @param {0|1|2} [options.additionalDigits=2] - the additional number of digits in the extended year format
	 * @returns {Date} the parsed date in the local time zone
	 * @throws {TypeError} 1 argument required
	 * @throws {RangeError} `options.additionalDigits` must be 0, 1 or 2
	 *
	 * @example
	 * // Convert string '2014-02-11T11:30:30' to date:
	 * var result = parseISO('2014-02-11T11:30:30')
	 * //=> Tue Feb 11 2014 11:30:30
	 *
	 * @example
	 * // Convert string '+02014101' to date,
	 * // if the additional number of digits in the extended year format is 1:
	 * var result = parseISO('+02014101', { additionalDigits: 1 })
	 * //=> Fri Apr 11 2014 00:00:00
	 */
	
	function parseISO(argument, dirtyOptions) {
	  (0, _index2.default)(1, arguments);
	  var options = dirtyOptions || {};
	  var additionalDigits = options.additionalDigits == null ? DEFAULT_ADDITIONAL_DIGITS : (0, _index.default)(options.additionalDigits);
	
	  if (additionalDigits !== 2 && additionalDigits !== 1 && additionalDigits !== 0) {
	    throw new RangeError('additionalDigits must be 0, 1 or 2');
	  }
	
	  if (!(typeof argument === 'string' || Object.prototype.toString.call(argument) === '[object String]')) {
	    return new Date(NaN);
	  }
	
	  var dateStrings = splitDateString(argument);
	  var date;
	
	  if (dateStrings.date) {
	    var parseYearResult = parseYear(dateStrings.date, additionalDigits);
	    date = parseDate(parseYearResult.restDateString, parseYearResult.year);
	  }
	
	  if (isNaN(date) || !date) {
	    return new Date(NaN);
	  }
	
	  var timestamp = date.getTime();
	  var time = 0;
	  var offset;
	
	  if (dateStrings.time) {
	    time = parseTime(dateStrings.time);
	
	    if (isNaN(time) || time === null) {
	      return new Date(NaN);
	    }
	  }
	
	  if (dateStrings.timezone) {
	    offset = parseTimezone(dateStrings.timezone);
	
	    if (isNaN(offset)) {
	      return new Date(NaN);
	    }
	  } else {
	    var dirtyDate = new Date(timestamp + time); // js parsed string assuming it's in UTC timezone
	    // but we need it to be parsed in our timezone
	    // so we use utc values to build date in our timezone.
	    // Year values from 0 to 99 map to the years 1900 to 1999
	    // so set year explicitly with setFullYear.
	
	    var result = new Date(dirtyDate.getUTCFullYear(), dirtyDate.getUTCMonth(), dirtyDate.getUTCDate(), dirtyDate.getUTCHours(), dirtyDate.getUTCMinutes(), dirtyDate.getUTCSeconds(), dirtyDate.getUTCMilliseconds());
	    result.setFullYear(dirtyDate.getUTCFullYear());
	    return result;
	  }
	
	  return new Date(timestamp + time + offset);
	}
	
	function splitDateString(dateString) {
	  var dateStrings = {};
	  var array = dateString.split(patterns.dateTimeDelimiter);
	  var timeString;
	
	  if (/:/.test(array[0])) {
	    dateStrings.date = null;
	    timeString = array[0];
	  } else {
	    dateStrings.date = array[0];
	    timeString = array[1];
	
	    if (patterns.timeZoneDelimiter.test(dateStrings.date)) {
	      dateStrings.date = dateString.split(patterns.timeZoneDelimiter)[0];
	      timeString = dateString.substr(dateStrings.date.length, dateString.length);
	    }
	  }
	
	  if (timeString) {
	    var token = patterns.timezone.exec(timeString);
	
	    if (token) {
	      dateStrings.time = timeString.replace(token[1], '');
	      dateStrings.timezone = token[1];
	    } else {
	      dateStrings.time = timeString;
	    }
	  }
	
	  return dateStrings;
	}
	
	function parseYear(dateString, additionalDigits) {
	  var regex = new RegExp('^(?:(\\d{4}|[+-]\\d{' + (4 + additionalDigits) + '})|(\\d{2}|[+-]\\d{' + (2 + additionalDigits) + '})$)');
	  var captures = dateString.match(regex); // Invalid ISO-formatted year
	
	  if (!captures) return {
	    year: null
	  };
	  var year = captures[1] && parseInt(captures[1]);
	  var century = captures[2] && parseInt(captures[2]);
	  return {
	    year: century == null ? year : century * 100,
	    restDateString: dateString.slice((captures[1] || captures[2]).length)
	  };
	}
	
	function parseDate(dateString, year) {
	  // Invalid ISO-formatted year
	  if (year === null) return null;
	  var captures = dateString.match(dateRegex); // Invalid ISO-formatted string
	
	  if (!captures) return null;
	  var isWeekDate = !!captures[4];
	  var dayOfYear = parseDateUnit(captures[1]);
	  var month = parseDateUnit(captures[2]) - 1;
	  var day = parseDateUnit(captures[3]);
	  var week = parseDateUnit(captures[4]);
	  var dayOfWeek = parseDateUnit(captures[5]) - 1;
	
	  if (isWeekDate) {
	    if (!validateWeekDate(year, week, dayOfWeek)) {
	      return new Date(NaN);
	    }
	
	    return dayOfISOWeekYear(year, week, dayOfWeek);
	  } else {
	    var date = new Date(0);
	
	    if (!validateDate(year, month, day) || !validateDayOfYearDate(year, dayOfYear)) {
	      return new Date(NaN);
	    }
	
	    date.setUTCFullYear(year, month, Math.max(dayOfYear, day));
	    return date;
	  }
	}
	
	function parseDateUnit(value) {
	  return value ? parseInt(value) : 1;
	}
	
	function parseTime(timeString) {
	  var captures = timeString.match(timeRegex);
	  if (!captures) return null; // Invalid ISO-formatted time
	
	  var hours = parseTimeUnit(captures[1]);
	  var minutes = parseTimeUnit(captures[2]);
	  var seconds = parseTimeUnit(captures[3]);
	
	  if (!validateTime(hours, minutes, seconds)) {
	    return NaN;
	  }
	
	  return hours * MILLISECONDS_IN_HOUR + minutes * MILLISECONDS_IN_MINUTE + seconds * 1000;
	}
	
	function parseTimeUnit(value) {
	  return value && parseFloat(value.replace(',', '.')) || 0;
	}
	
	function parseTimezone(timezoneString) {
	  if (timezoneString === 'Z') return 0;
	  var captures = timezoneString.match(timezoneRegex);
	  if (!captures) return 0;
	  var sign = captures[1] === '+' ? -1 : 1;
	  var hours = parseInt(captures[2]);
	  var minutes = captures[3] && parseInt(captures[3]) || 0;
	
	  if (!validateTimezone(hours, minutes)) {
	    return NaN;
	  }
	
	  return sign * (hours * MILLISECONDS_IN_HOUR + minutes * MILLISECONDS_IN_MINUTE);
	}
	
	function dayOfISOWeekYear(isoWeekYear, week, day) {
	  var date = new Date(0);
	  date.setUTCFullYear(isoWeekYear, 0, 4);
	  var fourthOfJanuaryDay = date.getUTCDay() || 7;
	  var diff = (week - 1) * 7 + day + 1 - fourthOfJanuaryDay;
	  date.setUTCDate(date.getUTCDate() + diff);
	  return date;
	} // Validation functions
	// February is null to handle the leap year (using ||)
	
	
	var daysInMonths = [31, null, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
	
	function isLeapYearIndex(year) {
	  return year % 400 === 0 || year % 4 === 0 && year % 100;
	}
	
	function validateDate(year, month, date) {
	  return month >= 0 && month <= 11 && date >= 1 && date <= (daysInMonths[month] || (isLeapYearIndex(year) ? 29 : 28));
	}
	
	function validateDayOfYearDate(year, dayOfYear) {
	  return dayOfYear >= 1 && dayOfYear <= (isLeapYearIndex(year) ? 366 : 365);
	}
	
	function validateWeekDate(_year, week, day) {
	  return week >= 1 && week <= 53 && day >= 0 && day <= 6;
	}
	
	function validateTime(hours, minutes, seconds) {
	  if (hours === 24) {
	    return minutes === 0 && seconds === 0;
	  }
	
	  return seconds >= 0 && seconds < 60 && minutes >= 0 && minutes < 60 && hours >= 0 && hours < 25;
	}
	
	function validateTimezone(_hours, minutes) {
	  return minutes >= 0 && minutes <= 59;
	}
	
	module.exports = exports.default;

/***/ },
/* 281 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = startOfWeekYear;
	
	var _index = _interopRequireDefault(__webpack_require__(415));
	
	var _index2 = _interopRequireDefault(__webpack_require__(75));
	
	var _index3 = _interopRequireDefault(__webpack_require__(9));
	
	var _index4 = _interopRequireDefault(__webpack_require__(2));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name startOfWeekYear
	 * @category Week-Numbering Year Helpers
	 * @summary Return the start of a local week-numbering year for the given date.
	 *
	 * @description
	 * Return the start of a local week-numbering year.
	 * The exact calculation depends on the values of
	 * `options.weekStartsOn` (which is the index of the first day of the week)
	 * and `options.firstWeekContainsDate` (which is the day of January, which is always in
	 * the first week of the week-numbering year)
	 *
	 * Week numbering: https://en.wikipedia.org/wiki/Week#Week_numbering
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} date - the original date
	 * @param {Object} [options] - an object with options.
	 * @param {Locale} [options.locale=defaultLocale] - the locale object. See [Locale]{@link https://date-fns.org/docs/Locale}
	 * @param {0|1|2|3|4|5|6} [options.weekStartsOn=0] - the index of the first day of the week (0 - Sunday)
	 * @param {1|2|3|4|5|6|7} [options.firstWeekContainsDate=1] - the day of January, which is always in the first week of the year
	 * @returns {Date} the start of a week-numbering year
	 * @throws {TypeError} 1 argument required
	 * @throws {RangeError} `options.weekStartsOn` must be between 0 and 6
	 * @throws {RangeError} `options.firstWeekContainsDate` must be between 1 and 7
	 *
	 * @example
	 * // The start of an a week-numbering year for 2 July 2005 with default settings:
	 * var result = startOfWeekYear(new Date(2005, 6, 2))
	 * //=> Sun Dec 26 2004 00:00:00
	 *
	 * @example
	 * // The start of a week-numbering year for 2 July 2005
	 * // if Monday is the first day of week
	 * // and 4 January is always in the first week of the year:
	 * var result = startOfWeekYear(new Date(2005, 6, 2), {
	 *   weekStartsOn: 1,
	 *   firstWeekContainsDate: 4
	 * })
	 * //=> Mon Jan 03 2005 00:00:00
	 */
	function startOfWeekYear(dirtyDate, dirtyOptions) {
	  (0, _index4.default)(1, arguments);
	  var options = dirtyOptions || {};
	  var locale = options.locale;
	  var localeFirstWeekContainsDate = locale && locale.options && locale.options.firstWeekContainsDate;
	  var defaultFirstWeekContainsDate = localeFirstWeekContainsDate == null ? 1 : (0, _index3.default)(localeFirstWeekContainsDate);
	  var firstWeekContainsDate = options.firstWeekContainsDate == null ? defaultFirstWeekContainsDate : (0, _index3.default)(options.firstWeekContainsDate);
	  var year = (0, _index.default)(dirtyDate, dirtyOptions);
	  var firstWeek = new Date(0);
	  firstWeek.setFullYear(year, 0, firstWeekContainsDate);
	  firstWeek.setHours(0, 0, 0, 0);
	  var date = (0, _index2.default)(firstWeek, dirtyOptions);
	  return date;
	}
	
	module.exports = exports.default;

/***/ },
/* 282 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = subMonths;
	
	var _index = _interopRequireDefault(__webpack_require__(9));
	
	var _index2 = _interopRequireDefault(__webpack_require__(112));
	
	var _index3 = _interopRequireDefault(__webpack_require__(2));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name subMonths
	 * @category Month Helpers
	 * @summary Subtract the specified number of months from the given date.
	 *
	 * @description
	 * Subtract the specified number of months from the given date.
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} date - the date to be changed
	 * @param {Number} amount - the amount of months to be subtracted. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
	 * @returns {Date} the new date with the months subtracted
	 * @throws {TypeError} 2 arguments required
	 *
	 * @example
	 * // Subtract 5 months from 1 February 2015:
	 * var result = subMonths(new Date(2015, 1, 1), 5)
	 * //=> Mon Sep 01 2014 00:00:00
	 */
	function subMonths(dirtyDate, dirtyAmount) {
	  (0, _index3.default)(2, arguments);
	  var amount = (0, _index.default)(dirtyAmount);
	  return (0, _index2.default)(dirtyDate, -amount);
	}
	
	module.exports = exports.default;

/***/ },
/* 283 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = sub;
	
	var _index = _interopRequireDefault(__webpack_require__(192));
	
	var _index2 = _interopRequireDefault(__webpack_require__(282));
	
	var _index3 = _interopRequireDefault(__webpack_require__(3));
	
	var _index4 = _interopRequireDefault(__webpack_require__(2));
	
	var _index5 = _interopRequireDefault(__webpack_require__(9));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name sub
	 * @category Common Helpers
	 * @summary Subtract the specified years, months, weeks, days, hours, minutes and seconds from the given date.
	 *
	 * @description
	 * Subtract the specified years, months, weeks, days, hours, minutes and seconds from the given date.
	 *
	 * @param {Date|Number} date - the date to be changed
	 * @param {Duration} duration - the object with years, months, weeks, days, hours, minutes and seconds to be subtracted
	 *
	 * | Key     | Description                        |
	 * |---------|------------------------------------|
	 * | years   | Amount of years to be subtracted   |
	 * | months  | Amount of months to be subtracted  |
	 * | weeks   | Amount of weeks to be subtracted   |
	 * | days    | Amount of days to be subtracted    |
	 * | hours   | Amount of hours to be subtracted   |
	 * | minutes | Amount of minutes to be subtracted |
	 * | seconds | Amount of seconds to be subtracted |
	 *
	 * All values default to 0
	 *
	 * @returns {Date} the new date with the seconds subtracted
	 * @throws {TypeError} 2 arguments required
	 *
	 * @example
	 * // Subtract the following duration from 15 June 2017 15:29:20
	 * const result = sub(new Date(2017, 5, 15, 15, 29, 20), {
	 *   years: 2,
	 *   months: 9,
	 *   weeks: 1,
	 *   days: 7,
	 *   hours: 5,
	 *   minutes: 9,
	 *   seconds: 30
	 * })
	 * //=> Mon Sep 1 2014 10:19:50
	 */
	function sub(dirtyDate, duration) {
	  (0, _index4.default)(2, arguments);
	  if (!duration || typeof duration !== 'object') return new Date(NaN);
	  var years = 'years' in duration ? (0, _index5.default)(duration.years) : 0;
	  var months = 'months' in duration ? (0, _index5.default)(duration.months) : 0;
	  var weeks = 'weeks' in duration ? (0, _index5.default)(duration.weeks) : 0;
	  var days = 'days' in duration ? (0, _index5.default)(duration.days) : 0;
	  var hours = 'hours' in duration ? (0, _index5.default)(duration.hours) : 0;
	  var minutes = 'minutes' in duration ? (0, _index5.default)(duration.minutes) : 0;
	  var seconds = 'seconds' in duration ? (0, _index5.default)(duration.seconds) : 0; // Subtract years and months
	
	  var dateWithoutMonths = (0, _index2.default)((0, _index3.default)(dirtyDate), months + years * 12); // Subtract weeks and days
	
	  var dateWithoutDays = (0, _index.default)(dateWithoutMonths, days + weeks * 7); // Subtract hours, minutes and seconds
	
	  var minutestoSub = minutes + hours * 60;
	  var secondstoSub = seconds + minutestoSub * 60;
	  var mstoSub = secondstoSub * 1000;
	  var finalDate = new Date(dateWithoutDays.getTime() - mstoSub);
	  return finalDate;
	}
	
	module.exports = exports.default;

/***/ },
/* 284 */
/***/ function(module, exports, __webpack_require__) {

	
	;(function (name, root, factory) {
	  if (true) {
	    module.exports = factory()
	  }
	  /* istanbul ignore next */
	  else if (typeof define === 'function' && define.amd) {
	    define(factory)
	  }
	  else {
	    root[name] = factory()
	  }
	}('dcopy', this, function () {
	  /**
	   * Deep copy objects and arrays
	   *
	   * @param {Object/Array} target
	   * @return {Object/Array} copy
	   * @api public
	   */
	
	  return function (target) {
	    if (/number|string|boolean/.test(typeof target)) {
	      return target
	    }
	    if (target instanceof Date) {
	      return new Date(target.getTime())
	    }
	
	    var copy = (target instanceof Array) ? [] : {}
	    walk(target, copy)
	    return copy
	
	    function walk (target, copy) {
	      for (var key in target) {
	        var obj = target[key]
	        if (obj instanceof Date) {
	          var value = new Date(obj.getTime())
	          add(copy, key, value)
	        }
	        else if (obj instanceof Function) {
	          var value = obj
	          add(copy, key, value)
	        }
	        else if (obj instanceof Array) {
	          var value = []
	          var last = add(copy, key, value)
	          walk(obj, last)
	        }
	        else if (obj instanceof Object) {
	          var value = {}
	          var last = add(copy, key, value)
	          walk(obj, last)
	        }
	        else {
	          var value = obj
	          add(copy, key, value)
	        }
	      }
	    }
	  }
	
	  /**
	   * Adds a value to the copy object based on its type
	   *
	   * @api private
	   */
	
	  function add (copy, key, value) {
	    if (copy instanceof Array) {
	      copy.push(value)
	      return copy[copy.length - 1]
	    }
	    else if (copy instanceof Object) {
	      copy[key] = value
	      return copy[key]
	    }
	  }
	}))


/***/ },
/* 285 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var keys = __webpack_require__(504);
	var hasSymbols = typeof Symbol === 'function' && typeof Symbol('foo') === 'symbol';
	
	var toStr = Object.prototype.toString;
	var concat = Array.prototype.concat;
	var origDefineProperty = Object.defineProperty;
	
	var isFunction = function (fn) {
		return typeof fn === 'function' && toStr.call(fn) === '[object Function]';
	};
	
	var arePropertyDescriptorsSupported = function () {
		var obj = {};
		try {
			origDefineProperty(obj, 'x', { enumerable: false, value: obj });
			// eslint-disable-next-line no-unused-vars, no-restricted-syntax
			for (var _ in obj) { // jscs:ignore disallowUnusedVariables
				return false;
			}
			return obj.x === obj;
		} catch (e) { /* this is IE 8. */
			return false;
		}
	};
	var supportsDescriptors = origDefineProperty && arePropertyDescriptorsSupported();
	
	var defineProperty = function (object, name, value, predicate) {
		if (name in object && (!isFunction(predicate) || !predicate())) {
			return;
		}
		if (supportsDescriptors) {
			origDefineProperty(object, name, {
				configurable: true,
				enumerable: false,
				value: value,
				writable: true
			});
		} else {
			object[name] = value;
		}
	};
	
	var defineProperties = function (object, map) {
		var predicates = arguments.length > 2 ? arguments[2] : {};
		var props = keys(map);
		if (hasSymbols) {
			props = concat.call(props, Object.getOwnPropertySymbols(map));
		}
		for (var i = 0; i < props.length; i += 1) {
			defineProperty(object, props[i], map[props[i]], predicates[props[i]]);
		}
	};
	
	defineProperties.supportsDescriptors = !!supportsDescriptors;
	
	module.exports = defineProperties;


/***/ },
/* 286 */
/***/ function(module, exports) {

	// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.
	
	function EventEmitter() {
	  this._events = this._events || {};
	  this._maxListeners = this._maxListeners || undefined;
	}
	module.exports = EventEmitter;
	
	// Backwards-compat with node 0.10.x
	EventEmitter.EventEmitter = EventEmitter;
	
	EventEmitter.prototype._events = undefined;
	EventEmitter.prototype._maxListeners = undefined;
	
	// By default EventEmitters will print a warning if more than 10 listeners are
	// added to it. This is a useful default which helps finding memory leaks.
	EventEmitter.defaultMaxListeners = 10;
	
	// Obviously not all Emitters should be limited to 10. This function allows
	// that to be increased. Set to zero for unlimited.
	EventEmitter.prototype.setMaxListeners = function(n) {
	  if (!isNumber(n) || n < 0 || isNaN(n))
	    throw TypeError('n must be a positive number');
	  this._maxListeners = n;
	  return this;
	};
	
	EventEmitter.prototype.emit = function(type) {
	  var er, handler, len, args, i, listeners;
	
	  if (!this._events)
	    this._events = {};
	
	  // If there is no 'error' event listener then throw.
	  if (type === 'error') {
	    if (!this._events.error ||
	        (isObject(this._events.error) && !this._events.error.length)) {
	      er = arguments[1];
	      if (er instanceof Error) {
	        throw er; // Unhandled 'error' event
	      } else {
	        // At least give some kind of context to the user
	        var err = new Error('Uncaught, unspecified "error" event. (' + er + ')');
	        err.context = er;
	        throw err;
	      }
	    }
	  }
	
	  handler = this._events[type];
	
	  if (isUndefined(handler))
	    return false;
	
	  if (isFunction(handler)) {
	    switch (arguments.length) {
	      // fast cases
	      case 1:
	        handler.call(this);
	        break;
	      case 2:
	        handler.call(this, arguments[1]);
	        break;
	      case 3:
	        handler.call(this, arguments[1], arguments[2]);
	        break;
	      // slower
	      default:
	        args = Array.prototype.slice.call(arguments, 1);
	        handler.apply(this, args);
	    }
	  } else if (isObject(handler)) {
	    args = Array.prototype.slice.call(arguments, 1);
	    listeners = handler.slice();
	    len = listeners.length;
	    for (i = 0; i < len; i++)
	      listeners[i].apply(this, args);
	  }
	
	  return true;
	};
	
	EventEmitter.prototype.addListener = function(type, listener) {
	  var m;
	
	  if (!isFunction(listener))
	    throw TypeError('listener must be a function');
	
	  if (!this._events)
	    this._events = {};
	
	  // To avoid recursion in the case that type === "newListener"! Before
	  // adding it to the listeners, first emit "newListener".
	  if (this._events.newListener)
	    this.emit('newListener', type,
	              isFunction(listener.listener) ?
	              listener.listener : listener);
	
	  if (!this._events[type])
	    // Optimize the case of one listener. Don't need the extra array object.
	    this._events[type] = listener;
	  else if (isObject(this._events[type]))
	    // If we've already got an array, just append.
	    this._events[type].push(listener);
	  else
	    // Adding the second element, need to change to array.
	    this._events[type] = [this._events[type], listener];
	
	  // Check for listener leak
	  if (isObject(this._events[type]) && !this._events[type].warned) {
	    if (!isUndefined(this._maxListeners)) {
	      m = this._maxListeners;
	    } else {
	      m = EventEmitter.defaultMaxListeners;
	    }
	
	    if (m && m > 0 && this._events[type].length > m) {
	      this._events[type].warned = true;
	      console.error('(node) warning: possible EventEmitter memory ' +
	                    'leak detected. %d listeners added. ' +
	                    'Use emitter.setMaxListeners() to increase limit.',
	                    this._events[type].length);
	      if (typeof console.trace === 'function') {
	        // not supported in IE 10
	        console.trace();
	      }
	    }
	  }
	
	  return this;
	};
	
	EventEmitter.prototype.on = EventEmitter.prototype.addListener;
	
	EventEmitter.prototype.once = function(type, listener) {
	  if (!isFunction(listener))
	    throw TypeError('listener must be a function');
	
	  var fired = false;
	
	  function g() {
	    this.removeListener(type, g);
	
	    if (!fired) {
	      fired = true;
	      listener.apply(this, arguments);
	    }
	  }
	
	  g.listener = listener;
	  this.on(type, g);
	
	  return this;
	};
	
	// emits a 'removeListener' event iff the listener was removed
	EventEmitter.prototype.removeListener = function(type, listener) {
	  var list, position, length, i;
	
	  if (!isFunction(listener))
	    throw TypeError('listener must be a function');
	
	  if (!this._events || !this._events[type])
	    return this;
	
	  list = this._events[type];
	  length = list.length;
	  position = -1;
	
	  if (list === listener ||
	      (isFunction(list.listener) && list.listener === listener)) {
	    delete this._events[type];
	    if (this._events.removeListener)
	      this.emit('removeListener', type, listener);
	
	  } else if (isObject(list)) {
	    for (i = length; i-- > 0;) {
	      if (list[i] === listener ||
	          (list[i].listener && list[i].listener === listener)) {
	        position = i;
	        break;
	      }
	    }
	
	    if (position < 0)
	      return this;
	
	    if (list.length === 1) {
	      list.length = 0;
	      delete this._events[type];
	    } else {
	      list.splice(position, 1);
	    }
	
	    if (this._events.removeListener)
	      this.emit('removeListener', type, listener);
	  }
	
	  return this;
	};
	
	EventEmitter.prototype.removeAllListeners = function(type) {
	  var key, listeners;
	
	  if (!this._events)
	    return this;
	
	  // not listening for removeListener, no need to emit
	  if (!this._events.removeListener) {
	    if (arguments.length === 0)
	      this._events = {};
	    else if (this._events[type])
	      delete this._events[type];
	    return this;
	  }
	
	  // emit removeListener for all listeners on all events
	  if (arguments.length === 0) {
	    for (key in this._events) {
	      if (key === 'removeListener') continue;
	      this.removeAllListeners(key);
	    }
	    this.removeAllListeners('removeListener');
	    this._events = {};
	    return this;
	  }
	
	  listeners = this._events[type];
	
	  if (isFunction(listeners)) {
	    this.removeListener(type, listeners);
	  } else if (listeners) {
	    // LIFO order
	    while (listeners.length)
	      this.removeListener(type, listeners[listeners.length - 1]);
	  }
	  delete this._events[type];
	
	  return this;
	};
	
	EventEmitter.prototype.listeners = function(type) {
	  var ret;
	  if (!this._events || !this._events[type])
	    ret = [];
	  else if (isFunction(this._events[type]))
	    ret = [this._events[type]];
	  else
	    ret = this._events[type].slice();
	  return ret;
	};
	
	EventEmitter.prototype.listenerCount = function(type) {
	  if (this._events) {
	    var evlistener = this._events[type];
	
	    if (isFunction(evlistener))
	      return 1;
	    else if (evlistener)
	      return evlistener.length;
	  }
	  return 0;
	};
	
	EventEmitter.listenerCount = function(emitter, type) {
	  return emitter.listenerCount(type);
	};
	
	function isFunction(arg) {
	  return typeof arg === 'function';
	}
	
	function isNumber(arg) {
	  return typeof arg === 'number';
	}
	
	function isObject(arg) {
	  return typeof arg === 'object' && arg !== null;
	}
	
	function isUndefined(arg) {
	  return arg === void 0;
	}


/***/ },
/* 287 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var implementation = __webpack_require__(1038);
	
	module.exports = Function.prototype.bind || implementation;


/***/ },
/* 288 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	if (true) {
	  module.exports = __webpack_require__(1043);
	} else {
	  module.exports = require('./cjs/history.js');
	}


/***/ },
/* 289 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getFiltersByLocalStorageKey = undefined;
	
	var _localStorage = __webpack_require__(59);
	
	var _localStorage2 = _interopRequireDefault(_localStorage);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var SUBROUTES = Array.isArray(([{"label":"Business","component":"Business","parameter":"business","myWorkQueueSearch":false,"sourceTypeId":54,"searchMustHaveOneOf":["FILING_TYPE_ID","STATUS_ID","STATE","search"],"serverWebSearchDescription":true,"serverWorkQueueDescription":true,"serverMyRecordsDescription":true,"searchPlaceholder":"Search by name or filing number (X########)","allowEmptySearchTerm":true,"requestCertificateAlternateLabel":"Request Information","fileAmendmentButtonLabel":"Filing Actions","advancedSearchParameters":[{"type":"radio","name":"QUERY_TYPE_ID","defaultValue":1010,"options":[{"value":1010,"label":"Starts with"},{"value":1011,"label":"Contains"},{"value":1012,"label":" Word Contains"}]},{"type":"serverSelect","name":"FILING_TYPE_ID","optionsSrc":"FILING_TYPES","label":"Entity Type","placeholder":"All","defaultValue":"0"},{"type":"serverSelect","name":"FILING_SUBTYPE_ID","optionsSrc":"FILING_SUBTYPES","label":"Entity Subtype","overrideSubOptionsSrcFromParameterName":"FILING_TYPE_ID","placeholder":"All","defaultValue":"0"},{"type":"serverSelect","name":"STATUS_ID","optionsSrc":"FILING_STATUS_WITHOUT_ALL","label":"Status","placeholder":"All","defaultValue":"0"},{"type":"serverSelect","name":"STATE","optionsSrc":"STATE","label":"State","placeholder":"All","defaultValue":""},{"type":"serverSelect","name":"COUNTY","optionsSrc":"COUNTY_SUBOPTION","label":"County","overrideSubOptionsSrcFromParameterName":"STATE","placeholder":"All","defaultValue":""},{"type":"checkbox","name":"CRA_SEARCH_YN","defaultValue":false,"label":"Search by Registered Agent PID"},{"type":"dateRange","name":"FILING_DATE","label":"Registration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}},{"type":"dateRange","name":"EXPIRATION_DATE","label":"Expiration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}}],"myRecordsFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Active"},{"value":2,"label":"Inactive"},{"value":3,"label":"Pending"}]},{"type":"dateRange","name":"DATE_RANGE","label":"Date range","defaultValue":{"start":null,"end":null}}],"myWorkQueueFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Approved"},{"value":2,"label":"Pending Online Payment"},{"value":3,"label":"Pending Review"},{"value":4,"label":"Needs Correction"},{"value":5,"label":"Rejected"},{"value":6,"label":"Draft"}]},{"type":"dateRange","name":"DATE_RANGE","label":"Date range","defaultValue":{"start":null,"end":null}}]},{"label":"Notary","component":"Notary","parameter":"notary","sourceTypeId":850,"myWorkQueueSearch":false,"allowEmptySearchTerm":true,"requestCertificateAlternateLabel":"Download Certificate","fileAmendmentButtonLabel":"Filing Actions","hideNameRequestCertificate":true,"hideAddressRequestCertificate":true,"hideRecordUserManagment":true,"searchPlaceholder":"Search by name or commission number","searchMustHaveOneOf":["CITY","search","SERVICE_TYPE"],"advancedParametersStartOpen":true,"searchIsSortable":true,"advancedSearchParameters":[{"type":"radio","name":"STARTS_WITH_YN","defaultValue":false,"options":[{"value":true,"label":"Starts with"},{"value":false,"label":"Contains"}]},{"type":"checkbox","name":"ACTIVE_ONLY_YN","defaultValue":true,"label":"Active entities only"},{"type":"text","name":"CITY","defaultValue":"","label":"City"},{"type":"select","name":"SERVICE_TYPE","label":"Special Services Offered","defaultValue":0,"options":[{"value":0,"label":"(N/A)"},{"value":6165,"label":"In-Person Electronic Notarization (IPEN)"},{"value":6166,"label":"Remote Online Notarization (RON)"},{"value":6167,"label":"Mobile Notary Services"},{"value":6168,"label":"Remote Ink Notarization (RIN)"}]}]},{"label":"Apostille","component":"Apostille","parameter":"apostille","sourceTypeId":720,"myRecordsSearch":false,"myWorkQueueSearch":false,"disabled":false,"allowedRoutes":["/forms-manager/","/queue/","/forms/"]},{"label":"Liens","component":"UCC","parameter":"ucc","sourceTypeId":1999,"myRecordsSearch":true,"myWorkQueueSearch":true,"fileAmendmentButtonLabel":"Filing Actions","searchPlaceholder":"Search by name or file number","disabled":false,"serverWebSearchDescription":true,"myRecordsDescription":"","workQueueDescription":"","searchDescription":"","hideRecordUserManagment":true,"searchLiensCheckout":false,"advancedSearchParameters":[{"type":"radio","name":"STARTS_WITH_YN","defaultValue":false,"options":[{"value":true,"label":"Starts with"},{"value":false,"label":"Contains"}]},{"type":"select","name":"STATUS","defaultValue":"ALL","label":"Status","options":[{"value":"ACTIVE_UNLAPSED","label":"Active (unlapsed)"},{"value":"ACTIVE_LAPSED_UNLAPSED","label":"Active (lapsed and unlapsed)"}]},{"type":"text","name":"EXCLUDE_VALUES","label":"Exclude Debtor Names (comma separated list of names to exclude)","defaultValue":""},{"type":"dateRange","name":"FILING_DATE","label":"Financing Statement Date","defaultValue":{"start":null,"end":null}},{"type":"dateRange","name":"LAPSE_DATE","label":"Lapse Date","defaultValue":{"start":null,"end":null}},{"type":"text","name":"CITY","label":"Debtor City","defaultValue":""}],"myRecordsFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Approved"},{"value":2,"label":"Pending Online Payment"},{"value":3,"label":"Pending Review"}]},{"type":"select","name":"TYPE","defaultValue":0,"label":"Lien Type","options":[{"value":0,"label":"All"},{"value":1,"label":"UCC"},{"value":2,"label":"EFS"},{"value":3,"label":"Title 71"}]}],"myWorkQueueFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Approved"},{"value":2,"label":"Pending Online Payment"},{"value":3,"label":"Pending Review"},{"value":4,"label":"Pending Print and Mail"},{"value":5,"label":"Rejected"},{"value":6,"label":"Draft"}]},{"type":"select","name":"TYPE","defaultValue":0,"label":"Lien Type","options":[{"value":0,"label":"All"},{"value":1,"label":"UCC"},{"value":2,"label":"EFS"},{"value":3,"label":"Title 71"}]}]},{"label":"Copy Request","component":"copies","parameter":"copies","sourceTypeId":2001,"myRecordsSearch":false,"myWorkQueueSearch":false,"disabled":false,"allowedRoutes":["/forms-manager/","/queue/","/forms/"]},{"label":"Trademark","component":"Trademark","parameter":"trademark","sourceTypeId":810,"showRequestCertificate":true,"searchMustHaveOneOf":["search","EXPIRATION_DATE","FILING_DATE"],"allowEmptySearchTerm":true,"requestCertificateAlternateLabel":"Request Information","fileAmendmentButtonLabel":"Filing Actions","advancedSearchParameters":[{"type":"radio","name":"QUERY_TYPE_ID","defaultValue":1010,"options":[{"value":1010,"label":"Starts with"},{"value":1011,"label":"Contains"},{"value":1012,"label":" Word Contains"}]},{"type":"checkbox","name":"OWNER_SEARCH_YN","defaultValue":false,"label":"Search owners"},{"type":"radio","name":"SERVICE_MARK_YN","label":"Mark Type","defaultValue":"","options":[{"value":"","label":"All Marks"},{"value":"Y","label":"Service Mark"},{"value":"N","label":"Trademark"}]},{"type":"serverSelect","name":"STATUS_ID","optionsSrc":"TYPE_V|TRADEMARK_STATUS_TYPE","label":"Status","placeholder":"All","defaultValue":"0"},{"type":"select","name":"DESIGN_TYPE_ID","options":[{"value":0,"label":"All"},{"value":990,"label":"Words Only"},{"value":991,"label":"Design Only"},{"value":992,"label":"Words and Design"}],"label":"Design Type","defaultValue":"0"},{"type":"dateRange","name":"FILING_DATE","label":"Registered Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}},{"type":"dateRange","name":"EXPIRATION_DATE","label":"Expiration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}}]},{"label":"Business Info Request","component":"InfoRequests","parameter":"info-request","sourceTypeId":167,"allowedRoutes":["/forms-manager/","/queue/","/forms/"]},{"label":"Data Requests","component":"DataRequests","parameter":"data-request","sourceTypeId":0,"allowedRoutes":["/forms-manager/"]},{"label":"CRA","component":"CRA","parameter":"cra","sourceTypeId":157,"myRecordsSearch":false,"searchPlaceholder":"Search by name or registered agent number","allowedRoutes":["/forms-manager/","/forms/","/records/","/queue/","/search/"],"allowEmptySearchTerm":true,"fileAmendmentButtonLabel":"Filing Actions","advancedSearchParameters":[{"type":"radio","name":"QUERY_TYPE_ID","defaultValue":1010,"options":[{"value":1010,"label":"Starts with"},{"value":1011,"label":"Contains"},{"value":1012,"label":" Word Contains"}]},{"type":"dateRange","name":"CRA_DATE","label":"Registration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}},{"type":"select","name":"STATUS_ID","label":"Status","defaultValue":0,"options":[{"value":0,"label":"All"},{"value":121,"label":"Active"},{"value":122,"label":"Inactive"}]},{"type":"select","name":"AGENT_TYPE_ID","label":"Agent Type","defaultValue":0,"options":[{"value":0,"label":"All"},{"value":460,"label":"Registered Agent"},{"value":461,"label":"Commercial Registered Agent"}]}]},{"label":"Farm Bill","component":"FarmBill","parameter":"farm-bill","path":"/lists/farm-bill","sourceTypeId":0,"myRecordsSearch":false,"allowedRules":["/search/"],"disabled":true,"searchDescription":"To perform a search, enter a debtor name. Your search results may include: exact debtor name, variations of that name and any filing that includes your search criteria. Punctuation is ignored.\n\nYou can click on \"Advanced\" to refine your search. Under “Advanced” you can search by crop, year, county and SSN/FEIN. As a registered Farm Bill Buyer with the Montana Secretary of State’s office it is important to maintain the confidentiality of the information contained within the Farm Bill Master List. The Farm Bill Master List reflects personal data, such as Social Security Numbers, which are a key piece of personal identifiable information to assist you in determining the existence of a lien against a specific debtor. The distribution of this information beyond its intended purpose is strictly prohibited.\n\nThe debtor's tax identification number has been hidden for confidentiality reasons. You may continue to search on a tax ID number and return debtors that match your search criteria. The SSN/FEIN must be entered without dashes or spaces.","searchMustHaveOneOf":["search","UCC_FARM_PRODUCT_ID","COUNTY"],"searchPlaceholder":"Search by debtor name","advancedSearchParameters":[{"type":"ServerMultiComplete","label":"Product code name(s)","name":"UCC_FARM_PRODUCT_ID","defaultValue":"","optionsSrc":"UCC_FARM_PRODUCT_V"},{"type":"MultiComplete","label":"Year or Range of Years","name":"YEAR_NUM","optionsSrc":"years","startYear":"1968","defaultValue":[],"preMergeOptions":[{"value":"ALL","label":"All"}]},{"type":"serverSelect","label":"State","name":"STATE","defaultValue":"MONTANA","optionsSrc":"STATE"},{"type":"ServerMultiComplete","label":"County","name":"COUNTY","defaultValue":[],"optionsSrc":"COUNTY","overrideSubOptionsSrcFromParameterName":"STATE"},{"type":"checkbox","name":"TIN_SEARCH_YN","defaultValue":false,"label":"Tax Identification Number Search"},{"type":"checkbox","name":"TIN_SORT_YN","defaultValue":false,"label":"Unique ID Sort"}]}])) ? ([{"label":"Business","component":"Business","parameter":"business","myWorkQueueSearch":false,"sourceTypeId":54,"searchMustHaveOneOf":["FILING_TYPE_ID","STATUS_ID","STATE","search"],"serverWebSearchDescription":true,"serverWorkQueueDescription":true,"serverMyRecordsDescription":true,"searchPlaceholder":"Search by name or filing number (X########)","allowEmptySearchTerm":true,"requestCertificateAlternateLabel":"Request Information","fileAmendmentButtonLabel":"Filing Actions","advancedSearchParameters":[{"type":"radio","name":"QUERY_TYPE_ID","defaultValue":1010,"options":[{"value":1010,"label":"Starts with"},{"value":1011,"label":"Contains"},{"value":1012,"label":" Word Contains"}]},{"type":"serverSelect","name":"FILING_TYPE_ID","optionsSrc":"FILING_TYPES","label":"Entity Type","placeholder":"All","defaultValue":"0"},{"type":"serverSelect","name":"FILING_SUBTYPE_ID","optionsSrc":"FILING_SUBTYPES","label":"Entity Subtype","overrideSubOptionsSrcFromParameterName":"FILING_TYPE_ID","placeholder":"All","defaultValue":"0"},{"type":"serverSelect","name":"STATUS_ID","optionsSrc":"FILING_STATUS_WITHOUT_ALL","label":"Status","placeholder":"All","defaultValue":"0"},{"type":"serverSelect","name":"STATE","optionsSrc":"STATE","label":"State","placeholder":"All","defaultValue":""},{"type":"serverSelect","name":"COUNTY","optionsSrc":"COUNTY_SUBOPTION","label":"County","overrideSubOptionsSrcFromParameterName":"STATE","placeholder":"All","defaultValue":""},{"type":"checkbox","name":"CRA_SEARCH_YN","defaultValue":false,"label":"Search by Registered Agent PID"},{"type":"dateRange","name":"FILING_DATE","label":"Registration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}},{"type":"dateRange","name":"EXPIRATION_DATE","label":"Expiration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}}],"myRecordsFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Active"},{"value":2,"label":"Inactive"},{"value":3,"label":"Pending"}]},{"type":"dateRange","name":"DATE_RANGE","label":"Date range","defaultValue":{"start":null,"end":null}}],"myWorkQueueFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Approved"},{"value":2,"label":"Pending Online Payment"},{"value":3,"label":"Pending Review"},{"value":4,"label":"Needs Correction"},{"value":5,"label":"Rejected"},{"value":6,"label":"Draft"}]},{"type":"dateRange","name":"DATE_RANGE","label":"Date range","defaultValue":{"start":null,"end":null}}]},{"label":"Notary","component":"Notary","parameter":"notary","sourceTypeId":850,"myWorkQueueSearch":false,"allowEmptySearchTerm":true,"requestCertificateAlternateLabel":"Download Certificate","fileAmendmentButtonLabel":"Filing Actions","hideNameRequestCertificate":true,"hideAddressRequestCertificate":true,"hideRecordUserManagment":true,"searchPlaceholder":"Search by name or commission number","searchMustHaveOneOf":["CITY","search","SERVICE_TYPE"],"advancedParametersStartOpen":true,"searchIsSortable":true,"advancedSearchParameters":[{"type":"radio","name":"STARTS_WITH_YN","defaultValue":false,"options":[{"value":true,"label":"Starts with"},{"value":false,"label":"Contains"}]},{"type":"checkbox","name":"ACTIVE_ONLY_YN","defaultValue":true,"label":"Active entities only"},{"type":"text","name":"CITY","defaultValue":"","label":"City"},{"type":"select","name":"SERVICE_TYPE","label":"Special Services Offered","defaultValue":0,"options":[{"value":0,"label":"(N/A)"},{"value":6165,"label":"In-Person Electronic Notarization (IPEN)"},{"value":6166,"label":"Remote Online Notarization (RON)"},{"value":6167,"label":"Mobile Notary Services"},{"value":6168,"label":"Remote Ink Notarization (RIN)"}]}]},{"label":"Apostille","component":"Apostille","parameter":"apostille","sourceTypeId":720,"myRecordsSearch":false,"myWorkQueueSearch":false,"disabled":false,"allowedRoutes":["/forms-manager/","/queue/","/forms/"]},{"label":"Liens","component":"UCC","parameter":"ucc","sourceTypeId":1999,"myRecordsSearch":true,"myWorkQueueSearch":true,"fileAmendmentButtonLabel":"Filing Actions","searchPlaceholder":"Search by name or file number","disabled":false,"serverWebSearchDescription":true,"myRecordsDescription":"","workQueueDescription":"","searchDescription":"","hideRecordUserManagment":true,"searchLiensCheckout":false,"advancedSearchParameters":[{"type":"radio","name":"STARTS_WITH_YN","defaultValue":false,"options":[{"value":true,"label":"Starts with"},{"value":false,"label":"Contains"}]},{"type":"select","name":"STATUS","defaultValue":"ALL","label":"Status","options":[{"value":"ACTIVE_UNLAPSED","label":"Active (unlapsed)"},{"value":"ACTIVE_LAPSED_UNLAPSED","label":"Active (lapsed and unlapsed)"}]},{"type":"text","name":"EXCLUDE_VALUES","label":"Exclude Debtor Names (comma separated list of names to exclude)","defaultValue":""},{"type":"dateRange","name":"FILING_DATE","label":"Financing Statement Date","defaultValue":{"start":null,"end":null}},{"type":"dateRange","name":"LAPSE_DATE","label":"Lapse Date","defaultValue":{"start":null,"end":null}},{"type":"text","name":"CITY","label":"Debtor City","defaultValue":""}],"myRecordsFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Approved"},{"value":2,"label":"Pending Online Payment"},{"value":3,"label":"Pending Review"}]},{"type":"select","name":"TYPE","defaultValue":0,"label":"Lien Type","options":[{"value":0,"label":"All"},{"value":1,"label":"UCC"},{"value":2,"label":"EFS"},{"value":3,"label":"Title 71"}]}],"myWorkQueueFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Approved"},{"value":2,"label":"Pending Online Payment"},{"value":3,"label":"Pending Review"},{"value":4,"label":"Pending Print and Mail"},{"value":5,"label":"Rejected"},{"value":6,"label":"Draft"}]},{"type":"select","name":"TYPE","defaultValue":0,"label":"Lien Type","options":[{"value":0,"label":"All"},{"value":1,"label":"UCC"},{"value":2,"label":"EFS"},{"value":3,"label":"Title 71"}]}]},{"label":"Copy Request","component":"copies","parameter":"copies","sourceTypeId":2001,"myRecordsSearch":false,"myWorkQueueSearch":false,"disabled":false,"allowedRoutes":["/forms-manager/","/queue/","/forms/"]},{"label":"Trademark","component":"Trademark","parameter":"trademark","sourceTypeId":810,"showRequestCertificate":true,"searchMustHaveOneOf":["search","EXPIRATION_DATE","FILING_DATE"],"allowEmptySearchTerm":true,"requestCertificateAlternateLabel":"Request Information","fileAmendmentButtonLabel":"Filing Actions","advancedSearchParameters":[{"type":"radio","name":"QUERY_TYPE_ID","defaultValue":1010,"options":[{"value":1010,"label":"Starts with"},{"value":1011,"label":"Contains"},{"value":1012,"label":" Word Contains"}]},{"type":"checkbox","name":"OWNER_SEARCH_YN","defaultValue":false,"label":"Search owners"},{"type":"radio","name":"SERVICE_MARK_YN","label":"Mark Type","defaultValue":"","options":[{"value":"","label":"All Marks"},{"value":"Y","label":"Service Mark"},{"value":"N","label":"Trademark"}]},{"type":"serverSelect","name":"STATUS_ID","optionsSrc":"TYPE_V|TRADEMARK_STATUS_TYPE","label":"Status","placeholder":"All","defaultValue":"0"},{"type":"select","name":"DESIGN_TYPE_ID","options":[{"value":0,"label":"All"},{"value":990,"label":"Words Only"},{"value":991,"label":"Design Only"},{"value":992,"label":"Words and Design"}],"label":"Design Type","defaultValue":"0"},{"type":"dateRange","name":"FILING_DATE","label":"Registered Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}},{"type":"dateRange","name":"EXPIRATION_DATE","label":"Expiration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}}]},{"label":"Business Info Request","component":"InfoRequests","parameter":"info-request","sourceTypeId":167,"allowedRoutes":["/forms-manager/","/queue/","/forms/"]},{"label":"Data Requests","component":"DataRequests","parameter":"data-request","sourceTypeId":0,"allowedRoutes":["/forms-manager/"]},{"label":"CRA","component":"CRA","parameter":"cra","sourceTypeId":157,"myRecordsSearch":false,"searchPlaceholder":"Search by name or registered agent number","allowedRoutes":["/forms-manager/","/forms/","/records/","/queue/","/search/"],"allowEmptySearchTerm":true,"fileAmendmentButtonLabel":"Filing Actions","advancedSearchParameters":[{"type":"radio","name":"QUERY_TYPE_ID","defaultValue":1010,"options":[{"value":1010,"label":"Starts with"},{"value":1011,"label":"Contains"},{"value":1012,"label":" Word Contains"}]},{"type":"dateRange","name":"CRA_DATE","label":"Registration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}},{"type":"select","name":"STATUS_ID","label":"Status","defaultValue":0,"options":[{"value":0,"label":"All"},{"value":121,"label":"Active"},{"value":122,"label":"Inactive"}]},{"type":"select","name":"AGENT_TYPE_ID","label":"Agent Type","defaultValue":0,"options":[{"value":0,"label":"All"},{"value":460,"label":"Registered Agent"},{"value":461,"label":"Commercial Registered Agent"}]}]},{"label":"Farm Bill","component":"FarmBill","parameter":"farm-bill","path":"/lists/farm-bill","sourceTypeId":0,"myRecordsSearch":false,"allowedRules":["/search/"],"disabled":true,"searchDescription":"To perform a search, enter a debtor name. Your search results may include: exact debtor name, variations of that name and any filing that includes your search criteria. Punctuation is ignored.\n\nYou can click on \"Advanced\" to refine your search. Under “Advanced” you can search by crop, year, county and SSN/FEIN. As a registered Farm Bill Buyer with the Montana Secretary of State’s office it is important to maintain the confidentiality of the information contained within the Farm Bill Master List. The Farm Bill Master List reflects personal data, such as Social Security Numbers, which are a key piece of personal identifiable information to assist you in determining the existence of a lien against a specific debtor. The distribution of this information beyond its intended purpose is strictly prohibited.\n\nThe debtor's tax identification number has been hidden for confidentiality reasons. You may continue to search on a tax ID number and return debtors that match your search criteria. The SSN/FEIN must be entered without dashes or spaces.","searchMustHaveOneOf":["search","UCC_FARM_PRODUCT_ID","COUNTY"],"searchPlaceholder":"Search by debtor name","advancedSearchParameters":[{"type":"ServerMultiComplete","label":"Product code name(s)","name":"UCC_FARM_PRODUCT_ID","defaultValue":"","optionsSrc":"UCC_FARM_PRODUCT_V"},{"type":"MultiComplete","label":"Year or Range of Years","name":"YEAR_NUM","optionsSrc":"years","startYear":"1968","defaultValue":[],"preMergeOptions":[{"value":"ALL","label":"All"}]},{"type":"serverSelect","label":"State","name":"STATE","defaultValue":"MONTANA","optionsSrc":"STATE"},{"type":"ServerMultiComplete","label":"County","name":"COUNTY","defaultValue":[],"optionsSrc":"COUNTY","overrideSubOptionsSrcFromParameterName":"STATE"},{"type":"checkbox","name":"TIN_SEARCH_YN","defaultValue":false,"label":"Tax Identification Number Search"},{"type":"checkbox","name":"TIN_SORT_YN","defaultValue":false,"label":"Unique ID Sort"}]}]) : [];
	
	var getFiltersByLocalStorageKey = exports.getFiltersByLocalStorageKey = function getFiltersByLocalStorageKey(lsKey) {
	  var cachedFilters = _localStorage2.default.get(lsKey);
	  var filterType = lsKey == 'MY_WORK_QUEUE_FILTERS' ? 'myWorkQueueFilters' : 'myRecordsFilters';
	  var filtersByCategory = SUBROUTES.reduce(function (obj, sub) {
	    return Object.assign({}, obj, _defineProperty({}, sub.parameter, sub[filterType] ? sub[filterType].reduce(function (fObj, f) {
	      return Object.assign({}, fObj, _defineProperty({}, f.name, f.defaultValue || ''));
	    }, {
	      SEARCH: ''
	    }) : {}));
	  }, {});
	  if (cachedFilters) {
	    filtersByCategory = Object.keys(filtersByCategory).reduce(function (obj, category) {
	      return Object.assign({}, obj, _defineProperty({}, category, Object.keys(filtersByCategory[category]).reduce(function (fObj, key) {
	        return Object.assign({}, fObj, _defineProperty({}, key, cachedFilters[category] ? cachedFilters[category][key] !== undefined ? cachedFilters[category][key] : filtersByCategory[category][key] : filtersByCategory[category][key]));
	      }, {})));
	    }, {});
	  }
	  return filtersByCategory;
	};

/***/ },
/* 290 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getWizardAttributeIsLogicControlled = exports.getIsLogicControlled = exports.AttributeWarning = exports.Attribute = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(7);
	
	var _reactInputRange = __webpack_require__(1295);
	
	var _reactInputRange2 = _interopRequireDefault(_reactInputRange);
	
	__webpack_require__(446);
	
	var _requests = __webpack_require__(6);
	
	var _validate = __webpack_require__(45);
	
	var _Form = __webpack_require__(14);
	
	var _TextEditor = __webpack_require__(452);
	
	var _TextEditor2 = _interopRequireDefault(_TextEditor);
	
	var _MetaEditor = __webpack_require__(1084);
	
	var _MetaEditor2 = _interopRequireDefault(_MetaEditor);
	
	var _ConstraintsEditor = __webpack_require__(1072);
	
	var _ConstraintsEditor2 = _interopRequireDefault(_ConstraintsEditor);
	
	var _SelectOptionConstrainer = __webpack_require__(1089);
	
	var _SelectOptionConstrainer2 = _interopRequireDefault(_SelectOptionConstrainer);
	
	var _Portal = __webpack_require__(12);
	
	var _Portal2 = _interopRequireDefault(_Portal);
	
	var _Modal = __webpack_require__(13);
	
	var _selectOptions = __webpack_require__(68);
	
	var _shortid = __webpack_require__(22);
	
	var _shortid2 = _interopRequireDefault(_shortid);
	
	var _utilities = __webpack_require__(8);
	
	var _MultiComplete = __webpack_require__(120);
	
	var _MultiComplete2 = _interopRequireDefault(_MultiComplete);
	
	var _lock = __webpack_require__(576);
	
	var _lock2 = _interopRequireDefault(_lock);
	
	var _store = __webpack_require__(18);
	
	var _store2 = _interopRequireDefault(_store);
	
	var _CustomBusinessRulesEditor = __webpack_require__(1073);
	
	var _CustomBusinessRulesEditor2 = _interopRequireDefault(_CustomBusinessRulesEditor);
	
	var _DesignerActions = __webpack_require__(44);
	
	var _RegulatedWordsSelector = __webpack_require__(1087);
	
	var _RegulatedWordsSelector2 = _interopRequireDefault(_RegulatedWordsSelector);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Attribute = exports.Attribute = function (_Component) {
	  _inherits(Attribute, _Component);
	
	  function Attribute() {
	    _classCallCheck(this, Attribute);
	
	    var _this = _possibleConstructorReturn(this, (Attribute.__proto__ || Object.getPrototypeOf(Attribute)).call(this));
	
	    _this.htmlId = _shortid2.default.generate();
	
	    _this.handleTextChange = function (e) {
	      var value = e.target.value;
	      if (_this.props.maxLength) {
	        value = value.slice(0, _this.props.maxLength);
	      }
	      _this.props.handleChange(_this.props.name, value, _this.props.additionalName);
	    };
	
	    _this.handleNumberChange = function (e) {
	      _this.props.handleChange(_this.props.name, _validate.MASK.onlyNumbers(e.target.value), _this.props.additionalName);
	    };
	
	    _this.handleFloatChange = function (e) {
	      _this.props.handleChange(_this.props.name, _validate.MASK.onlyNumbers(e.target.value, { allowDecimal: true }), _this.props.additionalName);
	    };
	
	    _this.handleRangeChange = function (e) {
	      if (/%/.test(_this.props.value)) {
	        e += '%';
	      }
	      _this.props.handleChange(_this.props.name, e, _this.props.additionalName);
	    };
	
	    _this.handleCheckChange = function (e) {
	      _this.props.handleChange(_this.props.name, e.target.checked, _this.props.additionalName);
	    };
	
	    _this.handleSelectChange = function (e) {
	      _this.props.handleChange(_this.props.name, e.target.value, _this.props.additionalName);
	    };
	
	    _this.handleGenericChange = function (name, value) {
	      _this.props.handleChange(name, value, _this.props.additionalName);
	    };
	
	    _this.fireButtonAction = function () {
	      _store2.default.dispatch(Object.assign({
	        type: _this.props.action
	      }, _this.props.actionPayload));
	      if (_this.props.onActionFired) {
	        _this.props.onActionFired();
	      }
	    };
	
	    _this.sanitizeRangeValue = function (value) {
	      value = value.toString();
	      return parseInt(value.replace('%', ''), 10);
	    };
	
	    _this.handleFocus = function () {
	      _this.setState({ focused: true, unFocused: false });
	    };
	
	    _this.handleBlur = function () {
	      _this.setState({ unFocused: true });
	    };
	
	    _this.handleTransition = function () {
	      _this.setState({ focused: false });
	    };
	
	    _this.state = { focused: false, confirmOpen: false, confirmed: false };
	    _this.id = _shortid2.default.generate();
	    return _this;
	  }
	
	  _createClass(Attribute, [{
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var focusEvents = { onFocus: this.handleFocus, onBlur: this.handleBlur };
	      var disabled = this.props.disabled || this.props.isLogicControlled;
	      return _react2.default.createElement(
	        'div',
	        {
	          className: 'dummy-field attribute ' + (this.props.className ? this.props.className : '') + (this.props.isLogicControlled ? 'logic-controlled' : ''),
	          onClick: this.props.onClick,
	          style: this.props.padding === false ? { paddingLeft: '0px', paddingRight: '0px' } : null
	        },
	        this.props.isLogicControlled ? _react2.default.createElement(
	          _react2.default.Fragment,
	          null,
	          _react2.default.createElement(
	            'span',
	            { className: 'round-icon-wrapper' },
	            _react2.default.createElement(_lock2.default, null)
	          ),
	          _react2.default.createElement(
	            'span',
	            { className: 'logic-tip' },
	            'This attribute is being controlled by the logic editor.'
	          )
	        ) : null,
	        this.props.type !== 'checkbox' && this.props.type !== 'button' && this.props.label !== '' && this.props.type !== 'required' && this.props.type !== 'textEditor' && this.props.label ? _react2.default.createElement(
	          'label',
	          { id: this.htmlId, className: 'field-label ' },
	          _react2.default.createElement(
	            'span',
	            { className: 'label-text ' + (this.props.required ? 'required' : '') },
	            this.props.label
	          ),
	          this.props.tip ? _react2.default.createElement(
	            'span',
	            { 'aria-hidden': 'true', className: 'tip', title: this.props.tip },
	            'i'
	          ) : null
	        ) : null,
	        this.props.description !== '' && this.props.description ? _react2.default.createElement(
	          'p',
	          { className: 'description' },
	          this.props.description
	        ) : null,
	        this.props.type === 'text' && _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement('input', {
	            'aria-labelledby': this.htmlId,
	            'aria-describedby': 'info' + this.htmlId,
	            type: 'text',
	            value: this.props.value,
	            onChange: this.handleTextChange,
	            disabled: disabled
	          }),
	          this.props.tip && _react2.default.createElement(
	            'p',
	            { id: 'info' + this.htmlId, className: 'visually-hidden' },
	            ' ',
	            this.props.tip,
	            ' '
	          )
	        ),
	        this.props.type === 'number' && _react2.default.createElement('input', { type: 'text', value: this.props.value, onChange: this.handleNumberChange }),
	        this.props.type === 'float' && _react2.default.createElement('input', { type: 'text', value: this.props.value, onChange: this.handleFloatChange }),
	        this.props.type === 'date' && _react2.default.createElement(_Form.DateInput, {
	          value: this.props.value,
	          onChange: function onChange(date) {
	            _this2.handleGenericChange(_this2.props.name, date);
	          }
	        }),
	        this.props.type === 'textarea' ? _react2.default.createElement(
	          'div',
	          { className: 'block-wrapper' },
	          _react2.default.createElement('textarea', Object.assign({
	            'aria-labelledby': this.htmlId,
	            'aria-describedby': 'info' + this.htmlId,
	            rows: this.props.rows,
	            cols: this.props.cols,
	            onChange: this.handleTextChange,
	            disabled: disabled
	          }, focusEvents, {
	            value: this.props.value ? this.props.value : ''
	          })),
	          this.props.tip && _react2.default.createElement(
	            'p',
	            { id: 'info' + this.htmlId, className: 'visually-hidden' },
	            ' ',
	            this.props.tip,
	            ' '
	          ),
	          this.props.markdown && this.state.focused ? _react2.default.createElement(
	            'span',
	            {
	              className: 'markdown-instructions animated fast-animation ' + (!this.state.unFocused ? 'fadeIn' : 'fadeOut'),
	              onTransitionEnd: this.handleTransition
	            },
	            '_',
	            _react2.default.createElement(
	              'i',
	              null,
	              'italic'
	            ),
	            '_ \xA0 **',
	            _react2.default.createElement(
	              'b',
	              null,
	              'bold'
	            ),
	            '** \xA0 [Link Text](URL) \xA0',
	            ' ',
	            _react2.default.createElement(
	              'a',
	              { href: 'http://commonmark.org/help/', target: '_blank' },
	              '...More'
	            )
	          ) : null
	        ) : null,
	        this.props.type === 'select' ? _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement(
	            'select',
	            {
	              'aria-labelledby': this.htmlId,
	              'aria-describedby': 'info' + this.htmlId,
	              onChange: this.handleSelectChange,
	              disabled: disabled,
	              value: this.props.value },
	            this.props.options.map(function (option, i) {
	              return _react2.default.createElement(
	                'option',
	                { value: option.value, key: i },
	                option.label
	              );
	            })
	          ),
	          this.props.tip && _react2.default.createElement(
	            'p',
	            { id: 'info' + this.htmlId, className: 'visually-hidden' },
	            ' ',
	            this.props.tip,
	            ' '
	          )
	        ) : null,
	        this.props.type === 'stateSelect' && _react2.default.createElement(Attribute, Object.assign({}, this.props, { label: '', type: 'select', options: _selectOptions.stateOptions })),
	        this.props.type === 'serverOptions' ? _react2.default.createElement(ServerAttributeSelect, {
	          optionsSrc: this.props.optionsSrc,
	          subOptionsSrc: this.props.subOptionsSrc,
	          controlType: this.props.controlType,
	          options: this.props.options,
	          required: this.props.required,
	          value: this.props.value,
	          placeholder: this.props.placeholder,
	          hideDefaultValue: this.props.hideDefaultValue,
	          isOverridingSubOptionsSrc: this.props.isOverridingSubOptionsSrc,
	          isOverridingOptionsSrc: this.props.isOverridingOptionsSrc,
	          isInRepeater: this.props.isInRepeater,
	          defaultValue: this.props.defaultValue,
	          onChange: this.handleGenericChange
	        }) : null,
	        this.props.type === 'genericServerOptions' ? _react2.default.createElement(GenericServerAttributeSelect, Object.assign({}, this.props, { onChange: this.handleGenericChange })) : null,
	        this.props.type === 'checkbox' ? _react2.default.createElement(
	          'div',
	          { className: 'checkbox-wrapper' },
	          _react2.default.createElement('input', {
	            'aria-describedby': 'info' + this.htmlId,
	            id: this.id,
	            name: this.id,
	            type: 'checkbox',
	            checked: this.props.value === undefined ? false : this.props.value,
	            className: 'attr-checkbox',
	            onChange: this.handleCheckChange,
	            disabled: disabled
	          }),
	          _react2.default.createElement('label', { className: 'checkbox-box', htmlFor: this.id }),
	          _react2.default.createElement(
	            'label',
	            { htmlFor: this.id, className: 'field-label check-label checkbox-label' },
	            _react2.default.createElement(
	              'span',
	              { className: 'label-text' },
	              this.props.label
	            ),
	            this.props.tip ? _react2.default.createElement(
	              'span',
	              {
	                'aria-hidden': 'true',
	                className: 'tip', title: this.props.tip },
	              'i'
	            ) : null
	          ),
	          this.props.tip && _react2.default.createElement(
	            'p',
	            { id: 'info' + this.htmlId, className: 'visually-hidden' },
	            ' ',
	            this.props.tip,
	            ' '
	          )
	        ) : null,
	        this.props.type === 'required' ? _react2.default.createElement(RequiredAttribute, {
	          hasBusinessRules: this.props.hasBusinessRules,
	          checked: this.props.value,
	          label: this.props.label,
	          onChange: this.handleGenericChange
	        }) : null,
	        this.props.type === 'range' ? _react2.default.createElement(_reactInputRange2.default, {
	          'aria-labelledby': this.htmlId,
	          minValue: this.props.minValue,
	          maxValue: this.props.maxValue,
	          step: this.props.step,
	          value: this.sanitizeRangeValue(this.props.value),
	          onChange: this.handleRangeChange
	        }) : null,
	        this.props.type === 'button' ? _react2.default.createElement(
	          'button',
	          {
	            className: 'attribute-button ' + this.props.buttonClass,
	            onClick: this.props.requiresConfirm ? function () {
	              _this2.setState({ confirmOpen: true });
	            } : this.fireButtonAction
	          },
	          this.props.label
	        ) : null,
	        this.props.type === 'button' && this.props.requiresConfirm ? _react2.default.createElement(
	          _Portal2.default,
	          { isOpened: this.state.confirmOpen },
	          _react2.default.createElement(_Modal.ConfirmDialog, {
	            closeModal: function closeModal() {
	              _this2.setState({ confirmOpen: false });
	            },
	            onModalClosed: function onModalClosed() {
	              if (_this2.state.confirmed) {
	                _this2.fireButtonAction();
	              }
	            },
	            message: this.props.confirmMessage,
	            buttons: [{ label: 'No', onClick: _utilities.noop, className: 'btn-default' }, {
	              label: 'Yes',
	              onClick: function onClick() {
	                _this2.setState({ confirmed: true });
	              },
	              className: 'btn-danger'
	            }],
	            modalStyle: { borderRadius: 3 }
	          })
	        ) : null,
	        this.props.type === 'textEditor' ? _react2.default.createElement(_TextEditor2.default, {
	          buttonLabel: this.props.label,
	          name: this.props.name,
	          onSave: this.handleGenericChange,
	          text: this.props.text,
	          placeholder: this.props.placeholder,
	          allowMergeCodes: this.props.allowMergeCodes
	        }) : null,
	        this.props.type === 'metaEditor' ? _react2.default.createElement(_MetaEditor2.default, {
	          pairs: this.props.value,
	          name: this.props.name,
	          id: this.props.id,
	          onChange: this.handleGenericChange,
	          buttonLabel: this.props.buttonLabel
	        }) : null,
	        this.props.type === 'fieldSrc' && _react2.default.createElement(FieldSrcSelect, Object.assign({}, this.props, { onChange: this.handleGenericChange })),
	        this.props.type === 'srcRepeaterColumn' && _react2.default.createElement(FieldSrcSelect, Object.assign({}, this.props, {
	          onChange: this.handleGenericChange,
	          limitToRepeaterSiblings: true
	        })),
	        this.props.type === 'constraints' && _react2.default.createElement(_ConstraintsEditor2.default, Object.assign({}, this.props, {
	          onChange: function onChange(value) {
	            _this2.handleGenericChange(_this2.props.name, value);
	          }
	        })),
	        this.props.type === 'selectOptionConstrainer' && _react2.default.createElement(_SelectOptionConstrainer2.default, Object.assign({}, this.props, {
	          onChange: function onChange(value) {
	            return _this2.handleGenericChange(_this2.props.name, value);
	          }
	        })),
	        this.props.type === 'localComplete' && _react2.default.createElement(FieldSrcSelect, Object.assign({}, this.props, {
	          onChange: this.handleGenericChange,
	          type: 'MultiComplete'
	        })),
	        this.props.type === 'customBusinessRules' && _react2.default.createElement(_CustomBusinessRulesEditor2.default, Object.assign({}, this.props, {
	          onChange: this.handleGenericChange
	        })),
	        this.props.type === 'regulatedWords' && _react2.default.createElement(_RegulatedWordsSelector2.default, Object.assign({}, this.props, { onChange: function onChange(list) {
	            return _this2.handleGenericChange(_this2.props.name, list);
	          }, id: this.id })),
	        this.props.children
	      );
	    }
	  }]);
	
	  return Attribute;
	}(_react.Component);
	
	exports.Attribute = Attribute = (0, _reactRedux.connect)(function (state, props) {
	  var selected = state.designer.selected;
	  if (selected) {
	    switch (selected.type) {
	      case 'FIELD':
	        {
	          var isLogicControlled = getIsLogicControlled(selected.id, props.name, state.designer.wizard.fields);
	          return { isLogicControlled: isLogicControlled };
	        }
	      case 'WIZARD':
	        {
	          var _isLogicControlled = getWizardAttributeIsLogicControlled(state.designer.wizard.wizardAttributesLogic, props.name);
	          return { isLogicControlled: _isLogicControlled };
	        }
	      default:
	        return { isLogicControlled: false };
	    }
	  } else {
	    return { isLogicControlled: false };
	  }
	})(Attribute);
	
	var RequiredAttribute = function (_Component2) {
	  _inherits(RequiredAttribute, _Component2);
	
	  function RequiredAttribute() {
	    var _ref;
	
	    var _temp, _this3, _ret;
	
	    _classCallCheck(this, RequiredAttribute);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this3 = _possibleConstructorReturn(this, (_ref = RequiredAttribute.__proto__ || Object.getPrototypeOf(RequiredAttribute)).call.apply(_ref, [this].concat(args))), _this3), _this3.handleChange = function (name, value) {
	      _this3.props.onChange(name, value);
	    }, _temp), _possibleConstructorReturn(_this3, _ret);
	  }
	
	  _createClass(RequiredAttribute, [{
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'div',
	        { className: 'block-wrapper', style: { marginTop: -10 } },
	        _react2.default.createElement(Attribute, {
	          padding: false,
	          label: 'Show Required Indicator',
	          type: 'checkbox',
	          name: 'required',
	          value: this.props.checked,
	          handleChange: this.handleChange
	        }),
	        !this.props.hasBusinessRules && this.props.checked ? _react2.default.createElement(
	          AttributeWarning,
	          null,
	          'You\'ve added a required indicator without adding any business rules. This will render a field which appears to be required, but will not be validated. To fix this, click',
	          ' ',
	          _react2.default.createElement(
	            'b',
	            null,
	            '"Edit Business Rules"'
	          ),
	          ' to add rules.'
	        ) : null
	      );
	    }
	  }]);
	
	  return RequiredAttribute;
	}(_react.Component);
	
	var ServerAttributeSelect = function (_Component3) {
	  _inherits(ServerAttributeSelect, _Component3);
	
	  function ServerAttributeSelect() {
	    _classCallCheck(this, ServerAttributeSelect);
	
	    var _this4 = _possibleConstructorReturn(this, (ServerAttributeSelect.__proto__ || Object.getPrototypeOf(ServerAttributeSelect)).call(this));
	
	    _this4.componentDidMount = function () {
	      _this4.getItems();
	    };
	
	    _this4.componentDidUpdate = function (prevProps, prevState) {
	      if (_this4.props.controlType !== prevProps.controlType) {
	        _this4.getItems();
	      }
	    };
	
	    _this4.getItems = function () {
	      _this4.getLookupGroups();
	      if (_this4.props.optionsSrc !== '0') {
	        if (_this4.props.subOptionsSrc !== '') {
	          (0, _requests.GET_GROUP_ITEMS)(_this4.props.optionsSrc, function (subOptionsSources) {
	            _this4.setState({
	              subOptionsSources: Array.isArray(subOptionsSources) ? subOptionsSources : subOptionsSources.options
	            });
	          });
	          _this4.getGroupItems(_this4.props.optionsSrc + '/' + _this4.props.subOptionsSrc);
	        } else {
	          _this4.getGroupItems(_this4.props.optionsSrc);
	        }
	      }
	    };
	
	    _this4.getLookupGroups = function () {
	      (0, _requests.GET_LOOKUP_GROUPS)(_this4.props.controlType, function (groups) {
	        var options = groups.map(function (group) {
	          return Object.assign({}, group, { label: _this4.formatLabel(group.label) });
	        });
	        _this4.setState({ optionsSources: options, optionsSourcesLoaded: true });
	      });
	    };
	
	    _this4.getSubLookupGroups = function () {
	      (0, _requests.GET_LOOKUP_GROUPS)(_this4.props.optionsSrc, function (groups) {
	        //console.log(groups);
	      });
	    };
	
	    _this4.getGroupItems = function (groupId) {
	      if (!_this4.state.initialLoad) {
	        _this4.props.onChange('selectedIndex', 0);
	        _this4.props.onChange('value', '0');
	      }
	      (0, _requests.GET_GROUP_ITEMS)(groupId, function (items) {
	        var options = Array.isArray(items) ? items : items.options;
	        _this4.props.setOptionsCacheById(groupId + (groupId.endsWith("/") ? "" : "/"), options);
	        _this4.setState({ initialLoad: false, options: options });
	      });
	    };
	
	    _this4.formatLabel = function (str) {
	      str = str.toLowerCase().split(' ');
	      for (var i = 0; i < str.length; i++) {
	        str[i] = str[i].split('');
	        if (str[i].length > 0) {
	          str[i][0] = str[i][0].toUpperCase();
	          str[i] = str[i].join('');
	        }
	      }
	      return str.join(' ').replace('_', ' ').replace('-', ' ');
	    };
	
	    _this4.handleSourceChange = function (name, value) {
	      _this4.props.onChange(name, value);
	      var selectedOptionSrc = _this4.state.optionsSources.find(function (option) {
	        return option.value == value;
	      });
	      var hasSubGroupsYN = selectedOptionSrc ? selectedOptionSrc.hasSubGroupsYN : false;
	      if (!hasSubGroupsYN) {
	        _this4.props.onChange('options', [{ value: 'loading', label: 'Loading' }]);
	        _this4.getGroupItems(value);
	      } else {
	        _this4.props.onChange('selectedIndex', 0);
	        _this4.props.onChange('options', [{ value: 'default', label: 'None' }]);
	        (0, _requests.GET_GROUP_ITEMS)(value, function (subOptionsSources) {
	          //console.log(subOptionsSources)
	          _this4.setState({ subOptionsSources: subOptionsSources.options });
	        });
	      }
	    };
	
	    _this4.handleSubSourceChange = function (name, value) {
	      _this4.props.onChange('subOptionsSrc', value);
	      _this4.getGroupItems(_this4.props.optionsSrc + '/' + value);
	    };
	
	    _this4.handleValueChange = function (name, value) {
	      _this4.props.onChange(name, value);
	      var selectedIndex = _this4.props.options.findIndex(function (option) {
	        return value == option.value;
	      });
	      if (selectedIndex < 0) {
	        selectedIndex = 0;
	      }
	      _this4.props.onChange('selectedIndex', selectedIndex);
	    };
	
	    _this4.state = {
	      optionsSources: [{ value: 'loading', label: 'Loading' }],
	      subOptionsSources: [{ value: 'loading', label: 'Loading' }],
	      optionsSourcesLoaded: false,
	      initialLoad: true,
	      options: []
	    };
	    return _this4;
	  }
	
	  _createClass(ServerAttributeSelect, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          optionsSrc = _props.optionsSrc,
	          hideDefaultValue = _props.hideDefaultValue,
	          isOverridingOptionsSrc = _props.isOverridingOptionsSrc,
	          isOverridingSubOptionsSrc = _props.isOverridingSubOptionsSrc,
	          isInRepeater = _props.isInRepeater;
	
	      var selectedOptionSrc = this.state.optionsSources.find(function (option) {
	        return option.value == optionsSrc;
	      });
	      var hasSubGroupsYN = selectedOptionSrc ? selectedOptionSrc.hasSubGroupsYN : false;
	      return _react2.default.createElement(
	        'div',
	        { className: 'block-wrapper' },
	        !isOverridingOptionsSrc && _react2.default.createElement(Attribute, {
	          padding: false,
	          label: 'Options Source',
	          type: 'select',
	          name: 'optionsSrc',
	          value: this.props.optionsSrc,
	          handleChange: this.handleSourceChange,
	          options: [{ value: '0', label: '[Select a source]' }].concat(_toConsumableArray(this.state.optionsSources))
	        }),
	        hasSubGroupsYN && !isOverridingSubOptionsSrc ? _react2.default.createElement(Attribute, {
	          padding: false,
	          label: 'Sub-options Source',
	          type: 'select',
	          name: 'subOptionsSrc',
	          value: this.props.subOptionsSrc,
	          handleChange: this.handleSubSourceChange,
	          options: [{ value: '0', label: '[Select a sub-option source]' }].concat(_toConsumableArray(this.state.subOptionsSources))
	        }) : null,
	        !isOverridingSubOptionsSrc ? this.props.required ? _react2.default.createElement(Attribute, {
	          padding: false,
	          label: 'Default Value',
	          type: 'select',
	          name: isInRepeater ? 'defaultValue' : 'value',
	          value: isInRepeater ? this.props.defaultValue : this.props.value,
	          handleChange: this.handleValueChange,
	          options: [{ value: '0', label: '[Select an Option]' }].concat(_toConsumableArray(this.state.options))
	        }) : !hideDefaultValue ? _react2.default.createElement(
	          'div',
	          { className: 'block-wrapper' },
	          _react2.default.createElement(Attribute, {
	            padding: false,
	            label: 'Default Value',
	            type: 'select',
	            name: isInRepeater ? 'defaultValue' : 'value',
	            value: isInRepeater ? this.props.defaultValue : this.props.value,
	            handleChange: this.handleValueChange,
	            options: [{ value: '0', label: this.props.placeholder }].concat(_toConsumableArray(this.state.options))
	          }),
	          this.props.value !== '0' ? _react2.default.createElement(
	            AttributeWarning,
	            null,
	            'Choosing a default option other than the empty option, "',
	            this.props.placeholder,
	            '" will exclude "',
	            this.props.placeholder,
	            '" from the available options.'
	          ) : null,
	          _react2.default.createElement(Attribute, {
	            padding: false,
	            label: 'Empty Option',
	            type: 'text',
	            name: 'placeholder',
	            value: this.props.placeholder,
	            handleChange: this.props.onChange,
	            tip: 'This option defaults to "None", but can be edited below. If the user selects this option it will be ignored by the server when submitting the form.'
	          })
	        ) : null : null
	      );
	    }
	  }]);
	
	  return ServerAttributeSelect;
	}(_react.Component);
	
	ServerAttributeSelect = (0, _reactRedux.connect)(null, { setOptionsCache: _DesignerActions.setOptionsCache, setOptionsCacheById: _DesignerActions.setOptionsCacheById })(ServerAttributeSelect);
	
	var FieldSrcSelect = function (_Component4) {
	  _inherits(FieldSrcSelect, _Component4);
	
	  function FieldSrcSelect() {
	    var _ref2;
	
	    var _temp2, _this5, _ret2;
	
	    _classCallCheck(this, FieldSrcSelect);
	
	    for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
	      args[_key2] = arguments[_key2];
	    }
	
	    return _ret2 = (_temp2 = (_this5 = _possibleConstructorReturn(this, (_ref2 = FieldSrcSelect.__proto__ || Object.getPrototypeOf(FieldSrcSelect)).call.apply(_ref2, [this].concat(args))), _this5), _this5.handleChange = function (e) {
	      _this5.props.onChange(_this5.props.name, e.target.value);
	    }, _temp2), _possibleConstructorReturn(_this5, _ret2);
	  }
	
	  _createClass(FieldSrcSelect, [{
	    key: 'render',
	    value: function render() {
	      var _this6 = this;
	
	      var _props2 = this.props,
	          options = _props2.options,
	          _props2$emptyOptionLa = _props2.emptyOptionLabel,
	          emptyOptionLabel = _props2$emptyOptionLa === undefined ? '[Select an Option]' : _props2$emptyOptionLa,
	          value = _props2.value,
	          _props2$emptyOptionVa = _props2.emptyOptionValue,
	          emptyOptionValue = _props2$emptyOptionVa === undefined ? '' : _props2$emptyOptionVa,
	          type = _props2.type,
	          selectedOptionExists = _props2.selectedOptionExists;
	
	      return type === 'MultiComplete' ? _react2.default.createElement(_MultiComplete2.default, {
	        onChange: function onChange(v) {
	          return _this6.props.onChange(_this6.props.name, v);
	        },
	        options: options,
	        value: value
	      }) : _react2.default.createElement(
	        'select',
	        { onChange: this.handleChange, value: value },
	        !selectedOptionExists ? _react2.default.createElement(
	          'option',
	          { value: value },
	          '[Selected Field Is Not Valid]'
	        ) : null,
	        _react2.default.createElement(
	          'option',
	          { value: emptyOptionValue },
	          emptyOptionLabel
	        ),
	        options.map(function (option, i) {
	          return _react2.default.createElement(
	            'option',
	            { value: option.value, key: i },
	            option.label
	          );
	        })
	      );
	    }
	  }]);
	
	  return FieldSrcSelect;
	}(_react.Component);
	
	FieldSrcSelect = (0, _reactRedux.connect)(function (state, props) {
	  var _props$props = props.props;
	  _props$props = _props$props === undefined ? {} : _props$props;
	  var excludeSelf = _props$props.excludeSelf,
	      _props$props$allowedT = _props$props.allowedTypes,
	      allowedTypes = _props$props$allowedT === undefined ? [] : _props$props$allowedT,
	      _props$parentField = props.parentField,
	      parentField = _props$parentField === undefined ? {} : _props$parentField,
	      secondExcludeSelf = props.excludeSelf,
	      parentFieldId = props.parentFieldId;
	
	  var options = Object.keys(state.designer.wizard.fields).map(function (fieldId) {
	    var label = state.designer.wizard.fields[fieldId].label;
	    var name = state.designer.wizard.fields[fieldId].name;
	    return {
	      value: fieldId,
	      label: label !== '' && label ? label.length > 50 ? label.substring(0, 50) + '...' : label : name
	    };
	  });
	  if (props.limitToRepeaterSiblings) {
	    var parent = state.designer.wizard.fields[props.parentField.parent.id];
	    options = options.filter(function (opt) {
	      return parent.template.includes(opt.value);
	    });
	  }
	  if (excludeSelf || secondExcludeSelf) {
	    options = options.filter(function (opt) {
	      return opt.value !== (parentFieldId || parentField.fieldId);
	    });
	  }
	  if (allowedTypes.length) {
	    options = options.filter(function (opt) {
	      var type = state.designer.wizard.fields[opt.value].type;
	      return allowedTypes.includes(type);
	    });
	  }
	  return {
	    options: options,
	    selectedOptionExists: props.value ? !!options.find(function (opt) {
	      return opt.value === props.value;
	    }) : true
	  };
	})(FieldSrcSelect);
	
	var GenericServerAttributeSelect = function (_Component5) {
	  _inherits(GenericServerAttributeSelect, _Component5);
	
	  function GenericServerAttributeSelect() {
	    _classCallCheck(this, GenericServerAttributeSelect);
	
	    var _this7 = _possibleConstructorReturn(this, (GenericServerAttributeSelect.__proto__ || Object.getPrototypeOf(GenericServerAttributeSelect)).call(this));
	
	    _this7.state = { options: null };
	    return _this7;
	  }
	
	  _createClass(GenericServerAttributeSelect, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _this8 = this;
	
	      if (this.props.getOptionsFunction) {
	        this.props.getOptionsFunction(function (options) {
	          _this8.setState({ options: options });
	        });
	      } else {
	        this.setState({ options: [] });
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props3 = this.props,
	          value = _props3.value,
	          name = _props3.name,
	          _props3$staticOptions = _props3.staticOptions,
	          staticOptions = _props3$staticOptions === undefined ? [] : _props3$staticOptions;
	
	      return _react2.default.createElement(Attribute, {
	        padding: false,
	        label: '',
	        type: 'select',
	        disabled: this.state.options === null,
	        name: name,
	        value: value,
	        handleChange: this.props.onChange,
	        options: this.state.options ? [].concat(_toConsumableArray(staticOptions), _toConsumableArray(this.state.options)) : [{ value: '0', label: 'Loading...' }]
	      });
	    }
	  }]);
	
	  return GenericServerAttributeSelect;
	}(_react.Component);
	
	var AttributeWarning = exports.AttributeWarning = function AttributeWarning(_ref3) {
	  var children = _ref3.children;
	  return _react2.default.createElement(
	    'div',
	    { className: 'block-wrapper attribute-warning' },
	    _react2.default.createElement('span', { className: 'glyphicon glyphicon-warning-sign' }),
	    ' ',
	    _react2.default.createElement(
	      'b',
	      null,
	      'Warning:'
	    ),
	    ' ',
	    children
	  );
	};
	
	var getIsLogicControlled = exports.getIsLogicControlled = function getIsLogicControlled(fieldId, name, fields) {
	  var field = fields[fieldId];
	
	  if (field) {
	    var outputNode = Object.values(field.logicNodes).find(function (n) {
	      return n.type === 'output';
	    });
	    if (outputNode) {
	      var logicControlMap = Object.keys(outputNode.connections.inputs).reduce(function (obj, input) {
	        obj[input] = true;
	        return obj;
	      }, {})[name];
	      return logicControlMap;
	    } else {
	      return false;
	    }
	  } else {
	    return false;
	  }
	};
	
	var getWizardAttributeIsLogicControlled = exports.getWizardAttributeIsLogicControlled = function getWizardAttributeIsLogicControlled(logic, name) {
	  var outputNode = Object.values(logic.nodes).find(function (n) {
	    return n.root;
	  });
	  if (outputNode) {
	    var logicControlMap = Object.keys(outputNode.connections.inputs).reduce(function (obj, input) {
	      obj[input] = true;
	      return obj;
	    }, {})[name];
	    return logicControlMap;
	  } else {
	    return false;
	  }
	};

/***/ },
/* 291 */,
/* 292 */,
/* 293 */,
/* 294 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _DragContext = __webpack_require__(85);
	
	var _shortid = __webpack_require__(22);
	
	var _shortid2 = _interopRequireDefault(_shortid);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	exports.default = function (_ref) {
	  var children = _ref.children,
	      onDragDelayStart = _ref.onDragDelayStart,
	      onDragStart = _ref.onDragStart,
	      onDrag = _ref.onDrag,
	      onDragEnd = _ref.onDragEnd,
	      _onMouseDown = _ref.onMouseDown,
	      _onTouchStart = _ref.onTouchStart,
	      disabled = _ref.disabled,
	      _ref$delay = _ref.delay,
	      delay = _ref$delay === undefined ? 6 : _ref$delay,
	      innerRef = _ref.innerRef,
	      data = _ref.data,
	      type = _ref.type,
	      rest = _objectWithoutProperties(_ref, ['children', 'onDragDelayStart', 'onDragStart', 'onDrag', 'onDragEnd', 'onMouseDown', 'onTouchStart', 'disabled', 'delay', 'innerRef', 'data', 'type']);
	
	  var dragStore = (0, _DragContext.useDragStore)();
	  var startCoordinates = _react2.default.useRef(null);
	  var offset = _react2.default.useRef();
	  var wrapper = _react2.default.useRef();
	  var draggableId = _react2.default.useRef(_shortid2.default.generate());
	
	  var getOffsetCoordinates = function getOffsetCoordinates(e) {
	    var clientX = e.clientX,
	        clientY = e.clientY;
	
	    return { x: clientX, y: clientY };
	  };
	
	  var updateCoordinates = function updateCoordinates(e) {
	    var coordinates = getOffsetCoordinates(e);
	    if (onDrag) {
	      onDrag(coordinates, e);
	    }
	  };
	
	  var stopDrag = function stopDrag(e) {
	    dragStore.dispatch.stopDrag();
	    var coordinates = getOffsetCoordinates(e);
	    if (onDragEnd) {
	      onDragEnd(e, coordinates);
	    }
	    window.removeEventListener('mouseup', stopDrag);
	    window.removeEventListener('mousemove', updateCoordinates);
	  };
	
	  var startDrag = function startDrag(e) {
	    if (onDragStart) {
	      onDragStart(e);
	    }
	    dragStore.dispatch.startDrag({
	      id: draggableId.current,
	      data: data,
	      type: type
	    });
	    var nodeRect = wrapper.current.getBoundingClientRect();
	    offset.current = {
	      x: startCoordinates.current.x - nodeRect.left,
	      y: startCoordinates.current.y - nodeRect.top
	    };
	    window.addEventListener('mouseup', stopDrag);
	    window.addEventListener('mousemove', updateCoordinates);
	  };
	
	  var checkDragDelay = function checkDragDelay(e) {
	    var x = void 0;
	    var y = void 0;
	    if ('ontouchstart' in window && e.touches) {
	      x = e.touches[0].clientX;
	      y = e.touches[0].clientY;
	    } else {
	      e.preventDefault();
	      x = e.clientX;
	      y = e.clientY;
	    }
	    var a = Math.abs(startCoordinates.current.x - x);
	    var b = Math.abs(startCoordinates.current.y - y);
	    var distance = Math.round(Math.sqrt(Math.pow(a, 2) + Math.pow(b, 2)));
	    var dragDistance = delay;
	    if (distance >= dragDistance) {
	      startDrag(e);
	      endDragDelay();
	    }
	  };
	
	  var endDragDelay = function endDragDelay() {
	    document.removeEventListener('mouseup', endDragDelay);
	    document.removeEventListener('mousemove', checkDragDelay);
	    startCoordinates.current = null;
	  };
	
	  var startDragDelay = function startDragDelay(e) {
	    if (onDragDelayStart) {
	      onDragDelayStart(e);
	    }
	    e.stopPropagation();
	    var x = void 0;
	    var y = void 0;
	    if ('ontouchstart' in window && e.touches) {
	      x = e.touches[0].clientX;
	      y = e.touches[0].clientY;
	    } else {
	      e.preventDefault();
	      x = e.clientX;
	      y = e.clientY;
	    }
	    startCoordinates.current = { x: x, y: y };
	    document.addEventListener('mouseup', endDragDelay);
	    document.addEventListener('mousemove', checkDragDelay);
	  };
	
	  return _react2.default.createElement(
	    'div',
	    Object.assign({
	      onMouseDown: function onMouseDown(e) {
	        if (!disabled) {
	          startDragDelay(e);
	        }
	        if (_onMouseDown) {
	          _onMouseDown(e);
	        }
	      },
	      onTouchStart: function onTouchStart(e) {
	        if (!disabled) {
	          startDragDelay(e);
	        }
	        if (_onTouchStart) {
	          _onTouchStart(e);
	        }
	      },
	      onDragStart: function onDragStart(e) {
	        e.preventDefault();
	        e.stopPropagation();
	      },
	      ref: function ref(_ref2) {
	        wrapper.current = _ref2;
	        if (innerRef) {
	          innerRef.current = _ref2;
	        }
	      }
	    }, rest),
	    children
	  );
	};

/***/ },
/* 295 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.StackedLabel = exports.Detail = exports.DetailBlock = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _utilities = __webpack_require__(8);
	
	__webpack_require__(539);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var DetailBlock = exports.DetailBlock = function DetailBlock(_ref) {
	  var children = _ref.children,
	      _ref$title = _ref.title,
	      title = _ref$title === undefined ? '' : _ref$title;
	  return _react2.default.createElement(
	    'div',
	    { className: 'detail-block' },
	    _react2.default.createElement(
	      'div',
	      { className: 'title' },
	      title
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'details' },
	      children
	    )
	  );
	};
	
	var Detail = exports.Detail = function (_React$Component) {
	  _inherits(Detail, _React$Component);
	
	  function Detail() {
	    var _ref2;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, Detail);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref2 = Detail.__proto__ || Object.getPrototypeOf(Detail)).call.apply(_ref2, [this].concat(args))), _this), _this.formatValueByType = function () {
	      var _this$props = _this.props,
	          value = _this$props.value,
	          type = _this$props.type;
	
	      switch (type) {
	        case 'address':
	          return _react2.default.createElement(_utilities.FormattedAddress, { value: value });
	        default:
	          return value;
	      }
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(Detail, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          label = _props.label,
	          value = _props.value,
	          _props$nullValue = _props.nullValue,
	          nullValue = _props$nullValue === undefined ? '' : _props$nullValue;
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'detail-wrapper' },
	        _react2.default.createElement(
	          'label',
	          null,
	          label
	        ),
	        _react2.default.createElement(
	          'span',
	          { className: 'value' },
	          value ? this.formatValueByType() : nullValue
	        )
	      );
	    }
	  }]);
	
	  return Detail;
	}(_react2.default.Component);
	
	var StackedLabel = exports.StackedLabel = function StackedLabel(_ref3) {
	  var primary = _ref3.primary,
	      secondary = _ref3.secondary;
	  return _react2.default.createElement(
	    'div',
	    { className: 'stacked-label' },
	    _react2.default.createElement(
	      'span',
	      { className: 'primary' },
	      primary
	    ),
	    _react2.default.createElement(
	      'span',
	      { className: 'secondary' },
	      secondary
	    )
	  );
	};

/***/ },
/* 296 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.DummyFormIcon = exports.DummyFormBlock = exports.FormBlockCard = exports.ExpandableFormBlock = exports.DumbCategory = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(7);
	
	var _Shell = __webpack_require__(19);
	
	var _reactRouterDom = __webpack_require__(30);
	
	var _requests = __webpack_require__(6);
	
	var _Loaders = __webpack_require__(16);
	
	var _document = __webpack_require__(126);
	
	var _document2 = _interopRequireDefault(_document);
	
	var _documentAdd = __webpack_require__(562);
	
	var _documentAdd2 = _interopRequireDefault(_documentAdd);
	
	var _reactPropTransition = __webpack_require__(317);
	
	var _reactPropTransition2 = _interopRequireDefault(_reactPropTransition);
	
	var _reactOnclickoutside = __webpack_require__(153);
	
	var _reactOnclickoutside2 = _interopRequireDefault(_reactOnclickoutside);
	
	var _import = __webpack_require__(160);
	
	var _import2 = _interopRequireDefault(_import);
	
	var _crossHeavy = __webpack_require__(51);
	
	var _crossHeavy2 = _interopRequireDefault(_crossHeavy);
	
	var _utilities = __webpack_require__(8);
	
	var _WizardActions = __webpack_require__(36);
	
	var _Icons = __webpack_require__(298);
	
	var _Icons2 = _interopRequireDefault(_Icons);
	
	var _store = __webpack_require__(18);
	
	var _App = __webpack_require__(118);
	
	var _shortid = __webpack_require__(22);
	
	var _shortid2 = _interopRequireDefault(_shortid);
	
	var _FormsActions = __webpack_require__(1101);
	
	__webpack_require__(1443);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	// import CircularActionBlock from 'components/CircularActionBlock/CircularActionBlock';
	
	
	var Forms = function (_Component) {
	  _inherits(Forms, _Component);
	
	  function Forms() {
	    _classCallCheck(this, Forms);
	
	    var _this = _possibleConstructorReturn(this, (Forms.__proto__ || Object.getPrototypeOf(Forms)).call(this));
	
	    _this.componentDidMount = function () {
	      if (_this.props.match.params.category) {
	        if (!_App.SUBROUTES_OBJ[_this.props.match.params.category]) {
	          _this.props.history.replace('/404');
	        }
	        _this.getForms(_this.props.match.params.category);
	      }
	    };
	
	    _this.componentWillReceiveProps = function (nextProps) {
	      var prevCategory = _this.props.match.params.category;
	      var currentCategory = nextProps.match.params.category;
	      var categoryHasSwitched = prevCategory !== currentCategory && currentCategory;
	      if (categoryHasSwitched) {
	        if (!_App.SUBROUTES_OBJ[currentCategory]) {
	          _this.props.history.replace('/404');
	        } else if (!_this.state.wizardsLoaded[currentCategory]) {
	          _this.props.setActiveCategory(currentCategory);
	          _this.setState({ loading: true });
	          _this.getForms(currentCategory);
	        }
	      }
	    };
	
	    _this.getForms = function () {
	      var category = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _this.props.subLinks[0].parameter;
	
	      var promises = [];
	      promises[0] = new Promise(function (resolve) {
	        (0, _requests.GET_ALL_WIZARDS)(category, function (data) {
	          resolve(data);
	        });
	      });
	      promises[1] = new Promise(function (resolve) {
	        (0, _requests.GET_APP_SETTING_BY_NAME)('FORM_MANAGER_STRUCTURE', function (data) {
	          resolve(JSON.parse(data.VALUE));
	        });
	      });
	      Promise.all(promises).then(function (responses) {
	        var wizards = {};
	        responses[0].forEach(function (wizard) {
	          wizards[wizard.FORM_DEFINITION_ID] = wizard;
	        });
	        _this.setState(function (state) {
	          return {
	            wizards: Object.assign({}, state.wizards, wizards),
	            wizardsLoaded: Object.assign({}, state.wizardsLoaded, _defineProperty({}, category, true)),
	            categories: responses[1].categories,
	            categoriesOrder: responses[1].categoriesOrder,
	            categoryIcons: responses[1].categoryIcons,
	            loading: false
	          };
	        });
	      });
	    };
	
	    _this.loadForm = function (formDefinitionId) {
	      _this.props.history.push('/forms/new/' + formDefinitionId);
	    };
	
	    _this.setFilter = function (e) {
	      _this.setState({
	        filter: e.target.value
	      });
	    };
	
	    _this.state = {
	      wizards: null,
	      categories: null,
	      categoriesOrder: null,
	      categoryIcons: null,
	      loading: true,
	      wizardsLoaded: {},
	      filter: ''
	    };
	    return _this;
	  }
	
	  _createClass(Forms, [{
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _state = this.state,
	          loading = _state.loading,
	          categories = _state.categories,
	          categoriesOrder = _state.categoriesOrder,
	          _state$categoryIcons = _state.categoryIcons,
	          categoryIcons = _state$categoryIcons === undefined ? {} : _state$categoryIcons,
	          wizards = _state.wizards;
	      var _props = this.props,
	          siteOffline = _props.siteOffline,
	          match = _props.match,
	          activeCategory = _props.activeCategory,
	          sublinks = _props.sublinks;
	
	      var sanitizedCategory = match.params.category ? match.params.category : 'business';
	      var activeCategories = loading ? {} : categories[sanitizedCategory];
	      var activeCategoriesOrder = loading ? [] : categoriesOrder[sanitizedCategory] || [];
	      var activeCategoryIcon = loading ? '' : categoryIcons[sanitizedCategory];
	      var sublinkExists = sublinks.find(function (x) {
	        return x.parameter === match.params.category;
	      }) ? true : false;
	      return _react2.default.createElement(
	        _Shell.Body,
	        { className: 'forms', hiddenTitle: 'Forms' },
	        siteOffline && _react2.default.createElement(_reactRouterDom.Redirect, { to: '/' }),
	        _react2.default.createElement(Toolbar, { filter: this.state.filter, onChange: this.setFilter }),
	        !this.props.match.params.category || !sublinkExists ? _react2.default.createElement(_reactRouterDom.Redirect, { to: '/forms/' + (activeCategory || this.props.sublinks[0].parameter) }) : _react2.default.createElement(
	          _Shell.FlexWrapper,
	          { direction: 'column', 'aria-busy': loading },
	          loading ? _react2.default.createElement(
	            'div',
	            { className: 'loading-wrapper forms-wrapper' },
	            _react2.default.createElement(_Loaders.Spinner, { className: 'page-loader', themeColor: 'neutral' })
	          ) : activeCategoriesOrder.map(function (categoryId) {
	            return activeCategories[categoryId].wizardsOrder.length > 0 && activeCategories[categoryId].visible === true ? _react2.default.createElement(DumbCategory, Object.assign({}, activeCategories[categoryId], {
	              icon: activeCategoryIcon,
	              filter: _this2.state.filter,
	              key: categoryId,
	              wizards: wizards,
	              loadForm: _this2.loadForm
	            })) : null;
	          })
	        )
	      );
	    }
	  }]);
	
	  return Forms;
	}(_react.Component);
	
	exports.default = (0, _reactRedux.connect)(function (state) {
	  return {
	    siteOffline: state.app.appSettings.WEBSITE_PORTAL_OFFLINE_YN === true,
	    activeCategory: state.forms.activeCategory || state.app.currentCategory
	  };
	}, { setActiveCategory: _FormsActions.setActiveCategory })(Forms);
	
	var Toolbar = function (_Component2) {
	  _inherits(Toolbar, _Component2);
	
	  function Toolbar() {
	    var _ref;
	
	    var _temp, _this3, _ret;
	
	    _classCallCheck(this, Toolbar);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this3 = _possibleConstructorReturn(this, (_ref = Toolbar.__proto__ || Object.getPrototypeOf(Toolbar)).call.apply(_ref, [this].concat(args))), _this3), _this3.startImportWizard = function (e) {
	      (0, _utilities.readFileAsText)(e).then(function (json) {
	        json = (0, _utilities.getUniqueJSONvalues)(json);
	        _this3.props.resetWizardState();
	        _this3.props.fetchAndPopulateWizard(json.ORIGIN_FDID, function () {
	          _this3.props.reconstructWizardWithValues(json.FIELD_VALUES);
	          _store.history.push('new/' + json.ORIGIN_FDID + '?prefilled=true');
	        });
	      });
	    }, _this3.clearFilter = function () {
	      _this3.props.onChange({ target: { value: '' } });
	    }, _temp), _possibleConstructorReturn(_this3, _ret);
	  }
	
	  _createClass(Toolbar, [{
	    key: 'render',
	    value: function render() {
	      var _props2 = this.props,
	          filter = _props2.filter,
	          onChange = _props2.onChange,
	          isAdmin = _props2.isAdmin,
	          loggedIn = _props2.loggedIn;
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'toolbar' },
	        (isAdmin || (false) && loggedIn) && _react2.default.createElement(
	          'div',
	          { className: 'import-wrapper' },
	          _react2.default.createElement('input', {
	            type: 'file',
	            id: 'wizard-import',
	            name: 'wizard-import',
	            accept: 'application/json',
	            className: 'faux-hide',
	            onChange: this.startImportWizard
	          }),
	          _react2.default.createElement(
	            'label',
	            { className: 'btn btn-raised btn-primary import', htmlFor: 'wizard-import' },
	            _react2.default.createElement(_import2.default, null),
	            ' File From Import'
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'filter-wrapper' },
	          _react2.default.createElement('input', {
	            type: 'text',
	            className: 'filter',
	            placeholder: 'Filter',
	            value: filter,
	            onChange: onChange,
	            'aria-label': 'Filter forms'
	          }),
	          filter && _react2.default.createElement(
	            'button',
	            { 'aria-label': 'clear filter', className: 'clear', onClick: this.clearFilter },
	            _react2.default.createElement(_crossHeavy2.default, null)
	          )
	        )
	      );
	    }
	  }]);
	
	  return Toolbar;
	}(_react.Component);
	
	Toolbar = (0, _reactRedux.connect)(function (state) {
	  return {
	    isAdmin: state.auth.USER_GROUP === 'ADMIN_WEB' || state.auth.USER_GROUP === 'ADMIN',
	    loggedIn: state.auth.loggedIn
	  };
	}, { fetchAndPopulateWizard: _WizardActions.fetchAndPopulateWizard, reconstructWizardWithValues: _WizardActions.reconstructWizardWithValues, resetWizardState: _WizardActions.resetWizardState })(Toolbar);
	
	var DumbCategory = exports.DumbCategory = function (_Component3) {
	  _inherits(DumbCategory, _Component3);
	
	  function DumbCategory() {
	    var _ref2;
	
	    var _temp2, _this4, _ret2;
	
	    _classCallCheck(this, DumbCategory);
	
	    for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
	      args[_key2] = arguments[_key2];
	    }
	
	    return _ret2 = (_temp2 = (_this4 = _possibleConstructorReturn(this, (_ref2 = DumbCategory.__proto__ || Object.getPrototypeOf(DumbCategory)).call.apply(_ref2, [this].concat(args))), _this4), _this4.getFilteredForms = function () {
	      if (_this4.props.filter === '') {
	        return _this4.props.wizardsOrder || [];
	      } else {
	        var filter = _this4.props.filter.toLowerCase();
	        return (_this4.props.wizardsOrder || []).filter(function (fId) {
	          return _this4.props.wizards[fId] ? _this4.props.wizards[fId].TITLE.toLowerCase().includes(filter) : false;
	        });
	      }
	    }, _temp2), _possibleConstructorReturn(_this4, _ret2);
	  }
	
	  _createClass(DumbCategory, [{
	    key: 'render',
	    value: function render() {
	      var _props3 = this.props,
	          title = _props3.title,
	          wizards = _props3.wizards,
	          loadForm = _props3.loadForm,
	          _props3$icon = _props3.icon,
	          icon = _props3$icon === undefined ? '' : _props3$icon;
	
	      var filteredForms = this.getFilteredForms();
	      return filteredForms.length > 0 && _react2.default.createElement(
	        'div',
	        { className: 'category' },
	        _react2.default.createElement(
	          'div',
	          { className: 'title-wrapper' },
	          _react2.default.createElement(
	            'h2',
	            { className: 'title' },
	            title
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'form-blocks ' + (({"NODE_ENV":"production","BUILD_DATE":"2025-08-27T15:15:31.687Z","BUILD_NUMBER":"Not Provided","GIT_VERSION":"v1.3.0-381-ga81e29b08","GIT_COMMIT_HASH":"a81e29b085c9268ffd96c78eb734365802722741","GIT_BRANCH":"beta","PUBLIC_URL":"","STATE_ABBR":"MT","STATE_NAME":"Montana","STATE_ORG_TITLE":"Secretary of State","LOGIN_HEADER_IMG_PATH":"","HOME_IMG_FILENAME":"montana.jpg","FAVICON_FILE_NAME":"favicon.ico","ALLOW_E_SIGN_ON_CORRECTIONS":true,"THIRD_PARTY_SIGNING_ALLOWED":false,"MY_ACCOUNT_SAVE_AND_CLOSE_BUTTON":true,"IE_DEPRECATED_MESSAGE":"Internet Explorer is not supported. Please select a supported browser below to access this website.","ADDITIONAL_ROUTES":{"dataRequests":true,"farmBill":true,"apostille":true,"externalHelp":"https://sosmt.gov/business/help-center/","systemAdministration":[{"title":"Saved Payments","parameter":"saved-payments","componentName":"SavedPayments"}]},"SUBROUTES":[{"label":"Business","component":"Business","parameter":"business","myWorkQueueSearch":false,"sourceTypeId":54,"searchMustHaveOneOf":["FILING_TYPE_ID","STATUS_ID","STATE","search"],"serverWebSearchDescription":true,"serverWorkQueueDescription":true,"serverMyRecordsDescription":true,"searchPlaceholder":"Search by name or filing number (X########)","allowEmptySearchTerm":true,"requestCertificateAlternateLabel":"Request Information","fileAmendmentButtonLabel":"Filing Actions","advancedSearchParameters":[{"type":"radio","name":"QUERY_TYPE_ID","defaultValue":1010,"options":[{"value":1010,"label":"Starts with"},{"value":1011,"label":"Contains"},{"value":1012,"label":" Word Contains"}]},{"type":"serverSelect","name":"FILING_TYPE_ID","optionsSrc":"FILING_TYPES","label":"Entity Type","placeholder":"All","defaultValue":"0"},{"type":"serverSelect","name":"FILING_SUBTYPE_ID","optionsSrc":"FILING_SUBTYPES","label":"Entity Subtype","overrideSubOptionsSrcFromParameterName":"FILING_TYPE_ID","placeholder":"All","defaultValue":"0"},{"type":"serverSelect","name":"STATUS_ID","optionsSrc":"FILING_STATUS_WITHOUT_ALL","label":"Status","placeholder":"All","defaultValue":"0"},{"type":"serverSelect","name":"STATE","optionsSrc":"STATE","label":"State","placeholder":"All","defaultValue":""},{"type":"serverSelect","name":"COUNTY","optionsSrc":"COUNTY_SUBOPTION","label":"County","overrideSubOptionsSrcFromParameterName":"STATE","placeholder":"All","defaultValue":""},{"type":"checkbox","name":"CRA_SEARCH_YN","defaultValue":false,"label":"Search by Registered Agent PID"},{"type":"dateRange","name":"FILING_DATE","label":"Registration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}},{"type":"dateRange","name":"EXPIRATION_DATE","label":"Expiration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}}],"myRecordsFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Active"},{"value":2,"label":"Inactive"},{"value":3,"label":"Pending"}]},{"type":"dateRange","name":"DATE_RANGE","label":"Date range","defaultValue":{"start":null,"end":null}}],"myWorkQueueFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Approved"},{"value":2,"label":"Pending Online Payment"},{"value":3,"label":"Pending Review"},{"value":4,"label":"Needs Correction"},{"value":5,"label":"Rejected"},{"value":6,"label":"Draft"}]},{"type":"dateRange","name":"DATE_RANGE","label":"Date range","defaultValue":{"start":null,"end":null}}]},{"label":"Notary","component":"Notary","parameter":"notary","sourceTypeId":850,"myWorkQueueSearch":false,"allowEmptySearchTerm":true,"requestCertificateAlternateLabel":"Download Certificate","fileAmendmentButtonLabel":"Filing Actions","hideNameRequestCertificate":true,"hideAddressRequestCertificate":true,"hideRecordUserManagment":true,"searchPlaceholder":"Search by name or commission number","searchMustHaveOneOf":["CITY","search","SERVICE_TYPE"],"advancedParametersStartOpen":true,"searchIsSortable":true,"advancedSearchParameters":[{"type":"radio","name":"STARTS_WITH_YN","defaultValue":false,"options":[{"value":true,"label":"Starts with"},{"value":false,"label":"Contains"}]},{"type":"checkbox","name":"ACTIVE_ONLY_YN","defaultValue":true,"label":"Active entities only"},{"type":"text","name":"CITY","defaultValue":"","label":"City"},{"type":"select","name":"SERVICE_TYPE","label":"Special Services Offered","defaultValue":0,"options":[{"value":0,"label":"(N/A)"},{"value":6165,"label":"In-Person Electronic Notarization (IPEN)"},{"value":6166,"label":"Remote Online Notarization (RON)"},{"value":6167,"label":"Mobile Notary Services"},{"value":6168,"label":"Remote Ink Notarization (RIN)"}]}]},{"label":"Apostille","component":"Apostille","parameter":"apostille","sourceTypeId":720,"myRecordsSearch":false,"myWorkQueueSearch":false,"disabled":false,"allowedRoutes":["/forms-manager/","/queue/","/forms/"]},{"label":"Liens","component":"UCC","parameter":"ucc","sourceTypeId":1999,"myRecordsSearch":true,"myWorkQueueSearch":true,"fileAmendmentButtonLabel":"Filing Actions","searchPlaceholder":"Search by name or file number","disabled":false,"serverWebSearchDescription":true,"myRecordsDescription":"","workQueueDescription":"","searchDescription":"","hideRecordUserManagment":true,"searchLiensCheckout":false,"advancedSearchParameters":[{"type":"radio","name":"STARTS_WITH_YN","defaultValue":false,"options":[{"value":true,"label":"Starts with"},{"value":false,"label":"Contains"}]},{"type":"select","name":"STATUS","defaultValue":"ALL","label":"Status","options":[{"value":"ACTIVE_UNLAPSED","label":"Active (unlapsed)"},{"value":"ACTIVE_LAPSED_UNLAPSED","label":"Active (lapsed and unlapsed)"}]},{"type":"text","name":"EXCLUDE_VALUES","label":"Exclude Debtor Names (comma separated list of names to exclude)","defaultValue":""},{"type":"dateRange","name":"FILING_DATE","label":"Financing Statement Date","defaultValue":{"start":null,"end":null}},{"type":"dateRange","name":"LAPSE_DATE","label":"Lapse Date","defaultValue":{"start":null,"end":null}},{"type":"text","name":"CITY","label":"Debtor City","defaultValue":""}],"myRecordsFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Approved"},{"value":2,"label":"Pending Online Payment"},{"value":3,"label":"Pending Review"}]},{"type":"select","name":"TYPE","defaultValue":0,"label":"Lien Type","options":[{"value":0,"label":"All"},{"value":1,"label":"UCC"},{"value":2,"label":"EFS"},{"value":3,"label":"Title 71"}]}],"myWorkQueueFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Approved"},{"value":2,"label":"Pending Online Payment"},{"value":3,"label":"Pending Review"},{"value":4,"label":"Pending Print and Mail"},{"value":5,"label":"Rejected"},{"value":6,"label":"Draft"}]},{"type":"select","name":"TYPE","defaultValue":0,"label":"Lien Type","options":[{"value":0,"label":"All"},{"value":1,"label":"UCC"},{"value":2,"label":"EFS"},{"value":3,"label":"Title 71"}]}]},{"label":"Copy Request","component":"copies","parameter":"copies","sourceTypeId":2001,"myRecordsSearch":false,"myWorkQueueSearch":false,"disabled":false,"allowedRoutes":["/forms-manager/","/queue/","/forms/"]},{"label":"Trademark","component":"Trademark","parameter":"trademark","sourceTypeId":810,"showRequestCertificate":true,"searchMustHaveOneOf":["search","EXPIRATION_DATE","FILING_DATE"],"allowEmptySearchTerm":true,"requestCertificateAlternateLabel":"Request Information","fileAmendmentButtonLabel":"Filing Actions","advancedSearchParameters":[{"type":"radio","name":"QUERY_TYPE_ID","defaultValue":1010,"options":[{"value":1010,"label":"Starts with"},{"value":1011,"label":"Contains"},{"value":1012,"label":" Word Contains"}]},{"type":"checkbox","name":"OWNER_SEARCH_YN","defaultValue":false,"label":"Search owners"},{"type":"radio","name":"SERVICE_MARK_YN","label":"Mark Type","defaultValue":"","options":[{"value":"","label":"All Marks"},{"value":"Y","label":"Service Mark"},{"value":"N","label":"Trademark"}]},{"type":"serverSelect","name":"STATUS_ID","optionsSrc":"TYPE_V|TRADEMARK_STATUS_TYPE","label":"Status","placeholder":"All","defaultValue":"0"},{"type":"select","name":"DESIGN_TYPE_ID","options":[{"value":0,"label":"All"},{"value":990,"label":"Words Only"},{"value":991,"label":"Design Only"},{"value":992,"label":"Words and Design"}],"label":"Design Type","defaultValue":"0"},{"type":"dateRange","name":"FILING_DATE","label":"Registered Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}},{"type":"dateRange","name":"EXPIRATION_DATE","label":"Expiration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}}]},{"label":"Business Info Request","component":"InfoRequests","parameter":"info-request","sourceTypeId":167,"allowedRoutes":["/forms-manager/","/queue/","/forms/"]},{"label":"Data Requests","component":"DataRequests","parameter":"data-request","sourceTypeId":0,"allowedRoutes":["/forms-manager/"]},{"label":"CRA","component":"CRA","parameter":"cra","sourceTypeId":157,"myRecordsSearch":false,"searchPlaceholder":"Search by name or registered agent number","allowedRoutes":["/forms-manager/","/forms/","/records/","/queue/","/search/"],"allowEmptySearchTerm":true,"fileAmendmentButtonLabel":"Filing Actions","advancedSearchParameters":[{"type":"radio","name":"QUERY_TYPE_ID","defaultValue":1010,"options":[{"value":1010,"label":"Starts with"},{"value":1011,"label":"Contains"},{"value":1012,"label":" Word Contains"}]},{"type":"dateRange","name":"CRA_DATE","label":"Registration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}},{"type":"select","name":"STATUS_ID","label":"Status","defaultValue":0,"options":[{"value":0,"label":"All"},{"value":121,"label":"Active"},{"value":122,"label":"Inactive"}]},{"type":"select","name":"AGENT_TYPE_ID","label":"Agent Type","defaultValue":0,"options":[{"value":0,"label":"All"},{"value":460,"label":"Registered Agent"},{"value":461,"label":"Commercial Registered Agent"}]}]},{"label":"Farm Bill","component":"FarmBill","parameter":"farm-bill","path":"/lists/farm-bill","sourceTypeId":0,"myRecordsSearch":false,"allowedRules":["/search/"],"disabled":true,"searchDescription":"To perform a search, enter a debtor name. Your search results may include: exact debtor name, variations of that name and any filing that includes your search criteria. Punctuation is ignored.\n\nYou can click on \"Advanced\" to refine your search. Under “Advanced” you can search by crop, year, county and SSN/FEIN. As a registered Farm Bill Buyer with the Montana Secretary of State’s office it is important to maintain the confidentiality of the information contained within the Farm Bill Master List. The Farm Bill Master List reflects personal data, such as Social Security Numbers, which are a key piece of personal identifiable information to assist you in determining the existence of a lien against a specific debtor. The distribution of this information beyond its intended purpose is strictly prohibited.\n\nThe debtor's tax identification number has been hidden for confidentiality reasons. You may continue to search on a tax ID number and return debtors that match your search criteria. The SSN/FEIN must be entered without dashes or spaces.","searchMustHaveOneOf":["search","UCC_FARM_PRODUCT_ID","COUNTY"],"searchPlaceholder":"Search by debtor name","advancedSearchParameters":[{"type":"ServerMultiComplete","label":"Product code name(s)","name":"UCC_FARM_PRODUCT_ID","defaultValue":"","optionsSrc":"UCC_FARM_PRODUCT_V"},{"type":"MultiComplete","label":"Year or Range of Years","name":"YEAR_NUM","optionsSrc":"years","startYear":"1968","defaultValue":[],"preMergeOptions":[{"value":"ALL","label":"All"}]},{"type":"serverSelect","label":"State","name":"STATE","defaultValue":"MONTANA","optionsSrc":"STATE"},{"type":"ServerMultiComplete","label":"County","name":"COUNTY","defaultValue":[],"optionsSrc":"COUNTY","overrideSubOptionsSrcFromParameterName":"STATE"},{"type":"checkbox","name":"TIN_SEARCH_YN","defaultValue":false,"label":"Tax Identification Number Search"},{"type":"checkbox","name":"TIN_SORT_YN","defaultValue":false,"label":"Unique ID Sort"}]}],"SYSTEM_NICKNAME":"Online Services Portal","PAYMENT_METHODS":[{"type":"bypass"},{"type":"iTransact"}],"PAYMENT_ALLOW_AMEX":true,"SYSTEM_ID_LABEL":"System Id","DOUBLE_COLUMN_PUBLIC_LOGIN":true,"INTERNAL_USER_MANAGEMENT":true,"ALLOW_PUBLIC_JSON_IMPORT":false,"MAX_FILE_UPLOAD_SIZE":10000000,"REFUND_TEXT":"","RETURN_TO_HOME_ON_LOGOUT":true,"CURRENT_SOS_NAME":"Christi Jacobsen","LOGO_FILENAME":"mt-sos-logo.png","LOGO_ALT":"Christi Jacobsen, Montana Secretary of State","LOGO_FULL_WIDTH":true,"HOME_HIDE_AUTH_HINT":true,"HOME_TITLE":"Montana Secretary of State","CUSTOM_TAB_TITLE":"Official Montana","HOME_SUBTITLE":"Online Business Services","ENTITY_NAME_CONSENT_DESCRIPTION":"","ALLOW_USER_PROFILE_EDITING":true,"COMPARE_FOREIGN_NAME_IN_ENTITY_NAME_VALIDATION":true,"FOREIGN_NAME_FIELD_NAME":"KIMA_PARENT_NAME_INFO","LOGIN_TITLE":"Montana Secretary of State Online Filing Portal Login","PUBLIC_LOGIN_LABEL":"Username","REVERSE_LOGIN_COLUMNS":true,"LOGIN_SEAL_FILENAME":"seal_white.png","SEPARATE_USERNAME_AND_EMAIL":true,"CREATE_ACCOUNT_BUTTON_ALIGN_LEFT":true,"CREATE_ACCOUNT_BUTTON_TEXT":"CREATE AN ACCOUNT","PASSWORD_CUSTOM_ERROR_TEXT":"The password must meet all requirements","ACCOUNT_CREATED_MESSAGE":"Please check your email to verify your account to login and allow a few minutes for this message to arrive. Check your junk/spam folders if you do not find the email in your inbox.","PUBLIC_LOGIN_PLACEHOLDER":" ","DISABLE_DEFAULT_PAYMENT_RADIO":true,"CUSTOM_RESET_PASSWORD_ERROR_MESSAGE":"Username invalid - no account found","PUBLIC_LOGIN_CREATE_DESCRIPTION":"### Existing User:\n\n  - Enter your username and password to login.  \n\n\n  #### - OR -  \n\n\n\n  - Forgot password? Click 'Reset Password' and follow the prompts.\n  - Forgot username? Click 'Forgot Username' and follow the prompts.  \n\n\n  ### New User:\n  ","LOGIN_HELP_LINK":"https://sosmt.gov/business/how-do-i/","LOGIN_HELP_LINK_TEXT":"Need Help?","FORGOT_USERNAME_TEXT":"Forgot Username?","LOGIN_ACTIVE_DIRECTORY_TEXT":"State User Login","MULTIPLE_LOGIN_METHODS":true,"HAS_ACTIVE_DIRECTORY_LOGIN":true,"RESET_PASSWORD_WITH_USERNAME":true,"DOWNLOAD_LINK":true,"SHOW_USERNAME_ACCOUNT_CREATE":true,"SHOW_SCROLL_DOWN_ARROW":true,"SHOW_ADDRESS_ACCOUNT_CREATE":true,"TWO_COLUMN_ACCOUNT_CREATE":true,"RESET_PASSWORD_TIP":"A link to change your password has been sent to your email. Please allow a few minutes for this message to arrive. Please check your junk/spam folders if you do not find the email in your inbox.","FORGOT_PASSWORD_LINK_TEXT":"Reset Password","PHONE_NUMBER_OPTIONAL_ACCOUNT_CREATE":true,"SHOW_REQUIRED_INDICATOR_ACCOUNT_CREATE":true,"PASSWORD_REQUIREMENTS_ACCOUNT_CREATE":"\n    <ul>\n      <li>MUST contain at least 8 characters (12+ recommended)</li>\n      <li>MUST contain at least one uppercase letter.</li>\n      <li>MUST contain at least one lowercase letter.</li>\n      <li>MUST contain at least one number.</li>\n      <li>MUST contain at least one special character (!”#$%&'()*+,-./:;<=>?</li>\n    </ul>\n  ","ALLOW_CERTIFICATION_REQUEST":true,"ALLOW_PUBLIC_CERTIFICATE_REQUEST":true,"ALLOW_COPY_REQUEST":false,"ALLOW_CORRECTION_STYLING":true,"HIDE_DEPRECATION_WARNING":false,"AMEND_ROUTE_PUBLIC":true,"SEAL_FILENAME":"seal.png","SHOPPING_CART":true,"ALLOW_PAYMENT_UPDATE_WITH_EMPTY_CART":true,"RA_EMAIL":true,"RA_WEBSITE":true,"RA_NO_DEFAULT_TYPE":true,"RA_ADDRESS_LABEL":"Street Address","RA_TYPE_SELECTION_DEFAULT":true,"RA_DEFAULT_TYPE":"460","RA_OVERRIDE_TYPE_WITH_DEFAULT":true,"RA_PRINCIPAL_ADDRESS_AMS":true,"UPLOAD_AND_SUBMIT_HIDE_IF_ONE_OPTION":true,"PAYMENT_PROCESSING_MESSAGE":"Your payment is processing - Do not close your browser or click the back button","CHECKOUT_BUTTON_WHEN_PROCESSING_TEXT":"Processing","EFS_CROP_PICKER_NONE_LABEL":"Lien Duration","DISALLOWED_WIZARD_PIECES":["FormationLocale"],"REPEATER_SHOW_EDIT_BUTTON":true,"DATA_REQUEST_PAGE_TITLE":"Data Requests and Subscriptions","DATA_REQUEST_SIDEBAR_LABEL":"Data Requests & Subscriptions","LOGIN_REDIRECTS_TO_EPASS":false,"LOGIN_REDIRECTS_TO_ACTIVE_DIRECTORY":true,"LOGIN_ACTIVE_DIRECTORY_LINK":true,"FETCH_EDIT_USER_LINK":false,"LISTS_FETCH_AVAILABLE_LISTS":true,"POST_WIZARD_SUBMIT_REDIRECT_URL":"/","PIN_REQUEST_ATTESTATIONS":true,"PIN_REQUEST_DESCRIPTION":"Click **Request PIN** to have a new PIN sent to the account holder's email address on file.","OWNERSHIP_REQUEST_DESCRIPTION":"To become an **authorized user** of this record, a current **AUTHORIZED USER** will need to grant you access. To request access, click **Request Access** below.","PIN_REQUEST_SUCCESS_MESSAGE":"The PIN you have requested for this entity has been sent to the email associated with your user account.  You should receive the PIN in approximately 3-5 minutes, depending on your email service provider.","APOSTILLE_HEADER_LABEL":"Verification Information","APOSTILLE_NUMBER_LABEL":"Apostille/Authentication","APOSTILLE_CITY_STATE_OVERRIDE":"HELENA, MT","APOSTILLE_FILING_DATE_LABEL":"Issue Date","APOSTILLE_CITY_STATE_IN_CERTIFIED":true,"NOTARY_EXISTING_FILING":true,"ALLOW_REVOKE_OWN_ACCESS_ONLY":false,"HIDE_CANCEL_ON_ONETIME_DATA_REQUESTS":true,"DATA_REQUESTS_IN_SHOPPING_CART":true,"WQ_ALLOW_EDIT_PENDING_PAYMENT":true,"WQ_CONFIRM_ON_DELETE":true,"WQ_DELETE_CONFIRM_MESSAGE":"Deleting this filing will forfeit any money already paid to the Secretary of State. This action is permanent and cannot be undone, are you sure you would like to delete?","PASS_ITEM_GUIDS_ON_CHECKOUT":true,"FORM_REVISION_HISTORY":true,"CHECKOUT_DISCLAIMER":"By entering your credit card and/or checking account information you (i) state that **you are an authorized user** of the credit card and/or electronic check and that the associated information entered (e.g., account holder name, account number, billing address) is accurate, (ii) **you authorize payment processor to charge the amount you have requested** to your credit card and/or funding account, and (iii) **acknowledge if a charge is declined or reversed you may also be assessed a customary charge** by the payment processor for such transactions.","FARM_BILL_SEARCH_CONFIDENTIAL":"As a registered Farm Bill Buyer with the Montana Secretary of State’s office it is important to maintain the confidentiality of the information contained within the Farm Bill Master List. The Farm Bill Master List reflects personal data, such as Social Security Numbers, which are a key piece of personal identifiable information to assist you in determining the existence of a lien against a specific debtor. The distribution of this information beyond its intended purpose is strictly prohibited.\n\n**The debtor's tax identification number has been hidden for confidentiality reasons. You may continue to search on a tax ID number and return debtors that match your search criteria. The SSN/FEIN must be entered without dashes or spaces.  If you need access to the tax identification number to clearly identify the debtor, please contact the UCC unit at (406) 444-3665.**","VIEW_HISTORY_BUTTON_ALT_TEXT":"View Filings","WIZARD_ERROR_TITLE_MESSAGE":"Form Error","FARM_BILL_SEARCH_INTERACTIVE":true,"USE_FARM_BILL_API":true,"DISALLOW_ASSIGN_SELF_AS_RA":true,"DISALLOW_ASSIGN_SELF_AS_PRINCIPAL":true,"USE_TRADEMARK_OWNER_VALIDATION":true,"USE_ALTERNATIVE_FOREIGN_ADDRESS_LABELS":true,"MY_RECEIPTS_FILTER":[{"type":"dateRange","name":"DATE_RANGE","label":"Date range","defaultValue":{"start":null,"end":null}},{"type":"text","name":"REF_NUM","defaultValue":"","label":"Reference Number"},{"type":"text","name":"RECEIPT_NUM","defaultValue":"","label":"Receipt Id"},{"type":"text","name":"AMOUNT","defaultValue":"","label":"Amount"},{"type":"select","name":"TYPE","defaultValue":"","label":"Payment Type","options":[{"value":"","label":"All"},{"value":"CC","label":"Credit Card"},{"value":"Check","label":"Check"}]}],"MY_RECEIPTS_SHOW_IN_SIDEBAR":true,"SHOW_MY_RECEIPTS_HELPER_TEXT":true,"MY_RECEIPTS_HELPER_LABEL":"About Receipt Search","MY_RECEIPTS_HELPER_TEXT":"You can search for receipts based on their descriptions, including the items paid for on the receipt. Use the filters to search for or filter specific information.","FARM_BILL_SUBLINK":{"label":"Farm Bill","component":"FarmBill","parameter":"farm-bill","path":"/lists/farm-bill","sourceTypeId":0,"myRecordsSearch":false,"allowedRules":["/search/"],"disabled":true,"searchDescription":"To perform a search, enter a debtor name. Your search results may include: exact debtor name, variations of that name and any filing that includes your search criteria. Punctuation is ignored.\n\nYou can click on \"Advanced\" to refine your search. Under “Advanced” you can search by crop, year, county and SSN/FEIN. As a registered Farm Bill Buyer with the Montana Secretary of State’s office it is important to maintain the confidentiality of the information contained within the Farm Bill Master List. The Farm Bill Master List reflects personal data, such as Social Security Numbers, which are a key piece of personal identifiable information to assist you in determining the existence of a lien against a specific debtor. The distribution of this information beyond its intended purpose is strictly prohibited.\n\nThe debtor's tax identification number has been hidden for confidentiality reasons. You may continue to search on a tax ID number and return debtors that match your search criteria. The SSN/FEIN must be entered without dashes or spaces.","searchMustHaveOneOf":["search","UCC_FARM_PRODUCT_ID","COUNTY"],"searchPlaceholder":"Search by debtor name","advancedSearchParameters":[{"type":"ServerMultiComplete","label":"Product code name(s)","name":"UCC_FARM_PRODUCT_ID","defaultValue":"","optionsSrc":"UCC_FARM_PRODUCT_V"},{"type":"MultiComplete","label":"Year or Range of Years","name":"YEAR_NUM","optionsSrc":"years","startYear":"1968","defaultValue":[],"preMergeOptions":[{"value":"ALL","label":"All"}]},{"type":"serverSelect","label":"State","name":"STATE","defaultValue":"MONTANA","optionsSrc":"STATE"},{"type":"ServerMultiComplete","label":"County","name":"COUNTY","defaultValue":[],"optionsSrc":"COUNTY","overrideSubOptionsSrcFromParameterName":"STATE"},{"type":"checkbox","name":"TIN_SEARCH_YN","defaultValue":false,"label":"Tax Identification Number Search"},{"type":"checkbox","name":"TIN_SORT_YN","defaultValue":false,"label":"Unique ID Sort"}]},"ALLOW_ADDRESS_VALIDATION_BYPASS_OPTION":true,"DEFAULT_ADDRESS_VALIDATION_BYPASS_OPTION_CHECKED":true}).ID_EXTRA_FORMS_PADDING ? 'form-blocks-idaho' : '') },
	          filteredForms.map(function (formDefinitionId) {
	            var wizard = wizards[formDefinitionId];
	            return wizard && _react2.default.createElement(ExpandableFormBlock, {
	              label: wizard.TITLE,
	              onPrimaryButtonClick: loadForm,
	              description: wizard.DESCR,
	              formDefinitionId: wizard.FORM_DEFINITION_ID,
	              actionIcon: _react2.default.createElement(_documentAdd2.default, null),
	              icon: icon,
	              key: formDefinitionId
	            });
	          })
	        )
	      );
	    }
	  }]);
	
	  return DumbCategory;
	}(_react.Component);
	
	var ExpandableFormBlock = exports.ExpandableFormBlock = function (_Component4) {
	  _inherits(ExpandableFormBlock, _Component4);
	
	  function ExpandableFormBlock() {
	    var _ref3;
	
	    var _temp3, _this5, _ret3;
	
	    _classCallCheck(this, ExpandableFormBlock);
	
	    for (var _len3 = arguments.length, args = Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
	      args[_key3] = arguments[_key3];
	    }
	
	    return _ret3 = (_temp3 = (_this5 = _possibleConstructorReturn(this, (_ref3 = ExpandableFormBlock.__proto__ || Object.getPrototypeOf(ExpandableFormBlock)).call.apply(_ref3, [this].concat(args))), _this5), _this5.state = {
	      expanded: false,
	      initialHeight: null,
	      closing: false
	    }, _this5.expandCard = function () {
	      if (_this5.props.onStartExpand) {
	        _this5.props.onStartExpand();
	      }
	      var size = _this5.block.getSize();
	      _this5.setState({
	        expanded: true,
	        initialHeight: size.height
	      });
	      _this5.registerEscapeListener();
	    }, _this5.collapseCard = function (shouldNotReturnFocus) {
	      _this5.setState({
	        expanded: false,
	        closing: false
	      });
	      _this5.unregisterEscapeListener();
	    }, _this5.startCollapse = function () {
	      if (_this5.props.onStartCollapse) {
	        _this5.props.onStartCollapse();
	      }
	      _this5.setState({
	        closing: true
	      });
	      if (_this5.card) {
	        _this5.card.getInstance().close();
	      }
	    }, _this5.registerEscapeListener = function () {
	      document.addEventListener('keydown', _this5.handleKeyDown);
	    }, _this5.unregisterEscapeListener = function () {
	      document.removeEventListener('keydown', _this5.handleKeyDown);
	    }, _this5.handleKeyDown = function (e) {
	      if (e.keyCode === 27) {
	        _this5.startCollapse();
	        if (_this5.wrapper) {
	          _this5.wrapper.focus();
	        }
	      }
	    }, _this5.handleButtonKeyDown = function (e) {
	      if (e.keyCode === 13 || e.keyCode === 32) {
	        e.preventDefault();
	        if (_this5.state.expanded) {
	          _this5.startCollapse();
	        } else {
	          _this5.expandCard();
	        }
	      }
	    }, _temp3), _possibleConstructorReturn(_this5, _ret3);
	  }
	
	  _createClass(ExpandableFormBlock, [{
	    key: 'render',
	    value: function render() {
	      var _this6 = this;
	
	      var _props4 = this.props,
	          label = _props4.label,
	          icon = _props4.icon,
	          onPrimaryButtonClick = _props4.onPrimaryButtonClick,
	          formDefinitionId = _props4.formDefinitionId,
	          _props4$className = _props4.className,
	          className = _props4$className === undefined ? '' : _props4$className,
	          metadata = _props4.metadata,
	          actions = _props4.actions,
	          collapsedChildren = _props4.collapsedChildren,
	          description = _props4.description;
	
	      return _react2.default.createElement(
	        'div',
	        {
	          role: 'button',
	          tabIndex: this.state.expanded ? -1 : 0,
	          ref: function ref(_ref6) {
	            _this6.wrapper = _ref6;
	          },
	          className: 'form-block-wrapper custom-focus ' + className,
	          style: {
	            zIndex: this.state.expanded && !this.state.closing ? 10 : ''
	          },
	          onClick: this.state.expanded ? this.startCollapse : this.expandCard,
	          onKeyDown: this.handleButtonKeyDown,
	          'aria-expanded': this.state.expanded
	        },
	        this.state.expanded && _react2.default.createElement(FormBlockCard, {
	          onCloseAnimationFinished: this.collapseCard,
	          ref: function ref(_ref4) {
	            _this6.card = _ref4;
	          },
	          description: description,
	          formDefinitionId: formDefinitionId,
	          onPrimaryButtonClick: onPrimaryButtonClick,
	          label: label,
	          animated: true,
	          initialHeight: this.state.initialHeight,
	          onRequestClose: this.startCollapse,
	          icon: icon,
	          metadata: metadata,
	          actions: actions
	        }),
	        _react2.default.createElement(
	          DummyFormBlock,
	          {
	            ref: function ref(_ref5) {
	              _this6.block = _ref5;
	            },
	            label: label,
	            icon: icon
	          },
	          collapsedChildren
	        )
	      );
	    }
	  }]);
	
	  return ExpandableFormBlock;
	}(_react.Component);
	
	var FormBlockCard = exports.FormBlockCard = function (_React$PureComponent) {
	  _inherits(FormBlockCard, _React$PureComponent);
	
	  function FormBlockCard() {
	    var _ref7;
	
	    var _temp4, _this7, _ret4;
	
	    _classCallCheck(this, FormBlockCard);
	
	    for (var _len4 = arguments.length, args = Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
	      args[_key4] = arguments[_key4];
	    }
	
	    return _ret4 = (_temp4 = (_this7 = _possibleConstructorReturn(this, (_ref7 = FormBlockCard.__proto__ || Object.getPrototypeOf(FormBlockCard)).call.apply(_ref7, [this].concat(args))), _this7), _this7.state = {
	      visible: false,
	      targetHeight: _this7.props.initialHeight + 20,
	      closing: false
	    }, _this7.id = _shortid2.default.generate(), _this7.componentDidMount = function () {
	      _this7.calculateTargetHeight();
	      if (document.activeElement) {
	        document.activeElement.blur();
	      }
	      _this7.setVisible(true);
	      setTimeout(function () {
	        if (_this7.fileOnline) {
	          _this7.fileOnline.focus();
	        }
	      });
	    }, _this7.close = function (shouldNotReturnFocus) {
	      _this7.setState({
	        targetHeight: _this7.props.initialHeight + 20,
	        closing: true,
	        shouldNotReturnFocus: shouldNotReturnFocus
	      });
	    }, _this7.setVisible = function (visible) {
	      _this7.setState({
	        visible: visible
	      });
	    }, _this7.calculateTargetHeight = function () {
	      var card = _this7.card.getBoundingClientRect();
	      _this7.setState({
	        targetHeight: card.height
	      });
	    }, _this7.handleClickOutside = function () {
	      _this7.props.onRequestClose();
	    }, _this7.onPrimaryButtonClick = function (e) {
	      e.stopPropagation();
	      _this7.props.onPrimaryButtonClick(_this7.props.formDefinitionId);
	    }, _temp4), _possibleConstructorReturn(_this7, _ret4);
	  }
	
	  _createClass(FormBlockCard, [{
	    key: 'render',
	    value: function render() {
	      var _this8 = this;
	
	      var _props5 = this.props,
	          label = _props5.label,
	          icon = _props5.icon,
	          animated = _props5.animated,
	          metadata = _props5.metadata,
	          actions = _props5.actions,
	          description = _props5.description;
	
	      return _react2.default.createElement(
	        _reactPropTransition2.default,
	        { props: { height: this.state.targetHeight }, duration: 300 },
	        function (props) {
	          return _react2.default.createElement(
	            'div',
	            {
	              ref: function ref(_ref9) {
	                _this8.card = _ref9;
	              },
	              className: 'form-block-card ' + (animated ? _this8.state.closing ? 'shadow-out' : 'shadow-in' : ''),
	              style: {
	                height: _this8.state.visible ? props.height : '',
	                opacity: _this8.state.visible ? 1 : 0
	              },
	              role: 'dialog',
	              onKeyDown: function onKeyDown(e) {
	                return e.preventDefault();
	              },
	              onBlur: function onBlur(e) {
	                setTimeout(function () {
	                  if (!_this8.card.contains(document.activeElement)) {
	                    _this8.close(true);
	                  }
	                });
	              }
	            },
	            _this8.state.closing && _react2.default.createElement(RestDetector, {
	              target: _this8.props.initialHeight + 20,
	              current: props.height,
	              onRest: function onRest() {
	                _this8.props.onCloseAnimationFinished(_this8.state.shouldNotReturnFocus);
	              }
	            }),
	            _react2.default.createElement(DummyFormBlock, { label: label, icon: icon }),
	            _react2.default.createElement(
	              'p',
	              { className: 'description', id: _this8.id },
	              description
	            ),
	            metadata ? metadata : null,
	            _react2.default.createElement(
	              'div',
	              { className: 'actions' },
	              actions ? actions : _react2.default.createElement(
	                'button',
	                {
	                  className: 'btn btn-primary btn-text',
	                  'aria-describedby': _this8.id,
	                  onMouseDown: function onMouseDown(e) {
	                    return e.preventDefault();
	                  },
	                  onKeyDown: function onKeyDown(e) {
	                    if (e.key === "Enter" || e.key === " ") {
	                      _this8.onPrimaryButtonClick(e);
	                    }
	                  },
	                  onClick: _this8.onPrimaryButtonClick,
	                  ref: function ref(_ref8) {
	                    _this8.fileOnline = _ref8;
	                  }
	                },
	                'File Online'
	              )
	            )
	          );
	        }
	      );
	    }
	  }]);
	
	  return FormBlockCard;
	}(_react2.default.PureComponent);
	
	exports.FormBlockCard = FormBlockCard = (0, _reactOnclickoutside2.default)(FormBlockCard);
	
	var RestDetector = function (_Component5) {
	  _inherits(RestDetector, _Component5);
	
	  function RestDetector() {
	    var _ref10;
	
	    var _temp5, _this9, _ret5;
	
	    _classCallCheck(this, RestDetector);
	
	    for (var _len5 = arguments.length, args = Array(_len5), _key5 = 0; _key5 < _len5; _key5++) {
	      args[_key5] = arguments[_key5];
	    }
	
	    return _ret5 = (_temp5 = (_this9 = _possibleConstructorReturn(this, (_ref10 = RestDetector.__proto__ || Object.getPrototypeOf(RestDetector)).call.apply(_ref10, [this].concat(args))), _this9), _this9.componentWillReceiveProps = function (nextProps) {
	      if (nextProps.current === _this9.props.target) {
	        _this9.props.onRest();
	      }
	    }, _temp5), _possibleConstructorReturn(_this9, _ret5);
	  }
	
	  _createClass(RestDetector, [{
	    key: 'render',
	    value: function render() {
	      return null;
	    }
	  }]);
	
	  return RestDetector;
	}(_react.Component);
	
	var DummyFormBlock = exports.DummyFormBlock = function (_React$Component) {
	  _inherits(DummyFormBlock, _React$Component);
	
	  function DummyFormBlock() {
	    var _ref11;
	
	    var _temp6, _this10, _ret6;
	
	    _classCallCheck(this, DummyFormBlock);
	
	    for (var _len6 = arguments.length, args = Array(_len6), _key6 = 0; _key6 < _len6; _key6++) {
	      args[_key6] = arguments[_key6];
	    }
	
	    return _ret6 = (_temp6 = (_this10 = _possibleConstructorReturn(this, (_ref11 = DummyFormBlock.__proto__ || Object.getPrototypeOf(DummyFormBlock)).call.apply(_ref11, [this].concat(args))), _this10), _this10.getSize = function () {
	      var wrapper = _this10.wrapper.getBoundingClientRect();
	      return { width: wrapper.width, height: wrapper.height };
	    }, _temp6), _possibleConstructorReturn(_this10, _ret6);
	  }
	
	  _createClass(DummyFormBlock, [{
	    key: 'render',
	    value: function render() {
	      var _this11 = this;
	
	      var _props6 = this.props,
	          label = _props6.label,
	          icon = _props6.icon,
	          children = _props6.children;
	
	      return _react2.default.createElement(
	        'div',
	        {
	          className: 'form-block',
	          ref: function ref(_ref12) {
	            _this11.wrapper = _ref12;
	          }
	        },
	        _react2.default.createElement(DummyFormIcon, { icon: icon }),
	        _react2.default.createElement(
	          'h3',
	          null,
	          _react2.default.createElement(
	            'span',
	            { className: 'title' },
	            label
	          )
	        ),
	        children
	      );
	    }
	  }]);
	
	  return DummyFormBlock;
	}(_react2.default.Component);
	
	var DummyFormIcon = exports.DummyFormIcon = function (_React$PureComponent2) {
	  _inherits(DummyFormIcon, _React$PureComponent2);
	
	  function DummyFormIcon() {
	    _classCallCheck(this, DummyFormIcon);
	
	    return _possibleConstructorReturn(this, (DummyFormIcon.__proto__ || Object.getPrototypeOf(DummyFormIcon)).apply(this, arguments));
	  }
	
	  _createClass(DummyFormIcon, [{
	    key: 'render',
	    value: function render() {
	      var _props7 = this.props,
	          _props7$style = _props7.style,
	          style = _props7$style === undefined ? {} : _props7$style,
	          _props7$className = _props7.className,
	          className = _props7$className === undefined ? '' : _props7$className,
	          icon = _props7.icon,
	          innerRef = _props7.innerRef;
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'form-block-icon-container ' + className, ref: innerRef, style: style },
	        _react2.default.createElement(
	          'div',
	          { className: 'abbr-wrapper' },
	          _react2.default.createElement(
	            'div',
	            { className: 'abbr' },
	            _Icons2.default[icon]
	          ),
	          _react2.default.createElement(_document2.default, null)
	        )
	      );
	    }
	  }]);
	
	  return DummyFormIcon;
	}(_react2.default.PureComponent);

/***/ },
/* 297 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.EditLink = exports.EditCategoryModal = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(7);
	
	var _Shell = __webpack_require__(19);
	
	var _reactRouterDom = __webpack_require__(30);
	
	var _ExpandableCard = __webpack_require__(1095);
	
	var _ExpandableCard2 = _interopRequireDefault(_ExpandableCard);
	
	var _Modal = __webpack_require__(13);
	
	var _reactTooltip = __webpack_require__(78);
	
	var _reactTooltip2 = _interopRequireDefault(_reactTooltip);
	
	var _caretDown = __webpack_require__(38);
	
	var _caretDown2 = _interopRequireDefault(_caretDown);
	
	var _caretUp = __webpack_require__(80);
	
	var _caretUp2 = _interopRequireDefault(_caretUp);
	
	var _pencil = __webpack_require__(161);
	
	var _pencil2 = _interopRequireDefault(_pencil);
	
	var _dotMenu = __webpack_require__(159);
	
	var _dotMenu2 = _interopRequireDefault(_dotMenu);
	
	var _trash = __webpack_require__(60);
	
	var _trash2 = _interopRequireDefault(_trash);
	
	var _Icons = __webpack_require__(298);
	
	var _Icons2 = _interopRequireDefault(_Icons);
	
	var _Portal = __webpack_require__(12);
	
	var _Portal2 = _interopRequireDefault(_Portal);
	
	var _Field = __webpack_require__(25);
	
	var _Form = __webpack_require__(14);
	
	var _actions = __webpack_require__(29);
	
	var _HomeActions = __webpack_require__(1104);
	
	var _TextEditor = __webpack_require__(452);
	
	var _Markdown = __webpack_require__(24);
	
	var _Markdown2 = _interopRequireDefault(_Markdown);
	
	var _FloatingMenu = __webpack_require__(86);
	
	var _FloatingMenu2 = _interopRequireDefault(_FloatingMenu);
	
	var _QuickLinksEditor = __webpack_require__(1106);
	
	var _QuickLinksEditor2 = _interopRequireDefault(_QuickLinksEditor);
	
	__webpack_require__(1445);
	
	var _AddCategoryCard = __webpack_require__(1050);
	
	var _AddCategoryCard2 = _interopRequireDefault(_AddCategoryCard);
	
	var _shortid = __webpack_require__(22);
	
	var _shortid2 = _interopRequireDefault(_shortid);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Home = function (_Component) {
	  _inherits(Home, _Component);
	
	  function Home() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, Home);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Home.__proto__ || Object.getPrototypeOf(Home)).call.apply(_ref, [this].concat(args))), _this), _this.componentDidMount = function () {
	      _this.getHomeStructure();
	      _this.getSystemMessage();
	      _this.getAndSetCartQuantity();
	    }, _this.getAndSetCartQuantity = function () {
	      _this.props.getAndSetCartQuantity();
	    }, _this.getHomeStructure = function () {
	      _this.props.getHomeStructure();
	    }, _this.getSystemMessage = function () {
	      _this.props.getSystemMessage();
	    }, _this.addCategory = function (category) {
	      _this.props.updateAndPushCategories([].concat(_toConsumableArray(_this.props.rawStructure.categories), [Object.assign({}, category, { id: _shortid2.default.generate() })]));
	    }, _this.deleteCategory = function (index) {
	      _this.props.updateAndPushCategories([].concat(_toConsumableArray(_this.props.rawStructure.categories.slice(0, index)), _toConsumableArray(_this.props.rawStructure.categories.slice(index + 1))));
	    }, _this.updateCategoryByIndex = function (_ref2) {
	      var index = _ref2.index,
	          category = _ref2.category;
	
	      _this.props.updateAndPushCategories([].concat(_toConsumableArray(_this.props.rawStructure.categories.slice(0, index)), [Object.assign({}, _this.props.rawStructure.categories[index], category)], _toConsumableArray(_this.props.rawStructure.categories.slice(index + 1))));
	    }, _this.updateAndPushSystemMessage = function (message) {
	      _this.props.updateAndPushSystemMessage(message);
	    }, _this.updateAndPushFoldLinks = function (links) {
	      _this.props.updateAndPushFoldLinks(links);
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(Home, [{
	    key: "render",
	    value: function render() {
	      var _props = this.props,
	          categories = _props.categories,
	          foldLinks = _props.foldLinks,
	          systemMessage = _props.systemMessage,
	          loggedInAsAdmin = _props.loggedInAsAdmin,
	          rawStructure = _props.rawStructure;
	
	      return _react2.default.createElement(
	        _Shell.Body,
	        { className: "no-padding home" },
	        _react2.default.createElement(
	          "div",
	          { className: "header-row" },
	          _react2.default.createElement(
	            "h1",
	            null,
	            ("Montana Secretary of State") || ("Online Services Portal")
	          ),
	          _react2.default.createElement(
	            "span",
	            { className: "subtitle" },
	            ("Online Business Services") || ("Montana") + " " + ("Secretary of State")
	          ),
	          _react2.default.createElement(SystemMessage, {
	            onChange: this.updateAndPushSystemMessage,
	            message: systemMessage,
	            allowEdit: loggedInAsAdmin
	          }),
	          _react2.default.createElement("div", { className: "shade" })
	        ),
	        _react2.default.createElement(FoldLinks, { links: foldLinks, allowEdit: loggedInAsAdmin, onChange: this.updateAndPushFoldLinks }),
	        _react2.default.createElement(CategoryCards, {
	          updateCategoryByIndex: this.updateCategoryByIndex,
	          addCategory: this.addCategory,
	          categories: categories,
	          rawCategories: rawStructure.categories,
	          deleteCategory: this.deleteCategory
	        }),
	        _react2.default.createElement("div", { className: "img-shade" })
	      );
	    }
	  }]);
	
	  return Home;
	}(_react.Component);
	
	exports.default = (0, _reactRedux.connect)(function (state) {
	  return {
	    categories: state.home.categories,
	    foldLinks: state.home.foldLinks,
	    systemMessage: state.home.systemMessage,
	    loggedInAsAdmin: state.auth.loggedIn && (state.auth.USER_GROUP === "ADMIN" || state.auth.USER_GROUP === "ADMIN_WEB"),
	    rawStructure: state.home.rawStructure
	  };
	}, {
	  getHomeStructure: _HomeActions.getHomeStructure,
	  updateAndPushCategories: _HomeActions.updateAndPushCategories,
	  getSystemMessage: _HomeActions.getSystemMessage,
	  updateAndPushSystemMessage: _HomeActions.updateAndPushSystemMessage,
	  updateAndPushFoldLinks: _HomeActions.updateAndPushFoldLinks,
	  getAndSetCartQuantity: _actions.getAndSetCartQuantity
	})(Home);
	
	var SystemMessage = function (_Component2) {
	  _inherits(SystemMessage, _Component2);
	
	  function SystemMessage() {
	    var _ref3;
	
	    var _temp2, _this2, _ret2;
	
	    _classCallCheck(this, SystemMessage);
	
	    for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
	      args[_key2] = arguments[_key2];
	    }
	
	    return _ret2 = (_temp2 = (_this2 = _possibleConstructorReturn(this, (_ref3 = SystemMessage.__proto__ || Object.getPrototypeOf(SystemMessage)).call.apply(_ref3, [this].concat(args))), _this2), _this2.state = {
	      messageModalOpen: false,
	      editText: ""
	    }, _this2.toggleEditModal = function () {
	      _this2.setState(function (state) {
	        return {
	          messageModalOpen: !state.messageModalOpen,
	          editText: _this2.props.message || ""
	        };
	      }, function () {
	        if (_this2.state.messageModalOpen && _this2.editor) _this2.editor.focus();
	      });
	    }, _this2.setEditText = function (e) {
	      _this2.setState({ editText: e.target.value });
	    }, _this2.setSystemMessage = function () {
	      _this2.props.onChange(_this2.state.editText);
	    }, _this2.handleKeyDown = function (e) {
	      if (e.keyCode === 13 || e.keyCode === 32) {
	        if (_this2.props.allowEdit) {
	          _this2.toggleEditModal();
	        }
	      }
	    }, _temp2), _possibleConstructorReturn(_this2, _ret2);
	  }
	
	  _createClass(SystemMessage, [{
	    key: "render",
	    value: function render() {
	      var _this3 = this;
	
	      var _props2 = this.props,
	          message = _props2.message,
	          allowEdit = _props2.allowEdit;
	
	      return _react2.default.createElement(
	        "div",
	        { className: "home-message-wrapper", tabIndex: "-1" },
	        message && message !== "" ? _react2.default.createElement(
	          "div",
	          {
	            role: allowEdit ? "button" : "",
	            tabIndex: allowEdit ? "0" : "", onKeyDown: this.handleKeyDown,
	            className: "message " + (allowEdit ? "editable" : ""),
	            onClick: allowEdit ? this.toggleEditModal : undefined
	          },
	          _react2.default.createElement(
	            "div",
	            { className: "icon-wrapper" },
	            _react2.default.createElement(
	              "span",
	              { className: "info-icon", "aria-hidden": "true" },
	              "i"
	            ),
	            allowEdit && _react2.default.createElement(_pencil2.default, { className: "edit-icon" })
	          ),
	          _react2.default.createElement(_Markdown2.default, {
	            source: message,
	            className: "markdown text"
	          }),
	          this.props.allowEdit && _react2.default.createElement(
	            "span",
	            { className: "visually-hidden" },
	            " Click to edit this message."
	          )
	        ) : allowEdit && _react2.default.createElement(
	          "button",
	          {
	            className: "message-placeholder",
	            onClick: this.toggleEditModal
	          },
	          "Add a system message"
	        ),
	        allowEdit && _react2.default.createElement(
	          _Portal2.default,
	          { isOpened: this.state.messageModalOpen },
	          _react2.default.createElement(
	            _Modal.Modal,
	            {
	              title: "Edit System Message",
	              modalSize: "large",
	              saveAndCloseButton: true,
	              cancelButton: true,
	              save: this.setSystemMessage,
	              closeModal: this.toggleEditModal
	            },
	            _react2.default.createElement(
	              "div",
	              { className: "text-editor-wrapper" },
	              _react2.default.createElement(
	                "div",
	                { className: "left-wrapper" },
	                _react2.default.createElement("textarea", {
	                  className: "text-editor",
	                  value: this.state.editText,
	                  onChange: this.setEditText,
	                  placeholder: "System maintenance is scheduled for...",
	                  ref: function ref(_ref4) {
	                    _this3.editor = _ref4;
	                  }
	                }),
	                _react2.default.createElement(_TextEditor.MarkdownHint, null)
	              ),
	              _react2.default.createElement(
	                "div",
	                { className: "right-wrapper preview-message" },
	                _react2.default.createElement("div", { className: "shade" }),
	                _react2.default.createElement(
	                  "div",
	                  { className: "message" },
	                  _react2.default.createElement(
	                    "div",
	                    { className: "icon-wrapper" },
	                    _react2.default.createElement(
	                      "span",
	                      { className: "info-icon" },
	                      "i"
	                    )
	                  ),
	                  _react2.default.createElement(
	                    "span",
	                    { className: "text" },
	                    _react2.default.createElement(_Markdown2.default, {
	                      source: this.state.editText,
	                      className: "markdown"
	                    })
	                  )
	                ),
	                _react2.default.createElement("div", { className: "img-shade" })
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return SystemMessage;
	}(_react.Component);
	
	var FoldLinks = function (_React$Component) {
	  _inherits(FoldLinks, _React$Component);
	
	  function FoldLinks() {
	    var _ref5;
	
	    var _temp3, _this4, _ret3;
	
	    _classCallCheck(this, FoldLinks);
	
	    for (var _len3 = arguments.length, args = Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
	      args[_key3] = arguments[_key3];
	    }
	
	    return _ret3 = (_temp3 = (_this4 = _possibleConstructorReturn(this, (_ref5 = FoldLinks.__proto__ || Object.getPrototypeOf(FoldLinks)).call.apply(_ref5, [this].concat(args))), _this4), _this4.state = {
	      modalOpen: false
	    }, _this4.openEditModal = function () {
	      _this4.setState({
	        modalOpen: true
	      });
	    }, _this4.closeEditModal = function () {
	      _this4.setState({
	        modalOpen: false
	      });
	    }, _this4.saveLinks = function () {
	      _this4.props.onChange(_this4.linkEditor.getLinks());
	    }, _temp3), _possibleConstructorReturn(_this4, _ret3);
	  }
	
	  _createClass(FoldLinks, [{
	    key: "render",
	    value: function render() {
	      var _this5 = this;
	
	      var _props3 = this.props,
	          _props3$links = _props3.links,
	          links = _props3$links === undefined ? [] : _props3$links,
	          allowEdit = _props3.allowEdit;
	
	      return _react2.default.createElement(
	        "div",
	        { className: "atf-links" },
	        links.map(function (link, i) {
	          return _react2.default.createElement(
	            FoldLink,
	            Object.assign({}, link, { key: i }),
	            link.label
	          );
	        }),
	        allowEdit && _react2.default.createElement(
	          "div",
	          { className: "link-wrapper" },
	          _react2.default.createElement(
	            "button",
	            { className: "", onClick: this.openEditModal, "aria-label": "Edit Links" },
	            _react2.default.createElement(_pencil2.default, null)
	          )
	        ),
	        allowEdit && _react2.default.createElement(
	          _Portal2.default,
	          { isOpened: this.state.modalOpen },
	          _react2.default.createElement(
	            _Modal.Modal,
	            {
	              title: "Edit Quick Links",
	              modalSize: "large",
	              saveAndCloseButton: true,
	              cancelButton: true,
	              save: this.saveLinks,
	              closeModal: this.closeEditModal,
	              bodyColor: "light-neutral"
	            },
	            _react2.default.createElement(_QuickLinksEditor2.default, { links: links, ref: function ref(r) {
	                _this5.linkEditor = r;
	              } })
	          )
	        )
	      );
	    }
	  }]);
	
	  return FoldLinks;
	}(_react2.default.Component);
	
	var FoldLink = function (_React$Component2) {
	  _inherits(FoldLink, _React$Component2);
	
	  function FoldLink() {
	    _classCallCheck(this, FoldLink);
	
	    return _possibleConstructorReturn(this, (FoldLink.__proto__ || Object.getPrototypeOf(FoldLink)).apply(this, arguments));
	  }
	
	  _createClass(FoldLink, [{
	    key: "render",
	    value: function render() {
	      var _props4 = this.props,
	          children = _props4.children,
	          _props4$href = _props4.href,
	          href = _props4$href === undefined ? "" : _props4$href,
	          _props4$themeColor = _props4.themeColor,
	          themeColor = _props4$themeColor === undefined ? '' : _props4$themeColor,
	          targetBlank = _props4.targetBlank;
	
	      return _react2.default.createElement(
	        "div",
	        { className: "link-wrapper " + themeColor },
	        href.startsWith("http") || href.startsWith("www") || href.endsWith(".com") || href.endsWith(".gov") ? _react2.default.createElement(
	          "a",
	          { href: href, target: targetBlank ? "blank" : undefined },
	          children
	        ) : _react2.default.createElement(
	          _reactRouterDom.Link,
	          { to: href, target: targetBlank ? "blank" : undefined },
	          children
	        )
	      );
	    }
	  }]);
	
	  return FoldLink;
	}(_react2.default.Component);
	
	var CategoryCards = function (_React$Component3) {
	  _inherits(CategoryCards, _React$Component3);
	
	  function CategoryCards() {
	    _classCallCheck(this, CategoryCards);
	
	    return _possibleConstructorReturn(this, (CategoryCards.__proto__ || Object.getPrototypeOf(CategoryCards)).apply(this, arguments));
	  }
	
	  _createClass(CategoryCards, [{
	    key: "render",
	    value: function render() {
	      var _props5 = this.props,
	          categories = _props5.categories,
	          updateCategoryByIndex = _props5.updateCategoryByIndex,
	          loggedInAsAdmin = _props5.loggedInAsAdmin,
	          rawCategories = _props5.rawCategories,
	          addCategory = _props5.addCategory,
	          deleteCategory = _props5.deleteCategory;
	
	      var filteredCategories = categories.filter(function (c) {
	        return !c.disabled || loggedInAsAdmin;
	      });
	      var filteredRawCategories = rawCategories.filter(function (c) {
	        return !c.disabled || loggedInAsAdmin;
	      });
	      return _react2.default.createElement(
	        "div",
	        { className: "home-category-cards" },
	        filteredCategories.map(function (category, i) {
	          return _react2.default.createElement(ExpandableCategoryCard, Object.assign({}, category, {
	            updateCategoryByIndex: updateCategoryByIndex,
	            index: i,
	            key: category.id,
	            rawCategory: filteredRawCategories[i],
	            deleteCategory: deleteCategory
	          }));
	        }),
	        loggedInAsAdmin ? _react2.default.createElement(_AddCategoryCard2.default, { onCategoryAdded: addCategory }) : null
	      );
	    }
	  }]);
	
	  return CategoryCards;
	}(_react2.default.Component);
	
	CategoryCards = (0, _reactRedux.connect)(function (state) {
	  return {
	    loggedInAsAdmin: state.auth.loggedIn && (state.auth.USER_GROUP === "ADMIN" || state.auth.USER_GROUP === "ADMIN_WEB")
	  };
	})(CategoryCards);
	
	var ExpandableCategoryCard = function (_React$Component4) {
	  _inherits(ExpandableCategoryCard, _React$Component4);
	
	  function ExpandableCategoryCard() {
	    _classCallCheck(this, ExpandableCategoryCard);
	
	    return _possibleConstructorReturn(this, (ExpandableCategoryCard.__proto__ || Object.getPrototypeOf(ExpandableCategoryCard)).apply(this, arguments));
	  }
	
	  _createClass(ExpandableCategoryCard, [{
	    key: "render",
	    value: function render() {
	      var _props6 = this.props,
	          title = _props6.title,
	          description = _props6.description,
	          _props6$links = _props6.links,
	          links = _props6$links === undefined ? [] : _props6$links,
	          icon = _props6.icon,
	          disabled = _props6.disabled,
	          id = _props6.id,
	          index = _props6.index,
	          updateCategoryByIndex = _props6.updateCategoryByIndex,
	          isMobile = _props6.isMobile,
	          rawCategory = _props6.rawCategory,
	          deleteCategory = _props6.deleteCategory;
	
	      return isMobile ? _react2.default.createElement(CategoryCard, {
	        className: "home-category-card-wrapper",
	        title: title,
	        description: description,
	        links: links,
	        disabled: disabled,
	        icon: icon,
	        index: index,
	        updateCategoryByIndex: updateCategoryByIndex,
	        id: id,
	        allowEdit: true,
	        rawCategory: rawCategory,
	        deleteCategory: deleteCategory
	      }) : _react2.default.createElement(_ExpandableCard2.default, {
	        className: "home-category-card-wrapper",
	        cardClassName: "expandable-home-card",
	        collapsedChildren: function collapsedChildren(_ref6) {
	          var innerRef = _ref6.innerRef,
	              expand = _ref6.expand;
	          return _react2.default.createElement(
	            CategoryCard,
	            {
	              wrapperRef: innerRef,
	              title: title,
	              description: description,
	              links: links,
	              disabled: disabled,
	              icon: icon,
	              maxLinks: 8,
	              index: index,
	              updateCategoryByIndex: updateCategoryByIndex,
	              id: id,
	              allowEdit: true,
	              rawCategory: rawCategory,
	              deleteCategory: deleteCategory
	            },
	            links.length > 8 && _react2.default.createElement(
	              "button",
	              { onClick: expand, className: "expand-button", "aria-label": "View more links" },
	              _react2.default.createElement(_caretDown2.default, null)
	            )
	          );
	        },
	        expandedChildren: function expandedChildren(_ref7) {
	          var collapse = _ref7.collapse;
	          return _react2.default.createElement(
	            CategoryCard,
	            { title: title, description: description, links: links, disabled: disabled, icon: icon, id: id },
	            _react2.default.createElement(
	              "button",
	              { onClick: collapse, className: "expand-button", "aria-label": "View less links" },
	              _react2.default.createElement(_caretUp2.default, null)
	            )
	          );
	        }
	      });
	    }
	  }]);
	
	  return ExpandableCategoryCard;
	}(_react2.default.Component);
	
	ExpandableCategoryCard = (0, _reactRedux.connect)(function (state) {
	  return {
	    isMobile: state.app.isMobile
	  };
	})(ExpandableCategoryCard);
	
	var CategoryCard = function (_React$Component5) {
	  _inherits(CategoryCard, _React$Component5);
	
	  function CategoryCard() {
	    var _ref8;
	
	    var _temp4, _this9, _ret4;
	
	    _classCallCheck(this, CategoryCard);
	
	    for (var _len4 = arguments.length, args = Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
	      args[_key4] = arguments[_key4];
	    }
	
	    return _ret4 = (_temp4 = (_this9 = _possibleConstructorReturn(this, (_ref8 = CategoryCard.__proto__ || Object.getPrototypeOf(CategoryCard)).call.apply(_ref8, [this].concat(args))), _this9), _this9.state = {
	      editModalOpen: false
	    }, _this9.toggleEditModal = function () {
	      _this9.setState(function (state) {
	        return { editModalOpen: !state.editModalOpen };
	      });
	    }, _this9.getEditedCategoryFromModal = function () {
	      var category = _this9.editModal.getValues();
	      _this9.props.updateCategoryByIndex({ index: _this9.props.index, category: category });
	    }, _this9.handleKeyDown = function (e) {
	      if (e.keyCode === 13 || e.keyCode === 32) {
	        if (_this9.props.loggedInAsAdmin && _this9.props.allowEdit) {
	          _this9.toggleEditModal();
	        }
	      }
	    }, _temp4), _possibleConstructorReturn(_this9, _ret4);
	  }
	
	  _createClass(CategoryCard, [{
	    key: "render",
	    value: function render() {
	      var _this10 = this;
	
	      var _props7 = this.props,
	          wrapperRef = _props7.wrapperRef,
	          title = _props7.title,
	          description = _props7.description,
	          links = _props7.links,
	          icon = _props7.icon,
	          disabled = _props7.disabled,
	          id = _props7.id,
	          children = _props7.children,
	          maxLinks = _props7.maxLinks,
	          loggedInAsAdmin = _props7.loggedInAsAdmin,
	          allowEdit = _props7.allowEdit,
	          rawCategory = _props7.rawCategory,
	          _props7$className = _props7.className,
	          className = _props7$className === undefined ? '' : _props7$className,
	          index = _props7.index,
	          deleteCategory = _props7.deleteCategory;
	
	
	      return _react2.default.createElement(
	        "div",
	        { ref: wrapperRef, className: "full-height " + className },
	        _react2.default.createElement(
	          "div",
	          { className: "home-category-card " + (disabled ? 'disabled' : '') },
	          _react2.default.createElement(
	            "div",
	            { tabIndex: "-1" },
	            _react2.default.createElement(
	              "div",
	              { tabIndex: loggedInAsAdmin && allowEdit ? "0" : "", className: "link-wrapper", onKeyDown: this.handleKeyDown },
	              _react2.default.createElement(
	                "h2",
	                {
	                  role: allowEdit && loggedInAsAdmin ? "button" : "",
	                  onClick: loggedInAsAdmin && allowEdit ? this.toggleEditModal : undefined,
	                  className: "" + (loggedInAsAdmin && allowEdit ? "admin" : "")
	                },
	                _react2.default.createElement(
	                  "div",
	                  { className: "icon-wrapper" },
	                  _Icons2.default[icon],
	                  loggedInAsAdmin && allowEdit && _react2.default.createElement(_pencil2.default, { className: "edit-icon" })
	                ),
	                title,
	                this.props.allowEdit && loggedInAsAdmin && _react2.default.createElement(
	                  "span",
	                  { className: "visually-hidden" },
	                  " Click to edit this category."
	                )
	              )
	            )
	          ),
	          description ? _react2.default.createElement(_Markdown2.default, { className: "markdown description", source: description }) : null,
	          _react2.default.createElement(
	            "div",
	            { className: "links" },
	            links.map(function (link, i) {
	              return link.type === "separator" ?  false ? _react2.default.createElement(Separator, { categoryId: id, key: i }) : null : (!maxLinks || maxLinks > i) && link.label && (link.href[0] !== '/' ? _react2.default.createElement(
	                "a",
	                { href: link.href, target: link.targetBlank ? "_blank" : undefined, key: i },
	                link.label
	              ) : _react2.default.createElement(
	                _reactRouterDom.Link,
	                {
	                  to: link.href,
	                  target: link.targetBlank ? "_blank" : undefined,
	                  key: i
	                },
	                link.label
	              ));
	            })
	          ),
	          children
	        ),
	        loggedInAsAdmin && allowEdit && _react2.default.createElement(
	          _Portal2.default,
	          { isOpened: this.state.editModalOpen },
	          _react2.default.createElement(
	            _Modal.Modal,
	            {
	              title: "Edit Category",
	              modalSize: "large",
	              saveAndCloseButton: true,
	              cancelButton: true,
	              save: this.getEditedCategoryFromModal,
	              closeModal: this.toggleEditModal
	            },
	            _react2.default.createElement(EditCategoryModal, {
	              ref: function ref(_ref9) {
	                _this10.editModal = _ref9;
	              },
	              id: id,
	              title: rawCategory.title,
	              description: rawCategory.description,
	              links: rawCategory.links,
	              icon: rawCategory.icon,
	              disabled: disabled,
	              deletable: true,
	              onRequestDelete: function onRequestDelete() {
	                return deleteCategory(index);
	              }
	            })
	          )
	        )
	      );
	    }
	  }]);
	
	  return CategoryCard;
	}(_react2.default.Component);
	
	CategoryCard = (0, _reactRedux.connect)(function (state) {
	  return {
	    loggedInAsAdmin: state.auth.loggedIn && (state.auth.USER_GROUP === "ADMIN" || state.auth.USER_GROUP === "ADMIN_WEB")
	  };
	})(CategoryCard);
	
	var Separator = function Separator(_ref10) {
	  var categoryId = _ref10.categoryId;
	  return _react2.default.createElement(
	    "div",
	    { className: "home-separator-wrapper" },
	    _react2.default.createElement("hr", null),
	    _react2.default.createElement(_reactTooltip2.default, { effect: "solid", place: "top", id: "auth-hint-" + categoryId }),
	    _react2.default.createElement("span", {
	      className: "icon icon-lock auth-hint",
	      "data-tip": ({"NODE_ENV":"production","BUILD_DATE":"2025-08-27T15:15:31.687Z","BUILD_NUMBER":"Not Provided","GIT_VERSION":"v1.3.0-381-ga81e29b08","GIT_COMMIT_HASH":"a81e29b085c9268ffd96c78eb734365802722741","GIT_BRANCH":"beta","PUBLIC_URL":"","STATE_ABBR":"MT","STATE_NAME":"Montana","STATE_ORG_TITLE":"Secretary of State","LOGIN_HEADER_IMG_PATH":"","HOME_IMG_FILENAME":"montana.jpg","FAVICON_FILE_NAME":"favicon.ico","ALLOW_E_SIGN_ON_CORRECTIONS":true,"THIRD_PARTY_SIGNING_ALLOWED":false,"MY_ACCOUNT_SAVE_AND_CLOSE_BUTTON":true,"IE_DEPRECATED_MESSAGE":"Internet Explorer is not supported. Please select a supported browser below to access this website.","ADDITIONAL_ROUTES":{"dataRequests":true,"farmBill":true,"apostille":true,"externalHelp":"https://sosmt.gov/business/help-center/","systemAdministration":[{"title":"Saved Payments","parameter":"saved-payments","componentName":"SavedPayments"}]},"SUBROUTES":[{"label":"Business","component":"Business","parameter":"business","myWorkQueueSearch":false,"sourceTypeId":54,"searchMustHaveOneOf":["FILING_TYPE_ID","STATUS_ID","STATE","search"],"serverWebSearchDescription":true,"serverWorkQueueDescription":true,"serverMyRecordsDescription":true,"searchPlaceholder":"Search by name or filing number (X########)","allowEmptySearchTerm":true,"requestCertificateAlternateLabel":"Request Information","fileAmendmentButtonLabel":"Filing Actions","advancedSearchParameters":[{"type":"radio","name":"QUERY_TYPE_ID","defaultValue":1010,"options":[{"value":1010,"label":"Starts with"},{"value":1011,"label":"Contains"},{"value":1012,"label":" Word Contains"}]},{"type":"serverSelect","name":"FILING_TYPE_ID","optionsSrc":"FILING_TYPES","label":"Entity Type","placeholder":"All","defaultValue":"0"},{"type":"serverSelect","name":"FILING_SUBTYPE_ID","optionsSrc":"FILING_SUBTYPES","label":"Entity Subtype","overrideSubOptionsSrcFromParameterName":"FILING_TYPE_ID","placeholder":"All","defaultValue":"0"},{"type":"serverSelect","name":"STATUS_ID","optionsSrc":"FILING_STATUS_WITHOUT_ALL","label":"Status","placeholder":"All","defaultValue":"0"},{"type":"serverSelect","name":"STATE","optionsSrc":"STATE","label":"State","placeholder":"All","defaultValue":""},{"type":"serverSelect","name":"COUNTY","optionsSrc":"COUNTY_SUBOPTION","label":"County","overrideSubOptionsSrcFromParameterName":"STATE","placeholder":"All","defaultValue":""},{"type":"checkbox","name":"CRA_SEARCH_YN","defaultValue":false,"label":"Search by Registered Agent PID"},{"type":"dateRange","name":"FILING_DATE","label":"Registration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}},{"type":"dateRange","name":"EXPIRATION_DATE","label":"Expiration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}}],"myRecordsFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Active"},{"value":2,"label":"Inactive"},{"value":3,"label":"Pending"}]},{"type":"dateRange","name":"DATE_RANGE","label":"Date range","defaultValue":{"start":null,"end":null}}],"myWorkQueueFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Approved"},{"value":2,"label":"Pending Online Payment"},{"value":3,"label":"Pending Review"},{"value":4,"label":"Needs Correction"},{"value":5,"label":"Rejected"},{"value":6,"label":"Draft"}]},{"type":"dateRange","name":"DATE_RANGE","label":"Date range","defaultValue":{"start":null,"end":null}}]},{"label":"Notary","component":"Notary","parameter":"notary","sourceTypeId":850,"myWorkQueueSearch":false,"allowEmptySearchTerm":true,"requestCertificateAlternateLabel":"Download Certificate","fileAmendmentButtonLabel":"Filing Actions","hideNameRequestCertificate":true,"hideAddressRequestCertificate":true,"hideRecordUserManagment":true,"searchPlaceholder":"Search by name or commission number","searchMustHaveOneOf":["CITY","search","SERVICE_TYPE"],"advancedParametersStartOpen":true,"searchIsSortable":true,"advancedSearchParameters":[{"type":"radio","name":"STARTS_WITH_YN","defaultValue":false,"options":[{"value":true,"label":"Starts with"},{"value":false,"label":"Contains"}]},{"type":"checkbox","name":"ACTIVE_ONLY_YN","defaultValue":true,"label":"Active entities only"},{"type":"text","name":"CITY","defaultValue":"","label":"City"},{"type":"select","name":"SERVICE_TYPE","label":"Special Services Offered","defaultValue":0,"options":[{"value":0,"label":"(N/A)"},{"value":6165,"label":"In-Person Electronic Notarization (IPEN)"},{"value":6166,"label":"Remote Online Notarization (RON)"},{"value":6167,"label":"Mobile Notary Services"},{"value":6168,"label":"Remote Ink Notarization (RIN)"}]}]},{"label":"Apostille","component":"Apostille","parameter":"apostille","sourceTypeId":720,"myRecordsSearch":false,"myWorkQueueSearch":false,"disabled":false,"allowedRoutes":["/forms-manager/","/queue/","/forms/"]},{"label":"Liens","component":"UCC","parameter":"ucc","sourceTypeId":1999,"myRecordsSearch":true,"myWorkQueueSearch":true,"fileAmendmentButtonLabel":"Filing Actions","searchPlaceholder":"Search by name or file number","disabled":false,"serverWebSearchDescription":true,"myRecordsDescription":"","workQueueDescription":"","searchDescription":"","hideRecordUserManagment":true,"searchLiensCheckout":false,"advancedSearchParameters":[{"type":"radio","name":"STARTS_WITH_YN","defaultValue":false,"options":[{"value":true,"label":"Starts with"},{"value":false,"label":"Contains"}]},{"type":"select","name":"STATUS","defaultValue":"ALL","label":"Status","options":[{"value":"ACTIVE_UNLAPSED","label":"Active (unlapsed)"},{"value":"ACTIVE_LAPSED_UNLAPSED","label":"Active (lapsed and unlapsed)"}]},{"type":"text","name":"EXCLUDE_VALUES","label":"Exclude Debtor Names (comma separated list of names to exclude)","defaultValue":""},{"type":"dateRange","name":"FILING_DATE","label":"Financing Statement Date","defaultValue":{"start":null,"end":null}},{"type":"dateRange","name":"LAPSE_DATE","label":"Lapse Date","defaultValue":{"start":null,"end":null}},{"type":"text","name":"CITY","label":"Debtor City","defaultValue":""}],"myRecordsFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Approved"},{"value":2,"label":"Pending Online Payment"},{"value":3,"label":"Pending Review"}]},{"type":"select","name":"TYPE","defaultValue":0,"label":"Lien Type","options":[{"value":0,"label":"All"},{"value":1,"label":"UCC"},{"value":2,"label":"EFS"},{"value":3,"label":"Title 71"}]}],"myWorkQueueFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Approved"},{"value":2,"label":"Pending Online Payment"},{"value":3,"label":"Pending Review"},{"value":4,"label":"Pending Print and Mail"},{"value":5,"label":"Rejected"},{"value":6,"label":"Draft"}]},{"type":"select","name":"TYPE","defaultValue":0,"label":"Lien Type","options":[{"value":0,"label":"All"},{"value":1,"label":"UCC"},{"value":2,"label":"EFS"},{"value":3,"label":"Title 71"}]}]},{"label":"Copy Request","component":"copies","parameter":"copies","sourceTypeId":2001,"myRecordsSearch":false,"myWorkQueueSearch":false,"disabled":false,"allowedRoutes":["/forms-manager/","/queue/","/forms/"]},{"label":"Trademark","component":"Trademark","parameter":"trademark","sourceTypeId":810,"showRequestCertificate":true,"searchMustHaveOneOf":["search","EXPIRATION_DATE","FILING_DATE"],"allowEmptySearchTerm":true,"requestCertificateAlternateLabel":"Request Information","fileAmendmentButtonLabel":"Filing Actions","advancedSearchParameters":[{"type":"radio","name":"QUERY_TYPE_ID","defaultValue":1010,"options":[{"value":1010,"label":"Starts with"},{"value":1011,"label":"Contains"},{"value":1012,"label":" Word Contains"}]},{"type":"checkbox","name":"OWNER_SEARCH_YN","defaultValue":false,"label":"Search owners"},{"type":"radio","name":"SERVICE_MARK_YN","label":"Mark Type","defaultValue":"","options":[{"value":"","label":"All Marks"},{"value":"Y","label":"Service Mark"},{"value":"N","label":"Trademark"}]},{"type":"serverSelect","name":"STATUS_ID","optionsSrc":"TYPE_V|TRADEMARK_STATUS_TYPE","label":"Status","placeholder":"All","defaultValue":"0"},{"type":"select","name":"DESIGN_TYPE_ID","options":[{"value":0,"label":"All"},{"value":990,"label":"Words Only"},{"value":991,"label":"Design Only"},{"value":992,"label":"Words and Design"}],"label":"Design Type","defaultValue":"0"},{"type":"dateRange","name":"FILING_DATE","label":"Registered Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}},{"type":"dateRange","name":"EXPIRATION_DATE","label":"Expiration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}}]},{"label":"Business Info Request","component":"InfoRequests","parameter":"info-request","sourceTypeId":167,"allowedRoutes":["/forms-manager/","/queue/","/forms/"]},{"label":"Data Requests","component":"DataRequests","parameter":"data-request","sourceTypeId":0,"allowedRoutes":["/forms-manager/"]},{"label":"CRA","component":"CRA","parameter":"cra","sourceTypeId":157,"myRecordsSearch":false,"searchPlaceholder":"Search by name or registered agent number","allowedRoutes":["/forms-manager/","/forms/","/records/","/queue/","/search/"],"allowEmptySearchTerm":true,"fileAmendmentButtonLabel":"Filing Actions","advancedSearchParameters":[{"type":"radio","name":"QUERY_TYPE_ID","defaultValue":1010,"options":[{"value":1010,"label":"Starts with"},{"value":1011,"label":"Contains"},{"value":1012,"label":" Word Contains"}]},{"type":"dateRange","name":"CRA_DATE","label":"Registration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}},{"type":"select","name":"STATUS_ID","label":"Status","defaultValue":0,"options":[{"value":0,"label":"All"},{"value":121,"label":"Active"},{"value":122,"label":"Inactive"}]},{"type":"select","name":"AGENT_TYPE_ID","label":"Agent Type","defaultValue":0,"options":[{"value":0,"label":"All"},{"value":460,"label":"Registered Agent"},{"value":461,"label":"Commercial Registered Agent"}]}]},{"label":"Farm Bill","component":"FarmBill","parameter":"farm-bill","path":"/lists/farm-bill","sourceTypeId":0,"myRecordsSearch":false,"allowedRules":["/search/"],"disabled":true,"searchDescription":"To perform a search, enter a debtor name. Your search results may include: exact debtor name, variations of that name and any filing that includes your search criteria. Punctuation is ignored.\n\nYou can click on \"Advanced\" to refine your search. Under “Advanced” you can search by crop, year, county and SSN/FEIN. As a registered Farm Bill Buyer with the Montana Secretary of State’s office it is important to maintain the confidentiality of the information contained within the Farm Bill Master List. The Farm Bill Master List reflects personal data, such as Social Security Numbers, which are a key piece of personal identifiable information to assist you in determining the existence of a lien against a specific debtor. The distribution of this information beyond its intended purpose is strictly prohibited.\n\nThe debtor's tax identification number has been hidden for confidentiality reasons. You may continue to search on a tax ID number and return debtors that match your search criteria. The SSN/FEIN must be entered without dashes or spaces.","searchMustHaveOneOf":["search","UCC_FARM_PRODUCT_ID","COUNTY"],"searchPlaceholder":"Search by debtor name","advancedSearchParameters":[{"type":"ServerMultiComplete","label":"Product code name(s)","name":"UCC_FARM_PRODUCT_ID","defaultValue":"","optionsSrc":"UCC_FARM_PRODUCT_V"},{"type":"MultiComplete","label":"Year or Range of Years","name":"YEAR_NUM","optionsSrc":"years","startYear":"1968","defaultValue":[],"preMergeOptions":[{"value":"ALL","label":"All"}]},{"type":"serverSelect","label":"State","name":"STATE","defaultValue":"MONTANA","optionsSrc":"STATE"},{"type":"ServerMultiComplete","label":"County","name":"COUNTY","defaultValue":[],"optionsSrc":"COUNTY","overrideSubOptionsSrcFromParameterName":"STATE"},{"type":"checkbox","name":"TIN_SEARCH_YN","defaultValue":false,"label":"Tax Identification Number Search"},{"type":"checkbox","name":"TIN_SORT_YN","defaultValue":false,"label":"Unique ID Sort"}]}],"SYSTEM_NICKNAME":"Online Services Portal","PAYMENT_METHODS":[{"type":"bypass"},{"type":"iTransact"}],"PAYMENT_ALLOW_AMEX":true,"SYSTEM_ID_LABEL":"System Id","DOUBLE_COLUMN_PUBLIC_LOGIN":true,"INTERNAL_USER_MANAGEMENT":true,"ALLOW_PUBLIC_JSON_IMPORT":false,"MAX_FILE_UPLOAD_SIZE":10000000,"REFUND_TEXT":"","RETURN_TO_HOME_ON_LOGOUT":true,"CURRENT_SOS_NAME":"Christi Jacobsen","LOGO_FILENAME":"mt-sos-logo.png","LOGO_ALT":"Christi Jacobsen, Montana Secretary of State","LOGO_FULL_WIDTH":true,"HOME_HIDE_AUTH_HINT":true,"HOME_TITLE":"Montana Secretary of State","CUSTOM_TAB_TITLE":"Official Montana","HOME_SUBTITLE":"Online Business Services","ENTITY_NAME_CONSENT_DESCRIPTION":"","ALLOW_USER_PROFILE_EDITING":true,"COMPARE_FOREIGN_NAME_IN_ENTITY_NAME_VALIDATION":true,"FOREIGN_NAME_FIELD_NAME":"KIMA_PARENT_NAME_INFO","LOGIN_TITLE":"Montana Secretary of State Online Filing Portal Login","PUBLIC_LOGIN_LABEL":"Username","REVERSE_LOGIN_COLUMNS":true,"LOGIN_SEAL_FILENAME":"seal_white.png","SEPARATE_USERNAME_AND_EMAIL":true,"CREATE_ACCOUNT_BUTTON_ALIGN_LEFT":true,"CREATE_ACCOUNT_BUTTON_TEXT":"CREATE AN ACCOUNT","PASSWORD_CUSTOM_ERROR_TEXT":"The password must meet all requirements","ACCOUNT_CREATED_MESSAGE":"Please check your email to verify your account to login and allow a few minutes for this message to arrive. Check your junk/spam folders if you do not find the email in your inbox.","PUBLIC_LOGIN_PLACEHOLDER":" ","DISABLE_DEFAULT_PAYMENT_RADIO":true,"CUSTOM_RESET_PASSWORD_ERROR_MESSAGE":"Username invalid - no account found","PUBLIC_LOGIN_CREATE_DESCRIPTION":"### Existing User:\n\n  - Enter your username and password to login.  \n\n\n  #### - OR -  \n\n\n\n  - Forgot password? Click 'Reset Password' and follow the prompts.\n  - Forgot username? Click 'Forgot Username' and follow the prompts.  \n\n\n  ### New User:\n  ","LOGIN_HELP_LINK":"https://sosmt.gov/business/how-do-i/","LOGIN_HELP_LINK_TEXT":"Need Help?","FORGOT_USERNAME_TEXT":"Forgot Username?","LOGIN_ACTIVE_DIRECTORY_TEXT":"State User Login","MULTIPLE_LOGIN_METHODS":true,"HAS_ACTIVE_DIRECTORY_LOGIN":true,"RESET_PASSWORD_WITH_USERNAME":true,"DOWNLOAD_LINK":true,"SHOW_USERNAME_ACCOUNT_CREATE":true,"SHOW_SCROLL_DOWN_ARROW":true,"SHOW_ADDRESS_ACCOUNT_CREATE":true,"TWO_COLUMN_ACCOUNT_CREATE":true,"RESET_PASSWORD_TIP":"A link to change your password has been sent to your email. Please allow a few minutes for this message to arrive. Please check your junk/spam folders if you do not find the email in your inbox.","FORGOT_PASSWORD_LINK_TEXT":"Reset Password","PHONE_NUMBER_OPTIONAL_ACCOUNT_CREATE":true,"SHOW_REQUIRED_INDICATOR_ACCOUNT_CREATE":true,"PASSWORD_REQUIREMENTS_ACCOUNT_CREATE":"\n    <ul>\n      <li>MUST contain at least 8 characters (12+ recommended)</li>\n      <li>MUST contain at least one uppercase letter.</li>\n      <li>MUST contain at least one lowercase letter.</li>\n      <li>MUST contain at least one number.</li>\n      <li>MUST contain at least one special character (!”#$%&'()*+,-./:;<=>?</li>\n    </ul>\n  ","ALLOW_CERTIFICATION_REQUEST":true,"ALLOW_PUBLIC_CERTIFICATE_REQUEST":true,"ALLOW_COPY_REQUEST":false,"ALLOW_CORRECTION_STYLING":true,"HIDE_DEPRECATION_WARNING":false,"AMEND_ROUTE_PUBLIC":true,"SEAL_FILENAME":"seal.png","SHOPPING_CART":true,"ALLOW_PAYMENT_UPDATE_WITH_EMPTY_CART":true,"RA_EMAIL":true,"RA_WEBSITE":true,"RA_NO_DEFAULT_TYPE":true,"RA_ADDRESS_LABEL":"Street Address","RA_TYPE_SELECTION_DEFAULT":true,"RA_DEFAULT_TYPE":"460","RA_OVERRIDE_TYPE_WITH_DEFAULT":true,"RA_PRINCIPAL_ADDRESS_AMS":true,"UPLOAD_AND_SUBMIT_HIDE_IF_ONE_OPTION":true,"PAYMENT_PROCESSING_MESSAGE":"Your payment is processing - Do not close your browser or click the back button","CHECKOUT_BUTTON_WHEN_PROCESSING_TEXT":"Processing","EFS_CROP_PICKER_NONE_LABEL":"Lien Duration","DISALLOWED_WIZARD_PIECES":["FormationLocale"],"REPEATER_SHOW_EDIT_BUTTON":true,"DATA_REQUEST_PAGE_TITLE":"Data Requests and Subscriptions","DATA_REQUEST_SIDEBAR_LABEL":"Data Requests & Subscriptions","LOGIN_REDIRECTS_TO_EPASS":false,"LOGIN_REDIRECTS_TO_ACTIVE_DIRECTORY":true,"LOGIN_ACTIVE_DIRECTORY_LINK":true,"FETCH_EDIT_USER_LINK":false,"LISTS_FETCH_AVAILABLE_LISTS":true,"POST_WIZARD_SUBMIT_REDIRECT_URL":"/","PIN_REQUEST_ATTESTATIONS":true,"PIN_REQUEST_DESCRIPTION":"Click **Request PIN** to have a new PIN sent to the account holder's email address on file.","OWNERSHIP_REQUEST_DESCRIPTION":"To become an **authorized user** of this record, a current **AUTHORIZED USER** will need to grant you access. To request access, click **Request Access** below.","PIN_REQUEST_SUCCESS_MESSAGE":"The PIN you have requested for this entity has been sent to the email associated with your user account.  You should receive the PIN in approximately 3-5 minutes, depending on your email service provider.","APOSTILLE_HEADER_LABEL":"Verification Information","APOSTILLE_NUMBER_LABEL":"Apostille/Authentication","APOSTILLE_CITY_STATE_OVERRIDE":"HELENA, MT","APOSTILLE_FILING_DATE_LABEL":"Issue Date","APOSTILLE_CITY_STATE_IN_CERTIFIED":true,"NOTARY_EXISTING_FILING":true,"ALLOW_REVOKE_OWN_ACCESS_ONLY":false,"HIDE_CANCEL_ON_ONETIME_DATA_REQUESTS":true,"DATA_REQUESTS_IN_SHOPPING_CART":true,"WQ_ALLOW_EDIT_PENDING_PAYMENT":true,"WQ_CONFIRM_ON_DELETE":true,"WQ_DELETE_CONFIRM_MESSAGE":"Deleting this filing will forfeit any money already paid to the Secretary of State. This action is permanent and cannot be undone, are you sure you would like to delete?","PASS_ITEM_GUIDS_ON_CHECKOUT":true,"FORM_REVISION_HISTORY":true,"CHECKOUT_DISCLAIMER":"By entering your credit card and/or checking account information you (i) state that **you are an authorized user** of the credit card and/or electronic check and that the associated information entered (e.g., account holder name, account number, billing address) is accurate, (ii) **you authorize payment processor to charge the amount you have requested** to your credit card and/or funding account, and (iii) **acknowledge if a charge is declined or reversed you may also be assessed a customary charge** by the payment processor for such transactions.","FARM_BILL_SEARCH_CONFIDENTIAL":"As a registered Farm Bill Buyer with the Montana Secretary of State’s office it is important to maintain the confidentiality of the information contained within the Farm Bill Master List. The Farm Bill Master List reflects personal data, such as Social Security Numbers, which are a key piece of personal identifiable information to assist you in determining the existence of a lien against a specific debtor. The distribution of this information beyond its intended purpose is strictly prohibited.\n\n**The debtor's tax identification number has been hidden for confidentiality reasons. You may continue to search on a tax ID number and return debtors that match your search criteria. The SSN/FEIN must be entered without dashes or spaces.  If you need access to the tax identification number to clearly identify the debtor, please contact the UCC unit at (406) 444-3665.**","VIEW_HISTORY_BUTTON_ALT_TEXT":"View Filings","WIZARD_ERROR_TITLE_MESSAGE":"Form Error","FARM_BILL_SEARCH_INTERACTIVE":true,"USE_FARM_BILL_API":true,"DISALLOW_ASSIGN_SELF_AS_RA":true,"DISALLOW_ASSIGN_SELF_AS_PRINCIPAL":true,"USE_TRADEMARK_OWNER_VALIDATION":true,"USE_ALTERNATIVE_FOREIGN_ADDRESS_LABELS":true,"MY_RECEIPTS_FILTER":[{"type":"dateRange","name":"DATE_RANGE","label":"Date range","defaultValue":{"start":null,"end":null}},{"type":"text","name":"REF_NUM","defaultValue":"","label":"Reference Number"},{"type":"text","name":"RECEIPT_NUM","defaultValue":"","label":"Receipt Id"},{"type":"text","name":"AMOUNT","defaultValue":"","label":"Amount"},{"type":"select","name":"TYPE","defaultValue":"","label":"Payment Type","options":[{"value":"","label":"All"},{"value":"CC","label":"Credit Card"},{"value":"Check","label":"Check"}]}],"MY_RECEIPTS_SHOW_IN_SIDEBAR":true,"SHOW_MY_RECEIPTS_HELPER_TEXT":true,"MY_RECEIPTS_HELPER_LABEL":"About Receipt Search","MY_RECEIPTS_HELPER_TEXT":"You can search for receipts based on their descriptions, including the items paid for on the receipt. Use the filters to search for or filter specific information.","FARM_BILL_SUBLINK":{"label":"Farm Bill","component":"FarmBill","parameter":"farm-bill","path":"/lists/farm-bill","sourceTypeId":0,"myRecordsSearch":false,"allowedRules":["/search/"],"disabled":true,"searchDescription":"To perform a search, enter a debtor name. Your search results may include: exact debtor name, variations of that name and any filing that includes your search criteria. Punctuation is ignored.\n\nYou can click on \"Advanced\" to refine your search. Under “Advanced” you can search by crop, year, county and SSN/FEIN. As a registered Farm Bill Buyer with the Montana Secretary of State’s office it is important to maintain the confidentiality of the information contained within the Farm Bill Master List. The Farm Bill Master List reflects personal data, such as Social Security Numbers, which are a key piece of personal identifiable information to assist you in determining the existence of a lien against a specific debtor. The distribution of this information beyond its intended purpose is strictly prohibited.\n\nThe debtor's tax identification number has been hidden for confidentiality reasons. You may continue to search on a tax ID number and return debtors that match your search criteria. The SSN/FEIN must be entered without dashes or spaces.","searchMustHaveOneOf":["search","UCC_FARM_PRODUCT_ID","COUNTY"],"searchPlaceholder":"Search by debtor name","advancedSearchParameters":[{"type":"ServerMultiComplete","label":"Product code name(s)","name":"UCC_FARM_PRODUCT_ID","defaultValue":"","optionsSrc":"UCC_FARM_PRODUCT_V"},{"type":"MultiComplete","label":"Year or Range of Years","name":"YEAR_NUM","optionsSrc":"years","startYear":"1968","defaultValue":[],"preMergeOptions":[{"value":"ALL","label":"All"}]},{"type":"serverSelect","label":"State","name":"STATE","defaultValue":"MONTANA","optionsSrc":"STATE"},{"type":"ServerMultiComplete","label":"County","name":"COUNTY","defaultValue":[],"optionsSrc":"COUNTY","overrideSubOptionsSrcFromParameterName":"STATE"},{"type":"checkbox","name":"TIN_SEARCH_YN","defaultValue":false,"label":"Tax Identification Number Search"},{"type":"checkbox","name":"TIN_SORT_YN","defaultValue":false,"label":"Unique ID Sort"}]},"ALLOW_ADDRESS_VALIDATION_BYPASS_OPTION":true,"DEFAULT_ADDRESS_VALIDATION_BYPASS_OPTION_CHECKED":true}).HOME_LOGIN_HINT || "LOGIN REQUIRED",
	      "data-for": "auth-hint-" + categoryId
	    })
	  );
	};
	
	var EditCategoryModal = exports.EditCategoryModal = function (_React$Component6) {
	  _inherits(EditCategoryModal, _React$Component6);
	
	  function EditCategoryModal(props) {
	    _classCallCheck(this, EditCategoryModal);
	
	    var _this11 = _possibleConstructorReturn(this, (EditCategoryModal.__proto__ || Object.getPrototypeOf(EditCategoryModal)).call(this, props));
	
	    _this11.getValues = function () {
	      return {
	        title: _this11.state.title,
	        description: _this11.state.description,
	        links: _this11.state.links,
	        disabled: _this11.state.disabled,
	        icon: _this11.state.icon,
	        id: _this11.props.id
	      };
	    };
	
	    _this11.setRowValueByIndex = function (_ref11) {
	      var name = _ref11.name,
	          value = _ref11.value,
	          index = _ref11.index;
	
	      _this11.setState(function (state) {
	        return {
	          links: [].concat(_toConsumableArray(state.links.slice(0, index)), [Object.assign({}, state.links[index], _defineProperty({}, name, value))], _toConsumableArray(state.links.slice(index + 1)))
	        };
	      });
	    };
	
	    _this11.setTitle = function (value) {
	      _this11.setState({
	        title: value
	      });
	    };
	
	    _this11.setDescription = function (value) {
	      _this11.setState({
	        description: value
	      });
	    };
	
	    _this11.addNewLink = function () {
	      _this11.setState(function (state) {
	        return {
	          links: [].concat(_toConsumableArray(state.links), [{ label: "", href: "", targetBlank: false }]),
	          newIconIndex: state.links.length
	        };
	      });
	    };
	
	    _this11.closeIconMenu = function () {
	      _this11.setState({ iconMenuOpen: false });
	    };
	
	    _this11.openIconMenu = function () {
	      _this11.setState({
	        iconMenuOpen: true,
	        iconMenuAnchor: _this11.iconMenuButton
	      });
	    };
	
	    _this11.setIcon = function (_ref12) {
	      var value = _ref12.value;
	
	      _this11.setState({
	        icon: value
	      });
	    };
	
	    _this11.insertAbove = function (index) {
	      _this11.setState(function (state) {
	        return {
	          links: [].concat(_toConsumableArray(state.links.slice(0, index)), [{ label: "", href: "", targetBlank: false }], _toConsumableArray(state.links.slice(index))),
	          newIconIndex: index
	        };
	      });
	    };
	
	    _this11.insertBelow = function (index) {
	      _this11.setState(function (state) {
	        return {
	          links: [].concat(_toConsumableArray(state.links.slice(0, index + 1)), [{ label: "", href: "", targetBlank: false }], _toConsumableArray(state.links.slice(index + 1))),
	          newIconIndex: index + 1
	        };
	      });
	    };
	
	    _this11.deleteLink = function (index) {
	      _this11.setState(function (state) {
	        return {
	          links: [].concat(_toConsumableArray(state.links.slice(0, index)), _toConsumableArray(state.links.slice(index + 1)))
	        };
	      });
	    };
	
	    _this11.clearNewIcon = function () {
	      _this11.setState({
	        newIconIndex: null
	      });
	    };
	
	    _this11.setDisabled = function (value) {
	      _this11.setState({ disabled: !value });
	    };
	
	    _this11.openDeleteDialog = function () {
	      _this11.setState({
	        deleteDialogOpen: true
	      });
	    };
	
	    _this11.closeDeleteDialog = function () {
	      _this11.setState({
	        deleteDialogOpen: false
	      });
	    };
	
	    _this11.handleKeyDown = function (e) {
	      if (e.keyCode === 13 || e.keyCode === 32) {
	        _this11.openIconMenu();
	      }
	    };
	
	    _this11.state = {
	      title: props.title,
	      description: props.description,
	      links: props.links,
	      icon: props.icon,
	      disabled: props.disabled || false,
	      iconMenuOpen: false,
	      iconMenuAnchor: null,
	      newIconIndex: null,
	      deleteDialogOpen: false
	    };
	    return _this11;
	  }
	
	  _createClass(EditCategoryModal, [{
	    key: "render",
	    value: function render() {
	      var _this12 = this;
	
	      return _react2.default.createElement(
	        "div",
	        { className: "container-fluid wizard home-category-modal" },
	        _react2.default.createElement(
	          "div",
	          { className: "row" },
	          _react2.default.createElement(
	            "div",
	            { className: "col-12 title-row" },
	            _react2.default.createElement(
	              _Field.DumbField,
	              { label: "Icon" },
	              _react2.default.createElement(
	                "div",
	                {
	                  tabIndex: "0",
	                  onClick: this.openIconMenu,
	                  onKeyDown: this.handleKeyDown,
	                  "aria-label": "Change Icon",
	                  className: "icon-menu-wrapper",
	                  ref: function ref(_ref13) {
	                    _this12.iconMenuButton = _ref13;
	                  }
	                },
	                _Icons2.default[this.state.icon]
	              )
	            ),
	            _react2.default.createElement(
	              _Field.DumbField,
	              { fieldId: "category-" + this.props.id, className: "title-wrapper", label: "Category title" },
	              _react2.default.createElement(_Form.TextInput, {
	                fieldId: "category-" + this.props.id,
	                value: this.state.title,
	                onChange: this.setTitle,
	                width: "100%"
	              })
	            ),
	            _react2.default.createElement(
	              _Field.DumbField,
	              { fieldId: "subtitle-" + this.props.id, className: "description-wrapper", label: "Subtitle" },
	              _react2.default.createElement(_Form.TextInput, {
	                fieldId: "subtitle-" + this.props.id,
	                value: this.state.description,
	                onChange: this.setDescription,
	                width: "100%"
	              })
	            ),
	            _react2.default.createElement(
	              "div",
	              { className: "check-wrapper" },
	              _react2.default.createElement(_Form.Checkbox, {
	                value: !this.state.disabled,
	                onChange: this.setDisabled,
	                label: "Enabled",
	                fieldId: "disabled-check"
	              })
	            ),
	            this.props.deletable ? _react2.default.createElement(
	              "div",
	              { className: "align-right" },
	              _react2.default.createElement(
	                "button",
	                { className: "btn btn-danger btn-raised", onClick: this.openDeleteDialog },
	                "Delete Category"
	              )
	            ) : null
	          )
	        ),
	        _react2.default.createElement(
	          "div",
	          { className: "links row" },
	          this.state.links.map(function (link, i) {
	            return link.type === "separator" ? _react2.default.createElement(EditSeparator, { index: i, key: i }) : _react2.default.createElement(EditLink, Object.assign({
	              onChange: _this12.setRowValueByIndex,
	              insertAbove: _this12.insertAbove,
	              insertBelow: _this12.insertBelow,
	              deleteLink: _this12.deleteLink,
	              clearNewIcon: _this12.clearNewIcon,
	              isNew: _this12.state.newIconIndex === i
	            }, link, {
	              index: i,
	              key: i
	            }));
	          }),
	          _react2.default.createElement(
	            "button",
	            { type: "button", onClick: this.addNewLink, className: "add-link custom-focus" },
	            "Add new link"
	          )
	        ),
	        _react2.default.createElement(_FloatingMenu2.default, {
	          className: "home-icon-menu",
	          isOpen: this.state.iconMenuOpen,
	          alignTo: this.state.iconMenuAnchor,
	          align: "right",
	          onRequestClose: this.closeIconMenu,
	          options: [{ value: "business", label: _Icons2.default.business, onClick: this.setIcon }, { value: "shield", label: _Icons2.default.shield, onClick: this.setIcon }, { value: "tools", label: _Icons2.default.tools, onClick: this.setIcon }, { value: "capital", label: _Icons2.default.capital, onClick: this.setIcon }, { value: "charity", label: _Icons2.default.charity, onClick: this.setIcon }, { value: "stamp", label: _Icons2.default.stamp, onClick: this.setIcon }]
	        }),
	        this.state.deleteDialogOpen && _react2.default.createElement(
	          _Portal2.default,
	          { isOpened: this.state.deleteDialogOpen },
	          _react2.default.createElement(_Modal.ConfirmDialog, {
	            closeModal: this.closeDeleteDialog,
	            message: "Are you sure you want to delete this Category?",
	            buttons: [{ label: "No", onClick: this.closeDeleteDialog, className: "btn-default" }, { label: "Yes", onClick: this.props.onRequestDelete, className: "btn-danger" }],
	            modalStyle: { borderRadius: 3 }
	          })
	        )
	      );
	    }
	  }]);
	
	  return EditCategoryModal;
	}(_react2.default.Component);
	
	var EditLink = exports.EditLink = function (_React$Component7) {
	  _inherits(EditLink, _React$Component7);
	
	  function EditLink() {
	    var _ref14;
	
	    var _temp5, _this13, _ret5;
	
	    _classCallCheck(this, EditLink);
	
	    for (var _len5 = arguments.length, args = Array(_len5), _key5 = 0; _key5 < _len5; _key5++) {
	      args[_key5] = arguments[_key5];
	    }
	
	    return _ret5 = (_temp5 = (_this13 = _possibleConstructorReturn(this, (_ref14 = EditLink.__proto__ || Object.getPrototypeOf(EditLink)).call.apply(_ref14, [this].concat(args))), _this13), _this13.state = {
	      menuOpen: false,
	      menuAnchor: null
	    }, _this13.onChange = function (value, e) {
	      _this13.props.onChange({
	        name: e.target.name,
	        value: value,
	        index: _this13.props.index
	      });
	    }, _this13.setTargetBlank = function (value, e) {
	      _this13.props.onChange({
	        name: "targetBlank",
	        value: value,
	        index: _this13.props.index
	      });
	    }, _this13.openMenu = function () {
	      _this13.setState({
	        menuOpen: true,
	        menuAnchor: _this13.menuButton
	      });
	    }, _this13.closeMenu = function () {
	      _this13.setState({ menuOpen: false });
	    }, _this13.insertAbove = function () {
	      _this13.props.insertAbove(_this13.props.index);
	    }, _this13.insertBelow = function () {
	      _this13.props.insertBelow(_this13.props.index);
	    }, _this13.startDeleteAnimation = function () {
	      _this13.setState({
	        deleting: true
	      });
	    }, _this13.onAnimationEnd = function () {
	      if (_this13.state.deleting) {
	        _this13.setState({ deleting: false });
	        _this13.props.deleteLink(_this13.props.index);
	      } else if (_this13.props.isNew) {
	        _this13.props.clearNewIcon();
	      }
	    }, _temp5), _possibleConstructorReturn(_this13, _ret5);
	  }
	
	  _createClass(EditLink, [{
	    key: "render",
	    value: function render() {
	      var _this14 = this;
	
	      var _props8 = this.props,
	          label = _props8.label,
	          href = _props8.href,
	          _props8$themeColor = _props8.themeColor,
	          themeColor = _props8$themeColor === undefined ? '' : _props8$themeColor,
	          themeable = _props8.themeable,
	          _props8$targetBlank = _props8.targetBlank,
	          targetBlank = _props8$targetBlank === undefined ? false : _props8$targetBlank,
	          index = _props8.index,
	          isNew = _props8.isNew;
	
	      return _react2.default.createElement(
	        "div",
	        {
	          className: "col-12 link-row " + (isNew ? "animate-new" : "") + " " + (this.state.deleting ? "animate-delete" : ""),
	          onAnimationEnd: this.onAnimationEnd
	        },
	        _react2.default.createElement(
	          "button",
	          {
	            "aria-haspopup": "true",
	            title: "Options",
	            onClick: this.openMenu,
	            className: "menu-button",
	            ref: function ref(_ref15) {
	              _this14.menuButton = _ref15;
	            }
	          },
	          _react2.default.createElement(_dotMenu2.default, null)
	        ),
	        _react2.default.createElement(
	          _Field.DumbField,
	          { fieldId: "display-" + index, label: "Display text" },
	          _react2.default.createElement(_Form.TextInput, { fieldId: "display-" + index, value: label, name: "label", onChange: this.onChange })
	        ),
	        _react2.default.createElement(
	          _Field.DumbField,
	          { fieldId: "url-" + index, className: "url", label: "URL" },
	          _react2.default.createElement(_Form.TextInput, {
	            fieldId: "url-" + index,
	            value: href,
	            placeholder: "https://",
	            name: "href",
	            onChange: this.onChange
	          })
	        ),
	        themeable && _react2.default.createElement(
	          _Field.DumbField,
	          { fieldId: "theme-" + index, className: "url", label: "Theme Color" },
	          _react2.default.createElement(_Form.Select, {
	            fieldId: "theme-" + index,
	            value: themeColor,
	            name: "themeColor",
	            options: [{ value: '', label: '[Default]' }, { value: 'secondary', label: 'Secondary' }],
	            onChange: this.onChange,
	            onBlur: function onBlur() {}
	          })
	        ),
	        _react2.default.createElement(
	          "div",
	          { className: "new-tab-wrapper" },
	          _react2.default.createElement(_Form.Checkbox, {
	            label: "Open in new tab/window",
	            value: targetBlank,
	            name: "targetBlank" + index,
	            onChange: this.setTargetBlank,
	            fieldId: "target-" + index
	          })
	        ),
	        _react2.default.createElement(_FloatingMenu2.default, {
	          className: "home-edit-menu",
	          isOpen: this.state.menuOpen,
	          alignTo: this.state.menuAnchor,
	          align: "right",
	          onRequestClose: this.closeMenu,
	          options: [{
	            label: _react2.default.createElement(
	              "span",
	              null,
	              _react2.default.createElement(_caretUp2.default, null),
	              "Insert above"
	            ),
	            onClick: this.insertAbove
	          }, {
	            label: _react2.default.createElement(
	              "span",
	              null,
	              _react2.default.createElement(_caretDown2.default, null),
	              "Insert below"
	            ),
	            onClick: this.insertBelow
	          }, {
	            label: _react2.default.createElement(
	              "span",
	              { className: "danger-text" },
	              _react2.default.createElement(_trash2.default, null),
	              "Delete link"
	            ),
	            onClick: this.startDeleteAnimation
	          }]
	        })
	      );
	    }
	  }]);
	
	  return EditLink;
	}(_react2.default.Component);
	
	var EditSeparator = function EditSeparator(_ref16) {
	  var index = _ref16.index;
	  return _react2.default.createElement(
	    "div",
	    { className: "col-12" },
	    _react2.default.createElement(Separator, { categoryId: "modal-" + index })
	  );
	};

/***/ },
/* 298 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _business = __webpack_require__(329);
	
	var _business2 = _interopRequireDefault(_business);
	
	var _stamp = __webpack_require__(590);
	
	var _stamp2 = _interopRequireDefault(_stamp);
	
	var _shield = __webpack_require__(338);
	
	var _shield2 = _interopRequireDefault(_shield);
	
	var _capital = __webpack_require__(553);
	
	var _capital2 = _interopRequireDefault(_capital);
	
	var _charity = __webpack_require__(556);
	
	var _charity2 = _interopRequireDefault(_charity);
	
	var _tools = __webpack_require__(595);
	
	var _tools2 = _interopRequireDefault(_tools);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ICONS = {
	  business: _react2.default.createElement(_business2.default, null),
	  stamp: _react2.default.createElement(_stamp2.default, null),
	  shield: _react2.default.createElement(_shield2.default, null),
	  capital: _react2.default.createElement(_capital2.default, null),
	  charity: _react2.default.createElement(_charity2.default, null),
	  tools: _react2.default.createElement(_tools2.default, null)
	};
	
	exports.default = ICONS;

/***/ },
/* 299 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MountDetector = function MountDetector(_ref) {
	  var onMounted = _ref.onMounted,
	      onWillUnmount = _ref.onWillUnmount;
	
	  _react2.default.useEffect(function () {
	    if (onMounted) {
	      onMounted();
	    }
	    return function () {
	      if (onWillUnmount) {
	        onWillUnmount();
	      }
	    };
	  }, []);
	
	  return null;
	};
	
	exports.default = MountDetector;

/***/ },
/* 300 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Report = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _requests = __webpack_require__(6);
	
	__webpack_require__(1455);
	
	var _downloadBox = __webpack_require__(219);
	
	var _downloadBox2 = _interopRequireDefault(_downloadBox);
	
	var _format = __webpack_require__(33);
	
	var _format2 = _interopRequireDefault(_format);
	
	var _FileDownloader = __webpack_require__(147);
	
	var _FileDownloader2 = _interopRequireDefault(_FileDownloader);
	
	var _Loaders = __webpack_require__(16);
	
	var _utilities = __webpack_require__(8);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ConnectedReportsList = function (_React$Component) {
	  _inherits(ConnectedReportsList, _React$Component);
	
	  function ConnectedReportsList() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, ConnectedReportsList);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = ConnectedReportsList.__proto__ || Object.getPrototypeOf(ConnectedReportsList)).call.apply(_ref, [this].concat(args))), _this), _this.state = { reports: [], loading: null }, _this.componentDidMount = function () {
	      _this.getReports();
	    }, _this.componentDidUpdate = function (prevProps) {
	      if (_this.props.formDefinitionId !== prevProps.formDefinitionId || _this.props.amendmentNum !== prevProps.amendmentNum) {
	        if (!_this.props.amendmentNum) {
	          _this.setState({ loading: null });
	        } else {
	          _this.getReports();
	        }
	      }
	    }, _this.getReports = function () {
	      if (_this.props.formDefinitionId && _this.props.amendmentNum && _this.props.amendmentNum !== "N/A") {
	        _this.setState({ loading: true });
	        var requestId = _this.props.amendmentNum;
	        (0, _requests.GET_REPORTS)(_this.props.formDefinitionId, _this.props.amendmentNum, function (reports) {
	          if (requestId === _this.props.amendmentNum) {
	            _this.setState({ reports: !reports || !Array.isArray(reports) ? [] : reports, loading: false });
	          }
	        });
	      } else {
	        _this.setState({ reports: [], loading: null });
	      }
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(ConnectedReportsList, [{
	    key: 'render',
	    value: function render() {
	      return this.state.loading !== null ? this.state.loading ? _react2.default.createElement(
	        'div',
	        { className: 'reports-spinner animated fadeIn' },
	        _react2.default.createElement(_Loaders.Spinner, { size: 'medium', themeColor: 'secondary' })
	      ) : _react2.default.createElement(ReportsList, { id: this.props.id, loading: this.state.loading, reports: this.state.reports }) : _react2.default.createElement(
	        'div',
	        { className: 'reports-list' },
	        _react2.default.createElement(
	          'h5',
	          null,
	          'No available downloads'
	        )
	      );
	    }
	  }]);
	
	  return ConnectedReportsList;
	}(_react2.default.Component);
	
	exports.default = ConnectedReportsList;
	
	
	var ReportsList = function ReportsList(_ref2) {
	  var loading = _ref2.loading,
	      reports = _ref2.reports,
	      id = _ref2.id;
	  return _react2.default.createElement(
	    'div',
	    { className: 'reports-list' },
	    _react2.default.createElement(
	      'h5',
	      null,
	      reports.length > 0 ? 'Available Downloads:' : 'No available downloads'
	    ),
	    !loading && reports.map(function (report, i) {
	      return _react2.default.createElement(Report, { report: report, id: id, key: id + i, delay: 50 * i });
	    })
	  );
	};
	
	var DOWNLOAD_ERROR = 'Something went wrong while downloading this file. Try again later.';
	
	var Report = exports.Report = function (_React$Component2) {
	  _inherits(Report, _React$Component2);
	
	  function Report() {
	    var _ref3;
	
	    var _temp2, _this2, _ret2;
	
	    _classCallCheck(this, Report);
	
	    for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
	      args[_key2] = arguments[_key2];
	    }
	
	    return _ret2 = (_temp2 = (_this2 = _possibleConstructorReturn(this, (_ref3 = Report.__proto__ || Object.getPrototypeOf(Report)).call.apply(_ref3, [this].concat(args))), _this2), _this2.state = { blob: null, downloading: false, fresh: true, rawBlob: null, downloadError: false }, _this2.getDownload = function () {
	      _this2.setState({ downloading: true, downloadError: false, fresh: false });
	      (0, _requests.GET_REPORT_BY_REPORT_OBJECT)(_this2.props.report, function (res) {
	        if (res.ok) {
	          if (_this2.props.report.RETURN_TYPE === "URL") {
	            res.text().then(function (url) {
	              _this2.setState({
	                blob: url,
	                downloading: false,
	                downloadError: false
	              }, function () {
	                _this2.downloader.download();
	              });
	            });
	          } else {
	            res.blob().then(function (blob) {
	              var blobObject = window.URL.createObjectURL(blob);
	              _this2.setState({ blob: blobObject, rawBlob: blob, downloading: false, downloadError: false }, function () {
	                _this2.downloader.download();
	              });
	            });
	          }
	        } else {
	          _this2.setState({ downloadError: true, downloading: false });
	        }
	      }, function (err) {
	        _this2.setState({ downloadError: true, downloading: false });
	      });
	    }, _temp2), _possibleConstructorReturn(_this2, _ret2);
	  }
	
	  _createClass(Report, [{
	    key: 'render',
	    value: function render() {
	      var _this3 = this;
	
	      var _props = this.props,
	          delay = _props.delay,
	          report = _props.report,
	          animated = _props.animated,
	          _props$id = _props.id,
	          id = _props$id === undefined ? Date.now() : _props$id;
	      var _report$REPORT_NAME = report.REPORT_NAME,
	          REPORT_NAME = _report$REPORT_NAME === undefined ? '' : _report$REPORT_NAME,
	          LAST_MODIFIED_DATE = report.LAST_MODIFIED_DATE;
	
	      var hasExtension = REPORT_NAME.split('.').length >= 2;
	      return _react2.default.createElement(
	        'button',
	        { className: 'report ' + (animated !== false ? 'animated fadeInUp extra-fast-animation' : '') + ' ' + (this.state.downloadError ? 'error' : ''), style: {
	            animationDelay: delay + 'ms'
	          }, onClick: this.state.downloading ? _utilities.noop : this.getDownload },
	        _react2.default.createElement(
	          'div',
	          { className: 'download-icon' },
	          this.state.downloading && _react2.default.createElement('div', { className: 'shine-spinner' }),
	          _react2.default.createElement(_downloadBox2.default, { className: 'icon ' + (this.state.fresh ? '' : this.state.downloading ? 'spin-out' : 'spin-in') })
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'labels' },
	          _react2.default.createElement(
	            'p',
	            { style: { opacity: this.state.downloadError ? 1 : 0 }, className: 'download-error', 'aria-hidden': true },
	            DOWNLOAD_ERROR
	          ),
	          _react2.default.createElement(
	            'span',
	            null,
	            REPORT_NAME
	          ),
	          _react2.default.createElement(
	            'span',
	            { className: 'date' },
	            (0, _format2.default)(new Date(LAST_MODIFIED_DATE), 'MM/dd/yyyy')
	          ),
	          _react2.default.createElement(
	            'p',
	            { role: 'alert', className: 'visually-hidden' },
	            this.state.downloadError ? DOWNLOAD_ERROR : ""
	          )
	        ),
	        _react2.default.createElement(_FileDownloader2.default, {
	          ref: function ref(downloader) {
	            _this3.downloader = downloader;
	          },
	          href: this.state.blob,
	          blob: this.state.rawBlob,
	          fileName: hasExtension ? REPORT_NAME : '' + REPORT_NAME + (id ? '_' + id : '') + '.pdf'
	        })
	      );
	    }
	  }]);
	
	  return Report;
	}(_react2.default.Component);

/***/ },
/* 301 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.PageError = PageError;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	__webpack_require__(1457);
	
	var _errorIcon = __webpack_require__(1028);
	
	var _errorIcon2 = _interopRequireDefault(_errorIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function PageError(props) {
	  var defaultErrorLines = _react2.default.createElement(
	    'div',
	    { className: 'error-text-color error-flex-margin' },
	    _react2.default.createElement(
	      'span',
	      { className: 'error-description-line' },
	      'Something broke while trying to complete your request.'
	    ),
	    _react2.default.createElement(
	      'span',
	      { className: 'error-description-line' },
	      'Check your internet connection and try again.'
	    )
	  );
	
	  var details = null;
	
	  if (props.errorDetails && props.errorDetails.code) {
	    details = _react2.default.createElement(
	      _react2.default.Fragment,
	      null,
	      defaultErrorLines,
	      _react2.default.createElement(
	        'span',
	        { className: 'error-details-header error-text-color error-flex-margin' },
	        'Error Code: ',
	        props.errorDetails.code
	      )
	    );
	  } else if (props.errorDetails && props.errorDetails.message) {
	    details = _react2.default.createElement(
	      'div',
	      { className: 'error-text-color error-flex-margin' },
	      _react2.default.createElement(
	        'span',
	        { className: 'error-description-line' },
	        props.errorDetails.message
	      )
	    );
	  } else {
	    details = defaultErrorLines;
	  }
	
	  return _react2.default.createElement(
	    'div',
	    { className: 'center-container grey-top-border generic-page-error' },
	    _react2.default.createElement(
	      'div',
	      { className: 'flex-column-wrapper flex-center' },
	      _react2.default.createElement('img', { src: _errorIcon2.default, className: 'error-icon error-flex-margin', alt: 'error-symbol' }),
	      _react2.default.createElement(
	        'h2',
	        { className: 'error-text-color error-flex-margin' },
	        'Whoops. Something went wrong.'
	      ),
	      details
	    )
	  );
	}

/***/ },
/* 302 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.AdminLoginPage = exports.AdminLogin = exports.PublicLogin = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(7);
	
	var _reactRouterDom = __webpack_require__(30);
	
	var _AuthActions = __webpack_require__(66);
	
	var _actions = __webpack_require__(29);
	
	var _Loaders = __webpack_require__(16);
	
	var _Portal = __webpack_require__(12);
	
	var _Portal2 = _interopRequireDefault(_Portal);
	
	var _Modal = __webpack_require__(13);
	
	var _Shell = __webpack_require__(19);
	
	__webpack_require__(1466);
	
	var _FloatingMenu = __webpack_require__(86);
	
	var _FloatingMenu2 = _interopRequireDefault(_FloatingMenu);
	
	var _store = __webpack_require__(18);
	
	var _utilities = __webpack_require__(8);
	
	var _CreateAccount = __webpack_require__(149);
	
	var _CreateAccount2 = _interopRequireDefault(_CreateAccount);
	
	var _ForgotPasswordForm = __webpack_require__(1139);
	
	var _ForgotPasswordForm2 = _interopRequireDefault(_ForgotPasswordForm);
	
	var _ForgotUsernameForm = __webpack_require__(1140);
	
	var _ForgotUsernameForm2 = _interopRequireDefault(_ForgotUsernameForm);
	
	var _Markdown = __webpack_require__(24);
	
	var _Markdown2 = _interopRequireDefault(_Markdown);
	
	var _UserAccountEditor = __webpack_require__(1150);
	
	var _UserAccountEditor2 = _interopRequireDefault(_UserAccountEditor);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Okta = function Okta() {
	  return null;
	};
	////////////////////////
	//////////////////////////////////////////////////
	//////////
	
	var loginHeaderImg = void 0;
	if (false) {
	  loginHeaderImg = require('../../../common/img/' + process.env.LOGIN_HEADER_IMG_PATH);
	}
	
	var STATE_ABBR = ("MT");
	STATE_ABBR = STATE_ABBR.toUpperCase();
	var SEAL_FILENAME = ("seal.png");
	var LOGIN_SEAL_FILENAME = ("seal_white.png");
	var stateSeal = __webpack_require__(216)("./" + STATE_ABBR + (LOGIN_SEAL_FILENAME ? '/' + LOGIN_SEAL_FILENAME : SEAL_FILENAME ? '/' + SEAL_FILENAME : '/seal.svg'));
	var ALLOW_USER_PROFILE_EDITING = (true);
	var LOGIN_REDIRECTS_TO_EPASS = (false);
	var FETCH_EDIT_USER_LINK = (false);
	
	var Auth = function (_Component) {
	  _inherits(Auth, _Component);
	
	  function Auth() {
	    _classCallCheck(this, Auth);
	
	    var _this = _possibleConstructorReturn(this, (Auth.__proto__ || Object.getPrototypeOf(Auth)).call(this));
	
	    _this.toggleLoginModal = function () {
	      if (LOGIN_REDIRECTS_TO_EPASS) {
	        _store.history.push((0, _utilities.getAuthRedirectUrl)({ pathname: _this.props.pathname, search: _this.props.search }));
	      } else {
	        _this.props.toggleLoginModal(!_this.props.showLogin);
	      }
	    };
	
	    _this.componentDidUpdate = function (prevProps) {
	      if (prevProps.loggedIn === false && _this.props.loggedIn === true) {
	        if (_this.modalref.current) {
	          _this.modalref.current.closeModal();
	        }
	      }
	      if (prevProps.siteOffline === true && _this.props.siteOffline === false) {
	        (0, _AuthActions.clearLocalUser)(true);
	      }
	    };
	
	    _this.logout = function () {
	      _this.props.logoutWebUser();
	//////////////////////////////
	//////////////////////////////
	////////////////
	    };
	
	    _this.openMenu = function (e) {
	      _this.setState({
	        alignTo: e.currentTarget,
	        menuOpen: true
	      });
	    };
	
	    _this.closeMenu = function () {
	      _this.setState({
	        menuOpen: false
	      });
	    };
	
	    _this.startProfileEditor = function () {
	      return _this.setState({ editingUserAccount: true });
	    };
	
	    _this.closeProfileEditor = function () {
	      return _this.setState({ editingUserAccount: false });
	    };
	
	    _this.startExternalProfileEdit = function () {};
	
	    _this.mountOkta = function (props) {
	      if (({"NODE_ENV":"production","BUILD_DATE":"2025-08-27T15:15:31.687Z","BUILD_NUMBER":"Not Provided","GIT_VERSION":"v1.3.0-381-ga81e29b08","GIT_COMMIT_HASH":"a81e29b085c9268ffd96c78eb734365802722741","GIT_BRANCH":"beta","PUBLIC_URL":"","STATE_ABBR":"MT","STATE_NAME":"Montana","STATE_ORG_TITLE":"Secretary of State","LOGIN_HEADER_IMG_PATH":"","HOME_IMG_FILENAME":"montana.jpg","FAVICON_FILE_NAME":"favicon.ico","ALLOW_E_SIGN_ON_CORRECTIONS":true,"THIRD_PARTY_SIGNING_ALLOWED":false,"MY_ACCOUNT_SAVE_AND_CLOSE_BUTTON":true,"IE_DEPRECATED_MESSAGE":"Internet Explorer is not supported. Please select a supported browser below to access this website.","ADDITIONAL_ROUTES":{"dataRequests":true,"farmBill":true,"apostille":true,"externalHelp":"https://sosmt.gov/business/help-center/","systemAdministration":[{"title":"Saved Payments","parameter":"saved-payments","componentName":"SavedPayments"}]},"SUBROUTES":[{"label":"Business","component":"Business","parameter":"business","myWorkQueueSearch":false,"sourceTypeId":54,"searchMustHaveOneOf":["FILING_TYPE_ID","STATUS_ID","STATE","search"],"serverWebSearchDescription":true,"serverWorkQueueDescription":true,"serverMyRecordsDescription":true,"searchPlaceholder":"Search by name or filing number (X########)","allowEmptySearchTerm":true,"requestCertificateAlternateLabel":"Request Information","fileAmendmentButtonLabel":"Filing Actions","advancedSearchParameters":[{"type":"radio","name":"QUERY_TYPE_ID","defaultValue":1010,"options":[{"value":1010,"label":"Starts with"},{"value":1011,"label":"Contains"},{"value":1012,"label":" Word Contains"}]},{"type":"serverSelect","name":"FILING_TYPE_ID","optionsSrc":"FILING_TYPES","label":"Entity Type","placeholder":"All","defaultValue":"0"},{"type":"serverSelect","name":"FILING_SUBTYPE_ID","optionsSrc":"FILING_SUBTYPES","label":"Entity Subtype","overrideSubOptionsSrcFromParameterName":"FILING_TYPE_ID","placeholder":"All","defaultValue":"0"},{"type":"serverSelect","name":"STATUS_ID","optionsSrc":"FILING_STATUS_WITHOUT_ALL","label":"Status","placeholder":"All","defaultValue":"0"},{"type":"serverSelect","name":"STATE","optionsSrc":"STATE","label":"State","placeholder":"All","defaultValue":""},{"type":"serverSelect","name":"COUNTY","optionsSrc":"COUNTY_SUBOPTION","label":"County","overrideSubOptionsSrcFromParameterName":"STATE","placeholder":"All","defaultValue":""},{"type":"checkbox","name":"CRA_SEARCH_YN","defaultValue":false,"label":"Search by Registered Agent PID"},{"type":"dateRange","name":"FILING_DATE","label":"Registration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}},{"type":"dateRange","name":"EXPIRATION_DATE","label":"Expiration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}}],"myRecordsFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Active"},{"value":2,"label":"Inactive"},{"value":3,"label":"Pending"}]},{"type":"dateRange","name":"DATE_RANGE","label":"Date range","defaultValue":{"start":null,"end":null}}],"myWorkQueueFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Approved"},{"value":2,"label":"Pending Online Payment"},{"value":3,"label":"Pending Review"},{"value":4,"label":"Needs Correction"},{"value":5,"label":"Rejected"},{"value":6,"label":"Draft"}]},{"type":"dateRange","name":"DATE_RANGE","label":"Date range","defaultValue":{"start":null,"end":null}}]},{"label":"Notary","component":"Notary","parameter":"notary","sourceTypeId":850,"myWorkQueueSearch":false,"allowEmptySearchTerm":true,"requestCertificateAlternateLabel":"Download Certificate","fileAmendmentButtonLabel":"Filing Actions","hideNameRequestCertificate":true,"hideAddressRequestCertificate":true,"hideRecordUserManagment":true,"searchPlaceholder":"Search by name or commission number","searchMustHaveOneOf":["CITY","search","SERVICE_TYPE"],"advancedParametersStartOpen":true,"searchIsSortable":true,"advancedSearchParameters":[{"type":"radio","name":"STARTS_WITH_YN","defaultValue":false,"options":[{"value":true,"label":"Starts with"},{"value":false,"label":"Contains"}]},{"type":"checkbox","name":"ACTIVE_ONLY_YN","defaultValue":true,"label":"Active entities only"},{"type":"text","name":"CITY","defaultValue":"","label":"City"},{"type":"select","name":"SERVICE_TYPE","label":"Special Services Offered","defaultValue":0,"options":[{"value":0,"label":"(N/A)"},{"value":6165,"label":"In-Person Electronic Notarization (IPEN)"},{"value":6166,"label":"Remote Online Notarization (RON)"},{"value":6167,"label":"Mobile Notary Services"},{"value":6168,"label":"Remote Ink Notarization (RIN)"}]}]},{"label":"Apostille","component":"Apostille","parameter":"apostille","sourceTypeId":720,"myRecordsSearch":false,"myWorkQueueSearch":false,"disabled":false,"allowedRoutes":["/forms-manager/","/queue/","/forms/"]},{"label":"Liens","component":"UCC","parameter":"ucc","sourceTypeId":1999,"myRecordsSearch":true,"myWorkQueueSearch":true,"fileAmendmentButtonLabel":"Filing Actions","searchPlaceholder":"Search by name or file number","disabled":false,"serverWebSearchDescription":true,"myRecordsDescription":"","workQueueDescription":"","searchDescription":"","hideRecordUserManagment":true,"searchLiensCheckout":false,"advancedSearchParameters":[{"type":"radio","name":"STARTS_WITH_YN","defaultValue":false,"options":[{"value":true,"label":"Starts with"},{"value":false,"label":"Contains"}]},{"type":"select","name":"STATUS","defaultValue":"ALL","label":"Status","options":[{"value":"ACTIVE_UNLAPSED","label":"Active (unlapsed)"},{"value":"ACTIVE_LAPSED_UNLAPSED","label":"Active (lapsed and unlapsed)"}]},{"type":"text","name":"EXCLUDE_VALUES","label":"Exclude Debtor Names (comma separated list of names to exclude)","defaultValue":""},{"type":"dateRange","name":"FILING_DATE","label":"Financing Statement Date","defaultValue":{"start":null,"end":null}},{"type":"dateRange","name":"LAPSE_DATE","label":"Lapse Date","defaultValue":{"start":null,"end":null}},{"type":"text","name":"CITY","label":"Debtor City","defaultValue":""}],"myRecordsFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Approved"},{"value":2,"label":"Pending Online Payment"},{"value":3,"label":"Pending Review"}]},{"type":"select","name":"TYPE","defaultValue":0,"label":"Lien Type","options":[{"value":0,"label":"All"},{"value":1,"label":"UCC"},{"value":2,"label":"EFS"},{"value":3,"label":"Title 71"}]}],"myWorkQueueFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Approved"},{"value":2,"label":"Pending Online Payment"},{"value":3,"label":"Pending Review"},{"value":4,"label":"Pending Print and Mail"},{"value":5,"label":"Rejected"},{"value":6,"label":"Draft"}]},{"type":"select","name":"TYPE","defaultValue":0,"label":"Lien Type","options":[{"value":0,"label":"All"},{"value":1,"label":"UCC"},{"value":2,"label":"EFS"},{"value":3,"label":"Title 71"}]}]},{"label":"Copy Request","component":"copies","parameter":"copies","sourceTypeId":2001,"myRecordsSearch":false,"myWorkQueueSearch":false,"disabled":false,"allowedRoutes":["/forms-manager/","/queue/","/forms/"]},{"label":"Trademark","component":"Trademark","parameter":"trademark","sourceTypeId":810,"showRequestCertificate":true,"searchMustHaveOneOf":["search","EXPIRATION_DATE","FILING_DATE"],"allowEmptySearchTerm":true,"requestCertificateAlternateLabel":"Request Information","fileAmendmentButtonLabel":"Filing Actions","advancedSearchParameters":[{"type":"radio","name":"QUERY_TYPE_ID","defaultValue":1010,"options":[{"value":1010,"label":"Starts with"},{"value":1011,"label":"Contains"},{"value":1012,"label":" Word Contains"}]},{"type":"checkbox","name":"OWNER_SEARCH_YN","defaultValue":false,"label":"Search owners"},{"type":"radio","name":"SERVICE_MARK_YN","label":"Mark Type","defaultValue":"","options":[{"value":"","label":"All Marks"},{"value":"Y","label":"Service Mark"},{"value":"N","label":"Trademark"}]},{"type":"serverSelect","name":"STATUS_ID","optionsSrc":"TYPE_V|TRADEMARK_STATUS_TYPE","label":"Status","placeholder":"All","defaultValue":"0"},{"type":"select","name":"DESIGN_TYPE_ID","options":[{"value":0,"label":"All"},{"value":990,"label":"Words Only"},{"value":991,"label":"Design Only"},{"value":992,"label":"Words and Design"}],"label":"Design Type","defaultValue":"0"},{"type":"dateRange","name":"FILING_DATE","label":"Registered Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}},{"type":"dateRange","name":"EXPIRATION_DATE","label":"Expiration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}}]},{"label":"Business Info Request","component":"InfoRequests","parameter":"info-request","sourceTypeId":167,"allowedRoutes":["/forms-manager/","/queue/","/forms/"]},{"label":"Data Requests","component":"DataRequests","parameter":"data-request","sourceTypeId":0,"allowedRoutes":["/forms-manager/"]},{"label":"CRA","component":"CRA","parameter":"cra","sourceTypeId":157,"myRecordsSearch":false,"searchPlaceholder":"Search by name or registered agent number","allowedRoutes":["/forms-manager/","/forms/","/records/","/queue/","/search/"],"allowEmptySearchTerm":true,"fileAmendmentButtonLabel":"Filing Actions","advancedSearchParameters":[{"type":"radio","name":"QUERY_TYPE_ID","defaultValue":1010,"options":[{"value":1010,"label":"Starts with"},{"value":1011,"label":"Contains"},{"value":1012,"label":" Word Contains"}]},{"type":"dateRange","name":"CRA_DATE","label":"Registration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}},{"type":"select","name":"STATUS_ID","label":"Status","defaultValue":0,"options":[{"value":0,"label":"All"},{"value":121,"label":"Active"},{"value":122,"label":"Inactive"}]},{"type":"select","name":"AGENT_TYPE_ID","label":"Agent Type","defaultValue":0,"options":[{"value":0,"label":"All"},{"value":460,"label":"Registered Agent"},{"value":461,"label":"Commercial Registered Agent"}]}]},{"label":"Farm Bill","component":"FarmBill","parameter":"farm-bill","path":"/lists/farm-bill","sourceTypeId":0,"myRecordsSearch":false,"allowedRules":["/search/"],"disabled":true,"searchDescription":"To perform a search, enter a debtor name. Your search results may include: exact debtor name, variations of that name and any filing that includes your search criteria. Punctuation is ignored.\n\nYou can click on \"Advanced\" to refine your search. Under “Advanced” you can search by crop, year, county and SSN/FEIN. As a registered Farm Bill Buyer with the Montana Secretary of State’s office it is important to maintain the confidentiality of the information contained within the Farm Bill Master List. The Farm Bill Master List reflects personal data, such as Social Security Numbers, which are a key piece of personal identifiable information to assist you in determining the existence of a lien against a specific debtor. The distribution of this information beyond its intended purpose is strictly prohibited.\n\nThe debtor's tax identification number has been hidden for confidentiality reasons. You may continue to search on a tax ID number and return debtors that match your search criteria. The SSN/FEIN must be entered without dashes or spaces.","searchMustHaveOneOf":["search","UCC_FARM_PRODUCT_ID","COUNTY"],"searchPlaceholder":"Search by debtor name","advancedSearchParameters":[{"type":"ServerMultiComplete","label":"Product code name(s)","name":"UCC_FARM_PRODUCT_ID","defaultValue":"","optionsSrc":"UCC_FARM_PRODUCT_V"},{"type":"MultiComplete","label":"Year or Range of Years","name":"YEAR_NUM","optionsSrc":"years","startYear":"1968","defaultValue":[],"preMergeOptions":[{"value":"ALL","label":"All"}]},{"type":"serverSelect","label":"State","name":"STATE","defaultValue":"MONTANA","optionsSrc":"STATE"},{"type":"ServerMultiComplete","label":"County","name":"COUNTY","defaultValue":[],"optionsSrc":"COUNTY","overrideSubOptionsSrcFromParameterName":"STATE"},{"type":"checkbox","name":"TIN_SEARCH_YN","defaultValue":false,"label":"Tax Identification Number Search"},{"type":"checkbox","name":"TIN_SORT_YN","defaultValue":false,"label":"Unique ID Sort"}]}],"SYSTEM_NICKNAME":"Online Services Portal","PAYMENT_METHODS":[{"type":"bypass"},{"type":"iTransact"}],"PAYMENT_ALLOW_AMEX":true,"SYSTEM_ID_LABEL":"System Id","DOUBLE_COLUMN_PUBLIC_LOGIN":true,"INTERNAL_USER_MANAGEMENT":true,"ALLOW_PUBLIC_JSON_IMPORT":false,"MAX_FILE_UPLOAD_SIZE":10000000,"REFUND_TEXT":"","RETURN_TO_HOME_ON_LOGOUT":true,"CURRENT_SOS_NAME":"Christi Jacobsen","LOGO_FILENAME":"mt-sos-logo.png","LOGO_ALT":"Christi Jacobsen, Montana Secretary of State","LOGO_FULL_WIDTH":true,"HOME_HIDE_AUTH_HINT":true,"HOME_TITLE":"Montana Secretary of State","CUSTOM_TAB_TITLE":"Official Montana","HOME_SUBTITLE":"Online Business Services","ENTITY_NAME_CONSENT_DESCRIPTION":"","ALLOW_USER_PROFILE_EDITING":true,"COMPARE_FOREIGN_NAME_IN_ENTITY_NAME_VALIDATION":true,"FOREIGN_NAME_FIELD_NAME":"KIMA_PARENT_NAME_INFO","LOGIN_TITLE":"Montana Secretary of State Online Filing Portal Login","PUBLIC_LOGIN_LABEL":"Username","REVERSE_LOGIN_COLUMNS":true,"LOGIN_SEAL_FILENAME":"seal_white.png","SEPARATE_USERNAME_AND_EMAIL":true,"CREATE_ACCOUNT_BUTTON_ALIGN_LEFT":true,"CREATE_ACCOUNT_BUTTON_TEXT":"CREATE AN ACCOUNT","PASSWORD_CUSTOM_ERROR_TEXT":"The password must meet all requirements","ACCOUNT_CREATED_MESSAGE":"Please check your email to verify your account to login and allow a few minutes for this message to arrive. Check your junk/spam folders if you do not find the email in your inbox.","PUBLIC_LOGIN_PLACEHOLDER":" ","DISABLE_DEFAULT_PAYMENT_RADIO":true,"CUSTOM_RESET_PASSWORD_ERROR_MESSAGE":"Username invalid - no account found","PUBLIC_LOGIN_CREATE_DESCRIPTION":"### Existing User:\n\n  - Enter your username and password to login.  \n\n\n  #### - OR -  \n\n\n\n  - Forgot password? Click 'Reset Password' and follow the prompts.\n  - Forgot username? Click 'Forgot Username' and follow the prompts.  \n\n\n  ### New User:\n  ","LOGIN_HELP_LINK":"https://sosmt.gov/business/how-do-i/","LOGIN_HELP_LINK_TEXT":"Need Help?","FORGOT_USERNAME_TEXT":"Forgot Username?","LOGIN_ACTIVE_DIRECTORY_TEXT":"State User Login","MULTIPLE_LOGIN_METHODS":true,"HAS_ACTIVE_DIRECTORY_LOGIN":true,"RESET_PASSWORD_WITH_USERNAME":true,"DOWNLOAD_LINK":true,"SHOW_USERNAME_ACCOUNT_CREATE":true,"SHOW_SCROLL_DOWN_ARROW":true,"SHOW_ADDRESS_ACCOUNT_CREATE":true,"TWO_COLUMN_ACCOUNT_CREATE":true,"RESET_PASSWORD_TIP":"A link to change your password has been sent to your email. Please allow a few minutes for this message to arrive. Please check your junk/spam folders if you do not find the email in your inbox.","FORGOT_PASSWORD_LINK_TEXT":"Reset Password","PHONE_NUMBER_OPTIONAL_ACCOUNT_CREATE":true,"SHOW_REQUIRED_INDICATOR_ACCOUNT_CREATE":true,"PASSWORD_REQUIREMENTS_ACCOUNT_CREATE":"\n    <ul>\n      <li>MUST contain at least 8 characters (12+ recommended)</li>\n      <li>MUST contain at least one uppercase letter.</li>\n      <li>MUST contain at least one lowercase letter.</li>\n      <li>MUST contain at least one number.</li>\n      <li>MUST contain at least one special character (!”#$%&'()*+,-./:;<=>?</li>\n    </ul>\n  ","ALLOW_CERTIFICATION_REQUEST":true,"ALLOW_PUBLIC_CERTIFICATE_REQUEST":true,"ALLOW_COPY_REQUEST":false,"ALLOW_CORRECTION_STYLING":true,"HIDE_DEPRECATION_WARNING":false,"AMEND_ROUTE_PUBLIC":true,"SEAL_FILENAME":"seal.png","SHOPPING_CART":true,"ALLOW_PAYMENT_UPDATE_WITH_EMPTY_CART":true,"RA_EMAIL":true,"RA_WEBSITE":true,"RA_NO_DEFAULT_TYPE":true,"RA_ADDRESS_LABEL":"Street Address","RA_TYPE_SELECTION_DEFAULT":true,"RA_DEFAULT_TYPE":"460","RA_OVERRIDE_TYPE_WITH_DEFAULT":true,"RA_PRINCIPAL_ADDRESS_AMS":true,"UPLOAD_AND_SUBMIT_HIDE_IF_ONE_OPTION":true,"PAYMENT_PROCESSING_MESSAGE":"Your payment is processing - Do not close your browser or click the back button","CHECKOUT_BUTTON_WHEN_PROCESSING_TEXT":"Processing","EFS_CROP_PICKER_NONE_LABEL":"Lien Duration","DISALLOWED_WIZARD_PIECES":["FormationLocale"],"REPEATER_SHOW_EDIT_BUTTON":true,"DATA_REQUEST_PAGE_TITLE":"Data Requests and Subscriptions","DATA_REQUEST_SIDEBAR_LABEL":"Data Requests & Subscriptions","LOGIN_REDIRECTS_TO_EPASS":false,"LOGIN_REDIRECTS_TO_ACTIVE_DIRECTORY":true,"LOGIN_ACTIVE_DIRECTORY_LINK":true,"FETCH_EDIT_USER_LINK":false,"LISTS_FETCH_AVAILABLE_LISTS":true,"POST_WIZARD_SUBMIT_REDIRECT_URL":"/","PIN_REQUEST_ATTESTATIONS":true,"PIN_REQUEST_DESCRIPTION":"Click **Request PIN** to have a new PIN sent to the account holder's email address on file.","OWNERSHIP_REQUEST_DESCRIPTION":"To become an **authorized user** of this record, a current **AUTHORIZED USER** will need to grant you access. To request access, click **Request Access** below.","PIN_REQUEST_SUCCESS_MESSAGE":"The PIN you have requested for this entity has been sent to the email associated with your user account.  You should receive the PIN in approximately 3-5 minutes, depending on your email service provider.","APOSTILLE_HEADER_LABEL":"Verification Information","APOSTILLE_NUMBER_LABEL":"Apostille/Authentication","APOSTILLE_CITY_STATE_OVERRIDE":"HELENA, MT","APOSTILLE_FILING_DATE_LABEL":"Issue Date","APOSTILLE_CITY_STATE_IN_CERTIFIED":true,"NOTARY_EXISTING_FILING":true,"ALLOW_REVOKE_OWN_ACCESS_ONLY":false,"HIDE_CANCEL_ON_ONETIME_DATA_REQUESTS":true,"DATA_REQUESTS_IN_SHOPPING_CART":true,"WQ_ALLOW_EDIT_PENDING_PAYMENT":true,"WQ_CONFIRM_ON_DELETE":true,"WQ_DELETE_CONFIRM_MESSAGE":"Deleting this filing will forfeit any money already paid to the Secretary of State. This action is permanent and cannot be undone, are you sure you would like to delete?","PASS_ITEM_GUIDS_ON_CHECKOUT":true,"FORM_REVISION_HISTORY":true,"CHECKOUT_DISCLAIMER":"By entering your credit card and/or checking account information you (i) state that **you are an authorized user** of the credit card and/or electronic check and that the associated information entered (e.g., account holder name, account number, billing address) is accurate, (ii) **you authorize payment processor to charge the amount you have requested** to your credit card and/or funding account, and (iii) **acknowledge if a charge is declined or reversed you may also be assessed a customary charge** by the payment processor for such transactions.","FARM_BILL_SEARCH_CONFIDENTIAL":"As a registered Farm Bill Buyer with the Montana Secretary of State’s office it is important to maintain the confidentiality of the information contained within the Farm Bill Master List. The Farm Bill Master List reflects personal data, such as Social Security Numbers, which are a key piece of personal identifiable information to assist you in determining the existence of a lien against a specific debtor. The distribution of this information beyond its intended purpose is strictly prohibited.\n\n**The debtor's tax identification number has been hidden for confidentiality reasons. You may continue to search on a tax ID number and return debtors that match your search criteria. The SSN/FEIN must be entered without dashes or spaces.  If you need access to the tax identification number to clearly identify the debtor, please contact the UCC unit at (406) 444-3665.**","VIEW_HISTORY_BUTTON_ALT_TEXT":"View Filings","WIZARD_ERROR_TITLE_MESSAGE":"Form Error","FARM_BILL_SEARCH_INTERACTIVE":true,"USE_FARM_BILL_API":true,"DISALLOW_ASSIGN_SELF_AS_RA":true,"DISALLOW_ASSIGN_SELF_AS_PRINCIPAL":true,"USE_TRADEMARK_OWNER_VALIDATION":true,"USE_ALTERNATIVE_FOREIGN_ADDRESS_LABELS":true,"MY_RECEIPTS_FILTER":[{"type":"dateRange","name":"DATE_RANGE","label":"Date range","defaultValue":{"start":null,"end":null}},{"type":"text","name":"REF_NUM","defaultValue":"","label":"Reference Number"},{"type":"text","name":"RECEIPT_NUM","defaultValue":"","label":"Receipt Id"},{"type":"text","name":"AMOUNT","defaultValue":"","label":"Amount"},{"type":"select","name":"TYPE","defaultValue":"","label":"Payment Type","options":[{"value":"","label":"All"},{"value":"CC","label":"Credit Card"},{"value":"Check","label":"Check"}]}],"MY_RECEIPTS_SHOW_IN_SIDEBAR":true,"SHOW_MY_RECEIPTS_HELPER_TEXT":true,"MY_RECEIPTS_HELPER_LABEL":"About Receipt Search","MY_RECEIPTS_HELPER_TEXT":"You can search for receipts based on their descriptions, including the items paid for on the receipt. Use the filters to search for or filter specific information.","FARM_BILL_SUBLINK":{"label":"Farm Bill","component":"FarmBill","parameter":"farm-bill","path":"/lists/farm-bill","sourceTypeId":0,"myRecordsSearch":false,"allowedRules":["/search/"],"disabled":true,"searchDescription":"To perform a search, enter a debtor name. Your search results may include: exact debtor name, variations of that name and any filing that includes your search criteria. Punctuation is ignored.\n\nYou can click on \"Advanced\" to refine your search. Under “Advanced” you can search by crop, year, county and SSN/FEIN. As a registered Farm Bill Buyer with the Montana Secretary of State’s office it is important to maintain the confidentiality of the information contained within the Farm Bill Master List. The Farm Bill Master List reflects personal data, such as Social Security Numbers, which are a key piece of personal identifiable information to assist you in determining the existence of a lien against a specific debtor. The distribution of this information beyond its intended purpose is strictly prohibited.\n\nThe debtor's tax identification number has been hidden for confidentiality reasons. You may continue to search on a tax ID number and return debtors that match your search criteria. The SSN/FEIN must be entered without dashes or spaces.","searchMustHaveOneOf":["search","UCC_FARM_PRODUCT_ID","COUNTY"],"searchPlaceholder":"Search by debtor name","advancedSearchParameters":[{"type":"ServerMultiComplete","label":"Product code name(s)","name":"UCC_FARM_PRODUCT_ID","defaultValue":"","optionsSrc":"UCC_FARM_PRODUCT_V"},{"type":"MultiComplete","label":"Year or Range of Years","name":"YEAR_NUM","optionsSrc":"years","startYear":"1968","defaultValue":[],"preMergeOptions":[{"value":"ALL","label":"All"}]},{"type":"serverSelect","label":"State","name":"STATE","defaultValue":"MONTANA","optionsSrc":"STATE"},{"type":"ServerMultiComplete","label":"County","name":"COUNTY","defaultValue":[],"optionsSrc":"COUNTY","overrideSubOptionsSrcFromParameterName":"STATE"},{"type":"checkbox","name":"TIN_SEARCH_YN","defaultValue":false,"label":"Tax Identification Number Search"},{"type":"checkbox","name":"TIN_SORT_YN","defaultValue":false,"label":"Unique ID Sort"}]},"ALLOW_ADDRESS_VALIDATION_BYPASS_OPTION":true,"DEFAULT_ADDRESS_VALIDATION_BYPASS_OPTION_CHECKED":true}).HAS_OKTA_LOGIN) {
	        var showLoginButton = !props.checkingAuthState && !props.loggedIn && !props.siteOffline;
	        return _react2.default.createElement(Okta, {
	          ref: function ref(_ref) {
	            _this.okta = _ref;
	          },
	          showLoginButton: showLoginButton
	        });
	      } else return null;
	    };
	
	    _this.renderAuth = function (props) {
	      if (props.checkingAuthState) {
	        return _react2.default.createElement(_Loaders.Spinner, { className: 'loader', size: 'small' });
	      } else if (props.siteOffline) {
	        return null;
	      } else if (props.loggedIn) {
	        return _react2.default.createElement(
	          'button',
	          {
	            'aria-haspopup': 'true',
	            className: 'user', onClick: _this.openMenu },
	          _react2.default.createElement(
	            'span',
	            { className: 'name' },
	            props.user.businessName || (props.user.firstName || '') + ' ' + (props.user.lastName || '')
	          ),
	          _react2.default.createElement(
	            'span',
	            { className: 'username' },
	            props.user.username
	          ),
	          _react2.default.createElement(
	            'span',
	            { className: 'visually-hidden' },
	            'Click to edit settings and logout'
	          )
	        );
	      } else if (!props.isOnAuthRoute && !({"NODE_ENV":"production","BUILD_DATE":"2025-08-27T15:15:31.687Z","BUILD_NUMBER":"Not Provided","GIT_VERSION":"v1.3.0-381-ga81e29b08","GIT_COMMIT_HASH":"a81e29b085c9268ffd96c78eb734365802722741","GIT_BRANCH":"beta","PUBLIC_URL":"","STATE_ABBR":"MT","STATE_NAME":"Montana","STATE_ORG_TITLE":"Secretary of State","LOGIN_HEADER_IMG_PATH":"","HOME_IMG_FILENAME":"montana.jpg","FAVICON_FILE_NAME":"favicon.ico","ALLOW_E_SIGN_ON_CORRECTIONS":true,"THIRD_PARTY_SIGNING_ALLOWED":false,"MY_ACCOUNT_SAVE_AND_CLOSE_BUTTON":true,"IE_DEPRECATED_MESSAGE":"Internet Explorer is not supported. Please select a supported browser below to access this website.","ADDITIONAL_ROUTES":{"dataRequests":true,"farmBill":true,"apostille":true,"externalHelp":"https://sosmt.gov/business/help-center/","systemAdministration":[{"title":"Saved Payments","parameter":"saved-payments","componentName":"SavedPayments"}]},"SUBROUTES":[{"label":"Business","component":"Business","parameter":"business","myWorkQueueSearch":false,"sourceTypeId":54,"searchMustHaveOneOf":["FILING_TYPE_ID","STATUS_ID","STATE","search"],"serverWebSearchDescription":true,"serverWorkQueueDescription":true,"serverMyRecordsDescription":true,"searchPlaceholder":"Search by name or filing number (X########)","allowEmptySearchTerm":true,"requestCertificateAlternateLabel":"Request Information","fileAmendmentButtonLabel":"Filing Actions","advancedSearchParameters":[{"type":"radio","name":"QUERY_TYPE_ID","defaultValue":1010,"options":[{"value":1010,"label":"Starts with"},{"value":1011,"label":"Contains"},{"value":1012,"label":" Word Contains"}]},{"type":"serverSelect","name":"FILING_TYPE_ID","optionsSrc":"FILING_TYPES","label":"Entity Type","placeholder":"All","defaultValue":"0"},{"type":"serverSelect","name":"FILING_SUBTYPE_ID","optionsSrc":"FILING_SUBTYPES","label":"Entity Subtype","overrideSubOptionsSrcFromParameterName":"FILING_TYPE_ID","placeholder":"All","defaultValue":"0"},{"type":"serverSelect","name":"STATUS_ID","optionsSrc":"FILING_STATUS_WITHOUT_ALL","label":"Status","placeholder":"All","defaultValue":"0"},{"type":"serverSelect","name":"STATE","optionsSrc":"STATE","label":"State","placeholder":"All","defaultValue":""},{"type":"serverSelect","name":"COUNTY","optionsSrc":"COUNTY_SUBOPTION","label":"County","overrideSubOptionsSrcFromParameterName":"STATE","placeholder":"All","defaultValue":""},{"type":"checkbox","name":"CRA_SEARCH_YN","defaultValue":false,"label":"Search by Registered Agent PID"},{"type":"dateRange","name":"FILING_DATE","label":"Registration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}},{"type":"dateRange","name":"EXPIRATION_DATE","label":"Expiration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}}],"myRecordsFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Active"},{"value":2,"label":"Inactive"},{"value":3,"label":"Pending"}]},{"type":"dateRange","name":"DATE_RANGE","label":"Date range","defaultValue":{"start":null,"end":null}}],"myWorkQueueFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Approved"},{"value":2,"label":"Pending Online Payment"},{"value":3,"label":"Pending Review"},{"value":4,"label":"Needs Correction"},{"value":5,"label":"Rejected"},{"value":6,"label":"Draft"}]},{"type":"dateRange","name":"DATE_RANGE","label":"Date range","defaultValue":{"start":null,"end":null}}]},{"label":"Notary","component":"Notary","parameter":"notary","sourceTypeId":850,"myWorkQueueSearch":false,"allowEmptySearchTerm":true,"requestCertificateAlternateLabel":"Download Certificate","fileAmendmentButtonLabel":"Filing Actions","hideNameRequestCertificate":true,"hideAddressRequestCertificate":true,"hideRecordUserManagment":true,"searchPlaceholder":"Search by name or commission number","searchMustHaveOneOf":["CITY","search","SERVICE_TYPE"],"advancedParametersStartOpen":true,"searchIsSortable":true,"advancedSearchParameters":[{"type":"radio","name":"STARTS_WITH_YN","defaultValue":false,"options":[{"value":true,"label":"Starts with"},{"value":false,"label":"Contains"}]},{"type":"checkbox","name":"ACTIVE_ONLY_YN","defaultValue":true,"label":"Active entities only"},{"type":"text","name":"CITY","defaultValue":"","label":"City"},{"type":"select","name":"SERVICE_TYPE","label":"Special Services Offered","defaultValue":0,"options":[{"value":0,"label":"(N/A)"},{"value":6165,"label":"In-Person Electronic Notarization (IPEN)"},{"value":6166,"label":"Remote Online Notarization (RON)"},{"value":6167,"label":"Mobile Notary Services"},{"value":6168,"label":"Remote Ink Notarization (RIN)"}]}]},{"label":"Apostille","component":"Apostille","parameter":"apostille","sourceTypeId":720,"myRecordsSearch":false,"myWorkQueueSearch":false,"disabled":false,"allowedRoutes":["/forms-manager/","/queue/","/forms/"]},{"label":"Liens","component":"UCC","parameter":"ucc","sourceTypeId":1999,"myRecordsSearch":true,"myWorkQueueSearch":true,"fileAmendmentButtonLabel":"Filing Actions","searchPlaceholder":"Search by name or file number","disabled":false,"serverWebSearchDescription":true,"myRecordsDescription":"","workQueueDescription":"","searchDescription":"","hideRecordUserManagment":true,"searchLiensCheckout":false,"advancedSearchParameters":[{"type":"radio","name":"STARTS_WITH_YN","defaultValue":false,"options":[{"value":true,"label":"Starts with"},{"value":false,"label":"Contains"}]},{"type":"select","name":"STATUS","defaultValue":"ALL","label":"Status","options":[{"value":"ACTIVE_UNLAPSED","label":"Active (unlapsed)"},{"value":"ACTIVE_LAPSED_UNLAPSED","label":"Active (lapsed and unlapsed)"}]},{"type":"text","name":"EXCLUDE_VALUES","label":"Exclude Debtor Names (comma separated list of names to exclude)","defaultValue":""},{"type":"dateRange","name":"FILING_DATE","label":"Financing Statement Date","defaultValue":{"start":null,"end":null}},{"type":"dateRange","name":"LAPSE_DATE","label":"Lapse Date","defaultValue":{"start":null,"end":null}},{"type":"text","name":"CITY","label":"Debtor City","defaultValue":""}],"myRecordsFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Approved"},{"value":2,"label":"Pending Online Payment"},{"value":3,"label":"Pending Review"}]},{"type":"select","name":"TYPE","defaultValue":0,"label":"Lien Type","options":[{"value":0,"label":"All"},{"value":1,"label":"UCC"},{"value":2,"label":"EFS"},{"value":3,"label":"Title 71"}]}],"myWorkQueueFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Approved"},{"value":2,"label":"Pending Online Payment"},{"value":3,"label":"Pending Review"},{"value":4,"label":"Pending Print and Mail"},{"value":5,"label":"Rejected"},{"value":6,"label":"Draft"}]},{"type":"select","name":"TYPE","defaultValue":0,"label":"Lien Type","options":[{"value":0,"label":"All"},{"value":1,"label":"UCC"},{"value":2,"label":"EFS"},{"value":3,"label":"Title 71"}]}]},{"label":"Copy Request","component":"copies","parameter":"copies","sourceTypeId":2001,"myRecordsSearch":false,"myWorkQueueSearch":false,"disabled":false,"allowedRoutes":["/forms-manager/","/queue/","/forms/"]},{"label":"Trademark","component":"Trademark","parameter":"trademark","sourceTypeId":810,"showRequestCertificate":true,"searchMustHaveOneOf":["search","EXPIRATION_DATE","FILING_DATE"],"allowEmptySearchTerm":true,"requestCertificateAlternateLabel":"Request Information","fileAmendmentButtonLabel":"Filing Actions","advancedSearchParameters":[{"type":"radio","name":"QUERY_TYPE_ID","defaultValue":1010,"options":[{"value":1010,"label":"Starts with"},{"value":1011,"label":"Contains"},{"value":1012,"label":" Word Contains"}]},{"type":"checkbox","name":"OWNER_SEARCH_YN","defaultValue":false,"label":"Search owners"},{"type":"radio","name":"SERVICE_MARK_YN","label":"Mark Type","defaultValue":"","options":[{"value":"","label":"All Marks"},{"value":"Y","label":"Service Mark"},{"value":"N","label":"Trademark"}]},{"type":"serverSelect","name":"STATUS_ID","optionsSrc":"TYPE_V|TRADEMARK_STATUS_TYPE","label":"Status","placeholder":"All","defaultValue":"0"},{"type":"select","name":"DESIGN_TYPE_ID","options":[{"value":0,"label":"All"},{"value":990,"label":"Words Only"},{"value":991,"label":"Design Only"},{"value":992,"label":"Words and Design"}],"label":"Design Type","defaultValue":"0"},{"type":"dateRange","name":"FILING_DATE","label":"Registered Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}},{"type":"dateRange","name":"EXPIRATION_DATE","label":"Expiration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}}]},{"label":"Business Info Request","component":"InfoRequests","parameter":"info-request","sourceTypeId":167,"allowedRoutes":["/forms-manager/","/queue/","/forms/"]},{"label":"Data Requests","component":"DataRequests","parameter":"data-request","sourceTypeId":0,"allowedRoutes":["/forms-manager/"]},{"label":"CRA","component":"CRA","parameter":"cra","sourceTypeId":157,"myRecordsSearch":false,"searchPlaceholder":"Search by name or registered agent number","allowedRoutes":["/forms-manager/","/forms/","/records/","/queue/","/search/"],"allowEmptySearchTerm":true,"fileAmendmentButtonLabel":"Filing Actions","advancedSearchParameters":[{"type":"radio","name":"QUERY_TYPE_ID","defaultValue":1010,"options":[{"value":1010,"label":"Starts with"},{"value":1011,"label":"Contains"},{"value":1012,"label":" Word Contains"}]},{"type":"dateRange","name":"CRA_DATE","label":"Registration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}},{"type":"select","name":"STATUS_ID","label":"Status","defaultValue":0,"options":[{"value":0,"label":"All"},{"value":121,"label":"Active"},{"value":122,"label":"Inactive"}]},{"type":"select","name":"AGENT_TYPE_ID","label":"Agent Type","defaultValue":0,"options":[{"value":0,"label":"All"},{"value":460,"label":"Registered Agent"},{"value":461,"label":"Commercial Registered Agent"}]}]},{"label":"Farm Bill","component":"FarmBill","parameter":"farm-bill","path":"/lists/farm-bill","sourceTypeId":0,"myRecordsSearch":false,"allowedRules":["/search/"],"disabled":true,"searchDescription":"To perform a search, enter a debtor name. Your search results may include: exact debtor name, variations of that name and any filing that includes your search criteria. Punctuation is ignored.\n\nYou can click on \"Advanced\" to refine your search. Under “Advanced” you can search by crop, year, county and SSN/FEIN. As a registered Farm Bill Buyer with the Montana Secretary of State’s office it is important to maintain the confidentiality of the information contained within the Farm Bill Master List. The Farm Bill Master List reflects personal data, such as Social Security Numbers, which are a key piece of personal identifiable information to assist you in determining the existence of a lien against a specific debtor. The distribution of this information beyond its intended purpose is strictly prohibited.\n\nThe debtor's tax identification number has been hidden for confidentiality reasons. You may continue to search on a tax ID number and return debtors that match your search criteria. The SSN/FEIN must be entered without dashes or spaces.","searchMustHaveOneOf":["search","UCC_FARM_PRODUCT_ID","COUNTY"],"searchPlaceholder":"Search by debtor name","advancedSearchParameters":[{"type":"ServerMultiComplete","label":"Product code name(s)","name":"UCC_FARM_PRODUCT_ID","defaultValue":"","optionsSrc":"UCC_FARM_PRODUCT_V"},{"type":"MultiComplete","label":"Year or Range of Years","name":"YEAR_NUM","optionsSrc":"years","startYear":"1968","defaultValue":[],"preMergeOptions":[{"value":"ALL","label":"All"}]},{"type":"serverSelect","label":"State","name":"STATE","defaultValue":"MONTANA","optionsSrc":"STATE"},{"type":"ServerMultiComplete","label":"County","name":"COUNTY","defaultValue":[],"optionsSrc":"COUNTY","overrideSubOptionsSrcFromParameterName":"STATE"},{"type":"checkbox","name":"TIN_SEARCH_YN","defaultValue":false,"label":"Tax Identification Number Search"},{"type":"checkbox","name":"TIN_SORT_YN","defaultValue":false,"label":"Unique ID Sort"}]}],"SYSTEM_NICKNAME":"Online Services Portal","PAYMENT_METHODS":[{"type":"bypass"},{"type":"iTransact"}],"PAYMENT_ALLOW_AMEX":true,"SYSTEM_ID_LABEL":"System Id","DOUBLE_COLUMN_PUBLIC_LOGIN":true,"INTERNAL_USER_MANAGEMENT":true,"ALLOW_PUBLIC_JSON_IMPORT":false,"MAX_FILE_UPLOAD_SIZE":10000000,"REFUND_TEXT":"","RETURN_TO_HOME_ON_LOGOUT":true,"CURRENT_SOS_NAME":"Christi Jacobsen","LOGO_FILENAME":"mt-sos-logo.png","LOGO_ALT":"Christi Jacobsen, Montana Secretary of State","LOGO_FULL_WIDTH":true,"HOME_HIDE_AUTH_HINT":true,"HOME_TITLE":"Montana Secretary of State","CUSTOM_TAB_TITLE":"Official Montana","HOME_SUBTITLE":"Online Business Services","ENTITY_NAME_CONSENT_DESCRIPTION":"","ALLOW_USER_PROFILE_EDITING":true,"COMPARE_FOREIGN_NAME_IN_ENTITY_NAME_VALIDATION":true,"FOREIGN_NAME_FIELD_NAME":"KIMA_PARENT_NAME_INFO","LOGIN_TITLE":"Montana Secretary of State Online Filing Portal Login","PUBLIC_LOGIN_LABEL":"Username","REVERSE_LOGIN_COLUMNS":true,"LOGIN_SEAL_FILENAME":"seal_white.png","SEPARATE_USERNAME_AND_EMAIL":true,"CREATE_ACCOUNT_BUTTON_ALIGN_LEFT":true,"CREATE_ACCOUNT_BUTTON_TEXT":"CREATE AN ACCOUNT","PASSWORD_CUSTOM_ERROR_TEXT":"The password must meet all requirements","ACCOUNT_CREATED_MESSAGE":"Please check your email to verify your account to login and allow a few minutes for this message to arrive. Check your junk/spam folders if you do not find the email in your inbox.","PUBLIC_LOGIN_PLACEHOLDER":" ","DISABLE_DEFAULT_PAYMENT_RADIO":true,"CUSTOM_RESET_PASSWORD_ERROR_MESSAGE":"Username invalid - no account found","PUBLIC_LOGIN_CREATE_DESCRIPTION":"### Existing User:\n\n  - Enter your username and password to login.  \n\n\n  #### - OR -  \n\n\n\n  - Forgot password? Click 'Reset Password' and follow the prompts.\n  - Forgot username? Click 'Forgot Username' and follow the prompts.  \n\n\n  ### New User:\n  ","LOGIN_HELP_LINK":"https://sosmt.gov/business/how-do-i/","LOGIN_HELP_LINK_TEXT":"Need Help?","FORGOT_USERNAME_TEXT":"Forgot Username?","LOGIN_ACTIVE_DIRECTORY_TEXT":"State User Login","MULTIPLE_LOGIN_METHODS":true,"HAS_ACTIVE_DIRECTORY_LOGIN":true,"RESET_PASSWORD_WITH_USERNAME":true,"DOWNLOAD_LINK":true,"SHOW_USERNAME_ACCOUNT_CREATE":true,"SHOW_SCROLL_DOWN_ARROW":true,"SHOW_ADDRESS_ACCOUNT_CREATE":true,"TWO_COLUMN_ACCOUNT_CREATE":true,"RESET_PASSWORD_TIP":"A link to change your password has been sent to your email. Please allow a few minutes for this message to arrive. Please check your junk/spam folders if you do not find the email in your inbox.","FORGOT_PASSWORD_LINK_TEXT":"Reset Password","PHONE_NUMBER_OPTIONAL_ACCOUNT_CREATE":true,"SHOW_REQUIRED_INDICATOR_ACCOUNT_CREATE":true,"PASSWORD_REQUIREMENTS_ACCOUNT_CREATE":"\n    <ul>\n      <li>MUST contain at least 8 characters (12+ recommended)</li>\n      <li>MUST contain at least one uppercase letter.</li>\n      <li>MUST contain at least one lowercase letter.</li>\n      <li>MUST contain at least one number.</li>\n      <li>MUST contain at least one special character (!”#$%&'()*+,-./:;<=>?</li>\n    </ul>\n  ","ALLOW_CERTIFICATION_REQUEST":true,"ALLOW_PUBLIC_CERTIFICATE_REQUEST":true,"ALLOW_COPY_REQUEST":false,"ALLOW_CORRECTION_STYLING":true,"HIDE_DEPRECATION_WARNING":false,"AMEND_ROUTE_PUBLIC":true,"SEAL_FILENAME":"seal.png","SHOPPING_CART":true,"ALLOW_PAYMENT_UPDATE_WITH_EMPTY_CART":true,"RA_EMAIL":true,"RA_WEBSITE":true,"RA_NO_DEFAULT_TYPE":true,"RA_ADDRESS_LABEL":"Street Address","RA_TYPE_SELECTION_DEFAULT":true,"RA_DEFAULT_TYPE":"460","RA_OVERRIDE_TYPE_WITH_DEFAULT":true,"RA_PRINCIPAL_ADDRESS_AMS":true,"UPLOAD_AND_SUBMIT_HIDE_IF_ONE_OPTION":true,"PAYMENT_PROCESSING_MESSAGE":"Your payment is processing - Do not close your browser or click the back button","CHECKOUT_BUTTON_WHEN_PROCESSING_TEXT":"Processing","EFS_CROP_PICKER_NONE_LABEL":"Lien Duration","DISALLOWED_WIZARD_PIECES":["FormationLocale"],"REPEATER_SHOW_EDIT_BUTTON":true,"DATA_REQUEST_PAGE_TITLE":"Data Requests and Subscriptions","DATA_REQUEST_SIDEBAR_LABEL":"Data Requests & Subscriptions","LOGIN_REDIRECTS_TO_EPASS":false,"LOGIN_REDIRECTS_TO_ACTIVE_DIRECTORY":true,"LOGIN_ACTIVE_DIRECTORY_LINK":true,"FETCH_EDIT_USER_LINK":false,"LISTS_FETCH_AVAILABLE_LISTS":true,"POST_WIZARD_SUBMIT_REDIRECT_URL":"/","PIN_REQUEST_ATTESTATIONS":true,"PIN_REQUEST_DESCRIPTION":"Click **Request PIN** to have a new PIN sent to the account holder's email address on file.","OWNERSHIP_REQUEST_DESCRIPTION":"To become an **authorized user** of this record, a current **AUTHORIZED USER** will need to grant you access. To request access, click **Request Access** below.","PIN_REQUEST_SUCCESS_MESSAGE":"The PIN you have requested for this entity has been sent to the email associated with your user account.  You should receive the PIN in approximately 3-5 minutes, depending on your email service provider.","APOSTILLE_HEADER_LABEL":"Verification Information","APOSTILLE_NUMBER_LABEL":"Apostille/Authentication","APOSTILLE_CITY_STATE_OVERRIDE":"HELENA, MT","APOSTILLE_FILING_DATE_LABEL":"Issue Date","APOSTILLE_CITY_STATE_IN_CERTIFIED":true,"NOTARY_EXISTING_FILING":true,"ALLOW_REVOKE_OWN_ACCESS_ONLY":false,"HIDE_CANCEL_ON_ONETIME_DATA_REQUESTS":true,"DATA_REQUESTS_IN_SHOPPING_CART":true,"WQ_ALLOW_EDIT_PENDING_PAYMENT":true,"WQ_CONFIRM_ON_DELETE":true,"WQ_DELETE_CONFIRM_MESSAGE":"Deleting this filing will forfeit any money already paid to the Secretary of State. This action is permanent and cannot be undone, are you sure you would like to delete?","PASS_ITEM_GUIDS_ON_CHECKOUT":true,"FORM_REVISION_HISTORY":true,"CHECKOUT_DISCLAIMER":"By entering your credit card and/or checking account information you (i) state that **you are an authorized user** of the credit card and/or electronic check and that the associated information entered (e.g., account holder name, account number, billing address) is accurate, (ii) **you authorize payment processor to charge the amount you have requested** to your credit card and/or funding account, and (iii) **acknowledge if a charge is declined or reversed you may also be assessed a customary charge** by the payment processor for such transactions.","FARM_BILL_SEARCH_CONFIDENTIAL":"As a registered Farm Bill Buyer with the Montana Secretary of State’s office it is important to maintain the confidentiality of the information contained within the Farm Bill Master List. The Farm Bill Master List reflects personal data, such as Social Security Numbers, which are a key piece of personal identifiable information to assist you in determining the existence of a lien against a specific debtor. The distribution of this information beyond its intended purpose is strictly prohibited.\n\n**The debtor's tax identification number has been hidden for confidentiality reasons. You may continue to search on a tax ID number and return debtors that match your search criteria. The SSN/FEIN must be entered without dashes or spaces.  If you need access to the tax identification number to clearly identify the debtor, please contact the UCC unit at (406) 444-3665.**","VIEW_HISTORY_BUTTON_ALT_TEXT":"View Filings","WIZARD_ERROR_TITLE_MESSAGE":"Form Error","FARM_BILL_SEARCH_INTERACTIVE":true,"USE_FARM_BILL_API":true,"DISALLOW_ASSIGN_SELF_AS_RA":true,"DISALLOW_ASSIGN_SELF_AS_PRINCIPAL":true,"USE_TRADEMARK_OWNER_VALIDATION":true,"USE_ALTERNATIVE_FOREIGN_ADDRESS_LABELS":true,"MY_RECEIPTS_FILTER":[{"type":"dateRange","name":"DATE_RANGE","label":"Date range","defaultValue":{"start":null,"end":null}},{"type":"text","name":"REF_NUM","defaultValue":"","label":"Reference Number"},{"type":"text","name":"RECEIPT_NUM","defaultValue":"","label":"Receipt Id"},{"type":"text","name":"AMOUNT","defaultValue":"","label":"Amount"},{"type":"select","name":"TYPE","defaultValue":"","label":"Payment Type","options":[{"value":"","label":"All"},{"value":"CC","label":"Credit Card"},{"value":"Check","label":"Check"}]}],"MY_RECEIPTS_SHOW_IN_SIDEBAR":true,"SHOW_MY_RECEIPTS_HELPER_TEXT":true,"MY_RECEIPTS_HELPER_LABEL":"About Receipt Search","MY_RECEIPTS_HELPER_TEXT":"You can search for receipts based on their descriptions, including the items paid for on the receipt. Use the filters to search for or filter specific information.","FARM_BILL_SUBLINK":{"label":"Farm Bill","component":"FarmBill","parameter":"farm-bill","path":"/lists/farm-bill","sourceTypeId":0,"myRecordsSearch":false,"allowedRules":["/search/"],"disabled":true,"searchDescription":"To perform a search, enter a debtor name. Your search results may include: exact debtor name, variations of that name and any filing that includes your search criteria. Punctuation is ignored.\n\nYou can click on \"Advanced\" to refine your search. Under “Advanced” you can search by crop, year, county and SSN/FEIN. As a registered Farm Bill Buyer with the Montana Secretary of State’s office it is important to maintain the confidentiality of the information contained within the Farm Bill Master List. The Farm Bill Master List reflects personal data, such as Social Security Numbers, which are a key piece of personal identifiable information to assist you in determining the existence of a lien against a specific debtor. The distribution of this information beyond its intended purpose is strictly prohibited.\n\nThe debtor's tax identification number has been hidden for confidentiality reasons. You may continue to search on a tax ID number and return debtors that match your search criteria. The SSN/FEIN must be entered without dashes or spaces.","searchMustHaveOneOf":["search","UCC_FARM_PRODUCT_ID","COUNTY"],"searchPlaceholder":"Search by debtor name","advancedSearchParameters":[{"type":"ServerMultiComplete","label":"Product code name(s)","name":"UCC_FARM_PRODUCT_ID","defaultValue":"","optionsSrc":"UCC_FARM_PRODUCT_V"},{"type":"MultiComplete","label":"Year or Range of Years","name":"YEAR_NUM","optionsSrc":"years","startYear":"1968","defaultValue":[],"preMergeOptions":[{"value":"ALL","label":"All"}]},{"type":"serverSelect","label":"State","name":"STATE","defaultValue":"MONTANA","optionsSrc":"STATE"},{"type":"ServerMultiComplete","label":"County","name":"COUNTY","defaultValue":[],"optionsSrc":"COUNTY","overrideSubOptionsSrcFromParameterName":"STATE"},{"type":"checkbox","name":"TIN_SEARCH_YN","defaultValue":false,"label":"Tax Identification Number Search"},{"type":"checkbox","name":"TIN_SORT_YN","defaultValue":false,"label":"Unique ID Sort"}]},"ALLOW_ADDRESS_VALIDATION_BYPASS_OPTION":true,"DEFAULT_ADDRESS_VALIDATION_BYPASS_OPTION_CHECKED":true}).HAS_OKTA_LOGIN) {
	        return _react2.default.createElement(
	          'button',
	          { className: 'btn btn-default login-link', onClick: _this.toggleLoginModal },
	          'Login'
	        );
	      } else return null;
	    };
	
	    _this.state = {
	      alignTo: null,
	      menuOpen: false,
	      editingUserAccount: false
	    };
	    _this.modalref = _react2.default.createRef();
	    return _this;
	  }
	
	  _createClass(Auth, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          showLogin = _props.showLogin,
	          loggedIn = _props.loggedIn,
	          location = _props.location,
	          editUserExternalUrl = _props.editUserExternalUrl;
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'auth' },
	        this.renderAuth(this.props),
	        this.mountOkta(this.props),
	        this.state.menuOpen ? _react2.default.createElement(_FloatingMenu2.default, {
	          options: [{ label: 'Logout', onClick: this.logout }].concat(_toConsumableArray(ALLOW_USER_PROFILE_EDITING ? [{
	            label: ({"NODE_ENV":"production","BUILD_DATE":"2025-08-27T15:15:31.687Z","BUILD_NUMBER":"Not Provided","GIT_VERSION":"v1.3.0-381-ga81e29b08","GIT_COMMIT_HASH":"a81e29b085c9268ffd96c78eb734365802722741","GIT_BRANCH":"beta","PUBLIC_URL":"","STATE_ABBR":"MT","STATE_NAME":"Montana","STATE_ORG_TITLE":"Secretary of State","LOGIN_HEADER_IMG_PATH":"","HOME_IMG_FILENAME":"montana.jpg","FAVICON_FILE_NAME":"favicon.ico","ALLOW_E_SIGN_ON_CORRECTIONS":true,"THIRD_PARTY_SIGNING_ALLOWED":false,"MY_ACCOUNT_SAVE_AND_CLOSE_BUTTON":true,"IE_DEPRECATED_MESSAGE":"Internet Explorer is not supported. Please select a supported browser below to access this website.","ADDITIONAL_ROUTES":{"dataRequests":true,"farmBill":true,"apostille":true,"externalHelp":"https://sosmt.gov/business/help-center/","systemAdministration":[{"title":"Saved Payments","parameter":"saved-payments","componentName":"SavedPayments"}]},"SUBROUTES":[{"label":"Business","component":"Business","parameter":"business","myWorkQueueSearch":false,"sourceTypeId":54,"searchMustHaveOneOf":["FILING_TYPE_ID","STATUS_ID","STATE","search"],"serverWebSearchDescription":true,"serverWorkQueueDescription":true,"serverMyRecordsDescription":true,"searchPlaceholder":"Search by name or filing number (X########)","allowEmptySearchTerm":true,"requestCertificateAlternateLabel":"Request Information","fileAmendmentButtonLabel":"Filing Actions","advancedSearchParameters":[{"type":"radio","name":"QUERY_TYPE_ID","defaultValue":1010,"options":[{"value":1010,"label":"Starts with"},{"value":1011,"label":"Contains"},{"value":1012,"label":" Word Contains"}]},{"type":"serverSelect","name":"FILING_TYPE_ID","optionsSrc":"FILING_TYPES","label":"Entity Type","placeholder":"All","defaultValue":"0"},{"type":"serverSelect","name":"FILING_SUBTYPE_ID","optionsSrc":"FILING_SUBTYPES","label":"Entity Subtype","overrideSubOptionsSrcFromParameterName":"FILING_TYPE_ID","placeholder":"All","defaultValue":"0"},{"type":"serverSelect","name":"STATUS_ID","optionsSrc":"FILING_STATUS_WITHOUT_ALL","label":"Status","placeholder":"All","defaultValue":"0"},{"type":"serverSelect","name":"STATE","optionsSrc":"STATE","label":"State","placeholder":"All","defaultValue":""},{"type":"serverSelect","name":"COUNTY","optionsSrc":"COUNTY_SUBOPTION","label":"County","overrideSubOptionsSrcFromParameterName":"STATE","placeholder":"All","defaultValue":""},{"type":"checkbox","name":"CRA_SEARCH_YN","defaultValue":false,"label":"Search by Registered Agent PID"},{"type":"dateRange","name":"FILING_DATE","label":"Registration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}},{"type":"dateRange","name":"EXPIRATION_DATE","label":"Expiration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}}],"myRecordsFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Active"},{"value":2,"label":"Inactive"},{"value":3,"label":"Pending"}]},{"type":"dateRange","name":"DATE_RANGE","label":"Date range","defaultValue":{"start":null,"end":null}}],"myWorkQueueFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Approved"},{"value":2,"label":"Pending Online Payment"},{"value":3,"label":"Pending Review"},{"value":4,"label":"Needs Correction"},{"value":5,"label":"Rejected"},{"value":6,"label":"Draft"}]},{"type":"dateRange","name":"DATE_RANGE","label":"Date range","defaultValue":{"start":null,"end":null}}]},{"label":"Notary","component":"Notary","parameter":"notary","sourceTypeId":850,"myWorkQueueSearch":false,"allowEmptySearchTerm":true,"requestCertificateAlternateLabel":"Download Certificate","fileAmendmentButtonLabel":"Filing Actions","hideNameRequestCertificate":true,"hideAddressRequestCertificate":true,"hideRecordUserManagment":true,"searchPlaceholder":"Search by name or commission number","searchMustHaveOneOf":["CITY","search","SERVICE_TYPE"],"advancedParametersStartOpen":true,"searchIsSortable":true,"advancedSearchParameters":[{"type":"radio","name":"STARTS_WITH_YN","defaultValue":false,"options":[{"value":true,"label":"Starts with"},{"value":false,"label":"Contains"}]},{"type":"checkbox","name":"ACTIVE_ONLY_YN","defaultValue":true,"label":"Active entities only"},{"type":"text","name":"CITY","defaultValue":"","label":"City"},{"type":"select","name":"SERVICE_TYPE","label":"Special Services Offered","defaultValue":0,"options":[{"value":0,"label":"(N/A)"},{"value":6165,"label":"In-Person Electronic Notarization (IPEN)"},{"value":6166,"label":"Remote Online Notarization (RON)"},{"value":6167,"label":"Mobile Notary Services"},{"value":6168,"label":"Remote Ink Notarization (RIN)"}]}]},{"label":"Apostille","component":"Apostille","parameter":"apostille","sourceTypeId":720,"myRecordsSearch":false,"myWorkQueueSearch":false,"disabled":false,"allowedRoutes":["/forms-manager/","/queue/","/forms/"]},{"label":"Liens","component":"UCC","parameter":"ucc","sourceTypeId":1999,"myRecordsSearch":true,"myWorkQueueSearch":true,"fileAmendmentButtonLabel":"Filing Actions","searchPlaceholder":"Search by name or file number","disabled":false,"serverWebSearchDescription":true,"myRecordsDescription":"","workQueueDescription":"","searchDescription":"","hideRecordUserManagment":true,"searchLiensCheckout":false,"advancedSearchParameters":[{"type":"radio","name":"STARTS_WITH_YN","defaultValue":false,"options":[{"value":true,"label":"Starts with"},{"value":false,"label":"Contains"}]},{"type":"select","name":"STATUS","defaultValue":"ALL","label":"Status","options":[{"value":"ACTIVE_UNLAPSED","label":"Active (unlapsed)"},{"value":"ACTIVE_LAPSED_UNLAPSED","label":"Active (lapsed and unlapsed)"}]},{"type":"text","name":"EXCLUDE_VALUES","label":"Exclude Debtor Names (comma separated list of names to exclude)","defaultValue":""},{"type":"dateRange","name":"FILING_DATE","label":"Financing Statement Date","defaultValue":{"start":null,"end":null}},{"type":"dateRange","name":"LAPSE_DATE","label":"Lapse Date","defaultValue":{"start":null,"end":null}},{"type":"text","name":"CITY","label":"Debtor City","defaultValue":""}],"myRecordsFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Approved"},{"value":2,"label":"Pending Online Payment"},{"value":3,"label":"Pending Review"}]},{"type":"select","name":"TYPE","defaultValue":0,"label":"Lien Type","options":[{"value":0,"label":"All"},{"value":1,"label":"UCC"},{"value":2,"label":"EFS"},{"value":3,"label":"Title 71"}]}],"myWorkQueueFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Approved"},{"value":2,"label":"Pending Online Payment"},{"value":3,"label":"Pending Review"},{"value":4,"label":"Pending Print and Mail"},{"value":5,"label":"Rejected"},{"value":6,"label":"Draft"}]},{"type":"select","name":"TYPE","defaultValue":0,"label":"Lien Type","options":[{"value":0,"label":"All"},{"value":1,"label":"UCC"},{"value":2,"label":"EFS"},{"value":3,"label":"Title 71"}]}]},{"label":"Copy Request","component":"copies","parameter":"copies","sourceTypeId":2001,"myRecordsSearch":false,"myWorkQueueSearch":false,"disabled":false,"allowedRoutes":["/forms-manager/","/queue/","/forms/"]},{"label":"Trademark","component":"Trademark","parameter":"trademark","sourceTypeId":810,"showRequestCertificate":true,"searchMustHaveOneOf":["search","EXPIRATION_DATE","FILING_DATE"],"allowEmptySearchTerm":true,"requestCertificateAlternateLabel":"Request Information","fileAmendmentButtonLabel":"Filing Actions","advancedSearchParameters":[{"type":"radio","name":"QUERY_TYPE_ID","defaultValue":1010,"options":[{"value":1010,"label":"Starts with"},{"value":1011,"label":"Contains"},{"value":1012,"label":" Word Contains"}]},{"type":"checkbox","name":"OWNER_SEARCH_YN","defaultValue":false,"label":"Search owners"},{"type":"radio","name":"SERVICE_MARK_YN","label":"Mark Type","defaultValue":"","options":[{"value":"","label":"All Marks"},{"value":"Y","label":"Service Mark"},{"value":"N","label":"Trademark"}]},{"type":"serverSelect","name":"STATUS_ID","optionsSrc":"TYPE_V|TRADEMARK_STATUS_TYPE","label":"Status","placeholder":"All","defaultValue":"0"},{"type":"select","name":"DESIGN_TYPE_ID","options":[{"value":0,"label":"All"},{"value":990,"label":"Words Only"},{"value":991,"label":"Design Only"},{"value":992,"label":"Words and Design"}],"label":"Design Type","defaultValue":"0"},{"type":"dateRange","name":"FILING_DATE","label":"Registered Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}},{"type":"dateRange","name":"EXPIRATION_DATE","label":"Expiration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}}]},{"label":"Business Info Request","component":"InfoRequests","parameter":"info-request","sourceTypeId":167,"allowedRoutes":["/forms-manager/","/queue/","/forms/"]},{"label":"Data Requests","component":"DataRequests","parameter":"data-request","sourceTypeId":0,"allowedRoutes":["/forms-manager/"]},{"label":"CRA","component":"CRA","parameter":"cra","sourceTypeId":157,"myRecordsSearch":false,"searchPlaceholder":"Search by name or registered agent number","allowedRoutes":["/forms-manager/","/forms/","/records/","/queue/","/search/"],"allowEmptySearchTerm":true,"fileAmendmentButtonLabel":"Filing Actions","advancedSearchParameters":[{"type":"radio","name":"QUERY_TYPE_ID","defaultValue":1010,"options":[{"value":1010,"label":"Starts with"},{"value":1011,"label":"Contains"},{"value":1012,"label":" Word Contains"}]},{"type":"dateRange","name":"CRA_DATE","label":"Registration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}},{"type":"select","name":"STATUS_ID","label":"Status","defaultValue":0,"options":[{"value":0,"label":"All"},{"value":121,"label":"Active"},{"value":122,"label":"Inactive"}]},{"type":"select","name":"AGENT_TYPE_ID","label":"Agent Type","defaultValue":0,"options":[{"value":0,"label":"All"},{"value":460,"label":"Registered Agent"},{"value":461,"label":"Commercial Registered Agent"}]}]},{"label":"Farm Bill","component":"FarmBill","parameter":"farm-bill","path":"/lists/farm-bill","sourceTypeId":0,"myRecordsSearch":false,"allowedRules":["/search/"],"disabled":true,"searchDescription":"To perform a search, enter a debtor name. Your search results may include: exact debtor name, variations of that name and any filing that includes your search criteria. Punctuation is ignored.\n\nYou can click on \"Advanced\" to refine your search. Under “Advanced” you can search by crop, year, county and SSN/FEIN. As a registered Farm Bill Buyer with the Montana Secretary of State’s office it is important to maintain the confidentiality of the information contained within the Farm Bill Master List. The Farm Bill Master List reflects personal data, such as Social Security Numbers, which are a key piece of personal identifiable information to assist you in determining the existence of a lien against a specific debtor. The distribution of this information beyond its intended purpose is strictly prohibited.\n\nThe debtor's tax identification number has been hidden for confidentiality reasons. You may continue to search on a tax ID number and return debtors that match your search criteria. The SSN/FEIN must be entered without dashes or spaces.","searchMustHaveOneOf":["search","UCC_FARM_PRODUCT_ID","COUNTY"],"searchPlaceholder":"Search by debtor name","advancedSearchParameters":[{"type":"ServerMultiComplete","label":"Product code name(s)","name":"UCC_FARM_PRODUCT_ID","defaultValue":"","optionsSrc":"UCC_FARM_PRODUCT_V"},{"type":"MultiComplete","label":"Year or Range of Years","name":"YEAR_NUM","optionsSrc":"years","startYear":"1968","defaultValue":[],"preMergeOptions":[{"value":"ALL","label":"All"}]},{"type":"serverSelect","label":"State","name":"STATE","defaultValue":"MONTANA","optionsSrc":"STATE"},{"type":"ServerMultiComplete","label":"County","name":"COUNTY","defaultValue":[],"optionsSrc":"COUNTY","overrideSubOptionsSrcFromParameterName":"STATE"},{"type":"checkbox","name":"TIN_SEARCH_YN","defaultValue":false,"label":"Tax Identification Number Search"},{"type":"checkbox","name":"TIN_SORT_YN","defaultValue":false,"label":"Unique ID Sort"}]}],"SYSTEM_NICKNAME":"Online Services Portal","PAYMENT_METHODS":[{"type":"bypass"},{"type":"iTransact"}],"PAYMENT_ALLOW_AMEX":true,"SYSTEM_ID_LABEL":"System Id","DOUBLE_COLUMN_PUBLIC_LOGIN":true,"INTERNAL_USER_MANAGEMENT":true,"ALLOW_PUBLIC_JSON_IMPORT":false,"MAX_FILE_UPLOAD_SIZE":10000000,"REFUND_TEXT":"","RETURN_TO_HOME_ON_LOGOUT":true,"CURRENT_SOS_NAME":"Christi Jacobsen","LOGO_FILENAME":"mt-sos-logo.png","LOGO_ALT":"Christi Jacobsen, Montana Secretary of State","LOGO_FULL_WIDTH":true,"HOME_HIDE_AUTH_HINT":true,"HOME_TITLE":"Montana Secretary of State","CUSTOM_TAB_TITLE":"Official Montana","HOME_SUBTITLE":"Online Business Services","ENTITY_NAME_CONSENT_DESCRIPTION":"","ALLOW_USER_PROFILE_EDITING":true,"COMPARE_FOREIGN_NAME_IN_ENTITY_NAME_VALIDATION":true,"FOREIGN_NAME_FIELD_NAME":"KIMA_PARENT_NAME_INFO","LOGIN_TITLE":"Montana Secretary of State Online Filing Portal Login","PUBLIC_LOGIN_LABEL":"Username","REVERSE_LOGIN_COLUMNS":true,"LOGIN_SEAL_FILENAME":"seal_white.png","SEPARATE_USERNAME_AND_EMAIL":true,"CREATE_ACCOUNT_BUTTON_ALIGN_LEFT":true,"CREATE_ACCOUNT_BUTTON_TEXT":"CREATE AN ACCOUNT","PASSWORD_CUSTOM_ERROR_TEXT":"The password must meet all requirements","ACCOUNT_CREATED_MESSAGE":"Please check your email to verify your account to login and allow a few minutes for this message to arrive. Check your junk/spam folders if you do not find the email in your inbox.","PUBLIC_LOGIN_PLACEHOLDER":" ","DISABLE_DEFAULT_PAYMENT_RADIO":true,"CUSTOM_RESET_PASSWORD_ERROR_MESSAGE":"Username invalid - no account found","PUBLIC_LOGIN_CREATE_DESCRIPTION":"### Existing User:\n\n  - Enter your username and password to login.  \n\n\n  #### - OR -  \n\n\n\n  - Forgot password? Click 'Reset Password' and follow the prompts.\n  - Forgot username? Click 'Forgot Username' and follow the prompts.  \n\n\n  ### New User:\n  ","LOGIN_HELP_LINK":"https://sosmt.gov/business/how-do-i/","LOGIN_HELP_LINK_TEXT":"Need Help?","FORGOT_USERNAME_TEXT":"Forgot Username?","LOGIN_ACTIVE_DIRECTORY_TEXT":"State User Login","MULTIPLE_LOGIN_METHODS":true,"HAS_ACTIVE_DIRECTORY_LOGIN":true,"RESET_PASSWORD_WITH_USERNAME":true,"DOWNLOAD_LINK":true,"SHOW_USERNAME_ACCOUNT_CREATE":true,"SHOW_SCROLL_DOWN_ARROW":true,"SHOW_ADDRESS_ACCOUNT_CREATE":true,"TWO_COLUMN_ACCOUNT_CREATE":true,"RESET_PASSWORD_TIP":"A link to change your password has been sent to your email. Please allow a few minutes for this message to arrive. Please check your junk/spam folders if you do not find the email in your inbox.","FORGOT_PASSWORD_LINK_TEXT":"Reset Password","PHONE_NUMBER_OPTIONAL_ACCOUNT_CREATE":true,"SHOW_REQUIRED_INDICATOR_ACCOUNT_CREATE":true,"PASSWORD_REQUIREMENTS_ACCOUNT_CREATE":"\n    <ul>\n      <li>MUST contain at least 8 characters (12+ recommended)</li>\n      <li>MUST contain at least one uppercase letter.</li>\n      <li>MUST contain at least one lowercase letter.</li>\n      <li>MUST contain at least one number.</li>\n      <li>MUST contain at least one special character (!”#$%&'()*+,-./:;<=>?</li>\n    </ul>\n  ","ALLOW_CERTIFICATION_REQUEST":true,"ALLOW_PUBLIC_CERTIFICATE_REQUEST":true,"ALLOW_COPY_REQUEST":false,"ALLOW_CORRECTION_STYLING":true,"HIDE_DEPRECATION_WARNING":false,"AMEND_ROUTE_PUBLIC":true,"SEAL_FILENAME":"seal.png","SHOPPING_CART":true,"ALLOW_PAYMENT_UPDATE_WITH_EMPTY_CART":true,"RA_EMAIL":true,"RA_WEBSITE":true,"RA_NO_DEFAULT_TYPE":true,"RA_ADDRESS_LABEL":"Street Address","RA_TYPE_SELECTION_DEFAULT":true,"RA_DEFAULT_TYPE":"460","RA_OVERRIDE_TYPE_WITH_DEFAULT":true,"RA_PRINCIPAL_ADDRESS_AMS":true,"UPLOAD_AND_SUBMIT_HIDE_IF_ONE_OPTION":true,"PAYMENT_PROCESSING_MESSAGE":"Your payment is processing - Do not close your browser or click the back button","CHECKOUT_BUTTON_WHEN_PROCESSING_TEXT":"Processing","EFS_CROP_PICKER_NONE_LABEL":"Lien Duration","DISALLOWED_WIZARD_PIECES":["FormationLocale"],"REPEATER_SHOW_EDIT_BUTTON":true,"DATA_REQUEST_PAGE_TITLE":"Data Requests and Subscriptions","DATA_REQUEST_SIDEBAR_LABEL":"Data Requests & Subscriptions","LOGIN_REDIRECTS_TO_EPASS":false,"LOGIN_REDIRECTS_TO_ACTIVE_DIRECTORY":true,"LOGIN_ACTIVE_DIRECTORY_LINK":true,"FETCH_EDIT_USER_LINK":false,"LISTS_FETCH_AVAILABLE_LISTS":true,"POST_WIZARD_SUBMIT_REDIRECT_URL":"/","PIN_REQUEST_ATTESTATIONS":true,"PIN_REQUEST_DESCRIPTION":"Click **Request PIN** to have a new PIN sent to the account holder's email address on file.","OWNERSHIP_REQUEST_DESCRIPTION":"To become an **authorized user** of this record, a current **AUTHORIZED USER** will need to grant you access. To request access, click **Request Access** below.","PIN_REQUEST_SUCCESS_MESSAGE":"The PIN you have requested for this entity has been sent to the email associated with your user account.  You should receive the PIN in approximately 3-5 minutes, depending on your email service provider.","APOSTILLE_HEADER_LABEL":"Verification Information","APOSTILLE_NUMBER_LABEL":"Apostille/Authentication","APOSTILLE_CITY_STATE_OVERRIDE":"HELENA, MT","APOSTILLE_FILING_DATE_LABEL":"Issue Date","APOSTILLE_CITY_STATE_IN_CERTIFIED":true,"NOTARY_EXISTING_FILING":true,"ALLOW_REVOKE_OWN_ACCESS_ONLY":false,"HIDE_CANCEL_ON_ONETIME_DATA_REQUESTS":true,"DATA_REQUESTS_IN_SHOPPING_CART":true,"WQ_ALLOW_EDIT_PENDING_PAYMENT":true,"WQ_CONFIRM_ON_DELETE":true,"WQ_DELETE_CONFIRM_MESSAGE":"Deleting this filing will forfeit any money already paid to the Secretary of State. This action is permanent and cannot be undone, are you sure you would like to delete?","PASS_ITEM_GUIDS_ON_CHECKOUT":true,"FORM_REVISION_HISTORY":true,"CHECKOUT_DISCLAIMER":"By entering your credit card and/or checking account information you (i) state that **you are an authorized user** of the credit card and/or electronic check and that the associated information entered (e.g., account holder name, account number, billing address) is accurate, (ii) **you authorize payment processor to charge the amount you have requested** to your credit card and/or funding account, and (iii) **acknowledge if a charge is declined or reversed you may also be assessed a customary charge** by the payment processor for such transactions.","FARM_BILL_SEARCH_CONFIDENTIAL":"As a registered Farm Bill Buyer with the Montana Secretary of State’s office it is important to maintain the confidentiality of the information contained within the Farm Bill Master List. The Farm Bill Master List reflects personal data, such as Social Security Numbers, which are a key piece of personal identifiable information to assist you in determining the existence of a lien against a specific debtor. The distribution of this information beyond its intended purpose is strictly prohibited.\n\n**The debtor's tax identification number has been hidden for confidentiality reasons. You may continue to search on a tax ID number and return debtors that match your search criteria. The SSN/FEIN must be entered without dashes or spaces.  If you need access to the tax identification number to clearly identify the debtor, please contact the UCC unit at (406) 444-3665.**","VIEW_HISTORY_BUTTON_ALT_TEXT":"View Filings","WIZARD_ERROR_TITLE_MESSAGE":"Form Error","FARM_BILL_SEARCH_INTERACTIVE":true,"USE_FARM_BILL_API":true,"DISALLOW_ASSIGN_SELF_AS_RA":true,"DISALLOW_ASSIGN_SELF_AS_PRINCIPAL":true,"USE_TRADEMARK_OWNER_VALIDATION":true,"USE_ALTERNATIVE_FOREIGN_ADDRESS_LABELS":true,"MY_RECEIPTS_FILTER":[{"type":"dateRange","name":"DATE_RANGE","label":"Date range","defaultValue":{"start":null,"end":null}},{"type":"text","name":"REF_NUM","defaultValue":"","label":"Reference Number"},{"type":"text","name":"RECEIPT_NUM","defaultValue":"","label":"Receipt Id"},{"type":"text","name":"AMOUNT","defaultValue":"","label":"Amount"},{"type":"select","name":"TYPE","defaultValue":"","label":"Payment Type","options":[{"value":"","label":"All"},{"value":"CC","label":"Credit Card"},{"value":"Check","label":"Check"}]}],"MY_RECEIPTS_SHOW_IN_SIDEBAR":true,"SHOW_MY_RECEIPTS_HELPER_TEXT":true,"MY_RECEIPTS_HELPER_LABEL":"About Receipt Search","MY_RECEIPTS_HELPER_TEXT":"You can search for receipts based on their descriptions, including the items paid for on the receipt. Use the filters to search for or filter specific information.","FARM_BILL_SUBLINK":{"label":"Farm Bill","component":"FarmBill","parameter":"farm-bill","path":"/lists/farm-bill","sourceTypeId":0,"myRecordsSearch":false,"allowedRules":["/search/"],"disabled":true,"searchDescription":"To perform a search, enter a debtor name. Your search results may include: exact debtor name, variations of that name and any filing that includes your search criteria. Punctuation is ignored.\n\nYou can click on \"Advanced\" to refine your search. Under “Advanced” you can search by crop, year, county and SSN/FEIN. As a registered Farm Bill Buyer with the Montana Secretary of State’s office it is important to maintain the confidentiality of the information contained within the Farm Bill Master List. The Farm Bill Master List reflects personal data, such as Social Security Numbers, which are a key piece of personal identifiable information to assist you in determining the existence of a lien against a specific debtor. The distribution of this information beyond its intended purpose is strictly prohibited.\n\nThe debtor's tax identification number has been hidden for confidentiality reasons. You may continue to search on a tax ID number and return debtors that match your search criteria. The SSN/FEIN must be entered without dashes or spaces.","searchMustHaveOneOf":["search","UCC_FARM_PRODUCT_ID","COUNTY"],"searchPlaceholder":"Search by debtor name","advancedSearchParameters":[{"type":"ServerMultiComplete","label":"Product code name(s)","name":"UCC_FARM_PRODUCT_ID","defaultValue":"","optionsSrc":"UCC_FARM_PRODUCT_V"},{"type":"MultiComplete","label":"Year or Range of Years","name":"YEAR_NUM","optionsSrc":"years","startYear":"1968","defaultValue":[],"preMergeOptions":[{"value":"ALL","label":"All"}]},{"type":"serverSelect","label":"State","name":"STATE","defaultValue":"MONTANA","optionsSrc":"STATE"},{"type":"ServerMultiComplete","label":"County","name":"COUNTY","defaultValue":[],"optionsSrc":"COUNTY","overrideSubOptionsSrcFromParameterName":"STATE"},{"type":"checkbox","name":"TIN_SEARCH_YN","defaultValue":false,"label":"Tax Identification Number Search"},{"type":"checkbox","name":"TIN_SORT_YN","defaultValue":false,"label":"Unique ID Sort"}]},"ALLOW_ADDRESS_VALIDATION_BYPASS_OPTION":true,"DEFAULT_ADDRESS_VALIDATION_BYPASS_OPTION_CHECKED":true}).EDIT_ACCOUNT_LABEL || 'Edit My Account',
	            onClick: this.startProfileEditor
	          }] : []), _toConsumableArray(FETCH_EDIT_USER_LINK ? [{
	            label: ({"NODE_ENV":"production","BUILD_DATE":"2025-08-27T15:15:31.687Z","BUILD_NUMBER":"Not Provided","GIT_VERSION":"v1.3.0-381-ga81e29b08","GIT_COMMIT_HASH":"a81e29b085c9268ffd96c78eb734365802722741","GIT_BRANCH":"beta","PUBLIC_URL":"","STATE_ABBR":"MT","STATE_NAME":"Montana","STATE_ORG_TITLE":"Secretary of State","LOGIN_HEADER_IMG_PATH":"","HOME_IMG_FILENAME":"montana.jpg","FAVICON_FILE_NAME":"favicon.ico","ALLOW_E_SIGN_ON_CORRECTIONS":true,"THIRD_PARTY_SIGNING_ALLOWED":false,"MY_ACCOUNT_SAVE_AND_CLOSE_BUTTON":true,"IE_DEPRECATED_MESSAGE":"Internet Explorer is not supported. Please select a supported browser below to access this website.","ADDITIONAL_ROUTES":{"dataRequests":true,"farmBill":true,"apostille":true,"externalHelp":"https://sosmt.gov/business/help-center/","systemAdministration":[{"title":"Saved Payments","parameter":"saved-payments","componentName":"SavedPayments"}]},"SUBROUTES":[{"label":"Business","component":"Business","parameter":"business","myWorkQueueSearch":false,"sourceTypeId":54,"searchMustHaveOneOf":["FILING_TYPE_ID","STATUS_ID","STATE","search"],"serverWebSearchDescription":true,"serverWorkQueueDescription":true,"serverMyRecordsDescription":true,"searchPlaceholder":"Search by name or filing number (X########)","allowEmptySearchTerm":true,"requestCertificateAlternateLabel":"Request Information","fileAmendmentButtonLabel":"Filing Actions","advancedSearchParameters":[{"type":"radio","name":"QUERY_TYPE_ID","defaultValue":1010,"options":[{"value":1010,"label":"Starts with"},{"value":1011,"label":"Contains"},{"value":1012,"label":" Word Contains"}]},{"type":"serverSelect","name":"FILING_TYPE_ID","optionsSrc":"FILING_TYPES","label":"Entity Type","placeholder":"All","defaultValue":"0"},{"type":"serverSelect","name":"FILING_SUBTYPE_ID","optionsSrc":"FILING_SUBTYPES","label":"Entity Subtype","overrideSubOptionsSrcFromParameterName":"FILING_TYPE_ID","placeholder":"All","defaultValue":"0"},{"type":"serverSelect","name":"STATUS_ID","optionsSrc":"FILING_STATUS_WITHOUT_ALL","label":"Status","placeholder":"All","defaultValue":"0"},{"type":"serverSelect","name":"STATE","optionsSrc":"STATE","label":"State","placeholder":"All","defaultValue":""},{"type":"serverSelect","name":"COUNTY","optionsSrc":"COUNTY_SUBOPTION","label":"County","overrideSubOptionsSrcFromParameterName":"STATE","placeholder":"All","defaultValue":""},{"type":"checkbox","name":"CRA_SEARCH_YN","defaultValue":false,"label":"Search by Registered Agent PID"},{"type":"dateRange","name":"FILING_DATE","label":"Registration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}},{"type":"dateRange","name":"EXPIRATION_DATE","label":"Expiration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}}],"myRecordsFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Active"},{"value":2,"label":"Inactive"},{"value":3,"label":"Pending"}]},{"type":"dateRange","name":"DATE_RANGE","label":"Date range","defaultValue":{"start":null,"end":null}}],"myWorkQueueFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Approved"},{"value":2,"label":"Pending Online Payment"},{"value":3,"label":"Pending Review"},{"value":4,"label":"Needs Correction"},{"value":5,"label":"Rejected"},{"value":6,"label":"Draft"}]},{"type":"dateRange","name":"DATE_RANGE","label":"Date range","defaultValue":{"start":null,"end":null}}]},{"label":"Notary","component":"Notary","parameter":"notary","sourceTypeId":850,"myWorkQueueSearch":false,"allowEmptySearchTerm":true,"requestCertificateAlternateLabel":"Download Certificate","fileAmendmentButtonLabel":"Filing Actions","hideNameRequestCertificate":true,"hideAddressRequestCertificate":true,"hideRecordUserManagment":true,"searchPlaceholder":"Search by name or commission number","searchMustHaveOneOf":["CITY","search","SERVICE_TYPE"],"advancedParametersStartOpen":true,"searchIsSortable":true,"advancedSearchParameters":[{"type":"radio","name":"STARTS_WITH_YN","defaultValue":false,"options":[{"value":true,"label":"Starts with"},{"value":false,"label":"Contains"}]},{"type":"checkbox","name":"ACTIVE_ONLY_YN","defaultValue":true,"label":"Active entities only"},{"type":"text","name":"CITY","defaultValue":"","label":"City"},{"type":"select","name":"SERVICE_TYPE","label":"Special Services Offered","defaultValue":0,"options":[{"value":0,"label":"(N/A)"},{"value":6165,"label":"In-Person Electronic Notarization (IPEN)"},{"value":6166,"label":"Remote Online Notarization (RON)"},{"value":6167,"label":"Mobile Notary Services"},{"value":6168,"label":"Remote Ink Notarization (RIN)"}]}]},{"label":"Apostille","component":"Apostille","parameter":"apostille","sourceTypeId":720,"myRecordsSearch":false,"myWorkQueueSearch":false,"disabled":false,"allowedRoutes":["/forms-manager/","/queue/","/forms/"]},{"label":"Liens","component":"UCC","parameter":"ucc","sourceTypeId":1999,"myRecordsSearch":true,"myWorkQueueSearch":true,"fileAmendmentButtonLabel":"Filing Actions","searchPlaceholder":"Search by name or file number","disabled":false,"serverWebSearchDescription":true,"myRecordsDescription":"","workQueueDescription":"","searchDescription":"","hideRecordUserManagment":true,"searchLiensCheckout":false,"advancedSearchParameters":[{"type":"radio","name":"STARTS_WITH_YN","defaultValue":false,"options":[{"value":true,"label":"Starts with"},{"value":false,"label":"Contains"}]},{"type":"select","name":"STATUS","defaultValue":"ALL","label":"Status","options":[{"value":"ACTIVE_UNLAPSED","label":"Active (unlapsed)"},{"value":"ACTIVE_LAPSED_UNLAPSED","label":"Active (lapsed and unlapsed)"}]},{"type":"text","name":"EXCLUDE_VALUES","label":"Exclude Debtor Names (comma separated list of names to exclude)","defaultValue":""},{"type":"dateRange","name":"FILING_DATE","label":"Financing Statement Date","defaultValue":{"start":null,"end":null}},{"type":"dateRange","name":"LAPSE_DATE","label":"Lapse Date","defaultValue":{"start":null,"end":null}},{"type":"text","name":"CITY","label":"Debtor City","defaultValue":""}],"myRecordsFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Approved"},{"value":2,"label":"Pending Online Payment"},{"value":3,"label":"Pending Review"}]},{"type":"select","name":"TYPE","defaultValue":0,"label":"Lien Type","options":[{"value":0,"label":"All"},{"value":1,"label":"UCC"},{"value":2,"label":"EFS"},{"value":3,"label":"Title 71"}]}],"myWorkQueueFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Approved"},{"value":2,"label":"Pending Online Payment"},{"value":3,"label":"Pending Review"},{"value":4,"label":"Pending Print and Mail"},{"value":5,"label":"Rejected"},{"value":6,"label":"Draft"}]},{"type":"select","name":"TYPE","defaultValue":0,"label":"Lien Type","options":[{"value":0,"label":"All"},{"value":1,"label":"UCC"},{"value":2,"label":"EFS"},{"value":3,"label":"Title 71"}]}]},{"label":"Copy Request","component":"copies","parameter":"copies","sourceTypeId":2001,"myRecordsSearch":false,"myWorkQueueSearch":false,"disabled":false,"allowedRoutes":["/forms-manager/","/queue/","/forms/"]},{"label":"Trademark","component":"Trademark","parameter":"trademark","sourceTypeId":810,"showRequestCertificate":true,"searchMustHaveOneOf":["search","EXPIRATION_DATE","FILING_DATE"],"allowEmptySearchTerm":true,"requestCertificateAlternateLabel":"Request Information","fileAmendmentButtonLabel":"Filing Actions","advancedSearchParameters":[{"type":"radio","name":"QUERY_TYPE_ID","defaultValue":1010,"options":[{"value":1010,"label":"Starts with"},{"value":1011,"label":"Contains"},{"value":1012,"label":" Word Contains"}]},{"type":"checkbox","name":"OWNER_SEARCH_YN","defaultValue":false,"label":"Search owners"},{"type":"radio","name":"SERVICE_MARK_YN","label":"Mark Type","defaultValue":"","options":[{"value":"","label":"All Marks"},{"value":"Y","label":"Service Mark"},{"value":"N","label":"Trademark"}]},{"type":"serverSelect","name":"STATUS_ID","optionsSrc":"TYPE_V|TRADEMARK_STATUS_TYPE","label":"Status","placeholder":"All","defaultValue":"0"},{"type":"select","name":"DESIGN_TYPE_ID","options":[{"value":0,"label":"All"},{"value":990,"label":"Words Only"},{"value":991,"label":"Design Only"},{"value":992,"label":"Words and Design"}],"label":"Design Type","defaultValue":"0"},{"type":"dateRange","name":"FILING_DATE","label":"Registered Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}},{"type":"dateRange","name":"EXPIRATION_DATE","label":"Expiration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}}]},{"label":"Business Info Request","component":"InfoRequests","parameter":"info-request","sourceTypeId":167,"allowedRoutes":["/forms-manager/","/queue/","/forms/"]},{"label":"Data Requests","component":"DataRequests","parameter":"data-request","sourceTypeId":0,"allowedRoutes":["/forms-manager/"]},{"label":"CRA","component":"CRA","parameter":"cra","sourceTypeId":157,"myRecordsSearch":false,"searchPlaceholder":"Search by name or registered agent number","allowedRoutes":["/forms-manager/","/forms/","/records/","/queue/","/search/"],"allowEmptySearchTerm":true,"fileAmendmentButtonLabel":"Filing Actions","advancedSearchParameters":[{"type":"radio","name":"QUERY_TYPE_ID","defaultValue":1010,"options":[{"value":1010,"label":"Starts with"},{"value":1011,"label":"Contains"},{"value":1012,"label":" Word Contains"}]},{"type":"dateRange","name":"CRA_DATE","label":"Registration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}},{"type":"select","name":"STATUS_ID","label":"Status","defaultValue":0,"options":[{"value":0,"label":"All"},{"value":121,"label":"Active"},{"value":122,"label":"Inactive"}]},{"type":"select","name":"AGENT_TYPE_ID","label":"Agent Type","defaultValue":0,"options":[{"value":0,"label":"All"},{"value":460,"label":"Registered Agent"},{"value":461,"label":"Commercial Registered Agent"}]}]},{"label":"Farm Bill","component":"FarmBill","parameter":"farm-bill","path":"/lists/farm-bill","sourceTypeId":0,"myRecordsSearch":false,"allowedRules":["/search/"],"disabled":true,"searchDescription":"To perform a search, enter a debtor name. Your search results may include: exact debtor name, variations of that name and any filing that includes your search criteria. Punctuation is ignored.\n\nYou can click on \"Advanced\" to refine your search. Under “Advanced” you can search by crop, year, county and SSN/FEIN. As a registered Farm Bill Buyer with the Montana Secretary of State’s office it is important to maintain the confidentiality of the information contained within the Farm Bill Master List. The Farm Bill Master List reflects personal data, such as Social Security Numbers, which are a key piece of personal identifiable information to assist you in determining the existence of a lien against a specific debtor. The distribution of this information beyond its intended purpose is strictly prohibited.\n\nThe debtor's tax identification number has been hidden for confidentiality reasons. You may continue to search on a tax ID number and return debtors that match your search criteria. The SSN/FEIN must be entered without dashes or spaces.","searchMustHaveOneOf":["search","UCC_FARM_PRODUCT_ID","COUNTY"],"searchPlaceholder":"Search by debtor name","advancedSearchParameters":[{"type":"ServerMultiComplete","label":"Product code name(s)","name":"UCC_FARM_PRODUCT_ID","defaultValue":"","optionsSrc":"UCC_FARM_PRODUCT_V"},{"type":"MultiComplete","label":"Year or Range of Years","name":"YEAR_NUM","optionsSrc":"years","startYear":"1968","defaultValue":[],"preMergeOptions":[{"value":"ALL","label":"All"}]},{"type":"serverSelect","label":"State","name":"STATE","defaultValue":"MONTANA","optionsSrc":"STATE"},{"type":"ServerMultiComplete","label":"County","name":"COUNTY","defaultValue":[],"optionsSrc":"COUNTY","overrideSubOptionsSrcFromParameterName":"STATE"},{"type":"checkbox","name":"TIN_SEARCH_YN","defaultValue":false,"label":"Tax Identification Number Search"},{"type":"checkbox","name":"TIN_SORT_YN","defaultValue":false,"label":"Unique ID Sort"}]}],"SYSTEM_NICKNAME":"Online Services Portal","PAYMENT_METHODS":[{"type":"bypass"},{"type":"iTransact"}],"PAYMENT_ALLOW_AMEX":true,"SYSTEM_ID_LABEL":"System Id","DOUBLE_COLUMN_PUBLIC_LOGIN":true,"INTERNAL_USER_MANAGEMENT":true,"ALLOW_PUBLIC_JSON_IMPORT":false,"MAX_FILE_UPLOAD_SIZE":10000000,"REFUND_TEXT":"","RETURN_TO_HOME_ON_LOGOUT":true,"CURRENT_SOS_NAME":"Christi Jacobsen","LOGO_FILENAME":"mt-sos-logo.png","LOGO_ALT":"Christi Jacobsen, Montana Secretary of State","LOGO_FULL_WIDTH":true,"HOME_HIDE_AUTH_HINT":true,"HOME_TITLE":"Montana Secretary of State","CUSTOM_TAB_TITLE":"Official Montana","HOME_SUBTITLE":"Online Business Services","ENTITY_NAME_CONSENT_DESCRIPTION":"","ALLOW_USER_PROFILE_EDITING":true,"COMPARE_FOREIGN_NAME_IN_ENTITY_NAME_VALIDATION":true,"FOREIGN_NAME_FIELD_NAME":"KIMA_PARENT_NAME_INFO","LOGIN_TITLE":"Montana Secretary of State Online Filing Portal Login","PUBLIC_LOGIN_LABEL":"Username","REVERSE_LOGIN_COLUMNS":true,"LOGIN_SEAL_FILENAME":"seal_white.png","SEPARATE_USERNAME_AND_EMAIL":true,"CREATE_ACCOUNT_BUTTON_ALIGN_LEFT":true,"CREATE_ACCOUNT_BUTTON_TEXT":"CREATE AN ACCOUNT","PASSWORD_CUSTOM_ERROR_TEXT":"The password must meet all requirements","ACCOUNT_CREATED_MESSAGE":"Please check your email to verify your account to login and allow a few minutes for this message to arrive. Check your junk/spam folders if you do not find the email in your inbox.","PUBLIC_LOGIN_PLACEHOLDER":" ","DISABLE_DEFAULT_PAYMENT_RADIO":true,"CUSTOM_RESET_PASSWORD_ERROR_MESSAGE":"Username invalid - no account found","PUBLIC_LOGIN_CREATE_DESCRIPTION":"### Existing User:\n\n  - Enter your username and password to login.  \n\n\n  #### - OR -  \n\n\n\n  - Forgot password? Click 'Reset Password' and follow the prompts.\n  - Forgot username? Click 'Forgot Username' and follow the prompts.  \n\n\n  ### New User:\n  ","LOGIN_HELP_LINK":"https://sosmt.gov/business/how-do-i/","LOGIN_HELP_LINK_TEXT":"Need Help?","FORGOT_USERNAME_TEXT":"Forgot Username?","LOGIN_ACTIVE_DIRECTORY_TEXT":"State User Login","MULTIPLE_LOGIN_METHODS":true,"HAS_ACTIVE_DIRECTORY_LOGIN":true,"RESET_PASSWORD_WITH_USERNAME":true,"DOWNLOAD_LINK":true,"SHOW_USERNAME_ACCOUNT_CREATE":true,"SHOW_SCROLL_DOWN_ARROW":true,"SHOW_ADDRESS_ACCOUNT_CREATE":true,"TWO_COLUMN_ACCOUNT_CREATE":true,"RESET_PASSWORD_TIP":"A link to change your password has been sent to your email. Please allow a few minutes for this message to arrive. Please check your junk/spam folders if you do not find the email in your inbox.","FORGOT_PASSWORD_LINK_TEXT":"Reset Password","PHONE_NUMBER_OPTIONAL_ACCOUNT_CREATE":true,"SHOW_REQUIRED_INDICATOR_ACCOUNT_CREATE":true,"PASSWORD_REQUIREMENTS_ACCOUNT_CREATE":"\n    <ul>\n      <li>MUST contain at least 8 characters (12+ recommended)</li>\n      <li>MUST contain at least one uppercase letter.</li>\n      <li>MUST contain at least one lowercase letter.</li>\n      <li>MUST contain at least one number.</li>\n      <li>MUST contain at least one special character (!”#$%&'()*+,-./:;<=>?</li>\n    </ul>\n  ","ALLOW_CERTIFICATION_REQUEST":true,"ALLOW_PUBLIC_CERTIFICATE_REQUEST":true,"ALLOW_COPY_REQUEST":false,"ALLOW_CORRECTION_STYLING":true,"HIDE_DEPRECATION_WARNING":false,"AMEND_ROUTE_PUBLIC":true,"SEAL_FILENAME":"seal.png","SHOPPING_CART":true,"ALLOW_PAYMENT_UPDATE_WITH_EMPTY_CART":true,"RA_EMAIL":true,"RA_WEBSITE":true,"RA_NO_DEFAULT_TYPE":true,"RA_ADDRESS_LABEL":"Street Address","RA_TYPE_SELECTION_DEFAULT":true,"RA_DEFAULT_TYPE":"460","RA_OVERRIDE_TYPE_WITH_DEFAULT":true,"RA_PRINCIPAL_ADDRESS_AMS":true,"UPLOAD_AND_SUBMIT_HIDE_IF_ONE_OPTION":true,"PAYMENT_PROCESSING_MESSAGE":"Your payment is processing - Do not close your browser or click the back button","CHECKOUT_BUTTON_WHEN_PROCESSING_TEXT":"Processing","EFS_CROP_PICKER_NONE_LABEL":"Lien Duration","DISALLOWED_WIZARD_PIECES":["FormationLocale"],"REPEATER_SHOW_EDIT_BUTTON":true,"DATA_REQUEST_PAGE_TITLE":"Data Requests and Subscriptions","DATA_REQUEST_SIDEBAR_LABEL":"Data Requests & Subscriptions","LOGIN_REDIRECTS_TO_EPASS":false,"LOGIN_REDIRECTS_TO_ACTIVE_DIRECTORY":true,"LOGIN_ACTIVE_DIRECTORY_LINK":true,"FETCH_EDIT_USER_LINK":false,"LISTS_FETCH_AVAILABLE_LISTS":true,"POST_WIZARD_SUBMIT_REDIRECT_URL":"/","PIN_REQUEST_ATTESTATIONS":true,"PIN_REQUEST_DESCRIPTION":"Click **Request PIN** to have a new PIN sent to the account holder's email address on file.","OWNERSHIP_REQUEST_DESCRIPTION":"To become an **authorized user** of this record, a current **AUTHORIZED USER** will need to grant you access. To request access, click **Request Access** below.","PIN_REQUEST_SUCCESS_MESSAGE":"The PIN you have requested for this entity has been sent to the email associated with your user account.  You should receive the PIN in approximately 3-5 minutes, depending on your email service provider.","APOSTILLE_HEADER_LABEL":"Verification Information","APOSTILLE_NUMBER_LABEL":"Apostille/Authentication","APOSTILLE_CITY_STATE_OVERRIDE":"HELENA, MT","APOSTILLE_FILING_DATE_LABEL":"Issue Date","APOSTILLE_CITY_STATE_IN_CERTIFIED":true,"NOTARY_EXISTING_FILING":true,"ALLOW_REVOKE_OWN_ACCESS_ONLY":false,"HIDE_CANCEL_ON_ONETIME_DATA_REQUESTS":true,"DATA_REQUESTS_IN_SHOPPING_CART":true,"WQ_ALLOW_EDIT_PENDING_PAYMENT":true,"WQ_CONFIRM_ON_DELETE":true,"WQ_DELETE_CONFIRM_MESSAGE":"Deleting this filing will forfeit any money already paid to the Secretary of State. This action is permanent and cannot be undone, are you sure you would like to delete?","PASS_ITEM_GUIDS_ON_CHECKOUT":true,"FORM_REVISION_HISTORY":true,"CHECKOUT_DISCLAIMER":"By entering your credit card and/or checking account information you (i) state that **you are an authorized user** of the credit card and/or electronic check and that the associated information entered (e.g., account holder name, account number, billing address) is accurate, (ii) **you authorize payment processor to charge the amount you have requested** to your credit card and/or funding account, and (iii) **acknowledge if a charge is declined or reversed you may also be assessed a customary charge** by the payment processor for such transactions.","FARM_BILL_SEARCH_CONFIDENTIAL":"As a registered Farm Bill Buyer with the Montana Secretary of State’s office it is important to maintain the confidentiality of the information contained within the Farm Bill Master List. The Farm Bill Master List reflects personal data, such as Social Security Numbers, which are a key piece of personal identifiable information to assist you in determining the existence of a lien against a specific debtor. The distribution of this information beyond its intended purpose is strictly prohibited.\n\n**The debtor's tax identification number has been hidden for confidentiality reasons. You may continue to search on a tax ID number and return debtors that match your search criteria. The SSN/FEIN must be entered without dashes or spaces.  If you need access to the tax identification number to clearly identify the debtor, please contact the UCC unit at (406) 444-3665.**","VIEW_HISTORY_BUTTON_ALT_TEXT":"View Filings","WIZARD_ERROR_TITLE_MESSAGE":"Form Error","FARM_BILL_SEARCH_INTERACTIVE":true,"USE_FARM_BILL_API":true,"DISALLOW_ASSIGN_SELF_AS_RA":true,"DISALLOW_ASSIGN_SELF_AS_PRINCIPAL":true,"USE_TRADEMARK_OWNER_VALIDATION":true,"USE_ALTERNATIVE_FOREIGN_ADDRESS_LABELS":true,"MY_RECEIPTS_FILTER":[{"type":"dateRange","name":"DATE_RANGE","label":"Date range","defaultValue":{"start":null,"end":null}},{"type":"text","name":"REF_NUM","defaultValue":"","label":"Reference Number"},{"type":"text","name":"RECEIPT_NUM","defaultValue":"","label":"Receipt Id"},{"type":"text","name":"AMOUNT","defaultValue":"","label":"Amount"},{"type":"select","name":"TYPE","defaultValue":"","label":"Payment Type","options":[{"value":"","label":"All"},{"value":"CC","label":"Credit Card"},{"value":"Check","label":"Check"}]}],"MY_RECEIPTS_SHOW_IN_SIDEBAR":true,"SHOW_MY_RECEIPTS_HELPER_TEXT":true,"MY_RECEIPTS_HELPER_LABEL":"About Receipt Search","MY_RECEIPTS_HELPER_TEXT":"You can search for receipts based on their descriptions, including the items paid for on the receipt. Use the filters to search for or filter specific information.","FARM_BILL_SUBLINK":{"label":"Farm Bill","component":"FarmBill","parameter":"farm-bill","path":"/lists/farm-bill","sourceTypeId":0,"myRecordsSearch":false,"allowedRules":["/search/"],"disabled":true,"searchDescription":"To perform a search, enter a debtor name. Your search results may include: exact debtor name, variations of that name and any filing that includes your search criteria. Punctuation is ignored.\n\nYou can click on \"Advanced\" to refine your search. Under “Advanced” you can search by crop, year, county and SSN/FEIN. As a registered Farm Bill Buyer with the Montana Secretary of State’s office it is important to maintain the confidentiality of the information contained within the Farm Bill Master List. The Farm Bill Master List reflects personal data, such as Social Security Numbers, which are a key piece of personal identifiable information to assist you in determining the existence of a lien against a specific debtor. The distribution of this information beyond its intended purpose is strictly prohibited.\n\nThe debtor's tax identification number has been hidden for confidentiality reasons. You may continue to search on a tax ID number and return debtors that match your search criteria. The SSN/FEIN must be entered without dashes or spaces.","searchMustHaveOneOf":["search","UCC_FARM_PRODUCT_ID","COUNTY"],"searchPlaceholder":"Search by debtor name","advancedSearchParameters":[{"type":"ServerMultiComplete","label":"Product code name(s)","name":"UCC_FARM_PRODUCT_ID","defaultValue":"","optionsSrc":"UCC_FARM_PRODUCT_V"},{"type":"MultiComplete","label":"Year or Range of Years","name":"YEAR_NUM","optionsSrc":"years","startYear":"1968","defaultValue":[],"preMergeOptions":[{"value":"ALL","label":"All"}]},{"type":"serverSelect","label":"State","name":"STATE","defaultValue":"MONTANA","optionsSrc":"STATE"},{"type":"ServerMultiComplete","label":"County","name":"COUNTY","defaultValue":[],"optionsSrc":"COUNTY","overrideSubOptionsSrcFromParameterName":"STATE"},{"type":"checkbox","name":"TIN_SEARCH_YN","defaultValue":false,"label":"Tax Identification Number Search"},{"type":"checkbox","name":"TIN_SORT_YN","defaultValue":false,"label":"Unique ID Sort"}]},"ALLOW_ADDRESS_VALIDATION_BYPASS_OPTION":true,"DEFAULT_ADDRESS_VALIDATION_BYPASS_OPTION_CHECKED":true}).EDIT_ACCOUNT_LABEL || 'Edit My Account',
	            href: editUserExternalUrl,
	            target: '_blank'
	          }] : [])),
	          isOpen: this.state.menuOpen,
	          alignTo: this.state.alignTo,
	          alignScreenRight: true,
	          offsetTop: 50,
	          offsetRight: 5,
	          animationDirection: 'right',
	          onRequestClose: this.closeMenu
	        }) : null,
	        _react2.default.createElement(
	          _Portal2.default,
	          { isOpened: showLogin && !loggedIn },
	          _react2.default.createElement(
	            _Modal.Modal,
	            {
	              hideHeader: true,
	              closeModal: this.toggleLoginModal,
	              modalSize: 'fullscreen',
	              noBackground: true,
	              disableEntranceAnimation: true,
	              modalBodyClassName: 'login-modal-body',
	              rootClassName: 'login-modal-root',
	              save: _utilities.noop,
	              cancel: _utilities.noop,
	              ref: this.modalref
	            },
	            _react2.default.createElement(PublicLogin, { location: location })
	          )
	        ),
	        _react2.default.createElement(_UserAccountEditor2.default, {
	          isOpen: this.state.editingUserAccount,
	          onClose: this.closeProfileEditor
	        })
	      );
	    }
	  }]);
	
	  return Auth;
	}(_react.Component);
	
	exports.default = (0, _reactRedux.connect)(function (state) {
	  return {
	    showLogin: state.app.showLogin,
	    loggedIn: state.auth.loggedIn,
	    siteOffline: state.app.appSettings.WEBSITE_PORTAL_OFFLINE_YN === true,
	    user: {
	      firstName: state.auth.FIRST_NAME,
	      lastName: state.auth.LAST_NAME,
	      username: state.auth.USERNAME,
	      businessName: state.auth.BUSINESS_NAME,
	      group: state.auth.USER_GROUP
	    },
	    checkingAuthState: state.auth.checkingAuthState,
	    useLDAP: state.app.appSettings.USE_LDAP_AUTHENTICATION_YN == true ? state.app.appSettings.USE_LDAP_AUTHENTICATION_YN : false,
	    isOnAuthRoute: state.router.location.pathname === '/auth',
	    pathname: state.router.location.pathname,
	    search: state.router.location.search,
	    editUserExternalUrl: state.app.appSettings.EPASS_ACCOUNT_EDIT_URL
	  };
	}, {
	  toggleLoginModal: _actions.toggleLoginModal,
	  logoutWebUser: _AuthActions.logoutWebUser,
	  setStateUser: _actions.setStateUser
	})(Auth);
	
	
	var DOUBLE_COLUMN_PUBLIC_LOGIN = (true);
	var REVERSE_LOGIN_COLUMNS = (true);
	var LOGIN_HEADER_BACKGROUND = ({"NODE_ENV":"production","BUILD_DATE":"2025-08-27T15:15:31.687Z","BUILD_NUMBER":"Not Provided","GIT_VERSION":"v1.3.0-381-ga81e29b08","GIT_COMMIT_HASH":"a81e29b085c9268ffd96c78eb734365802722741","GIT_BRANCH":"beta","PUBLIC_URL":"","STATE_ABBR":"MT","STATE_NAME":"Montana","STATE_ORG_TITLE":"Secretary of State","LOGIN_HEADER_IMG_PATH":"","HOME_IMG_FILENAME":"montana.jpg","FAVICON_FILE_NAME":"favicon.ico","ALLOW_E_SIGN_ON_CORRECTIONS":true,"THIRD_PARTY_SIGNING_ALLOWED":false,"MY_ACCOUNT_SAVE_AND_CLOSE_BUTTON":true,"IE_DEPRECATED_MESSAGE":"Internet Explorer is not supported. Please select a supported browser below to access this website.","ADDITIONAL_ROUTES":{"dataRequests":true,"farmBill":true,"apostille":true,"externalHelp":"https://sosmt.gov/business/help-center/","systemAdministration":[{"title":"Saved Payments","parameter":"saved-payments","componentName":"SavedPayments"}]},"SUBROUTES":[{"label":"Business","component":"Business","parameter":"business","myWorkQueueSearch":false,"sourceTypeId":54,"searchMustHaveOneOf":["FILING_TYPE_ID","STATUS_ID","STATE","search"],"serverWebSearchDescription":true,"serverWorkQueueDescription":true,"serverMyRecordsDescription":true,"searchPlaceholder":"Search by name or filing number (X########)","allowEmptySearchTerm":true,"requestCertificateAlternateLabel":"Request Information","fileAmendmentButtonLabel":"Filing Actions","advancedSearchParameters":[{"type":"radio","name":"QUERY_TYPE_ID","defaultValue":1010,"options":[{"value":1010,"label":"Starts with"},{"value":1011,"label":"Contains"},{"value":1012,"label":" Word Contains"}]},{"type":"serverSelect","name":"FILING_TYPE_ID","optionsSrc":"FILING_TYPES","label":"Entity Type","placeholder":"All","defaultValue":"0"},{"type":"serverSelect","name":"FILING_SUBTYPE_ID","optionsSrc":"FILING_SUBTYPES","label":"Entity Subtype","overrideSubOptionsSrcFromParameterName":"FILING_TYPE_ID","placeholder":"All","defaultValue":"0"},{"type":"serverSelect","name":"STATUS_ID","optionsSrc":"FILING_STATUS_WITHOUT_ALL","label":"Status","placeholder":"All","defaultValue":"0"},{"type":"serverSelect","name":"STATE","optionsSrc":"STATE","label":"State","placeholder":"All","defaultValue":""},{"type":"serverSelect","name":"COUNTY","optionsSrc":"COUNTY_SUBOPTION","label":"County","overrideSubOptionsSrcFromParameterName":"STATE","placeholder":"All","defaultValue":""},{"type":"checkbox","name":"CRA_SEARCH_YN","defaultValue":false,"label":"Search by Registered Agent PID"},{"type":"dateRange","name":"FILING_DATE","label":"Registration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}},{"type":"dateRange","name":"EXPIRATION_DATE","label":"Expiration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}}],"myRecordsFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Active"},{"value":2,"label":"Inactive"},{"value":3,"label":"Pending"}]},{"type":"dateRange","name":"DATE_RANGE","label":"Date range","defaultValue":{"start":null,"end":null}}],"myWorkQueueFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Approved"},{"value":2,"label":"Pending Online Payment"},{"value":3,"label":"Pending Review"},{"value":4,"label":"Needs Correction"},{"value":5,"label":"Rejected"},{"value":6,"label":"Draft"}]},{"type":"dateRange","name":"DATE_RANGE","label":"Date range","defaultValue":{"start":null,"end":null}}]},{"label":"Notary","component":"Notary","parameter":"notary","sourceTypeId":850,"myWorkQueueSearch":false,"allowEmptySearchTerm":true,"requestCertificateAlternateLabel":"Download Certificate","fileAmendmentButtonLabel":"Filing Actions","hideNameRequestCertificate":true,"hideAddressRequestCertificate":true,"hideRecordUserManagment":true,"searchPlaceholder":"Search by name or commission number","searchMustHaveOneOf":["CITY","search","SERVICE_TYPE"],"advancedParametersStartOpen":true,"searchIsSortable":true,"advancedSearchParameters":[{"type":"radio","name":"STARTS_WITH_YN","defaultValue":false,"options":[{"value":true,"label":"Starts with"},{"value":false,"label":"Contains"}]},{"type":"checkbox","name":"ACTIVE_ONLY_YN","defaultValue":true,"label":"Active entities only"},{"type":"text","name":"CITY","defaultValue":"","label":"City"},{"type":"select","name":"SERVICE_TYPE","label":"Special Services Offered","defaultValue":0,"options":[{"value":0,"label":"(N/A)"},{"value":6165,"label":"In-Person Electronic Notarization (IPEN)"},{"value":6166,"label":"Remote Online Notarization (RON)"},{"value":6167,"label":"Mobile Notary Services"},{"value":6168,"label":"Remote Ink Notarization (RIN)"}]}]},{"label":"Apostille","component":"Apostille","parameter":"apostille","sourceTypeId":720,"myRecordsSearch":false,"myWorkQueueSearch":false,"disabled":false,"allowedRoutes":["/forms-manager/","/queue/","/forms/"]},{"label":"Liens","component":"UCC","parameter":"ucc","sourceTypeId":1999,"myRecordsSearch":true,"myWorkQueueSearch":true,"fileAmendmentButtonLabel":"Filing Actions","searchPlaceholder":"Search by name or file number","disabled":false,"serverWebSearchDescription":true,"myRecordsDescription":"","workQueueDescription":"","searchDescription":"","hideRecordUserManagment":true,"searchLiensCheckout":false,"advancedSearchParameters":[{"type":"radio","name":"STARTS_WITH_YN","defaultValue":false,"options":[{"value":true,"label":"Starts with"},{"value":false,"label":"Contains"}]},{"type":"select","name":"STATUS","defaultValue":"ALL","label":"Status","options":[{"value":"ACTIVE_UNLAPSED","label":"Active (unlapsed)"},{"value":"ACTIVE_LAPSED_UNLAPSED","label":"Active (lapsed and unlapsed)"}]},{"type":"text","name":"EXCLUDE_VALUES","label":"Exclude Debtor Names (comma separated list of names to exclude)","defaultValue":""},{"type":"dateRange","name":"FILING_DATE","label":"Financing Statement Date","defaultValue":{"start":null,"end":null}},{"type":"dateRange","name":"LAPSE_DATE","label":"Lapse Date","defaultValue":{"start":null,"end":null}},{"type":"text","name":"CITY","label":"Debtor City","defaultValue":""}],"myRecordsFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Approved"},{"value":2,"label":"Pending Online Payment"},{"value":3,"label":"Pending Review"}]},{"type":"select","name":"TYPE","defaultValue":0,"label":"Lien Type","options":[{"value":0,"label":"All"},{"value":1,"label":"UCC"},{"value":2,"label":"EFS"},{"value":3,"label":"Title 71"}]}],"myWorkQueueFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Approved"},{"value":2,"label":"Pending Online Payment"},{"value":3,"label":"Pending Review"},{"value":4,"label":"Pending Print and Mail"},{"value":5,"label":"Rejected"},{"value":6,"label":"Draft"}]},{"type":"select","name":"TYPE","defaultValue":0,"label":"Lien Type","options":[{"value":0,"label":"All"},{"value":1,"label":"UCC"},{"value":2,"label":"EFS"},{"value":3,"label":"Title 71"}]}]},{"label":"Copy Request","component":"copies","parameter":"copies","sourceTypeId":2001,"myRecordsSearch":false,"myWorkQueueSearch":false,"disabled":false,"allowedRoutes":["/forms-manager/","/queue/","/forms/"]},{"label":"Trademark","component":"Trademark","parameter":"trademark","sourceTypeId":810,"showRequestCertificate":true,"searchMustHaveOneOf":["search","EXPIRATION_DATE","FILING_DATE"],"allowEmptySearchTerm":true,"requestCertificateAlternateLabel":"Request Information","fileAmendmentButtonLabel":"Filing Actions","advancedSearchParameters":[{"type":"radio","name":"QUERY_TYPE_ID","defaultValue":1010,"options":[{"value":1010,"label":"Starts with"},{"value":1011,"label":"Contains"},{"value":1012,"label":" Word Contains"}]},{"type":"checkbox","name":"OWNER_SEARCH_YN","defaultValue":false,"label":"Search owners"},{"type":"radio","name":"SERVICE_MARK_YN","label":"Mark Type","defaultValue":"","options":[{"value":"","label":"All Marks"},{"value":"Y","label":"Service Mark"},{"value":"N","label":"Trademark"}]},{"type":"serverSelect","name":"STATUS_ID","optionsSrc":"TYPE_V|TRADEMARK_STATUS_TYPE","label":"Status","placeholder":"All","defaultValue":"0"},{"type":"select","name":"DESIGN_TYPE_ID","options":[{"value":0,"label":"All"},{"value":990,"label":"Words Only"},{"value":991,"label":"Design Only"},{"value":992,"label":"Words and Design"}],"label":"Design Type","defaultValue":"0"},{"type":"dateRange","name":"FILING_DATE","label":"Registered Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}},{"type":"dateRange","name":"EXPIRATION_DATE","label":"Expiration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}}]},{"label":"Business Info Request","component":"InfoRequests","parameter":"info-request","sourceTypeId":167,"allowedRoutes":["/forms-manager/","/queue/","/forms/"]},{"label":"Data Requests","component":"DataRequests","parameter":"data-request","sourceTypeId":0,"allowedRoutes":["/forms-manager/"]},{"label":"CRA","component":"CRA","parameter":"cra","sourceTypeId":157,"myRecordsSearch":false,"searchPlaceholder":"Search by name or registered agent number","allowedRoutes":["/forms-manager/","/forms/","/records/","/queue/","/search/"],"allowEmptySearchTerm":true,"fileAmendmentButtonLabel":"Filing Actions","advancedSearchParameters":[{"type":"radio","name":"QUERY_TYPE_ID","defaultValue":1010,"options":[{"value":1010,"label":"Starts with"},{"value":1011,"label":"Contains"},{"value":1012,"label":" Word Contains"}]},{"type":"dateRange","name":"CRA_DATE","label":"Registration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}},{"type":"select","name":"STATUS_ID","label":"Status","defaultValue":0,"options":[{"value":0,"label":"All"},{"value":121,"label":"Active"},{"value":122,"label":"Inactive"}]},{"type":"select","name":"AGENT_TYPE_ID","label":"Agent Type","defaultValue":0,"options":[{"value":0,"label":"All"},{"value":460,"label":"Registered Agent"},{"value":461,"label":"Commercial Registered Agent"}]}]},{"label":"Farm Bill","component":"FarmBill","parameter":"farm-bill","path":"/lists/farm-bill","sourceTypeId":0,"myRecordsSearch":false,"allowedRules":["/search/"],"disabled":true,"searchDescription":"To perform a search, enter a debtor name. Your search results may include: exact debtor name, variations of that name and any filing that includes your search criteria. Punctuation is ignored.\n\nYou can click on \"Advanced\" to refine your search. Under “Advanced” you can search by crop, year, county and SSN/FEIN. As a registered Farm Bill Buyer with the Montana Secretary of State’s office it is important to maintain the confidentiality of the information contained within the Farm Bill Master List. The Farm Bill Master List reflects personal data, such as Social Security Numbers, which are a key piece of personal identifiable information to assist you in determining the existence of a lien against a specific debtor. The distribution of this information beyond its intended purpose is strictly prohibited.\n\nThe debtor's tax identification number has been hidden for confidentiality reasons. You may continue to search on a tax ID number and return debtors that match your search criteria. The SSN/FEIN must be entered without dashes or spaces.","searchMustHaveOneOf":["search","UCC_FARM_PRODUCT_ID","COUNTY"],"searchPlaceholder":"Search by debtor name","advancedSearchParameters":[{"type":"ServerMultiComplete","label":"Product code name(s)","name":"UCC_FARM_PRODUCT_ID","defaultValue":"","optionsSrc":"UCC_FARM_PRODUCT_V"},{"type":"MultiComplete","label":"Year or Range of Years","name":"YEAR_NUM","optionsSrc":"years","startYear":"1968","defaultValue":[],"preMergeOptions":[{"value":"ALL","label":"All"}]},{"type":"serverSelect","label":"State","name":"STATE","defaultValue":"MONTANA","optionsSrc":"STATE"},{"type":"ServerMultiComplete","label":"County","name":"COUNTY","defaultValue":[],"optionsSrc":"COUNTY","overrideSubOptionsSrcFromParameterName":"STATE"},{"type":"checkbox","name":"TIN_SEARCH_YN","defaultValue":false,"label":"Tax Identification Number Search"},{"type":"checkbox","name":"TIN_SORT_YN","defaultValue":false,"label":"Unique ID Sort"}]}],"SYSTEM_NICKNAME":"Online Services Portal","PAYMENT_METHODS":[{"type":"bypass"},{"type":"iTransact"}],"PAYMENT_ALLOW_AMEX":true,"SYSTEM_ID_LABEL":"System Id","DOUBLE_COLUMN_PUBLIC_LOGIN":true,"INTERNAL_USER_MANAGEMENT":true,"ALLOW_PUBLIC_JSON_IMPORT":false,"MAX_FILE_UPLOAD_SIZE":10000000,"REFUND_TEXT":"","RETURN_TO_HOME_ON_LOGOUT":true,"CURRENT_SOS_NAME":"Christi Jacobsen","LOGO_FILENAME":"mt-sos-logo.png","LOGO_ALT":"Christi Jacobsen, Montana Secretary of State","LOGO_FULL_WIDTH":true,"HOME_HIDE_AUTH_HINT":true,"HOME_TITLE":"Montana Secretary of State","CUSTOM_TAB_TITLE":"Official Montana","HOME_SUBTITLE":"Online Business Services","ENTITY_NAME_CONSENT_DESCRIPTION":"","ALLOW_USER_PROFILE_EDITING":true,"COMPARE_FOREIGN_NAME_IN_ENTITY_NAME_VALIDATION":true,"FOREIGN_NAME_FIELD_NAME":"KIMA_PARENT_NAME_INFO","LOGIN_TITLE":"Montana Secretary of State Online Filing Portal Login","PUBLIC_LOGIN_LABEL":"Username","REVERSE_LOGIN_COLUMNS":true,"LOGIN_SEAL_FILENAME":"seal_white.png","SEPARATE_USERNAME_AND_EMAIL":true,"CREATE_ACCOUNT_BUTTON_ALIGN_LEFT":true,"CREATE_ACCOUNT_BUTTON_TEXT":"CREATE AN ACCOUNT","PASSWORD_CUSTOM_ERROR_TEXT":"The password must meet all requirements","ACCOUNT_CREATED_MESSAGE":"Please check your email to verify your account to login and allow a few minutes for this message to arrive. Check your junk/spam folders if you do not find the email in your inbox.","PUBLIC_LOGIN_PLACEHOLDER":" ","DISABLE_DEFAULT_PAYMENT_RADIO":true,"CUSTOM_RESET_PASSWORD_ERROR_MESSAGE":"Username invalid - no account found","PUBLIC_LOGIN_CREATE_DESCRIPTION":"### Existing User:\n\n  - Enter your username and password to login.  \n\n\n  #### - OR -  \n\n\n\n  - Forgot password? Click 'Reset Password' and follow the prompts.\n  - Forgot username? Click 'Forgot Username' and follow the prompts.  \n\n\n  ### New User:\n  ","LOGIN_HELP_LINK":"https://sosmt.gov/business/how-do-i/","LOGIN_HELP_LINK_TEXT":"Need Help?","FORGOT_USERNAME_TEXT":"Forgot Username?","LOGIN_ACTIVE_DIRECTORY_TEXT":"State User Login","MULTIPLE_LOGIN_METHODS":true,"HAS_ACTIVE_DIRECTORY_LOGIN":true,"RESET_PASSWORD_WITH_USERNAME":true,"DOWNLOAD_LINK":true,"SHOW_USERNAME_ACCOUNT_CREATE":true,"SHOW_SCROLL_DOWN_ARROW":true,"SHOW_ADDRESS_ACCOUNT_CREATE":true,"TWO_COLUMN_ACCOUNT_CREATE":true,"RESET_PASSWORD_TIP":"A link to change your password has been sent to your email. Please allow a few minutes for this message to arrive. Please check your junk/spam folders if you do not find the email in your inbox.","FORGOT_PASSWORD_LINK_TEXT":"Reset Password","PHONE_NUMBER_OPTIONAL_ACCOUNT_CREATE":true,"SHOW_REQUIRED_INDICATOR_ACCOUNT_CREATE":true,"PASSWORD_REQUIREMENTS_ACCOUNT_CREATE":"\n    <ul>\n      <li>MUST contain at least 8 characters (12+ recommended)</li>\n      <li>MUST contain at least one uppercase letter.</li>\n      <li>MUST contain at least one lowercase letter.</li>\n      <li>MUST contain at least one number.</li>\n      <li>MUST contain at least one special character (!”#$%&'()*+,-./:;<=>?</li>\n    </ul>\n  ","ALLOW_CERTIFICATION_REQUEST":true,"ALLOW_PUBLIC_CERTIFICATE_REQUEST":true,"ALLOW_COPY_REQUEST":false,"ALLOW_CORRECTION_STYLING":true,"HIDE_DEPRECATION_WARNING":false,"AMEND_ROUTE_PUBLIC":true,"SEAL_FILENAME":"seal.png","SHOPPING_CART":true,"ALLOW_PAYMENT_UPDATE_WITH_EMPTY_CART":true,"RA_EMAIL":true,"RA_WEBSITE":true,"RA_NO_DEFAULT_TYPE":true,"RA_ADDRESS_LABEL":"Street Address","RA_TYPE_SELECTION_DEFAULT":true,"RA_DEFAULT_TYPE":"460","RA_OVERRIDE_TYPE_WITH_DEFAULT":true,"RA_PRINCIPAL_ADDRESS_AMS":true,"UPLOAD_AND_SUBMIT_HIDE_IF_ONE_OPTION":true,"PAYMENT_PROCESSING_MESSAGE":"Your payment is processing - Do not close your browser or click the back button","CHECKOUT_BUTTON_WHEN_PROCESSING_TEXT":"Processing","EFS_CROP_PICKER_NONE_LABEL":"Lien Duration","DISALLOWED_WIZARD_PIECES":["FormationLocale"],"REPEATER_SHOW_EDIT_BUTTON":true,"DATA_REQUEST_PAGE_TITLE":"Data Requests and Subscriptions","DATA_REQUEST_SIDEBAR_LABEL":"Data Requests & Subscriptions","LOGIN_REDIRECTS_TO_EPASS":false,"LOGIN_REDIRECTS_TO_ACTIVE_DIRECTORY":true,"LOGIN_ACTIVE_DIRECTORY_LINK":true,"FETCH_EDIT_USER_LINK":false,"LISTS_FETCH_AVAILABLE_LISTS":true,"POST_WIZARD_SUBMIT_REDIRECT_URL":"/","PIN_REQUEST_ATTESTATIONS":true,"PIN_REQUEST_DESCRIPTION":"Click **Request PIN** to have a new PIN sent to the account holder's email address on file.","OWNERSHIP_REQUEST_DESCRIPTION":"To become an **authorized user** of this record, a current **AUTHORIZED USER** will need to grant you access. To request access, click **Request Access** below.","PIN_REQUEST_SUCCESS_MESSAGE":"The PIN you have requested for this entity has been sent to the email associated with your user account.  You should receive the PIN in approximately 3-5 minutes, depending on your email service provider.","APOSTILLE_HEADER_LABEL":"Verification Information","APOSTILLE_NUMBER_LABEL":"Apostille/Authentication","APOSTILLE_CITY_STATE_OVERRIDE":"HELENA, MT","APOSTILLE_FILING_DATE_LABEL":"Issue Date","APOSTILLE_CITY_STATE_IN_CERTIFIED":true,"NOTARY_EXISTING_FILING":true,"ALLOW_REVOKE_OWN_ACCESS_ONLY":false,"HIDE_CANCEL_ON_ONETIME_DATA_REQUESTS":true,"DATA_REQUESTS_IN_SHOPPING_CART":true,"WQ_ALLOW_EDIT_PENDING_PAYMENT":true,"WQ_CONFIRM_ON_DELETE":true,"WQ_DELETE_CONFIRM_MESSAGE":"Deleting this filing will forfeit any money already paid to the Secretary of State. This action is permanent and cannot be undone, are you sure you would like to delete?","PASS_ITEM_GUIDS_ON_CHECKOUT":true,"FORM_REVISION_HISTORY":true,"CHECKOUT_DISCLAIMER":"By entering your credit card and/or checking account information you (i) state that **you are an authorized user** of the credit card and/or electronic check and that the associated information entered (e.g., account holder name, account number, billing address) is accurate, (ii) **you authorize payment processor to charge the amount you have requested** to your credit card and/or funding account, and (iii) **acknowledge if a charge is declined or reversed you may also be assessed a customary charge** by the payment processor for such transactions.","FARM_BILL_SEARCH_CONFIDENTIAL":"As a registered Farm Bill Buyer with the Montana Secretary of State’s office it is important to maintain the confidentiality of the information contained within the Farm Bill Master List. The Farm Bill Master List reflects personal data, such as Social Security Numbers, which are a key piece of personal identifiable information to assist you in determining the existence of a lien against a specific debtor. The distribution of this information beyond its intended purpose is strictly prohibited.\n\n**The debtor's tax identification number has been hidden for confidentiality reasons. You may continue to search on a tax ID number and return debtors that match your search criteria. The SSN/FEIN must be entered without dashes or spaces.  If you need access to the tax identification number to clearly identify the debtor, please contact the UCC unit at (406) 444-3665.**","VIEW_HISTORY_BUTTON_ALT_TEXT":"View Filings","WIZARD_ERROR_TITLE_MESSAGE":"Form Error","FARM_BILL_SEARCH_INTERACTIVE":true,"USE_FARM_BILL_API":true,"DISALLOW_ASSIGN_SELF_AS_RA":true,"DISALLOW_ASSIGN_SELF_AS_PRINCIPAL":true,"USE_TRADEMARK_OWNER_VALIDATION":true,"USE_ALTERNATIVE_FOREIGN_ADDRESS_LABELS":true,"MY_RECEIPTS_FILTER":[{"type":"dateRange","name":"DATE_RANGE","label":"Date range","defaultValue":{"start":null,"end":null}},{"type":"text","name":"REF_NUM","defaultValue":"","label":"Reference Number"},{"type":"text","name":"RECEIPT_NUM","defaultValue":"","label":"Receipt Id"},{"type":"text","name":"AMOUNT","defaultValue":"","label":"Amount"},{"type":"select","name":"TYPE","defaultValue":"","label":"Payment Type","options":[{"value":"","label":"All"},{"value":"CC","label":"Credit Card"},{"value":"Check","label":"Check"}]}],"MY_RECEIPTS_SHOW_IN_SIDEBAR":true,"SHOW_MY_RECEIPTS_HELPER_TEXT":true,"MY_RECEIPTS_HELPER_LABEL":"About Receipt Search","MY_RECEIPTS_HELPER_TEXT":"You can search for receipts based on their descriptions, including the items paid for on the receipt. Use the filters to search for or filter specific information.","FARM_BILL_SUBLINK":{"label":"Farm Bill","component":"FarmBill","parameter":"farm-bill","path":"/lists/farm-bill","sourceTypeId":0,"myRecordsSearch":false,"allowedRules":["/search/"],"disabled":true,"searchDescription":"To perform a search, enter a debtor name. Your search results may include: exact debtor name, variations of that name and any filing that includes your search criteria. Punctuation is ignored.\n\nYou can click on \"Advanced\" to refine your search. Under “Advanced” you can search by crop, year, county and SSN/FEIN. As a registered Farm Bill Buyer with the Montana Secretary of State’s office it is important to maintain the confidentiality of the information contained within the Farm Bill Master List. The Farm Bill Master List reflects personal data, such as Social Security Numbers, which are a key piece of personal identifiable information to assist you in determining the existence of a lien against a specific debtor. The distribution of this information beyond its intended purpose is strictly prohibited.\n\nThe debtor's tax identification number has been hidden for confidentiality reasons. You may continue to search on a tax ID number and return debtors that match your search criteria. The SSN/FEIN must be entered without dashes or spaces.","searchMustHaveOneOf":["search","UCC_FARM_PRODUCT_ID","COUNTY"],"searchPlaceholder":"Search by debtor name","advancedSearchParameters":[{"type":"ServerMultiComplete","label":"Product code name(s)","name":"UCC_FARM_PRODUCT_ID","defaultValue":"","optionsSrc":"UCC_FARM_PRODUCT_V"},{"type":"MultiComplete","label":"Year or Range of Years","name":"YEAR_NUM","optionsSrc":"years","startYear":"1968","defaultValue":[],"preMergeOptions":[{"value":"ALL","label":"All"}]},{"type":"serverSelect","label":"State","name":"STATE","defaultValue":"MONTANA","optionsSrc":"STATE"},{"type":"ServerMultiComplete","label":"County","name":"COUNTY","defaultValue":[],"optionsSrc":"COUNTY","overrideSubOptionsSrcFromParameterName":"STATE"},{"type":"checkbox","name":"TIN_SEARCH_YN","defaultValue":false,"label":"Tax Identification Number Search"},{"type":"checkbox","name":"TIN_SORT_YN","defaultValue":false,"label":"Unique ID Sort"}]},"ALLOW_ADDRESS_VALIDATION_BYPASS_OPTION":true,"DEFAULT_ADDRESS_VALIDATION_BYPASS_OPTION_CHECKED":true}).LOGIN_HEADER_BACKGROUND;
	var LOGIN_FORGOT_USERNAME_LABEL = ({"NODE_ENV":"production","BUILD_DATE":"2025-08-27T15:15:31.687Z","BUILD_NUMBER":"Not Provided","GIT_VERSION":"v1.3.0-381-ga81e29b08","GIT_COMMIT_HASH":"a81e29b085c9268ffd96c78eb734365802722741","GIT_BRANCH":"beta","PUBLIC_URL":"","STATE_ABBR":"MT","STATE_NAME":"Montana","STATE_ORG_TITLE":"Secretary of State","LOGIN_HEADER_IMG_PATH":"","HOME_IMG_FILENAME":"montana.jpg","FAVICON_FILE_NAME":"favicon.ico","ALLOW_E_SIGN_ON_CORRECTIONS":true,"THIRD_PARTY_SIGNING_ALLOWED":false,"MY_ACCOUNT_SAVE_AND_CLOSE_BUTTON":true,"IE_DEPRECATED_MESSAGE":"Internet Explorer is not supported. Please select a supported browser below to access this website.","ADDITIONAL_ROUTES":{"dataRequests":true,"farmBill":true,"apostille":true,"externalHelp":"https://sosmt.gov/business/help-center/","systemAdministration":[{"title":"Saved Payments","parameter":"saved-payments","componentName":"SavedPayments"}]},"SUBROUTES":[{"label":"Business","component":"Business","parameter":"business","myWorkQueueSearch":false,"sourceTypeId":54,"searchMustHaveOneOf":["FILING_TYPE_ID","STATUS_ID","STATE","search"],"serverWebSearchDescription":true,"serverWorkQueueDescription":true,"serverMyRecordsDescription":true,"searchPlaceholder":"Search by name or filing number (X########)","allowEmptySearchTerm":true,"requestCertificateAlternateLabel":"Request Information","fileAmendmentButtonLabel":"Filing Actions","advancedSearchParameters":[{"type":"radio","name":"QUERY_TYPE_ID","defaultValue":1010,"options":[{"value":1010,"label":"Starts with"},{"value":1011,"label":"Contains"},{"value":1012,"label":" Word Contains"}]},{"type":"serverSelect","name":"FILING_TYPE_ID","optionsSrc":"FILING_TYPES","label":"Entity Type","placeholder":"All","defaultValue":"0"},{"type":"serverSelect","name":"FILING_SUBTYPE_ID","optionsSrc":"FILING_SUBTYPES","label":"Entity Subtype","overrideSubOptionsSrcFromParameterName":"FILING_TYPE_ID","placeholder":"All","defaultValue":"0"},{"type":"serverSelect","name":"STATUS_ID","optionsSrc":"FILING_STATUS_WITHOUT_ALL","label":"Status","placeholder":"All","defaultValue":"0"},{"type":"serverSelect","name":"STATE","optionsSrc":"STATE","label":"State","placeholder":"All","defaultValue":""},{"type":"serverSelect","name":"COUNTY","optionsSrc":"COUNTY_SUBOPTION","label":"County","overrideSubOptionsSrcFromParameterName":"STATE","placeholder":"All","defaultValue":""},{"type":"checkbox","name":"CRA_SEARCH_YN","defaultValue":false,"label":"Search by Registered Agent PID"},{"type":"dateRange","name":"FILING_DATE","label":"Registration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}},{"type":"dateRange","name":"EXPIRATION_DATE","label":"Expiration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}}],"myRecordsFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Active"},{"value":2,"label":"Inactive"},{"value":3,"label":"Pending"}]},{"type":"dateRange","name":"DATE_RANGE","label":"Date range","defaultValue":{"start":null,"end":null}}],"myWorkQueueFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Approved"},{"value":2,"label":"Pending Online Payment"},{"value":3,"label":"Pending Review"},{"value":4,"label":"Needs Correction"},{"value":5,"label":"Rejected"},{"value":6,"label":"Draft"}]},{"type":"dateRange","name":"DATE_RANGE","label":"Date range","defaultValue":{"start":null,"end":null}}]},{"label":"Notary","component":"Notary","parameter":"notary","sourceTypeId":850,"myWorkQueueSearch":false,"allowEmptySearchTerm":true,"requestCertificateAlternateLabel":"Download Certificate","fileAmendmentButtonLabel":"Filing Actions","hideNameRequestCertificate":true,"hideAddressRequestCertificate":true,"hideRecordUserManagment":true,"searchPlaceholder":"Search by name or commission number","searchMustHaveOneOf":["CITY","search","SERVICE_TYPE"],"advancedParametersStartOpen":true,"searchIsSortable":true,"advancedSearchParameters":[{"type":"radio","name":"STARTS_WITH_YN","defaultValue":false,"options":[{"value":true,"label":"Starts with"},{"value":false,"label":"Contains"}]},{"type":"checkbox","name":"ACTIVE_ONLY_YN","defaultValue":true,"label":"Active entities only"},{"type":"text","name":"CITY","defaultValue":"","label":"City"},{"type":"select","name":"SERVICE_TYPE","label":"Special Services Offered","defaultValue":0,"options":[{"value":0,"label":"(N/A)"},{"value":6165,"label":"In-Person Electronic Notarization (IPEN)"},{"value":6166,"label":"Remote Online Notarization (RON)"},{"value":6167,"label":"Mobile Notary Services"},{"value":6168,"label":"Remote Ink Notarization (RIN)"}]}]},{"label":"Apostille","component":"Apostille","parameter":"apostille","sourceTypeId":720,"myRecordsSearch":false,"myWorkQueueSearch":false,"disabled":false,"allowedRoutes":["/forms-manager/","/queue/","/forms/"]},{"label":"Liens","component":"UCC","parameter":"ucc","sourceTypeId":1999,"myRecordsSearch":true,"myWorkQueueSearch":true,"fileAmendmentButtonLabel":"Filing Actions","searchPlaceholder":"Search by name or file number","disabled":false,"serverWebSearchDescription":true,"myRecordsDescription":"","workQueueDescription":"","searchDescription":"","hideRecordUserManagment":true,"searchLiensCheckout":false,"advancedSearchParameters":[{"type":"radio","name":"STARTS_WITH_YN","defaultValue":false,"options":[{"value":true,"label":"Starts with"},{"value":false,"label":"Contains"}]},{"type":"select","name":"STATUS","defaultValue":"ALL","label":"Status","options":[{"value":"ACTIVE_UNLAPSED","label":"Active (unlapsed)"},{"value":"ACTIVE_LAPSED_UNLAPSED","label":"Active (lapsed and unlapsed)"}]},{"type":"text","name":"EXCLUDE_VALUES","label":"Exclude Debtor Names (comma separated list of names to exclude)","defaultValue":""},{"type":"dateRange","name":"FILING_DATE","label":"Financing Statement Date","defaultValue":{"start":null,"end":null}},{"type":"dateRange","name":"LAPSE_DATE","label":"Lapse Date","defaultValue":{"start":null,"end":null}},{"type":"text","name":"CITY","label":"Debtor City","defaultValue":""}],"myRecordsFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Approved"},{"value":2,"label":"Pending Online Payment"},{"value":3,"label":"Pending Review"}]},{"type":"select","name":"TYPE","defaultValue":0,"label":"Lien Type","options":[{"value":0,"label":"All"},{"value":1,"label":"UCC"},{"value":2,"label":"EFS"},{"value":3,"label":"Title 71"}]}],"myWorkQueueFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Approved"},{"value":2,"label":"Pending Online Payment"},{"value":3,"label":"Pending Review"},{"value":4,"label":"Pending Print and Mail"},{"value":5,"label":"Rejected"},{"value":6,"label":"Draft"}]},{"type":"select","name":"TYPE","defaultValue":0,"label":"Lien Type","options":[{"value":0,"label":"All"},{"value":1,"label":"UCC"},{"value":2,"label":"EFS"},{"value":3,"label":"Title 71"}]}]},{"label":"Copy Request","component":"copies","parameter":"copies","sourceTypeId":2001,"myRecordsSearch":false,"myWorkQueueSearch":false,"disabled":false,"allowedRoutes":["/forms-manager/","/queue/","/forms/"]},{"label":"Trademark","component":"Trademark","parameter":"trademark","sourceTypeId":810,"showRequestCertificate":true,"searchMustHaveOneOf":["search","EXPIRATION_DATE","FILING_DATE"],"allowEmptySearchTerm":true,"requestCertificateAlternateLabel":"Request Information","fileAmendmentButtonLabel":"Filing Actions","advancedSearchParameters":[{"type":"radio","name":"QUERY_TYPE_ID","defaultValue":1010,"options":[{"value":1010,"label":"Starts with"},{"value":1011,"label":"Contains"},{"value":1012,"label":" Word Contains"}]},{"type":"checkbox","name":"OWNER_SEARCH_YN","defaultValue":false,"label":"Search owners"},{"type":"radio","name":"SERVICE_MARK_YN","label":"Mark Type","defaultValue":"","options":[{"value":"","label":"All Marks"},{"value":"Y","label":"Service Mark"},{"value":"N","label":"Trademark"}]},{"type":"serverSelect","name":"STATUS_ID","optionsSrc":"TYPE_V|TRADEMARK_STATUS_TYPE","label":"Status","placeholder":"All","defaultValue":"0"},{"type":"select","name":"DESIGN_TYPE_ID","options":[{"value":0,"label":"All"},{"value":990,"label":"Words Only"},{"value":991,"label":"Design Only"},{"value":992,"label":"Words and Design"}],"label":"Design Type","defaultValue":"0"},{"type":"dateRange","name":"FILING_DATE","label":"Registered Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}},{"type":"dateRange","name":"EXPIRATION_DATE","label":"Expiration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}}]},{"label":"Business Info Request","component":"InfoRequests","parameter":"info-request","sourceTypeId":167,"allowedRoutes":["/forms-manager/","/queue/","/forms/"]},{"label":"Data Requests","component":"DataRequests","parameter":"data-request","sourceTypeId":0,"allowedRoutes":["/forms-manager/"]},{"label":"CRA","component":"CRA","parameter":"cra","sourceTypeId":157,"myRecordsSearch":false,"searchPlaceholder":"Search by name or registered agent number","allowedRoutes":["/forms-manager/","/forms/","/records/","/queue/","/search/"],"allowEmptySearchTerm":true,"fileAmendmentButtonLabel":"Filing Actions","advancedSearchParameters":[{"type":"radio","name":"QUERY_TYPE_ID","defaultValue":1010,"options":[{"value":1010,"label":"Starts with"},{"value":1011,"label":"Contains"},{"value":1012,"label":" Word Contains"}]},{"type":"dateRange","name":"CRA_DATE","label":"Registration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}},{"type":"select","name":"STATUS_ID","label":"Status","defaultValue":0,"options":[{"value":0,"label":"All"},{"value":121,"label":"Active"},{"value":122,"label":"Inactive"}]},{"type":"select","name":"AGENT_TYPE_ID","label":"Agent Type","defaultValue":0,"options":[{"value":0,"label":"All"},{"value":460,"label":"Registered Agent"},{"value":461,"label":"Commercial Registered Agent"}]}]},{"label":"Farm Bill","component":"FarmBill","parameter":"farm-bill","path":"/lists/farm-bill","sourceTypeId":0,"myRecordsSearch":false,"allowedRules":["/search/"],"disabled":true,"searchDescription":"To perform a search, enter a debtor name. Your search results may include: exact debtor name, variations of that name and any filing that includes your search criteria. Punctuation is ignored.\n\nYou can click on \"Advanced\" to refine your search. Under “Advanced” you can search by crop, year, county and SSN/FEIN. As a registered Farm Bill Buyer with the Montana Secretary of State’s office it is important to maintain the confidentiality of the information contained within the Farm Bill Master List. The Farm Bill Master List reflects personal data, such as Social Security Numbers, which are a key piece of personal identifiable information to assist you in determining the existence of a lien against a specific debtor. The distribution of this information beyond its intended purpose is strictly prohibited.\n\nThe debtor's tax identification number has been hidden for confidentiality reasons. You may continue to search on a tax ID number and return debtors that match your search criteria. The SSN/FEIN must be entered without dashes or spaces.","searchMustHaveOneOf":["search","UCC_FARM_PRODUCT_ID","COUNTY"],"searchPlaceholder":"Search by debtor name","advancedSearchParameters":[{"type":"ServerMultiComplete","label":"Product code name(s)","name":"UCC_FARM_PRODUCT_ID","defaultValue":"","optionsSrc":"UCC_FARM_PRODUCT_V"},{"type":"MultiComplete","label":"Year or Range of Years","name":"YEAR_NUM","optionsSrc":"years","startYear":"1968","defaultValue":[],"preMergeOptions":[{"value":"ALL","label":"All"}]},{"type":"serverSelect","label":"State","name":"STATE","defaultValue":"MONTANA","optionsSrc":"STATE"},{"type":"ServerMultiComplete","label":"County","name":"COUNTY","defaultValue":[],"optionsSrc":"COUNTY","overrideSubOptionsSrcFromParameterName":"STATE"},{"type":"checkbox","name":"TIN_SEARCH_YN","defaultValue":false,"label":"Tax Identification Number Search"},{"type":"checkbox","name":"TIN_SORT_YN","defaultValue":false,"label":"Unique ID Sort"}]}],"SYSTEM_NICKNAME":"Online Services Portal","PAYMENT_METHODS":[{"type":"bypass"},{"type":"iTransact"}],"PAYMENT_ALLOW_AMEX":true,"SYSTEM_ID_LABEL":"System Id","DOUBLE_COLUMN_PUBLIC_LOGIN":true,"INTERNAL_USER_MANAGEMENT":true,"ALLOW_PUBLIC_JSON_IMPORT":false,"MAX_FILE_UPLOAD_SIZE":10000000,"REFUND_TEXT":"","RETURN_TO_HOME_ON_LOGOUT":true,"CURRENT_SOS_NAME":"Christi Jacobsen","LOGO_FILENAME":"mt-sos-logo.png","LOGO_ALT":"Christi Jacobsen, Montana Secretary of State","LOGO_FULL_WIDTH":true,"HOME_HIDE_AUTH_HINT":true,"HOME_TITLE":"Montana Secretary of State","CUSTOM_TAB_TITLE":"Official Montana","HOME_SUBTITLE":"Online Business Services","ENTITY_NAME_CONSENT_DESCRIPTION":"","ALLOW_USER_PROFILE_EDITING":true,"COMPARE_FOREIGN_NAME_IN_ENTITY_NAME_VALIDATION":true,"FOREIGN_NAME_FIELD_NAME":"KIMA_PARENT_NAME_INFO","LOGIN_TITLE":"Montana Secretary of State Online Filing Portal Login","PUBLIC_LOGIN_LABEL":"Username","REVERSE_LOGIN_COLUMNS":true,"LOGIN_SEAL_FILENAME":"seal_white.png","SEPARATE_USERNAME_AND_EMAIL":true,"CREATE_ACCOUNT_BUTTON_ALIGN_LEFT":true,"CREATE_ACCOUNT_BUTTON_TEXT":"CREATE AN ACCOUNT","PASSWORD_CUSTOM_ERROR_TEXT":"The password must meet all requirements","ACCOUNT_CREATED_MESSAGE":"Please check your email to verify your account to login and allow a few minutes for this message to arrive. Check your junk/spam folders if you do not find the email in your inbox.","PUBLIC_LOGIN_PLACEHOLDER":" ","DISABLE_DEFAULT_PAYMENT_RADIO":true,"CUSTOM_RESET_PASSWORD_ERROR_MESSAGE":"Username invalid - no account found","PUBLIC_LOGIN_CREATE_DESCRIPTION":"### Existing User:\n\n  - Enter your username and password to login.  \n\n\n  #### - OR -  \n\n\n\n  - Forgot password? Click 'Reset Password' and follow the prompts.\n  - Forgot username? Click 'Forgot Username' and follow the prompts.  \n\n\n  ### New User:\n  ","LOGIN_HELP_LINK":"https://sosmt.gov/business/how-do-i/","LOGIN_HELP_LINK_TEXT":"Need Help?","FORGOT_USERNAME_TEXT":"Forgot Username?","LOGIN_ACTIVE_DIRECTORY_TEXT":"State User Login","MULTIPLE_LOGIN_METHODS":true,"HAS_ACTIVE_DIRECTORY_LOGIN":true,"RESET_PASSWORD_WITH_USERNAME":true,"DOWNLOAD_LINK":true,"SHOW_USERNAME_ACCOUNT_CREATE":true,"SHOW_SCROLL_DOWN_ARROW":true,"SHOW_ADDRESS_ACCOUNT_CREATE":true,"TWO_COLUMN_ACCOUNT_CREATE":true,"RESET_PASSWORD_TIP":"A link to change your password has been sent to your email. Please allow a few minutes for this message to arrive. Please check your junk/spam folders if you do not find the email in your inbox.","FORGOT_PASSWORD_LINK_TEXT":"Reset Password","PHONE_NUMBER_OPTIONAL_ACCOUNT_CREATE":true,"SHOW_REQUIRED_INDICATOR_ACCOUNT_CREATE":true,"PASSWORD_REQUIREMENTS_ACCOUNT_CREATE":"\n    <ul>\n      <li>MUST contain at least 8 characters (12+ recommended)</li>\n      <li>MUST contain at least one uppercase letter.</li>\n      <li>MUST contain at least one lowercase letter.</li>\n      <li>MUST contain at least one number.</li>\n      <li>MUST contain at least one special character (!”#$%&'()*+,-./:;<=>?</li>\n    </ul>\n  ","ALLOW_CERTIFICATION_REQUEST":true,"ALLOW_PUBLIC_CERTIFICATE_REQUEST":true,"ALLOW_COPY_REQUEST":false,"ALLOW_CORRECTION_STYLING":true,"HIDE_DEPRECATION_WARNING":false,"AMEND_ROUTE_PUBLIC":true,"SEAL_FILENAME":"seal.png","SHOPPING_CART":true,"ALLOW_PAYMENT_UPDATE_WITH_EMPTY_CART":true,"RA_EMAIL":true,"RA_WEBSITE":true,"RA_NO_DEFAULT_TYPE":true,"RA_ADDRESS_LABEL":"Street Address","RA_TYPE_SELECTION_DEFAULT":true,"RA_DEFAULT_TYPE":"460","RA_OVERRIDE_TYPE_WITH_DEFAULT":true,"RA_PRINCIPAL_ADDRESS_AMS":true,"UPLOAD_AND_SUBMIT_HIDE_IF_ONE_OPTION":true,"PAYMENT_PROCESSING_MESSAGE":"Your payment is processing - Do not close your browser or click the back button","CHECKOUT_BUTTON_WHEN_PROCESSING_TEXT":"Processing","EFS_CROP_PICKER_NONE_LABEL":"Lien Duration","DISALLOWED_WIZARD_PIECES":["FormationLocale"],"REPEATER_SHOW_EDIT_BUTTON":true,"DATA_REQUEST_PAGE_TITLE":"Data Requests and Subscriptions","DATA_REQUEST_SIDEBAR_LABEL":"Data Requests & Subscriptions","LOGIN_REDIRECTS_TO_EPASS":false,"LOGIN_REDIRECTS_TO_ACTIVE_DIRECTORY":true,"LOGIN_ACTIVE_DIRECTORY_LINK":true,"FETCH_EDIT_USER_LINK":false,"LISTS_FETCH_AVAILABLE_LISTS":true,"POST_WIZARD_SUBMIT_REDIRECT_URL":"/","PIN_REQUEST_ATTESTATIONS":true,"PIN_REQUEST_DESCRIPTION":"Click **Request PIN** to have a new PIN sent to the account holder's email address on file.","OWNERSHIP_REQUEST_DESCRIPTION":"To become an **authorized user** of this record, a current **AUTHORIZED USER** will need to grant you access. To request access, click **Request Access** below.","PIN_REQUEST_SUCCESS_MESSAGE":"The PIN you have requested for this entity has been sent to the email associated with your user account.  You should receive the PIN in approximately 3-5 minutes, depending on your email service provider.","APOSTILLE_HEADER_LABEL":"Verification Information","APOSTILLE_NUMBER_LABEL":"Apostille/Authentication","APOSTILLE_CITY_STATE_OVERRIDE":"HELENA, MT","APOSTILLE_FILING_DATE_LABEL":"Issue Date","APOSTILLE_CITY_STATE_IN_CERTIFIED":true,"NOTARY_EXISTING_FILING":true,"ALLOW_REVOKE_OWN_ACCESS_ONLY":false,"HIDE_CANCEL_ON_ONETIME_DATA_REQUESTS":true,"DATA_REQUESTS_IN_SHOPPING_CART":true,"WQ_ALLOW_EDIT_PENDING_PAYMENT":true,"WQ_CONFIRM_ON_DELETE":true,"WQ_DELETE_CONFIRM_MESSAGE":"Deleting this filing will forfeit any money already paid to the Secretary of State. This action is permanent and cannot be undone, are you sure you would like to delete?","PASS_ITEM_GUIDS_ON_CHECKOUT":true,"FORM_REVISION_HISTORY":true,"CHECKOUT_DISCLAIMER":"By entering your credit card and/or checking account information you (i) state that **you are an authorized user** of the credit card and/or electronic check and that the associated information entered (e.g., account holder name, account number, billing address) is accurate, (ii) **you authorize payment processor to charge the amount you have requested** to your credit card and/or funding account, and (iii) **acknowledge if a charge is declined or reversed you may also be assessed a customary charge** by the payment processor for such transactions.","FARM_BILL_SEARCH_CONFIDENTIAL":"As a registered Farm Bill Buyer with the Montana Secretary of State’s office it is important to maintain the confidentiality of the information contained within the Farm Bill Master List. The Farm Bill Master List reflects personal data, such as Social Security Numbers, which are a key piece of personal identifiable information to assist you in determining the existence of a lien against a specific debtor. The distribution of this information beyond its intended purpose is strictly prohibited.\n\n**The debtor's tax identification number has been hidden for confidentiality reasons. You may continue to search on a tax ID number and return debtors that match your search criteria. The SSN/FEIN must be entered without dashes or spaces.  If you need access to the tax identification number to clearly identify the debtor, please contact the UCC unit at (406) 444-3665.**","VIEW_HISTORY_BUTTON_ALT_TEXT":"View Filings","WIZARD_ERROR_TITLE_MESSAGE":"Form Error","FARM_BILL_SEARCH_INTERACTIVE":true,"USE_FARM_BILL_API":true,"DISALLOW_ASSIGN_SELF_AS_RA":true,"DISALLOW_ASSIGN_SELF_AS_PRINCIPAL":true,"USE_TRADEMARK_OWNER_VALIDATION":true,"USE_ALTERNATIVE_FOREIGN_ADDRESS_LABELS":true,"MY_RECEIPTS_FILTER":[{"type":"dateRange","name":"DATE_RANGE","label":"Date range","defaultValue":{"start":null,"end":null}},{"type":"text","name":"REF_NUM","defaultValue":"","label":"Reference Number"},{"type":"text","name":"RECEIPT_NUM","defaultValue":"","label":"Receipt Id"},{"type":"text","name":"AMOUNT","defaultValue":"","label":"Amount"},{"type":"select","name":"TYPE","defaultValue":"","label":"Payment Type","options":[{"value":"","label":"All"},{"value":"CC","label":"Credit Card"},{"value":"Check","label":"Check"}]}],"MY_RECEIPTS_SHOW_IN_SIDEBAR":true,"SHOW_MY_RECEIPTS_HELPER_TEXT":true,"MY_RECEIPTS_HELPER_LABEL":"About Receipt Search","MY_RECEIPTS_HELPER_TEXT":"You can search for receipts based on their descriptions, including the items paid for on the receipt. Use the filters to search for or filter specific information.","FARM_BILL_SUBLINK":{"label":"Farm Bill","component":"FarmBill","parameter":"farm-bill","path":"/lists/farm-bill","sourceTypeId":0,"myRecordsSearch":false,"allowedRules":["/search/"],"disabled":true,"searchDescription":"To perform a search, enter a debtor name. Your search results may include: exact debtor name, variations of that name and any filing that includes your search criteria. Punctuation is ignored.\n\nYou can click on \"Advanced\" to refine your search. Under “Advanced” you can search by crop, year, county and SSN/FEIN. As a registered Farm Bill Buyer with the Montana Secretary of State’s office it is important to maintain the confidentiality of the information contained within the Farm Bill Master List. The Farm Bill Master List reflects personal data, such as Social Security Numbers, which are a key piece of personal identifiable information to assist you in determining the existence of a lien against a specific debtor. The distribution of this information beyond its intended purpose is strictly prohibited.\n\nThe debtor's tax identification number has been hidden for confidentiality reasons. You may continue to search on a tax ID number and return debtors that match your search criteria. The SSN/FEIN must be entered without dashes or spaces.","searchMustHaveOneOf":["search","UCC_FARM_PRODUCT_ID","COUNTY"],"searchPlaceholder":"Search by debtor name","advancedSearchParameters":[{"type":"ServerMultiComplete","label":"Product code name(s)","name":"UCC_FARM_PRODUCT_ID","defaultValue":"","optionsSrc":"UCC_FARM_PRODUCT_V"},{"type":"MultiComplete","label":"Year or Range of Years","name":"YEAR_NUM","optionsSrc":"years","startYear":"1968","defaultValue":[],"preMergeOptions":[{"value":"ALL","label":"All"}]},{"type":"serverSelect","label":"State","name":"STATE","defaultValue":"MONTANA","optionsSrc":"STATE"},{"type":"ServerMultiComplete","label":"County","name":"COUNTY","defaultValue":[],"optionsSrc":"COUNTY","overrideSubOptionsSrcFromParameterName":"STATE"},{"type":"checkbox","name":"TIN_SEARCH_YN","defaultValue":false,"label":"Tax Identification Number Search"},{"type":"checkbox","name":"TIN_SORT_YN","defaultValue":false,"label":"Unique ID Sort"}]},"ALLOW_ADDRESS_VALIDATION_BYPASS_OPTION":true,"DEFAULT_ADDRESS_VALIDATION_BYPASS_OPTION_CHECKED":true}).LOGIN_FORGOT_USERNAME_LABEL;
	var LOGIN_FORGOT_PASSWORD_LABEL = ({"NODE_ENV":"production","BUILD_DATE":"2025-08-27T15:15:31.687Z","BUILD_NUMBER":"Not Provided","GIT_VERSION":"v1.3.0-381-ga81e29b08","GIT_COMMIT_HASH":"a81e29b085c9268ffd96c78eb734365802722741","GIT_BRANCH":"beta","PUBLIC_URL":"","STATE_ABBR":"MT","STATE_NAME":"Montana","STATE_ORG_TITLE":"Secretary of State","LOGIN_HEADER_IMG_PATH":"","HOME_IMG_FILENAME":"montana.jpg","FAVICON_FILE_NAME":"favicon.ico","ALLOW_E_SIGN_ON_CORRECTIONS":true,"THIRD_PARTY_SIGNING_ALLOWED":false,"MY_ACCOUNT_SAVE_AND_CLOSE_BUTTON":true,"IE_DEPRECATED_MESSAGE":"Internet Explorer is not supported. Please select a supported browser below to access this website.","ADDITIONAL_ROUTES":{"dataRequests":true,"farmBill":true,"apostille":true,"externalHelp":"https://sosmt.gov/business/help-center/","systemAdministration":[{"title":"Saved Payments","parameter":"saved-payments","componentName":"SavedPayments"}]},"SUBROUTES":[{"label":"Business","component":"Business","parameter":"business","myWorkQueueSearch":false,"sourceTypeId":54,"searchMustHaveOneOf":["FILING_TYPE_ID","STATUS_ID","STATE","search"],"serverWebSearchDescription":true,"serverWorkQueueDescription":true,"serverMyRecordsDescription":true,"searchPlaceholder":"Search by name or filing number (X########)","allowEmptySearchTerm":true,"requestCertificateAlternateLabel":"Request Information","fileAmendmentButtonLabel":"Filing Actions","advancedSearchParameters":[{"type":"radio","name":"QUERY_TYPE_ID","defaultValue":1010,"options":[{"value":1010,"label":"Starts with"},{"value":1011,"label":"Contains"},{"value":1012,"label":" Word Contains"}]},{"type":"serverSelect","name":"FILING_TYPE_ID","optionsSrc":"FILING_TYPES","label":"Entity Type","placeholder":"All","defaultValue":"0"},{"type":"serverSelect","name":"FILING_SUBTYPE_ID","optionsSrc":"FILING_SUBTYPES","label":"Entity Subtype","overrideSubOptionsSrcFromParameterName":"FILING_TYPE_ID","placeholder":"All","defaultValue":"0"},{"type":"serverSelect","name":"STATUS_ID","optionsSrc":"FILING_STATUS_WITHOUT_ALL","label":"Status","placeholder":"All","defaultValue":"0"},{"type":"serverSelect","name":"STATE","optionsSrc":"STATE","label":"State","placeholder":"All","defaultValue":""},{"type":"serverSelect","name":"COUNTY","optionsSrc":"COUNTY_SUBOPTION","label":"County","overrideSubOptionsSrcFromParameterName":"STATE","placeholder":"All","defaultValue":""},{"type":"checkbox","name":"CRA_SEARCH_YN","defaultValue":false,"label":"Search by Registered Agent PID"},{"type":"dateRange","name":"FILING_DATE","label":"Registration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}},{"type":"dateRange","name":"EXPIRATION_DATE","label":"Expiration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}}],"myRecordsFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Active"},{"value":2,"label":"Inactive"},{"value":3,"label":"Pending"}]},{"type":"dateRange","name":"DATE_RANGE","label":"Date range","defaultValue":{"start":null,"end":null}}],"myWorkQueueFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Approved"},{"value":2,"label":"Pending Online Payment"},{"value":3,"label":"Pending Review"},{"value":4,"label":"Needs Correction"},{"value":5,"label":"Rejected"},{"value":6,"label":"Draft"}]},{"type":"dateRange","name":"DATE_RANGE","label":"Date range","defaultValue":{"start":null,"end":null}}]},{"label":"Notary","component":"Notary","parameter":"notary","sourceTypeId":850,"myWorkQueueSearch":false,"allowEmptySearchTerm":true,"requestCertificateAlternateLabel":"Download Certificate","fileAmendmentButtonLabel":"Filing Actions","hideNameRequestCertificate":true,"hideAddressRequestCertificate":true,"hideRecordUserManagment":true,"searchPlaceholder":"Search by name or commission number","searchMustHaveOneOf":["CITY","search","SERVICE_TYPE"],"advancedParametersStartOpen":true,"searchIsSortable":true,"advancedSearchParameters":[{"type":"radio","name":"STARTS_WITH_YN","defaultValue":false,"options":[{"value":true,"label":"Starts with"},{"value":false,"label":"Contains"}]},{"type":"checkbox","name":"ACTIVE_ONLY_YN","defaultValue":true,"label":"Active entities only"},{"type":"text","name":"CITY","defaultValue":"","label":"City"},{"type":"select","name":"SERVICE_TYPE","label":"Special Services Offered","defaultValue":0,"options":[{"value":0,"label":"(N/A)"},{"value":6165,"label":"In-Person Electronic Notarization (IPEN)"},{"value":6166,"label":"Remote Online Notarization (RON)"},{"value":6167,"label":"Mobile Notary Services"},{"value":6168,"label":"Remote Ink Notarization (RIN)"}]}]},{"label":"Apostille","component":"Apostille","parameter":"apostille","sourceTypeId":720,"myRecordsSearch":false,"myWorkQueueSearch":false,"disabled":false,"allowedRoutes":["/forms-manager/","/queue/","/forms/"]},{"label":"Liens","component":"UCC","parameter":"ucc","sourceTypeId":1999,"myRecordsSearch":true,"myWorkQueueSearch":true,"fileAmendmentButtonLabel":"Filing Actions","searchPlaceholder":"Search by name or file number","disabled":false,"serverWebSearchDescription":true,"myRecordsDescription":"","workQueueDescription":"","searchDescription":"","hideRecordUserManagment":true,"searchLiensCheckout":false,"advancedSearchParameters":[{"type":"radio","name":"STARTS_WITH_YN","defaultValue":false,"options":[{"value":true,"label":"Starts with"},{"value":false,"label":"Contains"}]},{"type":"select","name":"STATUS","defaultValue":"ALL","label":"Status","options":[{"value":"ACTIVE_UNLAPSED","label":"Active (unlapsed)"},{"value":"ACTIVE_LAPSED_UNLAPSED","label":"Active (lapsed and unlapsed)"}]},{"type":"text","name":"EXCLUDE_VALUES","label":"Exclude Debtor Names (comma separated list of names to exclude)","defaultValue":""},{"type":"dateRange","name":"FILING_DATE","label":"Financing Statement Date","defaultValue":{"start":null,"end":null}},{"type":"dateRange","name":"LAPSE_DATE","label":"Lapse Date","defaultValue":{"start":null,"end":null}},{"type":"text","name":"CITY","label":"Debtor City","defaultValue":""}],"myRecordsFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Approved"},{"value":2,"label":"Pending Online Payment"},{"value":3,"label":"Pending Review"}]},{"type":"select","name":"TYPE","defaultValue":0,"label":"Lien Type","options":[{"value":0,"label":"All"},{"value":1,"label":"UCC"},{"value":2,"label":"EFS"},{"value":3,"label":"Title 71"}]}],"myWorkQueueFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Approved"},{"value":2,"label":"Pending Online Payment"},{"value":3,"label":"Pending Review"},{"value":4,"label":"Pending Print and Mail"},{"value":5,"label":"Rejected"},{"value":6,"label":"Draft"}]},{"type":"select","name":"TYPE","defaultValue":0,"label":"Lien Type","options":[{"value":0,"label":"All"},{"value":1,"label":"UCC"},{"value":2,"label":"EFS"},{"value":3,"label":"Title 71"}]}]},{"label":"Copy Request","component":"copies","parameter":"copies","sourceTypeId":2001,"myRecordsSearch":false,"myWorkQueueSearch":false,"disabled":false,"allowedRoutes":["/forms-manager/","/queue/","/forms/"]},{"label":"Trademark","component":"Trademark","parameter":"trademark","sourceTypeId":810,"showRequestCertificate":true,"searchMustHaveOneOf":["search","EXPIRATION_DATE","FILING_DATE"],"allowEmptySearchTerm":true,"requestCertificateAlternateLabel":"Request Information","fileAmendmentButtonLabel":"Filing Actions","advancedSearchParameters":[{"type":"radio","name":"QUERY_TYPE_ID","defaultValue":1010,"options":[{"value":1010,"label":"Starts with"},{"value":1011,"label":"Contains"},{"value":1012,"label":" Word Contains"}]},{"type":"checkbox","name":"OWNER_SEARCH_YN","defaultValue":false,"label":"Search owners"},{"type":"radio","name":"SERVICE_MARK_YN","label":"Mark Type","defaultValue":"","options":[{"value":"","label":"All Marks"},{"value":"Y","label":"Service Mark"},{"value":"N","label":"Trademark"}]},{"type":"serverSelect","name":"STATUS_ID","optionsSrc":"TYPE_V|TRADEMARK_STATUS_TYPE","label":"Status","placeholder":"All","defaultValue":"0"},{"type":"select","name":"DESIGN_TYPE_ID","options":[{"value":0,"label":"All"},{"value":990,"label":"Words Only"},{"value":991,"label":"Design Only"},{"value":992,"label":"Words and Design"}],"label":"Design Type","defaultValue":"0"},{"type":"dateRange","name":"FILING_DATE","label":"Registered Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}},{"type":"dateRange","name":"EXPIRATION_DATE","label":"Expiration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}}]},{"label":"Business Info Request","component":"InfoRequests","parameter":"info-request","sourceTypeId":167,"allowedRoutes":["/forms-manager/","/queue/","/forms/"]},{"label":"Data Requests","component":"DataRequests","parameter":"data-request","sourceTypeId":0,"allowedRoutes":["/forms-manager/"]},{"label":"CRA","component":"CRA","parameter":"cra","sourceTypeId":157,"myRecordsSearch":false,"searchPlaceholder":"Search by name or registered agent number","allowedRoutes":["/forms-manager/","/forms/","/records/","/queue/","/search/"],"allowEmptySearchTerm":true,"fileAmendmentButtonLabel":"Filing Actions","advancedSearchParameters":[{"type":"radio","name":"QUERY_TYPE_ID","defaultValue":1010,"options":[{"value":1010,"label":"Starts with"},{"value":1011,"label":"Contains"},{"value":1012,"label":" Word Contains"}]},{"type":"dateRange","name":"CRA_DATE","label":"Registration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}},{"type":"select","name":"STATUS_ID","label":"Status","defaultValue":0,"options":[{"value":0,"label":"All"},{"value":121,"label":"Active"},{"value":122,"label":"Inactive"}]},{"type":"select","name":"AGENT_TYPE_ID","label":"Agent Type","defaultValue":0,"options":[{"value":0,"label":"All"},{"value":460,"label":"Registered Agent"},{"value":461,"label":"Commercial Registered Agent"}]}]},{"label":"Farm Bill","component":"FarmBill","parameter":"farm-bill","path":"/lists/farm-bill","sourceTypeId":0,"myRecordsSearch":false,"allowedRules":["/search/"],"disabled":true,"searchDescription":"To perform a search, enter a debtor name. Your search results may include: exact debtor name, variations of that name and any filing that includes your search criteria. Punctuation is ignored.\n\nYou can click on \"Advanced\" to refine your search. Under “Advanced” you can search by crop, year, county and SSN/FEIN. As a registered Farm Bill Buyer with the Montana Secretary of State’s office it is important to maintain the confidentiality of the information contained within the Farm Bill Master List. The Farm Bill Master List reflects personal data, such as Social Security Numbers, which are a key piece of personal identifiable information to assist you in determining the existence of a lien against a specific debtor. The distribution of this information beyond its intended purpose is strictly prohibited.\n\nThe debtor's tax identification number has been hidden for confidentiality reasons. You may continue to search on a tax ID number and return debtors that match your search criteria. The SSN/FEIN must be entered without dashes or spaces.","searchMustHaveOneOf":["search","UCC_FARM_PRODUCT_ID","COUNTY"],"searchPlaceholder":"Search by debtor name","advancedSearchParameters":[{"type":"ServerMultiComplete","label":"Product code name(s)","name":"UCC_FARM_PRODUCT_ID","defaultValue":"","optionsSrc":"UCC_FARM_PRODUCT_V"},{"type":"MultiComplete","label":"Year or Range of Years","name":"YEAR_NUM","optionsSrc":"years","startYear":"1968","defaultValue":[],"preMergeOptions":[{"value":"ALL","label":"All"}]},{"type":"serverSelect","label":"State","name":"STATE","defaultValue":"MONTANA","optionsSrc":"STATE"},{"type":"ServerMultiComplete","label":"County","name":"COUNTY","defaultValue":[],"optionsSrc":"COUNTY","overrideSubOptionsSrcFromParameterName":"STATE"},{"type":"checkbox","name":"TIN_SEARCH_YN","defaultValue":false,"label":"Tax Identification Number Search"},{"type":"checkbox","name":"TIN_SORT_YN","defaultValue":false,"label":"Unique ID Sort"}]}],"SYSTEM_NICKNAME":"Online Services Portal","PAYMENT_METHODS":[{"type":"bypass"},{"type":"iTransact"}],"PAYMENT_ALLOW_AMEX":true,"SYSTEM_ID_LABEL":"System Id","DOUBLE_COLUMN_PUBLIC_LOGIN":true,"INTERNAL_USER_MANAGEMENT":true,"ALLOW_PUBLIC_JSON_IMPORT":false,"MAX_FILE_UPLOAD_SIZE":10000000,"REFUND_TEXT":"","RETURN_TO_HOME_ON_LOGOUT":true,"CURRENT_SOS_NAME":"Christi Jacobsen","LOGO_FILENAME":"mt-sos-logo.png","LOGO_ALT":"Christi Jacobsen, Montana Secretary of State","LOGO_FULL_WIDTH":true,"HOME_HIDE_AUTH_HINT":true,"HOME_TITLE":"Montana Secretary of State","CUSTOM_TAB_TITLE":"Official Montana","HOME_SUBTITLE":"Online Business Services","ENTITY_NAME_CONSENT_DESCRIPTION":"","ALLOW_USER_PROFILE_EDITING":true,"COMPARE_FOREIGN_NAME_IN_ENTITY_NAME_VALIDATION":true,"FOREIGN_NAME_FIELD_NAME":"KIMA_PARENT_NAME_INFO","LOGIN_TITLE":"Montana Secretary of State Online Filing Portal Login","PUBLIC_LOGIN_LABEL":"Username","REVERSE_LOGIN_COLUMNS":true,"LOGIN_SEAL_FILENAME":"seal_white.png","SEPARATE_USERNAME_AND_EMAIL":true,"CREATE_ACCOUNT_BUTTON_ALIGN_LEFT":true,"CREATE_ACCOUNT_BUTTON_TEXT":"CREATE AN ACCOUNT","PASSWORD_CUSTOM_ERROR_TEXT":"The password must meet all requirements","ACCOUNT_CREATED_MESSAGE":"Please check your email to verify your account to login and allow a few minutes for this message to arrive. Check your junk/spam folders if you do not find the email in your inbox.","PUBLIC_LOGIN_PLACEHOLDER":" ","DISABLE_DEFAULT_PAYMENT_RADIO":true,"CUSTOM_RESET_PASSWORD_ERROR_MESSAGE":"Username invalid - no account found","PUBLIC_LOGIN_CREATE_DESCRIPTION":"### Existing User:\n\n  - Enter your username and password to login.  \n\n\n  #### - OR -  \n\n\n\n  - Forgot password? Click 'Reset Password' and follow the prompts.\n  - Forgot username? Click 'Forgot Username' and follow the prompts.  \n\n\n  ### New User:\n  ","LOGIN_HELP_LINK":"https://sosmt.gov/business/how-do-i/","LOGIN_HELP_LINK_TEXT":"Need Help?","FORGOT_USERNAME_TEXT":"Forgot Username?","LOGIN_ACTIVE_DIRECTORY_TEXT":"State User Login","MULTIPLE_LOGIN_METHODS":true,"HAS_ACTIVE_DIRECTORY_LOGIN":true,"RESET_PASSWORD_WITH_USERNAME":true,"DOWNLOAD_LINK":true,"SHOW_USERNAME_ACCOUNT_CREATE":true,"SHOW_SCROLL_DOWN_ARROW":true,"SHOW_ADDRESS_ACCOUNT_CREATE":true,"TWO_COLUMN_ACCOUNT_CREATE":true,"RESET_PASSWORD_TIP":"A link to change your password has been sent to your email. Please allow a few minutes for this message to arrive. Please check your junk/spam folders if you do not find the email in your inbox.","FORGOT_PASSWORD_LINK_TEXT":"Reset Password","PHONE_NUMBER_OPTIONAL_ACCOUNT_CREATE":true,"SHOW_REQUIRED_INDICATOR_ACCOUNT_CREATE":true,"PASSWORD_REQUIREMENTS_ACCOUNT_CREATE":"\n    <ul>\n      <li>MUST contain at least 8 characters (12+ recommended)</li>\n      <li>MUST contain at least one uppercase letter.</li>\n      <li>MUST contain at least one lowercase letter.</li>\n      <li>MUST contain at least one number.</li>\n      <li>MUST contain at least one special character (!”#$%&'()*+,-./:;<=>?</li>\n    </ul>\n  ","ALLOW_CERTIFICATION_REQUEST":true,"ALLOW_PUBLIC_CERTIFICATE_REQUEST":true,"ALLOW_COPY_REQUEST":false,"ALLOW_CORRECTION_STYLING":true,"HIDE_DEPRECATION_WARNING":false,"AMEND_ROUTE_PUBLIC":true,"SEAL_FILENAME":"seal.png","SHOPPING_CART":true,"ALLOW_PAYMENT_UPDATE_WITH_EMPTY_CART":true,"RA_EMAIL":true,"RA_WEBSITE":true,"RA_NO_DEFAULT_TYPE":true,"RA_ADDRESS_LABEL":"Street Address","RA_TYPE_SELECTION_DEFAULT":true,"RA_DEFAULT_TYPE":"460","RA_OVERRIDE_TYPE_WITH_DEFAULT":true,"RA_PRINCIPAL_ADDRESS_AMS":true,"UPLOAD_AND_SUBMIT_HIDE_IF_ONE_OPTION":true,"PAYMENT_PROCESSING_MESSAGE":"Your payment is processing - Do not close your browser or click the back button","CHECKOUT_BUTTON_WHEN_PROCESSING_TEXT":"Processing","EFS_CROP_PICKER_NONE_LABEL":"Lien Duration","DISALLOWED_WIZARD_PIECES":["FormationLocale"],"REPEATER_SHOW_EDIT_BUTTON":true,"DATA_REQUEST_PAGE_TITLE":"Data Requests and Subscriptions","DATA_REQUEST_SIDEBAR_LABEL":"Data Requests & Subscriptions","LOGIN_REDIRECTS_TO_EPASS":false,"LOGIN_REDIRECTS_TO_ACTIVE_DIRECTORY":true,"LOGIN_ACTIVE_DIRECTORY_LINK":true,"FETCH_EDIT_USER_LINK":false,"LISTS_FETCH_AVAILABLE_LISTS":true,"POST_WIZARD_SUBMIT_REDIRECT_URL":"/","PIN_REQUEST_ATTESTATIONS":true,"PIN_REQUEST_DESCRIPTION":"Click **Request PIN** to have a new PIN sent to the account holder's email address on file.","OWNERSHIP_REQUEST_DESCRIPTION":"To become an **authorized user** of this record, a current **AUTHORIZED USER** will need to grant you access. To request access, click **Request Access** below.","PIN_REQUEST_SUCCESS_MESSAGE":"The PIN you have requested for this entity has been sent to the email associated with your user account.  You should receive the PIN in approximately 3-5 minutes, depending on your email service provider.","APOSTILLE_HEADER_LABEL":"Verification Information","APOSTILLE_NUMBER_LABEL":"Apostille/Authentication","APOSTILLE_CITY_STATE_OVERRIDE":"HELENA, MT","APOSTILLE_FILING_DATE_LABEL":"Issue Date","APOSTILLE_CITY_STATE_IN_CERTIFIED":true,"NOTARY_EXISTING_FILING":true,"ALLOW_REVOKE_OWN_ACCESS_ONLY":false,"HIDE_CANCEL_ON_ONETIME_DATA_REQUESTS":true,"DATA_REQUESTS_IN_SHOPPING_CART":true,"WQ_ALLOW_EDIT_PENDING_PAYMENT":true,"WQ_CONFIRM_ON_DELETE":true,"WQ_DELETE_CONFIRM_MESSAGE":"Deleting this filing will forfeit any money already paid to the Secretary of State. This action is permanent and cannot be undone, are you sure you would like to delete?","PASS_ITEM_GUIDS_ON_CHECKOUT":true,"FORM_REVISION_HISTORY":true,"CHECKOUT_DISCLAIMER":"By entering your credit card and/or checking account information you (i) state that **you are an authorized user** of the credit card and/or electronic check and that the associated information entered (e.g., account holder name, account number, billing address) is accurate, (ii) **you authorize payment processor to charge the amount you have requested** to your credit card and/or funding account, and (iii) **acknowledge if a charge is declined or reversed you may also be assessed a customary charge** by the payment processor for such transactions.","FARM_BILL_SEARCH_CONFIDENTIAL":"As a registered Farm Bill Buyer with the Montana Secretary of State’s office it is important to maintain the confidentiality of the information contained within the Farm Bill Master List. The Farm Bill Master List reflects personal data, such as Social Security Numbers, which are a key piece of personal identifiable information to assist you in determining the existence of a lien against a specific debtor. The distribution of this information beyond its intended purpose is strictly prohibited.\n\n**The debtor's tax identification number has been hidden for confidentiality reasons. You may continue to search on a tax ID number and return debtors that match your search criteria. The SSN/FEIN must be entered without dashes or spaces.  If you need access to the tax identification number to clearly identify the debtor, please contact the UCC unit at (406) 444-3665.**","VIEW_HISTORY_BUTTON_ALT_TEXT":"View Filings","WIZARD_ERROR_TITLE_MESSAGE":"Form Error","FARM_BILL_SEARCH_INTERACTIVE":true,"USE_FARM_BILL_API":true,"DISALLOW_ASSIGN_SELF_AS_RA":true,"DISALLOW_ASSIGN_SELF_AS_PRINCIPAL":true,"USE_TRADEMARK_OWNER_VALIDATION":true,"USE_ALTERNATIVE_FOREIGN_ADDRESS_LABELS":true,"MY_RECEIPTS_FILTER":[{"type":"dateRange","name":"DATE_RANGE","label":"Date range","defaultValue":{"start":null,"end":null}},{"type":"text","name":"REF_NUM","defaultValue":"","label":"Reference Number"},{"type":"text","name":"RECEIPT_NUM","defaultValue":"","label":"Receipt Id"},{"type":"text","name":"AMOUNT","defaultValue":"","label":"Amount"},{"type":"select","name":"TYPE","defaultValue":"","label":"Payment Type","options":[{"value":"","label":"All"},{"value":"CC","label":"Credit Card"},{"value":"Check","label":"Check"}]}],"MY_RECEIPTS_SHOW_IN_SIDEBAR":true,"SHOW_MY_RECEIPTS_HELPER_TEXT":true,"MY_RECEIPTS_HELPER_LABEL":"About Receipt Search","MY_RECEIPTS_HELPER_TEXT":"You can search for receipts based on their descriptions, including the items paid for on the receipt. Use the filters to search for or filter specific information.","FARM_BILL_SUBLINK":{"label":"Farm Bill","component":"FarmBill","parameter":"farm-bill","path":"/lists/farm-bill","sourceTypeId":0,"myRecordsSearch":false,"allowedRules":["/search/"],"disabled":true,"searchDescription":"To perform a search, enter a debtor name. Your search results may include: exact debtor name, variations of that name and any filing that includes your search criteria. Punctuation is ignored.\n\nYou can click on \"Advanced\" to refine your search. Under “Advanced” you can search by crop, year, county and SSN/FEIN. As a registered Farm Bill Buyer with the Montana Secretary of State’s office it is important to maintain the confidentiality of the information contained within the Farm Bill Master List. The Farm Bill Master List reflects personal data, such as Social Security Numbers, which are a key piece of personal identifiable information to assist you in determining the existence of a lien against a specific debtor. The distribution of this information beyond its intended purpose is strictly prohibited.\n\nThe debtor's tax identification number has been hidden for confidentiality reasons. You may continue to search on a tax ID number and return debtors that match your search criteria. The SSN/FEIN must be entered without dashes or spaces.","searchMustHaveOneOf":["search","UCC_FARM_PRODUCT_ID","COUNTY"],"searchPlaceholder":"Search by debtor name","advancedSearchParameters":[{"type":"ServerMultiComplete","label":"Product code name(s)","name":"UCC_FARM_PRODUCT_ID","defaultValue":"","optionsSrc":"UCC_FARM_PRODUCT_V"},{"type":"MultiComplete","label":"Year or Range of Years","name":"YEAR_NUM","optionsSrc":"years","startYear":"1968","defaultValue":[],"preMergeOptions":[{"value":"ALL","label":"All"}]},{"type":"serverSelect","label":"State","name":"STATE","defaultValue":"MONTANA","optionsSrc":"STATE"},{"type":"ServerMultiComplete","label":"County","name":"COUNTY","defaultValue":[],"optionsSrc":"COUNTY","overrideSubOptionsSrcFromParameterName":"STATE"},{"type":"checkbox","name":"TIN_SEARCH_YN","defaultValue":false,"label":"Tax Identification Number Search"},{"type":"checkbox","name":"TIN_SORT_YN","defaultValue":false,"label":"Unique ID Sort"}]},"ALLOW_ADDRESS_VALIDATION_BYPASS_OPTION":true,"DEFAULT_ADDRESS_VALIDATION_BYPASS_OPTION_CHECKED":true}).LOGIN_FORGOT_PASSWORD_LABEL;
	var LOGIN_FOOTER_TEXT = ({"NODE_ENV":"production","BUILD_DATE":"2025-08-27T15:15:31.687Z","BUILD_NUMBER":"Not Provided","GIT_VERSION":"v1.3.0-381-ga81e29b08","GIT_COMMIT_HASH":"a81e29b085c9268ffd96c78eb734365802722741","GIT_BRANCH":"beta","PUBLIC_URL":"","STATE_ABBR":"MT","STATE_NAME":"Montana","STATE_ORG_TITLE":"Secretary of State","LOGIN_HEADER_IMG_PATH":"","HOME_IMG_FILENAME":"montana.jpg","FAVICON_FILE_NAME":"favicon.ico","ALLOW_E_SIGN_ON_CORRECTIONS":true,"THIRD_PARTY_SIGNING_ALLOWED":false,"MY_ACCOUNT_SAVE_AND_CLOSE_BUTTON":true,"IE_DEPRECATED_MESSAGE":"Internet Explorer is not supported. Please select a supported browser below to access this website.","ADDITIONAL_ROUTES":{"dataRequests":true,"farmBill":true,"apostille":true,"externalHelp":"https://sosmt.gov/business/help-center/","systemAdministration":[{"title":"Saved Payments","parameter":"saved-payments","componentName":"SavedPayments"}]},"SUBROUTES":[{"label":"Business","component":"Business","parameter":"business","myWorkQueueSearch":false,"sourceTypeId":54,"searchMustHaveOneOf":["FILING_TYPE_ID","STATUS_ID","STATE","search"],"serverWebSearchDescription":true,"serverWorkQueueDescription":true,"serverMyRecordsDescription":true,"searchPlaceholder":"Search by name or filing number (X########)","allowEmptySearchTerm":true,"requestCertificateAlternateLabel":"Request Information","fileAmendmentButtonLabel":"Filing Actions","advancedSearchParameters":[{"type":"radio","name":"QUERY_TYPE_ID","defaultValue":1010,"options":[{"value":1010,"label":"Starts with"},{"value":1011,"label":"Contains"},{"value":1012,"label":" Word Contains"}]},{"type":"serverSelect","name":"FILING_TYPE_ID","optionsSrc":"FILING_TYPES","label":"Entity Type","placeholder":"All","defaultValue":"0"},{"type":"serverSelect","name":"FILING_SUBTYPE_ID","optionsSrc":"FILING_SUBTYPES","label":"Entity Subtype","overrideSubOptionsSrcFromParameterName":"FILING_TYPE_ID","placeholder":"All","defaultValue":"0"},{"type":"serverSelect","name":"STATUS_ID","optionsSrc":"FILING_STATUS_WITHOUT_ALL","label":"Status","placeholder":"All","defaultValue":"0"},{"type":"serverSelect","name":"STATE","optionsSrc":"STATE","label":"State","placeholder":"All","defaultValue":""},{"type":"serverSelect","name":"COUNTY","optionsSrc":"COUNTY_SUBOPTION","label":"County","overrideSubOptionsSrcFromParameterName":"STATE","placeholder":"All","defaultValue":""},{"type":"checkbox","name":"CRA_SEARCH_YN","defaultValue":false,"label":"Search by Registered Agent PID"},{"type":"dateRange","name":"FILING_DATE","label":"Registration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}},{"type":"dateRange","name":"EXPIRATION_DATE","label":"Expiration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}}],"myRecordsFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Active"},{"value":2,"label":"Inactive"},{"value":3,"label":"Pending"}]},{"type":"dateRange","name":"DATE_RANGE","label":"Date range","defaultValue":{"start":null,"end":null}}],"myWorkQueueFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Approved"},{"value":2,"label":"Pending Online Payment"},{"value":3,"label":"Pending Review"},{"value":4,"label":"Needs Correction"},{"value":5,"label":"Rejected"},{"value":6,"label":"Draft"}]},{"type":"dateRange","name":"DATE_RANGE","label":"Date range","defaultValue":{"start":null,"end":null}}]},{"label":"Notary","component":"Notary","parameter":"notary","sourceTypeId":850,"myWorkQueueSearch":false,"allowEmptySearchTerm":true,"requestCertificateAlternateLabel":"Download Certificate","fileAmendmentButtonLabel":"Filing Actions","hideNameRequestCertificate":true,"hideAddressRequestCertificate":true,"hideRecordUserManagment":true,"searchPlaceholder":"Search by name or commission number","searchMustHaveOneOf":["CITY","search","SERVICE_TYPE"],"advancedParametersStartOpen":true,"searchIsSortable":true,"advancedSearchParameters":[{"type":"radio","name":"STARTS_WITH_YN","defaultValue":false,"options":[{"value":true,"label":"Starts with"},{"value":false,"label":"Contains"}]},{"type":"checkbox","name":"ACTIVE_ONLY_YN","defaultValue":true,"label":"Active entities only"},{"type":"text","name":"CITY","defaultValue":"","label":"City"},{"type":"select","name":"SERVICE_TYPE","label":"Special Services Offered","defaultValue":0,"options":[{"value":0,"label":"(N/A)"},{"value":6165,"label":"In-Person Electronic Notarization (IPEN)"},{"value":6166,"label":"Remote Online Notarization (RON)"},{"value":6167,"label":"Mobile Notary Services"},{"value":6168,"label":"Remote Ink Notarization (RIN)"}]}]},{"label":"Apostille","component":"Apostille","parameter":"apostille","sourceTypeId":720,"myRecordsSearch":false,"myWorkQueueSearch":false,"disabled":false,"allowedRoutes":["/forms-manager/","/queue/","/forms/"]},{"label":"Liens","component":"UCC","parameter":"ucc","sourceTypeId":1999,"myRecordsSearch":true,"myWorkQueueSearch":true,"fileAmendmentButtonLabel":"Filing Actions","searchPlaceholder":"Search by name or file number","disabled":false,"serverWebSearchDescription":true,"myRecordsDescription":"","workQueueDescription":"","searchDescription":"","hideRecordUserManagment":true,"searchLiensCheckout":false,"advancedSearchParameters":[{"type":"radio","name":"STARTS_WITH_YN","defaultValue":false,"options":[{"value":true,"label":"Starts with"},{"value":false,"label":"Contains"}]},{"type":"select","name":"STATUS","defaultValue":"ALL","label":"Status","options":[{"value":"ACTIVE_UNLAPSED","label":"Active (unlapsed)"},{"value":"ACTIVE_LAPSED_UNLAPSED","label":"Active (lapsed and unlapsed)"}]},{"type":"text","name":"EXCLUDE_VALUES","label":"Exclude Debtor Names (comma separated list of names to exclude)","defaultValue":""},{"type":"dateRange","name":"FILING_DATE","label":"Financing Statement Date","defaultValue":{"start":null,"end":null}},{"type":"dateRange","name":"LAPSE_DATE","label":"Lapse Date","defaultValue":{"start":null,"end":null}},{"type":"text","name":"CITY","label":"Debtor City","defaultValue":""}],"myRecordsFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Approved"},{"value":2,"label":"Pending Online Payment"},{"value":3,"label":"Pending Review"}]},{"type":"select","name":"TYPE","defaultValue":0,"label":"Lien Type","options":[{"value":0,"label":"All"},{"value":1,"label":"UCC"},{"value":2,"label":"EFS"},{"value":3,"label":"Title 71"}]}],"myWorkQueueFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Approved"},{"value":2,"label":"Pending Online Payment"},{"value":3,"label":"Pending Review"},{"value":4,"label":"Pending Print and Mail"},{"value":5,"label":"Rejected"},{"value":6,"label":"Draft"}]},{"type":"select","name":"TYPE","defaultValue":0,"label":"Lien Type","options":[{"value":0,"label":"All"},{"value":1,"label":"UCC"},{"value":2,"label":"EFS"},{"value":3,"label":"Title 71"}]}]},{"label":"Copy Request","component":"copies","parameter":"copies","sourceTypeId":2001,"myRecordsSearch":false,"myWorkQueueSearch":false,"disabled":false,"allowedRoutes":["/forms-manager/","/queue/","/forms/"]},{"label":"Trademark","component":"Trademark","parameter":"trademark","sourceTypeId":810,"showRequestCertificate":true,"searchMustHaveOneOf":["search","EXPIRATION_DATE","FILING_DATE"],"allowEmptySearchTerm":true,"requestCertificateAlternateLabel":"Request Information","fileAmendmentButtonLabel":"Filing Actions","advancedSearchParameters":[{"type":"radio","name":"QUERY_TYPE_ID","defaultValue":1010,"options":[{"value":1010,"label":"Starts with"},{"value":1011,"label":"Contains"},{"value":1012,"label":" Word Contains"}]},{"type":"checkbox","name":"OWNER_SEARCH_YN","defaultValue":false,"label":"Search owners"},{"type":"radio","name":"SERVICE_MARK_YN","label":"Mark Type","defaultValue":"","options":[{"value":"","label":"All Marks"},{"value":"Y","label":"Service Mark"},{"value":"N","label":"Trademark"}]},{"type":"serverSelect","name":"STATUS_ID","optionsSrc":"TYPE_V|TRADEMARK_STATUS_TYPE","label":"Status","placeholder":"All","defaultValue":"0"},{"type":"select","name":"DESIGN_TYPE_ID","options":[{"value":0,"label":"All"},{"value":990,"label":"Words Only"},{"value":991,"label":"Design Only"},{"value":992,"label":"Words and Design"}],"label":"Design Type","defaultValue":"0"},{"type":"dateRange","name":"FILING_DATE","label":"Registered Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}},{"type":"dateRange","name":"EXPIRATION_DATE","label":"Expiration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}}]},{"label":"Business Info Request","component":"InfoRequests","parameter":"info-request","sourceTypeId":167,"allowedRoutes":["/forms-manager/","/queue/","/forms/"]},{"label":"Data Requests","component":"DataRequests","parameter":"data-request","sourceTypeId":0,"allowedRoutes":["/forms-manager/"]},{"label":"CRA","component":"CRA","parameter":"cra","sourceTypeId":157,"myRecordsSearch":false,"searchPlaceholder":"Search by name or registered agent number","allowedRoutes":["/forms-manager/","/forms/","/records/","/queue/","/search/"],"allowEmptySearchTerm":true,"fileAmendmentButtonLabel":"Filing Actions","advancedSearchParameters":[{"type":"radio","name":"QUERY_TYPE_ID","defaultValue":1010,"options":[{"value":1010,"label":"Starts with"},{"value":1011,"label":"Contains"},{"value":1012,"label":" Word Contains"}]},{"type":"dateRange","name":"CRA_DATE","label":"Registration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}},{"type":"select","name":"STATUS_ID","label":"Status","defaultValue":0,"options":[{"value":0,"label":"All"},{"value":121,"label":"Active"},{"value":122,"label":"Inactive"}]},{"type":"select","name":"AGENT_TYPE_ID","label":"Agent Type","defaultValue":0,"options":[{"value":0,"label":"All"},{"value":460,"label":"Registered Agent"},{"value":461,"label":"Commercial Registered Agent"}]}]},{"label":"Farm Bill","component":"FarmBill","parameter":"farm-bill","path":"/lists/farm-bill","sourceTypeId":0,"myRecordsSearch":false,"allowedRules":["/search/"],"disabled":true,"searchDescription":"To perform a search, enter a debtor name. Your search results may include: exact debtor name, variations of that name and any filing that includes your search criteria. Punctuation is ignored.\n\nYou can click on \"Advanced\" to refine your search. Under “Advanced” you can search by crop, year, county and SSN/FEIN. As a registered Farm Bill Buyer with the Montana Secretary of State’s office it is important to maintain the confidentiality of the information contained within the Farm Bill Master List. The Farm Bill Master List reflects personal data, such as Social Security Numbers, which are a key piece of personal identifiable information to assist you in determining the existence of a lien against a specific debtor. The distribution of this information beyond its intended purpose is strictly prohibited.\n\nThe debtor's tax identification number has been hidden for confidentiality reasons. You may continue to search on a tax ID number and return debtors that match your search criteria. The SSN/FEIN must be entered without dashes or spaces.","searchMustHaveOneOf":["search","UCC_FARM_PRODUCT_ID","COUNTY"],"searchPlaceholder":"Search by debtor name","advancedSearchParameters":[{"type":"ServerMultiComplete","label":"Product code name(s)","name":"UCC_FARM_PRODUCT_ID","defaultValue":"","optionsSrc":"UCC_FARM_PRODUCT_V"},{"type":"MultiComplete","label":"Year or Range of Years","name":"YEAR_NUM","optionsSrc":"years","startYear":"1968","defaultValue":[],"preMergeOptions":[{"value":"ALL","label":"All"}]},{"type":"serverSelect","label":"State","name":"STATE","defaultValue":"MONTANA","optionsSrc":"STATE"},{"type":"ServerMultiComplete","label":"County","name":"COUNTY","defaultValue":[],"optionsSrc":"COUNTY","overrideSubOptionsSrcFromParameterName":"STATE"},{"type":"checkbox","name":"TIN_SEARCH_YN","defaultValue":false,"label":"Tax Identification Number Search"},{"type":"checkbox","name":"TIN_SORT_YN","defaultValue":false,"label":"Unique ID Sort"}]}],"SYSTEM_NICKNAME":"Online Services Portal","PAYMENT_METHODS":[{"type":"bypass"},{"type":"iTransact"}],"PAYMENT_ALLOW_AMEX":true,"SYSTEM_ID_LABEL":"System Id","DOUBLE_COLUMN_PUBLIC_LOGIN":true,"INTERNAL_USER_MANAGEMENT":true,"ALLOW_PUBLIC_JSON_IMPORT":false,"MAX_FILE_UPLOAD_SIZE":10000000,"REFUND_TEXT":"","RETURN_TO_HOME_ON_LOGOUT":true,"CURRENT_SOS_NAME":"Christi Jacobsen","LOGO_FILENAME":"mt-sos-logo.png","LOGO_ALT":"Christi Jacobsen, Montana Secretary of State","LOGO_FULL_WIDTH":true,"HOME_HIDE_AUTH_HINT":true,"HOME_TITLE":"Montana Secretary of State","CUSTOM_TAB_TITLE":"Official Montana","HOME_SUBTITLE":"Online Business Services","ENTITY_NAME_CONSENT_DESCRIPTION":"","ALLOW_USER_PROFILE_EDITING":true,"COMPARE_FOREIGN_NAME_IN_ENTITY_NAME_VALIDATION":true,"FOREIGN_NAME_FIELD_NAME":"KIMA_PARENT_NAME_INFO","LOGIN_TITLE":"Montana Secretary of State Online Filing Portal Login","PUBLIC_LOGIN_LABEL":"Username","REVERSE_LOGIN_COLUMNS":true,"LOGIN_SEAL_FILENAME":"seal_white.png","SEPARATE_USERNAME_AND_EMAIL":true,"CREATE_ACCOUNT_BUTTON_ALIGN_LEFT":true,"CREATE_ACCOUNT_BUTTON_TEXT":"CREATE AN ACCOUNT","PASSWORD_CUSTOM_ERROR_TEXT":"The password must meet all requirements","ACCOUNT_CREATED_MESSAGE":"Please check your email to verify your account to login and allow a few minutes for this message to arrive. Check your junk/spam folders if you do not find the email in your inbox.","PUBLIC_LOGIN_PLACEHOLDER":" ","DISABLE_DEFAULT_PAYMENT_RADIO":true,"CUSTOM_RESET_PASSWORD_ERROR_MESSAGE":"Username invalid - no account found","PUBLIC_LOGIN_CREATE_DESCRIPTION":"### Existing User:\n\n  - Enter your username and password to login.  \n\n\n  #### - OR -  \n\n\n\n  - Forgot password? Click 'Reset Password' and follow the prompts.\n  - Forgot username? Click 'Forgot Username' and follow the prompts.  \n\n\n  ### New User:\n  ","LOGIN_HELP_LINK":"https://sosmt.gov/business/how-do-i/","LOGIN_HELP_LINK_TEXT":"Need Help?","FORGOT_USERNAME_TEXT":"Forgot Username?","LOGIN_ACTIVE_DIRECTORY_TEXT":"State User Login","MULTIPLE_LOGIN_METHODS":true,"HAS_ACTIVE_DIRECTORY_LOGIN":true,"RESET_PASSWORD_WITH_USERNAME":true,"DOWNLOAD_LINK":true,"SHOW_USERNAME_ACCOUNT_CREATE":true,"SHOW_SCROLL_DOWN_ARROW":true,"SHOW_ADDRESS_ACCOUNT_CREATE":true,"TWO_COLUMN_ACCOUNT_CREATE":true,"RESET_PASSWORD_TIP":"A link to change your password has been sent to your email. Please allow a few minutes for this message to arrive. Please check your junk/spam folders if you do not find the email in your inbox.","FORGOT_PASSWORD_LINK_TEXT":"Reset Password","PHONE_NUMBER_OPTIONAL_ACCOUNT_CREATE":true,"SHOW_REQUIRED_INDICATOR_ACCOUNT_CREATE":true,"PASSWORD_REQUIREMENTS_ACCOUNT_CREATE":"\n    <ul>\n      <li>MUST contain at least 8 characters (12+ recommended)</li>\n      <li>MUST contain at least one uppercase letter.</li>\n      <li>MUST contain at least one lowercase letter.</li>\n      <li>MUST contain at least one number.</li>\n      <li>MUST contain at least one special character (!”#$%&'()*+,-./:;<=>?</li>\n    </ul>\n  ","ALLOW_CERTIFICATION_REQUEST":true,"ALLOW_PUBLIC_CERTIFICATE_REQUEST":true,"ALLOW_COPY_REQUEST":false,"ALLOW_CORRECTION_STYLING":true,"HIDE_DEPRECATION_WARNING":false,"AMEND_ROUTE_PUBLIC":true,"SEAL_FILENAME":"seal.png","SHOPPING_CART":true,"ALLOW_PAYMENT_UPDATE_WITH_EMPTY_CART":true,"RA_EMAIL":true,"RA_WEBSITE":true,"RA_NO_DEFAULT_TYPE":true,"RA_ADDRESS_LABEL":"Street Address","RA_TYPE_SELECTION_DEFAULT":true,"RA_DEFAULT_TYPE":"460","RA_OVERRIDE_TYPE_WITH_DEFAULT":true,"RA_PRINCIPAL_ADDRESS_AMS":true,"UPLOAD_AND_SUBMIT_HIDE_IF_ONE_OPTION":true,"PAYMENT_PROCESSING_MESSAGE":"Your payment is processing - Do not close your browser or click the back button","CHECKOUT_BUTTON_WHEN_PROCESSING_TEXT":"Processing","EFS_CROP_PICKER_NONE_LABEL":"Lien Duration","DISALLOWED_WIZARD_PIECES":["FormationLocale"],"REPEATER_SHOW_EDIT_BUTTON":true,"DATA_REQUEST_PAGE_TITLE":"Data Requests and Subscriptions","DATA_REQUEST_SIDEBAR_LABEL":"Data Requests & Subscriptions","LOGIN_REDIRECTS_TO_EPASS":false,"LOGIN_REDIRECTS_TO_ACTIVE_DIRECTORY":true,"LOGIN_ACTIVE_DIRECTORY_LINK":true,"FETCH_EDIT_USER_LINK":false,"LISTS_FETCH_AVAILABLE_LISTS":true,"POST_WIZARD_SUBMIT_REDIRECT_URL":"/","PIN_REQUEST_ATTESTATIONS":true,"PIN_REQUEST_DESCRIPTION":"Click **Request PIN** to have a new PIN sent to the account holder's email address on file.","OWNERSHIP_REQUEST_DESCRIPTION":"To become an **authorized user** of this record, a current **AUTHORIZED USER** will need to grant you access. To request access, click **Request Access** below.","PIN_REQUEST_SUCCESS_MESSAGE":"The PIN you have requested for this entity has been sent to the email associated with your user account.  You should receive the PIN in approximately 3-5 minutes, depending on your email service provider.","APOSTILLE_HEADER_LABEL":"Verification Information","APOSTILLE_NUMBER_LABEL":"Apostille/Authentication","APOSTILLE_CITY_STATE_OVERRIDE":"HELENA, MT","APOSTILLE_FILING_DATE_LABEL":"Issue Date","APOSTILLE_CITY_STATE_IN_CERTIFIED":true,"NOTARY_EXISTING_FILING":true,"ALLOW_REVOKE_OWN_ACCESS_ONLY":false,"HIDE_CANCEL_ON_ONETIME_DATA_REQUESTS":true,"DATA_REQUESTS_IN_SHOPPING_CART":true,"WQ_ALLOW_EDIT_PENDING_PAYMENT":true,"WQ_CONFIRM_ON_DELETE":true,"WQ_DELETE_CONFIRM_MESSAGE":"Deleting this filing will forfeit any money already paid to the Secretary of State. This action is permanent and cannot be undone, are you sure you would like to delete?","PASS_ITEM_GUIDS_ON_CHECKOUT":true,"FORM_REVISION_HISTORY":true,"CHECKOUT_DISCLAIMER":"By entering your credit card and/or checking account information you (i) state that **you are an authorized user** of the credit card and/or electronic check and that the associated information entered (e.g., account holder name, account number, billing address) is accurate, (ii) **you authorize payment processor to charge the amount you have requested** to your credit card and/or funding account, and (iii) **acknowledge if a charge is declined or reversed you may also be assessed a customary charge** by the payment processor for such transactions.","FARM_BILL_SEARCH_CONFIDENTIAL":"As a registered Farm Bill Buyer with the Montana Secretary of State’s office it is important to maintain the confidentiality of the information contained within the Farm Bill Master List. The Farm Bill Master List reflects personal data, such as Social Security Numbers, which are a key piece of personal identifiable information to assist you in determining the existence of a lien against a specific debtor. The distribution of this information beyond its intended purpose is strictly prohibited.\n\n**The debtor's tax identification number has been hidden for confidentiality reasons. You may continue to search on a tax ID number and return debtors that match your search criteria. The SSN/FEIN must be entered without dashes or spaces.  If you need access to the tax identification number to clearly identify the debtor, please contact the UCC unit at (406) 444-3665.**","VIEW_HISTORY_BUTTON_ALT_TEXT":"View Filings","WIZARD_ERROR_TITLE_MESSAGE":"Form Error","FARM_BILL_SEARCH_INTERACTIVE":true,"USE_FARM_BILL_API":true,"DISALLOW_ASSIGN_SELF_AS_RA":true,"DISALLOW_ASSIGN_SELF_AS_PRINCIPAL":true,"USE_TRADEMARK_OWNER_VALIDATION":true,"USE_ALTERNATIVE_FOREIGN_ADDRESS_LABELS":true,"MY_RECEIPTS_FILTER":[{"type":"dateRange","name":"DATE_RANGE","label":"Date range","defaultValue":{"start":null,"end":null}},{"type":"text","name":"REF_NUM","defaultValue":"","label":"Reference Number"},{"type":"text","name":"RECEIPT_NUM","defaultValue":"","label":"Receipt Id"},{"type":"text","name":"AMOUNT","defaultValue":"","label":"Amount"},{"type":"select","name":"TYPE","defaultValue":"","label":"Payment Type","options":[{"value":"","label":"All"},{"value":"CC","label":"Credit Card"},{"value":"Check","label":"Check"}]}],"MY_RECEIPTS_SHOW_IN_SIDEBAR":true,"SHOW_MY_RECEIPTS_HELPER_TEXT":true,"MY_RECEIPTS_HELPER_LABEL":"About Receipt Search","MY_RECEIPTS_HELPER_TEXT":"You can search for receipts based on their descriptions, including the items paid for on the receipt. Use the filters to search for or filter specific information.","FARM_BILL_SUBLINK":{"label":"Farm Bill","component":"FarmBill","parameter":"farm-bill","path":"/lists/farm-bill","sourceTypeId":0,"myRecordsSearch":false,"allowedRules":["/search/"],"disabled":true,"searchDescription":"To perform a search, enter a debtor name. Your search results may include: exact debtor name, variations of that name and any filing that includes your search criteria. Punctuation is ignored.\n\nYou can click on \"Advanced\" to refine your search. Under “Advanced” you can search by crop, year, county and SSN/FEIN. As a registered Farm Bill Buyer with the Montana Secretary of State’s office it is important to maintain the confidentiality of the information contained within the Farm Bill Master List. The Farm Bill Master List reflects personal data, such as Social Security Numbers, which are a key piece of personal identifiable information to assist you in determining the existence of a lien against a specific debtor. The distribution of this information beyond its intended purpose is strictly prohibited.\n\nThe debtor's tax identification number has been hidden for confidentiality reasons. You may continue to search on a tax ID number and return debtors that match your search criteria. The SSN/FEIN must be entered without dashes or spaces.","searchMustHaveOneOf":["search","UCC_FARM_PRODUCT_ID","COUNTY"],"searchPlaceholder":"Search by debtor name","advancedSearchParameters":[{"type":"ServerMultiComplete","label":"Product code name(s)","name":"UCC_FARM_PRODUCT_ID","defaultValue":"","optionsSrc":"UCC_FARM_PRODUCT_V"},{"type":"MultiComplete","label":"Year or Range of Years","name":"YEAR_NUM","optionsSrc":"years","startYear":"1968","defaultValue":[],"preMergeOptions":[{"value":"ALL","label":"All"}]},{"type":"serverSelect","label":"State","name":"STATE","defaultValue":"MONTANA","optionsSrc":"STATE"},{"type":"ServerMultiComplete","label":"County","name":"COUNTY","defaultValue":[],"optionsSrc":"COUNTY","overrideSubOptionsSrcFromParameterName":"STATE"},{"type":"checkbox","name":"TIN_SEARCH_YN","defaultValue":false,"label":"Tax Identification Number Search"},{"type":"checkbox","name":"TIN_SORT_YN","defaultValue":false,"label":"Unique ID Sort"}]},"ALLOW_ADDRESS_VALIDATION_BYPASS_OPTION":true,"DEFAULT_ADDRESS_VALIDATION_BYPASS_OPTION_CHECKED":true}).LOGIN_FOOTER_TEXT;
	
	var PublicLogin = exports.PublicLogin = function (_Component2) {
	  _inherits(PublicLogin, _Component2);
	
	  function PublicLogin() {
	    var _ref2;
	
	    var _temp, _this2, _ret;
	
	    _classCallCheck(this, PublicLogin);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this2 = _possibleConstructorReturn(this, (_ref2 = PublicLogin.__proto__ || Object.getPrototypeOf(PublicLogin)).call.apply(_ref2, [this].concat(args))), _this2), _this2.state = {
	      error: null,
	      activeView: 'login',
	      forgotSuccess: false,
	      forgotUsernameSuccess: false,
	      loginMessage: null,
	      changedSuccess: false
	    }, _this2.componentDidMount = function () {
	      if (_this2.props.location) {
	        var _parseUrlQuery = (0, _utilities.parseUrlQuery)(_this2.props.location.search),
	            page = _parseUrlQuery.page,
	            changed = _parseUrlQuery.changed;
	
	        var allowedStartPages = ['login', 'forgot', 'create'];
	        if (allowedStartPages.includes(page)) {
	          _this2.setState({ activeView: page });
	        }
	        if (changed) {
	          _this2.setState({ changedSuccess: true });
	        }
	      }
	    }, _this2.login = function () {
	      _this2.props.loginWebUser({
	        username: _this2.loginForm.getUsername(),
	        password: _this2.loginForm.getPassword()
	      }, function (success, err) {
	        if (_this2.props.onLogin && success) {
	          _this2.props.onLogin();
	        } else {
	          _this2.setState({ error: err });
	        }
	      });
	    }, _this2.checkEnter = function (_ref3) {
	      var keyCode = _ref3.keyCode;
	
	      if (keyCode === 13) {
	        if (_this2.state.error === null) {
	          _this2.login();
	        }
	      } else {
	        if (_this2.state.error) {
	          _this2.setState({ error: null });
	        }
	      }
	    }, _this2.setActiveViewCreate = function () {
	      _this2.setState({
	        activeView: 'create',
	        forgotSuccess: false,
	        changedSuccess: false,
	        loginMessage: null
	      });
	    }, _this2.setActiveViewLogin = function (message) {
	      _this2.setState({ activeView: 'login', forgotSuccess: false, changedSuccess: false, forgotUsernameSuccess: false });
	      if (message.hasOwnProperty('message')) {
	        _this2.setState({
	          loginMessage: message
	        });
	      }
	    }, _this2.setActiveViewForgot = function () {
	      _this2.setState({
	        activeView: 'forgot',
	        forgotSuccess: false,
	        changedSuccess: false,
	        loginMessage: null
	      });
	    }, _this2.setActiveViewForgotUsername = function () {
	      console.log('here');
	      _this2.setState({
	        activeView: 'forgotUsername',
	        forgotUsernameSuccess: false,
	        changedSuccess: false,
	        loginMessage: null
	      });
	    }, _this2.setLoginViewWithForgotSuccess = function () {
	      _this2.setState({
	        activeView: 'login',
	        forgotSuccess: true,
	        changedSuccess: false
	      });
	    }, _this2.setLoginViewWithForgotUsernameSuccess = function () {
	      _this2.setState({
	        activeView: 'login',
	        forgotUsernameSuccess: true
	      });
	    }, _temp), _possibleConstructorReturn(_this2, _ret);
	  }
	
	  _createClass(PublicLogin, [{
	    key: 'render',
	    value: function render() {
	      var _this3 = this;
	
	      var loginActive = this.state.activeView === 'login';
	      var doubleColumn = DOUBLE_COLUMN_PUBLIC_LOGIN && loginActive;
	      var siteOffline = this.props.siteOffline;
	
	      return _react2.default.createElement(
	        'div',
	        {
	          className: 'admin-login-wrapper login-modal-new animated fadeInDown fast-animation ' + (doubleColumn ? 'double-column' : '') + ' ' + (({"NODE_ENV":"production","BUILD_DATE":"2025-08-27T15:15:31.687Z","BUILD_NUMBER":"Not Provided","GIT_VERSION":"v1.3.0-381-ga81e29b08","GIT_COMMIT_HASH":"a81e29b085c9268ffd96c78eb734365802722741","GIT_BRANCH":"beta","PUBLIC_URL":"","STATE_ABBR":"MT","STATE_NAME":"Montana","STATE_ORG_TITLE":"Secretary of State","LOGIN_HEADER_IMG_PATH":"","HOME_IMG_FILENAME":"montana.jpg","FAVICON_FILE_NAME":"favicon.ico","ALLOW_E_SIGN_ON_CORRECTIONS":true,"THIRD_PARTY_SIGNING_ALLOWED":false,"MY_ACCOUNT_SAVE_AND_CLOSE_BUTTON":true,"IE_DEPRECATED_MESSAGE":"Internet Explorer is not supported. Please select a supported browser below to access this website.","ADDITIONAL_ROUTES":{"dataRequests":true,"farmBill":true,"apostille":true,"externalHelp":"https://sosmt.gov/business/help-center/","systemAdministration":[{"title":"Saved Payments","parameter":"saved-payments","componentName":"SavedPayments"}]},"SUBROUTES":[{"label":"Business","component":"Business","parameter":"business","myWorkQueueSearch":false,"sourceTypeId":54,"searchMustHaveOneOf":["FILING_TYPE_ID","STATUS_ID","STATE","search"],"serverWebSearchDescription":true,"serverWorkQueueDescription":true,"serverMyRecordsDescription":true,"searchPlaceholder":"Search by name or filing number (X########)","allowEmptySearchTerm":true,"requestCertificateAlternateLabel":"Request Information","fileAmendmentButtonLabel":"Filing Actions","advancedSearchParameters":[{"type":"radio","name":"QUERY_TYPE_ID","defaultValue":1010,"options":[{"value":1010,"label":"Starts with"},{"value":1011,"label":"Contains"},{"value":1012,"label":" Word Contains"}]},{"type":"serverSelect","name":"FILING_TYPE_ID","optionsSrc":"FILING_TYPES","label":"Entity Type","placeholder":"All","defaultValue":"0"},{"type":"serverSelect","name":"FILING_SUBTYPE_ID","optionsSrc":"FILING_SUBTYPES","label":"Entity Subtype","overrideSubOptionsSrcFromParameterName":"FILING_TYPE_ID","placeholder":"All","defaultValue":"0"},{"type":"serverSelect","name":"STATUS_ID","optionsSrc":"FILING_STATUS_WITHOUT_ALL","label":"Status","placeholder":"All","defaultValue":"0"},{"type":"serverSelect","name":"STATE","optionsSrc":"STATE","label":"State","placeholder":"All","defaultValue":""},{"type":"serverSelect","name":"COUNTY","optionsSrc":"COUNTY_SUBOPTION","label":"County","overrideSubOptionsSrcFromParameterName":"STATE","placeholder":"All","defaultValue":""},{"type":"checkbox","name":"CRA_SEARCH_YN","defaultValue":false,"label":"Search by Registered Agent PID"},{"type":"dateRange","name":"FILING_DATE","label":"Registration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}},{"type":"dateRange","name":"EXPIRATION_DATE","label":"Expiration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}}],"myRecordsFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Active"},{"value":2,"label":"Inactive"},{"value":3,"label":"Pending"}]},{"type":"dateRange","name":"DATE_RANGE","label":"Date range","defaultValue":{"start":null,"end":null}}],"myWorkQueueFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Approved"},{"value":2,"label":"Pending Online Payment"},{"value":3,"label":"Pending Review"},{"value":4,"label":"Needs Correction"},{"value":5,"label":"Rejected"},{"value":6,"label":"Draft"}]},{"type":"dateRange","name":"DATE_RANGE","label":"Date range","defaultValue":{"start":null,"end":null}}]},{"label":"Notary","component":"Notary","parameter":"notary","sourceTypeId":850,"myWorkQueueSearch":false,"allowEmptySearchTerm":true,"requestCertificateAlternateLabel":"Download Certificate","fileAmendmentButtonLabel":"Filing Actions","hideNameRequestCertificate":true,"hideAddressRequestCertificate":true,"hideRecordUserManagment":true,"searchPlaceholder":"Search by name or commission number","searchMustHaveOneOf":["CITY","search","SERVICE_TYPE"],"advancedParametersStartOpen":true,"searchIsSortable":true,"advancedSearchParameters":[{"type":"radio","name":"STARTS_WITH_YN","defaultValue":false,"options":[{"value":true,"label":"Starts with"},{"value":false,"label":"Contains"}]},{"type":"checkbox","name":"ACTIVE_ONLY_YN","defaultValue":true,"label":"Active entities only"},{"type":"text","name":"CITY","defaultValue":"","label":"City"},{"type":"select","name":"SERVICE_TYPE","label":"Special Services Offered","defaultValue":0,"options":[{"value":0,"label":"(N/A)"},{"value":6165,"label":"In-Person Electronic Notarization (IPEN)"},{"value":6166,"label":"Remote Online Notarization (RON)"},{"value":6167,"label":"Mobile Notary Services"},{"value":6168,"label":"Remote Ink Notarization (RIN)"}]}]},{"label":"Apostille","component":"Apostille","parameter":"apostille","sourceTypeId":720,"myRecordsSearch":false,"myWorkQueueSearch":false,"disabled":false,"allowedRoutes":["/forms-manager/","/queue/","/forms/"]},{"label":"Liens","component":"UCC","parameter":"ucc","sourceTypeId":1999,"myRecordsSearch":true,"myWorkQueueSearch":true,"fileAmendmentButtonLabel":"Filing Actions","searchPlaceholder":"Search by name or file number","disabled":false,"serverWebSearchDescription":true,"myRecordsDescription":"","workQueueDescription":"","searchDescription":"","hideRecordUserManagment":true,"searchLiensCheckout":false,"advancedSearchParameters":[{"type":"radio","name":"STARTS_WITH_YN","defaultValue":false,"options":[{"value":true,"label":"Starts with"},{"value":false,"label":"Contains"}]},{"type":"select","name":"STATUS","defaultValue":"ALL","label":"Status","options":[{"value":"ACTIVE_UNLAPSED","label":"Active (unlapsed)"},{"value":"ACTIVE_LAPSED_UNLAPSED","label":"Active (lapsed and unlapsed)"}]},{"type":"text","name":"EXCLUDE_VALUES","label":"Exclude Debtor Names (comma separated list of names to exclude)","defaultValue":""},{"type":"dateRange","name":"FILING_DATE","label":"Financing Statement Date","defaultValue":{"start":null,"end":null}},{"type":"dateRange","name":"LAPSE_DATE","label":"Lapse Date","defaultValue":{"start":null,"end":null}},{"type":"text","name":"CITY","label":"Debtor City","defaultValue":""}],"myRecordsFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Approved"},{"value":2,"label":"Pending Online Payment"},{"value":3,"label":"Pending Review"}]},{"type":"select","name":"TYPE","defaultValue":0,"label":"Lien Type","options":[{"value":0,"label":"All"},{"value":1,"label":"UCC"},{"value":2,"label":"EFS"},{"value":3,"label":"Title 71"}]}],"myWorkQueueFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Approved"},{"value":2,"label":"Pending Online Payment"},{"value":3,"label":"Pending Review"},{"value":4,"label":"Pending Print and Mail"},{"value":5,"label":"Rejected"},{"value":6,"label":"Draft"}]},{"type":"select","name":"TYPE","defaultValue":0,"label":"Lien Type","options":[{"value":0,"label":"All"},{"value":1,"label":"UCC"},{"value":2,"label":"EFS"},{"value":3,"label":"Title 71"}]}]},{"label":"Copy Request","component":"copies","parameter":"copies","sourceTypeId":2001,"myRecordsSearch":false,"myWorkQueueSearch":false,"disabled":false,"allowedRoutes":["/forms-manager/","/queue/","/forms/"]},{"label":"Trademark","component":"Trademark","parameter":"trademark","sourceTypeId":810,"showRequestCertificate":true,"searchMustHaveOneOf":["search","EXPIRATION_DATE","FILING_DATE"],"allowEmptySearchTerm":true,"requestCertificateAlternateLabel":"Request Information","fileAmendmentButtonLabel":"Filing Actions","advancedSearchParameters":[{"type":"radio","name":"QUERY_TYPE_ID","defaultValue":1010,"options":[{"value":1010,"label":"Starts with"},{"value":1011,"label":"Contains"},{"value":1012,"label":" Word Contains"}]},{"type":"checkbox","name":"OWNER_SEARCH_YN","defaultValue":false,"label":"Search owners"},{"type":"radio","name":"SERVICE_MARK_YN","label":"Mark Type","defaultValue":"","options":[{"value":"","label":"All Marks"},{"value":"Y","label":"Service Mark"},{"value":"N","label":"Trademark"}]},{"type":"serverSelect","name":"STATUS_ID","optionsSrc":"TYPE_V|TRADEMARK_STATUS_TYPE","label":"Status","placeholder":"All","defaultValue":"0"},{"type":"select","name":"DESIGN_TYPE_ID","options":[{"value":0,"label":"All"},{"value":990,"label":"Words Only"},{"value":991,"label":"Design Only"},{"value":992,"label":"Words and Design"}],"label":"Design Type","defaultValue":"0"},{"type":"dateRange","name":"FILING_DATE","label":"Registered Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}},{"type":"dateRange","name":"EXPIRATION_DATE","label":"Expiration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}}]},{"label":"Business Info Request","component":"InfoRequests","parameter":"info-request","sourceTypeId":167,"allowedRoutes":["/forms-manager/","/queue/","/forms/"]},{"label":"Data Requests","component":"DataRequests","parameter":"data-request","sourceTypeId":0,"allowedRoutes":["/forms-manager/"]},{"label":"CRA","component":"CRA","parameter":"cra","sourceTypeId":157,"myRecordsSearch":false,"searchPlaceholder":"Search by name or registered agent number","allowedRoutes":["/forms-manager/","/forms/","/records/","/queue/","/search/"],"allowEmptySearchTerm":true,"fileAmendmentButtonLabel":"Filing Actions","advancedSearchParameters":[{"type":"radio","name":"QUERY_TYPE_ID","defaultValue":1010,"options":[{"value":1010,"label":"Starts with"},{"value":1011,"label":"Contains"},{"value":1012,"label":" Word Contains"}]},{"type":"dateRange","name":"CRA_DATE","label":"Registration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}},{"type":"select","name":"STATUS_ID","label":"Status","defaultValue":0,"options":[{"value":0,"label":"All"},{"value":121,"label":"Active"},{"value":122,"label":"Inactive"}]},{"type":"select","name":"AGENT_TYPE_ID","label":"Agent Type","defaultValue":0,"options":[{"value":0,"label":"All"},{"value":460,"label":"Registered Agent"},{"value":461,"label":"Commercial Registered Agent"}]}]},{"label":"Farm Bill","component":"FarmBill","parameter":"farm-bill","path":"/lists/farm-bill","sourceTypeId":0,"myRecordsSearch":false,"allowedRules":["/search/"],"disabled":true,"searchDescription":"To perform a search, enter a debtor name. Your search results may include: exact debtor name, variations of that name and any filing that includes your search criteria. Punctuation is ignored.\n\nYou can click on \"Advanced\" to refine your search. Under “Advanced” you can search by crop, year, county and SSN/FEIN. As a registered Farm Bill Buyer with the Montana Secretary of State’s office it is important to maintain the confidentiality of the information contained within the Farm Bill Master List. The Farm Bill Master List reflects personal data, such as Social Security Numbers, which are a key piece of personal identifiable information to assist you in determining the existence of a lien against a specific debtor. The distribution of this information beyond its intended purpose is strictly prohibited.\n\nThe debtor's tax identification number has been hidden for confidentiality reasons. You may continue to search on a tax ID number and return debtors that match your search criteria. The SSN/FEIN must be entered without dashes or spaces.","searchMustHaveOneOf":["search","UCC_FARM_PRODUCT_ID","COUNTY"],"searchPlaceholder":"Search by debtor name","advancedSearchParameters":[{"type":"ServerMultiComplete","label":"Product code name(s)","name":"UCC_FARM_PRODUCT_ID","defaultValue":"","optionsSrc":"UCC_FARM_PRODUCT_V"},{"type":"MultiComplete","label":"Year or Range of Years","name":"YEAR_NUM","optionsSrc":"years","startYear":"1968","defaultValue":[],"preMergeOptions":[{"value":"ALL","label":"All"}]},{"type":"serverSelect","label":"State","name":"STATE","defaultValue":"MONTANA","optionsSrc":"STATE"},{"type":"ServerMultiComplete","label":"County","name":"COUNTY","defaultValue":[],"optionsSrc":"COUNTY","overrideSubOptionsSrcFromParameterName":"STATE"},{"type":"checkbox","name":"TIN_SEARCH_YN","defaultValue":false,"label":"Tax Identification Number Search"},{"type":"checkbox","name":"TIN_SORT_YN","defaultValue":false,"label":"Unique ID Sort"}]}],"SYSTEM_NICKNAME":"Online Services Portal","PAYMENT_METHODS":[{"type":"bypass"},{"type":"iTransact"}],"PAYMENT_ALLOW_AMEX":true,"SYSTEM_ID_LABEL":"System Id","DOUBLE_COLUMN_PUBLIC_LOGIN":true,"INTERNAL_USER_MANAGEMENT":true,"ALLOW_PUBLIC_JSON_IMPORT":false,"MAX_FILE_UPLOAD_SIZE":10000000,"REFUND_TEXT":"","RETURN_TO_HOME_ON_LOGOUT":true,"CURRENT_SOS_NAME":"Christi Jacobsen","LOGO_FILENAME":"mt-sos-logo.png","LOGO_ALT":"Christi Jacobsen, Montana Secretary of State","LOGO_FULL_WIDTH":true,"HOME_HIDE_AUTH_HINT":true,"HOME_TITLE":"Montana Secretary of State","CUSTOM_TAB_TITLE":"Official Montana","HOME_SUBTITLE":"Online Business Services","ENTITY_NAME_CONSENT_DESCRIPTION":"","ALLOW_USER_PROFILE_EDITING":true,"COMPARE_FOREIGN_NAME_IN_ENTITY_NAME_VALIDATION":true,"FOREIGN_NAME_FIELD_NAME":"KIMA_PARENT_NAME_INFO","LOGIN_TITLE":"Montana Secretary of State Online Filing Portal Login","PUBLIC_LOGIN_LABEL":"Username","REVERSE_LOGIN_COLUMNS":true,"LOGIN_SEAL_FILENAME":"seal_white.png","SEPARATE_USERNAME_AND_EMAIL":true,"CREATE_ACCOUNT_BUTTON_ALIGN_LEFT":true,"CREATE_ACCOUNT_BUTTON_TEXT":"CREATE AN ACCOUNT","PASSWORD_CUSTOM_ERROR_TEXT":"The password must meet all requirements","ACCOUNT_CREATED_MESSAGE":"Please check your email to verify your account to login and allow a few minutes for this message to arrive. Check your junk/spam folders if you do not find the email in your inbox.","PUBLIC_LOGIN_PLACEHOLDER":" ","DISABLE_DEFAULT_PAYMENT_RADIO":true,"CUSTOM_RESET_PASSWORD_ERROR_MESSAGE":"Username invalid - no account found","PUBLIC_LOGIN_CREATE_DESCRIPTION":"### Existing User:\n\n  - Enter your username and password to login.  \n\n\n  #### - OR -  \n\n\n\n  - Forgot password? Click 'Reset Password' and follow the prompts.\n  - Forgot username? Click 'Forgot Username' and follow the prompts.  \n\n\n  ### New User:\n  ","LOGIN_HELP_LINK":"https://sosmt.gov/business/how-do-i/","LOGIN_HELP_LINK_TEXT":"Need Help?","FORGOT_USERNAME_TEXT":"Forgot Username?","LOGIN_ACTIVE_DIRECTORY_TEXT":"State User Login","MULTIPLE_LOGIN_METHODS":true,"HAS_ACTIVE_DIRECTORY_LOGIN":true,"RESET_PASSWORD_WITH_USERNAME":true,"DOWNLOAD_LINK":true,"SHOW_USERNAME_ACCOUNT_CREATE":true,"SHOW_SCROLL_DOWN_ARROW":true,"SHOW_ADDRESS_ACCOUNT_CREATE":true,"TWO_COLUMN_ACCOUNT_CREATE":true,"RESET_PASSWORD_TIP":"A link to change your password has been sent to your email. Please allow a few minutes for this message to arrive. Please check your junk/spam folders if you do not find the email in your inbox.","FORGOT_PASSWORD_LINK_TEXT":"Reset Password","PHONE_NUMBER_OPTIONAL_ACCOUNT_CREATE":true,"SHOW_REQUIRED_INDICATOR_ACCOUNT_CREATE":true,"PASSWORD_REQUIREMENTS_ACCOUNT_CREATE":"\n    <ul>\n      <li>MUST contain at least 8 characters (12+ recommended)</li>\n      <li>MUST contain at least one uppercase letter.</li>\n      <li>MUST contain at least one lowercase letter.</li>\n      <li>MUST contain at least one number.</li>\n      <li>MUST contain at least one special character (!”#$%&'()*+,-./:;<=>?</li>\n    </ul>\n  ","ALLOW_CERTIFICATION_REQUEST":true,"ALLOW_PUBLIC_CERTIFICATE_REQUEST":true,"ALLOW_COPY_REQUEST":false,"ALLOW_CORRECTION_STYLING":true,"HIDE_DEPRECATION_WARNING":false,"AMEND_ROUTE_PUBLIC":true,"SEAL_FILENAME":"seal.png","SHOPPING_CART":true,"ALLOW_PAYMENT_UPDATE_WITH_EMPTY_CART":true,"RA_EMAIL":true,"RA_WEBSITE":true,"RA_NO_DEFAULT_TYPE":true,"RA_ADDRESS_LABEL":"Street Address","RA_TYPE_SELECTION_DEFAULT":true,"RA_DEFAULT_TYPE":"460","RA_OVERRIDE_TYPE_WITH_DEFAULT":true,"RA_PRINCIPAL_ADDRESS_AMS":true,"UPLOAD_AND_SUBMIT_HIDE_IF_ONE_OPTION":true,"PAYMENT_PROCESSING_MESSAGE":"Your payment is processing - Do not close your browser or click the back button","CHECKOUT_BUTTON_WHEN_PROCESSING_TEXT":"Processing","EFS_CROP_PICKER_NONE_LABEL":"Lien Duration","DISALLOWED_WIZARD_PIECES":["FormationLocale"],"REPEATER_SHOW_EDIT_BUTTON":true,"DATA_REQUEST_PAGE_TITLE":"Data Requests and Subscriptions","DATA_REQUEST_SIDEBAR_LABEL":"Data Requests & Subscriptions","LOGIN_REDIRECTS_TO_EPASS":false,"LOGIN_REDIRECTS_TO_ACTIVE_DIRECTORY":true,"LOGIN_ACTIVE_DIRECTORY_LINK":true,"FETCH_EDIT_USER_LINK":false,"LISTS_FETCH_AVAILABLE_LISTS":true,"POST_WIZARD_SUBMIT_REDIRECT_URL":"/","PIN_REQUEST_ATTESTATIONS":true,"PIN_REQUEST_DESCRIPTION":"Click **Request PIN** to have a new PIN sent to the account holder's email address on file.","OWNERSHIP_REQUEST_DESCRIPTION":"To become an **authorized user** of this record, a current **AUTHORIZED USER** will need to grant you access. To request access, click **Request Access** below.","PIN_REQUEST_SUCCESS_MESSAGE":"The PIN you have requested for this entity has been sent to the email associated with your user account.  You should receive the PIN in approximately 3-5 minutes, depending on your email service provider.","APOSTILLE_HEADER_LABEL":"Verification Information","APOSTILLE_NUMBER_LABEL":"Apostille/Authentication","APOSTILLE_CITY_STATE_OVERRIDE":"HELENA, MT","APOSTILLE_FILING_DATE_LABEL":"Issue Date","APOSTILLE_CITY_STATE_IN_CERTIFIED":true,"NOTARY_EXISTING_FILING":true,"ALLOW_REVOKE_OWN_ACCESS_ONLY":false,"HIDE_CANCEL_ON_ONETIME_DATA_REQUESTS":true,"DATA_REQUESTS_IN_SHOPPING_CART":true,"WQ_ALLOW_EDIT_PENDING_PAYMENT":true,"WQ_CONFIRM_ON_DELETE":true,"WQ_DELETE_CONFIRM_MESSAGE":"Deleting this filing will forfeit any money already paid to the Secretary of State. This action is permanent and cannot be undone, are you sure you would like to delete?","PASS_ITEM_GUIDS_ON_CHECKOUT":true,"FORM_REVISION_HISTORY":true,"CHECKOUT_DISCLAIMER":"By entering your credit card and/or checking account information you (i) state that **you are an authorized user** of the credit card and/or electronic check and that the associated information entered (e.g., account holder name, account number, billing address) is accurate, (ii) **you authorize payment processor to charge the amount you have requested** to your credit card and/or funding account, and (iii) **acknowledge if a charge is declined or reversed you may also be assessed a customary charge** by the payment processor for such transactions.","FARM_BILL_SEARCH_CONFIDENTIAL":"As a registered Farm Bill Buyer with the Montana Secretary of State’s office it is important to maintain the confidentiality of the information contained within the Farm Bill Master List. The Farm Bill Master List reflects personal data, such as Social Security Numbers, which are a key piece of personal identifiable information to assist you in determining the existence of a lien against a specific debtor. The distribution of this information beyond its intended purpose is strictly prohibited.\n\n**The debtor's tax identification number has been hidden for confidentiality reasons. You may continue to search on a tax ID number and return debtors that match your search criteria. The SSN/FEIN must be entered without dashes or spaces.  If you need access to the tax identification number to clearly identify the debtor, please contact the UCC unit at (406) 444-3665.**","VIEW_HISTORY_BUTTON_ALT_TEXT":"View Filings","WIZARD_ERROR_TITLE_MESSAGE":"Form Error","FARM_BILL_SEARCH_INTERACTIVE":true,"USE_FARM_BILL_API":true,"DISALLOW_ASSIGN_SELF_AS_RA":true,"DISALLOW_ASSIGN_SELF_AS_PRINCIPAL":true,"USE_TRADEMARK_OWNER_VALIDATION":true,"USE_ALTERNATIVE_FOREIGN_ADDRESS_LABELS":true,"MY_RECEIPTS_FILTER":[{"type":"dateRange","name":"DATE_RANGE","label":"Date range","defaultValue":{"start":null,"end":null}},{"type":"text","name":"REF_NUM","defaultValue":"","label":"Reference Number"},{"type":"text","name":"RECEIPT_NUM","defaultValue":"","label":"Receipt Id"},{"type":"text","name":"AMOUNT","defaultValue":"","label":"Amount"},{"type":"select","name":"TYPE","defaultValue":"","label":"Payment Type","options":[{"value":"","label":"All"},{"value":"CC","label":"Credit Card"},{"value":"Check","label":"Check"}]}],"MY_RECEIPTS_SHOW_IN_SIDEBAR":true,"SHOW_MY_RECEIPTS_HELPER_TEXT":true,"MY_RECEIPTS_HELPER_LABEL":"About Receipt Search","MY_RECEIPTS_HELPER_TEXT":"You can search for receipts based on their descriptions, including the items paid for on the receipt. Use the filters to search for or filter specific information.","FARM_BILL_SUBLINK":{"label":"Farm Bill","component":"FarmBill","parameter":"farm-bill","path":"/lists/farm-bill","sourceTypeId":0,"myRecordsSearch":false,"allowedRules":["/search/"],"disabled":true,"searchDescription":"To perform a search, enter a debtor name. Your search results may include: exact debtor name, variations of that name and any filing that includes your search criteria. Punctuation is ignored.\n\nYou can click on \"Advanced\" to refine your search. Under “Advanced” you can search by crop, year, county and SSN/FEIN. As a registered Farm Bill Buyer with the Montana Secretary of State’s office it is important to maintain the confidentiality of the information contained within the Farm Bill Master List. The Farm Bill Master List reflects personal data, such as Social Security Numbers, which are a key piece of personal identifiable information to assist you in determining the existence of a lien against a specific debtor. The distribution of this information beyond its intended purpose is strictly prohibited.\n\nThe debtor's tax identification number has been hidden for confidentiality reasons. You may continue to search on a tax ID number and return debtors that match your search criteria. The SSN/FEIN must be entered without dashes or spaces.","searchMustHaveOneOf":["search","UCC_FARM_PRODUCT_ID","COUNTY"],"searchPlaceholder":"Search by debtor name","advancedSearchParameters":[{"type":"ServerMultiComplete","label":"Product code name(s)","name":"UCC_FARM_PRODUCT_ID","defaultValue":"","optionsSrc":"UCC_FARM_PRODUCT_V"},{"type":"MultiComplete","label":"Year or Range of Years","name":"YEAR_NUM","optionsSrc":"years","startYear":"1968","defaultValue":[],"preMergeOptions":[{"value":"ALL","label":"All"}]},{"type":"serverSelect","label":"State","name":"STATE","defaultValue":"MONTANA","optionsSrc":"STATE"},{"type":"ServerMultiComplete","label":"County","name":"COUNTY","defaultValue":[],"optionsSrc":"COUNTY","overrideSubOptionsSrcFromParameterName":"STATE"},{"type":"checkbox","name":"TIN_SEARCH_YN","defaultValue":false,"label":"Tax Identification Number Search"},{"type":"checkbox","name":"TIN_SORT_YN","defaultValue":false,"label":"Unique ID Sort"}]},"ALLOW_ADDRESS_VALIDATION_BYPASS_OPTION":true,"DEFAULT_ADDRESS_VALIDATION_BYPASS_OPTION_CHECKED":true}).LOGIN_HEADER_STYLE === 'full-width' ? 'has-full-width-banner' : '') + ' ' + (LOGIN_FOOTER_TEXT ? 'has-footer' : '') + ' ' + ( true ? 'double-col-account-create' : '')
	        },
	        siteOffline && _react2.default.createElement(_reactRouterDom.Redirect, { to: '/' }),
	        ({"NODE_ENV":"production","BUILD_DATE":"2025-08-27T15:15:31.687Z","BUILD_NUMBER":"Not Provided","GIT_VERSION":"v1.3.0-381-ga81e29b08","GIT_COMMIT_HASH":"a81e29b085c9268ffd96c78eb734365802722741","GIT_BRANCH":"beta","PUBLIC_URL":"","STATE_ABBR":"MT","STATE_NAME":"Montana","STATE_ORG_TITLE":"Secretary of State","LOGIN_HEADER_IMG_PATH":"","HOME_IMG_FILENAME":"montana.jpg","FAVICON_FILE_NAME":"favicon.ico","ALLOW_E_SIGN_ON_CORRECTIONS":true,"THIRD_PARTY_SIGNING_ALLOWED":false,"MY_ACCOUNT_SAVE_AND_CLOSE_BUTTON":true,"IE_DEPRECATED_MESSAGE":"Internet Explorer is not supported. Please select a supported browser below to access this website.","ADDITIONAL_ROUTES":{"dataRequests":true,"farmBill":true,"apostille":true,"externalHelp":"https://sosmt.gov/business/help-center/","systemAdministration":[{"title":"Saved Payments","parameter":"saved-payments","componentName":"SavedPayments"}]},"SUBROUTES":[{"label":"Business","component":"Business","parameter":"business","myWorkQueueSearch":false,"sourceTypeId":54,"searchMustHaveOneOf":["FILING_TYPE_ID","STATUS_ID","STATE","search"],"serverWebSearchDescription":true,"serverWorkQueueDescription":true,"serverMyRecordsDescription":true,"searchPlaceholder":"Search by name or filing number (X########)","allowEmptySearchTerm":true,"requestCertificateAlternateLabel":"Request Information","fileAmendmentButtonLabel":"Filing Actions","advancedSearchParameters":[{"type":"radio","name":"QUERY_TYPE_ID","defaultValue":1010,"options":[{"value":1010,"label":"Starts with"},{"value":1011,"label":"Contains"},{"value":1012,"label":" Word Contains"}]},{"type":"serverSelect","name":"FILING_TYPE_ID","optionsSrc":"FILING_TYPES","label":"Entity Type","placeholder":"All","defaultValue":"0"},{"type":"serverSelect","name":"FILING_SUBTYPE_ID","optionsSrc":"FILING_SUBTYPES","label":"Entity Subtype","overrideSubOptionsSrcFromParameterName":"FILING_TYPE_ID","placeholder":"All","defaultValue":"0"},{"type":"serverSelect","name":"STATUS_ID","optionsSrc":"FILING_STATUS_WITHOUT_ALL","label":"Status","placeholder":"All","defaultValue":"0"},{"type":"serverSelect","name":"STATE","optionsSrc":"STATE","label":"State","placeholder":"All","defaultValue":""},{"type":"serverSelect","name":"COUNTY","optionsSrc":"COUNTY_SUBOPTION","label":"County","overrideSubOptionsSrcFromParameterName":"STATE","placeholder":"All","defaultValue":""},{"type":"checkbox","name":"CRA_SEARCH_YN","defaultValue":false,"label":"Search by Registered Agent PID"},{"type":"dateRange","name":"FILING_DATE","label":"Registration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}},{"type":"dateRange","name":"EXPIRATION_DATE","label":"Expiration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}}],"myRecordsFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Active"},{"value":2,"label":"Inactive"},{"value":3,"label":"Pending"}]},{"type":"dateRange","name":"DATE_RANGE","label":"Date range","defaultValue":{"start":null,"end":null}}],"myWorkQueueFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Approved"},{"value":2,"label":"Pending Online Payment"},{"value":3,"label":"Pending Review"},{"value":4,"label":"Needs Correction"},{"value":5,"label":"Rejected"},{"value":6,"label":"Draft"}]},{"type":"dateRange","name":"DATE_RANGE","label":"Date range","defaultValue":{"start":null,"end":null}}]},{"label":"Notary","component":"Notary","parameter":"notary","sourceTypeId":850,"myWorkQueueSearch":false,"allowEmptySearchTerm":true,"requestCertificateAlternateLabel":"Download Certificate","fileAmendmentButtonLabel":"Filing Actions","hideNameRequestCertificate":true,"hideAddressRequestCertificate":true,"hideRecordUserManagment":true,"searchPlaceholder":"Search by name or commission number","searchMustHaveOneOf":["CITY","search","SERVICE_TYPE"],"advancedParametersStartOpen":true,"searchIsSortable":true,"advancedSearchParameters":[{"type":"radio","name":"STARTS_WITH_YN","defaultValue":false,"options":[{"value":true,"label":"Starts with"},{"value":false,"label":"Contains"}]},{"type":"checkbox","name":"ACTIVE_ONLY_YN","defaultValue":true,"label":"Active entities only"},{"type":"text","name":"CITY","defaultValue":"","label":"City"},{"type":"select","name":"SERVICE_TYPE","label":"Special Services Offered","defaultValue":0,"options":[{"value":0,"label":"(N/A)"},{"value":6165,"label":"In-Person Electronic Notarization (IPEN)"},{"value":6166,"label":"Remote Online Notarization (RON)"},{"value":6167,"label":"Mobile Notary Services"},{"value":6168,"label":"Remote Ink Notarization (RIN)"}]}]},{"label":"Apostille","component":"Apostille","parameter":"apostille","sourceTypeId":720,"myRecordsSearch":false,"myWorkQueueSearch":false,"disabled":false,"allowedRoutes":["/forms-manager/","/queue/","/forms/"]},{"label":"Liens","component":"UCC","parameter":"ucc","sourceTypeId":1999,"myRecordsSearch":true,"myWorkQueueSearch":true,"fileAmendmentButtonLabel":"Filing Actions","searchPlaceholder":"Search by name or file number","disabled":false,"serverWebSearchDescription":true,"myRecordsDescription":"","workQueueDescription":"","searchDescription":"","hideRecordUserManagment":true,"searchLiensCheckout":false,"advancedSearchParameters":[{"type":"radio","name":"STARTS_WITH_YN","defaultValue":false,"options":[{"value":true,"label":"Starts with"},{"value":false,"label":"Contains"}]},{"type":"select","name":"STATUS","defaultValue":"ALL","label":"Status","options":[{"value":"ACTIVE_UNLAPSED","label":"Active (unlapsed)"},{"value":"ACTIVE_LAPSED_UNLAPSED","label":"Active (lapsed and unlapsed)"}]},{"type":"text","name":"EXCLUDE_VALUES","label":"Exclude Debtor Names (comma separated list of names to exclude)","defaultValue":""},{"type":"dateRange","name":"FILING_DATE","label":"Financing Statement Date","defaultValue":{"start":null,"end":null}},{"type":"dateRange","name":"LAPSE_DATE","label":"Lapse Date","defaultValue":{"start":null,"end":null}},{"type":"text","name":"CITY","label":"Debtor City","defaultValue":""}],"myRecordsFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Approved"},{"value":2,"label":"Pending Online Payment"},{"value":3,"label":"Pending Review"}]},{"type":"select","name":"TYPE","defaultValue":0,"label":"Lien Type","options":[{"value":0,"label":"All"},{"value":1,"label":"UCC"},{"value":2,"label":"EFS"},{"value":3,"label":"Title 71"}]}],"myWorkQueueFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Approved"},{"value":2,"label":"Pending Online Payment"},{"value":3,"label":"Pending Review"},{"value":4,"label":"Pending Print and Mail"},{"value":5,"label":"Rejected"},{"value":6,"label":"Draft"}]},{"type":"select","name":"TYPE","defaultValue":0,"label":"Lien Type","options":[{"value":0,"label":"All"},{"value":1,"label":"UCC"},{"value":2,"label":"EFS"},{"value":3,"label":"Title 71"}]}]},{"label":"Copy Request","component":"copies","parameter":"copies","sourceTypeId":2001,"myRecordsSearch":false,"myWorkQueueSearch":false,"disabled":false,"allowedRoutes":["/forms-manager/","/queue/","/forms/"]},{"label":"Trademark","component":"Trademark","parameter":"trademark","sourceTypeId":810,"showRequestCertificate":true,"searchMustHaveOneOf":["search","EXPIRATION_DATE","FILING_DATE"],"allowEmptySearchTerm":true,"requestCertificateAlternateLabel":"Request Information","fileAmendmentButtonLabel":"Filing Actions","advancedSearchParameters":[{"type":"radio","name":"QUERY_TYPE_ID","defaultValue":1010,"options":[{"value":1010,"label":"Starts with"},{"value":1011,"label":"Contains"},{"value":1012,"label":" Word Contains"}]},{"type":"checkbox","name":"OWNER_SEARCH_YN","defaultValue":false,"label":"Search owners"},{"type":"radio","name":"SERVICE_MARK_YN","label":"Mark Type","defaultValue":"","options":[{"value":"","label":"All Marks"},{"value":"Y","label":"Service Mark"},{"value":"N","label":"Trademark"}]},{"type":"serverSelect","name":"STATUS_ID","optionsSrc":"TYPE_V|TRADEMARK_STATUS_TYPE","label":"Status","placeholder":"All","defaultValue":"0"},{"type":"select","name":"DESIGN_TYPE_ID","options":[{"value":0,"label":"All"},{"value":990,"label":"Words Only"},{"value":991,"label":"Design Only"},{"value":992,"label":"Words and Design"}],"label":"Design Type","defaultValue":"0"},{"type":"dateRange","name":"FILING_DATE","label":"Registered Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}},{"type":"dateRange","name":"EXPIRATION_DATE","label":"Expiration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}}]},{"label":"Business Info Request","component":"InfoRequests","parameter":"info-request","sourceTypeId":167,"allowedRoutes":["/forms-manager/","/queue/","/forms/"]},{"label":"Data Requests","component":"DataRequests","parameter":"data-request","sourceTypeId":0,"allowedRoutes":["/forms-manager/"]},{"label":"CRA","component":"CRA","parameter":"cra","sourceTypeId":157,"myRecordsSearch":false,"searchPlaceholder":"Search by name or registered agent number","allowedRoutes":["/forms-manager/","/forms/","/records/","/queue/","/search/"],"allowEmptySearchTerm":true,"fileAmendmentButtonLabel":"Filing Actions","advancedSearchParameters":[{"type":"radio","name":"QUERY_TYPE_ID","defaultValue":1010,"options":[{"value":1010,"label":"Starts with"},{"value":1011,"label":"Contains"},{"value":1012,"label":" Word Contains"}]},{"type":"dateRange","name":"CRA_DATE","label":"Registration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}},{"type":"select","name":"STATUS_ID","label":"Status","defaultValue":0,"options":[{"value":0,"label":"All"},{"value":121,"label":"Active"},{"value":122,"label":"Inactive"}]},{"type":"select","name":"AGENT_TYPE_ID","label":"Agent Type","defaultValue":0,"options":[{"value":0,"label":"All"},{"value":460,"label":"Registered Agent"},{"value":461,"label":"Commercial Registered Agent"}]}]},{"label":"Farm Bill","component":"FarmBill","parameter":"farm-bill","path":"/lists/farm-bill","sourceTypeId":0,"myRecordsSearch":false,"allowedRules":["/search/"],"disabled":true,"searchDescription":"To perform a search, enter a debtor name. Your search results may include: exact debtor name, variations of that name and any filing that includes your search criteria. Punctuation is ignored.\n\nYou can click on \"Advanced\" to refine your search. Under “Advanced” you can search by crop, year, county and SSN/FEIN. As a registered Farm Bill Buyer with the Montana Secretary of State’s office it is important to maintain the confidentiality of the information contained within the Farm Bill Master List. The Farm Bill Master List reflects personal data, such as Social Security Numbers, which are a key piece of personal identifiable information to assist you in determining the existence of a lien against a specific debtor. The distribution of this information beyond its intended purpose is strictly prohibited.\n\nThe debtor's tax identification number has been hidden for confidentiality reasons. You may continue to search on a tax ID number and return debtors that match your search criteria. The SSN/FEIN must be entered without dashes or spaces.","searchMustHaveOneOf":["search","UCC_FARM_PRODUCT_ID","COUNTY"],"searchPlaceholder":"Search by debtor name","advancedSearchParameters":[{"type":"ServerMultiComplete","label":"Product code name(s)","name":"UCC_FARM_PRODUCT_ID","defaultValue":"","optionsSrc":"UCC_FARM_PRODUCT_V"},{"type":"MultiComplete","label":"Year or Range of Years","name":"YEAR_NUM","optionsSrc":"years","startYear":"1968","defaultValue":[],"preMergeOptions":[{"value":"ALL","label":"All"}]},{"type":"serverSelect","label":"State","name":"STATE","defaultValue":"MONTANA","optionsSrc":"STATE"},{"type":"ServerMultiComplete","label":"County","name":"COUNTY","defaultValue":[],"optionsSrc":"COUNTY","overrideSubOptionsSrcFromParameterName":"STATE"},{"type":"checkbox","name":"TIN_SEARCH_YN","defaultValue":false,"label":"Tax Identification Number Search"},{"type":"checkbox","name":"TIN_SORT_YN","defaultValue":false,"label":"Unique ID Sort"}]}],"SYSTEM_NICKNAME":"Online Services Portal","PAYMENT_METHODS":[{"type":"bypass"},{"type":"iTransact"}],"PAYMENT_ALLOW_AMEX":true,"SYSTEM_ID_LABEL":"System Id","DOUBLE_COLUMN_PUBLIC_LOGIN":true,"INTERNAL_USER_MANAGEMENT":true,"ALLOW_PUBLIC_JSON_IMPORT":false,"MAX_FILE_UPLOAD_SIZE":10000000,"REFUND_TEXT":"","RETURN_TO_HOME_ON_LOGOUT":true,"CURRENT_SOS_NAME":"Christi Jacobsen","LOGO_FILENAME":"mt-sos-logo.png","LOGO_ALT":"Christi Jacobsen, Montana Secretary of State","LOGO_FULL_WIDTH":true,"HOME_HIDE_AUTH_HINT":true,"HOME_TITLE":"Montana Secretary of State","CUSTOM_TAB_TITLE":"Official Montana","HOME_SUBTITLE":"Online Business Services","ENTITY_NAME_CONSENT_DESCRIPTION":"","ALLOW_USER_PROFILE_EDITING":true,"COMPARE_FOREIGN_NAME_IN_ENTITY_NAME_VALIDATION":true,"FOREIGN_NAME_FIELD_NAME":"KIMA_PARENT_NAME_INFO","LOGIN_TITLE":"Montana Secretary of State Online Filing Portal Login","PUBLIC_LOGIN_LABEL":"Username","REVERSE_LOGIN_COLUMNS":true,"LOGIN_SEAL_FILENAME":"seal_white.png","SEPARATE_USERNAME_AND_EMAIL":true,"CREATE_ACCOUNT_BUTTON_ALIGN_LEFT":true,"CREATE_ACCOUNT_BUTTON_TEXT":"CREATE AN ACCOUNT","PASSWORD_CUSTOM_ERROR_TEXT":"The password must meet all requirements","ACCOUNT_CREATED_MESSAGE":"Please check your email to verify your account to login and allow a few minutes for this message to arrive. Check your junk/spam folders if you do not find the email in your inbox.","PUBLIC_LOGIN_PLACEHOLDER":" ","DISABLE_DEFAULT_PAYMENT_RADIO":true,"CUSTOM_RESET_PASSWORD_ERROR_MESSAGE":"Username invalid - no account found","PUBLIC_LOGIN_CREATE_DESCRIPTION":"### Existing User:\n\n  - Enter your username and password to login.  \n\n\n  #### - OR -  \n\n\n\n  - Forgot password? Click 'Reset Password' and follow the prompts.\n  - Forgot username? Click 'Forgot Username' and follow the prompts.  \n\n\n  ### New User:\n  ","LOGIN_HELP_LINK":"https://sosmt.gov/business/how-do-i/","LOGIN_HELP_LINK_TEXT":"Need Help?","FORGOT_USERNAME_TEXT":"Forgot Username?","LOGIN_ACTIVE_DIRECTORY_TEXT":"State User Login","MULTIPLE_LOGIN_METHODS":true,"HAS_ACTIVE_DIRECTORY_LOGIN":true,"RESET_PASSWORD_WITH_USERNAME":true,"DOWNLOAD_LINK":true,"SHOW_USERNAME_ACCOUNT_CREATE":true,"SHOW_SCROLL_DOWN_ARROW":true,"SHOW_ADDRESS_ACCOUNT_CREATE":true,"TWO_COLUMN_ACCOUNT_CREATE":true,"RESET_PASSWORD_TIP":"A link to change your password has been sent to your email. Please allow a few minutes for this message to arrive. Please check your junk/spam folders if you do not find the email in your inbox.","FORGOT_PASSWORD_LINK_TEXT":"Reset Password","PHONE_NUMBER_OPTIONAL_ACCOUNT_CREATE":true,"SHOW_REQUIRED_INDICATOR_ACCOUNT_CREATE":true,"PASSWORD_REQUIREMENTS_ACCOUNT_CREATE":"\n    <ul>\n      <li>MUST contain at least 8 characters (12+ recommended)</li>\n      <li>MUST contain at least one uppercase letter.</li>\n      <li>MUST contain at least one lowercase letter.</li>\n      <li>MUST contain at least one number.</li>\n      <li>MUST contain at least one special character (!”#$%&'()*+,-./:;<=>?</li>\n    </ul>\n  ","ALLOW_CERTIFICATION_REQUEST":true,"ALLOW_PUBLIC_CERTIFICATE_REQUEST":true,"ALLOW_COPY_REQUEST":false,"ALLOW_CORRECTION_STYLING":true,"HIDE_DEPRECATION_WARNING":false,"AMEND_ROUTE_PUBLIC":true,"SEAL_FILENAME":"seal.png","SHOPPING_CART":true,"ALLOW_PAYMENT_UPDATE_WITH_EMPTY_CART":true,"RA_EMAIL":true,"RA_WEBSITE":true,"RA_NO_DEFAULT_TYPE":true,"RA_ADDRESS_LABEL":"Street Address","RA_TYPE_SELECTION_DEFAULT":true,"RA_DEFAULT_TYPE":"460","RA_OVERRIDE_TYPE_WITH_DEFAULT":true,"RA_PRINCIPAL_ADDRESS_AMS":true,"UPLOAD_AND_SUBMIT_HIDE_IF_ONE_OPTION":true,"PAYMENT_PROCESSING_MESSAGE":"Your payment is processing - Do not close your browser or click the back button","CHECKOUT_BUTTON_WHEN_PROCESSING_TEXT":"Processing","EFS_CROP_PICKER_NONE_LABEL":"Lien Duration","DISALLOWED_WIZARD_PIECES":["FormationLocale"],"REPEATER_SHOW_EDIT_BUTTON":true,"DATA_REQUEST_PAGE_TITLE":"Data Requests and Subscriptions","DATA_REQUEST_SIDEBAR_LABEL":"Data Requests & Subscriptions","LOGIN_REDIRECTS_TO_EPASS":false,"LOGIN_REDIRECTS_TO_ACTIVE_DIRECTORY":true,"LOGIN_ACTIVE_DIRECTORY_LINK":true,"FETCH_EDIT_USER_LINK":false,"LISTS_FETCH_AVAILABLE_LISTS":true,"POST_WIZARD_SUBMIT_REDIRECT_URL":"/","PIN_REQUEST_ATTESTATIONS":true,"PIN_REQUEST_DESCRIPTION":"Click **Request PIN** to have a new PIN sent to the account holder's email address on file.","OWNERSHIP_REQUEST_DESCRIPTION":"To become an **authorized user** of this record, a current **AUTHORIZED USER** will need to grant you access. To request access, click **Request Access** below.","PIN_REQUEST_SUCCESS_MESSAGE":"The PIN you have requested for this entity has been sent to the email associated with your user account.  You should receive the PIN in approximately 3-5 minutes, depending on your email service provider.","APOSTILLE_HEADER_LABEL":"Verification Information","APOSTILLE_NUMBER_LABEL":"Apostille/Authentication","APOSTILLE_CITY_STATE_OVERRIDE":"HELENA, MT","APOSTILLE_FILING_DATE_LABEL":"Issue Date","APOSTILLE_CITY_STATE_IN_CERTIFIED":true,"NOTARY_EXISTING_FILING":true,"ALLOW_REVOKE_OWN_ACCESS_ONLY":false,"HIDE_CANCEL_ON_ONETIME_DATA_REQUESTS":true,"DATA_REQUESTS_IN_SHOPPING_CART":true,"WQ_ALLOW_EDIT_PENDING_PAYMENT":true,"WQ_CONFIRM_ON_DELETE":true,"WQ_DELETE_CONFIRM_MESSAGE":"Deleting this filing will forfeit any money already paid to the Secretary of State. This action is permanent and cannot be undone, are you sure you would like to delete?","PASS_ITEM_GUIDS_ON_CHECKOUT":true,"FORM_REVISION_HISTORY":true,"CHECKOUT_DISCLAIMER":"By entering your credit card and/or checking account information you (i) state that **you are an authorized user** of the credit card and/or electronic check and that the associated information entered (e.g., account holder name, account number, billing address) is accurate, (ii) **you authorize payment processor to charge the amount you have requested** to your credit card and/or funding account, and (iii) **acknowledge if a charge is declined or reversed you may also be assessed a customary charge** by the payment processor for such transactions.","FARM_BILL_SEARCH_CONFIDENTIAL":"As a registered Farm Bill Buyer with the Montana Secretary of State’s office it is important to maintain the confidentiality of the information contained within the Farm Bill Master List. The Farm Bill Master List reflects personal data, such as Social Security Numbers, which are a key piece of personal identifiable information to assist you in determining the existence of a lien against a specific debtor. The distribution of this information beyond its intended purpose is strictly prohibited.\n\n**The debtor's tax identification number has been hidden for confidentiality reasons. You may continue to search on a tax ID number and return debtors that match your search criteria. The SSN/FEIN must be entered without dashes or spaces.  If you need access to the tax identification number to clearly identify the debtor, please contact the UCC unit at (406) 444-3665.**","VIEW_HISTORY_BUTTON_ALT_TEXT":"View Filings","WIZARD_ERROR_TITLE_MESSAGE":"Form Error","FARM_BILL_SEARCH_INTERACTIVE":true,"USE_FARM_BILL_API":true,"DISALLOW_ASSIGN_SELF_AS_RA":true,"DISALLOW_ASSIGN_SELF_AS_PRINCIPAL":true,"USE_TRADEMARK_OWNER_VALIDATION":true,"USE_ALTERNATIVE_FOREIGN_ADDRESS_LABELS":true,"MY_RECEIPTS_FILTER":[{"type":"dateRange","name":"DATE_RANGE","label":"Date range","defaultValue":{"start":null,"end":null}},{"type":"text","name":"REF_NUM","defaultValue":"","label":"Reference Number"},{"type":"text","name":"RECEIPT_NUM","defaultValue":"","label":"Receipt Id"},{"type":"text","name":"AMOUNT","defaultValue":"","label":"Amount"},{"type":"select","name":"TYPE","defaultValue":"","label":"Payment Type","options":[{"value":"","label":"All"},{"value":"CC","label":"Credit Card"},{"value":"Check","label":"Check"}]}],"MY_RECEIPTS_SHOW_IN_SIDEBAR":true,"SHOW_MY_RECEIPTS_HELPER_TEXT":true,"MY_RECEIPTS_HELPER_LABEL":"About Receipt Search","MY_RECEIPTS_HELPER_TEXT":"You can search for receipts based on their descriptions, including the items paid for on the receipt. Use the filters to search for or filter specific information.","FARM_BILL_SUBLINK":{"label":"Farm Bill","component":"FarmBill","parameter":"farm-bill","path":"/lists/farm-bill","sourceTypeId":0,"myRecordsSearch":false,"allowedRules":["/search/"],"disabled":true,"searchDescription":"To perform a search, enter a debtor name. Your search results may include: exact debtor name, variations of that name and any filing that includes your search criteria. Punctuation is ignored.\n\nYou can click on \"Advanced\" to refine your search. Under “Advanced” you can search by crop, year, county and SSN/FEIN. As a registered Farm Bill Buyer with the Montana Secretary of State’s office it is important to maintain the confidentiality of the information contained within the Farm Bill Master List. The Farm Bill Master List reflects personal data, such as Social Security Numbers, which are a key piece of personal identifiable information to assist you in determining the existence of a lien against a specific debtor. The distribution of this information beyond its intended purpose is strictly prohibited.\n\nThe debtor's tax identification number has been hidden for confidentiality reasons. You may continue to search on a tax ID number and return debtors that match your search criteria. The SSN/FEIN must be entered without dashes or spaces.","searchMustHaveOneOf":["search","UCC_FARM_PRODUCT_ID","COUNTY"],"searchPlaceholder":"Search by debtor name","advancedSearchParameters":[{"type":"ServerMultiComplete","label":"Product code name(s)","name":"UCC_FARM_PRODUCT_ID","defaultValue":"","optionsSrc":"UCC_FARM_PRODUCT_V"},{"type":"MultiComplete","label":"Year or Range of Years","name":"YEAR_NUM","optionsSrc":"years","startYear":"1968","defaultValue":[],"preMergeOptions":[{"value":"ALL","label":"All"}]},{"type":"serverSelect","label":"State","name":"STATE","defaultValue":"MONTANA","optionsSrc":"STATE"},{"type":"ServerMultiComplete","label":"County","name":"COUNTY","defaultValue":[],"optionsSrc":"COUNTY","overrideSubOptionsSrcFromParameterName":"STATE"},{"type":"checkbox","name":"TIN_SEARCH_YN","defaultValue":false,"label":"Tax Identification Number Search"},{"type":"checkbox","name":"TIN_SORT_YN","defaultValue":false,"label":"Unique ID Sort"}]},"ALLOW_ADDRESS_VALIDATION_BYPASS_OPTION":true,"DEFAULT_ADDRESS_VALIDATION_BYPASS_OPTION_CHECKED":true}).LOGIN_HEADER_STYLE === 'full-width' && _react2.default.createElement(
	          'div',
	          {
	            className: 'full-width-banner',
	            style: LOGIN_HEADER_BACKGROUND ? { background: LOGIN_HEADER_BACKGROUND } : undefined
	          },
	          ("") && _react2.default.createElement('img', {
	            src: loginHeaderImg,
	            alt: ("Montana") + ' Login',
	            style: { marginLeft: '20px', marginTop: '15px' }
	          })
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'row ' + (REVERSE_LOGIN_COLUMNS ? 'reverse' : '') },
	          _react2.default.createElement(
	            'div',
	            {
	              className: (doubleColumn ? 'col-sm-6' : undefined) + ' login-column left',
	              style: {
	                paddingTop:  false ? '' : 95
	              }
	            },
	            ({"NODE_ENV":"production","BUILD_DATE":"2025-08-27T15:15:31.687Z","BUILD_NUMBER":"Not Provided","GIT_VERSION":"v1.3.0-381-ga81e29b08","GIT_COMMIT_HASH":"a81e29b085c9268ffd96c78eb734365802722741","GIT_BRANCH":"beta","PUBLIC_URL":"","STATE_ABBR":"MT","STATE_NAME":"Montana","STATE_ORG_TITLE":"Secretary of State","LOGIN_HEADER_IMG_PATH":"","HOME_IMG_FILENAME":"montana.jpg","FAVICON_FILE_NAME":"favicon.ico","ALLOW_E_SIGN_ON_CORRECTIONS":true,"THIRD_PARTY_SIGNING_ALLOWED":false,"MY_ACCOUNT_SAVE_AND_CLOSE_BUTTON":true,"IE_DEPRECATED_MESSAGE":"Internet Explorer is not supported. Please select a supported browser below to access this website.","ADDITIONAL_ROUTES":{"dataRequests":true,"farmBill":true,"apostille":true,"externalHelp":"https://sosmt.gov/business/help-center/","systemAdministration":[{"title":"Saved Payments","parameter":"saved-payments","componentName":"SavedPayments"}]},"SUBROUTES":[{"label":"Business","component":"Business","parameter":"business","myWorkQueueSearch":false,"sourceTypeId":54,"searchMustHaveOneOf":["FILING_TYPE_ID","STATUS_ID","STATE","search"],"serverWebSearchDescription":true,"serverWorkQueueDescription":true,"serverMyRecordsDescription":true,"searchPlaceholder":"Search by name or filing number (X########)","allowEmptySearchTerm":true,"requestCertificateAlternateLabel":"Request Information","fileAmendmentButtonLabel":"Filing Actions","advancedSearchParameters":[{"type":"radio","name":"QUERY_TYPE_ID","defaultValue":1010,"options":[{"value":1010,"label":"Starts with"},{"value":1011,"label":"Contains"},{"value":1012,"label":" Word Contains"}]},{"type":"serverSelect","name":"FILING_TYPE_ID","optionsSrc":"FILING_TYPES","label":"Entity Type","placeholder":"All","defaultValue":"0"},{"type":"serverSelect","name":"FILING_SUBTYPE_ID","optionsSrc":"FILING_SUBTYPES","label":"Entity Subtype","overrideSubOptionsSrcFromParameterName":"FILING_TYPE_ID","placeholder":"All","defaultValue":"0"},{"type":"serverSelect","name":"STATUS_ID","optionsSrc":"FILING_STATUS_WITHOUT_ALL","label":"Status","placeholder":"All","defaultValue":"0"},{"type":"serverSelect","name":"STATE","optionsSrc":"STATE","label":"State","placeholder":"All","defaultValue":""},{"type":"serverSelect","name":"COUNTY","optionsSrc":"COUNTY_SUBOPTION","label":"County","overrideSubOptionsSrcFromParameterName":"STATE","placeholder":"All","defaultValue":""},{"type":"checkbox","name":"CRA_SEARCH_YN","defaultValue":false,"label":"Search by Registered Agent PID"},{"type":"dateRange","name":"FILING_DATE","label":"Registration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}},{"type":"dateRange","name":"EXPIRATION_DATE","label":"Expiration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}}],"myRecordsFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Active"},{"value":2,"label":"Inactive"},{"value":3,"label":"Pending"}]},{"type":"dateRange","name":"DATE_RANGE","label":"Date range","defaultValue":{"start":null,"end":null}}],"myWorkQueueFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Approved"},{"value":2,"label":"Pending Online Payment"},{"value":3,"label":"Pending Review"},{"value":4,"label":"Needs Correction"},{"value":5,"label":"Rejected"},{"value":6,"label":"Draft"}]},{"type":"dateRange","name":"DATE_RANGE","label":"Date range","defaultValue":{"start":null,"end":null}}]},{"label":"Notary","component":"Notary","parameter":"notary","sourceTypeId":850,"myWorkQueueSearch":false,"allowEmptySearchTerm":true,"requestCertificateAlternateLabel":"Download Certificate","fileAmendmentButtonLabel":"Filing Actions","hideNameRequestCertificate":true,"hideAddressRequestCertificate":true,"hideRecordUserManagment":true,"searchPlaceholder":"Search by name or commission number","searchMustHaveOneOf":["CITY","search","SERVICE_TYPE"],"advancedParametersStartOpen":true,"searchIsSortable":true,"advancedSearchParameters":[{"type":"radio","name":"STARTS_WITH_YN","defaultValue":false,"options":[{"value":true,"label":"Starts with"},{"value":false,"label":"Contains"}]},{"type":"checkbox","name":"ACTIVE_ONLY_YN","defaultValue":true,"label":"Active entities only"},{"type":"text","name":"CITY","defaultValue":"","label":"City"},{"type":"select","name":"SERVICE_TYPE","label":"Special Services Offered","defaultValue":0,"options":[{"value":0,"label":"(N/A)"},{"value":6165,"label":"In-Person Electronic Notarization (IPEN)"},{"value":6166,"label":"Remote Online Notarization (RON)"},{"value":6167,"label":"Mobile Notary Services"},{"value":6168,"label":"Remote Ink Notarization (RIN)"}]}]},{"label":"Apostille","component":"Apostille","parameter":"apostille","sourceTypeId":720,"myRecordsSearch":false,"myWorkQueueSearch":false,"disabled":false,"allowedRoutes":["/forms-manager/","/queue/","/forms/"]},{"label":"Liens","component":"UCC","parameter":"ucc","sourceTypeId":1999,"myRecordsSearch":true,"myWorkQueueSearch":true,"fileAmendmentButtonLabel":"Filing Actions","searchPlaceholder":"Search by name or file number","disabled":false,"serverWebSearchDescription":true,"myRecordsDescription":"","workQueueDescription":"","searchDescription":"","hideRecordUserManagment":true,"searchLiensCheckout":false,"advancedSearchParameters":[{"type":"radio","name":"STARTS_WITH_YN","defaultValue":false,"options":[{"value":true,"label":"Starts with"},{"value":false,"label":"Contains"}]},{"type":"select","name":"STATUS","defaultValue":"ALL","label":"Status","options":[{"value":"ACTIVE_UNLAPSED","label":"Active (unlapsed)"},{"value":"ACTIVE_LAPSED_UNLAPSED","label":"Active (lapsed and unlapsed)"}]},{"type":"text","name":"EXCLUDE_VALUES","label":"Exclude Debtor Names (comma separated list of names to exclude)","defaultValue":""},{"type":"dateRange","name":"FILING_DATE","label":"Financing Statement Date","defaultValue":{"start":null,"end":null}},{"type":"dateRange","name":"LAPSE_DATE","label":"Lapse Date","defaultValue":{"start":null,"end":null}},{"type":"text","name":"CITY","label":"Debtor City","defaultValue":""}],"myRecordsFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Approved"},{"value":2,"label":"Pending Online Payment"},{"value":3,"label":"Pending Review"}]},{"type":"select","name":"TYPE","defaultValue":0,"label":"Lien Type","options":[{"value":0,"label":"All"},{"value":1,"label":"UCC"},{"value":2,"label":"EFS"},{"value":3,"label":"Title 71"}]}],"myWorkQueueFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Approved"},{"value":2,"label":"Pending Online Payment"},{"value":3,"label":"Pending Review"},{"value":4,"label":"Pending Print and Mail"},{"value":5,"label":"Rejected"},{"value":6,"label":"Draft"}]},{"type":"select","name":"TYPE","defaultValue":0,"label":"Lien Type","options":[{"value":0,"label":"All"},{"value":1,"label":"UCC"},{"value":2,"label":"EFS"},{"value":3,"label":"Title 71"}]}]},{"label":"Copy Request","component":"copies","parameter":"copies","sourceTypeId":2001,"myRecordsSearch":false,"myWorkQueueSearch":false,"disabled":false,"allowedRoutes":["/forms-manager/","/queue/","/forms/"]},{"label":"Trademark","component":"Trademark","parameter":"trademark","sourceTypeId":810,"showRequestCertificate":true,"searchMustHaveOneOf":["search","EXPIRATION_DATE","FILING_DATE"],"allowEmptySearchTerm":true,"requestCertificateAlternateLabel":"Request Information","fileAmendmentButtonLabel":"Filing Actions","advancedSearchParameters":[{"type":"radio","name":"QUERY_TYPE_ID","defaultValue":1010,"options":[{"value":1010,"label":"Starts with"},{"value":1011,"label":"Contains"},{"value":1012,"label":" Word Contains"}]},{"type":"checkbox","name":"OWNER_SEARCH_YN","defaultValue":false,"label":"Search owners"},{"type":"radio","name":"SERVICE_MARK_YN","label":"Mark Type","defaultValue":"","options":[{"value":"","label":"All Marks"},{"value":"Y","label":"Service Mark"},{"value":"N","label":"Trademark"}]},{"type":"serverSelect","name":"STATUS_ID","optionsSrc":"TYPE_V|TRADEMARK_STATUS_TYPE","label":"Status","placeholder":"All","defaultValue":"0"},{"type":"select","name":"DESIGN_TYPE_ID","options":[{"value":0,"label":"All"},{"value":990,"label":"Words Only"},{"value":991,"label":"Design Only"},{"value":992,"label":"Words and Design"}],"label":"Design Type","defaultValue":"0"},{"type":"dateRange","name":"FILING_DATE","label":"Registered Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}},{"type":"dateRange","name":"EXPIRATION_DATE","label":"Expiration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}}]},{"label":"Business Info Request","component":"InfoRequests","parameter":"info-request","sourceTypeId":167,"allowedRoutes":["/forms-manager/","/queue/","/forms/"]},{"label":"Data Requests","component":"DataRequests","parameter":"data-request","sourceTypeId":0,"allowedRoutes":["/forms-manager/"]},{"label":"CRA","component":"CRA","parameter":"cra","sourceTypeId":157,"myRecordsSearch":false,"searchPlaceholder":"Search by name or registered agent number","allowedRoutes":["/forms-manager/","/forms/","/records/","/queue/","/search/"],"allowEmptySearchTerm":true,"fileAmendmentButtonLabel":"Filing Actions","advancedSearchParameters":[{"type":"radio","name":"QUERY_TYPE_ID","defaultValue":1010,"options":[{"value":1010,"label":"Starts with"},{"value":1011,"label":"Contains"},{"value":1012,"label":" Word Contains"}]},{"type":"dateRange","name":"CRA_DATE","label":"Registration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}},{"type":"select","name":"STATUS_ID","label":"Status","defaultValue":0,"options":[{"value":0,"label":"All"},{"value":121,"label":"Active"},{"value":122,"label":"Inactive"}]},{"type":"select","name":"AGENT_TYPE_ID","label":"Agent Type","defaultValue":0,"options":[{"value":0,"label":"All"},{"value":460,"label":"Registered Agent"},{"value":461,"label":"Commercial Registered Agent"}]}]},{"label":"Farm Bill","component":"FarmBill","parameter":"farm-bill","path":"/lists/farm-bill","sourceTypeId":0,"myRecordsSearch":false,"allowedRules":["/search/"],"disabled":true,"searchDescription":"To perform a search, enter a debtor name. Your search results may include: exact debtor name, variations of that name and any filing that includes your search criteria. Punctuation is ignored.\n\nYou can click on \"Advanced\" to refine your search. Under “Advanced” you can search by crop, year, county and SSN/FEIN. As a registered Farm Bill Buyer with the Montana Secretary of State’s office it is important to maintain the confidentiality of the information contained within the Farm Bill Master List. The Farm Bill Master List reflects personal data, such as Social Security Numbers, which are a key piece of personal identifiable information to assist you in determining the existence of a lien against a specific debtor. The distribution of this information beyond its intended purpose is strictly prohibited.\n\nThe debtor's tax identification number has been hidden for confidentiality reasons. You may continue to search on a tax ID number and return debtors that match your search criteria. The SSN/FEIN must be entered without dashes or spaces.","searchMustHaveOneOf":["search","UCC_FARM_PRODUCT_ID","COUNTY"],"searchPlaceholder":"Search by debtor name","advancedSearchParameters":[{"type":"ServerMultiComplete","label":"Product code name(s)","name":"UCC_FARM_PRODUCT_ID","defaultValue":"","optionsSrc":"UCC_FARM_PRODUCT_V"},{"type":"MultiComplete","label":"Year or Range of Years","name":"YEAR_NUM","optionsSrc":"years","startYear":"1968","defaultValue":[],"preMergeOptions":[{"value":"ALL","label":"All"}]},{"type":"serverSelect","label":"State","name":"STATE","defaultValue":"MONTANA","optionsSrc":"STATE"},{"type":"ServerMultiComplete","label":"County","name":"COUNTY","defaultValue":[],"optionsSrc":"COUNTY","overrideSubOptionsSrcFromParameterName":"STATE"},{"type":"checkbox","name":"TIN_SEARCH_YN","defaultValue":false,"label":"Tax Identification Number Search"},{"type":"checkbox","name":"TIN_SORT_YN","defaultValue":false,"label":"Unique ID Sort"}]}],"SYSTEM_NICKNAME":"Online Services Portal","PAYMENT_METHODS":[{"type":"bypass"},{"type":"iTransact"}],"PAYMENT_ALLOW_AMEX":true,"SYSTEM_ID_LABEL":"System Id","DOUBLE_COLUMN_PUBLIC_LOGIN":true,"INTERNAL_USER_MANAGEMENT":true,"ALLOW_PUBLIC_JSON_IMPORT":false,"MAX_FILE_UPLOAD_SIZE":10000000,"REFUND_TEXT":"","RETURN_TO_HOME_ON_LOGOUT":true,"CURRENT_SOS_NAME":"Christi Jacobsen","LOGO_FILENAME":"mt-sos-logo.png","LOGO_ALT":"Christi Jacobsen, Montana Secretary of State","LOGO_FULL_WIDTH":true,"HOME_HIDE_AUTH_HINT":true,"HOME_TITLE":"Montana Secretary of State","CUSTOM_TAB_TITLE":"Official Montana","HOME_SUBTITLE":"Online Business Services","ENTITY_NAME_CONSENT_DESCRIPTION":"","ALLOW_USER_PROFILE_EDITING":true,"COMPARE_FOREIGN_NAME_IN_ENTITY_NAME_VALIDATION":true,"FOREIGN_NAME_FIELD_NAME":"KIMA_PARENT_NAME_INFO","LOGIN_TITLE":"Montana Secretary of State Online Filing Portal Login","PUBLIC_LOGIN_LABEL":"Username","REVERSE_LOGIN_COLUMNS":true,"LOGIN_SEAL_FILENAME":"seal_white.png","SEPARATE_USERNAME_AND_EMAIL":true,"CREATE_ACCOUNT_BUTTON_ALIGN_LEFT":true,"CREATE_ACCOUNT_BUTTON_TEXT":"CREATE AN ACCOUNT","PASSWORD_CUSTOM_ERROR_TEXT":"The password must meet all requirements","ACCOUNT_CREATED_MESSAGE":"Please check your email to verify your account to login and allow a few minutes for this message to arrive. Check your junk/spam folders if you do not find the email in your inbox.","PUBLIC_LOGIN_PLACEHOLDER":" ","DISABLE_DEFAULT_PAYMENT_RADIO":true,"CUSTOM_RESET_PASSWORD_ERROR_MESSAGE":"Username invalid - no account found","PUBLIC_LOGIN_CREATE_DESCRIPTION":"### Existing User:\n\n  - Enter your username and password to login.  \n\n\n  #### - OR -  \n\n\n\n  - Forgot password? Click 'Reset Password' and follow the prompts.\n  - Forgot username? Click 'Forgot Username' and follow the prompts.  \n\n\n  ### New User:\n  ","LOGIN_HELP_LINK":"https://sosmt.gov/business/how-do-i/","LOGIN_HELP_LINK_TEXT":"Need Help?","FORGOT_USERNAME_TEXT":"Forgot Username?","LOGIN_ACTIVE_DIRECTORY_TEXT":"State User Login","MULTIPLE_LOGIN_METHODS":true,"HAS_ACTIVE_DIRECTORY_LOGIN":true,"RESET_PASSWORD_WITH_USERNAME":true,"DOWNLOAD_LINK":true,"SHOW_USERNAME_ACCOUNT_CREATE":true,"SHOW_SCROLL_DOWN_ARROW":true,"SHOW_ADDRESS_ACCOUNT_CREATE":true,"TWO_COLUMN_ACCOUNT_CREATE":true,"RESET_PASSWORD_TIP":"A link to change your password has been sent to your email. Please allow a few minutes for this message to arrive. Please check your junk/spam folders if you do not find the email in your inbox.","FORGOT_PASSWORD_LINK_TEXT":"Reset Password","PHONE_NUMBER_OPTIONAL_ACCOUNT_CREATE":true,"SHOW_REQUIRED_INDICATOR_ACCOUNT_CREATE":true,"PASSWORD_REQUIREMENTS_ACCOUNT_CREATE":"\n    <ul>\n      <li>MUST contain at least 8 characters (12+ recommended)</li>\n      <li>MUST contain at least one uppercase letter.</li>\n      <li>MUST contain at least one lowercase letter.</li>\n      <li>MUST contain at least one number.</li>\n      <li>MUST contain at least one special character (!”#$%&'()*+,-./:;<=>?</li>\n    </ul>\n  ","ALLOW_CERTIFICATION_REQUEST":true,"ALLOW_PUBLIC_CERTIFICATE_REQUEST":true,"ALLOW_COPY_REQUEST":false,"ALLOW_CORRECTION_STYLING":true,"HIDE_DEPRECATION_WARNING":false,"AMEND_ROUTE_PUBLIC":true,"SEAL_FILENAME":"seal.png","SHOPPING_CART":true,"ALLOW_PAYMENT_UPDATE_WITH_EMPTY_CART":true,"RA_EMAIL":true,"RA_WEBSITE":true,"RA_NO_DEFAULT_TYPE":true,"RA_ADDRESS_LABEL":"Street Address","RA_TYPE_SELECTION_DEFAULT":true,"RA_DEFAULT_TYPE":"460","RA_OVERRIDE_TYPE_WITH_DEFAULT":true,"RA_PRINCIPAL_ADDRESS_AMS":true,"UPLOAD_AND_SUBMIT_HIDE_IF_ONE_OPTION":true,"PAYMENT_PROCESSING_MESSAGE":"Your payment is processing - Do not close your browser or click the back button","CHECKOUT_BUTTON_WHEN_PROCESSING_TEXT":"Processing","EFS_CROP_PICKER_NONE_LABEL":"Lien Duration","DISALLOWED_WIZARD_PIECES":["FormationLocale"],"REPEATER_SHOW_EDIT_BUTTON":true,"DATA_REQUEST_PAGE_TITLE":"Data Requests and Subscriptions","DATA_REQUEST_SIDEBAR_LABEL":"Data Requests & Subscriptions","LOGIN_REDIRECTS_TO_EPASS":false,"LOGIN_REDIRECTS_TO_ACTIVE_DIRECTORY":true,"LOGIN_ACTIVE_DIRECTORY_LINK":true,"FETCH_EDIT_USER_LINK":false,"LISTS_FETCH_AVAILABLE_LISTS":true,"POST_WIZARD_SUBMIT_REDIRECT_URL":"/","PIN_REQUEST_ATTESTATIONS":true,"PIN_REQUEST_DESCRIPTION":"Click **Request PIN** to have a new PIN sent to the account holder's email address on file.","OWNERSHIP_REQUEST_DESCRIPTION":"To become an **authorized user** of this record, a current **AUTHORIZED USER** will need to grant you access. To request access, click **Request Access** below.","PIN_REQUEST_SUCCESS_MESSAGE":"The PIN you have requested for this entity has been sent to the email associated with your user account.  You should receive the PIN in approximately 3-5 minutes, depending on your email service provider.","APOSTILLE_HEADER_LABEL":"Verification Information","APOSTILLE_NUMBER_LABEL":"Apostille/Authentication","APOSTILLE_CITY_STATE_OVERRIDE":"HELENA, MT","APOSTILLE_FILING_DATE_LABEL":"Issue Date","APOSTILLE_CITY_STATE_IN_CERTIFIED":true,"NOTARY_EXISTING_FILING":true,"ALLOW_REVOKE_OWN_ACCESS_ONLY":false,"HIDE_CANCEL_ON_ONETIME_DATA_REQUESTS":true,"DATA_REQUESTS_IN_SHOPPING_CART":true,"WQ_ALLOW_EDIT_PENDING_PAYMENT":true,"WQ_CONFIRM_ON_DELETE":true,"WQ_DELETE_CONFIRM_MESSAGE":"Deleting this filing will forfeit any money already paid to the Secretary of State. This action is permanent and cannot be undone, are you sure you would like to delete?","PASS_ITEM_GUIDS_ON_CHECKOUT":true,"FORM_REVISION_HISTORY":true,"CHECKOUT_DISCLAIMER":"By entering your credit card and/or checking account information you (i) state that **you are an authorized user** of the credit card and/or electronic check and that the associated information entered (e.g., account holder name, account number, billing address) is accurate, (ii) **you authorize payment processor to charge the amount you have requested** to your credit card and/or funding account, and (iii) **acknowledge if a charge is declined or reversed you may also be assessed a customary charge** by the payment processor for such transactions.","FARM_BILL_SEARCH_CONFIDENTIAL":"As a registered Farm Bill Buyer with the Montana Secretary of State’s office it is important to maintain the confidentiality of the information contained within the Farm Bill Master List. The Farm Bill Master List reflects personal data, such as Social Security Numbers, which are a key piece of personal identifiable information to assist you in determining the existence of a lien against a specific debtor. The distribution of this information beyond its intended purpose is strictly prohibited.\n\n**The debtor's tax identification number has been hidden for confidentiality reasons. You may continue to search on a tax ID number and return debtors that match your search criteria. The SSN/FEIN must be entered without dashes or spaces.  If you need access to the tax identification number to clearly identify the debtor, please contact the UCC unit at (406) 444-3665.**","VIEW_HISTORY_BUTTON_ALT_TEXT":"View Filings","WIZARD_ERROR_TITLE_MESSAGE":"Form Error","FARM_BILL_SEARCH_INTERACTIVE":true,"USE_FARM_BILL_API":true,"DISALLOW_ASSIGN_SELF_AS_RA":true,"DISALLOW_ASSIGN_SELF_AS_PRINCIPAL":true,"USE_TRADEMARK_OWNER_VALIDATION":true,"USE_ALTERNATIVE_FOREIGN_ADDRESS_LABELS":true,"MY_RECEIPTS_FILTER":[{"type":"dateRange","name":"DATE_RANGE","label":"Date range","defaultValue":{"start":null,"end":null}},{"type":"text","name":"REF_NUM","defaultValue":"","label":"Reference Number"},{"type":"text","name":"RECEIPT_NUM","defaultValue":"","label":"Receipt Id"},{"type":"text","name":"AMOUNT","defaultValue":"","label":"Amount"},{"type":"select","name":"TYPE","defaultValue":"","label":"Payment Type","options":[{"value":"","label":"All"},{"value":"CC","label":"Credit Card"},{"value":"Check","label":"Check"}]}],"MY_RECEIPTS_SHOW_IN_SIDEBAR":true,"SHOW_MY_RECEIPTS_HELPER_TEXT":true,"MY_RECEIPTS_HELPER_LABEL":"About Receipt Search","MY_RECEIPTS_HELPER_TEXT":"You can search for receipts based on their descriptions, including the items paid for on the receipt. Use the filters to search for or filter specific information.","FARM_BILL_SUBLINK":{"label":"Farm Bill","component":"FarmBill","parameter":"farm-bill","path":"/lists/farm-bill","sourceTypeId":0,"myRecordsSearch":false,"allowedRules":["/search/"],"disabled":true,"searchDescription":"To perform a search, enter a debtor name. Your search results may include: exact debtor name, variations of that name and any filing that includes your search criteria. Punctuation is ignored.\n\nYou can click on \"Advanced\" to refine your search. Under “Advanced” you can search by crop, year, county and SSN/FEIN. As a registered Farm Bill Buyer with the Montana Secretary of State’s office it is important to maintain the confidentiality of the information contained within the Farm Bill Master List. The Farm Bill Master List reflects personal data, such as Social Security Numbers, which are a key piece of personal identifiable information to assist you in determining the existence of a lien against a specific debtor. The distribution of this information beyond its intended purpose is strictly prohibited.\n\nThe debtor's tax identification number has been hidden for confidentiality reasons. You may continue to search on a tax ID number and return debtors that match your search criteria. The SSN/FEIN must be entered without dashes or spaces.","searchMustHaveOneOf":["search","UCC_FARM_PRODUCT_ID","COUNTY"],"searchPlaceholder":"Search by debtor name","advancedSearchParameters":[{"type":"ServerMultiComplete","label":"Product code name(s)","name":"UCC_FARM_PRODUCT_ID","defaultValue":"","optionsSrc":"UCC_FARM_PRODUCT_V"},{"type":"MultiComplete","label":"Year or Range of Years","name":"YEAR_NUM","optionsSrc":"years","startYear":"1968","defaultValue":[],"preMergeOptions":[{"value":"ALL","label":"All"}]},{"type":"serverSelect","label":"State","name":"STATE","defaultValue":"MONTANA","optionsSrc":"STATE"},{"type":"ServerMultiComplete","label":"County","name":"COUNTY","defaultValue":[],"optionsSrc":"COUNTY","overrideSubOptionsSrcFromParameterName":"STATE"},{"type":"checkbox","name":"TIN_SEARCH_YN","defaultValue":false,"label":"Tax Identification Number Search"},{"type":"checkbox","name":"TIN_SORT_YN","defaultValue":false,"label":"Unique ID Sort"}]},"ALLOW_ADDRESS_VALIDATION_BYPASS_OPTION":true,"DEFAULT_ADDRESS_VALIDATION_BYPASS_OPTION_CHECKED":true}).LOGIN_HEADER_STYLE !== 'full-width' && ( false ? _react2.default.createElement('img', {
	              src: loginHeaderImg,
	              alt: process.env.STATE_NAME + ' Login',
	              style: { marginLeft: '20px', marginTop: '15px' }
	            }) : REVERSE_LOGIN_COLUMNS && loginActive ? null : _react2.default.createElement(
	              'div',
	              { className: 'banner' },
	              this.state.activeView === 'create' && 'Create ' + ("Montana") + ' Account',
	              this.state.activeView === 'login' && (("Montana Secretary of State Online Filing Portal Login") || ("Montana") + ' Login'),
	              this.state.activeView === 'forgot' && 'Forgot Password',
	              this.state.activeView === 'forgotUsername' && 'Forgot Username'
	            )),
	            this.state.forgotSuccess && _react2.default.createElement(
	              'div',
	              { className: 'info' },
	              ("A link to change your password has been sent to your email. Please allow a few minutes for this message to arrive. Please check your junk/spam folders if you do not find the email in your inbox.") || 'A link to change your password has been sent to your email. Please allow a few minutes for this message to arrive.'
	            ),
	            this.state.forgotUsernameSuccess && _react2.default.createElement(
	              'div',
	              { className: 'info' },
	              'An email has been sent with the username(s) associated with your email address. Please allow a few minutes for this message to arrive. Check your junk/spam folders if you do not find the email in your inbox.'
	            ),
	            this.state.changedSuccess && _react2.default.createElement(
	              'div',
	              { className: 'info' },
	              'Password successfully changed, please login with your new password below.'
	            ),
	            this.state.loginMessage && _react2.default.createElement(
	              'div',
	              { className: 'info ' + (this.state.loginMessage.type || '') },
	              this.state.loginMessage.message
	            ),
	            this.state.activeView === 'create' && _react2.default.createElement(_CreateAccount2.default, { returnToLogin: this.setActiveViewLogin }),
	            this.state.activeView === 'login' && _react2.default.createElement(LoginForm, {
	              ref: function ref(_ref4) {
	                return _this3.loginForm = _ref4;
	              },
	              checkEnter: this.checkEnter,
	              error: this.state.error,
	              login: this.login,
	              startAccountCreation: this.setActiveViewCreate,
	              startForgotPassword: this.setActiveViewForgot,
	              startForgotUsername: this.setActiveViewForgotUsername,
	              pathname: this.props.pathname,
	              search: this.props.search,
	              setStateUser: this.props.setStateUser,
	              toggleLoginModal: this.props.toggleLoginModal
	            }),
	            this.state.activeView === 'forgot' && _react2.default.createElement(_ForgotPasswordForm2.default, {
	              returnToLogin: this.setActiveViewLogin,
	              returnAndDisplaySuccess: this.setLoginViewWithForgotSuccess
	            }),
	            this.state.activeView === 'forgotUsername' && _react2.default.createElement(_ForgotUsernameForm2.default, {
	              returnToLogin: this.setActiveViewLogin,
	              returnAndDisplaySuccess: this.setLoginViewWithForgotUsernameSuccess
	            })
	          ),
	          doubleColumn && _react2.default.createElement(LoginInformationColumn, {
	            startAccountCreation: this.setActiveViewCreate,
	            banner: loginActive && REVERSE_LOGIN_COLUMNS && DOUBLE_COLUMN_PUBLIC_LOGIN ? ("Montana Secretary of State Online Filing Portal Login") : undefined
	          })
	        ),
	        LOGIN_FOOTER_TEXT && _react2.default.createElement(_Markdown2.default, { className: 'login-footer', source: LOGIN_FOOTER_TEXT })
	      );
	    }
	  }]);
	
	  return PublicLogin;
	}(_react.Component);
	
	exports.PublicLogin = PublicLogin = (0, _reactRedux.connect)(function (state) {
	  return {
	    user: state.app.user,
	    siteOffline: state.app.appSettings.WEBSITE_PORTAL_OFFLINE_YN === true,
	    pathname: state.router.location.pathname,
	    search: state.router.location.search
	  };
	}, { loginWebUser: _AuthActions.loginWebUser, setStateUser: _actions.setStateUser, toggleLoginModal: _actions.toggleLoginModal })(PublicLogin);
	
	var LOGIN_CREATE_PERSONAL_LINK = ({"NODE_ENV":"production","BUILD_DATE":"2025-08-27T15:15:31.687Z","BUILD_NUMBER":"Not Provided","GIT_VERSION":"v1.3.0-381-ga81e29b08","GIT_COMMIT_HASH":"a81e29b085c9268ffd96c78eb734365802722741","GIT_BRANCH":"beta","PUBLIC_URL":"","STATE_ABBR":"MT","STATE_NAME":"Montana","STATE_ORG_TITLE":"Secretary of State","LOGIN_HEADER_IMG_PATH":"","HOME_IMG_FILENAME":"montana.jpg","FAVICON_FILE_NAME":"favicon.ico","ALLOW_E_SIGN_ON_CORRECTIONS":true,"THIRD_PARTY_SIGNING_ALLOWED":false,"MY_ACCOUNT_SAVE_AND_CLOSE_BUTTON":true,"IE_DEPRECATED_MESSAGE":"Internet Explorer is not supported. Please select a supported browser below to access this website.","ADDITIONAL_ROUTES":{"dataRequests":true,"farmBill":true,"apostille":true,"externalHelp":"https://sosmt.gov/business/help-center/","systemAdministration":[{"title":"Saved Payments","parameter":"saved-payments","componentName":"SavedPayments"}]},"SUBROUTES":[{"label":"Business","component":"Business","parameter":"business","myWorkQueueSearch":false,"sourceTypeId":54,"searchMustHaveOneOf":["FILING_TYPE_ID","STATUS_ID","STATE","search"],"serverWebSearchDescription":true,"serverWorkQueueDescription":true,"serverMyRecordsDescription":true,"searchPlaceholder":"Search by name or filing number (X########)","allowEmptySearchTerm":true,"requestCertificateAlternateLabel":"Request Information","fileAmendmentButtonLabel":"Filing Actions","advancedSearchParameters":[{"type":"radio","name":"QUERY_TYPE_ID","defaultValue":1010,"options":[{"value":1010,"label":"Starts with"},{"value":1011,"label":"Contains"},{"value":1012,"label":" Word Contains"}]},{"type":"serverSelect","name":"FILING_TYPE_ID","optionsSrc":"FILING_TYPES","label":"Entity Type","placeholder":"All","defaultValue":"0"},{"type":"serverSelect","name":"FILING_SUBTYPE_ID","optionsSrc":"FILING_SUBTYPES","label":"Entity Subtype","overrideSubOptionsSrcFromParameterName":"FILING_TYPE_ID","placeholder":"All","defaultValue":"0"},{"type":"serverSelect","name":"STATUS_ID","optionsSrc":"FILING_STATUS_WITHOUT_ALL","label":"Status","placeholder":"All","defaultValue":"0"},{"type":"serverSelect","name":"STATE","optionsSrc":"STATE","label":"State","placeholder":"All","defaultValue":""},{"type":"serverSelect","name":"COUNTY","optionsSrc":"COUNTY_SUBOPTION","label":"County","overrideSubOptionsSrcFromParameterName":"STATE","placeholder":"All","defaultValue":""},{"type":"checkbox","name":"CRA_SEARCH_YN","defaultValue":false,"label":"Search by Registered Agent PID"},{"type":"dateRange","name":"FILING_DATE","label":"Registration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}},{"type":"dateRange","name":"EXPIRATION_DATE","label":"Expiration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}}],"myRecordsFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Active"},{"value":2,"label":"Inactive"},{"value":3,"label":"Pending"}]},{"type":"dateRange","name":"DATE_RANGE","label":"Date range","defaultValue":{"start":null,"end":null}}],"myWorkQueueFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Approved"},{"value":2,"label":"Pending Online Payment"},{"value":3,"label":"Pending Review"},{"value":4,"label":"Needs Correction"},{"value":5,"label":"Rejected"},{"value":6,"label":"Draft"}]},{"type":"dateRange","name":"DATE_RANGE","label":"Date range","defaultValue":{"start":null,"end":null}}]},{"label":"Notary","component":"Notary","parameter":"notary","sourceTypeId":850,"myWorkQueueSearch":false,"allowEmptySearchTerm":true,"requestCertificateAlternateLabel":"Download Certificate","fileAmendmentButtonLabel":"Filing Actions","hideNameRequestCertificate":true,"hideAddressRequestCertificate":true,"hideRecordUserManagment":true,"searchPlaceholder":"Search by name or commission number","searchMustHaveOneOf":["CITY","search","SERVICE_TYPE"],"advancedParametersStartOpen":true,"searchIsSortable":true,"advancedSearchParameters":[{"type":"radio","name":"STARTS_WITH_YN","defaultValue":false,"options":[{"value":true,"label":"Starts with"},{"value":false,"label":"Contains"}]},{"type":"checkbox","name":"ACTIVE_ONLY_YN","defaultValue":true,"label":"Active entities only"},{"type":"text","name":"CITY","defaultValue":"","label":"City"},{"type":"select","name":"SERVICE_TYPE","label":"Special Services Offered","defaultValue":0,"options":[{"value":0,"label":"(N/A)"},{"value":6165,"label":"In-Person Electronic Notarization (IPEN)"},{"value":6166,"label":"Remote Online Notarization (RON)"},{"value":6167,"label":"Mobile Notary Services"},{"value":6168,"label":"Remote Ink Notarization (RIN)"}]}]},{"label":"Apostille","component":"Apostille","parameter":"apostille","sourceTypeId":720,"myRecordsSearch":false,"myWorkQueueSearch":false,"disabled":false,"allowedRoutes":["/forms-manager/","/queue/","/forms/"]},{"label":"Liens","component":"UCC","parameter":"ucc","sourceTypeId":1999,"myRecordsSearch":true,"myWorkQueueSearch":true,"fileAmendmentButtonLabel":"Filing Actions","searchPlaceholder":"Search by name or file number","disabled":false,"serverWebSearchDescription":true,"myRecordsDescription":"","workQueueDescription":"","searchDescription":"","hideRecordUserManagment":true,"searchLiensCheckout":false,"advancedSearchParameters":[{"type":"radio","name":"STARTS_WITH_YN","defaultValue":false,"options":[{"value":true,"label":"Starts with"},{"value":false,"label":"Contains"}]},{"type":"select","name":"STATUS","defaultValue":"ALL","label":"Status","options":[{"value":"ACTIVE_UNLAPSED","label":"Active (unlapsed)"},{"value":"ACTIVE_LAPSED_UNLAPSED","label":"Active (lapsed and unlapsed)"}]},{"type":"text","name":"EXCLUDE_VALUES","label":"Exclude Debtor Names (comma separated list of names to exclude)","defaultValue":""},{"type":"dateRange","name":"FILING_DATE","label":"Financing Statement Date","defaultValue":{"start":null,"end":null}},{"type":"dateRange","name":"LAPSE_DATE","label":"Lapse Date","defaultValue":{"start":null,"end":null}},{"type":"text","name":"CITY","label":"Debtor City","defaultValue":""}],"myRecordsFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Approved"},{"value":2,"label":"Pending Online Payment"},{"value":3,"label":"Pending Review"}]},{"type":"select","name":"TYPE","defaultValue":0,"label":"Lien Type","options":[{"value":0,"label":"All"},{"value":1,"label":"UCC"},{"value":2,"label":"EFS"},{"value":3,"label":"Title 71"}]}],"myWorkQueueFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Approved"},{"value":2,"label":"Pending Online Payment"},{"value":3,"label":"Pending Review"},{"value":4,"label":"Pending Print and Mail"},{"value":5,"label":"Rejected"},{"value":6,"label":"Draft"}]},{"type":"select","name":"TYPE","defaultValue":0,"label":"Lien Type","options":[{"value":0,"label":"All"},{"value":1,"label":"UCC"},{"value":2,"label":"EFS"},{"value":3,"label":"Title 71"}]}]},{"label":"Copy Request","component":"copies","parameter":"copies","sourceTypeId":2001,"myRecordsSearch":false,"myWorkQueueSearch":false,"disabled":false,"allowedRoutes":["/forms-manager/","/queue/","/forms/"]},{"label":"Trademark","component":"Trademark","parameter":"trademark","sourceTypeId":810,"showRequestCertificate":true,"searchMustHaveOneOf":["search","EXPIRATION_DATE","FILING_DATE"],"allowEmptySearchTerm":true,"requestCertificateAlternateLabel":"Request Information","fileAmendmentButtonLabel":"Filing Actions","advancedSearchParameters":[{"type":"radio","name":"QUERY_TYPE_ID","defaultValue":1010,"options":[{"value":1010,"label":"Starts with"},{"value":1011,"label":"Contains"},{"value":1012,"label":" Word Contains"}]},{"type":"checkbox","name":"OWNER_SEARCH_YN","defaultValue":false,"label":"Search owners"},{"type":"radio","name":"SERVICE_MARK_YN","label":"Mark Type","defaultValue":"","options":[{"value":"","label":"All Marks"},{"value":"Y","label":"Service Mark"},{"value":"N","label":"Trademark"}]},{"type":"serverSelect","name":"STATUS_ID","optionsSrc":"TYPE_V|TRADEMARK_STATUS_TYPE","label":"Status","placeholder":"All","defaultValue":"0"},{"type":"select","name":"DESIGN_TYPE_ID","options":[{"value":0,"label":"All"},{"value":990,"label":"Words Only"},{"value":991,"label":"Design Only"},{"value":992,"label":"Words and Design"}],"label":"Design Type","defaultValue":"0"},{"type":"dateRange","name":"FILING_DATE","label":"Registered Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}},{"type":"dateRange","name":"EXPIRATION_DATE","label":"Expiration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}}]},{"label":"Business Info Request","component":"InfoRequests","parameter":"info-request","sourceTypeId":167,"allowedRoutes":["/forms-manager/","/queue/","/forms/"]},{"label":"Data Requests","component":"DataRequests","parameter":"data-request","sourceTypeId":0,"allowedRoutes":["/forms-manager/"]},{"label":"CRA","component":"CRA","parameter":"cra","sourceTypeId":157,"myRecordsSearch":false,"searchPlaceholder":"Search by name or registered agent number","allowedRoutes":["/forms-manager/","/forms/","/records/","/queue/","/search/"],"allowEmptySearchTerm":true,"fileAmendmentButtonLabel":"Filing Actions","advancedSearchParameters":[{"type":"radio","name":"QUERY_TYPE_ID","defaultValue":1010,"options":[{"value":1010,"label":"Starts with"},{"value":1011,"label":"Contains"},{"value":1012,"label":" Word Contains"}]},{"type":"dateRange","name":"CRA_DATE","label":"Registration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}},{"type":"select","name":"STATUS_ID","label":"Status","defaultValue":0,"options":[{"value":0,"label":"All"},{"value":121,"label":"Active"},{"value":122,"label":"Inactive"}]},{"type":"select","name":"AGENT_TYPE_ID","label":"Agent Type","defaultValue":0,"options":[{"value":0,"label":"All"},{"value":460,"label":"Registered Agent"},{"value":461,"label":"Commercial Registered Agent"}]}]},{"label":"Farm Bill","component":"FarmBill","parameter":"farm-bill","path":"/lists/farm-bill","sourceTypeId":0,"myRecordsSearch":false,"allowedRules":["/search/"],"disabled":true,"searchDescription":"To perform a search, enter a debtor name. Your search results may include: exact debtor name, variations of that name and any filing that includes your search criteria. Punctuation is ignored.\n\nYou can click on \"Advanced\" to refine your search. Under “Advanced” you can search by crop, year, county and SSN/FEIN. As a registered Farm Bill Buyer with the Montana Secretary of State’s office it is important to maintain the confidentiality of the information contained within the Farm Bill Master List. The Farm Bill Master List reflects personal data, such as Social Security Numbers, which are a key piece of personal identifiable information to assist you in determining the existence of a lien against a specific debtor. The distribution of this information beyond its intended purpose is strictly prohibited.\n\nThe debtor's tax identification number has been hidden for confidentiality reasons. You may continue to search on a tax ID number and return debtors that match your search criteria. The SSN/FEIN must be entered without dashes or spaces.","searchMustHaveOneOf":["search","UCC_FARM_PRODUCT_ID","COUNTY"],"searchPlaceholder":"Search by debtor name","advancedSearchParameters":[{"type":"ServerMultiComplete","label":"Product code name(s)","name":"UCC_FARM_PRODUCT_ID","defaultValue":"","optionsSrc":"UCC_FARM_PRODUCT_V"},{"type":"MultiComplete","label":"Year or Range of Years","name":"YEAR_NUM","optionsSrc":"years","startYear":"1968","defaultValue":[],"preMergeOptions":[{"value":"ALL","label":"All"}]},{"type":"serverSelect","label":"State","name":"STATE","defaultValue":"MONTANA","optionsSrc":"STATE"},{"type":"ServerMultiComplete","label":"County","name":"COUNTY","defaultValue":[],"optionsSrc":"COUNTY","overrideSubOptionsSrcFromParameterName":"STATE"},{"type":"checkbox","name":"TIN_SEARCH_YN","defaultValue":false,"label":"Tax Identification Number Search"},{"type":"checkbox","name":"TIN_SORT_YN","defaultValue":false,"label":"Unique ID Sort"}]}],"SYSTEM_NICKNAME":"Online Services Portal","PAYMENT_METHODS":[{"type":"bypass"},{"type":"iTransact"}],"PAYMENT_ALLOW_AMEX":true,"SYSTEM_ID_LABEL":"System Id","DOUBLE_COLUMN_PUBLIC_LOGIN":true,"INTERNAL_USER_MANAGEMENT":true,"ALLOW_PUBLIC_JSON_IMPORT":false,"MAX_FILE_UPLOAD_SIZE":10000000,"REFUND_TEXT":"","RETURN_TO_HOME_ON_LOGOUT":true,"CURRENT_SOS_NAME":"Christi Jacobsen","LOGO_FILENAME":"mt-sos-logo.png","LOGO_ALT":"Christi Jacobsen, Montana Secretary of State","LOGO_FULL_WIDTH":true,"HOME_HIDE_AUTH_HINT":true,"HOME_TITLE":"Montana Secretary of State","CUSTOM_TAB_TITLE":"Official Montana","HOME_SUBTITLE":"Online Business Services","ENTITY_NAME_CONSENT_DESCRIPTION":"","ALLOW_USER_PROFILE_EDITING":true,"COMPARE_FOREIGN_NAME_IN_ENTITY_NAME_VALIDATION":true,"FOREIGN_NAME_FIELD_NAME":"KIMA_PARENT_NAME_INFO","LOGIN_TITLE":"Montana Secretary of State Online Filing Portal Login","PUBLIC_LOGIN_LABEL":"Username","REVERSE_LOGIN_COLUMNS":true,"LOGIN_SEAL_FILENAME":"seal_white.png","SEPARATE_USERNAME_AND_EMAIL":true,"CREATE_ACCOUNT_BUTTON_ALIGN_LEFT":true,"CREATE_ACCOUNT_BUTTON_TEXT":"CREATE AN ACCOUNT","PASSWORD_CUSTOM_ERROR_TEXT":"The password must meet all requirements","ACCOUNT_CREATED_MESSAGE":"Please check your email to verify your account to login and allow a few minutes for this message to arrive. Check your junk/spam folders if you do not find the email in your inbox.","PUBLIC_LOGIN_PLACEHOLDER":" ","DISABLE_DEFAULT_PAYMENT_RADIO":true,"CUSTOM_RESET_PASSWORD_ERROR_MESSAGE":"Username invalid - no account found","PUBLIC_LOGIN_CREATE_DESCRIPTION":"### Existing User:\n\n  - Enter your username and password to login.  \n\n\n  #### - OR -  \n\n\n\n  - Forgot password? Click 'Reset Password' and follow the prompts.\n  - Forgot username? Click 'Forgot Username' and follow the prompts.  \n\n\n  ### New User:\n  ","LOGIN_HELP_LINK":"https://sosmt.gov/business/how-do-i/","LOGIN_HELP_LINK_TEXT":"Need Help?","FORGOT_USERNAME_TEXT":"Forgot Username?","LOGIN_ACTIVE_DIRECTORY_TEXT":"State User Login","MULTIPLE_LOGIN_METHODS":true,"HAS_ACTIVE_DIRECTORY_LOGIN":true,"RESET_PASSWORD_WITH_USERNAME":true,"DOWNLOAD_LINK":true,"SHOW_USERNAME_ACCOUNT_CREATE":true,"SHOW_SCROLL_DOWN_ARROW":true,"SHOW_ADDRESS_ACCOUNT_CREATE":true,"TWO_COLUMN_ACCOUNT_CREATE":true,"RESET_PASSWORD_TIP":"A link to change your password has been sent to your email. Please allow a few minutes for this message to arrive. Please check your junk/spam folders if you do not find the email in your inbox.","FORGOT_PASSWORD_LINK_TEXT":"Reset Password","PHONE_NUMBER_OPTIONAL_ACCOUNT_CREATE":true,"SHOW_REQUIRED_INDICATOR_ACCOUNT_CREATE":true,"PASSWORD_REQUIREMENTS_ACCOUNT_CREATE":"\n    <ul>\n      <li>MUST contain at least 8 characters (12+ recommended)</li>\n      <li>MUST contain at least one uppercase letter.</li>\n      <li>MUST contain at least one lowercase letter.</li>\n      <li>MUST contain at least one number.</li>\n      <li>MUST contain at least one special character (!”#$%&'()*+,-./:;<=>?</li>\n    </ul>\n  ","ALLOW_CERTIFICATION_REQUEST":true,"ALLOW_PUBLIC_CERTIFICATE_REQUEST":true,"ALLOW_COPY_REQUEST":false,"ALLOW_CORRECTION_STYLING":true,"HIDE_DEPRECATION_WARNING":false,"AMEND_ROUTE_PUBLIC":true,"SEAL_FILENAME":"seal.png","SHOPPING_CART":true,"ALLOW_PAYMENT_UPDATE_WITH_EMPTY_CART":true,"RA_EMAIL":true,"RA_WEBSITE":true,"RA_NO_DEFAULT_TYPE":true,"RA_ADDRESS_LABEL":"Street Address","RA_TYPE_SELECTION_DEFAULT":true,"RA_DEFAULT_TYPE":"460","RA_OVERRIDE_TYPE_WITH_DEFAULT":true,"RA_PRINCIPAL_ADDRESS_AMS":true,"UPLOAD_AND_SUBMIT_HIDE_IF_ONE_OPTION":true,"PAYMENT_PROCESSING_MESSAGE":"Your payment is processing - Do not close your browser or click the back button","CHECKOUT_BUTTON_WHEN_PROCESSING_TEXT":"Processing","EFS_CROP_PICKER_NONE_LABEL":"Lien Duration","DISALLOWED_WIZARD_PIECES":["FormationLocale"],"REPEATER_SHOW_EDIT_BUTTON":true,"DATA_REQUEST_PAGE_TITLE":"Data Requests and Subscriptions","DATA_REQUEST_SIDEBAR_LABEL":"Data Requests & Subscriptions","LOGIN_REDIRECTS_TO_EPASS":false,"LOGIN_REDIRECTS_TO_ACTIVE_DIRECTORY":true,"LOGIN_ACTIVE_DIRECTORY_LINK":true,"FETCH_EDIT_USER_LINK":false,"LISTS_FETCH_AVAILABLE_LISTS":true,"POST_WIZARD_SUBMIT_REDIRECT_URL":"/","PIN_REQUEST_ATTESTATIONS":true,"PIN_REQUEST_DESCRIPTION":"Click **Request PIN** to have a new PIN sent to the account holder's email address on file.","OWNERSHIP_REQUEST_DESCRIPTION":"To become an **authorized user** of this record, a current **AUTHORIZED USER** will need to grant you access. To request access, click **Request Access** below.","PIN_REQUEST_SUCCESS_MESSAGE":"The PIN you have requested for this entity has been sent to the email associated with your user account.  You should receive the PIN in approximately 3-5 minutes, depending on your email service provider.","APOSTILLE_HEADER_LABEL":"Verification Information","APOSTILLE_NUMBER_LABEL":"Apostille/Authentication","APOSTILLE_CITY_STATE_OVERRIDE":"HELENA, MT","APOSTILLE_FILING_DATE_LABEL":"Issue Date","APOSTILLE_CITY_STATE_IN_CERTIFIED":true,"NOTARY_EXISTING_FILING":true,"ALLOW_REVOKE_OWN_ACCESS_ONLY":false,"HIDE_CANCEL_ON_ONETIME_DATA_REQUESTS":true,"DATA_REQUESTS_IN_SHOPPING_CART":true,"WQ_ALLOW_EDIT_PENDING_PAYMENT":true,"WQ_CONFIRM_ON_DELETE":true,"WQ_DELETE_CONFIRM_MESSAGE":"Deleting this filing will forfeit any money already paid to the Secretary of State. This action is permanent and cannot be undone, are you sure you would like to delete?","PASS_ITEM_GUIDS_ON_CHECKOUT":true,"FORM_REVISION_HISTORY":true,"CHECKOUT_DISCLAIMER":"By entering your credit card and/or checking account information you (i) state that **you are an authorized user** of the credit card and/or electronic check and that the associated information entered (e.g., account holder name, account number, billing address) is accurate, (ii) **you authorize payment processor to charge the amount you have requested** to your credit card and/or funding account, and (iii) **acknowledge if a charge is declined or reversed you may also be assessed a customary charge** by the payment processor for such transactions.","FARM_BILL_SEARCH_CONFIDENTIAL":"As a registered Farm Bill Buyer with the Montana Secretary of State’s office it is important to maintain the confidentiality of the information contained within the Farm Bill Master List. The Farm Bill Master List reflects personal data, such as Social Security Numbers, which are a key piece of personal identifiable information to assist you in determining the existence of a lien against a specific debtor. The distribution of this information beyond its intended purpose is strictly prohibited.\n\n**The debtor's tax identification number has been hidden for confidentiality reasons. You may continue to search on a tax ID number and return debtors that match your search criteria. The SSN/FEIN must be entered without dashes or spaces.  If you need access to the tax identification number to clearly identify the debtor, please contact the UCC unit at (406) 444-3665.**","VIEW_HISTORY_BUTTON_ALT_TEXT":"View Filings","WIZARD_ERROR_TITLE_MESSAGE":"Form Error","FARM_BILL_SEARCH_INTERACTIVE":true,"USE_FARM_BILL_API":true,"DISALLOW_ASSIGN_SELF_AS_RA":true,"DISALLOW_ASSIGN_SELF_AS_PRINCIPAL":true,"USE_TRADEMARK_OWNER_VALIDATION":true,"USE_ALTERNATIVE_FOREIGN_ADDRESS_LABELS":true,"MY_RECEIPTS_FILTER":[{"type":"dateRange","name":"DATE_RANGE","label":"Date range","defaultValue":{"start":null,"end":null}},{"type":"text","name":"REF_NUM","defaultValue":"","label":"Reference Number"},{"type":"text","name":"RECEIPT_NUM","defaultValue":"","label":"Receipt Id"},{"type":"text","name":"AMOUNT","defaultValue":"","label":"Amount"},{"type":"select","name":"TYPE","defaultValue":"","label":"Payment Type","options":[{"value":"","label":"All"},{"value":"CC","label":"Credit Card"},{"value":"Check","label":"Check"}]}],"MY_RECEIPTS_SHOW_IN_SIDEBAR":true,"SHOW_MY_RECEIPTS_HELPER_TEXT":true,"MY_RECEIPTS_HELPER_LABEL":"About Receipt Search","MY_RECEIPTS_HELPER_TEXT":"You can search for receipts based on their descriptions, including the items paid for on the receipt. Use the filters to search for or filter specific information.","FARM_BILL_SUBLINK":{"label":"Farm Bill","component":"FarmBill","parameter":"farm-bill","path":"/lists/farm-bill","sourceTypeId":0,"myRecordsSearch":false,"allowedRules":["/search/"],"disabled":true,"searchDescription":"To perform a search, enter a debtor name. Your search results may include: exact debtor name, variations of that name and any filing that includes your search criteria. Punctuation is ignored.\n\nYou can click on \"Advanced\" to refine your search. Under “Advanced” you can search by crop, year, county and SSN/FEIN. As a registered Farm Bill Buyer with the Montana Secretary of State’s office it is important to maintain the confidentiality of the information contained within the Farm Bill Master List. The Farm Bill Master List reflects personal data, such as Social Security Numbers, which are a key piece of personal identifiable information to assist you in determining the existence of a lien against a specific debtor. The distribution of this information beyond its intended purpose is strictly prohibited.\n\nThe debtor's tax identification number has been hidden for confidentiality reasons. You may continue to search on a tax ID number and return debtors that match your search criteria. The SSN/FEIN must be entered without dashes or spaces.","searchMustHaveOneOf":["search","UCC_FARM_PRODUCT_ID","COUNTY"],"searchPlaceholder":"Search by debtor name","advancedSearchParameters":[{"type":"ServerMultiComplete","label":"Product code name(s)","name":"UCC_FARM_PRODUCT_ID","defaultValue":"","optionsSrc":"UCC_FARM_PRODUCT_V"},{"type":"MultiComplete","label":"Year or Range of Years","name":"YEAR_NUM","optionsSrc":"years","startYear":"1968","defaultValue":[],"preMergeOptions":[{"value":"ALL","label":"All"}]},{"type":"serverSelect","label":"State","name":"STATE","defaultValue":"MONTANA","optionsSrc":"STATE"},{"type":"ServerMultiComplete","label":"County","name":"COUNTY","defaultValue":[],"optionsSrc":"COUNTY","overrideSubOptionsSrcFromParameterName":"STATE"},{"type":"checkbox","name":"TIN_SEARCH_YN","defaultValue":false,"label":"Tax Identification Number Search"},{"type":"checkbox","name":"TIN_SORT_YN","defaultValue":false,"label":"Unique ID Sort"}]},"ALLOW_ADDRESS_VALIDATION_BYPASS_OPTION":true,"DEFAULT_ADDRESS_VALIDATION_BYPASS_OPTION_CHECKED":true}).LOGIN_CREATE_PERSONAL_LINK;
	var LOGIN_CREATE_BUSINESS_LINK = ({"NODE_ENV":"production","BUILD_DATE":"2025-08-27T15:15:31.687Z","BUILD_NUMBER":"Not Provided","GIT_VERSION":"v1.3.0-381-ga81e29b08","GIT_COMMIT_HASH":"a81e29b085c9268ffd96c78eb734365802722741","GIT_BRANCH":"beta","PUBLIC_URL":"","STATE_ABBR":"MT","STATE_NAME":"Montana","STATE_ORG_TITLE":"Secretary of State","LOGIN_HEADER_IMG_PATH":"","HOME_IMG_FILENAME":"montana.jpg","FAVICON_FILE_NAME":"favicon.ico","ALLOW_E_SIGN_ON_CORRECTIONS":true,"THIRD_PARTY_SIGNING_ALLOWED":false,"MY_ACCOUNT_SAVE_AND_CLOSE_BUTTON":true,"IE_DEPRECATED_MESSAGE":"Internet Explorer is not supported. Please select a supported browser below to access this website.","ADDITIONAL_ROUTES":{"dataRequests":true,"farmBill":true,"apostille":true,"externalHelp":"https://sosmt.gov/business/help-center/","systemAdministration":[{"title":"Saved Payments","parameter":"saved-payments","componentName":"SavedPayments"}]},"SUBROUTES":[{"label":"Business","component":"Business","parameter":"business","myWorkQueueSearch":false,"sourceTypeId":54,"searchMustHaveOneOf":["FILING_TYPE_ID","STATUS_ID","STATE","search"],"serverWebSearchDescription":true,"serverWorkQueueDescription":true,"serverMyRecordsDescription":true,"searchPlaceholder":"Search by name or filing number (X########)","allowEmptySearchTerm":true,"requestCertificateAlternateLabel":"Request Information","fileAmendmentButtonLabel":"Filing Actions","advancedSearchParameters":[{"type":"radio","name":"QUERY_TYPE_ID","defaultValue":1010,"options":[{"value":1010,"label":"Starts with"},{"value":1011,"label":"Contains"},{"value":1012,"label":" Word Contains"}]},{"type":"serverSelect","name":"FILING_TYPE_ID","optionsSrc":"FILING_TYPES","label":"Entity Type","placeholder":"All","defaultValue":"0"},{"type":"serverSelect","name":"FILING_SUBTYPE_ID","optionsSrc":"FILING_SUBTYPES","label":"Entity Subtype","overrideSubOptionsSrcFromParameterName":"FILING_TYPE_ID","placeholder":"All","defaultValue":"0"},{"type":"serverSelect","name":"STATUS_ID","optionsSrc":"FILING_STATUS_WITHOUT_ALL","label":"Status","placeholder":"All","defaultValue":"0"},{"type":"serverSelect","name":"STATE","optionsSrc":"STATE","label":"State","placeholder":"All","defaultValue":""},{"type":"serverSelect","name":"COUNTY","optionsSrc":"COUNTY_SUBOPTION","label":"County","overrideSubOptionsSrcFromParameterName":"STATE","placeholder":"All","defaultValue":""},{"type":"checkbox","name":"CRA_SEARCH_YN","defaultValue":false,"label":"Search by Registered Agent PID"},{"type":"dateRange","name":"FILING_DATE","label":"Registration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}},{"type":"dateRange","name":"EXPIRATION_DATE","label":"Expiration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}}],"myRecordsFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Active"},{"value":2,"label":"Inactive"},{"value":3,"label":"Pending"}]},{"type":"dateRange","name":"DATE_RANGE","label":"Date range","defaultValue":{"start":null,"end":null}}],"myWorkQueueFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Approved"},{"value":2,"label":"Pending Online Payment"},{"value":3,"label":"Pending Review"},{"value":4,"label":"Needs Correction"},{"value":5,"label":"Rejected"},{"value":6,"label":"Draft"}]},{"type":"dateRange","name":"DATE_RANGE","label":"Date range","defaultValue":{"start":null,"end":null}}]},{"label":"Notary","component":"Notary","parameter":"notary","sourceTypeId":850,"myWorkQueueSearch":false,"allowEmptySearchTerm":true,"requestCertificateAlternateLabel":"Download Certificate","fileAmendmentButtonLabel":"Filing Actions","hideNameRequestCertificate":true,"hideAddressRequestCertificate":true,"hideRecordUserManagment":true,"searchPlaceholder":"Search by name or commission number","searchMustHaveOneOf":["CITY","search","SERVICE_TYPE"],"advancedParametersStartOpen":true,"searchIsSortable":true,"advancedSearchParameters":[{"type":"radio","name":"STARTS_WITH_YN","defaultValue":false,"options":[{"value":true,"label":"Starts with"},{"value":false,"label":"Contains"}]},{"type":"checkbox","name":"ACTIVE_ONLY_YN","defaultValue":true,"label":"Active entities only"},{"type":"text","name":"CITY","defaultValue":"","label":"City"},{"type":"select","name":"SERVICE_TYPE","label":"Special Services Offered","defaultValue":0,"options":[{"value":0,"label":"(N/A)"},{"value":6165,"label":"In-Person Electronic Notarization (IPEN)"},{"value":6166,"label":"Remote Online Notarization (RON)"},{"value":6167,"label":"Mobile Notary Services"},{"value":6168,"label":"Remote Ink Notarization (RIN)"}]}]},{"label":"Apostille","component":"Apostille","parameter":"apostille","sourceTypeId":720,"myRecordsSearch":false,"myWorkQueueSearch":false,"disabled":false,"allowedRoutes":["/forms-manager/","/queue/","/forms/"]},{"label":"Liens","component":"UCC","parameter":"ucc","sourceTypeId":1999,"myRecordsSearch":true,"myWorkQueueSearch":true,"fileAmendmentButtonLabel":"Filing Actions","searchPlaceholder":"Search by name or file number","disabled":false,"serverWebSearchDescription":true,"myRecordsDescription":"","workQueueDescription":"","searchDescription":"","hideRecordUserManagment":true,"searchLiensCheckout":false,"advancedSearchParameters":[{"type":"radio","name":"STARTS_WITH_YN","defaultValue":false,"options":[{"value":true,"label":"Starts with"},{"value":false,"label":"Contains"}]},{"type":"select","name":"STATUS","defaultValue":"ALL","label":"Status","options":[{"value":"ACTIVE_UNLAPSED","label":"Active (unlapsed)"},{"value":"ACTIVE_LAPSED_UNLAPSED","label":"Active (lapsed and unlapsed)"}]},{"type":"text","name":"EXCLUDE_VALUES","label":"Exclude Debtor Names (comma separated list of names to exclude)","defaultValue":""},{"type":"dateRange","name":"FILING_DATE","label":"Financing Statement Date","defaultValue":{"start":null,"end":null}},{"type":"dateRange","name":"LAPSE_DATE","label":"Lapse Date","defaultValue":{"start":null,"end":null}},{"type":"text","name":"CITY","label":"Debtor City","defaultValue":""}],"myRecordsFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Approved"},{"value":2,"label":"Pending Online Payment"},{"value":3,"label":"Pending Review"}]},{"type":"select","name":"TYPE","defaultValue":0,"label":"Lien Type","options":[{"value":0,"label":"All"},{"value":1,"label":"UCC"},{"value":2,"label":"EFS"},{"value":3,"label":"Title 71"}]}],"myWorkQueueFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Approved"},{"value":2,"label":"Pending Online Payment"},{"value":3,"label":"Pending Review"},{"value":4,"label":"Pending Print and Mail"},{"value":5,"label":"Rejected"},{"value":6,"label":"Draft"}]},{"type":"select","name":"TYPE","defaultValue":0,"label":"Lien Type","options":[{"value":0,"label":"All"},{"value":1,"label":"UCC"},{"value":2,"label":"EFS"},{"value":3,"label":"Title 71"}]}]},{"label":"Copy Request","component":"copies","parameter":"copies","sourceTypeId":2001,"myRecordsSearch":false,"myWorkQueueSearch":false,"disabled":false,"allowedRoutes":["/forms-manager/","/queue/","/forms/"]},{"label":"Trademark","component":"Trademark","parameter":"trademark","sourceTypeId":810,"showRequestCertificate":true,"searchMustHaveOneOf":["search","EXPIRATION_DATE","FILING_DATE"],"allowEmptySearchTerm":true,"requestCertificateAlternateLabel":"Request Information","fileAmendmentButtonLabel":"Filing Actions","advancedSearchParameters":[{"type":"radio","name":"QUERY_TYPE_ID","defaultValue":1010,"options":[{"value":1010,"label":"Starts with"},{"value":1011,"label":"Contains"},{"value":1012,"label":" Word Contains"}]},{"type":"checkbox","name":"OWNER_SEARCH_YN","defaultValue":false,"label":"Search owners"},{"type":"radio","name":"SERVICE_MARK_YN","label":"Mark Type","defaultValue":"","options":[{"value":"","label":"All Marks"},{"value":"Y","label":"Service Mark"},{"value":"N","label":"Trademark"}]},{"type":"serverSelect","name":"STATUS_ID","optionsSrc":"TYPE_V|TRADEMARK_STATUS_TYPE","label":"Status","placeholder":"All","defaultValue":"0"},{"type":"select","name":"DESIGN_TYPE_ID","options":[{"value":0,"label":"All"},{"value":990,"label":"Words Only"},{"value":991,"label":"Design Only"},{"value":992,"label":"Words and Design"}],"label":"Design Type","defaultValue":"0"},{"type":"dateRange","name":"FILING_DATE","label":"Registered Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}},{"type":"dateRange","name":"EXPIRATION_DATE","label":"Expiration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}}]},{"label":"Business Info Request","component":"InfoRequests","parameter":"info-request","sourceTypeId":167,"allowedRoutes":["/forms-manager/","/queue/","/forms/"]},{"label":"Data Requests","component":"DataRequests","parameter":"data-request","sourceTypeId":0,"allowedRoutes":["/forms-manager/"]},{"label":"CRA","component":"CRA","parameter":"cra","sourceTypeId":157,"myRecordsSearch":false,"searchPlaceholder":"Search by name or registered agent number","allowedRoutes":["/forms-manager/","/forms/","/records/","/queue/","/search/"],"allowEmptySearchTerm":true,"fileAmendmentButtonLabel":"Filing Actions","advancedSearchParameters":[{"type":"radio","name":"QUERY_TYPE_ID","defaultValue":1010,"options":[{"value":1010,"label":"Starts with"},{"value":1011,"label":"Contains"},{"value":1012,"label":" Word Contains"}]},{"type":"dateRange","name":"CRA_DATE","label":"Registration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}},{"type":"select","name":"STATUS_ID","label":"Status","defaultValue":0,"options":[{"value":0,"label":"All"},{"value":121,"label":"Active"},{"value":122,"label":"Inactive"}]},{"type":"select","name":"AGENT_TYPE_ID","label":"Agent Type","defaultValue":0,"options":[{"value":0,"label":"All"},{"value":460,"label":"Registered Agent"},{"value":461,"label":"Commercial Registered Agent"}]}]},{"label":"Farm Bill","component":"FarmBill","parameter":"farm-bill","path":"/lists/farm-bill","sourceTypeId":0,"myRecordsSearch":false,"allowedRules":["/search/"],"disabled":true,"searchDescription":"To perform a search, enter a debtor name. Your search results may include: exact debtor name, variations of that name and any filing that includes your search criteria. Punctuation is ignored.\n\nYou can click on \"Advanced\" to refine your search. Under “Advanced” you can search by crop, year, county and SSN/FEIN. As a registered Farm Bill Buyer with the Montana Secretary of State’s office it is important to maintain the confidentiality of the information contained within the Farm Bill Master List. The Farm Bill Master List reflects personal data, such as Social Security Numbers, which are a key piece of personal identifiable information to assist you in determining the existence of a lien against a specific debtor. The distribution of this information beyond its intended purpose is strictly prohibited.\n\nThe debtor's tax identification number has been hidden for confidentiality reasons. You may continue to search on a tax ID number and return debtors that match your search criteria. The SSN/FEIN must be entered without dashes or spaces.","searchMustHaveOneOf":["search","UCC_FARM_PRODUCT_ID","COUNTY"],"searchPlaceholder":"Search by debtor name","advancedSearchParameters":[{"type":"ServerMultiComplete","label":"Product code name(s)","name":"UCC_FARM_PRODUCT_ID","defaultValue":"","optionsSrc":"UCC_FARM_PRODUCT_V"},{"type":"MultiComplete","label":"Year or Range of Years","name":"YEAR_NUM","optionsSrc":"years","startYear":"1968","defaultValue":[],"preMergeOptions":[{"value":"ALL","label":"All"}]},{"type":"serverSelect","label":"State","name":"STATE","defaultValue":"MONTANA","optionsSrc":"STATE"},{"type":"ServerMultiComplete","label":"County","name":"COUNTY","defaultValue":[],"optionsSrc":"COUNTY","overrideSubOptionsSrcFromParameterName":"STATE"},{"type":"checkbox","name":"TIN_SEARCH_YN","defaultValue":false,"label":"Tax Identification Number Search"},{"type":"checkbox","name":"TIN_SORT_YN","defaultValue":false,"label":"Unique ID Sort"}]}],"SYSTEM_NICKNAME":"Online Services Portal","PAYMENT_METHODS":[{"type":"bypass"},{"type":"iTransact"}],"PAYMENT_ALLOW_AMEX":true,"SYSTEM_ID_LABEL":"System Id","DOUBLE_COLUMN_PUBLIC_LOGIN":true,"INTERNAL_USER_MANAGEMENT":true,"ALLOW_PUBLIC_JSON_IMPORT":false,"MAX_FILE_UPLOAD_SIZE":10000000,"REFUND_TEXT":"","RETURN_TO_HOME_ON_LOGOUT":true,"CURRENT_SOS_NAME":"Christi Jacobsen","LOGO_FILENAME":"mt-sos-logo.png","LOGO_ALT":"Christi Jacobsen, Montana Secretary of State","LOGO_FULL_WIDTH":true,"HOME_HIDE_AUTH_HINT":true,"HOME_TITLE":"Montana Secretary of State","CUSTOM_TAB_TITLE":"Official Montana","HOME_SUBTITLE":"Online Business Services","ENTITY_NAME_CONSENT_DESCRIPTION":"","ALLOW_USER_PROFILE_EDITING":true,"COMPARE_FOREIGN_NAME_IN_ENTITY_NAME_VALIDATION":true,"FOREIGN_NAME_FIELD_NAME":"KIMA_PARENT_NAME_INFO","LOGIN_TITLE":"Montana Secretary of State Online Filing Portal Login","PUBLIC_LOGIN_LABEL":"Username","REVERSE_LOGIN_COLUMNS":true,"LOGIN_SEAL_FILENAME":"seal_white.png","SEPARATE_USERNAME_AND_EMAIL":true,"CREATE_ACCOUNT_BUTTON_ALIGN_LEFT":true,"CREATE_ACCOUNT_BUTTON_TEXT":"CREATE AN ACCOUNT","PASSWORD_CUSTOM_ERROR_TEXT":"The password must meet all requirements","ACCOUNT_CREATED_MESSAGE":"Please check your email to verify your account to login and allow a few minutes for this message to arrive. Check your junk/spam folders if you do not find the email in your inbox.","PUBLIC_LOGIN_PLACEHOLDER":" ","DISABLE_DEFAULT_PAYMENT_RADIO":true,"CUSTOM_RESET_PASSWORD_ERROR_MESSAGE":"Username invalid - no account found","PUBLIC_LOGIN_CREATE_DESCRIPTION":"### Existing User:\n\n  - Enter your username and password to login.  \n\n\n  #### - OR -  \n\n\n\n  - Forgot password? Click 'Reset Password' and follow the prompts.\n  - Forgot username? Click 'Forgot Username' and follow the prompts.  \n\n\n  ### New User:\n  ","LOGIN_HELP_LINK":"https://sosmt.gov/business/how-do-i/","LOGIN_HELP_LINK_TEXT":"Need Help?","FORGOT_USERNAME_TEXT":"Forgot Username?","LOGIN_ACTIVE_DIRECTORY_TEXT":"State User Login","MULTIPLE_LOGIN_METHODS":true,"HAS_ACTIVE_DIRECTORY_LOGIN":true,"RESET_PASSWORD_WITH_USERNAME":true,"DOWNLOAD_LINK":true,"SHOW_USERNAME_ACCOUNT_CREATE":true,"SHOW_SCROLL_DOWN_ARROW":true,"SHOW_ADDRESS_ACCOUNT_CREATE":true,"TWO_COLUMN_ACCOUNT_CREATE":true,"RESET_PASSWORD_TIP":"A link to change your password has been sent to your email. Please allow a few minutes for this message to arrive. Please check your junk/spam folders if you do not find the email in your inbox.","FORGOT_PASSWORD_LINK_TEXT":"Reset Password","PHONE_NUMBER_OPTIONAL_ACCOUNT_CREATE":true,"SHOW_REQUIRED_INDICATOR_ACCOUNT_CREATE":true,"PASSWORD_REQUIREMENTS_ACCOUNT_CREATE":"\n    <ul>\n      <li>MUST contain at least 8 characters (12+ recommended)</li>\n      <li>MUST contain at least one uppercase letter.</li>\n      <li>MUST contain at least one lowercase letter.</li>\n      <li>MUST contain at least one number.</li>\n      <li>MUST contain at least one special character (!”#$%&'()*+,-./:;<=>?</li>\n    </ul>\n  ","ALLOW_CERTIFICATION_REQUEST":true,"ALLOW_PUBLIC_CERTIFICATE_REQUEST":true,"ALLOW_COPY_REQUEST":false,"ALLOW_CORRECTION_STYLING":true,"HIDE_DEPRECATION_WARNING":false,"AMEND_ROUTE_PUBLIC":true,"SEAL_FILENAME":"seal.png","SHOPPING_CART":true,"ALLOW_PAYMENT_UPDATE_WITH_EMPTY_CART":true,"RA_EMAIL":true,"RA_WEBSITE":true,"RA_NO_DEFAULT_TYPE":true,"RA_ADDRESS_LABEL":"Street Address","RA_TYPE_SELECTION_DEFAULT":true,"RA_DEFAULT_TYPE":"460","RA_OVERRIDE_TYPE_WITH_DEFAULT":true,"RA_PRINCIPAL_ADDRESS_AMS":true,"UPLOAD_AND_SUBMIT_HIDE_IF_ONE_OPTION":true,"PAYMENT_PROCESSING_MESSAGE":"Your payment is processing - Do not close your browser or click the back button","CHECKOUT_BUTTON_WHEN_PROCESSING_TEXT":"Processing","EFS_CROP_PICKER_NONE_LABEL":"Lien Duration","DISALLOWED_WIZARD_PIECES":["FormationLocale"],"REPEATER_SHOW_EDIT_BUTTON":true,"DATA_REQUEST_PAGE_TITLE":"Data Requests and Subscriptions","DATA_REQUEST_SIDEBAR_LABEL":"Data Requests & Subscriptions","LOGIN_REDIRECTS_TO_EPASS":false,"LOGIN_REDIRECTS_TO_ACTIVE_DIRECTORY":true,"LOGIN_ACTIVE_DIRECTORY_LINK":true,"FETCH_EDIT_USER_LINK":false,"LISTS_FETCH_AVAILABLE_LISTS":true,"POST_WIZARD_SUBMIT_REDIRECT_URL":"/","PIN_REQUEST_ATTESTATIONS":true,"PIN_REQUEST_DESCRIPTION":"Click **Request PIN** to have a new PIN sent to the account holder's email address on file.","OWNERSHIP_REQUEST_DESCRIPTION":"To become an **authorized user** of this record, a current **AUTHORIZED USER** will need to grant you access. To request access, click **Request Access** below.","PIN_REQUEST_SUCCESS_MESSAGE":"The PIN you have requested for this entity has been sent to the email associated with your user account.  You should receive the PIN in approximately 3-5 minutes, depending on your email service provider.","APOSTILLE_HEADER_LABEL":"Verification Information","APOSTILLE_NUMBER_LABEL":"Apostille/Authentication","APOSTILLE_CITY_STATE_OVERRIDE":"HELENA, MT","APOSTILLE_FILING_DATE_LABEL":"Issue Date","APOSTILLE_CITY_STATE_IN_CERTIFIED":true,"NOTARY_EXISTING_FILING":true,"ALLOW_REVOKE_OWN_ACCESS_ONLY":false,"HIDE_CANCEL_ON_ONETIME_DATA_REQUESTS":true,"DATA_REQUESTS_IN_SHOPPING_CART":true,"WQ_ALLOW_EDIT_PENDING_PAYMENT":true,"WQ_CONFIRM_ON_DELETE":true,"WQ_DELETE_CONFIRM_MESSAGE":"Deleting this filing will forfeit any money already paid to the Secretary of State. This action is permanent and cannot be undone, are you sure you would like to delete?","PASS_ITEM_GUIDS_ON_CHECKOUT":true,"FORM_REVISION_HISTORY":true,"CHECKOUT_DISCLAIMER":"By entering your credit card and/or checking account information you (i) state that **you are an authorized user** of the credit card and/or electronic check and that the associated information entered (e.g., account holder name, account number, billing address) is accurate, (ii) **you authorize payment processor to charge the amount you have requested** to your credit card and/or funding account, and (iii) **acknowledge if a charge is declined or reversed you may also be assessed a customary charge** by the payment processor for such transactions.","FARM_BILL_SEARCH_CONFIDENTIAL":"As a registered Farm Bill Buyer with the Montana Secretary of State’s office it is important to maintain the confidentiality of the information contained within the Farm Bill Master List. The Farm Bill Master List reflects personal data, such as Social Security Numbers, which are a key piece of personal identifiable information to assist you in determining the existence of a lien against a specific debtor. The distribution of this information beyond its intended purpose is strictly prohibited.\n\n**The debtor's tax identification number has been hidden for confidentiality reasons. You may continue to search on a tax ID number and return debtors that match your search criteria. The SSN/FEIN must be entered without dashes or spaces.  If you need access to the tax identification number to clearly identify the debtor, please contact the UCC unit at (406) 444-3665.**","VIEW_HISTORY_BUTTON_ALT_TEXT":"View Filings","WIZARD_ERROR_TITLE_MESSAGE":"Form Error","FARM_BILL_SEARCH_INTERACTIVE":true,"USE_FARM_BILL_API":true,"DISALLOW_ASSIGN_SELF_AS_RA":true,"DISALLOW_ASSIGN_SELF_AS_PRINCIPAL":true,"USE_TRADEMARK_OWNER_VALIDATION":true,"USE_ALTERNATIVE_FOREIGN_ADDRESS_LABELS":true,"MY_RECEIPTS_FILTER":[{"type":"dateRange","name":"DATE_RANGE","label":"Date range","defaultValue":{"start":null,"end":null}},{"type":"text","name":"REF_NUM","defaultValue":"","label":"Reference Number"},{"type":"text","name":"RECEIPT_NUM","defaultValue":"","label":"Receipt Id"},{"type":"text","name":"AMOUNT","defaultValue":"","label":"Amount"},{"type":"select","name":"TYPE","defaultValue":"","label":"Payment Type","options":[{"value":"","label":"All"},{"value":"CC","label":"Credit Card"},{"value":"Check","label":"Check"}]}],"MY_RECEIPTS_SHOW_IN_SIDEBAR":true,"SHOW_MY_RECEIPTS_HELPER_TEXT":true,"MY_RECEIPTS_HELPER_LABEL":"About Receipt Search","MY_RECEIPTS_HELPER_TEXT":"You can search for receipts based on their descriptions, including the items paid for on the receipt. Use the filters to search for or filter specific information.","FARM_BILL_SUBLINK":{"label":"Farm Bill","component":"FarmBill","parameter":"farm-bill","path":"/lists/farm-bill","sourceTypeId":0,"myRecordsSearch":false,"allowedRules":["/search/"],"disabled":true,"searchDescription":"To perform a search, enter a debtor name. Your search results may include: exact debtor name, variations of that name and any filing that includes your search criteria. Punctuation is ignored.\n\nYou can click on \"Advanced\" to refine your search. Under “Advanced” you can search by crop, year, county and SSN/FEIN. As a registered Farm Bill Buyer with the Montana Secretary of State’s office it is important to maintain the confidentiality of the information contained within the Farm Bill Master List. The Farm Bill Master List reflects personal data, such as Social Security Numbers, which are a key piece of personal identifiable information to assist you in determining the existence of a lien against a specific debtor. The distribution of this information beyond its intended purpose is strictly prohibited.\n\nThe debtor's tax identification number has been hidden for confidentiality reasons. You may continue to search on a tax ID number and return debtors that match your search criteria. The SSN/FEIN must be entered without dashes or spaces.","searchMustHaveOneOf":["search","UCC_FARM_PRODUCT_ID","COUNTY"],"searchPlaceholder":"Search by debtor name","advancedSearchParameters":[{"type":"ServerMultiComplete","label":"Product code name(s)","name":"UCC_FARM_PRODUCT_ID","defaultValue":"","optionsSrc":"UCC_FARM_PRODUCT_V"},{"type":"MultiComplete","label":"Year or Range of Years","name":"YEAR_NUM","optionsSrc":"years","startYear":"1968","defaultValue":[],"preMergeOptions":[{"value":"ALL","label":"All"}]},{"type":"serverSelect","label":"State","name":"STATE","defaultValue":"MONTANA","optionsSrc":"STATE"},{"type":"ServerMultiComplete","label":"County","name":"COUNTY","defaultValue":[],"optionsSrc":"COUNTY","overrideSubOptionsSrcFromParameterName":"STATE"},{"type":"checkbox","name":"TIN_SEARCH_YN","defaultValue":false,"label":"Tax Identification Number Search"},{"type":"checkbox","name":"TIN_SORT_YN","defaultValue":false,"label":"Unique ID Sort"}]},"ALLOW_ADDRESS_VALIDATION_BYPASS_OPTION":true,"DEFAULT_ADDRESS_VALIDATION_BYPASS_OPTION_CHECKED":true}).LOGIN_CREATE_BUSINESS_LINK;
	var LOGIN_FORGOT_PASSWORD_LINK = ({"NODE_ENV":"production","BUILD_DATE":"2025-08-27T15:15:31.687Z","BUILD_NUMBER":"Not Provided","GIT_VERSION":"v1.3.0-381-ga81e29b08","GIT_COMMIT_HASH":"a81e29b085c9268ffd96c78eb734365802722741","GIT_BRANCH":"beta","PUBLIC_URL":"","STATE_ABBR":"MT","STATE_NAME":"Montana","STATE_ORG_TITLE":"Secretary of State","LOGIN_HEADER_IMG_PATH":"","HOME_IMG_FILENAME":"montana.jpg","FAVICON_FILE_NAME":"favicon.ico","ALLOW_E_SIGN_ON_CORRECTIONS":true,"THIRD_PARTY_SIGNING_ALLOWED":false,"MY_ACCOUNT_SAVE_AND_CLOSE_BUTTON":true,"IE_DEPRECATED_MESSAGE":"Internet Explorer is not supported. Please select a supported browser below to access this website.","ADDITIONAL_ROUTES":{"dataRequests":true,"farmBill":true,"apostille":true,"externalHelp":"https://sosmt.gov/business/help-center/","systemAdministration":[{"title":"Saved Payments","parameter":"saved-payments","componentName":"SavedPayments"}]},"SUBROUTES":[{"label":"Business","component":"Business","parameter":"business","myWorkQueueSearch":false,"sourceTypeId":54,"searchMustHaveOneOf":["FILING_TYPE_ID","STATUS_ID","STATE","search"],"serverWebSearchDescription":true,"serverWorkQueueDescription":true,"serverMyRecordsDescription":true,"searchPlaceholder":"Search by name or filing number (X########)","allowEmptySearchTerm":true,"requestCertificateAlternateLabel":"Request Information","fileAmendmentButtonLabel":"Filing Actions","advancedSearchParameters":[{"type":"radio","name":"QUERY_TYPE_ID","defaultValue":1010,"options":[{"value":1010,"label":"Starts with"},{"value":1011,"label":"Contains"},{"value":1012,"label":" Word Contains"}]},{"type":"serverSelect","name":"FILING_TYPE_ID","optionsSrc":"FILING_TYPES","label":"Entity Type","placeholder":"All","defaultValue":"0"},{"type":"serverSelect","name":"FILING_SUBTYPE_ID","optionsSrc":"FILING_SUBTYPES","label":"Entity Subtype","overrideSubOptionsSrcFromParameterName":"FILING_TYPE_ID","placeholder":"All","defaultValue":"0"},{"type":"serverSelect","name":"STATUS_ID","optionsSrc":"FILING_STATUS_WITHOUT_ALL","label":"Status","placeholder":"All","defaultValue":"0"},{"type":"serverSelect","name":"STATE","optionsSrc":"STATE","label":"State","placeholder":"All","defaultValue":""},{"type":"serverSelect","name":"COUNTY","optionsSrc":"COUNTY_SUBOPTION","label":"County","overrideSubOptionsSrcFromParameterName":"STATE","placeholder":"All","defaultValue":""},{"type":"checkbox","name":"CRA_SEARCH_YN","defaultValue":false,"label":"Search by Registered Agent PID"},{"type":"dateRange","name":"FILING_DATE","label":"Registration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}},{"type":"dateRange","name":"EXPIRATION_DATE","label":"Expiration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}}],"myRecordsFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Active"},{"value":2,"label":"Inactive"},{"value":3,"label":"Pending"}]},{"type":"dateRange","name":"DATE_RANGE","label":"Date range","defaultValue":{"start":null,"end":null}}],"myWorkQueueFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Approved"},{"value":2,"label":"Pending Online Payment"},{"value":3,"label":"Pending Review"},{"value":4,"label":"Needs Correction"},{"value":5,"label":"Rejected"},{"value":6,"label":"Draft"}]},{"type":"dateRange","name":"DATE_RANGE","label":"Date range","defaultValue":{"start":null,"end":null}}]},{"label":"Notary","component":"Notary","parameter":"notary","sourceTypeId":850,"myWorkQueueSearch":false,"allowEmptySearchTerm":true,"requestCertificateAlternateLabel":"Download Certificate","fileAmendmentButtonLabel":"Filing Actions","hideNameRequestCertificate":true,"hideAddressRequestCertificate":true,"hideRecordUserManagment":true,"searchPlaceholder":"Search by name or commission number","searchMustHaveOneOf":["CITY","search","SERVICE_TYPE"],"advancedParametersStartOpen":true,"searchIsSortable":true,"advancedSearchParameters":[{"type":"radio","name":"STARTS_WITH_YN","defaultValue":false,"options":[{"value":true,"label":"Starts with"},{"value":false,"label":"Contains"}]},{"type":"checkbox","name":"ACTIVE_ONLY_YN","defaultValue":true,"label":"Active entities only"},{"type":"text","name":"CITY","defaultValue":"","label":"City"},{"type":"select","name":"SERVICE_TYPE","label":"Special Services Offered","defaultValue":0,"options":[{"value":0,"label":"(N/A)"},{"value":6165,"label":"In-Person Electronic Notarization (IPEN)"},{"value":6166,"label":"Remote Online Notarization (RON)"},{"value":6167,"label":"Mobile Notary Services"},{"value":6168,"label":"Remote Ink Notarization (RIN)"}]}]},{"label":"Apostille","component":"Apostille","parameter":"apostille","sourceTypeId":720,"myRecordsSearch":false,"myWorkQueueSearch":false,"disabled":false,"allowedRoutes":["/forms-manager/","/queue/","/forms/"]},{"label":"Liens","component":"UCC","parameter":"ucc","sourceTypeId":1999,"myRecordsSearch":true,"myWorkQueueSearch":true,"fileAmendmentButtonLabel":"Filing Actions","searchPlaceholder":"Search by name or file number","disabled":false,"serverWebSearchDescription":true,"myRecordsDescription":"","workQueueDescription":"","searchDescription":"","hideRecordUserManagment":true,"searchLiensCheckout":false,"advancedSearchParameters":[{"type":"radio","name":"STARTS_WITH_YN","defaultValue":false,"options":[{"value":true,"label":"Starts with"},{"value":false,"label":"Contains"}]},{"type":"select","name":"STATUS","defaultValue":"ALL","label":"Status","options":[{"value":"ACTIVE_UNLAPSED","label":"Active (unlapsed)"},{"value":"ACTIVE_LAPSED_UNLAPSED","label":"Active (lapsed and unlapsed)"}]},{"type":"text","name":"EXCLUDE_VALUES","label":"Exclude Debtor Names (comma separated list of names to exclude)","defaultValue":""},{"type":"dateRange","name":"FILING_DATE","label":"Financing Statement Date","defaultValue":{"start":null,"end":null}},{"type":"dateRange","name":"LAPSE_DATE","label":"Lapse Date","defaultValue":{"start":null,"end":null}},{"type":"text","name":"CITY","label":"Debtor City","defaultValue":""}],"myRecordsFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Approved"},{"value":2,"label":"Pending Online Payment"},{"value":3,"label":"Pending Review"}]},{"type":"select","name":"TYPE","defaultValue":0,"label":"Lien Type","options":[{"value":0,"label":"All"},{"value":1,"label":"UCC"},{"value":2,"label":"EFS"},{"value":3,"label":"Title 71"}]}],"myWorkQueueFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Approved"},{"value":2,"label":"Pending Online Payment"},{"value":3,"label":"Pending Review"},{"value":4,"label":"Pending Print and Mail"},{"value":5,"label":"Rejected"},{"value":6,"label":"Draft"}]},{"type":"select","name":"TYPE","defaultValue":0,"label":"Lien Type","options":[{"value":0,"label":"All"},{"value":1,"label":"UCC"},{"value":2,"label":"EFS"},{"value":3,"label":"Title 71"}]}]},{"label":"Copy Request","component":"copies","parameter":"copies","sourceTypeId":2001,"myRecordsSearch":false,"myWorkQueueSearch":false,"disabled":false,"allowedRoutes":["/forms-manager/","/queue/","/forms/"]},{"label":"Trademark","component":"Trademark","parameter":"trademark","sourceTypeId":810,"showRequestCertificate":true,"searchMustHaveOneOf":["search","EXPIRATION_DATE","FILING_DATE"],"allowEmptySearchTerm":true,"requestCertificateAlternateLabel":"Request Information","fileAmendmentButtonLabel":"Filing Actions","advancedSearchParameters":[{"type":"radio","name":"QUERY_TYPE_ID","defaultValue":1010,"options":[{"value":1010,"label":"Starts with"},{"value":1011,"label":"Contains"},{"value":1012,"label":" Word Contains"}]},{"type":"checkbox","name":"OWNER_SEARCH_YN","defaultValue":false,"label":"Search owners"},{"type":"radio","name":"SERVICE_MARK_YN","label":"Mark Type","defaultValue":"","options":[{"value":"","label":"All Marks"},{"value":"Y","label":"Service Mark"},{"value":"N","label":"Trademark"}]},{"type":"serverSelect","name":"STATUS_ID","optionsSrc":"TYPE_V|TRADEMARK_STATUS_TYPE","label":"Status","placeholder":"All","defaultValue":"0"},{"type":"select","name":"DESIGN_TYPE_ID","options":[{"value":0,"label":"All"},{"value":990,"label":"Words Only"},{"value":991,"label":"Design Only"},{"value":992,"label":"Words and Design"}],"label":"Design Type","defaultValue":"0"},{"type":"dateRange","name":"FILING_DATE","label":"Registered Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}},{"type":"dateRange","name":"EXPIRATION_DATE","label":"Expiration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}}]},{"label":"Business Info Request","component":"InfoRequests","parameter":"info-request","sourceTypeId":167,"allowedRoutes":["/forms-manager/","/queue/","/forms/"]},{"label":"Data Requests","component":"DataRequests","parameter":"data-request","sourceTypeId":0,"allowedRoutes":["/forms-manager/"]},{"label":"CRA","component":"CRA","parameter":"cra","sourceTypeId":157,"myRecordsSearch":false,"searchPlaceholder":"Search by name or registered agent number","allowedRoutes":["/forms-manager/","/forms/","/records/","/queue/","/search/"],"allowEmptySearchTerm":true,"fileAmendmentButtonLabel":"Filing Actions","advancedSearchParameters":[{"type":"radio","name":"QUERY_TYPE_ID","defaultValue":1010,"options":[{"value":1010,"label":"Starts with"},{"value":1011,"label":"Contains"},{"value":1012,"label":" Word Contains"}]},{"type":"dateRange","name":"CRA_DATE","label":"Registration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}},{"type":"select","name":"STATUS_ID","label":"Status","defaultValue":0,"options":[{"value":0,"label":"All"},{"value":121,"label":"Active"},{"value":122,"label":"Inactive"}]},{"type":"select","name":"AGENT_TYPE_ID","label":"Agent Type","defaultValue":0,"options":[{"value":0,"label":"All"},{"value":460,"label":"Registered Agent"},{"value":461,"label":"Commercial Registered Agent"}]}]},{"label":"Farm Bill","component":"FarmBill","parameter":"farm-bill","path":"/lists/farm-bill","sourceTypeId":0,"myRecordsSearch":false,"allowedRules":["/search/"],"disabled":true,"searchDescription":"To perform a search, enter a debtor name. Your search results may include: exact debtor name, variations of that name and any filing that includes your search criteria. Punctuation is ignored.\n\nYou can click on \"Advanced\" to refine your search. Under “Advanced” you can search by crop, year, county and SSN/FEIN. As a registered Farm Bill Buyer with the Montana Secretary of State’s office it is important to maintain the confidentiality of the information contained within the Farm Bill Master List. The Farm Bill Master List reflects personal data, such as Social Security Numbers, which are a key piece of personal identifiable information to assist you in determining the existence of a lien against a specific debtor. The distribution of this information beyond its intended purpose is strictly prohibited.\n\nThe debtor's tax identification number has been hidden for confidentiality reasons. You may continue to search on a tax ID number and return debtors that match your search criteria. The SSN/FEIN must be entered without dashes or spaces.","searchMustHaveOneOf":["search","UCC_FARM_PRODUCT_ID","COUNTY"],"searchPlaceholder":"Search by debtor name","advancedSearchParameters":[{"type":"ServerMultiComplete","label":"Product code name(s)","name":"UCC_FARM_PRODUCT_ID","defaultValue":"","optionsSrc":"UCC_FARM_PRODUCT_V"},{"type":"MultiComplete","label":"Year or Range of Years","name":"YEAR_NUM","optionsSrc":"years","startYear":"1968","defaultValue":[],"preMergeOptions":[{"value":"ALL","label":"All"}]},{"type":"serverSelect","label":"State","name":"STATE","defaultValue":"MONTANA","optionsSrc":"STATE"},{"type":"ServerMultiComplete","label":"County","name":"COUNTY","defaultValue":[],"optionsSrc":"COUNTY","overrideSubOptionsSrcFromParameterName":"STATE"},{"type":"checkbox","name":"TIN_SEARCH_YN","defaultValue":false,"label":"Tax Identification Number Search"},{"type":"checkbox","name":"TIN_SORT_YN","defaultValue":false,"label":"Unique ID Sort"}]}],"SYSTEM_NICKNAME":"Online Services Portal","PAYMENT_METHODS":[{"type":"bypass"},{"type":"iTransact"}],"PAYMENT_ALLOW_AMEX":true,"SYSTEM_ID_LABEL":"System Id","DOUBLE_COLUMN_PUBLIC_LOGIN":true,"INTERNAL_USER_MANAGEMENT":true,"ALLOW_PUBLIC_JSON_IMPORT":false,"MAX_FILE_UPLOAD_SIZE":10000000,"REFUND_TEXT":"","RETURN_TO_HOME_ON_LOGOUT":true,"CURRENT_SOS_NAME":"Christi Jacobsen","LOGO_FILENAME":"mt-sos-logo.png","LOGO_ALT":"Christi Jacobsen, Montana Secretary of State","LOGO_FULL_WIDTH":true,"HOME_HIDE_AUTH_HINT":true,"HOME_TITLE":"Montana Secretary of State","CUSTOM_TAB_TITLE":"Official Montana","HOME_SUBTITLE":"Online Business Services","ENTITY_NAME_CONSENT_DESCRIPTION":"","ALLOW_USER_PROFILE_EDITING":true,"COMPARE_FOREIGN_NAME_IN_ENTITY_NAME_VALIDATION":true,"FOREIGN_NAME_FIELD_NAME":"KIMA_PARENT_NAME_INFO","LOGIN_TITLE":"Montana Secretary of State Online Filing Portal Login","PUBLIC_LOGIN_LABEL":"Username","REVERSE_LOGIN_COLUMNS":true,"LOGIN_SEAL_FILENAME":"seal_white.png","SEPARATE_USERNAME_AND_EMAIL":true,"CREATE_ACCOUNT_BUTTON_ALIGN_LEFT":true,"CREATE_ACCOUNT_BUTTON_TEXT":"CREATE AN ACCOUNT","PASSWORD_CUSTOM_ERROR_TEXT":"The password must meet all requirements","ACCOUNT_CREATED_MESSAGE":"Please check your email to verify your account to login and allow a few minutes for this message to arrive. Check your junk/spam folders if you do not find the email in your inbox.","PUBLIC_LOGIN_PLACEHOLDER":" ","DISABLE_DEFAULT_PAYMENT_RADIO":true,"CUSTOM_RESET_PASSWORD_ERROR_MESSAGE":"Username invalid - no account found","PUBLIC_LOGIN_CREATE_DESCRIPTION":"### Existing User:\n\n  - Enter your username and password to login.  \n\n\n  #### - OR -  \n\n\n\n  - Forgot password? Click 'Reset Password' and follow the prompts.\n  - Forgot username? Click 'Forgot Username' and follow the prompts.  \n\n\n  ### New User:\n  ","LOGIN_HELP_LINK":"https://sosmt.gov/business/how-do-i/","LOGIN_HELP_LINK_TEXT":"Need Help?","FORGOT_USERNAME_TEXT":"Forgot Username?","LOGIN_ACTIVE_DIRECTORY_TEXT":"State User Login","MULTIPLE_LOGIN_METHODS":true,"HAS_ACTIVE_DIRECTORY_LOGIN":true,"RESET_PASSWORD_WITH_USERNAME":true,"DOWNLOAD_LINK":true,"SHOW_USERNAME_ACCOUNT_CREATE":true,"SHOW_SCROLL_DOWN_ARROW":true,"SHOW_ADDRESS_ACCOUNT_CREATE":true,"TWO_COLUMN_ACCOUNT_CREATE":true,"RESET_PASSWORD_TIP":"A link to change your password has been sent to your email. Please allow a few minutes for this message to arrive. Please check your junk/spam folders if you do not find the email in your inbox.","FORGOT_PASSWORD_LINK_TEXT":"Reset Password","PHONE_NUMBER_OPTIONAL_ACCOUNT_CREATE":true,"SHOW_REQUIRED_INDICATOR_ACCOUNT_CREATE":true,"PASSWORD_REQUIREMENTS_ACCOUNT_CREATE":"\n    <ul>\n      <li>MUST contain at least 8 characters (12+ recommended)</li>\n      <li>MUST contain at least one uppercase letter.</li>\n      <li>MUST contain at least one lowercase letter.</li>\n      <li>MUST contain at least one number.</li>\n      <li>MUST contain at least one special character (!”#$%&'()*+,-./:;<=>?</li>\n    </ul>\n  ","ALLOW_CERTIFICATION_REQUEST":true,"ALLOW_PUBLIC_CERTIFICATE_REQUEST":true,"ALLOW_COPY_REQUEST":false,"ALLOW_CORRECTION_STYLING":true,"HIDE_DEPRECATION_WARNING":false,"AMEND_ROUTE_PUBLIC":true,"SEAL_FILENAME":"seal.png","SHOPPING_CART":true,"ALLOW_PAYMENT_UPDATE_WITH_EMPTY_CART":true,"RA_EMAIL":true,"RA_WEBSITE":true,"RA_NO_DEFAULT_TYPE":true,"RA_ADDRESS_LABEL":"Street Address","RA_TYPE_SELECTION_DEFAULT":true,"RA_DEFAULT_TYPE":"460","RA_OVERRIDE_TYPE_WITH_DEFAULT":true,"RA_PRINCIPAL_ADDRESS_AMS":true,"UPLOAD_AND_SUBMIT_HIDE_IF_ONE_OPTION":true,"PAYMENT_PROCESSING_MESSAGE":"Your payment is processing - Do not close your browser or click the back button","CHECKOUT_BUTTON_WHEN_PROCESSING_TEXT":"Processing","EFS_CROP_PICKER_NONE_LABEL":"Lien Duration","DISALLOWED_WIZARD_PIECES":["FormationLocale"],"REPEATER_SHOW_EDIT_BUTTON":true,"DATA_REQUEST_PAGE_TITLE":"Data Requests and Subscriptions","DATA_REQUEST_SIDEBAR_LABEL":"Data Requests & Subscriptions","LOGIN_REDIRECTS_TO_EPASS":false,"LOGIN_REDIRECTS_TO_ACTIVE_DIRECTORY":true,"LOGIN_ACTIVE_DIRECTORY_LINK":true,"FETCH_EDIT_USER_LINK":false,"LISTS_FETCH_AVAILABLE_LISTS":true,"POST_WIZARD_SUBMIT_REDIRECT_URL":"/","PIN_REQUEST_ATTESTATIONS":true,"PIN_REQUEST_DESCRIPTION":"Click **Request PIN** to have a new PIN sent to the account holder's email address on file.","OWNERSHIP_REQUEST_DESCRIPTION":"To become an **authorized user** of this record, a current **AUTHORIZED USER** will need to grant you access. To request access, click **Request Access** below.","PIN_REQUEST_SUCCESS_MESSAGE":"The PIN you have requested for this entity has been sent to the email associated with your user account.  You should receive the PIN in approximately 3-5 minutes, depending on your email service provider.","APOSTILLE_HEADER_LABEL":"Verification Information","APOSTILLE_NUMBER_LABEL":"Apostille/Authentication","APOSTILLE_CITY_STATE_OVERRIDE":"HELENA, MT","APOSTILLE_FILING_DATE_LABEL":"Issue Date","APOSTILLE_CITY_STATE_IN_CERTIFIED":true,"NOTARY_EXISTING_FILING":true,"ALLOW_REVOKE_OWN_ACCESS_ONLY":false,"HIDE_CANCEL_ON_ONETIME_DATA_REQUESTS":true,"DATA_REQUESTS_IN_SHOPPING_CART":true,"WQ_ALLOW_EDIT_PENDING_PAYMENT":true,"WQ_CONFIRM_ON_DELETE":true,"WQ_DELETE_CONFIRM_MESSAGE":"Deleting this filing will forfeit any money already paid to the Secretary of State. This action is permanent and cannot be undone, are you sure you would like to delete?","PASS_ITEM_GUIDS_ON_CHECKOUT":true,"FORM_REVISION_HISTORY":true,"CHECKOUT_DISCLAIMER":"By entering your credit card and/or checking account information you (i) state that **you are an authorized user** of the credit card and/or electronic check and that the associated information entered (e.g., account holder name, account number, billing address) is accurate, (ii) **you authorize payment processor to charge the amount you have requested** to your credit card and/or funding account, and (iii) **acknowledge if a charge is declined or reversed you may also be assessed a customary charge** by the payment processor for such transactions.","FARM_BILL_SEARCH_CONFIDENTIAL":"As a registered Farm Bill Buyer with the Montana Secretary of State’s office it is important to maintain the confidentiality of the information contained within the Farm Bill Master List. The Farm Bill Master List reflects personal data, such as Social Security Numbers, which are a key piece of personal identifiable information to assist you in determining the existence of a lien against a specific debtor. The distribution of this information beyond its intended purpose is strictly prohibited.\n\n**The debtor's tax identification number has been hidden for confidentiality reasons. You may continue to search on a tax ID number and return debtors that match your search criteria. The SSN/FEIN must be entered without dashes or spaces.  If you need access to the tax identification number to clearly identify the debtor, please contact the UCC unit at (406) 444-3665.**","VIEW_HISTORY_BUTTON_ALT_TEXT":"View Filings","WIZARD_ERROR_TITLE_MESSAGE":"Form Error","FARM_BILL_SEARCH_INTERACTIVE":true,"USE_FARM_BILL_API":true,"DISALLOW_ASSIGN_SELF_AS_RA":true,"DISALLOW_ASSIGN_SELF_AS_PRINCIPAL":true,"USE_TRADEMARK_OWNER_VALIDATION":true,"USE_ALTERNATIVE_FOREIGN_ADDRESS_LABELS":true,"MY_RECEIPTS_FILTER":[{"type":"dateRange","name":"DATE_RANGE","label":"Date range","defaultValue":{"start":null,"end":null}},{"type":"text","name":"REF_NUM","defaultValue":"","label":"Reference Number"},{"type":"text","name":"RECEIPT_NUM","defaultValue":"","label":"Receipt Id"},{"type":"text","name":"AMOUNT","defaultValue":"","label":"Amount"},{"type":"select","name":"TYPE","defaultValue":"","label":"Payment Type","options":[{"value":"","label":"All"},{"value":"CC","label":"Credit Card"},{"value":"Check","label":"Check"}]}],"MY_RECEIPTS_SHOW_IN_SIDEBAR":true,"SHOW_MY_RECEIPTS_HELPER_TEXT":true,"MY_RECEIPTS_HELPER_LABEL":"About Receipt Search","MY_RECEIPTS_HELPER_TEXT":"You can search for receipts based on their descriptions, including the items paid for on the receipt. Use the filters to search for or filter specific information.","FARM_BILL_SUBLINK":{"label":"Farm Bill","component":"FarmBill","parameter":"farm-bill","path":"/lists/farm-bill","sourceTypeId":0,"myRecordsSearch":false,"allowedRules":["/search/"],"disabled":true,"searchDescription":"To perform a search, enter a debtor name. Your search results may include: exact debtor name, variations of that name and any filing that includes your search criteria. Punctuation is ignored.\n\nYou can click on \"Advanced\" to refine your search. Under “Advanced” you can search by crop, year, county and SSN/FEIN. As a registered Farm Bill Buyer with the Montana Secretary of State’s office it is important to maintain the confidentiality of the information contained within the Farm Bill Master List. The Farm Bill Master List reflects personal data, such as Social Security Numbers, which are a key piece of personal identifiable information to assist you in determining the existence of a lien against a specific debtor. The distribution of this information beyond its intended purpose is strictly prohibited.\n\nThe debtor's tax identification number has been hidden for confidentiality reasons. You may continue to search on a tax ID number and return debtors that match your search criteria. The SSN/FEIN must be entered without dashes or spaces.","searchMustHaveOneOf":["search","UCC_FARM_PRODUCT_ID","COUNTY"],"searchPlaceholder":"Search by debtor name","advancedSearchParameters":[{"type":"ServerMultiComplete","label":"Product code name(s)","name":"UCC_FARM_PRODUCT_ID","defaultValue":"","optionsSrc":"UCC_FARM_PRODUCT_V"},{"type":"MultiComplete","label":"Year or Range of Years","name":"YEAR_NUM","optionsSrc":"years","startYear":"1968","defaultValue":[],"preMergeOptions":[{"value":"ALL","label":"All"}]},{"type":"serverSelect","label":"State","name":"STATE","defaultValue":"MONTANA","optionsSrc":"STATE"},{"type":"ServerMultiComplete","label":"County","name":"COUNTY","defaultValue":[],"optionsSrc":"COUNTY","overrideSubOptionsSrcFromParameterName":"STATE"},{"type":"checkbox","name":"TIN_SEARCH_YN","defaultValue":false,"label":"Tax Identification Number Search"},{"type":"checkbox","name":"TIN_SORT_YN","defaultValue":false,"label":"Unique ID Sort"}]},"ALLOW_ADDRESS_VALIDATION_BYPASS_OPTION":true,"DEFAULT_ADDRESS_VALIDATION_BYPASS_OPTION_CHECKED":true}).LOGIN_FORGOT_PASSWORD_LINK;
	var LOGIN_FORGOT_USERNAME_LINK = ({"NODE_ENV":"production","BUILD_DATE":"2025-08-27T15:15:31.687Z","BUILD_NUMBER":"Not Provided","GIT_VERSION":"v1.3.0-381-ga81e29b08","GIT_COMMIT_HASH":"a81e29b085c9268ffd96c78eb734365802722741","GIT_BRANCH":"beta","PUBLIC_URL":"","STATE_ABBR":"MT","STATE_NAME":"Montana","STATE_ORG_TITLE":"Secretary of State","LOGIN_HEADER_IMG_PATH":"","HOME_IMG_FILENAME":"montana.jpg","FAVICON_FILE_NAME":"favicon.ico","ALLOW_E_SIGN_ON_CORRECTIONS":true,"THIRD_PARTY_SIGNING_ALLOWED":false,"MY_ACCOUNT_SAVE_AND_CLOSE_BUTTON":true,"IE_DEPRECATED_MESSAGE":"Internet Explorer is not supported. Please select a supported browser below to access this website.","ADDITIONAL_ROUTES":{"dataRequests":true,"farmBill":true,"apostille":true,"externalHelp":"https://sosmt.gov/business/help-center/","systemAdministration":[{"title":"Saved Payments","parameter":"saved-payments","componentName":"SavedPayments"}]},"SUBROUTES":[{"label":"Business","component":"Business","parameter":"business","myWorkQueueSearch":false,"sourceTypeId":54,"searchMustHaveOneOf":["FILING_TYPE_ID","STATUS_ID","STATE","search"],"serverWebSearchDescription":true,"serverWorkQueueDescription":true,"serverMyRecordsDescription":true,"searchPlaceholder":"Search by name or filing number (X########)","allowEmptySearchTerm":true,"requestCertificateAlternateLabel":"Request Information","fileAmendmentButtonLabel":"Filing Actions","advancedSearchParameters":[{"type":"radio","name":"QUERY_TYPE_ID","defaultValue":1010,"options":[{"value":1010,"label":"Starts with"},{"value":1011,"label":"Contains"},{"value":1012,"label":" Word Contains"}]},{"type":"serverSelect","name":"FILING_TYPE_ID","optionsSrc":"FILING_TYPES","label":"Entity Type","placeholder":"All","defaultValue":"0"},{"type":"serverSelect","name":"FILING_SUBTYPE_ID","optionsSrc":"FILING_SUBTYPES","label":"Entity Subtype","overrideSubOptionsSrcFromParameterName":"FILING_TYPE_ID","placeholder":"All","defaultValue":"0"},{"type":"serverSelect","name":"STATUS_ID","optionsSrc":"FILING_STATUS_WITHOUT_ALL","label":"Status","placeholder":"All","defaultValue":"0"},{"type":"serverSelect","name":"STATE","optionsSrc":"STATE","label":"State","placeholder":"All","defaultValue":""},{"type":"serverSelect","name":"COUNTY","optionsSrc":"COUNTY_SUBOPTION","label":"County","overrideSubOptionsSrcFromParameterName":"STATE","placeholder":"All","defaultValue":""},{"type":"checkbox","name":"CRA_SEARCH_YN","defaultValue":false,"label":"Search by Registered Agent PID"},{"type":"dateRange","name":"FILING_DATE","label":"Registration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}},{"type":"dateRange","name":"EXPIRATION_DATE","label":"Expiration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}}],"myRecordsFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Active"},{"value":2,"label":"Inactive"},{"value":3,"label":"Pending"}]},{"type":"dateRange","name":"DATE_RANGE","label":"Date range","defaultValue":{"start":null,"end":null}}],"myWorkQueueFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Approved"},{"value":2,"label":"Pending Online Payment"},{"value":3,"label":"Pending Review"},{"value":4,"label":"Needs Correction"},{"value":5,"label":"Rejected"},{"value":6,"label":"Draft"}]},{"type":"dateRange","name":"DATE_RANGE","label":"Date range","defaultValue":{"start":null,"end":null}}]},{"label":"Notary","component":"Notary","parameter":"notary","sourceTypeId":850,"myWorkQueueSearch":false,"allowEmptySearchTerm":true,"requestCertificateAlternateLabel":"Download Certificate","fileAmendmentButtonLabel":"Filing Actions","hideNameRequestCertificate":true,"hideAddressRequestCertificate":true,"hideRecordUserManagment":true,"searchPlaceholder":"Search by name or commission number","searchMustHaveOneOf":["CITY","search","SERVICE_TYPE"],"advancedParametersStartOpen":true,"searchIsSortable":true,"advancedSearchParameters":[{"type":"radio","name":"STARTS_WITH_YN","defaultValue":false,"options":[{"value":true,"label":"Starts with"},{"value":false,"label":"Contains"}]},{"type":"checkbox","name":"ACTIVE_ONLY_YN","defaultValue":true,"label":"Active entities only"},{"type":"text","name":"CITY","defaultValue":"","label":"City"},{"type":"select","name":"SERVICE_TYPE","label":"Special Services Offered","defaultValue":0,"options":[{"value":0,"label":"(N/A)"},{"value":6165,"label":"In-Person Electronic Notarization (IPEN)"},{"value":6166,"label":"Remote Online Notarization (RON)"},{"value":6167,"label":"Mobile Notary Services"},{"value":6168,"label":"Remote Ink Notarization (RIN)"}]}]},{"label":"Apostille","component":"Apostille","parameter":"apostille","sourceTypeId":720,"myRecordsSearch":false,"myWorkQueueSearch":false,"disabled":false,"allowedRoutes":["/forms-manager/","/queue/","/forms/"]},{"label":"Liens","component":"UCC","parameter":"ucc","sourceTypeId":1999,"myRecordsSearch":true,"myWorkQueueSearch":true,"fileAmendmentButtonLabel":"Filing Actions","searchPlaceholder":"Search by name or file number","disabled":false,"serverWebSearchDescription":true,"myRecordsDescription":"","workQueueDescription":"","searchDescription":"","hideRecordUserManagment":true,"searchLiensCheckout":false,"advancedSearchParameters":[{"type":"radio","name":"STARTS_WITH_YN","defaultValue":false,"options":[{"value":true,"label":"Starts with"},{"value":false,"label":"Contains"}]},{"type":"select","name":"STATUS","defaultValue":"ALL","label":"Status","options":[{"value":"ACTIVE_UNLAPSED","label":"Active (unlapsed)"},{"value":"ACTIVE_LAPSED_UNLAPSED","label":"Active (lapsed and unlapsed)"}]},{"type":"text","name":"EXCLUDE_VALUES","label":"Exclude Debtor Names (comma separated list of names to exclude)","defaultValue":""},{"type":"dateRange","name":"FILING_DATE","label":"Financing Statement Date","defaultValue":{"start":null,"end":null}},{"type":"dateRange","name":"LAPSE_DATE","label":"Lapse Date","defaultValue":{"start":null,"end":null}},{"type":"text","name":"CITY","label":"Debtor City","defaultValue":""}],"myRecordsFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Approved"},{"value":2,"label":"Pending Online Payment"},{"value":3,"label":"Pending Review"}]},{"type":"select","name":"TYPE","defaultValue":0,"label":"Lien Type","options":[{"value":0,"label":"All"},{"value":1,"label":"UCC"},{"value":2,"label":"EFS"},{"value":3,"label":"Title 71"}]}],"myWorkQueueFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Approved"},{"value":2,"label":"Pending Online Payment"},{"value":3,"label":"Pending Review"},{"value":4,"label":"Pending Print and Mail"},{"value":5,"label":"Rejected"},{"value":6,"label":"Draft"}]},{"type":"select","name":"TYPE","defaultValue":0,"label":"Lien Type","options":[{"value":0,"label":"All"},{"value":1,"label":"UCC"},{"value":2,"label":"EFS"},{"value":3,"label":"Title 71"}]}]},{"label":"Copy Request","component":"copies","parameter":"copies","sourceTypeId":2001,"myRecordsSearch":false,"myWorkQueueSearch":false,"disabled":false,"allowedRoutes":["/forms-manager/","/queue/","/forms/"]},{"label":"Trademark","component":"Trademark","parameter":"trademark","sourceTypeId":810,"showRequestCertificate":true,"searchMustHaveOneOf":["search","EXPIRATION_DATE","FILING_DATE"],"allowEmptySearchTerm":true,"requestCertificateAlternateLabel":"Request Information","fileAmendmentButtonLabel":"Filing Actions","advancedSearchParameters":[{"type":"radio","name":"QUERY_TYPE_ID","defaultValue":1010,"options":[{"value":1010,"label":"Starts with"},{"value":1011,"label":"Contains"},{"value":1012,"label":" Word Contains"}]},{"type":"checkbox","name":"OWNER_SEARCH_YN","defaultValue":false,"label":"Search owners"},{"type":"radio","name":"SERVICE_MARK_YN","label":"Mark Type","defaultValue":"","options":[{"value":"","label":"All Marks"},{"value":"Y","label":"Service Mark"},{"value":"N","label":"Trademark"}]},{"type":"serverSelect","name":"STATUS_ID","optionsSrc":"TYPE_V|TRADEMARK_STATUS_TYPE","label":"Status","placeholder":"All","defaultValue":"0"},{"type":"select","name":"DESIGN_TYPE_ID","options":[{"value":0,"label":"All"},{"value":990,"label":"Words Only"},{"value":991,"label":"Design Only"},{"value":992,"label":"Words and Design"}],"label":"Design Type","defaultValue":"0"},{"type":"dateRange","name":"FILING_DATE","label":"Registered Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}},{"type":"dateRange","name":"EXPIRATION_DATE","label":"Expiration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}}]},{"label":"Business Info Request","component":"InfoRequests","parameter":"info-request","sourceTypeId":167,"allowedRoutes":["/forms-manager/","/queue/","/forms/"]},{"label":"Data Requests","component":"DataRequests","parameter":"data-request","sourceTypeId":0,"allowedRoutes":["/forms-manager/"]},{"label":"CRA","component":"CRA","parameter":"cra","sourceTypeId":157,"myRecordsSearch":false,"searchPlaceholder":"Search by name or registered agent number","allowedRoutes":["/forms-manager/","/forms/","/records/","/queue/","/search/"],"allowEmptySearchTerm":true,"fileAmendmentButtonLabel":"Filing Actions","advancedSearchParameters":[{"type":"radio","name":"QUERY_TYPE_ID","defaultValue":1010,"options":[{"value":1010,"label":"Starts with"},{"value":1011,"label":"Contains"},{"value":1012,"label":" Word Contains"}]},{"type":"dateRange","name":"CRA_DATE","label":"Registration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}},{"type":"select","name":"STATUS_ID","label":"Status","defaultValue":0,"options":[{"value":0,"label":"All"},{"value":121,"label":"Active"},{"value":122,"label":"Inactive"}]},{"type":"select","name":"AGENT_TYPE_ID","label":"Agent Type","defaultValue":0,"options":[{"value":0,"label":"All"},{"value":460,"label":"Registered Agent"},{"value":461,"label":"Commercial Registered Agent"}]}]},{"label":"Farm Bill","component":"FarmBill","parameter":"farm-bill","path":"/lists/farm-bill","sourceTypeId":0,"myRecordsSearch":false,"allowedRules":["/search/"],"disabled":true,"searchDescription":"To perform a search, enter a debtor name. Your search results may include: exact debtor name, variations of that name and any filing that includes your search criteria. Punctuation is ignored.\n\nYou can click on \"Advanced\" to refine your search. Under “Advanced” you can search by crop, year, county and SSN/FEIN. As a registered Farm Bill Buyer with the Montana Secretary of State’s office it is important to maintain the confidentiality of the information contained within the Farm Bill Master List. The Farm Bill Master List reflects personal data, such as Social Security Numbers, which are a key piece of personal identifiable information to assist you in determining the existence of a lien against a specific debtor. The distribution of this information beyond its intended purpose is strictly prohibited.\n\nThe debtor's tax identification number has been hidden for confidentiality reasons. You may continue to search on a tax ID number and return debtors that match your search criteria. The SSN/FEIN must be entered without dashes or spaces.","searchMustHaveOneOf":["search","UCC_FARM_PRODUCT_ID","COUNTY"],"searchPlaceholder":"Search by debtor name","advancedSearchParameters":[{"type":"ServerMultiComplete","label":"Product code name(s)","name":"UCC_FARM_PRODUCT_ID","defaultValue":"","optionsSrc":"UCC_FARM_PRODUCT_V"},{"type":"MultiComplete","label":"Year or Range of Years","name":"YEAR_NUM","optionsSrc":"years","startYear":"1968","defaultValue":[],"preMergeOptions":[{"value":"ALL","label":"All"}]},{"type":"serverSelect","label":"State","name":"STATE","defaultValue":"MONTANA","optionsSrc":"STATE"},{"type":"ServerMultiComplete","label":"County","name":"COUNTY","defaultValue":[],"optionsSrc":"COUNTY","overrideSubOptionsSrcFromParameterName":"STATE"},{"type":"checkbox","name":"TIN_SEARCH_YN","defaultValue":false,"label":"Tax Identification Number Search"},{"type":"checkbox","name":"TIN_SORT_YN","defaultValue":false,"label":"Unique ID Sort"}]}],"SYSTEM_NICKNAME":"Online Services Portal","PAYMENT_METHODS":[{"type":"bypass"},{"type":"iTransact"}],"PAYMENT_ALLOW_AMEX":true,"SYSTEM_ID_LABEL":"System Id","DOUBLE_COLUMN_PUBLIC_LOGIN":true,"INTERNAL_USER_MANAGEMENT":true,"ALLOW_PUBLIC_JSON_IMPORT":false,"MAX_FILE_UPLOAD_SIZE":10000000,"REFUND_TEXT":"","RETURN_TO_HOME_ON_LOGOUT":true,"CURRENT_SOS_NAME":"Christi Jacobsen","LOGO_FILENAME":"mt-sos-logo.png","LOGO_ALT":"Christi Jacobsen, Montana Secretary of State","LOGO_FULL_WIDTH":true,"HOME_HIDE_AUTH_HINT":true,"HOME_TITLE":"Montana Secretary of State","CUSTOM_TAB_TITLE":"Official Montana","HOME_SUBTITLE":"Online Business Services","ENTITY_NAME_CONSENT_DESCRIPTION":"","ALLOW_USER_PROFILE_EDITING":true,"COMPARE_FOREIGN_NAME_IN_ENTITY_NAME_VALIDATION":true,"FOREIGN_NAME_FIELD_NAME":"KIMA_PARENT_NAME_INFO","LOGIN_TITLE":"Montana Secretary of State Online Filing Portal Login","PUBLIC_LOGIN_LABEL":"Username","REVERSE_LOGIN_COLUMNS":true,"LOGIN_SEAL_FILENAME":"seal_white.png","SEPARATE_USERNAME_AND_EMAIL":true,"CREATE_ACCOUNT_BUTTON_ALIGN_LEFT":true,"CREATE_ACCOUNT_BUTTON_TEXT":"CREATE AN ACCOUNT","PASSWORD_CUSTOM_ERROR_TEXT":"The password must meet all requirements","ACCOUNT_CREATED_MESSAGE":"Please check your email to verify your account to login and allow a few minutes for this message to arrive. Check your junk/spam folders if you do not find the email in your inbox.","PUBLIC_LOGIN_PLACEHOLDER":" ","DISABLE_DEFAULT_PAYMENT_RADIO":true,"CUSTOM_RESET_PASSWORD_ERROR_MESSAGE":"Username invalid - no account found","PUBLIC_LOGIN_CREATE_DESCRIPTION":"### Existing User:\n\n  - Enter your username and password to login.  \n\n\n  #### - OR -  \n\n\n\n  - Forgot password? Click 'Reset Password' and follow the prompts.\n  - Forgot username? Click 'Forgot Username' and follow the prompts.  \n\n\n  ### New User:\n  ","LOGIN_HELP_LINK":"https://sosmt.gov/business/how-do-i/","LOGIN_HELP_LINK_TEXT":"Need Help?","FORGOT_USERNAME_TEXT":"Forgot Username?","LOGIN_ACTIVE_DIRECTORY_TEXT":"State User Login","MULTIPLE_LOGIN_METHODS":true,"HAS_ACTIVE_DIRECTORY_LOGIN":true,"RESET_PASSWORD_WITH_USERNAME":true,"DOWNLOAD_LINK":true,"SHOW_USERNAME_ACCOUNT_CREATE":true,"SHOW_SCROLL_DOWN_ARROW":true,"SHOW_ADDRESS_ACCOUNT_CREATE":true,"TWO_COLUMN_ACCOUNT_CREATE":true,"RESET_PASSWORD_TIP":"A link to change your password has been sent to your email. Please allow a few minutes for this message to arrive. Please check your junk/spam folders if you do not find the email in your inbox.","FORGOT_PASSWORD_LINK_TEXT":"Reset Password","PHONE_NUMBER_OPTIONAL_ACCOUNT_CREATE":true,"SHOW_REQUIRED_INDICATOR_ACCOUNT_CREATE":true,"PASSWORD_REQUIREMENTS_ACCOUNT_CREATE":"\n    <ul>\n      <li>MUST contain at least 8 characters (12+ recommended)</li>\n      <li>MUST contain at least one uppercase letter.</li>\n      <li>MUST contain at least one lowercase letter.</li>\n      <li>MUST contain at least one number.</li>\n      <li>MUST contain at least one special character (!”#$%&'()*+,-./:;<=>?</li>\n    </ul>\n  ","ALLOW_CERTIFICATION_REQUEST":true,"ALLOW_PUBLIC_CERTIFICATE_REQUEST":true,"ALLOW_COPY_REQUEST":false,"ALLOW_CORRECTION_STYLING":true,"HIDE_DEPRECATION_WARNING":false,"AMEND_ROUTE_PUBLIC":true,"SEAL_FILENAME":"seal.png","SHOPPING_CART":true,"ALLOW_PAYMENT_UPDATE_WITH_EMPTY_CART":true,"RA_EMAIL":true,"RA_WEBSITE":true,"RA_NO_DEFAULT_TYPE":true,"RA_ADDRESS_LABEL":"Street Address","RA_TYPE_SELECTION_DEFAULT":true,"RA_DEFAULT_TYPE":"460","RA_OVERRIDE_TYPE_WITH_DEFAULT":true,"RA_PRINCIPAL_ADDRESS_AMS":true,"UPLOAD_AND_SUBMIT_HIDE_IF_ONE_OPTION":true,"PAYMENT_PROCESSING_MESSAGE":"Your payment is processing - Do not close your browser or click the back button","CHECKOUT_BUTTON_WHEN_PROCESSING_TEXT":"Processing","EFS_CROP_PICKER_NONE_LABEL":"Lien Duration","DISALLOWED_WIZARD_PIECES":["FormationLocale"],"REPEATER_SHOW_EDIT_BUTTON":true,"DATA_REQUEST_PAGE_TITLE":"Data Requests and Subscriptions","DATA_REQUEST_SIDEBAR_LABEL":"Data Requests & Subscriptions","LOGIN_REDIRECTS_TO_EPASS":false,"LOGIN_REDIRECTS_TO_ACTIVE_DIRECTORY":true,"LOGIN_ACTIVE_DIRECTORY_LINK":true,"FETCH_EDIT_USER_LINK":false,"LISTS_FETCH_AVAILABLE_LISTS":true,"POST_WIZARD_SUBMIT_REDIRECT_URL":"/","PIN_REQUEST_ATTESTATIONS":true,"PIN_REQUEST_DESCRIPTION":"Click **Request PIN** to have a new PIN sent to the account holder's email address on file.","OWNERSHIP_REQUEST_DESCRIPTION":"To become an **authorized user** of this record, a current **AUTHORIZED USER** will need to grant you access. To request access, click **Request Access** below.","PIN_REQUEST_SUCCESS_MESSAGE":"The PIN you have requested for this entity has been sent to the email associated with your user account.  You should receive the PIN in approximately 3-5 minutes, depending on your email service provider.","APOSTILLE_HEADER_LABEL":"Verification Information","APOSTILLE_NUMBER_LABEL":"Apostille/Authentication","APOSTILLE_CITY_STATE_OVERRIDE":"HELENA, MT","APOSTILLE_FILING_DATE_LABEL":"Issue Date","APOSTILLE_CITY_STATE_IN_CERTIFIED":true,"NOTARY_EXISTING_FILING":true,"ALLOW_REVOKE_OWN_ACCESS_ONLY":false,"HIDE_CANCEL_ON_ONETIME_DATA_REQUESTS":true,"DATA_REQUESTS_IN_SHOPPING_CART":true,"WQ_ALLOW_EDIT_PENDING_PAYMENT":true,"WQ_CONFIRM_ON_DELETE":true,"WQ_DELETE_CONFIRM_MESSAGE":"Deleting this filing will forfeit any money already paid to the Secretary of State. This action is permanent and cannot be undone, are you sure you would like to delete?","PASS_ITEM_GUIDS_ON_CHECKOUT":true,"FORM_REVISION_HISTORY":true,"CHECKOUT_DISCLAIMER":"By entering your credit card and/or checking account information you (i) state that **you are an authorized user** of the credit card and/or electronic check and that the associated information entered (e.g., account holder name, account number, billing address) is accurate, (ii) **you authorize payment processor to charge the amount you have requested** to your credit card and/or funding account, and (iii) **acknowledge if a charge is declined or reversed you may also be assessed a customary charge** by the payment processor for such transactions.","FARM_BILL_SEARCH_CONFIDENTIAL":"As a registered Farm Bill Buyer with the Montana Secretary of State’s office it is important to maintain the confidentiality of the information contained within the Farm Bill Master List. The Farm Bill Master List reflects personal data, such as Social Security Numbers, which are a key piece of personal identifiable information to assist you in determining the existence of a lien against a specific debtor. The distribution of this information beyond its intended purpose is strictly prohibited.\n\n**The debtor's tax identification number has been hidden for confidentiality reasons. You may continue to search on a tax ID number and return debtors that match your search criteria. The SSN/FEIN must be entered without dashes or spaces.  If you need access to the tax identification number to clearly identify the debtor, please contact the UCC unit at (406) 444-3665.**","VIEW_HISTORY_BUTTON_ALT_TEXT":"View Filings","WIZARD_ERROR_TITLE_MESSAGE":"Form Error","FARM_BILL_SEARCH_INTERACTIVE":true,"USE_FARM_BILL_API":true,"DISALLOW_ASSIGN_SELF_AS_RA":true,"DISALLOW_ASSIGN_SELF_AS_PRINCIPAL":true,"USE_TRADEMARK_OWNER_VALIDATION":true,"USE_ALTERNATIVE_FOREIGN_ADDRESS_LABELS":true,"MY_RECEIPTS_FILTER":[{"type":"dateRange","name":"DATE_RANGE","label":"Date range","defaultValue":{"start":null,"end":null}},{"type":"text","name":"REF_NUM","defaultValue":"","label":"Reference Number"},{"type":"text","name":"RECEIPT_NUM","defaultValue":"","label":"Receipt Id"},{"type":"text","name":"AMOUNT","defaultValue":"","label":"Amount"},{"type":"select","name":"TYPE","defaultValue":"","label":"Payment Type","options":[{"value":"","label":"All"},{"value":"CC","label":"Credit Card"},{"value":"Check","label":"Check"}]}],"MY_RECEIPTS_SHOW_IN_SIDEBAR":true,"SHOW_MY_RECEIPTS_HELPER_TEXT":true,"MY_RECEIPTS_HELPER_LABEL":"About Receipt Search","MY_RECEIPTS_HELPER_TEXT":"You can search for receipts based on their descriptions, including the items paid for on the receipt. Use the filters to search for or filter specific information.","FARM_BILL_SUBLINK":{"label":"Farm Bill","component":"FarmBill","parameter":"farm-bill","path":"/lists/farm-bill","sourceTypeId":0,"myRecordsSearch":false,"allowedRules":["/search/"],"disabled":true,"searchDescription":"To perform a search, enter a debtor name. Your search results may include: exact debtor name, variations of that name and any filing that includes your search criteria. Punctuation is ignored.\n\nYou can click on \"Advanced\" to refine your search. Under “Advanced” you can search by crop, year, county and SSN/FEIN. As a registered Farm Bill Buyer with the Montana Secretary of State’s office it is important to maintain the confidentiality of the information contained within the Farm Bill Master List. The Farm Bill Master List reflects personal data, such as Social Security Numbers, which are a key piece of personal identifiable information to assist you in determining the existence of a lien against a specific debtor. The distribution of this information beyond its intended purpose is strictly prohibited.\n\nThe debtor's tax identification number has been hidden for confidentiality reasons. You may continue to search on a tax ID number and return debtors that match your search criteria. The SSN/FEIN must be entered without dashes or spaces.","searchMustHaveOneOf":["search","UCC_FARM_PRODUCT_ID","COUNTY"],"searchPlaceholder":"Search by debtor name","advancedSearchParameters":[{"type":"ServerMultiComplete","label":"Product code name(s)","name":"UCC_FARM_PRODUCT_ID","defaultValue":"","optionsSrc":"UCC_FARM_PRODUCT_V"},{"type":"MultiComplete","label":"Year or Range of Years","name":"YEAR_NUM","optionsSrc":"years","startYear":"1968","defaultValue":[],"preMergeOptions":[{"value":"ALL","label":"All"}]},{"type":"serverSelect","label":"State","name":"STATE","defaultValue":"MONTANA","optionsSrc":"STATE"},{"type":"ServerMultiComplete","label":"County","name":"COUNTY","defaultValue":[],"optionsSrc":"COUNTY","overrideSubOptionsSrcFromParameterName":"STATE"},{"type":"checkbox","name":"TIN_SEARCH_YN","defaultValue":false,"label":"Tax Identification Number Search"},{"type":"checkbox","name":"TIN_SORT_YN","defaultValue":false,"label":"Unique ID Sort"}]},"ALLOW_ADDRESS_VALIDATION_BYPASS_OPTION":true,"DEFAULT_ADDRESS_VALIDATION_BYPASS_OPTION_CHECKED":true}).LOGIN_FORGOT_USERNAME_LINK;
	var LOGIN_UPDATE_ACCOUNT_LINK = ({"NODE_ENV":"production","BUILD_DATE":"2025-08-27T15:15:31.687Z","BUILD_NUMBER":"Not Provided","GIT_VERSION":"v1.3.0-381-ga81e29b08","GIT_COMMIT_HASH":"a81e29b085c9268ffd96c78eb734365802722741","GIT_BRANCH":"beta","PUBLIC_URL":"","STATE_ABBR":"MT","STATE_NAME":"Montana","STATE_ORG_TITLE":"Secretary of State","LOGIN_HEADER_IMG_PATH":"","HOME_IMG_FILENAME":"montana.jpg","FAVICON_FILE_NAME":"favicon.ico","ALLOW_E_SIGN_ON_CORRECTIONS":true,"THIRD_PARTY_SIGNING_ALLOWED":false,"MY_ACCOUNT_SAVE_AND_CLOSE_BUTTON":true,"IE_DEPRECATED_MESSAGE":"Internet Explorer is not supported. Please select a supported browser below to access this website.","ADDITIONAL_ROUTES":{"dataRequests":true,"farmBill":true,"apostille":true,"externalHelp":"https://sosmt.gov/business/help-center/","systemAdministration":[{"title":"Saved Payments","parameter":"saved-payments","componentName":"SavedPayments"}]},"SUBROUTES":[{"label":"Business","component":"Business","parameter":"business","myWorkQueueSearch":false,"sourceTypeId":54,"searchMustHaveOneOf":["FILING_TYPE_ID","STATUS_ID","STATE","search"],"serverWebSearchDescription":true,"serverWorkQueueDescription":true,"serverMyRecordsDescription":true,"searchPlaceholder":"Search by name or filing number (X########)","allowEmptySearchTerm":true,"requestCertificateAlternateLabel":"Request Information","fileAmendmentButtonLabel":"Filing Actions","advancedSearchParameters":[{"type":"radio","name":"QUERY_TYPE_ID","defaultValue":1010,"options":[{"value":1010,"label":"Starts with"},{"value":1011,"label":"Contains"},{"value":1012,"label":" Word Contains"}]},{"type":"serverSelect","name":"FILING_TYPE_ID","optionsSrc":"FILING_TYPES","label":"Entity Type","placeholder":"All","defaultValue":"0"},{"type":"serverSelect","name":"FILING_SUBTYPE_ID","optionsSrc":"FILING_SUBTYPES","label":"Entity Subtype","overrideSubOptionsSrcFromParameterName":"FILING_TYPE_ID","placeholder":"All","defaultValue":"0"},{"type":"serverSelect","name":"STATUS_ID","optionsSrc":"FILING_STATUS_WITHOUT_ALL","label":"Status","placeholder":"All","defaultValue":"0"},{"type":"serverSelect","name":"STATE","optionsSrc":"STATE","label":"State","placeholder":"All","defaultValue":""},{"type":"serverSelect","name":"COUNTY","optionsSrc":"COUNTY_SUBOPTION","label":"County","overrideSubOptionsSrcFromParameterName":"STATE","placeholder":"All","defaultValue":""},{"type":"checkbox","name":"CRA_SEARCH_YN","defaultValue":false,"label":"Search by Registered Agent PID"},{"type":"dateRange","name":"FILING_DATE","label":"Registration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}},{"type":"dateRange","name":"EXPIRATION_DATE","label":"Expiration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}}],"myRecordsFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Active"},{"value":2,"label":"Inactive"},{"value":3,"label":"Pending"}]},{"type":"dateRange","name":"DATE_RANGE","label":"Date range","defaultValue":{"start":null,"end":null}}],"myWorkQueueFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Approved"},{"value":2,"label":"Pending Online Payment"},{"value":3,"label":"Pending Review"},{"value":4,"label":"Needs Correction"},{"value":5,"label":"Rejected"},{"value":6,"label":"Draft"}]},{"type":"dateRange","name":"DATE_RANGE","label":"Date range","defaultValue":{"start":null,"end":null}}]},{"label":"Notary","component":"Notary","parameter":"notary","sourceTypeId":850,"myWorkQueueSearch":false,"allowEmptySearchTerm":true,"requestCertificateAlternateLabel":"Download Certificate","fileAmendmentButtonLabel":"Filing Actions","hideNameRequestCertificate":true,"hideAddressRequestCertificate":true,"hideRecordUserManagment":true,"searchPlaceholder":"Search by name or commission number","searchMustHaveOneOf":["CITY","search","SERVICE_TYPE"],"advancedParametersStartOpen":true,"searchIsSortable":true,"advancedSearchParameters":[{"type":"radio","name":"STARTS_WITH_YN","defaultValue":false,"options":[{"value":true,"label":"Starts with"},{"value":false,"label":"Contains"}]},{"type":"checkbox","name":"ACTIVE_ONLY_YN","defaultValue":true,"label":"Active entities only"},{"type":"text","name":"CITY","defaultValue":"","label":"City"},{"type":"select","name":"SERVICE_TYPE","label":"Special Services Offered","defaultValue":0,"options":[{"value":0,"label":"(N/A)"},{"value":6165,"label":"In-Person Electronic Notarization (IPEN)"},{"value":6166,"label":"Remote Online Notarization (RON)"},{"value":6167,"label":"Mobile Notary Services"},{"value":6168,"label":"Remote Ink Notarization (RIN)"}]}]},{"label":"Apostille","component":"Apostille","parameter":"apostille","sourceTypeId":720,"myRecordsSearch":false,"myWorkQueueSearch":false,"disabled":false,"allowedRoutes":["/forms-manager/","/queue/","/forms/"]},{"label":"Liens","component":"UCC","parameter":"ucc","sourceTypeId":1999,"myRecordsSearch":true,"myWorkQueueSearch":true,"fileAmendmentButtonLabel":"Filing Actions","searchPlaceholder":"Search by name or file number","disabled":false,"serverWebSearchDescription":true,"myRecordsDescription":"","workQueueDescription":"","searchDescription":"","hideRecordUserManagment":true,"searchLiensCheckout":false,"advancedSearchParameters":[{"type":"radio","name":"STARTS_WITH_YN","defaultValue":false,"options":[{"value":true,"label":"Starts with"},{"value":false,"label":"Contains"}]},{"type":"select","name":"STATUS","defaultValue":"ALL","label":"Status","options":[{"value":"ACTIVE_UNLAPSED","label":"Active (unlapsed)"},{"value":"ACTIVE_LAPSED_UNLAPSED","label":"Active (lapsed and unlapsed)"}]},{"type":"text","name":"EXCLUDE_VALUES","label":"Exclude Debtor Names (comma separated list of names to exclude)","defaultValue":""},{"type":"dateRange","name":"FILING_DATE","label":"Financing Statement Date","defaultValue":{"start":null,"end":null}},{"type":"dateRange","name":"LAPSE_DATE","label":"Lapse Date","defaultValue":{"start":null,"end":null}},{"type":"text","name":"CITY","label":"Debtor City","defaultValue":""}],"myRecordsFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Approved"},{"value":2,"label":"Pending Online Payment"},{"value":3,"label":"Pending Review"}]},{"type":"select","name":"TYPE","defaultValue":0,"label":"Lien Type","options":[{"value":0,"label":"All"},{"value":1,"label":"UCC"},{"value":2,"label":"EFS"},{"value":3,"label":"Title 71"}]}],"myWorkQueueFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Approved"},{"value":2,"label":"Pending Online Payment"},{"value":3,"label":"Pending Review"},{"value":4,"label":"Pending Print and Mail"},{"value":5,"label":"Rejected"},{"value":6,"label":"Draft"}]},{"type":"select","name":"TYPE","defaultValue":0,"label":"Lien Type","options":[{"value":0,"label":"All"},{"value":1,"label":"UCC"},{"value":2,"label":"EFS"},{"value":3,"label":"Title 71"}]}]},{"label":"Copy Request","component":"copies","parameter":"copies","sourceTypeId":2001,"myRecordsSearch":false,"myWorkQueueSearch":false,"disabled":false,"allowedRoutes":["/forms-manager/","/queue/","/forms/"]},{"label":"Trademark","component":"Trademark","parameter":"trademark","sourceTypeId":810,"showRequestCertificate":true,"searchMustHaveOneOf":["search","EXPIRATION_DATE","FILING_DATE"],"allowEmptySearchTerm":true,"requestCertificateAlternateLabel":"Request Information","fileAmendmentButtonLabel":"Filing Actions","advancedSearchParameters":[{"type":"radio","name":"QUERY_TYPE_ID","defaultValue":1010,"options":[{"value":1010,"label":"Starts with"},{"value":1011,"label":"Contains"},{"value":1012,"label":" Word Contains"}]},{"type":"checkbox","name":"OWNER_SEARCH_YN","defaultValue":false,"label":"Search owners"},{"type":"radio","name":"SERVICE_MARK_YN","label":"Mark Type","defaultValue":"","options":[{"value":"","label":"All Marks"},{"value":"Y","label":"Service Mark"},{"value":"N","label":"Trademark"}]},{"type":"serverSelect","name":"STATUS_ID","optionsSrc":"TYPE_V|TRADEMARK_STATUS_TYPE","label":"Status","placeholder":"All","defaultValue":"0"},{"type":"select","name":"DESIGN_TYPE_ID","options":[{"value":0,"label":"All"},{"value":990,"label":"Words Only"},{"value":991,"label":"Design Only"},{"value":992,"label":"Words and Design"}],"label":"Design Type","defaultValue":"0"},{"type":"dateRange","name":"FILING_DATE","label":"Registered Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}},{"type":"dateRange","name":"EXPIRATION_DATE","label":"Expiration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}}]},{"label":"Business Info Request","component":"InfoRequests","parameter":"info-request","sourceTypeId":167,"allowedRoutes":["/forms-manager/","/queue/","/forms/"]},{"label":"Data Requests","component":"DataRequests","parameter":"data-request","sourceTypeId":0,"allowedRoutes":["/forms-manager/"]},{"label":"CRA","component":"CRA","parameter":"cra","sourceTypeId":157,"myRecordsSearch":false,"searchPlaceholder":"Search by name or registered agent number","allowedRoutes":["/forms-manager/","/forms/","/records/","/queue/","/search/"],"allowEmptySearchTerm":true,"fileAmendmentButtonLabel":"Filing Actions","advancedSearchParameters":[{"type":"radio","name":"QUERY_TYPE_ID","defaultValue":1010,"options":[{"value":1010,"label":"Starts with"},{"value":1011,"label":"Contains"},{"value":1012,"label":" Word Contains"}]},{"type":"dateRange","name":"CRA_DATE","label":"Registration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}},{"type":"select","name":"STATUS_ID","label":"Status","defaultValue":0,"options":[{"value":0,"label":"All"},{"value":121,"label":"Active"},{"value":122,"label":"Inactive"}]},{"type":"select","name":"AGENT_TYPE_ID","label":"Agent Type","defaultValue":0,"options":[{"value":0,"label":"All"},{"value":460,"label":"Registered Agent"},{"value":461,"label":"Commercial Registered Agent"}]}]},{"label":"Farm Bill","component":"FarmBill","parameter":"farm-bill","path":"/lists/farm-bill","sourceTypeId":0,"myRecordsSearch":false,"allowedRules":["/search/"],"disabled":true,"searchDescription":"To perform a search, enter a debtor name. Your search results may include: exact debtor name, variations of that name and any filing that includes your search criteria. Punctuation is ignored.\n\nYou can click on \"Advanced\" to refine your search. Under “Advanced” you can search by crop, year, county and SSN/FEIN. As a registered Farm Bill Buyer with the Montana Secretary of State’s office it is important to maintain the confidentiality of the information contained within the Farm Bill Master List. The Farm Bill Master List reflects personal data, such as Social Security Numbers, which are a key piece of personal identifiable information to assist you in determining the existence of a lien against a specific debtor. The distribution of this information beyond its intended purpose is strictly prohibited.\n\nThe debtor's tax identification number has been hidden for confidentiality reasons. You may continue to search on a tax ID number and return debtors that match your search criteria. The SSN/FEIN must be entered without dashes or spaces.","searchMustHaveOneOf":["search","UCC_FARM_PRODUCT_ID","COUNTY"],"searchPlaceholder":"Search by debtor name","advancedSearchParameters":[{"type":"ServerMultiComplete","label":"Product code name(s)","name":"UCC_FARM_PRODUCT_ID","defaultValue":"","optionsSrc":"UCC_FARM_PRODUCT_V"},{"type":"MultiComplete","label":"Year or Range of Years","name":"YEAR_NUM","optionsSrc":"years","startYear":"1968","defaultValue":[],"preMergeOptions":[{"value":"ALL","label":"All"}]},{"type":"serverSelect","label":"State","name":"STATE","defaultValue":"MONTANA","optionsSrc":"STATE"},{"type":"ServerMultiComplete","label":"County","name":"COUNTY","defaultValue":[],"optionsSrc":"COUNTY","overrideSubOptionsSrcFromParameterName":"STATE"},{"type":"checkbox","name":"TIN_SEARCH_YN","defaultValue":false,"label":"Tax Identification Number Search"},{"type":"checkbox","name":"TIN_SORT_YN","defaultValue":false,"label":"Unique ID Sort"}]}],"SYSTEM_NICKNAME":"Online Services Portal","PAYMENT_METHODS":[{"type":"bypass"},{"type":"iTransact"}],"PAYMENT_ALLOW_AMEX":true,"SYSTEM_ID_LABEL":"System Id","DOUBLE_COLUMN_PUBLIC_LOGIN":true,"INTERNAL_USER_MANAGEMENT":true,"ALLOW_PUBLIC_JSON_IMPORT":false,"MAX_FILE_UPLOAD_SIZE":10000000,"REFUND_TEXT":"","RETURN_TO_HOME_ON_LOGOUT":true,"CURRENT_SOS_NAME":"Christi Jacobsen","LOGO_FILENAME":"mt-sos-logo.png","LOGO_ALT":"Christi Jacobsen, Montana Secretary of State","LOGO_FULL_WIDTH":true,"HOME_HIDE_AUTH_HINT":true,"HOME_TITLE":"Montana Secretary of State","CUSTOM_TAB_TITLE":"Official Montana","HOME_SUBTITLE":"Online Business Services","ENTITY_NAME_CONSENT_DESCRIPTION":"","ALLOW_USER_PROFILE_EDITING":true,"COMPARE_FOREIGN_NAME_IN_ENTITY_NAME_VALIDATION":true,"FOREIGN_NAME_FIELD_NAME":"KIMA_PARENT_NAME_INFO","LOGIN_TITLE":"Montana Secretary of State Online Filing Portal Login","PUBLIC_LOGIN_LABEL":"Username","REVERSE_LOGIN_COLUMNS":true,"LOGIN_SEAL_FILENAME":"seal_white.png","SEPARATE_USERNAME_AND_EMAIL":true,"CREATE_ACCOUNT_BUTTON_ALIGN_LEFT":true,"CREATE_ACCOUNT_BUTTON_TEXT":"CREATE AN ACCOUNT","PASSWORD_CUSTOM_ERROR_TEXT":"The password must meet all requirements","ACCOUNT_CREATED_MESSAGE":"Please check your email to verify your account to login and allow a few minutes for this message to arrive. Check your junk/spam folders if you do not find the email in your inbox.","PUBLIC_LOGIN_PLACEHOLDER":" ","DISABLE_DEFAULT_PAYMENT_RADIO":true,"CUSTOM_RESET_PASSWORD_ERROR_MESSAGE":"Username invalid - no account found","PUBLIC_LOGIN_CREATE_DESCRIPTION":"### Existing User:\n\n  - Enter your username and password to login.  \n\n\n  #### - OR -  \n\n\n\n  - Forgot password? Click 'Reset Password' and follow the prompts.\n  - Forgot username? Click 'Forgot Username' and follow the prompts.  \n\n\n  ### New User:\n  ","LOGIN_HELP_LINK":"https://sosmt.gov/business/how-do-i/","LOGIN_HELP_LINK_TEXT":"Need Help?","FORGOT_USERNAME_TEXT":"Forgot Username?","LOGIN_ACTIVE_DIRECTORY_TEXT":"State User Login","MULTIPLE_LOGIN_METHODS":true,"HAS_ACTIVE_DIRECTORY_LOGIN":true,"RESET_PASSWORD_WITH_USERNAME":true,"DOWNLOAD_LINK":true,"SHOW_USERNAME_ACCOUNT_CREATE":true,"SHOW_SCROLL_DOWN_ARROW":true,"SHOW_ADDRESS_ACCOUNT_CREATE":true,"TWO_COLUMN_ACCOUNT_CREATE":true,"RESET_PASSWORD_TIP":"A link to change your password has been sent to your email. Please allow a few minutes for this message to arrive. Please check your junk/spam folders if you do not find the email in your inbox.","FORGOT_PASSWORD_LINK_TEXT":"Reset Password","PHONE_NUMBER_OPTIONAL_ACCOUNT_CREATE":true,"SHOW_REQUIRED_INDICATOR_ACCOUNT_CREATE":true,"PASSWORD_REQUIREMENTS_ACCOUNT_CREATE":"\n    <ul>\n      <li>MUST contain at least 8 characters (12+ recommended)</li>\n      <li>MUST contain at least one uppercase letter.</li>\n      <li>MUST contain at least one lowercase letter.</li>\n      <li>MUST contain at least one number.</li>\n      <li>MUST contain at least one special character (!”#$%&'()*+,-./:;<=>?</li>\n    </ul>\n  ","ALLOW_CERTIFICATION_REQUEST":true,"ALLOW_PUBLIC_CERTIFICATE_REQUEST":true,"ALLOW_COPY_REQUEST":false,"ALLOW_CORRECTION_STYLING":true,"HIDE_DEPRECATION_WARNING":false,"AMEND_ROUTE_PUBLIC":true,"SEAL_FILENAME":"seal.png","SHOPPING_CART":true,"ALLOW_PAYMENT_UPDATE_WITH_EMPTY_CART":true,"RA_EMAIL":true,"RA_WEBSITE":true,"RA_NO_DEFAULT_TYPE":true,"RA_ADDRESS_LABEL":"Street Address","RA_TYPE_SELECTION_DEFAULT":true,"RA_DEFAULT_TYPE":"460","RA_OVERRIDE_TYPE_WITH_DEFAULT":true,"RA_PRINCIPAL_ADDRESS_AMS":true,"UPLOAD_AND_SUBMIT_HIDE_IF_ONE_OPTION":true,"PAYMENT_PROCESSING_MESSAGE":"Your payment is processing - Do not close your browser or click the back button","CHECKOUT_BUTTON_WHEN_PROCESSING_TEXT":"Processing","EFS_CROP_PICKER_NONE_LABEL":"Lien Duration","DISALLOWED_WIZARD_PIECES":["FormationLocale"],"REPEATER_SHOW_EDIT_BUTTON":true,"DATA_REQUEST_PAGE_TITLE":"Data Requests and Subscriptions","DATA_REQUEST_SIDEBAR_LABEL":"Data Requests & Subscriptions","LOGIN_REDIRECTS_TO_EPASS":false,"LOGIN_REDIRECTS_TO_ACTIVE_DIRECTORY":true,"LOGIN_ACTIVE_DIRECTORY_LINK":true,"FETCH_EDIT_USER_LINK":false,"LISTS_FETCH_AVAILABLE_LISTS":true,"POST_WIZARD_SUBMIT_REDIRECT_URL":"/","PIN_REQUEST_ATTESTATIONS":true,"PIN_REQUEST_DESCRIPTION":"Click **Request PIN** to have a new PIN sent to the account holder's email address on file.","OWNERSHIP_REQUEST_DESCRIPTION":"To become an **authorized user** of this record, a current **AUTHORIZED USER** will need to grant you access. To request access, click **Request Access** below.","PIN_REQUEST_SUCCESS_MESSAGE":"The PIN you have requested for this entity has been sent to the email associated with your user account.  You should receive the PIN in approximately 3-5 minutes, depending on your email service provider.","APOSTILLE_HEADER_LABEL":"Verification Information","APOSTILLE_NUMBER_LABEL":"Apostille/Authentication","APOSTILLE_CITY_STATE_OVERRIDE":"HELENA, MT","APOSTILLE_FILING_DATE_LABEL":"Issue Date","APOSTILLE_CITY_STATE_IN_CERTIFIED":true,"NOTARY_EXISTING_FILING":true,"ALLOW_REVOKE_OWN_ACCESS_ONLY":false,"HIDE_CANCEL_ON_ONETIME_DATA_REQUESTS":true,"DATA_REQUESTS_IN_SHOPPING_CART":true,"WQ_ALLOW_EDIT_PENDING_PAYMENT":true,"WQ_CONFIRM_ON_DELETE":true,"WQ_DELETE_CONFIRM_MESSAGE":"Deleting this filing will forfeit any money already paid to the Secretary of State. This action is permanent and cannot be undone, are you sure you would like to delete?","PASS_ITEM_GUIDS_ON_CHECKOUT":true,"FORM_REVISION_HISTORY":true,"CHECKOUT_DISCLAIMER":"By entering your credit card and/or checking account information you (i) state that **you are an authorized user** of the credit card and/or electronic check and that the associated information entered (e.g., account holder name, account number, billing address) is accurate, (ii) **you authorize payment processor to charge the amount you have requested** to your credit card and/or funding account, and (iii) **acknowledge if a charge is declined or reversed you may also be assessed a customary charge** by the payment processor for such transactions.","FARM_BILL_SEARCH_CONFIDENTIAL":"As a registered Farm Bill Buyer with the Montana Secretary of State’s office it is important to maintain the confidentiality of the information contained within the Farm Bill Master List. The Farm Bill Master List reflects personal data, such as Social Security Numbers, which are a key piece of personal identifiable information to assist you in determining the existence of a lien against a specific debtor. The distribution of this information beyond its intended purpose is strictly prohibited.\n\n**The debtor's tax identification number has been hidden for confidentiality reasons. You may continue to search on a tax ID number and return debtors that match your search criteria. The SSN/FEIN must be entered without dashes or spaces.  If you need access to the tax identification number to clearly identify the debtor, please contact the UCC unit at (406) 444-3665.**","VIEW_HISTORY_BUTTON_ALT_TEXT":"View Filings","WIZARD_ERROR_TITLE_MESSAGE":"Form Error","FARM_BILL_SEARCH_INTERACTIVE":true,"USE_FARM_BILL_API":true,"DISALLOW_ASSIGN_SELF_AS_RA":true,"DISALLOW_ASSIGN_SELF_AS_PRINCIPAL":true,"USE_TRADEMARK_OWNER_VALIDATION":true,"USE_ALTERNATIVE_FOREIGN_ADDRESS_LABELS":true,"MY_RECEIPTS_FILTER":[{"type":"dateRange","name":"DATE_RANGE","label":"Date range","defaultValue":{"start":null,"end":null}},{"type":"text","name":"REF_NUM","defaultValue":"","label":"Reference Number"},{"type":"text","name":"RECEIPT_NUM","defaultValue":"","label":"Receipt Id"},{"type":"text","name":"AMOUNT","defaultValue":"","label":"Amount"},{"type":"select","name":"TYPE","defaultValue":"","label":"Payment Type","options":[{"value":"","label":"All"},{"value":"CC","label":"Credit Card"},{"value":"Check","label":"Check"}]}],"MY_RECEIPTS_SHOW_IN_SIDEBAR":true,"SHOW_MY_RECEIPTS_HELPER_TEXT":true,"MY_RECEIPTS_HELPER_LABEL":"About Receipt Search","MY_RECEIPTS_HELPER_TEXT":"You can search for receipts based on their descriptions, including the items paid for on the receipt. Use the filters to search for or filter specific information.","FARM_BILL_SUBLINK":{"label":"Farm Bill","component":"FarmBill","parameter":"farm-bill","path":"/lists/farm-bill","sourceTypeId":0,"myRecordsSearch":false,"allowedRules":["/search/"],"disabled":true,"searchDescription":"To perform a search, enter a debtor name. Your search results may include: exact debtor name, variations of that name and any filing that includes your search criteria. Punctuation is ignored.\n\nYou can click on \"Advanced\" to refine your search. Under “Advanced” you can search by crop, year, county and SSN/FEIN. As a registered Farm Bill Buyer with the Montana Secretary of State’s office it is important to maintain the confidentiality of the information contained within the Farm Bill Master List. The Farm Bill Master List reflects personal data, such as Social Security Numbers, which are a key piece of personal identifiable information to assist you in determining the existence of a lien against a specific debtor. The distribution of this information beyond its intended purpose is strictly prohibited.\n\nThe debtor's tax identification number has been hidden for confidentiality reasons. You may continue to search on a tax ID number and return debtors that match your search criteria. The SSN/FEIN must be entered without dashes or spaces.","searchMustHaveOneOf":["search","UCC_FARM_PRODUCT_ID","COUNTY"],"searchPlaceholder":"Search by debtor name","advancedSearchParameters":[{"type":"ServerMultiComplete","label":"Product code name(s)","name":"UCC_FARM_PRODUCT_ID","defaultValue":"","optionsSrc":"UCC_FARM_PRODUCT_V"},{"type":"MultiComplete","label":"Year or Range of Years","name":"YEAR_NUM","optionsSrc":"years","startYear":"1968","defaultValue":[],"preMergeOptions":[{"value":"ALL","label":"All"}]},{"type":"serverSelect","label":"State","name":"STATE","defaultValue":"MONTANA","optionsSrc":"STATE"},{"type":"ServerMultiComplete","label":"County","name":"COUNTY","defaultValue":[],"optionsSrc":"COUNTY","overrideSubOptionsSrcFromParameterName":"STATE"},{"type":"checkbox","name":"TIN_SEARCH_YN","defaultValue":false,"label":"Tax Identification Number Search"},{"type":"checkbox","name":"TIN_SORT_YN","defaultValue":false,"label":"Unique ID Sort"}]},"ALLOW_ADDRESS_VALIDATION_BYPASS_OPTION":true,"DEFAULT_ADDRESS_VALIDATION_BYPASS_OPTION_CHECKED":true}).LOGIN_UPDATE_ACCOUNT_LINK;
	var LOGIN_ACTIVE_DIRECTORY_LINK = (true);
	var LOGIN_LINK_STYLE = ({"NODE_ENV":"production","BUILD_DATE":"2025-08-27T15:15:31.687Z","BUILD_NUMBER":"Not Provided","GIT_VERSION":"v1.3.0-381-ga81e29b08","GIT_COMMIT_HASH":"a81e29b085c9268ffd96c78eb734365802722741","GIT_BRANCH":"beta","PUBLIC_URL":"","STATE_ABBR":"MT","STATE_NAME":"Montana","STATE_ORG_TITLE":"Secretary of State","LOGIN_HEADER_IMG_PATH":"","HOME_IMG_FILENAME":"montana.jpg","FAVICON_FILE_NAME":"favicon.ico","ALLOW_E_SIGN_ON_CORRECTIONS":true,"THIRD_PARTY_SIGNING_ALLOWED":false,"MY_ACCOUNT_SAVE_AND_CLOSE_BUTTON":true,"IE_DEPRECATED_MESSAGE":"Internet Explorer is not supported. Please select a supported browser below to access this website.","ADDITIONAL_ROUTES":{"dataRequests":true,"farmBill":true,"apostille":true,"externalHelp":"https://sosmt.gov/business/help-center/","systemAdministration":[{"title":"Saved Payments","parameter":"saved-payments","componentName":"SavedPayments"}]},"SUBROUTES":[{"label":"Business","component":"Business","parameter":"business","myWorkQueueSearch":false,"sourceTypeId":54,"searchMustHaveOneOf":["FILING_TYPE_ID","STATUS_ID","STATE","search"],"serverWebSearchDescription":true,"serverWorkQueueDescription":true,"serverMyRecordsDescription":true,"searchPlaceholder":"Search by name or filing number (X########)","allowEmptySearchTerm":true,"requestCertificateAlternateLabel":"Request Information","fileAmendmentButtonLabel":"Filing Actions","advancedSearchParameters":[{"type":"radio","name":"QUERY_TYPE_ID","defaultValue":1010,"options":[{"value":1010,"label":"Starts with"},{"value":1011,"label":"Contains"},{"value":1012,"label":" Word Contains"}]},{"type":"serverSelect","name":"FILING_TYPE_ID","optionsSrc":"FILING_TYPES","label":"Entity Type","placeholder":"All","defaultValue":"0"},{"type":"serverSelect","name":"FILING_SUBTYPE_ID","optionsSrc":"FILING_SUBTYPES","label":"Entity Subtype","overrideSubOptionsSrcFromParameterName":"FILING_TYPE_ID","placeholder":"All","defaultValue":"0"},{"type":"serverSelect","name":"STATUS_ID","optionsSrc":"FILING_STATUS_WITHOUT_ALL","label":"Status","placeholder":"All","defaultValue":"0"},{"type":"serverSelect","name":"STATE","optionsSrc":"STATE","label":"State","placeholder":"All","defaultValue":""},{"type":"serverSelect","name":"COUNTY","optionsSrc":"COUNTY_SUBOPTION","label":"County","overrideSubOptionsSrcFromParameterName":"STATE","placeholder":"All","defaultValue":""},{"type":"checkbox","name":"CRA_SEARCH_YN","defaultValue":false,"label":"Search by Registered Agent PID"},{"type":"dateRange","name":"FILING_DATE","label":"Registration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}},{"type":"dateRange","name":"EXPIRATION_DATE","label":"Expiration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}}],"myRecordsFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Active"},{"value":2,"label":"Inactive"},{"value":3,"label":"Pending"}]},{"type":"dateRange","name":"DATE_RANGE","label":"Date range","defaultValue":{"start":null,"end":null}}],"myWorkQueueFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Approved"},{"value":2,"label":"Pending Online Payment"},{"value":3,"label":"Pending Review"},{"value":4,"label":"Needs Correction"},{"value":5,"label":"Rejected"},{"value":6,"label":"Draft"}]},{"type":"dateRange","name":"DATE_RANGE","label":"Date range","defaultValue":{"start":null,"end":null}}]},{"label":"Notary","component":"Notary","parameter":"notary","sourceTypeId":850,"myWorkQueueSearch":false,"allowEmptySearchTerm":true,"requestCertificateAlternateLabel":"Download Certificate","fileAmendmentButtonLabel":"Filing Actions","hideNameRequestCertificate":true,"hideAddressRequestCertificate":true,"hideRecordUserManagment":true,"searchPlaceholder":"Search by name or commission number","searchMustHaveOneOf":["CITY","search","SERVICE_TYPE"],"advancedParametersStartOpen":true,"searchIsSortable":true,"advancedSearchParameters":[{"type":"radio","name":"STARTS_WITH_YN","defaultValue":false,"options":[{"value":true,"label":"Starts with"},{"value":false,"label":"Contains"}]},{"type":"checkbox","name":"ACTIVE_ONLY_YN","defaultValue":true,"label":"Active entities only"},{"type":"text","name":"CITY","defaultValue":"","label":"City"},{"type":"select","name":"SERVICE_TYPE","label":"Special Services Offered","defaultValue":0,"options":[{"value":0,"label":"(N/A)"},{"value":6165,"label":"In-Person Electronic Notarization (IPEN)"},{"value":6166,"label":"Remote Online Notarization (RON)"},{"value":6167,"label":"Mobile Notary Services"},{"value":6168,"label":"Remote Ink Notarization (RIN)"}]}]},{"label":"Apostille","component":"Apostille","parameter":"apostille","sourceTypeId":720,"myRecordsSearch":false,"myWorkQueueSearch":false,"disabled":false,"allowedRoutes":["/forms-manager/","/queue/","/forms/"]},{"label":"Liens","component":"UCC","parameter":"ucc","sourceTypeId":1999,"myRecordsSearch":true,"myWorkQueueSearch":true,"fileAmendmentButtonLabel":"Filing Actions","searchPlaceholder":"Search by name or file number","disabled":false,"serverWebSearchDescription":true,"myRecordsDescription":"","workQueueDescription":"","searchDescription":"","hideRecordUserManagment":true,"searchLiensCheckout":false,"advancedSearchParameters":[{"type":"radio","name":"STARTS_WITH_YN","defaultValue":false,"options":[{"value":true,"label":"Starts with"},{"value":false,"label":"Contains"}]},{"type":"select","name":"STATUS","defaultValue":"ALL","label":"Status","options":[{"value":"ACTIVE_UNLAPSED","label":"Active (unlapsed)"},{"value":"ACTIVE_LAPSED_UNLAPSED","label":"Active (lapsed and unlapsed)"}]},{"type":"text","name":"EXCLUDE_VALUES","label":"Exclude Debtor Names (comma separated list of names to exclude)","defaultValue":""},{"type":"dateRange","name":"FILING_DATE","label":"Financing Statement Date","defaultValue":{"start":null,"end":null}},{"type":"dateRange","name":"LAPSE_DATE","label":"Lapse Date","defaultValue":{"start":null,"end":null}},{"type":"text","name":"CITY","label":"Debtor City","defaultValue":""}],"myRecordsFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Approved"},{"value":2,"label":"Pending Online Payment"},{"value":3,"label":"Pending Review"}]},{"type":"select","name":"TYPE","defaultValue":0,"label":"Lien Type","options":[{"value":0,"label":"All"},{"value":1,"label":"UCC"},{"value":2,"label":"EFS"},{"value":3,"label":"Title 71"}]}],"myWorkQueueFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Approved"},{"value":2,"label":"Pending Online Payment"},{"value":3,"label":"Pending Review"},{"value":4,"label":"Pending Print and Mail"},{"value":5,"label":"Rejected"},{"value":6,"label":"Draft"}]},{"type":"select","name":"TYPE","defaultValue":0,"label":"Lien Type","options":[{"value":0,"label":"All"},{"value":1,"label":"UCC"},{"value":2,"label":"EFS"},{"value":3,"label":"Title 71"}]}]},{"label":"Copy Request","component":"copies","parameter":"copies","sourceTypeId":2001,"myRecordsSearch":false,"myWorkQueueSearch":false,"disabled":false,"allowedRoutes":["/forms-manager/","/queue/","/forms/"]},{"label":"Trademark","component":"Trademark","parameter":"trademark","sourceTypeId":810,"showRequestCertificate":true,"searchMustHaveOneOf":["search","EXPIRATION_DATE","FILING_DATE"],"allowEmptySearchTerm":true,"requestCertificateAlternateLabel":"Request Information","fileAmendmentButtonLabel":"Filing Actions","advancedSearchParameters":[{"type":"radio","name":"QUERY_TYPE_ID","defaultValue":1010,"options":[{"value":1010,"label":"Starts with"},{"value":1011,"label":"Contains"},{"value":1012,"label":" Word Contains"}]},{"type":"checkbox","name":"OWNER_SEARCH_YN","defaultValue":false,"label":"Search owners"},{"type":"radio","name":"SERVICE_MARK_YN","label":"Mark Type","defaultValue":"","options":[{"value":"","label":"All Marks"},{"value":"Y","label":"Service Mark"},{"value":"N","label":"Trademark"}]},{"type":"serverSelect","name":"STATUS_ID","optionsSrc":"TYPE_V|TRADEMARK_STATUS_TYPE","label":"Status","placeholder":"All","defaultValue":"0"},{"type":"select","name":"DESIGN_TYPE_ID","options":[{"value":0,"label":"All"},{"value":990,"label":"Words Only"},{"value":991,"label":"Design Only"},{"value":992,"label":"Words and Design"}],"label":"Design Type","defaultValue":"0"},{"type":"dateRange","name":"FILING_DATE","label":"Registered Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}},{"type":"dateRange","name":"EXPIRATION_DATE","label":"Expiration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}}]},{"label":"Business Info Request","component":"InfoRequests","parameter":"info-request","sourceTypeId":167,"allowedRoutes":["/forms-manager/","/queue/","/forms/"]},{"label":"Data Requests","component":"DataRequests","parameter":"data-request","sourceTypeId":0,"allowedRoutes":["/forms-manager/"]},{"label":"CRA","component":"CRA","parameter":"cra","sourceTypeId":157,"myRecordsSearch":false,"searchPlaceholder":"Search by name or registered agent number","allowedRoutes":["/forms-manager/","/forms/","/records/","/queue/","/search/"],"allowEmptySearchTerm":true,"fileAmendmentButtonLabel":"Filing Actions","advancedSearchParameters":[{"type":"radio","name":"QUERY_TYPE_ID","defaultValue":1010,"options":[{"value":1010,"label":"Starts with"},{"value":1011,"label":"Contains"},{"value":1012,"label":" Word Contains"}]},{"type":"dateRange","name":"CRA_DATE","label":"Registration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}},{"type":"select","name":"STATUS_ID","label":"Status","defaultValue":0,"options":[{"value":0,"label":"All"},{"value":121,"label":"Active"},{"value":122,"label":"Inactive"}]},{"type":"select","name":"AGENT_TYPE_ID","label":"Agent Type","defaultValue":0,"options":[{"value":0,"label":"All"},{"value":460,"label":"Registered Agent"},{"value":461,"label":"Commercial Registered Agent"}]}]},{"label":"Farm Bill","component":"FarmBill","parameter":"farm-bill","path":"/lists/farm-bill","sourceTypeId":0,"myRecordsSearch":false,"allowedRules":["/search/"],"disabled":true,"searchDescription":"To perform a search, enter a debtor name. Your search results may include: exact debtor name, variations of that name and any filing that includes your search criteria. Punctuation is ignored.\n\nYou can click on \"Advanced\" to refine your search. Under “Advanced” you can search by crop, year, county and SSN/FEIN. As a registered Farm Bill Buyer with the Montana Secretary of State’s office it is important to maintain the confidentiality of the information contained within the Farm Bill Master List. The Farm Bill Master List reflects personal data, such as Social Security Numbers, which are a key piece of personal identifiable information to assist you in determining the existence of a lien against a specific debtor. The distribution of this information beyond its intended purpose is strictly prohibited.\n\nThe debtor's tax identification number has been hidden for confidentiality reasons. You may continue to search on a tax ID number and return debtors that match your search criteria. The SSN/FEIN must be entered without dashes or spaces.","searchMustHaveOneOf":["search","UCC_FARM_PRODUCT_ID","COUNTY"],"searchPlaceholder":"Search by debtor name","advancedSearchParameters":[{"type":"ServerMultiComplete","label":"Product code name(s)","name":"UCC_FARM_PRODUCT_ID","defaultValue":"","optionsSrc":"UCC_FARM_PRODUCT_V"},{"type":"MultiComplete","label":"Year or Range of Years","name":"YEAR_NUM","optionsSrc":"years","startYear":"1968","defaultValue":[],"preMergeOptions":[{"value":"ALL","label":"All"}]},{"type":"serverSelect","label":"State","name":"STATE","defaultValue":"MONTANA","optionsSrc":"STATE"},{"type":"ServerMultiComplete","label":"County","name":"COUNTY","defaultValue":[],"optionsSrc":"COUNTY","overrideSubOptionsSrcFromParameterName":"STATE"},{"type":"checkbox","name":"TIN_SEARCH_YN","defaultValue":false,"label":"Tax Identification Number Search"},{"type":"checkbox","name":"TIN_SORT_YN","defaultValue":false,"label":"Unique ID Sort"}]}],"SYSTEM_NICKNAME":"Online Services Portal","PAYMENT_METHODS":[{"type":"bypass"},{"type":"iTransact"}],"PAYMENT_ALLOW_AMEX":true,"SYSTEM_ID_LABEL":"System Id","DOUBLE_COLUMN_PUBLIC_LOGIN":true,"INTERNAL_USER_MANAGEMENT":true,"ALLOW_PUBLIC_JSON_IMPORT":false,"MAX_FILE_UPLOAD_SIZE":10000000,"REFUND_TEXT":"","RETURN_TO_HOME_ON_LOGOUT":true,"CURRENT_SOS_NAME":"Christi Jacobsen","LOGO_FILENAME":"mt-sos-logo.png","LOGO_ALT":"Christi Jacobsen, Montana Secretary of State","LOGO_FULL_WIDTH":true,"HOME_HIDE_AUTH_HINT":true,"HOME_TITLE":"Montana Secretary of State","CUSTOM_TAB_TITLE":"Official Montana","HOME_SUBTITLE":"Online Business Services","ENTITY_NAME_CONSENT_DESCRIPTION":"","ALLOW_USER_PROFILE_EDITING":true,"COMPARE_FOREIGN_NAME_IN_ENTITY_NAME_VALIDATION":true,"FOREIGN_NAME_FIELD_NAME":"KIMA_PARENT_NAME_INFO","LOGIN_TITLE":"Montana Secretary of State Online Filing Portal Login","PUBLIC_LOGIN_LABEL":"Username","REVERSE_LOGIN_COLUMNS":true,"LOGIN_SEAL_FILENAME":"seal_white.png","SEPARATE_USERNAME_AND_EMAIL":true,"CREATE_ACCOUNT_BUTTON_ALIGN_LEFT":true,"CREATE_ACCOUNT_BUTTON_TEXT":"CREATE AN ACCOUNT","PASSWORD_CUSTOM_ERROR_TEXT":"The password must meet all requirements","ACCOUNT_CREATED_MESSAGE":"Please check your email to verify your account to login and allow a few minutes for this message to arrive. Check your junk/spam folders if you do not find the email in your inbox.","PUBLIC_LOGIN_PLACEHOLDER":" ","DISABLE_DEFAULT_PAYMENT_RADIO":true,"CUSTOM_RESET_PASSWORD_ERROR_MESSAGE":"Username invalid - no account found","PUBLIC_LOGIN_CREATE_DESCRIPTION":"### Existing User:\n\n  - Enter your username and password to login.  \n\n\n  #### - OR -  \n\n\n\n  - Forgot password? Click 'Reset Password' and follow the prompts.\n  - Forgot username? Click 'Forgot Username' and follow the prompts.  \n\n\n  ### New User:\n  ","LOGIN_HELP_LINK":"https://sosmt.gov/business/how-do-i/","LOGIN_HELP_LINK_TEXT":"Need Help?","FORGOT_USERNAME_TEXT":"Forgot Username?","LOGIN_ACTIVE_DIRECTORY_TEXT":"State User Login","MULTIPLE_LOGIN_METHODS":true,"HAS_ACTIVE_DIRECTORY_LOGIN":true,"RESET_PASSWORD_WITH_USERNAME":true,"DOWNLOAD_LINK":true,"SHOW_USERNAME_ACCOUNT_CREATE":true,"SHOW_SCROLL_DOWN_ARROW":true,"SHOW_ADDRESS_ACCOUNT_CREATE":true,"TWO_COLUMN_ACCOUNT_CREATE":true,"RESET_PASSWORD_TIP":"A link to change your password has been sent to your email. Please allow a few minutes for this message to arrive. Please check your junk/spam folders if you do not find the email in your inbox.","FORGOT_PASSWORD_LINK_TEXT":"Reset Password","PHONE_NUMBER_OPTIONAL_ACCOUNT_CREATE":true,"SHOW_REQUIRED_INDICATOR_ACCOUNT_CREATE":true,"PASSWORD_REQUIREMENTS_ACCOUNT_CREATE":"\n    <ul>\n      <li>MUST contain at least 8 characters (12+ recommended)</li>\n      <li>MUST contain at least one uppercase letter.</li>\n      <li>MUST contain at least one lowercase letter.</li>\n      <li>MUST contain at least one number.</li>\n      <li>MUST contain at least one special character (!”#$%&'()*+,-./:;<=>?</li>\n    </ul>\n  ","ALLOW_CERTIFICATION_REQUEST":true,"ALLOW_PUBLIC_CERTIFICATE_REQUEST":true,"ALLOW_COPY_REQUEST":false,"ALLOW_CORRECTION_STYLING":true,"HIDE_DEPRECATION_WARNING":false,"AMEND_ROUTE_PUBLIC":true,"SEAL_FILENAME":"seal.png","SHOPPING_CART":true,"ALLOW_PAYMENT_UPDATE_WITH_EMPTY_CART":true,"RA_EMAIL":true,"RA_WEBSITE":true,"RA_NO_DEFAULT_TYPE":true,"RA_ADDRESS_LABEL":"Street Address","RA_TYPE_SELECTION_DEFAULT":true,"RA_DEFAULT_TYPE":"460","RA_OVERRIDE_TYPE_WITH_DEFAULT":true,"RA_PRINCIPAL_ADDRESS_AMS":true,"UPLOAD_AND_SUBMIT_HIDE_IF_ONE_OPTION":true,"PAYMENT_PROCESSING_MESSAGE":"Your payment is processing - Do not close your browser or click the back button","CHECKOUT_BUTTON_WHEN_PROCESSING_TEXT":"Processing","EFS_CROP_PICKER_NONE_LABEL":"Lien Duration","DISALLOWED_WIZARD_PIECES":["FormationLocale"],"REPEATER_SHOW_EDIT_BUTTON":true,"DATA_REQUEST_PAGE_TITLE":"Data Requests and Subscriptions","DATA_REQUEST_SIDEBAR_LABEL":"Data Requests & Subscriptions","LOGIN_REDIRECTS_TO_EPASS":false,"LOGIN_REDIRECTS_TO_ACTIVE_DIRECTORY":true,"LOGIN_ACTIVE_DIRECTORY_LINK":true,"FETCH_EDIT_USER_LINK":false,"LISTS_FETCH_AVAILABLE_LISTS":true,"POST_WIZARD_SUBMIT_REDIRECT_URL":"/","PIN_REQUEST_ATTESTATIONS":true,"PIN_REQUEST_DESCRIPTION":"Click **Request PIN** to have a new PIN sent to the account holder's email address on file.","OWNERSHIP_REQUEST_DESCRIPTION":"To become an **authorized user** of this record, a current **AUTHORIZED USER** will need to grant you access. To request access, click **Request Access** below.","PIN_REQUEST_SUCCESS_MESSAGE":"The PIN you have requested for this entity has been sent to the email associated with your user account.  You should receive the PIN in approximately 3-5 minutes, depending on your email service provider.","APOSTILLE_HEADER_LABEL":"Verification Information","APOSTILLE_NUMBER_LABEL":"Apostille/Authentication","APOSTILLE_CITY_STATE_OVERRIDE":"HELENA, MT","APOSTILLE_FILING_DATE_LABEL":"Issue Date","APOSTILLE_CITY_STATE_IN_CERTIFIED":true,"NOTARY_EXISTING_FILING":true,"ALLOW_REVOKE_OWN_ACCESS_ONLY":false,"HIDE_CANCEL_ON_ONETIME_DATA_REQUESTS":true,"DATA_REQUESTS_IN_SHOPPING_CART":true,"WQ_ALLOW_EDIT_PENDING_PAYMENT":true,"WQ_CONFIRM_ON_DELETE":true,"WQ_DELETE_CONFIRM_MESSAGE":"Deleting this filing will forfeit any money already paid to the Secretary of State. This action is permanent and cannot be undone, are you sure you would like to delete?","PASS_ITEM_GUIDS_ON_CHECKOUT":true,"FORM_REVISION_HISTORY":true,"CHECKOUT_DISCLAIMER":"By entering your credit card and/or checking account information you (i) state that **you are an authorized user** of the credit card and/or electronic check and that the associated information entered (e.g., account holder name, account number, billing address) is accurate, (ii) **you authorize payment processor to charge the amount you have requested** to your credit card and/or funding account, and (iii) **acknowledge if a charge is declined or reversed you may also be assessed a customary charge** by the payment processor for such transactions.","FARM_BILL_SEARCH_CONFIDENTIAL":"As a registered Farm Bill Buyer with the Montana Secretary of State’s office it is important to maintain the confidentiality of the information contained within the Farm Bill Master List. The Farm Bill Master List reflects personal data, such as Social Security Numbers, which are a key piece of personal identifiable information to assist you in determining the existence of a lien against a specific debtor. The distribution of this information beyond its intended purpose is strictly prohibited.\n\n**The debtor's tax identification number has been hidden for confidentiality reasons. You may continue to search on a tax ID number and return debtors that match your search criteria. The SSN/FEIN must be entered without dashes or spaces.  If you need access to the tax identification number to clearly identify the debtor, please contact the UCC unit at (406) 444-3665.**","VIEW_HISTORY_BUTTON_ALT_TEXT":"View Filings","WIZARD_ERROR_TITLE_MESSAGE":"Form Error","FARM_BILL_SEARCH_INTERACTIVE":true,"USE_FARM_BILL_API":true,"DISALLOW_ASSIGN_SELF_AS_RA":true,"DISALLOW_ASSIGN_SELF_AS_PRINCIPAL":true,"USE_TRADEMARK_OWNER_VALIDATION":true,"USE_ALTERNATIVE_FOREIGN_ADDRESS_LABELS":true,"MY_RECEIPTS_FILTER":[{"type":"dateRange","name":"DATE_RANGE","label":"Date range","defaultValue":{"start":null,"end":null}},{"type":"text","name":"REF_NUM","defaultValue":"","label":"Reference Number"},{"type":"text","name":"RECEIPT_NUM","defaultValue":"","label":"Receipt Id"},{"type":"text","name":"AMOUNT","defaultValue":"","label":"Amount"},{"type":"select","name":"TYPE","defaultValue":"","label":"Payment Type","options":[{"value":"","label":"All"},{"value":"CC","label":"Credit Card"},{"value":"Check","label":"Check"}]}],"MY_RECEIPTS_SHOW_IN_SIDEBAR":true,"SHOW_MY_RECEIPTS_HELPER_TEXT":true,"MY_RECEIPTS_HELPER_LABEL":"About Receipt Search","MY_RECEIPTS_HELPER_TEXT":"You can search for receipts based on their descriptions, including the items paid for on the receipt. Use the filters to search for or filter specific information.","FARM_BILL_SUBLINK":{"label":"Farm Bill","component":"FarmBill","parameter":"farm-bill","path":"/lists/farm-bill","sourceTypeId":0,"myRecordsSearch":false,"allowedRules":["/search/"],"disabled":true,"searchDescription":"To perform a search, enter a debtor name. Your search results may include: exact debtor name, variations of that name and any filing that includes your search criteria. Punctuation is ignored.\n\nYou can click on \"Advanced\" to refine your search. Under “Advanced” you can search by crop, year, county and SSN/FEIN. As a registered Farm Bill Buyer with the Montana Secretary of State’s office it is important to maintain the confidentiality of the information contained within the Farm Bill Master List. The Farm Bill Master List reflects personal data, such as Social Security Numbers, which are a key piece of personal identifiable information to assist you in determining the existence of a lien against a specific debtor. The distribution of this information beyond its intended purpose is strictly prohibited.\n\nThe debtor's tax identification number has been hidden for confidentiality reasons. You may continue to search on a tax ID number and return debtors that match your search criteria. The SSN/FEIN must be entered without dashes or spaces.","searchMustHaveOneOf":["search","UCC_FARM_PRODUCT_ID","COUNTY"],"searchPlaceholder":"Search by debtor name","advancedSearchParameters":[{"type":"ServerMultiComplete","label":"Product code name(s)","name":"UCC_FARM_PRODUCT_ID","defaultValue":"","optionsSrc":"UCC_FARM_PRODUCT_V"},{"type":"MultiComplete","label":"Year or Range of Years","name":"YEAR_NUM","optionsSrc":"years","startYear":"1968","defaultValue":[],"preMergeOptions":[{"value":"ALL","label":"All"}]},{"type":"serverSelect","label":"State","name":"STATE","defaultValue":"MONTANA","optionsSrc":"STATE"},{"type":"ServerMultiComplete","label":"County","name":"COUNTY","defaultValue":[],"optionsSrc":"COUNTY","overrideSubOptionsSrcFromParameterName":"STATE"},{"type":"checkbox","name":"TIN_SEARCH_YN","defaultValue":false,"label":"Tax Identification Number Search"},{"type":"checkbox","name":"TIN_SORT_YN","defaultValue":false,"label":"Unique ID Sort"}]},"ALLOW_ADDRESS_VALIDATION_BYPASS_OPTION":true,"DEFAULT_ADDRESS_VALIDATION_BYPASS_OPTION_CHECKED":true}).LOGIN_LINK_STYLE;
	var INLINE_LOGIN_LINKS = LOGIN_LINK_STYLE === 'inline';
	var GROUPED_LOGIN_LINKS = LOGIN_LINK_STYLE === 'grouped';
	var LOGIN_ALREADY_REGISTERED_LINK = ({"NODE_ENV":"production","BUILD_DATE":"2025-08-27T15:15:31.687Z","BUILD_NUMBER":"Not Provided","GIT_VERSION":"v1.3.0-381-ga81e29b08","GIT_COMMIT_HASH":"a81e29b085c9268ffd96c78eb734365802722741","GIT_BRANCH":"beta","PUBLIC_URL":"","STATE_ABBR":"MT","STATE_NAME":"Montana","STATE_ORG_TITLE":"Secretary of State","LOGIN_HEADER_IMG_PATH":"","HOME_IMG_FILENAME":"montana.jpg","FAVICON_FILE_NAME":"favicon.ico","ALLOW_E_SIGN_ON_CORRECTIONS":true,"THIRD_PARTY_SIGNING_ALLOWED":false,"MY_ACCOUNT_SAVE_AND_CLOSE_BUTTON":true,"IE_DEPRECATED_MESSAGE":"Internet Explorer is not supported. Please select a supported browser below to access this website.","ADDITIONAL_ROUTES":{"dataRequests":true,"farmBill":true,"apostille":true,"externalHelp":"https://sosmt.gov/business/help-center/","systemAdministration":[{"title":"Saved Payments","parameter":"saved-payments","componentName":"SavedPayments"}]},"SUBROUTES":[{"label":"Business","component":"Business","parameter":"business","myWorkQueueSearch":false,"sourceTypeId":54,"searchMustHaveOneOf":["FILING_TYPE_ID","STATUS_ID","STATE","search"],"serverWebSearchDescription":true,"serverWorkQueueDescription":true,"serverMyRecordsDescription":true,"searchPlaceholder":"Search by name or filing number (X########)","allowEmptySearchTerm":true,"requestCertificateAlternateLabel":"Request Information","fileAmendmentButtonLabel":"Filing Actions","advancedSearchParameters":[{"type":"radio","name":"QUERY_TYPE_ID","defaultValue":1010,"options":[{"value":1010,"label":"Starts with"},{"value":1011,"label":"Contains"},{"value":1012,"label":" Word Contains"}]},{"type":"serverSelect","name":"FILING_TYPE_ID","optionsSrc":"FILING_TYPES","label":"Entity Type","placeholder":"All","defaultValue":"0"},{"type":"serverSelect","name":"FILING_SUBTYPE_ID","optionsSrc":"FILING_SUBTYPES","label":"Entity Subtype","overrideSubOptionsSrcFromParameterName":"FILING_TYPE_ID","placeholder":"All","defaultValue":"0"},{"type":"serverSelect","name":"STATUS_ID","optionsSrc":"FILING_STATUS_WITHOUT_ALL","label":"Status","placeholder":"All","defaultValue":"0"},{"type":"serverSelect","name":"STATE","optionsSrc":"STATE","label":"State","placeholder":"All","defaultValue":""},{"type":"serverSelect","name":"COUNTY","optionsSrc":"COUNTY_SUBOPTION","label":"County","overrideSubOptionsSrcFromParameterName":"STATE","placeholder":"All","defaultValue":""},{"type":"checkbox","name":"CRA_SEARCH_YN","defaultValue":false,"label":"Search by Registered Agent PID"},{"type":"dateRange","name":"FILING_DATE","label":"Registration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}},{"type":"dateRange","name":"EXPIRATION_DATE","label":"Expiration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}}],"myRecordsFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Active"},{"value":2,"label":"Inactive"},{"value":3,"label":"Pending"}]},{"type":"dateRange","name":"DATE_RANGE","label":"Date range","defaultValue":{"start":null,"end":null}}],"myWorkQueueFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Approved"},{"value":2,"label":"Pending Online Payment"},{"value":3,"label":"Pending Review"},{"value":4,"label":"Needs Correction"},{"value":5,"label":"Rejected"},{"value":6,"label":"Draft"}]},{"type":"dateRange","name":"DATE_RANGE","label":"Date range","defaultValue":{"start":null,"end":null}}]},{"label":"Notary","component":"Notary","parameter":"notary","sourceTypeId":850,"myWorkQueueSearch":false,"allowEmptySearchTerm":true,"requestCertificateAlternateLabel":"Download Certificate","fileAmendmentButtonLabel":"Filing Actions","hideNameRequestCertificate":true,"hideAddressRequestCertificate":true,"hideRecordUserManagment":true,"searchPlaceholder":"Search by name or commission number","searchMustHaveOneOf":["CITY","search","SERVICE_TYPE"],"advancedParametersStartOpen":true,"searchIsSortable":true,"advancedSearchParameters":[{"type":"radio","name":"STARTS_WITH_YN","defaultValue":false,"options":[{"value":true,"label":"Starts with"},{"value":false,"label":"Contains"}]},{"type":"checkbox","name":"ACTIVE_ONLY_YN","defaultValue":true,"label":"Active entities only"},{"type":"text","name":"CITY","defaultValue":"","label":"City"},{"type":"select","name":"SERVICE_TYPE","label":"Special Services Offered","defaultValue":0,"options":[{"value":0,"label":"(N/A)"},{"value":6165,"label":"In-Person Electronic Notarization (IPEN)"},{"value":6166,"label":"Remote Online Notarization (RON)"},{"value":6167,"label":"Mobile Notary Services"},{"value":6168,"label":"Remote Ink Notarization (RIN)"}]}]},{"label":"Apostille","component":"Apostille","parameter":"apostille","sourceTypeId":720,"myRecordsSearch":false,"myWorkQueueSearch":false,"disabled":false,"allowedRoutes":["/forms-manager/","/queue/","/forms/"]},{"label":"Liens","component":"UCC","parameter":"ucc","sourceTypeId":1999,"myRecordsSearch":true,"myWorkQueueSearch":true,"fileAmendmentButtonLabel":"Filing Actions","searchPlaceholder":"Search by name or file number","disabled":false,"serverWebSearchDescription":true,"myRecordsDescription":"","workQueueDescription":"","searchDescription":"","hideRecordUserManagment":true,"searchLiensCheckout":false,"advancedSearchParameters":[{"type":"radio","name":"STARTS_WITH_YN","defaultValue":false,"options":[{"value":true,"label":"Starts with"},{"value":false,"label":"Contains"}]},{"type":"select","name":"STATUS","defaultValue":"ALL","label":"Status","options":[{"value":"ACTIVE_UNLAPSED","label":"Active (unlapsed)"},{"value":"ACTIVE_LAPSED_UNLAPSED","label":"Active (lapsed and unlapsed)"}]},{"type":"text","name":"EXCLUDE_VALUES","label":"Exclude Debtor Names (comma separated list of names to exclude)","defaultValue":""},{"type":"dateRange","name":"FILING_DATE","label":"Financing Statement Date","defaultValue":{"start":null,"end":null}},{"type":"dateRange","name":"LAPSE_DATE","label":"Lapse Date","defaultValue":{"start":null,"end":null}},{"type":"text","name":"CITY","label":"Debtor City","defaultValue":""}],"myRecordsFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Approved"},{"value":2,"label":"Pending Online Payment"},{"value":3,"label":"Pending Review"}]},{"type":"select","name":"TYPE","defaultValue":0,"label":"Lien Type","options":[{"value":0,"label":"All"},{"value":1,"label":"UCC"},{"value":2,"label":"EFS"},{"value":3,"label":"Title 71"}]}],"myWorkQueueFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Approved"},{"value":2,"label":"Pending Online Payment"},{"value":3,"label":"Pending Review"},{"value":4,"label":"Pending Print and Mail"},{"value":5,"label":"Rejected"},{"value":6,"label":"Draft"}]},{"type":"select","name":"TYPE","defaultValue":0,"label":"Lien Type","options":[{"value":0,"label":"All"},{"value":1,"label":"UCC"},{"value":2,"label":"EFS"},{"value":3,"label":"Title 71"}]}]},{"label":"Copy Request","component":"copies","parameter":"copies","sourceTypeId":2001,"myRecordsSearch":false,"myWorkQueueSearch":false,"disabled":false,"allowedRoutes":["/forms-manager/","/queue/","/forms/"]},{"label":"Trademark","component":"Trademark","parameter":"trademark","sourceTypeId":810,"showRequestCertificate":true,"searchMustHaveOneOf":["search","EXPIRATION_DATE","FILING_DATE"],"allowEmptySearchTerm":true,"requestCertificateAlternateLabel":"Request Information","fileAmendmentButtonLabel":"Filing Actions","advancedSearchParameters":[{"type":"radio","name":"QUERY_TYPE_ID","defaultValue":1010,"options":[{"value":1010,"label":"Starts with"},{"value":1011,"label":"Contains"},{"value":1012,"label":" Word Contains"}]},{"type":"checkbox","name":"OWNER_SEARCH_YN","defaultValue":false,"label":"Search owners"},{"type":"radio","name":"SERVICE_MARK_YN","label":"Mark Type","defaultValue":"","options":[{"value":"","label":"All Marks"},{"value":"Y","label":"Service Mark"},{"value":"N","label":"Trademark"}]},{"type":"serverSelect","name":"STATUS_ID","optionsSrc":"TYPE_V|TRADEMARK_STATUS_TYPE","label":"Status","placeholder":"All","defaultValue":"0"},{"type":"select","name":"DESIGN_TYPE_ID","options":[{"value":0,"label":"All"},{"value":990,"label":"Words Only"},{"value":991,"label":"Design Only"},{"value":992,"label":"Words and Design"}],"label":"Design Type","defaultValue":"0"},{"type":"dateRange","name":"FILING_DATE","label":"Registered Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}},{"type":"dateRange","name":"EXPIRATION_DATE","label":"Expiration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}}]},{"label":"Business Info Request","component":"InfoRequests","parameter":"info-request","sourceTypeId":167,"allowedRoutes":["/forms-manager/","/queue/","/forms/"]},{"label":"Data Requests","component":"DataRequests","parameter":"data-request","sourceTypeId":0,"allowedRoutes":["/forms-manager/"]},{"label":"CRA","component":"CRA","parameter":"cra","sourceTypeId":157,"myRecordsSearch":false,"searchPlaceholder":"Search by name or registered agent number","allowedRoutes":["/forms-manager/","/forms/","/records/","/queue/","/search/"],"allowEmptySearchTerm":true,"fileAmendmentButtonLabel":"Filing Actions","advancedSearchParameters":[{"type":"radio","name":"QUERY_TYPE_ID","defaultValue":1010,"options":[{"value":1010,"label":"Starts with"},{"value":1011,"label":"Contains"},{"value":1012,"label":" Word Contains"}]},{"type":"dateRange","name":"CRA_DATE","label":"Registration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}},{"type":"select","name":"STATUS_ID","label":"Status","defaultValue":0,"options":[{"value":0,"label":"All"},{"value":121,"label":"Active"},{"value":122,"label":"Inactive"}]},{"type":"select","name":"AGENT_TYPE_ID","label":"Agent Type","defaultValue":0,"options":[{"value":0,"label":"All"},{"value":460,"label":"Registered Agent"},{"value":461,"label":"Commercial Registered Agent"}]}]},{"label":"Farm Bill","component":"FarmBill","parameter":"farm-bill","path":"/lists/farm-bill","sourceTypeId":0,"myRecordsSearch":false,"allowedRules":["/search/"],"disabled":true,"searchDescription":"To perform a search, enter a debtor name. Your search results may include: exact debtor name, variations of that name and any filing that includes your search criteria. Punctuation is ignored.\n\nYou can click on \"Advanced\" to refine your search. Under “Advanced” you can search by crop, year, county and SSN/FEIN. As a registered Farm Bill Buyer with the Montana Secretary of State’s office it is important to maintain the confidentiality of the information contained within the Farm Bill Master List. The Farm Bill Master List reflects personal data, such as Social Security Numbers, which are a key piece of personal identifiable information to assist you in determining the existence of a lien against a specific debtor. The distribution of this information beyond its intended purpose is strictly prohibited.\n\nThe debtor's tax identification number has been hidden for confidentiality reasons. You may continue to search on a tax ID number and return debtors that match your search criteria. The SSN/FEIN must be entered without dashes or spaces.","searchMustHaveOneOf":["search","UCC_FARM_PRODUCT_ID","COUNTY"],"searchPlaceholder":"Search by debtor name","advancedSearchParameters":[{"type":"ServerMultiComplete","label":"Product code name(s)","name":"UCC_FARM_PRODUCT_ID","defaultValue":"","optionsSrc":"UCC_FARM_PRODUCT_V"},{"type":"MultiComplete","label":"Year or Range of Years","name":"YEAR_NUM","optionsSrc":"years","startYear":"1968","defaultValue":[],"preMergeOptions":[{"value":"ALL","label":"All"}]},{"type":"serverSelect","label":"State","name":"STATE","defaultValue":"MONTANA","optionsSrc":"STATE"},{"type":"ServerMultiComplete","label":"County","name":"COUNTY","defaultValue":[],"optionsSrc":"COUNTY","overrideSubOptionsSrcFromParameterName":"STATE"},{"type":"checkbox","name":"TIN_SEARCH_YN","defaultValue":false,"label":"Tax Identification Number Search"},{"type":"checkbox","name":"TIN_SORT_YN","defaultValue":false,"label":"Unique ID Sort"}]}],"SYSTEM_NICKNAME":"Online Services Portal","PAYMENT_METHODS":[{"type":"bypass"},{"type":"iTransact"}],"PAYMENT_ALLOW_AMEX":true,"SYSTEM_ID_LABEL":"System Id","DOUBLE_COLUMN_PUBLIC_LOGIN":true,"INTERNAL_USER_MANAGEMENT":true,"ALLOW_PUBLIC_JSON_IMPORT":false,"MAX_FILE_UPLOAD_SIZE":10000000,"REFUND_TEXT":"","RETURN_TO_HOME_ON_LOGOUT":true,"CURRENT_SOS_NAME":"Christi Jacobsen","LOGO_FILENAME":"mt-sos-logo.png","LOGO_ALT":"Christi Jacobsen, Montana Secretary of State","LOGO_FULL_WIDTH":true,"HOME_HIDE_AUTH_HINT":true,"HOME_TITLE":"Montana Secretary of State","CUSTOM_TAB_TITLE":"Official Montana","HOME_SUBTITLE":"Online Business Services","ENTITY_NAME_CONSENT_DESCRIPTION":"","ALLOW_USER_PROFILE_EDITING":true,"COMPARE_FOREIGN_NAME_IN_ENTITY_NAME_VALIDATION":true,"FOREIGN_NAME_FIELD_NAME":"KIMA_PARENT_NAME_INFO","LOGIN_TITLE":"Montana Secretary of State Online Filing Portal Login","PUBLIC_LOGIN_LABEL":"Username","REVERSE_LOGIN_COLUMNS":true,"LOGIN_SEAL_FILENAME":"seal_white.png","SEPARATE_USERNAME_AND_EMAIL":true,"CREATE_ACCOUNT_BUTTON_ALIGN_LEFT":true,"CREATE_ACCOUNT_BUTTON_TEXT":"CREATE AN ACCOUNT","PASSWORD_CUSTOM_ERROR_TEXT":"The password must meet all requirements","ACCOUNT_CREATED_MESSAGE":"Please check your email to verify your account to login and allow a few minutes for this message to arrive. Check your junk/spam folders if you do not find the email in your inbox.","PUBLIC_LOGIN_PLACEHOLDER":" ","DISABLE_DEFAULT_PAYMENT_RADIO":true,"CUSTOM_RESET_PASSWORD_ERROR_MESSAGE":"Username invalid - no account found","PUBLIC_LOGIN_CREATE_DESCRIPTION":"### Existing User:\n\n  - Enter your username and password to login.  \n\n\n  #### - OR -  \n\n\n\n  - Forgot password? Click 'Reset Password' and follow the prompts.\n  - Forgot username? Click 'Forgot Username' and follow the prompts.  \n\n\n  ### New User:\n  ","LOGIN_HELP_LINK":"https://sosmt.gov/business/how-do-i/","LOGIN_HELP_LINK_TEXT":"Need Help?","FORGOT_USERNAME_TEXT":"Forgot Username?","LOGIN_ACTIVE_DIRECTORY_TEXT":"State User Login","MULTIPLE_LOGIN_METHODS":true,"HAS_ACTIVE_DIRECTORY_LOGIN":true,"RESET_PASSWORD_WITH_USERNAME":true,"DOWNLOAD_LINK":true,"SHOW_USERNAME_ACCOUNT_CREATE":true,"SHOW_SCROLL_DOWN_ARROW":true,"SHOW_ADDRESS_ACCOUNT_CREATE":true,"TWO_COLUMN_ACCOUNT_CREATE":true,"RESET_PASSWORD_TIP":"A link to change your password has been sent to your email. Please allow a few minutes for this message to arrive. Please check your junk/spam folders if you do not find the email in your inbox.","FORGOT_PASSWORD_LINK_TEXT":"Reset Password","PHONE_NUMBER_OPTIONAL_ACCOUNT_CREATE":true,"SHOW_REQUIRED_INDICATOR_ACCOUNT_CREATE":true,"PASSWORD_REQUIREMENTS_ACCOUNT_CREATE":"\n    <ul>\n      <li>MUST contain at least 8 characters (12+ recommended)</li>\n      <li>MUST contain at least one uppercase letter.</li>\n      <li>MUST contain at least one lowercase letter.</li>\n      <li>MUST contain at least one number.</li>\n      <li>MUST contain at least one special character (!”#$%&'()*+,-./:;<=>?</li>\n    </ul>\n  ","ALLOW_CERTIFICATION_REQUEST":true,"ALLOW_PUBLIC_CERTIFICATE_REQUEST":true,"ALLOW_COPY_REQUEST":false,"ALLOW_CORRECTION_STYLING":true,"HIDE_DEPRECATION_WARNING":false,"AMEND_ROUTE_PUBLIC":true,"SEAL_FILENAME":"seal.png","SHOPPING_CART":true,"ALLOW_PAYMENT_UPDATE_WITH_EMPTY_CART":true,"RA_EMAIL":true,"RA_WEBSITE":true,"RA_NO_DEFAULT_TYPE":true,"RA_ADDRESS_LABEL":"Street Address","RA_TYPE_SELECTION_DEFAULT":true,"RA_DEFAULT_TYPE":"460","RA_OVERRIDE_TYPE_WITH_DEFAULT":true,"RA_PRINCIPAL_ADDRESS_AMS":true,"UPLOAD_AND_SUBMIT_HIDE_IF_ONE_OPTION":true,"PAYMENT_PROCESSING_MESSAGE":"Your payment is processing - Do not close your browser or click the back button","CHECKOUT_BUTTON_WHEN_PROCESSING_TEXT":"Processing","EFS_CROP_PICKER_NONE_LABEL":"Lien Duration","DISALLOWED_WIZARD_PIECES":["FormationLocale"],"REPEATER_SHOW_EDIT_BUTTON":true,"DATA_REQUEST_PAGE_TITLE":"Data Requests and Subscriptions","DATA_REQUEST_SIDEBAR_LABEL":"Data Requests & Subscriptions","LOGIN_REDIRECTS_TO_EPASS":false,"LOGIN_REDIRECTS_TO_ACTIVE_DIRECTORY":true,"LOGIN_ACTIVE_DIRECTORY_LINK":true,"FETCH_EDIT_USER_LINK":false,"LISTS_FETCH_AVAILABLE_LISTS":true,"POST_WIZARD_SUBMIT_REDIRECT_URL":"/","PIN_REQUEST_ATTESTATIONS":true,"PIN_REQUEST_DESCRIPTION":"Click **Request PIN** to have a new PIN sent to the account holder's email address on file.","OWNERSHIP_REQUEST_DESCRIPTION":"To become an **authorized user** of this record, a current **AUTHORIZED USER** will need to grant you access. To request access, click **Request Access** below.","PIN_REQUEST_SUCCESS_MESSAGE":"The PIN you have requested for this entity has been sent to the email associated with your user account.  You should receive the PIN in approximately 3-5 minutes, depending on your email service provider.","APOSTILLE_HEADER_LABEL":"Verification Information","APOSTILLE_NUMBER_LABEL":"Apostille/Authentication","APOSTILLE_CITY_STATE_OVERRIDE":"HELENA, MT","APOSTILLE_FILING_DATE_LABEL":"Issue Date","APOSTILLE_CITY_STATE_IN_CERTIFIED":true,"NOTARY_EXISTING_FILING":true,"ALLOW_REVOKE_OWN_ACCESS_ONLY":false,"HIDE_CANCEL_ON_ONETIME_DATA_REQUESTS":true,"DATA_REQUESTS_IN_SHOPPING_CART":true,"WQ_ALLOW_EDIT_PENDING_PAYMENT":true,"WQ_CONFIRM_ON_DELETE":true,"WQ_DELETE_CONFIRM_MESSAGE":"Deleting this filing will forfeit any money already paid to the Secretary of State. This action is permanent and cannot be undone, are you sure you would like to delete?","PASS_ITEM_GUIDS_ON_CHECKOUT":true,"FORM_REVISION_HISTORY":true,"CHECKOUT_DISCLAIMER":"By entering your credit card and/or checking account information you (i) state that **you are an authorized user** of the credit card and/or electronic check and that the associated information entered (e.g., account holder name, account number, billing address) is accurate, (ii) **you authorize payment processor to charge the amount you have requested** to your credit card and/or funding account, and (iii) **acknowledge if a charge is declined or reversed you may also be assessed a customary charge** by the payment processor for such transactions.","FARM_BILL_SEARCH_CONFIDENTIAL":"As a registered Farm Bill Buyer with the Montana Secretary of State’s office it is important to maintain the confidentiality of the information contained within the Farm Bill Master List. The Farm Bill Master List reflects personal data, such as Social Security Numbers, which are a key piece of personal identifiable information to assist you in determining the existence of a lien against a specific debtor. The distribution of this information beyond its intended purpose is strictly prohibited.\n\n**The debtor's tax identification number has been hidden for confidentiality reasons. You may continue to search on a tax ID number and return debtors that match your search criteria. The SSN/FEIN must be entered without dashes or spaces.  If you need access to the tax identification number to clearly identify the debtor, please contact the UCC unit at (406) 444-3665.**","VIEW_HISTORY_BUTTON_ALT_TEXT":"View Filings","WIZARD_ERROR_TITLE_MESSAGE":"Form Error","FARM_BILL_SEARCH_INTERACTIVE":true,"USE_FARM_BILL_API":true,"DISALLOW_ASSIGN_SELF_AS_RA":true,"DISALLOW_ASSIGN_SELF_AS_PRINCIPAL":true,"USE_TRADEMARK_OWNER_VALIDATION":true,"USE_ALTERNATIVE_FOREIGN_ADDRESS_LABELS":true,"MY_RECEIPTS_FILTER":[{"type":"dateRange","name":"DATE_RANGE","label":"Date range","defaultValue":{"start":null,"end":null}},{"type":"text","name":"REF_NUM","defaultValue":"","label":"Reference Number"},{"type":"text","name":"RECEIPT_NUM","defaultValue":"","label":"Receipt Id"},{"type":"text","name":"AMOUNT","defaultValue":"","label":"Amount"},{"type":"select","name":"TYPE","defaultValue":"","label":"Payment Type","options":[{"value":"","label":"All"},{"value":"CC","label":"Credit Card"},{"value":"Check","label":"Check"}]}],"MY_RECEIPTS_SHOW_IN_SIDEBAR":true,"SHOW_MY_RECEIPTS_HELPER_TEXT":true,"MY_RECEIPTS_HELPER_LABEL":"About Receipt Search","MY_RECEIPTS_HELPER_TEXT":"You can search for receipts based on their descriptions, including the items paid for on the receipt. Use the filters to search for or filter specific information.","FARM_BILL_SUBLINK":{"label":"Farm Bill","component":"FarmBill","parameter":"farm-bill","path":"/lists/farm-bill","sourceTypeId":0,"myRecordsSearch":false,"allowedRules":["/search/"],"disabled":true,"searchDescription":"To perform a search, enter a debtor name. Your search results may include: exact debtor name, variations of that name and any filing that includes your search criteria. Punctuation is ignored.\n\nYou can click on \"Advanced\" to refine your search. Under “Advanced” you can search by crop, year, county and SSN/FEIN. As a registered Farm Bill Buyer with the Montana Secretary of State’s office it is important to maintain the confidentiality of the information contained within the Farm Bill Master List. The Farm Bill Master List reflects personal data, such as Social Security Numbers, which are a key piece of personal identifiable information to assist you in determining the existence of a lien against a specific debtor. The distribution of this information beyond its intended purpose is strictly prohibited.\n\nThe debtor's tax identification number has been hidden for confidentiality reasons. You may continue to search on a tax ID number and return debtors that match your search criteria. The SSN/FEIN must be entered without dashes or spaces.","searchMustHaveOneOf":["search","UCC_FARM_PRODUCT_ID","COUNTY"],"searchPlaceholder":"Search by debtor name","advancedSearchParameters":[{"type":"ServerMultiComplete","label":"Product code name(s)","name":"UCC_FARM_PRODUCT_ID","defaultValue":"","optionsSrc":"UCC_FARM_PRODUCT_V"},{"type":"MultiComplete","label":"Year or Range of Years","name":"YEAR_NUM","optionsSrc":"years","startYear":"1968","defaultValue":[],"preMergeOptions":[{"value":"ALL","label":"All"}]},{"type":"serverSelect","label":"State","name":"STATE","defaultValue":"MONTANA","optionsSrc":"STATE"},{"type":"ServerMultiComplete","label":"County","name":"COUNTY","defaultValue":[],"optionsSrc":"COUNTY","overrideSubOptionsSrcFromParameterName":"STATE"},{"type":"checkbox","name":"TIN_SEARCH_YN","defaultValue":false,"label":"Tax Identification Number Search"},{"type":"checkbox","name":"TIN_SORT_YN","defaultValue":false,"label":"Unique ID Sort"}]},"ALLOW_ADDRESS_VALIDATION_BYPASS_OPTION":true,"DEFAULT_ADDRESS_VALIDATION_BYPASS_OPTION_CHECKED":true}).LOGIN_ALREADY_REGISTERED_LINK;
	
	var LoginForm = function (_Component3) {
	  _inherits(LoginForm, _Component3);
	
	  function LoginForm() {
	    var _ref5;
	
	    var _temp2, _this4, _ret2;
	
	    _classCallCheck(this, LoginForm);
	
	    for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
	      args[_key2] = arguments[_key2];
	    }
	
	    return _ret2 = (_temp2 = (_this4 = _possibleConstructorReturn(this, (_ref5 = LoginForm.__proto__ || Object.getPrototypeOf(LoginForm)).call.apply(_ref5, [this].concat(args))), _this4), _this4.componentDidMount = function () {
	      _this4.username.focus();
	    }, _this4.getUsername = function () {
	      return _this4.username.value;
	    }, _this4.getPassword = function () {
	      return _this4.password.value;
	    }, _temp2), _possibleConstructorReturn(_this4, _ret2);
	  }
	
	  _createClass(LoginForm, [{
	    key: 'render',
	    value: function render() {
	      var _this5 = this;
	
	      var _props2 = this.props,
	          checkEnter = _props2.checkEnter,
	          error = _props2.error,
	          login = _props2.login,
	          startAccountCreation = _props2.startAccountCreation,
	          startForgotPassword = _props2.startForgotPassword,
	          startForgotUsername = _props2.startForgotUsername;
	
	      return _react2.default.createElement(
	        'form',
	        { className: 'login' },
	        LOGIN_ALREADY_REGISTERED_LINK && _react2.default.createElement(
	          'h5',
	          { className: 'subtitle' },
	          'Already Registered - ',
	          _react2.default.createElement(
	            'a',
	            { href: LOGIN_ALREADY_REGISTERED_LINK },
	            'Not sure?'
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'field' },
	          _react2.default.createElement(
	            'label',
	            { htmlFor: 'username' },
	            ("Username") || 'User ID'
	          ),
	          _react2.default.createElement('input', {
	            type: 'text',
	            ref: function ref(_ref6) {
	              _this5.username = _ref6;
	            },
	            id: 'username',
	            name: 'username',
	            onKeyDown: checkEnter,
	            placeholder: (" ") || 'example@email.com'
	          }),
	          LOGIN_FORGOT_USERNAME_LINK && INLINE_LOGIN_LINKS && _react2.default.createElement(
	            'div',
	            { className: 'flex-right' },
	            _react2.default.createElement(
	              'a',
	              { target: 'blank', href: LOGIN_FORGOT_USERNAME_LINK },
	              LOGIN_FORGOT_USERNAME_LABEL || 'Forgot username?'
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'field' },
	          _react2.default.createElement(
	            'label',
	            { htmlFor: 'password' },
	            'Password'
	          ),
	          _react2.default.createElement('input', {
	            type: 'password',
	            ref: function ref(_ref7) {
	              _this5.password = _ref7;
	            },
	            id: 'password',
	            name: 'password',
	            onKeyDown: checkEnter
	          }),
	          LOGIN_FORGOT_PASSWORD_LINK && INLINE_LOGIN_LINKS && _react2.default.createElement(
	            'div',
	            { className: 'flex-right' },
	            _react2.default.createElement(
	              'a',
	              { target: 'blank', href: LOGIN_FORGOT_PASSWORD_LINK },
	              LOGIN_FORGOT_PASSWORD_LABEL || 'Forgot password?'
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'button-wrapper' },
	          error && _react2.default.createElement(
	            'span',
	            { className: 'error animated fadeIn fast-animation' },
	            _react2.default.createElement(_Markdown2.default, { source: error, className: 'markdown' })
	          ),
	          _react2.default.createElement(
	            'button',
	            {
	              type: 'button'
	              // disabled={error ? true : false}
	              , className: 'btn-raised btn-light-primary submit',
	              onClick: login
	            },
	            _react2.default.createElement('span', { className: 'icon icon-lock' }),
	            '\xA0 LOGIN'
	          ),
	          LOGIN_FORGOT_PASSWORD_LINK && GROUPED_LOGIN_LINKS && _react2.default.createElement(
	            'a',
	            { target: 'blank', href: LOGIN_FORGOT_PASSWORD_LINK },
	            'Forgot password?'
	          ),
	          LOGIN_FORGOT_USERNAME_LINK && GROUPED_LOGIN_LINKS && _react2.default.createElement(
	            'a',
	            { target: 'blank', href: LOGIN_FORGOT_USERNAME_LINK },
	            'Forgot username?'
	          ),
	          LOGIN_UPDATE_ACCOUNT_LINK && (GROUPED_LOGIN_LINKS || INLINE_LOGIN_LINKS) && _react2.default.createElement(
	            'a',
	            { target: 'blank', href: LOGIN_UPDATE_ACCOUNT_LINK },
	            'Update your account'
	          ),
	          LOGIN_ACTIVE_DIRECTORY_LINK && GROUPED_LOGIN_LINKS && _react2.default.createElement(
	            'a',
	            { target: 'blank', href: LOGIN_ACTIVE_DIRECTORY_LINK },
	            'State User Login'
	          )
	        ),
	        (true) && _react2.default.createElement(
	          'div',
	          { className: 'button-wrapper create-wrapper' },
	          _react2.default.createElement(
	            'button',
	            { type: 'button', className: 'create-account-button', onClick: startForgotPassword },
	            ("Reset Password") || 'Forgot or Change Password?'
	          )
	        ),
	        (true) && ("Forgot Username?") && _react2.default.createElement(
	          'div',
	          { className: 'button-wrapper create-wrapper' },
	          _react2.default.createElement(
	            'button',
	            { type: 'button', className: 'create-account-button', onClick: startForgotUsername },
	            ("Forgot Username?") || 'Forgot Username?'
	          )
	        ),
	        (true) && ("State User Login") && _react2.default.createElement(
	          'div',
	          { className: 'button-wrapper create-wrapper' },
	          _react2.default.createElement(
	            'button',
	            { type: 'button', className: 'create-account-button', onClick: function onClick(e) {
	                e.preventDefault();
	                _this5.props.setStateUser(true);
	                _this5.props.toggleLoginModal(false);
	                _this5.props.pathname.toLowerCase() !== '/auth' && _store.history.push((0, _utilities.getAuthRedirectUrl)({ pathname: _this5.props.pathname, search: _this5.props.search }));
	              } },
	            ("State User Login") || 'State User Login'
	          )
	        ),
	        (true) && !REVERSE_LOGIN_COLUMNS && _react2.default.createElement(
	          'div',
	          { className: 'button-wrapper create-wrapper' },
	          _react2.default.createElement(
	            'button',
	            { type: 'button', className: 'create-account-button', onClick: startAccountCreation },
	            ("CREATE AN ACCOUNT") || 'Create an account'
	          )
	        )
	      );
	    }
	  }]);
	
	  return LoginForm;
	}(_react.Component);
	
	var LoginInformationColumn = function LoginInformationColumn(_ref8) {
	  var startAccountCreation = _ref8.startAccountCreation,
	      banner = _ref8.banner;
	  return _react2.default.createElement(
	    'div',
	    { className: 'col-sm-6 login-column right' },
	    banner && _react2.default.createElement(
	      'div',
	      { className: 'banner span-2-columns' },
	      ("seal_white.png") && _react2.default.createElement('img', { src: stateSeal, alt:  true ? ("Montana") + ' state seal' : 'state seal' }),
	      banner
	    ),
	    _react2.default.createElement(
	      'div',
	      {
	        className: 'instructions markdown ' + (banner ? 'has-banner' : '') + ' ' + ( true ? 'has-own-instructions' : '')
	      },
	       true ? _react2.default.createElement(
	        _react2.default.Fragment,
	        null,
	        _react2.default.createElement(_Markdown2.default, {
	          source: ("### Existing User:\n\n  - Enter your username and password to login.  \n\n\n  #### - OR -  \n\n\n\n  - Forgot password? Click 'Reset Password' and follow the prompts.\n  - Forgot username? Click 'Forgot Username' and follow the prompts.  \n\n\n  ### New User:\n  "),
	          className: 'markdown markdown-instructions'
	        }),
	        _react2.default.createElement(
	          'div',
	          { className:  false ? 'right-align' : '' },
	          _react2.default.createElement(
	            'button',
	            {
	              type: 'button',
	              className: 'btn btn-raised btn-light-primary submit',
	              style: { marginTop: 9, marginBottom: 12 },
	              onClick: startAccountCreation
	            },
	            ("CREATE AN ACCOUNT") || 'Create an account'
	          ),
	          ("https://sosmt.gov/business/how-do-i/") && _react2.default.createElement(
	            'a',
	            { href: ("https://sosmt.gov/business/how-do-i/") },
	            ("Need Help?")
	          )
	        )
	      ) : _react2.default.createElement(
	        _react2.default.Fragment,
	        null,
	        _react2.default.createElement(
	          'h6',
	          null,
	          'New to ',
	          process.env.STATE_NAME,
	          ' Online Services?'
	        ),
	        _react2.default.createElement(
	          'p',
	          null,
	          'Register now!'
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'login-create-buttons-wrapper' },
	          _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(
	              'a',
	              { href: LOGIN_CREATE_PERSONAL_LINK, className: 'btn btn-raised btn-primary' },
	              'Personal Account'
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(
	              'a',
	              { href: LOGIN_CREATE_BUSINESS_LINK, className: 'btn btn-raised btn-primary' },
	              'Business Account'
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'p',
	          null,
	          'Benefits of ',
	          process.env.STATE_NAME,
	          ' Login'
	        ),
	        _react2.default.createElement(
	          'ul',
	          null,
	          _react2.default.createElement(
	            'li',
	            null,
	            'One ',
	            process.env.STATE_NAME,
	            ' Login and password to access multiple',
	            ' ',
	            _react2.default.createElement(
	              'a',
	              { href: 'https://www.nd.gov/government/citizen-services', target: '_blank' },
	              process.env.STATE_ABBR,
	              ' Online Services'
	            )
	          ),
	          _react2.default.createElement(
	            'li',
	            null,
	            'Register once for secure access to State services'
	          )
	        ),
	        _react2.default.createElement(
	          'p',
	          null,
	          'Need help? Read through the',
	          ' ',
	          _react2.default.createElement(
	            'a',
	            { target: '_blank', href: 'https://apps.nd.gov/itd/ldap/info.htm' },
	            'FAQ'
	          )
	        )
	      )
	    )
	  );
	};
	
	var AdminLogin = exports.AdminLogin = function (_Component4) {
	  _inherits(AdminLogin, _Component4);
	
	  function AdminLogin() {
	    var _ref9;
	
	    var _temp3, _this6, _ret3;
	
	    _classCallCheck(this, AdminLogin);
	
	    for (var _len3 = arguments.length, args = Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
	      args[_key3] = arguments[_key3];
	    }
	
	    return _ret3 = (_temp3 = (_this6 = _possibleConstructorReturn(this, (_ref9 = AdminLogin.__proto__ || Object.getPrototypeOf(AdminLogin)).call.apply(_ref9, [this].concat(args))), _this6), _this6.state = { error: null }, _this6.componentDidMount = function () {
	      if (_this6.email) {
	        _this6.email.focus();
	      }
	    }, _this6.loginAdmin = function () {
	      _this6.props.loginAppUser({ username: _this6.email.value, password: _this6.pass.value }, function (success, err) {
	        if (success) {
	          var from = _this6.getFrom();
	          _store.history.replace(from);
	        } else {
	          _this6.setState({ error: err });
	        }
	      });
	    }, _this6.getFrom = function () {
	      var _parseUrlQuery2 = (0, _utilities.parseUrlQuery)(_this6.props.location.search),
	          _parseUrlQuery2$from = _parseUrlQuery2.from,
	          from = _parseUrlQuery2$from === undefined ? "" : _parseUrlQuery2$from,
	          _parseUrlQuery2$searc = _parseUrlQuery2.search,
	          search = _parseUrlQuery2$searc === undefined ? "" : _parseUrlQuery2$searc;
	
	      return _this6.props.location.search !== '' ? '' + from + (search ? '&search=' + search : "") : '/';
	    }, _this6.checkEnter = function (_ref10) {
	      var keyCode = _ref10.keyCode;
	
	      if (keyCode === 13) {
	        if (_this6.state.error === null) {
	          _this6.loginAdmin();
	        }
	      } else {
	        if (_this6.state.error) {
	          _this6.setState({ error: null });
	        }
	      }
	    }, _temp3), _possibleConstructorReturn(_this6, _ret3);
	  }
	
	  _createClass(AdminLogin, [{
	    key: 'render',
	    value: function render() {
	      var _this7 = this;
	
	      var loggedIn = this.props.loggedIn;
	
	      if (({"NODE_ENV":"production","BUILD_DATE":"2025-08-27T15:15:31.687Z","BUILD_NUMBER":"Not Provided","GIT_VERSION":"v1.3.0-381-ga81e29b08","GIT_COMMIT_HASH":"a81e29b085c9268ffd96c78eb734365802722741","GIT_BRANCH":"beta","PUBLIC_URL":"","STATE_ABBR":"MT","STATE_NAME":"Montana","STATE_ORG_TITLE":"Secretary of State","LOGIN_HEADER_IMG_PATH":"","HOME_IMG_FILENAME":"montana.jpg","FAVICON_FILE_NAME":"favicon.ico","ALLOW_E_SIGN_ON_CORRECTIONS":true,"THIRD_PARTY_SIGNING_ALLOWED":false,"MY_ACCOUNT_SAVE_AND_CLOSE_BUTTON":true,"IE_DEPRECATED_MESSAGE":"Internet Explorer is not supported. Please select a supported browser below to access this website.","ADDITIONAL_ROUTES":{"dataRequests":true,"farmBill":true,"apostille":true,"externalHelp":"https://sosmt.gov/business/help-center/","systemAdministration":[{"title":"Saved Payments","parameter":"saved-payments","componentName":"SavedPayments"}]},"SUBROUTES":[{"label":"Business","component":"Business","parameter":"business","myWorkQueueSearch":false,"sourceTypeId":54,"searchMustHaveOneOf":["FILING_TYPE_ID","STATUS_ID","STATE","search"],"serverWebSearchDescription":true,"serverWorkQueueDescription":true,"serverMyRecordsDescription":true,"searchPlaceholder":"Search by name or filing number (X########)","allowEmptySearchTerm":true,"requestCertificateAlternateLabel":"Request Information","fileAmendmentButtonLabel":"Filing Actions","advancedSearchParameters":[{"type":"radio","name":"QUERY_TYPE_ID","defaultValue":1010,"options":[{"value":1010,"label":"Starts with"},{"value":1011,"label":"Contains"},{"value":1012,"label":" Word Contains"}]},{"type":"serverSelect","name":"FILING_TYPE_ID","optionsSrc":"FILING_TYPES","label":"Entity Type","placeholder":"All","defaultValue":"0"},{"type":"serverSelect","name":"FILING_SUBTYPE_ID","optionsSrc":"FILING_SUBTYPES","label":"Entity Subtype","overrideSubOptionsSrcFromParameterName":"FILING_TYPE_ID","placeholder":"All","defaultValue":"0"},{"type":"serverSelect","name":"STATUS_ID","optionsSrc":"FILING_STATUS_WITHOUT_ALL","label":"Status","placeholder":"All","defaultValue":"0"},{"type":"serverSelect","name":"STATE","optionsSrc":"STATE","label":"State","placeholder":"All","defaultValue":""},{"type":"serverSelect","name":"COUNTY","optionsSrc":"COUNTY_SUBOPTION","label":"County","overrideSubOptionsSrcFromParameterName":"STATE","placeholder":"All","defaultValue":""},{"type":"checkbox","name":"CRA_SEARCH_YN","defaultValue":false,"label":"Search by Registered Agent PID"},{"type":"dateRange","name":"FILING_DATE","label":"Registration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}},{"type":"dateRange","name":"EXPIRATION_DATE","label":"Expiration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}}],"myRecordsFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Active"},{"value":2,"label":"Inactive"},{"value":3,"label":"Pending"}]},{"type":"dateRange","name":"DATE_RANGE","label":"Date range","defaultValue":{"start":null,"end":null}}],"myWorkQueueFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Approved"},{"value":2,"label":"Pending Online Payment"},{"value":3,"label":"Pending Review"},{"value":4,"label":"Needs Correction"},{"value":5,"label":"Rejected"},{"value":6,"label":"Draft"}]},{"type":"dateRange","name":"DATE_RANGE","label":"Date range","defaultValue":{"start":null,"end":null}}]},{"label":"Notary","component":"Notary","parameter":"notary","sourceTypeId":850,"myWorkQueueSearch":false,"allowEmptySearchTerm":true,"requestCertificateAlternateLabel":"Download Certificate","fileAmendmentButtonLabel":"Filing Actions","hideNameRequestCertificate":true,"hideAddressRequestCertificate":true,"hideRecordUserManagment":true,"searchPlaceholder":"Search by name or commission number","searchMustHaveOneOf":["CITY","search","SERVICE_TYPE"],"advancedParametersStartOpen":true,"searchIsSortable":true,"advancedSearchParameters":[{"type":"radio","name":"STARTS_WITH_YN","defaultValue":false,"options":[{"value":true,"label":"Starts with"},{"value":false,"label":"Contains"}]},{"type":"checkbox","name":"ACTIVE_ONLY_YN","defaultValue":true,"label":"Active entities only"},{"type":"text","name":"CITY","defaultValue":"","label":"City"},{"type":"select","name":"SERVICE_TYPE","label":"Special Services Offered","defaultValue":0,"options":[{"value":0,"label":"(N/A)"},{"value":6165,"label":"In-Person Electronic Notarization (IPEN)"},{"value":6166,"label":"Remote Online Notarization (RON)"},{"value":6167,"label":"Mobile Notary Services"},{"value":6168,"label":"Remote Ink Notarization (RIN)"}]}]},{"label":"Apostille","component":"Apostille","parameter":"apostille","sourceTypeId":720,"myRecordsSearch":false,"myWorkQueueSearch":false,"disabled":false,"allowedRoutes":["/forms-manager/","/queue/","/forms/"]},{"label":"Liens","component":"UCC","parameter":"ucc","sourceTypeId":1999,"myRecordsSearch":true,"myWorkQueueSearch":true,"fileAmendmentButtonLabel":"Filing Actions","searchPlaceholder":"Search by name or file number","disabled":false,"serverWebSearchDescription":true,"myRecordsDescription":"","workQueueDescription":"","searchDescription":"","hideRecordUserManagment":true,"searchLiensCheckout":false,"advancedSearchParameters":[{"type":"radio","name":"STARTS_WITH_YN","defaultValue":false,"options":[{"value":true,"label":"Starts with"},{"value":false,"label":"Contains"}]},{"type":"select","name":"STATUS","defaultValue":"ALL","label":"Status","options":[{"value":"ACTIVE_UNLAPSED","label":"Active (unlapsed)"},{"value":"ACTIVE_LAPSED_UNLAPSED","label":"Active (lapsed and unlapsed)"}]},{"type":"text","name":"EXCLUDE_VALUES","label":"Exclude Debtor Names (comma separated list of names to exclude)","defaultValue":""},{"type":"dateRange","name":"FILING_DATE","label":"Financing Statement Date","defaultValue":{"start":null,"end":null}},{"type":"dateRange","name":"LAPSE_DATE","label":"Lapse Date","defaultValue":{"start":null,"end":null}},{"type":"text","name":"CITY","label":"Debtor City","defaultValue":""}],"myRecordsFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Approved"},{"value":2,"label":"Pending Online Payment"},{"value":3,"label":"Pending Review"}]},{"type":"select","name":"TYPE","defaultValue":0,"label":"Lien Type","options":[{"value":0,"label":"All"},{"value":1,"label":"UCC"},{"value":2,"label":"EFS"},{"value":3,"label":"Title 71"}]}],"myWorkQueueFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Approved"},{"value":2,"label":"Pending Online Payment"},{"value":3,"label":"Pending Review"},{"value":4,"label":"Pending Print and Mail"},{"value":5,"label":"Rejected"},{"value":6,"label":"Draft"}]},{"type":"select","name":"TYPE","defaultValue":0,"label":"Lien Type","options":[{"value":0,"label":"All"},{"value":1,"label":"UCC"},{"value":2,"label":"EFS"},{"value":3,"label":"Title 71"}]}]},{"label":"Copy Request","component":"copies","parameter":"copies","sourceTypeId":2001,"myRecordsSearch":false,"myWorkQueueSearch":false,"disabled":false,"allowedRoutes":["/forms-manager/","/queue/","/forms/"]},{"label":"Trademark","component":"Trademark","parameter":"trademark","sourceTypeId":810,"showRequestCertificate":true,"searchMustHaveOneOf":["search","EXPIRATION_DATE","FILING_DATE"],"allowEmptySearchTerm":true,"requestCertificateAlternateLabel":"Request Information","fileAmendmentButtonLabel":"Filing Actions","advancedSearchParameters":[{"type":"radio","name":"QUERY_TYPE_ID","defaultValue":1010,"options":[{"value":1010,"label":"Starts with"},{"value":1011,"label":"Contains"},{"value":1012,"label":" Word Contains"}]},{"type":"checkbox","name":"OWNER_SEARCH_YN","defaultValue":false,"label":"Search owners"},{"type":"radio","name":"SERVICE_MARK_YN","label":"Mark Type","defaultValue":"","options":[{"value":"","label":"All Marks"},{"value":"Y","label":"Service Mark"},{"value":"N","label":"Trademark"}]},{"type":"serverSelect","name":"STATUS_ID","optionsSrc":"TYPE_V|TRADEMARK_STATUS_TYPE","label":"Status","placeholder":"All","defaultValue":"0"},{"type":"select","name":"DESIGN_TYPE_ID","options":[{"value":0,"label":"All"},{"value":990,"label":"Words Only"},{"value":991,"label":"Design Only"},{"value":992,"label":"Words and Design"}],"label":"Design Type","defaultValue":"0"},{"type":"dateRange","name":"FILING_DATE","label":"Registered Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}},{"type":"dateRange","name":"EXPIRATION_DATE","label":"Expiration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}}]},{"label":"Business Info Request","component":"InfoRequests","parameter":"info-request","sourceTypeId":167,"allowedRoutes":["/forms-manager/","/queue/","/forms/"]},{"label":"Data Requests","component":"DataRequests","parameter":"data-request","sourceTypeId":0,"allowedRoutes":["/forms-manager/"]},{"label":"CRA","component":"CRA","parameter":"cra","sourceTypeId":157,"myRecordsSearch":false,"searchPlaceholder":"Search by name or registered agent number","allowedRoutes":["/forms-manager/","/forms/","/records/","/queue/","/search/"],"allowEmptySearchTerm":true,"fileAmendmentButtonLabel":"Filing Actions","advancedSearchParameters":[{"type":"radio","name":"QUERY_TYPE_ID","defaultValue":1010,"options":[{"value":1010,"label":"Starts with"},{"value":1011,"label":"Contains"},{"value":1012,"label":" Word Contains"}]},{"type":"dateRange","name":"CRA_DATE","label":"Registration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}},{"type":"select","name":"STATUS_ID","label":"Status","defaultValue":0,"options":[{"value":0,"label":"All"},{"value":121,"label":"Active"},{"value":122,"label":"Inactive"}]},{"type":"select","name":"AGENT_TYPE_ID","label":"Agent Type","defaultValue":0,"options":[{"value":0,"label":"All"},{"value":460,"label":"Registered Agent"},{"value":461,"label":"Commercial Registered Agent"}]}]},{"label":"Farm Bill","component":"FarmBill","parameter":"farm-bill","path":"/lists/farm-bill","sourceTypeId":0,"myRecordsSearch":false,"allowedRules":["/search/"],"disabled":true,"searchDescription":"To perform a search, enter a debtor name. Your search results may include: exact debtor name, variations of that name and any filing that includes your search criteria. Punctuation is ignored.\n\nYou can click on \"Advanced\" to refine your search. Under “Advanced” you can search by crop, year, county and SSN/FEIN. As a registered Farm Bill Buyer with the Montana Secretary of State’s office it is important to maintain the confidentiality of the information contained within the Farm Bill Master List. The Farm Bill Master List reflects personal data, such as Social Security Numbers, which are a key piece of personal identifiable information to assist you in determining the existence of a lien against a specific debtor. The distribution of this information beyond its intended purpose is strictly prohibited.\n\nThe debtor's tax identification number has been hidden for confidentiality reasons. You may continue to search on a tax ID number and return debtors that match your search criteria. The SSN/FEIN must be entered without dashes or spaces.","searchMustHaveOneOf":["search","UCC_FARM_PRODUCT_ID","COUNTY"],"searchPlaceholder":"Search by debtor name","advancedSearchParameters":[{"type":"ServerMultiComplete","label":"Product code name(s)","name":"UCC_FARM_PRODUCT_ID","defaultValue":"","optionsSrc":"UCC_FARM_PRODUCT_V"},{"type":"MultiComplete","label":"Year or Range of Years","name":"YEAR_NUM","optionsSrc":"years","startYear":"1968","defaultValue":[],"preMergeOptions":[{"value":"ALL","label":"All"}]},{"type":"serverSelect","label":"State","name":"STATE","defaultValue":"MONTANA","optionsSrc":"STATE"},{"type":"ServerMultiComplete","label":"County","name":"COUNTY","defaultValue":[],"optionsSrc":"COUNTY","overrideSubOptionsSrcFromParameterName":"STATE"},{"type":"checkbox","name":"TIN_SEARCH_YN","defaultValue":false,"label":"Tax Identification Number Search"},{"type":"checkbox","name":"TIN_SORT_YN","defaultValue":false,"label":"Unique ID Sort"}]}],"SYSTEM_NICKNAME":"Online Services Portal","PAYMENT_METHODS":[{"type":"bypass"},{"type":"iTransact"}],"PAYMENT_ALLOW_AMEX":true,"SYSTEM_ID_LABEL":"System Id","DOUBLE_COLUMN_PUBLIC_LOGIN":true,"INTERNAL_USER_MANAGEMENT":true,"ALLOW_PUBLIC_JSON_IMPORT":false,"MAX_FILE_UPLOAD_SIZE":10000000,"REFUND_TEXT":"","RETURN_TO_HOME_ON_LOGOUT":true,"CURRENT_SOS_NAME":"Christi Jacobsen","LOGO_FILENAME":"mt-sos-logo.png","LOGO_ALT":"Christi Jacobsen, Montana Secretary of State","LOGO_FULL_WIDTH":true,"HOME_HIDE_AUTH_HINT":true,"HOME_TITLE":"Montana Secretary of State","CUSTOM_TAB_TITLE":"Official Montana","HOME_SUBTITLE":"Online Business Services","ENTITY_NAME_CONSENT_DESCRIPTION":"","ALLOW_USER_PROFILE_EDITING":true,"COMPARE_FOREIGN_NAME_IN_ENTITY_NAME_VALIDATION":true,"FOREIGN_NAME_FIELD_NAME":"KIMA_PARENT_NAME_INFO","LOGIN_TITLE":"Montana Secretary of State Online Filing Portal Login","PUBLIC_LOGIN_LABEL":"Username","REVERSE_LOGIN_COLUMNS":true,"LOGIN_SEAL_FILENAME":"seal_white.png","SEPARATE_USERNAME_AND_EMAIL":true,"CREATE_ACCOUNT_BUTTON_ALIGN_LEFT":true,"CREATE_ACCOUNT_BUTTON_TEXT":"CREATE AN ACCOUNT","PASSWORD_CUSTOM_ERROR_TEXT":"The password must meet all requirements","ACCOUNT_CREATED_MESSAGE":"Please check your email to verify your account to login and allow a few minutes for this message to arrive. Check your junk/spam folders if you do not find the email in your inbox.","PUBLIC_LOGIN_PLACEHOLDER":" ","DISABLE_DEFAULT_PAYMENT_RADIO":true,"CUSTOM_RESET_PASSWORD_ERROR_MESSAGE":"Username invalid - no account found","PUBLIC_LOGIN_CREATE_DESCRIPTION":"### Existing User:\n\n  - Enter your username and password to login.  \n\n\n  #### - OR -  \n\n\n\n  - Forgot password? Click 'Reset Password' and follow the prompts.\n  - Forgot username? Click 'Forgot Username' and follow the prompts.  \n\n\n  ### New User:\n  ","LOGIN_HELP_LINK":"https://sosmt.gov/business/how-do-i/","LOGIN_HELP_LINK_TEXT":"Need Help?","FORGOT_USERNAME_TEXT":"Forgot Username?","LOGIN_ACTIVE_DIRECTORY_TEXT":"State User Login","MULTIPLE_LOGIN_METHODS":true,"HAS_ACTIVE_DIRECTORY_LOGIN":true,"RESET_PASSWORD_WITH_USERNAME":true,"DOWNLOAD_LINK":true,"SHOW_USERNAME_ACCOUNT_CREATE":true,"SHOW_SCROLL_DOWN_ARROW":true,"SHOW_ADDRESS_ACCOUNT_CREATE":true,"TWO_COLUMN_ACCOUNT_CREATE":true,"RESET_PASSWORD_TIP":"A link to change your password has been sent to your email. Please allow a few minutes for this message to arrive. Please check your junk/spam folders if you do not find the email in your inbox.","FORGOT_PASSWORD_LINK_TEXT":"Reset Password","PHONE_NUMBER_OPTIONAL_ACCOUNT_CREATE":true,"SHOW_REQUIRED_INDICATOR_ACCOUNT_CREATE":true,"PASSWORD_REQUIREMENTS_ACCOUNT_CREATE":"\n    <ul>\n      <li>MUST contain at least 8 characters (12+ recommended)</li>\n      <li>MUST contain at least one uppercase letter.</li>\n      <li>MUST contain at least one lowercase letter.</li>\n      <li>MUST contain at least one number.</li>\n      <li>MUST contain at least one special character (!”#$%&'()*+,-./:;<=>?</li>\n    </ul>\n  ","ALLOW_CERTIFICATION_REQUEST":true,"ALLOW_PUBLIC_CERTIFICATE_REQUEST":true,"ALLOW_COPY_REQUEST":false,"ALLOW_CORRECTION_STYLING":true,"HIDE_DEPRECATION_WARNING":false,"AMEND_ROUTE_PUBLIC":true,"SEAL_FILENAME":"seal.png","SHOPPING_CART":true,"ALLOW_PAYMENT_UPDATE_WITH_EMPTY_CART":true,"RA_EMAIL":true,"RA_WEBSITE":true,"RA_NO_DEFAULT_TYPE":true,"RA_ADDRESS_LABEL":"Street Address","RA_TYPE_SELECTION_DEFAULT":true,"RA_DEFAULT_TYPE":"460","RA_OVERRIDE_TYPE_WITH_DEFAULT":true,"RA_PRINCIPAL_ADDRESS_AMS":true,"UPLOAD_AND_SUBMIT_HIDE_IF_ONE_OPTION":true,"PAYMENT_PROCESSING_MESSAGE":"Your payment is processing - Do not close your browser or click the back button","CHECKOUT_BUTTON_WHEN_PROCESSING_TEXT":"Processing","EFS_CROP_PICKER_NONE_LABEL":"Lien Duration","DISALLOWED_WIZARD_PIECES":["FormationLocale"],"REPEATER_SHOW_EDIT_BUTTON":true,"DATA_REQUEST_PAGE_TITLE":"Data Requests and Subscriptions","DATA_REQUEST_SIDEBAR_LABEL":"Data Requests & Subscriptions","LOGIN_REDIRECTS_TO_EPASS":false,"LOGIN_REDIRECTS_TO_ACTIVE_DIRECTORY":true,"LOGIN_ACTIVE_DIRECTORY_LINK":true,"FETCH_EDIT_USER_LINK":false,"LISTS_FETCH_AVAILABLE_LISTS":true,"POST_WIZARD_SUBMIT_REDIRECT_URL":"/","PIN_REQUEST_ATTESTATIONS":true,"PIN_REQUEST_DESCRIPTION":"Click **Request PIN** to have a new PIN sent to the account holder's email address on file.","OWNERSHIP_REQUEST_DESCRIPTION":"To become an **authorized user** of this record, a current **AUTHORIZED USER** will need to grant you access. To request access, click **Request Access** below.","PIN_REQUEST_SUCCESS_MESSAGE":"The PIN you have requested for this entity has been sent to the email associated with your user account.  You should receive the PIN in approximately 3-5 minutes, depending on your email service provider.","APOSTILLE_HEADER_LABEL":"Verification Information","APOSTILLE_NUMBER_LABEL":"Apostille/Authentication","APOSTILLE_CITY_STATE_OVERRIDE":"HELENA, MT","APOSTILLE_FILING_DATE_LABEL":"Issue Date","APOSTILLE_CITY_STATE_IN_CERTIFIED":true,"NOTARY_EXISTING_FILING":true,"ALLOW_REVOKE_OWN_ACCESS_ONLY":false,"HIDE_CANCEL_ON_ONETIME_DATA_REQUESTS":true,"DATA_REQUESTS_IN_SHOPPING_CART":true,"WQ_ALLOW_EDIT_PENDING_PAYMENT":true,"WQ_CONFIRM_ON_DELETE":true,"WQ_DELETE_CONFIRM_MESSAGE":"Deleting this filing will forfeit any money already paid to the Secretary of State. This action is permanent and cannot be undone, are you sure you would like to delete?","PASS_ITEM_GUIDS_ON_CHECKOUT":true,"FORM_REVISION_HISTORY":true,"CHECKOUT_DISCLAIMER":"By entering your credit card and/or checking account information you (i) state that **you are an authorized user** of the credit card and/or electronic check and that the associated information entered (e.g., account holder name, account number, billing address) is accurate, (ii) **you authorize payment processor to charge the amount you have requested** to your credit card and/or funding account, and (iii) **acknowledge if a charge is declined or reversed you may also be assessed a customary charge** by the payment processor for such transactions.","FARM_BILL_SEARCH_CONFIDENTIAL":"As a registered Farm Bill Buyer with the Montana Secretary of State’s office it is important to maintain the confidentiality of the information contained within the Farm Bill Master List. The Farm Bill Master List reflects personal data, such as Social Security Numbers, which are a key piece of personal identifiable information to assist you in determining the existence of a lien against a specific debtor. The distribution of this information beyond its intended purpose is strictly prohibited.\n\n**The debtor's tax identification number has been hidden for confidentiality reasons. You may continue to search on a tax ID number and return debtors that match your search criteria. The SSN/FEIN must be entered without dashes or spaces.  If you need access to the tax identification number to clearly identify the debtor, please contact the UCC unit at (406) 444-3665.**","VIEW_HISTORY_BUTTON_ALT_TEXT":"View Filings","WIZARD_ERROR_TITLE_MESSAGE":"Form Error","FARM_BILL_SEARCH_INTERACTIVE":true,"USE_FARM_BILL_API":true,"DISALLOW_ASSIGN_SELF_AS_RA":true,"DISALLOW_ASSIGN_SELF_AS_PRINCIPAL":true,"USE_TRADEMARK_OWNER_VALIDATION":true,"USE_ALTERNATIVE_FOREIGN_ADDRESS_LABELS":true,"MY_RECEIPTS_FILTER":[{"type":"dateRange","name":"DATE_RANGE","label":"Date range","defaultValue":{"start":null,"end":null}},{"type":"text","name":"REF_NUM","defaultValue":"","label":"Reference Number"},{"type":"text","name":"RECEIPT_NUM","defaultValue":"","label":"Receipt Id"},{"type":"text","name":"AMOUNT","defaultValue":"","label":"Amount"},{"type":"select","name":"TYPE","defaultValue":"","label":"Payment Type","options":[{"value":"","label":"All"},{"value":"CC","label":"Credit Card"},{"value":"Check","label":"Check"}]}],"MY_RECEIPTS_SHOW_IN_SIDEBAR":true,"SHOW_MY_RECEIPTS_HELPER_TEXT":true,"MY_RECEIPTS_HELPER_LABEL":"About Receipt Search","MY_RECEIPTS_HELPER_TEXT":"You can search for receipts based on their descriptions, including the items paid for on the receipt. Use the filters to search for or filter specific information.","FARM_BILL_SUBLINK":{"label":"Farm Bill","component":"FarmBill","parameter":"farm-bill","path":"/lists/farm-bill","sourceTypeId":0,"myRecordsSearch":false,"allowedRules":["/search/"],"disabled":true,"searchDescription":"To perform a search, enter a debtor name. Your search results may include: exact debtor name, variations of that name and any filing that includes your search criteria. Punctuation is ignored.\n\nYou can click on \"Advanced\" to refine your search. Under “Advanced” you can search by crop, year, county and SSN/FEIN. As a registered Farm Bill Buyer with the Montana Secretary of State’s office it is important to maintain the confidentiality of the information contained within the Farm Bill Master List. The Farm Bill Master List reflects personal data, such as Social Security Numbers, which are a key piece of personal identifiable information to assist you in determining the existence of a lien against a specific debtor. The distribution of this information beyond its intended purpose is strictly prohibited.\n\nThe debtor's tax identification number has been hidden for confidentiality reasons. You may continue to search on a tax ID number and return debtors that match your search criteria. The SSN/FEIN must be entered without dashes or spaces.","searchMustHaveOneOf":["search","UCC_FARM_PRODUCT_ID","COUNTY"],"searchPlaceholder":"Search by debtor name","advancedSearchParameters":[{"type":"ServerMultiComplete","label":"Product code name(s)","name":"UCC_FARM_PRODUCT_ID","defaultValue":"","optionsSrc":"UCC_FARM_PRODUCT_V"},{"type":"MultiComplete","label":"Year or Range of Years","name":"YEAR_NUM","optionsSrc":"years","startYear":"1968","defaultValue":[],"preMergeOptions":[{"value":"ALL","label":"All"}]},{"type":"serverSelect","label":"State","name":"STATE","defaultValue":"MONTANA","optionsSrc":"STATE"},{"type":"ServerMultiComplete","label":"County","name":"COUNTY","defaultValue":[],"optionsSrc":"COUNTY","overrideSubOptionsSrcFromParameterName":"STATE"},{"type":"checkbox","name":"TIN_SEARCH_YN","defaultValue":false,"label":"Tax Identification Number Search"},{"type":"checkbox","name":"TIN_SORT_YN","defaultValue":false,"label":"Unique ID Sort"}]},"ALLOW_ADDRESS_VALIDATION_BYPASS_OPTION":true,"DEFAULT_ADDRESS_VALIDATION_BYPASS_OPTION_CHECKED":true}).HAS_OKTA_LOGIN) {
	        return _react2.default.createElement(_reactRouterDom.Redirect, { to: '/auth?from=' + this.getFrom(), replace: true });
	      }
	      return _react2.default.createElement(
	        'div',
	        { className: 'admin-login-wrapper login-modal-new animated fadeInDown fast-animation' },
	        loggedIn && _react2.default.createElement(_reactRouterDom.Redirect, { to: this.getFrom(), replace: true }),
	        _react2.default.createElement(
	          'div',
	          { className: 'row', style: { padding: '0px' } },
	          _react2.default.createElement(
	            'div',
	            { className: 'col login-column left', style: { paddingTop: 95 } },
	            _react2.default.createElement(
	              'div',
	              { className: 'banner' },
	              _react2.default.createElement('span', { className: 'icon icon-lock' }),
	              ' Administrator Login'
	            ),
	            _react2.default.createElement(
	              'form',
	              { className: 'login' },
	              _react2.default.createElement(
	                'div',
	                { className: 'field' },
	                _react2.default.createElement(
	                  'label',
	                  null,
	                  'User ID'
	                ),
	                _react2.default.createElement('input', {
	                  type: 'text',
	                  ref: function ref(email) {
	                    _this7.email = email;
	                  },
	                  placeholder: (" ") || 'example@email.com',
	                  onKeyDown: this.checkEnter
	                })
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'field' },
	                _react2.default.createElement(
	                  'label',
	                  null,
	                  'Password'
	                ),
	                _react2.default.createElement('input', {
	                  type: 'password',
	                  ref: function ref(pass) {
	                    _this7.pass = pass;
	                  },
	                  placeholder: '********',
	                  onKeyDown: this.checkEnter
	                })
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'button-wrapper' },
	                this.state.error && _react2.default.createElement(
	                  'span',
	                  { className: 'error animated fadeIn fast-animation' },
	                  this.state.error
	                ),
	                _react2.default.createElement(
	                  'button',
	                  {
	                    type: 'button'
	                    // disabled={this.state.error ? true : false}
	                    , className: 'btn-raised btn-light-primary submit',
	                    onClick: this.loginAdmin
	                  },
	                  _react2.default.createElement('span', { className: 'icon icon-lock' }),
	                  '\xA0 LOGIN'
	                )
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return AdminLogin;
	}(_react.Component);
	
	exports.AdminLogin = AdminLogin = (0, _reactRedux.connect)(function (state) {
	  return {
	    location: state.router.location,
	    loggedIn: state.auth.loggedIn
	  };
	}, { loginAppUser: _AuthActions.loginAppUser })(AdminLogin);
	
	var AdminLoginPage = exports.AdminLoginPage = function (_Component5) {
	  _inherits(AdminLoginPage, _Component5);
	
	  function AdminLoginPage() {
	    _classCallCheck(this, AdminLoginPage);
	
	    return _possibleConstructorReturn(this, (AdminLoginPage.__proto__ || Object.getPrototypeOf(AdminLoginPage)).apply(this, arguments));
	  }
	
	  _createClass(AdminLoginPage, [{
	    key: 'render',
	    value: function render() {
	      var _props3 = this.props,
	          initialAuthCheck = _props3.initialAuthCheck,
	          siteOffline = _props3.siteOffline;
	
	      return _react2.default.createElement(
	        _Shell.Body,
	        { className: 'login-redirector' },
	        siteOffline && _react2.default.createElement(_reactRouterDom.Redirect, { to: '/' }),
	        !initialAuthCheck && _react2.default.createElement(AdminLogin, null)
	      );
	    }
	  }]);
	
	  return AdminLoginPage;
	}(_react.Component);
	
	exports.AdminLoginPage = AdminLoginPage = (0, _reactRedux.connect)(function (state) {
	  return {
	    initialAuthCheck: state.auth.initialAuthCheck,
	    siteOffline: state.app.appSettings.WEBSITE_PORTAL_OFFLINE_YN === true
	  };
	})(AdminLoginPage);

/***/ },
/* 303 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _FilterPopout = __webpack_require__(1147);
	
	var _FilterPopout2 = _interopRequireDefault(_FilterPopout);
	
	var _searchHeavy = __webpack_require__(129);
	
	var _searchHeavy2 = _interopRequireDefault(_searchHeavy);
	
	var _filter = __webpack_require__(569);
	
	var _filter2 = _interopRequireDefault(_filter);
	
	var _crossHeavy = __webpack_require__(51);
	
	var _crossHeavy2 = _interopRequireDefault(_crossHeavy);
	
	var _Loaders = __webpack_require__(16);
	
	var _deepEqual = __webpack_require__(65);
	
	var _deepEqual2 = _interopRequireDefault(_deepEqual);
	
	var _format = __webpack_require__(33);
	
	var _format2 = _interopRequireDefault(_format);
	
	var _isValid = __webpack_require__(43);
	
	var _isValid2 = _interopRequireDefault(_isValid);
	
	var _reactMarkdown = __webpack_require__(510);
	
	var _reactMarkdown2 = _interopRequireDefault(_reactMarkdown);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var SEARCH_CONFIG = {
	  type: 'text',
	  name: 'SEARCH',
	  defaultValue: '',
	  label: 'Search'
	};
	
	var TableControls = function (_React$Component) {
	  _inherits(TableControls, _React$Component);
	
	  function TableControls() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, TableControls);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = TableControls.__proto__ || Object.getPrototypeOf(TableControls)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      searchValue: '',
	      filterOpen: false
	    }, _this.onSearchChange = function (e) {
	      var searchValue = e.target.value;
	      _this.setState({ searchValue: searchValue });
	    }, _this.search = function () {
	      _this.props.onFilterChange(Object.assign({}, _this.props.filters, {
	        SEARCH: _this.state.searchValue
	      }));
	      _this.setState({ searchValue: '' });
	    }, _this.toggleFilter = function () {
	      _this.setState(function (state) {
	        return {
	          filterOpen: !state.filterOpen
	        };
	      });
	    }, _this.revertFilter = function (name) {
	      var targetFilter = [].concat(_toConsumableArray(_this.props.filterTemplates), [SEARCH_CONFIG]).find(function (ft) {
	        return ft.name === name;
	      });
	      _this.props.onFilterChange(Object.assign({}, _this.props.filters, _defineProperty({}, name, targetFilter.defaultValue)));
	    }, _this.parseDate = function (date) {
	      var parsed = new Date(date);
	      return (0, _isValid2.default)(parsed) ? (0, _format2.default)(parsed, 'MM/dd/yyyy') : '';
	    }, _this.getChipValueByType = function () {
	      var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
	      var filter = arguments[1];
	
	      switch (filter.type) {
	        case 'select':
	        case 'radio':
	          return (filter.options.find(function (opt) {
	            return opt.value.toString() === value.toString();
	          }) || {}).label;
	        case 'checkbox':
	          return value ? 'Yes' : 'No';
	        case 'dateRange':
	          var startDate = _this.parseDate(value.start);
	          var endDate = _this.parseDate(value.end);
	          return (startDate || 'Today') + ' - ' + (endDate || 'Today');
	        default:
	          return value;
	      }
	    }, _this.getFilterChips = function () {
	      var _this$props = _this.props,
	          filterTemplates = _this$props.filterTemplates,
	          filters = _this$props.filters;
	
	      return [SEARCH_CONFIG].concat(_toConsumableArray(filterTemplates)).reduce(function (arr, ft) {
	        if (filters[ft.name] && !(0, _deepEqual2.default)(filters[ft.name], ft.defaultValue)) {
	          return [].concat(_toConsumableArray(arr), [{
	            label: ft.label,
	            value: _this.getChipValueByType(filters[ft.name], ft),
	            name: ft.name
	          }]);
	        }
	        return arr;
	      }, []);
	    }, _this.checkForSubmit = function (e) {
	      if (e.keyCode === 13) {
	        _this.search();
	      }
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(TableControls, [{
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _props = this.props,
	          filterTemplates = _props.filterTemplates,
	          filters = _props.filters,
	          onFilterChange = _props.onFilterChange,
	          title = _props.title,
	          allowSearch = _props.allowSearch,
	          loading = _props.loading,
	          searchPlaceholder = _props.searchPlaceholder,
	          description = _props.description,
	          showHelpText = _props.showHelpText,
	          helpText = _props.helpText,
	          helpLabel = _props.helpLabel;
	
	      var calculatedDescription = description;
	      return _react2.default.createElement(
	        'div',
	        { className: 'table-controls-wrapper' },
	        _react2.default.createElement(
	          'div',
	          { className: 'toolbar' },
	          _react2.default.createElement(
	            'h2',
	            null,
	            title,
	            loading && _react2.default.createElement(
	              'div',
	              { className: 'loading-wrapper' },
	              _react2.default.createElement(_Loaders.Spinner, { size: 'small', themeColor: 'medium-neutral' })
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'filter-wrapper' },
	            showHelpText ? _react2.default.createElement(
	              'div',
	              { className: 'help-icon-wrapper' },
	              _react2.default.createElement(
	                'span',
	                { className: 'info-help-text' },
	                _react2.default.createElement(
	                  'div',
	                  null,
	                  _react2.default.createElement(
	                    'b',
	                    null,
	                    helpLabel
	                  )
	                ),
	                _react2.default.createElement('br', null),
	                _react2.default.createElement(
	                  'div',
	                  null,
	                  helpText
	                )
	              ),
	              _react2.default.createElement(
	                'span',
	                { className: 'info-icon', 'aria-hidden': 'true' },
	                'i'
	              )
	            ) : null,
	            allowSearch && _react2.default.createElement('input', {
	              type: 'text',
	              className: 'filter',
	              placeholder: searchPlaceholder || 'Search',
	              value: this.state.searchValue,
	              onChange: this.onSearchChange,
	              onKeyDown: this.checkForSubmit,
	              'aria-label': searchPlaceholder || 'Search',
	              ref: function ref(r) {
	                return _this2.searchInput = r;
	              }
	            }),
	            allowSearch && _react2.default.createElement(
	              'button',
	              {
	                type: 'button',
	                'aria-disabled': this.state.searchValue.length === 0,
	                className: 'search btn btn-primary btn-raised',
	                'aria-label': 'Search',
	                onClick: this.search
	              },
	              _react2.default.createElement(_searchHeavy2.default, null)
	            ),
	            filterTemplates && _react2.default.createElement(
	              'button',
	              {
	                type: 'button',
	                className: 'search btn btn-primary btn-raised',
	                'aria-label': 'Filter',
	                onClick: this.toggleFilter,
	                ref: function ref(r) {
	                  return _this2.filterButton = r;
	                }
	              },
	              _react2.default.createElement(_filter2.default, { 'aria-hidden': true, className: 'filter-icon' })
	            ),
	            filterTemplates && this.state.filterOpen && _react2.default.createElement(_FilterPopout2.default, {
	              onChange: onFilterChange,
	              filterTemplates: filterTemplates,
	              filters: filters,
	              onRequestClose: this.toggleFilter
	            })
	          )
	        ),
	        calculatedDescription ? _react2.default.createElement(_reactMarkdown2.default, { className: 'description', source: calculatedDescription }) : null,
	        _react2.default.createElement(
	          'div',
	          { className: 'filter-chips' },
	          filterTemplates && this.getFilterChips().map(function (fc) {
	            return _react2.default.createElement(FilterChip, {
	              label: fc.label,
	              value: fc.value,
	              name: fc.name,
	              onDeleteRequested: _this2.revertFilter,
	              key: fc.name
	            });
	          })
	        )
	      );
	    }
	  }]);
	
	  return TableControls;
	}(_react2.default.Component);
	
	exports.default = TableControls;
	
	
	var FilterChip = function FilterChip(_ref2) {
	  var label = _ref2.label,
	      value = _ref2.value,
	      name = _ref2.name,
	      onDeleteRequested = _ref2.onDeleteRequested;
	  return _react2.default.createElement(
	    'span',
	    { className: 'filter-chip' },
	    _react2.default.createElement(
	      'div',
	      { className: 'label' },
	      label
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'value' },
	      value
	    ),
	    _react2.default.createElement(
	      'button',
	      {
	        type: 'button',
	        'aria-label': 'Remove filter',
	        onClick: function onClick() {
	          onDeleteRequested(name);
	        }
	      },
	      _react2.default.createElement(
	        'div',
	        { className: 'center' },
	        _react2.default.createElement(_crossHeavy2.default, null)
	      )
	    )
	  );
	};

/***/ },
/* 304 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _crossHeavy = __webpack_require__(51);
	
	var _crossHeavy2 = _interopRequireDefault(_crossHeavy);
	
	var _searchHeavy = __webpack_require__(129);
	
	var _searchHeavy2 = _interopRequireDefault(_searchHeavy);
	
	var _Loaders = __webpack_require__(16);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Toolbar = function (_React$Component) {
	  _inherits(Toolbar, _React$Component);
	
	  function Toolbar() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, Toolbar);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Toolbar.__proto__ || Object.getPrototypeOf(Toolbar)).call.apply(_ref, [this].concat(args))), _this), _this.state = { searchValue: '' }, _this.clearFilter = function () {
	      _this.props.onSearchBlur('');
	      _this.filter.value = '';
	      _this.setState({ searchValue: '' });
	    }, _this.toggleExpansion = function () {
	      _this.props.onExpansionChange();
	    }, _this.checkSubmit = function (e) {
	      if (e.keyCode === 13 && _this.props.onSearchBlur) {
	        _this.props.onSearchBlur(e.target.value);
	      }
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(Toolbar, [{
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _props = this.props,
	          onSearchBlur = _props.onSearchBlur,
	          onSearchChange = _props.onSearchChange,
	          searchPlaceholder = _props.searchPlaceholder,
	          title = _props.title,
	          className = _props.className,
	          searching = _props.searching,
	          underToolbar = _props.underToolbar,
	          filterable = _props.filterable,
	          searchable = _props.searchable,
	          filter = _props.filter,
	          onRequestFilterClear = _props.onRequestFilterClear,
	          onFilterChange = _props.onFilterChange,
	          rightAlignChildren = _props.rightAlignChildren;
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'table-toolbar ' + className },
	        _react2.default.createElement(
	          'div',
	          { className: 'main-wrapper' },
	          _react2.default.createElement(
	            'h1',
	            null,
	            title
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'right-align' },
	            rightAlignChildren,
	            searchable !== false && _react2.default.createElement(
	              'div',
	              { className: 'filter-wrapper' },
	              _react2.default.createElement('input', {
	                ref: function ref(r) {
	                  _this2.filter = r;
	                },
	                type: 'text',
	                placeholder: searchPlaceholder,
	                onChange: function onChange(e) {
	                  if (onSearchChange) onSearchChange(e.target.value);
	                  if (onFilterChange) onFilterChange(e.target.value);
	                  if (!filterable) {
	                    _this2.setState({ searchValue: e.target.value });
	                  }
	                },
	                onKeyDown: this.checkSubmit,
	                onBlur: function onBlur(e) {
	                  if (onSearchBlur) onSearchBlur(e.target.value);
	                },
	                value: filterable ? filter : undefined
	              }),
	              this.state.searchValue && _react2.default.createElement(
	                'button',
	                { onClick: filterable ? onRequestFilterClear : this.clearFilter },
	                _react2.default.createElement(_crossHeavy2.default, null)
	              )
	            ),
	            !filterable && searchable !== false && _react2.default.createElement(
	              'button',
	              { className: 'btn btn-primary toolbar-search-button', disabled: searching },
	              _react2.default.createElement(
	                'div',
	                { className: 'center-icon' },
	                searching ? _react2.default.createElement(_Loaders.Spinner, { size: 'small', themeColor: 'inherit', className: 'list-spinner' }) : _react2.default.createElement(_searchHeavy2.default, null)
	              )
	            )
	          )
	        ),
	        underToolbar && _react2.default.createElement(
	          'div',
	          null,
	          underToolbar
	        )
	      );
	    }
	  }]);
	
	  return Toolbar;
	}(_react2.default.Component);
	
	exports.default = Toolbar;

/***/ },
/* 305 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Portal = __webpack_require__(12);
	
	var _Portal2 = _interopRequireDefault(_Portal);
	
	var _shortid = __webpack_require__(22);
	
	var _shortid2 = _interopRequireDefault(_shortid);
	
	var _MountDetector = __webpack_require__(299);
	
	var _MountDetector2 = _interopRequireDefault(_MountDetector);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var WIZARD_BODY_SELECTOR = 'wizard-body-scroll-container';
	
	var FieldTooltip = function FieldTooltip(_ref) {
	  var tooltip = _ref.tooltip;
	
	  var _React$useState = _react2.default.useState(false),
	      _React$useState2 = _slicedToArray(_React$useState, 2),
	      shown = _React$useState2[0],
	      setShown = _React$useState2[1];
	
	  var _React$useState3 = _react2.default.useState({}),
	      _React$useState4 = _slicedToArray(_React$useState3, 2),
	      wrapperStyle = _React$useState4[0],
	      setWrapperStyle = _React$useState4[1];
	
	  var trigger = _react2.default.useRef();
	  var wrapper = _react2.default.useRef();
	  var tipId = _react2.default.useRef(_shortid2.default.generate());
	
	  var positionTooltip = function positionTooltip() {
	    if (trigger.current && wrapper.current) {
	      var triggerRect = trigger.current.getBoundingClientRect();
	      var wrapperRect = wrapper.current.getBoundingClientRect();
	
	      var left = triggerRect.left + triggerRect.width / 2 - wrapperRect.width / 2;
	      var top = triggerRect.top - wrapperRect.height - 10;
	
	      if (left < 10) {
	        left = 10;
	      }
	
	      if (top < 10) {
	        top = 10;
	      }
	
	      setWrapperStyle({ transform: 'translate(' + left + 'px, ' + top + 'px)' });
	      setShown(true);
	    }
	  };
	
	  _react2.default.useEffect(function () {
	    if (shown) {
	      document.addEventListener('scroll', positionTooltip);
	      document.getElementById(WIZARD_BODY_SELECTOR).addEventListener('scroll', positionTooltip);
	      window.addEventListener('resize', positionTooltip);
	    }
	
	    return function () {
	      document.removeEventListener('scroll', positionTooltip);
	      document.getElementById(WIZARD_BODY_SELECTOR).removeEventListener('scroll', positionTooltip);
	      window.removeEventListener('resize', positionTooltip);
	    };
	  }, [shown]);
	
	  var hideTooltip = function hideTooltip() {
	    if (document.activeElement !== trigger.current) {
	      setShown(false);
	    }
	  };
	
	  return _react2.default.createElement(
	    'span',
	    {
	      ref: trigger,
	      className: 'tip tooltip-trigger',
	      onClick: function onClick(e) {
	        e.stopPropagation();
	        e.preventDefault();
	      },
	      onMouseEnter: positionTooltip,
	      onMouseOut: hideTooltip,
	      onFocus: positionTooltip,
	      onBlur: hideTooltip,
	      tabIndex: 0,
	      'aria-label': 'tooltip',
	      'aria-describedby': tipId.current
	    },
	    'i',
	    _react2.default.createElement(
	      _Portal2.default,
	      { isOpened: true },
	      _react2.default.createElement(
	        'div',
	        {
	          role: 'tooltip',
	          className: 'tooltip-wrapper',
	          style: Object.assign({}, wrapperStyle, { opacity: shown ? 1 : 0 }),
	          id: tipId.current,
	          ref: wrapper
	        },
	        tooltip,
	        _react2.default.createElement(_MountDetector2.default, { onMounted: function onMounted() {
	            if (document.activeElement === trigger.current) {
	              positionTooltip();
	            }
	          } })
	      )
	    )
	  );
	};
	
	exports.default = FieldTooltip;

/***/ },
/* 306 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Form = __webpack_require__(14);
	
	var _Field = __webpack_require__(25);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var DateRange = function (_React$Component) {
		_inherits(DateRange, _React$Component);
	
		function DateRange() {
			var _ref;
	
			var _temp, _this, _ret;
	
			_classCallCheck(this, DateRange);
	
			for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
				args[_key] = arguments[_key];
			}
	
			return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = DateRange.__proto__ || Object.getPrototypeOf(DateRange)).call.apply(_ref, [this].concat(args))), _this), _this.setValue = function (value, key) {
				_this.props.onChange(Object.assign({}, _this.props.value, _defineProperty({}, key, value)));
			}, _this.onBlur = function () {
				if (_this.props.onBlur) _this.props.onBlur(_this.props.value);
			}, _this.onButtonClicked = function (value, key) {
				if (_this.props.onButtonClicked) {
					_this.props.onButtonClicked(Object.assign({}, _this.props.value, _defineProperty({}, key, value)));
				}
			}, _temp), _possibleConstructorReturn(_this, _ret);
		}
	
		_createClass(DateRange, [{
			key: 'render',
			value: function render() {
				var _this2 = this;
	
				var _props = this.props,
				    _props$label = _props.label,
				    label = _props$label === undefined ? "" : _props$label,
				    startLabel = _props.startLabel,
				    endLabel = _props.endLabel,
				    value = _props.value,
				    isFirst = _props.isFirst,
				    validityClass = _props.validityClass,
				    stacked = _props.stacked,
				    todayButton = _props.todayButton,
				    onPickerOpened = _props.onPickerOpened,
				    onPickerClosed = _props.onPickerClosed,
				    fieldId = _props.fieldId,
				    disabled = _props.disabled,
				    tabIndex = _props.tabIndex;
	
				return _react2.default.createElement(
					'div',
					{ className: 'row' },
					_react2.default.createElement(
						'div',
						{ className: stacked ? 'col-12' : 'col-sm-6 col-md-6 col-lg-5' },
						_react2.default.createElement(
							_Field.DumbField,
							{ label: startLabel, fieldId: 'date-' + fieldId + 's' },
							_react2.default.createElement(_Form.DateInput, {
								validityClass: validityClass,
								fieldId: fieldId + 's',
								name: 'start',
								value: value.start,
								onChange: function onChange(value) {
									_this2.setValue(value, 'start');
								},
								onBlur: this.onBlur,
								disabled: disabled,
								isFirst: isFirst,
								maxDate: value.end,
								todayButton: todayButton,
								onButtonClicked: function onButtonClicked(value) {
									_this2.onButtonClicked(value, 'start');
								},
								onPickerOpened: onPickerOpened,
								onPickerClosed: onPickerClosed,
								tabIndex: tabIndex,
								ariaLabel: label + ': ' + startLabel
							})
						)
					),
					_react2.default.createElement(
						'div',
						{ className: stacked ? 'col-12' : 'col-sm-6 col-md-6 col-lg-5' },
						_react2.default.createElement(
							_Field.DumbField,
							{ label: endLabel, fieldId: 'date-' + fieldId + 'e' },
							_react2.default.createElement(_Form.DateInput, {
								validityClass: validityClass,
								fieldId: fieldId + 'e',
								name: 'end',
								value: value.end,
								disabled: disabled,
								onChange: function onChange(value) {
									_this2.setValue(value, 'end');
								},
								onBlur: this.onBlur,
								todayButton: todayButton,
								minDate: value.start,
								onButtonClicked: function onButtonClicked(value) {
									_this2.onButtonClicked(value, 'end');
								},
								onPickerOpened: onPickerOpened,
								onPickerClosed: onPickerClosed,
								tabIndex: tabIndex,
								ariaLabel: label + ': ' + endLabel
							})
						)
					)
				);
			}
		}]);
	
		return DateRange;
	}(_react2.default.Component);
	
	exports.default = DateRange;

/***/ },
/* 307 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(7);
	
	var _Form = __webpack_require__(14);
	
	var _requests = __webpack_require__(6);
	
	var _ResultsDrawer = __webpack_require__(466);
	
	var _Portal = __webpack_require__(12);
	
	var _Portal2 = _interopRequireDefault(_Portal);
	
	var _Modal = __webpack_require__(13);
	
	var _utilities = __webpack_require__(8);
	
	var _searchHeavy = __webpack_require__(129);
	
	var _searchHeavy2 = _interopRequireDefault(_searchHeavy);
	
	var _revert = __webpack_require__(227);
	
	var _revert2 = _interopRequireDefault(_revert);
	
	var _Loaders = __webpack_require__(16);
	
	var _WizardClasses = __webpack_require__(35);
	
	var WizardClasses = _interopRequireWildcard(_WizardClasses);
	
	var _wizardUtilities = __webpack_require__(52);
	
	var _caretDown = __webpack_require__(38);
	
	var _caretDown2 = _interopRequireDefault(_caretDown);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var SearchControl = function (_Component) {
	  _inherits(SearchControl, _Component);
	
	  function SearchControl(props) {
	    _classCallCheck(this, SearchControl);
	
	    var _this = _possibleConstructorReturn(this, (SearchControl.__proto__ || Object.getPrototypeOf(SearchControl)).call(this));
	
	    _this.componentDidMount = function () {
	      if (_this.props.value) {
	        if (Array.isArray(_this.props.value)) {
	          _this.getMultiById(_this.props.value);
	        } else {
	          _this.getById(_this.props.value.SOURCE_ID);
	        }
	      }
	    };
	
	    _this.getById = function (sourceId, callback) {
	      return new Promise(function (resolve, reject) {
	        if (sourceId) {
	          var SEARCH_TYPE = _this.props.searchType || 'ACTIVE_FILINGS';
	          var query = '?' + _this.getSearchQuery();
	          (0, _requests.GET_BY_ID)(SEARCH_TYPE, sourceId + query, function (result) {
	            _this.setState({ loading: false });
	            _this.props.onChange(result, { target: { name: _this.props.name } });
	            resolve(result);
	          });
	        } else {
	          resolve();
	        }
	      });
	    };
	
	    _this.getMultiById = function (results) {
	      _this.setState({ loadingMultiResults: true });
	      var promises = results.map(function (result) {
	        return new Promise(function (resolve, reject) {
	          if (result.SOURCE_ID) {
	            var SEARCH_TYPE = _this.props.searchType || 'ACTIVE_FILINGS';
	            (0, _requests.GET_BY_ID)(SEARCH_TYPE, result.SOURCE_ID, resolve);
	          } else {
	            reject();
	          }
	        });
	      });
	      Promise.all(promises).then(function (values) {
	        _this.setState({ loadingMultiResults: false });
	        _this.props.onChange(values, {});
	      });
	    };
	
	    _this.onSearchChange = function (value) {
	      _this.setState({ search: value });
	    };
	
	    _this.getSearchQuery = function () {
	      var parameterFields = _this.getFieldParameters();
	      var params = _this.props.additionalParameters || Object.keys(parameterFields).length ? Object.assign({}, parameterFields, _this.props.additionalParameters) : {};
	      var paramsString = Object.entries(params).reduce(function (str, _ref, index) {
	        var _ref2 = _slicedToArray(_ref, 2),
	            key = _ref2[0],
	            value = _ref2[1];
	
	        if (index !== 0) {
	          str += '&';
	        }
	        str += key + '=' + encodeURIComponent((typeof value === 'undefined' ? 'undefined' : _typeof(value)) === 'object' ? JSON.stringify(value) : value);
	        return str;
	      }, '');
	      return paramsString;
	    };
	
	    _this.getFieldParameters = function () {
	      return (_this.props.parameterFields || []).map(function (fieldId) {
	        return _this.props.fields[fieldId];
	      }).filter(function (x) {
	        return x;
	      }).filter(function (field) {
	        return (0, _wizardUtilities.resolveFieldConditions)(field.conditions, _this.props.fields, field.conditionsOperator);
	      }).map(function (field) {
	        return new WizardClasses[field.fieldClass](field).getKeyValuePairs(field, _this.props.fields)[0];
	      }).reduce(function (obj, kv) {
	        return Object.assign({}, obj, _defineProperty({}, kv.name, kv.value));
	      }, {});
	    };
	
	    _this.search = function () {
	      _this.setState({ searching: true });
	      var SEARCH_TYPE = _this.props.searchType || 'ACTIVE_FILINGS';
	      var parameterFields = _this.getFieldParameters();
	      (0, _requests.SEARCH_BY_KEY)(SEARCH_TYPE, Object.assign({
	        SEARCH_VALUE: _this.state.search
	      }, _this.props.additionalParameters || Object.keys(parameterFields).length ? { ADDITIONAL_PARAMS: Object.assign({}, parameterFields, _this.props.additionalParameters) } : {}), function (results) {
	        _this.setState({
	          results: SEARCH_TYPE === 'ACTIVE_FILINGS|CRA' && (true) && _this.props.parentId || (true) && _this.props.parentId ? results.filter(function (result) {
	            return result.SOURCE_ID.toString() !== _this.props.parentId.toString();
	          }) : results,
	          modalOpen: true,
	          searching: false
	        });
	        if (_this.filterInput) {
	          _this.filterInput.focus();
	        }
	      }, function (err) {
	        _this.setState({ searching: false });
	        console.error(err);
	      });
	    };
	
	    _this.toggleModal = function () {
	      _this.setState({ modalOpen: !_this.state.modalOpen });
	    };
	
	    _this.checkForSubmit = function (e) {
	      if (e.charCode === 13) {
	        e.stopPropagation();
	        _this.search();
	      }
	    };
	
	    _this.filter = function (e) {
	      _this.setState({ filter: e.target.value });
	    };
	
	    _this.onFilterKeyUp = function (_ref3) {
	      var keyCode = _ref3.keyCode;
	
	      if (keyCode === 27) {
	        _this.setState({ modalOpen: false });
	        _this.searchInput.focus();
	      }
	    };
	
	    _this.selectResult = function (result) {
	      _this.getById(result.SOURCE_ID).then(function (result) {
	        _this.toggleModal();
	      });
	    };
	
	    _this.selectMultiResults = function () {
	      var results = _this.selectableResults.getSelected();
	      _this.getMultiById(results);
	    };
	
	    _this.deSelect = function () {
	      _this.props.onChange(null, { target: { name: _this.props.name, value: null } });
	    };
	
	    _this.deSelectAll = function () {
	      _this.props.onChange([], {});
	    };
	
	    _this.deSelectRow = function (index) {
	      var newRows = [].concat(_toConsumableArray(_this.props.value.slice(0, index)), _toConsumableArray(_this.props.value.slice(index + 1)));
	
	      _this.props.onChange(newRows, { target: { name: _this.props.name, value: newRows } });
	    };
	
	    _this.onBlur = function (value, e) {
	      _this.props.onBlur(_this.props.value, e);
	    };
	
	    _this.setNameValue = function (value, e) {
	      _this.props.onChange(Object.assign({}, _this.props.value, value), e);
	    };
	
	    _this.getFilteredOptions = function (labels) {
	      return labels.reduce(function (options, label, index) {
	        if (label !== '') {
	          return [].concat(_toConsumableArray(options), [{ value: index.toString(), label: label }]);
	        } else {
	          return options;
	        }
	      }, []);
	    };
	
	    _this.getDefaultOrgType = function (currentValue, filteredOptions) {
	      if (filteredOptions.length) {
	        filteredOptions.forEach(function (option) {
	          if (option.value === currentValue) {
	            return option.value;
	          }
	        });
	        return filteredOptions[0].value;
	      }
	    };
	
	    _this.selectAll = function () {
	      _this.selectableResults.setGlobalSelect(true);
	    };
	
	    _this.selectNone = function () {
	      _this.selectableResults.setGlobalSelect(false);
	    };
	
	    _this.state = {
	      search: '',
	      modalOpen: false,
	      results: [],
	      filter: '',
	      loading: props.value !== null,
	      loadingMultiResults: false,
	      searching: false
	    };
	    return _this;
	  }
	
	  _createClass(SearchControl, [{
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _props = this.props,
	          value = _props.value,
	          disabled = _props.disabled,
	          modalTitle = _props.modalTitle,
	          width = _props.width,
	          _props$fullWidthResul = _props.fullWidthResult,
	          fullWidthResult = _props$fullWidthResul === undefined ? true : _props$fullWidthResul,
	          placeholder = _props.placeholder,
	          fieldId = _props.fieldId,
	          multiSelect = _props.multiSelect;
	
	      var hasNotSelectedResult = multiSelect ? !value.length : !value;
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'organization-search', style: { width: width } },
	        hasNotSelectedResult ? _react2.default.createElement(
	          'div',
	          { className: 'row' },
	          _react2.default.createElement(
	            'div',
	            { className: 'col-12 search-input-wrapper' },
	            _react2.default.createElement(_Form.TextInput, Object.assign({}, this.props, {
	              value: this.state.search,
	              fieldId: fieldId,
	              ref: function ref(r) {
	                _this2.searchInput = r;
	              },
	              name: 'SEARCH_VALUE',
	              className: 'text-input',
	              onBlur: function onBlur() {},
	              width: width,
	              onKeyPress: this.checkForSubmit,
	              onChange: this.onSearchChange,
	              placeholder: placeholder,
	              'aria-label': 'Search'
	            })),
	            _react2.default.createElement(
	              'button',
	              {
	                type: 'button',
	                className: 'btn btn-primary btn-raised search-button live',
	                onClick: this.search,
	                disabled: disabled || this.state.searching
	              },
	              this.state.searching ? _react2.default.createElement(
	                'div',
	                { className: 'button-loading-wrapper' },
	                _react2.default.createElement(_Loaders.Spinner, { size: 'small', themeColor: 'inherit' }),
	                ' Searching'
	              ) : _react2.default.createElement(
	                _react2.default.Fragment,
	                null,
	                _react2.default.createElement(_searchHeavy2.default, null),
	                ' Search'
	              )
	            )
	          )
	        ) : multiSelect ? this.state.loadingMultiResults ? value.map(function (row, i) {
	          return _react2.default.createElement('div', {
	            className: 'shimmer-result-placeholder ' + (fullWidthResult ? 'col' : 'col-md-8 col-lg-7'),
	            style: { animationDelay: -i * 120 + 'ms' },
	            key: i
	          });
	        }) : _react2.default.createElement(
	          _react2.default.Fragment,
	          null,
	          !disabled && _react2.default.createElement(
	            'div',
	            { className: 'flex-row button-row', style: { marginBottom: 15, marginLeft: -10 } },
	            _react2.default.createElement(
	              'button',
	              {
	                disabled: disabled,
	                type: 'button',
	                className: 'btn btn-raised btn-primary search-button',
	                onClick: this.deSelectAll
	              },
	              _react2.default.createElement(_revert2.default, null),
	              ' \xA0 Clear Results & Re-Search'
	            )
	          ),
	          value.map(function (row, i) {
	            return _react2.default.createElement(
	              'div',
	              { style: { marginBottom: 10 }, key: row.SOURCE_ID + row.SOURCE_TYPE_ID },
	              _react2.default.createElement(SelectedResultDisplay, {
	                value: row,
	                disabled: disabled,
	                fullWidthResult: fullWidthResult,
	                onRequestDeselect: function onRequestDeselect() {
	                  return _this2.deSelectRow(i);
	                }
	              })
	            );
	          })
	        ) : _react2.default.createElement(SelectedResultDisplay, {
	          value: value,
	          disabled: disabled,
	          fullWidthResult: fullWidthResult,
	          onRequestDeselect: this.deSelect
	        }),
	        _react2.default.createElement(
	          _Portal2.default,
	          { isOpened: this.state.modalOpen },
	          _react2.default.createElement(
	            _Modal.Modal,
	            {
	              title: modalTitle !== '' ? modalTitle : 'Search',
	              closeModal: this.toggleModal,
	              modalSize: 'medium',
	              saveAndCloseButton: multiSelect,
	              cancelButton: multiSelect,
	              closeButton: !multiSelect,
	              save: multiSelect ? this.selectMultiResults : undefined,
	              cancel: _utilities.noop
	            },
	            _react2.default.createElement(
	              'div',
	              { className: 'results-wrapper ' },
	              _react2.default.createElement(
	                'div',
	                { className: 'filter-wrapper' },
	                _react2.default.createElement('input', {
	                  type: 'text',
	                  className: 'filter'
	                  // placeholder="Filter Results..."
	                  , ref: function ref(r) {
	                    return _this2.filterInput = r;
	                  },
	                  onChange: function onChange(e) {
	                    _this2.onSearchChange(e.target.value);
	                  },
	                  onKeyPress: this.checkForSubmit,
	                  value: this.state.search
	                }),
	                _react2.default.createElement(
	                  'button',
	                  {
	                    type: 'button',
	                    className: 'btn btn-primary search-button live',
	                    onClick: this.search,
	                    disabled: disabled || this.state.searching
	                  },
	                  this.state.searching ? _react2.default.createElement(
	                    'div',
	                    { className: 'button-loading-wrapper' },
	                    _react2.default.createElement(_Loaders.Spinner, { size: 'small', themeColor: 'inherit' }),
	                    ' Searching'
	                  ) : _react2.default.createElement(
	                    _react2.default.Fragment,
	                    null,
	                    _react2.default.createElement(_searchHeavy2.default, null),
	                    ' Search'
	                  )
	                ),
	                multiSelect && _react2.default.createElement(
	                  'button',
	                  {
	                    className: 'btn btn-default search-button select-button',
	                    type: 'button',
	                    onClick: this.selectAll
	                  },
	                  'Select All'
	                ),
	                multiSelect && _react2.default.createElement(
	                  'button',
	                  {
	                    className: 'btn btn-default search-button select-button',
	                    type: 'button',
	                    onClick: this.selectNone
	                  },
	                  'Select None'
	                ),
	                !multiSelect && _react2.default.createElement(
	                  'div',
	                  { className: 'align-right' },
	                  _react2.default.createElement(
	                    'span',
	                    { className: 'info' },
	                    'Showing ' + this.state.results.length + ' result(s)'
	                  )
	                )
	              ),
	              _react2.default.createElement(Results, {
	                ref: function ref(_ref4) {
	                  return _this2.selectableResults = _ref4;
	                },
	                data: this.state.results,
	                selectResult: this.selectResult,
	                multiSelect: multiSelect,
	                toolbarChildren: _react2.default.createElement(
	                  'div',
	                  { className: 'align-right' },
	                  _react2.default.createElement(
	                    'span',
	                    { className: 'info' },
	                    'Showing ' + this.state.results.length + ' result(s)'
	                  )
	                )
	              })
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return SearchControl;
	}(_react.Component);
	
	SearchControl.defaultProps = { metadata: {} };
	exports.default = (0, _reactRedux.connect)(function (state) {
	  return {
	    fields: state.wizard.wizard.fields,
	    parentId: state.wizard.wizard.meta.FILING_ID
	  };
	})(SearchControl);
	
	var Results = function (_Component2) {
	  _inherits(Results, _Component2);
	
	  function Results(props) {
	    _classCallCheck(this, Results);
	
	    var _this3 = _possibleConstructorReturn(this, (Results.__proto__ || Object.getPrototypeOf(Results)).call(this, props));
	
	    _this3.componentDidMount = function () {
	      if (true) {
	        window.addEventListener('resize', _this3.handleScroll);
	        _this3.handleScrollUpdate();
	      }
	    };
	
	    _this3.handleScroll = function (e) {
	      if (true) {
	        var bottom = e.target.scrollHeight - (e.target.scrollTop + e.target.clientHeight) < 10;
	        var scrollable = e.target.scrollHeight - (e.target.scrollTop + e.target.clientHeight) >= 10;
	        _this3.setState(Object.assign({}, _this3.state, {
	          reachedBottom: bottom,
	          isScrollable: scrollable
	        }));
	      }
	    };
	
	    _this3.componentDidUpdate = function (prevProps) {
	      if (prevProps.data !== _this3.props.data) {
	        _this3.setState({
	          selected: _this3.calculateInitialSelection(_this3.props.data)
	        });
	      }
	      if (true) {
	        _this3.handleScrollUpdate();
	      }
	    };
	
	    _this3.calculateInitialSelection = function (data) {
	      return data.reduce(function (obj, result, i) {
	        obj[i] = false;
	        return obj;
	      }, {});
	    };
	
	    _this3.getSelected = function () {
	      return _this3.props.data.filter(function (result, i) {
	        return _this3.state.selected[i];
	      });
	    };
	
	    _this3.select = function (index, isSelected) {
	      _this3.setState(function (state) {
	        return {
	          selected: Object.assign({}, state.selected, _defineProperty({}, index, isSelected))
	        };
	      });
	    };
	
	    _this3.setGlobalSelect = function (isSelected) {
	      _this3.setState({
	        selected: _this3.props.data.reduce(function (obj, result, i) {
	          obj[i] = result.DISABLED ? false : isSelected;
	          return obj;
	        }, {})
	      });
	    };
	
	    _this3.state = {
	      selected: _this3.calculateInitialSelection(props.data),
	      windowHeight: window.innerHeight
	    };
	    window.addEventListener('resize', _this3.handleScroll);
	    return _this3;
	  }
	
	  _createClass(Results, [{
	    key: 'handleScrollUpdate',
	    value: function handleScrollUpdate() {
	      var elements = document.getElementsByClassName('search-control-modal');
	      if (elements[0]) {
	        var position = elements[0].scrollHeight - (elements[0].clientHeight + elements[0].scrollTop);
	        if (position < 10 && this.state.isScrollable) {
	          this.setState(Object.assign({}, this.state, { isScrollable: false }));
	        } else if (!this.state.isScrollable && position >= 10) {
	          this.setState(Object.assign({}, this.state, { isScrollable: true }));
	        }
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this4 = this;
	
	      var _props2 = this.props,
	          selectResult = _props2.selectResult,
	          data = _props2.data,
	          multiSelect = _props2.multiSelect,
	          toolbarChildren = _props2.toolbarChildren;
	
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'results-modal-body-wrapper', style: { paddingTop: multiSelect ? 26 : 0 } },
	        (true) && this.state.isScrollable ? _react2.default.createElement(
	          'div',
	          { className: 'scroll-down-container-bottom-right' },
	          _react2.default.createElement(
	            'div',
	            { className: 'scroll-down-text' },
	            'Scroll Down'
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'scroll-down-icon' },
	            _react2.default.createElement(_caretDown2.default, null)
	          )
	        ) : null,
	        multiSelect && _react2.default.createElement(
	          'div',
	          { className: 'results-toolbar' },
	          toolbarChildren
	        ),
	        _react2.default.createElement(
	          'div',
	          {
	            className: 'flex-column-wrapper scroll-wrapper results-list-wrapper search-control-modal',
	            onScroll:  true ? this.handleScroll : null
	          },
	          data.map(function (result, i) {
	            return _react2.default.createElement(_ResultsDrawer.Result, {
	              element: 'button',
	              data: result,
	              onClick: selectResult,
	              selectable: multiSelect,
	              isSelected: _this4.state.selected[i],
	              onSelectToggled: function onSelectToggled(isSelected) {
	                return _this4.select(i, isSelected);
	              },
	              key: i
	            });
	          })
	        )
	      );
	    }
	  }]);
	
	  return Results;
	}(_react.Component);
	
	var SelectedResultDisplay = function SelectedResultDisplay(_ref5) {
	  var fullWidthResult = _ref5.fullWidthResult,
	      value = _ref5.value,
	      disabled = _ref5.disabled,
	      onRequestDeselect = _ref5.onRequestDeselect;
	  return _react2.default.createElement(
	    'div',
	    { className: 'row' },
	    _react2.default.createElement(
	      'div',
	      { className: fullWidthResult ? 'col' : 'col-md-8 col-lg-7' },
	      _react2.default.createElement(
	        _ResultsDrawer.Result,
	        {
	          className: 'static static-selected-result animated fadeInUp fast-animation',
	          data: value
	        },
	        !disabled ? _react2.default.createElement(
	          'button',
	          {
	            type: 'button',
	            className: 'close',
	            'aria-label': 'Clear selection',
	            onClick: onRequestDeselect
	          },
	          _react2.default.createElement('span', { className: 'icon icon-close' })
	        ) : null
	      )
	    )
	  );
	};

/***/ },
/* 308 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.minNumberUnchecked = exports.minNumberChecked = exports.xMayNotEqualY = exports.minNumberOfSelectedOption = exports.maxNumberOfSelectedOption = exports.mustBeLessThanOrEqualToColumn = exports.atLeastSomeStateMustBe = exports.validateRepeaterConstraints = undefined;
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _repeaterConstraints = __webpack_require__(308);
	
	var CONSTRAINTS = _interopRequireWildcard(_repeaterConstraints);
	
	var _deepEqual = __webpack_require__(65);
	
	var _deepEqual2 = _interopRequireDefault(_deepEqual);
	
	var _store = __webpack_require__(18);
	
	var _store2 = _interopRequireDefault(_store);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var getProps = function getProps() {
	  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	  return Object.assign({
	    errorMessage: { type: "text", value: "", label: "Error Message" }
	  }, props);
	};
	
	exports.default = {
	  atLeastSomeStateMustBe: {
	    fn: 'atLeastSomeStateMustBe',
	    name: 'At least X rows must have Y state',
	    props: getProps({
	      minNumber: {
	        type: 'range',
	        label: 'How many rows are required to have this state?',
	        name: 'minNumber',
	        minValue: 0,
	        maxValue: 100,
	        value: 0
	      },
	      state: {
	        label: 'Which state is required?',
	        name: 'state',
	        width: '40%',
	        type: 'stateSelect',
	        value: ("MT")
	      }
	    })
	  },
	  mustBeLessThanOrEqualToColumn: {
	    fn: 'mustBeLessThanOrEqualToColumn',
	    name: 'Value must be less than or equal to column X',
	    props: getProps({
	      column: {
	        type: 'srcRepeaterColumn',
	        label: 'Which column must this field be less than?',
	        value: ''
	      }
	    })
	  },
	  maxNumberOfSelectedOption: {
	    fn: 'maxNumberOfSelectedOption',
	    name: 'Maximum Number of Selected Options',
	    props: {
	      config: {
	        label: 'Put the max number of selected options per repeater for the provided options. Leave it blank to allow unlimited options.',
	        name: 'config',
	        type: 'selectOptionConstrainer',
	        value: {}
	      }
	    }
	  },
	  minNumberOfSelectedOption: {
	    fn: 'minNumberOfSelectedOption',
	    name: 'Minimum Number of Selected Options',
	    props: {
	      config: {
	        label: 'Put the minimum number of selected options per repeater for the provided options. Leave it blank to allow unlimited options.',
	        name: 'config',
	        type: 'selectOptionConstrainer',
	        value: {}
	      }
	    }
	  },
	  xMayNotEqualY: {
	    fn: 'xMayNotEqualY',
	    name: 'Column X may not equal column Y',
	    props: getProps({
	      column: {
	        type: 'srcRepeaterColumn',
	        label: 'Which column may this column not be equal to?',
	        value: ''
	      }
	    })
	  },
	  minNumberChecked: {
	    fn: 'minNumberChecked',
	    name: 'Must be checked in a minimum number of rows',
	    props: getProps({
	      minNumber: {
	        type: 'range',
	        label: 'How many rows must have this checkbox checked?',
	        name: 'minNumber',
	        minValue: 0,
	        maxValue: 100,
	        value: 0
	      }
	    })
	  },
	  minNumberUnchecked: {
	    fn: 'minNumberUnchecked',
	    name: 'Must be unchecked in a minimum number of rows',
	    props: getProps({
	      minNumber: {
	        type: 'range',
	        label: 'How many rows must have this checkbox unchecked',
	        name: 'minNumber',
	        minValue: 0,
	        maxValue: 100,
	        value: 0
	      }
	    })
	  }
	};
	var validateRepeaterConstraints = exports.validateRepeaterConstraints = function validateRepeaterConstraints(columns, repeater) {
	  return new Promise(function (resolve, reject) {
	    var columnPromises = columns.map(function (col) {
	      return new Promise(function (columnResolve, columnReject) {
	        var constraintPromises = col.repeaterConstraints.map(function (constraint) {
	          return new Promise(function (constraintResolve, constrainReject) {
	            CONSTRAINTS[constraint.fn](repeater, col, constraint.props).then(function (res) {
	              constraintResolve(Object.assign({}, res, { fieldId: col.fieldId, constraint: constraint.fn }));
	            });
	          });
	        });
	        Promise.all(constraintPromises).then(function (values) {
	          return columnResolve(values);
	        });
	      });
	    });
	    Promise.all(columnPromises).then(function (values) {
	      return resolve(values.flatMap(function (v) {
	        return v;
	      }));
	    });
	  });
	};
	
	var atLeastSomeStateMustBe = exports.atLeastSomeStateMustBe = function atLeastSomeStateMustBe(repeater, field) {
	  var props = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	  return new Promise(function (resolve, reject) {
	    var states = repeater.value.map(function (row) {
	      return row[field.fieldId].STATE;
	    });
	    var numWithState = states.filter(function (state) {
	      return state === props.state;
	    }).length;
	    if (numWithState >= props.minNumber) {
	      resolve({
	        isValid: true,
	        errorMessage: ''
	      });
	    } else {
	      resolve({
	        isValid: false,
	        errorMessage: props.errorMessage || 'At least ' + props.minNumber + ' row(s) must have a(an) ' + props.state + ' address.'
	      });
	    }
	  });
	};
	
	var mustBeLessThanOrEqualToColumn = exports.mustBeLessThanOrEqualToColumn = function mustBeLessThanOrEqualToColumn(repeater, field) {
	  var props = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	  return new Promise(function (resolve, reject) {
	    var isValids = repeater.value.map(function (row) {
	      var currentField = row[field.fieldId];
	      var fieldToCompare = row[props.column];
	      if (currentField !== undefined && fieldToCompare !== undefined) {
	        var num1 = parseInt(currentField.replace(/,/g, ''), 10);
	        var num2 = parseInt(fieldToCompare.replace(/,/g, ''), 10);
	        return num1 <= num2;
	      } else {
	        return false;
	      }
	    });
	    var isValid = !isValids.some(function (v) {
	      return v === false;
	    });
	    var fieldToCompare = _store2.default.getState().wizard.wizard.fields[props.column] || {};
	    resolve({
	      isValid: isValid,
	      errorMessage: isValid ? '' : props.errorMessage || field.label + ' must be less than ' + fieldToCompare.label
	    });
	  });
	};
	
	var maxNumberOfSelectedOption = exports.maxNumberOfSelectedOption = function maxNumberOfSelectedOption(repeater, field) {
	  var props = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	  return new Promise(function (resolve, reject) {
	    var numOptions = repeater.value.reduce(function (obj, row) {
	      var hasValidateRepeater = !!repeater.businessRules.find(function (item) {
	        return item.fn === "validateRepeaterFields";
	      });
	      var isExempt = hasValidateRepeater && !!repeater.businessRules.find(function (item) {
	        return item.fn === "validateRepeaterFields";
	      }).props.skipDeletedRows ? row._statusId === 3 : false;
	      if (isExempt) return obj;
	      if (field.type === 'MultiComplete') {
	        var val = row[field.fieldId];
	        var newObj = Object.assign({}, obj);
	        val.forEach(function (v) {
	          newObj = Object.assign({}, newObj, _defineProperty({}, v, newObj[v] !== undefined ? newObj[v] + (isExempt ? 0 : 1) : 1));
	        }, {});
	        return newObj;
	      } else {
	        return Object.assign({}, obj, _defineProperty({}, row[field.fieldId], obj[row[field.fieldId]] !== undefined ? obj[row[field.fieldId]] + (isExempt ? 0 : 1) : 1));
	      }
	    }, {});
	
	    var results = field.options.map(function (option) {
	      var maxNum = _typeof(props.config[option.value]) !== 'object' ? props.config[option.value] : props.config[option.value].num;
	
	      var errorMessage = _typeof(props.config[option.value]) !== 'object' ? '' : props.config[option.value].error;
	
	      if (maxNum) {
	        if ((numOptions[option.value] || 0) <= maxNum) {
	          return { isValid: true, errorMessage: '' };
	        } else {
	          return {
	            isValid: false,
	            errorMessage: errorMessage || 'You cannot have more than ' + maxNum + ' of ' + option.label
	          };
	        }
	      } else {
	        return undefined;
	      }
	    }).filter(function (x) {
	      return x;
	    });
	
	    if (results.every(function (result) {
	      return result.isValid;
	    })) {
	      resolve({
	        isValid: true,
	        errorMessage: ''
	      });
	    } else {
	      resolve({
	        isValid: false,
	        errorMessage: results.map(function (result) {
	          return result.errorMessage;
	        }).filter(function (x) {
	          return x;
	        }).join('\n')
	      });
	    }
	  });
	};
	
	var minNumberOfSelectedOption = exports.minNumberOfSelectedOption = function minNumberOfSelectedOption(repeater, field) {
	  var props = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	  return new Promise(function (resolve, reject) {
	    var numOptions = repeater.value.reduce(function (obj, row) {
	      var hasValidateRepeater = !!repeater.businessRules.find(function (item) {
	        return item.fn === "validateRepeaterFields";
	      });
	      var isExempt = hasValidateRepeater && !!repeater.businessRules.find(function (item) {
	        return item.fn === "validateRepeaterFields";
	      }).props.skipDeletedRows ? row._statusId === 3 : false;
	      if (isExempt) return obj;
	      if (field.type === 'MultiComplete') {
	        var val = row[field.fieldId];
	        var newObj = Object.assign({}, obj);
	        val.forEach(function (v) {
	          newObj = Object.assign({}, newObj, _defineProperty({}, v, newObj[v] !== undefined ? newObj[v] + (isExempt ? 0 : 1) : 1));
	        }, {});
	        return newObj;
	      } else {
	        return Object.assign({}, obj, _defineProperty({}, row[field.fieldId], obj[row[field.fieldId]] !== undefined ? obj[row[field.fieldId]] + (isExempt ? 0 : 1) : 1));
	      }
	    }, {});
	
	    var results = field.options.map(function (option) {
	      var maxNum = _typeof(props.config[option.value]) !== 'object' ? props.config[option.value] : props.config[option.value].num;
	
	      var errorMessage = _typeof(props.config[option.value]) !== 'object' ? '' : props.config[option.value].error;
	
	      if (maxNum) {
	        if ((numOptions[option.value] || 0) >= maxNum) {
	          return { isValid: true, errorMessage: '' };
	        } else {
	          return {
	            isValid: false,
	            errorMessage: errorMessage || 'You must have at least ' + props.config[option.value] + ' of ' + option.label
	          };
	        }
	      } else {
	        return undefined;
	      }
	    }).filter(function (x) {
	      return x;
	    });
	
	    if (results.every(function (result) {
	      return result.isValid;
	    })) {
	      resolve({
	        isValid: true,
	        errorMessage: ''
	      });
	    } else {
	      resolve({
	        isValid: false,
	        errorMessage: [results.map(function (result) {
	          return result.errorMessage;
	        }).filter(function (x) {
	          return x;
	        }).join('\n')]
	      });
	    }
	  });
	};
	
	var xMayNotEqualY = exports.xMayNotEqualY = function xMayNotEqualY(repeater, field) {
	  var props = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	  return new Promise(function (resolve, reject) {
	    var isValids = repeater.value.map(function (row) {
	      var currentField = row[field.fieldId];
	      var fieldToCompare = row[props.column];
	      if (currentField !== undefined && fieldToCompare !== undefined) {
	        return (0, _deepEqual2.default)(currentField, fieldToCompare);
	      } else {
	        return false;
	      }
	    });
	    var isValid = !isValids.some(function (x) {
	      return x === false;
	    });
	    var fieldToCompare = _store2.default.getState().wizard.wizard.fields[props.column] || {};
	    resolve({
	      isValid: isValid,
	      errorMessage: isValid ? '' : props.errorMessage || '"' + field.label + '" may not be the same as "' + fieldToCompare.label + '"'
	    });
	  });
	};
	
	var minNumberChecked = exports.minNumberChecked = function minNumberChecked(repeater, field) {
	  var props = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	  return new Promise(function (resolve, reject) {
	    var numChecked = repeater.value.reduce(function (num, row) {
	      return row[field.fieldId] ? num + 1 : num;
	    }, 0);
	    if (numChecked >= props.minNumber) {
	      resolve({
	        isValid: true,
	        errorMessage: ""
	      });
	    } else {
	      resolve({
	        isValid: false,
	        errorMessage: '"' + field.label + '" must be checked in at least ' + props.minNumber + ' row(s).'
	      });
	    }
	  });
	};
	
	var minNumberUnchecked = exports.minNumberUnchecked = function minNumberUnchecked(repeater, field) {
	  var props = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	  return new Promise(function (resolve, reject) {
	    var numUnchecked = repeater.value.reduce(function (num, row) {
	      return !row[field.fieldId] ? num + 1 : num;
	    }, 0);
	    if (numUnchecked >= props.minNumber) {
	      resolve({
	        isValid: true,
	        errorMessage: ""
	      });
	    } else {
	      resolve({
	        isValid: false,
	        errorMessage: '"' + field.label + '" must not be checked in at least ' + props.minNumber + ' row(s).'
	      });
	    }
	  });
	};

/***/ },
/* 309 */
/***/ function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__(122),
	    root = __webpack_require__(69);
	
	/* Built-in method references that are verified to be native. */
	var Map = getNative(root, 'Map');
	
	module.exports = Map;


/***/ },
/* 310 */
/***/ function(module, exports, __webpack_require__) {

	var mapCacheClear = __webpack_require__(1244),
	    mapCacheDelete = __webpack_require__(1245),
	    mapCacheGet = __webpack_require__(1246),
	    mapCacheHas = __webpack_require__(1247),
	    mapCacheSet = __webpack_require__(1248);
	
	/**
	 * Creates a map cache object to store key-value pairs.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function MapCache(entries) {
	  var index = -1,
	      length = entries == null ? 0 : entries.length;
	
	  this.clear();
	  while (++index < length) {
	    var entry = entries[index];
	    this.set(entry[0], entry[1]);
	  }
	}
	
	// Add methods to `MapCache`.
	MapCache.prototype.clear = mapCacheClear;
	MapCache.prototype['delete'] = mapCacheDelete;
	MapCache.prototype.get = mapCacheGet;
	MapCache.prototype.has = mapCacheHas;
	MapCache.prototype.set = mapCacheSet;
	
	module.exports = MapCache;


/***/ },
/* 311 */
/***/ function(module, exports, __webpack_require__) {

	var isArray = __webpack_require__(76),
	    isSymbol = __webpack_require__(152);
	
	/** Used to match property names within property paths. */
	var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
	    reIsPlainProp = /^\w*$/;
	
	/**
	 * Checks if `value` is a property name and not a property path.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @param {Object} [object] The object to query keys on.
	 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
	 */
	function isKey(value, object) {
	  if (isArray(value)) {
	    return false;
	  }
	  var type = typeof value;
	  if (type == 'number' || type == 'symbol' || type == 'boolean' ||
	      value == null || isSymbol(value)) {
	    return true;
	  }
	  return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
	    (object != null && value in Object(object));
	}
	
	module.exports = isKey;


/***/ },
/* 312 */
/***/ function(module, exports, __webpack_require__) {

	var isFunction = __webpack_require__(501),
	    isLength = __webpack_require__(313);
	
	/**
	 * Checks if `value` is array-like. A value is considered array-like if it's
	 * not a function and has a `value.length` that's an integer greater than or
	 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
	 * @example
	 *
	 * _.isArrayLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isArrayLike(document.body.children);
	 * // => true
	 *
	 * _.isArrayLike('abc');
	 * // => true
	 *
	 * _.isArrayLike(_.noop);
	 * // => false
	 */
	function isArrayLike(value) {
	  return value != null && isLength(value.length) && !isFunction(value);
	}
	
	module.exports = isArrayLike;


/***/ },
/* 313 */
/***/ function(module, exports) {

	/** Used as references for various `Number` constants. */
	var MAX_SAFE_INTEGER = 9007199254740991;
	
	/**
	 * Checks if `value` is a valid array-like length.
	 *
	 * **Note:** This method is loosely based on
	 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
	 * @example
	 *
	 * _.isLength(3);
	 * // => true
	 *
	 * _.isLength(Number.MIN_VALUE);
	 * // => false
	 *
	 * _.isLength(Infinity);
	 * // => false
	 *
	 * _.isLength('3');
	 * // => false
	 */
	function isLength(value) {
	  return typeof value == 'number' &&
	    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
	}
	
	module.exports = isLength;


/***/ },
/* 314 */
/***/ function(module, exports, __webpack_require__) {

	var arrayLikeKeys = __webpack_require__(1191),
	    baseKeys = __webpack_require__(1205),
	    isArrayLike = __webpack_require__(312);
	
	/**
	 * Creates an array of the own enumerable property names of `object`.
	 *
	 * **Note:** Non-object values are coerced to objects. See the
	 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
	 * for more details.
	 *
	 * @static
	 * @since 0.1.0
	 * @memberOf _
	 * @category Object
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 * @example
	 *
	 * function Foo() {
	 *   this.a = 1;
	 *   this.b = 2;
	 * }
	 *
	 * Foo.prototype.c = 3;
	 *
	 * _.keys(new Foo);
	 * // => ['a', 'b'] (iteration order is not guaranteed)
	 *
	 * _.keys('hi');
	 * // => ['0', '1']
	 */
	function keys(object) {
	  return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
	}
	
	module.exports = keys;


/***/ },
/* 315 */
/***/ function(module, exports, __webpack_require__) {

	'use strict'
	
	var legacy = __webpack_require__(1177)
	var invalid = __webpack_require__(1178)
	var decimal = __webpack_require__(200)
	var hexadecimal = __webpack_require__(1173)
	var alphanumerical = __webpack_require__(1169)
	var decodeEntity = __webpack_require__(1279)
	
	module.exports = parseEntities
	
	var own = {}.hasOwnProperty
	var fromCharCode = String.fromCharCode
	var noop = Function.prototype
	
	// Default settings.
	var defaults = {
	  warning: null,
	  reference: null,
	  text: null,
	  warningContext: null,
	  referenceContext: null,
	  textContext: null,
	  position: {},
	  additional: null,
	  attribute: false,
	  nonTerminated: true
	}
	
	// Characters.
	var tab = 9 // '\t'
	var lineFeed = 10 // '\n'
	var formFeed = 12 //  '\f'
	var space = 32 // ' '
	var ampersand = 38 //  '&'
	var semicolon = 59 //  ';'
	var lessThan = 60 //  '<'
	var equalsTo = 61 //  '='
	var numberSign = 35 //  '#'
	var uppercaseX = 88 //  'X'
	var lowercaseX = 120 //  'x'
	var replacementCharacter = 65533 // '�'
	
	// Reference types.
	var name = 'named'
	var hexa = 'hexadecimal'
	var deci = 'decimal'
	
	// Map of bases.
	var bases = {}
	
	bases[hexa] = 16
	bases[deci] = 10
	
	// Map of types to tests.
	// Each type of character reference accepts different characters.
	// This test is used to detect whether a reference has ended (as the semicolon
	// is not strictly needed).
	var tests = {}
	
	tests[name] = alphanumerical
	tests[deci] = decimal
	tests[hexa] = hexadecimal
	
	// Warning types.
	var namedNotTerminated = 1
	var numericNotTerminated = 2
	var namedEmpty = 3
	var numericEmpty = 4
	var namedUnknown = 5
	var numericDisallowed = 6
	var numericProhibited = 7
	
	// Warning messages.
	var messages = {}
	
	messages[namedNotTerminated] =
	  'Named character references must be terminated by a semicolon'
	messages[numericNotTerminated] =
	  'Numeric character references must be terminated by a semicolon'
	messages[namedEmpty] = 'Named character references cannot be empty'
	messages[numericEmpty] = 'Numeric character references cannot be empty'
	messages[namedUnknown] = 'Named character references must be known'
	messages[numericDisallowed] =
	  'Numeric character references cannot be disallowed'
	messages[numericProhibited] =
	  'Numeric character references cannot be outside the permissible Unicode range'
	
	// Wrap to ensure clean parameters are given to `parse`.
	function parseEntities(value, options) {
	  var settings = {}
	  var option
	  var key
	
	  if (!options) {
	    options = {}
	  }
	
	  for (key in defaults) {
	    option = options[key]
	    settings[key] =
	      option === null || option === undefined ? defaults[key] : option
	  }
	
	  if (settings.position.indent || settings.position.start) {
	    settings.indent = settings.position.indent || []
	    settings.position = settings.position.start
	  }
	
	  return parse(value, settings)
	}
	
	// Parse entities.
	// eslint-disable-next-line complexity
	function parse(value, settings) {
	  var additional = settings.additional
	  var nonTerminated = settings.nonTerminated
	  var handleText = settings.text
	  var handleReference = settings.reference
	  var handleWarning = settings.warning
	  var textContext = settings.textContext
	  var referenceContext = settings.referenceContext
	  var warningContext = settings.warningContext
	  var pos = settings.position
	  var indent = settings.indent || []
	  var length = value.length
	  var index = 0
	  var lines = -1
	  var column = pos.column || 1
	  var line = pos.line || 1
	  var queue = ''
	  var result = []
	  var entityCharacters
	  var namedEntity
	  var terminated
	  var characters
	  var character
	  var reference
	  var following
	  var warning
	  var reason
	  var output
	  var entity
	  var begin
	  var start
	  var type
	  var test
	  var prev
	  var next
	  var diff
	  var end
	
	  if (typeof additional === 'string') {
	    additional = additional.charCodeAt(0)
	  }
	
	  // Cache the current point.
	  prev = now()
	
	  // Wrap `handleWarning`.
	  warning = handleWarning ? parseError : noop
	
	  // Ensure the algorithm walks over the first character and the end (inclusive).
	  index--
	  length++
	
	  while (++index < length) {
	    // If the previous character was a newline.
	    if (character === lineFeed) {
	      column = indent[lines] || 1
	    }
	
	    character = value.charCodeAt(index)
	
	    if (character === ampersand) {
	      following = value.charCodeAt(index + 1)
	
	      // The behaviour depends on the identity of the next character.
	      if (
	        following === tab ||
	        following === lineFeed ||
	        following === formFeed ||
	        following === space ||
	        following === ampersand ||
	        following === lessThan ||
	        following !== following ||
	        (additional && following === additional)
	      ) {
	        // Not a character reference.
	        // No characters are consumed, and nothing is returned.
	        // This is not an error, either.
	        queue += fromCharCode(character)
	        column++
	
	        continue
	      }
	
	      start = index + 1
	      begin = start
	      end = start
	
	      if (following === numberSign) {
	        // Numerical entity.
	        end = ++begin
	
	        // The behaviour further depends on the next character.
	        following = value.charCodeAt(end)
	
	        if (following === uppercaseX || following === lowercaseX) {
	          // ASCII hex digits.
	          type = hexa
	          end = ++begin
	        } else {
	          // ASCII digits.
	          type = deci
	        }
	      } else {
	        // Named entity.
	        type = name
	      }
	
	      entityCharacters = ''
	      entity = ''
	      characters = ''
	      test = tests[type]
	      end--
	
	      while (++end < length) {
	        following = value.charCodeAt(end)
	
	        if (!test(following)) {
	          break
	        }
	
	        characters += fromCharCode(following)
	
	        // Check if we can match a legacy named reference.
	        // If so, we cache that as the last viable named reference.
	        // This ensures we do not need to walk backwards later.
	        if (type === name && own.call(legacy, characters)) {
	          entityCharacters = characters
	          entity = legacy[characters]
	        }
	      }
	
	      terminated = value.charCodeAt(end) === semicolon
	
	      if (terminated) {
	        end++
	
	        namedEntity = type === name ? decodeEntity(characters) : false
	
	        if (namedEntity) {
	          entityCharacters = characters
	          entity = namedEntity
	        }
	      }
	
	      diff = 1 + end - start
	
	      if (!terminated && !nonTerminated) {
	        // Empty.
	      } else if (!characters) {
	        // An empty (possible) entity is valid, unless it’s numeric (thus an
	        // ampersand followed by an octothorp).
	        if (type !== name) {
	          warning(numericEmpty, diff)
	        }
	      } else if (type === name) {
	        // An ampersand followed by anything unknown, and not terminated, is
	        // invalid.
	        if (terminated && !entity) {
	          warning(namedUnknown, 1)
	        } else {
	          // If theres something after an entity name which is not known, cap
	          // the reference.
	          if (entityCharacters !== characters) {
	            end = begin + entityCharacters.length
	            diff = 1 + end - begin
	            terminated = false
	          }
	
	          // If the reference is not terminated, warn.
	          if (!terminated) {
	            reason = entityCharacters ? namedNotTerminated : namedEmpty
	
	            if (settings.attribute) {
	              following = value.charCodeAt(end)
	
	              if (following === equalsTo) {
	                warning(reason, diff)
	                entity = null
	              } else if (alphanumerical(following)) {
	                entity = null
	              } else {
	                warning(reason, diff)
	              }
	            } else {
	              warning(reason, diff)
	            }
	          }
	        }
	
	        reference = entity
	      } else {
	        if (!terminated) {
	          // All non-terminated numeric entities are not rendered, and trigger a
	          // warning.
	          warning(numericNotTerminated, diff)
	        }
	
	        // When terminated and number, parse as either hexadecimal or decimal.
	        reference = parseInt(characters, bases[type])
	
	        // Trigger a warning when the parsed number is prohibited, and replace
	        // with replacement character.
	        if (prohibited(reference)) {
	          warning(numericProhibited, diff)
	          reference = fromCharCode(replacementCharacter)
	        } else if (reference in invalid) {
	          // Trigger a warning when the parsed number is disallowed, and replace
	          // by an alternative.
	          warning(numericDisallowed, diff)
	          reference = invalid[reference]
	        } else {
	          // Parse the number.
	          output = ''
	
	          // Trigger a warning when the parsed number should not be used.
	          if (disallowed(reference)) {
	            warning(numericDisallowed, diff)
	          }
	
	          // Stringify the number.
	          if (reference > 0xffff) {
	            reference -= 0x10000
	            output += fromCharCode((reference >>> (10 & 0x3ff)) | 0xd800)
	            reference = 0xdc00 | (reference & 0x3ff)
	          }
	
	          reference = output + fromCharCode(reference)
	        }
	      }
	
	      // Found it!
	      // First eat the queued characters as normal text, then eat an entity.
	      if (reference) {
	        flush()
	
	        prev = now()
	        index = end - 1
	        column += end - start + 1
	        result.push(reference)
	        next = now()
	        next.offset++
	
	        if (handleReference) {
	          handleReference.call(
	            referenceContext,
	            reference,
	            {start: prev, end: next},
	            value.slice(start - 1, end)
	          )
	        }
	
	        prev = next
	      } else {
	        // If we could not find a reference, queue the checked characters (as
	        // normal characters), and move the pointer to their end.
	        // This is possible because we can be certain neither newlines nor
	        // ampersands are included.
	        characters = value.slice(start - 1, end)
	        queue += characters
	        column += characters.length
	        index = end - 1
	      }
	    } else {
	      // Handle anything other than an ampersand, including newlines and EOF.
	      if (
	        character === 10 // Line feed
	      ) {
	        line++
	        lines++
	        column = 0
	      }
	
	      if (character === character) {
	        queue += fromCharCode(character)
	        column++
	      } else {
	        flush()
	      }
	    }
	  }
	
	  // Return the reduced nodes, and any possible warnings.
	  return result.join('')
	
	  // Get current position.
	  function now() {
	    return {
	      line: line,
	      column: column,
	      offset: index + (pos.offset || 0)
	    }
	  }
	
	  // “Throw” a parse-error: a warning.
	  function parseError(code, offset) {
	    var position = now()
	
	    position.column += offset
	    position.offset += offset
	
	    handleWarning.call(warningContext, messages[code], position, code)
	  }
	
	  // Flush `queue` (normal text).
	  // Macro invoked before each entity and at the end of `value`.
	  // Does nothing when `queue` is empty.
	  function flush() {
	    if (queue) {
	      result.push(queue)
	
	      if (handleText) {
	        handleText.call(textContext, queue, {start: prev, end: now()})
	      }
	
	      queue = ''
	    }
	  }
	}
	
	// Check if `character` is outside the permissible unicode range.
	function prohibited(code) {
	  return (code >= 0xd800 && code <= 0xdfff) || code > 0x10ffff
	}
	
	// Check if `character` is disallowed.
	function disallowed(code) {
	  return (
	    (code >= 0x0001 && code <= 0x0008) ||
	    code === 0x000b ||
	    (code >= 0x000d && code <= 0x001f) ||
	    (code >= 0x007f && code <= 0x009f) ||
	    (code >= 0xfdd0 && code <= 0xfdef) ||
	    (code & 0xffff) === 0xffff ||
	    (code & 0xffff) === 0xfffe
	  )
	}


/***/ },
/* 316 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(106);
	
	var _interopRequireDefault = __webpack_require__(37);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.ManagerReferenceNodeSetterContext = exports.ManagerReferenceNodeContext = void 0;
	
	var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(217));
	
	var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(156));
	
	var _defineProperty2 = _interopRequireDefault(__webpack_require__(218));
	
	var React = _interopRequireWildcard(__webpack_require__(1));
	
	var _createReactContext = _interopRequireDefault(__webpack_require__(828));
	
	var ManagerReferenceNodeContext = (0, _createReactContext.default)();
	exports.ManagerReferenceNodeContext = ManagerReferenceNodeContext;
	var ManagerReferenceNodeSetterContext = (0, _createReactContext.default)();
	exports.ManagerReferenceNodeSetterContext = ManagerReferenceNodeSetterContext;
	
	var Manager =
	/*#__PURE__*/
	function (_React$Component) {
	  (0, _inheritsLoose2.default)(Manager, _React$Component);
	
	  function Manager() {
	    var _this;
	
	    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "referenceNode", void 0);
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "setReferenceNode", function (newReferenceNode) {
	      if (newReferenceNode && _this.referenceNode !== newReferenceNode) {
	        _this.referenceNode = newReferenceNode;
	
	        _this.forceUpdate();
	      }
	    });
	    return _this;
	  }
	
	  var _proto = Manager.prototype;
	
	  _proto.componentWillUnmount = function componentWillUnmount() {
	    this.referenceNode = null;
	  };
	
	  _proto.render = function render() {
	    return React.createElement(ManagerReferenceNodeContext.Provider, {
	      value: this.referenceNode
	    }, React.createElement(ManagerReferenceNodeSetterContext.Provider, {
	      value: this.setReferenceNode
	    }, this.props.children));
	  };
	
	  return Manager;
	}(React.Component);
	
	exports.default = Manager;

/***/ },
/* 317 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _propTypes = __webpack_require__(20);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _d3Interpolate = __webpack_require__(891);
	
	var _d3Timer = __webpack_require__(892);
	
	var _easing = __webpack_require__(1328);
	
	var _easing2 = _interopRequireDefault(_easing);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Transition = function (_Component) {
	  _inherits(Transition, _Component);
	
	  function Transition(props) {
	    _classCallCheck(this, Transition);
	
	    var _this = _possibleConstructorReturn(this, (Transition.__proto__ || Object.getPrototypeOf(Transition)).call(this, props));
	
	    _this.start = function () {
	      _this.timer = (0, _d3Timer.timer)(_this.animate);
	    };
	
	    _this.animate = function (elapsed) {
	      _this.timer || _this.start();
	      var _this$props = _this.props,
	          duration = _this$props.duration,
	          easing = _this$props.easing;
	
	      var t = elapsed / duration;
	      var nextState = void 0;
	      if (t > 1) {
	        nextState = _this.interpolator(1);
	        _this.timer.stop();
	      } else {
	        nextState = _this.interpolator(_easing2.default[easing](t));
	      }
	      _this.setState({ props: nextState });
	    };
	
	    _this.state = {
	      props: props.props
	    };
	    return _this;
	  }
	
	  _createClass(Transition, [{
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(props) {
	      this.timer && this.timer.stop();
	      this.interpolator = (0, _d3Interpolate.interpolateObject)(this.state.props, props.props);
	      this.start();
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var children = this.props.children;
	
	      return children(this.state.props);
	    }
	  }]);
	
	  return Transition;
	}(_react.Component);
	
	Transition.propTypes = {
	  children: _propTypes2.default.func.isRequired,
	  duration: _propTypes2.default.number,
	  easing: _propTypes2.default.oneOf(Object.keys(_easing2.default)),
	  props: _propTypes2.default.object.isRequired
	};
	Transition.defaultProps = {
	  duration: 400,
	  easing: 'cubicOut'
	};
	exports.default = Transition;
	//# sourceMappingURL=index.js.map

/***/ },
/* 318 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports["default"] = void 0;
	
	var _batch = __webpack_require__(517);
	
	// encapsulates the subscription logic for connecting a component to the redux store, as
	// well as nesting subscriptions of descendant components, so that we can ensure the
	// ancestor components re-render before descendants
	var nullListeners = {
	  notify: function notify() {}
	};
	
	function createListenerCollection() {
	  var batch = (0, _batch.getBatch)();
	  var first = null;
	  var last = null;
	  return {
	    clear: function clear() {
	      first = null;
	      last = null;
	    },
	    notify: function notify() {
	      batch(function () {
	        var listener = first;
	
	        while (listener) {
	          listener.callback();
	          listener = listener.next;
	        }
	      });
	    },
	    get: function get() {
	      var listeners = [];
	      var listener = first;
	
	      while (listener) {
	        listeners.push(listener);
	        listener = listener.next;
	      }
	
	      return listeners;
	    },
	    subscribe: function subscribe(callback) {
	      var isSubscribed = true;
	      var listener = last = {
	        callback: callback,
	        next: null,
	        prev: last
	      };
	
	      if (listener.prev) {
	        listener.prev.next = listener;
	      } else {
	        first = listener;
	      }
	
	      return function unsubscribe() {
	        if (!isSubscribed || first === null) return;
	        isSubscribed = false;
	
	        if (listener.next) {
	          listener.next.prev = listener.prev;
	        } else {
	          last = listener.prev;
	        }
	
	        if (listener.prev) {
	          listener.prev.next = listener.next;
	        } else {
	          first = listener.next;
	        }
	      };
	    }
	  };
	}
	
	var Subscription = /*#__PURE__*/function () {
	  function Subscription(store, parentSub) {
	    this.store = store;
	    this.parentSub = parentSub;
	    this.unsubscribe = null;
	    this.listeners = nullListeners;
	    this.handleChangeWrapper = this.handleChangeWrapper.bind(this);
	  }
	
	  var _proto = Subscription.prototype;
	
	  _proto.addNestedSub = function addNestedSub(listener) {
	    this.trySubscribe();
	    return this.listeners.subscribe(listener);
	  };
	
	  _proto.notifyNestedSubs = function notifyNestedSubs() {
	    this.listeners.notify();
	  };
	
	  _proto.handleChangeWrapper = function handleChangeWrapper() {
	    if (this.onStateChange) {
	      this.onStateChange();
	    }
	  };
	
	  _proto.isSubscribed = function isSubscribed() {
	    return Boolean(this.unsubscribe);
	  };
	
	  _proto.trySubscribe = function trySubscribe() {
	    if (!this.unsubscribe) {
	      this.unsubscribe = this.parentSub ? this.parentSub.addNestedSub(this.handleChangeWrapper) : this.store.subscribe(this.handleChangeWrapper);
	      this.listeners = createListenerCollection();
	    }
	  };
	
	  _proto.tryUnsubscribe = function tryUnsubscribe() {
	    if (this.unsubscribe) {
	      this.unsubscribe();
	      this.unsubscribe = null;
	      this.listeners.clear();
	      this.listeners = nullListeners;
	    }
	  };
	
	  return Subscription;
	}();
	
	exports["default"] = Subscription;

/***/ },
/* 319 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process, setImmediate, global) {// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.
	
	// A bit simpler than readable streams.
	// Implement an async ._write(chunk, encoding, cb), and it'll handle all
	// the drain event emission and buffering.
	
	'use strict';
	
	/*<replacement>*/
	
	var pna = __webpack_require__(208);
	/*</replacement>*/
	
	module.exports = Writable;
	
	/* <replacement> */
	function WriteReq(chunk, encoding, cb) {
	  this.chunk = chunk;
	  this.encoding = encoding;
	  this.callback = cb;
	  this.next = null;
	}
	
	// It seems a linked list but it is not
	// there will be only 2 of these for each stream
	function CorkedRequest(state) {
	  var _this = this;
	
	  this.next = null;
	  this.entry = null;
	  this.finish = function () {
	    onCorkedFinish(_this, state);
	  };
	}
	/* </replacement> */
	
	/*<replacement>*/
	var asyncWrite = !process.browser && ['v0.10', 'v0.9.'].indexOf(process.version.slice(0, 5)) > -1 ? setImmediate : pna.nextTick;
	/*</replacement>*/
	
	/*<replacement>*/
	var Duplex;
	/*</replacement>*/
	
	Writable.WritableState = WritableState;
	
	/*<replacement>*/
	var util = Object.create(__webpack_require__(136));
	util.inherits = __webpack_require__(58);
	/*</replacement>*/
	
	/*<replacement>*/
	var internalUtil = {
	  deprecate: __webpack_require__(1509)
	};
	/*</replacement>*/
	
	/*<replacement>*/
	var Stream = __webpack_require__(526);
	/*</replacement>*/
	
	/*<replacement>*/
	
	var Buffer = __webpack_require__(213).Buffer;
	var OurUint8Array = global.Uint8Array || function () {};
	function _uint8ArrayToBuffer(chunk) {
	  return Buffer.from(chunk);
	}
	function _isUint8Array(obj) {
	  return Buffer.isBuffer(obj) || obj instanceof OurUint8Array;
	}
	
	/*</replacement>*/
	
	var destroyImpl = __webpack_require__(525);
	
	util.inherits(Writable, Stream);
	
	function nop() {}
	
	function WritableState(options, stream) {
	  Duplex = Duplex || __webpack_require__(105);
	
	  options = options || {};
	
	  // Duplex streams are both readable and writable, but share
	  // the same options object.
	  // However, some cases require setting options to different
	  // values for the readable and the writable sides of the duplex stream.
	  // These options can be provided separately as readableXXX and writableXXX.
	  var isDuplex = stream instanceof Duplex;
	
	  // object stream flag to indicate whether or not this stream
	  // contains buffers or objects.
	  this.objectMode = !!options.objectMode;
	
	  if (isDuplex) this.objectMode = this.objectMode || !!options.writableObjectMode;
	
	  // the point at which write() starts returning false
	  // Note: 0 is a valid value, means that we always return false if
	  // the entire buffer is not flushed immediately on write()
	  var hwm = options.highWaterMark;
	  var writableHwm = options.writableHighWaterMark;
	  var defaultHwm = this.objectMode ? 16 : 16 * 1024;
	
	  if (hwm || hwm === 0) this.highWaterMark = hwm;else if (isDuplex && (writableHwm || writableHwm === 0)) this.highWaterMark = writableHwm;else this.highWaterMark = defaultHwm;
	
	  // cast to ints.
	  this.highWaterMark = Math.floor(this.highWaterMark);
	
	  // if _final has been called
	  this.finalCalled = false;
	
	  // drain event flag.
	  this.needDrain = false;
	  // at the start of calling end()
	  this.ending = false;
	  // when end() has been called, and returned
	  this.ended = false;
	  // when 'finish' is emitted
	  this.finished = false;
	
	  // has it been destroyed
	  this.destroyed = false;
	
	  // should we decode strings into buffers before passing to _write?
	  // this is here so that some node-core streams can optimize string
	  // handling at a lower level.
	  var noDecode = options.decodeStrings === false;
	  this.decodeStrings = !noDecode;
	
	  // Crypto is kind of old and crusty.  Historically, its default string
	  // encoding is 'binary' so we have to make this configurable.
	  // Everything else in the universe uses 'utf8', though.
	  this.defaultEncoding = options.defaultEncoding || 'utf8';
	
	  // not an actual buffer we keep track of, but a measurement
	  // of how much we're waiting to get pushed to some underlying
	  // socket or file.
	  this.length = 0;
	
	  // a flag to see when we're in the middle of a write.
	  this.writing = false;
	
	  // when true all writes will be buffered until .uncork() call
	  this.corked = 0;
	
	  // a flag to be able to tell if the onwrite cb is called immediately,
	  // or on a later tick.  We set this to true at first, because any
	  // actions that shouldn't happen until "later" should generally also
	  // not happen before the first write call.
	  this.sync = true;
	
	  // a flag to know if we're processing previously buffered items, which
	  // may call the _write() callback in the same tick, so that we don't
	  // end up in an overlapped onwrite situation.
	  this.bufferProcessing = false;
	
	  // the callback that's passed to _write(chunk,cb)
	  this.onwrite = function (er) {
	    onwrite(stream, er);
	  };
	
	  // the callback that the user supplies to write(chunk,encoding,cb)
	  this.writecb = null;
	
	  // the amount that is being written when _write is called.
	  this.writelen = 0;
	
	  this.bufferedRequest = null;
	  this.lastBufferedRequest = null;
	
	  // number of pending user-supplied write callbacks
	  // this must be 0 before 'finish' can be emitted
	  this.pendingcb = 0;
	
	  // emit prefinish if the only thing we're waiting for is _write cbs
	  // This is relevant for synchronous Transform streams
	  this.prefinished = false;
	
	  // True if the error was already emitted and should not be thrown again
	  this.errorEmitted = false;
	
	  // count buffered requests
	  this.bufferedRequestCount = 0;
	
	  // allocate the first CorkedRequest, there is always
	  // one allocated and free to use, and we maintain at most two
	  this.corkedRequestsFree = new CorkedRequest(this);
	}
	
	WritableState.prototype.getBuffer = function getBuffer() {
	  var current = this.bufferedRequest;
	  var out = [];
	  while (current) {
	    out.push(current);
	    current = current.next;
	  }
	  return out;
	};
	
	(function () {
	  try {
	    Object.defineProperty(WritableState.prototype, 'buffer', {
	      get: internalUtil.deprecate(function () {
	        return this.getBuffer();
	      }, '_writableState.buffer is deprecated. Use _writableState.getBuffer ' + 'instead.', 'DEP0003')
	    });
	  } catch (_) {}
	})();
	
	// Test _writableState for inheritance to account for Duplex streams,
	// whose prototype chain only points to Readable.
	var realHasInstance;
	if (typeof Symbol === 'function' && Symbol.hasInstance && typeof Function.prototype[Symbol.hasInstance] === 'function') {
	  realHasInstance = Function.prototype[Symbol.hasInstance];
	  Object.defineProperty(Writable, Symbol.hasInstance, {
	    value: function (object) {
	      if (realHasInstance.call(this, object)) return true;
	      if (this !== Writable) return false;
	
	      return object && object._writableState instanceof WritableState;
	    }
	  });
	} else {
	  realHasInstance = function (object) {
	    return object instanceof this;
	  };
	}
	
	function Writable(options) {
	  Duplex = Duplex || __webpack_require__(105);
	
	  // Writable ctor is applied to Duplexes, too.
	  // `realHasInstance` is necessary because using plain `instanceof`
	  // would return false, as no `_writableState` property is attached.
	
	  // Trying to use the custom `instanceof` for Writable here will also break the
	  // Node.js LazyTransform implementation, which has a non-trivial getter for
	  // `_writableState` that would lead to infinite recursion.
	  if (!realHasInstance.call(Writable, this) && !(this instanceof Duplex)) {
	    return new Writable(options);
	  }
	
	  this._writableState = new WritableState(options, this);
	
	  // legacy.
	  this.writable = true;
	
	  if (options) {
	    if (typeof options.write === 'function') this._write = options.write;
	
	    if (typeof options.writev === 'function') this._writev = options.writev;
	
	    if (typeof options.destroy === 'function') this._destroy = options.destroy;
	
	    if (typeof options.final === 'function') this._final = options.final;
	  }
	
	  Stream.call(this);
	}
	
	// Otherwise people can pipe Writable streams, which is just wrong.
	Writable.prototype.pipe = function () {
	  this.emit('error', new Error('Cannot pipe, not readable'));
	};
	
	function writeAfterEnd(stream, cb) {
	  var er = new Error('write after end');
	  // TODO: defer error events consistently everywhere, not just the cb
	  stream.emit('error', er);
	  pna.nextTick(cb, er);
	}
	
	// Checks that a user-supplied chunk is valid, especially for the particular
	// mode the stream is in. Currently this means that `null` is never accepted
	// and undefined/non-string values are only allowed in object mode.
	function validChunk(stream, state, chunk, cb) {
	  var valid = true;
	  var er = false;
	
	  if (chunk === null) {
	    er = new TypeError('May not write null values to stream');
	  } else if (typeof chunk !== 'string' && chunk !== undefined && !state.objectMode) {
	    er = new TypeError('Invalid non-string/buffer chunk');
	  }
	  if (er) {
	    stream.emit('error', er);
	    pna.nextTick(cb, er);
	    valid = false;
	  }
	  return valid;
	}
	
	Writable.prototype.write = function (chunk, encoding, cb) {
	  var state = this._writableState;
	  var ret = false;
	  var isBuf = !state.objectMode && _isUint8Array(chunk);
	
	  if (isBuf && !Buffer.isBuffer(chunk)) {
	    chunk = _uint8ArrayToBuffer(chunk);
	  }
	
	  if (typeof encoding === 'function') {
	    cb = encoding;
	    encoding = null;
	  }
	
	  if (isBuf) encoding = 'buffer';else if (!encoding) encoding = state.defaultEncoding;
	
	  if (typeof cb !== 'function') cb = nop;
	
	  if (state.ended) writeAfterEnd(this, cb);else if (isBuf || validChunk(this, state, chunk, cb)) {
	    state.pendingcb++;
	    ret = writeOrBuffer(this, state, isBuf, chunk, encoding, cb);
	  }
	
	  return ret;
	};
	
	Writable.prototype.cork = function () {
	  var state = this._writableState;
	
	  state.corked++;
	};
	
	Writable.prototype.uncork = function () {
	  var state = this._writableState;
	
	  if (state.corked) {
	    state.corked--;
	
	    if (!state.writing && !state.corked && !state.finished && !state.bufferProcessing && state.bufferedRequest) clearBuffer(this, state);
	  }
	};
	
	Writable.prototype.setDefaultEncoding = function setDefaultEncoding(encoding) {
	  // node::ParseEncoding() requires lower case.
	  if (typeof encoding === 'string') encoding = encoding.toLowerCase();
	  if (!(['hex', 'utf8', 'utf-8', 'ascii', 'binary', 'base64', 'ucs2', 'ucs-2', 'utf16le', 'utf-16le', 'raw'].indexOf((encoding + '').toLowerCase()) > -1)) throw new TypeError('Unknown encoding: ' + encoding);
	  this._writableState.defaultEncoding = encoding;
	  return this;
	};
	
	function decodeChunk(state, chunk, encoding) {
	  if (!state.objectMode && state.decodeStrings !== false && typeof chunk === 'string') {
	    chunk = Buffer.from(chunk, encoding);
	  }
	  return chunk;
	}
	
	Object.defineProperty(Writable.prototype, 'writableHighWaterMark', {
	  // making it explicit this property is not enumerable
	  // because otherwise some prototype manipulation in
	  // userland will fail
	  enumerable: false,
	  get: function () {
	    return this._writableState.highWaterMark;
	  }
	});
	
	// if we're already writing something, then just put this
	// in the queue, and wait our turn.  Otherwise, call _write
	// If we return false, then we need a drain event, so set that flag.
	function writeOrBuffer(stream, state, isBuf, chunk, encoding, cb) {
	  if (!isBuf) {
	    var newChunk = decodeChunk(state, chunk, encoding);
	    if (chunk !== newChunk) {
	      isBuf = true;
	      encoding = 'buffer';
	      chunk = newChunk;
	    }
	  }
	  var len = state.objectMode ? 1 : chunk.length;
	
	  state.length += len;
	
	  var ret = state.length < state.highWaterMark;
	  // we must ensure that previous needDrain will not be reset to false.
	  if (!ret) state.needDrain = true;
	
	  if (state.writing || state.corked) {
	    var last = state.lastBufferedRequest;
	    state.lastBufferedRequest = {
	      chunk: chunk,
	      encoding: encoding,
	      isBuf: isBuf,
	      callback: cb,
	      next: null
	    };
	    if (last) {
	      last.next = state.lastBufferedRequest;
	    } else {
	      state.bufferedRequest = state.lastBufferedRequest;
	    }
	    state.bufferedRequestCount += 1;
	  } else {
	    doWrite(stream, state, false, len, chunk, encoding, cb);
	  }
	
	  return ret;
	}
	
	function doWrite(stream, state, writev, len, chunk, encoding, cb) {
	  state.writelen = len;
	  state.writecb = cb;
	  state.writing = true;
	  state.sync = true;
	  if (writev) stream._writev(chunk, state.onwrite);else stream._write(chunk, encoding, state.onwrite);
	  state.sync = false;
	}
	
	function onwriteError(stream, state, sync, er, cb) {
	  --state.pendingcb;
	
	  if (sync) {
	    // defer the callback if we are being called synchronously
	    // to avoid piling up things on the stack
	    pna.nextTick(cb, er);
	    // this can emit finish, and it will always happen
	    // after error
	    pna.nextTick(finishMaybe, stream, state);
	    stream._writableState.errorEmitted = true;
	    stream.emit('error', er);
	  } else {
	    // the caller expect this to happen before if
	    // it is async
	    cb(er);
	    stream._writableState.errorEmitted = true;
	    stream.emit('error', er);
	    // this can emit finish, but finish must
	    // always follow error
	    finishMaybe(stream, state);
	  }
	}
	
	function onwriteStateUpdate(state) {
	  state.writing = false;
	  state.writecb = null;
	  state.length -= state.writelen;
	  state.writelen = 0;
	}
	
	function onwrite(stream, er) {
	  var state = stream._writableState;
	  var sync = state.sync;
	  var cb = state.writecb;
	
	  onwriteStateUpdate(state);
	
	  if (er) onwriteError(stream, state, sync, er, cb);else {
	    // Check if we're actually ready to finish, but don't emit yet
	    var finished = needFinish(state);
	
	    if (!finished && !state.corked && !state.bufferProcessing && state.bufferedRequest) {
	      clearBuffer(stream, state);
	    }
	
	    if (sync) {
	      /*<replacement>*/
	      asyncWrite(afterWrite, stream, state, finished, cb);
	      /*</replacement>*/
	    } else {
	      afterWrite(stream, state, finished, cb);
	    }
	  }
	}
	
	function afterWrite(stream, state, finished, cb) {
	  if (!finished) onwriteDrain(stream, state);
	  state.pendingcb--;
	  cb();
	  finishMaybe(stream, state);
	}
	
	// Must force callback to be called on nextTick, so that we don't
	// emit 'drain' before the write() consumer gets the 'false' return
	// value, and has a chance to attach a 'drain' listener.
	function onwriteDrain(stream, state) {
	  if (state.length === 0 && state.needDrain) {
	    state.needDrain = false;
	    stream.emit('drain');
	  }
	}
	
	// if there's something in the buffer waiting, then process it
	function clearBuffer(stream, state) {
	  state.bufferProcessing = true;
	  var entry = state.bufferedRequest;
	
	  if (stream._writev && entry && entry.next) {
	    // Fast case, write everything using _writev()
	    var l = state.bufferedRequestCount;
	    var buffer = new Array(l);
	    var holder = state.corkedRequestsFree;
	    holder.entry = entry;
	
	    var count = 0;
	    var allBuffers = true;
	    while (entry) {
	      buffer[count] = entry;
	      if (!entry.isBuf) allBuffers = false;
	      entry = entry.next;
	      count += 1;
	    }
	    buffer.allBuffers = allBuffers;
	
	    doWrite(stream, state, true, state.length, buffer, '', holder.finish);
	
	    // doWrite is almost always async, defer these to save a bit of time
	    // as the hot path ends with doWrite
	    state.pendingcb++;
	    state.lastBufferedRequest = null;
	    if (holder.next) {
	      state.corkedRequestsFree = holder.next;
	      holder.next = null;
	    } else {
	      state.corkedRequestsFree = new CorkedRequest(state);
	    }
	    state.bufferedRequestCount = 0;
	  } else {
	    // Slow case, write chunks one-by-one
	    while (entry) {
	      var chunk = entry.chunk;
	      var encoding = entry.encoding;
	      var cb = entry.callback;
	      var len = state.objectMode ? 1 : chunk.length;
	
	      doWrite(stream, state, false, len, chunk, encoding, cb);
	      entry = entry.next;
	      state.bufferedRequestCount--;
	      // if we didn't call the onwrite immediately, then
	      // it means that we need to wait until it does.
	      // also, that means that the chunk and cb are currently
	      // being processed, so move the buffer counter past them.
	      if (state.writing) {
	        break;
	      }
	    }
	
	    if (entry === null) state.lastBufferedRequest = null;
	  }
	
	  state.bufferedRequest = entry;
	  state.bufferProcessing = false;
	}
	
	Writable.prototype._write = function (chunk, encoding, cb) {
	  cb(new Error('_write() is not implemented'));
	};
	
	Writable.prototype._writev = null;
	
	Writable.prototype.end = function (chunk, encoding, cb) {
	  var state = this._writableState;
	
	  if (typeof chunk === 'function') {
	    cb = chunk;
	    chunk = null;
	    encoding = null;
	  } else if (typeof encoding === 'function') {
	    cb = encoding;
	    encoding = null;
	  }
	
	  if (chunk !== null && chunk !== undefined) this.write(chunk, encoding);
	
	  // .end() fully uncorks
	  if (state.corked) {
	    state.corked = 1;
	    this.uncork();
	  }
	
	  // ignore unnecessary end() calls.
	  if (!state.ending && !state.finished) endWritable(this, state, cb);
	};
	
	function needFinish(state) {
	  return state.ending && state.length === 0 && state.bufferedRequest === null && !state.finished && !state.writing;
	}
	function callFinal(stream, state) {
	  stream._final(function (err) {
	    state.pendingcb--;
	    if (err) {
	      stream.emit('error', err);
	    }
	    state.prefinished = true;
	    stream.emit('prefinish');
	    finishMaybe(stream, state);
	  });
	}
	function prefinish(stream, state) {
	  if (!state.prefinished && !state.finalCalled) {
	    if (typeof stream._final === 'function') {
	      state.pendingcb++;
	      state.finalCalled = true;
	      pna.nextTick(callFinal, stream, state);
	    } else {
	      state.prefinished = true;
	      stream.emit('prefinish');
	    }
	  }
	}
	
	function finishMaybe(stream, state) {
	  var need = needFinish(state);
	  if (need) {
	    prefinish(stream, state);
	    if (state.pendingcb === 0) {
	      state.finished = true;
	      stream.emit('finish');
	    }
	  }
	  return need;
	}
	
	function endWritable(stream, state, cb) {
	  state.ending = true;
	  finishMaybe(stream, state);
	  if (cb) {
	    if (state.finished) pna.nextTick(cb);else stream.once('finish', cb);
	  }
	  state.ended = true;
	  stream.writable = false;
	}
	
	function onCorkedFinish(corkReq, state, err) {
	  var entry = corkReq.entry;
	  corkReq.entry = null;
	  while (entry) {
	    var cb = entry.callback;
	    state.pendingcb--;
	    cb(err);
	    entry = entry.next;
	  }
	  if (state.corkedRequestsFree) {
	    state.corkedRequestsFree.next = corkReq;
	  } else {
	    state.corkedRequestsFree = corkReq;
	  }
	}
	
	Object.defineProperty(Writable.prototype, 'destroyed', {
	  get: function () {
	    if (this._writableState === undefined) {
	      return false;
	    }
	    return this._writableState.destroyed;
	  },
	  set: function (value) {
	    // we ignore the value if the stream
	    // has not been initialized yet
	    if (!this._writableState) {
	      return;
	    }
	
	    // backward compatibility, the user is explicitly
	    // managing destroyed
	    this._writableState.destroyed = value;
	  }
	});
	
	Writable.prototype.destroy = destroyImpl.destroy;
	Writable.prototype._undestroy = destroyImpl.undestroy;
	Writable.prototype._destroy = function (err, cb) {
	  this.end();
	  cb(err);
	};
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(77), __webpack_require__(1480).setImmediate, (function() { return this; }())))

/***/ },
/* 320 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(523);
	exports.Stream = exports;
	exports.Readable = exports;
	exports.Writable = __webpack_require__(319);
	exports.Duplex = __webpack_require__(105);
	exports.Transform = __webpack_require__(524);
	exports.PassThrough = __webpack_require__(1358);


/***/ },
/* 321 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.compose = exports.applyMiddleware = exports.bindActionCreators = exports.combineReducers = exports.createStore = undefined;
	
	var _createStore = __webpack_require__(528);
	
	var _createStore2 = _interopRequireDefault(_createStore);
	
	var _combineReducers = __webpack_require__(1366);
	
	var _combineReducers2 = _interopRequireDefault(_combineReducers);
	
	var _bindActionCreators = __webpack_require__(1365);
	
	var _bindActionCreators2 = _interopRequireDefault(_bindActionCreators);
	
	var _applyMiddleware = __webpack_require__(1364);
	
	var _applyMiddleware2 = _interopRequireDefault(_applyMiddleware);
	
	var _compose = __webpack_require__(527);
	
	var _compose2 = _interopRequireDefault(_compose);
	
	var _warning = __webpack_require__(529);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	/*
	* This is a dummy function to check if the function name has been altered by minification.
	* If the function has been minified and NODE_ENV !== 'production', warn the user.
	*/
	function isCrushed() {}
	
	if (false) {
	  (0, _warning2['default'])('You are currently using minified code outside of NODE_ENV === \'production\'. ' + 'This means that you are running a slower development build of Redux. ' + 'You can use loose-envify (https://github.com/zertosh/loose-envify) for browserify ' + 'or DefinePlugin for webpack (http://stackoverflow.com/questions/30030031) ' + 'to ensure you have the correct code for your production build.');
	}
	
	exports.createStore = _createStore2['default'];
	exports.combineReducers = _combineReducers2['default'];
	exports.bindActionCreators = _bindActionCreators2['default'];
	exports.applyMiddleware = _applyMiddleware2['default'];
	exports.compose = _compose2['default'];

/***/ },
/* 322 */
/***/ function(module, exports) {

	'use strict';
	
	module.exports = interrupt;
	
	function interrupt(interruptors, tokenizers, ctx, params) {
	  var bools = ['pedantic', 'commonmark'];
	  var count = bools.length;
	  var length = interruptors.length;
	  var index = -1;
	  var interruptor;
	  var config;
	  var fn;
	  var offset;
	  var bool;
	  var ignore;
	
	  while (++index < length) {
	    interruptor = interruptors[index];
	    config = interruptor[1] || {};
	    fn = interruptor[0];
	    offset = -1;
	    ignore = false;
	
	    while (++offset < count) {
	      bool = bools[offset];
	
	      if (config[bool] !== undefined && config[bool] !== ctx.options[bool]) {
	        ignore = true;
	        break;
	      }
	    }
	
	    if (ignore) {
	      continue;
	    }
	
	    if (tokenizers[fn].apply(ctx, params)) {
	      return true;
	    }
	  }
	
	  return false;
	}


/***/ },
/* 323 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var collapseWhiteSpace = __webpack_require__(620);
	
	module.exports = normalize;
	
	/* Normalize an identifier.  Collapses multiple white space
	 * characters into a single space, and removes casing. */
	function normalize(value) {
	  return collapseWhiteSpace(value).toLowerCase();
	}


/***/ },
/* 324 */
/***/ function(module, exports) {

	/*!
	 * repeat-string <https://github.com/jonschlinkert/repeat-string>
	 *
	 * Copyright (c) 2014-2015, Jon Schlinkert.
	 * Licensed under the MIT License.
	 */
	
	'use strict';
	
	/**
	 * Results cache
	 */
	
	var res = '';
	var cache;
	
	/**
	 * Expose `repeat`
	 */
	
	module.exports = repeat;
	
	/**
	 * Repeat the given `string` the specified `number`
	 * of times.
	 *
	 * **Example:**
	 *
	 * ```js
	 * var repeat = require('repeat-string');
	 * repeat('A', 5);
	 * //=> AAAAA
	 * ```
	 *
	 * @param {String} `string` The string to repeat
	 * @param {Number} `number` The number of times to repeat the string
	 * @return {String} Repeated string
	 * @api public
	 */
	
	function repeat(str, num) {
	  if (typeof str !== 'string') {
	    throw new TypeError('expected a string');
	  }
	
	  // cover common, quick use cases
	  if (num === 1) return str;
	  if (num === 2) return str + str;
	
	  var max = str.length * num;
	  if (cache !== str || typeof cache === 'undefined') {
	    cache = str;
	    res = '';
	  } else if (res.length >= max) {
	    return res.substr(0, max);
	  }
	
	  while (max > res.length && num > 1) {
	    if (num & 1) {
	      res += str;
	    }
	
	    num >>= 1;
	    str += str;
	  }
	
	  res += str;
	  res = res.substr(0, max);
	  return res;
	}


/***/ },
/* 325 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", { value: true });
	var isProduction = ("production") === 'production';
	var prefix = 'Invariant failed';
	function invariant(condition, message) {
	    if (condition) {
	        return;
	    }
	    if (isProduction) {
	        throw new Error(prefix);
	    }
	    throw new Error(prefix + ": " + (message || ''));
	}
	exports.default = invariant;


/***/ },
/* 326 */
/***/ function(module, exports) {

	'use strict'
	
	module.exports = trimTrailingLines
	
	var line = '\n'
	
	// Remove final newline characters from `value`.
	function trimTrailingLines(value) {
	  var val = String(value)
	  var index = val.length
	
	  while (val.charAt(--index) === line) {
	    // Empty
	  }
	
	  return val.slice(0, index + 1)
	}


/***/ },
/* 327 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global, process) {// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.
	
	var formatRegExp = /%[sdj%]/g;
	exports.format = function(f) {
	  if (!isString(f)) {
	    var objects = [];
	    for (var i = 0; i < arguments.length; i++) {
	      objects.push(inspect(arguments[i]));
	    }
	    return objects.join(' ');
	  }
	
	  var i = 1;
	  var args = arguments;
	  var len = args.length;
	  var str = String(f).replace(formatRegExp, function(x) {
	    if (x === '%%') return '%';
	    if (i >= len) return x;
	    switch (x) {
	      case '%s': return String(args[i++]);
	      case '%d': return Number(args[i++]);
	      case '%j':
	        try {
	          return JSON.stringify(args[i++]);
	        } catch (_) {
	          return '[Circular]';
	        }
	      default:
	        return x;
	    }
	  });
	  for (var x = args[i]; i < len; x = args[++i]) {
	    if (isNull(x) || !isObject(x)) {
	      str += ' ' + x;
	    } else {
	      str += ' ' + inspect(x);
	    }
	  }
	  return str;
	};
	
	
	// Mark that a method should not be used.
	// Returns a modified function which warns once by default.
	// If --no-deprecation is set, then it is a no-op.
	exports.deprecate = function(fn, msg) {
	  // Allow for deprecating things in the process of starting up.
	  if (isUndefined(global.process)) {
	    return function() {
	      return exports.deprecate(fn, msg).apply(this, arguments);
	    };
	  }
	
	  if (process.noDeprecation === true) {
	    return fn;
	  }
	
	  var warned = false;
	  function deprecated() {
	    if (!warned) {
	      if (process.throwDeprecation) {
	        throw new Error(msg);
	      } else if (process.traceDeprecation) {
	        console.trace(msg);
	      } else {
	        console.error(msg);
	      }
	      warned = true;
	    }
	    return fn.apply(this, arguments);
	  }
	
	  return deprecated;
	};
	
	
	var debugs = {};
	var debugEnviron;
	exports.debuglog = function(set) {
	  if (isUndefined(debugEnviron))
	    debugEnviron = ({"NODE_ENV":"production","BUILD_DATE":"2025-08-27T15:15:31.687Z","BUILD_NUMBER":"Not Provided","GIT_VERSION":"v1.3.0-381-ga81e29b08","GIT_COMMIT_HASH":"a81e29b085c9268ffd96c78eb734365802722741","GIT_BRANCH":"beta","PUBLIC_URL":"","STATE_ABBR":"MT","STATE_NAME":"Montana","STATE_ORG_TITLE":"Secretary of State","LOGIN_HEADER_IMG_PATH":"","HOME_IMG_FILENAME":"montana.jpg","FAVICON_FILE_NAME":"favicon.ico","ALLOW_E_SIGN_ON_CORRECTIONS":true,"THIRD_PARTY_SIGNING_ALLOWED":false,"MY_ACCOUNT_SAVE_AND_CLOSE_BUTTON":true,"IE_DEPRECATED_MESSAGE":"Internet Explorer is not supported. Please select a supported browser below to access this website.","ADDITIONAL_ROUTES":{"dataRequests":true,"farmBill":true,"apostille":true,"externalHelp":"https://sosmt.gov/business/help-center/","systemAdministration":[{"title":"Saved Payments","parameter":"saved-payments","componentName":"SavedPayments"}]},"SUBROUTES":[{"label":"Business","component":"Business","parameter":"business","myWorkQueueSearch":false,"sourceTypeId":54,"searchMustHaveOneOf":["FILING_TYPE_ID","STATUS_ID","STATE","search"],"serverWebSearchDescription":true,"serverWorkQueueDescription":true,"serverMyRecordsDescription":true,"searchPlaceholder":"Search by name or filing number (X########)","allowEmptySearchTerm":true,"requestCertificateAlternateLabel":"Request Information","fileAmendmentButtonLabel":"Filing Actions","advancedSearchParameters":[{"type":"radio","name":"QUERY_TYPE_ID","defaultValue":1010,"options":[{"value":1010,"label":"Starts with"},{"value":1011,"label":"Contains"},{"value":1012,"label":" Word Contains"}]},{"type":"serverSelect","name":"FILING_TYPE_ID","optionsSrc":"FILING_TYPES","label":"Entity Type","placeholder":"All","defaultValue":"0"},{"type":"serverSelect","name":"FILING_SUBTYPE_ID","optionsSrc":"FILING_SUBTYPES","label":"Entity Subtype","overrideSubOptionsSrcFromParameterName":"FILING_TYPE_ID","placeholder":"All","defaultValue":"0"},{"type":"serverSelect","name":"STATUS_ID","optionsSrc":"FILING_STATUS_WITHOUT_ALL","label":"Status","placeholder":"All","defaultValue":"0"},{"type":"serverSelect","name":"STATE","optionsSrc":"STATE","label":"State","placeholder":"All","defaultValue":""},{"type":"serverSelect","name":"COUNTY","optionsSrc":"COUNTY_SUBOPTION","label":"County","overrideSubOptionsSrcFromParameterName":"STATE","placeholder":"All","defaultValue":""},{"type":"checkbox","name":"CRA_SEARCH_YN","defaultValue":false,"label":"Search by Registered Agent PID"},{"type":"dateRange","name":"FILING_DATE","label":"Registration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}},{"type":"dateRange","name":"EXPIRATION_DATE","label":"Expiration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}}],"myRecordsFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Active"},{"value":2,"label":"Inactive"},{"value":3,"label":"Pending"}]},{"type":"dateRange","name":"DATE_RANGE","label":"Date range","defaultValue":{"start":null,"end":null}}],"myWorkQueueFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Approved"},{"value":2,"label":"Pending Online Payment"},{"value":3,"label":"Pending Review"},{"value":4,"label":"Needs Correction"},{"value":5,"label":"Rejected"},{"value":6,"label":"Draft"}]},{"type":"dateRange","name":"DATE_RANGE","label":"Date range","defaultValue":{"start":null,"end":null}}]},{"label":"Notary","component":"Notary","parameter":"notary","sourceTypeId":850,"myWorkQueueSearch":false,"allowEmptySearchTerm":true,"requestCertificateAlternateLabel":"Download Certificate","fileAmendmentButtonLabel":"Filing Actions","hideNameRequestCertificate":true,"hideAddressRequestCertificate":true,"hideRecordUserManagment":true,"searchPlaceholder":"Search by name or commission number","searchMustHaveOneOf":["CITY","search","SERVICE_TYPE"],"advancedParametersStartOpen":true,"searchIsSortable":true,"advancedSearchParameters":[{"type":"radio","name":"STARTS_WITH_YN","defaultValue":false,"options":[{"value":true,"label":"Starts with"},{"value":false,"label":"Contains"}]},{"type":"checkbox","name":"ACTIVE_ONLY_YN","defaultValue":true,"label":"Active entities only"},{"type":"text","name":"CITY","defaultValue":"","label":"City"},{"type":"select","name":"SERVICE_TYPE","label":"Special Services Offered","defaultValue":0,"options":[{"value":0,"label":"(N/A)"},{"value":6165,"label":"In-Person Electronic Notarization (IPEN)"},{"value":6166,"label":"Remote Online Notarization (RON)"},{"value":6167,"label":"Mobile Notary Services"},{"value":6168,"label":"Remote Ink Notarization (RIN)"}]}]},{"label":"Apostille","component":"Apostille","parameter":"apostille","sourceTypeId":720,"myRecordsSearch":false,"myWorkQueueSearch":false,"disabled":false,"allowedRoutes":["/forms-manager/","/queue/","/forms/"]},{"label":"Liens","component":"UCC","parameter":"ucc","sourceTypeId":1999,"myRecordsSearch":true,"myWorkQueueSearch":true,"fileAmendmentButtonLabel":"Filing Actions","searchPlaceholder":"Search by name or file number","disabled":false,"serverWebSearchDescription":true,"myRecordsDescription":"","workQueueDescription":"","searchDescription":"","hideRecordUserManagment":true,"searchLiensCheckout":false,"advancedSearchParameters":[{"type":"radio","name":"STARTS_WITH_YN","defaultValue":false,"options":[{"value":true,"label":"Starts with"},{"value":false,"label":"Contains"}]},{"type":"select","name":"STATUS","defaultValue":"ALL","label":"Status","options":[{"value":"ACTIVE_UNLAPSED","label":"Active (unlapsed)"},{"value":"ACTIVE_LAPSED_UNLAPSED","label":"Active (lapsed and unlapsed)"}]},{"type":"text","name":"EXCLUDE_VALUES","label":"Exclude Debtor Names (comma separated list of names to exclude)","defaultValue":""},{"type":"dateRange","name":"FILING_DATE","label":"Financing Statement Date","defaultValue":{"start":null,"end":null}},{"type":"dateRange","name":"LAPSE_DATE","label":"Lapse Date","defaultValue":{"start":null,"end":null}},{"type":"text","name":"CITY","label":"Debtor City","defaultValue":""}],"myRecordsFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Approved"},{"value":2,"label":"Pending Online Payment"},{"value":3,"label":"Pending Review"}]},{"type":"select","name":"TYPE","defaultValue":0,"label":"Lien Type","options":[{"value":0,"label":"All"},{"value":1,"label":"UCC"},{"value":2,"label":"EFS"},{"value":3,"label":"Title 71"}]}],"myWorkQueueFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Approved"},{"value":2,"label":"Pending Online Payment"},{"value":3,"label":"Pending Review"},{"value":4,"label":"Pending Print and Mail"},{"value":5,"label":"Rejected"},{"value":6,"label":"Draft"}]},{"type":"select","name":"TYPE","defaultValue":0,"label":"Lien Type","options":[{"value":0,"label":"All"},{"value":1,"label":"UCC"},{"value":2,"label":"EFS"},{"value":3,"label":"Title 71"}]}]},{"label":"Copy Request","component":"copies","parameter":"copies","sourceTypeId":2001,"myRecordsSearch":false,"myWorkQueueSearch":false,"disabled":false,"allowedRoutes":["/forms-manager/","/queue/","/forms/"]},{"label":"Trademark","component":"Trademark","parameter":"trademark","sourceTypeId":810,"showRequestCertificate":true,"searchMustHaveOneOf":["search","EXPIRATION_DATE","FILING_DATE"],"allowEmptySearchTerm":true,"requestCertificateAlternateLabel":"Request Information","fileAmendmentButtonLabel":"Filing Actions","advancedSearchParameters":[{"type":"radio","name":"QUERY_TYPE_ID","defaultValue":1010,"options":[{"value":1010,"label":"Starts with"},{"value":1011,"label":"Contains"},{"value":1012,"label":" Word Contains"}]},{"type":"checkbox","name":"OWNER_SEARCH_YN","defaultValue":false,"label":"Search owners"},{"type":"radio","name":"SERVICE_MARK_YN","label":"Mark Type","defaultValue":"","options":[{"value":"","label":"All Marks"},{"value":"Y","label":"Service Mark"},{"value":"N","label":"Trademark"}]},{"type":"serverSelect","name":"STATUS_ID","optionsSrc":"TYPE_V|TRADEMARK_STATUS_TYPE","label":"Status","placeholder":"All","defaultValue":"0"},{"type":"select","name":"DESIGN_TYPE_ID","options":[{"value":0,"label":"All"},{"value":990,"label":"Words Only"},{"value":991,"label":"Design Only"},{"value":992,"label":"Words and Design"}],"label":"Design Type","defaultValue":"0"},{"type":"dateRange","name":"FILING_DATE","label":"Registered Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}},{"type":"dateRange","name":"EXPIRATION_DATE","label":"Expiration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}}]},{"label":"Business Info Request","component":"InfoRequests","parameter":"info-request","sourceTypeId":167,"allowedRoutes":["/forms-manager/","/queue/","/forms/"]},{"label":"Data Requests","component":"DataRequests","parameter":"data-request","sourceTypeId":0,"allowedRoutes":["/forms-manager/"]},{"label":"CRA","component":"CRA","parameter":"cra","sourceTypeId":157,"myRecordsSearch":false,"searchPlaceholder":"Search by name or registered agent number","allowedRoutes":["/forms-manager/","/forms/","/records/","/queue/","/search/"],"allowEmptySearchTerm":true,"fileAmendmentButtonLabel":"Filing Actions","advancedSearchParameters":[{"type":"radio","name":"QUERY_TYPE_ID","defaultValue":1010,"options":[{"value":1010,"label":"Starts with"},{"value":1011,"label":"Contains"},{"value":1012,"label":" Word Contains"}]},{"type":"dateRange","name":"CRA_DATE","label":"Registration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}},{"type":"select","name":"STATUS_ID","label":"Status","defaultValue":0,"options":[{"value":0,"label":"All"},{"value":121,"label":"Active"},{"value":122,"label":"Inactive"}]},{"type":"select","name":"AGENT_TYPE_ID","label":"Agent Type","defaultValue":0,"options":[{"value":0,"label":"All"},{"value":460,"label":"Registered Agent"},{"value":461,"label":"Commercial Registered Agent"}]}]},{"label":"Farm Bill","component":"FarmBill","parameter":"farm-bill","path":"/lists/farm-bill","sourceTypeId":0,"myRecordsSearch":false,"allowedRules":["/search/"],"disabled":true,"searchDescription":"To perform a search, enter a debtor name. Your search results may include: exact debtor name, variations of that name and any filing that includes your search criteria. Punctuation is ignored.\n\nYou can click on \"Advanced\" to refine your search. Under “Advanced” you can search by crop, year, county and SSN/FEIN. As a registered Farm Bill Buyer with the Montana Secretary of State’s office it is important to maintain the confidentiality of the information contained within the Farm Bill Master List. The Farm Bill Master List reflects personal data, such as Social Security Numbers, which are a key piece of personal identifiable information to assist you in determining the existence of a lien against a specific debtor. The distribution of this information beyond its intended purpose is strictly prohibited.\n\nThe debtor's tax identification number has been hidden for confidentiality reasons. You may continue to search on a tax ID number and return debtors that match your search criteria. The SSN/FEIN must be entered without dashes or spaces.","searchMustHaveOneOf":["search","UCC_FARM_PRODUCT_ID","COUNTY"],"searchPlaceholder":"Search by debtor name","advancedSearchParameters":[{"type":"ServerMultiComplete","label":"Product code name(s)","name":"UCC_FARM_PRODUCT_ID","defaultValue":"","optionsSrc":"UCC_FARM_PRODUCT_V"},{"type":"MultiComplete","label":"Year or Range of Years","name":"YEAR_NUM","optionsSrc":"years","startYear":"1968","defaultValue":[],"preMergeOptions":[{"value":"ALL","label":"All"}]},{"type":"serverSelect","label":"State","name":"STATE","defaultValue":"MONTANA","optionsSrc":"STATE"},{"type":"ServerMultiComplete","label":"County","name":"COUNTY","defaultValue":[],"optionsSrc":"COUNTY","overrideSubOptionsSrcFromParameterName":"STATE"},{"type":"checkbox","name":"TIN_SEARCH_YN","defaultValue":false,"label":"Tax Identification Number Search"},{"type":"checkbox","name":"TIN_SORT_YN","defaultValue":false,"label":"Unique ID Sort"}]}],"SYSTEM_NICKNAME":"Online Services Portal","PAYMENT_METHODS":[{"type":"bypass"},{"type":"iTransact"}],"PAYMENT_ALLOW_AMEX":true,"SYSTEM_ID_LABEL":"System Id","DOUBLE_COLUMN_PUBLIC_LOGIN":true,"INTERNAL_USER_MANAGEMENT":true,"ALLOW_PUBLIC_JSON_IMPORT":false,"MAX_FILE_UPLOAD_SIZE":10000000,"REFUND_TEXT":"","RETURN_TO_HOME_ON_LOGOUT":true,"CURRENT_SOS_NAME":"Christi Jacobsen","LOGO_FILENAME":"mt-sos-logo.png","LOGO_ALT":"Christi Jacobsen, Montana Secretary of State","LOGO_FULL_WIDTH":true,"HOME_HIDE_AUTH_HINT":true,"HOME_TITLE":"Montana Secretary of State","CUSTOM_TAB_TITLE":"Official Montana","HOME_SUBTITLE":"Online Business Services","ENTITY_NAME_CONSENT_DESCRIPTION":"","ALLOW_USER_PROFILE_EDITING":true,"COMPARE_FOREIGN_NAME_IN_ENTITY_NAME_VALIDATION":true,"FOREIGN_NAME_FIELD_NAME":"KIMA_PARENT_NAME_INFO","LOGIN_TITLE":"Montana Secretary of State Online Filing Portal Login","PUBLIC_LOGIN_LABEL":"Username","REVERSE_LOGIN_COLUMNS":true,"LOGIN_SEAL_FILENAME":"seal_white.png","SEPARATE_USERNAME_AND_EMAIL":true,"CREATE_ACCOUNT_BUTTON_ALIGN_LEFT":true,"CREATE_ACCOUNT_BUTTON_TEXT":"CREATE AN ACCOUNT","PASSWORD_CUSTOM_ERROR_TEXT":"The password must meet all requirements","ACCOUNT_CREATED_MESSAGE":"Please check your email to verify your account to login and allow a few minutes for this message to arrive. Check your junk/spam folders if you do not find the email in your inbox.","PUBLIC_LOGIN_PLACEHOLDER":" ","DISABLE_DEFAULT_PAYMENT_RADIO":true,"CUSTOM_RESET_PASSWORD_ERROR_MESSAGE":"Username invalid - no account found","PUBLIC_LOGIN_CREATE_DESCRIPTION":"### Existing User:\n\n  - Enter your username and password to login.  \n\n\n  #### - OR -  \n\n\n\n  - Forgot password? Click 'Reset Password' and follow the prompts.\n  - Forgot username? Click 'Forgot Username' and follow the prompts.  \n\n\n  ### New User:\n  ","LOGIN_HELP_LINK":"https://sosmt.gov/business/how-do-i/","LOGIN_HELP_LINK_TEXT":"Need Help?","FORGOT_USERNAME_TEXT":"Forgot Username?","LOGIN_ACTIVE_DIRECTORY_TEXT":"State User Login","MULTIPLE_LOGIN_METHODS":true,"HAS_ACTIVE_DIRECTORY_LOGIN":true,"RESET_PASSWORD_WITH_USERNAME":true,"DOWNLOAD_LINK":true,"SHOW_USERNAME_ACCOUNT_CREATE":true,"SHOW_SCROLL_DOWN_ARROW":true,"SHOW_ADDRESS_ACCOUNT_CREATE":true,"TWO_COLUMN_ACCOUNT_CREATE":true,"RESET_PASSWORD_TIP":"A link to change your password has been sent to your email. Please allow a few minutes for this message to arrive. Please check your junk/spam folders if you do not find the email in your inbox.","FORGOT_PASSWORD_LINK_TEXT":"Reset Password","PHONE_NUMBER_OPTIONAL_ACCOUNT_CREATE":true,"SHOW_REQUIRED_INDICATOR_ACCOUNT_CREATE":true,"PASSWORD_REQUIREMENTS_ACCOUNT_CREATE":"\n    <ul>\n      <li>MUST contain at least 8 characters (12+ recommended)</li>\n      <li>MUST contain at least one uppercase letter.</li>\n      <li>MUST contain at least one lowercase letter.</li>\n      <li>MUST contain at least one number.</li>\n      <li>MUST contain at least one special character (!”#$%&'()*+,-./:;<=>?</li>\n    </ul>\n  ","ALLOW_CERTIFICATION_REQUEST":true,"ALLOW_PUBLIC_CERTIFICATE_REQUEST":true,"ALLOW_COPY_REQUEST":false,"ALLOW_CORRECTION_STYLING":true,"HIDE_DEPRECATION_WARNING":false,"AMEND_ROUTE_PUBLIC":true,"SEAL_FILENAME":"seal.png","SHOPPING_CART":true,"ALLOW_PAYMENT_UPDATE_WITH_EMPTY_CART":true,"RA_EMAIL":true,"RA_WEBSITE":true,"RA_NO_DEFAULT_TYPE":true,"RA_ADDRESS_LABEL":"Street Address","RA_TYPE_SELECTION_DEFAULT":true,"RA_DEFAULT_TYPE":"460","RA_OVERRIDE_TYPE_WITH_DEFAULT":true,"RA_PRINCIPAL_ADDRESS_AMS":true,"UPLOAD_AND_SUBMIT_HIDE_IF_ONE_OPTION":true,"PAYMENT_PROCESSING_MESSAGE":"Your payment is processing - Do not close your browser or click the back button","CHECKOUT_BUTTON_WHEN_PROCESSING_TEXT":"Processing","EFS_CROP_PICKER_NONE_LABEL":"Lien Duration","DISALLOWED_WIZARD_PIECES":["FormationLocale"],"REPEATER_SHOW_EDIT_BUTTON":true,"DATA_REQUEST_PAGE_TITLE":"Data Requests and Subscriptions","DATA_REQUEST_SIDEBAR_LABEL":"Data Requests & Subscriptions","LOGIN_REDIRECTS_TO_EPASS":false,"LOGIN_REDIRECTS_TO_ACTIVE_DIRECTORY":true,"LOGIN_ACTIVE_DIRECTORY_LINK":true,"FETCH_EDIT_USER_LINK":false,"LISTS_FETCH_AVAILABLE_LISTS":true,"POST_WIZARD_SUBMIT_REDIRECT_URL":"/","PIN_REQUEST_ATTESTATIONS":true,"PIN_REQUEST_DESCRIPTION":"Click **Request PIN** to have a new PIN sent to the account holder's email address on file.","OWNERSHIP_REQUEST_DESCRIPTION":"To become an **authorized user** of this record, a current **AUTHORIZED USER** will need to grant you access. To request access, click **Request Access** below.","PIN_REQUEST_SUCCESS_MESSAGE":"The PIN you have requested for this entity has been sent to the email associated with your user account.  You should receive the PIN in approximately 3-5 minutes, depending on your email service provider.","APOSTILLE_HEADER_LABEL":"Verification Information","APOSTILLE_NUMBER_LABEL":"Apostille/Authentication","APOSTILLE_CITY_STATE_OVERRIDE":"HELENA, MT","APOSTILLE_FILING_DATE_LABEL":"Issue Date","APOSTILLE_CITY_STATE_IN_CERTIFIED":true,"NOTARY_EXISTING_FILING":true,"ALLOW_REVOKE_OWN_ACCESS_ONLY":false,"HIDE_CANCEL_ON_ONETIME_DATA_REQUESTS":true,"DATA_REQUESTS_IN_SHOPPING_CART":true,"WQ_ALLOW_EDIT_PENDING_PAYMENT":true,"WQ_CONFIRM_ON_DELETE":true,"WQ_DELETE_CONFIRM_MESSAGE":"Deleting this filing will forfeit any money already paid to the Secretary of State. This action is permanent and cannot be undone, are you sure you would like to delete?","PASS_ITEM_GUIDS_ON_CHECKOUT":true,"FORM_REVISION_HISTORY":true,"CHECKOUT_DISCLAIMER":"By entering your credit card and/or checking account information you (i) state that **you are an authorized user** of the credit card and/or electronic check and that the associated information entered (e.g., account holder name, account number, billing address) is accurate, (ii) **you authorize payment processor to charge the amount you have requested** to your credit card and/or funding account, and (iii) **acknowledge if a charge is declined or reversed you may also be assessed a customary charge** by the payment processor for such transactions.","FARM_BILL_SEARCH_CONFIDENTIAL":"As a registered Farm Bill Buyer with the Montana Secretary of State’s office it is important to maintain the confidentiality of the information contained within the Farm Bill Master List. The Farm Bill Master List reflects personal data, such as Social Security Numbers, which are a key piece of personal identifiable information to assist you in determining the existence of a lien against a specific debtor. The distribution of this information beyond its intended purpose is strictly prohibited.\n\n**The debtor's tax identification number has been hidden for confidentiality reasons. You may continue to search on a tax ID number and return debtors that match your search criteria. The SSN/FEIN must be entered without dashes or spaces.  If you need access to the tax identification number to clearly identify the debtor, please contact the UCC unit at (406) 444-3665.**","VIEW_HISTORY_BUTTON_ALT_TEXT":"View Filings","WIZARD_ERROR_TITLE_MESSAGE":"Form Error","FARM_BILL_SEARCH_INTERACTIVE":true,"USE_FARM_BILL_API":true,"DISALLOW_ASSIGN_SELF_AS_RA":true,"DISALLOW_ASSIGN_SELF_AS_PRINCIPAL":true,"USE_TRADEMARK_OWNER_VALIDATION":true,"USE_ALTERNATIVE_FOREIGN_ADDRESS_LABELS":true,"MY_RECEIPTS_FILTER":[{"type":"dateRange","name":"DATE_RANGE","label":"Date range","defaultValue":{"start":null,"end":null}},{"type":"text","name":"REF_NUM","defaultValue":"","label":"Reference Number"},{"type":"text","name":"RECEIPT_NUM","defaultValue":"","label":"Receipt Id"},{"type":"text","name":"AMOUNT","defaultValue":"","label":"Amount"},{"type":"select","name":"TYPE","defaultValue":"","label":"Payment Type","options":[{"value":"","label":"All"},{"value":"CC","label":"Credit Card"},{"value":"Check","label":"Check"}]}],"MY_RECEIPTS_SHOW_IN_SIDEBAR":true,"SHOW_MY_RECEIPTS_HELPER_TEXT":true,"MY_RECEIPTS_HELPER_LABEL":"About Receipt Search","MY_RECEIPTS_HELPER_TEXT":"You can search for receipts based on their descriptions, including the items paid for on the receipt. Use the filters to search for or filter specific information.","FARM_BILL_SUBLINK":{"label":"Farm Bill","component":"FarmBill","parameter":"farm-bill","path":"/lists/farm-bill","sourceTypeId":0,"myRecordsSearch":false,"allowedRules":["/search/"],"disabled":true,"searchDescription":"To perform a search, enter a debtor name. Your search results may include: exact debtor name, variations of that name and any filing that includes your search criteria. Punctuation is ignored.\n\nYou can click on \"Advanced\" to refine your search. Under “Advanced” you can search by crop, year, county and SSN/FEIN. As a registered Farm Bill Buyer with the Montana Secretary of State’s office it is important to maintain the confidentiality of the information contained within the Farm Bill Master List. The Farm Bill Master List reflects personal data, such as Social Security Numbers, which are a key piece of personal identifiable information to assist you in determining the existence of a lien against a specific debtor. The distribution of this information beyond its intended purpose is strictly prohibited.\n\nThe debtor's tax identification number has been hidden for confidentiality reasons. You may continue to search on a tax ID number and return debtors that match your search criteria. The SSN/FEIN must be entered without dashes or spaces.","searchMustHaveOneOf":["search","UCC_FARM_PRODUCT_ID","COUNTY"],"searchPlaceholder":"Search by debtor name","advancedSearchParameters":[{"type":"ServerMultiComplete","label":"Product code name(s)","name":"UCC_FARM_PRODUCT_ID","defaultValue":"","optionsSrc":"UCC_FARM_PRODUCT_V"},{"type":"MultiComplete","label":"Year or Range of Years","name":"YEAR_NUM","optionsSrc":"years","startYear":"1968","defaultValue":[],"preMergeOptions":[{"value":"ALL","label":"All"}]},{"type":"serverSelect","label":"State","name":"STATE","defaultValue":"MONTANA","optionsSrc":"STATE"},{"type":"ServerMultiComplete","label":"County","name":"COUNTY","defaultValue":[],"optionsSrc":"COUNTY","overrideSubOptionsSrcFromParameterName":"STATE"},{"type":"checkbox","name":"TIN_SEARCH_YN","defaultValue":false,"label":"Tax Identification Number Search"},{"type":"checkbox","name":"TIN_SORT_YN","defaultValue":false,"label":"Unique ID Sort"}]},"ALLOW_ADDRESS_VALIDATION_BYPASS_OPTION":true,"DEFAULT_ADDRESS_VALIDATION_BYPASS_OPTION_CHECKED":true}).NODE_DEBUG || '';
	  set = set.toUpperCase();
	  if (!debugs[set]) {
	    if (new RegExp('\\b' + set + '\\b', 'i').test(debugEnviron)) {
	      var pid = process.pid;
	      debugs[set] = function() {
	        var msg = exports.format.apply(exports, arguments);
	        console.error('%s %d: %s', set, pid, msg);
	      };
	    } else {
	      debugs[set] = function() {};
	    }
	  }
	  return debugs[set];
	};
	
	
	/**
	 * Echos the value of a value. Trys to print the value out
	 * in the best way possible given the different types.
	 *
	 * @param {Object} obj The object to print out.
	 * @param {Object} opts Optional options object that alters the output.
	 */
	/* legacy: obj, showHidden, depth, colors*/
	function inspect(obj, opts) {
	  // default options
	  var ctx = {
	    seen: [],
	    stylize: stylizeNoColor
	  };
	  // legacy...
	  if (arguments.length >= 3) ctx.depth = arguments[2];
	  if (arguments.length >= 4) ctx.colors = arguments[3];
	  if (isBoolean(opts)) {
	    // legacy...
	    ctx.showHidden = opts;
	  } else if (opts) {
	    // got an "options" object
	    exports._extend(ctx, opts);
	  }
	  // set default options
	  if (isUndefined(ctx.showHidden)) ctx.showHidden = false;
	  if (isUndefined(ctx.depth)) ctx.depth = 2;
	  if (isUndefined(ctx.colors)) ctx.colors = false;
	  if (isUndefined(ctx.customInspect)) ctx.customInspect = true;
	  if (ctx.colors) ctx.stylize = stylizeWithColor;
	  return formatValue(ctx, obj, ctx.depth);
	}
	exports.inspect = inspect;
	
	
	// http://en.wikipedia.org/wiki/ANSI_escape_code#graphics
	inspect.colors = {
	  'bold' : [1, 22],
	  'italic' : [3, 23],
	  'underline' : [4, 24],
	  'inverse' : [7, 27],
	  'white' : [37, 39],
	  'grey' : [90, 39],
	  'black' : [30, 39],
	  'blue' : [34, 39],
	  'cyan' : [36, 39],
	  'green' : [32, 39],
	  'magenta' : [35, 39],
	  'red' : [31, 39],
	  'yellow' : [33, 39]
	};
	
	// Don't use 'blue' not visible on cmd.exe
	inspect.styles = {
	  'special': 'cyan',
	  'number': 'yellow',
	  'boolean': 'yellow',
	  'undefined': 'grey',
	  'null': 'bold',
	  'string': 'green',
	  'date': 'magenta',
	  // "name": intentionally not styling
	  'regexp': 'red'
	};
	
	
	function stylizeWithColor(str, styleType) {
	  var style = inspect.styles[styleType];
	
	  if (style) {
	    return '\u001b[' + inspect.colors[style][0] + 'm' + str +
	           '\u001b[' + inspect.colors[style][1] + 'm';
	  } else {
	    return str;
	  }
	}
	
	
	function stylizeNoColor(str, styleType) {
	  return str;
	}
	
	
	function arrayToHash(array) {
	  var hash = {};
	
	  array.forEach(function(val, idx) {
	    hash[val] = true;
	  });
	
	  return hash;
	}
	
	
	function formatValue(ctx, value, recurseTimes) {
	  // Provide a hook for user-specified inspect functions.
	  // Check that value is an object with an inspect function on it
	  if (ctx.customInspect &&
	      value &&
	      isFunction(value.inspect) &&
	      // Filter out the util module, it's inspect function is special
	      value.inspect !== exports.inspect &&
	      // Also filter out any prototype objects using the circular check.
	      !(value.constructor && value.constructor.prototype === value)) {
	    var ret = value.inspect(recurseTimes, ctx);
	    if (!isString(ret)) {
	      ret = formatValue(ctx, ret, recurseTimes);
	    }
	    return ret;
	  }
	
	  // Primitive types cannot have properties
	  var primitive = formatPrimitive(ctx, value);
	  if (primitive) {
	    return primitive;
	  }
	
	  // Look up the keys of the object.
	  var keys = Object.keys(value);
	  var visibleKeys = arrayToHash(keys);
	
	  if (ctx.showHidden) {
	    keys = Object.getOwnPropertyNames(value);
	  }
	
	  // IE doesn't make error fields non-enumerable
	  // http://msdn.microsoft.com/en-us/library/ie/dww52sbt(v=vs.94).aspx
	  if (isError(value)
	      && (keys.indexOf('message') >= 0 || keys.indexOf('description') >= 0)) {
	    return formatError(value);
	  }
	
	  // Some type of object without properties can be shortcutted.
	  if (keys.length === 0) {
	    if (isFunction(value)) {
	      var name = value.name ? ': ' + value.name : '';
	      return ctx.stylize('[Function' + name + ']', 'special');
	    }
	    if (isRegExp(value)) {
	      return ctx.stylize(RegExp.prototype.toString.call(value), 'regexp');
	    }
	    if (isDate(value)) {
	      return ctx.stylize(Date.prototype.toString.call(value), 'date');
	    }
	    if (isError(value)) {
	      return formatError(value);
	    }
	  }
	
	  var base = '', array = false, braces = ['{', '}'];
	
	  // Make Array say that they are Array
	  if (isArray(value)) {
	    array = true;
	    braces = ['[', ']'];
	  }
	
	  // Make functions say that they are functions
	  if (isFunction(value)) {
	    var n = value.name ? ': ' + value.name : '';
	    base = ' [Function' + n + ']';
	  }
	
	  // Make RegExps say that they are RegExps
	  if (isRegExp(value)) {
	    base = ' ' + RegExp.prototype.toString.call(value);
	  }
	
	  // Make dates with properties first say the date
	  if (isDate(value)) {
	    base = ' ' + Date.prototype.toUTCString.call(value);
	  }
	
	  // Make error with message first say the error
	  if (isError(value)) {
	    base = ' ' + formatError(value);
	  }
	
	  if (keys.length === 0 && (!array || value.length == 0)) {
	    return braces[0] + base + braces[1];
	  }
	
	  if (recurseTimes < 0) {
	    if (isRegExp(value)) {
	      return ctx.stylize(RegExp.prototype.toString.call(value), 'regexp');
	    } else {
	      return ctx.stylize('[Object]', 'special');
	    }
	  }
	
	  ctx.seen.push(value);
	
	  var output;
	  if (array) {
	    output = formatArray(ctx, value, recurseTimes, visibleKeys, keys);
	  } else {
	    output = keys.map(function(key) {
	      return formatProperty(ctx, value, recurseTimes, visibleKeys, key, array);
	    });
	  }
	
	  ctx.seen.pop();
	
	  return reduceToSingleString(output, base, braces);
	}
	
	
	function formatPrimitive(ctx, value) {
	  if (isUndefined(value))
	    return ctx.stylize('undefined', 'undefined');
	  if (isString(value)) {
	    var simple = '\'' + JSON.stringify(value).replace(/^"|"$/g, '')
	                                             .replace(/'/g, "\\'")
	                                             .replace(/\\"/g, '"') + '\'';
	    return ctx.stylize(simple, 'string');
	  }
	  if (isNumber(value))
	    return ctx.stylize('' + value, 'number');
	  if (isBoolean(value))
	    return ctx.stylize('' + value, 'boolean');
	  // For some reason typeof null is "object", so special case here.
	  if (isNull(value))
	    return ctx.stylize('null', 'null');
	}
	
	
	function formatError(value) {
	  return '[' + Error.prototype.toString.call(value) + ']';
	}
	
	
	function formatArray(ctx, value, recurseTimes, visibleKeys, keys) {
	  var output = [];
	  for (var i = 0, l = value.length; i < l; ++i) {
	    if (hasOwnProperty(value, String(i))) {
	      output.push(formatProperty(ctx, value, recurseTimes, visibleKeys,
	          String(i), true));
	    } else {
	      output.push('');
	    }
	  }
	  keys.forEach(function(key) {
	    if (!key.match(/^\d+$/)) {
	      output.push(formatProperty(ctx, value, recurseTimes, visibleKeys,
	          key, true));
	    }
	  });
	  return output;
	}
	
	
	function formatProperty(ctx, value, recurseTimes, visibleKeys, key, array) {
	  var name, str, desc;
	  desc = Object.getOwnPropertyDescriptor(value, key) || { value: value[key] };
	  if (desc.get) {
	    if (desc.set) {
	      str = ctx.stylize('[Getter/Setter]', 'special');
	    } else {
	      str = ctx.stylize('[Getter]', 'special');
	    }
	  } else {
	    if (desc.set) {
	      str = ctx.stylize('[Setter]', 'special');
	    }
	  }
	  if (!hasOwnProperty(visibleKeys, key)) {
	    name = '[' + key + ']';
	  }
	  if (!str) {
	    if (ctx.seen.indexOf(desc.value) < 0) {
	      if (isNull(recurseTimes)) {
	        str = formatValue(ctx, desc.value, null);
	      } else {
	        str = formatValue(ctx, desc.value, recurseTimes - 1);
	      }
	      if (str.indexOf('\n') > -1) {
	        if (array) {
	          str = str.split('\n').map(function(line) {
	            return '  ' + line;
	          }).join('\n').substr(2);
	        } else {
	          str = '\n' + str.split('\n').map(function(line) {
	            return '   ' + line;
	          }).join('\n');
	        }
	      }
	    } else {
	      str = ctx.stylize('[Circular]', 'special');
	    }
	  }
	  if (isUndefined(name)) {
	    if (array && key.match(/^\d+$/)) {
	      return str;
	    }
	    name = JSON.stringify('' + key);
	    if (name.match(/^"([a-zA-Z_][a-zA-Z_0-9]*)"$/)) {
	      name = name.substr(1, name.length - 2);
	      name = ctx.stylize(name, 'name');
	    } else {
	      name = name.replace(/'/g, "\\'")
	                 .replace(/\\"/g, '"')
	                 .replace(/(^"|"$)/g, "'");
	      name = ctx.stylize(name, 'string');
	    }
	  }
	
	  return name + ': ' + str;
	}
	
	
	function reduceToSingleString(output, base, braces) {
	  var numLinesEst = 0;
	  var length = output.reduce(function(prev, cur) {
	    numLinesEst++;
	    if (cur.indexOf('\n') >= 0) numLinesEst++;
	    return prev + cur.replace(/\u001b\[\d\d?m/g, '').length + 1;
	  }, 0);
	
	  if (length > 60) {
	    return braces[0] +
	           (base === '' ? '' : base + '\n ') +
	           ' ' +
	           output.join(',\n  ') +
	           ' ' +
	           braces[1];
	  }
	
	  return braces[0] + base + ' ' + output.join(', ') + ' ' + braces[1];
	}
	
	
	// NOTE: These type checking functions intentionally don't use `instanceof`
	// because it is fragile and can be easily faked with `Object.create()`.
	function isArray(ar) {
	  return Array.isArray(ar);
	}
	exports.isArray = isArray;
	
	function isBoolean(arg) {
	  return typeof arg === 'boolean';
	}
	exports.isBoolean = isBoolean;
	
	function isNull(arg) {
	  return arg === null;
	}
	exports.isNull = isNull;
	
	function isNullOrUndefined(arg) {
	  return arg == null;
	}
	exports.isNullOrUndefined = isNullOrUndefined;
	
	function isNumber(arg) {
	  return typeof arg === 'number';
	}
	exports.isNumber = isNumber;
	
	function isString(arg) {
	  return typeof arg === 'string';
	}
	exports.isString = isString;
	
	function isSymbol(arg) {
	  return typeof arg === 'symbol';
	}
	exports.isSymbol = isSymbol;
	
	function isUndefined(arg) {
	  return arg === void 0;
	}
	exports.isUndefined = isUndefined;
	
	function isRegExp(re) {
	  return isObject(re) && objectToString(re) === '[object RegExp]';
	}
	exports.isRegExp = isRegExp;
	
	function isObject(arg) {
	  return typeof arg === 'object' && arg !== null;
	}
	exports.isObject = isObject;
	
	function isDate(d) {
	  return isObject(d) && objectToString(d) === '[object Date]';
	}
	exports.isDate = isDate;
	
	function isError(e) {
	  return isObject(e) &&
	      (objectToString(e) === '[object Error]' || e instanceof Error);
	}
	exports.isError = isError;
	
	function isFunction(arg) {
	  return typeof arg === 'function';
	}
	exports.isFunction = isFunction;
	
	function isPrimitive(arg) {
	  return arg === null ||
	         typeof arg === 'boolean' ||
	         typeof arg === 'number' ||
	         typeof arg === 'string' ||
	         typeof arg === 'symbol' ||  // ES6 symbol
	         typeof arg === 'undefined';
	}
	exports.isPrimitive = isPrimitive;
	
	exports.isBuffer = __webpack_require__(1511);
	
	function objectToString(o) {
	  return Object.prototype.toString.call(o);
	}
	
	
	function pad(n) {
	  return n < 10 ? '0' + n.toString(10) : n.toString(10);
	}
	
	
	var months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep',
	              'Oct', 'Nov', 'Dec'];
	
	// 26 Feb 16:19:34
	function timestamp() {
	  var d = new Date();
	  var time = [pad(d.getHours()),
	              pad(d.getMinutes()),
	              pad(d.getSeconds())].join(':');
	  return [d.getDate(), months[d.getMonth()], time].join(' ');
	}
	
	
	// log is just a thin wrapper to console.log that prepends a timestamp
	exports.log = function() {
	  console.log('%s - %s', timestamp(), exports.format.apply(exports, arguments));
	};
	
	
	/**
	 * Inherit the prototype methods from one constructor into another.
	 *
	 * The Function.prototype.inherits from lang.js rewritten as a standalone
	 * function (not on Function.prototype). NOTE: If this file is to be loaded
	 * during bootstrapping this function needs to be rewritten using some native
	 * functions as prototype setup using normal JavaScript does not work as
	 * expected during bootstrapping (see mirror.js in r114903).
	 *
	 * @param {function} ctor Constructor function which needs to inherit the
	 *     prototype.
	 * @param {function} superCtor Constructor function to inherit prototype from.
	 */
	exports.inherits = __webpack_require__(1510);
	
	exports._extend = function(origin, add) {
	  // Don't do anything if add isn't an object
	  if (!add || !isObject(add)) return origin;
	
	  var keys = Object.keys(add);
	  var i = keys.length;
	  while (i--) {
	    origin[keys[i]] = add[keys[i]];
	  }
	  return origin;
	};
	
	function hasOwnProperty(obj, prop) {
	  return Object.prototype.hasOwnProperty.call(obj, prop);
	}
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }()), __webpack_require__(77)))

/***/ },
/* 328 */
/***/ function(module, exports, __webpack_require__) {

	Object.defineProperty(exports,"__esModule",{value:true});var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var _react=__webpack_require__(1);var _react2=_interopRequireDefault(_react);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var createIconComponent=function createIconComponent(_ref){var content=_ref.content,_ref$height=_ref.height,height=_ref$height===undefined?'70':_ref$height,_ref$width=_ref.width,width=_ref$width===undefined?'70':_ref$width;return function(props){return _react2.default.createElement('svg',_extends({},props,{className:'svg-icon '+(props.className!==''?props.className:''),viewBox:'0 0 '+width+' '+height}),content);};};exports.default=createIconComponent;

/***/ },
/* 329 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _createIconComponent = _interopRequireDefault(__webpack_require__(5));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	var IconBusiness = (0, _createIconComponent["default"])({
	  content: _react["default"].createElement("g", null, _react["default"].createElement("path", {
	    d: "M32.3 16.92h17a1.6 1.6 0 1 0 0-3.2h-17a1.6 1.6 0 1 0 0 3.2z"
	  }), _react["default"].createElement("path", {
	    d: "M62.72 46.41h-4.95V7.82a1.6 1.6 0 0 0-1.6-1.6H25.46a1.6 1.6 0 0 0-1.6 1.6v11.12H7.28a1.6 1.6 0 0 0-1.6 1.6v41.64a1.6 1.6 0 0 0 1.6 1.6h55.44a1.6 1.6 0 0 0 1.6-1.6V48a1.6 1.6 0 0 0-1.6-1.59zM8.88 22.14H30v38.44H8.88zM54.57 9.42v37H33.16v-4h16.17a1.6 1.6 0 1 0 0-3.2H33.16v-5.33h16.17a1.6 1.6 0 1 0 0-3.2H33.16v-5.28h16.17a1.6 1.6 0 0 0 0-3.2H33.16v-1.67a1.6 1.6 0 0 0-1.6-1.6h-4.5V9.42zm6.55 51.17h-28v-11h28z"
	  }), _react["default"].createElement("path", {
	    d: "M14.91 47.25h9.43a1.6 1.6 0 1 0 0-3.2h-9.43a1.6 1.6 0 0 0 0 3.2zM14.91 38h9.43a1.6 1.6 0 1 0 0-3.2h-9.43a1.6 1.6 0 0 0 0 3.2zM14.91 28.75h9.43a1.6 1.6 0 1 0 0-3.2h-9.43a1.6 1.6 0 0 0 0 3.2zM24.34 56.5a1.6 1.6 0 1 0 0-3.2h-9.43a1.6 1.6 0 0 0 0 3.2zM53.32 53.5H41.56a1.6 1.6 0 0 0 0 3.2h11.76a1.6 1.6 0 0 0 0-3.2z"
	  })),
	  height: undefined,
	  width: undefined
	});
	IconBusiness.displayName = 'IconBusiness';
	var _default = IconBusiness;
	exports["default"] = _default;

/***/ },
/* 330 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _createIconComponent = _interopRequireDefault(__webpack_require__(5));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	var IconDatabase = (0, _createIconComponent["default"])({
	  content: _react["default"].createElement("g", null, _react["default"].createElement("path", {
	    d: "M64 22.83V11.17c0-6.33-27.79-6.41-29-6.41S6 4.84 6 11.17v11.66c0 1.26 1.16 2.28 3 3.09-1.84.82-3 1.83-3 3.08v11.68c0 1.25 1.1 2.26 2.86 3.07C7.13 44.56 6 45.56 6 46.82v11.66c0 6.33 27.79 6.4 29 6.4s29-.07 29-6.4V46.82c0-1.26-1.1-2.26-2.86-3.07 1.76-.81 2.86-1.82 2.86-3.07V29c0-1.27-1.13-2.28-2.92-3.1 1.76-.79 2.92-1.81 2.92-3.07zm-2.49-.08c-.63 1.43-10 4-26.48 4s-25.88-2.57-26.5-3.92v-8.76c6.85 3.45 25.47 3.5 26.47 3.5s19.62-.05 26.47-3.5zm0 17.85c-.63 1.43-10 4-26.48 4S9.15 42 8.53 40.68v-8.76c6.85 3.45 25.47 3.5 26.47 3.5s19.62-.05 26.47-3.5zm0 17.8c-.63 1.43-10 4-26.48 4s-25.88-2.57-26.5-3.92v-8.76c6.85 3.45 25.47 3.5 26.47 3.5s19.62 0 26.47-3.5zm0-11.58c-.93 1.44-10.28 3.9-26.44 3.9s-25.58-2.46-26.51-3.9c.33-.52 1.77-1.17 4.21-1.79 8.3 2 21.43 2 22.23 2s13.93 0 22.23-2c2.44.62 3.88 1.27 4.21 1.79zm0-17.8c-.93 1.44-10.28 3.9-26.44 3.9S9.49 30.46 8.56 29c.34-.53 1.81-1.19 4.31-1.82 8.31 2 21.33 2 22.13 2s13.82 0 22.13-2c2.5.65 3.97 1.31 4.31 1.82zm0-17.85c-.93 1.44-10.28 3.9-26.44 3.9s-25.58-2.46-26.51-3.9C9.49 9.73 18.84 7.26 35 7.26s25.51 2.47 26.44 3.91z"
	  })),
	  height: undefined,
	  width: undefined
	});
	IconDatabase.displayName = 'IconDatabase';
	var _default = IconDatabase;
	exports["default"] = _default;

/***/ },
/* 331 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _createIconComponent = _interopRequireDefault(__webpack_require__(5));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	var IconDocumentClone = (0, _createIconComponent["default"])({
	  content: _react["default"].createElement("g", null, _react["default"].createElement("path", {
	    d: "M59.3 12.15H47.79V6.6a3 3 0 0 0-3-3H10.7a3 3 0 0 0-3 3v48.26a3 3 0 0 0 3 3h11.51v5.54a3 3 0 0 0 3 3H59.3a3 3 0 0 0 3-3V15.14a3 3 0 0 0-3-3zM10.7 55.29a.43.43 0 0 1-.43-.42V6.6a.43.43 0 0 1 .43-.43h34.11a.43.43 0 0 1 .42.43v48.26a.43.43 0 0 1-.42.42zm49 8.11a.43.43 0 0 1-.43.43H25.19a.43.43 0 0 1-.42-.43V58h20a3 3 0 0 0 3-3v-.9h6.13a1.28 1.28 0 0 0 0-2.56h-6.11v-6.22h6.11a1.28 1.28 0 0 0 0-2.56h-6.11v-6.4h6.11a1.28 1.28 0 0 0 0-2.56h-6.11v-6.13h1.7a1.28 1.28 0 1 0 0-2.56h-1.7v-10.4H59.3a.43.43 0 0 1 .43.42zm-46.12-47a1.28 1.28 0 0 1 1.28-1.28h20.78a1.28 1.28 0 1 1 0 2.56H14.89a1.28 1.28 0 0 1-1.28-1.28zm27.71 8.7A1.28 1.28 0 0 1 40 26.39H14.89a1.28 1.28 0 1 1 0-2.56H40a1.28 1.28 0 0 1 1.28 1.28zm0 9A1.28 1.28 0 0 1 40 35.34H14.89a1.28 1.28 0 0 1 0-2.56H40a1.28 1.28 0 0 1 1.28 1.28zm0 8.81A1.28 1.28 0 0 1 40 44.15H14.89a1.28 1.28 0 0 1 0-2.56H40a1.28 1.28 0 0 1 1.28 1.28zm0 0"
	  })),
	  height: undefined,
	  width: undefined
	});
	IconDocumentClone.displayName = 'IconDocumentClone';
	var _default = IconDocumentClone;
	exports["default"] = _default;

/***/ },
/* 332 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _createIconComponent = _interopRequireDefault(__webpack_require__(5));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	var IconDocumentEdit = (0, _createIconComponent["default"])({
	  content: _react["default"].createElement("g", null, _react["default"].createElement("path", {
	    d: "M22.55 16.43a.27.27 0 0 1-.27.27h-6.9l7.17-7.17v6.89zm34.35 21.9a1.47 1.47 0 0 0-1.47 1.47v22.47a.27.27 0 0 1-.27.28H13.57a.28.28 0 0 1-.28-.28V19.65h9a3.22 3.22 0 0 0 3.22-3.22v-9h29.64a.27.27 0 0 1 .27.28v4.64a1.47 1.47 0 1 0 2.94 0V7.73a3.22 3.22 0 0 0-3.22-3.22H24a1.47 1.47 0 0 0-1 .43L10.78 17.13a1.47 1.47 0 0 0-.43 1v44.14a3.22 3.22 0 0 0 3.22 3.22h41.58a3.22 3.22 0 0 0 3.22-3.22V39.8a1.47 1.47 0 0 0-1.47-1.47z"
	  }), _react["default"].createElement("path", {
	    d: "M66.15 21.43l-1.85 1.85-4.61-4.61 1.85-1.85a2 2 0 0 1 2.88 0l1.73 1.73a2 2 0 0 1 0 2.88zM32.72 47.12l3.13 3.13-4.33 1.2 1.2-4.33zm6 1.79l-4.61-4.61L57.6 20.75l4.61 4.61L38.67 48.9zm29.51-32.44l-1.73-1.73a5 5 0 0 0-7 0L45.71 28.48H21.86a1.47 1.47 0 0 0 0 2.94h20.9l-8.86 8.86h-12a1.47 1.47 0 1 0 0 2.94H31a1.47 1.47 0 0 0-.38.65l-2.27 8.19h-6.49a1.47 1.47 0 0 0 0 2.94h7.91l9.29-2.58a1.47 1.47 0 0 0 .65-.38l28.52-28.53a5 5 0 0 0 0-7z"
	  })),
	  height: undefined,
	  width: undefined
	});
	IconDocumentEdit.displayName = 'IconDocumentEdit';
	var _default = IconDocumentEdit;
	exports["default"] = _default;

/***/ },
/* 333 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _createIconComponent = _interopRequireDefault(__webpack_require__(5));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	var IconExport = (0, _createIconComponent["default"])({
	  content: _react["default"].createElement("g", null, _react["default"].createElement("path", {
	    d: "M53.27 21.38H42v5.38h8.59v31.15H19.42V26.76H28v-5.38H16.73A2.69 2.69 0 0 0 14 24.07V60.6a2.69 2.69 0 0 0 2.69 2.69h36.58A2.69 2.69 0 0 0 56 60.6V24.07a2.69 2.69 0 0 0-2.73-2.69z"
	  }), _react["default"].createElement("path", {
	    d: "M32.31 36.36a2.69 2.69 0 1 0 5.38 0V9.15l4.3 4.3 1.66 1.66a2.69 2.69 0 0 0 3.8-3.8L41.8 5.66 36.9.75a2.46 2.46 0 0 0-.43-.34 2.82 2.82 0 0 0-2.93 0 2.46 2.46 0 0 0-.43.34l-4.9 4.9-5.65 5.65a2.69 2.69 0 1 0 3.8 3.8L28 13.45l4.3-4.3z"
	  })),
	  height: undefined,
	  width: undefined
	});
	IconExport.displayName = 'IconExport';
	var _default = IconExport;
	exports["default"] = _default;

/***/ },
/* 334 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _createIconComponent = _interopRequireDefault(__webpack_require__(5));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	var IconFileBox = (0, _createIconComponent["default"])({
	  content: _react["default"].createElement("g", null, _react["default"].createElement("path", {
	    d: "M40.95 49h-11.9v-3h11.9v3zm.5-5.22h-12.9a1.77 1.77 0 0 0-1.76 1.76v4a1.77 1.77 0 0 0 1.76 1.76h12.9a1.77 1.77 0 0 0 1.76-1.76v-4a1.77 1.77 0 0 0-1.76-1.76z"
	  }), _react["default"].createElement("path", {
	    d: "M61.74 53.78a1.45 1.45 0 0 1-1.45 1.45H9.71a1.45 1.45 0 0 1-1.45-1.45V36a1.45 1.45 0 0 1 1.45-1.45h13.36a.1.1 0 0 1 .09.06l1.63 3.62a2.62 2.62 0 0 0 2.38 1.54h15.65a2.62 2.62 0 0 0 2.38-1.54l1.63-3.62a.1.1 0 0 1 .09-.06h13.37A1.45 1.45 0 0 1 61.74 36v17.78zM17 18.28a1.49 1.49 0 0 1 1.33-.82H20v2h-1.51a1.13 1.13 0 0 0-1.13 1.13v6.08H16a1.13 1.13 0 0 0-1.13 1.13V32h-4.78l7-13.77zm33.32 3.45v4.95H19.63v-4.95zm-28.05-7.22h25.46v4.95H22.27v-4.95zm30.64 14.44V32h-6a2.62 2.62 0 0 0-2.38 1.54l-1.63 3.62a.1.1 0 0 1-.09.06H27.18a.1.1 0 0 1-.09-.06l-1.63-3.62A2.62 2.62 0 0 0 23.07 32h-6v-3.1zM50 17.46h1.62a1.49 1.49 0 0 1 1.33.82l7 13.77h-4.77v-4.24A1.13 1.13 0 0 0 54 26.68h-1.4V20.6a1.13 1.13 0 0 0-1.13-1.13H50v-2zM63.69 34L55.2 17.14a4 4 0 0 0-3.58-2.2H50v-1.56a1.13 1.13 0 0 0-1.13-1.13H21.13A1.13 1.13 0 0 0 20 13.38v1.56h-1.62a4 4 0 0 0-3.58 2.2L6.3 34a4 4 0 0 0-.56 2v17.78a4 4 0 0 0 4 4h50.55a4 4 0 0 0 4-4V36a4 4 0 0 0-.6-2z"
	  })),
	  height: undefined,
	  width: undefined
	});
	IconFileBox.displayName = 'IconFileBox';
	var _default = IconFileBox;
	exports["default"] = _default;

/***/ },
/* 335 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _createIconComponent = _interopRequireDefault(__webpack_require__(5));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	var IconHome = (0, _createIconComponent["default"])({
	  content: _react["default"].createElement("g", null, _react["default"].createElement("path", {
	    d: "M54.28 34.46a1.63 1.63 0 0 0-1.66 1.66v22.66H40.87v-9.25a1.64 1.64 0 0 0-1.6-1.63h-8.5a1.68 1.68 0 0 0-1.69 1.63v9.25H17.35V36.87a1.63 1.63 0 0 0-3.25 0v23.57a1.61 1.61 0 0 0 1.6 1.6h15.07a1.61 1.61 0 0 0 1.59-1.6v-9.25h5.25v9.25A1.63 1.63 0 0 0 39.27 62h15a1.61 1.61 0 0 0 1.6-1.6V36.12a1.62 1.62 0 0 0-1.6-1.66zm0 0"
	  }), _react["default"].createElement("path", {
	    d: "M63.29 35.75L50.21 22.61v-9A1.66 1.66 0 0 0 48.52 12a1.62 1.62 0 0 0-1.6 1.66v5.67L36.13 8.47A1.58 1.58 0 0 0 35 8a1.62 1.62 0 0 0-1.17.52L6.74 35.57a1.55 1.55 0 0 0 0 2.29 1.55 1.55 0 0 0 2.29 0L35 11.94l25.94 26.17a1.6 1.6 0 0 0 1.17.42 1.83 1.83 0 0 0 1.18-.42 1.71 1.71 0 0 0 0-2.36zm0 0"
	  })),
	  height: undefined,
	  width: undefined
	});
	IconHome.displayName = 'IconHome';
	var _default = IconHome;
	exports["default"] = _default;

/***/ },
/* 336 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _createIconComponent = _interopRequireDefault(__webpack_require__(5));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	var IconLockSolid = (0, _createIconComponent["default"])({
	  content: _react["default"].createElement("g", null, _react["default"].createElement("path", {
	    d: "M51.29 30.22H50v-6.83c0-8.66-6.73-15.71-15-15.71s-15 7-15 15.71v6.83h-1.29a3.33 3.33 0 0 0-3.33 3.33V59a3.33 3.33 0 0 0 3.33 3.33h32.58A3.33 3.33 0 0 0 54.63 59V33.55a3.33 3.33 0 0 0-3.34-3.33zM24 23.39c0-6.45 4.93-11.71 11-11.71s11 5.25 11 11.71v6.83H24zm13.48 24.84l1.62 7.85H31l1.62-7.85.38-1.89L31.61 45a4.87 4.87 0 1 1 6.85 0l-1.37 1.35z"
	  })),
	  height: undefined,
	  width: undefined
	});
	IconLockSolid.displayName = 'IconLockSolid';
	var _default = IconLockSolid;
	exports["default"] = _default;

/***/ },
/* 337 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _createIconComponent = _interopRequireDefault(__webpack_require__(5));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	var IconPlus = (0, _createIconComponent["default"])({
	  content: _react["default"].createElement("g", null, _react["default"].createElement("path", {
	    d: "M35 65.21a2.37 2.37 0 0 1-2.37-2.37V7.17a2.37 2.37 0 1 1 4.75 0v55.66A2.37 2.37 0 0 1 35 65.21z"
	  }), _react["default"].createElement("path", {
	    d: "M62.83 37.37H7.17a2.37 2.37 0 1 1 0-4.75h55.66a2.37 2.37 0 1 1 0 4.75z"
	  })),
	  height: undefined,
	  width: undefined
	});
	IconPlus.displayName = 'IconPlus';
	var _default = IconPlus;
	exports["default"] = _default;

/***/ },
/* 338 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _createIconComponent = _interopRequireDefault(__webpack_require__(5));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	var IconShield = (0, _createIconComponent["default"])({
	  content: _react["default"].createElement("g", null, _react["default"].createElement("path", {
	    d: "M56.82 10.35A48.69 48.69 0 0 1 47 8.51a46.59 46.59 0 0 1-9.89-4.13 4.2 4.2 0 0 0-4.16 0A46.62 46.62 0 0 1 23 8.51a48.66 48.66 0 0 1-9.84 1.83 4.21 4.21 0 0 0-3.87 4.19v15.73c0 17.13 9.94 26.65 24.86 35.68a1.6 1.6 0 0 0 1.66 0c14.92-9 24.86-18.55 24.86-35.68V14.54a4.21 4.21 0 0 0-3.85-4.19zm.67 19.91c0 15.38-8.58 23.9-22.48 32.44-13.92-8.54-22.49-17.06-22.49-32.44V14.54a1 1 0 0 1 .91-1 51.89 51.89 0 0 0 10.5-2 49.89 49.89 0 0 0 10.58-4.38 1 1 0 0 1 1 0 49.84 49.84 0 0 0 10.58 4.43 51.91 51.91 0 0 0 10.5 2 1 1 0 0 1 .91 1z"
	  }), _react["default"].createElement("path", {
	    d: "M50.58 17a34.15 34.15 0 0 1-6.92-1.29 32.76 32.76 0 0 1-6.95-2.9 3.46 3.46 0 0 0-3.42 0 32.71 32.71 0 0 1-6.95 2.9A34.13 34.13 0 0 1 19.42 17a3.46 3.46 0 0 0-3.18 3.45v11.2c0 12.42 7.17 19.3 17.93 25.82a1.6 1.6 0 0 0 1.66 0C46.59 50.93 53.76 44 53.76 31.62v-11.2A3.47 3.47 0 0 0 50.58 17zm0 14.65c0 10.66-5.93 16.62-15.56 22.57-9.63-6-15.56-11.92-15.56-22.57V20.42a.25.25 0 0 1 .22-.25 37.37 37.37 0 0 0 7.58-1.41 36 36 0 0 0 7.64-3.2.25.25 0 0 1 .12 0 .23.23 0 0 1 .12 0 36.08 36.08 0 0 0 7.64 3.2 37.39 37.39 0 0 0 7.58 1.41.25.25 0 0 1 .23.25z"
	  })),
	  height: undefined,
	  width: undefined
	});
	IconShield.displayName = 'IconShield';
	var _default = IconShield;
	exports["default"] = _default;

/***/ },
/* 339 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _createIconComponent = _interopRequireDefault(__webpack_require__(5));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	var IconSignature = (0, _createIconComponent["default"])({
	  content: _react["default"].createElement("g", null, _react["default"].createElement("path", {
	    d: "M34.3 21.324l6.152-5.982 20.37 20.948-6.15 5.982zM58.7 46.42a10.29 10.29 0 0 0 5.67 3l3.83.58-.54-3.84a10.29 10.29 0 0 0-2.81-5.75l-1.9-2-6.15 6zM36.79 11.59a4.29 4.29 0 1 0-6.15 6l1.53 1.57 6.15-6zM30.37 19.39a1.52 1.52 0 1 0-2.19 2.13l11.26 11.57A1.52 1.52 0 0 0 41.62 31l-8.38-8.61-2.13-2.19zM65.11 58.24H21.27a5.4 5.4 0 0 1-5.4-5.4v-.46a5.4 5.4 0 0 1 5.4-5.4H35.9a2.2 2.2 0 0 0 2.2-2.2v-.15a2.2 2.2 0 0 0-2.2-2.2H12.76a5.4 5.4 0 0 1 0-10.79h3.95a2.2 2.2 0 0 0 2.2-2.2V29a2.2 2.2 0 0 0-2.2-2.2H2.44a1.6 1.6 0 0 1 0-3.2h14.27a5.4 5.4 0 0 1 5.4 5.4v.51a5.4 5.4 0 0 1-5.4 5.4h-3.95a2.2 2.2 0 0 0 0 4.39H35.9a5.4 5.4 0 0 1 5.4 5.4v.15a5.4 5.4 0 0 1-5.4 5.4H21.27a2.2 2.2 0 0 0-2.2 2.2v.46a2.2 2.2 0 0 0 2.2 2.2h43.84a1.6 1.6 0 0 1 0 3.2z"
	  })),
	  height: undefined,
	  width: undefined
	});
	IconSignature.displayName = 'IconSignature';
	var _default = IconSignature;
	exports["default"] = _default;

/***/ },
/* 340 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _createIconComponent = _interopRequireDefault(__webpack_require__(5));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	var IconUserGroup = (0, _createIconComponent["default"])({
	  content: _react["default"].createElement("g", null, _react["default"].createElement("path", {
	    d: "M9.64 17.13a9 9 0 0 0 13.69 7.78 12.3 12.3 0 0 1 4.42-7.49v-.28a9.06 9.06 0 0 0-18.12 0zm9.06-6.46A6.44 6.44 0 0 1 25.07 16v.26l-.18.18a14.93 14.93 0 0 0-3.8 6.44l-.07.25-.24.09a6.35 6.35 0 0 1-2.11.36 6.46 6.46 0 1 1 0-12.92zM47.72 25.45a9.06 9.06 0 1 0 3.57-17.38 9.1 9.1 0 0 0-9 8.65 12.26 12.26 0 0 1 5.43 8.73zm-2.59-10.22a6.45 6.45 0 1 1 6.16 8.36 6.41 6.41 0 0 1-1-.07l-.29-.06-.08-.31a14.79 14.79 0 0 0-4.63-7.39l-.29-.22zM26.42 27a9.06 9.06 0 1 0 9.06-9.06A9.07 9.07 0 0 0 26.42 27zm9.06-6.46A6.46 6.46 0 1 1 29 27a6.46 6.46 0 0 1 6.48-6.45zM55.35 27.85h-7.57a12.22 12.22 0 0 1-3.2 7.48 15.12 15.12 0 0 1 10 14.14V52c7.56-.37 11.92-2.53 12.1-2.62l.43-.22v-9.58a11.75 11.75 0 0 0-11.76-11.73zm9.14 19.64l-.33.12a30.72 30.72 0 0 1-6.46 1.51l-.54.07v-.54a17.71 17.71 0 0 0-8.23-14.08l-.39-.25.21-.41a14.77 14.77 0 0 0 1.19-3.09l.1-.37h5.33a9.15 9.15 0 0 1 9.14 9.14z"
	  }), _react["default"].createElement("path", {
	    d: "M39.53 37.71h-8.11a11.75 11.75 0 0 0-11.74 11.74v9.7l.36.11a55.46 55.46 0 0 0 16.49 2.66c9 0 14.09-2.57 14.3-2.67l.43-.22v-9.58a11.75 11.75 0 0 0-11.73-11.74zm9.14 19.64l-.33.12a35.29 35.29 0 0 1-11.8 1.85 51.87 51.87 0 0 1-13.89-2l-.37-.1v-7.77a9.15 9.15 0 0 1 9.14-9.14h8.11a9.15 9.15 0 0 1 9.14 9.14z"
	  }), _react["default"].createElement("path", {
	    d: "M26.38 35.33a12.24 12.24 0 0 1-3.19-7.47h-8.54A11.75 11.75 0 0 0 2.91 39.58v9.7l.36.11a57.4 57.4 0 0 0 13.13 2.54v-2.46a15.12 15.12 0 0 1 9.98-14.14zm-12.55 13.2v.54l-.57-.07a56 56 0 0 1-7.38-1.54l-.37-.1v-7.78a9.15 9.15 0 0 1 9.14-9.14h6.29l.1.37a14.82 14.82 0 0 0 1.19 3.09l.21.41-.39.25a17.72 17.72 0 0 0-8.22 13.97z"
	  })),
	  height: undefined,
	  width: undefined
	});
	IconUserGroup.displayName = 'IconUserGroup';
	var _default = IconUserGroup;
	exports["default"] = _default;

/***/ },
/* 341 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {"use strict";
	
	__webpack_require__(826);
	
	__webpack_require__(610);
	
	__webpack_require__(627);
	
	if (global._babelPolyfill) {
	  throw new Error("only one instance of babel-polyfill is allowed");
	}
	global._babelPolyfill = true;
	
	var DEFINE_PROPERTY = "defineProperty";
	function define(O, key, value) {
	  O[key] || Object[DEFINE_PROPERTY](O, key, {
	    writable: true,
	    configurable: true,
	    value: value
	  });
	}
	
	define(String.prototype, "padLeft", "".padStart);
	define(String.prototype, "padRight", "".padEnd);
	
	"pop,reverse,shift,keys,values,entries,indexOf,every,some,forEach,map,filter,find,findIndex,includes,join,slice,concat,push,splice,unshift,sort,lastIndexOf,reduce,reduceRight,copyWithin,fill".split(",").forEach(function (key) {
	  [][key] && define(Array, key, Function.call.bind([][key]));
	});
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 342 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Buffer) {
	module.exports = function (crypto, password, keyLen, ivLen) {
	  keyLen = keyLen/8;
	  ivLen = ivLen || 0;
	  var ki = 0;
	  var ii = 0;
	  var key = new Buffer(keyLen);
	  var iv = new Buffer(ivLen);
	  var addmd = 0;
	  var md, md_buf;
	  var i;
	  while (true) {
	    md = crypto.createHash('md5');
	    if(addmd++ > 0) {
	       md.update(md_buf);
	    }
	    md.update(password);
	    md_buf = md.digest();
	    i = 0;
	    if(keyLen > 0) {
	      while(true) {
	        if(keyLen === 0) {
	          break;
	        }
	        if(i === md_buf.length) {
	          break;
	        }
	        key[ki++] = md_buf[i];
	        keyLen--;
	        i++;
	       }
	    }
	    if(ivLen > 0 && i !== md_buf.length) {
	      while(true) {
	        if(ivLen === 0) {
	          break;
	        }
	        if(i === md_buf.length) {
	          break;
	        }
	       iv[ii++] = md_buf[i];
	       ivLen--;
	       i++;
	     }
	   }
	   if(keyLen === 0 && ivLen === 0) {
	      break;
	    }
	  }
	  for(i=0;i<md_buf.length;i++) {
	    md_buf[i] = 0;
	  }
	  return {
	    key: key,
	    iv: iv
	  };
	};
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(31).Buffer))

/***/ },
/* 343 */
/***/ function(module, exports, __webpack_require__) {

	var xor = __webpack_require__(163);
	exports.encrypt = function (self, block) {
	  var data = xor(block, self._prev);
	  self._prev = self._cipher.encryptBlock(data);
	  return self._prev;
	};
	exports.decrypt = function (self, block) {
	  var pad = self._prev;
	  self._prev = block;
	  var out = self._cipher.decryptBlock(block);
	  return xor(out, pad);
	};

/***/ },
/* 344 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Buffer) {var xor = __webpack_require__(163);
	exports.encrypt = function (self, data, decrypt) {
	  var out = new Buffer('');
	  var len;
	  while (data.length) {
	    if (self._cache.length === 0) {
	      self._cache = self._cipher.encryptBlock(self._prev);
	      self._prev = new Buffer('');
	    }
	    if (self._cache.length <= data.length) {
	      len = self._cache.length;
	      out = Buffer.concat([out, encryptStart(self, data.slice(0, len), decrypt)]);
	      data = data.slice(len);
	    } else {
	      out = Buffer.concat([out, encryptStart(self, data, decrypt)]);
	      break;
	    }
	  }
	  return out;
	};
	function encryptStart(self, data, decrypt) {
	  var len = data.length;
	  var out = xor(data, self._cache);
	  self._cache = self._cache.slice(len);
	  self._prev = Buffer.concat([self._prev, decrypt?data:out]);
	  return out;
	}
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(31).Buffer))

/***/ },
/* 345 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Buffer) {var xor = __webpack_require__(163);
	function getBlock(self) {
	  var out = self._cipher.encryptBlock(self._prev);
	  incr32(self._prev);
	  return out;
	}
	exports.encrypt = function (self, chunk) {
	  while (self._cache.length < chunk.length) {
	    self._cache = Buffer.concat([self._cache, getBlock(self)]);
	  }
	  var pad = self._cache.slice(0, chunk.length);
	  self._cache = self._cache.slice(chunk.length);
	  return xor(chunk, pad);
	};
	function incr32(iv) {
	  var len = iv.length;
	  var item;
	  while (len--) {
	    item = iv.readUInt8(len);
	    if (item === 255) {
	      iv.writeUInt8(0, len);
	    } else {
	      item++;
	      iv.writeUInt8(item, len);
	      break;
	    }
	  }
	}
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(31).Buffer))

/***/ },
/* 346 */
/***/ function(module, exports) {

	exports.encrypt = function (self, block) {
	  return self._cipher.encryptBlock(block);
	};
	exports.decrypt = function (self, block) {
	  return self._cipher.decryptBlock(block);
	};

/***/ },
/* 347 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Buffer) {var xor = __webpack_require__(163);
	function getBlock(self) {
	  self._prev = self._cipher.encryptBlock(self._prev);
	  return self._prev;
	}
	exports.encrypt = function (self, chunk) {
	  while (self._cache.length < chunk.length) {
	    self._cache = Buffer.concat([self._cache, getBlock(self)]);
	  }
	  var pad = self._cache.slice(0, chunk.length);
	  self._cache = self._cache.slice(chunk.length);
	  return xor(chunk, pad);
	};
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(31).Buffer))

/***/ },
/* 348 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Buffer) {var aes = __webpack_require__(230);
	var Transform = __webpack_require__(231);
	var inherits = __webpack_require__(58);
	
	inherits(StreamCipher, Transform);
	module.exports = StreamCipher;
	function StreamCipher(mode, key, iv, decrypt) {
	  if (!(this instanceof StreamCipher)) {
	    return new StreamCipher(mode, key, iv);
	  }
	  Transform.call(this);
	  this._cipher = new aes.AES(key);
	  this._prev = new Buffer(iv.length);
	  this._cache = new Buffer('');
	  this._secCache = new Buffer('');
	  this._decrypt = decrypt;
	  iv.copy(this._prev);
	  this._mode = mode;
	}
	StreamCipher.prototype._transform = function (chunk, _, next) {
	  next(null, this._mode.encrypt(this, chunk, this._decrypt));
	};
	StreamCipher.prototype._flush = function (next) {
	  this._cipher.scrub();
	  next();
	};
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(31).Buffer))

/***/ },
/* 349 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
	  Copyright (c) 2017 Jed Watson.
	  Licensed under the MIT License (MIT), see
	  http://jedwatson.github.io/classnames
	*/
	/* global define */
	
	(function () {
		'use strict';
	
		var hasOwn = {}.hasOwnProperty;
	
		function classNames () {
			var classes = [];
	
			for (var i = 0; i < arguments.length; i++) {
				var arg = arguments[i];
				if (!arg) continue;
	
				var argType = typeof arg;
	
				if (argType === 'string' || argType === 'number') {
					classes.push(arg);
				} else if (Array.isArray(arg) && arg.length) {
					var inner = classNames.apply(null, arg);
					if (inner) {
						classes.push(inner);
					}
				} else if (argType === 'object') {
					for (var key in arg) {
						if (hasOwn.call(arg, key) && arg[key]) {
							classes.push(key);
						}
					}
				}
			}
	
			return classes.join(' ');
		}
	
		if (typeof module !== 'undefined' && module.exports) {
			classNames.default = classNames;
			module.exports = classNames;
		} else if (true) {
			// register as 'classnames', consistent with npm package name
			!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
				return classNames;
			}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		} else {
			window.classNames = classNames;
		}
	}());


/***/ },
/* 350 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "LOCATION_CHANGE", {
	  enumerable: true,
	  get: function get() {
	    return _actions.LOCATION_CHANGE;
	  }
	});
	Object.defineProperty(exports, "CALL_HISTORY_METHOD", {
	  enumerable: true,
	  get: function get() {
	    return _actions.CALL_HISTORY_METHOD;
	  }
	});
	Object.defineProperty(exports, "onLocationChanged", {
	  enumerable: true,
	  get: function get() {
	    return _actions.onLocationChanged;
	  }
	});
	Object.defineProperty(exports, "push", {
	  enumerable: true,
	  get: function get() {
	    return _actions.push;
	  }
	});
	Object.defineProperty(exports, "replace", {
	  enumerable: true,
	  get: function get() {
	    return _actions.replace;
	  }
	});
	Object.defineProperty(exports, "go", {
	  enumerable: true,
	  get: function get() {
	    return _actions.go;
	  }
	});
	Object.defineProperty(exports, "goBack", {
	  enumerable: true,
	  get: function get() {
	    return _actions.goBack;
	  }
	});
	Object.defineProperty(exports, "goForward", {
	  enumerable: true,
	  get: function get() {
	    return _actions.goForward;
	  }
	});
	Object.defineProperty(exports, "routerActions", {
	  enumerable: true,
	  get: function get() {
	    return _actions.routerActions;
	  }
	});
	Object.defineProperty(exports, "routerMiddleware", {
	  enumerable: true,
	  get: function get() {
	    return _middleware["default"];
	  }
	});
	exports.createMatchSelector = exports.getSearch = exports.getRouter = exports.getHash = exports.getAction = exports.getLocation = exports.connectRouter = exports.ConnectedRouter = void 0;
	
	var _ConnectedRouter = _interopRequireDefault(__webpack_require__(622));
	
	var _reducer = _interopRequireDefault(__webpack_require__(624));
	
	var _selectors = _interopRequireDefault(__webpack_require__(351));
	
	var _plain = _interopRequireDefault(__webpack_require__(626));
	
	var _actions = __webpack_require__(164);
	
	var _middleware = _interopRequireDefault(__webpack_require__(623));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	var ConnectedRouter = /*#__PURE__*/(0, _ConnectedRouter["default"])(_plain["default"]);
	exports.ConnectedRouter = ConnectedRouter;
	var connectRouter = /*#__PURE__*/(0, _reducer["default"])(_plain["default"]);
	exports.connectRouter = connectRouter;
	
	var _createSelectors = /*#__PURE__*/(0, _selectors["default"])(_plain["default"]),
	    getLocation = _createSelectors.getLocation,
	    getAction = _createSelectors.getAction,
	    getHash = _createSelectors.getHash,
	    getRouter = _createSelectors.getRouter,
	    getSearch = _createSelectors.getSearch,
	    createMatchSelector = _createSelectors.createMatchSelector;
	
	exports.createMatchSelector = createMatchSelector;
	exports.getSearch = getSearch;
	exports.getRouter = getRouter;
	exports.getHash = getHash;
	exports.getAction = getAction;
	exports.getLocation = getLocation;

/***/ },
/* 351 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _reactRouter = __webpack_require__(212);
	
	function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	var createSelectors = function createSelectors(structure) {
	  var getIn = structure.getIn,
	      toJS = structure.toJS;
	
	  var isRouter = function isRouter(value) {
	    return value != null && _typeof(value) === 'object' && getIn(value, ['location']) && getIn(value, ['action']);
	  };
	
	  var getRouter = function getRouter(state) {
	    var router = toJS(getIn(state, ['router']));
	
	    if (!isRouter(router)) {
	      throw 'Could not find router reducer in state tree, it must be mounted under "router"';
	    }
	
	    return router;
	  };
	
	  var getLocation = function getLocation(state) {
	    return toJS(getIn(getRouter(state), ['location']));
	  };
	
	  var getAction = function getAction(state) {
	    return toJS(getIn(getRouter(state), ['action']));
	  };
	
	  var getSearch = function getSearch(state) {
	    return toJS(getIn(getRouter(state), ['location', 'search']));
	  };
	
	  var getHash = function getHash(state) {
	    return toJS(getIn(getRouter(state), ['location', 'hash']));
	  }; // It only makes sense to recalculate the `matchPath` whenever the pathname
	  // of the location changes. That's why `createMatchSelector` memoizes
	  // the latest result based on the location's pathname.
	
	
	  var createMatchSelector = function createMatchSelector(path) {
	    var lastPathname = null;
	    var lastMatch = null;
	    return function (state) {
	      var _ref = getLocation(state) || {},
	          pathname = _ref.pathname;
	
	      if (pathname === lastPathname) {
	        return lastMatch;
	      }
	
	      lastPathname = pathname;
	      var match = (0, _reactRouter.matchPath)(pathname, path);
	
	      if (!match || !lastMatch || match.url !== lastMatch.url // When URL matched for nested routes, URL is the same but isExact is not.
	      || match.isExact !== lastMatch.isExact) {
	        lastMatch = match;
	      }
	
	      return lastMatch;
	    };
	  };
	
	  return {
	    getLocation: getLocation,
	    getAction: getAction,
	    getRouter: getRouter,
	    getSearch: getSearch,
	    getHash: getHash,
	    createMatchSelector: createMatchSelector
	  };
	};
	
	var _default = createSelectors;
	exports["default"] = _default;

/***/ },
/* 352 */
/***/ function(module, exports, __webpack_require__) {

	var cof = __webpack_require__(53);
	module.exports = function (it, msg) {
	  if (typeof it != 'number' && cof(it) != 'Number') throw TypeError(msg);
	  return +it;
	};


/***/ },
/* 353 */
/***/ function(module, exports, __webpack_require__) {

	// 22.1.3.3 Array.prototype.copyWithin(target, start, end = this.length)
	'use strict';
	var toObject = __webpack_require__(34);
	var toAbsoluteIndex = __webpack_require__(95);
	var toLength = __webpack_require__(27);
	
	module.exports = [].copyWithin || function copyWithin(target /* = 0 */, start /* = 0, end = @length */) {
	  var O = toObject(this);
	  var len = toLength(O.length);
	  var to = toAbsoluteIndex(target, len);
	  var from = toAbsoluteIndex(start, len);
	  var end = arguments.length > 2 ? arguments[2] : undefined;
	  var count = Math.min((end === undefined ? len : toAbsoluteIndex(end, len)) - from, len - to);
	  var inc = 1;
	  if (from < to && to < from + count) {
	    inc = -1;
	    from += count - 1;
	    to += count - 1;
	  }
	  while (count-- > 0) {
	    if (from in O) O[to] = O[from];
	    else delete O[to];
	    to += inc;
	    from += inc;
	  } return O;
	};


/***/ },
/* 354 */
/***/ function(module, exports, __webpack_require__) {

	var forOf = __webpack_require__(88);
	
	module.exports = function (iter, ITERATOR) {
	  var result = [];
	  forOf(iter, false, result.push, result, ITERATOR);
	  return result;
	};


/***/ },
/* 355 */
/***/ function(module, exports, __webpack_require__) {

	var aFunction = __webpack_require__(39);
	var toObject = __webpack_require__(34);
	var IObject = __webpack_require__(132);
	var toLength = __webpack_require__(27);
	
	module.exports = function (that, callbackfn, aLen, memo, isRight) {
	  aFunction(callbackfn);
	  var O = toObject(that);
	  var self = IObject(O);
	  var length = toLength(O.length);
	  var index = isRight ? length - 1 : 0;
	  var i = isRight ? -1 : 1;
	  if (aLen < 2) for (;;) {
	    if (index in self) {
	      memo = self[index];
	      index += i;
	      break;
	    }
	    index += i;
	    if (isRight ? index < 0 : length <= index) {
	      throw TypeError('Reduce of empty array with no initial value');
	    }
	  }
	  for (;isRight ? index >= 0 : length > index; index += i) if (index in self) {
	    memo = callbackfn(memo, self[index], index, O);
	  }
	  return memo;
	};


/***/ },
/* 356 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var aFunction = __webpack_require__(39);
	var isObject = __webpack_require__(23);
	var invoke = __webpack_require__(362);
	var arraySlice = [].slice;
	var factories = {};
	
	var construct = function (F, len, args) {
	  if (!(len in factories)) {
	    for (var n = [], i = 0; i < len; i++) n[i] = 'a[' + i + ']';
	    // eslint-disable-next-line no-new-func
	    factories[len] = Function('F,a', 'return new F(' + n.join(',') + ')');
	  } return factories[len](F, args);
	};
	
	module.exports = Function.bind || function bind(that /* , ...args */) {
	  var fn = aFunction(this);
	  var partArgs = arraySlice.call(arguments, 1);
	  var bound = function (/* args... */) {
	    var args = partArgs.concat(arraySlice.call(arguments));
	    return this instanceof bound ? construct(fn, args.length, args) : invoke(fn, args, that);
	  };
	  if (isObject(fn.prototype)) bound.prototype = fn.prototype;
	  return bound;
	};


/***/ },
/* 357 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var dP = __webpack_require__(32).f;
	var create = __webpack_require__(89);
	var redefineAll = __webpack_require__(93);
	var ctx = __webpack_require__(55);
	var anInstance = __webpack_require__(87);
	var forOf = __webpack_require__(88);
	var $iterDefine = __webpack_require__(244);
	var step = __webpack_require__(365);
	var setSpecies = __webpack_require__(94);
	var DESCRIPTORS = __webpack_require__(28);
	var fastKey = __webpack_require__(83).fastKey;
	var validate = __webpack_require__(97);
	var SIZE = DESCRIPTORS ? '_s' : 'size';
	
	var getEntry = function (that, key) {
	  // fast case
	  var index = fastKey(key);
	  var entry;
	  if (index !== 'F') return that._i[index];
	  // frozen object case
	  for (entry = that._f; entry; entry = entry.n) {
	    if (entry.k == key) return entry;
	  }
	};
	
	module.exports = {
	  getConstructor: function (wrapper, NAME, IS_MAP, ADDER) {
	    var C = wrapper(function (that, iterable) {
	      anInstance(that, C, NAME, '_i');
	      that._t = NAME;         // collection type
	      that._i = create(null); // index
	      that._f = undefined;    // first entry
	      that._l = undefined;    // last entry
	      that[SIZE] = 0;         // size
	      if (iterable != undefined) forOf(iterable, IS_MAP, that[ADDER], that);
	    });
	    redefineAll(C.prototype, {
	      // 23.1.3.1 Map.prototype.clear()
	      // 23.2.3.2 Set.prototype.clear()
	      clear: function clear() {
	        for (var that = validate(this, NAME), data = that._i, entry = that._f; entry; entry = entry.n) {
	          entry.r = true;
	          if (entry.p) entry.p = entry.p.n = undefined;
	          delete data[entry.i];
	        }
	        that._f = that._l = undefined;
	        that[SIZE] = 0;
	      },
	      // 23.1.3.3 Map.prototype.delete(key)
	      // 23.2.3.4 Set.prototype.delete(value)
	      'delete': function (key) {
	        var that = validate(this, NAME);
	        var entry = getEntry(that, key);
	        if (entry) {
	          var next = entry.n;
	          var prev = entry.p;
	          delete that._i[entry.i];
	          entry.r = true;
	          if (prev) prev.n = next;
	          if (next) next.p = prev;
	          if (that._f == entry) that._f = next;
	          if (that._l == entry) that._l = prev;
	          that[SIZE]--;
	        } return !!entry;
	      },
	      // 23.2.3.6 Set.prototype.forEach(callbackfn, thisArg = undefined)
	      // 23.1.3.5 Map.prototype.forEach(callbackfn, thisArg = undefined)
	      forEach: function forEach(callbackfn /* , that = undefined */) {
	        validate(this, NAME);
	        var f = ctx(callbackfn, arguments.length > 1 ? arguments[1] : undefined, 3);
	        var entry;
	        while (entry = entry ? entry.n : this._f) {
	          f(entry.v, entry.k, this);
	          // revert to the last existing entry
	          while (entry && entry.r) entry = entry.p;
	        }
	      },
	      // 23.1.3.7 Map.prototype.has(key)
	      // 23.2.3.7 Set.prototype.has(value)
	      has: function has(key) {
	        return !!getEntry(validate(this, NAME), key);
	      }
	    });
	    if (DESCRIPTORS) dP(C.prototype, 'size', {
	      get: function () {
	        return validate(this, NAME)[SIZE];
	      }
	    });
	    return C;
	  },
	  def: function (that, key, value) {
	    var entry = getEntry(that, key);
	    var prev, index;
	    // change existing entry
	    if (entry) {
	      entry.v = value;
	    // create new entry
	    } else {
	      that._l = entry = {
	        i: index = fastKey(key, true), // <- index
	        k: key,                        // <- key
	        v: value,                      // <- value
	        p: prev = that._l,             // <- previous entry
	        n: undefined,                  // <- next entry
	        r: false                       // <- removed
	      };
	      if (!that._f) that._f = entry;
	      if (prev) prev.n = entry;
	      that[SIZE]++;
	      // add to index
	      if (index !== 'F') that._i[index] = entry;
	    } return that;
	  },
	  getEntry: getEntry,
	  setStrong: function (C, NAME, IS_MAP) {
	    // add .keys, .values, .entries, [@@iterator]
	    // 23.1.3.4, 23.1.3.8, 23.1.3.11, 23.1.3.12, 23.2.3.5, 23.2.3.8, 23.2.3.10, 23.2.3.11
	    $iterDefine(C, NAME, function (iterated, kind) {
	      this._t = validate(iterated, NAME); // target
	      this._k = kind;                     // kind
	      this._l = undefined;                // previous
	    }, function () {
	      var that = this;
	      var kind = that._k;
	      var entry = that._l;
	      // revert to the last existing entry
	      while (entry && entry.r) entry = entry.p;
	      // get next entry
	      if (!that._t || !(that._l = entry = entry ? entry.n : that._t._f)) {
	        // or finish the iteration
	        that._t = undefined;
	        return step(1);
	      }
	      // return step by kind
	      if (kind == 'keys') return step(0, entry.k);
	      if (kind == 'values') return step(0, entry.v);
	      return step(0, [entry.k, entry.v]);
	    }, IS_MAP ? 'entries' : 'values', !IS_MAP, true);
	
	    // add [@@species], 23.1.2.2, 23.2.2.2
	    setSpecies(NAME);
	  }
	};


/***/ },
/* 358 */
/***/ function(module, exports, __webpack_require__) {

	// https://github.com/DavidBruant/Map-Set.prototype.toJSON
	var classof = __webpack_require__(107);
	var from = __webpack_require__(354);
	module.exports = function (NAME) {
	  return function toJSON() {
	    if (classof(this) != NAME) throw TypeError(NAME + "#toJSON isn't generic");
	    return from(this);
	  };
	};


/***/ },
/* 359 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var redefineAll = __webpack_require__(93);
	var getWeak = __webpack_require__(83).getWeak;
	var anObject = __webpack_require__(15);
	var isObject = __webpack_require__(23);
	var anInstance = __webpack_require__(87);
	var forOf = __webpack_require__(88);
	var createArrayMethod = __webpack_require__(61);
	var $has = __webpack_require__(46);
	var validate = __webpack_require__(97);
	var arrayFind = createArrayMethod(5);
	var arrayFindIndex = createArrayMethod(6);
	var id = 0;
	
	// fallback for uncaught frozen keys
	var uncaughtFrozenStore = function (that) {
	  return that._l || (that._l = new UncaughtFrozenStore());
	};
	var UncaughtFrozenStore = function () {
	  this.a = [];
	};
	var findUncaughtFrozen = function (store, key) {
	  return arrayFind(store.a, function (it) {
	    return it[0] === key;
	  });
	};
	UncaughtFrozenStore.prototype = {
	  get: function (key) {
	    var entry = findUncaughtFrozen(this, key);
	    if (entry) return entry[1];
	  },
	  has: function (key) {
	    return !!findUncaughtFrozen(this, key);
	  },
	  set: function (key, value) {
	    var entry = findUncaughtFrozen(this, key);
	    if (entry) entry[1] = value;
	    else this.a.push([key, value]);
	  },
	  'delete': function (key) {
	    var index = arrayFindIndex(this.a, function (it) {
	      return it[0] === key;
	    });
	    if (~index) this.a.splice(index, 1);
	    return !!~index;
	  }
	};
	
	module.exports = {
	  getConstructor: function (wrapper, NAME, IS_MAP, ADDER) {
	    var C = wrapper(function (that, iterable) {
	      anInstance(that, C, NAME, '_i');
	      that._t = NAME;      // collection type
	      that._i = id++;      // collection id
	      that._l = undefined; // leak store for uncaught frozen objects
	      if (iterable != undefined) forOf(iterable, IS_MAP, that[ADDER], that);
	    });
	    redefineAll(C.prototype, {
	      // 23.3.3.2 WeakMap.prototype.delete(key)
	      // 23.4.3.3 WeakSet.prototype.delete(value)
	      'delete': function (key) {
	        if (!isObject(key)) return false;
	        var data = getWeak(key);
	        if (data === true) return uncaughtFrozenStore(validate(this, NAME))['delete'](key);
	        return data && $has(data, this._i) && delete data[this._i];
	      },
	      // 23.3.3.4 WeakMap.prototype.has(key)
	      // 23.4.3.4 WeakSet.prototype.has(value)
	      has: function has(key) {
	        if (!isObject(key)) return false;
	        var data = getWeak(key);
	        if (data === true) return uncaughtFrozenStore(validate(this, NAME)).has(key);
	        return data && $has(data, this._i);
	      }
	    });
	    return C;
	  },
	  def: function (that, key, value) {
	    var data = getWeak(anObject(key), true);
	    if (data === true) uncaughtFrozenStore(that).set(key, value);
	    else data[that._i] = value;
	    return that;
	  },
	  ufstore: uncaughtFrozenStore
	};


/***/ },
/* 360 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// https://tc39.github.io/proposal-flatMap/#sec-FlattenIntoArray
	var isArray = __webpack_require__(168);
	var isObject = __webpack_require__(23);
	var toLength = __webpack_require__(27);
	var ctx = __webpack_require__(55);
	var IS_CONCAT_SPREADABLE = __webpack_require__(26)('isConcatSpreadable');
	
	function flattenIntoArray(target, original, source, sourceLen, start, depth, mapper, thisArg) {
	  var targetIndex = start;
	  var sourceIndex = 0;
	  var mapFn = mapper ? ctx(mapper, thisArg, 3) : false;
	  var element, spreadable;
	
	  while (sourceIndex < sourceLen) {
	    if (sourceIndex in source) {
	      element = mapFn ? mapFn(source[sourceIndex], sourceIndex, original) : source[sourceIndex];
	
	      spreadable = false;
	      if (isObject(element)) {
	        spreadable = element[IS_CONCAT_SPREADABLE];
	        spreadable = spreadable !== undefined ? !!spreadable : isArray(element);
	      }
	
	      if (spreadable && depth > 0) {
	        targetIndex = flattenIntoArray(target, original, element, toLength(element.length), targetIndex, depth - 1) - 1;
	      } else {
	        if (targetIndex >= 0x1fffffffffffff) throw TypeError();
	        target[targetIndex] = element;
	      }
	
	      targetIndex++;
	    }
	    sourceIndex++;
	  }
	  return targetIndex;
	}
	
	module.exports = flattenIntoArray;


/***/ },
/* 361 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = !__webpack_require__(28) && !__webpack_require__(21)(function () {
	  return Object.defineProperty(__webpack_require__(237)('div'), 'a', { get: function () { return 7; } }).a != 7;
	});


/***/ },
/* 362 */
/***/ function(module, exports) {

	// fast apply, http://jsperf.lnkit.com/fast-apply/5
	module.exports = function (fn, args, that) {
	  var un = that === undefined;
	  switch (args.length) {
	    case 0: return un ? fn()
	                      : fn.call(that);
	    case 1: return un ? fn(args[0])
	                      : fn.call(that, args[0]);
	    case 2: return un ? fn(args[0], args[1])
	                      : fn.call(that, args[0], args[1]);
	    case 3: return un ? fn(args[0], args[1], args[2])
	                      : fn.call(that, args[0], args[1], args[2]);
	    case 4: return un ? fn(args[0], args[1], args[2], args[3])
	                      : fn.call(that, args[0], args[1], args[2], args[3]);
	  } return fn.apply(that, args);
	};


/***/ },
/* 363 */
/***/ function(module, exports, __webpack_require__) {

	// 20.1.2.3 Number.isInteger(number)
	var isObject = __webpack_require__(23);
	var floor = Math.floor;
	module.exports = function isInteger(it) {
	  return !isObject(it) && isFinite(it) && floor(it) === it;
	};


/***/ },
/* 364 */
/***/ function(module, exports, __webpack_require__) {

	// call something on iterator step with safe closing on error
	var anObject = __webpack_require__(15);
	module.exports = function (iterator, fn, value, entries) {
	  try {
	    return entries ? fn(anObject(value)[0], value[1]) : fn(value);
	  // 7.4.6 IteratorClose(iterator, completion)
	  } catch (e) {
	    var ret = iterator['return'];
	    if (ret !== undefined) anObject(ret.call(iterator));
	    throw e;
	  }
	};


/***/ },
/* 365 */
/***/ function(module, exports) {

	module.exports = function (done, value) {
	  return { value: value, done: !!done };
	};


/***/ },
/* 366 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.16 Math.fround(x)
	var sign = __webpack_require__(246);
	var pow = Math.pow;
	var EPSILON = pow(2, -52);
	var EPSILON32 = pow(2, -23);
	var MAX32 = pow(2, 127) * (2 - EPSILON32);
	var MIN32 = pow(2, -126);
	
	var roundTiesToEven = function (n) {
	  return n + 1 / EPSILON - 1 / EPSILON;
	};
	
	module.exports = Math.fround || function fround(x) {
	  var $abs = Math.abs(x);
	  var $sign = sign(x);
	  var a, result;
	  if ($abs < MIN32) return $sign * roundTiesToEven($abs / MIN32 / EPSILON32) * MIN32 * EPSILON32;
	  a = (1 + EPSILON32 / EPSILON) * $abs;
	  result = a - (a - $abs);
	  // eslint-disable-next-line no-self-compare
	  if (result > MAX32 || result != result) return $sign * Infinity;
	  return $sign * result;
	};


/***/ },
/* 367 */
/***/ function(module, exports) {

	// 20.2.2.20 Math.log1p(x)
	module.exports = Math.log1p || function log1p(x) {
	  return (x = +x) > -1e-8 && x < 1e-8 ? x - x * x / 2 : Math.log(1 + x);
	};


/***/ },
/* 368 */
/***/ function(module, exports) {

	// https://rwaldron.github.io/proposal-math-extensions/
	module.exports = Math.scale || function scale(x, inLow, inHigh, outLow, outHigh) {
	  if (
	    arguments.length === 0
	      // eslint-disable-next-line no-self-compare
	      || x != x
	      // eslint-disable-next-line no-self-compare
	      || inLow != inLow
	      // eslint-disable-next-line no-self-compare
	      || inHigh != inHigh
	      // eslint-disable-next-line no-self-compare
	      || outLow != outLow
	      // eslint-disable-next-line no-self-compare
	      || outHigh != outHigh
	  ) return NaN;
	  if (x === Infinity || x === -Infinity) return x;
	  return (x - inLow) * (outHigh - outLow) / (inHigh - inLow) + outLow;
	};


/***/ },
/* 369 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// 19.1.2.1 Object.assign(target, source, ...)
	var DESCRIPTORS = __webpack_require__(28);
	var getKeys = __webpack_require__(91);
	var gOPS = __webpack_require__(172);
	var pIE = __webpack_require__(133);
	var toObject = __webpack_require__(34);
	var IObject = __webpack_require__(132);
	var $assign = Object.assign;
	
	// should work with symbols and should have deterministic property order (V8 bug)
	module.exports = !$assign || __webpack_require__(21)(function () {
	  var A = {};
	  var B = {};
	  // eslint-disable-next-line no-undef
	  var S = Symbol();
	  var K = 'abcdefghijklmnopqrst';
	  A[S] = 7;
	  K.split('').forEach(function (k) { B[k] = k; });
	  return $assign({}, A)[S] != 7 || Object.keys($assign({}, B)).join('') != K;
	}) ? function assign(target, source) { // eslint-disable-line no-unused-vars
	  var T = toObject(target);
	  var aLen = arguments.length;
	  var index = 1;
	  var getSymbols = gOPS.f;
	  var isEnum = pIE.f;
	  while (aLen > index) {
	    var S = IObject(arguments[index++]);
	    var keys = getSymbols ? getKeys(S).concat(getSymbols(S)) : getKeys(S);
	    var length = keys.length;
	    var j = 0;
	    var key;
	    while (length > j) {
	      key = keys[j++];
	      if (!DESCRIPTORS || isEnum.call(S, key)) T[key] = S[key];
	    }
	  } return T;
	} : $assign;


/***/ },
/* 370 */
/***/ function(module, exports, __webpack_require__) {

	var dP = __webpack_require__(32);
	var anObject = __webpack_require__(15);
	var getKeys = __webpack_require__(91);
	
	module.exports = __webpack_require__(28) ? Object.defineProperties : function defineProperties(O, Properties) {
	  anObject(O);
	  var keys = getKeys(Properties);
	  var length = keys.length;
	  var i = 0;
	  var P;
	  while (length > i) dP.f(O, P = keys[i++], Properties[P]);
	  return O;
	};


/***/ },
/* 371 */
/***/ function(module, exports, __webpack_require__) {

	// fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window
	var toIObject = __webpack_require__(49);
	var gOPN = __webpack_require__(90).f;
	var toString = {}.toString;
	
	var windowNames = typeof window == 'object' && window && Object.getOwnPropertyNames
	  ? Object.getOwnPropertyNames(window) : [];
	
	var getWindowNames = function (it) {
	  try {
	    return gOPN(it);
	  } catch (e) {
	    return windowNames.slice();
	  }
	};
	
	module.exports.f = function getOwnPropertyNames(it) {
	  return windowNames && toString.call(it) == '[object Window]' ? getWindowNames(it) : gOPN(toIObject(it));
	};


/***/ },
/* 372 */
/***/ function(module, exports, __webpack_require__) {

	var has = __webpack_require__(46);
	var toIObject = __webpack_require__(49);
	var arrayIndexOf = __webpack_require__(165)(false);
	var IE_PROTO = __webpack_require__(251)('IE_PROTO');
	
	module.exports = function (object, names) {
	  var O = toIObject(object);
	  var i = 0;
	  var result = [];
	  var key;
	  for (key in O) if (key != IE_PROTO) has(O, key) && result.push(key);
	  // Don't enum bug & hidden keys
	  while (names.length > i) if (has(O, key = names[i++])) {
	    ~arrayIndexOf(result, key) || result.push(key);
	  }
	  return result;
	};


/***/ },
/* 373 */
/***/ function(module, exports, __webpack_require__) {

	var DESCRIPTORS = __webpack_require__(28);
	var getKeys = __webpack_require__(91);
	var toIObject = __webpack_require__(49);
	var isEnum = __webpack_require__(133).f;
	module.exports = function (isEntries) {
	  return function (it) {
	    var O = toIObject(it);
	    var keys = getKeys(O);
	    var length = keys.length;
	    var i = 0;
	    var result = [];
	    var key;
	    while (length > i) {
	      key = keys[i++];
	      if (!DESCRIPTORS || isEnum.call(O, key)) {
	        result.push(isEntries ? [key, O[key]] : O[key]);
	      }
	    }
	    return result;
	  };
	};


/***/ },
/* 374 */
/***/ function(module, exports, __webpack_require__) {

	// all object keys, includes non-enumerable and symbols
	var gOPN = __webpack_require__(90);
	var gOPS = __webpack_require__(172);
	var anObject = __webpack_require__(15);
	var Reflect = __webpack_require__(17).Reflect;
	module.exports = Reflect && Reflect.ownKeys || function ownKeys(it) {
	  var keys = gOPN.f(anObject(it));
	  var getSymbols = gOPS.f;
	  return getSymbols ? keys.concat(getSymbols(it)) : keys;
	};


/***/ },
/* 375 */
/***/ function(module, exports, __webpack_require__) {

	var $parseFloat = __webpack_require__(17).parseFloat;
	var $trim = __webpack_require__(110).trim;
	
	module.exports = 1 / $parseFloat(__webpack_require__(254) + '-0') !== -Infinity ? function parseFloat(str) {
	  var string = $trim(String(str), 3);
	  var result = $parseFloat(string);
	  return result === 0 && string.charAt(0) == '-' ? -0 : result;
	} : $parseFloat;


/***/ },
/* 376 */
/***/ function(module, exports, __webpack_require__) {

	var $parseInt = __webpack_require__(17).parseInt;
	var $trim = __webpack_require__(110).trim;
	var ws = __webpack_require__(254);
	var hex = /^[-+]?0[xX]/;
	
	module.exports = $parseInt(ws + '08') !== 8 || $parseInt(ws + '0x16') !== 22 ? function parseInt(str, radix) {
	  var string = $trim(String(str), 3);
	  return $parseInt(string, (radix >>> 0) || (hex.test(string) ? 16 : 10));
	} : $parseInt;


/***/ },
/* 377 */
/***/ function(module, exports) {

	module.exports = function (exec) {
	  try {
	    return { e: false, v: exec() };
	  } catch (e) {
	    return { e: true, v: e };
	  }
	};


/***/ },
/* 378 */
/***/ function(module, exports, __webpack_require__) {

	var anObject = __webpack_require__(15);
	var isObject = __webpack_require__(23);
	var newPromiseCapability = __webpack_require__(248);
	
	module.exports = function (C, x) {
	  anObject(C);
	  if (isObject(x) && x.constructor === C) return x;
	  var promiseCapability = newPromiseCapability.f(C);
	  var resolve = promiseCapability.resolve;
	  resolve(x);
	  return promiseCapability.promise;
	};


/***/ },
/* 379 */
/***/ function(module, exports) {

	// 7.2.9 SameValue(x, y)
	module.exports = Object.is || function is(x, y) {
	  // eslint-disable-next-line no-self-compare
	  return x === y ? x !== 0 || 1 / x === 1 / y : x != x && y != y;
	};


/***/ },
/* 380 */
/***/ function(module, exports, __webpack_require__) {

	// https://github.com/tc39/proposal-string-pad-start-end
	var toLength = __webpack_require__(27);
	var repeat = __webpack_require__(253);
	var defined = __webpack_require__(62);
	
	module.exports = function (that, maxLength, fillString, left) {
	  var S = String(defined(that));
	  var stringLength = S.length;
	  var fillStr = fillString === undefined ? ' ' : String(fillString);
	  var intMaxLength = toLength(maxLength);
	  if (intMaxLength <= stringLength || fillStr == '') return S;
	  var fillLen = intMaxLength - stringLength;
	  var stringFiller = repeat.call(fillStr, Math.ceil(fillLen / fillStr.length));
	  if (stringFiller.length > fillLen) stringFiller = stringFiller.slice(0, fillLen);
	  return left ? stringFiller + S : S + stringFiller;
	};


/***/ },
/* 381 */
/***/ function(module, exports, __webpack_require__) {

	// https://tc39.github.io/ecma262/#sec-toindex
	var toInteger = __webpack_require__(57);
	var toLength = __webpack_require__(27);
	module.exports = function (it) {
	  if (it === undefined) return 0;
	  var number = toInteger(it);
	  var length = toLength(number);
	  if (number !== length) throw RangeError('Wrong length!');
	  return length;
	};


/***/ },
/* 382 */
/***/ function(module, exports, __webpack_require__) {

	exports.f = __webpack_require__(26);


/***/ },
/* 383 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var strong = __webpack_require__(357);
	var validate = __webpack_require__(97);
	var MAP = 'Map';
	
	// 23.1 Map Objects
	module.exports = __webpack_require__(166)(MAP, function (get) {
	  return function Map() { return get(this, arguments.length > 0 ? arguments[0] : undefined); };
	}, {
	  // 23.1.3.6 Map.prototype.get(key)
	  get: function get(key) {
	    var entry = strong.getEntry(validate(this, MAP), key);
	    return entry && entry.v;
	  },
	  // 23.1.3.9 Map.prototype.set(key, value)
	  set: function set(key, value) {
	    return strong.def(validate(this, MAP), key === 0 ? 0 : key, value);
	  }
	}, strong, true);


/***/ },
/* 384 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var regexpExec = __webpack_require__(249);
	__webpack_require__(4)({
	  target: 'RegExp',
	  proto: true,
	  forced: regexpExec !== /./.exec
	}, {
	  exec: regexpExec
	});


/***/ },
/* 385 */
/***/ function(module, exports, __webpack_require__) {

	// 21.2.5.3 get RegExp.prototype.flags()
	if (__webpack_require__(28) && /./g.flags != 'g') __webpack_require__(32).f(RegExp.prototype, 'flags', {
	  configurable: true,
	  get: __webpack_require__(131)
	});


/***/ },
/* 386 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var strong = __webpack_require__(357);
	var validate = __webpack_require__(97);
	var SET = 'Set';
	
	// 23.2 Set Objects
	module.exports = __webpack_require__(166)(SET, function (get) {
	  return function Set() { return get(this, arguments.length > 0 ? arguments[0] : undefined); };
	}, {
	  // 23.2.3.1 Set.prototype.add(value)
	  add: function add(value) {
	    return strong.def(validate(this, SET), value = value === 0 ? 0 : value, value);
	  }
	}, strong);


/***/ },
/* 387 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var global = __webpack_require__(17);
	var each = __webpack_require__(61)(0);
	var redefine = __webpack_require__(41);
	var meta = __webpack_require__(83);
	var assign = __webpack_require__(369);
	var weak = __webpack_require__(359);
	var isObject = __webpack_require__(23);
	var validate = __webpack_require__(97);
	var NATIVE_WEAK_MAP = __webpack_require__(97);
	var IS_IE11 = !global.ActiveXObject && 'ActiveXObject' in global;
	var WEAK_MAP = 'WeakMap';
	var getWeak = meta.getWeak;
	var isExtensible = Object.isExtensible;
	var uncaughtFrozenStore = weak.ufstore;
	var InternalMap;
	
	var wrapper = function (get) {
	  return function WeakMap() {
	    return get(this, arguments.length > 0 ? arguments[0] : undefined);
	  };
	};
	
	var methods = {
	  // 23.3.3.3 WeakMap.prototype.get(key)
	  get: function get(key) {
	    if (isObject(key)) {
	      var data = getWeak(key);
	      if (data === true) return uncaughtFrozenStore(validate(this, WEAK_MAP)).get(key);
	      return data ? data[this._i] : undefined;
	    }
	  },
	  // 23.3.3.5 WeakMap.prototype.set(key, value)
	  set: function set(key, value) {
	    return weak.def(validate(this, WEAK_MAP), key, value);
	  }
	};
	
	// 23.3 WeakMap Objects
	var $WeakMap = module.exports = __webpack_require__(166)(WEAK_MAP, wrapper, methods, weak, true, true);
	
	// IE11 WeakMap frozen keys fix
	if (NATIVE_WEAK_MAP && IS_IE11) {
	  InternalMap = weak.getConstructor(wrapper, WEAK_MAP);
	  assign(InternalMap.prototype, methods);
	  meta.NEED = true;
	  each(['delete', 'has', 'get', 'set'], function (key) {
	    var proto = $WeakMap.prototype;
	    var method = proto[key];
	    redefine(proto, key, function (a, b) {
	      // store frozen objects on internal weakmap shim
	      if (isObject(a) && !isExtensible(a)) {
	        if (!this._f) this._f = new InternalMap();
	        var result = this._f[key](a, b);
	        return key == 'set' ? this : result;
	      // store all the rest on native weakmap
	      } return method.call(this, a, b);
	    });
	  });
	}


/***/ },
/* 388 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Buffer) {var createHash = __webpack_require__(1419)
	
	var md5 = toConstructor(__webpack_require__(832))
	var rmd160 = toConstructor(__webpack_require__(1412))
	
	function toConstructor (fn) {
	  return function () {
	    var buffers = []
	    var m= {
	      update: function (data, enc) {
	        if(!Buffer.isBuffer(data)) data = new Buffer(data, enc)
	        buffers.push(data)
	        return this
	      },
	      digest: function (enc) {
	        var buf = Buffer.concat(buffers)
	        var r = fn(buf)
	        buffers = null
	        return enc ? r.toString(enc) : r
	      }
	    }
	    return m
	  }
	}
	
	module.exports = function (alg) {
	  if('md5' === alg) return new md5()
	  if('rmd160' === alg) return new rmd160()
	  return createHash(alg)
	}
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(31).Buffer))

/***/ },
/* 389 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = assign;
	
	function assign(target, dirtyObject) {
	  if (target == null) {
	    throw new TypeError('assign requires that input parameter not be null or undefined');
	  }
	
	  dirtyObject = dirtyObject || {};
	
	  for (var property in dirtyObject) {
	    if (dirtyObject.hasOwnProperty(property)) {
	      target[property] = dirtyObject[property];
	    }
	  }
	
	  return target;
	}
	
	module.exports = exports.default;

/***/ },
/* 390 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = cloneObject;
	
	var _index = _interopRequireDefault(__webpack_require__(389));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function cloneObject(dirtyObject) {
	  return (0, _index.default)({}, dirtyObject);
	}
	
	module.exports = exports.default;

/***/ },
/* 391 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(111));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/*
	 * |     | Unit                           |     | Unit                           |
	 * |-----|--------------------------------|-----|--------------------------------|
	 * |  a  | AM, PM                         |  A* |                                |
	 * |  d  | Day of month                   |  D  |                                |
	 * |  h  | Hour [1-12]                    |  H  | Hour [0-23]                    |
	 * |  m  | Minute                         |  M  | Month                          |
	 * |  s  | Second                         |  S  | Fraction of second             |
	 * |  y  | Year (abs)                     |  Y  |                                |
	 *
	 * Letters marked by * are not implemented but reserved by Unicode standard.
	 */
	var formatters = {
	  // Year
	  y: function (date, token) {
	    // From http://www.unicode.org/reports/tr35/tr35-31/tr35-dates.html#Date_Format_tokens
	    // | Year     |     y | yy |   yyy |  yyyy | yyyyy |
	    // |----------|-------|----|-------|-------|-------|
	    // | AD 1     |     1 | 01 |   001 |  0001 | 00001 |
	    // | AD 12    |    12 | 12 |   012 |  0012 | 00012 |
	    // | AD 123   |   123 | 23 |   123 |  0123 | 00123 |
	    // | AD 1234  |  1234 | 34 |  1234 |  1234 | 01234 |
	    // | AD 12345 | 12345 | 45 | 12345 | 12345 | 12345 |
	    var signedYear = date.getUTCFullYear(); // Returns 1 for 1 BC (which is year 0 in JavaScript)
	
	    var year = signedYear > 0 ? signedYear : 1 - signedYear;
	    return (0, _index.default)(token === 'yy' ? year % 100 : year, token.length);
	  },
	  // Month
	  M: function (date, token) {
	    var month = date.getUTCMonth();
	    return token === 'M' ? String(month + 1) : (0, _index.default)(month + 1, 2);
	  },
	  // Day of the month
	  d: function (date, token) {
	    return (0, _index.default)(date.getUTCDate(), token.length);
	  },
	  // AM or PM
	  a: function (date, token) {
	    var dayPeriodEnumValue = date.getUTCHours() / 12 >= 1 ? 'pm' : 'am';
	
	    switch (token) {
	      case 'a':
	      case 'aa':
	      case 'aaa':
	        return dayPeriodEnumValue.toUpperCase();
	
	      case 'aaaaa':
	        return dayPeriodEnumValue[0];
	
	      case 'aaaa':
	      default:
	        return dayPeriodEnumValue === 'am' ? 'a.m.' : 'p.m.';
	    }
	  },
	  // Hour [1-12]
	  h: function (date, token) {
	    return (0, _index.default)(date.getUTCHours() % 12 || 12, token.length);
	  },
	  // Hour [0-23]
	  H: function (date, token) {
	    return (0, _index.default)(date.getUTCHours(), token.length);
	  },
	  // Minute
	  m: function (date, token) {
	    return (0, _index.default)(date.getUTCMinutes(), token.length);
	  },
	  // Second
	  s: function (date, token) {
	    return (0, _index.default)(date.getUTCSeconds(), token.length);
	  },
	  // Fraction of second
	  S: function (date, token) {
	    var numberOfDigits = token.length;
	    var milliseconds = date.getUTCMilliseconds();
	    var fractionalSeconds = Math.floor(milliseconds * Math.pow(10, numberOfDigits - 3));
	    return (0, _index.default)(fractionalSeconds, token.length);
	  }
	};
	var _default = formatters;
	exports.default = _default;
	module.exports = exports.default;

/***/ },
/* 392 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	function dateLongFormatter(pattern, formatLong) {
	  switch (pattern) {
	    case 'P':
	      return formatLong.date({
	        width: 'short'
	      });
	
	    case 'PP':
	      return formatLong.date({
	        width: 'medium'
	      });
	
	    case 'PPP':
	      return formatLong.date({
	        width: 'long'
	      });
	
	    case 'PPPP':
	    default:
	      return formatLong.date({
	        width: 'full'
	      });
	  }
	}
	
	function timeLongFormatter(pattern, formatLong) {
	  switch (pattern) {
	    case 'p':
	      return formatLong.time({
	        width: 'short'
	      });
	
	    case 'pp':
	      return formatLong.time({
	        width: 'medium'
	      });
	
	    case 'ppp':
	      return formatLong.time({
	        width: 'long'
	      });
	
	    case 'pppp':
	    default:
	      return formatLong.time({
	        width: 'full'
	      });
	  }
	}
	
	function dateTimeLongFormatter(pattern, formatLong) {
	  var matchResult = pattern.match(/(P+)(p+)?/);
	  var datePattern = matchResult[1];
	  var timePattern = matchResult[2];
	
	  if (!timePattern) {
	    return dateLongFormatter(pattern, formatLong);
	  }
	
	  var dateTimeFormat;
	
	  switch (datePattern) {
	    case 'P':
	      dateTimeFormat = formatLong.dateTime({
	        width: 'short'
	      });
	      break;
	
	    case 'PP':
	      dateTimeFormat = formatLong.dateTime({
	        width: 'medium'
	      });
	      break;
	
	    case 'PPP':
	      dateTimeFormat = formatLong.dateTime({
	        width: 'long'
	      });
	      break;
	
	    case 'PPPP':
	    default:
	      dateTimeFormat = formatLong.dateTime({
	        width: 'full'
	      });
	      break;
	  }
	
	  return dateTimeFormat.replace('{{date}}', dateLongFormatter(datePattern, formatLong)).replace('{{time}}', timeLongFormatter(timePattern, formatLong));
	}
	
	var longFormatters = {
	  p: timeLongFormatter,
	  P: dateTimeLongFormatter
	};
	var _default = longFormatters;
	exports.default = _default;
	module.exports = exports.default;

/***/ },
/* 393 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = getUTCISOWeekYear;
	
	var _index = _interopRequireDefault(__webpack_require__(3));
	
	var _index2 = _interopRequireDefault(__webpack_require__(179));
	
	var _index3 = _interopRequireDefault(__webpack_require__(2));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// This function will be a part of public API when UTC function will be implemented.
	// See issue: https://github.com/date-fns/date-fns/issues/376
	function getUTCISOWeekYear(dirtyDate) {
	  (0, _index3.default)(1, arguments);
	  var date = (0, _index.default)(dirtyDate);
	  var year = date.getUTCFullYear();
	  var fourthOfJanuaryOfNextYear = new Date(0);
	  fourthOfJanuaryOfNextYear.setUTCFullYear(year + 1, 0, 4);
	  fourthOfJanuaryOfNextYear.setUTCHours(0, 0, 0, 0);
	  var startOfNextYear = (0, _index2.default)(fourthOfJanuaryOfNextYear);
	  var fourthOfJanuaryOfThisYear = new Date(0);
	  fourthOfJanuaryOfThisYear.setUTCFullYear(year, 0, 4);
	  fourthOfJanuaryOfThisYear.setUTCHours(0, 0, 0, 0);
	  var startOfThisYear = (0, _index2.default)(fourthOfJanuaryOfThisYear);
	
	  if (date.getTime() >= startOfNextYear.getTime()) {
	    return year + 1;
	  } else if (date.getTime() >= startOfThisYear.getTime()) {
	    return year;
	  } else {
	    return year - 1;
	  }
	}
	
	module.exports = exports.default;

/***/ },
/* 394 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = getUTCISOWeek;
	
	var _index = _interopRequireDefault(__webpack_require__(3));
	
	var _index2 = _interopRequireDefault(__webpack_require__(179));
	
	var _index3 = _interopRequireDefault(__webpack_require__(899));
	
	var _index4 = _interopRequireDefault(__webpack_require__(2));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MILLISECONDS_IN_WEEK = 604800000; // This function will be a part of public API when UTC function will be implemented.
	// See issue: https://github.com/date-fns/date-fns/issues/376
	
	function getUTCISOWeek(dirtyDate) {
	  (0, _index4.default)(1, arguments);
	  var date = (0, _index.default)(dirtyDate);
	  var diff = (0, _index2.default)(date).getTime() - (0, _index3.default)(date).getTime(); // Round the number of days to the nearest integer
	  // because the number of milliseconds in a week is not constant
	  // (e.g. it's different in the week of the daylight saving time clock shift)
	
	  return Math.round(diff / MILLISECONDS_IN_WEEK) + 1;
	}
	
	module.exports = exports.default;

/***/ },
/* 395 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = getUTCWeek;
	
	var _index = _interopRequireDefault(__webpack_require__(3));
	
	var _index2 = _interopRequireDefault(__webpack_require__(180));
	
	var _index3 = _interopRequireDefault(__webpack_require__(900));
	
	var _index4 = _interopRequireDefault(__webpack_require__(2));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MILLISECONDS_IN_WEEK = 604800000; // This function will be a part of public API when UTC function will be implemented.
	// See issue: https://github.com/date-fns/date-fns/issues/376
	
	function getUTCWeek(dirtyDate, options) {
	  (0, _index4.default)(1, arguments);
	  var date = (0, _index.default)(dirtyDate);
	  var diff = (0, _index2.default)(date, options).getTime() - (0, _index3.default)(date, options).getTime(); // Round the number of days to the nearest integer
	  // because the number of milliseconds in a week is not constant
	  // (e.g. it's different in the week of the daylight saving time clock shift)
	
	  return Math.round(diff / MILLISECONDS_IN_WEEK) + 1;
	}
	
	module.exports = exports.default;

/***/ },
/* 396 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.isProtectedDayOfYearToken = isProtectedDayOfYearToken;
	exports.isProtectedWeekYearToken = isProtectedWeekYearToken;
	exports.throwProtectedError = throwProtectedError;
	var protectedDayOfYearTokens = ['D', 'DD'];
	var protectedWeekYearTokens = ['YY', 'YYYY'];
	
	function isProtectedDayOfYearToken(token) {
	  return protectedDayOfYearTokens.indexOf(token) !== -1;
	}
	
	function isProtectedWeekYearToken(token) {
	  return protectedWeekYearTokens.indexOf(token) !== -1;
	}
	
	function throwProtectedError(token) {
	  if (token === 'YYYY') {
	    throw new RangeError('Use `yyyy` instead of `YYYY` for formatting years; see: https://git.io/fxCyr');
	  } else if (token === 'YY') {
	    throw new RangeError('Use `yy` instead of `YY` for formatting years; see: https://git.io/fxCyr');
	  } else if (token === 'D') {
	    throw new RangeError('Use `d` instead of `D` for formatting days of the month; see: https://git.io/fxCyr');
	  } else if (token === 'DD') {
	    throw new RangeError('Use `dd` instead of `DD` for formatting days of the month; see: https://git.io/fxCyr');
	  }
	}

/***/ },
/* 397 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = addBusinessDays;
	
	var _index = _interopRequireDefault(__webpack_require__(188));
	
	var _index2 = _interopRequireDefault(__webpack_require__(3));
	
	var _index3 = _interopRequireDefault(__webpack_require__(9));
	
	var _index4 = _interopRequireDefault(__webpack_require__(2));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name addBusinessDays
	 * @category Day Helpers
	 * @summary Add the specified number of business days (mon - fri) to the given date.
	 *
	 * @description
	 * Add the specified number of business days (mon - fri) to the given date, ignoring weekends.
	 *
	 * @param {Date|Number} date - the date to be changed
	 * @param {Number} amount - the amount of business days to be added. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
	 * @returns {Date} the new date with the business days added
	 * @throws {TypeError} 2 arguments required
	 *
	 * @example
	 * // Add 10 business days to 1 September 2014:
	 * var result = addBusinessDays(new Date(2014, 8, 1), 10)
	 * //=> Mon Sep 15 2014 00:00:00 (skipped weekend days)
	 */
	function addBusinessDays(dirtyDate, dirtyAmount) {
	  (0, _index4.default)(2, arguments);
	  var date = (0, _index2.default)(dirtyDate);
	  var amount = (0, _index3.default)(dirtyAmount);
	  if (isNaN(amount)) return new Date(NaN);
	  var hours = date.getHours();
	  var sign = amount < 0 ? -1 : 1;
	  var fullWeeks = (0, _index3.default)(amount / 5);
	  date.setDate(date.getDate() + fullWeeks * 7); // Get remaining days not part of a full week
	
	  var restDays = Math.abs(amount % 5); // Loops over remaining days
	
	  while (restDays > 0) {
	    date.setDate(date.getDate() + sign);
	    if (!(0, _index.default)(date)) restDays -= 1;
	  } // Restore hours to avoid DST lag
	
	
	  date.setHours(hours);
	  return date;
	}
	
	module.exports = exports.default;

/***/ },
/* 398 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = addISOWeekYears;
	
	var _index = _interopRequireDefault(__webpack_require__(9));
	
	var _index2 = _interopRequireDefault(__webpack_require__(113));
	
	var _index3 = _interopRequireDefault(__webpack_require__(431));
	
	var _index4 = _interopRequireDefault(__webpack_require__(2));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name addISOWeekYears
	 * @category ISO Week-Numbering Year Helpers
	 * @summary Add the specified number of ISO week-numbering years to the given date.
	 *
	 * @description
	 * Add the specified number of ISO week-numbering years to the given date.
	 *
	 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * - The function was renamed from `addISOYears` to `addISOWeekYears`.
	 *   "ISO week year" is short for [ISO week-numbering year](https://en.wikipedia.org/wiki/ISO_week_date).
	 *   This change makes the name consistent with
	 *   locale-dependent week-numbering year helpers, e.g., `addWeekYears`.
	 *
	 * @param {Date|Number} date - the date to be changed
	 * @param {Number} amount - the amount of ISO week-numbering years to be added. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
	 * @returns {Date} the new date with the ISO week-numbering years added
	 * @throws {TypeError} 2 arguments required
	 *
	 * @example
	 * // Add 5 ISO week-numbering years to 2 July 2010:
	 * var result = addISOWeekYears(new Date(2010, 6, 2), 5)
	 * //=> Fri Jun 26 2015 00:00:00
	 */
	function addISOWeekYears(dirtyDate, dirtyAmount) {
	  (0, _index4.default)(2, arguments);
	  var amount = (0, _index.default)(dirtyAmount);
	  return (0, _index3.default)(dirtyDate, (0, _index2.default)(dirtyDate) + amount);
	}
	
	module.exports = exports.default;

/***/ },
/* 399 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = addSeconds;
	
	var _index = _interopRequireDefault(__webpack_require__(9));
	
	var _index2 = _interopRequireDefault(__webpack_require__(137));
	
	var _index3 = _interopRequireDefault(__webpack_require__(2));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name addSeconds
	 * @category Second Helpers
	 * @summary Add the specified number of seconds to the given date.
	 *
	 * @description
	 * Add the specified number of seconds to the given date.
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} date - the date to be changed
	 * @param {Number} amount - the amount of seconds to be added. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
	 * @returns {Date} the new date with the seconds added
	 * @throws {TypeError} 2 arguments required
	 *
	 * @example
	 * // Add 30 seconds to 10 July 2014 12:45:00:
	 * var result = addSeconds(new Date(2014, 6, 10, 12, 45, 0), 30)
	 * //=> Thu Jul 10 2014 12:45:30
	 */
	function addSeconds(dirtyDate, dirtyAmount) {
	  (0, _index3.default)(2, arguments);
	  var amount = (0, _index.default)(dirtyAmount);
	  return (0, _index2.default)(dirtyDate, amount * 1000);
	}
	
	module.exports = exports.default;

/***/ },
/* 400 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = differenceInCalendarISOWeekYears;
	
	var _index = _interopRequireDefault(__webpack_require__(113));
	
	var _index2 = _interopRequireDefault(__webpack_require__(2));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name differenceInCalendarISOWeekYears
	 * @category ISO Week-Numbering Year Helpers
	 * @summary Get the number of calendar ISO week-numbering years between the given dates.
	 *
	 * @description
	 * Get the number of calendar ISO week-numbering years between the given dates.
	 *
	 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * - The function was renamed from `differenceInCalendarISOYears` to `differenceInCalendarISOWeekYears`.
	 *   "ISO week year" is short for [ISO week-numbering year](https://en.wikipedia.org/wiki/ISO_week_date).
	 *   This change makes the name consistent with
	 *   locale-dependent week-numbering year helpers, e.g., `addWeekYears`.
	 *
	 * @param {Date|Number} dateLeft - the later date
	 * @param {Date|Number} dateRight - the earlier date
	 * @returns {Number} the number of calendar ISO week-numbering years
	 * @throws {TypeError} 2 arguments required
	 *
	 * @example
	 * // How many calendar ISO week-numbering years are 1 January 2010 and 1 January 2012?
	 * var result = differenceInCalendarISOWeekYears(
	 *   new Date(2012, 0, 1),
	 *   new Date(2010, 0, 1)
	 * )
	 * //=> 2
	 */
	function differenceInCalendarISOWeekYears(dirtyDateLeft, dirtyDateRight) {
	  (0, _index2.default)(2, arguments);
	  return (0, _index.default)(dirtyDateLeft) - (0, _index.default)(dirtyDateRight);
	}
	
	module.exports = exports.default;

/***/ },
/* 401 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = differenceInHours;
	
	var _index = _interopRequireDefault(__webpack_require__(182));
	
	var _index2 = _interopRequireDefault(__webpack_require__(2));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MILLISECONDS_IN_HOUR = 3600000;
	/**
	 * @name differenceInHours
	 * @category Hour Helpers
	 * @summary Get the number of hours between the given dates.
	 *
	 * @description
	 * Get the number of hours between the given dates.
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} dateLeft - the later date
	 * @param {Date|Number} dateRight - the earlier date
	 * @returns {Number} the number of hours
	 * @throws {TypeError} 2 arguments required
	 *
	 * @example
	 * // How many hours are between 2 July 2014 06:50:00 and 2 July 2014 19:00:00?
	 * var result = differenceInHours(
	 *   new Date(2014, 6, 2, 19, 0),
	 *   new Date(2014, 6, 2, 6, 50)
	 * )
	 * //=> 12
	 */
	
	function differenceInHours(dirtyDateLeft, dirtyDateRight) {
	  (0, _index2.default)(2, arguments);
	  var diff = (0, _index.default)(dirtyDateLeft, dirtyDateRight) / MILLISECONDS_IN_HOUR;
	  return diff > 0 ? Math.floor(diff) : Math.ceil(diff);
	}
	
	module.exports = exports.default;

/***/ },
/* 402 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = differenceInMinutes;
	
	var _index = _interopRequireDefault(__webpack_require__(182));
	
	var _index2 = _interopRequireDefault(__webpack_require__(2));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MILLISECONDS_IN_MINUTE = 60000;
	/**
	 * @name differenceInMinutes
	 * @category Minute Helpers
	 * @summary Get the number of minutes between the given dates.
	 *
	 * @description
	 * Get the signed number of full (rounded towards 0) minutes between the given dates.
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} dateLeft - the later date
	 * @param {Date|Number} dateRight - the earlier date
	 * @returns {Number} the number of minutes
	 * @throws {TypeError} 2 arguments required
	 *
	 * @example
	 * // How many minutes are between 2 July 2014 12:07:59 and 2 July 2014 12:20:00?
	 * var result = differenceInMinutes(
	 *   new Date(2014, 6, 2, 12, 20, 0),
	 *   new Date(2014, 6, 2, 12, 7, 59)
	 * )
	 * //=> 12
	 *
	 * @example
	 * // How many minutes are from 10:01:59 to 10:00:00
	 * var result = differenceInMinutes(
	 *   new Date(2000, 0, 1, 10, 0, 0),
	 *   new Date(2000, 0, 1, 10, 1, 59)
	 * )
	 * //=> -1
	 */
	
	function differenceInMinutes(dirtyDateLeft, dirtyDateRight) {
	  (0, _index2.default)(2, arguments);
	  var diff = (0, _index.default)(dirtyDateLeft, dirtyDateRight) / MILLISECONDS_IN_MINUTE;
	  return diff > 0 ? Math.floor(diff) : Math.ceil(diff);
	}
	
	module.exports = exports.default;

/***/ },
/* 403 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = differenceInYears;
	
	var _index = _interopRequireDefault(__webpack_require__(3));
	
	var _index2 = _interopRequireDefault(__webpack_require__(266));
	
	var _index3 = _interopRequireDefault(__webpack_require__(98));
	
	var _index4 = _interopRequireDefault(__webpack_require__(2));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name differenceInYears
	 * @category Year Helpers
	 * @summary Get the number of full years between the given dates.
	 *
	 * @description
	 * Get the number of full years between the given dates.
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} dateLeft - the later date
	 * @param {Date|Number} dateRight - the earlier date
	 * @returns {Number} the number of full years
	 * @throws {TypeError} 2 arguments required
	 *
	 * @example
	 * // How many full years are between 31 December 2013 and 11 February 2015?
	 * var result = differenceInYears(new Date(2015, 1, 11), new Date(2013, 11, 31))
	 * //=> 1
	 */
	function differenceInYears(dirtyDateLeft, dirtyDateRight) {
	  (0, _index4.default)(2, arguments);
	  var dateLeft = (0, _index.default)(dirtyDateLeft);
	  var dateRight = (0, _index.default)(dirtyDateRight);
	  var sign = (0, _index3.default)(dateLeft, dateRight);
	  var difference = Math.abs((0, _index2.default)(dateLeft, dateRight)); // Set both dates to a valid leap year for accurate comparison when dealing
	  // with leap days
	
	  dateLeft.setFullYear('1584');
	  dateRight.setFullYear('1584'); // Math.abs(diff in full years - diff in calendar years) === 1 if last calendar year is not full
	  // If so, result must be decreased by 1 in absolute value
	
	  var isLastYearNotFull = (0, _index3.default)(dateLeft, dateRight) === -sign;
	  var result = sign * (difference - isLastYearNotFull); // Prevent negative zero
	
	  return result === 0 ? 0 : result;
	}
	
	module.exports = exports.default;

/***/ },
/* 404 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = eachDayOfInterval;
	
	var _index = _interopRequireDefault(__webpack_require__(3));
	
	var _index2 = _interopRequireDefault(__webpack_require__(2));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name eachDayOfInterval
	 * @category Interval Helpers
	 * @summary Return the array of dates within the specified time interval.
	 *
	 * @description
	 * Return the array of dates within the specified time interval.
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * - The function was renamed from `eachDay` to `eachDayOfInterval`.
	 *   This change was made to mirror the use of the word "interval" in standard ISO 8601:2004 terminology:
	 *
	 *   ```
	 *   2.1.3
	 *   time interval
	 *   part of the time axis limited by two instants
	 *   ```
	 *
	 *   Also, this function now accepts an object with `start` and `end` properties
	 *   instead of two arguments as an interval.
	 *   This function now throws `RangeError` if the start of the interval is after its end
	 *   or if any date in the interval is `Invalid Date`.
	 *
	 *   ```javascript
	 *   // Before v2.0.0
	 *
	 *   eachDay(new Date(2014, 0, 10), new Date(2014, 0, 20))
	 *
	 *   // v2.0.0 onward
	 *
	 *   eachDayOfInterval(
	 *     { start: new Date(2014, 0, 10), end: new Date(2014, 0, 20) }
	 *   )
	 *   ```
	 *
	 * @param {Interval} interval - the interval. See [Interval]{@link docs/types/Interval}
	 * @param {Object} [options] - an object with options.
	 * @param {Number} [options.step=1] - the step to increment by. The value should be more than 1.
	 * @returns {Date[]} the array with starts of days from the day of the interval start to the day of the interval end
	 * @throws {TypeError} 1 argument required
	 * @throws {RangeError} `options.step` must be a number greater than 1
	 * @throws {RangeError} The start of an interval cannot be after its end
	 * @throws {RangeError} Date in interval cannot be `Invalid Date`
	 *
	 * @example
	 * // Each day between 6 October 2014 and 10 October 2014:
	 * var result = eachDayOfInterval({
	 *   start: new Date(2014, 9, 6),
	 *   end: new Date(2014, 9, 10)
	 * })
	 * //=> [
	 * //   Mon Oct 06 2014 00:00:00,
	 * //   Tue Oct 07 2014 00:00:00,
	 * //   Wed Oct 08 2014 00:00:00,
	 * //   Thu Oct 09 2014 00:00:00,
	 * //   Fri Oct 10 2014 00:00:00
	 * // ]
	 */
	function eachDayOfInterval(dirtyInterval, options) {
	  (0, _index2.default)(1, arguments);
	  var interval = dirtyInterval || {};
	  var startDate = (0, _index.default)(interval.start);
	  var endDate = (0, _index.default)(interval.end);
	  var endTime = endDate.getTime(); // Throw an exception if start date is after end date or if any date is `Invalid Date`
	
	  if (!(startDate.getTime() <= endTime)) {
	    throw new RangeError('Invalid interval');
	  }
	
	  var dates = [];
	  var currentDate = startDate;
	  currentDate.setHours(0, 0, 0, 0);
	  var step = options && 'step' in options ? Number(options.step) : 1;
	  if (step < 1 || isNaN(step)) throw new RangeError('`options.step` must be a number greater than 1');
	
	  while (currentDate.getTime() <= endTime) {
	    dates.push((0, _index.default)(currentDate));
	    currentDate.setDate(currentDate.getDate() + step);
	    currentDate.setHours(0, 0, 0, 0);
	  }
	
	  return dates;
	}
	
	module.exports = exports.default;

/***/ },
/* 405 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = endOfYear;
	
	var _index = _interopRequireDefault(__webpack_require__(3));
	
	var _index2 = _interopRequireDefault(__webpack_require__(2));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name endOfYear
	 * @category Year Helpers
	 * @summary Return the end of a year for the given date.
	 *
	 * @description
	 * Return the end of a year for the given date.
	 * The result will be in the local timezone.
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} date - the original date
	 * @returns {Date} the end of a year
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // The end of a year for 2 September 2014 11:55:00:
	 * var result = endOfYear(new Date(2014, 8, 2, 11, 55, 00))
	 * //=> Wed Dec 31 2014 23:59:59.999
	 */
	function endOfYear(dirtyDate) {
	  (0, _index2.default)(1, arguments);
	  var date = (0, _index.default)(dirtyDate);
	  var year = date.getFullYear();
	  date.setFullYear(year + 1, 0, 0);
	  date.setHours(23, 59, 59, 999);
	  return date;
	}
	
	module.exports = exports.default;

/***/ },
/* 406 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = formatDistanceStrict;
	
	var _index = _interopRequireDefault(__webpack_require__(73));
	
	var _index2 = _interopRequireDefault(__webpack_require__(98));
	
	var _index3 = _interopRequireDefault(__webpack_require__(3));
	
	var _index4 = _interopRequireDefault(__webpack_require__(183));
	
	var _index5 = _interopRequireDefault(__webpack_require__(390));
	
	var _index6 = _interopRequireDefault(__webpack_require__(115));
	
	var _index7 = _interopRequireDefault(__webpack_require__(2));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MINUTES_IN_DAY = 1440;
	var MINUTES_IN_MONTH = 43200;
	var MINUTES_IN_YEAR = 525600;
	/**
	 * @name formatDistanceStrict
	 * @category Common Helpers
	 * @summary Return the distance between the given dates in words.
	 *
	 * @description
	 * Return the distance between the given dates in words, using strict units.
	 * This is like `formatDistance`, but does not use helpers like 'almost', 'over',
	 * 'less than' and the like.
	 *
	 * | Distance between dates | Result              |
	 * |------------------------|---------------------|
	 * | 0 ... 59 secs          | [0..59] seconds     |
	 * | 1 ... 59 mins          | [1..59] minutes     |
	 * | 1 ... 23 hrs           | [1..23] hours       |
	 * | 1 ... 29 days          | [1..29] days        |
	 * | 1 ... 11 months        | [1..11] months      |
	 * | 1 ... N years          | [1..N]  years       |
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * - The function was renamed from `distanceInWordsStrict` to `formatDistanceStrict`
	 *   to make its name consistent with `format` and `formatRelative`.
	 *
	 * - The order of arguments is swapped to make the function
	 *   consistent with `differenceIn...` functions.
	 *
	 *   ```javascript
	 *   // Before v2.0.0
	 *
	 *   distanceInWordsStrict(
	 *     new Date(2015, 0, 2),
	 *     new Date(2014, 6, 2)
	 *   ) //=> '6 months'
	 *
	 *   // v2.0.0 onward
	 *
	 *   formatDistanceStrict(
	 *     new Date(2014, 6, 2),
	 *     new Date(2015, 0, 2)
	 *   ) //=> '6 months'
	 *   ```
	 *
	 * - `partialMethod` option is renamed to `roundingMethod`.
	 *
	 *   ```javascript
	 *   // Before v2.0.0
	 *
	 *   distanceInWordsStrict(
	 *     new Date(1986, 3, 4, 10, 32, 0),
	 *     new Date(1986, 3, 4, 10, 33, 1),
	 *     { partialMethod: 'ceil' }
	 *   ) //=> '2 minutes'
	 *
	 *   // v2.0.0 onward
	 *
	 *   formatDistanceStrict(
	 *     new Date(1986, 3, 4, 10, 33, 1),
	 *     new Date(1986, 3, 4, 10, 32, 0),
	 *     { roundingMethod: 'ceil' }
	 *   ) //=> '2 minutes'
	 *   ```
	 *
	 * - If `roundingMethod` is not specified, it now defaults to `round` instead of `floor`.
	 *
	 * - `unit` option now accepts one of the strings:
	 *   'second', 'minute', 'hour', 'day', 'month' or 'year' instead of 's', 'm', 'h', 'd', 'M' or 'Y'
	 *
	 *   ```javascript
	 *   // Before v2.0.0
	 *
	 *   distanceInWordsStrict(
	 *     new Date(1986, 3, 4, 10, 32, 0),
	 *     new Date(1986, 3, 4, 10, 33, 1),
	 *     { unit: 'm' }
	 *   )
	 *
	 *   // v2.0.0 onward
	 *
	 *   formatDistanceStrict(
	 *     new Date(1986, 3, 4, 10, 33, 1),
	 *     new Date(1986, 3, 4, 10, 32, 0),
	 *     { unit: 'minute' }
	 *   )
	 *   ```
	 *
	 * @param {Date|Number} date - the date
	 * @param {Date|Number} baseDate - the date to compare with
	 * @param {Object} [options] - an object with options.
	 * @param {Boolean} [options.addSuffix=false] - result indicates if the second date is earlier or later than the first
	 * @param {'second'|'minute'|'hour'|'day'|'month'|'year'} [options.unit] - if specified, will force a unit
	 * @param {'floor'|'ceil'|'round'} [options.roundingMethod='round'] - which way to round partial units
	 * @param {Locale} [options.locale=defaultLocale] - the locale object. See [Locale]{@link https://date-fns.org/docs/Locale}
	 * @returns {String} the distance in words
	 * @throws {TypeError} 2 arguments required
	 * @throws {RangeError} `date` must not be Invalid Date
	 * @throws {RangeError} `baseDate` must not be Invalid Date
	 * @throws {RangeError} `options.roundingMethod` must be 'floor', 'ceil' or 'round'
	 * @throws {RangeError} `options.unit` must be 'second', 'minute', 'hour', 'day', 'month' or 'year'
	 * @throws {RangeError} `options.locale` must contain `formatDistance` property
	 *
	 * @example
	 * // What is the distance between 2 July 2014 and 1 January 2015?
	 * var result = formatDistanceStrict(new Date(2014, 6, 2), new Date(2015, 0, 2))
	 * //=> '6 months'
	 *
	 * @example
	 * // What is the distance between 1 January 2015 00:00:15
	 * // and 1 January 2015 00:00:00?
	 * var result = formatDistanceStrict(
	 *   new Date(2015, 0, 1, 0, 0, 15),
	 *   new Date(2015, 0, 1, 0, 0, 0)
	 * )
	 * //=> '15 seconds'
	 *
	 * @example
	 * // What is the distance from 1 January 2016
	 * // to 1 January 2015, with a suffix?
	 * var result = formatDistanceStrict(new Date(2015, 0, 1), new Date(2016, 0, 1), {
	 *   addSuffix: true
	 * })
	 * //=> '1 year ago'
	 *
	 * @example
	 * // What is the distance from 1 January 2016
	 * // to 1 January 2015, in minutes?
	 * var result = formatDistanceStrict(new Date(2016, 0, 1), new Date(2015, 0, 1), {
	 *   unit: 'minute'
	 * })
	 * //=> '525600 minutes'
	 *
	 * @example
	 * // What is the distance from 1 January 2015
	 * // to 28 January 2015, in months, rounded up?
	 * var result = formatDistanceStrict(new Date(2015, 0, 28), new Date(2015, 0, 1), {
	 *   unit: 'month',
	 *   roundingMethod: 'ceil'
	 * })
	 * //=> '1 month'
	 *
	 * @example
	 * // What is the distance between 1 August 2016 and 1 January 2015 in Esperanto?
	 * import { eoLocale } from 'date-fns/locale/eo'
	 * var result = formatDistanceStrict(new Date(2016, 7, 1), new Date(2015, 0, 1), {
	 *   locale: eoLocale
	 * })
	 * //=> '1 jaro'
	 */
	
	function formatDistanceStrict(dirtyDate, dirtyBaseDate, dirtyOptions) {
	  (0, _index7.default)(2, arguments);
	  var options = dirtyOptions || {};
	  var locale = options.locale || _index6.default;
	
	  if (!locale.formatDistance) {
	    throw new RangeError('locale must contain localize.formatDistance property');
	  }
	
	  var comparison = (0, _index2.default)(dirtyDate, dirtyBaseDate);
	
	  if (isNaN(comparison)) {
	    throw new RangeError('Invalid time value');
	  }
	
	  var localizeOptions = (0, _index5.default)(options);
	  localizeOptions.addSuffix = Boolean(options.addSuffix);
	  localizeOptions.comparison = comparison;
	  var dateLeft;
	  var dateRight;
	
	  if (comparison > 0) {
	    dateLeft = (0, _index3.default)(dirtyBaseDate);
	    dateRight = (0, _index3.default)(dirtyDate);
	  } else {
	    dateLeft = (0, _index3.default)(dirtyDate);
	    dateRight = (0, _index3.default)(dirtyBaseDate);
	  }
	
	  var roundingMethod = options.roundingMethod == null ? 'round' : String(options.roundingMethod);
	  var roundingMethodFn;
	
	  if (roundingMethod === 'floor') {
	    roundingMethodFn = Math.floor;
	  } else if (roundingMethod === 'ceil') {
	    roundingMethodFn = Math.ceil;
	  } else if (roundingMethod === 'round') {
	    roundingMethodFn = Math.round;
	  } else {
	    throw new RangeError("roundingMethod must be 'floor', 'ceil' or 'round'");
	  }
	
	  var seconds = (0, _index4.default)(dateRight, dateLeft);
	  var offsetInSeconds = ((0, _index.default)(dateRight) - (0, _index.default)(dateLeft)) / 1000;
	  var minutes = roundingMethodFn((seconds - offsetInSeconds) / 60);
	  var unit;
	
	  if (options.unit == null) {
	    if (minutes < 1) {
	      unit = 'second';
	    } else if (minutes < 60) {
	      unit = 'minute';
	    } else if (minutes < MINUTES_IN_DAY) {
	      unit = 'hour';
	    } else if (minutes < MINUTES_IN_MONTH) {
	      unit = 'day';
	    } else if (minutes < MINUTES_IN_YEAR) {
	      unit = 'month';
	    } else {
	      unit = 'year';
	    }
	  } else {
	    unit = String(options.unit);
	  } // 0 up to 60 seconds
	
	
	  if (unit === 'second') {
	    return locale.formatDistance('xSeconds', seconds, localizeOptions); // 1 up to 60 mins
	  } else if (unit === 'minute') {
	    return locale.formatDistance('xMinutes', minutes, localizeOptions); // 1 up to 24 hours
	  } else if (unit === 'hour') {
	    var hours = roundingMethodFn(minutes / 60);
	    return locale.formatDistance('xHours', hours, localizeOptions); // 1 up to 30 days
	  } else if (unit === 'day') {
	    var days = roundingMethodFn(minutes / MINUTES_IN_DAY);
	    return locale.formatDistance('xDays', days, localizeOptions); // 1 up to 12 months
	  } else if (unit === 'month') {
	    var months = roundingMethodFn(minutes / MINUTES_IN_MONTH);
	    return locale.formatDistance('xMonths', months, localizeOptions); // 1 year up to max Date
	  } else if (unit === 'year') {
	    var years = roundingMethodFn(minutes / MINUTES_IN_YEAR);
	    return locale.formatDistance('xYears', years, localizeOptions);
	  }
	
	  throw new RangeError("unit must be 'second', 'minute', 'hour', 'day', 'month' or 'year'");
	}
	
	module.exports = exports.default;

/***/ },
/* 407 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = formatDistance;
	
	var _index = _interopRequireDefault(__webpack_require__(98));
	
	var _index2 = _interopRequireDefault(__webpack_require__(140));
	
	var _index3 = _interopRequireDefault(__webpack_require__(183));
	
	var _index4 = _interopRequireDefault(__webpack_require__(115));
	
	var _index5 = _interopRequireDefault(__webpack_require__(3));
	
	var _index6 = _interopRequireDefault(__webpack_require__(390));
	
	var _index7 = _interopRequireDefault(__webpack_require__(73));
	
	var _index8 = _interopRequireDefault(__webpack_require__(2));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MINUTES_IN_DAY = 1440;
	var MINUTES_IN_ALMOST_TWO_DAYS = 2520;
	var MINUTES_IN_MONTH = 43200;
	var MINUTES_IN_TWO_MONTHS = 86400;
	/**
	 * @name formatDistance
	 * @category Common Helpers
	 * @summary Return the distance between the given dates in words.
	 *
	 * @description
	 * Return the distance between the given dates in words.
	 *
	 * | Distance between dates                                            | Result              |
	 * |-------------------------------------------------------------------|---------------------|
	 * | 0 ... 30 secs                                                     | less than a minute  |
	 * | 30 secs ... 1 min 30 secs                                         | 1 minute            |
	 * | 1 min 30 secs ... 44 mins 30 secs                                 | [2..44] minutes     |
	 * | 44 mins ... 30 secs ... 89 mins 30 secs                           | about 1 hour        |
	 * | 89 mins 30 secs ... 23 hrs 59 mins 30 secs                        | about [2..24] hours |
	 * | 23 hrs 59 mins 30 secs ... 41 hrs 59 mins 30 secs                 | 1 day               |
	 * | 41 hrs 59 mins 30 secs ... 29 days 23 hrs 59 mins 30 secs         | [2..30] days        |
	 * | 29 days 23 hrs 59 mins 30 secs ... 44 days 23 hrs 59 mins 30 secs | about 1 month       |
	 * | 44 days 23 hrs 59 mins 30 secs ... 59 days 23 hrs 59 mins 30 secs | about 2 months      |
	 * | 59 days 23 hrs 59 mins 30 secs ... 1 yr                           | [2..12] months      |
	 * | 1 yr ... 1 yr 3 months                                            | about 1 year        |
	 * | 1 yr 3 months ... 1 yr 9 month s                                  | over 1 year         |
	 * | 1 yr 9 months ... 2 yrs                                           | almost 2 years      |
	 * | N yrs ... N yrs 3 months                                          | about N years       |
	 * | N yrs 3 months ... N yrs 9 months                                 | over N years        |
	 * | N yrs 9 months ... N+1 yrs                                        | almost N+1 years    |
	 *
	 * With `options.includeSeconds == true`:
	 * | Distance between dates | Result               |
	 * |------------------------|----------------------|
	 * | 0 secs ... 5 secs      | less than 5 seconds  |
	 * | 5 secs ... 10 secs     | less than 10 seconds |
	 * | 10 secs ... 20 secs    | less than 20 seconds |
	 * | 20 secs ... 40 secs    | half a minute        |
	 * | 40 secs ... 60 secs    | less than a minute   |
	 * | 60 secs ... 90 secs    | 1 minute             |
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * - The function was renamed from `distanceInWords ` to `formatDistance`
	 *   to make its name consistent with `format` and `formatRelative`.
	 *
	 * - The order of arguments is swapped to make the function
	 *   consistent with `differenceIn...` functions.
	 *
	 *   ```javascript
	 *   // Before v2.0.0
	 *
	 *   distanceInWords(
	 *     new Date(1986, 3, 4, 10, 32, 0),
	 *     new Date(1986, 3, 4, 11, 32, 0),
	 *     { addSuffix: true }
	 *   ) //=> 'in about 1 hour'
	 *
	 *   // v2.0.0 onward
	 *
	 *   formatDistance(
	 *     new Date(1986, 3, 4, 11, 32, 0),
	 *     new Date(1986, 3, 4, 10, 32, 0),
	 *     { addSuffix: true }
	 *   ) //=> 'in about 1 hour'
	 *   ```
	 *
	 * @param {Date|Number} date - the date
	 * @param {Date|Number} baseDate - the date to compare with
	 * @param {Object} [options] - an object with options.
	 * @param {Boolean} [options.includeSeconds=false] - distances less than a minute are more detailed
	 * @param {Boolean} [options.addSuffix=false] - result indicates if the second date is earlier or later than the first
	 * @param {Locale} [options.locale=defaultLocale] - the locale object. See [Locale]{@link https://date-fns.org/docs/Locale}
	 * @returns {String} the distance in words
	 * @throws {TypeError} 2 arguments required
	 * @throws {RangeError} `date` must not be Invalid Date
	 * @throws {RangeError} `baseDate` must not be Invalid Date
	 * @throws {RangeError} `options.locale` must contain `formatDistance` property
	 *
	 * @example
	 * // What is the distance between 2 July 2014 and 1 January 2015?
	 * var result = formatDistance(new Date(2014, 6, 2), new Date(2015, 0, 1))
	 * //=> '6 months'
	 *
	 * @example
	 * // What is the distance between 1 January 2015 00:00:15
	 * // and 1 January 2015 00:00:00, including seconds?
	 * var result = formatDistance(
	 *   new Date(2015, 0, 1, 0, 0, 15),
	 *   new Date(2015, 0, 1, 0, 0, 0),
	 *   { includeSeconds: true }
	 * )
	 * //=> 'less than 20 seconds'
	 *
	 * @example
	 * // What is the distance from 1 January 2016
	 * // to 1 January 2015, with a suffix?
	 * var result = formatDistance(new Date(2015, 0, 1), new Date(2016, 0, 1), {
	 *   addSuffix: true
	 * })
	 * //=> 'about 1 year ago'
	 *
	 * @example
	 * // What is the distance between 1 August 2016 and 1 January 2015 in Esperanto?
	 * import { eoLocale } from 'date-fns/locale/eo'
	 * var result = formatDistance(new Date(2016, 7, 1), new Date(2015, 0, 1), {
	 *   locale: eoLocale
	 * })
	 * //=> 'pli ol 1 jaro'
	 */
	
	function formatDistance(dirtyDate, dirtyBaseDate, dirtyOptions) {
	  (0, _index8.default)(2, arguments);
	  var options = dirtyOptions || {};
	  var locale = options.locale || _index4.default;
	
	  if (!locale.formatDistance) {
	    throw new RangeError('locale must contain formatDistance property');
	  }
	
	  var comparison = (0, _index.default)(dirtyDate, dirtyBaseDate);
	
	  if (isNaN(comparison)) {
	    throw new RangeError('Invalid time value');
	  }
	
	  var localizeOptions = (0, _index6.default)(options);
	  localizeOptions.addSuffix = Boolean(options.addSuffix);
	  localizeOptions.comparison = comparison;
	  var dateLeft;
	  var dateRight;
	
	  if (comparison > 0) {
	    dateLeft = (0, _index5.default)(dirtyBaseDate);
	    dateRight = (0, _index5.default)(dirtyDate);
	  } else {
	    dateLeft = (0, _index5.default)(dirtyDate);
	    dateRight = (0, _index5.default)(dirtyBaseDate);
	  }
	
	  var seconds = (0, _index3.default)(dateRight, dateLeft);
	  var offsetInSeconds = ((0, _index7.default)(dateRight) - (0, _index7.default)(dateLeft)) / 1000;
	  var minutes = Math.round((seconds - offsetInSeconds) / 60);
	  var months; // 0 up to 2 mins
	
	  if (minutes < 2) {
	    if (options.includeSeconds) {
	      if (seconds < 5) {
	        return locale.formatDistance('lessThanXSeconds', 5, localizeOptions);
	      } else if (seconds < 10) {
	        return locale.formatDistance('lessThanXSeconds', 10, localizeOptions);
	      } else if (seconds < 20) {
	        return locale.formatDistance('lessThanXSeconds', 20, localizeOptions);
	      } else if (seconds < 40) {
	        return locale.formatDistance('halfAMinute', null, localizeOptions);
	      } else if (seconds < 60) {
	        return locale.formatDistance('lessThanXMinutes', 1, localizeOptions);
	      } else {
	        return locale.formatDistance('xMinutes', 1, localizeOptions);
	      }
	    } else {
	      if (minutes === 0) {
	        return locale.formatDistance('lessThanXMinutes', 1, localizeOptions);
	      } else {
	        return locale.formatDistance('xMinutes', minutes, localizeOptions);
	      }
	    } // 2 mins up to 0.75 hrs
	
	  } else if (minutes < 45) {
	    return locale.formatDistance('xMinutes', minutes, localizeOptions); // 0.75 hrs up to 1.5 hrs
	  } else if (minutes < 90) {
	    return locale.formatDistance('aboutXHours', 1, localizeOptions); // 1.5 hrs up to 24 hrs
	  } else if (minutes < MINUTES_IN_DAY) {
	    var hours = Math.round(minutes / 60);
	    return locale.formatDistance('aboutXHours', hours, localizeOptions); // 1 day up to 1.75 days
	  } else if (minutes < MINUTES_IN_ALMOST_TWO_DAYS) {
	    return locale.formatDistance('xDays', 1, localizeOptions); // 1.75 days up to 30 days
	  } else if (minutes < MINUTES_IN_MONTH) {
	    var days = Math.round(minutes / MINUTES_IN_DAY);
	    return locale.formatDistance('xDays', days, localizeOptions); // 1 month up to 2 months
	  } else if (minutes < MINUTES_IN_TWO_MONTHS) {
	    months = Math.round(minutes / MINUTES_IN_MONTH);
	    return locale.formatDistance('aboutXMonths', months, localizeOptions);
	  }
	
	  months = (0, _index2.default)(dateRight, dateLeft); // 2 months up to 12 months
	
	  if (months < 12) {
	    var nearestMonth = Math.round(minutes / MINUTES_IN_MONTH);
	    return locale.formatDistance('xMonths', nearestMonth, localizeOptions); // 1 year up to max Date
	  } else {
	    var monthsSinceStartOfYear = months % 12;
	    var years = Math.floor(months / 12); // N years up to 1 years 3 months
	
	    if (monthsSinceStartOfYear < 3) {
	      return locale.formatDistance('aboutXYears', years, localizeOptions); // N years 3 months up to N years 9 months
	    } else if (monthsSinceStartOfYear < 9) {
	      return locale.formatDistance('overXYears', years, localizeOptions); // N years 9 months up to N year 12 months
	    } else {
	      return locale.formatDistance('almostXYears', years + 1, localizeOptions);
	    }
	  }
	}
	
	module.exports = exports.default;

/***/ },
/* 408 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = getDaysInMonth;
	
	var _index = _interopRequireDefault(__webpack_require__(3));
	
	var _index2 = _interopRequireDefault(__webpack_require__(2));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name getDaysInMonth
	 * @category Month Helpers
	 * @summary Get the number of days in a month of the given date.
	 *
	 * @description
	 * Get the number of days in a month of the given date.
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} date - the given date
	 * @returns {Number} the number of days in a month
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // How many days are in February 2000?
	 * var result = getDaysInMonth(new Date(2000, 1))
	 * //=> 29
	 */
	function getDaysInMonth(dirtyDate) {
	  (0, _index2.default)(1, arguments);
	  var date = (0, _index.default)(dirtyDate);
	  var year = date.getFullYear();
	  var monthIndex = date.getMonth();
	  var lastDayOfMonth = new Date(0);
	  lastDayOfMonth.setFullYear(year, monthIndex + 1, 0);
	  lastDayOfMonth.setHours(0, 0, 0, 0);
	  return lastDayOfMonth.getDate();
	}
	
	module.exports = exports.default;

/***/ },
/* 409 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = getHours;
	
	var _index = _interopRequireDefault(__webpack_require__(3));
	
	var _index2 = _interopRequireDefault(__webpack_require__(2));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name getHours
	 * @category Hour Helpers
	 * @summary Get the hours of the given date.
	 *
	 * @description
	 * Get the hours of the given date.
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} date - the given date
	 * @returns {Number} the hours
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // Get the hours of 29 February 2012 11:45:00:
	 * var result = getHours(new Date(2012, 1, 29, 11, 45))
	 * //=> 11
	 */
	function getHours(dirtyDate) {
	  (0, _index2.default)(1, arguments);
	  var date = (0, _index.default)(dirtyDate);
	  var hours = date.getHours();
	  return hours;
	}
	
	module.exports = exports.default;

/***/ },
/* 410 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = getISODay;
	
	var _index = _interopRequireDefault(__webpack_require__(3));
	
	var _index2 = _interopRequireDefault(__webpack_require__(2));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name getISODay
	 * @category Weekday Helpers
	 * @summary Get the day of the ISO week of the given date.
	 *
	 * @description
	 * Get the day of the ISO week of the given date,
	 * which is 7 for Sunday, 1 for Monday etc.
	 *
	 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} date - the given date
	 * @returns {Number} the day of ISO week
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // Which day of the ISO week is 26 February 2012?
	 * var result = getISODay(new Date(2012, 1, 26))
	 * //=> 7
	 */
	function getISODay(dirtyDate) {
	  (0, _index2.default)(1, arguments);
	  var date = (0, _index.default)(dirtyDate);
	  var day = date.getDay();
	
	  if (day === 0) {
	    day = 7;
	  }
	
	  return day;
	}
	
	module.exports = exports.default;

/***/ },
/* 411 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = getISOWeek;
	
	var _index = _interopRequireDefault(__webpack_require__(3));
	
	var _index2 = _interopRequireDefault(__webpack_require__(99));
	
	var _index3 = _interopRequireDefault(__webpack_require__(141));
	
	var _index4 = _interopRequireDefault(__webpack_require__(2));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MILLISECONDS_IN_WEEK = 604800000;
	/**
	 * @name getISOWeek
	 * @category ISO Week Helpers
	 * @summary Get the ISO week of the given date.
	 *
	 * @description
	 * Get the ISO week of the given date.
	 *
	 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} date - the given date
	 * @returns {Number} the ISO week
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // Which week of the ISO-week numbering year is 2 January 2005?
	 * var result = getISOWeek(new Date(2005, 0, 2))
	 * //=> 53
	 */
	
	function getISOWeek(dirtyDate) {
	  (0, _index4.default)(1, arguments);
	  var date = (0, _index.default)(dirtyDate);
	  var diff = (0, _index2.default)(date).getTime() - (0, _index3.default)(date).getTime(); // Round the number of days to the nearest integer
	  // because the number of milliseconds in a week is not constant
	  // (e.g. it's different in the week of the daylight saving time clock shift)
	
	  return Math.round(diff / MILLISECONDS_IN_WEEK) + 1;
	}
	
	module.exports = exports.default;

/***/ },
/* 412 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = getMinutes;
	
	var _index = _interopRequireDefault(__webpack_require__(3));
	
	var _index2 = _interopRequireDefault(__webpack_require__(2));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name getMinutes
	 * @category Minute Helpers
	 * @summary Get the minutes of the given date.
	 *
	 * @description
	 * Get the minutes of the given date.
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} date - the given date
	 * @returns {Number} the minutes
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // Get the minutes of 29 February 2012 11:45:05:
	 * var result = getMinutes(new Date(2012, 1, 29, 11, 45, 5))
	 * //=> 45
	 */
	function getMinutes(dirtyDate) {
	  (0, _index2.default)(1, arguments);
	  var date = (0, _index.default)(dirtyDate);
	  var minutes = date.getMinutes();
	  return minutes;
	}
	
	module.exports = exports.default;

/***/ },
/* 413 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = getMonth;
	
	var _index = _interopRequireDefault(__webpack_require__(3));
	
	var _index2 = _interopRequireDefault(__webpack_require__(2));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name getMonth
	 * @category Month Helpers
	 * @summary Get the month of the given date.
	 *
	 * @description
	 * Get the month of the given date.
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} date - the given date
	 * @returns {Number} the month
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // Which month is 29 February 2012?
	 * var result = getMonth(new Date(2012, 1, 29))
	 * //=> 1
	 */
	function getMonth(dirtyDate) {
	  (0, _index2.default)(1, arguments);
	  var date = (0, _index.default)(dirtyDate);
	  var month = date.getMonth();
	  return month;
	}
	
	module.exports = exports.default;

/***/ },
/* 414 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = getSeconds;
	
	var _index = _interopRequireDefault(__webpack_require__(3));
	
	var _index2 = _interopRequireDefault(__webpack_require__(2));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name getSeconds
	 * @category Second Helpers
	 * @summary Get the seconds of the given date.
	 *
	 * @description
	 * Get the seconds of the given date.
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} date - the given date
	 * @returns {Number} the seconds
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // Get the seconds of 29 February 2012 11:45:05.123:
	 * var result = getSeconds(new Date(2012, 1, 29, 11, 45, 5, 123))
	 * //=> 5
	 */
	function getSeconds(dirtyDate) {
	  (0, _index2.default)(1, arguments);
	  var date = (0, _index.default)(dirtyDate);
	  var seconds = date.getSeconds();
	  return seconds;
	}
	
	module.exports = exports.default;

/***/ },
/* 415 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = getWeekYear;
	
	var _index = _interopRequireDefault(__webpack_require__(75));
	
	var _index2 = _interopRequireDefault(__webpack_require__(3));
	
	var _index3 = _interopRequireDefault(__webpack_require__(9));
	
	var _index4 = _interopRequireDefault(__webpack_require__(2));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name getWeekYear
	 * @category Week-Numbering Year Helpers
	 * @summary Get the local week-numbering year of the given date.
	 *
	 * @description
	 * Get the local week-numbering year of the given date.
	 * The exact calculation depends on the values of
	 * `options.weekStartsOn` (which is the index of the first day of the week)
	 * and `options.firstWeekContainsDate` (which is the day of January, which is always in
	 * the first week of the week-numbering year)
	 *
	 * Week numbering: https://en.wikipedia.org/wiki/Week#Week_numbering
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} date - the given date
	 * @param {Object} [options] - an object with options.
	 * @param {Locale} [options.locale=defaultLocale] - the locale object. See [Locale]{@link https://date-fns.org/docs/Locale}
	 * @param {0|1|2|3|4|5|6} [options.weekStartsOn=0] - the index of the first day of the week (0 - Sunday)
	 * @param {1|2|3|4|5|6|7} [options.firstWeekContainsDate=1] - the day of January, which is always in the first week of the year
	 * @returns {Number} the local week-numbering year
	 * @throws {TypeError} 1 argument required
	 * @throws {RangeError} `options.weekStartsOn` must be between 0 and 6
	 * @throws {RangeError} `options.firstWeekContainsDate` must be between 1 and 7
	 *
	 * @example
	 * // Which week numbering year is 26 December 2004 with the default settings?
	 * var result = getWeekYear(new Date(2004, 11, 26))
	 * //=> 2005
	 *
	 * @example
	 * // Which week numbering year is 26 December 2004 if week starts on Saturday?
	 * var result = getWeekYear(new Date(2004, 11, 26), { weekStartsOn: 6 })
	 * //=> 2004
	 *
	 * @example
	 * // Which week numbering year is 26 December 2004 if the first week contains 4 January?
	 * var result = getWeekYear(new Date(2004, 11, 26), { firstWeekContainsDate: 4 })
	 * //=> 2004
	 */
	function getWeekYear(dirtyDate, dirtyOptions) {
	  (0, _index4.default)(1, arguments);
	  var date = (0, _index2.default)(dirtyDate);
	  var year = date.getFullYear();
	  var options = dirtyOptions || {};
	  var locale = options.locale;
	  var localeFirstWeekContainsDate = locale && locale.options && locale.options.firstWeekContainsDate;
	  var defaultFirstWeekContainsDate = localeFirstWeekContainsDate == null ? 1 : (0, _index3.default)(localeFirstWeekContainsDate);
	  var firstWeekContainsDate = options.firstWeekContainsDate == null ? defaultFirstWeekContainsDate : (0, _index3.default)(options.firstWeekContainsDate); // Test if weekStartsOn is between 1 and 7 _and_ is not NaN
	
	  if (!(firstWeekContainsDate >= 1 && firstWeekContainsDate <= 7)) {
	    throw new RangeError('firstWeekContainsDate must be between 1 and 7 inclusively');
	  }
	
	  var firstWeekOfNextYear = new Date(0);
	  firstWeekOfNextYear.setFullYear(year + 1, 0, firstWeekContainsDate);
	  firstWeekOfNextYear.setHours(0, 0, 0, 0);
	  var startOfNextYear = (0, _index.default)(firstWeekOfNextYear, dirtyOptions);
	  var firstWeekOfThisYear = new Date(0);
	  firstWeekOfThisYear.setFullYear(year, 0, firstWeekContainsDate);
	  firstWeekOfThisYear.setHours(0, 0, 0, 0);
	  var startOfThisYear = (0, _index.default)(firstWeekOfThisYear, dirtyOptions);
	
	  if (date.getTime() >= startOfNextYear.getTime()) {
	    return year + 1;
	  } else if (date.getTime() >= startOfThisYear.getTime()) {
	    return year;
	  } else {
	    return year - 1;
	  }
	}
	
	module.exports = exports.default;

/***/ },
/* 416 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = getYear;
	
	var _index = _interopRequireDefault(__webpack_require__(3));
	
	var _index2 = _interopRequireDefault(__webpack_require__(2));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name getYear
	 * @category Year Helpers
	 * @summary Get the year of the given date.
	 *
	 * @description
	 * Get the year of the given date.
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} date - the given date
	 * @returns {Number} the year
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // Which year is 2 July 2014?
	 * var result = getYear(new Date(2014, 6, 2))
	 * //=> 2014
	 */
	function getYear(dirtyDate) {
	  (0, _index2.default)(1, arguments);
	  var date = (0, _index.default)(dirtyDate);
	  var year = date.getFullYear();
	  return year;
	}
	
	module.exports = exports.default;

/***/ },
/* 417 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var _exportNames = {
	  add: true,
	  addBusinessDays: true,
	  addDays: true,
	  addHours: true,
	  addISOWeekYears: true,
	  addMilliseconds: true,
	  addMinutes: true,
	  addMonths: true,
	  addQuarters: true,
	  addSeconds: true,
	  addWeeks: true,
	  addYears: true,
	  areIntervalsOverlapping: true,
	  closestIndexTo: true,
	  closestTo: true,
	  compareAsc: true,
	  compareDesc: true,
	  differenceInBusinessDays: true,
	  differenceInCalendarDays: true,
	  differenceInCalendarISOWeekYears: true,
	  differenceInCalendarISOWeeks: true,
	  differenceInCalendarMonths: true,
	  differenceInCalendarQuarters: true,
	  differenceInCalendarWeeks: true,
	  differenceInCalendarYears: true,
	  differenceInDays: true,
	  differenceInHours: true,
	  differenceInISOWeekYears: true,
	  differenceInMilliseconds: true,
	  differenceInMinutes: true,
	  differenceInMonths: true,
	  differenceInQuarters: true,
	  differenceInSeconds: true,
	  differenceInWeeks: true,
	  differenceInYears: true,
	  eachDayOfInterval: true,
	  eachHourOfInterval: true,
	  eachMonthOfInterval: true,
	  eachQuarterOfInterval: true,
	  eachWeekOfInterval: true,
	  eachWeekendOfInterval: true,
	  eachWeekendOfMonth: true,
	  eachWeekendOfYear: true,
	  eachYearOfInterval: true,
	  endOfDay: true,
	  endOfDecade: true,
	  endOfHour: true,
	  endOfISOWeek: true,
	  endOfISOWeekYear: true,
	  endOfMinute: true,
	  endOfMonth: true,
	  endOfQuarter: true,
	  endOfSecond: true,
	  endOfToday: true,
	  endOfTomorrow: true,
	  endOfWeek: true,
	  endOfYear: true,
	  endOfYesterday: true,
	  format: true,
	  formatDistance: true,
	  formatDistanceStrict: true,
	  formatDistanceToNow: true,
	  formatDistanceToNowStrict: true,
	  formatDuration: true,
	  formatISO: true,
	  formatISO9075: true,
	  formatISODuration: true,
	  formatRFC3339: true,
	  formatRFC7231: true,
	  formatRelative: true,
	  fromUnixTime: true,
	  getDate: true,
	  getDay: true,
	  getDayOfYear: true,
	  getDaysInMonth: true,
	  getDaysInYear: true,
	  getDecade: true,
	  getHours: true,
	  getISODay: true,
	  getISOWeek: true,
	  getISOWeekYear: true,
	  getISOWeeksInYear: true,
	  getMilliseconds: true,
	  getMinutes: true,
	  getMonth: true,
	  getOverlappingDaysInIntervals: true,
	  getQuarter: true,
	  getSeconds: true,
	  getTime: true,
	  getUnixTime: true,
	  getWeek: true,
	  getWeekOfMonth: true,
	  getWeekYear: true,
	  getWeeksInMonth: true,
	  getYear: true,
	  intervalToDuration: true,
	  isAfter: true,
	  isBefore: true,
	  isDate: true,
	  isEqual: true,
	  isExists: true,
	  isFirstDayOfMonth: true,
	  isFriday: true,
	  isFuture: true,
	  isLastDayOfMonth: true,
	  isLeapYear: true,
	  isMonday: true,
	  isPast: true,
	  isSameDay: true,
	  isSameHour: true,
	  isSameISOWeek: true,
	  isSameISOWeekYear: true,
	  isSameMinute: true,
	  isSameMonth: true,
	  isSameQuarter: true,
	  isSameSecond: true,
	  isSameWeek: true,
	  isSameYear: true,
	  isSaturday: true,
	  isSunday: true,
	  isThisHour: true,
	  isThisISOWeek: true,
	  isThisMinute: true,
	  isThisMonth: true,
	  isThisQuarter: true,
	  isThisSecond: true,
	  isThisWeek: true,
	  isThisYear: true,
	  isThursday: true,
	  isToday: true,
	  isTomorrow: true,
	  isTuesday: true,
	  isValid: true,
	  isWednesday: true,
	  isWeekend: true,
	  isWithinInterval: true,
	  isYesterday: true,
	  lastDayOfDecade: true,
	  lastDayOfISOWeek: true,
	  lastDayOfISOWeekYear: true,
	  lastDayOfMonth: true,
	  lastDayOfQuarter: true,
	  lastDayOfWeek: true,
	  lastDayOfYear: true,
	  lightFormat: true,
	  max: true,
	  min: true,
	  parse: true,
	  parseISO: true,
	  parseJSON: true,
	  roundToNearestMinutes: true,
	  set: true,
	  setDate: true,
	  setDay: true,
	  setDayOfYear: true,
	  setHours: true,
	  setISODay: true,
	  setISOWeek: true,
	  setISOWeekYear: true,
	  setMilliseconds: true,
	  setMinutes: true,
	  setMonth: true,
	  setQuarter: true,
	  setSeconds: true,
	  setWeek: true,
	  setWeekYear: true,
	  setYear: true,
	  startOfDay: true,
	  startOfDecade: true,
	  startOfHour: true,
	  startOfISOWeek: true,
	  startOfISOWeekYear: true,
	  startOfMinute: true,
	  startOfMonth: true,
	  startOfQuarter: true,
	  startOfSecond: true,
	  startOfToday: true,
	  startOfTomorrow: true,
	  startOfWeek: true,
	  startOfWeekYear: true,
	  startOfYear: true,
	  startOfYesterday: true,
	  sub: true,
	  subBusinessDays: true,
	  subDays: true,
	  subHours: true,
	  subISOWeekYears: true,
	  subMilliseconds: true,
	  subMinutes: true,
	  subMonths: true,
	  subQuarters: true,
	  subSeconds: true,
	  subWeeks: true,
	  subYears: true,
	  toDate: true
	};
	Object.defineProperty(exports, "add", {
	  enumerable: true,
	  get: function () {
	    return _index.default;
	  }
	});
	Object.defineProperty(exports, "addBusinessDays", {
	  enumerable: true,
	  get: function () {
	    return _index2.default;
	  }
	});
	Object.defineProperty(exports, "addDays", {
	  enumerable: true,
	  get: function () {
	    return _index3.default;
	  }
	});
	Object.defineProperty(exports, "addHours", {
	  enumerable: true,
	  get: function () {
	    return _index4.default;
	  }
	});
	Object.defineProperty(exports, "addISOWeekYears", {
	  enumerable: true,
	  get: function () {
	    return _index5.default;
	  }
	});
	Object.defineProperty(exports, "addMilliseconds", {
	  enumerable: true,
	  get: function () {
	    return _index6.default;
	  }
	});
	Object.defineProperty(exports, "addMinutes", {
	  enumerable: true,
	  get: function () {
	    return _index7.default;
	  }
	});
	Object.defineProperty(exports, "addMonths", {
	  enumerable: true,
	  get: function () {
	    return _index8.default;
	  }
	});
	Object.defineProperty(exports, "addQuarters", {
	  enumerable: true,
	  get: function () {
	    return _index9.default;
	  }
	});
	Object.defineProperty(exports, "addSeconds", {
	  enumerable: true,
	  get: function () {
	    return _index10.default;
	  }
	});
	Object.defineProperty(exports, "addWeeks", {
	  enumerable: true,
	  get: function () {
	    return _index11.default;
	  }
	});
	Object.defineProperty(exports, "addYears", {
	  enumerable: true,
	  get: function () {
	    return _index12.default;
	  }
	});
	Object.defineProperty(exports, "areIntervalsOverlapping", {
	  enumerable: true,
	  get: function () {
	    return _index13.default;
	  }
	});
	Object.defineProperty(exports, "closestIndexTo", {
	  enumerable: true,
	  get: function () {
	    return _index14.default;
	  }
	});
	Object.defineProperty(exports, "closestTo", {
	  enumerable: true,
	  get: function () {
	    return _index15.default;
	  }
	});
	Object.defineProperty(exports, "compareAsc", {
	  enumerable: true,
	  get: function () {
	    return _index16.default;
	  }
	});
	Object.defineProperty(exports, "compareDesc", {
	  enumerable: true,
	  get: function () {
	    return _index17.default;
	  }
	});
	Object.defineProperty(exports, "differenceInBusinessDays", {
	  enumerable: true,
	  get: function () {
	    return _index18.default;
	  }
	});
	Object.defineProperty(exports, "differenceInCalendarDays", {
	  enumerable: true,
	  get: function () {
	    return _index19.default;
	  }
	});
	Object.defineProperty(exports, "differenceInCalendarISOWeekYears", {
	  enumerable: true,
	  get: function () {
	    return _index20.default;
	  }
	});
	Object.defineProperty(exports, "differenceInCalendarISOWeeks", {
	  enumerable: true,
	  get: function () {
	    return _index21.default;
	  }
	});
	Object.defineProperty(exports, "differenceInCalendarMonths", {
	  enumerable: true,
	  get: function () {
	    return _index22.default;
	  }
	});
	Object.defineProperty(exports, "differenceInCalendarQuarters", {
	  enumerable: true,
	  get: function () {
	    return _index23.default;
	  }
	});
	Object.defineProperty(exports, "differenceInCalendarWeeks", {
	  enumerable: true,
	  get: function () {
	    return _index24.default;
	  }
	});
	Object.defineProperty(exports, "differenceInCalendarYears", {
	  enumerable: true,
	  get: function () {
	    return _index25.default;
	  }
	});
	Object.defineProperty(exports, "differenceInDays", {
	  enumerable: true,
	  get: function () {
	    return _index26.default;
	  }
	});
	Object.defineProperty(exports, "differenceInHours", {
	  enumerable: true,
	  get: function () {
	    return _index27.default;
	  }
	});
	Object.defineProperty(exports, "differenceInISOWeekYears", {
	  enumerable: true,
	  get: function () {
	    return _index28.default;
	  }
	});
	Object.defineProperty(exports, "differenceInMilliseconds", {
	  enumerable: true,
	  get: function () {
	    return _index29.default;
	  }
	});
	Object.defineProperty(exports, "differenceInMinutes", {
	  enumerable: true,
	  get: function () {
	    return _index30.default;
	  }
	});
	Object.defineProperty(exports, "differenceInMonths", {
	  enumerable: true,
	  get: function () {
	    return _index31.default;
	  }
	});
	Object.defineProperty(exports, "differenceInQuarters", {
	  enumerable: true,
	  get: function () {
	    return _index32.default;
	  }
	});
	Object.defineProperty(exports, "differenceInSeconds", {
	  enumerable: true,
	  get: function () {
	    return _index33.default;
	  }
	});
	Object.defineProperty(exports, "differenceInWeeks", {
	  enumerable: true,
	  get: function () {
	    return _index34.default;
	  }
	});
	Object.defineProperty(exports, "differenceInYears", {
	  enumerable: true,
	  get: function () {
	    return _index35.default;
	  }
	});
	Object.defineProperty(exports, "eachDayOfInterval", {
	  enumerable: true,
	  get: function () {
	    return _index36.default;
	  }
	});
	Object.defineProperty(exports, "eachHourOfInterval", {
	  enumerable: true,
	  get: function () {
	    return _index37.default;
	  }
	});
	Object.defineProperty(exports, "eachMonthOfInterval", {
	  enumerable: true,
	  get: function () {
	    return _index38.default;
	  }
	});
	Object.defineProperty(exports, "eachQuarterOfInterval", {
	  enumerable: true,
	  get: function () {
	    return _index39.default;
	  }
	});
	Object.defineProperty(exports, "eachWeekOfInterval", {
	  enumerable: true,
	  get: function () {
	    return _index40.default;
	  }
	});
	Object.defineProperty(exports, "eachWeekendOfInterval", {
	  enumerable: true,
	  get: function () {
	    return _index41.default;
	  }
	});
	Object.defineProperty(exports, "eachWeekendOfMonth", {
	  enumerable: true,
	  get: function () {
	    return _index42.default;
	  }
	});
	Object.defineProperty(exports, "eachWeekendOfYear", {
	  enumerable: true,
	  get: function () {
	    return _index43.default;
	  }
	});
	Object.defineProperty(exports, "eachYearOfInterval", {
	  enumerable: true,
	  get: function () {
	    return _index44.default;
	  }
	});
	Object.defineProperty(exports, "endOfDay", {
	  enumerable: true,
	  get: function () {
	    return _index45.default;
	  }
	});
	Object.defineProperty(exports, "endOfDecade", {
	  enumerable: true,
	  get: function () {
	    return _index46.default;
	  }
	});
	Object.defineProperty(exports, "endOfHour", {
	  enumerable: true,
	  get: function () {
	    return _index47.default;
	  }
	});
	Object.defineProperty(exports, "endOfISOWeek", {
	  enumerable: true,
	  get: function () {
	    return _index48.default;
	  }
	});
	Object.defineProperty(exports, "endOfISOWeekYear", {
	  enumerable: true,
	  get: function () {
	    return _index49.default;
	  }
	});
	Object.defineProperty(exports, "endOfMinute", {
	  enumerable: true,
	  get: function () {
	    return _index50.default;
	  }
	});
	Object.defineProperty(exports, "endOfMonth", {
	  enumerable: true,
	  get: function () {
	    return _index51.default;
	  }
	});
	Object.defineProperty(exports, "endOfQuarter", {
	  enumerable: true,
	  get: function () {
	    return _index52.default;
	  }
	});
	Object.defineProperty(exports, "endOfSecond", {
	  enumerable: true,
	  get: function () {
	    return _index53.default;
	  }
	});
	Object.defineProperty(exports, "endOfToday", {
	  enumerable: true,
	  get: function () {
	    return _index54.default;
	  }
	});
	Object.defineProperty(exports, "endOfTomorrow", {
	  enumerable: true,
	  get: function () {
	    return _index55.default;
	  }
	});
	Object.defineProperty(exports, "endOfWeek", {
	  enumerable: true,
	  get: function () {
	    return _index56.default;
	  }
	});
	Object.defineProperty(exports, "endOfYear", {
	  enumerable: true,
	  get: function () {
	    return _index57.default;
	  }
	});
	Object.defineProperty(exports, "endOfYesterday", {
	  enumerable: true,
	  get: function () {
	    return _index58.default;
	  }
	});
	Object.defineProperty(exports, "format", {
	  enumerable: true,
	  get: function () {
	    return _index59.default;
	  }
	});
	Object.defineProperty(exports, "formatDistance", {
	  enumerable: true,
	  get: function () {
	    return _index60.default;
	  }
	});
	Object.defineProperty(exports, "formatDistanceStrict", {
	  enumerable: true,
	  get: function () {
	    return _index61.default;
	  }
	});
	Object.defineProperty(exports, "formatDistanceToNow", {
	  enumerable: true,
	  get: function () {
	    return _index62.default;
	  }
	});
	Object.defineProperty(exports, "formatDistanceToNowStrict", {
	  enumerable: true,
	  get: function () {
	    return _index63.default;
	  }
	});
	Object.defineProperty(exports, "formatDuration", {
	  enumerable: true,
	  get: function () {
	    return _index64.default;
	  }
	});
	Object.defineProperty(exports, "formatISO", {
	  enumerable: true,
	  get: function () {
	    return _index65.default;
	  }
	});
	Object.defineProperty(exports, "formatISO9075", {
	  enumerable: true,
	  get: function () {
	    return _index66.default;
	  }
	});
	Object.defineProperty(exports, "formatISODuration", {
	  enumerable: true,
	  get: function () {
	    return _index67.default;
	  }
	});
	Object.defineProperty(exports, "formatRFC3339", {
	  enumerable: true,
	  get: function () {
	    return _index68.default;
	  }
	});
	Object.defineProperty(exports, "formatRFC7231", {
	  enumerable: true,
	  get: function () {
	    return _index69.default;
	  }
	});
	Object.defineProperty(exports, "formatRelative", {
	  enumerable: true,
	  get: function () {
	    return _index70.default;
	  }
	});
	Object.defineProperty(exports, "fromUnixTime", {
	  enumerable: true,
	  get: function () {
	    return _index71.default;
	  }
	});
	Object.defineProperty(exports, "getDate", {
	  enumerable: true,
	  get: function () {
	    return _index72.default;
	  }
	});
	Object.defineProperty(exports, "getDay", {
	  enumerable: true,
	  get: function () {
	    return _index73.default;
	  }
	});
	Object.defineProperty(exports, "getDayOfYear", {
	  enumerable: true,
	  get: function () {
	    return _index74.default;
	  }
	});
	Object.defineProperty(exports, "getDaysInMonth", {
	  enumerable: true,
	  get: function () {
	    return _index75.default;
	  }
	});
	Object.defineProperty(exports, "getDaysInYear", {
	  enumerable: true,
	  get: function () {
	    return _index76.default;
	  }
	});
	Object.defineProperty(exports, "getDecade", {
	  enumerable: true,
	  get: function () {
	    return _index77.default;
	  }
	});
	Object.defineProperty(exports, "getHours", {
	  enumerable: true,
	  get: function () {
	    return _index78.default;
	  }
	});
	Object.defineProperty(exports, "getISODay", {
	  enumerable: true,
	  get: function () {
	    return _index79.default;
	  }
	});
	Object.defineProperty(exports, "getISOWeek", {
	  enumerable: true,
	  get: function () {
	    return _index80.default;
	  }
	});
	Object.defineProperty(exports, "getISOWeekYear", {
	  enumerable: true,
	  get: function () {
	    return _index81.default;
	  }
	});
	Object.defineProperty(exports, "getISOWeeksInYear", {
	  enumerable: true,
	  get: function () {
	    return _index82.default;
	  }
	});
	Object.defineProperty(exports, "getMilliseconds", {
	  enumerable: true,
	  get: function () {
	    return _index83.default;
	  }
	});
	Object.defineProperty(exports, "getMinutes", {
	  enumerable: true,
	  get: function () {
	    return _index84.default;
	  }
	});
	Object.defineProperty(exports, "getMonth", {
	  enumerable: true,
	  get: function () {
	    return _index85.default;
	  }
	});
	Object.defineProperty(exports, "getOverlappingDaysInIntervals", {
	  enumerable: true,
	  get: function () {
	    return _index86.default;
	  }
	});
	Object.defineProperty(exports, "getQuarter", {
	  enumerable: true,
	  get: function () {
	    return _index87.default;
	  }
	});
	Object.defineProperty(exports, "getSeconds", {
	  enumerable: true,
	  get: function () {
	    return _index88.default;
	  }
	});
	Object.defineProperty(exports, "getTime", {
	  enumerable: true,
	  get: function () {
	    return _index89.default;
	  }
	});
	Object.defineProperty(exports, "getUnixTime", {
	  enumerable: true,
	  get: function () {
	    return _index90.default;
	  }
	});
	Object.defineProperty(exports, "getWeek", {
	  enumerable: true,
	  get: function () {
	    return _index91.default;
	  }
	});
	Object.defineProperty(exports, "getWeekOfMonth", {
	  enumerable: true,
	  get: function () {
	    return _index92.default;
	  }
	});
	Object.defineProperty(exports, "getWeekYear", {
	  enumerable: true,
	  get: function () {
	    return _index93.default;
	  }
	});
	Object.defineProperty(exports, "getWeeksInMonth", {
	  enumerable: true,
	  get: function () {
	    return _index94.default;
	  }
	});
	Object.defineProperty(exports, "getYear", {
	  enumerable: true,
	  get: function () {
	    return _index95.default;
	  }
	});
	Object.defineProperty(exports, "intervalToDuration", {
	  enumerable: true,
	  get: function () {
	    return _index96.default;
	  }
	});
	Object.defineProperty(exports, "isAfter", {
	  enumerable: true,
	  get: function () {
	    return _index97.default;
	  }
	});
	Object.defineProperty(exports, "isBefore", {
	  enumerable: true,
	  get: function () {
	    return _index98.default;
	  }
	});
	Object.defineProperty(exports, "isDate", {
	  enumerable: true,
	  get: function () {
	    return _index99.default;
	  }
	});
	Object.defineProperty(exports, "isEqual", {
	  enumerable: true,
	  get: function () {
	    return _index100.default;
	  }
	});
	Object.defineProperty(exports, "isExists", {
	  enumerable: true,
	  get: function () {
	    return _index101.default;
	  }
	});
	Object.defineProperty(exports, "isFirstDayOfMonth", {
	  enumerable: true,
	  get: function () {
	    return _index102.default;
	  }
	});
	Object.defineProperty(exports, "isFriday", {
	  enumerable: true,
	  get: function () {
	    return _index103.default;
	  }
	});
	Object.defineProperty(exports, "isFuture", {
	  enumerable: true,
	  get: function () {
	    return _index104.default;
	  }
	});
	Object.defineProperty(exports, "isLastDayOfMonth", {
	  enumerable: true,
	  get: function () {
	    return _index105.default;
	  }
	});
	Object.defineProperty(exports, "isLeapYear", {
	  enumerable: true,
	  get: function () {
	    return _index106.default;
	  }
	});
	Object.defineProperty(exports, "isMonday", {
	  enumerable: true,
	  get: function () {
	    return _index107.default;
	  }
	});
	Object.defineProperty(exports, "isPast", {
	  enumerable: true,
	  get: function () {
	    return _index108.default;
	  }
	});
	Object.defineProperty(exports, "isSameDay", {
	  enumerable: true,
	  get: function () {
	    return _index109.default;
	  }
	});
	Object.defineProperty(exports, "isSameHour", {
	  enumerable: true,
	  get: function () {
	    return _index110.default;
	  }
	});
	Object.defineProperty(exports, "isSameISOWeek", {
	  enumerable: true,
	  get: function () {
	    return _index111.default;
	  }
	});
	Object.defineProperty(exports, "isSameISOWeekYear", {
	  enumerable: true,
	  get: function () {
	    return _index112.default;
	  }
	});
	Object.defineProperty(exports, "isSameMinute", {
	  enumerable: true,
	  get: function () {
	    return _index113.default;
	  }
	});
	Object.defineProperty(exports, "isSameMonth", {
	  enumerable: true,
	  get: function () {
	    return _index114.default;
	  }
	});
	Object.defineProperty(exports, "isSameQuarter", {
	  enumerable: true,
	  get: function () {
	    return _index115.default;
	  }
	});
	Object.defineProperty(exports, "isSameSecond", {
	  enumerable: true,
	  get: function () {
	    return _index116.default;
	  }
	});
	Object.defineProperty(exports, "isSameWeek", {
	  enumerable: true,
	  get: function () {
	    return _index117.default;
	  }
	});
	Object.defineProperty(exports, "isSameYear", {
	  enumerable: true,
	  get: function () {
	    return _index118.default;
	  }
	});
	Object.defineProperty(exports, "isSaturday", {
	  enumerable: true,
	  get: function () {
	    return _index119.default;
	  }
	});
	Object.defineProperty(exports, "isSunday", {
	  enumerable: true,
	  get: function () {
	    return _index120.default;
	  }
	});
	Object.defineProperty(exports, "isThisHour", {
	  enumerable: true,
	  get: function () {
	    return _index121.default;
	  }
	});
	Object.defineProperty(exports, "isThisISOWeek", {
	  enumerable: true,
	  get: function () {
	    return _index122.default;
	  }
	});
	Object.defineProperty(exports, "isThisMinute", {
	  enumerable: true,
	  get: function () {
	    return _index123.default;
	  }
	});
	Object.defineProperty(exports, "isThisMonth", {
	  enumerable: true,
	  get: function () {
	    return _index124.default;
	  }
	});
	Object.defineProperty(exports, "isThisQuarter", {
	  enumerable: true,
	  get: function () {
	    return _index125.default;
	  }
	});
	Object.defineProperty(exports, "isThisSecond", {
	  enumerable: true,
	  get: function () {
	    return _index126.default;
	  }
	});
	Object.defineProperty(exports, "isThisWeek", {
	  enumerable: true,
	  get: function () {
	    return _index127.default;
	  }
	});
	Object.defineProperty(exports, "isThisYear", {
	  enumerable: true,
	  get: function () {
	    return _index128.default;
	  }
	});
	Object.defineProperty(exports, "isThursday", {
	  enumerable: true,
	  get: function () {
	    return _index129.default;
	  }
	});
	Object.defineProperty(exports, "isToday", {
	  enumerable: true,
	  get: function () {
	    return _index130.default;
	  }
	});
	Object.defineProperty(exports, "isTomorrow", {
	  enumerable: true,
	  get: function () {
	    return _index131.default;
	  }
	});
	Object.defineProperty(exports, "isTuesday", {
	  enumerable: true,
	  get: function () {
	    return _index132.default;
	  }
	});
	Object.defineProperty(exports, "isValid", {
	  enumerable: true,
	  get: function () {
	    return _index133.default;
	  }
	});
	Object.defineProperty(exports, "isWednesday", {
	  enumerable: true,
	  get: function () {
	    return _index134.default;
	  }
	});
	Object.defineProperty(exports, "isWeekend", {
	  enumerable: true,
	  get: function () {
	    return _index135.default;
	  }
	});
	Object.defineProperty(exports, "isWithinInterval", {
	  enumerable: true,
	  get: function () {
	    return _index136.default;
	  }
	});
	Object.defineProperty(exports, "isYesterday", {
	  enumerable: true,
	  get: function () {
	    return _index137.default;
	  }
	});
	Object.defineProperty(exports, "lastDayOfDecade", {
	  enumerable: true,
	  get: function () {
	    return _index138.default;
	  }
	});
	Object.defineProperty(exports, "lastDayOfISOWeek", {
	  enumerable: true,
	  get: function () {
	    return _index139.default;
	  }
	});
	Object.defineProperty(exports, "lastDayOfISOWeekYear", {
	  enumerable: true,
	  get: function () {
	    return _index140.default;
	  }
	});
	Object.defineProperty(exports, "lastDayOfMonth", {
	  enumerable: true,
	  get: function () {
	    return _index141.default;
	  }
	});
	Object.defineProperty(exports, "lastDayOfQuarter", {
	  enumerable: true,
	  get: function () {
	    return _index142.default;
	  }
	});
	Object.defineProperty(exports, "lastDayOfWeek", {
	  enumerable: true,
	  get: function () {
	    return _index143.default;
	  }
	});
	Object.defineProperty(exports, "lastDayOfYear", {
	  enumerable: true,
	  get: function () {
	    return _index144.default;
	  }
	});
	Object.defineProperty(exports, "lightFormat", {
	  enumerable: true,
	  get: function () {
	    return _index145.default;
	  }
	});
	Object.defineProperty(exports, "max", {
	  enumerable: true,
	  get: function () {
	    return _index146.default;
	  }
	});
	Object.defineProperty(exports, "min", {
	  enumerable: true,
	  get: function () {
	    return _index147.default;
	  }
	});
	Object.defineProperty(exports, "parse", {
	  enumerable: true,
	  get: function () {
	    return _index148.default;
	  }
	});
	Object.defineProperty(exports, "parseISO", {
	  enumerable: true,
	  get: function () {
	    return _index149.default;
	  }
	});
	Object.defineProperty(exports, "parseJSON", {
	  enumerable: true,
	  get: function () {
	    return _index150.default;
	  }
	});
	Object.defineProperty(exports, "roundToNearestMinutes", {
	  enumerable: true,
	  get: function () {
	    return _index151.default;
	  }
	});
	Object.defineProperty(exports, "set", {
	  enumerable: true,
	  get: function () {
	    return _index152.default;
	  }
	});
	Object.defineProperty(exports, "setDate", {
	  enumerable: true,
	  get: function () {
	    return _index153.default;
	  }
	});
	Object.defineProperty(exports, "setDay", {
	  enumerable: true,
	  get: function () {
	    return _index154.default;
	  }
	});
	Object.defineProperty(exports, "setDayOfYear", {
	  enumerable: true,
	  get: function () {
	    return _index155.default;
	  }
	});
	Object.defineProperty(exports, "setHours", {
	  enumerable: true,
	  get: function () {
	    return _index156.default;
	  }
	});
	Object.defineProperty(exports, "setISODay", {
	  enumerable: true,
	  get: function () {
	    return _index157.default;
	  }
	});
	Object.defineProperty(exports, "setISOWeek", {
	  enumerable: true,
	  get: function () {
	    return _index158.default;
	  }
	});
	Object.defineProperty(exports, "setISOWeekYear", {
	  enumerable: true,
	  get: function () {
	    return _index159.default;
	  }
	});
	Object.defineProperty(exports, "setMilliseconds", {
	  enumerable: true,
	  get: function () {
	    return _index160.default;
	  }
	});
	Object.defineProperty(exports, "setMinutes", {
	  enumerable: true,
	  get: function () {
	    return _index161.default;
	  }
	});
	Object.defineProperty(exports, "setMonth", {
	  enumerable: true,
	  get: function () {
	    return _index162.default;
	  }
	});
	Object.defineProperty(exports, "setQuarter", {
	  enumerable: true,
	  get: function () {
	    return _index163.default;
	  }
	});
	Object.defineProperty(exports, "setSeconds", {
	  enumerable: true,
	  get: function () {
	    return _index164.default;
	  }
	});
	Object.defineProperty(exports, "setWeek", {
	  enumerable: true,
	  get: function () {
	    return _index165.default;
	  }
	});
	Object.defineProperty(exports, "setWeekYear", {
	  enumerable: true,
	  get: function () {
	    return _index166.default;
	  }
	});
	Object.defineProperty(exports, "setYear", {
	  enumerable: true,
	  get: function () {
	    return _index167.default;
	  }
	});
	Object.defineProperty(exports, "startOfDay", {
	  enumerable: true,
	  get: function () {
	    return _index168.default;
	  }
	});
	Object.defineProperty(exports, "startOfDecade", {
	  enumerable: true,
	  get: function () {
	    return _index169.default;
	  }
	});
	Object.defineProperty(exports, "startOfHour", {
	  enumerable: true,
	  get: function () {
	    return _index170.default;
	  }
	});
	Object.defineProperty(exports, "startOfISOWeek", {
	  enumerable: true,
	  get: function () {
	    return _index171.default;
	  }
	});
	Object.defineProperty(exports, "startOfISOWeekYear", {
	  enumerable: true,
	  get: function () {
	    return _index172.default;
	  }
	});
	Object.defineProperty(exports, "startOfMinute", {
	  enumerable: true,
	  get: function () {
	    return _index173.default;
	  }
	});
	Object.defineProperty(exports, "startOfMonth", {
	  enumerable: true,
	  get: function () {
	    return _index174.default;
	  }
	});
	Object.defineProperty(exports, "startOfQuarter", {
	  enumerable: true,
	  get: function () {
	    return _index175.default;
	  }
	});
	Object.defineProperty(exports, "startOfSecond", {
	  enumerable: true,
	  get: function () {
	    return _index176.default;
	  }
	});
	Object.defineProperty(exports, "startOfToday", {
	  enumerable: true,
	  get: function () {
	    return _index177.default;
	  }
	});
	Object.defineProperty(exports, "startOfTomorrow", {
	  enumerable: true,
	  get: function () {
	    return _index178.default;
	  }
	});
	Object.defineProperty(exports, "startOfWeek", {
	  enumerable: true,
	  get: function () {
	    return _index179.default;
	  }
	});
	Object.defineProperty(exports, "startOfWeekYear", {
	  enumerable: true,
	  get: function () {
	    return _index180.default;
	  }
	});
	Object.defineProperty(exports, "startOfYear", {
	  enumerable: true,
	  get: function () {
	    return _index181.default;
	  }
	});
	Object.defineProperty(exports, "startOfYesterday", {
	  enumerable: true,
	  get: function () {
	    return _index182.default;
	  }
	});
	Object.defineProperty(exports, "sub", {
	  enumerable: true,
	  get: function () {
	    return _index183.default;
	  }
	});
	Object.defineProperty(exports, "subBusinessDays", {
	  enumerable: true,
	  get: function () {
	    return _index184.default;
	  }
	});
	Object.defineProperty(exports, "subDays", {
	  enumerable: true,
	  get: function () {
	    return _index185.default;
	  }
	});
	Object.defineProperty(exports, "subHours", {
	  enumerable: true,
	  get: function () {
	    return _index186.default;
	  }
	});
	Object.defineProperty(exports, "subISOWeekYears", {
	  enumerable: true,
	  get: function () {
	    return _index187.default;
	  }
	});
	Object.defineProperty(exports, "subMilliseconds", {
	  enumerable: true,
	  get: function () {
	    return _index188.default;
	  }
	});
	Object.defineProperty(exports, "subMinutes", {
	  enumerable: true,
	  get: function () {
	    return _index189.default;
	  }
	});
	Object.defineProperty(exports, "subMonths", {
	  enumerable: true,
	  get: function () {
	    return _index190.default;
	  }
	});
	Object.defineProperty(exports, "subQuarters", {
	  enumerable: true,
	  get: function () {
	    return _index191.default;
	  }
	});
	Object.defineProperty(exports, "subSeconds", {
	  enumerable: true,
	  get: function () {
	    return _index192.default;
	  }
	});
	Object.defineProperty(exports, "subWeeks", {
	  enumerable: true,
	  get: function () {
	    return _index193.default;
	  }
	});
	Object.defineProperty(exports, "subYears", {
	  enumerable: true,
	  get: function () {
	    return _index194.default;
	  }
	});
	Object.defineProperty(exports, "toDate", {
	  enumerable: true,
	  get: function () {
	    return _index195.default;
	  }
	});
	
	var _index = _interopRequireDefault(__webpack_require__(901));
	
	var _index2 = _interopRequireDefault(__webpack_require__(397));
	
	var _index3 = _interopRequireDefault(__webpack_require__(74));
	
	var _index4 = _interopRequireDefault(__webpack_require__(181));
	
	var _index5 = _interopRequireDefault(__webpack_require__(398));
	
	var _index6 = _interopRequireDefault(__webpack_require__(137));
	
	var _index7 = _interopRequireDefault(__webpack_require__(261));
	
	var _index8 = _interopRequireDefault(__webpack_require__(112));
	
	var _index9 = _interopRequireDefault(__webpack_require__(262));
	
	var _index10 = _interopRequireDefault(__webpack_require__(399));
	
	var _index11 = _interopRequireDefault(__webpack_require__(138));
	
	var _index12 = _interopRequireDefault(__webpack_require__(263));
	
	var _index13 = _interopRequireDefault(__webpack_require__(902));
	
	var _index14 = _interopRequireDefault(__webpack_require__(903));
	
	var _index15 = _interopRequireDefault(__webpack_require__(904));
	
	var _index16 = _interopRequireDefault(__webpack_require__(98));
	
	var _index17 = _interopRequireDefault(__webpack_require__(905));
	
	var _index18 = _interopRequireDefault(__webpack_require__(907));
	
	var _index19 = _interopRequireDefault(__webpack_require__(84));
	
	var _index20 = _interopRequireDefault(__webpack_require__(400));
	
	var _index21 = _interopRequireDefault(__webpack_require__(908));
	
	var _index22 = _interopRequireDefault(__webpack_require__(264));
	
	var _index23 = _interopRequireDefault(__webpack_require__(909));
	
	var _index24 = _interopRequireDefault(__webpack_require__(265));
	
	var _index25 = _interopRequireDefault(__webpack_require__(266));
	
	var _index26 = _interopRequireDefault(__webpack_require__(139));
	
	var _index27 = _interopRequireDefault(__webpack_require__(401));
	
	var _index28 = _interopRequireDefault(__webpack_require__(910));
	
	var _index29 = _interopRequireDefault(__webpack_require__(182));
	
	var _index30 = _interopRequireDefault(__webpack_require__(402));
	
	var _index31 = _interopRequireDefault(__webpack_require__(140));
	
	var _index32 = _interopRequireDefault(__webpack_require__(911));
	
	var _index33 = _interopRequireDefault(__webpack_require__(183));
	
	var _index34 = _interopRequireDefault(__webpack_require__(912));
	
	var _index35 = _interopRequireDefault(__webpack_require__(403));
	
	var _index36 = _interopRequireDefault(__webpack_require__(404));
	
	var _index37 = _interopRequireDefault(__webpack_require__(913));
	
	var _index38 = _interopRequireDefault(__webpack_require__(914));
	
	var _index39 = _interopRequireDefault(__webpack_require__(915));
	
	var _index40 = _interopRequireDefault(__webpack_require__(916));
	
	var _index41 = _interopRequireDefault(__webpack_require__(267));
	
	var _index42 = _interopRequireDefault(__webpack_require__(917));
	
	var _index43 = _interopRequireDefault(__webpack_require__(918));
	
	var _index44 = _interopRequireDefault(__webpack_require__(919));
	
	var _index45 = _interopRequireDefault(__webpack_require__(184));
	
	var _index46 = _interopRequireDefault(__webpack_require__(920));
	
	var _index47 = _interopRequireDefault(__webpack_require__(921));
	
	var _index48 = _interopRequireDefault(__webpack_require__(923));
	
	var _index49 = _interopRequireDefault(__webpack_require__(922));
	
	var _index50 = _interopRequireDefault(__webpack_require__(924));
	
	var _index51 = _interopRequireDefault(__webpack_require__(185));
	
	var _index52 = _interopRequireDefault(__webpack_require__(925));
	
	var _index53 = _interopRequireDefault(__webpack_require__(926));
	
	var _index54 = _interopRequireDefault(__webpack_require__(927));
	
	var _index55 = _interopRequireDefault(__webpack_require__(928));
	
	var _index56 = _interopRequireDefault(__webpack_require__(268));
	
	var _index57 = _interopRequireDefault(__webpack_require__(405));
	
	var _index58 = _interopRequireDefault(__webpack_require__(929));
	
	var _index59 = _interopRequireDefault(__webpack_require__(33));
	
	var _index60 = _interopRequireDefault(__webpack_require__(407));
	
	var _index61 = _interopRequireDefault(__webpack_require__(406));
	
	var _index62 = _interopRequireDefault(__webpack_require__(931));
	
	var _index63 = _interopRequireDefault(__webpack_require__(930));
	
	var _index64 = _interopRequireDefault(__webpack_require__(932));
	
	var _index65 = _interopRequireDefault(__webpack_require__(935));
	
	var _index66 = _interopRequireDefault(__webpack_require__(933));
	
	var _index67 = _interopRequireDefault(__webpack_require__(934));
	
	var _index68 = _interopRequireDefault(__webpack_require__(936));
	
	var _index69 = _interopRequireDefault(__webpack_require__(937));
	
	var _index70 = _interopRequireDefault(__webpack_require__(938));
	
	var _index71 = _interopRequireDefault(__webpack_require__(939));
	
	var _index72 = _interopRequireDefault(__webpack_require__(269));
	
	var _index73 = _interopRequireDefault(__webpack_require__(270));
	
	var _index74 = _interopRequireDefault(__webpack_require__(940));
	
	var _index75 = _interopRequireDefault(__webpack_require__(408));
	
	var _index76 = _interopRequireDefault(__webpack_require__(941));
	
	var _index77 = _interopRequireDefault(__webpack_require__(942));
	
	var _index78 = _interopRequireDefault(__webpack_require__(409));
	
	var _index79 = _interopRequireDefault(__webpack_require__(410));
	
	var _index80 = _interopRequireDefault(__webpack_require__(411));
	
	var _index81 = _interopRequireDefault(__webpack_require__(113));
	
	var _index82 = _interopRequireDefault(__webpack_require__(943));
	
	var _index83 = _interopRequireDefault(__webpack_require__(944));
	
	var _index84 = _interopRequireDefault(__webpack_require__(412));
	
	var _index85 = _interopRequireDefault(__webpack_require__(413));
	
	var _index86 = _interopRequireDefault(__webpack_require__(945));
	
	var _index87 = _interopRequireDefault(__webpack_require__(271));
	
	var _index88 = _interopRequireDefault(__webpack_require__(414));
	
	var _index89 = _interopRequireDefault(__webpack_require__(272));
	
	var _index90 = _interopRequireDefault(__webpack_require__(946));
	
	var _index91 = _interopRequireDefault(__webpack_require__(273));
	
	var _index92 = _interopRequireDefault(__webpack_require__(947));
	
	var _index93 = _interopRequireDefault(__webpack_require__(415));
	
	var _index94 = _interopRequireDefault(__webpack_require__(948));
	
	var _index95 = _interopRequireDefault(__webpack_require__(416));
	
	var _index96 = _interopRequireDefault(__webpack_require__(949));
	
	var _index97 = _interopRequireDefault(__webpack_require__(186));
	
	var _index98 = _interopRequireDefault(__webpack_require__(187));
	
	var _index99 = _interopRequireDefault(__webpack_require__(274));
	
	var _index100 = _interopRequireDefault(__webpack_require__(275));
	
	var _index101 = _interopRequireDefault(__webpack_require__(950));
	
	var _index102 = _interopRequireDefault(__webpack_require__(951));
	
	var _index103 = _interopRequireDefault(__webpack_require__(952));
	
	var _index104 = _interopRequireDefault(__webpack_require__(953));
	
	var _index105 = _interopRequireDefault(__webpack_require__(954));
	
	var _index106 = _interopRequireDefault(__webpack_require__(418));
	
	var _index107 = _interopRequireDefault(__webpack_require__(955));
	
	var _index108 = _interopRequireDefault(__webpack_require__(956));
	
	var _index109 = _interopRequireDefault(__webpack_require__(114));
	
	var _index110 = _interopRequireDefault(__webpack_require__(419));
	
	var _index111 = _interopRequireDefault(__webpack_require__(420));
	
	var _index112 = _interopRequireDefault(__webpack_require__(957));
	
	var _index113 = _interopRequireDefault(__webpack_require__(421));
	
	var _index114 = _interopRequireDefault(__webpack_require__(276));
	
	var _index115 = _interopRequireDefault(__webpack_require__(277));
	
	var _index116 = _interopRequireDefault(__webpack_require__(422));
	
	var _index117 = _interopRequireDefault(__webpack_require__(278));
	
	var _index118 = _interopRequireDefault(__webpack_require__(279));
	
	var _index119 = _interopRequireDefault(__webpack_require__(958));
	
	var _index120 = _interopRequireDefault(__webpack_require__(423));
	
	var _index121 = _interopRequireDefault(__webpack_require__(959));
	
	var _index122 = _interopRequireDefault(__webpack_require__(960));
	
	var _index123 = _interopRequireDefault(__webpack_require__(961));
	
	var _index124 = _interopRequireDefault(__webpack_require__(962));
	
	var _index125 = _interopRequireDefault(__webpack_require__(963));
	
	var _index126 = _interopRequireDefault(__webpack_require__(964));
	
	var _index127 = _interopRequireDefault(__webpack_require__(965));
	
	var _index128 = _interopRequireDefault(__webpack_require__(966));
	
	var _index129 = _interopRequireDefault(__webpack_require__(967));
	
	var _index130 = _interopRequireDefault(__webpack_require__(968));
	
	var _index131 = _interopRequireDefault(__webpack_require__(969));
	
	var _index132 = _interopRequireDefault(__webpack_require__(970));
	
	var _index133 = _interopRequireDefault(__webpack_require__(43));
	
	var _index134 = _interopRequireDefault(__webpack_require__(971));
	
	var _index135 = _interopRequireDefault(__webpack_require__(188));
	
	var _index136 = _interopRequireDefault(__webpack_require__(424));
	
	var _index137 = _interopRequireDefault(__webpack_require__(972));
	
	var _index138 = _interopRequireDefault(__webpack_require__(973));
	
	var _index139 = _interopRequireDefault(__webpack_require__(975));
	
	var _index140 = _interopRequireDefault(__webpack_require__(974));
	
	var _index141 = _interopRequireDefault(__webpack_require__(425));
	
	var _index142 = _interopRequireDefault(__webpack_require__(976));
	
	var _index143 = _interopRequireDefault(__webpack_require__(426));
	
	var _index144 = _interopRequireDefault(__webpack_require__(977));
	
	var _index145 = _interopRequireDefault(__webpack_require__(978));
	
	var _index146 = _interopRequireDefault(__webpack_require__(427));
	
	var _index147 = _interopRequireDefault(__webpack_require__(428));
	
	var _index148 = _interopRequireDefault(__webpack_require__(429));
	
	var _index149 = _interopRequireDefault(__webpack_require__(280));
	
	var _index150 = _interopRequireDefault(__webpack_require__(988));
	
	var _index151 = _interopRequireDefault(__webpack_require__(990));
	
	var _index152 = _interopRequireDefault(__webpack_require__(999));
	
	var _index153 = _interopRequireDefault(__webpack_require__(991));
	
	var _index154 = _interopRequireDefault(__webpack_require__(993));
	
	var _index155 = _interopRequireDefault(__webpack_require__(992));
	
	var _index156 = _interopRequireDefault(__webpack_require__(430));
	
	var _index157 = _interopRequireDefault(__webpack_require__(994));
	
	var _index158 = _interopRequireDefault(__webpack_require__(995));
	
	var _index159 = _interopRequireDefault(__webpack_require__(431));
	
	var _index160 = _interopRequireDefault(__webpack_require__(996));
	
	var _index161 = _interopRequireDefault(__webpack_require__(432));
	
	var _index162 = _interopRequireDefault(__webpack_require__(189));
	
	var _index163 = _interopRequireDefault(__webpack_require__(433));
	
	var _index164 = _interopRequireDefault(__webpack_require__(434));
	
	var _index165 = _interopRequireDefault(__webpack_require__(998));
	
	var _index166 = _interopRequireDefault(__webpack_require__(997));
	
	var _index167 = _interopRequireDefault(__webpack_require__(435));
	
	var _index168 = _interopRequireDefault(__webpack_require__(116));
	
	var _index169 = _interopRequireDefault(__webpack_require__(1000));
	
	var _index170 = _interopRequireDefault(__webpack_require__(436));
	
	var _index171 = _interopRequireDefault(__webpack_require__(99));
	
	var _index172 = _interopRequireDefault(__webpack_require__(141));
	
	var _index173 = _interopRequireDefault(__webpack_require__(437));
	
	var _index174 = _interopRequireDefault(__webpack_require__(142));
	
	var _index175 = _interopRequireDefault(__webpack_require__(190));
	
	var _index176 = _interopRequireDefault(__webpack_require__(438));
	
	var _index177 = _interopRequireDefault(__webpack_require__(1001));
	
	var _index178 = _interopRequireDefault(__webpack_require__(1002));
	
	var _index179 = _interopRequireDefault(__webpack_require__(75));
	
	var _index180 = _interopRequireDefault(__webpack_require__(281));
	
	var _index181 = _interopRequireDefault(__webpack_require__(191));
	
	var _index182 = _interopRequireDefault(__webpack_require__(1003));
	
	var _index183 = _interopRequireDefault(__webpack_require__(283));
	
	var _index184 = _interopRequireDefault(__webpack_require__(1004));
	
	var _index185 = _interopRequireDefault(__webpack_require__(192));
	
	var _index186 = _interopRequireDefault(__webpack_require__(439));
	
	var _index187 = _interopRequireDefault(__webpack_require__(440));
	
	var _index188 = _interopRequireDefault(__webpack_require__(143));
	
	var _index189 = _interopRequireDefault(__webpack_require__(441));
	
	var _index190 = _interopRequireDefault(__webpack_require__(282));
	
	var _index191 = _interopRequireDefault(__webpack_require__(1005));
	
	var _index192 = _interopRequireDefault(__webpack_require__(1006));
	
	var _index193 = _interopRequireDefault(__webpack_require__(442));
	
	var _index194 = _interopRequireDefault(__webpack_require__(443));
	
	var _index195 = _interopRequireDefault(__webpack_require__(3));
	
	var _index196 = __webpack_require__(906);
	
	Object.keys(_index196).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function () {
	      return _index196[key];
	    }
	  });
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 418 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isLeapYear;
	
	var _index = _interopRequireDefault(__webpack_require__(3));
	
	var _index2 = _interopRequireDefault(__webpack_require__(2));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name isLeapYear
	 * @category Year Helpers
	 * @summary Is the given date in the leap year?
	 *
	 * @description
	 * Is the given date in the leap year?
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} date - the date to check
	 * @returns {Boolean} the date is in the leap year
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // Is 1 September 2012 in the leap year?
	 * var result = isLeapYear(new Date(2012, 8, 1))
	 * //=> true
	 */
	function isLeapYear(dirtyDate) {
	  (0, _index2.default)(1, arguments);
	  var date = (0, _index.default)(dirtyDate);
	  var year = date.getFullYear();
	  return year % 400 === 0 || year % 4 === 0 && year % 100 !== 0;
	}
	
	module.exports = exports.default;

/***/ },
/* 419 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isSameHour;
	
	var _index = _interopRequireDefault(__webpack_require__(436));
	
	var _index2 = _interopRequireDefault(__webpack_require__(2));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name isSameHour
	 * @category Hour Helpers
	 * @summary Are the given dates in the same hour?
	 *
	 * @description
	 * Are the given dates in the same hour?
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} dateLeft - the first date to check
	 * @param {Date|Number} dateRight - the second date to check
	 * @returns {Boolean} the dates are in the same hour
	 * @throws {TypeError} 2 arguments required
	 *
	 * @example
	 * // Are 4 September 2014 06:00:00 and 4 September 06:30:00 in the same hour?
	 * var result = isSameHour(new Date(2014, 8, 4, 6, 0), new Date(2014, 8, 4, 6, 30))
	 * //=> true
	 */
	function isSameHour(dirtyDateLeft, dirtyDateRight) {
	  (0, _index2.default)(2, arguments);
	  var dateLeftStartOfHour = (0, _index.default)(dirtyDateLeft);
	  var dateRightStartOfHour = (0, _index.default)(dirtyDateRight);
	  return dateLeftStartOfHour.getTime() === dateRightStartOfHour.getTime();
	}
	
	module.exports = exports.default;

/***/ },
/* 420 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isSameISOWeek;
	
	var _index = _interopRequireDefault(__webpack_require__(278));
	
	var _index2 = _interopRequireDefault(__webpack_require__(2));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name isSameISOWeek
	 * @category ISO Week Helpers
	 * @summary Are the given dates in the same ISO week?
	 *
	 * @description
	 * Are the given dates in the same ISO week?
	 *
	 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} dateLeft - the first date to check
	 * @param {Date|Number} dateRight - the second date to check
	 * @returns {Boolean} the dates are in the same ISO week
	 * @throws {TypeError} 2 arguments required
	 *
	 * @example
	 * // Are 1 September 2014 and 7 September 2014 in the same ISO week?
	 * var result = isSameISOWeek(new Date(2014, 8, 1), new Date(2014, 8, 7))
	 * //=> true
	 */
	function isSameISOWeek(dirtyDateLeft, dirtyDateRight) {
	  (0, _index2.default)(2, arguments);
	  return (0, _index.default)(dirtyDateLeft, dirtyDateRight, {
	    weekStartsOn: 1
	  });
	}
	
	module.exports = exports.default;

/***/ },
/* 421 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isSameMinute;
	
	var _index = _interopRequireDefault(__webpack_require__(437));
	
	var _index2 = _interopRequireDefault(__webpack_require__(2));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name isSameMinute
	 * @category Minute Helpers
	 * @summary Are the given dates in the same minute?
	 *
	 * @description
	 * Are the given dates in the same minute?
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} dateLeft - the first date to check
	 * @param {Date|Number} dateRight - the second date to check
	 * @returns {Boolean} the dates are in the same minute
	 * @throws {TypeError} 2 arguments required
	 *
	 * @example
	 * // Are 4 September 2014 06:30:00 and 4 September 2014 06:30:15
	 * // in the same minute?
	 * var result = isSameMinute(
	 *   new Date(2014, 8, 4, 6, 30),
	 *   new Date(2014, 8, 4, 6, 30, 15)
	 * )
	 * //=> true
	 */
	function isSameMinute(dirtyDateLeft, dirtyDateRight) {
	  (0, _index2.default)(2, arguments);
	  var dateLeftStartOfMinute = (0, _index.default)(dirtyDateLeft);
	  var dateRightStartOfMinute = (0, _index.default)(dirtyDateRight);
	  return dateLeftStartOfMinute.getTime() === dateRightStartOfMinute.getTime();
	}
	
	module.exports = exports.default;

/***/ },
/* 422 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isSameSecond;
	
	var _index = _interopRequireDefault(__webpack_require__(438));
	
	var _index2 = _interopRequireDefault(__webpack_require__(2));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name isSameSecond
	 * @category Second Helpers
	 * @summary Are the given dates in the same second?
	 *
	 * @description
	 * Are the given dates in the same second?
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} dateLeft - the first date to check
	 * @param {Date|Number} dateRight - the second date to check
	 * @returns {Boolean} the dates are in the same second
	 * @throws {TypeError} 2 arguments required
	 *
	 * @example
	 * // Are 4 September 2014 06:30:15.000 and 4 September 2014 06:30.15.500
	 * // in the same second?
	 * var result = isSameSecond(
	 *   new Date(2014, 8, 4, 6, 30, 15),
	 *   new Date(2014, 8, 4, 6, 30, 15, 500)
	 * )
	 * //=> true
	 */
	function isSameSecond(dirtyDateLeft, dirtyDateRight) {
	  (0, _index2.default)(2, arguments);
	  var dateLeftStartOfSecond = (0, _index.default)(dirtyDateLeft);
	  var dateRightStartOfSecond = (0, _index.default)(dirtyDateRight);
	  return dateLeftStartOfSecond.getTime() === dateRightStartOfSecond.getTime();
	}
	
	module.exports = exports.default;

/***/ },
/* 423 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isSunday;
	
	var _index = _interopRequireDefault(__webpack_require__(3));
	
	var _index2 = _interopRequireDefault(__webpack_require__(2));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name isSunday
	 * @category Weekday Helpers
	 * @summary Is the given date Sunday?
	 *
	 * @description
	 * Is the given date Sunday?
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} date - the date to check
	 * @returns {Boolean} the date is Sunday
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // Is 21 September 2014 Sunday?
	 * var result = isSunday(new Date(2014, 8, 21))
	 * //=> true
	 */
	function isSunday(dirtyDate) {
	  (0, _index2.default)(1, arguments);
	  return (0, _index.default)(dirtyDate).getDay() === 0;
	}
	
	module.exports = exports.default;

/***/ },
/* 424 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isWithinInterval;
	
	var _index = _interopRequireDefault(__webpack_require__(3));
	
	var _index2 = _interopRequireDefault(__webpack_require__(2));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name isWithinInterval
	 * @category Interval Helpers
	 * @summary Is the given date within the interval?
	 *
	 * @description
	 * Is the given date within the interval? (Including start and end.)
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * - The function was renamed from `isWithinRange` to `isWithinInterval`.
	 *   This change was made to mirror the use of the word "interval" in standard ISO 8601:2004 terminology:
	 *
	 *   ```
	 *   2.1.3
	 *   time interval
	 *   part of the time axis limited by two instants
	 *   ```
	 *
	 *   Also, this function now accepts an object with `start` and `end` properties
	 *   instead of two arguments as an interval.
	 *   This function now throws `RangeError` if the start of the interval is after its end
	 *   or if any date in the interval is `Invalid Date`.
	 *
	 *   ```javascript
	 *   // Before v2.0.0
	 *
	 *   isWithinRange(
	 *     new Date(2014, 0, 3),
	 *     new Date(2014, 0, 1), new Date(2014, 0, 7)
	 *   )
	 *
	 *   // v2.0.0 onward
	 *
	 *   isWithinInterval(
	 *     new Date(2014, 0, 3),
	 *     { start: new Date(2014, 0, 1), end: new Date(2014, 0, 7) }
	 *   )
	 *   ```
	 *
	 * @param {Date|Number} date - the date to check
	 * @param {Interval} interval - the interval to check
	 * @returns {Boolean} the date is within the interval
	 * @throws {TypeError} 2 arguments required
	 * @throws {RangeError} The start of an interval cannot be after its end
	 * @throws {RangeError} Date in interval cannot be `Invalid Date`
	 *
	 * @example
	 * // For the date within the interval:
	 * isWithinInterval(new Date(2014, 0, 3), {
	 *   start: new Date(2014, 0, 1),
	 *   end: new Date(2014, 0, 7)
	 * })
	 * //=> true
	 *
	 * @example
	 * // For the date outside of the interval:
	 * isWithinInterval(new Date(2014, 0, 10), {
	 *   start: new Date(2014, 0, 1),
	 *   end: new Date(2014, 0, 7)
	 * })
	 * //=> false
	 *
	 * @example
	 * // For date equal to interval start:
	 * isWithinInterval(date, { start, end: date }) // => true
	 *
	 * @example
	 * // For date equal to interval end:
	 * isWithinInterval(date, { start: date, end }) // => true
	 */
	function isWithinInterval(dirtyDate, dirtyInterval) {
	  (0, _index2.default)(2, arguments);
	  var interval = dirtyInterval || {};
	  var time = (0, _index.default)(dirtyDate).getTime();
	  var startTime = (0, _index.default)(interval.start).getTime();
	  var endTime = (0, _index.default)(interval.end).getTime(); // Throw an exception if start date is after end date or if any date is `Invalid Date`
	
	  if (!(startTime <= endTime)) {
	    throw new RangeError('Invalid interval');
	  }
	
	  return time >= startTime && time <= endTime;
	}
	
	module.exports = exports.default;

/***/ },
/* 425 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = lastDayOfMonth;
	
	var _index = _interopRequireDefault(__webpack_require__(3));
	
	var _index2 = _interopRequireDefault(__webpack_require__(2));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name lastDayOfMonth
	 * @category Month Helpers
	 * @summary Return the last day of a month for the given date.
	 *
	 * @description
	 * Return the last day of a month for the given date.
	 * The result will be in the local timezone.
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} date - the original date
	 * @returns {Date} the last day of a month
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // The last day of a month for 2 September 2014 11:55:00:
	 * var result = lastDayOfMonth(new Date(2014, 8, 2, 11, 55, 0))
	 * //=> Tue Sep 30 2014 00:00:00
	 */
	function lastDayOfMonth(dirtyDate) {
	  (0, _index2.default)(1, arguments);
	  var date = (0, _index.default)(dirtyDate);
	  var month = date.getMonth();
	  date.setFullYear(date.getFullYear(), month + 1, 0);
	  date.setHours(0, 0, 0, 0);
	  return date;
	}
	
	module.exports = exports.default;

/***/ },
/* 426 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = lastDayOfWeek;
	
	var _index = _interopRequireDefault(__webpack_require__(3));
	
	var _index2 = _interopRequireDefault(__webpack_require__(9));
	
	var _index3 = _interopRequireDefault(__webpack_require__(2));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name lastDayOfWeek
	 * @category Week Helpers
	 * @summary Return the last day of a week for the given date.
	 *
	 * @description
	 * Return the last day of a week for the given date.
	 * The result will be in the local timezone.
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} date - the original date
	 * @param {Object} [options] - an object with options.
	 * @param {Locale} [options.locale=defaultLocale] - the locale object. See [Locale]{@link https://date-fns.org/docs/Locale}
	 * @param {0|1|2|3|4|5|6} [options.weekStartsOn=0] - the index of the first day of the week (0 - Sunday)
	 * @returns {Date} the last day of a week
	 * @throws {TypeError} 1 argument required
	 * @throws {RangeError} `options.weekStartsOn` must be between 0 and 6
	 *
	 * @example
	 * // The last day of a week for 2 September 2014 11:55:00:
	 * var result = lastDayOfWeek(new Date(2014, 8, 2, 11, 55, 0))
	 * //=> Sat Sep 06 2014 00:00:00
	 *
	 * @example
	 * // If the week starts on Monday, the last day of the week for 2 September 2014 11:55:00:
	 * var result = lastDayOfWeek(new Date(2014, 8, 2, 11, 55, 0), { weekStartsOn: 1 })
	 * //=> Sun Sep 07 2014 00:00:00
	 */
	function lastDayOfWeek(dirtyDate, dirtyOptions) {
	  (0, _index3.default)(1, arguments);
	  var options = dirtyOptions || {};
	  var locale = options.locale;
	  var localeWeekStartsOn = locale && locale.options && locale.options.weekStartsOn;
	  var defaultWeekStartsOn = localeWeekStartsOn == null ? 0 : (0, _index2.default)(localeWeekStartsOn);
	  var weekStartsOn = options.weekStartsOn == null ? defaultWeekStartsOn : (0, _index2.default)(options.weekStartsOn); // Test if weekStartsOn is between 0 and 6 _and_ is not NaN
	
	  if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) {
	    throw new RangeError('weekStartsOn must be between 0 and 6');
	  }
	
	  var date = (0, _index.default)(dirtyDate);
	  var day = date.getDay();
	  var diff = (day < weekStartsOn ? -7 : 0) + 6 - (day - weekStartsOn);
	  date.setHours(0, 0, 0, 0);
	  date.setDate(date.getDate() + diff);
	  return date;
	}
	
	module.exports = exports.default;

/***/ },
/* 427 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = max;
	
	var _index = _interopRequireDefault(__webpack_require__(3));
	
	var _index2 = _interopRequireDefault(__webpack_require__(2));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name max
	 * @category Common Helpers
	 * @summary Return the latest of the given dates.
	 *
	 * @description
	 * Return the latest of the given dates.
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * - `max` function now accepts an array of dates rather than spread arguments.
	 *
	 *   ```javascript
	 *   // Before v2.0.0
	 *   var date1 = new Date(1989, 6, 10)
	 *   var date2 = new Date(1987, 1, 11)
	 *   var maxDate = max(date1, date2)
	 *
	 *   // v2.0.0 onward:
	 *   var dates = [new Date(1989, 6, 10), new Date(1987, 1, 11)]
	 *   var maxDate = max(dates)
	 *   ```
	 *
	 * @param {Date[]|Number[]} datesArray - the dates to compare
	 * @returns {Date} the latest of the dates
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // Which of these dates is the latest?
	 * var result = max([
	 *   new Date(1989, 6, 10),
	 *   new Date(1987, 1, 11),
	 *   new Date(1995, 6, 2),
	 *   new Date(1990, 0, 1)
	 * ])
	 * //=> Sun Jul 02 1995 00:00:00
	 */
	function max(dirtyDatesArray) {
	  (0, _index2.default)(1, arguments);
	  var datesArray; // `dirtyDatesArray` is Array, Set or Map, or object with custom `forEach` method
	
	  if (dirtyDatesArray && typeof dirtyDatesArray.forEach === 'function') {
	    datesArray = dirtyDatesArray; // If `dirtyDatesArray` is Array-like Object, convert to Array.
	  } else if (typeof dirtyDatesArray === 'object' && dirtyDatesArray !== null) {
	    datesArray = Array.prototype.slice.call(dirtyDatesArray);
	  } else {
	    // `dirtyDatesArray` is non-iterable, return Invalid Date
	    return new Date(NaN);
	  }
	
	  var result;
	  datesArray.forEach(function (dirtyDate) {
	    var currentDate = (0, _index.default)(dirtyDate);
	
	    if (result === undefined || result < currentDate || isNaN(currentDate)) {
	      result = currentDate;
	    }
	  });
	  return result || new Date(NaN);
	}
	
	module.exports = exports.default;

/***/ },
/* 428 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = min;
	
	var _index = _interopRequireDefault(__webpack_require__(3));
	
	var _index2 = _interopRequireDefault(__webpack_require__(2));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name min
	 * @category Common Helpers
	 * @summary Return the earliest of the given dates.
	 *
	 * @description
	 * Return the earliest of the given dates.
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * - `min` function now accepts an array of dates rather than spread arguments.
	 *
	 *   ```javascript
	 *   // Before v2.0.0
	 *   var date1 = new Date(1989, 6, 10)
	 *   var date2 = new Date(1987, 1, 11)
	 *   var minDate = min(date1, date2)
	 *
	 *   // v2.0.0 onward:
	 *   var dates = [new Date(1989, 6, 10), new Date(1987, 1, 11)]
	 *   var minDate = min(dates)
	 *   ```
	 *
	 * @param {Date[]|Number[]} datesArray - the dates to compare
	 * @returns {Date} the earliest of the dates
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // Which of these dates is the earliest?
	 * var result = min([
	 *   new Date(1989, 6, 10),
	 *   new Date(1987, 1, 11),
	 *   new Date(1995, 6, 2),
	 *   new Date(1990, 0, 1)
	 * ])
	 * //=> Wed Feb 11 1987 00:00:00
	 */
	function min(dirtyDatesArray) {
	  (0, _index2.default)(1, arguments);
	  var datesArray; // `dirtyDatesArray` is Array, Set or Map, or object with custom `forEach` method
	
	  if (dirtyDatesArray && typeof dirtyDatesArray.forEach === 'function') {
	    datesArray = dirtyDatesArray; // If `dirtyDatesArray` is Array-like Object, convert to Array.
	  } else if (typeof dirtyDatesArray === 'object' && dirtyDatesArray !== null) {
	    datesArray = Array.prototype.slice.call(dirtyDatesArray);
	  } else {
	    // `dirtyDatesArray` is non-iterable, return Invalid Date
	    return new Date(NaN);
	  }
	
	  var result;
	  datesArray.forEach(function (dirtyDate) {
	    var currentDate = (0, _index.default)(dirtyDate);
	
	    if (result === undefined || result > currentDate || isNaN(currentDate)) {
	      result = currentDate;
	    }
	  });
	  return result || new Date(NaN);
	}
	
	module.exports = exports.default;

/***/ },
/* 429 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = parse;
	
	var _index = _interopRequireDefault(__webpack_require__(115));
	
	var _index2 = _interopRequireDefault(__webpack_require__(143));
	
	var _index3 = _interopRequireDefault(__webpack_require__(3));
	
	var _index4 = _interopRequireDefault(__webpack_require__(389));
	
	var _index5 = _interopRequireDefault(__webpack_require__(392));
	
	var _index6 = _interopRequireDefault(__webpack_require__(73));
	
	var _index7 = __webpack_require__(396);
	
	var _index8 = _interopRequireDefault(__webpack_require__(9));
	
	var _index9 = _interopRequireDefault(__webpack_require__(989));
	
	var _index10 = _interopRequireDefault(__webpack_require__(2));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var TIMEZONE_UNIT_PRIORITY = 10; // This RegExp consists of three parts separated by `|`:
	// - [yYQqMLwIdDecihHKkms]o matches any available ordinal number token
	//   (one of the certain letters followed by `o`)
	// - (\w)\1* matches any sequences of the same letter
	// - '' matches two quote characters in a row
	// - '(''|[^'])+('|$) matches anything surrounded by two quote characters ('),
	//   except a single quote symbol, which ends the sequence.
	//   Two quote characters do not end the sequence.
	//   If there is no matching single quote
	//   then the sequence will continue until the end of the string.
	// - . matches any single character unmatched by previous parts of the RegExps
	
	var formattingTokensRegExp = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g; // This RegExp catches symbols escaped by quotes, and also
	// sequences of symbols P, p, and the combinations like `PPPPPPPppppp`
	
	var longFormattingTokensRegExp = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g;
	var escapedStringRegExp = /^'([^]*?)'?$/;
	var doubleQuoteRegExp = /''/g;
	var notWhitespaceRegExp = /\S/;
	var unescapedLatinCharacterRegExp = /[a-zA-Z]/;
	/**
	 * @name parse
	 * @category Common Helpers
	 * @summary Parse the date.
	 *
	 * @description
	 * Return the date parsed from string using the given format string.
	 *
	 * > ⚠️ Please note that the `format` tokens differ from Moment.js and other libraries.
	 * > See: https://git.io/fxCyr
	 *
	 * The characters in the format string wrapped between two single quotes characters (') are escaped.
	 * Two single quotes in a row, whether inside or outside a quoted sequence, represent a 'real' single quote.
	 *
	 * Format of the format string is based on Unicode Technical Standard #35:
	 * https://www.unicode.org/reports/tr35/tr35-dates.html#Date_Field_Symbol_Table
	 * with a few additions (see note 5 below the table).
	 *
	 * Not all tokens are compatible. Combinations that don't make sense or could lead to bugs are prohibited
	 * and will throw `RangeError`. For example usage of 24-hour format token with AM/PM token will throw an exception:
	 *
	 * ```javascript
	 * parse('23 AM', 'HH a', new Date())
	 * //=> RangeError: The format string mustn't contain `HH` and `a` at the same time
	 * ```
	 *
	 * See the compatibility table: https://docs.google.com/spreadsheets/d/e/2PACX-1vQOPU3xUhplll6dyoMmVUXHKl_8CRDs6_ueLmex3SoqwhuolkuN3O05l4rqx5h1dKX8eb46Ul-CCSrq/pubhtml?gid=0&single=true
	 *
	 * Accepted format string patterns:
	 * | Unit                            |Prior| Pattern | Result examples                   | Notes |
	 * |---------------------------------|-----|---------|-----------------------------------|-------|
	 * | Era                             | 140 | G..GGG  | AD, BC                            |       |
	 * |                                 |     | GGGG    | Anno Domini, Before Christ        | 2     |
	 * |                                 |     | GGGGG   | A, B                              |       |
	 * | Calendar year                   | 130 | y       | 44, 1, 1900, 2017, 9999           | 4     |
	 * |                                 |     | yo      | 44th, 1st, 1900th, 9999999th      | 4,5   |
	 * |                                 |     | yy      | 44, 01, 00, 17                    | 4     |
	 * |                                 |     | yyy     | 044, 001, 123, 999                | 4     |
	 * |                                 |     | yyyy    | 0044, 0001, 1900, 2017            | 4     |
	 * |                                 |     | yyyyy   | ...                               | 2,4   |
	 * | Local week-numbering year       | 130 | Y       | 44, 1, 1900, 2017, 9000           | 4     |
	 * |                                 |     | Yo      | 44th, 1st, 1900th, 9999999th      | 4,5   |
	 * |                                 |     | YY      | 44, 01, 00, 17                    | 4,6   |
	 * |                                 |     | YYY     | 044, 001, 123, 999                | 4     |
	 * |                                 |     | YYYY    | 0044, 0001, 1900, 2017            | 4,6   |
	 * |                                 |     | YYYYY   | ...                               | 2,4   |
	 * | ISO week-numbering year         | 130 | R       | -43, 1, 1900, 2017, 9999, -9999   | 4,5   |
	 * |                                 |     | RR      | -43, 01, 00, 17                   | 4,5   |
	 * |                                 |     | RRR     | -043, 001, 123, 999, -999         | 4,5   |
	 * |                                 |     | RRRR    | -0043, 0001, 2017, 9999, -9999    | 4,5   |
	 * |                                 |     | RRRRR   | ...                               | 2,4,5 |
	 * | Extended year                   | 130 | u       | -43, 1, 1900, 2017, 9999, -999    | 4     |
	 * |                                 |     | uu      | -43, 01, 99, -99                  | 4     |
	 * |                                 |     | uuu     | -043, 001, 123, 999, -999         | 4     |
	 * |                                 |     | uuuu    | -0043, 0001, 2017, 9999, -9999    | 4     |
	 * |                                 |     | uuuuu   | ...                               | 2,4   |
	 * | Quarter (formatting)            | 120 | Q       | 1, 2, 3, 4                        |       |
	 * |                                 |     | Qo      | 1st, 2nd, 3rd, 4th                | 5     |
	 * |                                 |     | QQ      | 01, 02, 03, 04                    |       |
	 * |                                 |     | QQQ     | Q1, Q2, Q3, Q4                    |       |
	 * |                                 |     | QQQQ    | 1st quarter, 2nd quarter, ...     | 2     |
	 * |                                 |     | QQQQQ   | 1, 2, 3, 4                        | 4     |
	 * | Quarter (stand-alone)           | 120 | q       | 1, 2, 3, 4                        |       |
	 * |                                 |     | qo      | 1st, 2nd, 3rd, 4th                | 5     |
	 * |                                 |     | qq      | 01, 02, 03, 04                    |       |
	 * |                                 |     | qqq     | Q1, Q2, Q3, Q4                    |       |
	 * |                                 |     | qqqq    | 1st quarter, 2nd quarter, ...     | 2     |
	 * |                                 |     | qqqqq   | 1, 2, 3, 4                        | 3     |
	 * | Month (formatting)              | 110 | M       | 1, 2, ..., 12                     |       |
	 * |                                 |     | Mo      | 1st, 2nd, ..., 12th               | 5     |
	 * |                                 |     | MM      | 01, 02, ..., 12                   |       |
	 * |                                 |     | MMM     | Jan, Feb, ..., Dec                |       |
	 * |                                 |     | MMMM    | January, February, ..., December  | 2     |
	 * |                                 |     | MMMMM   | J, F, ..., D                      |       |
	 * | Month (stand-alone)             | 110 | L       | 1, 2, ..., 12                     |       |
	 * |                                 |     | Lo      | 1st, 2nd, ..., 12th               | 5     |
	 * |                                 |     | LL      | 01, 02, ..., 12                   |       |
	 * |                                 |     | LLL     | Jan, Feb, ..., Dec                |       |
	 * |                                 |     | LLLL    | January, February, ..., December  | 2     |
	 * |                                 |     | LLLLL   | J, F, ..., D                      |       |
	 * | Local week of year              | 100 | w       | 1, 2, ..., 53                     |       |
	 * |                                 |     | wo      | 1st, 2nd, ..., 53th               | 5     |
	 * |                                 |     | ww      | 01, 02, ..., 53                   |       |
	 * | ISO week of year                | 100 | I       | 1, 2, ..., 53                     | 5     |
	 * |                                 |     | Io      | 1st, 2nd, ..., 53th               | 5     |
	 * |                                 |     | II      | 01, 02, ..., 53                   | 5     |
	 * | Day of month                    |  90 | d       | 1, 2, ..., 31                     |       |
	 * |                                 |     | do      | 1st, 2nd, ..., 31st               | 5     |
	 * |                                 |     | dd      | 01, 02, ..., 31                   |       |
	 * | Day of year                     |  90 | D       | 1, 2, ..., 365, 366               | 7     |
	 * |                                 |     | Do      | 1st, 2nd, ..., 365th, 366th       | 5     |
	 * |                                 |     | DD      | 01, 02, ..., 365, 366             | 7     |
	 * |                                 |     | DDD     | 001, 002, ..., 365, 366           |       |
	 * |                                 |     | DDDD    | ...                               | 2     |
	 * | Day of week (formatting)        |  90 | E..EEE  | Mon, Tue, Wed, ..., Su            |       |
	 * |                                 |     | EEEE    | Monday, Tuesday, ..., Sunday      | 2     |
	 * |                                 |     | EEEEE   | M, T, W, T, F, S, S               |       |
	 * |                                 |     | EEEEEE  | Mo, Tu, We, Th, Fr, Su, Sa        |       |
	 * | ISO day of week (formatting)    |  90 | i       | 1, 2, 3, ..., 7                   | 5     |
	 * |                                 |     | io      | 1st, 2nd, ..., 7th                | 5     |
	 * |                                 |     | ii      | 01, 02, ..., 07                   | 5     |
	 * |                                 |     | iii     | Mon, Tue, Wed, ..., Su            | 5     |
	 * |                                 |     | iiii    | Monday, Tuesday, ..., Sunday      | 2,5   |
	 * |                                 |     | iiiii   | M, T, W, T, F, S, S               | 5     |
	 * |                                 |     | iiiiii  | Mo, Tu, We, Th, Fr, Su, Sa        | 5     |
	 * | Local day of week (formatting)  |  90 | e       | 2, 3, 4, ..., 1                   |       |
	 * |                                 |     | eo      | 2nd, 3rd, ..., 1st                | 5     |
	 * |                                 |     | ee      | 02, 03, ..., 01                   |       |
	 * |                                 |     | eee     | Mon, Tue, Wed, ..., Su            |       |
	 * |                                 |     | eeee    | Monday, Tuesday, ..., Sunday      | 2     |
	 * |                                 |     | eeeee   | M, T, W, T, F, S, S               |       |
	 * |                                 |     | eeeeee  | Mo, Tu, We, Th, Fr, Su, Sa        |       |
	 * | Local day of week (stand-alone) |  90 | c       | 2, 3, 4, ..., 1                   |       |
	 * |                                 |     | co      | 2nd, 3rd, ..., 1st                | 5     |
	 * |                                 |     | cc      | 02, 03, ..., 01                   |       |
	 * |                                 |     | ccc     | Mon, Tue, Wed, ..., Su            |       |
	 * |                                 |     | cccc    | Monday, Tuesday, ..., Sunday      | 2     |
	 * |                                 |     | ccccc   | M, T, W, T, F, S, S               |       |
	 * |                                 |     | cccccc  | Mo, Tu, We, Th, Fr, Su, Sa        |       |
	 * | AM, PM                          |  80 | a..aaa  | AM, PM                            |       |
	 * |                                 |     | aaaa    | a.m., p.m.                        | 2     |
	 * |                                 |     | aaaaa   | a, p                              |       |
	 * | AM, PM, noon, midnight          |  80 | b..bbb  | AM, PM, noon, midnight            |       |
	 * |                                 |     | bbbb    | a.m., p.m., noon, midnight        | 2     |
	 * |                                 |     | bbbbb   | a, p, n, mi                       |       |
	 * | Flexible day period             |  80 | B..BBB  | at night, in the morning, ...     |       |
	 * |                                 |     | BBBB    | at night, in the morning, ...     | 2     |
	 * |                                 |     | BBBBB   | at night, in the morning, ...     |       |
	 * | Hour [1-12]                     |  70 | h       | 1, 2, ..., 11, 12                 |       |
	 * |                                 |     | ho      | 1st, 2nd, ..., 11th, 12th         | 5     |
	 * |                                 |     | hh      | 01, 02, ..., 11, 12               |       |
	 * | Hour [0-23]                     |  70 | H       | 0, 1, 2, ..., 23                  |       |
	 * |                                 |     | Ho      | 0th, 1st, 2nd, ..., 23rd          | 5     |
	 * |                                 |     | HH      | 00, 01, 02, ..., 23               |       |
	 * | Hour [0-11]                     |  70 | K       | 1, 2, ..., 11, 0                  |       |
	 * |                                 |     | Ko      | 1st, 2nd, ..., 11th, 0th          | 5     |
	 * |                                 |     | KK      | 01, 02, ..., 11, 00               |       |
	 * | Hour [1-24]                     |  70 | k       | 24, 1, 2, ..., 23                 |       |
	 * |                                 |     | ko      | 24th, 1st, 2nd, ..., 23rd         | 5     |
	 * |                                 |     | kk      | 24, 01, 02, ..., 23               |       |
	 * | Minute                          |  60 | m       | 0, 1, ..., 59                     |       |
	 * |                                 |     | mo      | 0th, 1st, ..., 59th               | 5     |
	 * |                                 |     | mm      | 00, 01, ..., 59                   |       |
	 * | Second                          |  50 | s       | 0, 1, ..., 59                     |       |
	 * |                                 |     | so      | 0th, 1st, ..., 59th               | 5     |
	 * |                                 |     | ss      | 00, 01, ..., 59                   |       |
	 * | Seconds timestamp               |  40 | t       | 512969520                         |       |
	 * |                                 |     | tt      | ...                               | 2     |
	 * | Fraction of second              |  30 | S       | 0, 1, ..., 9                      |       |
	 * |                                 |     | SS      | 00, 01, ..., 99                   |       |
	 * |                                 |     | SSS     | 000, 0001, ..., 999               |       |
	 * |                                 |     | SSSS    | ...                               | 2     |
	 * | Milliseconds timestamp          |  20 | T       | 512969520900                      |       |
	 * |                                 |     | TT      | ...                               | 2     |
	 * | Timezone (ISO-8601 w/ Z)        |  10 | X       | -08, +0530, Z                     |       |
	 * |                                 |     | XX      | -0800, +0530, Z                   |       |
	 * |                                 |     | XXX     | -08:00, +05:30, Z                 |       |
	 * |                                 |     | XXXX    | -0800, +0530, Z, +123456          | 2     |
	 * |                                 |     | XXXXX   | -08:00, +05:30, Z, +12:34:56      |       |
	 * | Timezone (ISO-8601 w/o Z)       |  10 | x       | -08, +0530, +00                   |       |
	 * |                                 |     | xx      | -0800, +0530, +0000               |       |
	 * |                                 |     | xxx     | -08:00, +05:30, +00:00            | 2     |
	 * |                                 |     | xxxx    | -0800, +0530, +0000, +123456      |       |
	 * |                                 |     | xxxxx   | -08:00, +05:30, +00:00, +12:34:56 |       |
	 * | Long localized date             |  NA | P       | 05/29/1453                        | 5,8   |
	 * |                                 |     | PP      | May 29, 1453                      |       |
	 * |                                 |     | PPP     | May 29th, 1453                    |       |
	 * |                                 |     | PPPP    | Sunday, May 29th, 1453            | 2,5,8 |
	 * | Long localized time             |  NA | p       | 12:00 AM                          | 5,8   |
	 * |                                 |     | pp      | 12:00:00 AM                       |       |
	 * | Combination of date and time    |  NA | Pp      | 05/29/1453, 12:00 AM              |       |
	 * |                                 |     | PPpp    | May 29, 1453, 12:00:00 AM         |       |
	 * |                                 |     | PPPpp   | May 29th, 1453 at ...             |       |
	 * |                                 |     | PPPPpp  | Sunday, May 29th, 1453 at ...     | 2,5,8 |
	 * Notes:
	 * 1. "Formatting" units (e.g. formatting quarter) in the default en-US locale
	 *    are the same as "stand-alone" units, but are different in some languages.
	 *    "Formatting" units are declined according to the rules of the language
	 *    in the context of a date. "Stand-alone" units are always nominative singular.
	 *    In `format` function, they will produce different result:
	 *
	 *    `format(new Date(2017, 10, 6), 'do LLLL', {locale: cs}) //=> '6. listopad'`
	 *
	 *    `format(new Date(2017, 10, 6), 'do MMMM', {locale: cs}) //=> '6. listopadu'`
	 *
	 *    `parse` will try to match both formatting and stand-alone units interchangably.
	 *
	 * 2. Any sequence of the identical letters is a pattern, unless it is escaped by
	 *    the single quote characters (see below).
	 *    If the sequence is longer than listed in table:
	 *    - for numerical units (`yyyyyyyy`) `parse` will try to match a number
	 *      as wide as the sequence
	 *    - for text units (`MMMMMMMM`) `parse` will try to match the widest variation of the unit.
	 *      These variations are marked with "2" in the last column of the table.
	 *
	 * 3. `QQQQQ` and `qqqqq` could be not strictly numerical in some locales.
	 *    These tokens represent the shortest form of the quarter.
	 *
	 * 4. The main difference between `y` and `u` patterns are B.C. years:
	 *
	 *    | Year | `y` | `u` |
	 *    |------|-----|-----|
	 *    | AC 1 |   1 |   1 |
	 *    | BC 1 |   1 |   0 |
	 *    | BC 2 |   2 |  -1 |
	 *
	 *    Also `yy` will try to guess the century of two digit year by proximity with `referenceDate`:
	 *
	 *    `parse('50', 'yy', new Date(2018, 0, 1)) //=> Sat Jan 01 2050 00:00:00`
	 *
	 *    `parse('75', 'yy', new Date(2018, 0, 1)) //=> Wed Jan 01 1975 00:00:00`
	 *
	 *    while `uu` will just assign the year as is:
	 *
	 *    `parse('50', 'uu', new Date(2018, 0, 1)) //=> Sat Jan 01 0050 00:00:00`
	 *
	 *    `parse('75', 'uu', new Date(2018, 0, 1)) //=> Tue Jan 01 0075 00:00:00`
	 *
	 *    The same difference is true for local and ISO week-numbering years (`Y` and `R`),
	 *    except local week-numbering years are dependent on `options.weekStartsOn`
	 *    and `options.firstWeekContainsDate` (compare [setISOWeekYear]{@link https://date-fns.org/docs/setISOWeekYear}
	 *    and [setWeekYear]{@link https://date-fns.org/docs/setWeekYear}).
	 *
	 * 5. These patterns are not in the Unicode Technical Standard #35:
	 *    - `i`: ISO day of week
	 *    - `I`: ISO week of year
	 *    - `R`: ISO week-numbering year
	 *    - `o`: ordinal number modifier
	 *    - `P`: long localized date
	 *    - `p`: long localized time
	 *
	 * 6. `YY` and `YYYY` tokens represent week-numbering years but they are often confused with years.
	 *    You should enable `options.useAdditionalWeekYearTokens` to use them. See: https://git.io/fxCyr
	 *
	 * 7. `D` and `DD` tokens represent days of the year but they are ofthen confused with days of the month.
	 *    You should enable `options.useAdditionalDayOfYearTokens` to use them. See: https://git.io/fxCyr
	 *
	 * 8. `P+` tokens do not have a defined priority since they are merely aliases to other tokens based
	 *    on the given locale.
	 *
	 *    using `en-US` locale: `P` => `MM/dd/yyyy`
	 *    using `en-US` locale: `p` => `hh:mm a`
	 *    using `pt-BR` locale: `P` => `dd/MM/yyyy`
	 *    using `pt-BR` locale: `p` => `HH:mm`
	 *
	 * Values will be assigned to the date in the descending order of its unit's priority.
	 * Units of an equal priority overwrite each other in the order of appearance.
	 *
	 * If no values of higher priority are parsed (e.g. when parsing string 'January 1st' without a year),
	 * the values will be taken from 3rd argument `referenceDate` which works as a context of parsing.
	 *
	 * `referenceDate` must be passed for correct work of the function.
	 * If you're not sure which `referenceDate` to supply, create a new instance of Date:
	 * `parse('02/11/2014', 'MM/dd/yyyy', new Date())`
	 * In this case parsing will be done in the context of the current date.
	 * If `referenceDate` is `Invalid Date` or a value not convertible to valid `Date`,
	 * then `Invalid Date` will be returned.
	 *
	 * The result may vary by locale.
	 *
	 * If `formatString` matches with `dateString` but does not provides tokens, `referenceDate` will be returned.
	 *
	 * If parsing failed, `Invalid Date` will be returned.
	 * Invalid Date is a Date, whose time value is NaN.
	 * Time value of Date: http://es5.github.io/#x15.9.1.1
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * - Old `parse` was renamed to `toDate`.
	 *   Now `parse` is a new function which parses a string using a provided format.
	 *
	 *   ```javascript
	 *   // Before v2.0.0
	 *   parse('2016-01-01')
	 *
	 *   // v2.0.0 onward
	 *   toDate('2016-01-01')
	 *   parse('2016-01-01', 'yyyy-MM-dd', new Date())
	 *   ```
	 *
	 * @param {String} dateString - the string to parse
	 * @param {String} formatString - the string of tokens
	 * @param {Date|Number} referenceDate - defines values missing from the parsed dateString
	 * @param {Object} [options] - an object with options.
	 * @param {Locale} [options.locale=defaultLocale] - the locale object. See [Locale]{@link https://date-fns.org/docs/Locale}
	 * @param {0|1|2|3|4|5|6} [options.weekStartsOn=0] - the index of the first day of the week (0 - Sunday)
	 * @param {1|2|3|4|5|6|7} [options.firstWeekContainsDate=1] - the day of January, which is always in the first week of the year
	 * @param {Boolean} [options.useAdditionalWeekYearTokens=false] - if true, allows usage of the week-numbering year tokens `YY` and `YYYY`;
	 *   see: https://git.io/fxCyr
	 * @param {Boolean} [options.useAdditionalDayOfYearTokens=false] - if true, allows usage of the day of year tokens `D` and `DD`;
	 *   see: https://git.io/fxCyr
	 * @returns {Date} the parsed date
	 * @throws {TypeError} 3 arguments required
	 * @throws {RangeError} `options.weekStartsOn` must be between 0 and 6
	 * @throws {RangeError} `options.firstWeekContainsDate` must be between 1 and 7
	 * @throws {RangeError} `options.locale` must contain `match` property
	 * @throws {RangeError} use `yyyy` instead of `YYYY` for formatting years; see: https://git.io/fxCyr
	 * @throws {RangeError} use `yy` instead of `YY` for formatting years; see: https://git.io/fxCyr
	 * @throws {RangeError} use `d` instead of `D` for formatting days of the month; see: https://git.io/fxCyr
	 * @throws {RangeError} use `dd` instead of `DD` for formatting days of the month; see: https://git.io/fxCyr
	 * @throws {RangeError} format string contains an unescaped latin alphabet character
	 *
	 * @example
	 * // Parse 11 February 2014 from middle-endian format:
	 * var result = parse('02/11/2014', 'MM/dd/yyyy', new Date())
	 * //=> Tue Feb 11 2014 00:00:00
	 *
	 * @example
	 * // Parse 28th of February in Esperanto locale in the context of 2010 year:
	 * import eo from 'date-fns/locale/eo'
	 * var result = parse('28-a de februaro', "do 'de' MMMM", new Date(2010, 0, 1), {
	 *   locale: eo
	 * })
	 * //=> Sun Feb 28 2010 00:00:00
	 */
	
	function parse(dirtyDateString, dirtyFormatString, dirtyReferenceDate, dirtyOptions) {
	  (0, _index10.default)(3, arguments);
	  var dateString = String(dirtyDateString);
	  var formatString = String(dirtyFormatString);
	  var options = dirtyOptions || {};
	  var locale = options.locale || _index.default;
	
	  if (!locale.match) {
	    throw new RangeError('locale must contain match property');
	  }
	
	  var localeFirstWeekContainsDate = locale.options && locale.options.firstWeekContainsDate;
	  var defaultFirstWeekContainsDate = localeFirstWeekContainsDate == null ? 1 : (0, _index8.default)(localeFirstWeekContainsDate);
	  var firstWeekContainsDate = options.firstWeekContainsDate == null ? defaultFirstWeekContainsDate : (0, _index8.default)(options.firstWeekContainsDate); // Test if weekStartsOn is between 1 and 7 _and_ is not NaN
	
	  if (!(firstWeekContainsDate >= 1 && firstWeekContainsDate <= 7)) {
	    throw new RangeError('firstWeekContainsDate must be between 1 and 7 inclusively');
	  }
	
	  var localeWeekStartsOn = locale.options && locale.options.weekStartsOn;
	  var defaultWeekStartsOn = localeWeekStartsOn == null ? 0 : (0, _index8.default)(localeWeekStartsOn);
	  var weekStartsOn = options.weekStartsOn == null ? defaultWeekStartsOn : (0, _index8.default)(options.weekStartsOn); // Test if weekStartsOn is between 0 and 6 _and_ is not NaN
	
	  if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) {
	    throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
	  }
	
	  if (formatString === '') {
	    if (dateString === '') {
	      return (0, _index3.default)(dirtyReferenceDate);
	    } else {
	      return new Date(NaN);
	    }
	  }
	
	  var subFnOptions = {
	    firstWeekContainsDate: firstWeekContainsDate,
	    weekStartsOn: weekStartsOn,
	    locale: locale // If timezone isn't specified, it will be set to the system timezone
	
	  };
	  var setters = [{
	    priority: TIMEZONE_UNIT_PRIORITY,
	    set: dateToSystemTimezone,
	    index: 0
	  }];
	  var i;
	  var tokens = formatString.match(longFormattingTokensRegExp).map(function (substring) {
	    var firstCharacter = substring[0];
	
	    if (firstCharacter === 'p' || firstCharacter === 'P') {
	      var longFormatter = _index5.default[firstCharacter];
	      return longFormatter(substring, locale.formatLong, subFnOptions);
	    }
	
	    return substring;
	  }).join('').match(formattingTokensRegExp);
	  var usedTokens = [];
	
	  for (i = 0; i < tokens.length; i++) {
	    var token = tokens[i];
	
	    if (!options.useAdditionalWeekYearTokens && (0, _index7.isProtectedWeekYearToken)(token)) {
	      (0, _index7.throwProtectedError)(token);
	    }
	
	    if (!options.useAdditionalDayOfYearTokens && (0, _index7.isProtectedDayOfYearToken)(token)) {
	      (0, _index7.throwProtectedError)(token);
	    }
	
	    var firstCharacter = token[0];
	    var parser = _index9.default[firstCharacter];
	
	    if (parser) {
	      var incompatibleTokens = parser.incompatibleTokens;
	
	      if (Array.isArray(incompatibleTokens)) {
	        var incompatibleToken = void 0;
	
	        for (var _i = 0; _i < usedTokens.length; _i++) {
	          var usedToken = usedTokens[_i].token;
	
	          if (incompatibleTokens.indexOf(usedToken) !== -1 || usedToken === firstCharacter) {
	            incompatibleToken = usedTokens[_i];
	            break;
	          }
	        }
	
	        if (incompatibleToken) {
	          throw new RangeError("The format string mustn't contain `".concat(incompatibleToken.fullToken, "` and `").concat(token, "` at the same time"));
	        }
	      } else if (parser.incompatibleTokens === '*' && usedTokens.length) {
	        throw new RangeError("The format string mustn't contain `".concat(token, "` and any other token at the same time"));
	      }
	
	      usedTokens.push({
	        token: firstCharacter,
	        fullToken: token
	      });
	      var parseResult = parser.parse(dateString, token, locale.match, subFnOptions);
	
	      if (!parseResult) {
	        return new Date(NaN);
	      }
	
	      setters.push({
	        priority: parser.priority,
	        set: parser.set,
	        validate: parser.validate,
	        value: parseResult.value,
	        index: setters.length
	      });
	      dateString = parseResult.rest;
	    } else {
	      if (firstCharacter.match(unescapedLatinCharacterRegExp)) {
	        throw new RangeError('Format string contains an unescaped latin alphabet character `' + firstCharacter + '`');
	      } // Replace two single quote characters with one single quote character
	
	
	      if (token === "''") {
	        token = "'";
	      } else if (firstCharacter === "'") {
	        token = cleanEscapedString(token);
	      } // Cut token from string, or, if string doesn't match the token, return Invalid Date
	
	
	      if (dateString.indexOf(token) === 0) {
	        dateString = dateString.slice(token.length);
	      } else {
	        return new Date(NaN);
	      }
	    }
	  } // Check if the remaining input contains something other than whitespace
	
	
	  if (dateString.length > 0 && notWhitespaceRegExp.test(dateString)) {
	    return new Date(NaN);
	  }
	
	  var uniquePrioritySetters = setters.map(function (setter) {
	    return setter.priority;
	  }).sort(function (a, b) {
	    return b - a;
	  }).filter(function (priority, index, array) {
	    return array.indexOf(priority) === index;
	  }).map(function (priority) {
	    return setters.filter(function (setter) {
	      return setter.priority === priority;
	    }).reverse();
	  }).map(function (setterArray) {
	    return setterArray[0];
	  });
	  var date = (0, _index3.default)(dirtyReferenceDate);
	
	  if (isNaN(date)) {
	    return new Date(NaN);
	  } // Convert the date in system timezone to the same date in UTC+00:00 timezone.
	  // This ensures that when UTC functions will be implemented, locales will be compatible with them.
	  // See an issue about UTC functions: https://github.com/date-fns/date-fns/issues/37
	
	
	  var utcDate = (0, _index2.default)(date, (0, _index6.default)(date));
	  var flags = {};
	
	  for (i = 0; i < uniquePrioritySetters.length; i++) {
	    var setter = uniquePrioritySetters[i];
	
	    if (setter.validate && !setter.validate(utcDate, setter.value, subFnOptions)) {
	      return new Date(NaN);
	    }
	
	    var result = setter.set(utcDate, flags, setter.value, subFnOptions); // Result is tuple (date, flags)
	
	    if (result[0]) {
	      utcDate = result[0];
	      (0, _index4.default)(flags, result[1]); // Result is date
	    } else {
	      utcDate = result;
	    }
	  }
	
	  return utcDate;
	}
	
	function dateToSystemTimezone(date, flags) {
	  if (flags.timestampIsSet) {
	    return date;
	  }
	
	  var convertedDate = new Date(0);
	  convertedDate.setFullYear(date.getUTCFullYear(), date.getUTCMonth(), date.getUTCDate());
	  convertedDate.setHours(date.getUTCHours(), date.getUTCMinutes(), date.getUTCSeconds(), date.getUTCMilliseconds());
	  return convertedDate;
	}
	
	function cleanEscapedString(input) {
	  return input.match(escapedStringRegExp)[1].replace(doubleQuoteRegExp, "'");
	}
	
	module.exports = exports.default;

/***/ },
/* 430 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = setHours;
	
	var _index = _interopRequireDefault(__webpack_require__(9));
	
	var _index2 = _interopRequireDefault(__webpack_require__(3));
	
	var _index3 = _interopRequireDefault(__webpack_require__(2));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name setHours
	 * @category Hour Helpers
	 * @summary Set the hours to the given date.
	 *
	 * @description
	 * Set the hours to the given date.
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} date - the date to be changed
	 * @param {Number} hours - the hours of the new date
	 * @returns {Date} the new date with the hours set
	 * @throws {TypeError} 2 arguments required
	 *
	 * @example
	 * // Set 4 hours to 1 September 2014 11:30:00:
	 * var result = setHours(new Date(2014, 8, 1, 11, 30), 4)
	 * //=> Mon Sep 01 2014 04:30:00
	 */
	function setHours(dirtyDate, dirtyHours) {
	  (0, _index3.default)(2, arguments);
	  var date = (0, _index2.default)(dirtyDate);
	  var hours = (0, _index.default)(dirtyHours);
	  date.setHours(hours);
	  return date;
	}
	
	module.exports = exports.default;

/***/ },
/* 431 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = setISOWeekYear;
	
	var _index = _interopRequireDefault(__webpack_require__(9));
	
	var _index2 = _interopRequireDefault(__webpack_require__(3));
	
	var _index3 = _interopRequireDefault(__webpack_require__(141));
	
	var _index4 = _interopRequireDefault(__webpack_require__(84));
	
	var _index5 = _interopRequireDefault(__webpack_require__(2));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name setISOWeekYear
	 * @category ISO Week-Numbering Year Helpers
	 * @summary Set the ISO week-numbering year to the given date.
	 *
	 * @description
	 * Set the ISO week-numbering year to the given date,
	 * saving the week number and the weekday number.
	 *
	 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * - The function was renamed from `setISOYear` to `setISOWeekYear`.
	 *   "ISO week year" is short for [ISO week-numbering year](https://en.wikipedia.org/wiki/ISO_week_date).
	 *   This change makes the name consistent with
	 *   locale-dependent week-numbering year helpers, e.g., `setWeekYear`.
	 *
	 * @param {Date|Number} date - the date to be changed
	 * @param {Number} isoWeekYear - the ISO week-numbering year of the new date
	 * @returns {Date} the new date with the ISO week-numbering year set
	 * @throws {TypeError} 2 arguments required
	 *
	 * @example
	 * // Set ISO week-numbering year 2007 to 29 December 2008:
	 * var result = setISOWeekYear(new Date(2008, 11, 29), 2007)
	 * //=> Mon Jan 01 2007 00:00:00
	 */
	function setISOWeekYear(dirtyDate, dirtyISOWeekYear) {
	  (0, _index5.default)(2, arguments);
	  var date = (0, _index2.default)(dirtyDate);
	  var isoWeekYear = (0, _index.default)(dirtyISOWeekYear);
	  var diff = (0, _index4.default)(date, (0, _index3.default)(date));
	  var fourthOfJanuary = new Date(0);
	  fourthOfJanuary.setFullYear(isoWeekYear, 0, 4);
	  fourthOfJanuary.setHours(0, 0, 0, 0);
	  date = (0, _index3.default)(fourthOfJanuary);
	  date.setDate(date.getDate() + diff);
	  return date;
	}
	
	module.exports = exports.default;

/***/ },
/* 432 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = setMinutes;
	
	var _index = _interopRequireDefault(__webpack_require__(9));
	
	var _index2 = _interopRequireDefault(__webpack_require__(3));
	
	var _index3 = _interopRequireDefault(__webpack_require__(2));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name setMinutes
	 * @category Minute Helpers
	 * @summary Set the minutes to the given date.
	 *
	 * @description
	 * Set the minutes to the given date.
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} date - the date to be changed
	 * @param {Number} minutes - the minutes of the new date
	 * @returns {Date} the new date with the minutes set
	 * @throws {TypeError} 2 arguments required
	 *
	 * @example
	 * // Set 45 minutes to 1 September 2014 11:30:40:
	 * var result = setMinutes(new Date(2014, 8, 1, 11, 30, 40), 45)
	 * //=> Mon Sep 01 2014 11:45:40
	 */
	function setMinutes(dirtyDate, dirtyMinutes) {
	  (0, _index3.default)(2, arguments);
	  var date = (0, _index2.default)(dirtyDate);
	  var minutes = (0, _index.default)(dirtyMinutes);
	  date.setMinutes(minutes);
	  return date;
	}
	
	module.exports = exports.default;

/***/ },
/* 433 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = setQuarter;
	
	var _index = _interopRequireDefault(__webpack_require__(9));
	
	var _index2 = _interopRequireDefault(__webpack_require__(3));
	
	var _index3 = _interopRequireDefault(__webpack_require__(189));
	
	var _index4 = _interopRequireDefault(__webpack_require__(2));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name setQuarter
	 * @category Quarter Helpers
	 * @summary Set the year quarter to the given date.
	 *
	 * @description
	 * Set the year quarter to the given date.
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} date - the date to be changed
	 * @param {Number} quarter - the quarter of the new date
	 * @returns {Date} the new date with the quarter set
	 * @throws {TypeError} 2 arguments required
	 *
	 * @example
	 * // Set the 2nd quarter to 2 July 2014:
	 * var result = setQuarter(new Date(2014, 6, 2), 2)
	 * //=> Wed Apr 02 2014 00:00:00
	 */
	function setQuarter(dirtyDate, dirtyQuarter) {
	  (0, _index4.default)(2, arguments);
	  var date = (0, _index2.default)(dirtyDate);
	  var quarter = (0, _index.default)(dirtyQuarter);
	  var oldQuarter = Math.floor(date.getMonth() / 3) + 1;
	  var diff = quarter - oldQuarter;
	  return (0, _index3.default)(date, date.getMonth() + diff * 3);
	}
	
	module.exports = exports.default;

/***/ },
/* 434 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = setSeconds;
	
	var _index = _interopRequireDefault(__webpack_require__(9));
	
	var _index2 = _interopRequireDefault(__webpack_require__(3));
	
	var _index3 = _interopRequireDefault(__webpack_require__(2));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name setSeconds
	 * @category Second Helpers
	 * @summary Set the seconds to the given date.
	 *
	 * @description
	 * Set the seconds to the given date.
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} date - the date to be changed
	 * @param {Number} seconds - the seconds of the new date
	 * @returns {Date} the new date with the seconds set
	 * @throws {TypeError} 2 arguments required
	 *
	 * @example
	 * // Set 45 seconds to 1 September 2014 11:30:40:
	 * var result = setSeconds(new Date(2014, 8, 1, 11, 30, 40), 45)
	 * //=> Mon Sep 01 2014 11:30:45
	 */
	function setSeconds(dirtyDate, dirtySeconds) {
	  (0, _index3.default)(2, arguments);
	  var date = (0, _index2.default)(dirtyDate);
	  var seconds = (0, _index.default)(dirtySeconds);
	  date.setSeconds(seconds);
	  return date;
	}
	
	module.exports = exports.default;

/***/ },
/* 435 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = setYear;
	
	var _index = _interopRequireDefault(__webpack_require__(9));
	
	var _index2 = _interopRequireDefault(__webpack_require__(3));
	
	var _index3 = _interopRequireDefault(__webpack_require__(2));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name setYear
	 * @category Year Helpers
	 * @summary Set the year to the given date.
	 *
	 * @description
	 * Set the year to the given date.
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} date - the date to be changed
	 * @param {Number} year - the year of the new date
	 * @returns {Date} the new date with the year set
	 * @throws {TypeError} 2 arguments required
	 *
	 * @example
	 * // Set year 2013 to 1 September 2014:
	 * var result = setYear(new Date(2014, 8, 1), 2013)
	 * //=> Sun Sep 01 2013 00:00:00
	 */
	function setYear(dirtyDate, dirtyYear) {
	  (0, _index3.default)(2, arguments);
	  var date = (0, _index2.default)(dirtyDate);
	  var year = (0, _index.default)(dirtyYear); // Check if date is Invalid Date because Date.prototype.setFullYear ignores the value of Invalid Date
	
	  if (isNaN(date)) {
	    return new Date(NaN);
	  }
	
	  date.setFullYear(year);
	  return date;
	}
	
	module.exports = exports.default;

/***/ },
/* 436 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = startOfHour;
	
	var _index = _interopRequireDefault(__webpack_require__(3));
	
	var _index2 = _interopRequireDefault(__webpack_require__(2));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name startOfHour
	 * @category Hour Helpers
	 * @summary Return the start of an hour for the given date.
	 *
	 * @description
	 * Return the start of an hour for the given date.
	 * The result will be in the local timezone.
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} date - the original date
	 * @returns {Date} the start of an hour
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // The start of an hour for 2 September 2014 11:55:00:
	 * var result = startOfHour(new Date(2014, 8, 2, 11, 55))
	 * //=> Tue Sep 02 2014 11:00:00
	 */
	function startOfHour(dirtyDate) {
	  (0, _index2.default)(1, arguments);
	  var date = (0, _index.default)(dirtyDate);
	  date.setMinutes(0, 0, 0);
	  return date;
	}
	
	module.exports = exports.default;

/***/ },
/* 437 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = startOfMinute;
	
	var _index = _interopRequireDefault(__webpack_require__(3));
	
	var _index2 = _interopRequireDefault(__webpack_require__(2));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name startOfMinute
	 * @category Minute Helpers
	 * @summary Return the start of a minute for the given date.
	 *
	 * @description
	 * Return the start of a minute for the given date.
	 * The result will be in the local timezone.
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} date - the original date
	 * @returns {Date} the start of a minute
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // The start of a minute for 1 December 2014 22:15:45.400:
	 * var result = startOfMinute(new Date(2014, 11, 1, 22, 15, 45, 400))
	 * //=> Mon Dec 01 2014 22:15:00
	 */
	function startOfMinute(dirtyDate) {
	  (0, _index2.default)(1, arguments);
	  var date = (0, _index.default)(dirtyDate);
	  date.setSeconds(0, 0);
	  return date;
	}
	
	module.exports = exports.default;

/***/ },
/* 438 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = startOfSecond;
	
	var _index = _interopRequireDefault(__webpack_require__(3));
	
	var _index2 = _interopRequireDefault(__webpack_require__(2));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name startOfSecond
	 * @category Second Helpers
	 * @summary Return the start of a second for the given date.
	 *
	 * @description
	 * Return the start of a second for the given date.
	 * The result will be in the local timezone.
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} date - the original date
	 * @returns {Date} the start of a second
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // The start of a second for 1 December 2014 22:15:45.400:
	 * var result = startOfSecond(new Date(2014, 11, 1, 22, 15, 45, 400))
	 * //=> Mon Dec 01 2014 22:15:45.000
	 */
	function startOfSecond(dirtyDate) {
	  (0, _index2.default)(1, arguments);
	  var date = (0, _index.default)(dirtyDate);
	  date.setMilliseconds(0);
	  return date;
	}
	
	module.exports = exports.default;

/***/ },
/* 439 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = subHours;
	
	var _index = _interopRequireDefault(__webpack_require__(9));
	
	var _index2 = _interopRequireDefault(__webpack_require__(181));
	
	var _index3 = _interopRequireDefault(__webpack_require__(2));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name subHours
	 * @category Hour Helpers
	 * @summary Subtract the specified number of hours from the given date.
	 *
	 * @description
	 * Subtract the specified number of hours from the given date.
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} date - the date to be changed
	 * @param {Number} amount - the amount of hours to be subtracted. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
	 * @returns {Date} the new date with the hours subtracted
	 * @throws {TypeError} 2 arguments required
	 *
	 * @example
	 * // Subtract 2 hours from 11 July 2014 01:00:00:
	 * var result = subHours(new Date(2014, 6, 11, 1, 0), 2)
	 * //=> Thu Jul 10 2014 23:00:00
	 */
	function subHours(dirtyDate, dirtyAmount) {
	  (0, _index3.default)(2, arguments);
	  var amount = (0, _index.default)(dirtyAmount);
	  return (0, _index2.default)(dirtyDate, -amount);
	}
	
	module.exports = exports.default;

/***/ },
/* 440 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = subISOWeekYears;
	
	var _index = _interopRequireDefault(__webpack_require__(9));
	
	var _index2 = _interopRequireDefault(__webpack_require__(398));
	
	var _index3 = _interopRequireDefault(__webpack_require__(2));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name subISOWeekYears
	 * @category ISO Week-Numbering Year Helpers
	 * @summary Subtract the specified number of ISO week-numbering years from the given date.
	 *
	 * @description
	 * Subtract the specified number of ISO week-numbering years from the given date.
	 *
	 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * - The function was renamed from `subISOYears` to `subISOWeekYears`.
	 *   "ISO week year" is short for [ISO week-numbering year](https://en.wikipedia.org/wiki/ISO_week_date).
	 *   This change makes the name consistent with
	 *   locale-dependent week-numbering year helpers, e.g., `setWeekYear`.
	 *
	 * @param {Date|Number} date - the date to be changed
	 * @param {Number} amount - the amount of ISO week-numbering years to be subtracted. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
	 * @returns {Date} the new date with the ISO week-numbering years subtracted
	 * @throws {TypeError} 2 arguments required
	 *
	 * @example
	 * // Subtract 5 ISO week-numbering years from 1 September 2014:
	 * var result = subISOWeekYears(new Date(2014, 8, 1), 5)
	 * //=> Mon Aug 31 2009 00:00:00
	 */
	function subISOWeekYears(dirtyDate, dirtyAmount) {
	  (0, _index3.default)(2, arguments);
	  var amount = (0, _index.default)(dirtyAmount);
	  return (0, _index2.default)(dirtyDate, -amount);
	}
	
	module.exports = exports.default;

/***/ },
/* 441 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = subMinutes;
	
	var _index = _interopRequireDefault(__webpack_require__(9));
	
	var _index2 = _interopRequireDefault(__webpack_require__(261));
	
	var _index3 = _interopRequireDefault(__webpack_require__(2));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name subMinutes
	 * @category Minute Helpers
	 * @summary Subtract the specified number of minutes from the given date.
	 *
	 * @description
	 * Subtract the specified number of minutes from the given date.
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} date - the date to be changed
	 * @param {Number} amount - the amount of minutes to be subtracted. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
	 * @returns {Date} the new date with the minutes subtracted
	 * @throws {TypeError} 2 arguments required
	 *
	 * @example
	 * // Subtract 30 minutes from 10 July 2014 12:00:00:
	 * var result = subMinutes(new Date(2014, 6, 10, 12, 0), 30)
	 * //=> Thu Jul 10 2014 11:30:00
	 */
	function subMinutes(dirtyDate, dirtyAmount) {
	  (0, _index3.default)(2, arguments);
	  var amount = (0, _index.default)(dirtyAmount);
	  return (0, _index2.default)(dirtyDate, -amount);
	}
	
	module.exports = exports.default;

/***/ },
/* 442 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = subWeeks;
	
	var _index = _interopRequireDefault(__webpack_require__(9));
	
	var _index2 = _interopRequireDefault(__webpack_require__(138));
	
	var _index3 = _interopRequireDefault(__webpack_require__(2));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name subWeeks
	 * @category Week Helpers
	 * @summary Subtract the specified number of weeks from the given date.
	 *
	 * @description
	 * Subtract the specified number of weeks from the given date.
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} date - the date to be changed
	 * @param {Number} amount - the amount of weeks to be subtracted. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
	 * @returns {Date} the new date with the weeks subtracted
	 * @throws {TypeError} 2 arguments required
	 *
	 * @example
	 * // Subtract 4 weeks from 1 September 2014:
	 * var result = subWeeks(new Date(2014, 8, 1), 4)
	 * //=> Mon Aug 04 2014 00:00:00
	 */
	function subWeeks(dirtyDate, dirtyAmount) {
	  (0, _index3.default)(2, arguments);
	  var amount = (0, _index.default)(dirtyAmount);
	  return (0, _index2.default)(dirtyDate, -amount);
	}
	
	module.exports = exports.default;

/***/ },
/* 443 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = subYears;
	
	var _index = _interopRequireDefault(__webpack_require__(9));
	
	var _index2 = _interopRequireDefault(__webpack_require__(263));
	
	var _index3 = _interopRequireDefault(__webpack_require__(2));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name subYears
	 * @category Year Helpers
	 * @summary Subtract the specified number of years from the given date.
	 *
	 * @description
	 * Subtract the specified number of years from the given date.
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} date - the date to be changed
	 * @param {Number} amount - the amount of years to be subtracted. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
	 * @returns {Date} the new date with the years subtracted
	 * @throws {TypeError} 2 arguments required
	 *
	 * @example
	 * // Subtract 5 years from 1 September 2014:
	 * var result = subYears(new Date(2014, 8, 1), 5)
	 * //=> Tue Sep 01 2009 00:00:00
	 */
	function subYears(dirtyDate, dirtyAmount) {
	  (0, _index3.default)(2, arguments);
	  var amount = (0, _index.default)(dirtyAmount);
	  return (0, _index2.default)(dirtyDate, -amount);
	}
	
	module.exports = exports.default;

/***/ },
/* 444 */
/***/ function(module, exports) {

	"use strict";
	
	var detector = module.exports = {};
	
	detector.isIE = function(version) {
	    function isAnyIeVersion() {
	        var agent = navigator.userAgent.toLowerCase();
	        return agent.indexOf("msie") !== -1 || agent.indexOf("trident") !== -1 || agent.indexOf(" edge/") !== -1;
	    }
	
	    if(!isAnyIeVersion()) {
	        return false;
	    }
	
	    if(!version) {
	        return true;
	    }
	
	    //Shamelessly stolen from https://gist.github.com/padolsey/527683
	    var ieVersion = (function(){
	        var undef,
	            v = 3,
	            div = document.createElement("div"),
	            all = div.getElementsByTagName("i");
	
	        do {
	            div.innerHTML = "<!--[if gt IE " + (++v) + "]><i></i><![endif]-->";
	        }
	        while (all[0]);
	
	        return v > 4 ? v : undef;
	    }());
	
	    return version === ieVersion;
	};
	
	detector.isLegacyOpera = function() {
	    return !!window.opera;
	};


/***/ },
/* 445 */
/***/ function(module, exports) {

	"use strict";
	
	var utils = module.exports = {};
	
	/**
	 * Loops through the collection and calls the callback for each element. if the callback returns truthy, the loop is broken and returns the same value.
	 * @public
	 * @param {*} collection The collection to loop through. Needs to have a length property set and have indices set from 0 to length - 1.
	 * @param {function} callback The callback to be called for each element. The element will be given as a parameter to the callback. If this callback returns truthy, the loop is broken and the same value is returned.
	 * @returns {*} The value that a callback has returned (if truthy). Otherwise nothing.
	 */
	utils.forEach = function(collection, callback) {
	    for(var i = 0; i < collection.length; i++) {
	        var result = callback(collection[i]);
	        if(result) {
	            return result;
	        }
	    }
	};


/***/ },
/* 446 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 447 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var reactIs = __webpack_require__(211);
	
	/**
	 * Copyright 2015, Yahoo! Inc.
	 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
	 */
	var REACT_STATICS = {
	  childContextTypes: true,
	  contextType: true,
	  contextTypes: true,
	  defaultProps: true,
	  displayName: true,
	  getDefaultProps: true,
	  getDerivedStateFromError: true,
	  getDerivedStateFromProps: true,
	  mixins: true,
	  propTypes: true,
	  type: true
	};
	var KNOWN_STATICS = {
	  name: true,
	  length: true,
	  prototype: true,
	  caller: true,
	  callee: true,
	  arguments: true,
	  arity: true
	};
	var FORWARD_REF_STATICS = {
	  '$$typeof': true,
	  render: true,
	  defaultProps: true,
	  displayName: true,
	  propTypes: true
	};
	var MEMO_STATICS = {
	  '$$typeof': true,
	  compare: true,
	  defaultProps: true,
	  displayName: true,
	  propTypes: true,
	  type: true
	};
	var TYPE_STATICS = {};
	TYPE_STATICS[reactIs.ForwardRef] = FORWARD_REF_STATICS;
	TYPE_STATICS[reactIs.Memo] = MEMO_STATICS;
	
	function getStatics(component) {
	  // React v16.11 and below
	  if (reactIs.isMemo(component)) {
	    return MEMO_STATICS;
	  } // React v16.12 and above
	
	
	  return TYPE_STATICS[component['$$typeof']] || REACT_STATICS;
	}
	
	var defineProperty = Object.defineProperty;
	var getOwnPropertyNames = Object.getOwnPropertyNames;
	var getOwnPropertySymbols = Object.getOwnPropertySymbols;
	var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
	var getPrototypeOf = Object.getPrototypeOf;
	var objectPrototype = Object.prototype;
	function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
	  if (typeof sourceComponent !== 'string') {
	    // don't hoist over string (html) components
	    if (objectPrototype) {
	      var inheritedComponent = getPrototypeOf(sourceComponent);
	
	      if (inheritedComponent && inheritedComponent !== objectPrototype) {
	        hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
	      }
	    }
	
	    var keys = getOwnPropertyNames(sourceComponent);
	
	    if (getOwnPropertySymbols) {
	      keys = keys.concat(getOwnPropertySymbols(sourceComponent));
	    }
	
	    var targetStatics = getStatics(targetComponent);
	    var sourceStatics = getStatics(sourceComponent);
	
	    for (var i = 0; i < keys.length; ++i) {
	      var key = keys[i];
	
	      if (!KNOWN_STATICS[key] && !(blacklist && blacklist[key]) && !(sourceStatics && sourceStatics[key]) && !(targetStatics && targetStatics[key])) {
	        var descriptor = getOwnPropertyDescriptor(sourceComponent, key);
	
	        try {
	          // Avoid failures from read-only properties
	          defineProperty(targetComponent, key, descriptor);
	        } catch (e) {}
	      }
	    }
	  }
	
	  return targetComponent;
	}
	
	module.exports = hoistNonReactStatics;


/***/ },
/* 448 */,
/* 449 */,
/* 450 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Auditor = exports.fieldNamesNotUnique = exports.fieldsWithoutNames = exports.fieldsWithoutLabels = exports.getFieldIsFirstInSection = exports.getFieldsInOrder = exports.buildEntityMap = exports.getEntityType = exports.LOG_GROUPS = exports.SEVERITIES = undefined;
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _shortid = __webpack_require__(22);
	
	var _shortid2 = _interopRequireDefault(_shortid);
	
	var _WizardActions = __webpack_require__(36);
	
	var _utilities = __webpack_require__(8);
	
	var _orderBy = __webpack_require__(103);
	
	var _orderBy2 = _interopRequireDefault(_orderBy);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	var CATEGORIES = {
	  accessibility: 'Accessibility',
	  dataSafety: 'Data Safety'
	};
	
	var SEVERITIES = exports.SEVERITIES = {
	  critical: { id: 6, label: 'Critical', name: 'critical' },
	  moderate: { id: 5, label: 'Moderate', name: 'moderate' },
	  warning: { id: 4, label: 'Warning', name: 'warning' },
	  info: { id: 3, label: 'Informational', name: 'info' }
	};
	
	var LOG_GROUPS = exports.LOG_GROUPS = {
	  0: {
	    label: 'Accessibility'
	  },
	  1: {
	    label: 'Field name is not unique'
	  }
	};
	
	var SCREEN_READER_HINT = 'This will make the field difficult for screen reader users to understand.';
	
	var SAVED_FILING_HINT = 'or their values will not be preserved when saving a filing.';
	var RECONNECT_NODES_HINT = 'Reconnect or delete these nodes or this logic will not operate.';
	
	var MESSAGES = {
	  fieldLabelMissing: SCREEN_READER_HINT + ' With a few exceptions, fields should always have a label even if it isn\'t shown to the user.',
	  fieldLabelMissingInFirstField: 'It looks like you may be trying to use a section title as the label for this field.',
	  fieldNameMissing: 'Fields must have a unique database field name ' + SAVED_FILING_HINT,
	  fieldNameNotUnique: 'Field names must be unique or their values will not be preserved when saving a filing.',
	  fieldNameNotUniqueWithConditions: 'This field shares a field name with another field(s). Ensure that the logic governing these fields never allows them to display in the Wizard at the same time, even on different steps, ' + SAVED_FILING_HINT,
	  fieldDescriptionUsedAsLabel: 'It looks like you may be trying to use a description as the label for this field. ' + SCREEN_READER_HINT,
	  referenceFieldIsDeleted: function referenceFieldIsDeleted(attributeName) {
	    return 'The "' + attributeName + '" attribute references a field that has been deleted or is otherwise invalid. This will not allow the Wizard to load.';
	  },
	  stepTemplateIdNotUnique: 'Step template IDs must be unique or the first template ID found will be used as the template step.',
	  logicReferencesDeletedFields: 'One or more logic nodes reference fields which have been deleted. ' + RECONNECT_NODES_HINT,
	  customRuleReferencesDeletedFields: function customRuleReferencesDeletedFields(label) {
	    return 'One or more logic nodes in the custom business rule, "' + label + '", reference fields which have been deleted. ' + RECONNECT_NODES_HINT;
	  }
	};
	
	var UNLABELED_FIELD_TYPES = ['paragraph', 'repeater', 'UCCSearch'];
	
	var getEntityType = exports.getEntityType = function getEntityType(entity) {
	  if (entity.classType === 'Step') {
	    return 'STEP';
	  }
	  if (entity.type === 'section') {
	    return 'SECTION';
	  }
	  if (entity.parent.type.toUpperCase() === 'REPEATER') {
	    return 'REPEATER';
	  }
	  if (entity.parent.type.toUpperCase() === 'OPTION') {
	    return 'OPTION';
	  }
	  if (entity.parent.type.toUpperCase() === 'CHECKBOX') {
	    return 'CHECKBOX';
	  }
	  if (!!entity.fieldId) {
	    return 'FIELD';
	  }
	  return 'UNHANDLED';
	};
	
	var buildEntityMap = exports.buildEntityMap = function buildEntityMap(entity, state) {
	  var type = getEntityType(entity);
	  var map = void 0;
	  switch (type) {
	    case 'REPEATER':
	    case 'OPTION':
	    case 'CHECKBOX':
	      {
	        var stepId = state.wizard.sections[state.wizard.fields[entity.parent.id].parent.id].stepId;
	        if (!stepId) {
	          stepId = Object.values(state.wizard.steps).find(function (step) {
	            return step.sectionOrder.includes(state.wizard.fields[entity.parent.id].parent.id);
	          }).stepId;
	        }
	        return {
	          type: type,
	          parentFieldId: entity.parent.id,
	          fieldId: entity.fieldId,
	          sectionId: state.wizard.fields[entity.parent.id].parent.id,
	          stepId: stepId
	        };
	      }
	    case 'FIELD':
	      map = {
	        type: type,
	        fieldId: entity.fieldId,
	        sectionId: entity.parent.id,
	        stepId: state.wizard.sections[entity.parent.id].stepId
	      };
	      if (!map.stepId) {
	        map.stepId = state.wizard.stepOrder.find(function (stepId) {
	          return state.wizard.steps[stepId].sectionOrder.includes(entity.parent.id);
	        });
	      }
	      return map;
	    case 'SECTION':
	      return {
	        type: type,
	        sectionId: entity.sectionId,
	        stepId: entity.stepId
	      };
	    case 'STEP':
	      return {
	        type: type,
	        stepId: entity.stepId
	      };
	    default:
	      return {};
	  }
	};
	
	var getFieldsInOrder = exports.getFieldsInOrder = function getFieldsInOrder(_ref) {
	  var steps = _ref.steps,
	      stepOrder = _ref.stepOrder,
	      sections = _ref.sections,
	      fields = _ref.fields;
	  return stepOrder.flatMap(function (stepId) {
	    return steps[stepId].sectionOrder.flatMap(function (sectionId) {
	      return sections[sectionId].fieldOrder.flatMap(function (fieldId) {
	        return fields[fieldId];
	      });
	    });
	  });
	};
	
	var getFieldIsFirstInSection = exports.getFieldIsFirstInSection = function getFieldIsFirstInSection(_ref2) {
	  var field = _ref2.field,
	      sections = _ref2.sections;
	
	  if (field.parent.type.toUpperCase() !== 'SECTION') return false;
	  return sections[field.parent.id].fieldOrder[0] === field.fieldId;
	};
	
	var fieldsWithoutLabels = exports.fieldsWithoutLabels = function fieldsWithoutLabels(_ref3, Logger) {
	  var allFields = _ref3.allFields,
	      sections = _ref3.wizard.sections;
	
	  allFields.forEach(function (field) {
	    if (!field.label && !UNLABELED_FIELD_TYPES.includes(field.type)) {
	      var fieldIsFirstInSection = getFieldIsFirstInSection({ field: field, sections: sections });
	      var warning = {
	        title: 'Field has no label or description',
	        category: CATEGORIES.accessibility,
	        severity: SEVERITIES.warning,
	        entity: field
	      };
	      if (field.description) {
	        warning.title = 'Description used as field label';
	        warning.message = MESSAGES.fieldDescriptionUsedAsLabel;
	      } else if (fieldIsFirstInSection) {
	        warning.title = 'Section title used as field label';
	        warning.message = MESSAGES.fieldLabelMissingInFirstField + ' ' + MESSAGES.fieldLabelMissing;
	      } else {
	        warning.message = MESSAGES.fieldLabelMissing;
	        warning.severity = SEVERITIES.critical;
	      }
	      Logger.log(warning);
	    }
	  });
	};
	
	var fieldsWithoutNames = exports.fieldsWithoutNames = function fieldsWithoutNames(_ref4, Logger) {
	  var allFields = _ref4.allFields;
	
	  allFields.forEach(function (field) {
	    if (field.name === '') {
	      Logger.log({
	        title: 'Field has no database field name',
	        category: CATEGORIES.dataSafety,
	        severity: SEVERITIES.critical,
	        entity: field,
	        message: MESSAGES.fieldNameMissing
	      });
	    }
	  });
	};
	
	var hasNonMutuallyExclusiveConditions = function hasNonMutuallyExclusiveConditions(field1, field2) {
	  var field1ConditionParents = field1.conditions.map(function (c) {
	    return c.parentId;
	  });
	  var field2ConditionParents = field2.conditions.map(function (c) {
	    return c.parentId;
	  });
	
	  var sharesAllConditionParents = (field1.conditionsOperator === 'or' ? field1.conditions.every(function (c1) {
	    return field2ConditionParents.includes(c1.parentId);
	  }) : true) && (field2.conditionsOperator === 'or' ? field2.conditions.every(function (c2) {
	    return field1ConditionParents.includes(c2.parentId);
	  }) : true);
	
	  if (!sharesAllConditionParents) {
	    return true;
	  }
	
	  var allMutuallyExclusive = true;
	
	  for (var i = 0; i < field1.conditions.length; i++) {
	    for (var k = 0; k < field2.conditions.length; k++) {
	      var c1 = field1.conditions[i];
	      var c2 = field2.conditions[k];
	      if (c1.parentId === c2.parentId) {
	        // Depends on the same field
	        if (c1.value === c2.value && (field1.conditionsOperator === 'or' || field2.conditionsOperator === 'or')) {
	          allMutuallyExclusive = false;
	        }
	      }
	    }
	  }
	  return !allMutuallyExclusive;
	};
	
	var fieldNamesNotUnique = exports.fieldNamesNotUnique = function fieldNamesNotUnique(_ref5, Logger) {
	  var allFields = _ref5.allFields,
	      _ref5$wizard = _ref5.wizard,
	      fields = _ref5$wizard.fields,
	      mode = _ref5$wizard.mode;
	
	  var fieldNameMap = (0, _WizardActions.buildFieldNameMap)(allFields.map(function (f) {
	    return f.fieldId;
	  }), fields);
	
	  allFields.forEach(function (field) {
	    if (fieldNameMap[field.name] > 1 && !field.disabled && field.active && !(mode !== 'amendment' && field.type === 'paragraph')) {
	      var otherFieldsWithName = Object.values(fields).filter(function (f) {
	        if (f.name === field.name && !f.disabled && f.active && !(mode !== 'amendment' && f.type === 'paragraph')) {
	          if (f.fieldId === field.fieldId) return false;
	          if (field.parent.type === 'REPEATER') {
	            if (f.parent.type === 'REPEATER') {
	              return f.parent.id === field.parent.id;
	            }
	            return true;
	          } else {
	            var bothFieldsHaveCondtions = field.conditions && f.conditions;
	            if (bothFieldsHaveCondtions) {
	              return hasNonMutuallyExclusiveConditions(field, f);
	            } else {
	              return true;
	            }
	          }
	        }
	        return false;
	      });
	      if (otherFieldsWithName.length > 0) {
	        var log = {
	          title: 'Field name is not unique',
	          category: CATEGORIES.dataSafety,
	          entity: field
	        };
	        var fieldsWithName = [field].concat(_toConsumableArray(otherFieldsWithName));
	
	        var numFieldsWithLogicOrConditions = fieldsWithName.filter(function (f) {
	          return f.conditions && f.conditions.length > 0 || Object.keys(f.logicNodes).length > 1;
	        }).length;
	
	        if (numFieldsWithLogicOrConditions >= fieldsWithName.length - 1) {
	          log.severity = SEVERITIES.warning;
	          log.message = MESSAGES.fieldNameNotUniqueWithConditions;
	        } else {
	          log.severity = SEVERITIES.critical;
	          log.message = MESSAGES.fieldNameNotUnique;
	        }
	        Logger.log(log);
	      }
	    }
	  });
	};
	
	var templateIdsNotUnique = function templateIdsNotUnique(_ref6, Logger) {
	  var steps = _ref6.wizard.steps;
	
	  var stepsArray = Object.values(steps);
	
	  stepsArray.forEach(function (step) {
	    var templateIdIsNotUnique = step.templateId !== '' && stepsArray.some(function (s) {
	      return s.stepId !== step.stepId && s.templateId === step.templateId;
	    });
	    if (templateIdIsNotUnique) {
	      Logger.log({
	        title: 'Step template ID is not unique',
	        category: CATEGORIES.dataSafety,
	        severity: SEVERITIES.critical,
	        message: MESSAGES.stepTemplateIdNotUnique,
	        entity: step
	      });
	    }
	  });
	};
	
	var serverSelectOverridesExist = function serverSelectOverridesExist(_ref7, Logger) {
	  var fields = _ref7.wizard.fields;
	
	  var serverControls = (0, _utilities.getFieldsByType)('serverSelect', fields);
	
	  if (serverControls) {
	    serverControls.forEach(function (field) {
	      if (field.optionsSrcOverride) {
	        if (!fields[field.optionsSrcOverride]) {
	          Logger.log({
	            title: 'Options source override is not valid',
	            category: CATEGORIES.dataSafety,
	            severity: SEVERITIES.critical,
	            message: MESSAGES.referenceFieldIsDeleted('Override options source with this field'),
	            entity: field
	          });
	        }
	      }
	      if (field.subOptionsSrcOverride) {
	        if (!fields[field.subOptionsSrcOverride]) {
	          Logger.log({
	            title: 'Sub-options source override is not valid',
	            category: CATEGORIES.dataSafety,
	            severity: SEVERITIES.critical,
	            message: MESSAGES.referenceFieldIsDeleted('Override sub-options source with this field'),
	            entity: field
	          });
	        }
	      }
	    });
	  }
	};
	
	var fieldIdFlumeKeys = ['fieldId', 'optionFieldId', 'checkboxFieldId', 'textboxFieldId', 'uploadAndSubmitFieldId', 'uploadFieldId', 'dateFieldId', 'entityNameFieldId', 'nameQualifiedOrgFieldId', 'repeaterFieldId', 'formationLocaleFieldId'];
	
	var getFieldIdsFromNodeData = function getFieldIdsFromNodeData(data) {
	  var fieldIds = [];
	  Object.entries(data).forEach(function (_ref8) {
	    var _ref9 = _slicedToArray(_ref8, 2),
	        key = _ref9[0],
	        value = _ref9[1];
	
	    if (fieldIdFlumeKeys.includes(key)) {
	      fieldIds.push(value[key]);
	    }
	  });
	  return fieldIds;
	};
	
	var nodesWithStaleFieldIds = function nodesWithStaleFieldIds(_ref10, Logger) {
	  var allFields = _ref10.allFields,
	      fields = _ref10.wizard.fields;
	
	  allFields.forEach(function (field) {
	    Object.values(field.logicNodes).forEach(function (node) {
	      var fieldIds = getFieldIdsFromNodeData(node.inputData);
	      var hasMissingFieldIds = !!fieldIds.find(function (fieldId) {
	        return !fields[fieldId];
	      });
	      if (hasMissingFieldIds) {
	        Logger.log({
	          title: 'Logic references deleted fields',
	          category: CATEGORIES.dataSafety,
	          message: MESSAGES.logicReferencesDeletedFields,
	          severity: SEVERITIES.critical,
	          entity: field
	        });
	      }
	    });
	    field.businessRules.forEach(function (rule) {
	      if (rule.fn === 'customBusinessRules') {
	        rule.props.rules.forEach(function (rule) {
	          var fieldIds = Object.values(rule.logicNodes).flatMap(function (node) {
	            return getFieldIdsFromNodeData(node.inputData);
	          });
	          var hasMissingFieldIds = !!fieldIds.find(function (fieldId) {
	            return !fields[fieldId];
	          });
	          if (hasMissingFieldIds) {
	            Logger.log({
	              title: 'Custom business rules reference deleted fields',
	              category: CATEGORIES.dataSafety,
	              message: MESSAGES.customRuleReferencesDeletedFields(rule.label),
	              severity: SEVERITIES.critical,
	              entity: field
	            });
	          }
	        });
	      }
	    });
	  });
	};
	
	var Auditor = exports.Auditor = function Auditor(designer) {
	  var _this = this;
	
	  _classCallCheck(this, Auditor);
	
	  this.log = function (_ref11) {
	    var title = _ref11.title,
	        message = _ref11.message,
	        category = _ref11.category,
	        severity = _ref11.severity,
	        entity = _ref11.entity;
	
	    _this.logs.push({
	      id: _shortid2.default.generate(),
	      title: title,
	      message: message,
	      category: category,
	      severity: severity.id,
	      entityMap: buildEntityMap(entity, _this.state)
	    });
	  };
	
	  this.collect = function (func) {
	    func(_this.state, { log: _this.log });
	  };
	
	  this.startAudit = function () {
	    _this.collect(fieldsWithoutLabels);
	    _this.collect(fieldsWithoutNames);
	    _this.collect(fieldNamesNotUnique);
	    _this.collect(serverSelectOverridesExist);
	    _this.collect(templateIdsNotUnique);
	    _this.collect(nodesWithStaleFieldIds);
	    _this.logs = (0, _orderBy2.default)(_this.logs, 'severity', ['desc']);
	  };
	
	  var _designer$wizard = designer.wizard,
	      stepOrder = _designer$wizard.stepOrder,
	      steps = _designer$wizard.steps,
	      sections = _designer$wizard.sections,
	      fields = _designer$wizard.fields;
	
	  this.state = {
	    designer: designer,
	    wizard: designer.wizard,
	    orderedFields: getFieldsInOrder({ stepOrder: stepOrder, steps: steps, sections: sections, fields: fields }),
	    allFields: Object.values(fields)
	  };
	  this.logs = [];
	};

/***/ },
/* 451 */,
/* 452 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.allowedMergeFieldTypes = exports.MarkdownHint = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(7);
	
	var _Modal = __webpack_require__(13);
	
	var _requests = __webpack_require__(6);
	
	var _Portal = __webpack_require__(12);
	
	var _Portal2 = _interopRequireDefault(_Portal);
	
	var _Markdown = __webpack_require__(24);
	
	var _Markdown2 = _interopRequireDefault(_Markdown);
	
	var _propTypes = __webpack_require__(20);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var TextEditor = function (_Component) {
	  _inherits(TextEditor, _Component);
	
	  function TextEditor(props) {
	    _classCallCheck(this, TextEditor);
	
	    var _this = _possibleConstructorReturn(this, (TextEditor.__proto__ || Object.getPrototypeOf(TextEditor)).call(this));
	
	    _this.caretStart = 0;
	    _this.caretEnd = 0;
	
	    _this.componentWillReceiveProps = function (nextProps) {
	      if (_this.props.text !== nextProps.text) {
	        _this.setState({ text: nextProps.text });
	      }
	    };
	
	    _this.toggleModal = function () {
	      _this.setState({ modalOpen: !_this.state.modalOpen });
	    };
	
	    _this.handleChange = function (e) {
	      _this.setState({ text: e.target.value });
	    };
	
	    _this.save = function () {
	      _this.props.onSave(_this.props.name, _this.state.text);
	    };
	
	    _this.cancel = function () {
	      _this.setState({ text: _this.props.text });
	    };
	
	    _this.openMergeModal = function () {
	      _this.fetchMergeCodes();
	      _this.setState({
	        mergeModalOpen: true,
	        cursorPosition: _this.textarea.selectionEnd
	      });
	    };
	
	    _this.closeMergeModal = function () {
	      _this.setState({ mergeModalOpen: false });
	    };
	
	    _this.insertMergeCode = function (code) {
	      _this.mergeModal.closeModal();
	      _this.setState(function (state) {
	        return {
	          text: state.text.slice(0, state.cursorPosition) + '{{' + code + '}}' + state.text.slice(state.cursorPosition)
	        };
	      });
	    };
	
	    _this.fetchMergeCodes = function () {
	      if (!_this.state.mergeCodes) {
	        (0, _requests.GET_ALL_MERGE_CODES)(function (mergeCodes) {
	          // console.log(mergeCodes);
	          _this.setState({ mergeCodes: mergeCodes });
	        });
	      }
	    };
	
	    _this.cacheSelection = function (e) {
	      _this.caretStart = e.target.selectionStart;
	      _this.caretEnd = e.target.selectionEnd;
	    };
	
	    _this.indentLine = function () {
	      var text = _this.state.text;
	      var firstReturn = text.slice(0, _this.caretStart).lastIndexOf('\n');
	      if (firstReturn < 0) firstReturn = 0;
	      var returnIndicies = Array.from(text.slice(_this.caretStart, _this.caretEnd).matchAll(/\n/g)).map(function (group) {
	        return group.index + _this.caretStart;
	      });
	      returnIndicies.unshift(firstReturn);
	      returnIndicies.unshift(0);
	      var parts = returnIndicies.map(function (index, i) {
	        var nextIndex = returnIndicies[i + 1] !== undefined ? returnIndicies[i + 1] : text.length - 1;
	        if (index === nextIndex) {
	          return '';
	        } else {
	          return text.slice(index === 0 ? 0 : index + 1, nextIndex + 1);
	        }
	      });
	      var indentedText = parts.join('\t\t');
	      _this.setState({
	        text: indentedText
	      });
	    };
	
	    _this.state = {
	      modalOpen: false,
	      text: props.text,
	      mergeModalOpen: false,
	      cursorPosition: 0,
	      mergeCodes: false
	    };
	    return _this;
	  }
	
	  _createClass(TextEditor, [{
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _props = this.props,
	          buttonLabel = _props.buttonLabel,
	          placeholder = _props.placeholder,
	          allowMergeCodes = _props.allowMergeCodes;
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'block-wrapper' },
	        _react2.default.createElement(
	          'button',
	          { className: 'attribute-button', onClick: this.toggleModal },
	          buttonLabel
	        ),
	        _react2.default.createElement(
	          _Portal2.default,
	          { isOpened: this.state.modalOpen },
	          _react2.default.createElement(
	            _Modal.Modal,
	            {
	              title: buttonLabel,
	              closeModal: this.toggleModal,
	              modalSize: 'large',
	              saveAndCloseButton: true,
	              cancelButton: true,
	              save: this.save,
	              cancel: this.cancel
	            },
	            _react2.default.createElement(
	              'div',
	              { className: 'text-editor-wrapper' },
	              _react2.default.createElement(
	                'div',
	                { className: 'left-wrapper merge-codes' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'toolbar' },
	                  _react2.default.createElement(
	                    'button',
	                    { className: 'btn btn-primary', onClick: this.indentLine },
	                    'Indent'
	                  ),
	                  allowMergeCodes && _react2.default.createElement(
	                    'button',
	                    { className: 'btn btn-primary', onClick: this.openMergeModal },
	                    'Insert Merge Code'
	                  )
	                ),
	                _react2.default.createElement('textarea', {
	                  ref: function ref(r) {
	                    _this2.textarea = r;
	                  },
	                  className: 'text-editor',
	                  value: this.state.text,
	                  onChange: this.handleChange,
	                  onSelect: this.cacheSelection,
	                  placeholder: placeholder
	                }),
	                _react2.default.createElement(MarkdownHint, null)
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'right-wrapper' },
	                _react2.default.createElement(_Markdown2.default, { source: this.state.text, className: 'markdown' })
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(
	          _Portal2.default,
	          { isOpened: this.state.mergeModalOpen && this.state.mergeCodes ? true : false },
	          _react2.default.createElement(
	            _Modal.Modal,
	            {
	              title: 'Insert Merge Code',
	              ref: function ref(r) {
	                _this2.mergeModal = r;
	              },
	              closeModal: this.closeMergeModal,
	              modalSize: 'small',
	              autoHeight: true,
	              closeButton: true
	            },
	            _react2.default.createElement(MergeCodeList, { mergeCodes: this.state.mergeCodes, onSelection: this.insertMergeCode })
	          )
	        )
	      );
	    }
	  }]);
	
	  return TextEditor;
	}(_react.Component);
	
	TextEditor.propTypes = {
	  text: _propTypes2.default.string,
	  name: _propTypes2.default.string,
	  buttonLabel: _propTypes2.default.node,
	  placeholder: _propTypes2.default.string,
	  allowMergeCodes: _propTypes2.default.bool,
	  save: _propTypes2.default.func
	};
	exports.default = TextEditor;
	var MarkdownHint = exports.MarkdownHint = function MarkdownHint() {
	  return _react2.default.createElement(
	    'div',
	    { className: 'hint' },
	    _react2.default.createElement(
	      'span',
	      null,
	      '_',
	      _react2.default.createElement(
	        'i',
	        null,
	        'italic'
	      ),
	      '_'
	    ),
	    _react2.default.createElement(
	      'span',
	      null,
	      '**',
	      _react2.default.createElement(
	        'b',
	        null,
	        'bold'
	      ),
	      '**'
	    ),
	    _react2.default.createElement(
	      'span',
	      null,
	      '# Heading'
	    ),
	    _react2.default.createElement(
	      'span',
	      null,
	      '- List'
	    ),
	    _react2.default.createElement(
	      'span',
	      null,
	      '1. Ordered List'
	    ),
	    _react2.default.createElement(
	      'span',
	      null,
	      '[Link Text](URL)'
	    ),
	    _react2.default.createElement(
	      'span',
	      null,
	      '[',
	      '>>>',
	      'Redirect Link](URL)'
	    ),
	    _react2.default.createElement(
	      'span',
	      null,
	      '>',
	      ' Blockquote'
	    ),
	    _react2.default.createElement(
	      'span',
	      null,
	      '--- horizontal rule'
	    ),
	    _react2.default.createElement(
	      'a',
	      { href: 'http://commonmark.org/help/', target: '_blank' },
	      '...More'
	    )
	  );
	};
	
	var allowedMergeFieldTypes = exports.allowedMergeFieldTypes = ['text', 'textArea', 'checkbox', 'date', 'DateRange', 'radio', 'select', 'confirmFields', 'FullName', 'NameOrg', 'dependentRadio', 'dependentSelect', 'LocalSelect', 'dependentCheck', 'serverSelect', 'serverRadio', 'paragraph', 'FormationLocale', 'MultiComplete', 'ServerMultiComplete', 'EFSCropPicker'];
	
	var MergeCodeList = function (_React$Component) {
	  _inherits(MergeCodeList, _React$Component);
	
	  function MergeCodeList() {
	    _classCallCheck(this, MergeCodeList);
	
	    return _possibleConstructorReturn(this, (MergeCodeList.__proto__ || Object.getPrototypeOf(MergeCodeList)).apply(this, arguments));
	  }
	
	  _createClass(MergeCodeList, [{
	    key: 'render',
	    value: function render() {
	      var _props2 = this.props,
	          _props2$mergeCodes = _props2.mergeCodes,
	          mergeCodes = _props2$mergeCodes === undefined ? [] : _props2$mergeCodes,
	          onSelection = _props2.onSelection,
	          fields = _props2.fields;
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'merge-code-list' },
	        mergeCodes.map(function (code, i) {
	          return _react2.default.createElement(MergeCode, Object.assign({}, code, { onClick: onSelection, key: i }));
	        }),
	        fields.map(function (field) {
	          return _react2.default.createElement(MergeCode, {
	            CODE: field.name,
	            LABEL: field.label || '[Unlabeled Field]',
	            onClick: function onClick(code) {
	              return onSelection('FIELD:' + code);
	            },
	            key: field.fieldId
	          });
	        })
	      );
	    }
	  }]);
	
	  return MergeCodeList;
	}(_react2.default.Component);
	
	MergeCodeList = (0, _reactRedux.connect)(function (state) {
	  var fields = Object.values(state.designer.wizard.fields).filter(function (field) {
	    return allowedMergeFieldTypes.includes(field.type);
	  });
	  return {
	    fields: fields
	  };
	})(MergeCodeList);
	
	var MergeCode = function MergeCode(_ref) {
	  var CODE = _ref.CODE,
	      LABEL = _ref.LABEL,
	      _onClick = _ref.onClick;
	  return _react2.default.createElement(
	    'button',
	    {
	      className: 'merge-code',
	      onClick: function onClick() {
	        _onClick(CODE);
	      }
	    },
	    _react2.default.createElement(
	      'span',
	      { className: 'label' },
	      LABEL
	    ),
	    _react2.default.createElement(
	      'span',
	      { className: 'code' },
	      CODE
	    )
	  );
	};

/***/ },
/* 453 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(7);
	
	var _Modal = __webpack_require__(13);
	
	var _Portal = __webpack_require__(12);
	
	var _Portal2 = _interopRequireDefault(_Portal);
	
	var _MaskEditor = __webpack_require__(1083);
	
	var _MaskEditor2 = _interopRequireDefault(_MaskEditor);
	
	var _Attribute = __webpack_require__(290);
	
	var _businessRules = __webpack_require__(198);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ValidationButton = function (_Component) {
	  _inherits(ValidationButton, _Component);
	
	  function ValidationButton() {
	    _classCallCheck(this, ValidationButton);
	
	    var _this = _possibleConstructorReturn(this, (ValidationButton.__proto__ || Object.getPrototypeOf(ValidationButton)).call(this));
	
	    _this.toggleEditor = function () {
	      _this.setState({ modalOpen: !_this.state.modalOpen });
	    };
	
	    _this.saveRules = function () {
	      if (_this.props.maskEditor) {
	        _this.editorRef.current.saveRules();
	      } else {
	        _this.editorRef.current.saveRules();
	      }
	    };
	
	    _this.cancel = function () {
	      if (_this.props.maskEditor) {
	        _this.editorRef.current.clearState();
	      }
	    };
	
	    _this.state = { modalOpen: false };
	    _this.editorRef = _react2.default.createRef();
	    return _this;
	  }
	
	  _createClass(ValidationButton, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          numRules = _props.numRules,
	          handleChange = _props.handleChange,
	          field = _props.field,
	          _props$label = _props.label,
	          label = _props$label === undefined ? 'Edit Business Rules' : _props$label,
	          maskEditor = _props.maskEditor,
	          allRules = _props.allRules,
	          allowedRules = _props.allowedRules,
	          ruleKey = _props.ruleKey,
	          buttonClassName = _props.buttonClassName;
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'block-wrapper' },
	        _react2.default.createElement(
	          'button',
	          {
	            className: 'attribute-button validation-button ' + buttonClassName,
	            onClick: this.toggleEditor
	          },
	          numRules > 0 ? _react2.default.createElement(
	            'span',
	            { className: 'rules-flag' },
	            numRules
	          ) : null,
	          _react2.default.createElement(
	            'span',
	            { className: 'button-text' },
	            label
	          )
	        ),
	        _react2.default.createElement(
	          _Portal2.default,
	          { isOpened: this.state.modalOpen },
	          _react2.default.createElement(
	            _Modal.Modal,
	            {
	              title: label,
	              closeModal: this.toggleEditor,
	              modalSize: 'large',
	              saveAndCloseButton: true,
	              cancelButton: true,
	              save: this.saveRules,
	              cancel: this.cancel
	            },
	            maskEditor ? _react2.default.createElement(_MaskEditor2.default, { ref: this.editorRef, field: field, handleChange: handleChange }) : _react2.default.createElement(ValidationEditor, {
	              ref: this.editorRef,
	              field: field,
	              handleChange: handleChange,
	              allowedRules: allowedRules,
	              allRules: allRules,
	              ruleKey: ruleKey
	            })
	          )
	        )
	      );
	    }
	  }]);
	
	  return ValidationButton;
	}(_react.Component);
	
	exports.default = (0, _reactRedux.connect)(function (state) {
	  return {};
	})(ValidationButton);
	
	var ValidationEditor = function (_Component2) {
	  _inherits(ValidationEditor, _Component2);
	
	  function ValidationEditor(_ref) {
	    var field = _ref.field,
	        ruleKey = _ref.ruleKey,
	        allowedRules = _ref.allowedRules;
	
	    _classCallCheck(this, ValidationEditor);
	
	    var _this2 = _possibleConstructorReturn(this, (ValidationEditor.__proto__ || Object.getPrototypeOf(ValidationEditor)).call(this));
	
	    _this2.addRule = function (oldRule, fn, ruleId) {
	      var props = {};
	      Object.keys(oldRule.props).map(function (key, i) {
	        props[key] = oldRule.props[key].value;
	        return null;
	      });
	      var rule = { fn: fn, ruleId: ruleId, props: props };
	      var rules = [].concat(_toConsumableArray(_this2.state.businessRules), [rule]);
	      _this2.setState({ businessRules: rules, selectedRule: ruleId });
	    };
	
	    _this2.removeRule = function (ruleId) {
	      var rules = [].concat(_toConsumableArray(_this2.state.businessRules));
	      var newRules = [];
	      rules.map(function (rule, i) {
	        if (rule.ruleId !== ruleId) {
	          newRules.push(rule);
	        }
	        return null;
	      });
	      _this2.setState({ businessRules: newRules, selectedRule: null });
	    };
	
	    _this2.loadProps = function (ruleId) {
	      if (_this2.isInArray(ruleId)) {
	        _this2.setState({ selectedRule: ruleId });
	      }
	    };
	
	    _this2.setPropValue = function (name, value) {
	      var rules = [].concat(_toConsumableArray(_this2.state.businessRules));
	      var ruleId = _this2.state.selectedRule;
	      for (var i = 0; i < rules.length; i++) {
	        if (rules[i].ruleId === ruleId) {
	          var props = Object.assign({}, rules[i].props);
	          props[name] = value;
	          rules[i] = Object.assign({}, rules[i], { props: props });
	        }
	      }
	      _this2.setState({ businessRules: rules });
	    };
	
	    _this2.saveRules = function () {
	      _this2.props.handleChange('businessRules', _this2.state.businessRules);
	    };
	
	    _this2.state = {
	      businessRules: ruleKey ? field[ruleKey] : field.businessRules,
	      allowedRules: allowedRules || field.allowedRules,
	      selectedRule: null
	    };
	    return _this2;
	  }
	
	  _createClass(ValidationEditor, [{
	    key: 'isInArray',
	    value: function isInArray(key) {
	      var found = false;
	      this.state.businessRules.map(function (currentRule) {
	        if (key === currentRule.ruleId) {
	          found = true;
	        }
	        return null;
	      });
	      return found;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this3 = this;
	
	      var allRules = this.props.allRules;
	
	      var ALL_RULES = allRules || _businessRules.BUSINESS_RULES;
	      return _react2.default.createElement(
	        'div',
	        { className: 'validation-editor' },
	        _react2.default.createElement(
	          'div',
	          { className: 'row' },
	          _react2.default.createElement(
	            'div',
	            { className: 'col-6 rule-container' },
	            this.state.allowedRules.map(function (key, i) {
	              var rule = ALL_RULES[key];
	              return _react2.default.createElement(BusinessRule, {
	                selected: key === _this3.state.selectedRule,
	                checked: _this3.isInArray(key),
	                addRule: _this3.addRule,
	                removeRule: _this3.removeRule,
	                loadProps: _this3.loadProps,
	                isSubField: _this3.state.isSubField,
	                ruleId: key,
	                name: rule.name,
	                rule: rule,
	                fn: rule.fn,
	                key: i
	              });
	            })
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'attribute-container col-6' },
	            this.state.selectedRule ? Object.keys(ALL_RULES[this.state.selectedRule].props).map(function (key, i) {
	              var template = ALL_RULES[_this3.state.selectedRule].props[key];
	              var prop = _this3.state.businessRules.find(function (rule) {
	                return rule.ruleId === _this3.state.selectedRule;
	              }).props[key];
	              return _react2.default.createElement(_Attribute.Attribute, Object.assign({}, template, {
	                parentField: _this3.props.field,
	                name: key,
	                value: prop,
	                handleChange: _this3.setPropValue,
	                key: i
	              }));
	            }) : null
	          )
	        )
	      );
	    }
	  }]);
	
	  return ValidationEditor;
	}(_react.Component);
	
	ValidationEditor = (0, _reactRedux.connect)(null, null, null, { forwardRef: true })(ValidationEditor);
	
	var BusinessRule = function (_Component3) {
	  _inherits(BusinessRule, _Component3);
	
	  function BusinessRule() {
	    var _ref2;
	
	    var _temp, _this4, _ret;
	
	    _classCallCheck(this, BusinessRule);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this4 = _possibleConstructorReturn(this, (_ref2 = BusinessRule.__proto__ || Object.getPrototypeOf(BusinessRule)).call.apply(_ref2, [this].concat(args))), _this4), _this4.toggleRule = function (e) {
	      if (e.target.checked) {
	        _this4.props.addRule(_this4.props.rule, _this4.props.fn, _this4.props.ruleId);
	      } else {
	        _this4.props.removeRule(_this4.props.ruleId);
	      }
	    }, _this4.loadProps = function () {
	      _this4.props.loadProps(_this4.props.ruleId);
	    }, _temp), _possibleConstructorReturn(_this4, _ret);
	  }
	
	  _createClass(BusinessRule, [{
	    key: 'render',
	    value: function render() {
	      var props = this.props;
	      return _react2.default.createElement(
	        'div',
	        {
	          className: 'rule ' + (props.checked ? 'checked ' : '') + (props.selected ? 'selected ' : ''),
	          onClick: this.loadProps
	        },
	        _react2.default.createElement('input', {
	          type: 'checkbox',
	          disabled: props.rule.deprecated ? props.checked ? false : true : false,
	          checked: props.checked,
	          onChange: props.rule.deprecated ? props.checked ? this.toggleRule : undefined : this.toggleRule
	        }),
	        _react2.default.createElement(
	          'span',
	          { className: 'rule-name' },
	          _react2.default.createElement(
	            'span',
	            null,
	            props.name
	          ),
	          ' ',
	          props.rule.deprecated ? _react2.default.createElement(
	            'span',
	            { className: 'deprecated' },
	            '[deprecated]'
	          ) : null
	        )
	      );
	    }
	  }]);
	
	  return BusinessRule;
	}(_react.Component);

/***/ },
/* 454 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouterDom = __webpack_require__(30);
	
	var _Markdown = __webpack_require__(24);
	
	var _Markdown2 = _interopRequireDefault(_Markdown);
	
	var _Modal = __webpack_require__(13);
	
	var _requests = __webpack_require__(6);
	
	__webpack_require__(1438);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var DetailsList = function (_Component) {
	  _inherits(DetailsList, _Component);
	
	  function DetailsList() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, DetailsList);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = DetailsList.__proto__ || Object.getPrototypeOf(DetailsList)).call.apply(_ref, [this].concat(args))), _this), _this.getDetailByType = function (detail, i) {
	      switch (detail.TYPE) {
	        case 'image':
	          return _react2.default.createElement(DetailImage, { label: detail.LABEL, src: detail.VALUE, key: i });
	        case 'download':
	          return _react2.default.createElement(DetailDownload, {
	            label: detail.LABEL,
	            linklabel: detail.LINKLABEL,
	            src: detail.VALUE,
	            key: i
	          });
	        case 'url':
	          return _react2.default.createElement(DetailUrl, { label: detail.LABEL, linklabel: detail.LINKLABEL, src: detail.VALUE, key: i });
	        case 'markdown':
	          return _react2.default.createElement(DetailMarkdown, { label: detail.LABEL, value: detail.VALUE, key: i });
	        case 'apimodal':
	        case 'modal':
	          return _react2.default.createElement(DetailMarkdownModal, {
	            label: detail.LABEL,
	            linklabel: detail.LINKLABEL,
	            modalTitle: detail.TITLE,
	            modalSize: detail.MODAL_SIZE,
	            modalBody: detail.MODAL_BODY,
	            src: detail.VALUE,
	            key: i
	          });
	        default:
	          return _react2.default.createElement(Detail, { label: detail.LABEL, value: detail.VALUE, alert: detail.ALERT_YN, key: i });
	      }
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(DetailsList, [{
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _props$details = this.props.details,
	          details = _props$details === undefined ? [] : _props$details;
	
	      return _react2.default.createElement(
	        _react.Fragment,
	        null,
	        _react2.default.createElement('hr', { className: 'details-divider' }),
	        _react2.default.createElement(
	          'table',
	          { className: 'details-list container-fluid' },
	          _react2.default.createElement(
	            'tbody',
	            null,
	            details.map(function (detail, i) {
	              return detail.VALUE === null ? null : _this2.getDetailByType(detail, i);
	            })
	          )
	        ),
	        _react2.default.createElement('hr', { className: 'details-divider' })
	      );
	    }
	  }]);
	
	  return DetailsList;
	}(_react.Component);
	
	exports.default = DetailsList;
	
	
	var TableDivider = function TableDivider() {
	  return _react2.default.createElement(
	    'tr',
	    { 'aria-hidden': true },
	    _react2.default.createElement(
	      'td',
	      { colSpan: 2 },
	      _react2.default.createElement('hr', { className: 'details-divider' })
	    )
	  );
	};
	
	var Detail = function Detail(_ref2) {
	  var label = _ref2.label,
	      value = _ref2.value,
	      alert = _ref2.alert,
	      markdown = _ref2.markdown;
	  return _react2.default.createElement(
	    'tr',
	    { className: 'detail ' + (alert ? 'alert' : '') },
	    _react2.default.createElement(
	      'td',
	      { className: 'label' },
	      label
	    ),
	    _react2.default.createElement(
	      'td',
	      { className: 'value' },
	      Array.isArray(value) ? _react2.default.createElement(
	        'ul',
	        null,
	        value.map(function (li, i) {
	          return _react2.default.createElement(
	            'li',
	            { key: i },
	            li
	          );
	        })
	      ) : value
	    )
	  );
	};
	
	var DetailMarkdown = function DetailMarkdown(_ref3) {
	  var label = _ref3.label,
	      value = _ref3.value;
	  return _react2.default.createElement(
	    _react2.default.Fragment,
	    null,
	    _react2.default.createElement(TableDivider, null),
	    label ? _react2.default.createElement(
	      'tr',
	      { className: 'detail' },
	      _react2.default.createElement(
	        'td',
	        { className: 'label full-width', colSpan: '2' },
	        label
	      )
	    ) : null,
	    _react2.default.createElement(
	      'tr',
	      { className: 'detail markdown-cell' },
	      _react2.default.createElement(
	        'td',
	        { className: 'value', colSpan: '2' },
	        _react2.default.createElement(_Markdown2.default, { className: 'markdown', source: value })
	      )
	    ),
	    _react2.default.createElement(TableDivider, null)
	  );
	};
	
	var DetailMarkdownModal = function DetailMarkdownModal(_ref4) {
	  var alert = _ref4.alert,
	      label = _ref4.label,
	      linklabel = _ref4.linklabel,
	      src = _ref4.src,
	      modalTitle = _ref4.modalTitle,
	      modalSize = _ref4.modalSize,
	      modalBody = _ref4.modalBody;
	
	  var _React$useState = _react2.default.useState(false),
	      _React$useState2 = _slicedToArray(_React$useState, 2),
	      isOpen = _React$useState2[0],
	      setIsOpen = _React$useState2[1];
	
	  var _React$useState3 = _react2.default.useState(modalBody),
	      _React$useState4 = _slicedToArray(_React$useState3, 2),
	      modalMarkdown = _React$useState4[0],
	      setModalMarkdown = _React$useState4[1];
	
	  var _React$useState5 = _react2.default.useState(''),
	      _React$useState6 = _slicedToArray(_React$useState5, 2),
	      error = _React$useState6[0],
	      setError = _React$useState6[1];
	
	  var getModalMarkdown = function getModalMarkdown(url) {
	    (0, _requests.GET)(url, function (result) {
	      setModalMarkdown(result);
	      setIsOpen(true);
	      setError('');
	    }, function (error) {
	      setError(error);
	      console.error(error);
	    });
	  };
	
	  var handleOnClick = function handleOnClick() {
	    if (src) {
	      getModalMarkdown(src);
	    } else {
	      setIsOpen(!isOpen);
	    }
	  };
	
	  return _react2.default.createElement(
	    _react2.default.Fragment,
	    null,
	    _react2.default.createElement(
	      'tr',
	      { className: 'detail ' + (alert ? 'alert' : '') },
	      _react2.default.createElement(
	        'td',
	        { className: 'label' },
	        label
	      ),
	      _react2.default.createElement(
	        'td',
	        { className: 'value' },
	        _react2.default.createElement(
	          'button',
	          { className: 'modal-link', onClick: function onClick() {
	              return handleOnClick();
	            } },
	          linklabel
	        ),
	        error !== '' ? _react2.default.createElement(
	          'p',
	          { className: 'error' },
	          'There was an error retrieving the data'
	        ) : null
	      )
	    ),
	    _react2.default.createElement(
	      _Modal.ControlledModal,
	      {
	        isOpen: isOpen,
	        onRequestModalClose: function onRequestModalClose() {
	          return setIsOpen(false);
	        },
	        onModalClosed: function onModalClosed() {
	          return setIsOpen(false);
	        },
	        modalSize: modalSize,
	        title: modalTitle
	      },
	      _react2.default.createElement(
	        'div',
	        { className: 'markdown-modal-wrapper' },
	        _react2.default.createElement(_Markdown2.default, { className: 'markdown', source: modalMarkdown })
	      )
	    )
	  );
	};
	
	var DetailDownload = function DetailDownload(_ref5) {
	  var label = _ref5.label,
	      linklabel = _ref5.linklabel,
	      src = _ref5.src,
	      alert = _ref5.alert;
	  return _react2.default.createElement(
	    'tr',
	    { className: 'detail ' + (alert ? 'alert' : '') },
	    _react2.default.createElement(
	      'td',
	      { className: 'label' },
	      label
	    ),
	    _react2.default.createElement(
	      'td',
	      { className: 'value' },
	      _react2.default.createElement(
	        'a',
	        { href: _requests.BASE_URL + src },
	        linklabel
	      )
	    )
	  );
	};
	
	var DetailUrl = function DetailUrl(_ref6) {
	  var label = _ref6.label,
	      linklabel = _ref6.linklabel,
	      src = _ref6.src,
	      alert = _ref6.alert;
	
	  return _react2.default.createElement(
	    'tr',
	    { className: 'detail ' + (alert ? 'alert' : '') },
	    _react2.default.createElement(
	      'td',
	      { className: 'label' },
	      label
	    ),
	    _react2.default.createElement(
	      'td',
	      { className: 'value' },
	       true ? _react2.default.createElement(
	        'a',
	        { href: _requests.BASE_URL + src },
	        linklabel
	      ) : !src.startsWith('http') ? _react2.default.createElement(
	        _reactRouterDom.Link,
	        { to: src },
	        linklabel
	      ) : _react2.default.createElement(
	        'a',
	        { href: src },
	        linklabel
	      )
	    )
	  );
	};
	
	var DetailImage = function DetailImage(_ref7) {
	  var label = _ref7.label,
	      src = _ref7.src;
	  return _react2.default.createElement(
	    'tr',
	    null,
	    _react2.default.createElement(
	      'td',
	      { colSpan: 2 },
	      _react2.default.createElement('hr', { className: 'details-divider' }),
	      label && _react2.default.createElement(
	        'span',
	        { className: 'image-label' },
	        label
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'image-wrapper' },
	        _react2.default.createElement('img', { className: 'image', src: _requests.BASE_URL + src, alt: label })
	      )
	    )
	  );
	};

/***/ },
/* 455 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _DetailBlock = __webpack_require__(295);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var DetailHeader = function (_React$Component) {
	  _inherits(DetailHeader, _React$Component);
	
	  function DetailHeader() {
	    _classCallCheck(this, DetailHeader);
	
	    return _possibleConstructorReturn(this, (DetailHeader.__proto__ || Object.getPrototypeOf(DetailHeader)).apply(this, arguments));
	  }
	
	  _createClass(DetailHeader, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          name = _props.name,
	          _props$entityType = _props.entityType,
	          entityType = _props$entityType === undefined ? 'Domestic Limited Liability Company' : _props$entityType,
	          status = _props.status,
	          _props$statusColor = _props.statusColor,
	          statusColor = _props$statusColor === undefined ? 'green' : _props$statusColor,
	          systemId = _props.systemId,
	          filingDate = _props.filingDate,
	          filingDateLabel = _props.filingDateLabel,
	          standingBlock = _props.standingBlock,
	          systemIdLabel = _props.systemIdLabel,
	          children = _props.children;
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'row detail-header' },
	        _react2.default.createElement(
	          'div',
	          {
	            className: '' + (standingBlock === false ? 'col' : 'col-lg-10 col-md-9 col-sm-8 first-col')
	          },
	          _react2.default.createElement(
	            'div',
	            { className: 'critical-block' },
	            _react2.default.createElement(
	              'div',
	              { className: 'name-block' },
	              _react2.default.createElement(
	                'h2',
	                { className: 'name' },
	                name
	              ),
	              _react2.default.createElement(
	                'span',
	                { className: 'type' },
	                entityType
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'details-block status-color-' + statusColor },
	              status && _react2.default.createElement(_DetailBlock.Detail, { label: 'Status', value: status }),
	              _react2.default.createElement(_DetailBlock.Detail, { label: systemIdLabel || 'System ID', value: systemId }),
	              filingDate ? _react2.default.createElement(_DetailBlock.Detail, { label: filingDateLabel || 'Initial Filing Date', value: filingDate }) : null,
	              children
	            )
	          )
	        ),
	        standingBlock !== false && _react2.default.createElement(
	          'div',
	          { className: 'col-lg-2 col-md-3 col-sm-4 last-col' },
	          _react2.default.createElement(
	            'div',
	            { className: 'standing-block' },
	            _react2.default.createElement(Standing, { label: 'Standing', standing: 'Good', color: 'green' }),
	            _react2.default.createElement(Standing, { label: 'Standing-RA', standing: 'Delinquent', color: 'red' }),
	            _react2.default.createElement(Standing, { label: 'Other', standing: 'Good', color: 'green' })
	          )
	        )
	      );
	    }
	  }]);
	
	  return DetailHeader;
	}(_react2.default.Component);
	
	exports.default = DetailHeader;
	
	
	var Standing = function Standing(_ref) {
	  var standing = _ref.standing,
	      label = _ref.label,
	      _ref$color = _ref.color,
	      color = _ref$color === undefined ? '' : _ref$color;
	  return _react2.default.createElement(
	    'div',
	    { className: 'standing standing-' + color },
	    _react2.default.createElement(_DetailBlock.Detail, { label: label, value: standing })
	  );
	};

/***/ },
/* 456 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Portal = __webpack_require__(12);
	
	var _Portal2 = _interopRequireDefault(_Portal);
	
	var _reactRedux = __webpack_require__(7);
	
	var _Modal = __webpack_require__(13);
	
	var _DesignerActions = __webpack_require__(44);
	
	var _FormManagerActions = __webpack_require__(196);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// import x2js from 'x2js'
	// const convert = new x2js()
	
	var ImportDialog = function (_Component) {
	  _inherits(ImportDialog, _Component);
	
	  function ImportDialog() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, ImportDialog);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = ImportDialog.__proto__ || Object.getPrototypeOf(ImportDialog)).call.apply(_ref, [this].concat(args))), _this), _this.processUpload = function (e) {
	      var reader = new FileReader();
	      reader.onload = function (e) {
	        var json = JSON.parse(reader.result);
	        //json.METADATA = convert.js2xml(convert.xml2js(json.METADATA).METADATA)
	        json.FORM_DEFINITION_ID = 0;
	        _this.props.saveWizard(json, function (formDefinitionId) {
	          if (_this.props.categoryTarget) {
	            _this.addToCategory(formDefinitionId);
	          } else {
	            _this.modal.closeModal(function () {
	              _this.props.closeAndReload();
	            });
	          }
	        });
	      };
	      reader.readAsText(e.target.files[0]);
	    }, _this.addToCategory = function (formDefinitionId) {
	      _this.props.importToLast({ categoryId: _this.props.categoryTarget, formDefinitionId: parseInt(formDefinitionId, 10) }, function () {
	        _this.modal.closeModal(function () {
	          _this.props.closeAndReload();
	        });
	      });
	    }, _this.modal = null, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(ImportDialog, [{
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var isOpened = this.props.isOpened;
	
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          _Portal2.default,
	          { isOpened: isOpened },
	          _react2.default.createElement(
	            _Modal.Modal,
	            {
	              ref: function ref(_ref2) {
	                return _this2.modal = _ref2;
	              },
	              modalSize: 'toast',
	              title: 'Import Wizards',
	              hideHeader: true,
	              modalBodyClassName: 'import-dialog',
	              closeModal: this.props.closeModal
	            },
	            _react2.default.createElement(
	              'p',
	              null,
	              'Select a previously-exported ',
	              _react2.default.createElement(
	                'b',
	                null,
	                '.json'
	              ),
	              ' file.'
	            ),
	            _react2.default.createElement('input', {
	              type: 'file',
	              name: 'json',
	              id: 'json',
	              accept: 'application/json',
	              className: 'file-input',
	              onChange: this.processUpload
	            }),
	            _react2.default.createElement(
	              'label',
	              { htmlFor: 'json', className: 'file-label btn-raised btn-primary' },
	              'Choose a json file'
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return ImportDialog;
	}(_react.Component);
	
	exports.default = (0, _reactRedux.connect)(null, { saveWizard: _DesignerActions.saveWizard, importToLast: _FormManagerActions.importToLast })(ImportDialog);

/***/ },
/* 457 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.FrequentPayorUserEditorSection = exports.FrequentPayorModal = exports.FrequentPayorCheckoutSection = exports.FrequentPayorDataProvider = exports.useFrequentPayor = undefined;
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	// import TooltipWrapper from '../TooltipWrapper/TooltipWrapper'
	
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(20);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _Modal = __webpack_require__(13);
	
	var _Portal = __webpack_require__(12);
	
	var _Portal2 = _interopRequireDefault(_Portal);
	
	var _reactPropTransition = __webpack_require__(317);
	
	var _reactPropTransition2 = _interopRequireDefault(_reactPropTransition);
	
	var _requests = __webpack_require__(6);
	
	var _Checkout = __webpack_require__(67);
	
	var _plusHeavy = __webpack_require__(128);
	
	var _plusHeavy2 = _interopRequireDefault(_plusHeavy);
	
	var _pencil = __webpack_require__(161);
	
	var _pencil2 = _interopRequireDefault(_pencil);
	
	var _Field = __webpack_require__(25);
	
	var _Form = __webpack_require__(14);
	
	var _validate = __webpack_require__(45);
	
	var _downloadBox = __webpack_require__(127);
	
	var _downloadBox2 = _interopRequireDefault(_downloadBox);
	
	var _FileDownloader = __webpack_require__(147);
	
	var _FileDownloader2 = _interopRequireDefault(_FileDownloader);
	
	var _sub = __webpack_require__(283);
	
	var _sub2 = _interopRequireDefault(_sub);
	
	var _format = __webpack_require__(33);
	
	var _format2 = _interopRequireDefault(_format);
	
	__webpack_require__(1444);
	
	var _Utilities = __webpack_require__(8);
	
	var _AddressBlock = __webpack_require__(102);
	
	var _AddressBlock2 = _interopRequireDefault(_AddressBlock);
	
	var _validate2 = __webpack_require__(45);
	
	var _requests2 = __webpack_require__(6);
	
	var _CheckoutSlider = __webpack_require__(1059);
	
	var _CheckoutSlider2 = _interopRequireDefault(_CheckoutSlider);
	
	var _toggleModalObscuredContext = __webpack_require__(471);
	
	var _toggleModalObscuredContext2 = _interopRequireDefault(_toggleModalObscuredContext);
	
	var _deepEqual = __webpack_require__(65);
	
	var _deepEqual2 = _interopRequireDefault(_deepEqual);
	
	var _store = __webpack_require__(18);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	var useFrequentPayor = exports.useFrequentPayor = function useFrequentPayor() {
	  var _React$useState = _react2.default.useState(),
	      _React$useState2 = _slicedToArray(_React$useState, 2),
	      payor = _React$useState2[0],
	      setPayor = _React$useState2[1];
	
	  _react2.default.useEffect(function () {
	    (0, _requests.GET_CURRENT_USER_FREQUENT_PAYOR_ACCOUNT)(function (payor) {
	      setPayor(Object.assign({}, payor, {
	        payorType: payor.PREPAID_YN && payor.BILLABLE_YN ? 'both' : payor.PREPAID_YN ? 'prepaid' : 'billable',
	        payorLabel: payor.PREPAID_YN && payor.BILLABLE_YN ? 'Payment' : payor.PREPAID_YN ? 'Prepaid' : 'Billable'
	      }));
	    });
	  }, []);
	
	  var setBalance = function setBalance(Balance) {
	    return setPayor(function (payor) {
	      return Object.assign({}, payor, {
	        Balance: Balance
	      });
	    });
	  };
	
	  var setAddress = function setAddress(ADDRESS) {
	    setPayor(function (payor) {
	      return Object.assign({}, payor, {
	        ADDRESS: ADDRESS
	      });
	    });
	  };
	
	  return { payor: payor, loading: payor ? false : true, setBalance: setBalance, setAddress: setAddress };
	};
	
	var FrequentPayorDataProvider = exports.FrequentPayorDataProvider = function FrequentPayorDataProvider(_ref) {
	  var children = _ref.children;
	
	  var payor = useFrequentPayor();
	  return children(payor);
	};
	FrequentPayorDataProvider.propTypes = {
	  children: _propTypes2.default.func.isRequired
	};
	
	var FrequentPayorCheckoutSection = exports.FrequentPayorCheckoutSection = function FrequentPayorCheckoutSection(_ref2) {
	  var disabled = _ref2.disabled,
	      error = _ref2.error,
	      total = _ref2.total,
	      onPaymentRequested = _ref2.onPaymentRequested;
	
	  var _useFrequentPayor = useFrequentPayor(),
	      payorLoading = _useFrequentPayor.loading,
	      payor = _useFrequentPayor.payor;
	
	  return _react2.default.createElement(
	    'div',
	    { className: 'frequent-payor-section' },
	    _react2.default.createElement(
	      'p',
	      { className: 'balance' },
	      'Account Balance:',
	      ' ',
	      payorLoading ? 'loading' : _react2.default.createElement(
	        'strong',
	        null,
	        '$' + payor.Balance.toFixed(2)
	      )
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'flex-row' },
	      _react2.default.createElement(
	        _Checkout.PaymentButton,
	        {
	          disabled: disabled || payorLoading || payor.Balance < total && !payor.BILLABLE_YN,
	          onClick: onPaymentRequested,
	          className: '' + (payorLoading || payor.Balance < total && !payor.BILLABLE_YN ? 'visually-disabled' : ''),
	          style: { paddingRight: 7, paddingLeft: 8 },
	          forceShowError: error
	        },
	        'Pay with ',
	        payorLoading ? 'Prepaid' : payor.payorLabel,
	        ' Account'
	      )
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'flex-row' },
	      _react2.default.createElement(
	        'p',
	        { className: 'funds-hint' },
	        _react2.default.createElement(
	          'span',
	          { className: 'tip', 'aria-hidden': true },
	          'i'
	        ),
	        ' ',
	        'Funds may be added by visiting "My Account".'
	      )
	    )
	  );
	};
	
	var getPrepaidWebcart = function getPrepaidWebcart(amount) {
	  return new Promise(function (resolve, reject) {
	    (0, _requests.GET_FREQUENT_PAYOR_WEBCART_FROM_AMOUNT)(amount, resolve, reject);
	  });
	};
	
	var FrequentPayorModal = exports.FrequentPayorModal = function FrequentPayorModal(_ref3) {
	  var initialIsOpen = _ref3.isOpen,
	      onModalClosed = _ref3.onModalClosed,
	      onRequestModalClose = _ref3.onRequestModalClose,
	      onBalanceChanged = _ref3.onBalanceChanged;
	
	  var _useFrequentPayor2 = useFrequentPayor(),
	      payorLoading = _useFrequentPayor2.loading,
	      payor = _useFrequentPayor2.payor,
	      setBalance = _useFrequentPayor2.setBalance;
	
	  var _React$useState3 = _react2.default.useState(initialIsOpen),
	      _React$useState4 = _slicedToArray(_React$useState3, 2),
	      isOpen = _React$useState4[0],
	      setIsOpen = _React$useState4[1];
	
	  var _React$useState5 = _react2.default.useState(false),
	      _React$useState6 = _slicedToArray(_React$useState5, 2),
	      checkoutOpen = _React$useState6[0],
	      setCheckoutOpen = _React$useState6[1];
	
	  var _React$useState7 = _react2.default.useState(0),
	      _React$useState8 = _slicedToArray(_React$useState7, 2),
	      balanceToUpdate = _React$useState8[0],
	      setBalanceToUpdate = _React$useState8[1];
	
	  var _React$useState9 = _react2.default.useState(null),
	      _React$useState10 = _slicedToArray(_React$useState9, 2),
	      webCart = _React$useState10[0],
	      setWebCart = _React$useState10[1];
	
	  var toggleModalObscured = _react2.default.useContext(_toggleModalObscuredContext2.default);
	  var modal = _react2.default.useRef();
	
	  _react2.default.useEffect(function () {
	    if (initialIsOpen && !isOpen) {
	      setIsOpen(true);
	    } else if (!initialIsOpen && isOpen) {
	      modal.current.closeModal(function () {
	        setIsOpen(false);
	      });
	    }
	  }, [initialIsOpen]);
	
	  return _react2.default.createElement(
	    _react2.default.Fragment,
	    null,
	    _react2.default.createElement(
	      _Portal2.default,
	      { isOpened: isOpen },
	      _react2.default.createElement(
	        _Modal.Modal,
	        {
	          title: 'Add Funds',
	          closeModal: function closeModal() {
	            setIsOpen(false);
	            onModalClosed();
	          },
	          modalSize: 'small',
	          closeButton: true,
	          autoHeight: true,
	          ref: modal
	        },
	        _react2.default.createElement(
	          'div',
	          { className: 'inner-body frequent-payor-modal' },
	          _react2.default.createElement(FrequentPayor, {
	            onAddFundsRequested: function onAddFundsRequested(webCart, newBalance) {
	              onRequestModalClose();
	              setBalanceToUpdate(newBalance);
	              setWebCart(webCart);
	              setCheckoutOpen(true);
	              toggleModalObscured(true);
	            },
	            payorLoading: payorLoading,
	            payor: payor,
	            setBalance: setBalance
	          })
	        )
	      )
	    ),
	    _react2.default.createElement(_CheckoutSlider2.default, {
	      isOpen: checkoutOpen,
	      onRequestClose: function onRequestClose() {
	        return setCheckoutOpen(false);
	      },
	      onTransactionComplete: function onTransactionComplete(closeSlider, refNum) {
	        closeSlider();
	        setBalance(balanceToUpdate);
	        onBalanceChanged(balanceToUpdate);
	        toggleModalObscured(false);
	        onRequestModalClose();
	        _store.history.replace('/receipt?ref=' + (refNum || webCart.REF_NUM));
	      },
	      onCancel: function onCancel() {
	        toggleModalObscured(false);
	      },
	      webCart: webCart,
	      skipCartQuantityUpdate: true
	    })
	  );
	};
	
	var FrequentPayor = function FrequentPayor(_ref4) {
	  var onAddFundsRequested = _ref4.onAddFundsRequested,
	      payor = _ref4.payor,
	      payorLoading = _ref4.payorLoading,
	      setBalance = _ref4.setBalance;
	
	  var _React$useState11 = _react2.default.useState('0'),
	      _React$useState12 = _slicedToArray(_React$useState11, 2),
	      other = _React$useState12[0],
	      setOther = _React$useState12[1];
	
	  var _React$useState13 = _react2.default.useState(false),
	      _React$useState14 = _slicedToArray(_React$useState13, 2),
	      updatingBalance = _React$useState14[0],
	      setUpdatingBalance = _React$useState14[1];
	
	  var _React$useState15 = _react2.default.useState(""),
	      _React$useState16 = _slicedToArray(_React$useState15, 2),
	      errorMessage = _React$useState16[0],
	      setErrorMessage = _React$useState16[1];
	
	  var setOtherAmount = function setOtherAmount(amount) {
	    var sanitizedAmount = _validate.MASK.onlyNumbers(amount, {
	      leadingZerosAllowed: false,
	      allowDecimal: true
	    });
	    var splitAmount = sanitizedAmount.split('.');
	    if (splitAmount.length > 1) {
	      sanitizedAmount = splitAmount[0] + '.' + splitAmount[1].slice(0, 2);
	    }
	    setOther(sanitizedAmount);
	  };
	
	  var addFunds = function addFunds(amount) {
	    var amt = parseFloat(amount, 10);
	    var newBalance = amt + payor.Balance;
	    setUpdatingBalance(true);
	
	    getPrepaidWebcart(amt).then(function (webcart) {
	      onAddFundsRequested(webcart, newBalance);
	      setUpdatingBalance(false);
	    }).catch(function (err) {
	      setUpdatingBalance(false);
	      setErrorMessage(err.message || "Sorry something went wrong while processing your request.");
	      console.error(err);
	    });
	  };
	
	  return _react2.default.createElement(
	    'div',
	    { className: 'flex-column frequent-payor' },
	    _react2.default.createElement(
	      'h2',
	      { className: 'flex-column total-header' },
	      _react2.default.createElement(
	        'span',
	        { className: 'label' },
	        'Current account balance:'
	      ),
	      _react2.default.createElement(
	        _reactPropTransition2.default,
	        {
	          props: { number: payorLoading ? 0 : payor.Balance },
	          duration: 700,
	          easing: 'cubic'
	        },
	        function (props) {
	          return _react2.default.createElement(
	            'span',
	            { className: 'total' },
	            '$',
	            props.number.toFixed(2)
	          );
	        }
	      )
	    ),
	    _react2.default.createElement(
	      'p',
	      { className: 'instructions' },
	      'Select an amount or input a custom amount:'
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'flex-row payment-options' },
	      _react2.default.createElement(PaymentOptionButton, { amount: 10, onClick: addFunds, disabled: updatingBalance }),
	      _react2.default.createElement(PaymentOptionButton, { amount: 50, onClick: addFunds, disabled: updatingBalance }),
	      _react2.default.createElement(PaymentOptionButton, { amount: 100, onClick: addFunds, disabled: updatingBalance }),
	      _react2.default.createElement(PaymentOptionButton, { amount: 500, onClick: addFunds, disabled: updatingBalance }),
	      _react2.default.createElement(PaymentOptionButton, { amount: 1000, onClick: addFunds, disabled: updatingBalance })
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'flex-row wizard center other-wrapper' },
	      _react2.default.createElement(
	        _Field.DumbField,
	        { fieldId: 'other-fpa', label: 'Custom amount (at least $10)', className: 'other-field' },
	        _react2.default.createElement(_Form.TextInput, { fieldId: 'other-fpa', width: '100%', value: other, onChange: setOtherAmount })
	      ),
	      _react2.default.createElement(
	        'button',
	        {
	          disabled: parseFloat(other, 10) < 10 || !other || updatingBalance || other[other.length - 1] === '.',
	          className: 'btn btn-primary btn-raised add-button',
	          onClick: function onClick() {
	            return addFunds(other);
	          }
	        },
	        'Add Funds'
	      )
	    ),
	    _react2.default.createElement(
	      'p',
	      { 'aria-live': 'assertive', className: 'danger-text' },
	      errorMessage
	    )
	  );
	};
	exports.default = FrequentPayor;
	
	
	var PaymentOptionButton = function PaymentOptionButton(_ref5) {
	  var amount = _ref5.amount,
	      _onClick = _ref5.onClick,
	      disabled = _ref5.disabled;
	  return _react2.default.createElement(
	    'button',
	    {
	      className: 'btn btn-primary btn-raised',
	      onClick: function onClick() {
	        return _onClick(amount);
	      },
	      disabled: disabled
	    },
	    '$',
	    amount
	  );
	};
	
	var FrequentPayorUserEditorSection = exports.FrequentPayorUserEditorSection = function FrequentPayorUserEditorSection() {
	  var _useFrequentPayor3 = useFrequentPayor(),
	      payorLoading = _useFrequentPayor3.loading,
	      payor = _useFrequentPayor3.payor,
	      setBalance = _useFrequentPayor3.setBalance,
	      setPayorAddress = _useFrequentPayor3.setAddress;
	
	  var _React$useState17 = _react2.default.useState(false),
	      _React$useState18 = _slicedToArray(_React$useState17, 2),
	      addingFunds = _React$useState18[0],
	      setAddingFunds = _React$useState18[1];
	
	  var _React$useState19 = _react2.default.useState(false),
	      _React$useState20 = _slicedToArray(_React$useState19, 2),
	      selectingStatementDate = _React$useState20[0],
	      setSelectingStatementDate = _React$useState20[1];
	
	  var _React$useState21 = _react2.default.useState(false),
	      _React$useState22 = _slicedToArray(_React$useState21, 2),
	      editingAddress = _React$useState22[0],
	      setEditingAddress = _React$useState22[1];
	
	  var _React$useState23 = _react2.default.useState({}),
	      _React$useState24 = _slicedToArray(_React$useState23, 2),
	      address = _React$useState24[0],
	      setAddress = _React$useState24[1];
	
	  var _React$useState25 = _react2.default.useState(''),
	      _React$useState26 = _slicedToArray(_React$useState25, 2),
	      error = _React$useState26[0],
	      setError = _React$useState26[1];
	
	  _react2.default.useEffect(function () {
	    if (!payorLoading) {
	      setAddress(payor.ADDRESS);
	    }
	  }, [payorLoading]);
	
	  var saveAddress = function saveAddress() {
	    _validate2.VALIDATE.addressIsValid(address, {}, {}, function (isValid, error) {
	      if (isValid === false) {
	        setError(error);
	      } else {
	        var oldAddress = payor.ADDRESS;
	        if (!(0, _deepEqual2.default)(address, oldAddress)) {
	          setPayorAddress(address);
	          (0, _requests2.UPDATE_FREQUENT_PAYOR_ADDRESS)(address, function () {
	            setEditingAddress(false);
	          }, function (err) {
	            setError(err.message);
	            setPayorAddress(oldAddress);
	          });
	        } else {
	          setEditingAddress(false);
	        }
	      }
	    });
	  };
	
	  return _react2.default.createElement(
	    'div',
	    { className: 'flex-column frequent-payor-user-section' },
	    _react2.default.createElement(
	      'h2',
	      null,
	      payorLoading ? 'Prepaid' : payor.payorLabel,
	      ' Account',
	      _react2.default.createElement(
	        'button',
	        {
	          className: 'btn btn-primary btn-raised',
	          onClick: function onClick() {
	            return setSelectingStatementDate(true);
	          }
	        },
	        _react2.default.createElement(_downloadBox2.default, null),
	        ' Download Statements'
	      )
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'flex-row account-details' },
	      _react2.default.createElement(
	        'div',
	        { className: 'flex-column' },
	        _react2.default.createElement(
	          'label',
	          { id: 'fp-acc-name' },
	          'Account Name:'
	        ),
	        _react2.default.createElement(
	          'p',
	          { 'aria-labelledby': 'fp-acc-name', 'aria-busy': payorLoading },
	          _react2.default.createElement(
	            'strong',
	            null,
	            payorLoading ? 'Loading' : payor.Name
	          )
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'flex-column' },
	        _react2.default.createElement(
	          'label',
	          { id: 'fp-acc-num' },
	          'Account Number:'
	        ),
	        _react2.default.createElement(
	          'p',
	          { 'aria-labelledby': 'fp-acc-num', 'aria-busy': payorLoading },
	          _react2.default.createElement(
	            'strong',
	            null,
	            payorLoading ? 'Loading' : payor.Frequent_Payor_Num
	          )
	        )
	      )
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'flex-row address-section' },
	      _react2.default.createElement(
	        'div',
	        { className: 'flex-column fp-acc-address' },
	        _react2.default.createElement(
	          'label',
	          { id: 'fp-acc-address' },
	          'Account Address:\xA0'
	        ),
	        _react2.default.createElement(
	          'p',
	          { 'aria-labelledby': 'fp-acc-address', 'aria-busy': payorLoading },
	          _react2.default.createElement(
	            'strong',
	            null,
	            payorLoading ? 'Loading' : _react2.default.createElement(_Utilities.FormattedAddress, { value: payor.ADDRESS })
	          )
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'flex-row align-center' },
	        _react2.default.createElement(
	          'button',
	          {
	            className: 'btn btn-primary btn-raised',
	            onClick: function onClick() {
	              setAddress(payor.ADDRESS);
	              setError('');
	              setEditingAddress(true);
	            }
	          },
	          _react2.default.createElement(
	            'div',
	            { className: 'center' },
	            _react2.default.createElement(_pencil2.default, { className: 'edit-icon' }),
	            ' Edit Address'
	          )
	        )
	      )
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'flex-row balance-section' },
	      _react2.default.createElement(
	        'div',
	        { className: 'flex-column prepaid-balance' },
	        _react2.default.createElement(
	          'label',
	          { id: 'prepaid-balance-label' },
	          'Account Balance:\xA0'
	        ),
	        _react2.default.createElement(
	          'p',
	          { 'aria-labelledby': 'prepaid-balance-label', 'aria-busy': payorLoading },
	          _react2.default.createElement(
	            'strong',
	            null,
	            payorLoading ? 'Loading' : '$' + payor.Balance.toFixed(2)
	          )
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'flex-row align-center' },
	        _react2.default.createElement(
	          'button',
	          { className: 'btn btn-primary btn-raised', onClick: function onClick() {
	              return setAddingFunds(true);
	            } },
	          _react2.default.createElement(
	            'div',
	            { className: 'center' },
	            _react2.default.createElement(_plusHeavy2.default, null),
	            ' Add Funds'
	          )
	        )
	      )
	    ),
	    _react2.default.createElement(FrequentPayorModal, {
	      isOpen: addingFunds,
	      onRequestModalClose: function onRequestModalClose() {
	        return setAddingFunds(false);
	      },
	      onModalClosed: function onModalClosed() {
	        return setAddingFunds(false);
	      },
	      onBalanceChanged: setBalance
	    }),
	    _react2.default.createElement(
	      _Modal.ControlledModal,
	      {
	        title: 'Prepaid Statements',
	        isOpen: selectingStatementDate,
	        onModalClosed: function onModalClosed() {
	          return setSelectingStatementDate(false);
	        },
	        onRequestModalClose: function onRequestModalClose() {
	          return setSelectingStatementDate(false);
	        }
	      },
	      _react2.default.createElement(
	        'div',
	        { className: 'inner-body' },
	        _react2.default.createElement(StatementSelector, { onDownloadInitiated: function onDownloadInitiated() {
	            return setSelectingStatementDate(false);
	          } })
	      )
	    ),
	    _react2.default.createElement(
	      _Modal.ControlledModal,
	      {
	        title: 'Edit Address',
	        isOpen: editingAddress,
	        onModalClosed: function onModalClosed() {
	          return setEditingAddress(false);
	        },
	        onRequestModalClose: function onRequestModalClose() {
	          return setEditingAddress(false);
	        },
	        closeButton: false,
	        cancelButton: true,
	        saveButton: true,
	        save: saveAddress,
	        noSaveOnClose: true
	      },
	      _react2.default.createElement(
	        'form',
	        { className: 'inner-body wizard' },
	        _react2.default.createElement(
	          _Field.DumbField,
	          { errorMessage: [error] },
	          _react2.default.createElement(_AddressBlock2.default, {
	            isValid: (error || []).length > 0 ? false : null,
	            width: '100%',
	            value: address,
	            onChange: function onChange(value) {
	              return setAddress(value);
	            },
	            showCityStateZip: true,
	            allowSelection: false,
	            singleColSize: 'col-12',
	            triColSizes: {
	              CITY: 'col-5',
	              STATE: 'col-3',
	              ZIP: 'col-4'
	            }
	          })
	        )
	      )
	    )
	  );
	};
	
	var StatementSelector = function StatementSelector(_ref6) {
	  var onDownloadInitiated = _ref6.onDownloadInitiated;
	
	  var options = new Array(12).fill(null).map(function (_, i) {
	    var date = (0, _sub2.default)(new Date(), { months: i + 1 });
	    return {
	      value: (0, _format2.default)(date, 'MM') + '/01/' + (0, _format2.default)(date, 'Y'),
	      label: (0, _format2.default)(date, 'MMMM Y')
	    };
	  });
	
	  var _React$useState27 = _react2.default.useState(''),
	      _React$useState28 = _slicedToArray(_React$useState27, 2),
	      selectedDate = _React$useState28[0],
	      setSelectedDate = _React$useState28[1];
	
	  var _React$useState29 = _react2.default.useState(null),
	      _React$useState30 = _slicedToArray(_React$useState29, 2),
	      blob = _React$useState30[0],
	      setBlob = _React$useState30[1];
	
	  var _React$useState31 = _react2.default.useState(null),
	      _React$useState32 = _slicedToArray(_React$useState31, 2),
	      rawBlob = _React$useState32[0],
	      setRawBlob = _React$useState32[1];
	
	  var _React$useState33 = _react2.default.useState(false),
	      _React$useState34 = _slicedToArray(_React$useState33, 2),
	      downloadOnNextTick = _React$useState34[0],
	      setDownloadOnNextTick = _React$useState34[1];
	
	  var _React$useState35 = _react2.default.useState(null),
	      _React$useState36 = _slicedToArray(_React$useState35, 2),
	      serverError = _React$useState36[0],
	      setServerError = _React$useState36[1];
	
	  var _React$useState37 = _react2.default.useState(false),
	      _React$useState38 = _slicedToArray(_React$useState37, 2),
	      downloading = _React$useState38[0],
	      setDownloading = _React$useState38[1];
	
	  var downloader = _react2.default.useRef();
	
	  _react2.default.useEffect(function () {
	    if (downloadOnNextTick) {
	      downloader.current.download();
	      setDownloadOnNextTick(false);
	    }
	  }, [downloadOnNextTick]);
	
	  var downloadStatement = function downloadStatement(date) {
	    setDownloading(true);
	    (0, _requests.GET_FREQUENT_PAYOR_STATEMENT)(date, function (res) {
	      if (res.ok) {
	        res.blob().then(function (blob) {
	          var blobObject = window.URL.createObjectURL(blob);
	          setBlob(blobObject);
	          setRawBlob(blob);
	          setDownloadOnNextTick(true);
	          setServerError(null);
	          setDownloading(false);
	          onDownloadInitiated();
	        });
	      } else {
	        res.json().then(function (err) {
	          return setServerError(err.message);
	        });
	        setDownloading(false);
	      }
	    });
	  };
	
	  return _react2.default.createElement(
	    'div',
	    { className: 'flex-column' },
	    _react2.default.createElement(
	      'div',
	      { className: 'statement-selector wizard flex-row align-center' },
	      _react2.default.createElement(
	        _Field.DumbField,
	        { label: 'Statement Date', fieldId: 'statement-select' },
	        _react2.default.createElement(_Form.Select, {
	          options: [{ value: '', label: '[Select a statement date]', disabled: true }].concat(_toConsumableArray(options)),
	          value: selectedDate,
	          onChange: function onChange(date) {
	            return setSelectedDate(date);
	          },
	          fieldId: 'statement-select'
	        })
	      ),
	      _react2.default.createElement(
	        'button',
	        {
	          disabled: !selectedDate || downloading,
	          className: 'btn btn-primary btn-raised',
	          onClick: function onClick() {
	            return downloadStatement(selectedDate);
	          }
	        },
	        _react2.default.createElement(_downloadBox2.default, null),
	        ' ',
	        downloading ? 'Downloading' : 'Download'
	      )
	    ),
	    _react2.default.createElement(
	      'p',
	      { className: 'danger-text', role: 'alert', style: { display: serverError ? 'block' : 'none' } },
	      serverError || 'Something went wrong'
	    ),
	    _react2.default.createElement(_FileDownloader2.default, {
	      ref: downloader,
	      href: blob,
	      blob: rawBlob,
	      fileName: 'Account Statement.pdf'
	    })
	  );
	};

/***/ },
/* 458 */,
/* 459 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.pullAndSetReceiptDetails = exports.pullAndSetMyReceipts = exports.selectMyReceiptsRowAndGetDetails = exports.selectMyReceiptRecord = exports.selectMyReceiptsRow = exports.setMyReceiptDetails = exports.setMyReceiptsSelectedReceipt = exports.setFilters = exports.setLastRequestId = exports.setMyReceiptDetailsLoading = exports.setReceiptsLoading = exports.setMyReceiptsDetailErrorMessage = exports.setReceiptsErrorDetails = exports.setMyReceiptDetailsError = exports.setReceiptsError = exports.setMyReceipts = undefined;
	
	var _shortid = __webpack_require__(22);
	
	var _shortid2 = _interopRequireDefault(_shortid);
	
	var _localStorage = __webpack_require__(59);
	
	var _localStorage2 = _interopRequireDefault(_localStorage);
	
	var _requests = __webpack_require__(6);
	
	var api = _interopRequireWildcard(_requests);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var setMyReceipts = exports.setMyReceipts = function setMyReceipts(rows, template) {
	  return {
	    type: 'SET_MY_RECEIPTS',
	    rows: rows,
	    template: template
	  };
	};
	
	var setReceiptsError = exports.setReceiptsError = function setReceiptsError(error) {
	  return { type: 'SET_MY_RECEIPTS_ERROR', error: error };
	};
	
	var setMyReceiptDetailsError = exports.setMyReceiptDetailsError = function setMyReceiptDetailsError(error) {
	  return { type: 'SET_MY_RECEIPT_DETAIL_ERROR', error: error };
	};
	
	var setReceiptsErrorDetails = exports.setReceiptsErrorDetails = function setReceiptsErrorDetails(errorDetail) {
	  return {
	    type: 'SET_MY_RECEIPTS_ERROR_DETAILS',
	    errorDetail: errorDetail
	  };
	};
	
	var setMyReceiptsDetailErrorMessage = exports.setMyReceiptsDetailErrorMessage = function setMyReceiptsDetailErrorMessage(errorDetail) {
	  return {
	    type: 'SET_MY_RECEIPT_DETAIL_ERROR_MESSAGE',
	    errorDetail: errorDetail
	  };
	};
	
	var setReceiptsLoading = exports.setReceiptsLoading = function setReceiptsLoading(loading) {
	  return {
	    type: 'SET_MY_RECEIPTS_LOADING',
	    loading: loading
	  };
	};
	
	var setMyReceiptDetailsLoading = exports.setMyReceiptDetailsLoading = function setMyReceiptDetailsLoading(loading) {
	  return {
	    type: 'SET_MY_RECEIPT_DETAIL_LOADING',
	    loading: loading
	  };
	};
	
	var setLastRequestId = exports.setLastRequestId = function setLastRequestId(reqId) {
	  return {
	    type: '@@mrcpt/SET_REQUEST_ID',
	    reqId: reqId
	  };
	};
	
	var setFilters = exports.setFilters = function setFilters(category, filters) {
	  return function (dispatch, getState) {
	    dispatch({
	      type: '@@mrcpt/SET_FILTERS',
	      category: category,
	      filters: filters
	    });
	    _localStorage2.default.set('MY_RECEIPTS_FILTERS', Object.assign({}, getState().myReceipts.filters, _defineProperty({}, category, filters)));
	  };
	};
	
	var setMyReceiptsSelectedReceipt = exports.setMyReceiptsSelectedReceipt = function setMyReceiptsSelectedReceipt(details) {
	  return {
	    type: 'SET_MY_RECEIPTS_SELECTED_RECEIPT',
	    details: details
	  };
	};
	
	var setMyReceiptDetails = exports.setMyReceiptDetails = function setMyReceiptDetails(details) {
	  return {
	    type: 'SET_MY_RECEIPT_DETAILS',
	    details: details
	  };
	};
	
	var selectMyReceiptsRow = exports.selectMyReceiptsRow = function selectMyReceiptsRow(selected, row) {
	  return {
	    type: 'SELECT_MY_RECEIPTS_ROW',
	    selected: selected,
	    row: row
	  };
	};
	
	var selectMyReceiptRecord = exports.selectMyReceiptRecord = function selectMyReceiptRecord(selected) {
	  return {
	    type: 'SELECT_MY_RECEIPT_RECORD',
	    selected: selected
	  };
	};
	
	var selectMyReceiptsRowAndGetDetails = exports.selectMyReceiptsRowAndGetDetails = function selectMyReceiptsRowAndGetDetails(id, row) {
	  return function (dispatch) {
	    dispatch(selectMyReceiptsRow(id, row));
	  };
	};
	
	var pullAndSetMyReceipts = exports.pullAndSetMyReceipts = function pullAndSetMyReceipts(category) {
	  return function (dispatch, getState) {
	    dispatch(setReceiptsLoading(true));
	    dispatch(setReceiptsError(false));
	    dispatch(setReceiptsErrorDetails({ message: null, code: null }));
	    var parameters = getState().myReceipts.filters.myReceipts || {
	      SEARCH: '',
	      DATE_RANGE: {
	        start: null,
	        end: null
	      },
	      REF_NUM: '',
	      RECEIPT_NUM: '',
	      DESCRIPTION: '',
	      AMOUNT: '',
	      TYPE: ''
	    };
	    var requestId = _shortid2.default.generate();
	    dispatch(setLastRequestId(requestId));
	
	    api.GET_MY_RECEIPTS(requestId, parameters, function (data) {
	      var props = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	      dispatch(setReceiptsLoading(false));
	      dispatch(setMyReceipts(data.rows, data.template));
	    }, function (err) {
	      dispatch(setReceiptsLoading(false));
	      dispatch(setReceiptsError(true));
	      dispatch(setReceiptsErrorDetails({ message: err.Message, code: err.Code }));
	    });
	  };
	};
	
	var pullAndSetReceiptDetails = exports.pullAndSetReceiptDetails = function pullAndSetReceiptDetails(category) {
	  return function (dispatch, getState) {
	    var requestId = _shortid2.default.generate();
	    var parameters = getState();
	    dispatch(setMyReceiptDetails([]));
	    dispatch(setMyReceiptDetailsLoading(true));
	
	    api.GET_MY_RECEIPTS_DETAILS(requestId, parameters.myReceipts.selectedReceipt.RECEIPT_ID, function (data) {
	      var props = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	      dispatch(setMyReceiptDetailsLoading(false));
	      dispatch(setMyReceiptDetails(data));
	    }, function (err) {
	      dispatch(setMyReceiptDetailsLoading(false));
	      dispatch(setMyReceiptDetailsError(true));
	      dispatch(setMyReceiptsDetailErrorMessage({ message: err.Message, code: err.Code }));
	    });
	  };
	};

/***/ },
/* 460 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Loaders = __webpack_require__(16);
	
	var _requests = __webpack_require__(6);
	
	var _store = __webpack_require__(18);
	
	var _Forms = __webpack_require__(296);
	
	var _Markdown = __webpack_require__(24);
	
	var _Markdown2 = _interopRequireDefault(_Markdown);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var AmendmentLauncher = function (_Component) {
	  _inherits(AmendmentLauncher, _Component);
	
	  function AmendmentLauncher() {
	    _classCallCheck(this, AmendmentLauncher);
	
	    var _this = _possibleConstructorReturn(this, (AmendmentLauncher.__proto__ || Object.getPrototypeOf(AmendmentLauncher)).call(this));
	
	    _this.componentDidMount = function () {
	      if (_this.props.getAvailableAmendments) {
	        _this.props.getAvailableAmendments().then(function (amendments) {
	          return _this.setState({ amendments: amendments });
	        });
	      } else {
	        _this.getAvailableAmendments();
	      }
	    };
	
	    _this.getAvailableAmendments = function () {
	      (0, _requests.GET_AVAILABLE_AMENDMENTS)(_this.props.filingNum, _this.props.category, function (amendments) {
	        _this.setState({ amendments: amendments });
	      }, function (err) {
	        console.error(err);
	      });
	    };
	
	    _this.openAmendment = function (FORM_DEFINITION_ID) {
	      if (_this.props.openAmendment) {
	        _this.props.openAmendment(FORM_DEFINITION_ID);
	      } else {
	        _store.history.push("/amend/" + FORM_DEFINITION_ID + "/" + _this.props.filingNum);
	      }
	    };
	
	    _this.state = { amendments: null };
	    return _this;
	  }
	
	  _createClass(AmendmentLauncher, [{
	    key: "render",
	    value: function render() {
	      var _this2 = this;
	
	      return _react2.default.createElement(
	        "div",
	        { className: "amendment-launcher" },
	        this.state.amendments ? _react2.default.createElement(
	          "div",
	          { className: "amendments" },
	          this.state.amendments.length === 0 && _react2.default.createElement(
	            "p",
	            { className: "empty" },
	            "There are no amendments available for this record."
	          ),
	          this.state.amendments.map(function (amd) {
	            return _react2.default.createElement(
	              "button",
	              {
	                className: 'form-block-card',
	                key: "" + amd.AMENDMENT_TYPE_ID + amd.FORM_DEFINITION_ID,
	                disabled: amd.DISABLED || amd.NOT_AVAILABLE_ONLINE_YN,
	                onClick: function onClick() {
	                  return _this2.openAmendment(amd.FORM_DEFINITION_ID);
	                }
	              },
	              _react2.default.createElement(_Forms.DummyFormBlock, { label: amd.TITLE }),
	              _react2.default.createElement(_Markdown2.default, {
	                className: "markdown description",
	                source: amd.DESCR || ""
	              }),
	              (amd.EXPIRATION_DATE || amd.EXPIRATION_MESSAGE) && _react2.default.createElement(_Markdown2.default, {
	                className: "markdown description " + (amd.MESSAGE_COLOR || ""),
	                source: amd.EXPIRATION_MESSAGE
	              })
	            );
	          })
	        ) : _react2.default.createElement(
	          "div",
	          { className: "flex-center" },
	          _react2.default.createElement(_Loaders.Spinner, { className: "page-loader", themeColor: "medium-neutral" })
	        )
	      );
	    }
	  }]);
	
	  return AmendmentLauncher;
	}(_react.Component);
	
	// const FormDefinitionBlock = ({TITLE, DESCR, FORM_DEFINITION_ID, onClick}) => (
	//   <div className='fd-block' onClick={() => {onClick(FORM_DEFINITION_ID)}}>
	//     <div className='image-col'>
	//       <div className='image'>
	//         <div className="img-shade" />
	//         <img src={placeholderImg} alt="icon" />
	//       </div>
	//     </div>
	//     <div className='text'>
	//       <h4>{TITLE}</h4>
	//       <p>{DESCR}</p>
	//     </div>
	//   </div>
	// )
	
	
	exports.default = AmendmentLauncher;

/***/ },
/* 461 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getMyRecordsDescription = exports.invalidateAllCategoryCaches = exports.setLastRequestId = exports.setRecordsErrorDetails = exports.setRecordsError = exports.setRecordsLoading = exports.setFilters = exports.fetchAndSetSelectedOwnershipRecords = exports.setSelectedOwnershipRecords = exports.selectMyRecordsRowAndGetDetails = exports.setRecordDetailsLoading = exports.setMyRecordsResultsMode = exports.setMyRecordsSelectedDetails = exports.selectMyRecordsRow = exports.pullAndSetMyRecords = exports.setMyRecords = exports.setActiveCategory = undefined;
	
	var _requests = __webpack_require__(6);
	
	var api = _interopRequireWildcard(_requests);
	
	var _localStorage = __webpack_require__(59);
	
	var _localStorage2 = _interopRequireDefault(_localStorage);
	
	var _shortid = __webpack_require__(22);
	
	var _shortid2 = _interopRequireDefault(_shortid);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var setActiveCategory = exports.setActiveCategory = function setActiveCategory(category) {
	  return function (dispatch) {
	    dispatch({
	      type: '@@mr/SET_ACTIVE_CATEGORY',
	      category: category
	    });
	    dispatch({
	      type: 'SET_CURRENT_CATEGORY',
	      category: category
	    });
	  };
	};
	
	var setMyRecords = exports.setMyRecords = function setMyRecords(results, category) {
	  return {
	    type: 'SET_MY_RECORDS',
	    results: results,
	    category: category
	  };
	};
	
	var pullAndSetMyRecords = exports.pullAndSetMyRecords = function pullAndSetMyRecords(category) {
	  return function (dispatch, getState) {
	    var loading = getState().queue.loading;
	    if (!loading) {
	      dispatch(setRecordsLoading(true));
	      dispatch(setRecordsError(false));
	      dispatch(setRecordsErrorDetails({ message: null, code: null }));
	      var parameters = getState().myRecords.filters[category] || {};
	      var requestId = _shortid2.default.generate();
	      dispatch(setLastRequestId(requestId));
	      api.GET_MY_RECORDS(category, parameters, requestId, function (data) {
	        var props = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	        if (getState().myRecords.lastRequestId === props.requestId) {
	          dispatch(setMyRecords(data, category));
	          dispatch(setRecordsLoading(false));
	        }
	      }, function (err) {
	        dispatch(setRecordsLoading(false));
	        dispatch(setRecordsError(true));
	        dispatch(setRecordsErrorDetails({ message: err.Message, code: err.Code }));
	      });
	    }
	  };
	};
	
	var selectMyRecordsRow = exports.selectMyRecordsRow = function selectMyRecordsRow(category, selected) {
	  return {
	    type: 'SELECT_MY_RECORDS_ROW',
	    selected: selected,
	    category: category
	  };
	};
	
	var setMyRecordsSelectedDetails = exports.setMyRecordsSelectedDetails = function setMyRecordsSelectedDetails(details) {
	  return {
	    type: 'SET_MY_RECORDS_SELECTED_DETAILS',
	    details: details
	  };
	};
	
	var setMyRecordsResultsMode = exports.setMyRecordsResultsMode = function setMyRecordsResultsMode(mode) {
	  return {
	    type: 'SET_MY_RECORDS_RESULTS_MODE',
	    mode: mode
	  };
	};
	
	var setRecordDetailsLoading = exports.setRecordDetailsLoading = function setRecordDetailsLoading(loading) {
	  return {
	    type: 'SET_RECORD_DETAILS_LOADING',
	    loading: loading
	  };
	};
	
	var selectMyRecordsRowAndGetDetails = exports.selectMyRecordsRowAndGetDetails = function selectMyRecordsRowAndGetDetails(category, id, callback) {
	  return function (dispatch) {
	    dispatch(selectMyRecordsRow(category, id));
	    // if (id !== null) {
	    //   console.log("selectMyRecordsRowAndGetDetails HIT")
	    //  
	    //   api.GET_FILING_DETAILS(
	    //     category,
	    //     id,
	    //     false,
	    //     () => {},
	    //     data => {
	    //       dispatch(setMyRecordsSelectedDetails(data.DRAWER_DETAIL_LIST))
	    //         console.log(store.getState())
	    //       console.log(data)
	    //       console.log(callback)
	    //       if (callback) {
	    //         callback(data)
	    //       }
	    //     }
	    //   )
	    // }
	  };
	};
	
	var setSelectedOwnershipRecords = exports.setSelectedOwnershipRecords = function setSelectedOwnershipRecords(records) {
	  return {
	    type: 'SET_MY_RECORDS_SELECTED_OWNERSHIP_RECORDS',
	    selectedOwnershipRecords: records
	  };
	};
	
	var fetchAndSetSelectedOwnershipRecords = exports.fetchAndSetSelectedOwnershipRecords = function fetchAndSetSelectedOwnershipRecords(sourceTypeId, sourceId, callback) {
	  return function (dispatch) {
	    api.GET_WEB_USER_ACCESS_LIST(sourceTypeId, sourceId, function (records) {
	      dispatch(setSelectedOwnershipRecords(records));
	      if (callback) {
	        callback(records);
	      }
	    });
	  };
	};
	
	var setFilters = exports.setFilters = function setFilters(category, filters) {
	  return function (dispatch, getState) {
	    dispatch({
	      type: '@@mr/SET_FILTERS',
	      category: category,
	      filters: filters
	    });
	    _localStorage2.default.set('MY_RECORDS_FILTERS', Object.assign({}, getState().myRecords.filters, _defineProperty({}, category, filters)));
	  };
	};
	
	var setRecordsLoading = exports.setRecordsLoading = function setRecordsLoading(loading) {
	  return {
	    type: 'SET_MY_RECORDS_LOADING',
	    loading: loading
	  };
	};
	
	var setRecordsError = exports.setRecordsError = function setRecordsError(error) {
	  return {
	    type: 'SET_MY_RECORDS_ERROR',
	    error: error
	  };
	};
	
	var setRecordsErrorDetails = exports.setRecordsErrorDetails = function setRecordsErrorDetails(errorDetails) {
	  return {
	    type: 'SET_MY_RECORDS_ERROR_DETAILS',
	    errorDetails: errorDetails
	  };
	};
	
	var setLastRequestId = exports.setLastRequestId = function setLastRequestId(requestId) {
	  return {
	    type: '@@mr/SET_REQUEST_ID',
	    requestId: requestId
	  };
	};
	
	var invalidateAllCategoryCaches = exports.invalidateAllCategoryCaches = function invalidateAllCategoryCaches() {
	  return function (dispatch) {
	    dispatch({
	      type: '@@mr/INVALIDATE_CACHE'
	    });
	  };
	};
	
	var getMyRecordsDescription = exports.getMyRecordsDescription = function getMyRecordsDescription(category) {
	  return function (dispatch) {
	    return new Promise(function (resolve) {
	      (0, _requests.GET_MY_RECORDS_DESCRIPTION)(category, function (description) {
	        dispatch({
	          type: '@@MY_RECORDS_SET_DESCRIPTION',
	          category: category,
	          description: description
	        });
	        resolve(description);
	      });
	    });
	  };
	};

/***/ },
/* 462 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.PinInputSection = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Modal = __webpack_require__(13);
	
	var _requests = __webpack_require__(6);
	
	var _Loaders = __webpack_require__(16);
	
	var _utilities = __webpack_require__(8);
	
	var _Markdown = __webpack_require__(24);
	
	var _Markdown2 = _interopRequireDefault(_Markdown);
	
	var _Form = __webpack_require__(14);
	
	var _LoginRedirector = __webpack_require__(148);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var PIN_REQUEST_ATTESTATIONS = (true);
	var PIN_REQUEST_SUCCESS_MESSAGE = ("The PIN you have requested for this entity has been sent to the email associated with your user account.  You should receive the PIN in approximately 3-5 minutes, depending on your email service provider.");
	var ONLY_REQUIRE_ONE_PIN_ATTESTATION = ({"NODE_ENV":"production","BUILD_DATE":"2025-08-27T15:15:31.687Z","BUILD_NUMBER":"Not Provided","GIT_VERSION":"v1.3.0-381-ga81e29b08","GIT_COMMIT_HASH":"a81e29b085c9268ffd96c78eb734365802722741","GIT_BRANCH":"beta","PUBLIC_URL":"","STATE_ABBR":"MT","STATE_NAME":"Montana","STATE_ORG_TITLE":"Secretary of State","LOGIN_HEADER_IMG_PATH":"","HOME_IMG_FILENAME":"montana.jpg","FAVICON_FILE_NAME":"favicon.ico","ALLOW_E_SIGN_ON_CORRECTIONS":true,"THIRD_PARTY_SIGNING_ALLOWED":false,"MY_ACCOUNT_SAVE_AND_CLOSE_BUTTON":true,"IE_DEPRECATED_MESSAGE":"Internet Explorer is not supported. Please select a supported browser below to access this website.","ADDITIONAL_ROUTES":{"dataRequests":true,"farmBill":true,"apostille":true,"externalHelp":"https://sosmt.gov/business/help-center/","systemAdministration":[{"title":"Saved Payments","parameter":"saved-payments","componentName":"SavedPayments"}]},"SUBROUTES":[{"label":"Business","component":"Business","parameter":"business","myWorkQueueSearch":false,"sourceTypeId":54,"searchMustHaveOneOf":["FILING_TYPE_ID","STATUS_ID","STATE","search"],"serverWebSearchDescription":true,"serverWorkQueueDescription":true,"serverMyRecordsDescription":true,"searchPlaceholder":"Search by name or filing number (X########)","allowEmptySearchTerm":true,"requestCertificateAlternateLabel":"Request Information","fileAmendmentButtonLabel":"Filing Actions","advancedSearchParameters":[{"type":"radio","name":"QUERY_TYPE_ID","defaultValue":1010,"options":[{"value":1010,"label":"Starts with"},{"value":1011,"label":"Contains"},{"value":1012,"label":" Word Contains"}]},{"type":"serverSelect","name":"FILING_TYPE_ID","optionsSrc":"FILING_TYPES","label":"Entity Type","placeholder":"All","defaultValue":"0"},{"type":"serverSelect","name":"FILING_SUBTYPE_ID","optionsSrc":"FILING_SUBTYPES","label":"Entity Subtype","overrideSubOptionsSrcFromParameterName":"FILING_TYPE_ID","placeholder":"All","defaultValue":"0"},{"type":"serverSelect","name":"STATUS_ID","optionsSrc":"FILING_STATUS_WITHOUT_ALL","label":"Status","placeholder":"All","defaultValue":"0"},{"type":"serverSelect","name":"STATE","optionsSrc":"STATE","label":"State","placeholder":"All","defaultValue":""},{"type":"serverSelect","name":"COUNTY","optionsSrc":"COUNTY_SUBOPTION","label":"County","overrideSubOptionsSrcFromParameterName":"STATE","placeholder":"All","defaultValue":""},{"type":"checkbox","name":"CRA_SEARCH_YN","defaultValue":false,"label":"Search by Registered Agent PID"},{"type":"dateRange","name":"FILING_DATE","label":"Registration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}},{"type":"dateRange","name":"EXPIRATION_DATE","label":"Expiration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}}],"myRecordsFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Active"},{"value":2,"label":"Inactive"},{"value":3,"label":"Pending"}]},{"type":"dateRange","name":"DATE_RANGE","label":"Date range","defaultValue":{"start":null,"end":null}}],"myWorkQueueFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Approved"},{"value":2,"label":"Pending Online Payment"},{"value":3,"label":"Pending Review"},{"value":4,"label":"Needs Correction"},{"value":5,"label":"Rejected"},{"value":6,"label":"Draft"}]},{"type":"dateRange","name":"DATE_RANGE","label":"Date range","defaultValue":{"start":null,"end":null}}]},{"label":"Notary","component":"Notary","parameter":"notary","sourceTypeId":850,"myWorkQueueSearch":false,"allowEmptySearchTerm":true,"requestCertificateAlternateLabel":"Download Certificate","fileAmendmentButtonLabel":"Filing Actions","hideNameRequestCertificate":true,"hideAddressRequestCertificate":true,"hideRecordUserManagment":true,"searchPlaceholder":"Search by name or commission number","searchMustHaveOneOf":["CITY","search","SERVICE_TYPE"],"advancedParametersStartOpen":true,"searchIsSortable":true,"advancedSearchParameters":[{"type":"radio","name":"STARTS_WITH_YN","defaultValue":false,"options":[{"value":true,"label":"Starts with"},{"value":false,"label":"Contains"}]},{"type":"checkbox","name":"ACTIVE_ONLY_YN","defaultValue":true,"label":"Active entities only"},{"type":"text","name":"CITY","defaultValue":"","label":"City"},{"type":"select","name":"SERVICE_TYPE","label":"Special Services Offered","defaultValue":0,"options":[{"value":0,"label":"(N/A)"},{"value":6165,"label":"In-Person Electronic Notarization (IPEN)"},{"value":6166,"label":"Remote Online Notarization (RON)"},{"value":6167,"label":"Mobile Notary Services"},{"value":6168,"label":"Remote Ink Notarization (RIN)"}]}]},{"label":"Apostille","component":"Apostille","parameter":"apostille","sourceTypeId":720,"myRecordsSearch":false,"myWorkQueueSearch":false,"disabled":false,"allowedRoutes":["/forms-manager/","/queue/","/forms/"]},{"label":"Liens","component":"UCC","parameter":"ucc","sourceTypeId":1999,"myRecordsSearch":true,"myWorkQueueSearch":true,"fileAmendmentButtonLabel":"Filing Actions","searchPlaceholder":"Search by name or file number","disabled":false,"serverWebSearchDescription":true,"myRecordsDescription":"","workQueueDescription":"","searchDescription":"","hideRecordUserManagment":true,"searchLiensCheckout":false,"advancedSearchParameters":[{"type":"radio","name":"STARTS_WITH_YN","defaultValue":false,"options":[{"value":true,"label":"Starts with"},{"value":false,"label":"Contains"}]},{"type":"select","name":"STATUS","defaultValue":"ALL","label":"Status","options":[{"value":"ACTIVE_UNLAPSED","label":"Active (unlapsed)"},{"value":"ACTIVE_LAPSED_UNLAPSED","label":"Active (lapsed and unlapsed)"}]},{"type":"text","name":"EXCLUDE_VALUES","label":"Exclude Debtor Names (comma separated list of names to exclude)","defaultValue":""},{"type":"dateRange","name":"FILING_DATE","label":"Financing Statement Date","defaultValue":{"start":null,"end":null}},{"type":"dateRange","name":"LAPSE_DATE","label":"Lapse Date","defaultValue":{"start":null,"end":null}},{"type":"text","name":"CITY","label":"Debtor City","defaultValue":""}],"myRecordsFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Approved"},{"value":2,"label":"Pending Online Payment"},{"value":3,"label":"Pending Review"}]},{"type":"select","name":"TYPE","defaultValue":0,"label":"Lien Type","options":[{"value":0,"label":"All"},{"value":1,"label":"UCC"},{"value":2,"label":"EFS"},{"value":3,"label":"Title 71"}]}],"myWorkQueueFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Approved"},{"value":2,"label":"Pending Online Payment"},{"value":3,"label":"Pending Review"},{"value":4,"label":"Pending Print and Mail"},{"value":5,"label":"Rejected"},{"value":6,"label":"Draft"}]},{"type":"select","name":"TYPE","defaultValue":0,"label":"Lien Type","options":[{"value":0,"label":"All"},{"value":1,"label":"UCC"},{"value":2,"label":"EFS"},{"value":3,"label":"Title 71"}]}]},{"label":"Copy Request","component":"copies","parameter":"copies","sourceTypeId":2001,"myRecordsSearch":false,"myWorkQueueSearch":false,"disabled":false,"allowedRoutes":["/forms-manager/","/queue/","/forms/"]},{"label":"Trademark","component":"Trademark","parameter":"trademark","sourceTypeId":810,"showRequestCertificate":true,"searchMustHaveOneOf":["search","EXPIRATION_DATE","FILING_DATE"],"allowEmptySearchTerm":true,"requestCertificateAlternateLabel":"Request Information","fileAmendmentButtonLabel":"Filing Actions","advancedSearchParameters":[{"type":"radio","name":"QUERY_TYPE_ID","defaultValue":1010,"options":[{"value":1010,"label":"Starts with"},{"value":1011,"label":"Contains"},{"value":1012,"label":" Word Contains"}]},{"type":"checkbox","name":"OWNER_SEARCH_YN","defaultValue":false,"label":"Search owners"},{"type":"radio","name":"SERVICE_MARK_YN","label":"Mark Type","defaultValue":"","options":[{"value":"","label":"All Marks"},{"value":"Y","label":"Service Mark"},{"value":"N","label":"Trademark"}]},{"type":"serverSelect","name":"STATUS_ID","optionsSrc":"TYPE_V|TRADEMARK_STATUS_TYPE","label":"Status","placeholder":"All","defaultValue":"0"},{"type":"select","name":"DESIGN_TYPE_ID","options":[{"value":0,"label":"All"},{"value":990,"label":"Words Only"},{"value":991,"label":"Design Only"},{"value":992,"label":"Words and Design"}],"label":"Design Type","defaultValue":"0"},{"type":"dateRange","name":"FILING_DATE","label":"Registered Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}},{"type":"dateRange","name":"EXPIRATION_DATE","label":"Expiration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}}]},{"label":"Business Info Request","component":"InfoRequests","parameter":"info-request","sourceTypeId":167,"allowedRoutes":["/forms-manager/","/queue/","/forms/"]},{"label":"Data Requests","component":"DataRequests","parameter":"data-request","sourceTypeId":0,"allowedRoutes":["/forms-manager/"]},{"label":"CRA","component":"CRA","parameter":"cra","sourceTypeId":157,"myRecordsSearch":false,"searchPlaceholder":"Search by name or registered agent number","allowedRoutes":["/forms-manager/","/forms/","/records/","/queue/","/search/"],"allowEmptySearchTerm":true,"fileAmendmentButtonLabel":"Filing Actions","advancedSearchParameters":[{"type":"radio","name":"QUERY_TYPE_ID","defaultValue":1010,"options":[{"value":1010,"label":"Starts with"},{"value":1011,"label":"Contains"},{"value":1012,"label":" Word Contains"}]},{"type":"dateRange","name":"CRA_DATE","label":"Registration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}},{"type":"select","name":"STATUS_ID","label":"Status","defaultValue":0,"options":[{"value":0,"label":"All"},{"value":121,"label":"Active"},{"value":122,"label":"Inactive"}]},{"type":"select","name":"AGENT_TYPE_ID","label":"Agent Type","defaultValue":0,"options":[{"value":0,"label":"All"},{"value":460,"label":"Registered Agent"},{"value":461,"label":"Commercial Registered Agent"}]}]},{"label":"Farm Bill","component":"FarmBill","parameter":"farm-bill","path":"/lists/farm-bill","sourceTypeId":0,"myRecordsSearch":false,"allowedRules":["/search/"],"disabled":true,"searchDescription":"To perform a search, enter a debtor name. Your search results may include: exact debtor name, variations of that name and any filing that includes your search criteria. Punctuation is ignored.\n\nYou can click on \"Advanced\" to refine your search. Under “Advanced” you can search by crop, year, county and SSN/FEIN. As a registered Farm Bill Buyer with the Montana Secretary of State’s office it is important to maintain the confidentiality of the information contained within the Farm Bill Master List. The Farm Bill Master List reflects personal data, such as Social Security Numbers, which are a key piece of personal identifiable information to assist you in determining the existence of a lien against a specific debtor. The distribution of this information beyond its intended purpose is strictly prohibited.\n\nThe debtor's tax identification number has been hidden for confidentiality reasons. You may continue to search on a tax ID number and return debtors that match your search criteria. The SSN/FEIN must be entered without dashes or spaces.","searchMustHaveOneOf":["search","UCC_FARM_PRODUCT_ID","COUNTY"],"searchPlaceholder":"Search by debtor name","advancedSearchParameters":[{"type":"ServerMultiComplete","label":"Product code name(s)","name":"UCC_FARM_PRODUCT_ID","defaultValue":"","optionsSrc":"UCC_FARM_PRODUCT_V"},{"type":"MultiComplete","label":"Year or Range of Years","name":"YEAR_NUM","optionsSrc":"years","startYear":"1968","defaultValue":[],"preMergeOptions":[{"value":"ALL","label":"All"}]},{"type":"serverSelect","label":"State","name":"STATE","defaultValue":"MONTANA","optionsSrc":"STATE"},{"type":"ServerMultiComplete","label":"County","name":"COUNTY","defaultValue":[],"optionsSrc":"COUNTY","overrideSubOptionsSrcFromParameterName":"STATE"},{"type":"checkbox","name":"TIN_SEARCH_YN","defaultValue":false,"label":"Tax Identification Number Search"},{"type":"checkbox","name":"TIN_SORT_YN","defaultValue":false,"label":"Unique ID Sort"}]}],"SYSTEM_NICKNAME":"Online Services Portal","PAYMENT_METHODS":[{"type":"bypass"},{"type":"iTransact"}],"PAYMENT_ALLOW_AMEX":true,"SYSTEM_ID_LABEL":"System Id","DOUBLE_COLUMN_PUBLIC_LOGIN":true,"INTERNAL_USER_MANAGEMENT":true,"ALLOW_PUBLIC_JSON_IMPORT":false,"MAX_FILE_UPLOAD_SIZE":10000000,"REFUND_TEXT":"","RETURN_TO_HOME_ON_LOGOUT":true,"CURRENT_SOS_NAME":"Christi Jacobsen","LOGO_FILENAME":"mt-sos-logo.png","LOGO_ALT":"Christi Jacobsen, Montana Secretary of State","LOGO_FULL_WIDTH":true,"HOME_HIDE_AUTH_HINT":true,"HOME_TITLE":"Montana Secretary of State","CUSTOM_TAB_TITLE":"Official Montana","HOME_SUBTITLE":"Online Business Services","ENTITY_NAME_CONSENT_DESCRIPTION":"","ALLOW_USER_PROFILE_EDITING":true,"COMPARE_FOREIGN_NAME_IN_ENTITY_NAME_VALIDATION":true,"FOREIGN_NAME_FIELD_NAME":"KIMA_PARENT_NAME_INFO","LOGIN_TITLE":"Montana Secretary of State Online Filing Portal Login","PUBLIC_LOGIN_LABEL":"Username","REVERSE_LOGIN_COLUMNS":true,"LOGIN_SEAL_FILENAME":"seal_white.png","SEPARATE_USERNAME_AND_EMAIL":true,"CREATE_ACCOUNT_BUTTON_ALIGN_LEFT":true,"CREATE_ACCOUNT_BUTTON_TEXT":"CREATE AN ACCOUNT","PASSWORD_CUSTOM_ERROR_TEXT":"The password must meet all requirements","ACCOUNT_CREATED_MESSAGE":"Please check your email to verify your account to login and allow a few minutes for this message to arrive. Check your junk/spam folders if you do not find the email in your inbox.","PUBLIC_LOGIN_PLACEHOLDER":" ","DISABLE_DEFAULT_PAYMENT_RADIO":true,"CUSTOM_RESET_PASSWORD_ERROR_MESSAGE":"Username invalid - no account found","PUBLIC_LOGIN_CREATE_DESCRIPTION":"### Existing User:\n\n  - Enter your username and password to login.  \n\n\n  #### - OR -  \n\n\n\n  - Forgot password? Click 'Reset Password' and follow the prompts.\n  - Forgot username? Click 'Forgot Username' and follow the prompts.  \n\n\n  ### New User:\n  ","LOGIN_HELP_LINK":"https://sosmt.gov/business/how-do-i/","LOGIN_HELP_LINK_TEXT":"Need Help?","FORGOT_USERNAME_TEXT":"Forgot Username?","LOGIN_ACTIVE_DIRECTORY_TEXT":"State User Login","MULTIPLE_LOGIN_METHODS":true,"HAS_ACTIVE_DIRECTORY_LOGIN":true,"RESET_PASSWORD_WITH_USERNAME":true,"DOWNLOAD_LINK":true,"SHOW_USERNAME_ACCOUNT_CREATE":true,"SHOW_SCROLL_DOWN_ARROW":true,"SHOW_ADDRESS_ACCOUNT_CREATE":true,"TWO_COLUMN_ACCOUNT_CREATE":true,"RESET_PASSWORD_TIP":"A link to change your password has been sent to your email. Please allow a few minutes for this message to arrive. Please check your junk/spam folders if you do not find the email in your inbox.","FORGOT_PASSWORD_LINK_TEXT":"Reset Password","PHONE_NUMBER_OPTIONAL_ACCOUNT_CREATE":true,"SHOW_REQUIRED_INDICATOR_ACCOUNT_CREATE":true,"PASSWORD_REQUIREMENTS_ACCOUNT_CREATE":"\n    <ul>\n      <li>MUST contain at least 8 characters (12+ recommended)</li>\n      <li>MUST contain at least one uppercase letter.</li>\n      <li>MUST contain at least one lowercase letter.</li>\n      <li>MUST contain at least one number.</li>\n      <li>MUST contain at least one special character (!”#$%&'()*+,-./:;<=>?</li>\n    </ul>\n  ","ALLOW_CERTIFICATION_REQUEST":true,"ALLOW_PUBLIC_CERTIFICATE_REQUEST":true,"ALLOW_COPY_REQUEST":false,"ALLOW_CORRECTION_STYLING":true,"HIDE_DEPRECATION_WARNING":false,"AMEND_ROUTE_PUBLIC":true,"SEAL_FILENAME":"seal.png","SHOPPING_CART":true,"ALLOW_PAYMENT_UPDATE_WITH_EMPTY_CART":true,"RA_EMAIL":true,"RA_WEBSITE":true,"RA_NO_DEFAULT_TYPE":true,"RA_ADDRESS_LABEL":"Street Address","RA_TYPE_SELECTION_DEFAULT":true,"RA_DEFAULT_TYPE":"460","RA_OVERRIDE_TYPE_WITH_DEFAULT":true,"RA_PRINCIPAL_ADDRESS_AMS":true,"UPLOAD_AND_SUBMIT_HIDE_IF_ONE_OPTION":true,"PAYMENT_PROCESSING_MESSAGE":"Your payment is processing - Do not close your browser or click the back button","CHECKOUT_BUTTON_WHEN_PROCESSING_TEXT":"Processing","EFS_CROP_PICKER_NONE_LABEL":"Lien Duration","DISALLOWED_WIZARD_PIECES":["FormationLocale"],"REPEATER_SHOW_EDIT_BUTTON":true,"DATA_REQUEST_PAGE_TITLE":"Data Requests and Subscriptions","DATA_REQUEST_SIDEBAR_LABEL":"Data Requests & Subscriptions","LOGIN_REDIRECTS_TO_EPASS":false,"LOGIN_REDIRECTS_TO_ACTIVE_DIRECTORY":true,"LOGIN_ACTIVE_DIRECTORY_LINK":true,"FETCH_EDIT_USER_LINK":false,"LISTS_FETCH_AVAILABLE_LISTS":true,"POST_WIZARD_SUBMIT_REDIRECT_URL":"/","PIN_REQUEST_ATTESTATIONS":true,"PIN_REQUEST_DESCRIPTION":"Click **Request PIN** to have a new PIN sent to the account holder's email address on file.","OWNERSHIP_REQUEST_DESCRIPTION":"To become an **authorized user** of this record, a current **AUTHORIZED USER** will need to grant you access. To request access, click **Request Access** below.","PIN_REQUEST_SUCCESS_MESSAGE":"The PIN you have requested for this entity has been sent to the email associated with your user account.  You should receive the PIN in approximately 3-5 minutes, depending on your email service provider.","APOSTILLE_HEADER_LABEL":"Verification Information","APOSTILLE_NUMBER_LABEL":"Apostille/Authentication","APOSTILLE_CITY_STATE_OVERRIDE":"HELENA, MT","APOSTILLE_FILING_DATE_LABEL":"Issue Date","APOSTILLE_CITY_STATE_IN_CERTIFIED":true,"NOTARY_EXISTING_FILING":true,"ALLOW_REVOKE_OWN_ACCESS_ONLY":false,"HIDE_CANCEL_ON_ONETIME_DATA_REQUESTS":true,"DATA_REQUESTS_IN_SHOPPING_CART":true,"WQ_ALLOW_EDIT_PENDING_PAYMENT":true,"WQ_CONFIRM_ON_DELETE":true,"WQ_DELETE_CONFIRM_MESSAGE":"Deleting this filing will forfeit any money already paid to the Secretary of State. This action is permanent and cannot be undone, are you sure you would like to delete?","PASS_ITEM_GUIDS_ON_CHECKOUT":true,"FORM_REVISION_HISTORY":true,"CHECKOUT_DISCLAIMER":"By entering your credit card and/or checking account information you (i) state that **you are an authorized user** of the credit card and/or electronic check and that the associated information entered (e.g., account holder name, account number, billing address) is accurate, (ii) **you authorize payment processor to charge the amount you have requested** to your credit card and/or funding account, and (iii) **acknowledge if a charge is declined or reversed you may also be assessed a customary charge** by the payment processor for such transactions.","FARM_BILL_SEARCH_CONFIDENTIAL":"As a registered Farm Bill Buyer with the Montana Secretary of State’s office it is important to maintain the confidentiality of the information contained within the Farm Bill Master List. The Farm Bill Master List reflects personal data, such as Social Security Numbers, which are a key piece of personal identifiable information to assist you in determining the existence of a lien against a specific debtor. The distribution of this information beyond its intended purpose is strictly prohibited.\n\n**The debtor's tax identification number has been hidden for confidentiality reasons. You may continue to search on a tax ID number and return debtors that match your search criteria. The SSN/FEIN must be entered without dashes or spaces.  If you need access to the tax identification number to clearly identify the debtor, please contact the UCC unit at (406) 444-3665.**","VIEW_HISTORY_BUTTON_ALT_TEXT":"View Filings","WIZARD_ERROR_TITLE_MESSAGE":"Form Error","FARM_BILL_SEARCH_INTERACTIVE":true,"USE_FARM_BILL_API":true,"DISALLOW_ASSIGN_SELF_AS_RA":true,"DISALLOW_ASSIGN_SELF_AS_PRINCIPAL":true,"USE_TRADEMARK_OWNER_VALIDATION":true,"USE_ALTERNATIVE_FOREIGN_ADDRESS_LABELS":true,"MY_RECEIPTS_FILTER":[{"type":"dateRange","name":"DATE_RANGE","label":"Date range","defaultValue":{"start":null,"end":null}},{"type":"text","name":"REF_NUM","defaultValue":"","label":"Reference Number"},{"type":"text","name":"RECEIPT_NUM","defaultValue":"","label":"Receipt Id"},{"type":"text","name":"AMOUNT","defaultValue":"","label":"Amount"},{"type":"select","name":"TYPE","defaultValue":"","label":"Payment Type","options":[{"value":"","label":"All"},{"value":"CC","label":"Credit Card"},{"value":"Check","label":"Check"}]}],"MY_RECEIPTS_SHOW_IN_SIDEBAR":true,"SHOW_MY_RECEIPTS_HELPER_TEXT":true,"MY_RECEIPTS_HELPER_LABEL":"About Receipt Search","MY_RECEIPTS_HELPER_TEXT":"You can search for receipts based on their descriptions, including the items paid for on the receipt. Use the filters to search for or filter specific information.","FARM_BILL_SUBLINK":{"label":"Farm Bill","component":"FarmBill","parameter":"farm-bill","path":"/lists/farm-bill","sourceTypeId":0,"myRecordsSearch":false,"allowedRules":["/search/"],"disabled":true,"searchDescription":"To perform a search, enter a debtor name. Your search results may include: exact debtor name, variations of that name and any filing that includes your search criteria. Punctuation is ignored.\n\nYou can click on \"Advanced\" to refine your search. Under “Advanced” you can search by crop, year, county and SSN/FEIN. As a registered Farm Bill Buyer with the Montana Secretary of State’s office it is important to maintain the confidentiality of the information contained within the Farm Bill Master List. The Farm Bill Master List reflects personal data, such as Social Security Numbers, which are a key piece of personal identifiable information to assist you in determining the existence of a lien against a specific debtor. The distribution of this information beyond its intended purpose is strictly prohibited.\n\nThe debtor's tax identification number has been hidden for confidentiality reasons. You may continue to search on a tax ID number and return debtors that match your search criteria. The SSN/FEIN must be entered without dashes or spaces.","searchMustHaveOneOf":["search","UCC_FARM_PRODUCT_ID","COUNTY"],"searchPlaceholder":"Search by debtor name","advancedSearchParameters":[{"type":"ServerMultiComplete","label":"Product code name(s)","name":"UCC_FARM_PRODUCT_ID","defaultValue":"","optionsSrc":"UCC_FARM_PRODUCT_V"},{"type":"MultiComplete","label":"Year or Range of Years","name":"YEAR_NUM","optionsSrc":"years","startYear":"1968","defaultValue":[],"preMergeOptions":[{"value":"ALL","label":"All"}]},{"type":"serverSelect","label":"State","name":"STATE","defaultValue":"MONTANA","optionsSrc":"STATE"},{"type":"ServerMultiComplete","label":"County","name":"COUNTY","defaultValue":[],"optionsSrc":"COUNTY","overrideSubOptionsSrcFromParameterName":"STATE"},{"type":"checkbox","name":"TIN_SEARCH_YN","defaultValue":false,"label":"Tax Identification Number Search"},{"type":"checkbox","name":"TIN_SORT_YN","defaultValue":false,"label":"Unique ID Sort"}]},"ALLOW_ADDRESS_VALIDATION_BYPASS_OPTION":true,"DEFAULT_ADDRESS_VALIDATION_BYPASS_OPTION_CHECKED":true}).ONLY_REQUIRE_ONE_PIN_ATTESTATION;
	var PIN_REQUEST_DESCRIPTION = ("Click **Request PIN** to have a new PIN sent to the account holder's email address on file.");
	var NO_PIN_INPUT_AFTER_REQUEST = ({"NODE_ENV":"production","BUILD_DATE":"2025-08-27T15:15:31.687Z","BUILD_NUMBER":"Not Provided","GIT_VERSION":"v1.3.0-381-ga81e29b08","GIT_COMMIT_HASH":"a81e29b085c9268ffd96c78eb734365802722741","GIT_BRANCH":"beta","PUBLIC_URL":"","STATE_ABBR":"MT","STATE_NAME":"Montana","STATE_ORG_TITLE":"Secretary of State","LOGIN_HEADER_IMG_PATH":"","HOME_IMG_FILENAME":"montana.jpg","FAVICON_FILE_NAME":"favicon.ico","ALLOW_E_SIGN_ON_CORRECTIONS":true,"THIRD_PARTY_SIGNING_ALLOWED":false,"MY_ACCOUNT_SAVE_AND_CLOSE_BUTTON":true,"IE_DEPRECATED_MESSAGE":"Internet Explorer is not supported. Please select a supported browser below to access this website.","ADDITIONAL_ROUTES":{"dataRequests":true,"farmBill":true,"apostille":true,"externalHelp":"https://sosmt.gov/business/help-center/","systemAdministration":[{"title":"Saved Payments","parameter":"saved-payments","componentName":"SavedPayments"}]},"SUBROUTES":[{"label":"Business","component":"Business","parameter":"business","myWorkQueueSearch":false,"sourceTypeId":54,"searchMustHaveOneOf":["FILING_TYPE_ID","STATUS_ID","STATE","search"],"serverWebSearchDescription":true,"serverWorkQueueDescription":true,"serverMyRecordsDescription":true,"searchPlaceholder":"Search by name or filing number (X########)","allowEmptySearchTerm":true,"requestCertificateAlternateLabel":"Request Information","fileAmendmentButtonLabel":"Filing Actions","advancedSearchParameters":[{"type":"radio","name":"QUERY_TYPE_ID","defaultValue":1010,"options":[{"value":1010,"label":"Starts with"},{"value":1011,"label":"Contains"},{"value":1012,"label":" Word Contains"}]},{"type":"serverSelect","name":"FILING_TYPE_ID","optionsSrc":"FILING_TYPES","label":"Entity Type","placeholder":"All","defaultValue":"0"},{"type":"serverSelect","name":"FILING_SUBTYPE_ID","optionsSrc":"FILING_SUBTYPES","label":"Entity Subtype","overrideSubOptionsSrcFromParameterName":"FILING_TYPE_ID","placeholder":"All","defaultValue":"0"},{"type":"serverSelect","name":"STATUS_ID","optionsSrc":"FILING_STATUS_WITHOUT_ALL","label":"Status","placeholder":"All","defaultValue":"0"},{"type":"serverSelect","name":"STATE","optionsSrc":"STATE","label":"State","placeholder":"All","defaultValue":""},{"type":"serverSelect","name":"COUNTY","optionsSrc":"COUNTY_SUBOPTION","label":"County","overrideSubOptionsSrcFromParameterName":"STATE","placeholder":"All","defaultValue":""},{"type":"checkbox","name":"CRA_SEARCH_YN","defaultValue":false,"label":"Search by Registered Agent PID"},{"type":"dateRange","name":"FILING_DATE","label":"Registration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}},{"type":"dateRange","name":"EXPIRATION_DATE","label":"Expiration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}}],"myRecordsFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Active"},{"value":2,"label":"Inactive"},{"value":3,"label":"Pending"}]},{"type":"dateRange","name":"DATE_RANGE","label":"Date range","defaultValue":{"start":null,"end":null}}],"myWorkQueueFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Approved"},{"value":2,"label":"Pending Online Payment"},{"value":3,"label":"Pending Review"},{"value":4,"label":"Needs Correction"},{"value":5,"label":"Rejected"},{"value":6,"label":"Draft"}]},{"type":"dateRange","name":"DATE_RANGE","label":"Date range","defaultValue":{"start":null,"end":null}}]},{"label":"Notary","component":"Notary","parameter":"notary","sourceTypeId":850,"myWorkQueueSearch":false,"allowEmptySearchTerm":true,"requestCertificateAlternateLabel":"Download Certificate","fileAmendmentButtonLabel":"Filing Actions","hideNameRequestCertificate":true,"hideAddressRequestCertificate":true,"hideRecordUserManagment":true,"searchPlaceholder":"Search by name or commission number","searchMustHaveOneOf":["CITY","search","SERVICE_TYPE"],"advancedParametersStartOpen":true,"searchIsSortable":true,"advancedSearchParameters":[{"type":"radio","name":"STARTS_WITH_YN","defaultValue":false,"options":[{"value":true,"label":"Starts with"},{"value":false,"label":"Contains"}]},{"type":"checkbox","name":"ACTIVE_ONLY_YN","defaultValue":true,"label":"Active entities only"},{"type":"text","name":"CITY","defaultValue":"","label":"City"},{"type":"select","name":"SERVICE_TYPE","label":"Special Services Offered","defaultValue":0,"options":[{"value":0,"label":"(N/A)"},{"value":6165,"label":"In-Person Electronic Notarization (IPEN)"},{"value":6166,"label":"Remote Online Notarization (RON)"},{"value":6167,"label":"Mobile Notary Services"},{"value":6168,"label":"Remote Ink Notarization (RIN)"}]}]},{"label":"Apostille","component":"Apostille","parameter":"apostille","sourceTypeId":720,"myRecordsSearch":false,"myWorkQueueSearch":false,"disabled":false,"allowedRoutes":["/forms-manager/","/queue/","/forms/"]},{"label":"Liens","component":"UCC","parameter":"ucc","sourceTypeId":1999,"myRecordsSearch":true,"myWorkQueueSearch":true,"fileAmendmentButtonLabel":"Filing Actions","searchPlaceholder":"Search by name or file number","disabled":false,"serverWebSearchDescription":true,"myRecordsDescription":"","workQueueDescription":"","searchDescription":"","hideRecordUserManagment":true,"searchLiensCheckout":false,"advancedSearchParameters":[{"type":"radio","name":"STARTS_WITH_YN","defaultValue":false,"options":[{"value":true,"label":"Starts with"},{"value":false,"label":"Contains"}]},{"type":"select","name":"STATUS","defaultValue":"ALL","label":"Status","options":[{"value":"ACTIVE_UNLAPSED","label":"Active (unlapsed)"},{"value":"ACTIVE_LAPSED_UNLAPSED","label":"Active (lapsed and unlapsed)"}]},{"type":"text","name":"EXCLUDE_VALUES","label":"Exclude Debtor Names (comma separated list of names to exclude)","defaultValue":""},{"type":"dateRange","name":"FILING_DATE","label":"Financing Statement Date","defaultValue":{"start":null,"end":null}},{"type":"dateRange","name":"LAPSE_DATE","label":"Lapse Date","defaultValue":{"start":null,"end":null}},{"type":"text","name":"CITY","label":"Debtor City","defaultValue":""}],"myRecordsFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Approved"},{"value":2,"label":"Pending Online Payment"},{"value":3,"label":"Pending Review"}]},{"type":"select","name":"TYPE","defaultValue":0,"label":"Lien Type","options":[{"value":0,"label":"All"},{"value":1,"label":"UCC"},{"value":2,"label":"EFS"},{"value":3,"label":"Title 71"}]}],"myWorkQueueFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Approved"},{"value":2,"label":"Pending Online Payment"},{"value":3,"label":"Pending Review"},{"value":4,"label":"Pending Print and Mail"},{"value":5,"label":"Rejected"},{"value":6,"label":"Draft"}]},{"type":"select","name":"TYPE","defaultValue":0,"label":"Lien Type","options":[{"value":0,"label":"All"},{"value":1,"label":"UCC"},{"value":2,"label":"EFS"},{"value":3,"label":"Title 71"}]}]},{"label":"Copy Request","component":"copies","parameter":"copies","sourceTypeId":2001,"myRecordsSearch":false,"myWorkQueueSearch":false,"disabled":false,"allowedRoutes":["/forms-manager/","/queue/","/forms/"]},{"label":"Trademark","component":"Trademark","parameter":"trademark","sourceTypeId":810,"showRequestCertificate":true,"searchMustHaveOneOf":["search","EXPIRATION_DATE","FILING_DATE"],"allowEmptySearchTerm":true,"requestCertificateAlternateLabel":"Request Information","fileAmendmentButtonLabel":"Filing Actions","advancedSearchParameters":[{"type":"radio","name":"QUERY_TYPE_ID","defaultValue":1010,"options":[{"value":1010,"label":"Starts with"},{"value":1011,"label":"Contains"},{"value":1012,"label":" Word Contains"}]},{"type":"checkbox","name":"OWNER_SEARCH_YN","defaultValue":false,"label":"Search owners"},{"type":"radio","name":"SERVICE_MARK_YN","label":"Mark Type","defaultValue":"","options":[{"value":"","label":"All Marks"},{"value":"Y","label":"Service Mark"},{"value":"N","label":"Trademark"}]},{"type":"serverSelect","name":"STATUS_ID","optionsSrc":"TYPE_V|TRADEMARK_STATUS_TYPE","label":"Status","placeholder":"All","defaultValue":"0"},{"type":"select","name":"DESIGN_TYPE_ID","options":[{"value":0,"label":"All"},{"value":990,"label":"Words Only"},{"value":991,"label":"Design Only"},{"value":992,"label":"Words and Design"}],"label":"Design Type","defaultValue":"0"},{"type":"dateRange","name":"FILING_DATE","label":"Registered Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}},{"type":"dateRange","name":"EXPIRATION_DATE","label":"Expiration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}}]},{"label":"Business Info Request","component":"InfoRequests","parameter":"info-request","sourceTypeId":167,"allowedRoutes":["/forms-manager/","/queue/","/forms/"]},{"label":"Data Requests","component":"DataRequests","parameter":"data-request","sourceTypeId":0,"allowedRoutes":["/forms-manager/"]},{"label":"CRA","component":"CRA","parameter":"cra","sourceTypeId":157,"myRecordsSearch":false,"searchPlaceholder":"Search by name or registered agent number","allowedRoutes":["/forms-manager/","/forms/","/records/","/queue/","/search/"],"allowEmptySearchTerm":true,"fileAmendmentButtonLabel":"Filing Actions","advancedSearchParameters":[{"type":"radio","name":"QUERY_TYPE_ID","defaultValue":1010,"options":[{"value":1010,"label":"Starts with"},{"value":1011,"label":"Contains"},{"value":1012,"label":" Word Contains"}]},{"type":"dateRange","name":"CRA_DATE","label":"Registration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}},{"type":"select","name":"STATUS_ID","label":"Status","defaultValue":0,"options":[{"value":0,"label":"All"},{"value":121,"label":"Active"},{"value":122,"label":"Inactive"}]},{"type":"select","name":"AGENT_TYPE_ID","label":"Agent Type","defaultValue":0,"options":[{"value":0,"label":"All"},{"value":460,"label":"Registered Agent"},{"value":461,"label":"Commercial Registered Agent"}]}]},{"label":"Farm Bill","component":"FarmBill","parameter":"farm-bill","path":"/lists/farm-bill","sourceTypeId":0,"myRecordsSearch":false,"allowedRules":["/search/"],"disabled":true,"searchDescription":"To perform a search, enter a debtor name. Your search results may include: exact debtor name, variations of that name and any filing that includes your search criteria. Punctuation is ignored.\n\nYou can click on \"Advanced\" to refine your search. Under “Advanced” you can search by crop, year, county and SSN/FEIN. As a registered Farm Bill Buyer with the Montana Secretary of State’s office it is important to maintain the confidentiality of the information contained within the Farm Bill Master List. The Farm Bill Master List reflects personal data, such as Social Security Numbers, which are a key piece of personal identifiable information to assist you in determining the existence of a lien against a specific debtor. The distribution of this information beyond its intended purpose is strictly prohibited.\n\nThe debtor's tax identification number has been hidden for confidentiality reasons. You may continue to search on a tax ID number and return debtors that match your search criteria. The SSN/FEIN must be entered without dashes or spaces.","searchMustHaveOneOf":["search","UCC_FARM_PRODUCT_ID","COUNTY"],"searchPlaceholder":"Search by debtor name","advancedSearchParameters":[{"type":"ServerMultiComplete","label":"Product code name(s)","name":"UCC_FARM_PRODUCT_ID","defaultValue":"","optionsSrc":"UCC_FARM_PRODUCT_V"},{"type":"MultiComplete","label":"Year or Range of Years","name":"YEAR_NUM","optionsSrc":"years","startYear":"1968","defaultValue":[],"preMergeOptions":[{"value":"ALL","label":"All"}]},{"type":"serverSelect","label":"State","name":"STATE","defaultValue":"MONTANA","optionsSrc":"STATE"},{"type":"ServerMultiComplete","label":"County","name":"COUNTY","defaultValue":[],"optionsSrc":"COUNTY","overrideSubOptionsSrcFromParameterName":"STATE"},{"type":"checkbox","name":"TIN_SEARCH_YN","defaultValue":false,"label":"Tax Identification Number Search"},{"type":"checkbox","name":"TIN_SORT_YN","defaultValue":false,"label":"Unique ID Sort"}]}],"SYSTEM_NICKNAME":"Online Services Portal","PAYMENT_METHODS":[{"type":"bypass"},{"type":"iTransact"}],"PAYMENT_ALLOW_AMEX":true,"SYSTEM_ID_LABEL":"System Id","DOUBLE_COLUMN_PUBLIC_LOGIN":true,"INTERNAL_USER_MANAGEMENT":true,"ALLOW_PUBLIC_JSON_IMPORT":false,"MAX_FILE_UPLOAD_SIZE":10000000,"REFUND_TEXT":"","RETURN_TO_HOME_ON_LOGOUT":true,"CURRENT_SOS_NAME":"Christi Jacobsen","LOGO_FILENAME":"mt-sos-logo.png","LOGO_ALT":"Christi Jacobsen, Montana Secretary of State","LOGO_FULL_WIDTH":true,"HOME_HIDE_AUTH_HINT":true,"HOME_TITLE":"Montana Secretary of State","CUSTOM_TAB_TITLE":"Official Montana","HOME_SUBTITLE":"Online Business Services","ENTITY_NAME_CONSENT_DESCRIPTION":"","ALLOW_USER_PROFILE_EDITING":true,"COMPARE_FOREIGN_NAME_IN_ENTITY_NAME_VALIDATION":true,"FOREIGN_NAME_FIELD_NAME":"KIMA_PARENT_NAME_INFO","LOGIN_TITLE":"Montana Secretary of State Online Filing Portal Login","PUBLIC_LOGIN_LABEL":"Username","REVERSE_LOGIN_COLUMNS":true,"LOGIN_SEAL_FILENAME":"seal_white.png","SEPARATE_USERNAME_AND_EMAIL":true,"CREATE_ACCOUNT_BUTTON_ALIGN_LEFT":true,"CREATE_ACCOUNT_BUTTON_TEXT":"CREATE AN ACCOUNT","PASSWORD_CUSTOM_ERROR_TEXT":"The password must meet all requirements","ACCOUNT_CREATED_MESSAGE":"Please check your email to verify your account to login and allow a few minutes for this message to arrive. Check your junk/spam folders if you do not find the email in your inbox.","PUBLIC_LOGIN_PLACEHOLDER":" ","DISABLE_DEFAULT_PAYMENT_RADIO":true,"CUSTOM_RESET_PASSWORD_ERROR_MESSAGE":"Username invalid - no account found","PUBLIC_LOGIN_CREATE_DESCRIPTION":"### Existing User:\n\n  - Enter your username and password to login.  \n\n\n  #### - OR -  \n\n\n\n  - Forgot password? Click 'Reset Password' and follow the prompts.\n  - Forgot username? Click 'Forgot Username' and follow the prompts.  \n\n\n  ### New User:\n  ","LOGIN_HELP_LINK":"https://sosmt.gov/business/how-do-i/","LOGIN_HELP_LINK_TEXT":"Need Help?","FORGOT_USERNAME_TEXT":"Forgot Username?","LOGIN_ACTIVE_DIRECTORY_TEXT":"State User Login","MULTIPLE_LOGIN_METHODS":true,"HAS_ACTIVE_DIRECTORY_LOGIN":true,"RESET_PASSWORD_WITH_USERNAME":true,"DOWNLOAD_LINK":true,"SHOW_USERNAME_ACCOUNT_CREATE":true,"SHOW_SCROLL_DOWN_ARROW":true,"SHOW_ADDRESS_ACCOUNT_CREATE":true,"TWO_COLUMN_ACCOUNT_CREATE":true,"RESET_PASSWORD_TIP":"A link to change your password has been sent to your email. Please allow a few minutes for this message to arrive. Please check your junk/spam folders if you do not find the email in your inbox.","FORGOT_PASSWORD_LINK_TEXT":"Reset Password","PHONE_NUMBER_OPTIONAL_ACCOUNT_CREATE":true,"SHOW_REQUIRED_INDICATOR_ACCOUNT_CREATE":true,"PASSWORD_REQUIREMENTS_ACCOUNT_CREATE":"\n    <ul>\n      <li>MUST contain at least 8 characters (12+ recommended)</li>\n      <li>MUST contain at least one uppercase letter.</li>\n      <li>MUST contain at least one lowercase letter.</li>\n      <li>MUST contain at least one number.</li>\n      <li>MUST contain at least one special character (!”#$%&'()*+,-./:;<=>?</li>\n    </ul>\n  ","ALLOW_CERTIFICATION_REQUEST":true,"ALLOW_PUBLIC_CERTIFICATE_REQUEST":true,"ALLOW_COPY_REQUEST":false,"ALLOW_CORRECTION_STYLING":true,"HIDE_DEPRECATION_WARNING":false,"AMEND_ROUTE_PUBLIC":true,"SEAL_FILENAME":"seal.png","SHOPPING_CART":true,"ALLOW_PAYMENT_UPDATE_WITH_EMPTY_CART":true,"RA_EMAIL":true,"RA_WEBSITE":true,"RA_NO_DEFAULT_TYPE":true,"RA_ADDRESS_LABEL":"Street Address","RA_TYPE_SELECTION_DEFAULT":true,"RA_DEFAULT_TYPE":"460","RA_OVERRIDE_TYPE_WITH_DEFAULT":true,"RA_PRINCIPAL_ADDRESS_AMS":true,"UPLOAD_AND_SUBMIT_HIDE_IF_ONE_OPTION":true,"PAYMENT_PROCESSING_MESSAGE":"Your payment is processing - Do not close your browser or click the back button","CHECKOUT_BUTTON_WHEN_PROCESSING_TEXT":"Processing","EFS_CROP_PICKER_NONE_LABEL":"Lien Duration","DISALLOWED_WIZARD_PIECES":["FormationLocale"],"REPEATER_SHOW_EDIT_BUTTON":true,"DATA_REQUEST_PAGE_TITLE":"Data Requests and Subscriptions","DATA_REQUEST_SIDEBAR_LABEL":"Data Requests & Subscriptions","LOGIN_REDIRECTS_TO_EPASS":false,"LOGIN_REDIRECTS_TO_ACTIVE_DIRECTORY":true,"LOGIN_ACTIVE_DIRECTORY_LINK":true,"FETCH_EDIT_USER_LINK":false,"LISTS_FETCH_AVAILABLE_LISTS":true,"POST_WIZARD_SUBMIT_REDIRECT_URL":"/","PIN_REQUEST_ATTESTATIONS":true,"PIN_REQUEST_DESCRIPTION":"Click **Request PIN** to have a new PIN sent to the account holder's email address on file.","OWNERSHIP_REQUEST_DESCRIPTION":"To become an **authorized user** of this record, a current **AUTHORIZED USER** will need to grant you access. To request access, click **Request Access** below.","PIN_REQUEST_SUCCESS_MESSAGE":"The PIN you have requested for this entity has been sent to the email associated with your user account.  You should receive the PIN in approximately 3-5 minutes, depending on your email service provider.","APOSTILLE_HEADER_LABEL":"Verification Information","APOSTILLE_NUMBER_LABEL":"Apostille/Authentication","APOSTILLE_CITY_STATE_OVERRIDE":"HELENA, MT","APOSTILLE_FILING_DATE_LABEL":"Issue Date","APOSTILLE_CITY_STATE_IN_CERTIFIED":true,"NOTARY_EXISTING_FILING":true,"ALLOW_REVOKE_OWN_ACCESS_ONLY":false,"HIDE_CANCEL_ON_ONETIME_DATA_REQUESTS":true,"DATA_REQUESTS_IN_SHOPPING_CART":true,"WQ_ALLOW_EDIT_PENDING_PAYMENT":true,"WQ_CONFIRM_ON_DELETE":true,"WQ_DELETE_CONFIRM_MESSAGE":"Deleting this filing will forfeit any money already paid to the Secretary of State. This action is permanent and cannot be undone, are you sure you would like to delete?","PASS_ITEM_GUIDS_ON_CHECKOUT":true,"FORM_REVISION_HISTORY":true,"CHECKOUT_DISCLAIMER":"By entering your credit card and/or checking account information you (i) state that **you are an authorized user** of the credit card and/or electronic check and that the associated information entered (e.g., account holder name, account number, billing address) is accurate, (ii) **you authorize payment processor to charge the amount you have requested** to your credit card and/or funding account, and (iii) **acknowledge if a charge is declined or reversed you may also be assessed a customary charge** by the payment processor for such transactions.","FARM_BILL_SEARCH_CONFIDENTIAL":"As a registered Farm Bill Buyer with the Montana Secretary of State’s office it is important to maintain the confidentiality of the information contained within the Farm Bill Master List. The Farm Bill Master List reflects personal data, such as Social Security Numbers, which are a key piece of personal identifiable information to assist you in determining the existence of a lien against a specific debtor. The distribution of this information beyond its intended purpose is strictly prohibited.\n\n**The debtor's tax identification number has been hidden for confidentiality reasons. You may continue to search on a tax ID number and return debtors that match your search criteria. The SSN/FEIN must be entered without dashes or spaces.  If you need access to the tax identification number to clearly identify the debtor, please contact the UCC unit at (406) 444-3665.**","VIEW_HISTORY_BUTTON_ALT_TEXT":"View Filings","WIZARD_ERROR_TITLE_MESSAGE":"Form Error","FARM_BILL_SEARCH_INTERACTIVE":true,"USE_FARM_BILL_API":true,"DISALLOW_ASSIGN_SELF_AS_RA":true,"DISALLOW_ASSIGN_SELF_AS_PRINCIPAL":true,"USE_TRADEMARK_OWNER_VALIDATION":true,"USE_ALTERNATIVE_FOREIGN_ADDRESS_LABELS":true,"MY_RECEIPTS_FILTER":[{"type":"dateRange","name":"DATE_RANGE","label":"Date range","defaultValue":{"start":null,"end":null}},{"type":"text","name":"REF_NUM","defaultValue":"","label":"Reference Number"},{"type":"text","name":"RECEIPT_NUM","defaultValue":"","label":"Receipt Id"},{"type":"text","name":"AMOUNT","defaultValue":"","label":"Amount"},{"type":"select","name":"TYPE","defaultValue":"","label":"Payment Type","options":[{"value":"","label":"All"},{"value":"CC","label":"Credit Card"},{"value":"Check","label":"Check"}]}],"MY_RECEIPTS_SHOW_IN_SIDEBAR":true,"SHOW_MY_RECEIPTS_HELPER_TEXT":true,"MY_RECEIPTS_HELPER_LABEL":"About Receipt Search","MY_RECEIPTS_HELPER_TEXT":"You can search for receipts based on their descriptions, including the items paid for on the receipt. Use the filters to search for or filter specific information.","FARM_BILL_SUBLINK":{"label":"Farm Bill","component":"FarmBill","parameter":"farm-bill","path":"/lists/farm-bill","sourceTypeId":0,"myRecordsSearch":false,"allowedRules":["/search/"],"disabled":true,"searchDescription":"To perform a search, enter a debtor name. Your search results may include: exact debtor name, variations of that name and any filing that includes your search criteria. Punctuation is ignored.\n\nYou can click on \"Advanced\" to refine your search. Under “Advanced” you can search by crop, year, county and SSN/FEIN. As a registered Farm Bill Buyer with the Montana Secretary of State’s office it is important to maintain the confidentiality of the information contained within the Farm Bill Master List. The Farm Bill Master List reflects personal data, such as Social Security Numbers, which are a key piece of personal identifiable information to assist you in determining the existence of a lien against a specific debtor. The distribution of this information beyond its intended purpose is strictly prohibited.\n\nThe debtor's tax identification number has been hidden for confidentiality reasons. You may continue to search on a tax ID number and return debtors that match your search criteria. The SSN/FEIN must be entered without dashes or spaces.","searchMustHaveOneOf":["search","UCC_FARM_PRODUCT_ID","COUNTY"],"searchPlaceholder":"Search by debtor name","advancedSearchParameters":[{"type":"ServerMultiComplete","label":"Product code name(s)","name":"UCC_FARM_PRODUCT_ID","defaultValue":"","optionsSrc":"UCC_FARM_PRODUCT_V"},{"type":"MultiComplete","label":"Year or Range of Years","name":"YEAR_NUM","optionsSrc":"years","startYear":"1968","defaultValue":[],"preMergeOptions":[{"value":"ALL","label":"All"}]},{"type":"serverSelect","label":"State","name":"STATE","defaultValue":"MONTANA","optionsSrc":"STATE"},{"type":"ServerMultiComplete","label":"County","name":"COUNTY","defaultValue":[],"optionsSrc":"COUNTY","overrideSubOptionsSrcFromParameterName":"STATE"},{"type":"checkbox","name":"TIN_SEARCH_YN","defaultValue":false,"label":"Tax Identification Number Search"},{"type":"checkbox","name":"TIN_SORT_YN","defaultValue":false,"label":"Unique ID Sort"}]},"ALLOW_ADDRESS_VALIDATION_BYPASS_OPTION":true,"DEFAULT_ADDRESS_VALIDATION_BYPASS_OPTION_CHECKED":true}).NO_PIN_INPUT_AFTER_REQUEST;
	var PIN_SWAP_ON_SUCCESS = ({"NODE_ENV":"production","BUILD_DATE":"2025-08-27T15:15:31.687Z","BUILD_NUMBER":"Not Provided","GIT_VERSION":"v1.3.0-381-ga81e29b08","GIT_COMMIT_HASH":"a81e29b085c9268ffd96c78eb734365802722741","GIT_BRANCH":"beta","PUBLIC_URL":"","STATE_ABBR":"MT","STATE_NAME":"Montana","STATE_ORG_TITLE":"Secretary of State","LOGIN_HEADER_IMG_PATH":"","HOME_IMG_FILENAME":"montana.jpg","FAVICON_FILE_NAME":"favicon.ico","ALLOW_E_SIGN_ON_CORRECTIONS":true,"THIRD_PARTY_SIGNING_ALLOWED":false,"MY_ACCOUNT_SAVE_AND_CLOSE_BUTTON":true,"IE_DEPRECATED_MESSAGE":"Internet Explorer is not supported. Please select a supported browser below to access this website.","ADDITIONAL_ROUTES":{"dataRequests":true,"farmBill":true,"apostille":true,"externalHelp":"https://sosmt.gov/business/help-center/","systemAdministration":[{"title":"Saved Payments","parameter":"saved-payments","componentName":"SavedPayments"}]},"SUBROUTES":[{"label":"Business","component":"Business","parameter":"business","myWorkQueueSearch":false,"sourceTypeId":54,"searchMustHaveOneOf":["FILING_TYPE_ID","STATUS_ID","STATE","search"],"serverWebSearchDescription":true,"serverWorkQueueDescription":true,"serverMyRecordsDescription":true,"searchPlaceholder":"Search by name or filing number (X########)","allowEmptySearchTerm":true,"requestCertificateAlternateLabel":"Request Information","fileAmendmentButtonLabel":"Filing Actions","advancedSearchParameters":[{"type":"radio","name":"QUERY_TYPE_ID","defaultValue":1010,"options":[{"value":1010,"label":"Starts with"},{"value":1011,"label":"Contains"},{"value":1012,"label":" Word Contains"}]},{"type":"serverSelect","name":"FILING_TYPE_ID","optionsSrc":"FILING_TYPES","label":"Entity Type","placeholder":"All","defaultValue":"0"},{"type":"serverSelect","name":"FILING_SUBTYPE_ID","optionsSrc":"FILING_SUBTYPES","label":"Entity Subtype","overrideSubOptionsSrcFromParameterName":"FILING_TYPE_ID","placeholder":"All","defaultValue":"0"},{"type":"serverSelect","name":"STATUS_ID","optionsSrc":"FILING_STATUS_WITHOUT_ALL","label":"Status","placeholder":"All","defaultValue":"0"},{"type":"serverSelect","name":"STATE","optionsSrc":"STATE","label":"State","placeholder":"All","defaultValue":""},{"type":"serverSelect","name":"COUNTY","optionsSrc":"COUNTY_SUBOPTION","label":"County","overrideSubOptionsSrcFromParameterName":"STATE","placeholder":"All","defaultValue":""},{"type":"checkbox","name":"CRA_SEARCH_YN","defaultValue":false,"label":"Search by Registered Agent PID"},{"type":"dateRange","name":"FILING_DATE","label":"Registration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}},{"type":"dateRange","name":"EXPIRATION_DATE","label":"Expiration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}}],"myRecordsFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Active"},{"value":2,"label":"Inactive"},{"value":3,"label":"Pending"}]},{"type":"dateRange","name":"DATE_RANGE","label":"Date range","defaultValue":{"start":null,"end":null}}],"myWorkQueueFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Approved"},{"value":2,"label":"Pending Online Payment"},{"value":3,"label":"Pending Review"},{"value":4,"label":"Needs Correction"},{"value":5,"label":"Rejected"},{"value":6,"label":"Draft"}]},{"type":"dateRange","name":"DATE_RANGE","label":"Date range","defaultValue":{"start":null,"end":null}}]},{"label":"Notary","component":"Notary","parameter":"notary","sourceTypeId":850,"myWorkQueueSearch":false,"allowEmptySearchTerm":true,"requestCertificateAlternateLabel":"Download Certificate","fileAmendmentButtonLabel":"Filing Actions","hideNameRequestCertificate":true,"hideAddressRequestCertificate":true,"hideRecordUserManagment":true,"searchPlaceholder":"Search by name or commission number","searchMustHaveOneOf":["CITY","search","SERVICE_TYPE"],"advancedParametersStartOpen":true,"searchIsSortable":true,"advancedSearchParameters":[{"type":"radio","name":"STARTS_WITH_YN","defaultValue":false,"options":[{"value":true,"label":"Starts with"},{"value":false,"label":"Contains"}]},{"type":"checkbox","name":"ACTIVE_ONLY_YN","defaultValue":true,"label":"Active entities only"},{"type":"text","name":"CITY","defaultValue":"","label":"City"},{"type":"select","name":"SERVICE_TYPE","label":"Special Services Offered","defaultValue":0,"options":[{"value":0,"label":"(N/A)"},{"value":6165,"label":"In-Person Electronic Notarization (IPEN)"},{"value":6166,"label":"Remote Online Notarization (RON)"},{"value":6167,"label":"Mobile Notary Services"},{"value":6168,"label":"Remote Ink Notarization (RIN)"}]}]},{"label":"Apostille","component":"Apostille","parameter":"apostille","sourceTypeId":720,"myRecordsSearch":false,"myWorkQueueSearch":false,"disabled":false,"allowedRoutes":["/forms-manager/","/queue/","/forms/"]},{"label":"Liens","component":"UCC","parameter":"ucc","sourceTypeId":1999,"myRecordsSearch":true,"myWorkQueueSearch":true,"fileAmendmentButtonLabel":"Filing Actions","searchPlaceholder":"Search by name or file number","disabled":false,"serverWebSearchDescription":true,"myRecordsDescription":"","workQueueDescription":"","searchDescription":"","hideRecordUserManagment":true,"searchLiensCheckout":false,"advancedSearchParameters":[{"type":"radio","name":"STARTS_WITH_YN","defaultValue":false,"options":[{"value":true,"label":"Starts with"},{"value":false,"label":"Contains"}]},{"type":"select","name":"STATUS","defaultValue":"ALL","label":"Status","options":[{"value":"ACTIVE_UNLAPSED","label":"Active (unlapsed)"},{"value":"ACTIVE_LAPSED_UNLAPSED","label":"Active (lapsed and unlapsed)"}]},{"type":"text","name":"EXCLUDE_VALUES","label":"Exclude Debtor Names (comma separated list of names to exclude)","defaultValue":""},{"type":"dateRange","name":"FILING_DATE","label":"Financing Statement Date","defaultValue":{"start":null,"end":null}},{"type":"dateRange","name":"LAPSE_DATE","label":"Lapse Date","defaultValue":{"start":null,"end":null}},{"type":"text","name":"CITY","label":"Debtor City","defaultValue":""}],"myRecordsFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Approved"},{"value":2,"label":"Pending Online Payment"},{"value":3,"label":"Pending Review"}]},{"type":"select","name":"TYPE","defaultValue":0,"label":"Lien Type","options":[{"value":0,"label":"All"},{"value":1,"label":"UCC"},{"value":2,"label":"EFS"},{"value":3,"label":"Title 71"}]}],"myWorkQueueFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Approved"},{"value":2,"label":"Pending Online Payment"},{"value":3,"label":"Pending Review"},{"value":4,"label":"Pending Print and Mail"},{"value":5,"label":"Rejected"},{"value":6,"label":"Draft"}]},{"type":"select","name":"TYPE","defaultValue":0,"label":"Lien Type","options":[{"value":0,"label":"All"},{"value":1,"label":"UCC"},{"value":2,"label":"EFS"},{"value":3,"label":"Title 71"}]}]},{"label":"Copy Request","component":"copies","parameter":"copies","sourceTypeId":2001,"myRecordsSearch":false,"myWorkQueueSearch":false,"disabled":false,"allowedRoutes":["/forms-manager/","/queue/","/forms/"]},{"label":"Trademark","component":"Trademark","parameter":"trademark","sourceTypeId":810,"showRequestCertificate":true,"searchMustHaveOneOf":["search","EXPIRATION_DATE","FILING_DATE"],"allowEmptySearchTerm":true,"requestCertificateAlternateLabel":"Request Information","fileAmendmentButtonLabel":"Filing Actions","advancedSearchParameters":[{"type":"radio","name":"QUERY_TYPE_ID","defaultValue":1010,"options":[{"value":1010,"label":"Starts with"},{"value":1011,"label":"Contains"},{"value":1012,"label":" Word Contains"}]},{"type":"checkbox","name":"OWNER_SEARCH_YN","defaultValue":false,"label":"Search owners"},{"type":"radio","name":"SERVICE_MARK_YN","label":"Mark Type","defaultValue":"","options":[{"value":"","label":"All Marks"},{"value":"Y","label":"Service Mark"},{"value":"N","label":"Trademark"}]},{"type":"serverSelect","name":"STATUS_ID","optionsSrc":"TYPE_V|TRADEMARK_STATUS_TYPE","label":"Status","placeholder":"All","defaultValue":"0"},{"type":"select","name":"DESIGN_TYPE_ID","options":[{"value":0,"label":"All"},{"value":990,"label":"Words Only"},{"value":991,"label":"Design Only"},{"value":992,"label":"Words and Design"}],"label":"Design Type","defaultValue":"0"},{"type":"dateRange","name":"FILING_DATE","label":"Registered Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}},{"type":"dateRange","name":"EXPIRATION_DATE","label":"Expiration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}}]},{"label":"Business Info Request","component":"InfoRequests","parameter":"info-request","sourceTypeId":167,"allowedRoutes":["/forms-manager/","/queue/","/forms/"]},{"label":"Data Requests","component":"DataRequests","parameter":"data-request","sourceTypeId":0,"allowedRoutes":["/forms-manager/"]},{"label":"CRA","component":"CRA","parameter":"cra","sourceTypeId":157,"myRecordsSearch":false,"searchPlaceholder":"Search by name or registered agent number","allowedRoutes":["/forms-manager/","/forms/","/records/","/queue/","/search/"],"allowEmptySearchTerm":true,"fileAmendmentButtonLabel":"Filing Actions","advancedSearchParameters":[{"type":"radio","name":"QUERY_TYPE_ID","defaultValue":1010,"options":[{"value":1010,"label":"Starts with"},{"value":1011,"label":"Contains"},{"value":1012,"label":" Word Contains"}]},{"type":"dateRange","name":"CRA_DATE","label":"Registration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}},{"type":"select","name":"STATUS_ID","label":"Status","defaultValue":0,"options":[{"value":0,"label":"All"},{"value":121,"label":"Active"},{"value":122,"label":"Inactive"}]},{"type":"select","name":"AGENT_TYPE_ID","label":"Agent Type","defaultValue":0,"options":[{"value":0,"label":"All"},{"value":460,"label":"Registered Agent"},{"value":461,"label":"Commercial Registered Agent"}]}]},{"label":"Farm Bill","component":"FarmBill","parameter":"farm-bill","path":"/lists/farm-bill","sourceTypeId":0,"myRecordsSearch":false,"allowedRules":["/search/"],"disabled":true,"searchDescription":"To perform a search, enter a debtor name. Your search results may include: exact debtor name, variations of that name and any filing that includes your search criteria. Punctuation is ignored.\n\nYou can click on \"Advanced\" to refine your search. Under “Advanced” you can search by crop, year, county and SSN/FEIN. As a registered Farm Bill Buyer with the Montana Secretary of State’s office it is important to maintain the confidentiality of the information contained within the Farm Bill Master List. The Farm Bill Master List reflects personal data, such as Social Security Numbers, which are a key piece of personal identifiable information to assist you in determining the existence of a lien against a specific debtor. The distribution of this information beyond its intended purpose is strictly prohibited.\n\nThe debtor's tax identification number has been hidden for confidentiality reasons. You may continue to search on a tax ID number and return debtors that match your search criteria. The SSN/FEIN must be entered without dashes or spaces.","searchMustHaveOneOf":["search","UCC_FARM_PRODUCT_ID","COUNTY"],"searchPlaceholder":"Search by debtor name","advancedSearchParameters":[{"type":"ServerMultiComplete","label":"Product code name(s)","name":"UCC_FARM_PRODUCT_ID","defaultValue":"","optionsSrc":"UCC_FARM_PRODUCT_V"},{"type":"MultiComplete","label":"Year or Range of Years","name":"YEAR_NUM","optionsSrc":"years","startYear":"1968","defaultValue":[],"preMergeOptions":[{"value":"ALL","label":"All"}]},{"type":"serverSelect","label":"State","name":"STATE","defaultValue":"MONTANA","optionsSrc":"STATE"},{"type":"ServerMultiComplete","label":"County","name":"COUNTY","defaultValue":[],"optionsSrc":"COUNTY","overrideSubOptionsSrcFromParameterName":"STATE"},{"type":"checkbox","name":"TIN_SEARCH_YN","defaultValue":false,"label":"Tax Identification Number Search"},{"type":"checkbox","name":"TIN_SORT_YN","defaultValue":false,"label":"Unique ID Sort"}]}],"SYSTEM_NICKNAME":"Online Services Portal","PAYMENT_METHODS":[{"type":"bypass"},{"type":"iTransact"}],"PAYMENT_ALLOW_AMEX":true,"SYSTEM_ID_LABEL":"System Id","DOUBLE_COLUMN_PUBLIC_LOGIN":true,"INTERNAL_USER_MANAGEMENT":true,"ALLOW_PUBLIC_JSON_IMPORT":false,"MAX_FILE_UPLOAD_SIZE":10000000,"REFUND_TEXT":"","RETURN_TO_HOME_ON_LOGOUT":true,"CURRENT_SOS_NAME":"Christi Jacobsen","LOGO_FILENAME":"mt-sos-logo.png","LOGO_ALT":"Christi Jacobsen, Montana Secretary of State","LOGO_FULL_WIDTH":true,"HOME_HIDE_AUTH_HINT":true,"HOME_TITLE":"Montana Secretary of State","CUSTOM_TAB_TITLE":"Official Montana","HOME_SUBTITLE":"Online Business Services","ENTITY_NAME_CONSENT_DESCRIPTION":"","ALLOW_USER_PROFILE_EDITING":true,"COMPARE_FOREIGN_NAME_IN_ENTITY_NAME_VALIDATION":true,"FOREIGN_NAME_FIELD_NAME":"KIMA_PARENT_NAME_INFO","LOGIN_TITLE":"Montana Secretary of State Online Filing Portal Login","PUBLIC_LOGIN_LABEL":"Username","REVERSE_LOGIN_COLUMNS":true,"LOGIN_SEAL_FILENAME":"seal_white.png","SEPARATE_USERNAME_AND_EMAIL":true,"CREATE_ACCOUNT_BUTTON_ALIGN_LEFT":true,"CREATE_ACCOUNT_BUTTON_TEXT":"CREATE AN ACCOUNT","PASSWORD_CUSTOM_ERROR_TEXT":"The password must meet all requirements","ACCOUNT_CREATED_MESSAGE":"Please check your email to verify your account to login and allow a few minutes for this message to arrive. Check your junk/spam folders if you do not find the email in your inbox.","PUBLIC_LOGIN_PLACEHOLDER":" ","DISABLE_DEFAULT_PAYMENT_RADIO":true,"CUSTOM_RESET_PASSWORD_ERROR_MESSAGE":"Username invalid - no account found","PUBLIC_LOGIN_CREATE_DESCRIPTION":"### Existing User:\n\n  - Enter your username and password to login.  \n\n\n  #### - OR -  \n\n\n\n  - Forgot password? Click 'Reset Password' and follow the prompts.\n  - Forgot username? Click 'Forgot Username' and follow the prompts.  \n\n\n  ### New User:\n  ","LOGIN_HELP_LINK":"https://sosmt.gov/business/how-do-i/","LOGIN_HELP_LINK_TEXT":"Need Help?","FORGOT_USERNAME_TEXT":"Forgot Username?","LOGIN_ACTIVE_DIRECTORY_TEXT":"State User Login","MULTIPLE_LOGIN_METHODS":true,"HAS_ACTIVE_DIRECTORY_LOGIN":true,"RESET_PASSWORD_WITH_USERNAME":true,"DOWNLOAD_LINK":true,"SHOW_USERNAME_ACCOUNT_CREATE":true,"SHOW_SCROLL_DOWN_ARROW":true,"SHOW_ADDRESS_ACCOUNT_CREATE":true,"TWO_COLUMN_ACCOUNT_CREATE":true,"RESET_PASSWORD_TIP":"A link to change your password has been sent to your email. Please allow a few minutes for this message to arrive. Please check your junk/spam folders if you do not find the email in your inbox.","FORGOT_PASSWORD_LINK_TEXT":"Reset Password","PHONE_NUMBER_OPTIONAL_ACCOUNT_CREATE":true,"SHOW_REQUIRED_INDICATOR_ACCOUNT_CREATE":true,"PASSWORD_REQUIREMENTS_ACCOUNT_CREATE":"\n    <ul>\n      <li>MUST contain at least 8 characters (12+ recommended)</li>\n      <li>MUST contain at least one uppercase letter.</li>\n      <li>MUST contain at least one lowercase letter.</li>\n      <li>MUST contain at least one number.</li>\n      <li>MUST contain at least one special character (!”#$%&'()*+,-./:;<=>?</li>\n    </ul>\n  ","ALLOW_CERTIFICATION_REQUEST":true,"ALLOW_PUBLIC_CERTIFICATE_REQUEST":true,"ALLOW_COPY_REQUEST":false,"ALLOW_CORRECTION_STYLING":true,"HIDE_DEPRECATION_WARNING":false,"AMEND_ROUTE_PUBLIC":true,"SEAL_FILENAME":"seal.png","SHOPPING_CART":true,"ALLOW_PAYMENT_UPDATE_WITH_EMPTY_CART":true,"RA_EMAIL":true,"RA_WEBSITE":true,"RA_NO_DEFAULT_TYPE":true,"RA_ADDRESS_LABEL":"Street Address","RA_TYPE_SELECTION_DEFAULT":true,"RA_DEFAULT_TYPE":"460","RA_OVERRIDE_TYPE_WITH_DEFAULT":true,"RA_PRINCIPAL_ADDRESS_AMS":true,"UPLOAD_AND_SUBMIT_HIDE_IF_ONE_OPTION":true,"PAYMENT_PROCESSING_MESSAGE":"Your payment is processing - Do not close your browser or click the back button","CHECKOUT_BUTTON_WHEN_PROCESSING_TEXT":"Processing","EFS_CROP_PICKER_NONE_LABEL":"Lien Duration","DISALLOWED_WIZARD_PIECES":["FormationLocale"],"REPEATER_SHOW_EDIT_BUTTON":true,"DATA_REQUEST_PAGE_TITLE":"Data Requests and Subscriptions","DATA_REQUEST_SIDEBAR_LABEL":"Data Requests & Subscriptions","LOGIN_REDIRECTS_TO_EPASS":false,"LOGIN_REDIRECTS_TO_ACTIVE_DIRECTORY":true,"LOGIN_ACTIVE_DIRECTORY_LINK":true,"FETCH_EDIT_USER_LINK":false,"LISTS_FETCH_AVAILABLE_LISTS":true,"POST_WIZARD_SUBMIT_REDIRECT_URL":"/","PIN_REQUEST_ATTESTATIONS":true,"PIN_REQUEST_DESCRIPTION":"Click **Request PIN** to have a new PIN sent to the account holder's email address on file.","OWNERSHIP_REQUEST_DESCRIPTION":"To become an **authorized user** of this record, a current **AUTHORIZED USER** will need to grant you access. To request access, click **Request Access** below.","PIN_REQUEST_SUCCESS_MESSAGE":"The PIN you have requested for this entity has been sent to the email associated with your user account.  You should receive the PIN in approximately 3-5 minutes, depending on your email service provider.","APOSTILLE_HEADER_LABEL":"Verification Information","APOSTILLE_NUMBER_LABEL":"Apostille/Authentication","APOSTILLE_CITY_STATE_OVERRIDE":"HELENA, MT","APOSTILLE_FILING_DATE_LABEL":"Issue Date","APOSTILLE_CITY_STATE_IN_CERTIFIED":true,"NOTARY_EXISTING_FILING":true,"ALLOW_REVOKE_OWN_ACCESS_ONLY":false,"HIDE_CANCEL_ON_ONETIME_DATA_REQUESTS":true,"DATA_REQUESTS_IN_SHOPPING_CART":true,"WQ_ALLOW_EDIT_PENDING_PAYMENT":true,"WQ_CONFIRM_ON_DELETE":true,"WQ_DELETE_CONFIRM_MESSAGE":"Deleting this filing will forfeit any money already paid to the Secretary of State. This action is permanent and cannot be undone, are you sure you would like to delete?","PASS_ITEM_GUIDS_ON_CHECKOUT":true,"FORM_REVISION_HISTORY":true,"CHECKOUT_DISCLAIMER":"By entering your credit card and/or checking account information you (i) state that **you are an authorized user** of the credit card and/or electronic check and that the associated information entered (e.g., account holder name, account number, billing address) is accurate, (ii) **you authorize payment processor to charge the amount you have requested** to your credit card and/or funding account, and (iii) **acknowledge if a charge is declined or reversed you may also be assessed a customary charge** by the payment processor for such transactions.","FARM_BILL_SEARCH_CONFIDENTIAL":"As a registered Farm Bill Buyer with the Montana Secretary of State’s office it is important to maintain the confidentiality of the information contained within the Farm Bill Master List. The Farm Bill Master List reflects personal data, such as Social Security Numbers, which are a key piece of personal identifiable information to assist you in determining the existence of a lien against a specific debtor. The distribution of this information beyond its intended purpose is strictly prohibited.\n\n**The debtor's tax identification number has been hidden for confidentiality reasons. You may continue to search on a tax ID number and return debtors that match your search criteria. The SSN/FEIN must be entered without dashes or spaces.  If you need access to the tax identification number to clearly identify the debtor, please contact the UCC unit at (406) 444-3665.**","VIEW_HISTORY_BUTTON_ALT_TEXT":"View Filings","WIZARD_ERROR_TITLE_MESSAGE":"Form Error","FARM_BILL_SEARCH_INTERACTIVE":true,"USE_FARM_BILL_API":true,"DISALLOW_ASSIGN_SELF_AS_RA":true,"DISALLOW_ASSIGN_SELF_AS_PRINCIPAL":true,"USE_TRADEMARK_OWNER_VALIDATION":true,"USE_ALTERNATIVE_FOREIGN_ADDRESS_LABELS":true,"MY_RECEIPTS_FILTER":[{"type":"dateRange","name":"DATE_RANGE","label":"Date range","defaultValue":{"start":null,"end":null}},{"type":"text","name":"REF_NUM","defaultValue":"","label":"Reference Number"},{"type":"text","name":"RECEIPT_NUM","defaultValue":"","label":"Receipt Id"},{"type":"text","name":"AMOUNT","defaultValue":"","label":"Amount"},{"type":"select","name":"TYPE","defaultValue":"","label":"Payment Type","options":[{"value":"","label":"All"},{"value":"CC","label":"Credit Card"},{"value":"Check","label":"Check"}]}],"MY_RECEIPTS_SHOW_IN_SIDEBAR":true,"SHOW_MY_RECEIPTS_HELPER_TEXT":true,"MY_RECEIPTS_HELPER_LABEL":"About Receipt Search","MY_RECEIPTS_HELPER_TEXT":"You can search for receipts based on their descriptions, including the items paid for on the receipt. Use the filters to search for or filter specific information.","FARM_BILL_SUBLINK":{"label":"Farm Bill","component":"FarmBill","parameter":"farm-bill","path":"/lists/farm-bill","sourceTypeId":0,"myRecordsSearch":false,"allowedRules":["/search/"],"disabled":true,"searchDescription":"To perform a search, enter a debtor name. Your search results may include: exact debtor name, variations of that name and any filing that includes your search criteria. Punctuation is ignored.\n\nYou can click on \"Advanced\" to refine your search. Under “Advanced” you can search by crop, year, county and SSN/FEIN. As a registered Farm Bill Buyer with the Montana Secretary of State’s office it is important to maintain the confidentiality of the information contained within the Farm Bill Master List. The Farm Bill Master List reflects personal data, such as Social Security Numbers, which are a key piece of personal identifiable information to assist you in determining the existence of a lien against a specific debtor. The distribution of this information beyond its intended purpose is strictly prohibited.\n\nThe debtor's tax identification number has been hidden for confidentiality reasons. You may continue to search on a tax ID number and return debtors that match your search criteria. The SSN/FEIN must be entered without dashes or spaces.","searchMustHaveOneOf":["search","UCC_FARM_PRODUCT_ID","COUNTY"],"searchPlaceholder":"Search by debtor name","advancedSearchParameters":[{"type":"ServerMultiComplete","label":"Product code name(s)","name":"UCC_FARM_PRODUCT_ID","defaultValue":"","optionsSrc":"UCC_FARM_PRODUCT_V"},{"type":"MultiComplete","label":"Year or Range of Years","name":"YEAR_NUM","optionsSrc":"years","startYear":"1968","defaultValue":[],"preMergeOptions":[{"value":"ALL","label":"All"}]},{"type":"serverSelect","label":"State","name":"STATE","defaultValue":"MONTANA","optionsSrc":"STATE"},{"type":"ServerMultiComplete","label":"County","name":"COUNTY","defaultValue":[],"optionsSrc":"COUNTY","overrideSubOptionsSrcFromParameterName":"STATE"},{"type":"checkbox","name":"TIN_SEARCH_YN","defaultValue":false,"label":"Tax Identification Number Search"},{"type":"checkbox","name":"TIN_SORT_YN","defaultValue":false,"label":"Unique ID Sort"}]},"ALLOW_ADDRESS_VALIDATION_BYPASS_OPTION":true,"DEFAULT_ADDRESS_VALIDATION_BYPASS_OPTION_CHECKED":true}).PIN_SWAP_ON_SUCCESS !== undefined ? ({"NODE_ENV":"production","BUILD_DATE":"2025-08-27T15:15:31.687Z","BUILD_NUMBER":"Not Provided","GIT_VERSION":"v1.3.0-381-ga81e29b08","GIT_COMMIT_HASH":"a81e29b085c9268ffd96c78eb734365802722741","GIT_BRANCH":"beta","PUBLIC_URL":"","STATE_ABBR":"MT","STATE_NAME":"Montana","STATE_ORG_TITLE":"Secretary of State","LOGIN_HEADER_IMG_PATH":"","HOME_IMG_FILENAME":"montana.jpg","FAVICON_FILE_NAME":"favicon.ico","ALLOW_E_SIGN_ON_CORRECTIONS":true,"THIRD_PARTY_SIGNING_ALLOWED":false,"MY_ACCOUNT_SAVE_AND_CLOSE_BUTTON":true,"IE_DEPRECATED_MESSAGE":"Internet Explorer is not supported. Please select a supported browser below to access this website.","ADDITIONAL_ROUTES":{"dataRequests":true,"farmBill":true,"apostille":true,"externalHelp":"https://sosmt.gov/business/help-center/","systemAdministration":[{"title":"Saved Payments","parameter":"saved-payments","componentName":"SavedPayments"}]},"SUBROUTES":[{"label":"Business","component":"Business","parameter":"business","myWorkQueueSearch":false,"sourceTypeId":54,"searchMustHaveOneOf":["FILING_TYPE_ID","STATUS_ID","STATE","search"],"serverWebSearchDescription":true,"serverWorkQueueDescription":true,"serverMyRecordsDescription":true,"searchPlaceholder":"Search by name or filing number (X########)","allowEmptySearchTerm":true,"requestCertificateAlternateLabel":"Request Information","fileAmendmentButtonLabel":"Filing Actions","advancedSearchParameters":[{"type":"radio","name":"QUERY_TYPE_ID","defaultValue":1010,"options":[{"value":1010,"label":"Starts with"},{"value":1011,"label":"Contains"},{"value":1012,"label":" Word Contains"}]},{"type":"serverSelect","name":"FILING_TYPE_ID","optionsSrc":"FILING_TYPES","label":"Entity Type","placeholder":"All","defaultValue":"0"},{"type":"serverSelect","name":"FILING_SUBTYPE_ID","optionsSrc":"FILING_SUBTYPES","label":"Entity Subtype","overrideSubOptionsSrcFromParameterName":"FILING_TYPE_ID","placeholder":"All","defaultValue":"0"},{"type":"serverSelect","name":"STATUS_ID","optionsSrc":"FILING_STATUS_WITHOUT_ALL","label":"Status","placeholder":"All","defaultValue":"0"},{"type":"serverSelect","name":"STATE","optionsSrc":"STATE","label":"State","placeholder":"All","defaultValue":""},{"type":"serverSelect","name":"COUNTY","optionsSrc":"COUNTY_SUBOPTION","label":"County","overrideSubOptionsSrcFromParameterName":"STATE","placeholder":"All","defaultValue":""},{"type":"checkbox","name":"CRA_SEARCH_YN","defaultValue":false,"label":"Search by Registered Agent PID"},{"type":"dateRange","name":"FILING_DATE","label":"Registration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}},{"type":"dateRange","name":"EXPIRATION_DATE","label":"Expiration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}}],"myRecordsFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Active"},{"value":2,"label":"Inactive"},{"value":3,"label":"Pending"}]},{"type":"dateRange","name":"DATE_RANGE","label":"Date range","defaultValue":{"start":null,"end":null}}],"myWorkQueueFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Approved"},{"value":2,"label":"Pending Online Payment"},{"value":3,"label":"Pending Review"},{"value":4,"label":"Needs Correction"},{"value":5,"label":"Rejected"},{"value":6,"label":"Draft"}]},{"type":"dateRange","name":"DATE_RANGE","label":"Date range","defaultValue":{"start":null,"end":null}}]},{"label":"Notary","component":"Notary","parameter":"notary","sourceTypeId":850,"myWorkQueueSearch":false,"allowEmptySearchTerm":true,"requestCertificateAlternateLabel":"Download Certificate","fileAmendmentButtonLabel":"Filing Actions","hideNameRequestCertificate":true,"hideAddressRequestCertificate":true,"hideRecordUserManagment":true,"searchPlaceholder":"Search by name or commission number","searchMustHaveOneOf":["CITY","search","SERVICE_TYPE"],"advancedParametersStartOpen":true,"searchIsSortable":true,"advancedSearchParameters":[{"type":"radio","name":"STARTS_WITH_YN","defaultValue":false,"options":[{"value":true,"label":"Starts with"},{"value":false,"label":"Contains"}]},{"type":"checkbox","name":"ACTIVE_ONLY_YN","defaultValue":true,"label":"Active entities only"},{"type":"text","name":"CITY","defaultValue":"","label":"City"},{"type":"select","name":"SERVICE_TYPE","label":"Special Services Offered","defaultValue":0,"options":[{"value":0,"label":"(N/A)"},{"value":6165,"label":"In-Person Electronic Notarization (IPEN)"},{"value":6166,"label":"Remote Online Notarization (RON)"},{"value":6167,"label":"Mobile Notary Services"},{"value":6168,"label":"Remote Ink Notarization (RIN)"}]}]},{"label":"Apostille","component":"Apostille","parameter":"apostille","sourceTypeId":720,"myRecordsSearch":false,"myWorkQueueSearch":false,"disabled":false,"allowedRoutes":["/forms-manager/","/queue/","/forms/"]},{"label":"Liens","component":"UCC","parameter":"ucc","sourceTypeId":1999,"myRecordsSearch":true,"myWorkQueueSearch":true,"fileAmendmentButtonLabel":"Filing Actions","searchPlaceholder":"Search by name or file number","disabled":false,"serverWebSearchDescription":true,"myRecordsDescription":"","workQueueDescription":"","searchDescription":"","hideRecordUserManagment":true,"searchLiensCheckout":false,"advancedSearchParameters":[{"type":"radio","name":"STARTS_WITH_YN","defaultValue":false,"options":[{"value":true,"label":"Starts with"},{"value":false,"label":"Contains"}]},{"type":"select","name":"STATUS","defaultValue":"ALL","label":"Status","options":[{"value":"ACTIVE_UNLAPSED","label":"Active (unlapsed)"},{"value":"ACTIVE_LAPSED_UNLAPSED","label":"Active (lapsed and unlapsed)"}]},{"type":"text","name":"EXCLUDE_VALUES","label":"Exclude Debtor Names (comma separated list of names to exclude)","defaultValue":""},{"type":"dateRange","name":"FILING_DATE","label":"Financing Statement Date","defaultValue":{"start":null,"end":null}},{"type":"dateRange","name":"LAPSE_DATE","label":"Lapse Date","defaultValue":{"start":null,"end":null}},{"type":"text","name":"CITY","label":"Debtor City","defaultValue":""}],"myRecordsFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Approved"},{"value":2,"label":"Pending Online Payment"},{"value":3,"label":"Pending Review"}]},{"type":"select","name":"TYPE","defaultValue":0,"label":"Lien Type","options":[{"value":0,"label":"All"},{"value":1,"label":"UCC"},{"value":2,"label":"EFS"},{"value":3,"label":"Title 71"}]}],"myWorkQueueFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Approved"},{"value":2,"label":"Pending Online Payment"},{"value":3,"label":"Pending Review"},{"value":4,"label":"Pending Print and Mail"},{"value":5,"label":"Rejected"},{"value":6,"label":"Draft"}]},{"type":"select","name":"TYPE","defaultValue":0,"label":"Lien Type","options":[{"value":0,"label":"All"},{"value":1,"label":"UCC"},{"value":2,"label":"EFS"},{"value":3,"label":"Title 71"}]}]},{"label":"Copy Request","component":"copies","parameter":"copies","sourceTypeId":2001,"myRecordsSearch":false,"myWorkQueueSearch":false,"disabled":false,"allowedRoutes":["/forms-manager/","/queue/","/forms/"]},{"label":"Trademark","component":"Trademark","parameter":"trademark","sourceTypeId":810,"showRequestCertificate":true,"searchMustHaveOneOf":["search","EXPIRATION_DATE","FILING_DATE"],"allowEmptySearchTerm":true,"requestCertificateAlternateLabel":"Request Information","fileAmendmentButtonLabel":"Filing Actions","advancedSearchParameters":[{"type":"radio","name":"QUERY_TYPE_ID","defaultValue":1010,"options":[{"value":1010,"label":"Starts with"},{"value":1011,"label":"Contains"},{"value":1012,"label":" Word Contains"}]},{"type":"checkbox","name":"OWNER_SEARCH_YN","defaultValue":false,"label":"Search owners"},{"type":"radio","name":"SERVICE_MARK_YN","label":"Mark Type","defaultValue":"","options":[{"value":"","label":"All Marks"},{"value":"Y","label":"Service Mark"},{"value":"N","label":"Trademark"}]},{"type":"serverSelect","name":"STATUS_ID","optionsSrc":"TYPE_V|TRADEMARK_STATUS_TYPE","label":"Status","placeholder":"All","defaultValue":"0"},{"type":"select","name":"DESIGN_TYPE_ID","options":[{"value":0,"label":"All"},{"value":990,"label":"Words Only"},{"value":991,"label":"Design Only"},{"value":992,"label":"Words and Design"}],"label":"Design Type","defaultValue":"0"},{"type":"dateRange","name":"FILING_DATE","label":"Registered Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}},{"type":"dateRange","name":"EXPIRATION_DATE","label":"Expiration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}}]},{"label":"Business Info Request","component":"InfoRequests","parameter":"info-request","sourceTypeId":167,"allowedRoutes":["/forms-manager/","/queue/","/forms/"]},{"label":"Data Requests","component":"DataRequests","parameter":"data-request","sourceTypeId":0,"allowedRoutes":["/forms-manager/"]},{"label":"CRA","component":"CRA","parameter":"cra","sourceTypeId":157,"myRecordsSearch":false,"searchPlaceholder":"Search by name or registered agent number","allowedRoutes":["/forms-manager/","/forms/","/records/","/queue/","/search/"],"allowEmptySearchTerm":true,"fileAmendmentButtonLabel":"Filing Actions","advancedSearchParameters":[{"type":"radio","name":"QUERY_TYPE_ID","defaultValue":1010,"options":[{"value":1010,"label":"Starts with"},{"value":1011,"label":"Contains"},{"value":1012,"label":" Word Contains"}]},{"type":"dateRange","name":"CRA_DATE","label":"Registration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}},{"type":"select","name":"STATUS_ID","label":"Status","defaultValue":0,"options":[{"value":0,"label":"All"},{"value":121,"label":"Active"},{"value":122,"label":"Inactive"}]},{"type":"select","name":"AGENT_TYPE_ID","label":"Agent Type","defaultValue":0,"options":[{"value":0,"label":"All"},{"value":460,"label":"Registered Agent"},{"value":461,"label":"Commercial Registered Agent"}]}]},{"label":"Farm Bill","component":"FarmBill","parameter":"farm-bill","path":"/lists/farm-bill","sourceTypeId":0,"myRecordsSearch":false,"allowedRules":["/search/"],"disabled":true,"searchDescription":"To perform a search, enter a debtor name. Your search results may include: exact debtor name, variations of that name and any filing that includes your search criteria. Punctuation is ignored.\n\nYou can click on \"Advanced\" to refine your search. Under “Advanced” you can search by crop, year, county and SSN/FEIN. As a registered Farm Bill Buyer with the Montana Secretary of State’s office it is important to maintain the confidentiality of the information contained within the Farm Bill Master List. The Farm Bill Master List reflects personal data, such as Social Security Numbers, which are a key piece of personal identifiable information to assist you in determining the existence of a lien against a specific debtor. The distribution of this information beyond its intended purpose is strictly prohibited.\n\nThe debtor's tax identification number has been hidden for confidentiality reasons. You may continue to search on a tax ID number and return debtors that match your search criteria. The SSN/FEIN must be entered without dashes or spaces.","searchMustHaveOneOf":["search","UCC_FARM_PRODUCT_ID","COUNTY"],"searchPlaceholder":"Search by debtor name","advancedSearchParameters":[{"type":"ServerMultiComplete","label":"Product code name(s)","name":"UCC_FARM_PRODUCT_ID","defaultValue":"","optionsSrc":"UCC_FARM_PRODUCT_V"},{"type":"MultiComplete","label":"Year or Range of Years","name":"YEAR_NUM","optionsSrc":"years","startYear":"1968","defaultValue":[],"preMergeOptions":[{"value":"ALL","label":"All"}]},{"type":"serverSelect","label":"State","name":"STATE","defaultValue":"MONTANA","optionsSrc":"STATE"},{"type":"ServerMultiComplete","label":"County","name":"COUNTY","defaultValue":[],"optionsSrc":"COUNTY","overrideSubOptionsSrcFromParameterName":"STATE"},{"type":"checkbox","name":"TIN_SEARCH_YN","defaultValue":false,"label":"Tax Identification Number Search"},{"type":"checkbox","name":"TIN_SORT_YN","defaultValue":false,"label":"Unique ID Sort"}]}],"SYSTEM_NICKNAME":"Online Services Portal","PAYMENT_METHODS":[{"type":"bypass"},{"type":"iTransact"}],"PAYMENT_ALLOW_AMEX":true,"SYSTEM_ID_LABEL":"System Id","DOUBLE_COLUMN_PUBLIC_LOGIN":true,"INTERNAL_USER_MANAGEMENT":true,"ALLOW_PUBLIC_JSON_IMPORT":false,"MAX_FILE_UPLOAD_SIZE":10000000,"REFUND_TEXT":"","RETURN_TO_HOME_ON_LOGOUT":true,"CURRENT_SOS_NAME":"Christi Jacobsen","LOGO_FILENAME":"mt-sos-logo.png","LOGO_ALT":"Christi Jacobsen, Montana Secretary of State","LOGO_FULL_WIDTH":true,"HOME_HIDE_AUTH_HINT":true,"HOME_TITLE":"Montana Secretary of State","CUSTOM_TAB_TITLE":"Official Montana","HOME_SUBTITLE":"Online Business Services","ENTITY_NAME_CONSENT_DESCRIPTION":"","ALLOW_USER_PROFILE_EDITING":true,"COMPARE_FOREIGN_NAME_IN_ENTITY_NAME_VALIDATION":true,"FOREIGN_NAME_FIELD_NAME":"KIMA_PARENT_NAME_INFO","LOGIN_TITLE":"Montana Secretary of State Online Filing Portal Login","PUBLIC_LOGIN_LABEL":"Username","REVERSE_LOGIN_COLUMNS":true,"LOGIN_SEAL_FILENAME":"seal_white.png","SEPARATE_USERNAME_AND_EMAIL":true,"CREATE_ACCOUNT_BUTTON_ALIGN_LEFT":true,"CREATE_ACCOUNT_BUTTON_TEXT":"CREATE AN ACCOUNT","PASSWORD_CUSTOM_ERROR_TEXT":"The password must meet all requirements","ACCOUNT_CREATED_MESSAGE":"Please check your email to verify your account to login and allow a few minutes for this message to arrive. Check your junk/spam folders if you do not find the email in your inbox.","PUBLIC_LOGIN_PLACEHOLDER":" ","DISABLE_DEFAULT_PAYMENT_RADIO":true,"CUSTOM_RESET_PASSWORD_ERROR_MESSAGE":"Username invalid - no account found","PUBLIC_LOGIN_CREATE_DESCRIPTION":"### Existing User:\n\n  - Enter your username and password to login.  \n\n\n  #### - OR -  \n\n\n\n  - Forgot password? Click 'Reset Password' and follow the prompts.\n  - Forgot username? Click 'Forgot Username' and follow the prompts.  \n\n\n  ### New User:\n  ","LOGIN_HELP_LINK":"https://sosmt.gov/business/how-do-i/","LOGIN_HELP_LINK_TEXT":"Need Help?","FORGOT_USERNAME_TEXT":"Forgot Username?","LOGIN_ACTIVE_DIRECTORY_TEXT":"State User Login","MULTIPLE_LOGIN_METHODS":true,"HAS_ACTIVE_DIRECTORY_LOGIN":true,"RESET_PASSWORD_WITH_USERNAME":true,"DOWNLOAD_LINK":true,"SHOW_USERNAME_ACCOUNT_CREATE":true,"SHOW_SCROLL_DOWN_ARROW":true,"SHOW_ADDRESS_ACCOUNT_CREATE":true,"TWO_COLUMN_ACCOUNT_CREATE":true,"RESET_PASSWORD_TIP":"A link to change your password has been sent to your email. Please allow a few minutes for this message to arrive. Please check your junk/spam folders if you do not find the email in your inbox.","FORGOT_PASSWORD_LINK_TEXT":"Reset Password","PHONE_NUMBER_OPTIONAL_ACCOUNT_CREATE":true,"SHOW_REQUIRED_INDICATOR_ACCOUNT_CREATE":true,"PASSWORD_REQUIREMENTS_ACCOUNT_CREATE":"\n    <ul>\n      <li>MUST contain at least 8 characters (12+ recommended)</li>\n      <li>MUST contain at least one uppercase letter.</li>\n      <li>MUST contain at least one lowercase letter.</li>\n      <li>MUST contain at least one number.</li>\n      <li>MUST contain at least one special character (!”#$%&'()*+,-./:;<=>?</li>\n    </ul>\n  ","ALLOW_CERTIFICATION_REQUEST":true,"ALLOW_PUBLIC_CERTIFICATE_REQUEST":true,"ALLOW_COPY_REQUEST":false,"ALLOW_CORRECTION_STYLING":true,"HIDE_DEPRECATION_WARNING":false,"AMEND_ROUTE_PUBLIC":true,"SEAL_FILENAME":"seal.png","SHOPPING_CART":true,"ALLOW_PAYMENT_UPDATE_WITH_EMPTY_CART":true,"RA_EMAIL":true,"RA_WEBSITE":true,"RA_NO_DEFAULT_TYPE":true,"RA_ADDRESS_LABEL":"Street Address","RA_TYPE_SELECTION_DEFAULT":true,"RA_DEFAULT_TYPE":"460","RA_OVERRIDE_TYPE_WITH_DEFAULT":true,"RA_PRINCIPAL_ADDRESS_AMS":true,"UPLOAD_AND_SUBMIT_HIDE_IF_ONE_OPTION":true,"PAYMENT_PROCESSING_MESSAGE":"Your payment is processing - Do not close your browser or click the back button","CHECKOUT_BUTTON_WHEN_PROCESSING_TEXT":"Processing","EFS_CROP_PICKER_NONE_LABEL":"Lien Duration","DISALLOWED_WIZARD_PIECES":["FormationLocale"],"REPEATER_SHOW_EDIT_BUTTON":true,"DATA_REQUEST_PAGE_TITLE":"Data Requests and Subscriptions","DATA_REQUEST_SIDEBAR_LABEL":"Data Requests & Subscriptions","LOGIN_REDIRECTS_TO_EPASS":false,"LOGIN_REDIRECTS_TO_ACTIVE_DIRECTORY":true,"LOGIN_ACTIVE_DIRECTORY_LINK":true,"FETCH_EDIT_USER_LINK":false,"LISTS_FETCH_AVAILABLE_LISTS":true,"POST_WIZARD_SUBMIT_REDIRECT_URL":"/","PIN_REQUEST_ATTESTATIONS":true,"PIN_REQUEST_DESCRIPTION":"Click **Request PIN** to have a new PIN sent to the account holder's email address on file.","OWNERSHIP_REQUEST_DESCRIPTION":"To become an **authorized user** of this record, a current **AUTHORIZED USER** will need to grant you access. To request access, click **Request Access** below.","PIN_REQUEST_SUCCESS_MESSAGE":"The PIN you have requested for this entity has been sent to the email associated with your user account.  You should receive the PIN in approximately 3-5 minutes, depending on your email service provider.","APOSTILLE_HEADER_LABEL":"Verification Information","APOSTILLE_NUMBER_LABEL":"Apostille/Authentication","APOSTILLE_CITY_STATE_OVERRIDE":"HELENA, MT","APOSTILLE_FILING_DATE_LABEL":"Issue Date","APOSTILLE_CITY_STATE_IN_CERTIFIED":true,"NOTARY_EXISTING_FILING":true,"ALLOW_REVOKE_OWN_ACCESS_ONLY":false,"HIDE_CANCEL_ON_ONETIME_DATA_REQUESTS":true,"DATA_REQUESTS_IN_SHOPPING_CART":true,"WQ_ALLOW_EDIT_PENDING_PAYMENT":true,"WQ_CONFIRM_ON_DELETE":true,"WQ_DELETE_CONFIRM_MESSAGE":"Deleting this filing will forfeit any money already paid to the Secretary of State. This action is permanent and cannot be undone, are you sure you would like to delete?","PASS_ITEM_GUIDS_ON_CHECKOUT":true,"FORM_REVISION_HISTORY":true,"CHECKOUT_DISCLAIMER":"By entering your credit card and/or checking account information you (i) state that **you are an authorized user** of the credit card and/or electronic check and that the associated information entered (e.g., account holder name, account number, billing address) is accurate, (ii) **you authorize payment processor to charge the amount you have requested** to your credit card and/or funding account, and (iii) **acknowledge if a charge is declined or reversed you may also be assessed a customary charge** by the payment processor for such transactions.","FARM_BILL_SEARCH_CONFIDENTIAL":"As a registered Farm Bill Buyer with the Montana Secretary of State’s office it is important to maintain the confidentiality of the information contained within the Farm Bill Master List. The Farm Bill Master List reflects personal data, such as Social Security Numbers, which are a key piece of personal identifiable information to assist you in determining the existence of a lien against a specific debtor. The distribution of this information beyond its intended purpose is strictly prohibited.\n\n**The debtor's tax identification number has been hidden for confidentiality reasons. You may continue to search on a tax ID number and return debtors that match your search criteria. The SSN/FEIN must be entered without dashes or spaces.  If you need access to the tax identification number to clearly identify the debtor, please contact the UCC unit at (406) 444-3665.**","VIEW_HISTORY_BUTTON_ALT_TEXT":"View Filings","WIZARD_ERROR_TITLE_MESSAGE":"Form Error","FARM_BILL_SEARCH_INTERACTIVE":true,"USE_FARM_BILL_API":true,"DISALLOW_ASSIGN_SELF_AS_RA":true,"DISALLOW_ASSIGN_SELF_AS_PRINCIPAL":true,"USE_TRADEMARK_OWNER_VALIDATION":true,"USE_ALTERNATIVE_FOREIGN_ADDRESS_LABELS":true,"MY_RECEIPTS_FILTER":[{"type":"dateRange","name":"DATE_RANGE","label":"Date range","defaultValue":{"start":null,"end":null}},{"type":"text","name":"REF_NUM","defaultValue":"","label":"Reference Number"},{"type":"text","name":"RECEIPT_NUM","defaultValue":"","label":"Receipt Id"},{"type":"text","name":"AMOUNT","defaultValue":"","label":"Amount"},{"type":"select","name":"TYPE","defaultValue":"","label":"Payment Type","options":[{"value":"","label":"All"},{"value":"CC","label":"Credit Card"},{"value":"Check","label":"Check"}]}],"MY_RECEIPTS_SHOW_IN_SIDEBAR":true,"SHOW_MY_RECEIPTS_HELPER_TEXT":true,"MY_RECEIPTS_HELPER_LABEL":"About Receipt Search","MY_RECEIPTS_HELPER_TEXT":"You can search for receipts based on their descriptions, including the items paid for on the receipt. Use the filters to search for or filter specific information.","FARM_BILL_SUBLINK":{"label":"Farm Bill","component":"FarmBill","parameter":"farm-bill","path":"/lists/farm-bill","sourceTypeId":0,"myRecordsSearch":false,"allowedRules":["/search/"],"disabled":true,"searchDescription":"To perform a search, enter a debtor name. Your search results may include: exact debtor name, variations of that name and any filing that includes your search criteria. Punctuation is ignored.\n\nYou can click on \"Advanced\" to refine your search. Under “Advanced” you can search by crop, year, county and SSN/FEIN. As a registered Farm Bill Buyer with the Montana Secretary of State’s office it is important to maintain the confidentiality of the information contained within the Farm Bill Master List. The Farm Bill Master List reflects personal data, such as Social Security Numbers, which are a key piece of personal identifiable information to assist you in determining the existence of a lien against a specific debtor. The distribution of this information beyond its intended purpose is strictly prohibited.\n\nThe debtor's tax identification number has been hidden for confidentiality reasons. You may continue to search on a tax ID number and return debtors that match your search criteria. The SSN/FEIN must be entered without dashes or spaces.","searchMustHaveOneOf":["search","UCC_FARM_PRODUCT_ID","COUNTY"],"searchPlaceholder":"Search by debtor name","advancedSearchParameters":[{"type":"ServerMultiComplete","label":"Product code name(s)","name":"UCC_FARM_PRODUCT_ID","defaultValue":"","optionsSrc":"UCC_FARM_PRODUCT_V"},{"type":"MultiComplete","label":"Year or Range of Years","name":"YEAR_NUM","optionsSrc":"years","startYear":"1968","defaultValue":[],"preMergeOptions":[{"value":"ALL","label":"All"}]},{"type":"serverSelect","label":"State","name":"STATE","defaultValue":"MONTANA","optionsSrc":"STATE"},{"type":"ServerMultiComplete","label":"County","name":"COUNTY","defaultValue":[],"optionsSrc":"COUNTY","overrideSubOptionsSrcFromParameterName":"STATE"},{"type":"checkbox","name":"TIN_SEARCH_YN","defaultValue":false,"label":"Tax Identification Number Search"},{"type":"checkbox","name":"TIN_SORT_YN","defaultValue":false,"label":"Unique ID Sort"}]},"ALLOW_ADDRESS_VALIDATION_BYPASS_OPTION":true,"DEFAULT_ADDRESS_VALIDATION_BYPASS_OPTION_CHECKED":true}).PIN_SWAP_ON_SUCCESS : true;
	var HIDE_REQUIRED_PIN_ATTESTATION_MESSAGE = ({"NODE_ENV":"production","BUILD_DATE":"2025-08-27T15:15:31.687Z","BUILD_NUMBER":"Not Provided","GIT_VERSION":"v1.3.0-381-ga81e29b08","GIT_COMMIT_HASH":"a81e29b085c9268ffd96c78eb734365802722741","GIT_BRANCH":"beta","PUBLIC_URL":"","STATE_ABBR":"MT","STATE_NAME":"Montana","STATE_ORG_TITLE":"Secretary of State","LOGIN_HEADER_IMG_PATH":"","HOME_IMG_FILENAME":"montana.jpg","FAVICON_FILE_NAME":"favicon.ico","ALLOW_E_SIGN_ON_CORRECTIONS":true,"THIRD_PARTY_SIGNING_ALLOWED":false,"MY_ACCOUNT_SAVE_AND_CLOSE_BUTTON":true,"IE_DEPRECATED_MESSAGE":"Internet Explorer is not supported. Please select a supported browser below to access this website.","ADDITIONAL_ROUTES":{"dataRequests":true,"farmBill":true,"apostille":true,"externalHelp":"https://sosmt.gov/business/help-center/","systemAdministration":[{"title":"Saved Payments","parameter":"saved-payments","componentName":"SavedPayments"}]},"SUBROUTES":[{"label":"Business","component":"Business","parameter":"business","myWorkQueueSearch":false,"sourceTypeId":54,"searchMustHaveOneOf":["FILING_TYPE_ID","STATUS_ID","STATE","search"],"serverWebSearchDescription":true,"serverWorkQueueDescription":true,"serverMyRecordsDescription":true,"searchPlaceholder":"Search by name or filing number (X########)","allowEmptySearchTerm":true,"requestCertificateAlternateLabel":"Request Information","fileAmendmentButtonLabel":"Filing Actions","advancedSearchParameters":[{"type":"radio","name":"QUERY_TYPE_ID","defaultValue":1010,"options":[{"value":1010,"label":"Starts with"},{"value":1011,"label":"Contains"},{"value":1012,"label":" Word Contains"}]},{"type":"serverSelect","name":"FILING_TYPE_ID","optionsSrc":"FILING_TYPES","label":"Entity Type","placeholder":"All","defaultValue":"0"},{"type":"serverSelect","name":"FILING_SUBTYPE_ID","optionsSrc":"FILING_SUBTYPES","label":"Entity Subtype","overrideSubOptionsSrcFromParameterName":"FILING_TYPE_ID","placeholder":"All","defaultValue":"0"},{"type":"serverSelect","name":"STATUS_ID","optionsSrc":"FILING_STATUS_WITHOUT_ALL","label":"Status","placeholder":"All","defaultValue":"0"},{"type":"serverSelect","name":"STATE","optionsSrc":"STATE","label":"State","placeholder":"All","defaultValue":""},{"type":"serverSelect","name":"COUNTY","optionsSrc":"COUNTY_SUBOPTION","label":"County","overrideSubOptionsSrcFromParameterName":"STATE","placeholder":"All","defaultValue":""},{"type":"checkbox","name":"CRA_SEARCH_YN","defaultValue":false,"label":"Search by Registered Agent PID"},{"type":"dateRange","name":"FILING_DATE","label":"Registration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}},{"type":"dateRange","name":"EXPIRATION_DATE","label":"Expiration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}}],"myRecordsFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Active"},{"value":2,"label":"Inactive"},{"value":3,"label":"Pending"}]},{"type":"dateRange","name":"DATE_RANGE","label":"Date range","defaultValue":{"start":null,"end":null}}],"myWorkQueueFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Approved"},{"value":2,"label":"Pending Online Payment"},{"value":3,"label":"Pending Review"},{"value":4,"label":"Needs Correction"},{"value":5,"label":"Rejected"},{"value":6,"label":"Draft"}]},{"type":"dateRange","name":"DATE_RANGE","label":"Date range","defaultValue":{"start":null,"end":null}}]},{"label":"Notary","component":"Notary","parameter":"notary","sourceTypeId":850,"myWorkQueueSearch":false,"allowEmptySearchTerm":true,"requestCertificateAlternateLabel":"Download Certificate","fileAmendmentButtonLabel":"Filing Actions","hideNameRequestCertificate":true,"hideAddressRequestCertificate":true,"hideRecordUserManagment":true,"searchPlaceholder":"Search by name or commission number","searchMustHaveOneOf":["CITY","search","SERVICE_TYPE"],"advancedParametersStartOpen":true,"searchIsSortable":true,"advancedSearchParameters":[{"type":"radio","name":"STARTS_WITH_YN","defaultValue":false,"options":[{"value":true,"label":"Starts with"},{"value":false,"label":"Contains"}]},{"type":"checkbox","name":"ACTIVE_ONLY_YN","defaultValue":true,"label":"Active entities only"},{"type":"text","name":"CITY","defaultValue":"","label":"City"},{"type":"select","name":"SERVICE_TYPE","label":"Special Services Offered","defaultValue":0,"options":[{"value":0,"label":"(N/A)"},{"value":6165,"label":"In-Person Electronic Notarization (IPEN)"},{"value":6166,"label":"Remote Online Notarization (RON)"},{"value":6167,"label":"Mobile Notary Services"},{"value":6168,"label":"Remote Ink Notarization (RIN)"}]}]},{"label":"Apostille","component":"Apostille","parameter":"apostille","sourceTypeId":720,"myRecordsSearch":false,"myWorkQueueSearch":false,"disabled":false,"allowedRoutes":["/forms-manager/","/queue/","/forms/"]},{"label":"Liens","component":"UCC","parameter":"ucc","sourceTypeId":1999,"myRecordsSearch":true,"myWorkQueueSearch":true,"fileAmendmentButtonLabel":"Filing Actions","searchPlaceholder":"Search by name or file number","disabled":false,"serverWebSearchDescription":true,"myRecordsDescription":"","workQueueDescription":"","searchDescription":"","hideRecordUserManagment":true,"searchLiensCheckout":false,"advancedSearchParameters":[{"type":"radio","name":"STARTS_WITH_YN","defaultValue":false,"options":[{"value":true,"label":"Starts with"},{"value":false,"label":"Contains"}]},{"type":"select","name":"STATUS","defaultValue":"ALL","label":"Status","options":[{"value":"ACTIVE_UNLAPSED","label":"Active (unlapsed)"},{"value":"ACTIVE_LAPSED_UNLAPSED","label":"Active (lapsed and unlapsed)"}]},{"type":"text","name":"EXCLUDE_VALUES","label":"Exclude Debtor Names (comma separated list of names to exclude)","defaultValue":""},{"type":"dateRange","name":"FILING_DATE","label":"Financing Statement Date","defaultValue":{"start":null,"end":null}},{"type":"dateRange","name":"LAPSE_DATE","label":"Lapse Date","defaultValue":{"start":null,"end":null}},{"type":"text","name":"CITY","label":"Debtor City","defaultValue":""}],"myRecordsFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Approved"},{"value":2,"label":"Pending Online Payment"},{"value":3,"label":"Pending Review"}]},{"type":"select","name":"TYPE","defaultValue":0,"label":"Lien Type","options":[{"value":0,"label":"All"},{"value":1,"label":"UCC"},{"value":2,"label":"EFS"},{"value":3,"label":"Title 71"}]}],"myWorkQueueFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Approved"},{"value":2,"label":"Pending Online Payment"},{"value":3,"label":"Pending Review"},{"value":4,"label":"Pending Print and Mail"},{"value":5,"label":"Rejected"},{"value":6,"label":"Draft"}]},{"type":"select","name":"TYPE","defaultValue":0,"label":"Lien Type","options":[{"value":0,"label":"All"},{"value":1,"label":"UCC"},{"value":2,"label":"EFS"},{"value":3,"label":"Title 71"}]}]},{"label":"Copy Request","component":"copies","parameter":"copies","sourceTypeId":2001,"myRecordsSearch":false,"myWorkQueueSearch":false,"disabled":false,"allowedRoutes":["/forms-manager/","/queue/","/forms/"]},{"label":"Trademark","component":"Trademark","parameter":"trademark","sourceTypeId":810,"showRequestCertificate":true,"searchMustHaveOneOf":["search","EXPIRATION_DATE","FILING_DATE"],"allowEmptySearchTerm":true,"requestCertificateAlternateLabel":"Request Information","fileAmendmentButtonLabel":"Filing Actions","advancedSearchParameters":[{"type":"radio","name":"QUERY_TYPE_ID","defaultValue":1010,"options":[{"value":1010,"label":"Starts with"},{"value":1011,"label":"Contains"},{"value":1012,"label":" Word Contains"}]},{"type":"checkbox","name":"OWNER_SEARCH_YN","defaultValue":false,"label":"Search owners"},{"type":"radio","name":"SERVICE_MARK_YN","label":"Mark Type","defaultValue":"","options":[{"value":"","label":"All Marks"},{"value":"Y","label":"Service Mark"},{"value":"N","label":"Trademark"}]},{"type":"serverSelect","name":"STATUS_ID","optionsSrc":"TYPE_V|TRADEMARK_STATUS_TYPE","label":"Status","placeholder":"All","defaultValue":"0"},{"type":"select","name":"DESIGN_TYPE_ID","options":[{"value":0,"label":"All"},{"value":990,"label":"Words Only"},{"value":991,"label":"Design Only"},{"value":992,"label":"Words and Design"}],"label":"Design Type","defaultValue":"0"},{"type":"dateRange","name":"FILING_DATE","label":"Registered Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}},{"type":"dateRange","name":"EXPIRATION_DATE","label":"Expiration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}}]},{"label":"Business Info Request","component":"InfoRequests","parameter":"info-request","sourceTypeId":167,"allowedRoutes":["/forms-manager/","/queue/","/forms/"]},{"label":"Data Requests","component":"DataRequests","parameter":"data-request","sourceTypeId":0,"allowedRoutes":["/forms-manager/"]},{"label":"CRA","component":"CRA","parameter":"cra","sourceTypeId":157,"myRecordsSearch":false,"searchPlaceholder":"Search by name or registered agent number","allowedRoutes":["/forms-manager/","/forms/","/records/","/queue/","/search/"],"allowEmptySearchTerm":true,"fileAmendmentButtonLabel":"Filing Actions","advancedSearchParameters":[{"type":"radio","name":"QUERY_TYPE_ID","defaultValue":1010,"options":[{"value":1010,"label":"Starts with"},{"value":1011,"label":"Contains"},{"value":1012,"label":" Word Contains"}]},{"type":"dateRange","name":"CRA_DATE","label":"Registration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}},{"type":"select","name":"STATUS_ID","label":"Status","defaultValue":0,"options":[{"value":0,"label":"All"},{"value":121,"label":"Active"},{"value":122,"label":"Inactive"}]},{"type":"select","name":"AGENT_TYPE_ID","label":"Agent Type","defaultValue":0,"options":[{"value":0,"label":"All"},{"value":460,"label":"Registered Agent"},{"value":461,"label":"Commercial Registered Agent"}]}]},{"label":"Farm Bill","component":"FarmBill","parameter":"farm-bill","path":"/lists/farm-bill","sourceTypeId":0,"myRecordsSearch":false,"allowedRules":["/search/"],"disabled":true,"searchDescription":"To perform a search, enter a debtor name. Your search results may include: exact debtor name, variations of that name and any filing that includes your search criteria. Punctuation is ignored.\n\nYou can click on \"Advanced\" to refine your search. Under “Advanced” you can search by crop, year, county and SSN/FEIN. As a registered Farm Bill Buyer with the Montana Secretary of State’s office it is important to maintain the confidentiality of the information contained within the Farm Bill Master List. The Farm Bill Master List reflects personal data, such as Social Security Numbers, which are a key piece of personal identifiable information to assist you in determining the existence of a lien against a specific debtor. The distribution of this information beyond its intended purpose is strictly prohibited.\n\nThe debtor's tax identification number has been hidden for confidentiality reasons. You may continue to search on a tax ID number and return debtors that match your search criteria. The SSN/FEIN must be entered without dashes or spaces.","searchMustHaveOneOf":["search","UCC_FARM_PRODUCT_ID","COUNTY"],"searchPlaceholder":"Search by debtor name","advancedSearchParameters":[{"type":"ServerMultiComplete","label":"Product code name(s)","name":"UCC_FARM_PRODUCT_ID","defaultValue":"","optionsSrc":"UCC_FARM_PRODUCT_V"},{"type":"MultiComplete","label":"Year or Range of Years","name":"YEAR_NUM","optionsSrc":"years","startYear":"1968","defaultValue":[],"preMergeOptions":[{"value":"ALL","label":"All"}]},{"type":"serverSelect","label":"State","name":"STATE","defaultValue":"MONTANA","optionsSrc":"STATE"},{"type":"ServerMultiComplete","label":"County","name":"COUNTY","defaultValue":[],"optionsSrc":"COUNTY","overrideSubOptionsSrcFromParameterName":"STATE"},{"type":"checkbox","name":"TIN_SEARCH_YN","defaultValue":false,"label":"Tax Identification Number Search"},{"type":"checkbox","name":"TIN_SORT_YN","defaultValue":false,"label":"Unique ID Sort"}]}],"SYSTEM_NICKNAME":"Online Services Portal","PAYMENT_METHODS":[{"type":"bypass"},{"type":"iTransact"}],"PAYMENT_ALLOW_AMEX":true,"SYSTEM_ID_LABEL":"System Id","DOUBLE_COLUMN_PUBLIC_LOGIN":true,"INTERNAL_USER_MANAGEMENT":true,"ALLOW_PUBLIC_JSON_IMPORT":false,"MAX_FILE_UPLOAD_SIZE":10000000,"REFUND_TEXT":"","RETURN_TO_HOME_ON_LOGOUT":true,"CURRENT_SOS_NAME":"Christi Jacobsen","LOGO_FILENAME":"mt-sos-logo.png","LOGO_ALT":"Christi Jacobsen, Montana Secretary of State","LOGO_FULL_WIDTH":true,"HOME_HIDE_AUTH_HINT":true,"HOME_TITLE":"Montana Secretary of State","CUSTOM_TAB_TITLE":"Official Montana","HOME_SUBTITLE":"Online Business Services","ENTITY_NAME_CONSENT_DESCRIPTION":"","ALLOW_USER_PROFILE_EDITING":true,"COMPARE_FOREIGN_NAME_IN_ENTITY_NAME_VALIDATION":true,"FOREIGN_NAME_FIELD_NAME":"KIMA_PARENT_NAME_INFO","LOGIN_TITLE":"Montana Secretary of State Online Filing Portal Login","PUBLIC_LOGIN_LABEL":"Username","REVERSE_LOGIN_COLUMNS":true,"LOGIN_SEAL_FILENAME":"seal_white.png","SEPARATE_USERNAME_AND_EMAIL":true,"CREATE_ACCOUNT_BUTTON_ALIGN_LEFT":true,"CREATE_ACCOUNT_BUTTON_TEXT":"CREATE AN ACCOUNT","PASSWORD_CUSTOM_ERROR_TEXT":"The password must meet all requirements","ACCOUNT_CREATED_MESSAGE":"Please check your email to verify your account to login and allow a few minutes for this message to arrive. Check your junk/spam folders if you do not find the email in your inbox.","PUBLIC_LOGIN_PLACEHOLDER":" ","DISABLE_DEFAULT_PAYMENT_RADIO":true,"CUSTOM_RESET_PASSWORD_ERROR_MESSAGE":"Username invalid - no account found","PUBLIC_LOGIN_CREATE_DESCRIPTION":"### Existing User:\n\n  - Enter your username and password to login.  \n\n\n  #### - OR -  \n\n\n\n  - Forgot password? Click 'Reset Password' and follow the prompts.\n  - Forgot username? Click 'Forgot Username' and follow the prompts.  \n\n\n  ### New User:\n  ","LOGIN_HELP_LINK":"https://sosmt.gov/business/how-do-i/","LOGIN_HELP_LINK_TEXT":"Need Help?","FORGOT_USERNAME_TEXT":"Forgot Username?","LOGIN_ACTIVE_DIRECTORY_TEXT":"State User Login","MULTIPLE_LOGIN_METHODS":true,"HAS_ACTIVE_DIRECTORY_LOGIN":true,"RESET_PASSWORD_WITH_USERNAME":true,"DOWNLOAD_LINK":true,"SHOW_USERNAME_ACCOUNT_CREATE":true,"SHOW_SCROLL_DOWN_ARROW":true,"SHOW_ADDRESS_ACCOUNT_CREATE":true,"TWO_COLUMN_ACCOUNT_CREATE":true,"RESET_PASSWORD_TIP":"A link to change your password has been sent to your email. Please allow a few minutes for this message to arrive. Please check your junk/spam folders if you do not find the email in your inbox.","FORGOT_PASSWORD_LINK_TEXT":"Reset Password","PHONE_NUMBER_OPTIONAL_ACCOUNT_CREATE":true,"SHOW_REQUIRED_INDICATOR_ACCOUNT_CREATE":true,"PASSWORD_REQUIREMENTS_ACCOUNT_CREATE":"\n    <ul>\n      <li>MUST contain at least 8 characters (12+ recommended)</li>\n      <li>MUST contain at least one uppercase letter.</li>\n      <li>MUST contain at least one lowercase letter.</li>\n      <li>MUST contain at least one number.</li>\n      <li>MUST contain at least one special character (!”#$%&'()*+,-./:;<=>?</li>\n    </ul>\n  ","ALLOW_CERTIFICATION_REQUEST":true,"ALLOW_PUBLIC_CERTIFICATE_REQUEST":true,"ALLOW_COPY_REQUEST":false,"ALLOW_CORRECTION_STYLING":true,"HIDE_DEPRECATION_WARNING":false,"AMEND_ROUTE_PUBLIC":true,"SEAL_FILENAME":"seal.png","SHOPPING_CART":true,"ALLOW_PAYMENT_UPDATE_WITH_EMPTY_CART":true,"RA_EMAIL":true,"RA_WEBSITE":true,"RA_NO_DEFAULT_TYPE":true,"RA_ADDRESS_LABEL":"Street Address","RA_TYPE_SELECTION_DEFAULT":true,"RA_DEFAULT_TYPE":"460","RA_OVERRIDE_TYPE_WITH_DEFAULT":true,"RA_PRINCIPAL_ADDRESS_AMS":true,"UPLOAD_AND_SUBMIT_HIDE_IF_ONE_OPTION":true,"PAYMENT_PROCESSING_MESSAGE":"Your payment is processing - Do not close your browser or click the back button","CHECKOUT_BUTTON_WHEN_PROCESSING_TEXT":"Processing","EFS_CROP_PICKER_NONE_LABEL":"Lien Duration","DISALLOWED_WIZARD_PIECES":["FormationLocale"],"REPEATER_SHOW_EDIT_BUTTON":true,"DATA_REQUEST_PAGE_TITLE":"Data Requests and Subscriptions","DATA_REQUEST_SIDEBAR_LABEL":"Data Requests & Subscriptions","LOGIN_REDIRECTS_TO_EPASS":false,"LOGIN_REDIRECTS_TO_ACTIVE_DIRECTORY":true,"LOGIN_ACTIVE_DIRECTORY_LINK":true,"FETCH_EDIT_USER_LINK":false,"LISTS_FETCH_AVAILABLE_LISTS":true,"POST_WIZARD_SUBMIT_REDIRECT_URL":"/","PIN_REQUEST_ATTESTATIONS":true,"PIN_REQUEST_DESCRIPTION":"Click **Request PIN** to have a new PIN sent to the account holder's email address on file.","OWNERSHIP_REQUEST_DESCRIPTION":"To become an **authorized user** of this record, a current **AUTHORIZED USER** will need to grant you access. To request access, click **Request Access** below.","PIN_REQUEST_SUCCESS_MESSAGE":"The PIN you have requested for this entity has been sent to the email associated with your user account.  You should receive the PIN in approximately 3-5 minutes, depending on your email service provider.","APOSTILLE_HEADER_LABEL":"Verification Information","APOSTILLE_NUMBER_LABEL":"Apostille/Authentication","APOSTILLE_CITY_STATE_OVERRIDE":"HELENA, MT","APOSTILLE_FILING_DATE_LABEL":"Issue Date","APOSTILLE_CITY_STATE_IN_CERTIFIED":true,"NOTARY_EXISTING_FILING":true,"ALLOW_REVOKE_OWN_ACCESS_ONLY":false,"HIDE_CANCEL_ON_ONETIME_DATA_REQUESTS":true,"DATA_REQUESTS_IN_SHOPPING_CART":true,"WQ_ALLOW_EDIT_PENDING_PAYMENT":true,"WQ_CONFIRM_ON_DELETE":true,"WQ_DELETE_CONFIRM_MESSAGE":"Deleting this filing will forfeit any money already paid to the Secretary of State. This action is permanent and cannot be undone, are you sure you would like to delete?","PASS_ITEM_GUIDS_ON_CHECKOUT":true,"FORM_REVISION_HISTORY":true,"CHECKOUT_DISCLAIMER":"By entering your credit card and/or checking account information you (i) state that **you are an authorized user** of the credit card and/or electronic check and that the associated information entered (e.g., account holder name, account number, billing address) is accurate, (ii) **you authorize payment processor to charge the amount you have requested** to your credit card and/or funding account, and (iii) **acknowledge if a charge is declined or reversed you may also be assessed a customary charge** by the payment processor for such transactions.","FARM_BILL_SEARCH_CONFIDENTIAL":"As a registered Farm Bill Buyer with the Montana Secretary of State’s office it is important to maintain the confidentiality of the information contained within the Farm Bill Master List. The Farm Bill Master List reflects personal data, such as Social Security Numbers, which are a key piece of personal identifiable information to assist you in determining the existence of a lien against a specific debtor. The distribution of this information beyond its intended purpose is strictly prohibited.\n\n**The debtor's tax identification number has been hidden for confidentiality reasons. You may continue to search on a tax ID number and return debtors that match your search criteria. The SSN/FEIN must be entered without dashes or spaces.  If you need access to the tax identification number to clearly identify the debtor, please contact the UCC unit at (406) 444-3665.**","VIEW_HISTORY_BUTTON_ALT_TEXT":"View Filings","WIZARD_ERROR_TITLE_MESSAGE":"Form Error","FARM_BILL_SEARCH_INTERACTIVE":true,"USE_FARM_BILL_API":true,"DISALLOW_ASSIGN_SELF_AS_RA":true,"DISALLOW_ASSIGN_SELF_AS_PRINCIPAL":true,"USE_TRADEMARK_OWNER_VALIDATION":true,"USE_ALTERNATIVE_FOREIGN_ADDRESS_LABELS":true,"MY_RECEIPTS_FILTER":[{"type":"dateRange","name":"DATE_RANGE","label":"Date range","defaultValue":{"start":null,"end":null}},{"type":"text","name":"REF_NUM","defaultValue":"","label":"Reference Number"},{"type":"text","name":"RECEIPT_NUM","defaultValue":"","label":"Receipt Id"},{"type":"text","name":"AMOUNT","defaultValue":"","label":"Amount"},{"type":"select","name":"TYPE","defaultValue":"","label":"Payment Type","options":[{"value":"","label":"All"},{"value":"CC","label":"Credit Card"},{"value":"Check","label":"Check"}]}],"MY_RECEIPTS_SHOW_IN_SIDEBAR":true,"SHOW_MY_RECEIPTS_HELPER_TEXT":true,"MY_RECEIPTS_HELPER_LABEL":"About Receipt Search","MY_RECEIPTS_HELPER_TEXT":"You can search for receipts based on their descriptions, including the items paid for on the receipt. Use the filters to search for or filter specific information.","FARM_BILL_SUBLINK":{"label":"Farm Bill","component":"FarmBill","parameter":"farm-bill","path":"/lists/farm-bill","sourceTypeId":0,"myRecordsSearch":false,"allowedRules":["/search/"],"disabled":true,"searchDescription":"To perform a search, enter a debtor name. Your search results may include: exact debtor name, variations of that name and any filing that includes your search criteria. Punctuation is ignored.\n\nYou can click on \"Advanced\" to refine your search. Under “Advanced” you can search by crop, year, county and SSN/FEIN. As a registered Farm Bill Buyer with the Montana Secretary of State’s office it is important to maintain the confidentiality of the information contained within the Farm Bill Master List. The Farm Bill Master List reflects personal data, such as Social Security Numbers, which are a key piece of personal identifiable information to assist you in determining the existence of a lien against a specific debtor. The distribution of this information beyond its intended purpose is strictly prohibited.\n\nThe debtor's tax identification number has been hidden for confidentiality reasons. You may continue to search on a tax ID number and return debtors that match your search criteria. The SSN/FEIN must be entered without dashes or spaces.","searchMustHaveOneOf":["search","UCC_FARM_PRODUCT_ID","COUNTY"],"searchPlaceholder":"Search by debtor name","advancedSearchParameters":[{"type":"ServerMultiComplete","label":"Product code name(s)","name":"UCC_FARM_PRODUCT_ID","defaultValue":"","optionsSrc":"UCC_FARM_PRODUCT_V"},{"type":"MultiComplete","label":"Year or Range of Years","name":"YEAR_NUM","optionsSrc":"years","startYear":"1968","defaultValue":[],"preMergeOptions":[{"value":"ALL","label":"All"}]},{"type":"serverSelect","label":"State","name":"STATE","defaultValue":"MONTANA","optionsSrc":"STATE"},{"type":"ServerMultiComplete","label":"County","name":"COUNTY","defaultValue":[],"optionsSrc":"COUNTY","overrideSubOptionsSrcFromParameterName":"STATE"},{"type":"checkbox","name":"TIN_SEARCH_YN","defaultValue":false,"label":"Tax Identification Number Search"},{"type":"checkbox","name":"TIN_SORT_YN","defaultValue":false,"label":"Unique ID Sort"}]},"ALLOW_ADDRESS_VALIDATION_BYPASS_OPTION":true,"DEFAULT_ADDRESS_VALIDATION_BYPASS_OPTION_CHECKED":true}).HIDE_REQUIRED_PIN_ATTESTATION_MESSAGE;
	
	var Pins = function (_Component) {
	  _inherits(Pins, _Component);
	
	  function Pins() {
	    _classCallCheck(this, Pins);
	
	    var _this = _possibleConstructorReturn(this, (Pins.__proto__ || Object.getPrototypeOf(Pins)).call(this));
	
	    _this.componentDidMount = function () {
	      _this.getNumActivePins();
	    };
	
	    _this.getNumActivePins = function () {
	      (0, _requests.GET_RECORD_HAS_ACTIVE_PIN)(_this.props.category, _this.props.source_id, function (recordHasActivePin) {
	        _this.setState({ recordHasActivePin: recordHasActivePin });
	      });
	    };
	
	    _this.checkPin = function () {
	      var SOURCE_TYPE_ID = (0, _utilities.getSourceTypeId)(_this.props.category);
	      (0, _requests.GET_WEB_USER_ACCESS_WITH_PIN)({
	        PIN_NUM: _this.pinSection.getValue().value,
	        SOURCE_TYPE_ID: SOURCE_TYPE_ID,
	        SOURCE_ID: _this.props.source_id
	      }, function (accepted) {
	        if (accepted) {
	          if (PIN_SWAP_ON_SUCCESS) {
	            _this.props.onPinSuccess();
	          } else {
	            _this.setState({ pinCorrect: true });
	          }
	        } else {
	          _this.setState({ pinCorrect: false });
	        }
	      }, function (err) {
	        _this.setState({ pinCorrect: false, error: err.message });
	      });
	    };
	
	    _this.requestPin = function () {
	      (0, _requests.REQUEST_NEW_PIN)(_this.props.category, _this.props.source_id, function (success) {
	        _this.setState({ pinRequestSuccessful: success });
	        _this.getNumActivePins();
	      }, function (err) {
	        _this.setState({
	          error: "Something went wrong. Please try again later, and if the problem persists please contact customer support."
	        });
	      });
	    };
	
	    _this.redirectToPinInput = function () {
	      _this.setState({ pinRequestSuccessful: null });
	    };
	
	    _this.state = {
	      recordHasActivePin: null,
	      pinRequestSuccessful: null,
	      pinCorrect: null,
	      error: null
	    };
	    return _this;
	  }
	
	  _createClass(Pins, [{
	    key: "render",
	    value: function render() {
	      var _this2 = this;
	
	      // console.log(SUBROUTES_OBJ[this.props.category]);
	
	      return _react2.default.createElement(
	        "div",
	        { className: "request-pins" },
	        _react2.default.createElement(_LoginRedirector.InRouteRedirector, null),
	        this.state.recordHasActivePin !== null || this.state.recordHasActivePin !== undefined ? this.state.recordHasActivePin === true || this.state.pinRequestSuccessful ? _react2.default.createElement(
	          "div",
	          null,
	          this.state.pinRequestSuccessful === true && !NO_PIN_INPUT_AFTER_REQUEST && _react2.default.createElement(
	            _react2.default.Fragment,
	            null,
	            _react2.default.createElement(
	              "p",
	              null,
	              PIN_REQUEST_SUCCESS_MESSAGE ? PIN_REQUEST_SUCCESS_MESSAGE : "We've sent a new pin to the entity's mailing address on file. When it arrives, return to this page and input your PIN using the Request Access function to gain access to this record."
	            ),
	            _react2.default.createElement(
	              "div",
	              { className: "row" },
	              _react2.default.createElement(
	                "div",
	                { className: "col-12 button-column" },
	                _react2.default.createElement(_Modal.DialogButton, {
	                  label: "Input PIN Now",
	                  className: "btn-raised",
	                  customClickHandler: true,
	                  onClick: this.redirectToPinInput
	                })
	              )
	            )
	          ),
	          this.state.pinRequestSuccessful === true && NO_PIN_INPUT_AFTER_REQUEST && _react2.default.createElement(
	            "div",
	            { className: "row" },
	            _react2.default.createElement(
	              "div",
	              { className: "col-12" },
	              _react2.default.createElement(
	                "p",
	                { className: "center-text" },
	                "PIN has been requested. A PIN letter will be sent to the record's mailing address on file. Follow the instructions provided in the letter to enter the PIN and obtain access to this record."
	              )
	            )
	          ),
	          this.state.pinRequestSuccessful === null && _react2.default.createElement(PinInputSection, {
	            ref: function ref(pinSection) {
	              _this2.pinSection = pinSection;
	            },
	            onPinRequest: this.requestPin,
	            onCheckPinRequest: this.checkPin,
	            error: this.state.pinCorrect === false ? this.state.error ? this.state.error : "Sorry, the PIN you entered is not associated with this record." : null,
	            pinAccepted: this.state.pinCorrect === true,
	            onRequestModalClose: this.props.onRequestModalClose,
	            config: _utilities.SUBROUTES_OBJ[this.props.category]
	          })
	        ) : this.state.pinRequestSuccessful !== true && _react2.default.createElement(PinRequestSection, {
	          description: PIN_REQUEST_DESCRIPTION ? PIN_REQUEST_DESCRIPTION : "Click **Request PIN** to have a new PIN sent to the entity's mailing address on file.",
	          onPinRequest: this.requestPin,
	          error: this.state.error,
	          config: _utilities.SUBROUTES_OBJ[this.props.category]
	        }) : _react2.default.createElement(
	          "div",
	          { className: "loader-wrapper" },
	          _react2.default.createElement(_Loaders.Spinner, { themeColor: "medium-neutral", size: "small" })
	        )
	      );
	    }
	  }]);
	
	  return Pins;
	}(_react.Component);
	
	exports.default = Pins;
	
	var PinInputSection = exports.PinInputSection = function (_Component2) {
	  _inherits(PinInputSection, _Component2);
	
	  function PinInputSection() {
	    var _ref;
	
	    var _temp, _this3, _ret;
	
	    _classCallCheck(this, PinInputSection);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this3 = _possibleConstructorReturn(this, (_ref = PinInputSection.__proto__ || Object.getPrototypeOf(PinInputSection)).call.apply(_ref, [this].concat(args))), _this3), _this3.state = {
	      attestation1Checked: false,
	      attestation2: false
	    }, _this3.componentDidMount = function () {
	      _this3.pinInput.focus();
	    }, _this3.getValue = function () {
	      return _this3.pinInput.getValue();
	    }, _this3.resetValue = function () {
	      _this3.pinInput.setValue('');
	    }, _this3.setValue = function (name, checked) {
	      _this3.setState(_defineProperty({}, name, checked));
	    }, _temp), _possibleConstructorReturn(_this3, _ret);
	  }
	
	  _createClass(PinInputSection, [{
	    key: "render",
	    value: function render() {
	      var _this4 = this;
	
	      var _props = this.props,
	          onPinRequest = _props.onPinRequest,
	          onCheckPinRequest = _props.onCheckPinRequest,
	          sendValue = _props.sendValue,
	          error = _props.error,
	          config = _props.config,
	          submitDisabled = _props.submitDisabled,
	          pinAccepted = _props.pinAccepted,
	          onRequestModalClose = _props.onRequestModalClose;
	
	      return pinAccepted ? _react2.default.createElement(
	        "div",
	        null,
	        _react2.default.createElement(
	          "p",
	          { className: "success-text flex-center" },
	          "Your PIN has been accepted."
	        ),
	        _react2.default.createElement(
	          "div",
	          { className: "flex-center" },
	          _react2.default.createElement(
	            "button",
	            { onClick: onRequestModalClose, className: "btn btn-raised" },
	            "Continue"
	          )
	        )
	      ) : _react2.default.createElement(
	        "div",
	        { className: "wizard" },
	        PIN_REQUEST_ATTESTATIONS && !HIDE_REQUIRED_PIN_ATTESTATION_MESSAGE && _react2.default.createElement(
	          "div",
	          { className: "row" },
	          _react2.default.createElement(
	            "div",
	            { className: "col-12" },
	            _react2.default.createElement(
	              "p",
	              { className: "attestation-hint" },
	              "You ",
	              _react2.default.createElement(
	                "strong",
	                null,
	                "must"
	              ),
	              " check ",
	              ONLY_REQUIRE_ONE_PIN_ATTESTATION ? "the box below to proceed" : "both boxes below to proceed"
	            )
	          )
	        ),
	        PIN_REQUEST_ATTESTATIONS && _react2.default.createElement(
	          "div",
	          { className: "row" },
	          _react2.default.createElement(
	            "div",
	            { className: "col-12 checkbox-column" },
	            _react2.default.createElement(_Form.Checkbox, {
	              fieldId: "attestation1",
	              value: this.state.attestation1Checked,
	              onChange: function onChange(checked) {
	                _this4.setValue("attestation1Checked", checked);
	              },
	              label: (config ? config.pinInputAttest1Label : "I certify that I am authorized to use this PIN to obtain access to this record.") || "I hereby certify I am authorized to utilize this PIN to associate this business entity to my user account."
	            })
	          )
	        ),
	        PIN_REQUEST_ATTESTATIONS && !ONLY_REQUIRE_ONE_PIN_ATTESTATION && _react2.default.createElement(
	          "div",
	          { className: "row" },
	          _react2.default.createElement(
	            "div",
	            { className: "col-12" },
	            _react2.default.createElement(_Form.Checkbox, {
	              fieldId: "attestation2",
	              value: this.state.attestation2Checked,
	              onChange: function onChange(checked) {
	                _this4.setValue("attestation2Checked", checked);
	              },
	              label: config.pinInputAttest2Label || "I hereby certify the account to which I am a associating this entity is my account, an authorized account for an employee of this entity, or the account of an authorized third party preparer for the entity."
	            })
	          )
	        ),
	        _react2.default.createElement(
	          "div",
	          { className: "row pin-input-section" },
	          _react2.default.createElement(
	            "div",
	            { className: "col-8" },
	            _react2.default.createElement(_Modal.DialogInput, {
	              ref: function ref(pinInput) {
	                _this4.pinInput = pinInput;
	              },
	              submit: function submit(e) {
	                return (!PIN_REQUEST_ATTESTATIONS || _this4.state.attestation1Checked && (_this4.state.attestation2Checked || ONLY_REQUIRE_ONE_PIN_ATTESTATION)) && (sendValue ? onCheckPinRequest(_this4.getValue()) : onCheckPinRequest(e));
	              },
	              type: "text",
	              label: "Enter PIN"
	            })
	          ),
	          _react2.default.createElement(
	            "div",
	            { className: "col-4 button-column" },
	            _react2.default.createElement(_Modal.DialogButton, {
	              disabled: submitDisabled ? true : !(!PIN_REQUEST_ATTESTATIONS || this.state.attestation1Checked && (this.state.attestation2Checked || ONLY_REQUIRE_ONE_PIN_ATTESTATION)),
	              label: "Get Access",
	              className: "btn-raised",
	              customClickHandler: true,
	              onClick: function onClick(e) {
	                return sendValue ? onCheckPinRequest(_this4.getValue()) : onCheckPinRequest(e);
	              }
	            })
	          ),
	          ({"NODE_ENV":"production","BUILD_DATE":"2025-08-27T15:15:31.687Z","BUILD_NUMBER":"Not Provided","GIT_VERSION":"v1.3.0-381-ga81e29b08","GIT_COMMIT_HASH":"a81e29b085c9268ffd96c78eb734365802722741","GIT_BRANCH":"beta","PUBLIC_URL":"","STATE_ABBR":"MT","STATE_NAME":"Montana","STATE_ORG_TITLE":"Secretary of State","LOGIN_HEADER_IMG_PATH":"","HOME_IMG_FILENAME":"montana.jpg","FAVICON_FILE_NAME":"favicon.ico","ALLOW_E_SIGN_ON_CORRECTIONS":true,"THIRD_PARTY_SIGNING_ALLOWED":false,"MY_ACCOUNT_SAVE_AND_CLOSE_BUTTON":true,"IE_DEPRECATED_MESSAGE":"Internet Explorer is not supported. Please select a supported browser below to access this website.","ADDITIONAL_ROUTES":{"dataRequests":true,"farmBill":true,"apostille":true,"externalHelp":"https://sosmt.gov/business/help-center/","systemAdministration":[{"title":"Saved Payments","parameter":"saved-payments","componentName":"SavedPayments"}]},"SUBROUTES":[{"label":"Business","component":"Business","parameter":"business","myWorkQueueSearch":false,"sourceTypeId":54,"searchMustHaveOneOf":["FILING_TYPE_ID","STATUS_ID","STATE","search"],"serverWebSearchDescription":true,"serverWorkQueueDescription":true,"serverMyRecordsDescription":true,"searchPlaceholder":"Search by name or filing number (X########)","allowEmptySearchTerm":true,"requestCertificateAlternateLabel":"Request Information","fileAmendmentButtonLabel":"Filing Actions","advancedSearchParameters":[{"type":"radio","name":"QUERY_TYPE_ID","defaultValue":1010,"options":[{"value":1010,"label":"Starts with"},{"value":1011,"label":"Contains"},{"value":1012,"label":" Word Contains"}]},{"type":"serverSelect","name":"FILING_TYPE_ID","optionsSrc":"FILING_TYPES","label":"Entity Type","placeholder":"All","defaultValue":"0"},{"type":"serverSelect","name":"FILING_SUBTYPE_ID","optionsSrc":"FILING_SUBTYPES","label":"Entity Subtype","overrideSubOptionsSrcFromParameterName":"FILING_TYPE_ID","placeholder":"All","defaultValue":"0"},{"type":"serverSelect","name":"STATUS_ID","optionsSrc":"FILING_STATUS_WITHOUT_ALL","label":"Status","placeholder":"All","defaultValue":"0"},{"type":"serverSelect","name":"STATE","optionsSrc":"STATE","label":"State","placeholder":"All","defaultValue":""},{"type":"serverSelect","name":"COUNTY","optionsSrc":"COUNTY_SUBOPTION","label":"County","overrideSubOptionsSrcFromParameterName":"STATE","placeholder":"All","defaultValue":""},{"type":"checkbox","name":"CRA_SEARCH_YN","defaultValue":false,"label":"Search by Registered Agent PID"},{"type":"dateRange","name":"FILING_DATE","label":"Registration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}},{"type":"dateRange","name":"EXPIRATION_DATE","label":"Expiration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}}],"myRecordsFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Active"},{"value":2,"label":"Inactive"},{"value":3,"label":"Pending"}]},{"type":"dateRange","name":"DATE_RANGE","label":"Date range","defaultValue":{"start":null,"end":null}}],"myWorkQueueFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Approved"},{"value":2,"label":"Pending Online Payment"},{"value":3,"label":"Pending Review"},{"value":4,"label":"Needs Correction"},{"value":5,"label":"Rejected"},{"value":6,"label":"Draft"}]},{"type":"dateRange","name":"DATE_RANGE","label":"Date range","defaultValue":{"start":null,"end":null}}]},{"label":"Notary","component":"Notary","parameter":"notary","sourceTypeId":850,"myWorkQueueSearch":false,"allowEmptySearchTerm":true,"requestCertificateAlternateLabel":"Download Certificate","fileAmendmentButtonLabel":"Filing Actions","hideNameRequestCertificate":true,"hideAddressRequestCertificate":true,"hideRecordUserManagment":true,"searchPlaceholder":"Search by name or commission number","searchMustHaveOneOf":["CITY","search","SERVICE_TYPE"],"advancedParametersStartOpen":true,"searchIsSortable":true,"advancedSearchParameters":[{"type":"radio","name":"STARTS_WITH_YN","defaultValue":false,"options":[{"value":true,"label":"Starts with"},{"value":false,"label":"Contains"}]},{"type":"checkbox","name":"ACTIVE_ONLY_YN","defaultValue":true,"label":"Active entities only"},{"type":"text","name":"CITY","defaultValue":"","label":"City"},{"type":"select","name":"SERVICE_TYPE","label":"Special Services Offered","defaultValue":0,"options":[{"value":0,"label":"(N/A)"},{"value":6165,"label":"In-Person Electronic Notarization (IPEN)"},{"value":6166,"label":"Remote Online Notarization (RON)"},{"value":6167,"label":"Mobile Notary Services"},{"value":6168,"label":"Remote Ink Notarization (RIN)"}]}]},{"label":"Apostille","component":"Apostille","parameter":"apostille","sourceTypeId":720,"myRecordsSearch":false,"myWorkQueueSearch":false,"disabled":false,"allowedRoutes":["/forms-manager/","/queue/","/forms/"]},{"label":"Liens","component":"UCC","parameter":"ucc","sourceTypeId":1999,"myRecordsSearch":true,"myWorkQueueSearch":true,"fileAmendmentButtonLabel":"Filing Actions","searchPlaceholder":"Search by name or file number","disabled":false,"serverWebSearchDescription":true,"myRecordsDescription":"","workQueueDescription":"","searchDescription":"","hideRecordUserManagment":true,"searchLiensCheckout":false,"advancedSearchParameters":[{"type":"radio","name":"STARTS_WITH_YN","defaultValue":false,"options":[{"value":true,"label":"Starts with"},{"value":false,"label":"Contains"}]},{"type":"select","name":"STATUS","defaultValue":"ALL","label":"Status","options":[{"value":"ACTIVE_UNLAPSED","label":"Active (unlapsed)"},{"value":"ACTIVE_LAPSED_UNLAPSED","label":"Active (lapsed and unlapsed)"}]},{"type":"text","name":"EXCLUDE_VALUES","label":"Exclude Debtor Names (comma separated list of names to exclude)","defaultValue":""},{"type":"dateRange","name":"FILING_DATE","label":"Financing Statement Date","defaultValue":{"start":null,"end":null}},{"type":"dateRange","name":"LAPSE_DATE","label":"Lapse Date","defaultValue":{"start":null,"end":null}},{"type":"text","name":"CITY","label":"Debtor City","defaultValue":""}],"myRecordsFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Approved"},{"value":2,"label":"Pending Online Payment"},{"value":3,"label":"Pending Review"}]},{"type":"select","name":"TYPE","defaultValue":0,"label":"Lien Type","options":[{"value":0,"label":"All"},{"value":1,"label":"UCC"},{"value":2,"label":"EFS"},{"value":3,"label":"Title 71"}]}],"myWorkQueueFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Approved"},{"value":2,"label":"Pending Online Payment"},{"value":3,"label":"Pending Review"},{"value":4,"label":"Pending Print and Mail"},{"value":5,"label":"Rejected"},{"value":6,"label":"Draft"}]},{"type":"select","name":"TYPE","defaultValue":0,"label":"Lien Type","options":[{"value":0,"label":"All"},{"value":1,"label":"UCC"},{"value":2,"label":"EFS"},{"value":3,"label":"Title 71"}]}]},{"label":"Copy Request","component":"copies","parameter":"copies","sourceTypeId":2001,"myRecordsSearch":false,"myWorkQueueSearch":false,"disabled":false,"allowedRoutes":["/forms-manager/","/queue/","/forms/"]},{"label":"Trademark","component":"Trademark","parameter":"trademark","sourceTypeId":810,"showRequestCertificate":true,"searchMustHaveOneOf":["search","EXPIRATION_DATE","FILING_DATE"],"allowEmptySearchTerm":true,"requestCertificateAlternateLabel":"Request Information","fileAmendmentButtonLabel":"Filing Actions","advancedSearchParameters":[{"type":"radio","name":"QUERY_TYPE_ID","defaultValue":1010,"options":[{"value":1010,"label":"Starts with"},{"value":1011,"label":"Contains"},{"value":1012,"label":" Word Contains"}]},{"type":"checkbox","name":"OWNER_SEARCH_YN","defaultValue":false,"label":"Search owners"},{"type":"radio","name":"SERVICE_MARK_YN","label":"Mark Type","defaultValue":"","options":[{"value":"","label":"All Marks"},{"value":"Y","label":"Service Mark"},{"value":"N","label":"Trademark"}]},{"type":"serverSelect","name":"STATUS_ID","optionsSrc":"TYPE_V|TRADEMARK_STATUS_TYPE","label":"Status","placeholder":"All","defaultValue":"0"},{"type":"select","name":"DESIGN_TYPE_ID","options":[{"value":0,"label":"All"},{"value":990,"label":"Words Only"},{"value":991,"label":"Design Only"},{"value":992,"label":"Words and Design"}],"label":"Design Type","defaultValue":"0"},{"type":"dateRange","name":"FILING_DATE","label":"Registered Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}},{"type":"dateRange","name":"EXPIRATION_DATE","label":"Expiration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}}]},{"label":"Business Info Request","component":"InfoRequests","parameter":"info-request","sourceTypeId":167,"allowedRoutes":["/forms-manager/","/queue/","/forms/"]},{"label":"Data Requests","component":"DataRequests","parameter":"data-request","sourceTypeId":0,"allowedRoutes":["/forms-manager/"]},{"label":"CRA","component":"CRA","parameter":"cra","sourceTypeId":157,"myRecordsSearch":false,"searchPlaceholder":"Search by name or registered agent number","allowedRoutes":["/forms-manager/","/forms/","/records/","/queue/","/search/"],"allowEmptySearchTerm":true,"fileAmendmentButtonLabel":"Filing Actions","advancedSearchParameters":[{"type":"radio","name":"QUERY_TYPE_ID","defaultValue":1010,"options":[{"value":1010,"label":"Starts with"},{"value":1011,"label":"Contains"},{"value":1012,"label":" Word Contains"}]},{"type":"dateRange","name":"CRA_DATE","label":"Registration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}},{"type":"select","name":"STATUS_ID","label":"Status","defaultValue":0,"options":[{"value":0,"label":"All"},{"value":121,"label":"Active"},{"value":122,"label":"Inactive"}]},{"type":"select","name":"AGENT_TYPE_ID","label":"Agent Type","defaultValue":0,"options":[{"value":0,"label":"All"},{"value":460,"label":"Registered Agent"},{"value":461,"label":"Commercial Registered Agent"}]}]},{"label":"Farm Bill","component":"FarmBill","parameter":"farm-bill","path":"/lists/farm-bill","sourceTypeId":0,"myRecordsSearch":false,"allowedRules":["/search/"],"disabled":true,"searchDescription":"To perform a search, enter a debtor name. Your search results may include: exact debtor name, variations of that name and any filing that includes your search criteria. Punctuation is ignored.\n\nYou can click on \"Advanced\" to refine your search. Under “Advanced” you can search by crop, year, county and SSN/FEIN. As a registered Farm Bill Buyer with the Montana Secretary of State’s office it is important to maintain the confidentiality of the information contained within the Farm Bill Master List. The Farm Bill Master List reflects personal data, such as Social Security Numbers, which are a key piece of personal identifiable information to assist you in determining the existence of a lien against a specific debtor. The distribution of this information beyond its intended purpose is strictly prohibited.\n\nThe debtor's tax identification number has been hidden for confidentiality reasons. You may continue to search on a tax ID number and return debtors that match your search criteria. The SSN/FEIN must be entered without dashes or spaces.","searchMustHaveOneOf":["search","UCC_FARM_PRODUCT_ID","COUNTY"],"searchPlaceholder":"Search by debtor name","advancedSearchParameters":[{"type":"ServerMultiComplete","label":"Product code name(s)","name":"UCC_FARM_PRODUCT_ID","defaultValue":"","optionsSrc":"UCC_FARM_PRODUCT_V"},{"type":"MultiComplete","label":"Year or Range of Years","name":"YEAR_NUM","optionsSrc":"years","startYear":"1968","defaultValue":[],"preMergeOptions":[{"value":"ALL","label":"All"}]},{"type":"serverSelect","label":"State","name":"STATE","defaultValue":"MONTANA","optionsSrc":"STATE"},{"type":"ServerMultiComplete","label":"County","name":"COUNTY","defaultValue":[],"optionsSrc":"COUNTY","overrideSubOptionsSrcFromParameterName":"STATE"},{"type":"checkbox","name":"TIN_SEARCH_YN","defaultValue":false,"label":"Tax Identification Number Search"},{"type":"checkbox","name":"TIN_SORT_YN","defaultValue":false,"label":"Unique ID Sort"}]}],"SYSTEM_NICKNAME":"Online Services Portal","PAYMENT_METHODS":[{"type":"bypass"},{"type":"iTransact"}],"PAYMENT_ALLOW_AMEX":true,"SYSTEM_ID_LABEL":"System Id","DOUBLE_COLUMN_PUBLIC_LOGIN":true,"INTERNAL_USER_MANAGEMENT":true,"ALLOW_PUBLIC_JSON_IMPORT":false,"MAX_FILE_UPLOAD_SIZE":10000000,"REFUND_TEXT":"","RETURN_TO_HOME_ON_LOGOUT":true,"CURRENT_SOS_NAME":"Christi Jacobsen","LOGO_FILENAME":"mt-sos-logo.png","LOGO_ALT":"Christi Jacobsen, Montana Secretary of State","LOGO_FULL_WIDTH":true,"HOME_HIDE_AUTH_HINT":true,"HOME_TITLE":"Montana Secretary of State","CUSTOM_TAB_TITLE":"Official Montana","HOME_SUBTITLE":"Online Business Services","ENTITY_NAME_CONSENT_DESCRIPTION":"","ALLOW_USER_PROFILE_EDITING":true,"COMPARE_FOREIGN_NAME_IN_ENTITY_NAME_VALIDATION":true,"FOREIGN_NAME_FIELD_NAME":"KIMA_PARENT_NAME_INFO","LOGIN_TITLE":"Montana Secretary of State Online Filing Portal Login","PUBLIC_LOGIN_LABEL":"Username","REVERSE_LOGIN_COLUMNS":true,"LOGIN_SEAL_FILENAME":"seal_white.png","SEPARATE_USERNAME_AND_EMAIL":true,"CREATE_ACCOUNT_BUTTON_ALIGN_LEFT":true,"CREATE_ACCOUNT_BUTTON_TEXT":"CREATE AN ACCOUNT","PASSWORD_CUSTOM_ERROR_TEXT":"The password must meet all requirements","ACCOUNT_CREATED_MESSAGE":"Please check your email to verify your account to login and allow a few minutes for this message to arrive. Check your junk/spam folders if you do not find the email in your inbox.","PUBLIC_LOGIN_PLACEHOLDER":" ","DISABLE_DEFAULT_PAYMENT_RADIO":true,"CUSTOM_RESET_PASSWORD_ERROR_MESSAGE":"Username invalid - no account found","PUBLIC_LOGIN_CREATE_DESCRIPTION":"### Existing User:\n\n  - Enter your username and password to login.  \n\n\n  #### - OR -  \n\n\n\n  - Forgot password? Click 'Reset Password' and follow the prompts.\n  - Forgot username? Click 'Forgot Username' and follow the prompts.  \n\n\n  ### New User:\n  ","LOGIN_HELP_LINK":"https://sosmt.gov/business/how-do-i/","LOGIN_HELP_LINK_TEXT":"Need Help?","FORGOT_USERNAME_TEXT":"Forgot Username?","LOGIN_ACTIVE_DIRECTORY_TEXT":"State User Login","MULTIPLE_LOGIN_METHODS":true,"HAS_ACTIVE_DIRECTORY_LOGIN":true,"RESET_PASSWORD_WITH_USERNAME":true,"DOWNLOAD_LINK":true,"SHOW_USERNAME_ACCOUNT_CREATE":true,"SHOW_SCROLL_DOWN_ARROW":true,"SHOW_ADDRESS_ACCOUNT_CREATE":true,"TWO_COLUMN_ACCOUNT_CREATE":true,"RESET_PASSWORD_TIP":"A link to change your password has been sent to your email. Please allow a few minutes for this message to arrive. Please check your junk/spam folders if you do not find the email in your inbox.","FORGOT_PASSWORD_LINK_TEXT":"Reset Password","PHONE_NUMBER_OPTIONAL_ACCOUNT_CREATE":true,"SHOW_REQUIRED_INDICATOR_ACCOUNT_CREATE":true,"PASSWORD_REQUIREMENTS_ACCOUNT_CREATE":"\n    <ul>\n      <li>MUST contain at least 8 characters (12+ recommended)</li>\n      <li>MUST contain at least one uppercase letter.</li>\n      <li>MUST contain at least one lowercase letter.</li>\n      <li>MUST contain at least one number.</li>\n      <li>MUST contain at least one special character (!”#$%&'()*+,-./:;<=>?</li>\n    </ul>\n  ","ALLOW_CERTIFICATION_REQUEST":true,"ALLOW_PUBLIC_CERTIFICATE_REQUEST":true,"ALLOW_COPY_REQUEST":false,"ALLOW_CORRECTION_STYLING":true,"HIDE_DEPRECATION_WARNING":false,"AMEND_ROUTE_PUBLIC":true,"SEAL_FILENAME":"seal.png","SHOPPING_CART":true,"ALLOW_PAYMENT_UPDATE_WITH_EMPTY_CART":true,"RA_EMAIL":true,"RA_WEBSITE":true,"RA_NO_DEFAULT_TYPE":true,"RA_ADDRESS_LABEL":"Street Address","RA_TYPE_SELECTION_DEFAULT":true,"RA_DEFAULT_TYPE":"460","RA_OVERRIDE_TYPE_WITH_DEFAULT":true,"RA_PRINCIPAL_ADDRESS_AMS":true,"UPLOAD_AND_SUBMIT_HIDE_IF_ONE_OPTION":true,"PAYMENT_PROCESSING_MESSAGE":"Your payment is processing - Do not close your browser or click the back button","CHECKOUT_BUTTON_WHEN_PROCESSING_TEXT":"Processing","EFS_CROP_PICKER_NONE_LABEL":"Lien Duration","DISALLOWED_WIZARD_PIECES":["FormationLocale"],"REPEATER_SHOW_EDIT_BUTTON":true,"DATA_REQUEST_PAGE_TITLE":"Data Requests and Subscriptions","DATA_REQUEST_SIDEBAR_LABEL":"Data Requests & Subscriptions","LOGIN_REDIRECTS_TO_EPASS":false,"LOGIN_REDIRECTS_TO_ACTIVE_DIRECTORY":true,"LOGIN_ACTIVE_DIRECTORY_LINK":true,"FETCH_EDIT_USER_LINK":false,"LISTS_FETCH_AVAILABLE_LISTS":true,"POST_WIZARD_SUBMIT_REDIRECT_URL":"/","PIN_REQUEST_ATTESTATIONS":true,"PIN_REQUEST_DESCRIPTION":"Click **Request PIN** to have a new PIN sent to the account holder's email address on file.","OWNERSHIP_REQUEST_DESCRIPTION":"To become an **authorized user** of this record, a current **AUTHORIZED USER** will need to grant you access. To request access, click **Request Access** below.","PIN_REQUEST_SUCCESS_MESSAGE":"The PIN you have requested for this entity has been sent to the email associated with your user account.  You should receive the PIN in approximately 3-5 minutes, depending on your email service provider.","APOSTILLE_HEADER_LABEL":"Verification Information","APOSTILLE_NUMBER_LABEL":"Apostille/Authentication","APOSTILLE_CITY_STATE_OVERRIDE":"HELENA, MT","APOSTILLE_FILING_DATE_LABEL":"Issue Date","APOSTILLE_CITY_STATE_IN_CERTIFIED":true,"NOTARY_EXISTING_FILING":true,"ALLOW_REVOKE_OWN_ACCESS_ONLY":false,"HIDE_CANCEL_ON_ONETIME_DATA_REQUESTS":true,"DATA_REQUESTS_IN_SHOPPING_CART":true,"WQ_ALLOW_EDIT_PENDING_PAYMENT":true,"WQ_CONFIRM_ON_DELETE":true,"WQ_DELETE_CONFIRM_MESSAGE":"Deleting this filing will forfeit any money already paid to the Secretary of State. This action is permanent and cannot be undone, are you sure you would like to delete?","PASS_ITEM_GUIDS_ON_CHECKOUT":true,"FORM_REVISION_HISTORY":true,"CHECKOUT_DISCLAIMER":"By entering your credit card and/or checking account information you (i) state that **you are an authorized user** of the credit card and/or electronic check and that the associated information entered (e.g., account holder name, account number, billing address) is accurate, (ii) **you authorize payment processor to charge the amount you have requested** to your credit card and/or funding account, and (iii) **acknowledge if a charge is declined or reversed you may also be assessed a customary charge** by the payment processor for such transactions.","FARM_BILL_SEARCH_CONFIDENTIAL":"As a registered Farm Bill Buyer with the Montana Secretary of State’s office it is important to maintain the confidentiality of the information contained within the Farm Bill Master List. The Farm Bill Master List reflects personal data, such as Social Security Numbers, which are a key piece of personal identifiable information to assist you in determining the existence of a lien against a specific debtor. The distribution of this information beyond its intended purpose is strictly prohibited.\n\n**The debtor's tax identification number has been hidden for confidentiality reasons. You may continue to search on a tax ID number and return debtors that match your search criteria. The SSN/FEIN must be entered without dashes or spaces.  If you need access to the tax identification number to clearly identify the debtor, please contact the UCC unit at (406) 444-3665.**","VIEW_HISTORY_BUTTON_ALT_TEXT":"View Filings","WIZARD_ERROR_TITLE_MESSAGE":"Form Error","FARM_BILL_SEARCH_INTERACTIVE":true,"USE_FARM_BILL_API":true,"DISALLOW_ASSIGN_SELF_AS_RA":true,"DISALLOW_ASSIGN_SELF_AS_PRINCIPAL":true,"USE_TRADEMARK_OWNER_VALIDATION":true,"USE_ALTERNATIVE_FOREIGN_ADDRESS_LABELS":true,"MY_RECEIPTS_FILTER":[{"type":"dateRange","name":"DATE_RANGE","label":"Date range","defaultValue":{"start":null,"end":null}},{"type":"text","name":"REF_NUM","defaultValue":"","label":"Reference Number"},{"type":"text","name":"RECEIPT_NUM","defaultValue":"","label":"Receipt Id"},{"type":"text","name":"AMOUNT","defaultValue":"","label":"Amount"},{"type":"select","name":"TYPE","defaultValue":"","label":"Payment Type","options":[{"value":"","label":"All"},{"value":"CC","label":"Credit Card"},{"value":"Check","label":"Check"}]}],"MY_RECEIPTS_SHOW_IN_SIDEBAR":true,"SHOW_MY_RECEIPTS_HELPER_TEXT":true,"MY_RECEIPTS_HELPER_LABEL":"About Receipt Search","MY_RECEIPTS_HELPER_TEXT":"You can search for receipts based on their descriptions, including the items paid for on the receipt. Use the filters to search for or filter specific information.","FARM_BILL_SUBLINK":{"label":"Farm Bill","component":"FarmBill","parameter":"farm-bill","path":"/lists/farm-bill","sourceTypeId":0,"myRecordsSearch":false,"allowedRules":["/search/"],"disabled":true,"searchDescription":"To perform a search, enter a debtor name. Your search results may include: exact debtor name, variations of that name and any filing that includes your search criteria. Punctuation is ignored.\n\nYou can click on \"Advanced\" to refine your search. Under “Advanced” you can search by crop, year, county and SSN/FEIN. As a registered Farm Bill Buyer with the Montana Secretary of State’s office it is important to maintain the confidentiality of the information contained within the Farm Bill Master List. The Farm Bill Master List reflects personal data, such as Social Security Numbers, which are a key piece of personal identifiable information to assist you in determining the existence of a lien against a specific debtor. The distribution of this information beyond its intended purpose is strictly prohibited.\n\nThe debtor's tax identification number has been hidden for confidentiality reasons. You may continue to search on a tax ID number and return debtors that match your search criteria. The SSN/FEIN must be entered without dashes or spaces.","searchMustHaveOneOf":["search","UCC_FARM_PRODUCT_ID","COUNTY"],"searchPlaceholder":"Search by debtor name","advancedSearchParameters":[{"type":"ServerMultiComplete","label":"Product code name(s)","name":"UCC_FARM_PRODUCT_ID","defaultValue":"","optionsSrc":"UCC_FARM_PRODUCT_V"},{"type":"MultiComplete","label":"Year or Range of Years","name":"YEAR_NUM","optionsSrc":"years","startYear":"1968","defaultValue":[],"preMergeOptions":[{"value":"ALL","label":"All"}]},{"type":"serverSelect","label":"State","name":"STATE","defaultValue":"MONTANA","optionsSrc":"STATE"},{"type":"ServerMultiComplete","label":"County","name":"COUNTY","defaultValue":[],"optionsSrc":"COUNTY","overrideSubOptionsSrcFromParameterName":"STATE"},{"type":"checkbox","name":"TIN_SEARCH_YN","defaultValue":false,"label":"Tax Identification Number Search"},{"type":"checkbox","name":"TIN_SORT_YN","defaultValue":false,"label":"Unique ID Sort"}]},"ALLOW_ADDRESS_VALIDATION_BYPASS_OPTION":true,"DEFAULT_ADDRESS_VALIDATION_BYPASS_OPTION_CHECKED":true}).ALLOW_USER_TO_CHOOSE_PIN_INPUT && _react2.default.createElement(
	            "div",
	            { style: { textAlign: "center" } },
	            _react2.default.createElement("br", null),
	            "Or ",
	            _react2.default.createElement("br", null),
	            _react2.default.createElement("br", null),
	            _react2.default.createElement(PinRequestSection, {
	              description: PIN_REQUEST_DESCRIPTION ? PIN_REQUEST_DESCRIPTION : "Click **Request PIN** to have a new PIN sent to the entity's mailing address on file.",
	              onPinRequest: onPinRequest,
	              error: this.state.error,
	              config: _utilities.SUBROUTES_OBJ[this.props.category]
	            })
	          )
	        ),
	        error && _react2.default.createElement(
	          "div",
	          { className: "error" },
	          _react2.default.createElement("span", { className: "icon icon-danger" }),
	          error
	        )
	      );
	    }
	  }]);
	
	  return PinInputSection;
	}(_react.Component);
	
	var PinRequestSection = function (_Component3) {
	  _inherits(PinRequestSection, _Component3);
	
	  function PinRequestSection() {
	    var _ref2;
	
	    var _temp2, _this5, _ret2;
	
	    _classCallCheck(this, PinRequestSection);
	
	    for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
	      args[_key2] = arguments[_key2];
	    }
	
	    return _ret2 = (_temp2 = (_this5 = _possibleConstructorReturn(this, (_ref2 = PinRequestSection.__proto__ || Object.getPrototypeOf(PinRequestSection)).call.apply(_ref2, [this].concat(args))), _this5), _this5.state = {
	      attestation1Checked: false,
	      attestation2Checked: false
	    }, _this5.setValue = function (name, checked) {
	      _this5.setState(_defineProperty({}, name, checked));
	    }, _temp2), _possibleConstructorReturn(_this5, _ret2);
	  }
	
	  _createClass(PinRequestSection, [{
	    key: "render",
	    value: function render() {
	      var _this6 = this;
	
	      var _props2 = this.props,
	          onPinRequest = _props2.onPinRequest,
	          description = _props2.description,
	          error = _props2.error,
	          config = _props2.config;
	
	      return _react2.default.createElement(
	        "div",
	        { className: "wizard" },
	        _react2.default.createElement(
	          "div",
	          { className: "row" },
	          _react2.default.createElement(
	            "div",
	            { className: "col-12" },
	            _react2.default.createElement(_Markdown2.default, {
	              source: description,
	              className: "center-text pin-description"
	            })
	          )
	        ),
	        PIN_REQUEST_ATTESTATIONS && !HIDE_REQUIRED_PIN_ATTESTATION_MESSAGE && _react2.default.createElement(
	          "div",
	          { className: "row" },
	          _react2.default.createElement(
	            "div",
	            { className: "col-12" },
	            _react2.default.createElement(
	              "p",
	              { className: "attestation-hint" },
	              "You ",
	              _react2.default.createElement(
	                "strong",
	                null,
	                "must"
	              ),
	              " check ",
	              ONLY_REQUIRE_ONE_PIN_ATTESTATION ? "the box below to proceed" : "both boxes below to proceed"
	            )
	          )
	        ),
	        PIN_REQUEST_ATTESTATIONS && _react2.default.createElement(
	          "div",
	          { className: "row" },
	          _react2.default.createElement(
	            "div",
	            { className: "col-12 checkbox-column" },
	            _react2.default.createElement(_Form.Checkbox, {
	              fieldId: "attestation1",
	              value: this.state.attestation1Checked,
	              onChange: function onChange(checked) {
	                _this6.setValue("attestation1Checked", checked);
	              },
	              label: config.pinRequestAttest1Label || "I hereby certify I am authorized to request access to this account on behalf of the business entity to which this request pertains."
	            })
	          )
	        ),
	        PIN_REQUEST_ATTESTATIONS && !ONLY_REQUIRE_ONE_PIN_ATTESTATION && _react2.default.createElement(
	          "div",
	          { className: "row" },
	          _react2.default.createElement(
	            "div",
	            { className: "col-12" },
	            _react2.default.createElement(_Form.Checkbox, {
	              fieldId: "attestation2",
	              value: this.state.attestation2Checked,
	              onChange: function onChange(checked) {
	                _this6.setValue("attestation2Checked", checked);
	              },
	              label: config.pinRequestAttest2Label || "I hereby certify the account from which I am requesting access to this entity is my account, an authorized account for an employee of this entity, or the account of an authorized third party preparer for the entity."
	            })
	          )
	        ),
	        _react2.default.createElement(
	          "div",
	          { className: "row margin-top" },
	          _react2.default.createElement(
	            "div",
	            { className: "col-12 button-column" },
	            _react2.default.createElement(_Modal.DialogButton, {
	              disabled: !(!PIN_REQUEST_ATTESTATIONS || this.state.attestation1Checked && (this.state.attestation2Checked || ONLY_REQUIRE_ONE_PIN_ATTESTATION)),
	              label: "Request PIN",
	              className: "btn-raised",
	              customClickHandler: true,
	              onClick: onPinRequest
	            })
	          )
	        ),
	        error && _react2.default.createElement(
	          "p",
	          { className: "error" },
	          error
	        )
	      );
	    }
	  }]);
	
	  return PinRequestSection;
	}(_react.Component);

/***/ },
/* 463 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getWorkQueueDescription = exports.invalidateAllCategoryCaches = exports.setRecordsLoading = exports.setLastRequestId = exports.setFilters = exports.setWorkQueueErrorDetails = exports.setWorkQueueError = exports.selectWorkQueueItem = exports.fetchAndSetWorkQueueItems = exports.setWorkQueueItems = exports.setActiveCategory = undefined;
	
	var _requests = __webpack_require__(6);
	
	var api = _interopRequireWildcard(_requests);
	
	var _localStorage = __webpack_require__(59);
	
	var _localStorage2 = _interopRequireDefault(_localStorage);
	
	var _shortid = __webpack_require__(22);
	
	var _shortid2 = _interopRequireDefault(_shortid);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var setActiveCategory = exports.setActiveCategory = function setActiveCategory(category) {
	  return function (dispatch) {
	    dispatch({
	      type: '@@wq/SET_ACTIVE_CATEGORY',
	      category: category
	    });
	    dispatch({
	      type: 'SET_CURRENT_CATEGORY',
	      category: category
	    });
	  };
	};
	
	var setWorkQueueItems = exports.setWorkQueueItems = function setWorkQueueItems(items, template, category) {
	  return {
	    type: 'SET_WORK_QUEUE_ITEMS',
	    items: items,
	    template: template,
	    category: category
	  };
	};
	
	var fetchAndSetWorkQueueItems = exports.fetchAndSetWorkQueueItems = function fetchAndSetWorkQueueItems(category, callback) {
	  return function (dispatch, getState) {
	    var loading = getState().queue.loading;
	    if (!loading) {
	      dispatch(setRecordsLoading(true));
	      dispatch(setWorkQueueError(null));
	      dispatch(setWorkQueueErrorDetails(null));
	      var parameters = getState().queue.filters[category] || {};
	      var requestId = _shortid2.default.generate();
	      dispatch(setLastRequestId(requestId));
	      api.GET_WORK_QUEUE_ITEMS(category, parameters, requestId, function (data) {
	        var props = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	        if (getState().queue.lastRequestId === props.requestId) {
	          dispatch(setWorkQueueItems(data.items, data.template, category));
	          dispatch(setRecordsLoading(false));
	        }
	        if (callback) callback();
	      }, function (err) {
	        dispatch(setRecordsLoading(false));
	        dispatch(setWorkQueueError(true));
	        dispatch(setWorkQueueErrorDetails({ message: err.Message, code: err.Code }));
	      });
	    }
	  };
	};
	
	var selectWorkQueueItem = exports.selectWorkQueueItem = function selectWorkQueueItem(category, selected) {
	  return {
	    type: 'SELECT_WORK_QUEUE_ITEM',
	    category: category,
	    selected: selected
	  };
	};
	
	var setWorkQueueError = exports.setWorkQueueError = function setWorkQueueError(error) {
	  return {
	    type: 'SET_WORK_QUEUE_ERROR',
	    error: error
	  };
	};
	
	var setWorkQueueErrorDetails = exports.setWorkQueueErrorDetails = function setWorkQueueErrorDetails(errorDetails) {
	  return {
	    type: 'SET_WORK_QUEUE_ERROR_DETAILS',
	    errorDetails: errorDetails
	  };
	};
	
	var setFilters = exports.setFilters = function setFilters(category, filters) {
	  return function (dispatch, getState) {
	    dispatch({
	      type: '@@wq/SET_FILTERS',
	      category: category,
	      filters: filters
	    });
	    _localStorage2.default.set('MY_WORK_QUEUE_FILTERS', Object.assign({}, getState().queue.filters, _defineProperty({}, category, filters)));
	  };
	};
	
	var setLastRequestId = exports.setLastRequestId = function setLastRequestId(requestId) {
	  return {
	    type: '@@wq/SET_REQUEST_ID',
	    requestId: requestId
	  };
	};
	
	var setRecordsLoading = exports.setRecordsLoading = function setRecordsLoading(loading) {
	  return {
	    type: '@@wq/SET_LOADING',
	    loading: loading
	  };
	};
	
	var invalidateAllCategoryCaches = exports.invalidateAllCategoryCaches = function invalidateAllCategoryCaches() {
	  return function (dispatch) {
	    dispatch({
	      type: '@@wq/INVALIDATE_CACHE'
	    });
	  };
	};
	
	var getWorkQueueDescription = exports.getWorkQueueDescription = function getWorkQueueDescription(category) {
	  return function (dispatch) {
	    return new Promise(function (resolve) {
	      (0, _requests.GET_WORK_QUEUE_DESCRIPTION)(category, function (description) {
	        dispatch({
	          type: '@@WORK_QUEUE_SET_DESCRIPTION',
	          category: category,
	          description: description
	        });
	        resolve(description);
	      });
	    });
	  };
	};

/***/ },
/* 464 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	__webpack_require__(1456);
	
	var _reactRouterDom = __webpack_require__(30);
	
	var _business = __webpack_require__(329);
	
	var _business2 = _interopRequireDefault(_business);
	
	var _searchThin = __webpack_require__(228);
	
	var _searchThin2 = _interopRequireDefault(_searchThin);
	
	var _fileBox = __webpack_require__(334);
	
	var _fileBox2 = _interopRequireDefault(_fileBox);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var NotFound = function (_React$Component) {
	  _inherits(NotFound, _React$Component);
	
	  function NotFound() {
	    _classCallCheck(this, NotFound);
	
	    return _possibleConstructorReturn(this, (NotFound.__proto__ || Object.getPrototypeOf(NotFound)).apply(this, arguments));
	  }
	
	  _createClass(NotFound, [{
	    key: "render",
	    value: function render() {
	      return _react2.default.createElement(
	        "div",
	        { className: "not-found" },
	        _react2.default.createElement(
	          "h1",
	          null,
	          "404"
	        ),
	        _react2.default.createElement(
	          "span",
	          { className: "message" },
	          "Oops, looks like the page you're looking for doesn't exist. You can try one of the links below or ",
	          _react2.default.createElement(
	            _reactRouterDom.Link,
	            { to: "/", replace: true },
	            "click here"
	          ),
	          " to return to the homepage."
	        ),
	        _react2.default.createElement(
	          "div",
	          { className: "quick-links" },
	          _react2.default.createElement(QuickLink, { icon: _react2.default.createElement(_business2.default, null), title: "Start a new business", href: "/forms" }),
	          _react2.default.createElement(QuickLink, { icon: _react2.default.createElement(_searchThin2.default, null), title: "Search for a record", href: "/search" }),
	          _react2.default.createElement(QuickLink, { icon: _react2.default.createElement(_fileBox2.default, null), title: "View my work queue", href: "/queue" })
	        )
	      );
	    }
	  }]);
	
	  return NotFound;
	}(_react2.default.Component);
	
	exports.default = NotFound;
	
	
	var QuickLink = function QuickLink(_ref) {
	  var icon = _ref.icon,
	      title = _ref.title,
	      href = _ref.href;
	  return _react2.default.createElement(
	    _reactRouterDom.Link,
	    { className: "quick-link", to: href, replace: true },
	    _react2.default.createElement(
	      "div",
	      { className: "icon-wrapper" },
	      icon
	    ),
	    _react2.default.createElement(
	      "span",
	      { className: "title" },
	      title
	    )
	  );
	};

/***/ },
/* 465 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(7);
	
	var _utilities = __webpack_require__(8);
	
	var _Shell = __webpack_require__(19);
	
	var _Portal = __webpack_require__(12);
	
	var _Portal2 = _interopRequireDefault(_Portal);
	
	var _Modal = __webpack_require__(13);
	
	var _Ownership = __webpack_require__(1117);
	
	var _Ownership2 = _interopRequireDefault(_Ownership);
	
	var _AmendmentLauncher = __webpack_require__(460);
	
	var _AmendmentLauncher2 = _interopRequireDefault(_AmendmentLauncher);
	
	var _ReinstatementLauncher = __webpack_require__(1119);
	
	var _ReinstatementLauncher2 = _interopRequireDefault(_ReinstatementLauncher);
	
	var _RecordHistory = __webpack_require__(1127);
	
	var _store = __webpack_require__(18);
	
	var _store2 = _interopRequireDefault(_store);
	
	var _ActionButton = __webpack_require__(194);
	
	var _ActionButton2 = _interopRequireDefault(_ActionButton);
	
	var _DetailsList = __webpack_require__(454);
	
	var _DetailsList2 = _interopRequireDefault(_DetailsList);
	
	var _Pins = __webpack_require__(462);
	
	var _Pins2 = _interopRequireDefault(_Pins);
	
	var _RequestOwnership = __webpack_require__(1120);
	
	var _RequestOwnership2 = _interopRequireDefault(_RequestOwnership);
	
	var _RequestCertificate = __webpack_require__(1057);
	
	var _RequestCertificate2 = _interopRequireDefault(_RequestCertificate);
	
	var _SlidingPanel = __webpack_require__(101);
	
	var _SlidingPanel2 = _interopRequireDefault(_SlidingPanel);
	
	var _Checkout = __webpack_require__(67);
	
	var _Checkout2 = _interopRequireDefault(_Checkout);
	
	var _userGroup = __webpack_require__(340);
	
	var _userGroup2 = _interopRequireDefault(_userGroup);
	
	var _history = __webpack_require__(226);
	
	var _history2 = _interopRequireDefault(_history);
	
	var _certificate = __webpack_require__(555);
	
	var _certificate2 = _interopRequireDefault(_certificate);
	
	var _documentEdit = __webpack_require__(332);
	
	var _documentEdit2 = _interopRequireDefault(_documentEdit);
	
	var _LoginRedirector = __webpack_require__(148);
	
	var _actions = __webpack_require__(29);
	
	var _shortid = __webpack_require__(22);
	
	var _shortid2 = _interopRequireDefault(_shortid);
	
	var _requests = __webpack_require__(6);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	// import { Spinner } from "components/Loaders/Loaders"
	
	
	var SHOW_REQUEST_ACCESS_PUBLIC = ({"NODE_ENV":"production","BUILD_DATE":"2025-08-27T15:15:31.687Z","BUILD_NUMBER":"Not Provided","GIT_VERSION":"v1.3.0-381-ga81e29b08","GIT_COMMIT_HASH":"a81e29b085c9268ffd96c78eb734365802722741","GIT_BRANCH":"beta","PUBLIC_URL":"","STATE_ABBR":"MT","STATE_NAME":"Montana","STATE_ORG_TITLE":"Secretary of State","LOGIN_HEADER_IMG_PATH":"","HOME_IMG_FILENAME":"montana.jpg","FAVICON_FILE_NAME":"favicon.ico","ALLOW_E_SIGN_ON_CORRECTIONS":true,"THIRD_PARTY_SIGNING_ALLOWED":false,"MY_ACCOUNT_SAVE_AND_CLOSE_BUTTON":true,"IE_DEPRECATED_MESSAGE":"Internet Explorer is not supported. Please select a supported browser below to access this website.","ADDITIONAL_ROUTES":{"dataRequests":true,"farmBill":true,"apostille":true,"externalHelp":"https://sosmt.gov/business/help-center/","systemAdministration":[{"title":"Saved Payments","parameter":"saved-payments","componentName":"SavedPayments"}]},"SUBROUTES":[{"label":"Business","component":"Business","parameter":"business","myWorkQueueSearch":false,"sourceTypeId":54,"searchMustHaveOneOf":["FILING_TYPE_ID","STATUS_ID","STATE","search"],"serverWebSearchDescription":true,"serverWorkQueueDescription":true,"serverMyRecordsDescription":true,"searchPlaceholder":"Search by name or filing number (X########)","allowEmptySearchTerm":true,"requestCertificateAlternateLabel":"Request Information","fileAmendmentButtonLabel":"Filing Actions","advancedSearchParameters":[{"type":"radio","name":"QUERY_TYPE_ID","defaultValue":1010,"options":[{"value":1010,"label":"Starts with"},{"value":1011,"label":"Contains"},{"value":1012,"label":" Word Contains"}]},{"type":"serverSelect","name":"FILING_TYPE_ID","optionsSrc":"FILING_TYPES","label":"Entity Type","placeholder":"All","defaultValue":"0"},{"type":"serverSelect","name":"FILING_SUBTYPE_ID","optionsSrc":"FILING_SUBTYPES","label":"Entity Subtype","overrideSubOptionsSrcFromParameterName":"FILING_TYPE_ID","placeholder":"All","defaultValue":"0"},{"type":"serverSelect","name":"STATUS_ID","optionsSrc":"FILING_STATUS_WITHOUT_ALL","label":"Status","placeholder":"All","defaultValue":"0"},{"type":"serverSelect","name":"STATE","optionsSrc":"STATE","label":"State","placeholder":"All","defaultValue":""},{"type":"serverSelect","name":"COUNTY","optionsSrc":"COUNTY_SUBOPTION","label":"County","overrideSubOptionsSrcFromParameterName":"STATE","placeholder":"All","defaultValue":""},{"type":"checkbox","name":"CRA_SEARCH_YN","defaultValue":false,"label":"Search by Registered Agent PID"},{"type":"dateRange","name":"FILING_DATE","label":"Registration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}},{"type":"dateRange","name":"EXPIRATION_DATE","label":"Expiration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}}],"myRecordsFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Active"},{"value":2,"label":"Inactive"},{"value":3,"label":"Pending"}]},{"type":"dateRange","name":"DATE_RANGE","label":"Date range","defaultValue":{"start":null,"end":null}}],"myWorkQueueFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Approved"},{"value":2,"label":"Pending Online Payment"},{"value":3,"label":"Pending Review"},{"value":4,"label":"Needs Correction"},{"value":5,"label":"Rejected"},{"value":6,"label":"Draft"}]},{"type":"dateRange","name":"DATE_RANGE","label":"Date range","defaultValue":{"start":null,"end":null}}]},{"label":"Notary","component":"Notary","parameter":"notary","sourceTypeId":850,"myWorkQueueSearch":false,"allowEmptySearchTerm":true,"requestCertificateAlternateLabel":"Download Certificate","fileAmendmentButtonLabel":"Filing Actions","hideNameRequestCertificate":true,"hideAddressRequestCertificate":true,"hideRecordUserManagment":true,"searchPlaceholder":"Search by name or commission number","searchMustHaveOneOf":["CITY","search","SERVICE_TYPE"],"advancedParametersStartOpen":true,"searchIsSortable":true,"advancedSearchParameters":[{"type":"radio","name":"STARTS_WITH_YN","defaultValue":false,"options":[{"value":true,"label":"Starts with"},{"value":false,"label":"Contains"}]},{"type":"checkbox","name":"ACTIVE_ONLY_YN","defaultValue":true,"label":"Active entities only"},{"type":"text","name":"CITY","defaultValue":"","label":"City"},{"type":"select","name":"SERVICE_TYPE","label":"Special Services Offered","defaultValue":0,"options":[{"value":0,"label":"(N/A)"},{"value":6165,"label":"In-Person Electronic Notarization (IPEN)"},{"value":6166,"label":"Remote Online Notarization (RON)"},{"value":6167,"label":"Mobile Notary Services"},{"value":6168,"label":"Remote Ink Notarization (RIN)"}]}]},{"label":"Apostille","component":"Apostille","parameter":"apostille","sourceTypeId":720,"myRecordsSearch":false,"myWorkQueueSearch":false,"disabled":false,"allowedRoutes":["/forms-manager/","/queue/","/forms/"]},{"label":"Liens","component":"UCC","parameter":"ucc","sourceTypeId":1999,"myRecordsSearch":true,"myWorkQueueSearch":true,"fileAmendmentButtonLabel":"Filing Actions","searchPlaceholder":"Search by name or file number","disabled":false,"serverWebSearchDescription":true,"myRecordsDescription":"","workQueueDescription":"","searchDescription":"","hideRecordUserManagment":true,"searchLiensCheckout":false,"advancedSearchParameters":[{"type":"radio","name":"STARTS_WITH_YN","defaultValue":false,"options":[{"value":true,"label":"Starts with"},{"value":false,"label":"Contains"}]},{"type":"select","name":"STATUS","defaultValue":"ALL","label":"Status","options":[{"value":"ACTIVE_UNLAPSED","label":"Active (unlapsed)"},{"value":"ACTIVE_LAPSED_UNLAPSED","label":"Active (lapsed and unlapsed)"}]},{"type":"text","name":"EXCLUDE_VALUES","label":"Exclude Debtor Names (comma separated list of names to exclude)","defaultValue":""},{"type":"dateRange","name":"FILING_DATE","label":"Financing Statement Date","defaultValue":{"start":null,"end":null}},{"type":"dateRange","name":"LAPSE_DATE","label":"Lapse Date","defaultValue":{"start":null,"end":null}},{"type":"text","name":"CITY","label":"Debtor City","defaultValue":""}],"myRecordsFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Approved"},{"value":2,"label":"Pending Online Payment"},{"value":3,"label":"Pending Review"}]},{"type":"select","name":"TYPE","defaultValue":0,"label":"Lien Type","options":[{"value":0,"label":"All"},{"value":1,"label":"UCC"},{"value":2,"label":"EFS"},{"value":3,"label":"Title 71"}]}],"myWorkQueueFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Approved"},{"value":2,"label":"Pending Online Payment"},{"value":3,"label":"Pending Review"},{"value":4,"label":"Pending Print and Mail"},{"value":5,"label":"Rejected"},{"value":6,"label":"Draft"}]},{"type":"select","name":"TYPE","defaultValue":0,"label":"Lien Type","options":[{"value":0,"label":"All"},{"value":1,"label":"UCC"},{"value":2,"label":"EFS"},{"value":3,"label":"Title 71"}]}]},{"label":"Copy Request","component":"copies","parameter":"copies","sourceTypeId":2001,"myRecordsSearch":false,"myWorkQueueSearch":false,"disabled":false,"allowedRoutes":["/forms-manager/","/queue/","/forms/"]},{"label":"Trademark","component":"Trademark","parameter":"trademark","sourceTypeId":810,"showRequestCertificate":true,"searchMustHaveOneOf":["search","EXPIRATION_DATE","FILING_DATE"],"allowEmptySearchTerm":true,"requestCertificateAlternateLabel":"Request Information","fileAmendmentButtonLabel":"Filing Actions","advancedSearchParameters":[{"type":"radio","name":"QUERY_TYPE_ID","defaultValue":1010,"options":[{"value":1010,"label":"Starts with"},{"value":1011,"label":"Contains"},{"value":1012,"label":" Word Contains"}]},{"type":"checkbox","name":"OWNER_SEARCH_YN","defaultValue":false,"label":"Search owners"},{"type":"radio","name":"SERVICE_MARK_YN","label":"Mark Type","defaultValue":"","options":[{"value":"","label":"All Marks"},{"value":"Y","label":"Service Mark"},{"value":"N","label":"Trademark"}]},{"type":"serverSelect","name":"STATUS_ID","optionsSrc":"TYPE_V|TRADEMARK_STATUS_TYPE","label":"Status","placeholder":"All","defaultValue":"0"},{"type":"select","name":"DESIGN_TYPE_ID","options":[{"value":0,"label":"All"},{"value":990,"label":"Words Only"},{"value":991,"label":"Design Only"},{"value":992,"label":"Words and Design"}],"label":"Design Type","defaultValue":"0"},{"type":"dateRange","name":"FILING_DATE","label":"Registered Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}},{"type":"dateRange","name":"EXPIRATION_DATE","label":"Expiration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}}]},{"label":"Business Info Request","component":"InfoRequests","parameter":"info-request","sourceTypeId":167,"allowedRoutes":["/forms-manager/","/queue/","/forms/"]},{"label":"Data Requests","component":"DataRequests","parameter":"data-request","sourceTypeId":0,"allowedRoutes":["/forms-manager/"]},{"label":"CRA","component":"CRA","parameter":"cra","sourceTypeId":157,"myRecordsSearch":false,"searchPlaceholder":"Search by name or registered agent number","allowedRoutes":["/forms-manager/","/forms/","/records/","/queue/","/search/"],"allowEmptySearchTerm":true,"fileAmendmentButtonLabel":"Filing Actions","advancedSearchParameters":[{"type":"radio","name":"QUERY_TYPE_ID","defaultValue":1010,"options":[{"value":1010,"label":"Starts with"},{"value":1011,"label":"Contains"},{"value":1012,"label":" Word Contains"}]},{"type":"dateRange","name":"CRA_DATE","label":"Registration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}},{"type":"select","name":"STATUS_ID","label":"Status","defaultValue":0,"options":[{"value":0,"label":"All"},{"value":121,"label":"Active"},{"value":122,"label":"Inactive"}]},{"type":"select","name":"AGENT_TYPE_ID","label":"Agent Type","defaultValue":0,"options":[{"value":0,"label":"All"},{"value":460,"label":"Registered Agent"},{"value":461,"label":"Commercial Registered Agent"}]}]},{"label":"Farm Bill","component":"FarmBill","parameter":"farm-bill","path":"/lists/farm-bill","sourceTypeId":0,"myRecordsSearch":false,"allowedRules":["/search/"],"disabled":true,"searchDescription":"To perform a search, enter a debtor name. Your search results may include: exact debtor name, variations of that name and any filing that includes your search criteria. Punctuation is ignored.\n\nYou can click on \"Advanced\" to refine your search. Under “Advanced” you can search by crop, year, county and SSN/FEIN. As a registered Farm Bill Buyer with the Montana Secretary of State’s office it is important to maintain the confidentiality of the information contained within the Farm Bill Master List. The Farm Bill Master List reflects personal data, such as Social Security Numbers, which are a key piece of personal identifiable information to assist you in determining the existence of a lien against a specific debtor. The distribution of this information beyond its intended purpose is strictly prohibited.\n\nThe debtor's tax identification number has been hidden for confidentiality reasons. You may continue to search on a tax ID number and return debtors that match your search criteria. The SSN/FEIN must be entered without dashes or spaces.","searchMustHaveOneOf":["search","UCC_FARM_PRODUCT_ID","COUNTY"],"searchPlaceholder":"Search by debtor name","advancedSearchParameters":[{"type":"ServerMultiComplete","label":"Product code name(s)","name":"UCC_FARM_PRODUCT_ID","defaultValue":"","optionsSrc":"UCC_FARM_PRODUCT_V"},{"type":"MultiComplete","label":"Year or Range of Years","name":"YEAR_NUM","optionsSrc":"years","startYear":"1968","defaultValue":[],"preMergeOptions":[{"value":"ALL","label":"All"}]},{"type":"serverSelect","label":"State","name":"STATE","defaultValue":"MONTANA","optionsSrc":"STATE"},{"type":"ServerMultiComplete","label":"County","name":"COUNTY","defaultValue":[],"optionsSrc":"COUNTY","overrideSubOptionsSrcFromParameterName":"STATE"},{"type":"checkbox","name":"TIN_SEARCH_YN","defaultValue":false,"label":"Tax Identification Number Search"},{"type":"checkbox","name":"TIN_SORT_YN","defaultValue":false,"label":"Unique ID Sort"}]}],"SYSTEM_NICKNAME":"Online Services Portal","PAYMENT_METHODS":[{"type":"bypass"},{"type":"iTransact"}],"PAYMENT_ALLOW_AMEX":true,"SYSTEM_ID_LABEL":"System Id","DOUBLE_COLUMN_PUBLIC_LOGIN":true,"INTERNAL_USER_MANAGEMENT":true,"ALLOW_PUBLIC_JSON_IMPORT":false,"MAX_FILE_UPLOAD_SIZE":10000000,"REFUND_TEXT":"","RETURN_TO_HOME_ON_LOGOUT":true,"CURRENT_SOS_NAME":"Christi Jacobsen","LOGO_FILENAME":"mt-sos-logo.png","LOGO_ALT":"Christi Jacobsen, Montana Secretary of State","LOGO_FULL_WIDTH":true,"HOME_HIDE_AUTH_HINT":true,"HOME_TITLE":"Montana Secretary of State","CUSTOM_TAB_TITLE":"Official Montana","HOME_SUBTITLE":"Online Business Services","ENTITY_NAME_CONSENT_DESCRIPTION":"","ALLOW_USER_PROFILE_EDITING":true,"COMPARE_FOREIGN_NAME_IN_ENTITY_NAME_VALIDATION":true,"FOREIGN_NAME_FIELD_NAME":"KIMA_PARENT_NAME_INFO","LOGIN_TITLE":"Montana Secretary of State Online Filing Portal Login","PUBLIC_LOGIN_LABEL":"Username","REVERSE_LOGIN_COLUMNS":true,"LOGIN_SEAL_FILENAME":"seal_white.png","SEPARATE_USERNAME_AND_EMAIL":true,"CREATE_ACCOUNT_BUTTON_ALIGN_LEFT":true,"CREATE_ACCOUNT_BUTTON_TEXT":"CREATE AN ACCOUNT","PASSWORD_CUSTOM_ERROR_TEXT":"The password must meet all requirements","ACCOUNT_CREATED_MESSAGE":"Please check your email to verify your account to login and allow a few minutes for this message to arrive. Check your junk/spam folders if you do not find the email in your inbox.","PUBLIC_LOGIN_PLACEHOLDER":" ","DISABLE_DEFAULT_PAYMENT_RADIO":true,"CUSTOM_RESET_PASSWORD_ERROR_MESSAGE":"Username invalid - no account found","PUBLIC_LOGIN_CREATE_DESCRIPTION":"### Existing User:\n\n  - Enter your username and password to login.  \n\n\n  #### - OR -  \n\n\n\n  - Forgot password? Click 'Reset Password' and follow the prompts.\n  - Forgot username? Click 'Forgot Username' and follow the prompts.  \n\n\n  ### New User:\n  ","LOGIN_HELP_LINK":"https://sosmt.gov/business/how-do-i/","LOGIN_HELP_LINK_TEXT":"Need Help?","FORGOT_USERNAME_TEXT":"Forgot Username?","LOGIN_ACTIVE_DIRECTORY_TEXT":"State User Login","MULTIPLE_LOGIN_METHODS":true,"HAS_ACTIVE_DIRECTORY_LOGIN":true,"RESET_PASSWORD_WITH_USERNAME":true,"DOWNLOAD_LINK":true,"SHOW_USERNAME_ACCOUNT_CREATE":true,"SHOW_SCROLL_DOWN_ARROW":true,"SHOW_ADDRESS_ACCOUNT_CREATE":true,"TWO_COLUMN_ACCOUNT_CREATE":true,"RESET_PASSWORD_TIP":"A link to change your password has been sent to your email. Please allow a few minutes for this message to arrive. Please check your junk/spam folders if you do not find the email in your inbox.","FORGOT_PASSWORD_LINK_TEXT":"Reset Password","PHONE_NUMBER_OPTIONAL_ACCOUNT_CREATE":true,"SHOW_REQUIRED_INDICATOR_ACCOUNT_CREATE":true,"PASSWORD_REQUIREMENTS_ACCOUNT_CREATE":"\n    <ul>\n      <li>MUST contain at least 8 characters (12+ recommended)</li>\n      <li>MUST contain at least one uppercase letter.</li>\n      <li>MUST contain at least one lowercase letter.</li>\n      <li>MUST contain at least one number.</li>\n      <li>MUST contain at least one special character (!”#$%&'()*+,-./:;<=>?</li>\n    </ul>\n  ","ALLOW_CERTIFICATION_REQUEST":true,"ALLOW_PUBLIC_CERTIFICATE_REQUEST":true,"ALLOW_COPY_REQUEST":false,"ALLOW_CORRECTION_STYLING":true,"HIDE_DEPRECATION_WARNING":false,"AMEND_ROUTE_PUBLIC":true,"SEAL_FILENAME":"seal.png","SHOPPING_CART":true,"ALLOW_PAYMENT_UPDATE_WITH_EMPTY_CART":true,"RA_EMAIL":true,"RA_WEBSITE":true,"RA_NO_DEFAULT_TYPE":true,"RA_ADDRESS_LABEL":"Street Address","RA_TYPE_SELECTION_DEFAULT":true,"RA_DEFAULT_TYPE":"460","RA_OVERRIDE_TYPE_WITH_DEFAULT":true,"RA_PRINCIPAL_ADDRESS_AMS":true,"UPLOAD_AND_SUBMIT_HIDE_IF_ONE_OPTION":true,"PAYMENT_PROCESSING_MESSAGE":"Your payment is processing - Do not close your browser or click the back button","CHECKOUT_BUTTON_WHEN_PROCESSING_TEXT":"Processing","EFS_CROP_PICKER_NONE_LABEL":"Lien Duration","DISALLOWED_WIZARD_PIECES":["FormationLocale"],"REPEATER_SHOW_EDIT_BUTTON":true,"DATA_REQUEST_PAGE_TITLE":"Data Requests and Subscriptions","DATA_REQUEST_SIDEBAR_LABEL":"Data Requests & Subscriptions","LOGIN_REDIRECTS_TO_EPASS":false,"LOGIN_REDIRECTS_TO_ACTIVE_DIRECTORY":true,"LOGIN_ACTIVE_DIRECTORY_LINK":true,"FETCH_EDIT_USER_LINK":false,"LISTS_FETCH_AVAILABLE_LISTS":true,"POST_WIZARD_SUBMIT_REDIRECT_URL":"/","PIN_REQUEST_ATTESTATIONS":true,"PIN_REQUEST_DESCRIPTION":"Click **Request PIN** to have a new PIN sent to the account holder's email address on file.","OWNERSHIP_REQUEST_DESCRIPTION":"To become an **authorized user** of this record, a current **AUTHORIZED USER** will need to grant you access. To request access, click **Request Access** below.","PIN_REQUEST_SUCCESS_MESSAGE":"The PIN you have requested for this entity has been sent to the email associated with your user account.  You should receive the PIN in approximately 3-5 minutes, depending on your email service provider.","APOSTILLE_HEADER_LABEL":"Verification Information","APOSTILLE_NUMBER_LABEL":"Apostille/Authentication","APOSTILLE_CITY_STATE_OVERRIDE":"HELENA, MT","APOSTILLE_FILING_DATE_LABEL":"Issue Date","APOSTILLE_CITY_STATE_IN_CERTIFIED":true,"NOTARY_EXISTING_FILING":true,"ALLOW_REVOKE_OWN_ACCESS_ONLY":false,"HIDE_CANCEL_ON_ONETIME_DATA_REQUESTS":true,"DATA_REQUESTS_IN_SHOPPING_CART":true,"WQ_ALLOW_EDIT_PENDING_PAYMENT":true,"WQ_CONFIRM_ON_DELETE":true,"WQ_DELETE_CONFIRM_MESSAGE":"Deleting this filing will forfeit any money already paid to the Secretary of State. This action is permanent and cannot be undone, are you sure you would like to delete?","PASS_ITEM_GUIDS_ON_CHECKOUT":true,"FORM_REVISION_HISTORY":true,"CHECKOUT_DISCLAIMER":"By entering your credit card and/or checking account information you (i) state that **you are an authorized user** of the credit card and/or electronic check and that the associated information entered (e.g., account holder name, account number, billing address) is accurate, (ii) **you authorize payment processor to charge the amount you have requested** to your credit card and/or funding account, and (iii) **acknowledge if a charge is declined or reversed you may also be assessed a customary charge** by the payment processor for such transactions.","FARM_BILL_SEARCH_CONFIDENTIAL":"As a registered Farm Bill Buyer with the Montana Secretary of State’s office it is important to maintain the confidentiality of the information contained within the Farm Bill Master List. The Farm Bill Master List reflects personal data, such as Social Security Numbers, which are a key piece of personal identifiable information to assist you in determining the existence of a lien against a specific debtor. The distribution of this information beyond its intended purpose is strictly prohibited.\n\n**The debtor's tax identification number has been hidden for confidentiality reasons. You may continue to search on a tax ID number and return debtors that match your search criteria. The SSN/FEIN must be entered without dashes or spaces.  If you need access to the tax identification number to clearly identify the debtor, please contact the UCC unit at (406) 444-3665.**","VIEW_HISTORY_BUTTON_ALT_TEXT":"View Filings","WIZARD_ERROR_TITLE_MESSAGE":"Form Error","FARM_BILL_SEARCH_INTERACTIVE":true,"USE_FARM_BILL_API":true,"DISALLOW_ASSIGN_SELF_AS_RA":true,"DISALLOW_ASSIGN_SELF_AS_PRINCIPAL":true,"USE_TRADEMARK_OWNER_VALIDATION":true,"USE_ALTERNATIVE_FOREIGN_ADDRESS_LABELS":true,"MY_RECEIPTS_FILTER":[{"type":"dateRange","name":"DATE_RANGE","label":"Date range","defaultValue":{"start":null,"end":null}},{"type":"text","name":"REF_NUM","defaultValue":"","label":"Reference Number"},{"type":"text","name":"RECEIPT_NUM","defaultValue":"","label":"Receipt Id"},{"type":"text","name":"AMOUNT","defaultValue":"","label":"Amount"},{"type":"select","name":"TYPE","defaultValue":"","label":"Payment Type","options":[{"value":"","label":"All"},{"value":"CC","label":"Credit Card"},{"value":"Check","label":"Check"}]}],"MY_RECEIPTS_SHOW_IN_SIDEBAR":true,"SHOW_MY_RECEIPTS_HELPER_TEXT":true,"MY_RECEIPTS_HELPER_LABEL":"About Receipt Search","MY_RECEIPTS_HELPER_TEXT":"You can search for receipts based on their descriptions, including the items paid for on the receipt. Use the filters to search for or filter specific information.","FARM_BILL_SUBLINK":{"label":"Farm Bill","component":"FarmBill","parameter":"farm-bill","path":"/lists/farm-bill","sourceTypeId":0,"myRecordsSearch":false,"allowedRules":["/search/"],"disabled":true,"searchDescription":"To perform a search, enter a debtor name. Your search results may include: exact debtor name, variations of that name and any filing that includes your search criteria. Punctuation is ignored.\n\nYou can click on \"Advanced\" to refine your search. Under “Advanced” you can search by crop, year, county and SSN/FEIN. As a registered Farm Bill Buyer with the Montana Secretary of State’s office it is important to maintain the confidentiality of the information contained within the Farm Bill Master List. The Farm Bill Master List reflects personal data, such as Social Security Numbers, which are a key piece of personal identifiable information to assist you in determining the existence of a lien against a specific debtor. The distribution of this information beyond its intended purpose is strictly prohibited.\n\nThe debtor's tax identification number has been hidden for confidentiality reasons. You may continue to search on a tax ID number and return debtors that match your search criteria. The SSN/FEIN must be entered without dashes or spaces.","searchMustHaveOneOf":["search","UCC_FARM_PRODUCT_ID","COUNTY"],"searchPlaceholder":"Search by debtor name","advancedSearchParameters":[{"type":"ServerMultiComplete","label":"Product code name(s)","name":"UCC_FARM_PRODUCT_ID","defaultValue":"","optionsSrc":"UCC_FARM_PRODUCT_V"},{"type":"MultiComplete","label":"Year or Range of Years","name":"YEAR_NUM","optionsSrc":"years","startYear":"1968","defaultValue":[],"preMergeOptions":[{"value":"ALL","label":"All"}]},{"type":"serverSelect","label":"State","name":"STATE","defaultValue":"MONTANA","optionsSrc":"STATE"},{"type":"ServerMultiComplete","label":"County","name":"COUNTY","defaultValue":[],"optionsSrc":"COUNTY","overrideSubOptionsSrcFromParameterName":"STATE"},{"type":"checkbox","name":"TIN_SEARCH_YN","defaultValue":false,"label":"Tax Identification Number Search"},{"type":"checkbox","name":"TIN_SORT_YN","defaultValue":false,"label":"Unique ID Sort"}]},"ALLOW_ADDRESS_VALIDATION_BYPASS_OPTION":true,"DEFAULT_ADDRESS_VALIDATION_BYPASS_OPTION_CHECKED":true}).SHOW_REQUEST_ACCESS_PUBLIC;
	var SHOPPING_CART = (true);
	
	var ALLOW_CERTIFICATION_REQUEST = (true) === undefined ? true : (true);
	
	var ALLOW_COPY_REQUEST = (false) === undefined ? true : (false);
	
	var ALLOW_REINSTATEMENT_AR_MODAL = ({"NODE_ENV":"production","BUILD_DATE":"2025-08-27T15:15:31.687Z","BUILD_NUMBER":"Not Provided","GIT_VERSION":"v1.3.0-381-ga81e29b08","GIT_COMMIT_HASH":"a81e29b085c9268ffd96c78eb734365802722741","GIT_BRANCH":"beta","PUBLIC_URL":"","STATE_ABBR":"MT","STATE_NAME":"Montana","STATE_ORG_TITLE":"Secretary of State","LOGIN_HEADER_IMG_PATH":"","HOME_IMG_FILENAME":"montana.jpg","FAVICON_FILE_NAME":"favicon.ico","ALLOW_E_SIGN_ON_CORRECTIONS":true,"THIRD_PARTY_SIGNING_ALLOWED":false,"MY_ACCOUNT_SAVE_AND_CLOSE_BUTTON":true,"IE_DEPRECATED_MESSAGE":"Internet Explorer is not supported. Please select a supported browser below to access this website.","ADDITIONAL_ROUTES":{"dataRequests":true,"farmBill":true,"apostille":true,"externalHelp":"https://sosmt.gov/business/help-center/","systemAdministration":[{"title":"Saved Payments","parameter":"saved-payments","componentName":"SavedPayments"}]},"SUBROUTES":[{"label":"Business","component":"Business","parameter":"business","myWorkQueueSearch":false,"sourceTypeId":54,"searchMustHaveOneOf":["FILING_TYPE_ID","STATUS_ID","STATE","search"],"serverWebSearchDescription":true,"serverWorkQueueDescription":true,"serverMyRecordsDescription":true,"searchPlaceholder":"Search by name or filing number (X########)","allowEmptySearchTerm":true,"requestCertificateAlternateLabel":"Request Information","fileAmendmentButtonLabel":"Filing Actions","advancedSearchParameters":[{"type":"radio","name":"QUERY_TYPE_ID","defaultValue":1010,"options":[{"value":1010,"label":"Starts with"},{"value":1011,"label":"Contains"},{"value":1012,"label":" Word Contains"}]},{"type":"serverSelect","name":"FILING_TYPE_ID","optionsSrc":"FILING_TYPES","label":"Entity Type","placeholder":"All","defaultValue":"0"},{"type":"serverSelect","name":"FILING_SUBTYPE_ID","optionsSrc":"FILING_SUBTYPES","label":"Entity Subtype","overrideSubOptionsSrcFromParameterName":"FILING_TYPE_ID","placeholder":"All","defaultValue":"0"},{"type":"serverSelect","name":"STATUS_ID","optionsSrc":"FILING_STATUS_WITHOUT_ALL","label":"Status","placeholder":"All","defaultValue":"0"},{"type":"serverSelect","name":"STATE","optionsSrc":"STATE","label":"State","placeholder":"All","defaultValue":""},{"type":"serverSelect","name":"COUNTY","optionsSrc":"COUNTY_SUBOPTION","label":"County","overrideSubOptionsSrcFromParameterName":"STATE","placeholder":"All","defaultValue":""},{"type":"checkbox","name":"CRA_SEARCH_YN","defaultValue":false,"label":"Search by Registered Agent PID"},{"type":"dateRange","name":"FILING_DATE","label":"Registration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}},{"type":"dateRange","name":"EXPIRATION_DATE","label":"Expiration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}}],"myRecordsFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Active"},{"value":2,"label":"Inactive"},{"value":3,"label":"Pending"}]},{"type":"dateRange","name":"DATE_RANGE","label":"Date range","defaultValue":{"start":null,"end":null}}],"myWorkQueueFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Approved"},{"value":2,"label":"Pending Online Payment"},{"value":3,"label":"Pending Review"},{"value":4,"label":"Needs Correction"},{"value":5,"label":"Rejected"},{"value":6,"label":"Draft"}]},{"type":"dateRange","name":"DATE_RANGE","label":"Date range","defaultValue":{"start":null,"end":null}}]},{"label":"Notary","component":"Notary","parameter":"notary","sourceTypeId":850,"myWorkQueueSearch":false,"allowEmptySearchTerm":true,"requestCertificateAlternateLabel":"Download Certificate","fileAmendmentButtonLabel":"Filing Actions","hideNameRequestCertificate":true,"hideAddressRequestCertificate":true,"hideRecordUserManagment":true,"searchPlaceholder":"Search by name or commission number","searchMustHaveOneOf":["CITY","search","SERVICE_TYPE"],"advancedParametersStartOpen":true,"searchIsSortable":true,"advancedSearchParameters":[{"type":"radio","name":"STARTS_WITH_YN","defaultValue":false,"options":[{"value":true,"label":"Starts with"},{"value":false,"label":"Contains"}]},{"type":"checkbox","name":"ACTIVE_ONLY_YN","defaultValue":true,"label":"Active entities only"},{"type":"text","name":"CITY","defaultValue":"","label":"City"},{"type":"select","name":"SERVICE_TYPE","label":"Special Services Offered","defaultValue":0,"options":[{"value":0,"label":"(N/A)"},{"value":6165,"label":"In-Person Electronic Notarization (IPEN)"},{"value":6166,"label":"Remote Online Notarization (RON)"},{"value":6167,"label":"Mobile Notary Services"},{"value":6168,"label":"Remote Ink Notarization (RIN)"}]}]},{"label":"Apostille","component":"Apostille","parameter":"apostille","sourceTypeId":720,"myRecordsSearch":false,"myWorkQueueSearch":false,"disabled":false,"allowedRoutes":["/forms-manager/","/queue/","/forms/"]},{"label":"Liens","component":"UCC","parameter":"ucc","sourceTypeId":1999,"myRecordsSearch":true,"myWorkQueueSearch":true,"fileAmendmentButtonLabel":"Filing Actions","searchPlaceholder":"Search by name or file number","disabled":false,"serverWebSearchDescription":true,"myRecordsDescription":"","workQueueDescription":"","searchDescription":"","hideRecordUserManagment":true,"searchLiensCheckout":false,"advancedSearchParameters":[{"type":"radio","name":"STARTS_WITH_YN","defaultValue":false,"options":[{"value":true,"label":"Starts with"},{"value":false,"label":"Contains"}]},{"type":"select","name":"STATUS","defaultValue":"ALL","label":"Status","options":[{"value":"ACTIVE_UNLAPSED","label":"Active (unlapsed)"},{"value":"ACTIVE_LAPSED_UNLAPSED","label":"Active (lapsed and unlapsed)"}]},{"type":"text","name":"EXCLUDE_VALUES","label":"Exclude Debtor Names (comma separated list of names to exclude)","defaultValue":""},{"type":"dateRange","name":"FILING_DATE","label":"Financing Statement Date","defaultValue":{"start":null,"end":null}},{"type":"dateRange","name":"LAPSE_DATE","label":"Lapse Date","defaultValue":{"start":null,"end":null}},{"type":"text","name":"CITY","label":"Debtor City","defaultValue":""}],"myRecordsFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Approved"},{"value":2,"label":"Pending Online Payment"},{"value":3,"label":"Pending Review"}]},{"type":"select","name":"TYPE","defaultValue":0,"label":"Lien Type","options":[{"value":0,"label":"All"},{"value":1,"label":"UCC"},{"value":2,"label":"EFS"},{"value":3,"label":"Title 71"}]}],"myWorkQueueFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Approved"},{"value":2,"label":"Pending Online Payment"},{"value":3,"label":"Pending Review"},{"value":4,"label":"Pending Print and Mail"},{"value":5,"label":"Rejected"},{"value":6,"label":"Draft"}]},{"type":"select","name":"TYPE","defaultValue":0,"label":"Lien Type","options":[{"value":0,"label":"All"},{"value":1,"label":"UCC"},{"value":2,"label":"EFS"},{"value":3,"label":"Title 71"}]}]},{"label":"Copy Request","component":"copies","parameter":"copies","sourceTypeId":2001,"myRecordsSearch":false,"myWorkQueueSearch":false,"disabled":false,"allowedRoutes":["/forms-manager/","/queue/","/forms/"]},{"label":"Trademark","component":"Trademark","parameter":"trademark","sourceTypeId":810,"showRequestCertificate":true,"searchMustHaveOneOf":["search","EXPIRATION_DATE","FILING_DATE"],"allowEmptySearchTerm":true,"requestCertificateAlternateLabel":"Request Information","fileAmendmentButtonLabel":"Filing Actions","advancedSearchParameters":[{"type":"radio","name":"QUERY_TYPE_ID","defaultValue":1010,"options":[{"value":1010,"label":"Starts with"},{"value":1011,"label":"Contains"},{"value":1012,"label":" Word Contains"}]},{"type":"checkbox","name":"OWNER_SEARCH_YN","defaultValue":false,"label":"Search owners"},{"type":"radio","name":"SERVICE_MARK_YN","label":"Mark Type","defaultValue":"","options":[{"value":"","label":"All Marks"},{"value":"Y","label":"Service Mark"},{"value":"N","label":"Trademark"}]},{"type":"serverSelect","name":"STATUS_ID","optionsSrc":"TYPE_V|TRADEMARK_STATUS_TYPE","label":"Status","placeholder":"All","defaultValue":"0"},{"type":"select","name":"DESIGN_TYPE_ID","options":[{"value":0,"label":"All"},{"value":990,"label":"Words Only"},{"value":991,"label":"Design Only"},{"value":992,"label":"Words and Design"}],"label":"Design Type","defaultValue":"0"},{"type":"dateRange","name":"FILING_DATE","label":"Registered Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}},{"type":"dateRange","name":"EXPIRATION_DATE","label":"Expiration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}}]},{"label":"Business Info Request","component":"InfoRequests","parameter":"info-request","sourceTypeId":167,"allowedRoutes":["/forms-manager/","/queue/","/forms/"]},{"label":"Data Requests","component":"DataRequests","parameter":"data-request","sourceTypeId":0,"allowedRoutes":["/forms-manager/"]},{"label":"CRA","component":"CRA","parameter":"cra","sourceTypeId":157,"myRecordsSearch":false,"searchPlaceholder":"Search by name or registered agent number","allowedRoutes":["/forms-manager/","/forms/","/records/","/queue/","/search/"],"allowEmptySearchTerm":true,"fileAmendmentButtonLabel":"Filing Actions","advancedSearchParameters":[{"type":"radio","name":"QUERY_TYPE_ID","defaultValue":1010,"options":[{"value":1010,"label":"Starts with"},{"value":1011,"label":"Contains"},{"value":1012,"label":" Word Contains"}]},{"type":"dateRange","name":"CRA_DATE","label":"Registration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}},{"type":"select","name":"STATUS_ID","label":"Status","defaultValue":0,"options":[{"value":0,"label":"All"},{"value":121,"label":"Active"},{"value":122,"label":"Inactive"}]},{"type":"select","name":"AGENT_TYPE_ID","label":"Agent Type","defaultValue":0,"options":[{"value":0,"label":"All"},{"value":460,"label":"Registered Agent"},{"value":461,"label":"Commercial Registered Agent"}]}]},{"label":"Farm Bill","component":"FarmBill","parameter":"farm-bill","path":"/lists/farm-bill","sourceTypeId":0,"myRecordsSearch":false,"allowedRules":["/search/"],"disabled":true,"searchDescription":"To perform a search, enter a debtor name. Your search results may include: exact debtor name, variations of that name and any filing that includes your search criteria. Punctuation is ignored.\n\nYou can click on \"Advanced\" to refine your search. Under “Advanced” you can search by crop, year, county and SSN/FEIN. As a registered Farm Bill Buyer with the Montana Secretary of State’s office it is important to maintain the confidentiality of the information contained within the Farm Bill Master List. The Farm Bill Master List reflects personal data, such as Social Security Numbers, which are a key piece of personal identifiable information to assist you in determining the existence of a lien against a specific debtor. The distribution of this information beyond its intended purpose is strictly prohibited.\n\nThe debtor's tax identification number has been hidden for confidentiality reasons. You may continue to search on a tax ID number and return debtors that match your search criteria. The SSN/FEIN must be entered without dashes or spaces.","searchMustHaveOneOf":["search","UCC_FARM_PRODUCT_ID","COUNTY"],"searchPlaceholder":"Search by debtor name","advancedSearchParameters":[{"type":"ServerMultiComplete","label":"Product code name(s)","name":"UCC_FARM_PRODUCT_ID","defaultValue":"","optionsSrc":"UCC_FARM_PRODUCT_V"},{"type":"MultiComplete","label":"Year or Range of Years","name":"YEAR_NUM","optionsSrc":"years","startYear":"1968","defaultValue":[],"preMergeOptions":[{"value":"ALL","label":"All"}]},{"type":"serverSelect","label":"State","name":"STATE","defaultValue":"MONTANA","optionsSrc":"STATE"},{"type":"ServerMultiComplete","label":"County","name":"COUNTY","defaultValue":[],"optionsSrc":"COUNTY","overrideSubOptionsSrcFromParameterName":"STATE"},{"type":"checkbox","name":"TIN_SEARCH_YN","defaultValue":false,"label":"Tax Identification Number Search"},{"type":"checkbox","name":"TIN_SORT_YN","defaultValue":false,"label":"Unique ID Sort"}]}],"SYSTEM_NICKNAME":"Online Services Portal","PAYMENT_METHODS":[{"type":"bypass"},{"type":"iTransact"}],"PAYMENT_ALLOW_AMEX":true,"SYSTEM_ID_LABEL":"System Id","DOUBLE_COLUMN_PUBLIC_LOGIN":true,"INTERNAL_USER_MANAGEMENT":true,"ALLOW_PUBLIC_JSON_IMPORT":false,"MAX_FILE_UPLOAD_SIZE":10000000,"REFUND_TEXT":"","RETURN_TO_HOME_ON_LOGOUT":true,"CURRENT_SOS_NAME":"Christi Jacobsen","LOGO_FILENAME":"mt-sos-logo.png","LOGO_ALT":"Christi Jacobsen, Montana Secretary of State","LOGO_FULL_WIDTH":true,"HOME_HIDE_AUTH_HINT":true,"HOME_TITLE":"Montana Secretary of State","CUSTOM_TAB_TITLE":"Official Montana","HOME_SUBTITLE":"Online Business Services","ENTITY_NAME_CONSENT_DESCRIPTION":"","ALLOW_USER_PROFILE_EDITING":true,"COMPARE_FOREIGN_NAME_IN_ENTITY_NAME_VALIDATION":true,"FOREIGN_NAME_FIELD_NAME":"KIMA_PARENT_NAME_INFO","LOGIN_TITLE":"Montana Secretary of State Online Filing Portal Login","PUBLIC_LOGIN_LABEL":"Username","REVERSE_LOGIN_COLUMNS":true,"LOGIN_SEAL_FILENAME":"seal_white.png","SEPARATE_USERNAME_AND_EMAIL":true,"CREATE_ACCOUNT_BUTTON_ALIGN_LEFT":true,"CREATE_ACCOUNT_BUTTON_TEXT":"CREATE AN ACCOUNT","PASSWORD_CUSTOM_ERROR_TEXT":"The password must meet all requirements","ACCOUNT_CREATED_MESSAGE":"Please check your email to verify your account to login and allow a few minutes for this message to arrive. Check your junk/spam folders if you do not find the email in your inbox.","PUBLIC_LOGIN_PLACEHOLDER":" ","DISABLE_DEFAULT_PAYMENT_RADIO":true,"CUSTOM_RESET_PASSWORD_ERROR_MESSAGE":"Username invalid - no account found","PUBLIC_LOGIN_CREATE_DESCRIPTION":"### Existing User:\n\n  - Enter your username and password to login.  \n\n\n  #### - OR -  \n\n\n\n  - Forgot password? Click 'Reset Password' and follow the prompts.\n  - Forgot username? Click 'Forgot Username' and follow the prompts.  \n\n\n  ### New User:\n  ","LOGIN_HELP_LINK":"https://sosmt.gov/business/how-do-i/","LOGIN_HELP_LINK_TEXT":"Need Help?","FORGOT_USERNAME_TEXT":"Forgot Username?","LOGIN_ACTIVE_DIRECTORY_TEXT":"State User Login","MULTIPLE_LOGIN_METHODS":true,"HAS_ACTIVE_DIRECTORY_LOGIN":true,"RESET_PASSWORD_WITH_USERNAME":true,"DOWNLOAD_LINK":true,"SHOW_USERNAME_ACCOUNT_CREATE":true,"SHOW_SCROLL_DOWN_ARROW":true,"SHOW_ADDRESS_ACCOUNT_CREATE":true,"TWO_COLUMN_ACCOUNT_CREATE":true,"RESET_PASSWORD_TIP":"A link to change your password has been sent to your email. Please allow a few minutes for this message to arrive. Please check your junk/spam folders if you do not find the email in your inbox.","FORGOT_PASSWORD_LINK_TEXT":"Reset Password","PHONE_NUMBER_OPTIONAL_ACCOUNT_CREATE":true,"SHOW_REQUIRED_INDICATOR_ACCOUNT_CREATE":true,"PASSWORD_REQUIREMENTS_ACCOUNT_CREATE":"\n    <ul>\n      <li>MUST contain at least 8 characters (12+ recommended)</li>\n      <li>MUST contain at least one uppercase letter.</li>\n      <li>MUST contain at least one lowercase letter.</li>\n      <li>MUST contain at least one number.</li>\n      <li>MUST contain at least one special character (!”#$%&'()*+,-./:;<=>?</li>\n    </ul>\n  ","ALLOW_CERTIFICATION_REQUEST":true,"ALLOW_PUBLIC_CERTIFICATE_REQUEST":true,"ALLOW_COPY_REQUEST":false,"ALLOW_CORRECTION_STYLING":true,"HIDE_DEPRECATION_WARNING":false,"AMEND_ROUTE_PUBLIC":true,"SEAL_FILENAME":"seal.png","SHOPPING_CART":true,"ALLOW_PAYMENT_UPDATE_WITH_EMPTY_CART":true,"RA_EMAIL":true,"RA_WEBSITE":true,"RA_NO_DEFAULT_TYPE":true,"RA_ADDRESS_LABEL":"Street Address","RA_TYPE_SELECTION_DEFAULT":true,"RA_DEFAULT_TYPE":"460","RA_OVERRIDE_TYPE_WITH_DEFAULT":true,"RA_PRINCIPAL_ADDRESS_AMS":true,"UPLOAD_AND_SUBMIT_HIDE_IF_ONE_OPTION":true,"PAYMENT_PROCESSING_MESSAGE":"Your payment is processing - Do not close your browser or click the back button","CHECKOUT_BUTTON_WHEN_PROCESSING_TEXT":"Processing","EFS_CROP_PICKER_NONE_LABEL":"Lien Duration","DISALLOWED_WIZARD_PIECES":["FormationLocale"],"REPEATER_SHOW_EDIT_BUTTON":true,"DATA_REQUEST_PAGE_TITLE":"Data Requests and Subscriptions","DATA_REQUEST_SIDEBAR_LABEL":"Data Requests & Subscriptions","LOGIN_REDIRECTS_TO_EPASS":false,"LOGIN_REDIRECTS_TO_ACTIVE_DIRECTORY":true,"LOGIN_ACTIVE_DIRECTORY_LINK":true,"FETCH_EDIT_USER_LINK":false,"LISTS_FETCH_AVAILABLE_LISTS":true,"POST_WIZARD_SUBMIT_REDIRECT_URL":"/","PIN_REQUEST_ATTESTATIONS":true,"PIN_REQUEST_DESCRIPTION":"Click **Request PIN** to have a new PIN sent to the account holder's email address on file.","OWNERSHIP_REQUEST_DESCRIPTION":"To become an **authorized user** of this record, a current **AUTHORIZED USER** will need to grant you access. To request access, click **Request Access** below.","PIN_REQUEST_SUCCESS_MESSAGE":"The PIN you have requested for this entity has been sent to the email associated with your user account.  You should receive the PIN in approximately 3-5 minutes, depending on your email service provider.","APOSTILLE_HEADER_LABEL":"Verification Information","APOSTILLE_NUMBER_LABEL":"Apostille/Authentication","APOSTILLE_CITY_STATE_OVERRIDE":"HELENA, MT","APOSTILLE_FILING_DATE_LABEL":"Issue Date","APOSTILLE_CITY_STATE_IN_CERTIFIED":true,"NOTARY_EXISTING_FILING":true,"ALLOW_REVOKE_OWN_ACCESS_ONLY":false,"HIDE_CANCEL_ON_ONETIME_DATA_REQUESTS":true,"DATA_REQUESTS_IN_SHOPPING_CART":true,"WQ_ALLOW_EDIT_PENDING_PAYMENT":true,"WQ_CONFIRM_ON_DELETE":true,"WQ_DELETE_CONFIRM_MESSAGE":"Deleting this filing will forfeit any money already paid to the Secretary of State. This action is permanent and cannot be undone, are you sure you would like to delete?","PASS_ITEM_GUIDS_ON_CHECKOUT":true,"FORM_REVISION_HISTORY":true,"CHECKOUT_DISCLAIMER":"By entering your credit card and/or checking account information you (i) state that **you are an authorized user** of the credit card and/or electronic check and that the associated information entered (e.g., account holder name, account number, billing address) is accurate, (ii) **you authorize payment processor to charge the amount you have requested** to your credit card and/or funding account, and (iii) **acknowledge if a charge is declined or reversed you may also be assessed a customary charge** by the payment processor for such transactions.","FARM_BILL_SEARCH_CONFIDENTIAL":"As a registered Farm Bill Buyer with the Montana Secretary of State’s office it is important to maintain the confidentiality of the information contained within the Farm Bill Master List. The Farm Bill Master List reflects personal data, such as Social Security Numbers, which are a key piece of personal identifiable information to assist you in determining the existence of a lien against a specific debtor. The distribution of this information beyond its intended purpose is strictly prohibited.\n\n**The debtor's tax identification number has been hidden for confidentiality reasons. You may continue to search on a tax ID number and return debtors that match your search criteria. The SSN/FEIN must be entered without dashes or spaces.  If you need access to the tax identification number to clearly identify the debtor, please contact the UCC unit at (406) 444-3665.**","VIEW_HISTORY_BUTTON_ALT_TEXT":"View Filings","WIZARD_ERROR_TITLE_MESSAGE":"Form Error","FARM_BILL_SEARCH_INTERACTIVE":true,"USE_FARM_BILL_API":true,"DISALLOW_ASSIGN_SELF_AS_RA":true,"DISALLOW_ASSIGN_SELF_AS_PRINCIPAL":true,"USE_TRADEMARK_OWNER_VALIDATION":true,"USE_ALTERNATIVE_FOREIGN_ADDRESS_LABELS":true,"MY_RECEIPTS_FILTER":[{"type":"dateRange","name":"DATE_RANGE","label":"Date range","defaultValue":{"start":null,"end":null}},{"type":"text","name":"REF_NUM","defaultValue":"","label":"Reference Number"},{"type":"text","name":"RECEIPT_NUM","defaultValue":"","label":"Receipt Id"},{"type":"text","name":"AMOUNT","defaultValue":"","label":"Amount"},{"type":"select","name":"TYPE","defaultValue":"","label":"Payment Type","options":[{"value":"","label":"All"},{"value":"CC","label":"Credit Card"},{"value":"Check","label":"Check"}]}],"MY_RECEIPTS_SHOW_IN_SIDEBAR":true,"SHOW_MY_RECEIPTS_HELPER_TEXT":true,"MY_RECEIPTS_HELPER_LABEL":"About Receipt Search","MY_RECEIPTS_HELPER_TEXT":"You can search for receipts based on their descriptions, including the items paid for on the receipt. Use the filters to search for or filter specific information.","FARM_BILL_SUBLINK":{"label":"Farm Bill","component":"FarmBill","parameter":"farm-bill","path":"/lists/farm-bill","sourceTypeId":0,"myRecordsSearch":false,"allowedRules":["/search/"],"disabled":true,"searchDescription":"To perform a search, enter a debtor name. Your search results may include: exact debtor name, variations of that name and any filing that includes your search criteria. Punctuation is ignored.\n\nYou can click on \"Advanced\" to refine your search. Under “Advanced” you can search by crop, year, county and SSN/FEIN. As a registered Farm Bill Buyer with the Montana Secretary of State’s office it is important to maintain the confidentiality of the information contained within the Farm Bill Master List. The Farm Bill Master List reflects personal data, such as Social Security Numbers, which are a key piece of personal identifiable information to assist you in determining the existence of a lien against a specific debtor. The distribution of this information beyond its intended purpose is strictly prohibited.\n\nThe debtor's tax identification number has been hidden for confidentiality reasons. You may continue to search on a tax ID number and return debtors that match your search criteria. The SSN/FEIN must be entered without dashes or spaces.","searchMustHaveOneOf":["search","UCC_FARM_PRODUCT_ID","COUNTY"],"searchPlaceholder":"Search by debtor name","advancedSearchParameters":[{"type":"ServerMultiComplete","label":"Product code name(s)","name":"UCC_FARM_PRODUCT_ID","defaultValue":"","optionsSrc":"UCC_FARM_PRODUCT_V"},{"type":"MultiComplete","label":"Year or Range of Years","name":"YEAR_NUM","optionsSrc":"years","startYear":"1968","defaultValue":[],"preMergeOptions":[{"value":"ALL","label":"All"}]},{"type":"serverSelect","label":"State","name":"STATE","defaultValue":"MONTANA","optionsSrc":"STATE"},{"type":"ServerMultiComplete","label":"County","name":"COUNTY","defaultValue":[],"optionsSrc":"COUNTY","overrideSubOptionsSrcFromParameterName":"STATE"},{"type":"checkbox","name":"TIN_SEARCH_YN","defaultValue":false,"label":"Tax Identification Number Search"},{"type":"checkbox","name":"TIN_SORT_YN","defaultValue":false,"label":"Unique ID Sort"}]},"ALLOW_ADDRESS_VALIDATION_BYPASS_OPTION":true,"DEFAULT_ADDRESS_VALIDATION_BYPASS_OPTION_CHECKED":true}).ALLOW_REINSTATEMENT_AR_MODAL === undefined ? true : ({"NODE_ENV":"production","BUILD_DATE":"2025-08-27T15:15:31.687Z","BUILD_NUMBER":"Not Provided","GIT_VERSION":"v1.3.0-381-ga81e29b08","GIT_COMMIT_HASH":"a81e29b085c9268ffd96c78eb734365802722741","GIT_BRANCH":"beta","PUBLIC_URL":"","STATE_ABBR":"MT","STATE_NAME":"Montana","STATE_ORG_TITLE":"Secretary of State","LOGIN_HEADER_IMG_PATH":"","HOME_IMG_FILENAME":"montana.jpg","FAVICON_FILE_NAME":"favicon.ico","ALLOW_E_SIGN_ON_CORRECTIONS":true,"THIRD_PARTY_SIGNING_ALLOWED":false,"MY_ACCOUNT_SAVE_AND_CLOSE_BUTTON":true,"IE_DEPRECATED_MESSAGE":"Internet Explorer is not supported. Please select a supported browser below to access this website.","ADDITIONAL_ROUTES":{"dataRequests":true,"farmBill":true,"apostille":true,"externalHelp":"https://sosmt.gov/business/help-center/","systemAdministration":[{"title":"Saved Payments","parameter":"saved-payments","componentName":"SavedPayments"}]},"SUBROUTES":[{"label":"Business","component":"Business","parameter":"business","myWorkQueueSearch":false,"sourceTypeId":54,"searchMustHaveOneOf":["FILING_TYPE_ID","STATUS_ID","STATE","search"],"serverWebSearchDescription":true,"serverWorkQueueDescription":true,"serverMyRecordsDescription":true,"searchPlaceholder":"Search by name or filing number (X########)","allowEmptySearchTerm":true,"requestCertificateAlternateLabel":"Request Information","fileAmendmentButtonLabel":"Filing Actions","advancedSearchParameters":[{"type":"radio","name":"QUERY_TYPE_ID","defaultValue":1010,"options":[{"value":1010,"label":"Starts with"},{"value":1011,"label":"Contains"},{"value":1012,"label":" Word Contains"}]},{"type":"serverSelect","name":"FILING_TYPE_ID","optionsSrc":"FILING_TYPES","label":"Entity Type","placeholder":"All","defaultValue":"0"},{"type":"serverSelect","name":"FILING_SUBTYPE_ID","optionsSrc":"FILING_SUBTYPES","label":"Entity Subtype","overrideSubOptionsSrcFromParameterName":"FILING_TYPE_ID","placeholder":"All","defaultValue":"0"},{"type":"serverSelect","name":"STATUS_ID","optionsSrc":"FILING_STATUS_WITHOUT_ALL","label":"Status","placeholder":"All","defaultValue":"0"},{"type":"serverSelect","name":"STATE","optionsSrc":"STATE","label":"State","placeholder":"All","defaultValue":""},{"type":"serverSelect","name":"COUNTY","optionsSrc":"COUNTY_SUBOPTION","label":"County","overrideSubOptionsSrcFromParameterName":"STATE","placeholder":"All","defaultValue":""},{"type":"checkbox","name":"CRA_SEARCH_YN","defaultValue":false,"label":"Search by Registered Agent PID"},{"type":"dateRange","name":"FILING_DATE","label":"Registration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}},{"type":"dateRange","name":"EXPIRATION_DATE","label":"Expiration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}}],"myRecordsFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Active"},{"value":2,"label":"Inactive"},{"value":3,"label":"Pending"}]},{"type":"dateRange","name":"DATE_RANGE","label":"Date range","defaultValue":{"start":null,"end":null}}],"myWorkQueueFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Approved"},{"value":2,"label":"Pending Online Payment"},{"value":3,"label":"Pending Review"},{"value":4,"label":"Needs Correction"},{"value":5,"label":"Rejected"},{"value":6,"label":"Draft"}]},{"type":"dateRange","name":"DATE_RANGE","label":"Date range","defaultValue":{"start":null,"end":null}}]},{"label":"Notary","component":"Notary","parameter":"notary","sourceTypeId":850,"myWorkQueueSearch":false,"allowEmptySearchTerm":true,"requestCertificateAlternateLabel":"Download Certificate","fileAmendmentButtonLabel":"Filing Actions","hideNameRequestCertificate":true,"hideAddressRequestCertificate":true,"hideRecordUserManagment":true,"searchPlaceholder":"Search by name or commission number","searchMustHaveOneOf":["CITY","search","SERVICE_TYPE"],"advancedParametersStartOpen":true,"searchIsSortable":true,"advancedSearchParameters":[{"type":"radio","name":"STARTS_WITH_YN","defaultValue":false,"options":[{"value":true,"label":"Starts with"},{"value":false,"label":"Contains"}]},{"type":"checkbox","name":"ACTIVE_ONLY_YN","defaultValue":true,"label":"Active entities only"},{"type":"text","name":"CITY","defaultValue":"","label":"City"},{"type":"select","name":"SERVICE_TYPE","label":"Special Services Offered","defaultValue":0,"options":[{"value":0,"label":"(N/A)"},{"value":6165,"label":"In-Person Electronic Notarization (IPEN)"},{"value":6166,"label":"Remote Online Notarization (RON)"},{"value":6167,"label":"Mobile Notary Services"},{"value":6168,"label":"Remote Ink Notarization (RIN)"}]}]},{"label":"Apostille","component":"Apostille","parameter":"apostille","sourceTypeId":720,"myRecordsSearch":false,"myWorkQueueSearch":false,"disabled":false,"allowedRoutes":["/forms-manager/","/queue/","/forms/"]},{"label":"Liens","component":"UCC","parameter":"ucc","sourceTypeId":1999,"myRecordsSearch":true,"myWorkQueueSearch":true,"fileAmendmentButtonLabel":"Filing Actions","searchPlaceholder":"Search by name or file number","disabled":false,"serverWebSearchDescription":true,"myRecordsDescription":"","workQueueDescription":"","searchDescription":"","hideRecordUserManagment":true,"searchLiensCheckout":false,"advancedSearchParameters":[{"type":"radio","name":"STARTS_WITH_YN","defaultValue":false,"options":[{"value":true,"label":"Starts with"},{"value":false,"label":"Contains"}]},{"type":"select","name":"STATUS","defaultValue":"ALL","label":"Status","options":[{"value":"ACTIVE_UNLAPSED","label":"Active (unlapsed)"},{"value":"ACTIVE_LAPSED_UNLAPSED","label":"Active (lapsed and unlapsed)"}]},{"type":"text","name":"EXCLUDE_VALUES","label":"Exclude Debtor Names (comma separated list of names to exclude)","defaultValue":""},{"type":"dateRange","name":"FILING_DATE","label":"Financing Statement Date","defaultValue":{"start":null,"end":null}},{"type":"dateRange","name":"LAPSE_DATE","label":"Lapse Date","defaultValue":{"start":null,"end":null}},{"type":"text","name":"CITY","label":"Debtor City","defaultValue":""}],"myRecordsFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Approved"},{"value":2,"label":"Pending Online Payment"},{"value":3,"label":"Pending Review"}]},{"type":"select","name":"TYPE","defaultValue":0,"label":"Lien Type","options":[{"value":0,"label":"All"},{"value":1,"label":"UCC"},{"value":2,"label":"EFS"},{"value":3,"label":"Title 71"}]}],"myWorkQueueFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Approved"},{"value":2,"label":"Pending Online Payment"},{"value":3,"label":"Pending Review"},{"value":4,"label":"Pending Print and Mail"},{"value":5,"label":"Rejected"},{"value":6,"label":"Draft"}]},{"type":"select","name":"TYPE","defaultValue":0,"label":"Lien Type","options":[{"value":0,"label":"All"},{"value":1,"label":"UCC"},{"value":2,"label":"EFS"},{"value":3,"label":"Title 71"}]}]},{"label":"Copy Request","component":"copies","parameter":"copies","sourceTypeId":2001,"myRecordsSearch":false,"myWorkQueueSearch":false,"disabled":false,"allowedRoutes":["/forms-manager/","/queue/","/forms/"]},{"label":"Trademark","component":"Trademark","parameter":"trademark","sourceTypeId":810,"showRequestCertificate":true,"searchMustHaveOneOf":["search","EXPIRATION_DATE","FILING_DATE"],"allowEmptySearchTerm":true,"requestCertificateAlternateLabel":"Request Information","fileAmendmentButtonLabel":"Filing Actions","advancedSearchParameters":[{"type":"radio","name":"QUERY_TYPE_ID","defaultValue":1010,"options":[{"value":1010,"label":"Starts with"},{"value":1011,"label":"Contains"},{"value":1012,"label":" Word Contains"}]},{"type":"checkbox","name":"OWNER_SEARCH_YN","defaultValue":false,"label":"Search owners"},{"type":"radio","name":"SERVICE_MARK_YN","label":"Mark Type","defaultValue":"","options":[{"value":"","label":"All Marks"},{"value":"Y","label":"Service Mark"},{"value":"N","label":"Trademark"}]},{"type":"serverSelect","name":"STATUS_ID","optionsSrc":"TYPE_V|TRADEMARK_STATUS_TYPE","label":"Status","placeholder":"All","defaultValue":"0"},{"type":"select","name":"DESIGN_TYPE_ID","options":[{"value":0,"label":"All"},{"value":990,"label":"Words Only"},{"value":991,"label":"Design Only"},{"value":992,"label":"Words and Design"}],"label":"Design Type","defaultValue":"0"},{"type":"dateRange","name":"FILING_DATE","label":"Registered Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}},{"type":"dateRange","name":"EXPIRATION_DATE","label":"Expiration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}}]},{"label":"Business Info Request","component":"InfoRequests","parameter":"info-request","sourceTypeId":167,"allowedRoutes":["/forms-manager/","/queue/","/forms/"]},{"label":"Data Requests","component":"DataRequests","parameter":"data-request","sourceTypeId":0,"allowedRoutes":["/forms-manager/"]},{"label":"CRA","component":"CRA","parameter":"cra","sourceTypeId":157,"myRecordsSearch":false,"searchPlaceholder":"Search by name or registered agent number","allowedRoutes":["/forms-manager/","/forms/","/records/","/queue/","/search/"],"allowEmptySearchTerm":true,"fileAmendmentButtonLabel":"Filing Actions","advancedSearchParameters":[{"type":"radio","name":"QUERY_TYPE_ID","defaultValue":1010,"options":[{"value":1010,"label":"Starts with"},{"value":1011,"label":"Contains"},{"value":1012,"label":" Word Contains"}]},{"type":"dateRange","name":"CRA_DATE","label":"Registration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}},{"type":"select","name":"STATUS_ID","label":"Status","defaultValue":0,"options":[{"value":0,"label":"All"},{"value":121,"label":"Active"},{"value":122,"label":"Inactive"}]},{"type":"select","name":"AGENT_TYPE_ID","label":"Agent Type","defaultValue":0,"options":[{"value":0,"label":"All"},{"value":460,"label":"Registered Agent"},{"value":461,"label":"Commercial Registered Agent"}]}]},{"label":"Farm Bill","component":"FarmBill","parameter":"farm-bill","path":"/lists/farm-bill","sourceTypeId":0,"myRecordsSearch":false,"allowedRules":["/search/"],"disabled":true,"searchDescription":"To perform a search, enter a debtor name. Your search results may include: exact debtor name, variations of that name and any filing that includes your search criteria. Punctuation is ignored.\n\nYou can click on \"Advanced\" to refine your search. Under “Advanced” you can search by crop, year, county and SSN/FEIN. As a registered Farm Bill Buyer with the Montana Secretary of State’s office it is important to maintain the confidentiality of the information contained within the Farm Bill Master List. The Farm Bill Master List reflects personal data, such as Social Security Numbers, which are a key piece of personal identifiable information to assist you in determining the existence of a lien against a specific debtor. The distribution of this information beyond its intended purpose is strictly prohibited.\n\nThe debtor's tax identification number has been hidden for confidentiality reasons. You may continue to search on a tax ID number and return debtors that match your search criteria. The SSN/FEIN must be entered without dashes or spaces.","searchMustHaveOneOf":["search","UCC_FARM_PRODUCT_ID","COUNTY"],"searchPlaceholder":"Search by debtor name","advancedSearchParameters":[{"type":"ServerMultiComplete","label":"Product code name(s)","name":"UCC_FARM_PRODUCT_ID","defaultValue":"","optionsSrc":"UCC_FARM_PRODUCT_V"},{"type":"MultiComplete","label":"Year or Range of Years","name":"YEAR_NUM","optionsSrc":"years","startYear":"1968","defaultValue":[],"preMergeOptions":[{"value":"ALL","label":"All"}]},{"type":"serverSelect","label":"State","name":"STATE","defaultValue":"MONTANA","optionsSrc":"STATE"},{"type":"ServerMultiComplete","label":"County","name":"COUNTY","defaultValue":[],"optionsSrc":"COUNTY","overrideSubOptionsSrcFromParameterName":"STATE"},{"type":"checkbox","name":"TIN_SEARCH_YN","defaultValue":false,"label":"Tax Identification Number Search"},{"type":"checkbox","name":"TIN_SORT_YN","defaultValue":false,"label":"Unique ID Sort"}]}],"SYSTEM_NICKNAME":"Online Services Portal","PAYMENT_METHODS":[{"type":"bypass"},{"type":"iTransact"}],"PAYMENT_ALLOW_AMEX":true,"SYSTEM_ID_LABEL":"System Id","DOUBLE_COLUMN_PUBLIC_LOGIN":true,"INTERNAL_USER_MANAGEMENT":true,"ALLOW_PUBLIC_JSON_IMPORT":false,"MAX_FILE_UPLOAD_SIZE":10000000,"REFUND_TEXT":"","RETURN_TO_HOME_ON_LOGOUT":true,"CURRENT_SOS_NAME":"Christi Jacobsen","LOGO_FILENAME":"mt-sos-logo.png","LOGO_ALT":"Christi Jacobsen, Montana Secretary of State","LOGO_FULL_WIDTH":true,"HOME_HIDE_AUTH_HINT":true,"HOME_TITLE":"Montana Secretary of State","CUSTOM_TAB_TITLE":"Official Montana","HOME_SUBTITLE":"Online Business Services","ENTITY_NAME_CONSENT_DESCRIPTION":"","ALLOW_USER_PROFILE_EDITING":true,"COMPARE_FOREIGN_NAME_IN_ENTITY_NAME_VALIDATION":true,"FOREIGN_NAME_FIELD_NAME":"KIMA_PARENT_NAME_INFO","LOGIN_TITLE":"Montana Secretary of State Online Filing Portal Login","PUBLIC_LOGIN_LABEL":"Username","REVERSE_LOGIN_COLUMNS":true,"LOGIN_SEAL_FILENAME":"seal_white.png","SEPARATE_USERNAME_AND_EMAIL":true,"CREATE_ACCOUNT_BUTTON_ALIGN_LEFT":true,"CREATE_ACCOUNT_BUTTON_TEXT":"CREATE AN ACCOUNT","PASSWORD_CUSTOM_ERROR_TEXT":"The password must meet all requirements","ACCOUNT_CREATED_MESSAGE":"Please check your email to verify your account to login and allow a few minutes for this message to arrive. Check your junk/spam folders if you do not find the email in your inbox.","PUBLIC_LOGIN_PLACEHOLDER":" ","DISABLE_DEFAULT_PAYMENT_RADIO":true,"CUSTOM_RESET_PASSWORD_ERROR_MESSAGE":"Username invalid - no account found","PUBLIC_LOGIN_CREATE_DESCRIPTION":"### Existing User:\n\n  - Enter your username and password to login.  \n\n\n  #### - OR -  \n\n\n\n  - Forgot password? Click 'Reset Password' and follow the prompts.\n  - Forgot username? Click 'Forgot Username' and follow the prompts.  \n\n\n  ### New User:\n  ","LOGIN_HELP_LINK":"https://sosmt.gov/business/how-do-i/","LOGIN_HELP_LINK_TEXT":"Need Help?","FORGOT_USERNAME_TEXT":"Forgot Username?","LOGIN_ACTIVE_DIRECTORY_TEXT":"State User Login","MULTIPLE_LOGIN_METHODS":true,"HAS_ACTIVE_DIRECTORY_LOGIN":true,"RESET_PASSWORD_WITH_USERNAME":true,"DOWNLOAD_LINK":true,"SHOW_USERNAME_ACCOUNT_CREATE":true,"SHOW_SCROLL_DOWN_ARROW":true,"SHOW_ADDRESS_ACCOUNT_CREATE":true,"TWO_COLUMN_ACCOUNT_CREATE":true,"RESET_PASSWORD_TIP":"A link to change your password has been sent to your email. Please allow a few minutes for this message to arrive. Please check your junk/spam folders if you do not find the email in your inbox.","FORGOT_PASSWORD_LINK_TEXT":"Reset Password","PHONE_NUMBER_OPTIONAL_ACCOUNT_CREATE":true,"SHOW_REQUIRED_INDICATOR_ACCOUNT_CREATE":true,"PASSWORD_REQUIREMENTS_ACCOUNT_CREATE":"\n    <ul>\n      <li>MUST contain at least 8 characters (12+ recommended)</li>\n      <li>MUST contain at least one uppercase letter.</li>\n      <li>MUST contain at least one lowercase letter.</li>\n      <li>MUST contain at least one number.</li>\n      <li>MUST contain at least one special character (!”#$%&'()*+,-./:;<=>?</li>\n    </ul>\n  ","ALLOW_CERTIFICATION_REQUEST":true,"ALLOW_PUBLIC_CERTIFICATE_REQUEST":true,"ALLOW_COPY_REQUEST":false,"ALLOW_CORRECTION_STYLING":true,"HIDE_DEPRECATION_WARNING":false,"AMEND_ROUTE_PUBLIC":true,"SEAL_FILENAME":"seal.png","SHOPPING_CART":true,"ALLOW_PAYMENT_UPDATE_WITH_EMPTY_CART":true,"RA_EMAIL":true,"RA_WEBSITE":true,"RA_NO_DEFAULT_TYPE":true,"RA_ADDRESS_LABEL":"Street Address","RA_TYPE_SELECTION_DEFAULT":true,"RA_DEFAULT_TYPE":"460","RA_OVERRIDE_TYPE_WITH_DEFAULT":true,"RA_PRINCIPAL_ADDRESS_AMS":true,"UPLOAD_AND_SUBMIT_HIDE_IF_ONE_OPTION":true,"PAYMENT_PROCESSING_MESSAGE":"Your payment is processing - Do not close your browser or click the back button","CHECKOUT_BUTTON_WHEN_PROCESSING_TEXT":"Processing","EFS_CROP_PICKER_NONE_LABEL":"Lien Duration","DISALLOWED_WIZARD_PIECES":["FormationLocale"],"REPEATER_SHOW_EDIT_BUTTON":true,"DATA_REQUEST_PAGE_TITLE":"Data Requests and Subscriptions","DATA_REQUEST_SIDEBAR_LABEL":"Data Requests & Subscriptions","LOGIN_REDIRECTS_TO_EPASS":false,"LOGIN_REDIRECTS_TO_ACTIVE_DIRECTORY":true,"LOGIN_ACTIVE_DIRECTORY_LINK":true,"FETCH_EDIT_USER_LINK":false,"LISTS_FETCH_AVAILABLE_LISTS":true,"POST_WIZARD_SUBMIT_REDIRECT_URL":"/","PIN_REQUEST_ATTESTATIONS":true,"PIN_REQUEST_DESCRIPTION":"Click **Request PIN** to have a new PIN sent to the account holder's email address on file.","OWNERSHIP_REQUEST_DESCRIPTION":"To become an **authorized user** of this record, a current **AUTHORIZED USER** will need to grant you access. To request access, click **Request Access** below.","PIN_REQUEST_SUCCESS_MESSAGE":"The PIN you have requested for this entity has been sent to the email associated with your user account.  You should receive the PIN in approximately 3-5 minutes, depending on your email service provider.","APOSTILLE_HEADER_LABEL":"Verification Information","APOSTILLE_NUMBER_LABEL":"Apostille/Authentication","APOSTILLE_CITY_STATE_OVERRIDE":"HELENA, MT","APOSTILLE_FILING_DATE_LABEL":"Issue Date","APOSTILLE_CITY_STATE_IN_CERTIFIED":true,"NOTARY_EXISTING_FILING":true,"ALLOW_REVOKE_OWN_ACCESS_ONLY":false,"HIDE_CANCEL_ON_ONETIME_DATA_REQUESTS":true,"DATA_REQUESTS_IN_SHOPPING_CART":true,"WQ_ALLOW_EDIT_PENDING_PAYMENT":true,"WQ_CONFIRM_ON_DELETE":true,"WQ_DELETE_CONFIRM_MESSAGE":"Deleting this filing will forfeit any money already paid to the Secretary of State. This action is permanent and cannot be undone, are you sure you would like to delete?","PASS_ITEM_GUIDS_ON_CHECKOUT":true,"FORM_REVISION_HISTORY":true,"CHECKOUT_DISCLAIMER":"By entering your credit card and/or checking account information you (i) state that **you are an authorized user** of the credit card and/or electronic check and that the associated information entered (e.g., account holder name, account number, billing address) is accurate, (ii) **you authorize payment processor to charge the amount you have requested** to your credit card and/or funding account, and (iii) **acknowledge if a charge is declined or reversed you may also be assessed a customary charge** by the payment processor for such transactions.","FARM_BILL_SEARCH_CONFIDENTIAL":"As a registered Farm Bill Buyer with the Montana Secretary of State’s office it is important to maintain the confidentiality of the information contained within the Farm Bill Master List. The Farm Bill Master List reflects personal data, such as Social Security Numbers, which are a key piece of personal identifiable information to assist you in determining the existence of a lien against a specific debtor. The distribution of this information beyond its intended purpose is strictly prohibited.\n\n**The debtor's tax identification number has been hidden for confidentiality reasons. You may continue to search on a tax ID number and return debtors that match your search criteria. The SSN/FEIN must be entered without dashes or spaces.  If you need access to the tax identification number to clearly identify the debtor, please contact the UCC unit at (406) 444-3665.**","VIEW_HISTORY_BUTTON_ALT_TEXT":"View Filings","WIZARD_ERROR_TITLE_MESSAGE":"Form Error","FARM_BILL_SEARCH_INTERACTIVE":true,"USE_FARM_BILL_API":true,"DISALLOW_ASSIGN_SELF_AS_RA":true,"DISALLOW_ASSIGN_SELF_AS_PRINCIPAL":true,"USE_TRADEMARK_OWNER_VALIDATION":true,"USE_ALTERNATIVE_FOREIGN_ADDRESS_LABELS":true,"MY_RECEIPTS_FILTER":[{"type":"dateRange","name":"DATE_RANGE","label":"Date range","defaultValue":{"start":null,"end":null}},{"type":"text","name":"REF_NUM","defaultValue":"","label":"Reference Number"},{"type":"text","name":"RECEIPT_NUM","defaultValue":"","label":"Receipt Id"},{"type":"text","name":"AMOUNT","defaultValue":"","label":"Amount"},{"type":"select","name":"TYPE","defaultValue":"","label":"Payment Type","options":[{"value":"","label":"All"},{"value":"CC","label":"Credit Card"},{"value":"Check","label":"Check"}]}],"MY_RECEIPTS_SHOW_IN_SIDEBAR":true,"SHOW_MY_RECEIPTS_HELPER_TEXT":true,"MY_RECEIPTS_HELPER_LABEL":"About Receipt Search","MY_RECEIPTS_HELPER_TEXT":"You can search for receipts based on their descriptions, including the items paid for on the receipt. Use the filters to search for or filter specific information.","FARM_BILL_SUBLINK":{"label":"Farm Bill","component":"FarmBill","parameter":"farm-bill","path":"/lists/farm-bill","sourceTypeId":0,"myRecordsSearch":false,"allowedRules":["/search/"],"disabled":true,"searchDescription":"To perform a search, enter a debtor name. Your search results may include: exact debtor name, variations of that name and any filing that includes your search criteria. Punctuation is ignored.\n\nYou can click on \"Advanced\" to refine your search. Under “Advanced” you can search by crop, year, county and SSN/FEIN. As a registered Farm Bill Buyer with the Montana Secretary of State’s office it is important to maintain the confidentiality of the information contained within the Farm Bill Master List. The Farm Bill Master List reflects personal data, such as Social Security Numbers, which are a key piece of personal identifiable information to assist you in determining the existence of a lien against a specific debtor. The distribution of this information beyond its intended purpose is strictly prohibited.\n\nThe debtor's tax identification number has been hidden for confidentiality reasons. You may continue to search on a tax ID number and return debtors that match your search criteria. The SSN/FEIN must be entered without dashes or spaces.","searchMustHaveOneOf":["search","UCC_FARM_PRODUCT_ID","COUNTY"],"searchPlaceholder":"Search by debtor name","advancedSearchParameters":[{"type":"ServerMultiComplete","label":"Product code name(s)","name":"UCC_FARM_PRODUCT_ID","defaultValue":"","optionsSrc":"UCC_FARM_PRODUCT_V"},{"type":"MultiComplete","label":"Year or Range of Years","name":"YEAR_NUM","optionsSrc":"years","startYear":"1968","defaultValue":[],"preMergeOptions":[{"value":"ALL","label":"All"}]},{"type":"serverSelect","label":"State","name":"STATE","defaultValue":"MONTANA","optionsSrc":"STATE"},{"type":"ServerMultiComplete","label":"County","name":"COUNTY","defaultValue":[],"optionsSrc":"COUNTY","overrideSubOptionsSrcFromParameterName":"STATE"},{"type":"checkbox","name":"TIN_SEARCH_YN","defaultValue":false,"label":"Tax Identification Number Search"},{"type":"checkbox","name":"TIN_SORT_YN","defaultValue":false,"label":"Unique ID Sort"}]},"ALLOW_ADDRESS_VALIDATION_BYPASS_OPTION":true,"DEFAULT_ADDRESS_VALIDATION_BYPASS_OPTION_CHECKED":true}).ALLOW_REINSTATEMENT_AR_MODAL;
	
	var ALLOW_PUBLIC_CERTIFICATE_REQUEST = (true);
	var PIN_SWAP_ON_SUCCESS = ({"NODE_ENV":"production","BUILD_DATE":"2025-08-27T15:15:31.687Z","BUILD_NUMBER":"Not Provided","GIT_VERSION":"v1.3.0-381-ga81e29b08","GIT_COMMIT_HASH":"a81e29b085c9268ffd96c78eb734365802722741","GIT_BRANCH":"beta","PUBLIC_URL":"","STATE_ABBR":"MT","STATE_NAME":"Montana","STATE_ORG_TITLE":"Secretary of State","LOGIN_HEADER_IMG_PATH":"","HOME_IMG_FILENAME":"montana.jpg","FAVICON_FILE_NAME":"favicon.ico","ALLOW_E_SIGN_ON_CORRECTIONS":true,"THIRD_PARTY_SIGNING_ALLOWED":false,"MY_ACCOUNT_SAVE_AND_CLOSE_BUTTON":true,"IE_DEPRECATED_MESSAGE":"Internet Explorer is not supported. Please select a supported browser below to access this website.","ADDITIONAL_ROUTES":{"dataRequests":true,"farmBill":true,"apostille":true,"externalHelp":"https://sosmt.gov/business/help-center/","systemAdministration":[{"title":"Saved Payments","parameter":"saved-payments","componentName":"SavedPayments"}]},"SUBROUTES":[{"label":"Business","component":"Business","parameter":"business","myWorkQueueSearch":false,"sourceTypeId":54,"searchMustHaveOneOf":["FILING_TYPE_ID","STATUS_ID","STATE","search"],"serverWebSearchDescription":true,"serverWorkQueueDescription":true,"serverMyRecordsDescription":true,"searchPlaceholder":"Search by name or filing number (X########)","allowEmptySearchTerm":true,"requestCertificateAlternateLabel":"Request Information","fileAmendmentButtonLabel":"Filing Actions","advancedSearchParameters":[{"type":"radio","name":"QUERY_TYPE_ID","defaultValue":1010,"options":[{"value":1010,"label":"Starts with"},{"value":1011,"label":"Contains"},{"value":1012,"label":" Word Contains"}]},{"type":"serverSelect","name":"FILING_TYPE_ID","optionsSrc":"FILING_TYPES","label":"Entity Type","placeholder":"All","defaultValue":"0"},{"type":"serverSelect","name":"FILING_SUBTYPE_ID","optionsSrc":"FILING_SUBTYPES","label":"Entity Subtype","overrideSubOptionsSrcFromParameterName":"FILING_TYPE_ID","placeholder":"All","defaultValue":"0"},{"type":"serverSelect","name":"STATUS_ID","optionsSrc":"FILING_STATUS_WITHOUT_ALL","label":"Status","placeholder":"All","defaultValue":"0"},{"type":"serverSelect","name":"STATE","optionsSrc":"STATE","label":"State","placeholder":"All","defaultValue":""},{"type":"serverSelect","name":"COUNTY","optionsSrc":"COUNTY_SUBOPTION","label":"County","overrideSubOptionsSrcFromParameterName":"STATE","placeholder":"All","defaultValue":""},{"type":"checkbox","name":"CRA_SEARCH_YN","defaultValue":false,"label":"Search by Registered Agent PID"},{"type":"dateRange","name":"FILING_DATE","label":"Registration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}},{"type":"dateRange","name":"EXPIRATION_DATE","label":"Expiration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}}],"myRecordsFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Active"},{"value":2,"label":"Inactive"},{"value":3,"label":"Pending"}]},{"type":"dateRange","name":"DATE_RANGE","label":"Date range","defaultValue":{"start":null,"end":null}}],"myWorkQueueFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Approved"},{"value":2,"label":"Pending Online Payment"},{"value":3,"label":"Pending Review"},{"value":4,"label":"Needs Correction"},{"value":5,"label":"Rejected"},{"value":6,"label":"Draft"}]},{"type":"dateRange","name":"DATE_RANGE","label":"Date range","defaultValue":{"start":null,"end":null}}]},{"label":"Notary","component":"Notary","parameter":"notary","sourceTypeId":850,"myWorkQueueSearch":false,"allowEmptySearchTerm":true,"requestCertificateAlternateLabel":"Download Certificate","fileAmendmentButtonLabel":"Filing Actions","hideNameRequestCertificate":true,"hideAddressRequestCertificate":true,"hideRecordUserManagment":true,"searchPlaceholder":"Search by name or commission number","searchMustHaveOneOf":["CITY","search","SERVICE_TYPE"],"advancedParametersStartOpen":true,"searchIsSortable":true,"advancedSearchParameters":[{"type":"radio","name":"STARTS_WITH_YN","defaultValue":false,"options":[{"value":true,"label":"Starts with"},{"value":false,"label":"Contains"}]},{"type":"checkbox","name":"ACTIVE_ONLY_YN","defaultValue":true,"label":"Active entities only"},{"type":"text","name":"CITY","defaultValue":"","label":"City"},{"type":"select","name":"SERVICE_TYPE","label":"Special Services Offered","defaultValue":0,"options":[{"value":0,"label":"(N/A)"},{"value":6165,"label":"In-Person Electronic Notarization (IPEN)"},{"value":6166,"label":"Remote Online Notarization (RON)"},{"value":6167,"label":"Mobile Notary Services"},{"value":6168,"label":"Remote Ink Notarization (RIN)"}]}]},{"label":"Apostille","component":"Apostille","parameter":"apostille","sourceTypeId":720,"myRecordsSearch":false,"myWorkQueueSearch":false,"disabled":false,"allowedRoutes":["/forms-manager/","/queue/","/forms/"]},{"label":"Liens","component":"UCC","parameter":"ucc","sourceTypeId":1999,"myRecordsSearch":true,"myWorkQueueSearch":true,"fileAmendmentButtonLabel":"Filing Actions","searchPlaceholder":"Search by name or file number","disabled":false,"serverWebSearchDescription":true,"myRecordsDescription":"","workQueueDescription":"","searchDescription":"","hideRecordUserManagment":true,"searchLiensCheckout":false,"advancedSearchParameters":[{"type":"radio","name":"STARTS_WITH_YN","defaultValue":false,"options":[{"value":true,"label":"Starts with"},{"value":false,"label":"Contains"}]},{"type":"select","name":"STATUS","defaultValue":"ALL","label":"Status","options":[{"value":"ACTIVE_UNLAPSED","label":"Active (unlapsed)"},{"value":"ACTIVE_LAPSED_UNLAPSED","label":"Active (lapsed and unlapsed)"}]},{"type":"text","name":"EXCLUDE_VALUES","label":"Exclude Debtor Names (comma separated list of names to exclude)","defaultValue":""},{"type":"dateRange","name":"FILING_DATE","label":"Financing Statement Date","defaultValue":{"start":null,"end":null}},{"type":"dateRange","name":"LAPSE_DATE","label":"Lapse Date","defaultValue":{"start":null,"end":null}},{"type":"text","name":"CITY","label":"Debtor City","defaultValue":""}],"myRecordsFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Approved"},{"value":2,"label":"Pending Online Payment"},{"value":3,"label":"Pending Review"}]},{"type":"select","name":"TYPE","defaultValue":0,"label":"Lien Type","options":[{"value":0,"label":"All"},{"value":1,"label":"UCC"},{"value":2,"label":"EFS"},{"value":3,"label":"Title 71"}]}],"myWorkQueueFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Approved"},{"value":2,"label":"Pending Online Payment"},{"value":3,"label":"Pending Review"},{"value":4,"label":"Pending Print and Mail"},{"value":5,"label":"Rejected"},{"value":6,"label":"Draft"}]},{"type":"select","name":"TYPE","defaultValue":0,"label":"Lien Type","options":[{"value":0,"label":"All"},{"value":1,"label":"UCC"},{"value":2,"label":"EFS"},{"value":3,"label":"Title 71"}]}]},{"label":"Copy Request","component":"copies","parameter":"copies","sourceTypeId":2001,"myRecordsSearch":false,"myWorkQueueSearch":false,"disabled":false,"allowedRoutes":["/forms-manager/","/queue/","/forms/"]},{"label":"Trademark","component":"Trademark","parameter":"trademark","sourceTypeId":810,"showRequestCertificate":true,"searchMustHaveOneOf":["search","EXPIRATION_DATE","FILING_DATE"],"allowEmptySearchTerm":true,"requestCertificateAlternateLabel":"Request Information","fileAmendmentButtonLabel":"Filing Actions","advancedSearchParameters":[{"type":"radio","name":"QUERY_TYPE_ID","defaultValue":1010,"options":[{"value":1010,"label":"Starts with"},{"value":1011,"label":"Contains"},{"value":1012,"label":" Word Contains"}]},{"type":"checkbox","name":"OWNER_SEARCH_YN","defaultValue":false,"label":"Search owners"},{"type":"radio","name":"SERVICE_MARK_YN","label":"Mark Type","defaultValue":"","options":[{"value":"","label":"All Marks"},{"value":"Y","label":"Service Mark"},{"value":"N","label":"Trademark"}]},{"type":"serverSelect","name":"STATUS_ID","optionsSrc":"TYPE_V|TRADEMARK_STATUS_TYPE","label":"Status","placeholder":"All","defaultValue":"0"},{"type":"select","name":"DESIGN_TYPE_ID","options":[{"value":0,"label":"All"},{"value":990,"label":"Words Only"},{"value":991,"label":"Design Only"},{"value":992,"label":"Words and Design"}],"label":"Design Type","defaultValue":"0"},{"type":"dateRange","name":"FILING_DATE","label":"Registered Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}},{"type":"dateRange","name":"EXPIRATION_DATE","label":"Expiration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}}]},{"label":"Business Info Request","component":"InfoRequests","parameter":"info-request","sourceTypeId":167,"allowedRoutes":["/forms-manager/","/queue/","/forms/"]},{"label":"Data Requests","component":"DataRequests","parameter":"data-request","sourceTypeId":0,"allowedRoutes":["/forms-manager/"]},{"label":"CRA","component":"CRA","parameter":"cra","sourceTypeId":157,"myRecordsSearch":false,"searchPlaceholder":"Search by name or registered agent number","allowedRoutes":["/forms-manager/","/forms/","/records/","/queue/","/search/"],"allowEmptySearchTerm":true,"fileAmendmentButtonLabel":"Filing Actions","advancedSearchParameters":[{"type":"radio","name":"QUERY_TYPE_ID","defaultValue":1010,"options":[{"value":1010,"label":"Starts with"},{"value":1011,"label":"Contains"},{"value":1012,"label":" Word Contains"}]},{"type":"dateRange","name":"CRA_DATE","label":"Registration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}},{"type":"select","name":"STATUS_ID","label":"Status","defaultValue":0,"options":[{"value":0,"label":"All"},{"value":121,"label":"Active"},{"value":122,"label":"Inactive"}]},{"type":"select","name":"AGENT_TYPE_ID","label":"Agent Type","defaultValue":0,"options":[{"value":0,"label":"All"},{"value":460,"label":"Registered Agent"},{"value":461,"label":"Commercial Registered Agent"}]}]},{"label":"Farm Bill","component":"FarmBill","parameter":"farm-bill","path":"/lists/farm-bill","sourceTypeId":0,"myRecordsSearch":false,"allowedRules":["/search/"],"disabled":true,"searchDescription":"To perform a search, enter a debtor name. Your search results may include: exact debtor name, variations of that name and any filing that includes your search criteria. Punctuation is ignored.\n\nYou can click on \"Advanced\" to refine your search. Under “Advanced” you can search by crop, year, county and SSN/FEIN. As a registered Farm Bill Buyer with the Montana Secretary of State’s office it is important to maintain the confidentiality of the information contained within the Farm Bill Master List. The Farm Bill Master List reflects personal data, such as Social Security Numbers, which are a key piece of personal identifiable information to assist you in determining the existence of a lien against a specific debtor. The distribution of this information beyond its intended purpose is strictly prohibited.\n\nThe debtor's tax identification number has been hidden for confidentiality reasons. You may continue to search on a tax ID number and return debtors that match your search criteria. The SSN/FEIN must be entered without dashes or spaces.","searchMustHaveOneOf":["search","UCC_FARM_PRODUCT_ID","COUNTY"],"searchPlaceholder":"Search by debtor name","advancedSearchParameters":[{"type":"ServerMultiComplete","label":"Product code name(s)","name":"UCC_FARM_PRODUCT_ID","defaultValue":"","optionsSrc":"UCC_FARM_PRODUCT_V"},{"type":"MultiComplete","label":"Year or Range of Years","name":"YEAR_NUM","optionsSrc":"years","startYear":"1968","defaultValue":[],"preMergeOptions":[{"value":"ALL","label":"All"}]},{"type":"serverSelect","label":"State","name":"STATE","defaultValue":"MONTANA","optionsSrc":"STATE"},{"type":"ServerMultiComplete","label":"County","name":"COUNTY","defaultValue":[],"optionsSrc":"COUNTY","overrideSubOptionsSrcFromParameterName":"STATE"},{"type":"checkbox","name":"TIN_SEARCH_YN","defaultValue":false,"label":"Tax Identification Number Search"},{"type":"checkbox","name":"TIN_SORT_YN","defaultValue":false,"label":"Unique ID Sort"}]}],"SYSTEM_NICKNAME":"Online Services Portal","PAYMENT_METHODS":[{"type":"bypass"},{"type":"iTransact"}],"PAYMENT_ALLOW_AMEX":true,"SYSTEM_ID_LABEL":"System Id","DOUBLE_COLUMN_PUBLIC_LOGIN":true,"INTERNAL_USER_MANAGEMENT":true,"ALLOW_PUBLIC_JSON_IMPORT":false,"MAX_FILE_UPLOAD_SIZE":10000000,"REFUND_TEXT":"","RETURN_TO_HOME_ON_LOGOUT":true,"CURRENT_SOS_NAME":"Christi Jacobsen","LOGO_FILENAME":"mt-sos-logo.png","LOGO_ALT":"Christi Jacobsen, Montana Secretary of State","LOGO_FULL_WIDTH":true,"HOME_HIDE_AUTH_HINT":true,"HOME_TITLE":"Montana Secretary of State","CUSTOM_TAB_TITLE":"Official Montana","HOME_SUBTITLE":"Online Business Services","ENTITY_NAME_CONSENT_DESCRIPTION":"","ALLOW_USER_PROFILE_EDITING":true,"COMPARE_FOREIGN_NAME_IN_ENTITY_NAME_VALIDATION":true,"FOREIGN_NAME_FIELD_NAME":"KIMA_PARENT_NAME_INFO","LOGIN_TITLE":"Montana Secretary of State Online Filing Portal Login","PUBLIC_LOGIN_LABEL":"Username","REVERSE_LOGIN_COLUMNS":true,"LOGIN_SEAL_FILENAME":"seal_white.png","SEPARATE_USERNAME_AND_EMAIL":true,"CREATE_ACCOUNT_BUTTON_ALIGN_LEFT":true,"CREATE_ACCOUNT_BUTTON_TEXT":"CREATE AN ACCOUNT","PASSWORD_CUSTOM_ERROR_TEXT":"The password must meet all requirements","ACCOUNT_CREATED_MESSAGE":"Please check your email to verify your account to login and allow a few minutes for this message to arrive. Check your junk/spam folders if you do not find the email in your inbox.","PUBLIC_LOGIN_PLACEHOLDER":" ","DISABLE_DEFAULT_PAYMENT_RADIO":true,"CUSTOM_RESET_PASSWORD_ERROR_MESSAGE":"Username invalid - no account found","PUBLIC_LOGIN_CREATE_DESCRIPTION":"### Existing User:\n\n  - Enter your username and password to login.  \n\n\n  #### - OR -  \n\n\n\n  - Forgot password? Click 'Reset Password' and follow the prompts.\n  - Forgot username? Click 'Forgot Username' and follow the prompts.  \n\n\n  ### New User:\n  ","LOGIN_HELP_LINK":"https://sosmt.gov/business/how-do-i/","LOGIN_HELP_LINK_TEXT":"Need Help?","FORGOT_USERNAME_TEXT":"Forgot Username?","LOGIN_ACTIVE_DIRECTORY_TEXT":"State User Login","MULTIPLE_LOGIN_METHODS":true,"HAS_ACTIVE_DIRECTORY_LOGIN":true,"RESET_PASSWORD_WITH_USERNAME":true,"DOWNLOAD_LINK":true,"SHOW_USERNAME_ACCOUNT_CREATE":true,"SHOW_SCROLL_DOWN_ARROW":true,"SHOW_ADDRESS_ACCOUNT_CREATE":true,"TWO_COLUMN_ACCOUNT_CREATE":true,"RESET_PASSWORD_TIP":"A link to change your password has been sent to your email. Please allow a few minutes for this message to arrive. Please check your junk/spam folders if you do not find the email in your inbox.","FORGOT_PASSWORD_LINK_TEXT":"Reset Password","PHONE_NUMBER_OPTIONAL_ACCOUNT_CREATE":true,"SHOW_REQUIRED_INDICATOR_ACCOUNT_CREATE":true,"PASSWORD_REQUIREMENTS_ACCOUNT_CREATE":"\n    <ul>\n      <li>MUST contain at least 8 characters (12+ recommended)</li>\n      <li>MUST contain at least one uppercase letter.</li>\n      <li>MUST contain at least one lowercase letter.</li>\n      <li>MUST contain at least one number.</li>\n      <li>MUST contain at least one special character (!”#$%&'()*+,-./:;<=>?</li>\n    </ul>\n  ","ALLOW_CERTIFICATION_REQUEST":true,"ALLOW_PUBLIC_CERTIFICATE_REQUEST":true,"ALLOW_COPY_REQUEST":false,"ALLOW_CORRECTION_STYLING":true,"HIDE_DEPRECATION_WARNING":false,"AMEND_ROUTE_PUBLIC":true,"SEAL_FILENAME":"seal.png","SHOPPING_CART":true,"ALLOW_PAYMENT_UPDATE_WITH_EMPTY_CART":true,"RA_EMAIL":true,"RA_WEBSITE":true,"RA_NO_DEFAULT_TYPE":true,"RA_ADDRESS_LABEL":"Street Address","RA_TYPE_SELECTION_DEFAULT":true,"RA_DEFAULT_TYPE":"460","RA_OVERRIDE_TYPE_WITH_DEFAULT":true,"RA_PRINCIPAL_ADDRESS_AMS":true,"UPLOAD_AND_SUBMIT_HIDE_IF_ONE_OPTION":true,"PAYMENT_PROCESSING_MESSAGE":"Your payment is processing - Do not close your browser or click the back button","CHECKOUT_BUTTON_WHEN_PROCESSING_TEXT":"Processing","EFS_CROP_PICKER_NONE_LABEL":"Lien Duration","DISALLOWED_WIZARD_PIECES":["FormationLocale"],"REPEATER_SHOW_EDIT_BUTTON":true,"DATA_REQUEST_PAGE_TITLE":"Data Requests and Subscriptions","DATA_REQUEST_SIDEBAR_LABEL":"Data Requests & Subscriptions","LOGIN_REDIRECTS_TO_EPASS":false,"LOGIN_REDIRECTS_TO_ACTIVE_DIRECTORY":true,"LOGIN_ACTIVE_DIRECTORY_LINK":true,"FETCH_EDIT_USER_LINK":false,"LISTS_FETCH_AVAILABLE_LISTS":true,"POST_WIZARD_SUBMIT_REDIRECT_URL":"/","PIN_REQUEST_ATTESTATIONS":true,"PIN_REQUEST_DESCRIPTION":"Click **Request PIN** to have a new PIN sent to the account holder's email address on file.","OWNERSHIP_REQUEST_DESCRIPTION":"To become an **authorized user** of this record, a current **AUTHORIZED USER** will need to grant you access. To request access, click **Request Access** below.","PIN_REQUEST_SUCCESS_MESSAGE":"The PIN you have requested for this entity has been sent to the email associated with your user account.  You should receive the PIN in approximately 3-5 minutes, depending on your email service provider.","APOSTILLE_HEADER_LABEL":"Verification Information","APOSTILLE_NUMBER_LABEL":"Apostille/Authentication","APOSTILLE_CITY_STATE_OVERRIDE":"HELENA, MT","APOSTILLE_FILING_DATE_LABEL":"Issue Date","APOSTILLE_CITY_STATE_IN_CERTIFIED":true,"NOTARY_EXISTING_FILING":true,"ALLOW_REVOKE_OWN_ACCESS_ONLY":false,"HIDE_CANCEL_ON_ONETIME_DATA_REQUESTS":true,"DATA_REQUESTS_IN_SHOPPING_CART":true,"WQ_ALLOW_EDIT_PENDING_PAYMENT":true,"WQ_CONFIRM_ON_DELETE":true,"WQ_DELETE_CONFIRM_MESSAGE":"Deleting this filing will forfeit any money already paid to the Secretary of State. This action is permanent and cannot be undone, are you sure you would like to delete?","PASS_ITEM_GUIDS_ON_CHECKOUT":true,"FORM_REVISION_HISTORY":true,"CHECKOUT_DISCLAIMER":"By entering your credit card and/or checking account information you (i) state that **you are an authorized user** of the credit card and/or electronic check and that the associated information entered (e.g., account holder name, account number, billing address) is accurate, (ii) **you authorize payment processor to charge the amount you have requested** to your credit card and/or funding account, and (iii) **acknowledge if a charge is declined or reversed you may also be assessed a customary charge** by the payment processor for such transactions.","FARM_BILL_SEARCH_CONFIDENTIAL":"As a registered Farm Bill Buyer with the Montana Secretary of State’s office it is important to maintain the confidentiality of the information contained within the Farm Bill Master List. The Farm Bill Master List reflects personal data, such as Social Security Numbers, which are a key piece of personal identifiable information to assist you in determining the existence of a lien against a specific debtor. The distribution of this information beyond its intended purpose is strictly prohibited.\n\n**The debtor's tax identification number has been hidden for confidentiality reasons. You may continue to search on a tax ID number and return debtors that match your search criteria. The SSN/FEIN must be entered without dashes or spaces.  If you need access to the tax identification number to clearly identify the debtor, please contact the UCC unit at (406) 444-3665.**","VIEW_HISTORY_BUTTON_ALT_TEXT":"View Filings","WIZARD_ERROR_TITLE_MESSAGE":"Form Error","FARM_BILL_SEARCH_INTERACTIVE":true,"USE_FARM_BILL_API":true,"DISALLOW_ASSIGN_SELF_AS_RA":true,"DISALLOW_ASSIGN_SELF_AS_PRINCIPAL":true,"USE_TRADEMARK_OWNER_VALIDATION":true,"USE_ALTERNATIVE_FOREIGN_ADDRESS_LABELS":true,"MY_RECEIPTS_FILTER":[{"type":"dateRange","name":"DATE_RANGE","label":"Date range","defaultValue":{"start":null,"end":null}},{"type":"text","name":"REF_NUM","defaultValue":"","label":"Reference Number"},{"type":"text","name":"RECEIPT_NUM","defaultValue":"","label":"Receipt Id"},{"type":"text","name":"AMOUNT","defaultValue":"","label":"Amount"},{"type":"select","name":"TYPE","defaultValue":"","label":"Payment Type","options":[{"value":"","label":"All"},{"value":"CC","label":"Credit Card"},{"value":"Check","label":"Check"}]}],"MY_RECEIPTS_SHOW_IN_SIDEBAR":true,"SHOW_MY_RECEIPTS_HELPER_TEXT":true,"MY_RECEIPTS_HELPER_LABEL":"About Receipt Search","MY_RECEIPTS_HELPER_TEXT":"You can search for receipts based on their descriptions, including the items paid for on the receipt. Use the filters to search for or filter specific information.","FARM_BILL_SUBLINK":{"label":"Farm Bill","component":"FarmBill","parameter":"farm-bill","path":"/lists/farm-bill","sourceTypeId":0,"myRecordsSearch":false,"allowedRules":["/search/"],"disabled":true,"searchDescription":"To perform a search, enter a debtor name. Your search results may include: exact debtor name, variations of that name and any filing that includes your search criteria. Punctuation is ignored.\n\nYou can click on \"Advanced\" to refine your search. Under “Advanced” you can search by crop, year, county and SSN/FEIN. As a registered Farm Bill Buyer with the Montana Secretary of State’s office it is important to maintain the confidentiality of the information contained within the Farm Bill Master List. The Farm Bill Master List reflects personal data, such as Social Security Numbers, which are a key piece of personal identifiable information to assist you in determining the existence of a lien against a specific debtor. The distribution of this information beyond its intended purpose is strictly prohibited.\n\nThe debtor's tax identification number has been hidden for confidentiality reasons. You may continue to search on a tax ID number and return debtors that match your search criteria. The SSN/FEIN must be entered without dashes or spaces.","searchMustHaveOneOf":["search","UCC_FARM_PRODUCT_ID","COUNTY"],"searchPlaceholder":"Search by debtor name","advancedSearchParameters":[{"type":"ServerMultiComplete","label":"Product code name(s)","name":"UCC_FARM_PRODUCT_ID","defaultValue":"","optionsSrc":"UCC_FARM_PRODUCT_V"},{"type":"MultiComplete","label":"Year or Range of Years","name":"YEAR_NUM","optionsSrc":"years","startYear":"1968","defaultValue":[],"preMergeOptions":[{"value":"ALL","label":"All"}]},{"type":"serverSelect","label":"State","name":"STATE","defaultValue":"MONTANA","optionsSrc":"STATE"},{"type":"ServerMultiComplete","label":"County","name":"COUNTY","defaultValue":[],"optionsSrc":"COUNTY","overrideSubOptionsSrcFromParameterName":"STATE"},{"type":"checkbox","name":"TIN_SEARCH_YN","defaultValue":false,"label":"Tax Identification Number Search"},{"type":"checkbox","name":"TIN_SORT_YN","defaultValue":false,"label":"Unique ID Sort"}]},"ALLOW_ADDRESS_VALIDATION_BYPASS_OPTION":true,"DEFAULT_ADDRESS_VALIDATION_BYPASS_OPTION_CHECKED":true}).PIN_SWAP_ON_SUCCESS !== undefined ? ({"NODE_ENV":"production","BUILD_DATE":"2025-08-27T15:15:31.687Z","BUILD_NUMBER":"Not Provided","GIT_VERSION":"v1.3.0-381-ga81e29b08","GIT_COMMIT_HASH":"a81e29b085c9268ffd96c78eb734365802722741","GIT_BRANCH":"beta","PUBLIC_URL":"","STATE_ABBR":"MT","STATE_NAME":"Montana","STATE_ORG_TITLE":"Secretary of State","LOGIN_HEADER_IMG_PATH":"","HOME_IMG_FILENAME":"montana.jpg","FAVICON_FILE_NAME":"favicon.ico","ALLOW_E_SIGN_ON_CORRECTIONS":true,"THIRD_PARTY_SIGNING_ALLOWED":false,"MY_ACCOUNT_SAVE_AND_CLOSE_BUTTON":true,"IE_DEPRECATED_MESSAGE":"Internet Explorer is not supported. Please select a supported browser below to access this website.","ADDITIONAL_ROUTES":{"dataRequests":true,"farmBill":true,"apostille":true,"externalHelp":"https://sosmt.gov/business/help-center/","systemAdministration":[{"title":"Saved Payments","parameter":"saved-payments","componentName":"SavedPayments"}]},"SUBROUTES":[{"label":"Business","component":"Business","parameter":"business","myWorkQueueSearch":false,"sourceTypeId":54,"searchMustHaveOneOf":["FILING_TYPE_ID","STATUS_ID","STATE","search"],"serverWebSearchDescription":true,"serverWorkQueueDescription":true,"serverMyRecordsDescription":true,"searchPlaceholder":"Search by name or filing number (X########)","allowEmptySearchTerm":true,"requestCertificateAlternateLabel":"Request Information","fileAmendmentButtonLabel":"Filing Actions","advancedSearchParameters":[{"type":"radio","name":"QUERY_TYPE_ID","defaultValue":1010,"options":[{"value":1010,"label":"Starts with"},{"value":1011,"label":"Contains"},{"value":1012,"label":" Word Contains"}]},{"type":"serverSelect","name":"FILING_TYPE_ID","optionsSrc":"FILING_TYPES","label":"Entity Type","placeholder":"All","defaultValue":"0"},{"type":"serverSelect","name":"FILING_SUBTYPE_ID","optionsSrc":"FILING_SUBTYPES","label":"Entity Subtype","overrideSubOptionsSrcFromParameterName":"FILING_TYPE_ID","placeholder":"All","defaultValue":"0"},{"type":"serverSelect","name":"STATUS_ID","optionsSrc":"FILING_STATUS_WITHOUT_ALL","label":"Status","placeholder":"All","defaultValue":"0"},{"type":"serverSelect","name":"STATE","optionsSrc":"STATE","label":"State","placeholder":"All","defaultValue":""},{"type":"serverSelect","name":"COUNTY","optionsSrc":"COUNTY_SUBOPTION","label":"County","overrideSubOptionsSrcFromParameterName":"STATE","placeholder":"All","defaultValue":""},{"type":"checkbox","name":"CRA_SEARCH_YN","defaultValue":false,"label":"Search by Registered Agent PID"},{"type":"dateRange","name":"FILING_DATE","label":"Registration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}},{"type":"dateRange","name":"EXPIRATION_DATE","label":"Expiration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}}],"myRecordsFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Active"},{"value":2,"label":"Inactive"},{"value":3,"label":"Pending"}]},{"type":"dateRange","name":"DATE_RANGE","label":"Date range","defaultValue":{"start":null,"end":null}}],"myWorkQueueFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Approved"},{"value":2,"label":"Pending Online Payment"},{"value":3,"label":"Pending Review"},{"value":4,"label":"Needs Correction"},{"value":5,"label":"Rejected"},{"value":6,"label":"Draft"}]},{"type":"dateRange","name":"DATE_RANGE","label":"Date range","defaultValue":{"start":null,"end":null}}]},{"label":"Notary","component":"Notary","parameter":"notary","sourceTypeId":850,"myWorkQueueSearch":false,"allowEmptySearchTerm":true,"requestCertificateAlternateLabel":"Download Certificate","fileAmendmentButtonLabel":"Filing Actions","hideNameRequestCertificate":true,"hideAddressRequestCertificate":true,"hideRecordUserManagment":true,"searchPlaceholder":"Search by name or commission number","searchMustHaveOneOf":["CITY","search","SERVICE_TYPE"],"advancedParametersStartOpen":true,"searchIsSortable":true,"advancedSearchParameters":[{"type":"radio","name":"STARTS_WITH_YN","defaultValue":false,"options":[{"value":true,"label":"Starts with"},{"value":false,"label":"Contains"}]},{"type":"checkbox","name":"ACTIVE_ONLY_YN","defaultValue":true,"label":"Active entities only"},{"type":"text","name":"CITY","defaultValue":"","label":"City"},{"type":"select","name":"SERVICE_TYPE","label":"Special Services Offered","defaultValue":0,"options":[{"value":0,"label":"(N/A)"},{"value":6165,"label":"In-Person Electronic Notarization (IPEN)"},{"value":6166,"label":"Remote Online Notarization (RON)"},{"value":6167,"label":"Mobile Notary Services"},{"value":6168,"label":"Remote Ink Notarization (RIN)"}]}]},{"label":"Apostille","component":"Apostille","parameter":"apostille","sourceTypeId":720,"myRecordsSearch":false,"myWorkQueueSearch":false,"disabled":false,"allowedRoutes":["/forms-manager/","/queue/","/forms/"]},{"label":"Liens","component":"UCC","parameter":"ucc","sourceTypeId":1999,"myRecordsSearch":true,"myWorkQueueSearch":true,"fileAmendmentButtonLabel":"Filing Actions","searchPlaceholder":"Search by name or file number","disabled":false,"serverWebSearchDescription":true,"myRecordsDescription":"","workQueueDescription":"","searchDescription":"","hideRecordUserManagment":true,"searchLiensCheckout":false,"advancedSearchParameters":[{"type":"radio","name":"STARTS_WITH_YN","defaultValue":false,"options":[{"value":true,"label":"Starts with"},{"value":false,"label":"Contains"}]},{"type":"select","name":"STATUS","defaultValue":"ALL","label":"Status","options":[{"value":"ACTIVE_UNLAPSED","label":"Active (unlapsed)"},{"value":"ACTIVE_LAPSED_UNLAPSED","label":"Active (lapsed and unlapsed)"}]},{"type":"text","name":"EXCLUDE_VALUES","label":"Exclude Debtor Names (comma separated list of names to exclude)","defaultValue":""},{"type":"dateRange","name":"FILING_DATE","label":"Financing Statement Date","defaultValue":{"start":null,"end":null}},{"type":"dateRange","name":"LAPSE_DATE","label":"Lapse Date","defaultValue":{"start":null,"end":null}},{"type":"text","name":"CITY","label":"Debtor City","defaultValue":""}],"myRecordsFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Approved"},{"value":2,"label":"Pending Online Payment"},{"value":3,"label":"Pending Review"}]},{"type":"select","name":"TYPE","defaultValue":0,"label":"Lien Type","options":[{"value":0,"label":"All"},{"value":1,"label":"UCC"},{"value":2,"label":"EFS"},{"value":3,"label":"Title 71"}]}],"myWorkQueueFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Approved"},{"value":2,"label":"Pending Online Payment"},{"value":3,"label":"Pending Review"},{"value":4,"label":"Pending Print and Mail"},{"value":5,"label":"Rejected"},{"value":6,"label":"Draft"}]},{"type":"select","name":"TYPE","defaultValue":0,"label":"Lien Type","options":[{"value":0,"label":"All"},{"value":1,"label":"UCC"},{"value":2,"label":"EFS"},{"value":3,"label":"Title 71"}]}]},{"label":"Copy Request","component":"copies","parameter":"copies","sourceTypeId":2001,"myRecordsSearch":false,"myWorkQueueSearch":false,"disabled":false,"allowedRoutes":["/forms-manager/","/queue/","/forms/"]},{"label":"Trademark","component":"Trademark","parameter":"trademark","sourceTypeId":810,"showRequestCertificate":true,"searchMustHaveOneOf":["search","EXPIRATION_DATE","FILING_DATE"],"allowEmptySearchTerm":true,"requestCertificateAlternateLabel":"Request Information","fileAmendmentButtonLabel":"Filing Actions","advancedSearchParameters":[{"type":"radio","name":"QUERY_TYPE_ID","defaultValue":1010,"options":[{"value":1010,"label":"Starts with"},{"value":1011,"label":"Contains"},{"value":1012,"label":" Word Contains"}]},{"type":"checkbox","name":"OWNER_SEARCH_YN","defaultValue":false,"label":"Search owners"},{"type":"radio","name":"SERVICE_MARK_YN","label":"Mark Type","defaultValue":"","options":[{"value":"","label":"All Marks"},{"value":"Y","label":"Service Mark"},{"value":"N","label":"Trademark"}]},{"type":"serverSelect","name":"STATUS_ID","optionsSrc":"TYPE_V|TRADEMARK_STATUS_TYPE","label":"Status","placeholder":"All","defaultValue":"0"},{"type":"select","name":"DESIGN_TYPE_ID","options":[{"value":0,"label":"All"},{"value":990,"label":"Words Only"},{"value":991,"label":"Design Only"},{"value":992,"label":"Words and Design"}],"label":"Design Type","defaultValue":"0"},{"type":"dateRange","name":"FILING_DATE","label":"Registered Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}},{"type":"dateRange","name":"EXPIRATION_DATE","label":"Expiration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}}]},{"label":"Business Info Request","component":"InfoRequests","parameter":"info-request","sourceTypeId":167,"allowedRoutes":["/forms-manager/","/queue/","/forms/"]},{"label":"Data Requests","component":"DataRequests","parameter":"data-request","sourceTypeId":0,"allowedRoutes":["/forms-manager/"]},{"label":"CRA","component":"CRA","parameter":"cra","sourceTypeId":157,"myRecordsSearch":false,"searchPlaceholder":"Search by name or registered agent number","allowedRoutes":["/forms-manager/","/forms/","/records/","/queue/","/search/"],"allowEmptySearchTerm":true,"fileAmendmentButtonLabel":"Filing Actions","advancedSearchParameters":[{"type":"radio","name":"QUERY_TYPE_ID","defaultValue":1010,"options":[{"value":1010,"label":"Starts with"},{"value":1011,"label":"Contains"},{"value":1012,"label":" Word Contains"}]},{"type":"dateRange","name":"CRA_DATE","label":"Registration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}},{"type":"select","name":"STATUS_ID","label":"Status","defaultValue":0,"options":[{"value":0,"label":"All"},{"value":121,"label":"Active"},{"value":122,"label":"Inactive"}]},{"type":"select","name":"AGENT_TYPE_ID","label":"Agent Type","defaultValue":0,"options":[{"value":0,"label":"All"},{"value":460,"label":"Registered Agent"},{"value":461,"label":"Commercial Registered Agent"}]}]},{"label":"Farm Bill","component":"FarmBill","parameter":"farm-bill","path":"/lists/farm-bill","sourceTypeId":0,"myRecordsSearch":false,"allowedRules":["/search/"],"disabled":true,"searchDescription":"To perform a search, enter a debtor name. Your search results may include: exact debtor name, variations of that name and any filing that includes your search criteria. Punctuation is ignored.\n\nYou can click on \"Advanced\" to refine your search. Under “Advanced” you can search by crop, year, county and SSN/FEIN. As a registered Farm Bill Buyer with the Montana Secretary of State’s office it is important to maintain the confidentiality of the information contained within the Farm Bill Master List. The Farm Bill Master List reflects personal data, such as Social Security Numbers, which are a key piece of personal identifiable information to assist you in determining the existence of a lien against a specific debtor. The distribution of this information beyond its intended purpose is strictly prohibited.\n\nThe debtor's tax identification number has been hidden for confidentiality reasons. You may continue to search on a tax ID number and return debtors that match your search criteria. The SSN/FEIN must be entered without dashes or spaces.","searchMustHaveOneOf":["search","UCC_FARM_PRODUCT_ID","COUNTY"],"searchPlaceholder":"Search by debtor name","advancedSearchParameters":[{"type":"ServerMultiComplete","label":"Product code name(s)","name":"UCC_FARM_PRODUCT_ID","defaultValue":"","optionsSrc":"UCC_FARM_PRODUCT_V"},{"type":"MultiComplete","label":"Year or Range of Years","name":"YEAR_NUM","optionsSrc":"years","startYear":"1968","defaultValue":[],"preMergeOptions":[{"value":"ALL","label":"All"}]},{"type":"serverSelect","label":"State","name":"STATE","defaultValue":"MONTANA","optionsSrc":"STATE"},{"type":"ServerMultiComplete","label":"County","name":"COUNTY","defaultValue":[],"optionsSrc":"COUNTY","overrideSubOptionsSrcFromParameterName":"STATE"},{"type":"checkbox","name":"TIN_SEARCH_YN","defaultValue":false,"label":"Tax Identification Number Search"},{"type":"checkbox","name":"TIN_SORT_YN","defaultValue":false,"label":"Unique ID Sort"}]}],"SYSTEM_NICKNAME":"Online Services Portal","PAYMENT_METHODS":[{"type":"bypass"},{"type":"iTransact"}],"PAYMENT_ALLOW_AMEX":true,"SYSTEM_ID_LABEL":"System Id","DOUBLE_COLUMN_PUBLIC_LOGIN":true,"INTERNAL_USER_MANAGEMENT":true,"ALLOW_PUBLIC_JSON_IMPORT":false,"MAX_FILE_UPLOAD_SIZE":10000000,"REFUND_TEXT":"","RETURN_TO_HOME_ON_LOGOUT":true,"CURRENT_SOS_NAME":"Christi Jacobsen","LOGO_FILENAME":"mt-sos-logo.png","LOGO_ALT":"Christi Jacobsen, Montana Secretary of State","LOGO_FULL_WIDTH":true,"HOME_HIDE_AUTH_HINT":true,"HOME_TITLE":"Montana Secretary of State","CUSTOM_TAB_TITLE":"Official Montana","HOME_SUBTITLE":"Online Business Services","ENTITY_NAME_CONSENT_DESCRIPTION":"","ALLOW_USER_PROFILE_EDITING":true,"COMPARE_FOREIGN_NAME_IN_ENTITY_NAME_VALIDATION":true,"FOREIGN_NAME_FIELD_NAME":"KIMA_PARENT_NAME_INFO","LOGIN_TITLE":"Montana Secretary of State Online Filing Portal Login","PUBLIC_LOGIN_LABEL":"Username","REVERSE_LOGIN_COLUMNS":true,"LOGIN_SEAL_FILENAME":"seal_white.png","SEPARATE_USERNAME_AND_EMAIL":true,"CREATE_ACCOUNT_BUTTON_ALIGN_LEFT":true,"CREATE_ACCOUNT_BUTTON_TEXT":"CREATE AN ACCOUNT","PASSWORD_CUSTOM_ERROR_TEXT":"The password must meet all requirements","ACCOUNT_CREATED_MESSAGE":"Please check your email to verify your account to login and allow a few minutes for this message to arrive. Check your junk/spam folders if you do not find the email in your inbox.","PUBLIC_LOGIN_PLACEHOLDER":" ","DISABLE_DEFAULT_PAYMENT_RADIO":true,"CUSTOM_RESET_PASSWORD_ERROR_MESSAGE":"Username invalid - no account found","PUBLIC_LOGIN_CREATE_DESCRIPTION":"### Existing User:\n\n  - Enter your username and password to login.  \n\n\n  #### - OR -  \n\n\n\n  - Forgot password? Click 'Reset Password' and follow the prompts.\n  - Forgot username? Click 'Forgot Username' and follow the prompts.  \n\n\n  ### New User:\n  ","LOGIN_HELP_LINK":"https://sosmt.gov/business/how-do-i/","LOGIN_HELP_LINK_TEXT":"Need Help?","FORGOT_USERNAME_TEXT":"Forgot Username?","LOGIN_ACTIVE_DIRECTORY_TEXT":"State User Login","MULTIPLE_LOGIN_METHODS":true,"HAS_ACTIVE_DIRECTORY_LOGIN":true,"RESET_PASSWORD_WITH_USERNAME":true,"DOWNLOAD_LINK":true,"SHOW_USERNAME_ACCOUNT_CREATE":true,"SHOW_SCROLL_DOWN_ARROW":true,"SHOW_ADDRESS_ACCOUNT_CREATE":true,"TWO_COLUMN_ACCOUNT_CREATE":true,"RESET_PASSWORD_TIP":"A link to change your password has been sent to your email. Please allow a few minutes for this message to arrive. Please check your junk/spam folders if you do not find the email in your inbox.","FORGOT_PASSWORD_LINK_TEXT":"Reset Password","PHONE_NUMBER_OPTIONAL_ACCOUNT_CREATE":true,"SHOW_REQUIRED_INDICATOR_ACCOUNT_CREATE":true,"PASSWORD_REQUIREMENTS_ACCOUNT_CREATE":"\n    <ul>\n      <li>MUST contain at least 8 characters (12+ recommended)</li>\n      <li>MUST contain at least one uppercase letter.</li>\n      <li>MUST contain at least one lowercase letter.</li>\n      <li>MUST contain at least one number.</li>\n      <li>MUST contain at least one special character (!”#$%&'()*+,-./:;<=>?</li>\n    </ul>\n  ","ALLOW_CERTIFICATION_REQUEST":true,"ALLOW_PUBLIC_CERTIFICATE_REQUEST":true,"ALLOW_COPY_REQUEST":false,"ALLOW_CORRECTION_STYLING":true,"HIDE_DEPRECATION_WARNING":false,"AMEND_ROUTE_PUBLIC":true,"SEAL_FILENAME":"seal.png","SHOPPING_CART":true,"ALLOW_PAYMENT_UPDATE_WITH_EMPTY_CART":true,"RA_EMAIL":true,"RA_WEBSITE":true,"RA_NO_DEFAULT_TYPE":true,"RA_ADDRESS_LABEL":"Street Address","RA_TYPE_SELECTION_DEFAULT":true,"RA_DEFAULT_TYPE":"460","RA_OVERRIDE_TYPE_WITH_DEFAULT":true,"RA_PRINCIPAL_ADDRESS_AMS":true,"UPLOAD_AND_SUBMIT_HIDE_IF_ONE_OPTION":true,"PAYMENT_PROCESSING_MESSAGE":"Your payment is processing - Do not close your browser or click the back button","CHECKOUT_BUTTON_WHEN_PROCESSING_TEXT":"Processing","EFS_CROP_PICKER_NONE_LABEL":"Lien Duration","DISALLOWED_WIZARD_PIECES":["FormationLocale"],"REPEATER_SHOW_EDIT_BUTTON":true,"DATA_REQUEST_PAGE_TITLE":"Data Requests and Subscriptions","DATA_REQUEST_SIDEBAR_LABEL":"Data Requests & Subscriptions","LOGIN_REDIRECTS_TO_EPASS":false,"LOGIN_REDIRECTS_TO_ACTIVE_DIRECTORY":true,"LOGIN_ACTIVE_DIRECTORY_LINK":true,"FETCH_EDIT_USER_LINK":false,"LISTS_FETCH_AVAILABLE_LISTS":true,"POST_WIZARD_SUBMIT_REDIRECT_URL":"/","PIN_REQUEST_ATTESTATIONS":true,"PIN_REQUEST_DESCRIPTION":"Click **Request PIN** to have a new PIN sent to the account holder's email address on file.","OWNERSHIP_REQUEST_DESCRIPTION":"To become an **authorized user** of this record, a current **AUTHORIZED USER** will need to grant you access. To request access, click **Request Access** below.","PIN_REQUEST_SUCCESS_MESSAGE":"The PIN you have requested for this entity has been sent to the email associated with your user account.  You should receive the PIN in approximately 3-5 minutes, depending on your email service provider.","APOSTILLE_HEADER_LABEL":"Verification Information","APOSTILLE_NUMBER_LABEL":"Apostille/Authentication","APOSTILLE_CITY_STATE_OVERRIDE":"HELENA, MT","APOSTILLE_FILING_DATE_LABEL":"Issue Date","APOSTILLE_CITY_STATE_IN_CERTIFIED":true,"NOTARY_EXISTING_FILING":true,"ALLOW_REVOKE_OWN_ACCESS_ONLY":false,"HIDE_CANCEL_ON_ONETIME_DATA_REQUESTS":true,"DATA_REQUESTS_IN_SHOPPING_CART":true,"WQ_ALLOW_EDIT_PENDING_PAYMENT":true,"WQ_CONFIRM_ON_DELETE":true,"WQ_DELETE_CONFIRM_MESSAGE":"Deleting this filing will forfeit any money already paid to the Secretary of State. This action is permanent and cannot be undone, are you sure you would like to delete?","PASS_ITEM_GUIDS_ON_CHECKOUT":true,"FORM_REVISION_HISTORY":true,"CHECKOUT_DISCLAIMER":"By entering your credit card and/or checking account information you (i) state that **you are an authorized user** of the credit card and/or electronic check and that the associated information entered (e.g., account holder name, account number, billing address) is accurate, (ii) **you authorize payment processor to charge the amount you have requested** to your credit card and/or funding account, and (iii) **acknowledge if a charge is declined or reversed you may also be assessed a customary charge** by the payment processor for such transactions.","FARM_BILL_SEARCH_CONFIDENTIAL":"As a registered Farm Bill Buyer with the Montana Secretary of State’s office it is important to maintain the confidentiality of the information contained within the Farm Bill Master List. The Farm Bill Master List reflects personal data, such as Social Security Numbers, which are a key piece of personal identifiable information to assist you in determining the existence of a lien against a specific debtor. The distribution of this information beyond its intended purpose is strictly prohibited.\n\n**The debtor's tax identification number has been hidden for confidentiality reasons. You may continue to search on a tax ID number and return debtors that match your search criteria. The SSN/FEIN must be entered without dashes or spaces.  If you need access to the tax identification number to clearly identify the debtor, please contact the UCC unit at (406) 444-3665.**","VIEW_HISTORY_BUTTON_ALT_TEXT":"View Filings","WIZARD_ERROR_TITLE_MESSAGE":"Form Error","FARM_BILL_SEARCH_INTERACTIVE":true,"USE_FARM_BILL_API":true,"DISALLOW_ASSIGN_SELF_AS_RA":true,"DISALLOW_ASSIGN_SELF_AS_PRINCIPAL":true,"USE_TRADEMARK_OWNER_VALIDATION":true,"USE_ALTERNATIVE_FOREIGN_ADDRESS_LABELS":true,"MY_RECEIPTS_FILTER":[{"type":"dateRange","name":"DATE_RANGE","label":"Date range","defaultValue":{"start":null,"end":null}},{"type":"text","name":"REF_NUM","defaultValue":"","label":"Reference Number"},{"type":"text","name":"RECEIPT_NUM","defaultValue":"","label":"Receipt Id"},{"type":"text","name":"AMOUNT","defaultValue":"","label":"Amount"},{"type":"select","name":"TYPE","defaultValue":"","label":"Payment Type","options":[{"value":"","label":"All"},{"value":"CC","label":"Credit Card"},{"value":"Check","label":"Check"}]}],"MY_RECEIPTS_SHOW_IN_SIDEBAR":true,"SHOW_MY_RECEIPTS_HELPER_TEXT":true,"MY_RECEIPTS_HELPER_LABEL":"About Receipt Search","MY_RECEIPTS_HELPER_TEXT":"You can search for receipts based on their descriptions, including the items paid for on the receipt. Use the filters to search for or filter specific information.","FARM_BILL_SUBLINK":{"label":"Farm Bill","component":"FarmBill","parameter":"farm-bill","path":"/lists/farm-bill","sourceTypeId":0,"myRecordsSearch":false,"allowedRules":["/search/"],"disabled":true,"searchDescription":"To perform a search, enter a debtor name. Your search results may include: exact debtor name, variations of that name and any filing that includes your search criteria. Punctuation is ignored.\n\nYou can click on \"Advanced\" to refine your search. Under “Advanced” you can search by crop, year, county and SSN/FEIN. As a registered Farm Bill Buyer with the Montana Secretary of State’s office it is important to maintain the confidentiality of the information contained within the Farm Bill Master List. The Farm Bill Master List reflects personal data, such as Social Security Numbers, which are a key piece of personal identifiable information to assist you in determining the existence of a lien against a specific debtor. The distribution of this information beyond its intended purpose is strictly prohibited.\n\nThe debtor's tax identification number has been hidden for confidentiality reasons. You may continue to search on a tax ID number and return debtors that match your search criteria. The SSN/FEIN must be entered without dashes or spaces.","searchMustHaveOneOf":["search","UCC_FARM_PRODUCT_ID","COUNTY"],"searchPlaceholder":"Search by debtor name","advancedSearchParameters":[{"type":"ServerMultiComplete","label":"Product code name(s)","name":"UCC_FARM_PRODUCT_ID","defaultValue":"","optionsSrc":"UCC_FARM_PRODUCT_V"},{"type":"MultiComplete","label":"Year or Range of Years","name":"YEAR_NUM","optionsSrc":"years","startYear":"1968","defaultValue":[],"preMergeOptions":[{"value":"ALL","label":"All"}]},{"type":"serverSelect","label":"State","name":"STATE","defaultValue":"MONTANA","optionsSrc":"STATE"},{"type":"ServerMultiComplete","label":"County","name":"COUNTY","defaultValue":[],"optionsSrc":"COUNTY","overrideSubOptionsSrcFromParameterName":"STATE"},{"type":"checkbox","name":"TIN_SEARCH_YN","defaultValue":false,"label":"Tax Identification Number Search"},{"type":"checkbox","name":"TIN_SORT_YN","defaultValue":false,"label":"Unique ID Sort"}]},"ALLOW_ADDRESS_VALIDATION_BYPASS_OPTION":true,"DEFAULT_ADDRESS_VALIDATION_BYPASS_OPTION_CHECKED":true}).PIN_SWAP_ON_SUCCESS : true;
	var RD_TOOLTIP_AMENDMENT = ({"NODE_ENV":"production","BUILD_DATE":"2025-08-27T15:15:31.687Z","BUILD_NUMBER":"Not Provided","GIT_VERSION":"v1.3.0-381-ga81e29b08","GIT_COMMIT_HASH":"a81e29b085c9268ffd96c78eb734365802722741","GIT_BRANCH":"beta","PUBLIC_URL":"","STATE_ABBR":"MT","STATE_NAME":"Montana","STATE_ORG_TITLE":"Secretary of State","LOGIN_HEADER_IMG_PATH":"","HOME_IMG_FILENAME":"montana.jpg","FAVICON_FILE_NAME":"favicon.ico","ALLOW_E_SIGN_ON_CORRECTIONS":true,"THIRD_PARTY_SIGNING_ALLOWED":false,"MY_ACCOUNT_SAVE_AND_CLOSE_BUTTON":true,"IE_DEPRECATED_MESSAGE":"Internet Explorer is not supported. Please select a supported browser below to access this website.","ADDITIONAL_ROUTES":{"dataRequests":true,"farmBill":true,"apostille":true,"externalHelp":"https://sosmt.gov/business/help-center/","systemAdministration":[{"title":"Saved Payments","parameter":"saved-payments","componentName":"SavedPayments"}]},"SUBROUTES":[{"label":"Business","component":"Business","parameter":"business","myWorkQueueSearch":false,"sourceTypeId":54,"searchMustHaveOneOf":["FILING_TYPE_ID","STATUS_ID","STATE","search"],"serverWebSearchDescription":true,"serverWorkQueueDescription":true,"serverMyRecordsDescription":true,"searchPlaceholder":"Search by name or filing number (X########)","allowEmptySearchTerm":true,"requestCertificateAlternateLabel":"Request Information","fileAmendmentButtonLabel":"Filing Actions","advancedSearchParameters":[{"type":"radio","name":"QUERY_TYPE_ID","defaultValue":1010,"options":[{"value":1010,"label":"Starts with"},{"value":1011,"label":"Contains"},{"value":1012,"label":" Word Contains"}]},{"type":"serverSelect","name":"FILING_TYPE_ID","optionsSrc":"FILING_TYPES","label":"Entity Type","placeholder":"All","defaultValue":"0"},{"type":"serverSelect","name":"FILING_SUBTYPE_ID","optionsSrc":"FILING_SUBTYPES","label":"Entity Subtype","overrideSubOptionsSrcFromParameterName":"FILING_TYPE_ID","placeholder":"All","defaultValue":"0"},{"type":"serverSelect","name":"STATUS_ID","optionsSrc":"FILING_STATUS_WITHOUT_ALL","label":"Status","placeholder":"All","defaultValue":"0"},{"type":"serverSelect","name":"STATE","optionsSrc":"STATE","label":"State","placeholder":"All","defaultValue":""},{"type":"serverSelect","name":"COUNTY","optionsSrc":"COUNTY_SUBOPTION","label":"County","overrideSubOptionsSrcFromParameterName":"STATE","placeholder":"All","defaultValue":""},{"type":"checkbox","name":"CRA_SEARCH_YN","defaultValue":false,"label":"Search by Registered Agent PID"},{"type":"dateRange","name":"FILING_DATE","label":"Registration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}},{"type":"dateRange","name":"EXPIRATION_DATE","label":"Expiration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}}],"myRecordsFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Active"},{"value":2,"label":"Inactive"},{"value":3,"label":"Pending"}]},{"type":"dateRange","name":"DATE_RANGE","label":"Date range","defaultValue":{"start":null,"end":null}}],"myWorkQueueFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Approved"},{"value":2,"label":"Pending Online Payment"},{"value":3,"label":"Pending Review"},{"value":4,"label":"Needs Correction"},{"value":5,"label":"Rejected"},{"value":6,"label":"Draft"}]},{"type":"dateRange","name":"DATE_RANGE","label":"Date range","defaultValue":{"start":null,"end":null}}]},{"label":"Notary","component":"Notary","parameter":"notary","sourceTypeId":850,"myWorkQueueSearch":false,"allowEmptySearchTerm":true,"requestCertificateAlternateLabel":"Download Certificate","fileAmendmentButtonLabel":"Filing Actions","hideNameRequestCertificate":true,"hideAddressRequestCertificate":true,"hideRecordUserManagment":true,"searchPlaceholder":"Search by name or commission number","searchMustHaveOneOf":["CITY","search","SERVICE_TYPE"],"advancedParametersStartOpen":true,"searchIsSortable":true,"advancedSearchParameters":[{"type":"radio","name":"STARTS_WITH_YN","defaultValue":false,"options":[{"value":true,"label":"Starts with"},{"value":false,"label":"Contains"}]},{"type":"checkbox","name":"ACTIVE_ONLY_YN","defaultValue":true,"label":"Active entities only"},{"type":"text","name":"CITY","defaultValue":"","label":"City"},{"type":"select","name":"SERVICE_TYPE","label":"Special Services Offered","defaultValue":0,"options":[{"value":0,"label":"(N/A)"},{"value":6165,"label":"In-Person Electronic Notarization (IPEN)"},{"value":6166,"label":"Remote Online Notarization (RON)"},{"value":6167,"label":"Mobile Notary Services"},{"value":6168,"label":"Remote Ink Notarization (RIN)"}]}]},{"label":"Apostille","component":"Apostille","parameter":"apostille","sourceTypeId":720,"myRecordsSearch":false,"myWorkQueueSearch":false,"disabled":false,"allowedRoutes":["/forms-manager/","/queue/","/forms/"]},{"label":"Liens","component":"UCC","parameter":"ucc","sourceTypeId":1999,"myRecordsSearch":true,"myWorkQueueSearch":true,"fileAmendmentButtonLabel":"Filing Actions","searchPlaceholder":"Search by name or file number","disabled":false,"serverWebSearchDescription":true,"myRecordsDescription":"","workQueueDescription":"","searchDescription":"","hideRecordUserManagment":true,"searchLiensCheckout":false,"advancedSearchParameters":[{"type":"radio","name":"STARTS_WITH_YN","defaultValue":false,"options":[{"value":true,"label":"Starts with"},{"value":false,"label":"Contains"}]},{"type":"select","name":"STATUS","defaultValue":"ALL","label":"Status","options":[{"value":"ACTIVE_UNLAPSED","label":"Active (unlapsed)"},{"value":"ACTIVE_LAPSED_UNLAPSED","label":"Active (lapsed and unlapsed)"}]},{"type":"text","name":"EXCLUDE_VALUES","label":"Exclude Debtor Names (comma separated list of names to exclude)","defaultValue":""},{"type":"dateRange","name":"FILING_DATE","label":"Financing Statement Date","defaultValue":{"start":null,"end":null}},{"type":"dateRange","name":"LAPSE_DATE","label":"Lapse Date","defaultValue":{"start":null,"end":null}},{"type":"text","name":"CITY","label":"Debtor City","defaultValue":""}],"myRecordsFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Approved"},{"value":2,"label":"Pending Online Payment"},{"value":3,"label":"Pending Review"}]},{"type":"select","name":"TYPE","defaultValue":0,"label":"Lien Type","options":[{"value":0,"label":"All"},{"value":1,"label":"UCC"},{"value":2,"label":"EFS"},{"value":3,"label":"Title 71"}]}],"myWorkQueueFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Approved"},{"value":2,"label":"Pending Online Payment"},{"value":3,"label":"Pending Review"},{"value":4,"label":"Pending Print and Mail"},{"value":5,"label":"Rejected"},{"value":6,"label":"Draft"}]},{"type":"select","name":"TYPE","defaultValue":0,"label":"Lien Type","options":[{"value":0,"label":"All"},{"value":1,"label":"UCC"},{"value":2,"label":"EFS"},{"value":3,"label":"Title 71"}]}]},{"label":"Copy Request","component":"copies","parameter":"copies","sourceTypeId":2001,"myRecordsSearch":false,"myWorkQueueSearch":false,"disabled":false,"allowedRoutes":["/forms-manager/","/queue/","/forms/"]},{"label":"Trademark","component":"Trademark","parameter":"trademark","sourceTypeId":810,"showRequestCertificate":true,"searchMustHaveOneOf":["search","EXPIRATION_DATE","FILING_DATE"],"allowEmptySearchTerm":true,"requestCertificateAlternateLabel":"Request Information","fileAmendmentButtonLabel":"Filing Actions","advancedSearchParameters":[{"type":"radio","name":"QUERY_TYPE_ID","defaultValue":1010,"options":[{"value":1010,"label":"Starts with"},{"value":1011,"label":"Contains"},{"value":1012,"label":" Word Contains"}]},{"type":"checkbox","name":"OWNER_SEARCH_YN","defaultValue":false,"label":"Search owners"},{"type":"radio","name":"SERVICE_MARK_YN","label":"Mark Type","defaultValue":"","options":[{"value":"","label":"All Marks"},{"value":"Y","label":"Service Mark"},{"value":"N","label":"Trademark"}]},{"type":"serverSelect","name":"STATUS_ID","optionsSrc":"TYPE_V|TRADEMARK_STATUS_TYPE","label":"Status","placeholder":"All","defaultValue":"0"},{"type":"select","name":"DESIGN_TYPE_ID","options":[{"value":0,"label":"All"},{"value":990,"label":"Words Only"},{"value":991,"label":"Design Only"},{"value":992,"label":"Words and Design"}],"label":"Design Type","defaultValue":"0"},{"type":"dateRange","name":"FILING_DATE","label":"Registered Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}},{"type":"dateRange","name":"EXPIRATION_DATE","label":"Expiration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}}]},{"label":"Business Info Request","component":"InfoRequests","parameter":"info-request","sourceTypeId":167,"allowedRoutes":["/forms-manager/","/queue/","/forms/"]},{"label":"Data Requests","component":"DataRequests","parameter":"data-request","sourceTypeId":0,"allowedRoutes":["/forms-manager/"]},{"label":"CRA","component":"CRA","parameter":"cra","sourceTypeId":157,"myRecordsSearch":false,"searchPlaceholder":"Search by name or registered agent number","allowedRoutes":["/forms-manager/","/forms/","/records/","/queue/","/search/"],"allowEmptySearchTerm":true,"fileAmendmentButtonLabel":"Filing Actions","advancedSearchParameters":[{"type":"radio","name":"QUERY_TYPE_ID","defaultValue":1010,"options":[{"value":1010,"label":"Starts with"},{"value":1011,"label":"Contains"},{"value":1012,"label":" Word Contains"}]},{"type":"dateRange","name":"CRA_DATE","label":"Registration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}},{"type":"select","name":"STATUS_ID","label":"Status","defaultValue":0,"options":[{"value":0,"label":"All"},{"value":121,"label":"Active"},{"value":122,"label":"Inactive"}]},{"type":"select","name":"AGENT_TYPE_ID","label":"Agent Type","defaultValue":0,"options":[{"value":0,"label":"All"},{"value":460,"label":"Registered Agent"},{"value":461,"label":"Commercial Registered Agent"}]}]},{"label":"Farm Bill","component":"FarmBill","parameter":"farm-bill","path":"/lists/farm-bill","sourceTypeId":0,"myRecordsSearch":false,"allowedRules":["/search/"],"disabled":true,"searchDescription":"To perform a search, enter a debtor name. Your search results may include: exact debtor name, variations of that name and any filing that includes your search criteria. Punctuation is ignored.\n\nYou can click on \"Advanced\" to refine your search. Under “Advanced” you can search by crop, year, county and SSN/FEIN. As a registered Farm Bill Buyer with the Montana Secretary of State’s office it is important to maintain the confidentiality of the information contained within the Farm Bill Master List. The Farm Bill Master List reflects personal data, such as Social Security Numbers, which are a key piece of personal identifiable information to assist you in determining the existence of a lien against a specific debtor. The distribution of this information beyond its intended purpose is strictly prohibited.\n\nThe debtor's tax identification number has been hidden for confidentiality reasons. You may continue to search on a tax ID number and return debtors that match your search criteria. The SSN/FEIN must be entered without dashes or spaces.","searchMustHaveOneOf":["search","UCC_FARM_PRODUCT_ID","COUNTY"],"searchPlaceholder":"Search by debtor name","advancedSearchParameters":[{"type":"ServerMultiComplete","label":"Product code name(s)","name":"UCC_FARM_PRODUCT_ID","defaultValue":"","optionsSrc":"UCC_FARM_PRODUCT_V"},{"type":"MultiComplete","label":"Year or Range of Years","name":"YEAR_NUM","optionsSrc":"years","startYear":"1968","defaultValue":[],"preMergeOptions":[{"value":"ALL","label":"All"}]},{"type":"serverSelect","label":"State","name":"STATE","defaultValue":"MONTANA","optionsSrc":"STATE"},{"type":"ServerMultiComplete","label":"County","name":"COUNTY","defaultValue":[],"optionsSrc":"COUNTY","overrideSubOptionsSrcFromParameterName":"STATE"},{"type":"checkbox","name":"TIN_SEARCH_YN","defaultValue":false,"label":"Tax Identification Number Search"},{"type":"checkbox","name":"TIN_SORT_YN","defaultValue":false,"label":"Unique ID Sort"}]}],"SYSTEM_NICKNAME":"Online Services Portal","PAYMENT_METHODS":[{"type":"bypass"},{"type":"iTransact"}],"PAYMENT_ALLOW_AMEX":true,"SYSTEM_ID_LABEL":"System Id","DOUBLE_COLUMN_PUBLIC_LOGIN":true,"INTERNAL_USER_MANAGEMENT":true,"ALLOW_PUBLIC_JSON_IMPORT":false,"MAX_FILE_UPLOAD_SIZE":10000000,"REFUND_TEXT":"","RETURN_TO_HOME_ON_LOGOUT":true,"CURRENT_SOS_NAME":"Christi Jacobsen","LOGO_FILENAME":"mt-sos-logo.png","LOGO_ALT":"Christi Jacobsen, Montana Secretary of State","LOGO_FULL_WIDTH":true,"HOME_HIDE_AUTH_HINT":true,"HOME_TITLE":"Montana Secretary of State","CUSTOM_TAB_TITLE":"Official Montana","HOME_SUBTITLE":"Online Business Services","ENTITY_NAME_CONSENT_DESCRIPTION":"","ALLOW_USER_PROFILE_EDITING":true,"COMPARE_FOREIGN_NAME_IN_ENTITY_NAME_VALIDATION":true,"FOREIGN_NAME_FIELD_NAME":"KIMA_PARENT_NAME_INFO","LOGIN_TITLE":"Montana Secretary of State Online Filing Portal Login","PUBLIC_LOGIN_LABEL":"Username","REVERSE_LOGIN_COLUMNS":true,"LOGIN_SEAL_FILENAME":"seal_white.png","SEPARATE_USERNAME_AND_EMAIL":true,"CREATE_ACCOUNT_BUTTON_ALIGN_LEFT":true,"CREATE_ACCOUNT_BUTTON_TEXT":"CREATE AN ACCOUNT","PASSWORD_CUSTOM_ERROR_TEXT":"The password must meet all requirements","ACCOUNT_CREATED_MESSAGE":"Please check your email to verify your account to login and allow a few minutes for this message to arrive. Check your junk/spam folders if you do not find the email in your inbox.","PUBLIC_LOGIN_PLACEHOLDER":" ","DISABLE_DEFAULT_PAYMENT_RADIO":true,"CUSTOM_RESET_PASSWORD_ERROR_MESSAGE":"Username invalid - no account found","PUBLIC_LOGIN_CREATE_DESCRIPTION":"### Existing User:\n\n  - Enter your username and password to login.  \n\n\n  #### - OR -  \n\n\n\n  - Forgot password? Click 'Reset Password' and follow the prompts.\n  - Forgot username? Click 'Forgot Username' and follow the prompts.  \n\n\n  ### New User:\n  ","LOGIN_HELP_LINK":"https://sosmt.gov/business/how-do-i/","LOGIN_HELP_LINK_TEXT":"Need Help?","FORGOT_USERNAME_TEXT":"Forgot Username?","LOGIN_ACTIVE_DIRECTORY_TEXT":"State User Login","MULTIPLE_LOGIN_METHODS":true,"HAS_ACTIVE_DIRECTORY_LOGIN":true,"RESET_PASSWORD_WITH_USERNAME":true,"DOWNLOAD_LINK":true,"SHOW_USERNAME_ACCOUNT_CREATE":true,"SHOW_SCROLL_DOWN_ARROW":true,"SHOW_ADDRESS_ACCOUNT_CREATE":true,"TWO_COLUMN_ACCOUNT_CREATE":true,"RESET_PASSWORD_TIP":"A link to change your password has been sent to your email. Please allow a few minutes for this message to arrive. Please check your junk/spam folders if you do not find the email in your inbox.","FORGOT_PASSWORD_LINK_TEXT":"Reset Password","PHONE_NUMBER_OPTIONAL_ACCOUNT_CREATE":true,"SHOW_REQUIRED_INDICATOR_ACCOUNT_CREATE":true,"PASSWORD_REQUIREMENTS_ACCOUNT_CREATE":"\n    <ul>\n      <li>MUST contain at least 8 characters (12+ recommended)</li>\n      <li>MUST contain at least one uppercase letter.</li>\n      <li>MUST contain at least one lowercase letter.</li>\n      <li>MUST contain at least one number.</li>\n      <li>MUST contain at least one special character (!”#$%&'()*+,-./:;<=>?</li>\n    </ul>\n  ","ALLOW_CERTIFICATION_REQUEST":true,"ALLOW_PUBLIC_CERTIFICATE_REQUEST":true,"ALLOW_COPY_REQUEST":false,"ALLOW_CORRECTION_STYLING":true,"HIDE_DEPRECATION_WARNING":false,"AMEND_ROUTE_PUBLIC":true,"SEAL_FILENAME":"seal.png","SHOPPING_CART":true,"ALLOW_PAYMENT_UPDATE_WITH_EMPTY_CART":true,"RA_EMAIL":true,"RA_WEBSITE":true,"RA_NO_DEFAULT_TYPE":true,"RA_ADDRESS_LABEL":"Street Address","RA_TYPE_SELECTION_DEFAULT":true,"RA_DEFAULT_TYPE":"460","RA_OVERRIDE_TYPE_WITH_DEFAULT":true,"RA_PRINCIPAL_ADDRESS_AMS":true,"UPLOAD_AND_SUBMIT_HIDE_IF_ONE_OPTION":true,"PAYMENT_PROCESSING_MESSAGE":"Your payment is processing - Do not close your browser or click the back button","CHECKOUT_BUTTON_WHEN_PROCESSING_TEXT":"Processing","EFS_CROP_PICKER_NONE_LABEL":"Lien Duration","DISALLOWED_WIZARD_PIECES":["FormationLocale"],"REPEATER_SHOW_EDIT_BUTTON":true,"DATA_REQUEST_PAGE_TITLE":"Data Requests and Subscriptions","DATA_REQUEST_SIDEBAR_LABEL":"Data Requests & Subscriptions","LOGIN_REDIRECTS_TO_EPASS":false,"LOGIN_REDIRECTS_TO_ACTIVE_DIRECTORY":true,"LOGIN_ACTIVE_DIRECTORY_LINK":true,"FETCH_EDIT_USER_LINK":false,"LISTS_FETCH_AVAILABLE_LISTS":true,"POST_WIZARD_SUBMIT_REDIRECT_URL":"/","PIN_REQUEST_ATTESTATIONS":true,"PIN_REQUEST_DESCRIPTION":"Click **Request PIN** to have a new PIN sent to the account holder's email address on file.","OWNERSHIP_REQUEST_DESCRIPTION":"To become an **authorized user** of this record, a current **AUTHORIZED USER** will need to grant you access. To request access, click **Request Access** below.","PIN_REQUEST_SUCCESS_MESSAGE":"The PIN you have requested for this entity has been sent to the email associated with your user account.  You should receive the PIN in approximately 3-5 minutes, depending on your email service provider.","APOSTILLE_HEADER_LABEL":"Verification Information","APOSTILLE_NUMBER_LABEL":"Apostille/Authentication","APOSTILLE_CITY_STATE_OVERRIDE":"HELENA, MT","APOSTILLE_FILING_DATE_LABEL":"Issue Date","APOSTILLE_CITY_STATE_IN_CERTIFIED":true,"NOTARY_EXISTING_FILING":true,"ALLOW_REVOKE_OWN_ACCESS_ONLY":false,"HIDE_CANCEL_ON_ONETIME_DATA_REQUESTS":true,"DATA_REQUESTS_IN_SHOPPING_CART":true,"WQ_ALLOW_EDIT_PENDING_PAYMENT":true,"WQ_CONFIRM_ON_DELETE":true,"WQ_DELETE_CONFIRM_MESSAGE":"Deleting this filing will forfeit any money already paid to the Secretary of State. This action is permanent and cannot be undone, are you sure you would like to delete?","PASS_ITEM_GUIDS_ON_CHECKOUT":true,"FORM_REVISION_HISTORY":true,"CHECKOUT_DISCLAIMER":"By entering your credit card and/or checking account information you (i) state that **you are an authorized user** of the credit card and/or electronic check and that the associated information entered (e.g., account holder name, account number, billing address) is accurate, (ii) **you authorize payment processor to charge the amount you have requested** to your credit card and/or funding account, and (iii) **acknowledge if a charge is declined or reversed you may also be assessed a customary charge** by the payment processor for such transactions.","FARM_BILL_SEARCH_CONFIDENTIAL":"As a registered Farm Bill Buyer with the Montana Secretary of State’s office it is important to maintain the confidentiality of the information contained within the Farm Bill Master List. The Farm Bill Master List reflects personal data, such as Social Security Numbers, which are a key piece of personal identifiable information to assist you in determining the existence of a lien against a specific debtor. The distribution of this information beyond its intended purpose is strictly prohibited.\n\n**The debtor's tax identification number has been hidden for confidentiality reasons. You may continue to search on a tax ID number and return debtors that match your search criteria. The SSN/FEIN must be entered without dashes or spaces.  If you need access to the tax identification number to clearly identify the debtor, please contact the UCC unit at (406) 444-3665.**","VIEW_HISTORY_BUTTON_ALT_TEXT":"View Filings","WIZARD_ERROR_TITLE_MESSAGE":"Form Error","FARM_BILL_SEARCH_INTERACTIVE":true,"USE_FARM_BILL_API":true,"DISALLOW_ASSIGN_SELF_AS_RA":true,"DISALLOW_ASSIGN_SELF_AS_PRINCIPAL":true,"USE_TRADEMARK_OWNER_VALIDATION":true,"USE_ALTERNATIVE_FOREIGN_ADDRESS_LABELS":true,"MY_RECEIPTS_FILTER":[{"type":"dateRange","name":"DATE_RANGE","label":"Date range","defaultValue":{"start":null,"end":null}},{"type":"text","name":"REF_NUM","defaultValue":"","label":"Reference Number"},{"type":"text","name":"RECEIPT_NUM","defaultValue":"","label":"Receipt Id"},{"type":"text","name":"AMOUNT","defaultValue":"","label":"Amount"},{"type":"select","name":"TYPE","defaultValue":"","label":"Payment Type","options":[{"value":"","label":"All"},{"value":"CC","label":"Credit Card"},{"value":"Check","label":"Check"}]}],"MY_RECEIPTS_SHOW_IN_SIDEBAR":true,"SHOW_MY_RECEIPTS_HELPER_TEXT":true,"MY_RECEIPTS_HELPER_LABEL":"About Receipt Search","MY_RECEIPTS_HELPER_TEXT":"You can search for receipts based on their descriptions, including the items paid for on the receipt. Use the filters to search for or filter specific information.","FARM_BILL_SUBLINK":{"label":"Farm Bill","component":"FarmBill","parameter":"farm-bill","path":"/lists/farm-bill","sourceTypeId":0,"myRecordsSearch":false,"allowedRules":["/search/"],"disabled":true,"searchDescription":"To perform a search, enter a debtor name. Your search results may include: exact debtor name, variations of that name and any filing that includes your search criteria. Punctuation is ignored.\n\nYou can click on \"Advanced\" to refine your search. Under “Advanced” you can search by crop, year, county and SSN/FEIN. As a registered Farm Bill Buyer with the Montana Secretary of State’s office it is important to maintain the confidentiality of the information contained within the Farm Bill Master List. The Farm Bill Master List reflects personal data, such as Social Security Numbers, which are a key piece of personal identifiable information to assist you in determining the existence of a lien against a specific debtor. The distribution of this information beyond its intended purpose is strictly prohibited.\n\nThe debtor's tax identification number has been hidden for confidentiality reasons. You may continue to search on a tax ID number and return debtors that match your search criteria. The SSN/FEIN must be entered without dashes or spaces.","searchMustHaveOneOf":["search","UCC_FARM_PRODUCT_ID","COUNTY"],"searchPlaceholder":"Search by debtor name","advancedSearchParameters":[{"type":"ServerMultiComplete","label":"Product code name(s)","name":"UCC_FARM_PRODUCT_ID","defaultValue":"","optionsSrc":"UCC_FARM_PRODUCT_V"},{"type":"MultiComplete","label":"Year or Range of Years","name":"YEAR_NUM","optionsSrc":"years","startYear":"1968","defaultValue":[],"preMergeOptions":[{"value":"ALL","label":"All"}]},{"type":"serverSelect","label":"State","name":"STATE","defaultValue":"MONTANA","optionsSrc":"STATE"},{"type":"ServerMultiComplete","label":"County","name":"COUNTY","defaultValue":[],"optionsSrc":"COUNTY","overrideSubOptionsSrcFromParameterName":"STATE"},{"type":"checkbox","name":"TIN_SEARCH_YN","defaultValue":false,"label":"Tax Identification Number Search"},{"type":"checkbox","name":"TIN_SORT_YN","defaultValue":false,"label":"Unique ID Sort"}]},"ALLOW_ADDRESS_VALIDATION_BYPASS_OPTION":true,"DEFAULT_ADDRESS_VALIDATION_BYPASS_OPTION_CHECKED":true}).RD_TOOLTIP_AMENDMENT;
	var RD_TOOLTIP_REINSTATE = ({"NODE_ENV":"production","BUILD_DATE":"2025-08-27T15:15:31.687Z","BUILD_NUMBER":"Not Provided","GIT_VERSION":"v1.3.0-381-ga81e29b08","GIT_COMMIT_HASH":"a81e29b085c9268ffd96c78eb734365802722741","GIT_BRANCH":"beta","PUBLIC_URL":"","STATE_ABBR":"MT","STATE_NAME":"Montana","STATE_ORG_TITLE":"Secretary of State","LOGIN_HEADER_IMG_PATH":"","HOME_IMG_FILENAME":"montana.jpg","FAVICON_FILE_NAME":"favicon.ico","ALLOW_E_SIGN_ON_CORRECTIONS":true,"THIRD_PARTY_SIGNING_ALLOWED":false,"MY_ACCOUNT_SAVE_AND_CLOSE_BUTTON":true,"IE_DEPRECATED_MESSAGE":"Internet Explorer is not supported. Please select a supported browser below to access this website.","ADDITIONAL_ROUTES":{"dataRequests":true,"farmBill":true,"apostille":true,"externalHelp":"https://sosmt.gov/business/help-center/","systemAdministration":[{"title":"Saved Payments","parameter":"saved-payments","componentName":"SavedPayments"}]},"SUBROUTES":[{"label":"Business","component":"Business","parameter":"business","myWorkQueueSearch":false,"sourceTypeId":54,"searchMustHaveOneOf":["FILING_TYPE_ID","STATUS_ID","STATE","search"],"serverWebSearchDescription":true,"serverWorkQueueDescription":true,"serverMyRecordsDescription":true,"searchPlaceholder":"Search by name or filing number (X########)","allowEmptySearchTerm":true,"requestCertificateAlternateLabel":"Request Information","fileAmendmentButtonLabel":"Filing Actions","advancedSearchParameters":[{"type":"radio","name":"QUERY_TYPE_ID","defaultValue":1010,"options":[{"value":1010,"label":"Starts with"},{"value":1011,"label":"Contains"},{"value":1012,"label":" Word Contains"}]},{"type":"serverSelect","name":"FILING_TYPE_ID","optionsSrc":"FILING_TYPES","label":"Entity Type","placeholder":"All","defaultValue":"0"},{"type":"serverSelect","name":"FILING_SUBTYPE_ID","optionsSrc":"FILING_SUBTYPES","label":"Entity Subtype","overrideSubOptionsSrcFromParameterName":"FILING_TYPE_ID","placeholder":"All","defaultValue":"0"},{"type":"serverSelect","name":"STATUS_ID","optionsSrc":"FILING_STATUS_WITHOUT_ALL","label":"Status","placeholder":"All","defaultValue":"0"},{"type":"serverSelect","name":"STATE","optionsSrc":"STATE","label":"State","placeholder":"All","defaultValue":""},{"type":"serverSelect","name":"COUNTY","optionsSrc":"COUNTY_SUBOPTION","label":"County","overrideSubOptionsSrcFromParameterName":"STATE","placeholder":"All","defaultValue":""},{"type":"checkbox","name":"CRA_SEARCH_YN","defaultValue":false,"label":"Search by Registered Agent PID"},{"type":"dateRange","name":"FILING_DATE","label":"Registration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}},{"type":"dateRange","name":"EXPIRATION_DATE","label":"Expiration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}}],"myRecordsFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Active"},{"value":2,"label":"Inactive"},{"value":3,"label":"Pending"}]},{"type":"dateRange","name":"DATE_RANGE","label":"Date range","defaultValue":{"start":null,"end":null}}],"myWorkQueueFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Approved"},{"value":2,"label":"Pending Online Payment"},{"value":3,"label":"Pending Review"},{"value":4,"label":"Needs Correction"},{"value":5,"label":"Rejected"},{"value":6,"label":"Draft"}]},{"type":"dateRange","name":"DATE_RANGE","label":"Date range","defaultValue":{"start":null,"end":null}}]},{"label":"Notary","component":"Notary","parameter":"notary","sourceTypeId":850,"myWorkQueueSearch":false,"allowEmptySearchTerm":true,"requestCertificateAlternateLabel":"Download Certificate","fileAmendmentButtonLabel":"Filing Actions","hideNameRequestCertificate":true,"hideAddressRequestCertificate":true,"hideRecordUserManagment":true,"searchPlaceholder":"Search by name or commission number","searchMustHaveOneOf":["CITY","search","SERVICE_TYPE"],"advancedParametersStartOpen":true,"searchIsSortable":true,"advancedSearchParameters":[{"type":"radio","name":"STARTS_WITH_YN","defaultValue":false,"options":[{"value":true,"label":"Starts with"},{"value":false,"label":"Contains"}]},{"type":"checkbox","name":"ACTIVE_ONLY_YN","defaultValue":true,"label":"Active entities only"},{"type":"text","name":"CITY","defaultValue":"","label":"City"},{"type":"select","name":"SERVICE_TYPE","label":"Special Services Offered","defaultValue":0,"options":[{"value":0,"label":"(N/A)"},{"value":6165,"label":"In-Person Electronic Notarization (IPEN)"},{"value":6166,"label":"Remote Online Notarization (RON)"},{"value":6167,"label":"Mobile Notary Services"},{"value":6168,"label":"Remote Ink Notarization (RIN)"}]}]},{"label":"Apostille","component":"Apostille","parameter":"apostille","sourceTypeId":720,"myRecordsSearch":false,"myWorkQueueSearch":false,"disabled":false,"allowedRoutes":["/forms-manager/","/queue/","/forms/"]},{"label":"Liens","component":"UCC","parameter":"ucc","sourceTypeId":1999,"myRecordsSearch":true,"myWorkQueueSearch":true,"fileAmendmentButtonLabel":"Filing Actions","searchPlaceholder":"Search by name or file number","disabled":false,"serverWebSearchDescription":true,"myRecordsDescription":"","workQueueDescription":"","searchDescription":"","hideRecordUserManagment":true,"searchLiensCheckout":false,"advancedSearchParameters":[{"type":"radio","name":"STARTS_WITH_YN","defaultValue":false,"options":[{"value":true,"label":"Starts with"},{"value":false,"label":"Contains"}]},{"type":"select","name":"STATUS","defaultValue":"ALL","label":"Status","options":[{"value":"ACTIVE_UNLAPSED","label":"Active (unlapsed)"},{"value":"ACTIVE_LAPSED_UNLAPSED","label":"Active (lapsed and unlapsed)"}]},{"type":"text","name":"EXCLUDE_VALUES","label":"Exclude Debtor Names (comma separated list of names to exclude)","defaultValue":""},{"type":"dateRange","name":"FILING_DATE","label":"Financing Statement Date","defaultValue":{"start":null,"end":null}},{"type":"dateRange","name":"LAPSE_DATE","label":"Lapse Date","defaultValue":{"start":null,"end":null}},{"type":"text","name":"CITY","label":"Debtor City","defaultValue":""}],"myRecordsFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Approved"},{"value":2,"label":"Pending Online Payment"},{"value":3,"label":"Pending Review"}]},{"type":"select","name":"TYPE","defaultValue":0,"label":"Lien Type","options":[{"value":0,"label":"All"},{"value":1,"label":"UCC"},{"value":2,"label":"EFS"},{"value":3,"label":"Title 71"}]}],"myWorkQueueFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Approved"},{"value":2,"label":"Pending Online Payment"},{"value":3,"label":"Pending Review"},{"value":4,"label":"Pending Print and Mail"},{"value":5,"label":"Rejected"},{"value":6,"label":"Draft"}]},{"type":"select","name":"TYPE","defaultValue":0,"label":"Lien Type","options":[{"value":0,"label":"All"},{"value":1,"label":"UCC"},{"value":2,"label":"EFS"},{"value":3,"label":"Title 71"}]}]},{"label":"Copy Request","component":"copies","parameter":"copies","sourceTypeId":2001,"myRecordsSearch":false,"myWorkQueueSearch":false,"disabled":false,"allowedRoutes":["/forms-manager/","/queue/","/forms/"]},{"label":"Trademark","component":"Trademark","parameter":"trademark","sourceTypeId":810,"showRequestCertificate":true,"searchMustHaveOneOf":["search","EXPIRATION_DATE","FILING_DATE"],"allowEmptySearchTerm":true,"requestCertificateAlternateLabel":"Request Information","fileAmendmentButtonLabel":"Filing Actions","advancedSearchParameters":[{"type":"radio","name":"QUERY_TYPE_ID","defaultValue":1010,"options":[{"value":1010,"label":"Starts with"},{"value":1011,"label":"Contains"},{"value":1012,"label":" Word Contains"}]},{"type":"checkbox","name":"OWNER_SEARCH_YN","defaultValue":false,"label":"Search owners"},{"type":"radio","name":"SERVICE_MARK_YN","label":"Mark Type","defaultValue":"","options":[{"value":"","label":"All Marks"},{"value":"Y","label":"Service Mark"},{"value":"N","label":"Trademark"}]},{"type":"serverSelect","name":"STATUS_ID","optionsSrc":"TYPE_V|TRADEMARK_STATUS_TYPE","label":"Status","placeholder":"All","defaultValue":"0"},{"type":"select","name":"DESIGN_TYPE_ID","options":[{"value":0,"label":"All"},{"value":990,"label":"Words Only"},{"value":991,"label":"Design Only"},{"value":992,"label":"Words and Design"}],"label":"Design Type","defaultValue":"0"},{"type":"dateRange","name":"FILING_DATE","label":"Registered Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}},{"type":"dateRange","name":"EXPIRATION_DATE","label":"Expiration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}}]},{"label":"Business Info Request","component":"InfoRequests","parameter":"info-request","sourceTypeId":167,"allowedRoutes":["/forms-manager/","/queue/","/forms/"]},{"label":"Data Requests","component":"DataRequests","parameter":"data-request","sourceTypeId":0,"allowedRoutes":["/forms-manager/"]},{"label":"CRA","component":"CRA","parameter":"cra","sourceTypeId":157,"myRecordsSearch":false,"searchPlaceholder":"Search by name or registered agent number","allowedRoutes":["/forms-manager/","/forms/","/records/","/queue/","/search/"],"allowEmptySearchTerm":true,"fileAmendmentButtonLabel":"Filing Actions","advancedSearchParameters":[{"type":"radio","name":"QUERY_TYPE_ID","defaultValue":1010,"options":[{"value":1010,"label":"Starts with"},{"value":1011,"label":"Contains"},{"value":1012,"label":" Word Contains"}]},{"type":"dateRange","name":"CRA_DATE","label":"Registration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}},{"type":"select","name":"STATUS_ID","label":"Status","defaultValue":0,"options":[{"value":0,"label":"All"},{"value":121,"label":"Active"},{"value":122,"label":"Inactive"}]},{"type":"select","name":"AGENT_TYPE_ID","label":"Agent Type","defaultValue":0,"options":[{"value":0,"label":"All"},{"value":460,"label":"Registered Agent"},{"value":461,"label":"Commercial Registered Agent"}]}]},{"label":"Farm Bill","component":"FarmBill","parameter":"farm-bill","path":"/lists/farm-bill","sourceTypeId":0,"myRecordsSearch":false,"allowedRules":["/search/"],"disabled":true,"searchDescription":"To perform a search, enter a debtor name. Your search results may include: exact debtor name, variations of that name and any filing that includes your search criteria. Punctuation is ignored.\n\nYou can click on \"Advanced\" to refine your search. Under “Advanced” you can search by crop, year, county and SSN/FEIN. As a registered Farm Bill Buyer with the Montana Secretary of State’s office it is important to maintain the confidentiality of the information contained within the Farm Bill Master List. The Farm Bill Master List reflects personal data, such as Social Security Numbers, which are a key piece of personal identifiable information to assist you in determining the existence of a lien against a specific debtor. The distribution of this information beyond its intended purpose is strictly prohibited.\n\nThe debtor's tax identification number has been hidden for confidentiality reasons. You may continue to search on a tax ID number and return debtors that match your search criteria. The SSN/FEIN must be entered without dashes or spaces.","searchMustHaveOneOf":["search","UCC_FARM_PRODUCT_ID","COUNTY"],"searchPlaceholder":"Search by debtor name","advancedSearchParameters":[{"type":"ServerMultiComplete","label":"Product code name(s)","name":"UCC_FARM_PRODUCT_ID","defaultValue":"","optionsSrc":"UCC_FARM_PRODUCT_V"},{"type":"MultiComplete","label":"Year or Range of Years","name":"YEAR_NUM","optionsSrc":"years","startYear":"1968","defaultValue":[],"preMergeOptions":[{"value":"ALL","label":"All"}]},{"type":"serverSelect","label":"State","name":"STATE","defaultValue":"MONTANA","optionsSrc":"STATE"},{"type":"ServerMultiComplete","label":"County","name":"COUNTY","defaultValue":[],"optionsSrc":"COUNTY","overrideSubOptionsSrcFromParameterName":"STATE"},{"type":"checkbox","name":"TIN_SEARCH_YN","defaultValue":false,"label":"Tax Identification Number Search"},{"type":"checkbox","name":"TIN_SORT_YN","defaultValue":false,"label":"Unique ID Sort"}]}],"SYSTEM_NICKNAME":"Online Services Portal","PAYMENT_METHODS":[{"type":"bypass"},{"type":"iTransact"}],"PAYMENT_ALLOW_AMEX":true,"SYSTEM_ID_LABEL":"System Id","DOUBLE_COLUMN_PUBLIC_LOGIN":true,"INTERNAL_USER_MANAGEMENT":true,"ALLOW_PUBLIC_JSON_IMPORT":false,"MAX_FILE_UPLOAD_SIZE":10000000,"REFUND_TEXT":"","RETURN_TO_HOME_ON_LOGOUT":true,"CURRENT_SOS_NAME":"Christi Jacobsen","LOGO_FILENAME":"mt-sos-logo.png","LOGO_ALT":"Christi Jacobsen, Montana Secretary of State","LOGO_FULL_WIDTH":true,"HOME_HIDE_AUTH_HINT":true,"HOME_TITLE":"Montana Secretary of State","CUSTOM_TAB_TITLE":"Official Montana","HOME_SUBTITLE":"Online Business Services","ENTITY_NAME_CONSENT_DESCRIPTION":"","ALLOW_USER_PROFILE_EDITING":true,"COMPARE_FOREIGN_NAME_IN_ENTITY_NAME_VALIDATION":true,"FOREIGN_NAME_FIELD_NAME":"KIMA_PARENT_NAME_INFO","LOGIN_TITLE":"Montana Secretary of State Online Filing Portal Login","PUBLIC_LOGIN_LABEL":"Username","REVERSE_LOGIN_COLUMNS":true,"LOGIN_SEAL_FILENAME":"seal_white.png","SEPARATE_USERNAME_AND_EMAIL":true,"CREATE_ACCOUNT_BUTTON_ALIGN_LEFT":true,"CREATE_ACCOUNT_BUTTON_TEXT":"CREATE AN ACCOUNT","PASSWORD_CUSTOM_ERROR_TEXT":"The password must meet all requirements","ACCOUNT_CREATED_MESSAGE":"Please check your email to verify your account to login and allow a few minutes for this message to arrive. Check your junk/spam folders if you do not find the email in your inbox.","PUBLIC_LOGIN_PLACEHOLDER":" ","DISABLE_DEFAULT_PAYMENT_RADIO":true,"CUSTOM_RESET_PASSWORD_ERROR_MESSAGE":"Username invalid - no account found","PUBLIC_LOGIN_CREATE_DESCRIPTION":"### Existing User:\n\n  - Enter your username and password to login.  \n\n\n  #### - OR -  \n\n\n\n  - Forgot password? Click 'Reset Password' and follow the prompts.\n  - Forgot username? Click 'Forgot Username' and follow the prompts.  \n\n\n  ### New User:\n  ","LOGIN_HELP_LINK":"https://sosmt.gov/business/how-do-i/","LOGIN_HELP_LINK_TEXT":"Need Help?","FORGOT_USERNAME_TEXT":"Forgot Username?","LOGIN_ACTIVE_DIRECTORY_TEXT":"State User Login","MULTIPLE_LOGIN_METHODS":true,"HAS_ACTIVE_DIRECTORY_LOGIN":true,"RESET_PASSWORD_WITH_USERNAME":true,"DOWNLOAD_LINK":true,"SHOW_USERNAME_ACCOUNT_CREATE":true,"SHOW_SCROLL_DOWN_ARROW":true,"SHOW_ADDRESS_ACCOUNT_CREATE":true,"TWO_COLUMN_ACCOUNT_CREATE":true,"RESET_PASSWORD_TIP":"A link to change your password has been sent to your email. Please allow a few minutes for this message to arrive. Please check your junk/spam folders if you do not find the email in your inbox.","FORGOT_PASSWORD_LINK_TEXT":"Reset Password","PHONE_NUMBER_OPTIONAL_ACCOUNT_CREATE":true,"SHOW_REQUIRED_INDICATOR_ACCOUNT_CREATE":true,"PASSWORD_REQUIREMENTS_ACCOUNT_CREATE":"\n    <ul>\n      <li>MUST contain at least 8 characters (12+ recommended)</li>\n      <li>MUST contain at least one uppercase letter.</li>\n      <li>MUST contain at least one lowercase letter.</li>\n      <li>MUST contain at least one number.</li>\n      <li>MUST contain at least one special character (!”#$%&'()*+,-./:;<=>?</li>\n    </ul>\n  ","ALLOW_CERTIFICATION_REQUEST":true,"ALLOW_PUBLIC_CERTIFICATE_REQUEST":true,"ALLOW_COPY_REQUEST":false,"ALLOW_CORRECTION_STYLING":true,"HIDE_DEPRECATION_WARNING":false,"AMEND_ROUTE_PUBLIC":true,"SEAL_FILENAME":"seal.png","SHOPPING_CART":true,"ALLOW_PAYMENT_UPDATE_WITH_EMPTY_CART":true,"RA_EMAIL":true,"RA_WEBSITE":true,"RA_NO_DEFAULT_TYPE":true,"RA_ADDRESS_LABEL":"Street Address","RA_TYPE_SELECTION_DEFAULT":true,"RA_DEFAULT_TYPE":"460","RA_OVERRIDE_TYPE_WITH_DEFAULT":true,"RA_PRINCIPAL_ADDRESS_AMS":true,"UPLOAD_AND_SUBMIT_HIDE_IF_ONE_OPTION":true,"PAYMENT_PROCESSING_MESSAGE":"Your payment is processing - Do not close your browser or click the back button","CHECKOUT_BUTTON_WHEN_PROCESSING_TEXT":"Processing","EFS_CROP_PICKER_NONE_LABEL":"Lien Duration","DISALLOWED_WIZARD_PIECES":["FormationLocale"],"REPEATER_SHOW_EDIT_BUTTON":true,"DATA_REQUEST_PAGE_TITLE":"Data Requests and Subscriptions","DATA_REQUEST_SIDEBAR_LABEL":"Data Requests & Subscriptions","LOGIN_REDIRECTS_TO_EPASS":false,"LOGIN_REDIRECTS_TO_ACTIVE_DIRECTORY":true,"LOGIN_ACTIVE_DIRECTORY_LINK":true,"FETCH_EDIT_USER_LINK":false,"LISTS_FETCH_AVAILABLE_LISTS":true,"POST_WIZARD_SUBMIT_REDIRECT_URL":"/","PIN_REQUEST_ATTESTATIONS":true,"PIN_REQUEST_DESCRIPTION":"Click **Request PIN** to have a new PIN sent to the account holder's email address on file.","OWNERSHIP_REQUEST_DESCRIPTION":"To become an **authorized user** of this record, a current **AUTHORIZED USER** will need to grant you access. To request access, click **Request Access** below.","PIN_REQUEST_SUCCESS_MESSAGE":"The PIN you have requested for this entity has been sent to the email associated with your user account.  You should receive the PIN in approximately 3-5 minutes, depending on your email service provider.","APOSTILLE_HEADER_LABEL":"Verification Information","APOSTILLE_NUMBER_LABEL":"Apostille/Authentication","APOSTILLE_CITY_STATE_OVERRIDE":"HELENA, MT","APOSTILLE_FILING_DATE_LABEL":"Issue Date","APOSTILLE_CITY_STATE_IN_CERTIFIED":true,"NOTARY_EXISTING_FILING":true,"ALLOW_REVOKE_OWN_ACCESS_ONLY":false,"HIDE_CANCEL_ON_ONETIME_DATA_REQUESTS":true,"DATA_REQUESTS_IN_SHOPPING_CART":true,"WQ_ALLOW_EDIT_PENDING_PAYMENT":true,"WQ_CONFIRM_ON_DELETE":true,"WQ_DELETE_CONFIRM_MESSAGE":"Deleting this filing will forfeit any money already paid to the Secretary of State. This action is permanent and cannot be undone, are you sure you would like to delete?","PASS_ITEM_GUIDS_ON_CHECKOUT":true,"FORM_REVISION_HISTORY":true,"CHECKOUT_DISCLAIMER":"By entering your credit card and/or checking account information you (i) state that **you are an authorized user** of the credit card and/or electronic check and that the associated information entered (e.g., account holder name, account number, billing address) is accurate, (ii) **you authorize payment processor to charge the amount you have requested** to your credit card and/or funding account, and (iii) **acknowledge if a charge is declined or reversed you may also be assessed a customary charge** by the payment processor for such transactions.","FARM_BILL_SEARCH_CONFIDENTIAL":"As a registered Farm Bill Buyer with the Montana Secretary of State’s office it is important to maintain the confidentiality of the information contained within the Farm Bill Master List. The Farm Bill Master List reflects personal data, such as Social Security Numbers, which are a key piece of personal identifiable information to assist you in determining the existence of a lien against a specific debtor. The distribution of this information beyond its intended purpose is strictly prohibited.\n\n**The debtor's tax identification number has been hidden for confidentiality reasons. You may continue to search on a tax ID number and return debtors that match your search criteria. The SSN/FEIN must be entered without dashes or spaces.  If you need access to the tax identification number to clearly identify the debtor, please contact the UCC unit at (406) 444-3665.**","VIEW_HISTORY_BUTTON_ALT_TEXT":"View Filings","WIZARD_ERROR_TITLE_MESSAGE":"Form Error","FARM_BILL_SEARCH_INTERACTIVE":true,"USE_FARM_BILL_API":true,"DISALLOW_ASSIGN_SELF_AS_RA":true,"DISALLOW_ASSIGN_SELF_AS_PRINCIPAL":true,"USE_TRADEMARK_OWNER_VALIDATION":true,"USE_ALTERNATIVE_FOREIGN_ADDRESS_LABELS":true,"MY_RECEIPTS_FILTER":[{"type":"dateRange","name":"DATE_RANGE","label":"Date range","defaultValue":{"start":null,"end":null}},{"type":"text","name":"REF_NUM","defaultValue":"","label":"Reference Number"},{"type":"text","name":"RECEIPT_NUM","defaultValue":"","label":"Receipt Id"},{"type":"text","name":"AMOUNT","defaultValue":"","label":"Amount"},{"type":"select","name":"TYPE","defaultValue":"","label":"Payment Type","options":[{"value":"","label":"All"},{"value":"CC","label":"Credit Card"},{"value":"Check","label":"Check"}]}],"MY_RECEIPTS_SHOW_IN_SIDEBAR":true,"SHOW_MY_RECEIPTS_HELPER_TEXT":true,"MY_RECEIPTS_HELPER_LABEL":"About Receipt Search","MY_RECEIPTS_HELPER_TEXT":"You can search for receipts based on their descriptions, including the items paid for on the receipt. Use the filters to search for or filter specific information.","FARM_BILL_SUBLINK":{"label":"Farm Bill","component":"FarmBill","parameter":"farm-bill","path":"/lists/farm-bill","sourceTypeId":0,"myRecordsSearch":false,"allowedRules":["/search/"],"disabled":true,"searchDescription":"To perform a search, enter a debtor name. Your search results may include: exact debtor name, variations of that name and any filing that includes your search criteria. Punctuation is ignored.\n\nYou can click on \"Advanced\" to refine your search. Under “Advanced” you can search by crop, year, county and SSN/FEIN. As a registered Farm Bill Buyer with the Montana Secretary of State’s office it is important to maintain the confidentiality of the information contained within the Farm Bill Master List. The Farm Bill Master List reflects personal data, such as Social Security Numbers, which are a key piece of personal identifiable information to assist you in determining the existence of a lien against a specific debtor. The distribution of this information beyond its intended purpose is strictly prohibited.\n\nThe debtor's tax identification number has been hidden for confidentiality reasons. You may continue to search on a tax ID number and return debtors that match your search criteria. The SSN/FEIN must be entered without dashes or spaces.","searchMustHaveOneOf":["search","UCC_FARM_PRODUCT_ID","COUNTY"],"searchPlaceholder":"Search by debtor name","advancedSearchParameters":[{"type":"ServerMultiComplete","label":"Product code name(s)","name":"UCC_FARM_PRODUCT_ID","defaultValue":"","optionsSrc":"UCC_FARM_PRODUCT_V"},{"type":"MultiComplete","label":"Year or Range of Years","name":"YEAR_NUM","optionsSrc":"years","startYear":"1968","defaultValue":[],"preMergeOptions":[{"value":"ALL","label":"All"}]},{"type":"serverSelect","label":"State","name":"STATE","defaultValue":"MONTANA","optionsSrc":"STATE"},{"type":"ServerMultiComplete","label":"County","name":"COUNTY","defaultValue":[],"optionsSrc":"COUNTY","overrideSubOptionsSrcFromParameterName":"STATE"},{"type":"checkbox","name":"TIN_SEARCH_YN","defaultValue":false,"label":"Tax Identification Number Search"},{"type":"checkbox","name":"TIN_SORT_YN","defaultValue":false,"label":"Unique ID Sort"}]},"ALLOW_ADDRESS_VALIDATION_BYPASS_OPTION":true,"DEFAULT_ADDRESS_VALIDATION_BYPASS_OPTION_CHECKED":true}).RD_TOOLTIP_REINSTATE;
	var RD_TOOLTIP_CERTIFICATE = ({"NODE_ENV":"production","BUILD_DATE":"2025-08-27T15:15:31.687Z","BUILD_NUMBER":"Not Provided","GIT_VERSION":"v1.3.0-381-ga81e29b08","GIT_COMMIT_HASH":"a81e29b085c9268ffd96c78eb734365802722741","GIT_BRANCH":"beta","PUBLIC_URL":"","STATE_ABBR":"MT","STATE_NAME":"Montana","STATE_ORG_TITLE":"Secretary of State","LOGIN_HEADER_IMG_PATH":"","HOME_IMG_FILENAME":"montana.jpg","FAVICON_FILE_NAME":"favicon.ico","ALLOW_E_SIGN_ON_CORRECTIONS":true,"THIRD_PARTY_SIGNING_ALLOWED":false,"MY_ACCOUNT_SAVE_AND_CLOSE_BUTTON":true,"IE_DEPRECATED_MESSAGE":"Internet Explorer is not supported. Please select a supported browser below to access this website.","ADDITIONAL_ROUTES":{"dataRequests":true,"farmBill":true,"apostille":true,"externalHelp":"https://sosmt.gov/business/help-center/","systemAdministration":[{"title":"Saved Payments","parameter":"saved-payments","componentName":"SavedPayments"}]},"SUBROUTES":[{"label":"Business","component":"Business","parameter":"business","myWorkQueueSearch":false,"sourceTypeId":54,"searchMustHaveOneOf":["FILING_TYPE_ID","STATUS_ID","STATE","search"],"serverWebSearchDescription":true,"serverWorkQueueDescription":true,"serverMyRecordsDescription":true,"searchPlaceholder":"Search by name or filing number (X########)","allowEmptySearchTerm":true,"requestCertificateAlternateLabel":"Request Information","fileAmendmentButtonLabel":"Filing Actions","advancedSearchParameters":[{"type":"radio","name":"QUERY_TYPE_ID","defaultValue":1010,"options":[{"value":1010,"label":"Starts with"},{"value":1011,"label":"Contains"},{"value":1012,"label":" Word Contains"}]},{"type":"serverSelect","name":"FILING_TYPE_ID","optionsSrc":"FILING_TYPES","label":"Entity Type","placeholder":"All","defaultValue":"0"},{"type":"serverSelect","name":"FILING_SUBTYPE_ID","optionsSrc":"FILING_SUBTYPES","label":"Entity Subtype","overrideSubOptionsSrcFromParameterName":"FILING_TYPE_ID","placeholder":"All","defaultValue":"0"},{"type":"serverSelect","name":"STATUS_ID","optionsSrc":"FILING_STATUS_WITHOUT_ALL","label":"Status","placeholder":"All","defaultValue":"0"},{"type":"serverSelect","name":"STATE","optionsSrc":"STATE","label":"State","placeholder":"All","defaultValue":""},{"type":"serverSelect","name":"COUNTY","optionsSrc":"COUNTY_SUBOPTION","label":"County","overrideSubOptionsSrcFromParameterName":"STATE","placeholder":"All","defaultValue":""},{"type":"checkbox","name":"CRA_SEARCH_YN","defaultValue":false,"label":"Search by Registered Agent PID"},{"type":"dateRange","name":"FILING_DATE","label":"Registration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}},{"type":"dateRange","name":"EXPIRATION_DATE","label":"Expiration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}}],"myRecordsFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Active"},{"value":2,"label":"Inactive"},{"value":3,"label":"Pending"}]},{"type":"dateRange","name":"DATE_RANGE","label":"Date range","defaultValue":{"start":null,"end":null}}],"myWorkQueueFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Approved"},{"value":2,"label":"Pending Online Payment"},{"value":3,"label":"Pending Review"},{"value":4,"label":"Needs Correction"},{"value":5,"label":"Rejected"},{"value":6,"label":"Draft"}]},{"type":"dateRange","name":"DATE_RANGE","label":"Date range","defaultValue":{"start":null,"end":null}}]},{"label":"Notary","component":"Notary","parameter":"notary","sourceTypeId":850,"myWorkQueueSearch":false,"allowEmptySearchTerm":true,"requestCertificateAlternateLabel":"Download Certificate","fileAmendmentButtonLabel":"Filing Actions","hideNameRequestCertificate":true,"hideAddressRequestCertificate":true,"hideRecordUserManagment":true,"searchPlaceholder":"Search by name or commission number","searchMustHaveOneOf":["CITY","search","SERVICE_TYPE"],"advancedParametersStartOpen":true,"searchIsSortable":true,"advancedSearchParameters":[{"type":"radio","name":"STARTS_WITH_YN","defaultValue":false,"options":[{"value":true,"label":"Starts with"},{"value":false,"label":"Contains"}]},{"type":"checkbox","name":"ACTIVE_ONLY_YN","defaultValue":true,"label":"Active entities only"},{"type":"text","name":"CITY","defaultValue":"","label":"City"},{"type":"select","name":"SERVICE_TYPE","label":"Special Services Offered","defaultValue":0,"options":[{"value":0,"label":"(N/A)"},{"value":6165,"label":"In-Person Electronic Notarization (IPEN)"},{"value":6166,"label":"Remote Online Notarization (RON)"},{"value":6167,"label":"Mobile Notary Services"},{"value":6168,"label":"Remote Ink Notarization (RIN)"}]}]},{"label":"Apostille","component":"Apostille","parameter":"apostille","sourceTypeId":720,"myRecordsSearch":false,"myWorkQueueSearch":false,"disabled":false,"allowedRoutes":["/forms-manager/","/queue/","/forms/"]},{"label":"Liens","component":"UCC","parameter":"ucc","sourceTypeId":1999,"myRecordsSearch":true,"myWorkQueueSearch":true,"fileAmendmentButtonLabel":"Filing Actions","searchPlaceholder":"Search by name or file number","disabled":false,"serverWebSearchDescription":true,"myRecordsDescription":"","workQueueDescription":"","searchDescription":"","hideRecordUserManagment":true,"searchLiensCheckout":false,"advancedSearchParameters":[{"type":"radio","name":"STARTS_WITH_YN","defaultValue":false,"options":[{"value":true,"label":"Starts with"},{"value":false,"label":"Contains"}]},{"type":"select","name":"STATUS","defaultValue":"ALL","label":"Status","options":[{"value":"ACTIVE_UNLAPSED","label":"Active (unlapsed)"},{"value":"ACTIVE_LAPSED_UNLAPSED","label":"Active (lapsed and unlapsed)"}]},{"type":"text","name":"EXCLUDE_VALUES","label":"Exclude Debtor Names (comma separated list of names to exclude)","defaultValue":""},{"type":"dateRange","name":"FILING_DATE","label":"Financing Statement Date","defaultValue":{"start":null,"end":null}},{"type":"dateRange","name":"LAPSE_DATE","label":"Lapse Date","defaultValue":{"start":null,"end":null}},{"type":"text","name":"CITY","label":"Debtor City","defaultValue":""}],"myRecordsFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Approved"},{"value":2,"label":"Pending Online Payment"},{"value":3,"label":"Pending Review"}]},{"type":"select","name":"TYPE","defaultValue":0,"label":"Lien Type","options":[{"value":0,"label":"All"},{"value":1,"label":"UCC"},{"value":2,"label":"EFS"},{"value":3,"label":"Title 71"}]}],"myWorkQueueFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Approved"},{"value":2,"label":"Pending Online Payment"},{"value":3,"label":"Pending Review"},{"value":4,"label":"Pending Print and Mail"},{"value":5,"label":"Rejected"},{"value":6,"label":"Draft"}]},{"type":"select","name":"TYPE","defaultValue":0,"label":"Lien Type","options":[{"value":0,"label":"All"},{"value":1,"label":"UCC"},{"value":2,"label":"EFS"},{"value":3,"label":"Title 71"}]}]},{"label":"Copy Request","component":"copies","parameter":"copies","sourceTypeId":2001,"myRecordsSearch":false,"myWorkQueueSearch":false,"disabled":false,"allowedRoutes":["/forms-manager/","/queue/","/forms/"]},{"label":"Trademark","component":"Trademark","parameter":"trademark","sourceTypeId":810,"showRequestCertificate":true,"searchMustHaveOneOf":["search","EXPIRATION_DATE","FILING_DATE"],"allowEmptySearchTerm":true,"requestCertificateAlternateLabel":"Request Information","fileAmendmentButtonLabel":"Filing Actions","advancedSearchParameters":[{"type":"radio","name":"QUERY_TYPE_ID","defaultValue":1010,"options":[{"value":1010,"label":"Starts with"},{"value":1011,"label":"Contains"},{"value":1012,"label":" Word Contains"}]},{"type":"checkbox","name":"OWNER_SEARCH_YN","defaultValue":false,"label":"Search owners"},{"type":"radio","name":"SERVICE_MARK_YN","label":"Mark Type","defaultValue":"","options":[{"value":"","label":"All Marks"},{"value":"Y","label":"Service Mark"},{"value":"N","label":"Trademark"}]},{"type":"serverSelect","name":"STATUS_ID","optionsSrc":"TYPE_V|TRADEMARK_STATUS_TYPE","label":"Status","placeholder":"All","defaultValue":"0"},{"type":"select","name":"DESIGN_TYPE_ID","options":[{"value":0,"label":"All"},{"value":990,"label":"Words Only"},{"value":991,"label":"Design Only"},{"value":992,"label":"Words and Design"}],"label":"Design Type","defaultValue":"0"},{"type":"dateRange","name":"FILING_DATE","label":"Registered Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}},{"type":"dateRange","name":"EXPIRATION_DATE","label":"Expiration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}}]},{"label":"Business Info Request","component":"InfoRequests","parameter":"info-request","sourceTypeId":167,"allowedRoutes":["/forms-manager/","/queue/","/forms/"]},{"label":"Data Requests","component":"DataRequests","parameter":"data-request","sourceTypeId":0,"allowedRoutes":["/forms-manager/"]},{"label":"CRA","component":"CRA","parameter":"cra","sourceTypeId":157,"myRecordsSearch":false,"searchPlaceholder":"Search by name or registered agent number","allowedRoutes":["/forms-manager/","/forms/","/records/","/queue/","/search/"],"allowEmptySearchTerm":true,"fileAmendmentButtonLabel":"Filing Actions","advancedSearchParameters":[{"type":"radio","name":"QUERY_TYPE_ID","defaultValue":1010,"options":[{"value":1010,"label":"Starts with"},{"value":1011,"label":"Contains"},{"value":1012,"label":" Word Contains"}]},{"type":"dateRange","name":"CRA_DATE","label":"Registration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}},{"type":"select","name":"STATUS_ID","label":"Status","defaultValue":0,"options":[{"value":0,"label":"All"},{"value":121,"label":"Active"},{"value":122,"label":"Inactive"}]},{"type":"select","name":"AGENT_TYPE_ID","label":"Agent Type","defaultValue":0,"options":[{"value":0,"label":"All"},{"value":460,"label":"Registered Agent"},{"value":461,"label":"Commercial Registered Agent"}]}]},{"label":"Farm Bill","component":"FarmBill","parameter":"farm-bill","path":"/lists/farm-bill","sourceTypeId":0,"myRecordsSearch":false,"allowedRules":["/search/"],"disabled":true,"searchDescription":"To perform a search, enter a debtor name. Your search results may include: exact debtor name, variations of that name and any filing that includes your search criteria. Punctuation is ignored.\n\nYou can click on \"Advanced\" to refine your search. Under “Advanced” you can search by crop, year, county and SSN/FEIN. As a registered Farm Bill Buyer with the Montana Secretary of State’s office it is important to maintain the confidentiality of the information contained within the Farm Bill Master List. The Farm Bill Master List reflects personal data, such as Social Security Numbers, which are a key piece of personal identifiable information to assist you in determining the existence of a lien against a specific debtor. The distribution of this information beyond its intended purpose is strictly prohibited.\n\nThe debtor's tax identification number has been hidden for confidentiality reasons. You may continue to search on a tax ID number and return debtors that match your search criteria. The SSN/FEIN must be entered without dashes or spaces.","searchMustHaveOneOf":["search","UCC_FARM_PRODUCT_ID","COUNTY"],"searchPlaceholder":"Search by debtor name","advancedSearchParameters":[{"type":"ServerMultiComplete","label":"Product code name(s)","name":"UCC_FARM_PRODUCT_ID","defaultValue":"","optionsSrc":"UCC_FARM_PRODUCT_V"},{"type":"MultiComplete","label":"Year or Range of Years","name":"YEAR_NUM","optionsSrc":"years","startYear":"1968","defaultValue":[],"preMergeOptions":[{"value":"ALL","label":"All"}]},{"type":"serverSelect","label":"State","name":"STATE","defaultValue":"MONTANA","optionsSrc":"STATE"},{"type":"ServerMultiComplete","label":"County","name":"COUNTY","defaultValue":[],"optionsSrc":"COUNTY","overrideSubOptionsSrcFromParameterName":"STATE"},{"type":"checkbox","name":"TIN_SEARCH_YN","defaultValue":false,"label":"Tax Identification Number Search"},{"type":"checkbox","name":"TIN_SORT_YN","defaultValue":false,"label":"Unique ID Sort"}]}],"SYSTEM_NICKNAME":"Online Services Portal","PAYMENT_METHODS":[{"type":"bypass"},{"type":"iTransact"}],"PAYMENT_ALLOW_AMEX":true,"SYSTEM_ID_LABEL":"System Id","DOUBLE_COLUMN_PUBLIC_LOGIN":true,"INTERNAL_USER_MANAGEMENT":true,"ALLOW_PUBLIC_JSON_IMPORT":false,"MAX_FILE_UPLOAD_SIZE":10000000,"REFUND_TEXT":"","RETURN_TO_HOME_ON_LOGOUT":true,"CURRENT_SOS_NAME":"Christi Jacobsen","LOGO_FILENAME":"mt-sos-logo.png","LOGO_ALT":"Christi Jacobsen, Montana Secretary of State","LOGO_FULL_WIDTH":true,"HOME_HIDE_AUTH_HINT":true,"HOME_TITLE":"Montana Secretary of State","CUSTOM_TAB_TITLE":"Official Montana","HOME_SUBTITLE":"Online Business Services","ENTITY_NAME_CONSENT_DESCRIPTION":"","ALLOW_USER_PROFILE_EDITING":true,"COMPARE_FOREIGN_NAME_IN_ENTITY_NAME_VALIDATION":true,"FOREIGN_NAME_FIELD_NAME":"KIMA_PARENT_NAME_INFO","LOGIN_TITLE":"Montana Secretary of State Online Filing Portal Login","PUBLIC_LOGIN_LABEL":"Username","REVERSE_LOGIN_COLUMNS":true,"LOGIN_SEAL_FILENAME":"seal_white.png","SEPARATE_USERNAME_AND_EMAIL":true,"CREATE_ACCOUNT_BUTTON_ALIGN_LEFT":true,"CREATE_ACCOUNT_BUTTON_TEXT":"CREATE AN ACCOUNT","PASSWORD_CUSTOM_ERROR_TEXT":"The password must meet all requirements","ACCOUNT_CREATED_MESSAGE":"Please check your email to verify your account to login and allow a few minutes for this message to arrive. Check your junk/spam folders if you do not find the email in your inbox.","PUBLIC_LOGIN_PLACEHOLDER":" ","DISABLE_DEFAULT_PAYMENT_RADIO":true,"CUSTOM_RESET_PASSWORD_ERROR_MESSAGE":"Username invalid - no account found","PUBLIC_LOGIN_CREATE_DESCRIPTION":"### Existing User:\n\n  - Enter your username and password to login.  \n\n\n  #### - OR -  \n\n\n\n  - Forgot password? Click 'Reset Password' and follow the prompts.\n  - Forgot username? Click 'Forgot Username' and follow the prompts.  \n\n\n  ### New User:\n  ","LOGIN_HELP_LINK":"https://sosmt.gov/business/how-do-i/","LOGIN_HELP_LINK_TEXT":"Need Help?","FORGOT_USERNAME_TEXT":"Forgot Username?","LOGIN_ACTIVE_DIRECTORY_TEXT":"State User Login","MULTIPLE_LOGIN_METHODS":true,"HAS_ACTIVE_DIRECTORY_LOGIN":true,"RESET_PASSWORD_WITH_USERNAME":true,"DOWNLOAD_LINK":true,"SHOW_USERNAME_ACCOUNT_CREATE":true,"SHOW_SCROLL_DOWN_ARROW":true,"SHOW_ADDRESS_ACCOUNT_CREATE":true,"TWO_COLUMN_ACCOUNT_CREATE":true,"RESET_PASSWORD_TIP":"A link to change your password has been sent to your email. Please allow a few minutes for this message to arrive. Please check your junk/spam folders if you do not find the email in your inbox.","FORGOT_PASSWORD_LINK_TEXT":"Reset Password","PHONE_NUMBER_OPTIONAL_ACCOUNT_CREATE":true,"SHOW_REQUIRED_INDICATOR_ACCOUNT_CREATE":true,"PASSWORD_REQUIREMENTS_ACCOUNT_CREATE":"\n    <ul>\n      <li>MUST contain at least 8 characters (12+ recommended)</li>\n      <li>MUST contain at least one uppercase letter.</li>\n      <li>MUST contain at least one lowercase letter.</li>\n      <li>MUST contain at least one number.</li>\n      <li>MUST contain at least one special character (!”#$%&'()*+,-./:;<=>?</li>\n    </ul>\n  ","ALLOW_CERTIFICATION_REQUEST":true,"ALLOW_PUBLIC_CERTIFICATE_REQUEST":true,"ALLOW_COPY_REQUEST":false,"ALLOW_CORRECTION_STYLING":true,"HIDE_DEPRECATION_WARNING":false,"AMEND_ROUTE_PUBLIC":true,"SEAL_FILENAME":"seal.png","SHOPPING_CART":true,"ALLOW_PAYMENT_UPDATE_WITH_EMPTY_CART":true,"RA_EMAIL":true,"RA_WEBSITE":true,"RA_NO_DEFAULT_TYPE":true,"RA_ADDRESS_LABEL":"Street Address","RA_TYPE_SELECTION_DEFAULT":true,"RA_DEFAULT_TYPE":"460","RA_OVERRIDE_TYPE_WITH_DEFAULT":true,"RA_PRINCIPAL_ADDRESS_AMS":true,"UPLOAD_AND_SUBMIT_HIDE_IF_ONE_OPTION":true,"PAYMENT_PROCESSING_MESSAGE":"Your payment is processing - Do not close your browser or click the back button","CHECKOUT_BUTTON_WHEN_PROCESSING_TEXT":"Processing","EFS_CROP_PICKER_NONE_LABEL":"Lien Duration","DISALLOWED_WIZARD_PIECES":["FormationLocale"],"REPEATER_SHOW_EDIT_BUTTON":true,"DATA_REQUEST_PAGE_TITLE":"Data Requests and Subscriptions","DATA_REQUEST_SIDEBAR_LABEL":"Data Requests & Subscriptions","LOGIN_REDIRECTS_TO_EPASS":false,"LOGIN_REDIRECTS_TO_ACTIVE_DIRECTORY":true,"LOGIN_ACTIVE_DIRECTORY_LINK":true,"FETCH_EDIT_USER_LINK":false,"LISTS_FETCH_AVAILABLE_LISTS":true,"POST_WIZARD_SUBMIT_REDIRECT_URL":"/","PIN_REQUEST_ATTESTATIONS":true,"PIN_REQUEST_DESCRIPTION":"Click **Request PIN** to have a new PIN sent to the account holder's email address on file.","OWNERSHIP_REQUEST_DESCRIPTION":"To become an **authorized user** of this record, a current **AUTHORIZED USER** will need to grant you access. To request access, click **Request Access** below.","PIN_REQUEST_SUCCESS_MESSAGE":"The PIN you have requested for this entity has been sent to the email associated with your user account.  You should receive the PIN in approximately 3-5 minutes, depending on your email service provider.","APOSTILLE_HEADER_LABEL":"Verification Information","APOSTILLE_NUMBER_LABEL":"Apostille/Authentication","APOSTILLE_CITY_STATE_OVERRIDE":"HELENA, MT","APOSTILLE_FILING_DATE_LABEL":"Issue Date","APOSTILLE_CITY_STATE_IN_CERTIFIED":true,"NOTARY_EXISTING_FILING":true,"ALLOW_REVOKE_OWN_ACCESS_ONLY":false,"HIDE_CANCEL_ON_ONETIME_DATA_REQUESTS":true,"DATA_REQUESTS_IN_SHOPPING_CART":true,"WQ_ALLOW_EDIT_PENDING_PAYMENT":true,"WQ_CONFIRM_ON_DELETE":true,"WQ_DELETE_CONFIRM_MESSAGE":"Deleting this filing will forfeit any money already paid to the Secretary of State. This action is permanent and cannot be undone, are you sure you would like to delete?","PASS_ITEM_GUIDS_ON_CHECKOUT":true,"FORM_REVISION_HISTORY":true,"CHECKOUT_DISCLAIMER":"By entering your credit card and/or checking account information you (i) state that **you are an authorized user** of the credit card and/or electronic check and that the associated information entered (e.g., account holder name, account number, billing address) is accurate, (ii) **you authorize payment processor to charge the amount you have requested** to your credit card and/or funding account, and (iii) **acknowledge if a charge is declined or reversed you may also be assessed a customary charge** by the payment processor for such transactions.","FARM_BILL_SEARCH_CONFIDENTIAL":"As a registered Farm Bill Buyer with the Montana Secretary of State’s office it is important to maintain the confidentiality of the information contained within the Farm Bill Master List. The Farm Bill Master List reflects personal data, such as Social Security Numbers, which are a key piece of personal identifiable information to assist you in determining the existence of a lien against a specific debtor. The distribution of this information beyond its intended purpose is strictly prohibited.\n\n**The debtor's tax identification number has been hidden for confidentiality reasons. You may continue to search on a tax ID number and return debtors that match your search criteria. The SSN/FEIN must be entered without dashes or spaces.  If you need access to the tax identification number to clearly identify the debtor, please contact the UCC unit at (406) 444-3665.**","VIEW_HISTORY_BUTTON_ALT_TEXT":"View Filings","WIZARD_ERROR_TITLE_MESSAGE":"Form Error","FARM_BILL_SEARCH_INTERACTIVE":true,"USE_FARM_BILL_API":true,"DISALLOW_ASSIGN_SELF_AS_RA":true,"DISALLOW_ASSIGN_SELF_AS_PRINCIPAL":true,"USE_TRADEMARK_OWNER_VALIDATION":true,"USE_ALTERNATIVE_FOREIGN_ADDRESS_LABELS":true,"MY_RECEIPTS_FILTER":[{"type":"dateRange","name":"DATE_RANGE","label":"Date range","defaultValue":{"start":null,"end":null}},{"type":"text","name":"REF_NUM","defaultValue":"","label":"Reference Number"},{"type":"text","name":"RECEIPT_NUM","defaultValue":"","label":"Receipt Id"},{"type":"text","name":"AMOUNT","defaultValue":"","label":"Amount"},{"type":"select","name":"TYPE","defaultValue":"","label":"Payment Type","options":[{"value":"","label":"All"},{"value":"CC","label":"Credit Card"},{"value":"Check","label":"Check"}]}],"MY_RECEIPTS_SHOW_IN_SIDEBAR":true,"SHOW_MY_RECEIPTS_HELPER_TEXT":true,"MY_RECEIPTS_HELPER_LABEL":"About Receipt Search","MY_RECEIPTS_HELPER_TEXT":"You can search for receipts based on their descriptions, including the items paid for on the receipt. Use the filters to search for or filter specific information.","FARM_BILL_SUBLINK":{"label":"Farm Bill","component":"FarmBill","parameter":"farm-bill","path":"/lists/farm-bill","sourceTypeId":0,"myRecordsSearch":false,"allowedRules":["/search/"],"disabled":true,"searchDescription":"To perform a search, enter a debtor name. Your search results may include: exact debtor name, variations of that name and any filing that includes your search criteria. Punctuation is ignored.\n\nYou can click on \"Advanced\" to refine your search. Under “Advanced” you can search by crop, year, county and SSN/FEIN. As a registered Farm Bill Buyer with the Montana Secretary of State’s office it is important to maintain the confidentiality of the information contained within the Farm Bill Master List. The Farm Bill Master List reflects personal data, such as Social Security Numbers, which are a key piece of personal identifiable information to assist you in determining the existence of a lien against a specific debtor. The distribution of this information beyond its intended purpose is strictly prohibited.\n\nThe debtor's tax identification number has been hidden for confidentiality reasons. You may continue to search on a tax ID number and return debtors that match your search criteria. The SSN/FEIN must be entered without dashes or spaces.","searchMustHaveOneOf":["search","UCC_FARM_PRODUCT_ID","COUNTY"],"searchPlaceholder":"Search by debtor name","advancedSearchParameters":[{"type":"ServerMultiComplete","label":"Product code name(s)","name":"UCC_FARM_PRODUCT_ID","defaultValue":"","optionsSrc":"UCC_FARM_PRODUCT_V"},{"type":"MultiComplete","label":"Year or Range of Years","name":"YEAR_NUM","optionsSrc":"years","startYear":"1968","defaultValue":[],"preMergeOptions":[{"value":"ALL","label":"All"}]},{"type":"serverSelect","label":"State","name":"STATE","defaultValue":"MONTANA","optionsSrc":"STATE"},{"type":"ServerMultiComplete","label":"County","name":"COUNTY","defaultValue":[],"optionsSrc":"COUNTY","overrideSubOptionsSrcFromParameterName":"STATE"},{"type":"checkbox","name":"TIN_SEARCH_YN","defaultValue":false,"label":"Tax Identification Number Search"},{"type":"checkbox","name":"TIN_SORT_YN","defaultValue":false,"label":"Unique ID Sort"}]},"ALLOW_ADDRESS_VALIDATION_BYPASS_OPTION":true,"DEFAULT_ADDRESS_VALIDATION_BYPASS_OPTION_CHECKED":true}).RD_TOOLTIP_CERTIFICATE;
	var RD_TOOLTIP_HISTORY = ({"NODE_ENV":"production","BUILD_DATE":"2025-08-27T15:15:31.687Z","BUILD_NUMBER":"Not Provided","GIT_VERSION":"v1.3.0-381-ga81e29b08","GIT_COMMIT_HASH":"a81e29b085c9268ffd96c78eb734365802722741","GIT_BRANCH":"beta","PUBLIC_URL":"","STATE_ABBR":"MT","STATE_NAME":"Montana","STATE_ORG_TITLE":"Secretary of State","LOGIN_HEADER_IMG_PATH":"","HOME_IMG_FILENAME":"montana.jpg","FAVICON_FILE_NAME":"favicon.ico","ALLOW_E_SIGN_ON_CORRECTIONS":true,"THIRD_PARTY_SIGNING_ALLOWED":false,"MY_ACCOUNT_SAVE_AND_CLOSE_BUTTON":true,"IE_DEPRECATED_MESSAGE":"Internet Explorer is not supported. Please select a supported browser below to access this website.","ADDITIONAL_ROUTES":{"dataRequests":true,"farmBill":true,"apostille":true,"externalHelp":"https://sosmt.gov/business/help-center/","systemAdministration":[{"title":"Saved Payments","parameter":"saved-payments","componentName":"SavedPayments"}]},"SUBROUTES":[{"label":"Business","component":"Business","parameter":"business","myWorkQueueSearch":false,"sourceTypeId":54,"searchMustHaveOneOf":["FILING_TYPE_ID","STATUS_ID","STATE","search"],"serverWebSearchDescription":true,"serverWorkQueueDescription":true,"serverMyRecordsDescription":true,"searchPlaceholder":"Search by name or filing number (X########)","allowEmptySearchTerm":true,"requestCertificateAlternateLabel":"Request Information","fileAmendmentButtonLabel":"Filing Actions","advancedSearchParameters":[{"type":"radio","name":"QUERY_TYPE_ID","defaultValue":1010,"options":[{"value":1010,"label":"Starts with"},{"value":1011,"label":"Contains"},{"value":1012,"label":" Word Contains"}]},{"type":"serverSelect","name":"FILING_TYPE_ID","optionsSrc":"FILING_TYPES","label":"Entity Type","placeholder":"All","defaultValue":"0"},{"type":"serverSelect","name":"FILING_SUBTYPE_ID","optionsSrc":"FILING_SUBTYPES","label":"Entity Subtype","overrideSubOptionsSrcFromParameterName":"FILING_TYPE_ID","placeholder":"All","defaultValue":"0"},{"type":"serverSelect","name":"STATUS_ID","optionsSrc":"FILING_STATUS_WITHOUT_ALL","label":"Status","placeholder":"All","defaultValue":"0"},{"type":"serverSelect","name":"STATE","optionsSrc":"STATE","label":"State","placeholder":"All","defaultValue":""},{"type":"serverSelect","name":"COUNTY","optionsSrc":"COUNTY_SUBOPTION","label":"County","overrideSubOptionsSrcFromParameterName":"STATE","placeholder":"All","defaultValue":""},{"type":"checkbox","name":"CRA_SEARCH_YN","defaultValue":false,"label":"Search by Registered Agent PID"},{"type":"dateRange","name":"FILING_DATE","label":"Registration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}},{"type":"dateRange","name":"EXPIRATION_DATE","label":"Expiration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}}],"myRecordsFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Active"},{"value":2,"label":"Inactive"},{"value":3,"label":"Pending"}]},{"type":"dateRange","name":"DATE_RANGE","label":"Date range","defaultValue":{"start":null,"end":null}}],"myWorkQueueFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Approved"},{"value":2,"label":"Pending Online Payment"},{"value":3,"label":"Pending Review"},{"value":4,"label":"Needs Correction"},{"value":5,"label":"Rejected"},{"value":6,"label":"Draft"}]},{"type":"dateRange","name":"DATE_RANGE","label":"Date range","defaultValue":{"start":null,"end":null}}]},{"label":"Notary","component":"Notary","parameter":"notary","sourceTypeId":850,"myWorkQueueSearch":false,"allowEmptySearchTerm":true,"requestCertificateAlternateLabel":"Download Certificate","fileAmendmentButtonLabel":"Filing Actions","hideNameRequestCertificate":true,"hideAddressRequestCertificate":true,"hideRecordUserManagment":true,"searchPlaceholder":"Search by name or commission number","searchMustHaveOneOf":["CITY","search","SERVICE_TYPE"],"advancedParametersStartOpen":true,"searchIsSortable":true,"advancedSearchParameters":[{"type":"radio","name":"STARTS_WITH_YN","defaultValue":false,"options":[{"value":true,"label":"Starts with"},{"value":false,"label":"Contains"}]},{"type":"checkbox","name":"ACTIVE_ONLY_YN","defaultValue":true,"label":"Active entities only"},{"type":"text","name":"CITY","defaultValue":"","label":"City"},{"type":"select","name":"SERVICE_TYPE","label":"Special Services Offered","defaultValue":0,"options":[{"value":0,"label":"(N/A)"},{"value":6165,"label":"In-Person Electronic Notarization (IPEN)"},{"value":6166,"label":"Remote Online Notarization (RON)"},{"value":6167,"label":"Mobile Notary Services"},{"value":6168,"label":"Remote Ink Notarization (RIN)"}]}]},{"label":"Apostille","component":"Apostille","parameter":"apostille","sourceTypeId":720,"myRecordsSearch":false,"myWorkQueueSearch":false,"disabled":false,"allowedRoutes":["/forms-manager/","/queue/","/forms/"]},{"label":"Liens","component":"UCC","parameter":"ucc","sourceTypeId":1999,"myRecordsSearch":true,"myWorkQueueSearch":true,"fileAmendmentButtonLabel":"Filing Actions","searchPlaceholder":"Search by name or file number","disabled":false,"serverWebSearchDescription":true,"myRecordsDescription":"","workQueueDescription":"","searchDescription":"","hideRecordUserManagment":true,"searchLiensCheckout":false,"advancedSearchParameters":[{"type":"radio","name":"STARTS_WITH_YN","defaultValue":false,"options":[{"value":true,"label":"Starts with"},{"value":false,"label":"Contains"}]},{"type":"select","name":"STATUS","defaultValue":"ALL","label":"Status","options":[{"value":"ACTIVE_UNLAPSED","label":"Active (unlapsed)"},{"value":"ACTIVE_LAPSED_UNLAPSED","label":"Active (lapsed and unlapsed)"}]},{"type":"text","name":"EXCLUDE_VALUES","label":"Exclude Debtor Names (comma separated list of names to exclude)","defaultValue":""},{"type":"dateRange","name":"FILING_DATE","label":"Financing Statement Date","defaultValue":{"start":null,"end":null}},{"type":"dateRange","name":"LAPSE_DATE","label":"Lapse Date","defaultValue":{"start":null,"end":null}},{"type":"text","name":"CITY","label":"Debtor City","defaultValue":""}],"myRecordsFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Approved"},{"value":2,"label":"Pending Online Payment"},{"value":3,"label":"Pending Review"}]},{"type":"select","name":"TYPE","defaultValue":0,"label":"Lien Type","options":[{"value":0,"label":"All"},{"value":1,"label":"UCC"},{"value":2,"label":"EFS"},{"value":3,"label":"Title 71"}]}],"myWorkQueueFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Approved"},{"value":2,"label":"Pending Online Payment"},{"value":3,"label":"Pending Review"},{"value":4,"label":"Pending Print and Mail"},{"value":5,"label":"Rejected"},{"value":6,"label":"Draft"}]},{"type":"select","name":"TYPE","defaultValue":0,"label":"Lien Type","options":[{"value":0,"label":"All"},{"value":1,"label":"UCC"},{"value":2,"label":"EFS"},{"value":3,"label":"Title 71"}]}]},{"label":"Copy Request","component":"copies","parameter":"copies","sourceTypeId":2001,"myRecordsSearch":false,"myWorkQueueSearch":false,"disabled":false,"allowedRoutes":["/forms-manager/","/queue/","/forms/"]},{"label":"Trademark","component":"Trademark","parameter":"trademark","sourceTypeId":810,"showRequestCertificate":true,"searchMustHaveOneOf":["search","EXPIRATION_DATE","FILING_DATE"],"allowEmptySearchTerm":true,"requestCertificateAlternateLabel":"Request Information","fileAmendmentButtonLabel":"Filing Actions","advancedSearchParameters":[{"type":"radio","name":"QUERY_TYPE_ID","defaultValue":1010,"options":[{"value":1010,"label":"Starts with"},{"value":1011,"label":"Contains"},{"value":1012,"label":" Word Contains"}]},{"type":"checkbox","name":"OWNER_SEARCH_YN","defaultValue":false,"label":"Search owners"},{"type":"radio","name":"SERVICE_MARK_YN","label":"Mark Type","defaultValue":"","options":[{"value":"","label":"All Marks"},{"value":"Y","label":"Service Mark"},{"value":"N","label":"Trademark"}]},{"type":"serverSelect","name":"STATUS_ID","optionsSrc":"TYPE_V|TRADEMARK_STATUS_TYPE","label":"Status","placeholder":"All","defaultValue":"0"},{"type":"select","name":"DESIGN_TYPE_ID","options":[{"value":0,"label":"All"},{"value":990,"label":"Words Only"},{"value":991,"label":"Design Only"},{"value":992,"label":"Words and Design"}],"label":"Design Type","defaultValue":"0"},{"type":"dateRange","name":"FILING_DATE","label":"Registered Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}},{"type":"dateRange","name":"EXPIRATION_DATE","label":"Expiration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}}]},{"label":"Business Info Request","component":"InfoRequests","parameter":"info-request","sourceTypeId":167,"allowedRoutes":["/forms-manager/","/queue/","/forms/"]},{"label":"Data Requests","component":"DataRequests","parameter":"data-request","sourceTypeId":0,"allowedRoutes":["/forms-manager/"]},{"label":"CRA","component":"CRA","parameter":"cra","sourceTypeId":157,"myRecordsSearch":false,"searchPlaceholder":"Search by name or registered agent number","allowedRoutes":["/forms-manager/","/forms/","/records/","/queue/","/search/"],"allowEmptySearchTerm":true,"fileAmendmentButtonLabel":"Filing Actions","advancedSearchParameters":[{"type":"radio","name":"QUERY_TYPE_ID","defaultValue":1010,"options":[{"value":1010,"label":"Starts with"},{"value":1011,"label":"Contains"},{"value":1012,"label":" Word Contains"}]},{"type":"dateRange","name":"CRA_DATE","label":"Registration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}},{"type":"select","name":"STATUS_ID","label":"Status","defaultValue":0,"options":[{"value":0,"label":"All"},{"value":121,"label":"Active"},{"value":122,"label":"Inactive"}]},{"type":"select","name":"AGENT_TYPE_ID","label":"Agent Type","defaultValue":0,"options":[{"value":0,"label":"All"},{"value":460,"label":"Registered Agent"},{"value":461,"label":"Commercial Registered Agent"}]}]},{"label":"Farm Bill","component":"FarmBill","parameter":"farm-bill","path":"/lists/farm-bill","sourceTypeId":0,"myRecordsSearch":false,"allowedRules":["/search/"],"disabled":true,"searchDescription":"To perform a search, enter a debtor name. Your search results may include: exact debtor name, variations of that name and any filing that includes your search criteria. Punctuation is ignored.\n\nYou can click on \"Advanced\" to refine your search. Under “Advanced” you can search by crop, year, county and SSN/FEIN. As a registered Farm Bill Buyer with the Montana Secretary of State’s office it is important to maintain the confidentiality of the information contained within the Farm Bill Master List. The Farm Bill Master List reflects personal data, such as Social Security Numbers, which are a key piece of personal identifiable information to assist you in determining the existence of a lien against a specific debtor. The distribution of this information beyond its intended purpose is strictly prohibited.\n\nThe debtor's tax identification number has been hidden for confidentiality reasons. You may continue to search on a tax ID number and return debtors that match your search criteria. The SSN/FEIN must be entered without dashes or spaces.","searchMustHaveOneOf":["search","UCC_FARM_PRODUCT_ID","COUNTY"],"searchPlaceholder":"Search by debtor name","advancedSearchParameters":[{"type":"ServerMultiComplete","label":"Product code name(s)","name":"UCC_FARM_PRODUCT_ID","defaultValue":"","optionsSrc":"UCC_FARM_PRODUCT_V"},{"type":"MultiComplete","label":"Year or Range of Years","name":"YEAR_NUM","optionsSrc":"years","startYear":"1968","defaultValue":[],"preMergeOptions":[{"value":"ALL","label":"All"}]},{"type":"serverSelect","label":"State","name":"STATE","defaultValue":"MONTANA","optionsSrc":"STATE"},{"type":"ServerMultiComplete","label":"County","name":"COUNTY","defaultValue":[],"optionsSrc":"COUNTY","overrideSubOptionsSrcFromParameterName":"STATE"},{"type":"checkbox","name":"TIN_SEARCH_YN","defaultValue":false,"label":"Tax Identification Number Search"},{"type":"checkbox","name":"TIN_SORT_YN","defaultValue":false,"label":"Unique ID Sort"}]}],"SYSTEM_NICKNAME":"Online Services Portal","PAYMENT_METHODS":[{"type":"bypass"},{"type":"iTransact"}],"PAYMENT_ALLOW_AMEX":true,"SYSTEM_ID_LABEL":"System Id","DOUBLE_COLUMN_PUBLIC_LOGIN":true,"INTERNAL_USER_MANAGEMENT":true,"ALLOW_PUBLIC_JSON_IMPORT":false,"MAX_FILE_UPLOAD_SIZE":10000000,"REFUND_TEXT":"","RETURN_TO_HOME_ON_LOGOUT":true,"CURRENT_SOS_NAME":"Christi Jacobsen","LOGO_FILENAME":"mt-sos-logo.png","LOGO_ALT":"Christi Jacobsen, Montana Secretary of State","LOGO_FULL_WIDTH":true,"HOME_HIDE_AUTH_HINT":true,"HOME_TITLE":"Montana Secretary of State","CUSTOM_TAB_TITLE":"Official Montana","HOME_SUBTITLE":"Online Business Services","ENTITY_NAME_CONSENT_DESCRIPTION":"","ALLOW_USER_PROFILE_EDITING":true,"COMPARE_FOREIGN_NAME_IN_ENTITY_NAME_VALIDATION":true,"FOREIGN_NAME_FIELD_NAME":"KIMA_PARENT_NAME_INFO","LOGIN_TITLE":"Montana Secretary of State Online Filing Portal Login","PUBLIC_LOGIN_LABEL":"Username","REVERSE_LOGIN_COLUMNS":true,"LOGIN_SEAL_FILENAME":"seal_white.png","SEPARATE_USERNAME_AND_EMAIL":true,"CREATE_ACCOUNT_BUTTON_ALIGN_LEFT":true,"CREATE_ACCOUNT_BUTTON_TEXT":"CREATE AN ACCOUNT","PASSWORD_CUSTOM_ERROR_TEXT":"The password must meet all requirements","ACCOUNT_CREATED_MESSAGE":"Please check your email to verify your account to login and allow a few minutes for this message to arrive. Check your junk/spam folders if you do not find the email in your inbox.","PUBLIC_LOGIN_PLACEHOLDER":" ","DISABLE_DEFAULT_PAYMENT_RADIO":true,"CUSTOM_RESET_PASSWORD_ERROR_MESSAGE":"Username invalid - no account found","PUBLIC_LOGIN_CREATE_DESCRIPTION":"### Existing User:\n\n  - Enter your username and password to login.  \n\n\n  #### - OR -  \n\n\n\n  - Forgot password? Click 'Reset Password' and follow the prompts.\n  - Forgot username? Click 'Forgot Username' and follow the prompts.  \n\n\n  ### New User:\n  ","LOGIN_HELP_LINK":"https://sosmt.gov/business/how-do-i/","LOGIN_HELP_LINK_TEXT":"Need Help?","FORGOT_USERNAME_TEXT":"Forgot Username?","LOGIN_ACTIVE_DIRECTORY_TEXT":"State User Login","MULTIPLE_LOGIN_METHODS":true,"HAS_ACTIVE_DIRECTORY_LOGIN":true,"RESET_PASSWORD_WITH_USERNAME":true,"DOWNLOAD_LINK":true,"SHOW_USERNAME_ACCOUNT_CREATE":true,"SHOW_SCROLL_DOWN_ARROW":true,"SHOW_ADDRESS_ACCOUNT_CREATE":true,"TWO_COLUMN_ACCOUNT_CREATE":true,"RESET_PASSWORD_TIP":"A link to change your password has been sent to your email. Please allow a few minutes for this message to arrive. Please check your junk/spam folders if you do not find the email in your inbox.","FORGOT_PASSWORD_LINK_TEXT":"Reset Password","PHONE_NUMBER_OPTIONAL_ACCOUNT_CREATE":true,"SHOW_REQUIRED_INDICATOR_ACCOUNT_CREATE":true,"PASSWORD_REQUIREMENTS_ACCOUNT_CREATE":"\n    <ul>\n      <li>MUST contain at least 8 characters (12+ recommended)</li>\n      <li>MUST contain at least one uppercase letter.</li>\n      <li>MUST contain at least one lowercase letter.</li>\n      <li>MUST contain at least one number.</li>\n      <li>MUST contain at least one special character (!”#$%&'()*+,-./:;<=>?</li>\n    </ul>\n  ","ALLOW_CERTIFICATION_REQUEST":true,"ALLOW_PUBLIC_CERTIFICATE_REQUEST":true,"ALLOW_COPY_REQUEST":false,"ALLOW_CORRECTION_STYLING":true,"HIDE_DEPRECATION_WARNING":false,"AMEND_ROUTE_PUBLIC":true,"SEAL_FILENAME":"seal.png","SHOPPING_CART":true,"ALLOW_PAYMENT_UPDATE_WITH_EMPTY_CART":true,"RA_EMAIL":true,"RA_WEBSITE":true,"RA_NO_DEFAULT_TYPE":true,"RA_ADDRESS_LABEL":"Street Address","RA_TYPE_SELECTION_DEFAULT":true,"RA_DEFAULT_TYPE":"460","RA_OVERRIDE_TYPE_WITH_DEFAULT":true,"RA_PRINCIPAL_ADDRESS_AMS":true,"UPLOAD_AND_SUBMIT_HIDE_IF_ONE_OPTION":true,"PAYMENT_PROCESSING_MESSAGE":"Your payment is processing - Do not close your browser or click the back button","CHECKOUT_BUTTON_WHEN_PROCESSING_TEXT":"Processing","EFS_CROP_PICKER_NONE_LABEL":"Lien Duration","DISALLOWED_WIZARD_PIECES":["FormationLocale"],"REPEATER_SHOW_EDIT_BUTTON":true,"DATA_REQUEST_PAGE_TITLE":"Data Requests and Subscriptions","DATA_REQUEST_SIDEBAR_LABEL":"Data Requests & Subscriptions","LOGIN_REDIRECTS_TO_EPASS":false,"LOGIN_REDIRECTS_TO_ACTIVE_DIRECTORY":true,"LOGIN_ACTIVE_DIRECTORY_LINK":true,"FETCH_EDIT_USER_LINK":false,"LISTS_FETCH_AVAILABLE_LISTS":true,"POST_WIZARD_SUBMIT_REDIRECT_URL":"/","PIN_REQUEST_ATTESTATIONS":true,"PIN_REQUEST_DESCRIPTION":"Click **Request PIN** to have a new PIN sent to the account holder's email address on file.","OWNERSHIP_REQUEST_DESCRIPTION":"To become an **authorized user** of this record, a current **AUTHORIZED USER** will need to grant you access. To request access, click **Request Access** below.","PIN_REQUEST_SUCCESS_MESSAGE":"The PIN you have requested for this entity has been sent to the email associated with your user account.  You should receive the PIN in approximately 3-5 minutes, depending on your email service provider.","APOSTILLE_HEADER_LABEL":"Verification Information","APOSTILLE_NUMBER_LABEL":"Apostille/Authentication","APOSTILLE_CITY_STATE_OVERRIDE":"HELENA, MT","APOSTILLE_FILING_DATE_LABEL":"Issue Date","APOSTILLE_CITY_STATE_IN_CERTIFIED":true,"NOTARY_EXISTING_FILING":true,"ALLOW_REVOKE_OWN_ACCESS_ONLY":false,"HIDE_CANCEL_ON_ONETIME_DATA_REQUESTS":true,"DATA_REQUESTS_IN_SHOPPING_CART":true,"WQ_ALLOW_EDIT_PENDING_PAYMENT":true,"WQ_CONFIRM_ON_DELETE":true,"WQ_DELETE_CONFIRM_MESSAGE":"Deleting this filing will forfeit any money already paid to the Secretary of State. This action is permanent and cannot be undone, are you sure you would like to delete?","PASS_ITEM_GUIDS_ON_CHECKOUT":true,"FORM_REVISION_HISTORY":true,"CHECKOUT_DISCLAIMER":"By entering your credit card and/or checking account information you (i) state that **you are an authorized user** of the credit card and/or electronic check and that the associated information entered (e.g., account holder name, account number, billing address) is accurate, (ii) **you authorize payment processor to charge the amount you have requested** to your credit card and/or funding account, and (iii) **acknowledge if a charge is declined or reversed you may also be assessed a customary charge** by the payment processor for such transactions.","FARM_BILL_SEARCH_CONFIDENTIAL":"As a registered Farm Bill Buyer with the Montana Secretary of State’s office it is important to maintain the confidentiality of the information contained within the Farm Bill Master List. The Farm Bill Master List reflects personal data, such as Social Security Numbers, which are a key piece of personal identifiable information to assist you in determining the existence of a lien against a specific debtor. The distribution of this information beyond its intended purpose is strictly prohibited.\n\n**The debtor's tax identification number has been hidden for confidentiality reasons. You may continue to search on a tax ID number and return debtors that match your search criteria. The SSN/FEIN must be entered without dashes or spaces.  If you need access to the tax identification number to clearly identify the debtor, please contact the UCC unit at (406) 444-3665.**","VIEW_HISTORY_BUTTON_ALT_TEXT":"View Filings","WIZARD_ERROR_TITLE_MESSAGE":"Form Error","FARM_BILL_SEARCH_INTERACTIVE":true,"USE_FARM_BILL_API":true,"DISALLOW_ASSIGN_SELF_AS_RA":true,"DISALLOW_ASSIGN_SELF_AS_PRINCIPAL":true,"USE_TRADEMARK_OWNER_VALIDATION":true,"USE_ALTERNATIVE_FOREIGN_ADDRESS_LABELS":true,"MY_RECEIPTS_FILTER":[{"type":"dateRange","name":"DATE_RANGE","label":"Date range","defaultValue":{"start":null,"end":null}},{"type":"text","name":"REF_NUM","defaultValue":"","label":"Reference Number"},{"type":"text","name":"RECEIPT_NUM","defaultValue":"","label":"Receipt Id"},{"type":"text","name":"AMOUNT","defaultValue":"","label":"Amount"},{"type":"select","name":"TYPE","defaultValue":"","label":"Payment Type","options":[{"value":"","label":"All"},{"value":"CC","label":"Credit Card"},{"value":"Check","label":"Check"}]}],"MY_RECEIPTS_SHOW_IN_SIDEBAR":true,"SHOW_MY_RECEIPTS_HELPER_TEXT":true,"MY_RECEIPTS_HELPER_LABEL":"About Receipt Search","MY_RECEIPTS_HELPER_TEXT":"You can search for receipts based on their descriptions, including the items paid for on the receipt. Use the filters to search for or filter specific information.","FARM_BILL_SUBLINK":{"label":"Farm Bill","component":"FarmBill","parameter":"farm-bill","path":"/lists/farm-bill","sourceTypeId":0,"myRecordsSearch":false,"allowedRules":["/search/"],"disabled":true,"searchDescription":"To perform a search, enter a debtor name. Your search results may include: exact debtor name, variations of that name and any filing that includes your search criteria. Punctuation is ignored.\n\nYou can click on \"Advanced\" to refine your search. Under “Advanced” you can search by crop, year, county and SSN/FEIN. As a registered Farm Bill Buyer with the Montana Secretary of State’s office it is important to maintain the confidentiality of the information contained within the Farm Bill Master List. The Farm Bill Master List reflects personal data, such as Social Security Numbers, which are a key piece of personal identifiable information to assist you in determining the existence of a lien against a specific debtor. The distribution of this information beyond its intended purpose is strictly prohibited.\n\nThe debtor's tax identification number has been hidden for confidentiality reasons. You may continue to search on a tax ID number and return debtors that match your search criteria. The SSN/FEIN must be entered without dashes or spaces.","searchMustHaveOneOf":["search","UCC_FARM_PRODUCT_ID","COUNTY"],"searchPlaceholder":"Search by debtor name","advancedSearchParameters":[{"type":"ServerMultiComplete","label":"Product code name(s)","name":"UCC_FARM_PRODUCT_ID","defaultValue":"","optionsSrc":"UCC_FARM_PRODUCT_V"},{"type":"MultiComplete","label":"Year or Range of Years","name":"YEAR_NUM","optionsSrc":"years","startYear":"1968","defaultValue":[],"preMergeOptions":[{"value":"ALL","label":"All"}]},{"type":"serverSelect","label":"State","name":"STATE","defaultValue":"MONTANA","optionsSrc":"STATE"},{"type":"ServerMultiComplete","label":"County","name":"COUNTY","defaultValue":[],"optionsSrc":"COUNTY","overrideSubOptionsSrcFromParameterName":"STATE"},{"type":"checkbox","name":"TIN_SEARCH_YN","defaultValue":false,"label":"Tax Identification Number Search"},{"type":"checkbox","name":"TIN_SORT_YN","defaultValue":false,"label":"Unique ID Sort"}]},"ALLOW_ADDRESS_VALIDATION_BYPASS_OPTION":true,"DEFAULT_ADDRESS_VALIDATION_BYPASS_OPTION_CHECKED":true}).RD_TOOLTIP_HISTORY;
	var RD_TOOLTIP_USER_ACCESS = ({"NODE_ENV":"production","BUILD_DATE":"2025-08-27T15:15:31.687Z","BUILD_NUMBER":"Not Provided","GIT_VERSION":"v1.3.0-381-ga81e29b08","GIT_COMMIT_HASH":"a81e29b085c9268ffd96c78eb734365802722741","GIT_BRANCH":"beta","PUBLIC_URL":"","STATE_ABBR":"MT","STATE_NAME":"Montana","STATE_ORG_TITLE":"Secretary of State","LOGIN_HEADER_IMG_PATH":"","HOME_IMG_FILENAME":"montana.jpg","FAVICON_FILE_NAME":"favicon.ico","ALLOW_E_SIGN_ON_CORRECTIONS":true,"THIRD_PARTY_SIGNING_ALLOWED":false,"MY_ACCOUNT_SAVE_AND_CLOSE_BUTTON":true,"IE_DEPRECATED_MESSAGE":"Internet Explorer is not supported. Please select a supported browser below to access this website.","ADDITIONAL_ROUTES":{"dataRequests":true,"farmBill":true,"apostille":true,"externalHelp":"https://sosmt.gov/business/help-center/","systemAdministration":[{"title":"Saved Payments","parameter":"saved-payments","componentName":"SavedPayments"}]},"SUBROUTES":[{"label":"Business","component":"Business","parameter":"business","myWorkQueueSearch":false,"sourceTypeId":54,"searchMustHaveOneOf":["FILING_TYPE_ID","STATUS_ID","STATE","search"],"serverWebSearchDescription":true,"serverWorkQueueDescription":true,"serverMyRecordsDescription":true,"searchPlaceholder":"Search by name or filing number (X########)","allowEmptySearchTerm":true,"requestCertificateAlternateLabel":"Request Information","fileAmendmentButtonLabel":"Filing Actions","advancedSearchParameters":[{"type":"radio","name":"QUERY_TYPE_ID","defaultValue":1010,"options":[{"value":1010,"label":"Starts with"},{"value":1011,"label":"Contains"},{"value":1012,"label":" Word Contains"}]},{"type":"serverSelect","name":"FILING_TYPE_ID","optionsSrc":"FILING_TYPES","label":"Entity Type","placeholder":"All","defaultValue":"0"},{"type":"serverSelect","name":"FILING_SUBTYPE_ID","optionsSrc":"FILING_SUBTYPES","label":"Entity Subtype","overrideSubOptionsSrcFromParameterName":"FILING_TYPE_ID","placeholder":"All","defaultValue":"0"},{"type":"serverSelect","name":"STATUS_ID","optionsSrc":"FILING_STATUS_WITHOUT_ALL","label":"Status","placeholder":"All","defaultValue":"0"},{"type":"serverSelect","name":"STATE","optionsSrc":"STATE","label":"State","placeholder":"All","defaultValue":""},{"type":"serverSelect","name":"COUNTY","optionsSrc":"COUNTY_SUBOPTION","label":"County","overrideSubOptionsSrcFromParameterName":"STATE","placeholder":"All","defaultValue":""},{"type":"checkbox","name":"CRA_SEARCH_YN","defaultValue":false,"label":"Search by Registered Agent PID"},{"type":"dateRange","name":"FILING_DATE","label":"Registration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}},{"type":"dateRange","name":"EXPIRATION_DATE","label":"Expiration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}}],"myRecordsFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Active"},{"value":2,"label":"Inactive"},{"value":3,"label":"Pending"}]},{"type":"dateRange","name":"DATE_RANGE","label":"Date range","defaultValue":{"start":null,"end":null}}],"myWorkQueueFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Approved"},{"value":2,"label":"Pending Online Payment"},{"value":3,"label":"Pending Review"},{"value":4,"label":"Needs Correction"},{"value":5,"label":"Rejected"},{"value":6,"label":"Draft"}]},{"type":"dateRange","name":"DATE_RANGE","label":"Date range","defaultValue":{"start":null,"end":null}}]},{"label":"Notary","component":"Notary","parameter":"notary","sourceTypeId":850,"myWorkQueueSearch":false,"allowEmptySearchTerm":true,"requestCertificateAlternateLabel":"Download Certificate","fileAmendmentButtonLabel":"Filing Actions","hideNameRequestCertificate":true,"hideAddressRequestCertificate":true,"hideRecordUserManagment":true,"searchPlaceholder":"Search by name or commission number","searchMustHaveOneOf":["CITY","search","SERVICE_TYPE"],"advancedParametersStartOpen":true,"searchIsSortable":true,"advancedSearchParameters":[{"type":"radio","name":"STARTS_WITH_YN","defaultValue":false,"options":[{"value":true,"label":"Starts with"},{"value":false,"label":"Contains"}]},{"type":"checkbox","name":"ACTIVE_ONLY_YN","defaultValue":true,"label":"Active entities only"},{"type":"text","name":"CITY","defaultValue":"","label":"City"},{"type":"select","name":"SERVICE_TYPE","label":"Special Services Offered","defaultValue":0,"options":[{"value":0,"label":"(N/A)"},{"value":6165,"label":"In-Person Electronic Notarization (IPEN)"},{"value":6166,"label":"Remote Online Notarization (RON)"},{"value":6167,"label":"Mobile Notary Services"},{"value":6168,"label":"Remote Ink Notarization (RIN)"}]}]},{"label":"Apostille","component":"Apostille","parameter":"apostille","sourceTypeId":720,"myRecordsSearch":false,"myWorkQueueSearch":false,"disabled":false,"allowedRoutes":["/forms-manager/","/queue/","/forms/"]},{"label":"Liens","component":"UCC","parameter":"ucc","sourceTypeId":1999,"myRecordsSearch":true,"myWorkQueueSearch":true,"fileAmendmentButtonLabel":"Filing Actions","searchPlaceholder":"Search by name or file number","disabled":false,"serverWebSearchDescription":true,"myRecordsDescription":"","workQueueDescription":"","searchDescription":"","hideRecordUserManagment":true,"searchLiensCheckout":false,"advancedSearchParameters":[{"type":"radio","name":"STARTS_WITH_YN","defaultValue":false,"options":[{"value":true,"label":"Starts with"},{"value":false,"label":"Contains"}]},{"type":"select","name":"STATUS","defaultValue":"ALL","label":"Status","options":[{"value":"ACTIVE_UNLAPSED","label":"Active (unlapsed)"},{"value":"ACTIVE_LAPSED_UNLAPSED","label":"Active (lapsed and unlapsed)"}]},{"type":"text","name":"EXCLUDE_VALUES","label":"Exclude Debtor Names (comma separated list of names to exclude)","defaultValue":""},{"type":"dateRange","name":"FILING_DATE","label":"Financing Statement Date","defaultValue":{"start":null,"end":null}},{"type":"dateRange","name":"LAPSE_DATE","label":"Lapse Date","defaultValue":{"start":null,"end":null}},{"type":"text","name":"CITY","label":"Debtor City","defaultValue":""}],"myRecordsFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Approved"},{"value":2,"label":"Pending Online Payment"},{"value":3,"label":"Pending Review"}]},{"type":"select","name":"TYPE","defaultValue":0,"label":"Lien Type","options":[{"value":0,"label":"All"},{"value":1,"label":"UCC"},{"value":2,"label":"EFS"},{"value":3,"label":"Title 71"}]}],"myWorkQueueFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Approved"},{"value":2,"label":"Pending Online Payment"},{"value":3,"label":"Pending Review"},{"value":4,"label":"Pending Print and Mail"},{"value":5,"label":"Rejected"},{"value":6,"label":"Draft"}]},{"type":"select","name":"TYPE","defaultValue":0,"label":"Lien Type","options":[{"value":0,"label":"All"},{"value":1,"label":"UCC"},{"value":2,"label":"EFS"},{"value":3,"label":"Title 71"}]}]},{"label":"Copy Request","component":"copies","parameter":"copies","sourceTypeId":2001,"myRecordsSearch":false,"myWorkQueueSearch":false,"disabled":false,"allowedRoutes":["/forms-manager/","/queue/","/forms/"]},{"label":"Trademark","component":"Trademark","parameter":"trademark","sourceTypeId":810,"showRequestCertificate":true,"searchMustHaveOneOf":["search","EXPIRATION_DATE","FILING_DATE"],"allowEmptySearchTerm":true,"requestCertificateAlternateLabel":"Request Information","fileAmendmentButtonLabel":"Filing Actions","advancedSearchParameters":[{"type":"radio","name":"QUERY_TYPE_ID","defaultValue":1010,"options":[{"value":1010,"label":"Starts with"},{"value":1011,"label":"Contains"},{"value":1012,"label":" Word Contains"}]},{"type":"checkbox","name":"OWNER_SEARCH_YN","defaultValue":false,"label":"Search owners"},{"type":"radio","name":"SERVICE_MARK_YN","label":"Mark Type","defaultValue":"","options":[{"value":"","label":"All Marks"},{"value":"Y","label":"Service Mark"},{"value":"N","label":"Trademark"}]},{"type":"serverSelect","name":"STATUS_ID","optionsSrc":"TYPE_V|TRADEMARK_STATUS_TYPE","label":"Status","placeholder":"All","defaultValue":"0"},{"type":"select","name":"DESIGN_TYPE_ID","options":[{"value":0,"label":"All"},{"value":990,"label":"Words Only"},{"value":991,"label":"Design Only"},{"value":992,"label":"Words and Design"}],"label":"Design Type","defaultValue":"0"},{"type":"dateRange","name":"FILING_DATE","label":"Registered Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}},{"type":"dateRange","name":"EXPIRATION_DATE","label":"Expiration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}}]},{"label":"Business Info Request","component":"InfoRequests","parameter":"info-request","sourceTypeId":167,"allowedRoutes":["/forms-manager/","/queue/","/forms/"]},{"label":"Data Requests","component":"DataRequests","parameter":"data-request","sourceTypeId":0,"allowedRoutes":["/forms-manager/"]},{"label":"CRA","component":"CRA","parameter":"cra","sourceTypeId":157,"myRecordsSearch":false,"searchPlaceholder":"Search by name or registered agent number","allowedRoutes":["/forms-manager/","/forms/","/records/","/queue/","/search/"],"allowEmptySearchTerm":true,"fileAmendmentButtonLabel":"Filing Actions","advancedSearchParameters":[{"type":"radio","name":"QUERY_TYPE_ID","defaultValue":1010,"options":[{"value":1010,"label":"Starts with"},{"value":1011,"label":"Contains"},{"value":1012,"label":" Word Contains"}]},{"type":"dateRange","name":"CRA_DATE","label":"Registration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}},{"type":"select","name":"STATUS_ID","label":"Status","defaultValue":0,"options":[{"value":0,"label":"All"},{"value":121,"label":"Active"},{"value":122,"label":"Inactive"}]},{"type":"select","name":"AGENT_TYPE_ID","label":"Agent Type","defaultValue":0,"options":[{"value":0,"label":"All"},{"value":460,"label":"Registered Agent"},{"value":461,"label":"Commercial Registered Agent"}]}]},{"label":"Farm Bill","component":"FarmBill","parameter":"farm-bill","path":"/lists/farm-bill","sourceTypeId":0,"myRecordsSearch":false,"allowedRules":["/search/"],"disabled":true,"searchDescription":"To perform a search, enter a debtor name. Your search results may include: exact debtor name, variations of that name and any filing that includes your search criteria. Punctuation is ignored.\n\nYou can click on \"Advanced\" to refine your search. Under “Advanced” you can search by crop, year, county and SSN/FEIN. As a registered Farm Bill Buyer with the Montana Secretary of State’s office it is important to maintain the confidentiality of the information contained within the Farm Bill Master List. The Farm Bill Master List reflects personal data, such as Social Security Numbers, which are a key piece of personal identifiable information to assist you in determining the existence of a lien against a specific debtor. The distribution of this information beyond its intended purpose is strictly prohibited.\n\nThe debtor's tax identification number has been hidden for confidentiality reasons. You may continue to search on a tax ID number and return debtors that match your search criteria. The SSN/FEIN must be entered without dashes or spaces.","searchMustHaveOneOf":["search","UCC_FARM_PRODUCT_ID","COUNTY"],"searchPlaceholder":"Search by debtor name","advancedSearchParameters":[{"type":"ServerMultiComplete","label":"Product code name(s)","name":"UCC_FARM_PRODUCT_ID","defaultValue":"","optionsSrc":"UCC_FARM_PRODUCT_V"},{"type":"MultiComplete","label":"Year or Range of Years","name":"YEAR_NUM","optionsSrc":"years","startYear":"1968","defaultValue":[],"preMergeOptions":[{"value":"ALL","label":"All"}]},{"type":"serverSelect","label":"State","name":"STATE","defaultValue":"MONTANA","optionsSrc":"STATE"},{"type":"ServerMultiComplete","label":"County","name":"COUNTY","defaultValue":[],"optionsSrc":"COUNTY","overrideSubOptionsSrcFromParameterName":"STATE"},{"type":"checkbox","name":"TIN_SEARCH_YN","defaultValue":false,"label":"Tax Identification Number Search"},{"type":"checkbox","name":"TIN_SORT_YN","defaultValue":false,"label":"Unique ID Sort"}]}],"SYSTEM_NICKNAME":"Online Services Portal","PAYMENT_METHODS":[{"type":"bypass"},{"type":"iTransact"}],"PAYMENT_ALLOW_AMEX":true,"SYSTEM_ID_LABEL":"System Id","DOUBLE_COLUMN_PUBLIC_LOGIN":true,"INTERNAL_USER_MANAGEMENT":true,"ALLOW_PUBLIC_JSON_IMPORT":false,"MAX_FILE_UPLOAD_SIZE":10000000,"REFUND_TEXT":"","RETURN_TO_HOME_ON_LOGOUT":true,"CURRENT_SOS_NAME":"Christi Jacobsen","LOGO_FILENAME":"mt-sos-logo.png","LOGO_ALT":"Christi Jacobsen, Montana Secretary of State","LOGO_FULL_WIDTH":true,"HOME_HIDE_AUTH_HINT":true,"HOME_TITLE":"Montana Secretary of State","CUSTOM_TAB_TITLE":"Official Montana","HOME_SUBTITLE":"Online Business Services","ENTITY_NAME_CONSENT_DESCRIPTION":"","ALLOW_USER_PROFILE_EDITING":true,"COMPARE_FOREIGN_NAME_IN_ENTITY_NAME_VALIDATION":true,"FOREIGN_NAME_FIELD_NAME":"KIMA_PARENT_NAME_INFO","LOGIN_TITLE":"Montana Secretary of State Online Filing Portal Login","PUBLIC_LOGIN_LABEL":"Username","REVERSE_LOGIN_COLUMNS":true,"LOGIN_SEAL_FILENAME":"seal_white.png","SEPARATE_USERNAME_AND_EMAIL":true,"CREATE_ACCOUNT_BUTTON_ALIGN_LEFT":true,"CREATE_ACCOUNT_BUTTON_TEXT":"CREATE AN ACCOUNT","PASSWORD_CUSTOM_ERROR_TEXT":"The password must meet all requirements","ACCOUNT_CREATED_MESSAGE":"Please check your email to verify your account to login and allow a few minutes for this message to arrive. Check your junk/spam folders if you do not find the email in your inbox.","PUBLIC_LOGIN_PLACEHOLDER":" ","DISABLE_DEFAULT_PAYMENT_RADIO":true,"CUSTOM_RESET_PASSWORD_ERROR_MESSAGE":"Username invalid - no account found","PUBLIC_LOGIN_CREATE_DESCRIPTION":"### Existing User:\n\n  - Enter your username and password to login.  \n\n\n  #### - OR -  \n\n\n\n  - Forgot password? Click 'Reset Password' and follow the prompts.\n  - Forgot username? Click 'Forgot Username' and follow the prompts.  \n\n\n  ### New User:\n  ","LOGIN_HELP_LINK":"https://sosmt.gov/business/how-do-i/","LOGIN_HELP_LINK_TEXT":"Need Help?","FORGOT_USERNAME_TEXT":"Forgot Username?","LOGIN_ACTIVE_DIRECTORY_TEXT":"State User Login","MULTIPLE_LOGIN_METHODS":true,"HAS_ACTIVE_DIRECTORY_LOGIN":true,"RESET_PASSWORD_WITH_USERNAME":true,"DOWNLOAD_LINK":true,"SHOW_USERNAME_ACCOUNT_CREATE":true,"SHOW_SCROLL_DOWN_ARROW":true,"SHOW_ADDRESS_ACCOUNT_CREATE":true,"TWO_COLUMN_ACCOUNT_CREATE":true,"RESET_PASSWORD_TIP":"A link to change your password has been sent to your email. Please allow a few minutes for this message to arrive. Please check your junk/spam folders if you do not find the email in your inbox.","FORGOT_PASSWORD_LINK_TEXT":"Reset Password","PHONE_NUMBER_OPTIONAL_ACCOUNT_CREATE":true,"SHOW_REQUIRED_INDICATOR_ACCOUNT_CREATE":true,"PASSWORD_REQUIREMENTS_ACCOUNT_CREATE":"\n    <ul>\n      <li>MUST contain at least 8 characters (12+ recommended)</li>\n      <li>MUST contain at least one uppercase letter.</li>\n      <li>MUST contain at least one lowercase letter.</li>\n      <li>MUST contain at least one number.</li>\n      <li>MUST contain at least one special character (!”#$%&'()*+,-./:;<=>?</li>\n    </ul>\n  ","ALLOW_CERTIFICATION_REQUEST":true,"ALLOW_PUBLIC_CERTIFICATE_REQUEST":true,"ALLOW_COPY_REQUEST":false,"ALLOW_CORRECTION_STYLING":true,"HIDE_DEPRECATION_WARNING":false,"AMEND_ROUTE_PUBLIC":true,"SEAL_FILENAME":"seal.png","SHOPPING_CART":true,"ALLOW_PAYMENT_UPDATE_WITH_EMPTY_CART":true,"RA_EMAIL":true,"RA_WEBSITE":true,"RA_NO_DEFAULT_TYPE":true,"RA_ADDRESS_LABEL":"Street Address","RA_TYPE_SELECTION_DEFAULT":true,"RA_DEFAULT_TYPE":"460","RA_OVERRIDE_TYPE_WITH_DEFAULT":true,"RA_PRINCIPAL_ADDRESS_AMS":true,"UPLOAD_AND_SUBMIT_HIDE_IF_ONE_OPTION":true,"PAYMENT_PROCESSING_MESSAGE":"Your payment is processing - Do not close your browser or click the back button","CHECKOUT_BUTTON_WHEN_PROCESSING_TEXT":"Processing","EFS_CROP_PICKER_NONE_LABEL":"Lien Duration","DISALLOWED_WIZARD_PIECES":["FormationLocale"],"REPEATER_SHOW_EDIT_BUTTON":true,"DATA_REQUEST_PAGE_TITLE":"Data Requests and Subscriptions","DATA_REQUEST_SIDEBAR_LABEL":"Data Requests & Subscriptions","LOGIN_REDIRECTS_TO_EPASS":false,"LOGIN_REDIRECTS_TO_ACTIVE_DIRECTORY":true,"LOGIN_ACTIVE_DIRECTORY_LINK":true,"FETCH_EDIT_USER_LINK":false,"LISTS_FETCH_AVAILABLE_LISTS":true,"POST_WIZARD_SUBMIT_REDIRECT_URL":"/","PIN_REQUEST_ATTESTATIONS":true,"PIN_REQUEST_DESCRIPTION":"Click **Request PIN** to have a new PIN sent to the account holder's email address on file.","OWNERSHIP_REQUEST_DESCRIPTION":"To become an **authorized user** of this record, a current **AUTHORIZED USER** will need to grant you access. To request access, click **Request Access** below.","PIN_REQUEST_SUCCESS_MESSAGE":"The PIN you have requested for this entity has been sent to the email associated with your user account.  You should receive the PIN in approximately 3-5 minutes, depending on your email service provider.","APOSTILLE_HEADER_LABEL":"Verification Information","APOSTILLE_NUMBER_LABEL":"Apostille/Authentication","APOSTILLE_CITY_STATE_OVERRIDE":"HELENA, MT","APOSTILLE_FILING_DATE_LABEL":"Issue Date","APOSTILLE_CITY_STATE_IN_CERTIFIED":true,"NOTARY_EXISTING_FILING":true,"ALLOW_REVOKE_OWN_ACCESS_ONLY":false,"HIDE_CANCEL_ON_ONETIME_DATA_REQUESTS":true,"DATA_REQUESTS_IN_SHOPPING_CART":true,"WQ_ALLOW_EDIT_PENDING_PAYMENT":true,"WQ_CONFIRM_ON_DELETE":true,"WQ_DELETE_CONFIRM_MESSAGE":"Deleting this filing will forfeit any money already paid to the Secretary of State. This action is permanent and cannot be undone, are you sure you would like to delete?","PASS_ITEM_GUIDS_ON_CHECKOUT":true,"FORM_REVISION_HISTORY":true,"CHECKOUT_DISCLAIMER":"By entering your credit card and/or checking account information you (i) state that **you are an authorized user** of the credit card and/or electronic check and that the associated information entered (e.g., account holder name, account number, billing address) is accurate, (ii) **you authorize payment processor to charge the amount you have requested** to your credit card and/or funding account, and (iii) **acknowledge if a charge is declined or reversed you may also be assessed a customary charge** by the payment processor for such transactions.","FARM_BILL_SEARCH_CONFIDENTIAL":"As a registered Farm Bill Buyer with the Montana Secretary of State’s office it is important to maintain the confidentiality of the information contained within the Farm Bill Master List. The Farm Bill Master List reflects personal data, such as Social Security Numbers, which are a key piece of personal identifiable information to assist you in determining the existence of a lien against a specific debtor. The distribution of this information beyond its intended purpose is strictly prohibited.\n\n**The debtor's tax identification number has been hidden for confidentiality reasons. You may continue to search on a tax ID number and return debtors that match your search criteria. The SSN/FEIN must be entered without dashes or spaces.  If you need access to the tax identification number to clearly identify the debtor, please contact the UCC unit at (406) 444-3665.**","VIEW_HISTORY_BUTTON_ALT_TEXT":"View Filings","WIZARD_ERROR_TITLE_MESSAGE":"Form Error","FARM_BILL_SEARCH_INTERACTIVE":true,"USE_FARM_BILL_API":true,"DISALLOW_ASSIGN_SELF_AS_RA":true,"DISALLOW_ASSIGN_SELF_AS_PRINCIPAL":true,"USE_TRADEMARK_OWNER_VALIDATION":true,"USE_ALTERNATIVE_FOREIGN_ADDRESS_LABELS":true,"MY_RECEIPTS_FILTER":[{"type":"dateRange","name":"DATE_RANGE","label":"Date range","defaultValue":{"start":null,"end":null}},{"type":"text","name":"REF_NUM","defaultValue":"","label":"Reference Number"},{"type":"text","name":"RECEIPT_NUM","defaultValue":"","label":"Receipt Id"},{"type":"text","name":"AMOUNT","defaultValue":"","label":"Amount"},{"type":"select","name":"TYPE","defaultValue":"","label":"Payment Type","options":[{"value":"","label":"All"},{"value":"CC","label":"Credit Card"},{"value":"Check","label":"Check"}]}],"MY_RECEIPTS_SHOW_IN_SIDEBAR":true,"SHOW_MY_RECEIPTS_HELPER_TEXT":true,"MY_RECEIPTS_HELPER_LABEL":"About Receipt Search","MY_RECEIPTS_HELPER_TEXT":"You can search for receipts based on their descriptions, including the items paid for on the receipt. Use the filters to search for or filter specific information.","FARM_BILL_SUBLINK":{"label":"Farm Bill","component":"FarmBill","parameter":"farm-bill","path":"/lists/farm-bill","sourceTypeId":0,"myRecordsSearch":false,"allowedRules":["/search/"],"disabled":true,"searchDescription":"To perform a search, enter a debtor name. Your search results may include: exact debtor name, variations of that name and any filing that includes your search criteria. Punctuation is ignored.\n\nYou can click on \"Advanced\" to refine your search. Under “Advanced” you can search by crop, year, county and SSN/FEIN. As a registered Farm Bill Buyer with the Montana Secretary of State’s office it is important to maintain the confidentiality of the information contained within the Farm Bill Master List. The Farm Bill Master List reflects personal data, such as Social Security Numbers, which are a key piece of personal identifiable information to assist you in determining the existence of a lien against a specific debtor. The distribution of this information beyond its intended purpose is strictly prohibited.\n\nThe debtor's tax identification number has been hidden for confidentiality reasons. You may continue to search on a tax ID number and return debtors that match your search criteria. The SSN/FEIN must be entered without dashes or spaces.","searchMustHaveOneOf":["search","UCC_FARM_PRODUCT_ID","COUNTY"],"searchPlaceholder":"Search by debtor name","advancedSearchParameters":[{"type":"ServerMultiComplete","label":"Product code name(s)","name":"UCC_FARM_PRODUCT_ID","defaultValue":"","optionsSrc":"UCC_FARM_PRODUCT_V"},{"type":"MultiComplete","label":"Year or Range of Years","name":"YEAR_NUM","optionsSrc":"years","startYear":"1968","defaultValue":[],"preMergeOptions":[{"value":"ALL","label":"All"}]},{"type":"serverSelect","label":"State","name":"STATE","defaultValue":"MONTANA","optionsSrc":"STATE"},{"type":"ServerMultiComplete","label":"County","name":"COUNTY","defaultValue":[],"optionsSrc":"COUNTY","overrideSubOptionsSrcFromParameterName":"STATE"},{"type":"checkbox","name":"TIN_SEARCH_YN","defaultValue":false,"label":"Tax Identification Number Search"},{"type":"checkbox","name":"TIN_SORT_YN","defaultValue":false,"label":"Unique ID Sort"}]},"ALLOW_ADDRESS_VALIDATION_BYPASS_OPTION":true,"DEFAULT_ADDRESS_VALIDATION_BYPASS_OPTION_CHECKED":true}).RD_TOOLTIP_USER_ACCESS;
	var REQUIRE_ANNUAL_REPORT_CONFIRMATION = ({"NODE_ENV":"production","BUILD_DATE":"2025-08-27T15:15:31.687Z","BUILD_NUMBER":"Not Provided","GIT_VERSION":"v1.3.0-381-ga81e29b08","GIT_COMMIT_HASH":"a81e29b085c9268ffd96c78eb734365802722741","GIT_BRANCH":"beta","PUBLIC_URL":"","STATE_ABBR":"MT","STATE_NAME":"Montana","STATE_ORG_TITLE":"Secretary of State","LOGIN_HEADER_IMG_PATH":"","HOME_IMG_FILENAME":"montana.jpg","FAVICON_FILE_NAME":"favicon.ico","ALLOW_E_SIGN_ON_CORRECTIONS":true,"THIRD_PARTY_SIGNING_ALLOWED":false,"MY_ACCOUNT_SAVE_AND_CLOSE_BUTTON":true,"IE_DEPRECATED_MESSAGE":"Internet Explorer is not supported. Please select a supported browser below to access this website.","ADDITIONAL_ROUTES":{"dataRequests":true,"farmBill":true,"apostille":true,"externalHelp":"https://sosmt.gov/business/help-center/","systemAdministration":[{"title":"Saved Payments","parameter":"saved-payments","componentName":"SavedPayments"}]},"SUBROUTES":[{"label":"Business","component":"Business","parameter":"business","myWorkQueueSearch":false,"sourceTypeId":54,"searchMustHaveOneOf":["FILING_TYPE_ID","STATUS_ID","STATE","search"],"serverWebSearchDescription":true,"serverWorkQueueDescription":true,"serverMyRecordsDescription":true,"searchPlaceholder":"Search by name or filing number (X########)","allowEmptySearchTerm":true,"requestCertificateAlternateLabel":"Request Information","fileAmendmentButtonLabel":"Filing Actions","advancedSearchParameters":[{"type":"radio","name":"QUERY_TYPE_ID","defaultValue":1010,"options":[{"value":1010,"label":"Starts with"},{"value":1011,"label":"Contains"},{"value":1012,"label":" Word Contains"}]},{"type":"serverSelect","name":"FILING_TYPE_ID","optionsSrc":"FILING_TYPES","label":"Entity Type","placeholder":"All","defaultValue":"0"},{"type":"serverSelect","name":"FILING_SUBTYPE_ID","optionsSrc":"FILING_SUBTYPES","label":"Entity Subtype","overrideSubOptionsSrcFromParameterName":"FILING_TYPE_ID","placeholder":"All","defaultValue":"0"},{"type":"serverSelect","name":"STATUS_ID","optionsSrc":"FILING_STATUS_WITHOUT_ALL","label":"Status","placeholder":"All","defaultValue":"0"},{"type":"serverSelect","name":"STATE","optionsSrc":"STATE","label":"State","placeholder":"All","defaultValue":""},{"type":"serverSelect","name":"COUNTY","optionsSrc":"COUNTY_SUBOPTION","label":"County","overrideSubOptionsSrcFromParameterName":"STATE","placeholder":"All","defaultValue":""},{"type":"checkbox","name":"CRA_SEARCH_YN","defaultValue":false,"label":"Search by Registered Agent PID"},{"type":"dateRange","name":"FILING_DATE","label":"Registration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}},{"type":"dateRange","name":"EXPIRATION_DATE","label":"Expiration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}}],"myRecordsFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Active"},{"value":2,"label":"Inactive"},{"value":3,"label":"Pending"}]},{"type":"dateRange","name":"DATE_RANGE","label":"Date range","defaultValue":{"start":null,"end":null}}],"myWorkQueueFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Approved"},{"value":2,"label":"Pending Online Payment"},{"value":3,"label":"Pending Review"},{"value":4,"label":"Needs Correction"},{"value":5,"label":"Rejected"},{"value":6,"label":"Draft"}]},{"type":"dateRange","name":"DATE_RANGE","label":"Date range","defaultValue":{"start":null,"end":null}}]},{"label":"Notary","component":"Notary","parameter":"notary","sourceTypeId":850,"myWorkQueueSearch":false,"allowEmptySearchTerm":true,"requestCertificateAlternateLabel":"Download Certificate","fileAmendmentButtonLabel":"Filing Actions","hideNameRequestCertificate":true,"hideAddressRequestCertificate":true,"hideRecordUserManagment":true,"searchPlaceholder":"Search by name or commission number","searchMustHaveOneOf":["CITY","search","SERVICE_TYPE"],"advancedParametersStartOpen":true,"searchIsSortable":true,"advancedSearchParameters":[{"type":"radio","name":"STARTS_WITH_YN","defaultValue":false,"options":[{"value":true,"label":"Starts with"},{"value":false,"label":"Contains"}]},{"type":"checkbox","name":"ACTIVE_ONLY_YN","defaultValue":true,"label":"Active entities only"},{"type":"text","name":"CITY","defaultValue":"","label":"City"},{"type":"select","name":"SERVICE_TYPE","label":"Special Services Offered","defaultValue":0,"options":[{"value":0,"label":"(N/A)"},{"value":6165,"label":"In-Person Electronic Notarization (IPEN)"},{"value":6166,"label":"Remote Online Notarization (RON)"},{"value":6167,"label":"Mobile Notary Services"},{"value":6168,"label":"Remote Ink Notarization (RIN)"}]}]},{"label":"Apostille","component":"Apostille","parameter":"apostille","sourceTypeId":720,"myRecordsSearch":false,"myWorkQueueSearch":false,"disabled":false,"allowedRoutes":["/forms-manager/","/queue/","/forms/"]},{"label":"Liens","component":"UCC","parameter":"ucc","sourceTypeId":1999,"myRecordsSearch":true,"myWorkQueueSearch":true,"fileAmendmentButtonLabel":"Filing Actions","searchPlaceholder":"Search by name or file number","disabled":false,"serverWebSearchDescription":true,"myRecordsDescription":"","workQueueDescription":"","searchDescription":"","hideRecordUserManagment":true,"searchLiensCheckout":false,"advancedSearchParameters":[{"type":"radio","name":"STARTS_WITH_YN","defaultValue":false,"options":[{"value":true,"label":"Starts with"},{"value":false,"label":"Contains"}]},{"type":"select","name":"STATUS","defaultValue":"ALL","label":"Status","options":[{"value":"ACTIVE_UNLAPSED","label":"Active (unlapsed)"},{"value":"ACTIVE_LAPSED_UNLAPSED","label":"Active (lapsed and unlapsed)"}]},{"type":"text","name":"EXCLUDE_VALUES","label":"Exclude Debtor Names (comma separated list of names to exclude)","defaultValue":""},{"type":"dateRange","name":"FILING_DATE","label":"Financing Statement Date","defaultValue":{"start":null,"end":null}},{"type":"dateRange","name":"LAPSE_DATE","label":"Lapse Date","defaultValue":{"start":null,"end":null}},{"type":"text","name":"CITY","label":"Debtor City","defaultValue":""}],"myRecordsFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Approved"},{"value":2,"label":"Pending Online Payment"},{"value":3,"label":"Pending Review"}]},{"type":"select","name":"TYPE","defaultValue":0,"label":"Lien Type","options":[{"value":0,"label":"All"},{"value":1,"label":"UCC"},{"value":2,"label":"EFS"},{"value":3,"label":"Title 71"}]}],"myWorkQueueFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Approved"},{"value":2,"label":"Pending Online Payment"},{"value":3,"label":"Pending Review"},{"value":4,"label":"Pending Print and Mail"},{"value":5,"label":"Rejected"},{"value":6,"label":"Draft"}]},{"type":"select","name":"TYPE","defaultValue":0,"label":"Lien Type","options":[{"value":0,"label":"All"},{"value":1,"label":"UCC"},{"value":2,"label":"EFS"},{"value":3,"label":"Title 71"}]}]},{"label":"Copy Request","component":"copies","parameter":"copies","sourceTypeId":2001,"myRecordsSearch":false,"myWorkQueueSearch":false,"disabled":false,"allowedRoutes":["/forms-manager/","/queue/","/forms/"]},{"label":"Trademark","component":"Trademark","parameter":"trademark","sourceTypeId":810,"showRequestCertificate":true,"searchMustHaveOneOf":["search","EXPIRATION_DATE","FILING_DATE"],"allowEmptySearchTerm":true,"requestCertificateAlternateLabel":"Request Information","fileAmendmentButtonLabel":"Filing Actions","advancedSearchParameters":[{"type":"radio","name":"QUERY_TYPE_ID","defaultValue":1010,"options":[{"value":1010,"label":"Starts with"},{"value":1011,"label":"Contains"},{"value":1012,"label":" Word Contains"}]},{"type":"checkbox","name":"OWNER_SEARCH_YN","defaultValue":false,"label":"Search owners"},{"type":"radio","name":"SERVICE_MARK_YN","label":"Mark Type","defaultValue":"","options":[{"value":"","label":"All Marks"},{"value":"Y","label":"Service Mark"},{"value":"N","label":"Trademark"}]},{"type":"serverSelect","name":"STATUS_ID","optionsSrc":"TYPE_V|TRADEMARK_STATUS_TYPE","label":"Status","placeholder":"All","defaultValue":"0"},{"type":"select","name":"DESIGN_TYPE_ID","options":[{"value":0,"label":"All"},{"value":990,"label":"Words Only"},{"value":991,"label":"Design Only"},{"value":992,"label":"Words and Design"}],"label":"Design Type","defaultValue":"0"},{"type":"dateRange","name":"FILING_DATE","label":"Registered Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}},{"type":"dateRange","name":"EXPIRATION_DATE","label":"Expiration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}}]},{"label":"Business Info Request","component":"InfoRequests","parameter":"info-request","sourceTypeId":167,"allowedRoutes":["/forms-manager/","/queue/","/forms/"]},{"label":"Data Requests","component":"DataRequests","parameter":"data-request","sourceTypeId":0,"allowedRoutes":["/forms-manager/"]},{"label":"CRA","component":"CRA","parameter":"cra","sourceTypeId":157,"myRecordsSearch":false,"searchPlaceholder":"Search by name or registered agent number","allowedRoutes":["/forms-manager/","/forms/","/records/","/queue/","/search/"],"allowEmptySearchTerm":true,"fileAmendmentButtonLabel":"Filing Actions","advancedSearchParameters":[{"type":"radio","name":"QUERY_TYPE_ID","defaultValue":1010,"options":[{"value":1010,"label":"Starts with"},{"value":1011,"label":"Contains"},{"value":1012,"label":" Word Contains"}]},{"type":"dateRange","name":"CRA_DATE","label":"Registration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}},{"type":"select","name":"STATUS_ID","label":"Status","defaultValue":0,"options":[{"value":0,"label":"All"},{"value":121,"label":"Active"},{"value":122,"label":"Inactive"}]},{"type":"select","name":"AGENT_TYPE_ID","label":"Agent Type","defaultValue":0,"options":[{"value":0,"label":"All"},{"value":460,"label":"Registered Agent"},{"value":461,"label":"Commercial Registered Agent"}]}]},{"label":"Farm Bill","component":"FarmBill","parameter":"farm-bill","path":"/lists/farm-bill","sourceTypeId":0,"myRecordsSearch":false,"allowedRules":["/search/"],"disabled":true,"searchDescription":"To perform a search, enter a debtor name. Your search results may include: exact debtor name, variations of that name and any filing that includes your search criteria. Punctuation is ignored.\n\nYou can click on \"Advanced\" to refine your search. Under “Advanced” you can search by crop, year, county and SSN/FEIN. As a registered Farm Bill Buyer with the Montana Secretary of State’s office it is important to maintain the confidentiality of the information contained within the Farm Bill Master List. The Farm Bill Master List reflects personal data, such as Social Security Numbers, which are a key piece of personal identifiable information to assist you in determining the existence of a lien against a specific debtor. The distribution of this information beyond its intended purpose is strictly prohibited.\n\nThe debtor's tax identification number has been hidden for confidentiality reasons. You may continue to search on a tax ID number and return debtors that match your search criteria. The SSN/FEIN must be entered without dashes or spaces.","searchMustHaveOneOf":["search","UCC_FARM_PRODUCT_ID","COUNTY"],"searchPlaceholder":"Search by debtor name","advancedSearchParameters":[{"type":"ServerMultiComplete","label":"Product code name(s)","name":"UCC_FARM_PRODUCT_ID","defaultValue":"","optionsSrc":"UCC_FARM_PRODUCT_V"},{"type":"MultiComplete","label":"Year or Range of Years","name":"YEAR_NUM","optionsSrc":"years","startYear":"1968","defaultValue":[],"preMergeOptions":[{"value":"ALL","label":"All"}]},{"type":"serverSelect","label":"State","name":"STATE","defaultValue":"MONTANA","optionsSrc":"STATE"},{"type":"ServerMultiComplete","label":"County","name":"COUNTY","defaultValue":[],"optionsSrc":"COUNTY","overrideSubOptionsSrcFromParameterName":"STATE"},{"type":"checkbox","name":"TIN_SEARCH_YN","defaultValue":false,"label":"Tax Identification Number Search"},{"type":"checkbox","name":"TIN_SORT_YN","defaultValue":false,"label":"Unique ID Sort"}]}],"SYSTEM_NICKNAME":"Online Services Portal","PAYMENT_METHODS":[{"type":"bypass"},{"type":"iTransact"}],"PAYMENT_ALLOW_AMEX":true,"SYSTEM_ID_LABEL":"System Id","DOUBLE_COLUMN_PUBLIC_LOGIN":true,"INTERNAL_USER_MANAGEMENT":true,"ALLOW_PUBLIC_JSON_IMPORT":false,"MAX_FILE_UPLOAD_SIZE":10000000,"REFUND_TEXT":"","RETURN_TO_HOME_ON_LOGOUT":true,"CURRENT_SOS_NAME":"Christi Jacobsen","LOGO_FILENAME":"mt-sos-logo.png","LOGO_ALT":"Christi Jacobsen, Montana Secretary of State","LOGO_FULL_WIDTH":true,"HOME_HIDE_AUTH_HINT":true,"HOME_TITLE":"Montana Secretary of State","CUSTOM_TAB_TITLE":"Official Montana","HOME_SUBTITLE":"Online Business Services","ENTITY_NAME_CONSENT_DESCRIPTION":"","ALLOW_USER_PROFILE_EDITING":true,"COMPARE_FOREIGN_NAME_IN_ENTITY_NAME_VALIDATION":true,"FOREIGN_NAME_FIELD_NAME":"KIMA_PARENT_NAME_INFO","LOGIN_TITLE":"Montana Secretary of State Online Filing Portal Login","PUBLIC_LOGIN_LABEL":"Username","REVERSE_LOGIN_COLUMNS":true,"LOGIN_SEAL_FILENAME":"seal_white.png","SEPARATE_USERNAME_AND_EMAIL":true,"CREATE_ACCOUNT_BUTTON_ALIGN_LEFT":true,"CREATE_ACCOUNT_BUTTON_TEXT":"CREATE AN ACCOUNT","PASSWORD_CUSTOM_ERROR_TEXT":"The password must meet all requirements","ACCOUNT_CREATED_MESSAGE":"Please check your email to verify your account to login and allow a few minutes for this message to arrive. Check your junk/spam folders if you do not find the email in your inbox.","PUBLIC_LOGIN_PLACEHOLDER":" ","DISABLE_DEFAULT_PAYMENT_RADIO":true,"CUSTOM_RESET_PASSWORD_ERROR_MESSAGE":"Username invalid - no account found","PUBLIC_LOGIN_CREATE_DESCRIPTION":"### Existing User:\n\n  - Enter your username and password to login.  \n\n\n  #### - OR -  \n\n\n\n  - Forgot password? Click 'Reset Password' and follow the prompts.\n  - Forgot username? Click 'Forgot Username' and follow the prompts.  \n\n\n  ### New User:\n  ","LOGIN_HELP_LINK":"https://sosmt.gov/business/how-do-i/","LOGIN_HELP_LINK_TEXT":"Need Help?","FORGOT_USERNAME_TEXT":"Forgot Username?","LOGIN_ACTIVE_DIRECTORY_TEXT":"State User Login","MULTIPLE_LOGIN_METHODS":true,"HAS_ACTIVE_DIRECTORY_LOGIN":true,"RESET_PASSWORD_WITH_USERNAME":true,"DOWNLOAD_LINK":true,"SHOW_USERNAME_ACCOUNT_CREATE":true,"SHOW_SCROLL_DOWN_ARROW":true,"SHOW_ADDRESS_ACCOUNT_CREATE":true,"TWO_COLUMN_ACCOUNT_CREATE":true,"RESET_PASSWORD_TIP":"A link to change your password has been sent to your email. Please allow a few minutes for this message to arrive. Please check your junk/spam folders if you do not find the email in your inbox.","FORGOT_PASSWORD_LINK_TEXT":"Reset Password","PHONE_NUMBER_OPTIONAL_ACCOUNT_CREATE":true,"SHOW_REQUIRED_INDICATOR_ACCOUNT_CREATE":true,"PASSWORD_REQUIREMENTS_ACCOUNT_CREATE":"\n    <ul>\n      <li>MUST contain at least 8 characters (12+ recommended)</li>\n      <li>MUST contain at least one uppercase letter.</li>\n      <li>MUST contain at least one lowercase letter.</li>\n      <li>MUST contain at least one number.</li>\n      <li>MUST contain at least one special character (!”#$%&'()*+,-./:;<=>?</li>\n    </ul>\n  ","ALLOW_CERTIFICATION_REQUEST":true,"ALLOW_PUBLIC_CERTIFICATE_REQUEST":true,"ALLOW_COPY_REQUEST":false,"ALLOW_CORRECTION_STYLING":true,"HIDE_DEPRECATION_WARNING":false,"AMEND_ROUTE_PUBLIC":true,"SEAL_FILENAME":"seal.png","SHOPPING_CART":true,"ALLOW_PAYMENT_UPDATE_WITH_EMPTY_CART":true,"RA_EMAIL":true,"RA_WEBSITE":true,"RA_NO_DEFAULT_TYPE":true,"RA_ADDRESS_LABEL":"Street Address","RA_TYPE_SELECTION_DEFAULT":true,"RA_DEFAULT_TYPE":"460","RA_OVERRIDE_TYPE_WITH_DEFAULT":true,"RA_PRINCIPAL_ADDRESS_AMS":true,"UPLOAD_AND_SUBMIT_HIDE_IF_ONE_OPTION":true,"PAYMENT_PROCESSING_MESSAGE":"Your payment is processing - Do not close your browser or click the back button","CHECKOUT_BUTTON_WHEN_PROCESSING_TEXT":"Processing","EFS_CROP_PICKER_NONE_LABEL":"Lien Duration","DISALLOWED_WIZARD_PIECES":["FormationLocale"],"REPEATER_SHOW_EDIT_BUTTON":true,"DATA_REQUEST_PAGE_TITLE":"Data Requests and Subscriptions","DATA_REQUEST_SIDEBAR_LABEL":"Data Requests & Subscriptions","LOGIN_REDIRECTS_TO_EPASS":false,"LOGIN_REDIRECTS_TO_ACTIVE_DIRECTORY":true,"LOGIN_ACTIVE_DIRECTORY_LINK":true,"FETCH_EDIT_USER_LINK":false,"LISTS_FETCH_AVAILABLE_LISTS":true,"POST_WIZARD_SUBMIT_REDIRECT_URL":"/","PIN_REQUEST_ATTESTATIONS":true,"PIN_REQUEST_DESCRIPTION":"Click **Request PIN** to have a new PIN sent to the account holder's email address on file.","OWNERSHIP_REQUEST_DESCRIPTION":"To become an **authorized user** of this record, a current **AUTHORIZED USER** will need to grant you access. To request access, click **Request Access** below.","PIN_REQUEST_SUCCESS_MESSAGE":"The PIN you have requested for this entity has been sent to the email associated with your user account.  You should receive the PIN in approximately 3-5 minutes, depending on your email service provider.","APOSTILLE_HEADER_LABEL":"Verification Information","APOSTILLE_NUMBER_LABEL":"Apostille/Authentication","APOSTILLE_CITY_STATE_OVERRIDE":"HELENA, MT","APOSTILLE_FILING_DATE_LABEL":"Issue Date","APOSTILLE_CITY_STATE_IN_CERTIFIED":true,"NOTARY_EXISTING_FILING":true,"ALLOW_REVOKE_OWN_ACCESS_ONLY":false,"HIDE_CANCEL_ON_ONETIME_DATA_REQUESTS":true,"DATA_REQUESTS_IN_SHOPPING_CART":true,"WQ_ALLOW_EDIT_PENDING_PAYMENT":true,"WQ_CONFIRM_ON_DELETE":true,"WQ_DELETE_CONFIRM_MESSAGE":"Deleting this filing will forfeit any money already paid to the Secretary of State. This action is permanent and cannot be undone, are you sure you would like to delete?","PASS_ITEM_GUIDS_ON_CHECKOUT":true,"FORM_REVISION_HISTORY":true,"CHECKOUT_DISCLAIMER":"By entering your credit card and/or checking account information you (i) state that **you are an authorized user** of the credit card and/or electronic check and that the associated information entered (e.g., account holder name, account number, billing address) is accurate, (ii) **you authorize payment processor to charge the amount you have requested** to your credit card and/or funding account, and (iii) **acknowledge if a charge is declined or reversed you may also be assessed a customary charge** by the payment processor for such transactions.","FARM_BILL_SEARCH_CONFIDENTIAL":"As a registered Farm Bill Buyer with the Montana Secretary of State’s office it is important to maintain the confidentiality of the information contained within the Farm Bill Master List. The Farm Bill Master List reflects personal data, such as Social Security Numbers, which are a key piece of personal identifiable information to assist you in determining the existence of a lien against a specific debtor. The distribution of this information beyond its intended purpose is strictly prohibited.\n\n**The debtor's tax identification number has been hidden for confidentiality reasons. You may continue to search on a tax ID number and return debtors that match your search criteria. The SSN/FEIN must be entered without dashes or spaces.  If you need access to the tax identification number to clearly identify the debtor, please contact the UCC unit at (406) 444-3665.**","VIEW_HISTORY_BUTTON_ALT_TEXT":"View Filings","WIZARD_ERROR_TITLE_MESSAGE":"Form Error","FARM_BILL_SEARCH_INTERACTIVE":true,"USE_FARM_BILL_API":true,"DISALLOW_ASSIGN_SELF_AS_RA":true,"DISALLOW_ASSIGN_SELF_AS_PRINCIPAL":true,"USE_TRADEMARK_OWNER_VALIDATION":true,"USE_ALTERNATIVE_FOREIGN_ADDRESS_LABELS":true,"MY_RECEIPTS_FILTER":[{"type":"dateRange","name":"DATE_RANGE","label":"Date range","defaultValue":{"start":null,"end":null}},{"type":"text","name":"REF_NUM","defaultValue":"","label":"Reference Number"},{"type":"text","name":"RECEIPT_NUM","defaultValue":"","label":"Receipt Id"},{"type":"text","name":"AMOUNT","defaultValue":"","label":"Amount"},{"type":"select","name":"TYPE","defaultValue":"","label":"Payment Type","options":[{"value":"","label":"All"},{"value":"CC","label":"Credit Card"},{"value":"Check","label":"Check"}]}],"MY_RECEIPTS_SHOW_IN_SIDEBAR":true,"SHOW_MY_RECEIPTS_HELPER_TEXT":true,"MY_RECEIPTS_HELPER_LABEL":"About Receipt Search","MY_RECEIPTS_HELPER_TEXT":"You can search for receipts based on their descriptions, including the items paid for on the receipt. Use the filters to search for or filter specific information.","FARM_BILL_SUBLINK":{"label":"Farm Bill","component":"FarmBill","parameter":"farm-bill","path":"/lists/farm-bill","sourceTypeId":0,"myRecordsSearch":false,"allowedRules":["/search/"],"disabled":true,"searchDescription":"To perform a search, enter a debtor name. Your search results may include: exact debtor name, variations of that name and any filing that includes your search criteria. Punctuation is ignored.\n\nYou can click on \"Advanced\" to refine your search. Under “Advanced” you can search by crop, year, county and SSN/FEIN. As a registered Farm Bill Buyer with the Montana Secretary of State’s office it is important to maintain the confidentiality of the information contained within the Farm Bill Master List. The Farm Bill Master List reflects personal data, such as Social Security Numbers, which are a key piece of personal identifiable information to assist you in determining the existence of a lien against a specific debtor. The distribution of this information beyond its intended purpose is strictly prohibited.\n\nThe debtor's tax identification number has been hidden for confidentiality reasons. You may continue to search on a tax ID number and return debtors that match your search criteria. The SSN/FEIN must be entered without dashes or spaces.","searchMustHaveOneOf":["search","UCC_FARM_PRODUCT_ID","COUNTY"],"searchPlaceholder":"Search by debtor name","advancedSearchParameters":[{"type":"ServerMultiComplete","label":"Product code name(s)","name":"UCC_FARM_PRODUCT_ID","defaultValue":"","optionsSrc":"UCC_FARM_PRODUCT_V"},{"type":"MultiComplete","label":"Year or Range of Years","name":"YEAR_NUM","optionsSrc":"years","startYear":"1968","defaultValue":[],"preMergeOptions":[{"value":"ALL","label":"All"}]},{"type":"serverSelect","label":"State","name":"STATE","defaultValue":"MONTANA","optionsSrc":"STATE"},{"type":"ServerMultiComplete","label":"County","name":"COUNTY","defaultValue":[],"optionsSrc":"COUNTY","overrideSubOptionsSrcFromParameterName":"STATE"},{"type":"checkbox","name":"TIN_SEARCH_YN","defaultValue":false,"label":"Tax Identification Number Search"},{"type":"checkbox","name":"TIN_SORT_YN","defaultValue":false,"label":"Unique ID Sort"}]},"ALLOW_ADDRESS_VALIDATION_BYPASS_OPTION":true,"DEFAULT_ADDRESS_VALIDATION_BYPASS_OPTION_CHECKED":true}).REQUIRE_ANNUAL_REPORT_CONFIRMATION;
	var AMENDMENTS_ALWAYS_ALLOWED_WHEN_LOGGED_IN = ({"NODE_ENV":"production","BUILD_DATE":"2025-08-27T15:15:31.687Z","BUILD_NUMBER":"Not Provided","GIT_VERSION":"v1.3.0-381-ga81e29b08","GIT_COMMIT_HASH":"a81e29b085c9268ffd96c78eb734365802722741","GIT_BRANCH":"beta","PUBLIC_URL":"","STATE_ABBR":"MT","STATE_NAME":"Montana","STATE_ORG_TITLE":"Secretary of State","LOGIN_HEADER_IMG_PATH":"","HOME_IMG_FILENAME":"montana.jpg","FAVICON_FILE_NAME":"favicon.ico","ALLOW_E_SIGN_ON_CORRECTIONS":true,"THIRD_PARTY_SIGNING_ALLOWED":false,"MY_ACCOUNT_SAVE_AND_CLOSE_BUTTON":true,"IE_DEPRECATED_MESSAGE":"Internet Explorer is not supported. Please select a supported browser below to access this website.","ADDITIONAL_ROUTES":{"dataRequests":true,"farmBill":true,"apostille":true,"externalHelp":"https://sosmt.gov/business/help-center/","systemAdministration":[{"title":"Saved Payments","parameter":"saved-payments","componentName":"SavedPayments"}]},"SUBROUTES":[{"label":"Business","component":"Business","parameter":"business","myWorkQueueSearch":false,"sourceTypeId":54,"searchMustHaveOneOf":["FILING_TYPE_ID","STATUS_ID","STATE","search"],"serverWebSearchDescription":true,"serverWorkQueueDescription":true,"serverMyRecordsDescription":true,"searchPlaceholder":"Search by name or filing number (X########)","allowEmptySearchTerm":true,"requestCertificateAlternateLabel":"Request Information","fileAmendmentButtonLabel":"Filing Actions","advancedSearchParameters":[{"type":"radio","name":"QUERY_TYPE_ID","defaultValue":1010,"options":[{"value":1010,"label":"Starts with"},{"value":1011,"label":"Contains"},{"value":1012,"label":" Word Contains"}]},{"type":"serverSelect","name":"FILING_TYPE_ID","optionsSrc":"FILING_TYPES","label":"Entity Type","placeholder":"All","defaultValue":"0"},{"type":"serverSelect","name":"FILING_SUBTYPE_ID","optionsSrc":"FILING_SUBTYPES","label":"Entity Subtype","overrideSubOptionsSrcFromParameterName":"FILING_TYPE_ID","placeholder":"All","defaultValue":"0"},{"type":"serverSelect","name":"STATUS_ID","optionsSrc":"FILING_STATUS_WITHOUT_ALL","label":"Status","placeholder":"All","defaultValue":"0"},{"type":"serverSelect","name":"STATE","optionsSrc":"STATE","label":"State","placeholder":"All","defaultValue":""},{"type":"serverSelect","name":"COUNTY","optionsSrc":"COUNTY_SUBOPTION","label":"County","overrideSubOptionsSrcFromParameterName":"STATE","placeholder":"All","defaultValue":""},{"type":"checkbox","name":"CRA_SEARCH_YN","defaultValue":false,"label":"Search by Registered Agent PID"},{"type":"dateRange","name":"FILING_DATE","label":"Registration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}},{"type":"dateRange","name":"EXPIRATION_DATE","label":"Expiration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}}],"myRecordsFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Active"},{"value":2,"label":"Inactive"},{"value":3,"label":"Pending"}]},{"type":"dateRange","name":"DATE_RANGE","label":"Date range","defaultValue":{"start":null,"end":null}}],"myWorkQueueFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Approved"},{"value":2,"label":"Pending Online Payment"},{"value":3,"label":"Pending Review"},{"value":4,"label":"Needs Correction"},{"value":5,"label":"Rejected"},{"value":6,"label":"Draft"}]},{"type":"dateRange","name":"DATE_RANGE","label":"Date range","defaultValue":{"start":null,"end":null}}]},{"label":"Notary","component":"Notary","parameter":"notary","sourceTypeId":850,"myWorkQueueSearch":false,"allowEmptySearchTerm":true,"requestCertificateAlternateLabel":"Download Certificate","fileAmendmentButtonLabel":"Filing Actions","hideNameRequestCertificate":true,"hideAddressRequestCertificate":true,"hideRecordUserManagment":true,"searchPlaceholder":"Search by name or commission number","searchMustHaveOneOf":["CITY","search","SERVICE_TYPE"],"advancedParametersStartOpen":true,"searchIsSortable":true,"advancedSearchParameters":[{"type":"radio","name":"STARTS_WITH_YN","defaultValue":false,"options":[{"value":true,"label":"Starts with"},{"value":false,"label":"Contains"}]},{"type":"checkbox","name":"ACTIVE_ONLY_YN","defaultValue":true,"label":"Active entities only"},{"type":"text","name":"CITY","defaultValue":"","label":"City"},{"type":"select","name":"SERVICE_TYPE","label":"Special Services Offered","defaultValue":0,"options":[{"value":0,"label":"(N/A)"},{"value":6165,"label":"In-Person Electronic Notarization (IPEN)"},{"value":6166,"label":"Remote Online Notarization (RON)"},{"value":6167,"label":"Mobile Notary Services"},{"value":6168,"label":"Remote Ink Notarization (RIN)"}]}]},{"label":"Apostille","component":"Apostille","parameter":"apostille","sourceTypeId":720,"myRecordsSearch":false,"myWorkQueueSearch":false,"disabled":false,"allowedRoutes":["/forms-manager/","/queue/","/forms/"]},{"label":"Liens","component":"UCC","parameter":"ucc","sourceTypeId":1999,"myRecordsSearch":true,"myWorkQueueSearch":true,"fileAmendmentButtonLabel":"Filing Actions","searchPlaceholder":"Search by name or file number","disabled":false,"serverWebSearchDescription":true,"myRecordsDescription":"","workQueueDescription":"","searchDescription":"","hideRecordUserManagment":true,"searchLiensCheckout":false,"advancedSearchParameters":[{"type":"radio","name":"STARTS_WITH_YN","defaultValue":false,"options":[{"value":true,"label":"Starts with"},{"value":false,"label":"Contains"}]},{"type":"select","name":"STATUS","defaultValue":"ALL","label":"Status","options":[{"value":"ACTIVE_UNLAPSED","label":"Active (unlapsed)"},{"value":"ACTIVE_LAPSED_UNLAPSED","label":"Active (lapsed and unlapsed)"}]},{"type":"text","name":"EXCLUDE_VALUES","label":"Exclude Debtor Names (comma separated list of names to exclude)","defaultValue":""},{"type":"dateRange","name":"FILING_DATE","label":"Financing Statement Date","defaultValue":{"start":null,"end":null}},{"type":"dateRange","name":"LAPSE_DATE","label":"Lapse Date","defaultValue":{"start":null,"end":null}},{"type":"text","name":"CITY","label":"Debtor City","defaultValue":""}],"myRecordsFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Approved"},{"value":2,"label":"Pending Online Payment"},{"value":3,"label":"Pending Review"}]},{"type":"select","name":"TYPE","defaultValue":0,"label":"Lien Type","options":[{"value":0,"label":"All"},{"value":1,"label":"UCC"},{"value":2,"label":"EFS"},{"value":3,"label":"Title 71"}]}],"myWorkQueueFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Approved"},{"value":2,"label":"Pending Online Payment"},{"value":3,"label":"Pending Review"},{"value":4,"label":"Pending Print and Mail"},{"value":5,"label":"Rejected"},{"value":6,"label":"Draft"}]},{"type":"select","name":"TYPE","defaultValue":0,"label":"Lien Type","options":[{"value":0,"label":"All"},{"value":1,"label":"UCC"},{"value":2,"label":"EFS"},{"value":3,"label":"Title 71"}]}]},{"label":"Copy Request","component":"copies","parameter":"copies","sourceTypeId":2001,"myRecordsSearch":false,"myWorkQueueSearch":false,"disabled":false,"allowedRoutes":["/forms-manager/","/queue/","/forms/"]},{"label":"Trademark","component":"Trademark","parameter":"trademark","sourceTypeId":810,"showRequestCertificate":true,"searchMustHaveOneOf":["search","EXPIRATION_DATE","FILING_DATE"],"allowEmptySearchTerm":true,"requestCertificateAlternateLabel":"Request Information","fileAmendmentButtonLabel":"Filing Actions","advancedSearchParameters":[{"type":"radio","name":"QUERY_TYPE_ID","defaultValue":1010,"options":[{"value":1010,"label":"Starts with"},{"value":1011,"label":"Contains"},{"value":1012,"label":" Word Contains"}]},{"type":"checkbox","name":"OWNER_SEARCH_YN","defaultValue":false,"label":"Search owners"},{"type":"radio","name":"SERVICE_MARK_YN","label":"Mark Type","defaultValue":"","options":[{"value":"","label":"All Marks"},{"value":"Y","label":"Service Mark"},{"value":"N","label":"Trademark"}]},{"type":"serverSelect","name":"STATUS_ID","optionsSrc":"TYPE_V|TRADEMARK_STATUS_TYPE","label":"Status","placeholder":"All","defaultValue":"0"},{"type":"select","name":"DESIGN_TYPE_ID","options":[{"value":0,"label":"All"},{"value":990,"label":"Words Only"},{"value":991,"label":"Design Only"},{"value":992,"label":"Words and Design"}],"label":"Design Type","defaultValue":"0"},{"type":"dateRange","name":"FILING_DATE","label":"Registered Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}},{"type":"dateRange","name":"EXPIRATION_DATE","label":"Expiration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}}]},{"label":"Business Info Request","component":"InfoRequests","parameter":"info-request","sourceTypeId":167,"allowedRoutes":["/forms-manager/","/queue/","/forms/"]},{"label":"Data Requests","component":"DataRequests","parameter":"data-request","sourceTypeId":0,"allowedRoutes":["/forms-manager/"]},{"label":"CRA","component":"CRA","parameter":"cra","sourceTypeId":157,"myRecordsSearch":false,"searchPlaceholder":"Search by name or registered agent number","allowedRoutes":["/forms-manager/","/forms/","/records/","/queue/","/search/"],"allowEmptySearchTerm":true,"fileAmendmentButtonLabel":"Filing Actions","advancedSearchParameters":[{"type":"radio","name":"QUERY_TYPE_ID","defaultValue":1010,"options":[{"value":1010,"label":"Starts with"},{"value":1011,"label":"Contains"},{"value":1012,"label":" Word Contains"}]},{"type":"dateRange","name":"CRA_DATE","label":"Registration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}},{"type":"select","name":"STATUS_ID","label":"Status","defaultValue":0,"options":[{"value":0,"label":"All"},{"value":121,"label":"Active"},{"value":122,"label":"Inactive"}]},{"type":"select","name":"AGENT_TYPE_ID","label":"Agent Type","defaultValue":0,"options":[{"value":0,"label":"All"},{"value":460,"label":"Registered Agent"},{"value":461,"label":"Commercial Registered Agent"}]}]},{"label":"Farm Bill","component":"FarmBill","parameter":"farm-bill","path":"/lists/farm-bill","sourceTypeId":0,"myRecordsSearch":false,"allowedRules":["/search/"],"disabled":true,"searchDescription":"To perform a search, enter a debtor name. Your search results may include: exact debtor name, variations of that name and any filing that includes your search criteria. Punctuation is ignored.\n\nYou can click on \"Advanced\" to refine your search. Under “Advanced” you can search by crop, year, county and SSN/FEIN. As a registered Farm Bill Buyer with the Montana Secretary of State’s office it is important to maintain the confidentiality of the information contained within the Farm Bill Master List. The Farm Bill Master List reflects personal data, such as Social Security Numbers, which are a key piece of personal identifiable information to assist you in determining the existence of a lien against a specific debtor. The distribution of this information beyond its intended purpose is strictly prohibited.\n\nThe debtor's tax identification number has been hidden for confidentiality reasons. You may continue to search on a tax ID number and return debtors that match your search criteria. The SSN/FEIN must be entered without dashes or spaces.","searchMustHaveOneOf":["search","UCC_FARM_PRODUCT_ID","COUNTY"],"searchPlaceholder":"Search by debtor name","advancedSearchParameters":[{"type":"ServerMultiComplete","label":"Product code name(s)","name":"UCC_FARM_PRODUCT_ID","defaultValue":"","optionsSrc":"UCC_FARM_PRODUCT_V"},{"type":"MultiComplete","label":"Year or Range of Years","name":"YEAR_NUM","optionsSrc":"years","startYear":"1968","defaultValue":[],"preMergeOptions":[{"value":"ALL","label":"All"}]},{"type":"serverSelect","label":"State","name":"STATE","defaultValue":"MONTANA","optionsSrc":"STATE"},{"type":"ServerMultiComplete","label":"County","name":"COUNTY","defaultValue":[],"optionsSrc":"COUNTY","overrideSubOptionsSrcFromParameterName":"STATE"},{"type":"checkbox","name":"TIN_SEARCH_YN","defaultValue":false,"label":"Tax Identification Number Search"},{"type":"checkbox","name":"TIN_SORT_YN","defaultValue":false,"label":"Unique ID Sort"}]}],"SYSTEM_NICKNAME":"Online Services Portal","PAYMENT_METHODS":[{"type":"bypass"},{"type":"iTransact"}],"PAYMENT_ALLOW_AMEX":true,"SYSTEM_ID_LABEL":"System Id","DOUBLE_COLUMN_PUBLIC_LOGIN":true,"INTERNAL_USER_MANAGEMENT":true,"ALLOW_PUBLIC_JSON_IMPORT":false,"MAX_FILE_UPLOAD_SIZE":10000000,"REFUND_TEXT":"","RETURN_TO_HOME_ON_LOGOUT":true,"CURRENT_SOS_NAME":"Christi Jacobsen","LOGO_FILENAME":"mt-sos-logo.png","LOGO_ALT":"Christi Jacobsen, Montana Secretary of State","LOGO_FULL_WIDTH":true,"HOME_HIDE_AUTH_HINT":true,"HOME_TITLE":"Montana Secretary of State","CUSTOM_TAB_TITLE":"Official Montana","HOME_SUBTITLE":"Online Business Services","ENTITY_NAME_CONSENT_DESCRIPTION":"","ALLOW_USER_PROFILE_EDITING":true,"COMPARE_FOREIGN_NAME_IN_ENTITY_NAME_VALIDATION":true,"FOREIGN_NAME_FIELD_NAME":"KIMA_PARENT_NAME_INFO","LOGIN_TITLE":"Montana Secretary of State Online Filing Portal Login","PUBLIC_LOGIN_LABEL":"Username","REVERSE_LOGIN_COLUMNS":true,"LOGIN_SEAL_FILENAME":"seal_white.png","SEPARATE_USERNAME_AND_EMAIL":true,"CREATE_ACCOUNT_BUTTON_ALIGN_LEFT":true,"CREATE_ACCOUNT_BUTTON_TEXT":"CREATE AN ACCOUNT","PASSWORD_CUSTOM_ERROR_TEXT":"The password must meet all requirements","ACCOUNT_CREATED_MESSAGE":"Please check your email to verify your account to login and allow a few minutes for this message to arrive. Check your junk/spam folders if you do not find the email in your inbox.","PUBLIC_LOGIN_PLACEHOLDER":" ","DISABLE_DEFAULT_PAYMENT_RADIO":true,"CUSTOM_RESET_PASSWORD_ERROR_MESSAGE":"Username invalid - no account found","PUBLIC_LOGIN_CREATE_DESCRIPTION":"### Existing User:\n\n  - Enter your username and password to login.  \n\n\n  #### - OR -  \n\n\n\n  - Forgot password? Click 'Reset Password' and follow the prompts.\n  - Forgot username? Click 'Forgot Username' and follow the prompts.  \n\n\n  ### New User:\n  ","LOGIN_HELP_LINK":"https://sosmt.gov/business/how-do-i/","LOGIN_HELP_LINK_TEXT":"Need Help?","FORGOT_USERNAME_TEXT":"Forgot Username?","LOGIN_ACTIVE_DIRECTORY_TEXT":"State User Login","MULTIPLE_LOGIN_METHODS":true,"HAS_ACTIVE_DIRECTORY_LOGIN":true,"RESET_PASSWORD_WITH_USERNAME":true,"DOWNLOAD_LINK":true,"SHOW_USERNAME_ACCOUNT_CREATE":true,"SHOW_SCROLL_DOWN_ARROW":true,"SHOW_ADDRESS_ACCOUNT_CREATE":true,"TWO_COLUMN_ACCOUNT_CREATE":true,"RESET_PASSWORD_TIP":"A link to change your password has been sent to your email. Please allow a few minutes for this message to arrive. Please check your junk/spam folders if you do not find the email in your inbox.","FORGOT_PASSWORD_LINK_TEXT":"Reset Password","PHONE_NUMBER_OPTIONAL_ACCOUNT_CREATE":true,"SHOW_REQUIRED_INDICATOR_ACCOUNT_CREATE":true,"PASSWORD_REQUIREMENTS_ACCOUNT_CREATE":"\n    <ul>\n      <li>MUST contain at least 8 characters (12+ recommended)</li>\n      <li>MUST contain at least one uppercase letter.</li>\n      <li>MUST contain at least one lowercase letter.</li>\n      <li>MUST contain at least one number.</li>\n      <li>MUST contain at least one special character (!”#$%&'()*+,-./:;<=>?</li>\n    </ul>\n  ","ALLOW_CERTIFICATION_REQUEST":true,"ALLOW_PUBLIC_CERTIFICATE_REQUEST":true,"ALLOW_COPY_REQUEST":false,"ALLOW_CORRECTION_STYLING":true,"HIDE_DEPRECATION_WARNING":false,"AMEND_ROUTE_PUBLIC":true,"SEAL_FILENAME":"seal.png","SHOPPING_CART":true,"ALLOW_PAYMENT_UPDATE_WITH_EMPTY_CART":true,"RA_EMAIL":true,"RA_WEBSITE":true,"RA_NO_DEFAULT_TYPE":true,"RA_ADDRESS_LABEL":"Street Address","RA_TYPE_SELECTION_DEFAULT":true,"RA_DEFAULT_TYPE":"460","RA_OVERRIDE_TYPE_WITH_DEFAULT":true,"RA_PRINCIPAL_ADDRESS_AMS":true,"UPLOAD_AND_SUBMIT_HIDE_IF_ONE_OPTION":true,"PAYMENT_PROCESSING_MESSAGE":"Your payment is processing - Do not close your browser or click the back button","CHECKOUT_BUTTON_WHEN_PROCESSING_TEXT":"Processing","EFS_CROP_PICKER_NONE_LABEL":"Lien Duration","DISALLOWED_WIZARD_PIECES":["FormationLocale"],"REPEATER_SHOW_EDIT_BUTTON":true,"DATA_REQUEST_PAGE_TITLE":"Data Requests and Subscriptions","DATA_REQUEST_SIDEBAR_LABEL":"Data Requests & Subscriptions","LOGIN_REDIRECTS_TO_EPASS":false,"LOGIN_REDIRECTS_TO_ACTIVE_DIRECTORY":true,"LOGIN_ACTIVE_DIRECTORY_LINK":true,"FETCH_EDIT_USER_LINK":false,"LISTS_FETCH_AVAILABLE_LISTS":true,"POST_WIZARD_SUBMIT_REDIRECT_URL":"/","PIN_REQUEST_ATTESTATIONS":true,"PIN_REQUEST_DESCRIPTION":"Click **Request PIN** to have a new PIN sent to the account holder's email address on file.","OWNERSHIP_REQUEST_DESCRIPTION":"To become an **authorized user** of this record, a current **AUTHORIZED USER** will need to grant you access. To request access, click **Request Access** below.","PIN_REQUEST_SUCCESS_MESSAGE":"The PIN you have requested for this entity has been sent to the email associated with your user account.  You should receive the PIN in approximately 3-5 minutes, depending on your email service provider.","APOSTILLE_HEADER_LABEL":"Verification Information","APOSTILLE_NUMBER_LABEL":"Apostille/Authentication","APOSTILLE_CITY_STATE_OVERRIDE":"HELENA, MT","APOSTILLE_FILING_DATE_LABEL":"Issue Date","APOSTILLE_CITY_STATE_IN_CERTIFIED":true,"NOTARY_EXISTING_FILING":true,"ALLOW_REVOKE_OWN_ACCESS_ONLY":false,"HIDE_CANCEL_ON_ONETIME_DATA_REQUESTS":true,"DATA_REQUESTS_IN_SHOPPING_CART":true,"WQ_ALLOW_EDIT_PENDING_PAYMENT":true,"WQ_CONFIRM_ON_DELETE":true,"WQ_DELETE_CONFIRM_MESSAGE":"Deleting this filing will forfeit any money already paid to the Secretary of State. This action is permanent and cannot be undone, are you sure you would like to delete?","PASS_ITEM_GUIDS_ON_CHECKOUT":true,"FORM_REVISION_HISTORY":true,"CHECKOUT_DISCLAIMER":"By entering your credit card and/or checking account information you (i) state that **you are an authorized user** of the credit card and/or electronic check and that the associated information entered (e.g., account holder name, account number, billing address) is accurate, (ii) **you authorize payment processor to charge the amount you have requested** to your credit card and/or funding account, and (iii) **acknowledge if a charge is declined or reversed you may also be assessed a customary charge** by the payment processor for such transactions.","FARM_BILL_SEARCH_CONFIDENTIAL":"As a registered Farm Bill Buyer with the Montana Secretary of State’s office it is important to maintain the confidentiality of the information contained within the Farm Bill Master List. The Farm Bill Master List reflects personal data, such as Social Security Numbers, which are a key piece of personal identifiable information to assist you in determining the existence of a lien against a specific debtor. The distribution of this information beyond its intended purpose is strictly prohibited.\n\n**The debtor's tax identification number has been hidden for confidentiality reasons. You may continue to search on a tax ID number and return debtors that match your search criteria. The SSN/FEIN must be entered without dashes or spaces.  If you need access to the tax identification number to clearly identify the debtor, please contact the UCC unit at (406) 444-3665.**","VIEW_HISTORY_BUTTON_ALT_TEXT":"View Filings","WIZARD_ERROR_TITLE_MESSAGE":"Form Error","FARM_BILL_SEARCH_INTERACTIVE":true,"USE_FARM_BILL_API":true,"DISALLOW_ASSIGN_SELF_AS_RA":true,"DISALLOW_ASSIGN_SELF_AS_PRINCIPAL":true,"USE_TRADEMARK_OWNER_VALIDATION":true,"USE_ALTERNATIVE_FOREIGN_ADDRESS_LABELS":true,"MY_RECEIPTS_FILTER":[{"type":"dateRange","name":"DATE_RANGE","label":"Date range","defaultValue":{"start":null,"end":null}},{"type":"text","name":"REF_NUM","defaultValue":"","label":"Reference Number"},{"type":"text","name":"RECEIPT_NUM","defaultValue":"","label":"Receipt Id"},{"type":"text","name":"AMOUNT","defaultValue":"","label":"Amount"},{"type":"select","name":"TYPE","defaultValue":"","label":"Payment Type","options":[{"value":"","label":"All"},{"value":"CC","label":"Credit Card"},{"value":"Check","label":"Check"}]}],"MY_RECEIPTS_SHOW_IN_SIDEBAR":true,"SHOW_MY_RECEIPTS_HELPER_TEXT":true,"MY_RECEIPTS_HELPER_LABEL":"About Receipt Search","MY_RECEIPTS_HELPER_TEXT":"You can search for receipts based on their descriptions, including the items paid for on the receipt. Use the filters to search for or filter specific information.","FARM_BILL_SUBLINK":{"label":"Farm Bill","component":"FarmBill","parameter":"farm-bill","path":"/lists/farm-bill","sourceTypeId":0,"myRecordsSearch":false,"allowedRules":["/search/"],"disabled":true,"searchDescription":"To perform a search, enter a debtor name. Your search results may include: exact debtor name, variations of that name and any filing that includes your search criteria. Punctuation is ignored.\n\nYou can click on \"Advanced\" to refine your search. Under “Advanced” you can search by crop, year, county and SSN/FEIN. As a registered Farm Bill Buyer with the Montana Secretary of State’s office it is important to maintain the confidentiality of the information contained within the Farm Bill Master List. The Farm Bill Master List reflects personal data, such as Social Security Numbers, which are a key piece of personal identifiable information to assist you in determining the existence of a lien against a specific debtor. The distribution of this information beyond its intended purpose is strictly prohibited.\n\nThe debtor's tax identification number has been hidden for confidentiality reasons. You may continue to search on a tax ID number and return debtors that match your search criteria. The SSN/FEIN must be entered without dashes or spaces.","searchMustHaveOneOf":["search","UCC_FARM_PRODUCT_ID","COUNTY"],"searchPlaceholder":"Search by debtor name","advancedSearchParameters":[{"type":"ServerMultiComplete","label":"Product code name(s)","name":"UCC_FARM_PRODUCT_ID","defaultValue":"","optionsSrc":"UCC_FARM_PRODUCT_V"},{"type":"MultiComplete","label":"Year or Range of Years","name":"YEAR_NUM","optionsSrc":"years","startYear":"1968","defaultValue":[],"preMergeOptions":[{"value":"ALL","label":"All"}]},{"type":"serverSelect","label":"State","name":"STATE","defaultValue":"MONTANA","optionsSrc":"STATE"},{"type":"ServerMultiComplete","label":"County","name":"COUNTY","defaultValue":[],"optionsSrc":"COUNTY","overrideSubOptionsSrcFromParameterName":"STATE"},{"type":"checkbox","name":"TIN_SEARCH_YN","defaultValue":false,"label":"Tax Identification Number Search"},{"type":"checkbox","name":"TIN_SORT_YN","defaultValue":false,"label":"Unique ID Sort"}]},"ALLOW_ADDRESS_VALIDATION_BYPASS_OPTION":true,"DEFAULT_ADDRESS_VALIDATION_BYPASS_OPTION_CHECKED":true}).AMENDMENTS_ALWAYS_ALLOWED_WHEN_LOGGED_IN;
	var ALLOW_CHECK_AR_ACCESS_LEVEL = ({"NODE_ENV":"production","BUILD_DATE":"2025-08-27T15:15:31.687Z","BUILD_NUMBER":"Not Provided","GIT_VERSION":"v1.3.0-381-ga81e29b08","GIT_COMMIT_HASH":"a81e29b085c9268ffd96c78eb734365802722741","GIT_BRANCH":"beta","PUBLIC_URL":"","STATE_ABBR":"MT","STATE_NAME":"Montana","STATE_ORG_TITLE":"Secretary of State","LOGIN_HEADER_IMG_PATH":"","HOME_IMG_FILENAME":"montana.jpg","FAVICON_FILE_NAME":"favicon.ico","ALLOW_E_SIGN_ON_CORRECTIONS":true,"THIRD_PARTY_SIGNING_ALLOWED":false,"MY_ACCOUNT_SAVE_AND_CLOSE_BUTTON":true,"IE_DEPRECATED_MESSAGE":"Internet Explorer is not supported. Please select a supported browser below to access this website.","ADDITIONAL_ROUTES":{"dataRequests":true,"farmBill":true,"apostille":true,"externalHelp":"https://sosmt.gov/business/help-center/","systemAdministration":[{"title":"Saved Payments","parameter":"saved-payments","componentName":"SavedPayments"}]},"SUBROUTES":[{"label":"Business","component":"Business","parameter":"business","myWorkQueueSearch":false,"sourceTypeId":54,"searchMustHaveOneOf":["FILING_TYPE_ID","STATUS_ID","STATE","search"],"serverWebSearchDescription":true,"serverWorkQueueDescription":true,"serverMyRecordsDescription":true,"searchPlaceholder":"Search by name or filing number (X########)","allowEmptySearchTerm":true,"requestCertificateAlternateLabel":"Request Information","fileAmendmentButtonLabel":"Filing Actions","advancedSearchParameters":[{"type":"radio","name":"QUERY_TYPE_ID","defaultValue":1010,"options":[{"value":1010,"label":"Starts with"},{"value":1011,"label":"Contains"},{"value":1012,"label":" Word Contains"}]},{"type":"serverSelect","name":"FILING_TYPE_ID","optionsSrc":"FILING_TYPES","label":"Entity Type","placeholder":"All","defaultValue":"0"},{"type":"serverSelect","name":"FILING_SUBTYPE_ID","optionsSrc":"FILING_SUBTYPES","label":"Entity Subtype","overrideSubOptionsSrcFromParameterName":"FILING_TYPE_ID","placeholder":"All","defaultValue":"0"},{"type":"serverSelect","name":"STATUS_ID","optionsSrc":"FILING_STATUS_WITHOUT_ALL","label":"Status","placeholder":"All","defaultValue":"0"},{"type":"serverSelect","name":"STATE","optionsSrc":"STATE","label":"State","placeholder":"All","defaultValue":""},{"type":"serverSelect","name":"COUNTY","optionsSrc":"COUNTY_SUBOPTION","label":"County","overrideSubOptionsSrcFromParameterName":"STATE","placeholder":"All","defaultValue":""},{"type":"checkbox","name":"CRA_SEARCH_YN","defaultValue":false,"label":"Search by Registered Agent PID"},{"type":"dateRange","name":"FILING_DATE","label":"Registration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}},{"type":"dateRange","name":"EXPIRATION_DATE","label":"Expiration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}}],"myRecordsFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Active"},{"value":2,"label":"Inactive"},{"value":3,"label":"Pending"}]},{"type":"dateRange","name":"DATE_RANGE","label":"Date range","defaultValue":{"start":null,"end":null}}],"myWorkQueueFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Approved"},{"value":2,"label":"Pending Online Payment"},{"value":3,"label":"Pending Review"},{"value":4,"label":"Needs Correction"},{"value":5,"label":"Rejected"},{"value":6,"label":"Draft"}]},{"type":"dateRange","name":"DATE_RANGE","label":"Date range","defaultValue":{"start":null,"end":null}}]},{"label":"Notary","component":"Notary","parameter":"notary","sourceTypeId":850,"myWorkQueueSearch":false,"allowEmptySearchTerm":true,"requestCertificateAlternateLabel":"Download Certificate","fileAmendmentButtonLabel":"Filing Actions","hideNameRequestCertificate":true,"hideAddressRequestCertificate":true,"hideRecordUserManagment":true,"searchPlaceholder":"Search by name or commission number","searchMustHaveOneOf":["CITY","search","SERVICE_TYPE"],"advancedParametersStartOpen":true,"searchIsSortable":true,"advancedSearchParameters":[{"type":"radio","name":"STARTS_WITH_YN","defaultValue":false,"options":[{"value":true,"label":"Starts with"},{"value":false,"label":"Contains"}]},{"type":"checkbox","name":"ACTIVE_ONLY_YN","defaultValue":true,"label":"Active entities only"},{"type":"text","name":"CITY","defaultValue":"","label":"City"},{"type":"select","name":"SERVICE_TYPE","label":"Special Services Offered","defaultValue":0,"options":[{"value":0,"label":"(N/A)"},{"value":6165,"label":"In-Person Electronic Notarization (IPEN)"},{"value":6166,"label":"Remote Online Notarization (RON)"},{"value":6167,"label":"Mobile Notary Services"},{"value":6168,"label":"Remote Ink Notarization (RIN)"}]}]},{"label":"Apostille","component":"Apostille","parameter":"apostille","sourceTypeId":720,"myRecordsSearch":false,"myWorkQueueSearch":false,"disabled":false,"allowedRoutes":["/forms-manager/","/queue/","/forms/"]},{"label":"Liens","component":"UCC","parameter":"ucc","sourceTypeId":1999,"myRecordsSearch":true,"myWorkQueueSearch":true,"fileAmendmentButtonLabel":"Filing Actions","searchPlaceholder":"Search by name or file number","disabled":false,"serverWebSearchDescription":true,"myRecordsDescription":"","workQueueDescription":"","searchDescription":"","hideRecordUserManagment":true,"searchLiensCheckout":false,"advancedSearchParameters":[{"type":"radio","name":"STARTS_WITH_YN","defaultValue":false,"options":[{"value":true,"label":"Starts with"},{"value":false,"label":"Contains"}]},{"type":"select","name":"STATUS","defaultValue":"ALL","label":"Status","options":[{"value":"ACTIVE_UNLAPSED","label":"Active (unlapsed)"},{"value":"ACTIVE_LAPSED_UNLAPSED","label":"Active (lapsed and unlapsed)"}]},{"type":"text","name":"EXCLUDE_VALUES","label":"Exclude Debtor Names (comma separated list of names to exclude)","defaultValue":""},{"type":"dateRange","name":"FILING_DATE","label":"Financing Statement Date","defaultValue":{"start":null,"end":null}},{"type":"dateRange","name":"LAPSE_DATE","label":"Lapse Date","defaultValue":{"start":null,"end":null}},{"type":"text","name":"CITY","label":"Debtor City","defaultValue":""}],"myRecordsFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Approved"},{"value":2,"label":"Pending Online Payment"},{"value":3,"label":"Pending Review"}]},{"type":"select","name":"TYPE","defaultValue":0,"label":"Lien Type","options":[{"value":0,"label":"All"},{"value":1,"label":"UCC"},{"value":2,"label":"EFS"},{"value":3,"label":"Title 71"}]}],"myWorkQueueFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Approved"},{"value":2,"label":"Pending Online Payment"},{"value":3,"label":"Pending Review"},{"value":4,"label":"Pending Print and Mail"},{"value":5,"label":"Rejected"},{"value":6,"label":"Draft"}]},{"type":"select","name":"TYPE","defaultValue":0,"label":"Lien Type","options":[{"value":0,"label":"All"},{"value":1,"label":"UCC"},{"value":2,"label":"EFS"},{"value":3,"label":"Title 71"}]}]},{"label":"Copy Request","component":"copies","parameter":"copies","sourceTypeId":2001,"myRecordsSearch":false,"myWorkQueueSearch":false,"disabled":false,"allowedRoutes":["/forms-manager/","/queue/","/forms/"]},{"label":"Trademark","component":"Trademark","parameter":"trademark","sourceTypeId":810,"showRequestCertificate":true,"searchMustHaveOneOf":["search","EXPIRATION_DATE","FILING_DATE"],"allowEmptySearchTerm":true,"requestCertificateAlternateLabel":"Request Information","fileAmendmentButtonLabel":"Filing Actions","advancedSearchParameters":[{"type":"radio","name":"QUERY_TYPE_ID","defaultValue":1010,"options":[{"value":1010,"label":"Starts with"},{"value":1011,"label":"Contains"},{"value":1012,"label":" Word Contains"}]},{"type":"checkbox","name":"OWNER_SEARCH_YN","defaultValue":false,"label":"Search owners"},{"type":"radio","name":"SERVICE_MARK_YN","label":"Mark Type","defaultValue":"","options":[{"value":"","label":"All Marks"},{"value":"Y","label":"Service Mark"},{"value":"N","label":"Trademark"}]},{"type":"serverSelect","name":"STATUS_ID","optionsSrc":"TYPE_V|TRADEMARK_STATUS_TYPE","label":"Status","placeholder":"All","defaultValue":"0"},{"type":"select","name":"DESIGN_TYPE_ID","options":[{"value":0,"label":"All"},{"value":990,"label":"Words Only"},{"value":991,"label":"Design Only"},{"value":992,"label":"Words and Design"}],"label":"Design Type","defaultValue":"0"},{"type":"dateRange","name":"FILING_DATE","label":"Registered Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}},{"type":"dateRange","name":"EXPIRATION_DATE","label":"Expiration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}}]},{"label":"Business Info Request","component":"InfoRequests","parameter":"info-request","sourceTypeId":167,"allowedRoutes":["/forms-manager/","/queue/","/forms/"]},{"label":"Data Requests","component":"DataRequests","parameter":"data-request","sourceTypeId":0,"allowedRoutes":["/forms-manager/"]},{"label":"CRA","component":"CRA","parameter":"cra","sourceTypeId":157,"myRecordsSearch":false,"searchPlaceholder":"Search by name or registered agent number","allowedRoutes":["/forms-manager/","/forms/","/records/","/queue/","/search/"],"allowEmptySearchTerm":true,"fileAmendmentButtonLabel":"Filing Actions","advancedSearchParameters":[{"type":"radio","name":"QUERY_TYPE_ID","defaultValue":1010,"options":[{"value":1010,"label":"Starts with"},{"value":1011,"label":"Contains"},{"value":1012,"label":" Word Contains"}]},{"type":"dateRange","name":"CRA_DATE","label":"Registration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}},{"type":"select","name":"STATUS_ID","label":"Status","defaultValue":0,"options":[{"value":0,"label":"All"},{"value":121,"label":"Active"},{"value":122,"label":"Inactive"}]},{"type":"select","name":"AGENT_TYPE_ID","label":"Agent Type","defaultValue":0,"options":[{"value":0,"label":"All"},{"value":460,"label":"Registered Agent"},{"value":461,"label":"Commercial Registered Agent"}]}]},{"label":"Farm Bill","component":"FarmBill","parameter":"farm-bill","path":"/lists/farm-bill","sourceTypeId":0,"myRecordsSearch":false,"allowedRules":["/search/"],"disabled":true,"searchDescription":"To perform a search, enter a debtor name. Your search results may include: exact debtor name, variations of that name and any filing that includes your search criteria. Punctuation is ignored.\n\nYou can click on \"Advanced\" to refine your search. Under “Advanced” you can search by crop, year, county and SSN/FEIN. As a registered Farm Bill Buyer with the Montana Secretary of State’s office it is important to maintain the confidentiality of the information contained within the Farm Bill Master List. The Farm Bill Master List reflects personal data, such as Social Security Numbers, which are a key piece of personal identifiable information to assist you in determining the existence of a lien against a specific debtor. The distribution of this information beyond its intended purpose is strictly prohibited.\n\nThe debtor's tax identification number has been hidden for confidentiality reasons. You may continue to search on a tax ID number and return debtors that match your search criteria. The SSN/FEIN must be entered without dashes or spaces.","searchMustHaveOneOf":["search","UCC_FARM_PRODUCT_ID","COUNTY"],"searchPlaceholder":"Search by debtor name","advancedSearchParameters":[{"type":"ServerMultiComplete","label":"Product code name(s)","name":"UCC_FARM_PRODUCT_ID","defaultValue":"","optionsSrc":"UCC_FARM_PRODUCT_V"},{"type":"MultiComplete","label":"Year or Range of Years","name":"YEAR_NUM","optionsSrc":"years","startYear":"1968","defaultValue":[],"preMergeOptions":[{"value":"ALL","label":"All"}]},{"type":"serverSelect","label":"State","name":"STATE","defaultValue":"MONTANA","optionsSrc":"STATE"},{"type":"ServerMultiComplete","label":"County","name":"COUNTY","defaultValue":[],"optionsSrc":"COUNTY","overrideSubOptionsSrcFromParameterName":"STATE"},{"type":"checkbox","name":"TIN_SEARCH_YN","defaultValue":false,"label":"Tax Identification Number Search"},{"type":"checkbox","name":"TIN_SORT_YN","defaultValue":false,"label":"Unique ID Sort"}]}],"SYSTEM_NICKNAME":"Online Services Portal","PAYMENT_METHODS":[{"type":"bypass"},{"type":"iTransact"}],"PAYMENT_ALLOW_AMEX":true,"SYSTEM_ID_LABEL":"System Id","DOUBLE_COLUMN_PUBLIC_LOGIN":true,"INTERNAL_USER_MANAGEMENT":true,"ALLOW_PUBLIC_JSON_IMPORT":false,"MAX_FILE_UPLOAD_SIZE":10000000,"REFUND_TEXT":"","RETURN_TO_HOME_ON_LOGOUT":true,"CURRENT_SOS_NAME":"Christi Jacobsen","LOGO_FILENAME":"mt-sos-logo.png","LOGO_ALT":"Christi Jacobsen, Montana Secretary of State","LOGO_FULL_WIDTH":true,"HOME_HIDE_AUTH_HINT":true,"HOME_TITLE":"Montana Secretary of State","CUSTOM_TAB_TITLE":"Official Montana","HOME_SUBTITLE":"Online Business Services","ENTITY_NAME_CONSENT_DESCRIPTION":"","ALLOW_USER_PROFILE_EDITING":true,"COMPARE_FOREIGN_NAME_IN_ENTITY_NAME_VALIDATION":true,"FOREIGN_NAME_FIELD_NAME":"KIMA_PARENT_NAME_INFO","LOGIN_TITLE":"Montana Secretary of State Online Filing Portal Login","PUBLIC_LOGIN_LABEL":"Username","REVERSE_LOGIN_COLUMNS":true,"LOGIN_SEAL_FILENAME":"seal_white.png","SEPARATE_USERNAME_AND_EMAIL":true,"CREATE_ACCOUNT_BUTTON_ALIGN_LEFT":true,"CREATE_ACCOUNT_BUTTON_TEXT":"CREATE AN ACCOUNT","PASSWORD_CUSTOM_ERROR_TEXT":"The password must meet all requirements","ACCOUNT_CREATED_MESSAGE":"Please check your email to verify your account to login and allow a few minutes for this message to arrive. Check your junk/spam folders if you do not find the email in your inbox.","PUBLIC_LOGIN_PLACEHOLDER":" ","DISABLE_DEFAULT_PAYMENT_RADIO":true,"CUSTOM_RESET_PASSWORD_ERROR_MESSAGE":"Username invalid - no account found","PUBLIC_LOGIN_CREATE_DESCRIPTION":"### Existing User:\n\n  - Enter your username and password to login.  \n\n\n  #### - OR -  \n\n\n\n  - Forgot password? Click 'Reset Password' and follow the prompts.\n  - Forgot username? Click 'Forgot Username' and follow the prompts.  \n\n\n  ### New User:\n  ","LOGIN_HELP_LINK":"https://sosmt.gov/business/how-do-i/","LOGIN_HELP_LINK_TEXT":"Need Help?","FORGOT_USERNAME_TEXT":"Forgot Username?","LOGIN_ACTIVE_DIRECTORY_TEXT":"State User Login","MULTIPLE_LOGIN_METHODS":true,"HAS_ACTIVE_DIRECTORY_LOGIN":true,"RESET_PASSWORD_WITH_USERNAME":true,"DOWNLOAD_LINK":true,"SHOW_USERNAME_ACCOUNT_CREATE":true,"SHOW_SCROLL_DOWN_ARROW":true,"SHOW_ADDRESS_ACCOUNT_CREATE":true,"TWO_COLUMN_ACCOUNT_CREATE":true,"RESET_PASSWORD_TIP":"A link to change your password has been sent to your email. Please allow a few minutes for this message to arrive. Please check your junk/spam folders if you do not find the email in your inbox.","FORGOT_PASSWORD_LINK_TEXT":"Reset Password","PHONE_NUMBER_OPTIONAL_ACCOUNT_CREATE":true,"SHOW_REQUIRED_INDICATOR_ACCOUNT_CREATE":true,"PASSWORD_REQUIREMENTS_ACCOUNT_CREATE":"\n    <ul>\n      <li>MUST contain at least 8 characters (12+ recommended)</li>\n      <li>MUST contain at least one uppercase letter.</li>\n      <li>MUST contain at least one lowercase letter.</li>\n      <li>MUST contain at least one number.</li>\n      <li>MUST contain at least one special character (!”#$%&'()*+,-./:;<=>?</li>\n    </ul>\n  ","ALLOW_CERTIFICATION_REQUEST":true,"ALLOW_PUBLIC_CERTIFICATE_REQUEST":true,"ALLOW_COPY_REQUEST":false,"ALLOW_CORRECTION_STYLING":true,"HIDE_DEPRECATION_WARNING":false,"AMEND_ROUTE_PUBLIC":true,"SEAL_FILENAME":"seal.png","SHOPPING_CART":true,"ALLOW_PAYMENT_UPDATE_WITH_EMPTY_CART":true,"RA_EMAIL":true,"RA_WEBSITE":true,"RA_NO_DEFAULT_TYPE":true,"RA_ADDRESS_LABEL":"Street Address","RA_TYPE_SELECTION_DEFAULT":true,"RA_DEFAULT_TYPE":"460","RA_OVERRIDE_TYPE_WITH_DEFAULT":true,"RA_PRINCIPAL_ADDRESS_AMS":true,"UPLOAD_AND_SUBMIT_HIDE_IF_ONE_OPTION":true,"PAYMENT_PROCESSING_MESSAGE":"Your payment is processing - Do not close your browser or click the back button","CHECKOUT_BUTTON_WHEN_PROCESSING_TEXT":"Processing","EFS_CROP_PICKER_NONE_LABEL":"Lien Duration","DISALLOWED_WIZARD_PIECES":["FormationLocale"],"REPEATER_SHOW_EDIT_BUTTON":true,"DATA_REQUEST_PAGE_TITLE":"Data Requests and Subscriptions","DATA_REQUEST_SIDEBAR_LABEL":"Data Requests & Subscriptions","LOGIN_REDIRECTS_TO_EPASS":false,"LOGIN_REDIRECTS_TO_ACTIVE_DIRECTORY":true,"LOGIN_ACTIVE_DIRECTORY_LINK":true,"FETCH_EDIT_USER_LINK":false,"LISTS_FETCH_AVAILABLE_LISTS":true,"POST_WIZARD_SUBMIT_REDIRECT_URL":"/","PIN_REQUEST_ATTESTATIONS":true,"PIN_REQUEST_DESCRIPTION":"Click **Request PIN** to have a new PIN sent to the account holder's email address on file.","OWNERSHIP_REQUEST_DESCRIPTION":"To become an **authorized user** of this record, a current **AUTHORIZED USER** will need to grant you access. To request access, click **Request Access** below.","PIN_REQUEST_SUCCESS_MESSAGE":"The PIN you have requested for this entity has been sent to the email associated with your user account.  You should receive the PIN in approximately 3-5 minutes, depending on your email service provider.","APOSTILLE_HEADER_LABEL":"Verification Information","APOSTILLE_NUMBER_LABEL":"Apostille/Authentication","APOSTILLE_CITY_STATE_OVERRIDE":"HELENA, MT","APOSTILLE_FILING_DATE_LABEL":"Issue Date","APOSTILLE_CITY_STATE_IN_CERTIFIED":true,"NOTARY_EXISTING_FILING":true,"ALLOW_REVOKE_OWN_ACCESS_ONLY":false,"HIDE_CANCEL_ON_ONETIME_DATA_REQUESTS":true,"DATA_REQUESTS_IN_SHOPPING_CART":true,"WQ_ALLOW_EDIT_PENDING_PAYMENT":true,"WQ_CONFIRM_ON_DELETE":true,"WQ_DELETE_CONFIRM_MESSAGE":"Deleting this filing will forfeit any money already paid to the Secretary of State. This action is permanent and cannot be undone, are you sure you would like to delete?","PASS_ITEM_GUIDS_ON_CHECKOUT":true,"FORM_REVISION_HISTORY":true,"CHECKOUT_DISCLAIMER":"By entering your credit card and/or checking account information you (i) state that **you are an authorized user** of the credit card and/or electronic check and that the associated information entered (e.g., account holder name, account number, billing address) is accurate, (ii) **you authorize payment processor to charge the amount you have requested** to your credit card and/or funding account, and (iii) **acknowledge if a charge is declined or reversed you may also be assessed a customary charge** by the payment processor for such transactions.","FARM_BILL_SEARCH_CONFIDENTIAL":"As a registered Farm Bill Buyer with the Montana Secretary of State’s office it is important to maintain the confidentiality of the information contained within the Farm Bill Master List. The Farm Bill Master List reflects personal data, such as Social Security Numbers, which are a key piece of personal identifiable information to assist you in determining the existence of a lien against a specific debtor. The distribution of this information beyond its intended purpose is strictly prohibited.\n\n**The debtor's tax identification number has been hidden for confidentiality reasons. You may continue to search on a tax ID number and return debtors that match your search criteria. The SSN/FEIN must be entered without dashes or spaces.  If you need access to the tax identification number to clearly identify the debtor, please contact the UCC unit at (406) 444-3665.**","VIEW_HISTORY_BUTTON_ALT_TEXT":"View Filings","WIZARD_ERROR_TITLE_MESSAGE":"Form Error","FARM_BILL_SEARCH_INTERACTIVE":true,"USE_FARM_BILL_API":true,"DISALLOW_ASSIGN_SELF_AS_RA":true,"DISALLOW_ASSIGN_SELF_AS_PRINCIPAL":true,"USE_TRADEMARK_OWNER_VALIDATION":true,"USE_ALTERNATIVE_FOREIGN_ADDRESS_LABELS":true,"MY_RECEIPTS_FILTER":[{"type":"dateRange","name":"DATE_RANGE","label":"Date range","defaultValue":{"start":null,"end":null}},{"type":"text","name":"REF_NUM","defaultValue":"","label":"Reference Number"},{"type":"text","name":"RECEIPT_NUM","defaultValue":"","label":"Receipt Id"},{"type":"text","name":"AMOUNT","defaultValue":"","label":"Amount"},{"type":"select","name":"TYPE","defaultValue":"","label":"Payment Type","options":[{"value":"","label":"All"},{"value":"CC","label":"Credit Card"},{"value":"Check","label":"Check"}]}],"MY_RECEIPTS_SHOW_IN_SIDEBAR":true,"SHOW_MY_RECEIPTS_HELPER_TEXT":true,"MY_RECEIPTS_HELPER_LABEL":"About Receipt Search","MY_RECEIPTS_HELPER_TEXT":"You can search for receipts based on their descriptions, including the items paid for on the receipt. Use the filters to search for or filter specific information.","FARM_BILL_SUBLINK":{"label":"Farm Bill","component":"FarmBill","parameter":"farm-bill","path":"/lists/farm-bill","sourceTypeId":0,"myRecordsSearch":false,"allowedRules":["/search/"],"disabled":true,"searchDescription":"To perform a search, enter a debtor name. Your search results may include: exact debtor name, variations of that name and any filing that includes your search criteria. Punctuation is ignored.\n\nYou can click on \"Advanced\" to refine your search. Under “Advanced” you can search by crop, year, county and SSN/FEIN. As a registered Farm Bill Buyer with the Montana Secretary of State’s office it is important to maintain the confidentiality of the information contained within the Farm Bill Master List. The Farm Bill Master List reflects personal data, such as Social Security Numbers, which are a key piece of personal identifiable information to assist you in determining the existence of a lien against a specific debtor. The distribution of this information beyond its intended purpose is strictly prohibited.\n\nThe debtor's tax identification number has been hidden for confidentiality reasons. You may continue to search on a tax ID number and return debtors that match your search criteria. The SSN/FEIN must be entered without dashes or spaces.","searchMustHaveOneOf":["search","UCC_FARM_PRODUCT_ID","COUNTY"],"searchPlaceholder":"Search by debtor name","advancedSearchParameters":[{"type":"ServerMultiComplete","label":"Product code name(s)","name":"UCC_FARM_PRODUCT_ID","defaultValue":"","optionsSrc":"UCC_FARM_PRODUCT_V"},{"type":"MultiComplete","label":"Year or Range of Years","name":"YEAR_NUM","optionsSrc":"years","startYear":"1968","defaultValue":[],"preMergeOptions":[{"value":"ALL","label":"All"}]},{"type":"serverSelect","label":"State","name":"STATE","defaultValue":"MONTANA","optionsSrc":"STATE"},{"type":"ServerMultiComplete","label":"County","name":"COUNTY","defaultValue":[],"optionsSrc":"COUNTY","overrideSubOptionsSrcFromParameterName":"STATE"},{"type":"checkbox","name":"TIN_SEARCH_YN","defaultValue":false,"label":"Tax Identification Number Search"},{"type":"checkbox","name":"TIN_SORT_YN","defaultValue":false,"label":"Unique ID Sort"}]},"ALLOW_ADDRESS_VALIDATION_BYPASS_OPTION":true,"DEFAULT_ADDRESS_VALIDATION_BYPASS_OPTION_CHECKED":true}).ALLOW_CHECK_AR_ACCESS_LEVEL;
	var VIEW_HISTORY_BUTTON_ALT_TEXT = ("View Filings");
	
	var lobbyistRenewalLabel = (_utilities.SUBROUTES_OBJ.lobbyist || {}).myRecordsRenewalButtonLabel;
	
	var RecordDrawer = function (_React$Component) {
	  _inherits(RecordDrawer, _React$Component);
	
	  function RecordDrawer() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, RecordDrawer);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = RecordDrawer.__proto__ || Object.getPrototypeOf(RecordDrawer)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      ownershipModalOpen: false,
	      requestOwnershipModal: false,
	      pinsModalOpen: false,
	      amendmentLauncherOpen: false,
	      reinstatementModalOpen: false,
	      certificateModalOpen: false,
	      userOwnsCurrentRecord: null,
	      currentRecordHasOwners: null,
	      certificateCheckoutOpen: false,
	      loadingDetails: true,
	      loadingOwnership: true,
	      title: _this.props.title,
	      subtitle: _this.props.subtitle,
	      details: [],
	      certificateReceiptItems: [],
	      certificateReceiptItemContainers: [],
	      certificateRefNum: null,
	      certificateConfig: null,
	      arConfirmOpen: false,
	      arConfirmFunction: null,
	      canAccessARLoggedIn: false,
	      unavailableARMessage: null,
	      unavailableReinstatementMessage: null,
	      unavailableRenewalMessage: null
	    }, _this.componentDidMount = function () {
	      _this.getUserOwnsRecord(_this.props.category, _this.props.sourceId);
	      _this.getRecordDetails(_this.props.category, _this.props.sourceId);
	    }, _this.componentDidUpdate = function (prevProps) {
	      if (_this.props.sourceId !== prevProps.sourceId || _this.props.recordNum !== prevProps.recordNum || _this.props.category !== prevProps.category) {
	        _this.getUserOwnsRecord(_this.props.category, _this.props.sourceId);
	        if (_this.props.category === 'farm-bill' && (true)) {
	          _this.getFarmBillRecordDetails(_this.props.category, _this.props.uccDebtorID, _this.props.uccEfsProductID, _this.props.uccFilingID, _this.props.uccSecuredPartyID);
	        } else {
	          _this.getRecordDetails(_this.props.category, _this.props.sourceId);
	        }
	        _this.props.loggedIn && _this.props.canFileAR && ALLOW_CHECK_AR_ACCESS_LEVEL && _this.props.recordNum && _this.getARFormAccessLevel(_this.props.recordNum);
	      }
	      if ((_this.props.title !== prevProps.title || _this.props.subtitle !== prevProps.subtitle) && (_this.props.title || _this.props.sourceId)) {
	        _this.setState({ title: _this.props.title, subtitle: _this.props.subtitle });
	      }
	    }, _this.ANNUAL_REPORT_OPTIONS = function () {
	      var _this$props = _this.props,
	          canReinstate = _this$props.canReinstate,
	          canFileAR = _this$props.canFileAR;
	
	      return {
	        business: {
	          label: _this.state.arButtonLabel ? _this.state.arButtonLabel : canReinstate ? "Reinstate" : canFileAR ? "File Annual Report" : "",
	          tooltip: RD_TOOLTIP_AMENDMENT || RD_TOOLTIP_REINSTATE ? _this.state.arButtonLabel ? _this.state.arButtonLabel : canReinstate ? RD_TOOLTIP_REINSTATE : undefined : undefined,
	          onClickFn: _this.getWrappedAnualReportFunction(_this.getReinstatementAROnClickFn())
	        },
	        contractor: {
	          label: _this.state.arButtonLabel || "File Contractor Renewal",
	          onClickFn: _this.getWrappedAnualReportFunction(_this.openContractorRenewalWizard)
	        },
	        lobbyist: {
	          label: _this.state.arButtonLabel || lobbyistRenewalLabel || "File Lobbyist Renewal",
	          onClickFn: _this.getWrappedAnualReportFunction(_this.openLobbyistRenewalWizard)
	        },
	        trademark: {
	          label: _this.state.arButtonLabel || "File Trademark Renewal",
	          onClickFn: _this.getWrappedAnualReportFunction(_this.openTrademarkRenewalWizard)
	        },
	        charitable: {
	          label: _this.state.arButtonLabel ? _this.state.arButtonLabel : canReinstate ? "Reregister" : canFileAR ? "File Annual Report" : "",
	          onClickFn: _this.getWrappedAnualReportFunction(_this.getCharitableReinstatementAROnClickFn())
	        },
	        notary: {
	          label: _this.state.arButtonLabel || "File Renewal",
	          onClickFn: _this.getWrappedAnualReportFunction(_this.openNotaryRenewalWizard)
	        }
	      };
	    }, _this.getCharitableReinstatementAROnClickFn = function () {
	      var _this$props2 = _this.props,
	          canReinstate = _this$props2.canReinstate,
	          canFileAR = _this$props2.canFileAR;
	
	      if (ALLOW_REINSTATEMENT_AR_MODAL !== false) {
	        if (canReinstate) {
	          return _this.openCharitableRenewalWizard;
	        } else if (canFileAR) {
	          return _this.openCharitableAnnualReportWizard;
	        } else {
	          return _utilities.noop;
	        }
	      } else {
	        if (canReinstate) {
	          return _this.openCharitableRenewalWizard;
	        } else if (canFileAR) {
	          return _this.openCharitableAnnualReportWizard;
	        } else {
	          return _utilities.noop;
	        }
	      }
	    }, _this.getReinstatementAROnClickFn = function () {
	      var _this$props3 = _this.props,
	          canReinstate = _this$props3.canReinstate,
	          canFileAR = _this$props3.canFileAR;
	
	      if (ALLOW_REINSTATEMENT_AR_MODAL !== false) {
	        if (canReinstate) {
	          return _this.toggleReinstatementModal;
	        } else if (canFileAR) {
	          return _this.openAnnualReportWizard;
	        } else {
	          return _utilities.noop;
	        }
	      } else {
	        if (canReinstate) {
	          return _this.OpenReinstatementWizard;
	        } else if (canFileAR) {
	          return _this.openAnnualReportWizard;
	        } else {
	          return _utilities.noop;
	        }
	      }
	    }, _this.getWrappedAnualReportFunction = function (fn) {
	      return function () {
	        if (REQUIRE_ANNUAL_REPORT_CONFIRMATION) {
	          _this.setState({ arConfirmOpen: true, arConfirmFunction: fn });
	        } else {
	          fn();
	        }
	      };
	    }, _this.getRecordDetails = function (category, sourceId) {
	      if (category && sourceId) {
	        if (_this.currentDetailsRequest) {
	          _this.currentDetailsRequest.abort();
	        }
	        _this.setState({ loadingDetails: true });
	
	        (0, _requests.GET_FILING_DETAILS)(category, sourceId, false, function (signal) {
	          return _this.currentDetailsRequest = signal;
	        }, function (data) {
	          _this.setState({
	            details: data.DRAWER_DETAIL_LIST,
	            arButtonLabel: data.AR_BUTTON_LABEL,
	            loadingDetails: false,
	            hideCertButton: data.HIDE_CERT_BUTTON,
	            hideRequestAccess: data.HIDE_REQUEST_ACCESS,
	            hideManageAccess: data.HIDE_MANAGE_ACCESS,
	            hideHistory: data.HIDE_HISTORY,
	            hideAmendmentButton: data.HIDE_AMENDMENT_BUTTON,
	            alwaysShowAmendmentButton: data.ALWAYS_SHOW_AMENDMENT_BUTTON,
	            certButtonRedirectsTo: data.CERT_BUTTON_REDIRECTS_TO,
	            unavailableARMessage: data.UNAVAILABLE_AR_MESSAGE,
	            unavailableReinstatementMessage: data.UNAVAILABLE_REINSTATEMENT_MESSAGE,
	            unavailableRenewalMessage: data.UNAVAILABLE_RENEWAL_MESSAGE
	          });
	        }, function (err) {
	          if (err.name !== 'AbortError') {
	            console.error(err);
	          }
	          _this.setState({
	            details: []
	          });
	        });
	      }
	    }, _this.getFarmBillRecordDetails = function (category, uccDebtorID, uccEfsProductID, uccFilingID, uccSecuredPartyID) {
	      if (category && uccDebtorID && uccEfsProductID && uccFilingID && uccSecuredPartyID) {
	        if (_this.currentDetailsRequest) {
	          _this.currentDetailsRequest.abort();
	        }
	        _this.setState({ loadingDetails: true });
	        var parameters = {
	          UCC_EFS_PRODUCT_ID: uccEfsProductID,
	          UCC_SECURED_PARTY_ID: uccSecuredPartyID,
	          UCC_DEBTOR_ID: uccDebtorID,
	          UCC_FILING_ID: uccFilingID
	        };
	        (0, _requests.GET_FARM_BILL_RECORD_DETAILS)(category, parameters, _shortid2.default.generate(), function (signal) {
	          return _this.currentDetailsRequest = signal;
	        }, function (data) {
	          _this.setState({
	            details: data.DRAWER_DETAIL_LIST,
	            arButtonLabel: data.AR_BUTTON_LABEL,
	            loadingDetails: false,
	            hideCertButton: data.HIDE_CERT_BUTTON,
	            hideRequestAccess: data.HIDE_REQUEST_ACCESS,
	            hideManageAccess: data.HIDE_MANAGE_ACCESS,
	            hideHistory: data.HIDE_HISTORY,
	            hideAmendmentButton: data.HIDE_AMENDMENT_BUTTON,
	            alwaysShowAmendmentButton: data.ALWAYS_SHOW_AMENDMENT_BUTTON,
	            certButtonRedirectsTo: data.CERT_BUTTON_REDIRECTS_TO
	          });
	        }, function (err) {
	          if (err.name !== 'AbortError') {
	            console.error(err);
	          }
	          _this.setState({
	            details: []
	          });
	        });
	      }
	    }, _this.getUserOwnsRecord = function (category, sourceId) {
	      if (category && sourceId && !_this.props.userOwnsCurrentRecord) {
	        _this.setState({ loadingOwnership: true });
	        (0, _requests.GET_WEB_USER_IS_RECORD_OWNER)(category, sourceId, function (userOwnsCurrentRecord) {
	          if (userOwnsCurrentRecord) {
	            _this.setState({ userOwnsCurrentRecord: userOwnsCurrentRecord, loadingOwnership: false });
	          } else {
	            (0, _requests.GET_RECORD_HAS_OWNERS)(category, sourceId, function (currentRecordHasOwners) {
	              _this.setState({
	                userOwnsCurrentRecord: userOwnsCurrentRecord,
	                currentRecordHasOwners: currentRecordHasOwners,
	                loadingOwnership: false
	              });
	            });
	          }
	        });
	      }
	    }, _this.toggleOwnershipModal = function () {
	      _this.setState(function (state) {
	        return { ownershipModalOpen: !state.ownershipModalOpen };
	      });
	    }, _this.toggleRequestOwnershipModal = function () {
	      _this.setState(function (state) {
	        return {
	          requestOwnershipModal: !state.requestOwnershipModal
	        };
	      });
	    }, _this.togglePinsModal = function () {
	      if (_this.state.pinsModalOpen) {
	        _this.pinsModal.closeModal(function () {
	          _this.setState(function (state) {
	            return { pinsModalOpen: false };
	          });
	        });
	      } else {
	        _this.setState(function (state) {
	          return { pinsModalOpen: true };
	        });
	      }
	    }, _this.closeOwnershipModalAndRefreshRecords = function () {
	      _this.ownershipModal.closeModal();
	      _this.props.onRequestRecordsRefresh();
	    }, _this.toggleAmendmentLauncher = function () {
	      _this.setState(function (state) {
	        return {
	          amendmentLauncherOpen: !state.amendmentLauncherOpen
	        };
	      });
	    }, _this.toggleReinstatementModal = function () {
	      _this.setState(function (state) {
	        return {
	          reinstatementModalOpen: !state.reinstatementModalOpen
	        };
	      });
	    }, _this.toggleCertificateModalOpen = function () {
	      _this.setState(function (state) {
	        return {
	          certificateModalOpen: !state.certificateModalOpen
	        };
	      });
	    }, _this.getConfigAndOpenCertificateModal = function () {
	      if (_this.props.sublink.certificateDownloadRedirectsTo) {
	        _store.history.push(_this.props.sublink.certificateDownloadRedirectsTo.replace(/{{recordNum}}/g, _this.props.recordNum));
	      } else if (_this.state.certButtonRedirectsTo) {
	        _store.history.push(_this.state.certButtonRedirectsTo);
	      } else {
	        _this.getCertificateConfig().then(function () {
	          _this.setState({
	            certificateModalOpen: true
	          });
	        });
	      }
	    }, _this.getCertificateConfig = function () {
	      return new Promise(function (resolve, reject) {
	        (0, _requests.GET_CERTIFICATION_CONFIG)(_this.props.category, _this.props.sourceId, function (certificateConfig) {
	          _this.setState({ certificateConfig: certificateConfig }, function () {
	            resolve();
	          });
	        });
	      });
	    }, _this.swapRequestAndOwnershipModals = function () {
	      _this.setState({ pinsModalOpen: false, ownershipModalOpen: PIN_SWAP_ON_SUCCESS ? true : false, userOwnsCurrentRecord: true });
	    }, _this.openAnnualReportWizard = function () {
	      var recordNum = _this.props.recordNum;
	
	      (0, _requests.GET_AR_FORM_DEFINITION_ID)(recordNum, function (formDefId) {
	        _store.history.push("/amend/" + formDefId + "/" + recordNum);
	      }, console.error);
	    }, _this.OpenReinstatementWizard = function () {
	      console.log("test");
	      var recordNum = _this.props.recordNum;
	
	      (0, _requests.GET_REINSTATEMENT_FORM_DEFINITION_ID)(recordNum, function (formDefinitionId) {
	        _store.history.push("/amend/" + formDefinitionId + "/" + recordNum);
	      }, console.error);
	    }, _this.openCharitableRenewalWizard = function () {
	      var recordNum = _this.props.recordNum;
	
	      (0, _requests.GET_CHARITABLE_RENEWAL_FORM_DEFINITION_ID)(recordNum, function (formDefId) {
	        _store.history.push("/amend/" + formDefId + "/" + recordNum);
	      }, console.error);
	    }, _this.openCharitableAnnualReportWizard = function () {
	      var recordNum = _this.props.recordNum;
	
	      (0, _requests.GET_CHARITABLE_AR_FORM_DEFINITION_ID)(recordNum, function (formDefId) {
	        _store.history.push("/amend/" + formDefId + "/" + recordNum);
	      }, console.error);
	    }, _this.openContractorRenewalWizard = function () {
	      var recordNum = _this.props.recordNum;
	
	      (0, _requests.GET_CONTRACTOR_RENEWAL_FORM_DEFINITION_ID)(recordNum, function (formDefId) {
	        _store.history.push("/amend/" + formDefId + "/" + recordNum);
	      }, console.error);
	    }, _this.openLobbyistRenewalWizard = function () {
	      var recordNum = _this.props.recordNum;
	
	      (0, _requests.GET_LOBBYIST_RENEWAL_FORM_DEFINITION_ID)(recordNum, function (formDefId) {
	        _store.history.push("/amend/" + formDefId + "/" + recordNum);
	      }, console.error);
	    }, _this.openTrademarkRenewalWizard = function () {
	      var recordNum = _this.props.recordNum;
	
	      (0, _requests.GET_TRADEMARK_RENEWAL_FORM_DEFINITION_ID)(recordNum, function (formDefId) {
	        _store.history.push("/amend/" + formDefId + "/" + recordNum);
	      }, console.error);
	    }, _this.openNotaryRenewalWizard = function () {
	      var recordNum = _this.props.recordNum;
	
	      (0, _requests.GET_NOTARY_RENEWAL_FORM_DEFINITION_ID)(recordNum, function (formDefId) {
	        _store.history.push("/amend/" + formDefId + "/" + recordNum);
	      }, console.error);
	    }, _this.toggleCertificateCheckout = function () {
	      _this.certificateModal.closeModal();
	      _this.setState(function (state) {
	        return { certificateCheckoutOpen: !state.certificateCheckoutOpen };
	      });
	    }, _this.cancelCertificateCheckout = function () {
	      _this.certificateSlider.closeSlider(function () {
	        _this.setState({ certificateCheckoutOpen: false });
	      });
	    }, _this.createCertification = function (params) {
	      // Get the FILING_ID of the selected filing
	      var filingId = _this.props.sourceId;
	      if (filingId) {
	        (0, _requests.CREATE_CERTIFICATION)(Object.assign({
	          FILING_ID: filingId,
	          REQUESTOR_NAME: params.requesterName,
	          EMAIL: params.email,
	          CERTIFICATION_TYPE_ID: params.certType,
	          CERTIFICATE_AMOUNT: params.certAmount,
	          DELIVERY_METHOD: params.delivery,
	          SOURCE_TYPE_ID: (0, _utilities.getSourceTypeId)(_this.props.category)
	        }, params.address), function (certificationId) {
	          (0, _requests.GET_WEB_CART_BY_CERTIFICATION_ID)(certificationId, SHOPPING_CART ? function (cart) {
	            var total = (0, _utilities.calculateReceiptItemContainersTotal)(cart.RECEIPT_ITEM_CONTAINER_WEB_LIST);
	            _this.setState({
	              certificateRefNum: cart.REF_NUM,
	              certificateReceiptItemContainers: cart.RECEIPT_ITEM_CONTAINER_WEB_LIST
	            }, function () {
	              if (total > 0) {
	                (0, _actions.setCartQuantity)(cart.RECEIPT_ITEM_CONTAINER_WEB_LIST.filter(function (x) {
	                  return !x.IS_FREE;
	                }).length);
	                _this.toggleCertificateCheckout();
	              } else {
	                _this.redirectToReceipt();
	              }
	            });
	          } : function (_ref2) {
	            var RECEIPT_ITEM_WEB_LIST = _ref2.RECEIPT_ITEM_WEB_LIST,
	                REF_NUM = _ref2.REF_NUM;
	
	            var total = (0, _utilities.calculateReceiptItemsTotal)(RECEIPT_ITEM_WEB_LIST);
	            _this.setState({
	              certificateReceiptItems: RECEIPT_ITEM_WEB_LIST,
	              certificateRefNum: REF_NUM
	            }, function () {
	              if (total > 0) {
	                _this.toggleCertificateCheckout();
	              } else {
	                _this.redirectToReceipt();
	              }
	            });
	          }, function (err) {
	            _this.certificateForm.setError();
	            console.error(err);
	          });
	        }, console.error);
	      }
	    }, _this.redirectToReceipt = function (refNum) {
	      _store.history.push("/receipt?ref=" + (refNum || _this.state.certificateRefNum));
	    }, _this.handleAccessRevoked = function () {
	      _this.setState({ userOwnsCurrentRecord: false, userAccessRevoked: true });
	      _this.closeOwnershipModalAndRefreshRecords();
	      _this.getUserOwnsRecord();
	    }, _this.getARFormAccessLevel = function (recordNum) {
	      (0, _requests.GET_AR_FORM_ACCESS_LEVEL)(recordNum, function (accessLevel) {
	        if (accessLevel === 20 && ({"NODE_ENV":"production","BUILD_DATE":"2025-08-27T15:15:31.687Z","BUILD_NUMBER":"Not Provided","GIT_VERSION":"v1.3.0-381-ga81e29b08","GIT_COMMIT_HASH":"a81e29b085c9268ffd96c78eb734365802722741","GIT_BRANCH":"beta","PUBLIC_URL":"","STATE_ABBR":"MT","STATE_NAME":"Montana","STATE_ORG_TITLE":"Secretary of State","LOGIN_HEADER_IMG_PATH":"","HOME_IMG_FILENAME":"montana.jpg","FAVICON_FILE_NAME":"favicon.ico","ALLOW_E_SIGN_ON_CORRECTIONS":true,"THIRD_PARTY_SIGNING_ALLOWED":false,"MY_ACCOUNT_SAVE_AND_CLOSE_BUTTON":true,"IE_DEPRECATED_MESSAGE":"Internet Explorer is not supported. Please select a supported browser below to access this website.","ADDITIONAL_ROUTES":{"dataRequests":true,"farmBill":true,"apostille":true,"externalHelp":"https://sosmt.gov/business/help-center/","systemAdministration":[{"title":"Saved Payments","parameter":"saved-payments","componentName":"SavedPayments"}]},"SUBROUTES":[{"label":"Business","component":"Business","parameter":"business","myWorkQueueSearch":false,"sourceTypeId":54,"searchMustHaveOneOf":["FILING_TYPE_ID","STATUS_ID","STATE","search"],"serverWebSearchDescription":true,"serverWorkQueueDescription":true,"serverMyRecordsDescription":true,"searchPlaceholder":"Search by name or filing number (X########)","allowEmptySearchTerm":true,"requestCertificateAlternateLabel":"Request Information","fileAmendmentButtonLabel":"Filing Actions","advancedSearchParameters":[{"type":"radio","name":"QUERY_TYPE_ID","defaultValue":1010,"options":[{"value":1010,"label":"Starts with"},{"value":1011,"label":"Contains"},{"value":1012,"label":" Word Contains"}]},{"type":"serverSelect","name":"FILING_TYPE_ID","optionsSrc":"FILING_TYPES","label":"Entity Type","placeholder":"All","defaultValue":"0"},{"type":"serverSelect","name":"FILING_SUBTYPE_ID","optionsSrc":"FILING_SUBTYPES","label":"Entity Subtype","overrideSubOptionsSrcFromParameterName":"FILING_TYPE_ID","placeholder":"All","defaultValue":"0"},{"type":"serverSelect","name":"STATUS_ID","optionsSrc":"FILING_STATUS_WITHOUT_ALL","label":"Status","placeholder":"All","defaultValue":"0"},{"type":"serverSelect","name":"STATE","optionsSrc":"STATE","label":"State","placeholder":"All","defaultValue":""},{"type":"serverSelect","name":"COUNTY","optionsSrc":"COUNTY_SUBOPTION","label":"County","overrideSubOptionsSrcFromParameterName":"STATE","placeholder":"All","defaultValue":""},{"type":"checkbox","name":"CRA_SEARCH_YN","defaultValue":false,"label":"Search by Registered Agent PID"},{"type":"dateRange","name":"FILING_DATE","label":"Registration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}},{"type":"dateRange","name":"EXPIRATION_DATE","label":"Expiration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}}],"myRecordsFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Active"},{"value":2,"label":"Inactive"},{"value":3,"label":"Pending"}]},{"type":"dateRange","name":"DATE_RANGE","label":"Date range","defaultValue":{"start":null,"end":null}}],"myWorkQueueFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Approved"},{"value":2,"label":"Pending Online Payment"},{"value":3,"label":"Pending Review"},{"value":4,"label":"Needs Correction"},{"value":5,"label":"Rejected"},{"value":6,"label":"Draft"}]},{"type":"dateRange","name":"DATE_RANGE","label":"Date range","defaultValue":{"start":null,"end":null}}]},{"label":"Notary","component":"Notary","parameter":"notary","sourceTypeId":850,"myWorkQueueSearch":false,"allowEmptySearchTerm":true,"requestCertificateAlternateLabel":"Download Certificate","fileAmendmentButtonLabel":"Filing Actions","hideNameRequestCertificate":true,"hideAddressRequestCertificate":true,"hideRecordUserManagment":true,"searchPlaceholder":"Search by name or commission number","searchMustHaveOneOf":["CITY","search","SERVICE_TYPE"],"advancedParametersStartOpen":true,"searchIsSortable":true,"advancedSearchParameters":[{"type":"radio","name":"STARTS_WITH_YN","defaultValue":false,"options":[{"value":true,"label":"Starts with"},{"value":false,"label":"Contains"}]},{"type":"checkbox","name":"ACTIVE_ONLY_YN","defaultValue":true,"label":"Active entities only"},{"type":"text","name":"CITY","defaultValue":"","label":"City"},{"type":"select","name":"SERVICE_TYPE","label":"Special Services Offered","defaultValue":0,"options":[{"value":0,"label":"(N/A)"},{"value":6165,"label":"In-Person Electronic Notarization (IPEN)"},{"value":6166,"label":"Remote Online Notarization (RON)"},{"value":6167,"label":"Mobile Notary Services"},{"value":6168,"label":"Remote Ink Notarization (RIN)"}]}]},{"label":"Apostille","component":"Apostille","parameter":"apostille","sourceTypeId":720,"myRecordsSearch":false,"myWorkQueueSearch":false,"disabled":false,"allowedRoutes":["/forms-manager/","/queue/","/forms/"]},{"label":"Liens","component":"UCC","parameter":"ucc","sourceTypeId":1999,"myRecordsSearch":true,"myWorkQueueSearch":true,"fileAmendmentButtonLabel":"Filing Actions","searchPlaceholder":"Search by name or file number","disabled":false,"serverWebSearchDescription":true,"myRecordsDescription":"","workQueueDescription":"","searchDescription":"","hideRecordUserManagment":true,"searchLiensCheckout":false,"advancedSearchParameters":[{"type":"radio","name":"STARTS_WITH_YN","defaultValue":false,"options":[{"value":true,"label":"Starts with"},{"value":false,"label":"Contains"}]},{"type":"select","name":"STATUS","defaultValue":"ALL","label":"Status","options":[{"value":"ACTIVE_UNLAPSED","label":"Active (unlapsed)"},{"value":"ACTIVE_LAPSED_UNLAPSED","label":"Active (lapsed and unlapsed)"}]},{"type":"text","name":"EXCLUDE_VALUES","label":"Exclude Debtor Names (comma separated list of names to exclude)","defaultValue":""},{"type":"dateRange","name":"FILING_DATE","label":"Financing Statement Date","defaultValue":{"start":null,"end":null}},{"type":"dateRange","name":"LAPSE_DATE","label":"Lapse Date","defaultValue":{"start":null,"end":null}},{"type":"text","name":"CITY","label":"Debtor City","defaultValue":""}],"myRecordsFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Approved"},{"value":2,"label":"Pending Online Payment"},{"value":3,"label":"Pending Review"}]},{"type":"select","name":"TYPE","defaultValue":0,"label":"Lien Type","options":[{"value":0,"label":"All"},{"value":1,"label":"UCC"},{"value":2,"label":"EFS"},{"value":3,"label":"Title 71"}]}],"myWorkQueueFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Approved"},{"value":2,"label":"Pending Online Payment"},{"value":3,"label":"Pending Review"},{"value":4,"label":"Pending Print and Mail"},{"value":5,"label":"Rejected"},{"value":6,"label":"Draft"}]},{"type":"select","name":"TYPE","defaultValue":0,"label":"Lien Type","options":[{"value":0,"label":"All"},{"value":1,"label":"UCC"},{"value":2,"label":"EFS"},{"value":3,"label":"Title 71"}]}]},{"label":"Copy Request","component":"copies","parameter":"copies","sourceTypeId":2001,"myRecordsSearch":false,"myWorkQueueSearch":false,"disabled":false,"allowedRoutes":["/forms-manager/","/queue/","/forms/"]},{"label":"Trademark","component":"Trademark","parameter":"trademark","sourceTypeId":810,"showRequestCertificate":true,"searchMustHaveOneOf":["search","EXPIRATION_DATE","FILING_DATE"],"allowEmptySearchTerm":true,"requestCertificateAlternateLabel":"Request Information","fileAmendmentButtonLabel":"Filing Actions","advancedSearchParameters":[{"type":"radio","name":"QUERY_TYPE_ID","defaultValue":1010,"options":[{"value":1010,"label":"Starts with"},{"value":1011,"label":"Contains"},{"value":1012,"label":" Word Contains"}]},{"type":"checkbox","name":"OWNER_SEARCH_YN","defaultValue":false,"label":"Search owners"},{"type":"radio","name":"SERVICE_MARK_YN","label":"Mark Type","defaultValue":"","options":[{"value":"","label":"All Marks"},{"value":"Y","label":"Service Mark"},{"value":"N","label":"Trademark"}]},{"type":"serverSelect","name":"STATUS_ID","optionsSrc":"TYPE_V|TRADEMARK_STATUS_TYPE","label":"Status","placeholder":"All","defaultValue":"0"},{"type":"select","name":"DESIGN_TYPE_ID","options":[{"value":0,"label":"All"},{"value":990,"label":"Words Only"},{"value":991,"label":"Design Only"},{"value":992,"label":"Words and Design"}],"label":"Design Type","defaultValue":"0"},{"type":"dateRange","name":"FILING_DATE","label":"Registered Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}},{"type":"dateRange","name":"EXPIRATION_DATE","label":"Expiration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}}]},{"label":"Business Info Request","component":"InfoRequests","parameter":"info-request","sourceTypeId":167,"allowedRoutes":["/forms-manager/","/queue/","/forms/"]},{"label":"Data Requests","component":"DataRequests","parameter":"data-request","sourceTypeId":0,"allowedRoutes":["/forms-manager/"]},{"label":"CRA","component":"CRA","parameter":"cra","sourceTypeId":157,"myRecordsSearch":false,"searchPlaceholder":"Search by name or registered agent number","allowedRoutes":["/forms-manager/","/forms/","/records/","/queue/","/search/"],"allowEmptySearchTerm":true,"fileAmendmentButtonLabel":"Filing Actions","advancedSearchParameters":[{"type":"radio","name":"QUERY_TYPE_ID","defaultValue":1010,"options":[{"value":1010,"label":"Starts with"},{"value":1011,"label":"Contains"},{"value":1012,"label":" Word Contains"}]},{"type":"dateRange","name":"CRA_DATE","label":"Registration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}},{"type":"select","name":"STATUS_ID","label":"Status","defaultValue":0,"options":[{"value":0,"label":"All"},{"value":121,"label":"Active"},{"value":122,"label":"Inactive"}]},{"type":"select","name":"AGENT_TYPE_ID","label":"Agent Type","defaultValue":0,"options":[{"value":0,"label":"All"},{"value":460,"label":"Registered Agent"},{"value":461,"label":"Commercial Registered Agent"}]}]},{"label":"Farm Bill","component":"FarmBill","parameter":"farm-bill","path":"/lists/farm-bill","sourceTypeId":0,"myRecordsSearch":false,"allowedRules":["/search/"],"disabled":true,"searchDescription":"To perform a search, enter a debtor name. Your search results may include: exact debtor name, variations of that name and any filing that includes your search criteria. Punctuation is ignored.\n\nYou can click on \"Advanced\" to refine your search. Under “Advanced” you can search by crop, year, county and SSN/FEIN. As a registered Farm Bill Buyer with the Montana Secretary of State’s office it is important to maintain the confidentiality of the information contained within the Farm Bill Master List. The Farm Bill Master List reflects personal data, such as Social Security Numbers, which are a key piece of personal identifiable information to assist you in determining the existence of a lien against a specific debtor. The distribution of this information beyond its intended purpose is strictly prohibited.\n\nThe debtor's tax identification number has been hidden for confidentiality reasons. You may continue to search on a tax ID number and return debtors that match your search criteria. The SSN/FEIN must be entered without dashes or spaces.","searchMustHaveOneOf":["search","UCC_FARM_PRODUCT_ID","COUNTY"],"searchPlaceholder":"Search by debtor name","advancedSearchParameters":[{"type":"ServerMultiComplete","label":"Product code name(s)","name":"UCC_FARM_PRODUCT_ID","defaultValue":"","optionsSrc":"UCC_FARM_PRODUCT_V"},{"type":"MultiComplete","label":"Year or Range of Years","name":"YEAR_NUM","optionsSrc":"years","startYear":"1968","defaultValue":[],"preMergeOptions":[{"value":"ALL","label":"All"}]},{"type":"serverSelect","label":"State","name":"STATE","defaultValue":"MONTANA","optionsSrc":"STATE"},{"type":"ServerMultiComplete","label":"County","name":"COUNTY","defaultValue":[],"optionsSrc":"COUNTY","overrideSubOptionsSrcFromParameterName":"STATE"},{"type":"checkbox","name":"TIN_SEARCH_YN","defaultValue":false,"label":"Tax Identification Number Search"},{"type":"checkbox","name":"TIN_SORT_YN","defaultValue":false,"label":"Unique ID Sort"}]}],"SYSTEM_NICKNAME":"Online Services Portal","PAYMENT_METHODS":[{"type":"bypass"},{"type":"iTransact"}],"PAYMENT_ALLOW_AMEX":true,"SYSTEM_ID_LABEL":"System Id","DOUBLE_COLUMN_PUBLIC_LOGIN":true,"INTERNAL_USER_MANAGEMENT":true,"ALLOW_PUBLIC_JSON_IMPORT":false,"MAX_FILE_UPLOAD_SIZE":10000000,"REFUND_TEXT":"","RETURN_TO_HOME_ON_LOGOUT":true,"CURRENT_SOS_NAME":"Christi Jacobsen","LOGO_FILENAME":"mt-sos-logo.png","LOGO_ALT":"Christi Jacobsen, Montana Secretary of State","LOGO_FULL_WIDTH":true,"HOME_HIDE_AUTH_HINT":true,"HOME_TITLE":"Montana Secretary of State","CUSTOM_TAB_TITLE":"Official Montana","HOME_SUBTITLE":"Online Business Services","ENTITY_NAME_CONSENT_DESCRIPTION":"","ALLOW_USER_PROFILE_EDITING":true,"COMPARE_FOREIGN_NAME_IN_ENTITY_NAME_VALIDATION":true,"FOREIGN_NAME_FIELD_NAME":"KIMA_PARENT_NAME_INFO","LOGIN_TITLE":"Montana Secretary of State Online Filing Portal Login","PUBLIC_LOGIN_LABEL":"Username","REVERSE_LOGIN_COLUMNS":true,"LOGIN_SEAL_FILENAME":"seal_white.png","SEPARATE_USERNAME_AND_EMAIL":true,"CREATE_ACCOUNT_BUTTON_ALIGN_LEFT":true,"CREATE_ACCOUNT_BUTTON_TEXT":"CREATE AN ACCOUNT","PASSWORD_CUSTOM_ERROR_TEXT":"The password must meet all requirements","ACCOUNT_CREATED_MESSAGE":"Please check your email to verify your account to login and allow a few minutes for this message to arrive. Check your junk/spam folders if you do not find the email in your inbox.","PUBLIC_LOGIN_PLACEHOLDER":" ","DISABLE_DEFAULT_PAYMENT_RADIO":true,"CUSTOM_RESET_PASSWORD_ERROR_MESSAGE":"Username invalid - no account found","PUBLIC_LOGIN_CREATE_DESCRIPTION":"### Existing User:\n\n  - Enter your username and password to login.  \n\n\n  #### - OR -  \n\n\n\n  - Forgot password? Click 'Reset Password' and follow the prompts.\n  - Forgot username? Click 'Forgot Username' and follow the prompts.  \n\n\n  ### New User:\n  ","LOGIN_HELP_LINK":"https://sosmt.gov/business/how-do-i/","LOGIN_HELP_LINK_TEXT":"Need Help?","FORGOT_USERNAME_TEXT":"Forgot Username?","LOGIN_ACTIVE_DIRECTORY_TEXT":"State User Login","MULTIPLE_LOGIN_METHODS":true,"HAS_ACTIVE_DIRECTORY_LOGIN":true,"RESET_PASSWORD_WITH_USERNAME":true,"DOWNLOAD_LINK":true,"SHOW_USERNAME_ACCOUNT_CREATE":true,"SHOW_SCROLL_DOWN_ARROW":true,"SHOW_ADDRESS_ACCOUNT_CREATE":true,"TWO_COLUMN_ACCOUNT_CREATE":true,"RESET_PASSWORD_TIP":"A link to change your password has been sent to your email. Please allow a few minutes for this message to arrive. Please check your junk/spam folders if you do not find the email in your inbox.","FORGOT_PASSWORD_LINK_TEXT":"Reset Password","PHONE_NUMBER_OPTIONAL_ACCOUNT_CREATE":true,"SHOW_REQUIRED_INDICATOR_ACCOUNT_CREATE":true,"PASSWORD_REQUIREMENTS_ACCOUNT_CREATE":"\n    <ul>\n      <li>MUST contain at least 8 characters (12+ recommended)</li>\n      <li>MUST contain at least one uppercase letter.</li>\n      <li>MUST contain at least one lowercase letter.</li>\n      <li>MUST contain at least one number.</li>\n      <li>MUST contain at least one special character (!”#$%&'()*+,-./:;<=>?</li>\n    </ul>\n  ","ALLOW_CERTIFICATION_REQUEST":true,"ALLOW_PUBLIC_CERTIFICATE_REQUEST":true,"ALLOW_COPY_REQUEST":false,"ALLOW_CORRECTION_STYLING":true,"HIDE_DEPRECATION_WARNING":false,"AMEND_ROUTE_PUBLIC":true,"SEAL_FILENAME":"seal.png","SHOPPING_CART":true,"ALLOW_PAYMENT_UPDATE_WITH_EMPTY_CART":true,"RA_EMAIL":true,"RA_WEBSITE":true,"RA_NO_DEFAULT_TYPE":true,"RA_ADDRESS_LABEL":"Street Address","RA_TYPE_SELECTION_DEFAULT":true,"RA_DEFAULT_TYPE":"460","RA_OVERRIDE_TYPE_WITH_DEFAULT":true,"RA_PRINCIPAL_ADDRESS_AMS":true,"UPLOAD_AND_SUBMIT_HIDE_IF_ONE_OPTION":true,"PAYMENT_PROCESSING_MESSAGE":"Your payment is processing - Do not close your browser or click the back button","CHECKOUT_BUTTON_WHEN_PROCESSING_TEXT":"Processing","EFS_CROP_PICKER_NONE_LABEL":"Lien Duration","DISALLOWED_WIZARD_PIECES":["FormationLocale"],"REPEATER_SHOW_EDIT_BUTTON":true,"DATA_REQUEST_PAGE_TITLE":"Data Requests and Subscriptions","DATA_REQUEST_SIDEBAR_LABEL":"Data Requests & Subscriptions","LOGIN_REDIRECTS_TO_EPASS":false,"LOGIN_REDIRECTS_TO_ACTIVE_DIRECTORY":true,"LOGIN_ACTIVE_DIRECTORY_LINK":true,"FETCH_EDIT_USER_LINK":false,"LISTS_FETCH_AVAILABLE_LISTS":true,"POST_WIZARD_SUBMIT_REDIRECT_URL":"/","PIN_REQUEST_ATTESTATIONS":true,"PIN_REQUEST_DESCRIPTION":"Click **Request PIN** to have a new PIN sent to the account holder's email address on file.","OWNERSHIP_REQUEST_DESCRIPTION":"To become an **authorized user** of this record, a current **AUTHORIZED USER** will need to grant you access. To request access, click **Request Access** below.","PIN_REQUEST_SUCCESS_MESSAGE":"The PIN you have requested for this entity has been sent to the email associated with your user account.  You should receive the PIN in approximately 3-5 minutes, depending on your email service provider.","APOSTILLE_HEADER_LABEL":"Verification Information","APOSTILLE_NUMBER_LABEL":"Apostille/Authentication","APOSTILLE_CITY_STATE_OVERRIDE":"HELENA, MT","APOSTILLE_FILING_DATE_LABEL":"Issue Date","APOSTILLE_CITY_STATE_IN_CERTIFIED":true,"NOTARY_EXISTING_FILING":true,"ALLOW_REVOKE_OWN_ACCESS_ONLY":false,"HIDE_CANCEL_ON_ONETIME_DATA_REQUESTS":true,"DATA_REQUESTS_IN_SHOPPING_CART":true,"WQ_ALLOW_EDIT_PENDING_PAYMENT":true,"WQ_CONFIRM_ON_DELETE":true,"WQ_DELETE_CONFIRM_MESSAGE":"Deleting this filing will forfeit any money already paid to the Secretary of State. This action is permanent and cannot be undone, are you sure you would like to delete?","PASS_ITEM_GUIDS_ON_CHECKOUT":true,"FORM_REVISION_HISTORY":true,"CHECKOUT_DISCLAIMER":"By entering your credit card and/or checking account information you (i) state that **you are an authorized user** of the credit card and/or electronic check and that the associated information entered (e.g., account holder name, account number, billing address) is accurate, (ii) **you authorize payment processor to charge the amount you have requested** to your credit card and/or funding account, and (iii) **acknowledge if a charge is declined or reversed you may also be assessed a customary charge** by the payment processor for such transactions.","FARM_BILL_SEARCH_CONFIDENTIAL":"As a registered Farm Bill Buyer with the Montana Secretary of State’s office it is important to maintain the confidentiality of the information contained within the Farm Bill Master List. The Farm Bill Master List reflects personal data, such as Social Security Numbers, which are a key piece of personal identifiable information to assist you in determining the existence of a lien against a specific debtor. The distribution of this information beyond its intended purpose is strictly prohibited.\n\n**The debtor's tax identification number has been hidden for confidentiality reasons. You may continue to search on a tax ID number and return debtors that match your search criteria. The SSN/FEIN must be entered without dashes or spaces.  If you need access to the tax identification number to clearly identify the debtor, please contact the UCC unit at (406) 444-3665.**","VIEW_HISTORY_BUTTON_ALT_TEXT":"View Filings","WIZARD_ERROR_TITLE_MESSAGE":"Form Error","FARM_BILL_SEARCH_INTERACTIVE":true,"USE_FARM_BILL_API":true,"DISALLOW_ASSIGN_SELF_AS_RA":true,"DISALLOW_ASSIGN_SELF_AS_PRINCIPAL":true,"USE_TRADEMARK_OWNER_VALIDATION":true,"USE_ALTERNATIVE_FOREIGN_ADDRESS_LABELS":true,"MY_RECEIPTS_FILTER":[{"type":"dateRange","name":"DATE_RANGE","label":"Date range","defaultValue":{"start":null,"end":null}},{"type":"text","name":"REF_NUM","defaultValue":"","label":"Reference Number"},{"type":"text","name":"RECEIPT_NUM","defaultValue":"","label":"Receipt Id"},{"type":"text","name":"AMOUNT","defaultValue":"","label":"Amount"},{"type":"select","name":"TYPE","defaultValue":"","label":"Payment Type","options":[{"value":"","label":"All"},{"value":"CC","label":"Credit Card"},{"value":"Check","label":"Check"}]}],"MY_RECEIPTS_SHOW_IN_SIDEBAR":true,"SHOW_MY_RECEIPTS_HELPER_TEXT":true,"MY_RECEIPTS_HELPER_LABEL":"About Receipt Search","MY_RECEIPTS_HELPER_TEXT":"You can search for receipts based on their descriptions, including the items paid for on the receipt. Use the filters to search for or filter specific information.","FARM_BILL_SUBLINK":{"label":"Farm Bill","component":"FarmBill","parameter":"farm-bill","path":"/lists/farm-bill","sourceTypeId":0,"myRecordsSearch":false,"allowedRules":["/search/"],"disabled":true,"searchDescription":"To perform a search, enter a debtor name. Your search results may include: exact debtor name, variations of that name and any filing that includes your search criteria. Punctuation is ignored.\n\nYou can click on \"Advanced\" to refine your search. Under “Advanced” you can search by crop, year, county and SSN/FEIN. As a registered Farm Bill Buyer with the Montana Secretary of State’s office it is important to maintain the confidentiality of the information contained within the Farm Bill Master List. The Farm Bill Master List reflects personal data, such as Social Security Numbers, which are a key piece of personal identifiable information to assist you in determining the existence of a lien against a specific debtor. The distribution of this information beyond its intended purpose is strictly prohibited.\n\nThe debtor's tax identification number has been hidden for confidentiality reasons. You may continue to search on a tax ID number and return debtors that match your search criteria. The SSN/FEIN must be entered without dashes or spaces.","searchMustHaveOneOf":["search","UCC_FARM_PRODUCT_ID","COUNTY"],"searchPlaceholder":"Search by debtor name","advancedSearchParameters":[{"type":"ServerMultiComplete","label":"Product code name(s)","name":"UCC_FARM_PRODUCT_ID","defaultValue":"","optionsSrc":"UCC_FARM_PRODUCT_V"},{"type":"MultiComplete","label":"Year or Range of Years","name":"YEAR_NUM","optionsSrc":"years","startYear":"1968","defaultValue":[],"preMergeOptions":[{"value":"ALL","label":"All"}]},{"type":"serverSelect","label":"State","name":"STATE","defaultValue":"MONTANA","optionsSrc":"STATE"},{"type":"ServerMultiComplete","label":"County","name":"COUNTY","defaultValue":[],"optionsSrc":"COUNTY","overrideSubOptionsSrcFromParameterName":"STATE"},{"type":"checkbox","name":"TIN_SEARCH_YN","defaultValue":false,"label":"Tax Identification Number Search"},{"type":"checkbox","name":"TIN_SORT_YN","defaultValue":false,"label":"Unique ID Sort"}]},"ALLOW_ADDRESS_VALIDATION_BYPASS_OPTION":true,"DEFAULT_ADDRESS_VALIDATION_BYPASS_OPTION_CHECKED":true}).ALLOW_SHOW_AR_WHEN_LOGGED_IN) _this.setState({ canAccessARLoggedIn: true });else _this.setState({ canAccessARLoggedIn: false });
	      }, console.error);
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(RecordDrawer, [{
	    key: "render",
	    value: function render() {
	      var _this2 = this;
	
	      var _props = this.props,
	          show = _props.show,
	          onSidebarDismiss = _props.onSidebarDismiss,
	          _props$category = _props.category,
	          category = _props$category === undefined ? "business" : _props$category,
	          sourceId = _props.sourceId,
	          recordNum = _props.recordNum,
	          canFileAR = _props.canFileAR,
	          canAlwaysFileAR = _props.canAlwaysFileAR,
	          canReinstate = _props.canReinstate,
	          canFileReinstatement = _props.canFileReinstatement,
	          loggedIn = _props.loggedIn,
	          showCopyRequests = _props.showCopyRequests,
	          sublink = _props.sublink,
	          userOwnsCurrentRecord = _props.userOwnsCurrentRecord,
	          siteOffline = _props.siteOffline,
	          uccEfsProductID = _props.uccEfsProductID,
	          uccSecuredPartyID = _props.uccSecuredPartyID,
	          uccDebtorID = _props.uccDebtorID,
	          uccFilingID = _props.uccFilingID;
	
	      var annualReportCategory = this.ANNUAL_REPORT_OPTIONS()[category] || {};
	      var userOwnsRecord = this.state.userOwnsCurrentRecord || userOwnsCurrentRecord;
	      var disableARButton = this.state.unavailableARMessage || this.state.unavailableReinstatementMessage || this.state.unavailableRenewalMessage;
	      var arTooltipMessage = this.state.unavailableARMessage ? this.state.unavailableARMessage : this.state.unavailableReinstatementMessage ? this.state.unavailableReinstatementMessage : this.state.unavailableRenewalMessage ? this.state.unavailableRenewalMessage : annualReportCategory.tooltip;
	
	      return _react2.default.createElement(
	        _react.Fragment,
	        null,
	        _react2.default.createElement(
	          _Shell.Drawer,
	          {
	            show: show ? true : false,
	            title: this.state.title,
	            subtitle: this.state.subtitle,
	            onSidebarDismiss: onSidebarDismiss,
	            showCloseButton: true,
	            alwaysShowClosebutton: true
	          },
	          _react2.default.createElement(
	            "div",
	            { className: "" + (this.state.loadingOwnership && !userOwnsCurrentRecord || this.state.loadingDetails ? 'record-loading' : '') },
	            _react2.default.createElement(
	              _ActionButton.ActionButtonGroup,
	              { className: "details-actions-top" },
	              (this.state.alwaysShowAmendmentButton || AMENDMENTS_ALWAYS_ALLOWED_WHEN_LOGGED_IN && loggedIn || !this.state.hideAmendmentButton && userOwnsRecord && (!this.state.loadingOwnership || userOwnsCurrentRecord)) && _react2.default.createElement(_ActionButton2.default, {
	                label: sublink.fileAmendmentButtonLabel || "File Amendment",
	                children: _react2.default.createElement(_documentEdit2.default, null),
	                onClick: this.toggleAmendmentLauncher,
	                tooltip: RD_TOOLTIP_AMENDMENT
	              }),
	              (canAlwaysFileAR || this.state.canAccessARLoggedIn || (canReinstate || canFileAR) && userOwnsRecord && (!this.state.loadingOwnership || userOwnsCurrentRecord) && (ALLOW_REINSTATEMENT_AR_MODAL || canFileAR)) && _react2.default.createElement(_ActionButton2.default, {
	                label: annualReportCategory.label,
	                iconClass: "icon icon-report",
	                onClick: annualReportCategory.onClickFn,
	                tooltip: arTooltipMessage,
	                disabled: disableARButton
	              }),
	              sublink.showRequestCertificate !== false && (ALLOW_CERTIFICATION_REQUEST !== false && userOwnsRecord && (!this.state.loadingOwnership || userOwnsCurrentRecord) || ALLOW_PUBLIC_CERTIFICATE_REQUEST) && this.state.hideCertButton !== true && !siteOffline && _react2.default.createElement(_ActionButton2.default, {
	                label: sublink.requestCertificateAlternateLabel || "Request Certificate",
	                children: _react2.default.createElement(_certificate2.default, null),
	                onClick: this.getConfigAndOpenCertificateModal,
	                tooltip: RD_TOOLTIP_CERTIFICATE
	              })
	            ),
	            (this.state.details || []).length > 0 && _react2.default.createElement(_DetailsList2.default, { details: this.state.details }),
	            _react2.default.createElement(
	              _ActionButton.ActionButtonGroup,
	              { className: "details-actions-bottom" },
	              this.state.hideHistory ? null : _react2.default.createElement(
	                _RecordHistory.ConnectedRecordHistory,
	                {
	                  category: category,
	                  amendmentNum: recordNum,
	                  userOwnsRecord: userOwnsRecord
	                },
	                function (_ref3) {
	                  var openModal = _ref3.openModal,
	                      loading = _ref3.loading;
	                  return _react2.default.createElement(_ActionButton2.default, {
	                    label: VIEW_HISTORY_BUTTON_ALT_TEXT ? VIEW_HISTORY_BUTTON_ALT_TEXT : "View History",
	                    onClick: openModal,
	                    loading: loading,
	                    disabled: _this2.state.loadingOwnership && !userOwnsCurrentRecord,
	                    children: _react2.default.createElement(_history2.default, null),
	                    tooltip: RD_TOOLTIP_HISTORY
	                  });
	                }
	              ),
	              !siteOffline && sublink.hideRecordUserManagment !== true ? loggedIn && userOwnsRecord && !this.state.userAccessRevoked && !this.state.hideManageAccess ? _react2.default.createElement(_ActionButton2.default, {
	                label: "Manage User Access",
	                onClick: this.toggleOwnershipModal,
	                disabled: this.state.loadingOwnership && !userOwnsRecord,
	                children: _react2.default.createElement(_userGroup2.default, null),
	                tooltip: RD_TOOLTIP_USER_ACCESS
	              }) : (loggedIn || SHOW_REQUEST_ACCESS_PUBLIC) && this.state.currentRecordHasOwners ? this.state.hideRequestAccess ? null : _react2.default.createElement(_ActionButton2.default, {
	                label: "Request Access",
	                onClick: this.toggleRequestOwnershipModal,
	                disabled: this.state.loadingOwnership && !userOwnsRecord,
	                children: _react2.default.createElement(_userGroup2.default, null),
	                tooltip: RD_TOOLTIP_USER_ACCESS
	              }) : (loggedIn || SHOW_REQUEST_ACCESS_PUBLIC) && !this.state.hideRequestAccess && _react2.default.createElement(_ActionButton2.default, {
	                label: "Request Access",
	                onClick: this.togglePinsModal,
	                disabled: this.state.loadingOwnership && !userOwnsRecord,
	                children: _react2.default.createElement(_userGroup2.default, null),
	                tooltip: RD_TOOLTIP_USER_ACCESS
	              }) : null,
	              showCopyRequests && ALLOW_COPY_REQUEST && !siteOffline && _react2.default.createElement(_ActionButton2.default, {
	                label: "Copy Requests",
	                iconClass: "icon icon-download",
	                onClick: null
	              })
	            )
	          )
	        ),
	        _react2.default.createElement(
	          _Portal2.default,
	          { isOpened: this.state.ownershipModalOpen },
	          _react2.default.createElement(
	            _Modal.Modal,
	            {
	              title: "Manage User Access",
	              closeModal: this.toggleOwnershipModal,
	              modalSize: "large",
	              ref: function ref(ownershipModal) {
	                _this2.ownershipModal = ownershipModal;
	              },
	              closeButton: true
	            },
	            _react2.default.createElement(_Ownership2.default, {
	              category: category,
	              source_id: sourceId,
	              onRequestModalClose: this.closeOwnershipModalAndRefreshRecords,
	              onAccessRevoked: this.handleAccessRevoked
	            })
	          )
	        ),
	        _react2.default.createElement(
	          _Portal2.default,
	          { isOpened: this.state.pinsModalOpen },
	          _react2.default.createElement(
	            _Modal.Modal,
	            {
	              title: "Request Access",
	              closeModal: this.togglePinsModal,
	              modalSize: "short",
	              hideHeader: true,
	              closeButton: true,
	              ref: function ref(_ref4) {
	                return _this2.pinsModal = _ref4;
	              }
	            },
	            _react2.default.createElement(_Pins2.default, {
	              category: category,
	              source_id: sourceId,
	              onRequestModalClose: this.togglePinsModal,
	              onPinSuccess: this.swapRequestAndOwnershipModals
	            })
	          )
	        ),
	        _react2.default.createElement(
	          _Portal2.default,
	          { isOpened: this.state.requestOwnershipModal },
	          _react2.default.createElement(
	            _Modal.Modal,
	            {
	              title: "Request Ownership",
	              closeModal: this.toggleRequestOwnershipModal,
	              ref: function ref(requestOwnershipModal) {
	                return _this2.requestOwnershipModal = requestOwnershipModal;
	              },
	              modalSize: "short",
	              hideHeader: true,
	              closeButton: true
	            },
	            loggedIn ? _react2.default.createElement(_RequestOwnership2.default, {
	              category: category,
	              source_id: sourceId,
	              onRequestModalClose: this.closeRequestOwnershipModal
	            }) : _react2.default.createElement(_LoginRedirector.LoginRedirectSwitch, { location: location })
	          )
	        ),
	        _react2.default.createElement(
	          _Portal2.default,
	          { isOpened: this.state.amendmentLauncherOpen },
	          _react2.default.createElement(
	            _Modal.Modal,
	            {
	              title: sublink.fileAmendmentButtonLabel || "File Amendment",
	              closeModal: this.toggleAmendmentLauncher,
	              ref: function ref(amendmentLauncher) {
	                return _this2.amendmentLauncher = amendmentLauncher;
	              },
	              modalSize: "small",
	              closeButton: true
	              // autoHeight
	            },
	            _react2.default.createElement(_AmendmentLauncher2.default, { filingNum: recordNum, category: category })
	          )
	        ),
	        _react2.default.createElement(
	          _Portal2.default,
	          { isOpened: this.state.reinstatementModalOpen },
	          _react2.default.createElement(
	            _Modal.Modal,
	            {
	              title: "Reinstate",
	              closeModal: this.toggleReinstatementModal,
	              ref: function ref(_ref5) {
	                return _this2.reinstatementModal = _ref5;
	              },
	              modalSize: "small",
	              closeButton: true,
	              autoHeight: true
	            },
	            _react2.default.createElement(_ReinstatementLauncher2.default, {
	              filingNum: recordNum,
	              category: category,
	              canFileAR: canFileAR,
	              canFileReinstatement: canFileReinstatement,
	              unavailableARMessage: this.state.unavailableARMessage,
	              unavailableReinstatementMessage: this.state.unavailableReinstatementMessage
	            })
	          )
	        ),
	        _react2.default.createElement(
	          _Portal2.default,
	          { isOpened: this.state.certificateModalOpen },
	          _react2.default.createElement(
	            _Modal.Modal,
	            {
	              title: sublink.requestCertificateAlternateLabel || "Request Certificate",
	              closeModal: this.toggleCertificateModalOpen,
	              ref: function ref(_ref6) {
	                _this2.certificateModal = _ref6;
	              },
	              modalSize: "small",
	              closeButton: true,
	              autoHeight: true
	            },
	            _react2.default.createElement(_RequestCertificate2.default, {
	              ref: function ref(r) {
	                _this2.certificateForm = r;
	              },
	              config: this.state.certificateConfig,
	              onCertificateRequested: this.createCertification,
	              hideNameField: sublink.hideNameRequestCertificate,
	              hideAddressBlock: sublink.hideAddressRequestCertificate
	            })
	          )
	        ),
	        _react2.default.createElement(
	          _Portal2.default,
	          { isOpened: this.state.certificateCheckoutOpen },
	          _react2.default.createElement(
	            _SlidingPanel2.default,
	            {
	              closeOnShadeClick: false,
	              closeSlider: this.cancelCertificateCheckout,
	              ref: function ref(r) {
	                _this2.certificateSlider = r;
	              },
	              ariaLabel: "Checkout"
	            },
	            _react2.default.createElement(_Checkout2.default, {
	              cancelCheckout: this.cancelCertificateCheckout,
	              redirectToReceipt: this.redirectToReceipt,
	              amendmentNum: 0,
	              formDefinitionId: 0,
	              category: category,
	              correctionMode: false,
	              receiptItems: this.state.certificateReceiptItems,
	              receiptItemContainers: SHOPPING_CART ? this.state.certificateReceiptItemContainers : null,
	              refNum: this.state.certificateRefNum
	            })
	          )
	        ),
	        _react2.default.createElement(
	          _Portal2.default,
	          { isOpened: this.state.arConfirmOpen },
	          _react2.default.createElement(_Modal.ConfirmDialog, {
	            closeModal: function closeModal() {
	              return _this2.setState({ arConfirmOpen: false });
	            },
	            sizeOverride: "toast toast-wide",
	            leftAligned: true,
	            onModalClosed: _utilities.noop,
	            message: _react2.default.createElement(
	              "span",
	              null,
	              "You are about to complete an online form for the record below.\xA0 Review the information to ensure this is the correct record:",
	              _react2.default.createElement("br", null),
	              _react2.default.createElement("br", null),
	              _react2.default.createElement(
	                "strong",
	                null,
	                "Name"
	              ),
	              ": ",
	              this.state.title,
	              " ",
	              _react2.default.createElement("br", null),
	              _react2.default.createElement(
	                "strong",
	                null,
	                "SOS Control ID#"
	              ),
	              ": ",
	              recordNum,
	              _react2.default.createElement("br", null),
	              _react2.default.createElement(
	                "strong",
	                null,
	                "Record Type"
	              ),
	              ": ",
	              category === 'business' ? this.state.subtitle : sublink.label,
	              _react2.default.createElement("br", null),
	              _react2.default.createElement("br", null),
	              "Is this the correct record for which you wish to complete the online form?"
	            ),
	            buttons: [{
	              label: 'Yes',
	              onClick: this.state.arConfirmFunction,
	              className: 'btn-primary'
	            }, { label: 'No', onClick: _utilities.noop, className: 'btn-default' }],
	            modalStyle: { borderRadius: 3 }
	          })
	        )
	      );
	    }
	  }]);
	
	  return RecordDrawer;
	}(_react2.default.Component);
	
	exports.default = (0, _reactRedux.connect)(function (state) {
	  return {
	    loggedIn: state.auth.loggedIn,
	    siteOffline: state.app.appSettings.WEBSITE_PORTAL_OFFLINE_YN === true,
	    location: state.router.location
	  };
	})(RecordDrawer);

/***/ },
/* 466 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Result = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	__webpack_require__(1462);
	
	var _reactOnclickoutside = __webpack_require__(153);
	
	var _reactOnclickoutside2 = _interopRequireDefault(_reactOnclickoutside);
	
	var _utilities = __webpack_require__(8);
	
	var _Form = __webpack_require__(14);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// import reactStringReplace from 'react-string-replace'
	
	var ResultsDrawer = function (_Component) {
	  _inherits(ResultsDrawer, _Component);
	
	  function ResultsDrawer() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, ResultsDrawer);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = ResultsDrawer.__proto__ || Object.getPrototypeOf(ResultsDrawer)).call.apply(_ref, [this].concat(args))), _this), _this.handleClickOutside = function (e) {
	      if (_this.props.onOutsideClick && _this.props.open) {
	        _this.props.onOutsideClick();
	      }
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(ResultsDrawer, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          results = _props.results,
	          _props$loading = _props.loading,
	          loading = _props$loading === undefined ? false : _props$loading;
	
	      console.log(results);
	      return _react2.default.createElement(
	        'div',
	        { className: 'results-drawer' },
	        loading ? _react2.default.createElement(
	          'span',
	          { className: 'loading' },
	          'Loading...'
	        ) : results.map(function (result, i) {
	          return _react2.default.createElement(Result, { data: result, key: result.SOURCE_ID || i });
	        })
	      );
	    }
	  }]);
	
	  return ResultsDrawer;
	}(_react.Component);
	
	exports.default = (0, _reactOnclickoutside2.default)(ResultsDrawer);
	
	var Result = exports.Result = function (_Component2) {
	  _inherits(Result, _Component2);
	
	  function Result() {
	    var _ref2;
	
	    var _temp2, _this2, _ret2;
	
	    _classCallCheck(this, Result);
	
	    for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
	      args[_key2] = arguments[_key2];
	    }
	
	    return _ret2 = (_temp2 = (_this2 = _possibleConstructorReturn(this, (_ref2 = Result.__proto__ || Object.getPrototypeOf(Result)).call.apply(_ref2, [this].concat(args))), _this2), _this2.onClick = function () {
	      if (!_this2.props.selectable) {
	        if (_this2.props.onClick) {
	          _this2.props.onClick(_this2.props.data);
	        }
	      } else {
	        if (_this2.props.onSelectToggled) {
	          _this2.props.onSelectToggled(!_this2.props.isSelected);
	        }
	      }
	    }, _temp2), _possibleConstructorReturn(_this2, _ret2);
	  }
	
	  _createClass(Result, [{
	    key: 'render',
	    value: function render() {
	      var _props2 = this.props,
	          _props2$className = _props2.className,
	          className = _props2$className === undefined ? '' : _props2$className,
	          children = _props2.children,
	          data = _props2.data,
	          highlight = _props2.highlight,
	          selectable = _props2.selectable,
	          isSelected = _props2.isSelected,
	          onSelectToggled = _props2.onSelectToggled;
	
	      var disabled = !!data.DISABLED;
	      return _react2.default.createElement(
	        this.props.element,
	        {
	          type: 'button',
	          className: 'stacked-data-result ' + className,
	          onClick: !disabled ? this.onClick : undefined,
	          disabled: disabled
	        },
	        _react2.default.createElement(
	          'div',
	          { className: 'flex-row' },
	          selectable ? _react2.default.createElement(
	            'div',
	            { className: 'result-checkbox-wrapper wizard' },
	            _react2.default.createElement(_Form.Checkbox, {
	              'aria-label': 'Select this result',
	              value: isSelected,
	              onChange: function onChange(checked, e) {
	                e.stopPropagation();
	                onSelectToggled(checked, e);
	              }
	            })
	          ) : null,
	          _react2.default.createElement(
	            'div',
	            { className: 'flex-column' },
	            children,
	            _react2.default.createElement(ResultLine, { type: 'h1', highlight: highlight, value: data.HEADER1 }),
	            _react2.default.createElement(ResultLine, { type: 'subtitle', highlight: highlight, value: data.HEADER2 }),
	            data && data.SECTIONS && data.SECTIONS.map(function (section, i) {
	              return _react2.default.createElement(
	                _react2.default.Fragment,
	                { key: i },
	                _react2.default.createElement(ResultLine, { type: 'h2', highlight: highlight, value: section.label }),
	                section.lines && _react2.default.createElement(
	                  'p',
	                  { className: 'lines' },
	                  section.lines.map(function (_ref3, j) {
	                    var line = _ref3.line;
	                    return _react2.default.createElement(ResultLine, { type: 'line', highlight: highlight, value: line, key: j });
	                  })
	                )
	              );
	            })
	          )
	        )
	      );
	    }
	  }]);
	
	  return Result;
	}(_react.Component);
	
	Result.defaultProps = {
	  element: 'div'
	};
	
	var ResultLine = function (_Component3) {
	  _inherits(ResultLine, _Component3);
	
	  function ResultLine() {
	    var _ref4;
	
	    var _temp3, _this3, _ret3;
	
	    _classCallCheck(this, ResultLine);
	
	    for (var _len3 = arguments.length, args = Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
	      args[_key3] = arguments[_key3];
	    }
	
	    return _ret3 = (_temp3 = (_this3 = _possibleConstructorReturn(this, (_ref4 = ResultLine.__proto__ || Object.getPrototypeOf(ResultLine)).call.apply(_ref4, [this].concat(args))), _this3), _this3.getByType = function () {
	      var _this3$props = _this3.props,
	          type = _this3$props.type,
	          value = _this3$props.value;
	
	      switch (type) {
	        case 'address':
	          return value ? _react2.default.createElement(_utilities.FormattedAddress, { value: value, className: 'value' }) : "None";
	        case 'h1':
	          return _react2.default.createElement(
	            'span',
	            { className: 'primary' },
	            value
	          );
	        case 'h2':
	          return _react2.default.createElement(
	            'span',
	            { className: 'secondary' },
	            value
	          );
	        case 'subtitle':
	          return _react2.default.createElement(
	            'span',
	            { className: 'subtitle' },
	            value
	          );
	        case 'line':
	          return _react2.default.createElement(
	            'span',
	            { className: 'value' },
	            value
	          );
	        default:
	          return _react2.default.createElement(
	            'span',
	            null,
	            value
	          );
	      }
	    }, _temp3), _possibleConstructorReturn(_this3, _ret3);
	  }
	
	  _createClass(ResultLine, [{
	    key: 'render',
	    value: function render() {
	      var value = this.getByType();
	      return value;
	    }
	  }]);
	
	  return ResultLine;
	}(_react.Component);

/***/ },
/* 467 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function () {
	  var _React$useState = _react2.default.useState(false),
	      _React$useState2 = _slicedToArray(_React$useState, 2),
	      loaded = _React$useState2[0],
	      setLoaded = _React$useState2[1];
	
	  var script = _react2.default.useRef();
	  _react2.default.useEffect(function () {
	    if (!window.iTransact) {
	      script.current = document.createElement('script');
	      script.current.type = 'text/javascript';
	      script.current.src = 'https://js.itransact.com/itransact.js';
	      document.head.appendChild(script.current);
	      script.current.onload = function (e) {
	        setLoaded(true);
	      };
	    } else {
	      setLoaded(true);
	    }
	  }, []);
	  return loaded;
	};

/***/ },
/* 468 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.SearchBox = exports.ConnectedSearchBox = exports.Search = undefined;
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(7);
	
	var _reactRouterDom = __webpack_require__(30);
	
	var _Table = __webpack_require__(150);
	
	var _Table2 = _interopRequireDefault(_Table);
	
	var _Shell = __webpack_require__(19);
	
	var _Loaders = __webpack_require__(16);
	
	var _requests = __webpack_require__(6);
	
	var _SearchActions = __webpack_require__(469);
	
	var _printSolid = __webpack_require__(583);
	
	var _printSolid2 = _interopRequireDefault(_printSolid);
	
	var _RecordDrawer = __webpack_require__(465);
	
	var _RecordDrawer2 = _interopRequireDefault(_RecordDrawer);
	
	var _Markdown = __webpack_require__(24);
	
	var _Markdown2 = _interopRequireDefault(_Markdown);
	
	var _utilities = __webpack_require__(8);
	
	var _App = __webpack_require__(118);
	
	var _AdvancedParameters = __webpack_require__(1131);
	
	var _AdvancedParameters2 = _interopRequireDefault(_AdvancedParameters);
	
	var _SlidingPanel = __webpack_require__(101);
	
	var _SlidingPanel2 = _interopRequireDefault(_SlidingPanel);
	
	var _Portal = __webpack_require__(12);
	
	var _Portal2 = _interopRequireDefault(_Portal);
	
	var _Checkout = __webpack_require__(67);
	
	var _Checkout2 = _interopRequireDefault(_Checkout);
	
	__webpack_require__(1464);
	
	var _Pager = __webpack_require__(1123);
	
	var _Pager2 = _interopRequireDefault(_Pager);
	
	var _EmptySearchPlaceholder = __webpack_require__(1132);
	
	var _EmptySearchPlaceholder2 = _interopRequireDefault(_EmptySearchPlaceholder);
	
	var _SearchError = __webpack_require__(1134);
	
	var _SearchError2 = _interopRequireDefault(_SearchError);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	// import Cards from '../Cards/Cards';
	
	// import ActionButton, { ActionButtonGroup } from '../ActionButton/ActionButton';
	
	
	var SEARCH_HAS_PAGINATION = ({"NODE_ENV":"production","BUILD_DATE":"2025-08-27T15:15:31.687Z","BUILD_NUMBER":"Not Provided","GIT_VERSION":"v1.3.0-381-ga81e29b08","GIT_COMMIT_HASH":"a81e29b085c9268ffd96c78eb734365802722741","GIT_BRANCH":"beta","PUBLIC_URL":"","STATE_ABBR":"MT","STATE_NAME":"Montana","STATE_ORG_TITLE":"Secretary of State","LOGIN_HEADER_IMG_PATH":"","HOME_IMG_FILENAME":"montana.jpg","FAVICON_FILE_NAME":"favicon.ico","ALLOW_E_SIGN_ON_CORRECTIONS":true,"THIRD_PARTY_SIGNING_ALLOWED":false,"MY_ACCOUNT_SAVE_AND_CLOSE_BUTTON":true,"IE_DEPRECATED_MESSAGE":"Internet Explorer is not supported. Please select a supported browser below to access this website.","ADDITIONAL_ROUTES":{"dataRequests":true,"farmBill":true,"apostille":true,"externalHelp":"https://sosmt.gov/business/help-center/","systemAdministration":[{"title":"Saved Payments","parameter":"saved-payments","componentName":"SavedPayments"}]},"SUBROUTES":[{"label":"Business","component":"Business","parameter":"business","myWorkQueueSearch":false,"sourceTypeId":54,"searchMustHaveOneOf":["FILING_TYPE_ID","STATUS_ID","STATE","search"],"serverWebSearchDescription":true,"serverWorkQueueDescription":true,"serverMyRecordsDescription":true,"searchPlaceholder":"Search by name or filing number (X########)","allowEmptySearchTerm":true,"requestCertificateAlternateLabel":"Request Information","fileAmendmentButtonLabel":"Filing Actions","advancedSearchParameters":[{"type":"radio","name":"QUERY_TYPE_ID","defaultValue":1010,"options":[{"value":1010,"label":"Starts with"},{"value":1011,"label":"Contains"},{"value":1012,"label":" Word Contains"}]},{"type":"serverSelect","name":"FILING_TYPE_ID","optionsSrc":"FILING_TYPES","label":"Entity Type","placeholder":"All","defaultValue":"0"},{"type":"serverSelect","name":"FILING_SUBTYPE_ID","optionsSrc":"FILING_SUBTYPES","label":"Entity Subtype","overrideSubOptionsSrcFromParameterName":"FILING_TYPE_ID","placeholder":"All","defaultValue":"0"},{"type":"serverSelect","name":"STATUS_ID","optionsSrc":"FILING_STATUS_WITHOUT_ALL","label":"Status","placeholder":"All","defaultValue":"0"},{"type":"serverSelect","name":"STATE","optionsSrc":"STATE","label":"State","placeholder":"All","defaultValue":""},{"type":"serverSelect","name":"COUNTY","optionsSrc":"COUNTY_SUBOPTION","label":"County","overrideSubOptionsSrcFromParameterName":"STATE","placeholder":"All","defaultValue":""},{"type":"checkbox","name":"CRA_SEARCH_YN","defaultValue":false,"label":"Search by Registered Agent PID"},{"type":"dateRange","name":"FILING_DATE","label":"Registration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}},{"type":"dateRange","name":"EXPIRATION_DATE","label":"Expiration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}}],"myRecordsFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Active"},{"value":2,"label":"Inactive"},{"value":3,"label":"Pending"}]},{"type":"dateRange","name":"DATE_RANGE","label":"Date range","defaultValue":{"start":null,"end":null}}],"myWorkQueueFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Approved"},{"value":2,"label":"Pending Online Payment"},{"value":3,"label":"Pending Review"},{"value":4,"label":"Needs Correction"},{"value":5,"label":"Rejected"},{"value":6,"label":"Draft"}]},{"type":"dateRange","name":"DATE_RANGE","label":"Date range","defaultValue":{"start":null,"end":null}}]},{"label":"Notary","component":"Notary","parameter":"notary","sourceTypeId":850,"myWorkQueueSearch":false,"allowEmptySearchTerm":true,"requestCertificateAlternateLabel":"Download Certificate","fileAmendmentButtonLabel":"Filing Actions","hideNameRequestCertificate":true,"hideAddressRequestCertificate":true,"hideRecordUserManagment":true,"searchPlaceholder":"Search by name or commission number","searchMustHaveOneOf":["CITY","search","SERVICE_TYPE"],"advancedParametersStartOpen":true,"searchIsSortable":true,"advancedSearchParameters":[{"type":"radio","name":"STARTS_WITH_YN","defaultValue":false,"options":[{"value":true,"label":"Starts with"},{"value":false,"label":"Contains"}]},{"type":"checkbox","name":"ACTIVE_ONLY_YN","defaultValue":true,"label":"Active entities only"},{"type":"text","name":"CITY","defaultValue":"","label":"City"},{"type":"select","name":"SERVICE_TYPE","label":"Special Services Offered","defaultValue":0,"options":[{"value":0,"label":"(N/A)"},{"value":6165,"label":"In-Person Electronic Notarization (IPEN)"},{"value":6166,"label":"Remote Online Notarization (RON)"},{"value":6167,"label":"Mobile Notary Services"},{"value":6168,"label":"Remote Ink Notarization (RIN)"}]}]},{"label":"Apostille","component":"Apostille","parameter":"apostille","sourceTypeId":720,"myRecordsSearch":false,"myWorkQueueSearch":false,"disabled":false,"allowedRoutes":["/forms-manager/","/queue/","/forms/"]},{"label":"Liens","component":"UCC","parameter":"ucc","sourceTypeId":1999,"myRecordsSearch":true,"myWorkQueueSearch":true,"fileAmendmentButtonLabel":"Filing Actions","searchPlaceholder":"Search by name or file number","disabled":false,"serverWebSearchDescription":true,"myRecordsDescription":"","workQueueDescription":"","searchDescription":"","hideRecordUserManagment":true,"searchLiensCheckout":false,"advancedSearchParameters":[{"type":"radio","name":"STARTS_WITH_YN","defaultValue":false,"options":[{"value":true,"label":"Starts with"},{"value":false,"label":"Contains"}]},{"type":"select","name":"STATUS","defaultValue":"ALL","label":"Status","options":[{"value":"ACTIVE_UNLAPSED","label":"Active (unlapsed)"},{"value":"ACTIVE_LAPSED_UNLAPSED","label":"Active (lapsed and unlapsed)"}]},{"type":"text","name":"EXCLUDE_VALUES","label":"Exclude Debtor Names (comma separated list of names to exclude)","defaultValue":""},{"type":"dateRange","name":"FILING_DATE","label":"Financing Statement Date","defaultValue":{"start":null,"end":null}},{"type":"dateRange","name":"LAPSE_DATE","label":"Lapse Date","defaultValue":{"start":null,"end":null}},{"type":"text","name":"CITY","label":"Debtor City","defaultValue":""}],"myRecordsFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Approved"},{"value":2,"label":"Pending Online Payment"},{"value":3,"label":"Pending Review"}]},{"type":"select","name":"TYPE","defaultValue":0,"label":"Lien Type","options":[{"value":0,"label":"All"},{"value":1,"label":"UCC"},{"value":2,"label":"EFS"},{"value":3,"label":"Title 71"}]}],"myWorkQueueFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Approved"},{"value":2,"label":"Pending Online Payment"},{"value":3,"label":"Pending Review"},{"value":4,"label":"Pending Print and Mail"},{"value":5,"label":"Rejected"},{"value":6,"label":"Draft"}]},{"type":"select","name":"TYPE","defaultValue":0,"label":"Lien Type","options":[{"value":0,"label":"All"},{"value":1,"label":"UCC"},{"value":2,"label":"EFS"},{"value":3,"label":"Title 71"}]}]},{"label":"Copy Request","component":"copies","parameter":"copies","sourceTypeId":2001,"myRecordsSearch":false,"myWorkQueueSearch":false,"disabled":false,"allowedRoutes":["/forms-manager/","/queue/","/forms/"]},{"label":"Trademark","component":"Trademark","parameter":"trademark","sourceTypeId":810,"showRequestCertificate":true,"searchMustHaveOneOf":["search","EXPIRATION_DATE","FILING_DATE"],"allowEmptySearchTerm":true,"requestCertificateAlternateLabel":"Request Information","fileAmendmentButtonLabel":"Filing Actions","advancedSearchParameters":[{"type":"radio","name":"QUERY_TYPE_ID","defaultValue":1010,"options":[{"value":1010,"label":"Starts with"},{"value":1011,"label":"Contains"},{"value":1012,"label":" Word Contains"}]},{"type":"checkbox","name":"OWNER_SEARCH_YN","defaultValue":false,"label":"Search owners"},{"type":"radio","name":"SERVICE_MARK_YN","label":"Mark Type","defaultValue":"","options":[{"value":"","label":"All Marks"},{"value":"Y","label":"Service Mark"},{"value":"N","label":"Trademark"}]},{"type":"serverSelect","name":"STATUS_ID","optionsSrc":"TYPE_V|TRADEMARK_STATUS_TYPE","label":"Status","placeholder":"All","defaultValue":"0"},{"type":"select","name":"DESIGN_TYPE_ID","options":[{"value":0,"label":"All"},{"value":990,"label":"Words Only"},{"value":991,"label":"Design Only"},{"value":992,"label":"Words and Design"}],"label":"Design Type","defaultValue":"0"},{"type":"dateRange","name":"FILING_DATE","label":"Registered Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}},{"type":"dateRange","name":"EXPIRATION_DATE","label":"Expiration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}}]},{"label":"Business Info Request","component":"InfoRequests","parameter":"info-request","sourceTypeId":167,"allowedRoutes":["/forms-manager/","/queue/","/forms/"]},{"label":"Data Requests","component":"DataRequests","parameter":"data-request","sourceTypeId":0,"allowedRoutes":["/forms-manager/"]},{"label":"CRA","component":"CRA","parameter":"cra","sourceTypeId":157,"myRecordsSearch":false,"searchPlaceholder":"Search by name or registered agent number","allowedRoutes":["/forms-manager/","/forms/","/records/","/queue/","/search/"],"allowEmptySearchTerm":true,"fileAmendmentButtonLabel":"Filing Actions","advancedSearchParameters":[{"type":"radio","name":"QUERY_TYPE_ID","defaultValue":1010,"options":[{"value":1010,"label":"Starts with"},{"value":1011,"label":"Contains"},{"value":1012,"label":" Word Contains"}]},{"type":"dateRange","name":"CRA_DATE","label":"Registration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}},{"type":"select","name":"STATUS_ID","label":"Status","defaultValue":0,"options":[{"value":0,"label":"All"},{"value":121,"label":"Active"},{"value":122,"label":"Inactive"}]},{"type":"select","name":"AGENT_TYPE_ID","label":"Agent Type","defaultValue":0,"options":[{"value":0,"label":"All"},{"value":460,"label":"Registered Agent"},{"value":461,"label":"Commercial Registered Agent"}]}]},{"label":"Farm Bill","component":"FarmBill","parameter":"farm-bill","path":"/lists/farm-bill","sourceTypeId":0,"myRecordsSearch":false,"allowedRules":["/search/"],"disabled":true,"searchDescription":"To perform a search, enter a debtor name. Your search results may include: exact debtor name, variations of that name and any filing that includes your search criteria. Punctuation is ignored.\n\nYou can click on \"Advanced\" to refine your search. Under “Advanced” you can search by crop, year, county and SSN/FEIN. As a registered Farm Bill Buyer with the Montana Secretary of State’s office it is important to maintain the confidentiality of the information contained within the Farm Bill Master List. The Farm Bill Master List reflects personal data, such as Social Security Numbers, which are a key piece of personal identifiable information to assist you in determining the existence of a lien against a specific debtor. The distribution of this information beyond its intended purpose is strictly prohibited.\n\nThe debtor's tax identification number has been hidden for confidentiality reasons. You may continue to search on a tax ID number and return debtors that match your search criteria. The SSN/FEIN must be entered without dashes or spaces.","searchMustHaveOneOf":["search","UCC_FARM_PRODUCT_ID","COUNTY"],"searchPlaceholder":"Search by debtor name","advancedSearchParameters":[{"type":"ServerMultiComplete","label":"Product code name(s)","name":"UCC_FARM_PRODUCT_ID","defaultValue":"","optionsSrc":"UCC_FARM_PRODUCT_V"},{"type":"MultiComplete","label":"Year or Range of Years","name":"YEAR_NUM","optionsSrc":"years","startYear":"1968","defaultValue":[],"preMergeOptions":[{"value":"ALL","label":"All"}]},{"type":"serverSelect","label":"State","name":"STATE","defaultValue":"MONTANA","optionsSrc":"STATE"},{"type":"ServerMultiComplete","label":"County","name":"COUNTY","defaultValue":[],"optionsSrc":"COUNTY","overrideSubOptionsSrcFromParameterName":"STATE"},{"type":"checkbox","name":"TIN_SEARCH_YN","defaultValue":false,"label":"Tax Identification Number Search"},{"type":"checkbox","name":"TIN_SORT_YN","defaultValue":false,"label":"Unique ID Sort"}]}],"SYSTEM_NICKNAME":"Online Services Portal","PAYMENT_METHODS":[{"type":"bypass"},{"type":"iTransact"}],"PAYMENT_ALLOW_AMEX":true,"SYSTEM_ID_LABEL":"System Id","DOUBLE_COLUMN_PUBLIC_LOGIN":true,"INTERNAL_USER_MANAGEMENT":true,"ALLOW_PUBLIC_JSON_IMPORT":false,"MAX_FILE_UPLOAD_SIZE":10000000,"REFUND_TEXT":"","RETURN_TO_HOME_ON_LOGOUT":true,"CURRENT_SOS_NAME":"Christi Jacobsen","LOGO_FILENAME":"mt-sos-logo.png","LOGO_ALT":"Christi Jacobsen, Montana Secretary of State","LOGO_FULL_WIDTH":true,"HOME_HIDE_AUTH_HINT":true,"HOME_TITLE":"Montana Secretary of State","CUSTOM_TAB_TITLE":"Official Montana","HOME_SUBTITLE":"Online Business Services","ENTITY_NAME_CONSENT_DESCRIPTION":"","ALLOW_USER_PROFILE_EDITING":true,"COMPARE_FOREIGN_NAME_IN_ENTITY_NAME_VALIDATION":true,"FOREIGN_NAME_FIELD_NAME":"KIMA_PARENT_NAME_INFO","LOGIN_TITLE":"Montana Secretary of State Online Filing Portal Login","PUBLIC_LOGIN_LABEL":"Username","REVERSE_LOGIN_COLUMNS":true,"LOGIN_SEAL_FILENAME":"seal_white.png","SEPARATE_USERNAME_AND_EMAIL":true,"CREATE_ACCOUNT_BUTTON_ALIGN_LEFT":true,"CREATE_ACCOUNT_BUTTON_TEXT":"CREATE AN ACCOUNT","PASSWORD_CUSTOM_ERROR_TEXT":"The password must meet all requirements","ACCOUNT_CREATED_MESSAGE":"Please check your email to verify your account to login and allow a few minutes for this message to arrive. Check your junk/spam folders if you do not find the email in your inbox.","PUBLIC_LOGIN_PLACEHOLDER":" ","DISABLE_DEFAULT_PAYMENT_RADIO":true,"CUSTOM_RESET_PASSWORD_ERROR_MESSAGE":"Username invalid - no account found","PUBLIC_LOGIN_CREATE_DESCRIPTION":"### Existing User:\n\n  - Enter your username and password to login.  \n\n\n  #### - OR -  \n\n\n\n  - Forgot password? Click 'Reset Password' and follow the prompts.\n  - Forgot username? Click 'Forgot Username' and follow the prompts.  \n\n\n  ### New User:\n  ","LOGIN_HELP_LINK":"https://sosmt.gov/business/how-do-i/","LOGIN_HELP_LINK_TEXT":"Need Help?","FORGOT_USERNAME_TEXT":"Forgot Username?","LOGIN_ACTIVE_DIRECTORY_TEXT":"State User Login","MULTIPLE_LOGIN_METHODS":true,"HAS_ACTIVE_DIRECTORY_LOGIN":true,"RESET_PASSWORD_WITH_USERNAME":true,"DOWNLOAD_LINK":true,"SHOW_USERNAME_ACCOUNT_CREATE":true,"SHOW_SCROLL_DOWN_ARROW":true,"SHOW_ADDRESS_ACCOUNT_CREATE":true,"TWO_COLUMN_ACCOUNT_CREATE":true,"RESET_PASSWORD_TIP":"A link to change your password has been sent to your email. Please allow a few minutes for this message to arrive. Please check your junk/spam folders if you do not find the email in your inbox.","FORGOT_PASSWORD_LINK_TEXT":"Reset Password","PHONE_NUMBER_OPTIONAL_ACCOUNT_CREATE":true,"SHOW_REQUIRED_INDICATOR_ACCOUNT_CREATE":true,"PASSWORD_REQUIREMENTS_ACCOUNT_CREATE":"\n    <ul>\n      <li>MUST contain at least 8 characters (12+ recommended)</li>\n      <li>MUST contain at least one uppercase letter.</li>\n      <li>MUST contain at least one lowercase letter.</li>\n      <li>MUST contain at least one number.</li>\n      <li>MUST contain at least one special character (!”#$%&'()*+,-./:;<=>?</li>\n    </ul>\n  ","ALLOW_CERTIFICATION_REQUEST":true,"ALLOW_PUBLIC_CERTIFICATE_REQUEST":true,"ALLOW_COPY_REQUEST":false,"ALLOW_CORRECTION_STYLING":true,"HIDE_DEPRECATION_WARNING":false,"AMEND_ROUTE_PUBLIC":true,"SEAL_FILENAME":"seal.png","SHOPPING_CART":true,"ALLOW_PAYMENT_UPDATE_WITH_EMPTY_CART":true,"RA_EMAIL":true,"RA_WEBSITE":true,"RA_NO_DEFAULT_TYPE":true,"RA_ADDRESS_LABEL":"Street Address","RA_TYPE_SELECTION_DEFAULT":true,"RA_DEFAULT_TYPE":"460","RA_OVERRIDE_TYPE_WITH_DEFAULT":true,"RA_PRINCIPAL_ADDRESS_AMS":true,"UPLOAD_AND_SUBMIT_HIDE_IF_ONE_OPTION":true,"PAYMENT_PROCESSING_MESSAGE":"Your payment is processing - Do not close your browser or click the back button","CHECKOUT_BUTTON_WHEN_PROCESSING_TEXT":"Processing","EFS_CROP_PICKER_NONE_LABEL":"Lien Duration","DISALLOWED_WIZARD_PIECES":["FormationLocale"],"REPEATER_SHOW_EDIT_BUTTON":true,"DATA_REQUEST_PAGE_TITLE":"Data Requests and Subscriptions","DATA_REQUEST_SIDEBAR_LABEL":"Data Requests & Subscriptions","LOGIN_REDIRECTS_TO_EPASS":false,"LOGIN_REDIRECTS_TO_ACTIVE_DIRECTORY":true,"LOGIN_ACTIVE_DIRECTORY_LINK":true,"FETCH_EDIT_USER_LINK":false,"LISTS_FETCH_AVAILABLE_LISTS":true,"POST_WIZARD_SUBMIT_REDIRECT_URL":"/","PIN_REQUEST_ATTESTATIONS":true,"PIN_REQUEST_DESCRIPTION":"Click **Request PIN** to have a new PIN sent to the account holder's email address on file.","OWNERSHIP_REQUEST_DESCRIPTION":"To become an **authorized user** of this record, a current **AUTHORIZED USER** will need to grant you access. To request access, click **Request Access** below.","PIN_REQUEST_SUCCESS_MESSAGE":"The PIN you have requested for this entity has been sent to the email associated with your user account.  You should receive the PIN in approximately 3-5 minutes, depending on your email service provider.","APOSTILLE_HEADER_LABEL":"Verification Information","APOSTILLE_NUMBER_LABEL":"Apostille/Authentication","APOSTILLE_CITY_STATE_OVERRIDE":"HELENA, MT","APOSTILLE_FILING_DATE_LABEL":"Issue Date","APOSTILLE_CITY_STATE_IN_CERTIFIED":true,"NOTARY_EXISTING_FILING":true,"ALLOW_REVOKE_OWN_ACCESS_ONLY":false,"HIDE_CANCEL_ON_ONETIME_DATA_REQUESTS":true,"DATA_REQUESTS_IN_SHOPPING_CART":true,"WQ_ALLOW_EDIT_PENDING_PAYMENT":true,"WQ_CONFIRM_ON_DELETE":true,"WQ_DELETE_CONFIRM_MESSAGE":"Deleting this filing will forfeit any money already paid to the Secretary of State. This action is permanent and cannot be undone, are you sure you would like to delete?","PASS_ITEM_GUIDS_ON_CHECKOUT":true,"FORM_REVISION_HISTORY":true,"CHECKOUT_DISCLAIMER":"By entering your credit card and/or checking account information you (i) state that **you are an authorized user** of the credit card and/or electronic check and that the associated information entered (e.g., account holder name, account number, billing address) is accurate, (ii) **you authorize payment processor to charge the amount you have requested** to your credit card and/or funding account, and (iii) **acknowledge if a charge is declined or reversed you may also be assessed a customary charge** by the payment processor for such transactions.","FARM_BILL_SEARCH_CONFIDENTIAL":"As a registered Farm Bill Buyer with the Montana Secretary of State’s office it is important to maintain the confidentiality of the information contained within the Farm Bill Master List. The Farm Bill Master List reflects personal data, such as Social Security Numbers, which are a key piece of personal identifiable information to assist you in determining the existence of a lien against a specific debtor. The distribution of this information beyond its intended purpose is strictly prohibited.\n\n**The debtor's tax identification number has been hidden for confidentiality reasons. You may continue to search on a tax ID number and return debtors that match your search criteria. The SSN/FEIN must be entered without dashes or spaces.  If you need access to the tax identification number to clearly identify the debtor, please contact the UCC unit at (406) 444-3665.**","VIEW_HISTORY_BUTTON_ALT_TEXT":"View Filings","WIZARD_ERROR_TITLE_MESSAGE":"Form Error","FARM_BILL_SEARCH_INTERACTIVE":true,"USE_FARM_BILL_API":true,"DISALLOW_ASSIGN_SELF_AS_RA":true,"DISALLOW_ASSIGN_SELF_AS_PRINCIPAL":true,"USE_TRADEMARK_OWNER_VALIDATION":true,"USE_ALTERNATIVE_FOREIGN_ADDRESS_LABELS":true,"MY_RECEIPTS_FILTER":[{"type":"dateRange","name":"DATE_RANGE","label":"Date range","defaultValue":{"start":null,"end":null}},{"type":"text","name":"REF_NUM","defaultValue":"","label":"Reference Number"},{"type":"text","name":"RECEIPT_NUM","defaultValue":"","label":"Receipt Id"},{"type":"text","name":"AMOUNT","defaultValue":"","label":"Amount"},{"type":"select","name":"TYPE","defaultValue":"","label":"Payment Type","options":[{"value":"","label":"All"},{"value":"CC","label":"Credit Card"},{"value":"Check","label":"Check"}]}],"MY_RECEIPTS_SHOW_IN_SIDEBAR":true,"SHOW_MY_RECEIPTS_HELPER_TEXT":true,"MY_RECEIPTS_HELPER_LABEL":"About Receipt Search","MY_RECEIPTS_HELPER_TEXT":"You can search for receipts based on their descriptions, including the items paid for on the receipt. Use the filters to search for or filter specific information.","FARM_BILL_SUBLINK":{"label":"Farm Bill","component":"FarmBill","parameter":"farm-bill","path":"/lists/farm-bill","sourceTypeId":0,"myRecordsSearch":false,"allowedRules":["/search/"],"disabled":true,"searchDescription":"To perform a search, enter a debtor name. Your search results may include: exact debtor name, variations of that name and any filing that includes your search criteria. Punctuation is ignored.\n\nYou can click on \"Advanced\" to refine your search. Under “Advanced” you can search by crop, year, county and SSN/FEIN. As a registered Farm Bill Buyer with the Montana Secretary of State’s office it is important to maintain the confidentiality of the information contained within the Farm Bill Master List. The Farm Bill Master List reflects personal data, such as Social Security Numbers, which are a key piece of personal identifiable information to assist you in determining the existence of a lien against a specific debtor. The distribution of this information beyond its intended purpose is strictly prohibited.\n\nThe debtor's tax identification number has been hidden for confidentiality reasons. You may continue to search on a tax ID number and return debtors that match your search criteria. The SSN/FEIN must be entered without dashes or spaces.","searchMustHaveOneOf":["search","UCC_FARM_PRODUCT_ID","COUNTY"],"searchPlaceholder":"Search by debtor name","advancedSearchParameters":[{"type":"ServerMultiComplete","label":"Product code name(s)","name":"UCC_FARM_PRODUCT_ID","defaultValue":"","optionsSrc":"UCC_FARM_PRODUCT_V"},{"type":"MultiComplete","label":"Year or Range of Years","name":"YEAR_NUM","optionsSrc":"years","startYear":"1968","defaultValue":[],"preMergeOptions":[{"value":"ALL","label":"All"}]},{"type":"serverSelect","label":"State","name":"STATE","defaultValue":"MONTANA","optionsSrc":"STATE"},{"type":"ServerMultiComplete","label":"County","name":"COUNTY","defaultValue":[],"optionsSrc":"COUNTY","overrideSubOptionsSrcFromParameterName":"STATE"},{"type":"checkbox","name":"TIN_SEARCH_YN","defaultValue":false,"label":"Tax Identification Number Search"},{"type":"checkbox","name":"TIN_SORT_YN","defaultValue":false,"label":"Unique ID Sort"}]},"ALLOW_ADDRESS_VALIDATION_BYPASS_OPTION":true,"DEFAULT_ADDRESS_VALIDATION_BYPASS_OPTION_CHECKED":true}).SEARCH_HAS_PAGINATION;
	
	var Search = exports.Search = function (_Component) {
	  _inherits(Search, _Component);
	
	  function Search() {
	    _classCallCheck(this, Search);
	
	    var _this = _possibleConstructorReturn(this, (Search.__proto__ || Object.getPrototypeOf(Search)).call(this));
	
	    _this.componentDidMount = function () {
	      if (_this.props.match.params.subParam) {
	        if (!_App.SUBROUTES_OBJ[_this.props.match.params.subParam]) {
	          _this.props.history.replace('/404');
	        } else if (_App.SUBROUTES_OBJ[_this.props.match.params.subParam].serverWebSearchDescription && !_this.props.serverDescription) {
	          _this.props.getSearchDescription(_this.props.match.params.subParam);
	        }
	        _this.props.clearSearchError(_this.props.match.params.subParam);
	      }
	    };
	
	    _this.componentWillReceiveProps = function (nextProps) {
	      var categoryHasChanged = _this.props.match.params.subParam !== nextProps.match.params.subParam;
	      if (categoryHasChanged) {
	        if (!_App.SUBROUTES_OBJ[nextProps.match.params.subParam]) {
	          _this.props.history.replace('/404');
	        } else if (_App.SUBROUTES_OBJ[nextProps.match.params.subParam].serverWebSearchDescription && !nextProps.serverDescription) {
	          _this.props.getSearchDescription(nextProps.match.params.subParam);
	        }
	        var previousCategoryWasNotValid = !_this.props.match.params.subParam && nextProps.match.params.subParam;
	        if (previousCategoryWasNotValid) {
	          _this.props.clearSearchError(nextProps.match.params.subParam);
	        }
	        _this.props.setActiveCategory(nextProps.match.params.subParam);
	      }
	    };
	
	    _this.selectRow = function (row) {
	      _this.props.selectRow(_this.props.match.params.subParam, row.ID);
	    };
	
	    _this.setResults = function (results, searchValue) {
	      _this.props.setResults(results, _this.props.match.params.subParam, searchValue);
	      _this.props.selectRow(_this.props.match.params.subParam, null);
	      if (_this.props.isMobile && _this.props.orderedResults.rows && _this.props.orderedResults.rows.length > 0) {
	        window.scrollTo(0, _this.searchResultsRef.offsetTop - 20);
	      }
	    };
	
	    _this.setSort = function (e, sortId) {
	      return _this.props.setSort({
	        category: _this.props.match.params.subParam || 'Record Type',
	        sortBy: sortId,
	        sortByDirection: _this.props.sortBy === sortId ? _this.props.sortByDirection === 'DESC' ? 'ASC' : 'DESC' : 'DESC'
	      }).then(function () {
	        return _this.searchTrigger(e, _this.props);
	      });
	    };
	
	    _this.formatForCards = function (header, rows) {
	      var cards = rows.map(function (row, i) {
	        return {
	          title: row.CELLS[0],
	          alert: row.ALERT_YN,
	          details: _this.formatRowDetails(header, row.CELLS),
	          recordId: row.RECORD_ID
	        };
	      });
	      return cards;
	    };
	
	    _this.onSidebarDismiss = function () {
	      _this.props.selectRow(_this.props.match.params.subParam, null);
	    };
	
	    _this.startLiensCheckout = function (searchTerm, advancedParameters) {
	      (0, _requests.GET_LIENS_SEARCH_WEB_CART)({
	        searchTerm: searchTerm,
	        advancedParameters: advancedParameters,
	        searchResults: _this.props.orderedResults.rows.map(function (row) {
	          return row.ID;
	        })
	      }, function (_ref) {
	        var RECEIPT_ITEM_WEB_LIST = _ref.RECEIPT_ITEM_WEB_LIST,
	            RECEIPT_ITEM_CONTAINER_WEB_LIST = _ref.RECEIPT_ITEM_CONTAINER_WEB_LIST,
	            REF_NUM = _ref.REF_NUM;
	
	        var total = RECEIPT_ITEM_CONTAINER_WEB_LIST ? (0, _utilities.calculateReceiptItemContainersTotal)(RECEIPT_ITEM_CONTAINER_WEB_LIST) : (0, _utilities.calculateReceiptItemsTotal)(RECEIPT_ITEM_WEB_LIST);
	        _this.setState({
	          webcart: {
	            receiptItems: RECEIPT_ITEM_WEB_LIST,
	            receiptItemContainers: RECEIPT_ITEM_CONTAINER_WEB_LIST,
	            refNum: REF_NUM
	          },
	          checkoutOpen: total > 0
	        }, function () {
	          if (total <= 0) {
	            _this.openReceipt();
	          }
	        });
	      }, function (err) {
	        console.error(err);
	      });
	    };
	
	    _this.closeCheckout = function () {
	      _this.setState({ checkoutOpen: false });
	    };
	
	    _this.cancelCheckout = function () {
	      _this.slider.closeSlider(function () {
	        _this.setState({ checkoutOpen: false, webcart: null });
	      });
	    };
	
	    _this.openReceipt = function (refNum) {
	      // this.disablePaymentButtons()
	      // this.getRecords(this.props.match.params.category, () => {
	      //   this.enablePaymentButtons()
	      // })
	      if (_this.slider) {
	        _this.slider.closeSlider(function () {
	          // this.setState({checkoutOpen: false})
	          _this.props.history.push('/receipt?ref=' + (refNum || _this.state.webcart.refNum));
	        });
	      } else {
	        _this.props.history.push('/receipt?ref=' + (refNum || _this.state.webcart.refNum));
	      }
	    };
	
	    _this.getPagerProps = function () {
	      var _this$props$edge = _this.props.edge,
	          offset = _this$props$edge.offset,
	          limit = _this$props$edge.limit,
	          total = _this$props$edge.total;
	
	      var numPages = Math.ceil(total / limit);
	      var activePage = Math.ceil(offset / limit) + 1;
	      return { numPages: numPages, activePage: activePage };
	    };
	
	    _this.onPrevClicked = function (event) {
	      var _this$props$edge2 = _this.props.edge,
	          offset = _this$props$edge2.offset,
	          limit = _this$props$edge2.limit;
	
	      _this.searchTrigger(event, { offset: offset - limit });
	    };
	
	    _this.onPageClicked = function (event, activePage) {
	      var limit = _this.props.edge.limit;
	
	      _this.searchTrigger(event, { offset: activePage * limit - limit });
	    };
	
	    _this.onNextClicked = function (event) {
	      var _this$props$edge3 = _this.props.edge,
	          offset = _this$props$edge3.offset,
	          limit = _this$props$edge3.limit;
	
	      _this.searchTrigger(event, { offset: offset + limit });
	    };
	
	    _this.searchTrigger = null;
	    _this.searchResultsRef = null;
	
	    _this.state = {
	      ownershipModalOpen: false,
	      requestOwnershipModal: false,
	      pinsModalOpen: false,
	      amendmentLauncherOpen: false,
	      webcart: null,
	      checkoutOpen: false
	    };
	    return _this;
	  }
	  // onBodyResize = ({width, height}) => {
	  //   if(width < 500 && this.props.resultsMode === "table"){
	  //     this.props.setResultsMode("cards")
	  //   }else if(width >= 500 && this.props.resultsMode === "cards"){
	  //     this.props.setResultsMode("table")
	  //   }
	  // }
	
	
	  _createClass(Search, [{
	    key: 'renderResults',
	    value: function renderResults(props, sublink) {
	      var _this2 = this;
	
	      if (props.searchError) {
	        return props.searching ? null : _react2.default.createElement(_SearchError2.default, { title: props.searchError.title, message: props.searchError.message });
	      } else if (props.orderedResults.rows && props.orderedResults.rows.length > 0 && !props.isStale) {
	        var headerClickedFunction = null;
	        if (props.onHeaderLabelClicked) {
	          headerClickedFunction = props.onHeaderLabelClicked;
	        } else if (({"NODE_ENV":"production","BUILD_DATE":"2025-08-27T15:15:31.687Z","BUILD_NUMBER":"Not Provided","GIT_VERSION":"v1.3.0-381-ga81e29b08","GIT_COMMIT_HASH":"a81e29b085c9268ffd96c78eb734365802722741","GIT_BRANCH":"beta","PUBLIC_URL":"","STATE_ABBR":"MT","STATE_NAME":"Montana","STATE_ORG_TITLE":"Secretary of State","LOGIN_HEADER_IMG_PATH":"","HOME_IMG_FILENAME":"montana.jpg","FAVICON_FILE_NAME":"favicon.ico","ALLOW_E_SIGN_ON_CORRECTIONS":true,"THIRD_PARTY_SIGNING_ALLOWED":false,"MY_ACCOUNT_SAVE_AND_CLOSE_BUTTON":true,"IE_DEPRECATED_MESSAGE":"Internet Explorer is not supported. Please select a supported browser below to access this website.","ADDITIONAL_ROUTES":{"dataRequests":true,"farmBill":true,"apostille":true,"externalHelp":"https://sosmt.gov/business/help-center/","systemAdministration":[{"title":"Saved Payments","parameter":"saved-payments","componentName":"SavedPayments"}]},"SUBROUTES":[{"label":"Business","component":"Business","parameter":"business","myWorkQueueSearch":false,"sourceTypeId":54,"searchMustHaveOneOf":["FILING_TYPE_ID","STATUS_ID","STATE","search"],"serverWebSearchDescription":true,"serverWorkQueueDescription":true,"serverMyRecordsDescription":true,"searchPlaceholder":"Search by name or filing number (X########)","allowEmptySearchTerm":true,"requestCertificateAlternateLabel":"Request Information","fileAmendmentButtonLabel":"Filing Actions","advancedSearchParameters":[{"type":"radio","name":"QUERY_TYPE_ID","defaultValue":1010,"options":[{"value":1010,"label":"Starts with"},{"value":1011,"label":"Contains"},{"value":1012,"label":" Word Contains"}]},{"type":"serverSelect","name":"FILING_TYPE_ID","optionsSrc":"FILING_TYPES","label":"Entity Type","placeholder":"All","defaultValue":"0"},{"type":"serverSelect","name":"FILING_SUBTYPE_ID","optionsSrc":"FILING_SUBTYPES","label":"Entity Subtype","overrideSubOptionsSrcFromParameterName":"FILING_TYPE_ID","placeholder":"All","defaultValue":"0"},{"type":"serverSelect","name":"STATUS_ID","optionsSrc":"FILING_STATUS_WITHOUT_ALL","label":"Status","placeholder":"All","defaultValue":"0"},{"type":"serverSelect","name":"STATE","optionsSrc":"STATE","label":"State","placeholder":"All","defaultValue":""},{"type":"serverSelect","name":"COUNTY","optionsSrc":"COUNTY_SUBOPTION","label":"County","overrideSubOptionsSrcFromParameterName":"STATE","placeholder":"All","defaultValue":""},{"type":"checkbox","name":"CRA_SEARCH_YN","defaultValue":false,"label":"Search by Registered Agent PID"},{"type":"dateRange","name":"FILING_DATE","label":"Registration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}},{"type":"dateRange","name":"EXPIRATION_DATE","label":"Expiration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}}],"myRecordsFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Active"},{"value":2,"label":"Inactive"},{"value":3,"label":"Pending"}]},{"type":"dateRange","name":"DATE_RANGE","label":"Date range","defaultValue":{"start":null,"end":null}}],"myWorkQueueFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Approved"},{"value":2,"label":"Pending Online Payment"},{"value":3,"label":"Pending Review"},{"value":4,"label":"Needs Correction"},{"value":5,"label":"Rejected"},{"value":6,"label":"Draft"}]},{"type":"dateRange","name":"DATE_RANGE","label":"Date range","defaultValue":{"start":null,"end":null}}]},{"label":"Notary","component":"Notary","parameter":"notary","sourceTypeId":850,"myWorkQueueSearch":false,"allowEmptySearchTerm":true,"requestCertificateAlternateLabel":"Download Certificate","fileAmendmentButtonLabel":"Filing Actions","hideNameRequestCertificate":true,"hideAddressRequestCertificate":true,"hideRecordUserManagment":true,"searchPlaceholder":"Search by name or commission number","searchMustHaveOneOf":["CITY","search","SERVICE_TYPE"],"advancedParametersStartOpen":true,"searchIsSortable":true,"advancedSearchParameters":[{"type":"radio","name":"STARTS_WITH_YN","defaultValue":false,"options":[{"value":true,"label":"Starts with"},{"value":false,"label":"Contains"}]},{"type":"checkbox","name":"ACTIVE_ONLY_YN","defaultValue":true,"label":"Active entities only"},{"type":"text","name":"CITY","defaultValue":"","label":"City"},{"type":"select","name":"SERVICE_TYPE","label":"Special Services Offered","defaultValue":0,"options":[{"value":0,"label":"(N/A)"},{"value":6165,"label":"In-Person Electronic Notarization (IPEN)"},{"value":6166,"label":"Remote Online Notarization (RON)"},{"value":6167,"label":"Mobile Notary Services"},{"value":6168,"label":"Remote Ink Notarization (RIN)"}]}]},{"label":"Apostille","component":"Apostille","parameter":"apostille","sourceTypeId":720,"myRecordsSearch":false,"myWorkQueueSearch":false,"disabled":false,"allowedRoutes":["/forms-manager/","/queue/","/forms/"]},{"label":"Liens","component":"UCC","parameter":"ucc","sourceTypeId":1999,"myRecordsSearch":true,"myWorkQueueSearch":true,"fileAmendmentButtonLabel":"Filing Actions","searchPlaceholder":"Search by name or file number","disabled":false,"serverWebSearchDescription":true,"myRecordsDescription":"","workQueueDescription":"","searchDescription":"","hideRecordUserManagment":true,"searchLiensCheckout":false,"advancedSearchParameters":[{"type":"radio","name":"STARTS_WITH_YN","defaultValue":false,"options":[{"value":true,"label":"Starts with"},{"value":false,"label":"Contains"}]},{"type":"select","name":"STATUS","defaultValue":"ALL","label":"Status","options":[{"value":"ACTIVE_UNLAPSED","label":"Active (unlapsed)"},{"value":"ACTIVE_LAPSED_UNLAPSED","label":"Active (lapsed and unlapsed)"}]},{"type":"text","name":"EXCLUDE_VALUES","label":"Exclude Debtor Names (comma separated list of names to exclude)","defaultValue":""},{"type":"dateRange","name":"FILING_DATE","label":"Financing Statement Date","defaultValue":{"start":null,"end":null}},{"type":"dateRange","name":"LAPSE_DATE","label":"Lapse Date","defaultValue":{"start":null,"end":null}},{"type":"text","name":"CITY","label":"Debtor City","defaultValue":""}],"myRecordsFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Approved"},{"value":2,"label":"Pending Online Payment"},{"value":3,"label":"Pending Review"}]},{"type":"select","name":"TYPE","defaultValue":0,"label":"Lien Type","options":[{"value":0,"label":"All"},{"value":1,"label":"UCC"},{"value":2,"label":"EFS"},{"value":3,"label":"Title 71"}]}],"myWorkQueueFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Approved"},{"value":2,"label":"Pending Online Payment"},{"value":3,"label":"Pending Review"},{"value":4,"label":"Pending Print and Mail"},{"value":5,"label":"Rejected"},{"value":6,"label":"Draft"}]},{"type":"select","name":"TYPE","defaultValue":0,"label":"Lien Type","options":[{"value":0,"label":"All"},{"value":1,"label":"UCC"},{"value":2,"label":"EFS"},{"value":3,"label":"Title 71"}]}]},{"label":"Copy Request","component":"copies","parameter":"copies","sourceTypeId":2001,"myRecordsSearch":false,"myWorkQueueSearch":false,"disabled":false,"allowedRoutes":["/forms-manager/","/queue/","/forms/"]},{"label":"Trademark","component":"Trademark","parameter":"trademark","sourceTypeId":810,"showRequestCertificate":true,"searchMustHaveOneOf":["search","EXPIRATION_DATE","FILING_DATE"],"allowEmptySearchTerm":true,"requestCertificateAlternateLabel":"Request Information","fileAmendmentButtonLabel":"Filing Actions","advancedSearchParameters":[{"type":"radio","name":"QUERY_TYPE_ID","defaultValue":1010,"options":[{"value":1010,"label":"Starts with"},{"value":1011,"label":"Contains"},{"value":1012,"label":" Word Contains"}]},{"type":"checkbox","name":"OWNER_SEARCH_YN","defaultValue":false,"label":"Search owners"},{"type":"radio","name":"SERVICE_MARK_YN","label":"Mark Type","defaultValue":"","options":[{"value":"","label":"All Marks"},{"value":"Y","label":"Service Mark"},{"value":"N","label":"Trademark"}]},{"type":"serverSelect","name":"STATUS_ID","optionsSrc":"TYPE_V|TRADEMARK_STATUS_TYPE","label":"Status","placeholder":"All","defaultValue":"0"},{"type":"select","name":"DESIGN_TYPE_ID","options":[{"value":0,"label":"All"},{"value":990,"label":"Words Only"},{"value":991,"label":"Design Only"},{"value":992,"label":"Words and Design"}],"label":"Design Type","defaultValue":"0"},{"type":"dateRange","name":"FILING_DATE","label":"Registered Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}},{"type":"dateRange","name":"EXPIRATION_DATE","label":"Expiration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}}]},{"label":"Business Info Request","component":"InfoRequests","parameter":"info-request","sourceTypeId":167,"allowedRoutes":["/forms-manager/","/queue/","/forms/"]},{"label":"Data Requests","component":"DataRequests","parameter":"data-request","sourceTypeId":0,"allowedRoutes":["/forms-manager/"]},{"label":"CRA","component":"CRA","parameter":"cra","sourceTypeId":157,"myRecordsSearch":false,"searchPlaceholder":"Search by name or registered agent number","allowedRoutes":["/forms-manager/","/forms/","/records/","/queue/","/search/"],"allowEmptySearchTerm":true,"fileAmendmentButtonLabel":"Filing Actions","advancedSearchParameters":[{"type":"radio","name":"QUERY_TYPE_ID","defaultValue":1010,"options":[{"value":1010,"label":"Starts with"},{"value":1011,"label":"Contains"},{"value":1012,"label":" Word Contains"}]},{"type":"dateRange","name":"CRA_DATE","label":"Registration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}},{"type":"select","name":"STATUS_ID","label":"Status","defaultValue":0,"options":[{"value":0,"label":"All"},{"value":121,"label":"Active"},{"value":122,"label":"Inactive"}]},{"type":"select","name":"AGENT_TYPE_ID","label":"Agent Type","defaultValue":0,"options":[{"value":0,"label":"All"},{"value":460,"label":"Registered Agent"},{"value":461,"label":"Commercial Registered Agent"}]}]},{"label":"Farm Bill","component":"FarmBill","parameter":"farm-bill","path":"/lists/farm-bill","sourceTypeId":0,"myRecordsSearch":false,"allowedRules":["/search/"],"disabled":true,"searchDescription":"To perform a search, enter a debtor name. Your search results may include: exact debtor name, variations of that name and any filing that includes your search criteria. Punctuation is ignored.\n\nYou can click on \"Advanced\" to refine your search. Under “Advanced” you can search by crop, year, county and SSN/FEIN. As a registered Farm Bill Buyer with the Montana Secretary of State’s office it is important to maintain the confidentiality of the information contained within the Farm Bill Master List. The Farm Bill Master List reflects personal data, such as Social Security Numbers, which are a key piece of personal identifiable information to assist you in determining the existence of a lien against a specific debtor. The distribution of this information beyond its intended purpose is strictly prohibited.\n\nThe debtor's tax identification number has been hidden for confidentiality reasons. You may continue to search on a tax ID number and return debtors that match your search criteria. The SSN/FEIN must be entered without dashes or spaces.","searchMustHaveOneOf":["search","UCC_FARM_PRODUCT_ID","COUNTY"],"searchPlaceholder":"Search by debtor name","advancedSearchParameters":[{"type":"ServerMultiComplete","label":"Product code name(s)","name":"UCC_FARM_PRODUCT_ID","defaultValue":"","optionsSrc":"UCC_FARM_PRODUCT_V"},{"type":"MultiComplete","label":"Year or Range of Years","name":"YEAR_NUM","optionsSrc":"years","startYear":"1968","defaultValue":[],"preMergeOptions":[{"value":"ALL","label":"All"}]},{"type":"serverSelect","label":"State","name":"STATE","defaultValue":"MONTANA","optionsSrc":"STATE"},{"type":"ServerMultiComplete","label":"County","name":"COUNTY","defaultValue":[],"optionsSrc":"COUNTY","overrideSubOptionsSrcFromParameterName":"STATE"},{"type":"checkbox","name":"TIN_SEARCH_YN","defaultValue":false,"label":"Tax Identification Number Search"},{"type":"checkbox","name":"TIN_SORT_YN","defaultValue":false,"label":"Unique ID Sort"}]}],"SYSTEM_NICKNAME":"Online Services Portal","PAYMENT_METHODS":[{"type":"bypass"},{"type":"iTransact"}],"PAYMENT_ALLOW_AMEX":true,"SYSTEM_ID_LABEL":"System Id","DOUBLE_COLUMN_PUBLIC_LOGIN":true,"INTERNAL_USER_MANAGEMENT":true,"ALLOW_PUBLIC_JSON_IMPORT":false,"MAX_FILE_UPLOAD_SIZE":10000000,"REFUND_TEXT":"","RETURN_TO_HOME_ON_LOGOUT":true,"CURRENT_SOS_NAME":"Christi Jacobsen","LOGO_FILENAME":"mt-sos-logo.png","LOGO_ALT":"Christi Jacobsen, Montana Secretary of State","LOGO_FULL_WIDTH":true,"HOME_HIDE_AUTH_HINT":true,"HOME_TITLE":"Montana Secretary of State","CUSTOM_TAB_TITLE":"Official Montana","HOME_SUBTITLE":"Online Business Services","ENTITY_NAME_CONSENT_DESCRIPTION":"","ALLOW_USER_PROFILE_EDITING":true,"COMPARE_FOREIGN_NAME_IN_ENTITY_NAME_VALIDATION":true,"FOREIGN_NAME_FIELD_NAME":"KIMA_PARENT_NAME_INFO","LOGIN_TITLE":"Montana Secretary of State Online Filing Portal Login","PUBLIC_LOGIN_LABEL":"Username","REVERSE_LOGIN_COLUMNS":true,"LOGIN_SEAL_FILENAME":"seal_white.png","SEPARATE_USERNAME_AND_EMAIL":true,"CREATE_ACCOUNT_BUTTON_ALIGN_LEFT":true,"CREATE_ACCOUNT_BUTTON_TEXT":"CREATE AN ACCOUNT","PASSWORD_CUSTOM_ERROR_TEXT":"The password must meet all requirements","ACCOUNT_CREATED_MESSAGE":"Please check your email to verify your account to login and allow a few minutes for this message to arrive. Check your junk/spam folders if you do not find the email in your inbox.","PUBLIC_LOGIN_PLACEHOLDER":" ","DISABLE_DEFAULT_PAYMENT_RADIO":true,"CUSTOM_RESET_PASSWORD_ERROR_MESSAGE":"Username invalid - no account found","PUBLIC_LOGIN_CREATE_DESCRIPTION":"### Existing User:\n\n  - Enter your username and password to login.  \n\n\n  #### - OR -  \n\n\n\n  - Forgot password? Click 'Reset Password' and follow the prompts.\n  - Forgot username? Click 'Forgot Username' and follow the prompts.  \n\n\n  ### New User:\n  ","LOGIN_HELP_LINK":"https://sosmt.gov/business/how-do-i/","LOGIN_HELP_LINK_TEXT":"Need Help?","FORGOT_USERNAME_TEXT":"Forgot Username?","LOGIN_ACTIVE_DIRECTORY_TEXT":"State User Login","MULTIPLE_LOGIN_METHODS":true,"HAS_ACTIVE_DIRECTORY_LOGIN":true,"RESET_PASSWORD_WITH_USERNAME":true,"DOWNLOAD_LINK":true,"SHOW_USERNAME_ACCOUNT_CREATE":true,"SHOW_SCROLL_DOWN_ARROW":true,"SHOW_ADDRESS_ACCOUNT_CREATE":true,"TWO_COLUMN_ACCOUNT_CREATE":true,"RESET_PASSWORD_TIP":"A link to change your password has been sent to your email. Please allow a few minutes for this message to arrive. Please check your junk/spam folders if you do not find the email in your inbox.","FORGOT_PASSWORD_LINK_TEXT":"Reset Password","PHONE_NUMBER_OPTIONAL_ACCOUNT_CREATE":true,"SHOW_REQUIRED_INDICATOR_ACCOUNT_CREATE":true,"PASSWORD_REQUIREMENTS_ACCOUNT_CREATE":"\n    <ul>\n      <li>MUST contain at least 8 characters (12+ recommended)</li>\n      <li>MUST contain at least one uppercase letter.</li>\n      <li>MUST contain at least one lowercase letter.</li>\n      <li>MUST contain at least one number.</li>\n      <li>MUST contain at least one special character (!”#$%&'()*+,-./:;<=>?</li>\n    </ul>\n  ","ALLOW_CERTIFICATION_REQUEST":true,"ALLOW_PUBLIC_CERTIFICATE_REQUEST":true,"ALLOW_COPY_REQUEST":false,"ALLOW_CORRECTION_STYLING":true,"HIDE_DEPRECATION_WARNING":false,"AMEND_ROUTE_PUBLIC":true,"SEAL_FILENAME":"seal.png","SHOPPING_CART":true,"ALLOW_PAYMENT_UPDATE_WITH_EMPTY_CART":true,"RA_EMAIL":true,"RA_WEBSITE":true,"RA_NO_DEFAULT_TYPE":true,"RA_ADDRESS_LABEL":"Street Address","RA_TYPE_SELECTION_DEFAULT":true,"RA_DEFAULT_TYPE":"460","RA_OVERRIDE_TYPE_WITH_DEFAULT":true,"RA_PRINCIPAL_ADDRESS_AMS":true,"UPLOAD_AND_SUBMIT_HIDE_IF_ONE_OPTION":true,"PAYMENT_PROCESSING_MESSAGE":"Your payment is processing - Do not close your browser or click the back button","CHECKOUT_BUTTON_WHEN_PROCESSING_TEXT":"Processing","EFS_CROP_PICKER_NONE_LABEL":"Lien Duration","DISALLOWED_WIZARD_PIECES":["FormationLocale"],"REPEATER_SHOW_EDIT_BUTTON":true,"DATA_REQUEST_PAGE_TITLE":"Data Requests and Subscriptions","DATA_REQUEST_SIDEBAR_LABEL":"Data Requests & Subscriptions","LOGIN_REDIRECTS_TO_EPASS":false,"LOGIN_REDIRECTS_TO_ACTIVE_DIRECTORY":true,"LOGIN_ACTIVE_DIRECTORY_LINK":true,"FETCH_EDIT_USER_LINK":false,"LISTS_FETCH_AVAILABLE_LISTS":true,"POST_WIZARD_SUBMIT_REDIRECT_URL":"/","PIN_REQUEST_ATTESTATIONS":true,"PIN_REQUEST_DESCRIPTION":"Click **Request PIN** to have a new PIN sent to the account holder's email address on file.","OWNERSHIP_REQUEST_DESCRIPTION":"To become an **authorized user** of this record, a current **AUTHORIZED USER** will need to grant you access. To request access, click **Request Access** below.","PIN_REQUEST_SUCCESS_MESSAGE":"The PIN you have requested for this entity has been sent to the email associated with your user account.  You should receive the PIN in approximately 3-5 minutes, depending on your email service provider.","APOSTILLE_HEADER_LABEL":"Verification Information","APOSTILLE_NUMBER_LABEL":"Apostille/Authentication","APOSTILLE_CITY_STATE_OVERRIDE":"HELENA, MT","APOSTILLE_FILING_DATE_LABEL":"Issue Date","APOSTILLE_CITY_STATE_IN_CERTIFIED":true,"NOTARY_EXISTING_FILING":true,"ALLOW_REVOKE_OWN_ACCESS_ONLY":false,"HIDE_CANCEL_ON_ONETIME_DATA_REQUESTS":true,"DATA_REQUESTS_IN_SHOPPING_CART":true,"WQ_ALLOW_EDIT_PENDING_PAYMENT":true,"WQ_CONFIRM_ON_DELETE":true,"WQ_DELETE_CONFIRM_MESSAGE":"Deleting this filing will forfeit any money already paid to the Secretary of State. This action is permanent and cannot be undone, are you sure you would like to delete?","PASS_ITEM_GUIDS_ON_CHECKOUT":true,"FORM_REVISION_HISTORY":true,"CHECKOUT_DISCLAIMER":"By entering your credit card and/or checking account information you (i) state that **you are an authorized user** of the credit card and/or electronic check and that the associated information entered (e.g., account holder name, account number, billing address) is accurate, (ii) **you authorize payment processor to charge the amount you have requested** to your credit card and/or funding account, and (iii) **acknowledge if a charge is declined or reversed you may also be assessed a customary charge** by the payment processor for such transactions.","FARM_BILL_SEARCH_CONFIDENTIAL":"As a registered Farm Bill Buyer with the Montana Secretary of State’s office it is important to maintain the confidentiality of the information contained within the Farm Bill Master List. The Farm Bill Master List reflects personal data, such as Social Security Numbers, which are a key piece of personal identifiable information to assist you in determining the existence of a lien against a specific debtor. The distribution of this information beyond its intended purpose is strictly prohibited.\n\n**The debtor's tax identification number has been hidden for confidentiality reasons. You may continue to search on a tax ID number and return debtors that match your search criteria. The SSN/FEIN must be entered without dashes or spaces.  If you need access to the tax identification number to clearly identify the debtor, please contact the UCC unit at (406) 444-3665.**","VIEW_HISTORY_BUTTON_ALT_TEXT":"View Filings","WIZARD_ERROR_TITLE_MESSAGE":"Form Error","FARM_BILL_SEARCH_INTERACTIVE":true,"USE_FARM_BILL_API":true,"DISALLOW_ASSIGN_SELF_AS_RA":true,"DISALLOW_ASSIGN_SELF_AS_PRINCIPAL":true,"USE_TRADEMARK_OWNER_VALIDATION":true,"USE_ALTERNATIVE_FOREIGN_ADDRESS_LABELS":true,"MY_RECEIPTS_FILTER":[{"type":"dateRange","name":"DATE_RANGE","label":"Date range","defaultValue":{"start":null,"end":null}},{"type":"text","name":"REF_NUM","defaultValue":"","label":"Reference Number"},{"type":"text","name":"RECEIPT_NUM","defaultValue":"","label":"Receipt Id"},{"type":"text","name":"AMOUNT","defaultValue":"","label":"Amount"},{"type":"select","name":"TYPE","defaultValue":"","label":"Payment Type","options":[{"value":"","label":"All"},{"value":"CC","label":"Credit Card"},{"value":"Check","label":"Check"}]}],"MY_RECEIPTS_SHOW_IN_SIDEBAR":true,"SHOW_MY_RECEIPTS_HELPER_TEXT":true,"MY_RECEIPTS_HELPER_LABEL":"About Receipt Search","MY_RECEIPTS_HELPER_TEXT":"You can search for receipts based on their descriptions, including the items paid for on the receipt. Use the filters to search for or filter specific information.","FARM_BILL_SUBLINK":{"label":"Farm Bill","component":"FarmBill","parameter":"farm-bill","path":"/lists/farm-bill","sourceTypeId":0,"myRecordsSearch":false,"allowedRules":["/search/"],"disabled":true,"searchDescription":"To perform a search, enter a debtor name. Your search results may include: exact debtor name, variations of that name and any filing that includes your search criteria. Punctuation is ignored.\n\nYou can click on \"Advanced\" to refine your search. Under “Advanced” you can search by crop, year, county and SSN/FEIN. As a registered Farm Bill Buyer with the Montana Secretary of State’s office it is important to maintain the confidentiality of the information contained within the Farm Bill Master List. The Farm Bill Master List reflects personal data, such as Social Security Numbers, which are a key piece of personal identifiable information to assist you in determining the existence of a lien against a specific debtor. The distribution of this information beyond its intended purpose is strictly prohibited.\n\nThe debtor's tax identification number has been hidden for confidentiality reasons. You may continue to search on a tax ID number and return debtors that match your search criteria. The SSN/FEIN must be entered without dashes or spaces.","searchMustHaveOneOf":["search","UCC_FARM_PRODUCT_ID","COUNTY"],"searchPlaceholder":"Search by debtor name","advancedSearchParameters":[{"type":"ServerMultiComplete","label":"Product code name(s)","name":"UCC_FARM_PRODUCT_ID","defaultValue":"","optionsSrc":"UCC_FARM_PRODUCT_V"},{"type":"MultiComplete","label":"Year or Range of Years","name":"YEAR_NUM","optionsSrc":"years","startYear":"1968","defaultValue":[],"preMergeOptions":[{"value":"ALL","label":"All"}]},{"type":"serverSelect","label":"State","name":"STATE","defaultValue":"MONTANA","optionsSrc":"STATE"},{"type":"ServerMultiComplete","label":"County","name":"COUNTY","defaultValue":[],"optionsSrc":"COUNTY","overrideSubOptionsSrcFromParameterName":"STATE"},{"type":"checkbox","name":"TIN_SEARCH_YN","defaultValue":false,"label":"Tax Identification Number Search"},{"type":"checkbox","name":"TIN_SORT_YN","defaultValue":false,"label":"Unique ID Sort"}]},"ALLOW_ADDRESS_VALIDATION_BYPASS_OPTION":true,"DEFAULT_ADDRESS_VALIDATION_BYPASS_OPTION_CHECKED":true}).SEARCH_IS_SORTABLE || sublink.searchIsSortable) {
	          headerClickedFunction = this.setSort;
	        }
	
	        return _react2.default.createElement(
	          _react2.default.Fragment,
	          null,
	          (SEARCH_HAS_PAGINATION || sublink.searchHasPagination) && props.orderedResults.rows && props.orderedResults.rows.length > 1 ? _react2.default.createElement(_Pager2.default, Object.assign({}, this.getPagerProps(), {
	            onPrevClicked: this.onPrevClicked,
	            onPageClicked: this.onPageClicked,
	            onNextClicked: this.onNextClicked
	          })) : null,
	          _react2.default.createElement(
	            'div',
	            { className: 'table-wrapper' },
	            _react2.default.createElement(_Table2.default, {
	              template: props.orderedResults.template,
	              rows: props.orderedResults.rows,
	              className: 'center-container',
	              onCellClick: this.selectRow,
	              selectedRowIndex: props.orderedResults.rows ? props.orderedResults.rows.findIndex(function (row) {
	                return row.ID === props.selectedId;
	              }) : false,
	              animated: false,
	              sortable: props.sortable || sublink.searchIsSortable || ({"NODE_ENV":"production","BUILD_DATE":"2025-08-27T15:15:31.687Z","BUILD_NUMBER":"Not Provided","GIT_VERSION":"v1.3.0-381-ga81e29b08","GIT_COMMIT_HASH":"a81e29b085c9268ffd96c78eb734365802722741","GIT_BRANCH":"beta","PUBLIC_URL":"","STATE_ABBR":"MT","STATE_NAME":"Montana","STATE_ORG_TITLE":"Secretary of State","LOGIN_HEADER_IMG_PATH":"","HOME_IMG_FILENAME":"montana.jpg","FAVICON_FILE_NAME":"favicon.ico","ALLOW_E_SIGN_ON_CORRECTIONS":true,"THIRD_PARTY_SIGNING_ALLOWED":false,"MY_ACCOUNT_SAVE_AND_CLOSE_BUTTON":true,"IE_DEPRECATED_MESSAGE":"Internet Explorer is not supported. Please select a supported browser below to access this website.","ADDITIONAL_ROUTES":{"dataRequests":true,"farmBill":true,"apostille":true,"externalHelp":"https://sosmt.gov/business/help-center/","systemAdministration":[{"title":"Saved Payments","parameter":"saved-payments","componentName":"SavedPayments"}]},"SUBROUTES":[{"label":"Business","component":"Business","parameter":"business","myWorkQueueSearch":false,"sourceTypeId":54,"searchMustHaveOneOf":["FILING_TYPE_ID","STATUS_ID","STATE","search"],"serverWebSearchDescription":true,"serverWorkQueueDescription":true,"serverMyRecordsDescription":true,"searchPlaceholder":"Search by name or filing number (X########)","allowEmptySearchTerm":true,"requestCertificateAlternateLabel":"Request Information","fileAmendmentButtonLabel":"Filing Actions","advancedSearchParameters":[{"type":"radio","name":"QUERY_TYPE_ID","defaultValue":1010,"options":[{"value":1010,"label":"Starts with"},{"value":1011,"label":"Contains"},{"value":1012,"label":" Word Contains"}]},{"type":"serverSelect","name":"FILING_TYPE_ID","optionsSrc":"FILING_TYPES","label":"Entity Type","placeholder":"All","defaultValue":"0"},{"type":"serverSelect","name":"FILING_SUBTYPE_ID","optionsSrc":"FILING_SUBTYPES","label":"Entity Subtype","overrideSubOptionsSrcFromParameterName":"FILING_TYPE_ID","placeholder":"All","defaultValue":"0"},{"type":"serverSelect","name":"STATUS_ID","optionsSrc":"FILING_STATUS_WITHOUT_ALL","label":"Status","placeholder":"All","defaultValue":"0"},{"type":"serverSelect","name":"STATE","optionsSrc":"STATE","label":"State","placeholder":"All","defaultValue":""},{"type":"serverSelect","name":"COUNTY","optionsSrc":"COUNTY_SUBOPTION","label":"County","overrideSubOptionsSrcFromParameterName":"STATE","placeholder":"All","defaultValue":""},{"type":"checkbox","name":"CRA_SEARCH_YN","defaultValue":false,"label":"Search by Registered Agent PID"},{"type":"dateRange","name":"FILING_DATE","label":"Registration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}},{"type":"dateRange","name":"EXPIRATION_DATE","label":"Expiration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}}],"myRecordsFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Active"},{"value":2,"label":"Inactive"},{"value":3,"label":"Pending"}]},{"type":"dateRange","name":"DATE_RANGE","label":"Date range","defaultValue":{"start":null,"end":null}}],"myWorkQueueFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Approved"},{"value":2,"label":"Pending Online Payment"},{"value":3,"label":"Pending Review"},{"value":4,"label":"Needs Correction"},{"value":5,"label":"Rejected"},{"value":6,"label":"Draft"}]},{"type":"dateRange","name":"DATE_RANGE","label":"Date range","defaultValue":{"start":null,"end":null}}]},{"label":"Notary","component":"Notary","parameter":"notary","sourceTypeId":850,"myWorkQueueSearch":false,"allowEmptySearchTerm":true,"requestCertificateAlternateLabel":"Download Certificate","fileAmendmentButtonLabel":"Filing Actions","hideNameRequestCertificate":true,"hideAddressRequestCertificate":true,"hideRecordUserManagment":true,"searchPlaceholder":"Search by name or commission number","searchMustHaveOneOf":["CITY","search","SERVICE_TYPE"],"advancedParametersStartOpen":true,"searchIsSortable":true,"advancedSearchParameters":[{"type":"radio","name":"STARTS_WITH_YN","defaultValue":false,"options":[{"value":true,"label":"Starts with"},{"value":false,"label":"Contains"}]},{"type":"checkbox","name":"ACTIVE_ONLY_YN","defaultValue":true,"label":"Active entities only"},{"type":"text","name":"CITY","defaultValue":"","label":"City"},{"type":"select","name":"SERVICE_TYPE","label":"Special Services Offered","defaultValue":0,"options":[{"value":0,"label":"(N/A)"},{"value":6165,"label":"In-Person Electronic Notarization (IPEN)"},{"value":6166,"label":"Remote Online Notarization (RON)"},{"value":6167,"label":"Mobile Notary Services"},{"value":6168,"label":"Remote Ink Notarization (RIN)"}]}]},{"label":"Apostille","component":"Apostille","parameter":"apostille","sourceTypeId":720,"myRecordsSearch":false,"myWorkQueueSearch":false,"disabled":false,"allowedRoutes":["/forms-manager/","/queue/","/forms/"]},{"label":"Liens","component":"UCC","parameter":"ucc","sourceTypeId":1999,"myRecordsSearch":true,"myWorkQueueSearch":true,"fileAmendmentButtonLabel":"Filing Actions","searchPlaceholder":"Search by name or file number","disabled":false,"serverWebSearchDescription":true,"myRecordsDescription":"","workQueueDescription":"","searchDescription":"","hideRecordUserManagment":true,"searchLiensCheckout":false,"advancedSearchParameters":[{"type":"radio","name":"STARTS_WITH_YN","defaultValue":false,"options":[{"value":true,"label":"Starts with"},{"value":false,"label":"Contains"}]},{"type":"select","name":"STATUS","defaultValue":"ALL","label":"Status","options":[{"value":"ACTIVE_UNLAPSED","label":"Active (unlapsed)"},{"value":"ACTIVE_LAPSED_UNLAPSED","label":"Active (lapsed and unlapsed)"}]},{"type":"text","name":"EXCLUDE_VALUES","label":"Exclude Debtor Names (comma separated list of names to exclude)","defaultValue":""},{"type":"dateRange","name":"FILING_DATE","label":"Financing Statement Date","defaultValue":{"start":null,"end":null}},{"type":"dateRange","name":"LAPSE_DATE","label":"Lapse Date","defaultValue":{"start":null,"end":null}},{"type":"text","name":"CITY","label":"Debtor City","defaultValue":""}],"myRecordsFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Approved"},{"value":2,"label":"Pending Online Payment"},{"value":3,"label":"Pending Review"}]},{"type":"select","name":"TYPE","defaultValue":0,"label":"Lien Type","options":[{"value":0,"label":"All"},{"value":1,"label":"UCC"},{"value":2,"label":"EFS"},{"value":3,"label":"Title 71"}]}],"myWorkQueueFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Approved"},{"value":2,"label":"Pending Online Payment"},{"value":3,"label":"Pending Review"},{"value":4,"label":"Pending Print and Mail"},{"value":5,"label":"Rejected"},{"value":6,"label":"Draft"}]},{"type":"select","name":"TYPE","defaultValue":0,"label":"Lien Type","options":[{"value":0,"label":"All"},{"value":1,"label":"UCC"},{"value":2,"label":"EFS"},{"value":3,"label":"Title 71"}]}]},{"label":"Copy Request","component":"copies","parameter":"copies","sourceTypeId":2001,"myRecordsSearch":false,"myWorkQueueSearch":false,"disabled":false,"allowedRoutes":["/forms-manager/","/queue/","/forms/"]},{"label":"Trademark","component":"Trademark","parameter":"trademark","sourceTypeId":810,"showRequestCertificate":true,"searchMustHaveOneOf":["search","EXPIRATION_DATE","FILING_DATE"],"allowEmptySearchTerm":true,"requestCertificateAlternateLabel":"Request Information","fileAmendmentButtonLabel":"Filing Actions","advancedSearchParameters":[{"type":"radio","name":"QUERY_TYPE_ID","defaultValue":1010,"options":[{"value":1010,"label":"Starts with"},{"value":1011,"label":"Contains"},{"value":1012,"label":" Word Contains"}]},{"type":"checkbox","name":"OWNER_SEARCH_YN","defaultValue":false,"label":"Search owners"},{"type":"radio","name":"SERVICE_MARK_YN","label":"Mark Type","defaultValue":"","options":[{"value":"","label":"All Marks"},{"value":"Y","label":"Service Mark"},{"value":"N","label":"Trademark"}]},{"type":"serverSelect","name":"STATUS_ID","optionsSrc":"TYPE_V|TRADEMARK_STATUS_TYPE","label":"Status","placeholder":"All","defaultValue":"0"},{"type":"select","name":"DESIGN_TYPE_ID","options":[{"value":0,"label":"All"},{"value":990,"label":"Words Only"},{"value":991,"label":"Design Only"},{"value":992,"label":"Words and Design"}],"label":"Design Type","defaultValue":"0"},{"type":"dateRange","name":"FILING_DATE","label":"Registered Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}},{"type":"dateRange","name":"EXPIRATION_DATE","label":"Expiration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}}]},{"label":"Business Info Request","component":"InfoRequests","parameter":"info-request","sourceTypeId":167,"allowedRoutes":["/forms-manager/","/queue/","/forms/"]},{"label":"Data Requests","component":"DataRequests","parameter":"data-request","sourceTypeId":0,"allowedRoutes":["/forms-manager/"]},{"label":"CRA","component":"CRA","parameter":"cra","sourceTypeId":157,"myRecordsSearch":false,"searchPlaceholder":"Search by name or registered agent number","allowedRoutes":["/forms-manager/","/forms/","/records/","/queue/","/search/"],"allowEmptySearchTerm":true,"fileAmendmentButtonLabel":"Filing Actions","advancedSearchParameters":[{"type":"radio","name":"QUERY_TYPE_ID","defaultValue":1010,"options":[{"value":1010,"label":"Starts with"},{"value":1011,"label":"Contains"},{"value":1012,"label":" Word Contains"}]},{"type":"dateRange","name":"CRA_DATE","label":"Registration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}},{"type":"select","name":"STATUS_ID","label":"Status","defaultValue":0,"options":[{"value":0,"label":"All"},{"value":121,"label":"Active"},{"value":122,"label":"Inactive"}]},{"type":"select","name":"AGENT_TYPE_ID","label":"Agent Type","defaultValue":0,"options":[{"value":0,"label":"All"},{"value":460,"label":"Registered Agent"},{"value":461,"label":"Commercial Registered Agent"}]}]},{"label":"Farm Bill","component":"FarmBill","parameter":"farm-bill","path":"/lists/farm-bill","sourceTypeId":0,"myRecordsSearch":false,"allowedRules":["/search/"],"disabled":true,"searchDescription":"To perform a search, enter a debtor name. Your search results may include: exact debtor name, variations of that name and any filing that includes your search criteria. Punctuation is ignored.\n\nYou can click on \"Advanced\" to refine your search. Under “Advanced” you can search by crop, year, county and SSN/FEIN. As a registered Farm Bill Buyer with the Montana Secretary of State’s office it is important to maintain the confidentiality of the information contained within the Farm Bill Master List. The Farm Bill Master List reflects personal data, such as Social Security Numbers, which are a key piece of personal identifiable information to assist you in determining the existence of a lien against a specific debtor. The distribution of this information beyond its intended purpose is strictly prohibited.\n\nThe debtor's tax identification number has been hidden for confidentiality reasons. You may continue to search on a tax ID number and return debtors that match your search criteria. The SSN/FEIN must be entered without dashes or spaces.","searchMustHaveOneOf":["search","UCC_FARM_PRODUCT_ID","COUNTY"],"searchPlaceholder":"Search by debtor name","advancedSearchParameters":[{"type":"ServerMultiComplete","label":"Product code name(s)","name":"UCC_FARM_PRODUCT_ID","defaultValue":"","optionsSrc":"UCC_FARM_PRODUCT_V"},{"type":"MultiComplete","label":"Year or Range of Years","name":"YEAR_NUM","optionsSrc":"years","startYear":"1968","defaultValue":[],"preMergeOptions":[{"value":"ALL","label":"All"}]},{"type":"serverSelect","label":"State","name":"STATE","defaultValue":"MONTANA","optionsSrc":"STATE"},{"type":"ServerMultiComplete","label":"County","name":"COUNTY","defaultValue":[],"optionsSrc":"COUNTY","overrideSubOptionsSrcFromParameterName":"STATE"},{"type":"checkbox","name":"TIN_SEARCH_YN","defaultValue":false,"label":"Tax Identification Number Search"},{"type":"checkbox","name":"TIN_SORT_YN","defaultValue":false,"label":"Unique ID Sort"}]}],"SYSTEM_NICKNAME":"Online Services Portal","PAYMENT_METHODS":[{"type":"bypass"},{"type":"iTransact"}],"PAYMENT_ALLOW_AMEX":true,"SYSTEM_ID_LABEL":"System Id","DOUBLE_COLUMN_PUBLIC_LOGIN":true,"INTERNAL_USER_MANAGEMENT":true,"ALLOW_PUBLIC_JSON_IMPORT":false,"MAX_FILE_UPLOAD_SIZE":10000000,"REFUND_TEXT":"","RETURN_TO_HOME_ON_LOGOUT":true,"CURRENT_SOS_NAME":"Christi Jacobsen","LOGO_FILENAME":"mt-sos-logo.png","LOGO_ALT":"Christi Jacobsen, Montana Secretary of State","LOGO_FULL_WIDTH":true,"HOME_HIDE_AUTH_HINT":true,"HOME_TITLE":"Montana Secretary of State","CUSTOM_TAB_TITLE":"Official Montana","HOME_SUBTITLE":"Online Business Services","ENTITY_NAME_CONSENT_DESCRIPTION":"","ALLOW_USER_PROFILE_EDITING":true,"COMPARE_FOREIGN_NAME_IN_ENTITY_NAME_VALIDATION":true,"FOREIGN_NAME_FIELD_NAME":"KIMA_PARENT_NAME_INFO","LOGIN_TITLE":"Montana Secretary of State Online Filing Portal Login","PUBLIC_LOGIN_LABEL":"Username","REVERSE_LOGIN_COLUMNS":true,"LOGIN_SEAL_FILENAME":"seal_white.png","SEPARATE_USERNAME_AND_EMAIL":true,"CREATE_ACCOUNT_BUTTON_ALIGN_LEFT":true,"CREATE_ACCOUNT_BUTTON_TEXT":"CREATE AN ACCOUNT","PASSWORD_CUSTOM_ERROR_TEXT":"The password must meet all requirements","ACCOUNT_CREATED_MESSAGE":"Please check your email to verify your account to login and allow a few minutes for this message to arrive. Check your junk/spam folders if you do not find the email in your inbox.","PUBLIC_LOGIN_PLACEHOLDER":" ","DISABLE_DEFAULT_PAYMENT_RADIO":true,"CUSTOM_RESET_PASSWORD_ERROR_MESSAGE":"Username invalid - no account found","PUBLIC_LOGIN_CREATE_DESCRIPTION":"### Existing User:\n\n  - Enter your username and password to login.  \n\n\n  #### - OR -  \n\n\n\n  - Forgot password? Click 'Reset Password' and follow the prompts.\n  - Forgot username? Click 'Forgot Username' and follow the prompts.  \n\n\n  ### New User:\n  ","LOGIN_HELP_LINK":"https://sosmt.gov/business/how-do-i/","LOGIN_HELP_LINK_TEXT":"Need Help?","FORGOT_USERNAME_TEXT":"Forgot Username?","LOGIN_ACTIVE_DIRECTORY_TEXT":"State User Login","MULTIPLE_LOGIN_METHODS":true,"HAS_ACTIVE_DIRECTORY_LOGIN":true,"RESET_PASSWORD_WITH_USERNAME":true,"DOWNLOAD_LINK":true,"SHOW_USERNAME_ACCOUNT_CREATE":true,"SHOW_SCROLL_DOWN_ARROW":true,"SHOW_ADDRESS_ACCOUNT_CREATE":true,"TWO_COLUMN_ACCOUNT_CREATE":true,"RESET_PASSWORD_TIP":"A link to change your password has been sent to your email. Please allow a few minutes for this message to arrive. Please check your junk/spam folders if you do not find the email in your inbox.","FORGOT_PASSWORD_LINK_TEXT":"Reset Password","PHONE_NUMBER_OPTIONAL_ACCOUNT_CREATE":true,"SHOW_REQUIRED_INDICATOR_ACCOUNT_CREATE":true,"PASSWORD_REQUIREMENTS_ACCOUNT_CREATE":"\n    <ul>\n      <li>MUST contain at least 8 characters (12+ recommended)</li>\n      <li>MUST contain at least one uppercase letter.</li>\n      <li>MUST contain at least one lowercase letter.</li>\n      <li>MUST contain at least one number.</li>\n      <li>MUST contain at least one special character (!”#$%&'()*+,-./:;<=>?</li>\n    </ul>\n  ","ALLOW_CERTIFICATION_REQUEST":true,"ALLOW_PUBLIC_CERTIFICATE_REQUEST":true,"ALLOW_COPY_REQUEST":false,"ALLOW_CORRECTION_STYLING":true,"HIDE_DEPRECATION_WARNING":false,"AMEND_ROUTE_PUBLIC":true,"SEAL_FILENAME":"seal.png","SHOPPING_CART":true,"ALLOW_PAYMENT_UPDATE_WITH_EMPTY_CART":true,"RA_EMAIL":true,"RA_WEBSITE":true,"RA_NO_DEFAULT_TYPE":true,"RA_ADDRESS_LABEL":"Street Address","RA_TYPE_SELECTION_DEFAULT":true,"RA_DEFAULT_TYPE":"460","RA_OVERRIDE_TYPE_WITH_DEFAULT":true,"RA_PRINCIPAL_ADDRESS_AMS":true,"UPLOAD_AND_SUBMIT_HIDE_IF_ONE_OPTION":true,"PAYMENT_PROCESSING_MESSAGE":"Your payment is processing - Do not close your browser or click the back button","CHECKOUT_BUTTON_WHEN_PROCESSING_TEXT":"Processing","EFS_CROP_PICKER_NONE_LABEL":"Lien Duration","DISALLOWED_WIZARD_PIECES":["FormationLocale"],"REPEATER_SHOW_EDIT_BUTTON":true,"DATA_REQUEST_PAGE_TITLE":"Data Requests and Subscriptions","DATA_REQUEST_SIDEBAR_LABEL":"Data Requests & Subscriptions","LOGIN_REDIRECTS_TO_EPASS":false,"LOGIN_REDIRECTS_TO_ACTIVE_DIRECTORY":true,"LOGIN_ACTIVE_DIRECTORY_LINK":true,"FETCH_EDIT_USER_LINK":false,"LISTS_FETCH_AVAILABLE_LISTS":true,"POST_WIZARD_SUBMIT_REDIRECT_URL":"/","PIN_REQUEST_ATTESTATIONS":true,"PIN_REQUEST_DESCRIPTION":"Click **Request PIN** to have a new PIN sent to the account holder's email address on file.","OWNERSHIP_REQUEST_DESCRIPTION":"To become an **authorized user** of this record, a current **AUTHORIZED USER** will need to grant you access. To request access, click **Request Access** below.","PIN_REQUEST_SUCCESS_MESSAGE":"The PIN you have requested for this entity has been sent to the email associated with your user account.  You should receive the PIN in approximately 3-5 minutes, depending on your email service provider.","APOSTILLE_HEADER_LABEL":"Verification Information","APOSTILLE_NUMBER_LABEL":"Apostille/Authentication","APOSTILLE_CITY_STATE_OVERRIDE":"HELENA, MT","APOSTILLE_FILING_DATE_LABEL":"Issue Date","APOSTILLE_CITY_STATE_IN_CERTIFIED":true,"NOTARY_EXISTING_FILING":true,"ALLOW_REVOKE_OWN_ACCESS_ONLY":false,"HIDE_CANCEL_ON_ONETIME_DATA_REQUESTS":true,"DATA_REQUESTS_IN_SHOPPING_CART":true,"WQ_ALLOW_EDIT_PENDING_PAYMENT":true,"WQ_CONFIRM_ON_DELETE":true,"WQ_DELETE_CONFIRM_MESSAGE":"Deleting this filing will forfeit any money already paid to the Secretary of State. This action is permanent and cannot be undone, are you sure you would like to delete?","PASS_ITEM_GUIDS_ON_CHECKOUT":true,"FORM_REVISION_HISTORY":true,"CHECKOUT_DISCLAIMER":"By entering your credit card and/or checking account information you (i) state that **you are an authorized user** of the credit card and/or electronic check and that the associated information entered (e.g., account holder name, account number, billing address) is accurate, (ii) **you authorize payment processor to charge the amount you have requested** to your credit card and/or funding account, and (iii) **acknowledge if a charge is declined or reversed you may also be assessed a customary charge** by the payment processor for such transactions.","FARM_BILL_SEARCH_CONFIDENTIAL":"As a registered Farm Bill Buyer with the Montana Secretary of State’s office it is important to maintain the confidentiality of the information contained within the Farm Bill Master List. The Farm Bill Master List reflects personal data, such as Social Security Numbers, which are a key piece of personal identifiable information to assist you in determining the existence of a lien against a specific debtor. The distribution of this information beyond its intended purpose is strictly prohibited.\n\n**The debtor's tax identification number has been hidden for confidentiality reasons. You may continue to search on a tax ID number and return debtors that match your search criteria. The SSN/FEIN must be entered without dashes or spaces.  If you need access to the tax identification number to clearly identify the debtor, please contact the UCC unit at (406) 444-3665.**","VIEW_HISTORY_BUTTON_ALT_TEXT":"View Filings","WIZARD_ERROR_TITLE_MESSAGE":"Form Error","FARM_BILL_SEARCH_INTERACTIVE":true,"USE_FARM_BILL_API":true,"DISALLOW_ASSIGN_SELF_AS_RA":true,"DISALLOW_ASSIGN_SELF_AS_PRINCIPAL":true,"USE_TRADEMARK_OWNER_VALIDATION":true,"USE_ALTERNATIVE_FOREIGN_ADDRESS_LABELS":true,"MY_RECEIPTS_FILTER":[{"type":"dateRange","name":"DATE_RANGE","label":"Date range","defaultValue":{"start":null,"end":null}},{"type":"text","name":"REF_NUM","defaultValue":"","label":"Reference Number"},{"type":"text","name":"RECEIPT_NUM","defaultValue":"","label":"Receipt Id"},{"type":"text","name":"AMOUNT","defaultValue":"","label":"Amount"},{"type":"select","name":"TYPE","defaultValue":"","label":"Payment Type","options":[{"value":"","label":"All"},{"value":"CC","label":"Credit Card"},{"value":"Check","label":"Check"}]}],"MY_RECEIPTS_SHOW_IN_SIDEBAR":true,"SHOW_MY_RECEIPTS_HELPER_TEXT":true,"MY_RECEIPTS_HELPER_LABEL":"About Receipt Search","MY_RECEIPTS_HELPER_TEXT":"You can search for receipts based on their descriptions, including the items paid for on the receipt. Use the filters to search for or filter specific information.","FARM_BILL_SUBLINK":{"label":"Farm Bill","component":"FarmBill","parameter":"farm-bill","path":"/lists/farm-bill","sourceTypeId":0,"myRecordsSearch":false,"allowedRules":["/search/"],"disabled":true,"searchDescription":"To perform a search, enter a debtor name. Your search results may include: exact debtor name, variations of that name and any filing that includes your search criteria. Punctuation is ignored.\n\nYou can click on \"Advanced\" to refine your search. Under “Advanced” you can search by crop, year, county and SSN/FEIN. As a registered Farm Bill Buyer with the Montana Secretary of State’s office it is important to maintain the confidentiality of the information contained within the Farm Bill Master List. The Farm Bill Master List reflects personal data, such as Social Security Numbers, which are a key piece of personal identifiable information to assist you in determining the existence of a lien against a specific debtor. The distribution of this information beyond its intended purpose is strictly prohibited.\n\nThe debtor's tax identification number has been hidden for confidentiality reasons. You may continue to search on a tax ID number and return debtors that match your search criteria. The SSN/FEIN must be entered without dashes or spaces.","searchMustHaveOneOf":["search","UCC_FARM_PRODUCT_ID","COUNTY"],"searchPlaceholder":"Search by debtor name","advancedSearchParameters":[{"type":"ServerMultiComplete","label":"Product code name(s)","name":"UCC_FARM_PRODUCT_ID","defaultValue":"","optionsSrc":"UCC_FARM_PRODUCT_V"},{"type":"MultiComplete","label":"Year or Range of Years","name":"YEAR_NUM","optionsSrc":"years","startYear":"1968","defaultValue":[],"preMergeOptions":[{"value":"ALL","label":"All"}]},{"type":"serverSelect","label":"State","name":"STATE","defaultValue":"MONTANA","optionsSrc":"STATE"},{"type":"ServerMultiComplete","label":"County","name":"COUNTY","defaultValue":[],"optionsSrc":"COUNTY","overrideSubOptionsSrcFromParameterName":"STATE"},{"type":"checkbox","name":"TIN_SEARCH_YN","defaultValue":false,"label":"Tax Identification Number Search"},{"type":"checkbox","name":"TIN_SORT_YN","defaultValue":false,"label":"Unique ID Sort"}]},"ALLOW_ADDRESS_VALIDATION_BYPASS_OPTION":true,"DEFAULT_ADDRESS_VALIDATION_BYPASS_OPTION_CHECKED":true}).SEARCH_IS_SORTABLE,
	              sortBy: props.sortBy,
	
	              sortByDirection: props.sortByDirection,
	              onHeaderLabelClicked: headerClickedFunction,
	              rowCount: true,
	              firstCellInteractive: props.firstCellInteractive,
	              totalRows: SEARCH_HAS_PAGINATION || sublink.searchHasPagination ? props.edge.total : null,
	              innerRef: function innerRef(ref) {
	                return _this2.searchResultsRef = ref;
	              }
	            })
	          ),
	          (SEARCH_HAS_PAGINATION || sublink.searchHasPagination) && props.orderedResults.rows && props.orderedResults.rows.length > 1 ? _react2.default.createElement(_Pager2.default, Object.assign({}, this.getPagerProps(), {
	            onPrevClicked: this.onPrevClicked,
	            onPageClicked: this.onPageClicked,
	            onNextClicked: this.onNextClicked
	          })) : null
	        );
	      } else if (props.orderedResults.rows && props.orderedResults.rows.length == 0) {
	        return _react2.default.createElement(_EmptySearchPlaceholder2.default, { searchTerm: props.currentSearchTerm });
	      } else if (props.searching) {
	        return _react2.default.createElement(_Loaders.Spinner, { className: 'search-loader' });
	      } else {
	        return null;
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this3 = this;
	
	      var _props = this.props,
	          orderedResults = _props.orderedResults,
	          results = _props.results,
	          selectedId = _props.selectedId,
	          activeCategory = _props.activeCategory,
	          sublinks = _props.sublinks,
	          allowEmptySearchTerm = _props.allowEmptySearchTerm,
	          sortBy = _props.sortBy,
	          sortByDirection = _props.sortByDirection,
	          sortable = _props.sortable,
	          _getSearchTrigger = _props.getSearchTrigger,
	          aboveSearchChildren = _props.aboveSearchChildren,
	          serverDescription = _props.serverDescription,
	          isStale = _props.isStale;
	
	      var category = this.props.match.params.subParam;
	      var selectedResult = results[selectedId];
	      var selectedTitle = selectedResult ? selectedResult.TITLE[0] : '';
	      var selectedSubtitle = selectedResult ? selectedResult.TITLE[1] : '';
	      var sublink = sublinks.find(function (l) {
	        return l.parameter === category;
	      }) || {};
	      var showSearchLiensCheckout = sublink.searchLiensCheckout === true;
	      var allowSearchPrint = sublink.allowSearchPrint === true;
	
	      if (!this.props.match.params.subParam) {
	        var curLocation = this.props.location.pathname;
	        curLocation = curLocation.replace(/\/+$/, '');
	        var url = curLocation + '/' + (activeCategory ? activeCategory : sublinks[0].parameter);
	        return _react2.default.createElement(_reactRouterDom.Redirect, { to: url });
	      } else if (!sublink.parameter) {
	        return _react2.default.createElement(_reactRouterDom.Redirect, { to: '/search/' + sublinks[0].parameter });
	      } else {
	        return _react2.default.createElement(
	          _Shell.Body,
	          { className: 'search', showDrawer: selectedId },
	          aboveSearchChildren,
	          sublink.serverWebSearchDescription && serverDescription === null ? _react2.default.createElement(
	            'div',
	            { className: 'flex-center-page' },
	            _react2.default.createElement(_Loaders.Spinner, { className: 'animated fadeIn', themeColor: 'neutral' })
	          ) : _react2.default.createElement(
	            _react2.default.Fragment,
	            null,
	            _react2.default.createElement(ConnectedSearchBox, {
	              title: (sublink.label || '') + ' Search',
	              showSearchLiensCheckout: showSearchLiensCheckout,
	              allowSearchPrint: allowSearchPrint,
	              placeholder: sublink.searchPlaceholder || ({"NODE_ENV":"production","BUILD_DATE":"2025-08-27T15:15:31.687Z","BUILD_NUMBER":"Not Provided","GIT_VERSION":"v1.3.0-381-ga81e29b08","GIT_COMMIT_HASH":"a81e29b085c9268ffd96c78eb734365802722741","GIT_BRANCH":"beta","PUBLIC_URL":"","STATE_ABBR":"MT","STATE_NAME":"Montana","STATE_ORG_TITLE":"Secretary of State","LOGIN_HEADER_IMG_PATH":"","HOME_IMG_FILENAME":"montana.jpg","FAVICON_FILE_NAME":"favicon.ico","ALLOW_E_SIGN_ON_CORRECTIONS":true,"THIRD_PARTY_SIGNING_ALLOWED":false,"MY_ACCOUNT_SAVE_AND_CLOSE_BUTTON":true,"IE_DEPRECATED_MESSAGE":"Internet Explorer is not supported. Please select a supported browser below to access this website.","ADDITIONAL_ROUTES":{"dataRequests":true,"farmBill":true,"apostille":true,"externalHelp":"https://sosmt.gov/business/help-center/","systemAdministration":[{"title":"Saved Payments","parameter":"saved-payments","componentName":"SavedPayments"}]},"SUBROUTES":[{"label":"Business","component":"Business","parameter":"business","myWorkQueueSearch":false,"sourceTypeId":54,"searchMustHaveOneOf":["FILING_TYPE_ID","STATUS_ID","STATE","search"],"serverWebSearchDescription":true,"serverWorkQueueDescription":true,"serverMyRecordsDescription":true,"searchPlaceholder":"Search by name or filing number (X########)","allowEmptySearchTerm":true,"requestCertificateAlternateLabel":"Request Information","fileAmendmentButtonLabel":"Filing Actions","advancedSearchParameters":[{"type":"radio","name":"QUERY_TYPE_ID","defaultValue":1010,"options":[{"value":1010,"label":"Starts with"},{"value":1011,"label":"Contains"},{"value":1012,"label":" Word Contains"}]},{"type":"serverSelect","name":"FILING_TYPE_ID","optionsSrc":"FILING_TYPES","label":"Entity Type","placeholder":"All","defaultValue":"0"},{"type":"serverSelect","name":"FILING_SUBTYPE_ID","optionsSrc":"FILING_SUBTYPES","label":"Entity Subtype","overrideSubOptionsSrcFromParameterName":"FILING_TYPE_ID","placeholder":"All","defaultValue":"0"},{"type":"serverSelect","name":"STATUS_ID","optionsSrc":"FILING_STATUS_WITHOUT_ALL","label":"Status","placeholder":"All","defaultValue":"0"},{"type":"serverSelect","name":"STATE","optionsSrc":"STATE","label":"State","placeholder":"All","defaultValue":""},{"type":"serverSelect","name":"COUNTY","optionsSrc":"COUNTY_SUBOPTION","label":"County","overrideSubOptionsSrcFromParameterName":"STATE","placeholder":"All","defaultValue":""},{"type":"checkbox","name":"CRA_SEARCH_YN","defaultValue":false,"label":"Search by Registered Agent PID"},{"type":"dateRange","name":"FILING_DATE","label":"Registration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}},{"type":"dateRange","name":"EXPIRATION_DATE","label":"Expiration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}}],"myRecordsFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Active"},{"value":2,"label":"Inactive"},{"value":3,"label":"Pending"}]},{"type":"dateRange","name":"DATE_RANGE","label":"Date range","defaultValue":{"start":null,"end":null}}],"myWorkQueueFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Approved"},{"value":2,"label":"Pending Online Payment"},{"value":3,"label":"Pending Review"},{"value":4,"label":"Needs Correction"},{"value":5,"label":"Rejected"},{"value":6,"label":"Draft"}]},{"type":"dateRange","name":"DATE_RANGE","label":"Date range","defaultValue":{"start":null,"end":null}}]},{"label":"Notary","component":"Notary","parameter":"notary","sourceTypeId":850,"myWorkQueueSearch":false,"allowEmptySearchTerm":true,"requestCertificateAlternateLabel":"Download Certificate","fileAmendmentButtonLabel":"Filing Actions","hideNameRequestCertificate":true,"hideAddressRequestCertificate":true,"hideRecordUserManagment":true,"searchPlaceholder":"Search by name or commission number","searchMustHaveOneOf":["CITY","search","SERVICE_TYPE"],"advancedParametersStartOpen":true,"searchIsSortable":true,"advancedSearchParameters":[{"type":"radio","name":"STARTS_WITH_YN","defaultValue":false,"options":[{"value":true,"label":"Starts with"},{"value":false,"label":"Contains"}]},{"type":"checkbox","name":"ACTIVE_ONLY_YN","defaultValue":true,"label":"Active entities only"},{"type":"text","name":"CITY","defaultValue":"","label":"City"},{"type":"select","name":"SERVICE_TYPE","label":"Special Services Offered","defaultValue":0,"options":[{"value":0,"label":"(N/A)"},{"value":6165,"label":"In-Person Electronic Notarization (IPEN)"},{"value":6166,"label":"Remote Online Notarization (RON)"},{"value":6167,"label":"Mobile Notary Services"},{"value":6168,"label":"Remote Ink Notarization (RIN)"}]}]},{"label":"Apostille","component":"Apostille","parameter":"apostille","sourceTypeId":720,"myRecordsSearch":false,"myWorkQueueSearch":false,"disabled":false,"allowedRoutes":["/forms-manager/","/queue/","/forms/"]},{"label":"Liens","component":"UCC","parameter":"ucc","sourceTypeId":1999,"myRecordsSearch":true,"myWorkQueueSearch":true,"fileAmendmentButtonLabel":"Filing Actions","searchPlaceholder":"Search by name or file number","disabled":false,"serverWebSearchDescription":true,"myRecordsDescription":"","workQueueDescription":"","searchDescription":"","hideRecordUserManagment":true,"searchLiensCheckout":false,"advancedSearchParameters":[{"type":"radio","name":"STARTS_WITH_YN","defaultValue":false,"options":[{"value":true,"label":"Starts with"},{"value":false,"label":"Contains"}]},{"type":"select","name":"STATUS","defaultValue":"ALL","label":"Status","options":[{"value":"ACTIVE_UNLAPSED","label":"Active (unlapsed)"},{"value":"ACTIVE_LAPSED_UNLAPSED","label":"Active (lapsed and unlapsed)"}]},{"type":"text","name":"EXCLUDE_VALUES","label":"Exclude Debtor Names (comma separated list of names to exclude)","defaultValue":""},{"type":"dateRange","name":"FILING_DATE","label":"Financing Statement Date","defaultValue":{"start":null,"end":null}},{"type":"dateRange","name":"LAPSE_DATE","label":"Lapse Date","defaultValue":{"start":null,"end":null}},{"type":"text","name":"CITY","label":"Debtor City","defaultValue":""}],"myRecordsFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Approved"},{"value":2,"label":"Pending Online Payment"},{"value":3,"label":"Pending Review"}]},{"type":"select","name":"TYPE","defaultValue":0,"label":"Lien Type","options":[{"value":0,"label":"All"},{"value":1,"label":"UCC"},{"value":2,"label":"EFS"},{"value":3,"label":"Title 71"}]}],"myWorkQueueFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Approved"},{"value":2,"label":"Pending Online Payment"},{"value":3,"label":"Pending Review"},{"value":4,"label":"Pending Print and Mail"},{"value":5,"label":"Rejected"},{"value":6,"label":"Draft"}]},{"type":"select","name":"TYPE","defaultValue":0,"label":"Lien Type","options":[{"value":0,"label":"All"},{"value":1,"label":"UCC"},{"value":2,"label":"EFS"},{"value":3,"label":"Title 71"}]}]},{"label":"Copy Request","component":"copies","parameter":"copies","sourceTypeId":2001,"myRecordsSearch":false,"myWorkQueueSearch":false,"disabled":false,"allowedRoutes":["/forms-manager/","/queue/","/forms/"]},{"label":"Trademark","component":"Trademark","parameter":"trademark","sourceTypeId":810,"showRequestCertificate":true,"searchMustHaveOneOf":["search","EXPIRATION_DATE","FILING_DATE"],"allowEmptySearchTerm":true,"requestCertificateAlternateLabel":"Request Information","fileAmendmentButtonLabel":"Filing Actions","advancedSearchParameters":[{"type":"radio","name":"QUERY_TYPE_ID","defaultValue":1010,"options":[{"value":1010,"label":"Starts with"},{"value":1011,"label":"Contains"},{"value":1012,"label":" Word Contains"}]},{"type":"checkbox","name":"OWNER_SEARCH_YN","defaultValue":false,"label":"Search owners"},{"type":"radio","name":"SERVICE_MARK_YN","label":"Mark Type","defaultValue":"","options":[{"value":"","label":"All Marks"},{"value":"Y","label":"Service Mark"},{"value":"N","label":"Trademark"}]},{"type":"serverSelect","name":"STATUS_ID","optionsSrc":"TYPE_V|TRADEMARK_STATUS_TYPE","label":"Status","placeholder":"All","defaultValue":"0"},{"type":"select","name":"DESIGN_TYPE_ID","options":[{"value":0,"label":"All"},{"value":990,"label":"Words Only"},{"value":991,"label":"Design Only"},{"value":992,"label":"Words and Design"}],"label":"Design Type","defaultValue":"0"},{"type":"dateRange","name":"FILING_DATE","label":"Registered Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}},{"type":"dateRange","name":"EXPIRATION_DATE","label":"Expiration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}}]},{"label":"Business Info Request","component":"InfoRequests","parameter":"info-request","sourceTypeId":167,"allowedRoutes":["/forms-manager/","/queue/","/forms/"]},{"label":"Data Requests","component":"DataRequests","parameter":"data-request","sourceTypeId":0,"allowedRoutes":["/forms-manager/"]},{"label":"CRA","component":"CRA","parameter":"cra","sourceTypeId":157,"myRecordsSearch":false,"searchPlaceholder":"Search by name or registered agent number","allowedRoutes":["/forms-manager/","/forms/","/records/","/queue/","/search/"],"allowEmptySearchTerm":true,"fileAmendmentButtonLabel":"Filing Actions","advancedSearchParameters":[{"type":"radio","name":"QUERY_TYPE_ID","defaultValue":1010,"options":[{"value":1010,"label":"Starts with"},{"value":1011,"label":"Contains"},{"value":1012,"label":" Word Contains"}]},{"type":"dateRange","name":"CRA_DATE","label":"Registration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}},{"type":"select","name":"STATUS_ID","label":"Status","defaultValue":0,"options":[{"value":0,"label":"All"},{"value":121,"label":"Active"},{"value":122,"label":"Inactive"}]},{"type":"select","name":"AGENT_TYPE_ID","label":"Agent Type","defaultValue":0,"options":[{"value":0,"label":"All"},{"value":460,"label":"Registered Agent"},{"value":461,"label":"Commercial Registered Agent"}]}]},{"label":"Farm Bill","component":"FarmBill","parameter":"farm-bill","path":"/lists/farm-bill","sourceTypeId":0,"myRecordsSearch":false,"allowedRules":["/search/"],"disabled":true,"searchDescription":"To perform a search, enter a debtor name. Your search results may include: exact debtor name, variations of that name and any filing that includes your search criteria. Punctuation is ignored.\n\nYou can click on \"Advanced\" to refine your search. Under “Advanced” you can search by crop, year, county and SSN/FEIN. As a registered Farm Bill Buyer with the Montana Secretary of State’s office it is important to maintain the confidentiality of the information contained within the Farm Bill Master List. The Farm Bill Master List reflects personal data, such as Social Security Numbers, which are a key piece of personal identifiable information to assist you in determining the existence of a lien against a specific debtor. The distribution of this information beyond its intended purpose is strictly prohibited.\n\nThe debtor's tax identification number has been hidden for confidentiality reasons. You may continue to search on a tax ID number and return debtors that match your search criteria. The SSN/FEIN must be entered without dashes or spaces.","searchMustHaveOneOf":["search","UCC_FARM_PRODUCT_ID","COUNTY"],"searchPlaceholder":"Search by debtor name","advancedSearchParameters":[{"type":"ServerMultiComplete","label":"Product code name(s)","name":"UCC_FARM_PRODUCT_ID","defaultValue":"","optionsSrc":"UCC_FARM_PRODUCT_V"},{"type":"MultiComplete","label":"Year or Range of Years","name":"YEAR_NUM","optionsSrc":"years","startYear":"1968","defaultValue":[],"preMergeOptions":[{"value":"ALL","label":"All"}]},{"type":"serverSelect","label":"State","name":"STATE","defaultValue":"MONTANA","optionsSrc":"STATE"},{"type":"ServerMultiComplete","label":"County","name":"COUNTY","defaultValue":[],"optionsSrc":"COUNTY","overrideSubOptionsSrcFromParameterName":"STATE"},{"type":"checkbox","name":"TIN_SEARCH_YN","defaultValue":false,"label":"Tax Identification Number Search"},{"type":"checkbox","name":"TIN_SORT_YN","defaultValue":false,"label":"Unique ID Sort"}]}],"SYSTEM_NICKNAME":"Online Services Portal","PAYMENT_METHODS":[{"type":"bypass"},{"type":"iTransact"}],"PAYMENT_ALLOW_AMEX":true,"SYSTEM_ID_LABEL":"System Id","DOUBLE_COLUMN_PUBLIC_LOGIN":true,"INTERNAL_USER_MANAGEMENT":true,"ALLOW_PUBLIC_JSON_IMPORT":false,"MAX_FILE_UPLOAD_SIZE":10000000,"REFUND_TEXT":"","RETURN_TO_HOME_ON_LOGOUT":true,"CURRENT_SOS_NAME":"Christi Jacobsen","LOGO_FILENAME":"mt-sos-logo.png","LOGO_ALT":"Christi Jacobsen, Montana Secretary of State","LOGO_FULL_WIDTH":true,"HOME_HIDE_AUTH_HINT":true,"HOME_TITLE":"Montana Secretary of State","CUSTOM_TAB_TITLE":"Official Montana","HOME_SUBTITLE":"Online Business Services","ENTITY_NAME_CONSENT_DESCRIPTION":"","ALLOW_USER_PROFILE_EDITING":true,"COMPARE_FOREIGN_NAME_IN_ENTITY_NAME_VALIDATION":true,"FOREIGN_NAME_FIELD_NAME":"KIMA_PARENT_NAME_INFO","LOGIN_TITLE":"Montana Secretary of State Online Filing Portal Login","PUBLIC_LOGIN_LABEL":"Username","REVERSE_LOGIN_COLUMNS":true,"LOGIN_SEAL_FILENAME":"seal_white.png","SEPARATE_USERNAME_AND_EMAIL":true,"CREATE_ACCOUNT_BUTTON_ALIGN_LEFT":true,"CREATE_ACCOUNT_BUTTON_TEXT":"CREATE AN ACCOUNT","PASSWORD_CUSTOM_ERROR_TEXT":"The password must meet all requirements","ACCOUNT_CREATED_MESSAGE":"Please check your email to verify your account to login and allow a few minutes for this message to arrive. Check your junk/spam folders if you do not find the email in your inbox.","PUBLIC_LOGIN_PLACEHOLDER":" ","DISABLE_DEFAULT_PAYMENT_RADIO":true,"CUSTOM_RESET_PASSWORD_ERROR_MESSAGE":"Username invalid - no account found","PUBLIC_LOGIN_CREATE_DESCRIPTION":"### Existing User:\n\n  - Enter your username and password to login.  \n\n\n  #### - OR -  \n\n\n\n  - Forgot password? Click 'Reset Password' and follow the prompts.\n  - Forgot username? Click 'Forgot Username' and follow the prompts.  \n\n\n  ### New User:\n  ","LOGIN_HELP_LINK":"https://sosmt.gov/business/how-do-i/","LOGIN_HELP_LINK_TEXT":"Need Help?","FORGOT_USERNAME_TEXT":"Forgot Username?","LOGIN_ACTIVE_DIRECTORY_TEXT":"State User Login","MULTIPLE_LOGIN_METHODS":true,"HAS_ACTIVE_DIRECTORY_LOGIN":true,"RESET_PASSWORD_WITH_USERNAME":true,"DOWNLOAD_LINK":true,"SHOW_USERNAME_ACCOUNT_CREATE":true,"SHOW_SCROLL_DOWN_ARROW":true,"SHOW_ADDRESS_ACCOUNT_CREATE":true,"TWO_COLUMN_ACCOUNT_CREATE":true,"RESET_PASSWORD_TIP":"A link to change your password has been sent to your email. Please allow a few minutes for this message to arrive. Please check your junk/spam folders if you do not find the email in your inbox.","FORGOT_PASSWORD_LINK_TEXT":"Reset Password","PHONE_NUMBER_OPTIONAL_ACCOUNT_CREATE":true,"SHOW_REQUIRED_INDICATOR_ACCOUNT_CREATE":true,"PASSWORD_REQUIREMENTS_ACCOUNT_CREATE":"\n    <ul>\n      <li>MUST contain at least 8 characters (12+ recommended)</li>\n      <li>MUST contain at least one uppercase letter.</li>\n      <li>MUST contain at least one lowercase letter.</li>\n      <li>MUST contain at least one number.</li>\n      <li>MUST contain at least one special character (!”#$%&'()*+,-./:;<=>?</li>\n    </ul>\n  ","ALLOW_CERTIFICATION_REQUEST":true,"ALLOW_PUBLIC_CERTIFICATE_REQUEST":true,"ALLOW_COPY_REQUEST":false,"ALLOW_CORRECTION_STYLING":true,"HIDE_DEPRECATION_WARNING":false,"AMEND_ROUTE_PUBLIC":true,"SEAL_FILENAME":"seal.png","SHOPPING_CART":true,"ALLOW_PAYMENT_UPDATE_WITH_EMPTY_CART":true,"RA_EMAIL":true,"RA_WEBSITE":true,"RA_NO_DEFAULT_TYPE":true,"RA_ADDRESS_LABEL":"Street Address","RA_TYPE_SELECTION_DEFAULT":true,"RA_DEFAULT_TYPE":"460","RA_OVERRIDE_TYPE_WITH_DEFAULT":true,"RA_PRINCIPAL_ADDRESS_AMS":true,"UPLOAD_AND_SUBMIT_HIDE_IF_ONE_OPTION":true,"PAYMENT_PROCESSING_MESSAGE":"Your payment is processing - Do not close your browser or click the back button","CHECKOUT_BUTTON_WHEN_PROCESSING_TEXT":"Processing","EFS_CROP_PICKER_NONE_LABEL":"Lien Duration","DISALLOWED_WIZARD_PIECES":["FormationLocale"],"REPEATER_SHOW_EDIT_BUTTON":true,"DATA_REQUEST_PAGE_TITLE":"Data Requests and Subscriptions","DATA_REQUEST_SIDEBAR_LABEL":"Data Requests & Subscriptions","LOGIN_REDIRECTS_TO_EPASS":false,"LOGIN_REDIRECTS_TO_ACTIVE_DIRECTORY":true,"LOGIN_ACTIVE_DIRECTORY_LINK":true,"FETCH_EDIT_USER_LINK":false,"LISTS_FETCH_AVAILABLE_LISTS":true,"POST_WIZARD_SUBMIT_REDIRECT_URL":"/","PIN_REQUEST_ATTESTATIONS":true,"PIN_REQUEST_DESCRIPTION":"Click **Request PIN** to have a new PIN sent to the account holder's email address on file.","OWNERSHIP_REQUEST_DESCRIPTION":"To become an **authorized user** of this record, a current **AUTHORIZED USER** will need to grant you access. To request access, click **Request Access** below.","PIN_REQUEST_SUCCESS_MESSAGE":"The PIN you have requested for this entity has been sent to the email associated with your user account.  You should receive the PIN in approximately 3-5 minutes, depending on your email service provider.","APOSTILLE_HEADER_LABEL":"Verification Information","APOSTILLE_NUMBER_LABEL":"Apostille/Authentication","APOSTILLE_CITY_STATE_OVERRIDE":"HELENA, MT","APOSTILLE_FILING_DATE_LABEL":"Issue Date","APOSTILLE_CITY_STATE_IN_CERTIFIED":true,"NOTARY_EXISTING_FILING":true,"ALLOW_REVOKE_OWN_ACCESS_ONLY":false,"HIDE_CANCEL_ON_ONETIME_DATA_REQUESTS":true,"DATA_REQUESTS_IN_SHOPPING_CART":true,"WQ_ALLOW_EDIT_PENDING_PAYMENT":true,"WQ_CONFIRM_ON_DELETE":true,"WQ_DELETE_CONFIRM_MESSAGE":"Deleting this filing will forfeit any money already paid to the Secretary of State. This action is permanent and cannot be undone, are you sure you would like to delete?","PASS_ITEM_GUIDS_ON_CHECKOUT":true,"FORM_REVISION_HISTORY":true,"CHECKOUT_DISCLAIMER":"By entering your credit card and/or checking account information you (i) state that **you are an authorized user** of the credit card and/or electronic check and that the associated information entered (e.g., account holder name, account number, billing address) is accurate, (ii) **you authorize payment processor to charge the amount you have requested** to your credit card and/or funding account, and (iii) **acknowledge if a charge is declined or reversed you may also be assessed a customary charge** by the payment processor for such transactions.","FARM_BILL_SEARCH_CONFIDENTIAL":"As a registered Farm Bill Buyer with the Montana Secretary of State’s office it is important to maintain the confidentiality of the information contained within the Farm Bill Master List. The Farm Bill Master List reflects personal data, such as Social Security Numbers, which are a key piece of personal identifiable information to assist you in determining the existence of a lien against a specific debtor. The distribution of this information beyond its intended purpose is strictly prohibited.\n\n**The debtor's tax identification number has been hidden for confidentiality reasons. You may continue to search on a tax ID number and return debtors that match your search criteria. The SSN/FEIN must be entered without dashes or spaces.  If you need access to the tax identification number to clearly identify the debtor, please contact the UCC unit at (406) 444-3665.**","VIEW_HISTORY_BUTTON_ALT_TEXT":"View Filings","WIZARD_ERROR_TITLE_MESSAGE":"Form Error","FARM_BILL_SEARCH_INTERACTIVE":true,"USE_FARM_BILL_API":true,"DISALLOW_ASSIGN_SELF_AS_RA":true,"DISALLOW_ASSIGN_SELF_AS_PRINCIPAL":true,"USE_TRADEMARK_OWNER_VALIDATION":true,"USE_ALTERNATIVE_FOREIGN_ADDRESS_LABELS":true,"MY_RECEIPTS_FILTER":[{"type":"dateRange","name":"DATE_RANGE","label":"Date range","defaultValue":{"start":null,"end":null}},{"type":"text","name":"REF_NUM","defaultValue":"","label":"Reference Number"},{"type":"text","name":"RECEIPT_NUM","defaultValue":"","label":"Receipt Id"},{"type":"text","name":"AMOUNT","defaultValue":"","label":"Amount"},{"type":"select","name":"TYPE","defaultValue":"","label":"Payment Type","options":[{"value":"","label":"All"},{"value":"CC","label":"Credit Card"},{"value":"Check","label":"Check"}]}],"MY_RECEIPTS_SHOW_IN_SIDEBAR":true,"SHOW_MY_RECEIPTS_HELPER_TEXT":true,"MY_RECEIPTS_HELPER_LABEL":"About Receipt Search","MY_RECEIPTS_HELPER_TEXT":"You can search for receipts based on their descriptions, including the items paid for on the receipt. Use the filters to search for or filter specific information.","FARM_BILL_SUBLINK":{"label":"Farm Bill","component":"FarmBill","parameter":"farm-bill","path":"/lists/farm-bill","sourceTypeId":0,"myRecordsSearch":false,"allowedRules":["/search/"],"disabled":true,"searchDescription":"To perform a search, enter a debtor name. Your search results may include: exact debtor name, variations of that name and any filing that includes your search criteria. Punctuation is ignored.\n\nYou can click on \"Advanced\" to refine your search. Under “Advanced” you can search by crop, year, county and SSN/FEIN. As a registered Farm Bill Buyer with the Montana Secretary of State’s office it is important to maintain the confidentiality of the information contained within the Farm Bill Master List. The Farm Bill Master List reflects personal data, such as Social Security Numbers, which are a key piece of personal identifiable information to assist you in determining the existence of a lien against a specific debtor. The distribution of this information beyond its intended purpose is strictly prohibited.\n\nThe debtor's tax identification number has been hidden for confidentiality reasons. You may continue to search on a tax ID number and return debtors that match your search criteria. The SSN/FEIN must be entered without dashes or spaces.","searchMustHaveOneOf":["search","UCC_FARM_PRODUCT_ID","COUNTY"],"searchPlaceholder":"Search by debtor name","advancedSearchParameters":[{"type":"ServerMultiComplete","label":"Product code name(s)","name":"UCC_FARM_PRODUCT_ID","defaultValue":"","optionsSrc":"UCC_FARM_PRODUCT_V"},{"type":"MultiComplete","label":"Year or Range of Years","name":"YEAR_NUM","optionsSrc":"years","startYear":"1968","defaultValue":[],"preMergeOptions":[{"value":"ALL","label":"All"}]},{"type":"serverSelect","label":"State","name":"STATE","defaultValue":"MONTANA","optionsSrc":"STATE"},{"type":"ServerMultiComplete","label":"County","name":"COUNTY","defaultValue":[],"optionsSrc":"COUNTY","overrideSubOptionsSrcFromParameterName":"STATE"},{"type":"checkbox","name":"TIN_SEARCH_YN","defaultValue":false,"label":"Tax Identification Number Search"},{"type":"checkbox","name":"TIN_SORT_YN","defaultValue":false,"label":"Unique ID Sort"}]},"ALLOW_ADDRESS_VALIDATION_BYPASS_OPTION":true,"DEFAULT_ADDRESS_VALIDATION_BYPASS_OPTION_CHECKED":true}).DEFAULT_SEARCH_PLACEHOLDER || 'Search by name or ' + ("System Id").toLowerCase() + ' (###-#####)',
	              onResultsReceived: this.setResults,
	              category: category,
	              advancedParameters: sublink.advancedSearchParameters,
	              searchRequirementsAreSatisfied: sublink.searchRequirementsAreSatisfied,
	              description: serverDescription || sublink.searchDescription || "",
	              limitDescription: sublink.limitDescription,
	              hasResults: orderedResults.rows && orderedResults.rows.length > 0,
	              onPurchaseRequested: showSearchLiensCheckout ? this.startLiensCheckout : null,
	              allowEmptySearchTerm: allowEmptySearchTerm || sublink.allowEmptySearchTerm,
	              sortable: sortable || sublink.searchIsSortable || ({"NODE_ENV":"production","BUILD_DATE":"2025-08-27T15:15:31.687Z","BUILD_NUMBER":"Not Provided","GIT_VERSION":"v1.3.0-381-ga81e29b08","GIT_COMMIT_HASH":"a81e29b085c9268ffd96c78eb734365802722741","GIT_BRANCH":"beta","PUBLIC_URL":"","STATE_ABBR":"MT","STATE_NAME":"Montana","STATE_ORG_TITLE":"Secretary of State","LOGIN_HEADER_IMG_PATH":"","HOME_IMG_FILENAME":"montana.jpg","FAVICON_FILE_NAME":"favicon.ico","ALLOW_E_SIGN_ON_CORRECTIONS":true,"THIRD_PARTY_SIGNING_ALLOWED":false,"MY_ACCOUNT_SAVE_AND_CLOSE_BUTTON":true,"IE_DEPRECATED_MESSAGE":"Internet Explorer is not supported. Please select a supported browser below to access this website.","ADDITIONAL_ROUTES":{"dataRequests":true,"farmBill":true,"apostille":true,"externalHelp":"https://sosmt.gov/business/help-center/","systemAdministration":[{"title":"Saved Payments","parameter":"saved-payments","componentName":"SavedPayments"}]},"SUBROUTES":[{"label":"Business","component":"Business","parameter":"business","myWorkQueueSearch":false,"sourceTypeId":54,"searchMustHaveOneOf":["FILING_TYPE_ID","STATUS_ID","STATE","search"],"serverWebSearchDescription":true,"serverWorkQueueDescription":true,"serverMyRecordsDescription":true,"searchPlaceholder":"Search by name or filing number (X########)","allowEmptySearchTerm":true,"requestCertificateAlternateLabel":"Request Information","fileAmendmentButtonLabel":"Filing Actions","advancedSearchParameters":[{"type":"radio","name":"QUERY_TYPE_ID","defaultValue":1010,"options":[{"value":1010,"label":"Starts with"},{"value":1011,"label":"Contains"},{"value":1012,"label":" Word Contains"}]},{"type":"serverSelect","name":"FILING_TYPE_ID","optionsSrc":"FILING_TYPES","label":"Entity Type","placeholder":"All","defaultValue":"0"},{"type":"serverSelect","name":"FILING_SUBTYPE_ID","optionsSrc":"FILING_SUBTYPES","label":"Entity Subtype","overrideSubOptionsSrcFromParameterName":"FILING_TYPE_ID","placeholder":"All","defaultValue":"0"},{"type":"serverSelect","name":"STATUS_ID","optionsSrc":"FILING_STATUS_WITHOUT_ALL","label":"Status","placeholder":"All","defaultValue":"0"},{"type":"serverSelect","name":"STATE","optionsSrc":"STATE","label":"State","placeholder":"All","defaultValue":""},{"type":"serverSelect","name":"COUNTY","optionsSrc":"COUNTY_SUBOPTION","label":"County","overrideSubOptionsSrcFromParameterName":"STATE","placeholder":"All","defaultValue":""},{"type":"checkbox","name":"CRA_SEARCH_YN","defaultValue":false,"label":"Search by Registered Agent PID"},{"type":"dateRange","name":"FILING_DATE","label":"Registration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}},{"type":"dateRange","name":"EXPIRATION_DATE","label":"Expiration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}}],"myRecordsFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Active"},{"value":2,"label":"Inactive"},{"value":3,"label":"Pending"}]},{"type":"dateRange","name":"DATE_RANGE","label":"Date range","defaultValue":{"start":null,"end":null}}],"myWorkQueueFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Approved"},{"value":2,"label":"Pending Online Payment"},{"value":3,"label":"Pending Review"},{"value":4,"label":"Needs Correction"},{"value":5,"label":"Rejected"},{"value":6,"label":"Draft"}]},{"type":"dateRange","name":"DATE_RANGE","label":"Date range","defaultValue":{"start":null,"end":null}}]},{"label":"Notary","component":"Notary","parameter":"notary","sourceTypeId":850,"myWorkQueueSearch":false,"allowEmptySearchTerm":true,"requestCertificateAlternateLabel":"Download Certificate","fileAmendmentButtonLabel":"Filing Actions","hideNameRequestCertificate":true,"hideAddressRequestCertificate":true,"hideRecordUserManagment":true,"searchPlaceholder":"Search by name or commission number","searchMustHaveOneOf":["CITY","search","SERVICE_TYPE"],"advancedParametersStartOpen":true,"searchIsSortable":true,"advancedSearchParameters":[{"type":"radio","name":"STARTS_WITH_YN","defaultValue":false,"options":[{"value":true,"label":"Starts with"},{"value":false,"label":"Contains"}]},{"type":"checkbox","name":"ACTIVE_ONLY_YN","defaultValue":true,"label":"Active entities only"},{"type":"text","name":"CITY","defaultValue":"","label":"City"},{"type":"select","name":"SERVICE_TYPE","label":"Special Services Offered","defaultValue":0,"options":[{"value":0,"label":"(N/A)"},{"value":6165,"label":"In-Person Electronic Notarization (IPEN)"},{"value":6166,"label":"Remote Online Notarization (RON)"},{"value":6167,"label":"Mobile Notary Services"},{"value":6168,"label":"Remote Ink Notarization (RIN)"}]}]},{"label":"Apostille","component":"Apostille","parameter":"apostille","sourceTypeId":720,"myRecordsSearch":false,"myWorkQueueSearch":false,"disabled":false,"allowedRoutes":["/forms-manager/","/queue/","/forms/"]},{"label":"Liens","component":"UCC","parameter":"ucc","sourceTypeId":1999,"myRecordsSearch":true,"myWorkQueueSearch":true,"fileAmendmentButtonLabel":"Filing Actions","searchPlaceholder":"Search by name or file number","disabled":false,"serverWebSearchDescription":true,"myRecordsDescription":"","workQueueDescription":"","searchDescription":"","hideRecordUserManagment":true,"searchLiensCheckout":false,"advancedSearchParameters":[{"type":"radio","name":"STARTS_WITH_YN","defaultValue":false,"options":[{"value":true,"label":"Starts with"},{"value":false,"label":"Contains"}]},{"type":"select","name":"STATUS","defaultValue":"ALL","label":"Status","options":[{"value":"ACTIVE_UNLAPSED","label":"Active (unlapsed)"},{"value":"ACTIVE_LAPSED_UNLAPSED","label":"Active (lapsed and unlapsed)"}]},{"type":"text","name":"EXCLUDE_VALUES","label":"Exclude Debtor Names (comma separated list of names to exclude)","defaultValue":""},{"type":"dateRange","name":"FILING_DATE","label":"Financing Statement Date","defaultValue":{"start":null,"end":null}},{"type":"dateRange","name":"LAPSE_DATE","label":"Lapse Date","defaultValue":{"start":null,"end":null}},{"type":"text","name":"CITY","label":"Debtor City","defaultValue":""}],"myRecordsFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Approved"},{"value":2,"label":"Pending Online Payment"},{"value":3,"label":"Pending Review"}]},{"type":"select","name":"TYPE","defaultValue":0,"label":"Lien Type","options":[{"value":0,"label":"All"},{"value":1,"label":"UCC"},{"value":2,"label":"EFS"},{"value":3,"label":"Title 71"}]}],"myWorkQueueFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Approved"},{"value":2,"label":"Pending Online Payment"},{"value":3,"label":"Pending Review"},{"value":4,"label":"Pending Print and Mail"},{"value":5,"label":"Rejected"},{"value":6,"label":"Draft"}]},{"type":"select","name":"TYPE","defaultValue":0,"label":"Lien Type","options":[{"value":0,"label":"All"},{"value":1,"label":"UCC"},{"value":2,"label":"EFS"},{"value":3,"label":"Title 71"}]}]},{"label":"Copy Request","component":"copies","parameter":"copies","sourceTypeId":2001,"myRecordsSearch":false,"myWorkQueueSearch":false,"disabled":false,"allowedRoutes":["/forms-manager/","/queue/","/forms/"]},{"label":"Trademark","component":"Trademark","parameter":"trademark","sourceTypeId":810,"showRequestCertificate":true,"searchMustHaveOneOf":["search","EXPIRATION_DATE","FILING_DATE"],"allowEmptySearchTerm":true,"requestCertificateAlternateLabel":"Request Information","fileAmendmentButtonLabel":"Filing Actions","advancedSearchParameters":[{"type":"radio","name":"QUERY_TYPE_ID","defaultValue":1010,"options":[{"value":1010,"label":"Starts with"},{"value":1011,"label":"Contains"},{"value":1012,"label":" Word Contains"}]},{"type":"checkbox","name":"OWNER_SEARCH_YN","defaultValue":false,"label":"Search owners"},{"type":"radio","name":"SERVICE_MARK_YN","label":"Mark Type","defaultValue":"","options":[{"value":"","label":"All Marks"},{"value":"Y","label":"Service Mark"},{"value":"N","label":"Trademark"}]},{"type":"serverSelect","name":"STATUS_ID","optionsSrc":"TYPE_V|TRADEMARK_STATUS_TYPE","label":"Status","placeholder":"All","defaultValue":"0"},{"type":"select","name":"DESIGN_TYPE_ID","options":[{"value":0,"label":"All"},{"value":990,"label":"Words Only"},{"value":991,"label":"Design Only"},{"value":992,"label":"Words and Design"}],"label":"Design Type","defaultValue":"0"},{"type":"dateRange","name":"FILING_DATE","label":"Registered Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}},{"type":"dateRange","name":"EXPIRATION_DATE","label":"Expiration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}}]},{"label":"Business Info Request","component":"InfoRequests","parameter":"info-request","sourceTypeId":167,"allowedRoutes":["/forms-manager/","/queue/","/forms/"]},{"label":"Data Requests","component":"DataRequests","parameter":"data-request","sourceTypeId":0,"allowedRoutes":["/forms-manager/"]},{"label":"CRA","component":"CRA","parameter":"cra","sourceTypeId":157,"myRecordsSearch":false,"searchPlaceholder":"Search by name or registered agent number","allowedRoutes":["/forms-manager/","/forms/","/records/","/queue/","/search/"],"allowEmptySearchTerm":true,"fileAmendmentButtonLabel":"Filing Actions","advancedSearchParameters":[{"type":"radio","name":"QUERY_TYPE_ID","defaultValue":1010,"options":[{"value":1010,"label":"Starts with"},{"value":1011,"label":"Contains"},{"value":1012,"label":" Word Contains"}]},{"type":"dateRange","name":"CRA_DATE","label":"Registration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}},{"type":"select","name":"STATUS_ID","label":"Status","defaultValue":0,"options":[{"value":0,"label":"All"},{"value":121,"label":"Active"},{"value":122,"label":"Inactive"}]},{"type":"select","name":"AGENT_TYPE_ID","label":"Agent Type","defaultValue":0,"options":[{"value":0,"label":"All"},{"value":460,"label":"Registered Agent"},{"value":461,"label":"Commercial Registered Agent"}]}]},{"label":"Farm Bill","component":"FarmBill","parameter":"farm-bill","path":"/lists/farm-bill","sourceTypeId":0,"myRecordsSearch":false,"allowedRules":["/search/"],"disabled":true,"searchDescription":"To perform a search, enter a debtor name. Your search results may include: exact debtor name, variations of that name and any filing that includes your search criteria. Punctuation is ignored.\n\nYou can click on \"Advanced\" to refine your search. Under “Advanced” you can search by crop, year, county and SSN/FEIN. As a registered Farm Bill Buyer with the Montana Secretary of State’s office it is important to maintain the confidentiality of the information contained within the Farm Bill Master List. The Farm Bill Master List reflects personal data, such as Social Security Numbers, which are a key piece of personal identifiable information to assist you in determining the existence of a lien against a specific debtor. The distribution of this information beyond its intended purpose is strictly prohibited.\n\nThe debtor's tax identification number has been hidden for confidentiality reasons. You may continue to search on a tax ID number and return debtors that match your search criteria. The SSN/FEIN must be entered without dashes or spaces.","searchMustHaveOneOf":["search","UCC_FARM_PRODUCT_ID","COUNTY"],"searchPlaceholder":"Search by debtor name","advancedSearchParameters":[{"type":"ServerMultiComplete","label":"Product code name(s)","name":"UCC_FARM_PRODUCT_ID","defaultValue":"","optionsSrc":"UCC_FARM_PRODUCT_V"},{"type":"MultiComplete","label":"Year or Range of Years","name":"YEAR_NUM","optionsSrc":"years","startYear":"1968","defaultValue":[],"preMergeOptions":[{"value":"ALL","label":"All"}]},{"type":"serverSelect","label":"State","name":"STATE","defaultValue":"MONTANA","optionsSrc":"STATE"},{"type":"ServerMultiComplete","label":"County","name":"COUNTY","defaultValue":[],"optionsSrc":"COUNTY","overrideSubOptionsSrcFromParameterName":"STATE"},{"type":"checkbox","name":"TIN_SEARCH_YN","defaultValue":false,"label":"Tax Identification Number Search"},{"type":"checkbox","name":"TIN_SORT_YN","defaultValue":false,"label":"Unique ID Sort"}]}],"SYSTEM_NICKNAME":"Online Services Portal","PAYMENT_METHODS":[{"type":"bypass"},{"type":"iTransact"}],"PAYMENT_ALLOW_AMEX":true,"SYSTEM_ID_LABEL":"System Id","DOUBLE_COLUMN_PUBLIC_LOGIN":true,"INTERNAL_USER_MANAGEMENT":true,"ALLOW_PUBLIC_JSON_IMPORT":false,"MAX_FILE_UPLOAD_SIZE":10000000,"REFUND_TEXT":"","RETURN_TO_HOME_ON_LOGOUT":true,"CURRENT_SOS_NAME":"Christi Jacobsen","LOGO_FILENAME":"mt-sos-logo.png","LOGO_ALT":"Christi Jacobsen, Montana Secretary of State","LOGO_FULL_WIDTH":true,"HOME_HIDE_AUTH_HINT":true,"HOME_TITLE":"Montana Secretary of State","CUSTOM_TAB_TITLE":"Official Montana","HOME_SUBTITLE":"Online Business Services","ENTITY_NAME_CONSENT_DESCRIPTION":"","ALLOW_USER_PROFILE_EDITING":true,"COMPARE_FOREIGN_NAME_IN_ENTITY_NAME_VALIDATION":true,"FOREIGN_NAME_FIELD_NAME":"KIMA_PARENT_NAME_INFO","LOGIN_TITLE":"Montana Secretary of State Online Filing Portal Login","PUBLIC_LOGIN_LABEL":"Username","REVERSE_LOGIN_COLUMNS":true,"LOGIN_SEAL_FILENAME":"seal_white.png","SEPARATE_USERNAME_AND_EMAIL":true,"CREATE_ACCOUNT_BUTTON_ALIGN_LEFT":true,"CREATE_ACCOUNT_BUTTON_TEXT":"CREATE AN ACCOUNT","PASSWORD_CUSTOM_ERROR_TEXT":"The password must meet all requirements","ACCOUNT_CREATED_MESSAGE":"Please check your email to verify your account to login and allow a few minutes for this message to arrive. Check your junk/spam folders if you do not find the email in your inbox.","PUBLIC_LOGIN_PLACEHOLDER":" ","DISABLE_DEFAULT_PAYMENT_RADIO":true,"CUSTOM_RESET_PASSWORD_ERROR_MESSAGE":"Username invalid - no account found","PUBLIC_LOGIN_CREATE_DESCRIPTION":"### Existing User:\n\n  - Enter your username and password to login.  \n\n\n  #### - OR -  \n\n\n\n  - Forgot password? Click 'Reset Password' and follow the prompts.\n  - Forgot username? Click 'Forgot Username' and follow the prompts.  \n\n\n  ### New User:\n  ","LOGIN_HELP_LINK":"https://sosmt.gov/business/how-do-i/","LOGIN_HELP_LINK_TEXT":"Need Help?","FORGOT_USERNAME_TEXT":"Forgot Username?","LOGIN_ACTIVE_DIRECTORY_TEXT":"State User Login","MULTIPLE_LOGIN_METHODS":true,"HAS_ACTIVE_DIRECTORY_LOGIN":true,"RESET_PASSWORD_WITH_USERNAME":true,"DOWNLOAD_LINK":true,"SHOW_USERNAME_ACCOUNT_CREATE":true,"SHOW_SCROLL_DOWN_ARROW":true,"SHOW_ADDRESS_ACCOUNT_CREATE":true,"TWO_COLUMN_ACCOUNT_CREATE":true,"RESET_PASSWORD_TIP":"A link to change your password has been sent to your email. Please allow a few minutes for this message to arrive. Please check your junk/spam folders if you do not find the email in your inbox.","FORGOT_PASSWORD_LINK_TEXT":"Reset Password","PHONE_NUMBER_OPTIONAL_ACCOUNT_CREATE":true,"SHOW_REQUIRED_INDICATOR_ACCOUNT_CREATE":true,"PASSWORD_REQUIREMENTS_ACCOUNT_CREATE":"\n    <ul>\n      <li>MUST contain at least 8 characters (12+ recommended)</li>\n      <li>MUST contain at least one uppercase letter.</li>\n      <li>MUST contain at least one lowercase letter.</li>\n      <li>MUST contain at least one number.</li>\n      <li>MUST contain at least one special character (!”#$%&'()*+,-./:;<=>?</li>\n    </ul>\n  ","ALLOW_CERTIFICATION_REQUEST":true,"ALLOW_PUBLIC_CERTIFICATE_REQUEST":true,"ALLOW_COPY_REQUEST":false,"ALLOW_CORRECTION_STYLING":true,"HIDE_DEPRECATION_WARNING":false,"AMEND_ROUTE_PUBLIC":true,"SEAL_FILENAME":"seal.png","SHOPPING_CART":true,"ALLOW_PAYMENT_UPDATE_WITH_EMPTY_CART":true,"RA_EMAIL":true,"RA_WEBSITE":true,"RA_NO_DEFAULT_TYPE":true,"RA_ADDRESS_LABEL":"Street Address","RA_TYPE_SELECTION_DEFAULT":true,"RA_DEFAULT_TYPE":"460","RA_OVERRIDE_TYPE_WITH_DEFAULT":true,"RA_PRINCIPAL_ADDRESS_AMS":true,"UPLOAD_AND_SUBMIT_HIDE_IF_ONE_OPTION":true,"PAYMENT_PROCESSING_MESSAGE":"Your payment is processing - Do not close your browser or click the back button","CHECKOUT_BUTTON_WHEN_PROCESSING_TEXT":"Processing","EFS_CROP_PICKER_NONE_LABEL":"Lien Duration","DISALLOWED_WIZARD_PIECES":["FormationLocale"],"REPEATER_SHOW_EDIT_BUTTON":true,"DATA_REQUEST_PAGE_TITLE":"Data Requests and Subscriptions","DATA_REQUEST_SIDEBAR_LABEL":"Data Requests & Subscriptions","LOGIN_REDIRECTS_TO_EPASS":false,"LOGIN_REDIRECTS_TO_ACTIVE_DIRECTORY":true,"LOGIN_ACTIVE_DIRECTORY_LINK":true,"FETCH_EDIT_USER_LINK":false,"LISTS_FETCH_AVAILABLE_LISTS":true,"POST_WIZARD_SUBMIT_REDIRECT_URL":"/","PIN_REQUEST_ATTESTATIONS":true,"PIN_REQUEST_DESCRIPTION":"Click **Request PIN** to have a new PIN sent to the account holder's email address on file.","OWNERSHIP_REQUEST_DESCRIPTION":"To become an **authorized user** of this record, a current **AUTHORIZED USER** will need to grant you access. To request access, click **Request Access** below.","PIN_REQUEST_SUCCESS_MESSAGE":"The PIN you have requested for this entity has been sent to the email associated with your user account.  You should receive the PIN in approximately 3-5 minutes, depending on your email service provider.","APOSTILLE_HEADER_LABEL":"Verification Information","APOSTILLE_NUMBER_LABEL":"Apostille/Authentication","APOSTILLE_CITY_STATE_OVERRIDE":"HELENA, MT","APOSTILLE_FILING_DATE_LABEL":"Issue Date","APOSTILLE_CITY_STATE_IN_CERTIFIED":true,"NOTARY_EXISTING_FILING":true,"ALLOW_REVOKE_OWN_ACCESS_ONLY":false,"HIDE_CANCEL_ON_ONETIME_DATA_REQUESTS":true,"DATA_REQUESTS_IN_SHOPPING_CART":true,"WQ_ALLOW_EDIT_PENDING_PAYMENT":true,"WQ_CONFIRM_ON_DELETE":true,"WQ_DELETE_CONFIRM_MESSAGE":"Deleting this filing will forfeit any money already paid to the Secretary of State. This action is permanent and cannot be undone, are you sure you would like to delete?","PASS_ITEM_GUIDS_ON_CHECKOUT":true,"FORM_REVISION_HISTORY":true,"CHECKOUT_DISCLAIMER":"By entering your credit card and/or checking account information you (i) state that **you are an authorized user** of the credit card and/or electronic check and that the associated information entered (e.g., account holder name, account number, billing address) is accurate, (ii) **you authorize payment processor to charge the amount you have requested** to your credit card and/or funding account, and (iii) **acknowledge if a charge is declined or reversed you may also be assessed a customary charge** by the payment processor for such transactions.","FARM_BILL_SEARCH_CONFIDENTIAL":"As a registered Farm Bill Buyer with the Montana Secretary of State’s office it is important to maintain the confidentiality of the information contained within the Farm Bill Master List. The Farm Bill Master List reflects personal data, such as Social Security Numbers, which are a key piece of personal identifiable information to assist you in determining the existence of a lien against a specific debtor. The distribution of this information beyond its intended purpose is strictly prohibited.\n\n**The debtor's tax identification number has been hidden for confidentiality reasons. You may continue to search on a tax ID number and return debtors that match your search criteria. The SSN/FEIN must be entered without dashes or spaces.  If you need access to the tax identification number to clearly identify the debtor, please contact the UCC unit at (406) 444-3665.**","VIEW_HISTORY_BUTTON_ALT_TEXT":"View Filings","WIZARD_ERROR_TITLE_MESSAGE":"Form Error","FARM_BILL_SEARCH_INTERACTIVE":true,"USE_FARM_BILL_API":true,"DISALLOW_ASSIGN_SELF_AS_RA":true,"DISALLOW_ASSIGN_SELF_AS_PRINCIPAL":true,"USE_TRADEMARK_OWNER_VALIDATION":true,"USE_ALTERNATIVE_FOREIGN_ADDRESS_LABELS":true,"MY_RECEIPTS_FILTER":[{"type":"dateRange","name":"DATE_RANGE","label":"Date range","defaultValue":{"start":null,"end":null}},{"type":"text","name":"REF_NUM","defaultValue":"","label":"Reference Number"},{"type":"text","name":"RECEIPT_NUM","defaultValue":"","label":"Receipt Id"},{"type":"text","name":"AMOUNT","defaultValue":"","label":"Amount"},{"type":"select","name":"TYPE","defaultValue":"","label":"Payment Type","options":[{"value":"","label":"All"},{"value":"CC","label":"Credit Card"},{"value":"Check","label":"Check"}]}],"MY_RECEIPTS_SHOW_IN_SIDEBAR":true,"SHOW_MY_RECEIPTS_HELPER_TEXT":true,"MY_RECEIPTS_HELPER_LABEL":"About Receipt Search","MY_RECEIPTS_HELPER_TEXT":"You can search for receipts based on their descriptions, including the items paid for on the receipt. Use the filters to search for or filter specific information.","FARM_BILL_SUBLINK":{"label":"Farm Bill","component":"FarmBill","parameter":"farm-bill","path":"/lists/farm-bill","sourceTypeId":0,"myRecordsSearch":false,"allowedRules":["/search/"],"disabled":true,"searchDescription":"To perform a search, enter a debtor name. Your search results may include: exact debtor name, variations of that name and any filing that includes your search criteria. Punctuation is ignored.\n\nYou can click on \"Advanced\" to refine your search. Under “Advanced” you can search by crop, year, county and SSN/FEIN. As a registered Farm Bill Buyer with the Montana Secretary of State’s office it is important to maintain the confidentiality of the information contained within the Farm Bill Master List. The Farm Bill Master List reflects personal data, such as Social Security Numbers, which are a key piece of personal identifiable information to assist you in determining the existence of a lien against a specific debtor. The distribution of this information beyond its intended purpose is strictly prohibited.\n\nThe debtor's tax identification number has been hidden for confidentiality reasons. You may continue to search on a tax ID number and return debtors that match your search criteria. The SSN/FEIN must be entered without dashes or spaces.","searchMustHaveOneOf":["search","UCC_FARM_PRODUCT_ID","COUNTY"],"searchPlaceholder":"Search by debtor name","advancedSearchParameters":[{"type":"ServerMultiComplete","label":"Product code name(s)","name":"UCC_FARM_PRODUCT_ID","defaultValue":"","optionsSrc":"UCC_FARM_PRODUCT_V"},{"type":"MultiComplete","label":"Year or Range of Years","name":"YEAR_NUM","optionsSrc":"years","startYear":"1968","defaultValue":[],"preMergeOptions":[{"value":"ALL","label":"All"}]},{"type":"serverSelect","label":"State","name":"STATE","defaultValue":"MONTANA","optionsSrc":"STATE"},{"type":"ServerMultiComplete","label":"County","name":"COUNTY","defaultValue":[],"optionsSrc":"COUNTY","overrideSubOptionsSrcFromParameterName":"STATE"},{"type":"checkbox","name":"TIN_SEARCH_YN","defaultValue":false,"label":"Tax Identification Number Search"},{"type":"checkbox","name":"TIN_SORT_YN","defaultValue":false,"label":"Unique ID Sort"}]},"ALLOW_ADDRESS_VALIDATION_BYPASS_OPTION":true,"DEFAULT_ADDRESS_VALIDATION_BYPASS_OPTION_CHECKED":true}).SEARCH_IS_SORTABLE,
	              sortBy: sortBy,
	              sortByDirection: sortByDirection,
	              searchMustHaveOneOf: sublink.searchMustHaveOneOf,
	              longDescriptionSearchPage: sublink.longDescriptionSearchPage,
	              minimumSearchCharacters: sublink.minimumSearchCharacters,
	              advancedParametersStartOpen: sublink.advancedParametersStartOpen,
	              isStale: isStale,
	              getSearchTrigger: function getSearchTrigger(trigger) {
	                if (_getSearchTrigger) _getSearchTrigger(trigger);
	                _this3.searchTrigger = trigger;
	              },
	              history: this.props.history
	            }),
	            this.renderResults(this.props, sublink)
	          ),
	          _react2.default.createElement(_RecordDrawer2.default, {
	            show: selectedId,
	            title: selectedTitle,
	            subtitle: selectedSubtitle,
	            category: category,
	            sourceId: selectedResult && selectedResult.ID,
	            recordNum: selectedResult && selectedResult.RECORD_NUM,
	            canFileAR: selectedResult && selectedResult.CAN_FILE_AR,
	            canAlwaysFileAR: selectedResult && selectedResult.CAN_ALWAYS_FILE_AR,
	            canReinstate: selectedResult && selectedResult.CAN_REINSTATE,
	            canFileReinstatement: selectedResult && selectedResult.CAN_FILE_REINSTATEMENT,
	            sublink: sublink,
	            onSidebarDismiss: this.onSidebarDismiss,
	            uccFilingID: selectedResult && selectedResult.UCC_FILING_ID,
	            uccDebtorID: selectedResult && selectedResult.UCC_DEBTOR_ID,
	            uccSecuredPartyID: selectedResult && selectedResult.UCC_SECURED_PARTY_ID,
	            uccEfsProductID: selectedResult && selectedResult.UCC_EFS_PRODUCT_ID
	          }),
	          _react2.default.createElement(
	            _Portal2.default,
	            { isOpened: this.state.checkoutOpen },
	            _react2.default.createElement(
	              _SlidingPanel2.default,
	              {
	                closeOnShadeClick: false,
	                closeSlider: this.closeCheckout,
	                ref: function ref(_ref2) {
	                  _this3.slider = _ref2;
	                }
	              },
	              _react2.default.createElement(_Checkout2.default, {
	                cancelCheckout: this.cancelCheckout,
	                closeModal: this.closeCheckout,
	                redirectToReceipt: this.openReceipt,
	                amendmentNum: this.state.checkoutOpen && this.state.webcart.amendmentNum,
	                refNum: this.state.checkoutOpen && this.state.webcart.refNum,
	                formDefinitionId: this.state.checkoutOpen && this.state.webcart.formDefinitionId,
	                category: this.props.match.params.category,
	                receiptItems: this.state.checkoutOpen && this.state.webcart.receiptItems,
	                receiptItemContainers: this.state.checkoutOpen && this.state.webcart.receiptItemContainers
	              })
	            )
	          )
	        );
	      }
	    }
	  }]);
	
	  return Search;
	}(_react.Component);
	
	exports.default = (0, _reactRedux.connect)(function (state, props) {
	  return {
	    results: props.match.params.subParam && state.search.results ? state.search.results[props.match.params.subParam] ? state.search.results[props.match.params.subParam] : {} : {},
	    orderedResults: props.match.params.subParam && state.search.results && state.search.results[props.match.params.subParam] ? (0, _utilities.getOrderedResultsByCategory)(props.match.params.subParam, state.search.results, state.search.templates) : [],
	    edge: (props.match.params.subParam && state.search.results ? state.search.edges[props.match.params.subParam] : {}) || {},
	    serverDescription: props.match.params.subParam && state.search.descriptions[props.match.params.subParam] || '',
	    searching: state.search.searching,
	    selectedId: props.match.params.subParam ? state.search.selected[props.match.params.subParam] : null,
	    resultsMode: state.search.resultsMode,
	    isMobile: state.app.isMobile,
	    activeCategory: state.search.activeCategory || state.app.currentCategory,
	    sortBy: props.sortBy ? props.sortBy : (state.search.sorts[props.match.params.subParam] || {}).sortBy,
	    sortByDirection: props.sortByDirection ? props.sortByDirection : (state.search.sorts[props.match.params.subParam] || {}).sortByDirection,
	    currentSearchTerm: props.match.params.subParam && state.search.searchValueCache ? state.search.searchValueCache[props.match.params.subParam] : '',
	    searchError: state.search.searchError[props.match.params.subParam],
	    isStale: state.search.stales[props.match.params.subParam] || false
	  };
	}, {
	  setResults: _SearchActions.setResults,
	  selectRow: _SearchActions.selectRow,
	  setResultsMode: _SearchActions.setResultsMode,
	  setActiveCategory: _SearchActions.setActiveCategory,
	  setSort: _SearchActions.setSort,
	  getSearchDescription: _SearchActions.getSearchDescription,
	  clearSearchError: _SearchActions.clearSearchError
	})(Search);
	
	var ConnectedSearchBox = exports.ConnectedSearchBox = function (_Component2) {
	  _inherits(ConnectedSearchBox, _Component2);
	
	  function ConnectedSearchBox() {
	    var _ref3;
	
	    var _temp, _this4, _ret;
	
	    _classCallCheck(this, ConnectedSearchBox);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this4 = _possibleConstructorReturn(this, (_ref3 = ConnectedSearchBox.__proto__ || Object.getPrototypeOf(ConnectedSearchBox)).call.apply(_ref3, [this].concat(args))), _this4), _this4.printWindow = null, _this4.resultsCache = null, _this4.componentDidMount = function () {
	      if (!_this4.props.prefilledSearch) {
	        _this4.setSearchValue(_this4.props.searchValueCache[_this4.props.category]);
	      }
	    }, _this4.componentWillReceiveProps = function (nextProps) {
	      if (_this4.props.category !== nextProps.category) {
	        _this4.setSearchValue(_this4.props.searchValueCache[nextProps.category]);
	      }
	    }, _this4.setSearchValue = function (value) {
	      _this4.searchBox.setValue(value);
	    }, _this4.componentWillUnmount = function () {
	      delete window.onPrintPageReady;
	    }, _this4.renderPrintPage = function (results) {
	      window.onPrintPageReady = _this4.sendResultsToPrintPage;
	      _this4.resultsCache = results;
	      _this4.printWindow = window.open('/print-results', 'Print Results');
	    }, _this4.sendResultsToPrintPage = function () {
	      _this4.printWindow.setPrintResults(_this4.resultsCache);
	    }, _this4.triggerSearch = function (event, searchProps) {
	      return _this4.searchBox.search(event, searchProps);
	    }, _this4.getSearchRequirementsFulfilled = function (search, parameters) {
	      if (_this4.props.searchRequirementsAreSatisfied) {
	        return _this4.props.searchRequirementsAreSatisfied(search, parameters);
	      }
	      var searchMustHaveOneOf = _this4.props.searchMustHaveOneOf;
	
	      var parametersConfig = _this4.props.advancedParameters.reduce(function (obj, param) {
	        obj[param.name] = param;
	        return obj;
	      }, {});
	      if (searchMustHaveOneOf.includes('search')) {
	        if (search !== '') {
	          return true;
	        }
	      }
	      return searchMustHaveOneOf.filter(function (key) {
	        return key !== 'search';
	      }).some(function (key) {
	        var param = parameters[key];
	        var config = parametersConfig[key];
	        switch (config.type) {
	          case 'dateRange':
	            return param.start || param.end;
	          default:
	            switch (typeof param === 'undefined' ? 'undefined' : _typeof(param)) {
	              case 'string':
	                return param !== '' && param !== '0';
	              case 'object':
	                if (Array.isArray(param)) {
	                  return param.length > 0;
	                }
	                return true;
	              default:
	                return true;
	            }
	        }
	      });
	    }, _this4.search = function (value, parameters) {
	      var meetsMinimumSearchChars = _this4.props.minimumSearchCharacters ? value.trim().length >= _this4.props.minimumSearchCharacters : true;
	
	      var meetsSearchMustHaveOneOf = _this4.props.searchMustHaveOneOf !== undefined ? _this4.getSearchRequirementsFulfilled(value, parameters) : true;
	
	      var validSearch = (value || _this4.props.allowEmptySearchTerm) && (meetsMinimumSearchChars || _this4.props.allowEmptySearchTerm) && meetsSearchMustHaveOneOf;
	
	      if (_this4.props.searchRequirementsAreSatisfied ? _this4.props.searchRequirementsAreSatisfied(value, parameters) : validSearch) {
	        _this4.props.toggleSearching(true);
	        _this4.props.setSearchError(null);
	
	        var sortingParameters = _this4.props.sortable && _this4.props.sortBy ? { SORT_BY_ID: _this4.props.sortBy, SORT_BY_DIRECTION: _this4.props.sortByDirection } : {};
	        (0, _requests.SEARCH)(Object.assign({ SEARCH_VALUE: value }, parameters, sortingParameters), _this4.props.category, function (results) {
	          _this4.props.clearSearchError(_this4.props.category);
	          _this4.props.toggleSearching(false);
	          if (parameters.PRINT) {
	            _this4.renderPrintPage(results);
	          } else {
	            _this4.props.onResultsReceived(results, value);
	          }
	        }, function () {
	          var err = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	          console.error(err);
	          _this4.props.setSearchError({
	            title: err.title,
	            message: err.message
	          }, _this4.props.category);
	          _this4.props.toggleSearching(false);
	        });
	      } else {
	        console.error('Invalid Search');
	      }
	    }, _temp), _possibleConstructorReturn(_this4, _ret);
	  }
	
	  _createClass(ConnectedSearchBox, [{
	    key: 'render',
	    value: function render() {
	      var _this5 = this;
	
	      var _props2 = this.props,
	          getSearchTrigger = _props2.getSearchTrigger,
	          allowEmptySearchTerm = _props2.allowEmptySearchTerm,
	          advancedParametersStartOpen = _props2.advancedParametersStartOpen,
	          isStale = _props2.isStale;
	
	
	      if (getSearchTrigger) {
	        getSearchTrigger(this.triggerSearch);
	      }
	      return _react2.default.createElement(SearchBox, {
	        ref: function ref(_ref4) {
	          _this5.searchBox = _ref4;
	        },
	        category: this.props.category,
	        title: this.props.title,
	        placeholder: this.props.placeholder,
	        search: this.search,
	        searching: this.props.searching,
	        advancedParameters: this.props.advancedParameters,
	        description: this.props.description,
	        limitDescription: this.props.limitDescription,
	        showSearchLiensCheckout: this.props.showSearchLiensCheckout,
	        allowSearchPrint: this.props.allowSearchPrint,
	        hasResults: this.props.hasResults,
	        onPurchaseRequested: this.props.onPurchaseRequested,
	        loggedIn: this.props.loggedIn,
	        allowEmptySearchTerm: allowEmptySearchTerm,
	        advancedParametersStartOpen: advancedParametersStartOpen,
	        searchRequirementsAreSatisfied: this.props.searchRequirementsAreSatisfied,
	        minimumSearchCharacters: this.props.minimumSearchCharacters,
	        isStale: isStale,
	        defaultValue: this.props.prefilledSearch,
	        key: this.props.category,
	        searchMustHaveOneOf: this.props.searchMustHaveOneOf,
	        longDescriptionSearchPage: this.props.longDescriptionSearchPage
	      });
	    }
	  }]);
	
	  return ConnectedSearchBox;
	}(_react.Component);
	
	exports.ConnectedSearchBox = ConnectedSearchBox = (0, _reactRedux.connect)(function (state) {
	  return {
	    searching: state.search.searching,
	    searchValueCache: state.search.searchValueCache,
	    loggedIn: state.auth.loggedIn,
	    location: state.router.location,
	    prefilledSearch: (0, _utilities.parseUrlQuery)(state.router.location.search).prefill
	  };
	}, { toggleSearching: _SearchActions.toggleSearching, setSearchError: _SearchActions.setSearchError, clearSearchError: _SearchActions.clearSearchError })(ConnectedSearchBox);
	
	var SearchBox = exports.SearchBox = function (_Component3) {
	  _inherits(SearchBox, _Component3);
	
	  function SearchBox() {
	    var _ref5;
	
	    var _temp2, _this6, _ret2;
	
	    _classCallCheck(this, SearchBox);
	
	    for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
	      args[_key2] = arguments[_key2];
	    }
	
	    return _ret2 = (_temp2 = (_this6 = _possibleConstructorReturn(this, (_ref5 = SearchBox.__proto__ || Object.getPrototypeOf(SearchBox)).call.apply(_ref5, [this].concat(args))), _this6), _this6.getDefaultValues = function (parameters) {
	      return parameters.reduce(function (obj, param) {
	        return Object.assign({}, obj, _defineProperty({}, param.name, param.defaultValue));
	      }, {});
	    }, _this6.state = {
	      drawerIsOpen: _this6.props.advancedParametersStartOpen ? true : false,
	      hasValue: false,
	      inputValue: '',
	      advancedParameterValues: _this6.getDefaultValues(_this6.props.advancedParameters)
	    }, _this6.componentDidMount = function () {
	      _this6.input.focus();
	      _this6.checkForStaleSearch(_this6.props);
	    }, _this6.componentDidUpdate = function () {
	      _this6.checkForStaleSearch(_this6.props);
	    }, _this6.checkForStaleSearch = function (props) {
	      if (props.isStale) {
	        _this6.search();
	      }
	    }, _this6.selectSearch = function () {
	      _this6.input.select();
	    }, _this6.setValue = function (value) {
	      _this6.input.value = value;
	      _this6.setState({ hasValue: !!value.length });
	    }, _this6.search = function (event) {
	      var _ref6 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
	          offset = _ref6.offset,
	          print = _ref6.print;
	
	      if (!event) return;
	
	      event.preventDefault();
	
	      if (!_this6.props.searching) {
	        var parameters = {};
	        if (_this6.parameters) {
	          parameters = _this6.state.advancedParameterValues;
	        }
	        parameters.OFFSET = offset;
	        parameters.PRINT = print;
	        _this6.props.search(_this6.input.value || '', parameters);
	      }
	    }, _this6.trimValue = function (e) {
	      if (e.target.value.length >= 50) {
	        _this6.input.value = e.target.value.slice(0, 49);
	      }
	      _this6.setState({ hasValue: !!e.target.value.length, inputValue: e.target.value });
	    }, _this6.clearFilters = function () {
	      _this6.setState({ advancedParameterValues: _this6.getDefaultValues(_this6.props.advancedParameters) });
	    }, _this6.setAdvanceParameterValues = function (values) {
	      return _this6.setState({ advancedParameterValues: values });
	    }, _temp2), _possibleConstructorReturn(_this6, _ret2);
	  }
	
	  _createClass(SearchBox, [{
	    key: 'render',
	    value: function render() {
	      var _this7 = this;
	
	      var _props3 = this.props,
	          _props3$title = _props3.title,
	          title = _props3$title === undefined ? 'Search' : _props3$title,
	          placeholder = _props3.placeholder,
	          searching = _props3.searching,
	          category = _props3.category,
	          advancedParameters = _props3.advancedParameters,
	          description = _props3.description,
	          limitDescription = _props3.limitDescription,
	          showSearchLiensCheckout = _props3.showSearchLiensCheckout,
	          allowSearchPrint = _props3.allowSearchPrint,
	          hasResults = _props3.hasResults,
	          onPurchaseRequested = _props3.onPurchaseRequested,
	          allowEmptySearchTerm = _props3.allowEmptySearchTerm,
	          advancedParametersStartOpen = _props3.advancedParametersStartOpen,
	          minimumSearchCharacters = _props3.minimumSearchCharacters,
	          searchRequirementsAreSatisfied = _props3.searchRequirementsAreSatisfied,
	          loggedIn = _props3.loggedIn,
	          defaultValue = _props3.defaultValue,
	          searchMustHaveOneOf = _props3.searchMustHaveOneOf,
	          longDescriptionSearchPage = _props3.longDescriptionSearchPage;
	
	      // Boolean to determine whether the main search can be overriden by certain fields and if they have values with more characters than the minimumSearchCharacters state config
	      // const searchOverrideSatisfied = !allowEmptySearchTerm ? false : searchMustHaveOneOf.some(param =>(
	      //     typeof this.state.advancedParameterValues[param] == 'object' ? Object.values(this.state.advancedParameterValues[param]).some(value => value !== '') : (this.state.advancedParameterValues[param] && this.state.advancedParameterValues[param].value !== (advancedParameters.find(advParam => advParam.name === param).defaultValue || !this.state.advancedParameterValues[param]) )
	      //   )
	      // )
	
	      var searchOverrideSatisfied = this.state.advancedParameterValues.SEARCH_TYPE_ID !== '2' || !allowEmptySearchTerm ? false : searchMustHaveOneOf.some(function (param) {
	        var advParam = advancedParameters.find(function (advParam) {
	          return advParam.name === param;
	        });
	        var paramValue = _this7.state.advancedParameterValues[param];
	        var valuesEqual = (typeof paramValue === 'undefined' ? 'undefined' : _typeof(paramValue)) === 'object' ? JSON.stringify(advParam.defaultValue) === JSON.stringify(paramValue) : advParam && advParam.defaultValue === _this7.state.advancedParameterValues[param];
	        // console.log('param: ' + param + '\n',
	        //             'value: ' + this.state.advancedParameterValues[param] + '\n',
	        //             'advParam.defaultValue: ' + (advParam && advParam.defaultValue) + '\n',
	        //             'valuesEqual: ' + valuesEqual)
	        //return typeof this.state.advancedParameterValues[param] == 'object' ? Object.values(this.state.advancedParameterValues[param]).some(value => value !== '') : (this.state.advancedParameterValues[param] && this.state.advancedParameterValues[param].value !== (advParam.defaultValue || '' || null) )
	        return !valuesEqual;
	      });
	
	      // console.log('searchOverrideSatisfied: ' + searchOverrideSatisfied)
	
	      var mainSearchDisabled = searchRequirementsAreSatisfied ? !searchRequirementsAreSatisfied(this.state.inputValue, this.state.advancedParameterValues) : (minimumSearchCharacters ? this.state.inputValue.trim().length < minimumSearchCharacters : false) || (allowEmptySearchTerm ? false : !this.state.hasValue);
	
	      var searchDisabled = this.state.advancedParameterValues.SEARCH_TYPE_ID === '2' ? mainSearchDisabled && !searchOverrideSatisfied : mainSearchDisabled;
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'search-box ' + (longDescriptionSearchPage ? 'long-descr' : '') },
	        _react2.default.createElement(
	          'h1',
	          null,
	          title,
	          showSearchLiensCheckout && loggedIn && _react2.default.createElement(
	            'button',
	            {
	              className: 'btn btn-primary btn-raised align-right',
	              onClick: function onClick() {
	                return onPurchaseRequested(_this7.input.value, _this7.state.advancedParameterValues);
	              },
	              disabled: !hasResults
	            },
	            'Purchase Search'
	          ),
	          allowSearchPrint ? _react2.default.createElement(
	            'button',
	            {
	              className: 'btn btn-primary btn-raised align-right print-button',
	              onClick: function onClick(e) {
	                return _this7.search(e, { offset: 0, print: true });
	              },
	              disabled: !hasResults
	            },
	            _react2.default.createElement(_printSolid2.default, null),
	            ' Print'
	          ) : null
	        ),
	        description && _react2.default.createElement(_Markdown2.default, { source: description, className: 'markdown description' }),
	        limitDescription && _react2.default.createElement(_Markdown2.default, { source: limitDescription, className: 'limit-Description' }),
	        _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement('br', null)
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'search-input-wrapper' },
	          _react2.default.createElement(
	            'div',
	            { className: 'inner-input-wrapper' },
	            _react2.default.createElement(
	              'form',
	              { onSubmit: this.search },
	              _react2.default.createElement('input', {
	                ref: function ref(_ref7) {
	                  _this7.input = _ref7;
	                },
	                type: 'text',
	                onFocus: this.selectSearch,
	                onChange: this.trimValue,
	                placeholder: placeholder,
	                className: 'search-input',
	                disabled: searching,
	                'aria-label': placeholder,
	                defaultValue: defaultValue
	              })
	            )
	          ),
	          !searching ? _react2.default.createElement(
	            _react2.default.Fragment,
	            null,
	            _react2.default.createElement(
	              'button',
	              {
	                className: 'search-button ' + (this.state.drawerIsOpen ? 'hide' : ''),
	                onClick: !searchDisabled ? this.search : undefined,
	                'aria-label': 'Execute search',
	                'aria-disabled': searchDisabled,
	                'aria-hidden': this.state.drawerIsOpen,
	                tabIndex: this.state.drawerIsOpen ? -1 : undefined,
	                'aria-busy': searching,
	                'aria-invalid': searchDisabled,
	                'aria-describedby': 'search-disabled-hint'
	              },
	              _react2.default.createElement('span', { className: 'icon icon-zoom-medium' })
	            ),
	            _react2.default.createElement(
	              'p',
	              { id: 'search-disabled-hint', 'aria-live': 'polite' },
	              searchDisabled ? _react2.default.createElement(
	                'span',
	                { className: ' visually-hidden' },
	                'Please provide valid search criteria to perform a search.'
	              ) : null
	            )
	          ) : _react2.default.createElement(_Loaders.Spinner, { className: 'search-loader', themeColor: 'medium-neutral', linear: true, size: 'medium' }),
	          advancedParameters && _react2.default.createElement(_AdvancedParameters2.default, {
	            key: category,
	            ref: function ref(_ref8) {
	              _this7.parameters = _ref8;
	            },
	            parameters: advancedParameters,
	            values: this.state.advancedParameterValues,
	            open: this.state.drawerIsOpen,
	            onSearchRequested: !searchDisabled ? this.search : undefined,
	            onRequestToggleDrawer: function onRequestToggleDrawer(open, callback) {
	              _this7.setState(function (state) {
	                return { drawerIsOpen: open !== undefined ? open : !state.drawerIsOpen };
	              }, function () {
	                if (!_this7.state.drawerIsOpen) {
	                  _this7.input.focus();
	                }
	                if (callback) {
	                  callback(_this7.state.drawerIsOpen);
	                }
	              });
	            },
	            clearFilters: this.clearFilters,
	            onChange: this.setAdvanceParameterValues,
	            startOpen: advancedParametersStartOpen,
	            searchDisabled: searchDisabled,
	            searching: searching
	          })
	        )
	      );
	    }
	  }]);
	
	  return SearchBox;
	}(_react.Component);

/***/ },
/* 469 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.invalidateAllCategoryCaches = exports.setActiveCategory = exports.setSort = exports.getSearchDescription = exports.clearSearchError = exports.setSearchError = exports.toggleSearching = exports.setResultsMode = exports.selectRow = exports.setResults = undefined;
	
	var _requests = __webpack_require__(6);
	
	var setResults = exports.setResults = function setResults(results, category, searchValue) {
		return {
			type: '@@SEARCH_SET_RESULTS',
			results: results,
			category: category,
			searchValue: searchValue
		};
	};
	
	var selectRow = exports.selectRow = function selectRow(category, recordId) {
		return {
			type: '@@SEARCH_SELECT_ROW',
			category: category,
			recordId: recordId
		};
	};
	
	var setResultsMode = exports.setResultsMode = function setResultsMode(mode) {
		return {
			type: '@@SEARCH_SET_RESULTS_MODE',
			mode: mode
		};
	};
	
	var toggleSearching = exports.toggleSearching = function toggleSearching(searching) {
		return {
			type: '@@SEARCH_TOGGLE_SEARCHING',
			searching: searching
		};
	};
	
	var setSearchError = exports.setSearchError = function setSearchError(searchError, category) {
		return {
			type: '@@SEARCH_SET_SEARCH_ERROR',
			searchError: searchError,
			category: category
		};
	};
	
	var clearSearchError = exports.clearSearchError = function clearSearchError(category) {
		return {
			type: '@@SEARCH_CLEAR_SEARCH_ERROR',
			category: category
		};
	};
	
	var getSearchDescription = exports.getSearchDescription = function getSearchDescription(category) {
		return function (dispatch) {
			return new Promise(function (resolve) {
				(0, _requests.GET_SEARCH_DESCRIPTION)(category, function (description) {
					dispatch({
						type: '@@SEARCH_SET_DESCRIPTION',
						category: category,
						description: description
					});
					resolve(description);
				});
			});
		};
	};
	
	var setSort = exports.setSort = function setSort(_ref) {
		var category = _ref.category,
		    sortBy = _ref.sortBy,
		    sortByDirection = _ref.sortByDirection;
		return function (dispatch) {
			return new Promise(function (resolve) {
				dispatch({
					type: '@@SEARCH_SET_SORT',
					category: category,
					sortBy: sortBy,
					sortByDirection: sortByDirection
				});
				resolve();
			});
		};
	};
	
	var setActiveCategory = exports.setActiveCategory = function setActiveCategory(category) {
		return function (dispatch) {
			dispatch({
				type: '@@SEARCH_SET_ACTIVE_CATEGORY',
				category: category
			});
			dispatch({
				type: 'SET_CURRENT_CATEGORY',
				category: category
			});
		};
	};
	
	var invalidateAllCategoryCaches = exports.invalidateAllCategoryCaches = function invalidateAllCategoryCaches() {
		return function (dispatch) {
			dispatch({
				type: '@@SEARCH_INVALIDATE_CACHE'
			});
		};
	};

/***/ },
/* 470 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(20);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _Markdown = __webpack_require__(24);
	
	var _Markdown2 = _interopRequireDefault(_Markdown);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MessageCard = function MessageCard(_ref) {
	  var title = _ref.title,
	      content = _ref.content,
	      _ref$className = _ref.className,
	      className = _ref$className === undefined ? '' : _ref$className,
	      children = _ref.children,
	      style = _ref.style;
	
	
	  return _react2.default.createElement(
	    'div',
	    { className: 'message-card ' + className, style: style },
	    _react2.default.createElement(
	      'h2',
	      null,
	      title
	    ),
	    content && _react2.default.createElement(_Markdown2.default, { source: content, className: 'markdown' }),
	    children
	  );
	};
	
	MessageCard.propTypes = {
	  title: _propTypes2.default.node,
	  content: _propTypes2.default.string,
	  children: _propTypes2.default.node
	};
	
	exports.default = MessageCard;

/***/ },
/* 471 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _react2.default.createContext();

/***/ },
/* 472 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.ConnectedWizard = exports.DraftEditor = exports.CorrectionEditor = exports.ReadOnlyWizard = exports.AmendmentEditor = exports.SignaturesWizard = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(7);
	
	var _reactRouterDom = __webpack_require__(30);
	
	var _WizardActions = __webpack_require__(36);
	
	var _actions = __webpack_require__(29);
	
	var _Markdown = __webpack_require__(24);
	
	var _Markdown2 = _interopRequireDefault(_Markdown);
	
	var _Shell = __webpack_require__(19);
	
	var _Portal = __webpack_require__(12);
	
	var _Portal2 = _interopRequireDefault(_Portal);
	
	var _store = __webpack_require__(18);
	
	var _store2 = _interopRequireDefault(_store);
	
	var _Field = __webpack_require__(25);
	
	var _Field2 = _interopRequireDefault(_Field);
	
	var _WizardClasses = __webpack_require__(35);
	
	var WizardClasses = _interopRequireWildcard(_WizardClasses);
	
	var _SlidingPanel = __webpack_require__(101);
	
	var _SlidingPanel2 = _interopRequireDefault(_SlidingPanel);
	
	var _Checkout = __webpack_require__(67);
	
	var _Checkout2 = _interopRequireDefault(_Checkout);
	
	var _Loaders = __webpack_require__(16);
	
	var _utilities = __webpack_require__(8);
	
	var _deepCopy = __webpack_require__(284);
	
	var _deepCopy2 = _interopRequireDefault(_deepCopy);
	
	__webpack_require__(1475);
	
	var _requests = __webpack_require__(6);
	
	var _FileDownloader = __webpack_require__(147);
	
	var _FileDownloader2 = _interopRequireDefault(_FileDownloader);
	
	var _x2js = __webpack_require__(155);
	
	var _x2js2 = _interopRequireDefault(_x2js);
	
	var _wizardUtilities = __webpack_require__(52);
	
	var _reactHelmet = __webpack_require__(209);
	
	var _get2 = __webpack_require__(497);
	
	var _get3 = _interopRequireDefault(_get2);
	
	var _import = __webpack_require__(160);
	
	var _import2 = _interopRequireDefault(_import);
	
	var _export = __webpack_require__(333);
	
	var _export2 = _interopRequireDefault(_export);
	
	var _check = __webpack_require__(224);
	
	var _check2 = _interopRequireDefault(_check);
	
	var _LoginRedirector = __webpack_require__(148);
	
	var _deepEqual = __webpack_require__(65);
	
	var _deepEqual2 = _interopRequireDefault(_deepEqual);
	
	var _PaymentCallback = __webpack_require__(119);
	
	var _ThirdPartySignatures = __webpack_require__(1152);
	
	var _ThirdPartySignatures2 = _interopRequireDefault(_ThirdPartySignatures);
	
	var _MessageCard = __webpack_require__(470);
	
	var _MessageCard2 = _interopRequireDefault(_MessageCard);
	
	var _differenceInDays = __webpack_require__(139);
	
	var _differenceInDays2 = _interopRequireDefault(_differenceInDays);
	
	var _Utilities = __webpack_require__(8);
	
	var _caretDown = __webpack_require__(38);
	
	var _caretDown2 = _interopRequireDefault(_caretDown);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// import shortid from 'shortid'
	var xml2Json = new _x2js2.default();
	
	var SignaturesWizard = exports.SignaturesWizard = function SignaturesWizard(_ref) {
	  var params = _ref.match.params;
	  return _react2.default.createElement(ConnectedWizard, { signatures: true, token: params.token });
	};
	
	var AmendmentEditor = exports.AmendmentEditor = function AmendmentEditor(_ref2) {
	  var params = _ref2.match.params;
	  return _react2.default.createElement(ConnectedWizard, {
	    amendment: true,
	    mode: 'amendment',
	    formDefinitionId: params.formDefinitionId,
	    amendmentNum: params.amendmentNum
	  });
	};
	
	var ReadOnlyWizard = exports.ReadOnlyWizard = function ReadOnlyWizard(_ref3) {
	  var params = _ref3.match.params;
	  return _react2.default.createElement(ConnectedWizard, {
	    readOnly: true,
	    formDefinitionId: params.formDefinitionId,
	    amendmentNum: params.amendmentNum
	  });
	};
	
	var CorrectionEditor = exports.CorrectionEditor = function CorrectionEditor(_ref4) {
	  var params = _ref4.match.params;
	  return _react2.default.createElement(ConnectedWizard, {
	    correction: true,
	    mode: 'correction',
	    correctionMode: true,
	    formDefinitionId: params.formDefinitionId,
	    amendmentNum: params.amendmentNum
	  });
	};
	
	var DraftEditor = exports.DraftEditor = function DraftEditor(_ref5) {
	  var params = _ref5.match.params;
	  return _react2.default.createElement(ConnectedWizard, { draft: true, draftId: params.draftId });
	};
	
	var ConnectedWizard = exports.ConnectedWizard = function (_Component) {
	  _inherits(ConnectedWizard, _Component);
	
	  function ConnectedWizard() {
	    var _ref6;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, ConnectedWizard);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref6 = ConnectedWizard.__proto__ || Object.getPrototypeOf(ConnectedWizard)).call.apply(_ref6, [this].concat(args))), _this), _this.state = { firstFetchSent: false }, _this.componentWillMount = function () {
	      var search = (0, _utilities.parseUrlQuery)((0, _get3.default)(_this.props, 'location.search', '?'));
	      if (!search.prefilled) {
	        _this.props.resetWizardState();
	      }
	    }, _this.componentDidMount = function () {
	      _this.fetchWizardDefinition();
	      _this.setState({ firstFetchSent: true });
	      window.ALLOW_BYPASS_WIZARD_PROMPT = false;
	    }, _this.fetchWizardDefinition = function () {
	      if (_this.props.signatures) {
	        _this.props.fetchAndPopulateSignatures(_this.props.token);
	        return;
	      }
	      if (_this.props.draft) {
	        _this.props.fetchAndPopulateDraft(_this.props.draftId);
	        return;
	      }
	      if (_this.props.readOnly) {
	        _this.props.fetchAndPopulateReadOnlyWizard({
	          formDefinitionId: _this.props.formDefinitionId,
	          amendmentNum: _this.props.amendmentNum
	        });
	        return;
	      }
	      if (_this.props.correction || _this.props.amendment) {
	        _this.props.fetchAndPopulateAmendment({
	          formDefinitionId: _this.props.formDefinitionId,
	          amendmentNum: _this.props.amendmentNum,
	          mode: _this.props.mode,
	          category: _this.props.category,
	          correctionMode: _this.props.correctionMode
	        });
	        return;
	      }
	      var search = (0, _utilities.parseUrlQuery)((0, _get3.default)(_this.props, 'location.search', '?'));
	      if (!search.prefilled) {
	        _this.props.fetchAndPopulateWizard(_this.props.match.params.formDefinitionId);
	      }
	    }, _this.componentWillReceiveProps = function (nextProps) {
	      if (nextProps.hasLoadedDifferentWizard && !_this.props.draft && !nextProps.wizardLoadFailed && !_this.props.isLoading && _this.state.firstFetchSent) {
	        _this.props.resetWizardState();
	        _this.fetchWizardDefinition();
	      }
	    }, _this.toggleHelpModal = function () {
	      _this.props.toggleHelpModal(false);
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(ConnectedWizard, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          helpShown = _props.helpShown,
	          help = _props.help,
	          isLoading = _props.isLoading,
	          submitted = _props.submitted,
	          submitting = _props.submitting,
	          wizardLoadFailed = _props.wizardLoadFailed,
	          wizardLoadErrorMessage = _props.wizardLoadErrorMessage,
	          wizardLoadErrorTitle = _props.wizardLoadErrorTitle,
	          siteOffline = _props.siteOffline,
	          genericSuccess = _props.genericSuccess;
	
	      return _react2.default.createElement(
	        _Shell.Body,
	        {
	          showDrawer: helpShown,
	          className: genericSuccess ? 'receipt-wrapper flex-center-page generic-success-page' : ''
	        },
	        (submitted || submitting) && _react2.default.createElement('div', { className: 'submit-shield' }),
	        isLoading ? _react2.default.createElement(
	          'div',
	          { className: 'wizard-loader-wrapper loader-wrapper' },
	          _react2.default.createElement(_Loaders.Spinner, { className: 'page-loader animated fadeIn fast-animation', themeColor: 'neutral' })
	        ) : wizardLoadFailed ? _react2.default.createElement(
	          'div',
	          { className: 'payment-callback' },
	          _react2.default.createElement(
	            _PaymentCallback.PaymentError,
	            { errorTitle: ("Form Error") || wizardLoadErrorTitle },
	            wizardLoadErrorMessage ? _react2.default.createElement(_Markdown2.default, { source: wizardLoadErrorMessage, className: 'markdown' }) : 'We encountered an error while loading this form. Try again later, and if the problem persists please contact customer support.'
	          )
	        ) : genericSuccess ? _react2.default.createElement(_MessageCard2.default, {
	          className: 'animated fadeInUp',
	          title: _react2.default.createElement(
	            'span',
	            { className: 'flex-center-row' },
	            _react2.default.createElement(
	              'div',
	              { className: 'generic-success-icon' },
	              _react2.default.createElement(_check2.default, null)
	            ),
	            genericSuccess.title
	          ),
	          content: genericSuccess.message
	        }) : _react2.default.createElement(Wizard, null),
	        _react2.default.createElement(
	          _Shell.Drawer,
	          {
	            title: 'Help',
	            show: helpShown,
	            showCloseButton: true,
	            alwaysShowClosebutton: true,
	            onSidebarDismiss: this.toggleHelpModal,
	            ariaCloseLabel: 'Close help'
	          },
	          isLoading ? _react2.default.createElement(_Loaders.Spinner, { className: 'page-loader' }) : _react2.default.createElement(_Markdown2.default, { className: 'markdown', source: help, escapeHtml: true })
	        ),
	        siteOffline && _react2.default.createElement(_reactRouterDom.Redirect, { to: '/' })
	      );
	    }
	  }]);
	
	  return ConnectedWizard;
	}(_react.Component);
	
	exports.ConnectedWizard = ConnectedWizard = (0, _reactRedux.connect)(function (state, props) {
	  return {
	    hasLoadedDifferentWizard: props.signatures ? false : !props.draft && !props.correction && !props.readOnly && !props.amendment && !props.signatures ? props.match.params.formDefinitionId !== state.wizard.wizard.formDefinitionId : state.wizard.wizard.formDefinitionId !== props.formDefinitionId,
	    helpShown: state.wizard.helpShown,
	    help: state.wizard.wizard.steps[state.wizard.wizard.stepOrder[state.wizard.activeStep]] ? state.wizard.wizard.steps[state.wizard.wizard.stepOrder[state.wizard.activeStep]].help : '',
	    isLoading: state.wizard.loadingWizard,
	    submitted: state.wizard.submitted,
	    submitting: state.wizard.submitting,
	    wizardLoadFailed: state.wizard.wizardLoadFailed,
	    wizardLoadErrorMessage: state.wizard.wizardLoadErrorMessage,
	    wizardLoadErrorTitle: state.wizard.wizardLoadErrorTitle,
	    siteOffline: state.app.appSettings.WEBSITE_PORTAL_OFFLINE_YN === true,
	    genericSuccess: state.wizard.genericSuccess
	  };
	}, {
	  fetchAndPopulateWizard: _WizardActions.fetchAndPopulateWizard,
	  toggleHelpModal: _WizardActions.toggleHelpModal,
	  fetchAndPopulateDraft: _WizardActions.fetchAndPopulateDraft,
	  fetchAndPopulateAmendment: _WizardActions.fetchAndPopulateAmendment,
	  fetchAndPopulateReadOnlyWizard: _WizardActions.fetchAndPopulateReadOnlyWizard,
	  fetchAndPopulateSignatures: _WizardActions.fetchAndPopulateSignatures,
	  resetWizardState: _WizardActions.resetWizardState
	})(ConnectedWizard);
	
	var Wizard = function (_Component2) {
	  _inherits(Wizard, _Component2);
	
	  function Wizard(props) {
	    _classCallCheck(this, Wizard);
	
	    var _this2 = _possibleConstructorReturn(this, (Wizard.__proto__ || Object.getPrototypeOf(Wizard)).call(this, props));
	
	    _this2.componentDidMount = function () {
	      _this2.handleIsMobile();
	      var focusable =  true ? _this2.state.isMobile === true ? document.getElementById("wizard-body-scrollArrow-container-mobile") : document.getElementById("wizard-body-scrollArrow-container") : document.getElementById("wizard-body-scroll-container");
	      if (focusable) {
	        focusable.focus();
	      }
	    };
	
	    _this2.handleIsMobile = function () {
	      var ret = document.body.clientWidth < 600;
	      _this2.setState({
	        isMobile: ret
	      });
	    };
	
	    _this2.componentWillReceiveProps = function (nextProps) {
	      var stepHasChanged = nextProps.activeStep !== _this2.props.activeStep;
	      if (stepHasChanged) {
	        _this2.wizardBody.scrollToTop();
	      }
	    };
	
	    _this2.componentDidUpdate = function (prevProps) {
	      var stepHasChanged = prevProps.activeStep !== _this2.props.activeStep;
	      if (stepHasChanged) {
	        _this2.setFocusOnWizardBody();
	      }
	    };
	
	    _this2.setFocusOnWizardBody = function () {
	      var firstFocusableNonHelp = (0, _utilities.getFirstFocusableScopedElement)( true ? _this2.state.isMobile ? "#wizard-body-scrollArrow-container-mobile" : "#wizard-body-scrollArrow-container" : '#wizard-body-scroll-container', ':not(.help-button):not(.toolbar-button):not(.tip)');
	      if (firstFocusableNonHelp) {
	        var isUploadSubmit = Array.from(firstFocusableNonHelp.classList).includes("selectable") && Array.from(firstFocusableNonHelp.parentNode.parentNode.classList).includes("upload-submit");
	        if (isUploadSubmit) {
	          var selectedTab = document.querySelector('#' + firstFocusableNonHelp.parentNode.parentNode.id + ' .selectable[aria-selected="true"]');
	          if (selectedTab) {
	            selectedTab.focus();
	          } else {
	            firstFocusableNonHelp.focus();
	          }
	        } else {
	          firstFocusableNonHelp.focus();
	        }
	      } else {
	        var firstFocusable = (0, _utilities.getFirstFocusableScopedElement)( true ? _this2.state.isMobile ? "#wizard-body-scrollArrow-container-mobile" : "#wizard-body-scrollArrow-container" : '#wizard-body-scroll-container');
	        if (firstFocusable) {
	          firstFocusable.focus();
	        }
	      }
	    };
	
	    _this2.toggleHelpModal = function () {
	      _this2.props.toggleHelpModal(!_this2.props.helpShown);
	    };
	
	    _this2.continueAdvance = function () {
	      _this2.props.setActiveStep(_this2.props.targetStep);
	    };
	
	    _this2.state = {
	      isMobile: false
	    };
	    return _this2;
	  }
	
	  _createClass(Wizard, [{
	    key: 'render',
	    value: function render() {
	      var _this3 = this;
	
	      var _props2 = this.props,
	          _props2$steps = _props2.steps,
	          steps = _props2$steps === undefined ? [] : _props2$steps,
	          validating = _props2.validating,
	          loadingWizard = _props2.loadingWizard,
	          activeStep = _props2.activeStep,
	          _props2$title = _props2.title,
	          title = _props2$title === undefined ? 'Loading' : _props2$title,
	          readOnly = _props2.readOnly,
	          _props2$rootClassName = _props2.rootClassName,
	          rootClassName = _props2$rootClassName === undefined ? '' : _props2$rootClassName,
	          wizard = _props2.wizard,
	          previewing = _props2.previewing,
	          noLoginRequired = _props2.noLoginRequired,
	          authenticated = _props2.authenticated,
	          location = _props2.location,
	          mode = _props2.mode;
	
	      var isInSignatureMode = mode === 'signature';
	      return _react2.default.createElement(
	        'div',
	        { className: 'wizard container animated fadeInDown fast-animation ' + rootClassName, id: 'main-wizard-container' },
	        !noLoginRequired && !authenticated && !previewing && _react2.default.createElement(_LoginRedirector.LoginRedirectSwitch, { location: location }),
	        _react2.default.createElement(_reactRouterDom.Prompt, {
	          when: !previewing && !readOnly && authenticated,
	          message: function message(location) {
	            if (window.ALLOW_BYPASS_WIZARD_PROMPT || (location.pathname === '/auth' || location.pathname === '/admin' || location.pathname === '/') && !authenticated || location.pathname === '/receipt') {
	              window.ALLOW_BYPASS_WIZARD_PROMPT = false;
	              return true;
	            } else {
	              return ({"NODE_ENV":"production","BUILD_DATE":"2025-08-27T15:15:31.687Z","BUILD_NUMBER":"Not Provided","GIT_VERSION":"v1.3.0-381-ga81e29b08","GIT_COMMIT_HASH":"a81e29b085c9268ffd96c78eb734365802722741","GIT_BRANCH":"beta","PUBLIC_URL":"","STATE_ABBR":"MT","STATE_NAME":"Montana","STATE_ORG_TITLE":"Secretary of State","LOGIN_HEADER_IMG_PATH":"","HOME_IMG_FILENAME":"montana.jpg","FAVICON_FILE_NAME":"favicon.ico","ALLOW_E_SIGN_ON_CORRECTIONS":true,"THIRD_PARTY_SIGNING_ALLOWED":false,"MY_ACCOUNT_SAVE_AND_CLOSE_BUTTON":true,"IE_DEPRECATED_MESSAGE":"Internet Explorer is not supported. Please select a supported browser below to access this website.","ADDITIONAL_ROUTES":{"dataRequests":true,"farmBill":true,"apostille":true,"externalHelp":"https://sosmt.gov/business/help-center/","systemAdministration":[{"title":"Saved Payments","parameter":"saved-payments","componentName":"SavedPayments"}]},"SUBROUTES":[{"label":"Business","component":"Business","parameter":"business","myWorkQueueSearch":false,"sourceTypeId":54,"searchMustHaveOneOf":["FILING_TYPE_ID","STATUS_ID","STATE","search"],"serverWebSearchDescription":true,"serverWorkQueueDescription":true,"serverMyRecordsDescription":true,"searchPlaceholder":"Search by name or filing number (X########)","allowEmptySearchTerm":true,"requestCertificateAlternateLabel":"Request Information","fileAmendmentButtonLabel":"Filing Actions","advancedSearchParameters":[{"type":"radio","name":"QUERY_TYPE_ID","defaultValue":1010,"options":[{"value":1010,"label":"Starts with"},{"value":1011,"label":"Contains"},{"value":1012,"label":" Word Contains"}]},{"type":"serverSelect","name":"FILING_TYPE_ID","optionsSrc":"FILING_TYPES","label":"Entity Type","placeholder":"All","defaultValue":"0"},{"type":"serverSelect","name":"FILING_SUBTYPE_ID","optionsSrc":"FILING_SUBTYPES","label":"Entity Subtype","overrideSubOptionsSrcFromParameterName":"FILING_TYPE_ID","placeholder":"All","defaultValue":"0"},{"type":"serverSelect","name":"STATUS_ID","optionsSrc":"FILING_STATUS_WITHOUT_ALL","label":"Status","placeholder":"All","defaultValue":"0"},{"type":"serverSelect","name":"STATE","optionsSrc":"STATE","label":"State","placeholder":"All","defaultValue":""},{"type":"serverSelect","name":"COUNTY","optionsSrc":"COUNTY_SUBOPTION","label":"County","overrideSubOptionsSrcFromParameterName":"STATE","placeholder":"All","defaultValue":""},{"type":"checkbox","name":"CRA_SEARCH_YN","defaultValue":false,"label":"Search by Registered Agent PID"},{"type":"dateRange","name":"FILING_DATE","label":"Registration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}},{"type":"dateRange","name":"EXPIRATION_DATE","label":"Expiration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}}],"myRecordsFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Active"},{"value":2,"label":"Inactive"},{"value":3,"label":"Pending"}]},{"type":"dateRange","name":"DATE_RANGE","label":"Date range","defaultValue":{"start":null,"end":null}}],"myWorkQueueFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Approved"},{"value":2,"label":"Pending Online Payment"},{"value":3,"label":"Pending Review"},{"value":4,"label":"Needs Correction"},{"value":5,"label":"Rejected"},{"value":6,"label":"Draft"}]},{"type":"dateRange","name":"DATE_RANGE","label":"Date range","defaultValue":{"start":null,"end":null}}]},{"label":"Notary","component":"Notary","parameter":"notary","sourceTypeId":850,"myWorkQueueSearch":false,"allowEmptySearchTerm":true,"requestCertificateAlternateLabel":"Download Certificate","fileAmendmentButtonLabel":"Filing Actions","hideNameRequestCertificate":true,"hideAddressRequestCertificate":true,"hideRecordUserManagment":true,"searchPlaceholder":"Search by name or commission number","searchMustHaveOneOf":["CITY","search","SERVICE_TYPE"],"advancedParametersStartOpen":true,"searchIsSortable":true,"advancedSearchParameters":[{"type":"radio","name":"STARTS_WITH_YN","defaultValue":false,"options":[{"value":true,"label":"Starts with"},{"value":false,"label":"Contains"}]},{"type":"checkbox","name":"ACTIVE_ONLY_YN","defaultValue":true,"label":"Active entities only"},{"type":"text","name":"CITY","defaultValue":"","label":"City"},{"type":"select","name":"SERVICE_TYPE","label":"Special Services Offered","defaultValue":0,"options":[{"value":0,"label":"(N/A)"},{"value":6165,"label":"In-Person Electronic Notarization (IPEN)"},{"value":6166,"label":"Remote Online Notarization (RON)"},{"value":6167,"label":"Mobile Notary Services"},{"value":6168,"label":"Remote Ink Notarization (RIN)"}]}]},{"label":"Apostille","component":"Apostille","parameter":"apostille","sourceTypeId":720,"myRecordsSearch":false,"myWorkQueueSearch":false,"disabled":false,"allowedRoutes":["/forms-manager/","/queue/","/forms/"]},{"label":"Liens","component":"UCC","parameter":"ucc","sourceTypeId":1999,"myRecordsSearch":true,"myWorkQueueSearch":true,"fileAmendmentButtonLabel":"Filing Actions","searchPlaceholder":"Search by name or file number","disabled":false,"serverWebSearchDescription":true,"myRecordsDescription":"","workQueueDescription":"","searchDescription":"","hideRecordUserManagment":true,"searchLiensCheckout":false,"advancedSearchParameters":[{"type":"radio","name":"STARTS_WITH_YN","defaultValue":false,"options":[{"value":true,"label":"Starts with"},{"value":false,"label":"Contains"}]},{"type":"select","name":"STATUS","defaultValue":"ALL","label":"Status","options":[{"value":"ACTIVE_UNLAPSED","label":"Active (unlapsed)"},{"value":"ACTIVE_LAPSED_UNLAPSED","label":"Active (lapsed and unlapsed)"}]},{"type":"text","name":"EXCLUDE_VALUES","label":"Exclude Debtor Names (comma separated list of names to exclude)","defaultValue":""},{"type":"dateRange","name":"FILING_DATE","label":"Financing Statement Date","defaultValue":{"start":null,"end":null}},{"type":"dateRange","name":"LAPSE_DATE","label":"Lapse Date","defaultValue":{"start":null,"end":null}},{"type":"text","name":"CITY","label":"Debtor City","defaultValue":""}],"myRecordsFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Approved"},{"value":2,"label":"Pending Online Payment"},{"value":3,"label":"Pending Review"}]},{"type":"select","name":"TYPE","defaultValue":0,"label":"Lien Type","options":[{"value":0,"label":"All"},{"value":1,"label":"UCC"},{"value":2,"label":"EFS"},{"value":3,"label":"Title 71"}]}],"myWorkQueueFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Approved"},{"value":2,"label":"Pending Online Payment"},{"value":3,"label":"Pending Review"},{"value":4,"label":"Pending Print and Mail"},{"value":5,"label":"Rejected"},{"value":6,"label":"Draft"}]},{"type":"select","name":"TYPE","defaultValue":0,"label":"Lien Type","options":[{"value":0,"label":"All"},{"value":1,"label":"UCC"},{"value":2,"label":"EFS"},{"value":3,"label":"Title 71"}]}]},{"label":"Copy Request","component":"copies","parameter":"copies","sourceTypeId":2001,"myRecordsSearch":false,"myWorkQueueSearch":false,"disabled":false,"allowedRoutes":["/forms-manager/","/queue/","/forms/"]},{"label":"Trademark","component":"Trademark","parameter":"trademark","sourceTypeId":810,"showRequestCertificate":true,"searchMustHaveOneOf":["search","EXPIRATION_DATE","FILING_DATE"],"allowEmptySearchTerm":true,"requestCertificateAlternateLabel":"Request Information","fileAmendmentButtonLabel":"Filing Actions","advancedSearchParameters":[{"type":"radio","name":"QUERY_TYPE_ID","defaultValue":1010,"options":[{"value":1010,"label":"Starts with"},{"value":1011,"label":"Contains"},{"value":1012,"label":" Word Contains"}]},{"type":"checkbox","name":"OWNER_SEARCH_YN","defaultValue":false,"label":"Search owners"},{"type":"radio","name":"SERVICE_MARK_YN","label":"Mark Type","defaultValue":"","options":[{"value":"","label":"All Marks"},{"value":"Y","label":"Service Mark"},{"value":"N","label":"Trademark"}]},{"type":"serverSelect","name":"STATUS_ID","optionsSrc":"TYPE_V|TRADEMARK_STATUS_TYPE","label":"Status","placeholder":"All","defaultValue":"0"},{"type":"select","name":"DESIGN_TYPE_ID","options":[{"value":0,"label":"All"},{"value":990,"label":"Words Only"},{"value":991,"label":"Design Only"},{"value":992,"label":"Words and Design"}],"label":"Design Type","defaultValue":"0"},{"type":"dateRange","name":"FILING_DATE","label":"Registered Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}},{"type":"dateRange","name":"EXPIRATION_DATE","label":"Expiration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}}]},{"label":"Business Info Request","component":"InfoRequests","parameter":"info-request","sourceTypeId":167,"allowedRoutes":["/forms-manager/","/queue/","/forms/"]},{"label":"Data Requests","component":"DataRequests","parameter":"data-request","sourceTypeId":0,"allowedRoutes":["/forms-manager/"]},{"label":"CRA","component":"CRA","parameter":"cra","sourceTypeId":157,"myRecordsSearch":false,"searchPlaceholder":"Search by name or registered agent number","allowedRoutes":["/forms-manager/","/forms/","/records/","/queue/","/search/"],"allowEmptySearchTerm":true,"fileAmendmentButtonLabel":"Filing Actions","advancedSearchParameters":[{"type":"radio","name":"QUERY_TYPE_ID","defaultValue":1010,"options":[{"value":1010,"label":"Starts with"},{"value":1011,"label":"Contains"},{"value":1012,"label":" Word Contains"}]},{"type":"dateRange","name":"CRA_DATE","label":"Registration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}},{"type":"select","name":"STATUS_ID","label":"Status","defaultValue":0,"options":[{"value":0,"label":"All"},{"value":121,"label":"Active"},{"value":122,"label":"Inactive"}]},{"type":"select","name":"AGENT_TYPE_ID","label":"Agent Type","defaultValue":0,"options":[{"value":0,"label":"All"},{"value":460,"label":"Registered Agent"},{"value":461,"label":"Commercial Registered Agent"}]}]},{"label":"Farm Bill","component":"FarmBill","parameter":"farm-bill","path":"/lists/farm-bill","sourceTypeId":0,"myRecordsSearch":false,"allowedRules":["/search/"],"disabled":true,"searchDescription":"To perform a search, enter a debtor name. Your search results may include: exact debtor name, variations of that name and any filing that includes your search criteria. Punctuation is ignored.\n\nYou can click on \"Advanced\" to refine your search. Under “Advanced” you can search by crop, year, county and SSN/FEIN. As a registered Farm Bill Buyer with the Montana Secretary of State’s office it is important to maintain the confidentiality of the information contained within the Farm Bill Master List. The Farm Bill Master List reflects personal data, such as Social Security Numbers, which are a key piece of personal identifiable information to assist you in determining the existence of a lien against a specific debtor. The distribution of this information beyond its intended purpose is strictly prohibited.\n\nThe debtor's tax identification number has been hidden for confidentiality reasons. You may continue to search on a tax ID number and return debtors that match your search criteria. The SSN/FEIN must be entered without dashes or spaces.","searchMustHaveOneOf":["search","UCC_FARM_PRODUCT_ID","COUNTY"],"searchPlaceholder":"Search by debtor name","advancedSearchParameters":[{"type":"ServerMultiComplete","label":"Product code name(s)","name":"UCC_FARM_PRODUCT_ID","defaultValue":"","optionsSrc":"UCC_FARM_PRODUCT_V"},{"type":"MultiComplete","label":"Year or Range of Years","name":"YEAR_NUM","optionsSrc":"years","startYear":"1968","defaultValue":[],"preMergeOptions":[{"value":"ALL","label":"All"}]},{"type":"serverSelect","label":"State","name":"STATE","defaultValue":"MONTANA","optionsSrc":"STATE"},{"type":"ServerMultiComplete","label":"County","name":"COUNTY","defaultValue":[],"optionsSrc":"COUNTY","overrideSubOptionsSrcFromParameterName":"STATE"},{"type":"checkbox","name":"TIN_SEARCH_YN","defaultValue":false,"label":"Tax Identification Number Search"},{"type":"checkbox","name":"TIN_SORT_YN","defaultValue":false,"label":"Unique ID Sort"}]}],"SYSTEM_NICKNAME":"Online Services Portal","PAYMENT_METHODS":[{"type":"bypass"},{"type":"iTransact"}],"PAYMENT_ALLOW_AMEX":true,"SYSTEM_ID_LABEL":"System Id","DOUBLE_COLUMN_PUBLIC_LOGIN":true,"INTERNAL_USER_MANAGEMENT":true,"ALLOW_PUBLIC_JSON_IMPORT":false,"MAX_FILE_UPLOAD_SIZE":10000000,"REFUND_TEXT":"","RETURN_TO_HOME_ON_LOGOUT":true,"CURRENT_SOS_NAME":"Christi Jacobsen","LOGO_FILENAME":"mt-sos-logo.png","LOGO_ALT":"Christi Jacobsen, Montana Secretary of State","LOGO_FULL_WIDTH":true,"HOME_HIDE_AUTH_HINT":true,"HOME_TITLE":"Montana Secretary of State","CUSTOM_TAB_TITLE":"Official Montana","HOME_SUBTITLE":"Online Business Services","ENTITY_NAME_CONSENT_DESCRIPTION":"","ALLOW_USER_PROFILE_EDITING":true,"COMPARE_FOREIGN_NAME_IN_ENTITY_NAME_VALIDATION":true,"FOREIGN_NAME_FIELD_NAME":"KIMA_PARENT_NAME_INFO","LOGIN_TITLE":"Montana Secretary of State Online Filing Portal Login","PUBLIC_LOGIN_LABEL":"Username","REVERSE_LOGIN_COLUMNS":true,"LOGIN_SEAL_FILENAME":"seal_white.png","SEPARATE_USERNAME_AND_EMAIL":true,"CREATE_ACCOUNT_BUTTON_ALIGN_LEFT":true,"CREATE_ACCOUNT_BUTTON_TEXT":"CREATE AN ACCOUNT","PASSWORD_CUSTOM_ERROR_TEXT":"The password must meet all requirements","ACCOUNT_CREATED_MESSAGE":"Please check your email to verify your account to login and allow a few minutes for this message to arrive. Check your junk/spam folders if you do not find the email in your inbox.","PUBLIC_LOGIN_PLACEHOLDER":" ","DISABLE_DEFAULT_PAYMENT_RADIO":true,"CUSTOM_RESET_PASSWORD_ERROR_MESSAGE":"Username invalid - no account found","PUBLIC_LOGIN_CREATE_DESCRIPTION":"### Existing User:\n\n  - Enter your username and password to login.  \n\n\n  #### - OR -  \n\n\n\n  - Forgot password? Click 'Reset Password' and follow the prompts.\n  - Forgot username? Click 'Forgot Username' and follow the prompts.  \n\n\n  ### New User:\n  ","LOGIN_HELP_LINK":"https://sosmt.gov/business/how-do-i/","LOGIN_HELP_LINK_TEXT":"Need Help?","FORGOT_USERNAME_TEXT":"Forgot Username?","LOGIN_ACTIVE_DIRECTORY_TEXT":"State User Login","MULTIPLE_LOGIN_METHODS":true,"HAS_ACTIVE_DIRECTORY_LOGIN":true,"RESET_PASSWORD_WITH_USERNAME":true,"DOWNLOAD_LINK":true,"SHOW_USERNAME_ACCOUNT_CREATE":true,"SHOW_SCROLL_DOWN_ARROW":true,"SHOW_ADDRESS_ACCOUNT_CREATE":true,"TWO_COLUMN_ACCOUNT_CREATE":true,"RESET_PASSWORD_TIP":"A link to change your password has been sent to your email. Please allow a few minutes for this message to arrive. Please check your junk/spam folders if you do not find the email in your inbox.","FORGOT_PASSWORD_LINK_TEXT":"Reset Password","PHONE_NUMBER_OPTIONAL_ACCOUNT_CREATE":true,"SHOW_REQUIRED_INDICATOR_ACCOUNT_CREATE":true,"PASSWORD_REQUIREMENTS_ACCOUNT_CREATE":"\n    <ul>\n      <li>MUST contain at least 8 characters (12+ recommended)</li>\n      <li>MUST contain at least one uppercase letter.</li>\n      <li>MUST contain at least one lowercase letter.</li>\n      <li>MUST contain at least one number.</li>\n      <li>MUST contain at least one special character (!”#$%&'()*+,-./:;<=>?</li>\n    </ul>\n  ","ALLOW_CERTIFICATION_REQUEST":true,"ALLOW_PUBLIC_CERTIFICATE_REQUEST":true,"ALLOW_COPY_REQUEST":false,"ALLOW_CORRECTION_STYLING":true,"HIDE_DEPRECATION_WARNING":false,"AMEND_ROUTE_PUBLIC":true,"SEAL_FILENAME":"seal.png","SHOPPING_CART":true,"ALLOW_PAYMENT_UPDATE_WITH_EMPTY_CART":true,"RA_EMAIL":true,"RA_WEBSITE":true,"RA_NO_DEFAULT_TYPE":true,"RA_ADDRESS_LABEL":"Street Address","RA_TYPE_SELECTION_DEFAULT":true,"RA_DEFAULT_TYPE":"460","RA_OVERRIDE_TYPE_WITH_DEFAULT":true,"RA_PRINCIPAL_ADDRESS_AMS":true,"UPLOAD_AND_SUBMIT_HIDE_IF_ONE_OPTION":true,"PAYMENT_PROCESSING_MESSAGE":"Your payment is processing - Do not close your browser or click the back button","CHECKOUT_BUTTON_WHEN_PROCESSING_TEXT":"Processing","EFS_CROP_PICKER_NONE_LABEL":"Lien Duration","DISALLOWED_WIZARD_PIECES":["FormationLocale"],"REPEATER_SHOW_EDIT_BUTTON":true,"DATA_REQUEST_PAGE_TITLE":"Data Requests and Subscriptions","DATA_REQUEST_SIDEBAR_LABEL":"Data Requests & Subscriptions","LOGIN_REDIRECTS_TO_EPASS":false,"LOGIN_REDIRECTS_TO_ACTIVE_DIRECTORY":true,"LOGIN_ACTIVE_DIRECTORY_LINK":true,"FETCH_EDIT_USER_LINK":false,"LISTS_FETCH_AVAILABLE_LISTS":true,"POST_WIZARD_SUBMIT_REDIRECT_URL":"/","PIN_REQUEST_ATTESTATIONS":true,"PIN_REQUEST_DESCRIPTION":"Click **Request PIN** to have a new PIN sent to the account holder's email address on file.","OWNERSHIP_REQUEST_DESCRIPTION":"To become an **authorized user** of this record, a current **AUTHORIZED USER** will need to grant you access. To request access, click **Request Access** below.","PIN_REQUEST_SUCCESS_MESSAGE":"The PIN you have requested for this entity has been sent to the email associated with your user account.  You should receive the PIN in approximately 3-5 minutes, depending on your email service provider.","APOSTILLE_HEADER_LABEL":"Verification Information","APOSTILLE_NUMBER_LABEL":"Apostille/Authentication","APOSTILLE_CITY_STATE_OVERRIDE":"HELENA, MT","APOSTILLE_FILING_DATE_LABEL":"Issue Date","APOSTILLE_CITY_STATE_IN_CERTIFIED":true,"NOTARY_EXISTING_FILING":true,"ALLOW_REVOKE_OWN_ACCESS_ONLY":false,"HIDE_CANCEL_ON_ONETIME_DATA_REQUESTS":true,"DATA_REQUESTS_IN_SHOPPING_CART":true,"WQ_ALLOW_EDIT_PENDING_PAYMENT":true,"WQ_CONFIRM_ON_DELETE":true,"WQ_DELETE_CONFIRM_MESSAGE":"Deleting this filing will forfeit any money already paid to the Secretary of State. This action is permanent and cannot be undone, are you sure you would like to delete?","PASS_ITEM_GUIDS_ON_CHECKOUT":true,"FORM_REVISION_HISTORY":true,"CHECKOUT_DISCLAIMER":"By entering your credit card and/or checking account information you (i) state that **you are an authorized user** of the credit card and/or electronic check and that the associated information entered (e.g., account holder name, account number, billing address) is accurate, (ii) **you authorize payment processor to charge the amount you have requested** to your credit card and/or funding account, and (iii) **acknowledge if a charge is declined or reversed you may also be assessed a customary charge** by the payment processor for such transactions.","FARM_BILL_SEARCH_CONFIDENTIAL":"As a registered Farm Bill Buyer with the Montana Secretary of State’s office it is important to maintain the confidentiality of the information contained within the Farm Bill Master List. The Farm Bill Master List reflects personal data, such as Social Security Numbers, which are a key piece of personal identifiable information to assist you in determining the existence of a lien against a specific debtor. The distribution of this information beyond its intended purpose is strictly prohibited.\n\n**The debtor's tax identification number has been hidden for confidentiality reasons. You may continue to search on a tax ID number and return debtors that match your search criteria. The SSN/FEIN must be entered without dashes or spaces.  If you need access to the tax identification number to clearly identify the debtor, please contact the UCC unit at (406) 444-3665.**","VIEW_HISTORY_BUTTON_ALT_TEXT":"View Filings","WIZARD_ERROR_TITLE_MESSAGE":"Form Error","FARM_BILL_SEARCH_INTERACTIVE":true,"USE_FARM_BILL_API":true,"DISALLOW_ASSIGN_SELF_AS_RA":true,"DISALLOW_ASSIGN_SELF_AS_PRINCIPAL":true,"USE_TRADEMARK_OWNER_VALIDATION":true,"USE_ALTERNATIVE_FOREIGN_ADDRESS_LABELS":true,"MY_RECEIPTS_FILTER":[{"type":"dateRange","name":"DATE_RANGE","label":"Date range","defaultValue":{"start":null,"end":null}},{"type":"text","name":"REF_NUM","defaultValue":"","label":"Reference Number"},{"type":"text","name":"RECEIPT_NUM","defaultValue":"","label":"Receipt Id"},{"type":"text","name":"AMOUNT","defaultValue":"","label":"Amount"},{"type":"select","name":"TYPE","defaultValue":"","label":"Payment Type","options":[{"value":"","label":"All"},{"value":"CC","label":"Credit Card"},{"value":"Check","label":"Check"}]}],"MY_RECEIPTS_SHOW_IN_SIDEBAR":true,"SHOW_MY_RECEIPTS_HELPER_TEXT":true,"MY_RECEIPTS_HELPER_LABEL":"About Receipt Search","MY_RECEIPTS_HELPER_TEXT":"You can search for receipts based on their descriptions, including the items paid for on the receipt. Use the filters to search for or filter specific information.","FARM_BILL_SUBLINK":{"label":"Farm Bill","component":"FarmBill","parameter":"farm-bill","path":"/lists/farm-bill","sourceTypeId":0,"myRecordsSearch":false,"allowedRules":["/search/"],"disabled":true,"searchDescription":"To perform a search, enter a debtor name. Your search results may include: exact debtor name, variations of that name and any filing that includes your search criteria. Punctuation is ignored.\n\nYou can click on \"Advanced\" to refine your search. Under “Advanced” you can search by crop, year, county and SSN/FEIN. As a registered Farm Bill Buyer with the Montana Secretary of State’s office it is important to maintain the confidentiality of the information contained within the Farm Bill Master List. The Farm Bill Master List reflects personal data, such as Social Security Numbers, which are a key piece of personal identifiable information to assist you in determining the existence of a lien against a specific debtor. The distribution of this information beyond its intended purpose is strictly prohibited.\n\nThe debtor's tax identification number has been hidden for confidentiality reasons. You may continue to search on a tax ID number and return debtors that match your search criteria. The SSN/FEIN must be entered without dashes or spaces.","searchMustHaveOneOf":["search","UCC_FARM_PRODUCT_ID","COUNTY"],"searchPlaceholder":"Search by debtor name","advancedSearchParameters":[{"type":"ServerMultiComplete","label":"Product code name(s)","name":"UCC_FARM_PRODUCT_ID","defaultValue":"","optionsSrc":"UCC_FARM_PRODUCT_V"},{"type":"MultiComplete","label":"Year or Range of Years","name":"YEAR_NUM","optionsSrc":"years","startYear":"1968","defaultValue":[],"preMergeOptions":[{"value":"ALL","label":"All"}]},{"type":"serverSelect","label":"State","name":"STATE","defaultValue":"MONTANA","optionsSrc":"STATE"},{"type":"ServerMultiComplete","label":"County","name":"COUNTY","defaultValue":[],"optionsSrc":"COUNTY","overrideSubOptionsSrcFromParameterName":"STATE"},{"type":"checkbox","name":"TIN_SEARCH_YN","defaultValue":false,"label":"Tax Identification Number Search"},{"type":"checkbox","name":"TIN_SORT_YN","defaultValue":false,"label":"Unique ID Sort"}]},"ALLOW_ADDRESS_VALIDATION_BYPASS_OPTION":true,"DEFAULT_ADDRESS_VALIDATION_BYPASS_OPTION_CHECKED":true}).WIZARD_ON_EARLY_EXIT_MESSAGE || 'Are you sure you want to leave this form? Any unsaved data will be lost.\n\nTo save your work and resume editing later click "Save Draft" below.';
	            }
	          }
	        }),
	        _react2.default.createElement(
	          'div',
	          { className: '' },
	          _react2.default.createElement(
	            'div',
	            { className: 'row' },
	            _react2.default.createElement(
	              'div',
	              { className: 'col' },
	              _react2.default.createElement(
	                'h1',
	                { className: 'wizard-title ' },
	                title
	              )
	            ),
	            _react2.default.createElement(
	              _reactHelmet.Helmet,
	              null,
	              _react2.default.createElement(
	                'title',
	                null,
	                '' + (previewing ? '👁 ' : '') + (title || '') + ' | ' + ("Montana") + ' ' + ("Secretary of State")
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'row' },
	            _react2.default.createElement(
	              'div',
	              { className: 'col' },
	              _react2.default.createElement(
	                'div',
	                { className: 'wrapper' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'row row-eq-height' },
	                  !isInSignatureMode && _react2.default.createElement(
	                    'div',
	                    { className: 'col-sm-4 col-md-3 col-lg-3 sidebar-wrapper' },
	                    _react2.default.createElement(
	                      Sidebar,
	                      null,
	                      !loadingWizard ? steps.map(function (step, i) {
	                        return _react2.default.createElement(StepButton, {
	                          stepIndex: i,
	                          title: step.title,
	                          active: i === activeStep,
	                          activeStep: activeStep,
	                          isValid: step.isValid,
	                          totalSteps: steps.length,
	                          key: i
	                        });
	                      }) : null
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    {
	                      className: '' + (!isInSignatureMode ? 'col-sm-8 col-md-9 col-lg-9' : 'col-12')
	                    },
	                    _react2.default.createElement(
	                      Body,
	                      {
	                        validating: validating,
	                        readOnly: readOnly,
	                        ref: function ref(r) {
	                          _this3.wizardBody = r;
	                        },
	                        isFullWidth: isInSignatureMode,
	                        activeStep: activeStep
	                      },
	                      !loadingWizard ? _react2.default.createElement(
	                        'form',
	                        {
	                          onSubmit: function onSubmit(e) {
	                            e.preventDefault();
	                          }
	                        },
	                        steps[activeStep] ? steps[activeStep].help !== '' && !readOnly && !isInSignatureMode ? _react2.default.createElement(
	                          'div',
	                          { className: 'help-wrapper' },
	                          _react2.default.createElement(
	                            'button',
	                            {
	                              type: 'button',
	                              className: 'help-button ' + (({"NODE_ENV":"production","BUILD_DATE":"2025-08-27T15:15:31.687Z","BUILD_NUMBER":"Not Provided","GIT_VERSION":"v1.3.0-381-ga81e29b08","GIT_COMMIT_HASH":"a81e29b085c9268ffd96c78eb734365802722741","GIT_BRANCH":"beta","PUBLIC_URL":"","STATE_ABBR":"MT","STATE_NAME":"Montana","STATE_ORG_TITLE":"Secretary of State","LOGIN_HEADER_IMG_PATH":"","HOME_IMG_FILENAME":"montana.jpg","FAVICON_FILE_NAME":"favicon.ico","ALLOW_E_SIGN_ON_CORRECTIONS":true,"THIRD_PARTY_SIGNING_ALLOWED":false,"MY_ACCOUNT_SAVE_AND_CLOSE_BUTTON":true,"IE_DEPRECATED_MESSAGE":"Internet Explorer is not supported. Please select a supported browser below to access this website.","ADDITIONAL_ROUTES":{"dataRequests":true,"farmBill":true,"apostille":true,"externalHelp":"https://sosmt.gov/business/help-center/","systemAdministration":[{"title":"Saved Payments","parameter":"saved-payments","componentName":"SavedPayments"}]},"SUBROUTES":[{"label":"Business","component":"Business","parameter":"business","myWorkQueueSearch":false,"sourceTypeId":54,"searchMustHaveOneOf":["FILING_TYPE_ID","STATUS_ID","STATE","search"],"serverWebSearchDescription":true,"serverWorkQueueDescription":true,"serverMyRecordsDescription":true,"searchPlaceholder":"Search by name or filing number (X########)","allowEmptySearchTerm":true,"requestCertificateAlternateLabel":"Request Information","fileAmendmentButtonLabel":"Filing Actions","advancedSearchParameters":[{"type":"radio","name":"QUERY_TYPE_ID","defaultValue":1010,"options":[{"value":1010,"label":"Starts with"},{"value":1011,"label":"Contains"},{"value":1012,"label":" Word Contains"}]},{"type":"serverSelect","name":"FILING_TYPE_ID","optionsSrc":"FILING_TYPES","label":"Entity Type","placeholder":"All","defaultValue":"0"},{"type":"serverSelect","name":"FILING_SUBTYPE_ID","optionsSrc":"FILING_SUBTYPES","label":"Entity Subtype","overrideSubOptionsSrcFromParameterName":"FILING_TYPE_ID","placeholder":"All","defaultValue":"0"},{"type":"serverSelect","name":"STATUS_ID","optionsSrc":"FILING_STATUS_WITHOUT_ALL","label":"Status","placeholder":"All","defaultValue":"0"},{"type":"serverSelect","name":"STATE","optionsSrc":"STATE","label":"State","placeholder":"All","defaultValue":""},{"type":"serverSelect","name":"COUNTY","optionsSrc":"COUNTY_SUBOPTION","label":"County","overrideSubOptionsSrcFromParameterName":"STATE","placeholder":"All","defaultValue":""},{"type":"checkbox","name":"CRA_SEARCH_YN","defaultValue":false,"label":"Search by Registered Agent PID"},{"type":"dateRange","name":"FILING_DATE","label":"Registration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}},{"type":"dateRange","name":"EXPIRATION_DATE","label":"Expiration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}}],"myRecordsFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Active"},{"value":2,"label":"Inactive"},{"value":3,"label":"Pending"}]},{"type":"dateRange","name":"DATE_RANGE","label":"Date range","defaultValue":{"start":null,"end":null}}],"myWorkQueueFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Approved"},{"value":2,"label":"Pending Online Payment"},{"value":3,"label":"Pending Review"},{"value":4,"label":"Needs Correction"},{"value":5,"label":"Rejected"},{"value":6,"label":"Draft"}]},{"type":"dateRange","name":"DATE_RANGE","label":"Date range","defaultValue":{"start":null,"end":null}}]},{"label":"Notary","component":"Notary","parameter":"notary","sourceTypeId":850,"myWorkQueueSearch":false,"allowEmptySearchTerm":true,"requestCertificateAlternateLabel":"Download Certificate","fileAmendmentButtonLabel":"Filing Actions","hideNameRequestCertificate":true,"hideAddressRequestCertificate":true,"hideRecordUserManagment":true,"searchPlaceholder":"Search by name or commission number","searchMustHaveOneOf":["CITY","search","SERVICE_TYPE"],"advancedParametersStartOpen":true,"searchIsSortable":true,"advancedSearchParameters":[{"type":"radio","name":"STARTS_WITH_YN","defaultValue":false,"options":[{"value":true,"label":"Starts with"},{"value":false,"label":"Contains"}]},{"type":"checkbox","name":"ACTIVE_ONLY_YN","defaultValue":true,"label":"Active entities only"},{"type":"text","name":"CITY","defaultValue":"","label":"City"},{"type":"select","name":"SERVICE_TYPE","label":"Special Services Offered","defaultValue":0,"options":[{"value":0,"label":"(N/A)"},{"value":6165,"label":"In-Person Electronic Notarization (IPEN)"},{"value":6166,"label":"Remote Online Notarization (RON)"},{"value":6167,"label":"Mobile Notary Services"},{"value":6168,"label":"Remote Ink Notarization (RIN)"}]}]},{"label":"Apostille","component":"Apostille","parameter":"apostille","sourceTypeId":720,"myRecordsSearch":false,"myWorkQueueSearch":false,"disabled":false,"allowedRoutes":["/forms-manager/","/queue/","/forms/"]},{"label":"Liens","component":"UCC","parameter":"ucc","sourceTypeId":1999,"myRecordsSearch":true,"myWorkQueueSearch":true,"fileAmendmentButtonLabel":"Filing Actions","searchPlaceholder":"Search by name or file number","disabled":false,"serverWebSearchDescription":true,"myRecordsDescription":"","workQueueDescription":"","searchDescription":"","hideRecordUserManagment":true,"searchLiensCheckout":false,"advancedSearchParameters":[{"type":"radio","name":"STARTS_WITH_YN","defaultValue":false,"options":[{"value":true,"label":"Starts with"},{"value":false,"label":"Contains"}]},{"type":"select","name":"STATUS","defaultValue":"ALL","label":"Status","options":[{"value":"ACTIVE_UNLAPSED","label":"Active (unlapsed)"},{"value":"ACTIVE_LAPSED_UNLAPSED","label":"Active (lapsed and unlapsed)"}]},{"type":"text","name":"EXCLUDE_VALUES","label":"Exclude Debtor Names (comma separated list of names to exclude)","defaultValue":""},{"type":"dateRange","name":"FILING_DATE","label":"Financing Statement Date","defaultValue":{"start":null,"end":null}},{"type":"dateRange","name":"LAPSE_DATE","label":"Lapse Date","defaultValue":{"start":null,"end":null}},{"type":"text","name":"CITY","label":"Debtor City","defaultValue":""}],"myRecordsFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Approved"},{"value":2,"label":"Pending Online Payment"},{"value":3,"label":"Pending Review"}]},{"type":"select","name":"TYPE","defaultValue":0,"label":"Lien Type","options":[{"value":0,"label":"All"},{"value":1,"label":"UCC"},{"value":2,"label":"EFS"},{"value":3,"label":"Title 71"}]}],"myWorkQueueFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Approved"},{"value":2,"label":"Pending Online Payment"},{"value":3,"label":"Pending Review"},{"value":4,"label":"Pending Print and Mail"},{"value":5,"label":"Rejected"},{"value":6,"label":"Draft"}]},{"type":"select","name":"TYPE","defaultValue":0,"label":"Lien Type","options":[{"value":0,"label":"All"},{"value":1,"label":"UCC"},{"value":2,"label":"EFS"},{"value":3,"label":"Title 71"}]}]},{"label":"Copy Request","component":"copies","parameter":"copies","sourceTypeId":2001,"myRecordsSearch":false,"myWorkQueueSearch":false,"disabled":false,"allowedRoutes":["/forms-manager/","/queue/","/forms/"]},{"label":"Trademark","component":"Trademark","parameter":"trademark","sourceTypeId":810,"showRequestCertificate":true,"searchMustHaveOneOf":["search","EXPIRATION_DATE","FILING_DATE"],"allowEmptySearchTerm":true,"requestCertificateAlternateLabel":"Request Information","fileAmendmentButtonLabel":"Filing Actions","advancedSearchParameters":[{"type":"radio","name":"QUERY_TYPE_ID","defaultValue":1010,"options":[{"value":1010,"label":"Starts with"},{"value":1011,"label":"Contains"},{"value":1012,"label":" Word Contains"}]},{"type":"checkbox","name":"OWNER_SEARCH_YN","defaultValue":false,"label":"Search owners"},{"type":"radio","name":"SERVICE_MARK_YN","label":"Mark Type","defaultValue":"","options":[{"value":"","label":"All Marks"},{"value":"Y","label":"Service Mark"},{"value":"N","label":"Trademark"}]},{"type":"serverSelect","name":"STATUS_ID","optionsSrc":"TYPE_V|TRADEMARK_STATUS_TYPE","label":"Status","placeholder":"All","defaultValue":"0"},{"type":"select","name":"DESIGN_TYPE_ID","options":[{"value":0,"label":"All"},{"value":990,"label":"Words Only"},{"value":991,"label":"Design Only"},{"value":992,"label":"Words and Design"}],"label":"Design Type","defaultValue":"0"},{"type":"dateRange","name":"FILING_DATE","label":"Registered Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}},{"type":"dateRange","name":"EXPIRATION_DATE","label":"Expiration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}}]},{"label":"Business Info Request","component":"InfoRequests","parameter":"info-request","sourceTypeId":167,"allowedRoutes":["/forms-manager/","/queue/","/forms/"]},{"label":"Data Requests","component":"DataRequests","parameter":"data-request","sourceTypeId":0,"allowedRoutes":["/forms-manager/"]},{"label":"CRA","component":"CRA","parameter":"cra","sourceTypeId":157,"myRecordsSearch":false,"searchPlaceholder":"Search by name or registered agent number","allowedRoutes":["/forms-manager/","/forms/","/records/","/queue/","/search/"],"allowEmptySearchTerm":true,"fileAmendmentButtonLabel":"Filing Actions","advancedSearchParameters":[{"type":"radio","name":"QUERY_TYPE_ID","defaultValue":1010,"options":[{"value":1010,"label":"Starts with"},{"value":1011,"label":"Contains"},{"value":1012,"label":" Word Contains"}]},{"type":"dateRange","name":"CRA_DATE","label":"Registration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}},{"type":"select","name":"STATUS_ID","label":"Status","defaultValue":0,"options":[{"value":0,"label":"All"},{"value":121,"label":"Active"},{"value":122,"label":"Inactive"}]},{"type":"select","name":"AGENT_TYPE_ID","label":"Agent Type","defaultValue":0,"options":[{"value":0,"label":"All"},{"value":460,"label":"Registered Agent"},{"value":461,"label":"Commercial Registered Agent"}]}]},{"label":"Farm Bill","component":"FarmBill","parameter":"farm-bill","path":"/lists/farm-bill","sourceTypeId":0,"myRecordsSearch":false,"allowedRules":["/search/"],"disabled":true,"searchDescription":"To perform a search, enter a debtor name. Your search results may include: exact debtor name, variations of that name and any filing that includes your search criteria. Punctuation is ignored.\n\nYou can click on \"Advanced\" to refine your search. Under “Advanced” you can search by crop, year, county and SSN/FEIN. As a registered Farm Bill Buyer with the Montana Secretary of State’s office it is important to maintain the confidentiality of the information contained within the Farm Bill Master List. The Farm Bill Master List reflects personal data, such as Social Security Numbers, which are a key piece of personal identifiable information to assist you in determining the existence of a lien against a specific debtor. The distribution of this information beyond its intended purpose is strictly prohibited.\n\nThe debtor's tax identification number has been hidden for confidentiality reasons. You may continue to search on a tax ID number and return debtors that match your search criteria. The SSN/FEIN must be entered without dashes or spaces.","searchMustHaveOneOf":["search","UCC_FARM_PRODUCT_ID","COUNTY"],"searchPlaceholder":"Search by debtor name","advancedSearchParameters":[{"type":"ServerMultiComplete","label":"Product code name(s)","name":"UCC_FARM_PRODUCT_ID","defaultValue":"","optionsSrc":"UCC_FARM_PRODUCT_V"},{"type":"MultiComplete","label":"Year or Range of Years","name":"YEAR_NUM","optionsSrc":"years","startYear":"1968","defaultValue":[],"preMergeOptions":[{"value":"ALL","label":"All"}]},{"type":"serverSelect","label":"State","name":"STATE","defaultValue":"MONTANA","optionsSrc":"STATE"},{"type":"ServerMultiComplete","label":"County","name":"COUNTY","defaultValue":[],"optionsSrc":"COUNTY","overrideSubOptionsSrcFromParameterName":"STATE"},{"type":"checkbox","name":"TIN_SEARCH_YN","defaultValue":false,"label":"Tax Identification Number Search"},{"type":"checkbox","name":"TIN_SORT_YN","defaultValue":false,"label":"Unique ID Sort"}]}],"SYSTEM_NICKNAME":"Online Services Portal","PAYMENT_METHODS":[{"type":"bypass"},{"type":"iTransact"}],"PAYMENT_ALLOW_AMEX":true,"SYSTEM_ID_LABEL":"System Id","DOUBLE_COLUMN_PUBLIC_LOGIN":true,"INTERNAL_USER_MANAGEMENT":true,"ALLOW_PUBLIC_JSON_IMPORT":false,"MAX_FILE_UPLOAD_SIZE":10000000,"REFUND_TEXT":"","RETURN_TO_HOME_ON_LOGOUT":true,"CURRENT_SOS_NAME":"Christi Jacobsen","LOGO_FILENAME":"mt-sos-logo.png","LOGO_ALT":"Christi Jacobsen, Montana Secretary of State","LOGO_FULL_WIDTH":true,"HOME_HIDE_AUTH_HINT":true,"HOME_TITLE":"Montana Secretary of State","CUSTOM_TAB_TITLE":"Official Montana","HOME_SUBTITLE":"Online Business Services","ENTITY_NAME_CONSENT_DESCRIPTION":"","ALLOW_USER_PROFILE_EDITING":true,"COMPARE_FOREIGN_NAME_IN_ENTITY_NAME_VALIDATION":true,"FOREIGN_NAME_FIELD_NAME":"KIMA_PARENT_NAME_INFO","LOGIN_TITLE":"Montana Secretary of State Online Filing Portal Login","PUBLIC_LOGIN_LABEL":"Username","REVERSE_LOGIN_COLUMNS":true,"LOGIN_SEAL_FILENAME":"seal_white.png","SEPARATE_USERNAME_AND_EMAIL":true,"CREATE_ACCOUNT_BUTTON_ALIGN_LEFT":true,"CREATE_ACCOUNT_BUTTON_TEXT":"CREATE AN ACCOUNT","PASSWORD_CUSTOM_ERROR_TEXT":"The password must meet all requirements","ACCOUNT_CREATED_MESSAGE":"Please check your email to verify your account to login and allow a few minutes for this message to arrive. Check your junk/spam folders if you do not find the email in your inbox.","PUBLIC_LOGIN_PLACEHOLDER":" ","DISABLE_DEFAULT_PAYMENT_RADIO":true,"CUSTOM_RESET_PASSWORD_ERROR_MESSAGE":"Username invalid - no account found","PUBLIC_LOGIN_CREATE_DESCRIPTION":"### Existing User:\n\n  - Enter your username and password to login.  \n\n\n  #### - OR -  \n\n\n\n  - Forgot password? Click 'Reset Password' and follow the prompts.\n  - Forgot username? Click 'Forgot Username' and follow the prompts.  \n\n\n  ### New User:\n  ","LOGIN_HELP_LINK":"https://sosmt.gov/business/how-do-i/","LOGIN_HELP_LINK_TEXT":"Need Help?","FORGOT_USERNAME_TEXT":"Forgot Username?","LOGIN_ACTIVE_DIRECTORY_TEXT":"State User Login","MULTIPLE_LOGIN_METHODS":true,"HAS_ACTIVE_DIRECTORY_LOGIN":true,"RESET_PASSWORD_WITH_USERNAME":true,"DOWNLOAD_LINK":true,"SHOW_USERNAME_ACCOUNT_CREATE":true,"SHOW_SCROLL_DOWN_ARROW":true,"SHOW_ADDRESS_ACCOUNT_CREATE":true,"TWO_COLUMN_ACCOUNT_CREATE":true,"RESET_PASSWORD_TIP":"A link to change your password has been sent to your email. Please allow a few minutes for this message to arrive. Please check your junk/spam folders if you do not find the email in your inbox.","FORGOT_PASSWORD_LINK_TEXT":"Reset Password","PHONE_NUMBER_OPTIONAL_ACCOUNT_CREATE":true,"SHOW_REQUIRED_INDICATOR_ACCOUNT_CREATE":true,"PASSWORD_REQUIREMENTS_ACCOUNT_CREATE":"\n    <ul>\n      <li>MUST contain at least 8 characters (12+ recommended)</li>\n      <li>MUST contain at least one uppercase letter.</li>\n      <li>MUST contain at least one lowercase letter.</li>\n      <li>MUST contain at least one number.</li>\n      <li>MUST contain at least one special character (!”#$%&'()*+,-./:;<=>?</li>\n    </ul>\n  ","ALLOW_CERTIFICATION_REQUEST":true,"ALLOW_PUBLIC_CERTIFICATE_REQUEST":true,"ALLOW_COPY_REQUEST":false,"ALLOW_CORRECTION_STYLING":true,"HIDE_DEPRECATION_WARNING":false,"AMEND_ROUTE_PUBLIC":true,"SEAL_FILENAME":"seal.png","SHOPPING_CART":true,"ALLOW_PAYMENT_UPDATE_WITH_EMPTY_CART":true,"RA_EMAIL":true,"RA_WEBSITE":true,"RA_NO_DEFAULT_TYPE":true,"RA_ADDRESS_LABEL":"Street Address","RA_TYPE_SELECTION_DEFAULT":true,"RA_DEFAULT_TYPE":"460","RA_OVERRIDE_TYPE_WITH_DEFAULT":true,"RA_PRINCIPAL_ADDRESS_AMS":true,"UPLOAD_AND_SUBMIT_HIDE_IF_ONE_OPTION":true,"PAYMENT_PROCESSING_MESSAGE":"Your payment is processing - Do not close your browser or click the back button","CHECKOUT_BUTTON_WHEN_PROCESSING_TEXT":"Processing","EFS_CROP_PICKER_NONE_LABEL":"Lien Duration","DISALLOWED_WIZARD_PIECES":["FormationLocale"],"REPEATER_SHOW_EDIT_BUTTON":true,"DATA_REQUEST_PAGE_TITLE":"Data Requests and Subscriptions","DATA_REQUEST_SIDEBAR_LABEL":"Data Requests & Subscriptions","LOGIN_REDIRECTS_TO_EPASS":false,"LOGIN_REDIRECTS_TO_ACTIVE_DIRECTORY":true,"LOGIN_ACTIVE_DIRECTORY_LINK":true,"FETCH_EDIT_USER_LINK":false,"LISTS_FETCH_AVAILABLE_LISTS":true,"POST_WIZARD_SUBMIT_REDIRECT_URL":"/","PIN_REQUEST_ATTESTATIONS":true,"PIN_REQUEST_DESCRIPTION":"Click **Request PIN** to have a new PIN sent to the account holder's email address on file.","OWNERSHIP_REQUEST_DESCRIPTION":"To become an **authorized user** of this record, a current **AUTHORIZED USER** will need to grant you access. To request access, click **Request Access** below.","PIN_REQUEST_SUCCESS_MESSAGE":"The PIN you have requested for this entity has been sent to the email associated with your user account.  You should receive the PIN in approximately 3-5 minutes, depending on your email service provider.","APOSTILLE_HEADER_LABEL":"Verification Information","APOSTILLE_NUMBER_LABEL":"Apostille/Authentication","APOSTILLE_CITY_STATE_OVERRIDE":"HELENA, MT","APOSTILLE_FILING_DATE_LABEL":"Issue Date","APOSTILLE_CITY_STATE_IN_CERTIFIED":true,"NOTARY_EXISTING_FILING":true,"ALLOW_REVOKE_OWN_ACCESS_ONLY":false,"HIDE_CANCEL_ON_ONETIME_DATA_REQUESTS":true,"DATA_REQUESTS_IN_SHOPPING_CART":true,"WQ_ALLOW_EDIT_PENDING_PAYMENT":true,"WQ_CONFIRM_ON_DELETE":true,"WQ_DELETE_CONFIRM_MESSAGE":"Deleting this filing will forfeit any money already paid to the Secretary of State. This action is permanent and cannot be undone, are you sure you would like to delete?","PASS_ITEM_GUIDS_ON_CHECKOUT":true,"FORM_REVISION_HISTORY":true,"CHECKOUT_DISCLAIMER":"By entering your credit card and/or checking account information you (i) state that **you are an authorized user** of the credit card and/or electronic check and that the associated information entered (e.g., account holder name, account number, billing address) is accurate, (ii) **you authorize payment processor to charge the amount you have requested** to your credit card and/or funding account, and (iii) **acknowledge if a charge is declined or reversed you may also be assessed a customary charge** by the payment processor for such transactions.","FARM_BILL_SEARCH_CONFIDENTIAL":"As a registered Farm Bill Buyer with the Montana Secretary of State’s office it is important to maintain the confidentiality of the information contained within the Farm Bill Master List. The Farm Bill Master List reflects personal data, such as Social Security Numbers, which are a key piece of personal identifiable information to assist you in determining the existence of a lien against a specific debtor. The distribution of this information beyond its intended purpose is strictly prohibited.\n\n**The debtor's tax identification number has been hidden for confidentiality reasons. You may continue to search on a tax ID number and return debtors that match your search criteria. The SSN/FEIN must be entered without dashes or spaces.  If you need access to the tax identification number to clearly identify the debtor, please contact the UCC unit at (406) 444-3665.**","VIEW_HISTORY_BUTTON_ALT_TEXT":"View Filings","WIZARD_ERROR_TITLE_MESSAGE":"Form Error","FARM_BILL_SEARCH_INTERACTIVE":true,"USE_FARM_BILL_API":true,"DISALLOW_ASSIGN_SELF_AS_RA":true,"DISALLOW_ASSIGN_SELF_AS_PRINCIPAL":true,"USE_TRADEMARK_OWNER_VALIDATION":true,"USE_ALTERNATIVE_FOREIGN_ADDRESS_LABELS":true,"MY_RECEIPTS_FILTER":[{"type":"dateRange","name":"DATE_RANGE","label":"Date range","defaultValue":{"start":null,"end":null}},{"type":"text","name":"REF_NUM","defaultValue":"","label":"Reference Number"},{"type":"text","name":"RECEIPT_NUM","defaultValue":"","label":"Receipt Id"},{"type":"text","name":"AMOUNT","defaultValue":"","label":"Amount"},{"type":"select","name":"TYPE","defaultValue":"","label":"Payment Type","options":[{"value":"","label":"All"},{"value":"CC","label":"Credit Card"},{"value":"Check","label":"Check"}]}],"MY_RECEIPTS_SHOW_IN_SIDEBAR":true,"SHOW_MY_RECEIPTS_HELPER_TEXT":true,"MY_RECEIPTS_HELPER_LABEL":"About Receipt Search","MY_RECEIPTS_HELPER_TEXT":"You can search for receipts based on their descriptions, including the items paid for on the receipt. Use the filters to search for or filter specific information.","FARM_BILL_SUBLINK":{"label":"Farm Bill","component":"FarmBill","parameter":"farm-bill","path":"/lists/farm-bill","sourceTypeId":0,"myRecordsSearch":false,"allowedRules":["/search/"],"disabled":true,"searchDescription":"To perform a search, enter a debtor name. Your search results may include: exact debtor name, variations of that name and any filing that includes your search criteria. Punctuation is ignored.\n\nYou can click on \"Advanced\" to refine your search. Under “Advanced” you can search by crop, year, county and SSN/FEIN. As a registered Farm Bill Buyer with the Montana Secretary of State’s office it is important to maintain the confidentiality of the information contained within the Farm Bill Master List. The Farm Bill Master List reflects personal data, such as Social Security Numbers, which are a key piece of personal identifiable information to assist you in determining the existence of a lien against a specific debtor. The distribution of this information beyond its intended purpose is strictly prohibited.\n\nThe debtor's tax identification number has been hidden for confidentiality reasons. You may continue to search on a tax ID number and return debtors that match your search criteria. The SSN/FEIN must be entered without dashes or spaces.","searchMustHaveOneOf":["search","UCC_FARM_PRODUCT_ID","COUNTY"],"searchPlaceholder":"Search by debtor name","advancedSearchParameters":[{"type":"ServerMultiComplete","label":"Product code name(s)","name":"UCC_FARM_PRODUCT_ID","defaultValue":"","optionsSrc":"UCC_FARM_PRODUCT_V"},{"type":"MultiComplete","label":"Year or Range of Years","name":"YEAR_NUM","optionsSrc":"years","startYear":"1968","defaultValue":[],"preMergeOptions":[{"value":"ALL","label":"All"}]},{"type":"serverSelect","label":"State","name":"STATE","defaultValue":"MONTANA","optionsSrc":"STATE"},{"type":"ServerMultiComplete","label":"County","name":"COUNTY","defaultValue":[],"optionsSrc":"COUNTY","overrideSubOptionsSrcFromParameterName":"STATE"},{"type":"checkbox","name":"TIN_SEARCH_YN","defaultValue":false,"label":"Tax Identification Number Search"},{"type":"checkbox","name":"TIN_SORT_YN","defaultValue":false,"label":"Unique ID Sort"}]},"ALLOW_ADDRESS_VALIDATION_BYPASS_OPTION":true,"DEFAULT_ADDRESS_VALIDATION_BYPASS_OPTION_CHECKED":true}).WIZARD_ALT_HELP_STYLE ? "alt-style" : ""),
	                              onClick: this.toggleHelpModal,
	                              'aria-label': 'Toggle additional help'
	                            },
	                            ({"NODE_ENV":"production","BUILD_DATE":"2025-08-27T15:15:31.687Z","BUILD_NUMBER":"Not Provided","GIT_VERSION":"v1.3.0-381-ga81e29b08","GIT_COMMIT_HASH":"a81e29b085c9268ffd96c78eb734365802722741","GIT_BRANCH":"beta","PUBLIC_URL":"","STATE_ABBR":"MT","STATE_NAME":"Montana","STATE_ORG_TITLE":"Secretary of State","LOGIN_HEADER_IMG_PATH":"","HOME_IMG_FILENAME":"montana.jpg","FAVICON_FILE_NAME":"favicon.ico","ALLOW_E_SIGN_ON_CORRECTIONS":true,"THIRD_PARTY_SIGNING_ALLOWED":false,"MY_ACCOUNT_SAVE_AND_CLOSE_BUTTON":true,"IE_DEPRECATED_MESSAGE":"Internet Explorer is not supported. Please select a supported browser below to access this website.","ADDITIONAL_ROUTES":{"dataRequests":true,"farmBill":true,"apostille":true,"externalHelp":"https://sosmt.gov/business/help-center/","systemAdministration":[{"title":"Saved Payments","parameter":"saved-payments","componentName":"SavedPayments"}]},"SUBROUTES":[{"label":"Business","component":"Business","parameter":"business","myWorkQueueSearch":false,"sourceTypeId":54,"searchMustHaveOneOf":["FILING_TYPE_ID","STATUS_ID","STATE","search"],"serverWebSearchDescription":true,"serverWorkQueueDescription":true,"serverMyRecordsDescription":true,"searchPlaceholder":"Search by name or filing number (X########)","allowEmptySearchTerm":true,"requestCertificateAlternateLabel":"Request Information","fileAmendmentButtonLabel":"Filing Actions","advancedSearchParameters":[{"type":"radio","name":"QUERY_TYPE_ID","defaultValue":1010,"options":[{"value":1010,"label":"Starts with"},{"value":1011,"label":"Contains"},{"value":1012,"label":" Word Contains"}]},{"type":"serverSelect","name":"FILING_TYPE_ID","optionsSrc":"FILING_TYPES","label":"Entity Type","placeholder":"All","defaultValue":"0"},{"type":"serverSelect","name":"FILING_SUBTYPE_ID","optionsSrc":"FILING_SUBTYPES","label":"Entity Subtype","overrideSubOptionsSrcFromParameterName":"FILING_TYPE_ID","placeholder":"All","defaultValue":"0"},{"type":"serverSelect","name":"STATUS_ID","optionsSrc":"FILING_STATUS_WITHOUT_ALL","label":"Status","placeholder":"All","defaultValue":"0"},{"type":"serverSelect","name":"STATE","optionsSrc":"STATE","label":"State","placeholder":"All","defaultValue":""},{"type":"serverSelect","name":"COUNTY","optionsSrc":"COUNTY_SUBOPTION","label":"County","overrideSubOptionsSrcFromParameterName":"STATE","placeholder":"All","defaultValue":""},{"type":"checkbox","name":"CRA_SEARCH_YN","defaultValue":false,"label":"Search by Registered Agent PID"},{"type":"dateRange","name":"FILING_DATE","label":"Registration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}},{"type":"dateRange","name":"EXPIRATION_DATE","label":"Expiration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}}],"myRecordsFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Active"},{"value":2,"label":"Inactive"},{"value":3,"label":"Pending"}]},{"type":"dateRange","name":"DATE_RANGE","label":"Date range","defaultValue":{"start":null,"end":null}}],"myWorkQueueFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Approved"},{"value":2,"label":"Pending Online Payment"},{"value":3,"label":"Pending Review"},{"value":4,"label":"Needs Correction"},{"value":5,"label":"Rejected"},{"value":6,"label":"Draft"}]},{"type":"dateRange","name":"DATE_RANGE","label":"Date range","defaultValue":{"start":null,"end":null}}]},{"label":"Notary","component":"Notary","parameter":"notary","sourceTypeId":850,"myWorkQueueSearch":false,"allowEmptySearchTerm":true,"requestCertificateAlternateLabel":"Download Certificate","fileAmendmentButtonLabel":"Filing Actions","hideNameRequestCertificate":true,"hideAddressRequestCertificate":true,"hideRecordUserManagment":true,"searchPlaceholder":"Search by name or commission number","searchMustHaveOneOf":["CITY","search","SERVICE_TYPE"],"advancedParametersStartOpen":true,"searchIsSortable":true,"advancedSearchParameters":[{"type":"radio","name":"STARTS_WITH_YN","defaultValue":false,"options":[{"value":true,"label":"Starts with"},{"value":false,"label":"Contains"}]},{"type":"checkbox","name":"ACTIVE_ONLY_YN","defaultValue":true,"label":"Active entities only"},{"type":"text","name":"CITY","defaultValue":"","label":"City"},{"type":"select","name":"SERVICE_TYPE","label":"Special Services Offered","defaultValue":0,"options":[{"value":0,"label":"(N/A)"},{"value":6165,"label":"In-Person Electronic Notarization (IPEN)"},{"value":6166,"label":"Remote Online Notarization (RON)"},{"value":6167,"label":"Mobile Notary Services"},{"value":6168,"label":"Remote Ink Notarization (RIN)"}]}]},{"label":"Apostille","component":"Apostille","parameter":"apostille","sourceTypeId":720,"myRecordsSearch":false,"myWorkQueueSearch":false,"disabled":false,"allowedRoutes":["/forms-manager/","/queue/","/forms/"]},{"label":"Liens","component":"UCC","parameter":"ucc","sourceTypeId":1999,"myRecordsSearch":true,"myWorkQueueSearch":true,"fileAmendmentButtonLabel":"Filing Actions","searchPlaceholder":"Search by name or file number","disabled":false,"serverWebSearchDescription":true,"myRecordsDescription":"","workQueueDescription":"","searchDescription":"","hideRecordUserManagment":true,"searchLiensCheckout":false,"advancedSearchParameters":[{"type":"radio","name":"STARTS_WITH_YN","defaultValue":false,"options":[{"value":true,"label":"Starts with"},{"value":false,"label":"Contains"}]},{"type":"select","name":"STATUS","defaultValue":"ALL","label":"Status","options":[{"value":"ACTIVE_UNLAPSED","label":"Active (unlapsed)"},{"value":"ACTIVE_LAPSED_UNLAPSED","label":"Active (lapsed and unlapsed)"}]},{"type":"text","name":"EXCLUDE_VALUES","label":"Exclude Debtor Names (comma separated list of names to exclude)","defaultValue":""},{"type":"dateRange","name":"FILING_DATE","label":"Financing Statement Date","defaultValue":{"start":null,"end":null}},{"type":"dateRange","name":"LAPSE_DATE","label":"Lapse Date","defaultValue":{"start":null,"end":null}},{"type":"text","name":"CITY","label":"Debtor City","defaultValue":""}],"myRecordsFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Approved"},{"value":2,"label":"Pending Online Payment"},{"value":3,"label":"Pending Review"}]},{"type":"select","name":"TYPE","defaultValue":0,"label":"Lien Type","options":[{"value":0,"label":"All"},{"value":1,"label":"UCC"},{"value":2,"label":"EFS"},{"value":3,"label":"Title 71"}]}],"myWorkQueueFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Approved"},{"value":2,"label":"Pending Online Payment"},{"value":3,"label":"Pending Review"},{"value":4,"label":"Pending Print and Mail"},{"value":5,"label":"Rejected"},{"value":6,"label":"Draft"}]},{"type":"select","name":"TYPE","defaultValue":0,"label":"Lien Type","options":[{"value":0,"label":"All"},{"value":1,"label":"UCC"},{"value":2,"label":"EFS"},{"value":3,"label":"Title 71"}]}]},{"label":"Copy Request","component":"copies","parameter":"copies","sourceTypeId":2001,"myRecordsSearch":false,"myWorkQueueSearch":false,"disabled":false,"allowedRoutes":["/forms-manager/","/queue/","/forms/"]},{"label":"Trademark","component":"Trademark","parameter":"trademark","sourceTypeId":810,"showRequestCertificate":true,"searchMustHaveOneOf":["search","EXPIRATION_DATE","FILING_DATE"],"allowEmptySearchTerm":true,"requestCertificateAlternateLabel":"Request Information","fileAmendmentButtonLabel":"Filing Actions","advancedSearchParameters":[{"type":"radio","name":"QUERY_TYPE_ID","defaultValue":1010,"options":[{"value":1010,"label":"Starts with"},{"value":1011,"label":"Contains"},{"value":1012,"label":" Word Contains"}]},{"type":"checkbox","name":"OWNER_SEARCH_YN","defaultValue":false,"label":"Search owners"},{"type":"radio","name":"SERVICE_MARK_YN","label":"Mark Type","defaultValue":"","options":[{"value":"","label":"All Marks"},{"value":"Y","label":"Service Mark"},{"value":"N","label":"Trademark"}]},{"type":"serverSelect","name":"STATUS_ID","optionsSrc":"TYPE_V|TRADEMARK_STATUS_TYPE","label":"Status","placeholder":"All","defaultValue":"0"},{"type":"select","name":"DESIGN_TYPE_ID","options":[{"value":0,"label":"All"},{"value":990,"label":"Words Only"},{"value":991,"label":"Design Only"},{"value":992,"label":"Words and Design"}],"label":"Design Type","defaultValue":"0"},{"type":"dateRange","name":"FILING_DATE","label":"Registered Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}},{"type":"dateRange","name":"EXPIRATION_DATE","label":"Expiration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}}]},{"label":"Business Info Request","component":"InfoRequests","parameter":"info-request","sourceTypeId":167,"allowedRoutes":["/forms-manager/","/queue/","/forms/"]},{"label":"Data Requests","component":"DataRequests","parameter":"data-request","sourceTypeId":0,"allowedRoutes":["/forms-manager/"]},{"label":"CRA","component":"CRA","parameter":"cra","sourceTypeId":157,"myRecordsSearch":false,"searchPlaceholder":"Search by name or registered agent number","allowedRoutes":["/forms-manager/","/forms/","/records/","/queue/","/search/"],"allowEmptySearchTerm":true,"fileAmendmentButtonLabel":"Filing Actions","advancedSearchParameters":[{"type":"radio","name":"QUERY_TYPE_ID","defaultValue":1010,"options":[{"value":1010,"label":"Starts with"},{"value":1011,"label":"Contains"},{"value":1012,"label":" Word Contains"}]},{"type":"dateRange","name":"CRA_DATE","label":"Registration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}},{"type":"select","name":"STATUS_ID","label":"Status","defaultValue":0,"options":[{"value":0,"label":"All"},{"value":121,"label":"Active"},{"value":122,"label":"Inactive"}]},{"type":"select","name":"AGENT_TYPE_ID","label":"Agent Type","defaultValue":0,"options":[{"value":0,"label":"All"},{"value":460,"label":"Registered Agent"},{"value":461,"label":"Commercial Registered Agent"}]}]},{"label":"Farm Bill","component":"FarmBill","parameter":"farm-bill","path":"/lists/farm-bill","sourceTypeId":0,"myRecordsSearch":false,"allowedRules":["/search/"],"disabled":true,"searchDescription":"To perform a search, enter a debtor name. Your search results may include: exact debtor name, variations of that name and any filing that includes your search criteria. Punctuation is ignored.\n\nYou can click on \"Advanced\" to refine your search. Under “Advanced” you can search by crop, year, county and SSN/FEIN. As a registered Farm Bill Buyer with the Montana Secretary of State’s office it is important to maintain the confidentiality of the information contained within the Farm Bill Master List. The Farm Bill Master List reflects personal data, such as Social Security Numbers, which are a key piece of personal identifiable information to assist you in determining the existence of a lien against a specific debtor. The distribution of this information beyond its intended purpose is strictly prohibited.\n\nThe debtor's tax identification number has been hidden for confidentiality reasons. You may continue to search on a tax ID number and return debtors that match your search criteria. The SSN/FEIN must be entered without dashes or spaces.","searchMustHaveOneOf":["search","UCC_FARM_PRODUCT_ID","COUNTY"],"searchPlaceholder":"Search by debtor name","advancedSearchParameters":[{"type":"ServerMultiComplete","label":"Product code name(s)","name":"UCC_FARM_PRODUCT_ID","defaultValue":"","optionsSrc":"UCC_FARM_PRODUCT_V"},{"type":"MultiComplete","label":"Year or Range of Years","name":"YEAR_NUM","optionsSrc":"years","startYear":"1968","defaultValue":[],"preMergeOptions":[{"value":"ALL","label":"All"}]},{"type":"serverSelect","label":"State","name":"STATE","defaultValue":"MONTANA","optionsSrc":"STATE"},{"type":"ServerMultiComplete","label":"County","name":"COUNTY","defaultValue":[],"optionsSrc":"COUNTY","overrideSubOptionsSrcFromParameterName":"STATE"},{"type":"checkbox","name":"TIN_SEARCH_YN","defaultValue":false,"label":"Tax Identification Number Search"},{"type":"checkbox","name":"TIN_SORT_YN","defaultValue":false,"label":"Unique ID Sort"}]}],"SYSTEM_NICKNAME":"Online Services Portal","PAYMENT_METHODS":[{"type":"bypass"},{"type":"iTransact"}],"PAYMENT_ALLOW_AMEX":true,"SYSTEM_ID_LABEL":"System Id","DOUBLE_COLUMN_PUBLIC_LOGIN":true,"INTERNAL_USER_MANAGEMENT":true,"ALLOW_PUBLIC_JSON_IMPORT":false,"MAX_FILE_UPLOAD_SIZE":10000000,"REFUND_TEXT":"","RETURN_TO_HOME_ON_LOGOUT":true,"CURRENT_SOS_NAME":"Christi Jacobsen","LOGO_FILENAME":"mt-sos-logo.png","LOGO_ALT":"Christi Jacobsen, Montana Secretary of State","LOGO_FULL_WIDTH":true,"HOME_HIDE_AUTH_HINT":true,"HOME_TITLE":"Montana Secretary of State","CUSTOM_TAB_TITLE":"Official Montana","HOME_SUBTITLE":"Online Business Services","ENTITY_NAME_CONSENT_DESCRIPTION":"","ALLOW_USER_PROFILE_EDITING":true,"COMPARE_FOREIGN_NAME_IN_ENTITY_NAME_VALIDATION":true,"FOREIGN_NAME_FIELD_NAME":"KIMA_PARENT_NAME_INFO","LOGIN_TITLE":"Montana Secretary of State Online Filing Portal Login","PUBLIC_LOGIN_LABEL":"Username","REVERSE_LOGIN_COLUMNS":true,"LOGIN_SEAL_FILENAME":"seal_white.png","SEPARATE_USERNAME_AND_EMAIL":true,"CREATE_ACCOUNT_BUTTON_ALIGN_LEFT":true,"CREATE_ACCOUNT_BUTTON_TEXT":"CREATE AN ACCOUNT","PASSWORD_CUSTOM_ERROR_TEXT":"The password must meet all requirements","ACCOUNT_CREATED_MESSAGE":"Please check your email to verify your account to login and allow a few minutes for this message to arrive. Check your junk/spam folders if you do not find the email in your inbox.","PUBLIC_LOGIN_PLACEHOLDER":" ","DISABLE_DEFAULT_PAYMENT_RADIO":true,"CUSTOM_RESET_PASSWORD_ERROR_MESSAGE":"Username invalid - no account found","PUBLIC_LOGIN_CREATE_DESCRIPTION":"### Existing User:\n\n  - Enter your username and password to login.  \n\n\n  #### - OR -  \n\n\n\n  - Forgot password? Click 'Reset Password' and follow the prompts.\n  - Forgot username? Click 'Forgot Username' and follow the prompts.  \n\n\n  ### New User:\n  ","LOGIN_HELP_LINK":"https://sosmt.gov/business/how-do-i/","LOGIN_HELP_LINK_TEXT":"Need Help?","FORGOT_USERNAME_TEXT":"Forgot Username?","LOGIN_ACTIVE_DIRECTORY_TEXT":"State User Login","MULTIPLE_LOGIN_METHODS":true,"HAS_ACTIVE_DIRECTORY_LOGIN":true,"RESET_PASSWORD_WITH_USERNAME":true,"DOWNLOAD_LINK":true,"SHOW_USERNAME_ACCOUNT_CREATE":true,"SHOW_SCROLL_DOWN_ARROW":true,"SHOW_ADDRESS_ACCOUNT_CREATE":true,"TWO_COLUMN_ACCOUNT_CREATE":true,"RESET_PASSWORD_TIP":"A link to change your password has been sent to your email. Please allow a few minutes for this message to arrive. Please check your junk/spam folders if you do not find the email in your inbox.","FORGOT_PASSWORD_LINK_TEXT":"Reset Password","PHONE_NUMBER_OPTIONAL_ACCOUNT_CREATE":true,"SHOW_REQUIRED_INDICATOR_ACCOUNT_CREATE":true,"PASSWORD_REQUIREMENTS_ACCOUNT_CREATE":"\n    <ul>\n      <li>MUST contain at least 8 characters (12+ recommended)</li>\n      <li>MUST contain at least one uppercase letter.</li>\n      <li>MUST contain at least one lowercase letter.</li>\n      <li>MUST contain at least one number.</li>\n      <li>MUST contain at least one special character (!”#$%&'()*+,-./:;<=>?</li>\n    </ul>\n  ","ALLOW_CERTIFICATION_REQUEST":true,"ALLOW_PUBLIC_CERTIFICATE_REQUEST":true,"ALLOW_COPY_REQUEST":false,"ALLOW_CORRECTION_STYLING":true,"HIDE_DEPRECATION_WARNING":false,"AMEND_ROUTE_PUBLIC":true,"SEAL_FILENAME":"seal.png","SHOPPING_CART":true,"ALLOW_PAYMENT_UPDATE_WITH_EMPTY_CART":true,"RA_EMAIL":true,"RA_WEBSITE":true,"RA_NO_DEFAULT_TYPE":true,"RA_ADDRESS_LABEL":"Street Address","RA_TYPE_SELECTION_DEFAULT":true,"RA_DEFAULT_TYPE":"460","RA_OVERRIDE_TYPE_WITH_DEFAULT":true,"RA_PRINCIPAL_ADDRESS_AMS":true,"UPLOAD_AND_SUBMIT_HIDE_IF_ONE_OPTION":true,"PAYMENT_PROCESSING_MESSAGE":"Your payment is processing - Do not close your browser or click the back button","CHECKOUT_BUTTON_WHEN_PROCESSING_TEXT":"Processing","EFS_CROP_PICKER_NONE_LABEL":"Lien Duration","DISALLOWED_WIZARD_PIECES":["FormationLocale"],"REPEATER_SHOW_EDIT_BUTTON":true,"DATA_REQUEST_PAGE_TITLE":"Data Requests and Subscriptions","DATA_REQUEST_SIDEBAR_LABEL":"Data Requests & Subscriptions","LOGIN_REDIRECTS_TO_EPASS":false,"LOGIN_REDIRECTS_TO_ACTIVE_DIRECTORY":true,"LOGIN_ACTIVE_DIRECTORY_LINK":true,"FETCH_EDIT_USER_LINK":false,"LISTS_FETCH_AVAILABLE_LISTS":true,"POST_WIZARD_SUBMIT_REDIRECT_URL":"/","PIN_REQUEST_ATTESTATIONS":true,"PIN_REQUEST_DESCRIPTION":"Click **Request PIN** to have a new PIN sent to the account holder's email address on file.","OWNERSHIP_REQUEST_DESCRIPTION":"To become an **authorized user** of this record, a current **AUTHORIZED USER** will need to grant you access. To request access, click **Request Access** below.","PIN_REQUEST_SUCCESS_MESSAGE":"The PIN you have requested for this entity has been sent to the email associated with your user account.  You should receive the PIN in approximately 3-5 minutes, depending on your email service provider.","APOSTILLE_HEADER_LABEL":"Verification Information","APOSTILLE_NUMBER_LABEL":"Apostille/Authentication","APOSTILLE_CITY_STATE_OVERRIDE":"HELENA, MT","APOSTILLE_FILING_DATE_LABEL":"Issue Date","APOSTILLE_CITY_STATE_IN_CERTIFIED":true,"NOTARY_EXISTING_FILING":true,"ALLOW_REVOKE_OWN_ACCESS_ONLY":false,"HIDE_CANCEL_ON_ONETIME_DATA_REQUESTS":true,"DATA_REQUESTS_IN_SHOPPING_CART":true,"WQ_ALLOW_EDIT_PENDING_PAYMENT":true,"WQ_CONFIRM_ON_DELETE":true,"WQ_DELETE_CONFIRM_MESSAGE":"Deleting this filing will forfeit any money already paid to the Secretary of State. This action is permanent and cannot be undone, are you sure you would like to delete?","PASS_ITEM_GUIDS_ON_CHECKOUT":true,"FORM_REVISION_HISTORY":true,"CHECKOUT_DISCLAIMER":"By entering your credit card and/or checking account information you (i) state that **you are an authorized user** of the credit card and/or electronic check and that the associated information entered (e.g., account holder name, account number, billing address) is accurate, (ii) **you authorize payment processor to charge the amount you have requested** to your credit card and/or funding account, and (iii) **acknowledge if a charge is declined or reversed you may also be assessed a customary charge** by the payment processor for such transactions.","FARM_BILL_SEARCH_CONFIDENTIAL":"As a registered Farm Bill Buyer with the Montana Secretary of State’s office it is important to maintain the confidentiality of the information contained within the Farm Bill Master List. The Farm Bill Master List reflects personal data, such as Social Security Numbers, which are a key piece of personal identifiable information to assist you in determining the existence of a lien against a specific debtor. The distribution of this information beyond its intended purpose is strictly prohibited.\n\n**The debtor's tax identification number has been hidden for confidentiality reasons. You may continue to search on a tax ID number and return debtors that match your search criteria. The SSN/FEIN must be entered without dashes or spaces.  If you need access to the tax identification number to clearly identify the debtor, please contact the UCC unit at (406) 444-3665.**","VIEW_HISTORY_BUTTON_ALT_TEXT":"View Filings","WIZARD_ERROR_TITLE_MESSAGE":"Form Error","FARM_BILL_SEARCH_INTERACTIVE":true,"USE_FARM_BILL_API":true,"DISALLOW_ASSIGN_SELF_AS_RA":true,"DISALLOW_ASSIGN_SELF_AS_PRINCIPAL":true,"USE_TRADEMARK_OWNER_VALIDATION":true,"USE_ALTERNATIVE_FOREIGN_ADDRESS_LABELS":true,"MY_RECEIPTS_FILTER":[{"type":"dateRange","name":"DATE_RANGE","label":"Date range","defaultValue":{"start":null,"end":null}},{"type":"text","name":"REF_NUM","defaultValue":"","label":"Reference Number"},{"type":"text","name":"RECEIPT_NUM","defaultValue":"","label":"Receipt Id"},{"type":"text","name":"AMOUNT","defaultValue":"","label":"Amount"},{"type":"select","name":"TYPE","defaultValue":"","label":"Payment Type","options":[{"value":"","label":"All"},{"value":"CC","label":"Credit Card"},{"value":"Check","label":"Check"}]}],"MY_RECEIPTS_SHOW_IN_SIDEBAR":true,"SHOW_MY_RECEIPTS_HELPER_TEXT":true,"MY_RECEIPTS_HELPER_LABEL":"About Receipt Search","MY_RECEIPTS_HELPER_TEXT":"You can search for receipts based on their descriptions, including the items paid for on the receipt. Use the filters to search for or filter specific information.","FARM_BILL_SUBLINK":{"label":"Farm Bill","component":"FarmBill","parameter":"farm-bill","path":"/lists/farm-bill","sourceTypeId":0,"myRecordsSearch":false,"allowedRules":["/search/"],"disabled":true,"searchDescription":"To perform a search, enter a debtor name. Your search results may include: exact debtor name, variations of that name and any filing that includes your search criteria. Punctuation is ignored.\n\nYou can click on \"Advanced\" to refine your search. Under “Advanced” you can search by crop, year, county and SSN/FEIN. As a registered Farm Bill Buyer with the Montana Secretary of State’s office it is important to maintain the confidentiality of the information contained within the Farm Bill Master List. The Farm Bill Master List reflects personal data, such as Social Security Numbers, which are a key piece of personal identifiable information to assist you in determining the existence of a lien against a specific debtor. The distribution of this information beyond its intended purpose is strictly prohibited.\n\nThe debtor's tax identification number has been hidden for confidentiality reasons. You may continue to search on a tax ID number and return debtors that match your search criteria. The SSN/FEIN must be entered without dashes or spaces.","searchMustHaveOneOf":["search","UCC_FARM_PRODUCT_ID","COUNTY"],"searchPlaceholder":"Search by debtor name","advancedSearchParameters":[{"type":"ServerMultiComplete","label":"Product code name(s)","name":"UCC_FARM_PRODUCT_ID","defaultValue":"","optionsSrc":"UCC_FARM_PRODUCT_V"},{"type":"MultiComplete","label":"Year or Range of Years","name":"YEAR_NUM","optionsSrc":"years","startYear":"1968","defaultValue":[],"preMergeOptions":[{"value":"ALL","label":"All"}]},{"type":"serverSelect","label":"State","name":"STATE","defaultValue":"MONTANA","optionsSrc":"STATE"},{"type":"ServerMultiComplete","label":"County","name":"COUNTY","defaultValue":[],"optionsSrc":"COUNTY","overrideSubOptionsSrcFromParameterName":"STATE"},{"type":"checkbox","name":"TIN_SEARCH_YN","defaultValue":false,"label":"Tax Identification Number Search"},{"type":"checkbox","name":"TIN_SORT_YN","defaultValue":false,"label":"Unique ID Sort"}]},"ALLOW_ADDRESS_VALIDATION_BYPASS_OPTION":true,"DEFAULT_ADDRESS_VALIDATION_BYPASS_OPTION_CHECKED":true}).WIZARD_ALT_HELP_STYLE ? 'Help ' : "",
	                            '?'
	                          )
	                        ) : null : null,
	                        !isInSignatureMode ? steps[activeStep].sections.map(function (section, i) {
	                          return section.type !== 'confirm' ? _react2.default.createElement(Section, Object.assign({}, section, {
	                            allFields: wizard.fields,
	                            index: i,
	                            zIndex: steps[activeStep].sections.length - i + 1,
	                            key: section.sectionId
	                          })) : null;
	                        }) : _react2.default.createElement(_ThirdPartySignatures2.default, null)
	                      ) : null
	                    )
	                  )
	                )
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return Wizard;
	}(_react.Component);
	
	Wizard = (0, _reactRedux.connect)(function (state) {
	  var steps = state.wizard.wizard.steps;
	  var sections = state.wizard.wizard.sections;
	  var fields = state.wizard.wizard.fields;
	
	  var orderedSteps = state.wizard.wizard.stepOrder.map(function (stepId) {
	    return Object.assign({}, steps[stepId], {
	      sections: steps[stepId].sectionOrder.map(function (sectionId) {
	        return Object.assign({}, sections[sectionId], {
	          fields: sections[sectionId].fieldOrder.map(function (fieldId) {
	            return fields[fieldId];
	          })
	        });
	      })
	    });
	  });
	  return {
	    steps: orderedSteps,
	    wizard: state.wizard.wizard,
	    title: state.wizard.wizard.title,
	    activeStep: state.wizard.activeStep,
	    targetStep: state.wizard.targetStep,
	    validating: state.wizard.validating,
	    loadingWizard: state.wizard.loadingWizard,
	    helpShown: state.wizard.helpShown,
	    readOnly: state.wizard.readOnly,
	    previewing: state.wizard.preview,
	    noLoginRequired: state.wizard.wizard.noLoginRequired,
	    authenticated: state.auth.loggedIn && ['WEB', 'ADMIN_WEB'].includes(state.auth.USER_GROUP),
	    location: state.router.location,
	    mode: state.wizard.mode
	  };
	}, { toggleHelpModal: _WizardActions.toggleHelpModal, clearInfoMessages: _WizardActions.clearInfoMessages, setActiveStep: _WizardActions.setActiveStep })(Wizard);
	exports.default = Wizard;
	
	var StepButton = function (_Component3) {
	  _inherits(StepButton, _Component3);
	
	  function StepButton() {
	    var _ref7;
	
	    var _temp2, _this4, _ret2;
	
	    _classCallCheck(this, StepButton);
	
	    for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
	      args[_key2] = arguments[_key2];
	    }
	
	    return _ret2 = (_temp2 = (_this4 = _possibleConstructorReturn(this, (_ref7 = StepButton.__proto__ || Object.getPrototypeOf(StepButton)).call.apply(_ref7, [this].concat(args))), _this4), _this4.setActiveStep = function () {
	      if (_this4.props.readOnly) {
	        _this4.props.setActiveStep(_this4.props.stepIndex);
	      } else {
	        _this4.props.validateAndSetActiveStep(_this4.props.stepIndex);
	      }
	    }, _temp2), _possibleConstructorReturn(_this4, _ret2);
	  }
	
	  _createClass(StepButton, [{
	    key: 'render',
	    value: function render() {
	      var _props3 = this.props,
	          active = _props3.active,
	          isValid = _props3.isValid,
	          title = _props3.title,
	          readOnly = _props3.readOnly,
	          stepIndex = _props3.stepIndex,
	          totalSteps = _props3.totalSteps;
	
	      return _react2.default.createElement(
	        'button',
	        {
	          className: (active ? 'active ' : ' ') + (isValid === false ? 'step-invalid' : ''),
	          onClick: this.setActiveStep,
	          'aria-invalid': !isValid
	        },
	        _react2.default.createElement(
	          'div',
	          { className: isValid || readOnly ? 'step-check step-valid' : 'step-check' },
	          isValid === false && _react2.default.createElement('div', { className: 'invalid-icon' })
	        ),
	        title,
	        _react2.default.createElement(
	          'span',
	          { className: 'visually-hidden' },
	          'Step ' + (stepIndex + 1) + ' of ' + totalSteps,
	          isValid === false ? "There are errors on this step" : ""
	        )
	      );
	    }
	  }]);
	
	  return StepButton;
	}(_react.Component);
	
	StepButton = (0, _reactRedux.connect)(function (state) {
	  return {
	    readOnly: state.wizard.readOnly
	  };
	}, { validateAndSetActiveStep: _WizardActions.validateAndSetActiveStep, setActiveStep: _WizardActions.setActiveStep })(StepButton);
	
	var Sidebar = function Sidebar(_ref8) {
	  var children = _ref8.children;
	  return _react2.default.createElement(
	    'div',
	    { className: 'sidebar' },
	    children
	  );
	};
	
	var Body = function (_Component4) {
	  _inherits(Body, _Component4);
	
	  function Body(props) {
	    _classCallCheck(this, Body);
	
	    var _this5 = _possibleConstructorReturn(this, (Body.__proto__ || Object.getPrototypeOf(Body)).call(this, props));
	
	    _this5.componentDidMount = function () {
	      if (true) {
	        _this5.handleIsMobile();
	      }
	    };
	
	    _this5.handleIsMobile = function () {
	      if (true) {
	
	        var ret = document.body.clientWidth < 600;
	        _this5.setState({
	          isMobile: ret
	        });
	      }
	    };
	
	    _this5.scrollToTop = function () {
	      _this5.wrapper.scrollTop = 0;
	    };
	
	    _this5.state = {
	      reachedBottom: false,
	      isMobile: false
	    };
	    return _this5;
	  }
	
	  _createClass(Body, [{
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate() {
	      if (true) {
	        var element = this.state.isMobile === true ? document.getElementById('wizard-body-scrollArrow-container-mobile') : document.getElementById('wizard-body-scrollArrow-container');
	        var position = element.scrollHeight - (element.clientHeight + element.scrollTop);
	
	        if (position < 10 && this.state.isScrollable) {
	          this.setState(Object.assign({}, this.state, { isScrollable: false }));
	        } else if (!this.state.isScrollable && position >= 10) {
	          this.setState(Object.assign({}, this.state, { isScrollable: true }));
	        }
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this6 = this;
	
	      var _props4 = this.props,
	          children = _props4.children,
	          validating = _props4.validating,
	          isFullWidth = _props4.isFullWidth;
	
	
	      var handleScroll = function handleScroll(e) {
	        if (true) {
	          var bottom = e.target.scrollHeight - (e.target.scrollTop + e.target.clientHeight) < 10;
	          _this6.setState({
	            reachedBottom: bottom
	          });
	        }
	      };
	
	      return _react2.default.createElement(
	        'div',
	        {
	          className: 'body ' + (isFullWidth ? 'full-width' : ''),
	          ref: function ref(r) {
	            _this6.wrapper = r;
	          },
	          id:  true ? this.state.isMobile === true ? "wizard-body-scrollArrow-container-mobile" : "wizard-body-scrollArrow-container" : "wizard-body-scroll-container",
	          tabIndex: '-1',
	          onScroll:  true ? handleScroll : null
	        },
	        (true) && this.state.isScrollable ? _react2.default.createElement(
	          _react.Fragment,
	          null,
	          _react2.default.createElement(
	            'div',
	            { className: 'scroll-down-container-bottom-right' },
	            _react2.default.createElement(
	              'div',
	              { className: 'scroll-down-text' },
	              'Scroll Down'
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'scroll-down-icon' },
	              _react2.default.createElement(_caretDown2.default, null)
	            )
	          )
	        ) : null,
	        _react2.default.createElement('div', { className: 'validation-indicator ' + (validating ? 'show' : '') }),
	        validating ? _react2.default.createElement('div', { className: 'validation-shade' }) : null,
	        children,
	        _react2.default.createElement(Toolbar, { validating: validating })
	      );
	    }
	  }]);
	
	  return Body;
	}(_react.Component);
	
	var Section = function Section(_ref9) {
	  var title = _ref9.title,
	      _ref9$description = _ref9.description,
	      description = _ref9$description === undefined ? '' : _ref9$description,
	      fields = _ref9.fields,
	      index = _ref9.index,
	      _ref9$zIndex = _ref9.zIndex,
	      zIndex = _ref9$zIndex === undefined ? '' : _ref9$zIndex,
	      allFields = _ref9.allFields;
	
	  var mappedFields = fields.map(function (rawField, i) {
	    if (rawField) {
	      var field = (0, _store.resolveFieldLogic)(rawField);
	      return field.active && (0, _wizardUtilities.resolveFieldConditions)(field.conditions, allFields, field.conditionsOperator) && _react2.default.createElement(_Field2.default, {
	        field: field,
	        isFirst: index === 0 && i === 0,
	        bypassConditionCheck: true,
	        bypassLogicResolution: true,
	        key: field.fieldId
	      });
	    } else {
	      console.warn('Attempted to render a field at index ' + i + ' of section "' + title + '", but got null.');
	      return null;
	    }
	  });
	  return mappedFields.some(function (f) {
	    return f;
	  }) && _react2.default.createElement(
	    'div',
	    { className: 'section', style: { zIndex: zIndex } },
	    title ? _react2.default.createElement(
	      'h2',
	      null,
	      title
	    ) : null,
	    description && _react2.default.createElement(_Markdown2.default, { className: 'description', source: description }),
	    mappedFields,
	    _react2.default.createElement('div', { className: 'bottom-divider' })
	  );
	};
	
	var GENERIC_SERVER_ERROR = 'Something went wrong while we were trying to save your filing. Try submitting your filing again, and if the problem persists please contact customer support.';
	var SHOPPING_CART = (true);
	
	var Toolbar = function (_Component5) {
	  _inherits(Toolbar, _Component5);
	
	  function Toolbar() {
	    _classCallCheck(this, Toolbar);
	
	    var _this7 = _possibleConstructorReturn(this, (Toolbar.__proto__ || Object.getPrototypeOf(Toolbar)).call(this));
	
	    _this7.componentDidMount = function () {
	      window.stringifyFields = function () {
	        return JSON.stringify(_this7.props.fields);
	      };
	      window.stringifyWizard = function () {
	        console.log(JSON.stringify(_this7.getReportPreview()));
	      };
	      window.logWizard = function () {
	        return _this7.buildFieldJSON();
	      };
	      window.logCurrentStep = function () {
	        return Object.values(_this7.props.wizard.wizard.sections).filter(function (s) {
	          return s.stepId === _this7.props.wizard.wizard.stepOrder[_this7.props.activeStep];
	        }).flatMap(function (s) {
	          return Object.values(_this7.props.fields).filter(function (f) {
	            return f.parent.id === s.sectionId;
	          });
	        }).flatMap(function (f) {
	          return f.hasOptionFields ? f.options.flatMap(function (o) {
	            return o.fields.map(function (f) {
	              return _this7.props.fields[f];
	            });
	          }) : [f];
	        });
	      };
	      window.logFieldByName = function (name) {
	        return Object.values(_this7.props.fields).filter(function (field) {
	          return field.name === name;
	        });
	      };
	      window.logFieldByFieldId = function (fieldId) {
	        return Object.values(_this7.props.fields).filter(function (field) {
	          return field.fieldId === fieldId;
	        });
	      };
	      window.buildFullWizardFieldIdList = function () {
	        return (0, _WizardActions.buildFullWizardFieldIdList)();
	      };
	      window.logWizardPayload = function () {
	        return _this7.createPayload();
	      };
	      window.logFields = function () {
	        return _this7.props.fields;
	      };
	      window.logSigners = function () {
	        return (0, _utilities.formatSignaturesForServer)(_this7.props.activeUploadAndSubmitField.value.signers);
	      };
	      window.stringifySigners = function () {
	        console.log(JSON.stringify((0, _utilities.formatSignaturesForServer)(_this7.props.activeUploadAndSubmitField.value.signers)));
	      };
	    };
	
	    _this7.componentWillReceiveProps = function (nextProps) {
	      if (_this7.props.activeStep !== nextProps.activeStep) {
	        _this7.setState({ wizardValid: null });
	      }
	    };
	
	    _this7.toggleSubmitModal = function () {
	      _this7.setState({ submitted: !_this7.state.submitted });
	    };
	
	    _this7.toggleCheckout = function () {
	      _this7.setState({ checkoutOpen: !_this7.state.checkoutOpen });
	    };
	
	    _this7.setActiveStep = function (stepIndex) {
	      _store2.default.dispatch({
	        type: 'SET_ACTIVE_STEP',
	        stepIndex: stepIndex
	      });
	    };
	
	    _this7.nextStep = function () {
	      if (_this7.props.readOnly) {
	        _this7.props.setActiveStep(_this7.props.activeStep + 1);
	      } else {
	        _this7.props.validateAndSetActiveStep(_this7.props.activeStep + 1);
	      }
	    };
	
	    _this7.prevStep = function () {
	      if (_this7.props.readOnly) {
	        _this7.props.setActiveStep(_this7.props.activeStep - 1);
	      } else {
	        _this7.props.validateAndSetActiveStep(_this7.props.activeStep - 1);
	      }
	    };
	
	    _this7.getDraftName = function () {
	      var field = _this7.props.fields[_this7.props.docTitleSrc];
	      if (field) {
	        switch (field.type) {
	          case 'EntityNameSearch':
	            return field.value.reservedYN === 'Y' ? field.value.reservedName : field.value.val1;
	          case 'SearchControl':
	            return field.value && field.value.HEADER1;
	          case 'FullName':
	            return field.value.FIRST_NAME + ' ' + field.value.LAST_NAME;
	          case 'confirmFields':
	            return field.value.val1;
	          default:
	            return field.value;
	        }
	      } else {
	        return _this7.props.wizardTitle;
	      }
	    };
	
	    _this7.saveDraft = function () {
	      _this7.clearServerError();
	      var fieldValues = _this7.buildFieldJSON();
	      var docTitle = _this7.getDraftName();
	      var wizardState = (0, _deepCopy2.default)(_this7.props.wizardState);
	      delete wizardState.wizard.stepOrder;
	      delete wizardState.wizard.steps;
	      delete wizardState.wizard.sections;
	      delete wizardState.wizard.fields;
	      var draft = {
	        DRAFT_ID: _this7.props.draftId ? _this7.props.draftId : 0,
	        SOURCE_ID: _this7.props.sourceId,
	        SOURCE_TYPE_ID: 54,
	        FORM_DEFINITION_ID: _this7.props.formDefinitionId,
	        ADDITIONAL_INFO_XML: '',
	        STATUS: 'Draft',
	        WIZARD_JSON: JSON.stringify(fieldValues),
	        WIZARD_STATE: JSON.stringify(wizardState),
	        DRAFT_NAME: docTitle,
	        AMENDMENT_NUM: _this7.props.amendmentNum,
	        CATEGORY: _this7.props.category
	        //console.log(draft)
	      };_this7.props.saveDraft(draft, function () {
	        _this7.props.announce("Your draft has been saved successfully.");
	      });
	    };
	
	    _this7.buildFieldNameMap = function (fieldIds) {
	      return fieldIds.reduce(function (obj, fieldId) {
	        var fieldName = _this7.props.fields[fieldId].name;
	        obj[fieldName] = (obj[fieldName] || 0) + 1;
	        return obj;
	      }, {});
	    };
	
	    _this7.buildFieldJSON = function () {
	      var fieldIds = (0, _WizardActions.buildFullWizardFieldIdList)();
	      var FIELD_VALUES = {};
	      var DYNAMIC_DATA = [];
	      var FIELD_META = {};
	      var fieldNameMap = _this7.buildFieldNameMap(fieldIds);
	      fieldIds.filter(function (fieldId) {
	        var field = _this7.props.fields[fieldId];
	        var fieldAfterLogicResolution = (0, _store.resolveFieldLogic)(field);
	        var fieldOnlyHiddenByLogic = field.active && !fieldAfterLogicResolution.active;
	        if (fieldOnlyHiddenByLogic) {
	          return false;
	        }
	        return true;
	      }).forEach(function (fieldId) {
	        var field = (0, _store.resolveFieldLogic)(_this7.props.fields[fieldId]);
	        var kvPairs = new WizardClasses[field.fieldClass]().getKeyValuePairs(field, _this7.props.fields);
	        kvPairs.forEach(function (pair) {
	          var fieldNameIsNotUnique = fieldNameMap[field.name] > 1;
	          var shouldUseFieldIdAsFieldName = field.disabled && !field.hideFieldOnForm;
	          // const metaKey = shouldUseFieldIdAsFieldName ? field.fieldId : field.name
	          if (shouldUseFieldIdAsFieldName && fieldNameIsNotUnique) {
	            FIELD_VALUES = Object.assign({}, FIELD_VALUES, _defineProperty({}, field.fieldId, [pair.value]));
	            FIELD_META = Object.assign({}, FIELD_META, _defineProperty({}, field.fieldId, pair.meta));
	          } else {
	            if (FIELD_VALUES[pair.name]) {
	              FIELD_VALUES = Object.assign({}, FIELD_VALUES, _defineProperty({}, pair.name, [].concat(_toConsumableArray(FIELD_VALUES[pair.name]), [pair.value])));
	            } else {
	              FIELD_VALUES = Object.assign({}, FIELD_VALUES, _defineProperty({}, pair.name, [pair.value]));
	            }
	            FIELD_META = Object.assign({}, FIELD_META, _defineProperty({}, pair.name, pair.meta));
	          }
	        });
	        if (field.dynamic) {
	          DYNAMIC_DATA.push(field.name);
	        }
	      });
	      Object.keys(FIELD_VALUES).forEach(function (key) {
	        if (Array.isArray(FIELD_VALUES[key])) {
	          if (FIELD_VALUES[key].length === 1) {
	            FIELD_VALUES[key] = FIELD_VALUES[key][0];
	          }
	        }
	      });
	      FIELD_META = (0, _WizardActions.createMetaCollection)(FIELD_META, _this7.props.wizard, fieldIds);
	      var ENCRYPTION = (0, _WizardActions.createEncryptionCollection)(_this7.props.wizard);
	      var FIELD_OVERRIDES = (0, _WizardActions.createFieldOverridesCollection)(_this7.props.wizard);
	      var resolvedWizard = _this7.props.resolveWizardAttributesLogic();
	      return {
	        FIELD_VALUES: FIELD_VALUES,
	        DYNAMIC_DATA: DYNAMIC_DATA,
	        FIELD_META: FIELD_META,
	        ENCRYPTION: ENCRYPTION,
	        FIELD_OVERRIDES: FIELD_OVERRIDES,
	        WIZARD_OVERRIDES: _this7.getWizardOverrides(resolvedWizard)
	      };
	    };
	
	    _this7.getWizardOverrides = function (wizard) {
	      return {
	        internalReviewRequired: wizard.internalReviewRequired,
	        formTitle: wizard.formTitle,
	        feeDescription: wizard.feeDescription
	      };
	    };
	
	    _this7.createPayload = function () {
	      var _this7$buildFieldJSON = _this7.buildFieldJSON(),
	          FIELD_VALUES = _this7$buildFieldJSON.FIELD_VALUES,
	          DYNAMIC_DATA = _this7$buildFieldJSON.DYNAMIC_DATA,
	          FIELD_META = _this7$buildFieldJSON.FIELD_META,
	          ENCRYPTION = _this7$buildFieldJSON.ENCRYPTION,
	          FIELD_OVERRIDES = _this7$buildFieldJSON.FIELD_OVERRIDES;
	
	      var webUser = JSON.parse(localStorage.getItem('WEB_USER'));
	      var resolvedWizard = _this7.props.resolveWizardAttributesLogic();
	      var payload = {
	        METADATA: Object.assign({
	          FORM_DEFINITION_ID: _this7.props.formDefinitionId,
	          WEB_USER_ID: webUser ? webUser.WEB_USER_ID : 0,
	          SOURCE_ID: _this7.props.sourceId,
	          SOURCE_TYPE_ID: _this7.props.sourceTypeId,
	          AMENDMENT_NUM: _this7.props.amendmentNum,
	          DRAFT_ID: _this7.props.draftId ? _this7.props.draftId : 0,
	          DYNAMIC_DATA: DYNAMIC_DATA,
	          INTERNAL_REVIEW_REQUIRED_YN: resolvedWizard.internalReviewRequired || _this7.props.calculateInternalReview(),
	          REDACTION_REQUIRED_YN: _this7.calculateRedaction()
	        }, _this7.props.meta),
	        FIELD_VALUES: FIELD_VALUES,
	        FIELD_META: FIELD_META,
	        ENCRYPTION: ENCRYPTION,
	        FIELD_OVERRIDES: FIELD_OVERRIDES,
	        WIZARD_OVERRIDES: _this7.getWizardOverrides(resolvedWizard)
	      };
	      return payload;
	    };
	
	    _this7.calculateRedaction = function () {
	      var fields = (0, _WizardActions.buildFullWizardFieldIdList)().map(function (fieldId) {
	        return _this7.props.fields[fieldId];
	      });
	      return fields.reduce(function (redacted, field) {
	        if (redacted) {
	          return true;
	        } else {
	          switch (field.type.toUpperCase()) {
	            case 'REPEATER':
	              return field.value.length > 0 ? field.redact ? true : field.template.some(function (fid) {
	                return _this7.props.fields[fid].redact;
	              }) : redacted;
	            default:
	              return field.redact;
	          }
	        }
	      }, false);
	    };
	
	    _this7.submit = function (saveRoute, extraPayload) {
	      _this7.props.setWizardSubmitting(true);
	      return new Promise(function (resolve, reject) {
	        (0, _WizardActions.validateAllSteps)(function (wizardValid, globalErrorMessages) {
	          _this7.setState({ wizardValid: wizardValid });
	          if (wizardValid) {
	            var payload = _this7.createPayload();
	            var mergedPayload = extraPayload ? Object.assign({}, payload, { extraPayload: extraPayload }) : payload;(saveRoute || _this7.props.saveRecord)(mergedPayload, _this7.props.category, _this7.props.mode, _this7.props.correctionMode, function (amendmentNum) {
	              // console.log(amendmentNum)
	              _this7.props.mode === 'correction' ? _store.history.push('/receipt') : _this7.setState({ submitted: true });
	              _this7.props.setWizardSubmitted(true);
	              _this7.props.setWizardSubmitting(false);
	              resolve(amendmentNum);
	            }, function (e) {
	              console.error(e);
	              _this7.props.setWizardSubmitting(false);
	              if (e.code === 'filing/amendmentSaveFailed' || e.code === 'filing/amendmentImgsNotCreated') {
	                _this7.setState({
	                  serverError: GENERIC_SERVER_ERROR
	                });
	              } else if (e.displayInWizard === true) {
	                _this7.setState({
	                  serverError: e.message
	                });
	              }
	            });
	          } else {
	            _this7.props.setWizardSubmitting(false);
	            _this7.setState({ globalErrorMessage: globalErrorMessages.join('\n') });
	            reject('There are errors in the wizard preventing submission.');
	            var focusable = (0, _utilities.getFirstFocusableScopedElement)('.sidebar', '[aria-invalid="true"]');
	            if (focusable) {
	              focusable.focus();
	            }
	          }
	        });
	      });
	    };
	
	    _this7.getReceiptItems = function (amendmentNum) {
	      return new Promise(function (resolve, reject) {
	        (0, _requests.GET_RECEIPT_ITEMS_BY_ADMENDMENT_NUM)(amendmentNum, _this7.props.category, _this7.props.correctionMode, function (_ref10) {
	          var RECEIPT_ITEM_WEB_LIST = _ref10.RECEIPT_ITEM_WEB_LIST,
	              RECEIPT_ITEM_CONTAINER_WEB_LIST = _ref10.RECEIPT_ITEM_CONTAINER_WEB_LIST,
	              REF_NUM = _ref10.REF_NUM,
	              PAYMENT_METHOD_STATUS_LIST = _ref10.PAYMENT_METHOD_STATUS_LIST;
	
	          _this7.setState({
	            receiptItemContainers: RECEIPT_ITEM_CONTAINER_WEB_LIST,
	            receiptItems: RECEIPT_ITEM_WEB_LIST,
	            transactionRefNum: REF_NUM,
	            availablePaymentMethods: PAYMENT_METHOD_STATUS_LIST
	          }, function () {
	            var total = (SHOPPING_CART ? (0, _utilities.calculateReceiptItemContainersTotal)(RECEIPT_ITEM_CONTAINER_WEB_LIST) : (0, _utilities.calculateReceiptItemsTotal)(RECEIPT_ITEM_WEB_LIST)) > 0;
	            resolve(total);
	            if (SHOPPING_CART) {
	              _this7.props.setCartQuantity(RECEIPT_ITEM_CONTAINER_WEB_LIST.filter(function (x) {
	                return !x.IS_FREE;
	              }).length);
	            }
	          });
	        }, function (err) {
	          reject(err);
	        });
	      });
	    };
	
	    _this7.testValidate = function () {
	      _this7.clearServerError();
	      _this7.props.setWizardSubmitting(true);
	      _this7.setState({ globalErrorMessage: "" });
	      (0, _WizardActions.validateAllSteps)(function (wizardValid, globalErrorMessages) {
	        _this7.setState({ wizardValid: wizardValid });
	        if (wizardValid) {
	          _this7.setState({ globalErrorMessage: "This wizard is valid, and would be submitted." });
	        } else {
	          _this7.props.setWizardSubmitting(false);
	          _this7.setState({ globalErrorMessage: globalErrorMessages.join('\n') });
	        }
	      });
	    };
	
	    _this7.validateSubmitAndPay = function () {
	      _this7.clearServerError();
	      _this7.submit().then(_this7.getReceiptItems).then(function (requiresPayment) {
	        if (requiresPayment) _this7.toggleCheckout();else {
	          _store.history.replace('/receipt?ref=' + _this7.state.transactionRefNum);
	        }
	      }).catch(function (err) {
	        console.error(err);
	      });
	    };
	
	    _this7.validateSubmitAndDownloadPDF = function () {
	      _this7.clearServerError();
	      _this7.submit().then(function (amendmentNum) {
	        _this7.getPdfFromJson(null, { amendmentNum: amendmentNum }).then(function () {
	          window.ALLOW_BYPASS_WIZARD_PROMPT = true;
	          _store.history.replace('/queue/' + _this7.props.category + '?hid=' + amendmentNum);
	        });
	      }).catch(function (e) {
	        console.error(e);
	      });
	    };
	
	    _this7.validateAndSendForSignatures = function () {
	      _this7.clearServerError();
	      _this7.submit(_this7.props.saveRecordWithSignatures, {
	        SIGNERS: (0, _utilities.formatSignaturesForServer)(_this7.props.activeUploadAndSubmitField.value.signers)
	      }).then(function (groupToken) {
	        window.ALLOW_BYPASS_WIZARD_PROMPT = true;
	        _store.history.push('/signatures/' + groupToken, { showSuccessMessage: true });
	      });
	    };
	
	    _this7.saveSignature = function () {
	      _this7.clearServerError();
	      var errors = {};
	      if (!_this7.props.signatureValues.SIGNATURE) errors.SIGNATURE = 'Please sign your name to continue.';
	
	      if (!_this7.props.signatureValues.SIGNED_DATE) {
	        errors.SIGNED_DATE = 'Please provide the date of signing to continue.';
	      } else if ((0, _differenceInDays2.default)(({"NODE_ENV":"production","BUILD_DATE":"2025-08-27T15:15:31.687Z","BUILD_NUMBER":"Not Provided","GIT_VERSION":"v1.3.0-381-ga81e29b08","GIT_COMMIT_HASH":"a81e29b085c9268ffd96c78eb734365802722741","GIT_BRANCH":"beta","PUBLIC_URL":"","STATE_ABBR":"MT","STATE_NAME":"Montana","STATE_ORG_TITLE":"Secretary of State","LOGIN_HEADER_IMG_PATH":"","HOME_IMG_FILENAME":"montana.jpg","FAVICON_FILE_NAME":"favicon.ico","ALLOW_E_SIGN_ON_CORRECTIONS":true,"THIRD_PARTY_SIGNING_ALLOWED":false,"MY_ACCOUNT_SAVE_AND_CLOSE_BUTTON":true,"IE_DEPRECATED_MESSAGE":"Internet Explorer is not supported. Please select a supported browser below to access this website.","ADDITIONAL_ROUTES":{"dataRequests":true,"farmBill":true,"apostille":true,"externalHelp":"https://sosmt.gov/business/help-center/","systemAdministration":[{"title":"Saved Payments","parameter":"saved-payments","componentName":"SavedPayments"}]},"SUBROUTES":[{"label":"Business","component":"Business","parameter":"business","myWorkQueueSearch":false,"sourceTypeId":54,"searchMustHaveOneOf":["FILING_TYPE_ID","STATUS_ID","STATE","search"],"serverWebSearchDescription":true,"serverWorkQueueDescription":true,"serverMyRecordsDescription":true,"searchPlaceholder":"Search by name or filing number (X########)","allowEmptySearchTerm":true,"requestCertificateAlternateLabel":"Request Information","fileAmendmentButtonLabel":"Filing Actions","advancedSearchParameters":[{"type":"radio","name":"QUERY_TYPE_ID","defaultValue":1010,"options":[{"value":1010,"label":"Starts with"},{"value":1011,"label":"Contains"},{"value":1012,"label":" Word Contains"}]},{"type":"serverSelect","name":"FILING_TYPE_ID","optionsSrc":"FILING_TYPES","label":"Entity Type","placeholder":"All","defaultValue":"0"},{"type":"serverSelect","name":"FILING_SUBTYPE_ID","optionsSrc":"FILING_SUBTYPES","label":"Entity Subtype","overrideSubOptionsSrcFromParameterName":"FILING_TYPE_ID","placeholder":"All","defaultValue":"0"},{"type":"serverSelect","name":"STATUS_ID","optionsSrc":"FILING_STATUS_WITHOUT_ALL","label":"Status","placeholder":"All","defaultValue":"0"},{"type":"serverSelect","name":"STATE","optionsSrc":"STATE","label":"State","placeholder":"All","defaultValue":""},{"type":"serverSelect","name":"COUNTY","optionsSrc":"COUNTY_SUBOPTION","label":"County","overrideSubOptionsSrcFromParameterName":"STATE","placeholder":"All","defaultValue":""},{"type":"checkbox","name":"CRA_SEARCH_YN","defaultValue":false,"label":"Search by Registered Agent PID"},{"type":"dateRange","name":"FILING_DATE","label":"Registration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}},{"type":"dateRange","name":"EXPIRATION_DATE","label":"Expiration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}}],"myRecordsFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Active"},{"value":2,"label":"Inactive"},{"value":3,"label":"Pending"}]},{"type":"dateRange","name":"DATE_RANGE","label":"Date range","defaultValue":{"start":null,"end":null}}],"myWorkQueueFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Approved"},{"value":2,"label":"Pending Online Payment"},{"value":3,"label":"Pending Review"},{"value":4,"label":"Needs Correction"},{"value":5,"label":"Rejected"},{"value":6,"label":"Draft"}]},{"type":"dateRange","name":"DATE_RANGE","label":"Date range","defaultValue":{"start":null,"end":null}}]},{"label":"Notary","component":"Notary","parameter":"notary","sourceTypeId":850,"myWorkQueueSearch":false,"allowEmptySearchTerm":true,"requestCertificateAlternateLabel":"Download Certificate","fileAmendmentButtonLabel":"Filing Actions","hideNameRequestCertificate":true,"hideAddressRequestCertificate":true,"hideRecordUserManagment":true,"searchPlaceholder":"Search by name or commission number","searchMustHaveOneOf":["CITY","search","SERVICE_TYPE"],"advancedParametersStartOpen":true,"searchIsSortable":true,"advancedSearchParameters":[{"type":"radio","name":"STARTS_WITH_YN","defaultValue":false,"options":[{"value":true,"label":"Starts with"},{"value":false,"label":"Contains"}]},{"type":"checkbox","name":"ACTIVE_ONLY_YN","defaultValue":true,"label":"Active entities only"},{"type":"text","name":"CITY","defaultValue":"","label":"City"},{"type":"select","name":"SERVICE_TYPE","label":"Special Services Offered","defaultValue":0,"options":[{"value":0,"label":"(N/A)"},{"value":6165,"label":"In-Person Electronic Notarization (IPEN)"},{"value":6166,"label":"Remote Online Notarization (RON)"},{"value":6167,"label":"Mobile Notary Services"},{"value":6168,"label":"Remote Ink Notarization (RIN)"}]}]},{"label":"Apostille","component":"Apostille","parameter":"apostille","sourceTypeId":720,"myRecordsSearch":false,"myWorkQueueSearch":false,"disabled":false,"allowedRoutes":["/forms-manager/","/queue/","/forms/"]},{"label":"Liens","component":"UCC","parameter":"ucc","sourceTypeId":1999,"myRecordsSearch":true,"myWorkQueueSearch":true,"fileAmendmentButtonLabel":"Filing Actions","searchPlaceholder":"Search by name or file number","disabled":false,"serverWebSearchDescription":true,"myRecordsDescription":"","workQueueDescription":"","searchDescription":"","hideRecordUserManagment":true,"searchLiensCheckout":false,"advancedSearchParameters":[{"type":"radio","name":"STARTS_WITH_YN","defaultValue":false,"options":[{"value":true,"label":"Starts with"},{"value":false,"label":"Contains"}]},{"type":"select","name":"STATUS","defaultValue":"ALL","label":"Status","options":[{"value":"ACTIVE_UNLAPSED","label":"Active (unlapsed)"},{"value":"ACTIVE_LAPSED_UNLAPSED","label":"Active (lapsed and unlapsed)"}]},{"type":"text","name":"EXCLUDE_VALUES","label":"Exclude Debtor Names (comma separated list of names to exclude)","defaultValue":""},{"type":"dateRange","name":"FILING_DATE","label":"Financing Statement Date","defaultValue":{"start":null,"end":null}},{"type":"dateRange","name":"LAPSE_DATE","label":"Lapse Date","defaultValue":{"start":null,"end":null}},{"type":"text","name":"CITY","label":"Debtor City","defaultValue":""}],"myRecordsFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Approved"},{"value":2,"label":"Pending Online Payment"},{"value":3,"label":"Pending Review"}]},{"type":"select","name":"TYPE","defaultValue":0,"label":"Lien Type","options":[{"value":0,"label":"All"},{"value":1,"label":"UCC"},{"value":2,"label":"EFS"},{"value":3,"label":"Title 71"}]}],"myWorkQueueFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Approved"},{"value":2,"label":"Pending Online Payment"},{"value":3,"label":"Pending Review"},{"value":4,"label":"Pending Print and Mail"},{"value":5,"label":"Rejected"},{"value":6,"label":"Draft"}]},{"type":"select","name":"TYPE","defaultValue":0,"label":"Lien Type","options":[{"value":0,"label":"All"},{"value":1,"label":"UCC"},{"value":2,"label":"EFS"},{"value":3,"label":"Title 71"}]}]},{"label":"Copy Request","component":"copies","parameter":"copies","sourceTypeId":2001,"myRecordsSearch":false,"myWorkQueueSearch":false,"disabled":false,"allowedRoutes":["/forms-manager/","/queue/","/forms/"]},{"label":"Trademark","component":"Trademark","parameter":"trademark","sourceTypeId":810,"showRequestCertificate":true,"searchMustHaveOneOf":["search","EXPIRATION_DATE","FILING_DATE"],"allowEmptySearchTerm":true,"requestCertificateAlternateLabel":"Request Information","fileAmendmentButtonLabel":"Filing Actions","advancedSearchParameters":[{"type":"radio","name":"QUERY_TYPE_ID","defaultValue":1010,"options":[{"value":1010,"label":"Starts with"},{"value":1011,"label":"Contains"},{"value":1012,"label":" Word Contains"}]},{"type":"checkbox","name":"OWNER_SEARCH_YN","defaultValue":false,"label":"Search owners"},{"type":"radio","name":"SERVICE_MARK_YN","label":"Mark Type","defaultValue":"","options":[{"value":"","label":"All Marks"},{"value":"Y","label":"Service Mark"},{"value":"N","label":"Trademark"}]},{"type":"serverSelect","name":"STATUS_ID","optionsSrc":"TYPE_V|TRADEMARK_STATUS_TYPE","label":"Status","placeholder":"All","defaultValue":"0"},{"type":"select","name":"DESIGN_TYPE_ID","options":[{"value":0,"label":"All"},{"value":990,"label":"Words Only"},{"value":991,"label":"Design Only"},{"value":992,"label":"Words and Design"}],"label":"Design Type","defaultValue":"0"},{"type":"dateRange","name":"FILING_DATE","label":"Registered Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}},{"type":"dateRange","name":"EXPIRATION_DATE","label":"Expiration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}}]},{"label":"Business Info Request","component":"InfoRequests","parameter":"info-request","sourceTypeId":167,"allowedRoutes":["/forms-manager/","/queue/","/forms/"]},{"label":"Data Requests","component":"DataRequests","parameter":"data-request","sourceTypeId":0,"allowedRoutes":["/forms-manager/"]},{"label":"CRA","component":"CRA","parameter":"cra","sourceTypeId":157,"myRecordsSearch":false,"searchPlaceholder":"Search by name or registered agent number","allowedRoutes":["/forms-manager/","/forms/","/records/","/queue/","/search/"],"allowEmptySearchTerm":true,"fileAmendmentButtonLabel":"Filing Actions","advancedSearchParameters":[{"type":"radio","name":"QUERY_TYPE_ID","defaultValue":1010,"options":[{"value":1010,"label":"Starts with"},{"value":1011,"label":"Contains"},{"value":1012,"label":" Word Contains"}]},{"type":"dateRange","name":"CRA_DATE","label":"Registration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}},{"type":"select","name":"STATUS_ID","label":"Status","defaultValue":0,"options":[{"value":0,"label":"All"},{"value":121,"label":"Active"},{"value":122,"label":"Inactive"}]},{"type":"select","name":"AGENT_TYPE_ID","label":"Agent Type","defaultValue":0,"options":[{"value":0,"label":"All"},{"value":460,"label":"Registered Agent"},{"value":461,"label":"Commercial Registered Agent"}]}]},{"label":"Farm Bill","component":"FarmBill","parameter":"farm-bill","path":"/lists/farm-bill","sourceTypeId":0,"myRecordsSearch":false,"allowedRules":["/search/"],"disabled":true,"searchDescription":"To perform a search, enter a debtor name. Your search results may include: exact debtor name, variations of that name and any filing that includes your search criteria. Punctuation is ignored.\n\nYou can click on \"Advanced\" to refine your search. Under “Advanced” you can search by crop, year, county and SSN/FEIN. As a registered Farm Bill Buyer with the Montana Secretary of State’s office it is important to maintain the confidentiality of the information contained within the Farm Bill Master List. The Farm Bill Master List reflects personal data, such as Social Security Numbers, which are a key piece of personal identifiable information to assist you in determining the existence of a lien against a specific debtor. The distribution of this information beyond its intended purpose is strictly prohibited.\n\nThe debtor's tax identification number has been hidden for confidentiality reasons. You may continue to search on a tax ID number and return debtors that match your search criteria. The SSN/FEIN must be entered without dashes or spaces.","searchMustHaveOneOf":["search","UCC_FARM_PRODUCT_ID","COUNTY"],"searchPlaceholder":"Search by debtor name","advancedSearchParameters":[{"type":"ServerMultiComplete","label":"Product code name(s)","name":"UCC_FARM_PRODUCT_ID","defaultValue":"","optionsSrc":"UCC_FARM_PRODUCT_V"},{"type":"MultiComplete","label":"Year or Range of Years","name":"YEAR_NUM","optionsSrc":"years","startYear":"1968","defaultValue":[],"preMergeOptions":[{"value":"ALL","label":"All"}]},{"type":"serverSelect","label":"State","name":"STATE","defaultValue":"MONTANA","optionsSrc":"STATE"},{"type":"ServerMultiComplete","label":"County","name":"COUNTY","defaultValue":[],"optionsSrc":"COUNTY","overrideSubOptionsSrcFromParameterName":"STATE"},{"type":"checkbox","name":"TIN_SEARCH_YN","defaultValue":false,"label":"Tax Identification Number Search"},{"type":"checkbox","name":"TIN_SORT_YN","defaultValue":false,"label":"Unique ID Sort"}]}],"SYSTEM_NICKNAME":"Online Services Portal","PAYMENT_METHODS":[{"type":"bypass"},{"type":"iTransact"}],"PAYMENT_ALLOW_AMEX":true,"SYSTEM_ID_LABEL":"System Id","DOUBLE_COLUMN_PUBLIC_LOGIN":true,"INTERNAL_USER_MANAGEMENT":true,"ALLOW_PUBLIC_JSON_IMPORT":false,"MAX_FILE_UPLOAD_SIZE":10000000,"REFUND_TEXT":"","RETURN_TO_HOME_ON_LOGOUT":true,"CURRENT_SOS_NAME":"Christi Jacobsen","LOGO_FILENAME":"mt-sos-logo.png","LOGO_ALT":"Christi Jacobsen, Montana Secretary of State","LOGO_FULL_WIDTH":true,"HOME_HIDE_AUTH_HINT":true,"HOME_TITLE":"Montana Secretary of State","CUSTOM_TAB_TITLE":"Official Montana","HOME_SUBTITLE":"Online Business Services","ENTITY_NAME_CONSENT_DESCRIPTION":"","ALLOW_USER_PROFILE_EDITING":true,"COMPARE_FOREIGN_NAME_IN_ENTITY_NAME_VALIDATION":true,"FOREIGN_NAME_FIELD_NAME":"KIMA_PARENT_NAME_INFO","LOGIN_TITLE":"Montana Secretary of State Online Filing Portal Login","PUBLIC_LOGIN_LABEL":"Username","REVERSE_LOGIN_COLUMNS":true,"LOGIN_SEAL_FILENAME":"seal_white.png","SEPARATE_USERNAME_AND_EMAIL":true,"CREATE_ACCOUNT_BUTTON_ALIGN_LEFT":true,"CREATE_ACCOUNT_BUTTON_TEXT":"CREATE AN ACCOUNT","PASSWORD_CUSTOM_ERROR_TEXT":"The password must meet all requirements","ACCOUNT_CREATED_MESSAGE":"Please check your email to verify your account to login and allow a few minutes for this message to arrive. Check your junk/spam folders if you do not find the email in your inbox.","PUBLIC_LOGIN_PLACEHOLDER":" ","DISABLE_DEFAULT_PAYMENT_RADIO":true,"CUSTOM_RESET_PASSWORD_ERROR_MESSAGE":"Username invalid - no account found","PUBLIC_LOGIN_CREATE_DESCRIPTION":"### Existing User:\n\n  - Enter your username and password to login.  \n\n\n  #### - OR -  \n\n\n\n  - Forgot password? Click 'Reset Password' and follow the prompts.\n  - Forgot username? Click 'Forgot Username' and follow the prompts.  \n\n\n  ### New User:\n  ","LOGIN_HELP_LINK":"https://sosmt.gov/business/how-do-i/","LOGIN_HELP_LINK_TEXT":"Need Help?","FORGOT_USERNAME_TEXT":"Forgot Username?","LOGIN_ACTIVE_DIRECTORY_TEXT":"State User Login","MULTIPLE_LOGIN_METHODS":true,"HAS_ACTIVE_DIRECTORY_LOGIN":true,"RESET_PASSWORD_WITH_USERNAME":true,"DOWNLOAD_LINK":true,"SHOW_USERNAME_ACCOUNT_CREATE":true,"SHOW_SCROLL_DOWN_ARROW":true,"SHOW_ADDRESS_ACCOUNT_CREATE":true,"TWO_COLUMN_ACCOUNT_CREATE":true,"RESET_PASSWORD_TIP":"A link to change your password has been sent to your email. Please allow a few minutes for this message to arrive. Please check your junk/spam folders if you do not find the email in your inbox.","FORGOT_PASSWORD_LINK_TEXT":"Reset Password","PHONE_NUMBER_OPTIONAL_ACCOUNT_CREATE":true,"SHOW_REQUIRED_INDICATOR_ACCOUNT_CREATE":true,"PASSWORD_REQUIREMENTS_ACCOUNT_CREATE":"\n    <ul>\n      <li>MUST contain at least 8 characters (12+ recommended)</li>\n      <li>MUST contain at least one uppercase letter.</li>\n      <li>MUST contain at least one lowercase letter.</li>\n      <li>MUST contain at least one number.</li>\n      <li>MUST contain at least one special character (!”#$%&'()*+,-./:;<=>?</li>\n    </ul>\n  ","ALLOW_CERTIFICATION_REQUEST":true,"ALLOW_PUBLIC_CERTIFICATE_REQUEST":true,"ALLOW_COPY_REQUEST":false,"ALLOW_CORRECTION_STYLING":true,"HIDE_DEPRECATION_WARNING":false,"AMEND_ROUTE_PUBLIC":true,"SEAL_FILENAME":"seal.png","SHOPPING_CART":true,"ALLOW_PAYMENT_UPDATE_WITH_EMPTY_CART":true,"RA_EMAIL":true,"RA_WEBSITE":true,"RA_NO_DEFAULT_TYPE":true,"RA_ADDRESS_LABEL":"Street Address","RA_TYPE_SELECTION_DEFAULT":true,"RA_DEFAULT_TYPE":"460","RA_OVERRIDE_TYPE_WITH_DEFAULT":true,"RA_PRINCIPAL_ADDRESS_AMS":true,"UPLOAD_AND_SUBMIT_HIDE_IF_ONE_OPTION":true,"PAYMENT_PROCESSING_MESSAGE":"Your payment is processing - Do not close your browser or click the back button","CHECKOUT_BUTTON_WHEN_PROCESSING_TEXT":"Processing","EFS_CROP_PICKER_NONE_LABEL":"Lien Duration","DISALLOWED_WIZARD_PIECES":["FormationLocale"],"REPEATER_SHOW_EDIT_BUTTON":true,"DATA_REQUEST_PAGE_TITLE":"Data Requests and Subscriptions","DATA_REQUEST_SIDEBAR_LABEL":"Data Requests & Subscriptions","LOGIN_REDIRECTS_TO_EPASS":false,"LOGIN_REDIRECTS_TO_ACTIVE_DIRECTORY":true,"LOGIN_ACTIVE_DIRECTORY_LINK":true,"FETCH_EDIT_USER_LINK":false,"LISTS_FETCH_AVAILABLE_LISTS":true,"POST_WIZARD_SUBMIT_REDIRECT_URL":"/","PIN_REQUEST_ATTESTATIONS":true,"PIN_REQUEST_DESCRIPTION":"Click **Request PIN** to have a new PIN sent to the account holder's email address on file.","OWNERSHIP_REQUEST_DESCRIPTION":"To become an **authorized user** of this record, a current **AUTHORIZED USER** will need to grant you access. To request access, click **Request Access** below.","PIN_REQUEST_SUCCESS_MESSAGE":"The PIN you have requested for this entity has been sent to the email associated with your user account.  You should receive the PIN in approximately 3-5 minutes, depending on your email service provider.","APOSTILLE_HEADER_LABEL":"Verification Information","APOSTILLE_NUMBER_LABEL":"Apostille/Authentication","APOSTILLE_CITY_STATE_OVERRIDE":"HELENA, MT","APOSTILLE_FILING_DATE_LABEL":"Issue Date","APOSTILLE_CITY_STATE_IN_CERTIFIED":true,"NOTARY_EXISTING_FILING":true,"ALLOW_REVOKE_OWN_ACCESS_ONLY":false,"HIDE_CANCEL_ON_ONETIME_DATA_REQUESTS":true,"DATA_REQUESTS_IN_SHOPPING_CART":true,"WQ_ALLOW_EDIT_PENDING_PAYMENT":true,"WQ_CONFIRM_ON_DELETE":true,"WQ_DELETE_CONFIRM_MESSAGE":"Deleting this filing will forfeit any money already paid to the Secretary of State. This action is permanent and cannot be undone, are you sure you would like to delete?","PASS_ITEM_GUIDS_ON_CHECKOUT":true,"FORM_REVISION_HISTORY":true,"CHECKOUT_DISCLAIMER":"By entering your credit card and/or checking account information you (i) state that **you are an authorized user** of the credit card and/or electronic check and that the associated information entered (e.g., account holder name, account number, billing address) is accurate, (ii) **you authorize payment processor to charge the amount you have requested** to your credit card and/or funding account, and (iii) **acknowledge if a charge is declined or reversed you may also be assessed a customary charge** by the payment processor for such transactions.","FARM_BILL_SEARCH_CONFIDENTIAL":"As a registered Farm Bill Buyer with the Montana Secretary of State’s office it is important to maintain the confidentiality of the information contained within the Farm Bill Master List. The Farm Bill Master List reflects personal data, such as Social Security Numbers, which are a key piece of personal identifiable information to assist you in determining the existence of a lien against a specific debtor. The distribution of this information beyond its intended purpose is strictly prohibited.\n\n**The debtor's tax identification number has been hidden for confidentiality reasons. You may continue to search on a tax ID number and return debtors that match your search criteria. The SSN/FEIN must be entered without dashes or spaces.  If you need access to the tax identification number to clearly identify the debtor, please contact the UCC unit at (406) 444-3665.**","VIEW_HISTORY_BUTTON_ALT_TEXT":"View Filings","WIZARD_ERROR_TITLE_MESSAGE":"Form Error","FARM_BILL_SEARCH_INTERACTIVE":true,"USE_FARM_BILL_API":true,"DISALLOW_ASSIGN_SELF_AS_RA":true,"DISALLOW_ASSIGN_SELF_AS_PRINCIPAL":true,"USE_TRADEMARK_OWNER_VALIDATION":true,"USE_ALTERNATIVE_FOREIGN_ADDRESS_LABELS":true,"MY_RECEIPTS_FILTER":[{"type":"dateRange","name":"DATE_RANGE","label":"Date range","defaultValue":{"start":null,"end":null}},{"type":"text","name":"REF_NUM","defaultValue":"","label":"Reference Number"},{"type":"text","name":"RECEIPT_NUM","defaultValue":"","label":"Receipt Id"},{"type":"text","name":"AMOUNT","defaultValue":"","label":"Amount"},{"type":"select","name":"TYPE","defaultValue":"","label":"Payment Type","options":[{"value":"","label":"All"},{"value":"CC","label":"Credit Card"},{"value":"Check","label":"Check"}]}],"MY_RECEIPTS_SHOW_IN_SIDEBAR":true,"SHOW_MY_RECEIPTS_HELPER_TEXT":true,"MY_RECEIPTS_HELPER_LABEL":"About Receipt Search","MY_RECEIPTS_HELPER_TEXT":"You can search for receipts based on their descriptions, including the items paid for on the receipt. Use the filters to search for or filter specific information.","FARM_BILL_SUBLINK":{"label":"Farm Bill","component":"FarmBill","parameter":"farm-bill","path":"/lists/farm-bill","sourceTypeId":0,"myRecordsSearch":false,"allowedRules":["/search/"],"disabled":true,"searchDescription":"To perform a search, enter a debtor name. Your search results may include: exact debtor name, variations of that name and any filing that includes your search criteria. Punctuation is ignored.\n\nYou can click on \"Advanced\" to refine your search. Under “Advanced” you can search by crop, year, county and SSN/FEIN. As a registered Farm Bill Buyer with the Montana Secretary of State’s office it is important to maintain the confidentiality of the information contained within the Farm Bill Master List. The Farm Bill Master List reflects personal data, such as Social Security Numbers, which are a key piece of personal identifiable information to assist you in determining the existence of a lien against a specific debtor. The distribution of this information beyond its intended purpose is strictly prohibited.\n\nThe debtor's tax identification number has been hidden for confidentiality reasons. You may continue to search on a tax ID number and return debtors that match your search criteria. The SSN/FEIN must be entered without dashes or spaces.","searchMustHaveOneOf":["search","UCC_FARM_PRODUCT_ID","COUNTY"],"searchPlaceholder":"Search by debtor name","advancedSearchParameters":[{"type":"ServerMultiComplete","label":"Product code name(s)","name":"UCC_FARM_PRODUCT_ID","defaultValue":"","optionsSrc":"UCC_FARM_PRODUCT_V"},{"type":"MultiComplete","label":"Year or Range of Years","name":"YEAR_NUM","optionsSrc":"years","startYear":"1968","defaultValue":[],"preMergeOptions":[{"value":"ALL","label":"All"}]},{"type":"serverSelect","label":"State","name":"STATE","defaultValue":"MONTANA","optionsSrc":"STATE"},{"type":"ServerMultiComplete","label":"County","name":"COUNTY","defaultValue":[],"optionsSrc":"COUNTY","overrideSubOptionsSrcFromParameterName":"STATE"},{"type":"checkbox","name":"TIN_SEARCH_YN","defaultValue":false,"label":"Tax Identification Number Search"},{"type":"checkbox","name":"TIN_SORT_YN","defaultValue":false,"label":"Unique ID Sort"}]},"ALLOW_ADDRESS_VALIDATION_BYPASS_OPTION":true,"DEFAULT_ADDRESS_VALIDATION_BYPASS_OPTION_CHECKED":true}).STATE_TIMEZONE ? new Date(new Date().toLocaleString('en-US', { timeZone: ({"NODE_ENV":"production","BUILD_DATE":"2025-08-27T15:15:31.687Z","BUILD_NUMBER":"Not Provided","GIT_VERSION":"v1.3.0-381-ga81e29b08","GIT_COMMIT_HASH":"a81e29b085c9268ffd96c78eb734365802722741","GIT_BRANCH":"beta","PUBLIC_URL":"","STATE_ABBR":"MT","STATE_NAME":"Montana","STATE_ORG_TITLE":"Secretary of State","LOGIN_HEADER_IMG_PATH":"","HOME_IMG_FILENAME":"montana.jpg","FAVICON_FILE_NAME":"favicon.ico","ALLOW_E_SIGN_ON_CORRECTIONS":true,"THIRD_PARTY_SIGNING_ALLOWED":false,"MY_ACCOUNT_SAVE_AND_CLOSE_BUTTON":true,"IE_DEPRECATED_MESSAGE":"Internet Explorer is not supported. Please select a supported browser below to access this website.","ADDITIONAL_ROUTES":{"dataRequests":true,"farmBill":true,"apostille":true,"externalHelp":"https://sosmt.gov/business/help-center/","systemAdministration":[{"title":"Saved Payments","parameter":"saved-payments","componentName":"SavedPayments"}]},"SUBROUTES":[{"label":"Business","component":"Business","parameter":"business","myWorkQueueSearch":false,"sourceTypeId":54,"searchMustHaveOneOf":["FILING_TYPE_ID","STATUS_ID","STATE","search"],"serverWebSearchDescription":true,"serverWorkQueueDescription":true,"serverMyRecordsDescription":true,"searchPlaceholder":"Search by name or filing number (X########)","allowEmptySearchTerm":true,"requestCertificateAlternateLabel":"Request Information","fileAmendmentButtonLabel":"Filing Actions","advancedSearchParameters":[{"type":"radio","name":"QUERY_TYPE_ID","defaultValue":1010,"options":[{"value":1010,"label":"Starts with"},{"value":1011,"label":"Contains"},{"value":1012,"label":" Word Contains"}]},{"type":"serverSelect","name":"FILING_TYPE_ID","optionsSrc":"FILING_TYPES","label":"Entity Type","placeholder":"All","defaultValue":"0"},{"type":"serverSelect","name":"FILING_SUBTYPE_ID","optionsSrc":"FILING_SUBTYPES","label":"Entity Subtype","overrideSubOptionsSrcFromParameterName":"FILING_TYPE_ID","placeholder":"All","defaultValue":"0"},{"type":"serverSelect","name":"STATUS_ID","optionsSrc":"FILING_STATUS_WITHOUT_ALL","label":"Status","placeholder":"All","defaultValue":"0"},{"type":"serverSelect","name":"STATE","optionsSrc":"STATE","label":"State","placeholder":"All","defaultValue":""},{"type":"serverSelect","name":"COUNTY","optionsSrc":"COUNTY_SUBOPTION","label":"County","overrideSubOptionsSrcFromParameterName":"STATE","placeholder":"All","defaultValue":""},{"type":"checkbox","name":"CRA_SEARCH_YN","defaultValue":false,"label":"Search by Registered Agent PID"},{"type":"dateRange","name":"FILING_DATE","label":"Registration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}},{"type":"dateRange","name":"EXPIRATION_DATE","label":"Expiration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}}],"myRecordsFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Active"},{"value":2,"label":"Inactive"},{"value":3,"label":"Pending"}]},{"type":"dateRange","name":"DATE_RANGE","label":"Date range","defaultValue":{"start":null,"end":null}}],"myWorkQueueFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Approved"},{"value":2,"label":"Pending Online Payment"},{"value":3,"label":"Pending Review"},{"value":4,"label":"Needs Correction"},{"value":5,"label":"Rejected"},{"value":6,"label":"Draft"}]},{"type":"dateRange","name":"DATE_RANGE","label":"Date range","defaultValue":{"start":null,"end":null}}]},{"label":"Notary","component":"Notary","parameter":"notary","sourceTypeId":850,"myWorkQueueSearch":false,"allowEmptySearchTerm":true,"requestCertificateAlternateLabel":"Download Certificate","fileAmendmentButtonLabel":"Filing Actions","hideNameRequestCertificate":true,"hideAddressRequestCertificate":true,"hideRecordUserManagment":true,"searchPlaceholder":"Search by name or commission number","searchMustHaveOneOf":["CITY","search","SERVICE_TYPE"],"advancedParametersStartOpen":true,"searchIsSortable":true,"advancedSearchParameters":[{"type":"radio","name":"STARTS_WITH_YN","defaultValue":false,"options":[{"value":true,"label":"Starts with"},{"value":false,"label":"Contains"}]},{"type":"checkbox","name":"ACTIVE_ONLY_YN","defaultValue":true,"label":"Active entities only"},{"type":"text","name":"CITY","defaultValue":"","label":"City"},{"type":"select","name":"SERVICE_TYPE","label":"Special Services Offered","defaultValue":0,"options":[{"value":0,"label":"(N/A)"},{"value":6165,"label":"In-Person Electronic Notarization (IPEN)"},{"value":6166,"label":"Remote Online Notarization (RON)"},{"value":6167,"label":"Mobile Notary Services"},{"value":6168,"label":"Remote Ink Notarization (RIN)"}]}]},{"label":"Apostille","component":"Apostille","parameter":"apostille","sourceTypeId":720,"myRecordsSearch":false,"myWorkQueueSearch":false,"disabled":false,"allowedRoutes":["/forms-manager/","/queue/","/forms/"]},{"label":"Liens","component":"UCC","parameter":"ucc","sourceTypeId":1999,"myRecordsSearch":true,"myWorkQueueSearch":true,"fileAmendmentButtonLabel":"Filing Actions","searchPlaceholder":"Search by name or file number","disabled":false,"serverWebSearchDescription":true,"myRecordsDescription":"","workQueueDescription":"","searchDescription":"","hideRecordUserManagment":true,"searchLiensCheckout":false,"advancedSearchParameters":[{"type":"radio","name":"STARTS_WITH_YN","defaultValue":false,"options":[{"value":true,"label":"Starts with"},{"value":false,"label":"Contains"}]},{"type":"select","name":"STATUS","defaultValue":"ALL","label":"Status","options":[{"value":"ACTIVE_UNLAPSED","label":"Active (unlapsed)"},{"value":"ACTIVE_LAPSED_UNLAPSED","label":"Active (lapsed and unlapsed)"}]},{"type":"text","name":"EXCLUDE_VALUES","label":"Exclude Debtor Names (comma separated list of names to exclude)","defaultValue":""},{"type":"dateRange","name":"FILING_DATE","label":"Financing Statement Date","defaultValue":{"start":null,"end":null}},{"type":"dateRange","name":"LAPSE_DATE","label":"Lapse Date","defaultValue":{"start":null,"end":null}},{"type":"text","name":"CITY","label":"Debtor City","defaultValue":""}],"myRecordsFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Approved"},{"value":2,"label":"Pending Online Payment"},{"value":3,"label":"Pending Review"}]},{"type":"select","name":"TYPE","defaultValue":0,"label":"Lien Type","options":[{"value":0,"label":"All"},{"value":1,"label":"UCC"},{"value":2,"label":"EFS"},{"value":3,"label":"Title 71"}]}],"myWorkQueueFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Approved"},{"value":2,"label":"Pending Online Payment"},{"value":3,"label":"Pending Review"},{"value":4,"label":"Pending Print and Mail"},{"value":5,"label":"Rejected"},{"value":6,"label":"Draft"}]},{"type":"select","name":"TYPE","defaultValue":0,"label":"Lien Type","options":[{"value":0,"label":"All"},{"value":1,"label":"UCC"},{"value":2,"label":"EFS"},{"value":3,"label":"Title 71"}]}]},{"label":"Copy Request","component":"copies","parameter":"copies","sourceTypeId":2001,"myRecordsSearch":false,"myWorkQueueSearch":false,"disabled":false,"allowedRoutes":["/forms-manager/","/queue/","/forms/"]},{"label":"Trademark","component":"Trademark","parameter":"trademark","sourceTypeId":810,"showRequestCertificate":true,"searchMustHaveOneOf":["search","EXPIRATION_DATE","FILING_DATE"],"allowEmptySearchTerm":true,"requestCertificateAlternateLabel":"Request Information","fileAmendmentButtonLabel":"Filing Actions","advancedSearchParameters":[{"type":"radio","name":"QUERY_TYPE_ID","defaultValue":1010,"options":[{"value":1010,"label":"Starts with"},{"value":1011,"label":"Contains"},{"value":1012,"label":" Word Contains"}]},{"type":"checkbox","name":"OWNER_SEARCH_YN","defaultValue":false,"label":"Search owners"},{"type":"radio","name":"SERVICE_MARK_YN","label":"Mark Type","defaultValue":"","options":[{"value":"","label":"All Marks"},{"value":"Y","label":"Service Mark"},{"value":"N","label":"Trademark"}]},{"type":"serverSelect","name":"STATUS_ID","optionsSrc":"TYPE_V|TRADEMARK_STATUS_TYPE","label":"Status","placeholder":"All","defaultValue":"0"},{"type":"select","name":"DESIGN_TYPE_ID","options":[{"value":0,"label":"All"},{"value":990,"label":"Words Only"},{"value":991,"label":"Design Only"},{"value":992,"label":"Words and Design"}],"label":"Design Type","defaultValue":"0"},{"type":"dateRange","name":"FILING_DATE","label":"Registered Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}},{"type":"dateRange","name":"EXPIRATION_DATE","label":"Expiration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}}]},{"label":"Business Info Request","component":"InfoRequests","parameter":"info-request","sourceTypeId":167,"allowedRoutes":["/forms-manager/","/queue/","/forms/"]},{"label":"Data Requests","component":"DataRequests","parameter":"data-request","sourceTypeId":0,"allowedRoutes":["/forms-manager/"]},{"label":"CRA","component":"CRA","parameter":"cra","sourceTypeId":157,"myRecordsSearch":false,"searchPlaceholder":"Search by name or registered agent number","allowedRoutes":["/forms-manager/","/forms/","/records/","/queue/","/search/"],"allowEmptySearchTerm":true,"fileAmendmentButtonLabel":"Filing Actions","advancedSearchParameters":[{"type":"radio","name":"QUERY_TYPE_ID","defaultValue":1010,"options":[{"value":1010,"label":"Starts with"},{"value":1011,"label":"Contains"},{"value":1012,"label":" Word Contains"}]},{"type":"dateRange","name":"CRA_DATE","label":"Registration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}},{"type":"select","name":"STATUS_ID","label":"Status","defaultValue":0,"options":[{"value":0,"label":"All"},{"value":121,"label":"Active"},{"value":122,"label":"Inactive"}]},{"type":"select","name":"AGENT_TYPE_ID","label":"Agent Type","defaultValue":0,"options":[{"value":0,"label":"All"},{"value":460,"label":"Registered Agent"},{"value":461,"label":"Commercial Registered Agent"}]}]},{"label":"Farm Bill","component":"FarmBill","parameter":"farm-bill","path":"/lists/farm-bill","sourceTypeId":0,"myRecordsSearch":false,"allowedRules":["/search/"],"disabled":true,"searchDescription":"To perform a search, enter a debtor name. Your search results may include: exact debtor name, variations of that name and any filing that includes your search criteria. Punctuation is ignored.\n\nYou can click on \"Advanced\" to refine your search. Under “Advanced” you can search by crop, year, county and SSN/FEIN. As a registered Farm Bill Buyer with the Montana Secretary of State’s office it is important to maintain the confidentiality of the information contained within the Farm Bill Master List. The Farm Bill Master List reflects personal data, such as Social Security Numbers, which are a key piece of personal identifiable information to assist you in determining the existence of a lien against a specific debtor. The distribution of this information beyond its intended purpose is strictly prohibited.\n\nThe debtor's tax identification number has been hidden for confidentiality reasons. You may continue to search on a tax ID number and return debtors that match your search criteria. The SSN/FEIN must be entered without dashes or spaces.","searchMustHaveOneOf":["search","UCC_FARM_PRODUCT_ID","COUNTY"],"searchPlaceholder":"Search by debtor name","advancedSearchParameters":[{"type":"ServerMultiComplete","label":"Product code name(s)","name":"UCC_FARM_PRODUCT_ID","defaultValue":"","optionsSrc":"UCC_FARM_PRODUCT_V"},{"type":"MultiComplete","label":"Year or Range of Years","name":"YEAR_NUM","optionsSrc":"years","startYear":"1968","defaultValue":[],"preMergeOptions":[{"value":"ALL","label":"All"}]},{"type":"serverSelect","label":"State","name":"STATE","defaultValue":"MONTANA","optionsSrc":"STATE"},{"type":"ServerMultiComplete","label":"County","name":"COUNTY","defaultValue":[],"optionsSrc":"COUNTY","overrideSubOptionsSrcFromParameterName":"STATE"},{"type":"checkbox","name":"TIN_SEARCH_YN","defaultValue":false,"label":"Tax Identification Number Search"},{"type":"checkbox","name":"TIN_SORT_YN","defaultValue":false,"label":"Unique ID Sort"}]}],"SYSTEM_NICKNAME":"Online Services Portal","PAYMENT_METHODS":[{"type":"bypass"},{"type":"iTransact"}],"PAYMENT_ALLOW_AMEX":true,"SYSTEM_ID_LABEL":"System Id","DOUBLE_COLUMN_PUBLIC_LOGIN":true,"INTERNAL_USER_MANAGEMENT":true,"ALLOW_PUBLIC_JSON_IMPORT":false,"MAX_FILE_UPLOAD_SIZE":10000000,"REFUND_TEXT":"","RETURN_TO_HOME_ON_LOGOUT":true,"CURRENT_SOS_NAME":"Christi Jacobsen","LOGO_FILENAME":"mt-sos-logo.png","LOGO_ALT":"Christi Jacobsen, Montana Secretary of State","LOGO_FULL_WIDTH":true,"HOME_HIDE_AUTH_HINT":true,"HOME_TITLE":"Montana Secretary of State","CUSTOM_TAB_TITLE":"Official Montana","HOME_SUBTITLE":"Online Business Services","ENTITY_NAME_CONSENT_DESCRIPTION":"","ALLOW_USER_PROFILE_EDITING":true,"COMPARE_FOREIGN_NAME_IN_ENTITY_NAME_VALIDATION":true,"FOREIGN_NAME_FIELD_NAME":"KIMA_PARENT_NAME_INFO","LOGIN_TITLE":"Montana Secretary of State Online Filing Portal Login","PUBLIC_LOGIN_LABEL":"Username","REVERSE_LOGIN_COLUMNS":true,"LOGIN_SEAL_FILENAME":"seal_white.png","SEPARATE_USERNAME_AND_EMAIL":true,"CREATE_ACCOUNT_BUTTON_ALIGN_LEFT":true,"CREATE_ACCOUNT_BUTTON_TEXT":"CREATE AN ACCOUNT","PASSWORD_CUSTOM_ERROR_TEXT":"The password must meet all requirements","ACCOUNT_CREATED_MESSAGE":"Please check your email to verify your account to login and allow a few minutes for this message to arrive. Check your junk/spam folders if you do not find the email in your inbox.","PUBLIC_LOGIN_PLACEHOLDER":" ","DISABLE_DEFAULT_PAYMENT_RADIO":true,"CUSTOM_RESET_PASSWORD_ERROR_MESSAGE":"Username invalid - no account found","PUBLIC_LOGIN_CREATE_DESCRIPTION":"### Existing User:\n\n  - Enter your username and password to login.  \n\n\n  #### - OR -  \n\n\n\n  - Forgot password? Click 'Reset Password' and follow the prompts.\n  - Forgot username? Click 'Forgot Username' and follow the prompts.  \n\n\n  ### New User:\n  ","LOGIN_HELP_LINK":"https://sosmt.gov/business/how-do-i/","LOGIN_HELP_LINK_TEXT":"Need Help?","FORGOT_USERNAME_TEXT":"Forgot Username?","LOGIN_ACTIVE_DIRECTORY_TEXT":"State User Login","MULTIPLE_LOGIN_METHODS":true,"HAS_ACTIVE_DIRECTORY_LOGIN":true,"RESET_PASSWORD_WITH_USERNAME":true,"DOWNLOAD_LINK":true,"SHOW_USERNAME_ACCOUNT_CREATE":true,"SHOW_SCROLL_DOWN_ARROW":true,"SHOW_ADDRESS_ACCOUNT_CREATE":true,"TWO_COLUMN_ACCOUNT_CREATE":true,"RESET_PASSWORD_TIP":"A link to change your password has been sent to your email. Please allow a few minutes for this message to arrive. Please check your junk/spam folders if you do not find the email in your inbox.","FORGOT_PASSWORD_LINK_TEXT":"Reset Password","PHONE_NUMBER_OPTIONAL_ACCOUNT_CREATE":true,"SHOW_REQUIRED_INDICATOR_ACCOUNT_CREATE":true,"PASSWORD_REQUIREMENTS_ACCOUNT_CREATE":"\n    <ul>\n      <li>MUST contain at least 8 characters (12+ recommended)</li>\n      <li>MUST contain at least one uppercase letter.</li>\n      <li>MUST contain at least one lowercase letter.</li>\n      <li>MUST contain at least one number.</li>\n      <li>MUST contain at least one special character (!”#$%&'()*+,-./:;<=>?</li>\n    </ul>\n  ","ALLOW_CERTIFICATION_REQUEST":true,"ALLOW_PUBLIC_CERTIFICATE_REQUEST":true,"ALLOW_COPY_REQUEST":false,"ALLOW_CORRECTION_STYLING":true,"HIDE_DEPRECATION_WARNING":false,"AMEND_ROUTE_PUBLIC":true,"SEAL_FILENAME":"seal.png","SHOPPING_CART":true,"ALLOW_PAYMENT_UPDATE_WITH_EMPTY_CART":true,"RA_EMAIL":true,"RA_WEBSITE":true,"RA_NO_DEFAULT_TYPE":true,"RA_ADDRESS_LABEL":"Street Address","RA_TYPE_SELECTION_DEFAULT":true,"RA_DEFAULT_TYPE":"460","RA_OVERRIDE_TYPE_WITH_DEFAULT":true,"RA_PRINCIPAL_ADDRESS_AMS":true,"UPLOAD_AND_SUBMIT_HIDE_IF_ONE_OPTION":true,"PAYMENT_PROCESSING_MESSAGE":"Your payment is processing - Do not close your browser or click the back button","CHECKOUT_BUTTON_WHEN_PROCESSING_TEXT":"Processing","EFS_CROP_PICKER_NONE_LABEL":"Lien Duration","DISALLOWED_WIZARD_PIECES":["FormationLocale"],"REPEATER_SHOW_EDIT_BUTTON":true,"DATA_REQUEST_PAGE_TITLE":"Data Requests and Subscriptions","DATA_REQUEST_SIDEBAR_LABEL":"Data Requests & Subscriptions","LOGIN_REDIRECTS_TO_EPASS":false,"LOGIN_REDIRECTS_TO_ACTIVE_DIRECTORY":true,"LOGIN_ACTIVE_DIRECTORY_LINK":true,"FETCH_EDIT_USER_LINK":false,"LISTS_FETCH_AVAILABLE_LISTS":true,"POST_WIZARD_SUBMIT_REDIRECT_URL":"/","PIN_REQUEST_ATTESTATIONS":true,"PIN_REQUEST_DESCRIPTION":"Click **Request PIN** to have a new PIN sent to the account holder's email address on file.","OWNERSHIP_REQUEST_DESCRIPTION":"To become an **authorized user** of this record, a current **AUTHORIZED USER** will need to grant you access. To request access, click **Request Access** below.","PIN_REQUEST_SUCCESS_MESSAGE":"The PIN you have requested for this entity has been sent to the email associated with your user account.  You should receive the PIN in approximately 3-5 minutes, depending on your email service provider.","APOSTILLE_HEADER_LABEL":"Verification Information","APOSTILLE_NUMBER_LABEL":"Apostille/Authentication","APOSTILLE_CITY_STATE_OVERRIDE":"HELENA, MT","APOSTILLE_FILING_DATE_LABEL":"Issue Date","APOSTILLE_CITY_STATE_IN_CERTIFIED":true,"NOTARY_EXISTING_FILING":true,"ALLOW_REVOKE_OWN_ACCESS_ONLY":false,"HIDE_CANCEL_ON_ONETIME_DATA_REQUESTS":true,"DATA_REQUESTS_IN_SHOPPING_CART":true,"WQ_ALLOW_EDIT_PENDING_PAYMENT":true,"WQ_CONFIRM_ON_DELETE":true,"WQ_DELETE_CONFIRM_MESSAGE":"Deleting this filing will forfeit any money already paid to the Secretary of State. This action is permanent and cannot be undone, are you sure you would like to delete?","PASS_ITEM_GUIDS_ON_CHECKOUT":true,"FORM_REVISION_HISTORY":true,"CHECKOUT_DISCLAIMER":"By entering your credit card and/or checking account information you (i) state that **you are an authorized user** of the credit card and/or electronic check and that the associated information entered (e.g., account holder name, account number, billing address) is accurate, (ii) **you authorize payment processor to charge the amount you have requested** to your credit card and/or funding account, and (iii) **acknowledge if a charge is declined or reversed you may also be assessed a customary charge** by the payment processor for such transactions.","FARM_BILL_SEARCH_CONFIDENTIAL":"As a registered Farm Bill Buyer with the Montana Secretary of State’s office it is important to maintain the confidentiality of the information contained within the Farm Bill Master List. The Farm Bill Master List reflects personal data, such as Social Security Numbers, which are a key piece of personal identifiable information to assist you in determining the existence of a lien against a specific debtor. The distribution of this information beyond its intended purpose is strictly prohibited.\n\n**The debtor's tax identification number has been hidden for confidentiality reasons. You may continue to search on a tax ID number and return debtors that match your search criteria. The SSN/FEIN must be entered without dashes or spaces.  If you need access to the tax identification number to clearly identify the debtor, please contact the UCC unit at (406) 444-3665.**","VIEW_HISTORY_BUTTON_ALT_TEXT":"View Filings","WIZARD_ERROR_TITLE_MESSAGE":"Form Error","FARM_BILL_SEARCH_INTERACTIVE":true,"USE_FARM_BILL_API":true,"DISALLOW_ASSIGN_SELF_AS_RA":true,"DISALLOW_ASSIGN_SELF_AS_PRINCIPAL":true,"USE_TRADEMARK_OWNER_VALIDATION":true,"USE_ALTERNATIVE_FOREIGN_ADDRESS_LABELS":true,"MY_RECEIPTS_FILTER":[{"type":"dateRange","name":"DATE_RANGE","label":"Date range","defaultValue":{"start":null,"end":null}},{"type":"text","name":"REF_NUM","defaultValue":"","label":"Reference Number"},{"type":"text","name":"RECEIPT_NUM","defaultValue":"","label":"Receipt Id"},{"type":"text","name":"AMOUNT","defaultValue":"","label":"Amount"},{"type":"select","name":"TYPE","defaultValue":"","label":"Payment Type","options":[{"value":"","label":"All"},{"value":"CC","label":"Credit Card"},{"value":"Check","label":"Check"}]}],"MY_RECEIPTS_SHOW_IN_SIDEBAR":true,"SHOW_MY_RECEIPTS_HELPER_TEXT":true,"MY_RECEIPTS_HELPER_LABEL":"About Receipt Search","MY_RECEIPTS_HELPER_TEXT":"You can search for receipts based on their descriptions, including the items paid for on the receipt. Use the filters to search for or filter specific information.","FARM_BILL_SUBLINK":{"label":"Farm Bill","component":"FarmBill","parameter":"farm-bill","path":"/lists/farm-bill","sourceTypeId":0,"myRecordsSearch":false,"allowedRules":["/search/"],"disabled":true,"searchDescription":"To perform a search, enter a debtor name. Your search results may include: exact debtor name, variations of that name and any filing that includes your search criteria. Punctuation is ignored.\n\nYou can click on \"Advanced\" to refine your search. Under “Advanced” you can search by crop, year, county and SSN/FEIN. As a registered Farm Bill Buyer with the Montana Secretary of State’s office it is important to maintain the confidentiality of the information contained within the Farm Bill Master List. The Farm Bill Master List reflects personal data, such as Social Security Numbers, which are a key piece of personal identifiable information to assist you in determining the existence of a lien against a specific debtor. The distribution of this information beyond its intended purpose is strictly prohibited.\n\nThe debtor's tax identification number has been hidden for confidentiality reasons. You may continue to search on a tax ID number and return debtors that match your search criteria. The SSN/FEIN must be entered without dashes or spaces.","searchMustHaveOneOf":["search","UCC_FARM_PRODUCT_ID","COUNTY"],"searchPlaceholder":"Search by debtor name","advancedSearchParameters":[{"type":"ServerMultiComplete","label":"Product code name(s)","name":"UCC_FARM_PRODUCT_ID","defaultValue":"","optionsSrc":"UCC_FARM_PRODUCT_V"},{"type":"MultiComplete","label":"Year or Range of Years","name":"YEAR_NUM","optionsSrc":"years","startYear":"1968","defaultValue":[],"preMergeOptions":[{"value":"ALL","label":"All"}]},{"type":"serverSelect","label":"State","name":"STATE","defaultValue":"MONTANA","optionsSrc":"STATE"},{"type":"ServerMultiComplete","label":"County","name":"COUNTY","defaultValue":[],"optionsSrc":"COUNTY","overrideSubOptionsSrcFromParameterName":"STATE"},{"type":"checkbox","name":"TIN_SEARCH_YN","defaultValue":false,"label":"Tax Identification Number Search"},{"type":"checkbox","name":"TIN_SORT_YN","defaultValue":false,"label":"Unique ID Sort"}]},"ALLOW_ADDRESS_VALIDATION_BYPASS_OPTION":true,"DEFAULT_ADDRESS_VALIDATION_BYPASS_OPTION_CHECKED":true}).STATE_TIMEZONE })) : new Date(), new Date(_this7.props.signatureValues.SIGNED_DATE))) {
	        errors.SIGNED_DATE = 'The date signed must be today.';
	      }
	
	      _this7.props.activeUploadAndSubmitField.signerAttestations.forEach(function (_, i) {
	        if (_this7.props.signatureValues.attestations[i] !== true) {
	          errors.ATTESTATIONS = 'You must attest to all of the above attestations to continue.';
	        }
	      });
	
	      var isValid = !Object.keys(errors).length;
	      _this7.props.setWizardSignatureErrors(errors);
	      if (isValid) {
	        _this7.props.setWizardSubmitting(true);
	        (0, _requests.SAVE_SIGNATURE_BY_TOKEN_AND_CATEGORY)({
	          token: _this7.props.signature.TOKEN,
	          category: _this7.props.category,
	          payload: {
	            SIGNED_DATE: _this7.props.signatureValues.SIGNED_DATE,
	            SIGNATURE: _this7.props.signatureValues.SIGNATURE
	          }
	        }, function (successful) {
	          _this7.props.setWizardSubmitting(false);
	          _this7.props.setWizardSubmitted(true);
	          _this7.props.setGenericSuccess({
	            title: 'Successfully submitted',
	            message: 'Your signature was successfully saved. You may now safely close your browser window.'
	          });
	        }, function (err) {
	          console.error(err);
	          _this7.props.setWizardSubmitting(false);
	          _this7.setState({
	            serverError: err.message || GENERIC_SERVER_ERROR
	          });
	        });
	      } else {
	        _this7.setState({ wizardValid: false });
	      }
	    };
	
	    _this7.startCheckout = function () {
	      _this7.modalRef.current.closeModal(function () {
	        _this7.toggleCheckout();
	      });
	    };
	
	    _this7.cancelCheckout = function (callback) {
	      _this7.slider.closeSlider(function () {
	        window.ALLOW_BYPASS_WIZARD_PROMPT = true;
	        _this7.toggleCheckout();
	        if (false) {
	          if (_this7.props.category === 'data-request') {
	            _store.history.replace('/data-requests');
	          } else {
	            _store.history.replace('/queue/' + _this7.props.category);
	          }
	        } else {
	          _store.history.replace(("/"));
	        }
	        if (typeof callback === 'function') {
	          callback();
	        }
	      });
	    };
	
	    _this7.redirectToReceipt = function (refNum) {
	      _this7.slider.closeSlider(function () {
	        window.ALLOW_BYPASS_WIZARD_PROMPT = true;
	        _store.history.replace('/receipt?ref=' + (refNum || _this7.state.transactionRefNum));
	      });
	    };
	
	    _this7.downloadPrintPdf = function () {
	      window.location.assign(_requests.BASE_URL + '/api/Report/FromReactPDF/' + _this7.props.formDefinitionId + '/' + _this7.props.amendmentNum);
	    };
	
	    _this7.getReportPreview = function () {
	      var _this7$props$wizard$w = _this7.props.wizard.wizard,
	          title = _this7$props$wizard$w.title,
	          sourceId = _this7$props$wizard$w.sourceId,
	          formDefinitionId = _this7$props$wizard$w.formDefinitionId,
	          category = _this7$props$wizard$w.category,
	          description = _this7$props$wizard$w.description,
	          steps = _this7$props$wizard$w.steps,
	          sections = _this7$props$wizard$w.sections,
	          fields = _this7$props$wizard$w.fields,
	          stepOrder = _this7$props$wizard$w.stepOrder;
	
	      var previewJson = {
	        formDefinition: {
	          FORM_DEFINITION_ID: formDefinitionId,
	          SOURCE_ID: sourceId,
	          TITLE: title,
	          STEPS_JSON: JSON.stringify({
	            stepOrder: stepOrder,
	            steps: steps,
	            sections: sections,
	            fields: fields
	          }),
	          CATEGORY: category,
	          METADATA: xml2Json.js2xml(_this7.props.meta),
	          DESCR: description,
	          ABBREVIATION: '',
	          MODE: _this7.props.mode ? _this7.props.mode : 'filing',
	          DOC_TITLE_SRC: _this7.props.docTitleSrc,
	          DOC_ID: _this7.props.docId,
	          FORM_TITLE: _this7.props.formTitle,
	          INTERNAL_REVIEW_REQUIRED_YN: _this7.props.internalReviewRequired,
	          ONLY_SHOW_CHANGED_FIELDS_ON_FORM_YN: _this7.props.wizard.wizard.onlyRenderChangedFieldsOnForm,
	          FEE_DESCR: _this7.props.feeDescription
	        },
	        amendment: JSON.stringify(_this7.buildFieldJSON())
	      };
	      return previewJson;
	    };
	
	    _this7.getPdfFromJson = function (_) {
	      var payload = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	      return new Promise(function (resolve, reject) {
	        var previewJson = Object.assign({}, _this7.getReportPreview(), payload);
	        (0, _requests.GET_REPORT_BY_JSON)(previewJson, function (response) {
	          response.blob().then(function (blob) {
	            var blobObject = window.URL.createObjectURL(blob);
	            _this7.setState({ reportBlob: blobObject, rawBlob: blob }, function () {
	              _this7.downloader.download();
	              resolve();
	            });
	          });
	        });
	      });
	    };
	
	    _this7.exportFieldValues = function () {
	      var _this7$buildFieldJSON2 = _this7.buildFieldJSON(),
	          FIELD_VALUES = _this7$buildFieldJSON2.FIELD_VALUES;
	
	      var dataExport = JSON.stringify({
	        ORIGIN_FDID: _this7.props.formDefinitionId,
	        FIELD_VALUES: FIELD_VALUES
	      });
	      _this7.setState({
	        dataExport: dataExport
	      }, function () {
	        _this7.dataDownloader.download();
	      });
	    };
	
	    _this7.refreshCart = function () {
	      (0, _requests.GET_WEB_USER_ACTIVE_CART)(function (cart) {
	        _this7.setState({
	          receiptItemContainers: cart.RECEIPT_ITEM_CONTAINER_WEB_LIST,
	          receiptItems: cart.RECEIPT_ITEM_WEB_LIST,
	          refNum: _this7.cart.REF_NUM
	        });
	      });
	    };
	
	    _this7.importFieldValues = function (e) {
	      (0, _utilities.readFileAsText)(e).then(function (json) {
	        json = (0, _utilities.getUniqueJSONvalues)(json);
	        // console.log(json);
	        _this7.props.reconstructWizardWithValues(json.FIELD_VALUES);
	      });
	    };
	
	    _this7.clearServerError = function () {
	      _this7.setState({ serverError: null, globalErrorMessage: "" });
	    };
	
	    _this7.getStepsWithErrors = function () {
	      return _this7.props.wizard.wizard.stepOrder.map(function (stepId) {
	        return _this7.props.wizard.wizard.steps[stepId];
	      }).filter(function (step) {
	        return !step.isValid;
	      }).map(function (step) {
	        return step.title;
	      });
	    };
	
	    _this7.state = {
	      submitted: false,
	      checkoutOpen: false,
	      receiptItems: [],
	      receiptItemContainers: [],
	      wizardValid: null,
	      reportBlob: null,
	      rawBlob: null,
	      dataExport: null,
	      serverError: null,
	      transactionRefNum: null,
	      availablePaymentMethods: undefined,
	      screenReaderMessage: "",
	      globalErrorMessage: ""
	    };
	    _this7.modalRef = _react2.default.createRef();
	    return _this7;
	  }
	
	  _createClass(Toolbar, [{
	    key: 'render',
	    value: function render() {
	      var _this8 = this;
	
	      var _props5 = this.props,
	          activeStep = _props5.activeStep,
	          stepLength = _props5.stepLength,
	          validating = _props5.validating,
	          savingDraft = _props5.savingDraft,
	          amendmentNum = _props5.amendmentNum,
	          preview = _props5.preview,
	          filingMethod = _props5.filingMethod,
	          lastStep = _props5.lastStep,
	          formDefinitionId = _props5.formDefinitionId,
	          category = _props5.category,
	          correctionMode = _props5.correctionMode,
	          wizardTitle = _props5.wizardTitle,
	          currentUserGroup = _props5.currentUserGroup,
	          readOnly = _props5.readOnly,
	          mode = _props5.mode,
	          uploading = _props5.uploading,
	          entryTypeChanged = _props5.entryTypeChanged,
	          onlineOverrideLabel = _props5.onlineOverrideLabel,
	          printOverrideLabel = _props5.printOverrideLabel,
	          signerOverrideLabel = _props5.signerOverrideLabel,
	          draftsDisabled = _props5.draftsDisabled,
	          isMobile = _props5.isMobile;
	
	      var unsubmittable = mode === 'unsubmittable';
	      var isAdminOrPrviewing = preview || currentUserGroup === 'ADMIN' || currentUserGroup === 'ADMIN_WEB';
	      var publicImportAllowed = (false) && currentUserGroup === 'WEB';
	
	      var wizardInvalidError = _react2.default.createElement(
	        'div',
	        { className: 'wizard-toolbar-popover ' + (isMobile ? 'is-mobile' : '') },
	        _react2.default.createElement(
	          'button',
	          {
	            onClick: function onClick() {
	              _this8.setState({ wizardValid: null, globalErrorMessage: "" });
	            },
	            'aria-label': 'Close Error Message'
	          },
	          _react2.default.createElement('span', { className: 'icon icon-cross' })
	        ),
	        _react2.default.createElement(
	          'span',
	          { 'aria-live': 'assertive', role: 'alert' },
	          'It looks like there are some mistakes in the data you\'ve entered. Please review each invalid step before continuing.',
	          this.state.globalErrorMessage ? _react2.default.createElement(
	            _react2.default.Fragment,
	            null,
	            _react2.default.createElement('br', null),
	            _react2.default.createElement('br', null),
	            this.state.globalErrorMessage
	          ) : null
	        )
	      );
	
	      var serverError = _react2.default.createElement(
	        'div',
	        { className: 'wizard-toolbar-popover ' + (isMobile ? 'is-mobile' : '') },
	        _react2.default.createElement(
	          'button',
	          {
	            onClick: function onClick() {
	              _this8.setState({ serverError: null });
	            },
	            'aria-label': 'Close Error Message'
	          },
	          _react2.default.createElement('span', { className: 'icon icon-cross' })
	        ),
	        _react2.default.createElement(
	          'span',
	          { 'aria-live': 'assertive', role: 'alert' },
	          this.state.serverError
	        )
	      );
	      var isInSignatureMode = mode === 'signature';
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'toolbar ' + (isAdminOrPrviewing ? 'admin' : '') },
	        !readOnly && !unsubmittable && category !== 'data-request' && !draftsDisabled && _react2.default.createElement(
	          'button',
	          { type: 'button', className: 'btn btn-default save toolbar-button', onClick: this.saveDraft },
	          'Save Draft'
	        ),
	        isAdminOrPrviewing && !unsubmittable && _react2.default.createElement(
	          'button',
	          { type: 'button', className: 'btn btn-default toolbar-button', onClick: this.getPdfFromJson },
	          'Preview Form'
	        ),
	        (isAdminOrPrviewing || publicImportAllowed) && _react2.default.createElement('input', {
	          type: 'file',
	          name: 'importJson',
	          id: 'importJson',
	          accept: 'application/json',
	          className: 'faux-hide toolbar-button',
	          onChange: this.importFieldValues
	        }),
	        (isAdminOrPrviewing || publicImportAllowed) && _react2.default.createElement(
	          'label',
	          { htmlFor: 'importJson', className: 'btn btn-default sibling-focus toolbar-button' },
	          _react2.default.createElement(_import2.default, null),
	          ' Import'
	        ),
	        (isAdminOrPrviewing || publicImportAllowed) && _react2.default.createElement(
	          'button',
	          { type: 'button', className: 'btn btn-default toolbar-button', onClick: this.exportFieldValues },
	          _react2.default.createElement(_export2.default, null),
	          ' Export'
	        ),
	        savingDraft === false && _react2.default.createElement(
	          'div',
	          { className: 'save-indicator' },
	          _react2.default.createElement('span', { className: 'icon icon-circle-check animated fadeOut fast-animation pull-left' }),
	          _react2.default.createElement(
	            'span',
	            { className: 'text animated fadeOut fast-animation pull-left' },
	            'Saved'
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'right-align' },
	          activeStep > 0 && !isInSignatureMode && _react2.default.createElement(
	            'button',
	            { type: 'button', className: 'btn btn-default prev toolbar-button', onClick: this.prevStep },
	            'Previous Step'
	          ),
	          activeStep !== stepLength - 1 && !isInSignatureMode && _react2.default.createElement(
	            'button',
	            {
	              type: 'button',
	              className: 'btn btn-raised btn-primary next toolbar-button',
	              onClick: this.nextStep
	            },
	            'Next Step'
	          ),
	          preview && lastStep ? _react2.default.createElement(
	            'button',
	            { type: 'button', onClick: this.testValidate, className: 'btn btn-raised btn-primary next toolbar-button' },
	            'Test Validation'
	          ) : null,
	          filingMethod === 'online' && lastStep && !preview && (!readOnly || entryTypeChanged) && (!unsubmittable || entryTypeChanged) && mode !== 'signature' && _react2.default.createElement(
	            'button',
	            {
	              type: 'button',
	              disabled: uploading,
	              className: 'btn btn-raised btn-primary next toolbar-button',
	              onClick: this.validateSubmitAndPay,
	              'aria-busy': this.state.submitted || this.props.submitting || validating,
	              'aria-live': 'polite'
	            },
	            validating || this.state.submitted ? _react2.default.createElement(
	              'div',
	              { className: 'center' },
	              _react2.default.createElement(_Loaders.Spinner, { className: 'validation-loader', size: 'small', color: 'currentcolor' }),
	              _react2.default.createElement(
	                'span',
	                null,
	                this.state.submitted ? 'Submitting' : 'Validating'
	              )
	            ) : onlineOverrideLabel || 'File Online'
	          ),
	          filingMethod === 'mail' && lastStep && !isInSignatureMode && !preview && (!readOnly || entryTypeChanged) && (!unsubmittable || entryTypeChanged) && _react2.default.createElement(
	            'button',
	            {
	              type: 'button',
	              disabled: uploading,
	              className: 'btn btn-raised btn-primary next toolbar-button',
	              onClick: this.validateSubmitAndDownloadPDF,
	              'aria-busy': this.state.submitted || this.props.submitting || validating,
	              'aria-live': 'polite'
	            },
	            validating || this.state.submitted ? _react2.default.createElement(
	              'div',
	              { className: 'center' },
	              _react2.default.createElement(_Loaders.Spinner, { className: 'validation-loader', size: 'small', color: 'currentcolor' }),
	              _react2.default.createElement(
	                'span',
	                null,
	                this.state.submitted ? 'Submitting' : 'Validating'
	              )
	            ) : printOverrideLabel || 'Print and Mail'
	          ),
	          filingMethod === 'signer' && lastStep && !preview && !isInSignatureMode && (!readOnly || entryTypeChanged) && (!unsubmittable || entryTypeChanged) && _react2.default.createElement(
	            'button',
	            {
	              type: 'button',
	              disabled: uploading,
	              className: 'btn btn-raised btn-primary next toolbar-button',
	              onClick: this.validateAndSendForSignatures,
	              'aria-busy': this.state.submitted || this.props.submitting || validating,
	              'aria-live': 'polite'
	            },
	            validating || this.state.submitted ? _react2.default.createElement(
	              'div',
	              { className: 'center' },
	              _react2.default.createElement(_Loaders.Spinner, { className: 'validation-loader', size: 'small', color: 'currentcolor' }),
	              _react2.default.createElement(
	                'span',
	                null,
	                this.state.submitted ? signerOverrideLabel || 'Send for Signatures' : 'Validating'
	              )
	            ) : signerOverrideLabel || 'Send for Signatures'
	          ),
	          isInSignatureMode && _react2.default.createElement(
	            'button',
	            {
	              type: 'button',
	              disabled: uploading,
	              className: 'btn btn-raised btn-primary next toolbar-button',
	              onClick: this.saveSignature,
	              'aria-busy': this.state.submitted || this.props.submitting || validating,
	              'aria-live': 'polite'
	            },
	            validating || this.props.submitting || this.state.submitted ? _react2.default.createElement(
	              'div',
	              { className: 'center' },
	              _react2.default.createElement(_Loaders.Spinner, { className: 'validation-loader', size: 'small', color: 'currentcolor' }),
	              _react2.default.createElement(
	                'span',
	                null,
	                'Submitting'
	              )
	            ) : signerOverrideLabel || 'Submit Signature'
	          ),
	          lastStep && filingMethod === null && (!readOnly || entryTypeChanged) && (!unsubmittable || entryTypeChanged) && _react2.default.createElement(
	            'button',
	            {
	              type: 'button',
	              className: 'btn btn-raised btn-primary next toolbar-button',
	              onClick: this.getPdfFromJson
	            },
	            'Download PDF'
	          )
	        ),
	        this.state.wizardValid === false && (isMobile ? _react2.default.createElement(
	          _Portal2.default,
	          { isOpened: true },
	          wizardInvalidError
	        ) : wizardInvalidError),
	        this.state.serverError && (isMobile ? _react2.default.createElement(
	          _Portal2.default,
	          { isOpened: true },
	          serverError
	        ) : serverError),
	        _react2.default.createElement(_FileDownloader2.default, {
	          ref: function ref(downloader) {
	            _this8.downloader = downloader;
	          },
	          href: this.state.reportBlob,
	          blob: this.state.rawBlob,
	          fileName: wizardTitle + '.pdf'
	        }),
	        _react2.default.createElement(_FileDownloader2.default, {
	          ref: function ref(downloader) {
	            _this8.dataDownloader = downloader;
	          },
	          fileString: this.state.dataExport,
	          fileName: 'DATA_' + wizardTitle + '.json'
	        }),
	        _react2.default.createElement(
	          _Portal2.default,
	          { isOpened: this.state.checkoutOpen },
	          _react2.default.createElement(
	            _SlidingPanel2.default,
	            {
	              closeOnShadeClick: false,
	              closeSlider: this.toggleCheckout,
	              ref: function ref(r) {
	                _this8.slider = r;
	              }
	            },
	            _react2.default.createElement(_Checkout2.default, {
	              cancelCheckout: this.cancelCheckout,
	              closeModal: this.toggleCheckout,
	              redirectToReceipt: this.redirectToReceipt,
	              amendmentNum: amendmentNum,
	              formDefinitionId: formDefinitionId,
	              category: category,
	              correctionMode: correctionMode,
	              receiptItems: this.state.receiptItems,
	              receiptItemContainers: this.state.receiptItemContainers,
	              refNum: this.state.transactionRefNum,
	              availableMethods: this.state.availablePaymentMethods,
	              onCartRefresh: this.refreshCart
	            })
	          )
	        )
	      );
	    }
	  }]);
	
	  return Toolbar;
	}(_react.Component);
	
	Toolbar = (0, _reactRedux.connect)(function (state) {
	  var filingMethod = state.wizard.requirePrintMailMethod.size > 0 ? [{ value: { method: 'mail' } }] : (0, _utilities.getFieldsByType)('UploadAndSubmit', state.wizard.wizard.fields);
	  var activeFilingMethods = filingMethod && filingMethod.filter(function (field) {
	    return (0, _wizardUtilities.resolveFieldConditions)(field.conditions, state.wizard.wizard.fields, field.conditionsOperator) && (field.logicNodes ? (0, _store.resolveFieldLogic)(field).active : true);
	  });
	  var method = activeFilingMethods ? activeFilingMethods[0] && activeFilingMethods[0].value.method : null;
	  var stepLength = Object.keys(state.wizard.wizard.steps).length;
	  return {
	    activeStep: state.wizard.activeStep,
	    stepLength: stepLength,
	    lastStep: stepLength - 1 === state.wizard.activeStep,
	    fields: state.wizard.wizard.fields,
	    sourceId: state.wizard.wizard.sourceId,
	    formDefinitionId: state.wizard.wizard.formDefinitionId,
	    meta: state.wizard.wizard.meta,
	    wizardTitle: state.wizard.wizard.title,
	    onlineOverrideLabel: activeFilingMethods ? activeFilingMethods[0] && activeFilingMethods[0].onlineButtonLabel : '',
	    printOverrideLabel: activeFilingMethods ? activeFilingMethods[0] && activeFilingMethods[0].printButtonLabel : '',
	    signerOverrideLabel: activeFilingMethods ? activeFilingMethods[0] && activeFilingMethods[0].signerButtonLabel : '',
	    activeUploadAndSubmitField: activeFilingMethods ? activeFilingMethods[0] || {} : {},
	    validating: state.wizard.validating,
	    draftId: state.wizard.draftId,
	    savingDraft: state.wizard.savingDraft,
	    readOnly: state.wizard.readOnly,
	    currentStepIsValid: state.wizard.wizard.steps[state.wizard.wizard.stepOrder[state.wizard.activeStep]].isValid,
	    mode: state.wizard.mode,
	    amendmentNum: state.wizard.wizard.amendmentNum,
	    preview: state.wizard.preview,
	    docTitleSrc: state.wizard.wizard.docTitleSrc,
	    docId: state.wizard.wizard.docId,
	    formTitle: state.wizard.wizard.formTitle,
	    filingMethod: method,
	    category: state.wizard.wizard.category,
	    correctionMode: state.wizard.correctionMode,
	    wizardState: state.wizard,
	    internalReviewRequired: state.wizard.wizard.internalReviewRequired,
	    wizard: state.wizard,
	    currentUserGroup: state.auth.USER_GROUP,
	    feeDescription: state.wizard.wizard.feeDescription,
	    uploading: state.wizard.uploading,
	    entryTypeChanged: state.wizard.readOnly ? !(0, _deepEqual2.default)(state.wizard.diff.original.UPLOADS.method, method) : false,
	    draftsDisabled: state.wizard.wizard.draftsDisabled,
	    isMobile: state.app.isMobile,
	    signatureValues: state.wizard.signatureValues,
	    signature: state.wizard.signature,
	    submitting: state.wizard.submitting
	  };
	}, {
	  validateAndSetActiveStep: _WizardActions.validateAndSetActiveStep,
	  resolveWizardAttributesLogic: _WizardActions.resolveWizardAttributesLogic,
	  saveRecord: _WizardActions.saveRecord,
	  saveDraft: _WizardActions.saveDraft,
	  saveRecordWithSignatures: _WizardActions.saveRecordWithSignatures,
	  calculateInternalReview: _WizardActions.calculateInternalReview,
	  setActiveStep: _WizardActions.setActiveStep,
	  reconstructWizardWithValues: _WizardActions.reconstructWizardWithValues,
	  setErrorToast: _actions.setErrorToast,
	  setWizardSubmitted: _WizardActions.setWizardSubmitted,
	  setWizardSubmitting: _WizardActions.setWizardSubmitting,
	  setWizardSignatureErrors: _WizardActions.setWizardSignatureErrors,
	  setGenericSuccess: _WizardActions.setGenericSuccess,
	  setCartQuantity: _actions.setCartQuantity,
	  announce: _actions.announce
	})(Toolbar);

/***/ },
/* 473 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.uploadFile = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(7);
	
	var _WizardActions = __webpack_require__(36);
	
	var _requests = __webpack_require__(6);
	
	var _utilities = __webpack_require__(8);
	
	var _cloudUpload = __webpack_require__(547);
	
	var _cloudUpload2 = _interopRequireDefault(_cloudUpload);
	
	var _shortid = __webpack_require__(22);
	
	var _shortid2 = _interopRequireDefault(_shortid);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var MAX_FILE_UPLOAD_SIZE = (10000000) || 10000000;
	var UPLOAD_FILE_FORMAT_MERGEABLE_ERROR = ({"NODE_ENV":"production","BUILD_DATE":"2025-08-27T15:15:31.687Z","BUILD_NUMBER":"Not Provided","GIT_VERSION":"v1.3.0-381-ga81e29b08","GIT_COMMIT_HASH":"a81e29b085c9268ffd96c78eb734365802722741","GIT_BRANCH":"beta","PUBLIC_URL":"","STATE_ABBR":"MT","STATE_NAME":"Montana","STATE_ORG_TITLE":"Secretary of State","LOGIN_HEADER_IMG_PATH":"","HOME_IMG_FILENAME":"montana.jpg","FAVICON_FILE_NAME":"favicon.ico","ALLOW_E_SIGN_ON_CORRECTIONS":true,"THIRD_PARTY_SIGNING_ALLOWED":false,"MY_ACCOUNT_SAVE_AND_CLOSE_BUTTON":true,"IE_DEPRECATED_MESSAGE":"Internet Explorer is not supported. Please select a supported browser below to access this website.","ADDITIONAL_ROUTES":{"dataRequests":true,"farmBill":true,"apostille":true,"externalHelp":"https://sosmt.gov/business/help-center/","systemAdministration":[{"title":"Saved Payments","parameter":"saved-payments","componentName":"SavedPayments"}]},"SUBROUTES":[{"label":"Business","component":"Business","parameter":"business","myWorkQueueSearch":false,"sourceTypeId":54,"searchMustHaveOneOf":["FILING_TYPE_ID","STATUS_ID","STATE","search"],"serverWebSearchDescription":true,"serverWorkQueueDescription":true,"serverMyRecordsDescription":true,"searchPlaceholder":"Search by name or filing number (X########)","allowEmptySearchTerm":true,"requestCertificateAlternateLabel":"Request Information","fileAmendmentButtonLabel":"Filing Actions","advancedSearchParameters":[{"type":"radio","name":"QUERY_TYPE_ID","defaultValue":1010,"options":[{"value":1010,"label":"Starts with"},{"value":1011,"label":"Contains"},{"value":1012,"label":" Word Contains"}]},{"type":"serverSelect","name":"FILING_TYPE_ID","optionsSrc":"FILING_TYPES","label":"Entity Type","placeholder":"All","defaultValue":"0"},{"type":"serverSelect","name":"FILING_SUBTYPE_ID","optionsSrc":"FILING_SUBTYPES","label":"Entity Subtype","overrideSubOptionsSrcFromParameterName":"FILING_TYPE_ID","placeholder":"All","defaultValue":"0"},{"type":"serverSelect","name":"STATUS_ID","optionsSrc":"FILING_STATUS_WITHOUT_ALL","label":"Status","placeholder":"All","defaultValue":"0"},{"type":"serverSelect","name":"STATE","optionsSrc":"STATE","label":"State","placeholder":"All","defaultValue":""},{"type":"serverSelect","name":"COUNTY","optionsSrc":"COUNTY_SUBOPTION","label":"County","overrideSubOptionsSrcFromParameterName":"STATE","placeholder":"All","defaultValue":""},{"type":"checkbox","name":"CRA_SEARCH_YN","defaultValue":false,"label":"Search by Registered Agent PID"},{"type":"dateRange","name":"FILING_DATE","label":"Registration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}},{"type":"dateRange","name":"EXPIRATION_DATE","label":"Expiration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}}],"myRecordsFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Active"},{"value":2,"label":"Inactive"},{"value":3,"label":"Pending"}]},{"type":"dateRange","name":"DATE_RANGE","label":"Date range","defaultValue":{"start":null,"end":null}}],"myWorkQueueFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Approved"},{"value":2,"label":"Pending Online Payment"},{"value":3,"label":"Pending Review"},{"value":4,"label":"Needs Correction"},{"value":5,"label":"Rejected"},{"value":6,"label":"Draft"}]},{"type":"dateRange","name":"DATE_RANGE","label":"Date range","defaultValue":{"start":null,"end":null}}]},{"label":"Notary","component":"Notary","parameter":"notary","sourceTypeId":850,"myWorkQueueSearch":false,"allowEmptySearchTerm":true,"requestCertificateAlternateLabel":"Download Certificate","fileAmendmentButtonLabel":"Filing Actions","hideNameRequestCertificate":true,"hideAddressRequestCertificate":true,"hideRecordUserManagment":true,"searchPlaceholder":"Search by name or commission number","searchMustHaveOneOf":["CITY","search","SERVICE_TYPE"],"advancedParametersStartOpen":true,"searchIsSortable":true,"advancedSearchParameters":[{"type":"radio","name":"STARTS_WITH_YN","defaultValue":false,"options":[{"value":true,"label":"Starts with"},{"value":false,"label":"Contains"}]},{"type":"checkbox","name":"ACTIVE_ONLY_YN","defaultValue":true,"label":"Active entities only"},{"type":"text","name":"CITY","defaultValue":"","label":"City"},{"type":"select","name":"SERVICE_TYPE","label":"Special Services Offered","defaultValue":0,"options":[{"value":0,"label":"(N/A)"},{"value":6165,"label":"In-Person Electronic Notarization (IPEN)"},{"value":6166,"label":"Remote Online Notarization (RON)"},{"value":6167,"label":"Mobile Notary Services"},{"value":6168,"label":"Remote Ink Notarization (RIN)"}]}]},{"label":"Apostille","component":"Apostille","parameter":"apostille","sourceTypeId":720,"myRecordsSearch":false,"myWorkQueueSearch":false,"disabled":false,"allowedRoutes":["/forms-manager/","/queue/","/forms/"]},{"label":"Liens","component":"UCC","parameter":"ucc","sourceTypeId":1999,"myRecordsSearch":true,"myWorkQueueSearch":true,"fileAmendmentButtonLabel":"Filing Actions","searchPlaceholder":"Search by name or file number","disabled":false,"serverWebSearchDescription":true,"myRecordsDescription":"","workQueueDescription":"","searchDescription":"","hideRecordUserManagment":true,"searchLiensCheckout":false,"advancedSearchParameters":[{"type":"radio","name":"STARTS_WITH_YN","defaultValue":false,"options":[{"value":true,"label":"Starts with"},{"value":false,"label":"Contains"}]},{"type":"select","name":"STATUS","defaultValue":"ALL","label":"Status","options":[{"value":"ACTIVE_UNLAPSED","label":"Active (unlapsed)"},{"value":"ACTIVE_LAPSED_UNLAPSED","label":"Active (lapsed and unlapsed)"}]},{"type":"text","name":"EXCLUDE_VALUES","label":"Exclude Debtor Names (comma separated list of names to exclude)","defaultValue":""},{"type":"dateRange","name":"FILING_DATE","label":"Financing Statement Date","defaultValue":{"start":null,"end":null}},{"type":"dateRange","name":"LAPSE_DATE","label":"Lapse Date","defaultValue":{"start":null,"end":null}},{"type":"text","name":"CITY","label":"Debtor City","defaultValue":""}],"myRecordsFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Approved"},{"value":2,"label":"Pending Online Payment"},{"value":3,"label":"Pending Review"}]},{"type":"select","name":"TYPE","defaultValue":0,"label":"Lien Type","options":[{"value":0,"label":"All"},{"value":1,"label":"UCC"},{"value":2,"label":"EFS"},{"value":3,"label":"Title 71"}]}],"myWorkQueueFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Approved"},{"value":2,"label":"Pending Online Payment"},{"value":3,"label":"Pending Review"},{"value":4,"label":"Pending Print and Mail"},{"value":5,"label":"Rejected"},{"value":6,"label":"Draft"}]},{"type":"select","name":"TYPE","defaultValue":0,"label":"Lien Type","options":[{"value":0,"label":"All"},{"value":1,"label":"UCC"},{"value":2,"label":"EFS"},{"value":3,"label":"Title 71"}]}]},{"label":"Copy Request","component":"copies","parameter":"copies","sourceTypeId":2001,"myRecordsSearch":false,"myWorkQueueSearch":false,"disabled":false,"allowedRoutes":["/forms-manager/","/queue/","/forms/"]},{"label":"Trademark","component":"Trademark","parameter":"trademark","sourceTypeId":810,"showRequestCertificate":true,"searchMustHaveOneOf":["search","EXPIRATION_DATE","FILING_DATE"],"allowEmptySearchTerm":true,"requestCertificateAlternateLabel":"Request Information","fileAmendmentButtonLabel":"Filing Actions","advancedSearchParameters":[{"type":"radio","name":"QUERY_TYPE_ID","defaultValue":1010,"options":[{"value":1010,"label":"Starts with"},{"value":1011,"label":"Contains"},{"value":1012,"label":" Word Contains"}]},{"type":"checkbox","name":"OWNER_SEARCH_YN","defaultValue":false,"label":"Search owners"},{"type":"radio","name":"SERVICE_MARK_YN","label":"Mark Type","defaultValue":"","options":[{"value":"","label":"All Marks"},{"value":"Y","label":"Service Mark"},{"value":"N","label":"Trademark"}]},{"type":"serverSelect","name":"STATUS_ID","optionsSrc":"TYPE_V|TRADEMARK_STATUS_TYPE","label":"Status","placeholder":"All","defaultValue":"0"},{"type":"select","name":"DESIGN_TYPE_ID","options":[{"value":0,"label":"All"},{"value":990,"label":"Words Only"},{"value":991,"label":"Design Only"},{"value":992,"label":"Words and Design"}],"label":"Design Type","defaultValue":"0"},{"type":"dateRange","name":"FILING_DATE","label":"Registered Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}},{"type":"dateRange","name":"EXPIRATION_DATE","label":"Expiration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}}]},{"label":"Business Info Request","component":"InfoRequests","parameter":"info-request","sourceTypeId":167,"allowedRoutes":["/forms-manager/","/queue/","/forms/"]},{"label":"Data Requests","component":"DataRequests","parameter":"data-request","sourceTypeId":0,"allowedRoutes":["/forms-manager/"]},{"label":"CRA","component":"CRA","parameter":"cra","sourceTypeId":157,"myRecordsSearch":false,"searchPlaceholder":"Search by name or registered agent number","allowedRoutes":["/forms-manager/","/forms/","/records/","/queue/","/search/"],"allowEmptySearchTerm":true,"fileAmendmentButtonLabel":"Filing Actions","advancedSearchParameters":[{"type":"radio","name":"QUERY_TYPE_ID","defaultValue":1010,"options":[{"value":1010,"label":"Starts with"},{"value":1011,"label":"Contains"},{"value":1012,"label":" Word Contains"}]},{"type":"dateRange","name":"CRA_DATE","label":"Registration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}},{"type":"select","name":"STATUS_ID","label":"Status","defaultValue":0,"options":[{"value":0,"label":"All"},{"value":121,"label":"Active"},{"value":122,"label":"Inactive"}]},{"type":"select","name":"AGENT_TYPE_ID","label":"Agent Type","defaultValue":0,"options":[{"value":0,"label":"All"},{"value":460,"label":"Registered Agent"},{"value":461,"label":"Commercial Registered Agent"}]}]},{"label":"Farm Bill","component":"FarmBill","parameter":"farm-bill","path":"/lists/farm-bill","sourceTypeId":0,"myRecordsSearch":false,"allowedRules":["/search/"],"disabled":true,"searchDescription":"To perform a search, enter a debtor name. Your search results may include: exact debtor name, variations of that name and any filing that includes your search criteria. Punctuation is ignored.\n\nYou can click on \"Advanced\" to refine your search. Under “Advanced” you can search by crop, year, county and SSN/FEIN. As a registered Farm Bill Buyer with the Montana Secretary of State’s office it is important to maintain the confidentiality of the information contained within the Farm Bill Master List. The Farm Bill Master List reflects personal data, such as Social Security Numbers, which are a key piece of personal identifiable information to assist you in determining the existence of a lien against a specific debtor. The distribution of this information beyond its intended purpose is strictly prohibited.\n\nThe debtor's tax identification number has been hidden for confidentiality reasons. You may continue to search on a tax ID number and return debtors that match your search criteria. The SSN/FEIN must be entered without dashes or spaces.","searchMustHaveOneOf":["search","UCC_FARM_PRODUCT_ID","COUNTY"],"searchPlaceholder":"Search by debtor name","advancedSearchParameters":[{"type":"ServerMultiComplete","label":"Product code name(s)","name":"UCC_FARM_PRODUCT_ID","defaultValue":"","optionsSrc":"UCC_FARM_PRODUCT_V"},{"type":"MultiComplete","label":"Year or Range of Years","name":"YEAR_NUM","optionsSrc":"years","startYear":"1968","defaultValue":[],"preMergeOptions":[{"value":"ALL","label":"All"}]},{"type":"serverSelect","label":"State","name":"STATE","defaultValue":"MONTANA","optionsSrc":"STATE"},{"type":"ServerMultiComplete","label":"County","name":"COUNTY","defaultValue":[],"optionsSrc":"COUNTY","overrideSubOptionsSrcFromParameterName":"STATE"},{"type":"checkbox","name":"TIN_SEARCH_YN","defaultValue":false,"label":"Tax Identification Number Search"},{"type":"checkbox","name":"TIN_SORT_YN","defaultValue":false,"label":"Unique ID Sort"}]}],"SYSTEM_NICKNAME":"Online Services Portal","PAYMENT_METHODS":[{"type":"bypass"},{"type":"iTransact"}],"PAYMENT_ALLOW_AMEX":true,"SYSTEM_ID_LABEL":"System Id","DOUBLE_COLUMN_PUBLIC_LOGIN":true,"INTERNAL_USER_MANAGEMENT":true,"ALLOW_PUBLIC_JSON_IMPORT":false,"MAX_FILE_UPLOAD_SIZE":10000000,"REFUND_TEXT":"","RETURN_TO_HOME_ON_LOGOUT":true,"CURRENT_SOS_NAME":"Christi Jacobsen","LOGO_FILENAME":"mt-sos-logo.png","LOGO_ALT":"Christi Jacobsen, Montana Secretary of State","LOGO_FULL_WIDTH":true,"HOME_HIDE_AUTH_HINT":true,"HOME_TITLE":"Montana Secretary of State","CUSTOM_TAB_TITLE":"Official Montana","HOME_SUBTITLE":"Online Business Services","ENTITY_NAME_CONSENT_DESCRIPTION":"","ALLOW_USER_PROFILE_EDITING":true,"COMPARE_FOREIGN_NAME_IN_ENTITY_NAME_VALIDATION":true,"FOREIGN_NAME_FIELD_NAME":"KIMA_PARENT_NAME_INFO","LOGIN_TITLE":"Montana Secretary of State Online Filing Portal Login","PUBLIC_LOGIN_LABEL":"Username","REVERSE_LOGIN_COLUMNS":true,"LOGIN_SEAL_FILENAME":"seal_white.png","SEPARATE_USERNAME_AND_EMAIL":true,"CREATE_ACCOUNT_BUTTON_ALIGN_LEFT":true,"CREATE_ACCOUNT_BUTTON_TEXT":"CREATE AN ACCOUNT","PASSWORD_CUSTOM_ERROR_TEXT":"The password must meet all requirements","ACCOUNT_CREATED_MESSAGE":"Please check your email to verify your account to login and allow a few minutes for this message to arrive. Check your junk/spam folders if you do not find the email in your inbox.","PUBLIC_LOGIN_PLACEHOLDER":" ","DISABLE_DEFAULT_PAYMENT_RADIO":true,"CUSTOM_RESET_PASSWORD_ERROR_MESSAGE":"Username invalid - no account found","PUBLIC_LOGIN_CREATE_DESCRIPTION":"### Existing User:\n\n  - Enter your username and password to login.  \n\n\n  #### - OR -  \n\n\n\n  - Forgot password? Click 'Reset Password' and follow the prompts.\n  - Forgot username? Click 'Forgot Username' and follow the prompts.  \n\n\n  ### New User:\n  ","LOGIN_HELP_LINK":"https://sosmt.gov/business/how-do-i/","LOGIN_HELP_LINK_TEXT":"Need Help?","FORGOT_USERNAME_TEXT":"Forgot Username?","LOGIN_ACTIVE_DIRECTORY_TEXT":"State User Login","MULTIPLE_LOGIN_METHODS":true,"HAS_ACTIVE_DIRECTORY_LOGIN":true,"RESET_PASSWORD_WITH_USERNAME":true,"DOWNLOAD_LINK":true,"SHOW_USERNAME_ACCOUNT_CREATE":true,"SHOW_SCROLL_DOWN_ARROW":true,"SHOW_ADDRESS_ACCOUNT_CREATE":true,"TWO_COLUMN_ACCOUNT_CREATE":true,"RESET_PASSWORD_TIP":"A link to change your password has been sent to your email. Please allow a few minutes for this message to arrive. Please check your junk/spam folders if you do not find the email in your inbox.","FORGOT_PASSWORD_LINK_TEXT":"Reset Password","PHONE_NUMBER_OPTIONAL_ACCOUNT_CREATE":true,"SHOW_REQUIRED_INDICATOR_ACCOUNT_CREATE":true,"PASSWORD_REQUIREMENTS_ACCOUNT_CREATE":"\n    <ul>\n      <li>MUST contain at least 8 characters (12+ recommended)</li>\n      <li>MUST contain at least one uppercase letter.</li>\n      <li>MUST contain at least one lowercase letter.</li>\n      <li>MUST contain at least one number.</li>\n      <li>MUST contain at least one special character (!”#$%&'()*+,-./:;<=>?</li>\n    </ul>\n  ","ALLOW_CERTIFICATION_REQUEST":true,"ALLOW_PUBLIC_CERTIFICATE_REQUEST":true,"ALLOW_COPY_REQUEST":false,"ALLOW_CORRECTION_STYLING":true,"HIDE_DEPRECATION_WARNING":false,"AMEND_ROUTE_PUBLIC":true,"SEAL_FILENAME":"seal.png","SHOPPING_CART":true,"ALLOW_PAYMENT_UPDATE_WITH_EMPTY_CART":true,"RA_EMAIL":true,"RA_WEBSITE":true,"RA_NO_DEFAULT_TYPE":true,"RA_ADDRESS_LABEL":"Street Address","RA_TYPE_SELECTION_DEFAULT":true,"RA_DEFAULT_TYPE":"460","RA_OVERRIDE_TYPE_WITH_DEFAULT":true,"RA_PRINCIPAL_ADDRESS_AMS":true,"UPLOAD_AND_SUBMIT_HIDE_IF_ONE_OPTION":true,"PAYMENT_PROCESSING_MESSAGE":"Your payment is processing - Do not close your browser or click the back button","CHECKOUT_BUTTON_WHEN_PROCESSING_TEXT":"Processing","EFS_CROP_PICKER_NONE_LABEL":"Lien Duration","DISALLOWED_WIZARD_PIECES":["FormationLocale"],"REPEATER_SHOW_EDIT_BUTTON":true,"DATA_REQUEST_PAGE_TITLE":"Data Requests and Subscriptions","DATA_REQUEST_SIDEBAR_LABEL":"Data Requests & Subscriptions","LOGIN_REDIRECTS_TO_EPASS":false,"LOGIN_REDIRECTS_TO_ACTIVE_DIRECTORY":true,"LOGIN_ACTIVE_DIRECTORY_LINK":true,"FETCH_EDIT_USER_LINK":false,"LISTS_FETCH_AVAILABLE_LISTS":true,"POST_WIZARD_SUBMIT_REDIRECT_URL":"/","PIN_REQUEST_ATTESTATIONS":true,"PIN_REQUEST_DESCRIPTION":"Click **Request PIN** to have a new PIN sent to the account holder's email address on file.","OWNERSHIP_REQUEST_DESCRIPTION":"To become an **authorized user** of this record, a current **AUTHORIZED USER** will need to grant you access. To request access, click **Request Access** below.","PIN_REQUEST_SUCCESS_MESSAGE":"The PIN you have requested for this entity has been sent to the email associated with your user account.  You should receive the PIN in approximately 3-5 minutes, depending on your email service provider.","APOSTILLE_HEADER_LABEL":"Verification Information","APOSTILLE_NUMBER_LABEL":"Apostille/Authentication","APOSTILLE_CITY_STATE_OVERRIDE":"HELENA, MT","APOSTILLE_FILING_DATE_LABEL":"Issue Date","APOSTILLE_CITY_STATE_IN_CERTIFIED":true,"NOTARY_EXISTING_FILING":true,"ALLOW_REVOKE_OWN_ACCESS_ONLY":false,"HIDE_CANCEL_ON_ONETIME_DATA_REQUESTS":true,"DATA_REQUESTS_IN_SHOPPING_CART":true,"WQ_ALLOW_EDIT_PENDING_PAYMENT":true,"WQ_CONFIRM_ON_DELETE":true,"WQ_DELETE_CONFIRM_MESSAGE":"Deleting this filing will forfeit any money already paid to the Secretary of State. This action is permanent and cannot be undone, are you sure you would like to delete?","PASS_ITEM_GUIDS_ON_CHECKOUT":true,"FORM_REVISION_HISTORY":true,"CHECKOUT_DISCLAIMER":"By entering your credit card and/or checking account information you (i) state that **you are an authorized user** of the credit card and/or electronic check and that the associated information entered (e.g., account holder name, account number, billing address) is accurate, (ii) **you authorize payment processor to charge the amount you have requested** to your credit card and/or funding account, and (iii) **acknowledge if a charge is declined or reversed you may also be assessed a customary charge** by the payment processor for such transactions.","FARM_BILL_SEARCH_CONFIDENTIAL":"As a registered Farm Bill Buyer with the Montana Secretary of State’s office it is important to maintain the confidentiality of the information contained within the Farm Bill Master List. The Farm Bill Master List reflects personal data, such as Social Security Numbers, which are a key piece of personal identifiable information to assist you in determining the existence of a lien against a specific debtor. The distribution of this information beyond its intended purpose is strictly prohibited.\n\n**The debtor's tax identification number has been hidden for confidentiality reasons. You may continue to search on a tax ID number and return debtors that match your search criteria. The SSN/FEIN must be entered without dashes or spaces.  If you need access to the tax identification number to clearly identify the debtor, please contact the UCC unit at (406) 444-3665.**","VIEW_HISTORY_BUTTON_ALT_TEXT":"View Filings","WIZARD_ERROR_TITLE_MESSAGE":"Form Error","FARM_BILL_SEARCH_INTERACTIVE":true,"USE_FARM_BILL_API":true,"DISALLOW_ASSIGN_SELF_AS_RA":true,"DISALLOW_ASSIGN_SELF_AS_PRINCIPAL":true,"USE_TRADEMARK_OWNER_VALIDATION":true,"USE_ALTERNATIVE_FOREIGN_ADDRESS_LABELS":true,"MY_RECEIPTS_FILTER":[{"type":"dateRange","name":"DATE_RANGE","label":"Date range","defaultValue":{"start":null,"end":null}},{"type":"text","name":"REF_NUM","defaultValue":"","label":"Reference Number"},{"type":"text","name":"RECEIPT_NUM","defaultValue":"","label":"Receipt Id"},{"type":"text","name":"AMOUNT","defaultValue":"","label":"Amount"},{"type":"select","name":"TYPE","defaultValue":"","label":"Payment Type","options":[{"value":"","label":"All"},{"value":"CC","label":"Credit Card"},{"value":"Check","label":"Check"}]}],"MY_RECEIPTS_SHOW_IN_SIDEBAR":true,"SHOW_MY_RECEIPTS_HELPER_TEXT":true,"MY_RECEIPTS_HELPER_LABEL":"About Receipt Search","MY_RECEIPTS_HELPER_TEXT":"You can search for receipts based on their descriptions, including the items paid for on the receipt. Use the filters to search for or filter specific information.","FARM_BILL_SUBLINK":{"label":"Farm Bill","component":"FarmBill","parameter":"farm-bill","path":"/lists/farm-bill","sourceTypeId":0,"myRecordsSearch":false,"allowedRules":["/search/"],"disabled":true,"searchDescription":"To perform a search, enter a debtor name. Your search results may include: exact debtor name, variations of that name and any filing that includes your search criteria. Punctuation is ignored.\n\nYou can click on \"Advanced\" to refine your search. Under “Advanced” you can search by crop, year, county and SSN/FEIN. As a registered Farm Bill Buyer with the Montana Secretary of State’s office it is important to maintain the confidentiality of the information contained within the Farm Bill Master List. The Farm Bill Master List reflects personal data, such as Social Security Numbers, which are a key piece of personal identifiable information to assist you in determining the existence of a lien against a specific debtor. The distribution of this information beyond its intended purpose is strictly prohibited.\n\nThe debtor's tax identification number has been hidden for confidentiality reasons. You may continue to search on a tax ID number and return debtors that match your search criteria. The SSN/FEIN must be entered without dashes or spaces.","searchMustHaveOneOf":["search","UCC_FARM_PRODUCT_ID","COUNTY"],"searchPlaceholder":"Search by debtor name","advancedSearchParameters":[{"type":"ServerMultiComplete","label":"Product code name(s)","name":"UCC_FARM_PRODUCT_ID","defaultValue":"","optionsSrc":"UCC_FARM_PRODUCT_V"},{"type":"MultiComplete","label":"Year or Range of Years","name":"YEAR_NUM","optionsSrc":"years","startYear":"1968","defaultValue":[],"preMergeOptions":[{"value":"ALL","label":"All"}]},{"type":"serverSelect","label":"State","name":"STATE","defaultValue":"MONTANA","optionsSrc":"STATE"},{"type":"ServerMultiComplete","label":"County","name":"COUNTY","defaultValue":[],"optionsSrc":"COUNTY","overrideSubOptionsSrcFromParameterName":"STATE"},{"type":"checkbox","name":"TIN_SEARCH_YN","defaultValue":false,"label":"Tax Identification Number Search"},{"type":"checkbox","name":"TIN_SORT_YN","defaultValue":false,"label":"Unique ID Sort"}]},"ALLOW_ADDRESS_VALIDATION_BYPASS_OPTION":true,"DEFAULT_ADDRESS_VALIDATION_BYPASS_OPTION_CHECKED":true}).UPLOAD_FILE_FORMAT_MERGEABLE_ERROR;
	var UPLOAD_FILE_SIZE_MERGEABLE_ERROR = ({"NODE_ENV":"production","BUILD_DATE":"2025-08-27T15:15:31.687Z","BUILD_NUMBER":"Not Provided","GIT_VERSION":"v1.3.0-381-ga81e29b08","GIT_COMMIT_HASH":"a81e29b085c9268ffd96c78eb734365802722741","GIT_BRANCH":"beta","PUBLIC_URL":"","STATE_ABBR":"MT","STATE_NAME":"Montana","STATE_ORG_TITLE":"Secretary of State","LOGIN_HEADER_IMG_PATH":"","HOME_IMG_FILENAME":"montana.jpg","FAVICON_FILE_NAME":"favicon.ico","ALLOW_E_SIGN_ON_CORRECTIONS":true,"THIRD_PARTY_SIGNING_ALLOWED":false,"MY_ACCOUNT_SAVE_AND_CLOSE_BUTTON":true,"IE_DEPRECATED_MESSAGE":"Internet Explorer is not supported. Please select a supported browser below to access this website.","ADDITIONAL_ROUTES":{"dataRequests":true,"farmBill":true,"apostille":true,"externalHelp":"https://sosmt.gov/business/help-center/","systemAdministration":[{"title":"Saved Payments","parameter":"saved-payments","componentName":"SavedPayments"}]},"SUBROUTES":[{"label":"Business","component":"Business","parameter":"business","myWorkQueueSearch":false,"sourceTypeId":54,"searchMustHaveOneOf":["FILING_TYPE_ID","STATUS_ID","STATE","search"],"serverWebSearchDescription":true,"serverWorkQueueDescription":true,"serverMyRecordsDescription":true,"searchPlaceholder":"Search by name or filing number (X########)","allowEmptySearchTerm":true,"requestCertificateAlternateLabel":"Request Information","fileAmendmentButtonLabel":"Filing Actions","advancedSearchParameters":[{"type":"radio","name":"QUERY_TYPE_ID","defaultValue":1010,"options":[{"value":1010,"label":"Starts with"},{"value":1011,"label":"Contains"},{"value":1012,"label":" Word Contains"}]},{"type":"serverSelect","name":"FILING_TYPE_ID","optionsSrc":"FILING_TYPES","label":"Entity Type","placeholder":"All","defaultValue":"0"},{"type":"serverSelect","name":"FILING_SUBTYPE_ID","optionsSrc":"FILING_SUBTYPES","label":"Entity Subtype","overrideSubOptionsSrcFromParameterName":"FILING_TYPE_ID","placeholder":"All","defaultValue":"0"},{"type":"serverSelect","name":"STATUS_ID","optionsSrc":"FILING_STATUS_WITHOUT_ALL","label":"Status","placeholder":"All","defaultValue":"0"},{"type":"serverSelect","name":"STATE","optionsSrc":"STATE","label":"State","placeholder":"All","defaultValue":""},{"type":"serverSelect","name":"COUNTY","optionsSrc":"COUNTY_SUBOPTION","label":"County","overrideSubOptionsSrcFromParameterName":"STATE","placeholder":"All","defaultValue":""},{"type":"checkbox","name":"CRA_SEARCH_YN","defaultValue":false,"label":"Search by Registered Agent PID"},{"type":"dateRange","name":"FILING_DATE","label":"Registration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}},{"type":"dateRange","name":"EXPIRATION_DATE","label":"Expiration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}}],"myRecordsFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Active"},{"value":2,"label":"Inactive"},{"value":3,"label":"Pending"}]},{"type":"dateRange","name":"DATE_RANGE","label":"Date range","defaultValue":{"start":null,"end":null}}],"myWorkQueueFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Approved"},{"value":2,"label":"Pending Online Payment"},{"value":3,"label":"Pending Review"},{"value":4,"label":"Needs Correction"},{"value":5,"label":"Rejected"},{"value":6,"label":"Draft"}]},{"type":"dateRange","name":"DATE_RANGE","label":"Date range","defaultValue":{"start":null,"end":null}}]},{"label":"Notary","component":"Notary","parameter":"notary","sourceTypeId":850,"myWorkQueueSearch":false,"allowEmptySearchTerm":true,"requestCertificateAlternateLabel":"Download Certificate","fileAmendmentButtonLabel":"Filing Actions","hideNameRequestCertificate":true,"hideAddressRequestCertificate":true,"hideRecordUserManagment":true,"searchPlaceholder":"Search by name or commission number","searchMustHaveOneOf":["CITY","search","SERVICE_TYPE"],"advancedParametersStartOpen":true,"searchIsSortable":true,"advancedSearchParameters":[{"type":"radio","name":"STARTS_WITH_YN","defaultValue":false,"options":[{"value":true,"label":"Starts with"},{"value":false,"label":"Contains"}]},{"type":"checkbox","name":"ACTIVE_ONLY_YN","defaultValue":true,"label":"Active entities only"},{"type":"text","name":"CITY","defaultValue":"","label":"City"},{"type":"select","name":"SERVICE_TYPE","label":"Special Services Offered","defaultValue":0,"options":[{"value":0,"label":"(N/A)"},{"value":6165,"label":"In-Person Electronic Notarization (IPEN)"},{"value":6166,"label":"Remote Online Notarization (RON)"},{"value":6167,"label":"Mobile Notary Services"},{"value":6168,"label":"Remote Ink Notarization (RIN)"}]}]},{"label":"Apostille","component":"Apostille","parameter":"apostille","sourceTypeId":720,"myRecordsSearch":false,"myWorkQueueSearch":false,"disabled":false,"allowedRoutes":["/forms-manager/","/queue/","/forms/"]},{"label":"Liens","component":"UCC","parameter":"ucc","sourceTypeId":1999,"myRecordsSearch":true,"myWorkQueueSearch":true,"fileAmendmentButtonLabel":"Filing Actions","searchPlaceholder":"Search by name or file number","disabled":false,"serverWebSearchDescription":true,"myRecordsDescription":"","workQueueDescription":"","searchDescription":"","hideRecordUserManagment":true,"searchLiensCheckout":false,"advancedSearchParameters":[{"type":"radio","name":"STARTS_WITH_YN","defaultValue":false,"options":[{"value":true,"label":"Starts with"},{"value":false,"label":"Contains"}]},{"type":"select","name":"STATUS","defaultValue":"ALL","label":"Status","options":[{"value":"ACTIVE_UNLAPSED","label":"Active (unlapsed)"},{"value":"ACTIVE_LAPSED_UNLAPSED","label":"Active (lapsed and unlapsed)"}]},{"type":"text","name":"EXCLUDE_VALUES","label":"Exclude Debtor Names (comma separated list of names to exclude)","defaultValue":""},{"type":"dateRange","name":"FILING_DATE","label":"Financing Statement Date","defaultValue":{"start":null,"end":null}},{"type":"dateRange","name":"LAPSE_DATE","label":"Lapse Date","defaultValue":{"start":null,"end":null}},{"type":"text","name":"CITY","label":"Debtor City","defaultValue":""}],"myRecordsFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Approved"},{"value":2,"label":"Pending Online Payment"},{"value":3,"label":"Pending Review"}]},{"type":"select","name":"TYPE","defaultValue":0,"label":"Lien Type","options":[{"value":0,"label":"All"},{"value":1,"label":"UCC"},{"value":2,"label":"EFS"},{"value":3,"label":"Title 71"}]}],"myWorkQueueFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Approved"},{"value":2,"label":"Pending Online Payment"},{"value":3,"label":"Pending Review"},{"value":4,"label":"Pending Print and Mail"},{"value":5,"label":"Rejected"},{"value":6,"label":"Draft"}]},{"type":"select","name":"TYPE","defaultValue":0,"label":"Lien Type","options":[{"value":0,"label":"All"},{"value":1,"label":"UCC"},{"value":2,"label":"EFS"},{"value":3,"label":"Title 71"}]}]},{"label":"Copy Request","component":"copies","parameter":"copies","sourceTypeId":2001,"myRecordsSearch":false,"myWorkQueueSearch":false,"disabled":false,"allowedRoutes":["/forms-manager/","/queue/","/forms/"]},{"label":"Trademark","component":"Trademark","parameter":"trademark","sourceTypeId":810,"showRequestCertificate":true,"searchMustHaveOneOf":["search","EXPIRATION_DATE","FILING_DATE"],"allowEmptySearchTerm":true,"requestCertificateAlternateLabel":"Request Information","fileAmendmentButtonLabel":"Filing Actions","advancedSearchParameters":[{"type":"radio","name":"QUERY_TYPE_ID","defaultValue":1010,"options":[{"value":1010,"label":"Starts with"},{"value":1011,"label":"Contains"},{"value":1012,"label":" Word Contains"}]},{"type":"checkbox","name":"OWNER_SEARCH_YN","defaultValue":false,"label":"Search owners"},{"type":"radio","name":"SERVICE_MARK_YN","label":"Mark Type","defaultValue":"","options":[{"value":"","label":"All Marks"},{"value":"Y","label":"Service Mark"},{"value":"N","label":"Trademark"}]},{"type":"serverSelect","name":"STATUS_ID","optionsSrc":"TYPE_V|TRADEMARK_STATUS_TYPE","label":"Status","placeholder":"All","defaultValue":"0"},{"type":"select","name":"DESIGN_TYPE_ID","options":[{"value":0,"label":"All"},{"value":990,"label":"Words Only"},{"value":991,"label":"Design Only"},{"value":992,"label":"Words and Design"}],"label":"Design Type","defaultValue":"0"},{"type":"dateRange","name":"FILING_DATE","label":"Registered Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}},{"type":"dateRange","name":"EXPIRATION_DATE","label":"Expiration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}}]},{"label":"Business Info Request","component":"InfoRequests","parameter":"info-request","sourceTypeId":167,"allowedRoutes":["/forms-manager/","/queue/","/forms/"]},{"label":"Data Requests","component":"DataRequests","parameter":"data-request","sourceTypeId":0,"allowedRoutes":["/forms-manager/"]},{"label":"CRA","component":"CRA","parameter":"cra","sourceTypeId":157,"myRecordsSearch":false,"searchPlaceholder":"Search by name or registered agent number","allowedRoutes":["/forms-manager/","/forms/","/records/","/queue/","/search/"],"allowEmptySearchTerm":true,"fileAmendmentButtonLabel":"Filing Actions","advancedSearchParameters":[{"type":"radio","name":"QUERY_TYPE_ID","defaultValue":1010,"options":[{"value":1010,"label":"Starts with"},{"value":1011,"label":"Contains"},{"value":1012,"label":" Word Contains"}]},{"type":"dateRange","name":"CRA_DATE","label":"Registration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}},{"type":"select","name":"STATUS_ID","label":"Status","defaultValue":0,"options":[{"value":0,"label":"All"},{"value":121,"label":"Active"},{"value":122,"label":"Inactive"}]},{"type":"select","name":"AGENT_TYPE_ID","label":"Agent Type","defaultValue":0,"options":[{"value":0,"label":"All"},{"value":460,"label":"Registered Agent"},{"value":461,"label":"Commercial Registered Agent"}]}]},{"label":"Farm Bill","component":"FarmBill","parameter":"farm-bill","path":"/lists/farm-bill","sourceTypeId":0,"myRecordsSearch":false,"allowedRules":["/search/"],"disabled":true,"searchDescription":"To perform a search, enter a debtor name. Your search results may include: exact debtor name, variations of that name and any filing that includes your search criteria. Punctuation is ignored.\n\nYou can click on \"Advanced\" to refine your search. Under “Advanced” you can search by crop, year, county and SSN/FEIN. As a registered Farm Bill Buyer with the Montana Secretary of State’s office it is important to maintain the confidentiality of the information contained within the Farm Bill Master List. The Farm Bill Master List reflects personal data, such as Social Security Numbers, which are a key piece of personal identifiable information to assist you in determining the existence of a lien against a specific debtor. The distribution of this information beyond its intended purpose is strictly prohibited.\n\nThe debtor's tax identification number has been hidden for confidentiality reasons. You may continue to search on a tax ID number and return debtors that match your search criteria. The SSN/FEIN must be entered without dashes or spaces.","searchMustHaveOneOf":["search","UCC_FARM_PRODUCT_ID","COUNTY"],"searchPlaceholder":"Search by debtor name","advancedSearchParameters":[{"type":"ServerMultiComplete","label":"Product code name(s)","name":"UCC_FARM_PRODUCT_ID","defaultValue":"","optionsSrc":"UCC_FARM_PRODUCT_V"},{"type":"MultiComplete","label":"Year or Range of Years","name":"YEAR_NUM","optionsSrc":"years","startYear":"1968","defaultValue":[],"preMergeOptions":[{"value":"ALL","label":"All"}]},{"type":"serverSelect","label":"State","name":"STATE","defaultValue":"MONTANA","optionsSrc":"STATE"},{"type":"ServerMultiComplete","label":"County","name":"COUNTY","defaultValue":[],"optionsSrc":"COUNTY","overrideSubOptionsSrcFromParameterName":"STATE"},{"type":"checkbox","name":"TIN_SEARCH_YN","defaultValue":false,"label":"Tax Identification Number Search"},{"type":"checkbox","name":"TIN_SORT_YN","defaultValue":false,"label":"Unique ID Sort"}]}],"SYSTEM_NICKNAME":"Online Services Portal","PAYMENT_METHODS":[{"type":"bypass"},{"type":"iTransact"}],"PAYMENT_ALLOW_AMEX":true,"SYSTEM_ID_LABEL":"System Id","DOUBLE_COLUMN_PUBLIC_LOGIN":true,"INTERNAL_USER_MANAGEMENT":true,"ALLOW_PUBLIC_JSON_IMPORT":false,"MAX_FILE_UPLOAD_SIZE":10000000,"REFUND_TEXT":"","RETURN_TO_HOME_ON_LOGOUT":true,"CURRENT_SOS_NAME":"Christi Jacobsen","LOGO_FILENAME":"mt-sos-logo.png","LOGO_ALT":"Christi Jacobsen, Montana Secretary of State","LOGO_FULL_WIDTH":true,"HOME_HIDE_AUTH_HINT":true,"HOME_TITLE":"Montana Secretary of State","CUSTOM_TAB_TITLE":"Official Montana","HOME_SUBTITLE":"Online Business Services","ENTITY_NAME_CONSENT_DESCRIPTION":"","ALLOW_USER_PROFILE_EDITING":true,"COMPARE_FOREIGN_NAME_IN_ENTITY_NAME_VALIDATION":true,"FOREIGN_NAME_FIELD_NAME":"KIMA_PARENT_NAME_INFO","LOGIN_TITLE":"Montana Secretary of State Online Filing Portal Login","PUBLIC_LOGIN_LABEL":"Username","REVERSE_LOGIN_COLUMNS":true,"LOGIN_SEAL_FILENAME":"seal_white.png","SEPARATE_USERNAME_AND_EMAIL":true,"CREATE_ACCOUNT_BUTTON_ALIGN_LEFT":true,"CREATE_ACCOUNT_BUTTON_TEXT":"CREATE AN ACCOUNT","PASSWORD_CUSTOM_ERROR_TEXT":"The password must meet all requirements","ACCOUNT_CREATED_MESSAGE":"Please check your email to verify your account to login and allow a few minutes for this message to arrive. Check your junk/spam folders if you do not find the email in your inbox.","PUBLIC_LOGIN_PLACEHOLDER":" ","DISABLE_DEFAULT_PAYMENT_RADIO":true,"CUSTOM_RESET_PASSWORD_ERROR_MESSAGE":"Username invalid - no account found","PUBLIC_LOGIN_CREATE_DESCRIPTION":"### Existing User:\n\n  - Enter your username and password to login.  \n\n\n  #### - OR -  \n\n\n\n  - Forgot password? Click 'Reset Password' and follow the prompts.\n  - Forgot username? Click 'Forgot Username' and follow the prompts.  \n\n\n  ### New User:\n  ","LOGIN_HELP_LINK":"https://sosmt.gov/business/how-do-i/","LOGIN_HELP_LINK_TEXT":"Need Help?","FORGOT_USERNAME_TEXT":"Forgot Username?","LOGIN_ACTIVE_DIRECTORY_TEXT":"State User Login","MULTIPLE_LOGIN_METHODS":true,"HAS_ACTIVE_DIRECTORY_LOGIN":true,"RESET_PASSWORD_WITH_USERNAME":true,"DOWNLOAD_LINK":true,"SHOW_USERNAME_ACCOUNT_CREATE":true,"SHOW_SCROLL_DOWN_ARROW":true,"SHOW_ADDRESS_ACCOUNT_CREATE":true,"TWO_COLUMN_ACCOUNT_CREATE":true,"RESET_PASSWORD_TIP":"A link to change your password has been sent to your email. Please allow a few minutes for this message to arrive. Please check your junk/spam folders if you do not find the email in your inbox.","FORGOT_PASSWORD_LINK_TEXT":"Reset Password","PHONE_NUMBER_OPTIONAL_ACCOUNT_CREATE":true,"SHOW_REQUIRED_INDICATOR_ACCOUNT_CREATE":true,"PASSWORD_REQUIREMENTS_ACCOUNT_CREATE":"\n    <ul>\n      <li>MUST contain at least 8 characters (12+ recommended)</li>\n      <li>MUST contain at least one uppercase letter.</li>\n      <li>MUST contain at least one lowercase letter.</li>\n      <li>MUST contain at least one number.</li>\n      <li>MUST contain at least one special character (!”#$%&'()*+,-./:;<=>?</li>\n    </ul>\n  ","ALLOW_CERTIFICATION_REQUEST":true,"ALLOW_PUBLIC_CERTIFICATE_REQUEST":true,"ALLOW_COPY_REQUEST":false,"ALLOW_CORRECTION_STYLING":true,"HIDE_DEPRECATION_WARNING":false,"AMEND_ROUTE_PUBLIC":true,"SEAL_FILENAME":"seal.png","SHOPPING_CART":true,"ALLOW_PAYMENT_UPDATE_WITH_EMPTY_CART":true,"RA_EMAIL":true,"RA_WEBSITE":true,"RA_NO_DEFAULT_TYPE":true,"RA_ADDRESS_LABEL":"Street Address","RA_TYPE_SELECTION_DEFAULT":true,"RA_DEFAULT_TYPE":"460","RA_OVERRIDE_TYPE_WITH_DEFAULT":true,"RA_PRINCIPAL_ADDRESS_AMS":true,"UPLOAD_AND_SUBMIT_HIDE_IF_ONE_OPTION":true,"PAYMENT_PROCESSING_MESSAGE":"Your payment is processing - Do not close your browser or click the back button","CHECKOUT_BUTTON_WHEN_PROCESSING_TEXT":"Processing","EFS_CROP_PICKER_NONE_LABEL":"Lien Duration","DISALLOWED_WIZARD_PIECES":["FormationLocale"],"REPEATER_SHOW_EDIT_BUTTON":true,"DATA_REQUEST_PAGE_TITLE":"Data Requests and Subscriptions","DATA_REQUEST_SIDEBAR_LABEL":"Data Requests & Subscriptions","LOGIN_REDIRECTS_TO_EPASS":false,"LOGIN_REDIRECTS_TO_ACTIVE_DIRECTORY":true,"LOGIN_ACTIVE_DIRECTORY_LINK":true,"FETCH_EDIT_USER_LINK":false,"LISTS_FETCH_AVAILABLE_LISTS":true,"POST_WIZARD_SUBMIT_REDIRECT_URL":"/","PIN_REQUEST_ATTESTATIONS":true,"PIN_REQUEST_DESCRIPTION":"Click **Request PIN** to have a new PIN sent to the account holder's email address on file.","OWNERSHIP_REQUEST_DESCRIPTION":"To become an **authorized user** of this record, a current **AUTHORIZED USER** will need to grant you access. To request access, click **Request Access** below.","PIN_REQUEST_SUCCESS_MESSAGE":"The PIN you have requested for this entity has been sent to the email associated with your user account.  You should receive the PIN in approximately 3-5 minutes, depending on your email service provider.","APOSTILLE_HEADER_LABEL":"Verification Information","APOSTILLE_NUMBER_LABEL":"Apostille/Authentication","APOSTILLE_CITY_STATE_OVERRIDE":"HELENA, MT","APOSTILLE_FILING_DATE_LABEL":"Issue Date","APOSTILLE_CITY_STATE_IN_CERTIFIED":true,"NOTARY_EXISTING_FILING":true,"ALLOW_REVOKE_OWN_ACCESS_ONLY":false,"HIDE_CANCEL_ON_ONETIME_DATA_REQUESTS":true,"DATA_REQUESTS_IN_SHOPPING_CART":true,"WQ_ALLOW_EDIT_PENDING_PAYMENT":true,"WQ_CONFIRM_ON_DELETE":true,"WQ_DELETE_CONFIRM_MESSAGE":"Deleting this filing will forfeit any money already paid to the Secretary of State. This action is permanent and cannot be undone, are you sure you would like to delete?","PASS_ITEM_GUIDS_ON_CHECKOUT":true,"FORM_REVISION_HISTORY":true,"CHECKOUT_DISCLAIMER":"By entering your credit card and/or checking account information you (i) state that **you are an authorized user** of the credit card and/or electronic check and that the associated information entered (e.g., account holder name, account number, billing address) is accurate, (ii) **you authorize payment processor to charge the amount you have requested** to your credit card and/or funding account, and (iii) **acknowledge if a charge is declined or reversed you may also be assessed a customary charge** by the payment processor for such transactions.","FARM_BILL_SEARCH_CONFIDENTIAL":"As a registered Farm Bill Buyer with the Montana Secretary of State’s office it is important to maintain the confidentiality of the information contained within the Farm Bill Master List. The Farm Bill Master List reflects personal data, such as Social Security Numbers, which are a key piece of personal identifiable information to assist you in determining the existence of a lien against a specific debtor. The distribution of this information beyond its intended purpose is strictly prohibited.\n\n**The debtor's tax identification number has been hidden for confidentiality reasons. You may continue to search on a tax ID number and return debtors that match your search criteria. The SSN/FEIN must be entered without dashes or spaces.  If you need access to the tax identification number to clearly identify the debtor, please contact the UCC unit at (406) 444-3665.**","VIEW_HISTORY_BUTTON_ALT_TEXT":"View Filings","WIZARD_ERROR_TITLE_MESSAGE":"Form Error","FARM_BILL_SEARCH_INTERACTIVE":true,"USE_FARM_BILL_API":true,"DISALLOW_ASSIGN_SELF_AS_RA":true,"DISALLOW_ASSIGN_SELF_AS_PRINCIPAL":true,"USE_TRADEMARK_OWNER_VALIDATION":true,"USE_ALTERNATIVE_FOREIGN_ADDRESS_LABELS":true,"MY_RECEIPTS_FILTER":[{"type":"dateRange","name":"DATE_RANGE","label":"Date range","defaultValue":{"start":null,"end":null}},{"type":"text","name":"REF_NUM","defaultValue":"","label":"Reference Number"},{"type":"text","name":"RECEIPT_NUM","defaultValue":"","label":"Receipt Id"},{"type":"text","name":"AMOUNT","defaultValue":"","label":"Amount"},{"type":"select","name":"TYPE","defaultValue":"","label":"Payment Type","options":[{"value":"","label":"All"},{"value":"CC","label":"Credit Card"},{"value":"Check","label":"Check"}]}],"MY_RECEIPTS_SHOW_IN_SIDEBAR":true,"SHOW_MY_RECEIPTS_HELPER_TEXT":true,"MY_RECEIPTS_HELPER_LABEL":"About Receipt Search","MY_RECEIPTS_HELPER_TEXT":"You can search for receipts based on their descriptions, including the items paid for on the receipt. Use the filters to search for or filter specific information.","FARM_BILL_SUBLINK":{"label":"Farm Bill","component":"FarmBill","parameter":"farm-bill","path":"/lists/farm-bill","sourceTypeId":0,"myRecordsSearch":false,"allowedRules":["/search/"],"disabled":true,"searchDescription":"To perform a search, enter a debtor name. Your search results may include: exact debtor name, variations of that name and any filing that includes your search criteria. Punctuation is ignored.\n\nYou can click on \"Advanced\" to refine your search. Under “Advanced” you can search by crop, year, county and SSN/FEIN. As a registered Farm Bill Buyer with the Montana Secretary of State’s office it is important to maintain the confidentiality of the information contained within the Farm Bill Master List. The Farm Bill Master List reflects personal data, such as Social Security Numbers, which are a key piece of personal identifiable information to assist you in determining the existence of a lien against a specific debtor. The distribution of this information beyond its intended purpose is strictly prohibited.\n\nThe debtor's tax identification number has been hidden for confidentiality reasons. You may continue to search on a tax ID number and return debtors that match your search criteria. The SSN/FEIN must be entered without dashes or spaces.","searchMustHaveOneOf":["search","UCC_FARM_PRODUCT_ID","COUNTY"],"searchPlaceholder":"Search by debtor name","advancedSearchParameters":[{"type":"ServerMultiComplete","label":"Product code name(s)","name":"UCC_FARM_PRODUCT_ID","defaultValue":"","optionsSrc":"UCC_FARM_PRODUCT_V"},{"type":"MultiComplete","label":"Year or Range of Years","name":"YEAR_NUM","optionsSrc":"years","startYear":"1968","defaultValue":[],"preMergeOptions":[{"value":"ALL","label":"All"}]},{"type":"serverSelect","label":"State","name":"STATE","defaultValue":"MONTANA","optionsSrc":"STATE"},{"type":"ServerMultiComplete","label":"County","name":"COUNTY","defaultValue":[],"optionsSrc":"COUNTY","overrideSubOptionsSrcFromParameterName":"STATE"},{"type":"checkbox","name":"TIN_SEARCH_YN","defaultValue":false,"label":"Tax Identification Number Search"},{"type":"checkbox","name":"TIN_SORT_YN","defaultValue":false,"label":"Unique ID Sort"}]},"ALLOW_ADDRESS_VALIDATION_BYPASS_OPTION":true,"DEFAULT_ADDRESS_VALIDATION_BYPASS_OPTION_CHECKED":true}).UPLOAD_FILE_SIZE_MERGEABLE_ERROR;
	
	var FileUpload = function (_Component) {
	  _inherits(FileUpload, _Component);
	
	  function FileUpload(props) {
	    _classCallCheck(this, FileUpload);
	
	    var _this = _possibleConstructorReturn(this, (FileUpload.__proto__ || Object.getPrototypeOf(FileUpload)).call(this));
	
	    _this.preventDrop = function (e) {
	      e = e || event;
	      e.preventDefault();
	    };
	
	    _this.hideDroppableIndicator = function (e) {
	      _this.preventDrop(e);
	      _this.setState({ droppable: false });
	    };
	
	    _this.showDroppableIndicator = function (e) {
	      _this.preventDrop(e);
	      _this.setState({ droppable: true });
	    };
	
	    _this.componentDidMount = function () {
	      window.addEventListener("dragover", _this.showDroppableIndicator, false);
	      window.addEventListener("drop", _this.hideDroppableIndicator, false);
	    };
	
	    _this.componentWillUnmount = function () {
	      window.removeEventListener("dragover", _this.showDroppableIndicator, false);
	      window.removeEventListener("drop", _this.hideDroppableIndicator, false);
	    };
	
	    _this.componentDidUpdate = function (prevProps) {
	      var filesWereAddedToQueue = false;
	      var wasWaitingForOtherQueue = false;
	      var renderedByAccumulator = _this.props.parent.type === 'UploadAccumulator';
	      if (!renderedByAccumulator) {
	        var currentPending = _this.getNumByStatus(_this.props.value, 'pending');
	        filesWereAddedToQueue = currentPending > _this.getNumByStatus(prevProps.value, 'pending');
	        wasWaitingForOtherQueue = currentPending > 0 && !_this.props.uploading && prevProps.uploading;
	      }
	      if (filesWereAddedToQueue && !renderedByAccumulator && !_this.props.uploading || wasWaitingForOtherQueue) {
	        // console.log("%c Started the queue ", 'background: #2e55b9; color: #fff; padding: 2px; border-radius: 3px')
	        _this.startQueue();
	      }
	    };
	
	    _this.startQueue = function () {
	      _this.props.setUploading(true);
	      var limitedQueue = _this.getFreshQueue().filter(function (fileObj) {
	        return fileObj.status === 'pending';
	      }).slice(0, 5);
	      limitedQueue.forEach(function (fileObj) {
	        _this.props.onChange(_this.getNewFileObjFromPayload(fileObj.queueId, { status: 'uploading' }));
	      });
	      limitedQueue.forEach(function (fileObj) {
	        _this.startFileUpload(fileObj);
	      });
	    };
	
	    _this.startFileUpload = function (fileObj) {
	      _this.props.onChange(_this.getNewFileObjFromPayload(fileObj.queueId, { status: 'uploading' }));
	      uploadFile(fileObj.file, { SORT_ORDER: fileObj.sortOrder, IMAGE_DATA_TYPE_ID: fileObj.imageTypeId }, function (e) {
	        if (e.lengthComputable) {
	          var progress = e.loaded / e.total * 100;
	          _this.props.onChange(_this.getNewFileObjFromPayload(fileObj.queueId, { progress: progress }));
	        }
	      }, fileObj).then(function (guid) {
	        // console.log("%c" + fileObj.file.name, 'background: #52c848; padding: 2px; border-radius: 3px;')
	        _this.props.onChange(_this.getNewFileObjFromPayload(fileObj.queueId, { status: 'success', guid: guid }));
	        _this.checkForAndRunNextItemInQueue();
	      }).catch(function (err) {
	        console.error(err);
	        _this.props.onChange(_this.getNewFileObjFromPayload(fileObj.queueId, { status: 'failed' }));
	        _this.checkForAndRunNextItemInQueue();
	      });
	    };
	
	    _this.checkForAndRunNextItemInQueue = function () {
	      var numPending = _this.getNumByStatus(_this.getFreshQueue(), 'pending');
	      if (numPending > 0) {
	        _this.startFileUpload(_this.getNextItemInQueue());
	      } else {
	        _this.props.setUploading(false);
	      }
	    };
	
	    _this.getNextItemInQueue = function () {
	      var queue = _this.getFreshQueue();
	      return queue.filter(function (fileObj) {
	        return fileObj.status === 'pending';
	      })[0];
	    };
	
	    _this.getFreshQueue = function () {
	      return (0, _utilities.getFreshValueFromStoreByFieldId)(_this.props.fieldId);
	    };
	
	    _this.getNumByStatus = function (queue, status) {
	      return queue.reduce(function (num, file) {
	        return file.status === status ? num + 1 : num;
	      }, 0);
	    };
	
	    _this.getNewFileObjFromPayload = function (queueId, payload) {
	      var value = _this.getFreshQueue();
	      var index = value.findIndex(function (file) {
	        return file.queueId === queueId;
	      });
	      return [].concat(_toConsumableArray(value.slice(0, index)), [Object.assign({}, value[index], payload)], _toConsumableArray(value.slice(index + 1)));
	    };
	
	    _this.handleChange = function (e) {
	      var milliseconds = Date.now();
	      var allowedExtensions = _this.props.accept.trim().split(',').map(function (ext) {
	        return ext.trim().toLowerCase().replace(/\./g, '');
	      });
	      var files = [].concat(_toConsumableArray(e.target.files)).map(function (file, i) {
	        var extension = file.name.split('.').pop().toLowerCase();
	        var rejectImmediately = false;
	        var rejectReason = '';
	        if (file.size > MAX_FILE_UPLOAD_SIZE) {
	          rejectImmediately = true;
	          rejectReason = UPLOAD_FILE_SIZE_MERGEABLE_ERROR ? UPLOAD_FILE_SIZE_MERGEABLE_ERROR.replace('{{FILE_SIZE}}', MAX_FILE_UPLOAD_SIZE / 1000000) : 'Exceeded max file size';
	        }
	        if (_this.props.accept) {
	          if (allowedExtensions.every(function (ext) {
	            return ext !== extension;
	          })) {
	            rejectImmediately = true;
	            rejectReason = UPLOAD_FILE_FORMAT_MERGEABLE_ERROR ? UPLOAD_FILE_FORMAT_MERGEABLE_ERROR.replace('{{FILE_FORMAT}}', allowedExtensions.join(', ').toUpperCase()) : 'Unsupported file format.';
	          }
	        }
	        return {
	          file: file,
	          queuePosition: milliseconds + i,
	          guid: null,
	          rejectImmediately: rejectImmediately,
	          rejectReason: rejectReason,
	          status: 'pending',
	          progress: 0,
	          fieldId: _this.props.fieldId,
	          queueId: _shortid2.default.generate(),
	          sortOrder: _this.props.sortOrder,
	          imageTypeId: _this.props.imageTypeId,
	          filename: file.name,
	          '@type': 'file',
	          type: file.type
	        };
	      });
	      _this.upload.value = null;
	      _this.props.onChange([].concat(_toConsumableArray(Array.isArray(_this.props.value) ? _this.props.value : []), _toConsumableArray(files)), e);
	    };
	
	    _this.updateProgress = function (e) {
	      if (e.lengthComputable) {
	        var percentComplete = e.loaded / e.total;
	        _this.setState({
	          progress: percentComplete * 100
	        });
	      }
	    };
	
	    _this.removeFileByIndex = function (index, e) {
	      var files = [].concat(_toConsumableArray(_this.props.value.slice(0, index)), _toConsumableArray(_this.props.value.slice(index + 1)));
	      _this.props.onChange(files, Object.assign({}, e, { target: Object.assign({}, e.target, { name: _this.props.fieldId }) }));
	    };
	
	    _this.handleFileDrop = function (e) {
	      e.preventDefault();
	      var files = [];
	      for (var i = 0; i < e.dataTransfer.items.length; i++) {
	        if (e.dataTransfer.items[i].kind === 'file') {
	          var file = e.dataTransfer.items[i].getAsFile();
	          if (file) files.push(file);
	        }
	      }
	      if (files.length) _this.handleChange({ target: { files: files, name: _this.props.fieldId } });
	    };
	
	    _this.state = {
	      progress: 0,
	      droppable: false
	    };
	    return _this;
	  }
	
	  _createClass(FileUpload, [{
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _props = this.props,
	          disabled = _props.disabled,
	          accept = _props.accept,
	          fieldId = _props.fieldId,
	          multiple = _props.multiple,
	          _props$value = _props.value,
	          value = _props$value === undefined ? [] : _props$value;
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'file-wrapper' },
	        _react2.default.createElement(
	          'div',
	          { className: 'row' },
	          _react2.default.createElement(
	            'div',
	            { className: 'col-xl-7 col-lg-8 col-md-9 file-column' },
	            value && value.map(function (file, i) {
	              return _react2.default.createElement(File, Object.assign({}, file, { onRemoveFile: _this2.removeFileByIndex, filename: file.filename, index: i, key: file.queueId, disabled: disabled }));
	            })
	          )
	        ),
	        (multiple || value.length === 0) && _react2.default.createElement(
	          'div',
	          { className: 'row' },
	          _react2.default.createElement(
	            'div',
	            { className: 'col-xl-7 col-lg-8 col-md-9' },
	            _react2.default.createElement('input', {
	              className: 'hidden-upload',
	              type: 'file',
	              id: fieldId,
	              name: fieldId,
	              disabled: disabled,
	              onChange: this.handleChange,
	              accept: accept,
	              multiple: multiple,
	              ref: function ref(_ref) {
	                return _this2.upload = _ref;
	              }
	            }),
	            _react2.default.createElement(
	              'label',
	              { className: 'styled-file-upload ' + (disabled ? 'disabled' : ''), htmlFor: fieldId, onDrop: this.handleFileDrop },
	              _react2.default.createElement('span', { className: 'icon icon-upload ' + (this.state.droppable ? 'droppable-animation' : '') }),
	              this.state.droppable ? 'Drop files here to upload' : value.length > 0 ? "Select additional files to upload" : multiple ? 'Select files to upload ' + (accept ? '(' + accept + ')' : "") : 'Select a file to upload ' + (accept ? '(' + accept + ')' : "")
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return FileUpload;
	}(_react.Component);
	
	exports.default = (0, _reactRedux.connect)(function (state) {
	  return {
	    uploading: state.wizard.uploading
	  };
	}, { setUploading: _WizardActions.setUploading })(FileUpload);
	
	var File = function (_Component2) {
	  _inherits(File, _Component2);
	
	  function File() {
	    var _ref2;
	
	    var _temp, _this3, _ret;
	
	    _classCallCheck(this, File);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this3 = _possibleConstructorReturn(this, (_ref2 = File.__proto__ || Object.getPrototypeOf(File)).call.apply(_ref2, [this].concat(args))), _this3), _this3.removeFile = function (e) {
	      _this3.props.onRemoveFile(_this3.props.index, e);
	    }, _temp), _possibleConstructorReturn(_this3, _ret);
	  }
	
	  _createClass(File, [{
	    key: 'render',
	    value: function render() {
	      var _props2 = this.props,
	          progress = _props2.progress,
	          filename = _props2.filename,
	          status = _props2.status,
	          disabled = _props2.disabled,
	          rejectReason = _props2.rejectReason;
	
	      var success = status === 'success';
	      var failed = status === 'failed';
	      var uploading = status === 'uploading';
	      return _react2.default.createElement(
	        'div',
	        { className: 'progress ' + (success ? "success" : "") + ' ' + (failed ? "failed" : '') },
	        _react2.default.createElement(
	          'div',
	          { className: 'file-icon' },
	          uploading && _react2.default.createElement('div', { className: 'shine-spinner' }),
	          _react2.default.createElement(_cloudUpload2.default, { className: 'icon ' + (uploading ? 'spin-out' : 'spin-in') })
	        ),
	        _react2.default.createElement(
	          'span',
	          { className: 'filename' },
	          filename
	        ),
	        failed && _react2.default.createElement(
	          'span',
	          { className: 'failed-text' },
	          rejectReason || 'Upload Failed'
	        ),
	        !disabled ? (success || failed) && _react2.default.createElement(
	          'button',
	          { className: 'remove', onClick: this.removeFile },
	          _react2.default.createElement('span', { className: 'icon icon-close' })
	        ) : null,
	        _react2.default.createElement('div', { className: 'bar', style: { width: progress + "%" } })
	      );
	    }
	  }]);
	
	  return File;
	}(_react.Component);
	
	//Defines an upload exception
	
	
	function Exception(message) {
	  this.message = message;
	  this.name = 'Upload Exception';
	}
	
	//Starts a new XHR upload request and reports back progress to the onProgress function.
	var uploadFile = exports.uploadFile = function uploadFile(file, metadata, onProgress, fileObj) {
	  return new Promise(function (res, rej) {
	    if (fileObj.rejectImmediately) {
	      rej(fileObj.rejectReason);
	    } else {
	      (0, _requests.UPLOAD_FILES)([file], metadata, onProgress).then(function (guid) {
	        guid = JSON.parse(guid);
	        //console.log(guid)
	        if (typeof guid === 'string' && guid.length < 100 && guid !== 'false') {
	          res(guid);
	        } else {
	          rej(guid);
	          throw new Exception('The returned guid was not a string. It likely returned an error object.');
	        }
	      }).catch(function (err) {
	        rej(err);
	      });
	    }
	  });
	};

/***/ },
/* 474 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.DumbRow = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(7);
	
	var _shortid = __webpack_require__(22);
	
	var _shortid2 = _interopRequireDefault(_shortid);
	
	var _Field = __webpack_require__(25);
	
	var _Field2 = _interopRequireDefault(_Field);
	
	var _WizardActions = __webpack_require__(36);
	
	var _utilities = __webpack_require__(8);
	
	var _WizardClasses = __webpack_require__(35);
	
	var WizardClasses = _interopRequireWildcard(_WizardClasses);
	
	var _Modal = __webpack_require__(13);
	
	var _Portal = __webpack_require__(12);
	
	var _Portal2 = _interopRequireDefault(_Portal);
	
	var _wizardUtilities = __webpack_require__(52);
	
	var _Tooltip = __webpack_require__(305);
	
	var _Tooltip2 = _interopRequireDefault(_Tooltip);
	
	var _caretDown = __webpack_require__(38);
	
	var _caretDown2 = _interopRequireDefault(_caretDown);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// import CloneIcon from '@tecuity/sos-icons/react/clone'
	// import TrashIcon from '@tecuity/sos-icons/react/trash'
	// import RevertIcon from '@tecuity/sos-icons/react/revert'
	
	var disallowedFields = ['Paragraph', 'UploadPlaceholder'];
	var REPEATER_SHOW_EDIT_BUTTON = (true);
	
	var Repeater = function (_Component) {
	  _inherits(Repeater, _Component);
	
	  function Repeater() {
	    _classCallCheck(this, Repeater);
	
	    var _this = _possibleConstructorReturn(this, (Repeater.__proto__ || Object.getPrototypeOf(Repeater)).call(this));
	
	    _this.componentDidMount = function () {
	      if (_this.props.isFirst && !_this.props.disabled) {
	        _this.focus();
	      }
	    };
	
	    _this.componentWillReceiveProps = function (nextProps) {
	      if (_this.props.value.length !== nextProps.value.length) {
	        var printMailRequiredIf = _this.props.printMailRequiredIf;
	        switch (printMailRequiredIf) {
	          case '>1':
	            if (nextProps.value.length > 1 && !_this.props.requirePrintMailMethod.has(_this.props.fieldId)) {
	              _this.props.addRequirePrintMailMethod(_this.props.fieldId);
	            } else if (nextProps.value.length <= 1 && _this.props.requirePrintMailMethod.has(_this.props.fieldId)) {
	              _this.props.removeRequirePrintMailMethod(_this.props.fieldId);
	            }
	            break;
	          case '>2':
	            if (nextProps.value.length > 2 && !_this.props.requirePrintMailMethod.has(_this.props.fieldId)) {
	              _this.props.addRequirePrintMailMethod(_this.props.fieldId);
	            } else if (nextProps.value.length <= 2 && _this.props.requirePrintMailMethod.has(_this.props.fieldId)) {
	              _this.props.removeRequirePrintMailMethod(_this.props.fieldId);
	            }
	            break;
	        }
	      }
	    };
	
	    _this.toggleAdding = function () {
	      if (!_this.state.adding) {
	        _this.props.template.forEach(function (fieldId) {
	          var fieldClass = _this.props.fields[fieldId].fieldClass;
	
	          var _this$props$fields$fi = _this.props.fields[fieldId],
	              _ = _this$props$fields$fi.value,
	              propsLessValue = _objectWithoutProperties(_this$props$fields$fi, ['value']);
	
	          var instance = new WizardClasses[fieldClass](propsLessValue);
	          var value = _this.props.fields[fieldId].defaultValue !== '' ? _this.props.fields[fieldId].defaultValue : instance.value;
	          if (fieldClass === 'Paragraph') {
	            value = _this.props.fields[fieldId].value;
	          }
	          if (fieldClass === 'AddressBlock') {
	            value = Object.assign({}, instance.value, {
	              STATE: _this.props.fields[fieldId].defaultState || instance.value.STATE
	            });
	          }
	          _this.props.setFieldAttributes({
	            fieldId: fieldId,
	            payload: {
	              value: value,
	              infoMessage: instance.infoMessage,
	              isValid: null,
	              confirmed: instance.confirmed,
	              feedback: instance.feedback,
	              errorMessage: instance.errorMessage
	            }
	          });
	        });
	      }
	      _this.setState({ adding: !_this.state.adding });
	    };
	
	    _this.addRow = function (callback) {
	      (0, _WizardActions.validateFieldArray)((0, _WizardActions.buildFieldIdList)(_this.props.template), function (isValid) {
	        callback(isValid);
	        if (isValid) {
	          var rows = [].concat(_toConsumableArray(_this.props.value), [_this.buildRow(1)]);
	          _this.props.onChange(rows, null, {}, undefined, { triggerOnAdvanceValidation: true });
	          _this.setState({ adding: false });
	        }
	      }, { isSavingRepeater: true });
	    };
	
	    _this.buildRow = function (status) {
	      var props = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	      var row = {};
	      _this.props.templateFields.forEach(function (field) {
	        if (props.resolveConditions) {
	          if ((0, _wizardUtilities.resolveFieldConditions)(field.conditions, _this.props.fields, field.conditionsOperator)) {
	            row[field.fieldId] = field.value;
	          } else {
	            var fieldClass = field.fieldClass;
	            var instance = new WizardClasses[fieldClass]();
	            var value = field.defaultValue !== '' ? field.defaultValue : instance.value;
	            row[field.fieldId] = value;
	          }
	        } else {
	          row[field.fieldId] = field.value;
	        }
	      });
	      row._rowId = _shortid2.default.generate();
	      row._statusId = status === 0 ? 0 : status ? status : 1;
	      return row;
	    };
	
	    _this.editRow = function (rowIndex) {
	      if (_this.props.value[rowIndex]._statusId !== 3) {
	        _this.props.template.forEach(function (fieldId) {
	          var fieldClass = _this.props.fields[fieldId].fieldClass;
	          var value = _this.props.value[rowIndex][fieldId];
	          if (fieldClass === 'Paragraph') {
	            value = _this.props.fields[fieldId].value;
	          }
	          _this.props.setFieldAttributes({
	            fieldId: fieldId,
	            payload: {
	              value: value,
	              isValid: null,
	              confirmed: false,
	              feedback: null,
	              errorMessage: ''
	            }
	          });
	        });
	        _this.setState({ editing: rowIndex });
	        _this.props.setRepeaterEditing(true);
	      }
	    };
	
	    _this.saveRow = function (rowIndex, callback) {
	      (0, _WizardActions.validateFieldArray)((0, _WizardActions.buildFieldIdList)(_this.props.template), function (isValid) {
	        callback(isValid);
	        if (isValid) {
	          var rows = [].concat(_toConsumableArray(_this.props.value.slice(0, rowIndex)), [Object.assign({}, _this.buildRow(null, { resolveConditions: true }), Object.keys(_this.props.value[rowIndex]).reduce(function (obj, key) {
	            //if(key.charAt(0) === "_"){
	            if (key === '_statusId' || key === '_rowId' || key === '_original' || key === '_partyId') {
	              obj[key] = _this.props.value[rowIndex][key];
	            }
	            return obj;
	          }, {}), {
	            _statusId: _this.props.value[rowIndex]._statusId === 0 || _this.props.value[rowIndex]._original ? 2 : 1,
	            _dirty: true,
	            _original: _this.props.value[rowIndex]._original,
	            _rowId: _this.props.value[rowIndex]._rowId
	          })], _toConsumableArray(_this.props.value.slice(rowIndex + 1)));
	          _this.props.onChange(rows, null, { rowErrors: null }, undefined, {
	            triggerOnAdvanceValidation: true
	          });
	          _this.setState({ editing: null });
	          _this.props.setRepeaterEditing(false);
	        }
	      }, { isSavingRepeater: true });
	    };
	
	    _this.deleteRow = function (rowIndex) {
	      var rows = void 0;
	      if (_this.props.trackChanges && _this.props.value[rowIndex]._original) {
	        var currentRow = _this.props.value[rowIndex];
	        var originalRow = _this.props.original.find(function (r) {
	          return r._original && r._rowId === currentRow._rowId;
	        });
	        // this is used when a draft is saved and edited again where the rowIds no longer match.
	        if (!originalRow) {
	          originalRow = _this.props.value[rowIndex];
	        }
	        rows = [].concat(_toConsumableArray(_this.props.value.slice(0, rowIndex)), [Object.assign({}, originalRow, {
	          _statusId: 3
	        })], _toConsumableArray(_this.props.value.slice(rowIndex + 1)));
	      } else {
	        rows = [].concat(_toConsumableArray(_this.props.value.slice(0, rowIndex)), _toConsumableArray(_this.props.value.slice(rowIndex + 1)));
	      }
	      _this.props.onChange(rows, null, {}, undefined, { triggerOnAdvanceValidation: true });
	    };
	
	    _this.revertRow = function (rowIndex) {
	      var currentRow = _this.props.value[rowIndex];
	      var originalRow = _this.props.original.find(function (r) {
	        return r._original && r._rowId === currentRow._rowId;
	      });
	      // this is used when a draft is saved and edited again where the rowIds no longer match.
	      if (!originalRow) {
	        originalRow = _this.props.value[rowIndex];
	        originalRow._statusId = 1;
	      }
	      var rows = [].concat(_toConsumableArray(_this.props.value.slice(0, rowIndex)), [Object.assign({}, originalRow)], _toConsumableArray(_this.props.value.slice(rowIndex + 1)));
	      _this.props.onChange(rows, null);
	    };
	
	    _this.cloneRow = function (rowIndex) {
	      var rowToClone = _this.props.value[rowIndex];
	      var filteredRow = Object.keys(rowToClone)
	      //.filter((key) => !key.startsWith('_'))
	      .filter(function (key) {
	        return key !== '_statusId' && key !== '_rowId' && key !== '_original' && key !== '_partyId';
	      }).reduce(function (obj, key) {
	        obj[key] = rowToClone[key];
	        return obj;
	      }, {});
	      var rows = [].concat(_toConsumableArray(_this.props.value.slice(0, rowIndex)), _toConsumableArray(_this.props.value.slice(rowIndex)), [Object.assign({}, filteredRow, { _rowId: _shortid2.default.generate(), _statusId: 1, _original: false })]);
	      _this.props.onChange(rows, null, {}, undefined, { triggerOnAdvanceValidation: true });
	    };
	
	    _this.cancelEdit = function () {
	      _this.setState({ editing: null });
	      _this.props.setRepeaterEditing(false);
	    };
	
	    _this.focus = function () {
	      try {
	        if (_this.props.value.length > 0) {
	          _this.firstRow.focus();
	        } else {
	          if (!_this.props.disableAdding) {
	            _this.addButton.focus();
	          }
	        }
	      } catch (e) {
	        console.warn('Attempted to focus unfocusable element.');
	      }
	    };
	
	    _this.state = { adding: false, editing: null };
	    return _this;
	  }
	
	  _createClass(Repeater, [{
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _props = this.props,
	          tooltip = _props.tooltip,
	          _props$templateFields = _props.templateFields,
	          templateFields = _props$templateFields === undefined ? [] : _props$templateFields,
	          disabled = _props.disabled,
	          emptyRepeaterLabel = _props.emptyRepeaterLabel,
	          _props$businessRules = _props.businessRules,
	          businessRules = _props$businessRules === undefined ? [] : _props$businessRules,
	          value = _props.value,
	          disableAdding = _props.disableAdding,
	          disableCloning = _props.disableCloning,
	          disableDeleting = _props.disableDeleting,
	          disableEditing = _props.disableEditing,
	          rowErrors = _props.rowErrors,
	          trackChanges = _props.trackChanges,
	          customDeleteLabel = _props.customDeleteLabel,
	          noDeletedStyling = _props.noDeletedStyling,
	          addButtonLabel = _props.addButtonLabel,
	          maxRepeaterRows = _props.maxRepeaterRows;
	
	      var hasMaxRows = maxRepeaterRows !== undefined ? true : businessRules.find(function (rule) {
	        return rule.fn === 'repeaterMaxRows';
	      });
	      var maxRows = hasMaxRows ? maxRepeaterRows !== undefined ? maxRepeaterRows : hasMaxRows.props.maxRows : null;
	      var numRows = value.filter(function (row) {
	        return row._statusId !== 3;
	      }).length;
	      var editingDisabled = disabled ? disabled : hasMaxRows ? numRows >= maxRows : disabled;
	      var filteredFields = templateFields.filter(function (field) {
	        return !disallowedFields.includes(field.fieldClass) && field.active && !field.hideInRepeaterGrid;
	      });
	      return _react2.default.createElement(
	        'div',
	        { className: 'repeater ' + (disabled ? 'disabled' : '') },
	        tooltip !== '' && tooltip ? _react2.default.createElement(_Tooltip2.default, { tooltip: tooltip }) : null,
	        _react2.default.createElement(
	          'div',
	          { className: 'repeats' },
	          _react2.default.createElement(
	            'div',
	            { className: 'scrollable' },
	            _react2.default.createElement(
	              'table',
	              { className: 'form-table' },
	              _react2.default.createElement(
	                'thead',
	                null,
	                _react2.default.createElement(
	                  'tr',
	                  { className: 'repeats-row' },
	                  filteredFields.map(function (field, i) {
	                    return _react2.default.createElement(
	                      'th',
	                      { key: i },
	                      field.shortLabel !== '' ? field.shortLabel : field.label
	                    );
	                  }),
	                  (!editingDisabled || !disableDeleting || !disableCloning) && this.props.value.length > 0 && !disabled && _react2.default.createElement(
	                    'th',
	                    null,
	                    _react2.default.createElement(
	                      'span',
	                      { className: 'visually-hidden' },
	                      'Actions'
	                    )
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                'tbody',
	                null,
	                this.props.value.length === 0 ? _react2.default.createElement(
	                  'tr',
	                  { className: 'repeats-row' },
	                  _react2.default.createElement(
	                    'td',
	                    { className: 'no-entries', colSpan: filteredFields.length },
	                    emptyRepeaterLabel === '' ? 'None' : emptyRepeaterLabel
	                  )
	                ) : this.props.value.map(function (row, i) {
	                  return _react2.default.createElement(TableRow, {
	                    onChange: _this2.setEditValue,
	                    templateFields: templateFields,
	                    cancelEdit: _this2.cancelEdit,
	                    saveRow: _this2.saveRow,
	                    cloneRow: _this2.cloneRow,
	                    deleteRow: _this2.deleteRow,
	                    revertRow: _this2.revertRow,
	                    editRow: _this2.editRow,
	                    row: row,
	                    editing: _this2.state.editing === i,
	                    disabled: disabled,
	                    editDisabled: disableEditing,
	                    cloneDisabled: editingDisabled === true ? true : disableCloning,
	                    deleteDisabled: disableDeleting,
	                    customDeleteLabel: customDeleteLabel,
	                    noDeletedStyling: noDeletedStyling,
	                    errors: rowErrors ? rowErrors[i] : null,
	                    trackChanges: trackChanges,
	                    rowIndex: i,
	                    ref: function ref(rowRef) {
	                      if (i === 0) {
	                        _this2.firstRow = rowRef;
	                      }
	                    },
	                    key: i
	                  });
	                })
	              )
	            )
	          ),
	          !disabled && !disableAdding && _react2.default.createElement(
	            'div',
	            { className: 'row' },
	            _react2.default.createElement(
	              'div',
	              { className: 'col-sm-4 col-md-3 col-lg-3' },
	              _react2.default.createElement(
	                'button',
	                {
	                  className: 'btn btn-raised btn-primary form-button add-row',
	                  disabled: editingDisabled || disableAdding,
	                  type: 'button',
	                  onClick: this.toggleAdding,
	                  ref: function ref(addButton) {
	                    _this2.addButton = addButton;
	                  }
	                },
	                addButtonLabel || 'Add'
	              )
	            )
	          ),
	          _react2.default.createElement(AddSection, {
	            ref: function ref(r) {
	              _this2.addSection = r;
	            },
	            open: this.state.adding,
	            templateFields: templateFields,
	            addRow: this.addRow,
	            toggleAdding: this.toggleAdding
	          })
	        )
	      );
	    }
	  }]);
	
	  return Repeater;
	}(_react.Component);
	
	exports.default = (0, _reactRedux.connect)(function (state, props) {
	  return {
	    fields: state.wizard.wizard.fields,
	    templateFields: props.template.map(function (fieldId) {
	      return state.wizard.wizard.fields[fieldId];
	    }),
	    requirePrintMailMethod: state.wizard.requirePrintMailMethod,
	    original: state.wizard.diff.originalByFieldId[props.fieldId]
	  };
	}, {
	  setFieldAttributes: _WizardActions.setFieldAttributes,
	  addRequirePrintMailMethod: _WizardActions.addRequirePrintMailMethod,
	  removeRequirePrintMailMethod: _WizardActions.removeRequirePrintMailMethod,
	  setRepeaterEditing: _WizardActions.setRepeaterEditing
	})(Repeater);
	
	var AddSection = function (_Component2) {
	  _inherits(AddSection, _Component2);
	
	  function AddSection() {
	    var _ref;
	
	    var _temp, _this3, _ret;
	
	    _classCallCheck(this, AddSection);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this3 = _possibleConstructorReturn(this, (_ref = AddSection.__proto__ || Object.getPrototypeOf(AddSection)).call.apply(_ref, [this].concat(args))), _this3), _this3.state = {
	      open: false
	    }, _this3.componentDidMount = function () {
	      if (true) {
	        window.addEventListener('resize', _this3.handleScroll);
	        _this3.handleScrollUpdate();
	      }
	    }, _this3.componentWillReceiveProps = function (nextProps) {
	      if (_this3.props.open == false && nextProps.open === true) {
	        _this3.setState({
	          open: true
	        });
	      }
	    }, _this3.closeModal = function () {
	      _this3.modal.closeModal(function () {
	        _this3.closePortal();
	      });
	    }, _this3.closePortal = function () {
	      _this3.setState({ open: false });
	      if (_this3.props.open) {
	        _this3.props.toggleAdding();
	      }
	    }, _this3.addRow = function () {
	      _this3.props.addRow(function (isValid) {
	        if (isValid) {
	          _this3.closeModal();
	        }
	      });
	    }, _this3.handleScroll = function (e) {
	      if (true) {
	        var bottom = e.target.scrollHeight - (e.target.scrollTop + e.target.clientHeight) < 10;
	        var scrollable = e.target.scrollHeight - (e.target.scrollTop + e.target.clientHeight) >= 10;
	        _this3.setState({
	          reachedBottom: bottom,
	          isScrollable: scrollable
	        });
	      }
	    }, _temp), _possibleConstructorReturn(_this3, _ret);
	  }
	
	  _createClass(AddSection, [{
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate() {
	      if (true) {
	        this.handleScrollUpdate();
	      }
	    }
	  }, {
	    key: 'handleScrollUpdate',
	    value: function handleScrollUpdate() {
	      var elements = document.getElementsByClassName('template sub-section');
	      if (elements[0]) {
	        var position = elements[0].scrollHeight - (elements[0].clientHeight + elements[0].scrollTop);
	
	        if (position < 10 && this.state.isScrollable) {
	          this.setState(Object.assign({}, this.state, { isScrollable: false }));
	        } else if (!this.state.isScrollable && position >= 10) {
	          this.setState(Object.assign({}, this.state, { isScrollable: true }));
	        }
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this4 = this;
	
	      var templateFields = this.props.templateFields;
	
	      return _react2.default.createElement(
	        _Portal2.default,
	        { isOpened: this.state.open },
	        _react2.default.createElement(
	          _Modal.Modal,
	          {
	            ref: function ref(r) {
	              _this4.modal = r;
	            },
	            closeButton: true,
	            closeModal: this.closePortal,
	            modalSize: 'large',
	            modalBodyClassName: 'wizard relative-modal',
	            title: 'Add',
	            autoHeight: true
	          },
	          _react2.default.createElement(
	            'div',
	            {
	              className: 'template sub-section',
	              onScroll:  true ? this.handleScroll : null
	            },
	            (true) && this.state.isScrollable ? _react2.default.createElement(
	              _react.Fragment,
	              null,
	              _react2.default.createElement(
	                'div',
	                { className: 'scroll-down-container-bottom-right' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'scroll-down-text' },
	                  'Scroll Down'
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'scroll-down-icon' },
	                  _react2.default.createElement(_caretDown2.default, null)
	                )
	              )
	            ) : null,
	            _react2.default.createElement(
	              'div',
	              { className: 'template-fields' },
	              templateFields.map(function (field, i) {
	                if (field) {
	                  return field.active ? _react2.default.createElement(_Field2.default, { field: field, key: field.fieldId }) : null;
	                } else {
	                  console.warn('Attempted to render Repeater subfield at index ' + i + ' but got null.');
	                  return null;
	                }
	              })
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'controls' },
	              _react2.default.createElement(
	                'button',
	                { type: 'button', className: 'btn btn-raised btn-primary', onClick: this.addRow },
	                'Save'
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return AddSection;
	}(_react.Component);
	
	var TableRow = function (_Component3) {
	  _inherits(TableRow, _Component3);
	
	  function TableRow() {
	    var _ref2;
	
	    var _temp2, _this5, _ret2;
	
	    _classCallCheck(this, TableRow);
	
	    for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
	      args[_key2] = arguments[_key2];
	    }
	
	    return _ret2 = (_temp2 = (_this5 = _possibleConstructorReturn(this, (_ref2 = TableRow.__proto__ || Object.getPrototypeOf(TableRow)).call.apply(_ref2, [this].concat(args))), _this5), _this5.editRow = function (e) {
	      // e.stopPropagation();
	      if (!_this5.props.editing) _this5.props.editRow(_this5.props.rowIndex);
	    }, _this5.setEditValue = function (e) {
	      _this5.props.onChange(e);
	    }, _this5.saveRow = function (e, callback) {
	      e.stopPropagation();
	      _this5.props.saveRow(_this5.props.rowIndex, callback);
	    }, _this5.cancelEdit = function () {
	      _this5.props.cancelEdit();
	    }, _this5.deleteRow = function (e) {
	      e.stopPropagation();
	      _this5.props.deleteRow(_this5.props.rowIndex);
	    }, _this5.revertRow = function (e) {
	      e.stopPropagation();
	      _this5.props.revertRow(_this5.props.rowIndex);
	    }, _this5.cloneRow = function (e) {
	      e.stopPropagation();
	      _this5.props.cloneRow(_this5.props.rowIndex);
	    }, _this5.checkForSubmit = function (e) {
	      if ((e.charCode === 13 || e.charCode === 32) && e.target.tagName === 'TR') {
	        e.preventDefault();
	        _this5.editRow();
	      }
	    }, _this5.focus = function () {
	      _this5.row.focus();
	    }, _temp2), _possibleConstructorReturn(_this5, _ret2);
	  }
	
	  _createClass(TableRow, [{
	    key: 'render',
	    value: function render() {
	      var _this6 = this;
	
	      var _props2 = this.props,
	          row = _props2.row,
	          templateFields = _props2.templateFields,
	          editing = _props2.editing,
	          fields = _props2.fields,
	          disabled = _props2.disabled,
	          cloneDisabled = _props2.cloneDisabled,
	          deleteDisabled = _props2.deleteDisabled,
	          editDisabled = _props2.editDisabled,
	          errors = _props2.errors,
	          trackChanges = _props2.trackChanges,
	          customDeleteLabel = _props2.customDeleteLabel,
	          noDeletedStyling = _props2.noDeletedStyling;
	
	      var filteredColumns = Object.keys(row)
	      //.filter((key) => key.charAt(0) !== "_")
	      .filter(function (key) {
	        return key !== '_statusId' && key !== '_rowId' && key !== '_original' && key !== '_partyId';
	      }).filter(function (item) {
	        return fields[item] ? !disallowedFields.includes(fields[item].fieldClass) && !fields[item].hideInRepeaterGrid : false;
	      });
	
	      var deleting = row._statusId === 3;
	      var added = row._statusId === 1;
	      var edited = row._statusId === 2;
	      return _react2.default.createElement(
	        'tr',
	        {
	          role: editing || disabled || deleting || editDisabled ? '' : 'button',
	          tabIndex: disabled || deleting || editDisabled ? '' : 0,
	          className: 'not-editing repeats-row ' + (deleting && trackChanges ? 'deleting ' + (noDeletedStyling ? 'no-delete' : '') : '') + ' ' + (added && trackChanges ? 'adding' : '') + ' ' + (edited && trackChanges ? 'edited' : '') + ' ' + (disabled || editDisabled ? 'disabled' : ''),
	          onClick: editing || disabled || editDisabled ? _utilities.noop : this.editRow,
	          onKeyPress: editing || disabled || editDisabled ? _utilities.noop : this.checkForSubmit,
	          ref: function ref(row) {
	            _this6.row = row;
	          }
	        },
	        filteredColumns.map(function (fieldId, i) {
	          var field = fields[fieldId];
	          var fieldClass = field.fieldClass,
	              _field$textAlignment = field.textAlignment,
	              textAlignment = _field$textAlignment === undefined ? 'left' : _field$textAlignment;
	
	          return field.active ? _react2.default.createElement(
	            'td',
	            { className: 'repeats-column', key: fieldId, style: { textAlign: textAlignment } },
	            errors && errors.cellValids[fieldId] ? errors.cellValids[fieldId].isValid === false && _react2.default.createElement(
	              'span',
	              { className: 'error-badge' },
	              '!'
	            ) : null,
	            new WizardClasses[fieldClass]().getHumanReadableValue(field, row[fieldId]) === '[Select An Option]' ? '' : new WizardClasses[fieldClass]().getHumanReadableValue(field, row[fieldId])
	          ) : null;
	        }),
	        _react2.default.createElement(EditModal, {
	          open: editing,
	          row: row,
	          errors: errors,
	          templateFields: templateFields,
	          saveRow: this.saveRow,
	          cancelEdit: this.cancelEdit,
	          setEditValue: this.setEditValue
	        }),
	        !disabled && (!cloneDisabled || !deleteDisabled || REPEATER_SHOW_EDIT_BUTTON && !editDisabled) && _react2.default.createElement(
	          'td',
	          { className: 'row-controls-col' },
	          _react2.default.createElement(
	            'div',
	            { className: 'row-controls' },
	            REPEATER_SHOW_EDIT_BUTTON && !disabled && !editDisabled && _react2.default.createElement(
	              'button',
	              { type: 'button', className: 'btn btn-primary control', onClick: this.editRow },
	              'Edit'
	            ),
	            !deleteDisabled && !disabled && trackChanges && deleting && _react2.default.createElement(
	              'button',
	              {
	                type: 'button',
	                className: 'btn btn-primary control',
	                disabled: disabled || deleteDisabled,
	                onClick: this.revertRow
	              },
	              'Revert'
	            ),
	            !cloneDisabled && !disabled && _react2.default.createElement(
	              'button',
	              {
	                type: 'button',
	                className: 'btn btn-primary control',
	                disabled: cloneDisabled || disabled,
	                onClick: this.cloneRow
	              },
	              'Copy'
	            ),
	            !deleteDisabled && !disabled && (!deleting || !trackChanges) && _react2.default.createElement(
	              'button',
	              {
	                type: 'button',
	                className: 'btn btn-danger control',
	                disabled: disabled || deleteDisabled,
	                onClick: this.deleteRow
	              },
	              customDeleteLabel ? customDeleteLabel : 'Delete'
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return TableRow;
	}(_react.Component);
	
	TableRow = (0, _reactRedux.connect)(function (state) {
	  return {
	    fields: state.wizard.wizard.fields
	  };
	}, null, null, { forwardRef: true })(TableRow);
	
	var EditModal = function (_Component4) {
	  _inherits(EditModal, _Component4);
	
	  function EditModal() {
	    var _ref3;
	
	    var _temp3, _this7, _ret3;
	
	    _classCallCheck(this, EditModal);
	
	    for (var _len3 = arguments.length, args = Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
	      args[_key3] = arguments[_key3];
	    }
	
	    return _ret3 = (_temp3 = (_this7 = _possibleConstructorReturn(this, (_ref3 = EditModal.__proto__ || Object.getPrototypeOf(EditModal)).call.apply(_ref3, [this].concat(args))), _this7), _this7.state = {
	      open: false
	    }, _this7.componentWillReceiveProps = function (nextProps) {
	      if (_this7.state.open === false && nextProps.open === true) {
	        _this7.setState({
	          open: true
	        });
	      }
	    }, _this7.closeModal = function () {
	      _this7.modal.closeModal(function () {
	        _this7.closePortal();
	      });
	    }, _this7.closePortal = function () {
	      _this7.setState({ open: false });
	      if (_this7.props.open) {
	        _this7.props.cancelEdit();
	      }
	    }, _this7.saveRow = function (e) {
	      _this7.props.saveRow(e, function (isValid) {
	        if (isValid) {
	          _this7.closeModal();
	        }
	      });
	    }, _temp3), _possibleConstructorReturn(_this7, _ret3);
	  }
	
	  _createClass(EditModal, [{
	    key: 'render',
	    value: function render() {
	      var _this8 = this;
	
	      var _props3 = this.props,
	          templateFields = _props3.templateFields,
	          errors = _props3.errors;
	
	      return _react2.default.createElement(
	        _Portal2.default,
	        { isOpened: this.state.open },
	        _react2.default.createElement(
	          _Modal.Modal,
	          {
	            ref: function ref(r) {
	              _this8.modal = r;
	            },
	            closeButton: true,
	            closeModal: this.closePortal,
	            modalSize: 'large',
	            modalBodyClassName: 'wizard relative-modal',
	            title: 'Edit',
	            autoHeight: true
	          },
	          _react2.default.createElement(
	            'div',
	            { className: 'template sub-section' },
	            templateFields.map(function (field, i) {
	              var isValid = errors && errors.cellValids[field.fieldId] ? errors.cellValids[field.fieldId].isValid : field.isValid;
	              var cellErrors = errors && errors.cellValids[field.fieldId] ? errors.cellValids[field.fieldId].errors : field.errorMessage;
	              return field.active ? _react2.default.createElement(_Field2.default, {
	                field: Object.assign({}, field, {
	                  isValid: field.isValid === true ? field.isValid : isValid,
	                  errorMessage: field.isValid === true ? [] : cellErrors
	                }),
	                key: field.fieldId
	              }) : null;
	            }),
	            _react2.default.createElement(
	              'div',
	              { className: 'controls' },
	              _react2.default.createElement(
	                'button',
	                { type: 'button', className: 'btn btn-raised btn-primary', onClick: this.saveRow },
	                'Save'
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return EditModal;
	}(_react.Component);
	
	EditModal = (0, _reactRedux.connect)(function (state) {
	  return {
	    fields: state.wizard.wizard.fields
	  };
	})(EditModal);
	
	var DumbRow = exports.DumbRow = function DumbRow(_ref4) {
	  var row = _ref4.row;
	  return _react2.default.createElement(
	    'tr',
	    null,
	    Object.keys(row).map(function (key, k) {
	      return _react2.default.createElement(
	        'td',
	        { key: k },
	        row[key]
	      );
	    })
	  );
	};

/***/ },
/* 475 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(7);
	
	var _Form = __webpack_require__(14);
	
	var _MultiComplete = __webpack_require__(120);
	
	var _MultiComplete2 = _interopRequireDefault(_MultiComplete);
	
	var _WizardActions = __webpack_require__(36);
	
	var _deepEqual = __webpack_require__(65);
	
	var _deepEqual2 = _interopRequireDefault(_deepEqual);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ServerOptions = function (_Component) {
	  _inherits(ServerOptions, _Component);
	
	  function ServerOptions() {
	    _classCallCheck(this, ServerOptions);
	
	    var _this = _possibleConstructorReturn(this, (ServerOptions.__proto__ || Object.getPrototypeOf(ServerOptions)).call(this));
	
	    _this.componentDidUpdate = function (prevProps) {
	      var _this$props = _this.props,
	          fields = _this$props.fields,
	          optionsSrcOverride = _this$props.optionsSrcOverride,
	          subOptionsSrcOverride = _this$props.subOptionsSrcOverride,
	          fieldId = _this$props.fieldId,
	          optionsSrcOverrideValue = _this$props.optionsSrcOverrideValue,
	          subOptionsSrcOverrideValue = _this$props.subOptionsSrcOverrideValue;
	
	      var dependsOnAnOverrideValue = optionsSrcOverride || subOptionsSrcOverride || optionsSrcOverrideValue || subOptionsSrcOverrideValue;
	      if (dependsOnAnOverrideValue) {
	        var optionsSrcChanged = false;
	        var subOptionsSrcChanged = false;
	        if (optionsSrcOverride && !optionsSrcOverrideValue) {
	          var prevField = prevProps.fields[optionsSrcOverride].value;
	          var currentField = fields[optionsSrcOverride].value;
	          optionsSrcChanged = !(0, _deepEqual2.default)(prevField, currentField);
	        }
	        if (subOptionsSrcOverride && !subOptionsSrcOverrideValue) {
	          var _prevField = prevProps.fields[subOptionsSrcOverride].value;
	          var _currentField = fields[subOptionsSrcOverride].value;
	          subOptionsSrcChanged = !(0, _deepEqual2.default)(_prevField, _currentField);
	        }
	        if (optionsSrcOverrideValue) {
	          optionsSrcChanged = prevProps.optionsSrcOverrideValue !== optionsSrcOverrideValue;
	        }
	        if (subOptionsSrcOverrideValue) {
	          subOptionsSrcChanged = prevProps.subOptionsSrcOverrideValue !== subOptionsSrcOverrideValue;
	        }
	        if (optionsSrcChanged || subOptionsSrcChanged) {
	          _this.setState({ options: [{ value: '0', label: 'Loading...' }] });
	          _this.resetValue();
	          if (_this.props.onOptionsFetchStarted) _this.props.onOptionsFetchStarted();
	          _this.props.getGroupItemsAndSetFieldOptions(fieldId, _this.getPassedField(), _this.props.onOptionsFetched);
	        }
	      }
	    };
	
	    _this.resolveUnmountedOverrideChanges = function () {
	      var _this$props2 = _this.props,
	          fields = _this$props2.fields,
	          optionsSrcOverride = _this$props2.optionsSrcOverride,
	          subOptionsSrcOverride = _this$props2.subOptionsSrcOverride,
	          lastSeenOptionsSrcOverride = _this$props2.lastSeenOptionsSrcOverride,
	          lastSeenSubOptionsSrcOverride = _this$props2.lastSeenSubOptionsSrcOverride;
	
	      var overrideChangedWhileUnmounted = false;
	      if (optionsSrcOverride && lastSeenOptionsSrcOverride) {
	        overrideChangedWhileUnmounted = !(0, _deepEqual2.default)(lastSeenOptionsSrcOverride, fields[optionsSrcOverride].value);
	      }
	      if (subOptionsSrcOverride && overrideChangedWhileUnmounted === false && lastSeenSubOptionsSrcOverride) {
	        overrideChangedWhileUnmounted = !(0, _deepEqual2.default)(lastSeenSubOptionsSrcOverride, fields[subOptionsSrcOverride].value);
	      }
	      if (overrideChangedWhileUnmounted) {
	        _this.resetValue();
	      }
	      return overrideChangedWhileUnmounted;
	    };
	
	    _this.resetValue = function () {
	      _this.props.setFieldAttributes({
	        fieldId: _this.props.fieldId,
	        payload: { value: _this.props.controlType === 'ServerMultiComplete' ? [] : '' }
	      });
	    };
	
	    _this.getPassedField = function () {
	      return _this.props.passFieldToOptionsHandler ? {
	        optionsSrc: _this.props.optionsSrcOverrideValue || _this.props.optionsSrc,
	        subOptionsSrc: _this.props.subOptionsSrcOverrideValue || _this.props.subOptionsSrc
	      } : undefined;
	    };
	
	    _this.getOptions = function (_ref) {
	      var forceFetch = _ref.forceFetch;
	
	      if (!_this.props.optionsFetched || forceFetch) {
	        _this.props.getGroupItemsAndSetFieldOptions(_this.props.fieldId, _this.getPassedField(), _this.props.onOptionsFetched);
	      }
	    };
	
	    _this.formatLabel = function (str) {
	      str = str.toLowerCase().split(' ');
	      for (var i = 0; i < str.length; i++) {
	        str[i] = str[i].split('');
	        if (str[i].length > 0) {
	          str[i][0] = str[i][0].toUpperCase();
	          str[i] = str[i].join('');
	        }
	      }
	      return str.join(' ').replace('_', ' ').replace('-', ' ');
	    };
	
	    _this.setFieldValue = function (value, e, payload) {
	      _this.props.onChange(value, e, Object.assign({}, payload, {
	        selectedOptionLabel: _this.state.options.find(function (option) {
	          return (option.value === value).label;
	        })
	      }));
	    };
	
	    _this.handleFieldBlur = function (value) {
	      _this.props.onBlur(value);
	    };
	
	    _this.state = { options: [{ value: '0', label: 'Loading...' }] };
	    return _this;
	  }
	
	  _createClass(ServerOptions, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.setState({ options: [{ value: '0', label: 'Loading...' }] });
	      var shouldForceFetch = !this.props.options.length || this.resolveUnmountedOverrideChanges() || this.props.getGroupItemsOnLoad;
	      this.getOptions({ forceFetch: shouldForceFetch });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          value = _props.value,
	          required = _props.required,
	          name = _props.name,
	          controlType = _props.controlType,
	          width = _props.width,
	          isValid = _props.isValid,
	          disabled = _props.disabled,
	          validityClass = _props.validityClass,
	          _props$options = _props.options,
	          options = _props$options === undefined ? [] : _props$options,
	          placeholder = _props.placeholder,
	          optionGroups = _props.optionGroups,
	          fieldId = _props.fieldId,
	          tabIndex = _props.tabIndex,
	          restProps = _objectWithoutProperties(_props, ['value', 'required', 'name', 'controlType', 'width', 'isValid', 'disabled', 'validityClass', 'options', 'placeholder', 'optionGroups', 'fieldId', 'tabIndex']);
	
	      var computedOptions = options;
	      if (controlType === 'select') {
	        if (required) {
	          computedOptions = [{ value: '', label: '[Select an option]' }].concat(_toConsumableArray(options));
	        } else {
	          computedOptions = [{ value: '0', label: placeholder }].concat(_toConsumableArray(options));
	        }
	      }
	      return _react2.default.createElement(
	        'div',
	        null,
	        controlType === 'select' ? _react2.default.createElement(_Form.Select, {
	          onChange: this.setFieldValue,
	          onBlur: this.handleFieldBlur,
	          fieldId: fieldId,
	          options: computedOptions,
	          value: value,
	          required: required,
	          width: width,
	          validityClass: validityClass,
	          isValid: isValid,
	          disabled: disabled,
	          optionGroups: optionGroups,
	          tabIndex: tabIndex
	        }) : controlType === 'ServerMultiComplete' ? _react2.default.createElement(_MultiComplete2.default, Object.assign({
	          onChange: this.setFieldValue,
	          onBlur: this.handleFieldBlur,
	          fieldId: fieldId,
	          name: name,
	          options: computedOptions,
	          value: value,
	          required: required,
	          width: width,
	          validityClass: validityClass,
	          isValid: isValid,
	          disabled: disabled,
	          tabIndex: tabIndex
	        }, restProps)) : _react2.default.createElement(_Form.RadioInput, {
	          onChange: this.setFieldValue,
	          onBlur: this.handleFieldBlur,
	          fieldId: fieldId,
	          name: name,
	          options: computedOptions,
	          value: value,
	          required: required,
	          width: width,
	          validityClass: validityClass,
	          isValid: isValid,
	          disabled: disabled,
	          tabIndex: tabIndex
	        })
	      );
	    }
	  }]);
	
	  return ServerOptions;
	}(_react.Component);
	
	exports.default = (0, _reactRedux.connect)(function (state) {
	  return {
	    fields: state.wizard.wizard.fields
	  };
	}, { getGroupItemsAndSetFieldOptions: _WizardActions.getGroupItemsAndSetFieldOptions, setFieldAttributes: _WizardActions.setFieldAttributes })(ServerOptions);

/***/ },
/* 476 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(7);
	
	var _WizardClasses = __webpack_require__(35);
	
	var WizardClasses = _interopRequireWildcard(_WizardClasses);
	
	var _store = __webpack_require__(18);
	
	var _store2 = _interopRequireDefault(_store);
	
	var _deepEqual = __webpack_require__(65);
	
	var _deepEqual2 = _interopRequireDefault(_deepEqual);
	
	var _wizardUtilities = __webpack_require__(52);
	
	var _format = __webpack_require__(33);
	
	var _format2 = _interopRequireDefault(_format);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Summary = function (_Component) {
	  _inherits(Summary, _Component);
	
	  function Summary() {
	    _classCallCheck(this, Summary);
	
	    return _possibleConstructorReturn(this, (Summary.__proto__ || Object.getPrototypeOf(Summary)).apply(this, arguments));
	  }
	
	  _createClass(Summary, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          steps = _props.steps,
	          sections = _props.sections,
	          fields = _props.fields,
	          mode = _props.mode,
	          originalValues = _props.originalValues,
	          originalByFieldId = _props.originalByFieldId,
	          showDiff = _props.showDiff;
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'confirm' },
	        _react2.default.createElement(
	          'div',
	          { className: 'row' },
	          steps.map(function (step, i) {
	            return step.includeInSummary ? _react2.default.createElement(
	              ConfirmStep,
	              { title: step.title, mode: mode, key: step.stepId },
	              step.sectionOrder.map(function (sectionId) {
	                var section = sections[sectionId];
	                return _react2.default.createElement(
	                  ConfirmSection,
	                  { title: section.title, mode: mode, key: section.sectionId },
	                  section.fieldOrder.filter(function (fieldId) {
	                    return fields[fieldId].includeInSummary === true;
	                  }).map(function (fieldId) {
	                    var field = (0, _store.resolveFieldLogic)(fields[fieldId]);
	
	                    var fieldClass = new WizardClasses[field.fieldClass]();
	                    var isNotInAmendmentMode = !showDiff;
	                    var fieldColSpan = field.fieldClass !== 'Paragraph' && field.fieldClass !== 'UCCSearch' ? 'col-6' : 'col-12';
	                    var valuesHaveChanged = originalValues.hasOwnProperty(field.name) && WizardClasses[field.fieldClass].compareValues(originalValues[field.name], field.value);
	
	                    var conditionsSatsified = (0, _wizardUtilities.resolveFieldConditions)(field.conditions, fields, field.conditionsOperator);
	
	                    //Check if any dependent option fields have subfields with changed values.
	                    if (field.hasOptionFields) {
	                      var selectedOption = field.options.find(function (option) {
	                        return option.value === field.value;
	                      });
	                      if (selectedOption) {
	                        selectedOption.fields.forEach(function (subfieldId) {
	                          var subfield = fields[subfieldId];
	                          var subfieldValueHasChanged = originalValues.hasOwnProperty(subfield.name) && WizardClasses[subfield.fieldClass].compareValues(originalValues[subfield.name], subfield.value);
	
	                          valuesHaveChanged = valuesHaveChanged === true ? true : subfieldValueHasChanged;
	                        });
	                      }
	                    }
	
	                    //Check if any dependent check fields have subfields with changed values.
	                    if (field.hasCheckFields) {
	                      var checkedProp = field.value === true ? 'checkedFields' : 'uncheckedFields';
	                      field[checkedProp].forEach(function (subfieldId) {
	                        var subfield = fields[subfieldId];
	                        var subfieldValueHasChanged = originalValues.hasOwnProperty(subfield.name) && WizardClasses[subfield.fieldClass].compareValues(originalValues[subfield.name], subfield.value);
	
	                        valuesHaveChanged = valuesHaveChanged === true ? true : subfieldValueHasChanged;
	                      });
	                    }
	
	                    if ((isNotInAmendmentMode || valuesHaveChanged || field.alwaysIncludeInSummary) && field.active && conditionsSatsified) {
	                      if (field.type === 'repeater') {
	                        if (field.displayType === 'additional_article_layout' && field.value.length === 0) {
	                          return null;
	                        }
	                        return _react2.default.createElement(DumbRepeater, Object.assign({}, field, {
	                          key: field.fieldId,
	                          originalByFieldId: originalByFieldId
	                        }));
	                      }
	
	                      if (field.type === 'Signatures') {
	                        return _react2.default.createElement(SummarySignatures, Object.assign({}, field, { key: field.fieldId }));
	                      } else if (field.hasOptionFields) {
	                        var _selectedOption = field.options.find(function (option) {
	                          return option.value.toString() === field.value.toString();
	                        });
	                        var parentFieldValueHasChanged = originalValues.hasOwnProperty(field.name) && WizardClasses[field.fieldClass].compareValues(originalValues[field.name], field.value);
	
	                        return _react2.default.createElement(
	                          'div',
	                          { className: 'field-divider', key: field.fieldId },
	                          parentFieldValueHasChanged || isNotInAmendmentMode || field.alwaysIncludeInSummary ? _react2.default.createElement(ConfirmField, {
	                            label: field.label,
	                            value: fieldClass.getHumanReadableValue(field, field.value),
	                            colSpan: fieldColSpan,
	                            key: field.fieldId
	                          }) : null,
	                          _selectedOption ? _selectedOption.fields.filter(function (subfieldId) {
	                            return fields[subfieldId].includeInSummary;
	                          }).map(function (subfieldId) {
	                            var subfield = fields[subfieldId];
	                            var subfieldClass = new WizardClasses[subfield.fieldClass]();
	                            var subfieldValueHasChanged = originalValues.hasOwnProperty(subfield.name) && WizardClasses[subfield.fieldClass].compareValues(originalValues[subfield.name], subfield.value);
	
	                            var subfieldConditionsSatisfied = (0, _wizardUtilities.resolveFieldConditions)(subfield.conditions, fields, subfield.conditionsOperator);
	                            return (subfieldValueHasChanged || subfield.alwaysIncludeInSummary || isNotInAmendmentMode) && subfield.active && subfieldConditionsSatisfied ? _react2.default.createElement(ConfirmField, {
	                              label: subfield.label,
	                              value: subfieldClass.getHumanReadableValue(subfield, subfield.value),
	                              colSpan: fieldColSpan,
	                              key: subfield.fieldId
	                            }) : null;
	                          }) : null
	                        );
	                      } else if (field.hasCheckFields) {
	                        var _checkedProp = field.value === true ? 'checkedFields' : 'uncheckedFields';
	                        var _parentFieldValueHasChanged = originalValues.hasOwnProperty(field.name) && WizardClasses[field.fieldClass].compareValues(originalValues[field.name], field.value);
	
	                        return _react2.default.createElement(
	                          'div',
	                          { className: 'field-divider', key: field.fieldId },
	                          _parentFieldValueHasChanged || isNotInAmendmentMode || field.alwaysIncludeInSummary ? _react2.default.createElement(ConfirmField, {
	                            label: field.label,
	                            value: fieldClass.getHumanReadableValue(field, field.value),
	                            colSpan: fieldColSpan,
	                            key: field.fieldId
	                          }) : null,
	                          field[_checkedProp].filter(function (subfieldId) {
	                            return fields[subfieldId].includeInSummary;
	                          }).map(function (subfieldId) {
	                            var subfield = fields[subfieldId];
	                            var subfieldClass = new WizardClasses[subfield.fieldClass]();
	                            var subfieldValueHasChanged = originalValues.hasOwnProperty(subfield.name) && WizardClasses[subfield.fieldClass].compareValues(originalValues[subfield.name], subfield.value);
	
	                            var subfieldConditionsSatisfied = (0, _wizardUtilities.resolveFieldConditions)(subfield.conditions, fields, subfield.conditionsOperator);
	                            return (subfieldValueHasChanged || subfield.alwaysIncludeInSummary || isNotInAmendmentMode) && subfield.active && subfieldConditionsSatisfied ? _react2.default.createElement(ConfirmField, {
	                              label: subfield.label,
	                              value: subfieldClass.getHumanReadableValue(subfield, subfield.value),
	                              colSpan: fieldColSpan,
	                              key: subfield.fieldId
	                            }) : null;
	                          })
	                        );
	                      } else {
	                        return _react2.default.createElement(ConfirmField, {
	                          label: field.label,
	                          value: fieldClass.getHumanReadableValue(field, field.value),
	                          colSpan: fieldColSpan,
	                          key: field.fieldId
	                        });
	                      }
	                    } else {
	                      return null;
	                    }
	                  })
	                );
	              })
	            ) : null;
	          })
	        )
	      );
	    }
	  }]);
	
	  return Summary;
	}(_react.Component);
	
	exports.default = (0, _reactRedux.connect)(function (state) {
	  return {
	    steps: state.wizard.wizard.stepOrder.map(function (stepId) {
	      return state.wizard.wizard.steps[stepId];
	    }),
	    sections: state.wizard.wizard.sections,
	    fields: state.wizard.wizard.fields,
	    mode: state.wizard.mode,
	    originalValues: state.wizard.diff.original,
	    originalByFieldId: state.wizard.diff.originalByFieldId,
	    showDiff: state.wizard.showDiff
	  };
	})(Summary);
	
	
	var ConfirmStep = function ConfirmStep(_ref) {
	  var title = _ref.title,
	      children = _ref.children,
	      mode = _ref.mode;
	  return _react2.default.Children.toArray(children).filter(function (child) {
	    return child.props.children.filter(function (subchild) {
	      return subchild;
	    }).length > 0;
	  }).length > 0 && _react2.default.createElement(
	    'div',
	    { className: 'col-12 confirm-col' },
	    _react2.default.createElement(
	      'div',
	      { className: 'confirm-step' },
	      _react2.default.createElement(
	        'h4',
	        { className: 'title' },
	        title
	      ),
	      children
	    )
	  );
	};
	
	var ConfirmSection = function ConfirmSection(_ref2) {
	  var title = _ref2.title,
	      children = _ref2.children,
	      mode = _ref2.mode;
	  return _react2.default.Children.toArray(children).length > 0 && _react2.default.createElement(
	    'div',
	    { className: 'confirm-section' },
	    _react2.default.createElement(
	      'h4',
	      { className: 'section-title' },
	      title
	    ),
	    children
	  );
	};
	
	var ConfirmField = function ConfirmField(_ref3) {
	  var label = _ref3.label,
	      value = _ref3.value,
	      colSpan = _ref3.colSpan;
	  return _react2.default.createElement(
	    'div',
	    { className: 'row field-divider' },
	    colSpan !== 'col-12' ? _react2.default.createElement(
	      'div',
	      { className: colSpan },
	      _react2.default.createElement(
	        'i',
	        null,
	        label
	      )
	    ) : null,
	    _react2.default.createElement(
	      'div',
	      { className: colSpan + ' value' },
	      _react2.default.createElement(
	        'b',
	        null,
	        value && value !== undefined && value !== "" ? value : _react2.default.createElement(
	          'span',
	          { className: 'visually-hidden' },
	          'No entry'
	        )
	      )
	    )
	  );
	};
	
	var DumbRepeater = function DumbRepeater(_ref4) {
	  var fieldId = _ref4.fieldId,
	      ame = _ref4.ame,
	      label = _ref4.label,
	      template = _ref4.template,
	      value = _ref4.value,
	      emptyRepeaterLabel = _ref4.emptyRepeaterLabel,
	      displayType = _ref4.displayType,
	      trackChanges = _ref4.trackChanges,
	      showChangesOnForm = _ref4.showChangesOnForm,
	      showChangesOnSummary = _ref4.showChangesOnSummary,
	      noDeletedStylingOnSummary = _ref4.noDeletedStylingOnSummary,
	      originalByFieldId = _ref4.originalByFieldId;
	
	  var fields = _store2.default.getState().wizard.wizard.fields;
	  var filteredTemplate = template.filter(function (item) {
	    return fields[item].fieldClass !== 'Paragraph';
	  }).filter(function (item) {
	    return fields[item].active && !fields[item].hideInRepeaterGrid;
	  });
	  return _react2.default.createElement(
	    'div',
	    { className: 'row field-divider' },
	    _react2.default.createElement(
	      'span',
	      { className: 'repeats-wrapper' },
	      _react2.default.createElement(
	        'div',
	        { className: 'repeats dumb-repeats' },
	        _react2.default.createElement(
	          'table',
	          { className: 'form-table' },
	          _react2.default.createElement(
	            'thead',
	            null,
	            _react2.default.createElement(
	              'tr',
	              null,
	              filteredTemplate.map(function (fieldId, i) {
	                return _react2.default.createElement(
	                  'th',
	                  { key: i },
	                  fields[fieldId].shortLabel !== '' ? fields[fieldId].shortLabel : fields[fieldId].label
	                );
	              })
	            )
	          ),
	          _react2.default.createElement(
	            'tbody',
	            null,
	            value.length === 0 && emptyRepeaterLabel !== '' ? _react2.default.createElement(
	              'tr',
	              { className: 'repeats-row' },
	              _react2.default.createElement(
	                'td',
	                { className: 'no-entries', colSpan: filteredTemplate.length },
	                emptyRepeaterLabel === '' ? 'None' : emptyRepeaterLabel
	              )
	            ) : value.map(function (row, i) {
	              return _react2.default.createElement(DumbRow, {
	                fieldId: fieldId,
	                trackChanges: trackChanges,
	                showChangesOnForm: showChangesOnForm,
	                showChangesOnSummary: showChangesOnSummary,
	                noDeletedStylingOnSummary: noDeletedStylingOnSummary,
	                originalByFieldId: originalByFieldId,
	                row: row,
	                rowIndex: i,
	                key: i
	              });
	            })
	          )
	        )
	      )
	    )
	  );
	};
	
	var DumbRow = function DumbRow(_ref5) {
	  var parentFieldId = _ref5.fieldId,
	      row = _ref5.row,
	      trackChanges = _ref5.trackChanges,
	      showChangesOnForm = _ref5.showChangesOnForm,
	      showChangesOnSummary = _ref5.showChangesOnSummary,
	      noDeletedStylingOnSummary = _ref5.noDeletedStylingOnSummary,
	      originalByFieldId = _ref5.originalByFieldId,
	      rowIndex = _ref5.rowIndex;
	
	  var fields = _store2.default.getState().wizard.wizard.fields;
	  var getCellValue = function getCellValue(fieldId, value) {
	    var field = fields[fieldId];
	    var fieldClass = new WizardClasses[field.fieldClass]();
	    return fieldClass.getHumanReadableValue(field, value);
	  };
	  var deleting = row._statusId === 3;
	  var added = row._statusId === 1;
	  var edited = row._statusId === 2;
	  return _react2.default.createElement(
	    'tr',
	    {
	      className: 'repeats-row ' + (deleting && trackChanges ? 'deleting' : '') + ' ' + (added && trackChanges ? 'adding' : '') + ' ' + (edited && trackChanges ? 'edited' : '') + '\n      ' + (noDeletedStylingOnSummary ? 'hide-strikethrough' : '') + '\n      '
	    },
	    Object.keys(row).filter(function (fieldId) {
	      return fieldId.charAt(0) !== '_' && fields[fieldId].active && (showChangesOnSummary && trackChanges ? deleting || added || edited : true) && !(fields[fieldId] || {}).hideInRepeaterGrid;
	    }).map(function (fieldId, i) {
	      return fields[fieldId].fieldClass !== 'Paragraph' ? edited && trackChanges && showChangesOnForm ? _react2.default.createElement(HistoryCell, {
	        original: (originalByFieldId[parentFieldId][rowIndex] || {})[fieldId],
	        current: row[fieldId],
	        getCellValue: getCellValue,
	        edited: edited,
	        originalByFieldId: originalByFieldId,
	        fieldId: fieldId,
	        key: i
	      }) : _react2.default.createElement(
	        'td',
	        { key: i },
	        getCellValue(fieldId, row[fieldId])
	      ) : null;
	    })
	  );
	};
	
	var HistoryCell = function HistoryCell(_ref6) {
	  var original = _ref6.original,
	      fieldId = _ref6.fieldId,
	      originalByFieldId = _ref6.originalByFieldId,
	      current = _ref6.current,
	      getCellValue = _ref6.getCellValue,
	      edited = _ref6.edited;
	  return !(0, _deepEqual2.default)(original, current) && edited && original && current ? _react2.default.createElement(
	    'td',
	    null,
	    _react2.default.createElement(
	      'div',
	      { className: 'cell-history' },
	      _react2.default.createElement(
	        'span',
	        { className: 'label' },
	        'Changed From: '
	      ),
	      _react2.default.createElement(
	        'span',
	        { className: 'before' },
	        getCellValue(fieldId, original)
	      ),
	      _react2.default.createElement(
	        'span',
	        { className: 'label' },
	        'Changed To: '
	      ),
	      _react2.default.createElement(
	        'span',
	        { className: 'after' },
	        getCellValue(fieldId, current)
	      )
	    )
	  ) : _react2.default.createElement(
	    'td',
	    null,
	    getCellValue(fieldId, current)
	  );
	};
	
	var SummarySignatures = function SummarySignatures(_ref7) {
	  var srcRepeater = _ref7.srcRepeater,
	      srcField = _ref7.srcField,
	      value = _ref7.value,
	      multiple = _ref7.multiple;
	
	  var fields = _store2.default.getState().wizard.wizard.fields;
	  var repeaterRows = fields[srcRepeater] ? fields[srcRepeater].value : [];
	  var columnField = fields[srcField] ? new WizardClasses[fields[srcField].fieldClass](fields[srcField]) : null;
	  return _react2.default.createElement(
	    'div',
	    { className: 'summary-signatures field-divider' },
	    multiple ? columnField && repeaterRows.map(function (row, i) {
	      var signature = value[i] ? value[i] : {};
	      return _react2.default.createElement(SummarySignatureRow, {
	        name: columnField.getHumanReadableValue(columnField, row[columnField.fieldId]),
	        signature: signature,
	        key: i
	      });
	    }) : _react2.default.createElement(SummarySignatureRow, { name: 'Signature', signature: value[0] || {} })
	  );
	};
	
	var SummarySignatureRow = function SummarySignatureRow(_ref8) {
	  var name = _ref8.name,
	      signature = _ref8.signature;
	  return _react2.default.createElement(
	    'div',
	    { className: 'row signature-row' },
	    _react2.default.createElement(
	      'div',
	      { className: 'col-md-9' },
	      _react2.default.createElement(
	        'span',
	        { className: 'signature' },
	        ' ',
	        signature.sig
	      ),
	      _react2.default.createElement('br', null),
	      _react2.default.createElement(
	        'span',
	        { className: 'name' },
	        name
	      )
	    ),
	    _react2.default.createElement('br', null),
	    _react2.default.createElement(
	      'div',
	      { className: 'col-md-3' },
	      _react2.default.createElement(
	        'span',
	        { className: 'signature' },
	        (0, _format2.default)(new Date(signature.date), 'MM/dd/yyyy')
	      ),
	      _react2.default.createElement('br', null),
	      _react2.default.createElement(
	        'span',
	        { className: 'name' },
	        'Date'
	      )
	    )
	  );
	};

/***/ },
/* 477 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.UCCSearchDisplay = exports.UCCSearch = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Field = __webpack_require__(25);
	
	var _Form = __webpack_require__(14);
	
	var _utilities = __webpack_require__(8);
	
	var _selectOptions = __webpack_require__(68);
	
	var _searchHeavy = __webpack_require__(129);
	
	var _searchHeavy2 = _interopRequireDefault(_searchHeavy);
	
	var _revert = __webpack_require__(227);
	
	var _revert2 = _interopRequireDefault(_revert);
	
	var _Modal = __webpack_require__(13);
	
	var _HelpTooltip = __webpack_require__(1159);
	
	var _Portal = __webpack_require__(12);
	
	var _Portal2 = _interopRequireDefault(_Portal);
	
	var _requests = __webpack_require__(6);
	
	var _orderBy = __webpack_require__(103);
	
	var _orderBy2 = _interopRequireDefault(_orderBy);
	
	var _format = __webpack_require__(33);
	
	var _format2 = _interopRequireDefault(_format);
	
	var _actions = __webpack_require__(29);
	
	var _reactRedux = __webpack_require__(7);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	var STATE_OPTIONS = [{ value: '', label: '' }].concat(_toConsumableArray(_selectOptions.stateOptions));
	var UCC_SEARCH_ALLOW_SEARCH_TYPE = ({"NODE_ENV":"production","BUILD_DATE":"2025-08-27T15:15:31.687Z","BUILD_NUMBER":"Not Provided","GIT_VERSION":"v1.3.0-381-ga81e29b08","GIT_COMMIT_HASH":"a81e29b085c9268ffd96c78eb734365802722741","GIT_BRANCH":"beta","PUBLIC_URL":"","STATE_ABBR":"MT","STATE_NAME":"Montana","STATE_ORG_TITLE":"Secretary of State","LOGIN_HEADER_IMG_PATH":"","HOME_IMG_FILENAME":"montana.jpg","FAVICON_FILE_NAME":"favicon.ico","ALLOW_E_SIGN_ON_CORRECTIONS":true,"THIRD_PARTY_SIGNING_ALLOWED":false,"MY_ACCOUNT_SAVE_AND_CLOSE_BUTTON":true,"IE_DEPRECATED_MESSAGE":"Internet Explorer is not supported. Please select a supported browser below to access this website.","ADDITIONAL_ROUTES":{"dataRequests":true,"farmBill":true,"apostille":true,"externalHelp":"https://sosmt.gov/business/help-center/","systemAdministration":[{"title":"Saved Payments","parameter":"saved-payments","componentName":"SavedPayments"}]},"SUBROUTES":[{"label":"Business","component":"Business","parameter":"business","myWorkQueueSearch":false,"sourceTypeId":54,"searchMustHaveOneOf":["FILING_TYPE_ID","STATUS_ID","STATE","search"],"serverWebSearchDescription":true,"serverWorkQueueDescription":true,"serverMyRecordsDescription":true,"searchPlaceholder":"Search by name or filing number (X########)","allowEmptySearchTerm":true,"requestCertificateAlternateLabel":"Request Information","fileAmendmentButtonLabel":"Filing Actions","advancedSearchParameters":[{"type":"radio","name":"QUERY_TYPE_ID","defaultValue":1010,"options":[{"value":1010,"label":"Starts with"},{"value":1011,"label":"Contains"},{"value":1012,"label":" Word Contains"}]},{"type":"serverSelect","name":"FILING_TYPE_ID","optionsSrc":"FILING_TYPES","label":"Entity Type","placeholder":"All","defaultValue":"0"},{"type":"serverSelect","name":"FILING_SUBTYPE_ID","optionsSrc":"FILING_SUBTYPES","label":"Entity Subtype","overrideSubOptionsSrcFromParameterName":"FILING_TYPE_ID","placeholder":"All","defaultValue":"0"},{"type":"serverSelect","name":"STATUS_ID","optionsSrc":"FILING_STATUS_WITHOUT_ALL","label":"Status","placeholder":"All","defaultValue":"0"},{"type":"serverSelect","name":"STATE","optionsSrc":"STATE","label":"State","placeholder":"All","defaultValue":""},{"type":"serverSelect","name":"COUNTY","optionsSrc":"COUNTY_SUBOPTION","label":"County","overrideSubOptionsSrcFromParameterName":"STATE","placeholder":"All","defaultValue":""},{"type":"checkbox","name":"CRA_SEARCH_YN","defaultValue":false,"label":"Search by Registered Agent PID"},{"type":"dateRange","name":"FILING_DATE","label":"Registration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}},{"type":"dateRange","name":"EXPIRATION_DATE","label":"Expiration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}}],"myRecordsFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Active"},{"value":2,"label":"Inactive"},{"value":3,"label":"Pending"}]},{"type":"dateRange","name":"DATE_RANGE","label":"Date range","defaultValue":{"start":null,"end":null}}],"myWorkQueueFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Approved"},{"value":2,"label":"Pending Online Payment"},{"value":3,"label":"Pending Review"},{"value":4,"label":"Needs Correction"},{"value":5,"label":"Rejected"},{"value":6,"label":"Draft"}]},{"type":"dateRange","name":"DATE_RANGE","label":"Date range","defaultValue":{"start":null,"end":null}}]},{"label":"Notary","component":"Notary","parameter":"notary","sourceTypeId":850,"myWorkQueueSearch":false,"allowEmptySearchTerm":true,"requestCertificateAlternateLabel":"Download Certificate","fileAmendmentButtonLabel":"Filing Actions","hideNameRequestCertificate":true,"hideAddressRequestCertificate":true,"hideRecordUserManagment":true,"searchPlaceholder":"Search by name or commission number","searchMustHaveOneOf":["CITY","search","SERVICE_TYPE"],"advancedParametersStartOpen":true,"searchIsSortable":true,"advancedSearchParameters":[{"type":"radio","name":"STARTS_WITH_YN","defaultValue":false,"options":[{"value":true,"label":"Starts with"},{"value":false,"label":"Contains"}]},{"type":"checkbox","name":"ACTIVE_ONLY_YN","defaultValue":true,"label":"Active entities only"},{"type":"text","name":"CITY","defaultValue":"","label":"City"},{"type":"select","name":"SERVICE_TYPE","label":"Special Services Offered","defaultValue":0,"options":[{"value":0,"label":"(N/A)"},{"value":6165,"label":"In-Person Electronic Notarization (IPEN)"},{"value":6166,"label":"Remote Online Notarization (RON)"},{"value":6167,"label":"Mobile Notary Services"},{"value":6168,"label":"Remote Ink Notarization (RIN)"}]}]},{"label":"Apostille","component":"Apostille","parameter":"apostille","sourceTypeId":720,"myRecordsSearch":false,"myWorkQueueSearch":false,"disabled":false,"allowedRoutes":["/forms-manager/","/queue/","/forms/"]},{"label":"Liens","component":"UCC","parameter":"ucc","sourceTypeId":1999,"myRecordsSearch":true,"myWorkQueueSearch":true,"fileAmendmentButtonLabel":"Filing Actions","searchPlaceholder":"Search by name or file number","disabled":false,"serverWebSearchDescription":true,"myRecordsDescription":"","workQueueDescription":"","searchDescription":"","hideRecordUserManagment":true,"searchLiensCheckout":false,"advancedSearchParameters":[{"type":"radio","name":"STARTS_WITH_YN","defaultValue":false,"options":[{"value":true,"label":"Starts with"},{"value":false,"label":"Contains"}]},{"type":"select","name":"STATUS","defaultValue":"ALL","label":"Status","options":[{"value":"ACTIVE_UNLAPSED","label":"Active (unlapsed)"},{"value":"ACTIVE_LAPSED_UNLAPSED","label":"Active (lapsed and unlapsed)"}]},{"type":"text","name":"EXCLUDE_VALUES","label":"Exclude Debtor Names (comma separated list of names to exclude)","defaultValue":""},{"type":"dateRange","name":"FILING_DATE","label":"Financing Statement Date","defaultValue":{"start":null,"end":null}},{"type":"dateRange","name":"LAPSE_DATE","label":"Lapse Date","defaultValue":{"start":null,"end":null}},{"type":"text","name":"CITY","label":"Debtor City","defaultValue":""}],"myRecordsFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Approved"},{"value":2,"label":"Pending Online Payment"},{"value":3,"label":"Pending Review"}]},{"type":"select","name":"TYPE","defaultValue":0,"label":"Lien Type","options":[{"value":0,"label":"All"},{"value":1,"label":"UCC"},{"value":2,"label":"EFS"},{"value":3,"label":"Title 71"}]}],"myWorkQueueFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Approved"},{"value":2,"label":"Pending Online Payment"},{"value":3,"label":"Pending Review"},{"value":4,"label":"Pending Print and Mail"},{"value":5,"label":"Rejected"},{"value":6,"label":"Draft"}]},{"type":"select","name":"TYPE","defaultValue":0,"label":"Lien Type","options":[{"value":0,"label":"All"},{"value":1,"label":"UCC"},{"value":2,"label":"EFS"},{"value":3,"label":"Title 71"}]}]},{"label":"Copy Request","component":"copies","parameter":"copies","sourceTypeId":2001,"myRecordsSearch":false,"myWorkQueueSearch":false,"disabled":false,"allowedRoutes":["/forms-manager/","/queue/","/forms/"]},{"label":"Trademark","component":"Trademark","parameter":"trademark","sourceTypeId":810,"showRequestCertificate":true,"searchMustHaveOneOf":["search","EXPIRATION_DATE","FILING_DATE"],"allowEmptySearchTerm":true,"requestCertificateAlternateLabel":"Request Information","fileAmendmentButtonLabel":"Filing Actions","advancedSearchParameters":[{"type":"radio","name":"QUERY_TYPE_ID","defaultValue":1010,"options":[{"value":1010,"label":"Starts with"},{"value":1011,"label":"Contains"},{"value":1012,"label":" Word Contains"}]},{"type":"checkbox","name":"OWNER_SEARCH_YN","defaultValue":false,"label":"Search owners"},{"type":"radio","name":"SERVICE_MARK_YN","label":"Mark Type","defaultValue":"","options":[{"value":"","label":"All Marks"},{"value":"Y","label":"Service Mark"},{"value":"N","label":"Trademark"}]},{"type":"serverSelect","name":"STATUS_ID","optionsSrc":"TYPE_V|TRADEMARK_STATUS_TYPE","label":"Status","placeholder":"All","defaultValue":"0"},{"type":"select","name":"DESIGN_TYPE_ID","options":[{"value":0,"label":"All"},{"value":990,"label":"Words Only"},{"value":991,"label":"Design Only"},{"value":992,"label":"Words and Design"}],"label":"Design Type","defaultValue":"0"},{"type":"dateRange","name":"FILING_DATE","label":"Registered Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}},{"type":"dateRange","name":"EXPIRATION_DATE","label":"Expiration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}}]},{"label":"Business Info Request","component":"InfoRequests","parameter":"info-request","sourceTypeId":167,"allowedRoutes":["/forms-manager/","/queue/","/forms/"]},{"label":"Data Requests","component":"DataRequests","parameter":"data-request","sourceTypeId":0,"allowedRoutes":["/forms-manager/"]},{"label":"CRA","component":"CRA","parameter":"cra","sourceTypeId":157,"myRecordsSearch":false,"searchPlaceholder":"Search by name or registered agent number","allowedRoutes":["/forms-manager/","/forms/","/records/","/queue/","/search/"],"allowEmptySearchTerm":true,"fileAmendmentButtonLabel":"Filing Actions","advancedSearchParameters":[{"type":"radio","name":"QUERY_TYPE_ID","defaultValue":1010,"options":[{"value":1010,"label":"Starts with"},{"value":1011,"label":"Contains"},{"value":1012,"label":" Word Contains"}]},{"type":"dateRange","name":"CRA_DATE","label":"Registration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}},{"type":"select","name":"STATUS_ID","label":"Status","defaultValue":0,"options":[{"value":0,"label":"All"},{"value":121,"label":"Active"},{"value":122,"label":"Inactive"}]},{"type":"select","name":"AGENT_TYPE_ID","label":"Agent Type","defaultValue":0,"options":[{"value":0,"label":"All"},{"value":460,"label":"Registered Agent"},{"value":461,"label":"Commercial Registered Agent"}]}]},{"label":"Farm Bill","component":"FarmBill","parameter":"farm-bill","path":"/lists/farm-bill","sourceTypeId":0,"myRecordsSearch":false,"allowedRules":["/search/"],"disabled":true,"searchDescription":"To perform a search, enter a debtor name. Your search results may include: exact debtor name, variations of that name and any filing that includes your search criteria. Punctuation is ignored.\n\nYou can click on \"Advanced\" to refine your search. Under “Advanced” you can search by crop, year, county and SSN/FEIN. As a registered Farm Bill Buyer with the Montana Secretary of State’s office it is important to maintain the confidentiality of the information contained within the Farm Bill Master List. The Farm Bill Master List reflects personal data, such as Social Security Numbers, which are a key piece of personal identifiable information to assist you in determining the existence of a lien against a specific debtor. The distribution of this information beyond its intended purpose is strictly prohibited.\n\nThe debtor's tax identification number has been hidden for confidentiality reasons. You may continue to search on a tax ID number and return debtors that match your search criteria. The SSN/FEIN must be entered without dashes or spaces.","searchMustHaveOneOf":["search","UCC_FARM_PRODUCT_ID","COUNTY"],"searchPlaceholder":"Search by debtor name","advancedSearchParameters":[{"type":"ServerMultiComplete","label":"Product code name(s)","name":"UCC_FARM_PRODUCT_ID","defaultValue":"","optionsSrc":"UCC_FARM_PRODUCT_V"},{"type":"MultiComplete","label":"Year or Range of Years","name":"YEAR_NUM","optionsSrc":"years","startYear":"1968","defaultValue":[],"preMergeOptions":[{"value":"ALL","label":"All"}]},{"type":"serverSelect","label":"State","name":"STATE","defaultValue":"MONTANA","optionsSrc":"STATE"},{"type":"ServerMultiComplete","label":"County","name":"COUNTY","defaultValue":[],"optionsSrc":"COUNTY","overrideSubOptionsSrcFromParameterName":"STATE"},{"type":"checkbox","name":"TIN_SEARCH_YN","defaultValue":false,"label":"Tax Identification Number Search"},{"type":"checkbox","name":"TIN_SORT_YN","defaultValue":false,"label":"Unique ID Sort"}]}],"SYSTEM_NICKNAME":"Online Services Portal","PAYMENT_METHODS":[{"type":"bypass"},{"type":"iTransact"}],"PAYMENT_ALLOW_AMEX":true,"SYSTEM_ID_LABEL":"System Id","DOUBLE_COLUMN_PUBLIC_LOGIN":true,"INTERNAL_USER_MANAGEMENT":true,"ALLOW_PUBLIC_JSON_IMPORT":false,"MAX_FILE_UPLOAD_SIZE":10000000,"REFUND_TEXT":"","RETURN_TO_HOME_ON_LOGOUT":true,"CURRENT_SOS_NAME":"Christi Jacobsen","LOGO_FILENAME":"mt-sos-logo.png","LOGO_ALT":"Christi Jacobsen, Montana Secretary of State","LOGO_FULL_WIDTH":true,"HOME_HIDE_AUTH_HINT":true,"HOME_TITLE":"Montana Secretary of State","CUSTOM_TAB_TITLE":"Official Montana","HOME_SUBTITLE":"Online Business Services","ENTITY_NAME_CONSENT_DESCRIPTION":"","ALLOW_USER_PROFILE_EDITING":true,"COMPARE_FOREIGN_NAME_IN_ENTITY_NAME_VALIDATION":true,"FOREIGN_NAME_FIELD_NAME":"KIMA_PARENT_NAME_INFO","LOGIN_TITLE":"Montana Secretary of State Online Filing Portal Login","PUBLIC_LOGIN_LABEL":"Username","REVERSE_LOGIN_COLUMNS":true,"LOGIN_SEAL_FILENAME":"seal_white.png","SEPARATE_USERNAME_AND_EMAIL":true,"CREATE_ACCOUNT_BUTTON_ALIGN_LEFT":true,"CREATE_ACCOUNT_BUTTON_TEXT":"CREATE AN ACCOUNT","PASSWORD_CUSTOM_ERROR_TEXT":"The password must meet all requirements","ACCOUNT_CREATED_MESSAGE":"Please check your email to verify your account to login and allow a few minutes for this message to arrive. Check your junk/spam folders if you do not find the email in your inbox.","PUBLIC_LOGIN_PLACEHOLDER":" ","DISABLE_DEFAULT_PAYMENT_RADIO":true,"CUSTOM_RESET_PASSWORD_ERROR_MESSAGE":"Username invalid - no account found","PUBLIC_LOGIN_CREATE_DESCRIPTION":"### Existing User:\n\n  - Enter your username and password to login.  \n\n\n  #### - OR -  \n\n\n\n  - Forgot password? Click 'Reset Password' and follow the prompts.\n  - Forgot username? Click 'Forgot Username' and follow the prompts.  \n\n\n  ### New User:\n  ","LOGIN_HELP_LINK":"https://sosmt.gov/business/how-do-i/","LOGIN_HELP_LINK_TEXT":"Need Help?","FORGOT_USERNAME_TEXT":"Forgot Username?","LOGIN_ACTIVE_DIRECTORY_TEXT":"State User Login","MULTIPLE_LOGIN_METHODS":true,"HAS_ACTIVE_DIRECTORY_LOGIN":true,"RESET_PASSWORD_WITH_USERNAME":true,"DOWNLOAD_LINK":true,"SHOW_USERNAME_ACCOUNT_CREATE":true,"SHOW_SCROLL_DOWN_ARROW":true,"SHOW_ADDRESS_ACCOUNT_CREATE":true,"TWO_COLUMN_ACCOUNT_CREATE":true,"RESET_PASSWORD_TIP":"A link to change your password has been sent to your email. Please allow a few minutes for this message to arrive. Please check your junk/spam folders if you do not find the email in your inbox.","FORGOT_PASSWORD_LINK_TEXT":"Reset Password","PHONE_NUMBER_OPTIONAL_ACCOUNT_CREATE":true,"SHOW_REQUIRED_INDICATOR_ACCOUNT_CREATE":true,"PASSWORD_REQUIREMENTS_ACCOUNT_CREATE":"\n    <ul>\n      <li>MUST contain at least 8 characters (12+ recommended)</li>\n      <li>MUST contain at least one uppercase letter.</li>\n      <li>MUST contain at least one lowercase letter.</li>\n      <li>MUST contain at least one number.</li>\n      <li>MUST contain at least one special character (!”#$%&'()*+,-./:;<=>?</li>\n    </ul>\n  ","ALLOW_CERTIFICATION_REQUEST":true,"ALLOW_PUBLIC_CERTIFICATE_REQUEST":true,"ALLOW_COPY_REQUEST":false,"ALLOW_CORRECTION_STYLING":true,"HIDE_DEPRECATION_WARNING":false,"AMEND_ROUTE_PUBLIC":true,"SEAL_FILENAME":"seal.png","SHOPPING_CART":true,"ALLOW_PAYMENT_UPDATE_WITH_EMPTY_CART":true,"RA_EMAIL":true,"RA_WEBSITE":true,"RA_NO_DEFAULT_TYPE":true,"RA_ADDRESS_LABEL":"Street Address","RA_TYPE_SELECTION_DEFAULT":true,"RA_DEFAULT_TYPE":"460","RA_OVERRIDE_TYPE_WITH_DEFAULT":true,"RA_PRINCIPAL_ADDRESS_AMS":true,"UPLOAD_AND_SUBMIT_HIDE_IF_ONE_OPTION":true,"PAYMENT_PROCESSING_MESSAGE":"Your payment is processing - Do not close your browser or click the back button","CHECKOUT_BUTTON_WHEN_PROCESSING_TEXT":"Processing","EFS_CROP_PICKER_NONE_LABEL":"Lien Duration","DISALLOWED_WIZARD_PIECES":["FormationLocale"],"REPEATER_SHOW_EDIT_BUTTON":true,"DATA_REQUEST_PAGE_TITLE":"Data Requests and Subscriptions","DATA_REQUEST_SIDEBAR_LABEL":"Data Requests & Subscriptions","LOGIN_REDIRECTS_TO_EPASS":false,"LOGIN_REDIRECTS_TO_ACTIVE_DIRECTORY":true,"LOGIN_ACTIVE_DIRECTORY_LINK":true,"FETCH_EDIT_USER_LINK":false,"LISTS_FETCH_AVAILABLE_LISTS":true,"POST_WIZARD_SUBMIT_REDIRECT_URL":"/","PIN_REQUEST_ATTESTATIONS":true,"PIN_REQUEST_DESCRIPTION":"Click **Request PIN** to have a new PIN sent to the account holder's email address on file.","OWNERSHIP_REQUEST_DESCRIPTION":"To become an **authorized user** of this record, a current **AUTHORIZED USER** will need to grant you access. To request access, click **Request Access** below.","PIN_REQUEST_SUCCESS_MESSAGE":"The PIN you have requested for this entity has been sent to the email associated with your user account.  You should receive the PIN in approximately 3-5 minutes, depending on your email service provider.","APOSTILLE_HEADER_LABEL":"Verification Information","APOSTILLE_NUMBER_LABEL":"Apostille/Authentication","APOSTILLE_CITY_STATE_OVERRIDE":"HELENA, MT","APOSTILLE_FILING_DATE_LABEL":"Issue Date","APOSTILLE_CITY_STATE_IN_CERTIFIED":true,"NOTARY_EXISTING_FILING":true,"ALLOW_REVOKE_OWN_ACCESS_ONLY":false,"HIDE_CANCEL_ON_ONETIME_DATA_REQUESTS":true,"DATA_REQUESTS_IN_SHOPPING_CART":true,"WQ_ALLOW_EDIT_PENDING_PAYMENT":true,"WQ_CONFIRM_ON_DELETE":true,"WQ_DELETE_CONFIRM_MESSAGE":"Deleting this filing will forfeit any money already paid to the Secretary of State. This action is permanent and cannot be undone, are you sure you would like to delete?","PASS_ITEM_GUIDS_ON_CHECKOUT":true,"FORM_REVISION_HISTORY":true,"CHECKOUT_DISCLAIMER":"By entering your credit card and/or checking account information you (i) state that **you are an authorized user** of the credit card and/or electronic check and that the associated information entered (e.g., account holder name, account number, billing address) is accurate, (ii) **you authorize payment processor to charge the amount you have requested** to your credit card and/or funding account, and (iii) **acknowledge if a charge is declined or reversed you may also be assessed a customary charge** by the payment processor for such transactions.","FARM_BILL_SEARCH_CONFIDENTIAL":"As a registered Farm Bill Buyer with the Montana Secretary of State’s office it is important to maintain the confidentiality of the information contained within the Farm Bill Master List. The Farm Bill Master List reflects personal data, such as Social Security Numbers, which are a key piece of personal identifiable information to assist you in determining the existence of a lien against a specific debtor. The distribution of this information beyond its intended purpose is strictly prohibited.\n\n**The debtor's tax identification number has been hidden for confidentiality reasons. You may continue to search on a tax ID number and return debtors that match your search criteria. The SSN/FEIN must be entered without dashes or spaces.  If you need access to the tax identification number to clearly identify the debtor, please contact the UCC unit at (406) 444-3665.**","VIEW_HISTORY_BUTTON_ALT_TEXT":"View Filings","WIZARD_ERROR_TITLE_MESSAGE":"Form Error","FARM_BILL_SEARCH_INTERACTIVE":true,"USE_FARM_BILL_API":true,"DISALLOW_ASSIGN_SELF_AS_RA":true,"DISALLOW_ASSIGN_SELF_AS_PRINCIPAL":true,"USE_TRADEMARK_OWNER_VALIDATION":true,"USE_ALTERNATIVE_FOREIGN_ADDRESS_LABELS":true,"MY_RECEIPTS_FILTER":[{"type":"dateRange","name":"DATE_RANGE","label":"Date range","defaultValue":{"start":null,"end":null}},{"type":"text","name":"REF_NUM","defaultValue":"","label":"Reference Number"},{"type":"text","name":"RECEIPT_NUM","defaultValue":"","label":"Receipt Id"},{"type":"text","name":"AMOUNT","defaultValue":"","label":"Amount"},{"type":"select","name":"TYPE","defaultValue":"","label":"Payment Type","options":[{"value":"","label":"All"},{"value":"CC","label":"Credit Card"},{"value":"Check","label":"Check"}]}],"MY_RECEIPTS_SHOW_IN_SIDEBAR":true,"SHOW_MY_RECEIPTS_HELPER_TEXT":true,"MY_RECEIPTS_HELPER_LABEL":"About Receipt Search","MY_RECEIPTS_HELPER_TEXT":"You can search for receipts based on their descriptions, including the items paid for on the receipt. Use the filters to search for or filter specific information.","FARM_BILL_SUBLINK":{"label":"Farm Bill","component":"FarmBill","parameter":"farm-bill","path":"/lists/farm-bill","sourceTypeId":0,"myRecordsSearch":false,"allowedRules":["/search/"],"disabled":true,"searchDescription":"To perform a search, enter a debtor name. Your search results may include: exact debtor name, variations of that name and any filing that includes your search criteria. Punctuation is ignored.\n\nYou can click on \"Advanced\" to refine your search. Under “Advanced” you can search by crop, year, county and SSN/FEIN. As a registered Farm Bill Buyer with the Montana Secretary of State’s office it is important to maintain the confidentiality of the information contained within the Farm Bill Master List. The Farm Bill Master List reflects personal data, such as Social Security Numbers, which are a key piece of personal identifiable information to assist you in determining the existence of a lien against a specific debtor. The distribution of this information beyond its intended purpose is strictly prohibited.\n\nThe debtor's tax identification number has been hidden for confidentiality reasons. You may continue to search on a tax ID number and return debtors that match your search criteria. The SSN/FEIN must be entered without dashes or spaces.","searchMustHaveOneOf":["search","UCC_FARM_PRODUCT_ID","COUNTY"],"searchPlaceholder":"Search by debtor name","advancedSearchParameters":[{"type":"ServerMultiComplete","label":"Product code name(s)","name":"UCC_FARM_PRODUCT_ID","defaultValue":"","optionsSrc":"UCC_FARM_PRODUCT_V"},{"type":"MultiComplete","label":"Year or Range of Years","name":"YEAR_NUM","optionsSrc":"years","startYear":"1968","defaultValue":[],"preMergeOptions":[{"value":"ALL","label":"All"}]},{"type":"serverSelect","label":"State","name":"STATE","defaultValue":"MONTANA","optionsSrc":"STATE"},{"type":"ServerMultiComplete","label":"County","name":"COUNTY","defaultValue":[],"optionsSrc":"COUNTY","overrideSubOptionsSrcFromParameterName":"STATE"},{"type":"checkbox","name":"TIN_SEARCH_YN","defaultValue":false,"label":"Tax Identification Number Search"},{"type":"checkbox","name":"TIN_SORT_YN","defaultValue":false,"label":"Unique ID Sort"}]},"ALLOW_ADDRESS_VALIDATION_BYPASS_OPTION":true,"DEFAULT_ADDRESS_VALIDATION_BYPASS_OPTION_CHECKED":true}).UCC_SEARCH_ALLOW_SEARCH_TYPE;
	var UCC_SEARCH_REQUEST_TYPE_LABEL_1 = ({"NODE_ENV":"production","BUILD_DATE":"2025-08-27T15:15:31.687Z","BUILD_NUMBER":"Not Provided","GIT_VERSION":"v1.3.0-381-ga81e29b08","GIT_COMMIT_HASH":"a81e29b085c9268ffd96c78eb734365802722741","GIT_BRANCH":"beta","PUBLIC_URL":"","STATE_ABBR":"MT","STATE_NAME":"Montana","STATE_ORG_TITLE":"Secretary of State","LOGIN_HEADER_IMG_PATH":"","HOME_IMG_FILENAME":"montana.jpg","FAVICON_FILE_NAME":"favicon.ico","ALLOW_E_SIGN_ON_CORRECTIONS":true,"THIRD_PARTY_SIGNING_ALLOWED":false,"MY_ACCOUNT_SAVE_AND_CLOSE_BUTTON":true,"IE_DEPRECATED_MESSAGE":"Internet Explorer is not supported. Please select a supported browser below to access this website.","ADDITIONAL_ROUTES":{"dataRequests":true,"farmBill":true,"apostille":true,"externalHelp":"https://sosmt.gov/business/help-center/","systemAdministration":[{"title":"Saved Payments","parameter":"saved-payments","componentName":"SavedPayments"}]},"SUBROUTES":[{"label":"Business","component":"Business","parameter":"business","myWorkQueueSearch":false,"sourceTypeId":54,"searchMustHaveOneOf":["FILING_TYPE_ID","STATUS_ID","STATE","search"],"serverWebSearchDescription":true,"serverWorkQueueDescription":true,"serverMyRecordsDescription":true,"searchPlaceholder":"Search by name or filing number (X########)","allowEmptySearchTerm":true,"requestCertificateAlternateLabel":"Request Information","fileAmendmentButtonLabel":"Filing Actions","advancedSearchParameters":[{"type":"radio","name":"QUERY_TYPE_ID","defaultValue":1010,"options":[{"value":1010,"label":"Starts with"},{"value":1011,"label":"Contains"},{"value":1012,"label":" Word Contains"}]},{"type":"serverSelect","name":"FILING_TYPE_ID","optionsSrc":"FILING_TYPES","label":"Entity Type","placeholder":"All","defaultValue":"0"},{"type":"serverSelect","name":"FILING_SUBTYPE_ID","optionsSrc":"FILING_SUBTYPES","label":"Entity Subtype","overrideSubOptionsSrcFromParameterName":"FILING_TYPE_ID","placeholder":"All","defaultValue":"0"},{"type":"serverSelect","name":"STATUS_ID","optionsSrc":"FILING_STATUS_WITHOUT_ALL","label":"Status","placeholder":"All","defaultValue":"0"},{"type":"serverSelect","name":"STATE","optionsSrc":"STATE","label":"State","placeholder":"All","defaultValue":""},{"type":"serverSelect","name":"COUNTY","optionsSrc":"COUNTY_SUBOPTION","label":"County","overrideSubOptionsSrcFromParameterName":"STATE","placeholder":"All","defaultValue":""},{"type":"checkbox","name":"CRA_SEARCH_YN","defaultValue":false,"label":"Search by Registered Agent PID"},{"type":"dateRange","name":"FILING_DATE","label":"Registration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}},{"type":"dateRange","name":"EXPIRATION_DATE","label":"Expiration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}}],"myRecordsFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Active"},{"value":2,"label":"Inactive"},{"value":3,"label":"Pending"}]},{"type":"dateRange","name":"DATE_RANGE","label":"Date range","defaultValue":{"start":null,"end":null}}],"myWorkQueueFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Approved"},{"value":2,"label":"Pending Online Payment"},{"value":3,"label":"Pending Review"},{"value":4,"label":"Needs Correction"},{"value":5,"label":"Rejected"},{"value":6,"label":"Draft"}]},{"type":"dateRange","name":"DATE_RANGE","label":"Date range","defaultValue":{"start":null,"end":null}}]},{"label":"Notary","component":"Notary","parameter":"notary","sourceTypeId":850,"myWorkQueueSearch":false,"allowEmptySearchTerm":true,"requestCertificateAlternateLabel":"Download Certificate","fileAmendmentButtonLabel":"Filing Actions","hideNameRequestCertificate":true,"hideAddressRequestCertificate":true,"hideRecordUserManagment":true,"searchPlaceholder":"Search by name or commission number","searchMustHaveOneOf":["CITY","search","SERVICE_TYPE"],"advancedParametersStartOpen":true,"searchIsSortable":true,"advancedSearchParameters":[{"type":"radio","name":"STARTS_WITH_YN","defaultValue":false,"options":[{"value":true,"label":"Starts with"},{"value":false,"label":"Contains"}]},{"type":"checkbox","name":"ACTIVE_ONLY_YN","defaultValue":true,"label":"Active entities only"},{"type":"text","name":"CITY","defaultValue":"","label":"City"},{"type":"select","name":"SERVICE_TYPE","label":"Special Services Offered","defaultValue":0,"options":[{"value":0,"label":"(N/A)"},{"value":6165,"label":"In-Person Electronic Notarization (IPEN)"},{"value":6166,"label":"Remote Online Notarization (RON)"},{"value":6167,"label":"Mobile Notary Services"},{"value":6168,"label":"Remote Ink Notarization (RIN)"}]}]},{"label":"Apostille","component":"Apostille","parameter":"apostille","sourceTypeId":720,"myRecordsSearch":false,"myWorkQueueSearch":false,"disabled":false,"allowedRoutes":["/forms-manager/","/queue/","/forms/"]},{"label":"Liens","component":"UCC","parameter":"ucc","sourceTypeId":1999,"myRecordsSearch":true,"myWorkQueueSearch":true,"fileAmendmentButtonLabel":"Filing Actions","searchPlaceholder":"Search by name or file number","disabled":false,"serverWebSearchDescription":true,"myRecordsDescription":"","workQueueDescription":"","searchDescription":"","hideRecordUserManagment":true,"searchLiensCheckout":false,"advancedSearchParameters":[{"type":"radio","name":"STARTS_WITH_YN","defaultValue":false,"options":[{"value":true,"label":"Starts with"},{"value":false,"label":"Contains"}]},{"type":"select","name":"STATUS","defaultValue":"ALL","label":"Status","options":[{"value":"ACTIVE_UNLAPSED","label":"Active (unlapsed)"},{"value":"ACTIVE_LAPSED_UNLAPSED","label":"Active (lapsed and unlapsed)"}]},{"type":"text","name":"EXCLUDE_VALUES","label":"Exclude Debtor Names (comma separated list of names to exclude)","defaultValue":""},{"type":"dateRange","name":"FILING_DATE","label":"Financing Statement Date","defaultValue":{"start":null,"end":null}},{"type":"dateRange","name":"LAPSE_DATE","label":"Lapse Date","defaultValue":{"start":null,"end":null}},{"type":"text","name":"CITY","label":"Debtor City","defaultValue":""}],"myRecordsFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Approved"},{"value":2,"label":"Pending Online Payment"},{"value":3,"label":"Pending Review"}]},{"type":"select","name":"TYPE","defaultValue":0,"label":"Lien Type","options":[{"value":0,"label":"All"},{"value":1,"label":"UCC"},{"value":2,"label":"EFS"},{"value":3,"label":"Title 71"}]}],"myWorkQueueFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Approved"},{"value":2,"label":"Pending Online Payment"},{"value":3,"label":"Pending Review"},{"value":4,"label":"Pending Print and Mail"},{"value":5,"label":"Rejected"},{"value":6,"label":"Draft"}]},{"type":"select","name":"TYPE","defaultValue":0,"label":"Lien Type","options":[{"value":0,"label":"All"},{"value":1,"label":"UCC"},{"value":2,"label":"EFS"},{"value":3,"label":"Title 71"}]}]},{"label":"Copy Request","component":"copies","parameter":"copies","sourceTypeId":2001,"myRecordsSearch":false,"myWorkQueueSearch":false,"disabled":false,"allowedRoutes":["/forms-manager/","/queue/","/forms/"]},{"label":"Trademark","component":"Trademark","parameter":"trademark","sourceTypeId":810,"showRequestCertificate":true,"searchMustHaveOneOf":["search","EXPIRATION_DATE","FILING_DATE"],"allowEmptySearchTerm":true,"requestCertificateAlternateLabel":"Request Information","fileAmendmentButtonLabel":"Filing Actions","advancedSearchParameters":[{"type":"radio","name":"QUERY_TYPE_ID","defaultValue":1010,"options":[{"value":1010,"label":"Starts with"},{"value":1011,"label":"Contains"},{"value":1012,"label":" Word Contains"}]},{"type":"checkbox","name":"OWNER_SEARCH_YN","defaultValue":false,"label":"Search owners"},{"type":"radio","name":"SERVICE_MARK_YN","label":"Mark Type","defaultValue":"","options":[{"value":"","label":"All Marks"},{"value":"Y","label":"Service Mark"},{"value":"N","label":"Trademark"}]},{"type":"serverSelect","name":"STATUS_ID","optionsSrc":"TYPE_V|TRADEMARK_STATUS_TYPE","label":"Status","placeholder":"All","defaultValue":"0"},{"type":"select","name":"DESIGN_TYPE_ID","options":[{"value":0,"label":"All"},{"value":990,"label":"Words Only"},{"value":991,"label":"Design Only"},{"value":992,"label":"Words and Design"}],"label":"Design Type","defaultValue":"0"},{"type":"dateRange","name":"FILING_DATE","label":"Registered Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}},{"type":"dateRange","name":"EXPIRATION_DATE","label":"Expiration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}}]},{"label":"Business Info Request","component":"InfoRequests","parameter":"info-request","sourceTypeId":167,"allowedRoutes":["/forms-manager/","/queue/","/forms/"]},{"label":"Data Requests","component":"DataRequests","parameter":"data-request","sourceTypeId":0,"allowedRoutes":["/forms-manager/"]},{"label":"CRA","component":"CRA","parameter":"cra","sourceTypeId":157,"myRecordsSearch":false,"searchPlaceholder":"Search by name or registered agent number","allowedRoutes":["/forms-manager/","/forms/","/records/","/queue/","/search/"],"allowEmptySearchTerm":true,"fileAmendmentButtonLabel":"Filing Actions","advancedSearchParameters":[{"type":"radio","name":"QUERY_TYPE_ID","defaultValue":1010,"options":[{"value":1010,"label":"Starts with"},{"value":1011,"label":"Contains"},{"value":1012,"label":" Word Contains"}]},{"type":"dateRange","name":"CRA_DATE","label":"Registration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}},{"type":"select","name":"STATUS_ID","label":"Status","defaultValue":0,"options":[{"value":0,"label":"All"},{"value":121,"label":"Active"},{"value":122,"label":"Inactive"}]},{"type":"select","name":"AGENT_TYPE_ID","label":"Agent Type","defaultValue":0,"options":[{"value":0,"label":"All"},{"value":460,"label":"Registered Agent"},{"value":461,"label":"Commercial Registered Agent"}]}]},{"label":"Farm Bill","component":"FarmBill","parameter":"farm-bill","path":"/lists/farm-bill","sourceTypeId":0,"myRecordsSearch":false,"allowedRules":["/search/"],"disabled":true,"searchDescription":"To perform a search, enter a debtor name. Your search results may include: exact debtor name, variations of that name and any filing that includes your search criteria. Punctuation is ignored.\n\nYou can click on \"Advanced\" to refine your search. Under “Advanced” you can search by crop, year, county and SSN/FEIN. As a registered Farm Bill Buyer with the Montana Secretary of State’s office it is important to maintain the confidentiality of the information contained within the Farm Bill Master List. The Farm Bill Master List reflects personal data, such as Social Security Numbers, which are a key piece of personal identifiable information to assist you in determining the existence of a lien against a specific debtor. The distribution of this information beyond its intended purpose is strictly prohibited.\n\nThe debtor's tax identification number has been hidden for confidentiality reasons. You may continue to search on a tax ID number and return debtors that match your search criteria. The SSN/FEIN must be entered without dashes or spaces.","searchMustHaveOneOf":["search","UCC_FARM_PRODUCT_ID","COUNTY"],"searchPlaceholder":"Search by debtor name","advancedSearchParameters":[{"type":"ServerMultiComplete","label":"Product code name(s)","name":"UCC_FARM_PRODUCT_ID","defaultValue":"","optionsSrc":"UCC_FARM_PRODUCT_V"},{"type":"MultiComplete","label":"Year or Range of Years","name":"YEAR_NUM","optionsSrc":"years","startYear":"1968","defaultValue":[],"preMergeOptions":[{"value":"ALL","label":"All"}]},{"type":"serverSelect","label":"State","name":"STATE","defaultValue":"MONTANA","optionsSrc":"STATE"},{"type":"ServerMultiComplete","label":"County","name":"COUNTY","defaultValue":[],"optionsSrc":"COUNTY","overrideSubOptionsSrcFromParameterName":"STATE"},{"type":"checkbox","name":"TIN_SEARCH_YN","defaultValue":false,"label":"Tax Identification Number Search"},{"type":"checkbox","name":"TIN_SORT_YN","defaultValue":false,"label":"Unique ID Sort"}]}],"SYSTEM_NICKNAME":"Online Services Portal","PAYMENT_METHODS":[{"type":"bypass"},{"type":"iTransact"}],"PAYMENT_ALLOW_AMEX":true,"SYSTEM_ID_LABEL":"System Id","DOUBLE_COLUMN_PUBLIC_LOGIN":true,"INTERNAL_USER_MANAGEMENT":true,"ALLOW_PUBLIC_JSON_IMPORT":false,"MAX_FILE_UPLOAD_SIZE":10000000,"REFUND_TEXT":"","RETURN_TO_HOME_ON_LOGOUT":true,"CURRENT_SOS_NAME":"Christi Jacobsen","LOGO_FILENAME":"mt-sos-logo.png","LOGO_ALT":"Christi Jacobsen, Montana Secretary of State","LOGO_FULL_WIDTH":true,"HOME_HIDE_AUTH_HINT":true,"HOME_TITLE":"Montana Secretary of State","CUSTOM_TAB_TITLE":"Official Montana","HOME_SUBTITLE":"Online Business Services","ENTITY_NAME_CONSENT_DESCRIPTION":"","ALLOW_USER_PROFILE_EDITING":true,"COMPARE_FOREIGN_NAME_IN_ENTITY_NAME_VALIDATION":true,"FOREIGN_NAME_FIELD_NAME":"KIMA_PARENT_NAME_INFO","LOGIN_TITLE":"Montana Secretary of State Online Filing Portal Login","PUBLIC_LOGIN_LABEL":"Username","REVERSE_LOGIN_COLUMNS":true,"LOGIN_SEAL_FILENAME":"seal_white.png","SEPARATE_USERNAME_AND_EMAIL":true,"CREATE_ACCOUNT_BUTTON_ALIGN_LEFT":true,"CREATE_ACCOUNT_BUTTON_TEXT":"CREATE AN ACCOUNT","PASSWORD_CUSTOM_ERROR_TEXT":"The password must meet all requirements","ACCOUNT_CREATED_MESSAGE":"Please check your email to verify your account to login and allow a few minutes for this message to arrive. Check your junk/spam folders if you do not find the email in your inbox.","PUBLIC_LOGIN_PLACEHOLDER":" ","DISABLE_DEFAULT_PAYMENT_RADIO":true,"CUSTOM_RESET_PASSWORD_ERROR_MESSAGE":"Username invalid - no account found","PUBLIC_LOGIN_CREATE_DESCRIPTION":"### Existing User:\n\n  - Enter your username and password to login.  \n\n\n  #### - OR -  \n\n\n\n  - Forgot password? Click 'Reset Password' and follow the prompts.\n  - Forgot username? Click 'Forgot Username' and follow the prompts.  \n\n\n  ### New User:\n  ","LOGIN_HELP_LINK":"https://sosmt.gov/business/how-do-i/","LOGIN_HELP_LINK_TEXT":"Need Help?","FORGOT_USERNAME_TEXT":"Forgot Username?","LOGIN_ACTIVE_DIRECTORY_TEXT":"State User Login","MULTIPLE_LOGIN_METHODS":true,"HAS_ACTIVE_DIRECTORY_LOGIN":true,"RESET_PASSWORD_WITH_USERNAME":true,"DOWNLOAD_LINK":true,"SHOW_USERNAME_ACCOUNT_CREATE":true,"SHOW_SCROLL_DOWN_ARROW":true,"SHOW_ADDRESS_ACCOUNT_CREATE":true,"TWO_COLUMN_ACCOUNT_CREATE":true,"RESET_PASSWORD_TIP":"A link to change your password has been sent to your email. Please allow a few minutes for this message to arrive. Please check your junk/spam folders if you do not find the email in your inbox.","FORGOT_PASSWORD_LINK_TEXT":"Reset Password","PHONE_NUMBER_OPTIONAL_ACCOUNT_CREATE":true,"SHOW_REQUIRED_INDICATOR_ACCOUNT_CREATE":true,"PASSWORD_REQUIREMENTS_ACCOUNT_CREATE":"\n    <ul>\n      <li>MUST contain at least 8 characters (12+ recommended)</li>\n      <li>MUST contain at least one uppercase letter.</li>\n      <li>MUST contain at least one lowercase letter.</li>\n      <li>MUST contain at least one number.</li>\n      <li>MUST contain at least one special character (!”#$%&'()*+,-./:;<=>?</li>\n    </ul>\n  ","ALLOW_CERTIFICATION_REQUEST":true,"ALLOW_PUBLIC_CERTIFICATE_REQUEST":true,"ALLOW_COPY_REQUEST":false,"ALLOW_CORRECTION_STYLING":true,"HIDE_DEPRECATION_WARNING":false,"AMEND_ROUTE_PUBLIC":true,"SEAL_FILENAME":"seal.png","SHOPPING_CART":true,"ALLOW_PAYMENT_UPDATE_WITH_EMPTY_CART":true,"RA_EMAIL":true,"RA_WEBSITE":true,"RA_NO_DEFAULT_TYPE":true,"RA_ADDRESS_LABEL":"Street Address","RA_TYPE_SELECTION_DEFAULT":true,"RA_DEFAULT_TYPE":"460","RA_OVERRIDE_TYPE_WITH_DEFAULT":true,"RA_PRINCIPAL_ADDRESS_AMS":true,"UPLOAD_AND_SUBMIT_HIDE_IF_ONE_OPTION":true,"PAYMENT_PROCESSING_MESSAGE":"Your payment is processing - Do not close your browser or click the back button","CHECKOUT_BUTTON_WHEN_PROCESSING_TEXT":"Processing","EFS_CROP_PICKER_NONE_LABEL":"Lien Duration","DISALLOWED_WIZARD_PIECES":["FormationLocale"],"REPEATER_SHOW_EDIT_BUTTON":true,"DATA_REQUEST_PAGE_TITLE":"Data Requests and Subscriptions","DATA_REQUEST_SIDEBAR_LABEL":"Data Requests & Subscriptions","LOGIN_REDIRECTS_TO_EPASS":false,"LOGIN_REDIRECTS_TO_ACTIVE_DIRECTORY":true,"LOGIN_ACTIVE_DIRECTORY_LINK":true,"FETCH_EDIT_USER_LINK":false,"LISTS_FETCH_AVAILABLE_LISTS":true,"POST_WIZARD_SUBMIT_REDIRECT_URL":"/","PIN_REQUEST_ATTESTATIONS":true,"PIN_REQUEST_DESCRIPTION":"Click **Request PIN** to have a new PIN sent to the account holder's email address on file.","OWNERSHIP_REQUEST_DESCRIPTION":"To become an **authorized user** of this record, a current **AUTHORIZED USER** will need to grant you access. To request access, click **Request Access** below.","PIN_REQUEST_SUCCESS_MESSAGE":"The PIN you have requested for this entity has been sent to the email associated with your user account.  You should receive the PIN in approximately 3-5 minutes, depending on your email service provider.","APOSTILLE_HEADER_LABEL":"Verification Information","APOSTILLE_NUMBER_LABEL":"Apostille/Authentication","APOSTILLE_CITY_STATE_OVERRIDE":"HELENA, MT","APOSTILLE_FILING_DATE_LABEL":"Issue Date","APOSTILLE_CITY_STATE_IN_CERTIFIED":true,"NOTARY_EXISTING_FILING":true,"ALLOW_REVOKE_OWN_ACCESS_ONLY":false,"HIDE_CANCEL_ON_ONETIME_DATA_REQUESTS":true,"DATA_REQUESTS_IN_SHOPPING_CART":true,"WQ_ALLOW_EDIT_PENDING_PAYMENT":true,"WQ_CONFIRM_ON_DELETE":true,"WQ_DELETE_CONFIRM_MESSAGE":"Deleting this filing will forfeit any money already paid to the Secretary of State. This action is permanent and cannot be undone, are you sure you would like to delete?","PASS_ITEM_GUIDS_ON_CHECKOUT":true,"FORM_REVISION_HISTORY":true,"CHECKOUT_DISCLAIMER":"By entering your credit card and/or checking account information you (i) state that **you are an authorized user** of the credit card and/or electronic check and that the associated information entered (e.g., account holder name, account number, billing address) is accurate, (ii) **you authorize payment processor to charge the amount you have requested** to your credit card and/or funding account, and (iii) **acknowledge if a charge is declined or reversed you may also be assessed a customary charge** by the payment processor for such transactions.","FARM_BILL_SEARCH_CONFIDENTIAL":"As a registered Farm Bill Buyer with the Montana Secretary of State’s office it is important to maintain the confidentiality of the information contained within the Farm Bill Master List. The Farm Bill Master List reflects personal data, such as Social Security Numbers, which are a key piece of personal identifiable information to assist you in determining the existence of a lien against a specific debtor. The distribution of this information beyond its intended purpose is strictly prohibited.\n\n**The debtor's tax identification number has been hidden for confidentiality reasons. You may continue to search on a tax ID number and return debtors that match your search criteria. The SSN/FEIN must be entered without dashes or spaces.  If you need access to the tax identification number to clearly identify the debtor, please contact the UCC unit at (406) 444-3665.**","VIEW_HISTORY_BUTTON_ALT_TEXT":"View Filings","WIZARD_ERROR_TITLE_MESSAGE":"Form Error","FARM_BILL_SEARCH_INTERACTIVE":true,"USE_FARM_BILL_API":true,"DISALLOW_ASSIGN_SELF_AS_RA":true,"DISALLOW_ASSIGN_SELF_AS_PRINCIPAL":true,"USE_TRADEMARK_OWNER_VALIDATION":true,"USE_ALTERNATIVE_FOREIGN_ADDRESS_LABELS":true,"MY_RECEIPTS_FILTER":[{"type":"dateRange","name":"DATE_RANGE","label":"Date range","defaultValue":{"start":null,"end":null}},{"type":"text","name":"REF_NUM","defaultValue":"","label":"Reference Number"},{"type":"text","name":"RECEIPT_NUM","defaultValue":"","label":"Receipt Id"},{"type":"text","name":"AMOUNT","defaultValue":"","label":"Amount"},{"type":"select","name":"TYPE","defaultValue":"","label":"Payment Type","options":[{"value":"","label":"All"},{"value":"CC","label":"Credit Card"},{"value":"Check","label":"Check"}]}],"MY_RECEIPTS_SHOW_IN_SIDEBAR":true,"SHOW_MY_RECEIPTS_HELPER_TEXT":true,"MY_RECEIPTS_HELPER_LABEL":"About Receipt Search","MY_RECEIPTS_HELPER_TEXT":"You can search for receipts based on their descriptions, including the items paid for on the receipt. Use the filters to search for or filter specific information.","FARM_BILL_SUBLINK":{"label":"Farm Bill","component":"FarmBill","parameter":"farm-bill","path":"/lists/farm-bill","sourceTypeId":0,"myRecordsSearch":false,"allowedRules":["/search/"],"disabled":true,"searchDescription":"To perform a search, enter a debtor name. Your search results may include: exact debtor name, variations of that name and any filing that includes your search criteria. Punctuation is ignored.\n\nYou can click on \"Advanced\" to refine your search. Under “Advanced” you can search by crop, year, county and SSN/FEIN. As a registered Farm Bill Buyer with the Montana Secretary of State’s office it is important to maintain the confidentiality of the information contained within the Farm Bill Master List. The Farm Bill Master List reflects personal data, such as Social Security Numbers, which are a key piece of personal identifiable information to assist you in determining the existence of a lien against a specific debtor. The distribution of this information beyond its intended purpose is strictly prohibited.\n\nThe debtor's tax identification number has been hidden for confidentiality reasons. You may continue to search on a tax ID number and return debtors that match your search criteria. The SSN/FEIN must be entered without dashes or spaces.","searchMustHaveOneOf":["search","UCC_FARM_PRODUCT_ID","COUNTY"],"searchPlaceholder":"Search by debtor name","advancedSearchParameters":[{"type":"ServerMultiComplete","label":"Product code name(s)","name":"UCC_FARM_PRODUCT_ID","defaultValue":"","optionsSrc":"UCC_FARM_PRODUCT_V"},{"type":"MultiComplete","label":"Year or Range of Years","name":"YEAR_NUM","optionsSrc":"years","startYear":"1968","defaultValue":[],"preMergeOptions":[{"value":"ALL","label":"All"}]},{"type":"serverSelect","label":"State","name":"STATE","defaultValue":"MONTANA","optionsSrc":"STATE"},{"type":"ServerMultiComplete","label":"County","name":"COUNTY","defaultValue":[],"optionsSrc":"COUNTY","overrideSubOptionsSrcFromParameterName":"STATE"},{"type":"checkbox","name":"TIN_SEARCH_YN","defaultValue":false,"label":"Tax Identification Number Search"},{"type":"checkbox","name":"TIN_SORT_YN","defaultValue":false,"label":"Unique ID Sort"}]},"ALLOW_ADDRESS_VALIDATION_BYPASS_OPTION":true,"DEFAULT_ADDRESS_VALIDATION_BYPASS_OPTION_CHECKED":true}).UCC_SEARCH_REQUEST_TYPE_LABEL_1;
	var UCC_SEARCH_REQUEST_TYPE_LABEL_2 = ({"NODE_ENV":"production","BUILD_DATE":"2025-08-27T15:15:31.687Z","BUILD_NUMBER":"Not Provided","GIT_VERSION":"v1.3.0-381-ga81e29b08","GIT_COMMIT_HASH":"a81e29b085c9268ffd96c78eb734365802722741","GIT_BRANCH":"beta","PUBLIC_URL":"","STATE_ABBR":"MT","STATE_NAME":"Montana","STATE_ORG_TITLE":"Secretary of State","LOGIN_HEADER_IMG_PATH":"","HOME_IMG_FILENAME":"montana.jpg","FAVICON_FILE_NAME":"favicon.ico","ALLOW_E_SIGN_ON_CORRECTIONS":true,"THIRD_PARTY_SIGNING_ALLOWED":false,"MY_ACCOUNT_SAVE_AND_CLOSE_BUTTON":true,"IE_DEPRECATED_MESSAGE":"Internet Explorer is not supported. Please select a supported browser below to access this website.","ADDITIONAL_ROUTES":{"dataRequests":true,"farmBill":true,"apostille":true,"externalHelp":"https://sosmt.gov/business/help-center/","systemAdministration":[{"title":"Saved Payments","parameter":"saved-payments","componentName":"SavedPayments"}]},"SUBROUTES":[{"label":"Business","component":"Business","parameter":"business","myWorkQueueSearch":false,"sourceTypeId":54,"searchMustHaveOneOf":["FILING_TYPE_ID","STATUS_ID","STATE","search"],"serverWebSearchDescription":true,"serverWorkQueueDescription":true,"serverMyRecordsDescription":true,"searchPlaceholder":"Search by name or filing number (X########)","allowEmptySearchTerm":true,"requestCertificateAlternateLabel":"Request Information","fileAmendmentButtonLabel":"Filing Actions","advancedSearchParameters":[{"type":"radio","name":"QUERY_TYPE_ID","defaultValue":1010,"options":[{"value":1010,"label":"Starts with"},{"value":1011,"label":"Contains"},{"value":1012,"label":" Word Contains"}]},{"type":"serverSelect","name":"FILING_TYPE_ID","optionsSrc":"FILING_TYPES","label":"Entity Type","placeholder":"All","defaultValue":"0"},{"type":"serverSelect","name":"FILING_SUBTYPE_ID","optionsSrc":"FILING_SUBTYPES","label":"Entity Subtype","overrideSubOptionsSrcFromParameterName":"FILING_TYPE_ID","placeholder":"All","defaultValue":"0"},{"type":"serverSelect","name":"STATUS_ID","optionsSrc":"FILING_STATUS_WITHOUT_ALL","label":"Status","placeholder":"All","defaultValue":"0"},{"type":"serverSelect","name":"STATE","optionsSrc":"STATE","label":"State","placeholder":"All","defaultValue":""},{"type":"serverSelect","name":"COUNTY","optionsSrc":"COUNTY_SUBOPTION","label":"County","overrideSubOptionsSrcFromParameterName":"STATE","placeholder":"All","defaultValue":""},{"type":"checkbox","name":"CRA_SEARCH_YN","defaultValue":false,"label":"Search by Registered Agent PID"},{"type":"dateRange","name":"FILING_DATE","label":"Registration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}},{"type":"dateRange","name":"EXPIRATION_DATE","label":"Expiration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}}],"myRecordsFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Active"},{"value":2,"label":"Inactive"},{"value":3,"label":"Pending"}]},{"type":"dateRange","name":"DATE_RANGE","label":"Date range","defaultValue":{"start":null,"end":null}}],"myWorkQueueFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Approved"},{"value":2,"label":"Pending Online Payment"},{"value":3,"label":"Pending Review"},{"value":4,"label":"Needs Correction"},{"value":5,"label":"Rejected"},{"value":6,"label":"Draft"}]},{"type":"dateRange","name":"DATE_RANGE","label":"Date range","defaultValue":{"start":null,"end":null}}]},{"label":"Notary","component":"Notary","parameter":"notary","sourceTypeId":850,"myWorkQueueSearch":false,"allowEmptySearchTerm":true,"requestCertificateAlternateLabel":"Download Certificate","fileAmendmentButtonLabel":"Filing Actions","hideNameRequestCertificate":true,"hideAddressRequestCertificate":true,"hideRecordUserManagment":true,"searchPlaceholder":"Search by name or commission number","searchMustHaveOneOf":["CITY","search","SERVICE_TYPE"],"advancedParametersStartOpen":true,"searchIsSortable":true,"advancedSearchParameters":[{"type":"radio","name":"STARTS_WITH_YN","defaultValue":false,"options":[{"value":true,"label":"Starts with"},{"value":false,"label":"Contains"}]},{"type":"checkbox","name":"ACTIVE_ONLY_YN","defaultValue":true,"label":"Active entities only"},{"type":"text","name":"CITY","defaultValue":"","label":"City"},{"type":"select","name":"SERVICE_TYPE","label":"Special Services Offered","defaultValue":0,"options":[{"value":0,"label":"(N/A)"},{"value":6165,"label":"In-Person Electronic Notarization (IPEN)"},{"value":6166,"label":"Remote Online Notarization (RON)"},{"value":6167,"label":"Mobile Notary Services"},{"value":6168,"label":"Remote Ink Notarization (RIN)"}]}]},{"label":"Apostille","component":"Apostille","parameter":"apostille","sourceTypeId":720,"myRecordsSearch":false,"myWorkQueueSearch":false,"disabled":false,"allowedRoutes":["/forms-manager/","/queue/","/forms/"]},{"label":"Liens","component":"UCC","parameter":"ucc","sourceTypeId":1999,"myRecordsSearch":true,"myWorkQueueSearch":true,"fileAmendmentButtonLabel":"Filing Actions","searchPlaceholder":"Search by name or file number","disabled":false,"serverWebSearchDescription":true,"myRecordsDescription":"","workQueueDescription":"","searchDescription":"","hideRecordUserManagment":true,"searchLiensCheckout":false,"advancedSearchParameters":[{"type":"radio","name":"STARTS_WITH_YN","defaultValue":false,"options":[{"value":true,"label":"Starts with"},{"value":false,"label":"Contains"}]},{"type":"select","name":"STATUS","defaultValue":"ALL","label":"Status","options":[{"value":"ACTIVE_UNLAPSED","label":"Active (unlapsed)"},{"value":"ACTIVE_LAPSED_UNLAPSED","label":"Active (lapsed and unlapsed)"}]},{"type":"text","name":"EXCLUDE_VALUES","label":"Exclude Debtor Names (comma separated list of names to exclude)","defaultValue":""},{"type":"dateRange","name":"FILING_DATE","label":"Financing Statement Date","defaultValue":{"start":null,"end":null}},{"type":"dateRange","name":"LAPSE_DATE","label":"Lapse Date","defaultValue":{"start":null,"end":null}},{"type":"text","name":"CITY","label":"Debtor City","defaultValue":""}],"myRecordsFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Approved"},{"value":2,"label":"Pending Online Payment"},{"value":3,"label":"Pending Review"}]},{"type":"select","name":"TYPE","defaultValue":0,"label":"Lien Type","options":[{"value":0,"label":"All"},{"value":1,"label":"UCC"},{"value":2,"label":"EFS"},{"value":3,"label":"Title 71"}]}],"myWorkQueueFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Approved"},{"value":2,"label":"Pending Online Payment"},{"value":3,"label":"Pending Review"},{"value":4,"label":"Pending Print and Mail"},{"value":5,"label":"Rejected"},{"value":6,"label":"Draft"}]},{"type":"select","name":"TYPE","defaultValue":0,"label":"Lien Type","options":[{"value":0,"label":"All"},{"value":1,"label":"UCC"},{"value":2,"label":"EFS"},{"value":3,"label":"Title 71"}]}]},{"label":"Copy Request","component":"copies","parameter":"copies","sourceTypeId":2001,"myRecordsSearch":false,"myWorkQueueSearch":false,"disabled":false,"allowedRoutes":["/forms-manager/","/queue/","/forms/"]},{"label":"Trademark","component":"Trademark","parameter":"trademark","sourceTypeId":810,"showRequestCertificate":true,"searchMustHaveOneOf":["search","EXPIRATION_DATE","FILING_DATE"],"allowEmptySearchTerm":true,"requestCertificateAlternateLabel":"Request Information","fileAmendmentButtonLabel":"Filing Actions","advancedSearchParameters":[{"type":"radio","name":"QUERY_TYPE_ID","defaultValue":1010,"options":[{"value":1010,"label":"Starts with"},{"value":1011,"label":"Contains"},{"value":1012,"label":" Word Contains"}]},{"type":"checkbox","name":"OWNER_SEARCH_YN","defaultValue":false,"label":"Search owners"},{"type":"radio","name":"SERVICE_MARK_YN","label":"Mark Type","defaultValue":"","options":[{"value":"","label":"All Marks"},{"value":"Y","label":"Service Mark"},{"value":"N","label":"Trademark"}]},{"type":"serverSelect","name":"STATUS_ID","optionsSrc":"TYPE_V|TRADEMARK_STATUS_TYPE","label":"Status","placeholder":"All","defaultValue":"0"},{"type":"select","name":"DESIGN_TYPE_ID","options":[{"value":0,"label":"All"},{"value":990,"label":"Words Only"},{"value":991,"label":"Design Only"},{"value":992,"label":"Words and Design"}],"label":"Design Type","defaultValue":"0"},{"type":"dateRange","name":"FILING_DATE","label":"Registered Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}},{"type":"dateRange","name":"EXPIRATION_DATE","label":"Expiration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}}]},{"label":"Business Info Request","component":"InfoRequests","parameter":"info-request","sourceTypeId":167,"allowedRoutes":["/forms-manager/","/queue/","/forms/"]},{"label":"Data Requests","component":"DataRequests","parameter":"data-request","sourceTypeId":0,"allowedRoutes":["/forms-manager/"]},{"label":"CRA","component":"CRA","parameter":"cra","sourceTypeId":157,"myRecordsSearch":false,"searchPlaceholder":"Search by name or registered agent number","allowedRoutes":["/forms-manager/","/forms/","/records/","/queue/","/search/"],"allowEmptySearchTerm":true,"fileAmendmentButtonLabel":"Filing Actions","advancedSearchParameters":[{"type":"radio","name":"QUERY_TYPE_ID","defaultValue":1010,"options":[{"value":1010,"label":"Starts with"},{"value":1011,"label":"Contains"},{"value":1012,"label":" Word Contains"}]},{"type":"dateRange","name":"CRA_DATE","label":"Registration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}},{"type":"select","name":"STATUS_ID","label":"Status","defaultValue":0,"options":[{"value":0,"label":"All"},{"value":121,"label":"Active"},{"value":122,"label":"Inactive"}]},{"type":"select","name":"AGENT_TYPE_ID","label":"Agent Type","defaultValue":0,"options":[{"value":0,"label":"All"},{"value":460,"label":"Registered Agent"},{"value":461,"label":"Commercial Registered Agent"}]}]},{"label":"Farm Bill","component":"FarmBill","parameter":"farm-bill","path":"/lists/farm-bill","sourceTypeId":0,"myRecordsSearch":false,"allowedRules":["/search/"],"disabled":true,"searchDescription":"To perform a search, enter a debtor name. Your search results may include: exact debtor name, variations of that name and any filing that includes your search criteria. Punctuation is ignored.\n\nYou can click on \"Advanced\" to refine your search. Under “Advanced” you can search by crop, year, county and SSN/FEIN. As a registered Farm Bill Buyer with the Montana Secretary of State’s office it is important to maintain the confidentiality of the information contained within the Farm Bill Master List. The Farm Bill Master List reflects personal data, such as Social Security Numbers, which are a key piece of personal identifiable information to assist you in determining the existence of a lien against a specific debtor. The distribution of this information beyond its intended purpose is strictly prohibited.\n\nThe debtor's tax identification number has been hidden for confidentiality reasons. You may continue to search on a tax ID number and return debtors that match your search criteria. The SSN/FEIN must be entered without dashes or spaces.","searchMustHaveOneOf":["search","UCC_FARM_PRODUCT_ID","COUNTY"],"searchPlaceholder":"Search by debtor name","advancedSearchParameters":[{"type":"ServerMultiComplete","label":"Product code name(s)","name":"UCC_FARM_PRODUCT_ID","defaultValue":"","optionsSrc":"UCC_FARM_PRODUCT_V"},{"type":"MultiComplete","label":"Year or Range of Years","name":"YEAR_NUM","optionsSrc":"years","startYear":"1968","defaultValue":[],"preMergeOptions":[{"value":"ALL","label":"All"}]},{"type":"serverSelect","label":"State","name":"STATE","defaultValue":"MONTANA","optionsSrc":"STATE"},{"type":"ServerMultiComplete","label":"County","name":"COUNTY","defaultValue":[],"optionsSrc":"COUNTY","overrideSubOptionsSrcFromParameterName":"STATE"},{"type":"checkbox","name":"TIN_SEARCH_YN","defaultValue":false,"label":"Tax Identification Number Search"},{"type":"checkbox","name":"TIN_SORT_YN","defaultValue":false,"label":"Unique ID Sort"}]}],"SYSTEM_NICKNAME":"Online Services Portal","PAYMENT_METHODS":[{"type":"bypass"},{"type":"iTransact"}],"PAYMENT_ALLOW_AMEX":true,"SYSTEM_ID_LABEL":"System Id","DOUBLE_COLUMN_PUBLIC_LOGIN":true,"INTERNAL_USER_MANAGEMENT":true,"ALLOW_PUBLIC_JSON_IMPORT":false,"MAX_FILE_UPLOAD_SIZE":10000000,"REFUND_TEXT":"","RETURN_TO_HOME_ON_LOGOUT":true,"CURRENT_SOS_NAME":"Christi Jacobsen","LOGO_FILENAME":"mt-sos-logo.png","LOGO_ALT":"Christi Jacobsen, Montana Secretary of State","LOGO_FULL_WIDTH":true,"HOME_HIDE_AUTH_HINT":true,"HOME_TITLE":"Montana Secretary of State","CUSTOM_TAB_TITLE":"Official Montana","HOME_SUBTITLE":"Online Business Services","ENTITY_NAME_CONSENT_DESCRIPTION":"","ALLOW_USER_PROFILE_EDITING":true,"COMPARE_FOREIGN_NAME_IN_ENTITY_NAME_VALIDATION":true,"FOREIGN_NAME_FIELD_NAME":"KIMA_PARENT_NAME_INFO","LOGIN_TITLE":"Montana Secretary of State Online Filing Portal Login","PUBLIC_LOGIN_LABEL":"Username","REVERSE_LOGIN_COLUMNS":true,"LOGIN_SEAL_FILENAME":"seal_white.png","SEPARATE_USERNAME_AND_EMAIL":true,"CREATE_ACCOUNT_BUTTON_ALIGN_LEFT":true,"CREATE_ACCOUNT_BUTTON_TEXT":"CREATE AN ACCOUNT","PASSWORD_CUSTOM_ERROR_TEXT":"The password must meet all requirements","ACCOUNT_CREATED_MESSAGE":"Please check your email to verify your account to login and allow a few minutes for this message to arrive. Check your junk/spam folders if you do not find the email in your inbox.","PUBLIC_LOGIN_PLACEHOLDER":" ","DISABLE_DEFAULT_PAYMENT_RADIO":true,"CUSTOM_RESET_PASSWORD_ERROR_MESSAGE":"Username invalid - no account found","PUBLIC_LOGIN_CREATE_DESCRIPTION":"### Existing User:\n\n  - Enter your username and password to login.  \n\n\n  #### - OR -  \n\n\n\n  - Forgot password? Click 'Reset Password' and follow the prompts.\n  - Forgot username? Click 'Forgot Username' and follow the prompts.  \n\n\n  ### New User:\n  ","LOGIN_HELP_LINK":"https://sosmt.gov/business/how-do-i/","LOGIN_HELP_LINK_TEXT":"Need Help?","FORGOT_USERNAME_TEXT":"Forgot Username?","LOGIN_ACTIVE_DIRECTORY_TEXT":"State User Login","MULTIPLE_LOGIN_METHODS":true,"HAS_ACTIVE_DIRECTORY_LOGIN":true,"RESET_PASSWORD_WITH_USERNAME":true,"DOWNLOAD_LINK":true,"SHOW_USERNAME_ACCOUNT_CREATE":true,"SHOW_SCROLL_DOWN_ARROW":true,"SHOW_ADDRESS_ACCOUNT_CREATE":true,"TWO_COLUMN_ACCOUNT_CREATE":true,"RESET_PASSWORD_TIP":"A link to change your password has been sent to your email. Please allow a few minutes for this message to arrive. Please check your junk/spam folders if you do not find the email in your inbox.","FORGOT_PASSWORD_LINK_TEXT":"Reset Password","PHONE_NUMBER_OPTIONAL_ACCOUNT_CREATE":true,"SHOW_REQUIRED_INDICATOR_ACCOUNT_CREATE":true,"PASSWORD_REQUIREMENTS_ACCOUNT_CREATE":"\n    <ul>\n      <li>MUST contain at least 8 characters (12+ recommended)</li>\n      <li>MUST contain at least one uppercase letter.</li>\n      <li>MUST contain at least one lowercase letter.</li>\n      <li>MUST contain at least one number.</li>\n      <li>MUST contain at least one special character (!”#$%&'()*+,-./:;<=>?</li>\n    </ul>\n  ","ALLOW_CERTIFICATION_REQUEST":true,"ALLOW_PUBLIC_CERTIFICATE_REQUEST":true,"ALLOW_COPY_REQUEST":false,"ALLOW_CORRECTION_STYLING":true,"HIDE_DEPRECATION_WARNING":false,"AMEND_ROUTE_PUBLIC":true,"SEAL_FILENAME":"seal.png","SHOPPING_CART":true,"ALLOW_PAYMENT_UPDATE_WITH_EMPTY_CART":true,"RA_EMAIL":true,"RA_WEBSITE":true,"RA_NO_DEFAULT_TYPE":true,"RA_ADDRESS_LABEL":"Street Address","RA_TYPE_SELECTION_DEFAULT":true,"RA_DEFAULT_TYPE":"460","RA_OVERRIDE_TYPE_WITH_DEFAULT":true,"RA_PRINCIPAL_ADDRESS_AMS":true,"UPLOAD_AND_SUBMIT_HIDE_IF_ONE_OPTION":true,"PAYMENT_PROCESSING_MESSAGE":"Your payment is processing - Do not close your browser or click the back button","CHECKOUT_BUTTON_WHEN_PROCESSING_TEXT":"Processing","EFS_CROP_PICKER_NONE_LABEL":"Lien Duration","DISALLOWED_WIZARD_PIECES":["FormationLocale"],"REPEATER_SHOW_EDIT_BUTTON":true,"DATA_REQUEST_PAGE_TITLE":"Data Requests and Subscriptions","DATA_REQUEST_SIDEBAR_LABEL":"Data Requests & Subscriptions","LOGIN_REDIRECTS_TO_EPASS":false,"LOGIN_REDIRECTS_TO_ACTIVE_DIRECTORY":true,"LOGIN_ACTIVE_DIRECTORY_LINK":true,"FETCH_EDIT_USER_LINK":false,"LISTS_FETCH_AVAILABLE_LISTS":true,"POST_WIZARD_SUBMIT_REDIRECT_URL":"/","PIN_REQUEST_ATTESTATIONS":true,"PIN_REQUEST_DESCRIPTION":"Click **Request PIN** to have a new PIN sent to the account holder's email address on file.","OWNERSHIP_REQUEST_DESCRIPTION":"To become an **authorized user** of this record, a current **AUTHORIZED USER** will need to grant you access. To request access, click **Request Access** below.","PIN_REQUEST_SUCCESS_MESSAGE":"The PIN you have requested for this entity has been sent to the email associated with your user account.  You should receive the PIN in approximately 3-5 minutes, depending on your email service provider.","APOSTILLE_HEADER_LABEL":"Verification Information","APOSTILLE_NUMBER_LABEL":"Apostille/Authentication","APOSTILLE_CITY_STATE_OVERRIDE":"HELENA, MT","APOSTILLE_FILING_DATE_LABEL":"Issue Date","APOSTILLE_CITY_STATE_IN_CERTIFIED":true,"NOTARY_EXISTING_FILING":true,"ALLOW_REVOKE_OWN_ACCESS_ONLY":false,"HIDE_CANCEL_ON_ONETIME_DATA_REQUESTS":true,"DATA_REQUESTS_IN_SHOPPING_CART":true,"WQ_ALLOW_EDIT_PENDING_PAYMENT":true,"WQ_CONFIRM_ON_DELETE":true,"WQ_DELETE_CONFIRM_MESSAGE":"Deleting this filing will forfeit any money already paid to the Secretary of State. This action is permanent and cannot be undone, are you sure you would like to delete?","PASS_ITEM_GUIDS_ON_CHECKOUT":true,"FORM_REVISION_HISTORY":true,"CHECKOUT_DISCLAIMER":"By entering your credit card and/or checking account information you (i) state that **you are an authorized user** of the credit card and/or electronic check and that the associated information entered (e.g., account holder name, account number, billing address) is accurate, (ii) **you authorize payment processor to charge the amount you have requested** to your credit card and/or funding account, and (iii) **acknowledge if a charge is declined or reversed you may also be assessed a customary charge** by the payment processor for such transactions.","FARM_BILL_SEARCH_CONFIDENTIAL":"As a registered Farm Bill Buyer with the Montana Secretary of State’s office it is important to maintain the confidentiality of the information contained within the Farm Bill Master List. The Farm Bill Master List reflects personal data, such as Social Security Numbers, which are a key piece of personal identifiable information to assist you in determining the existence of a lien against a specific debtor. The distribution of this information beyond its intended purpose is strictly prohibited.\n\n**The debtor's tax identification number has been hidden for confidentiality reasons. You may continue to search on a tax ID number and return debtors that match your search criteria. The SSN/FEIN must be entered without dashes or spaces.  If you need access to the tax identification number to clearly identify the debtor, please contact the UCC unit at (406) 444-3665.**","VIEW_HISTORY_BUTTON_ALT_TEXT":"View Filings","WIZARD_ERROR_TITLE_MESSAGE":"Form Error","FARM_BILL_SEARCH_INTERACTIVE":true,"USE_FARM_BILL_API":true,"DISALLOW_ASSIGN_SELF_AS_RA":true,"DISALLOW_ASSIGN_SELF_AS_PRINCIPAL":true,"USE_TRADEMARK_OWNER_VALIDATION":true,"USE_ALTERNATIVE_FOREIGN_ADDRESS_LABELS":true,"MY_RECEIPTS_FILTER":[{"type":"dateRange","name":"DATE_RANGE","label":"Date range","defaultValue":{"start":null,"end":null}},{"type":"text","name":"REF_NUM","defaultValue":"","label":"Reference Number"},{"type":"text","name":"RECEIPT_NUM","defaultValue":"","label":"Receipt Id"},{"type":"text","name":"AMOUNT","defaultValue":"","label":"Amount"},{"type":"select","name":"TYPE","defaultValue":"","label":"Payment Type","options":[{"value":"","label":"All"},{"value":"CC","label":"Credit Card"},{"value":"Check","label":"Check"}]}],"MY_RECEIPTS_SHOW_IN_SIDEBAR":true,"SHOW_MY_RECEIPTS_HELPER_TEXT":true,"MY_RECEIPTS_HELPER_LABEL":"About Receipt Search","MY_RECEIPTS_HELPER_TEXT":"You can search for receipts based on their descriptions, including the items paid for on the receipt. Use the filters to search for or filter specific information.","FARM_BILL_SUBLINK":{"label":"Farm Bill","component":"FarmBill","parameter":"farm-bill","path":"/lists/farm-bill","sourceTypeId":0,"myRecordsSearch":false,"allowedRules":["/search/"],"disabled":true,"searchDescription":"To perform a search, enter a debtor name. Your search results may include: exact debtor name, variations of that name and any filing that includes your search criteria. Punctuation is ignored.\n\nYou can click on \"Advanced\" to refine your search. Under “Advanced” you can search by crop, year, county and SSN/FEIN. As a registered Farm Bill Buyer with the Montana Secretary of State’s office it is important to maintain the confidentiality of the information contained within the Farm Bill Master List. The Farm Bill Master List reflects personal data, such as Social Security Numbers, which are a key piece of personal identifiable information to assist you in determining the existence of a lien against a specific debtor. The distribution of this information beyond its intended purpose is strictly prohibited.\n\nThe debtor's tax identification number has been hidden for confidentiality reasons. You may continue to search on a tax ID number and return debtors that match your search criteria. The SSN/FEIN must be entered without dashes or spaces.","searchMustHaveOneOf":["search","UCC_FARM_PRODUCT_ID","COUNTY"],"searchPlaceholder":"Search by debtor name","advancedSearchParameters":[{"type":"ServerMultiComplete","label":"Product code name(s)","name":"UCC_FARM_PRODUCT_ID","defaultValue":"","optionsSrc":"UCC_FARM_PRODUCT_V"},{"type":"MultiComplete","label":"Year or Range of Years","name":"YEAR_NUM","optionsSrc":"years","startYear":"1968","defaultValue":[],"preMergeOptions":[{"value":"ALL","label":"All"}]},{"type":"serverSelect","label":"State","name":"STATE","defaultValue":"MONTANA","optionsSrc":"STATE"},{"type":"ServerMultiComplete","label":"County","name":"COUNTY","defaultValue":[],"optionsSrc":"COUNTY","overrideSubOptionsSrcFromParameterName":"STATE"},{"type":"checkbox","name":"TIN_SEARCH_YN","defaultValue":false,"label":"Tax Identification Number Search"},{"type":"checkbox","name":"TIN_SORT_YN","defaultValue":false,"label":"Unique ID Sort"}]},"ALLOW_ADDRESS_VALIDATION_BYPASS_OPTION":true,"DEFAULT_ADDRESS_VALIDATION_BYPASS_OPTION_CHECKED":true}).UCC_SEARCH_REQUEST_TYPE_LABEL_2;
	var UCC_SEARCH_NAME_ORG_LABEL = ({"NODE_ENV":"production","BUILD_DATE":"2025-08-27T15:15:31.687Z","BUILD_NUMBER":"Not Provided","GIT_VERSION":"v1.3.0-381-ga81e29b08","GIT_COMMIT_HASH":"a81e29b085c9268ffd96c78eb734365802722741","GIT_BRANCH":"beta","PUBLIC_URL":"","STATE_ABBR":"MT","STATE_NAME":"Montana","STATE_ORG_TITLE":"Secretary of State","LOGIN_HEADER_IMG_PATH":"","HOME_IMG_FILENAME":"montana.jpg","FAVICON_FILE_NAME":"favicon.ico","ALLOW_E_SIGN_ON_CORRECTIONS":true,"THIRD_PARTY_SIGNING_ALLOWED":false,"MY_ACCOUNT_SAVE_AND_CLOSE_BUTTON":true,"IE_DEPRECATED_MESSAGE":"Internet Explorer is not supported. Please select a supported browser below to access this website.","ADDITIONAL_ROUTES":{"dataRequests":true,"farmBill":true,"apostille":true,"externalHelp":"https://sosmt.gov/business/help-center/","systemAdministration":[{"title":"Saved Payments","parameter":"saved-payments","componentName":"SavedPayments"}]},"SUBROUTES":[{"label":"Business","component":"Business","parameter":"business","myWorkQueueSearch":false,"sourceTypeId":54,"searchMustHaveOneOf":["FILING_TYPE_ID","STATUS_ID","STATE","search"],"serverWebSearchDescription":true,"serverWorkQueueDescription":true,"serverMyRecordsDescription":true,"searchPlaceholder":"Search by name or filing number (X########)","allowEmptySearchTerm":true,"requestCertificateAlternateLabel":"Request Information","fileAmendmentButtonLabel":"Filing Actions","advancedSearchParameters":[{"type":"radio","name":"QUERY_TYPE_ID","defaultValue":1010,"options":[{"value":1010,"label":"Starts with"},{"value":1011,"label":"Contains"},{"value":1012,"label":" Word Contains"}]},{"type":"serverSelect","name":"FILING_TYPE_ID","optionsSrc":"FILING_TYPES","label":"Entity Type","placeholder":"All","defaultValue":"0"},{"type":"serverSelect","name":"FILING_SUBTYPE_ID","optionsSrc":"FILING_SUBTYPES","label":"Entity Subtype","overrideSubOptionsSrcFromParameterName":"FILING_TYPE_ID","placeholder":"All","defaultValue":"0"},{"type":"serverSelect","name":"STATUS_ID","optionsSrc":"FILING_STATUS_WITHOUT_ALL","label":"Status","placeholder":"All","defaultValue":"0"},{"type":"serverSelect","name":"STATE","optionsSrc":"STATE","label":"State","placeholder":"All","defaultValue":""},{"type":"serverSelect","name":"COUNTY","optionsSrc":"COUNTY_SUBOPTION","label":"County","overrideSubOptionsSrcFromParameterName":"STATE","placeholder":"All","defaultValue":""},{"type":"checkbox","name":"CRA_SEARCH_YN","defaultValue":false,"label":"Search by Registered Agent PID"},{"type":"dateRange","name":"FILING_DATE","label":"Registration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}},{"type":"dateRange","name":"EXPIRATION_DATE","label":"Expiration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}}],"myRecordsFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Active"},{"value":2,"label":"Inactive"},{"value":3,"label":"Pending"}]},{"type":"dateRange","name":"DATE_RANGE","label":"Date range","defaultValue":{"start":null,"end":null}}],"myWorkQueueFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Approved"},{"value":2,"label":"Pending Online Payment"},{"value":3,"label":"Pending Review"},{"value":4,"label":"Needs Correction"},{"value":5,"label":"Rejected"},{"value":6,"label":"Draft"}]},{"type":"dateRange","name":"DATE_RANGE","label":"Date range","defaultValue":{"start":null,"end":null}}]},{"label":"Notary","component":"Notary","parameter":"notary","sourceTypeId":850,"myWorkQueueSearch":false,"allowEmptySearchTerm":true,"requestCertificateAlternateLabel":"Download Certificate","fileAmendmentButtonLabel":"Filing Actions","hideNameRequestCertificate":true,"hideAddressRequestCertificate":true,"hideRecordUserManagment":true,"searchPlaceholder":"Search by name or commission number","searchMustHaveOneOf":["CITY","search","SERVICE_TYPE"],"advancedParametersStartOpen":true,"searchIsSortable":true,"advancedSearchParameters":[{"type":"radio","name":"STARTS_WITH_YN","defaultValue":false,"options":[{"value":true,"label":"Starts with"},{"value":false,"label":"Contains"}]},{"type":"checkbox","name":"ACTIVE_ONLY_YN","defaultValue":true,"label":"Active entities only"},{"type":"text","name":"CITY","defaultValue":"","label":"City"},{"type":"select","name":"SERVICE_TYPE","label":"Special Services Offered","defaultValue":0,"options":[{"value":0,"label":"(N/A)"},{"value":6165,"label":"In-Person Electronic Notarization (IPEN)"},{"value":6166,"label":"Remote Online Notarization (RON)"},{"value":6167,"label":"Mobile Notary Services"},{"value":6168,"label":"Remote Ink Notarization (RIN)"}]}]},{"label":"Apostille","component":"Apostille","parameter":"apostille","sourceTypeId":720,"myRecordsSearch":false,"myWorkQueueSearch":false,"disabled":false,"allowedRoutes":["/forms-manager/","/queue/","/forms/"]},{"label":"Liens","component":"UCC","parameter":"ucc","sourceTypeId":1999,"myRecordsSearch":true,"myWorkQueueSearch":true,"fileAmendmentButtonLabel":"Filing Actions","searchPlaceholder":"Search by name or file number","disabled":false,"serverWebSearchDescription":true,"myRecordsDescription":"","workQueueDescription":"","searchDescription":"","hideRecordUserManagment":true,"searchLiensCheckout":false,"advancedSearchParameters":[{"type":"radio","name":"STARTS_WITH_YN","defaultValue":false,"options":[{"value":true,"label":"Starts with"},{"value":false,"label":"Contains"}]},{"type":"select","name":"STATUS","defaultValue":"ALL","label":"Status","options":[{"value":"ACTIVE_UNLAPSED","label":"Active (unlapsed)"},{"value":"ACTIVE_LAPSED_UNLAPSED","label":"Active (lapsed and unlapsed)"}]},{"type":"text","name":"EXCLUDE_VALUES","label":"Exclude Debtor Names (comma separated list of names to exclude)","defaultValue":""},{"type":"dateRange","name":"FILING_DATE","label":"Financing Statement Date","defaultValue":{"start":null,"end":null}},{"type":"dateRange","name":"LAPSE_DATE","label":"Lapse Date","defaultValue":{"start":null,"end":null}},{"type":"text","name":"CITY","label":"Debtor City","defaultValue":""}],"myRecordsFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Approved"},{"value":2,"label":"Pending Online Payment"},{"value":3,"label":"Pending Review"}]},{"type":"select","name":"TYPE","defaultValue":0,"label":"Lien Type","options":[{"value":0,"label":"All"},{"value":1,"label":"UCC"},{"value":2,"label":"EFS"},{"value":3,"label":"Title 71"}]}],"myWorkQueueFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Approved"},{"value":2,"label":"Pending Online Payment"},{"value":3,"label":"Pending Review"},{"value":4,"label":"Pending Print and Mail"},{"value":5,"label":"Rejected"},{"value":6,"label":"Draft"}]},{"type":"select","name":"TYPE","defaultValue":0,"label":"Lien Type","options":[{"value":0,"label":"All"},{"value":1,"label":"UCC"},{"value":2,"label":"EFS"},{"value":3,"label":"Title 71"}]}]},{"label":"Copy Request","component":"copies","parameter":"copies","sourceTypeId":2001,"myRecordsSearch":false,"myWorkQueueSearch":false,"disabled":false,"allowedRoutes":["/forms-manager/","/queue/","/forms/"]},{"label":"Trademark","component":"Trademark","parameter":"trademark","sourceTypeId":810,"showRequestCertificate":true,"searchMustHaveOneOf":["search","EXPIRATION_DATE","FILING_DATE"],"allowEmptySearchTerm":true,"requestCertificateAlternateLabel":"Request Information","fileAmendmentButtonLabel":"Filing Actions","advancedSearchParameters":[{"type":"radio","name":"QUERY_TYPE_ID","defaultValue":1010,"options":[{"value":1010,"label":"Starts with"},{"value":1011,"label":"Contains"},{"value":1012,"label":" Word Contains"}]},{"type":"checkbox","name":"OWNER_SEARCH_YN","defaultValue":false,"label":"Search owners"},{"type":"radio","name":"SERVICE_MARK_YN","label":"Mark Type","defaultValue":"","options":[{"value":"","label":"All Marks"},{"value":"Y","label":"Service Mark"},{"value":"N","label":"Trademark"}]},{"type":"serverSelect","name":"STATUS_ID","optionsSrc":"TYPE_V|TRADEMARK_STATUS_TYPE","label":"Status","placeholder":"All","defaultValue":"0"},{"type":"select","name":"DESIGN_TYPE_ID","options":[{"value":0,"label":"All"},{"value":990,"label":"Words Only"},{"value":991,"label":"Design Only"},{"value":992,"label":"Words and Design"}],"label":"Design Type","defaultValue":"0"},{"type":"dateRange","name":"FILING_DATE","label":"Registered Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}},{"type":"dateRange","name":"EXPIRATION_DATE","label":"Expiration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}}]},{"label":"Business Info Request","component":"InfoRequests","parameter":"info-request","sourceTypeId":167,"allowedRoutes":["/forms-manager/","/queue/","/forms/"]},{"label":"Data Requests","component":"DataRequests","parameter":"data-request","sourceTypeId":0,"allowedRoutes":["/forms-manager/"]},{"label":"CRA","component":"CRA","parameter":"cra","sourceTypeId":157,"myRecordsSearch":false,"searchPlaceholder":"Search by name or registered agent number","allowedRoutes":["/forms-manager/","/forms/","/records/","/queue/","/search/"],"allowEmptySearchTerm":true,"fileAmendmentButtonLabel":"Filing Actions","advancedSearchParameters":[{"type":"radio","name":"QUERY_TYPE_ID","defaultValue":1010,"options":[{"value":1010,"label":"Starts with"},{"value":1011,"label":"Contains"},{"value":1012,"label":" Word Contains"}]},{"type":"dateRange","name":"CRA_DATE","label":"Registration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}},{"type":"select","name":"STATUS_ID","label":"Status","defaultValue":0,"options":[{"value":0,"label":"All"},{"value":121,"label":"Active"},{"value":122,"label":"Inactive"}]},{"type":"select","name":"AGENT_TYPE_ID","label":"Agent Type","defaultValue":0,"options":[{"value":0,"label":"All"},{"value":460,"label":"Registered Agent"},{"value":461,"label":"Commercial Registered Agent"}]}]},{"label":"Farm Bill","component":"FarmBill","parameter":"farm-bill","path":"/lists/farm-bill","sourceTypeId":0,"myRecordsSearch":false,"allowedRules":["/search/"],"disabled":true,"searchDescription":"To perform a search, enter a debtor name. Your search results may include: exact debtor name, variations of that name and any filing that includes your search criteria. Punctuation is ignored.\n\nYou can click on \"Advanced\" to refine your search. Under “Advanced” you can search by crop, year, county and SSN/FEIN. As a registered Farm Bill Buyer with the Montana Secretary of State’s office it is important to maintain the confidentiality of the information contained within the Farm Bill Master List. The Farm Bill Master List reflects personal data, such as Social Security Numbers, which are a key piece of personal identifiable information to assist you in determining the existence of a lien against a specific debtor. The distribution of this information beyond its intended purpose is strictly prohibited.\n\nThe debtor's tax identification number has been hidden for confidentiality reasons. You may continue to search on a tax ID number and return debtors that match your search criteria. The SSN/FEIN must be entered without dashes or spaces.","searchMustHaveOneOf":["search","UCC_FARM_PRODUCT_ID","COUNTY"],"searchPlaceholder":"Search by debtor name","advancedSearchParameters":[{"type":"ServerMultiComplete","label":"Product code name(s)","name":"UCC_FARM_PRODUCT_ID","defaultValue":"","optionsSrc":"UCC_FARM_PRODUCT_V"},{"type":"MultiComplete","label":"Year or Range of Years","name":"YEAR_NUM","optionsSrc":"years","startYear":"1968","defaultValue":[],"preMergeOptions":[{"value":"ALL","label":"All"}]},{"type":"serverSelect","label":"State","name":"STATE","defaultValue":"MONTANA","optionsSrc":"STATE"},{"type":"ServerMultiComplete","label":"County","name":"COUNTY","defaultValue":[],"optionsSrc":"COUNTY","overrideSubOptionsSrcFromParameterName":"STATE"},{"type":"checkbox","name":"TIN_SEARCH_YN","defaultValue":false,"label":"Tax Identification Number Search"},{"type":"checkbox","name":"TIN_SORT_YN","defaultValue":false,"label":"Unique ID Sort"}]}],"SYSTEM_NICKNAME":"Online Services Portal","PAYMENT_METHODS":[{"type":"bypass"},{"type":"iTransact"}],"PAYMENT_ALLOW_AMEX":true,"SYSTEM_ID_LABEL":"System Id","DOUBLE_COLUMN_PUBLIC_LOGIN":true,"INTERNAL_USER_MANAGEMENT":true,"ALLOW_PUBLIC_JSON_IMPORT":false,"MAX_FILE_UPLOAD_SIZE":10000000,"REFUND_TEXT":"","RETURN_TO_HOME_ON_LOGOUT":true,"CURRENT_SOS_NAME":"Christi Jacobsen","LOGO_FILENAME":"mt-sos-logo.png","LOGO_ALT":"Christi Jacobsen, Montana Secretary of State","LOGO_FULL_WIDTH":true,"HOME_HIDE_AUTH_HINT":true,"HOME_TITLE":"Montana Secretary of State","CUSTOM_TAB_TITLE":"Official Montana","HOME_SUBTITLE":"Online Business Services","ENTITY_NAME_CONSENT_DESCRIPTION":"","ALLOW_USER_PROFILE_EDITING":true,"COMPARE_FOREIGN_NAME_IN_ENTITY_NAME_VALIDATION":true,"FOREIGN_NAME_FIELD_NAME":"KIMA_PARENT_NAME_INFO","LOGIN_TITLE":"Montana Secretary of State Online Filing Portal Login","PUBLIC_LOGIN_LABEL":"Username","REVERSE_LOGIN_COLUMNS":true,"LOGIN_SEAL_FILENAME":"seal_white.png","SEPARATE_USERNAME_AND_EMAIL":true,"CREATE_ACCOUNT_BUTTON_ALIGN_LEFT":true,"CREATE_ACCOUNT_BUTTON_TEXT":"CREATE AN ACCOUNT","PASSWORD_CUSTOM_ERROR_TEXT":"The password must meet all requirements","ACCOUNT_CREATED_MESSAGE":"Please check your email to verify your account to login and allow a few minutes for this message to arrive. Check your junk/spam folders if you do not find the email in your inbox.","PUBLIC_LOGIN_PLACEHOLDER":" ","DISABLE_DEFAULT_PAYMENT_RADIO":true,"CUSTOM_RESET_PASSWORD_ERROR_MESSAGE":"Username invalid - no account found","PUBLIC_LOGIN_CREATE_DESCRIPTION":"### Existing User:\n\n  - Enter your username and password to login.  \n\n\n  #### - OR -  \n\n\n\n  - Forgot password? Click 'Reset Password' and follow the prompts.\n  - Forgot username? Click 'Forgot Username' and follow the prompts.  \n\n\n  ### New User:\n  ","LOGIN_HELP_LINK":"https://sosmt.gov/business/how-do-i/","LOGIN_HELP_LINK_TEXT":"Need Help?","FORGOT_USERNAME_TEXT":"Forgot Username?","LOGIN_ACTIVE_DIRECTORY_TEXT":"State User Login","MULTIPLE_LOGIN_METHODS":true,"HAS_ACTIVE_DIRECTORY_LOGIN":true,"RESET_PASSWORD_WITH_USERNAME":true,"DOWNLOAD_LINK":true,"SHOW_USERNAME_ACCOUNT_CREATE":true,"SHOW_SCROLL_DOWN_ARROW":true,"SHOW_ADDRESS_ACCOUNT_CREATE":true,"TWO_COLUMN_ACCOUNT_CREATE":true,"RESET_PASSWORD_TIP":"A link to change your password has been sent to your email. Please allow a few minutes for this message to arrive. Please check your junk/spam folders if you do not find the email in your inbox.","FORGOT_PASSWORD_LINK_TEXT":"Reset Password","PHONE_NUMBER_OPTIONAL_ACCOUNT_CREATE":true,"SHOW_REQUIRED_INDICATOR_ACCOUNT_CREATE":true,"PASSWORD_REQUIREMENTS_ACCOUNT_CREATE":"\n    <ul>\n      <li>MUST contain at least 8 characters (12+ recommended)</li>\n      <li>MUST contain at least one uppercase letter.</li>\n      <li>MUST contain at least one lowercase letter.</li>\n      <li>MUST contain at least one number.</li>\n      <li>MUST contain at least one special character (!”#$%&'()*+,-./:;<=>?</li>\n    </ul>\n  ","ALLOW_CERTIFICATION_REQUEST":true,"ALLOW_PUBLIC_CERTIFICATE_REQUEST":true,"ALLOW_COPY_REQUEST":false,"ALLOW_CORRECTION_STYLING":true,"HIDE_DEPRECATION_WARNING":false,"AMEND_ROUTE_PUBLIC":true,"SEAL_FILENAME":"seal.png","SHOPPING_CART":true,"ALLOW_PAYMENT_UPDATE_WITH_EMPTY_CART":true,"RA_EMAIL":true,"RA_WEBSITE":true,"RA_NO_DEFAULT_TYPE":true,"RA_ADDRESS_LABEL":"Street Address","RA_TYPE_SELECTION_DEFAULT":true,"RA_DEFAULT_TYPE":"460","RA_OVERRIDE_TYPE_WITH_DEFAULT":true,"RA_PRINCIPAL_ADDRESS_AMS":true,"UPLOAD_AND_SUBMIT_HIDE_IF_ONE_OPTION":true,"PAYMENT_PROCESSING_MESSAGE":"Your payment is processing - Do not close your browser or click the back button","CHECKOUT_BUTTON_WHEN_PROCESSING_TEXT":"Processing","EFS_CROP_PICKER_NONE_LABEL":"Lien Duration","DISALLOWED_WIZARD_PIECES":["FormationLocale"],"REPEATER_SHOW_EDIT_BUTTON":true,"DATA_REQUEST_PAGE_TITLE":"Data Requests and Subscriptions","DATA_REQUEST_SIDEBAR_LABEL":"Data Requests & Subscriptions","LOGIN_REDIRECTS_TO_EPASS":false,"LOGIN_REDIRECTS_TO_ACTIVE_DIRECTORY":true,"LOGIN_ACTIVE_DIRECTORY_LINK":true,"FETCH_EDIT_USER_LINK":false,"LISTS_FETCH_AVAILABLE_LISTS":true,"POST_WIZARD_SUBMIT_REDIRECT_URL":"/","PIN_REQUEST_ATTESTATIONS":true,"PIN_REQUEST_DESCRIPTION":"Click **Request PIN** to have a new PIN sent to the account holder's email address on file.","OWNERSHIP_REQUEST_DESCRIPTION":"To become an **authorized user** of this record, a current **AUTHORIZED USER** will need to grant you access. To request access, click **Request Access** below.","PIN_REQUEST_SUCCESS_MESSAGE":"The PIN you have requested for this entity has been sent to the email associated with your user account.  You should receive the PIN in approximately 3-5 minutes, depending on your email service provider.","APOSTILLE_HEADER_LABEL":"Verification Information","APOSTILLE_NUMBER_LABEL":"Apostille/Authentication","APOSTILLE_CITY_STATE_OVERRIDE":"HELENA, MT","APOSTILLE_FILING_DATE_LABEL":"Issue Date","APOSTILLE_CITY_STATE_IN_CERTIFIED":true,"NOTARY_EXISTING_FILING":true,"ALLOW_REVOKE_OWN_ACCESS_ONLY":false,"HIDE_CANCEL_ON_ONETIME_DATA_REQUESTS":true,"DATA_REQUESTS_IN_SHOPPING_CART":true,"WQ_ALLOW_EDIT_PENDING_PAYMENT":true,"WQ_CONFIRM_ON_DELETE":true,"WQ_DELETE_CONFIRM_MESSAGE":"Deleting this filing will forfeit any money already paid to the Secretary of State. This action is permanent and cannot be undone, are you sure you would like to delete?","PASS_ITEM_GUIDS_ON_CHECKOUT":true,"FORM_REVISION_HISTORY":true,"CHECKOUT_DISCLAIMER":"By entering your credit card and/or checking account information you (i) state that **you are an authorized user** of the credit card and/or electronic check and that the associated information entered (e.g., account holder name, account number, billing address) is accurate, (ii) **you authorize payment processor to charge the amount you have requested** to your credit card and/or funding account, and (iii) **acknowledge if a charge is declined or reversed you may also be assessed a customary charge** by the payment processor for such transactions.","FARM_BILL_SEARCH_CONFIDENTIAL":"As a registered Farm Bill Buyer with the Montana Secretary of State’s office it is important to maintain the confidentiality of the information contained within the Farm Bill Master List. The Farm Bill Master List reflects personal data, such as Social Security Numbers, which are a key piece of personal identifiable information to assist you in determining the existence of a lien against a specific debtor. The distribution of this information beyond its intended purpose is strictly prohibited.\n\n**The debtor's tax identification number has been hidden for confidentiality reasons. You may continue to search on a tax ID number and return debtors that match your search criteria. The SSN/FEIN must be entered without dashes or spaces.  If you need access to the tax identification number to clearly identify the debtor, please contact the UCC unit at (406) 444-3665.**","VIEW_HISTORY_BUTTON_ALT_TEXT":"View Filings","WIZARD_ERROR_TITLE_MESSAGE":"Form Error","FARM_BILL_SEARCH_INTERACTIVE":true,"USE_FARM_BILL_API":true,"DISALLOW_ASSIGN_SELF_AS_RA":true,"DISALLOW_ASSIGN_SELF_AS_PRINCIPAL":true,"USE_TRADEMARK_OWNER_VALIDATION":true,"USE_ALTERNATIVE_FOREIGN_ADDRESS_LABELS":true,"MY_RECEIPTS_FILTER":[{"type":"dateRange","name":"DATE_RANGE","label":"Date range","defaultValue":{"start":null,"end":null}},{"type":"text","name":"REF_NUM","defaultValue":"","label":"Reference Number"},{"type":"text","name":"RECEIPT_NUM","defaultValue":"","label":"Receipt Id"},{"type":"text","name":"AMOUNT","defaultValue":"","label":"Amount"},{"type":"select","name":"TYPE","defaultValue":"","label":"Payment Type","options":[{"value":"","label":"All"},{"value":"CC","label":"Credit Card"},{"value":"Check","label":"Check"}]}],"MY_RECEIPTS_SHOW_IN_SIDEBAR":true,"SHOW_MY_RECEIPTS_HELPER_TEXT":true,"MY_RECEIPTS_HELPER_LABEL":"About Receipt Search","MY_RECEIPTS_HELPER_TEXT":"You can search for receipts based on their descriptions, including the items paid for on the receipt. Use the filters to search for or filter specific information.","FARM_BILL_SUBLINK":{"label":"Farm Bill","component":"FarmBill","parameter":"farm-bill","path":"/lists/farm-bill","sourceTypeId":0,"myRecordsSearch":false,"allowedRules":["/search/"],"disabled":true,"searchDescription":"To perform a search, enter a debtor name. Your search results may include: exact debtor name, variations of that name and any filing that includes your search criteria. Punctuation is ignored.\n\nYou can click on \"Advanced\" to refine your search. Under “Advanced” you can search by crop, year, county and SSN/FEIN. As a registered Farm Bill Buyer with the Montana Secretary of State’s office it is important to maintain the confidentiality of the information contained within the Farm Bill Master List. The Farm Bill Master List reflects personal data, such as Social Security Numbers, which are a key piece of personal identifiable information to assist you in determining the existence of a lien against a specific debtor. The distribution of this information beyond its intended purpose is strictly prohibited.\n\nThe debtor's tax identification number has been hidden for confidentiality reasons. You may continue to search on a tax ID number and return debtors that match your search criteria. The SSN/FEIN must be entered without dashes or spaces.","searchMustHaveOneOf":["search","UCC_FARM_PRODUCT_ID","COUNTY"],"searchPlaceholder":"Search by debtor name","advancedSearchParameters":[{"type":"ServerMultiComplete","label":"Product code name(s)","name":"UCC_FARM_PRODUCT_ID","defaultValue":"","optionsSrc":"UCC_FARM_PRODUCT_V"},{"type":"MultiComplete","label":"Year or Range of Years","name":"YEAR_NUM","optionsSrc":"years","startYear":"1968","defaultValue":[],"preMergeOptions":[{"value":"ALL","label":"All"}]},{"type":"serverSelect","label":"State","name":"STATE","defaultValue":"MONTANA","optionsSrc":"STATE"},{"type":"ServerMultiComplete","label":"County","name":"COUNTY","defaultValue":[],"optionsSrc":"COUNTY","overrideSubOptionsSrcFromParameterName":"STATE"},{"type":"checkbox","name":"TIN_SEARCH_YN","defaultValue":false,"label":"Tax Identification Number Search"},{"type":"checkbox","name":"TIN_SORT_YN","defaultValue":false,"label":"Unique ID Sort"}]},"ALLOW_ADDRESS_VALIDATION_BYPASS_OPTION":true,"DEFAULT_ADDRESS_VALIDATION_BYPASS_OPTION_CHECKED":true}).UCC_SEARCH_NAME_ORG_LABEL;
	var UCC_SEARCH_ONLY_REQUIRE_LAST_NAME = ({"NODE_ENV":"production","BUILD_DATE":"2025-08-27T15:15:31.687Z","BUILD_NUMBER":"Not Provided","GIT_VERSION":"v1.3.0-381-ga81e29b08","GIT_COMMIT_HASH":"a81e29b085c9268ffd96c78eb734365802722741","GIT_BRANCH":"beta","PUBLIC_URL":"","STATE_ABBR":"MT","STATE_NAME":"Montana","STATE_ORG_TITLE":"Secretary of State","LOGIN_HEADER_IMG_PATH":"","HOME_IMG_FILENAME":"montana.jpg","FAVICON_FILE_NAME":"favicon.ico","ALLOW_E_SIGN_ON_CORRECTIONS":true,"THIRD_PARTY_SIGNING_ALLOWED":false,"MY_ACCOUNT_SAVE_AND_CLOSE_BUTTON":true,"IE_DEPRECATED_MESSAGE":"Internet Explorer is not supported. Please select a supported browser below to access this website.","ADDITIONAL_ROUTES":{"dataRequests":true,"farmBill":true,"apostille":true,"externalHelp":"https://sosmt.gov/business/help-center/","systemAdministration":[{"title":"Saved Payments","parameter":"saved-payments","componentName":"SavedPayments"}]},"SUBROUTES":[{"label":"Business","component":"Business","parameter":"business","myWorkQueueSearch":false,"sourceTypeId":54,"searchMustHaveOneOf":["FILING_TYPE_ID","STATUS_ID","STATE","search"],"serverWebSearchDescription":true,"serverWorkQueueDescription":true,"serverMyRecordsDescription":true,"searchPlaceholder":"Search by name or filing number (X########)","allowEmptySearchTerm":true,"requestCertificateAlternateLabel":"Request Information","fileAmendmentButtonLabel":"Filing Actions","advancedSearchParameters":[{"type":"radio","name":"QUERY_TYPE_ID","defaultValue":1010,"options":[{"value":1010,"label":"Starts with"},{"value":1011,"label":"Contains"},{"value":1012,"label":" Word Contains"}]},{"type":"serverSelect","name":"FILING_TYPE_ID","optionsSrc":"FILING_TYPES","label":"Entity Type","placeholder":"All","defaultValue":"0"},{"type":"serverSelect","name":"FILING_SUBTYPE_ID","optionsSrc":"FILING_SUBTYPES","label":"Entity Subtype","overrideSubOptionsSrcFromParameterName":"FILING_TYPE_ID","placeholder":"All","defaultValue":"0"},{"type":"serverSelect","name":"STATUS_ID","optionsSrc":"FILING_STATUS_WITHOUT_ALL","label":"Status","placeholder":"All","defaultValue":"0"},{"type":"serverSelect","name":"STATE","optionsSrc":"STATE","label":"State","placeholder":"All","defaultValue":""},{"type":"serverSelect","name":"COUNTY","optionsSrc":"COUNTY_SUBOPTION","label":"County","overrideSubOptionsSrcFromParameterName":"STATE","placeholder":"All","defaultValue":""},{"type":"checkbox","name":"CRA_SEARCH_YN","defaultValue":false,"label":"Search by Registered Agent PID"},{"type":"dateRange","name":"FILING_DATE","label":"Registration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}},{"type":"dateRange","name":"EXPIRATION_DATE","label":"Expiration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}}],"myRecordsFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Active"},{"value":2,"label":"Inactive"},{"value":3,"label":"Pending"}]},{"type":"dateRange","name":"DATE_RANGE","label":"Date range","defaultValue":{"start":null,"end":null}}],"myWorkQueueFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Approved"},{"value":2,"label":"Pending Online Payment"},{"value":3,"label":"Pending Review"},{"value":4,"label":"Needs Correction"},{"value":5,"label":"Rejected"},{"value":6,"label":"Draft"}]},{"type":"dateRange","name":"DATE_RANGE","label":"Date range","defaultValue":{"start":null,"end":null}}]},{"label":"Notary","component":"Notary","parameter":"notary","sourceTypeId":850,"myWorkQueueSearch":false,"allowEmptySearchTerm":true,"requestCertificateAlternateLabel":"Download Certificate","fileAmendmentButtonLabel":"Filing Actions","hideNameRequestCertificate":true,"hideAddressRequestCertificate":true,"hideRecordUserManagment":true,"searchPlaceholder":"Search by name or commission number","searchMustHaveOneOf":["CITY","search","SERVICE_TYPE"],"advancedParametersStartOpen":true,"searchIsSortable":true,"advancedSearchParameters":[{"type":"radio","name":"STARTS_WITH_YN","defaultValue":false,"options":[{"value":true,"label":"Starts with"},{"value":false,"label":"Contains"}]},{"type":"checkbox","name":"ACTIVE_ONLY_YN","defaultValue":true,"label":"Active entities only"},{"type":"text","name":"CITY","defaultValue":"","label":"City"},{"type":"select","name":"SERVICE_TYPE","label":"Special Services Offered","defaultValue":0,"options":[{"value":0,"label":"(N/A)"},{"value":6165,"label":"In-Person Electronic Notarization (IPEN)"},{"value":6166,"label":"Remote Online Notarization (RON)"},{"value":6167,"label":"Mobile Notary Services"},{"value":6168,"label":"Remote Ink Notarization (RIN)"}]}]},{"label":"Apostille","component":"Apostille","parameter":"apostille","sourceTypeId":720,"myRecordsSearch":false,"myWorkQueueSearch":false,"disabled":false,"allowedRoutes":["/forms-manager/","/queue/","/forms/"]},{"label":"Liens","component":"UCC","parameter":"ucc","sourceTypeId":1999,"myRecordsSearch":true,"myWorkQueueSearch":true,"fileAmendmentButtonLabel":"Filing Actions","searchPlaceholder":"Search by name or file number","disabled":false,"serverWebSearchDescription":true,"myRecordsDescription":"","workQueueDescription":"","searchDescription":"","hideRecordUserManagment":true,"searchLiensCheckout":false,"advancedSearchParameters":[{"type":"radio","name":"STARTS_WITH_YN","defaultValue":false,"options":[{"value":true,"label":"Starts with"},{"value":false,"label":"Contains"}]},{"type":"select","name":"STATUS","defaultValue":"ALL","label":"Status","options":[{"value":"ACTIVE_UNLAPSED","label":"Active (unlapsed)"},{"value":"ACTIVE_LAPSED_UNLAPSED","label":"Active (lapsed and unlapsed)"}]},{"type":"text","name":"EXCLUDE_VALUES","label":"Exclude Debtor Names (comma separated list of names to exclude)","defaultValue":""},{"type":"dateRange","name":"FILING_DATE","label":"Financing Statement Date","defaultValue":{"start":null,"end":null}},{"type":"dateRange","name":"LAPSE_DATE","label":"Lapse Date","defaultValue":{"start":null,"end":null}},{"type":"text","name":"CITY","label":"Debtor City","defaultValue":""}],"myRecordsFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Approved"},{"value":2,"label":"Pending Online Payment"},{"value":3,"label":"Pending Review"}]},{"type":"select","name":"TYPE","defaultValue":0,"label":"Lien Type","options":[{"value":0,"label":"All"},{"value":1,"label":"UCC"},{"value":2,"label":"EFS"},{"value":3,"label":"Title 71"}]}],"myWorkQueueFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Approved"},{"value":2,"label":"Pending Online Payment"},{"value":3,"label":"Pending Review"},{"value":4,"label":"Pending Print and Mail"},{"value":5,"label":"Rejected"},{"value":6,"label":"Draft"}]},{"type":"select","name":"TYPE","defaultValue":0,"label":"Lien Type","options":[{"value":0,"label":"All"},{"value":1,"label":"UCC"},{"value":2,"label":"EFS"},{"value":3,"label":"Title 71"}]}]},{"label":"Copy Request","component":"copies","parameter":"copies","sourceTypeId":2001,"myRecordsSearch":false,"myWorkQueueSearch":false,"disabled":false,"allowedRoutes":["/forms-manager/","/queue/","/forms/"]},{"label":"Trademark","component":"Trademark","parameter":"trademark","sourceTypeId":810,"showRequestCertificate":true,"searchMustHaveOneOf":["search","EXPIRATION_DATE","FILING_DATE"],"allowEmptySearchTerm":true,"requestCertificateAlternateLabel":"Request Information","fileAmendmentButtonLabel":"Filing Actions","advancedSearchParameters":[{"type":"radio","name":"QUERY_TYPE_ID","defaultValue":1010,"options":[{"value":1010,"label":"Starts with"},{"value":1011,"label":"Contains"},{"value":1012,"label":" Word Contains"}]},{"type":"checkbox","name":"OWNER_SEARCH_YN","defaultValue":false,"label":"Search owners"},{"type":"radio","name":"SERVICE_MARK_YN","label":"Mark Type","defaultValue":"","options":[{"value":"","label":"All Marks"},{"value":"Y","label":"Service Mark"},{"value":"N","label":"Trademark"}]},{"type":"serverSelect","name":"STATUS_ID","optionsSrc":"TYPE_V|TRADEMARK_STATUS_TYPE","label":"Status","placeholder":"All","defaultValue":"0"},{"type":"select","name":"DESIGN_TYPE_ID","options":[{"value":0,"label":"All"},{"value":990,"label":"Words Only"},{"value":991,"label":"Design Only"},{"value":992,"label":"Words and Design"}],"label":"Design Type","defaultValue":"0"},{"type":"dateRange","name":"FILING_DATE","label":"Registered Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}},{"type":"dateRange","name":"EXPIRATION_DATE","label":"Expiration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}}]},{"label":"Business Info Request","component":"InfoRequests","parameter":"info-request","sourceTypeId":167,"allowedRoutes":["/forms-manager/","/queue/","/forms/"]},{"label":"Data Requests","component":"DataRequests","parameter":"data-request","sourceTypeId":0,"allowedRoutes":["/forms-manager/"]},{"label":"CRA","component":"CRA","parameter":"cra","sourceTypeId":157,"myRecordsSearch":false,"searchPlaceholder":"Search by name or registered agent number","allowedRoutes":["/forms-manager/","/forms/","/records/","/queue/","/search/"],"allowEmptySearchTerm":true,"fileAmendmentButtonLabel":"Filing Actions","advancedSearchParameters":[{"type":"radio","name":"QUERY_TYPE_ID","defaultValue":1010,"options":[{"value":1010,"label":"Starts with"},{"value":1011,"label":"Contains"},{"value":1012,"label":" Word Contains"}]},{"type":"dateRange","name":"CRA_DATE","label":"Registration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}},{"type":"select","name":"STATUS_ID","label":"Status","defaultValue":0,"options":[{"value":0,"label":"All"},{"value":121,"label":"Active"},{"value":122,"label":"Inactive"}]},{"type":"select","name":"AGENT_TYPE_ID","label":"Agent Type","defaultValue":0,"options":[{"value":0,"label":"All"},{"value":460,"label":"Registered Agent"},{"value":461,"label":"Commercial Registered Agent"}]}]},{"label":"Farm Bill","component":"FarmBill","parameter":"farm-bill","path":"/lists/farm-bill","sourceTypeId":0,"myRecordsSearch":false,"allowedRules":["/search/"],"disabled":true,"searchDescription":"To perform a search, enter a debtor name. Your search results may include: exact debtor name, variations of that name and any filing that includes your search criteria. Punctuation is ignored.\n\nYou can click on \"Advanced\" to refine your search. Under “Advanced” you can search by crop, year, county and SSN/FEIN. As a registered Farm Bill Buyer with the Montana Secretary of State’s office it is important to maintain the confidentiality of the information contained within the Farm Bill Master List. The Farm Bill Master List reflects personal data, such as Social Security Numbers, which are a key piece of personal identifiable information to assist you in determining the existence of a lien against a specific debtor. The distribution of this information beyond its intended purpose is strictly prohibited.\n\nThe debtor's tax identification number has been hidden for confidentiality reasons. You may continue to search on a tax ID number and return debtors that match your search criteria. The SSN/FEIN must be entered without dashes or spaces.","searchMustHaveOneOf":["search","UCC_FARM_PRODUCT_ID","COUNTY"],"searchPlaceholder":"Search by debtor name","advancedSearchParameters":[{"type":"ServerMultiComplete","label":"Product code name(s)","name":"UCC_FARM_PRODUCT_ID","defaultValue":"","optionsSrc":"UCC_FARM_PRODUCT_V"},{"type":"MultiComplete","label":"Year or Range of Years","name":"YEAR_NUM","optionsSrc":"years","startYear":"1968","defaultValue":[],"preMergeOptions":[{"value":"ALL","label":"All"}]},{"type":"serverSelect","label":"State","name":"STATE","defaultValue":"MONTANA","optionsSrc":"STATE"},{"type":"ServerMultiComplete","label":"County","name":"COUNTY","defaultValue":[],"optionsSrc":"COUNTY","overrideSubOptionsSrcFromParameterName":"STATE"},{"type":"checkbox","name":"TIN_SEARCH_YN","defaultValue":false,"label":"Tax Identification Number Search"},{"type":"checkbox","name":"TIN_SORT_YN","defaultValue":false,"label":"Unique ID Sort"}]}],"SYSTEM_NICKNAME":"Online Services Portal","PAYMENT_METHODS":[{"type":"bypass"},{"type":"iTransact"}],"PAYMENT_ALLOW_AMEX":true,"SYSTEM_ID_LABEL":"System Id","DOUBLE_COLUMN_PUBLIC_LOGIN":true,"INTERNAL_USER_MANAGEMENT":true,"ALLOW_PUBLIC_JSON_IMPORT":false,"MAX_FILE_UPLOAD_SIZE":10000000,"REFUND_TEXT":"","RETURN_TO_HOME_ON_LOGOUT":true,"CURRENT_SOS_NAME":"Christi Jacobsen","LOGO_FILENAME":"mt-sos-logo.png","LOGO_ALT":"Christi Jacobsen, Montana Secretary of State","LOGO_FULL_WIDTH":true,"HOME_HIDE_AUTH_HINT":true,"HOME_TITLE":"Montana Secretary of State","CUSTOM_TAB_TITLE":"Official Montana","HOME_SUBTITLE":"Online Business Services","ENTITY_NAME_CONSENT_DESCRIPTION":"","ALLOW_USER_PROFILE_EDITING":true,"COMPARE_FOREIGN_NAME_IN_ENTITY_NAME_VALIDATION":true,"FOREIGN_NAME_FIELD_NAME":"KIMA_PARENT_NAME_INFO","LOGIN_TITLE":"Montana Secretary of State Online Filing Portal Login","PUBLIC_LOGIN_LABEL":"Username","REVERSE_LOGIN_COLUMNS":true,"LOGIN_SEAL_FILENAME":"seal_white.png","SEPARATE_USERNAME_AND_EMAIL":true,"CREATE_ACCOUNT_BUTTON_ALIGN_LEFT":true,"CREATE_ACCOUNT_BUTTON_TEXT":"CREATE AN ACCOUNT","PASSWORD_CUSTOM_ERROR_TEXT":"The password must meet all requirements","ACCOUNT_CREATED_MESSAGE":"Please check your email to verify your account to login and allow a few minutes for this message to arrive. Check your junk/spam folders if you do not find the email in your inbox.","PUBLIC_LOGIN_PLACEHOLDER":" ","DISABLE_DEFAULT_PAYMENT_RADIO":true,"CUSTOM_RESET_PASSWORD_ERROR_MESSAGE":"Username invalid - no account found","PUBLIC_LOGIN_CREATE_DESCRIPTION":"### Existing User:\n\n  - Enter your username and password to login.  \n\n\n  #### - OR -  \n\n\n\n  - Forgot password? Click 'Reset Password' and follow the prompts.\n  - Forgot username? Click 'Forgot Username' and follow the prompts.  \n\n\n  ### New User:\n  ","LOGIN_HELP_LINK":"https://sosmt.gov/business/how-do-i/","LOGIN_HELP_LINK_TEXT":"Need Help?","FORGOT_USERNAME_TEXT":"Forgot Username?","LOGIN_ACTIVE_DIRECTORY_TEXT":"State User Login","MULTIPLE_LOGIN_METHODS":true,"HAS_ACTIVE_DIRECTORY_LOGIN":true,"RESET_PASSWORD_WITH_USERNAME":true,"DOWNLOAD_LINK":true,"SHOW_USERNAME_ACCOUNT_CREATE":true,"SHOW_SCROLL_DOWN_ARROW":true,"SHOW_ADDRESS_ACCOUNT_CREATE":true,"TWO_COLUMN_ACCOUNT_CREATE":true,"RESET_PASSWORD_TIP":"A link to change your password has been sent to your email. Please allow a few minutes for this message to arrive. Please check your junk/spam folders if you do not find the email in your inbox.","FORGOT_PASSWORD_LINK_TEXT":"Reset Password","PHONE_NUMBER_OPTIONAL_ACCOUNT_CREATE":true,"SHOW_REQUIRED_INDICATOR_ACCOUNT_CREATE":true,"PASSWORD_REQUIREMENTS_ACCOUNT_CREATE":"\n    <ul>\n      <li>MUST contain at least 8 characters (12+ recommended)</li>\n      <li>MUST contain at least one uppercase letter.</li>\n      <li>MUST contain at least one lowercase letter.</li>\n      <li>MUST contain at least one number.</li>\n      <li>MUST contain at least one special character (!”#$%&'()*+,-./:;<=>?</li>\n    </ul>\n  ","ALLOW_CERTIFICATION_REQUEST":true,"ALLOW_PUBLIC_CERTIFICATE_REQUEST":true,"ALLOW_COPY_REQUEST":false,"ALLOW_CORRECTION_STYLING":true,"HIDE_DEPRECATION_WARNING":false,"AMEND_ROUTE_PUBLIC":true,"SEAL_FILENAME":"seal.png","SHOPPING_CART":true,"ALLOW_PAYMENT_UPDATE_WITH_EMPTY_CART":true,"RA_EMAIL":true,"RA_WEBSITE":true,"RA_NO_DEFAULT_TYPE":true,"RA_ADDRESS_LABEL":"Street Address","RA_TYPE_SELECTION_DEFAULT":true,"RA_DEFAULT_TYPE":"460","RA_OVERRIDE_TYPE_WITH_DEFAULT":true,"RA_PRINCIPAL_ADDRESS_AMS":true,"UPLOAD_AND_SUBMIT_HIDE_IF_ONE_OPTION":true,"PAYMENT_PROCESSING_MESSAGE":"Your payment is processing - Do not close your browser or click the back button","CHECKOUT_BUTTON_WHEN_PROCESSING_TEXT":"Processing","EFS_CROP_PICKER_NONE_LABEL":"Lien Duration","DISALLOWED_WIZARD_PIECES":["FormationLocale"],"REPEATER_SHOW_EDIT_BUTTON":true,"DATA_REQUEST_PAGE_TITLE":"Data Requests and Subscriptions","DATA_REQUEST_SIDEBAR_LABEL":"Data Requests & Subscriptions","LOGIN_REDIRECTS_TO_EPASS":false,"LOGIN_REDIRECTS_TO_ACTIVE_DIRECTORY":true,"LOGIN_ACTIVE_DIRECTORY_LINK":true,"FETCH_EDIT_USER_LINK":false,"LISTS_FETCH_AVAILABLE_LISTS":true,"POST_WIZARD_SUBMIT_REDIRECT_URL":"/","PIN_REQUEST_ATTESTATIONS":true,"PIN_REQUEST_DESCRIPTION":"Click **Request PIN** to have a new PIN sent to the account holder's email address on file.","OWNERSHIP_REQUEST_DESCRIPTION":"To become an **authorized user** of this record, a current **AUTHORIZED USER** will need to grant you access. To request access, click **Request Access** below.","PIN_REQUEST_SUCCESS_MESSAGE":"The PIN you have requested for this entity has been sent to the email associated with your user account.  You should receive the PIN in approximately 3-5 minutes, depending on your email service provider.","APOSTILLE_HEADER_LABEL":"Verification Information","APOSTILLE_NUMBER_LABEL":"Apostille/Authentication","APOSTILLE_CITY_STATE_OVERRIDE":"HELENA, MT","APOSTILLE_FILING_DATE_LABEL":"Issue Date","APOSTILLE_CITY_STATE_IN_CERTIFIED":true,"NOTARY_EXISTING_FILING":true,"ALLOW_REVOKE_OWN_ACCESS_ONLY":false,"HIDE_CANCEL_ON_ONETIME_DATA_REQUESTS":true,"DATA_REQUESTS_IN_SHOPPING_CART":true,"WQ_ALLOW_EDIT_PENDING_PAYMENT":true,"WQ_CONFIRM_ON_DELETE":true,"WQ_DELETE_CONFIRM_MESSAGE":"Deleting this filing will forfeit any money already paid to the Secretary of State. This action is permanent and cannot be undone, are you sure you would like to delete?","PASS_ITEM_GUIDS_ON_CHECKOUT":true,"FORM_REVISION_HISTORY":true,"CHECKOUT_DISCLAIMER":"By entering your credit card and/or checking account information you (i) state that **you are an authorized user** of the credit card and/or electronic check and that the associated information entered (e.g., account holder name, account number, billing address) is accurate, (ii) **you authorize payment processor to charge the amount you have requested** to your credit card and/or funding account, and (iii) **acknowledge if a charge is declined or reversed you may also be assessed a customary charge** by the payment processor for such transactions.","FARM_BILL_SEARCH_CONFIDENTIAL":"As a registered Farm Bill Buyer with the Montana Secretary of State’s office it is important to maintain the confidentiality of the information contained within the Farm Bill Master List. The Farm Bill Master List reflects personal data, such as Social Security Numbers, which are a key piece of personal identifiable information to assist you in determining the existence of a lien against a specific debtor. The distribution of this information beyond its intended purpose is strictly prohibited.\n\n**The debtor's tax identification number has been hidden for confidentiality reasons. You may continue to search on a tax ID number and return debtors that match your search criteria. The SSN/FEIN must be entered without dashes or spaces.  If you need access to the tax identification number to clearly identify the debtor, please contact the UCC unit at (406) 444-3665.**","VIEW_HISTORY_BUTTON_ALT_TEXT":"View Filings","WIZARD_ERROR_TITLE_MESSAGE":"Form Error","FARM_BILL_SEARCH_INTERACTIVE":true,"USE_FARM_BILL_API":true,"DISALLOW_ASSIGN_SELF_AS_RA":true,"DISALLOW_ASSIGN_SELF_AS_PRINCIPAL":true,"USE_TRADEMARK_OWNER_VALIDATION":true,"USE_ALTERNATIVE_FOREIGN_ADDRESS_LABELS":true,"MY_RECEIPTS_FILTER":[{"type":"dateRange","name":"DATE_RANGE","label":"Date range","defaultValue":{"start":null,"end":null}},{"type":"text","name":"REF_NUM","defaultValue":"","label":"Reference Number"},{"type":"text","name":"RECEIPT_NUM","defaultValue":"","label":"Receipt Id"},{"type":"text","name":"AMOUNT","defaultValue":"","label":"Amount"},{"type":"select","name":"TYPE","defaultValue":"","label":"Payment Type","options":[{"value":"","label":"All"},{"value":"CC","label":"Credit Card"},{"value":"Check","label":"Check"}]}],"MY_RECEIPTS_SHOW_IN_SIDEBAR":true,"SHOW_MY_RECEIPTS_HELPER_TEXT":true,"MY_RECEIPTS_HELPER_LABEL":"About Receipt Search","MY_RECEIPTS_HELPER_TEXT":"You can search for receipts based on their descriptions, including the items paid for on the receipt. Use the filters to search for or filter specific information.","FARM_BILL_SUBLINK":{"label":"Farm Bill","component":"FarmBill","parameter":"farm-bill","path":"/lists/farm-bill","sourceTypeId":0,"myRecordsSearch":false,"allowedRules":["/search/"],"disabled":true,"searchDescription":"To perform a search, enter a debtor name. Your search results may include: exact debtor name, variations of that name and any filing that includes your search criteria. Punctuation is ignored.\n\nYou can click on \"Advanced\" to refine your search. Under “Advanced” you can search by crop, year, county and SSN/FEIN. As a registered Farm Bill Buyer with the Montana Secretary of State’s office it is important to maintain the confidentiality of the information contained within the Farm Bill Master List. The Farm Bill Master List reflects personal data, such as Social Security Numbers, which are a key piece of personal identifiable information to assist you in determining the existence of a lien against a specific debtor. The distribution of this information beyond its intended purpose is strictly prohibited.\n\nThe debtor's tax identification number has been hidden for confidentiality reasons. You may continue to search on a tax ID number and return debtors that match your search criteria. The SSN/FEIN must be entered without dashes or spaces.","searchMustHaveOneOf":["search","UCC_FARM_PRODUCT_ID","COUNTY"],"searchPlaceholder":"Search by debtor name","advancedSearchParameters":[{"type":"ServerMultiComplete","label":"Product code name(s)","name":"UCC_FARM_PRODUCT_ID","defaultValue":"","optionsSrc":"UCC_FARM_PRODUCT_V"},{"type":"MultiComplete","label":"Year or Range of Years","name":"YEAR_NUM","optionsSrc":"years","startYear":"1968","defaultValue":[],"preMergeOptions":[{"value":"ALL","label":"All"}]},{"type":"serverSelect","label":"State","name":"STATE","defaultValue":"MONTANA","optionsSrc":"STATE"},{"type":"ServerMultiComplete","label":"County","name":"COUNTY","defaultValue":[],"optionsSrc":"COUNTY","overrideSubOptionsSrcFromParameterName":"STATE"},{"type":"checkbox","name":"TIN_SEARCH_YN","defaultValue":false,"label":"Tax Identification Number Search"},{"type":"checkbox","name":"TIN_SORT_YN","defaultValue":false,"label":"Unique ID Sort"}]},"ALLOW_ADDRESS_VALIDATION_BYPASS_OPTION":true,"DEFAULT_ADDRESS_VALIDATION_BYPASS_OPTION_CHECKED":true}).UCC_SEARCH_ONLY_REQUIRE_LAST_NAME;
	var UCC_SEARCH_ALLOW_START_DATE = ({"NODE_ENV":"production","BUILD_DATE":"2025-08-27T15:15:31.687Z","BUILD_NUMBER":"Not Provided","GIT_VERSION":"v1.3.0-381-ga81e29b08","GIT_COMMIT_HASH":"a81e29b085c9268ffd96c78eb734365802722741","GIT_BRANCH":"beta","PUBLIC_URL":"","STATE_ABBR":"MT","STATE_NAME":"Montana","STATE_ORG_TITLE":"Secretary of State","LOGIN_HEADER_IMG_PATH":"","HOME_IMG_FILENAME":"montana.jpg","FAVICON_FILE_NAME":"favicon.ico","ALLOW_E_SIGN_ON_CORRECTIONS":true,"THIRD_PARTY_SIGNING_ALLOWED":false,"MY_ACCOUNT_SAVE_AND_CLOSE_BUTTON":true,"IE_DEPRECATED_MESSAGE":"Internet Explorer is not supported. Please select a supported browser below to access this website.","ADDITIONAL_ROUTES":{"dataRequests":true,"farmBill":true,"apostille":true,"externalHelp":"https://sosmt.gov/business/help-center/","systemAdministration":[{"title":"Saved Payments","parameter":"saved-payments","componentName":"SavedPayments"}]},"SUBROUTES":[{"label":"Business","component":"Business","parameter":"business","myWorkQueueSearch":false,"sourceTypeId":54,"searchMustHaveOneOf":["FILING_TYPE_ID","STATUS_ID","STATE","search"],"serverWebSearchDescription":true,"serverWorkQueueDescription":true,"serverMyRecordsDescription":true,"searchPlaceholder":"Search by name or filing number (X########)","allowEmptySearchTerm":true,"requestCertificateAlternateLabel":"Request Information","fileAmendmentButtonLabel":"Filing Actions","advancedSearchParameters":[{"type":"radio","name":"QUERY_TYPE_ID","defaultValue":1010,"options":[{"value":1010,"label":"Starts with"},{"value":1011,"label":"Contains"},{"value":1012,"label":" Word Contains"}]},{"type":"serverSelect","name":"FILING_TYPE_ID","optionsSrc":"FILING_TYPES","label":"Entity Type","placeholder":"All","defaultValue":"0"},{"type":"serverSelect","name":"FILING_SUBTYPE_ID","optionsSrc":"FILING_SUBTYPES","label":"Entity Subtype","overrideSubOptionsSrcFromParameterName":"FILING_TYPE_ID","placeholder":"All","defaultValue":"0"},{"type":"serverSelect","name":"STATUS_ID","optionsSrc":"FILING_STATUS_WITHOUT_ALL","label":"Status","placeholder":"All","defaultValue":"0"},{"type":"serverSelect","name":"STATE","optionsSrc":"STATE","label":"State","placeholder":"All","defaultValue":""},{"type":"serverSelect","name":"COUNTY","optionsSrc":"COUNTY_SUBOPTION","label":"County","overrideSubOptionsSrcFromParameterName":"STATE","placeholder":"All","defaultValue":""},{"type":"checkbox","name":"CRA_SEARCH_YN","defaultValue":false,"label":"Search by Registered Agent PID"},{"type":"dateRange","name":"FILING_DATE","label":"Registration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}},{"type":"dateRange","name":"EXPIRATION_DATE","label":"Expiration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}}],"myRecordsFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Active"},{"value":2,"label":"Inactive"},{"value":3,"label":"Pending"}]},{"type":"dateRange","name":"DATE_RANGE","label":"Date range","defaultValue":{"start":null,"end":null}}],"myWorkQueueFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Approved"},{"value":2,"label":"Pending Online Payment"},{"value":3,"label":"Pending Review"},{"value":4,"label":"Needs Correction"},{"value":5,"label":"Rejected"},{"value":6,"label":"Draft"}]},{"type":"dateRange","name":"DATE_RANGE","label":"Date range","defaultValue":{"start":null,"end":null}}]},{"label":"Notary","component":"Notary","parameter":"notary","sourceTypeId":850,"myWorkQueueSearch":false,"allowEmptySearchTerm":true,"requestCertificateAlternateLabel":"Download Certificate","fileAmendmentButtonLabel":"Filing Actions","hideNameRequestCertificate":true,"hideAddressRequestCertificate":true,"hideRecordUserManagment":true,"searchPlaceholder":"Search by name or commission number","searchMustHaveOneOf":["CITY","search","SERVICE_TYPE"],"advancedParametersStartOpen":true,"searchIsSortable":true,"advancedSearchParameters":[{"type":"radio","name":"STARTS_WITH_YN","defaultValue":false,"options":[{"value":true,"label":"Starts with"},{"value":false,"label":"Contains"}]},{"type":"checkbox","name":"ACTIVE_ONLY_YN","defaultValue":true,"label":"Active entities only"},{"type":"text","name":"CITY","defaultValue":"","label":"City"},{"type":"select","name":"SERVICE_TYPE","label":"Special Services Offered","defaultValue":0,"options":[{"value":0,"label":"(N/A)"},{"value":6165,"label":"In-Person Electronic Notarization (IPEN)"},{"value":6166,"label":"Remote Online Notarization (RON)"},{"value":6167,"label":"Mobile Notary Services"},{"value":6168,"label":"Remote Ink Notarization (RIN)"}]}]},{"label":"Apostille","component":"Apostille","parameter":"apostille","sourceTypeId":720,"myRecordsSearch":false,"myWorkQueueSearch":false,"disabled":false,"allowedRoutes":["/forms-manager/","/queue/","/forms/"]},{"label":"Liens","component":"UCC","parameter":"ucc","sourceTypeId":1999,"myRecordsSearch":true,"myWorkQueueSearch":true,"fileAmendmentButtonLabel":"Filing Actions","searchPlaceholder":"Search by name or file number","disabled":false,"serverWebSearchDescription":true,"myRecordsDescription":"","workQueueDescription":"","searchDescription":"","hideRecordUserManagment":true,"searchLiensCheckout":false,"advancedSearchParameters":[{"type":"radio","name":"STARTS_WITH_YN","defaultValue":false,"options":[{"value":true,"label":"Starts with"},{"value":false,"label":"Contains"}]},{"type":"select","name":"STATUS","defaultValue":"ALL","label":"Status","options":[{"value":"ACTIVE_UNLAPSED","label":"Active (unlapsed)"},{"value":"ACTIVE_LAPSED_UNLAPSED","label":"Active (lapsed and unlapsed)"}]},{"type":"text","name":"EXCLUDE_VALUES","label":"Exclude Debtor Names (comma separated list of names to exclude)","defaultValue":""},{"type":"dateRange","name":"FILING_DATE","label":"Financing Statement Date","defaultValue":{"start":null,"end":null}},{"type":"dateRange","name":"LAPSE_DATE","label":"Lapse Date","defaultValue":{"start":null,"end":null}},{"type":"text","name":"CITY","label":"Debtor City","defaultValue":""}],"myRecordsFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Approved"},{"value":2,"label":"Pending Online Payment"},{"value":3,"label":"Pending Review"}]},{"type":"select","name":"TYPE","defaultValue":0,"label":"Lien Type","options":[{"value":0,"label":"All"},{"value":1,"label":"UCC"},{"value":2,"label":"EFS"},{"value":3,"label":"Title 71"}]}],"myWorkQueueFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Approved"},{"value":2,"label":"Pending Online Payment"},{"value":3,"label":"Pending Review"},{"value":4,"label":"Pending Print and Mail"},{"value":5,"label":"Rejected"},{"value":6,"label":"Draft"}]},{"type":"select","name":"TYPE","defaultValue":0,"label":"Lien Type","options":[{"value":0,"label":"All"},{"value":1,"label":"UCC"},{"value":2,"label":"EFS"},{"value":3,"label":"Title 71"}]}]},{"label":"Copy Request","component":"copies","parameter":"copies","sourceTypeId":2001,"myRecordsSearch":false,"myWorkQueueSearch":false,"disabled":false,"allowedRoutes":["/forms-manager/","/queue/","/forms/"]},{"label":"Trademark","component":"Trademark","parameter":"trademark","sourceTypeId":810,"showRequestCertificate":true,"searchMustHaveOneOf":["search","EXPIRATION_DATE","FILING_DATE"],"allowEmptySearchTerm":true,"requestCertificateAlternateLabel":"Request Information","fileAmendmentButtonLabel":"Filing Actions","advancedSearchParameters":[{"type":"radio","name":"QUERY_TYPE_ID","defaultValue":1010,"options":[{"value":1010,"label":"Starts with"},{"value":1011,"label":"Contains"},{"value":1012,"label":" Word Contains"}]},{"type":"checkbox","name":"OWNER_SEARCH_YN","defaultValue":false,"label":"Search owners"},{"type":"radio","name":"SERVICE_MARK_YN","label":"Mark Type","defaultValue":"","options":[{"value":"","label":"All Marks"},{"value":"Y","label":"Service Mark"},{"value":"N","label":"Trademark"}]},{"type":"serverSelect","name":"STATUS_ID","optionsSrc":"TYPE_V|TRADEMARK_STATUS_TYPE","label":"Status","placeholder":"All","defaultValue":"0"},{"type":"select","name":"DESIGN_TYPE_ID","options":[{"value":0,"label":"All"},{"value":990,"label":"Words Only"},{"value":991,"label":"Design Only"},{"value":992,"label":"Words and Design"}],"label":"Design Type","defaultValue":"0"},{"type":"dateRange","name":"FILING_DATE","label":"Registered Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}},{"type":"dateRange","name":"EXPIRATION_DATE","label":"Expiration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}}]},{"label":"Business Info Request","component":"InfoRequests","parameter":"info-request","sourceTypeId":167,"allowedRoutes":["/forms-manager/","/queue/","/forms/"]},{"label":"Data Requests","component":"DataRequests","parameter":"data-request","sourceTypeId":0,"allowedRoutes":["/forms-manager/"]},{"label":"CRA","component":"CRA","parameter":"cra","sourceTypeId":157,"myRecordsSearch":false,"searchPlaceholder":"Search by name or registered agent number","allowedRoutes":["/forms-manager/","/forms/","/records/","/queue/","/search/"],"allowEmptySearchTerm":true,"fileAmendmentButtonLabel":"Filing Actions","advancedSearchParameters":[{"type":"radio","name":"QUERY_TYPE_ID","defaultValue":1010,"options":[{"value":1010,"label":"Starts with"},{"value":1011,"label":"Contains"},{"value":1012,"label":" Word Contains"}]},{"type":"dateRange","name":"CRA_DATE","label":"Registration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}},{"type":"select","name":"STATUS_ID","label":"Status","defaultValue":0,"options":[{"value":0,"label":"All"},{"value":121,"label":"Active"},{"value":122,"label":"Inactive"}]},{"type":"select","name":"AGENT_TYPE_ID","label":"Agent Type","defaultValue":0,"options":[{"value":0,"label":"All"},{"value":460,"label":"Registered Agent"},{"value":461,"label":"Commercial Registered Agent"}]}]},{"label":"Farm Bill","component":"FarmBill","parameter":"farm-bill","path":"/lists/farm-bill","sourceTypeId":0,"myRecordsSearch":false,"allowedRules":["/search/"],"disabled":true,"searchDescription":"To perform a search, enter a debtor name. Your search results may include: exact debtor name, variations of that name and any filing that includes your search criteria. Punctuation is ignored.\n\nYou can click on \"Advanced\" to refine your search. Under “Advanced” you can search by crop, year, county and SSN/FEIN. As a registered Farm Bill Buyer with the Montana Secretary of State’s office it is important to maintain the confidentiality of the information contained within the Farm Bill Master List. The Farm Bill Master List reflects personal data, such as Social Security Numbers, which are a key piece of personal identifiable information to assist you in determining the existence of a lien against a specific debtor. The distribution of this information beyond its intended purpose is strictly prohibited.\n\nThe debtor's tax identification number has been hidden for confidentiality reasons. You may continue to search on a tax ID number and return debtors that match your search criteria. The SSN/FEIN must be entered without dashes or spaces.","searchMustHaveOneOf":["search","UCC_FARM_PRODUCT_ID","COUNTY"],"searchPlaceholder":"Search by debtor name","advancedSearchParameters":[{"type":"ServerMultiComplete","label":"Product code name(s)","name":"UCC_FARM_PRODUCT_ID","defaultValue":"","optionsSrc":"UCC_FARM_PRODUCT_V"},{"type":"MultiComplete","label":"Year or Range of Years","name":"YEAR_NUM","optionsSrc":"years","startYear":"1968","defaultValue":[],"preMergeOptions":[{"value":"ALL","label":"All"}]},{"type":"serverSelect","label":"State","name":"STATE","defaultValue":"MONTANA","optionsSrc":"STATE"},{"type":"ServerMultiComplete","label":"County","name":"COUNTY","defaultValue":[],"optionsSrc":"COUNTY","overrideSubOptionsSrcFromParameterName":"STATE"},{"type":"checkbox","name":"TIN_SEARCH_YN","defaultValue":false,"label":"Tax Identification Number Search"},{"type":"checkbox","name":"TIN_SORT_YN","defaultValue":false,"label":"Unique ID Sort"}]}],"SYSTEM_NICKNAME":"Online Services Portal","PAYMENT_METHODS":[{"type":"bypass"},{"type":"iTransact"}],"PAYMENT_ALLOW_AMEX":true,"SYSTEM_ID_LABEL":"System Id","DOUBLE_COLUMN_PUBLIC_LOGIN":true,"INTERNAL_USER_MANAGEMENT":true,"ALLOW_PUBLIC_JSON_IMPORT":false,"MAX_FILE_UPLOAD_SIZE":10000000,"REFUND_TEXT":"","RETURN_TO_HOME_ON_LOGOUT":true,"CURRENT_SOS_NAME":"Christi Jacobsen","LOGO_FILENAME":"mt-sos-logo.png","LOGO_ALT":"Christi Jacobsen, Montana Secretary of State","LOGO_FULL_WIDTH":true,"HOME_HIDE_AUTH_HINT":true,"HOME_TITLE":"Montana Secretary of State","CUSTOM_TAB_TITLE":"Official Montana","HOME_SUBTITLE":"Online Business Services","ENTITY_NAME_CONSENT_DESCRIPTION":"","ALLOW_USER_PROFILE_EDITING":true,"COMPARE_FOREIGN_NAME_IN_ENTITY_NAME_VALIDATION":true,"FOREIGN_NAME_FIELD_NAME":"KIMA_PARENT_NAME_INFO","LOGIN_TITLE":"Montana Secretary of State Online Filing Portal Login","PUBLIC_LOGIN_LABEL":"Username","REVERSE_LOGIN_COLUMNS":true,"LOGIN_SEAL_FILENAME":"seal_white.png","SEPARATE_USERNAME_AND_EMAIL":true,"CREATE_ACCOUNT_BUTTON_ALIGN_LEFT":true,"CREATE_ACCOUNT_BUTTON_TEXT":"CREATE AN ACCOUNT","PASSWORD_CUSTOM_ERROR_TEXT":"The password must meet all requirements","ACCOUNT_CREATED_MESSAGE":"Please check your email to verify your account to login and allow a few minutes for this message to arrive. Check your junk/spam folders if you do not find the email in your inbox.","PUBLIC_LOGIN_PLACEHOLDER":" ","DISABLE_DEFAULT_PAYMENT_RADIO":true,"CUSTOM_RESET_PASSWORD_ERROR_MESSAGE":"Username invalid - no account found","PUBLIC_LOGIN_CREATE_DESCRIPTION":"### Existing User:\n\n  - Enter your username and password to login.  \n\n\n  #### - OR -  \n\n\n\n  - Forgot password? Click 'Reset Password' and follow the prompts.\n  - Forgot username? Click 'Forgot Username' and follow the prompts.  \n\n\n  ### New User:\n  ","LOGIN_HELP_LINK":"https://sosmt.gov/business/how-do-i/","LOGIN_HELP_LINK_TEXT":"Need Help?","FORGOT_USERNAME_TEXT":"Forgot Username?","LOGIN_ACTIVE_DIRECTORY_TEXT":"State User Login","MULTIPLE_LOGIN_METHODS":true,"HAS_ACTIVE_DIRECTORY_LOGIN":true,"RESET_PASSWORD_WITH_USERNAME":true,"DOWNLOAD_LINK":true,"SHOW_USERNAME_ACCOUNT_CREATE":true,"SHOW_SCROLL_DOWN_ARROW":true,"SHOW_ADDRESS_ACCOUNT_CREATE":true,"TWO_COLUMN_ACCOUNT_CREATE":true,"RESET_PASSWORD_TIP":"A link to change your password has been sent to your email. Please allow a few minutes for this message to arrive. Please check your junk/spam folders if you do not find the email in your inbox.","FORGOT_PASSWORD_LINK_TEXT":"Reset Password","PHONE_NUMBER_OPTIONAL_ACCOUNT_CREATE":true,"SHOW_REQUIRED_INDICATOR_ACCOUNT_CREATE":true,"PASSWORD_REQUIREMENTS_ACCOUNT_CREATE":"\n    <ul>\n      <li>MUST contain at least 8 characters (12+ recommended)</li>\n      <li>MUST contain at least one uppercase letter.</li>\n      <li>MUST contain at least one lowercase letter.</li>\n      <li>MUST contain at least one number.</li>\n      <li>MUST contain at least one special character (!”#$%&'()*+,-./:;<=>?</li>\n    </ul>\n  ","ALLOW_CERTIFICATION_REQUEST":true,"ALLOW_PUBLIC_CERTIFICATE_REQUEST":true,"ALLOW_COPY_REQUEST":false,"ALLOW_CORRECTION_STYLING":true,"HIDE_DEPRECATION_WARNING":false,"AMEND_ROUTE_PUBLIC":true,"SEAL_FILENAME":"seal.png","SHOPPING_CART":true,"ALLOW_PAYMENT_UPDATE_WITH_EMPTY_CART":true,"RA_EMAIL":true,"RA_WEBSITE":true,"RA_NO_DEFAULT_TYPE":true,"RA_ADDRESS_LABEL":"Street Address","RA_TYPE_SELECTION_DEFAULT":true,"RA_DEFAULT_TYPE":"460","RA_OVERRIDE_TYPE_WITH_DEFAULT":true,"RA_PRINCIPAL_ADDRESS_AMS":true,"UPLOAD_AND_SUBMIT_HIDE_IF_ONE_OPTION":true,"PAYMENT_PROCESSING_MESSAGE":"Your payment is processing - Do not close your browser or click the back button","CHECKOUT_BUTTON_WHEN_PROCESSING_TEXT":"Processing","EFS_CROP_PICKER_NONE_LABEL":"Lien Duration","DISALLOWED_WIZARD_PIECES":["FormationLocale"],"REPEATER_SHOW_EDIT_BUTTON":true,"DATA_REQUEST_PAGE_TITLE":"Data Requests and Subscriptions","DATA_REQUEST_SIDEBAR_LABEL":"Data Requests & Subscriptions","LOGIN_REDIRECTS_TO_EPASS":false,"LOGIN_REDIRECTS_TO_ACTIVE_DIRECTORY":true,"LOGIN_ACTIVE_DIRECTORY_LINK":true,"FETCH_EDIT_USER_LINK":false,"LISTS_FETCH_AVAILABLE_LISTS":true,"POST_WIZARD_SUBMIT_REDIRECT_URL":"/","PIN_REQUEST_ATTESTATIONS":true,"PIN_REQUEST_DESCRIPTION":"Click **Request PIN** to have a new PIN sent to the account holder's email address on file.","OWNERSHIP_REQUEST_DESCRIPTION":"To become an **authorized user** of this record, a current **AUTHORIZED USER** will need to grant you access. To request access, click **Request Access** below.","PIN_REQUEST_SUCCESS_MESSAGE":"The PIN you have requested for this entity has been sent to the email associated with your user account.  You should receive the PIN in approximately 3-5 minutes, depending on your email service provider.","APOSTILLE_HEADER_LABEL":"Verification Information","APOSTILLE_NUMBER_LABEL":"Apostille/Authentication","APOSTILLE_CITY_STATE_OVERRIDE":"HELENA, MT","APOSTILLE_FILING_DATE_LABEL":"Issue Date","APOSTILLE_CITY_STATE_IN_CERTIFIED":true,"NOTARY_EXISTING_FILING":true,"ALLOW_REVOKE_OWN_ACCESS_ONLY":false,"HIDE_CANCEL_ON_ONETIME_DATA_REQUESTS":true,"DATA_REQUESTS_IN_SHOPPING_CART":true,"WQ_ALLOW_EDIT_PENDING_PAYMENT":true,"WQ_CONFIRM_ON_DELETE":true,"WQ_DELETE_CONFIRM_MESSAGE":"Deleting this filing will forfeit any money already paid to the Secretary of State. This action is permanent and cannot be undone, are you sure you would like to delete?","PASS_ITEM_GUIDS_ON_CHECKOUT":true,"FORM_REVISION_HISTORY":true,"CHECKOUT_DISCLAIMER":"By entering your credit card and/or checking account information you (i) state that **you are an authorized user** of the credit card and/or electronic check and that the associated information entered (e.g., account holder name, account number, billing address) is accurate, (ii) **you authorize payment processor to charge the amount you have requested** to your credit card and/or funding account, and (iii) **acknowledge if a charge is declined or reversed you may also be assessed a customary charge** by the payment processor for such transactions.","FARM_BILL_SEARCH_CONFIDENTIAL":"As a registered Farm Bill Buyer with the Montana Secretary of State’s office it is important to maintain the confidentiality of the information contained within the Farm Bill Master List. The Farm Bill Master List reflects personal data, such as Social Security Numbers, which are a key piece of personal identifiable information to assist you in determining the existence of a lien against a specific debtor. The distribution of this information beyond its intended purpose is strictly prohibited.\n\n**The debtor's tax identification number has been hidden for confidentiality reasons. You may continue to search on a tax ID number and return debtors that match your search criteria. The SSN/FEIN must be entered without dashes or spaces.  If you need access to the tax identification number to clearly identify the debtor, please contact the UCC unit at (406) 444-3665.**","VIEW_HISTORY_BUTTON_ALT_TEXT":"View Filings","WIZARD_ERROR_TITLE_MESSAGE":"Form Error","FARM_BILL_SEARCH_INTERACTIVE":true,"USE_FARM_BILL_API":true,"DISALLOW_ASSIGN_SELF_AS_RA":true,"DISALLOW_ASSIGN_SELF_AS_PRINCIPAL":true,"USE_TRADEMARK_OWNER_VALIDATION":true,"USE_ALTERNATIVE_FOREIGN_ADDRESS_LABELS":true,"MY_RECEIPTS_FILTER":[{"type":"dateRange","name":"DATE_RANGE","label":"Date range","defaultValue":{"start":null,"end":null}},{"type":"text","name":"REF_NUM","defaultValue":"","label":"Reference Number"},{"type":"text","name":"RECEIPT_NUM","defaultValue":"","label":"Receipt Id"},{"type":"text","name":"AMOUNT","defaultValue":"","label":"Amount"},{"type":"select","name":"TYPE","defaultValue":"","label":"Payment Type","options":[{"value":"","label":"All"},{"value":"CC","label":"Credit Card"},{"value":"Check","label":"Check"}]}],"MY_RECEIPTS_SHOW_IN_SIDEBAR":true,"SHOW_MY_RECEIPTS_HELPER_TEXT":true,"MY_RECEIPTS_HELPER_LABEL":"About Receipt Search","MY_RECEIPTS_HELPER_TEXT":"You can search for receipts based on their descriptions, including the items paid for on the receipt. Use the filters to search for or filter specific information.","FARM_BILL_SUBLINK":{"label":"Farm Bill","component":"FarmBill","parameter":"farm-bill","path":"/lists/farm-bill","sourceTypeId":0,"myRecordsSearch":false,"allowedRules":["/search/"],"disabled":true,"searchDescription":"To perform a search, enter a debtor name. Your search results may include: exact debtor name, variations of that name and any filing that includes your search criteria. Punctuation is ignored.\n\nYou can click on \"Advanced\" to refine your search. Under “Advanced” you can search by crop, year, county and SSN/FEIN. As a registered Farm Bill Buyer with the Montana Secretary of State’s office it is important to maintain the confidentiality of the information contained within the Farm Bill Master List. The Farm Bill Master List reflects personal data, such as Social Security Numbers, which are a key piece of personal identifiable information to assist you in determining the existence of a lien against a specific debtor. The distribution of this information beyond its intended purpose is strictly prohibited.\n\nThe debtor's tax identification number has been hidden for confidentiality reasons. You may continue to search on a tax ID number and return debtors that match your search criteria. The SSN/FEIN must be entered without dashes or spaces.","searchMustHaveOneOf":["search","UCC_FARM_PRODUCT_ID","COUNTY"],"searchPlaceholder":"Search by debtor name","advancedSearchParameters":[{"type":"ServerMultiComplete","label":"Product code name(s)","name":"UCC_FARM_PRODUCT_ID","defaultValue":"","optionsSrc":"UCC_FARM_PRODUCT_V"},{"type":"MultiComplete","label":"Year or Range of Years","name":"YEAR_NUM","optionsSrc":"years","startYear":"1968","defaultValue":[],"preMergeOptions":[{"value":"ALL","label":"All"}]},{"type":"serverSelect","label":"State","name":"STATE","defaultValue":"MONTANA","optionsSrc":"STATE"},{"type":"ServerMultiComplete","label":"County","name":"COUNTY","defaultValue":[],"optionsSrc":"COUNTY","overrideSubOptionsSrcFromParameterName":"STATE"},{"type":"checkbox","name":"TIN_SEARCH_YN","defaultValue":false,"label":"Tax Identification Number Search"},{"type":"checkbox","name":"TIN_SORT_YN","defaultValue":false,"label":"Unique ID Sort"}]},"ALLOW_ADDRESS_VALIDATION_BYPASS_OPTION":true,"DEFAULT_ADDRESS_VALIDATION_BYPASS_OPTION_CHECKED":true}).UCC_SEARCH_ALLOW_START_DATE;
	
	var UCCSearch = exports.UCCSearch = function (_React$Component) {
	  _inherits(UCCSearch, _React$Component);
	
	  function UCCSearch() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, UCCSearch);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = UCCSearch.__proto__ || Object.getPrototypeOf(UCCSearch)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      modalOpen: false,
	      rawRow: [],
	      searching: false,
	      renderHeadlessModal: false
	    }, _this.setByKey = function (key, value) {
	      _this.props.onChange(Object.assign({}, _this.props.value, {
	        search: Object.assign({}, _this.props.value.search, _defineProperty({}, key, value))
	      }));
	    }, _this.setName = function (name) {
	      _this.props.onChange(Object.assign({}, _this.props.value, {
	        search: Object.assign({}, _this.props.value.search, Object.entries(name).reduce(function (obj, ent) {
	          return Object.assign({}, obj, _defineProperty({}, 'SEARCH_' + ent[0], ent[1]));
	        }, {}))
	      }));
	    }, _this.search = function () {
	      var _this$props = _this.props,
	          value = _this$props.value,
	          uccMode = _this$props.uccMode,
	          skipResultSelection = _this$props.skipResultSelection;
	
	      _this.setState({ searching: true });
	      var isOrg = value.search.IS_ORG === "true" || value.search.IS_ORG === true;
	      (0, _requests.SEARCH_UCC_INFO_REQ)({
	        SEC_PARTY_SEARCH_YN: false,
	        SEARCH_IS_ORG: isOrg,
	        SEARCH_LAST_NAME: isOrg ? "" : value.search.SEARCH_LAST_NAME,
	        SEARCH_FIRST_NAME: isOrg ? "" : value.search.SEARCH_FIRST_NAME,
	        SEARCH_MIDDLE_NAME: isOrg ? "" : value.search.SEARCH_MIDDLE_NAME,
	        SEARCH_SUFFIX: isOrg ? "" : value.search.SEARCH_SUFFIX,
	        SEARCH_ORG_NAME: isOrg ? value.search.SEARCH_ORG_NAME : "",
	        SEARCH_CITY: value.search.SEARCH_CITY,
	        SEARCH_STATE: value.search.SEARCH_STATE,
	        SEARCH_LAPSED: value.search.SEARCH_LAPSED,
	        SEARCH_TYPE: value.search.SEARCH_TYPE,
	        SEARCH_REQUEST_TYPE: value.search.SEARCH_REQUEST_TYPE,
	        SEARCH_UCC: value.search.SEARCH_UCC,
	        SEARCH_GOV: value.search.SEARCH_GOV,
	        SEARCH_EFS: value.search.SEARCH_EFS,
	        SEARCH_CROP_LIEN: value.search.SEARCH_CROP_LIEN,
	        SEARCH_AG_LIEN: value.search.SEARCH_AG_LIEN,
	        SEARCH_MODE: uccMode,
	        SEARCH_UCC_NUM: value.search.SEARCH_UCC_NUM,
	        BEGIN_DATE: value.search.BEGIN_DATE
	      }, function (records) {
	        // console.log(records)
	        var rows = (0, _orderBy2.default)(Object.values(records.rows).map(function (row) {
	          return row;
	        }), ['SORT_INDEX'], 'desc').map(function (row) {
	          return records.template.map(function (t) {
	            var cell = row[t.id];
	            if (Array.isArray(cell)) {
	              if (cell.length > 1) {
	                return cell.split('\n');
	              }
	              return cell[0];
	            }
	            return cell;
	          });
	        });
	        // console.log(rows)
	        _this.setState({
	          modalOpen: skipResultSelection ? false : true,
	          renderHeadlessModal: skipResultSelection,
	          template: records.template,
	          rows: rows,
	          rawRows: records.rows,
	          searching: false
	        }, function () {
	          if (skipResultSelection) {
	            _this.resultsModal.triggerConfirm();
	            _this.setState({
	              renderHeadlessModal: false
	            });
	          }
	        });
	      }, function (err) {
	        console.error(err);
	        _this.props.setErrorToast(err.internalerror);
	        _this.setState({
	          searching: false
	        });
	      });
	    }, _this.onConfirm = function (_ref2) {
	      var cache = _ref2.cache,
	          indexes = _ref2.indexes;
	
	      var rawRows = (0, _orderBy2.default)(Object.values(_this.state.rawRows).map(function (x) {
	        return x;
	      }), ['SORT_INDEX'], 'desc');
	      var ids = indexes.map(function (i) {
	        return rawRows[i].ID;
	      });
	      var IS_PARTIAL = rawRows.length > indexes.length;
	      _this.props.onChange(Object.assign({}, _this.props.value, { IS_PARTIAL: IS_PARTIAL, cache: cache, ids: ids }));
	    }, _this.deSelect = function () {
	      _this.setState({ modalOpen: false, template: null, rawRow: null });
	      _this.props.onChange(Object.assign({}, _this.props.value, { cache: null, ids: null }));
	    }, _this.getCanSearch = function () {
	      var _this$props2 = _this.props,
	          value = _this$props2.value,
	          disabled = _this$props2.disabled,
	          uccMode = _this$props2.uccMode;
	
	      var atLeastOneBoxChecked = !value.search.SEARCH_UCC && !value.search.SEARCH_GOV && !value.search.SEARCH_EFS && !value.search.SEARCH_CROP_LIEN && !value.search.SEARCH_AG_LIEN;
	      if (_this.state.searching || disabled) {
	        return false;
	      }
	      if (uccMode.toString() === '4') {
	        if (atLeastOneBoxChecked) {
	          return false;
	        }
	      }
	      if (UCC_SEARCH_ALLOW_SEARCH_TYPE) {
	        if (value.search.SEARCH_TYPE === 'DEBTOR' || value.search.SEARCH_TYPE === 'SECURED_PARTY') {
	          if (value.search.IS_ORG === true || value.search.IS_ORG === 'true') {
	            if (!value.search.SEARCH_ORG_NAME) {
	              return false;
	            }
	          } else if ((UCC_SEARCH_ONLY_REQUIRE_LAST_NAME ? false : !value.search.SEARCH_FIRST_NAME) || !value.search.SEARCH_LAST_NAME) {
	            return false;
	          }
	        } else if (value.search.SEARCH_TYPE === 'UCC_NUM') {
	          if (!value.search.SEARCH_UCC_NUM) {
	            return false;
	          }
	        }
	      } else if (value.search.IS_ORG === true || value.search.IS_ORG === 'true') {
	        if (!value.search.SEARCH_ORG_NAME) {
	          return false;
	        }
	      } else if (!value.search.SEARCH_FIRST_NAME || !value.search.SEARCH_LAST_NAME) {
	        return false;
	      }
	
	      return true;
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(UCCSearch, [{
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _props = this.props,
	          value = _props.value,
	          disabled = _props.disabled,
	          uccMode = _props.uccMode,
	          fieldId = _props.fieldId;
	
	      var fieldsDisabled = disabled || value.cache ? true : false;
	
	      return _react2.default.createElement(
	        _react2.default.Fragment,
	        null,
	        _react2.default.createElement(
	          'div',
	          { className: 'sub-section organization-search ucc-box' },
	          _react2.default.createElement(
	            'h3',
	            null,
	            _react2.default.createElement(_searchHeavy2.default, null),
	            ' Search for UCC Documents'
	          ),
	          value.cache && _react2.default.createElement(
	            'div',
	            { className: 'flex-row button-row' },
	            _react2.default.createElement(
	              'button',
	              {
	                disabled: disabled,
	                type: 'button',
	                className: 'btn btn-raised btn-primary search-button',
	                onClick: this.deSelect,
	                ref: function ref(focusTarget) {
	                  _this2.focusTarget = focusTarget;
	                }
	              },
	              _react2.default.createElement(_revert2.default, null),
	              ' \xA0 Clear Results & Re-Search'
	            )
	          ),
	          _react2.default.createElement(
	            _Field.DumbField,
	            { label: UCC_SEARCH_ALLOW_SEARCH_TYPE ? 'Request Type' : 'Search Type' },
	            _react2.default.createElement(_Form.RadioInput, {
	              value: value.search.SEARCH_REQUEST_TYPE,
	              onChange: function onChange(v) {
	                return _this2.setByKey('SEARCH_REQUEST_TYPE', v);
	              },
	              onBlur: _utilities.noop,
	              disabled: fieldsDisabled,
	              options: [{ value: 'LIST_ONLY', label: UCC_SEARCH_REQUEST_TYPE_LABEL_1 || 'Search request only' }, { value: 'LIST_AND_COPIES', label: UCC_SEARCH_REQUEST_TYPE_LABEL_2 || 'Both search and copy request' }]
	            })
	          ),
	          UCC_SEARCH_ALLOW_SEARCH_TYPE ? _react2.default.createElement(
	            _Field.DumbField,
	            { label: 'Search Type' },
	            _react2.default.createElement(_Form.RadioInput, {
	              leftAlign: true,
	              value: value.search.SEARCH_TYPE,
	              onChange: function onChange(v) {
	                return _this2.setByKey('SEARCH_TYPE', v);
	              },
	              onBlur: _utilities.noop,
	              disabled: fieldsDisabled,
	              options: [{ value: 'DEBTOR', label: 'Debtor Search' }, { value: 'SECURED_PARTY', label: 'Secured Party Search' }, { value: 'UCC_NUM', label: 'File Number Search' }]
	            })
	          ) : null,
	          (UCC_SEARCH_ALLOW_SEARCH_TYPE ? value.search.SEARCH_TYPE === 'DEBTOR' || value.search.SEARCH_TYPE === 'SECURED_PARTY' : true) ? _react2.default.createElement(
	            _react2.default.Fragment,
	            null,
	            _react2.default.createElement(
	              _Field.DumbField,
	              { label: UCC_SEARCH_NAME_ORG_LABEL || "Search for an Individual or Organization" },
	              _react2.default.createElement(_Form.RadioInput, {
	                leftAlign: true,
	                value: value.search.IS_ORG,
	                onChange: function onChange(v) {
	                  return _this2.setByKey('IS_ORG', v);
	                },
	                onBlur: _utilities.noop,
	                disabled: fieldsDisabled,
	                options: [{ value: false, label: 'Individual' }, { value: true, label: 'Organization' }]
	              })
	            ),
	            value.search.IS_ORG === true || value.search.IS_ORG === 'true' ? _react2.default.createElement(
	              'div',
	              { className: 'flex-row' },
	              _react2.default.createElement(
	                'div',
	                { className: 'no-field-padding col-sm-8 col-md-6 col-lg-4' },
	                _react2.default.createElement(
	                  _Field.DumbField,
	                  { label: 'Organization name', className: 'org-name', required: true },
	                  _react2.default.createElement(_Form.TextInput, {
	                    value: value.search.SEARCH_ORG_NAME,
	                    onChange: function onChange(v) {
	                      return _this2.setByKey('SEARCH_ORG_NAME', v);
	                    },
	                    onBlur: _utilities.noop,
	                    disabled: fieldsDisabled,
	                    width: '100%'
	                  })
	                )
	              )
	            ) : _react2.default.createElement(
	              'div',
	              { className: 'no-field-padding' },
	              _react2.default.createElement(_Form.FullName, {
	                value: {
	                  FIRST_NAME: value.search.SEARCH_FIRST_NAME,
	                  LAST_NAME: value.search.SEARCH_LAST_NAME,
	                  MIDDLE_NAME: value.search.SEARCH_MIDDLE_NAME,
	                  SUFFIX: value.search.SEARCH_SUFFIX
	                },
	                onlyRequireLastName: UCC_SEARCH_ONLY_REQUIRE_LAST_NAME,
	                required: true,
	                suffix: true,
	                onChange: this.setName,
	                onBlur: _utilities.noop,
	                disabled: fieldsDisabled
	              })
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'no-field-padding flex-row' },
	              _react2.default.createElement(
	                'div',
	                { className: 'col-sm-5 col-md-4 col-lg-3' },
	                _react2.default.createElement(
	                  _Field.DumbField,
	                  { label: 'City' },
	                  _react2.default.createElement(_Form.TextInput, {
	                    value: value.search.SEARCH_CITY,
	                    onChange: function onChange(v) {
	                      return _this2.setByKey('SEARCH_CITY', v);
	                    },
	                    onBlur: _utilities.noop,
	                    disabled: fieldsDisabled
	                  })
	                )
	              ),
	              _react2.default.createElement(
	                _Field.DumbField,
	                { label: 'State' },
	                _react2.default.createElement(_Form.Select, {
	                  value: value.search.SEARCH_STATE,
	                  onChange: function onChange(v) {
	                    return _this2.setByKey('SEARCH_STATE', v);
	                  },
	                  options: STATE_OPTIONS,
	                  onBlur: _utilities.noop,
	                  disabled: fieldsDisabled
	                })
	              )
	            )
	          ) : _react2.default.createElement(
	            _react2.default.Fragment,
	            null,
	            UCC_SEARCH_ALLOW_SEARCH_TYPE ? _react2.default.createElement(
	              'div',
	              { className: 'flex-row' },
	              _react2.default.createElement(
	                'div',
	                { className: 'no-field-padding col-sm-8 col-md-6 col-lg-4' },
	                _react2.default.createElement(
	                  _Field.DumbField,
	                  { label: 'File Number', className: 'ucc-num', required: true },
	                  _react2.default.createElement(_Form.TextInput, {
	                    value: value.search.SEARCH_UCC_NUM,
	                    onChange: function onChange(v) {
	                      return _this2.setByKey('SEARCH_UCC_NUM', v);
	                    },
	                    onBlur: _utilities.noop,
	                    disabled: fieldsDisabled,
	                    width: '100%'
	                  })
	                )
	              )
	            ) : null
	          ),
	          UCC_SEARCH_ALLOW_START_DATE ? _react2.default.createElement(
	            'div',
	            { className: 'flex-row' },
	            _react2.default.createElement(
	              'div',
	              { className: 'no-field-padding col-sm-8 col-md-6 col-lg-4' },
	              _react2.default.createElement(
	                _Field.DumbField,
	                { label: 'Start Date', description: 'Leave empty for all results' },
	                _react2.default.createElement(_Form.DateInput, {
	                  value: value.search.BEGIN_DATE,
	                  onChange: function onChange(v) {
	                    return _this2.setByKey('BEGIN_DATE', v);
	                  },
	                  onBlur: _utilities.noop,
	                  disabled: fieldsDisabled
	                })
	              )
	            )
	          ) : null,
	          _react2.default.createElement(
	            'div',
	            { className: 'flex-row checkbox-padding top-box' },
	            _react2.default.createElement(_Form.Checkbox, {
	              fieldId: fieldId + '-unlapsed',
	              label: 'Include lapsed filings on search response.',
	              value: value.search.SEARCH_LAPSED,
	              onChange: function onChange(v) {
	                return _this2.setByKey('SEARCH_LAPSED', v);
	              },
	              onBlur: _utilities.noop,
	              disabled: fieldsDisabled
	            })
	          ),
	          uccMode.toString() === '4' && _react2.default.createElement(
	            _react2.default.Fragment,
	            null,
	            _react2.default.createElement(
	              'label',
	              { className: 'sub-label' },
	              'Select at least one of the following:'
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'flex-row checkbox-padding' },
	              _react2.default.createElement(_Form.Checkbox, {
	                fieldId: fieldId + '-ucc',
	                label: 'Include UCC Financing statements (other than farm products)',
	                value: value.search.SEARCH_UCC,
	                onChange: function onChange(v) {
	                  return _this2.setByKey('SEARCH_UCC', v);
	                },
	                onBlur: _utilities.noop,
	                disabled: fieldsDisabled
	              })
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'flex-row checkbox-padding' },
	              _react2.default.createElement(_Form.Checkbox, {
	                fieldId: fieldId + '-tax',
	                label: 'Include Government Liens (IRS, indigent, employment, state tax, etc.)',
	                value: value.search.SEARCH_GOV,
	                onChange: function onChange(v) {
	                  return _this2.setByKey('SEARCH_GOV', v);
	                },
	                onBlur: _utilities.noop,
	                disabled: fieldsDisabled
	              })
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'flex-row checkbox-padding' },
	              _react2.default.createElement(_Form.Checkbox, {
	                fieldId: fieldId + '-efs',
	                label: 'Include Effective financing statements (EFS) pertaining to farm products',
	                value: value.search.SEARCH_EFS,
	                onChange: function onChange(v) {
	                  return _this2.setByKey('SEARCH_EFS', v);
	                },
	                onBlur: _utilities.noop,
	                disabled: fieldsDisabled
	              })
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'flex-row checkbox-padding' },
	              _react2.default.createElement(_Form.Checkbox, {
	                fieldId: fieldId + '-crop-lien',
	                label: 'Include liens in crops, for seed or farm labor',
	                value: value.search.SEARCH_CROP_LIEN,
	                onChange: function onChange(v) {
	                  return _this2.setByKey('SEARCH_CROP_LIEN', v);
	                },
	                onBlur: _utilities.noop,
	                disabled: fieldsDisabled
	              })
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'flex-row checkbox-padding' },
	              _react2.default.createElement(_Form.Checkbox, {
	                fieldId: fieldId + '-ag-lien',
	                label: 'Include liens on agricultural products, after sale/delivery to purchasers',
	                value: value.search.SEARCH_AG_LIEN,
	                onChange: function onChange(v) {
	                  return _this2.setByKey('SEARCH_AG_LIEN', v);
	                },
	                onBlur: _utilities.noop,
	                disabled: fieldsDisabled
	              })
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'flex-row button-row' },
	            !fieldsDisabled && _react2.default.createElement(
	              'button',
	              {
	                className: 'btn btn-primary btn-raised search-button',
	                onClick: this.search,
	                disabled: !this.getCanSearch()
	              },
	              _react2.default.createElement(_searchHeavy2.default, null),
	              ' \xA0 ',
	              '' + (this.state.searching ? 'Searching' : 'Search'),
	              ' \xA0'
	            )
	          ),
	          (this.state.modalOpen || this.state.renderHeadlessModal) && _react2.default.createElement(ResultsModal, {
	            template: this.state.template,
	            rows: this.state.rows,
	            onRequestClose: function onRequestClose() {
	              _this2.setState({ modalOpen: false });
	            },
	            onConfirm: this.onConfirm,
	            ref: function ref(r) {
	              return _this2.resultsModal = r;
	            },
	            headless: this.state.renderHeadlessModal
	          }),
	          value.cache && _react2.default.createElement(
	            'div',
	            { className: 'ucc-result' },
	            _react2.default.createElement(
	              'table',
	              { className: 'styled-table cache-table' },
	              _react2.default.createElement(
	                'thead',
	                null,
	                _react2.default.createElement(
	                  'tr',
	                  null,
	                  value.cache.template.map(function (_ref3, i) {
	                    var label = _ref3.label;
	                    return _react2.default.createElement(
	                      'th',
	                      { key: i },
	                      label
	                    );
	                  })
	                )
	              ),
	              _react2.default.createElement(
	                'tbody',
	                null,
	                value.cache.rows.map(function (row, i) {
	                  return _react2.default.createElement(
	                    'tr',
	                    { key: i },
	                    row.map(function (cell, i) {
	                      return _react2.default.createElement(
	                        'td',
	                        { key: i },
	                        cell
	                      );
	                    })
	                  );
	                })
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return UCCSearch;
	}(_react2.default.Component);
	
	exports.default = (0, _reactRedux.connect)(null, {
	  setErrorToast: _actions.setErrorToast
	})(UCCSearch);
	
	var ResultsModal = function (_React$Component2) {
	  _inherits(ResultsModal, _React$Component2);
	
	  function ResultsModal() {
	    var _ref4;
	
	    var _temp2, _this3, _ret2;
	
	    _classCallCheck(this, ResultsModal);
	
	    for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
	      args[_key2] = arguments[_key2];
	    }
	
	    return _ret2 = (_temp2 = (_this3 = _possibleConstructorReturn(this, (_ref4 = ResultsModal.__proto__ || Object.getPrototypeOf(ResultsModal)).call.apply(_ref4, [this].concat(args))), _this3), _this3.state = {
	      checked: _this3.props.rows.reduce(function (obj, _, i) {
	        return Object.assign({}, obj, _defineProperty({}, i, true));
	      }, {}),
	      checkedCount: _this3.props.rows.length,
	      error: null
	    }, _this3.submitValid = function () {
	      // If we get results from the search, users MUST select one or more.
	      if (_this3.props.rows.length > 0 && _this3.state.checkedCount > 0) {
	        return true;
	        // If the search returns no results, it should be considered valid.
	      } else if (_this3.props.rows.length == 0 && _this3.state.checkedCount == 0) {
	        return true;
	      } else return false;
	    }, _this3.setChecked = function (val, i) {
	      var countChange = 0;
	      if (!_this3.state.checked[i] && val) {
	        countChange = 1;
	      } else if (_this3.state.checked[i] && !val) {
	        countChange = -1;
	      }
	      _this3.setState(function (state) {
	        return {
	          checked: Object.assign({}, state.checked, _defineProperty({}, i, val)),
	          checkedCount: state.checkedCount + countChange,
	          error: null
	        };
	      });
	    }, _this3.uncheckAll = function () {
	      _this3.setState({
	        checked: _this3.props.rows.reduce(function (obj, _, i) {
	          return Object.assign({}, obj, _defineProperty({}, i, false));
	        }, {}),
	        checkedCount: 0,
	        error: null
	      });
	    }, _this3.checkAll = function () {
	      _this3.setState({
	        checked: _this3.props.rows.reduce(function (obj, _, i) {
	          return Object.assign({}, obj, _defineProperty({}, i, true));
	        }, {}),
	        checkedCount: _this3.props.rows.length,
	        error: null
	      });
	    }, _this3.triggerConfirm = function () {
	      return _this3.onConfirm();
	    }, _this3.onConfirm = function (callback) {
	      if (!_this3.submitValid()) {
	        _this3.setState({ error: 'You must select at least one record to continue.' });
	        return;
	      } else {
	        _this3.setState({ error: null });
	      }
	      _this3.props.onConfirm({
	        cache: {
	          template: _this3.props.template,
	          rows: _this3.props.rows.filter(function (row, i) {
	            return _this3.state.checked[i];
	          })
	        },
	        indexes: Object.keys(_this3.state.checked).reduce(function (arr, i) {
	          if (_this3.state.checked[i]) {
	            return [].concat(_toConsumableArray(arr), [i]);
	          } else {
	            return arr;
	          }
	        }, [])
	      });
	      if (callback) {
	        callback();
	      }
	    }, _temp2), _possibleConstructorReturn(_this3, _ret2);
	  }
	
	  _createClass(ResultsModal, [{
	    key: 'render',
	    value: function render() {
	      var _this4 = this;
	
	      var _props2 = this.props,
	          onRequestClose = _props2.onRequestClose,
	          rows = _props2.rows,
	          template = _props2.template,
	          headless = _props2.headless;
	
	      return _react2.default.createElement(
	        _Portal2.default,
	        { isOpened: headless ? false : true },
	        _react2.default.createElement(
	          _Modal.Modal,
	          { modalSize: 'large', title: 'UCC Documents', closeModal: onRequestClose, closeButton: true },
	          function (_ref5) {
	            var closeModal = _ref5.closeModal;
	            return _react2.default.createElement(
	              _react2.default.Fragment,
	              null,
	              _react2.default.createElement(
	                'div',
	                { className: 'scrollable ucc-scrollable' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'ucc-search-modal' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'button-wrapper' },
	                    _react2.default.createElement(
	                      'button',
	                      { className: 'btn btn-secondary', onClick: _this4.uncheckAll },
	                      'Uncheck all'
	                    ),
	                    _react2.default.createElement(
	                      'button',
	                      { className: 'btn btn-secondary', onClick: _this4.checkAll },
	                      'Check all'
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'table',
	                    { className: 'form-table' },
	                    _react2.default.createElement(
	                      'thead',
	                      null,
	                      _react2.default.createElement(
	                        'tr',
	                        null,
	                        _react2.default.createElement('th', null),
	                        template.map(function (_ref6, i) {
	                          var label = _ref6.label;
	                          return _react2.default.createElement(
	                            'th',
	                            { key: i },
	                            label
	                          );
	                        })
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'tbody',
	                      null,
	                      rows.map(function (row, i) {
	                        return _react2.default.createElement(
	                          'tr',
	                          {
	                            className: 'clickable wizard ' + (_this4.state.checked[i] ? 'checked' : 'unchecked'),
	                            onClick: function onClick() {
	                              return _this4.setChecked(!_this4.state.checked[i], i);
	                            },
	                            key: i
	                          },
	                          _react2.default.createElement(
	                            'td',
	                            null,
	                            _react2.default.createElement(_Form.Checkbox, {
	                              value: _this4.state.checked[i],
	                              onChange: function onChange(val) {
	                                return _this4.setChecked(val, i);
	                              }
	                            })
	                          ),
	                          row.map(function (cell, i) {
	                            return _react2.default.createElement(
	                              'td',
	                              { key: i },
	                              cell
	                            );
	                          })
	                        );
	                      })
	                    )
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'ucc-toolbar' },
	                _react2.default.createElement(
	                  'button',
	                  {
	                    'aria-invalid': _this4.state.error ? true : '',
	                    className: 'btn btn-secondary',
	                    id: 'ucc-doc-submit',
	                    onClick: function onClick() {
	                      _this4.onConfirm(closeModal, _this4.setError);
	                    }
	                  },
	                  'Confirm'
	                ),
	                _react2.default.createElement(_HelpTooltip.HelpTooltip, { ariaDescribedBy: 'ucc-doc-submit', message: _this4.state.error })
	              )
	            );
	          }
	        )
	      );
	    }
	  }]);
	
	  return ResultsModal;
	}(_react2.default.Component);
	
	var UCCSearchDisplay = exports.UCCSearchDisplay = function UCCSearchDisplay(_ref7) {
	  var uccMode = _ref7.uccMode,
	      value = _ref7.value,
	      disabled = _ref7.disabled;
	
	  var individualOrg = {
	    label: 'Individual or Organization:',
	    value: value.IS_ORG ? 'Organization' : 'Individual'
	  };
	  var cells = [{
	    label: UCC_SEARCH_ALLOW_SEARCH_TYPE ? 'Request Type:' : 'Search Type:',
	    value: value.SEARCH_REQUEST_TYPE === 'LIST_ONLY' ? 'Search request only' : 'Both search and copy request'
	  }, UCC_SEARCH_ALLOW_SEARCH_TYPE ? {
	    label: 'Search Type:',
	    value: value.SEARCH_TYPE === 'DEBTOR' ? 'Debtor Search' : value.SEARCH_TYPE === 'SECURED_PARTY' ? 'Secured Party Search' : value.SEARCH_TYPE === 'UCC_NUM' ? 'File Number Search' : value.SEARCH_TYPE
	  } : null].concat(_toConsumableArray((UCC_SEARCH_ALLOW_SEARCH_TYPE ? value.SEARCH_TYPE === 'DEBTOR' || value.SEARCH_TYPE === 'SECURED_PARTY' : true) ? value.IS_ORG === true || value.IS_ORG === 'true' ? [individualOrg, { label: 'Organization name:', value: value.SEARCH_ORG_NAME }] : [individualOrg, {
	    label: 'Individual Name:',
	    value: _react2.default.createElement(_Form.FullNameDisplay, {
	      value: {
	        FIRST_NAME: value.SEARCH_FIRST_NAME,
	        MIDDLE_NAME: value.SEARCH_MIDDLE_NAME,
	        LAST_NAME: value.SEARCH_LAST_NAME,
	        SUFFIX: value.SEARCH_SUFFIX
	      }
	    })
	  }] : [{
	    label: 'File Number:',
	    value: value.SEARCH_UCC_NUM
	  }]), [UCC_SEARCH_ALLOW_SEARCH_TYPE && value.SEARCH_TYPE === 'UCC_NUM' ? null : {
	    label: 'City:',
	    value: value.SEARCH_CITY
	  }, UCC_SEARCH_ALLOW_SEARCH_TYPE && value.SEARCH_TYPE === 'UCC_NUM' ? null : {
	    label: 'State:',
	    value: value.SEARCH_STATE
	  }, UCC_SEARCH_ALLOW_START_DATE ? {
	    label: "Start Date:",
	    value: value.BEGIN_DATE ? (0, _format2.default)(new Date(value.BEGIN_DATE), 'MM/dd/yyyy') : value.BEGIN_DATE
	  } : null, {
	    label: 'Include lapsed filings on search response:',
	    value: value.SEARCH_LAPSED ? 'Yes' : 'No'
	  }], _toConsumableArray(uccMode.toString() === '4' ? [{
	    label: 'Include UCC Financing statements:',
	    value: value.SEARCH_UCC ? 'Yes' : 'No'
	  }, {
	    label: 'Include Government Liens:',
	    value: value.SEARCH_GOV ? 'Yes' : 'No'
	  }, {
	    label: 'Include Effective Financing Statements:',
	    value: value.SEARCH_EFS ? 'Yes' : 'No'
	  }, {
	    label: 'Include liens in crops:',
	    value: value.SEARCH_CROP_LIEN ? 'Yes' : 'No'
	  }, {
	    label: 'Include liens on agricultural products:',
	    value: value.SEARCH_AG_LIEN ? 'Yes' : 'No'
	  }] : [])).filter(function (x) {
	    return x !== null;
	  });
	
	  return _react2.default.createElement(
	    'div',
	    { className: 'ucc-search-display' },
	    cells.map(function (cell, i) {
	      return _react2.default.createElement(
	        'div',
	        { className: 'flex-row ucc-summary-row', key: i },
	        _react2.default.createElement(
	          'label',
	          { className: 'ucc-label' },
	          cell.label
	        ),
	        _react2.default.createElement(
	          'span',
	          { className: 'ucc-value' },
	          cell.value
	        )
	      );
	    })
	  );
	};

/***/ },
/* 478 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.engine = undefined;
	
	var _flume = __webpack_require__(117);
	
	var _fieldFlumeConfig = __webpack_require__(146);
	
	var _fieldFlumeConfig2 = _interopRequireDefault(_fieldFlumeConfig);
	
	var _store = __webpack_require__(18);
	
	var _store2 = _interopRequireDefault(_store);
	
	var _isBefore = __webpack_require__(187);
	
	var _isBefore2 = _interopRequireDefault(_isBefore);
	
	var _isAfter = __webpack_require__(186);
	
	var _isAfter2 = _interopRequireDefault(_isAfter);
	
	var _isEqual = __webpack_require__(275);
	
	var _isEqual2 = _interopRequireDefault(_isEqual);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var getFieldById = function getFieldById(fieldId) {
	  var context = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	  var fields = context.fields || _store2.default.getState().wizard.wizard.fields;
	  var field = fields[fieldId];
	  if (field) {
	    if (field.parent.type === 'REPEATER' && !context.isSavingRepeater) {
	      var currentRowIndex = context.currentRepeaterRowIndex || 0;
	      var parentRepeater = fields[field.parent.id];
	      var currentRow = parentRepeater.value[currentRowIndex];
	      if (parentRepeater && currentRow && !context.isRenderingFieldInRepeater) {
	        return Object.assign({}, field, {
	          value: currentRow[field.fieldId]
	        });
	      } else {
	        return field;
	      }
	    } else {
	      return field;
	    }
	  } else {
	    return field;
	  }
	};
	
	var engine = exports.engine = new _flume.RootEngine(_fieldFlumeConfig2.default, function (type, data) {
	  switch (type) {
	    case 'number':
	      return data.number;
	    case 'boolean':
	      return !!data.boolean;
	    case 'string':
	      return data.string;
	    case 'fieldId':
	      return data.fieldId;
	    case 'optionFieldId':
	      return data.optionFieldId;
	    case 'checkboxFieldId':
	      return data.checkboxFieldId;
	    case 'textboxFieldId':
	      return data.textboxFieldId;
	    case 'uploadFieldId':
	      return data.uploadFieldId;
	    case 'uploadAndSubmitFieldId':
	      return data.uploadAndSubmitFieldId;
	    case 'nameQualifiedOrgFieldId':
	      return data.nameQualifiedOrgFieldId;
	    case 'dateFieldId':
	      return data.dateFieldId;
	    case 'entityNameFieldId':
	      return data.entityNameFieldId;
	    case 'repeaterFieldId':
	      return data.repeaterFieldId;
	    case 'formationLocaleFieldId':
	      return data.formationLocaleFieldId;
	    case 'checkboxState':
	      return data.checkboxState;
	    case 'fieldOptionValues':
	      return data.values;
	    case 'businessRules':
	      return data.businessRules;
	    case 'booleanAppSetting':
	      return data.booleanAppSetting;
	    case 'stringAppSetting':
	      return data.stringAppSetting;
	    case 'numberAppSetting':
	      return data.numberAppSetting;
	    case 'globalBoolean':
	      return data.globalBoolean;
	    case 'globalString':
	      return data.globalString;
	    case 'globalNumber':
	      return data.globalNumber;
	    case 'date':
	      return data.date;
	    default:
	      return data;
	  }
	}, function (node, inputValues, nodeType, context) {
	  switch (node.type) {
	    case 'user':
	      var user = _store2.default.getState().auth;
	      return {
	        loggedIn: user.loggedIn,
	        isAdmin: user.USER_GROUP === 'ADMIN' || user.USER_GROUP === 'ADMIN_WEB',
	        firstName: user.FIRST_NAME,
	        lastName: user.LAST_NAME,
	        email: user.USERNAME
	      };
	    case 'number':
	      return { number: inputValues.number };
	    case 'boolean':
	      return { boolean: inputValues.boolean };
	    case 'string':
	      return { string: inputValues.string };
	    case 'date':
	      return { date: inputValues.date };
	    case 'isBeforeDate':
	      if (inputValues.date && inputValues.date.length >= 10 && inputValues.isBeforeDate && inputValues.isBeforeDate.length >= 10) {
	        return {
	          result: (0, _isBefore2.default)(new Date(inputValues.date), new Date(inputValues.isBeforeDate))
	        };
	      } else {
	        return { result: false };
	      }
	    case 'isAfterDate':
	      if (inputValues.date && inputValues.date.length >= 10 && inputValues.isAfterDate && inputValues.isAfterDate.length >= 10) {
	        return { result: (0, _isAfter2.default)(new Date(inputValues.date), new Date(inputValues.isAfterDate)) };
	      } else {
	        return { result: false };
	      }
	    case 'datesEqual':
	      if (inputValues.date1 && inputValues.date1.length >= 10 && inputValues.date2 && inputValues.date2.length >= 10) {
	        return { result: (0, _isEqual2.default)(new Date(inputValues.date1), new Date(inputValues.date2)) };
	      } else {
	        return { result: false };
	      }
	    case 'and':
	      return { result: inputValues.bool1 && inputValues.bool2 };
	    case 'or':
	      return { result: inputValues.bool1 || inputValues.bool2 };
	    case 'reverseBoolean':
	      return { result: !inputValues.boolean };
	    case 'stringSwitch':
	      return { result: inputValues.test ? inputValues.stringIfTrue : inputValues.stringIfFalse };
	    case 'stringJoin':
	      return { result: '' + inputValues.string1 + inputValues.string2 };
	    case 'stringEquals':
	      {
	        var _inputValues$string = inputValues.string1,
	            string1 = _inputValues$string === undefined ? '' : _inputValues$string,
	            _inputValues$string2 = inputValues.string2,
	            string2 = _inputValues$string2 === undefined ? '' : _inputValues$string2;
	
	        return {
	          result: inputValues.caseSensitive ? string1 === string2 : string1.toLowerCase() === string2.toLowerCase()
	        };
	      }
	    case 'stringContains':
	      {
	        var _inputValues$string3 = inputValues.string1,
	            _string = _inputValues$string3 === undefined ? '' : _inputValues$string3,
	            _inputValues$string4 = inputValues.string2,
	            _string2 = _inputValues$string4 === undefined ? '' : _inputValues$string4;
	
	        var result = void 0;
	        if (inputValues.caseSensitive) {
	          result = _string.includes(_string2);
	        } else {
	          result = _string.toLowerCase().includes(_string2.toLowerCase());
	        }
	        return { result: result };
	      }
	    case 'stringRegex':
	      {
	        var _inputValues$string5 = inputValues.string,
	            string = _inputValues$string5 === undefined ? '' : _inputValues$string5,
	            _inputValues$regex = inputValues.regex,
	            regex = _inputValues$regex === undefined ? '' : _inputValues$regex,
	            _inputValues$flags = inputValues.flags,
	            flags = _inputValues$flags === undefined ? '' : _inputValues$flags;
	
	        var rgx = new RegExp(regex, flags);
	        var matches = string.match(rgx);
	        if (matches) {
	          return { result: !!matches.length };
	        } else {
	          return { result: false };
	        }
	      }
	    case 'field':
	      {
	        var fields = context.fields || _store2.default.getState().wizard.wizard.fields;
	        var field = fields[inputValues.fieldId];
	        return field ? resolveLogic(field, fields) : {};
	      }
	    case 'valueEqualsOneOfOptions':
	      {
	        var _field = getFieldById(inputValues.optionFieldId, context);
	        var value = void 0,
	            isMultiComplete = void 0;
	        if (_field) {
	          value = _field.value;
	          isMultiComplete = _field.type === 'MultiComplete' || _field.type === 'ServerMultiComplete';
	        }
	        return {
	          result: isMultiComplete ? value.some(function (v) {
	            return inputValues.fieldOptionValues.includes(v);
	          }) : inputValues.fieldOptionValues.includes(value)
	        };
	      }
	    case 'checkboxIsInState':
	      {
	        var _field2 = getFieldById(inputValues.checkboxFieldId, context);
	        var _value = false;
	        if (_field2) {
	          _value = _field2.value;
	        }
	        return {
	          result: inputValues.checkboxState === 'checked' ? _value === true : _value === false
	        };
	      }
	    case 'textbox':
	      {
	        var _field3 = getFieldById(inputValues.textboxFieldId, context);
	        var output = { value: '', charCount: 0 };
	        if (_field3) {
	          output.value = _field3.value;
	          output.charCount = _field3.value.length;
	        }
	        return output;
	      }
	    case 'uploadAndSubmit':
	      {
	        var _field4 = getFieldById(inputValues.uploadAndSubmitFieldId, context);
	        var _output = { isOnline: false, isMailing: false, isSignatures: false };
	        if (_field4) {
	          _output.isOnline = _field4.value.method === 'online';
	          _output.isMailing = _field4.value.method === 'mail';
	          _output.isSignatures = _field4.value.method === 'signer';
	        }
	        return _output;
	      }
	    case 'file':
	      {
	        var _field5 = getFieldById(inputValues.uploadFieldId, context);
	        var _output2 = { numAttachments: 0 };
	        if (_field5) {
	          _output2.numAttachments = _field5.value.length || 0;
	        }
	        return _output2;
	      }
	    case 'dateInput':
	      {
	        var _field6 = getFieldById(inputValues.dateFieldId, context);
	        return { date: _field6.value };
	      }
	    case 'entityNameField':
	      {
	        var _field7 = getFieldById(inputValues.entityNameFieldId, context);
	        if (_field7) {
	          return {
	            isReserved: _field7.value.reservedYN === 'Y',
	            reservedName: _field7.value.reservedName,
	            entityName: _field7.value.val1,
	            confirmedEntityName: _field7.value.val2,
	            additionalNameNeeded: _field7.value.additionalYN === 'Y',
	            additionalName: _field7.value.additionalName || '',
	            consentNeeded: _field7.value.consentYN === 'Y',
	            numConsents: _field7.value.numConsents ? parseInt(_field7.value.numConsents, 10) : 0
	          };
	        }
	        return {
	          isReserved: false,
	          reservedName: '',
	          entityName: '',
	          confirmedEntityName: '',
	          additionalNameNeeded: false,
	          consentNeeded: false,
	          numConsents: 0
	        };
	      }
	    case 'nameQualifiedOrgField':
	      {
	        var _field8 = getFieldById(inputValues.nameQualifiedOrgFieldId, context);
	        var isIndividual = _field8.value.ORG_TYPE === '0';
	        var isQualifiedOrg = _field8.value.ORG_TYPE === '1';
	        var isUnqualifiedOrg = _field8.value.ORG_TYPE === '2';
	        var _output3 = {
	          isIndividual: isIndividual,
	          firstName: isIndividual ? _field8.value.FIRST_NAME : '',
	          middleName: isIndividual ? _field8.value.MIDDLE_NAME : '',
	          lastName: isIndividual ? _field8.value.LAST_NAME : '',
	          isQualifiedOrg: isQualifiedOrg,
	          hasSelectedQualifiedOrg: isQualifiedOrg ? !!_field8.value.SELECTED : false,
	          isUnqualifiedOrg: isUnqualifiedOrg,
	          unqualifiedOrg: isUnqualifiedOrg ? _field8.value.ORG_NAME : ''
	        };
	        return _output3;
	      }
	    case 'formationLocaleField':
	      {
	        var _field9 = getFieldById(inputValues.formationLocaleFieldId, context);
	        var isStateType = _field9.value.FORMATION_TYPE === 'STATE';
	        var isCountryType = _field9.value.FORMATION_TYPE === 'COUNTRY';
	        var isOtherType = _field9.value.FORMATION_TYPE === 'OTHER';
	        return {
	          isStateType: isStateType,
	          isCountryType: isCountryType,
	          isOtherType: isOtherType,
	          STATE: isStateType ? _field9.value.STATE : '',
	          COUNTRY: isCountryType ? _field9.value.COUNTRY : '',
	          OTHER: isOtherType ? _field9.value.OTHER : ''
	        };
	      }
	    case 'repeater':
	      {
	        var _field10 = getFieldById(inputValues.repeaterFieldId, context);
	        var _output4 = { numRows: 0 };
	        if (_field10) {
	          _output4.numRows = _field10.value.length;
	        }
	        return _output4;
	      }
	    case 'businessRules':
	      {
	        return { businessRules: inputValues.businessRules };
	      }
	    case 'businessRulesSwitch':
	      {
	        return { businessRules: inputValues.test ? inputValues.rules1 : inputValues.rules2 };
	      }
	    case 'booleanAppSetting':
	      {
	        var setting = _store2.default.getState().appSettings[inputValues.booleanAppSetting];
	        return { value: setting ? setting.VALUE : false };
	      }
	    case 'stringAppSetting':
	      {
	        var _setting = _store2.default.getState().appSettings[inputValues.stringAppSetting];
	        return { value: _setting ? _setting.VALUE : '' };
	      }
	    case 'wizardSettings':
	      {
	        var wizard = _store2.default.getState().wizard.wizard;
	        return {
	          title: wizard.title,
	          description: wizard.description,
	          formTitle: wizard.formTitle,
	          feeDescription: wizard.feeDescription
	        };
	      }
	    case 'globalBoolean':
	      {
	        var variable = _store2.default.getState().wizard.wizard.globalVariables.boolean.variables[inputValues.globalBoolean];
	        if (variable !== undefined) {
	          var _value2 = engine.resolveRootNode(variable.nodes).value;
	          return { value: _value2 };
	        }
	        return { value: false };
	      }
	    case 'globalString':
	      {
	        var _variable = _store2.default.getState().wizard.wizard.globalVariables.string.variables[inputValues.globalString];
	        if (_variable !== undefined) {
	          var _value3 = engine.resolveRootNode(_variable.nodes).value;
	          return { value: _value3 };
	        }
	        return { value: '' };
	      }
	    case 'globalNumber':
	      {
	        var _variable2 = _store2.default.getState().wizard.wizard.globalVariables.number.variables[inputValues.globalNumber];
	        if (_variable2 !== undefined) {
	          var _value4 = engine.resolveRootNode(_variable2.nodes).value;
	          return { value: _value4 };
	        }
	        return { value: 0 };
	      }
	    case 'metadataValue':
	      {
	        var meta = _store2.default.getState().wizard.wizard.meta;
	        var _value5 = meta[inputValues.key];
	        return { value: _value5 !== undefined ? _value5 : '' };
	      }
	    case 'addNumbers':
	      {
	        return { result: inputValues.num1 + inputValues.num2 };
	      }
	    case 'subtractNumbers':
	      {
	        return { result: inputValues.num1 - inputValues.num2 };
	      }
	    case 'multiplyNumbers':
	      {
	        return { result: inputValues.num1 * inputValues.num2 };
	      }
	    case 'divideNumbers':
	      {
	        return { result: inputValues.num1 / inputValues.num2 };
	      }
	    case 'greaterThanNumber':
	      {
	        return { result: inputValues.num1 > inputValues.num2 };
	      }
	    case 'lessThanNumber':
	      {
	        return { result: inputValues.num1 < inputValues.num2 };
	      }
	    case 'numbersEqual':
	      {
	        return { result: inputValues.num1 === inputValues.num2 };
	      }
	    case 'numberToString':
	      {
	        return { result: String(inputValues.num) };
	      }
	    case 'stringToNumber':
	      {
	        var number = Number(inputValues.string);
	        var succeeded = !isNaN(number);
	        return { result: succeeded ? number : 0, succeeded: succeeded };
	      }
	    default:
	      return undefined;
	  }
	});
	
	var resolveLogic = function resolveLogic(field, context) {
	  var logic = field.logicNodes;
	  if (Object.keys(logic).length) {
	    var attrs = engine.resolveRootNode(logic, {
	      onlyResolveConnected: true,
	      context: context
	    });
	    return Object.assign({}, field, attrs);
	  } else {
	    return field;
	  }
	};
	
	exports.default = resolveLogic;

/***/ },
/* 479 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var STATIC_FIELD_IDS = exports.STATIC_FIELD_IDS = {
	  SIGNER_EMAIL: '~~SIGNER_EMAIL_FH42JAD8942KDW~~',
	  SIGNER_NAME: '~~SIGNER_NAME_JHEK12LKHK12KJ~~'
	};
	
	var getStaticFields = function getStaticFields(WizardClasses) {
	  var onlyLastNameRequired = ({"NODE_ENV":"production","BUILD_DATE":"2025-08-27T15:15:31.687Z","BUILD_NUMBER":"Not Provided","GIT_VERSION":"v1.3.0-381-ga81e29b08","GIT_COMMIT_HASH":"a81e29b085c9268ffd96c78eb734365802722741","GIT_BRANCH":"beta","PUBLIC_URL":"","STATE_ABBR":"MT","STATE_NAME":"Montana","STATE_ORG_TITLE":"Secretary of State","LOGIN_HEADER_IMG_PATH":"","HOME_IMG_FILENAME":"montana.jpg","FAVICON_FILE_NAME":"favicon.ico","ALLOW_E_SIGN_ON_CORRECTIONS":true,"THIRD_PARTY_SIGNING_ALLOWED":false,"MY_ACCOUNT_SAVE_AND_CLOSE_BUTTON":true,"IE_DEPRECATED_MESSAGE":"Internet Explorer is not supported. Please select a supported browser below to access this website.","ADDITIONAL_ROUTES":{"dataRequests":true,"farmBill":true,"apostille":true,"externalHelp":"https://sosmt.gov/business/help-center/","systemAdministration":[{"title":"Saved Payments","parameter":"saved-payments","componentName":"SavedPayments"}]},"SUBROUTES":[{"label":"Business","component":"Business","parameter":"business","myWorkQueueSearch":false,"sourceTypeId":54,"searchMustHaveOneOf":["FILING_TYPE_ID","STATUS_ID","STATE","search"],"serverWebSearchDescription":true,"serverWorkQueueDescription":true,"serverMyRecordsDescription":true,"searchPlaceholder":"Search by name or filing number (X########)","allowEmptySearchTerm":true,"requestCertificateAlternateLabel":"Request Information","fileAmendmentButtonLabel":"Filing Actions","advancedSearchParameters":[{"type":"radio","name":"QUERY_TYPE_ID","defaultValue":1010,"options":[{"value":1010,"label":"Starts with"},{"value":1011,"label":"Contains"},{"value":1012,"label":" Word Contains"}]},{"type":"serverSelect","name":"FILING_TYPE_ID","optionsSrc":"FILING_TYPES","label":"Entity Type","placeholder":"All","defaultValue":"0"},{"type":"serverSelect","name":"FILING_SUBTYPE_ID","optionsSrc":"FILING_SUBTYPES","label":"Entity Subtype","overrideSubOptionsSrcFromParameterName":"FILING_TYPE_ID","placeholder":"All","defaultValue":"0"},{"type":"serverSelect","name":"STATUS_ID","optionsSrc":"FILING_STATUS_WITHOUT_ALL","label":"Status","placeholder":"All","defaultValue":"0"},{"type":"serverSelect","name":"STATE","optionsSrc":"STATE","label":"State","placeholder":"All","defaultValue":""},{"type":"serverSelect","name":"COUNTY","optionsSrc":"COUNTY_SUBOPTION","label":"County","overrideSubOptionsSrcFromParameterName":"STATE","placeholder":"All","defaultValue":""},{"type":"checkbox","name":"CRA_SEARCH_YN","defaultValue":false,"label":"Search by Registered Agent PID"},{"type":"dateRange","name":"FILING_DATE","label":"Registration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}},{"type":"dateRange","name":"EXPIRATION_DATE","label":"Expiration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}}],"myRecordsFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Active"},{"value":2,"label":"Inactive"},{"value":3,"label":"Pending"}]},{"type":"dateRange","name":"DATE_RANGE","label":"Date range","defaultValue":{"start":null,"end":null}}],"myWorkQueueFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Approved"},{"value":2,"label":"Pending Online Payment"},{"value":3,"label":"Pending Review"},{"value":4,"label":"Needs Correction"},{"value":5,"label":"Rejected"},{"value":6,"label":"Draft"}]},{"type":"dateRange","name":"DATE_RANGE","label":"Date range","defaultValue":{"start":null,"end":null}}]},{"label":"Notary","component":"Notary","parameter":"notary","sourceTypeId":850,"myWorkQueueSearch":false,"allowEmptySearchTerm":true,"requestCertificateAlternateLabel":"Download Certificate","fileAmendmentButtonLabel":"Filing Actions","hideNameRequestCertificate":true,"hideAddressRequestCertificate":true,"hideRecordUserManagment":true,"searchPlaceholder":"Search by name or commission number","searchMustHaveOneOf":["CITY","search","SERVICE_TYPE"],"advancedParametersStartOpen":true,"searchIsSortable":true,"advancedSearchParameters":[{"type":"radio","name":"STARTS_WITH_YN","defaultValue":false,"options":[{"value":true,"label":"Starts with"},{"value":false,"label":"Contains"}]},{"type":"checkbox","name":"ACTIVE_ONLY_YN","defaultValue":true,"label":"Active entities only"},{"type":"text","name":"CITY","defaultValue":"","label":"City"},{"type":"select","name":"SERVICE_TYPE","label":"Special Services Offered","defaultValue":0,"options":[{"value":0,"label":"(N/A)"},{"value":6165,"label":"In-Person Electronic Notarization (IPEN)"},{"value":6166,"label":"Remote Online Notarization (RON)"},{"value":6167,"label":"Mobile Notary Services"},{"value":6168,"label":"Remote Ink Notarization (RIN)"}]}]},{"label":"Apostille","component":"Apostille","parameter":"apostille","sourceTypeId":720,"myRecordsSearch":false,"myWorkQueueSearch":false,"disabled":false,"allowedRoutes":["/forms-manager/","/queue/","/forms/"]},{"label":"Liens","component":"UCC","parameter":"ucc","sourceTypeId":1999,"myRecordsSearch":true,"myWorkQueueSearch":true,"fileAmendmentButtonLabel":"Filing Actions","searchPlaceholder":"Search by name or file number","disabled":false,"serverWebSearchDescription":true,"myRecordsDescription":"","workQueueDescription":"","searchDescription":"","hideRecordUserManagment":true,"searchLiensCheckout":false,"advancedSearchParameters":[{"type":"radio","name":"STARTS_WITH_YN","defaultValue":false,"options":[{"value":true,"label":"Starts with"},{"value":false,"label":"Contains"}]},{"type":"select","name":"STATUS","defaultValue":"ALL","label":"Status","options":[{"value":"ACTIVE_UNLAPSED","label":"Active (unlapsed)"},{"value":"ACTIVE_LAPSED_UNLAPSED","label":"Active (lapsed and unlapsed)"}]},{"type":"text","name":"EXCLUDE_VALUES","label":"Exclude Debtor Names (comma separated list of names to exclude)","defaultValue":""},{"type":"dateRange","name":"FILING_DATE","label":"Financing Statement Date","defaultValue":{"start":null,"end":null}},{"type":"dateRange","name":"LAPSE_DATE","label":"Lapse Date","defaultValue":{"start":null,"end":null}},{"type":"text","name":"CITY","label":"Debtor City","defaultValue":""}],"myRecordsFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Approved"},{"value":2,"label":"Pending Online Payment"},{"value":3,"label":"Pending Review"}]},{"type":"select","name":"TYPE","defaultValue":0,"label":"Lien Type","options":[{"value":0,"label":"All"},{"value":1,"label":"UCC"},{"value":2,"label":"EFS"},{"value":3,"label":"Title 71"}]}],"myWorkQueueFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Approved"},{"value":2,"label":"Pending Online Payment"},{"value":3,"label":"Pending Review"},{"value":4,"label":"Pending Print and Mail"},{"value":5,"label":"Rejected"},{"value":6,"label":"Draft"}]},{"type":"select","name":"TYPE","defaultValue":0,"label":"Lien Type","options":[{"value":0,"label":"All"},{"value":1,"label":"UCC"},{"value":2,"label":"EFS"},{"value":3,"label":"Title 71"}]}]},{"label":"Copy Request","component":"copies","parameter":"copies","sourceTypeId":2001,"myRecordsSearch":false,"myWorkQueueSearch":false,"disabled":false,"allowedRoutes":["/forms-manager/","/queue/","/forms/"]},{"label":"Trademark","component":"Trademark","parameter":"trademark","sourceTypeId":810,"showRequestCertificate":true,"searchMustHaveOneOf":["search","EXPIRATION_DATE","FILING_DATE"],"allowEmptySearchTerm":true,"requestCertificateAlternateLabel":"Request Information","fileAmendmentButtonLabel":"Filing Actions","advancedSearchParameters":[{"type":"radio","name":"QUERY_TYPE_ID","defaultValue":1010,"options":[{"value":1010,"label":"Starts with"},{"value":1011,"label":"Contains"},{"value":1012,"label":" Word Contains"}]},{"type":"checkbox","name":"OWNER_SEARCH_YN","defaultValue":false,"label":"Search owners"},{"type":"radio","name":"SERVICE_MARK_YN","label":"Mark Type","defaultValue":"","options":[{"value":"","label":"All Marks"},{"value":"Y","label":"Service Mark"},{"value":"N","label":"Trademark"}]},{"type":"serverSelect","name":"STATUS_ID","optionsSrc":"TYPE_V|TRADEMARK_STATUS_TYPE","label":"Status","placeholder":"All","defaultValue":"0"},{"type":"select","name":"DESIGN_TYPE_ID","options":[{"value":0,"label":"All"},{"value":990,"label":"Words Only"},{"value":991,"label":"Design Only"},{"value":992,"label":"Words and Design"}],"label":"Design Type","defaultValue":"0"},{"type":"dateRange","name":"FILING_DATE","label":"Registered Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}},{"type":"dateRange","name":"EXPIRATION_DATE","label":"Expiration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}}]},{"label":"Business Info Request","component":"InfoRequests","parameter":"info-request","sourceTypeId":167,"allowedRoutes":["/forms-manager/","/queue/","/forms/"]},{"label":"Data Requests","component":"DataRequests","parameter":"data-request","sourceTypeId":0,"allowedRoutes":["/forms-manager/"]},{"label":"CRA","component":"CRA","parameter":"cra","sourceTypeId":157,"myRecordsSearch":false,"searchPlaceholder":"Search by name or registered agent number","allowedRoutes":["/forms-manager/","/forms/","/records/","/queue/","/search/"],"allowEmptySearchTerm":true,"fileAmendmentButtonLabel":"Filing Actions","advancedSearchParameters":[{"type":"radio","name":"QUERY_TYPE_ID","defaultValue":1010,"options":[{"value":1010,"label":"Starts with"},{"value":1011,"label":"Contains"},{"value":1012,"label":" Word Contains"}]},{"type":"dateRange","name":"CRA_DATE","label":"Registration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}},{"type":"select","name":"STATUS_ID","label":"Status","defaultValue":0,"options":[{"value":0,"label":"All"},{"value":121,"label":"Active"},{"value":122,"label":"Inactive"}]},{"type":"select","name":"AGENT_TYPE_ID","label":"Agent Type","defaultValue":0,"options":[{"value":0,"label":"All"},{"value":460,"label":"Registered Agent"},{"value":461,"label":"Commercial Registered Agent"}]}]},{"label":"Farm Bill","component":"FarmBill","parameter":"farm-bill","path":"/lists/farm-bill","sourceTypeId":0,"myRecordsSearch":false,"allowedRules":["/search/"],"disabled":true,"searchDescription":"To perform a search, enter a debtor name. Your search results may include: exact debtor name, variations of that name and any filing that includes your search criteria. Punctuation is ignored.\n\nYou can click on \"Advanced\" to refine your search. Under “Advanced” you can search by crop, year, county and SSN/FEIN. As a registered Farm Bill Buyer with the Montana Secretary of State’s office it is important to maintain the confidentiality of the information contained within the Farm Bill Master List. The Farm Bill Master List reflects personal data, such as Social Security Numbers, which are a key piece of personal identifiable information to assist you in determining the existence of a lien against a specific debtor. The distribution of this information beyond its intended purpose is strictly prohibited.\n\nThe debtor's tax identification number has been hidden for confidentiality reasons. You may continue to search on a tax ID number and return debtors that match your search criteria. The SSN/FEIN must be entered without dashes or spaces.","searchMustHaveOneOf":["search","UCC_FARM_PRODUCT_ID","COUNTY"],"searchPlaceholder":"Search by debtor name","advancedSearchParameters":[{"type":"ServerMultiComplete","label":"Product code name(s)","name":"UCC_FARM_PRODUCT_ID","defaultValue":"","optionsSrc":"UCC_FARM_PRODUCT_V"},{"type":"MultiComplete","label":"Year or Range of Years","name":"YEAR_NUM","optionsSrc":"years","startYear":"1968","defaultValue":[],"preMergeOptions":[{"value":"ALL","label":"All"}]},{"type":"serverSelect","label":"State","name":"STATE","defaultValue":"MONTANA","optionsSrc":"STATE"},{"type":"ServerMultiComplete","label":"County","name":"COUNTY","defaultValue":[],"optionsSrc":"COUNTY","overrideSubOptionsSrcFromParameterName":"STATE"},{"type":"checkbox","name":"TIN_SEARCH_YN","defaultValue":false,"label":"Tax Identification Number Search"},{"type":"checkbox","name":"TIN_SORT_YN","defaultValue":false,"label":"Unique ID Sort"}]}],"SYSTEM_NICKNAME":"Online Services Portal","PAYMENT_METHODS":[{"type":"bypass"},{"type":"iTransact"}],"PAYMENT_ALLOW_AMEX":true,"SYSTEM_ID_LABEL":"System Id","DOUBLE_COLUMN_PUBLIC_LOGIN":true,"INTERNAL_USER_MANAGEMENT":true,"ALLOW_PUBLIC_JSON_IMPORT":false,"MAX_FILE_UPLOAD_SIZE":10000000,"REFUND_TEXT":"","RETURN_TO_HOME_ON_LOGOUT":true,"CURRENT_SOS_NAME":"Christi Jacobsen","LOGO_FILENAME":"mt-sos-logo.png","LOGO_ALT":"Christi Jacobsen, Montana Secretary of State","LOGO_FULL_WIDTH":true,"HOME_HIDE_AUTH_HINT":true,"HOME_TITLE":"Montana Secretary of State","CUSTOM_TAB_TITLE":"Official Montana","HOME_SUBTITLE":"Online Business Services","ENTITY_NAME_CONSENT_DESCRIPTION":"","ALLOW_USER_PROFILE_EDITING":true,"COMPARE_FOREIGN_NAME_IN_ENTITY_NAME_VALIDATION":true,"FOREIGN_NAME_FIELD_NAME":"KIMA_PARENT_NAME_INFO","LOGIN_TITLE":"Montana Secretary of State Online Filing Portal Login","PUBLIC_LOGIN_LABEL":"Username","REVERSE_LOGIN_COLUMNS":true,"LOGIN_SEAL_FILENAME":"seal_white.png","SEPARATE_USERNAME_AND_EMAIL":true,"CREATE_ACCOUNT_BUTTON_ALIGN_LEFT":true,"CREATE_ACCOUNT_BUTTON_TEXT":"CREATE AN ACCOUNT","PASSWORD_CUSTOM_ERROR_TEXT":"The password must meet all requirements","ACCOUNT_CREATED_MESSAGE":"Please check your email to verify your account to login and allow a few minutes for this message to arrive. Check your junk/spam folders if you do not find the email in your inbox.","PUBLIC_LOGIN_PLACEHOLDER":" ","DISABLE_DEFAULT_PAYMENT_RADIO":true,"CUSTOM_RESET_PASSWORD_ERROR_MESSAGE":"Username invalid - no account found","PUBLIC_LOGIN_CREATE_DESCRIPTION":"### Existing User:\n\n  - Enter your username and password to login.  \n\n\n  #### - OR -  \n\n\n\n  - Forgot password? Click 'Reset Password' and follow the prompts.\n  - Forgot username? Click 'Forgot Username' and follow the prompts.  \n\n\n  ### New User:\n  ","LOGIN_HELP_LINK":"https://sosmt.gov/business/how-do-i/","LOGIN_HELP_LINK_TEXT":"Need Help?","FORGOT_USERNAME_TEXT":"Forgot Username?","LOGIN_ACTIVE_DIRECTORY_TEXT":"State User Login","MULTIPLE_LOGIN_METHODS":true,"HAS_ACTIVE_DIRECTORY_LOGIN":true,"RESET_PASSWORD_WITH_USERNAME":true,"DOWNLOAD_LINK":true,"SHOW_USERNAME_ACCOUNT_CREATE":true,"SHOW_SCROLL_DOWN_ARROW":true,"SHOW_ADDRESS_ACCOUNT_CREATE":true,"TWO_COLUMN_ACCOUNT_CREATE":true,"RESET_PASSWORD_TIP":"A link to change your password has been sent to your email. Please allow a few minutes for this message to arrive. Please check your junk/spam folders if you do not find the email in your inbox.","FORGOT_PASSWORD_LINK_TEXT":"Reset Password","PHONE_NUMBER_OPTIONAL_ACCOUNT_CREATE":true,"SHOW_REQUIRED_INDICATOR_ACCOUNT_CREATE":true,"PASSWORD_REQUIREMENTS_ACCOUNT_CREATE":"\n    <ul>\n      <li>MUST contain at least 8 characters (12+ recommended)</li>\n      <li>MUST contain at least one uppercase letter.</li>\n      <li>MUST contain at least one lowercase letter.</li>\n      <li>MUST contain at least one number.</li>\n      <li>MUST contain at least one special character (!”#$%&'()*+,-./:;<=>?</li>\n    </ul>\n  ","ALLOW_CERTIFICATION_REQUEST":true,"ALLOW_PUBLIC_CERTIFICATE_REQUEST":true,"ALLOW_COPY_REQUEST":false,"ALLOW_CORRECTION_STYLING":true,"HIDE_DEPRECATION_WARNING":false,"AMEND_ROUTE_PUBLIC":true,"SEAL_FILENAME":"seal.png","SHOPPING_CART":true,"ALLOW_PAYMENT_UPDATE_WITH_EMPTY_CART":true,"RA_EMAIL":true,"RA_WEBSITE":true,"RA_NO_DEFAULT_TYPE":true,"RA_ADDRESS_LABEL":"Street Address","RA_TYPE_SELECTION_DEFAULT":true,"RA_DEFAULT_TYPE":"460","RA_OVERRIDE_TYPE_WITH_DEFAULT":true,"RA_PRINCIPAL_ADDRESS_AMS":true,"UPLOAD_AND_SUBMIT_HIDE_IF_ONE_OPTION":true,"PAYMENT_PROCESSING_MESSAGE":"Your payment is processing - Do not close your browser or click the back button","CHECKOUT_BUTTON_WHEN_PROCESSING_TEXT":"Processing","EFS_CROP_PICKER_NONE_LABEL":"Lien Duration","DISALLOWED_WIZARD_PIECES":["FormationLocale"],"REPEATER_SHOW_EDIT_BUTTON":true,"DATA_REQUEST_PAGE_TITLE":"Data Requests and Subscriptions","DATA_REQUEST_SIDEBAR_LABEL":"Data Requests & Subscriptions","LOGIN_REDIRECTS_TO_EPASS":false,"LOGIN_REDIRECTS_TO_ACTIVE_DIRECTORY":true,"LOGIN_ACTIVE_DIRECTORY_LINK":true,"FETCH_EDIT_USER_LINK":false,"LISTS_FETCH_AVAILABLE_LISTS":true,"POST_WIZARD_SUBMIT_REDIRECT_URL":"/","PIN_REQUEST_ATTESTATIONS":true,"PIN_REQUEST_DESCRIPTION":"Click **Request PIN** to have a new PIN sent to the account holder's email address on file.","OWNERSHIP_REQUEST_DESCRIPTION":"To become an **authorized user** of this record, a current **AUTHORIZED USER** will need to grant you access. To request access, click **Request Access** below.","PIN_REQUEST_SUCCESS_MESSAGE":"The PIN you have requested for this entity has been sent to the email associated with your user account.  You should receive the PIN in approximately 3-5 minutes, depending on your email service provider.","APOSTILLE_HEADER_LABEL":"Verification Information","APOSTILLE_NUMBER_LABEL":"Apostille/Authentication","APOSTILLE_CITY_STATE_OVERRIDE":"HELENA, MT","APOSTILLE_FILING_DATE_LABEL":"Issue Date","APOSTILLE_CITY_STATE_IN_CERTIFIED":true,"NOTARY_EXISTING_FILING":true,"ALLOW_REVOKE_OWN_ACCESS_ONLY":false,"HIDE_CANCEL_ON_ONETIME_DATA_REQUESTS":true,"DATA_REQUESTS_IN_SHOPPING_CART":true,"WQ_ALLOW_EDIT_PENDING_PAYMENT":true,"WQ_CONFIRM_ON_DELETE":true,"WQ_DELETE_CONFIRM_MESSAGE":"Deleting this filing will forfeit any money already paid to the Secretary of State. This action is permanent and cannot be undone, are you sure you would like to delete?","PASS_ITEM_GUIDS_ON_CHECKOUT":true,"FORM_REVISION_HISTORY":true,"CHECKOUT_DISCLAIMER":"By entering your credit card and/or checking account information you (i) state that **you are an authorized user** of the credit card and/or electronic check and that the associated information entered (e.g., account holder name, account number, billing address) is accurate, (ii) **you authorize payment processor to charge the amount you have requested** to your credit card and/or funding account, and (iii) **acknowledge if a charge is declined or reversed you may also be assessed a customary charge** by the payment processor for such transactions.","FARM_BILL_SEARCH_CONFIDENTIAL":"As a registered Farm Bill Buyer with the Montana Secretary of State’s office it is important to maintain the confidentiality of the information contained within the Farm Bill Master List. The Farm Bill Master List reflects personal data, such as Social Security Numbers, which are a key piece of personal identifiable information to assist you in determining the existence of a lien against a specific debtor. The distribution of this information beyond its intended purpose is strictly prohibited.\n\n**The debtor's tax identification number has been hidden for confidentiality reasons. You may continue to search on a tax ID number and return debtors that match your search criteria. The SSN/FEIN must be entered without dashes or spaces.  If you need access to the tax identification number to clearly identify the debtor, please contact the UCC unit at (406) 444-3665.**","VIEW_HISTORY_BUTTON_ALT_TEXT":"View Filings","WIZARD_ERROR_TITLE_MESSAGE":"Form Error","FARM_BILL_SEARCH_INTERACTIVE":true,"USE_FARM_BILL_API":true,"DISALLOW_ASSIGN_SELF_AS_RA":true,"DISALLOW_ASSIGN_SELF_AS_PRINCIPAL":true,"USE_TRADEMARK_OWNER_VALIDATION":true,"USE_ALTERNATIVE_FOREIGN_ADDRESS_LABELS":true,"MY_RECEIPTS_FILTER":[{"type":"dateRange","name":"DATE_RANGE","label":"Date range","defaultValue":{"start":null,"end":null}},{"type":"text","name":"REF_NUM","defaultValue":"","label":"Reference Number"},{"type":"text","name":"RECEIPT_NUM","defaultValue":"","label":"Receipt Id"},{"type":"text","name":"AMOUNT","defaultValue":"","label":"Amount"},{"type":"select","name":"TYPE","defaultValue":"","label":"Payment Type","options":[{"value":"","label":"All"},{"value":"CC","label":"Credit Card"},{"value":"Check","label":"Check"}]}],"MY_RECEIPTS_SHOW_IN_SIDEBAR":true,"SHOW_MY_RECEIPTS_HELPER_TEXT":true,"MY_RECEIPTS_HELPER_LABEL":"About Receipt Search","MY_RECEIPTS_HELPER_TEXT":"You can search for receipts based on their descriptions, including the items paid for on the receipt. Use the filters to search for or filter specific information.","FARM_BILL_SUBLINK":{"label":"Farm Bill","component":"FarmBill","parameter":"farm-bill","path":"/lists/farm-bill","sourceTypeId":0,"myRecordsSearch":false,"allowedRules":["/search/"],"disabled":true,"searchDescription":"To perform a search, enter a debtor name. Your search results may include: exact debtor name, variations of that name and any filing that includes your search criteria. Punctuation is ignored.\n\nYou can click on \"Advanced\" to refine your search. Under “Advanced” you can search by crop, year, county and SSN/FEIN. As a registered Farm Bill Buyer with the Montana Secretary of State’s office it is important to maintain the confidentiality of the information contained within the Farm Bill Master List. The Farm Bill Master List reflects personal data, such as Social Security Numbers, which are a key piece of personal identifiable information to assist you in determining the existence of a lien against a specific debtor. The distribution of this information beyond its intended purpose is strictly prohibited.\n\nThe debtor's tax identification number has been hidden for confidentiality reasons. You may continue to search on a tax ID number and return debtors that match your search criteria. The SSN/FEIN must be entered without dashes or spaces.","searchMustHaveOneOf":["search","UCC_FARM_PRODUCT_ID","COUNTY"],"searchPlaceholder":"Search by debtor name","advancedSearchParameters":[{"type":"ServerMultiComplete","label":"Product code name(s)","name":"UCC_FARM_PRODUCT_ID","defaultValue":"","optionsSrc":"UCC_FARM_PRODUCT_V"},{"type":"MultiComplete","label":"Year or Range of Years","name":"YEAR_NUM","optionsSrc":"years","startYear":"1968","defaultValue":[],"preMergeOptions":[{"value":"ALL","label":"All"}]},{"type":"serverSelect","label":"State","name":"STATE","defaultValue":"MONTANA","optionsSrc":"STATE"},{"type":"ServerMultiComplete","label":"County","name":"COUNTY","defaultValue":[],"optionsSrc":"COUNTY","overrideSubOptionsSrcFromParameterName":"STATE"},{"type":"checkbox","name":"TIN_SEARCH_YN","defaultValue":false,"label":"Tax Identification Number Search"},{"type":"checkbox","name":"TIN_SORT_YN","defaultValue":false,"label":"Unique ID Sort"}]},"ALLOW_ADDRESS_VALIDATION_BYPASS_OPTION":true,"DEFAULT_ADDRESS_VALIDATION_BYPASS_OPTION_CHECKED":true}).THIRD_PARTY_SIGNATURE_REQUIRE_LAST_NAME_ONLY;
	  return {
	    SIGNER_EMAIL: new WizardClasses.Field({
	      businessRules: [{ fn: 'isValidEmailFormat', props: {} }, { fn: 'notEmptyOrNull', props: {} }],
	      fieldId: STATIC_FIELD_IDS.SIGNER_EMAIL,
	      name: 'SIGNER_EMAIL',
	      label: "Signer's Email",
	      isStaticField: true,
	      parent: { type: 'STATIC', id: null }
	    }),
	    SIGNER_NAME: new WizardClasses.FullName({
	      businessRules: [{
	        fn: 'nameRequired',
	        props: { onlyLastNameRequired: onlyLastNameRequired }
	      }],
	      fieldId: STATIC_FIELD_IDS.SIGNER_NAME,
	      name: 'SIGNER_NAME',
	      label: "Signer's Name",
	      isStaticField: true,
	      onlyRequireLastName: onlyLastNameRequired,
	      parent: { type: 'STATIC', id: null }
	    })
	  };
	};
	
	exports.default = getStaticFields;

/***/ },
/* 480 */
/***/ function(module, exports) {

	'use strict'
	
	module.exports = alphabetical
	
	// Check if the given character code, or the character code at the first
	// character, is alphabetical.
	function alphabetical(character) {
	  var code = typeof character === 'string' ? character.charCodeAt(0) : character
	
	  return (
	    (code >= 97 && code <= 122) /* a-z */ ||
	    (code >= 65 && code <= 90) /* A-Z */
	  )
	}


/***/ },
/* 481 */
/***/ function(module, exports) {

	var toString = {}.toString;
	
	module.exports = Array.isArray || function (arr) {
	  return toString.call(arr) == '[object Array]';
	};


/***/ },
/* 482 */
/***/ function(module, exports, __webpack_require__) {

	var ListCache = __webpack_require__(201),
	    stackClear = __webpack_require__(1257),
	    stackDelete = __webpack_require__(1258),
	    stackGet = __webpack_require__(1259),
	    stackHas = __webpack_require__(1260),
	    stackSet = __webpack_require__(1261);
	
	/**
	 * Creates a stack cache object to store key-value pairs.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function Stack(entries) {
	  var data = this.__data__ = new ListCache(entries);
	  this.size = data.size;
	}
	
	// Add methods to `Stack`.
	Stack.prototype.clear = stackClear;
	Stack.prototype['delete'] = stackDelete;
	Stack.prototype.get = stackGet;
	Stack.prototype.has = stackHas;
	Stack.prototype.set = stackSet;
	
	module.exports = Stack;


/***/ },
/* 483 */
/***/ function(module, exports) {

	/**
	 * A specialized version of `_.map` for arrays without support for iteratee
	 * shorthands.
	 *
	 * @private
	 * @param {Array} [array] The array to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Array} Returns the new mapped array.
	 */
	function arrayMap(array, iteratee) {
	  var index = -1,
	      length = array == null ? 0 : array.length,
	      result = Array(length);
	
	  while (++index < length) {
	    result[index] = iteratee(array[index], index, array);
	  }
	  return result;
	}
	
	module.exports = arrayMap;


/***/ },
/* 484 */
/***/ function(module, exports, __webpack_require__) {

	var castPath = __webpack_require__(487),
	    toKey = __webpack_require__(206);
	
	/**
	 * The base implementation of `_.get` without support for default values.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {Array|string} path The path of the property to get.
	 * @returns {*} Returns the resolved value.
	 */
	function baseGet(object, path) {
	  path = castPath(path, object);
	
	  var index = 0,
	      length = path.length;
	
	  while (object != null && index < length) {
	    object = object[toKey(path[index++])];
	  }
	  return (index && index == length) ? object : undefined;
	}
	
	module.exports = baseGet;


/***/ },
/* 485 */
/***/ function(module, exports, __webpack_require__) {

	var baseIsEqualDeep = __webpack_require__(1200),
	    isObjectLike = __webpack_require__(123);
	
	/**
	 * The base implementation of `_.isEqual` which supports partial comparisons
	 * and tracks traversed objects.
	 *
	 * @private
	 * @param {*} value The value to compare.
	 * @param {*} other The other value to compare.
	 * @param {boolean} bitmask The bitmask flags.
	 *  1 - Unordered comparison
	 *  2 - Partial comparison
	 * @param {Function} [customizer] The function to customize comparisons.
	 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
	 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	 */
	function baseIsEqual(value, other, bitmask, customizer, stack) {
	  if (value === other) {
	    return true;
	  }
	  if (value == null || other == null || (!isObjectLike(value) && !isObjectLike(other))) {
	    return value !== value && other !== other;
	  }
	  return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
	}
	
	module.exports = baseIsEqual;


/***/ },
/* 486 */
/***/ function(module, exports) {

	/**
	 * The base implementation of `_.unary` without support for storing metadata.
	 *
	 * @private
	 * @param {Function} func The function to cap arguments for.
	 * @returns {Function} Returns the new capped function.
	 */
	function baseUnary(func) {
	  return function(value) {
	    return func(value);
	  };
	}
	
	module.exports = baseUnary;


/***/ },
/* 487 */
/***/ function(module, exports, __webpack_require__) {

	var isArray = __webpack_require__(76),
	    isKey = __webpack_require__(311),
	    stringToPath = __webpack_require__(1262),
	    toString = __webpack_require__(1271);
	
	/**
	 * Casts `value` to a path array if it's not one.
	 *
	 * @private
	 * @param {*} value The value to inspect.
	 * @param {Object} [object] The object to query keys on.
	 * @returns {Array} Returns the cast property path array.
	 */
	function castPath(value, object) {
	  if (isArray(value)) {
	    return value;
	  }
	  return isKey(value, object) ? [value] : stringToPath(toString(value));
	}
	
	module.exports = castPath;


/***/ },
/* 488 */
/***/ function(module, exports, __webpack_require__) {

	var SetCache = __webpack_require__(1187),
	    arraySome = __webpack_require__(1193),
	    cacheHas = __webpack_require__(1215);
	
	/** Used to compose bitmasks for value comparisons. */
	var COMPARE_PARTIAL_FLAG = 1,
	    COMPARE_UNORDERED_FLAG = 2;
	
	/**
	 * A specialized version of `baseIsEqualDeep` for arrays with support for
	 * partial deep comparisons.
	 *
	 * @private
	 * @param {Array} array The array to compare.
	 * @param {Array} other The other array to compare.
	 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	 * @param {Function} customizer The function to customize comparisons.
	 * @param {Function} equalFunc The function to determine equivalents of values.
	 * @param {Object} stack Tracks traversed `array` and `other` objects.
	 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
	 */
	function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
	  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
	      arrLength = array.length,
	      othLength = other.length;
	
	  if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
	    return false;
	  }
	  // Assume cyclic values are equal.
	  var stacked = stack.get(array);
	  if (stacked && stack.get(other)) {
	    return stacked == other;
	  }
	  var index = -1,
	      result = true,
	      seen = (bitmask & COMPARE_UNORDERED_FLAG) ? new SetCache : undefined;
	
	  stack.set(array, other);
	  stack.set(other, array);
	
	  // Ignore non-index properties.
	  while (++index < arrLength) {
	    var arrValue = array[index],
	        othValue = other[index];
	
	    if (customizer) {
	      var compared = isPartial
	        ? customizer(othValue, arrValue, index, other, array, stack)
	        : customizer(arrValue, othValue, index, array, other, stack);
	    }
	    if (compared !== undefined) {
	      if (compared) {
	        continue;
	      }
	      result = false;
	      break;
	    }
	    // Recursively compare arrays (susceptible to call stack limits).
	    if (seen) {
	      if (!arraySome(other, function(othValue, othIndex) {
	            if (!cacheHas(seen, othIndex) &&
	                (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
	              return seen.push(othIndex);
	            }
	          })) {
	        result = false;
	        break;
	      }
	    } else if (!(
	          arrValue === othValue ||
	            equalFunc(arrValue, othValue, bitmask, customizer, stack)
	        )) {
	      result = false;
	      break;
	    }
	  }
	  stack['delete'](array);
	  stack['delete'](other);
	  return result;
	}
	
	module.exports = equalArrays;


/***/ },
/* 489 */
/***/ function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {/** Detect free variable `global` from Node.js. */
	var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;
	
	module.exports = freeGlobal;
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 490 */
/***/ function(module, exports) {

	/** Used as references for various `Number` constants. */
	var MAX_SAFE_INTEGER = 9007199254740991;
	
	/** Used to detect unsigned integer values. */
	var reIsUint = /^(?:0|[1-9]\d*)$/;
	
	/**
	 * Checks if `value` is a valid array-like index.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
	 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
	 */
	function isIndex(value, length) {
	  var type = typeof value;
	  length = length == null ? MAX_SAFE_INTEGER : length;
	
	  return !!length &&
	    (type == 'number' ||
	      (type != 'symbol' && reIsUint.test(value))) &&
	        (value > -1 && value % 1 == 0 && value < length);
	}
	
	module.exports = isIndex;


/***/ },
/* 491 */
/***/ function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(151);
	
	/**
	 * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` if suitable for strict
	 *  equality comparisons, else `false`.
	 */
	function isStrictComparable(value) {
	  return value === value && !isObject(value);
	}
	
	module.exports = isStrictComparable;


/***/ },
/* 492 */
/***/ function(module, exports) {

	/**
	 * A specialized version of `matchesProperty` for source values suitable
	 * for strict equality comparisons, i.e. `===`.
	 *
	 * @private
	 * @param {string} key The key of the property to get.
	 * @param {*} srcValue The value to match.
	 * @returns {Function} Returns the new spec function.
	 */
	function matchesStrictComparable(key, srcValue) {
	  return function(object) {
	    if (object == null) {
	      return false;
	    }
	    return object[key] === srcValue &&
	      (srcValue !== undefined || (key in Object(object)));
	  };
	}
	
	module.exports = matchesStrictComparable;


/***/ },
/* 493 */
/***/ function(module, exports) {

	/**
	 * Creates a unary function that invokes `func` with its argument transformed.
	 *
	 * @private
	 * @param {Function} func The function to wrap.
	 * @param {Function} transform The argument transform.
	 * @returns {Function} Returns the new function.
	 */
	function overArg(func, transform) {
	  return function(arg) {
	    return func(transform(arg));
	  };
	}
	
	module.exports = overArg;


/***/ },
/* 494 */
/***/ function(module, exports) {

	/** Used for built-in method references. */
	var funcProto = Function.prototype;
	
	/** Used to resolve the decompiled source of functions. */
	var funcToString = funcProto.toString;
	
	/**
	 * Converts `func` to its source code.
	 *
	 * @private
	 * @param {Function} func The function to convert.
	 * @returns {string} Returns the source code.
	 */
	function toSource(func) {
	  if (func != null) {
	    try {
	      return funcToString.call(func);
	    } catch (e) {}
	    try {
	      return (func + '');
	    } catch (e) {}
	  }
	  return '';
	}
	
	module.exports = toSource;


/***/ },
/* 495 */
/***/ function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(151),
	    now = __webpack_require__(1266),
	    toNumber = __webpack_require__(1270);
	
	/** Error message constants. */
	var FUNC_ERROR_TEXT = 'Expected a function';
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeMax = Math.max,
	    nativeMin = Math.min;
	
	/**
	 * Creates a debounced function that delays invoking `func` until after `wait`
	 * milliseconds have elapsed since the last time the debounced function was
	 * invoked. The debounced function comes with a `cancel` method to cancel
	 * delayed `func` invocations and a `flush` method to immediately invoke them.
	 * Provide `options` to indicate whether `func` should be invoked on the
	 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
	 * with the last arguments provided to the debounced function. Subsequent
	 * calls to the debounced function return the result of the last `func`
	 * invocation.
	 *
	 * **Note:** If `leading` and `trailing` options are `true`, `func` is
	 * invoked on the trailing edge of the timeout only if the debounced function
	 * is invoked more than once during the `wait` timeout.
	 *
	 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
	 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
	 *
	 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
	 * for details over the differences between `_.debounce` and `_.throttle`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Function
	 * @param {Function} func The function to debounce.
	 * @param {number} [wait=0] The number of milliseconds to delay.
	 * @param {Object} [options={}] The options object.
	 * @param {boolean} [options.leading=false]
	 *  Specify invoking on the leading edge of the timeout.
	 * @param {number} [options.maxWait]
	 *  The maximum time `func` is allowed to be delayed before it's invoked.
	 * @param {boolean} [options.trailing=true]
	 *  Specify invoking on the trailing edge of the timeout.
	 * @returns {Function} Returns the new debounced function.
	 * @example
	 *
	 * // Avoid costly calculations while the window size is in flux.
	 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
	 *
	 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
	 * jQuery(element).on('click', _.debounce(sendMail, 300, {
	 *   'leading': true,
	 *   'trailing': false
	 * }));
	 *
	 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
	 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
	 * var source = new EventSource('/stream');
	 * jQuery(source).on('message', debounced);
	 *
	 * // Cancel the trailing debounced invocation.
	 * jQuery(window).on('popstate', debounced.cancel);
	 */
	function debounce(func, wait, options) {
	  var lastArgs,
	      lastThis,
	      maxWait,
	      result,
	      timerId,
	      lastCallTime,
	      lastInvokeTime = 0,
	      leading = false,
	      maxing = false,
	      trailing = true;
	
	  if (typeof func != 'function') {
	    throw new TypeError(FUNC_ERROR_TEXT);
	  }
	  wait = toNumber(wait) || 0;
	  if (isObject(options)) {
	    leading = !!options.leading;
	    maxing = 'maxWait' in options;
	    maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
	    trailing = 'trailing' in options ? !!options.trailing : trailing;
	  }
	
	  function invokeFunc(time) {
	    var args = lastArgs,
	        thisArg = lastThis;
	
	    lastArgs = lastThis = undefined;
	    lastInvokeTime = time;
	    result = func.apply(thisArg, args);
	    return result;
	  }
	
	  function leadingEdge(time) {
	    // Reset any `maxWait` timer.
	    lastInvokeTime = time;
	    // Start the timer for the trailing edge.
	    timerId = setTimeout(timerExpired, wait);
	    // Invoke the leading edge.
	    return leading ? invokeFunc(time) : result;
	  }
	
	  function remainingWait(time) {
	    var timeSinceLastCall = time - lastCallTime,
	        timeSinceLastInvoke = time - lastInvokeTime,
	        timeWaiting = wait - timeSinceLastCall;
	
	    return maxing
	      ? nativeMin(timeWaiting, maxWait - timeSinceLastInvoke)
	      : timeWaiting;
	  }
	
	  function shouldInvoke(time) {
	    var timeSinceLastCall = time - lastCallTime,
	        timeSinceLastInvoke = time - lastInvokeTime;
	
	    // Either this is the first call, activity has stopped and we're at the
	    // trailing edge, the system time has gone backwards and we're treating
	    // it as the trailing edge, or we've hit the `maxWait` limit.
	    return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
	      (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
	  }
	
	  function timerExpired() {
	    var time = now();
	    if (shouldInvoke(time)) {
	      return trailingEdge(time);
	    }
	    // Restart the timer.
	    timerId = setTimeout(timerExpired, remainingWait(time));
	  }
	
	  function trailingEdge(time) {
	    timerId = undefined;
	
	    // Only invoke if we have `lastArgs` which means `func` has been
	    // debounced at least once.
	    if (trailing && lastArgs) {
	      return invokeFunc(time);
	    }
	    lastArgs = lastThis = undefined;
	    return result;
	  }
	
	  function cancel() {
	    if (timerId !== undefined) {
	      clearTimeout(timerId);
	    }
	    lastInvokeTime = 0;
	    lastArgs = lastCallTime = lastThis = timerId = undefined;
	  }
	
	  function flush() {
	    return timerId === undefined ? result : trailingEdge(now());
	  }
	
	  function debounced() {
	    var time = now(),
	        isInvoking = shouldInvoke(time);
	
	    lastArgs = arguments;
	    lastThis = this;
	    lastCallTime = time;
	
	    if (isInvoking) {
	      if (timerId === undefined) {
	        return leadingEdge(lastCallTime);
	      }
	      if (maxing) {
	        // Handle invocations in a tight loop.
	        clearTimeout(timerId);
	        timerId = setTimeout(timerExpired, wait);
	        return invokeFunc(lastCallTime);
	      }
	    }
	    if (timerId === undefined) {
	      timerId = setTimeout(timerExpired, wait);
	    }
	    return result;
	  }
	  debounced.cancel = cancel;
	  debounced.flush = flush;
	  return debounced;
	}
	
	module.exports = debounce;


/***/ },
/* 496 */
/***/ function(module, exports) {

	/**
	 * Performs a
	 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	 * comparison between two values to determine if they are equivalent.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to compare.
	 * @param {*} other The other value to compare.
	 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	 * @example
	 *
	 * var object = { 'a': 1 };
	 * var other = { 'a': 1 };
	 *
	 * _.eq(object, object);
	 * // => true
	 *
	 * _.eq(object, other);
	 * // => false
	 *
	 * _.eq('a', 'a');
	 * // => true
	 *
	 * _.eq('a', Object('a'));
	 * // => false
	 *
	 * _.eq(NaN, NaN);
	 * // => true
	 */
	function eq(value, other) {
	  return value === other || (value !== value && other !== other);
	}
	
	module.exports = eq;


/***/ },
/* 497 */
/***/ function(module, exports, __webpack_require__) {

	var baseGet = __webpack_require__(484);
	
	/**
	 * Gets the value at `path` of `object`. If the resolved value is
	 * `undefined`, the `defaultValue` is returned in its place.
	 *
	 * @static
	 * @memberOf _
	 * @since 3.7.0
	 * @category Object
	 * @param {Object} object The object to query.
	 * @param {Array|string} path The path of the property to get.
	 * @param {*} [defaultValue] The value returned for `undefined` resolved values.
	 * @returns {*} Returns the resolved value.
	 * @example
	 *
	 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
	 *
	 * _.get(object, 'a[0].b.c');
	 * // => 3
	 *
	 * _.get(object, ['a', '0', 'b', 'c']);
	 * // => 3
	 *
	 * _.get(object, 'a.b.c', 'default');
	 * // => 'default'
	 */
	function get(object, path, defaultValue) {
	  var result = object == null ? undefined : baseGet(object, path);
	  return result === undefined ? defaultValue : result;
	}
	
	module.exports = get;


/***/ },
/* 498 */
/***/ function(module, exports) {

	/**
	 * This method returns the first argument it receives.
	 *
	 * @static
	 * @since 0.1.0
	 * @memberOf _
	 * @category Util
	 * @param {*} value Any value.
	 * @returns {*} Returns `value`.
	 * @example
	 *
	 * var object = { 'a': 1 };
	 *
	 * console.log(_.identity(object) === object);
	 * // => true
	 */
	function identity(value) {
	  return value;
	}
	
	module.exports = identity;


/***/ },
/* 499 */
/***/ function(module, exports, __webpack_require__) {

	var baseIsArguments = __webpack_require__(1199),
	    isObjectLike = __webpack_require__(123);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/** Built-in value references. */
	var propertyIsEnumerable = objectProto.propertyIsEnumerable;
	
	/**
	 * Checks if `value` is likely an `arguments` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
	 *  else `false`.
	 * @example
	 *
	 * _.isArguments(function() { return arguments; }());
	 * // => true
	 *
	 * _.isArguments([1, 2, 3]);
	 * // => false
	 */
	var isArguments = baseIsArguments(function() { return arguments; }()) ? baseIsArguments : function(value) {
	  return isObjectLike(value) && hasOwnProperty.call(value, 'callee') &&
	    !propertyIsEnumerable.call(value, 'callee');
	};
	
	module.exports = isArguments;


/***/ },
/* 500 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var root = __webpack_require__(69),
	    stubFalse = __webpack_require__(1269);
	
	/** Detect free variable `exports`. */
	var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;
	
	/** Detect free variable `module`. */
	var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;
	
	/** Detect the popular CommonJS extension `module.exports`. */
	var moduleExports = freeModule && freeModule.exports === freeExports;
	
	/** Built-in value references. */
	var Buffer = moduleExports ? root.Buffer : undefined;
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined;
	
	/**
	 * Checks if `value` is a buffer.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.3.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
	 * @example
	 *
	 * _.isBuffer(new Buffer(2));
	 * // => true
	 *
	 * _.isBuffer(new Uint8Array(2));
	 * // => false
	 */
	var isBuffer = nativeIsBuffer || stubFalse;
	
	module.exports = isBuffer;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(154)(module)))

/***/ },
/* 501 */
/***/ function(module, exports, __webpack_require__) {

	var baseGetTag = __webpack_require__(121),
	    isObject = __webpack_require__(151);
	
	/** `Object#toString` result references. */
	var asyncTag = '[object AsyncFunction]',
	    funcTag = '[object Function]',
	    genTag = '[object GeneratorFunction]',
	    proxyTag = '[object Proxy]';
	
	/**
	 * Checks if `value` is classified as a `Function` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
	 * @example
	 *
	 * _.isFunction(_);
	 * // => true
	 *
	 * _.isFunction(/abc/);
	 * // => false
	 */
	function isFunction(value) {
	  if (!isObject(value)) {
	    return false;
	  }
	  // The use of `Object#toString` avoids issues with the `typeof` operator
	  // in Safari 9 which returns 'object' for typed arrays and other constructors.
	  var tag = baseGetTag(value);
	  return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
	}
	
	module.exports = isFunction;


/***/ },
/* 502 */
/***/ function(module, exports, __webpack_require__) {

	var baseGetTag = __webpack_require__(121),
	    getPrototype = __webpack_require__(1225),
	    isObjectLike = __webpack_require__(123);
	
	/** `Object#toString` result references. */
	var objectTag = '[object Object]';
	
	/** Used for built-in method references. */
	var funcProto = Function.prototype,
	    objectProto = Object.prototype;
	
	/** Used to resolve the decompiled source of functions. */
	var funcToString = funcProto.toString;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/** Used to infer the `Object` constructor. */
	var objectCtorString = funcToString.call(Object);
	
	/**
	 * Checks if `value` is a plain object, that is, an object created by the
	 * `Object` constructor or one with a `[[Prototype]]` of `null`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.8.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
	 * @example
	 *
	 * function Foo() {
	 *   this.a = 1;
	 * }
	 *
	 * _.isPlainObject(new Foo);
	 * // => false
	 *
	 * _.isPlainObject([1, 2, 3]);
	 * // => false
	 *
	 * _.isPlainObject({ 'x': 0, 'y': 0 });
	 * // => true
	 *
	 * _.isPlainObject(Object.create(null));
	 * // => true
	 */
	function isPlainObject(value) {
	  if (!isObjectLike(value) || baseGetTag(value) != objectTag) {
	    return false;
	  }
	  var proto = getPrototype(value);
	  if (proto === null) {
	    return true;
	  }
	  var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
	  return typeof Ctor == 'function' && Ctor instanceof Ctor &&
	    funcToString.call(Ctor) == objectCtorString;
	}
	
	module.exports = isPlainObject;


/***/ },
/* 503 */
/***/ function(module, exports, __webpack_require__) {

	var baseIsTypedArray = __webpack_require__(1203),
	    baseUnary = __webpack_require__(486),
	    nodeUtil = __webpack_require__(1252);
	
	/* Node.js helper references. */
	var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;
	
	/**
	 * Checks if `value` is classified as a typed array.
	 *
	 * @static
	 * @memberOf _
	 * @since 3.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
	 * @example
	 *
	 * _.isTypedArray(new Uint8Array);
	 * // => true
	 *
	 * _.isTypedArray([]);
	 * // => false
	 */
	var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;
	
	module.exports = isTypedArray;


/***/ },
/* 504 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var slice = Array.prototype.slice;
	var isArgs = __webpack_require__(505);
	
	var origKeys = Object.keys;
	var keysShim = origKeys ? function keys(o) { return origKeys(o); } : __webpack_require__(1278);
	
	var originalKeys = Object.keys;
	
	keysShim.shim = function shimObjectKeys() {
		if (Object.keys) {
			var keysWorksWithArguments = (function () {
				// Safari 5.0 bug
				var args = Object.keys(arguments);
				return args && args.length === arguments.length;
			}(1, 2));
			if (!keysWorksWithArguments) {
				Object.keys = function keys(object) { // eslint-disable-line func-name-matching
					if (isArgs(object)) {
						return originalKeys(slice.call(object));
					}
					return originalKeys(object);
				};
			}
		} else {
			Object.keys = keysShim;
		}
		return Object.keys || keysShim;
	};
	
	module.exports = keysShim;


/***/ },
/* 505 */
/***/ function(module, exports) {

	'use strict';
	
	var toStr = Object.prototype.toString;
	
	module.exports = function isArguments(value) {
		var str = toStr.call(value);
		var isArgs = str === '[object Arguments]';
		if (!isArgs) {
			isArgs = str !== '[object Array]' &&
				value !== null &&
				typeof value === 'object' &&
				typeof value.length === 'number' &&
				value.length >= 0 &&
				toStr.call(value.callee) === '[object Function]';
		}
		return isArgs;
	};


/***/ },
/* 506 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.
	
	// resolves . and .. elements in a path array with directory names there
	// must be no slashes, empty elements, or device names (c:\) in the array
	// (so also no leading and trailing slashes - it does not distinguish
	// relative and absolute paths)
	function normalizeArray(parts, allowAboveRoot) {
	  // if the path tries to go above the root, `up` ends up > 0
	  var up = 0;
	  for (var i = parts.length - 1; i >= 0; i--) {
	    var last = parts[i];
	    if (last === '.') {
	      parts.splice(i, 1);
	    } else if (last === '..') {
	      parts.splice(i, 1);
	      up++;
	    } else if (up) {
	      parts.splice(i, 1);
	      up--;
	    }
	  }
	
	  // if the path is allowed to go above the root, restore leading ..s
	  if (allowAboveRoot) {
	    for (; up--; up) {
	      parts.unshift('..');
	    }
	  }
	
	  return parts;
	}
	
	// Split a filename into [root, dir, basename, ext], unix version
	// 'root' is just a slash, or nothing.
	var splitPathRe =
	    /^(\/?|)([\s\S]*?)((?:\.{1,2}|[^\/]+?|)(\.[^.\/]*|))(?:[\/]*)$/;
	var splitPath = function(filename) {
	  return splitPathRe.exec(filename).slice(1);
	};
	
	// path.resolve([from ...], to)
	// posix version
	exports.resolve = function() {
	  var resolvedPath = '',
	      resolvedAbsolute = false;
	
	  for (var i = arguments.length - 1; i >= -1 && !resolvedAbsolute; i--) {
	    var path = (i >= 0) ? arguments[i] : process.cwd();
	
	    // Skip empty and invalid entries
	    if (typeof path !== 'string') {
	      throw new TypeError('Arguments to path.resolve must be strings');
	    } else if (!path) {
	      continue;
	    }
	
	    resolvedPath = path + '/' + resolvedPath;
	    resolvedAbsolute = path.charAt(0) === '/';
	  }
	
	  // At this point the path should be resolved to a full absolute path, but
	  // handle relative paths to be safe (might happen when process.cwd() fails)
	
	  // Normalize the path
	  resolvedPath = normalizeArray(filter(resolvedPath.split('/'), function(p) {
	    return !!p;
	  }), !resolvedAbsolute).join('/');
	
	  return ((resolvedAbsolute ? '/' : '') + resolvedPath) || '.';
	};
	
	// path.normalize(path)
	// posix version
	exports.normalize = function(path) {
	  var isAbsolute = exports.isAbsolute(path),
	      trailingSlash = substr(path, -1) === '/';
	
	  // Normalize the path
	  path = normalizeArray(filter(path.split('/'), function(p) {
	    return !!p;
	  }), !isAbsolute).join('/');
	
	  if (!path && !isAbsolute) {
	    path = '.';
	  }
	  if (path && trailingSlash) {
	    path += '/';
	  }
	
	  return (isAbsolute ? '/' : '') + path;
	};
	
	// posix version
	exports.isAbsolute = function(path) {
	  return path.charAt(0) === '/';
	};
	
	// posix version
	exports.join = function() {
	  var paths = Array.prototype.slice.call(arguments, 0);
	  return exports.normalize(filter(paths, function(p, index) {
	    if (typeof p !== 'string') {
	      throw new TypeError('Arguments to path.join must be strings');
	    }
	    return p;
	  }).join('/'));
	};
	
	
	// path.relative(from, to)
	// posix version
	exports.relative = function(from, to) {
	  from = exports.resolve(from).substr(1);
	  to = exports.resolve(to).substr(1);
	
	  function trim(arr) {
	    var start = 0;
	    for (; start < arr.length; start++) {
	      if (arr[start] !== '') break;
	    }
	
	    var end = arr.length - 1;
	    for (; end >= 0; end--) {
	      if (arr[end] !== '') break;
	    }
	
	    if (start > end) return [];
	    return arr.slice(start, end - start + 1);
	  }
	
	  var fromParts = trim(from.split('/'));
	  var toParts = trim(to.split('/'));
	
	  var length = Math.min(fromParts.length, toParts.length);
	  var samePartsLength = length;
	  for (var i = 0; i < length; i++) {
	    if (fromParts[i] !== toParts[i]) {
	      samePartsLength = i;
	      break;
	    }
	  }
	
	  var outputParts = [];
	  for (var i = samePartsLength; i < fromParts.length; i++) {
	    outputParts.push('..');
	  }
	
	  outputParts = outputParts.concat(toParts.slice(samePartsLength));
	
	  return outputParts.join('/');
	};
	
	exports.sep = '/';
	exports.delimiter = ':';
	
	exports.dirname = function(path) {
	  var result = splitPath(path),
	      root = result[0],
	      dir = result[1];
	
	  if (!root && !dir) {
	    // No dirname whatsoever
	    return '.';
	  }
	
	  if (dir) {
	    // It has a dirname, strip trailing slash
	    dir = dir.substr(0, dir.length - 1);
	  }
	
	  return root + dir;
	};
	
	
	exports.basename = function(path, ext) {
	  var f = splitPath(path)[2];
	  // TODO: make this comparison case-insensitive on windows?
	  if (ext && f.substr(-1 * ext.length) === ext) {
	    f = f.substr(0, f.length - ext.length);
	  }
	  return f;
	};
	
	
	exports.extname = function(path) {
	  return splitPath(path)[3];
	};
	
	function filter (xs, f) {
	    if (xs.filter) return xs.filter(f);
	    var res = [];
	    for (var i = 0; i < xs.length; i++) {
	        if (f(xs[i], i, xs)) res.push(xs[i]);
	    }
	    return res;
	}
	
	// String.prototype.substr - negative index don't work in IE8
	var substr = 'ab'.substr(-1) === 'b'
	    ? function (str, start, len) { return str.substr(start, len) }
	    : function (str, start, len) {
	        if (start < 0) start = str.length + start;
	        return str.substr(start, len);
	    }
	;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(77)))

/***/ },
/* 507 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var asap = __webpack_require__(609);
	
	function noop() {}
	
	// States:
	//
	// 0 - pending
	// 1 - fulfilled with _value
	// 2 - rejected with _value
	// 3 - adopted the state of another promise, _value
	//
	// once the state is no longer pending (0) it is immutable
	
	// All `_` prefixed properties will be reduced to `_{random number}`
	// at build time to obfuscate them and discourage their use.
	// We don't use symbols or Object.defineProperty to fully hide them
	// because the performance isn't good enough.
	
	
	// to avoid using try/catch inside critical functions, we
	// extract them to here.
	var LAST_ERROR = null;
	var IS_ERROR = {};
	function getThen(obj) {
	  try {
	    return obj.then;
	  } catch (ex) {
	    LAST_ERROR = ex;
	    return IS_ERROR;
	  }
	}
	
	function tryCallOne(fn, a) {
	  try {
	    return fn(a);
	  } catch (ex) {
	    LAST_ERROR = ex;
	    return IS_ERROR;
	  }
	}
	function tryCallTwo(fn, a, b) {
	  try {
	    fn(a, b);
	  } catch (ex) {
	    LAST_ERROR = ex;
	    return IS_ERROR;
	  }
	}
	
	module.exports = Promise;
	
	function Promise(fn) {
	  if (typeof this !== 'object') {
	    throw new TypeError('Promises must be constructed via new');
	  }
	  if (typeof fn !== 'function') {
	    throw new TypeError('not a function');
	  }
	  this._45 = 0;
	  this._81 = 0;
	  this._65 = null;
	  this._54 = null;
	  if (fn === noop) return;
	  doResolve(fn, this);
	}
	Promise._10 = null;
	Promise._97 = null;
	Promise._61 = noop;
	
	Promise.prototype.then = function(onFulfilled, onRejected) {
	  if (this.constructor !== Promise) {
	    return safeThen(this, onFulfilled, onRejected);
	  }
	  var res = new Promise(noop);
	  handle(this, new Handler(onFulfilled, onRejected, res));
	  return res;
	};
	
	function safeThen(self, onFulfilled, onRejected) {
	  return new self.constructor(function (resolve, reject) {
	    var res = new Promise(noop);
	    res.then(resolve, reject);
	    handle(self, new Handler(onFulfilled, onRejected, res));
	  });
	};
	function handle(self, deferred) {
	  while (self._81 === 3) {
	    self = self._65;
	  }
	  if (Promise._10) {
	    Promise._10(self);
	  }
	  if (self._81 === 0) {
	    if (self._45 === 0) {
	      self._45 = 1;
	      self._54 = deferred;
	      return;
	    }
	    if (self._45 === 1) {
	      self._45 = 2;
	      self._54 = [self._54, deferred];
	      return;
	    }
	    self._54.push(deferred);
	    return;
	  }
	  handleResolved(self, deferred);
	}
	
	function handleResolved(self, deferred) {
	  asap(function() {
	    var cb = self._81 === 1 ? deferred.onFulfilled : deferred.onRejected;
	    if (cb === null) {
	      if (self._81 === 1) {
	        resolve(deferred.promise, self._65);
	      } else {
	        reject(deferred.promise, self._65);
	      }
	      return;
	    }
	    var ret = tryCallOne(cb, self._65);
	    if (ret === IS_ERROR) {
	      reject(deferred.promise, LAST_ERROR);
	    } else {
	      resolve(deferred.promise, ret);
	    }
	  });
	}
	function resolve(self, newValue) {
	  // Promise Resolution Procedure: https://github.com/promises-aplus/promises-spec#the-promise-resolution-procedure
	  if (newValue === self) {
	    return reject(
	      self,
	      new TypeError('A promise cannot be resolved with itself.')
	    );
	  }
	  if (
	    newValue &&
	    (typeof newValue === 'object' || typeof newValue === 'function')
	  ) {
	    var then = getThen(newValue);
	    if (then === IS_ERROR) {
	      return reject(self, LAST_ERROR);
	    }
	    if (
	      then === self.then &&
	      newValue instanceof Promise
	    ) {
	      self._81 = 3;
	      self._65 = newValue;
	      finale(self);
	      return;
	    } else if (typeof then === 'function') {
	      doResolve(then.bind(newValue), self);
	      return;
	    }
	  }
	  self._81 = 1;
	  self._65 = newValue;
	  finale(self);
	}
	
	function reject(self, newValue) {
	  self._81 = 2;
	  self._65 = newValue;
	  if (Promise._97) {
	    Promise._97(self, newValue);
	  }
	  finale(self);
	}
	function finale(self) {
	  if (self._45 === 1) {
	    handle(self, self._54);
	    self._54 = null;
	  }
	  if (self._45 === 2) {
	    for (var i = 0; i < self._54.length; i++) {
	      handle(self, self._54[i]);
	    }
	    self._54 = null;
	  }
	}
	
	function Handler(onFulfilled, onRejected, promise){
	  this.onFulfilled = typeof onFulfilled === 'function' ? onFulfilled : null;
	  this.onRejected = typeof onRejected === 'function' ? onRejected : null;
	  this.promise = promise;
	}
	
	/**
	 * Take a potentially misbehaving resolver function and make sure
	 * onFulfilled and onRejected are only called once.
	 *
	 * Makes no guarantees about asynchrony.
	 */
	function doResolve(fn, promise) {
	  var done = false;
	  var res = tryCallTwo(fn, function (value) {
	    if (done) return;
	    done = true;
	    resolve(promise, value);
	  }, function (reason) {
	    if (done) return;
	    done = true;
	    reject(promise, reason);
	  })
	  if (!done && res === IS_ERROR) {
	    done = true;
	    reject(promise, LAST_ERROR);
	  }
	}


/***/ },
/* 508 */
/***/ function(module, exports) {

	exports.__esModule = true;
	var ATTRIBUTE_NAMES = exports.ATTRIBUTE_NAMES = {
	    BODY: "bodyAttributes",
	    HTML: "htmlAttributes",
	    TITLE: "titleAttributes"
	};
	
	var TAG_NAMES = exports.TAG_NAMES = {
	    BASE: "base",
	    BODY: "body",
	    HEAD: "head",
	    HTML: "html",
	    LINK: "link",
	    META: "meta",
	    NOSCRIPT: "noscript",
	    SCRIPT: "script",
	    STYLE: "style",
	    TITLE: "title"
	};
	
	var VALID_TAG_NAMES = exports.VALID_TAG_NAMES = Object.keys(TAG_NAMES).map(function (name) {
	    return TAG_NAMES[name];
	});
	
	var TAG_PROPERTIES = exports.TAG_PROPERTIES = {
	    CHARSET: "charset",
	    CSS_TEXT: "cssText",
	    HREF: "href",
	    HTTPEQUIV: "http-equiv",
	    INNER_HTML: "innerHTML",
	    ITEM_PROP: "itemprop",
	    NAME: "name",
	    PROPERTY: "property",
	    REL: "rel",
	    SRC: "src"
	};
	
	var REACT_TAG_MAP = exports.REACT_TAG_MAP = {
	    accesskey: "accessKey",
	    charset: "charSet",
	    class: "className",
	    contenteditable: "contentEditable",
	    contextmenu: "contextMenu",
	    "http-equiv": "httpEquiv",
	    itemprop: "itemProp",
	    tabindex: "tabIndex"
	};
	
	var HELMET_PROPS = exports.HELMET_PROPS = {
	    DEFAULT_TITLE: "defaultTitle",
	    DEFER: "defer",
	    ENCODE_SPECIAL_CHARACTERS: "encodeSpecialCharacters",
	    ON_CHANGE_CLIENT_STATE: "onChangeClientState",
	    TITLE_TEMPLATE: "titleTemplate"
	};
	
	var HTML_TAG_MAP = exports.HTML_TAG_MAP = Object.keys(REACT_TAG_MAP).reduce(function (obj, key) {
	    obj[REACT_TAG_MAP[key]] = key;
	    return obj;
	}, {});
	
	var SELF_CLOSING_TAGS = exports.SELF_CLOSING_TAGS = [TAG_NAMES.NOSCRIPT, TAG_NAMES.SCRIPT, TAG_NAMES.STYLE];
	
	var HELMET_ATTRIBUTE = exports.HELMET_ATTRIBUTE = "data-react-helmet";

/***/ },
/* 509 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = Label;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(20);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @ignore
	 * @param {Object} props
	 * @param {InputRangeClassNames} props.classNames
	 * @param {Function} props.formatLabel
	 * @param {string} props.type
	 */
	function Label(props) {
	  var labelValue = props.formatLabel ? props.formatLabel(props.children, props.type) : props.children;
	
	  return _react2.default.createElement(
	    'span',
	    { className: props.classNames[props.type + 'Label'] },
	    _react2.default.createElement(
	      'span',
	      { className: props.classNames.labelContainer },
	      labelValue
	    )
	  );
	}
	
	/**
	 * @type {Object}
	 * @property {Function} children
	 * @property {Function} classNames
	 * @property {Function} formatLabel
	 * @property {Function} type
	 */
	Label.propTypes = {
	  children: _propTypes2.default.node.isRequired,
	  classNames: _propTypes2.default.objectOf(_propTypes2.default.string).isRequired,
	  formatLabel: _propTypes2.default.func,
	  type: _propTypes2.default.string.isRequired
	};
	module.exports = exports['default'];
	//# sourceMappingURL=label.js.map

/***/ },
/* 510 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	var xtend = __webpack_require__(79);
	var unified = __webpack_require__(1484);
	var parse = __webpack_require__(1369);
	var PropTypes = __webpack_require__(20);
	var addListMetadata = __webpack_require__(1273);
	var naiveHtml = __webpack_require__(1315);
	var disallowNode = __webpack_require__(1314);
	var astToReact = __webpack_require__(1312);
	var wrapTableRows = __webpack_require__(1318);
	var getDefinitions = __webpack_require__(1313);
	var uriTransformer = __webpack_require__(1317);
	var defaultRenderers = __webpack_require__(1316);
	
	var allTypes = Object.keys(defaultRenderers);
	
	var ReactMarkdown = function ReactMarkdown(props) {
	  var src = props.source || props.children || '';
	
	  if (props.allowedTypes && props.disallowedTypes) {
	    throw new Error('Only one of `allowedTypes` and `disallowedTypes` should be defined');
	  }
	
	  var renderers = xtend(defaultRenderers, props.renderers);
	
	  var plugins = [parse].concat(props.plugins || []);
	  var parser = plugins.reduce(applyParserPlugin, unified());
	
	  var rawAst = parser.parse(src);
	  var renderProps = xtend(props, {
	    renderers: renderers,
	    definitions: getDefinitions(rawAst)
	  });
	
	  var astPlugins = determineAstPlugins(props);
	  var ast = astPlugins.reduce(function (node, plugin) {
	    return plugin(node, renderProps);
	  }, rawAst);
	
	  return astToReact(ast, renderProps);
	};
	
	function applyParserPlugin(parser, plugin) {
	  return Array.isArray(plugin) ? parser.use.apply(parser, _toConsumableArray(plugin)) : parser.use(plugin);
	}
	
	function determineAstPlugins(props) {
	  var plugins = [wrapTableRows, addListMetadata()];
	
	  var disallowedTypes = props.disallowedTypes;
	  if (props.allowedTypes) {
	    disallowedTypes = allTypes.filter(function (type) {
	      return type !== 'root' && props.allowedTypes.indexOf(type) === -1;
	    });
	  }
	
	  var removalMethod = props.unwrapDisallowed ? 'unwrap' : 'remove';
	  if (disallowedTypes && disallowedTypes.length > 0) {
	    plugins.push(disallowNode.ofType(disallowedTypes, removalMethod));
	  }
	
	  if (props.allowNode) {
	    plugins.push(disallowNode.ifNotMatch(props.allowNode, removalMethod));
	  }
	
	  var renderHtml = !props.escapeHtml && !props.skipHtml;
	  if (renderHtml) {
	    plugins.push(naiveHtml);
	  }
	
	  return props.astPlugins ? plugins.concat(props.astPlugins) : plugins;
	}
	
	ReactMarkdown.defaultProps = {
	  renderers: {},
	  escapeHtml: true,
	  skipHtml: false,
	  sourcePos: false,
	  rawSourcePos: false,
	  transformLinkUri: uriTransformer,
	  astPlugins: [],
	  plugins: []
	};
	
	ReactMarkdown.propTypes = {
	  className: PropTypes.string,
	  source: PropTypes.string,
	  children: PropTypes.string,
	  sourcePos: PropTypes.bool,
	  rawSourcePos: PropTypes.bool,
	  escapeHtml: PropTypes.bool,
	  skipHtml: PropTypes.bool,
	  allowNode: PropTypes.func,
	  allowedTypes: PropTypes.arrayOf(PropTypes.oneOf(allTypes)),
	  disallowedTypes: PropTypes.arrayOf(PropTypes.oneOf(allTypes)),
	  transformLinkUri: PropTypes.oneOfType([PropTypes.func, PropTypes.bool]),
	  linkTarget: PropTypes.oneOfType([PropTypes.func, PropTypes.string]),
	  transformImageUri: PropTypes.func,
	  astPlugins: PropTypes.arrayOf(PropTypes.func),
	  unwrapDisallowed: PropTypes.bool,
	  renderers: PropTypes.object,
	  plugins: PropTypes.array
	};
	
	ReactMarkdown.types = allTypes;
	ReactMarkdown.renderers = defaultRenderers;
	ReactMarkdown.uriTransformer = uriTransformer;
	
	module.exports = ReactMarkdown;

/***/ },
/* 511 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.setRef = exports.shallowEqual = exports.safeInvoke = exports.unwrapArray = void 0;
	
	/**
	 * Takes an argument and if it's an array, returns the first item in the array,
	 * otherwise returns the argument. Used for Preact compatibility.
	 */
	var unwrapArray = function unwrapArray(arg) {
	  return Array.isArray(arg) ? arg[0] : arg;
	};
	/**
	 * Takes a maybe-undefined function and arbitrary args and invokes the function
	 * only if it is defined.
	 */
	
	
	exports.unwrapArray = unwrapArray;
	
	var safeInvoke = function safeInvoke(fn) {
	  if (typeof fn === "function") {
	    for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	      args[_key - 1] = arguments[_key];
	    }
	
	    return fn.apply(void 0, args);
	  }
	};
	/**
	 * Does a shallow equality check of two objects by comparing the reference
	 * equality of each value.
	 */
	
	
	exports.safeInvoke = safeInvoke;
	
	var shallowEqual = function shallowEqual(objA, objB) {
	  var aKeys = Object.keys(objA);
	  var bKeys = Object.keys(objB);
	
	  if (bKeys.length !== aKeys.length) {
	    return false;
	  }
	
	  for (var i = 0; i < bKeys.length; i++) {
	    var key = aKeys[i];
	
	    if (objA[key] !== objB[key]) {
	      return false;
	    }
	  }
	
	  return true;
	};
	/**
	 * Sets a ref using either a ref callback or a ref object
	 */
	
	
	exports.shallowEqual = shallowEqual;
	
	var setRef = function setRef(ref, node) {
	  // if its a function call it
	  if (typeof ref === "function") {
	    return safeInvoke(ref, node);
	  } // otherwise we should treat it as a ref object
	  else if (ref != null) {
	      ref.current = node;
	    }
	};
	
	exports.setRef = setRef;

/***/ },
/* 512 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _reactDom = __webpack_require__(70);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _Portal = __webpack_require__(1324);
	
	var _Portal2 = _interopRequireDefault(_Portal);
	
	var _LegacyPortal = __webpack_require__(1323);
	
	var _LegacyPortal2 = _interopRequireDefault(_LegacyPortal);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Portal = void 0;
	
	if (_reactDom2.default.createPortal) {
	  Portal = _Portal2.default;
	} else {
	  Portal = _LegacyPortal2.default;
	}
	
	exports.default = Portal;

/***/ },
/* 513 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(106);
	
	var _interopRequireDefault = __webpack_require__(37);
	
	exports.__esModule = true;
	exports["default"] = connectAdvanced;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(125));
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(157));
	
	var _hoistNonReactStatics = _interopRequireDefault(__webpack_require__(447));
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _reactIs = __webpack_require__(211);
	
	var _Subscription = _interopRequireDefault(__webpack_require__(318));
	
	var _useIsomorphicLayoutEffect = __webpack_require__(519);
	
	var _Context = __webpack_require__(104);
	
	// Define some constant arrays just to avoid re-creating these
	var EMPTY_ARRAY = [];
	var NO_SUBSCRIPTION_ARRAY = [null, null];
	
	var stringifyComponent = function stringifyComponent(Comp) {
	  try {
	    return JSON.stringify(Comp);
	  } catch (err) {
	    return String(Comp);
	  }
	};
	
	function storeStateUpdatesReducer(state, action) {
	  var updateCount = state[1];
	  return [action.payload, updateCount + 1];
	}
	
	function useIsomorphicLayoutEffectWithArgs(effectFunc, effectArgs, dependencies) {
	  (0, _useIsomorphicLayoutEffect.useIsomorphicLayoutEffect)(function () {
	    return effectFunc.apply(void 0, effectArgs);
	  }, dependencies);
	}
	
	function captureWrapperProps(lastWrapperProps, lastChildProps, renderIsScheduled, wrapperProps, actualChildProps, childPropsFromStoreUpdate, notifyNestedSubs) {
	  // We want to capture the wrapper props and child props we used for later comparisons
	  lastWrapperProps.current = wrapperProps;
	  lastChildProps.current = actualChildProps;
	  renderIsScheduled.current = false; // If the render was from a store update, clear out that reference and cascade the subscriber update
	
	  if (childPropsFromStoreUpdate.current) {
	    childPropsFromStoreUpdate.current = null;
	    notifyNestedSubs();
	  }
	}
	
	function subscribeUpdates(shouldHandleStateChanges, store, subscription, childPropsSelector, lastWrapperProps, lastChildProps, renderIsScheduled, childPropsFromStoreUpdate, notifyNestedSubs, forceComponentUpdateDispatch) {
	  // If we're not subscribed to the store, nothing to do here
	  if (!shouldHandleStateChanges) return; // Capture values for checking if and when this component unmounts
	
	  var didUnsubscribe = false;
	  var lastThrownError = null; // We'll run this callback every time a store subscription update propagates to this component
	
	  var checkForUpdates = function checkForUpdates() {
	    if (didUnsubscribe) {
	      // Don't run stale listeners.
	      // Redux doesn't guarantee unsubscriptions happen until next dispatch.
	      return;
	    }
	
	    var latestStoreState = store.getState();
	    var newChildProps, error;
	
	    try {
	      // Actually run the selector with the most recent store state and wrapper props
	      // to determine what the child props should be
	      newChildProps = childPropsSelector(latestStoreState, lastWrapperProps.current);
	    } catch (e) {
	      error = e;
	      lastThrownError = e;
	    }
	
	    if (!error) {
	      lastThrownError = null;
	    } // If the child props haven't changed, nothing to do here - cascade the subscription update
	
	
	    if (newChildProps === lastChildProps.current) {
	      if (!renderIsScheduled.current) {
	        notifyNestedSubs();
	      }
	    } else {
	      // Save references to the new child props.  Note that we track the "child props from store update"
	      // as a ref instead of a useState/useReducer because we need a way to determine if that value has
	      // been processed.  If this went into useState/useReducer, we couldn't clear out the value without
	      // forcing another re-render, which we don't want.
	      lastChildProps.current = newChildProps;
	      childPropsFromStoreUpdate.current = newChildProps;
	      renderIsScheduled.current = true; // If the child props _did_ change (or we caught an error), this wrapper component needs to re-render
	
	      forceComponentUpdateDispatch({
	        type: 'STORE_UPDATED',
	        payload: {
	          error: error
	        }
	      });
	    }
	  }; // Actually subscribe to the nearest connected ancestor (or store)
	
	
	  subscription.onStateChange = checkForUpdates;
	  subscription.trySubscribe(); // Pull data from the store after first render in case the store has
	  // changed since we began.
	
	  checkForUpdates();
	
	  var unsubscribeWrapper = function unsubscribeWrapper() {
	    didUnsubscribe = true;
	    subscription.tryUnsubscribe();
	    subscription.onStateChange = null;
	
	    if (lastThrownError) {
	      // It's possible that we caught an error due to a bad mapState function, but the
	      // parent re-rendered without this component and we're about to unmount.
	      // This shouldn't happen as long as we do top-down subscriptions correctly, but
	      // if we ever do those wrong, this throw will surface the error in our tests.
	      // In that case, throw the error from here so it doesn't get lost.
	      throw lastThrownError;
	    }
	  };
	
	  return unsubscribeWrapper;
	}
	
	var initStateUpdates = function initStateUpdates() {
	  return [null, 0];
	};
	
	function connectAdvanced(
	/*
	  selectorFactory is a func that is responsible for returning the selector function used to
	  compute new props from state, props, and dispatch. For example:
	     export default connectAdvanced((dispatch, options) => (state, props) => ({
	      thing: state.things[props.thingId],
	      saveThing: fields => dispatch(actionCreators.saveThing(props.thingId, fields)),
	    }))(YourComponent)
	   Access to dispatch is provided to the factory so selectorFactories can bind actionCreators
	  outside of their selector as an optimization. Options passed to connectAdvanced are passed to
	  the selectorFactory, along with displayName and WrappedComponent, as the second argument.
	   Note that selectorFactory is responsible for all caching/memoization of inbound and outbound
	  props. Do not use connectAdvanced directly without memoizing results between calls to your
	  selector, otherwise the Connect component will re-render on every state or props change.
	*/
	selectorFactory, // options object:
	_ref) {
	  if (_ref === void 0) {
	    _ref = {};
	  }
	
	  var _ref2 = _ref,
	      _ref2$getDisplayName = _ref2.getDisplayName,
	      getDisplayName = _ref2$getDisplayName === void 0 ? function (name) {
	    return "ConnectAdvanced(" + name + ")";
	  } : _ref2$getDisplayName,
	      _ref2$methodName = _ref2.methodName,
	      methodName = _ref2$methodName === void 0 ? 'connectAdvanced' : _ref2$methodName,
	      _ref2$renderCountProp = _ref2.renderCountProp,
	      renderCountProp = _ref2$renderCountProp === void 0 ? undefined : _ref2$renderCountProp,
	      _ref2$shouldHandleSta = _ref2.shouldHandleStateChanges,
	      shouldHandleStateChanges = _ref2$shouldHandleSta === void 0 ? true : _ref2$shouldHandleSta,
	      _ref2$storeKey = _ref2.storeKey,
	      storeKey = _ref2$storeKey === void 0 ? 'store' : _ref2$storeKey,
	      _ref2$withRef = _ref2.withRef,
	      withRef = _ref2$withRef === void 0 ? false : _ref2$withRef,
	      _ref2$forwardRef = _ref2.forwardRef,
	      forwardRef = _ref2$forwardRef === void 0 ? false : _ref2$forwardRef,
	      _ref2$context = _ref2.context,
	      context = _ref2$context === void 0 ? _Context.ReactReduxContext : _ref2$context,
	      connectOptions = (0, _objectWithoutPropertiesLoose2["default"])(_ref2, ["getDisplayName", "methodName", "renderCountProp", "shouldHandleStateChanges", "storeKey", "withRef", "forwardRef", "context"]);
	
	  if (false) {
	    if (renderCountProp !== undefined) {
	      throw new Error("renderCountProp is removed. render counting is built into the latest React Dev Tools profiling extension");
	    }
	
	    if (withRef) {
	      throw new Error('withRef is removed. To access the wrapped instance, use a ref on the connected component');
	    }
	
	    var customStoreWarningMessage = 'To use a custom Redux store for specific components, create a custom React context with ' + "React.createContext(), and pass the context object to React Redux's Provider and specific components" + ' like: <Provider context={MyContext}><ConnectedComponent context={MyContext} /></Provider>. ' + 'You may also pass a {context : MyContext} option to connect';
	
	    if (storeKey !== 'store') {
	      throw new Error('storeKey has been removed and does not do anything. ' + customStoreWarningMessage);
	    }
	  }
	
	  var Context = context;
	  return function wrapWithConnect(WrappedComponent) {
	    if (false) {
	      throw new Error("You must pass a component to the function returned by " + (methodName + ". Instead received " + stringifyComponent(WrappedComponent)));
	    }
	
	    var wrappedComponentName = WrappedComponent.displayName || WrappedComponent.name || 'Component';
	    var displayName = getDisplayName(wrappedComponentName);
	    var selectorFactoryOptions = (0, _extends2["default"])({}, connectOptions, {
	      getDisplayName: getDisplayName,
	      methodName: methodName,
	      renderCountProp: renderCountProp,
	      shouldHandleStateChanges: shouldHandleStateChanges,
	      storeKey: storeKey,
	      displayName: displayName,
	      wrappedComponentName: wrappedComponentName,
	      WrappedComponent: WrappedComponent
	    });
	    var pure = connectOptions.pure;
	
	    function createChildSelector(store) {
	      return selectorFactory(store.dispatch, selectorFactoryOptions);
	    } // If we aren't running in "pure" mode, we don't want to memoize values.
	    // To avoid conditionally calling hooks, we fall back to a tiny wrapper
	    // that just executes the given callback immediately.
	
	
	    var usePureOnlyMemo = pure ? _react.useMemo : function (callback) {
	      return callback();
	    };
	
	    function ConnectFunction(props) {
	      var _useMemo = (0, _react.useMemo)(function () {
	        // Distinguish between actual "data" props that were passed to the wrapper component,
	        // and values needed to control behavior (forwarded refs, alternate context instances).
	        // To maintain the wrapperProps object reference, memoize this destructuring.
	        var reactReduxForwardedRef = props.reactReduxForwardedRef,
	            wrapperProps = (0, _objectWithoutPropertiesLoose2["default"])(props, ["reactReduxForwardedRef"]);
	        return [props.context, reactReduxForwardedRef, wrapperProps];
	      }, [props]),
	          propsContext = _useMemo[0],
	          reactReduxForwardedRef = _useMemo[1],
	          wrapperProps = _useMemo[2];
	
	      var ContextToUse = (0, _react.useMemo)(function () {
	        // Users may optionally pass in a custom context instance to use instead of our ReactReduxContext.
	        // Memoize the check that determines which context instance we should use.
	        return propsContext && propsContext.Consumer && (0, _reactIs.isContextConsumer)( /*#__PURE__*/_react["default"].createElement(propsContext.Consumer, null)) ? propsContext : Context;
	      }, [propsContext, Context]); // Retrieve the store and ancestor subscription via context, if available
	
	      var contextValue = (0, _react.useContext)(ContextToUse); // The store _must_ exist as either a prop or in context.
	      // We'll check to see if it _looks_ like a Redux store first.
	      // This allows us to pass through a `store` prop that is just a plain value.
	
	      var didStoreComeFromProps = Boolean(props.store) && Boolean(props.store.getState) && Boolean(props.store.dispatch);
	      var didStoreComeFromContext = Boolean(contextValue) && Boolean(contextValue.store);
	
	      if (false) {
	        throw new Error("Could not find \"store\" in the context of " + ("\"" + displayName + "\". Either wrap the root component in a <Provider>, ") + "or pass a custom React context provider to <Provider> and the corresponding " + ("React context consumer to " + displayName + " in connect options."));
	      } // Based on the previous check, one of these must be true
	
	
	      var store = didStoreComeFromProps ? props.store : contextValue.store;
	      var childPropsSelector = (0, _react.useMemo)(function () {
	        // The child props selector needs the store reference as an input.
	        // Re-create this selector whenever the store changes.
	        return createChildSelector(store);
	      }, [store]);
	
	      var _useMemo2 = (0, _react.useMemo)(function () {
	        if (!shouldHandleStateChanges) return NO_SUBSCRIPTION_ARRAY; // This Subscription's source should match where store came from: props vs. context. A component
	        // connected to the store via props shouldn't use subscription from context, or vice versa.
	
	        var subscription = new _Subscription["default"](store, didStoreComeFromProps ? null : contextValue.subscription); // `notifyNestedSubs` is duplicated to handle the case where the component is unmounted in
	        // the middle of the notification loop, where `subscription` will then be null. This can
	        // probably be avoided if Subscription's listeners logic is changed to not call listeners
	        // that have been unsubscribed in the  middle of the notification loop.
	
	        var notifyNestedSubs = subscription.notifyNestedSubs.bind(subscription);
	        return [subscription, notifyNestedSubs];
	      }, [store, didStoreComeFromProps, contextValue]),
	          subscription = _useMemo2[0],
	          notifyNestedSubs = _useMemo2[1]; // Determine what {store, subscription} value should be put into nested context, if necessary,
	      // and memoize that value to avoid unnecessary context updates.
	
	
	      var overriddenContextValue = (0, _react.useMemo)(function () {
	        if (didStoreComeFromProps) {
	          // This component is directly subscribed to a store from props.
	          // We don't want descendants reading from this store - pass down whatever
	          // the existing context value is from the nearest connected ancestor.
	          return contextValue;
	        } // Otherwise, put this component's subscription instance into context, so that
	        // connected descendants won't update until after this component is done
	
	
	        return (0, _extends2["default"])({}, contextValue, {
	          subscription: subscription
	        });
	      }, [didStoreComeFromProps, contextValue, subscription]); // We need to force this wrapper component to re-render whenever a Redux store update
	      // causes a change to the calculated child component props (or we caught an error in mapState)
	
	      var _useReducer = (0, _react.useReducer)(storeStateUpdatesReducer, EMPTY_ARRAY, initStateUpdates),
	          _useReducer$ = _useReducer[0],
	          previousStateUpdateResult = _useReducer$[0],
	          forceComponentUpdateDispatch = _useReducer[1]; // Propagate any mapState/mapDispatch errors upwards
	
	
	      if (previousStateUpdateResult && previousStateUpdateResult.error) {
	        throw previousStateUpdateResult.error;
	      } // Set up refs to coordinate values between the subscription effect and the render logic
	
	
	      var lastChildProps = (0, _react.useRef)();
	      var lastWrapperProps = (0, _react.useRef)(wrapperProps);
	      var childPropsFromStoreUpdate = (0, _react.useRef)();
	      var renderIsScheduled = (0, _react.useRef)(false);
	      var actualChildProps = usePureOnlyMemo(function () {
	        // Tricky logic here:
	        // - This render may have been triggered by a Redux store update that produced new child props
	        // - However, we may have gotten new wrapper props after that
	        // If we have new child props, and the same wrapper props, we know we should use the new child props as-is.
	        // But, if we have new wrapper props, those might change the child props, so we have to recalculate things.
	        // So, we'll use the child props from store update only if the wrapper props are the same as last time.
	        if (childPropsFromStoreUpdate.current && wrapperProps === lastWrapperProps.current) {
	          return childPropsFromStoreUpdate.current;
	        } // TODO We're reading the store directly in render() here. Bad idea?
	        // This will likely cause Bad Things (TM) to happen in Concurrent Mode.
	        // Note that we do this because on renders _not_ caused by store updates, we need the latest store state
	        // to determine what the child props should be.
	
	
	        return childPropsSelector(store.getState(), wrapperProps);
	      }, [store, previousStateUpdateResult, wrapperProps]); // We need this to execute synchronously every time we re-render. However, React warns
	      // about useLayoutEffect in SSR, so we try to detect environment and fall back to
	      // just useEffect instead to avoid the warning, since neither will run anyway.
	
	      useIsomorphicLayoutEffectWithArgs(captureWrapperProps, [lastWrapperProps, lastChildProps, renderIsScheduled, wrapperProps, actualChildProps, childPropsFromStoreUpdate, notifyNestedSubs]); // Our re-subscribe logic only runs when the store/subscription setup changes
	
	      useIsomorphicLayoutEffectWithArgs(subscribeUpdates, [shouldHandleStateChanges, store, subscription, childPropsSelector, lastWrapperProps, lastChildProps, renderIsScheduled, childPropsFromStoreUpdate, notifyNestedSubs, forceComponentUpdateDispatch], [store, subscription, childPropsSelector]); // Now that all that's done, we can finally try to actually render the child component.
	      // We memoize the elements for the rendered child component as an optimization.
	
	      var renderedWrappedComponent = (0, _react.useMemo)(function () {
	        return /*#__PURE__*/_react["default"].createElement(WrappedComponent, (0, _extends2["default"])({}, actualChildProps, {
	          ref: reactReduxForwardedRef
	        }));
	      }, [reactReduxForwardedRef, WrappedComponent, actualChildProps]); // If React sees the exact same element reference as last time, it bails out of re-rendering
	      // that child, same as if it was wrapped in React.memo() or returned false from shouldComponentUpdate.
	
	      var renderedChild = (0, _react.useMemo)(function () {
	        if (shouldHandleStateChanges) {
	          // If this component is subscribed to store updates, we need to pass its own
	          // subscription instance down to our descendants. That means rendering the same
	          // Context instance, and putting a different value into the context.
	          return /*#__PURE__*/_react["default"].createElement(ContextToUse.Provider, {
	            value: overriddenContextValue
	          }, renderedWrappedComponent);
	        }
	
	        return renderedWrappedComponent;
	      }, [ContextToUse, renderedWrappedComponent, overriddenContextValue]);
	      return renderedChild;
	    } // If we're in "pure" mode, ensure our wrapper component only re-renders when incoming props have changed.
	
	
	    var Connect = pure ? _react["default"].memo(ConnectFunction) : ConnectFunction;
	    Connect.WrappedComponent = WrappedComponent;
	    Connect.displayName = displayName;
	
	    if (forwardRef) {
	      var forwarded = _react["default"].forwardRef(function forwardConnectRef(props, ref) {
	        return /*#__PURE__*/_react["default"].createElement(Connect, (0, _extends2["default"])({}, props, {
	          reactReduxForwardedRef: ref
	        }));
	      });
	
	      forwarded.displayName = displayName;
	      forwarded.WrappedComponent = WrappedComponent;
	      return (0, _hoistNonReactStatics["default"])(forwarded, WrappedComponent);
	    }
	
	    return (0, _hoistNonReactStatics["default"])(Connect, WrappedComponent);
	  };
	}

/***/ },
/* 514 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(37);
	
	exports.__esModule = true;
	exports.wrapMapToPropsConstant = wrapMapToPropsConstant;
	exports.getDependsOnOwnProps = getDependsOnOwnProps;
	exports.wrapMapToPropsFunc = wrapMapToPropsFunc;
	
	var _verifyPlainObject = _interopRequireDefault(__webpack_require__(520));
	
	function wrapMapToPropsConstant(getConstant) {
	  return function initConstantSelector(dispatch, options) {
	    var constant = getConstant(dispatch, options);
	
	    function constantSelector() {
	      return constant;
	    }
	
	    constantSelector.dependsOnOwnProps = false;
	    return constantSelector;
	  };
	} // dependsOnOwnProps is used by createMapToPropsProxy to determine whether to pass props as args
	// to the mapToProps function being wrapped. It is also used by makePurePropsSelector to determine
	// whether mapToProps needs to be invoked when props have changed.
	//
	// A length of one signals that mapToProps does not depend on props from the parent component.
	// A length of zero is assumed to mean mapToProps is getting args via arguments or ...args and
	// therefore not reporting its length accurately..
	
	
	function getDependsOnOwnProps(mapToProps) {
	  return mapToProps.dependsOnOwnProps !== null && mapToProps.dependsOnOwnProps !== undefined ? Boolean(mapToProps.dependsOnOwnProps) : mapToProps.length !== 1;
	} // Used by whenMapStateToPropsIsFunction and whenMapDispatchToPropsIsFunction,
	// this function wraps mapToProps in a proxy function which does several things:
	//
	//  * Detects whether the mapToProps function being called depends on props, which
	//    is used by selectorFactory to decide if it should reinvoke on props changes.
	//
	//  * On first call, handles mapToProps if returns another function, and treats that
	//    new function as the true mapToProps for subsequent calls.
	//
	//  * On first call, verifies the first result is a plain object, in order to warn
	//    the developer that their mapToProps function is not returning a valid result.
	//
	
	
	function wrapMapToPropsFunc(mapToProps, methodName) {
	  return function initProxySelector(dispatch, _ref) {
	    var displayName = _ref.displayName;
	
	    var proxy = function mapToPropsProxy(stateOrDispatch, ownProps) {
	      return proxy.dependsOnOwnProps ? proxy.mapToProps(stateOrDispatch, ownProps) : proxy.mapToProps(stateOrDispatch);
	    }; // allow detectFactoryAndVerify to get ownProps
	
	
	    proxy.dependsOnOwnProps = true;
	
	    proxy.mapToProps = function detectFactoryAndVerify(stateOrDispatch, ownProps) {
	      proxy.mapToProps = mapToProps;
	      proxy.dependsOnOwnProps = getDependsOnOwnProps(mapToProps);
	      var props = proxy(stateOrDispatch, ownProps);
	
	      if (typeof props === 'function') {
	        proxy.mapToProps = props;
	        proxy.dependsOnOwnProps = getDependsOnOwnProps(props);
	        props = proxy(stateOrDispatch, ownProps);
	      }
	
	      if (false) (0, _verifyPlainObject["default"])(props, displayName, methodName);
	      return props;
	    };
	
	    return proxy;
	  };
	}

/***/ },
/* 515 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.useReduxContext = useReduxContext;
	
	var _react = __webpack_require__(1);
	
	var _Context = __webpack_require__(104);
	
	/**
	 * A hook to access the value of the `ReactReduxContext`. This is a low-level
	 * hook that you should usually not need to call directly.
	 *
	 * @returns {any} the value of the `ReactReduxContext`
	 *
	 * @example
	 *
	 * import React from 'react'
	 * import { useReduxContext } from 'react-redux'
	 *
	 * export const CounterComponent = ({ value }) => {
	 *   const { store } = useReduxContext()
	 *   return <div>{store.getState()}</div>
	 * }
	 */
	function useReduxContext() {
	  var contextValue = (0, _react.useContext)(_Context.ReactReduxContext);
	
	  if (false) {
	    throw new Error('could not find react-redux context value; please ensure the component is wrapped in a <Provider>');
	  }
	
	  return contextValue;
	}

/***/ },
/* 516 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.createStoreHook = createStoreHook;
	exports.useStore = void 0;
	
	var _react = __webpack_require__(1);
	
	var _Context = __webpack_require__(104);
	
	var _useReduxContext2 = __webpack_require__(515);
	
	/**
	 * Hook factory, which creates a `useStore` hook bound to a given context.
	 *
	 * @param {React.Context} [context=ReactReduxContext] Context passed to your `<Provider>`.
	 * @returns {Function} A `useStore` hook bound to the specified context.
	 */
	function createStoreHook(context) {
	  if (context === void 0) {
	    context = _Context.ReactReduxContext;
	  }
	
	  var useReduxContext = context === _Context.ReactReduxContext ? _useReduxContext2.useReduxContext : function () {
	    return (0, _react.useContext)(context);
	  };
	  return function useStore() {
	    var _useReduxContext = useReduxContext(),
	        store = _useReduxContext.store;
	
	    return store;
	  };
	}
	/**
	 * A hook to access the redux store.
	 *
	 * @returns {any} the redux store
	 *
	 * @example
	 *
	 * import React from 'react'
	 * import { useStore } from 'react-redux'
	 *
	 * export const ExampleComponent = () => {
	 *   const store = useStore()
	 *   return <div>{store.getState()}</div>
	 * }
	 */
	
	
	var useStore = /*#__PURE__*/createStoreHook();
	exports.useStore = useStore;

/***/ },
/* 517 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports.getBatch = exports.setBatch = void 0;
	
	// Default to a dummy "batch" implementation that just runs the callback
	function defaultNoopBatch(callback) {
	  callback();
	}
	
	var batch = defaultNoopBatch; // Allow injecting another batching function later
	
	var setBatch = function setBatch(newBatch) {
	  return batch = newBatch;
	}; // Supply a getter just to skip dealing with ESM bindings
	
	
	exports.setBatch = setBatch;
	
	var getBatch = function getBatch() {
	  return batch;
	};
	
	exports.getBatch = getBatch;

/***/ },
/* 518 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports["default"] = shallowEqual;
	
	function is(x, y) {
	  if (x === y) {
	    return x !== 0 || y !== 0 || 1 / x === 1 / y;
	  } else {
	    return x !== x && y !== y;
	  }
	}
	
	function shallowEqual(objA, objB) {
	  if (is(objA, objB)) return true;
	
	  if (typeof objA !== 'object' || objA === null || typeof objB !== 'object' || objB === null) {
	    return false;
	  }
	
	  var keysA = Object.keys(objA);
	  var keysB = Object.keys(objB);
	  if (keysA.length !== keysB.length) return false;
	
	  for (var i = 0; i < keysA.length; i++) {
	    if (!Object.prototype.hasOwnProperty.call(objB, keysA[i]) || !is(objA[keysA[i]], objB[keysA[i]])) {
	      return false;
	    }
	  }
	
	  return true;
	}

/***/ },
/* 519 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.useIsomorphicLayoutEffect = void 0;
	
	var _react = __webpack_require__(1);
	
	// React currently throws a warning when using useLayoutEffect on the server.
	// To get around it, we can conditionally useEffect on the server (no-op) and
	// useLayoutEffect in the browser. We need useLayoutEffect to ensure the store
	// subscription callback always has the selector from the latest render commit
	// available, otherwise a store update may happen between render and the effect,
	// which may cause missed updates; we also must ensure the store subscription
	// is created synchronously, otherwise a store update may occur before the
	// subscription is created and an inconsistent state may be observed
	var useIsomorphicLayoutEffect = typeof window !== 'undefined' && typeof window.document !== 'undefined' && typeof window.document.createElement !== 'undefined' ? _react.useLayoutEffect : _react.useEffect;
	exports.useIsomorphicLayoutEffect = useIsomorphicLayoutEffect;

/***/ },
/* 520 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(37);
	
	exports.__esModule = true;
	exports["default"] = verifyPlainObject;
	
	var _isPlainObject = _interopRequireDefault(__webpack_require__(1339));
	
	var _warning = _interopRequireDefault(__webpack_require__(521));
	
	function verifyPlainObject(value, displayName, methodName) {
	  if (!(0, _isPlainObject["default"])(value)) {
	    (0, _warning["default"])(methodName + "() in " + displayName + " must return a plain object. Instead received " + value + ".");
	  }
	}

/***/ },
/* 521 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports["default"] = warning;
	
	/**
	 * Prints a warning in the console if it exists.
	 *
	 * @param {String} message The warning message.
	 * @returns {void}
	 */
	function warning(message) {
	  /* eslint-disable no-console */
	  if (typeof console !== 'undefined' && typeof console.error === 'function') {
	    console.error(message);
	  }
	  /* eslint-enable no-console */
	
	
	  try {
	    // This error was thrown as a convenience so that if you enable
	    // "break on all exceptions" in your console,
	    // it would pause the execution at this line.
	    throw new Error(message);
	    /* eslint-disable no-empty */
	  } catch (e) {}
	  /* eslint-enable no-empty */
	
	}

/***/ },
/* 522 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	
	  GLOBAL: {
	    HIDE: '__react_tooltip_hide_event',
	    REBUILD: '__react_tooltip_rebuild_event',
	    SHOW: '__react_tooltip_show_event'
	  }
	};

/***/ },
/* 523 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global, process) {// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.
	
	'use strict';
	
	/*<replacement>*/
	
	var pna = __webpack_require__(208);
	/*</replacement>*/
	
	module.exports = Readable;
	
	/*<replacement>*/
	var isArray = __webpack_require__(481);
	/*</replacement>*/
	
	/*<replacement>*/
	var Duplex;
	/*</replacement>*/
	
	Readable.ReadableState = ReadableState;
	
	/*<replacement>*/
	var EE = __webpack_require__(286).EventEmitter;
	
	var EElistenerCount = function (emitter, type) {
	  return emitter.listeners(type).length;
	};
	/*</replacement>*/
	
	/*<replacement>*/
	var Stream = __webpack_require__(526);
	/*</replacement>*/
	
	/*<replacement>*/
	
	var Buffer = __webpack_require__(213).Buffer;
	var OurUint8Array = global.Uint8Array || function () {};
	function _uint8ArrayToBuffer(chunk) {
	  return Buffer.from(chunk);
	}
	function _isUint8Array(obj) {
	  return Buffer.isBuffer(obj) || obj instanceof OurUint8Array;
	}
	
	/*</replacement>*/
	
	/*<replacement>*/
	var util = Object.create(__webpack_require__(136));
	util.inherits = __webpack_require__(58);
	/*</replacement>*/
	
	/*<replacement>*/
	var debugUtil = __webpack_require__(1524);
	var debug = void 0;
	if (debugUtil && debugUtil.debuglog) {
	  debug = debugUtil.debuglog('stream');
	} else {
	  debug = function () {};
	}
	/*</replacement>*/
	
	var BufferList = __webpack_require__(1359);
	var destroyImpl = __webpack_require__(525);
	var StringDecoder;
	
	util.inherits(Readable, Stream);
	
	var kProxyEvents = ['error', 'close', 'destroy', 'pause', 'resume'];
	
	function prependListener(emitter, event, fn) {
	  // Sadly this is not cacheable as some libraries bundle their own
	  // event emitter implementation with them.
	  if (typeof emitter.prependListener === 'function') return emitter.prependListener(event, fn);
	
	  // This is a hack to make sure that our error handler is attached before any
	  // userland ones.  NEVER DO THIS. This is here only because this code needs
	  // to continue to work with older versions of Node.js that do not include
	  // the prependListener() method. The goal is to eventually remove this hack.
	  if (!emitter._events || !emitter._events[event]) emitter.on(event, fn);else if (isArray(emitter._events[event])) emitter._events[event].unshift(fn);else emitter._events[event] = [fn, emitter._events[event]];
	}
	
	function ReadableState(options, stream) {
	  Duplex = Duplex || __webpack_require__(105);
	
	  options = options || {};
	
	  // Duplex streams are both readable and writable, but share
	  // the same options object.
	  // However, some cases require setting options to different
	  // values for the readable and the writable sides of the duplex stream.
	  // These options can be provided separately as readableXXX and writableXXX.
	  var isDuplex = stream instanceof Duplex;
	
	  // object stream flag. Used to make read(n) ignore n and to
	  // make all the buffer merging and length checks go away
	  this.objectMode = !!options.objectMode;
	
	  if (isDuplex) this.objectMode = this.objectMode || !!options.readableObjectMode;
	
	  // the point at which it stops calling _read() to fill the buffer
	  // Note: 0 is a valid value, means "don't call _read preemptively ever"
	  var hwm = options.highWaterMark;
	  var readableHwm = options.readableHighWaterMark;
	  var defaultHwm = this.objectMode ? 16 : 16 * 1024;
	
	  if (hwm || hwm === 0) this.highWaterMark = hwm;else if (isDuplex && (readableHwm || readableHwm === 0)) this.highWaterMark = readableHwm;else this.highWaterMark = defaultHwm;
	
	  // cast to ints.
	  this.highWaterMark = Math.floor(this.highWaterMark);
	
	  // A linked list is used to store data chunks instead of an array because the
	  // linked list can remove elements from the beginning faster than
	  // array.shift()
	  this.buffer = new BufferList();
	  this.length = 0;
	  this.pipes = null;
	  this.pipesCount = 0;
	  this.flowing = null;
	  this.ended = false;
	  this.endEmitted = false;
	  this.reading = false;
	
	  // a flag to be able to tell if the event 'readable'/'data' is emitted
	  // immediately, or on a later tick.  We set this to true at first, because
	  // any actions that shouldn't happen until "later" should generally also
	  // not happen before the first read call.
	  this.sync = true;
	
	  // whenever we return null, then we set a flag to say
	  // that we're awaiting a 'readable' event emission.
	  this.needReadable = false;
	  this.emittedReadable = false;
	  this.readableListening = false;
	  this.resumeScheduled = false;
	
	  // has it been destroyed
	  this.destroyed = false;
	
	  // Crypto is kind of old and crusty.  Historically, its default string
	  // encoding is 'binary' so we have to make this configurable.
	  // Everything else in the universe uses 'utf8', though.
	  this.defaultEncoding = options.defaultEncoding || 'utf8';
	
	  // the number of writers that are awaiting a drain event in .pipe()s
	  this.awaitDrain = 0;
	
	  // if true, a maybeReadMore has been scheduled
	  this.readingMore = false;
	
	  this.decoder = null;
	  this.encoding = null;
	  if (options.encoding) {
	    if (!StringDecoder) StringDecoder = __webpack_require__(537).StringDecoder;
	    this.decoder = new StringDecoder(options.encoding);
	    this.encoding = options.encoding;
	  }
	}
	
	function Readable(options) {
	  Duplex = Duplex || __webpack_require__(105);
	
	  if (!(this instanceof Readable)) return new Readable(options);
	
	  this._readableState = new ReadableState(options, this);
	
	  // legacy
	  this.readable = true;
	
	  if (options) {
	    if (typeof options.read === 'function') this._read = options.read;
	
	    if (typeof options.destroy === 'function') this._destroy = options.destroy;
	  }
	
	  Stream.call(this);
	}
	
	Object.defineProperty(Readable.prototype, 'destroyed', {
	  get: function () {
	    if (this._readableState === undefined) {
	      return false;
	    }
	    return this._readableState.destroyed;
	  },
	  set: function (value) {
	    // we ignore the value if the stream
	    // has not been initialized yet
	    if (!this._readableState) {
	      return;
	    }
	
	    // backward compatibility, the user is explicitly
	    // managing destroyed
	    this._readableState.destroyed = value;
	  }
	});
	
	Readable.prototype.destroy = destroyImpl.destroy;
	Readable.prototype._undestroy = destroyImpl.undestroy;
	Readable.prototype._destroy = function (err, cb) {
	  this.push(null);
	  cb(err);
	};
	
	// Manually shove something into the read() buffer.
	// This returns true if the highWaterMark has not been hit yet,
	// similar to how Writable.write() returns true if you should
	// write() some more.
	Readable.prototype.push = function (chunk, encoding) {
	  var state = this._readableState;
	  var skipChunkCheck;
	
	  if (!state.objectMode) {
	    if (typeof chunk === 'string') {
	      encoding = encoding || state.defaultEncoding;
	      if (encoding !== state.encoding) {
	        chunk = Buffer.from(chunk, encoding);
	        encoding = '';
	      }
	      skipChunkCheck = true;
	    }
	  } else {
	    skipChunkCheck = true;
	  }
	
	  return readableAddChunk(this, chunk, encoding, false, skipChunkCheck);
	};
	
	// Unshift should *always* be something directly out of read()
	Readable.prototype.unshift = function (chunk) {
	  return readableAddChunk(this, chunk, null, true, false);
	};
	
	function readableAddChunk(stream, chunk, encoding, addToFront, skipChunkCheck) {
	  var state = stream._readableState;
	  if (chunk === null) {
	    state.reading = false;
	    onEofChunk(stream, state);
	  } else {
	    var er;
	    if (!skipChunkCheck) er = chunkInvalid(state, chunk);
	    if (er) {
	      stream.emit('error', er);
	    } else if (state.objectMode || chunk && chunk.length > 0) {
	      if (typeof chunk !== 'string' && !state.objectMode && Object.getPrototypeOf(chunk) !== Buffer.prototype) {
	        chunk = _uint8ArrayToBuffer(chunk);
	      }
	
	      if (addToFront) {
	        if (state.endEmitted) stream.emit('error', new Error('stream.unshift() after end event'));else addChunk(stream, state, chunk, true);
	      } else if (state.ended) {
	        stream.emit('error', new Error('stream.push() after EOF'));
	      } else {
	        state.reading = false;
	        if (state.decoder && !encoding) {
	          chunk = state.decoder.write(chunk);
	          if (state.objectMode || chunk.length !== 0) addChunk(stream, state, chunk, false);else maybeReadMore(stream, state);
	        } else {
	          addChunk(stream, state, chunk, false);
	        }
	      }
	    } else if (!addToFront) {
	      state.reading = false;
	    }
	  }
	
	  return needMoreData(state);
	}
	
	function addChunk(stream, state, chunk, addToFront) {
	  if (state.flowing && state.length === 0 && !state.sync) {
	    stream.emit('data', chunk);
	    stream.read(0);
	  } else {
	    // update the buffer info.
	    state.length += state.objectMode ? 1 : chunk.length;
	    if (addToFront) state.buffer.unshift(chunk);else state.buffer.push(chunk);
	
	    if (state.needReadable) emitReadable(stream);
	  }
	  maybeReadMore(stream, state);
	}
	
	function chunkInvalid(state, chunk) {
	  var er;
	  if (!_isUint8Array(chunk) && typeof chunk !== 'string' && chunk !== undefined && !state.objectMode) {
	    er = new TypeError('Invalid non-string/buffer chunk');
	  }
	  return er;
	}
	
	// if it's past the high water mark, we can push in some more.
	// Also, if we have no data yet, we can stand some
	// more bytes.  This is to work around cases where hwm=0,
	// such as the repl.  Also, if the push() triggered a
	// readable event, and the user called read(largeNumber) such that
	// needReadable was set, then we ought to push more, so that another
	// 'readable' event will be triggered.
	function needMoreData(state) {
	  return !state.ended && (state.needReadable || state.length < state.highWaterMark || state.length === 0);
	}
	
	Readable.prototype.isPaused = function () {
	  return this._readableState.flowing === false;
	};
	
	// backwards compatibility.
	Readable.prototype.setEncoding = function (enc) {
	  if (!StringDecoder) StringDecoder = __webpack_require__(537).StringDecoder;
	  this._readableState.decoder = new StringDecoder(enc);
	  this._readableState.encoding = enc;
	  return this;
	};
	
	// Don't raise the hwm > 8MB
	var MAX_HWM = 0x800000;
	function computeNewHighWaterMark(n) {
	  if (n >= MAX_HWM) {
	    n = MAX_HWM;
	  } else {
	    // Get the next highest power of 2 to prevent increasing hwm excessively in
	    // tiny amounts
	    n--;
	    n |= n >>> 1;
	    n |= n >>> 2;
	    n |= n >>> 4;
	    n |= n >>> 8;
	    n |= n >>> 16;
	    n++;
	  }
	  return n;
	}
	
	// This function is designed to be inlinable, so please take care when making
	// changes to the function body.
	function howMuchToRead(n, state) {
	  if (n <= 0 || state.length === 0 && state.ended) return 0;
	  if (state.objectMode) return 1;
	  if (n !== n) {
	    // Only flow one buffer at a time
	    if (state.flowing && state.length) return state.buffer.head.data.length;else return state.length;
	  }
	  // If we're asking for more than the current hwm, then raise the hwm.
	  if (n > state.highWaterMark) state.highWaterMark = computeNewHighWaterMark(n);
	  if (n <= state.length) return n;
	  // Don't have enough
	  if (!state.ended) {
	    state.needReadable = true;
	    return 0;
	  }
	  return state.length;
	}
	
	// you can override either this method, or the async _read(n) below.
	Readable.prototype.read = function (n) {
	  debug('read', n);
	  n = parseInt(n, 10);
	  var state = this._readableState;
	  var nOrig = n;
	
	  if (n !== 0) state.emittedReadable = false;
	
	  // if we're doing read(0) to trigger a readable event, but we
	  // already have a bunch of data in the buffer, then just trigger
	  // the 'readable' event and move on.
	  if (n === 0 && state.needReadable && (state.length >= state.highWaterMark || state.ended)) {
	    debug('read: emitReadable', state.length, state.ended);
	    if (state.length === 0 && state.ended) endReadable(this);else emitReadable(this);
	    return null;
	  }
	
	  n = howMuchToRead(n, state);
	
	  // if we've ended, and we're now clear, then finish it up.
	  if (n === 0 && state.ended) {
	    if (state.length === 0) endReadable(this);
	    return null;
	  }
	
	  // All the actual chunk generation logic needs to be
	  // *below* the call to _read.  The reason is that in certain
	  // synthetic stream cases, such as passthrough streams, _read
	  // may be a completely synchronous operation which may change
	  // the state of the read buffer, providing enough data when
	  // before there was *not* enough.
	  //
	  // So, the steps are:
	  // 1. Figure out what the state of things will be after we do
	  // a read from the buffer.
	  //
	  // 2. If that resulting state will trigger a _read, then call _read.
	  // Note that this may be asynchronous, or synchronous.  Yes, it is
	  // deeply ugly to write APIs this way, but that still doesn't mean
	  // that the Readable class should behave improperly, as streams are
	  // designed to be sync/async agnostic.
	  // Take note if the _read call is sync or async (ie, if the read call
	  // has returned yet), so that we know whether or not it's safe to emit
	  // 'readable' etc.
	  //
	  // 3. Actually pull the requested chunks out of the buffer and return.
	
	  // if we need a readable event, then we need to do some reading.
	  var doRead = state.needReadable;
	  debug('need readable', doRead);
	
	  // if we currently have less than the highWaterMark, then also read some
	  if (state.length === 0 || state.length - n < state.highWaterMark) {
	    doRead = true;
	    debug('length less than watermark', doRead);
	  }
	
	  // however, if we've ended, then there's no point, and if we're already
	  // reading, then it's unnecessary.
	  if (state.ended || state.reading) {
	    doRead = false;
	    debug('reading or ended', doRead);
	  } else if (doRead) {
	    debug('do read');
	    state.reading = true;
	    state.sync = true;
	    // if the length is currently zero, then we *need* a readable event.
	    if (state.length === 0) state.needReadable = true;
	    // call internal read method
	    this._read(state.highWaterMark);
	    state.sync = false;
	    // If _read pushed data synchronously, then `reading` will be false,
	    // and we need to re-evaluate how much data we can return to the user.
	    if (!state.reading) n = howMuchToRead(nOrig, state);
	  }
	
	  var ret;
	  if (n > 0) ret = fromList(n, state);else ret = null;
	
	  if (ret === null) {
	    state.needReadable = true;
	    n = 0;
	  } else {
	    state.length -= n;
	  }
	
	  if (state.length === 0) {
	    // If we have nothing in the buffer, then we want to know
	    // as soon as we *do* get something into the buffer.
	    if (!state.ended) state.needReadable = true;
	
	    // If we tried to read() past the EOF, then emit end on the next tick.
	    if (nOrig !== n && state.ended) endReadable(this);
	  }
	
	  if (ret !== null) this.emit('data', ret);
	
	  return ret;
	};
	
	function onEofChunk(stream, state) {
	  if (state.ended) return;
	  if (state.decoder) {
	    var chunk = state.decoder.end();
	    if (chunk && chunk.length) {
	      state.buffer.push(chunk);
	      state.length += state.objectMode ? 1 : chunk.length;
	    }
	  }
	  state.ended = true;
	
	  // emit 'readable' now to make sure it gets picked up.
	  emitReadable(stream);
	}
	
	// Don't emit readable right away in sync mode, because this can trigger
	// another read() call => stack overflow.  This way, it might trigger
	// a nextTick recursion warning, but that's not so bad.
	function emitReadable(stream) {
	  var state = stream._readableState;
	  state.needReadable = false;
	  if (!state.emittedReadable) {
	    debug('emitReadable', state.flowing);
	    state.emittedReadable = true;
	    if (state.sync) pna.nextTick(emitReadable_, stream);else emitReadable_(stream);
	  }
	}
	
	function emitReadable_(stream) {
	  debug('emit readable');
	  stream.emit('readable');
	  flow(stream);
	}
	
	// at this point, the user has presumably seen the 'readable' event,
	// and called read() to consume some data.  that may have triggered
	// in turn another _read(n) call, in which case reading = true if
	// it's in progress.
	// However, if we're not ended, or reading, and the length < hwm,
	// then go ahead and try to read some more preemptively.
	function maybeReadMore(stream, state) {
	  if (!state.readingMore) {
	    state.readingMore = true;
	    pna.nextTick(maybeReadMore_, stream, state);
	  }
	}
	
	function maybeReadMore_(stream, state) {
	  var len = state.length;
	  while (!state.reading && !state.flowing && !state.ended && state.length < state.highWaterMark) {
	    debug('maybeReadMore read 0');
	    stream.read(0);
	    if (len === state.length)
	      // didn't get any data, stop spinning.
	      break;else len = state.length;
	  }
	  state.readingMore = false;
	}
	
	// abstract method.  to be overridden in specific implementation classes.
	// call cb(er, data) where data is <= n in length.
	// for virtual (non-string, non-buffer) streams, "length" is somewhat
	// arbitrary, and perhaps not very meaningful.
	Readable.prototype._read = function (n) {
	  this.emit('error', new Error('_read() is not implemented'));
	};
	
	Readable.prototype.pipe = function (dest, pipeOpts) {
	  var src = this;
	  var state = this._readableState;
	
	  switch (state.pipesCount) {
	    case 0:
	      state.pipes = dest;
	      break;
	    case 1:
	      state.pipes = [state.pipes, dest];
	      break;
	    default:
	      state.pipes.push(dest);
	      break;
	  }
	  state.pipesCount += 1;
	  debug('pipe count=%d opts=%j', state.pipesCount, pipeOpts);
	
	  var doEnd = (!pipeOpts || pipeOpts.end !== false) && dest !== process.stdout && dest !== process.stderr;
	
	  var endFn = doEnd ? onend : unpipe;
	  if (state.endEmitted) pna.nextTick(endFn);else src.once('end', endFn);
	
	  dest.on('unpipe', onunpipe);
	  function onunpipe(readable, unpipeInfo) {
	    debug('onunpipe');
	    if (readable === src) {
	      if (unpipeInfo && unpipeInfo.hasUnpiped === false) {
	        unpipeInfo.hasUnpiped = true;
	        cleanup();
	      }
	    }
	  }
	
	  function onend() {
	    debug('onend');
	    dest.end();
	  }
	
	  // when the dest drains, it reduces the awaitDrain counter
	  // on the source.  This would be more elegant with a .once()
	  // handler in flow(), but adding and removing repeatedly is
	  // too slow.
	  var ondrain = pipeOnDrain(src);
	  dest.on('drain', ondrain);
	
	  var cleanedUp = false;
	  function cleanup() {
	    debug('cleanup');
	    // cleanup event handlers once the pipe is broken
	    dest.removeListener('close', onclose);
	    dest.removeListener('finish', onfinish);
	    dest.removeListener('drain', ondrain);
	    dest.removeListener('error', onerror);
	    dest.removeListener('unpipe', onunpipe);
	    src.removeListener('end', onend);
	    src.removeListener('end', unpipe);
	    src.removeListener('data', ondata);
	
	    cleanedUp = true;
	
	    // if the reader is waiting for a drain event from this
	    // specific writer, then it would cause it to never start
	    // flowing again.
	    // So, if this is awaiting a drain, then we just call it now.
	    // If we don't know, then assume that we are waiting for one.
	    if (state.awaitDrain && (!dest._writableState || dest._writableState.needDrain)) ondrain();
	  }
	
	  // If the user pushes more data while we're writing to dest then we'll end up
	  // in ondata again. However, we only want to increase awaitDrain once because
	  // dest will only emit one 'drain' event for the multiple writes.
	  // => Introduce a guard on increasing awaitDrain.
	  var increasedAwaitDrain = false;
	  src.on('data', ondata);
	  function ondata(chunk) {
	    debug('ondata');
	    increasedAwaitDrain = false;
	    var ret = dest.write(chunk);
	    if (false === ret && !increasedAwaitDrain) {
	      // If the user unpiped during `dest.write()`, it is possible
	      // to get stuck in a permanently paused state if that write
	      // also returned false.
	      // => Check whether `dest` is still a piping destination.
	      if ((state.pipesCount === 1 && state.pipes === dest || state.pipesCount > 1 && indexOf(state.pipes, dest) !== -1) && !cleanedUp) {
	        debug('false write response, pause', src._readableState.awaitDrain);
	        src._readableState.awaitDrain++;
	        increasedAwaitDrain = true;
	      }
	      src.pause();
	    }
	  }
	
	  // if the dest has an error, then stop piping into it.
	  // however, don't suppress the throwing behavior for this.
	  function onerror(er) {
	    debug('onerror', er);
	    unpipe();
	    dest.removeListener('error', onerror);
	    if (EElistenerCount(dest, 'error') === 0) dest.emit('error', er);
	  }
	
	  // Make sure our error handler is attached before userland ones.
	  prependListener(dest, 'error', onerror);
	
	  // Both close and finish should trigger unpipe, but only once.
	  function onclose() {
	    dest.removeListener('finish', onfinish);
	    unpipe();
	  }
	  dest.once('close', onclose);
	  function onfinish() {
	    debug('onfinish');
	    dest.removeListener('close', onclose);
	    unpipe();
	  }
	  dest.once('finish', onfinish);
	
	  function unpipe() {
	    debug('unpipe');
	    src.unpipe(dest);
	  }
	
	  // tell the dest that it's being piped to
	  dest.emit('pipe', src);
	
	  // start the flow if it hasn't been started already.
	  if (!state.flowing) {
	    debug('pipe resume');
	    src.resume();
	  }
	
	  return dest;
	};
	
	function pipeOnDrain(src) {
	  return function () {
	    var state = src._readableState;
	    debug('pipeOnDrain', state.awaitDrain);
	    if (state.awaitDrain) state.awaitDrain--;
	    if (state.awaitDrain === 0 && EElistenerCount(src, 'data')) {
	      state.flowing = true;
	      flow(src);
	    }
	  };
	}
	
	Readable.prototype.unpipe = function (dest) {
	  var state = this._readableState;
	  var unpipeInfo = { hasUnpiped: false };
	
	  // if we're not piping anywhere, then do nothing.
	  if (state.pipesCount === 0) return this;
	
	  // just one destination.  most common case.
	  if (state.pipesCount === 1) {
	    // passed in one, but it's not the right one.
	    if (dest && dest !== state.pipes) return this;
	
	    if (!dest) dest = state.pipes;
	
	    // got a match.
	    state.pipes = null;
	    state.pipesCount = 0;
	    state.flowing = false;
	    if (dest) dest.emit('unpipe', this, unpipeInfo);
	    return this;
	  }
	
	  // slow case. multiple pipe destinations.
	
	  if (!dest) {
	    // remove all.
	    var dests = state.pipes;
	    var len = state.pipesCount;
	    state.pipes = null;
	    state.pipesCount = 0;
	    state.flowing = false;
	
	    for (var i = 0; i < len; i++) {
	      dests[i].emit('unpipe', this, unpipeInfo);
	    }return this;
	  }
	
	  // try to find the right one.
	  var index = indexOf(state.pipes, dest);
	  if (index === -1) return this;
	
	  state.pipes.splice(index, 1);
	  state.pipesCount -= 1;
	  if (state.pipesCount === 1) state.pipes = state.pipes[0];
	
	  dest.emit('unpipe', this, unpipeInfo);
	
	  return this;
	};
	
	// set up data events if they are asked for
	// Ensure readable listeners eventually get something
	Readable.prototype.on = function (ev, fn) {
	  var res = Stream.prototype.on.call(this, ev, fn);
	
	  if (ev === 'data') {
	    // Start flowing on next tick if stream isn't explicitly paused
	    if (this._readableState.flowing !== false) this.resume();
	  } else if (ev === 'readable') {
	    var state = this._readableState;
	    if (!state.endEmitted && !state.readableListening) {
	      state.readableListening = state.needReadable = true;
	      state.emittedReadable = false;
	      if (!state.reading) {
	        pna.nextTick(nReadingNextTick, this);
	      } else if (state.length) {
	        emitReadable(this);
	      }
	    }
	  }
	
	  return res;
	};
	Readable.prototype.addListener = Readable.prototype.on;
	
	function nReadingNextTick(self) {
	  debug('readable nexttick read 0');
	  self.read(0);
	}
	
	// pause() and resume() are remnants of the legacy readable stream API
	// If the user uses them, then switch into old mode.
	Readable.prototype.resume = function () {
	  var state = this._readableState;
	  if (!state.flowing) {
	    debug('resume');
	    state.flowing = true;
	    resume(this, state);
	  }
	  return this;
	};
	
	function resume(stream, state) {
	  if (!state.resumeScheduled) {
	    state.resumeScheduled = true;
	    pna.nextTick(resume_, stream, state);
	  }
	}
	
	function resume_(stream, state) {
	  if (!state.reading) {
	    debug('resume read 0');
	    stream.read(0);
	  }
	
	  state.resumeScheduled = false;
	  state.awaitDrain = 0;
	  stream.emit('resume');
	  flow(stream);
	  if (state.flowing && !state.reading) stream.read(0);
	}
	
	Readable.prototype.pause = function () {
	  debug('call pause flowing=%j', this._readableState.flowing);
	  if (false !== this._readableState.flowing) {
	    debug('pause');
	    this._readableState.flowing = false;
	    this.emit('pause');
	  }
	  return this;
	};
	
	function flow(stream) {
	  var state = stream._readableState;
	  debug('flow', state.flowing);
	  while (state.flowing && stream.read() !== null) {}
	}
	
	// wrap an old-style stream as the async data source.
	// This is *not* part of the readable stream interface.
	// It is an ugly unfortunate mess of history.
	Readable.prototype.wrap = function (stream) {
	  var _this = this;
	
	  var state = this._readableState;
	  var paused = false;
	
	  stream.on('end', function () {
	    debug('wrapped end');
	    if (state.decoder && !state.ended) {
	      var chunk = state.decoder.end();
	      if (chunk && chunk.length) _this.push(chunk);
	    }
	
	    _this.push(null);
	  });
	
	  stream.on('data', function (chunk) {
	    debug('wrapped data');
	    if (state.decoder) chunk = state.decoder.write(chunk);
	
	    // don't skip over falsy values in objectMode
	    if (state.objectMode && (chunk === null || chunk === undefined)) return;else if (!state.objectMode && (!chunk || !chunk.length)) return;
	
	    var ret = _this.push(chunk);
	    if (!ret) {
	      paused = true;
	      stream.pause();
	    }
	  });
	
	  // proxy all the other methods.
	  // important when wrapping filters and duplexes.
	  for (var i in stream) {
	    if (this[i] === undefined && typeof stream[i] === 'function') {
	      this[i] = function (method) {
	        return function () {
	          return stream[method].apply(stream, arguments);
	        };
	      }(i);
	    }
	  }
	
	  // proxy certain important events.
	  for (var n = 0; n < kProxyEvents.length; n++) {
	    stream.on(kProxyEvents[n], this.emit.bind(this, kProxyEvents[n]));
	  }
	
	  // when we try to consume some more bytes, simply unpause the
	  // underlying stream.
	  this._read = function (n) {
	    debug('wrapped _read', n);
	    if (paused) {
	      paused = false;
	      stream.resume();
	    }
	  };
	
	  return this;
	};
	
	Object.defineProperty(Readable.prototype, 'readableHighWaterMark', {
	  // making it explicit this property is not enumerable
	  // because otherwise some prototype manipulation in
	  // userland will fail
	  enumerable: false,
	  get: function () {
	    return this._readableState.highWaterMark;
	  }
	});
	
	// exposed for testing purposes only.
	Readable._fromList = fromList;
	
	// Pluck off n bytes from an array of buffers.
	// Length is the combined lengths of all the buffers in the list.
	// This function is designed to be inlinable, so please take care when making
	// changes to the function body.
	function fromList(n, state) {
	  // nothing buffered
	  if (state.length === 0) return null;
	
	  var ret;
	  if (state.objectMode) ret = state.buffer.shift();else if (!n || n >= state.length) {
	    // read it all, truncate the list
	    if (state.decoder) ret = state.buffer.join('');else if (state.buffer.length === 1) ret = state.buffer.head.data;else ret = state.buffer.concat(state.length);
	    state.buffer.clear();
	  } else {
	    // read part of list
	    ret = fromListPartial(n, state.buffer, state.decoder);
	  }
	
	  return ret;
	}
	
	// Extracts only enough buffered data to satisfy the amount requested.
	// This function is designed to be inlinable, so please take care when making
	// changes to the function body.
	function fromListPartial(n, list, hasStrings) {
	  var ret;
	  if (n < list.head.data.length) {
	    // slice is the same for buffers and strings
	    ret = list.head.data.slice(0, n);
	    list.head.data = list.head.data.slice(n);
	  } else if (n === list.head.data.length) {
	    // first chunk is a perfect match
	    ret = list.shift();
	  } else {
	    // result spans more than one buffer
	    ret = hasStrings ? copyFromBufferString(n, list) : copyFromBuffer(n, list);
	  }
	  return ret;
	}
	
	// Copies a specified amount of characters from the list of buffered data
	// chunks.
	// This function is designed to be inlinable, so please take care when making
	// changes to the function body.
	function copyFromBufferString(n, list) {
	  var p = list.head;
	  var c = 1;
	  var ret = p.data;
	  n -= ret.length;
	  while (p = p.next) {
	    var str = p.data;
	    var nb = n > str.length ? str.length : n;
	    if (nb === str.length) ret += str;else ret += str.slice(0, n);
	    n -= nb;
	    if (n === 0) {
	      if (nb === str.length) {
	        ++c;
	        if (p.next) list.head = p.next;else list.head = list.tail = null;
	      } else {
	        list.head = p;
	        p.data = str.slice(nb);
	      }
	      break;
	    }
	    ++c;
	  }
	  list.length -= c;
	  return ret;
	}
	
	// Copies a specified amount of bytes from the list of buffered data chunks.
	// This function is designed to be inlinable, so please take care when making
	// changes to the function body.
	function copyFromBuffer(n, list) {
	  var ret = Buffer.allocUnsafe(n);
	  var p = list.head;
	  var c = 1;
	  p.data.copy(ret);
	  n -= p.data.length;
	  while (p = p.next) {
	    var buf = p.data;
	    var nb = n > buf.length ? buf.length : n;
	    buf.copy(ret, ret.length - n, 0, nb);
	    n -= nb;
	    if (n === 0) {
	      if (nb === buf.length) {
	        ++c;
	        if (p.next) list.head = p.next;else list.head = list.tail = null;
	      } else {
	        list.head = p;
	        p.data = buf.slice(nb);
	      }
	      break;
	    }
	    ++c;
	  }
	  list.length -= c;
	  return ret;
	}
	
	function endReadable(stream) {
	  var state = stream._readableState;
	
	  // If we get here before consuming all the bytes, then that is a
	  // bug in node.  Should never happen.
	  if (state.length > 0) throw new Error('"endReadable()" called on non-empty stream');
	
	  if (!state.endEmitted) {
	    state.ended = true;
	    pna.nextTick(endReadableNT, state, stream);
	  }
	}
	
	function endReadableNT(state, stream) {
	  // Check that we didn't get one last unshift.
	  if (!state.endEmitted && state.length === 0) {
	    state.endEmitted = true;
	    stream.readable = false;
	    stream.emit('end');
	  }
	}
	
	function indexOf(xs, x) {
	  for (var i = 0, l = xs.length; i < l; i++) {
	    if (xs[i] === x) return i;
	  }
	  return -1;
	}
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }()), __webpack_require__(77)))

/***/ },
/* 524 */
/***/ function(module, exports, __webpack_require__) {

	// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.
	
	// a transform stream is a readable/writable stream where you do
	// something with the data.  Sometimes it's called a "filter",
	// but that's not a great name for it, since that implies a thing where
	// some bits pass through, and others are simply ignored.  (That would
	// be a valid example of a transform, of course.)
	//
	// While the output is causally related to the input, it's not a
	// necessarily symmetric or synchronous transformation.  For example,
	// a zlib stream might take multiple plain-text writes(), and then
	// emit a single compressed chunk some time in the future.
	//
	// Here's how this works:
	//
	// The Transform stream has all the aspects of the readable and writable
	// stream classes.  When you write(chunk), that calls _write(chunk,cb)
	// internally, and returns false if there's a lot of pending writes
	// buffered up.  When you call read(), that calls _read(n) until
	// there's enough pending readable data buffered up.
	//
	// In a transform stream, the written data is placed in a buffer.  When
	// _read(n) is called, it transforms the queued up data, calling the
	// buffered _write cb's as it consumes chunks.  If consuming a single
	// written chunk would result in multiple output chunks, then the first
	// outputted bit calls the readcb, and subsequent chunks just go into
	// the read buffer, and will cause it to emit 'readable' if necessary.
	//
	// This way, back-pressure is actually determined by the reading side,
	// since _read has to be called to start processing a new chunk.  However,
	// a pathological inflate type of transform can cause excessive buffering
	// here.  For example, imagine a stream where every byte of input is
	// interpreted as an integer from 0-255, and then results in that many
	// bytes of output.  Writing the 4 bytes {ff,ff,ff,ff} would result in
	// 1kb of data being output.  In this case, you could write a very small
	// amount of input, and end up with a very large amount of output.  In
	// such a pathological inflating mechanism, there'd be no way to tell
	// the system to stop doing the transform.  A single 4MB write could
	// cause the system to run out of memory.
	//
	// However, even in such a pathological case, only a single written chunk
	// would be consumed, and then the rest would wait (un-transformed) until
	// the results of the previous transformed chunk were consumed.
	
	'use strict';
	
	module.exports = Transform;
	
	var Duplex = __webpack_require__(105);
	
	/*<replacement>*/
	var util = Object.create(__webpack_require__(136));
	util.inherits = __webpack_require__(58);
	/*</replacement>*/
	
	util.inherits(Transform, Duplex);
	
	function afterTransform(er, data) {
	  var ts = this._transformState;
	  ts.transforming = false;
	
	  var cb = ts.writecb;
	
	  if (!cb) {
	    return this.emit('error', new Error('write callback called multiple times'));
	  }
	
	  ts.writechunk = null;
	  ts.writecb = null;
	
	  if (data != null) // single equals check for both `null` and `undefined`
	    this.push(data);
	
	  cb(er);
	
	  var rs = this._readableState;
	  rs.reading = false;
	  if (rs.needReadable || rs.length < rs.highWaterMark) {
	    this._read(rs.highWaterMark);
	  }
	}
	
	function Transform(options) {
	  if (!(this instanceof Transform)) return new Transform(options);
	
	  Duplex.call(this, options);
	
	  this._transformState = {
	    afterTransform: afterTransform.bind(this),
	    needTransform: false,
	    transforming: false,
	    writecb: null,
	    writechunk: null,
	    writeencoding: null
	  };
	
	  // start out asking for a readable event once data is transformed.
	  this._readableState.needReadable = true;
	
	  // we have implemented the _read method, and done the other things
	  // that Readable wants before the first _read call, so unset the
	  // sync guard flag.
	  this._readableState.sync = false;
	
	  if (options) {
	    if (typeof options.transform === 'function') this._transform = options.transform;
	
	    if (typeof options.flush === 'function') this._flush = options.flush;
	  }
	
	  // When the writable side finishes, then flush out anything remaining.
	  this.on('prefinish', prefinish);
	}
	
	function prefinish() {
	  var _this = this;
	
	  if (typeof this._flush === 'function') {
	    this._flush(function (er, data) {
	      done(_this, er, data);
	    });
	  } else {
	    done(this, null, null);
	  }
	}
	
	Transform.prototype.push = function (chunk, encoding) {
	  this._transformState.needTransform = false;
	  return Duplex.prototype.push.call(this, chunk, encoding);
	};
	
	// This is the part where you do stuff!
	// override this function in implementation classes.
	// 'chunk' is an input chunk.
	//
	// Call `push(newChunk)` to pass along transformed output
	// to the readable side.  You may call 'push' zero or more times.
	//
	// Call `cb(err)` when you are done with this chunk.  If you pass
	// an error, then that'll put the hurt on the whole operation.  If you
	// never call cb(), then you'll never get another chunk.
	Transform.prototype._transform = function (chunk, encoding, cb) {
	  throw new Error('_transform() is not implemented');
	};
	
	Transform.prototype._write = function (chunk, encoding, cb) {
	  var ts = this._transformState;
	  ts.writecb = cb;
	  ts.writechunk = chunk;
	  ts.writeencoding = encoding;
	  if (!ts.transforming) {
	    var rs = this._readableState;
	    if (ts.needTransform || rs.needReadable || rs.length < rs.highWaterMark) this._read(rs.highWaterMark);
	  }
	};
	
	// Doesn't matter what the args are here.
	// _transform does all the work.
	// That we got here means that the readable side wants more data.
	Transform.prototype._read = function (n) {
	  var ts = this._transformState;
	
	  if (ts.writechunk !== null && ts.writecb && !ts.transforming) {
	    ts.transforming = true;
	    this._transform(ts.writechunk, ts.writeencoding, ts.afterTransform);
	  } else {
	    // mark that we need a transform, so that any data that comes in
	    // will get processed, now that we've asked for it.
	    ts.needTransform = true;
	  }
	};
	
	Transform.prototype._destroy = function (err, cb) {
	  var _this2 = this;
	
	  Duplex.prototype._destroy.call(this, err, function (err2) {
	    cb(err2);
	    _this2.emit('close');
	  });
	};
	
	function done(stream, er, data) {
	  if (er) return stream.emit('error', er);
	
	  if (data != null) // single equals check for both `null` and `undefined`
	    stream.push(data);
	
	  // if there's nothing in the write buffer, then that means
	  // that nothing more will ever be provided
	  if (stream._writableState.length) throw new Error('Calling transform done when ws.length != 0');
	
	  if (stream._transformState.transforming) throw new Error('Calling transform done when still transforming');
	
	  return stream.push(null);
	}

/***/ },
/* 525 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/*<replacement>*/
	
	var pna = __webpack_require__(208);
	/*</replacement>*/
	
	// undocumented cb() API, needed for core, not for public API
	function destroy(err, cb) {
	  var _this = this;
	
	  var readableDestroyed = this._readableState && this._readableState.destroyed;
	  var writableDestroyed = this._writableState && this._writableState.destroyed;
	
	  if (readableDestroyed || writableDestroyed) {
	    if (cb) {
	      cb(err);
	    } else if (err && (!this._writableState || !this._writableState.errorEmitted)) {
	      pna.nextTick(emitErrorNT, this, err);
	    }
	    return this;
	  }
	
	  // we set destroyed to true before firing error callbacks in order
	  // to make it re-entrance safe in case destroy() is called within callbacks
	
	  if (this._readableState) {
	    this._readableState.destroyed = true;
	  }
	
	  // if this is a duplex stream mark the writable part as destroyed as well
	  if (this._writableState) {
	    this._writableState.destroyed = true;
	  }
	
	  this._destroy(err || null, function (err) {
	    if (!cb && err) {
	      pna.nextTick(emitErrorNT, _this, err);
	      if (_this._writableState) {
	        _this._writableState.errorEmitted = true;
	      }
	    } else if (cb) {
	      cb(err);
	    }
	  });
	
	  return this;
	}
	
	function undestroy() {
	  if (this._readableState) {
	    this._readableState.destroyed = false;
	    this._readableState.reading = false;
	    this._readableState.ended = false;
	    this._readableState.endEmitted = false;
	  }
	
	  if (this._writableState) {
	    this._writableState.destroyed = false;
	    this._writableState.ended = false;
	    this._writableState.ending = false;
	    this._writableState.finished = false;
	    this._writableState.errorEmitted = false;
	  }
	}
	
	function emitErrorNT(self, err) {
	  self.emit('error', err);
	}
	
	module.exports = {
	  destroy: destroy,
	  undestroy: undestroy
	};

/***/ },
/* 526 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(286).EventEmitter;


/***/ },
/* 527 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports["default"] = compose;
	/**
	 * Composes single-argument functions from right to left. The rightmost
	 * function can take multiple arguments as it provides the signature for
	 * the resulting composite function.
	 *
	 * @param {...Function} funcs The functions to compose.
	 * @returns {Function} A function obtained by composing the argument functions
	 * from right to left. For example, compose(f, g, h) is identical to doing
	 * (...args) => f(g(h(...args))).
	 */
	
	function compose() {
	  for (var _len = arguments.length, funcs = Array(_len), _key = 0; _key < _len; _key++) {
	    funcs[_key] = arguments[_key];
	  }
	
	  if (funcs.length === 0) {
	    return function (arg) {
	      return arg;
	    };
	  }
	
	  if (funcs.length === 1) {
	    return funcs[0];
	  }
	
	  return funcs.reduce(function (a, b) {
	    return function () {
	      return a(b.apply(undefined, arguments));
	    };
	  });
	}

/***/ },
/* 528 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.ActionTypes = undefined;
	exports['default'] = createStore;
	
	var _isPlainObject = __webpack_require__(502);
	
	var _isPlainObject2 = _interopRequireDefault(_isPlainObject);
	
	var _symbolObservable = __webpack_require__(1477);
	
	var _symbolObservable2 = _interopRequireDefault(_symbolObservable);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	/**
	 * These are private action types reserved by Redux.
	 * For any unknown actions, you must return the current state.
	 * If the current state is undefined, you must return the initial state.
	 * Do not reference these action types directly in your code.
	 */
	var ActionTypes = exports.ActionTypes = {
	  INIT: '@@redux/INIT'
	
	  /**
	   * Creates a Redux store that holds the state tree.
	   * The only way to change the data in the store is to call `dispatch()` on it.
	   *
	   * There should only be a single store in your app. To specify how different
	   * parts of the state tree respond to actions, you may combine several reducers
	   * into a single reducer function by using `combineReducers`.
	   *
	   * @param {Function} reducer A function that returns the next state tree, given
	   * the current state tree and the action to handle.
	   *
	   * @param {any} [preloadedState] The initial state. You may optionally specify it
	   * to hydrate the state from the server in universal apps, or to restore a
	   * previously serialized user session.
	   * If you use `combineReducers` to produce the root reducer function, this must be
	   * an object with the same shape as `combineReducers` keys.
	   *
	   * @param {Function} [enhancer] The store enhancer. You may optionally specify it
	   * to enhance the store with third-party capabilities such as middleware,
	   * time travel, persistence, etc. The only store enhancer that ships with Redux
	   * is `applyMiddleware()`.
	   *
	   * @returns {Store} A Redux store that lets you read the state, dispatch actions
	   * and subscribe to changes.
	   */
	};function createStore(reducer, preloadedState, enhancer) {
	  var _ref2;
	
	  if (typeof preloadedState === 'function' && typeof enhancer === 'undefined') {
	    enhancer = preloadedState;
	    preloadedState = undefined;
	  }
	
	  if (typeof enhancer !== 'undefined') {
	    if (typeof enhancer !== 'function') {
	      throw new Error('Expected the enhancer to be a function.');
	    }
	
	    return enhancer(createStore)(reducer, preloadedState);
	  }
	
	  if (typeof reducer !== 'function') {
	    throw new Error('Expected the reducer to be a function.');
	  }
	
	  var currentReducer = reducer;
	  var currentState = preloadedState;
	  var currentListeners = [];
	  var nextListeners = currentListeners;
	  var isDispatching = false;
	
	  function ensureCanMutateNextListeners() {
	    if (nextListeners === currentListeners) {
	      nextListeners = currentListeners.slice();
	    }
	  }
	
	  /**
	   * Reads the state tree managed by the store.
	   *
	   * @returns {any} The current state tree of your application.
	   */
	  function getState() {
	    return currentState;
	  }
	
	  /**
	   * Adds a change listener. It will be called any time an action is dispatched,
	   * and some part of the state tree may potentially have changed. You may then
	   * call `getState()` to read the current state tree inside the callback.
	   *
	   * You may call `dispatch()` from a change listener, with the following
	   * caveats:
	   *
	   * 1. The subscriptions are snapshotted just before every `dispatch()` call.
	   * If you subscribe or unsubscribe while the listeners are being invoked, this
	   * will not have any effect on the `dispatch()` that is currently in progress.
	   * However, the next `dispatch()` call, whether nested or not, will use a more
	   * recent snapshot of the subscription list.
	   *
	   * 2. The listener should not expect to see all state changes, as the state
	   * might have been updated multiple times during a nested `dispatch()` before
	   * the listener is called. It is, however, guaranteed that all subscribers
	   * registered before the `dispatch()` started will be called with the latest
	   * state by the time it exits.
	   *
	   * @param {Function} listener A callback to be invoked on every dispatch.
	   * @returns {Function} A function to remove this change listener.
	   */
	  function subscribe(listener) {
	    if (typeof listener !== 'function') {
	      throw new Error('Expected listener to be a function.');
	    }
	
	    var isSubscribed = true;
	
	    ensureCanMutateNextListeners();
	    nextListeners.push(listener);
	
	    return function unsubscribe() {
	      if (!isSubscribed) {
	        return;
	      }
	
	      isSubscribed = false;
	
	      ensureCanMutateNextListeners();
	      var index = nextListeners.indexOf(listener);
	      nextListeners.splice(index, 1);
	    };
	  }
	
	  /**
	   * Dispatches an action. It is the only way to trigger a state change.
	   *
	   * The `reducer` function, used to create the store, will be called with the
	   * current state tree and the given `action`. Its return value will
	   * be considered the **next** state of the tree, and the change listeners
	   * will be notified.
	   *
	   * The base implementation only supports plain object actions. If you want to
	   * dispatch a Promise, an Observable, a thunk, or something else, you need to
	   * wrap your store creating function into the corresponding middleware. For
	   * example, see the documentation for the `redux-thunk` package. Even the
	   * middleware will eventually dispatch plain object actions using this method.
	   *
	   * @param {Object} action A plain object representing “what changed”. It is
	   * a good idea to keep actions serializable so you can record and replay user
	   * sessions, or use the time travelling `redux-devtools`. An action must have
	   * a `type` property which may not be `undefined`. It is a good idea to use
	   * string constants for action types.
	   *
	   * @returns {Object} For convenience, the same action object you dispatched.
	   *
	   * Note that, if you use a custom middleware, it may wrap `dispatch()` to
	   * return something else (for example, a Promise you can await).
	   */
	  function dispatch(action) {
	    if (!(0, _isPlainObject2['default'])(action)) {
	      throw new Error('Actions must be plain objects. ' + 'Use custom middleware for async actions.');
	    }
	
	    if (typeof action.type === 'undefined') {
	      throw new Error('Actions may not have an undefined "type" property. ' + 'Have you misspelled a constant?');
	    }
	
	    if (isDispatching) {
	      throw new Error('Reducers may not dispatch actions.');
	    }
	
	    try {
	      isDispatching = true;
	      currentState = currentReducer(currentState, action);
	    } finally {
	      isDispatching = false;
	    }
	
	    var listeners = currentListeners = nextListeners;
	    for (var i = 0; i < listeners.length; i++) {
	      var listener = listeners[i];
	      listener();
	    }
	
	    return action;
	  }
	
	  /**
	   * Replaces the reducer currently used by the store to calculate the state.
	   *
	   * You might need this if your app implements code splitting and you want to
	   * load some of the reducers dynamically. You might also need this if you
	   * implement a hot reloading mechanism for Redux.
	   *
	   * @param {Function} nextReducer The reducer for the store to use instead.
	   * @returns {void}
	   */
	  function replaceReducer(nextReducer) {
	    if (typeof nextReducer !== 'function') {
	      throw new Error('Expected the nextReducer to be a function.');
	    }
	
	    currentReducer = nextReducer;
	    dispatch({ type: ActionTypes.INIT });
	  }
	
	  /**
	   * Interoperability point for observable/reactive libraries.
	   * @returns {observable} A minimal observable of state changes.
	   * For more information, see the observable proposal:
	   * https://github.com/tc39/proposal-observable
	   */
	  function observable() {
	    var _ref;
	
	    var outerSubscribe = subscribe;
	    return _ref = {
	      /**
	       * The minimal observable subscription method.
	       * @param {Object} observer Any object that can be used as an observer.
	       * The observer object should have a `next` method.
	       * @returns {subscription} An object with an `unsubscribe` method that can
	       * be used to unsubscribe the observable from the store, and prevent further
	       * emission of values from the observable.
	       */
	      subscribe: function subscribe(observer) {
	        if (typeof observer !== 'object') {
	          throw new TypeError('Expected the observer to be an object.');
	        }
	
	        function observeState() {
	          if (observer.next) {
	            observer.next(getState());
	          }
	        }
	
	        observeState();
	        var unsubscribe = outerSubscribe(observeState);
	        return { unsubscribe: unsubscribe };
	      }
	    }, _ref[_symbolObservable2['default']] = function () {
	      return this;
	    }, _ref;
	  }
	
	  // When a store is created, an "INIT" action is dispatched so that every
	  // reducer returns their initial state. This effectively populates
	  // the initial state tree.
	  dispatch({ type: ActionTypes.INIT });
	
	  return _ref2 = {
	    dispatch: dispatch,
	    subscribe: subscribe,
	    getState: getState,
	    replaceReducer: replaceReducer
	  }, _ref2[_symbolObservable2['default']] = observable, _ref2;
	}

/***/ },
/* 529 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports['default'] = warning;
	/**
	 * Prints a warning in the console if it exists.
	 *
	 * @param {String} message The warning message.
	 * @returns {void}
	 */
	function warning(message) {
	  /* eslint-disable no-console */
	  if (typeof console !== 'undefined' && typeof console.error === 'function') {
	    console.error(message);
	  }
	  /* eslint-enable no-console */
	  try {
	    // This error was thrown as a convenience so that if you enable
	    // "break on all exceptions" in your console,
	    // it would pause the execution at this line.
	    throw new Error(message);
	    /* eslint-disable no-empty */
	  } catch (e) {}
	  /* eslint-enable no-empty */
	}

/***/ },
/* 530 */
/***/ function(module, exports) {

	'use strict';
	
	var $Object = Object;
	var $TypeError = TypeError;
	
	module.exports = function flags() {
		if (this != null && this !== $Object(this)) {
			throw new $TypeError('RegExp.prototype.flags getter called on non-object');
		}
		var result = '';
		if (this.global) {
			result += 'g';
		}
		if (this.ignoreCase) {
			result += 'i';
		}
		if (this.multiline) {
			result += 'm';
		}
		if (this.dotAll) {
			result += 's';
		}
		if (this.unicode) {
			result += 'u';
		}
		if (this.sticky) {
			result += 'y';
		}
		return result;
	};


/***/ },
/* 531 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var implementation = __webpack_require__(530);
	
	var supportsDescriptors = __webpack_require__(285).supportsDescriptors;
	var $gOPD = Object.getOwnPropertyDescriptor;
	var $TypeError = TypeError;
	
	module.exports = function getPolyfill() {
		if (!supportsDescriptors) {
			throw new $TypeError('RegExp.prototype.flags requires a true ES5 environment that supports property descriptors');
		}
		if ((/a/mig).flags === 'gim') {
			var descriptor = $gOPD(RegExp.prototype, 'flags');
			if (descriptor && typeof descriptor.get === 'function' && typeof (/a/).dotAll === 'boolean') {
				return descriptor.get;
			}
		}
		return implementation;
	};


/***/ },
/* 532 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	module.exports = {
	  position: true,
	  gfm: true,
	  commonmark: false,
	  footnotes: false,
	  pedantic: false,
	  blocks: __webpack_require__(1179)
	};


/***/ },
/* 533 */
/***/ function(module, exports) {

	'use strict';
	
	module.exports = locate;
	
	function locate(value, fromIndex) {
	  var link = value.indexOf('[', fromIndex);
	  var image = value.indexOf('![', fromIndex);
	
	  if (image === -1) {
	    return link;
	  }
	
	  /* Link can never be `-1` if an image is found, so we don’t need
	   * to check for that :) */
	  return link < image ? link : image;
	}


/***/ },
/* 534 */
/***/ function(module, exports) {

	'use strict';
	
	module.exports = locate;
	
	function locate(value, fromIndex) {
	  return value.indexOf('<', fromIndex);
	}


/***/ },
/* 535 */
/***/ function(module, exports) {

	'use strict';
	
	module.exports = indentation;
	
	/* Map of characters, and their column length,
	 * which can be used as indentation. */
	var characters = {' ': 1, '\t': 4};
	
	/* Gets indentation information for a line. */
	function indentation(value) {
	  var index = 0;
	  var indent = 0;
	  var character = value.charAt(index);
	  var stops = {};
	  var size;
	
	  while (character in characters) {
	    size = characters[character];
	
	    indent += size;
	
	    if (size > 1) {
	      indent = Math.floor(indent / size) * size;
	    }
	
	    stops[indent] = index;
	
	    character = value.charAt(++index);
	  }
	
	  return {indent: indent, stops: stops};
	}


/***/ },
/* 536 */
/***/ function(module, exports) {

	'use strict';
	
	var attributeName = '[a-zA-Z_:][a-zA-Z0-9:._-]*';
	var unquoted = '[^"\'=<>`\\u0000-\\u0020]+';
	var singleQuoted = '\'[^\']*\'';
	var doubleQuoted = '"[^"]*"';
	var attributeValue = '(?:' + unquoted + '|' + singleQuoted + '|' + doubleQuoted + ')';
	var attribute = '(?:\\s+' + attributeName + '(?:\\s*=\\s*' + attributeValue + ')?)';
	var openTag = '<[A-Za-z][A-Za-z0-9\\-]*' + attribute + '*\\s*\\/?>';
	var closeTag = '<\\/[A-Za-z][A-Za-z0-9\\-]*\\s*>';
	var comment = '<!---->|<!--(?:-?[^>-])(?:-?[^-])*-->';
	var processing = '<[?].*?[?]>';
	var declaration = '<![A-Za-z]+\\s+[^>]*>';
	var cdata = '<!\\[CDATA\\[[\\s\\S]*?\\]\\]>';
	
	exports.openCloseTag = new RegExp('^(?:' + openTag + '|' + closeTag + ')');
	
	exports.tag = new RegExp('^(?:' +
	  openTag + '|' +
	  closeTag + '|' +
	  comment + '|' +
	  processing + '|' +
	  declaration + '|' +
	  cdata +
	')');


/***/ },
/* 537 */
/***/ function(module, exports, __webpack_require__) {

	// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.
	
	'use strict';
	
	/*<replacement>*/
	
	var Buffer = __webpack_require__(213).Buffer;
	/*</replacement>*/
	
	var isEncoding = Buffer.isEncoding || function (encoding) {
	  encoding = '' + encoding;
	  switch (encoding && encoding.toLowerCase()) {
	    case 'hex':case 'utf8':case 'utf-8':case 'ascii':case 'binary':case 'base64':case 'ucs2':case 'ucs-2':case 'utf16le':case 'utf-16le':case 'raw':
	      return true;
	    default:
	      return false;
	  }
	};
	
	function _normalizeEncoding(enc) {
	  if (!enc) return 'utf8';
	  var retried;
	  while (true) {
	    switch (enc) {
	      case 'utf8':
	      case 'utf-8':
	        return 'utf8';
	      case 'ucs2':
	      case 'ucs-2':
	      case 'utf16le':
	      case 'utf-16le':
	        return 'utf16le';
	      case 'latin1':
	      case 'binary':
	        return 'latin1';
	      case 'base64':
	      case 'ascii':
	      case 'hex':
	        return enc;
	      default:
	        if (retried) return; // undefined
	        enc = ('' + enc).toLowerCase();
	        retried = true;
	    }
	  }
	};
	
	// Do not cache `Buffer.isEncoding` when checking encoding names as some
	// modules monkey-patch it to support additional encodings
	function normalizeEncoding(enc) {
	  var nenc = _normalizeEncoding(enc);
	  if (typeof nenc !== 'string' && (Buffer.isEncoding === isEncoding || !isEncoding(enc))) throw new Error('Unknown encoding: ' + enc);
	  return nenc || enc;
	}
	
	// StringDecoder provides an interface for efficiently splitting a series of
	// buffers into a series of JS strings without breaking apart multi-byte
	// characters.
	exports.StringDecoder = StringDecoder;
	function StringDecoder(encoding) {
	  this.encoding = normalizeEncoding(encoding);
	  var nb;
	  switch (this.encoding) {
	    case 'utf16le':
	      this.text = utf16Text;
	      this.end = utf16End;
	      nb = 4;
	      break;
	    case 'utf8':
	      this.fillLast = utf8FillLast;
	      nb = 4;
	      break;
	    case 'base64':
	      this.text = base64Text;
	      this.end = base64End;
	      nb = 3;
	      break;
	    default:
	      this.write = simpleWrite;
	      this.end = simpleEnd;
	      return;
	  }
	  this.lastNeed = 0;
	  this.lastTotal = 0;
	  this.lastChar = Buffer.allocUnsafe(nb);
	}
	
	StringDecoder.prototype.write = function (buf) {
	  if (buf.length === 0) return '';
	  var r;
	  var i;
	  if (this.lastNeed) {
	    r = this.fillLast(buf);
	    if (r === undefined) return '';
	    i = this.lastNeed;
	    this.lastNeed = 0;
	  } else {
	    i = 0;
	  }
	  if (i < buf.length) return r ? r + this.text(buf, i) : this.text(buf, i);
	  return r || '';
	};
	
	StringDecoder.prototype.end = utf8End;
	
	// Returns only complete characters in a Buffer
	StringDecoder.prototype.text = utf8Text;
	
	// Attempts to complete a partial non-UTF-8 character using bytes from a Buffer
	StringDecoder.prototype.fillLast = function (buf) {
	  if (this.lastNeed <= buf.length) {
	    buf.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, this.lastNeed);
	    return this.lastChar.toString(this.encoding, 0, this.lastTotal);
	  }
	  buf.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, buf.length);
	  this.lastNeed -= buf.length;
	};
	
	// Checks the type of a UTF-8 byte, whether it's ASCII, a leading byte, or a
	// continuation byte. If an invalid byte is detected, -2 is returned.
	function utf8CheckByte(byte) {
	  if (byte <= 0x7F) return 0;else if (byte >> 5 === 0x06) return 2;else if (byte >> 4 === 0x0E) return 3;else if (byte >> 3 === 0x1E) return 4;
	  return byte >> 6 === 0x02 ? -1 : -2;
	}
	
	// Checks at most 3 bytes at the end of a Buffer in order to detect an
	// incomplete multi-byte UTF-8 character. The total number of bytes (2, 3, or 4)
	// needed to complete the UTF-8 character (if applicable) are returned.
	function utf8CheckIncomplete(self, buf, i) {
	  var j = buf.length - 1;
	  if (j < i) return 0;
	  var nb = utf8CheckByte(buf[j]);
	  if (nb >= 0) {
	    if (nb > 0) self.lastNeed = nb - 1;
	    return nb;
	  }
	  if (--j < i || nb === -2) return 0;
	  nb = utf8CheckByte(buf[j]);
	  if (nb >= 0) {
	    if (nb > 0) self.lastNeed = nb - 2;
	    return nb;
	  }
	  if (--j < i || nb === -2) return 0;
	  nb = utf8CheckByte(buf[j]);
	  if (nb >= 0) {
	    if (nb > 0) {
	      if (nb === 2) nb = 0;else self.lastNeed = nb - 3;
	    }
	    return nb;
	  }
	  return 0;
	}
	
	// Validates as many continuation bytes for a multi-byte UTF-8 character as
	// needed or are available. If we see a non-continuation byte where we expect
	// one, we "replace" the validated continuation bytes we've seen so far with
	// a single UTF-8 replacement character ('\ufffd'), to match v8's UTF-8 decoding
	// behavior. The continuation byte check is included three times in the case
	// where all of the continuation bytes for a character exist in the same buffer.
	// It is also done this way as a slight performance increase instead of using a
	// loop.
	function utf8CheckExtraBytes(self, buf, p) {
	  if ((buf[0] & 0xC0) !== 0x80) {
	    self.lastNeed = 0;
	    return '\ufffd';
	  }
	  if (self.lastNeed > 1 && buf.length > 1) {
	    if ((buf[1] & 0xC0) !== 0x80) {
	      self.lastNeed = 1;
	      return '\ufffd';
	    }
	    if (self.lastNeed > 2 && buf.length > 2) {
	      if ((buf[2] & 0xC0) !== 0x80) {
	        self.lastNeed = 2;
	        return '\ufffd';
	      }
	    }
	  }
	}
	
	// Attempts to complete a multi-byte UTF-8 character using bytes from a Buffer.
	function utf8FillLast(buf) {
	  var p = this.lastTotal - this.lastNeed;
	  var r = utf8CheckExtraBytes(this, buf, p);
	  if (r !== undefined) return r;
	  if (this.lastNeed <= buf.length) {
	    buf.copy(this.lastChar, p, 0, this.lastNeed);
	    return this.lastChar.toString(this.encoding, 0, this.lastTotal);
	  }
	  buf.copy(this.lastChar, p, 0, buf.length);
	  this.lastNeed -= buf.length;
	}
	
	// Returns all complete UTF-8 characters in a Buffer. If the Buffer ended on a
	// partial character, the character's bytes are buffered until the required
	// number of bytes are available.
	function utf8Text(buf, i) {
	  var total = utf8CheckIncomplete(this, buf, i);
	  if (!this.lastNeed) return buf.toString('utf8', i);
	  this.lastTotal = total;
	  var end = buf.length - (total - this.lastNeed);
	  buf.copy(this.lastChar, 0, end);
	  return buf.toString('utf8', i, end);
	}
	
	// For UTF-8, a replacement character is added when ending on a partial
	// character.
	function utf8End(buf) {
	  var r = buf && buf.length ? this.write(buf) : '';
	  if (this.lastNeed) return r + '\ufffd';
	  return r;
	}
	
	// UTF-16LE typically needs two bytes per character, but even if we have an even
	// number of bytes available, we need to check if we end on a leading/high
	// surrogate. In that case, we need to wait for the next two bytes in order to
	// decode the last character properly.
	function utf16Text(buf, i) {
	  if ((buf.length - i) % 2 === 0) {
	    var r = buf.toString('utf16le', i);
	    if (r) {
	      var c = r.charCodeAt(r.length - 1);
	      if (c >= 0xD800 && c <= 0xDBFF) {
	        this.lastNeed = 2;
	        this.lastTotal = 4;
	        this.lastChar[0] = buf[buf.length - 2];
	        this.lastChar[1] = buf[buf.length - 1];
	        return r.slice(0, -1);
	      }
	    }
	    return r;
	  }
	  this.lastNeed = 1;
	  this.lastTotal = 2;
	  this.lastChar[0] = buf[buf.length - 1];
	  return buf.toString('utf16le', i, buf.length - 1);
	}
	
	// For UTF-16LE we do not explicitly append special replacement characters if we
	// end on a partial character, we simply let v8 handle that.
	function utf16End(buf) {
	  var r = buf && buf.length ? this.write(buf) : '';
	  if (this.lastNeed) {
	    var end = this.lastTotal - this.lastNeed;
	    return r + this.lastChar.toString('utf16le', 0, end);
	  }
	  return r;
	}
	
	function base64Text(buf, i) {
	  var n = (buf.length - i) % 3;
	  if (n === 0) return buf.toString('base64', i);
	  this.lastNeed = 3 - n;
	  this.lastTotal = 3;
	  if (n === 1) {
	    this.lastChar[0] = buf[buf.length - 1];
	  } else {
	    this.lastChar[0] = buf[buf.length - 2];
	    this.lastChar[1] = buf[buf.length - 1];
	  }
	  return buf.toString('base64', i, buf.length - n);
	}
	
	function base64End(buf) {
	  var r = buf && buf.length ? this.write(buf) : '';
	  if (this.lastNeed) return r + this.lastChar.toString('base64', 0, 3 - this.lastNeed);
	  return r;
	}
	
	// Pass bytes on through for single-byte encodings (e.g. ascii, latin1, hex)
	function simpleWrite(buf) {
	  return buf.toString(this.encoding);
	}
	
	function simpleEnd(buf) {
	  return buf && buf.length ? this.write(buf) : '';
	}

/***/ },
/* 538 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(845);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(11)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../node_modules/css-loader/index.js!../../../node_modules/sass-loader/lib/loader.js!./Dashboard.scss", function() {
				var newContent = require("!!../../../node_modules/css-loader/index.js!../../../node_modules/sass-loader/lib/loader.js!./Dashboard.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 539 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(850);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(11)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../node_modules/css-loader/index.js!../../../node_modules/sass-loader/lib/loader.js!./FilingDetail.scss", function() {
				var newContent = require("!!../../../node_modules/css-loader/index.js!../../../node_modules/sass-loader/lib/loader.js!./FilingDetail.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 540 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(856);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(11)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../node_modules/css-loader/index.js!../../../node_modules/sass-loader/lib/loader.js!./HealthCareDirective.scss", function() {
				var newContent = require("!!../../../node_modules/css-loader/index.js!../../../node_modules/sass-loader/lib/loader.js!./HealthCareDirective.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 541 */
/***/ function(module, exports) {

	/**
	 * Convert array of 16 byte values to UUID string format of the form:
	 * XXXXXXXX-XXXX-XXXX-XXXX-XXXXXXXXXXXX
	 */
	var byteToHex = [];
	for (var i = 0; i < 256; ++i) {
	  byteToHex[i] = (i + 0x100).toString(16).substr(1);
	}
	
	function bytesToUuid(buf, offset) {
	  var i = offset || 0;
	  var bth = byteToHex;
	  // join used to fix memory issue caused by concatenation: https://bugs.chromium.org/p/v8/issues/detail?id=3175#c4
	  return ([
	    bth[buf[i++]], bth[buf[i++]],
	    bth[buf[i++]], bth[buf[i++]], '-',
	    bth[buf[i++]], bth[buf[i++]], '-',
	    bth[buf[i++]], bth[buf[i++]], '-',
	    bth[buf[i++]], bth[buf[i++]], '-',
	    bth[buf[i++]], bth[buf[i++]],
	    bth[buf[i++]], bth[buf[i++]],
	    bth[buf[i++]], bth[buf[i++]]
	  ]).join('');
	}
	
	module.exports = bytesToUuid;


/***/ },
/* 542 */
/***/ function(module, exports) {

	// Unique ID creation requires a high quality random # generator.  In the
	// browser this is a little complicated due to unknown quality of Math.random()
	// and inconsistent support for the `crypto` API.  We do the best we can via
	// feature-detection
	
	// getRandomValues needs to be invoked in a context where "this" is a Crypto
	// implementation. Also, find the complete implementation of crypto on IE11.
	var getRandomValues = (typeof(crypto) != 'undefined' && crypto.getRandomValues && crypto.getRandomValues.bind(crypto)) ||
	                      (typeof(msCrypto) != 'undefined' && typeof window.msCrypto.getRandomValues == 'function' && msCrypto.getRandomValues.bind(msCrypto));
	
	if (getRandomValues) {
	  // WHATWG crypto RNG - http://wiki.whatwg.org/wiki/Crypto
	  var rnds8 = new Uint8Array(16); // eslint-disable-line no-undef
	
	  module.exports = function whatwgRNG() {
	    getRandomValues(rnds8);
	    return rnds8;
	  };
	} else {
	  // Math.random()-based (RNG)
	  //
	  // If all else fails, use Math.random().  It's fast, but is of unspecified
	  // quality.
	  var rnds = new Array(16);
	
	  module.exports = function mathRNG() {
	    for (var i = 0, r; i < 16; i++) {
	      if ((i & 0x03) === 0) r = Math.random() * 0x100000000;
	      rnds[i] = r >>> ((i & 0x03) << 3) & 0xff;
	    }
	
	    return rnds;
	  };
	}


/***/ },
/* 543 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2014-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';
	
	/**
	 * Similar to invariant but only logs a warning if the condition is not met.
	 * This can be used to log issues in development environments in critical
	 * paths. Removing the logging code for production environments will keep the
	 * same logic and follow the same code paths.
	 */
	
	var __DEV__ = ("production") !== 'production';
	
	var warning = function() {};
	
	if (__DEV__) {
	  var printWarning = function printWarning(format, args) {
	    var len = arguments.length;
	    args = new Array(len > 1 ? len - 1 : 0);
	    for (var key = 1; key < len; key++) {
	      args[key - 1] = arguments[key];
	    }
	    var argIndex = 0;
	    var message = 'Warning: ' +
	      format.replace(/%s/g, function() {
	        return args[argIndex++];
	      });
	    if (typeof console !== 'undefined') {
	      console.error(message);
	    }
	    try {
	      // --- Welcome to debugging React ---
	      // This error was thrown as a convenience so that you can use this stack
	      // to find the callsite that caused this warning to fire.
	      throw new Error(message);
	    } catch (x) {}
	  }
	
	  warning = function(condition, format, args) {
	    var len = arguments.length;
	    args = new Array(len > 2 ? len - 2 : 0);
	    for (var key = 2; key < len; key++) {
	      args[key - 2] = arguments[key];
	    }
	    if (format === undefined) {
	      throw new Error(
	          '`warning(condition, format, ...args)` requires a warning ' +
	          'message argument'
	      );
	    }
	    if (!condition) {
	      printWarning.apply(null, [format].concat(args));
	    }
	  };
	}
	
	module.exports = warning;


/***/ },
/* 544 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	if (typeof Promise === 'undefined') {
	  // Rejection tracking prevents a common issue where React gets into an
	  // inconsistent state due to an error, but it gets swallowed by a Promise,
	  // and the user has no idea what causes React's erratic future behavior.
	  __webpack_require__(1286).enable();
	  window.Promise = __webpack_require__(1285);
	}
	
	// fetch() polyfill for making API calls.
	__webpack_require__(1521);
	
	// Object.assign() is commonly used with React.
	// It will use the native implementation if it's present and isn't buggy.
	Object.assign = __webpack_require__(207);


/***/ },
/* 545 */
/***/ function(module, exports) {

	function _setPrototypeOf(o, p) {
	  module.exports = _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
	    o.__proto__ = p;
	    return o;
	  };
	
	  module.exports["default"] = module.exports, module.exports.__esModule = true;
	  return _setPrototypeOf(o, p);
	}
	
	module.exports = _setPrototypeOf;
	module.exports["default"] = module.exports, module.exports.__esModule = true;

/***/ },
/* 546 */
/***/ function(module, exports) {

	function _typeof(obj) {
	  "@babel/helpers - typeof";
	
	  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
	    module.exports = _typeof = function _typeof(obj) {
	      return typeof obj;
	    };
	
	    module.exports["default"] = module.exports, module.exports.__esModule = true;
	  } else {
	    module.exports = _typeof = function _typeof(obj) {
	      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
	    };
	
	    module.exports["default"] = module.exports, module.exports.__esModule = true;
	  }
	
	  return _typeof(obj);
	}
	
	module.exports = _typeof;
	module.exports["default"] = module.exports, module.exports.__esModule = true;

/***/ },
/* 547 */
/***/ function(module, exports, __webpack_require__) {

	Object.defineProperty(exports,"__esModule",{value:true});var _createIconComponent=__webpack_require__(328);var _createIconComponent2=_interopRequireDefault(_createIconComponent);var _react=__webpack_require__(1);var _react2=_interopRequireDefault(_react);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var IconCloudUpload=(0,_createIconComponent2.default)({content:_react2.default.createElement('g',null,_react2.default.createElement('path',{d:'M34.14 59.33a1.67 1.67 0 0 0 1.67-1.67V32.32l8.4 8.19a1.92 1.92 0 0 0 1.29.49 1.8 1.8 0 0 0 1.24-.49 1.68 1.68 0 0 0 0-2.37L36.17 27.53a1.66 1.66 0 0 0-2.36 0L23.2 38.14a1.67 1.67 0 0 0 0 2.37 1.43 1.43 0 0 0 2.16 0l7.11-7.32v24.47a1.68 1.68 0 0 0 1.68 1.67zm0 0'}),_react2.default.createElement('path',{d:'M14 49.79h12.18a1.68 1.68 0 1 0 0-3.35H14c-5.27 0-9.24-3.6-9.24-8.59s4-8.67 9.24-8.67a9.25 9.25 0 0 1 2.74.45l.32.12a1.66 1.66 0 0 0 2.17-1.5 15 15 0 0 1 29.06-4.37 1.68 1.68 0 0 0 2 1.06h.13a11.72 11.72 0 0 1 3.28-.65c6.51 0 11.62 4.84 11.62 11.22s-5.11 11-11.62 11H42.94a1.68 1.68 0 1 0 0 3.35h10.71c8.4 0 15-6.2 15-14.32a14.63 14.63 0 0 0-15-14.64 11.54 11.54 0 0 0-2.83.43 18.36 18.36 0 0 0-34.75 4.82A12.73 12.73 0 0 0 14 25.9c-7.06 0-12.59 5.16-12.59 11.94S6.91 49.79 14 49.79zm0 0'})),height:undefined,width:undefined});IconCloudUpload.displayName='IconCloudUpload';exports.default=IconCloudUpload;

/***/ },
/* 548 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _createIconComponent = _interopRequireDefault(__webpack_require__(5));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	var IconAddCategory = (0, _createIconComponent["default"])({
	  content: _react["default"].createElement("g", null, _react["default"].createElement("path", {
	    d: "M59.35 23.95H44.56a2 2 0 0 1-1.18-.39 14.08 14.08 0 0 0-16.76 0 2 2 0 0 1-1.18.39H10.65a5.27 5.27 0 0 1-5.26-5.26v-6.76a5.27 5.27 0 0 1 5.26-5.26h48.7a5.27 5.27 0 0 1 5.26 5.26v6.76a5.27 5.27 0 0 1-5.26 5.26zm-14.15-4h14.15a1.26 1.26 0 0 0 1.26-1.26v-6.76a1.26 1.26 0 0 0-1.26-1.26h-48.7a1.26 1.26 0 0 0-1.26 1.26v6.76a1.26 1.26 0 0 0 1.26 1.26H24.8a18.07 18.07 0 0 1 20.4 0zM20.24 43.64h-9.59a5.27 5.27 0 0 1-5.26-5.26v-6.76a5.27 5.27 0 0 1 5.26-5.26h9.58a2 2 0 0 1 1.82 2.82 14 14 0 0 0 0 11.64 2 2 0 0 1-1.82 2.82zm-9.59-13.28a1.26 1.26 0 0 0-1.26 1.26v6.76a1.26 1.26 0 0 0 1.26 1.26h6.75a18 18 0 0 1 0-9.28zM59.35 43.64h-9.59a2 2 0 0 1-1.82-2.82 14 14 0 0 0 0-11.64 2 2 0 0 1 1.82-2.82h9.58a5.27 5.27 0 0 1 5.26 5.26v6.76a5.27 5.27 0 0 1-5.25 5.26zm-6.75-4h6.75a1.26 1.26 0 0 0 1.26-1.26v-6.76a1.26 1.26 0 0 0-1.26-1.26H52.6a18 18 0 0 1 0 9.28zM59.35 63.33h-48.7a5.27 5.27 0 0 1-5.26-5.26v-6.76a5.27 5.27 0 0 1 5.26-5.26h14.79a2 2 0 0 1 1.18.39 14.08 14.08 0 0 0 16.75 0 2 2 0 0 1 1.18-.39h14.8a5.27 5.27 0 0 1 5.26 5.26v6.76a5.27 5.27 0 0 1-5.26 5.26zm-48.7-13.28a1.26 1.26 0 0 0-1.26 1.26v6.76a1.26 1.26 0 0 0 1.26 1.26h48.7a1.26 1.26 0 0 0 1.26-1.26v-6.76a1.26 1.26 0 0 0-1.26-1.26H45.2a18.07 18.07 0 0 1-20.39 0zM43.37 33.29a1.71 1.71 0 1 1 0 3.42h-6.66v6.66a1.71 1.71 0 0 1-3.42 0v-6.66h-6.66a1.71 1.71 0 1 1 0-3.42h6.66v-6.66a1.71 1.71 0 1 1 3.42 0v6.66z"
	  })),
	  height: undefined,
	  width: undefined
	});
	IconAddCategory.displayName = 'IconAddCategory';
	var _default = IconAddCategory;
	exports["default"] = _default;

/***/ },
/* 549 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _createIconComponent = _interopRequireDefault(__webpack_require__(5));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	var IconAddWizard = (0, _createIconComponent["default"])({
	  content: _react["default"].createElement("g", null, _react["default"].createElement("path", {
	    d: "M55.26 7.53a4 4 0 0 0-2.86-1.19H17.6a4 4 0 0 0-2.26.66 4.08 4.08 0 0 0-.6.49 4 4 0 0 0-1.19 2.86v49.26a4 4 0 0 0 4 4h36l.16-.05a4 4 0 0 0 2.73-3.81V10.39a4 4 0 0 0-1.18-2.86zm-4.31 4.31v46.32H19.06V11.84z"
	  }), _react["default"].createElement("path", {
	    d: "M24.74 37.6h7.66v7.66a2.6 2.6 0 0 0 5.19 0V37.6h7.66a2.6 2.6 0 1 0 0-5.19H37.6v-7.67a2.6 2.6 0 1 0-5.19 0v7.66h-7.67a2.6 2.6 0 1 0 0 5.19z"
	  })),
	  height: undefined,
	  width: undefined
	});
	IconAddWizard.displayName = 'IconAddWizard';
	var _default = IconAddWizard;
	exports["default"] = _default;

/***/ },
/* 550 */,
/* 551 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _createIconComponent = _interopRequireDefault(__webpack_require__(5));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	var IconArchive = (0, _createIconComponent["default"])({
	  content: _react["default"].createElement("g", null, _react["default"].createElement("path", {
	    d: "M23.66 41.8h22.68a2 2 0 0 0 2-2v-7.3a2 2 0 0 0-2-2H23.66a2 2 0 0 0-2 2v7.3a2 2 0 0 0 2 2zm2-7.3h18.68v3.3H25.66z"
	  }), _react["default"].createElement("path", {
	    d: "M63.23 14.9v-.11a2 2 0 0 0-.21-.46 2 2 0 0 0-.37-.4l-7-5.64a2 2 0 0 0-1.26-.44H15.68a2 2 0 0 0-1.26.44l-7 5.64a2 2 0 0 0-.37.4 2 2 0 0 0-.21.46v.11a2 2 0 0 0-.07.5V25a2 2 0 0 0 2 2h3v33.2a2 2 0 0 0 2 2h42.56a2 2 0 0 0 2-2V27h3a2 2 0 0 0 2-2v-9.61a2 2 0 0 0-.1-.49zm-46.84-3.15h37.22l2 1.64H14.36zm37.94 46.5H15.67V27h38.66zm5-35.2H10.7v-5.66h48.6z"
	  })),
	  height: undefined,
	  width: undefined
	});
	IconArchive.displayName = 'IconArchive';
	var _default = IconArchive;
	exports["default"] = _default;

/***/ },
/* 552 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _createIconComponent = _interopRequireDefault(__webpack_require__(5));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	var IconBulletList = (0, _createIconComponent["default"])({
	  content: _react["default"].createElement("g", null, _react["default"].createElement("path", {
	    d: "M12.61 22.17A6.15 6.15 0 1 0 6.47 16a6.15 6.15 0 0 0 6.14 6.15zm0-9.44A3.29 3.29 0 1 1 9.32 16a3.29 3.29 0 0 1 3.29-3.29zm0 0M12.61 41.14A6.14 6.14 0 1 0 6.47 35a6.15 6.15 0 0 0 6.14 6.14zm0-9.43A3.29 3.29 0 1 1 9.32 35a3.29 3.29 0 0 1 3.29-3.29zm0 0M12.61 60.12A6.14 6.14 0 1 0 6.47 54a6.15 6.15 0 0 0 6.14 6.14zm0-9.44A3.29 3.29 0 1 1 9.32 54a3.29 3.29 0 0 1 3.29-3.29zm0 0M27 17.45h35.1a1.43 1.43 0 0 0 0-2.87H27a1.43 1.43 0 0 0 0 2.87zm0 0M27 36.43h35.1a1.43 1.43 0 1 0 0-2.87H27a1.43 1.43 0 1 0 0 2.87zm0 0M27 55.4h35.1a1.43 1.43 0 0 0 0-2.87H27a1.43 1.43 0 0 0 0 2.87zm0 0"
	  })),
	  height: undefined,
	  width: undefined
	});
	IconBulletList.displayName = 'IconBulletList';
	var _default = IconBulletList;
	exports["default"] = _default;

/***/ },
/* 553 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _createIconComponent = _interopRequireDefault(__webpack_require__(5));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	var IconCapital = (0, _createIconComponent["default"])({
	  content: _react["default"].createElement("g", null, _react["default"].createElement("path", {
	    d: "M59.48 55.53h-2.9v-13.7h2.9a1.6 1.6 0 0 0 0-3.2h-3a21.58 21.58 0 0 0-19.88-19.9v-2.16H46a1.6 1.6 0 0 0 1.6-1.6V9.31a1.6 1.6 0 0 0-1.6-1.6h-9.4v-.84a1.6 1.6 0 1 0-3.2 0v11.86a21.58 21.58 0 0 0-19.9 19.9h-3a1.6 1.6 0 0 0 0 3.2h2.9v13.7h-2.9a1.6 1.6 0 0 0 0 3.2h49a1.6 1.6 0 0 0 0-3.2zm-16.22 0v-13.7h3.46v13.7zm-9.86-13.7v13.7h-3.46v-13.7zm3.2 0h3.46v13.7H36.6zm-9.86 0v13.7h-3.46v-13.7zm26.64 13.7h-3.46v-13.7h3.46zM35 21.85a18.4 18.4 0 0 1 18.31 16.77H16.69A18.4 18.4 0 0 1 35 21.85zm9.36-10.95v2.46H36.6v-2.45zM16.62 41.83h3.46v13.7h-3.46z"
	  })),
	  height: undefined,
	  width: undefined
	});
	IconCapital.displayName = 'IconCapital';
	var _default = IconCapital;
	exports["default"] = _default;

/***/ },
/* 554 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _createIconComponent = _interopRequireDefault(__webpack_require__(5));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	var IconCaretRight = (0, _createIconComponent["default"])({
	  content: _react["default"].createElement("g", null, _react["default"].createElement("path", {
	    d: "M21.6 12.51a3.85 3.85 0 0 0 0 5.44l17 17-17 17a3.85 3.85 0 0 0 0 5.45 3.85 3.85 0 0 0 5.45 0L49.54 35 27.06 12.5a3.85 3.85 0 0 0-5.46.01z"
	  })),
	  height: undefined,
	  width: undefined
	});
	IconCaretRight.displayName = 'IconCaretRight';
	var _default = IconCaretRight;
	exports["default"] = _default;

/***/ },
/* 555 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _createIconComponent = _interopRequireDefault(__webpack_require__(5));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	var IconCertificate = (0, _createIconComponent["default"])({
	  content: _react["default"].createElement("g", null, _react["default"].createElement("path", {
	    d: "M60.85 20.41a1 1 0 0 0 1-1v-6.82a4.86 4.86 0 0 0-4.9-4.81H17.48a4.79 4.79 0 0 0-4.87 4.81v43.62a4.91 4.91 0 0 0 4.87 4.94h9.58v6.77a1 1 0 0 0 1.41.87l4.77-2.39L38 68.8a1 1 0 0 0 1.41-.87v-6.78H56.9a4.91 4.91 0 0 0 4.9-4.91v-6.87a1 1 0 0 0-1-1H54v-28zm-1-7.82v5.87H54v-5.8a2.93 2.93 0 0 1 5.86-.07zM38 52.09a1 1 0 0 0-.34.3 6.88 6.88 0 1 1 .34-.3zm-.52 14.25l-3.79-1.9a1 1 0 0 0-.87 0L29 66.34V54.81a8.77 8.77 0 0 0 8.46 0zm2-12.92a8.79 8.79 0 1 0-12.37-.09v5.87h-9.63a3 3 0 0 1-2.92-3V12.59a2.86 2.86 0 0 1 2.92-2.86H53a4.85 4.85 0 0 0-1 2.92v43.56a4.9 4.9 0 0 0 1 3H39.38zm20.44-3.07v5.86a3 3 0 0 1-3 3 2.94 2.94 0 0 1-2.91-3v-5.86zm0 0"
	  }), _react["default"].createElement("path", {
	    d: "M33.29 42.26a4.88 4.88 0 1 0 4.88 4.88 4.89 4.89 0 0 0-4.88-4.88zm0 7.81a2.93 2.93 0 1 1 2.93-2.93 2.93 2.93 0 0 1-2.93 2.93zm0 0M46.33 27.57h-26a1 1 0 0 0 0 2h26a1 1 0 0 0 0-2zm0 0M42.43 31.47H24.2a1 1 0 1 0 0 2h18.23a1 1 0 0 0 0-2zm0 0M46.33 23.66h-3.9a1 1 0 1 0 0 2h3.91a1 1 0 0 0 0-2zm0 0M20.29 25.61h18.23a1 1 0 0 0 0-2H20.29a1 1 0 0 0 0 2zm0 0M23.58 20.22a1 1 0 0 0 1.42-.17l2.27-2.92L29.49 20A1 1 0 0 0 31 20l2.27-2.91L35.56 20a1 1 0 0 0 1.54 0l2.27-2.91L41.64 20a1 1 0 0 0 1.54-1.2l-3-3.91a1 1 0 0 0-1.54 0l-2.27 2.91-2.27-2.91a1 1 0 0 0-1.54 0l-2.27 2.91L28 14.95a1 1 0 0 0-1.54 0l-3 3.91a1 1 0 0 0 .17 1.37zm0 0"
	  })),
	  height: undefined,
	  width: undefined
	});
	IconCertificate.displayName = 'IconCertificate';
	var _default = IconCertificate;
	exports["default"] = _default;

/***/ },
/* 556 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _createIconComponent = _interopRequireDefault(__webpack_require__(5));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	var IconCharity = (0, _createIconComponent["default"])({
	  content: _react["default"].createElement("g", null, _react["default"].createElement("path", {
	    d: "M39.44 40.55a1.6 1.6 0 0 0 2.26 0l14.1-14.1a10.68 10.68 0 0 0 0-15.09 10.68 10.68 0 0 0-15.09 0l-.13.13-.13-.13a10.67 10.67 0 0 0-15.11 15.09zm14.1-16.36l-13 13-13-13a7.47 7.47 0 0 1 10.63-10.57l1.26 1.26a1.6 1.6 0 0 0 2.26 0L43 13.63a7.46 7.46 0 0 1 10.5-.07l.07.07a7.48 7.48 0 0 1-.04 10.56z"
	  }), _react["default"].createElement("path", {
	    d: "M62.7 43.17a4.39 4.39 0 0 0-5.48-2.36l-15 5.33a4.36 4.36 0 0 0-2-1.64L25 38.43a8.28 8.28 0 0 0-6.7.21l-.81.39v-.64a1.6 1.6 0 0 0-1.6-1.6H7.53a1.6 1.6 0 0 0-1.6 1.6v20.25a1.6 1.6 0 0 0 1.6 1.6h8.33a1.6 1.6 0 0 0 1.6-1.6v-2.26a7.89 7.89 0 0 1 4.57.17l9.25 3.15a11.09 11.09 0 0 0 8.43-.51l20.86-10a4.56 4.56 0 0 0 2.13-6.02zm-3.51 3.09l-20.86 10a7.9 7.9 0 0 1-6 .36l-9.25-3.15a11.14 11.14 0 0 0-3.6-.6 11 11 0 0 0-2 .2V42.58l2.2-1.06a5.07 5.07 0 0 1 4.11-.12L39 47.47a1.25 1.25 0 0 1 .66 1.61 1.18 1.18 0 0 1-.63.68 1.09 1.09 0 0 1-.87 0l-11-4.39a1.6 1.6 0 1 0-1.18 3l11 4.39a4.25 4.25 0 0 0 3.33 0 4.36 4.36 0 0 0 2.35-2.47 4.46 4.46 0 0 0 .25-.93l15.41-5.46a1.21 1.21 0 0 1 1.5.67 1.34 1.34 0 0 1-.64 1.69zM9.13 40h5.13v17H9.13z"
	  })),
	  height: undefined,
	  width: undefined
	});
	IconCharity.displayName = 'IconCharity';
	var _default = IconCharity;
	exports["default"] = _default;

/***/ },
/* 557 */,
/* 558 */,
/* 559 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _createIconComponent = _interopRequireDefault(__webpack_require__(5));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	var IconClone = (0, _createIconComponent["default"])({
	  content: _react["default"].createElement("g", null, _react["default"].createElement("path", {
	    d: "M5.38 18.58v34.59A2.64 2.64 0 0 0 8 55.81h16.12V15.94H8a2.64 2.64 0 0 0-2.62 2.64zm4.5 32.73V20.44h9.73v30.87zM63.65 11a3.3 3.3 0 0 0-2.33-1H29.41a3.26 3.26 0 0 0-1.84.56 3.32 3.32 0 0 0-.49.4 3.27 3.27 0 0 0-1 2.33v45.16a3.3 3.3 0 0 0 3.29 3.29h32.98a3.29 3.29 0 0 0 2.23-3.1V13.3a3.27 3.27 0 0 0-.93-2.3zm-3.53 3.5v42.74h-29.5V14.5z"
	  }), _react["default"].createElement("path", {
	    d: "M38 37.87h5.34v5.34a2 2 0 0 0 4 0v-5.34h5.34a2 2 0 0 0 0-4h-5.31v-5.34a2 2 0 1 0-4 0v5.34H38a2 2 0 0 0 0 4z"
	  })),
	  height: undefined,
	  width: undefined
	});
	IconClone.displayName = 'IconClone';
	var _default = IconClone;
	exports["default"] = _default;

/***/ },
/* 560 */,
/* 561 */,
/* 562 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _createIconComponent = _interopRequireDefault(__webpack_require__(5));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	var IconDocumentAdd = (0, _createIconComponent["default"])({
	  content: _react["default"].createElement("g", null, _react["default"].createElement("path", {
	    d: "M21.65 31.92h25.16a1.28 1.28 0 0 0 0-2.56H21.65a1.28 1.28 0 0 0 0 2.56zM21.65 23.22H42.4a1.28 1.28 0 1 0 0-2.56H21.65a1.28 1.28 0 0 0 0 2.56z"
	  }), _react["default"].createElement("path", {
	    d: "M54.56 38.37V12.14a3 3 0 0 0-3-3h-34.1a3 3 0 0 0-3 3V60.4a3 3 0 0 0 3 3h17.66a16.37 16.37 0 1 0 19.44-25zm-37.1 22.45a.43.43 0 0 1-.46-.42V12.14a.43.43 0 0 1 .43-.43h34.14a.43.43 0 0 1 .42.43v25.38a16.16 16.16 0 0 0-10.28.8H21.65a1.28 1.28 0 0 0 0 2.56h15.91A16.45 16.45 0 0 0 33 47.13H21.65a1.28 1.28 0 0 0 0 2.56h10.5a16.11 16.11 0 0 0 1.35 11.13zm30.62 6a13.38 13.38 0 1 1 13.39-13.41 13.4 13.4 0 0 1-13.38 13.38z"
	  }), _react["default"].createElement("path", {
	    d: "M55.43 51.91h-5.84v-5.84a1.5 1.5 0 0 0-3 0v5.84h-5.84a1.5 1.5 0 0 0 0 3h5.84v5.84a1.5 1.5 0 0 0 3 0v-5.84h5.84a1.5 1.5 0 0 0 0-3z"
	  })),
	  height: undefined,
	  width: undefined
	});
	IconDocumentAdd.displayName = 'IconDocumentAdd';
	var _default = IconDocumentAdd;
	exports["default"] = _default;

/***/ },
/* 563 */,
/* 564 */,
/* 565 */,
/* 566 */,
/* 567 */,
/* 568 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _createIconComponent = _interopRequireDefault(__webpack_require__(5));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	var IconFileBoxTime = (0, _createIconComponent["default"])({
	  content: _react["default"].createElement("g", null, _react["default"].createElement("path", {
	    d: "M41.37 49.87H28.46a1.77 1.77 0 0 0-1.76 1.76v4a1.77 1.77 0 0 0 1.76 1.76h12.91a1.77 1.77 0 0 0 1.76-1.76v-4a1.77 1.77 0 0 0-1.76-1.76zm-.5 5.22H29v-3h11.9z"
	  }), _react["default"].createElement("path", {
	    d: "M63.62 40.05l-2-4a17.89 17.89 0 0 1-2.2 1.23l.45.89h-2.63a16.37 16.37 0 0 1-11.16.11 2.62 2.62 0 0 0-1.63 1.43l-1.63 3.62a.1.1 0 0 1-.09.06H27.09a.1.1 0 0 1-.09-.06l-1.63-3.62A2.62 2.62 0 0 0 23 38.15h-6V35h23.19a17.87 17.87 0 0 1-2.3-2.27H19.54v-4.9h15.35a17.7 17.7 0 0 1-.71-2.27h-12v-4.95h11.51a17.84 17.84 0 0 1 .23-2.27H21a1.13 1.13 0 0 0-1.13 1.13V21H18.3a4 4 0 0 0-3.58 2.2L6.21 40.05a4 4 0 0 0-.57 2.05v17.78a4 4 0 0 0 4 4H60.2a4 4 0 0 0 4-4V42.12a4 4 0 0 0-.57-2.05zM17 24.38a1.49 1.49 0 0 1 1.33-.82h1.62v2h-1.54a1.13 1.13 0 0 0-1.13 1.13v6.08h-1.4a1.13 1.13 0 0 0-1.13 1.13v4.24H10zm43.24 37H9.63a1.45 1.45 0 0 1-1.45-1.45V42.12a1.45 1.45 0 0 1 1.45-1.45H23a.1.1 0 0 1 .09.06l1.63 3.62a2.62 2.62 0 0 0 2.38 1.54h15.63a2.62 2.62 0 0 0 2.38-1.54l1.63-3.62a.1.1 0 0 1 .09-.06H60.2a1.45 1.45 0 0 1 1.45 1.45v17.76a1.45 1.45 0 0 1-1.45 1.45zM50.07 22.11a1.25 1.25 0 0 0 1.25 1.25h8.07a1.25 1.25 0 1 0 0-2.5h-6.82v-8.2a1.25 1.25 0 0 0-2.5 0z"
	  }), _react["default"].createElement("path", {
	    d: "M36.3 21.33A15.18 15.18 0 1 0 51.48 6.15 15.2 15.2 0 0 0 36.3 21.33zm15.18-12a12 12 0 1 1-12 12 12 12 0 0 1 12-11.95z"
	  })),
	  height: undefined,
	  width: undefined
	});
	IconFileBoxTime.displayName = 'IconFileBoxTime';
	var _default = IconFileBoxTime;
	exports["default"] = _default;

/***/ },
/* 569 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _createIconComponent = _interopRequireDefault(__webpack_require__(5));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	var IconFilter = (0, _createIconComponent["default"])({
	  content: _react["default"].createElement("g", null, _react["default"].createElement("path", {
	    d: "M59.63 7.72H11.55a2.08 2.08 0 0 0-1.47 3.55l20.86 20.85v25.53A6.12 6.12 0 0 0 32.73 62l4.9 4.9a1.53 1.53 0 0 0 2.61-1.08v-33.7L61.1 11.27a2.08 2.08 0 0 0-1.47-3.55z"
	  })),
	  height: undefined,
	  width: undefined
	});
	IconFilter.displayName = 'IconFilter';
	var _default = IconFilter;
	exports["default"] = _default;

/***/ },
/* 570 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _createIconComponent = _interopRequireDefault(__webpack_require__(5));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	var IconGauge = (0, _createIconComponent["default"])({
	  content: _react["default"].createElement("g", null, _react["default"].createElement("path", {
	    d: "M43 29.11a1.44 1.44 0 0 0-1.5-.34c-1.64.59-9.9 3.6-11.72 5.42a5.75 5.75 0 0 0 0 8.13 5.75 5.75 0 0 0 8.13 0c1.82-1.82 4.84-10.08 5.42-11.72a1.44 1.44 0 0 0-.34-1.5zM35.93 40.3a2.88 2.88 0 0 1-4.07-4.07c.77-.77 4.36-2.34 7.71-3.65-1.31 3.35-2.88 6.95-3.65 7.71zm0 0"
	  }), _react["default"].createElement("path", {
	    d: "M35 9.12a28.74 28.74 0 0 0-23.54 12.26c-.95 1.42-1.54 2.43-1.54 2.43a28.74 28.74 0 0 0 2.54 32l1.9 2.16a29.22 29.22 0 0 0 3 2.66 1.44 1.44 0 0 0 .88.3h33.53a1.43 1.43 0 0 0 .88-.3A28.76 28.76 0 0 0 35 9.12zm19.29 46l-4-4a1.44 1.44 0 1 0-2 2l4 4q-.48.43-1 .84H36.44V53.7a1.44 1.44 0 0 0-2.88 0V58H18.73q-.51-.41-1-.84l4-4a1.44 1.44 0 0 0-2-2l-4 4-.07-.08a1.48 1.48 0 0 0-.18-.22 25.68 25.68 0 0 1-6.26-15.5h5.71a1.44 1.44 0 0 0 0-2.88H9.16a25.77 25.77 0 0 1 6.56-15.81l4 4a1.44 1.44 0 0 0 2-2l-4-4A25.77 25.77 0 0 1 33.56 12v5.71a1.44 1.44 0 0 0 2.88 0V12a25.77 25.77 0 0 1 15.81 6.6l-4 4a1.44 1.44 0 1 0 2 2l4-4a25.77 25.77 0 0 1 6.56 15.81h-5.68a1.44 1.44 0 0 0 0 2.88h5.71a25.66 25.66 0 0 1-6.55 15.85z"
	  })),
	  height: undefined,
	  width: undefined
	});
	IconGauge.displayName = 'IconGauge';
	var _default = IconGauge;
	exports["default"] = _default;

/***/ },
/* 571 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _createIconComponent = _interopRequireDefault(__webpack_require__(5));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	var IconHamburger = (0, _createIconComponent["default"])({
	  content: _react["default"].createElement("g", null, _react["default"].createElement("rect", {
	    x: "5.67",
	    y: "14.54",
	    width: "58.67",
	    height: "7.71",
	    rx: "3.85",
	    ry: "3.85"
	  }), _react["default"].createElement("rect", {
	    x: "5.67",
	    y: "31.15",
	    width: "58.67",
	    height: "7.71",
	    rx: "3.85",
	    ry: "3.85"
	  }), _react["default"].createElement("rect", {
	    x: "5.67",
	    y: "47.75",
	    width: "58.67",
	    height: "7.71",
	    rx: "3.85",
	    ry: "3.85"
	  })),
	  height: undefined,
	  width: undefined
	});
	IconHamburger.displayName = 'IconHamburger';
	var _default = IconHamburger;
	exports["default"] = _default;

/***/ },
/* 572 */,
/* 573 */,
/* 574 */,
/* 575 */,
/* 576 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _createIconComponent = _interopRequireDefault(__webpack_require__(5));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	var IconLock = (0, _createIconComponent["default"])({
	  content: _react["default"].createElement("g", null, _react["default"].createElement("path", {
	    d: "M59 33.45h-4V24a20 20 0 0 0-40 0v9.47h-4a4 4 0 0 0-4 4.03V61a4 4 0 0 0 4.05 4H59a4 4 0 0 0 4-4V37.5a4 4 0 0 0-4-4.05zM21.33 24a13.67 13.67 0 1 1 27.34 0v9.47H21.33z"
	  })),
	  height: undefined,
	  width: undefined
	});
	IconLock.displayName = 'IconLock';
	var _default = IconLock;
	exports["default"] = _default;

/***/ },
/* 577 */,
/* 578 */,
/* 579 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _createIconComponent = _interopRequireDefault(__webpack_require__(5));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	var IconPause = (0, _createIconComponent["default"])({
	  content: _react["default"].createElement("g", null, _react["default"].createElement("path", {
	    d: "M26.46 60.76h-7.95a1.6 1.6 0 0 1-1.6-1.6V10.84a1.6 1.6 0 0 1 1.6-1.6h8a1.59 1.59 0 0 1 1.6 1.6v48.32a1.6 1.6 0 0 1-1.65 1.6zm-6.35-3.2h4.75V12.44h-4.75zM51.49 60.76h-8a1.6 1.6 0 0 1-1.6-1.6V10.84a1.59 1.59 0 0 1 1.6-1.6h8a1.6 1.6 0 0 1 1.6 1.6v48.32a1.6 1.6 0 0 1-1.6 1.6zm-6.35-3.2h4.75V12.44h-4.75z"
	  })),
	  height: undefined,
	  width: undefined
	});
	IconPause.displayName = 'IconPause';
	var _default = IconPause;
	exports["default"] = _default;

/***/ },
/* 580 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _createIconComponent = _interopRequireDefault(__webpack_require__(5));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	var IconPencilSolid = (0, _createIconComponent["default"])({
	  content: _react["default"].createElement("g", null, _react["default"].createElement("path", {
	    d: "M40.874 13.537l4.929-4.928 15.578 15.577-4.929 4.929zM37.74 16.68L8.62 45.81v15.57h15.57l29.13-29.12-15.58-15.58z"
	  })),
	  height: undefined,
	  width: undefined
	});
	IconPencilSolid.displayName = 'IconPencilSolid';
	var _default = IconPencilSolid;
	exports["default"] = _default;

/***/ },
/* 581 */,
/* 582 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _createIconComponent = _interopRequireDefault(__webpack_require__(5));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	var IconPlay = (0, _createIconComponent["default"])({
	  content: _react["default"].createElement("g", null, _react["default"].createElement("path", {
	    d: "M16.62 60.76a1.58 1.58 0 0 1-.79-.21 1.61 1.61 0 0 1-.83-1.39V10.84a1.61 1.61 0 0 1 2.4-1.39l41.87 24.16a1.61 1.61 0 0 1 0 2.78L17.42 60.55a1.59 1.59 0 0 1-.8.21zm1.61-47.15v42.78L55.27 35z"
	  })),
	  height: undefined,
	  width: undefined
	});
	IconPlay.displayName = 'IconPlay';
	var _default = IconPlay;
	exports["default"] = _default;

/***/ },
/* 583 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _createIconComponent = _interopRequireDefault(__webpack_require__(5));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	var IconPrintSolid = (0, _createIconComponent["default"])({
	  content: _react["default"].createElement("g", null, _react["default"].createElement("path", {
	    d: "M61.08 34.46H8.92a2.44 2.44 0 0 0-2.44 2.44v18.34a6.37 6.37 0 0 0 6.38 6.38h44.28a6.37 6.37 0 0 0 6.38-6.38V36.9a2.44 2.44 0 0 0-2.44-2.44zm-50 9.37a2.51 2.51 0 0 1 0-3.54 2.51 2.51 0 1 1 0 3.54zm45.38 9.73a2 2 0 0 1-2 2h-39a2 2 0 0 1-2-2v-3.28a2 2 0 0 1 2-2h39a2 2 0 0 1 2 2zM55.44 21.29a4 4 0 0 0-1.16-2.82l-8.84-8.91a4 4 0 0 0-2.84-1.18H18.51a4 4 0 0 0-4 3.95v19.24h40.93z"
	  })),
	  height: undefined,
	  width: undefined
	});
	IconPrintSolid.displayName = 'IconPrintSolid';
	var _default = IconPrintSolid;
	exports["default"] = _default;

/***/ },
/* 584 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _createIconComponent = _interopRequireDefault(__webpack_require__(5));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	var IconQuestionMark = (0, _createIconComponent["default"])({
	  content: _react["default"].createElement("g", null, _react["default"].createElement("path", {
	    d: "M45.27 10.52A15.08 15.08 0 0 0 20 23.17a2.5 2.5 0 1 0 5-.54 10.09 10.09 0 1 1 17.16 6.15l-4.71 4.71a21.43 21.43 0 0 0-6.35 15.26V54a2.5 2.5 0 1 0 5 0v-5.25A16.47 16.47 0 0 1 41 37l4.71-4.71a15.15 15.15 0 0 0-.38-21.8z"
	  }), _react["default"].createElement("circle", {
	    cx: "33.59",
	    cy: "62.28",
	    r: "2.75"
	  })),
	  height: undefined,
	  width: undefined
	});
	IconQuestionMark.displayName = 'IconQuestionMark';
	var _default = IconQuestionMark;
	exports["default"] = _default;

/***/ },
/* 585 */,
/* 586 */,
/* 587 */,
/* 588 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _createIconComponent = _interopRequireDefault(__webpack_require__(5));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	var IconRss = (0, _createIconComponent["default"])({
	  content: _react["default"].createElement("g", null, _react["default"].createElement("path", {
	    d: "M14.87 50.56a4.57 4.57 0 1 0 4.57 4.57 4.57 4.57 0 0 0-4.57-4.57zm0 12.43a7.87 7.87 0 1 1 7.87-7.87A7.88 7.88 0 0 1 14.87 63z"
	  }), _react["default"].createElement("path", {
	    d: "M11.13 28.41a.83.83 0 0 0-.52.19.81.81 0 0 0-.3.64v4.07a.82.82 0 0 0 .65.8A32.84 32.84 0 0 1 27 43a32.83 32.83 0 0 1 8.88 16 .82.82 0 0 0 .8.65h4.07a.83.83 0 0 0 .81-1A38.37 38.37 0 0 0 31.07 39 38.37 38.37 0 0 0 11.3 28.43h-.17zM40.76 63h-4.07a4.1 4.1 0 0 1-4-3.23 29.53 29.53 0 0 0-8-14.46 29.54 29.54 0 0 0-14.46-8 4.1 4.1 0 0 1-3.23-4v-4.07a4.13 4.13 0 0 1 4.94-4 41.65 41.65 0 0 1 21.47 11.47 41.66 41.66 0 0 1 11.4 21.35 4.13 4.13 0 0 1-4 4.93z"
	  }), _react["default"].createElement("path", {
	    d: "M11.12 10.3a.81.81 0 0 0-.53.2.82.82 0 0 0-.28.62v4A.82.82 0 0 0 11 16a50.36 50.36 0 0 1 28.35 14A50.85 50.85 0 0 1 49 43.12 50.37 50.37 0 0 1 54 59a.83.83 0 0 0 .82.72h4a.82.82 0 0 0 .62-.28.81.81 0 0 0 .2-.64 55.94 55.94 0 0 0-5.36-17.58 56.44 56.44 0 0 0-10.4-14.64A56.48 56.48 0 0 0 29.1 15.82a56 56 0 0 0-17.87-5.51zM58.87 63h-4a4.16 4.16 0 0 1-4.09-3.56A47.08 47.08 0 0 0 46 44.63a47.55 47.55 0 0 0-9-12.25 47.09 47.09 0 0 0-26.44-13.14A4.15 4.15 0 0 1 7 15.16v-4A4.12 4.12 0 0 1 11.67 7a59.26 59.26 0 0 1 18.92 5.83 59.76 59.76 0 0 1 15.64 11.43 59.74 59.74 0 0 1 11.05 15.46A59.23 59.23 0 0 1 63 58.34 4.12 4.12 0 0 1 58.87 63z"
	  })),
	  height: undefined,
	  width: undefined
	});
	IconRss.displayName = 'IconRss';
	var _default = IconRss;
	exports["default"] = _default;

/***/ },
/* 589 */,
/* 590 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _createIconComponent = _interopRequireDefault(__webpack_require__(5));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	var IconStamp = (0, _createIconComponent["default"])({
	  content: _react["default"].createElement("g", null, _react["default"].createElement("path", {
	    d: "M59.2 37.41H43.06v-9l2.45-3.92A12.2 12.2 0 0 0 35.17 5.83h-.34a12.2 12.2 0 0 0-10.34 18.66l2.45 3.92v9H10.8A1.6 1.6 0 0 0 9.2 39v14.25a1.6 1.6 0 0 0 1.6 1.6h48.4a1.6 1.6 0 0 0 1.6-1.6V39a1.6 1.6 0 0 0-1.6-1.59zM25.83 18a9 9 0 0 1 9-9h.34a9 9 0 0 1 7.63 13.8l-2.7 4.31a1.6 1.6 0 0 0-.24.85v9.45h-9.72V28a1.6 1.6 0 0 0-.24-.85l-2.7-4.35a9 9 0 0 1-1.37-4.8zM57.6 51.65H12.4v-11h45.2zM17.7 60.17h34.6A3.2 3.2 0 0 0 55.5 57h-41a3.2 3.2 0 0 0 3.2 3.17z"
	  })),
	  height: undefined,
	  width: undefined
	});
	IconStamp.displayName = 'IconStamp';
	var _default = IconStamp;
	exports["default"] = _default;

/***/ },
/* 591 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _createIconComponent = _interopRequireDefault(__webpack_require__(5));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	var IconStarSolid = (0, _createIconComponent["default"])({
	  content: _react["default"].createElement("g", null, _react["default"].createElement("path", {
	    d: "M49.53 64.29a7.09 7.09 0 0 1-3.24-.8l-9.46-5a4 4 0 0 0-3.66 0l-9.46 5a6.94 6.94 0 0 1-10.07-7.32l1.81-10.54a4 4 0 0 0-1.13-3.48l-7.66-7.46a6.93 6.93 0 0 1 3.84-11.83l10.58-1.54a3.92 3.92 0 0 0 3-2.16l4.73-9.58a6.93 6.93 0 0 1 12.44 0L46 19.16a3.94 3.94 0 0 0 3 2.16l10.5 1.54a6.93 6.93 0 0 1 3.84 11.83l-7.66 7.46a4 4 0 0 0-1.13 3.49l1.81 10.53a6.95 6.95 0 0 1-6.83 8.12z"
	  })),
	  height: undefined,
	  width: undefined
	});
	IconStarSolid.displayName = 'IconStarSolid';
	var _default = IconStarSolid;
	exports["default"] = _default;

/***/ },
/* 592 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _createIconComponent = _interopRequireDefault(__webpack_require__(5));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	var IconStar = (0, _createIconComponent["default"])({
	  content: _react["default"].createElement("g", null, _react["default"].createElement("path", {
	    d: "M49.53 64.29a6.94 6.94 0 0 1-3.23-.8l-9.46-5a3.94 3.94 0 0 0-3.66 0l-9.46 5a6.94 6.94 0 0 1-10.07-7.31l1.81-10.54a3.93 3.93 0 0 0-1.13-3.48l-7.67-7.47a6.94 6.94 0 0 1 3.84-11.83l10.58-1.54a3.93 3.93 0 0 0 3-2.15l4.73-9.59a6.94 6.94 0 0 1 12.44 0L46 19.16a3.94 3.94 0 0 0 3 2.15l10.5 1.55a6.94 6.94 0 0 1 3.84 11.83l-7.66 7.46a3.94 3.94 0 0 0-1.13 3.49l1.81 10.54a7 7 0 0 1-6.83 8.12zM35 8.71a3.86 3.86 0 0 0-3.53 2.19l-4.73 9.59a6.94 6.94 0 0 1-5.22 3.79l-10.58 1.54a3.94 3.94 0 0 0-2.18 6.71L16.41 40a6.94 6.94 0 0 1 2 6.14L16.6 56.68a3.94 3.94 0 0 0 5.71 4.15l9.46-5a6.93 6.93 0 0 1 6.46 0l9.46 5a3.94 3.94 0 0 0 5.71-4.15l-1.8-10.54a6.94 6.94 0 0 1 2-6.14l7.66-7.46a3.94 3.94 0 0 0-2.18-6.71l-10.6-1.54a6.94 6.94 0 0 1-5.22-3.79l-4.73-9.59A3.86 3.86 0 0 0 35 8.71z"
	  })),
	  height: undefined,
	  width: undefined
	});
	IconStar.displayName = 'IconStar';
	var _default = IconStar;
	exports["default"] = _default;

/***/ },
/* 593 */,
/* 594 */,
/* 595 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _createIconComponent = _interopRequireDefault(__webpack_require__(5));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	var IconTools = (0, _createIconComponent["default"])({
	  content: _react["default"].createElement("g", null, _react["default"].createElement("path", {
	    d: "M46.38 39.1l16.5-16.51a1.6 1.6 0 0 0 0-2.26l-8.16-8.16a1.6 1.6 0 0 0-2.26 0l-11 11-5.5 5.5-4.31-4.31 1.59-1.59a1.6 1.6 0 0 0 0-2.26L30 17.24a24.94 24.94 0 0 1 10.53-7.55 1.6 1.6 0 0 0 .18-2.93c-.37-.19-9.17-4.47-18.56 4.93L11.67 22.16l-.25-.25a1.65 1.65 0 0 0-2.26 0l-5.53 5.53a1.6 1.6 0 0 0 0 2.26l11.59 11.59a1.6 1.6 0 0 0 2.26 0L23 35.76a1.6 1.6 0 0 0 0-2.26l-.25-.25 1.93-1.93 4.32 4.3-5.7 5.7-10.8 10.8a1.6 1.6 0 0 0 0 2.26l8.16 8.16a1.6 1.6 0 0 0 2.26 0L39.42 46l16.47 16.51a1.6 1.6 0 0 0 2.26 0l4.69-4.69a1.6 1.6 0 0 0 0-2.26zm-3.79-12.54l3.12 3.12A1.6 1.6 0 1 0 48 27.42l-3.15-3.12 3.79-3.79 3.12 3.12A1.6 1.6 0 1 0 54 21.36l-3.1-3.12 2.68-2.68 5.9 5.9-15.37 15.37-5.9-5.9zM16.35 37.9L7 28.57l3.27-3.27.25.25 8.83 8.83.25.25zM20.5 31l-6.56-6.56 10.47-10.49c4-4 7.74-5 10.49-5.12a26.94 26.94 0 0 0-8.39 7.69 1.6 1.6 0 0 0 .21 2l3.13 3.13zm1.29 28.18l-5.9-5.9 2.49-2.49 3.12 3.12a1.6 1.6 0 0 0 2.26-2.26l-3.12-3.12 3.79-3.79 3.12 3.12a1.6 1.6 0 1 0 2.26-2.26l-3.12-3.12 4.57-4.57 5.9 5.9zm35.23 0L27 29.05l2.43-2.43 30.01 30.07z"
	  })),
	  height: undefined,
	  width: undefined
	});
	IconTools.displayName = 'IconTools';
	var _default = IconTools;
	exports["default"] = _default;

/***/ },
/* 596 */,
/* 597 */,
/* 598 */,
/* 599 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _createIconComponent = _interopRequireDefault(__webpack_require__(5));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	var IconUserSquareSolid = (0, _createIconComponent["default"])({
	  content: _react["default"].createElement("g", null, _react["default"].createElement("path", {
	    d: "M35 36.44a13.72 13.72 0 1 0-13.72-13.71A13.73 13.73 0 0 0 35 36.44zM35 39.65c-21.36 0-19.75 12.94-22.17 30.35h44.34C54.75 52.59 56.36 39.65 35 39.65z"
	  })),
	  height: undefined,
	  width: undefined
	});
	IconUserSquareSolid.displayName = 'IconUserSquareSolid';
	var _default = IconUserSquareSolid;
	exports["default"] = _default;

/***/ },
/* 600 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _createIconComponent = _interopRequireDefault(__webpack_require__(5));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	var IconVisible = (0, _createIconComponent["default"])({
	  content: _react["default"].createElement("g", null, _react["default"].createElement("path", {
	    d: "M64.88 33.81C64.34 33.21 51.31 19 35 19S5.66 33.21 5.12 33.81a1.78 1.78 0 0 0 0 2.37C5.66 36.79 18.69 51 35 51s29.34-14.21 29.88-14.81a1.78 1.78 0 0 0 0-2.38zM35 47.44A12.44 12.44 0 1 1 47.44 35 12.46 12.46 0 0 1 35 47.44z"
	  }), _react["default"].createElement("path", {
	    d: "M36.78 31.45A5.31 5.31 0 0 1 39 27.12a8.77 8.77 0 0 0-4-1 8.89 8.89 0 1 0 8.74 10.38 5.3 5.3 0 0 1-6.96-5.05z"
	  })),
	  height: undefined,
	  width: undefined
	});
	IconVisible.displayName = 'IconVisible';
	var _default = IconVisible;
	exports["default"] = _default;

/***/ },
/* 601 */
/***/ function(module, exports) {

	var MILLISECONDS_IN_MINUTE = 60000
	
	/**
	 * Google Chrome as of 67.0.3396.87 introduced timezones with offset that includes seconds.
	 * They usually appear for dates that denote time before the timezones were introduced
	 * (e.g. for 'Europe/Prague' timezone the offset is GMT+00:57:44 before 1 October 1891
	 * and GMT+01:00:00 after that date)
	 *
	 * Date#getTimezoneOffset returns the offset in minutes and would return 57 for the example above,
	 * which would lead to incorrect calculations.
	 *
	 * This function returns the timezone offset in milliseconds that takes seconds in account.
	 */
	module.exports = function getTimezoneOffsetInMilliseconds (dirtyDate) {
	  var date = new Date(dirtyDate.getTime())
	  var baseTimezoneOffset = date.getTimezoneOffset()
	  date.setSeconds(0, 0)
	  var millisecondsPartOfTimezoneOffset = date.getTime() % MILLISECONDS_IN_MINUTE
	
	  return baseTimezoneOffset * MILLISECONDS_IN_MINUTE + millisecondsPartOfTimezoneOffset
	}


/***/ },
/* 602 */
/***/ function(module, exports, __webpack_require__) {

	var parse = __webpack_require__(130)
	var getDaysInMonth = __webpack_require__(603)
	
	/**
	 * @category Month Helpers
	 * @summary Add the specified number of months to the given date.
	 *
	 * @description
	 * Add the specified number of months to the given date.
	 *
	 * @param {Date|String|Number} date - the date to be changed
	 * @param {Number} amount - the amount of months to be added
	 * @returns {Date} the new date with the months added
	 *
	 * @example
	 * // Add 5 months to 1 September 2014:
	 * var result = addMonths(new Date(2014, 8, 1), 5)
	 * //=> Sun Feb 01 2015 00:00:00
	 */
	function addMonths (dirtyDate, dirtyAmount) {
	  var date = parse(dirtyDate)
	  var amount = Number(dirtyAmount)
	  var desiredMonth = date.getMonth() + amount
	  var dateWithDesiredMonth = new Date(0)
	  dateWithDesiredMonth.setFullYear(date.getFullYear(), desiredMonth, 1)
	  dateWithDesiredMonth.setHours(0, 0, 0, 0)
	  var daysInMonth = getDaysInMonth(dateWithDesiredMonth)
	  // Set the last day of the new month
	  // if the original date was the last day of the longer month
	  date.setMonth(desiredMonth, Math.min(daysInMonth, date.getDate()))
	  return date
	}
	
	module.exports = addMonths


/***/ },
/* 603 */
/***/ function(module, exports, __webpack_require__) {

	var parse = __webpack_require__(130)
	
	/**
	 * @category Month Helpers
	 * @summary Get the number of days in a month of the given date.
	 *
	 * @description
	 * Get the number of days in a month of the given date.
	 *
	 * @param {Date|String|Number} date - the given date
	 * @returns {Number} the number of days in a month
	 *
	 * @example
	 * // How many days are in February 2000?
	 * var result = getDaysInMonth(new Date(2000, 1))
	 * //=> 29
	 */
	function getDaysInMonth (dirtyDate) {
	  var date = parse(dirtyDate)
	  var year = date.getFullYear()
	  var monthIndex = date.getMonth()
	  var lastDayOfMonth = new Date(0)
	  lastDayOfMonth.setFullYear(year, monthIndex + 1, 0)
	  lastDayOfMonth.setHours(0, 0, 0, 0)
	  return lastDayOfMonth.getDate()
	}
	
	module.exports = getDaysInMonth


/***/ },
/* 604 */
/***/ function(module, exports, __webpack_require__) {

	var parse = __webpack_require__(130)
	
	/**
	 * @category Common Helpers
	 * @summary Is the first date after the second one?
	 *
	 * @description
	 * Is the first date after the second one?
	 *
	 * @param {Date|String|Number} date - the date that should be after the other one to return true
	 * @param {Date|String|Number} dateToCompare - the date to compare with
	 * @returns {Boolean} the first date is after the second date
	 *
	 * @example
	 * // Is 10 July 1989 after 11 February 1987?
	 * var result = isAfter(new Date(1989, 6, 10), new Date(1987, 1, 11))
	 * //=> true
	 */
	function isAfter (dirtyDate, dirtyDateToCompare) {
	  var date = parse(dirtyDate)
	  var dateToCompare = parse(dirtyDateToCompare)
	  return date.getTime() > dateToCompare.getTime()
	}
	
	module.exports = isAfter


/***/ },
/* 605 */
/***/ function(module, exports, __webpack_require__) {

	var parse = __webpack_require__(130)
	
	/**
	 * @category Common Helpers
	 * @summary Is the first date before the second one?
	 *
	 * @description
	 * Is the first date before the second one?
	 *
	 * @param {Date|String|Number} date - the date that should be before the other one to return true
	 * @param {Date|String|Number} dateToCompare - the date to compare with
	 * @returns {Boolean} the first date is before the second date
	 *
	 * @example
	 * // Is 10 July 1989 before 11 February 1987?
	 * var result = isBefore(new Date(1989, 6, 10), new Date(1987, 1, 11))
	 * //=> false
	 */
	function isBefore (dirtyDate, dirtyDateToCompare) {
	  var date = parse(dirtyDate)
	  var dateToCompare = parse(dirtyDateToCompare)
	  return date.getTime() < dateToCompare.getTime()
	}
	
	module.exports = isBefore


/***/ },
/* 606 */
/***/ function(module, exports) {

	/**
	 * @category Common Helpers
	 * @summary Is the given argument an instance of Date?
	 *
	 * @description
	 * Is the given argument an instance of Date?
	 *
	 * @param {*} argument - the argument to check
	 * @returns {Boolean} the given argument is an instance of Date
	 *
	 * @example
	 * // Is 'mayonnaise' a Date?
	 * var result = isDate('mayonnaise')
	 * //=> false
	 */
	function isDate (argument) {
	  return argument instanceof Date
	}
	
	module.exports = isDate


/***/ },
/* 607 */
/***/ function(module, exports, __webpack_require__) {

	var startOfDay = __webpack_require__(608)
	
	/**
	 * @category Day Helpers
	 * @summary Is the given date today?
	 *
	 * @description
	 * Is the given date today?
	 *
	 * @param {Date|String|Number} date - the date to check
	 * @returns {Boolean} the date is today
	 *
	 * @example
	 * // If today is 6 October 2014, is 6 October 14:00:00 today?
	 * var result = isToday(new Date(2014, 9, 6, 14, 0))
	 * //=> true
	 */
	function isToday (dirtyDate) {
	  return startOfDay(dirtyDate).getTime() === startOfDay(new Date()).getTime()
	}
	
	module.exports = isToday


/***/ },
/* 608 */
/***/ function(module, exports, __webpack_require__) {

	var parse = __webpack_require__(130)
	
	/**
	 * @category Day Helpers
	 * @summary Return the start of a day for the given date.
	 *
	 * @description
	 * Return the start of a day for the given date.
	 * The result will be in the local timezone.
	 *
	 * @param {Date|String|Number} date - the original date
	 * @returns {Date} the start of a day
	 *
	 * @example
	 * // The start of a day for 2 September 2014 11:55:00:
	 * var result = startOfDay(new Date(2014, 8, 2, 11, 55, 0))
	 * //=> Tue Sep 02 2014 00:00:00
	 */
	function startOfDay (dirtyDate) {
	  var date = parse(dirtyDate)
	  date.setHours(0, 0, 0, 0)
	  return date
	}
	
	module.exports = startOfDay


/***/ },
/* 609 */
/***/ function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {"use strict";
	
	// Use the fastest means possible to execute a task in its own turn, with
	// priority over other events including IO, animation, reflow, and redraw
	// events in browsers.
	//
	// An exception thrown by a task will permanently interrupt the processing of
	// subsequent tasks. The higher level `asap` function ensures that if an
	// exception is thrown by a task, that the task queue will continue flushing as
	// soon as possible, but if you use `rawAsap` directly, you are responsible to
	// either ensure that no exceptions are thrown from your task, or to manually
	// call `rawAsap.requestFlush` if an exception is thrown.
	module.exports = rawAsap;
	function rawAsap(task) {
	    if (!queue.length) {
	        requestFlush();
	        flushing = true;
	    }
	    // Equivalent to push, but avoids a function call.
	    queue[queue.length] = task;
	}
	
	var queue = [];
	// Once a flush has been requested, no further calls to `requestFlush` are
	// necessary until the next `flush` completes.
	var flushing = false;
	// `requestFlush` is an implementation-specific method that attempts to kick
	// off a `flush` event as quickly as possible. `flush` will attempt to exhaust
	// the event queue before yielding to the browser's own event loop.
	var requestFlush;
	// The position of the next task to execute in the task queue. This is
	// preserved between calls to `flush` so that it can be resumed if
	// a task throws an exception.
	var index = 0;
	// If a task schedules additional tasks recursively, the task queue can grow
	// unbounded. To prevent memory exhaustion, the task queue will periodically
	// truncate already-completed tasks.
	var capacity = 1024;
	
	// The flush function processes all tasks that have been scheduled with
	// `rawAsap` unless and until one of those tasks throws an exception.
	// If a task throws an exception, `flush` ensures that its state will remain
	// consistent and will resume where it left off when called again.
	// However, `flush` does not make any arrangements to be called again if an
	// exception is thrown.
	function flush() {
	    while (index < queue.length) {
	        var currentIndex = index;
	        // Advance the index before calling the task. This ensures that we will
	        // begin flushing on the next task the task throws an error.
	        index = index + 1;
	        queue[currentIndex].call();
	        // Prevent leaking memory for long chains of recursive calls to `asap`.
	        // If we call `asap` within tasks scheduled by `asap`, the queue will
	        // grow, but to avoid an O(n) walk for every task we execute, we don't
	        // shift tasks off the queue after they have been executed.
	        // Instead, we periodically shift 1024 tasks off the queue.
	        if (index > capacity) {
	            // Manually shift all values starting at the index back to the
	            // beginning of the queue.
	            for (var scan = 0, newLength = queue.length - index; scan < newLength; scan++) {
	                queue[scan] = queue[scan + index];
	            }
	            queue.length -= index;
	            index = 0;
	        }
	    }
	    queue.length = 0;
	    index = 0;
	    flushing = false;
	}
	
	// `requestFlush` is implemented using a strategy based on data collected from
	// every available SauceLabs Selenium web driver worker at time of writing.
	// https://docs.google.com/spreadsheets/d/1mG-5UYGup5qxGdEMWkhP6BWCz053NUb2E1QoUTU16uA/edit#gid=783724593
	
	// Safari 6 and 6.1 for desktop, iPad, and iPhone are the only browsers that
	// have WebKitMutationObserver but not un-prefixed MutationObserver.
	// Must use `global` or `self` instead of `window` to work in both frames and web
	// workers. `global` is a provision of Browserify, Mr, Mrs, or Mop.
	
	/* globals self */
	var scope = typeof global !== "undefined" ? global : self;
	var BrowserMutationObserver = scope.MutationObserver || scope.WebKitMutationObserver;
	
	// MutationObservers are desirable because they have high priority and work
	// reliably everywhere they are implemented.
	// They are implemented in all modern browsers.
	//
	// - Android 4-4.3
	// - Chrome 26-34
	// - Firefox 14-29
	// - Internet Explorer 11
	// - iPad Safari 6-7.1
	// - iPhone Safari 7-7.1
	// - Safari 6-7
	if (typeof BrowserMutationObserver === "function") {
	    requestFlush = makeRequestCallFromMutationObserver(flush);
	
	// MessageChannels are desirable because they give direct access to the HTML
	// task queue, are implemented in Internet Explorer 10, Safari 5.0-1, and Opera
	// 11-12, and in web workers in many engines.
	// Although message channels yield to any queued rendering and IO tasks, they
	// would be better than imposing the 4ms delay of timers.
	// However, they do not work reliably in Internet Explorer or Safari.
	
	// Internet Explorer 10 is the only browser that has setImmediate but does
	// not have MutationObservers.
	// Although setImmediate yields to the browser's renderer, it would be
	// preferrable to falling back to setTimeout since it does not have
	// the minimum 4ms penalty.
	// Unfortunately there appears to be a bug in Internet Explorer 10 Mobile (and
	// Desktop to a lesser extent) that renders both setImmediate and
	// MessageChannel useless for the purposes of ASAP.
	// https://github.com/kriskowal/q/issues/396
	
	// Timers are implemented universally.
	// We fall back to timers in workers in most engines, and in foreground
	// contexts in the following browsers.
	// However, note that even this simple case requires nuances to operate in a
	// broad spectrum of browsers.
	//
	// - Firefox 3-13
	// - Internet Explorer 6-9
	// - iPad Safari 4.3
	// - Lynx 2.8.7
	} else {
	    requestFlush = makeRequestCallFromTimer(flush);
	}
	
	// `requestFlush` requests that the high priority event queue be flushed as
	// soon as possible.
	// This is useful to prevent an error thrown in a task from stalling the event
	// queue if the exception handled by Node.js’s
	// `process.on("uncaughtException")` or by a domain.
	rawAsap.requestFlush = requestFlush;
	
	// To request a high priority event, we induce a mutation observer by toggling
	// the text of a text node between "1" and "-1".
	function makeRequestCallFromMutationObserver(callback) {
	    var toggle = 1;
	    var observer = new BrowserMutationObserver(callback);
	    var node = document.createTextNode("");
	    observer.observe(node, {characterData: true});
	    return function requestCall() {
	        toggle = -toggle;
	        node.data = toggle;
	    };
	}
	
	// The message channel technique was discovered by Malte Ubl and was the
	// original foundation for this library.
	// http://www.nonblocking.io/2011/06/windownexttick.html
	
	// Safari 6.0.5 (at least) intermittently fails to create message ports on a
	// page's first load. Thankfully, this version of Safari supports
	// MutationObservers, so we don't need to fall back in that case.
	
	// function makeRequestCallFromMessageChannel(callback) {
	//     var channel = new MessageChannel();
	//     channel.port1.onmessage = callback;
	//     return function requestCall() {
	//         channel.port2.postMessage(0);
	//     };
	// }
	
	// For reasons explained above, we are also unable to use `setImmediate`
	// under any circumstances.
	// Even if we were, there is another bug in Internet Explorer 10.
	// It is not sufficient to assign `setImmediate` to `requestFlush` because
	// `setImmediate` must be called *by name* and therefore must be wrapped in a
	// closure.
	// Never forget.
	
	// function makeRequestCallFromSetImmediate(callback) {
	//     return function requestCall() {
	//         setImmediate(callback);
	//     };
	// }
	
	// Safari 6.0 has a problem where timers will get lost while the user is
	// scrolling. This problem does not impact ASAP because Safari 6.0 supports
	// mutation observers, so that implementation is used instead.
	// However, if we ever elect to use timers in Safari, the prevalent work-around
	// is to add a scroll event listener that calls for a flush.
	
	// `setTimeout` does not call the passed callback if the delay is less than
	// approximately 7 in web workers in Firefox 8 through 18, and sometimes not
	// even then.
	
	function makeRequestCallFromTimer(callback) {
	    return function requestCall() {
	        // We dispatch a timeout with a specified delay of 0 for engines that
	        // can reliably accommodate that request. This will usually be snapped
	        // to a 4 milisecond delay, but once we're flushing, there's no delay
	        // between events.
	        var timeoutHandle = setTimeout(handleTimer, 0);
	        // However, since this timer gets frequently dropped in Firefox
	        // workers, we enlist an interval handle that will try to fire
	        // an event 20 times per second until it succeeds.
	        var intervalHandle = setInterval(handleTimer, 50);
	
	        function handleTimer() {
	            // Whichever timer succeeds will cancel both timers and
	            // execute the callback.
	            clearTimeout(timeoutHandle);
	            clearInterval(intervalHandle);
	            callback();
	        }
	    };
	}
	
	// This is for `asap.js` only.
	// Its name will be periodically randomized to break any code that depends on
	// its existence.
	rawAsap.makeRequestCallFromTimer = makeRequestCallFromTimer;
	
	// ASAP was originally a nextTick shim included in Q. This was factored out
	// into this ASAP package. It was later adapted to RSVP which made further
	// amendments. These decisions, particularly to marginalize MessageChannel and
	// to capture the MutationObserver implementation in a closure, were integrated
	// back into ASAP proper.
	// https://github.com/tildeio/rsvp.js/blob/cddf7232546a9cf858524b75cde6f9edf72620a7/lib/rsvp/asap.js
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 610 */
/***/ function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {/**
	 * Copyright (c) 2014, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * https://raw.github.com/facebook/regenerator/master/LICENSE file. An
	 * additional grant of patent rights can be found in the PATENTS file in
	 * the same directory.
	 */
	
	!(function(global) {
	  "use strict";
	
	  var Op = Object.prototype;
	  var hasOwn = Op.hasOwnProperty;
	  var undefined; // More compressible than void 0.
	  var $Symbol = typeof Symbol === "function" ? Symbol : {};
	  var iteratorSymbol = $Symbol.iterator || "@@iterator";
	  var asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator";
	  var toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";
	
	  var inModule = typeof module === "object";
	  var runtime = global.regeneratorRuntime;
	  if (runtime) {
	    if (inModule) {
	      // If regeneratorRuntime is defined globally and we're in a module,
	      // make the exports object identical to regeneratorRuntime.
	      module.exports = runtime;
	    }
	    // Don't bother evaluating the rest of this file if the runtime was
	    // already defined globally.
	    return;
	  }
	
	  // Define the runtime globally (as expected by generated code) as either
	  // module.exports (if we're in a module) or a new, empty object.
	  runtime = global.regeneratorRuntime = inModule ? module.exports : {};
	
	  function wrap(innerFn, outerFn, self, tryLocsList) {
	    // If outerFn provided and outerFn.prototype is a Generator, then outerFn.prototype instanceof Generator.
	    var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator;
	    var generator = Object.create(protoGenerator.prototype);
	    var context = new Context(tryLocsList || []);
	
	    // The ._invoke method unifies the implementations of the .next,
	    // .throw, and .return methods.
	    generator._invoke = makeInvokeMethod(innerFn, self, context);
	
	    return generator;
	  }
	  runtime.wrap = wrap;
	
	  // Try/catch helper to minimize deoptimizations. Returns a completion
	  // record like context.tryEntries[i].completion. This interface could
	  // have been (and was previously) designed to take a closure to be
	  // invoked without arguments, but in all the cases we care about we
	  // already have an existing method we want to call, so there's no need
	  // to create a new function object. We can even get away with assuming
	  // the method takes exactly one argument, since that happens to be true
	  // in every case, so we don't have to touch the arguments object. The
	  // only additional allocation required is the completion record, which
	  // has a stable shape and so hopefully should be cheap to allocate.
	  function tryCatch(fn, obj, arg) {
	    try {
	      return { type: "normal", arg: fn.call(obj, arg) };
	    } catch (err) {
	      return { type: "throw", arg: err };
	    }
	  }
	
	  var GenStateSuspendedStart = "suspendedStart";
	  var GenStateSuspendedYield = "suspendedYield";
	  var GenStateExecuting = "executing";
	  var GenStateCompleted = "completed";
	
	  // Returning this object from the innerFn has the same effect as
	  // breaking out of the dispatch switch statement.
	  var ContinueSentinel = {};
	
	  // Dummy constructor functions that we use as the .constructor and
	  // .constructor.prototype properties for functions that return Generator
	  // objects. For full spec compliance, you may wish to configure your
	  // minifier not to mangle the names of these two functions.
	  function Generator() {}
	  function GeneratorFunction() {}
	  function GeneratorFunctionPrototype() {}
	
	  // This is a polyfill for %IteratorPrototype% for environments that
	  // don't natively support it.
	  var IteratorPrototype = {};
	  IteratorPrototype[iteratorSymbol] = function () {
	    return this;
	  };
	
	  var getProto = Object.getPrototypeOf;
	  var NativeIteratorPrototype = getProto && getProto(getProto(values([])));
	  if (NativeIteratorPrototype &&
	      NativeIteratorPrototype !== Op &&
	      hasOwn.call(NativeIteratorPrototype, iteratorSymbol)) {
	    // This environment has a native %IteratorPrototype%; use it instead
	    // of the polyfill.
	    IteratorPrototype = NativeIteratorPrototype;
	  }
	
	  var Gp = GeneratorFunctionPrototype.prototype =
	    Generator.prototype = Object.create(IteratorPrototype);
	  GeneratorFunction.prototype = Gp.constructor = GeneratorFunctionPrototype;
	  GeneratorFunctionPrototype.constructor = GeneratorFunction;
	  GeneratorFunctionPrototype[toStringTagSymbol] =
	    GeneratorFunction.displayName = "GeneratorFunction";
	
	  // Helper for defining the .next, .throw, and .return methods of the
	  // Iterator interface in terms of a single ._invoke method.
	  function defineIteratorMethods(prototype) {
	    ["next", "throw", "return"].forEach(function(method) {
	      prototype[method] = function(arg) {
	        return this._invoke(method, arg);
	      };
	    });
	  }
	
	  runtime.isGeneratorFunction = function(genFun) {
	    var ctor = typeof genFun === "function" && genFun.constructor;
	    return ctor
	      ? ctor === GeneratorFunction ||
	        // For the native GeneratorFunction constructor, the best we can
	        // do is to check its .name property.
	        (ctor.displayName || ctor.name) === "GeneratorFunction"
	      : false;
	  };
	
	  runtime.mark = function(genFun) {
	    if (Object.setPrototypeOf) {
	      Object.setPrototypeOf(genFun, GeneratorFunctionPrototype);
	    } else {
	      genFun.__proto__ = GeneratorFunctionPrototype;
	      if (!(toStringTagSymbol in genFun)) {
	        genFun[toStringTagSymbol] = "GeneratorFunction";
	      }
	    }
	    genFun.prototype = Object.create(Gp);
	    return genFun;
	  };
	
	  // Within the body of any async function, `await x` is transformed to
	  // `yield regeneratorRuntime.awrap(x)`, so that the runtime can test
	  // `hasOwn.call(value, "__await")` to determine if the yielded value is
	  // meant to be awaited.
	  runtime.awrap = function(arg) {
	    return { __await: arg };
	  };
	
	  function AsyncIterator(generator) {
	    function invoke(method, arg, resolve, reject) {
	      var record = tryCatch(generator[method], generator, arg);
	      if (record.type === "throw") {
	        reject(record.arg);
	      } else {
	        var result = record.arg;
	        var value = result.value;
	        if (value &&
	            typeof value === "object" &&
	            hasOwn.call(value, "__await")) {
	          return Promise.resolve(value.__await).then(function(value) {
	            invoke("next", value, resolve, reject);
	          }, function(err) {
	            invoke("throw", err, resolve, reject);
	          });
	        }
	
	        return Promise.resolve(value).then(function(unwrapped) {
	          // When a yielded Promise is resolved, its final value becomes
	          // the .value of the Promise<{value,done}> result for the
	          // current iteration. If the Promise is rejected, however, the
	          // result for this iteration will be rejected with the same
	          // reason. Note that rejections of yielded Promises are not
	          // thrown back into the generator function, as is the case
	          // when an awaited Promise is rejected. This difference in
	          // behavior between yield and await is important, because it
	          // allows the consumer to decide what to do with the yielded
	          // rejection (swallow it and continue, manually .throw it back
	          // into the generator, abandon iteration, whatever). With
	          // await, by contrast, there is no opportunity to examine the
	          // rejection reason outside the generator function, so the
	          // only option is to throw it from the await expression, and
	          // let the generator function handle the exception.
	          result.value = unwrapped;
	          resolve(result);
	        }, reject);
	      }
	    }
	
	    if (typeof global.process === "object" && global.process.domain) {
	      invoke = global.process.domain.bind(invoke);
	    }
	
	    var previousPromise;
	
	    function enqueue(method, arg) {
	      function callInvokeWithMethodAndArg() {
	        return new Promise(function(resolve, reject) {
	          invoke(method, arg, resolve, reject);
	        });
	      }
	
	      return previousPromise =
	        // If enqueue has been called before, then we want to wait until
	        // all previous Promises have been resolved before calling invoke,
	        // so that results are always delivered in the correct order. If
	        // enqueue has not been called before, then it is important to
	        // call invoke immediately, without waiting on a callback to fire,
	        // so that the async generator function has the opportunity to do
	        // any necessary setup in a predictable way. This predictability
	        // is why the Promise constructor synchronously invokes its
	        // executor callback, and why async functions synchronously
	        // execute code before the first await. Since we implement simple
	        // async functions in terms of async generators, it is especially
	        // important to get this right, even though it requires care.
	        previousPromise ? previousPromise.then(
	          callInvokeWithMethodAndArg,
	          // Avoid propagating failures to Promises returned by later
	          // invocations of the iterator.
	          callInvokeWithMethodAndArg
	        ) : callInvokeWithMethodAndArg();
	    }
	
	    // Define the unified helper method that is used to implement .next,
	    // .throw, and .return (see defineIteratorMethods).
	    this._invoke = enqueue;
	  }
	
	  defineIteratorMethods(AsyncIterator.prototype);
	  AsyncIterator.prototype[asyncIteratorSymbol] = function () {
	    return this;
	  };
	  runtime.AsyncIterator = AsyncIterator;
	
	  // Note that simple async functions are implemented on top of
	  // AsyncIterator objects; they just return a Promise for the value of
	  // the final result produced by the iterator.
	  runtime.async = function(innerFn, outerFn, self, tryLocsList) {
	    var iter = new AsyncIterator(
	      wrap(innerFn, outerFn, self, tryLocsList)
	    );
	
	    return runtime.isGeneratorFunction(outerFn)
	      ? iter // If outerFn is a generator, return the full iterator.
	      : iter.next().then(function(result) {
	          return result.done ? result.value : iter.next();
	        });
	  };
	
	  function makeInvokeMethod(innerFn, self, context) {
	    var state = GenStateSuspendedStart;
	
	    return function invoke(method, arg) {
	      if (state === GenStateExecuting) {
	        throw new Error("Generator is already running");
	      }
	
	      if (state === GenStateCompleted) {
	        if (method === "throw") {
	          throw arg;
	        }
	
	        // Be forgiving, per 25.3.3.3.3 of the spec:
	        // https://people.mozilla.org/~jorendorff/es6-draft.html#sec-generatorresume
	        return doneResult();
	      }
	
	      context.method = method;
	      context.arg = arg;
	
	      while (true) {
	        var delegate = context.delegate;
	        if (delegate) {
	          var delegateResult = maybeInvokeDelegate(delegate, context);
	          if (delegateResult) {
	            if (delegateResult === ContinueSentinel) continue;
	            return delegateResult;
	          }
	        }
	
	        if (context.method === "next") {
	          // Setting context._sent for legacy support of Babel's
	          // function.sent implementation.
	          context.sent = context._sent = context.arg;
	
	        } else if (context.method === "throw") {
	          if (state === GenStateSuspendedStart) {
	            state = GenStateCompleted;
	            throw context.arg;
	          }
	
	          context.dispatchException(context.arg);
	
	        } else if (context.method === "return") {
	          context.abrupt("return", context.arg);
	        }
	
	        state = GenStateExecuting;
	
	        var record = tryCatch(innerFn, self, context);
	        if (record.type === "normal") {
	          // If an exception is thrown from innerFn, we leave state ===
	          // GenStateExecuting and loop back for another invocation.
	          state = context.done
	            ? GenStateCompleted
	            : GenStateSuspendedYield;
	
	          if (record.arg === ContinueSentinel) {
	            continue;
	          }
	
	          return {
	            value: record.arg,
	            done: context.done
	          };
	
	        } else if (record.type === "throw") {
	          state = GenStateCompleted;
	          // Dispatch the exception by looping back around to the
	          // context.dispatchException(context.arg) call above.
	          context.method = "throw";
	          context.arg = record.arg;
	        }
	      }
	    };
	  }
	
	  // Call delegate.iterator[context.method](context.arg) and handle the
	  // result, either by returning a { value, done } result from the
	  // delegate iterator, or by modifying context.method and context.arg,
	  // setting context.delegate to null, and returning the ContinueSentinel.
	  function maybeInvokeDelegate(delegate, context) {
	    var method = delegate.iterator[context.method];
	    if (method === undefined) {
	      // A .throw or .return when the delegate iterator has no .throw
	      // method always terminates the yield* loop.
	      context.delegate = null;
	
	      if (context.method === "throw") {
	        if (delegate.iterator.return) {
	          // If the delegate iterator has a return method, give it a
	          // chance to clean up.
	          context.method = "return";
	          context.arg = undefined;
	          maybeInvokeDelegate(delegate, context);
	
	          if (context.method === "throw") {
	            // If maybeInvokeDelegate(context) changed context.method from
	            // "return" to "throw", let that override the TypeError below.
	            return ContinueSentinel;
	          }
	        }
	
	        context.method = "throw";
	        context.arg = new TypeError(
	          "The iterator does not provide a 'throw' method");
	      }
	
	      return ContinueSentinel;
	    }
	
	    var record = tryCatch(method, delegate.iterator, context.arg);
	
	    if (record.type === "throw") {
	      context.method = "throw";
	      context.arg = record.arg;
	      context.delegate = null;
	      return ContinueSentinel;
	    }
	
	    var info = record.arg;
	
	    if (! info) {
	      context.method = "throw";
	      context.arg = new TypeError("iterator result is not an object");
	      context.delegate = null;
	      return ContinueSentinel;
	    }
	
	    if (info.done) {
	      // Assign the result of the finished delegate to the temporary
	      // variable specified by delegate.resultName (see delegateYield).
	      context[delegate.resultName] = info.value;
	
	      // Resume execution at the desired location (see delegateYield).
	      context.next = delegate.nextLoc;
	
	      // If context.method was "throw" but the delegate handled the
	      // exception, let the outer generator proceed normally. If
	      // context.method was "next", forget context.arg since it has been
	      // "consumed" by the delegate iterator. If context.method was
	      // "return", allow the original .return call to continue in the
	      // outer generator.
	      if (context.method !== "return") {
	        context.method = "next";
	        context.arg = undefined;
	      }
	
	    } else {
	      // Re-yield the result returned by the delegate method.
	      return info;
	    }
	
	    // The delegate iterator is finished, so forget it and continue with
	    // the outer generator.
	    context.delegate = null;
	    return ContinueSentinel;
	  }
	
	  // Define Generator.prototype.{next,throw,return} in terms of the
	  // unified ._invoke helper method.
	  defineIteratorMethods(Gp);
	
	  Gp[toStringTagSymbol] = "Generator";
	
	  // A Generator should always return itself as the iterator object when the
	  // @@iterator function is called on it. Some browsers' implementations of the
	  // iterator prototype chain incorrectly implement this, causing the Generator
	  // object to not be returned from this call. This ensures that doesn't happen.
	  // See https://github.com/facebook/regenerator/issues/274 for more details.
	  Gp[iteratorSymbol] = function() {
	    return this;
	  };
	
	  Gp.toString = function() {
	    return "[object Generator]";
	  };
	
	  function pushTryEntry(locs) {
	    var entry = { tryLoc: locs[0] };
	
	    if (1 in locs) {
	      entry.catchLoc = locs[1];
	    }
	
	    if (2 in locs) {
	      entry.finallyLoc = locs[2];
	      entry.afterLoc = locs[3];
	    }
	
	    this.tryEntries.push(entry);
	  }
	
	  function resetTryEntry(entry) {
	    var record = entry.completion || {};
	    record.type = "normal";
	    delete record.arg;
	    entry.completion = record;
	  }
	
	  function Context(tryLocsList) {
	    // The root entry object (effectively a try statement without a catch
	    // or a finally block) gives us a place to store values thrown from
	    // locations where there is no enclosing try statement.
	    this.tryEntries = [{ tryLoc: "root" }];
	    tryLocsList.forEach(pushTryEntry, this);
	    this.reset(true);
	  }
	
	  runtime.keys = function(object) {
	    var keys = [];
	    for (var key in object) {
	      keys.push(key);
	    }
	    keys.reverse();
	
	    // Rather than returning an object with a next method, we keep
	    // things simple and return the next function itself.
	    return function next() {
	      while (keys.length) {
	        var key = keys.pop();
	        if (key in object) {
	          next.value = key;
	          next.done = false;
	          return next;
	        }
	      }
	
	      // To avoid creating an additional object, we just hang the .value
	      // and .done properties off the next function object itself. This
	      // also ensures that the minifier will not anonymize the function.
	      next.done = true;
	      return next;
	    };
	  };
	
	  function values(iterable) {
	    if (iterable) {
	      var iteratorMethod = iterable[iteratorSymbol];
	      if (iteratorMethod) {
	        return iteratorMethod.call(iterable);
	      }
	
	      if (typeof iterable.next === "function") {
	        return iterable;
	      }
	
	      if (!isNaN(iterable.length)) {
	        var i = -1, next = function next() {
	          while (++i < iterable.length) {
	            if (hasOwn.call(iterable, i)) {
	              next.value = iterable[i];
	              next.done = false;
	              return next;
	            }
	          }
	
	          next.value = undefined;
	          next.done = true;
	
	          return next;
	        };
	
	        return next.next = next;
	      }
	    }
	
	    // Return an iterator with no values.
	    return { next: doneResult };
	  }
	  runtime.values = values;
	
	  function doneResult() {
	    return { value: undefined, done: true };
	  }
	
	  Context.prototype = {
	    constructor: Context,
	
	    reset: function(skipTempReset) {
	      this.prev = 0;
	      this.next = 0;
	      // Resetting context._sent for legacy support of Babel's
	      // function.sent implementation.
	      this.sent = this._sent = undefined;
	      this.done = false;
	      this.delegate = null;
	
	      this.method = "next";
	      this.arg = undefined;
	
	      this.tryEntries.forEach(resetTryEntry);
	
	      if (!skipTempReset) {
	        for (var name in this) {
	          // Not sure about the optimal order of these conditions:
	          if (name.charAt(0) === "t" &&
	              hasOwn.call(this, name) &&
	              !isNaN(+name.slice(1))) {
	            this[name] = undefined;
	          }
	        }
	      }
	    },
	
	    stop: function() {
	      this.done = true;
	
	      var rootEntry = this.tryEntries[0];
	      var rootRecord = rootEntry.completion;
	      if (rootRecord.type === "throw") {
	        throw rootRecord.arg;
	      }
	
	      return this.rval;
	    },
	
	    dispatchException: function(exception) {
	      if (this.done) {
	        throw exception;
	      }
	
	      var context = this;
	      function handle(loc, caught) {
	        record.type = "throw";
	        record.arg = exception;
	        context.next = loc;
	
	        if (caught) {
	          // If the dispatched exception was caught by a catch block,
	          // then let that catch block handle the exception normally.
	          context.method = "next";
	          context.arg = undefined;
	        }
	
	        return !! caught;
	      }
	
	      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
	        var entry = this.tryEntries[i];
	        var record = entry.completion;
	
	        if (entry.tryLoc === "root") {
	          // Exception thrown outside of any try block that could handle
	          // it, so set the completion value of the entire function to
	          // throw the exception.
	          return handle("end");
	        }
	
	        if (entry.tryLoc <= this.prev) {
	          var hasCatch = hasOwn.call(entry, "catchLoc");
	          var hasFinally = hasOwn.call(entry, "finallyLoc");
	
	          if (hasCatch && hasFinally) {
	            if (this.prev < entry.catchLoc) {
	              return handle(entry.catchLoc, true);
	            } else if (this.prev < entry.finallyLoc) {
	              return handle(entry.finallyLoc);
	            }
	
	          } else if (hasCatch) {
	            if (this.prev < entry.catchLoc) {
	              return handle(entry.catchLoc, true);
	            }
	
	          } else if (hasFinally) {
	            if (this.prev < entry.finallyLoc) {
	              return handle(entry.finallyLoc);
	            }
	
	          } else {
	            throw new Error("try statement without catch or finally");
	          }
	        }
	      }
	    },
	
	    abrupt: function(type, arg) {
	      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
	        var entry = this.tryEntries[i];
	        if (entry.tryLoc <= this.prev &&
	            hasOwn.call(entry, "finallyLoc") &&
	            this.prev < entry.finallyLoc) {
	          var finallyEntry = entry;
	          break;
	        }
	      }
	
	      if (finallyEntry &&
	          (type === "break" ||
	           type === "continue") &&
	          finallyEntry.tryLoc <= arg &&
	          arg <= finallyEntry.finallyLoc) {
	        // Ignore the finally entry if control is not jumping to a
	        // location outside the try/catch block.
	        finallyEntry = null;
	      }
	
	      var record = finallyEntry ? finallyEntry.completion : {};
	      record.type = type;
	      record.arg = arg;
	
	      if (finallyEntry) {
	        this.method = "next";
	        this.next = finallyEntry.finallyLoc;
	        return ContinueSentinel;
	      }
	
	      return this.complete(record);
	    },
	
	    complete: function(record, afterLoc) {
	      if (record.type === "throw") {
	        throw record.arg;
	      }
	
	      if (record.type === "break" ||
	          record.type === "continue") {
	        this.next = record.arg;
	      } else if (record.type === "return") {
	        this.rval = this.arg = record.arg;
	        this.method = "return";
	        this.next = "end";
	      } else if (record.type === "normal" && afterLoc) {
	        this.next = afterLoc;
	      }
	
	      return ContinueSentinel;
	    },
	
	    finish: function(finallyLoc) {
	      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
	        var entry = this.tryEntries[i];
	        if (entry.finallyLoc === finallyLoc) {
	          this.complete(entry.completion, entry.afterLoc);
	          resetTryEntry(entry);
	          return ContinueSentinel;
	        }
	      }
	    },
	
	    "catch": function(tryLoc) {
	      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
	        var entry = this.tryEntries[i];
	        if (entry.tryLoc === tryLoc) {
	          var record = entry.completion;
	          if (record.type === "throw") {
	            var thrown = record.arg;
	            resetTryEntry(entry);
	          }
	          return thrown;
	        }
	      }
	
	      // The context.catch method must only be called with a location
	      // argument that corresponds to a known catch block.
	      throw new Error("illegal catch attempt");
	    },
	
	    delegateYield: function(iterable, resultName, nextLoc) {
	      this.delegate = {
	        iterator: values(iterable),
	        resultName: resultName,
	        nextLoc: nextLoc
	      };
	
	      if (this.method === "next") {
	        // Deliberately forget the last sent value so that we don't
	        // accidentally pass it on to the delegate.
	        this.arg = undefined;
	      }
	
	      return ContinueSentinel;
	    }
	  };
	})(
	  // Among the various tricks for obtaining a reference to the global
	  // object, this seems to be the most reliable technique that does not
	  // use indirect eval (which violates Content Security Policy).
	  typeof global === "object" ? global :
	  typeof window === "object" ? window :
	  typeof self === "object" ? self : this
	);
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 611 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {// This method of obtaining a reference to the global object needs to be
	// kept identical to the way it is obtained in runtime.js
	var g =
	  typeof global === "object" ? global :
	  typeof window === "object" ? window :
	  typeof self === "object" ? self : this;
	
	// Use `getOwnPropertyNames` because not all browsers support calling
	// `hasOwnProperty` on the global `self` object in a worker. See #183.
	var hadRuntime = g.regeneratorRuntime &&
	  Object.getOwnPropertyNames(g).indexOf("regeneratorRuntime") >= 0;
	
	// Save the old regeneratorRuntime in case it needs to be restored later.
	var oldRuntime = hadRuntime && g.regeneratorRuntime;
	
	// Force reevalutation of runtime.js.
	g.regeneratorRuntime = undefined;
	
	module.exports = __webpack_require__(612);
	
	if (hadRuntime) {
	  // Restore the original runtime.
	  g.regeneratorRuntime = oldRuntime;
	} else {
	  // Remove the global property added by runtime.js.
	  try {
	    delete g.regeneratorRuntime;
	  } catch(e) {
	    g.regeneratorRuntime = undefined;
	  }
	}
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 612 */
610,
/* 613 */
/***/ function(module, exports) {

	'use strict'
	
	module.exports = bail
	
	function bail(err) {
	  if (err) {
	    throw err
	  }
	}


/***/ },
/* 614 */
/***/ function(module, exports) {

	'use strict'
	
	exports.byteLength = byteLength
	exports.toByteArray = toByteArray
	exports.fromByteArray = fromByteArray
	
	var lookup = []
	var revLookup = []
	var Arr = typeof Uint8Array !== 'undefined' ? Uint8Array : Array
	
	var code = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/'
	for (var i = 0, len = code.length; i < len; ++i) {
	  lookup[i] = code[i]
	  revLookup[code.charCodeAt(i)] = i
	}
	
	// Support decoding URL-safe base64 strings, as Node.js does.
	// See: https://en.wikipedia.org/wiki/Base64#URL_applications
	revLookup['-'.charCodeAt(0)] = 62
	revLookup['_'.charCodeAt(0)] = 63
	
	function getLens (b64) {
	  var len = b64.length
	
	  if (len % 4 > 0) {
	    throw new Error('Invalid string. Length must be a multiple of 4')
	  }
	
	  // Trim off extra bytes after placeholder bytes are found
	  // See: https://github.com/beatgammit/base64-js/issues/42
	  var validLen = b64.indexOf('=')
	  if (validLen === -1) validLen = len
	
	  var placeHoldersLen = validLen === len
	    ? 0
	    : 4 - (validLen % 4)
	
	  return [validLen, placeHoldersLen]
	}
	
	// base64 is 4/3 + up to two characters of the original data
	function byteLength (b64) {
	  var lens = getLens(b64)
	  var validLen = lens[0]
	  var placeHoldersLen = lens[1]
	  return ((validLen + placeHoldersLen) * 3 / 4) - placeHoldersLen
	}
	
	function _byteLength (b64, validLen, placeHoldersLen) {
	  return ((validLen + placeHoldersLen) * 3 / 4) - placeHoldersLen
	}
	
	function toByteArray (b64) {
	  var tmp
	  var lens = getLens(b64)
	  var validLen = lens[0]
	  var placeHoldersLen = lens[1]
	
	  var arr = new Arr(_byteLength(b64, validLen, placeHoldersLen))
	
	  var curByte = 0
	
	  // if there are placeholders, only get up to the last complete 4 chars
	  var len = placeHoldersLen > 0
	    ? validLen - 4
	    : validLen
	
	  var i
	  for (i = 0; i < len; i += 4) {
	    tmp =
	      (revLookup[b64.charCodeAt(i)] << 18) |
	      (revLookup[b64.charCodeAt(i + 1)] << 12) |
	      (revLookup[b64.charCodeAt(i + 2)] << 6) |
	      revLookup[b64.charCodeAt(i + 3)]
	    arr[curByte++] = (tmp >> 16) & 0xFF
	    arr[curByte++] = (tmp >> 8) & 0xFF
	    arr[curByte++] = tmp & 0xFF
	  }
	
	  if (placeHoldersLen === 2) {
	    tmp =
	      (revLookup[b64.charCodeAt(i)] << 2) |
	      (revLookup[b64.charCodeAt(i + 1)] >> 4)
	    arr[curByte++] = tmp & 0xFF
	  }
	
	  if (placeHoldersLen === 1) {
	    tmp =
	      (revLookup[b64.charCodeAt(i)] << 10) |
	      (revLookup[b64.charCodeAt(i + 1)] << 4) |
	      (revLookup[b64.charCodeAt(i + 2)] >> 2)
	    arr[curByte++] = (tmp >> 8) & 0xFF
	    arr[curByte++] = tmp & 0xFF
	  }
	
	  return arr
	}
	
	function tripletToBase64 (num) {
	  return lookup[num >> 18 & 0x3F] +
	    lookup[num >> 12 & 0x3F] +
	    lookup[num >> 6 & 0x3F] +
	    lookup[num & 0x3F]
	}
	
	function encodeChunk (uint8, start, end) {
	  var tmp
	  var output = []
	  for (var i = start; i < end; i += 3) {
	    tmp =
	      ((uint8[i] << 16) & 0xFF0000) +
	      ((uint8[i + 1] << 8) & 0xFF00) +
	      (uint8[i + 2] & 0xFF)
	    output.push(tripletToBase64(tmp))
	  }
	  return output.join('')
	}
	
	function fromByteArray (uint8) {
	  var tmp
	  var len = uint8.length
	  var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
	  var parts = []
	  var maxChunkLength = 16383 // must be multiple of 3
	
	  // go through the array every three bytes, we'll deal with trailing stuff later
	  for (var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength) {
	    parts.push(encodeChunk(
	      uint8, i, (i + maxChunkLength) > len2 ? len2 : (i + maxChunkLength)
	    ))
	  }
	
	  // pad the end with zeros, but make sure to not forget the extra bytes
	  if (extraBytes === 1) {
	    tmp = uint8[len - 1]
	    parts.push(
	      lookup[tmp >> 2] +
	      lookup[(tmp << 4) & 0x3F] +
	      '=='
	    )
	  } else if (extraBytes === 2) {
	    tmp = (uint8[len - 2] << 8) + uint8[len - 1]
	    parts.push(
	      lookup[tmp >> 10] +
	      lookup[(tmp >> 4) & 0x3F] +
	      lookup[(tmp << 2) & 0x3F] +
	      '='
	    )
	  }
	
	  return parts.join('')
	}


/***/ },
/* 615 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var utils = __webpack_require__(616);
	
	module.exports = function batchProcessorMaker(options) {
	    options             = options || {};
	    var reporter        = options.reporter;
	    var asyncProcess    = utils.getOption(options, "async", true);
	    var autoProcess     = utils.getOption(options, "auto", true);
	
	    if(autoProcess && !asyncProcess) {
	        reporter && reporter.warn("Invalid options combination. auto=true and async=false is invalid. Setting async=true.");
	        asyncProcess = true;
	    }
	
	    var batch = Batch();
	    var asyncFrameHandler;
	    var isProcessing = false;
	
	    function addFunction(level, fn) {
	        if(!isProcessing && autoProcess && asyncProcess && batch.size() === 0) {
	            // Since this is async, it is guaranteed to be executed after that the fn is added to the batch.
	            // This needs to be done before, since we're checking the size of the batch to be 0.
	            processBatchAsync();
	        }
	
	        batch.add(level, fn);
	    }
	
	    function processBatch() {
	        // Save the current batch, and create a new batch so that incoming functions are not added into the currently processing batch.
	        // Continue processing until the top-level batch is empty (functions may be added to the new batch while processing, and so on).
	        isProcessing = true;
	        while (batch.size()) {
	            var processingBatch = batch;
	            batch = Batch();
	            processingBatch.process();
	        }
	        isProcessing = false;
	    }
	
	    function forceProcessBatch(localAsyncProcess) {
	        if (isProcessing) {
	            return;
	        }
	
	        if(localAsyncProcess === undefined) {
	            localAsyncProcess = asyncProcess;
	        }
	
	        if(asyncFrameHandler) {
	            cancelFrame(asyncFrameHandler);
	            asyncFrameHandler = null;
	        }
	
	        if(localAsyncProcess) {
	            processBatchAsync();
	        } else {
	            processBatch();
	        }
	    }
	
	    function processBatchAsync() {
	        asyncFrameHandler = requestFrame(processBatch);
	    }
	
	    function clearBatch() {
	        batch           = {};
	        batchSize       = 0;
	        topLevel        = 0;
	        bottomLevel     = 0;
	    }
	
	    function cancelFrame(listener) {
	        // var cancel = window.cancelAnimationFrame || window.mozCancelAnimationFrame || window.webkitCancelAnimationFrame || window.clearTimeout;
	        var cancel = clearTimeout;
	        return cancel(listener);
	    }
	
	    function requestFrame(callback) {
	        // var raf = window.requestAnimationFrame || window.mozRequestAnimationFrame || window.webkitRequestAnimationFrame || function(fn) { return window.setTimeout(fn, 20); };
	        var raf = function(fn) { return setTimeout(fn, 0); };
	        return raf(callback);
	    }
	
	    return {
	        add: addFunction,
	        force: forceProcessBatch
	    };
	};
	
	function Batch() {
	    var batch       = {};
	    var size        = 0;
	    var topLevel    = 0;
	    var bottomLevel = 0;
	
	    function add(level, fn) {
	        if(!fn) {
	            fn = level;
	            level = 0;
	        }
	
	        if(level > topLevel) {
	            topLevel = level;
	        } else if(level < bottomLevel) {
	            bottomLevel = level;
	        }
	
	        if(!batch[level]) {
	            batch[level] = [];
	        }
	
	        batch[level].push(fn);
	        size++;
	    }
	
	    function process() {
	        for(var level = bottomLevel; level <= topLevel; level++) {
	            var fns = batch[level];
	
	            for(var i = 0; i < fns.length; i++) {
	                var fn = fns[i];
	                fn();
	            }
	        }
	    }
	
	    function getSize() {
	        return size;
	    }
	
	    return {
	        add: add,
	        process: process,
	        size: getSize
	    };
	}


/***/ },
/* 616 */
/***/ function(module, exports) {

	"use strict";
	
	var utils = module.exports = {};
	
	utils.getOption = getOption;
	
	function getOption(options, name, defaultValue) {
	    var value = options[name];
	
	    if((value === undefined || value === null) && defaultValue !== undefined) {
	        return defaultValue;
	    }
	
	    return value;
	}


/***/ },
/* 617 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Buffer) {var aes = __webpack_require__(230);
	var Transform = __webpack_require__(231);
	var inherits = __webpack_require__(58);
	var modes = __webpack_require__(232);
	var StreamCipher = __webpack_require__(348);
	var ebtk = __webpack_require__(342);
	
	inherits(Decipher, Transform);
	function Decipher(mode, key, iv) {
	  if (!(this instanceof Decipher)) {
	    return new Decipher(mode, key, iv);
	  }
	  Transform.call(this);
	  this._cache = new Splitter();
	  this._last = void 0;
	  this._cipher = new aes.AES(key);
	  this._prev = new Buffer(iv.length);
	  iv.copy(this._prev);
	  this._mode = mode;
	}
	Decipher.prototype._transform = function (data, _, next) {
	  this._cache.add(data);
	  var chunk;
	  var thing;
	  while ((chunk = this._cache.get())) {
	    thing = this._mode.decrypt(this, chunk);
	    this.push(thing);
	  }
	  next();
	};
	Decipher.prototype._flush = function (next) {
	  var chunk = this._cache.flush();
	  if (!chunk) {
	    return next;
	  }
	
	  this.push(unpad(this._mode.decrypt(this, chunk)));
	
	  next();
	};
	
	function Splitter() {
	   if (!(this instanceof Splitter)) {
	    return new Splitter();
	  }
	  this.cache = new Buffer('');
	}
	Splitter.prototype.add = function (data) {
	  this.cache = Buffer.concat([this.cache, data]);
	};
	
	Splitter.prototype.get = function () {
	  if (this.cache.length > 16) {
	    var out = this.cache.slice(0, 16);
	    this.cache = this.cache.slice(16);
	    return out;
	  }
	  return null;
	};
	Splitter.prototype.flush = function () {
	  if (this.cache.length) {
	    return this.cache;
	  }
	};
	function unpad(last) {
	  var padded = last[15];
	  if (padded === 16) {
	    return;
	  }
	  return last.slice(0, 16 - padded);
	}
	
	var modelist = {
	  ECB: __webpack_require__(346),
	  CBC: __webpack_require__(343),
	  CFB: __webpack_require__(344),
	  OFB: __webpack_require__(347),
	  CTR: __webpack_require__(345)
	};
	
	module.exports = function (crypto) {
	  function createDecipheriv(suite, password, iv) {
	    var config = modes[suite];
	    if (!config) {
	      throw new TypeError('invalid suite type');
	    }
	    if (typeof iv === 'string') {
	      iv = new Buffer(iv);
	    }
	    if (typeof password === 'string') {
	      password = new Buffer(password);
	    }
	    if (password.length !== config.key/8) {
	      throw new TypeError('invalid key length ' + password.length);
	    }
	    if (iv.length !== config.iv) {
	      throw new TypeError('invalid iv length ' + iv.length);
	    }
	    if (config.type === 'stream') {
	      return new StreamCipher(modelist[config.mode], password, iv, true);
	    }
	    return new Decipher(modelist[config.mode], password, iv);
	  }
	
	  function createDecipher (suite, password) {
	    var config = modes[suite];
	    if (!config) {
	      throw new TypeError('invalid suite type');
	    }
	    var keys = ebtk(crypto, password, config.key, config.iv);
	    return createDecipheriv(suite, keys.key, keys.iv);
	  }
	  return {
	    createDecipher: createDecipher,
	    createDecipheriv: createDecipheriv
	  };
	};
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(31).Buffer))

/***/ },
/* 618 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Buffer) {var aes = __webpack_require__(230);
	var Transform = __webpack_require__(231);
	var inherits = __webpack_require__(58);
	var modes = __webpack_require__(232);
	var ebtk = __webpack_require__(342);
	var StreamCipher = __webpack_require__(348);
	inherits(Cipher, Transform);
	function Cipher(mode, key, iv) {
	  if (!(this instanceof Cipher)) {
	    return new Cipher(mode, key, iv);
	  }
	  Transform.call(this);
	  this._cache = new Splitter();
	  this._cipher = new aes.AES(key);
	  this._prev = new Buffer(iv.length);
	  iv.copy(this._prev);
	  this._mode = mode;
	}
	Cipher.prototype._transform = function (data, _, next) {
	  this._cache.add(data);
	  var chunk;
	  var thing;
	  while ((chunk = this._cache.get())) {
	    thing = this._mode.encrypt(this, chunk);
	    this.push(thing);
	  }
	  next();
	};
	Cipher.prototype._flush = function (next) {
	  var chunk = this._cache.flush();
	  this.push(this._mode.encrypt(this, chunk));
	  this._cipher.scrub();
	  next();
	};
	
	
	function Splitter() {
	   if (!(this instanceof Splitter)) {
	    return new Splitter();
	  }
	  this.cache = new Buffer('');
	}
	Splitter.prototype.add = function (data) {
	  this.cache = Buffer.concat([this.cache, data]);
	};
	
	Splitter.prototype.get = function () {
	  if (this.cache.length > 15) {
	    var out = this.cache.slice(0, 16);
	    this.cache = this.cache.slice(16);
	    return out;
	  }
	  return null;
	};
	Splitter.prototype.flush = function () {
	  var len = 16 - this.cache.length;
	  var padBuff = new Buffer(len);
	
	  var i = -1;
	  while (++i < len) {
	    padBuff.writeUInt8(len, i);
	  }
	  var out = Buffer.concat([this.cache, padBuff]);
	  return out;
	};
	var modelist = {
	  ECB: __webpack_require__(346),
	  CBC: __webpack_require__(343),
	  CFB: __webpack_require__(344),
	  OFB: __webpack_require__(347),
	  CTR: __webpack_require__(345)
	};
	module.exports = function (crypto) {
	  function createCipheriv(suite, password, iv) {
	    var config = modes[suite];
	    if (!config) {
	      throw new TypeError('invalid suite type');
	    }
	    if (typeof iv === 'string') {
	      iv = new Buffer(iv);
	    }
	    if (typeof password === 'string') {
	      password = new Buffer(password);
	    }
	    if (password.length !== config.key/8) {
	      throw new TypeError('invalid key length ' + password.length);
	    }
	    if (iv.length !== config.iv) {
	      throw new TypeError('invalid iv length ' + iv.length);
	    }
	    if (config.type === 'stream') {
	      return new StreamCipher(modelist[config.mode], password, iv);
	    }
	    return new Cipher(modelist[config.mode], password, iv);
	  }
	  function createCipher (suite, password) {
	    var config = modes[suite];
	    if (!config) {
	      throw new TypeError('invalid suite type');
	    }
	    var keys = ebtk(crypto, password, config.key, config.iv);
	    return createCipheriv(suite, keys.key, keys.iv);
	  }
	  return {
	    createCipher: createCipher,
	    createCipheriv: createCipheriv
	  };
	};
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(31).Buffer))

/***/ },
/* 619 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = function (crypto, exports) {
	  exports = exports || {};
	  var ciphers = __webpack_require__(618)(crypto);
	  exports.createCipher = ciphers.createCipher;
	  exports.createCipheriv = ciphers.createCipheriv;
	  var deciphers = __webpack_require__(617)(crypto);
	  exports.createDecipher = deciphers.createDecipher;
	  exports.createDecipheriv = deciphers.createDecipheriv;
	  var modes = __webpack_require__(232);
	  function listCiphers () {
	    return Object.keys(modes);
	  }
	  exports.listCiphers = listCiphers;
	};
	


/***/ },
/* 620 */
/***/ function(module, exports) {

	'use strict'
	
	module.exports = collapse
	
	// `collapse(' \t\nbar \nbaz\t') // ' bar baz '`
	function collapse(value) {
	  return String(value).replace(/\s+/g, ' ')
	}


/***/ },
/* 621 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports["default"] = void 0;
	
	function isElement(el) {
	  return el != null && typeof el === 'object' && el.nodeType === 1;
	}
	
	function canOverflow(overflow, skipOverflowHiddenElements) {
	  if (skipOverflowHiddenElements && overflow === 'hidden') {
	    return false;
	  }
	
	  return overflow !== 'visible' && overflow !== 'clip';
	}
	
	function getFrameElement(el) {
	  if (!el.ownerDocument || !el.ownerDocument.defaultView) {
	    return null;
	  }
	
	  return el.ownerDocument.defaultView.frameElement;
	}
	
	function isHiddenByFrame(el) {
	  var frame = getFrameElement(el);
	
	  if (!frame) {
	    return false;
	  }
	
	  return frame.clientHeight < el.scrollHeight || frame.clientWidth < el.scrollWidth;
	}
	
	function isScrollable(el, skipOverflowHiddenElements) {
	  if (el.clientHeight < el.scrollHeight || el.clientWidth < el.scrollWidth) {
	    var style = getComputedStyle(el, null);
	    return canOverflow(style.overflowY, skipOverflowHiddenElements) || canOverflow(style.overflowX, skipOverflowHiddenElements) || isHiddenByFrame(el);
	  }
	
	  return false;
	}
	
	function alignNearest(scrollingEdgeStart, scrollingEdgeEnd, scrollingSize, scrollingBorderStart, scrollingBorderEnd, elementEdgeStart, elementEdgeEnd, elementSize) {
	  if (elementEdgeStart < scrollingEdgeStart && elementEdgeEnd > scrollingEdgeEnd || elementEdgeStart > scrollingEdgeStart && elementEdgeEnd < scrollingEdgeEnd) {
	    return 0;
	  }
	
	  if (elementEdgeStart <= scrollingEdgeStart && elementSize <= scrollingSize || elementEdgeEnd >= scrollingEdgeEnd && elementSize >= scrollingSize) {
	    return elementEdgeStart - scrollingEdgeStart - scrollingBorderStart;
	  }
	
	  if (elementEdgeEnd > scrollingEdgeEnd && elementSize < scrollingSize || elementEdgeStart < scrollingEdgeStart && elementSize > scrollingSize) {
	    return elementEdgeEnd - scrollingEdgeEnd + scrollingBorderEnd;
	  }
	
	  return 0;
	}
	
	var _default = function _default(target, options) {
	  var scrollMode = options.scrollMode,
	      block = options.block,
	      inline = options.inline,
	      boundary = options.boundary,
	      skipOverflowHiddenElements = options.skipOverflowHiddenElements;
	  var checkBoundary = typeof boundary === 'function' ? boundary : function (node) {
	    return node !== boundary;
	  };
	
	  if (!isElement(target)) {
	    throw new TypeError('Invalid target');
	  }
	
	  var scrollingElement = document.scrollingElement || document.documentElement;
	  var frames = [];
	  var cursor = target;
	
	  while (isElement(cursor) && checkBoundary(cursor)) {
	    cursor = cursor.parentNode;
	
	    if (cursor === scrollingElement) {
	      frames.push(cursor);
	      break;
	    }
	
	    if (cursor === document.body && isScrollable(cursor) && !isScrollable(document.documentElement)) {
	      continue;
	    }
	
	    if (isScrollable(cursor, skipOverflowHiddenElements)) {
	      frames.push(cursor);
	    }
	  }
	
	  var viewportWidth = window.visualViewport ? visualViewport.width : innerWidth;
	  var viewportHeight = window.visualViewport ? visualViewport.height : innerHeight;
	  var viewportX = window.scrollX || pageXOffset;
	  var viewportY = window.scrollY || pageYOffset;
	
	  var _target$getBoundingCl = target.getBoundingClientRect(),
	      targetHeight = _target$getBoundingCl.height,
	      targetWidth = _target$getBoundingCl.width,
	      targetTop = _target$getBoundingCl.top,
	      targetRight = _target$getBoundingCl.right,
	      targetBottom = _target$getBoundingCl.bottom,
	      targetLeft = _target$getBoundingCl.left;
	
	  var targetBlock = block === 'start' || block === 'nearest' ? targetTop : block === 'end' ? targetBottom : targetTop + targetHeight / 2;
	  var targetInline = inline === 'center' ? targetLeft + targetWidth / 2 : inline === 'end' ? targetRight : targetLeft;
	  var computations = [];
	
	  for (var index = 0; index < frames.length; index++) {
	    var frame = frames[index];
	
	    var _frame$getBoundingCli = frame.getBoundingClientRect(),
	        height = _frame$getBoundingCli.height,
	        width = _frame$getBoundingCli.width,
	        top = _frame$getBoundingCli.top,
	        right = _frame$getBoundingCli.right,
	        bottom = _frame$getBoundingCli.bottom,
	        left = _frame$getBoundingCli.left;
	
	    if (scrollMode === 'if-needed' && targetTop >= 0 && targetLeft >= 0 && targetBottom <= viewportHeight && targetRight <= viewportWidth && targetTop >= top && targetBottom <= bottom && targetLeft >= left && targetRight <= right) {
	      return computations;
	    }
	
	    var frameStyle = getComputedStyle(frame);
	    var borderLeft = parseInt(frameStyle.borderLeftWidth, 10);
	    var borderTop = parseInt(frameStyle.borderTopWidth, 10);
	    var borderRight = parseInt(frameStyle.borderRightWidth, 10);
	    var borderBottom = parseInt(frameStyle.borderBottomWidth, 10);
	    var blockScroll = 0;
	    var inlineScroll = 0;
	    var scrollbarWidth = 'offsetWidth' in frame ? frame.offsetWidth - frame.clientWidth - borderLeft - borderRight : 0;
	    var scrollbarHeight = 'offsetHeight' in frame ? frame.offsetHeight - frame.clientHeight - borderTop - borderBottom : 0;
	
	    if (scrollingElement === frame) {
	      if (block === 'start') {
	        blockScroll = targetBlock;
	      } else if (block === 'end') {
	        blockScroll = targetBlock - viewportHeight;
	      } else if (block === 'nearest') {
	        blockScroll = alignNearest(viewportY, viewportY + viewportHeight, viewportHeight, borderTop, borderBottom, viewportY + targetBlock, viewportY + targetBlock + targetHeight, targetHeight);
	      } else {
	        blockScroll = targetBlock - viewportHeight / 2;
	      }
	
	      if (inline === 'start') {
	        inlineScroll = targetInline;
	      } else if (inline === 'center') {
	        inlineScroll = targetInline - viewportWidth / 2;
	      } else if (inline === 'end') {
	        inlineScroll = targetInline - viewportWidth;
	      } else {
	        inlineScroll = alignNearest(viewportX, viewportX + viewportWidth, viewportWidth, borderLeft, borderRight, viewportX + targetInline, viewportX + targetInline + targetWidth, targetWidth);
	      }
	
	      blockScroll = Math.max(0, blockScroll + viewportY);
	      inlineScroll = Math.max(0, inlineScroll + viewportX);
	    } else {
	      if (block === 'start') {
	        blockScroll = targetBlock - top - borderTop;
	      } else if (block === 'end') {
	        blockScroll = targetBlock - bottom + borderBottom + scrollbarHeight;
	      } else if (block === 'nearest') {
	        blockScroll = alignNearest(top, bottom, height, borderTop, borderBottom + scrollbarHeight, targetBlock, targetBlock + targetHeight, targetHeight);
	      } else {
	        blockScroll = targetBlock - (top + height / 2) + scrollbarHeight / 2;
	      }
	
	      if (inline === 'start') {
	        inlineScroll = targetInline - left - borderLeft;
	      } else if (inline === 'center') {
	        inlineScroll = targetInline - (left + width / 2) + scrollbarWidth / 2;
	      } else if (inline === 'end') {
	        inlineScroll = targetInline - right + borderRight + scrollbarWidth;
	      } else {
	        inlineScroll = alignNearest(left, right, width, borderLeft, borderRight + scrollbarWidth, targetInline, targetInline + targetWidth, targetWidth);
	      }
	
	      var scrollLeft = frame.scrollLeft,
	          scrollTop = frame.scrollTop;
	      blockScroll = Math.max(0, Math.min(scrollTop + blockScroll, frame.scrollHeight - height + scrollbarHeight));
	      inlineScroll = Math.max(0, Math.min(scrollLeft + inlineScroll, frame.scrollWidth - width + scrollbarWidth));
	      targetBlock += scrollTop - blockScroll;
	      targetInline += scrollLeft - inlineScroll;
	    }
	
	    computations.push({
	      el: frame,
	      top: blockScroll,
	      left: inlineScroll
	    });
	  }
	
	  return computations;
	};
	
	exports["default"] = _default;
	module.exports = exports.default;

/***/ },
/* 622 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(20));
	
	var _reactRedux = __webpack_require__(7);
	
	var _reactRouter = __webpack_require__(212);
	
	var _lodash = _interopRequireDefault(__webpack_require__(1182));
	
	var _actions = __webpack_require__(164);
	
	var _selectors = _interopRequireDefault(__webpack_require__(351));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _createSuper(Derived) { return function () { var Super = _getPrototypeOf(Derived), result; if (_isNativeReflectConstruct()) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
	
	function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }
	
	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }
	
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
	
	var createConnectedRouter = function createConnectedRouter(structure) {
	  var _createSelectors = (0, _selectors["default"])(structure),
	      getLocation = _createSelectors.getLocation;
	  /*
	   * ConnectedRouter listens to a history object passed from props.
	   * When history is changed, it dispatches action to redux store.
	   * Then, store will pass props to component to render.
	   * This creates uni-directional flow from history->store->router->components.
	   */
	
	
	  var ConnectedRouter = /*#__PURE__*/function (_PureComponent) {
	    _inherits(ConnectedRouter, _PureComponent);
	
	    var _super = _createSuper(ConnectedRouter);
	
	    function ConnectedRouter(props) {
	      var _this;
	
	      _classCallCheck(this, ConnectedRouter);
	
	      _this = _super.call(this, props);
	      var store = props.store,
	          history = props.history,
	          onLocationChanged = props.onLocationChanged,
	          stateCompareFunction = props.stateCompareFunction;
	      _this.inTimeTravelling = false; // Subscribe to store changes to check if we are in time travelling
	
	      _this.unsubscribe = store.subscribe(function () {
	        // Allow time travel debugging compatibility to be turned off
	        // as the detection for this (below) is error prone in apps where the
	        // store may be unmounted, a navigation occurs, and then the store is re-mounted
	        // during the app's lifetime. Detection could be much improved if Redux DevTools
	        // simply set a global variable like `REDUX_DEVTOOLS_IS_TIME_TRAVELLING=true`.
	        var isTimeTravelDebuggingAllowed = !props.noTimeTravelDebugging; // Extract store's location
	
	        var _getLocation = getLocation(store.getState()),
	            pathnameInStore = _getLocation.pathname,
	            searchInStore = _getLocation.search,
	            hashInStore = _getLocation.hash,
	            stateInStore = _getLocation.state; // Extract history's location
	
	
	        var _history$location = history.location,
	            pathnameInHistory = _history$location.pathname,
	            searchInHistory = _history$location.search,
	            hashInHistory = _history$location.hash,
	            stateInHistory = _history$location.state; // If we do time travelling, the location in store is changed but location in history is not changed
	
	        if (isTimeTravelDebuggingAllowed && props.history.action === 'PUSH' && (pathnameInHistory !== pathnameInStore || searchInHistory !== searchInStore || hashInHistory !== hashInStore || !(0, _lodash["default"])(stateInStore, stateInHistory, stateCompareFunction))) {
	          _this.inTimeTravelling = true; // Update history's location to match store's location
	
	          history.push({
	            pathname: pathnameInStore,
	            search: searchInStore,
	            hash: hashInStore,
	            state: stateInStore
	          });
	        }
	      });
	
	      var handleLocationChange = function handleLocationChange(location, action) {
	        var isFirstRendering = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
	
	        // Dispatch onLocationChanged except when we're in time travelling
	        if (!_this.inTimeTravelling) {
	          onLocationChanged(location, action, isFirstRendering);
	        } else {
	          _this.inTimeTravelling = false;
	        }
	      }; // Listen to history changes
	
	
	      _this.unlisten = history.listen(handleLocationChange);
	
	      if (!props.noInitialPop) {
	        // Dispatch a location change action for the initial location.
	        // This makes it backward-compatible with react-router-redux.
	        // But, we add `isFirstRendering` to `true` to prevent double-rendering.
	        handleLocationChange(history.location, history.action, true);
	      }
	
	      return _this;
	    }
	
	    _createClass(ConnectedRouter, [{
	      key: "componentWillUnmount",
	      value: function componentWillUnmount() {
	        this.unlisten();
	        this.unsubscribe();
	      }
	    }, {
	      key: "render",
	      value: function render() {
	        var _this$props = this.props,
	            omitRouter = _this$props.omitRouter,
	            history = _this$props.history,
	            children = _this$props.children; // The `omitRouter` option is available for applications that must
	        // have a Router instance higher in the component tree but still desire
	        // to use connected-react-router for its Redux integration.
	
	        if (omitRouter) {
	          return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, children);
	        }
	
	        return /*#__PURE__*/_react["default"].createElement(_reactRouter.Router, {
	          history: history
	        }, children);
	      }
	    }]);
	
	    return ConnectedRouter;
	  }(_react.PureComponent);
	
	  ConnectedRouter.propTypes = {
	    store: _propTypes["default"].shape({
	      getState: _propTypes["default"].func.isRequired,
	      subscribe: _propTypes["default"].func.isRequired
	    }).isRequired,
	    history: _propTypes["default"].shape({
	      action: _propTypes["default"].string.isRequired,
	      listen: _propTypes["default"].func.isRequired,
	      location: _propTypes["default"].object.isRequired,
	      push: _propTypes["default"].func.isRequired
	    }).isRequired,
	    basename: _propTypes["default"].string,
	    children: _propTypes["default"].oneOfType([_propTypes["default"].func, _propTypes["default"].node]),
	    onLocationChanged: _propTypes["default"].func.isRequired,
	    noInitialPop: _propTypes["default"].bool,
	    noTimeTravelDebugging: _propTypes["default"].bool,
	    stateCompareFunction: _propTypes["default"].func,
	    omitRouter: _propTypes["default"].bool
	  };
	
	  var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	    return {
	      onLocationChanged: function onLocationChanged(location, action, isFirstRendering) {
	        return dispatch((0, _actions.onLocationChanged)(location, action, isFirstRendering));
	      }
	    };
	  };
	
	  var ConnectedRouterWithContext = function ConnectedRouterWithContext(props) {
	    var Context = props.context || _reactRedux.ReactReduxContext;
	
	    if (Context == null) {
	      throw 'Please upgrade to react-redux v6';
	    }
	
	    return /*#__PURE__*/_react["default"].createElement(Context.Consumer, null, function (_ref) {
	      var store = _ref.store;
	      return /*#__PURE__*/_react["default"].createElement(ConnectedRouter, _extends({
	        store: store
	      }, props));
	    });
	  };
	
	  ConnectedRouterWithContext.propTypes = {
	    context: _propTypes["default"].object
	  };
	  return (0, _reactRedux.connect)(null, mapDispatchToProps)(ConnectedRouterWithContext);
	};
	
	var _default = createConnectedRouter;
	exports["default"] = _default;

/***/ },
/* 623 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _actions = __webpack_require__(164);
	
	function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
	
	function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
	
	function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(n); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
	
	function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter); }
	
	function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
	
	function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
	
	/**
	 * This middleware captures CALL_HISTORY_METHOD actions to redirect to the
	 * provided history object. This will prevent these actions from reaching your
	 * reducer or any middleware that comes after this one.
	 */
	var routerMiddleware = function routerMiddleware(history) {
	  return function (store) {
	    return function (next) {
	      return function (action) {
	        // eslint-disable-line no-unused-vars
	        if (action.type !== _actions.CALL_HISTORY_METHOD) {
	          return next(action);
	        }
	
	        var _action$payload = action.payload,
	            method = _action$payload.method,
	            args = _action$payload.args;
	        history[method].apply(history, _toConsumableArray(args));
	      };
	    };
	  };
	};
	
	var _default = routerMiddleware;
	exports["default"] = _default;

/***/ },
/* 624 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _actions = __webpack_require__(164);
	
	function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
	
	function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
	
	function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(n); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
	
	function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
	
	function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
	
	function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
	
	function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }
	
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	/**
	 * Adds query to location.
	 * Utilises the search prop of location to construct query.
	 */
	var injectQuery = function injectQuery(location) {
	  if (location && location.query) {
	    // Don't inject query if it already exists in history
	    return location;
	  }
	
	  var searchQuery = location && location.search;
	
	  if (typeof searchQuery !== 'string' || searchQuery.length === 0) {
	    return _objectSpread({}, location, {
	      query: {}
	    });
	  } // Ignore the `?` part of the search string e.g. ?username=codejockie
	
	
	  var search = searchQuery.substring(1); // Split the query string on `&` e.g. ?username=codejockie&name=Kennedy
	
	  var queries = search.split('&'); // Contruct query
	
	  var query = queries.reduce(function (acc, currentQuery) {
	    // Split on `=`, to get key and value
	    var _currentQuery$split = currentQuery.split('='),
	        _currentQuery$split2 = _slicedToArray(_currentQuery$split, 2),
	        queryKey = _currentQuery$split2[0],
	        queryValue = _currentQuery$split2[1];
	
	    return _objectSpread({}, acc, _defineProperty({}, queryKey, queryValue));
	  }, {});
	  return _objectSpread({}, location, {
	    query: query
	  });
	};
	
	var createConnectRouter = function createConnectRouter(structure) {
	  var fromJS = structure.fromJS,
	      merge = structure.merge;
	
	  var createRouterReducer = function createRouterReducer(history) {
	    var initialRouterState = fromJS({
	      location: injectQuery(history.location),
	      action: history.action
	    });
	    /*
	    * This reducer will update the state with the most recent location history
	    * has transitioned to.
	    */
	
	    return function () {
	      var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialRouterState;
	
	      var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
	          type = _ref.type,
	          payload = _ref.payload;
	
	      if (type === _actions.LOCATION_CHANGE) {
	        var location = payload.location,
	            action = payload.action,
	            isFirstRendering = payload.isFirstRendering; // Don't update the state ref for the first rendering
	        // to prevent the double-rendering issue on initilization
	
	        return isFirstRendering ? state : merge(state, {
	          location: fromJS(injectQuery(location)),
	          action: action
	        });
	      }
	
	      return state;
	    };
	  };
	
	  return createRouterReducer;
	};
	
	var _default = createConnectRouter;
	exports["default"] = _default;

/***/ },
/* 625 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	/* Code from github.com/erikras/redux-form by Erik Rasmussen */
	var getIn = function getIn(state, path) {
	  if (!state) {
	    return state;
	  }
	
	  var length = path.length;
	
	  if (!length) {
	    return undefined;
	  }
	
	  var result = state;
	
	  for (var i = 0; i < length && !!result; ++i) {
	    result = result[path[i]];
	  }
	
	  return result;
	};
	
	var _default = getIn;
	exports["default"] = _default;

/***/ },
/* 626 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _getIn = _interopRequireDefault(__webpack_require__(625));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }
	
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var structure = {
	  fromJS: function fromJS(value) {
	    return value;
	  },
	  getIn: _getIn["default"],
	  merge: function merge(state, payload) {
	    return _objectSpread({}, state, {}, payload);
	  },
	  toJS: function toJS(value) {
	    return value;
	  }
	};
	var _default = structure;
	exports["default"] = _default;

/***/ },
/* 627 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(634);
	module.exports = __webpack_require__(54).RegExp.escape;


/***/ },
/* 628 */
/***/ function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(23);
	var isArray = __webpack_require__(168);
	var SPECIES = __webpack_require__(26)('species');
	
	module.exports = function (original) {
	  var C;
	  if (isArray(original)) {
	    C = original.constructor;
	    // cross-realm fallback
	    if (typeof C == 'function' && (C === Array || isArray(C.prototype))) C = undefined;
	    if (isObject(C)) {
	      C = C[SPECIES];
	      if (C === null) C = undefined;
	    }
	  } return C === undefined ? Array : C;
	};


/***/ },
/* 629 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// 20.3.4.36 / 15.9.5.43 Date.prototype.toISOString()
	var fails = __webpack_require__(21);
	var getTime = Date.prototype.getTime;
	var $toISOString = Date.prototype.toISOString;
	
	var lz = function (num) {
	  return num > 9 ? num : '0' + num;
	};
	
	// PhantomJS / old WebKit has a broken implementations
	module.exports = (fails(function () {
	  return $toISOString.call(new Date(-5e13 - 1)) != '0385-07-25T07:06:39.999Z';
	}) || !fails(function () {
	  $toISOString.call(new Date(NaN));
	})) ? function toISOString() {
	  if (!isFinite(getTime.call(this))) throw RangeError('Invalid time value');
	  var d = this;
	  var y = d.getUTCFullYear();
	  var m = d.getUTCMilliseconds();
	  var s = y < 0 ? '-' : y > 9999 ? '+' : '';
	  return s + ('00000' + Math.abs(y)).slice(s ? -6 : -4) +
	    '-' + lz(d.getUTCMonth() + 1) + '-' + lz(d.getUTCDate()) +
	    'T' + lz(d.getUTCHours()) + ':' + lz(d.getUTCMinutes()) +
	    ':' + lz(d.getUTCSeconds()) + '.' + (m > 99 ? m : '0' + lz(m)) + 'Z';
	} : $toISOString;


/***/ },
/* 630 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var anObject = __webpack_require__(15);
	var toPrimitive = __webpack_require__(64);
	var NUMBER = 'number';
	
	module.exports = function (hint) {
	  if (hint !== 'string' && hint !== NUMBER && hint !== 'default') throw TypeError('Incorrect hint');
	  return toPrimitive(anObject(this), hint != NUMBER);
	};


/***/ },
/* 631 */
/***/ function(module, exports, __webpack_require__) {

	// all enumerable object keys, includes symbols
	var getKeys = __webpack_require__(91);
	var gOPS = __webpack_require__(172);
	var pIE = __webpack_require__(133);
	module.exports = function (it) {
	  var result = getKeys(it);
	  var getSymbols = gOPS.f;
	  if (getSymbols) {
	    var symbols = getSymbols(it);
	    var isEnum = pIE.f;
	    var i = 0;
	    var key;
	    while (symbols.length > i) if (isEnum.call(it, key = symbols[i++])) result.push(key);
	  } return result;
	};


/***/ },
/* 632 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(134)('native-function-to-string', Function.toString);


/***/ },
/* 633 */
/***/ function(module, exports) {

	module.exports = function (regExp, replace) {
	  var replacer = replace === Object(replace) ? function (part) {
	    return replace[part];
	  } : replace;
	  return function (it) {
	    return String(it).replace(regExp, replacer);
	  };
	};


/***/ },
/* 634 */
/***/ function(module, exports, __webpack_require__) {

	// https://github.com/benjamingr/RexExp.escape
	var $export = __webpack_require__(4);
	var $re = __webpack_require__(633)(/[\\^$*+?.()|[\]{}]/g, '\\$&');
	
	$export($export.S, 'RegExp', { escape: function escape(it) { return $re(it); } });


/***/ },
/* 635 */
/***/ function(module, exports, __webpack_require__) {

	// 22.1.3.3 Array.prototype.copyWithin(target, start, end = this.length)
	var $export = __webpack_require__(4);
	
	$export($export.P, 'Array', { copyWithin: __webpack_require__(353) });
	
	__webpack_require__(81)('copyWithin');


/***/ },
/* 636 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(4);
	var $every = __webpack_require__(61)(4);
	
	$export($export.P + $export.F * !__webpack_require__(56)([].every, true), 'Array', {
	  // 22.1.3.5 / 15.4.4.16 Array.prototype.every(callbackfn [, thisArg])
	  every: function every(callbackfn /* , thisArg */) {
	    return $every(this, callbackfn, arguments[1]);
	  }
	});


/***/ },
/* 637 */
/***/ function(module, exports, __webpack_require__) {

	// 22.1.3.6 Array.prototype.fill(value, start = 0, end = this.length)
	var $export = __webpack_require__(4);
	
	$export($export.P, 'Array', { fill: __webpack_require__(234) });
	
	__webpack_require__(81)('fill');


/***/ },
/* 638 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(4);
	var $filter = __webpack_require__(61)(2);
	
	$export($export.P + $export.F * !__webpack_require__(56)([].filter, true), 'Array', {
	  // 22.1.3.7 / 15.4.4.20 Array.prototype.filter(callbackfn [, thisArg])
	  filter: function filter(callbackfn /* , thisArg */) {
	    return $filter(this, callbackfn, arguments[1]);
	  }
	});


/***/ },
/* 639 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// 22.1.3.9 Array.prototype.findIndex(predicate, thisArg = undefined)
	var $export = __webpack_require__(4);
	var $find = __webpack_require__(61)(6);
	var KEY = 'findIndex';
	var forced = true;
	// Shouldn't skip holes
	if (KEY in []) Array(1)[KEY](function () { forced = false; });
	$export($export.P + $export.F * forced, 'Array', {
	  findIndex: function findIndex(callbackfn /* , that = undefined */) {
	    return $find(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
	  }
	});
	__webpack_require__(81)(KEY);


/***/ },
/* 640 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// 22.1.3.8 Array.prototype.find(predicate, thisArg = undefined)
	var $export = __webpack_require__(4);
	var $find = __webpack_require__(61)(5);
	var KEY = 'find';
	var forced = true;
	// Shouldn't skip holes
	if (KEY in []) Array(1)[KEY](function () { forced = false; });
	$export($export.P + $export.F * forced, 'Array', {
	  find: function find(callbackfn /* , that = undefined */) {
	    return $find(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
	  }
	});
	__webpack_require__(81)(KEY);


/***/ },
/* 641 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(4);
	var $forEach = __webpack_require__(61)(0);
	var STRICT = __webpack_require__(56)([].forEach, true);
	
	$export($export.P + $export.F * !STRICT, 'Array', {
	  // 22.1.3.10 / 15.4.4.18 Array.prototype.forEach(callbackfn [, thisArg])
	  forEach: function forEach(callbackfn /* , thisArg */) {
	    return $forEach(this, callbackfn, arguments[1]);
	  }
	});


/***/ },
/* 642 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var ctx = __webpack_require__(55);
	var $export = __webpack_require__(4);
	var toObject = __webpack_require__(34);
	var call = __webpack_require__(364);
	var isArrayIter = __webpack_require__(242);
	var toLength = __webpack_require__(27);
	var createProperty = __webpack_require__(236);
	var getIterFn = __webpack_require__(258);
	
	$export($export.S + $export.F * !__webpack_require__(170)(function (iter) { Array.from(iter); }), 'Array', {
	  // 22.1.2.1 Array.from(arrayLike, mapfn = undefined, thisArg = undefined)
	  from: function from(arrayLike /* , mapfn = undefined, thisArg = undefined */) {
	    var O = toObject(arrayLike);
	    var C = typeof this == 'function' ? this : Array;
	    var aLen = arguments.length;
	    var mapfn = aLen > 1 ? arguments[1] : undefined;
	    var mapping = mapfn !== undefined;
	    var index = 0;
	    var iterFn = getIterFn(O);
	    var length, result, step, iterator;
	    if (mapping) mapfn = ctx(mapfn, aLen > 2 ? arguments[2] : undefined, 2);
	    // if object isn't iterable or it's array with default iterator - use simple case
	    if (iterFn != undefined && !(C == Array && isArrayIter(iterFn))) {
	      for (iterator = iterFn.call(O), result = new C(); !(step = iterator.next()).done; index++) {
	        createProperty(result, index, mapping ? call(iterator, mapfn, [step.value, index], true) : step.value);
	      }
	    } else {
	      length = toLength(O.length);
	      for (result = new C(length); length > index; index++) {
	        createProperty(result, index, mapping ? mapfn(O[index], index) : O[index]);
	      }
	    }
	    result.length = index;
	    return result;
	  }
	});


/***/ },
/* 643 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(4);
	var $indexOf = __webpack_require__(165)(false);
	var $native = [].indexOf;
	var NEGATIVE_ZERO = !!$native && 1 / [1].indexOf(1, -0) < 0;
	
	$export($export.P + $export.F * (NEGATIVE_ZERO || !__webpack_require__(56)($native)), 'Array', {
	  // 22.1.3.11 / 15.4.4.14 Array.prototype.indexOf(searchElement [, fromIndex])
	  indexOf: function indexOf(searchElement /* , fromIndex = 0 */) {
	    return NEGATIVE_ZERO
	      // convert -0 to +0
	      ? $native.apply(this, arguments) || 0
	      : $indexOf(this, searchElement, arguments[1]);
	  }
	});


/***/ },
/* 644 */
/***/ function(module, exports, __webpack_require__) {

	// 22.1.2.2 / 15.4.3.2 Array.isArray(arg)
	var $export = __webpack_require__(4);
	
	$export($export.S, 'Array', { isArray: __webpack_require__(168) });


/***/ },
/* 645 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// 22.1.3.13 Array.prototype.join(separator)
	var $export = __webpack_require__(4);
	var toIObject = __webpack_require__(49);
	var arrayJoin = [].join;
	
	// fallback for not array-like strings
	$export($export.P + $export.F * (__webpack_require__(132) != Object || !__webpack_require__(56)(arrayJoin)), 'Array', {
	  join: function join(separator) {
	    return arrayJoin.call(toIObject(this), separator === undefined ? ',' : separator);
	  }
	});


/***/ },
/* 646 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(4);
	var toIObject = __webpack_require__(49);
	var toInteger = __webpack_require__(57);
	var toLength = __webpack_require__(27);
	var $native = [].lastIndexOf;
	var NEGATIVE_ZERO = !!$native && 1 / [1].lastIndexOf(1, -0) < 0;
	
	$export($export.P + $export.F * (NEGATIVE_ZERO || !__webpack_require__(56)($native)), 'Array', {
	  // 22.1.3.14 / 15.4.4.15 Array.prototype.lastIndexOf(searchElement [, fromIndex])
	  lastIndexOf: function lastIndexOf(searchElement /* , fromIndex = @[*-1] */) {
	    // convert -0 to +0
	    if (NEGATIVE_ZERO) return $native.apply(this, arguments) || 0;
	    var O = toIObject(this);
	    var length = toLength(O.length);
	    var index = length - 1;
	    if (arguments.length > 1) index = Math.min(index, toInteger(arguments[1]));
	    if (index < 0) index = length + index;
	    for (;index >= 0; index--) if (index in O) if (O[index] === searchElement) return index || 0;
	    return -1;
	  }
	});


/***/ },
/* 647 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(4);
	var $map = __webpack_require__(61)(1);
	
	$export($export.P + $export.F * !__webpack_require__(56)([].map, true), 'Array', {
	  // 22.1.3.15 / 15.4.4.19 Array.prototype.map(callbackfn [, thisArg])
	  map: function map(callbackfn /* , thisArg */) {
	    return $map(this, callbackfn, arguments[1]);
	  }
	});


/***/ },
/* 648 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(4);
	var createProperty = __webpack_require__(236);
	
	// WebKit Array.of isn't generic
	$export($export.S + $export.F * __webpack_require__(21)(function () {
	  function F() { /* empty */ }
	  return !(Array.of.call(F) instanceof F);
	}), 'Array', {
	  // 22.1.2.3 Array.of( ...items)
	  of: function of(/* ...args */) {
	    var index = 0;
	    var aLen = arguments.length;
	    var result = new (typeof this == 'function' ? this : Array)(aLen);
	    while (aLen > index) createProperty(result, index, arguments[index++]);
	    result.length = aLen;
	    return result;
	  }
	});


/***/ },
/* 649 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(4);
	var $reduce = __webpack_require__(355);
	
	$export($export.P + $export.F * !__webpack_require__(56)([].reduceRight, true), 'Array', {
	  // 22.1.3.19 / 15.4.4.22 Array.prototype.reduceRight(callbackfn [, initialValue])
	  reduceRight: function reduceRight(callbackfn /* , initialValue */) {
	    return $reduce(this, callbackfn, arguments.length, arguments[1], true);
	  }
	});


/***/ },
/* 650 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(4);
	var $reduce = __webpack_require__(355);
	
	$export($export.P + $export.F * !__webpack_require__(56)([].reduce, true), 'Array', {
	  // 22.1.3.18 / 15.4.4.21 Array.prototype.reduce(callbackfn [, initialValue])
	  reduce: function reduce(callbackfn /* , initialValue */) {
	    return $reduce(this, callbackfn, arguments.length, arguments[1], false);
	  }
	});


/***/ },
/* 651 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(4);
	var html = __webpack_require__(240);
	var cof = __webpack_require__(53);
	var toAbsoluteIndex = __webpack_require__(95);
	var toLength = __webpack_require__(27);
	var arraySlice = [].slice;
	
	// fallback for not array-like ES3 strings and DOM objects
	$export($export.P + $export.F * __webpack_require__(21)(function () {
	  if (html) arraySlice.call(html);
	}), 'Array', {
	  slice: function slice(begin, end) {
	    var len = toLength(this.length);
	    var klass = cof(this);
	    end = end === undefined ? len : end;
	    if (klass == 'Array') return arraySlice.call(this, begin, end);
	    var start = toAbsoluteIndex(begin, len);
	    var upTo = toAbsoluteIndex(end, len);
	    var size = toLength(upTo - start);
	    var cloned = new Array(size);
	    var i = 0;
	    for (; i < size; i++) cloned[i] = klass == 'String'
	      ? this.charAt(start + i)
	      : this[start + i];
	    return cloned;
	  }
	});


/***/ },
/* 652 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(4);
	var $some = __webpack_require__(61)(3);
	
	$export($export.P + $export.F * !__webpack_require__(56)([].some, true), 'Array', {
	  // 22.1.3.23 / 15.4.4.17 Array.prototype.some(callbackfn [, thisArg])
	  some: function some(callbackfn /* , thisArg */) {
	    return $some(this, callbackfn, arguments[1]);
	  }
	});


/***/ },
/* 653 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(4);
	var aFunction = __webpack_require__(39);
	var toObject = __webpack_require__(34);
	var fails = __webpack_require__(21);
	var $sort = [].sort;
	var test = [1, 2, 3];
	
	$export($export.P + $export.F * (fails(function () {
	  // IE8-
	  test.sort(undefined);
	}) || !fails(function () {
	  // V8 bug
	  test.sort(null);
	  // Old WebKit
	}) || !__webpack_require__(56)($sort)), 'Array', {
	  // 22.1.3.25 Array.prototype.sort(comparefn)
	  sort: function sort(comparefn) {
	    return comparefn === undefined
	      ? $sort.call(toObject(this))
	      : $sort.call(toObject(this), aFunction(comparefn));
	  }
	});


/***/ },
/* 654 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(94)('Array');


/***/ },
/* 655 */
/***/ function(module, exports, __webpack_require__) {

	// 20.3.3.1 / 15.9.4.4 Date.now()
	var $export = __webpack_require__(4);
	
	$export($export.S, 'Date', { now: function () { return new Date().getTime(); } });


/***/ },
/* 656 */
/***/ function(module, exports, __webpack_require__) {

	// 20.3.4.36 / 15.9.5.43 Date.prototype.toISOString()
	var $export = __webpack_require__(4);
	var toISOString = __webpack_require__(629);
	
	// PhantomJS / old WebKit has a broken implementations
	$export($export.P + $export.F * (Date.prototype.toISOString !== toISOString), 'Date', {
	  toISOString: toISOString
	});


/***/ },
/* 657 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(4);
	var toObject = __webpack_require__(34);
	var toPrimitive = __webpack_require__(64);
	
	$export($export.P + $export.F * __webpack_require__(21)(function () {
	  return new Date(NaN).toJSON() !== null
	    || Date.prototype.toJSON.call({ toISOString: function () { return 1; } }) !== 1;
	}), 'Date', {
	  // eslint-disable-next-line no-unused-vars
	  toJSON: function toJSON(key) {
	    var O = toObject(this);
	    var pv = toPrimitive(O);
	    return typeof pv == 'number' && !isFinite(pv) ? null : O.toISOString();
	  }
	});


/***/ },
/* 658 */
/***/ function(module, exports, __webpack_require__) {

	var TO_PRIMITIVE = __webpack_require__(26)('toPrimitive');
	var proto = Date.prototype;
	
	if (!(TO_PRIMITIVE in proto)) __webpack_require__(40)(proto, TO_PRIMITIVE, __webpack_require__(630));


/***/ },
/* 659 */
/***/ function(module, exports, __webpack_require__) {

	var DateProto = Date.prototype;
	var INVALID_DATE = 'Invalid Date';
	var TO_STRING = 'toString';
	var $toString = DateProto[TO_STRING];
	var getTime = DateProto.getTime;
	if (new Date(NaN) + '' != INVALID_DATE) {
	  __webpack_require__(41)(DateProto, TO_STRING, function toString() {
	    var value = getTime.call(this);
	    // eslint-disable-next-line no-self-compare
	    return value === value ? $toString.call(this) : INVALID_DATE;
	  });
	}


/***/ },
/* 660 */
/***/ function(module, exports, __webpack_require__) {

	// 19.2.3.2 / 15.3.4.5 Function.prototype.bind(thisArg, args...)
	var $export = __webpack_require__(4);
	
	$export($export.P, 'Function', { bind: __webpack_require__(356) });


/***/ },
/* 661 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var isObject = __webpack_require__(23);
	var getPrototypeOf = __webpack_require__(48);
	var HAS_INSTANCE = __webpack_require__(26)('hasInstance');
	var FunctionProto = Function.prototype;
	// 19.2.3.6 Function.prototype[@@hasInstance](V)
	if (!(HAS_INSTANCE in FunctionProto)) __webpack_require__(32).f(FunctionProto, HAS_INSTANCE, { value: function (O) {
	  if (typeof this != 'function' || !isObject(O)) return false;
	  if (!isObject(this.prototype)) return O instanceof this;
	  // for environment w/o native `@@hasInstance` logic enough `instanceof`, but add this:
	  while (O = getPrototypeOf(O)) if (this.prototype === O) return true;
	  return false;
	} });


/***/ },
/* 662 */
/***/ function(module, exports, __webpack_require__) {

	var dP = __webpack_require__(32).f;
	var FProto = Function.prototype;
	var nameRE = /^\s*function ([^ (]*)/;
	var NAME = 'name';
	
	// 19.2.4.2 name
	NAME in FProto || __webpack_require__(28) && dP(FProto, NAME, {
	  configurable: true,
	  get: function () {
	    try {
	      return ('' + this).match(nameRE)[1];
	    } catch (e) {
	      return '';
	    }
	  }
	});


/***/ },
/* 663 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.3 Math.acosh(x)
	var $export = __webpack_require__(4);
	var log1p = __webpack_require__(367);
	var sqrt = Math.sqrt;
	var $acosh = Math.acosh;
	
	$export($export.S + $export.F * !($acosh
	  // V8 bug: https://code.google.com/p/v8/issues/detail?id=3509
	  && Math.floor($acosh(Number.MAX_VALUE)) == 710
	  // Tor Browser bug: Math.acosh(Infinity) -> NaN
	  && $acosh(Infinity) == Infinity
	), 'Math', {
	  acosh: function acosh(x) {
	    return (x = +x) < 1 ? NaN : x > 94906265.62425156
	      ? Math.log(x) + Math.LN2
	      : log1p(x - 1 + sqrt(x - 1) * sqrt(x + 1));
	  }
	});


/***/ },
/* 664 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.5 Math.asinh(x)
	var $export = __webpack_require__(4);
	var $asinh = Math.asinh;
	
	function asinh(x) {
	  return !isFinite(x = +x) || x == 0 ? x : x < 0 ? -asinh(-x) : Math.log(x + Math.sqrt(x * x + 1));
	}
	
	// Tor Browser bug: Math.asinh(0) -> -0
	$export($export.S + $export.F * !($asinh && 1 / $asinh(0) > 0), 'Math', { asinh: asinh });


/***/ },
/* 665 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.7 Math.atanh(x)
	var $export = __webpack_require__(4);
	var $atanh = Math.atanh;
	
	// Tor Browser bug: Math.atanh(-0) -> 0
	$export($export.S + $export.F * !($atanh && 1 / $atanh(-0) < 0), 'Math', {
	  atanh: function atanh(x) {
	    return (x = +x) == 0 ? x : Math.log((1 + x) / (1 - x)) / 2;
	  }
	});


/***/ },
/* 666 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.9 Math.cbrt(x)
	var $export = __webpack_require__(4);
	var sign = __webpack_require__(246);
	
	$export($export.S, 'Math', {
	  cbrt: function cbrt(x) {
	    return sign(x = +x) * Math.pow(Math.abs(x), 1 / 3);
	  }
	});


/***/ },
/* 667 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.11 Math.clz32(x)
	var $export = __webpack_require__(4);
	
	$export($export.S, 'Math', {
	  clz32: function clz32(x) {
	    return (x >>>= 0) ? 31 - Math.floor(Math.log(x + 0.5) * Math.LOG2E) : 32;
	  }
	});


/***/ },
/* 668 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.12 Math.cosh(x)
	var $export = __webpack_require__(4);
	var exp = Math.exp;
	
	$export($export.S, 'Math', {
	  cosh: function cosh(x) {
	    return (exp(x = +x) + exp(-x)) / 2;
	  }
	});


/***/ },
/* 669 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.14 Math.expm1(x)
	var $export = __webpack_require__(4);
	var $expm1 = __webpack_require__(245);
	
	$export($export.S + $export.F * ($expm1 != Math.expm1), 'Math', { expm1: $expm1 });


/***/ },
/* 670 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.16 Math.fround(x)
	var $export = __webpack_require__(4);
	
	$export($export.S, 'Math', { fround: __webpack_require__(366) });


/***/ },
/* 671 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.17 Math.hypot([value1[, value2[, … ]]])
	var $export = __webpack_require__(4);
	var abs = Math.abs;
	
	$export($export.S, 'Math', {
	  hypot: function hypot(value1, value2) { // eslint-disable-line no-unused-vars
	    var sum = 0;
	    var i = 0;
	    var aLen = arguments.length;
	    var larg = 0;
	    var arg, div;
	    while (i < aLen) {
	      arg = abs(arguments[i++]);
	      if (larg < arg) {
	        div = larg / arg;
	        sum = sum * div * div + 1;
	        larg = arg;
	      } else if (arg > 0) {
	        div = arg / larg;
	        sum += div * div;
	      } else sum += arg;
	    }
	    return larg === Infinity ? Infinity : larg * Math.sqrt(sum);
	  }
	});


/***/ },
/* 672 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.18 Math.imul(x, y)
	var $export = __webpack_require__(4);
	var $imul = Math.imul;
	
	// some WebKit versions fails with big numbers, some has wrong arity
	$export($export.S + $export.F * __webpack_require__(21)(function () {
	  return $imul(0xffffffff, 5) != -5 || $imul.length != 2;
	}), 'Math', {
	  imul: function imul(x, y) {
	    var UINT16 = 0xffff;
	    var xn = +x;
	    var yn = +y;
	    var xl = UINT16 & xn;
	    var yl = UINT16 & yn;
	    return 0 | xl * yl + ((UINT16 & xn >>> 16) * yl + xl * (UINT16 & yn >>> 16) << 16 >>> 0);
	  }
	});


/***/ },
/* 673 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.21 Math.log10(x)
	var $export = __webpack_require__(4);
	
	$export($export.S, 'Math', {
	  log10: function log10(x) {
	    return Math.log(x) * Math.LOG10E;
	  }
	});


/***/ },
/* 674 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.20 Math.log1p(x)
	var $export = __webpack_require__(4);
	
	$export($export.S, 'Math', { log1p: __webpack_require__(367) });


/***/ },
/* 675 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.22 Math.log2(x)
	var $export = __webpack_require__(4);
	
	$export($export.S, 'Math', {
	  log2: function log2(x) {
	    return Math.log(x) / Math.LN2;
	  }
	});


/***/ },
/* 676 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.28 Math.sign(x)
	var $export = __webpack_require__(4);
	
	$export($export.S, 'Math', { sign: __webpack_require__(246) });


/***/ },
/* 677 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.30 Math.sinh(x)
	var $export = __webpack_require__(4);
	var expm1 = __webpack_require__(245);
	var exp = Math.exp;
	
	// V8 near Chromium 38 has a problem with very small numbers
	$export($export.S + $export.F * __webpack_require__(21)(function () {
	  return !Math.sinh(-2e-17) != -2e-17;
	}), 'Math', {
	  sinh: function sinh(x) {
	    return Math.abs(x = +x) < 1
	      ? (expm1(x) - expm1(-x)) / 2
	      : (exp(x - 1) - exp(-x - 1)) * (Math.E / 2);
	  }
	});


/***/ },
/* 678 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.33 Math.tanh(x)
	var $export = __webpack_require__(4);
	var expm1 = __webpack_require__(245);
	var exp = Math.exp;
	
	$export($export.S, 'Math', {
	  tanh: function tanh(x) {
	    var a = expm1(x = +x);
	    var b = expm1(-x);
	    return a == Infinity ? 1 : b == Infinity ? -1 : (a - b) / (exp(x) + exp(-x));
	  }
	});


/***/ },
/* 679 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.34 Math.trunc(x)
	var $export = __webpack_require__(4);
	
	$export($export.S, 'Math', {
	  trunc: function trunc(it) {
	    return (it > 0 ? Math.floor : Math.ceil)(it);
	  }
	});


/***/ },
/* 680 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var global = __webpack_require__(17);
	var has = __webpack_require__(46);
	var cof = __webpack_require__(53);
	var inheritIfRequired = __webpack_require__(241);
	var toPrimitive = __webpack_require__(64);
	var fails = __webpack_require__(21);
	var gOPN = __webpack_require__(90).f;
	var gOPD = __webpack_require__(47).f;
	var dP = __webpack_require__(32).f;
	var $trim = __webpack_require__(110).trim;
	var NUMBER = 'Number';
	var $Number = global[NUMBER];
	var Base = $Number;
	var proto = $Number.prototype;
	// Opera ~12 has broken Object#toString
	var BROKEN_COF = cof(__webpack_require__(89)(proto)) == NUMBER;
	var TRIM = 'trim' in String.prototype;
	
	// 7.1.3 ToNumber(argument)
	var toNumber = function (argument) {
	  var it = toPrimitive(argument, false);
	  if (typeof it == 'string' && it.length > 2) {
	    it = TRIM ? it.trim() : $trim(it, 3);
	    var first = it.charCodeAt(0);
	    var third, radix, maxCode;
	    if (first === 43 || first === 45) {
	      third = it.charCodeAt(2);
	      if (third === 88 || third === 120) return NaN; // Number('+0x1') should be NaN, old V8 fix
	    } else if (first === 48) {
	      switch (it.charCodeAt(1)) {
	        case 66: case 98: radix = 2; maxCode = 49; break; // fast equal /^0b[01]+$/i
	        case 79: case 111: radix = 8; maxCode = 55; break; // fast equal /^0o[0-7]+$/i
	        default: return +it;
	      }
	      for (var digits = it.slice(2), i = 0, l = digits.length, code; i < l; i++) {
	        code = digits.charCodeAt(i);
	        // parseInt parses a string to a first unavailable symbol
	        // but ToNumber should return NaN if a string contains unavailable symbols
	        if (code < 48 || code > maxCode) return NaN;
	      } return parseInt(digits, radix);
	    }
	  } return +it;
	};
	
	if (!$Number(' 0o1') || !$Number('0b1') || $Number('+0x1')) {
	  $Number = function Number(value) {
	    var it = arguments.length < 1 ? 0 : value;
	    var that = this;
	    return that instanceof $Number
	      // check on 1..constructor(foo) case
	      && (BROKEN_COF ? fails(function () { proto.valueOf.call(that); }) : cof(that) != NUMBER)
	        ? inheritIfRequired(new Base(toNumber(it)), that, $Number) : toNumber(it);
	  };
	  for (var keys = __webpack_require__(28) ? gOPN(Base) : (
	    // ES3:
	    'MAX_VALUE,MIN_VALUE,NaN,NEGATIVE_INFINITY,POSITIVE_INFINITY,' +
	    // ES6 (in case, if modules with ES6 Number statics required before):
	    'EPSILON,isFinite,isInteger,isNaN,isSafeInteger,MAX_SAFE_INTEGER,' +
	    'MIN_SAFE_INTEGER,parseFloat,parseInt,isInteger'
	  ).split(','), j = 0, key; keys.length > j; j++) {
	    if (has(Base, key = keys[j]) && !has($Number, key)) {
	      dP($Number, key, gOPD(Base, key));
	    }
	  }
	  $Number.prototype = proto;
	  proto.constructor = $Number;
	  __webpack_require__(41)(global, NUMBER, $Number);
	}


/***/ },
/* 681 */
/***/ function(module, exports, __webpack_require__) {

	// 20.1.2.1 Number.EPSILON
	var $export = __webpack_require__(4);
	
	$export($export.S, 'Number', { EPSILON: Math.pow(2, -52) });


/***/ },
/* 682 */
/***/ function(module, exports, __webpack_require__) {

	// 20.1.2.2 Number.isFinite(number)
	var $export = __webpack_require__(4);
	var _isFinite = __webpack_require__(17).isFinite;
	
	$export($export.S, 'Number', {
	  isFinite: function isFinite(it) {
	    return typeof it == 'number' && _isFinite(it);
	  }
	});


/***/ },
/* 683 */
/***/ function(module, exports, __webpack_require__) {

	// 20.1.2.3 Number.isInteger(number)
	var $export = __webpack_require__(4);
	
	$export($export.S, 'Number', { isInteger: __webpack_require__(363) });


/***/ },
/* 684 */
/***/ function(module, exports, __webpack_require__) {

	// 20.1.2.4 Number.isNaN(number)
	var $export = __webpack_require__(4);
	
	$export($export.S, 'Number', {
	  isNaN: function isNaN(number) {
	    // eslint-disable-next-line no-self-compare
	    return number != number;
	  }
	});


/***/ },
/* 685 */
/***/ function(module, exports, __webpack_require__) {

	// 20.1.2.5 Number.isSafeInteger(number)
	var $export = __webpack_require__(4);
	var isInteger = __webpack_require__(363);
	var abs = Math.abs;
	
	$export($export.S, 'Number', {
	  isSafeInteger: function isSafeInteger(number) {
	    return isInteger(number) && abs(number) <= 0x1fffffffffffff;
	  }
	});


/***/ },
/* 686 */
/***/ function(module, exports, __webpack_require__) {

	// 20.1.2.6 Number.MAX_SAFE_INTEGER
	var $export = __webpack_require__(4);
	
	$export($export.S, 'Number', { MAX_SAFE_INTEGER: 0x1fffffffffffff });


/***/ },
/* 687 */
/***/ function(module, exports, __webpack_require__) {

	// 20.1.2.10 Number.MIN_SAFE_INTEGER
	var $export = __webpack_require__(4);
	
	$export($export.S, 'Number', { MIN_SAFE_INTEGER: -0x1fffffffffffff });


/***/ },
/* 688 */
/***/ function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(4);
	var $parseFloat = __webpack_require__(375);
	// 20.1.2.12 Number.parseFloat(string)
	$export($export.S + $export.F * (Number.parseFloat != $parseFloat), 'Number', { parseFloat: $parseFloat });


/***/ },
/* 689 */
/***/ function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(4);
	var $parseInt = __webpack_require__(376);
	// 20.1.2.13 Number.parseInt(string, radix)
	$export($export.S + $export.F * (Number.parseInt != $parseInt), 'Number', { parseInt: $parseInt });


/***/ },
/* 690 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(4);
	var toInteger = __webpack_require__(57);
	var aNumberValue = __webpack_require__(352);
	var repeat = __webpack_require__(253);
	var $toFixed = 1.0.toFixed;
	var floor = Math.floor;
	var data = [0, 0, 0, 0, 0, 0];
	var ERROR = 'Number.toFixed: incorrect invocation!';
	var ZERO = '0';
	
	var multiply = function (n, c) {
	  var i = -1;
	  var c2 = c;
	  while (++i < 6) {
	    c2 += n * data[i];
	    data[i] = c2 % 1e7;
	    c2 = floor(c2 / 1e7);
	  }
	};
	var divide = function (n) {
	  var i = 6;
	  var c = 0;
	  while (--i >= 0) {
	    c += data[i];
	    data[i] = floor(c / n);
	    c = (c % n) * 1e7;
	  }
	};
	var numToString = function () {
	  var i = 6;
	  var s = '';
	  while (--i >= 0) {
	    if (s !== '' || i === 0 || data[i] !== 0) {
	      var t = String(data[i]);
	      s = s === '' ? t : s + repeat.call(ZERO, 7 - t.length) + t;
	    }
	  } return s;
	};
	var pow = function (x, n, acc) {
	  return n === 0 ? acc : n % 2 === 1 ? pow(x, n - 1, acc * x) : pow(x * x, n / 2, acc);
	};
	var log = function (x) {
	  var n = 0;
	  var x2 = x;
	  while (x2 >= 4096) {
	    n += 12;
	    x2 /= 4096;
	  }
	  while (x2 >= 2) {
	    n += 1;
	    x2 /= 2;
	  } return n;
	};
	
	$export($export.P + $export.F * (!!$toFixed && (
	  0.00008.toFixed(3) !== '0.000' ||
	  0.9.toFixed(0) !== '1' ||
	  1.255.toFixed(2) !== '1.25' ||
	  1000000000000000128.0.toFixed(0) !== '1000000000000000128'
	) || !__webpack_require__(21)(function () {
	  // V8 ~ Android 4.3-
	  $toFixed.call({});
	})), 'Number', {
	  toFixed: function toFixed(fractionDigits) {
	    var x = aNumberValue(this, ERROR);
	    var f = toInteger(fractionDigits);
	    var s = '';
	    var m = ZERO;
	    var e, z, j, k;
	    if (f < 0 || f > 20) throw RangeError(ERROR);
	    // eslint-disable-next-line no-self-compare
	    if (x != x) return 'NaN';
	    if (x <= -1e21 || x >= 1e21) return String(x);
	    if (x < 0) {
	      s = '-';
	      x = -x;
	    }
	    if (x > 1e-21) {
	      e = log(x * pow(2, 69, 1)) - 69;
	      z = e < 0 ? x * pow(2, -e, 1) : x / pow(2, e, 1);
	      z *= 0x10000000000000;
	      e = 52 - e;
	      if (e > 0) {
	        multiply(0, z);
	        j = f;
	        while (j >= 7) {
	          multiply(1e7, 0);
	          j -= 7;
	        }
	        multiply(pow(10, j, 1), 0);
	        j = e - 1;
	        while (j >= 23) {
	          divide(1 << 23);
	          j -= 23;
	        }
	        divide(1 << j);
	        multiply(1, 1);
	        divide(2);
	        m = numToString();
	      } else {
	        multiply(0, z);
	        multiply(1 << -e, 0);
	        m = numToString() + repeat.call(ZERO, f);
	      }
	    }
	    if (f > 0) {
	      k = m.length;
	      m = s + (k <= f ? '0.' + repeat.call(ZERO, f - k) + m : m.slice(0, k - f) + '.' + m.slice(k - f));
	    } else {
	      m = s + m;
	    } return m;
	  }
	});


/***/ },
/* 691 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(4);
	var $fails = __webpack_require__(21);
	var aNumberValue = __webpack_require__(352);
	var $toPrecision = 1.0.toPrecision;
	
	$export($export.P + $export.F * ($fails(function () {
	  // IE7-
	  return $toPrecision.call(1, undefined) !== '1';
	}) || !$fails(function () {
	  // V8 ~ Android 4.3-
	  $toPrecision.call({});
	})), 'Number', {
	  toPrecision: function toPrecision(precision) {
	    var that = aNumberValue(this, 'Number#toPrecision: incorrect invocation!');
	    return precision === undefined ? $toPrecision.call(that) : $toPrecision.call(that, precision);
	  }
	});


/***/ },
/* 692 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.3.1 Object.assign(target, source)
	var $export = __webpack_require__(4);
	
	$export($export.S + $export.F, 'Object', { assign: __webpack_require__(369) });


/***/ },
/* 693 */
/***/ function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(4);
	// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
	$export($export.S, 'Object', { create: __webpack_require__(89) });


/***/ },
/* 694 */
/***/ function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(4);
	// 19.1.2.3 / 15.2.3.7 Object.defineProperties(O, Properties)
	$export($export.S + $export.F * !__webpack_require__(28), 'Object', { defineProperties: __webpack_require__(370) });


/***/ },
/* 695 */
/***/ function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(4);
	// 19.1.2.4 / 15.2.3.6 Object.defineProperty(O, P, Attributes)
	$export($export.S + $export.F * !__webpack_require__(28), 'Object', { defineProperty: __webpack_require__(32).f });


/***/ },
/* 696 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.2.5 Object.freeze(O)
	var isObject = __webpack_require__(23);
	var meta = __webpack_require__(83).onFreeze;
	
	__webpack_require__(63)('freeze', function ($freeze) {
	  return function freeze(it) {
	    return $freeze && isObject(it) ? $freeze(meta(it)) : it;
	  };
	});


/***/ },
/* 697 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
	var toIObject = __webpack_require__(49);
	var $getOwnPropertyDescriptor = __webpack_require__(47).f;
	
	__webpack_require__(63)('getOwnPropertyDescriptor', function () {
	  return function getOwnPropertyDescriptor(it, key) {
	    return $getOwnPropertyDescriptor(toIObject(it), key);
	  };
	});


/***/ },
/* 698 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.2.7 Object.getOwnPropertyNames(O)
	__webpack_require__(63)('getOwnPropertyNames', function () {
	  return __webpack_require__(371).f;
	});


/***/ },
/* 699 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.2.9 Object.getPrototypeOf(O)
	var toObject = __webpack_require__(34);
	var $getPrototypeOf = __webpack_require__(48);
	
	__webpack_require__(63)('getPrototypeOf', function () {
	  return function getPrototypeOf(it) {
	    return $getPrototypeOf(toObject(it));
	  };
	});


/***/ },
/* 700 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.2.11 Object.isExtensible(O)
	var isObject = __webpack_require__(23);
	
	__webpack_require__(63)('isExtensible', function ($isExtensible) {
	  return function isExtensible(it) {
	    return isObject(it) ? $isExtensible ? $isExtensible(it) : true : false;
	  };
	});


/***/ },
/* 701 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.2.12 Object.isFrozen(O)
	var isObject = __webpack_require__(23);
	
	__webpack_require__(63)('isFrozen', function ($isFrozen) {
	  return function isFrozen(it) {
	    return isObject(it) ? $isFrozen ? $isFrozen(it) : false : true;
	  };
	});


/***/ },
/* 702 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.2.13 Object.isSealed(O)
	var isObject = __webpack_require__(23);
	
	__webpack_require__(63)('isSealed', function ($isSealed) {
	  return function isSealed(it) {
	    return isObject(it) ? $isSealed ? $isSealed(it) : false : true;
	  };
	});


/***/ },
/* 703 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.3.10 Object.is(value1, value2)
	var $export = __webpack_require__(4);
	$export($export.S, 'Object', { is: __webpack_require__(379) });


/***/ },
/* 704 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.2.14 Object.keys(O)
	var toObject = __webpack_require__(34);
	var $keys = __webpack_require__(91);
	
	__webpack_require__(63)('keys', function () {
	  return function keys(it) {
	    return $keys(toObject(it));
	  };
	});


/***/ },
/* 705 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.2.15 Object.preventExtensions(O)
	var isObject = __webpack_require__(23);
	var meta = __webpack_require__(83).onFreeze;
	
	__webpack_require__(63)('preventExtensions', function ($preventExtensions) {
	  return function preventExtensions(it) {
	    return $preventExtensions && isObject(it) ? $preventExtensions(meta(it)) : it;
	  };
	});


/***/ },
/* 706 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.2.17 Object.seal(O)
	var isObject = __webpack_require__(23);
	var meta = __webpack_require__(83).onFreeze;
	
	__webpack_require__(63)('seal', function ($seal) {
	  return function seal(it) {
	    return $seal && isObject(it) ? $seal(meta(it)) : it;
	  };
	});


/***/ },
/* 707 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.3.19 Object.setPrototypeOf(O, proto)
	var $export = __webpack_require__(4);
	$export($export.S, 'Object', { setPrototypeOf: __webpack_require__(250).set });


/***/ },
/* 708 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// 19.1.3.6 Object.prototype.toString()
	var classof = __webpack_require__(107);
	var test = {};
	test[__webpack_require__(26)('toStringTag')] = 'z';
	if (test + '' != '[object z]') {
	  __webpack_require__(41)(Object.prototype, 'toString', function toString() {
	    return '[object ' + classof(this) + ']';
	  }, true);
	}


/***/ },
/* 709 */
/***/ function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(4);
	var $parseFloat = __webpack_require__(375);
	// 18.2.4 parseFloat(string)
	$export($export.G + $export.F * (parseFloat != $parseFloat), { parseFloat: $parseFloat });


/***/ },
/* 710 */
/***/ function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(4);
	var $parseInt = __webpack_require__(376);
	// 18.2.5 parseInt(string, radix)
	$export($export.G + $export.F * (parseInt != $parseInt), { parseInt: $parseInt });


/***/ },
/* 711 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var LIBRARY = __webpack_require__(82);
	var global = __webpack_require__(17);
	var ctx = __webpack_require__(55);
	var classof = __webpack_require__(107);
	var $export = __webpack_require__(4);
	var isObject = __webpack_require__(23);
	var aFunction = __webpack_require__(39);
	var anInstance = __webpack_require__(87);
	var forOf = __webpack_require__(88);
	var speciesConstructor = __webpack_require__(135);
	var task = __webpack_require__(255).set;
	var microtask = __webpack_require__(247)();
	var newPromiseCapabilityModule = __webpack_require__(248);
	var perform = __webpack_require__(377);
	var userAgent = __webpack_require__(178);
	var promiseResolve = __webpack_require__(378);
	var PROMISE = 'Promise';
	var TypeError = global.TypeError;
	var process = global.process;
	var versions = process && process.versions;
	var v8 = versions && versions.v8 || '';
	var $Promise = global[PROMISE];
	var isNode = classof(process) == 'process';
	var empty = function () { /* empty */ };
	var Internal, newGenericPromiseCapability, OwnPromiseCapability, Wrapper;
	var newPromiseCapability = newGenericPromiseCapability = newPromiseCapabilityModule.f;
	
	var USE_NATIVE = !!function () {
	  try {
	    // correct subclassing with @@species support
	    var promise = $Promise.resolve(1);
	    var FakePromise = (promise.constructor = {})[__webpack_require__(26)('species')] = function (exec) {
	      exec(empty, empty);
	    };
	    // unhandled rejections tracking support, NodeJS Promise without it fails @@species test
	    return (isNode || typeof PromiseRejectionEvent == 'function')
	      && promise.then(empty) instanceof FakePromise
	      // v8 6.6 (Node 10 and Chrome 66) have a bug with resolving custom thenables
	      // https://bugs.chromium.org/p/chromium/issues/detail?id=830565
	      // we can't detect it synchronously, so just check versions
	      && v8.indexOf('6.6') !== 0
	      && userAgent.indexOf('Chrome/66') === -1;
	  } catch (e) { /* empty */ }
	}();
	
	// helpers
	var isThenable = function (it) {
	  var then;
	  return isObject(it) && typeof (then = it.then) == 'function' ? then : false;
	};
	var notify = function (promise, isReject) {
	  if (promise._n) return;
	  promise._n = true;
	  var chain = promise._c;
	  microtask(function () {
	    var value = promise._v;
	    var ok = promise._s == 1;
	    var i = 0;
	    var run = function (reaction) {
	      var handler = ok ? reaction.ok : reaction.fail;
	      var resolve = reaction.resolve;
	      var reject = reaction.reject;
	      var domain = reaction.domain;
	      var result, then, exited;
	      try {
	        if (handler) {
	          if (!ok) {
	            if (promise._h == 2) onHandleUnhandled(promise);
	            promise._h = 1;
	          }
	          if (handler === true) result = value;
	          else {
	            if (domain) domain.enter();
	            result = handler(value); // may throw
	            if (domain) {
	              domain.exit();
	              exited = true;
	            }
	          }
	          if (result === reaction.promise) {
	            reject(TypeError('Promise-chain cycle'));
	          } else if (then = isThenable(result)) {
	            then.call(result, resolve, reject);
	          } else resolve(result);
	        } else reject(value);
	      } catch (e) {
	        if (domain && !exited) domain.exit();
	        reject(e);
	      }
	    };
	    while (chain.length > i) run(chain[i++]); // variable length - can't use forEach
	    promise._c = [];
	    promise._n = false;
	    if (isReject && !promise._h) onUnhandled(promise);
	  });
	};
	var onUnhandled = function (promise) {
	  task.call(global, function () {
	    var value = promise._v;
	    var unhandled = isUnhandled(promise);
	    var result, handler, console;
	    if (unhandled) {
	      result = perform(function () {
	        if (isNode) {
	          process.emit('unhandledRejection', value, promise);
	        } else if (handler = global.onunhandledrejection) {
	          handler({ promise: promise, reason: value });
	        } else if ((console = global.console) && console.error) {
	          console.error('Unhandled promise rejection', value);
	        }
	      });
	      // Browsers should not trigger `rejectionHandled` event if it was handled here, NodeJS - should
	      promise._h = isNode || isUnhandled(promise) ? 2 : 1;
	    } promise._a = undefined;
	    if (unhandled && result.e) throw result.v;
	  });
	};
	var isUnhandled = function (promise) {
	  return promise._h !== 1 && (promise._a || promise._c).length === 0;
	};
	var onHandleUnhandled = function (promise) {
	  task.call(global, function () {
	    var handler;
	    if (isNode) {
	      process.emit('rejectionHandled', promise);
	    } else if (handler = global.onrejectionhandled) {
	      handler({ promise: promise, reason: promise._v });
	    }
	  });
	};
	var $reject = function (value) {
	  var promise = this;
	  if (promise._d) return;
	  promise._d = true;
	  promise = promise._w || promise; // unwrap
	  promise._v = value;
	  promise._s = 2;
	  if (!promise._a) promise._a = promise._c.slice();
	  notify(promise, true);
	};
	var $resolve = function (value) {
	  var promise = this;
	  var then;
	  if (promise._d) return;
	  promise._d = true;
	  promise = promise._w || promise; // unwrap
	  try {
	    if (promise === value) throw TypeError("Promise can't be resolved itself");
	    if (then = isThenable(value)) {
	      microtask(function () {
	        var wrapper = { _w: promise, _d: false }; // wrap
	        try {
	          then.call(value, ctx($resolve, wrapper, 1), ctx($reject, wrapper, 1));
	        } catch (e) {
	          $reject.call(wrapper, e);
	        }
	      });
	    } else {
	      promise._v = value;
	      promise._s = 1;
	      notify(promise, false);
	    }
	  } catch (e) {
	    $reject.call({ _w: promise, _d: false }, e); // wrap
	  }
	};
	
	// constructor polyfill
	if (!USE_NATIVE) {
	  // 25.4.3.1 Promise(executor)
	  $Promise = function Promise(executor) {
	    anInstance(this, $Promise, PROMISE, '_h');
	    aFunction(executor);
	    Internal.call(this);
	    try {
	      executor(ctx($resolve, this, 1), ctx($reject, this, 1));
	    } catch (err) {
	      $reject.call(this, err);
	    }
	  };
	  // eslint-disable-next-line no-unused-vars
	  Internal = function Promise(executor) {
	    this._c = [];             // <- awaiting reactions
	    this._a = undefined;      // <- checked in isUnhandled reactions
	    this._s = 0;              // <- state
	    this._d = false;          // <- done
	    this._v = undefined;      // <- value
	    this._h = 0;              // <- rejection state, 0 - default, 1 - handled, 2 - unhandled
	    this._n = false;          // <- notify
	  };
	  Internal.prototype = __webpack_require__(93)($Promise.prototype, {
	    // 25.4.5.3 Promise.prototype.then(onFulfilled, onRejected)
	    then: function then(onFulfilled, onRejected) {
	      var reaction = newPromiseCapability(speciesConstructor(this, $Promise));
	      reaction.ok = typeof onFulfilled == 'function' ? onFulfilled : true;
	      reaction.fail = typeof onRejected == 'function' && onRejected;
	      reaction.domain = isNode ? process.domain : undefined;
	      this._c.push(reaction);
	      if (this._a) this._a.push(reaction);
	      if (this._s) notify(this, false);
	      return reaction.promise;
	    },
	    // 25.4.5.1 Promise.prototype.catch(onRejected)
	    'catch': function (onRejected) {
	      return this.then(undefined, onRejected);
	    }
	  });
	  OwnPromiseCapability = function () {
	    var promise = new Internal();
	    this.promise = promise;
	    this.resolve = ctx($resolve, promise, 1);
	    this.reject = ctx($reject, promise, 1);
	  };
	  newPromiseCapabilityModule.f = newPromiseCapability = function (C) {
	    return C === $Promise || C === Wrapper
	      ? new OwnPromiseCapability(C)
	      : newGenericPromiseCapability(C);
	  };
	}
	
	$export($export.G + $export.W + $export.F * !USE_NATIVE, { Promise: $Promise });
	__webpack_require__(109)($Promise, PROMISE);
	__webpack_require__(94)(PROMISE);
	Wrapper = __webpack_require__(54)[PROMISE];
	
	// statics
	$export($export.S + $export.F * !USE_NATIVE, PROMISE, {
	  // 25.4.4.5 Promise.reject(r)
	  reject: function reject(r) {
	    var capability = newPromiseCapability(this);
	    var $$reject = capability.reject;
	    $$reject(r);
	    return capability.promise;
	  }
	});
	$export($export.S + $export.F * (LIBRARY || !USE_NATIVE), PROMISE, {
	  // 25.4.4.6 Promise.resolve(x)
	  resolve: function resolve(x) {
	    return promiseResolve(LIBRARY && this === Wrapper ? $Promise : this, x);
	  }
	});
	$export($export.S + $export.F * !(USE_NATIVE && __webpack_require__(170)(function (iter) {
	  $Promise.all(iter)['catch'](empty);
	})), PROMISE, {
	  // 25.4.4.1 Promise.all(iterable)
	  all: function all(iterable) {
	    var C = this;
	    var capability = newPromiseCapability(C);
	    var resolve = capability.resolve;
	    var reject = capability.reject;
	    var result = perform(function () {
	      var values = [];
	      var index = 0;
	      var remaining = 1;
	      forOf(iterable, false, function (promise) {
	        var $index = index++;
	        var alreadyCalled = false;
	        values.push(undefined);
	        remaining++;
	        C.resolve(promise).then(function (value) {
	          if (alreadyCalled) return;
	          alreadyCalled = true;
	          values[$index] = value;
	          --remaining || resolve(values);
	        }, reject);
	      });
	      --remaining || resolve(values);
	    });
	    if (result.e) reject(result.v);
	    return capability.promise;
	  },
	  // 25.4.4.4 Promise.race(iterable)
	  race: function race(iterable) {
	    var C = this;
	    var capability = newPromiseCapability(C);
	    var reject = capability.reject;
	    var result = perform(function () {
	      forOf(iterable, false, function (promise) {
	        C.resolve(promise).then(capability.resolve, reject);
	      });
	    });
	    if (result.e) reject(result.v);
	    return capability.promise;
	  }
	});


/***/ },
/* 712 */
/***/ function(module, exports, __webpack_require__) {

	// 26.1.1 Reflect.apply(target, thisArgument, argumentsList)
	var $export = __webpack_require__(4);
	var aFunction = __webpack_require__(39);
	var anObject = __webpack_require__(15);
	var rApply = (__webpack_require__(17).Reflect || {}).apply;
	var fApply = Function.apply;
	// MS Edge argumentsList argument is optional
	$export($export.S + $export.F * !__webpack_require__(21)(function () {
	  rApply(function () { /* empty */ });
	}), 'Reflect', {
	  apply: function apply(target, thisArgument, argumentsList) {
	    var T = aFunction(target);
	    var L = anObject(argumentsList);
	    return rApply ? rApply(T, thisArgument, L) : fApply.call(T, thisArgument, L);
	  }
	});


/***/ },
/* 713 */
/***/ function(module, exports, __webpack_require__) {

	// 26.1.2 Reflect.construct(target, argumentsList [, newTarget])
	var $export = __webpack_require__(4);
	var create = __webpack_require__(89);
	var aFunction = __webpack_require__(39);
	var anObject = __webpack_require__(15);
	var isObject = __webpack_require__(23);
	var fails = __webpack_require__(21);
	var bind = __webpack_require__(356);
	var rConstruct = (__webpack_require__(17).Reflect || {}).construct;
	
	// MS Edge supports only 2 arguments and argumentsList argument is optional
	// FF Nightly sets third argument as `new.target`, but does not create `this` from it
	var NEW_TARGET_BUG = fails(function () {
	  function F() { /* empty */ }
	  return !(rConstruct(function () { /* empty */ }, [], F) instanceof F);
	});
	var ARGS_BUG = !fails(function () {
	  rConstruct(function () { /* empty */ });
	});
	
	$export($export.S + $export.F * (NEW_TARGET_BUG || ARGS_BUG), 'Reflect', {
	  construct: function construct(Target, args /* , newTarget */) {
	    aFunction(Target);
	    anObject(args);
	    var newTarget = arguments.length < 3 ? Target : aFunction(arguments[2]);
	    if (ARGS_BUG && !NEW_TARGET_BUG) return rConstruct(Target, args, newTarget);
	    if (Target == newTarget) {
	      // w/o altered newTarget, optimization for 0-4 arguments
	      switch (args.length) {
	        case 0: return new Target();
	        case 1: return new Target(args[0]);
	        case 2: return new Target(args[0], args[1]);
	        case 3: return new Target(args[0], args[1], args[2]);
	        case 4: return new Target(args[0], args[1], args[2], args[3]);
	      }
	      // w/o altered newTarget, lot of arguments case
	      var $args = [null];
	      $args.push.apply($args, args);
	      return new (bind.apply(Target, $args))();
	    }
	    // with altered newTarget, not support built-in constructors
	    var proto = newTarget.prototype;
	    var instance = create(isObject(proto) ? proto : Object.prototype);
	    var result = Function.apply.call(Target, instance, args);
	    return isObject(result) ? result : instance;
	  }
	});


/***/ },
/* 714 */
/***/ function(module, exports, __webpack_require__) {

	// 26.1.3 Reflect.defineProperty(target, propertyKey, attributes)
	var dP = __webpack_require__(32);
	var $export = __webpack_require__(4);
	var anObject = __webpack_require__(15);
	var toPrimitive = __webpack_require__(64);
	
	// MS Edge has broken Reflect.defineProperty - throwing instead of returning false
	$export($export.S + $export.F * __webpack_require__(21)(function () {
	  // eslint-disable-next-line no-undef
	  Reflect.defineProperty(dP.f({}, 1, { value: 1 }), 1, { value: 2 });
	}), 'Reflect', {
	  defineProperty: function defineProperty(target, propertyKey, attributes) {
	    anObject(target);
	    propertyKey = toPrimitive(propertyKey, true);
	    anObject(attributes);
	    try {
	      dP.f(target, propertyKey, attributes);
	      return true;
	    } catch (e) {
	      return false;
	    }
	  }
	});


/***/ },
/* 715 */
/***/ function(module, exports, __webpack_require__) {

	// 26.1.4 Reflect.deleteProperty(target, propertyKey)
	var $export = __webpack_require__(4);
	var gOPD = __webpack_require__(47).f;
	var anObject = __webpack_require__(15);
	
	$export($export.S, 'Reflect', {
	  deleteProperty: function deleteProperty(target, propertyKey) {
	    var desc = gOPD(anObject(target), propertyKey);
	    return desc && !desc.configurable ? false : delete target[propertyKey];
	  }
	});


/***/ },
/* 716 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// 26.1.5 Reflect.enumerate(target)
	var $export = __webpack_require__(4);
	var anObject = __webpack_require__(15);
	var Enumerate = function (iterated) {
	  this._t = anObject(iterated); // target
	  this._i = 0;                  // next index
	  var keys = this._k = [];      // keys
	  var key;
	  for (key in iterated) keys.push(key);
	};
	__webpack_require__(243)(Enumerate, 'Object', function () {
	  var that = this;
	  var keys = that._k;
	  var key;
	  do {
	    if (that._i >= keys.length) return { value: undefined, done: true };
	  } while (!((key = keys[that._i++]) in that._t));
	  return { value: key, done: false };
	});
	
	$export($export.S, 'Reflect', {
	  enumerate: function enumerate(target) {
	    return new Enumerate(target);
	  }
	});


/***/ },
/* 717 */
/***/ function(module, exports, __webpack_require__) {

	// 26.1.7 Reflect.getOwnPropertyDescriptor(target, propertyKey)
	var gOPD = __webpack_require__(47);
	var $export = __webpack_require__(4);
	var anObject = __webpack_require__(15);
	
	$export($export.S, 'Reflect', {
	  getOwnPropertyDescriptor: function getOwnPropertyDescriptor(target, propertyKey) {
	    return gOPD.f(anObject(target), propertyKey);
	  }
	});


/***/ },
/* 718 */
/***/ function(module, exports, __webpack_require__) {

	// 26.1.8 Reflect.getPrototypeOf(target)
	var $export = __webpack_require__(4);
	var getProto = __webpack_require__(48);
	var anObject = __webpack_require__(15);
	
	$export($export.S, 'Reflect', {
	  getPrototypeOf: function getPrototypeOf(target) {
	    return getProto(anObject(target));
	  }
	});


/***/ },
/* 719 */
/***/ function(module, exports, __webpack_require__) {

	// 26.1.6 Reflect.get(target, propertyKey [, receiver])
	var gOPD = __webpack_require__(47);
	var getPrototypeOf = __webpack_require__(48);
	var has = __webpack_require__(46);
	var $export = __webpack_require__(4);
	var isObject = __webpack_require__(23);
	var anObject = __webpack_require__(15);
	
	function get(target, propertyKey /* , receiver */) {
	  var receiver = arguments.length < 3 ? target : arguments[2];
	  var desc, proto;
	  if (anObject(target) === receiver) return target[propertyKey];
	  if (desc = gOPD.f(target, propertyKey)) return has(desc, 'value')
	    ? desc.value
	    : desc.get !== undefined
	      ? desc.get.call(receiver)
	      : undefined;
	  if (isObject(proto = getPrototypeOf(target))) return get(proto, propertyKey, receiver);
	}
	
	$export($export.S, 'Reflect', { get: get });


/***/ },
/* 720 */
/***/ function(module, exports, __webpack_require__) {

	// 26.1.9 Reflect.has(target, propertyKey)
	var $export = __webpack_require__(4);
	
	$export($export.S, 'Reflect', {
	  has: function has(target, propertyKey) {
	    return propertyKey in target;
	  }
	});


/***/ },
/* 721 */
/***/ function(module, exports, __webpack_require__) {

	// 26.1.10 Reflect.isExtensible(target)
	var $export = __webpack_require__(4);
	var anObject = __webpack_require__(15);
	var $isExtensible = Object.isExtensible;
	
	$export($export.S, 'Reflect', {
	  isExtensible: function isExtensible(target) {
	    anObject(target);
	    return $isExtensible ? $isExtensible(target) : true;
	  }
	});


/***/ },
/* 722 */
/***/ function(module, exports, __webpack_require__) {

	// 26.1.11 Reflect.ownKeys(target)
	var $export = __webpack_require__(4);
	
	$export($export.S, 'Reflect', { ownKeys: __webpack_require__(374) });


/***/ },
/* 723 */
/***/ function(module, exports, __webpack_require__) {

	// 26.1.12 Reflect.preventExtensions(target)
	var $export = __webpack_require__(4);
	var anObject = __webpack_require__(15);
	var $preventExtensions = Object.preventExtensions;
	
	$export($export.S, 'Reflect', {
	  preventExtensions: function preventExtensions(target) {
	    anObject(target);
	    try {
	      if ($preventExtensions) $preventExtensions(target);
	      return true;
	    } catch (e) {
	      return false;
	    }
	  }
	});


/***/ },
/* 724 */
/***/ function(module, exports, __webpack_require__) {

	// 26.1.14 Reflect.setPrototypeOf(target, proto)
	var $export = __webpack_require__(4);
	var setProto = __webpack_require__(250);
	
	if (setProto) $export($export.S, 'Reflect', {
	  setPrototypeOf: function setPrototypeOf(target, proto) {
	    setProto.check(target, proto);
	    try {
	      setProto.set(target, proto);
	      return true;
	    } catch (e) {
	      return false;
	    }
	  }
	});


/***/ },
/* 725 */
/***/ function(module, exports, __webpack_require__) {

	// 26.1.13 Reflect.set(target, propertyKey, V [, receiver])
	var dP = __webpack_require__(32);
	var gOPD = __webpack_require__(47);
	var getPrototypeOf = __webpack_require__(48);
	var has = __webpack_require__(46);
	var $export = __webpack_require__(4);
	var createDesc = __webpack_require__(92);
	var anObject = __webpack_require__(15);
	var isObject = __webpack_require__(23);
	
	function set(target, propertyKey, V /* , receiver */) {
	  var receiver = arguments.length < 4 ? target : arguments[3];
	  var ownDesc = gOPD.f(anObject(target), propertyKey);
	  var existingDescriptor, proto;
	  if (!ownDesc) {
	    if (isObject(proto = getPrototypeOf(target))) {
	      return set(proto, propertyKey, V, receiver);
	    }
	    ownDesc = createDesc(0);
	  }
	  if (has(ownDesc, 'value')) {
	    if (ownDesc.writable === false || !isObject(receiver)) return false;
	    if (existingDescriptor = gOPD.f(receiver, propertyKey)) {
	      if (existingDescriptor.get || existingDescriptor.set || existingDescriptor.writable === false) return false;
	      existingDescriptor.value = V;
	      dP.f(receiver, propertyKey, existingDescriptor);
	    } else dP.f(receiver, propertyKey, createDesc(0, V));
	    return true;
	  }
	  return ownDesc.set === undefined ? false : (ownDesc.set.call(receiver, V), true);
	}
	
	$export($export.S, 'Reflect', { set: set });


/***/ },
/* 726 */
/***/ function(module, exports, __webpack_require__) {

	var global = __webpack_require__(17);
	var inheritIfRequired = __webpack_require__(241);
	var dP = __webpack_require__(32).f;
	var gOPN = __webpack_require__(90).f;
	var isRegExp = __webpack_require__(169);
	var $flags = __webpack_require__(131);
	var $RegExp = global.RegExp;
	var Base = $RegExp;
	var proto = $RegExp.prototype;
	var re1 = /a/g;
	var re2 = /a/g;
	// "new" creates a new object, old webkit buggy here
	var CORRECT_NEW = new $RegExp(re1) !== re1;
	
	if (__webpack_require__(28) && (!CORRECT_NEW || __webpack_require__(21)(function () {
	  re2[__webpack_require__(26)('match')] = false;
	  // RegExp constructor can alter flags and IsRegExp works correct with @@match
	  return $RegExp(re1) != re1 || $RegExp(re2) == re2 || $RegExp(re1, 'i') != '/a/i';
	}))) {
	  $RegExp = function RegExp(p, f) {
	    var tiRE = this instanceof $RegExp;
	    var piRE = isRegExp(p);
	    var fiU = f === undefined;
	    return !tiRE && piRE && p.constructor === $RegExp && fiU ? p
	      : inheritIfRequired(CORRECT_NEW
	        ? new Base(piRE && !fiU ? p.source : p, f)
	        : Base((piRE = p instanceof $RegExp) ? p.source : p, piRE && fiU ? $flags.call(p) : f)
	      , tiRE ? this : proto, $RegExp);
	  };
	  var proxy = function (key) {
	    key in $RegExp || dP($RegExp, key, {
	      configurable: true,
	      get: function () { return Base[key]; },
	      set: function (it) { Base[key] = it; }
	    });
	  };
	  for (var keys = gOPN(Base), i = 0; keys.length > i;) proxy(keys[i++]);
	  proto.constructor = $RegExp;
	  $RegExp.prototype = proto;
	  __webpack_require__(41)(global, 'RegExp', $RegExp);
	}
	
	__webpack_require__(94)('RegExp');


/***/ },
/* 727 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var anObject = __webpack_require__(15);
	var toLength = __webpack_require__(27);
	var advanceStringIndex = __webpack_require__(233);
	var regExpExec = __webpack_require__(173);
	
	// @@match logic
	__webpack_require__(167)('match', 1, function (defined, MATCH, $match, maybeCallNative) {
	  return [
	    // `String.prototype.match` method
	    // https://tc39.github.io/ecma262/#sec-string.prototype.match
	    function match(regexp) {
	      var O = defined(this);
	      var fn = regexp == undefined ? undefined : regexp[MATCH];
	      return fn !== undefined ? fn.call(regexp, O) : new RegExp(regexp)[MATCH](String(O));
	    },
	    // `RegExp.prototype[@@match]` method
	    // https://tc39.github.io/ecma262/#sec-regexp.prototype-@@match
	    function (regexp) {
	      var res = maybeCallNative($match, regexp, this);
	      if (res.done) return res.value;
	      var rx = anObject(regexp);
	      var S = String(this);
	      if (!rx.global) return regExpExec(rx, S);
	      var fullUnicode = rx.unicode;
	      rx.lastIndex = 0;
	      var A = [];
	      var n = 0;
	      var result;
	      while ((result = regExpExec(rx, S)) !== null) {
	        var matchStr = String(result[0]);
	        A[n] = matchStr;
	        if (matchStr === '') rx.lastIndex = advanceStringIndex(S, toLength(rx.lastIndex), fullUnicode);
	        n++;
	      }
	      return n === 0 ? null : A;
	    }
	  ];
	});


/***/ },
/* 728 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var anObject = __webpack_require__(15);
	var toObject = __webpack_require__(34);
	var toLength = __webpack_require__(27);
	var toInteger = __webpack_require__(57);
	var advanceStringIndex = __webpack_require__(233);
	var regExpExec = __webpack_require__(173);
	var max = Math.max;
	var min = Math.min;
	var floor = Math.floor;
	var SUBSTITUTION_SYMBOLS = /\$([$&`']|\d\d?|<[^>]*>)/g;
	var SUBSTITUTION_SYMBOLS_NO_NAMED = /\$([$&`']|\d\d?)/g;
	
	var maybeToString = function (it) {
	  return it === undefined ? it : String(it);
	};
	
	// @@replace logic
	__webpack_require__(167)('replace', 2, function (defined, REPLACE, $replace, maybeCallNative) {
	  return [
	    // `String.prototype.replace` method
	    // https://tc39.github.io/ecma262/#sec-string.prototype.replace
	    function replace(searchValue, replaceValue) {
	      var O = defined(this);
	      var fn = searchValue == undefined ? undefined : searchValue[REPLACE];
	      return fn !== undefined
	        ? fn.call(searchValue, O, replaceValue)
	        : $replace.call(String(O), searchValue, replaceValue);
	    },
	    // `RegExp.prototype[@@replace]` method
	    // https://tc39.github.io/ecma262/#sec-regexp.prototype-@@replace
	    function (regexp, replaceValue) {
	      var res = maybeCallNative($replace, regexp, this, replaceValue);
	      if (res.done) return res.value;
	
	      var rx = anObject(regexp);
	      var S = String(this);
	      var functionalReplace = typeof replaceValue === 'function';
	      if (!functionalReplace) replaceValue = String(replaceValue);
	      var global = rx.global;
	      if (global) {
	        var fullUnicode = rx.unicode;
	        rx.lastIndex = 0;
	      }
	      var results = [];
	      while (true) {
	        var result = regExpExec(rx, S);
	        if (result === null) break;
	        results.push(result);
	        if (!global) break;
	        var matchStr = String(result[0]);
	        if (matchStr === '') rx.lastIndex = advanceStringIndex(S, toLength(rx.lastIndex), fullUnicode);
	      }
	      var accumulatedResult = '';
	      var nextSourcePosition = 0;
	      for (var i = 0; i < results.length; i++) {
	        result = results[i];
	        var matched = String(result[0]);
	        var position = max(min(toInteger(result.index), S.length), 0);
	        var captures = [];
	        // NOTE: This is equivalent to
	        //   captures = result.slice(1).map(maybeToString)
	        // but for some reason `nativeSlice.call(result, 1, result.length)` (called in
	        // the slice polyfill when slicing native arrays) "doesn't work" in safari 9 and
	        // causes a crash (https://pastebin.com/N21QzeQA) when trying to debug it.
	        for (var j = 1; j < result.length; j++) captures.push(maybeToString(result[j]));
	        var namedCaptures = result.groups;
	        if (functionalReplace) {
	          var replacerArgs = [matched].concat(captures, position, S);
	          if (namedCaptures !== undefined) replacerArgs.push(namedCaptures);
	          var replacement = String(replaceValue.apply(undefined, replacerArgs));
	        } else {
	          replacement = getSubstitution(matched, S, position, captures, namedCaptures, replaceValue);
	        }
	        if (position >= nextSourcePosition) {
	          accumulatedResult += S.slice(nextSourcePosition, position) + replacement;
	          nextSourcePosition = position + matched.length;
	        }
	      }
	      return accumulatedResult + S.slice(nextSourcePosition);
	    }
	  ];
	
	    // https://tc39.github.io/ecma262/#sec-getsubstitution
	  function getSubstitution(matched, str, position, captures, namedCaptures, replacement) {
	    var tailPos = position + matched.length;
	    var m = captures.length;
	    var symbols = SUBSTITUTION_SYMBOLS_NO_NAMED;
	    if (namedCaptures !== undefined) {
	      namedCaptures = toObject(namedCaptures);
	      symbols = SUBSTITUTION_SYMBOLS;
	    }
	    return $replace.call(replacement, symbols, function (match, ch) {
	      var capture;
	      switch (ch.charAt(0)) {
	        case '$': return '$';
	        case '&': return matched;
	        case '`': return str.slice(0, position);
	        case "'": return str.slice(tailPos);
	        case '<':
	          capture = namedCaptures[ch.slice(1, -1)];
	          break;
	        default: // \d\d?
	          var n = +ch;
	          if (n === 0) return match;
	          if (n > m) {
	            var f = floor(n / 10);
	            if (f === 0) return match;
	            if (f <= m) return captures[f - 1] === undefined ? ch.charAt(1) : captures[f - 1] + ch.charAt(1);
	            return match;
	          }
	          capture = captures[n - 1];
	      }
	      return capture === undefined ? '' : capture;
	    });
	  }
	});


/***/ },
/* 729 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var anObject = __webpack_require__(15);
	var sameValue = __webpack_require__(379);
	var regExpExec = __webpack_require__(173);
	
	// @@search logic
	__webpack_require__(167)('search', 1, function (defined, SEARCH, $search, maybeCallNative) {
	  return [
	    // `String.prototype.search` method
	    // https://tc39.github.io/ecma262/#sec-string.prototype.search
	    function search(regexp) {
	      var O = defined(this);
	      var fn = regexp == undefined ? undefined : regexp[SEARCH];
	      return fn !== undefined ? fn.call(regexp, O) : new RegExp(regexp)[SEARCH](String(O));
	    },
	    // `RegExp.prototype[@@search]` method
	    // https://tc39.github.io/ecma262/#sec-regexp.prototype-@@search
	    function (regexp) {
	      var res = maybeCallNative($search, regexp, this);
	      if (res.done) return res.value;
	      var rx = anObject(regexp);
	      var S = String(this);
	      var previousLastIndex = rx.lastIndex;
	      if (!sameValue(previousLastIndex, 0)) rx.lastIndex = 0;
	      var result = regExpExec(rx, S);
	      if (!sameValue(rx.lastIndex, previousLastIndex)) rx.lastIndex = previousLastIndex;
	      return result === null ? -1 : result.index;
	    }
	  ];
	});


/***/ },
/* 730 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var isRegExp = __webpack_require__(169);
	var anObject = __webpack_require__(15);
	var speciesConstructor = __webpack_require__(135);
	var advanceStringIndex = __webpack_require__(233);
	var toLength = __webpack_require__(27);
	var callRegExpExec = __webpack_require__(173);
	var regexpExec = __webpack_require__(249);
	var fails = __webpack_require__(21);
	var $min = Math.min;
	var $push = [].push;
	var $SPLIT = 'split';
	var LENGTH = 'length';
	var LAST_INDEX = 'lastIndex';
	var MAX_UINT32 = 0xffffffff;
	
	// babel-minify transpiles RegExp('x', 'y') -> /x/y and it causes SyntaxError
	var SUPPORTS_Y = !fails(function () { RegExp(MAX_UINT32, 'y'); });
	
	// @@split logic
	__webpack_require__(167)('split', 2, function (defined, SPLIT, $split, maybeCallNative) {
	  var internalSplit;
	  if (
	    'abbc'[$SPLIT](/(b)*/)[1] == 'c' ||
	    'test'[$SPLIT](/(?:)/, -1)[LENGTH] != 4 ||
	    'ab'[$SPLIT](/(?:ab)*/)[LENGTH] != 2 ||
	    '.'[$SPLIT](/(.?)(.?)/)[LENGTH] != 4 ||
	    '.'[$SPLIT](/()()/)[LENGTH] > 1 ||
	    ''[$SPLIT](/.?/)[LENGTH]
	  ) {
	    // based on es5-shim implementation, need to rework it
	    internalSplit = function (separator, limit) {
	      var string = String(this);
	      if (separator === undefined && limit === 0) return [];
	      // If `separator` is not a regex, use native split
	      if (!isRegExp(separator)) return $split.call(string, separator, limit);
	      var output = [];
	      var flags = (separator.ignoreCase ? 'i' : '') +
	                  (separator.multiline ? 'm' : '') +
	                  (separator.unicode ? 'u' : '') +
	                  (separator.sticky ? 'y' : '');
	      var lastLastIndex = 0;
	      var splitLimit = limit === undefined ? MAX_UINT32 : limit >>> 0;
	      // Make `global` and avoid `lastIndex` issues by working with a copy
	      var separatorCopy = new RegExp(separator.source, flags + 'g');
	      var match, lastIndex, lastLength;
	      while (match = regexpExec.call(separatorCopy, string)) {
	        lastIndex = separatorCopy[LAST_INDEX];
	        if (lastIndex > lastLastIndex) {
	          output.push(string.slice(lastLastIndex, match.index));
	          if (match[LENGTH] > 1 && match.index < string[LENGTH]) $push.apply(output, match.slice(1));
	          lastLength = match[0][LENGTH];
	          lastLastIndex = lastIndex;
	          if (output[LENGTH] >= splitLimit) break;
	        }
	        if (separatorCopy[LAST_INDEX] === match.index) separatorCopy[LAST_INDEX]++; // Avoid an infinite loop
	      }
	      if (lastLastIndex === string[LENGTH]) {
	        if (lastLength || !separatorCopy.test('')) output.push('');
	      } else output.push(string.slice(lastLastIndex));
	      return output[LENGTH] > splitLimit ? output.slice(0, splitLimit) : output;
	    };
	  // Chakra, V8
	  } else if ('0'[$SPLIT](undefined, 0)[LENGTH]) {
	    internalSplit = function (separator, limit) {
	      return separator === undefined && limit === 0 ? [] : $split.call(this, separator, limit);
	    };
	  } else {
	    internalSplit = $split;
	  }
	
	  return [
	    // `String.prototype.split` method
	    // https://tc39.github.io/ecma262/#sec-string.prototype.split
	    function split(separator, limit) {
	      var O = defined(this);
	      var splitter = separator == undefined ? undefined : separator[SPLIT];
	      return splitter !== undefined
	        ? splitter.call(separator, O, limit)
	        : internalSplit.call(String(O), separator, limit);
	    },
	    // `RegExp.prototype[@@split]` method
	    // https://tc39.github.io/ecma262/#sec-regexp.prototype-@@split
	    //
	    // NOTE: This cannot be properly polyfilled in engines that don't support
	    // the 'y' flag.
	    function (regexp, limit) {
	      var res = maybeCallNative(internalSplit, regexp, this, limit, internalSplit !== $split);
	      if (res.done) return res.value;
	
	      var rx = anObject(regexp);
	      var S = String(this);
	      var C = speciesConstructor(rx, RegExp);
	
	      var unicodeMatching = rx.unicode;
	      var flags = (rx.ignoreCase ? 'i' : '') +
	                  (rx.multiline ? 'm' : '') +
	                  (rx.unicode ? 'u' : '') +
	                  (SUPPORTS_Y ? 'y' : 'g');
	
	      // ^(? + rx + ) is needed, in combination with some S slicing, to
	      // simulate the 'y' flag.
	      var splitter = new C(SUPPORTS_Y ? rx : '^(?:' + rx.source + ')', flags);
	      var lim = limit === undefined ? MAX_UINT32 : limit >>> 0;
	      if (lim === 0) return [];
	      if (S.length === 0) return callRegExpExec(splitter, S) === null ? [S] : [];
	      var p = 0;
	      var q = 0;
	      var A = [];
	      while (q < S.length) {
	        splitter.lastIndex = SUPPORTS_Y ? q : 0;
	        var z = callRegExpExec(splitter, SUPPORTS_Y ? S : S.slice(q));
	        var e;
	        if (
	          z === null ||
	          (e = $min(toLength(splitter.lastIndex + (SUPPORTS_Y ? 0 : q)), S.length)) === p
	        ) {
	          q = advanceStringIndex(S, q, unicodeMatching);
	        } else {
	          A.push(S.slice(p, q));
	          if (A.length === lim) return A;
	          for (var i = 1; i <= z.length - 1; i++) {
	            A.push(z[i]);
	            if (A.length === lim) return A;
	          }
	          q = p = e;
	        }
	      }
	      A.push(S.slice(p));
	      return A;
	    }
	  ];
	});


/***/ },
/* 731 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	__webpack_require__(385);
	var anObject = __webpack_require__(15);
	var $flags = __webpack_require__(131);
	var DESCRIPTORS = __webpack_require__(28);
	var TO_STRING = 'toString';
	var $toString = /./[TO_STRING];
	
	var define = function (fn) {
	  __webpack_require__(41)(RegExp.prototype, TO_STRING, fn, true);
	};
	
	// 21.2.5.14 RegExp.prototype.toString()
	if (__webpack_require__(21)(function () { return $toString.call({ source: 'a', flags: 'b' }) != '/a/b'; })) {
	  define(function toString() {
	    var R = anObject(this);
	    return '/'.concat(R.source, '/',
	      'flags' in R ? R.flags : !DESCRIPTORS && R instanceof RegExp ? $flags.call(R) : undefined);
	  });
	// FF44- RegExp#toString has a wrong name
	} else if ($toString.name != TO_STRING) {
	  define(function toString() {
	    return $toString.call(this);
	  });
	}


/***/ },
/* 732 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.2 String.prototype.anchor(name)
	__webpack_require__(42)('anchor', function (createHTML) {
	  return function anchor(name) {
	    return createHTML(this, 'a', 'name', name);
	  };
	});


/***/ },
/* 733 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.3 String.prototype.big()
	__webpack_require__(42)('big', function (createHTML) {
	  return function big() {
	    return createHTML(this, 'big', '', '');
	  };
	});


/***/ },
/* 734 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.4 String.prototype.blink()
	__webpack_require__(42)('blink', function (createHTML) {
	  return function blink() {
	    return createHTML(this, 'blink', '', '');
	  };
	});


/***/ },
/* 735 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.5 String.prototype.bold()
	__webpack_require__(42)('bold', function (createHTML) {
	  return function bold() {
	    return createHTML(this, 'b', '', '');
	  };
	});


/***/ },
/* 736 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(4);
	var $at = __webpack_require__(176)(false);
	$export($export.P, 'String', {
	  // 21.1.3.3 String.prototype.codePointAt(pos)
	  codePointAt: function codePointAt(pos) {
	    return $at(this, pos);
	  }
	});


/***/ },
/* 737 */
/***/ function(module, exports, __webpack_require__) {

	// 21.1.3.6 String.prototype.endsWith(searchString [, endPosition])
	'use strict';
	var $export = __webpack_require__(4);
	var toLength = __webpack_require__(27);
	var context = __webpack_require__(252);
	var ENDS_WITH = 'endsWith';
	var $endsWith = ''[ENDS_WITH];
	
	$export($export.P + $export.F * __webpack_require__(239)(ENDS_WITH), 'String', {
	  endsWith: function endsWith(searchString /* , endPosition = @length */) {
	    var that = context(this, searchString, ENDS_WITH);
	    var endPosition = arguments.length > 1 ? arguments[1] : undefined;
	    var len = toLength(that.length);
	    var end = endPosition === undefined ? len : Math.min(toLength(endPosition), len);
	    var search = String(searchString);
	    return $endsWith
	      ? $endsWith.call(that, search, end)
	      : that.slice(end - search.length, end) === search;
	  }
	});


/***/ },
/* 738 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.6 String.prototype.fixed()
	__webpack_require__(42)('fixed', function (createHTML) {
	  return function fixed() {
	    return createHTML(this, 'tt', '', '');
	  };
	});


/***/ },
/* 739 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.7 String.prototype.fontcolor(color)
	__webpack_require__(42)('fontcolor', function (createHTML) {
	  return function fontcolor(color) {
	    return createHTML(this, 'font', 'color', color);
	  };
	});


/***/ },
/* 740 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.8 String.prototype.fontsize(size)
	__webpack_require__(42)('fontsize', function (createHTML) {
	  return function fontsize(size) {
	    return createHTML(this, 'font', 'size', size);
	  };
	});


/***/ },
/* 741 */
/***/ function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(4);
	var toAbsoluteIndex = __webpack_require__(95);
	var fromCharCode = String.fromCharCode;
	var $fromCodePoint = String.fromCodePoint;
	
	// length should be 1, old FF problem
	$export($export.S + $export.F * (!!$fromCodePoint && $fromCodePoint.length != 1), 'String', {
	  // 21.1.2.2 String.fromCodePoint(...codePoints)
	  fromCodePoint: function fromCodePoint(x) { // eslint-disable-line no-unused-vars
	    var res = [];
	    var aLen = arguments.length;
	    var i = 0;
	    var code;
	    while (aLen > i) {
	      code = +arguments[i++];
	      if (toAbsoluteIndex(code, 0x10ffff) !== code) throw RangeError(code + ' is not a valid code point');
	      res.push(code < 0x10000
	        ? fromCharCode(code)
	        : fromCharCode(((code -= 0x10000) >> 10) + 0xd800, code % 0x400 + 0xdc00)
	      );
	    } return res.join('');
	  }
	});


/***/ },
/* 742 */
/***/ function(module, exports, __webpack_require__) {

	// 21.1.3.7 String.prototype.includes(searchString, position = 0)
	'use strict';
	var $export = __webpack_require__(4);
	var context = __webpack_require__(252);
	var INCLUDES = 'includes';
	
	$export($export.P + $export.F * __webpack_require__(239)(INCLUDES), 'String', {
	  includes: function includes(searchString /* , position = 0 */) {
	    return !!~context(this, searchString, INCLUDES)
	      .indexOf(searchString, arguments.length > 1 ? arguments[1] : undefined);
	  }
	});


/***/ },
/* 743 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.9 String.prototype.italics()
	__webpack_require__(42)('italics', function (createHTML) {
	  return function italics() {
	    return createHTML(this, 'i', '', '');
	  };
	});


/***/ },
/* 744 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $at = __webpack_require__(176)(true);
	
	// 21.1.3.27 String.prototype[@@iterator]()
	__webpack_require__(244)(String, 'String', function (iterated) {
	  this._t = String(iterated); // target
	  this._i = 0;                // next index
	// 21.1.5.2.1 %StringIteratorPrototype%.next()
	}, function () {
	  var O = this._t;
	  var index = this._i;
	  var point;
	  if (index >= O.length) return { value: undefined, done: true };
	  point = $at(O, index);
	  this._i += point.length;
	  return { value: point, done: false };
	});


/***/ },
/* 745 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.10 String.prototype.link(url)
	__webpack_require__(42)('link', function (createHTML) {
	  return function link(url) {
	    return createHTML(this, 'a', 'href', url);
	  };
	});


/***/ },
/* 746 */
/***/ function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(4);
	var toIObject = __webpack_require__(49);
	var toLength = __webpack_require__(27);
	
	$export($export.S, 'String', {
	  // 21.1.2.4 String.raw(callSite, ...substitutions)
	  raw: function raw(callSite) {
	    var tpl = toIObject(callSite.raw);
	    var len = toLength(tpl.length);
	    var aLen = arguments.length;
	    var res = [];
	    var i = 0;
	    while (len > i) {
	      res.push(String(tpl[i++]));
	      if (i < aLen) res.push(String(arguments[i]));
	    } return res.join('');
	  }
	});


/***/ },
/* 747 */
/***/ function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(4);
	
	$export($export.P, 'String', {
	  // 21.1.3.13 String.prototype.repeat(count)
	  repeat: __webpack_require__(253)
	});


/***/ },
/* 748 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.11 String.prototype.small()
	__webpack_require__(42)('small', function (createHTML) {
	  return function small() {
	    return createHTML(this, 'small', '', '');
	  };
	});


/***/ },
/* 749 */
/***/ function(module, exports, __webpack_require__) {

	// 21.1.3.18 String.prototype.startsWith(searchString [, position ])
	'use strict';
	var $export = __webpack_require__(4);
	var toLength = __webpack_require__(27);
	var context = __webpack_require__(252);
	var STARTS_WITH = 'startsWith';
	var $startsWith = ''[STARTS_WITH];
	
	$export($export.P + $export.F * __webpack_require__(239)(STARTS_WITH), 'String', {
	  startsWith: function startsWith(searchString /* , position = 0 */) {
	    var that = context(this, searchString, STARTS_WITH);
	    var index = toLength(Math.min(arguments.length > 1 ? arguments[1] : undefined, that.length));
	    var search = String(searchString);
	    return $startsWith
	      ? $startsWith.call(that, search, index)
	      : that.slice(index, index + search.length) === search;
	  }
	});


/***/ },
/* 750 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.12 String.prototype.strike()
	__webpack_require__(42)('strike', function (createHTML) {
	  return function strike() {
	    return createHTML(this, 'strike', '', '');
	  };
	});


/***/ },
/* 751 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.13 String.prototype.sub()
	__webpack_require__(42)('sub', function (createHTML) {
	  return function sub() {
	    return createHTML(this, 'sub', '', '');
	  };
	});


/***/ },
/* 752 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.14 String.prototype.sup()
	__webpack_require__(42)('sup', function (createHTML) {
	  return function sup() {
	    return createHTML(this, 'sup', '', '');
	  };
	});


/***/ },
/* 753 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// 21.1.3.25 String.prototype.trim()
	__webpack_require__(110)('trim', function ($trim) {
	  return function trim() {
	    return $trim(this, 3);
	  };
	});


/***/ },
/* 754 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// ECMAScript 6 symbols shim
	var global = __webpack_require__(17);
	var has = __webpack_require__(46);
	var DESCRIPTORS = __webpack_require__(28);
	var $export = __webpack_require__(4);
	var redefine = __webpack_require__(41);
	var META = __webpack_require__(83).KEY;
	var $fails = __webpack_require__(21);
	var shared = __webpack_require__(134);
	var setToStringTag = __webpack_require__(109);
	var uid = __webpack_require__(96);
	var wks = __webpack_require__(26);
	var wksExt = __webpack_require__(382);
	var wksDefine = __webpack_require__(257);
	var enumKeys = __webpack_require__(631);
	var isArray = __webpack_require__(168);
	var anObject = __webpack_require__(15);
	var isObject = __webpack_require__(23);
	var toObject = __webpack_require__(34);
	var toIObject = __webpack_require__(49);
	var toPrimitive = __webpack_require__(64);
	var createDesc = __webpack_require__(92);
	var _create = __webpack_require__(89);
	var gOPNExt = __webpack_require__(371);
	var $GOPD = __webpack_require__(47);
	var $GOPS = __webpack_require__(172);
	var $DP = __webpack_require__(32);
	var $keys = __webpack_require__(91);
	var gOPD = $GOPD.f;
	var dP = $DP.f;
	var gOPN = gOPNExt.f;
	var $Symbol = global.Symbol;
	var $JSON = global.JSON;
	var _stringify = $JSON && $JSON.stringify;
	var PROTOTYPE = 'prototype';
	var HIDDEN = wks('_hidden');
	var TO_PRIMITIVE = wks('toPrimitive');
	var isEnum = {}.propertyIsEnumerable;
	var SymbolRegistry = shared('symbol-registry');
	var AllSymbols = shared('symbols');
	var OPSymbols = shared('op-symbols');
	var ObjectProto = Object[PROTOTYPE];
	var USE_NATIVE = typeof $Symbol == 'function' && !!$GOPS.f;
	var QObject = global.QObject;
	// Don't use setters in Qt Script, https://github.com/zloirock/core-js/issues/173
	var setter = !QObject || !QObject[PROTOTYPE] || !QObject[PROTOTYPE].findChild;
	
	// fallback for old Android, https://code.google.com/p/v8/issues/detail?id=687
	var setSymbolDesc = DESCRIPTORS && $fails(function () {
	  return _create(dP({}, 'a', {
	    get: function () { return dP(this, 'a', { value: 7 }).a; }
	  })).a != 7;
	}) ? function (it, key, D) {
	  var protoDesc = gOPD(ObjectProto, key);
	  if (protoDesc) delete ObjectProto[key];
	  dP(it, key, D);
	  if (protoDesc && it !== ObjectProto) dP(ObjectProto, key, protoDesc);
	} : dP;
	
	var wrap = function (tag) {
	  var sym = AllSymbols[tag] = _create($Symbol[PROTOTYPE]);
	  sym._k = tag;
	  return sym;
	};
	
	var isSymbol = USE_NATIVE && typeof $Symbol.iterator == 'symbol' ? function (it) {
	  return typeof it == 'symbol';
	} : function (it) {
	  return it instanceof $Symbol;
	};
	
	var $defineProperty = function defineProperty(it, key, D) {
	  if (it === ObjectProto) $defineProperty(OPSymbols, key, D);
	  anObject(it);
	  key = toPrimitive(key, true);
	  anObject(D);
	  if (has(AllSymbols, key)) {
	    if (!D.enumerable) {
	      if (!has(it, HIDDEN)) dP(it, HIDDEN, createDesc(1, {}));
	      it[HIDDEN][key] = true;
	    } else {
	      if (has(it, HIDDEN) && it[HIDDEN][key]) it[HIDDEN][key] = false;
	      D = _create(D, { enumerable: createDesc(0, false) });
	    } return setSymbolDesc(it, key, D);
	  } return dP(it, key, D);
	};
	var $defineProperties = function defineProperties(it, P) {
	  anObject(it);
	  var keys = enumKeys(P = toIObject(P));
	  var i = 0;
	  var l = keys.length;
	  var key;
	  while (l > i) $defineProperty(it, key = keys[i++], P[key]);
	  return it;
	};
	var $create = function create(it, P) {
	  return P === undefined ? _create(it) : $defineProperties(_create(it), P);
	};
	var $propertyIsEnumerable = function propertyIsEnumerable(key) {
	  var E = isEnum.call(this, key = toPrimitive(key, true));
	  if (this === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return false;
	  return E || !has(this, key) || !has(AllSymbols, key) || has(this, HIDDEN) && this[HIDDEN][key] ? E : true;
	};
	var $getOwnPropertyDescriptor = function getOwnPropertyDescriptor(it, key) {
	  it = toIObject(it);
	  key = toPrimitive(key, true);
	  if (it === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return;
	  var D = gOPD(it, key);
	  if (D && has(AllSymbols, key) && !(has(it, HIDDEN) && it[HIDDEN][key])) D.enumerable = true;
	  return D;
	};
	var $getOwnPropertyNames = function getOwnPropertyNames(it) {
	  var names = gOPN(toIObject(it));
	  var result = [];
	  var i = 0;
	  var key;
	  while (names.length > i) {
	    if (!has(AllSymbols, key = names[i++]) && key != HIDDEN && key != META) result.push(key);
	  } return result;
	};
	var $getOwnPropertySymbols = function getOwnPropertySymbols(it) {
	  var IS_OP = it === ObjectProto;
	  var names = gOPN(IS_OP ? OPSymbols : toIObject(it));
	  var result = [];
	  var i = 0;
	  var key;
	  while (names.length > i) {
	    if (has(AllSymbols, key = names[i++]) && (IS_OP ? has(ObjectProto, key) : true)) result.push(AllSymbols[key]);
	  } return result;
	};
	
	// 19.4.1.1 Symbol([description])
	if (!USE_NATIVE) {
	  $Symbol = function Symbol() {
	    if (this instanceof $Symbol) throw TypeError('Symbol is not a constructor!');
	    var tag = uid(arguments.length > 0 ? arguments[0] : undefined);
	    var $set = function (value) {
	      if (this === ObjectProto) $set.call(OPSymbols, value);
	      if (has(this, HIDDEN) && has(this[HIDDEN], tag)) this[HIDDEN][tag] = false;
	      setSymbolDesc(this, tag, createDesc(1, value));
	    };
	    if (DESCRIPTORS && setter) setSymbolDesc(ObjectProto, tag, { configurable: true, set: $set });
	    return wrap(tag);
	  };
	  redefine($Symbol[PROTOTYPE], 'toString', function toString() {
	    return this._k;
	  });
	
	  $GOPD.f = $getOwnPropertyDescriptor;
	  $DP.f = $defineProperty;
	  __webpack_require__(90).f = gOPNExt.f = $getOwnPropertyNames;
	  __webpack_require__(133).f = $propertyIsEnumerable;
	  $GOPS.f = $getOwnPropertySymbols;
	
	  if (DESCRIPTORS && !__webpack_require__(82)) {
	    redefine(ObjectProto, 'propertyIsEnumerable', $propertyIsEnumerable, true);
	  }
	
	  wksExt.f = function (name) {
	    return wrap(wks(name));
	  };
	}
	
	$export($export.G + $export.W + $export.F * !USE_NATIVE, { Symbol: $Symbol });
	
	for (var es6Symbols = (
	  // 19.4.2.2, 19.4.2.3, 19.4.2.4, 19.4.2.6, 19.4.2.8, 19.4.2.9, 19.4.2.10, 19.4.2.11, 19.4.2.12, 19.4.2.13, 19.4.2.14
	  'hasInstance,isConcatSpreadable,iterator,match,replace,search,species,split,toPrimitive,toStringTag,unscopables'
	).split(','), j = 0; es6Symbols.length > j;)wks(es6Symbols[j++]);
	
	for (var wellKnownSymbols = $keys(wks.store), k = 0; wellKnownSymbols.length > k;) wksDefine(wellKnownSymbols[k++]);
	
	$export($export.S + $export.F * !USE_NATIVE, 'Symbol', {
	  // 19.4.2.1 Symbol.for(key)
	  'for': function (key) {
	    return has(SymbolRegistry, key += '')
	      ? SymbolRegistry[key]
	      : SymbolRegistry[key] = $Symbol(key);
	  },
	  // 19.4.2.5 Symbol.keyFor(sym)
	  keyFor: function keyFor(sym) {
	    if (!isSymbol(sym)) throw TypeError(sym + ' is not a symbol!');
	    for (var key in SymbolRegistry) if (SymbolRegistry[key] === sym) return key;
	  },
	  useSetter: function () { setter = true; },
	  useSimple: function () { setter = false; }
	});
	
	$export($export.S + $export.F * !USE_NATIVE, 'Object', {
	  // 19.1.2.2 Object.create(O [, Properties])
	  create: $create,
	  // 19.1.2.4 Object.defineProperty(O, P, Attributes)
	  defineProperty: $defineProperty,
	  // 19.1.2.3 Object.defineProperties(O, Properties)
	  defineProperties: $defineProperties,
	  // 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
	  getOwnPropertyDescriptor: $getOwnPropertyDescriptor,
	  // 19.1.2.7 Object.getOwnPropertyNames(O)
	  getOwnPropertyNames: $getOwnPropertyNames,
	  // 19.1.2.8 Object.getOwnPropertySymbols(O)
	  getOwnPropertySymbols: $getOwnPropertySymbols
	});
	
	// Chrome 38 and 39 `Object.getOwnPropertySymbols` fails on primitives
	// https://bugs.chromium.org/p/v8/issues/detail?id=3443
	var FAILS_ON_PRIMITIVES = $fails(function () { $GOPS.f(1); });
	
	$export($export.S + $export.F * FAILS_ON_PRIMITIVES, 'Object', {
	  getOwnPropertySymbols: function getOwnPropertySymbols(it) {
	    return $GOPS.f(toObject(it));
	  }
	});
	
	// 24.3.2 JSON.stringify(value [, replacer [, space]])
	$JSON && $export($export.S + $export.F * (!USE_NATIVE || $fails(function () {
	  var S = $Symbol();
	  // MS Edge converts symbol values to JSON as {}
	  // WebKit converts symbol values to JSON as null
	  // V8 throws on boxed symbols
	  return _stringify([S]) != '[null]' || _stringify({ a: S }) != '{}' || _stringify(Object(S)) != '{}';
	})), 'JSON', {
	  stringify: function stringify(it) {
	    var args = [it];
	    var i = 1;
	    var replacer, $replacer;
	    while (arguments.length > i) args.push(arguments[i++]);
	    $replacer = replacer = args[1];
	    if (!isObject(replacer) && it === undefined || isSymbol(it)) return; // IE8 returns string on undefined
	    if (!isArray(replacer)) replacer = function (key, value) {
	      if (typeof $replacer == 'function') value = $replacer.call(this, key, value);
	      if (!isSymbol(value)) return value;
	    };
	    args[1] = replacer;
	    return _stringify.apply($JSON, args);
	  }
	});
	
	// 19.4.3.4 Symbol.prototype[@@toPrimitive](hint)
	$Symbol[PROTOTYPE][TO_PRIMITIVE] || __webpack_require__(40)($Symbol[PROTOTYPE], TO_PRIMITIVE, $Symbol[PROTOTYPE].valueOf);
	// 19.4.3.5 Symbol.prototype[@@toStringTag]
	setToStringTag($Symbol, 'Symbol');
	// 20.2.1.9 Math[@@toStringTag]
	setToStringTag(Math, 'Math', true);
	// 24.3.3 JSON[@@toStringTag]
	setToStringTag(global.JSON, 'JSON', true);


/***/ },
/* 755 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(4);
	var $typed = __webpack_require__(177);
	var buffer = __webpack_require__(256);
	var anObject = __webpack_require__(15);
	var toAbsoluteIndex = __webpack_require__(95);
	var toLength = __webpack_require__(27);
	var isObject = __webpack_require__(23);
	var ArrayBuffer = __webpack_require__(17).ArrayBuffer;
	var speciesConstructor = __webpack_require__(135);
	var $ArrayBuffer = buffer.ArrayBuffer;
	var $DataView = buffer.DataView;
	var $isView = $typed.ABV && ArrayBuffer.isView;
	var $slice = $ArrayBuffer.prototype.slice;
	var VIEW = $typed.VIEW;
	var ARRAY_BUFFER = 'ArrayBuffer';
	
	$export($export.G + $export.W + $export.F * (ArrayBuffer !== $ArrayBuffer), { ArrayBuffer: $ArrayBuffer });
	
	$export($export.S + $export.F * !$typed.CONSTR, ARRAY_BUFFER, {
	  // 24.1.3.1 ArrayBuffer.isView(arg)
	  isView: function isView(it) {
	    return $isView && $isView(it) || isObject(it) && VIEW in it;
	  }
	});
	
	$export($export.P + $export.U + $export.F * __webpack_require__(21)(function () {
	  return !new $ArrayBuffer(2).slice(1, undefined).byteLength;
	}), ARRAY_BUFFER, {
	  // 24.1.4.3 ArrayBuffer.prototype.slice(start, end)
	  slice: function slice(start, end) {
	    if ($slice !== undefined && end === undefined) return $slice.call(anObject(this), start); // FF fix
	    var len = anObject(this).byteLength;
	    var first = toAbsoluteIndex(start, len);
	    var fin = toAbsoluteIndex(end === undefined ? len : end, len);
	    var result = new (speciesConstructor(this, $ArrayBuffer))(toLength(fin - first));
	    var viewS = new $DataView(this);
	    var viewT = new $DataView(result);
	    var index = 0;
	    while (first < fin) {
	      viewT.setUint8(index++, viewS.getUint8(first++));
	    } return result;
	  }
	});
	
	__webpack_require__(94)(ARRAY_BUFFER);


/***/ },
/* 756 */
/***/ function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(4);
	$export($export.G + $export.W + $export.F * !__webpack_require__(177).ABV, {
	  DataView: __webpack_require__(256).DataView
	});


/***/ },
/* 757 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(72)('Float32', 4, function (init) {
	  return function Float32Array(data, byteOffset, length) {
	    return init(this, data, byteOffset, length);
	  };
	});


/***/ },
/* 758 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(72)('Float64', 8, function (init) {
	  return function Float64Array(data, byteOffset, length) {
	    return init(this, data, byteOffset, length);
	  };
	});


/***/ },
/* 759 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(72)('Int16', 2, function (init) {
	  return function Int16Array(data, byteOffset, length) {
	    return init(this, data, byteOffset, length);
	  };
	});


/***/ },
/* 760 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(72)('Int32', 4, function (init) {
	  return function Int32Array(data, byteOffset, length) {
	    return init(this, data, byteOffset, length);
	  };
	});


/***/ },
/* 761 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(72)('Int8', 1, function (init) {
	  return function Int8Array(data, byteOffset, length) {
	    return init(this, data, byteOffset, length);
	  };
	});


/***/ },
/* 762 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(72)('Uint16', 2, function (init) {
	  return function Uint16Array(data, byteOffset, length) {
	    return init(this, data, byteOffset, length);
	  };
	});


/***/ },
/* 763 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(72)('Uint32', 4, function (init) {
	  return function Uint32Array(data, byteOffset, length) {
	    return init(this, data, byteOffset, length);
	  };
	});


/***/ },
/* 764 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(72)('Uint8', 1, function (init) {
	  return function Uint8Array(data, byteOffset, length) {
	    return init(this, data, byteOffset, length);
	  };
	});


/***/ },
/* 765 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(72)('Uint8', 1, function (init) {
	  return function Uint8ClampedArray(data, byteOffset, length) {
	    return init(this, data, byteOffset, length);
	  };
	}, true);


/***/ },
/* 766 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var weak = __webpack_require__(359);
	var validate = __webpack_require__(97);
	var WEAK_SET = 'WeakSet';
	
	// 23.4 WeakSet Objects
	__webpack_require__(166)(WEAK_SET, function (get) {
	  return function WeakSet() { return get(this, arguments.length > 0 ? arguments[0] : undefined); };
	}, {
	  // 23.4.3.1 WeakSet.prototype.add(value)
	  add: function add(value) {
	    return weak.def(validate(this, WEAK_SET), value, true);
	  }
	}, weak, false, true);


/***/ },
/* 767 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// https://tc39.github.io/proposal-flatMap/#sec-Array.prototype.flatMap
	var $export = __webpack_require__(4);
	var flattenIntoArray = __webpack_require__(360);
	var toObject = __webpack_require__(34);
	var toLength = __webpack_require__(27);
	var aFunction = __webpack_require__(39);
	var arraySpeciesCreate = __webpack_require__(235);
	
	$export($export.P, 'Array', {
	  flatMap: function flatMap(callbackfn /* , thisArg */) {
	    var O = toObject(this);
	    var sourceLen, A;
	    aFunction(callbackfn);
	    sourceLen = toLength(O.length);
	    A = arraySpeciesCreate(O, 0);
	    flattenIntoArray(A, O, O, sourceLen, 0, 1, callbackfn, arguments[1]);
	    return A;
	  }
	});
	
	__webpack_require__(81)('flatMap');


/***/ },
/* 768 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// https://tc39.github.io/proposal-flatMap/#sec-Array.prototype.flatten
	var $export = __webpack_require__(4);
	var flattenIntoArray = __webpack_require__(360);
	var toObject = __webpack_require__(34);
	var toLength = __webpack_require__(27);
	var toInteger = __webpack_require__(57);
	var arraySpeciesCreate = __webpack_require__(235);
	
	$export($export.P, 'Array', {
	  flatten: function flatten(/* depthArg = 1 */) {
	    var depthArg = arguments[0];
	    var O = toObject(this);
	    var sourceLen = toLength(O.length);
	    var A = arraySpeciesCreate(O, 0);
	    flattenIntoArray(A, O, O, sourceLen, 0, depthArg === undefined ? 1 : toInteger(depthArg));
	    return A;
	  }
	});
	
	__webpack_require__(81)('flatten');


/***/ },
/* 769 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// https://github.com/tc39/Array.prototype.includes
	var $export = __webpack_require__(4);
	var $includes = __webpack_require__(165)(true);
	
	$export($export.P, 'Array', {
	  includes: function includes(el /* , fromIndex = 0 */) {
	    return $includes(this, el, arguments.length > 1 ? arguments[1] : undefined);
	  }
	});
	
	__webpack_require__(81)('includes');


/***/ },
/* 770 */
/***/ function(module, exports, __webpack_require__) {

	// https://github.com/rwaldron/tc39-notes/blob/master/es6/2014-09/sept-25.md#510-globalasap-for-enqueuing-a-microtask
	var $export = __webpack_require__(4);
	var microtask = __webpack_require__(247)();
	var process = __webpack_require__(17).process;
	var isNode = __webpack_require__(53)(process) == 'process';
	
	$export($export.G, {
	  asap: function asap(fn) {
	    var domain = isNode && process.domain;
	    microtask(domain ? domain.bind(fn) : fn);
	  }
	});


/***/ },
/* 771 */
/***/ function(module, exports, __webpack_require__) {

	// https://github.com/ljharb/proposal-is-error
	var $export = __webpack_require__(4);
	var cof = __webpack_require__(53);
	
	$export($export.S, 'Error', {
	  isError: function isError(it) {
	    return cof(it) === 'Error';
	  }
	});


/***/ },
/* 772 */
/***/ function(module, exports, __webpack_require__) {

	// https://github.com/tc39/proposal-global
	var $export = __webpack_require__(4);
	
	$export($export.G, { global: __webpack_require__(17) });


/***/ },
/* 773 */
/***/ function(module, exports, __webpack_require__) {

	// https://tc39.github.io/proposal-setmap-offrom/#sec-map.from
	__webpack_require__(174)('Map');


/***/ },
/* 774 */
/***/ function(module, exports, __webpack_require__) {

	// https://tc39.github.io/proposal-setmap-offrom/#sec-map.of
	__webpack_require__(175)('Map');


/***/ },
/* 775 */
/***/ function(module, exports, __webpack_require__) {

	// https://github.com/DavidBruant/Map-Set.prototype.toJSON
	var $export = __webpack_require__(4);
	
	$export($export.P + $export.R, 'Map', { toJSON: __webpack_require__(358)('Map') });


/***/ },
/* 776 */
/***/ function(module, exports, __webpack_require__) {

	// https://rwaldron.github.io/proposal-math-extensions/
	var $export = __webpack_require__(4);
	
	$export($export.S, 'Math', {
	  clamp: function clamp(x, lower, upper) {
	    return Math.min(upper, Math.max(lower, x));
	  }
	});


/***/ },
/* 777 */
/***/ function(module, exports, __webpack_require__) {

	// https://rwaldron.github.io/proposal-math-extensions/
	var $export = __webpack_require__(4);
	
	$export($export.S, 'Math', { DEG_PER_RAD: Math.PI / 180 });


/***/ },
/* 778 */
/***/ function(module, exports, __webpack_require__) {

	// https://rwaldron.github.io/proposal-math-extensions/
	var $export = __webpack_require__(4);
	var RAD_PER_DEG = 180 / Math.PI;
	
	$export($export.S, 'Math', {
	  degrees: function degrees(radians) {
	    return radians * RAD_PER_DEG;
	  }
	});


/***/ },
/* 779 */
/***/ function(module, exports, __webpack_require__) {

	// https://rwaldron.github.io/proposal-math-extensions/
	var $export = __webpack_require__(4);
	var scale = __webpack_require__(368);
	var fround = __webpack_require__(366);
	
	$export($export.S, 'Math', {
	  fscale: function fscale(x, inLow, inHigh, outLow, outHigh) {
	    return fround(scale(x, inLow, inHigh, outLow, outHigh));
	  }
	});


/***/ },
/* 780 */
/***/ function(module, exports, __webpack_require__) {

	// https://gist.github.com/BrendanEich/4294d5c212a6d2254703
	var $export = __webpack_require__(4);
	
	$export($export.S, 'Math', {
	  iaddh: function iaddh(x0, x1, y0, y1) {
	    var $x0 = x0 >>> 0;
	    var $x1 = x1 >>> 0;
	    var $y0 = y0 >>> 0;
	    return $x1 + (y1 >>> 0) + (($x0 & $y0 | ($x0 | $y0) & ~($x0 + $y0 >>> 0)) >>> 31) | 0;
	  }
	});


/***/ },
/* 781 */
/***/ function(module, exports, __webpack_require__) {

	// https://gist.github.com/BrendanEich/4294d5c212a6d2254703
	var $export = __webpack_require__(4);
	
	$export($export.S, 'Math', {
	  imulh: function imulh(u, v) {
	    var UINT16 = 0xffff;
	    var $u = +u;
	    var $v = +v;
	    var u0 = $u & UINT16;
	    var v0 = $v & UINT16;
	    var u1 = $u >> 16;
	    var v1 = $v >> 16;
	    var t = (u1 * v0 >>> 0) + (u0 * v0 >>> 16);
	    return u1 * v1 + (t >> 16) + ((u0 * v1 >>> 0) + (t & UINT16) >> 16);
	  }
	});


/***/ },
/* 782 */
/***/ function(module, exports, __webpack_require__) {

	// https://gist.github.com/BrendanEich/4294d5c212a6d2254703
	var $export = __webpack_require__(4);
	
	$export($export.S, 'Math', {
	  isubh: function isubh(x0, x1, y0, y1) {
	    var $x0 = x0 >>> 0;
	    var $x1 = x1 >>> 0;
	    var $y0 = y0 >>> 0;
	    return $x1 - (y1 >>> 0) - ((~$x0 & $y0 | ~($x0 ^ $y0) & $x0 - $y0 >>> 0) >>> 31) | 0;
	  }
	});


/***/ },
/* 783 */
/***/ function(module, exports, __webpack_require__) {

	// https://rwaldron.github.io/proposal-math-extensions/
	var $export = __webpack_require__(4);
	
	$export($export.S, 'Math', { RAD_PER_DEG: 180 / Math.PI });


/***/ },
/* 784 */
/***/ function(module, exports, __webpack_require__) {

	// https://rwaldron.github.io/proposal-math-extensions/
	var $export = __webpack_require__(4);
	var DEG_PER_RAD = Math.PI / 180;
	
	$export($export.S, 'Math', {
	  radians: function radians(degrees) {
	    return degrees * DEG_PER_RAD;
	  }
	});


/***/ },
/* 785 */
/***/ function(module, exports, __webpack_require__) {

	// https://rwaldron.github.io/proposal-math-extensions/
	var $export = __webpack_require__(4);
	
	$export($export.S, 'Math', { scale: __webpack_require__(368) });


/***/ },
/* 786 */
/***/ function(module, exports, __webpack_require__) {

	// http://jfbastien.github.io/papers/Math.signbit.html
	var $export = __webpack_require__(4);
	
	$export($export.S, 'Math', { signbit: function signbit(x) {
	  // eslint-disable-next-line no-self-compare
	  return (x = +x) != x ? x : x == 0 ? 1 / x == Infinity : x > 0;
	} });


/***/ },
/* 787 */
/***/ function(module, exports, __webpack_require__) {

	// https://gist.github.com/BrendanEich/4294d5c212a6d2254703
	var $export = __webpack_require__(4);
	
	$export($export.S, 'Math', {
	  umulh: function umulh(u, v) {
	    var UINT16 = 0xffff;
	    var $u = +u;
	    var $v = +v;
	    var u0 = $u & UINT16;
	    var v0 = $v & UINT16;
	    var u1 = $u >>> 16;
	    var v1 = $v >>> 16;
	    var t = (u1 * v0 >>> 0) + (u0 * v0 >>> 16);
	    return u1 * v1 + (t >>> 16) + ((u0 * v1 >>> 0) + (t & UINT16) >>> 16);
	  }
	});


/***/ },
/* 788 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(4);
	var toObject = __webpack_require__(34);
	var aFunction = __webpack_require__(39);
	var $defineProperty = __webpack_require__(32);
	
	// B.2.2.2 Object.prototype.__defineGetter__(P, getter)
	__webpack_require__(28) && $export($export.P + __webpack_require__(171), 'Object', {
	  __defineGetter__: function __defineGetter__(P, getter) {
	    $defineProperty.f(toObject(this), P, { get: aFunction(getter), enumerable: true, configurable: true });
	  }
	});


/***/ },
/* 789 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(4);
	var toObject = __webpack_require__(34);
	var aFunction = __webpack_require__(39);
	var $defineProperty = __webpack_require__(32);
	
	// B.2.2.3 Object.prototype.__defineSetter__(P, setter)
	__webpack_require__(28) && $export($export.P + __webpack_require__(171), 'Object', {
	  __defineSetter__: function __defineSetter__(P, setter) {
	    $defineProperty.f(toObject(this), P, { set: aFunction(setter), enumerable: true, configurable: true });
	  }
	});


/***/ },
/* 790 */
/***/ function(module, exports, __webpack_require__) {

	// https://github.com/tc39/proposal-object-values-entries
	var $export = __webpack_require__(4);
	var $entries = __webpack_require__(373)(true);
	
	$export($export.S, 'Object', {
	  entries: function entries(it) {
	    return $entries(it);
	  }
	});


/***/ },
/* 791 */
/***/ function(module, exports, __webpack_require__) {

	// https://github.com/tc39/proposal-object-getownpropertydescriptors
	var $export = __webpack_require__(4);
	var ownKeys = __webpack_require__(374);
	var toIObject = __webpack_require__(49);
	var gOPD = __webpack_require__(47);
	var createProperty = __webpack_require__(236);
	
	$export($export.S, 'Object', {
	  getOwnPropertyDescriptors: function getOwnPropertyDescriptors(object) {
	    var O = toIObject(object);
	    var getDesc = gOPD.f;
	    var keys = ownKeys(O);
	    var result = {};
	    var i = 0;
	    var key, desc;
	    while (keys.length > i) {
	      desc = getDesc(O, key = keys[i++]);
	      if (desc !== undefined) createProperty(result, key, desc);
	    }
	    return result;
	  }
	});


/***/ },
/* 792 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(4);
	var toObject = __webpack_require__(34);
	var toPrimitive = __webpack_require__(64);
	var getPrototypeOf = __webpack_require__(48);
	var getOwnPropertyDescriptor = __webpack_require__(47).f;
	
	// B.2.2.4 Object.prototype.__lookupGetter__(P)
	__webpack_require__(28) && $export($export.P + __webpack_require__(171), 'Object', {
	  __lookupGetter__: function __lookupGetter__(P) {
	    var O = toObject(this);
	    var K = toPrimitive(P, true);
	    var D;
	    do {
	      if (D = getOwnPropertyDescriptor(O, K)) return D.get;
	    } while (O = getPrototypeOf(O));
	  }
	});


/***/ },
/* 793 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(4);
	var toObject = __webpack_require__(34);
	var toPrimitive = __webpack_require__(64);
	var getPrototypeOf = __webpack_require__(48);
	var getOwnPropertyDescriptor = __webpack_require__(47).f;
	
	// B.2.2.5 Object.prototype.__lookupSetter__(P)
	__webpack_require__(28) && $export($export.P + __webpack_require__(171), 'Object', {
	  __lookupSetter__: function __lookupSetter__(P) {
	    var O = toObject(this);
	    var K = toPrimitive(P, true);
	    var D;
	    do {
	      if (D = getOwnPropertyDescriptor(O, K)) return D.set;
	    } while (O = getPrototypeOf(O));
	  }
	});


/***/ },
/* 794 */
/***/ function(module, exports, __webpack_require__) {

	// https://github.com/tc39/proposal-object-values-entries
	var $export = __webpack_require__(4);
	var $values = __webpack_require__(373)(false);
	
	$export($export.S, 'Object', {
	  values: function values(it) {
	    return $values(it);
	  }
	});


/***/ },
/* 795 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// https://github.com/zenparsing/es-observable
	var $export = __webpack_require__(4);
	var global = __webpack_require__(17);
	var core = __webpack_require__(54);
	var microtask = __webpack_require__(247)();
	var OBSERVABLE = __webpack_require__(26)('observable');
	var aFunction = __webpack_require__(39);
	var anObject = __webpack_require__(15);
	var anInstance = __webpack_require__(87);
	var redefineAll = __webpack_require__(93);
	var hide = __webpack_require__(40);
	var forOf = __webpack_require__(88);
	var RETURN = forOf.RETURN;
	
	var getMethod = function (fn) {
	  return fn == null ? undefined : aFunction(fn);
	};
	
	var cleanupSubscription = function (subscription) {
	  var cleanup = subscription._c;
	  if (cleanup) {
	    subscription._c = undefined;
	    cleanup();
	  }
	};
	
	var subscriptionClosed = function (subscription) {
	  return subscription._o === undefined;
	};
	
	var closeSubscription = function (subscription) {
	  if (!subscriptionClosed(subscription)) {
	    subscription._o = undefined;
	    cleanupSubscription(subscription);
	  }
	};
	
	var Subscription = function (observer, subscriber) {
	  anObject(observer);
	  this._c = undefined;
	  this._o = observer;
	  observer = new SubscriptionObserver(this);
	  try {
	    var cleanup = subscriber(observer);
	    var subscription = cleanup;
	    if (cleanup != null) {
	      if (typeof cleanup.unsubscribe === 'function') cleanup = function () { subscription.unsubscribe(); };
	      else aFunction(cleanup);
	      this._c = cleanup;
	    }
	  } catch (e) {
	    observer.error(e);
	    return;
	  } if (subscriptionClosed(this)) cleanupSubscription(this);
	};
	
	Subscription.prototype = redefineAll({}, {
	  unsubscribe: function unsubscribe() { closeSubscription(this); }
	});
	
	var SubscriptionObserver = function (subscription) {
	  this._s = subscription;
	};
	
	SubscriptionObserver.prototype = redefineAll({}, {
	  next: function next(value) {
	    var subscription = this._s;
	    if (!subscriptionClosed(subscription)) {
	      var observer = subscription._o;
	      try {
	        var m = getMethod(observer.next);
	        if (m) return m.call(observer, value);
	      } catch (e) {
	        try {
	          closeSubscription(subscription);
	        } finally {
	          throw e;
	        }
	      }
	    }
	  },
	  error: function error(value) {
	    var subscription = this._s;
	    if (subscriptionClosed(subscription)) throw value;
	    var observer = subscription._o;
	    subscription._o = undefined;
	    try {
	      var m = getMethod(observer.error);
	      if (!m) throw value;
	      value = m.call(observer, value);
	    } catch (e) {
	      try {
	        cleanupSubscription(subscription);
	      } finally {
	        throw e;
	      }
	    } cleanupSubscription(subscription);
	    return value;
	  },
	  complete: function complete(value) {
	    var subscription = this._s;
	    if (!subscriptionClosed(subscription)) {
	      var observer = subscription._o;
	      subscription._o = undefined;
	      try {
	        var m = getMethod(observer.complete);
	        value = m ? m.call(observer, value) : undefined;
	      } catch (e) {
	        try {
	          cleanupSubscription(subscription);
	        } finally {
	          throw e;
	        }
	      } cleanupSubscription(subscription);
	      return value;
	    }
	  }
	});
	
	var $Observable = function Observable(subscriber) {
	  anInstance(this, $Observable, 'Observable', '_f')._f = aFunction(subscriber);
	};
	
	redefineAll($Observable.prototype, {
	  subscribe: function subscribe(observer) {
	    return new Subscription(observer, this._f);
	  },
	  forEach: function forEach(fn) {
	    var that = this;
	    return new (core.Promise || global.Promise)(function (resolve, reject) {
	      aFunction(fn);
	      var subscription = that.subscribe({
	        next: function (value) {
	          try {
	            return fn(value);
	          } catch (e) {
	            reject(e);
	            subscription.unsubscribe();
	          }
	        },
	        error: reject,
	        complete: resolve
	      });
	    });
	  }
	});
	
	redefineAll($Observable, {
	  from: function from(x) {
	    var C = typeof this === 'function' ? this : $Observable;
	    var method = getMethod(anObject(x)[OBSERVABLE]);
	    if (method) {
	      var observable = anObject(method.call(x));
	      return observable.constructor === C ? observable : new C(function (observer) {
	        return observable.subscribe(observer);
	      });
	    }
	    return new C(function (observer) {
	      var done = false;
	      microtask(function () {
	        if (!done) {
	          try {
	            if (forOf(x, false, function (it) {
	              observer.next(it);
	              if (done) return RETURN;
	            }) === RETURN) return;
	          } catch (e) {
	            if (done) throw e;
	            observer.error(e);
	            return;
	          } observer.complete();
	        }
	      });
	      return function () { done = true; };
	    });
	  },
	  of: function of() {
	    for (var i = 0, l = arguments.length, items = new Array(l); i < l;) items[i] = arguments[i++];
	    return new (typeof this === 'function' ? this : $Observable)(function (observer) {
	      var done = false;
	      microtask(function () {
	        if (!done) {
	          for (var j = 0; j < items.length; ++j) {
	            observer.next(items[j]);
	            if (done) return;
	          } observer.complete();
	        }
	      });
	      return function () { done = true; };
	    });
	  }
	});
	
	hide($Observable.prototype, OBSERVABLE, function () { return this; });
	
	$export($export.G, { Observable: $Observable });
	
	__webpack_require__(94)('Observable');


/***/ },
/* 796 */
/***/ function(module, exports, __webpack_require__) {

	// https://github.com/tc39/proposal-promise-finally
	'use strict';
	var $export = __webpack_require__(4);
	var core = __webpack_require__(54);
	var global = __webpack_require__(17);
	var speciesConstructor = __webpack_require__(135);
	var promiseResolve = __webpack_require__(378);
	
	$export($export.P + $export.R, 'Promise', { 'finally': function (onFinally) {
	  var C = speciesConstructor(this, core.Promise || global.Promise);
	  var isFunction = typeof onFinally == 'function';
	  return this.then(
	    isFunction ? function (x) {
	      return promiseResolve(C, onFinally()).then(function () { return x; });
	    } : onFinally,
	    isFunction ? function (e) {
	      return promiseResolve(C, onFinally()).then(function () { throw e; });
	    } : onFinally
	  );
	} });


/***/ },
/* 797 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// https://github.com/tc39/proposal-promise-try
	var $export = __webpack_require__(4);
	var newPromiseCapability = __webpack_require__(248);
	var perform = __webpack_require__(377);
	
	$export($export.S, 'Promise', { 'try': function (callbackfn) {
	  var promiseCapability = newPromiseCapability.f(this);
	  var result = perform(callbackfn);
	  (result.e ? promiseCapability.reject : promiseCapability.resolve)(result.v);
	  return promiseCapability.promise;
	} });


/***/ },
/* 798 */
/***/ function(module, exports, __webpack_require__) {

	var metadata = __webpack_require__(71);
	var anObject = __webpack_require__(15);
	var toMetaKey = metadata.key;
	var ordinaryDefineOwnMetadata = metadata.set;
	
	metadata.exp({ defineMetadata: function defineMetadata(metadataKey, metadataValue, target, targetKey) {
	  ordinaryDefineOwnMetadata(metadataKey, metadataValue, anObject(target), toMetaKey(targetKey));
	} });


/***/ },
/* 799 */
/***/ function(module, exports, __webpack_require__) {

	var metadata = __webpack_require__(71);
	var anObject = __webpack_require__(15);
	var toMetaKey = metadata.key;
	var getOrCreateMetadataMap = metadata.map;
	var store = metadata.store;
	
	metadata.exp({ deleteMetadata: function deleteMetadata(metadataKey, target /* , targetKey */) {
	  var targetKey = arguments.length < 3 ? undefined : toMetaKey(arguments[2]);
	  var metadataMap = getOrCreateMetadataMap(anObject(target), targetKey, false);
	  if (metadataMap === undefined || !metadataMap['delete'](metadataKey)) return false;
	  if (metadataMap.size) return true;
	  var targetMetadata = store.get(target);
	  targetMetadata['delete'](targetKey);
	  return !!targetMetadata.size || store['delete'](target);
	} });


/***/ },
/* 800 */
/***/ function(module, exports, __webpack_require__) {

	var Set = __webpack_require__(386);
	var from = __webpack_require__(354);
	var metadata = __webpack_require__(71);
	var anObject = __webpack_require__(15);
	var getPrototypeOf = __webpack_require__(48);
	var ordinaryOwnMetadataKeys = metadata.keys;
	var toMetaKey = metadata.key;
	
	var ordinaryMetadataKeys = function (O, P) {
	  var oKeys = ordinaryOwnMetadataKeys(O, P);
	  var parent = getPrototypeOf(O);
	  if (parent === null) return oKeys;
	  var pKeys = ordinaryMetadataKeys(parent, P);
	  return pKeys.length ? oKeys.length ? from(new Set(oKeys.concat(pKeys))) : pKeys : oKeys;
	};
	
	metadata.exp({ getMetadataKeys: function getMetadataKeys(target /* , targetKey */) {
	  return ordinaryMetadataKeys(anObject(target), arguments.length < 2 ? undefined : toMetaKey(arguments[1]));
	} });


/***/ },
/* 801 */
/***/ function(module, exports, __webpack_require__) {

	var metadata = __webpack_require__(71);
	var anObject = __webpack_require__(15);
	var getPrototypeOf = __webpack_require__(48);
	var ordinaryHasOwnMetadata = metadata.has;
	var ordinaryGetOwnMetadata = metadata.get;
	var toMetaKey = metadata.key;
	
	var ordinaryGetMetadata = function (MetadataKey, O, P) {
	  var hasOwn = ordinaryHasOwnMetadata(MetadataKey, O, P);
	  if (hasOwn) return ordinaryGetOwnMetadata(MetadataKey, O, P);
	  var parent = getPrototypeOf(O);
	  return parent !== null ? ordinaryGetMetadata(MetadataKey, parent, P) : undefined;
	};
	
	metadata.exp({ getMetadata: function getMetadata(metadataKey, target /* , targetKey */) {
	  return ordinaryGetMetadata(metadataKey, anObject(target), arguments.length < 3 ? undefined : toMetaKey(arguments[2]));
	} });


/***/ },
/* 802 */
/***/ function(module, exports, __webpack_require__) {

	var metadata = __webpack_require__(71);
	var anObject = __webpack_require__(15);
	var ordinaryOwnMetadataKeys = metadata.keys;
	var toMetaKey = metadata.key;
	
	metadata.exp({ getOwnMetadataKeys: function getOwnMetadataKeys(target /* , targetKey */) {
	  return ordinaryOwnMetadataKeys(anObject(target), arguments.length < 2 ? undefined : toMetaKey(arguments[1]));
	} });


/***/ },
/* 803 */
/***/ function(module, exports, __webpack_require__) {

	var metadata = __webpack_require__(71);
	var anObject = __webpack_require__(15);
	var ordinaryGetOwnMetadata = metadata.get;
	var toMetaKey = metadata.key;
	
	metadata.exp({ getOwnMetadata: function getOwnMetadata(metadataKey, target /* , targetKey */) {
	  return ordinaryGetOwnMetadata(metadataKey, anObject(target)
	    , arguments.length < 3 ? undefined : toMetaKey(arguments[2]));
	} });


/***/ },
/* 804 */
/***/ function(module, exports, __webpack_require__) {

	var metadata = __webpack_require__(71);
	var anObject = __webpack_require__(15);
	var getPrototypeOf = __webpack_require__(48);
	var ordinaryHasOwnMetadata = metadata.has;
	var toMetaKey = metadata.key;
	
	var ordinaryHasMetadata = function (MetadataKey, O, P) {
	  var hasOwn = ordinaryHasOwnMetadata(MetadataKey, O, P);
	  if (hasOwn) return true;
	  var parent = getPrototypeOf(O);
	  return parent !== null ? ordinaryHasMetadata(MetadataKey, parent, P) : false;
	};
	
	metadata.exp({ hasMetadata: function hasMetadata(metadataKey, target /* , targetKey */) {
	  return ordinaryHasMetadata(metadataKey, anObject(target), arguments.length < 3 ? undefined : toMetaKey(arguments[2]));
	} });


/***/ },
/* 805 */
/***/ function(module, exports, __webpack_require__) {

	var metadata = __webpack_require__(71);
	var anObject = __webpack_require__(15);
	var ordinaryHasOwnMetadata = metadata.has;
	var toMetaKey = metadata.key;
	
	metadata.exp({ hasOwnMetadata: function hasOwnMetadata(metadataKey, target /* , targetKey */) {
	  return ordinaryHasOwnMetadata(metadataKey, anObject(target)
	    , arguments.length < 3 ? undefined : toMetaKey(arguments[2]));
	} });


/***/ },
/* 806 */
/***/ function(module, exports, __webpack_require__) {

	var $metadata = __webpack_require__(71);
	var anObject = __webpack_require__(15);
	var aFunction = __webpack_require__(39);
	var toMetaKey = $metadata.key;
	var ordinaryDefineOwnMetadata = $metadata.set;
	
	$metadata.exp({ metadata: function metadata(metadataKey, metadataValue) {
	  return function decorator(target, targetKey) {
	    ordinaryDefineOwnMetadata(
	      metadataKey, metadataValue,
	      (targetKey !== undefined ? anObject : aFunction)(target),
	      toMetaKey(targetKey)
	    );
	  };
	} });


/***/ },
/* 807 */
/***/ function(module, exports, __webpack_require__) {

	// https://tc39.github.io/proposal-setmap-offrom/#sec-set.from
	__webpack_require__(174)('Set');


/***/ },
/* 808 */
/***/ function(module, exports, __webpack_require__) {

	// https://tc39.github.io/proposal-setmap-offrom/#sec-set.of
	__webpack_require__(175)('Set');


/***/ },
/* 809 */
/***/ function(module, exports, __webpack_require__) {

	// https://github.com/DavidBruant/Map-Set.prototype.toJSON
	var $export = __webpack_require__(4);
	
	$export($export.P + $export.R, 'Set', { toJSON: __webpack_require__(358)('Set') });


/***/ },
/* 810 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// https://github.com/mathiasbynens/String.prototype.at
	var $export = __webpack_require__(4);
	var $at = __webpack_require__(176)(true);
	
	$export($export.P, 'String', {
	  at: function at(pos) {
	    return $at(this, pos);
	  }
	});


/***/ },
/* 811 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// https://tc39.github.io/String.prototype.matchAll/
	var $export = __webpack_require__(4);
	var defined = __webpack_require__(62);
	var toLength = __webpack_require__(27);
	var isRegExp = __webpack_require__(169);
	var getFlags = __webpack_require__(131);
	var RegExpProto = RegExp.prototype;
	
	var $RegExpStringIterator = function (regexp, string) {
	  this._r = regexp;
	  this._s = string;
	};
	
	__webpack_require__(243)($RegExpStringIterator, 'RegExp String', function next() {
	  var match = this._r.exec(this._s);
	  return { value: match, done: match === null };
	});
	
	$export($export.P, 'String', {
	  matchAll: function matchAll(regexp) {
	    defined(this);
	    if (!isRegExp(regexp)) throw TypeError(regexp + ' is not a regexp!');
	    var S = String(this);
	    var flags = 'flags' in RegExpProto ? String(regexp.flags) : getFlags.call(regexp);
	    var rx = new RegExp(regexp.source, ~flags.indexOf('g') ? flags : 'g' + flags);
	    rx.lastIndex = toLength(regexp.lastIndex);
	    return new $RegExpStringIterator(rx, S);
	  }
	});


/***/ },
/* 812 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// https://github.com/tc39/proposal-string-pad-start-end
	var $export = __webpack_require__(4);
	var $pad = __webpack_require__(380);
	var userAgent = __webpack_require__(178);
	
	// https://github.com/zloirock/core-js/issues/280
	var WEBKIT_BUG = /Version\/10\.\d+(\.\d+)?( Mobile\/\w+)? Safari\//.test(userAgent);
	
	$export($export.P + $export.F * WEBKIT_BUG, 'String', {
	  padEnd: function padEnd(maxLength /* , fillString = ' ' */) {
	    return $pad(this, maxLength, arguments.length > 1 ? arguments[1] : undefined, false);
	  }
	});


/***/ },
/* 813 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// https://github.com/tc39/proposal-string-pad-start-end
	var $export = __webpack_require__(4);
	var $pad = __webpack_require__(380);
	var userAgent = __webpack_require__(178);
	
	// https://github.com/zloirock/core-js/issues/280
	var WEBKIT_BUG = /Version\/10\.\d+(\.\d+)?( Mobile\/\w+)? Safari\//.test(userAgent);
	
	$export($export.P + $export.F * WEBKIT_BUG, 'String', {
	  padStart: function padStart(maxLength /* , fillString = ' ' */) {
	    return $pad(this, maxLength, arguments.length > 1 ? arguments[1] : undefined, true);
	  }
	});


/***/ },
/* 814 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// https://github.com/sebmarkbage/ecmascript-string-left-right-trim
	__webpack_require__(110)('trimLeft', function ($trim) {
	  return function trimLeft() {
	    return $trim(this, 1);
	  };
	}, 'trimStart');


/***/ },
/* 815 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// https://github.com/sebmarkbage/ecmascript-string-left-right-trim
	__webpack_require__(110)('trimRight', function ($trim) {
	  return function trimRight() {
	    return $trim(this, 2);
	  };
	}, 'trimEnd');


/***/ },
/* 816 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(257)('asyncIterator');


/***/ },
/* 817 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(257)('observable');


/***/ },
/* 818 */
/***/ function(module, exports, __webpack_require__) {

	// https://github.com/tc39/proposal-global
	var $export = __webpack_require__(4);
	
	$export($export.S, 'System', { global: __webpack_require__(17) });


/***/ },
/* 819 */
/***/ function(module, exports, __webpack_require__) {

	// https://tc39.github.io/proposal-setmap-offrom/#sec-weakmap.from
	__webpack_require__(174)('WeakMap');


/***/ },
/* 820 */
/***/ function(module, exports, __webpack_require__) {

	// https://tc39.github.io/proposal-setmap-offrom/#sec-weakmap.of
	__webpack_require__(175)('WeakMap');


/***/ },
/* 821 */
/***/ function(module, exports, __webpack_require__) {

	// https://tc39.github.io/proposal-setmap-offrom/#sec-weakset.from
	__webpack_require__(174)('WeakSet');


/***/ },
/* 822 */
/***/ function(module, exports, __webpack_require__) {

	// https://tc39.github.io/proposal-setmap-offrom/#sec-weakset.of
	__webpack_require__(175)('WeakSet');


/***/ },
/* 823 */
/***/ function(module, exports, __webpack_require__) {

	var $iterators = __webpack_require__(259);
	var getKeys = __webpack_require__(91);
	var redefine = __webpack_require__(41);
	var global = __webpack_require__(17);
	var hide = __webpack_require__(40);
	var Iterators = __webpack_require__(108);
	var wks = __webpack_require__(26);
	var ITERATOR = wks('iterator');
	var TO_STRING_TAG = wks('toStringTag');
	var ArrayValues = Iterators.Array;
	
	var DOMIterables = {
	  CSSRuleList: true, // TODO: Not spec compliant, should be false.
	  CSSStyleDeclaration: false,
	  CSSValueList: false,
	  ClientRectList: false,
	  DOMRectList: false,
	  DOMStringList: false,
	  DOMTokenList: true,
	  DataTransferItemList: false,
	  FileList: false,
	  HTMLAllCollection: false,
	  HTMLCollection: false,
	  HTMLFormElement: false,
	  HTMLSelectElement: false,
	  MediaList: true, // TODO: Not spec compliant, should be false.
	  MimeTypeArray: false,
	  NamedNodeMap: false,
	  NodeList: true,
	  PaintRequestList: false,
	  Plugin: false,
	  PluginArray: false,
	  SVGLengthList: false,
	  SVGNumberList: false,
	  SVGPathSegList: false,
	  SVGPointList: false,
	  SVGStringList: false,
	  SVGTransformList: false,
	  SourceBufferList: false,
	  StyleSheetList: true, // TODO: Not spec compliant, should be false.
	  TextTrackCueList: false,
	  TextTrackList: false,
	  TouchList: false
	};
	
	for (var collections = getKeys(DOMIterables), i = 0; i < collections.length; i++) {
	  var NAME = collections[i];
	  var explicit = DOMIterables[NAME];
	  var Collection = global[NAME];
	  var proto = Collection && Collection.prototype;
	  var key;
	  if (proto) {
	    if (!proto[ITERATOR]) hide(proto, ITERATOR, ArrayValues);
	    if (!proto[TO_STRING_TAG]) hide(proto, TO_STRING_TAG, NAME);
	    Iterators[NAME] = ArrayValues;
	    if (explicit) for (key in $iterators) if (!proto[key]) redefine(proto, key, $iterators[key], true);
	  }
	}


/***/ },
/* 824 */
/***/ function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(4);
	var $task = __webpack_require__(255);
	$export($export.G + $export.B, {
	  setImmediate: $task.set,
	  clearImmediate: $task.clear
	});


/***/ },
/* 825 */
/***/ function(module, exports, __webpack_require__) {

	// ie9- setTimeout & setInterval additional parameters fix
	var global = __webpack_require__(17);
	var $export = __webpack_require__(4);
	var userAgent = __webpack_require__(178);
	var slice = [].slice;
	var MSIE = /MSIE .\./.test(userAgent); // <- dirty ie9- check
	var wrap = function (set) {
	  return function (fn, time /* , ...args */) {
	    var boundArgs = arguments.length > 2;
	    var args = boundArgs ? slice.call(arguments, 2) : false;
	    return set(boundArgs ? function () {
	      // eslint-disable-next-line no-new-func
	      (typeof fn == 'function' ? fn : Function(fn)).apply(this, args);
	    } : fn, time);
	  };
	};
	$export($export.G + $export.B + $export.F * MSIE, {
	  setTimeout: wrap(global.setTimeout),
	  setInterval: wrap(global.setInterval)
	});


/***/ },
/* 826 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(754);
	__webpack_require__(693);
	__webpack_require__(695);
	__webpack_require__(694);
	__webpack_require__(697);
	__webpack_require__(699);
	__webpack_require__(704);
	__webpack_require__(698);
	__webpack_require__(696);
	__webpack_require__(706);
	__webpack_require__(705);
	__webpack_require__(701);
	__webpack_require__(702);
	__webpack_require__(700);
	__webpack_require__(692);
	__webpack_require__(703);
	__webpack_require__(707);
	__webpack_require__(708);
	__webpack_require__(660);
	__webpack_require__(662);
	__webpack_require__(661);
	__webpack_require__(710);
	__webpack_require__(709);
	__webpack_require__(680);
	__webpack_require__(690);
	__webpack_require__(691);
	__webpack_require__(681);
	__webpack_require__(682);
	__webpack_require__(683);
	__webpack_require__(684);
	__webpack_require__(685);
	__webpack_require__(686);
	__webpack_require__(687);
	__webpack_require__(688);
	__webpack_require__(689);
	__webpack_require__(663);
	__webpack_require__(664);
	__webpack_require__(665);
	__webpack_require__(666);
	__webpack_require__(667);
	__webpack_require__(668);
	__webpack_require__(669);
	__webpack_require__(670);
	__webpack_require__(671);
	__webpack_require__(672);
	__webpack_require__(673);
	__webpack_require__(674);
	__webpack_require__(675);
	__webpack_require__(676);
	__webpack_require__(677);
	__webpack_require__(678);
	__webpack_require__(679);
	__webpack_require__(741);
	__webpack_require__(746);
	__webpack_require__(753);
	__webpack_require__(744);
	__webpack_require__(736);
	__webpack_require__(737);
	__webpack_require__(742);
	__webpack_require__(747);
	__webpack_require__(749);
	__webpack_require__(732);
	__webpack_require__(733);
	__webpack_require__(734);
	__webpack_require__(735);
	__webpack_require__(738);
	__webpack_require__(739);
	__webpack_require__(740);
	__webpack_require__(743);
	__webpack_require__(745);
	__webpack_require__(748);
	__webpack_require__(750);
	__webpack_require__(751);
	__webpack_require__(752);
	__webpack_require__(655);
	__webpack_require__(657);
	__webpack_require__(656);
	__webpack_require__(659);
	__webpack_require__(658);
	__webpack_require__(644);
	__webpack_require__(642);
	__webpack_require__(648);
	__webpack_require__(645);
	__webpack_require__(651);
	__webpack_require__(653);
	__webpack_require__(641);
	__webpack_require__(647);
	__webpack_require__(638);
	__webpack_require__(652);
	__webpack_require__(636);
	__webpack_require__(650);
	__webpack_require__(649);
	__webpack_require__(643);
	__webpack_require__(646);
	__webpack_require__(635);
	__webpack_require__(637);
	__webpack_require__(640);
	__webpack_require__(639);
	__webpack_require__(654);
	__webpack_require__(259);
	__webpack_require__(726);
	__webpack_require__(384);
	__webpack_require__(731);
	__webpack_require__(385);
	__webpack_require__(727);
	__webpack_require__(728);
	__webpack_require__(729);
	__webpack_require__(730);
	__webpack_require__(711);
	__webpack_require__(383);
	__webpack_require__(386);
	__webpack_require__(387);
	__webpack_require__(766);
	__webpack_require__(755);
	__webpack_require__(756);
	__webpack_require__(761);
	__webpack_require__(764);
	__webpack_require__(765);
	__webpack_require__(759);
	__webpack_require__(762);
	__webpack_require__(760);
	__webpack_require__(763);
	__webpack_require__(757);
	__webpack_require__(758);
	__webpack_require__(712);
	__webpack_require__(713);
	__webpack_require__(714);
	__webpack_require__(715);
	__webpack_require__(716);
	__webpack_require__(719);
	__webpack_require__(717);
	__webpack_require__(718);
	__webpack_require__(720);
	__webpack_require__(721);
	__webpack_require__(722);
	__webpack_require__(723);
	__webpack_require__(725);
	__webpack_require__(724);
	__webpack_require__(769);
	__webpack_require__(767);
	__webpack_require__(768);
	__webpack_require__(810);
	__webpack_require__(813);
	__webpack_require__(812);
	__webpack_require__(814);
	__webpack_require__(815);
	__webpack_require__(811);
	__webpack_require__(816);
	__webpack_require__(817);
	__webpack_require__(791);
	__webpack_require__(794);
	__webpack_require__(790);
	__webpack_require__(788);
	__webpack_require__(789);
	__webpack_require__(792);
	__webpack_require__(793);
	__webpack_require__(775);
	__webpack_require__(809);
	__webpack_require__(774);
	__webpack_require__(808);
	__webpack_require__(820);
	__webpack_require__(822);
	__webpack_require__(773);
	__webpack_require__(807);
	__webpack_require__(819);
	__webpack_require__(821);
	__webpack_require__(772);
	__webpack_require__(818);
	__webpack_require__(771);
	__webpack_require__(776);
	__webpack_require__(777);
	__webpack_require__(778);
	__webpack_require__(779);
	__webpack_require__(780);
	__webpack_require__(782);
	__webpack_require__(781);
	__webpack_require__(783);
	__webpack_require__(784);
	__webpack_require__(785);
	__webpack_require__(787);
	__webpack_require__(786);
	__webpack_require__(796);
	__webpack_require__(797);
	__webpack_require__(798);
	__webpack_require__(799);
	__webpack_require__(801);
	__webpack_require__(800);
	__webpack_require__(803);
	__webpack_require__(802);
	__webpack_require__(804);
	__webpack_require__(805);
	__webpack_require__(806);
	__webpack_require__(770);
	__webpack_require__(795);
	__webpack_require__(825);
	__webpack_require__(824);
	__webpack_require__(823);
	module.exports = __webpack_require__(54);


/***/ },
/* 827 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(20);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _gud = __webpack_require__(1039);
	
	var _gud2 = _interopRequireDefault(_gud);
	
	var _warning = __webpack_require__(543);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var MAX_SIGNED_31_BIT_INT = 1073741823;
	
	// Inlined Object.is polyfill.
	// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
	function objectIs(x, y) {
	  if (x === y) {
	    return x !== 0 || 1 / x === 1 / y;
	  } else {
	    return x !== x && y !== y;
	  }
	}
	
	function createEventEmitter(value) {
	  var handlers = [];
	  return {
	    on: function on(handler) {
	      handlers.push(handler);
	    },
	    off: function off(handler) {
	      handlers = handlers.filter(function (h) {
	        return h !== handler;
	      });
	    },
	    get: function get() {
	      return value;
	    },
	    set: function set(newValue, changedBits) {
	      value = newValue;
	      handlers.forEach(function (handler) {
	        return handler(value, changedBits);
	      });
	    }
	  };
	}
	
	function onlyChild(children) {
	  return Array.isArray(children) ? children[0] : children;
	}
	
	function createReactContext(defaultValue, calculateChangedBits) {
	  var _Provider$childContex, _Consumer$contextType;
	
	  var contextProp = '__create-react-context-' + (0, _gud2.default)() + '__';
	
	  var Provider = function (_Component) {
	    _inherits(Provider, _Component);
	
	    function Provider() {
	      var _temp, _this, _ret;
	
	      _classCallCheck(this, Provider);
	
	      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	        args[_key] = arguments[_key];
	      }
	
	      return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.emitter = createEventEmitter(_this.props.value), _temp), _possibleConstructorReturn(_this, _ret);
	    }
	
	    Provider.prototype.getChildContext = function getChildContext() {
	      var _ref;
	
	      return _ref = {}, _ref[contextProp] = this.emitter, _ref;
	    };
	
	    Provider.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	      if (this.props.value !== nextProps.value) {
	        var oldValue = this.props.value;
	        var newValue = nextProps.value;
	        var changedBits = void 0;
	
	        if (objectIs(oldValue, newValue)) {
	          changedBits = 0; // No change
	        } else {
	          changedBits = typeof calculateChangedBits === 'function' ? calculateChangedBits(oldValue, newValue) : MAX_SIGNED_31_BIT_INT;
	          if (false) {
	            (0, _warning2.default)((changedBits & MAX_SIGNED_31_BIT_INT) === changedBits, 'calculateChangedBits: Expected the return value to be a ' + '31-bit integer. Instead received: %s', changedBits);
	          }
	
	          changedBits |= 0;
	
	          if (changedBits !== 0) {
	            this.emitter.set(nextProps.value, changedBits);
	          }
	        }
	      }
	    };
	
	    Provider.prototype.render = function render() {
	      return this.props.children;
	    };
	
	    return Provider;
	  }(_react.Component);
	
	  Provider.childContextTypes = (_Provider$childContex = {}, _Provider$childContex[contextProp] = _propTypes2.default.object.isRequired, _Provider$childContex);
	
	  var Consumer = function (_Component2) {
	    _inherits(Consumer, _Component2);
	
	    function Consumer() {
	      var _temp2, _this2, _ret2;
	
	      _classCallCheck(this, Consumer);
	
	      for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
	        args[_key2] = arguments[_key2];
	      }
	
	      return _ret2 = (_temp2 = (_this2 = _possibleConstructorReturn(this, _Component2.call.apply(_Component2, [this].concat(args))), _this2), _this2.state = {
	        value: _this2.getValue()
	      }, _this2.onUpdate = function (newValue, changedBits) {
	        var observedBits = _this2.observedBits | 0;
	        if ((observedBits & changedBits) !== 0) {
	          _this2.setState({ value: _this2.getValue() });
	        }
	      }, _temp2), _possibleConstructorReturn(_this2, _ret2);
	    }
	
	    Consumer.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	      var observedBits = nextProps.observedBits;
	
	      this.observedBits = observedBits === undefined || observedBits === null ? MAX_SIGNED_31_BIT_INT // Subscribe to all changes by default
	      : observedBits;
	    };
	
	    Consumer.prototype.componentDidMount = function componentDidMount() {
	      if (this.context[contextProp]) {
	        this.context[contextProp].on(this.onUpdate);
	      }
	      var observedBits = this.props.observedBits;
	
	      this.observedBits = observedBits === undefined || observedBits === null ? MAX_SIGNED_31_BIT_INT // Subscribe to all changes by default
	      : observedBits;
	    };
	
	    Consumer.prototype.componentWillUnmount = function componentWillUnmount() {
	      if (this.context[contextProp]) {
	        this.context[contextProp].off(this.onUpdate);
	      }
	    };
	
	    Consumer.prototype.getValue = function getValue() {
	      if (this.context[contextProp]) {
	        return this.context[contextProp].get();
	      } else {
	        return defaultValue;
	      }
	    };
	
	    Consumer.prototype.render = function render() {
	      return onlyChild(this.props.children)(this.state.value);
	    };
	
	    return Consumer;
	  }(_react.Component);
	
	  Consumer.contextTypes = (_Consumer$contextType = {}, _Consumer$contextType[contextProp] = _propTypes2.default.object, _Consumer$contextType);
	
	
	  return {
	    Provider: Provider,
	    Consumer: Consumer
	  };
	}
	
	exports.default = createReactContext;
	module.exports = exports['default'];

/***/ },
/* 828 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _implementation = __webpack_require__(827);
	
	var _implementation2 = _interopRequireDefault(_implementation);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _react2.default.createContext || _implementation2.default;
	module.exports = exports['default'];

/***/ },
/* 829 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Buffer) {var createHash = __webpack_require__(388)
	
	var zeroBuffer = new Buffer(128)
	zeroBuffer.fill(0)
	
	module.exports = Hmac
	
	function Hmac (alg, key) {
	  if(!(this instanceof Hmac)) return new Hmac(alg, key)
	  this._opad = opad
	  this._alg = alg
	
	  var blocksize = (alg === 'sha512') ? 128 : 64
	
	  key = this._key = !Buffer.isBuffer(key) ? new Buffer(key) : key
	
	  if(key.length > blocksize) {
	    key = createHash(alg).update(key).digest()
	  } else if(key.length < blocksize) {
	    key = Buffer.concat([key, zeroBuffer], blocksize)
	  }
	
	  var ipad = this._ipad = new Buffer(blocksize)
	  var opad = this._opad = new Buffer(blocksize)
	
	  for(var i = 0; i < blocksize; i++) {
	    ipad[i] = key[i] ^ 0x36
	    opad[i] = key[i] ^ 0x5C
	  }
	
	  this._hash = createHash(alg).update(ipad)
	}
	
	Hmac.prototype.update = function (data, enc) {
	  this._hash.update(data, enc)
	  return this
	}
	
	Hmac.prototype.digest = function (enc) {
	  var h = this._hash.digest()
	  return createHash(this._alg).update(this._opad).update(h).digest(enc)
	}
	
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(31).Buffer))

/***/ },
/* 830 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Buffer) {var intSize = 4;
	var zeroBuffer = new Buffer(intSize); zeroBuffer.fill(0);
	var chrsz = 8;
	
	function toArray(buf, bigEndian) {
	  if ((buf.length % intSize) !== 0) {
	    var len = buf.length + (intSize - (buf.length % intSize));
	    buf = Buffer.concat([buf, zeroBuffer], len);
	  }
	
	  var arr = [];
	  var fn = bigEndian ? buf.readInt32BE : buf.readInt32LE;
	  for (var i = 0; i < buf.length; i += intSize) {
	    arr.push(fn.call(buf, i));
	  }
	  return arr;
	}
	
	function toBuffer(arr, size, bigEndian) {
	  var buf = new Buffer(size);
	  var fn = bigEndian ? buf.writeInt32BE : buf.writeInt32LE;
	  for (var i = 0; i < arr.length; i++) {
	    fn.call(buf, arr[i], i * 4, true);
	  }
	  return buf;
	}
	
	function hash(buf, fn, hashSize, bigEndian) {
	  if (!Buffer.isBuffer(buf)) buf = new Buffer(buf);
	  var arr = fn(toArray(buf, bigEndian), buf.length * chrsz);
	  return toBuffer(arr, hashSize, bigEndian);
	}
	
	module.exports = { hash: hash };
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(31).Buffer))

/***/ },
/* 831 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Buffer) {var rng = __webpack_require__(834)
	
	function error () {
	  var m = [].slice.call(arguments).join(' ')
	  throw new Error([
	    m,
	    'we accept pull requests',
	    'http://github.com/dominictarr/crypto-browserify'
	    ].join('\n'))
	}
	
	exports.createHash = __webpack_require__(388)
	
	exports.createHmac = __webpack_require__(829)
	
	exports.randomBytes = function(size, callback) {
	  if (callback && callback.call) {
	    try {
	      callback.call(this, undefined, new Buffer(rng(size)))
	    } catch (err) { callback(err) }
	  } else {
	    return new Buffer(rng(size))
	  }
	}
	
	function each(a, f) {
	  for(var i in a)
	    f(a[i], i)
	}
	
	exports.getHashes = function () {
	  return ['sha1', 'sha256', 'sha512', 'md5', 'rmd160']
	}
	
	var p = __webpack_require__(833)(exports)
	exports.pbkdf2 = p.pbkdf2
	exports.pbkdf2Sync = p.pbkdf2Sync
	__webpack_require__(619)(exports, module.exports);
	
	// the least I can do is make error messages for the rest of the node.js/crypto api.
	each(['createCredentials'
	, 'createSign'
	, 'createVerify'
	, 'createDiffieHellman'
	], function (name) {
	  exports[name] = function () {
	    error('sorry,', name, 'is not implemented yet')
	  }
	})
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(31).Buffer))

/***/ },
/* 832 */
/***/ function(module, exports, __webpack_require__) {

	/*
	 * A JavaScript implementation of the RSA Data Security, Inc. MD5 Message
	 * Digest Algorithm, as defined in RFC 1321.
	 * Version 2.1 Copyright (C) Paul Johnston 1999 - 2002.
	 * Other contributors: Greg Holt, Andrew Kepert, Ydnar, Lostinet
	 * Distributed under the BSD License
	 * See http://pajhome.org.uk/crypt/md5 for more info.
	 */
	
	var helpers = __webpack_require__(830);
	
	/*
	 * Calculate the MD5 of an array of little-endian words, and a bit length
	 */
	function core_md5(x, len)
	{
	  /* append padding */
	  x[len >> 5] |= 0x80 << ((len) % 32);
	  x[(((len + 64) >>> 9) << 4) + 14] = len;
	
	  var a =  1732584193;
	  var b = -271733879;
	  var c = -1732584194;
	  var d =  271733878;
	
	  for(var i = 0; i < x.length; i += 16)
	  {
	    var olda = a;
	    var oldb = b;
	    var oldc = c;
	    var oldd = d;
	
	    a = md5_ff(a, b, c, d, x[i+ 0], 7 , -680876936);
	    d = md5_ff(d, a, b, c, x[i+ 1], 12, -389564586);
	    c = md5_ff(c, d, a, b, x[i+ 2], 17,  606105819);
	    b = md5_ff(b, c, d, a, x[i+ 3], 22, -1044525330);
	    a = md5_ff(a, b, c, d, x[i+ 4], 7 , -176418897);
	    d = md5_ff(d, a, b, c, x[i+ 5], 12,  1200080426);
	    c = md5_ff(c, d, a, b, x[i+ 6], 17, -1473231341);
	    b = md5_ff(b, c, d, a, x[i+ 7], 22, -45705983);
	    a = md5_ff(a, b, c, d, x[i+ 8], 7 ,  1770035416);
	    d = md5_ff(d, a, b, c, x[i+ 9], 12, -1958414417);
	    c = md5_ff(c, d, a, b, x[i+10], 17, -42063);
	    b = md5_ff(b, c, d, a, x[i+11], 22, -1990404162);
	    a = md5_ff(a, b, c, d, x[i+12], 7 ,  1804603682);
	    d = md5_ff(d, a, b, c, x[i+13], 12, -40341101);
	    c = md5_ff(c, d, a, b, x[i+14], 17, -1502002290);
	    b = md5_ff(b, c, d, a, x[i+15], 22,  1236535329);
	
	    a = md5_gg(a, b, c, d, x[i+ 1], 5 , -165796510);
	    d = md5_gg(d, a, b, c, x[i+ 6], 9 , -1069501632);
	    c = md5_gg(c, d, a, b, x[i+11], 14,  643717713);
	    b = md5_gg(b, c, d, a, x[i+ 0], 20, -373897302);
	    a = md5_gg(a, b, c, d, x[i+ 5], 5 , -701558691);
	    d = md5_gg(d, a, b, c, x[i+10], 9 ,  38016083);
	    c = md5_gg(c, d, a, b, x[i+15], 14, -660478335);
	    b = md5_gg(b, c, d, a, x[i+ 4], 20, -405537848);
	    a = md5_gg(a, b, c, d, x[i+ 9], 5 ,  568446438);
	    d = md5_gg(d, a, b, c, x[i+14], 9 , -1019803690);
	    c = md5_gg(c, d, a, b, x[i+ 3], 14, -187363961);
	    b = md5_gg(b, c, d, a, x[i+ 8], 20,  1163531501);
	    a = md5_gg(a, b, c, d, x[i+13], 5 , -1444681467);
	    d = md5_gg(d, a, b, c, x[i+ 2], 9 , -51403784);
	    c = md5_gg(c, d, a, b, x[i+ 7], 14,  1735328473);
	    b = md5_gg(b, c, d, a, x[i+12], 20, -1926607734);
	
	    a = md5_hh(a, b, c, d, x[i+ 5], 4 , -378558);
	    d = md5_hh(d, a, b, c, x[i+ 8], 11, -2022574463);
	    c = md5_hh(c, d, a, b, x[i+11], 16,  1839030562);
	    b = md5_hh(b, c, d, a, x[i+14], 23, -35309556);
	    a = md5_hh(a, b, c, d, x[i+ 1], 4 , -1530992060);
	    d = md5_hh(d, a, b, c, x[i+ 4], 11,  1272893353);
	    c = md5_hh(c, d, a, b, x[i+ 7], 16, -155497632);
	    b = md5_hh(b, c, d, a, x[i+10], 23, -1094730640);
	    a = md5_hh(a, b, c, d, x[i+13], 4 ,  681279174);
	    d = md5_hh(d, a, b, c, x[i+ 0], 11, -358537222);
	    c = md5_hh(c, d, a, b, x[i+ 3], 16, -722521979);
	    b = md5_hh(b, c, d, a, x[i+ 6], 23,  76029189);
	    a = md5_hh(a, b, c, d, x[i+ 9], 4 , -640364487);
	    d = md5_hh(d, a, b, c, x[i+12], 11, -421815835);
	    c = md5_hh(c, d, a, b, x[i+15], 16,  530742520);
	    b = md5_hh(b, c, d, a, x[i+ 2], 23, -995338651);
	
	    a = md5_ii(a, b, c, d, x[i+ 0], 6 , -198630844);
	    d = md5_ii(d, a, b, c, x[i+ 7], 10,  1126891415);
	    c = md5_ii(c, d, a, b, x[i+14], 15, -1416354905);
	    b = md5_ii(b, c, d, a, x[i+ 5], 21, -57434055);
	    a = md5_ii(a, b, c, d, x[i+12], 6 ,  1700485571);
	    d = md5_ii(d, a, b, c, x[i+ 3], 10, -1894986606);
	    c = md5_ii(c, d, a, b, x[i+10], 15, -1051523);
	    b = md5_ii(b, c, d, a, x[i+ 1], 21, -2054922799);
	    a = md5_ii(a, b, c, d, x[i+ 8], 6 ,  1873313359);
	    d = md5_ii(d, a, b, c, x[i+15], 10, -30611744);
	    c = md5_ii(c, d, a, b, x[i+ 6], 15, -1560198380);
	    b = md5_ii(b, c, d, a, x[i+13], 21,  1309151649);
	    a = md5_ii(a, b, c, d, x[i+ 4], 6 , -145523070);
	    d = md5_ii(d, a, b, c, x[i+11], 10, -1120210379);
	    c = md5_ii(c, d, a, b, x[i+ 2], 15,  718787259);
	    b = md5_ii(b, c, d, a, x[i+ 9], 21, -343485551);
	
	    a = safe_add(a, olda);
	    b = safe_add(b, oldb);
	    c = safe_add(c, oldc);
	    d = safe_add(d, oldd);
	  }
	  return Array(a, b, c, d);
	
	}
	
	/*
	 * These functions implement the four basic operations the algorithm uses.
	 */
	function md5_cmn(q, a, b, x, s, t)
	{
	  return safe_add(bit_rol(safe_add(safe_add(a, q), safe_add(x, t)), s),b);
	}
	function md5_ff(a, b, c, d, x, s, t)
	{
	  return md5_cmn((b & c) | ((~b) & d), a, b, x, s, t);
	}
	function md5_gg(a, b, c, d, x, s, t)
	{
	  return md5_cmn((b & d) | (c & (~d)), a, b, x, s, t);
	}
	function md5_hh(a, b, c, d, x, s, t)
	{
	  return md5_cmn(b ^ c ^ d, a, b, x, s, t);
	}
	function md5_ii(a, b, c, d, x, s, t)
	{
	  return md5_cmn(c ^ (b | (~d)), a, b, x, s, t);
	}
	
	/*
	 * Add integers, wrapping at 2^32. This uses 16-bit operations internally
	 * to work around bugs in some JS interpreters.
	 */
	function safe_add(x, y)
	{
	  var lsw = (x & 0xFFFF) + (y & 0xFFFF);
	  var msw = (x >> 16) + (y >> 16) + (lsw >> 16);
	  return (msw << 16) | (lsw & 0xFFFF);
	}
	
	/*
	 * Bitwise rotate a 32-bit number to the left.
	 */
	function bit_rol(num, cnt)
	{
	  return (num << cnt) | (num >>> (32 - cnt));
	}
	
	module.exports = function md5(buf) {
	  return helpers.hash(buf, core_md5, 16);
	};


/***/ },
/* 833 */
/***/ function(module, exports, __webpack_require__) {

	var pbkdf2Export = __webpack_require__(1282)
	
	module.exports = function (crypto, exports) {
	  exports = exports || {}
	
	  var exported = pbkdf2Export(crypto)
	
	  exports.pbkdf2 = exported.pbkdf2
	  exports.pbkdf2Sync = exported.pbkdf2Sync
	
	  return exports
	}


/***/ },
/* 834 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global, Buffer) {(function() {
	  var g = ('undefined' === typeof window ? global : window) || {}
	  _crypto = (
	    g.crypto || g.msCrypto || __webpack_require__(1523)
	  )
	  module.exports = function(size) {
	    // Modern Browsers
	    if(_crypto.getRandomValues) {
	      var bytes = new Buffer(size); //in browserify, this is an extended Uint8Array
	      /* This will not work in older browsers.
	       * See https://developer.mozilla.org/en-US/docs/Web/API/window.crypto.getRandomValues
	       */
	    
	      _crypto.getRandomValues(bytes);
	      return bytes;
	    }
	    else if (_crypto.randomBytes) {
	      return _crypto.randomBytes(size)
	    }
	    else
	      throw new Error(
	        'secure random number generation not supported by this browser\n'+
	        'use chrome, FireFox or Internet Explorer 11'
	      )
	  }
	}())
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }()), __webpack_require__(31).Buffer))

/***/ },
/* 835 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(10)();
	// imports
	
	
	// module
	exports.push([module.id, "@-ms-viewport{width:device-width}html{box-sizing:border-box;-ms-overflow-style:scrollbar}*,:after,:before{box-sizing:inherit}.container{position:relative;margin-left:auto;margin-right:auto;padding-right:2.5px;padding-left:2.5px}@media (min-width:576px){.container{padding-right:2.5px;padding-left:2.5px}}@media (min-width:768px){.container{padding-right:2.5px;padding-left:2.5px}}@media (min-width:992px){.container{padding-right:2.5px;padding-left:2.5px}}@media (min-width:1200px){.container{padding-right:2.5px;padding-left:2.5px}}@media (min-width:576px){.container{width:540px;max-width:100%}}@media (min-width:768px){.container{width:720px;max-width:100%}}@media (min-width:992px){.container{width:960px;max-width:100%}}@media (min-width:1200px){.container{width:1140px;max-width:100%}}.container-fluid{position:relative;margin-left:auto;margin-right:auto;padding-right:2.5px;padding-left:2.5px}@media (min-width:576px){.container-fluid{padding-right:2.5px;padding-left:2.5px}}@media (min-width:768px){.container-fluid{padding-right:2.5px;padding-left:2.5px}}@media (min-width:992px){.container-fluid{padding-right:2.5px;padding-left:2.5px}}@media (min-width:1200px){.container-fluid{padding-right:2.5px;padding-left:2.5px}}.row{display:flex;flex-wrap:wrap;margin-right:-2.5px;margin-left:-2.5px}@media (min-width:576px){.row{margin-right:-2.5px;margin-left:-2.5px}}@media (min-width:768px){.row{margin-right:-2.5px;margin-left:-2.5px}}@media (min-width:992px){.row{margin-right:-2.5px;margin-left:-2.5px}}@media (min-width:1200px){.row{margin-right:-2.5px;margin-left:-2.5px}}.no-gutters{margin-right:0;margin-left:0}.no-gutters>.col,.no-gutters>[class*=col-]{padding-right:0;padding-left:0}.col,.col-1,.col-2,.col-3,.col-4,.col-5,.col-6,.col-7,.col-8,.col-9,.col-10,.col-11,.col-12,.col-lg,.col-lg-1,.col-lg-2,.col-lg-3,.col-lg-4,.col-lg-5,.col-lg-6,.col-lg-7,.col-lg-8,.col-lg-9,.col-lg-10,.col-lg-11,.col-lg-12,.col-md,.col-md-1,.col-md-2,.col-md-3,.col-md-4,.col-md-5,.col-md-6,.col-md-7,.col-md-8,.col-md-9,.col-md-10,.col-md-11,.col-md-12,.col-sm,.col-sm-1,.col-sm-2,.col-sm-3,.col-sm-4,.col-sm-5,.col-sm-6,.col-sm-7,.col-sm-8,.col-sm-9,.col-sm-10,.col-sm-11,.col-sm-12,.col-xl,.col-xl-1,.col-xl-2,.col-xl-3,.col-xl-4,.col-xl-5,.col-xl-6,.col-xl-7,.col-xl-8,.col-xl-9,.col-xl-10,.col-xl-11,.col-xl-12{position:relative;width:100%;min-height:1px;padding-right:2.5px;padding-left:2.5px}@media (min-width:576px){.col,.col-1,.col-2,.col-3,.col-4,.col-5,.col-6,.col-7,.col-8,.col-9,.col-10,.col-11,.col-12,.col-lg,.col-lg-1,.col-lg-2,.col-lg-3,.col-lg-4,.col-lg-5,.col-lg-6,.col-lg-7,.col-lg-8,.col-lg-9,.col-lg-10,.col-lg-11,.col-lg-12,.col-md,.col-md-1,.col-md-2,.col-md-3,.col-md-4,.col-md-5,.col-md-6,.col-md-7,.col-md-8,.col-md-9,.col-md-10,.col-md-11,.col-md-12,.col-sm,.col-sm-1,.col-sm-2,.col-sm-3,.col-sm-4,.col-sm-5,.col-sm-6,.col-sm-7,.col-sm-8,.col-sm-9,.col-sm-10,.col-sm-11,.col-sm-12,.col-xl,.col-xl-1,.col-xl-2,.col-xl-3,.col-xl-4,.col-xl-5,.col-xl-6,.col-xl-7,.col-xl-8,.col-xl-9,.col-xl-10,.col-xl-11,.col-xl-12{padding-right:2.5px;padding-left:2.5px}}@media (min-width:768px){.col,.col-1,.col-2,.col-3,.col-4,.col-5,.col-6,.col-7,.col-8,.col-9,.col-10,.col-11,.col-12,.col-lg,.col-lg-1,.col-lg-2,.col-lg-3,.col-lg-4,.col-lg-5,.col-lg-6,.col-lg-7,.col-lg-8,.col-lg-9,.col-lg-10,.col-lg-11,.col-lg-12,.col-md,.col-md-1,.col-md-2,.col-md-3,.col-md-4,.col-md-5,.col-md-6,.col-md-7,.col-md-8,.col-md-9,.col-md-10,.col-md-11,.col-md-12,.col-sm,.col-sm-1,.col-sm-2,.col-sm-3,.col-sm-4,.col-sm-5,.col-sm-6,.col-sm-7,.col-sm-8,.col-sm-9,.col-sm-10,.col-sm-11,.col-sm-12,.col-xl,.col-xl-1,.col-xl-2,.col-xl-3,.col-xl-4,.col-xl-5,.col-xl-6,.col-xl-7,.col-xl-8,.col-xl-9,.col-xl-10,.col-xl-11,.col-xl-12{padding-right:2.5px;padding-left:2.5px}}@media (min-width:992px){.col,.col-1,.col-2,.col-3,.col-4,.col-5,.col-6,.col-7,.col-8,.col-9,.col-10,.col-11,.col-12,.col-lg,.col-lg-1,.col-lg-2,.col-lg-3,.col-lg-4,.col-lg-5,.col-lg-6,.col-lg-7,.col-lg-8,.col-lg-9,.col-lg-10,.col-lg-11,.col-lg-12,.col-md,.col-md-1,.col-md-2,.col-md-3,.col-md-4,.col-md-5,.col-md-6,.col-md-7,.col-md-8,.col-md-9,.col-md-10,.col-md-11,.col-md-12,.col-sm,.col-sm-1,.col-sm-2,.col-sm-3,.col-sm-4,.col-sm-5,.col-sm-6,.col-sm-7,.col-sm-8,.col-sm-9,.col-sm-10,.col-sm-11,.col-sm-12,.col-xl,.col-xl-1,.col-xl-2,.col-xl-3,.col-xl-4,.col-xl-5,.col-xl-6,.col-xl-7,.col-xl-8,.col-xl-9,.col-xl-10,.col-xl-11,.col-xl-12{padding-right:2.5px;padding-left:2.5px}}@media (min-width:1200px){.col,.col-1,.col-2,.col-3,.col-4,.col-5,.col-6,.col-7,.col-8,.col-9,.col-10,.col-11,.col-12,.col-lg,.col-lg-1,.col-lg-2,.col-lg-3,.col-lg-4,.col-lg-5,.col-lg-6,.col-lg-7,.col-lg-8,.col-lg-9,.col-lg-10,.col-lg-11,.col-lg-12,.col-md,.col-md-1,.col-md-2,.col-md-3,.col-md-4,.col-md-5,.col-md-6,.col-md-7,.col-md-8,.col-md-9,.col-md-10,.col-md-11,.col-md-12,.col-sm,.col-sm-1,.col-sm-2,.col-sm-3,.col-sm-4,.col-sm-5,.col-sm-6,.col-sm-7,.col-sm-8,.col-sm-9,.col-sm-10,.col-sm-11,.col-sm-12,.col-xl,.col-xl-1,.col-xl-2,.col-xl-3,.col-xl-4,.col-xl-5,.col-xl-6,.col-xl-7,.col-xl-8,.col-xl-9,.col-xl-10,.col-xl-11,.col-xl-12{padding-right:2.5px;padding-left:2.5px}}.col{flex-basis:0;flex-grow:1;max-width:100%}.col-auto{flex:0 0 auto;width:auto}.col-1{flex:0 0 8.33333%;max-width:8.33333%}.col-2{flex:0 0 16.66667%;max-width:16.66667%}.col-3{flex:0 0 25%;max-width:25%}.col-4{flex:0 0 33.33333%;max-width:33.33333%}.col-5{flex:0 0 41.66667%;max-width:41.66667%}.col-6{flex:0 0 50%;max-width:50%}.col-7{flex:0 0 58.33333%;max-width:58.33333%}.col-8{flex:0 0 66.66667%;max-width:66.66667%}.col-9{flex:0 0 75%;max-width:75%}.col-10{flex:0 0 83.33333%;max-width:83.33333%}.col-11{flex:0 0 91.66667%;max-width:91.66667%}.col-12{flex:0 0 100%;max-width:100%}.pull-0{right:auto}.pull-1{right:8.33333%}.pull-2{right:16.66667%}.pull-3{right:25%}.pull-4{right:33.33333%}.pull-5{right:41.66667%}.pull-6{right:50%}.pull-7{right:58.33333%}.pull-8{right:66.66667%}.pull-9{right:75%}.pull-10{right:83.33333%}.pull-11{right:91.66667%}.pull-12{right:100%}.push-0{left:auto}.push-1{left:8.33333%}.push-2{left:16.66667%}.push-3{left:25%}.push-4{left:33.33333%}.push-5{left:41.66667%}.push-6{left:50%}.push-7{left:58.33333%}.push-8{left:66.66667%}.push-9{left:75%}.push-10{left:83.33333%}.push-11{left:91.66667%}.push-12{left:100%}.offset-1{margin-left:8.33333%}.offset-2{margin-left:16.66667%}.offset-3{margin-left:25%}.offset-4{margin-left:33.33333%}.offset-5{margin-left:41.66667%}.offset-6{margin-left:50%}.offset-7{margin-left:58.33333%}.offset-8{margin-left:66.66667%}.offset-9{margin-left:75%}.offset-10{margin-left:83.33333%}.offset-11{margin-left:91.66667%}@media (min-width:576px){.col-sm{flex-basis:0;flex-grow:1;max-width:100%}.col-sm-auto{flex:0 0 auto;width:auto}.col-sm-1{flex:0 0 8.33333%;max-width:8.33333%}.col-sm-2{flex:0 0 16.66667%;max-width:16.66667%}.col-sm-3{flex:0 0 25%;max-width:25%}.col-sm-4{flex:0 0 33.33333%;max-width:33.33333%}.col-sm-5{flex:0 0 41.66667%;max-width:41.66667%}.col-sm-6{flex:0 0 50%;max-width:50%}.col-sm-7{flex:0 0 58.33333%;max-width:58.33333%}.col-sm-8{flex:0 0 66.66667%;max-width:66.66667%}.col-sm-9{flex:0 0 75%;max-width:75%}.col-sm-10{flex:0 0 83.33333%;max-width:83.33333%}.col-sm-11{flex:0 0 91.66667%;max-width:91.66667%}.col-sm-12{flex:0 0 100%;max-width:100%}.pull-sm-0{right:auto}.pull-sm-1{right:8.33333%}.pull-sm-2{right:16.66667%}.pull-sm-3{right:25%}.pull-sm-4{right:33.33333%}.pull-sm-5{right:41.66667%}.pull-sm-6{right:50%}.pull-sm-7{right:58.33333%}.pull-sm-8{right:66.66667%}.pull-sm-9{right:75%}.pull-sm-10{right:83.33333%}.pull-sm-11{right:91.66667%}.pull-sm-12{right:100%}.push-sm-0{left:auto}.push-sm-1{left:8.33333%}.push-sm-2{left:16.66667%}.push-sm-3{left:25%}.push-sm-4{left:33.33333%}.push-sm-5{left:41.66667%}.push-sm-6{left:50%}.push-sm-7{left:58.33333%}.push-sm-8{left:66.66667%}.push-sm-9{left:75%}.push-sm-10{left:83.33333%}.push-sm-11{left:91.66667%}.push-sm-12{left:100%}.offset-sm-0{margin-left:0}.offset-sm-1{margin-left:8.33333%}.offset-sm-2{margin-left:16.66667%}.offset-sm-3{margin-left:25%}.offset-sm-4{margin-left:33.33333%}.offset-sm-5{margin-left:41.66667%}.offset-sm-6{margin-left:50%}.offset-sm-7{margin-left:58.33333%}.offset-sm-8{margin-left:66.66667%}.offset-sm-9{margin-left:75%}.offset-sm-10{margin-left:83.33333%}.offset-sm-11{margin-left:91.66667%}}@media (min-width:768px){.col-md{flex-basis:0;flex-grow:1;max-width:100%}.col-md-auto{flex:0 0 auto;width:auto}.col-md-1{flex:0 0 8.33333%;max-width:8.33333%}.col-md-2{flex:0 0 16.66667%;max-width:16.66667%}.col-md-3{flex:0 0 25%;max-width:25%}.col-md-4{flex:0 0 33.33333%;max-width:33.33333%}.col-md-5{flex:0 0 41.66667%;max-width:41.66667%}.col-md-6{flex:0 0 50%;max-width:50%}.col-md-7{flex:0 0 58.33333%;max-width:58.33333%}.col-md-8{flex:0 0 66.66667%;max-width:66.66667%}.col-md-9{flex:0 0 75%;max-width:75%}.col-md-10{flex:0 0 83.33333%;max-width:83.33333%}.col-md-11{flex:0 0 91.66667%;max-width:91.66667%}.col-md-12{flex:0 0 100%;max-width:100%}.pull-md-0{right:auto}.pull-md-1{right:8.33333%}.pull-md-2{right:16.66667%}.pull-md-3{right:25%}.pull-md-4{right:33.33333%}.pull-md-5{right:41.66667%}.pull-md-6{right:50%}.pull-md-7{right:58.33333%}.pull-md-8{right:66.66667%}.pull-md-9{right:75%}.pull-md-10{right:83.33333%}.pull-md-11{right:91.66667%}.pull-md-12{right:100%}.push-md-0{left:auto}.push-md-1{left:8.33333%}.push-md-2{left:16.66667%}.push-md-3{left:25%}.push-md-4{left:33.33333%}.push-md-5{left:41.66667%}.push-md-6{left:50%}.push-md-7{left:58.33333%}.push-md-8{left:66.66667%}.push-md-9{left:75%}.push-md-10{left:83.33333%}.push-md-11{left:91.66667%}.push-md-12{left:100%}.offset-md-0{margin-left:0}.offset-md-1{margin-left:8.33333%}.offset-md-2{margin-left:16.66667%}.offset-md-3{margin-left:25%}.offset-md-4{margin-left:33.33333%}.offset-md-5{margin-left:41.66667%}.offset-md-6{margin-left:50%}.offset-md-7{margin-left:58.33333%}.offset-md-8{margin-left:66.66667%}.offset-md-9{margin-left:75%}.offset-md-10{margin-left:83.33333%}.offset-md-11{margin-left:91.66667%}}@media (min-width:992px){.col-lg{flex-basis:0;flex-grow:1;max-width:100%}.col-lg-auto{flex:0 0 auto;width:auto}.col-lg-1{flex:0 0 8.33333%;max-width:8.33333%}.col-lg-2{flex:0 0 16.66667%;max-width:16.66667%}.col-lg-3{flex:0 0 25%;max-width:25%}.col-lg-4{flex:0 0 33.33333%;max-width:33.33333%}.col-lg-5{flex:0 0 41.66667%;max-width:41.66667%}.col-lg-6{flex:0 0 50%;max-width:50%}.col-lg-7{flex:0 0 58.33333%;max-width:58.33333%}.col-lg-8{flex:0 0 66.66667%;max-width:66.66667%}.col-lg-9{flex:0 0 75%;max-width:75%}.col-lg-10{flex:0 0 83.33333%;max-width:83.33333%}.col-lg-11{flex:0 0 91.66667%;max-width:91.66667%}.col-lg-12{flex:0 0 100%;max-width:100%}.pull-lg-0{right:auto}.pull-lg-1{right:8.33333%}.pull-lg-2{right:16.66667%}.pull-lg-3{right:25%}.pull-lg-4{right:33.33333%}.pull-lg-5{right:41.66667%}.pull-lg-6{right:50%}.pull-lg-7{right:58.33333%}.pull-lg-8{right:66.66667%}.pull-lg-9{right:75%}.pull-lg-10{right:83.33333%}.pull-lg-11{right:91.66667%}.pull-lg-12{right:100%}.push-lg-0{left:auto}.push-lg-1{left:8.33333%}.push-lg-2{left:16.66667%}.push-lg-3{left:25%}.push-lg-4{left:33.33333%}.push-lg-5{left:41.66667%}.push-lg-6{left:50%}.push-lg-7{left:58.33333%}.push-lg-8{left:66.66667%}.push-lg-9{left:75%}.push-lg-10{left:83.33333%}.push-lg-11{left:91.66667%}.push-lg-12{left:100%}.offset-lg-0{margin-left:0}.offset-lg-1{margin-left:8.33333%}.offset-lg-2{margin-left:16.66667%}.offset-lg-3{margin-left:25%}.offset-lg-4{margin-left:33.33333%}.offset-lg-5{margin-left:41.66667%}.offset-lg-6{margin-left:50%}.offset-lg-7{margin-left:58.33333%}.offset-lg-8{margin-left:66.66667%}.offset-lg-9{margin-left:75%}.offset-lg-10{margin-left:83.33333%}.offset-lg-11{margin-left:91.66667%}}@media (min-width:1200px){.col-xl{flex-basis:0;flex-grow:1;max-width:100%}.col-xl-auto{flex:0 0 auto;width:auto}.col-xl-1{flex:0 0 8.33333%;max-width:8.33333%}.col-xl-2{flex:0 0 16.66667%;max-width:16.66667%}.col-xl-3{flex:0 0 25%;max-width:25%}.col-xl-4{flex:0 0 33.33333%;max-width:33.33333%}.col-xl-5{flex:0 0 41.66667%;max-width:41.66667%}.col-xl-6{flex:0 0 50%;max-width:50%}.col-xl-7{flex:0 0 58.33333%;max-width:58.33333%}.col-xl-8{flex:0 0 66.66667%;max-width:66.66667%}.col-xl-9{flex:0 0 75%;max-width:75%}.col-xl-10{flex:0 0 83.33333%;max-width:83.33333%}.col-xl-11{flex:0 0 91.66667%;max-width:91.66667%}.col-xl-12{flex:0 0 100%;max-width:100%}.pull-xl-0{right:auto}.pull-xl-1{right:8.33333%}.pull-xl-2{right:16.66667%}.pull-xl-3{right:25%}.pull-xl-4{right:33.33333%}.pull-xl-5{right:41.66667%}.pull-xl-6{right:50%}.pull-xl-7{right:58.33333%}.pull-xl-8{right:66.66667%}.pull-xl-9{right:75%}.pull-xl-10{right:83.33333%}.pull-xl-11{right:91.66667%}.pull-xl-12{right:100%}.push-xl-0{left:auto}.push-xl-1{left:8.33333%}.push-xl-2{left:16.66667%}.push-xl-3{left:25%}.push-xl-4{left:33.33333%}.push-xl-5{left:41.66667%}.push-xl-6{left:50%}.push-xl-7{left:58.33333%}.push-xl-8{left:66.66667%}.push-xl-9{left:75%}.push-xl-10{left:83.33333%}.push-xl-11{left:91.66667%}.push-xl-12{left:100%}.offset-xl-0{margin-left:0}.offset-xl-1{margin-left:8.33333%}.offset-xl-2{margin-left:16.66667%}.offset-xl-3{margin-left:25%}.offset-xl-4{margin-left:33.33333%}.offset-xl-5{margin-left:41.66667%}.offset-xl-6{margin-left:50%}.offset-xl-7{margin-left:58.33333%}.offset-xl-8{margin-left:66.66667%}.offset-xl-9{margin-left:75%}.offset-xl-10{margin-left:83.33333%}.offset-xl-11{margin-left:91.66667%}}", ""]);
	
	// exports


/***/ },
/* 836 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(10)();
	// imports
	exports.push([module.id, "@import url(https://fonts.googleapis.com/css?family=Open+Sans:400,400i,600,700,700i);", ""]);
	
	// module
	exports.push([module.id, "html{scroll-behavior:smooth}@media (prefers-reduced-motion:reduce){html{scroll-behavior:auto}}main{outline:none}body{font-size:large}body,button,input,select,textarea{font-family:Open Sans,sans-serif}.App.unsupported-browser{pointer-events:none}.pull-left{float:left}.pull-right{float:right}.no-padding{padding:0}.btn{padding:6px 10px;border-radius:3px;border:none;font-weight:600;font-family:Open Sans,sans-serif;cursor:pointer;outline:3px solid rgba(191,164,75,0);outline-offset:7px;transition:outline-offset .2s;will-change:outline-offset,background;text-decoration:none}.btn:focus{outline:3px solid rgba(191,164,75,.6);outline-offset:0}.btn:disabled{cursor:not-allowed}.btn .svg-icon{max-width:24px}@media screen and (-ms-high-contrast:active),screen and (-ms-high-contrast:none){.btn .svg-icon{width:24px;display:block}}.btn-raised{display:flex;padding:8px 18px;border:none;justify-content:center;align-items:center;background:#303030;color:#fff;font-weight:600;font-size:13.3333px;font-family:Open Sans,sans-serif;box-shadow:0 3px 6px rgba(0,0,0,.16),0 3px 6px rgba(0,0,0,.23);cursor:pointer;transition:outline-offset .2s;outline:3px solid rgba(191,164,75,0);outline-offset:7px}.btn-raised .icon{margin-top:3px}.btn-raised:focus{outline-color:rgba(191,164,75,.3);outline-offset:0}.btn-raised.btn-disabled,.btn-raised:disabled{background:#999794;box-shadow:0 0 0 transparent,0 0 0 transparent}.btn-raised.btn-disabled:hover,.btn-raised:disabled:hover{background:#999794}.btn-3d{border:none;background:#e4e4e3;border-bottom:3px solid #c9c7c4;padding:10px;border-radius:3px;font-weight:600;font-family:Open Sans,sans-serif;cursor:pointer;outline:none}.btn-default{border:1px solid #3d3c3b;color:#3d3c3b;padding:5px 9px;background:none}.btn-default:hover{background:rgba(0,0,0,.1)}.btn-default:disabled{color:#8a8987;border-color:#8a8987;background:rgba(0,0,0,.15)}.btn-white{border:1px solid #888;color:#3d3c3b;padding:5px 9px;background:#fff}.btn-white:hover{background:#ddd}.btn-text.btn-text{background:none}.btn-text.btn-text.btn-primary{color:#1c1c1c;font-weight:800;font-size:.8rem;text-transform:uppercase;padding:5px 15px}.btn-text.btn-text.btn-primary:hover{background:#e4e4e3;border-radius:0}.btn-text.btn-text.btn-primary:active{background:#eeeeec}.btn-primary{color:#fff;background:#1c1c1c}.btn-primary:hover{background:#303030}.btn-primary:active{background:#000}.btn-primary:disabled{background:#999794}.btn-light-primary{color:#fff;background:#303030}.btn-light-primary:hover{background:#3f3f3f}.btn-light-primary:active{background:#282828}.btn-medium-neutral{color:#3d3c3b;background:#c9c7c4}.btn-medium-neutral:hover{background:#e4e4e3}.btn-medium-neutral:active{background:#bdbab7}.btn-medium-neutral:disabled{background:#999794}.btn-neutral{color:#3d3c3b;background:#e4e4e3}.btn-neutral:hover{background:#d7d7d6}.btn-neutral:active{background:#d2d2d1}.btn-neutral:disabled{background:#999794}.btn-secondary{color:#fff;background:#bfa44b}.btn-secondary:hover{background:#ccb771}.btn-secondary:active{background:#c6ae5e}.btn-danger{color:#fff;background:#c01027}.btn-danger:hover{background:#ec1733}.btn-danger:active{background:#d8122c}.btn-nowrap{white-space:nowrap}.danger-text.danger-text.danger-text.danger-text.danger-text{color:#c01027}.danger-text.danger-text.danger-text.danger-text.danger-text.disabled{color:grey;cursor:not-allowed}.danger-text-bold{color:#c01027;font-weight:700}.danger-text-bold.disabled{color:grey;cursor:not-allowed}.success-text.success-text.success-text.success-text.success-text{color:#349838}.badge{content:\"\";background:#c01027;box-shadow:0 2px 3px rgba(0,0,0,.3);width:15px;height:15px;color:#fff;border-radius:100%;display:inline-block;margin-right:5px;text-align:center;font-style:normal;font-weight:800;padding-top:1px;vertical-align:top;z-index:9}.flex-column-wrapper{display:flex;flex-direction:column}.description p{padding:3px 0}.description ul{list-style:circle;padding:5px 0}.description ul li{margin-left:30px;margin-bottom:7px}.description ul li:last-child{margin-bottom:0}.no-padding.no-padding.no-padding.no-padding.no-padding.no-padding{padding:0}.danger.danger.danger{background:#c01027}b,strong{font-weight:700}.flex-center{display:flex;justify-content:center;align-items:center;height:100%;width:100%}.flex-right{justify-content:flex-end}.flex-right,.flex-row{display:flex;flex-direction:row}.flex-center-row,.flex-row{justify-content:flex-start}.flex-center-row{display:flex;flex-direction:row}.align-center,.flex-center-row{align-items:center}.flex-2-column>div{flex:0 0 50%}.flex-3-column>div{flex:0 0 33.33333%}.grabbable{cursor:move!important;cursor:grab!important;cursor:-moz-grab!important;cursor:-webkit-grab!important}.grabbed{cursor:grabbing!important;cursor:-moz-grabbing!important;cursor:-webkit-grabbing!important}.svg-icon{display:inline-block;fill:currentcolor;width:100%;position:relative;user-select:none;text-align-vertical:text-bottom}.pre-wrap{white-space:pre-wrap}.pop-in-down{animation:pop-in-down .2s;animation-timing-function:ease-out}@keyframes pop-in-down{0%{transform:translateY(-10px);opacity:0}to{transform:translateY(0);opacity:1}}.faux-hide{opacity:0;width:1px;height:1px;position:fixed;bottom:-1px;right:-1px;pointer-events:none}.full-height{height:100%}.flex-center-page{display:flex;flex-direction:column;justify-content:center;align-items:center;min-height:calc(100vh - 60px - 30px)}@keyframes input-focus-ring{0%{outline-offset:3px;outline-color:rgba(191,164,75,.3)}to{outline-offset:-4px;outline-color:rgba(191,164,75,0)}}", ""]);
	
	// exports


/***/ },
/* 837 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(10)();
	// imports
	
	
	// module
	exports.push([module.id, "@font-face{font-family:icomoon;src:url(" + __webpack_require__(1491) + ") format(\"truetype\"),url(" + __webpack_require__(1492) + ") format(\"woff\"),url(" + __webpack_require__(1490) + "#icomoon) format(\"svg\");font-weight:400;font-style:normal}.icon{font-family:icomoon!important;speak:none;font-style:normal;font-weight:400;font-variant:normal;text-transform:none;line-height:1;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale}.icon-lock:before{content:\"\\E93D\"}.icon-phone-wall:before{content:\"\\E940\"}.icon-shield:before{content:\"\\E941\"}.icon-shield-lock:before{content:\"\\E942\"}.icon-lock-stroke:before{content:\"\\E943\"}.icon-phone:before{content:\"\\E944\"}.icon-star-medium:before{content:\"\\E93E\"}.icon-star:before{content:\"\\E93F\"}.icon-gears:before{content:\"\\E939\"}.icon-pencil:before{content:\"\\E935\"}.icon-plus-medium:before{content:\"\\E936\"}.icon-plus-thick:before{content:\"\\E937\"}.icon-plus-thin:before{content:\"\\E938\"}.icon-print:before{content:\"\\E93A\"}.icon-cart:before{content:\"\\E93B\"}.icon-credit-cards:before{content:\"\\E93C\"}.icon-doc:before{content:\"\\E932\"}.icon-doc-add:before{content:\"\\E933\"}.icon-doc-delete:before{content:\"\\E934\"}.icon-agent-search:before{content:\"\\E905\"}.icon-calculator:before{content:\"\\E906\"}.icon-calendar:before{content:\"\\E907\"}.icon-checkbox:before{content:\"\\E908\"}.icon-cloud-dropdown:before{content:\"\\E909\"}.icon-confirm:before{content:\"\\E90A\"}.icon-dashboard:before{content:\"\\E90B\"}.icon-dependent-checkbox:before{content:\"\\E90C\"}.icon-dependent-dropdown:before{content:\"\\E90D\"}.icon-dependent-radio:before{content:\"\\E90E\"}.icon-documents:before{content:\"\\E90F\"}.icon-dropdown:before{content:\"\\E910\"}.icon-filing:before{content:\"\\E911\"}.icon-filing-time:before{content:\"\\E912\"}.icon-home:before{content:\"\\E913\"}.icon-input:before{content:\"\\E914\"}.icon-list:before{content:\"\\E915\"}.icon-paragraph:before{content:\"\\E916\"}.icon-radio:before{content:\"\\E917\"}.icon-radio-cloud:before{content:\"\\E918\"}.icon-search:before{content:\"\\E919\"}.icon-subscribe:before{content:\"\\E91A\"}.icon-table:before{content:\"\\E91B\"}.icon-textarea:before{content:\"\\E91C\"}.icon-upload:before{content:\"\\E91D\"}.icon-caret-down:before{content:\"\\E91E\"}.icon-caret-left:before{content:\"\\E91F\"}.icon-caret-right:before{content:\"\\E920\"}.icon-caret-up:before{content:\"\\E921\"}.icon-certificate:before{content:\"\\E922\"}.icon-download:before{content:\"\\E923\"}.icon-edit-doc:before{content:\"\\E924\"}.icon-history:before{content:\"\\E925\"}.icon-report:before{content:\"\\E926\"}.icon-user-group:before{content:\"\\E927\"}.icon-cards:before{content:\"\\E928\"}.icon-cards-solid:before{content:\"\\E929\"}.icon-history2:before{content:\"\\E92A\"}.icon-rows:before{content:\"\\E92B\"}.icon-rows-solid:before{content:\"\\E92C\"}.icon-user-group2:before{content:\"\\E92D\"}.icon-zoom-medium:before{content:\"\\E92E\"}.icon-zoom-thick:before{content:\"\\E92F\"}.icon-zoom-thin:before{content:\"\\E930\"}.icon-close:before{content:\"\\E900\"}.icon-menu:before{content:\"\\E931\"}.icon-circle-cross:before{content:\"\\E901\"}.icon-cross:before{content:\"\\E902\"}.icon-circle-check:before{content:\"\\E903\"}.icon-check:before{content:\"\\E904\"}", ""]);
	
	// exports


/***/ },
/* 838 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(10)();
	// imports
	
	
	// module
	exports.push([module.id, ".action-button-group{margin:10px 0}.action-button-group.flex{display:flex;flex-flow:row wrap;justify-content:space-around}.action-button-group.medium .action-button{width:3.4rem}.action-button-group.medium .action-icon{width:2.4rem;height:2.4rem;font-size:1.4rem}.action-button-group.small .action-button{width:2.8rem}.action-button-group.small .action-icon{width:2rem;height:2rem;font-size:1rem}.action-button-group.extra-small .action-button{width:2rem}.action-button-group.extra-small .action-icon{width:1.6rem;height:1.6rem;padding:0;font-size:.8rem}.action-button-group.extra-small .action-icon .svg-icon{min-width:1.3rem}.action-button-group.table-button.table-button{padding-top:5px;justify-content:flex-start}.action-button-group.table-button.table-button .action-button{margin:0 2px 2px}.action-button-group.table-button.table-button button.action-icon{width:1.7rem;height:1.7rem;padding:3px;border-radius:2px;border:none;background:rgba(191,164,75,.15);color:#3d3c3b;transition:outline-offset .2s;outline:3px solid rgba(191,164,75,0);outline-offset:7px;box-shadow:0 1px 3px rgba(0,0,0,.12),0 1px 2px rgba(0,0,0,.24)}.action-button-group.table-button.table-button button.action-icon:focus{outline-color:rgba(191,164,75,.3);outline-offset:0}.action-button-group.table-button.table-button .spinner-wrapper{display:flex;justify-content:center;align-items:center;height:100%;width:100%;padding-right:5px;padding-bottom:5px}.action-button-group.table-button.table-button .spinner-wrapper .orbit-loader div{animation-timing-function:linear}.action-button{background:none;border:none;width:5rem;padding:0;margin:0;position:relative}.action-button.flex{flex:0 0 auto}.action-button.inner.inner{width:auto;margin:0}.action-button .__react_component_tooltip.__react_component_tooltip{background:#000;color:#fff;padding:8px;border:1px solid #414141;border-radius:5px;font-size:11px;font-weight:600;max-width:210px;box-shadow:0 3px 3px rgba(0,0,0,.3);text-align:center;line-height:1.3}.action-button .__react_component_tooltip.__react_component_tooltip:after,.action-button .__react_component_tooltip.__react_component_tooltip:before{opacity:1}.action-button .inner-wrapper{display:flex;width:100%;height:100%;justify-content:center;align-items:center;text-align:center}.action-button .action-icon{display:block;width:3.2rem;height:3.2rem;margin:0 auto;margin-bottom:4px;background:#d5d5d3;color:#666665;border:none;outline:none;border-radius:4px;font-size:2rem;cursor:pointer;transition:outline-offset .2s;outline:3px solid rgba(191,164,75,0);outline-offset:7px}.action-button .action-icon:focus{outline-color:rgba(191,164,75,.3);outline-offset:0}.action-button .action-icon:hover{background:#c6c6c4}.action-button .action-icon.icon-edit-doc{padding-left:.3rem;padding-right:0}.action-button .action-icon.inner.inner.inner{width:auto;white-space:nowrap;padding:0 10px;color:#666665;margin:0}.action-button .action-icon:disabled{transition:background .3s,color .3s;background:#eeeeec;color:#e4e4e3;cursor:not-allowed}.action-button .action-icon .svg-icon{min-width:2.4rem}.action-button.primary .action-icon{background:none;border:1px solid #999794;color:#999794}.action-button.primary .action-icon:hover{background:hsla(36,2%,59%,.2)}.action-button.success.success.success.success{background:none}.action-button.success.success.success.success .action-icon{background:#41be46;border:none;color:#fff}.action-button.success.success.success.success .action-icon:hover{background:#54c559}.action-button.danger.danger.danger.danger{background:none}.action-button.danger.danger.danger.danger .action-icon{background:#c01027;border:none;color:#fff}.action-button.danger.danger.danger.danger .action-icon:hover{background:#d8122c}.action-button .label{font-size:.65rem;font-weight:600;line-height:.6rem;display:block;text-align:center}.details-actions-top{margin-top:0}.details-actions-bottom{margin-bottom:0}", ""]);
	
	// exports


/***/ },
/* 839 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(10)();
	// imports
	
	
	// module
	exports.push([module.id, ".edit-icon-wrapper{position:relative;flex:0 0 auto;display:flex;justify-content:center;align-items:center;transition:outline-offset .2s;outline:3px solid rgba(191,164,75,0);outline-offset:7px}@media only screen and (max-width:992px){.edit-icon-wrapper{width:100%}.edit-icon-wrapper .edit-icon-positioner.edit-icon-positioner{left:calc(50% - 17px);top:10px}}.edit-icon-wrapper.secondary a,.edit-icon-wrapper.secondary button{background:#bfa44b;color:#fff}.edit-icon-wrapper.secondary a:hover,.edit-icon-wrapper.secondary button:hover{background:#c6ae5e}.edit-icon-wrapper .edit-icon-positioner{position:absolute;left:10px}.edit-icon-wrapper a,.edit-icon-wrapper button{flex:0 0 auto;background:#bfa44b;padding:1.5vh;text-decoration:none;font-size:1rem;border-radius:2px;font-weight:600;color:#fff;box-shadow:0 1px 3px rgba(0,0,0,.12),0 1px 2px rgba(0,0,0,.24);transition:box-shadow .1s,background .1s}.edit-icon-wrapper a:hover,.edit-icon-wrapper button:hover{background:#c6ae5e;box-shadow:0 3px 6px rgba(0,0,0,.16),0 3px 6px rgba(0,0,0,.23)}.edit-icon-wrapper a:focus,.edit-icon-wrapper button:focus{outline-color:rgba(191,164,75,.3);outline-offset:0}.edit-icon-wrapper button{width:35px;height:35px;padding:0;border:none;display:flex;justify-content:center;align-items:center;box-shadow:none;border-radius:100%;background:#bfa44b}.edit-icon-wrapper button:hover{background:#ccb771;box-shadow:none}.edit-icon-wrapper button .svg-icon{width:25px;height:25px}", ""]);
	
	// exports


/***/ },
/* 840 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(10)();
	// imports
	
	
	// module
	exports.push([module.id, ".cart-button-wrapper{display:flex;flex-direction:column;justify-content:center;align-items:center}.cart-button-wrapper .cart-button{position:relative;border:none;background:none;margin-top:-5px;margin-right:6px;color:#000;padding:12px 8px;padding-bottom:7px;transition:outline-offset .2s;outline:3px solid rgba(191,164,75,0);outline-offset:7px}.cart-button-wrapper .cart-button .svg-icon{width:28px}.cart-button-wrapper .cart-button:hover{background:#d7d7d6}.cart-button-wrapper .cart-button:focus{background:#d7d7d6;outline-color:rgba(191,164,75,.3);outline-offset:0}.cart-button-wrapper .cart-button:disabled{background:none}.cart-button-wrapper .cart-amount{position:absolute;right:-1px;top:4px;z-index:9;display:flex;justify-content:center;align-items:center;padding:3px 2px;border-radius:30px;background:#1c1c1c;color:#fff;min-width:15px;font-weight:600;font-size:9px;line-height:1}.cart-button-wrapper .tooltip-positioner.tooltip-positioner.tooltip-positioner.tooltip-positioner{top:87%;left:-100%}.cart-button-wrapper .tooltip-wrapper.tooltip-wrapper.tooltip-wrapper.tooltip-wrapper{min-width:150px;text-align:center;left:-50%;display:flex;justify-content:center}", ""]);
	
	// exports


/***/ },
/* 841 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(10)();
	// imports
	
	
	// module
	exports.push([module.id, ".certificate-success .message{background:rgba(65,190,70,.3);padding:5px;border-radius:3px;color:#1a4c1c;font-style:normal;font-weight:600;display:flex;align-items:center}.certificate-success .message .svg-icon{max-width:30px;margin-right:5px}.certificate-success h2{font-size:1rem;margin-bottom:5px}.certificate-success .date{font-style:italic;font-weight:400}.certificate-success .verify-certificate-table{width:100%}.certificate-success .verify-certificate-table td{padding-bottom:10px}.certificate-success .verify-certificate-table td.label{text-align:right}.certificate-success .verify-certificate-table td.value{padding-left:20px;vertical-align:bottom}", ""]);
	
	// exports


/***/ },
/* 842 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(10)();
	// imports
	
	
	// module
	exports.push([module.id, ".request-certificate{padding:20px;overflow:auto;max-height:calc(100vh - 91px)}.request-certificate .instructions p{line-height:1.4;font-size:.85rem}.request-certificate .controls{margin-top:15px;display:flex;justify-content:center;margin-bottom:5px}", ""]);
	
	// exports


/***/ },
/* 843 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(10)();
	// imports
	
	
	// module
	exports.push([module.id, ".checkout{padding:20px;color:#fff;font-size:1.4rem}.checkout .frequent-payor-need-funds{font-size:12px;display:flex;flex-direction:column;justify-content:space-between;height:50px}.checkout .header{padding-bottom:15px;border-bottom:1px solid #3d3d3d;margin-bottom:15px}.checkout .header .icon{margin-right:10px;display:inline-block}.checkout .header .title{vertical-align:top;font-size:1.2rem;margin-top:2px;display:inline-block}.checkout .header .close{float:right;font-size:1.5rem;padding:0;background:none;color:#fff;border:none;width:1.5rem;outline:none;cursor:pointer;transition:outline-offset .2s;outline:3px solid rgba(191,164,75,0);outline-offset:7px}.checkout .header .close:hover{color:hsla(0,0%,100%,.8)}.checkout .header .close:focus{outline-color:rgba(191,164,75,.3);outline-offset:0}.checkout .header .close.close-text{margin-top:-1px;padding:3px 8px;background:hsla(0,0%,100%,.15);text-shadow:0 1px 1px rgba(0,0,0,.5);width:auto;font-size:.8rem;border-radius:3px;font-weight:600}.checkout .line-item-container{position:relative}.checkout .line-item-container .line-item{padding-bottom:10px}.checkout .line-item-container .line-item.subline .price{font-size:.85rem;font-weight:400}.checkout .line-item-container .line-item-column{width:100%}.checkout .line-item-container .buttons-wrapper{position:absolute;left:-10px;top:0;width:20px;height:100%;display:flex;align-items:center;justify-content:center;padding-bottom:30px;z-index:9}.checkout .line-item-container .remove-item-button{background:none;border:none;color:hsla(0,0%,100%,.7);padding:7px;transition:outline-offset .2s;outline:3px solid rgba(191,164,75,0);outline-offset:7px}.checkout .line-item-container .remove-item-button:focus{outline-color:rgba(191,164,75,.3);outline-offset:0}.checkout .line-item-container .remove-item-button:hover{color:#fff}.checkout .line-item-container .remove-item-button svg{width:14px;height:14px}.checkout .line-item{font-size:.95rem;padding-bottom:17px}.checkout .line-item .product{display:block;line-height:1.2}.checkout .line-item .product.deletable{padding-left:15px}.checkout .line-item.subline .product{font-size:.85rem;font-style:italic}.checkout .line-item .detail{font-size:.75rem;padding-left:10px;font-style:italic;color:#ccc}.checkout .line-item .price{font-weight:800;text-align:right;display:block}.checkout .line-item:last-child{border-bottom:1px solid #3d3d3d;margin-bottom:15px}.checkout .subtotal{font-size:.95rem;text-align:right;padding-bottom:10px;color:#3d3d3d}.checkout .subtotal.total{color:#fff}.checkout .subtotal .price{display:block;font-weight:800}.checkout .subtotal:last-child{border-bottom:1px solid #3d3d3d;margin-bottom:15px;padding-bottom:15px}.checkout .button{display:block;width:100%;background:#ffde55;border-color:#ccae1d;color:#6d4e00;margin-bottom:10px;user-select:none;padding-top:0;padding-bottom:0;height:42px;transition:outline-offset .2s;outline:3px solid rgba(191,164,75,0);outline-offset:7px}.checkout .button:last-child{margin-bottom:0}.checkout .button:hover{background:#ffe67e}.checkout .button:active{background:#f5d44d}.checkout .button:focus{outline-color:rgba(191,164,75,.3);outline-offset:0}.checkout .button.paypal{background:#85dfff;border-color:#2ab7d8;color:#263b80}.checkout .button.paypal:hover{background:#a7e8ff}.checkout .button.paypal:active{background:#72d2f5}.checkout .button.paypal .label{font-size:.75rem;font-weight:800}.checkout .button.paypal img{width:90px;margin-left:7px;margin-bottom:-5px;margin-top:-2px}.checkout .button:disabled{pointer-events:none}.checkout .button:disabled:hover{background:#ffde55}.checkout .button.visually-disabled{opacity:.5;cursor:not-allowed;pointer-events:auto}.checkout .button.danger{border-color:#9c1a25;color:#fff;transition:background .5s,border-color .5s}.checkout .button.danger:active,.checkout .button.danger:hover{background:#c01027}.checkout .button .svg-icon{width:1.1rem;height:1.1rem;margin-right:3px}.checkout .button .icon{font-size:1rem;display:inline-block;margin-top:2px;margin-right:5px;padding-bottom:0}.checkout .button .label{display:inline-block;vertical-align:top;font-size:.85rem}.checkout .button .loader{margin-right:18px;margin-top:-4px}.checkout .button.secondary{border-bottom-color:hsla(0,0%,100%,.05);background:hsla(0,0%,100%,.15);color:#fff}.checkout .button.secondary .label{text-shadow:0 1px 1px rgba(0,0,0,.5)}.checkout .method-error{font-size:.85rem;margin-bottom:10px;padding:10px;background:hsla(0,0%,100%,.1);border-radius:2px}.checkout .cart-empty-hint{font-size:.85rem;font-style:italic;text-align:center;margin:15px 0}.checkout .checkout-hint{font-size:.8rem;font-style:italic;margin-bottom:.5em;text-align:center}.checkout .cart-save-container{margin-top:15px;padding-top:15px;border-top:1px solid #3d3d3d}.checkout .continue-section{padding-top:20px;margin-top:12px;border-top:1px solid hsla(0,0%,100%,.2);justify-content:center}.checkout .continue-button{padding:3px 8px;background:hsla(0,0%,100%,.15);text-shadow:0 1px 1px rgba(0,0,0,.5);width:auto;font-size:.8rem;border-radius:3px;font-weight:600;border:none;color:#fff;cursor:pointer;transition:outline-offset .2s;outline:3px solid rgba(191,164,75,0);outline-offset:7px}.checkout .continue-button:focus{outline-color:rgba(191,164,75,.3);outline-offset:0}.checkout .continue-button:hover{color:hsla(0,0%,100%,.8)}.checkout .continue-button svg.svg-icon{width:14px;height:14px;margin-right:10px}.checkout .checkout-body{display:flex;flex-direction:column;margin-left:-20px;margin-right:-20px;position:relative}.checkout .checkout-body-inner-wrapper{left:0;top:0;width:200%;display:flex;flex-direction:row;flex:0 0 auto;transition:transform .3s;will-change:transform}.checkout .main-wrapper,.checkout .secondary-wrapper{width:50%;display:flex;flex-direction:column;padding:0 20px}.checkout .native-checkout{overflow:hidden}.checkout .native-checkout .return-button{background:none;border:none;text-align:left;color:#fff;font-size:.85rem;padding:0}.checkout .native-checkout .return-button:hover{text-decoration:underline}.checkout .native-checkout label.field-label{font-size:.85rem}.checkout .native-checkout .flex-row .field{margin-left:5px}.checkout .native-checkout .flex-row .field:first-child{margin-left:-5px}.checkout .native-checkout .flex-row .field:last-child{margin-right:-5px}.checkout .native-checkout .flex-row .field:only-child{margin-left:-5px;margin-right:-5px;width:calc(100% + 10px)}.checkout .native-checkout span.required.required{color:#ff8282}.checkout .native-checkout .field-error,.checkout .native-checkout .native-method-error{color:#370505;background:#f4b1b1;border-radius:3px;padding:2px 5px;display:inline-block}.checkout .native-checkout .native-method-error{padding:8px 7px}.checkout .native-checkout .separator{width:100%;border-top:1px solid hsla(0,0%,100%,.2);margin-top:5px;margin-bottom:5px}.checkout .native-checkout .exp-row .field{flex:0 0 auto}.checkout .native-checkout .exp-row .field:first-child{width:40%}.checkout .native-checkout .exp-row .field:last-child{width:30%}.checkout .native-checkout .phone-row{margin-right:-15px}.checkout .native-checkout .phone-row .field:first-child{width:65%}.checkout .native-checkout .phone-row .field:last-child{width:35%}.checkout .native-checkout .credit-card-description{font-size:14px;font-style:italic;margin-top:-2px}.checkout .native-checkout .card-icons{width:auto;height:auto;max-width:80px;margin-right:10px}.checkout fieldset.secondary-wrapper{padding-bottom:20px}.checkout .cart-description{margin-bottom:10px}.checkout-loader{display:block;margin:0 auto;margin-top:50px}.itransact-checkout p{font-size:.8rem;font-style:italic;margin-bottom:10px}.itransact-checkout .wizard label.field-label{font-size:.9rem}.itransact-checkout .wizard label.field-label span{display:flex;align-items:center}.itransact-checkout .wizard label.field-label span svg{width:18px;height:18px;margin-right:7px;margin-left:3px}.itransact-checkout .wizard label.field-label:before{background:hsla(0,0%,100%,.1);border-color:hsla(0,0%,100%,.6);border-width:2px;width:18px;height:18px}.itransact-checkout .wizard label.field-label:after{background:#fff!important;width:8px!important;height:8px!important}.itransact-checkout .new-payment-btn{background:hsla(0,0%,100%,.1);border:none;border-radius:5px;padding:5px 10px;margin-top:10px;color:inherit;margin-bottom:20px;font-size:.9rem;width:100%;height:39px}.itransact-checkout .new-payment-btn svg{width:16px;height:16px;margin-right:10px;margin-left:-5px}.itransact-checkout .new-payment-btn:hover{background:hsla(0,0%,100%,.2)}.itransact-checkout .new-payment-btn:focus{outline-color:#fff}.itransact-checkout .new-payment-btn:disabled{color:hsla(0,0%,100%,.6)}.itransact-checkout .new-payment-btn .orbit-loader{margin-right:20px;margin-top:-5px;transform:scale(.8)}.itransact-checkout .option-wrapper.option-wrapper.option-wrapper{display:flex}.itransact-checkout .label-wrapper,.itransact-checkout label.radio-label.radio-label.radio-label.radio-label{width:100%;display:flex;flex-direction:row;align-items:center}.itransact-checkout .label-wrapper{padding-top:5px}.itransact-checkout .trash-button{background:none;padding:3px;border:none;margin:0;margin-left:auto;color:#fff;padding-top:5px;padding-left:6px;padding-right:6px;border-radius:3px}.itransact-checkout .trash-button svg.svg-icon.svg-icon.svg-icon{margin:0}.itransact-checkout .trash-button:hover{background:hsla(0,0%,100%,.1)}.itransact-checkout .trash-button:focus{outline-color:#fff}.itransact-checkout .payment-error{background:#f68d9b;color:#790a19;padding:10px;border-radius:2px;margin:0;margin-bottom:15px}.itransact-checkout .payment-error .svg-icon{width:12px;height:12px;margin-right:7px}.itransact-checkout .payment-error span{vertical-align:top}.itransact-checkout .payment-processing{color:red;font-weight:700;margin-top:10px;margin-bottom:10px;font-size:.9rem}", ""]);
	
	// exports


/***/ },
/* 844 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(10)();
	// imports
	
	
	// module
	exports.push([module.id, ".receipt{display:block;margin:0 auto;margin-top:70px;background:#fff;max-width:506px;padding:30px;padding-bottom:15px;position:relative;margin-bottom:60px;box-shadow:0 60px 70px -20px rgba(0,0,0,.25)}.receipt .success-badge{position:absolute;left:50%;margin-left:-37px;width:74px;height:74px;top:-52px;border:4px solid #fff;border-radius:100%;background:#e6cb73;padding-top:10px;animation-delay:.7s}.receipt .success-badge:before{content:\" \";position:absolute;width:60px;height:60px;border:1px dashed #3d3d3d;top:3px;left:3px;border-radius:100%}.receipt .success-badge .icon{color:#fff;text-align:center;display:block;width:100%;font-size:3rem}.receipt h2{text-align:center;font-style:italic;font-size:1.5rem;font-weight:600;color:#666665;margin-top:30px;margin-bottom:15px;padding-bottom:20px;border-bottom:1px dashed #c9c7c4}.receipt h2 .markdown{font-style:normal;font-weight:400;margin-top:20px}.receipt h2 .markdown a{color:#bfa44b}.receipt .download-link{position:absolute;top:20px;right:30px;color:#3d3c3b}.receipt .total-row{display:flex;flex-direction:row;justify-content:flex-end;font-size:1.3rem;font-weight:600;padding:15px 0 5px}.receipt .total-row label{font-size:.7rem;color:#999794;text-align:right;margin-bottom:3px}.receipt .total-row .total-col{display:flex;flex-direction:column;width:100%}.receipt .total-row .total-col span{text-align:right}.receipt .refund-text{display:flex;flex-direction:row;font-size:.7rem;padding:0 0 10px;font-style:italic}.receipt .line-item{color:#3d3c3b;border-bottom:1px dashed #c9c7c4;padding-bottom:15px;margin-bottom:15px;display:flex;flex-direction:column}.receipt .line-item:last-child{margin-bottom:0}.receipt .line-item .details{display:flex;flex-direction:column}.receipt .line-item .price{text-align:right;margin-left:auto;font-weight:600;font-size:1.1rem;padding-left:10px}.receipt .line-item .product{display:block;width:100%;font-size:1.1rem;font-weight:600;margin-bottom:5px;white-space:pre-wrap}.receipt .line-item .detail{font-style:italic;margin-bottom:5px;display:flex;width:100%}.receipt .line-item .detail-price{margin-left:auto;font-style:normal;font-weight:600}.receipt .line-item button.download-button{text-transform:uppercase;font-weight:800;font-size:.75rem;background:rgba(191,164,75,.25);color:#978036}.receipt .line-item button.download-button:hover{background:rgba(191,164,75,.35)}.receipt .line-item button.download-button div{display:flex;justify-content:center;align-items:center}.receipt .line-item button.download-button .svg-icon{flex:0 0 auto;width:18px;margin-right:3px;height:20px}.receipt .receipt-download{appearance:none;text-transform:uppercase;font-weight:800;font-size:.8rem;position:absolute;right:30px;top:15px;background:none;color:#bfa44b;animation-delay:.9s;text-decoration:none}.receipt .receipt-download:hover{text-decoration:underline}.receipt .receipt-download div{display:flex;justify-content:center;align-items:center}.receipt .receipt-download .svg-icon{margin-right:2px;width:20px;height:20px}.receipt .controls{display:flex;justify-content:flex-end;margin-top:15px}.receipt .controls button{display:flex;align-items:center;text-transform:uppercase;font-weight:800}.receipt .controls button .svg-icon{display:none;width:20px;margin-right:5px;height:20px}.zig-zag:before{background:linear-gradient(-45deg,#fff 16px,#fff 0,#fff 0,transparent 0),linear-gradient(45deg,#fff 16px,transparent 0);background-position:0 0;background-repeat:repeat-x;background-size:22px 32px;top:-32px}.zig-zag:after,.zig-zag:before{content:\" \";display:block;height:32px;width:100%;position:absolute;left:0}.zig-zag:after{background:linear-gradient(-45deg,transparent 16px,#fff 0),linear-gradient(45deg,transparent 16px,#fff 0);background-repeat:repeat-x;background-position:0 100%;background-size:22px 32px;bottom:-32px}.receipt-wrapper{min-height:calc(100vh - 60px - 30px)}.payment-callback{flex-direction:column}.payment-callback .orbit-loader div{animation-timing-function:linear!important;animation-duration:.6s!important}.payment-callback .message{font-size:2rem;font-weight:800;text-transform:uppercase;color:#1c1c1c;margin-top:2rem}.payment-callback .text-danger{background:none;color:#c01027;text-align:center;max-width:700px}.payment-callback .svg-icon{width:100%;max-width:50px;margin-bottom:-20px}.payment-callback .flex-column{display:flex;flex-direction:column;justify-content:center;align-items:center}.payment-callback .delay{animation-delay:1s}.payment-callback p{margin-top:10px;font-size:1rem;font-style:italic;line-height:1.5}.receipt .downloads-wrapper h2{border:none;margin-top:20px;padding-bottom:5px}.receipt .downloads-wrapper.download-groups .download-group{margin-bottom:30px}.receipt .downloads-wrapper.download-groups .download-group h3{font-size:1.1rem;font-weight:600;color:#3d3c3b;margin-bottom:10px}.receipt .downloads-wrapper.download-groups .download-group p{font-size:.9rem;font-weight:600;color:#3d3c3b;margin-bottom:8px;font-style:italic}.receipt .downloads-wrapper.download-groups .download-group:last-child{margin-bottom:0}", ""]);
	
	// exports


/***/ },
/* 845 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(10)();
	// imports
	
	
	// module
	exports.push([module.id, ".dashboard-wrapper{background:#e4e4e3;display:flex;flex-wrap:wrap;flex-direction:row;min-height:100%}", ""]);
	
	// exports


/***/ },
/* 846 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(10)();
	// imports
	
	
	// module
	exports.push([module.id, ".data-requests,.inner-body{padding-top:30px}.data-requests .table-toolbar,.inner-body .table-toolbar{border-bottom:1px solid #e4e4e3}.data-requests .table-toolbar h1,.inner-body .table-toolbar h1{font-weight:700;font-size:1.6rem}.data-requests .table-toolbar .description,.inner-body .table-toolbar .description{padding-top:5px;font-style:italic}ul.data-request-blocks{display:flex;align-items:center;flex-direction:column;padding-top:20px}li.data-request-block{width:100%;max-width:550px;display:flex;align-items:center;padding:10px;border-radius:3px;background:#eeeeec;margin:4px;box-shadow:0 1px 1px rgba(0,0,0,.3);border-top:1px solid #e4e4e1;border-left:4px solid transparent;transition:background .1s}li.data-request-block .dr-title-wrapper{display:flex;flex-direction:column;padding-right:6px}li.data-request-block .dr-title-wrapper span.dr-title{font-weight:400;font-size:1rem;color:#505050}li.data-request-block .dr-title-wrapper span:last-child{margin-top:4px;color:gray;font-style:italic}li.data-request-block .dr-subtitle{display:flex;flex-direction:row;align-items:center;font-size:.8rem}li.data-request-block .dr-subtitle svg{margin-right:7px;width:16px;height:16px}li.data-request-block .dr-subtitle .date.date{margin-top:0;margin-right:5px}li.data-request-block .dr-buttons{display:flex;flex-direction:row;margin-left:auto}li.data-request-block .dr-buttons button{height:40px;border-radius:3px;border:1px solid #9a9a8e;color:#59594f;background:none;font-size:.85rem;white-space:nowrap;transition:outline-offset .2s;outline:3px solid rgba(191,164,75,0);outline-offset:7px}li.data-request-block .dr-buttons button:hover{background:#e2e2df}li.data-request-block .dr-buttons button:focus{outline-color:rgba(191,164,75,.3);outline-offset:0}li.data-request-block .dr-buttons button:last-child{margin-left:8px}li.data-request-block .dr-buttons button.fixed{width:40px;padding:1px;padding-top:2px}li.data-request-block .dr-buttons button.cart-button{margin-right:8px;padding:4px}li.data-request-block .dr-buttons .orbit-loader{transform:scale(.7) translateX(13px)}li.data-request-block.dr-active{border-left-color:#41be46}li.data-request-block.dr-cancelled,li.data-request-block.dr-failed{border-left-color:#c01027}li.data-request-block.dr-complete{border-left-color:#e2e2df}li.data-request-block.active{background:#dbdbd6}li.data-request-block.dr-paused{border-left-color:#fbe584}.subscription-blocks{display:flex;align-items:center;flex-direction:column;padding-top:20px}.subscription-block{width:100%;max-width:450px;display:flex;align-items:center;padding:10px;border-radius:5px;background:#eeeeec;margin:5px}.subscription-block label{font-size:.85rem;padding:10px}.subscription-block .subscribe-button{text-transform:uppercase;width:124px}.subscription-block .subscribe-button .svg-icon{margin-right:8px;width:20px;flex:0 0 auto}.subscription-block .subscribe-button .button-label{flex:1}.subscription-block.subscribed{background:rgba(191,164,75,.2)}.subscription-block.unsubscribed .subscribe-button{background:#fff;color:#8c7732}.subscription-block.unsubscribed .subscribe-button:hover{background:#f7f4e9}.dr-management-drawer{transition:opacity .3s}.dr-management-drawer.loading{opacity:.7}.dr-management-drawer .error-message{color:#c01027;text-align:center;font-size:.8rem;font-style:italic;line-height:1.2}.nickname-editor{padding:20px}.nickname-editor .text-wrapper{display:block}", ""]);
	
	// exports


/***/ },
/* 847 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(10)();
	// imports
	
	
	// module
	exports.push([module.id, ".designer-content{padding-bottom:0}.designer{width:100%;display:block;position:relative;height:calc(100vh - 60px - 40px);background:#c3c3c3;background-image:linear-gradient(0deg,transparent 24%,hsla(0,0%,100%,.2) 25%,hsla(0,0%,100%,.2) 26%,transparent 27%,transparent 74%,hsla(0,0%,100%,.2) 75%,hsla(0,0%,100%,.2) 76%,transparent 77%,transparent),linear-gradient(90deg,transparent 24%,hsla(0,0%,100%,.2) 25%,hsla(0,0%,100%,.2) 26%,transparent 27%,transparent 74%,hsla(0,0%,100%,.2) 75%,hsla(0,0%,100%,.2) 76%,transparent 77%,transparent);background-size:30px 30px}.designer .sidebar{display:block;position:absolute;width:250px;height:calc(100vh - 60px - 30px);background:#c9c7c4;color:#3d3c3b;z-index:9;padding:5px;overflow-y:auto}.designer .sidebar .right{padding:0}.designer .sidebar::-webkit-scrollbar{width:6px;height:8px}.designer .sidebar::-webkit-scrollbar-track{background:none;-webkit-border-radius:6px;border-radius:6px}.designer .sidebar::-webkit-scrollbar-track-piece{width:10px}.designer .sidebar::-webkit-scrollbar-thumb{-webkit-border-radius:6px;border-radius:6px;background:#aaa}.designer .sidebar::-webkit-scrollbar-thumb:window-inactive{background:hsla(36,2%,59%,.4)}.designer .sidebar.left{left:0;top:-40px;-webkit-box-shadow:2px 0 3px 0 rgba(0,0,0,.2);-moz-box-shadow:2px 0 3px 0 rgba(0,0,0,.2);box-shadow:2px 0 3px 0 rgba(0,0,0,.2)}.designer .sidebar.right{right:0;top:-40px;background:#e0e0e0;color:#1c1c1c;padding:0;-webkit-box-shadow:-2px 0 3px 0 rgba(0,0,0,.2);-moz-box-shadow:-2px 0 3px 0 rgba(0,0,0,.2);box-shadow:-2px 0 3px 0 rgba(0,0,0,.2)}.designer .sidebar .sidebar-title{font-size:18px;margin:0;margin:-5px -5px 10px;text-align:center;display:block;padding-top:10px;padding-bottom:10px;background:#4f4f4f;color:#1c1c1c;min-height:40px}.designer .body{display:block;width:calc(100% - 250px);padding:20px 265px;padding-right:15px;padding-top:20px;margin-top:40px;height:calc(100vh - 60px - 30px - 40px);overflow-y:scroll}.designer .body::-webkit-scrollbar{width:10px;height:8px}.designer .body::-webkit-scrollbar-track{background:none;-webkit-border-radius:6px;border-radius:6px}.designer .body::-webkit-scrollbar-track-piece{width:10px}.designer .body::-webkit-scrollbar-thumb{-webkit-border-radius:6px;border-radius:6px;background:#aaa}.designer .body::-webkit-scrollbar-thumb:window-inactive{background:hsla(36,2%,59%,.4)}.designer .body .loader-wrapper{display:flex;height:100%;justify-content:center;align-items:center;padding-left:20px}.designer .body .toolbar{display:flex;flex-wrap:nowrap;position:absolute;top:-40px;left:250px;right:250px;height:40px;background:#eee;padding:5px;z-index:999;-webkit-box-shadow:0 3px 4px 0 rgba(0,0,0,.1);-moz-box-shadow:0 3px 4px 0 rgba(0,0,0,.1);box-shadow:0 3px 4px 0 rgba(0,0,0,.1)}.designer .body .toolbar .revision-chip{background-color:#bfbfbf;border:none;border-radius:4px;font-weight:700;font-size:.7rem;display:flex;align-items:center;padding:5px;margin:2px 5px}.designer .body .toolbar .toolbar-title{display:flex;flex-shrink:1;min-width:100px}.designer .body .toolbar .toolbar-buttons{flex-shrink:0;flex-direction:row-reverse;margin-left:auto}.designer .body .toolbar button{white-space:nowrap;flex-shrink:0;margin-left:3px;margin-right:3px}.designer .body .toolbar button.danger{border:none;background:#9c1a25;color:#fff}.designer .body .toolbar button .icon{margin-top:2px;margin-bottom:-5px;vertical-align:top}.designer .body .toolbar button>.svg-icon{max-width:30px;padding:4px 5px 0}.designer .body .toolbar .wizard-title{display:block;background:none;height:100%;color:#3d3c3b;font-size:20px;font-weight:700;padding-left:5px;padding-right:5px;padding-top:5px;border-radius:6px;overflow:hidden;text-overflow:ellipsis;white-space:nowrap;cursor:pointer;border:none;transition:none!important;min-width:100px;transition:outline-offset .2s;outline:3px solid rgba(191,164,75,0);outline-offset:7px}.designer .body .toolbar .wizard-title:focus{outline-color:rgba(191,164,75,.3);outline-offset:0}.designer .body .toolbar .wizard-title:hover{background:rgba(255,238,175,.5)}.designer .body .toolbar .wizard-title.active{background:#ffeeaf}.designer button.search-button{margin-top:27px;margin-left:2px;background:#303030;border-color:#0f0f0f;color:#fff;text-shadow:0 1px 0 rgba(0,0,0,.7);width:94%}.designer button.search-button:hover{background:#3a3a3a}.designer button.search-button:active{background:#282828;color:#fff;text-shadow:0 1px 0 rgba(0,0,0,.7)}.designer button.search-button:focus,.designer button.search-button:hover{color:#fff}.designer .scroll-zone{position:fixed;top:60px;left:0;width:100%;height:80px;z-index:999}.designer .scroll-zone.bottom{top:auto;bottom:0}.sub-designer{height:calc(100% - 51px);border-radius:0 0 5px 5px}.sub-designer .sidebar.sidebar{height:100%;border-bottom-left-radius:5px;top:0}.sub-designer .sidebar.sidebar.right{border-bottom-left-radius:0;border-bottom-right-radius:5px}.sub-designer .body{padding:20px 10px 10px 250px;height:100%;margin-top:0;overflow:hidden}.sub-designer .sub-field-editor-wrapper{display:block;margin:0 auto;height:100%;min-height:100px;width:calc(100% + 17px);padding:0 20px;overflow-x:auto;padding-bottom:10px;user-select:none}.sub-designer .sub-field-editor-wrapper::-webkit-scrollbar{width:5px;height:8px}.sub-designer .sub-field-editor-wrapper::-webkit-scrollbar-track{background:rgba(0,0,0,.1);-webkit-border-radius:6px;border-radius:6px}.sub-designer .sub-field-editor-wrapper::-webkit-scrollbar-thumb{-webkit-border-radius:6px;border-radius:6px;background:#1c1c1c}.sub-designer .sub-field-editor-wrapper::-webkit-scrollbar-thumb:window-inactive{background:rgba(28,28,28,.4)}.sub-designer .sub-field-editor{display:flex;flex-direction:row;margin:0 auto;height:100%;min-height:100px;width:100%;padding:0}.sub-designer .sub-field-editor .option-column{min-width:40%;height:100%;flex:0 0 40%;padding:0;vertical-align:top;background:#eee;border-radius:5px;margin-right:10px;position:relative;overflow:hidden;-webkit-box-shadow:0 3px 5px 0 rgba(0,0,0,.3);-moz-box-shadow:0 3px 5px 0 rgba(0,0,0,.3);box-shadow:0 3px 5px 0 rgba(0,0,0,.3)}.sub-designer .sub-field-editor .option-column.check-column{width:49.5%;flex:0 0 49.5%;display:block}.sub-designer .sub-field-editor .option-column.repeater-column{width:100%;margin-right:0;flex:0 0 100%}.sub-designer .sub-field-editor .option-column .input-row{display:block;margin-bottom:0;background:#1c1c1c;color:#fff;border-radius:6px 6px 0 0;padding:8px;border-bottom:4px solid #4a4a4a;white-space:normal;cursor:pointer;text-align:center;font-size:16px;min-height:42px}.sub-designer .sub-field-editor .option-column .input-row:hover{background:#fff3c9;border-bottom-color:#ffeeaf;color:#493900}.sub-designer .sub-field-editor .option-column .input-row.active{background:#ffeeaf;border-bottom-color:#ffe37c;color:#493900}.sub-designer .sub-field-editor .option-column .field-row{padding:10px 20px;display:block;width:100%;height:85%;height:calc(100% - 40px);overflow-y:auto;overflow-x:hidden}.sub-designer .sub-field-editor .option-column .field-row::-webkit-scrollbar{width:8px;height:8px}.sub-designer .sub-field-editor .option-column .field-row::-webkit-scrollbar-track{background:none;-webkit-border-radius:6px;border-radius:6px}.sub-designer .sub-field-editor .option-column .field-row::-webkit-scrollbar-track-piece{width:10px}.sub-designer .sub-field-editor .option-column .field-row::-webkit-scrollbar-thumb{-webkit-border-radius:6px;border-radius:6px;background:#bdbdbd}.sub-designer .sub-field-editor .option-column .field-row::-webkit-scrollbar-thumb:window-inactive{background:hsla(36,2%,59%,.3)}.sub-designer .sub-field-editor .option-column .input-wrapper{width:48%}.sub-designer .sub-field-editor .option-column .input-wrapper.value{margin-right:4%}.sub-designer .sub-field-editor .option-column .input-wrapper span{color:#000;margin:0;font-size:12px}.sub-designer .sub-field-editor .option-column input[type=text]{width:100%}.sub-designer .add-option-column{width:60px;height:100%;border-radius:8px;border:2px dashed #1c1c1c;display:block;flex:0 0 60px;color:#1c1c1c;padding:10px;text-align:center;white-space:normal;cursor:pointer;position:relative}.sub-designer .add-option-column:hover{background:rgba(28,28,28,.1)}.sub-designer .add-option-column .add-text{position:absolute;width:200px;height:30px;top:50%;left:0;margin-left:-66px;margin-top:-20px;transform:rotate(-90deg)}.sub-designer .subfield-drop{width:100%;display:block;padding:10px;border-radius:6px;border:2px dashed #1c1c1c;text-align:center;color:#1c1c1c;margin-top:10px;font-size:.9rem;font-weight:600}.sub-designer .subfield-drop.over{background:rgba(28,28,28,.1)}.pieces{display:flex;flex-flow:row wrap;width:100%;padding-top:40px}.pieces .filter-wrapper{display:block;position:absolute;top:0;left:0;width:100%;height:40px}.pieces .filter-wrapper .clear-filter{position:absolute;width:40px;height:40px;top:0;right:0;font-size:1.4rem;background:none;border:none;padding-top:5px;color:#1c1c1c;outline:none;cursor:pointer}.pieces .filter-wrapper .clear-filter:hover{color:#e6cb73}.pieces input.filter.filter{width:100%;height:40px;border-radius:0;border:none;background:none;font-size:1.2rem}.pieces input.filter.filter:hover{background:rgba(0,0,0,.03)}.pieces input.filter.filter:focus{background:rgba(0,0,0,.05)}.pieces .category{display:flex;flex-direction:row;flex-wrap:wrap;margin-bottom:10px;width:100%}.pieces .category h5{display:block;width:100%;margin-bottom:3px;font-size:.85rem;font-weight:600;background:#bbb;color:#3d3c3b;padding:5px;margin-bottom:8px}.visible{width:100%;height:1px;background:none;border:none;display:block}.piece-clone-wrapper{position:fixed;pointer-events:none;z-index:9999}@keyframes rotateIn{0%{transform:rotate(-7deg);opacity:0}30%{opacity:1}to{transform:rotate(7deg);opacity:1}}.piece{color:#3d3c3b;text-align:center;user-select:none;display:block;flex:0 0 33.3333%;padding:0 3px;margin-bottom:5px;cursor:move;cursor:grab;cursor:-moz-grab;cursor:-webkit-grab}.piece:hover .icon{background:#fff}.piece.clone{user-select:none;pointer-events:none;position:fixed;z-index:9999;border-radius:4px;overflow:hidden;animation:rotateIn .4s;animation-fill-mode:forwards;width:70px;background:transparent;padding:0;margin:0;-webkit-box-shadow:0 10px 20px 2px rgba(0,0,0,.4);-moz-box-shadow:0 10px 20px 2px rgba(0,0,0,.4);box-shadow:0 10px 20px 2px rgba(0,0,0,.4)}.piece.clone,.piece.clone .icon,.piece.clone .label{transition:none!important}.piece.clone .icon{height:50px;background:#e6cb73;color:#fff;border-radius:4px;font-size:1.7rem;display:block;width:100%;padding-top:11px;transition:background .2s}.piece.clone .label{color:#fff}.piece .grabbable{cursor:move;cursor:grab;cursor:-moz-grab;cursor:-webkit-grab}.piece .grabbable:active{cursor:grabbing;cursor:-moz-grabbing;cursor:-webkit-grabbing}.piece .icon{height:50px;background:#e4e4e3;border-radius:4px;font-size:1.7rem;display:flex;justify-content:center;align-items:center;width:100%;transition:background .2s}.piece .icon.icon-checkbox{font-size:1.6rem;padding-left:4px}.piece .icon.icon-paragraph{font-size:1.65rem}.piece .icon.svg-icon{padding:5px}.piece .icon.svg-icon svg{max-height:100%}.piece .label{color:#3d3c3b;font-weight:600;font-size:10.5px;display:block;margin-top:3px;line-height:13px;transition:color .2s;width:100%}.no-cursor{cursor:none!important}.preview-toolbar{width:100%;display:inline-block;top:0;left:0;height:40px;background:hsla(0,0%,93%,.38);padding:5px;position:absolute;-webkit-box-shadow:0 3px 4px 0 rgba(0,0,0,.1);-moz-box-shadow:0 3px 4px 0 rgba(0,0,0,.1);box-shadow:0 3px 4px 0 rgba(0,0,0,.1);z-index:11}.preview-toolbar button .icon{margin-top:2px;vertical-align:top}.wizard.preview-wizard{margin-top:33px}.wizard.preview-wizard .wrapper .body{height:calc(100vh - 175px - 100px)}.designer-wizard{display:block;width:100%;max-width:1000px;margin:0 auto;position:relative;border-radius:7px;-webkit-box-shadow:0 3px 5px 0 rgba(0,0,0,.3);-moz-box-shadow:0 3px 5px 0 rgba(0,0,0,.3);box-shadow:0 3px 5px 0 rgba(0,0,0,.3)}.designer-wizard .wiz-sidebar{display:inline-block;position:absolute;height:100%;background:-webkit-linear-gradient(115deg,#000,#1c1c1c);background:-moz-linear-gradient(115deg,#000,#1c1c1c);background:-o-linear-gradient(115deg,#000,#1c1c1c);background:linear-gradient(335deg,#000,#1c1c1c);color:#fff;width:200px;border-top-left-radius:5px;border-bottom-left-radius:5px;padding:20px 15px;z-index:9}.designer-wizard .wiz-sidebar .is-over{width:100%;background:none}.designer-wizard .wiz-sidebar .step-button-wrapper{position:relative}.designer-wizard .wiz-sidebar .step-button-drop-trigger{position:absolute;left:0;top:0;width:100%;height:50%;z-index:99}.designer-wizard .wiz-sidebar .step-button{border:none;border-radius:3px;background:none;color:#fff;width:100%;text-align:left;padding:6px;padding-left:8px;position:relative;cursor:pointer;min-height:28px;margin-bottom:5px;text-overflow:ellipsis;font-family:Open Sans,sans-serif;user-select:none;transition:outline-offset .2s;outline:3px solid rgba(191,164,75,0);outline-offset:7px}.designer-wizard .wiz-sidebar .step-button:focus{outline-color:rgba(191,164,75,.3);outline-offset:0}.designer-wizard .wiz-sidebar .step-button.placeholder{background:none!important}.designer-wizard .wiz-sidebar .step-button.is-dragging,.designer-wizard .wiz-sidebar .step-button:hover{background:#303030}.designer-wizard .wiz-sidebar .step-button.active{background:-webkit-linear-gradient(210deg,#e6cb73,#7d7150);background:-moz-linear-gradient(210deg,#e6cb73,#7d7150);background:-o-linear-gradient(210deg,#e6cb73,#7d7150);background:linear-gradient(240deg,#e6cb73,#7d7150);box-shadow:0 5px 7px rgba(0,0,0,.2);z-index:9;margin-left:-25px;padding-left:33px;width:calc(100% + 28px)}.designer-wizard .wiz-sidebar .step-button.active .reorder{display:block;background:#fff;color:#1c1c1c;width:19px;height:19px;padding:0;padding-left:1px;text-align:center;padding-bottom:2px;right:-11px}.designer-wizard .wiz-sidebar .step-button.active .reorder:hover{background:#eeeeec}.designer-wizard .wiz-sidebar .step-button.active .reorder.down{padding-bottom:0;padding-top:2px;bottom:-10px}.designer-wizard .wiz-sidebar .step-button.active .reorder.up{top:-10px}.designer-wizard .wiz-sidebar .step-button.selected{border:3px solid #ffeeaf;padding-left:30px;padding-top:3px;min-height:25px}.designer-wizard .wiz-sidebar .step-button.disabled{color:hsla(0,0%,100%,.3);cursor:default}.designer-wizard .wiz-sidebar .step-button.disabled:hover{background:none}.designer-wizard .wiz-sidebar .step-button.dragging{position:fixed;pointer-events:none;width:auto;padding-left:15px;padding-right:15px}.designer-wizard .wiz-sidebar .step-button.is-dragging:hover{background:none}.designer-wizard .wiz-sidebar .drag-spacer{transition:height .2s}.designer-wizard .wiz-sidebar .add-step{border:2px dashed hsla(0,0%,100%,.5);background:none;padding:2px;padding-left:8px}.designer-wizard .wiz-sidebar .add-step:hover{background:hsla(0,0%,100%,.2)}.designer-wizard .wiz-body{height:100%;min-height:500px;width:100%;padding:20px 20px 20px 220px;background:#eee;border-radius:5px}.designer-wizard .wiz-body .section{position:relative;width:100%;padding:10px;padding-right:0;margin:-10px;margin-bottom:0}.designer-wizard .wiz-body .section.active{background:#ffeeaf;padding-right:15px;width:calc(100% + 15px);z-index:99}.designer-wizard .wiz-body .section.active h4:hover{background:none}.designer-wizard .wiz-body .section.active .reorder{display:block}.designer-wizard .wiz-body .section:nth-last-child(2) .bottom-divider{opacity:0;margin:0;padding:0}.designer-wizard .wiz-body .section .description{font-size:13px;font-style:italic;margin:-5px 0 4px;display:block}.designer-wizard .wiz-body .section .description p{margin:0;font-size:13px}.designer-wizard .wiz-body .section .description p strong{font-weight:800}.designer-wizard .wiz-body .section h4{margin:-5px -10px;padding:5px 10px;margin-bottom:5px;color:#1c1c1c;font-weight:700;font-size:1rem;cursor:pointer;border-radius:6px;position:relative}.designer-wizard .wiz-body .section h4:hover{background:#fff3c9}@media only screen and (max-width:768px){.designer-wizard .wiz-body .section{padding-right:0}}.designer-wizard .wiz-body .section .bottom-divider{margin-top:10px}.designer-wizard .wiz-body .add-section{width:100%;padding:6px 12px;text-align:center;border:2px dashed #1c1c1c;color:#1c1c1c;background:none;border-radius:6px;font-weight:700;font-family:Open Sans,sans-serif;transition:outline-offset .2s;outline:3px solid rgba(191,164,75,0);outline-offset:7px}.designer-wizard .wiz-body .add-section:focus{outline-color:rgba(191,164,75,.3);outline-offset:0}.designer-wizard .wiz-body .add-section:hover{background:rgba(28,28,28,.15)}.sub-section{background:#dadada;padding:15px;border-radius:6px;margin-bottom:20px}.sub-section.required:before{content:\"*\";position:absolute;right:15px;top:13px;color:red}.history-panel{padding-top:50px;flex-direction:column;color:#000;font-size:14px}.history-panel .error{color:#c01027;font-style:italic;font-weight:700;text-align:center}.history-panel .error:before{content:\"* \"}.history-panel .revision-panel{background-color:#d5d5d5;margin:2px auto;border-radius:5px;padding:5px;width:90%}.history-panel .revision-panel.active{background:rgba(67,145,237,.31)}.history-panel .revision-panel.active .revision-header button{background-color:#255983;color:#fff}.history-panel .revision-panel.active .revision-header button:disabled{background-color:#6395be;color:#ccc}.history-panel .revision-panel .revision-header{display:flex;flex-direction:row;align-items:center;justify-content:space-between;padding-bottom:5px}.history-panel .revision-panel .revision-header h4{font-weight:700;display:flex}.history-panel .revision-panel .revision-header button{margin:2px 5px;background-color:#bfbfbf;border:none;border-radius:4px;font-weight:700;font-size:.7rem}.history-panel .revision-panel .revision-info{font-style:italic;line-height:1.4em;font-size:.8rem}.history-panel .loader-wrapper{margin-top:50px}.audit-panel,.designer-panel,.history-panel{display:flex;width:100%;padding-bottom:10px}.audit-panel input,.designer-panel input,.history-panel input{display:inline-block}.audit-panel textarea,.designer-panel textarea,.history-panel textarea{resize:vertical}.audit-panel .title,.designer-panel .title,.history-panel .title{font-size:18px;margin:0;text-align:center;display:block;padding-top:10px;padding-bottom:10px;background:#1c1c1c;color:#fff;min-height:40px;position:absolute;top:0;left:0;width:100%}.audit-panel .title[data-interactive=true],.designer-panel .title[data-interactive=true],.history-panel .title[data-interactive=true]{cursor:default;user-select:none;transition:outline-offset .2s;outline:3px solid rgba(191,164,75,0);outline-offset:7px}.audit-panel .title[data-interactive=true]:hover,.designer-panel .title[data-interactive=true]:hover,.history-panel .title[data-interactive=true]:hover{background:#292929}.audit-panel .title[data-interactive=true]:active,.designer-panel .title[data-interactive=true]:active,.history-panel .title[data-interactive=true]:active{background:#2e2e2e}.audit-panel .title[data-interactive=true]:focus,.designer-panel .title[data-interactive=true]:focus,.history-panel .title[data-interactive=true]:focus{outline-color:rgba(191,164,75,.3);outline-offset:0}.audit-panel .pieces,.designer-panel .pieces,.history-panel .pieces{width:100%;padding:5px;padding-top:45px;display:flex;flex-direction:column;overflow-y:auto}.audit-panel .pieces .audit-logs,.designer-panel .pieces .audit-logs,.history-panel .pieces .audit-logs{padding-top:5px}.audit-panel .pieces .audit-log-card:focus,.designer-panel .pieces .audit-log-card:focus,.history-panel .pieces .audit-log-card:focus{outline:none}.audit-panel .panel-section,.designer-panel .panel-section,.history-panel .panel-section{background:hsla(36,2%,59%,.2);padding:15px 5px;padding-top:30px;margin:10px -5px 5px;position:relative;max-width:calc(100% + 10px)}.audit-panel .panel-section h4,.designer-panel .panel-section h4,.history-panel .panel-section h4{background:rgba(28,28,28,.1);font-weight:600;font-style:italic;font-size:.8rem;position:absolute;left:0;top:0;width:100%;padding:7px;cursor:pointer;user-select:none}.audit-panel .panel-section h4:hover .toggle,.designer-panel .panel-section h4:hover .toggle,.history-panel .panel-section h4:hover .toggle{opacity:1}.audit-panel .panel-section h4 .toggle,.designer-panel .panel-section h4 .toggle,.history-panel .panel-section h4 .toggle{position:absolute;right:6px;top:10px;opacity:0}.audit-panel .attribute-wrapper,.designer-panel .attribute-wrapper,.history-panel .attribute-wrapper{width:100%;display:block}.audit-panel .attribute-button,.designer-panel .attribute-button,.history-panel .attribute-button{width:100%;display:flex;justify-content:center;align-items:center;border:none;background:#1c1c1c;padding:8px 5px;color:#fff;border-radius:4px;font-family:Open Sans,sans-serif;font-weight:600;transition:outline-offset .2s;outline:3px solid rgba(191,164,75,0);outline-offset:7px}.audit-panel .attribute-button .icon,.designer-panel .attribute-button .icon,.history-panel .attribute-button .icon{width:20px;margin-right:5px}.audit-panel .attribute-button:hover,.designer-panel .attribute-button:hover,.history-panel .attribute-button:hover{background:#333}.audit-panel .attribute-button:focus,.designer-panel .attribute-button:focus,.history-panel .attribute-button:focus{outline-color:rgba(191,164,75,.3);outline-offset:0}.audit-panel .attribute-button.danger,.designer-panel .attribute-button.danger,.history-panel .attribute-button.danger{background:#c01027}.audit-panel .attribute-button.danger:hover,.designer-panel .attribute-button.danger:hover,.history-panel .attribute-button.danger:hover{background:#ea1430}.audit-panel .attribute-button.delete,.designer-panel .attribute-button.delete,.history-panel .attribute-button.delete{margin-top:0}.audit-panel .attribute-button.validation-button,.designer-panel .attribute-button.validation-button,.history-panel .attribute-button.validation-button{margin-top:2px}.audit-panel .attribute-button .rules-flag,.designer-panel .attribute-button .rules-flag,.history-panel .attribute-button .rules-flag{font-size:11px;width:14px;height:14px;border-radius:100%;color:#1c1c1c;background:#fff;padding-top:0;vertical-align:top;margin-top:2px;margin-right:4px;font-weight:700;font-family:Open Sans,sans-serif;display:inline-block;line-height:.9rem}.audit-panel .markdown-instructions,.designer-panel .markdown-instructions,.history-panel .markdown-instructions{font-size:10px;margin-top:-3px;margin-bottom:-7px;display:block;color:#888;z-index:99}.audit-panel .sub-header-label-input,.designer-panel .sub-header-label-input,.history-panel .sub-header-label-input{padding-left:35px}.audit-panel .audit-logs,.designer-panel .audit-logs,.history-panel .audit-logs{display:flex;flex-direction:column;align-items:center;padding:5px;padding-top:45px;width:100%}.audit-panel .audit-log-card,.designer-panel .audit-log-card,.history-panel .audit-log-card{width:100%;padding:10px;border-radius:5px;background:#fff;margin-bottom:5px;background:#ebf5ff;overflow:hidden;cursor:default;box-shadow:0 1px 3px rgba(0,0,0,.12),0 1px 2px rgba(0,0,0,.24);transition:outline-offset .2s;outline:3px solid rgba(191,164,75,0);outline-offset:7px}.audit-panel .audit-log-card:focus,.designer-panel .audit-log-card:focus,.history-panel .audit-log-card:focus{outline-color:rgba(191,164,75,.3);outline-offset:0}.audit-panel .audit-log-card:hover,.designer-panel .audit-log-card:hover,.history-panel .audit-log-card:hover{background:#fafdff}.audit-panel .audit-log-card:hover h4,.designer-panel .audit-log-card:hover h4,.history-panel .audit-log-card:hover h4{background:#e1f0ff}.audit-panel .audit-log-card h4,.designer-panel .audit-log-card h4,.history-panel .audit-log-card h4{font-size:13px;font-weight:600;background:#d2e9ff;margin:-10px -10px 5px;padding:7px 10px;padding-right:26px;position:relative}.audit-panel .audit-log-card h4 button,.designer-panel .audit-log-card h4 button,.history-panel .audit-log-card h4 button{position:absolute;right:0;top:0;padding:5px 7px;padding-top:6px;padding-bottom:4px;background:none;border:none}.audit-panel .audit-log-card h4 .caret,.designer-panel .audit-log-card h4 .caret,.history-panel .audit-log-card h4 .caret{width:14px}.audit-panel .audit-log-card p,.designer-panel .audit-log-card p,.history-panel .audit-log-card p{font-style:italic;font-size:13px;line-height:1.2}.audit-panel .audit-log-card-footer,.designer-panel .audit-log-card-footer,.history-panel .audit-log-card-footer{display:flex;flex-direction:column;align-items:flex-end;text-align:right;padding-top:10px;font-size:11px;font-weight:600}.audit-panel .audit-log-card-footer-token,.designer-panel .audit-log-card-footer-token,.history-panel .audit-log-card-footer-token{margin-bottom:3px}.audit-panel .audit-log-card-footer-token:last-child,.designer-panel .audit-log-card-footer-token:last-child,.history-panel .audit-log-card-footer-token:last-child{margin-bottom:0}.audit-panel .audit-log-card.warning,.designer-panel .audit-log-card.warning,.history-panel .audit-log-card.warning{background:#fffaeb;color:#523e00}.audit-panel .audit-log-card.warning h4,.designer-panel .audit-log-card.warning h4,.history-panel .audit-log-card.warning h4{background:#fff4d2}.audit-panel .audit-log-card.warning:hover,.designer-panel .audit-log-card.warning:hover,.history-panel .audit-log-card.warning:hover{background:#fffdf5}.audit-panel .audit-log-card.warning:hover h4,.designer-panel .audit-log-card.warning:hover h4,.history-panel .audit-log-card.warning:hover h4{background:#fff7e1}.audit-panel .audit-log-card.critical,.designer-panel .audit-log-card.critical,.history-panel .audit-log-card.critical{background:#ffeded;color:#a10000}.audit-panel .audit-log-card.critical h4,.designer-panel .audit-log-card.critical h4,.history-panel .audit-log-card.critical h4{background:#ffd4d4}.audit-panel .audit-log-card.critical:hover,.designer-panel .audit-log-card.critical:hover,.history-panel .audit-log-card.critical:hover{background:#fff2f2}.audit-panel .audit-log-card.critical:hover h4,.designer-panel .audit-log-card.critical:hover h4,.history-panel .audit-log-card.critical:hover h4{background:#ffe3e3}.audit-panel .audit-empty-state,.designer-panel .audit-empty-state,.history-panel .audit-empty-state{display:flex;width:100%;text-align:left;align-items:center;padding-left:10px;padding-right:10px;padding-top:13px}.audit-panel .audit-empty-state.audit-crashed .check-icon,.designer-panel .audit-empty-state.audit-crashed .check-icon,.history-panel .audit-empty-state.audit-crashed .check-icon{background:#ed0000;padding:10px}.audit-panel .audit-empty-state.audit-crashed h3,.audit-panel .audit-empty-state.audit-crashed p,.designer-panel .audit-empty-state.audit-crashed h3,.designer-panel .audit-empty-state.audit-crashed p,.history-panel .audit-empty-state.audit-crashed h3,.history-panel .audit-empty-state.audit-crashed p{color:#ba0000}.audit-panel .audit-empty-state h3,.designer-panel .audit-empty-state h3,.history-panel .audit-empty-state h3{font-size:18px;font-weight:600;color:#15aa47;margin-bottom:5px;animation-delay:.2s}.audit-panel .audit-empty-state p,.designer-panel .audit-empty-state p,.history-panel .audit-empty-state p{color:#149540;font-size:14px;animation-delay:.3s}.audit-panel .audit-empty-state .check-icon,.designer-panel .audit-empty-state .check-icon,.history-panel .audit-empty-state .check-icon{width:50px;height:50px;border-radius:100%;background:#28d161;color:#fff;padding:3px;padding-left:5px;padding-right:9px;padding-top:8px;flex:0 0 auto;margin-right:10px}.options-editor{display:flex;flex-direction:column;height:calc(100% - 80px);border-radius:0 0 4px 4px;width:100%;font-size:14px;padding:10px;background:#eeeeec;overflow-y:auto}.options-editor .options-editor-header{width:100%;display:block}.options-editor .options-editor-header div{width:43%;font-size:12px}.options-editor .options-editor-header div.value-header{margin-right:2%}.options-editor .option-wrapper{display:flex;flex-direction:row;margin-bottom:5px;flex:0 0 auto}.options-editor .option-wrapper button{background:none;border:none;padding:0;padding-right:5px}.options-editor .option-wrapper button svg.svg-icon{width:15px}.options-editor .option-wrapper input{flex:1 1 auto;display:inline-block;height:30px;padding:5px;margin:0;border-radius:4px;border:2px solid #d2cfcf}.options-editor .option-wrapper input:first-of-type{margin-right:5px}.options-editor .option-wrapper .delete-button{display:flex;justify-content:center;align-items:center;margin-right:5px}.options-editor .option-wrapper .svg-icon{width:12px}.options-editor .option-wrapper:hover .delete-button{opacity:1}.options-editor .add-option{margin-top:10px;flex:0 0 auto}.options-editor .option-value{margin-right:3%}.options-editor .option-value:disabled{cursor:not-allowed}.delete-button{position:relative;border:none;background:#c01027;color:#fff;padding:6px 9px 5px 8px;margin-top:1px;border-radius:4px;font-size:12px;margin-right:12px}.delete-button:hover{background:#d8122c}.delete-button:disabled{opacity:.2}.delete-button:disabled:hover{background:#c01027}.meta-head .key-head.key-head{padding-left:50px;width:54%}.meta-head .value-head.value-head{width:46%}.attribute-add{border:2px dashed #1c1c1c;border-radius:5px;background:none;display:block;width:100%;margin-top:10px}.attribute-add:hover{background:rgba(28,28,28,.1)}.dummy-field .dummy-field{outline:none}.dummy-field .dummy-field:hover{background:none}.dummy-field{width:100%;display:block;width:calc(100% + 20px);margin:0 -10px 5px;padding:10px;padding-bottom:5px;border-radius:6px;position:relative;cursor:pointer;font-size:.9rem;transition:box-shadow .3s,transform .3s}.dummy-field.custom-focus{transition:box-shadow .3s,transform .3s,outline-offset .2s}.dummy-field.active{background:#ffeeaf!important;z-index:99}.dummy-field.active .reorder{display:block}.dummy-field.active .icons-wrapper .designer-icon-wrapper{background:#ffeeaf}.dummy-field:hover,.dummy-field:hover:not(.active) .icons-wrapper .designer-icon-wrapper{background:#fff3c9}.dummy-field.sub-field.active,.dummy-field.sub-field:hover{background:none}.dummy-field.hovered{box-shadow:0 10px 20px rgba(0,0,0,.19),0 6px 6px rgba(0,0,0,.23);background:#fff3c9;transform:scale(1.02)}.dummy-field .audit-icon{position:absolute;left:-6px;top:0;z-index:9}.dummy-field .icons-wrapper{position:absolute;width:auto;height:24px;display:flex;flex-direction:row;right:4px;top:0;color:#1c1c1c;z-index:2}.dummy-field .icons-wrapper .designer-icon-wrapper{border-radius:14px;width:24px;height:24px;background:#eee;flex:0 0 auto;margin-left:2px}.dummy-field .icons-wrapper .link-icon{padding:2px}.dummy-field .icons-wrapper .logic-icon{padding:3px}.dummy-field .inactive-shade{position:absolute;left:0;top:0;width:100%;height:100%;border-radius:6px;background:linear-gradient(rgba(0,0,0,.35),transparent);z-index:9;pointer-events:none}.dummy-field .description{font-size:11px;font-style:italic;margin:-2px 0 4px}.dummy-field .description p{margin:0}.dummy-field .field-label{font-weight:400;display:inline-block;position:relative}.dummy-field .text{height:30px;padding-left:10px;padding-right:10px;padding-top:8px;margin-bottom:5px;border:3px solid #c3c3c3;border-radius:5px;height:35px;background:#fff;display:block;position:relative}.dummy-field .text,.dummy-field .text .value{width:100%;overflow:hidden;text-overflow:ellipsis}.dummy-field .text .value{height:25px;white-space:nowrap}.dummy-field .text .placeholder{color:#aaa;height:25px;width:100%;overflow:hidden;text-overflow:ellipsis;white-space:nowrap}.dummy-field .text.disabled{background:#dad9d7}.dummy-field .select{overflow:hidden;text-overflow:ellipsis;padding-right:10px}.dummy-field .select:after{right:7px;top:11px;font-size:10px;position:absolute;content:\"\\E91E\";display:inline-block;font-family:icomoon;font-style:normal;font-weight:400;font-size:.5rem;line-height:1;-webkit-font-smoothing:antialiased}.dummy-field .select.disabled{background:#dad9d7}.dummy-field .radio{width:100%;display:block;margin-top:5px;margin-bottom:5px;padding-left:7px}.dummy-field .radio.left-align{display:flex;flex-direction:row;justify-content:flex-start}.dummy-field .radio.left-align .radio-option{flex:0 0 auto;width:auto;margin-bottom:0;margin-right:25px;display:flex;flex-direction:row}.dummy-field .radio.left-align .radio-option .radio-label{display:flex;max-width:none}.dummy-field .radio .radio-option{width:100%;display:block;margin:5px 0}.dummy-field .radio .radio-option .radio-control{width:20px;height:20px;border-radius:10px;border:3px solid #c3c3c3;background:#fff;margin-right:6px;display:inline-block}.dummy-field .radio .radio-option .radio-control.disabled{background:#d8d6d4}.dummy-field .radio .radio-option .radio-label{vertical-align:top;display:inline-block;margin-top:3px;max-width:calc(100% - 28px);line-height:1rem}.dummy-field .date{padding-left:26px}.dummy-field .date:after{content:\"\\E907\";position:absolute;left:7px;top:7px;display:inline-block;font-family:icomoon!important;font-style:normal!important;font-weight:400!important;font-variant:normal!important;text-transform:none!important;speak:none;line-height:1;-webkit-font-smoothing:antialiased;pointer-events:none}.dummy-field .date.disabled{background:#d8d6d4}.dummy-field input[type=file].dummy-file{pointer-events:none}.dummy-field .dummy-address-block .row{margin-bottom:5px}.dummy-field .dummy-address-block div[class*=col]{padding-right:5px}.dummy-field .dummy-address-block div[class*=col]:last-child{padding-right:0}.dummy-field .dummy-server-search .field-wrapper{display:inline-block;padding-right:10px}.dummy-field .dummy-server-search .search-button{flex:1 1 auto;background:#303030;border-color:#0f0f0f;color:#fff;text-shadow:0 1px 0 rgba(0,0,0,.7);width:100%}.dummy-field .dummy-server-search .search-button:hover{background:#3a3a3a}.dummy-field .dummy-server-search .search-button:active{background:#282828;color:#fff;text-shadow:0 1px 0 rgba(0,0,0,.7)}.dummy-field .dummy-server-search .search-button:hover{background:#303030;color:#fff}.dummy-field .dummy-checkbox{display:flex;flex-direction:row}.dummy-field .dummy-checkbox .dummy-box{flex:0 0 20px;width:20px;height:20px;border:3px solid #c3c3c3;background:#fff;border-radius:5px;cursor:pointer;padding:2px;display:inline-block}.dummy-field .dummy-checkbox .dummy-box .check{background:#1c1c1c;width:10px;height:10px;border-radius:3px;display:block}.dummy-field .dummy-checkbox .dummy-box.disabled{background:#d8d6d4}.dummy-field .dummy-checkbox .label-text{display:inline-block;vertical-align:top;font-weight:600;margin-left:5px;margin-top:2px;line-height:1.4}.dummy-field .dummy-checkbox .label-text .required{color:red;padding-left:2px}.dummy-field .dummy-date-wrapper button{height:34px;margin-left:8px;padding-left:7px;padding-right:7px}.dummy-field .dummy-date-wrapper .calendar{padding:0;width:34px}.dummy-field .dummy-date-wrapper .center-wrapper{display:flex;flex-direction:row;justify-content:center;align-items:center;height:100%;width:100%}.dummy-field p,.dummy-field pre{display:block;width:100%;font-size:13px}.dummy-field .label-text{position:relative;margin-bottom:5px;display:inline-block;font-weight:600;font-size:.8rem}.dummy-field .label-text.required:after{color:red;font-size:.8rem;margin-left:2px;content:\"*\";position:absolute;right:-10px;top:2px}.dummy-field.is-dragging{background:none!important;z-index:auto}.dummy-field.is-dragging .reorder{display:none}.field-drop-spacer{width:100%;opacity:0;transition:height .4s,opacity .4s;border-radius:8px;display:flex;justify-content:center;align-items:center;background:rgba(28,28,28,.1);overflow:hidden}.field-drop-spacer.is-over-spacer{opacity:1;overflow:visible}.field-drop-spacer .drop-hint{font-size:1rem;font-weight:600;color:#1c1c1c}.droppable-field-wrapper{display:flex;flex-direction:column;position:relative}.droppable-field-wrapper .droppable-field-overlay{position:absolute;left:0;width:100%;height:50%;z-index:9}.droppable-field-wrapper .droppable-field-overlay.up{top:0}.droppable-field-wrapper .droppable-field-overlay.down{bottom:0}.checkbox-label .tip,.field-label .tip,.field .tip{background:#1c1c1c;color:#fff;border-radius:15px;width:14px;height:14px;padding-left:5px;line-height:16px;font-size:12px;font-weight:700;margin-left:4px;display:inline-block}.block-wrapper{display:block}.reorder{width:22px;height:22px;background:#1c1c1c;border:none;box-shadow:0 3px 4px rgba(0,0,0,.3);color:#fff;border-radius:16px;text-align:center;padding:3px;position:absolute;right:-9px;display:none;font-size:.4rem;z-index:9;transition:outline-offset .2s;outline:3px solid rgba(191,164,75,0);outline-offset:7px}.reorder:hover{background:#424242}.reorder:focus{outline-color:rgba(191,164,75,.3);outline-offset:0}.reorder.up{top:-9px;padding-top:2px}.reorder.down{bottom:-9px}.attribute{cursor:default;width:100%;margin:0;padding:10px;padding-top:5px;padding-bottom:5px}.attribute:hover{background:none}.attribute input,.attribute select{color:#000}.attribute .check-label.check-label.check-label{display:inline-block;margin-left:5px;vertical-align:top;max-width:calc(100% - 30px);margin-top:2px;margin-bottom:2px}.attribute textarea{width:100%;padding:5px;border:3px solid #c3c3c3;border-radius:5px;margin-bottom:4px}.attribute textarea:focus{outline:none;border-color:#82cae8}.attribute .checkbox-wrapper{margin-top:0;display:flex;align-items:center}.attribute .checkbox-wrapper .checkbox-label.checkbox-label.checkbox-label{margin-top:4px}.attribute.logic-controlled{background:rgba(28,28,28,.2)}.attribute.logic-controlled:hover .logic-tip{opacity:1}.attribute .round-icon-wrapper{width:15px;height:15px;border-radius:100%;color:#1c1c1c;background:#fff;right:-4px;top:-4px;padding:3px;padding-bottom:4px;z-index:9}.attribute .logic-tip,.attribute .round-icon-wrapper{display:flex;justify-content:center;align-items:center;position:absolute}.attribute .logic-tip{left:0;top:0;width:100%;height:100%;background:rgba(28,28,28,.8);color:#fff;border-radius:4px;z-index:8;text-align:center;opacity:0;transition:opacity .2s;font-size:12px;font-weight:600;padding:3px 15px;cursor:not-allowed}@supports (backdrop-filter:blur(4px)){.attribute .logic-tip{backdrop-filter:blur(4px);background:rgba(0,0,0,.6)}}.attribute-warning{font-size:10px;background:#fbe584;color:#a37d1a;padding:4px;border-radius:5px;margin-top:4px}.no-pointer-events *{pointer-events:none!important}.drag-mask{position:relative;width:100%;height:60px;border-radius:6px;z-index:9}.drag-mask .field-drop{display:block;height:50px;border-radius:6px;border:2px dashed #1c1c1c;color:#1c1c1c;text-align:center;font-weight:600;padding:16px 12px;z-index:99}.drag-mask .field-drop:hover{background:rgba(28,28,28,.1)}.validation-editor{display:block;width:100%;max-width:800px;position:relative;height:calc(100% - 51px);margin:0 auto;padding:15px;background:#fff;border-bottom-left-radius:5px;border-bottom-right-radius:5px}.validation-editor input{display:inline-block}.validation-editor .rule-container{padding-right:15px}.validation-editor .attribute-container{position:absolute;width:50%;height:100%;right:0;top:0;background:#ddd;border-radius:0 7px 7px 0;border-bottom-right-radius:5px}.validation-editor .rule{padding:7px 10px;background:#ccc;color:#222;margin-bottom:5px;border-radius:3px;transition:all .2s;font-size:.9rem;display:flex;flex-direction:row;align-items:center}.validation-editor .rule.checked{background:#1c1c1c;color:#fff;cursor:pointer}.validation-editor .rule.checked .deprecated{color:#fff}.validation-editor .rule.checked:hover{background:#363636}.validation-editor .rule.selected{background:#ffeeaf!important;color:#222}.validation-editor .rule.selected .deprecated{color:#9c1a25}.validation-editor .rule .rule-name{margin-left:6px;line-height:1.1rem;display:inline-block}.validation-editor .rule .deprecated{color:#9c1a25;font-size:.75rem;font-style:italic;vertical-align:top}.modal-head .head{width:50%;min-height:28px;display:inline-block;border-bottom:1px solid #b0b0b0;margin-bottom:1px;background:#c9c9c9;padding:5px 10px;border-right:1px solid #bcbcbc;font-size:12px;vertical-align:top}.pairs{overflow-x:hidden;overflow-y:auto;max-height:496px}.pairs .pair{margin-bottom:5px}.pairs .pair input{width:calc(50% - 30px);display:inline-block;font-size:14px}.pairs .pair .key{margin-right:2%}.pairs button.add-pair{width:100%;padding:5px 10px;border-radius:3px;background:#fff;border:2px dashed #1c1c1c;font-size:14px;margin-top:10px}.pairs button.add-pair:hover{background:rgba(28,28,28,.2)}.text-editor-wrapper{display:flex;flex-direction:row;height:calc(100% - 51px)}.text-editor-wrapper .left-wrapper{flex:0 0 50%}.text-editor-wrapper .left-wrapper.merge-codes{display:flex;flex-direction:column}.text-editor-wrapper .left-wrapper.merge-codes .toolbar{padding:10px;background:#e4e4e3;border-right:1px solid #e4e4e3;display:flex;flex-direction:row}.text-editor-wrapper .left-wrapper.merge-codes .toolbar button{margin-right:5px}.text-editor-wrapper .left-wrapper.merge-codes .toolbar button:last-child{margin-right:0}.text-editor-wrapper .left-wrapper.merge-codes .text-editor{height:auto;flex-grow:1}.text-editor-wrapper .left-wrapper.merge-codes .hint{padding-bottom:4px}.text-editor-wrapper .right-wrapper{flex:0 0 50%;padding:15px;background:#eeeeec;overflow-y:auto}.text-editor{display:block;width:100%;height:calc(100% - 43px);font-size:14px;padding:15px;border:none;border-radius:0;resize:none}.hint{display:flex;align-items:center;flex-wrap:wrap;font-size:.65rem;color:#444;padding-top:2px;-webkit-box-shadow:0 -2px 6px 0 rgba(0,0,0,.2);-moz-box-shadow:0 -2px 6px 0 rgba(0,0,0,.2);box-shadow:0 -2px 6px 0 rgba(0,0,0,.2)}.hint span{padding:4px 7.5px}.input-range{margin-bottom:10px;margin-top:10px}.input-range .input-range__label--max,.input-range .input-range__label--min{bottom:-.7rem}.input-range .input-range__label--value{top:-22px}.form-table{width:100%;border-collapse:separate;border-spacing:0}.form-table.disabled thead{opacity:.8}.form-table.disabled tbody tr{background:#ddd}.form-table thead{background:#1c1c1c;color:#fff}.form-table thead th{padding:5px 10px;font-size:13px}.form-table thead th:first-child{border-radius:4px 0 0 0}.form-table thead th:last-child{border-radius:0 4px 0 0}.form-table tbody tr{background:#fff}.form-table tbody tr:nth-child(2n) td{background:rgba(28,28,28,.1)}.form-table tbody tr:nth-child(2n) td:nth-child(2n){background:rgba(28,28,28,.2)}.form-table tbody tr:last-child{border-radius:0 0 5px 5px}.form-table tbody tr:last-child td:first-child{border-bottom-left-radius:5px}.form-table tbody tr:last-child td:last-child{border-bottom-right-radius:5px}.form-table tbody tr:hover .row-controls{opacity:1;right:0}.form-table tbody td{padding:5px 9px;position:relative}.form-table tbody td:nth-child(2n){background:rgba(28,28,28,.1)}button.form-button{margin-top:10px;background:#303030;border-color:#0f0f0f;color:#fff;text-shadow:0 1px 0 rgba(0,0,0,.7);width:100%}button.form-button:hover{background:#3a3a3a}button.form-button:active{background:#282828;color:#fff;text-shadow:0 1px 0 rgba(0,0,0,.7)}button.form-button:focus,button.form-button:hover{color:#fff}button.form-button.secondary{background:#bfbfbf;border-color:#9e9e9e;color:#222;text-shadow:0 1px 0 hsla(0,0%,100%,.7);width:100%}button.form-button.secondary:hover{background:#c9c9c9}button.form-button.secondary:active{background:#b7b7b7;color:#222;text-shadow:0 1px 0 hsla(0,0%,100%,.7)}.condition-editor{padding:15px;display:flex;flex-direction:column;max-height:calc(100% - 51px);overflow-y:auto}.condition-editor .warning{padding:15px;background:#fbe584;color:#614a0f;border:1px solid #f9d53a;border-radius:5px}.condition-editor .add-condition{width:100%;padding:7px;border-radius:6px;border:2px dashed #1c1c1c;cursor:pointer;background:none;font-family:Open Sans,sans-serif;font-weight:600;color:#1c1c1c;margin-top:5px}.condition-editor .add-condition:hover{background:rgba(28,28,28,.1)}.condition-editor .add-condition:active{background:rgba(28,28,28,.2)}.condition-editor .condition{padding:10px;padding-left:30px;position:relative}.condition-editor .condition .select{max-width:200px;margin-left:8px}.condition-editor .condition .delete{position:absolute;border-radius:4px;border:none;left:0;top:16px;width:25px;height:25px;display:flex;justify-content:center;align-items:center;font-size:1.4rem;padding:0;color:#fff;background:#c01027;font-weight:400;line-height:0;cursor:pointer}.condition-editor .condition .delete:hover{background:#ec1733}.dummy-search-col{display:flex;flex-direction:row;width:100%}.dummy-search-col .dummy-reg-search-input{flex:1 1 auto}.dummy-search-col button.search-button.search-button{pointer-events:none;flex:0 0 auto;margin-top:1px;margin-left:5px;max-width:100px;width:auto;display:flex;justify-content:center;align-items:center;padding-top:0;padding-bottom:0;height:32px;background:#1c1c1c}.dummy-search-col button.search-button.search-button .svg-icon{width:18px;margin-right:4px}.dummy-text-field.dummy-text-field.dummy-text-field{height:auto;padding:8px 10px}.dummy-text-field.dummy-text-field.dummy-text-field .value{overflow:visible;text-overflow:inherit;white-space:normal;height:auto;line-height:1.4}.attribute-import-button input{opacity:0;width:1px;height:1px;position:fixed;top:-1px;left:-1px}.attribute-import-button .attribute-button{font-size:.8rem;padding:11px 0}.merge-code-list{display:flex;flex-direction:column;overflow:auto;max-height:calc(100vh - 200px)}.merge-code-list .merge-code{padding:10px 15px;border:none;background:none;text-align:left;display:flex;flex-direction:row}.merge-code-list .merge-code:nth-child(2n){background:#eeeeec}.merge-code-list .merge-code:hover{background:rgba(191,164,75,.2)}.merge-code-list .merge-code .label{font-weight:600}.merge-code-list .merge-code .code{margin-left:auto;color:#999794;font-style:italic}.constraints-editor{width:100%;padding-top:10px}.constraints-editor .description{font-size:.8rem}.constraints-editor .error{color:#c01027;font-style:italic}.constraints-editor .error:before{content:\"* \"}.constraints-editor .add-constraint{padding:13px;border-radius:5px;background:none;color:#1c1c1c;border:2px dashed #1c1c1c;font-size:1rem;font-weight:600;width:100%}.constraints-editor .add-constraint:hover{background:rgba(28,28,28,.1)}.constraints-editor .constraints-row{display:flex;flex-direction:column;align-items:flex-start;padding:10px;background:#c9c7c4;border-radius:6px;margin-bottom:10px;position:relative}.constraints-editor .constraints-row:hover .delete-constraint{opacity:1}.constraints-editor .constraints-row .select-wrapper{margin-top:8px}.constraints-editor .constraints-row .select-wrapper:first-child{margin-top:0}.constraints-editor .constraints-row .select-wrapper label{font-weight:600}.constraints-editor .constraints-row select{max-width:260px}.constraints-editor .field-list{display:flex;flex-direction:row;flex-wrap:wrap}.constraints-editor .field-chip-wrapper{padding:3px;max-width:150px}.constraints-editor .field-chip{flex:0 0 auto;background:#e4e4e3;color:#3d3c3b;display:flex;justify-content:flex-start;align-items:center;text-align:center;font-weight:900;padding:5px 10px;font-size:.7rem;border-radius:3px;height:30px;white-space:nowrap;max-width:100%;text-overflow:ellipsis;position:relative;box-shadow:0 1px 3px rgba(0,0,0,.12),0 1px 2px rgba(0,0,0,.24)}.constraints-editor .field-chip:hover .delete-wrapper{opacity:1}.constraints-editor .field-chip .label{max-width:100%;overflow:hidden;text-overflow:ellipsis}.constraints-editor .delete-wrapper{position:absolute;left:0;top:0;width:100%;height:100%;background:#c01027;border-radius:4px;display:flex;justify-content:center;align-items:center;opacity:0;border:none;cursor:pointer}.constraints-editor .delete-chip{width:18px;height:18px;border-radius:100%;background:none;color:#fff;display:flex;justify-content:center;align-items:center;padding:3px}.constraints-editor .delete-chip .svg-icon{height:100%}.constraints-editor .error-message{width:calc(100% + 20px);background:rgba(0,0,0,.05);padding:10px;margin:8px -10px -10px;border-radius:0 0 4px 4px}.constraints-editor .error-message input{width:100%}.constraints-editor .delete-constraint{opacity:0;position:absolute;right:-5px;top:-5px;width:24px;height:24px;padding:5px;background:#c01027;color:#fff;border-radius:100%;border:none;box-shadow:0 3px 6px rgba(0,0,0,.16),0 3px 6px rgba(0,0,0,.23)}.constraints-editor .delete-constraint:hover{background:#ec1733}.constraints-editor .delete-constraint .svg-icon{width:100%}.ucc-search-modal{padding:10px}.ucc-search-modal .button-wrapper{display:flex;padding-bottom:10px}.ucc-search-modal .button-wrapper button{margin-left:10px}.ucc-search-modal .button-wrapper button:first-child{margin-left:0}.ucc-search-modal .checkbox-wrapper{justify-content:center}.ucc-search-modal .checkbox-wrapper .checkbox-label{display:none}.ucc-scrollable.ucc-scrollable.ucc-scrollable{max-height:calc(100% - 51px - 51px)}.ucc-toolbar{position:absolute;background:#eeeeec;box-shadow:0 -1px 5px rgba(0,0,0,.3);bottom:0;left:0;z-index:9;width:100%;height:51px;border-bottom-left-radius:7px;border-bottom-right-radius:7px;display:flex;justify-content:flex-start;align-items:center;flex-direction:row-reverse;padding-right:15px}.ucc-toolbar .helpful-tooltip{color:red;font-style:italic;margin-right:15px}.select-option-constrainer{display:flex;flex-direction:row;padding:5px 0;align-items:center}.select-option-constrainer label{width:60%}.panel-log-icon{background:hsla(0,0%,100%,.2);width:14px;height:14px;display:inline-flex;justify-content:center;align-items:center;border-radius:100%;color:#fff}.panel-log-icon.small{width:11px;height:11px}.panel-log-icon.small svg{width:9px;height:9px}.panel-log-icon.critical{background:#ba0000}.panel-log-icon.warning{background:#b88a00}.panel-log-icon svg{width:12px;height:12px}.log-hint-bar{width:6px;height:100%;position:absolute;left:-2px;top:0;background:rgba(255,33,33,.3);border-radius:6px}.log-hint-bar[data-severity=warning]{background:rgba(184,138,0,.4)}.flume-button{background:linear-gradient(0deg,#000,#050505);color:#fff;box-shadow:0 1px 0 rgba(0,0,0,.4);border:1px solid #000;border-top:1px solid #000;border-radius:4px;width:100%}.flume-button,.flume-button .rules-flag{display:flex;justify-content:center;align-items:center}.flume-button .rules-flag{width:14px;height:14px;background:#fff;color:#000;text-align:center;padding:0;border-radius:100%;line-height:0;margin-right:4px;font-weight:700;font-size:.9em}.flume-button:hover{background:linear-gradient(0deg,#050505,#0a0a0a);border-color:#000;border-top-color:#050505}.flume-calendar-input-wrapper{display:flex;flex-direction:column}.flume-calendar-input-wrapper input{width:100%;height:36px;background:linear-gradient(180deg,#5b5f62,#6f7477);border:1px solid #3c3e40;border-radius:4px;font-size:13px;padding:5px;resize:vertical;outline:none}.flume-calendar-input-wrapper input:disabled{color:#000}.flume-calendar-input-wrapper button:last-child{margin-right:0}.flume-calendar-input-wrapper .flume-button{width:auto}.global-logic-panel{display:flex;flex-direction:column;padding:10px;padding-top:50px}.global-logic-panel .logic-section{display:flex;flex-direction:column;margin-bottom:20px}.global-logic-panel .logic-section h2{color:#000;font-size:14px;border-bottom:2px solid #000;margin-bottom:12px;display:flex;align-items:center}.global-logic-panel .logic-section h2 .align-right{margin-left:auto}.global-logic-panel .logic-section .logic-add-button{text-align:center;border:none;color:#000;border-radius:4px;background:none;font-size:12px;font-weight:700;font-family:Open Sans,sans-serif;transition:outline-offset .2s;outline:3px solid rgba(191,164,75,0);outline-offset:7px}.global-logic-panel .logic-section .logic-add-button:hover{background:rgba(28,28,28,.15)}.global-logic-panel .logic-section .logic-add-button:focus{outline-color:rgba(191,164,75,.3);outline-offset:0}.global-logic-panel .logic-section .variable-row{margin-bottom:10px}.global-logic-panel .logic-section .variable-row input{flex:1 1 auto}.global-logic-panel .logic-section .variable-row button.attribute-button{width:auto;padding-left:10px;padding-right:10px;padding-top:5px;margin:1px 0;margin-left:10px;flex:0 0 auto}.global-logic-panel .logic-section .variable-row button.menu-button{background:none;border:none;border-radius:4px;margin:1px 2px 1px -5px}.global-logic-panel .logic-section .variable-row button.menu-button svg{width:auto;height:18px;margin-left:-8px;margin-right:-8px}.global-logic-panel .logic-section .variable-row button.menu-button:hover{background:#bebebc}.logic-editor-wrapper.logic-editor-wrapper.logic-editor-wrapper p{margin-bottom:unset}.custom-business-rules{padding-top:10px}.custom-business-rules p.description{font-size:.8rem}.custom-business-rules .add-rule{padding:13px;border-radius:5px;background:none;color:#1c1c1c;border:2px dashed #1c1c1c;font-size:1rem;font-weight:600;width:100%}.custom-business-rules .add-rule:hover{background:rgba(28,28,28,.1)}.custom-business-rules .custom-rule-row{margin-bottom:10px}.custom-business-rules .custom-rule-row .rule-label,.custom-business-rules .custom-rule-row input[type=text]{width:100%}.custom-business-rules .custom-rule-row button{margin-left:10px;flex-wrap:nowrap;white-space:nowrap}.custom-business-rules .custom-rule-row .delete-button{padding:0 7px;width:35px;flex:0 0 auto}.custom-business-rules .custom-rule-row .delete-button svg{width:100%}.custom-focus{transition:outline-offset .2s;outline:3px solid rgba(191,164,75,0);outline-offset:7px}.custom-focus:focus{outline-color:rgba(191,164,75,.3);outline-offset:0}.custom-focus:focus:not(:focus-visible){outline:none!important}.custom-focus:-moz-focus-visible{outline-color:rgba(191,164,75,.3);outline-offset:0}.custom-focus:focus-visible{outline-color:rgba(191,164,75,.3);outline-offset:0}.no-outline{outline:none}.options-message{padding:7px 10px;color:#222;margin-bottom:5px;border-radius:3px;transition:all .2s;font-size:.9rem;display:flex;flex-direction:row;align-items:center}", ""]);
	
	// exports


/***/ },
/* 848 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(10)();
	// imports
	
	
	// module
	exports.push([module.id, ".details-divider{border:none;border-bottom:1px dotted #999}.details-divider:first-child{display:none}.details-list{padding:10px 0;position:relative;margin:0;width:100%}.details-list .details-divider:first-child{display:block}.details-list tr:last-child .details-divider{display:none}.details-list .detail{font-size:.8rem}.details-list .detail.alert .label{color:#c01027}.details-list .detail.alert .label:before{content:\"\";background:#c01027;box-shadow:0 2px 3px rgba(0,0,0,.3);width:15px;height:15px;color:#fff;border-radius:100%;display:inline-block;margin-right:5px;text-align:center;font-style:normal;font-weight:800;padding-top:1px;vertical-align:top;z-index:9;content:\"!\"}.details-list .detail.alert .value{color:#c01027}.details-list .detail .label{text-align:right;padding-right:10px;font-style:italic;color:#666;white-space:pre-wrap;position:relative;padding-top:7px;padding-bottom:6px;border-right:1px dotted #999;width:40%}.details-list .detail .label.full-width{text-align:left;border-right:none}.details-list .detail .value{padding-left:10px;padding-top:7px;padding-bottom:6px;font-weight:600;color:#444;white-space:pre-wrap;width:60%}.details-list .detail .value .modal-link{border:none;text-decoration:underline;color:#00e;cursor:pointer}.details-list .detail .value .error{color:#c01027;font-style:italic;font-weight:100}.details-list .image-label{text-align:center;width:100%;display:block;font-style:italic;color:#777;font-size:.8rem;margin-top:10px}.details-list .image-wrapper{display:flex;flex-direction:row;justify-content:center;align-items:center;padding:10px}.details-list .image-wrapper .image{max-width:100%;height:auto;border-radius:3px}.details-list .markdown{font-size:.8rem;font-weight:400}.details-list .markdown table th{background:#d0d0ce;color:#3d3c3b;border-right-color:#a5a5a2}.details-list .markdown table td{background:hsla(0,0%,100%,.6);border-color:#d7d7d6;text-align:left}.details-list .markdown-cell .value{padding-left:0}.markdown-modal-wrapper{overflow:auto;max-height:calc(100vh - 91px);padding:20px}.markdown-modal-wrapper .markdown table{margin-bottom:10px;width:100%}.markdown-modal-wrapper .markdown table+h2{margin-top:25px}.markdown-modal-wrapper .markdown th:empty{display:none}.markdown-modal-wrapper .markdown h2{font-size:14px;font-weight:600}", ""]);
	
	// exports


/***/ },
/* 849 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(10)();
	// imports
	
	
	// module
	exports.push([module.id, ".expandable-card-wrapper{position:relative;z-index:999}.expandable-card{position:absolute;width:100%;left:0;top:0;z-index:999;overflow:hidden}.expand-in{animation:expand-in .2s;animation-fill-mode:forwards}.collapse-out{animation:collapse-out .15s;animation-fill-mode:forwards;animation-delay:.13s}@keyframes expand-in{0%{box-shadow:0 0 0 rgba(0,0,0,.19),0 0 0 rgba(0,0,0,.23)}to{box-shadow:0 10px 20px rgba(0,0,0,.19),0 6px 6px rgba(0,0,0,.23)}}@keyframes collapse-out{0%{box-shadow:0 10px 20px rgba(0,0,0,.19),0 6px 6px rgba(0,0,0,.23)}to{box-shadow:0 0 0 rgba(0,0,0,.19),0 0 0 rgba(0,0,0,.23)}}", ""]);
	
	// exports


/***/ },
/* 850 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(10)();
	// imports
	
	
	// module
	exports.push([module.id, ".detail-page-wrapper .general-info .column{padding:0 10px}.detail-page-wrapper .general-info .column:first-child{padding-right:10px;padding-left:0}.detail-page-wrapper .general-info .column:last-child{padding-left:10px;padding-right:0}@media only screen and (max-width:992px){.detail-page-wrapper .general-info .column{padding-right:0}.detail-page-wrapper .general-info .column:first-child{margin-bottom:20px}.detail-page-wrapper .general-info .column:last-child{padding-left:0;padding-right:10px}}@media only screen and (max-width:480px){.detail-page-wrapper .general-info .column{margin-bottom:20px;padding:0}.detail-page-wrapper .general-info .column:first-child,.detail-page-wrapper .general-info .column:last-child{padding:0}}.detail-header{margin-bottom:20px}.detail-header .first-col{padding-right:20px;padding-left:0}@media only screen and (max-width:480px){.detail-header .first-col{padding-right:0}}.detail-header .last-col{padding-left:0}.detail-header .critical-block{display:flex;flex-direction:column;overflow:hidden;border-radius:10px}.detail-header .critical-block .name-block{display:flex;flex-direction:column;background:#303030;padding:15px 20px}.detail-header .critical-block .name-block .name{color:#fff;font-size:2.5rem}.detail-header .critical-block .name-block .type{color:hsla(0,0%,100%,.8);font-style:italic;font-size:.95rem;margin-top:3px}@media only screen and (max-width:992px){.detail-header .critical-block .name-block{padding:8px 12px}.detail-header .critical-block .name-block .name{font-size:2rem}}.detail-header .critical-block .details-block{background:#eeeeec;display:flex;flex-direction:row;flex-wrap:wrap}.detail-header .critical-block .details-block.status-color-green{position:relative}.detail-header .critical-block .details-block.status-color-green:before{position:absolute;left:0;top:0;height:100%;width:5px;background:#49d04e;content:\"\"}.detail-header .critical-block .details-block .detail-wrapper{margin-right:7px}@media only screen and (max-width:992px){.detail-header .critical-block .details-block{padding:8px 12px}.detail-header .critical-block .details-block .detail{margin-bottom:10px}}@media only screen and (max-width:480px){.detail-header .critical-block{margin-bottom:15px}}.detail-header .standing-block{border-radius:10px;overflow:hidden;display:flex;flex-direction:column;height:100%}.detail-header .standing-block .standing{flex:1 1 auto;display:flex;align-items:center;background:#eeeeec;padding-left:10px}.detail-header .standing-block .standing .detail-wrapper{margin:0}.detail-header .standing-block .standing:nth-child(2n){background:#e4e4e3}.detail-header .standing-block .standing.standing-green{border-left:5px solid #49d04e}.detail-header .standing-block .standing.standing-red{border-left:5px solid #df2534}@media only screen and (max-width:480px){.detail-header .standing-block .standing .detail{margin:8px 12px;margin-left:5px}}.detail-wrapper{display:flex;flex-direction:column;margin:15px 20px}.detail-wrapper label{font-style:italic;color:#999794;font-size:.8rem;font-weight:600;margin-bottom:3px}.detail-wrapper .value{font-size:1.1rem;font-weight:600;color:#666665;line-height:1.2;margin-top:-1px}@media only screen and (max-width:992px){.detail-wrapper{margin:8px 12px;margin-right:4px;margin-bottom:20px}.detail-wrapper label{font-size:.75rem}.detail-wrapper .value{font-size:1rem}}.detail-block{overflow:hidden;border-radius:10px;background:#eeeeec;margin-bottom:20px}.detail-block:last-child{margin-bottom:0}.detail-block .title{padding:8px 12px;background:#c9c7c4;color:#3d3c3b;font-size:1rem;font-weight:800}.detail-block .stacked-label{margin:15px 20px;display:flex;flex-direction:column;margin-bottom:10px}.detail-block .stacked-label .primary{color:#303030;font-size:1.7rem;font-weight:800;margin-bottom:5px}.detail-block .stacked-label .secondary{color:#3d3c3b;font-size:1rem;font-weight:600;font-style:italic}@media only screen and (max-width:992px){.detail-block .stacked-label{margin:8px 12px;margin-bottom:15px}}.detail-notes .button-column,.detail-notes .input-column{padding:0}.detail-notes .button-column+div{margin-top:20px}.detail-notes textarea{width:100%;height:100%;background:#eeeeec;border:none;border-radius:10px 0 0 10px;padding:15px 20px;font-size:1rem;font-weight:600;color:#3d3c3b;outline:none;resize:none}.detail-notes textarea:focus{background:#e4e4e3}.detail-notes button{width:100%;height:100%;background:#303030;border:none;border-radius:0 10px 10px 0;color:#fff;font-size:1rem;font-weight:600;font-family:Open Sans,sans-serif;transition:background .2s,color .2s}.detail-notes button:disabled{background:#c9c7c4;color:#999794}.detail-notes button:focus{outline:none;background:#3d3d3d}.detail-notes .note{display:flex;flex-direction:column;margin:10px 0}.detail-notes .note .header{display:flex;flex-direction:row;align-items:center}.detail-notes .note .header img{margin-right:7px;margin-left:7px}.detail-notes .note .header .username{font-size:1.2rem;font-weight:800;color:#1c1c1c;margin-right:8px}.detail-notes .note .header .date{color:#999794;font-style:italic}.detail-notes .note .header .meta-wrapper{display:flex;flex-direction:row}.detail-notes .note .text{margin-top:-7px;padding-left:53px;font-size:.9rem;color:#3d3c3b;font-weight:600}@media only screen and (max-width:480px){.detail-notes textarea{border-radius:10px 10px 0 0}.detail-notes button{border-radius:0 0 10px 10px;padding:10px 0}.detail-notes .note{margin-bottom:15px}.detail-notes .note .header{margin-bottom:5px}.detail-notes .note .header .meta-wrapper{flex-direction:column}.detail-notes .note .header .meta-wrapper .username{margin-bottom:5px}.detail-notes .note .text{margin-top:0}}", ""]);
	
	// exports


/***/ },
/* 851 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(10)();
	// imports
	
	
	// module
	exports.push([module.id, ".floating-menu{position:fixed;top:15px;left:15px;z-index:99999;display:flex;flex-direction:column;box-shadow:0 14px 28px rgba(0,0,0,.25),0 10px 10px rgba(0,0,0,.22)}.floating-menu .menu-item{background:#fff;padding:15px;font-size:1rem;border:none;border-top:1px solid #eee;cursor:pointer;transition:background .15s;outline:none;line-height:1;white-space:nowrap;text-decoration:none;color:inherit}.floating-menu .menu-item:focus,.floating-menu .menu-item:hover{background:#eee}.floating-menu .menu-item:first-child{border-top:none}.floating-menu .menu-item .svg-icon{width:20px;margin-right:6px}.materialZoomIn{animation:materialZoomIn .25s;animation-timing-function:cubic-bezier(0,.92,.22,1.08)}@keyframes materialZoomIn{0%{transform:scale(.5) translate(-30%,-50%);opacity:0}30%{opacity:1}to{transform:scale(1) translate(0);opacity:1}}.materialZoomOut{animation:materialZoomOut .25s;animation-timing-function:cubic-bezier(.1,.81,.43,.93)}@keyframes materialZoomOut{0%{transform:scale(1) translate(0);opacity:1}50%{opacity:0}to{transform:scale(.5) translate(-30%,-50%);opacity:0}}.materialZoomInRight{animation:materialZoomInRight .25s;animation-timing-function:cubic-bezier(0,.92,.22,1.08)}@keyframes materialZoomInRight{0%{transform:scale(.5) translate(30%,-50%);opacity:0}30%{opacity:1}to{transform:scale(1) translate(0);opacity:1}}.materialZoomOutRight{animation:materialZoomOutRight .25s;animation-timing-function:cubic-bezier(.1,.81,.43,.93)}@keyframes materialZoomOutRight{0%{transform:scale(1) translate(0);opacity:1}50%{opacity:0}to{transform:scale(.5) translate(30%,-50%);opacity:0}}", ""]);
	
	// exports


/***/ },
/* 852 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(10)();
	// imports
	
	
	// module
	exports.push([module.id, ".fc-login-wrapper{display:flex;flex-direction:column;background:#fff;box-shadow:0 10px 20px rgba(0,0,0,.19),0 6px 6px rgba(0,0,0,.23);max-width:650px}@media only screen and (max-width:768px){.fc-login-wrapper{min-width:auto;box-shadow:0 3px 6px rgba(0,0,0,.16),0 3px 6px rgba(0,0,0,.23);width:100%}}.fc-header{display:flex;flex-direction:row;align-items:center;background:#1c1c1c;color:#fff;padding:10px;font-size:1.3rem}.fc-header img{width:60px;margin-right:10px}.fc-body{display:flex;flex-direction:row}@media only screen and (max-width:768px){.fc-body{flex-direction:column}}.fc-column{display:flex;flex-direction:column;flex:0 0 50%;width:50%;padding:25px}@media only screen and (max-width:768px){.fc-column{flex:0 0 100%;width:100%}}.fc-column.secondary{background:#eeeeec;padding:40px}.fc-column .description{max-width:350px;font-style:italic;line-height:1.3;margin-bottom:10px}.fc-column .description:last-child{margin-bottom:0}.fc-column .field{width:100%;margin:0;padding:0;margin-bottom:20px;transition:none}.fc-column .text-wrapper,.fc-column input{width:100%}.fc-column button{text-align:center;align-items:center;justify-content:center;margin:5px 0}.fc-column button:active{background:#0f0f0f}", ""]);
	
	// exports


/***/ },
/* 853 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(10)();
	// imports
	
	
	// module
	exports.push([module.id, ".form-manager{user-select:none}.form-manager .loader-wrapper{height:calc(100vh - 150px)}.form-manager .save-indicator{position:fixed;top:75px;right:15px;z-index:9;display:flex;align-items:center;flex-direction:row}.form-manager .save-indicator .svg-icon{width:20px;flex:0 0 auto;margin-top:1px}.form-manager .save-indicator .loader-text{margin-left:3px;font-weight:600;color:#aaa}.form-manager .save-indicator.saved{color:#41be46;animation-delay:2s}.form-manager .save-indicator.saved .icon{margin-top:3px;margin-right:4px;font-size:1rem}.form-manager .save-indicator.saved .loader-text{color:#41be46}.form-manager .toolbar{padding-left:10px}.form-manager .toolbar .icon-wrapper .selected-icon{cursor:pointer;padding:7px;display:flex;justify-content:center;align-items:center;width:50px;height:50px;background:#1c1c1c;color:#fff;border-radius:100%}.form-manager .toolbar .icon-wrapper .selected-icon:hover{background:#303030}.form-manager .add-button:hover .abbreviation.abbreviation{color:#fff}.form-manager .add-button:hover .block-icon{background:rgba(28,28,28,.3)}.form-manager .add-button .block-icon{background:none;border:2px dashed #1c1c1c;transition:background .2s}.form-manager .category{flex:0 0 auto;margin-bottom:0;padding-bottom:20px;padding-top:5px;position:relative;min-height:150px}.form-manager .category.editable{display:flex;flex-direction:column}.form-manager .category.editable .title-wrapper .title{padding-left:0;background:#eeeeec}.form-manager .category.editable .title-wrapper .title.abbreviation{width:60px;min-width:60px;text-transform:uppercase;margin-right:5px;padding-left:5px;font-size:1rem;font-style:italic;color:#999794}.form-manager .category.editable .title-wrapper .title:hover{background:#fff7d9}.form-manager .category.editable .title-wrapper .title:focus{background:#fff}.form-manager .category.editable .divider{width:100%;margin-left:-30px}.form-manager .category .actions{margin-left:auto;display:flex;flex-direction:row}.form-manager .category .title-wrapper{display:flex;flex-direction:row;justify-content:flex-start;align-items:center;margin-bottom:10px;padding:3px}.form-manager .category .title-wrapper .title{border:none;color:#1c1c1c;padding:5px;padding-bottom:4px;padding-left:15px;border-radius:3px;font-size:1rem;font-weight:800;display:inline-block;min-width:100px;max-width:100%}.form-manager .category .title-wrapper .title:focus{outline:none;background:#fff0b6}.form-manager .category .icon-wrapper{width:28px;height:28px;font-size:1rem;border:none;padding:4px;text-transform:none;cursor:pointer;display:flex;justify-content:center;align-items:center;margin:0 2px;box-shadow:none}.form-manager .category .icon-wrapper .icon{font-weight:700}.form-manager .category .delete:hover{background:rgba(192,16,39,.1)}.form-manager .draggable-wizard{flex-grow:0;background:#fff}.form-manager .draggable-wizard.is-over .inner-block{transform:translateX(100px);box-shadow:0 1px 3px rgba(0,0,0,.12),0 1px 2px rgba(0,0,0,.24);z-index:98}.form-manager .draggable-wizard[data-drag-over-direction=left]:before{content:\"\";position:absolute;left:-2px;top:0;width:4px;height:100%;border-radius:2px;background:#1c1c1c;z-index:99}.form-manager .draggable-wizard[data-drag-over-direction=right]:before{content:\"\";position:absolute;right:-2px;top:0;width:4px;height:100%;border-radius:2px;background:#1c1c1c;z-index:99}.form-manager .draggable-wizard .hover-edit-wrapper{position:absolute;left:0;top:0;background:none;border:none;width:70px;height:100%;z-index:2;transition:background .2s;cursor:pointer}.form-manager .draggable-wizard .hover-edit-wrapper:hover{background:hsla(0,0%,100%,.2)}.form-manager .draggable-wizard .hover-edit-wrapper:hover .hover-edit{opacity:1}.form-manager .draggable-wizard .hover-edit{position:absolute;width:30px;height:30px;left:29px;top:45px;opacity:0;padding:2px;border-radius:100%;transition:opacity .2s;background:#1c1c1c;color:#fff}.form-manager .draggable-wizard .full-width{width:100%}.form-manager .draggable-wizard .faded{opacity:.4;pointer-events:none;background:none!important}.form-manager .draggable-wizard .transition{transition:transform .3s,box-shadow .2s;transition-timing-function:cubic-bezier(.32,1.19,.78,1.07)}.form-manager .draggable-wizard .actions-row{display:flex;flex-direction:row;justify-content:space-between;width:100%}.form-manager .draggable-wizard .actions-row .btn-text{flex:1 1 25%;width:25%;padding:0;display:flex;flex-direction:column;justify-content:center;align-items:center}.form-manager .draggable-wizard .actions-row .label{font-size:.7rem}.form-manager .draggable-wizard .actions-row .svg-icon{width:100%;max-width:27px}.form-manager .draggable-wizard .metadata-row .metadata{padding:0}.form-manager .draggable-wizard .metadata-row .metadata:not(:last-child) *{padding-bottom:0}.form-manager .draggable-wizard .droppable-wizard{flex:0 0 auto;transition:width .4s;transition-timing-function:cubic-bezier(.32,1.19,.78,1.07)}.form-manager .draggable-wizard .collapse-animation{animation:collapse .4s cubic-bezier(.32,1.19,.78,1.07);animation-fill-mode:forwards}.form-manager .draggable-wizard .left-drop{position:absolute;left:0;top:0;width:50%;height:100%;opacity:.2;z-index:9}.form-manager .draggable-wizard .right-drop{position:absolute;right:0;top:0;width:50%;height:100%;background:blue;opacity:.2;z-index:9}.form-manager .draggable-wizard .form-block-wrapper{width:100%}.form-manager .uncategorized-wrapper{position:relative;bottom:28px;background:#f1eeea;padding:5px;z-index:9;margin-top:38px;margin-bottom:-30px;border-radius:6px}.form-manager .uncategorized-wrapper .draggable-wizard{background:#f1eeea}.form-manager .uncategorized-wrapper .draggable-wizard .abbr{border-color:#f1eeea}.form-manager .uncategorized-wrapper .category{padding-bottom:0;display:flex;flex-direction:column;background:none}.form-manager .uncategorized-wrapper .category .title-wrapper,.form-manager .uncategorized-wrapper .category h2.title.title.title{background:none}.form-manager .uncategorized-wrapper .category h2.title.title.title:hover{background:none;cursor:default}.form-manager .uncategorized-wrapper .category hr{display:none}.form-manager .uncategorized-wrapper .unpublish-shade{position:absolute;left:0;top:0;width:100%;height:100%;background:rgba(28,28,28,.7);color:#fff;text-align:center;font-size:1.8rem;font-weight:600;display:flex;justify-content:center;align-items:center;z-index:9;transition:background .3s,padding-bottom .3s;border-radius:6px;pointer-events:all}.form-manager .uncategorized-wrapper .unpublish-shade.over{background:rgba(28,28,28,.8);padding-bottom:15px}.form-manager .visibility-toggle{margin-right:10px;margin-left:10px}.form-manager .visibility-toggle:focus{box-shadow:0 0 0 3px rgba(191,164,75,.3)}.form-manager-end-spacer{flex:1 1 auto;min-width:100px;min-height:90px}.form-manager-end-spacer .droppable-wizard{height:100%}.form-manager-scroll-zone{position:fixed;top:0;left:0;width:100%;height:80px;z-index:9999}.form-manager-scroll-zone.bottom{top:auto;bottom:0}.drag-over-trigger{position:absolute;left:0;top:0;width:50%;height:100%;z-index:99}.drag-over-trigger.right{left:auto;right:0}.wizard-dragging{pointer-events:none;position:fixed;left:0;top:0;z-index:9999;background:#fff;border-radius:5px;box-shadow:0 10px 20px rgba(0,0,0,.19),0 6px 6px rgba(0,0,0,.23)}.wizard-dragging .block-icon{box-shadow:0 10px 30px rgba(0,0,0,.5)}.wizard-dragging .label{text-shadow:0 10px 30px rgba(0,0,0,.5)}.import-dialog.import-dialog{padding:15px;display:flex;flex-direction:column;align-items:center}.import-dialog.import-dialog p{font-size:.9rem}.import-dialog.import-dialog .file-input{opacity:0;width:1px;height:1px}.import-dialog.import-dialog .file-input:focus+.file-label{outline-color:rgba(191,164,75,.3);outline-offset:0}.import-dialog.import-dialog .file-label{flex:0 0 auto;margin-top:5px;margin-bottom:10px}@keyframes collapse{0%{width:130px}to{width:0}}.fm-icon-menu .svg-icon.svg-icon.svg-icon{width:28px;margin:0}input[type=file]:focus+.sibling-focus{outline:3px solid rgba(191,164,75,.6);outline-offset:0}", ""]);
	
	// exports


/***/ },
/* 854 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(10)();
	// imports
	
	
	// module
	exports.push([module.id, ".forms,.table-controls-wrapper{display:flex;flex-direction:column;padding-bottom:60px;min-height:calc(100vh - 60px - 30px)}@media (-ms-high-contrast:active),(-ms-high-contrast:none){.forms,.table-controls-wrapper{padding-bottom:150px}}.forms .toolbar,.table-controls-wrapper .toolbar{width:100%;display:flex;flex-direction:row;padding-bottom:15px;align-items:center}.forms .toolbar input[type=file]:focus+.import,.table-controls-wrapper .toolbar input[type=file]:focus+.import{outline-color:rgba(191,164,75,.3);outline-offset:0}.forms .toolbar .import,.table-controls-wrapper .toolbar .import{transition:outline-offset .2s;outline:3px solid rgba(191,164,75,0);outline-offset:7px;display:flex;flex-direction:row;align-items:center}.forms .toolbar .import .svg-icon,.table-controls-wrapper .toolbar .import .svg-icon{margin-right:2px;max-width:20px}@media (-ms-high-contrast:active),(-ms-high-contrast:none){.forms .toolbar .import .svg-icon,.table-controls-wrapper .toolbar .import .svg-icon{max-height:20px}}.forms .toolbar .filter-wrapper,.table-controls-wrapper .toolbar .filter-wrapper{margin-left:auto;flex:0 1 200px;position:relative}.forms .toolbar .filter-wrapper button.clear,.table-controls-wrapper .toolbar .filter-wrapper button.clear{position:absolute;top:5px;right:4px;width:20px;height:20px;background:#999794;color:#fff;padding:0;border:none;border-radius:100%;display:flex;justify-content:center;align-items:center;appearance:none;outline:none;transition:outline-offset .2s;outline:3px solid rgba(191,164,75,0);outline-offset:7px}.forms .toolbar .filter-wrapper button.clear:focus,.table-controls-wrapper .toolbar .filter-wrapper button.clear:focus{outline-color:rgba(191,164,75,.3);outline-offset:0}.forms .toolbar .filter-wrapper button.clear:hover,.table-controls-wrapper .toolbar .filter-wrapper button.clear:hover{background:#c9c7c4}.forms .toolbar .filter-wrapper button.clear .svg-icon,.table-controls-wrapper .toolbar .filter-wrapper button.clear .svg-icon{width:60%}.forms .toolbar input.filter,.table-controls-wrapper .toolbar input.filter{transition:outline-offset .2s;outline:3px solid rgba(191,164,75,0);outline-offset:7px;flex:1 1 auto;border:none;background:#eeeeec;height:30px;width:100%;font-size:1rem;padding:6px;font-weight:600;border-radius:5px;padding-right:30px}.forms .toolbar input.filter:focus,.table-controls-wrapper .toolbar input.filter:focus{outline-color:rgba(191,164,75,.3);outline-offset:0}@media only screen and (max-width:480px){.forms .toolbar,.table-controls-wrapper .toolbar{flex-direction:column;align-items:center}.forms .toolbar .import-wrapper,.table-controls-wrapper .toolbar .import-wrapper{width:100%}.forms .toolbar .filter-wrapper,.table-controls-wrapper .toolbar .filter-wrapper{margin-left:0;margin-bottom:10px;flex:0 0 auto;width:100%}.forms .toolbar .filter-wrapper input,.table-controls-wrapper .toolbar .filter-wrapper input{height:40px}}.forms .category,.table-controls-wrapper .category{flex:0 0 auto;display:flex;flex-direction:column}.forms .category:first-child .title-wrapper,.table-controls-wrapper .category:first-child .title-wrapper{margin-top:0}.forms .category:last-child .form-blocks.form-blocks-idaho,.table-controls-wrapper .category:last-child .form-blocks.form-blocks-idaho{margin-bottom:75px}.forms .category:last-child .form-blocks:has(.form-block-card):not(.form-blocks-idaho),.table-controls-wrapper .category:last-child .form-blocks:has(.form-block-card):not(.form-blocks-idaho){margin-bottom:75px}.forms .category .title-wrapper,.table-controls-wrapper .category .title-wrapper{width:100%;padding:10px;background:#eeeeec;margin-bottom:13px;margin-top:13px}.forms .category .form-blocks,.table-controls-wrapper .category .form-blocks{display:flex;flex-direction:row;flex-wrap:wrap}.forms .forms-wrapper,.table-controls-wrapper .forms-wrapper{width:100%;display:flex;justify-content:center;padding:10vw}.form-block-wrapper{flex:0 0 25%;display:flex;flex-direction:row;position:relative;user-select:none;cursor:default;padding:0;background:none;border:none;text-align:left;-webkit-appearance:none;-moz-appearance:none;line-height:1;outline:none}.form-block-wrapper:focus{background:#eeeeec}.form-block-wrapper.is-over,.form-block-wrapper.is-over .form-block-wrapper{background:#fff!important}.form-block-wrapper.is-over:hover{background:inherit}.form-block-wrapper:hover{background:#eeeeec}@media only screen and (min-width:1500px){.form-block-wrapper{flex:0 0 20%}}@media only screen and (max-width:992px){.form-block-wrapper{flex:0 0 33.3333%}}@media only screen and (max-width:768px){.form-block-wrapper{flex:0 0 50%}}@media only screen and (max-width:480px){.form-block-wrapper{flex:0 0 100%}}.shadow-in{animation:shadow-in .2s;animation-fill-mode:forwards}.shadow-out{animation:shadow-out .15s;animation-fill-mode:forwards;animation-delay:.13s}.form-block-card{position:absolute;width:100%;left:0;top:0;background:#fff;overflow:hidden;z-index:9;border-top:1px solid #eeeeec;margin-bottom:50px;box-shadow:0 10px 20px rgba(0,0,0,.19),0 6px 6px rgba(0,0,0,.23);transform:scale(1.1)}.form-block-card .description{padding:15px;padding-top:0;line-height:1.4;font-size:.8rem;font-style:italic}.form-block-card .actions{padding:15px;padding-top:0;display:flex;flex-direction:row;justify-content:flex-end}.form-block-card .actions button{outline:none;transition:outline-offset .2s;outline:3px solid rgba(191,164,75,0);outline-offset:7px}.form-block-card .actions button:focus{outline-color:rgba(191,164,75,.3);outline-offset:0;background:#eeeeec}.form-block{display:flex;flex-direction:row;align-items:center;margin:10px 0;background:none;border:none;padding:0}.form-block h3{flex:1 1 auto;font-weight:800;font-size:.85rem;line-height:1.2;word-wrap:break-word;max-width:100%;padding-right:10px}.form-block-icon-container,.form-block h3{color:#1c1c1c;align-items:center;display:flex}.form-block-icon-container{flex:0 0 auto;justify-content:center;position:relative}.form-block-icon-container .abbr-wrapper{position:relative}.form-block-icon-container .abbr{position:absolute;width:38px;height:38px;right:7px;bottom:2px;background:#1c1c1c;color:#fff;border-radius:100%;display:flex;justify-content:center;align-items:center;z-index:1;font-weight:800;font-size:.75rem;border:3px solid #fff;padding:4px}.form-block-icon-container .svg-icon{width:70px}@media (-ms-high-contrast:active),(-ms-high-contrast:none){.form-block-icon-container .svg-icon{height:70px}}@keyframes shadow-in{0%{transform:scale(1);box-shadow:0 0 0 rgba(0,0,0,.19),0 0 0 rgba(0,0,0,.23)}to{transform:scale(1.1);box-shadow:0 10px 20px rgba(0,0,0,.19),0 6px 6px rgba(0,0,0,.23)}}@keyframes shadow-out{0%{transform:scale(1.1);box-shadow:0 10px 20px rgba(0,0,0,.19),0 6px 6px rgba(0,0,0,.23)}to{transform:scale(1);box-shadow:0 0 0 rgba(0,0,0,.19),0 0 0 rgba(0,0,0,.23)}}", ""]);
	
	// exports


/***/ },
/* 855 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(10)();
	// imports
	
	
	// module
	exports.push([module.id, ".frequent-payor h2.total-header{font-weight:400;font-size:.85rem;background:#e4e4e3}.frequent-payor h2.total-header .total{font-weight:600;font-size:3rem;color:#1c1c1c}.frequent-payor .instructions{margin-top:20px}.frequent-payor .payment-options{justify-content:space-between}.frequent-payor .other-wrapper{margin-top:10px}.frequent-payor .other-field{flex:1 1 auto}.frequent-payor .add-button{align-self:flex-end;margin-bottom:10px;margin-left:10px}.frequent-payor-section{font-size:.85rem;margin-top:15px;padding-top:15px;border-top:1px solid hsla(0,0%,100%,.2)}.frequent-payor-section .balance{margin-bottom:10px}.frequent-payor-section .add-button{flex:0 0 auto;width:auto;height:42px;margin-left:5px;padding:5px 10px;width:42px}.frequent-payor-section .add-button svg.svg-icon{margin:0}.frequent-payor-section .tooltip-positioner{left:-124px}.frequent-payor-section .tooltip-wrapper{background:#fff;color:#000}.frequent-payor-section .tooltip-wrapper:before{left:calc(50% - 8px);border-top:8px solid #fff;opacity:1;z-index:1}.frequent-payor-section .funds-hint{font-style:italic;font-size:12px;margin-top:10px}.frequent-payor-section .funds-hint .tip{font-weight:800;font-style:normal;width:13px;height:13px;background:#fff;border-radius:100%;display:inline-block;color:#1c1c1c;text-align:center;padding-top:1px}.frequent-payor-modal h2.total-header{margin-left:-20px;margin-right:-20px;margin-top:-20px;padding:20px}.frequent-payor-user-section h2{display:flex;align-items:center;margin:15px 0;font-size:17px;padding-bottom:15px;border-bottom:1px solid #e4e4e3}.frequent-payor-user-section h2 button{display:flex;align-items:center;margin-left:auto;margin-top:2px}.frequent-payor-user-section h2 button svg.svg-icon.svg-icon.svg-icon{max-width:15px;width:15px;height:15px;margin-right:3px}.frequent-payor-user-section:not(:only-child){border-top:1px solid #e4e4e3;margin-top:15px}.frequent-payor-user-section .prepaid-balance p{font-size:24px}.frequent-payor-user-section .fp-acc-address{flex:0 0 auto;margin:15px 0}.frequent-payor-user-section .align-right{margin-left:auto}.frequent-payor-user-section .edit-icon.edit-icon.edit-icon{max-width:none;width:15px;height:15px}.frequent-payor-user-section .btn-neutral{font-size:13.33333px}.frequent-payor-user-section .btn-neutral svg.svg-icon{max-width:20px;width:20px;height:20px}.frequent-payor-user-section .btn-raised{font-size:12px}.frequent-payor-user-section .btn-raised svg.svg-icon{max-width:13px;width:13px;height:13px;margin-right:8px}.frequent-payor-user-section .account-details .flex-column:first-child,.frequent-payor-user-section .address-section .flex-column:first-child,.frequent-payor-user-section .balance-section .flex-column:first-child{width:51%}.statement-selector .field.field{flex:1 0 auto;margin-right:0}.statement-selector button{margin-top:16px;margin-left:auto;font-size:12px}.statement-selector button svg.svg-icon{width:17px;height:17px;margin-right:6px;margin-left:-5px}", ""]);
	
	// exports


/***/ },
/* 856 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(10)();
	// imports
	
	
	// module
	exports.push([module.id, ".health-care-directive-page{display:flex;flex-direction:row;justify-content:center;align-items:center;font-family:Open Sans,sans-serif;min-height:calc(100vh - 60px - 30px)}.health-care-directive-page .hcd-card{width:90%;align-self:center;margin-top:20px;box-shadow:0 5px 4px -3px rgba(0,0,0,.3);border-radius:10px;margin-bottom:10px}.health-care-directive-page.record-detail-page{align-items:flex-start}.health-care-directive-page.record-detail-page .align-right{display:flex;justify-content:center;padding-right:25px;margin-left:auto}.health-care-directive-page.record-detail-page .align-right a{display:flex;justify-content:center;align-items:center;font-weight:600;font-size:1rem;color:#666665}.health-care-directive-page.record-detail-page .align-right a:hover{text-decoration:underline}.health-care-directive-page.record-detail-page .align-right a svg{width:22px;margin-right:4px}.health-care-directive-page.record-detail-page .detail-page-wrapper .general-info .column:first-child{padding-left:3px}.health-care-directive-page.record-detail-page .detail-page-wrapper .general-info .column:last-child{padding-right:3px}.health-care-directive-page .hcd-description{line-height:1.3;font-size:13px}.health-care-directive-page .error{font-style:italic;color:#c01027;font-size:13px;margin-top:6px}.health-care-directive-page .back-link{margin-bottom:10px;background:none;border:none;font-weight:600;color:#000}.health-care-directive-page .back-link:hover{text-decoration:underline}.health-care-directive-page .certified-date-wrapper.certified-date-wrapper .field{margin-bottom:0}", ""]);
	
	// exports


/***/ },
/* 857 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(10)();
	// imports
	
	
	// module
	exports.push([module.id, ".home{min-height:calc(100vh - 60px - 30px)}.home,.home .header-row{display:flex;flex-direction:column}.home .header-row{z-index:1;justify-content:center;align-items:center;padding:20px;min-height:22vh;color:#1c1c1c;position:relative}.home .header-row h1{font-size:8vh;font-weight:800;font-style:italic;text-align:center}.home .header-row .subtitle{font-size:2.3vh;margin-top:0;margin:0}@media only screen and (max-width:1200px){.home .header-row{min-height:20vh}}@media only screen and (max-width:992px){.home .header-row{height:auto}.home .header-row h1{font-size:6vh}.home .header-row .subtitle{margin:7px 0}}.home .atf-links{z-index:1;width:100%;display:flex;flex-direction:row;flex-wrap:wrap;justify-content:center}.home .atf-links .link-wrapper{flex:0 0 auto;padding:10px;display:flex;justify-content:center;align-items:center}.home .atf-links .link-wrapper.secondary a,.home .atf-links .link-wrapper.secondary button{background:#bfa44b;color:#fff}.home .atf-links .link-wrapper.secondary a:hover,.home .atf-links .link-wrapper.secondary button:hover{background:#c6ae5e}.home .atf-links .link-wrapper a,.home .atf-links .link-wrapper button{flex:0 0 auto;background:#bfa44b;padding:1.5vh;text-decoration:none;font-size:1rem;border-radius:2px;font-weight:600;color:#fff;box-shadow:0 1px 3px rgba(0,0,0,.12),0 1px 2px rgba(0,0,0,.24);transition:box-shadow .1s,background .1s;transition:outline-offset .2s;outline:3px solid rgba(191,164,75,0);outline-offset:7px}.home .atf-links .link-wrapper a:focus,.home .atf-links .link-wrapper button:focus{outline-color:rgba(191,164,75,.3);outline-offset:0}.home .atf-links .link-wrapper a:hover,.home .atf-links .link-wrapper button:hover{background:#c6ae5e;box-shadow:0 3px 6px rgba(0,0,0,.16),0 3px 6px rgba(0,0,0,.23)}.home .atf-links .link-wrapper button{width:35px;height:35px;padding:0;border:none;display:flex;justify-content:center;align-items:center;box-shadow:none;border-radius:100%;background:#bfa44b}.home .atf-links .link-wrapper button:hover{background:#ccb771;box-shadow:none}.home .atf-links .link-wrapper button .svg-icon{width:25px;height:25px}@media only screen and (max-width:480px){.home .atf-links{flex-direction:column;align-items:center;margin-top:1vh}.home .atf-links .link-wrapper{width:100%;padding:0 2vh 1.5vh}.home .atf-links .link-wrapper a{width:100%;text-align:center;padding:2.5vh}}.expandable-home-card{width:calc(100% - 2vh);min-height:calc(100% - 2vh);left:1vh;top:1vh;z-index:9999}.home-category-cards{z-index:1;display:flex;flex-direction:row;flex-wrap:wrap;justify-content:center;padding:20px;margin-bottom:30px}.home-category-cards .home-category-card-wrapper{flex:0 0 25%;padding:1vh}.home-category-cards .home-category-card-wrapper>*{box-shadow:none!important}.home-category-cards .home-category-card{background:#e4e4e4;padding:20px;padding-bottom:25px;position:relative;height:100%}.home-category-cards .home-category-card.disabled{opacity:.7}.home-category-cards .home-category-card h2{font-size:1.2rem;font-weight:600;margin-bottom:15px;display:flex;align-items:center;padding:10px;background:#d1d1d1;margin:-20px;margin-bottom:16px;user-select:none;height:53px}.home-category-cards .home-category-card h2.admin:hover{background:#c4c4c4;cursor:pointer}.home-category-cards .home-category-card h2.admin:hover .edit-icon{opacity:1}.home-category-cards .home-category-card h2.admin:hover .user-icon{opacity:0}.home-category-cards .home-category-card h2.admin:active{background:#bdbdbd}.home-category-cards .home-category-card h2 .icon-wrapper{flex:0 0 auto;width:1.9rem;height:1.9rem;background:#1c1c1c;border-radius:100%;display:flex;justify-content:center;align-items:center;margin-right:8px;padding:4px;position:relative}.home-category-cards .home-category-card h2 .svg-icon{color:#fff;width:100%}.home-category-cards .home-category-card h2 .svg-icon.edit-icon{position:absolute;width:calc(100% - .6rem);left:.3rem;top:.3rem;opacity:0;background:#1c1c1c}@media (-ms-high-contrast:active),(-ms-high-contrast:none){.home-category-cards .home-category-card h2 .svg-icon.edit-icon{height:calc(100% - .6rem)}}.home-category-cards .home-category-card .description{font-style:italic;border-bottom:1px solid #c9c7c4;padding-bottom:7px;margin-top:-6px;margin-bottom:10px}.home-category-cards .home-category-card .links{display:flex;flex-direction:column}.home-category-cards .home-category-card .links a{padding:4px 0;text-decoration:none;color:#333}.home-category-cards .home-category-card .links a:first-child{padding-top:0}.home-category-cards .home-category-card .expand-button{background:#e4e4e4;border:none;display:flex;justify-content:center;align-items:center;width:100%;position:absolute;bottom:0;left:0}.home-category-cards .home-category-card .expand-button:hover{background:#eee}.home-category-cards .home-category-card .expand-button:focus{outline:none;background:#eee}.home-category-cards .home-category-card .expand-button .svg-icon{width:1.3rem;color:#999794}@media (-ms-high-contrast:active),(-ms-high-contrast:none){.home-category-cards .home-category-card .expand-button .svg-icon{height:1.3rem}}@media only screen and (max-width:768px){.home-category-cards .home-category-card .expand-button .svg-icon{width:2.5rem}}@media only screen and (min-width:1500px){.home-category-cards .home-category-card-wrapper{flex:0 0 16.666666%}}@media only screen and (max-width:992px){.home-category-cards .home-category-card-wrapper{flex:0 0 33.333333%}}@media only screen and (max-width:768px){.home-category-cards .home-category-card-wrapper{flex:0 0 50%}.home-category-cards .home-category-card-wrapper .home-category-card .links{font-size:16px}.home-category-cards .home-category-card-wrapper .home-category-card .links a{padding:8px 0}}@media only screen and (max-width:480px){.home-category-cards{padding:.5vh}.home-category-cards .home-category-card-wrapper{flex:0 0 100%}}.home-separator-wrapper{position:relative;padding:5px 0;padding-top:7px}.home-separator-wrapper .__react_component_tooltip{font-weight:600}.home-separator-wrapper hr{width:100%;border:none;border-top:1px solid rgba(28,28,28,.3)}.home-separator-wrapper .auth-hint{position:absolute;left:calc(50% - .5rem);bottom:6px;color:#999794;background:#fff;width:1rem;display:flex;justify-content:center;align-items:center}.home-category-modal.home-category-modal,.quick-links-editor{overflow-y:auto;max-height:calc(100% - 51px);border-radius:0 0 6px 6px;padding-bottom:10px;background:#eeeeec;min-height:calc(100% - 50px)}.home-category-modal.home-category-modal .title-row,.quick-links-editor .title-row{background:#e4e4e3;padding:15px 20px;display:flex;flex-direction:row}.home-category-modal.home-category-modal .title-row .description-wrapper,.home-category-modal.home-category-modal .title-row .title-wrapper,.quick-links-editor .title-row .description-wrapper,.quick-links-editor .title-row .title-wrapper{margin-right:10px}.home-category-modal.home-category-modal .title-row .check-wrapper,.quick-links-editor .title-row .check-wrapper{padding-top:30px}.home-category-modal.home-category-modal .title-row .icon-menu-wrapper,.quick-links-editor .title-row .icon-menu-wrapper{flex:0 0 auto;width:34px;height:34px;background:#1c1c1c;border-radius:100%;display:flex;justify-content:center;align-items:center;margin-right:8px;padding:5px;position:relative;margin-right:20px;transition:outline-offset .2s;outline:3px solid rgba(191,164,75,0);outline-offset:7px}.home-category-modal.home-category-modal .title-row .icon-menu-wrapper:focus,.quick-links-editor .title-row .icon-menu-wrapper:focus{outline-color:rgba(191,164,75,.3);outline-offset:0}.home-category-modal.home-category-modal .title-row .icon-menu-wrapper .svg-icon,.quick-links-editor .title-row .icon-menu-wrapper .svg-icon{color:#fff;width:100%}.home-category-modal.home-category-modal .title-row .align-right,.quick-links-editor .title-row .align-right{display:flex;margin-left:auto;align-items:center}.home-category-modal.home-category-modal .link-row,.quick-links-editor .link-row{padding:5px 20px;display:flex;flex-direction:row}.home-category-modal.home-category-modal .link-row.animate-new,.quick-links-editor .link-row.animate-new{animation:highlight 1s}.home-category-modal.home-category-modal .link-row.animate-delete,.quick-links-editor .link-row.animate-delete{animation:animate-delete .3s}.home-category-modal.home-category-modal .link-row .url,.quick-links-editor .link-row .url{flex:1 0 auto;margin-left:5px}.home-category-modal.home-category-modal .link-row .url .text-wrapper,.quick-links-editor .link-row .url .text-wrapper{width:100%}.home-category-modal.home-category-modal .link-row .menu-button,.quick-links-editor .link-row .menu-button{padding:0;background:none;border:none;margin-top:25px;margin-bottom:8px;margin-right:5px;border-radius:5px;color:#666665}.home-category-modal.home-category-modal .link-row .menu-button .svg-icon,.quick-links-editor .link-row .menu-button .svg-icon{width:20px}@media (-ms-high-contrast:active),(-ms-high-contrast:none){.home-category-modal.home-category-modal .link-row .menu-button .svg-icon,.quick-links-editor .link-row .menu-button .svg-icon{height:20px}}.home-category-modal.home-category-modal .link-row .menu-button:hover,.quick-links-editor .link-row .menu-button:hover{background:#e4e4e3}.home-category-modal.home-category-modal .home-separator-wrapper,.quick-links-editor .home-separator-wrapper{padding-left:20px;padding-right:20px}.home-category-modal.home-category-modal .auth-hint,.quick-links-editor .auth-hint{background:#eeeeec}.home-category-modal.home-category-modal .new-tab-wrapper,.quick-links-editor .new-tab-wrapper{height:100%;display:flex;align-items:center;padding-left:15px;padding-top:22px}.home-category-modal.home-category-modal .add-link,.quick-links-editor .add-link{padding:10px;background:none;border:3px dashed #1c1c1c;width:100%;border-radius:6px;font-family:Open Sans,sans-serif;font-weight:800;text-transform:uppercase;color:#1c1c1c;margin:10px 20px;cursor:pointer}.home-category-modal.home-category-modal .add-link:hover,.quick-links-editor .add-link:hover{background:rgba(28,28,28,.1)}.home-category-modal.home-category-modal .add-link:active,.quick-links-editor .add-link:active{background:rgba(28,28,28,.2)}.home-category-modal.home-category-modal .add-link:focus,.quick-links-editor .add-link:focus{border-color:#303030}.home-icon-menu.home-icon-menu.home-icon-menu .svg-icon{width:28px}@media (-ms-high-contrast:active),(-ms-high-contrast:none){.home-icon-menu.home-icon-menu.home-icon-menu .svg-icon{height:28px}}.home-edit-menu span{display:flex;align-items:center}.home-edit-menu .svg-icon{width:20px;margin-right:6px}@media (-ms-high-contrast:active),(-ms-high-contrast:none){.home-edit-menu .svg-icon{height:20px}}@keyframes highlight{0%{background:rgba(191,164,75,.3)}to{background:rgba(191,164,75,0)}}@keyframes animate-delete{0%{overflow:hidden;height:69px;background:rgba(192,16,39,.3)}to{overflow:hidden;height:0;background:rgba(192,16,39,0);padding-top:0;padding-bottom:0}}.home-message-wrapper,.right-wrapper{display:flex;flex-direction:row;justify-content:center;width:100%;flex:0 0 auto;outline:none}@media only screen and (max-width:768px){.home-message-wrapper .message-placeholder,.right-wrapper .message-placeholder{flex:1 0 auto}.home-message-wrapper .message.message,.right-wrapper .message.message{margin-top:10px;max-width:100%}}.home-message-wrapper .message-placeholder,.right-wrapper .message-placeholder{padding:7px 15px;border:2px dashed #fff;color:#fff;font-weight:600;text-transform:uppercase;display:flex;justify-content:center;align-items:center;background:none;border-radius:6px;margin-top:25px;opacity:.6;cursor:pointer}.home-message-wrapper .message-placeholder:focus,.right-wrapper .message-placeholder:focus{outline:none;background:hsla(0,0%,100%,.2)}.home-message-wrapper .message-placeholder:hover,.right-wrapper .message-placeholder:hover{opacity:1}.home-message-wrapper .message,.right-wrapper .message{display:flex;align-items:center;padding:15px 20px 15px 15px;background:rgba(5,5,5,.14);margin-top:30px;color:#1c1c1c;font-size:.9rem;max-width:50%}.home-message-wrapper .message .text,.right-wrapper .message .text{line-height:1.2;font-style:italic}.home-message-wrapper .message.editable,.right-wrapper .message.editable{transition:outline-offset .2s;outline:3px solid rgba(191,164,75,0);outline-offset:7px;transition:box-shadow .1s,background .1s;cursor:pointer}.home-message-wrapper .message.editable:hover,.right-wrapper .message.editable:hover{background:rgba(5,5,5,.2)}.home-message-wrapper .message.editable:hover .edit-icon,.right-wrapper .message.editable:hover .edit-icon{display:block}.home-message-wrapper .message.editable:hover .info-icon,.right-wrapper .message.editable:hover .info-icon{display:none}.home-message-wrapper .message.editable:focus,.right-wrapper .message.editable:focus{outline-color:rgba(191,164,75,.3);outline-offset:0}.home-message-wrapper .message.editable .edit-icon,.right-wrapper .message.editable .edit-icon{flex:0 0 auto;display:none;width:80%;margin-left:5%}@media (-ms-high-contrast:active),(-ms-high-contrast:none){.home-message-wrapper .message.editable .edit-icon,.right-wrapper .message.editable .edit-icon{height:80%}}.home-message-wrapper .message .icon-wrapper,.right-wrapper .message .icon-wrapper{flex:0 0 auto;background:#bfa44b;color:#fff;border-radius:100%;margin-right:10px;width:1.7rem;height:1.7rem;display:flex;justify-content:center;align-items:center;font-size:1.2rem;font-weight:600}.right-wrapper.preview-message.preview-message{display:flex;flex-direction:row;justify-content:center;align-items:flex-start;position:relative;z-index:-1}.right-wrapper.preview-message.preview-message .message.message{margin-top:5%;max-width:100%;z-index:9}.right-wrapper.preview-message.preview-message .shade{display:none;position:absolute;left:0;top:0;width:100%;height:30%;z-index:8;background:linear-gradient(180deg,#303030 0,#303030 36%,rgba(48,48,48,.5) 70%,rgba(48,48,48,0) 99%,rgba(48,48,48,0))}.quick-links-editor{padding-top:20px}.quick-links-editor .add-link{width:calc(100% - 40px)}.version-table{margin-top:40px}.version-table td{padding:10px}", ""]);
	
	// exports


/***/ },
/* 858 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(10)();
	// imports
	
	
	// module
	exports.push([module.id, "li.list-block{width:100%;max-width:550px;display:flex;align-items:center;padding:10px;border-radius:3px;background:#eeeeec;margin:4px;box-shadow:0 1px 1px rgba(0,0,0,.3);border-top:1px solid #e4e4e1;border-left:4px solid transparent;transition:background .1s}li.list-block .list-title-wrapper{display:flex;flex-direction:column}li.list-block .list-title-wrapper span.dr-title{font-weight:400;font-size:1rem;color:#505050}li.list-block .list-title-wrapper span:last-child{margin-top:4px;color:gray;font-style:italic}li.list-block .list-subtitle{display:flex;flex-direction:row;align-items:center;font-size:.8rem}li.list-block .list-subtitle svg{margin-right:7px;width:16px;height:16px}li.list-block .list-subtitle .date.date{margin-top:0;margin-right:5px}li.list-block .list-buttons{display:flex;flex-direction:row;margin-left:auto}li.list-block .list-buttons button{height:40px;border-radius:3px;border:1px solid #9a9a8e;color:#59594f;background:none;font-size:.85rem;transition:outline-offset .2s;outline:3px solid rgba(191,164,75,0);outline-offset:7px}li.list-block .list-buttons button:hover{background:#e2e2df}li.list-block .list-buttons button:focus{outline-color:rgba(191,164,75,.3);outline-offset:0}li.list-block .list-buttons button:last-child{margin-left:8px}li.list-block .list-buttons button.fixed{width:40px;padding:1px;padding-top:2px}li.list-block.list-active{border-left-color:#41be46}li.list-block.list-cancelled,li.list-block.list-failed{border-left-color:#c01027}li.list-block.list-complete{border-left-color:#e2e2df}li.list-block.active{background:#dbdbd6}", ""]);
	
	// exports


/***/ },
/* 859 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(10)();
	// imports
	
	
	// module
	exports.push([module.id, "h1{font-size:12pt}h2{font-weight:700}li{margin-left:12px;margin-top:3px;font-size:10pt}.lists-page{display:flex;flex-direction:row;flex-wrap:wrap}.list-wrapper{display:flex;flex-direction:column;padding:10px}.list-wrapper h2{padding:15px;background:#e4e4e3;font-size:1rem}.list-wrapper ul{padding:15px;background:hsla(60,2%,89%,.4)}.list-wrapper li{padding:0;margin:0;margin-bottom:15px;list-style:none}.list-wrapper li:last-child{margin-bottom:0}.list-wrapper li a{color:#000;text-decoration-color:#999794}@media only screen and (max-width:768px){.list-wrapper{width:100%}}.list-spinner{transform:scale(.8);margin-left:-4px;margin-top:-4px}", ""]);
	
	// exports


/***/ },
/* 860 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(10)();
	// imports
	
	
	// module
	exports.push([module.id, ".orbit-loader{display:inline-block;position:relative;width:15px;height:15px}.orbit-loader.linear.linear.linear div{animation-timing-function:linear}.orbit-loader.inherit div{background:currentColor}.orbit-loader.primary div{background:#1c1c1c}.orbit-loader.secondary div{background:#bfa44b}.orbit-loader.neutral div{background:#e4e4e3}.orbit-loader.medium-neutral div{background:#c9c7c4}.orbit-loader.dark-neutral div{background:#999794}.orbit-loader .top{animation:orbit-top .5s ease-in-out infinite}.orbit-loader .right{animation:orbit-right .5s ease-in-out infinite}.orbit-loader .bottom{animation:orbit-bottom .5s ease-in-out infinite}.orbit-loader .left{animation:orbit-left .5s ease-in-out infinite}.orbit-loader div{position:absolute;left:0;top:0;width:15px;height:15px;border-radius:100%}@keyframes orbit-top{0%{transform:rotate(0deg) translateY(30px) rotate(0deg)}to{transform:rotate(1turn) translateY(30px) rotate(-1turn)}}@keyframes orbit-right{0%{transform:rotate(0deg) translateX(30px) rotate(0deg)}to{transform:rotate(1turn) translateX(30px) rotate(-1turn)}}@keyframes orbit-bottom{0%{transform:rotate(0deg) translateY(-30px) rotate(0deg)}to{transform:rotate(1turn) translateY(-30px) rotate(-1turn)}}@keyframes orbit-left{0%{transform:rotate(0deg) translateX(-30px) rotate(0deg)}to{transform:rotate(1turn) translateX(-30px) rotate(-1turn)}}.orbit-loader.small{display:block;position:relative;width:1px;height:1px}.orbit-loader.small div{position:absolute;left:0;top:0;width:6px;height:6px;border-radius:100%}.orbit-loader.small .top{animation:orbit-top-small .5s ease-in-out infinite}.orbit-loader.small .right{animation:orbit-right-small .5s ease-in-out infinite}.orbit-loader.small .bottom{animation:orbit-bottom-small .5s ease-in-out infinite}.orbit-loader.small .left{animation:orbit-left-small .5s ease-in-out infinite}@keyframes orbit-top-small{0%{transform:rotate(0deg) translateY(7px) rotate(0deg)}to{transform:rotate(1turn) translateY(7px) rotate(-1turn)}}@keyframes orbit-right-small{0%{transform:rotate(0deg) translateX(7px) rotate(0deg)}to{transform:rotate(1turn) translateX(7px) rotate(-1turn)}}@keyframes orbit-bottom-small{0%{transform:rotate(0deg) translateY(-7px) rotate(0deg)}to{transform:rotate(1turn) translateY(-7px) rotate(-1turn)}}@keyframes orbit-left-small{0%{transform:rotate(0deg) translateX(-7px) rotate(0deg)}to{transform:rotate(1turn) translateX(-7px) rotate(-1turn)}}.orbit-loader.medium{display:block;position:relative;width:10px;height:10px}.orbit-loader.medium div{position:absolute;left:0;top:0;width:10px;height:10px;border-radius:100%}.orbit-loader.medium .top{animation:orbit-top-medium .5s ease-in-out infinite}.orbit-loader.medium .right{animation:orbit-right-medium .5s ease-in-out infinite}.orbit-loader.medium .bottom{animation:orbit-bottom-medium .5s ease-in-out infinite}.orbit-loader.medium .left{animation:orbit-left-medium .5s ease-in-out infinite}@keyframes orbit-top-medium{0%{transform:rotate(0deg) translateY(16px) rotate(0deg)}to{transform:rotate(1turn) translateY(16px) rotate(-1turn)}}@keyframes orbit-right-medium{0%{transform:rotate(0deg) translateX(16px) rotate(0deg)}to{transform:rotate(1turn) translateX(16px) rotate(-1turn)}}@keyframes orbit-bottom-medium{0%{transform:rotate(0deg) translateY(-16px) rotate(0deg)}to{transform:rotate(1turn) translateY(-16px) rotate(-1turn)}}@keyframes orbit-left-medium{0%{transform:rotate(0deg) translateX(-16px) rotate(0deg)}to{transform:rotate(1turn) translateX(-16px) rotate(-1turn)}}.page-loader{flex:0 0 auto}.loader-wrapper{display:flex;height:100%;justify-content:center;align-items:center}.button-loader,.button-loader.small{display:block;height:1px;margin-top:10px;margin-left:10px;margin-right:10px}.button-loader.small div,.button-loader div{background:#b0b0b0}", ""]);
	
	// exports


/***/ },
/* 861 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(10)();
	// imports
	
	
	// module
	exports.push([module.id, ".migration-page .section{gap:15px}.migration-page .description{font-style:italic}.migration-page .danger-text{font-weight:600;color:#9c1a25;font-style:italic}.migration-page p{max-width:600px;line-height:1.2}.migration-page .field{padding-top:0;padding-bottom:0}.migration-page ul{padding-left:20px}.migration-page li{max-width:600px;line-height:1.2;margin-bottom:8px}", ""]);
	
	// exports


/***/ },
/* 862 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(10)();
	// imports
	
	
	// module
	exports.push([module.id, ".modal-wrapper{position:fixed;z-index:9999;top:0;left:0;display:flex;justify-content:center;align-items:center;width:100%;height:100%}.modal-wrapper .shade{background:rgba(0,0,0,.6);position:fixed;top:0;left:0;width:100vw;height:100vh;animation-duration:.3s;transition:opacity .3s}.modal-wrapper.fullscreen{width:100%;height:100%;width:100vw;height:100vh;padding:20px}@media only screen and (max-width:480px){.modal-wrapper.fullscreen{overflow-y:auto}}.modal-wrapper .modal{width:calc(100% - 16px);max-width:400px;height:80vh;display:block;background:#fff;border-radius:3px;position:relative;border-radius:9px 9px 5px 5px;z-index:99;font-size:.85rem;flex:0 0 auto;animation-duration:.3s;-webkit-box-shadow:0 2px 4px 0 rgba(0,0,0,.3);-moz-box-shadow:0 2px 4px 0 rgba(0,0,0,.3);box-shadow:0 2px 4px 0 rgba(0,0,0,.3)}@media only screen and (max-width:480px){.modal-wrapper .modal{height:calc(100% - 16px)}}.modal-wrapper .modal.toast{max-width:350px;height:200px;height:auto;border-radius:4px}.modal-wrapper .modal.toast.toast-wide{max-width:400px}.modal-wrapper .modal.short{max-width:400px;height:auto}.modal-wrapper .modal.medium{max-width:600px}.modal-wrapper .modal.large{max-width:800px}.modal-wrapper .modal.fullscreen{max-width:100%;height:100%;left:0;top:0;position:relative}.modal-wrapper .modal.no-background{background:none;box-shadow:none;pointer-events:none}.modal-wrapper .modal.no-background *{pointer-events:all}.modal-wrapper .modal.hide-header{border-radius:5px}.modal-wrapper .modal.hide-header .close-button{position:absolute;right:5px;top:5px;border:none;background:none;color:#999794;width:25px;height:25px;font-size:.9rem}.modal-wrapper .modal.auto-height{height:auto;max-height:calc(100vh - 88px)}.modal-wrapper .modal.auto-height .template{max-height:calc(100vh - 140px)}.modal-wrapper .modal.light-neutral{background:#eeeeec}.modal-wrapper .modal .padded{padding:10px}.modal-wrapper .modal p{margin-bottom:15px;line-height:1.3}.modal-wrapper .modal p:last-child{margin-bottom:0}.modal-wrapper .modal .close-button{background:none;border:none;color:#fff;font-size:1.4rem;line-height:1rem;padding:2px 3px 4px;margin-bottom:-1px;border-radius:4px;cursor:pointer;display:flex;text-align:center;justify-content:center;align-items:center;outline:3px solid rgba(191,164,75,0);outline-offset:5px;transition:outline .2s,outline-offset .2s}.modal-wrapper .modal .close-button:focus{outline:3px solid rgba(191,164,75,.7);outline-offset:0}.modal-wrapper .modal .close-button:hover{background:hsla(0,0%,100%,.1)}.modal-wrapper .modal .close-button:active{background:hsla(0,0%,100%,.15)}.modal-wrapper .modal .modal-body{padding:15px}.modal-wrapper .modal .modal-body h1,.modal-wrapper .modal .modal-body h2,.modal-wrapper .modal .modal-body h3,.modal-wrapper .modal .modal-body h4,.modal-wrapper .modal .modal-body h5{font-weight:700;text-align:center;margin:0}.modal-wrapper .modal .modal-body .input-wrapper{margin-bottom:10px}.modal-wrapper .modal .modal-body .toast-message{text-align:center;margin-bottom:15px;margin-top:10px;display:block;font-size:.9rem;line-height:1.2rem}.modal-wrapper .modal .modal-body .button-wrapper{display:flex;width:100%;padding:10px 0}.modal-wrapper .modal .modal-body .button-wrapper button{flex:1 0 auto;margin:0 5px}.modal-wrapper .modal .header{background:#303030;color:#fff;padding:0 12px;height:51px;font-size:24px;font-weight:300;font-family:Open Sans,sans-serif;position:relative;border-top:0 solid #4a4a4a;border-radius:5px 5px 0 0;display:flex;flex-direction:row;align-items:center;-webkit-box-shadow:0 4px 7px 0 rgba(0,0,0,.2);-moz-box-shadow:0 4px 7px 0 rgba(0,0,0,.2);box-shadow:0 4px 7px 0 rgba(0,0,0,.2)}.modal-wrapper .modal .header.small{padding:10px;font-size:20px}.modal-wrapper .modal .header.danger{background:#c01027;border-color:#ec1733}.modal-wrapper .modal .header.danger .close{background:#4a060f}.modal-wrapper .modal .header.danger .close:hover{background:#790a19}.modal-wrapper .modal .header .btn-primary:hover{background:#242424}.modal-wrapper .modal .header .title{flex:1;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;margin-top:3px;height:100%;display:flex;align-items:center;padding-bottom:3px}.modal-wrapper .modal .header .button-group{display:flex;flex:0 0 auto;margin-left:auto}.modal-wrapper .modal .header .button-group .btn{margin-left:7px}.modal-wrapper .modal .header .icon-times-circle{margin-top:2px;margin-right:5px;float:left}.modal-wrapper .modal .header .close{font-size:14px;border:none;padding:4px 8px;font-family:Open Sans,sans-serif;margin-top:0;margin-left:5px}.modal-wrapper .modal .header .close .modal-icon{float:left;margin-top:2px}.modal-wrapper .modal .header .close .text{vertical-align:top}.modal-wrapper .modal .scrollable{overflow:auto;max-height:calc(100% - 51px);border-radius:0 0 5px 5px}.modal-wrapper .no-background-close{position:absolute;display:flex;flex-direction:row;justify-content:center;align-items:center;font-size:1.2rem;width:1.8rem;height:1.8rem;color:#fff;right:-.75rem;top:-.75rem;background:#303030;border-radius:100%;border:none;cursor:pointer;z-index:9;box-shadow:0 1px 3px rgba(0,0,0,.12),0 1px 2px rgba(0,0,0,.24);transition:outline-offset .2s;outline:3px solid rgba(191,164,75,0);outline-offset:7px}.modal-wrapper .no-background-close:hover{color:hsla(0,0%,100%,.8)}.modal-wrapper .no-background-close:focus{outline-color:rgba(191,164,75,.3);outline-offset:0}.modal-wrapper .scroll-wrapper{overflow-y:auto;height:calc(100% - 40px)}.modal-wrapper .inner-body{padding:20px}.modal-wrapper.modal-obscured{z-index:999;user-select:none;pointer-events:none}.dialog-input.field{width:100%;display:flex;flex-direction:column;padding:5px}.dialog-input.field label{font-size:.85rem;font-weight:600;display:block;position:relative;margin-bottom:3px}.dialog-input.field input[type=text],.dialog-input.field select[type=text]{width:100%;padding-left:10px;border:3px solid #c3c3c3;border-radius:5px;height:35px}.dialog-input.field input:focus,.dialog-input.field select:focus{outline:none;border-color:#25bdf5}", ""]);
	
	// exports


/***/ },
/* 863 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(10)();
	// imports
	
	
	// module
	exports.push([module.id, ".receipt-details-divider{border:none;border-bottom:1px dotted #999}.receipt-details-divider:first-child{display:none}h5{margin-bottom:10px;font-size:14px;font-weight:800;color:#6b6966}.error-message{color:#c01027;text-align:center;font-size:.8rem;font-style:italic;line-height:1.2}.receipt-details-list{padding:10px 0;position:relative;margin:0;width:100%}.receipt-details-list .receipt-details-divider:first-child{display:block}.receipt-details-list tr:last-child .receipt-details-divider{display:none}.receipt-details-list .receipt-detail{font-size:.8rem}.receipt-details-list .receipt-detail.alert .receipt-label{color:#c01027}.receipt-details-list .receipt-detail.alert .receipt-label:before{content:\"\";background:#c01027;box-shadow:0 2px 3px rgba(0,0,0,.3);width:15px;height:15px;color:#fff;border-radius:100%;display:inline-block;margin-right:5px;text-align:center;font-style:normal;font-weight:800;padding-top:1px;vertical-align:top;z-index:9;content:\"!\"}.receipt-details-list .receipt-detail.alert .receipt-value{color:#c01027}.receipt-details-list .receipt-detail .receipt-label{text-align:right;padding-right:10px;font-style:italic;color:#666;white-space:pre-wrap;position:relative;padding-top:7px;padding-bottom:6px;border-right:1px dotted #999;max-width:20%}.receipt-details-list .receipt-detail .receipt-label.full-width{text-align:left;border-right:none}.receipt-details-list .receipt-detail .receipt-value{padding-left:10px;padding-top:7px;padding-bottom:6px;font-weight:600;color:#444;white-space:pre-wrap;width:80%}.receipt-details-list .receipt-detail .receipt-value .modal-link{border:none;text-decoration:underline;color:#00e;cursor:pointer}.receipt-details-list .receipt-detail .receipt-value .error{color:#c01027;font-style:italic;font-weight:100}", ""]);
	
	// exports


/***/ },
/* 864 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(10)();
	// imports
	
	
	// module
	exports.push([module.id, ".report-download{display:flex;flex-direction:column;width:100%}.report-download h5{margin-bottom:10px;font-size:14px;font-weight:800;color:#6b6966}", ""]);
	
	// exports


/***/ },
/* 865 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(10)();
	// imports
	
	
	// module
	exports.push([module.id, ".ownership.ownership{padding:10px}.ownership.ownership .action-button-group{margin:0}.ownership.ownership .ownership-action-cell{justify-content:space-around}.ownership.ownership .ownership-action-cell .action-icon.action-icon.action-icon{background:#1c1c1c;border:none;color:#fff;display:flex;align-items:center;justify-content:center}.ownership.ownership .ownership-action-cell .action-icon.action-icon.action-icon:hover{background:#292929}.ownership.ownership .ownership-action-cell .action-icon.action-icon.action-icon *{flex:0 0 auto}.ownership.ownership .tip{background:#1c1c1c;color:#fff;width:14px;height:14px;display:flex;justify-content:center;align-items:center;border-radius:100%;font-weight:600;margin-left:4px}.my-records{display:flex;flex-direction:column}.my-records .loader-wrapper{display:flex;align-items:center;justify-content:center;height:90%}.empty-placeholder-wrapper{display:flex;width:100%;justify-content:center;align-items:center;padding-top:50px;flex-direction:column;left:0;top:0;padding-left:30px;padding-right:30px}.empty-placeholder-wrapper img,.empty-placeholder-wrapper svg{width:100%;max-width:200px;opacity:.5}.empty-placeholder-wrapper img{max-width:200px}.empty-placeholder-wrapper h2{font-size:1.5rem;color:#949494;margin-top:2rem;text-align:center}.empty-placeholder-wrapper p{font-size:1.25rem;color:#949494;margin-top:1rem;text-align:center}.empty-placeholder-wrapper a{text-align:center;padding:12px 16px}.empty-placeholder-wrapper div{margin-top:1.5rem;padding-left:1rem}@media only screen and (max-width:480px){.empty-placeholder-wrapper div{flex-direction:column}}.empty-placeholder-wrapper .or{margin:0 15px}@media only screen and (max-width:480px){.empty-placeholder-wrapper .or{margin:15px 0}}.empty-placeholder-wrapper.error h3,.empty-placeholder-wrapper.error p{color:#b58085}.ownership,.request-ownership,.request-pins{padding:20px}.ownership .button-column,.request-ownership .button-column,.request-pins .button-column{display:flex;align-items:flex-end;justify-content:center}.ownership .button-column .btn,.request-ownership .button-column .btn,.request-pins .button-column .btn{margin-bottom:10px}.ownership .loader-wrapper,.request-ownership .loader-wrapper,.request-pins .loader-wrapper{display:flex;align-items:center;justify-content:center;min-height:40px}.ownership .error,.request-ownership .error,.request-pins .error{color:#c01027;font-style:italic;padding:5px;font-size:.8rem}.ownership .divider,.request-ownership .divider,.request-pins .divider{border:none;border-bottom:1px solid #c9c7c4;margin-bottom:25px}.ownership .center-text,.request-ownership .center-text,.request-pins .center-text{text-align:center}.ownership .margin-top,.request-ownership .margin-top,.request-pins .margin-top{margin-top:15px}.ownership .success,.request-ownership .success,.request-pins .success{font-size:.85rem;color:#41be46}.ownership .pin-description,.request-ownership .pin-description,.request-pins .pin-description{margin-bottom:20px}.ownership .checkbox-column .checkbox-wrapper,.request-ownership .checkbox-column .checkbox-wrapper,.request-pins .checkbox-column .checkbox-wrapper{margin-bottom:15px}.ownership .checkbox-wrapper .checkbox-label,.request-ownership .checkbox-wrapper .checkbox-label,.request-pins .checkbox-wrapper .checkbox-label{font-weight:400}.ownership .attestation-hint.attestation-hint.attestation-hint,.request-ownership .attestation-hint.attestation-hint.attestation-hint,.request-pins .attestation-hint.attestation-hint.attestation-hint{margin-bottom:18px;display:block;font-style:italic}.ownership .attestation-hint.attestation-hint.attestation-hint:before,.request-ownership .attestation-hint.attestation-hint.attestation-hint:before,.request-pins .attestation-hint.attestation-hint.attestation-hint:before{content:\"!\";background:#1c1c1c;color:#fff;width:15px;height:15px;font-weight:800;line-height:1;border-radius:100%;text-align:center;font-style:normal;display:inline-block;margin-right:6px}.amendment-launcher{overflow:auto;height:calc(100% - 57px)}.amendment-launcher .amendments{display:flex;flex-direction:column;width:100%}.amendment-launcher .amendments p.empty{padding:15px}.amendment-launcher .form-block-card{position:relative;transform:none;box-shadow:none;margin-bottom:0;left:auto;top:auto;overflow:visible;background:none;border:none;cursor:pointer;text-align:left}.amendment-launcher .form-block-card:disabled{cursor:default}.amendment-launcher .form-block-card:disabled:hover{background:none}.amendment-launcher .form-block-card:disabled .form-block-icon-container,.amendment-launcher .form-block-card:disabled .title{color:#999794}.amendment-launcher .form-block-card:disabled .form-block-icon-container .abbr{background:#999794}.amendment-launcher .form-block-card:hover{background:rgba(0,0,0,.05)}.amendment-launcher .form-block-card .form-block{margin-bottom:0}.amendment-launcher .form-block-card .markdown p{white-space:pre-wrap;overflow-wrap:break-word}.amendment-launcher .form-block-card .red{color:#c01027;font-weight:700;margin-top:-20px}.amendment-launcher .form-block-card .default{font-weight:700;margin-top:-20px}.fd-block{flex:0 0 auto;display:flex;flex-direction:row;width:100%;padding:15px;cursor:pointer}.fd-block:hover{background:#eeeeec}.fd-block:active{background:#e4e4e3}.fd-block .image-col{flex:0 0 auto;height:100%;min-height:100%;display:flex;justify-content:center;align-items:center;flex-direction:column}.fd-block .image{flex:0 0 auto;width:50px;height:50px;overflow:hidden;border-radius:100%;position:relative}.fd-block .image img{width:100%}.fd-block .image .img-shade{background:rgba(28,28,28,.6);position:absolute;left:0;top:0;width:100%;height:100%}.fd-block .text{flex:0 0 auto;max-width:calc(100% - 70px)}.fd-block .text h4{font-weight:600;font-size:1rem;padding:10px;padding-top:0;padding-bottom:5px;color:#000}.fd-block .text p{padding:0 10px;font-style:italic;color:#666665}.my-records .div-table-cell span.cell:nth-child(2){display:block;font-style:italic;font-size:11.5px;padding-top:6px;font-weight:500}.reinstatement{min-height:130px;padding:20px;display:flex;flex-direction:column}.reinstatement .instructions{margin-bottom:15px}.reinstatement.center{justify-content:center;align-items:center}.reinstatement a{text-decoration:none;color:#000;font-weight:700}.reinstatement .disabled-link{pointer-events:none;opacity:.4}.record-loading{pointer-events:none;opacity:.5}.pins-page{display:flex;justify-content:center;align-items:center;height:calc(100vh - 60px - 30px)}.pins-page .pins-body{padding:30px;width:400px}.pins-page .pins-body .button-column{display:flex;align-items:flex-end;padding-bottom:10px}.pins-page p.description{line-height:1.3;margin-bottom:10px;white-space:pre-wrap}.pins-page .enter-pin-description{margin-bottom:20px}.pins-page .text-success{color:#2e8531;font-style:italic;line-height:1.3}.pins-page .text-success a{color:#2e8531}.pins-page .error{color:#c01027;font-style:italic;line-height:1.3}.pins-page .continue-wrapper{display:flex;justify-content:flex-end;margin-top:10px;padding-right:2px}.pins-page .continue-wrapper a{display:block;text-decoration:none;padding-top:10px;padding-bottom:10px;margin-right:10px}.pins-page .success-wrapper p{line-height:1.3;margin-bottom:30px}@media only screen and (max-width:768px){.pins-page{align-items:flex-start;height:auto}.pins-page .pins-body{width:100%}}", ""]);
	
	// exports


/***/ },
/* 866 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(10)();
	// imports
	
	
	// module
	exports.push([module.id, ".work-queue .action-button-group{margin:0;align-content:flex-start;justify-content:flex-start;flex-flow:unset;padding:0 5px}.work-queue .div-table-cell span.cell:nth-child(2){display:block;font-style:italic;font-size:11.5px;padding-top:6px;font-weight:500}", ""]);
	
	// exports


/***/ },
/* 867 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(10)();
	// imports
	
	
	// module
	exports.push([module.id, ".reports-list{display:flex;flex-direction:column;width:100%}.reports-list h5{margin-bottom:10px;font-size:14px;font-weight:800;color:#6b6966}.report{display:flex;align-items:center;padding:10px;background:rgba(198,174,94,.25);color:#413717;font-weight:600;font-size:1rem;min-height:50px;border-radius:5px;margin-bottom:5px;overflow:hidden;position:relative;will-change:box-shadow,background,transform;animation-fill-mode:backwards;border:none;font-family:Open Sans,sans-serif;justify-content:flex-start;outline:none;transition:box-shadow .3s,background .3s,transform .3s;cursor:pointer}.report:focus,.report:hover{background:#f5f0e1;box-shadow:0 9px 12px -7px rgba(83,71,30,.5);transform:scale(1.03)}.report:focus .download-icon,.report:hover .download-icon{background:hsla(47,48%,67%,.5)}.report:focus .shine,.report:hover .shine{opacity:1}.report:focus .shine:before,.report:hover .shine:before{transform:translateX(0)}.report:focus{background:rgba(198,174,94,.45)}.report:last-child{margin-bottom:0}.report .download-icon{flex:0 0 auto;width:40px;height:40px;color:#8c7732;padding:5px;border-radius:100%;background:rgba(198,174,94,.5);margin-right:8px;transition:background .3s;will-change:background;display:flex;justify-content:center;align-items:center;overflow:hidden;position:relative}.report .labels{display:flex;flex-direction:column;justify-content:center;align-items:flex-start}.report .labels span{text-align:left}.report .labels .date{font-size:.75rem;font-style:italic;margin-top:0}.report .shine-spinner{position:absolute;left:0;top:20%;width:100%;height:25px;background:linear-gradient(hsla(0,0%,100%,0),hsla(0,0%,100%,.5),hsla(0,0%,100%,0));flex:0 0 auto;animation:spin .3s infinite linear}.report .shine{position:absolute;width:calc(100% - 6px);height:calc(100% - 6px);border-radius:5px;left:3px;top:3px;overflow:hidden;transition:opacity .4s;will-change:opacity;opacity:0}.report .shine:before{content:\"\";background:radial-gradient(hsla(0,0%,100%,.6),hsla(0,0%,100%,0));width:200%;height:150%;border-radius:100%;position:absolute;top:-90%;right:-20%;z-index:9;transition:transform .5s;will-change:transform;transform:translateX(250px)}.report.error{background:#f7a5af}.report.error .download-icon{color:#790a19;background:rgba(216,18,44,.2)}.report.error:focus,.report.error:hover{background:#f9b3bc;box-shadow:0 9px 12px -7px rgba(51,4,10,.5)}.report.error:focus .download-error,.report.error:hover .download-error{background:#f9b3bc}.report.error:focus .download-icon,.report.error:hover .download-icon{background:rgba(238,47,72,.3)}.report .download-error{position:absolute;left:58px;top:0;width:calc(100% - 58px);height:100%;text-align:center;display:flex;justify-content:center;align-items:center;font-size:.8rem;font-style:italic;padding:10px;color:#3c050c;background:#f7a5af;transition:background .3s,opacity .3s;font-weight:600}.spin-in{animation:spin-in .1s ease-out;animation-fill-mode:forwards}.spin-out{animation:spin-out .1s ease-in;animation-fill-mode:forwards}@keyframes spin{0%{transform:rotate(0deg)}to{transform:rotate(1turn)}}@keyframes spin-in{0%{transform:rotate(-60deg);opacity:0}to{transform:rotate(0deg);opacity:1}}@keyframes spin-out{0%{transform:rotate(0deg);opacity:1}to{transform:rotate(80deg);opacity:0}}.reports-spinner{width:100%;display:flex;justify-content:center;animation-delay:.5s;padding-top:30px}.shine-spinner{position:absolute;left:0;top:20%;width:100%;height:25px;background:linear-gradient(hsla(0,0%,100%,0),hsla(0,0%,100%,.5),hsla(0,0%,100%,0));flex:0 0 auto;animation:spin .3s infinite linear}", ""]);
	
	// exports


/***/ },
/* 868 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(10)();
	// imports
	
	
	// module
	exports.push([module.id, ".not-found{display:flex;flex-direction:column}.not-found h1{font-weight:800;color:#e4e4e3;font-size:30vh;text-align:center;text-shadow:2vh 2vh 0 rgba(191,164,75,.1);padding:30px}@media only screen and (max-width:768px){.not-found h1{font-size:20vh}}.not-found .message{text-align:center;font-size:1.5rem;width:100%;padding:20px;max-width:800px;align-self:center;color:#666665;font-style:italic;line-height:1.4}@media only screen and (max-width:768px){.not-found .message{font-size:1rem}}.not-found .message a{color:#666665;text-decoration:none;border-bottom:3px solid #bfa44b;transition:border-bottom-width .15s,background .15s}.not-found .message a:hover{border-bottom-width:6px;background:rgba(191,164,75,.1)}.not-found .quick-links{display:flex;flex-direction:row;justify-content:space-around;width:100%;max-width:800px;align-self:center;margin-top:50px}@media only screen and (max-width:768px){.not-found .quick-links{flex-direction:column;margin-top:10px}.not-found .quick-links .quick-link{margin-bottom:15px}}.not-found .quick-link{display:flex;flex-direction:column;justify-content:center;align-items:center;text-decoration:none}.not-found .quick-link:hover .title{border-bottom:3px solid #bfa44b;background:rgba(191,164,75,.1)}.not-found .quick-link .icon-wrapper{width:70px;height:70px;border-radius:100%;background:rgba(191,164,75,.1);color:#666665;padding:10px}.not-found .quick-link .icon-wrapper .svg-icon{width:100%}.not-found .quick-link .title{font-size:1rem;font-weight:600;padding:10px;color:#666665;border-bottom:3px solid transparent;margin-top:10px;transition:border .15s,background .15s}", ""]);
	
	// exports


/***/ },
/* 869 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(10)();
	// imports
	
	
	// module
	exports.push([module.id, ".generic-page-error{padding:4rem 0;text-align:center;width:100%}.generic-page-error h2{font-size:2.5rem}.generic-page-error .error-details-header{display:block;font-size:1.5rem;font-style:italic;font-weight:600}.generic-page-error .error-description-line{display:block;font-size:1.25rem;font-weight:600;line-height:120%;max-width:600px;overflow-wrap:break-word;padding:.2rem}.generic-page-error .error-flex-margin{margin:1rem 0;max-width:100%}.generic-page-error .error-icon{max-width:15rem;min-width:5rem}.generic-page-error .error-text-color{color:#c35b5b}.generic-page-error .grey-top-border{border-top:1px solid #a5a6aa}", ""]);
	
	// exports


/***/ },
/* 870 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(10)();
	// imports
	
	
	// module
	exports.push([module.id, ".pager{margin-top:15px;margin-bottom:15px}.pager,.pager button{display:flex;justify-content:center}.pager button{padding:10px;background:#e4e4e3;border:1px solid #c9c7c4;border-right:none;align-items:center;font-size:14px;outline:none}.pager button:hover{background:#eeeeec}.pager button:focus{background:#d7d7d6}.pager button:first-child{border-radius:5px 0 0 5px}.pager button:last-child{border-radius:0 5px 5px 0;border-right:1px solid #c9c7c4}.pager button:only-child{border-radius:5px}.pager button.active{background:#d5d4d1}.pager button svg{width:14px}", ""]);
	
	// exports


/***/ },
/* 871 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(10)();
	// imports
	
	
	// module
	exports.push([module.id, ".generic-itransact{padding:30px}.generic-itransact .instructions{font-size:.9rem}.generic-itransact .payment-source{font-size:1rem;margin-bottom:16px;display:flex;align-items:center}.generic-itransact .payment-source:last-of-type{margin-bottom:0}.generic-itransact .payment-source .label-wrapper{padding-top:0}.generic-itransact .payment-source svg{width:24px;height:24px;margin-right:10px;fill:#1c1c1c}.generic-itransact .payment-source .select-button{margin-right:10px}.generic-itransact .add-button{font-size:.85rem;margin-top:20px}.generic-itransact .add-button svg{margin-right:10px;width:18px;height:18px}.generic-itransact .delete-method-button{margin-left:auto;padding:4px 5px 3px}.generic-itransact .delete-method-button svg{fill:#c01027;margin:0;width:22px;height:22px}", ""]);
	
	// exports


/***/ },
/* 872 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(10)();
	// imports
	
	
	// module
	exports.push([module.id, ".print-table table{border-collapse:none;border-spacing:none}.print-table table,.print-table td,.print-table th{border:1px solid #000}.print-table th{padding:10px;text-align:center;font-weight:600;background:#ededed}.print-table td{padding:5px}", ""]);
	
	// exports


/***/ },
/* 873 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(10)();
	// imports
	
	
	// module
	exports.push([module.id, ".record-history{padding:30px 20px;padding-top:15px}.record-history .toolbar{margin-bottom:15px;display:flex;flex-direction:row;justify-content:flex-end}.record-history .amendment-wrapper{display:flex;flex-direction:column;padding:0 0 30px 30px;border-left:6px solid #e4e4e3;position:relative}.record-history .amendment-wrapper:before{content:\"\";width:16px;height:16px;border-radius:100%;background:#1c1c1c;position:absolute;left:-11px;top:-5px}.record-history .amendment-wrapper:last-child{padding-bottom:0;border-left-color:transparent}.record-history .amendment-wrapper .title{background:#1c1c1c;border:none;padding:8px;color:#fff;border-radius:0 9px 0 0;display:flex;flex-direction:row;font-weight:600;position:relative;outline:none;cursor:pointer;transition:background 50ms}.record-history .amendment-wrapper .title:hover{background:#303030}.record-history .amendment-wrapper .title:hover:before{border-color:transparent #303030 transparent transparent}.record-history .amendment-wrapper .title:focus .svg-icon{outline-color:rgba(191,164,75,.3);outline-offset:0}.record-history .amendment-wrapper .title:before{content:\"\";position:absolute;left:-17px;top:0;width:0;height:0;border-style:solid;border-width:0 17px 17px 0;border-color:transparent #1c1c1c transparent transparent}.record-history .amendment-wrapper .title.collapsed{border-bottom-right-radius:9px;border-bottom-left-radius:9px}.record-history .amendment-wrapper .title span{margin-left:5px;font-style:italic;font-weight:400}.record-history .amendment-wrapper .title .svg-icon{width:20px;height:20px;margin-left:auto;transition:outline-offset .2s;outline:3px solid rgba(191,164,75,0);outline-offset:7px}.record-history .amendment-wrapper .amendment-drawer-wrapper{overflow:hidden}.record-history .amendment-wrapper .amendment-drawer{display:flex;flex-direction:row;transition:max-height .3s}.record-history .amendment-wrapper .amendment{background:#e4e4e3;padding:10px;flex:.3 1 auto;border-bottom-left-radius:9px}.record-history .amendment-wrapper .amendment.no-history{flex:1 1 auto}.record-history .amendment-wrapper .amendment .detail{display:flex;flex-direction:column;padding:6px 0}.record-history .amendment-wrapper .amendment .detail:first-child{padding-top:0}.record-history .amendment-wrapper .amendment .detail:last-child{padding-bottom:0}.record-history .amendment-wrapper .amendment .detail label{font-style:italic;font-size:.8rem;color:#716f6d;margin-bottom:4px}.record-history .amendment-wrapper .amendment .detail span{font-size:.9rem;font-weight:600}.record-history .amendment-wrapper .amendment .detail a .svg-icon{width:19px;display:inline-block;vertical-align:middle;padding-bottom:3px}.record-history .amendment-wrapper .table-wrapper{flex:1 1 auto}.record-history .amendment-wrapper table{flex:1 1 auto;height:100%;width:100%}.record-history .amendment-wrapper table th{text-align:left;padding:8px 7px;font-weight:600}.record-history .amendment-wrapper table th:first-child{background:#d7d7d6}.record-history .amendment-wrapper table th:nth-child(2){background:#f19ca7}.record-history .amendment-wrapper table th:nth-child(3){background:#cae8cb}.record-history .amendment-wrapper table tr:nth-child(odd) td:first-child{background:#f3f3f1}.record-history .amendment-wrapper table tr:nth-child(odd) td:nth-child(2){background:#f7c9cf}.record-history .amendment-wrapper table tr:nth-child(odd) td:nth-child(3){background:#f0faf0}.record-history .amendment-wrapper table tr:nth-child(2n) td:first-child{background:#e9e9e7}.record-history .amendment-wrapper table tr:nth-child(2n) td:nth-child(2){background:#f6c0c7}.record-history .amendment-wrapper table tr:nth-child(2n) td:nth-child(3){background:#e6f4e7}.record-history .amendment-wrapper table tr:last-child td{height:100%}.record-history .amendment-wrapper table tr:last-child td:nth-child(3){border-bottom-right-radius:9px}.record-history .amendment-wrapper table td{white-space:pre-wrap;padding:8px 7px}.history-modal{animation:none!important}", ""]);
	
	// exports


/***/ },
/* 874 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(10)();
	// imports
	
	
	// module
	exports.push([module.id, ".results-drawer{width:100%;position:absolute;top:58px;background:#fff;border:1px solid #c9c7c4;min-height:15px;border-radius:0 0 4px 4px;font-size:.9rem;font-color:#3d3c3b}.results-drawer .loading{padding:10px;display:block}.stacked-data-result{background:none;border:none;text-align:left;padding:5px 10px;width:100%;flex:0 0 auto;cursor:pointer;transition:outline-offset .2s;outline:3px solid rgba(191,164,75,0);outline-offset:7px}.stacked-data-result:nth-child(2n){background:#e4e4e3}.stacked-data-result:first-child{padding-top:10px}.stacked-data-result:last-child{padding-bottom:10px}.stacked-data-result:hover{background:rgba(191,164,75,.1)}.stacked-data-result:hover:nth-child(2n){background:rgba(191,164,75,.15)}.stacked-data-result:focus{outline-color:rgba(191,164,75,.3);outline-offset:0;z-index:99;outline-offset:-5px}.stacked-data-result.static{cursor:auto}.stacked-data-result.static:hover{background:initial;color:inherit}.stacked-data-result:disabled{cursor:default}.stacked-data-result:disabled:nth-child(2n){background:hsla(60,2%,89%,.85)}.stacked-data-result:disabled:hover{background:none}.stacked-data-result:disabled:hover:nth-child(2n){background:hsla(60,2%,89%,.85)}.stacked-data-result .primary,.stacked-data-result .secondary{display:block}.stacked-data-result .primary{font-weight:700;font-size:1rem}.stacked-data-result .secondary{font-size:.75rem;font-style:italic;font-weight:400;margin:3px 0;margin-top:8px;margin-bottom:2px}.stacked-data-result p.lines{margin-bottom:0}.stacked-data-result .value{font-weight:600}.stacked-data-result strong{background:rgba(191,164,75,.3);border:1px solid rgba(191,164,75,.7);border-radius:3px;font-weight:inherit}.stacked-data-result .value{padding-left:15px;display:block;font-size:.75rem;line-height:1.4}", ""]);
	
	// exports


/***/ },
/* 875 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(10)();
	// imports
	
	
	// module
	exports.push([module.id, ".saved-payments .list-wrapper{width:100%;display:flex;flex-direction:columns;align-items:center}.saved-payments-editor{transition:opacity .3s}.saved-payments-editor .payment-method{display:flex;align-items:center;padding-bottom:5px;margin-bottom:5px;color:#3d3c3b;font-size:.9rem}.saved-payments-editor .payment-method .brand{text-transform:capitalize;margin-right:5px;font-weight:800}.saved-payments-editor .payment-method .text{padding-top:3px}.saved-payments-editor .payment-method .digits{margin-left:5px;font-weight:800}.saved-payments-editor .payment-method em{font-style:italic}.saved-payments-editor .payment-method svg.svg-icon{width:24px;margin-right:8px;color:#1c1c1c;flex:0 0 auto}.saved-payments-editor .add-button{margin-top:15px}.saved-payments-editor .add-button:disabled{box-shadow:none;transition-delay:.2s;transition:background .2s,box-shadow .2s}.saved-payments-editor .add-button svg.svg-icon{margin-right:10px;margin-left:-5px}.saved-payments-editor .buttons{margin-left:auto;display:flex;flex-wrap:nowrap}.saved-payments-editor .control{border:none;border-radius:4px;padding:4px;font-size:.75rem;padding-right:10px;text-transform:uppercase;font-weight:600;transition:outline-offset .2s;outline:3px solid rgba(191,164,75,0);outline-offset:7px}.saved-payments-editor .control:focus{outline-color:rgba(191,164,75,.3);outline-offset:0}.saved-payments-editor .control svg.svg-icon{width:18px;margin:0;fill:#1c1c1c;flex:0 0 auto}.saved-payments-editor .control.danger{padding-right:4px;background:rgba(236,23,51,.25);color:#830b1b}.saved-payments-editor .control.danger svg.svg-icon{margin-right:0;fill:#830b1b}.saved-payments-editor .control.danger:hover{background:rgba(240,70,93,.25)}.saved-payments-editor .control.star{margin-right:5px;padding-right:4px;background:none}.saved-payments-editor .control.star:hover{background:#e5e0d4}.saved-payments-editor .control.star svg{margin-right:0;fill:#84754f}.saved-payments-editor .control.default:hover{background:none}", ""]);
	
	// exports


/***/ },
/* 876 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(10)();
	// imports
	
	
	// module
	exports.push([module.id, ".search-box{width:100%;max-width:600px;display:block;margin:0 auto;margin-top:15px;margin-bottom:35px}.search-box.long-descr{max-width:1200px}.search-box.long-descr .search-input-wrapper{max-width:600px;margin:0 auto}.search-box h1{font-size:32px;font-weight:600;margin-bottom:8px;color:#444;display:flex;flex-direction:row}.search-box h1 .align-right{margin-left:auto}.search-box .description{margin-bottom:5px;font-size:.9rem;font-style:italic}.search-box button.search-button{z-index:5;position:absolute;background:none;right:10px;top:10px;width:40px;height:40px;border:none;font-size:1.4rem;outline:none;color:#fff;background-color:#1c1c1c;border-radius:6px;padding:5px;display:flex;justify-content:center;align-items:center;margin:0;text-shadow:none;cursor:pointer;transition:outline-offset .2s;outline:3px solid rgba(191,164,75,0);outline-offset:7px;transition:opacity .3s,transform .3s,outline-offset .2s}.search-box button.search-button[aria-disabled=true]{background:#999794;box-shadow:0 0 0 transparent,0 0 0 transparent;cursor:not-allowed}.search-box button.search-button[aria-disabled=true]:hover{background:#999794}.search-box button.search-button:hover{background:#363636}.search-box button.search-button:focus{outline-color:rgba(191,164,75,.3);outline-offset:0}.search-box button.search-button:active{background:#292929}.search-box button.search-button:disabled{background:#c9c7c4;cursor:not-allowed}.search-box button.search-button.hide{transform:scale(0);opacity:0}.search-box .search-loader{position:absolute;right:23px;top:25px;margin:0}@media only screen and (max-width:768px){.search-box h3{font-size:24px}}.search-box .print-button{padding-left:15px}.search-box .print-button svg{width:18px;height:18px;margin-right:5px}.search-input-wrapper{display:flex;flex-direction:column;width:100%;position:relative}.search-input-wrapper .inner-input-wrapper{position:relative;z-index:3}.search-input{width:100%;height:60px;background:#fff;box-shadow:0 2px 3px rgba(0,0,0,.15);border:3px solid #c9c7c4;padding:10px 15px;padding-right:55px;font-size:24px;outline:none;border-radius:6px}.search-input:focus{border-color:#25bdf5}.search-input::placeholder{font-style:italic;color:#a6a6a6}@media only screen and (max-width:768px){.search-input::placeholder{font-size:18px}}.center-container{max-width:960px;margin:0 auto}.search-loader{margin:0 auto;display:block;margin-top:60px;z-index:9}.search .orbit-loader{animation-delay:.5s}.search .div-table-cell span.cell:nth-child(2){display:block;font-style:italic;font-size:11.5px;padding-top:6px}.search-advanced-parameters-wrapper{width:calc(100% - 20px)}.search-advanced-parameters.search-advanced-parameters{width:100%;z-index:1;position:relative;background:#eeeeec;display:flex;flex-direction:column;margin-left:10px;margin-right:10px;padding:15px;padding-top:0;box-shadow:0 7px 6px -4px rgba(0,0,0,.25);align-self:flex-end;border-radius:0 0 4px 4px;border:1px solid #dbdbd6;margin-bottom:15px}.search-advanced-parameters.search-advanced-parameters h3{font-size:16px;font-weight:800;margin-top:10px}.search-advanced-parameters.search-advanced-parameters h4{font-size:14px;font-weight:800;margin-top:10px}.search-advanced-parameters.search-advanced-parameters .field.field .field-label.field-label.field-label{font-weight:600}.search-advanced-parameters.search-advanced-parameters .field.checkbox{padding:5px 14px}.search-advanced-parameters.search-advanced-parameters .field.checkbox .checkbox-wrapper .checkbox-label{margin-bottom:0}.search-advanced-parameters.search-advanced-parameters .field.checkbox+.checkbox{padding-top:0}.search-advanced-parameters.search-advanced-parameters .clear-wrapper{padding:10px 0 0;display:flex;align-items:center}.search-advanced-parameters.search-advanced-parameters .clear-wrapper h2{font-size:1rem;margin:0}.search-advanced-parameters.search-advanced-parameters .clear-wrapper button{margin-left:auto}.search-advanced-parameters.search-advanced-parameters .advanced-toolbar{width:calc(100% + 30px);padding:15px;background:#dfdfde;margin:-15px;margin-top:10px;border-radius:0 0 4px 4px;border-top:1px solid #d7d7d6;display:flex;flex-direction:column}.search-advanced-parameters.search-advanced-parameters .advanced-toolbar button:first-child{margin-right:15px}.search-advanced-parameters.search-advanced-parameters .advanced-toolbar button svg{width:16px;height:16px;margin-right:5px;margin-left:-3px}.search-advanced-parameters.search-advanced-parameters .advanced-toolbar button.clear-button{font-size:100%}.search-advanced-parameters.search-advanced-parameters .advanced-toolbar button.clear-button:hover{background:#efefef}.search-advanced-parameters.search-advanced-parameters .advanced-search-button[aria-disabled=true]{background:#999794;box-shadow:0 0 0 transparent,0 0 0 transparent;cursor:not-allowed}.search-advanced-parameters.search-advanced-parameters .advanced-search-button[aria-disabled=true]:hover{background:#999794}.search-advanced-parameters.search-advanced-parameters .search-disabled-hint{font-style:italic;color:#910c1d;margin-top:8px;margin-bottom:-4px;display:block}.advanced-search-toggle-wrapper{width:100%;max-width:600px;justify-content:flex-end;padding-right:20px;z-index:9}.search-advanced-animation-wrapper{overflow:hidden;padding:0 30px;width:calc(100% + 60px);margin-left:-30px}.advanced-search-toggle{height:25px;appearance:none;background:#dfdfde;border:none;padding:0 10px;font-weight:600;font-size:.8rem;border-radius:0 0 4px 4px;box-shadow:0 3px 4px -2px rgba(0,0,0,.45);outline:none;transition:outline-offset .2s;outline:3px solid rgba(191,164,75,0);outline-offset:7px;transition:transform .35s,outline-offset .2s}.advanced-search-toggle:focus{outline-color:rgba(191,164,75,.3);outline-offset:0}.advanced-search-toggle .svg-icon{width:15px;margin-left:3px;max-height:25px}.advanced-search-toggle span{display:flex;justify-content:center;align-items:center}.search-confidential{width:100%;display:flex;flex-direction:column;align-items:center}.search-confidential div{max-width:600px;padding:20px;background:rgba(192,16,39,.15);border-radius:6px;white-space:pre-wrap}.search-confidential .markdown p{line-height:1.4}.search-confidential strong{color:#620814}.limit-Description{color:red;font-style:italic;font-weight:700}", ""]);
	
	// exports


/***/ },
/* 877 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(10)();
	// imports
	
	
	// module
	exports.push([module.id, ".fab-button{position:fixed;right:30px;bottom:60px;z-index:99}.fab-button .main{width:60px;height:60px;border-radius:100%;background:#bfa44b;color:#fff;border:none;cursor:pointer;font-size:2.2rem;box-shadow:0 4px 2px rgba(0,0,0,.4);z-index:9;outline:none;transition:transform .3s,box-shadow .3s;display:flex;justify-content:center;align-items:center;padding:15px}.fab-button .main:hover{background:#c7af62}.fab-button .main:focus{box-shadow:0 0 0 4px rgba(191,164,75,.3)}.fab-button .main:focus:not(:focus-visible){box-shadow:0 4px 2px rgba(0,0,0,.4)}.fab-button .main :-moz-focus-visible,.fab-button .main:focus-visible{box-shadow:0 0 0 4px rgba(191,164,75,.3)}.fab-button .main.open.open{transform:rotate(45deg);box-shadow:3px 3px 2px rgba(0,0,0,.4)}.fab-button .main.open.open:focus,.fab-button .main.open.open:focus-visible{box-shadow:0 0 0 4px rgba(191,164,75,.3)}.fab-button .main .icon{color:#fff}.fab-button .sub-wrapper{z-index:-1;position:relative}.fab-button .sub-wrapper .sub{width:40px;height:40px;border-radius:100%;background:#bfa44b;outline:none;border:none;cursor:pointer;font-size:1.2rem;box-shadow:0 4px 2px rgba(0,0,0,.4);position:absolute;left:10px;bottom:10px;transition:transform .3s,opacity .3s;color:#fff;display:flex;justify-content:center;align-items:center;padding:7px}.fab-button .sub-wrapper .sub:hover{background:#c7af62}.fab-button .sub-wrapper .sub:focus{box-shadow:0 0 0 4px rgba(191,164,75,.3)}.fab-button .sub-wrapper .sub.focus{outline:none}.fab-button .sub-wrapper .sub .icon{color:#fff}", ""]);
	
	// exports


/***/ },
/* 878 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(10)();
	// imports
	
	
	// module
	exports.push([module.id, ".login-modal-body.login-modal-body.login-modal-body{display:flex;justify-content:center;align-items:center}@media only screen and (max-width:480px){.login-modal-root .login-modal-body.login-modal-body.login-modal-body{align-items:flex-start}}.login-modal{width:100%;max-width:800px;height:auto;background:#fff;display:block;margin:0 auto;margin-top:calc(50vh - 190px);font-size:.8rem;border-radius:5px;font-family:Verdana,Arial,Open Sans,sans-serif}.login-modal .login-header{background-color:#e6dfcc;color:#5a5137;padding:3px 0 3px 3px;border-bottom:1px solid #aba48f;margin:0;border-radius:5px 5px 0 0}.login-modal .login-column{padding:15px}.login-modal .login-column.right{padding-left:7px}.login-modal .login-column.left{padding-right:7px}.login-modal .login{color:#5a5137;background-color:#fff;border:1px solid #ccc;width:100%;height:auto;padding:15px}.login-modal .login input,.login-modal .login label{display:block}.login-modal .login label{margin-bottom:4px}.login-modal .login input{width:169px;height:21px}.login-modal .login .input-block{display:block;margin-bottom:10px}@media only screen and (max-width:992px){.login-modal .login input[type=number],.login-modal .login input[type=password],.login-modal .login input[type=search],.login-modal .login input[type=text],.login-modal .login select,.login-modal .login select:focus,.login-modal .login textarea{font-size:16px}}.login-modal .instructions{border:1px solid #ccc;background-color:#eeeeed;width:100%;height:260px;padding:15px}.login-modal .instructions h6{font-weight:600;font-size:.85rem;margin-bottom:10px}.login-modal .instructions p{display:block;margin-bottom:8px}.login-modal .instructions ul{list-style:disc;padding-left:40px}.login-modal .instructions ul li{margin-top:5px}.login-modal-new{width:100%;max-width:800px;display:block;margin:0 auto;margin-top:calc(50vh - 190px);font-size:.8rem;font-family:Verdana,Arial,Open Sans,sans-serif;border-radius:4px 4px 4px 4px}.login-modal-new.double-col-account-create{max-width:800px}.login-modal-new.double-col-account-create .create-account{background:#fff;display:flex;flex-direction:row;gap:20px}@media only screen and (max-width:768px){.login-modal-new.double-col-account-create .create-account{flex-direction:column}}.login-modal-new .full-width-banner{position:absolute;left:0;top:0;width:calc(100% + 3px);z-index:9;background:#e2e2df;border-bottom:1px solid #cdcdcc;border-top:1px solid #dcdcdb;padding:10px;border-radius:4px 4px 0 0}.login-modal-new .full-width-banner img{margin:0!important;margin-bottom:-5px!important}.login-modal-new .login-header{padding:3px 0 3px 3px}.login-modal-new .login-column{padding:20px}.login-modal-new .login-column.right{background-color:#f3f3f3;border-bottom-right-radius:4px}.login-modal-new .login{width:100%;height:auto;padding:20px}@media only screen and (max-width:992px){.login-modal-new .login input[type=number],.login-modal-new .login input[type=password],.login-modal-new .login input[type=search],.login-modal-new .login input[type=text],.login-modal-new .login select,.login-modal-new .login select:focus,.login-modal-new .login textarea{font-size:16px}}.login-modal-new .has-own-instructions.has-own-instructions.has-own-instructions{padding-right:0;padding-left:10px}.login-modal-new .markdown-instructions.markdown-instructions.markdown-instructions{margin-top:-15px}.login-modal-new .markdown-instructions.markdown-instructions.markdown-instructions ul{list-style:none;padding-left:15px}.login-modal-new .markdown-instructions.markdown-instructions.markdown-instructions li{margin:2px}.login-modal-new .subtitle{font-weight:600;font-family:Open Sans,sans-serif}.login-modal-new h5,.login-modal-new h6{font-weight:600;font-size:1rem;margin-bottom:10px;margin-top:0}.login-modal-new h5{margin-bottom:20px}.login-modal-new .instructions{width:100%;height:auto;padding:20px}.login-modal-new .instructions h4{text-align:center;margin-bottom:23px}.login-modal-new .instructions.has-banner,.login-modal-new .instructions.margin-top{padding-top:90px}.login-modal-new .instructions p{display:block;margin-bottom:12px;line-height:1.3}.login-modal-new .instructions p:last-child{margin-bottom:0}.login-modal-new .instructions ul{list-style:none;padding-left:15px;margin-bottom:28px}.login-modal-new .instructions ul li{margin-top:5px}.login-modal-new .instructions a:not(.btn){background:none;font-size:13px;border:none;padding:0;margin:0;margin-bottom:5px;color:#1c1c1c;text-decoration:underline;cursor:pointer}.login-modal-new .instructions .right-align{display:flex;flex-direction:column;align-items:flex-end}.login-modal-new .instructions .right-align button{text-transform:uppercase}.login-modal-new .create-account{height:auto}.login-modal-new .create-account-button{background:none;border:none;padding:0;margin-top:10px;text-decoration:underline;color:#1c1c1c;cursor:pointer}.login-modal-new .name-wrapper{display:flex;flex-direction:row}.login-modal-new .name-wrapper .field{margin-right:10px}.login-modal-new .name-wrapper .field:last-child{margin-right:0}.login-modal-new .field{font-family:Open Sans,sans-serif}.login-modal-new .field .description{font-style:italic;font-size:11px;margin-bottom:5px}.login-modal-new .info{padding:10px;margin-left:20px;margin-right:20px;background:#cdeeff;color:#1c1c1c;font-style:italic;line-height:1.2;border-radius:4px}@media only screen and (max-width:768px){.login-modal-new{max-width:none;width:100%;box-shadow:none}.login-modal-new .full-width-banner,.login-modal-new .login-footer{width:100%}.login-modal-new .login-footer p{line-height:1.4}.login-modal-new .instructions ul{margin-bottom:5px}.login-modal-new h4{margin-top:18px}}.login-modal-new .reverse{flex-direction:row-reverse}@media only screen and (max-width:480px){.login-modal-new .reverse{flex-direction:column-reverse}}.login-modal-new .reverse .login-column.left{z-index:9}@media only screen and (max-width:768px){.login-modal-new .reverse .login-column.left{padding-top:30px!important}}@media only screen and (max-width:768px){.login-modal-new .reverse .login-column.right{padding-bottom:10px!important}.login-modal-new .reverse .login-column.right .banner{width:100%}.login-modal-new .reverse .login-column.right .instructions{padding-right:10px}}.auth .user{padding:10px;margin-top:-5px;margin-right:-5px;border:none;background:none;cursor:pointer;transition:outline-offset .2s;outline:3px solid rgba(191,164,75,0);outline-offset:7px}.auth .user:focus,.auth .user:hover{background:#d7d7d6}.auth .user:focus{outline-color:rgba(191,164,75,.3);outline-offset:0}.auth .user .name,.auth .user .username{display:block;text-align:right;line-height:1}.auth .user .name{font-size:.95rem;font-weight:600}.auth .user .username{font-size:.8rem}.auth .loader{padding:15px;margin-top:15px}.auth .loader div{background:#999794}.auth .btn{margin:5px}.auth .login-link{color:#3d3c3b;border-color:#3d3c3b}.login-redirector{min-height:calc(100vh - 60px);background:#eeeeec;display:flex;justify-content:center;align-items:center}.login-redirector .login-modal{margin-top:15px}.admin-login-wrapper{flex:0 0 100%;min-height:auto;background:#fff;box-shadow:0 14px 28px rgba(0,0,0,.25),0 10px 10px rgba(0,0,0,.22);position:relative;margin:0;max-width:400px;transition:none}.admin-login-wrapper.double-column{max-width:800px}.admin-login-wrapper.has-full-width-banner .login-column{padding-top:60px}.admin-login-wrapper.has-footer .login-column{padding-bottom:60px}.admin-login-wrapper .link-wrapper{display:flex}.admin-login-wrapper a:not(.btn){color:#4f4f4f;margin-bottom:8px;text-decoration:none}.admin-login-wrapper a:first-of-type{margin-top:12px}.admin-login-wrapper a:last-child{margin-bottom:0}.admin-login-wrapper a:only-child{margin:0}.admin-login-wrapper .banner{width:calc(100% - 60px);position:absolute;left:-30px;top:15px;padding:15px 20px;color:#fff;font-size:1.4rem;text-align:left;background:-webkit-linear-gradient(70deg,#7d7150,#e6cb73);background:-moz-linear-gradient(70deg,#7d7150,#e6cb73);background:-o-linear-gradient(70deg,#7d7150,#e6cb73);background:linear-gradient(20deg,#7d7150,#e6cb73);box-shadow:0 2px 5px rgba(0,0,0,.26),0 2px 5px rgba(0,0,0,.23)}.admin-login-wrapper .banner.span-2-columns{width:calc(200% - 60px)}.admin-login-wrapper .banner img{width:40px;margin:-10px;margin-right:3px}.admin-login-wrapper .field{display:flex;flex-direction:column;margin-bottom:15px}.admin-login-wrapper .field label{margin-bottom:5px;font-size:.9rem;font-weight:600}.admin-login-wrapper .field input{width:100%;padding-left:10px;padding-right:10px;border:3px solid #c3c3c3;border-radius:5px;height:35px}.admin-login-wrapper .field input:focus{outline:none;border-color:#25bdf5}@media only screen and (max-width:992px){.admin-login-wrapper .field input[type=number],.admin-login-wrapper .field input[type=password],.admin-login-wrapper .field input[type=search],.admin-login-wrapper .field input[type=text],.admin-login-wrapper .field select,.admin-login-wrapper .field select:focus,.admin-login-wrapper .field textarea{font-size:16px}}.admin-login-wrapper .field a{margin-top:4px}.admin-login-wrapper .button-wrapper{display:flex;align-items:flex-end;flex-direction:column}.admin-login-wrapper .button-wrapper button{flex-shrink:0;flex-grow:0;border-radius:3px}.admin-login-wrapper .button-wrapper .error{color:#df2534;font-style:italic;font-size:.75rem;padding-right:8px;margin-bottom:7px}.admin-login-wrapper .login-footer{background:#e8e8e8;border-top:1px solid #d5d5d5;position:absolute;left:0;bottom:0;z-index:13;width:calc(100% + 3px);padding:20px;text-align:center;border-radius:0 0 4px 4px}@media only screen and (max-width:480px){.admin-login-wrapper .login-column{padding:0}.admin-login-wrapper .login-column:first-child{padding-bottom:0;padding-top:50px}.admin-login-wrapper .login-column:last-child{padding-top:0;padding-bottom:60px}.admin-login-wrapper .login-footer{width:100%;border-bottom:1px solid #c9c7c4;padding:10px}}@media only screen and (max-width:480px){.admin-login-wrapper{box-shadow:none;max-width:none}.admin-login-wrapper .banner{left:-1px;top:-3px;width:calc(100% + 1px);box-shadow:none}.admin-login-wrapper .row{padding:3px}}.auth-timer{background:rgba(0,0,0,.6);position:fixed;left:0;top:0;width:100%;height:100%;z-index:999999}.auth-timer .timer{position:absolute;right:15px;bottom:15px;width:calc(100% - 15px);max-width:450px;height:calc(100% - 15px);max-height:300px;display:flex;flex-direction:column;justify-content:flex-end;align-items:center;padding:15px}.auth-timer .timer h4{color:#fff;font-size:2rem;text-align:center;text-shadow:0 7px 25px rgba(0,0,0,.8)}.auth-timer .timer span{flex:0 0 auto;color:#fff;font-size:6rem;font-weight:800;text-shadow:0 7px 35px rgba(0,0,0,.4)}@media only screen and (max-width:480px){.login-redirector.login-redirector.login-redirector{justify-content:flex-start;background:#fff;padding:0}}.forgot-password .description{line-height:1.2;margin-bottom:20px;font-style:italic}.reset-password-wrapper{padding:30px;display:flex;flex-direction:column;justify-content:center;width:100%}.reset-password-wrapper .text-wrapper{width:100%}.reset-password-wrapper button{justify-content:center;text-align:center}.login-create-buttons-wrapper.login-create-buttons-wrapper.login-create-buttons-wrapper{display:flex;flex-direction:row;margin-bottom:25px;justify-content:space-around;flex-wrap:wrap}.login-create-buttons-wrapper.login-create-buttons-wrapper.login-create-buttons-wrapper div{display:flex;flex-direction:row}.login-create-buttons-wrapper.login-create-buttons-wrapper.login-create-buttons-wrapper a{margin:0;margin-bottom:3px;margin-top:3px;text-decoration:none;display:block;text-align:center;white-space:nowrap}.login-create-buttons-wrapper.login-create-buttons-wrapper.login-create-buttons-wrapper a:first-child{margin-right:3px}.login-create-buttons-wrapper.login-create-buttons-wrapper.login-create-buttons-wrapper button:first-child{margin-bottom:10px}@media only screen and (max-width:768px){.login-create-buttons-wrapper.login-create-buttons-wrapper.login-create-buttons-wrapper{margin-bottom:15px}}", ""]);
	
	// exports


/***/ },
/* 879 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(10)();
	// imports
	
	
	// module
	exports.push([module.id, ".content{width:100%;height:auto;padding-top:60px;padding-left:200px;transition:padding .6s}.content.sidebar-collapsed{padding-left:50px}.content.sidebar-shown{overflow:hidden}.content.mobile{margin-left:0;padding-left:0;padding-top:50px}.content.no-shell{margin-left:0;padding-left:0;padding-top:0}.content header.main-header{width:calc(100% - 200px);top:0;left:200px;background:#e4e4e3;color:#3d3c3b;height:60px;padding-left:15px;padding-right:10px;position:fixed;z-index:15;display:flex;flex-direction:row;flex-wrap:nowrap}.content header.main-header.mobile{width:100%;left:0;height:50px;padding-left:60px;z-index:15;box-shadow:0 10px 20px rgba(0,0,0,.19),0 6px 6px rgba(0,0,0,.23)}.content header.main-header.mobile .sublink{height:50px;min-width:50px;padding:15px 10px;font-size:.7rem}.content header.main-header.mobile .auth{top:5px;right:5px}.content header.main-header a.child-focus:focus .branding{background-color:#292929}.content header.main-header a.child-focus:focus .title-container .statetitle,.content header.main-header a.child-focus:focus .title-container .subtext{text-decoration:underline}.content header.main-header nav.sublinks-wrapper{flex:1 1 auto;display:flex;overflow:hidden;position:relative;margin-right:30px}.content header.main-header .force-wrap{display:flex;flex-direction:row;flex-wrap:nowrap}.content header.main-header .force-wrap.hidden{visibility:hidden;opacity:0;pointer-events:none}.content header.main-header .wrap-enforcer{width:1px;height:60px;flex:0 0 auto}.content header.main-header .sublinks{display:flex;flex-direction:row;flex-wrap:wrap;position:absolute;padding-right:40px;left:0;top:0;width:100%;max-height:120px}.content header.main-header .sublinks .more-button{position:absolute;left:0;bottom:60px;background:#e4e4e3;border:none;border-bottom:6px solid #999;padding-bottom:6px;padding-left:13px;padding-right:13px;cursor:pointer;font-size:.85rem;font-weight:600;color:#3d3c3b;transition:outline-offset .2s;outline:3px solid rgba(191,164,75,0);outline-offset:7px}.content header.main-header .sublinks .more-button:hover .triangle{border-color:#716f6d transparent transparent}.content header.main-header .sublinks .more-button:focus{outline-color:rgba(191,164,75,.3);outline-offset:0}.content header.main-header .sublinks .more-button.hidden{visibility:hidden;opacity:0;pointer-events:none}.content header.main-header .sublinks .more-button .triangle{margin-left:3px;display:inline-block;width:0;height:0;border-style:solid;border-width:7px 5.5px 0;border-color:#3d3c3b transparent transparent}.content header.main-header .sublink{flex:0 0 auto;color:#3d3c3b;text-decoration:none;font-size:.85rem;font-weight:600;padding:15px;display:table-cell;vertical-align:bottom;min-width:100px;text-align:center;height:60px;display:flex;flex-direction:column;justify-content:flex-end;transition:outline-offset .2s;outline:3px solid rgba(191,164,75,0);outline-offset:7px}.content header.main-header .sublink:focus{outline-color:rgba(191,164,75,.3);outline-offset:0}.content header.main-header .sublink.active{border-bottom:6px solid #999;padding-bottom:9px}.content header.main-header .sidebar-toggle{width:50px;height:100%;background:#1c1c1c;color:#fff;border:none;font-size:1.5rem;padding:0;position:absolute;left:0;top:0;transition:outline-offset .2s;outline:3px solid rgba(191,164,75,0);outline-offset:7px}.content header.main-header .sidebar-toggle:focus{outline-color:rgba(191,164,75,.3);outline-offset:0}.content header.main-header .sidebar-toggle .center{width:100%}.content header.main-header .sidebar-toggle .svg-icon{width:28px;min-width:28px}.content .body-wrapper{display:block;width:100%;height:auto;font-size:.85rem;transition:margin-left .6s,width .6s}.branding{max-width:200px;left:-200px;position:absolute;top:0;height:60px;background:#1c1c1c;display:flex;align-items:center;width:100%;padding:10px;transition:outline-offset .2s;outline:3px solid rgba(191,164,75,0);outline-offset:7px}.branding .title-container{margin-left:7px;display:flex;flex-direction:column;align-items:center}.branding .statetitle{font-size:1.07em;font-weight:600;color:#fff;font-smooth:always;text-align:left;align-self:flex-start}.branding .subtext{font-size:.7em;font-style:italic;margin-top:4px;color:#fff;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;letter-spacing:.7px}.branding img{width:100%;max-width:45px;max-height:45px}.branding .logo-wrapper{padding:10px;margin-left:-15px;margin-right:15px}.branding .logo-wrapper img{max-width:none;max-height:none}.branding .logo-wrapper.full-width{margin-right:-15px}.auth{flex:0 0 auto;margin-left:auto;align-self:center}.body{width:100%;transition:width .6s;margin:0;padding:20px;padding-bottom:50px}.body.full-height-page{min-height:calc(100vh - 60px - 30px)}.body.drawer-shown{width:calc(100% - 350px);margin:0}.body.mobile{width:100%;min-height:calc(100vh - 50px);flex:0 0 auto;flex-flow:column nowrap}.body.neutral{background:#e4e4e3}.body.light-neutral{background:#eeeeec}.body.medium-neutral{background:#c9c7c4}.body.dark-neutral{background:#999794}body.force-scrollbar:not(.mobile){overflow-y:scroll}nav.sidebar{position:fixed;width:200px;height:100vh;top:60px;transition:width .6s,transform .3s;z-index:999;background:-webkit-linear-gradient(115deg,#000,#1c1c1c);background:-moz-linear-gradient(115deg,#000,#1c1c1c);background:-o-linear-gradient(115deg,#000,#1c1c1c);background:linear-gradient(335deg,#000,#1c1c1c)}nav.sidebar.collapsed{overflow:hidden;width:50px}nav.sidebar.collapsed .label{opacity:0;transition:opacity .4s}nav.sidebar.mobile{transform:translateX(-220px);top:0;box-shadow:14px 0 28px rgba(0,0,0,.25),10px 0 10px rgba(0,0,0,.22)}nav.sidebar.mobile .branding{position:relative;left:0;z-index:100;transition:none}nav.sidebar.mobile .branding.show,nav.sidebar.show{transform:translateX(0)}nav.sidebar a{display:block;width:100%;height:56px;font-size:.8rem;text-decoration:none;color:hsla(0,0%,100%,.8);padding-left:13px;margin-bottom:2px;position:relative;display:flex;align-items:center;flex-direction:row;transition:outline-offset .2s;outline:3px solid rgba(191,164,75,0);outline-offset:7px}nav.sidebar a:focus{outline-color:rgba(191,164,75,.3);outline-offset:0}nav.sidebar a .svg-icon{width:22px;margin-right:5px;overflow:visible}nav.sidebar a.active{background:-webkit-linear-gradient(70deg,#7d7150,#e6cb73);background:-moz-linear-gradient(70deg,#7d7150,#e6cb73);background:-o-linear-gradient(70deg,#7d7150,#e6cb73);background:linear-gradient(20deg,#7d7150,#e6cb73);box-shadow:0 4px 8px rgba(0,0,0,.2);width:calc(100% + 10px);color:#fff}nav.sidebar a .sidebar-alert{position:absolute;left:22px;top:13px}nav.sidebar a .icon{margin-right:12px;line-height:.85rem;vertical-align:top;font-size:1.2rem}nav.sidebar a .icon.icon-filing{font-size:1rem}nav.sidebar a .label{vertical-align:top;opacity:1;transition:opacity .4s;white-space:pre-wrap;display:flex;align-items:center;line-height:1.1;text-shadow:0 1px 1px rgba(0,0,0,.3)}.sidebar-shade{position:fixed;z-index:15;width:150%;height:150%;top:0;left:0;background:rgba(0,0,0,.6)}.drawer{position:fixed;right:-350px;top:60px;height:calc(100vh - 60px);width:350px;background:#eeeeec;z-index:11;display:flex;flex-direction:column;animation-fill-mode:forwards}.drawer.mobile{height:calc(100vh - 50px);top:50px;width:100vw;right:-100vw}.drawer.mobile .title-box{padding-left:60px}.drawer.mobile.show{animation:slide-in-right .4s forwards}.drawer.mobile.closing{animation:slide-out-right .4s forwards}.drawer.show{animation:slide-in-right .6s forwards;z-index:100}.drawer.closing{animation:slide-out-right .6s forwards}.drawer .drawer-inner-wrapper{display:flex;flex-direction:column;outline:none;overflow-y:auto}.drawer .title-box{display:block;padding:10px;padding-right:34px;padding-bottom:7px;position:relative;width:100%;background:-webkit-linear-gradient(70deg,#7d7150,#e6cb73);background:-moz-linear-gradient(70deg,#7d7150,#e6cb73);background:-o-linear-gradient(70deg,#7d7150,#e6cb73);background:linear-gradient(20deg,#7d7150,#e6cb73);color:#fff}.drawer .title-box h4{font-weight:400;font-size:1.2rem}.drawer .title-box p{font-size:.75rem;font-weight:200;margin-top:5px}.drawer .close-button{position:absolute;right:0;top:0;width:30px;height:100%;background:none;border:none;border-left:1px solid hsla(0,0%,100%,.1);font-size:1rem;color:#fff;padding:0;cursor:pointer;transition:outline-offset .2s;outline:3px solid rgba(191,164,75,0);outline-offset:7px}.drawer .close-button:focus{outline-color:rgba(191,164,75,.3);outline-offset:0}.drawer .close-button:hover{background:hsla(0,0%,100%,.1)}.drawer .close-button .svg-icon{width:20px;height:20px}.drawer .sidebar-dismiss{width:50px;height:60px;position:absolute;left:0;top:0;color:#fff;font-size:1.7rem;padding:0;padding-right:5px;background:none;border:none}.drawer .sidebar-dismiss .svg-icon{width:30px}.drawer .sidebar-dismiss:active{background:hsla(0,0%,100%,.1)}.drawer .scrollable-drawer-wrapper{overflow-y:auto;margin-bottom:30px;flex-grow:1;min-height:calc(100vh - 200px)}@media only screen and (max-width:768px){.drawer .scrollable-drawer-wrapper{margin-bottom:0}}.drawer .inner-drawer{padding:15px}.drawer .inner-drawer .drawer-message{padding:15px;background:#fbe584;color:darkend(#a37d1a,10%);border-radius:4px;border:1px solid #fae06b;margin-bottom:15px;font-style:italic}.drawer .inner-drawer.scrollable{overflow-y:auto}.flex-wrapper{display:flex;flex-wrap:wrap}footer{position:fixed;bottom:0;left:200px;width:calc(100% - 200px);background:#e4e4e3;color:#3d3c3b;height:30px;padding:0 9px;font-size:.75rem;transition:width .6s,left .6s;z-index:9;display:flex;align-items:center}footer.collapsed{width:calc(100% - 50px);left:50px}footer.mobile{width:100%;left:0;position:relative;bottom:0;height:auto;text-align:center;display:flex;align-self:flex-end;z-index:auto}footer.mobile .links{margin-top:5px}footer ul.links{margin-left:auto}footer ul.links .divider{margin-left:8px;margin-right:8px}footer ul.links li{display:inline-block;margin:0}footer ul.links a{color:#3d3c3b;text-decoration:none}footer ul.links a:hover{text-decoration:underline}.app-error{position:absolute;left:0;top:0;width:100%;padding:12px;font-weight:600;z-index:9}.app-error.danger.danger.danger.danger{background:-webkit-linear-gradient(70deg,#9c1a25,#c92a37);background:-moz-linear-gradient(70deg,#9c1a25,#c92a37);background:-o-linear-gradient(70deg,#9c1a25,#c92a37);background:linear-gradient(20deg,#9c1a25,#c92a37);color:#fff;font-size:.9rem}.app-error button{position:absolute;right:0;top:0;border:none;width:40px;height:100%;font-size:1.2rem;color:#fff;background:none;cursor:pointer}.app-error button:hover{background:hsla(0,0%,100%,.1)}.triangle.up{border-bottom:6px solid #303030}.triangle.down,.triangle.up{width:0;height:0;border-left:6px solid transparent;border-right:6px solid transparent}.triangle.down{border-top:6px solid #303030}.switch{background:#1c1c1c;width:42px;height:22px;border-radius:14px;padding:4px;position:relative;transition:background .15s;cursor:pointer;border:none;outline:none}.switch:active div.fob{width:22px}.switch div.fob{width:16px;height:16px;border-radius:16px;border:none;transition:width .15s,left .15s;outline:none;position:absolute;left:3px;top:3px;background:#fff;cursor:pointer;pointer-events:none}.switch.on{background:#bfa44b}.switch.on div.fob{left:calc(100% - 19px)}.switch.on:active div.fob{left:calc(100% - 25px)}.message-card{background:#fff;padding:30px;border-radius:4px;box-shadow:0 60px 70px -20px rgba(0,0,0,.25);width:100%;max-width:500px}.message-card h2{font-size:28px;margin-bottom:15px}.message-card .markdown p{font-size:15px;line-height:1.3}.skip-link{z-index:9999;background:#fff;font-family:Open Sans,sans-serif;font-size:.85rem;position:fixed;top:0;left:200px;padding:4px;transform:translateY(-100%);transition:outline-offset .2s;outline:3px solid rgba(191,164,75,0);outline-offset:7px}.skip-link:focus{transform:translateY(0);outline-color:rgba(191,164,75,.3);outline-offset:0}@keyframes slide-in-right{0%{transform:translateX(0)}to{transform:translateX(-100%)}}@keyframes slide-out-right{0%{transform:translateX(-100%)}to{transform:translateX(0)}}.side-scroll{overflow-y:auto;scrollbar-width:none;-ms-overflow-style:none}.side-scroll::-webkit-scrollbar{width:0;height:0}", ""]);
	
	// exports


/***/ },
/* 880 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(10)();
	// imports
	
	
	// module
	exports.push([module.id, ".manage-signers-page .add-wrapper{margin-top:20px}.manage-signers-page .add-wrapper button{text-transform:uppercase}.signers-display-wrapper{margin-top:20px}.signers-display-wrapper .loader-wrapper{min-height:80px}.signer-display-row{background:rgba(191,164,75,.15);border-radius:6px;margin:7px 0;padding:10px}.signer-display-row:last-child{margin-bottom:0}.signer-display-row .signer-icon{width:40px;height:40px;border-radius:100%;overflow:hidden;background:rgba(191,164,75,.4);padding-top:4px;color:#fff;margin-right:10px;flex:0 0 auto}.signer-display-row .signer-info{align-self:center;justify-content:center;align-items:flex-start;flex:1 1 auto}.signer-display-row .signer-info span:first-child{font-size:18px;margin-bottom:3px;font-weight:600}.signer-display-row .signer-info span:last-child{font-size:14px;color:#79672b;display:flex;align-items:center;cursor:default;outline:none;border-radius:3px;width:auto;word-break:break-word}.signer-display-row .signer-info span:last-child:hover .svg-icon{opacity:1}.signer-display-row .signer-info span:last-child .svg-icon{width:16px;margin-left:7px;opacity:0}.signer-display-row .signer-info span:last-child:focus{background:rgba(191,164,75,.2)}.signer-display-row .signer-info span:last-child:active{background:none}.signer-display-row .signer-info span:last-child.disabled{background:none!important;transition:background .2s}.signer-display-row .signer-info span:last-child.disabled .svg-icon{opacity:0}.signer-display-row .signer-info input{background:hsla(0,0%,100%,.7);border:none;border-radius:3px;width:100%;outline:none;font-size:14px;margin:-1px;height:17px}.signer-display-row.signed{background:rgba(65,190,70,.15)}.signer-display-row.signed .signer-icon{padding:3px;padding-top:5px;padding-right:4px;background:rgba(65,190,70,.4)}.signer-display-row.signed .signer-info span:last-child{color:#27722a}.signer-display-row.signed .signed-date{line-height:1.2;align-self:center;color:#27722a}.signer-display-row.signed .signed-date .label{font-style:italic}.signer-display-row .menu-button{margin-left:auto;width:30px;padding:0;background:none;border:none;margin-right:-5px;border-radius:6px;color:#bfa44b;outline:none;transition:outline-offset .2s;outline:3px solid rgba(191,164,75,0);outline-offset:7px}.signer-display-row .menu-button:hover{background:hsla(0,0%,100%,.5)}.signer-display-row .menu-button:focus{outline-color:rgba(191,164,75,.3);outline-offset:0}.signer-display-row button{align-self:center;text-transform:uppercase;background:rgba(191,164,75,.2);border:none;padding:10px;color:#79672b;margin-left:6px;white-space:nowrap}.signer-display-row button:hover{background:hsla(47,48%,67%,.2)}.signer-display-row button:disabled{background:hsla(47,48%,67%,.1)}.signatures-success-message{margin-bottom:30px}.signatures-success-message .signer-success-title{display:flex;align-items:center}.signatures-success-message .signer-success-icon{width:40px;height:40px;background:rgba(65,190,70,.4);display:flex;justify-content:center;align-items:center;padding:2px;padding-right:4px;padding-top:5px;border-radius:100%;color:#fff;margin-right:15px}.signers-manage-title{display:flex;flex-direction:row;align-items:center}.signers-manage-title .orbit-loader{opacity:0;margin-left:15px;animation-delay:1s}", ""]);
	
	// exports


/***/ },
/* 881 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(10)();
	// imports
	
	
	// module
	exports.push([module.id, ".sliding-panel-wrapper{z-index:99999}.sliding-panel-wrapper .sliding-panel{z-index:9999;position:fixed;right:0;top:0;width:300px;height:100%;background:-webkit-linear-gradient(115deg,#000,#303030);background:-moz-linear-gradient(115deg,#000,#303030);background:-o-linear-gradient(115deg,#000,#303030);background:linear-gradient(335deg,#000,#303030);box-shadow:-2px 0 4px rgba(0,0,0,.3);overflow-y:auto}.sliding-panel-wrapper .shade{background:rgba(0,0,0,.6);position:fixed;top:0;left:0;width:100vw;height:100vh;z-index:9998}", ""]);
	
	// exports


/***/ },
/* 882 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(10)();
	// imports
	
	
	// module
	exports.push([module.id, ".system-admin{display:flex;flex-direction:row}.system-admin .inner-body{flex:1 0 auto;padding:30px}.body-sidebar{display:flex;flex-direction:column;width:250px;height:100%;background:#eeeeec;min-height:calc(100vh - 60px - 30px)}.body-sidebar a{width:100%;display:block;padding:15px;font-size:14px;text-decoration:none;color:inherit;border-bottom:1px solid #e2e2df;border-top:1px solid #fafaf9}.body-sidebar a.active{background:#fafaf9;cursor:default}.body-sidebar a.active:hover{background:#fafaf9}.body-sidebar a:hover{background:#f5f5f4}", ""]);
	
	// exports


/***/ },
/* 883 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(10)();
	// imports
	
	
	// module
	exports.push([module.id, ".div-table,.styled-table{display:table;width:100%;position:relative}.div-table *,.styled-table *{position:relative}.div-table .action-cell,.styled-table .action-cell{vertical-align:middle}.div-table [role=row],.styled-table [role=row]{display:table-row}.row-count{position:absolute;left:0;top:-18px;color:#757575;font-size:.85rem;width:100%;display:flex;justify-content:center}.row-count .row-count-text{width:100%;max-width:960px;text-align:right}@media only screen and (max-width:768px){.row-count{position:relative;top:auto}.row-count .row-count-text{text-align:left;margin-bottom:5px}}.div-table-row,.styled-table tr{display:table-row;background:#e4e4e3;opacity:1;z-index:0;transition:transform .2s;position:relative}.div-table-row:nth-child(2n) .div-table-cell,.div-table-row:nth-child(2n) td,.styled-table tr:nth-child(2n) .div-table-cell,.styled-table tr:nth-child(2n) td{background:#f3f3f3}.div-table-row:nth-child(2n) .div-table-cell:first-child.interactive,.div-table-row:nth-child(2n) td:first-child.interactive,.styled-table tr:nth-child(2n) .div-table-cell:first-child.interactive,.styled-table tr:nth-child(2n) td:first-child.interactive{background:#303030;transition:outline-offset .2s;outline:3px solid rgba(191,164,75,0);outline-offset:7px}.div-table-row:nth-child(2n) .div-table-cell:first-child.interactive:focus,.div-table-row:nth-child(2n) td:first-child.interactive:focus,.styled-table tr:nth-child(2n) .div-table-cell:first-child.interactive:focus,.styled-table tr:nth-child(2n) td:first-child.interactive:focus{outline-color:rgba(191,164,75,.3);outline-offset:0}.div-table-row:nth-child(2n) .div-table-cell:first-child.interactive:hover,.div-table-row:nth-child(2n) td:first-child.interactive:hover,.styled-table tr:nth-child(2n) .div-table-cell:first-child.interactive:hover,.styled-table tr:nth-child(2n) td:first-child.interactive:hover{background:#4a4a4a}.div-table-row:nth-child(2n) .div-table-cell:first-child.selected,.div-table-row:nth-child(2n) td:first-child.selected,.styled-table tr:nth-child(2n) .div-table-cell:first-child.selected,.styled-table tr:nth-child(2n) td:first-child.selected{background:#3d3d3d}.div-table-row.selected,.styled-table tr.selected{width:101%;z-index:99}.div-table-row.highlighted,.styled-table tr.highlighted{animation:highlight 3s;animation-fill-mode:backwards}.div-table-row.highlighted .div-table-cell:first-child.interactive,.styled-table tr.highlighted .div-table-cell:first-child.interactive{animation:primaryHighlight 3s;animation-fill-mode:backwards;transition:outline-offset .2s;outline:3px solid rgba(191,164,75,0);outline-offset:7px}.div-table-row.highlighted .div-table-cell:first-child.interactive:focus,.styled-table tr.highlighted .div-table-cell:first-child.interactive:focus{outline-color:rgba(191,164,75,.3);outline-offset:0}.div-table-row.highlighted:nth-child(2n) .div-table-cell:first-child.interactive,.div-table-row.highlighted:nth-child(2n) td:first-child.interactive,.styled-table tr.highlighted:nth-child(2n) .div-table-cell:first-child.interactive,.styled-table tr.highlighted:nth-child(2n) td:first-child.interactive{animation:primaryHighlight 3s;animation-fill-mode:backwards;transition:outline-offset .2s;outline:3px solid rgba(191,164,75,0);outline-offset:7px}.div-table-row.highlighted:nth-child(2n) .div-table-cell:first-child.interactive:focus,.div-table-row.highlighted:nth-child(2n) td:first-child.interactive:focus,.styled-table tr.highlighted:nth-child(2n) .div-table-cell:first-child.interactive:focus,.styled-table tr.highlighted:nth-child(2n) td:first-child.interactive:focus{outline-color:rgba(191,164,75,.3);outline-offset:0}.div-table-row .row-alert,.styled-table tr .row-alert{display:block;position:absolute;left:-8px;top:7px}.div-table-row .div-table-cell span.stack span,.div-table-row td span.stack span,.styled-table tr .div-table-cell span.stack span,.styled-table tr td span.stack span{display:block}.div-table-row .div-table-cell .message,.div-table-row td .message,.styled-table tr .div-table-cell .message,.styled-table tr td .message{padding:15px}.div-table-row .div-table-cell:first-child,.div-table-row td:first-child,.styled-table tr .div-table-cell:first-child,.styled-table tr td:first-child{position:relative}.div-table-row .div-table-cell:first-child.interactive,.div-table-row td:first-child.interactive,.styled-table tr .div-table-cell:first-child.interactive,.styled-table tr td:first-child.interactive{background:#262626;color:#fff;font-weight:600;padding:0;transition:outline-offset .2s;outline:3px solid rgba(191,164,75,0);outline-offset:7px;transition:background .2s}.div-table-row .div-table-cell:first-child.interactive:focus,.div-table-row td:first-child.interactive:focus,.styled-table tr .div-table-cell:first-child.interactive:focus,.styled-table tr td:first-child.interactive:focus{outline-color:rgba(191,164,75,.3);outline-offset:0}.div-table-row .div-table-cell:first-child.interactive:hover,.div-table-row td:first-child.interactive:hover,.styled-table tr .div-table-cell:first-child.interactive:hover,.styled-table tr td:first-child.interactive:hover{background:#4a4a4a;cursor:pointer}.div-table-row .div-table-cell:first-child.interactive:hover .icon,.div-table-row td:first-child.interactive:hover .icon,.styled-table tr .div-table-cell:first-child.interactive:hover .icon,.styled-table tr td:first-child.interactive:hover .icon{right:10px}.div-table-row .div-table-cell:first-child.interactive .interactive-cell-button,.div-table-row td:first-child.interactive .interactive-cell-button,.styled-table tr .div-table-cell:first-child.interactive .interactive-cell-button,.styled-table tr td:first-child.interactive .interactive-cell-button{padding:13px 10px;padding-right:30px;transition:outline-offset .2s;outline:3px solid rgba(191,164,75,0);outline-offset:7px}.div-table-row .div-table-cell:first-child.interactive .interactive-cell-button:focus,.div-table-row td:first-child.interactive .interactive-cell-button:focus,.styled-table tr .div-table-cell:first-child.interactive .interactive-cell-button:focus,.styled-table tr td:first-child.interactive .interactive-cell-button:focus{outline-color:rgba(191,164,75,.3);outline-offset:0}.div-table-row .div-table-cell:first-child.selected,.div-table-row td:first-child.selected,.styled-table tr .div-table-cell:first-child.selected,.styled-table tr td:first-child.selected{background:#3d3d3d}.div-table-row .div-table-cell:first-child .icon,.div-table-row td:first-child .icon,.styled-table tr .div-table-cell:first-child .icon,.styled-table tr td:first-child .icon{position:absolute;right:0;transition:right .2s;display:flex;width:20px;top:0;height:100%;justify-content:center;align-items:center;text-align:center}.div-table-row .div-table-cell .icon.icon-edit-doc,.div-table-row td .icon.icon-edit-doc,.styled-table tr .div-table-cell .icon.icon-edit-doc,.styled-table tr td .icon.icon-edit-doc{padding-left:2px}.div-table-heading,.styled-table thead{background-color:#e4e4e3;display:table-header-group;font-weight:700;color:#3d3c3b;position:relative}.div-table-body,.styled-table tbody{display:table-row-group}.div-table-body:before,.styled-table tbody:before{display:block;content:\"-\";line-height:13px;color:transparent}.div-table-cell,.div-table-head,.styled-table td,.styled-table th{display:table-cell;padding:13px 10px;border-right:1px solid #bebebc;vertical-align:middle;text-align:left;white-space:pre-wrap;transition:outline-offset .2s;outline:3px solid rgba(191,164,75,0);outline-offset:7px}.div-table-cell:focus,.div-table-head:focus,.styled-table td:focus,.styled-table th:focus{outline-color:rgba(191,164,75,.3);outline-offset:0}.div-table-cell:last-child,.div-table-head:last-child,.styled-table td:last-child,.styled-table th:last-child{border:none}.div-table-head .svg-icon{width:16px;position:absolute;right:5px;top:calc(50% - 8px)}.div-table-foot{background-color:#eee;display:table-footer-group;font-weight:700}.styled-table .clickable{cursor:pointer}.styled-table .clickable:hover{background:#d7d7d6}.styled-table .clickable:nth-child(2n):hover{background:#dcdcdb}.styled-table .clickable:nth-child(2n):hover td{background:none}.styled-table td,.styled-table th{vertical-align:middle}.styled-table td{white-space:pre-wrap}.styled-table .expansion-spacer.expansion-spacer{background:none}.styled-table .expansion-spacer.expansion-spacer td{padding:0;background:none;padding-left:8px}.styled-table .expansion-spacer.expansion-spacer .spacer{padding:7px 0 0;background:#e0dbd2}.styled-table .expansion-spacer.expansion-spacer .spacer:before{content:\"\";width:0;height:0;border-style:solid;border-width:0 8px 7px 0;border-color:transparent #e0dbd2 transparent transparent;position:absolute;left:-8px;top:0}.styled-table .expanded-row.expanded-row{background:none;box-shadow:none}.styled-table .expanded-row.expanded-row>td{border-bottom:1px solid #c9c7c4}.styled-table .expanded-row.expanded-row:last-child>td{border-bottom:none}.styled-table .expanded-row.expanded-row thead{background:#cdc5b7}.styled-table .expanded-row.expanded-row th{background:none;font-size:.85rem;border-right:1px solid #c1b7a5;font-weight:700;color:#000}.styled-table .expanded-row.expanded-row td{background:none;padding:0;padding:15px 0;padding-bottom:30px;padding-top:0;padding-left:40px;vertical-align:middle}.styled-table .expanded-row.expanded-row td .child-wrapper{background:#e0dbd2;display:flex;flex-direction:column;position:relative;border:1px solid #c1b7a5;border-left:1px solid #d1cabd;border-right:1px solid #d1cabd;border-top:1px solid #cdc5b7;border-radius:0 0 5px 5px}.styled-table .expanded-row.expanded-row td .child-wrapper:before{content:\"\";position:absolute;left:0;top:-4px;width:100%;height:1px;z-index:9;box-shadow:0 10px 20px rgba(0,0,0,.62),0 6px 6px rgba(0,0,0,.55)}.styled-table .expanded-row.expanded-row td .child-wrapper tbody:before{display:none}.styled-table .expanded-row.expanded-row td .child-wrapper table td,.styled-table .expanded-row.expanded-row td .child-wrapper table tr{background:none;padding:0;box-shadow:none}.styled-table .expanded-row.expanded-row td .child-wrapper table td{padding:10px;white-space:pre-wrap;line-height:1.2;border-right:1px solid #cdc5b7}.styled-table .expanded-row.expanded-row td .child-wrapper table td:last-child{border-right:none}.styled-table .expanded-row.expanded-row td .child-wrapper table tr:nth-child(2n){background:#eae7e1}.styled-table .expanded-row.expanded-row td .child-wrapper table tr:last-child{border-radius:0 0 5px 5px}.styled-table .expanded-row.expanded-row td .child-wrapper table tr:last-child td:first-child{border-bottom-left-radius:5px}.styled-table .expanded-row.expanded-row td .child-wrapper table tr:last-child td:last-child{border-bottom-right-radius:5px}.styled-table ul{margin-left:10px}.styled-table ul li{font-size:14px;margin:4px 0 4px 10px}.styled-table .expand-cell .orbit-loader{transform:scale(.8);margin-left:3px}.styled-table .expand-cell .orbit-loader div{animation-timing-function:linear}.styled-table .expand-wrapper{margin:-5px;padding-top:3px}.styled-table .expand-wrapper .expanded{transform:rotate(180deg)}.styled-table .expand-wrapper .svg-icon{width:22px}.styled-table tr.expandable th:nth-last-child(2){border-right:none}.body .table-toolbar{width:100%;display:flex;flex-direction:column;padding-bottom:15px;justify-content:center}.body .table-toolbar h1{font-size:28px;font-weight:600;margin-bottom:8px;color:#444;display:flex;align-items:center}.body .table-toolbar h1 .subtitle{margin-left:5px;color:#b9b8b6;display:flex;flex-direction:row;align-items:center;cursor:default;padding:10px;margin-top:-10px;margin-bottom:-10px}.body .table-toolbar h1 .subtitle:hover{background:rgba(0,0,0,.05)}.body .table-toolbar h1 .subtitle .svg-icon{width:30px;margin-left:5px;margin-top:5px}@media only screen and (max-width:768px){.body .table-toolbar{flex-direction:column}.body .table-toolbar h1{font-size:24px;flex-direction:column}.body .table-toolbar h1 .subtitle{margin-top:5px}}.body .table-toolbar .import{display:flex;flex-direction:row;align-items:center}.body .table-toolbar .import .svg-icon{margin-right:2px;max-width:20px}@media (-ms-high-contrast:active),(-ms-high-contrast:none){.body .table-toolbar .import .svg-icon{max-height:20px}}.body .table-toolbar .right-align{margin-left:auto;flex:1 1;display:flex;justify-content:flex-end}@media only screen and (max-width:768px){.body .table-toolbar .right-align{width:100%;padding-top:10px}}.body .table-toolbar .filter-wrapper{flex:0 1 230px;position:relative;margin-left:10px}.body .table-toolbar .filter-wrapper button{position:absolute;top:5px;right:4px;width:20px;height:20px;background:#999794;color:#fff;padding:0;border:none;border-radius:100%;display:flex;justify-content:center;align-items:center;appearance:none;outline:none;transition:outline-offset .2s;outline:3px solid rgba(191,164,75,0);outline-offset:7px}.body .table-toolbar .filter-wrapper button:focus{outline-color:rgba(191,164,75,.3);outline-offset:0}.body .table-toolbar .filter-wrapper button:hover{background:#c9c7c4}.body .table-toolbar .filter-wrapper button .svg-icon{width:60%}@media only screen and (max-width:768px){.body .table-toolbar .filter-wrapper{flex:1 1 auto}}.body .table-toolbar button.toolbar-search-button{height:30px;width:30px;padding:0;margin-left:10px}.body .table-toolbar button.toolbar-search-button .center-icon{display:flex;justify-content:center;align-items:center}.body .table-toolbar button.toolbar-search-button .svg-icon{width:18px}.body .table-toolbar input{transition:outline-offset .2s;outline:3px solid rgba(191,164,75,0);outline-offset:7px;flex:1 1 auto;border:none;background:#eeeeec;height:30px;width:100%;font-size:.85rem;padding:6px;font-weight:600;border-radius:5px;padding-right:30px}.body .table-toolbar input:focus{outline-color:rgba(191,164,75,.3);outline-offset:0}.body .table-toolbar .main-wrapper{display:flex;flex-direction:row}.body .table-toolbar .download-link,.body .table-toolbar .download-link a{display:flex;flex-direction:row;align-items:center}.body .table-toolbar .download-link a{color:#1c1c1c}.body .table-toolbar .download-link a:hover{color:#424242}.body .table-toolbar .download-link .svg-icon{width:22px}.body .table-toolbar button.help-button{background:#949494;color:#fff;border:none;border-radius:100px;width:20px;height:20px;padding:0;font-size:15px;font-weight:600;margin-left:10px;margin-top:3px;transition:outline-offset .2s;outline:3px solid rgba(191,164,75,0);outline-offset:7px}.body .table-toolbar button.help-button:hover{background:#878787}.body .table-toolbar button.help-button:focus{outline-color:rgba(191,164,75,.3);outline-offset:0}@keyframes highlight{0%{background:#e4e4e3}5%{background:#ffeeaf}10%{background:#ffeeaf}to{background:#e4e4e3}}@keyframes primaryHighlight{0%{background:#262626}5%{background:#ffde63;color:#000}10%{background:#ffde63;color:#000}to{background:#262626;color:#fff}}.table-controls-wrapper.table-controls-wrapper{min-height:65px;padding-top:10px;padding-bottom:10px;align-items:center;justify-content:center}.table-controls-wrapper.table-controls-wrapper .toolbar{max-width:960px}.table-controls-wrapper.table-controls-wrapper .toolbar h2{font-size:1.6rem;display:flex;flex-direction:row;align-items:center}@media only screen and (max-width:480px){.table-controls-wrapper.table-controls-wrapper .toolbar h2{margin-bottom:20px}}.table-controls-wrapper.table-controls-wrapper .filter-wrapper.filter-wrapper{flex:0 1 auto;display:flex;flex-direction:row}.table-controls-wrapper.table-controls-wrapper button.search{align-items:center;display:flex;flex-basis:30px;flex-grow:0;flex-shrink:0;height:30px;justify-content:center;margin-left:5px;padding:5px}.table-controls-wrapper.table-controls-wrapper button.search[aria-disabled=true]{background:#999794;box-shadow:0 0 0 transparent,0 0 0 transparent;cursor:not-allowed}.table-controls-wrapper.table-controls-wrapper button.search[aria-disabled=true]:hover{background:#999794}@media only screen and (max-width:480px){.table-controls-wrapper.table-controls-wrapper button.search{flex-basis:40px;height:40px}}.table-controls-wrapper.table-controls-wrapper .loading-wrapper{margin-left:15px;margin-top:-3px}.table-controls-wrapper.table-controls-wrapper .filter-icon{max-width:19px}.table-controls-wrapper.table-controls-wrapper .description{width:100%;max-width:960px;font-style:italic;margin-bottom:5px;font-size:.9rem}.table-controls-wrapper.table-controls-wrapper .description p{margin-bottom:15px}.filter-popout.filter-popout{padding:20px;position:absolute;right:0;top:35px;background:#eeeeec;border-radius:4px;box-shadow:0 8px 15px -3px rgba(0,0,0,.4);z-index:100;min-width:250px;overflow:hidden}.filter-popout.filter-popout h3{font-weight:800;font-size:1rem;background:#c9c7c4;color:#3d3c3b;margin:-20px;margin-bottom:5px;padding:8px 10px}.filter-popout.filter-popout .field:last-child{padding-bottom:0}.filter-popout.filter-popout .date-range .row{display:flex;flex-direction:column}.filter-popout.filter-popout .date-range .row button:last-child{margin-right:0}.filter-popout-shade{position:fixed;width:100%;height:100%;background:hsla(0,0%,100%,.3);left:0;top:0;z-index:2}.filter-chips{width:100%;max-width:960px;display:flex}.filter-chip{background:#bfa44b;color:#fff;border-radius:3px;font-weight:600;font-size:.8rem;display:flex;align-items:center;margin:3px}.filter-chip:first-child{margin-left:0}.filter-chip:last-child{margin-right:0}.filter-chip div{padding:5px 0}.filter-chip .label{padding-right:7px;padding-left:7px;background:hsla(0,0%,100%,.2)}.filter-chip .value{padding-left:7px;padding-right:4px}.filter-chip button{appearance:none;padding:0;background:hsla(0,0%,100%,.3);color:#fff;border:none;width:16px;height:16px;margin-left:5px;margin-right:4px;border-radius:100%;outline:none}.filter-chip button .svg-icon{width:10px}.filter-chip button .center{padding:0}.filter-chip button:focus,.filter-chip button:hover{background:hsla(0,0%,100%,.5)}.center{display:flex;flex-direction:row;justify-content:center;align-items:center}.table-wrapper{position:relative}@media only screen and (max-width:768px){.table-wrapper{max-width:100vw;overflow-x:auto}}.table-loader{position:absolute;left:0;top:-5px;width:100%;height:5px;background:red}.history-cell{display:flex;flex-direction:column;white-space:pre-wrap}.history-cell label{font-size:11px;font-style:italic;opacity:.6}.history-cell .value{padding-left:5px;padding-top:4px;padding-bottom:4px}.history-cell .value:first-of-type{text-decoration:line-through}.styled-table td.edited:before{display:inline-block;text-align:center;width:14px;height:14px;background:rgba(191,164,75,.3);color:#79672b;border-radius:2px;font-size:20px;line-height:1;content:\"\\2022\"}.styled-table td.edited .value{vertical-align:top}.sort-indicator-wrapper{display:flex;flex:0 0 auto;align-items:center}.sort-indicator-wrapper .sort-indicator{height:20px;width:10px;flex:0 0 auto;margin-left:5px;transform:scale(.8) translateY(-2px)}.sort-indicator-wrapper .sort-indicator:before{content:\"\";position:absolute;width:0;height:0;border-style:solid;border-width:0 4.5px 7px;border-color:transparent transparent #000;opacity:.3}.sort-indicator-wrapper .sort-indicator:after{content:\"\";position:absolute;top:12px;width:0;height:0;border-style:solid;border-width:7px 4.5px 0;border-color:#000 transparent transparent;opacity:.3}.sort-indicator-wrapper .sort-indicator.ascending:before,.sort-indicator-wrapper .sort-indicator.descending:after{opacity:1}.filter-wrapper .help-icon-wrapper{flex:0 0 auto;background:#bfa44b;color:#fff;border-radius:100%;margin-right:10px;width:1.2rem;height:1.2rem;display:flex;justify-content:center;align-items:center;align-self:center;font-size:1.2rem;font-weight:600}.filter-wrapper .help-icon-wrapper .info-help-text{visibility:hidden;width:120px;background-color:#000;color:#fff;padding:5px 0;padding-left:5px;position:absolute;z-index:1;right:102%;font-size:9pt;z-index:100}.filter-wrapper .help-icon-wrapper:hover .info-help-text{visibility:visible}.filter-wrapper .info-help-text:after{content:\"\";position:absolute;top:50%;left:100%;margin-top:-5px;border-width:5px;border-style:solid;border-color:transparent transparent transparent #000}", ""]);
	
	// exports


/***/ },
/* 884 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(10)();
	// imports
	
	
	// module
	exports.push([module.id, ".toast-wrapper{position:fixed;left:50%;bottom:-5vh;z-index:1009;width:1px;height:1px;flex-direction:row}.toast-wrapper,.toast-wrapper .toast{display:flex;justify-content:center;align-items:center}.toast-wrapper .toast{background:#262626;color:#fff;font-weight:600;padding:18px;border-radius:6px;max-width:60vw;flex:0 0 auto;box-shadow:0 15px 30px 0 rgba(0,0,0,.21),0 5px 15px 0 rgba(0,0,0,.12)}@media only screen and (max-width:768px){.toast-wrapper .toast{max-width:90vw}}.toast-wrapper .toast .message{text-align:center;font-size:1rem;font-weight:400}.toast-wrapper .toast .dismiss-btn{padding:5px;color:#fff;border:none;background:#404040;width:26px;height:26px;border-radius:4px;margin:-5px;margin-left:10px;outline:none}.toast-wrapper .toast .dismiss-btn:hover{background:#4c4c4c}.toast-wrapper .toast .dismiss-btn .svg-icon{width:16px}.toast-wrapper .toast.danger{background:#8e2830;color:#fff;box-shadow:0 15px 30px 0 rgba(48,15,15,.21),0 5px 15px 0 rgba(48,15,15,.12)}.toast-wrapper .toast.danger .dismiss-btn{background:#aa2f3a;color:#fff}.toast-wrapper .toast.danger .dismiss-btn:hover{background:#be3541}.toast-wrapper .toast.success{background:#41be46;color:#fff}.toast-wrapper .toast.success .dismiss-btn{background:#67cb6b}.toast-wrapper .toast.success .dismiss-btn:hover{background:#7ad27e}@media only screen and (min-width:992px){.toast-wrapper{left:calc(50% + 100px)}}.float-in-up{animation:float-in-up .5s;animation-fill-mode:forwards}@keyframes float-in-up{0%{transform:translateY(0)}to{transform:translateY(-10vh)}}.float-out-down{animation:float-out-down .5s;animation-fill-mode:forwards}@keyframes float-out-down{0%{transform:translateY(-10vh)}to{transform:translateY(0)}}", ""]);
	
	// exports


/***/ },
/* 885 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(10)();
	// imports
	
	
	// module
	exports.push([module.id, ".unsupported-browser-wrapper{position:fixed;width:100%;height:100%;left:0;top:0;display:flex;justify-content:center;align-items:center;background:rgba(0,0,0,.7);z-index:9999}@supports (backdrop-filter:blur(10px)){.unsupported-browser-wrapper{backdrop-filter:blur(10px) grayscale(100%)}}.unsupported-browser-wrapper .inner-wrapper{width:100%;max-width:500px;padding:15px}.unsupported-browser-wrapper header{width:100%;padding:10px;padding-left:0;padding-right:0;display:flex;color:#fff;align-items:center}.unsupported-browser-wrapper header img{width:55px}.unsupported-browser-wrapper header .title-wrapper{display:flex;justify-content:center;padding-left:10px}.unsupported-browser-wrapper header .title-wrapper h1{font-size:20px;font-weight:600}.unsupported-browser-wrapper header .title-wrapper span{font-size:14px}.unsupported-browser-wrapper header p{margin-left:auto;font-weight:600;font-size:24px}.unsupported-browser-wrapper .message-wrapper{background:#fff;border-radius:3px;padding:20px;box-shadow:0 19px 38px rgba(0,0,0,.3),0 15px 12px rgba(0,0,0,.22);width:100%}.unsupported-browser-wrapper .message-wrapper p{font-size:16px;margin:15px 0}.unsupported-browser-wrapper .message-wrapper p:first-child{margin-top:0}.unsupported-browser-wrapper .message-wrapper p:last-child{margin-bottom:0}.unsupported-browser-wrapper .unsupported-footer{color:#fff;font-size:11px;font-style:italic;text-align:right;margin-top:5px;position:fixed;right:10px;bottom:10px}.unsupported-browser-wrapper .unsupported-footer a{color:#fff}.unsupported-browser-wrapper .browser-list{display:flex;flex-direction:row;margin:10px -10px -10px}.unsupported-browser-wrapper .browser-list a{display:flex;align-items:center;padding:5px;margin:3px;text-decoration:none;color:#1c1c1c;border-radius:6px;transition:background .1s}.unsupported-browser-wrapper .browser-list a img{width:50px;margin-right:10px}.unsupported-browser-wrapper .browser-list a:hover[data-hover-color=red]{background:rgba(255,52,52,.25)}.unsupported-browser-wrapper .browser-list a:hover[data-hover-color=teal]{background:rgba(52,255,170,.25)}.unsupported-browser-wrapper .browser-list a:hover[data-hover-color=blue]{background:rgba(52,164,255,.25)}.unsupported-browser-wrapper .browser-list a:hover[data-hover-color=orange]{background:rgba(255,131,52,.25)}.unsupported-browser-wrapper .browser-column{display:flex;flex-direction:column;width:50%}", ""]);
	
	// exports


/***/ },
/* 886 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(10)();
	// imports
	
	
	// module
	exports.push([module.id, ".user-account-editor{padding:20px}.user-account-editor .field.field.field{margin:0}.user-account-editor em{font-style:italic}", ""]);
	
	// exports


/***/ },
/* 887 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(10)();
	// imports
	
	
	// module
	exports.push([module.id, "#file,#file .page{background:#303030}#file .page{padding-top:30px}.generic-success-page{background:#eeeeec}.generic-success-icon{width:40px;height:40px;background:rgba(65,190,70,.4);display:flex;justify-content:center;align-items:center;padding:2px;padding-right:4px;padding-top:5px;border-radius:100%;color:#fff;margin-right:15px}.business-blocks{display:-webkit-flex;display:flex;-webkit-flex-flow:row wrap;flex-flow:row wrap;-webkit-justify-content:center;justify-content:center}.business-blocks .block{-webkit-flex:0 0 33.333%;flex:0 0 33.333%;padding:10px}@media only screen and (max-width:768px){.business-blocks .block{-webkit-flex:0 0 100%;flex:0 0 100%}}.business-blocks .block h5{width:100%;color:#fff;font-size:18px;text-align:left;margin-top:0;background:#1e1e1e;padding:15px;margin-bottom:10px}.business-blocks .block .block-description{background:#3d3d3d;color:#fff;border-top:none;padding:15px;font-family:Open Sans,sans-serif}.business-blocks .block .file-button{display:block;background:#4a4a4a;border:none;color:#fff;padding:7px;width:100%;margin-top:15px;font-size:16px;font-family:Open Sans,sans-serif}.business-blocks .block .file-button:hover{background:#565656}.intro{background:#fff;padding:20px 0 40px}.intro h2{padding-bottom:5px;font-size:24px;font-weight:400;border-bottom:1px solid #bfa44b}.intro .instruction h3{background:#cfcfcf;border-left:6px solid #1c1c1c;font-size:16px;font-weight:400;padding:4px 8px}.intro .instruction ul{font-family:Open Sans,sans-serif;padding-left:20px}.intro .instruction ul li{margin-bottom:8px;line-height:1.3em}.intro button.start{width:100%;max-width:300px;margin-top:15px;background:#bfa44b;border-color:#937d34;color:#fff;text-shadow:0 1px 0 rgba(0,0,0,.7)}.intro button.start:hover{background:#c4ac5a}.intro button.start:active{background:#b99d42;color:#fff;text-shadow:0 1px 0 rgba(0,0,0,.7)}.designer-wrapper .wizard{margin-top:20px}.scroll-down-text{text-align:center;font-size:small;color:#000;padding:3px;background-color:#fffcfc;border-radius:25px}.scroll-down-container-bottom-right{position:absolute;bottom:80px;right:20px;z-index:999;text-align:center;pointer-events:none}.scroll-down-container{position:-webkit-sticky;position:sticky;right:33%;z-index:999;margin:auto;width:110px;pointer-events:none}.scroll-down-icon{margin:auto;opacity:.5;width:30px;height:30px}#main-wizard-container,#wizard-body-scroll-container{outline:none}#wizard-body-scrollArrow-container-mobile{height:50vh}.wizard{background:none}@media only screen and (max-width:768px){.wizard{margin-bottom:15px}}.wizard .wizard-title{font-size:16px;font-weight:700;margin-bottom:0;background:#ccc;color:#3d3c3b;padding:8px 14px;border-radius:4px 4px 0 0;display:block;box-shadow:0 1px 2px rgba(0,0,0,.3);width:calc(100% + 1px)}@media only screen and (max-width:768px){.wizard .wizard-title{width:100%}}.wizard .wizard-title .prefix{font-weight:400}.wizard .wrapper{background:#eee;margin:15px 0;margin-bottom:0;margin-top:0;border-radius:0 0 4px 4px;box-shadow:0 2px 3px rgba(0,0,0,.3)}.wizard .wrapper .sidebar-wrapper .sidebar{background:-webkit-linear-gradient(115deg,#000,#1c1c1c);background:-moz-linear-gradient(115deg,#000,#1c1c1c);background:-o-linear-gradient(115deg,#000,#1c1c1c);background:linear-gradient(335deg,#000,#1c1c1c);width:100%;height:100%;padding:30px 15px;border-radius:0 0 0 4px}.wizard .wrapper .sidebar-wrapper .sidebar h3{color:#fff;font-size:16px;margin-top:0}.wizard .wrapper .sidebar-wrapper .sidebar button{border:none;border-radius:3px;background:none;color:#fff;width:100%;text-align:left;padding:6px;padding-left:28px;margin-bottom:5px;outline:none;position:relative;cursor:pointer;min-height:28px;text-overflow:ellipsis;font-family:Open Sans,sans-serif}.wizard .wrapper .sidebar-wrapper .sidebar button:hover{background:#303030}.wizard .wrapper .sidebar-wrapper .sidebar button:focus{box-shadow:0 0 0 3px rgba(191,164,75,.6)}.wizard .wrapper .sidebar-wrapper .sidebar button .step-check{margin-top:1px}.wizard .wrapper .sidebar-wrapper .sidebar button .invalid-icon{position:absolute;left:-2px;top:0;width:100%;height:100%;transform:scale(.7);opacity:.8}.wizard .wrapper .sidebar-wrapper .sidebar button .invalid-icon:after,.wizard .wrapper .sidebar-wrapper .sidebar button .invalid-icon:before{width:150%;height:4px;background:#fff;border-radius:4px;transform:rotate(45deg);position:absolute;left:0;top:4px;content:\"\"}.wizard .wrapper .sidebar-wrapper .sidebar button .invalid-icon:after{transform:rotate(-45deg)}.wizard .wrapper .sidebar-wrapper .sidebar button.active{background:-webkit-linear-gradient(210deg,#e6cb73,#7d7150);background:-moz-linear-gradient(210deg,#e6cb73,#7d7150);background:-o-linear-gradient(210deg,#e6cb73,#7d7150);background:linear-gradient(240deg,#e6cb73,#7d7150);box-shadow:0 5px 7px rgba(0,0,0,.2);z-index:9;margin-left:-25px;padding-left:53px;width:calc(100% + 25px)}.wizard .wrapper .sidebar-wrapper .sidebar button.active .step-check{left:30px}.wizard .wrapper .sidebar-wrapper .sidebar button.active:focus{box-shadow:0 0 0 2px rgba(191,164,75,.6),0 5px 7px rgba(0,0,0,.2)}.wizard .wrapper .sidebar-wrapper .sidebar button.step-invalid{background:-webkit-linear-gradient(70deg,#9c1a25,#c92a37);background:-moz-linear-gradient(70deg,#9c1a25,#c92a37);background:-o-linear-gradient(70deg,#9c1a25,#c92a37);background:linear-gradient(20deg,#9c1a25,#c92a37)}@media only screen and (max-width:768px){.wizard .wrapper .sidebar-wrapper .sidebar{padding:15px 15px 10px}.wizard .wrapper .sidebar-wrapper .sidebar button{font-size:.9rem}}.wizard .wrapper .body{padding:30px;padding-bottom:20px;height:calc(100vh - 175px - 60px);margin-bottom:60px;overflow-y:auto}@media only screen and (max-width:768px){.wizard .wrapper .body{overflow-y:auto;height:auto}}.wizard .wrapper .body.full-width form{display:flex;align-items:center;flex-direction:column}.wizard .wrapper .body.full-width form .section{width:100%;max-width:750px}.wizard .wrapper .body.no-toolbar{margin-bottom:0;height:calc(100vh - 115px - 60px)}.wizard .wrapper .body .section{margin-bottom:20px;padding-right:0;position:relative}.wizard .wrapper .body .section:last-child .bottom-divider{display:none}.wizard .wrapper .body .section .description{font-size:13px;font-style:italic;margin:6px 0}.wizard .wrapper .body .section .description p{margin:0;font-size:13px;line-height:1.2;margin-bottom:3px}.wizard .wrapper .body .section .description p:only-child{padding:0}.wizard .wrapper .body .section .description p em,.wizard .wrapper .body .section .description p strong{font-weight:800}.wizard .wrapper .body .section>.description{margin-top:-10px}.wizard .wrapper .body .section h2{margin:0;color:#1c1c1c;font-weight:700;font-size:1rem;padding-bottom:15px}@media only screen and (max-width:768px){.wizard .wrapper .body .section{padding-right:0}}@media only screen and (max-width:768px){.wizard .wrapper .body{padding:15px 15px 60px}}.wizard .toolbar{position:absolute;width:100%;height:60px;bottom:0;left:-2px;padding:15px;background:#ddd;border-bottom-right-radius:4px;z-index:9;display:flex;flex-direction:row;align-items:center;border-top:1px solid rgba(0,0,0,.2)}@media only screen and (max-width:768px){.wizard .toolbar.admin{overflow-x:auto;overflow-y:hidden}.wizard .toolbar.admin button,.wizard .toolbar.admin label{min-height:30px}}.wizard .toolbar button,.wizard .toolbar label{margin-left:5px;flex:0 0 auto;height:100%;display:flex;align-items:center;justify-content:center;font-size:.8rem;padding:0 9px;padding-bottom:2px}.wizard .toolbar button.btn-default,.wizard .toolbar label.btn-default{border:none;background:hsla(36,2%,59%,.2)}.wizard .toolbar button.btn-default:hover,.wizard .toolbar label.btn-default:hover{background:hsla(36,2%,59%,.3)}.wizard .toolbar button .svg-icon,.wizard .toolbar label .svg-icon{max-width:20px}@media only screen and (max-width:768px){.wizard .toolbar{left:0;width:100%;padding-left:6px;border-bottom-left-radius:6px}}.wizard .toolbar .right-align{display:flex;flex-direction:row;margin-left:auto;align-items:center;height:100%}.wizard .toolbar .loader{float:right;display:flex}.wizard .toolbar .loader-text{margin-right:4px;display:block;flex:1 1 auto;text-align:right;color:#909090;font-weight:600;font-size:.75rem}.wizard .save-indicator{color:#41be46;font-weight:600;padding:7px 10px}.wizard .save-indicator .icon,.wizard .save-indicator .text{animation-delay:2s}.wizard .save-indicator .icon{margin-right:3px;margin-top:1px}.wizard .save-indicator .text{margin-top:0}.wizard .field{margin:0 -7px;position:relative;padding:9px 7px;transition:transform .2s,box-shadow .2s,background .1s}.wizard .field.changed{background:hsla(46,70%,68%,.1);border-radius:5px;box-shadow:0 4px 4px -1px rgba(76,62,14,.25),0 -2px 2px -2px rgba(76,62,14,.2)}.wizard .field.consent{margin-top:10px;display:inline-block}.wizard .field button.field-revert{width:25px;height:25px;background:#bfa44b;color:#fff;border-radius:100%;border:none;position:absolute;right:-7px;top:-7px;padding:4px;text-align:center;box-shadow:0 3px 4px 1px rgba(0,0,0,.3);cursor:pointer;z-index:9;display:flex;justify-content:center;align-items:center}.wizard .field button.field-revert:hover{background:#9f8738}.wizard .field button.field-revert .__react_component_tooltip{background:#111;text-transform:uppercase;font-weight:600}.wizard .field .top{margin-bottom:15px}.wizard .field p.description{font-size:13px;font-style:italic;display:block;margin:0 0 6px}.wizard .field .field-label{font-weight:600;display:block;position:relative;margin-bottom:3px}.wizard .field .field-label .required{color:#b31010;font-size:.8rem;margin-left:2px}.wizard .field .field-label .label-text{position:relative;transition:background .3s,padding .3s,margin .3s}.wizard-toolbar-popover.wizard-toolbar-popover.wizard-toolbar-popover{position:absolute;bottom:80px;right:25px;padding:15px 20px;background:#fff;box-shadow:0 10px 20px rgba(0,0,0,.19),0 6px 6px rgba(0,0,0,.23);border-left:6px solid #f47586;border-radius:3px;max-width:230px;line-height:1.3;animation:pop-in-up .3s;animation-fill-mode:forwards;font-size:.85rem;white-space:pre-wrap}.wizard-toolbar-popover.wizard-toolbar-popover.wizard-toolbar-popover:before{content:\"!\";font-weight:800;font-size:1.4rem;line-height:0;color:#fff;background:#c01027;position:absolute;width:30px;height:30px;border-radius:100%;display:flex;justify-content:center;align-items:center;left:-17px;top:-10px;animation:pop-in-up .3s;animation-fill-mode:forwards;animation-delay:.1s;opacity:0;box-shadow:0 3px 6px rgba(0,0,0,.16),0 3px 6px rgba(0,0,0,.23)}.wizard-toolbar-popover.wizard-toolbar-popover.wizard-toolbar-popover:after{content:\"\";width:0;height:0;border-style:solid;border-width:0 12px 12px 0;border-color:transparent #fff transparent transparent;position:absolute;right:30px;bottom:-12px}.wizard-toolbar-popover.wizard-toolbar-popover.wizard-toolbar-popover.is-mobile{right:auto;bottom:5%;position:fixed;width:90%;left:5%;max-width:none;padding:20px;font-size:1rem;padding-right:30px}.wizard-toolbar-popover.wizard-toolbar-popover.wizard-toolbar-popover.is-mobile button{width:40px;height:40px;font-size:20px}.wizard-toolbar-popover.wizard-toolbar-popover.wizard-toolbar-popover.is-mobile:after{display:none}.wizard-toolbar-popover.wizard-toolbar-popover.wizard-toolbar-popover button{width:25px;height:25px;background:none;border:none;display:flex;justify-content:center;align-items:center;position:absolute;right:0;top:0;color:#999794}.wizard-toolbar-popover.wizard-toolbar-popover.wizard-toolbar-popover button:hover{color:#666665}.wizard-loader-wrapper{padding-top:80px}.wizard-loader-wrapper .orbit-loader{animation-delay:1s}.flex-column{display:flex;flex-direction:column}.confirm.confirm.confirm{margin-bottom:0;position:relative;font-size:.8rem;margin-top:15px}.confirm.confirm.confirm .confirm-col{margin-bottom:20px}.confirm.confirm.confirm .confirm-step{display:flex;flex-direction:column;background:#ddd;border-radius:6px;padding:10px;padding-top:25px;padding-bottom:1px;position:relative;box-shadow:0 1px 1px rgba(0,0,0,.3);display:block;flex:0 0 auto;margin-bottom:5px}.confirm.confirm.confirm .confirm-step i{font-style:normal}.confirm.confirm.confirm .confirm-step b{font-weight:600}.confirm.confirm.confirm .confirm-step .title{width:100%;position:absolute;top:0;left:0;border-top-left-radius:6px;border-top-right-radius:6px;background:#1c1c1c;color:#fff;padding:6px 0 6px 10px;font-weight:400;font-size:.85rem}.confirm.confirm.confirm .confirm-section .section-title{background:#b8b5b1;margin:0 -10px;color:#000;font-size:.8rem;padding:5px 10px;font-weight:600;font-style:italic}.confirm.confirm.confirm .confirm-section .row{margin-bottom:0}.confirm.confirm.confirm .confirm-section .field-divider{border-bottom:1px dotted rgba(0,0,0,.3);line-height:1.4}.confirm.confirm.confirm .confirm-section .field-divider .markdown{font-size:.8rem}.confirm.confirm.confirm .confirm-section .field-divider div{padding:15px 10px 15px 15px}.confirm.confirm.confirm .confirm-section .field-divider .field-divider{padding:0}.confirm.confirm.confirm .confirm-section .field-divider:last-child{border-bottom:none}.confirm.confirm.confirm .confirm-section .field-divider .value{border-left:1px dotted rgba(0,0,0,.3);white-space:pre-wrap;overflow-wrap:break-word}.confirm.confirm.confirm .confirm-section .field-divider .col-12{border-left:none}.confirm.confirm.confirm .confirm-section .field-divider .col-12 b{font-weight:400}.confirm.confirm.confirm .confirm-section .markdown.markdown.markdown{padding:0}.confirm.confirm.confirm .confirm-section .confirm-result .secondary{font-style:italic;font-weight:400;margin-top:10px}.confirm.confirm.confirm .confirm-section .confirm-result .secondary.first{margin-top:0}.confirm.confirm.confirm .repeats-wrapper{width:100%;display:block;margin-top:5px}.confirm.confirm.confirm .repeats{margin-top:0;margin-bottom:0;width:100%}.confirm.confirm.confirm .repeats.dumb-repeats{overflow-x:auto}.confirm.confirm.confirm .repeats thead{background:#c9c7c4;color:#3d3c3b;font-weight:600}.confirm.confirm.confirm .repeats .repeats-row:hover{background:#fff}.confirm.confirm.confirm .repeats .repeats-row td{padding:10px}.confirm.confirm.confirm .repeats .no-entries{text-align:center}.hr-result{line-height:1.3}.hr-result .h1{font-weight:600}.hr-result .label{font-size:11px;font-style:italic}.hr-result .result-value{padding-left:10px}.bottom-divider{width:100%;height:4px;margin-top:20px;border-radius:5px;background:#1c1c1c}.bottom-divider.search-divider{background:#bbb}.field-divider{margin-bottom:5px;position:relative}.field-divider:after{width:100%;margin-left:15px;margin-top:10px;margin-bottom:10px;height:10px;border-bottom:1px dotted rgba(0,0,0,.3)}.fast-animation{-webkit-animation-duration:.5s;animation-duration:.5s;-webkit-transition-duration:.5s;transition-duration:.5s}.extra-fast-animation{-webkit-animation-duration:.3s;animation-duration:.3s;-webkit-transition-duration:.3s;transition-duration:.3s}.field-error{margin-top:3px;color:#d00000;font-size:11px;font-style:italic;white-space:pre-wrap;line-height:1.3}.standalone-error:first-child{margin-bottom:3px}.info-message{padding:10px 5px;margin:5px 0;background:#cdeeff;border-radius:4px;border:1px solid #9fdeff;color:#1d76a3;font-size:.8rem;line-height:1.3;font-style:italic;display:flex;flex-direction:row;white-space:pre-wrap}.info-message .icon-wrapper{padding-right:5px}.info-message .i-icon,.info-message .icon-wrapper{display:flex;justify-content:center;align-items:center}.info-message .i-icon{text-align:center}.feedback{display:block;background:#fbe584;width:100%;padding:10px;border-radius:6px}.feedback,.feedback .field-error{color:#a37d1a}.feedback span{color:inherit}@keyframes focusZoom{0%{outline:3px solid rgba(191,164,75,0);outline-offset:7px}80%{outline:3px solid rgba(191,164,75,.6);outline-offset:0}to{outline:3px solid rgba(191,164,75,0);outline-offset:-3px}}.dummy-text-input{width:100%;padding:8px;padding-left:10px;padding-right:10px;border:3px solid #c3c3c3;border-radius:5px;line-height:1.4;background:#d5d4d1;cursor:not-allowed}.attribute-container input,.attribute-container select,.attribute-container textarea,.condition-editor input,.condition-editor select,.condition-editor textarea,.designer-wrapper input,.designer-wrapper select,.designer-wrapper textarea,.sub-designer input,.sub-designer select,.sub-designer textarea,.wizard input,.wizard select,.wizard textarea{background:#fff}.attribute-container input:disabled,.attribute-container select:disabled,.attribute-container textarea:disabled,.condition-editor input:disabled,.condition-editor select:disabled,.condition-editor textarea:disabled,.designer-wrapper input:disabled,.designer-wrapper select:disabled,.designer-wrapper textarea:disabled,.sub-designer input:disabled,.sub-designer select:disabled,.sub-designer textarea:disabled,.wizard input:disabled,.wizard select:disabled,.wizard textarea:disabled{color:#3d3c3b;opacity:1;background:#d5d4d1;cursor:not-allowed}.attribute-container input,.attribute-container textarea,.condition-editor input,.condition-editor textarea,.designer-wrapper input,.designer-wrapper textarea,.sub-designer input,.sub-designer textarea,.wizard input,.wizard textarea{display:block;transition:border .3s,padding-right .3s}.attribute-container input[type=password],.attribute-container input[type=text],.attribute-container textarea[type=password],.attribute-container textarea[type=text],.condition-editor input[type=password],.condition-editor input[type=text],.condition-editor textarea[type=password],.condition-editor textarea[type=text],.designer-wrapper input[type=password],.designer-wrapper input[type=text],.designer-wrapper textarea[type=password],.designer-wrapper textarea[type=text],.sub-designer input[type=password],.sub-designer input[type=text],.sub-designer textarea[type=password],.sub-designer textarea[type=text],.wizard input[type=password],.wizard input[type=text],.wizard textarea[type=password],.wizard textarea[type=text]{width:100%;padding-left:10px;padding-right:10px;border:3px solid #c3c3c3;border-radius:5px;height:35px}.attribute-container input:focus,.attribute-container textarea:focus,.condition-editor input:focus,.condition-editor textarea:focus,.designer-wrapper input:focus,.designer-wrapper textarea:focus,.sub-designer input:focus,.sub-designer textarea:focus,.wizard input:focus,.wizard textarea:focus{outline:none;border-color:#25bdf5}.attribute-container input.w10,.attribute-container textarea.w10,.condition-editor input.w10,.condition-editor textarea.w10,.designer-wrapper input.w10,.designer-wrapper textarea.w10,.sub-designer input.w10,.sub-designer textarea.w10,.wizard input.w10,.wizard textarea.w10{width:10%}.attribute-container input.w20,.attribute-container textarea.w20,.condition-editor input.w20,.condition-editor textarea.w20,.designer-wrapper input.w20,.designer-wrapper textarea.w20,.sub-designer input.w20,.sub-designer textarea.w20,.wizard input.w20,.wizard textarea.w20{width:20%}.attribute-container input.w30,.attribute-container textarea.w30,.condition-editor input.w30,.condition-editor textarea.w30,.designer-wrapper input.w30,.designer-wrapper textarea.w30,.sub-designer input.w30,.sub-designer textarea.w30,.wizard input.w30,.wizard textarea.w30{width:30%}.attribute-container input.w40,.attribute-container textarea.w40,.condition-editor input.w40,.condition-editor textarea.w40,.designer-wrapper input.w40,.designer-wrapper textarea.w40,.sub-designer input.w40,.sub-designer textarea.w40,.wizard input.w40,.wizard textarea.w40{width:40%}.attribute-container input.w50,.attribute-container textarea.w50,.condition-editor input.w50,.condition-editor textarea.w50,.designer-wrapper input.w50,.designer-wrapper textarea.w50,.sub-designer input.w50,.sub-designer textarea.w50,.wizard input.w50,.wizard textarea.w50{width:50%}.attribute-container input.w60,.attribute-container textarea.w60,.condition-editor input.w60,.condition-editor textarea.w60,.designer-wrapper input.w60,.designer-wrapper textarea.w60,.sub-designer input.w60,.sub-designer textarea.w60,.wizard input.w60,.wizard textarea.w60{width:60%}.attribute-container input.w70,.attribute-container textarea.w70,.condition-editor input.w70,.condition-editor textarea.w70,.designer-wrapper input.w70,.designer-wrapper textarea.w70,.sub-designer input.w70,.sub-designer textarea.w70,.wizard input.w70,.wizard textarea.w70{width:70%}.attribute-container input.w80,.attribute-container textarea.w80,.condition-editor input.w80,.condition-editor textarea.w80,.designer-wrapper input.w80,.designer-wrapper textarea.w80,.sub-designer input.w80,.sub-designer textarea.w80,.wizard input.w80,.wizard textarea.w80{width:80%}.attribute-container input.w90,.attribute-container textarea.w90,.condition-editor input.w90,.condition-editor textarea.w90,.designer-wrapper input.w90,.designer-wrapper textarea.w90,.sub-designer input.w90,.sub-designer textarea.w90,.wizard input.w90,.wizard textarea.w90{width:90%}.attribute-container input.w100,.attribute-container textarea.w100,.condition-editor input.w100,.condition-editor textarea.w100,.designer-wrapper input.w100,.designer-wrapper textarea.w100,.sub-designer input.w100,.sub-designer textarea.w100,.wizard input.w100,.wizard textarea.w100{width:100%}.attribute-container textarea,.condition-editor textarea,.designer-wrapper textarea,.sub-designer textarea,.wizard textarea{width:100%;padding-left:10px;border:3px solid #c3c3c3;border-radius:5px}.attribute-container .text-wrapper,.condition-editor .text-wrapper,.designer-wrapper .text-wrapper,.sub-designer .text-wrapper,.wizard .text-wrapper{position:relative;display:inline-block}.attribute-container .validation-indicator,.condition-editor .validation-indicator,.designer-wrapper .validation-indicator,.sub-designer .validation-indicator,.wizard .validation-indicator{position:absolute;left:-4px;top:0;width:calc(100% + 1px);height:0;background:rgba(28,28,28,.7);background:-moz-linear-gradient(top,rgba(28,28,28,.7) 0,rgba(28,28,28,0) 100%);background:-webkit-gradient(linear,left top,left bottom,color-stop(0,rgba(28,28,28,.7)),color-stop(100%,rgba(28,28,28,0)));background:-webkit-linear-gradient(top,rgba(28,28,28,.7),rgba(28,28,28,0));background:-o-linear-gradient(top,rgba(28,28,28,.7) 0,rgba(28,28,28,0) 100%);background:-ms-linear-gradient(top,rgba(28,28,28,.7) 0,rgba(28,28,28,0) 100%);background:linear-gradient(180deg,rgba(28,28,28,.7) 0,rgba(28,28,28,0));filter:progid:DXImageTransform.Microsoft.gradient(startColorstr=\"#ffffff\",endColorstr=\"#000000\",GradientType=0);color:#fff;z-index:99;overflow:hidden;transition:height .3s;user-select:none;pointer-events:none}.attribute-container .validation-indicator.show,.condition-editor .validation-indicator.show,.designer-wrapper .validation-indicator.show,.sub-designer .validation-indicator.show,.wizard .validation-indicator.show{height:250px}.attribute-container .validation-indicator .loader,.condition-editor .validation-indicator .loader,.designer-wrapper .validation-indicator .loader,.sub-designer .validation-indicator .loader,.wizard .validation-indicator .loader{margin:0 auto;margin-top:34px;width:120px;text-align:center}.attribute-container .validation-shade,.condition-editor .validation-shade,.designer-wrapper .validation-shade,.sub-designer .validation-shade,.wizard .validation-shade{position:absolute;left:0;top:0;width:100%;height:100%;background:none;z-index:98}.attribute-container .valid input,.attribute-container .valid textarea,.condition-editor .valid input,.condition-editor .valid textarea,.designer-wrapper .valid input,.designer-wrapper .valid textarea,.sub-designer .valid input,.sub-designer .valid textarea,.wizard .valid input,.wizard .valid textarea{border-color:#5add76;padding-right:25px}.attribute-container .valid:after,.condition-editor .valid:after,.designer-wrapper .valid:after,.sub-designer .valid:after,.wizard .valid:after{content:\"\\E903\";position:absolute;top:7px;right:6px;display:inline-block;font-family:icomoon;font-size:1.2rem;font-style:normal;font-weight:400;line-height:1;-webkit-font-smoothing:antialiased;color:#5add76;-webkit-animation-duration:.6s;animation-duration:.6s;-webkit-animation-fill-mode:both;animation-fill-mode:both;-webkit-animation-name:fadeInRight;animation-name:fadeInRight}.attribute-container select.valid,.condition-editor select.valid,.designer-wrapper select.valid,.sub-designer select.valid,.wizard select.valid{border-color:#5add76}.attribute-container .warning input,.attribute-container .warning textarea,.condition-editor .warning input,.condition-editor .warning textarea,.designer-wrapper .warning input,.designer-wrapper .warning textarea,.sub-designer .warning input,.sub-designer .warning textarea,.wizard .warning input,.wizard .warning textarea{border-color:#f9d25c}.attribute-container .invalid input,.attribute-container .invalid textarea,.condition-editor .invalid input,.condition-editor .invalid textarea,.designer-wrapper .invalid input,.designer-wrapper .invalid textarea,.sub-designer .invalid input,.sub-designer .invalid textarea,.wizard .invalid input,.wizard .invalid textarea{border-color:#ff6774;padding-right:25px}.attribute-container .invalid:after,.condition-editor .invalid:after,.designer-wrapper .invalid:after,.sub-designer .invalid:after,.wizard .invalid:after{content:\"\\E901\";position:absolute;top:7px;right:6px;display:inline-block;font-size:1.2rem;font-family:icomoon;font-style:normal;font-weight:400;line-height:1;-webkit-font-smoothing:antialiased;color:#ff6774;-webkit-animation-duration:.6s;animation-duration:.6s;-webkit-animation-fill-mode:both;animation-fill-mode:both;-webkit-animation-name:fadeInRight;animation-name:fadeInRight}.attribute-container select.invalid,.condition-editor select.invalid,.designer-wrapper select.invalid,.sub-designer select.invalid,.wizard select.invalid{border-color:#ff6774}.attribute-container select.warning,.condition-editor select.warning,.designer-wrapper select.warning,.sub-designer select.warning,.wizard select.warning{border-color:#f9d25c}.attribute-container button.form-button,.condition-editor button.form-button,.designer-wrapper button.form-button,.sub-designer button.form-button,.wizard button.form-button{background:#303030;border-color:#0f0f0f;color:#fff;text-shadow:0 1px 0 rgba(0,0,0,.7);width:100%}.attribute-container button.form-button:hover,.condition-editor button.form-button:hover,.designer-wrapper button.form-button:hover,.sub-designer button.form-button:hover,.wizard button.form-button:hover{background:#3a3a3a}.attribute-container button.form-button:active,.condition-editor button.form-button:active,.designer-wrapper button.form-button:active,.sub-designer button.form-button:active,.wizard button.form-button:active{background:#282828;color:#fff;text-shadow:0 1px 0 rgba(0,0,0,.7)}.attribute-container button.form-button:focus,.attribute-container button.form-button:hover,.condition-editor button.form-button:focus,.condition-editor button.form-button:hover,.designer-wrapper button.form-button:focus,.designer-wrapper button.form-button:hover,.sub-designer button.form-button:focus,.sub-designer button.form-button:hover,.wizard button.form-button:focus,.wizard button.form-button:hover{color:#fff}.attribute-container button.form-button.secondary,.condition-editor button.form-button.secondary,.designer-wrapper button.form-button.secondary,.sub-designer button.form-button.secondary,.wizard button.form-button.secondary{background:#bfbfbf;border-color:#9e9e9e;color:#222;text-shadow:0 1px 0 hsla(0,0%,100%,.7);width:100%}.attribute-container button.form-button.secondary:hover,.condition-editor button.form-button.secondary:hover,.designer-wrapper button.form-button.secondary:hover,.sub-designer button.form-button.secondary:hover,.wizard button.form-button.secondary:hover{background:#c9c9c9}.attribute-container button.form-button.secondary:active,.condition-editor button.form-button.secondary:active,.designer-wrapper button.form-button.secondary:active,.sub-designer button.form-button.secondary:active,.wizard button.form-button.secondary:active{background:#b7b7b7;color:#222;text-shadow:0 1px 0 hsla(0,0%,100%,.7)}.attribute-container p.paragraph,.condition-editor p.paragraph,.designer-wrapper p.paragraph,.sub-designer p.paragraph,.wizard p.paragraph{font-size:13px}.attribute-container .checkbox-wrapper,.condition-editor .checkbox-wrapper,.designer-wrapper .checkbox-wrapper,.sub-designer .checkbox-wrapper,.wizard .checkbox-wrapper{width:100%;display:flex;flex-direction:row}.attribute-container .checkbox-wrapper input[type=checkbox],.condition-editor .checkbox-wrapper input[type=checkbox],.designer-wrapper .checkbox-wrapper input[type=checkbox],.sub-designer .checkbox-wrapper input[type=checkbox],.wizard .checkbox-wrapper input[type=checkbox]{width:.1px;opacity:0;background:transparent;border:none;margin:0;padding:0;position:fixed;left:-3px;top:-3px}.attribute-container .checkbox-wrapper input[type=checkbox]:focus+label,.condition-editor .checkbox-wrapper input[type=checkbox]:focus+label,.designer-wrapper .checkbox-wrapper input[type=checkbox]:focus+label,.sub-designer .checkbox-wrapper input[type=checkbox]:focus+label,.wizard .checkbox-wrapper input[type=checkbox]:focus+label{border-color:#25bdf5}.attribute-container .checkbox-wrapper input[type=checkbox]+label,.condition-editor .checkbox-wrapper input[type=checkbox]+label,.designer-wrapper .checkbox-wrapper input[type=checkbox]+label,.sub-designer .checkbox-wrapper input[type=checkbox]+label,.wizard .checkbox-wrapper input[type=checkbox]+label{width:20px;height:20px;border:3px solid #c3c3c3;background:#fff;border-radius:5px;flex:0 0 20px;cursor:pointer;position:relative}.attribute-container .checkbox-wrapper input[type=checkbox]:checked+label:after,.condition-editor .checkbox-wrapper input[type=checkbox]:checked+label:after,.designer-wrapper .checkbox-wrapper input[type=checkbox]:checked+label:after,.sub-designer .checkbox-wrapper input[type=checkbox]:checked+label:after,.wizard .checkbox-wrapper input[type=checkbox]:checked+label:after{content:\"\";width:10px;height:10px;background:#1c1c1c;position:absolute;left:2px;top:2px;border-radius:3px}.attribute-container .checkbox-wrapper input[type=checkbox]:disabled+label,.condition-editor .checkbox-wrapper input[type=checkbox]:disabled+label,.designer-wrapper .checkbox-wrapper input[type=checkbox]:disabled+label,.sub-designer .checkbox-wrapper input[type=checkbox]:disabled+label,.wizard .checkbox-wrapper input[type=checkbox]:disabled+label{background:#d5d4d1;border:3px solid #bfbdb9;cursor:not-allowed}.attribute-container .checkbox-wrapper input[type=checkbox]:disabled~.checkbox-label,.condition-editor .checkbox-wrapper input[type=checkbox]:disabled~.checkbox-label,.designer-wrapper .checkbox-wrapper input[type=checkbox]:disabled~.checkbox-label,.sub-designer .checkbox-wrapper input[type=checkbox]:disabled~.checkbox-label,.wizard .checkbox-wrapper input[type=checkbox]:disabled~.checkbox-label{cursor:not-allowed}.attribute-container .checkbox-wrapper .checkbox-label,.condition-editor .checkbox-wrapper .checkbox-label,.designer-wrapper .checkbox-wrapper .checkbox-label,.sub-designer .checkbox-wrapper .checkbox-label,.wizard .checkbox-wrapper .checkbox-label{font-weight:600;flex:0 1 auto;position:relative;margin-bottom:10px;margin-left:8px;line-height:1.4;cursor:pointer}.attribute-container .checkbox-wrapper .checkbox-label .required,.condition-editor .checkbox-wrapper .checkbox-label .required,.designer-wrapper .checkbox-wrapper .checkbox-label .required,.sub-designer .checkbox-wrapper .checkbox-label .required,.wizard .checkbox-wrapper .checkbox-label .required{color:#b31010;display:inline}.attribute-container select,.condition-editor select,.designer-wrapper select,.sub-designer select,.wizard select{width:100%;height:30px;padding-left:10px;border:3px solid #c3c3c3;border-radius:5px;height:35px;transition:border-color .3s}.attribute-container select:focus,.condition-editor select:focus,.designer-wrapper select:focus,.sub-designer select:focus,.wizard select:focus{outline:none;border-color:#25bdf5}.attribute-container .radio-group,.condition-editor .radio-group,.designer-wrapper .radio-group,.sub-designer .radio-group,.wizard .radio-group{padding-left:7px}.attribute-container .radio-group .option-wrapper,.condition-editor .radio-group .option-wrapper,.designer-wrapper .radio-group .option-wrapper,.sub-designer .radio-group .option-wrapper,.wizard .radio-group .option-wrapper{position:relative;display:inline-block;width:100%;margin:5px 0}.attribute-container .radio-group .option-wrapper.left-align,.condition-editor .radio-group .option-wrapper.left-align,.designer-wrapper .radio-group .option-wrapper.left-align,.sub-designer .radio-group .option-wrapper.left-align,.wizard .radio-group .option-wrapper.left-align{width:auto;margin-right:10px}.attribute-container .radio-group .option-wrapper .radio-label.radio-label.radio-label,.condition-editor .radio-group .option-wrapper .radio-label.radio-label.radio-label,.designer-wrapper .radio-group .option-wrapper .radio-label.radio-label.radio-label,.sub-designer .radio-group .option-wrapper .radio-label.radio-label.radio-label,.wizard .radio-group .option-wrapper .radio-label.radio-label.radio-label{font-weight:400;height:.8rem;line-height:1.2rem}.attribute-container .radio-group label,.condition-editor .radio-group label,.designer-wrapper .radio-group label,.sub-designer .radio-group label,.wizard .radio-group label{position:relative;display:inline-block;padding-left:25px;cursor:pointer;transition:all .3s}.attribute-container .radio-group label:before,.condition-editor .radio-group label:before,.designer-wrapper .radio-group label:before,.sub-designer .radio-group label:before,.wizard .radio-group label:before{position:absolute;width:20px;height:20px;left:0;top:0;background:#fff;border:3px solid #c3c3c3;content:\"\";display:inline-block;border-radius:15px;cursor:pointer}.attribute-container .radio-group input[type=radio],.condition-editor .radio-group input[type=radio],.designer-wrapper .radio-group input[type=radio],.sub-designer .radio-group input[type=radio],.wizard .radio-group input[type=radio]{width:.1px;opacity:0;background:transparent;border:none;float:left}.attribute-container .radio-group input[type=radio]:focus+label:before,.condition-editor .radio-group input[type=radio]:focus+label:before,.designer-wrapper .radio-group input[type=radio]:focus+label:before,.sub-designer .radio-group input[type=radio]:focus+label:before,.wizard .radio-group input[type=radio]:focus+label:before{border-color:#25bdf5}.attribute-container .radio-group input[type=radio]:checked+label:after,.condition-editor .radio-group input[type=radio]:checked+label:after,.designer-wrapper .radio-group input[type=radio]:checked+label:after,.sub-designer .radio-group input[type=radio]:checked+label:after,.wizard .radio-group input[type=radio]:checked+label:after{position:absolute;width:10px;height:10px;left:5px;top:5px;background:#1c1c1c;content:\"\";display:inline-block;border-radius:15px;cursor:pointer}.attribute-container .file-wrapper,.condition-editor .file-wrapper,.designer-wrapper .file-wrapper,.sub-designer .file-wrapper,.wizard .file-wrapper{margin-top:5px}.attribute-container .file-wrapper .file-column,.attribute-container .file-wrapper .row,.condition-editor .file-wrapper .file-column,.condition-editor .file-wrapper .row,.designer-wrapper .file-wrapper .file-column,.designer-wrapper .file-wrapper .row,.sub-designer .file-wrapper .file-column,.sub-designer .file-wrapper .row,.wizard .file-wrapper .file-column,.wizard .file-wrapper .row{padding:0}.attribute-container .file-wrapper .hidden-upload,.condition-editor .file-wrapper .hidden-upload,.designer-wrapper .file-wrapper .hidden-upload,.sub-designer .file-wrapper .hidden-upload,.wizard .file-wrapper .hidden-upload{width:.1px;height:.1px;opacity:0;overflow:hidden;position:absolute;z-index:-1}.attribute-container .file-wrapper .hidden-upload:focus+.styled-file-upload,.condition-editor .file-wrapper .hidden-upload:focus+.styled-file-upload,.designer-wrapper .file-wrapper .hidden-upload:focus+.styled-file-upload,.sub-designer .file-wrapper .hidden-upload:focus+.styled-file-upload,.wizard .file-wrapper .hidden-upload:focus+.styled-file-upload{outline-color:rgba(191,164,75,.3);outline-offset:0;outline-offset:-4px}.attribute-container .file-wrapper .styled-file-upload,.condition-editor .file-wrapper .styled-file-upload,.designer-wrapper .file-wrapper .styled-file-upload,.sub-designer .file-wrapper .styled-file-upload,.wizard .file-wrapper .styled-file-upload{display:flex;width:100%;padding:15px;text-align:center;border-radius:5px;border:2px dashed #7d7d7d;font-weight:600;color:#1c1c1c;justify-content:center;align-items:center;transition:all .2s;cursor:pointer;transition:outline-offset .2s;outline:3px solid rgba(191,164,75,0);outline-offset:7px}.attribute-container .file-wrapper .styled-file-upload:hover,.condition-editor .file-wrapper .styled-file-upload:hover,.designer-wrapper .file-wrapper .styled-file-upload:hover,.sub-designer .file-wrapper .styled-file-upload:hover,.wizard .file-wrapper .styled-file-upload:hover{background:rgba(61,61,61,.1)}.attribute-container .file-wrapper .styled-file-upload .icon,.condition-editor .file-wrapper .styled-file-upload .icon,.designer-wrapper .file-wrapper .styled-file-upload .icon,.sub-designer .file-wrapper .styled-file-upload .icon,.wizard .file-wrapper .styled-file-upload .icon{margin-top:3px;margin-right:10px;font-size:1.2rem}.attribute-container .file-wrapper .styled-file-upload.disabled,.condition-editor .file-wrapper .styled-file-upload.disabled,.designer-wrapper .file-wrapper .styled-file-upload.disabled,.sub-designer .file-wrapper .styled-file-upload.disabled,.wizard .file-wrapper .styled-file-upload.disabled{color:#999794;border-color:#c9c7c4;background:#e4e4e3;cursor:not-allowed}.attribute-container .file-wrapper .styled-file-upload.disabled:hover,.condition-editor .file-wrapper .styled-file-upload.disabled:hover,.designer-wrapper .file-wrapper .styled-file-upload.disabled:hover,.sub-designer .file-wrapper .styled-file-upload.disabled:hover,.wizard .file-wrapper .styled-file-upload.disabled:hover{background:#e4e4e3}.attribute-container .file-wrapper .progress,.condition-editor .file-wrapper .progress,.designer-wrapper .file-wrapper .progress,.sub-designer .file-wrapper .progress,.wizard .file-wrapper .progress{width:100%;height:55px;display:flex;align-items:center;margin-bottom:8px;background:rgba(198,174,94,.15);border-radius:5px;position:relative;padding:10px;transition:background .4s,box-shadow .4s}.attribute-container .file-wrapper .progress.success,.condition-editor .file-wrapper .progress.success,.designer-wrapper .file-wrapper .progress.success,.sub-designer .file-wrapper .progress.success,.wizard .file-wrapper .progress.success{background:-webkit-linear-gradient(70deg,#7d7150,#e6cb73);background:-moz-linear-gradient(70deg,#7d7150,#e6cb73);background:-o-linear-gradient(70deg,#7d7150,#e6cb73);background:linear-gradient(20deg,#7d7150,#e6cb73);box-shadow:0 3px 6px rgba(0,0,0,.16),0 3px 6px rgba(0,0,0,.23)}.attribute-container .file-wrapper .progress.success .bar,.condition-editor .file-wrapper .progress.success .bar,.designer-wrapper .file-wrapper .progress.success .bar,.sub-designer .file-wrapper .progress.success .bar,.wizard .file-wrapper .progress.success .bar{opacity:0}.attribute-container .file-wrapper .progress.success .filename,.condition-editor .file-wrapper .progress.success .filename,.designer-wrapper .file-wrapper .progress.success .filename,.sub-designer .file-wrapper .progress.success .filename,.wizard .file-wrapper .progress.success .filename{color:#fff;max-width:calc(100% - 78px)}.attribute-container .file-wrapper .progress.failed,.condition-editor .file-wrapper .progress.failed,.designer-wrapper .file-wrapper .progress.failed,.sub-designer .file-wrapper .progress.failed,.wizard .file-wrapper .progress.failed{background:-webkit-linear-gradient(70deg,#9c1a25,#c92a37);background:-moz-linear-gradient(70deg,#9c1a25,#c92a37);background:-o-linear-gradient(70deg,#9c1a25,#c92a37);background:linear-gradient(20deg,#9c1a25,#c92a37);box-shadow:0 3px 6px rgba(0,0,0,.16),0 3px 6px rgba(0,0,0,.23)}.attribute-container .file-wrapper .progress.failed .bar,.condition-editor .file-wrapper .progress.failed .bar,.designer-wrapper .file-wrapper .progress.failed .bar,.sub-designer .file-wrapper .progress.failed .bar,.wizard .file-wrapper .progress.failed .bar{opacity:0}.attribute-container .file-wrapper .progress.failed .filename,.condition-editor .file-wrapper .progress.failed .filename,.designer-wrapper .file-wrapper .progress.failed .filename,.sub-designer .file-wrapper .progress.failed .filename,.wizard .file-wrapper .progress.failed .filename{color:#fff;max-width:calc(100% - 180px)}.attribute-container .file-wrapper .progress.failed .file-icon,.condition-editor .file-wrapper .progress.failed .file-icon,.designer-wrapper .file-wrapper .progress.failed .file-icon,.sub-designer .file-wrapper .progress.failed .file-icon,.wizard .file-wrapper .progress.failed .file-icon{background:#df2534}.attribute-container .file-wrapper .progress.failed .failed-text,.condition-editor .file-wrapper .progress.failed .failed-text,.designer-wrapper .file-wrapper .progress.failed .failed-text,.sub-designer .file-wrapper .progress.failed .failed-text,.wizard .file-wrapper .progress.failed .failed-text{color:#fff;font-style:italic;margin-left:10px}.attribute-container .file-wrapper .progress .file-icon,.condition-editor .file-wrapper .progress .file-icon,.designer-wrapper .file-wrapper .progress .file-icon,.sub-designer .file-wrapper .progress .file-icon,.wizard .file-wrapper .progress .file-icon{width:38px;height:38px;border-radius:100%;background:#bfa44b;display:flex;align-items:center;justify-content:center;color:#fff;font-size:1.2rem;z-index:3;margin-right:10px;flex:0 0 auto;position:relative;padding:4px}.attribute-container .file-wrapper .progress .filename,.condition-editor .file-wrapper .progress .filename,.designer-wrapper .file-wrapper .progress .filename,.sub-designer .file-wrapper .progress .filename,.wizard .file-wrapper .progress .filename{z-index:4;font-weight:600;color:#0f0f0f;transition:color .4s;flex:0 0 auto;white-space:nowrap;text-overflow:ellipsis;overflow:hidden;max-width:calc(100% - 58px)}.attribute-container .file-wrapper .progress .remove,.condition-editor .file-wrapper .progress .remove,.designer-wrapper .file-wrapper .progress .remove,.sub-designer .file-wrapper .progress .remove,.wizard .file-wrapper .progress .remove{margin-left:auto;border:none;background:#fff;box-shadow:0 1px 3px rgba(0,0,0,.12),0 1px 2px rgba(0,0,0,.24);color:#1c1c1c;border-radius:100%;height:20px;width:20px;text-align:center;padding:0;display:flex;align-items:center;justify-content:center;font-weight:800;font-size:.95rem;padding-bottom:1px;flex:0 0 auto;z-index:5;cursor:pointer;transition:box-shadow .2s,background .2s}.attribute-container .file-wrapper .progress .remove:hover,.condition-editor .file-wrapper .progress .remove:hover,.designer-wrapper .file-wrapper .progress .remove:hover,.sub-designer .file-wrapper .progress .remove:hover,.wizard .file-wrapper .progress .remove:hover{box-shadow:0 3px 6px rgba(0,0,0,.16),0 3px 6px rgba(0,0,0,.23);background:#eee}.attribute-container .file-wrapper .progress .bar,.condition-editor .file-wrapper .progress .bar,.designer-wrapper .file-wrapper .progress .bar,.sub-designer .file-wrapper .progress .bar,.wizard .file-wrapper .progress .bar{display:flex;justify-content:center;align-items:center;width:0;height:55px;transition:width .6s,background .4s,color .4s,opacity .4s;background:#cfc4a1;border-radius:3px;color:#fff;padding:10px;position:absolute;left:0;top:0}.attribute-container .disabled label,.condition-editor .disabled label,.designer-wrapper .disabled label,.sub-designer .disabled label,.wizard .disabled label{position:relative;display:inline-block;padding-left:25px;cursor:not-allowed}.attribute-container .disabled label:before,.condition-editor .disabled label:before,.designer-wrapper .disabled label:before,.sub-designer .disabled label:before,.wizard .disabled label:before{background:#ebebe4;border:3px solid #c3c3c3;content:\"\";display:inline-block;border-radius:15px;cursor:not-allowed}.attribute-container .disabled label:after,.condition-editor .disabled label:after,.designer-wrapper .disabled label:after,.sub-designer .disabled label:after,.wizard .disabled label:after{cursor:not-allowed!important}.attribute-container .step-check,.condition-editor .step-check,.designer-wrapper .step-check,.sub-designer .step-check,.wizard .step-check{width:16px;height:16px;position:absolute;border:2px solid hsla(0,0%,100%,.8);border-radius:4px;left:5px;top:6px}.attribute-container .step-check.step-valid:after,.condition-editor .step-check.step-valid:after,.designer-wrapper .step-check.step-valid:after,.sub-designer .step-check.step-valid:after,.wizard .step-check.step-valid:after{content:\"\";position:absolute;right:2px;top:4px;width:7px;transform:rotate(45deg);border-radius:5px;height:3px;background:#fff}.attribute-container .step-check.step-valid:before,.condition-editor .step-check.step-valid:before,.designer-wrapper .step-check.step-valid:before,.sub-designer .step-check.step-valid:before,.wizard .step-check.step-valid:before{content:\"\";position:absolute;right:-7px;top:2px;width:13px;transform:rotate(135deg);border-radius:5px;height:3px;background:#fff}.attribute-container .sub-section,.condition-editor .sub-section,.designer-wrapper .sub-section,.sub-designer .sub-section,.wizard .sub-section{background:#dadada;padding:15px;padding-top:10px;border-radius:6px;margin-bottom:20px}.attribute-container .sub-section.required:before,.condition-editor .sub-section.required:before,.designer-wrapper .sub-section.required:before,.sub-designer .sub-section.required:before,.wizard .sub-section.required:before{content:\"*\";position:absolute;right:15px;top:13px;color:red}.attribute-container .sub-section .field .field.field.field,.condition-editor .sub-section .field .field.field.field,.designer-wrapper .sub-section .field .field.field.field,.sub-designer .sub-section .field .field.field.field,.wizard .sub-section .field .field.field.field{margin:inherit}.attribute-container .sub-section .field.field.field,.condition-editor .sub-section .field.field.field,.designer-wrapper .sub-section .field.field.field,.sub-designer .sub-section .field.field.field,.wizard .sub-section .field.field.field{margin:10px 0}.attribute-container .sub-section .search-button,.condition-editor .sub-section .search-button,.designer-wrapper .sub-section .search-button,.sub-designer .sub-section .search-button,.wizard .sub-section .search-button{height:32px;margin-left:0;vertical-align:top;display:block;width:100%}@media only screen and (max-width:480px){.attribute-container .sub-section .search-button,.condition-editor .sub-section .search-button,.designer-wrapper .sub-section .search-button,.sub-designer .sub-section .search-button,.wizard .sub-section .search-button{margin-top:0}}.attribute-container .sub-section .toolbar,.condition-editor .sub-section .toolbar,.designer-wrapper .sub-section .toolbar,.sub-designer .sub-section .toolbar,.wizard .sub-section .toolbar{background:#c9c7c4;position:relative;width:calc(100% + 30px);padding-left:5px;margin-right:-15px;margin-left:-15px;margin-bottom:-15px;border-bottom-left-radius:6px}.attribute-container .template,.condition-editor .template,.designer-wrapper .template,.sub-designer .template,.wizard .template{background:#e4e4e3;border-radius:0;border-bottom-left-radius:6px;border-bottom-right-radius:6px;width:100%;height:auto;height:calc(100% - 50px);overflow-y:auto;padding:15px;margin-bottom:0}@media screen and (max-height:710px){.attribute-container .template,.condition-editor .template,.designer-wrapper .template,.sub-designer .template,.wizard .template{padding-bottom:46px}}.attribute-container .template .field .field:first-child,.condition-editor .template .field .field:first-child,.designer-wrapper .template .field .field:first-child,.sub-designer .template .field .field:first-child,.wizard .template .field .field:first-child{padding-left:0}.attribute-container .template .template-fields,.condition-editor .template .template-fields,.designer-wrapper .template .template-fields,.sub-designer .template .template-fields,.wizard .template .template-fields{width:100%;height:100%}.attribute-container .template .template-fields .description,.condition-editor .template .template-fields .description,.designer-wrapper .template .template-fields .description,.sub-designer .template .template-fields .description,.wizard .template .template-fields .description{font-style:italic}.attribute-container .template .controls,.condition-editor .template .controls,.designer-wrapper .template .controls,.sub-designer .template .controls,.wizard .template .controls{border-radius:0 0 6px 6px;position:absolute;bottom:0;left:0;width:100%;height:50px;background:#fff;display:flex;flex-direction:row;justify-content:flex-end;padding:10px;box-shadow:0 -3px 6px rgba(0,0,0,.1),0 -3px 6px rgba(0,0,0,.13)}.attribute-container .template .controls .btn,.condition-editor .template .controls .btn,.designer-wrapper .template .controls .btn,.sub-designer .template .controls .btn,.wizard .template .controls .btn{margin-left:10px;padding:0 20px;flex:0 0 auto;width:auto;height:auto}.attribute-container .server-search,.condition-editor .server-search,.designer-wrapper .server-search,.sub-designer .server-search,.wizard .server-search{padding-top:15px;padding-bottom:15px}.attribute-container .server-search .result-card,.condition-editor .server-search .result-card,.designer-wrapper .server-search .result-card,.sub-designer .server-search .result-card,.wizard .server-search .result-card{background:#dadada;padding:15px;border-radius:6px;display:inline-block;width:auto;margin:0 auto;position:relative}.attribute-container .server-search .result-card .name,.condition-editor .server-search .result-card .name,.designer-wrapper .server-search .result-card .name,.sub-designer .server-search .result-card .name,.wizard .server-search .result-card .name{font-weight:700;font-size:16px;display:block;width:100%;margin-bottom:10px}.attribute-container .server-search .result-card .remove-result,.condition-editor .server-search .result-card .remove-result,.designer-wrapper .server-search .result-card .remove-result,.sub-designer .server-search .result-card .remove-result,.wizard .server-search .result-card .remove-result{position:absolute;width:24px;height:24px;right:-9px;top:-9px;text-align:center;background:#c01027;border:none;border-radius:25px;color:#fff;padding:0;font-size:11px;padding-right:1px;padding-top:2px}.attribute-container .server-search .result-card .remove-result:hover,.condition-editor .server-search .result-card .remove-result:hover,.designer-wrapper .server-search .result-card .remove-result:hover,.sub-designer .server-search .result-card .remove-result:hover,.wizard .server-search .result-card .remove-result:hover{background:#e1132e}.attribute-container .server-search button.search-button,.condition-editor .server-search button.search-button,.designer-wrapper .server-search button.search-button,.sub-designer .server-search button.search-button,.wizard .server-search button.search-button{margin-top:31px;margin-left:2px;background:#303030;border-color:#0f0f0f;color:#fff;text-shadow:0 1px 0 rgba(0,0,0,.7);width:94%}.attribute-container .server-search button.search-button:hover,.condition-editor .server-search button.search-button:hover,.designer-wrapper .server-search button.search-button:hover,.sub-designer .server-search button.search-button:hover,.wizard .server-search button.search-button:hover{background:#3a3a3a}.attribute-container .server-search button.search-button:active,.condition-editor .server-search button.search-button:active,.designer-wrapper .server-search button.search-button:active,.sub-designer .server-search button.search-button:active,.wizard .server-search button.search-button:active{background:#282828;color:#fff;text-shadow:0 1px 0 rgba(0,0,0,.7)}.attribute-container .server-search button.search-button:focus,.attribute-container .server-search button.search-button:hover,.condition-editor .server-search button.search-button:focus,.condition-editor .server-search button.search-button:hover,.designer-wrapper .server-search button.search-button:focus,.designer-wrapper .server-search button.search-button:hover,.sub-designer .server-search button.search-button:focus,.sub-designer .server-search button.search-button:hover,.wizard .server-search button.search-button:focus,.wizard .server-search button.search-button:hover{color:#fff}.attribute-container .server-search .text-wrapper,.condition-editor .server-search .text-wrapper,.designer-wrapper .server-search .text-wrapper,.sub-designer .server-search .text-wrapper,.wizard .server-search .text-wrapper{width:100%;padding-right:10px}.attribute-container .server-search .text-wrapper:last-child,.condition-editor .server-search .text-wrapper:last-child,.designer-wrapper .server-search .text-wrapper:last-child,.sub-designer .server-search .text-wrapper:last-child,.wizard .server-search .text-wrapper:last-child{padding-right:0}.attribute-container .form-table,.condition-editor .form-table,.designer-wrapper .form-table,.sub-designer .form-table,.wizard .form-table{width:100%}.attribute-container .form-table .loading,.condition-editor .form-table .loading,.designer-wrapper .form-table .loading,.sub-designer .form-table .loading,.wizard .form-table .loading{display:flex;justify-content:center;align-items:center}.attribute-container .form-table .loading .orbit-loader,.condition-editor .form-table .loading .orbit-loader,.designer-wrapper .form-table .loading .orbit-loader,.sub-designer .form-table .loading .orbit-loader,.wizard .form-table .loading .orbit-loader{transform:scale(.6);margin-top:-5px;margin-left:8px}.attribute-container .form-table thead,.condition-editor .form-table thead,.designer-wrapper .form-table thead,.sub-designer .form-table thead,.wizard .form-table thead{background:#1c1c1c;color:#fff}.attribute-container .form-table thead th,.condition-editor .form-table thead th,.designer-wrapper .form-table thead th,.sub-designer .form-table thead th,.wizard .form-table thead th{padding:5px 10px;font-size:13px;font-family:Open Sans,sans-serif}.attribute-container .form-table thead th:first-child,.condition-editor .form-table thead th:first-child,.designer-wrapper .form-table thead th:first-child,.sub-designer .form-table thead th:first-child,.wizard .form-table thead th:first-child{border-radius:4px 0 0 0}.attribute-container .form-table thead th:last-child,.condition-editor .form-table thead th:last-child,.designer-wrapper .form-table thead th:last-child,.sub-designer .form-table thead th:last-child,.wizard .form-table thead th:last-child{border-radius:0 4px 0 0}.attribute-container .form-table thead th:only-child,.condition-editor .form-table thead th:only-child,.designer-wrapper .form-table thead th:only-child,.sub-designer .form-table thead th:only-child,.wizard .form-table thead th:only-child{border-radius:4px 4px 0 0}.attribute-container .form-table thead th.column-hidden,.condition-editor .form-table thead th.column-hidden,.designer-wrapper .form-table thead th.column-hidden,.sub-designer .form-table thead th.column-hidden,.wizard .form-table thead th.column-hidden{background:hsla(0,0%,100%,.6);color:hsla(0,0%,100%,.6)}.attribute-container .form-table tbody,.condition-editor .form-table tbody,.designer-wrapper .form-table tbody,.sub-designer .form-table tbody,.wizard .form-table tbody{box-shadow:0 2px 2px -1px rgba(0,0,0,.2);border-radius:0 0 5px 5px}.attribute-container .form-table tbody tr,.condition-editor .form-table tbody tr,.designer-wrapper .form-table tbody tr,.sub-designer .form-table tbody tr,.wizard .form-table tbody tr{background:#fff;outline:none}.attribute-container .form-table tbody tr:nth-child(2n) td,.condition-editor .form-table tbody tr:nth-child(2n) td,.designer-wrapper .form-table tbody tr:nth-child(2n) td,.sub-designer .form-table tbody tr:nth-child(2n) td,.wizard .form-table tbody tr:nth-child(2n) td{background:rgba(28,28,28,.1)}.attribute-container .form-table tbody tr:nth-child(2n) td:nth-child(2n),.condition-editor .form-table tbody tr:nth-child(2n) td:nth-child(2n),.designer-wrapper .form-table tbody tr:nth-child(2n) td:nth-child(2n),.sub-designer .form-table tbody tr:nth-child(2n) td:nth-child(2n),.wizard .form-table tbody tr:nth-child(2n) td:nth-child(2n){background:rgba(28,28,28,.2)}.attribute-container .form-table tbody tr:last-child,.condition-editor .form-table tbody tr:last-child,.designer-wrapper .form-table tbody tr:last-child,.sub-designer .form-table tbody tr:last-child,.wizard .form-table tbody tr:last-child{border-radius:0 0 5px 5px}.attribute-container .form-table tbody tr:last-child td:first-child,.condition-editor .form-table tbody tr:last-child td:first-child,.designer-wrapper .form-table tbody tr:last-child td:first-child,.sub-designer .form-table tbody tr:last-child td:first-child,.wizard .form-table tbody tr:last-child td:first-child{border-bottom-left-radius:5px}.attribute-container .form-table tbody tr:last-child td:last-child,.condition-editor .form-table tbody tr:last-child td:last-child,.designer-wrapper .form-table tbody tr:last-child td:last-child,.sub-designer .form-table tbody tr:last-child td:last-child,.wizard .form-table tbody tr:last-child td:last-child{border-bottom-right-radius:5px}.attribute-container .form-table tbody tr.not-editing,.condition-editor .form-table tbody tr.not-editing,.designer-wrapper .form-table tbody tr.not-editing,.sub-designer .form-table tbody tr.not-editing,.wizard .form-table tbody tr.not-editing{cursor:pointer;transition:outline-offset .2s;outline:3px solid rgba(191,164,75,0);outline-offset:7px}.attribute-container .form-table tbody tr.not-editing:focus,.condition-editor .form-table tbody tr.not-editing:focus,.designer-wrapper .form-table tbody tr.not-editing:focus,.sub-designer .form-table tbody tr.not-editing:focus,.wizard .form-table tbody tr.not-editing:focus{outline-color:rgba(191,164,75,.3);outline-offset:0;outline-offset:-4px}.attribute-container .form-table tbody tr:hover,.condition-editor .form-table tbody tr:hover,.designer-wrapper .form-table tbody tr:hover,.sub-designer .form-table tbody tr:hover,.wizard .form-table tbody tr:hover{background:hsla(0,0%,100%,.7)}.attribute-container .form-table tbody tr.disabled.disabled.disabled,.condition-editor .form-table tbody tr.disabled.disabled.disabled,.designer-wrapper .form-table tbody tr.disabled.disabled.disabled,.sub-designer .form-table tbody tr.disabled.disabled.disabled,.wizard .form-table tbody tr.disabled.disabled.disabled{cursor:default}.attribute-container .form-table tbody tr.disabled.disabled.disabled:hover,.condition-editor .form-table tbody tr.disabled.disabled.disabled:hover,.designer-wrapper .form-table tbody tr.disabled.disabled.disabled:hover,.sub-designer .form-table tbody tr.disabled.disabled.disabled:hover,.wizard .form-table tbody tr.disabled.disabled.disabled:hover{background:#fff}.attribute-container .form-table tbody td,.condition-editor .form-table tbody td,.designer-wrapper .form-table tbody td,.sub-designer .form-table tbody td,.wizard .form-table tbody td{padding:5px 9px;position:relative;white-space:pre-wrap}.attribute-container .form-table tbody td:nth-child(2n),.condition-editor .form-table tbody td:nth-child(2n),.designer-wrapper .form-table tbody td:nth-child(2n),.sub-designer .form-table tbody td:nth-child(2n),.wizard .form-table tbody td:nth-child(2n){background:rgba(28,28,28,.1)}.attribute-container .expand-wrapper,.condition-editor .expand-wrapper,.designer-wrapper .expand-wrapper,.sub-designer .expand-wrapper,.wizard .expand-wrapper{transition:max-height 2s}.attribute-container .row-controls-col.row-controls-col.row-controls-col,.condition-editor .row-controls-col.row-controls-col.row-controls-col,.designer-wrapper .row-controls-col.row-controls-col.row-controls-col,.sub-designer .row-controls-col.row-controls-col.row-controls-col,.wizard .row-controls-col.row-controls-col.row-controls-col{padding:0}.attribute-container .row-controls,.condition-editor .row-controls,.designer-wrapper .row-controls,.sub-designer .row-controls,.wizard .row-controls{display:flex;flex-direction:row;justify-content:center;flex-wrap:wrap}.attribute-container .row-controls .control,.condition-editor .row-controls .control,.designer-wrapper .row-controls .control,.sub-designer .row-controls .control,.wizard .row-controls .control{padding:3px;border-radius:2px;border:none;background:rgba(28,28,28,.15);color:#000;margin:3px 2px 0;transition:outline-offset .2s;outline:3px solid rgba(191,164,75,0);outline-offset:7px;font-size:.75rem;box-shadow:0 1px 3px rgba(0,0,0,.12),0 1px 2px rgba(0,0,0,.24)}.attribute-container .row-controls .control .svg-icon,.condition-editor .row-controls .control .svg-icon,.designer-wrapper .row-controls .control .svg-icon,.sub-designer .row-controls .control .svg-icon,.wizard .row-controls .control .svg-icon{width:19px}.attribute-container .row-controls .control.btn-danger,.condition-editor .row-controls .control.btn-danger,.designer-wrapper .row-controls .control.btn-danger,.sub-designer .row-controls .control.btn-danger,.wizard .row-controls .control.btn-danger{background:rgba(192,16,39,.18);color:#4a060f}.attribute-container .row-controls .control:last-child,.condition-editor .row-controls .control:last-child,.designer-wrapper .row-controls .control:last-child,.sub-designer .row-controls .control:last-child,.wizard .row-controls .control:last-child{margin-left:3px}.attribute-container .row-controls .control:first-child,.condition-editor .row-controls .control:first-child,.designer-wrapper .row-controls .control:first-child,.sub-designer .row-controls .control:first-child,.wizard .row-controls .control:first-child{margin-right:3px}.attribute-container .row-controls .control:focus,.condition-editor .row-controls .control:focus,.designer-wrapper .row-controls .control:focus,.sub-designer .row-controls .control:focus,.wizard .row-controls .control:focus{outline-color:rgba(191,164,75,.3);outline-offset:0}.attribute-container .results-header,.condition-editor .results-header,.designer-wrapper .results-header,.sub-designer .results-header,.wizard .results-header{display:block;border-bottom:1px solid #b0b0b0;margin-bottom:1px;background:#c9c9c9}.attribute-container .results-header div,.condition-editor .results-header div,.designer-wrapper .results-header div,.sub-designer .results-header div,.wizard .results-header div{display:inline-block;width:50%;padding:5px 10px;border-right:1px solid #bcbcbc}.attribute-container .results-header .name,.condition-editor .results-header .name,.designer-wrapper .results-header .name,.sub-designer .results-header .name,.wizard .results-header .name{width:30%}.attribute-container .results-header .address1,.condition-editor .results-header .address1,.designer-wrapper .results-header .address1,.sub-designer .results-header .address1,.wizard .results-header .address1{width:25%}.attribute-container .results-header .city,.condition-editor .results-header .city,.designer-wrapper .results-header .city,.sub-designer .results-header .city,.wizard .results-header .city{width:20%}.attribute-container .results-header .state,.condition-editor .results-header .state,.designer-wrapper .results-header .state,.sub-designer .results-header .state,.wizard .results-header .state{width:10%}.attribute-container .results-header .zipcode,.condition-editor .results-header .zipcode,.designer-wrapper .results-header .zipcode,.sub-designer .results-header .zipcode,.wizard .results-header .zipcode{width:15%}.attribute-container .result.cards-mode,.condition-editor .result.cards-mode,.designer-wrapper .result.cards-mode,.sub-designer .result.cards-mode,.wizard .result.cards-mode{display:block;padding:15px;background:#eee;border-bottom:1px solid #ddd;margin-bottom:1px;cursor:pointer}.attribute-container .result.cards-mode:hover,.condition-editor .result.cards-mode:hover,.designer-wrapper .result.cards-mode:hover,.sub-designer .result.cards-mode:hover,.wizard .result.cards-mode:hover{background:#ddd}.attribute-container .result.cards-mode .id,.attribute-container .result.cards-mode .name,.condition-editor .result.cards-mode .id,.condition-editor .result.cards-mode .name,.designer-wrapper .result.cards-mode .id,.designer-wrapper .result.cards-mode .name,.sub-designer .result.cards-mode .id,.sub-designer .result.cards-mode .name,.wizard .result.cards-mode .id,.wizard .result.cards-mode .name{display:block}.attribute-container .result.table-mode,.condition-editor .result.table-mode,.designer-wrapper .result.table-mode,.sub-designer .result.table-mode,.wizard .result.table-mode{display:block;padding:0;background:#eee;border-bottom:1px solid #ddd;margin-bottom:1px;cursor:pointer}.attribute-container .result.table-mode:hover,.condition-editor .result.table-mode:hover,.designer-wrapper .result.table-mode:hover,.sub-designer .result.table-mode:hover,.wizard .result.table-mode:hover{background:#e0e0e0}.attribute-container .result.table-mode:hover div,.condition-editor .result.table-mode:hover div,.designer-wrapper .result.table-mode:hover div,.sub-designer .result.table-mode:hover div,.wizard .result.table-mode:hover div{border-color:#ccc}.attribute-container .result.table-mode div,.condition-editor .result.table-mode div,.designer-wrapper .result.table-mode div,.sub-designer .result.table-mode div,.wizard .result.table-mode div{display:inline-block;padding:10px;border-right:1px solid #ddd}.attribute-container .result.table-mode .name,.condition-editor .result.table-mode .name,.designer-wrapper .result.table-mode .name,.sub-designer .result.table-mode .name,.wizard .result.table-mode .name{width:30%}.attribute-container .result.table-mode .address1,.condition-editor .result.table-mode .address1,.designer-wrapper .result.table-mode .address1,.sub-designer .result.table-mode .address1,.wizard .result.table-mode .address1{width:25%}.attribute-container .result.table-mode .city,.condition-editor .result.table-mode .city,.designer-wrapper .result.table-mode .city,.sub-designer .result.table-mode .city,.wizard .result.table-mode .city{width:20%}.attribute-container .result.table-mode .state,.condition-editor .result.table-mode .state,.designer-wrapper .result.table-mode .state,.sub-designer .result.table-mode .state,.wizard .result.table-mode .state{width:10%}.attribute-container .result.table-mode .zipcode,.condition-editor .result.table-mode .zipcode,.designer-wrapper .result.table-mode .zipcode,.sub-designer .result.table-mode .zipcode,.wizard .result.table-mode .zipcode{width:15%}.attribute-container .selected-result,.condition-editor .selected-result,.designer-wrapper .selected-result,.sub-designer .selected-result,.wizard .selected-result{display:inline-block;background:#ccc;border-radius:4px;padding:0;margin-right:10px;margin-bottom:8px;position:relative;cursor:pointer;font-style:italic;overflow:hidden}.attribute-container .selected-result .header,.condition-editor .selected-result .header,.designer-wrapper .selected-result .header,.sub-designer .selected-result .header,.wizard .selected-result .header{display:block;padding:6px;padding-left:26px;padding-right:10px;background:#b3b3b3;color:#353535;border-radius:4px 4px 0 0;position:relative}.attribute-container .selected-result .user-icon,.condition-editor .selected-result .user-icon,.designer-wrapper .selected-result .user-icon,.sub-designer .selected-result .user-icon,.wizard .selected-result .user-icon{font-size:16px;position:absolute;top:8px;left:6px}.attribute-container .selected-result .address,.condition-editor .selected-result .address,.designer-wrapper .selected-result .address,.sub-designer .selected-result .address,.wizard .selected-result .address{font-style:normal;font-size:13px;color:#777;padding:6px}.attribute-container .selected-result:before,.condition-editor .selected-result:before,.designer-wrapper .selected-result:before,.sub-designer .selected-result:before,.wizard .selected-result:before{transition:background .2s;content:\"\";background:rgba(219,29,29,0);position:absolute;left:0;top:0;width:100%;height:100%;z-index:9}.attribute-container .selected-result:hover:before,.condition-editor .selected-result:hover:before,.designer-wrapper .selected-result:hover:before,.sub-designer .selected-result:hover:before,.wizard .selected-result:hover:before{font-family:north-dakota!important;font-style:normal!important;font-weight:400!important;font-variant:normal!important;text-transform:none!important;font-size:40px;color:#fff;text-align:center;speak:none;line-height:1;-webkit-font-smoothing:antialiased;content:\"R\";background:rgba(219,29,29,.45);padding-top:28px}.attribute-container .selected-result .value,.condition-editor .selected-result .value,.designer-wrapper .selected-result .value,.sub-designer .selected-result .value,.wizard .selected-result .value{white-space:pre-wrap}.attribute-container .repeater .tooltip-trigger,.condition-editor .repeater .tooltip-trigger,.designer-wrapper .repeater .tooltip-trigger,.sub-designer .repeater .tooltip-trigger,.wizard .repeater .tooltip-trigger{transform:translate(-4px,-4px)}.attribute-container .repeater.disabled thead,.condition-editor .repeater.disabled thead,.designer-wrapper .repeater.disabled thead,.sub-designer .repeater.disabled thead,.wizard .repeater.disabled thead{opacity:.8}.attribute-container .repeater.disabled tbody tr,.condition-editor .repeater.disabled tbody tr,.designer-wrapper .repeater.disabled tbody tr,.sub-designer .repeater.disabled tbody tr,.wizard .repeater.disabled tbody tr{background:#ddd}.attribute-container .repeater .scrollable,.condition-editor .repeater .scrollable,.designer-wrapper .repeater .scrollable,.sub-designer .repeater .scrollable,.wizard .repeater .scrollable{overflow-x:auto}.attribute-container .repeater .row-controls,.condition-editor .repeater .row-controls,.designer-wrapper .repeater .row-controls,.sub-designer .repeater .row-controls,.wizard .repeater .row-controls{padding:3px}.attribute-container .repeater .row-controls button,.condition-editor .repeater .row-controls button,.designer-wrapper .repeater .row-controls button,.sub-designer .repeater .row-controls button,.wizard .repeater .row-controls button{cursor:pointer}.attribute-container .repeater .row-controls .clone:disabled,.condition-editor .repeater .row-controls .clone:disabled,.designer-wrapper .repeater .row-controls .clone:disabled,.sub-designer .repeater .row-controls .clone:disabled,.wizard .repeater .row-controls .clone:disabled{background:#999794;cursor:default}.attribute-container .repeater .edit-controls,.condition-editor .repeater .edit-controls,.designer-wrapper .repeater .edit-controls,.sub-designer .repeater .edit-controls,.wizard .repeater .edit-controls{margin-top:10px;margin-bottom:10px}.attribute-container .repeater .add-row,.condition-editor .repeater .add-row,.designer-wrapper .repeater .add-row,.sub-designer .repeater .add-row,.wizard .repeater .add-row{display:block;margin-top:15px;margin-bottom:7px}.attribute-container .repeater .add-row:disabled,.condition-editor .repeater .add-row:disabled,.designer-wrapper .repeater .add-row:disabled,.sub-designer .repeater .add-row:disabled,.wizard .repeater .add-row:disabled{cursor:default;background:#999794}.attribute-container .repeater .no-entries,.condition-editor .repeater .no-entries,.designer-wrapper .repeater .no-entries,.sub-designer .repeater .no-entries,.wizard .repeater .no-entries{text-align:center}.attribute-container .repeater .repeats-row td,.condition-editor .repeater .repeats-row td,.designer-wrapper .repeater .repeats-row td,.sub-designer .repeater .repeats-row td,.wizard .repeater .repeats-row td{padding:10px}.attribute-container .repeater .repeats-row.disabled.disabled.disabled:hover,.condition-editor .repeater .repeats-row.disabled.disabled.disabled:hover,.designer-wrapper .repeater .repeats-row.disabled.disabled.disabled:hover,.sub-designer .repeater .repeats-row.disabled.disabled.disabled:hover,.wizard .repeater .repeats-row.disabled.disabled.disabled:hover{background:#ddd}.attribute-container .repeater .error-badge,.condition-editor .repeater .error-badge,.designer-wrapper .repeater .error-badge,.sub-designer .repeater .error-badge,.wizard .repeater .error-badge{content:\"\";background:#c01027;box-shadow:0 2px 3px rgba(0,0,0,.3);width:15px;height:15px;color:#fff;border-radius:100%;display:inline-block;margin-right:5px;text-align:center;font-style:normal;font-weight:800;padding-top:1px;vertical-align:top;z-index:9}.attribute-container .react-tooltip,.condition-editor .react-tooltip,.designer-wrapper .react-tooltip,.sub-designer .react-tooltip,.wizard .react-tooltip{position:absolute;background:#fff;color:#444;padding:5px;border:1px solid #d2d2d2;border-radius:5px;font-size:11px;font-weight:400;z-index:999;left:24px;top:-15px;display:inline-table;max-width:300px;box-shadow:0 3px 3px rgba(0,0,0,.3)}.attribute-container .react-tooltip:before,.condition-editor .react-tooltip:before,.designer-wrapper .react-tooltip:before,.sub-designer .react-tooltip:before,.wizard .react-tooltip:before{content:\"\";position:absolute;left:-8px;top:15px;width:0;height:0;border-top:8px solid transparent;border-bottom:8px solid transparent;border-right:8px solid #d2d2d2}.attribute-container .react-tooltip a,.condition-editor .react-tooltip a,.designer-wrapper .react-tooltip a,.sub-designer .react-tooltip a,.wizard .react-tooltip a{color:#ddd;text-decoration:underline}@media only screen and (max-width:992px){.attribute-container input[type=number],.attribute-container input[type=password],.attribute-container input[type=search],.attribute-container input[type=text],.attribute-container select,.attribute-container select:focus,.attribute-container textarea,.condition-editor input[type=number],.condition-editor input[type=password],.condition-editor input[type=search],.condition-editor input[type=text],.condition-editor select,.condition-editor select:focus,.condition-editor textarea,.designer-wrapper input[type=number],.designer-wrapper input[type=password],.designer-wrapper input[type=search],.designer-wrapper input[type=text],.designer-wrapper select,.designer-wrapper select:focus,.designer-wrapper textarea,.sub-designer input[type=number],.sub-designer input[type=password],.sub-designer input[type=search],.sub-designer input[type=text],.sub-designer select,.sub-designer select:focus,.sub-designer textarea,.wizard input[type=number],.wizard input[type=password],.wizard input[type=search],.wizard input[type=text],.wizard select,.wizard select:focus,.wizard textarea{font-size:16px}}.tooltip-trigger{position:relative;cursor:default;transition:outline-offset .2s;outline:3px solid rgba(191,164,75,0);outline-offset:7px}.tooltip-trigger:focus,.tooltip-trigger:hover{outline-color:rgba(191,164,75,.3);outline-offset:0}.tooltip-trigger:focus .tooltip-wrapper,.tooltip-trigger:hover .tooltip-wrapper{opacity:1;visibility:visible}.tooltip-trigger.disabled:focus,.tooltip-trigger.disabled:hover,.tooltip-trigger:hover{outline:none}.tooltip-trigger.disabled:focus .tooltip-wrapper,.tooltip-trigger.disabled:hover .tooltip-wrapper{opacity:0}.tooltip-trigger.dynamic .tooltip-positioner{width:auto;left:0}.tooltip-trigger.dynamic .tooltip-positioner.down{top:105%}.tooltip-trigger.dynamic .tooltip-wrapper{position:absolute;top:0;left:50%}.tooltip-trigger.dynamic .tooltip-wrapper:before{transform:rotate(180deg);bottom:auto;top:-15px}.tooltip-wrapper{background:rgba(3,3,3,.95);color:#fff;padding:5px;border:1px solid #414141;border-radius:5px;font-size:11px;font-weight:600;max-width:250px;box-shadow:0 3px 3px rgba(0,0,0,.3);display:flex;opacity:0;text-align:center;transition:opacity .15s;transition-delay:0ms;pointer-events:none;position:fixed;z-index:9999;left:0;top:0}.tooltip-wrapper:before{content:\"\";z-index:-1;position:absolute;left:calc(50% - 8px);bottom:-15px;width:0;height:0;border-left:8px solid transparent;border-right:8px solid transparent;border-bottom:8px solid transparent;border-top:8px solid #030303;transform:rotate(180deg);top:-15px!important}.tooltip-wrapper a{color:#ddd;text-decoration:underline}.tooltip-positioner{position:fixed;z-index:999;left:-143px;top:25px;display:flex;justify-content:center;align-items:flex-end;width:300px;height:1px;pointer-events:none}.tooltip-positioner.down{bottom:auto;top:25px}.repeats-row.deleting{text-decoration:line-through;cursor:default}.repeats-row.deleting:hover{background:#fff}.repeats-row.deleting .button,.repeats-row.hide-strikethrough,.repeats-row.no-delete.no-delete{text-decoration:none}.repeats-row.edited td:first-child:before{content:\"\\2022\";color:#79672b;background:rgba(191,164,75,.2)}.repeats-row.adding td:first-child:before,.repeats-row.edited td:first-child:before{padding:2px;width:15px;height:15px;text-align:center;line-height:0;vertical-align:top;padding-top:7px;margin-right:3px;box-sizing:border-box;display:inline-block;font-weight:800}.repeats-row.adding td:first-child:before{content:\"+\";color:#27722a;background:rgba(65,190,70,.2)}.repeats-row.deleting td:first-child:before{content:\"-\";padding:2px;width:15px;height:15px;text-align:center;line-height:0;vertical-align:top;color:#620814;padding-top:7px;margin-right:3px;box-sizing:border-box;display:inline-block;background:rgba(192,16,39,.2);font-weight:800}.repeats-row .cell-history.cell-history.cell-history.cell-history.cell-history.cell-history{display:flex;flex-direction:column;justify-content:flex-start;padding:0}.repeats-row .cell-history.cell-history.cell-history.cell-history.cell-history.cell-history .label{font-style:italic;font-size:.75rem;margin-top:8px}.repeats-row .cell-history.cell-history.cell-history.cell-history.cell-history.cell-history .label:first-child{margin-top:0}.repeats-row .cell-history.cell-history.cell-history.cell-history.cell-history.cell-history .after,.repeats-row .cell-history.cell-history.cell-history.cell-history.cell-history.cell-history .before{padding-left:10px}.repeats-row td:first-child .cell-history.cell-history.cell-history.cell-history.cell-history.cell-history.cell-history{margin-top:-15px;padding-left:25px}.help-wrapper{position:absolute;top:15px;right:25px;z-index:10}.help-wrapper .help-button{background:#1c1c1c;color:#fff;font-size:15px;border:none;border-radius:100%;width:20px;height:20px;padding-top:0;cursor:pointer;box-shadow:0 3px 5px rgba(0,0,0,.3);transition:outline-offset .2s;outline:3px solid rgba(191,164,75,0);outline-offset:7px}.help-wrapper .help-button.alt-style{font-size:12px;font-weight:600;border-radius:3px;width:auto;height:auto;padding:4px 8px;padding-top:3px}.help-wrapper .help-button:hover{background:#424242}.help-wrapper .help-button:focus{outline-color:rgba(191,164,75,.3);outline-offset:0}@media only screen and (max-width:768px){.help-wrapper{top:8px;right:8px}.help-wrapper .help-button{width:23px;height:23px;font-size:14px;padding:0;font-weight:800;text-align:center}}.markdown{font-size:14px;width:100%;font-family:Open Sans,sans-serif}.markdown h3{font-size:16px;font-weight:600;margin-bottom:10px}.markdown p,.markdown pre{display:block;line-height:1.3;margin-bottom:15px;overflow-wrap:break-word}.markdown p:last-child,.markdown pre:last-child{margin-bottom:0}.markdown pre{white-space:pre-wrap}.markdown ol,.markdown ul{padding-left:30px;margin-bottom:20px}.markdown ol:last-child,.markdown ul:last-child{margin-bottom:0}.markdown ol li,.markdown ul li{margin-bottom:10px;line-height:1rem}.markdown ol{counter-reset:ordered-counter}.markdown ol li{list-style:none;position:relative}.markdown ol li:before{content:counter(ordered-counter);counter-increment:ordered-counter;font-weight:800;font-size:.7rem;width:14px;height:14px;line-height:0;display:flex;justify-content:center;align-items:center;border-radius:2px;background:#c9c7c4;color:#3d3c3b;position:absolute;top:1px;left:-20px}.markdown ul{padding-left:10px;list-style:none;margin-top:5px;display:block}.markdown ul li{position:relative}.markdown ul li:before{width:6px;height:6px;border-radius:100%;background:#999794;display:inline-block;vertical-align:top;position:absolute;left:-13px;top:6px;content:\" \"}.markdown h1{font-size:1.5rem;font-weight:800}.markdown h1,.markdown h2{color:#1c1c1c;margin-bottom:10px;display:block}.markdown h2{font-size:1.1rem}.markdown h1,.markdown h2,.markdown h3,.markdown h4,.markdown h5,.markdown h6{font-weight:600}.markdown em,.markdown i{font-style:italic}.markdown blockquote{display:block;padding:5px 10px;padding-left:15px;border-left:4px solid #303030;margin-bottom:15px}.markdown blockquote p:last-child{margin-bottom:0}.markdown hr{border:none;border-bottom:1px solid #c3c3c1;margin-bottom:20px}.markdown table{border-collapse:collapse}.markdown table tr{border:none}.markdown table td,.markdown table th{border:1px solid #999794;padding:5px 20px;background:#fff;font-size:.9rem;text-align:center}.markdown table thead{border:none}.markdown table th{background:#1c1c1c;color:#fff;font-weight:600;border:none;border-right:1px solid;border-color:#303030}.markdown table th:first-child{border-top-left-radius:5px}.markdown table th:last-child{border-right:none;border-top-right-radius:5px}.address-block .row-wrapper{display:flex;flex-direction:row}.address-block .row-wrapper .text-wrapper{flex-grow:1}.address-block .row div[class*=col]{padding-right:10px}.address-block .row div[class*=col]:last-child{padding-right:0}@media only screen and (max-width:768px){.address-block .row div[class*=col]{padding-right:0}}.address-block .auto-width{flex-grow:1}.address-block .flex-col{display:flex;flex-direction:row}.address-block .copy-button{height:32px;padding:6px;margin-bottom:2px;margin-left:15px;align-self:flex-end;max-width:32px}.relative-modal{position:relative;padding-bottom:50px}.stacked-data-result{padding:10px}.stacked-data-result .value{white-space:pre-wrap}.results-wrapper{border-bottom-left-radius:5px;border-bottom-right-radius:5px;overflow:hidden;height:calc(100% - 50px)}.results-wrapper .stacked-data-result{padding:10px}.results-wrapper .stacked-data-result .value{white-space:pre-wrap}.results-wrapper .filter-wrapper{box-shadow:0 1px 3px rgba(0,0,0,.12),0 1px 2px rgba(0,0,0,.24);height:45px;padding:5px;display:flex;justify-content:flex-start;align-items:center;background:#e4e4e3}.results-wrapper .filter-wrapper .align-right{margin-left:auto;padding-right:10px}.results-wrapper .filter-wrapper .info{font-style:italic;color:#666665}.results-wrapper .filter{flex:1 1 100%;width:100%;max-width:300px;height:35px;background:#fff;color:#3d3c3b;border:3px solid #c9c7c4;padding-left:10px;border-radius:5px;font-size:1rem;outline:none}.results-wrapper .filter:focus{border-color:#25bdf5}.results-wrapper .search-button{height:31px;display:flex;flex-direction:row;align-items:center;margin-left:5px;margin-right:5px;padding-top:4px}.results-wrapper .search-button .svg-icon{width:16px;margin-right:3px}.results-wrapper .select-button{white-space:nowrap}.results-wrapper .results-toolbar{position:absolute;top:0;left:0;width:100%;padding:10px;height:26px;display:flex;align-items:center;justify-content:flex-end;border-bottom:1px solid #e4e4e3;font-style:italic}.results-wrapper .results-modal-body-wrapper{height:100%;position:relative}.results-wrapper .results-list-wrapper{position:relative}.organization-search.organization-search .search-button{display:flex;align-items:center;flex:0 0 auto;width:auto;padding-top:6px;margin-bottom:1px}.filter-fields{flex:1 1 100%;width:100%;max-width:300px;height:35px;background:#fff;color:#3d3c3b;border:3px solid #c9c7c4;padding-left:10px;border-radius:5px;font-size:1rem;transition:outline-offset .2s;outline:3px solid rgba(191,164,75,0);outline-offset:7px}.filter-fields:focus{outline-color:rgba(191,164,75,.3);outline-offset:0}.registered-agent-modal .field.field.field.field{margin-bottom:0}@media only screen and (max-width:768px){.organization-search.organization-search.organization-search,.registered-agent-search{width:100%!important}}.organization-search.organization-search.organization-search h3,.registered-agent-search h3{font-weight:800;font-size:.9rem;background:#bdbab7;font-style:italic;color:#4c4c4c;padding:10px 20px;border-radius:7px 7px 0 0;margin:-10px -15px;margin-bottom:0;display:flex;align-items:center}.organization-search.organization-search.organization-search h3.mid-title,.registered-agent-search h3.mid-title{border-radius:0;margin-top:0}.organization-search.organization-search.organization-search h3 .svg-icon,.registered-agent-search h3 .svg-icon{width:20px;margin-right:7px;margin-bottom:-5px;margin-top:-5px}.organization-search.organization-search.organization-search p.description.description.description.description,.registered-agent-search p.description.description.description.description{margin-top:15px;padding-left:7px}.organization-search.organization-search.organization-search button.add,.registered-agent-search button.add{align-items:center;display:flex;background:#bdbab7}.organization-search.organization-search.organization-search button.add:hover,.registered-agent-search button.add:hover{background:#c9c7c4}.organization-search.organization-search.organization-search button.add .svg-icon,.registered-agent-search button.add .svg-icon{width:14px;margin-right:5px}.organization-search.organization-search.organization-search .reg-type.reg-type.reg-type.reg-type.reg-type,.registered-agent-search .reg-type.reg-type.reg-type.reg-type.reg-type{margin-bottom:0}.organization-search.organization-search.organization-search .new-col,.registered-agent-search .new-col{display:flex;flex-direction:row;align-items:center;padding-left:10px}.organization-search.organization-search.organization-search .new-col span,.registered-agent-search .new-col span{margin-right:10px}.organization-search.organization-search.organization-search .search-col,.organization-search.organization-search.organization-search .search-column,.registered-agent-search .search-col,.registered-agent-search .search-column{display:flex;flex-direction:row;flex-wrap:nowrap;align-items:center}.organization-search.organization-search.organization-search .search-col .field,.organization-search.organization-search.organization-search .search-column .field,.registered-agent-search .search-col .field,.registered-agent-search .search-column .field{width:100%}.organization-search.organization-search.organization-search .search-col .reg-search-input,.organization-search.organization-search.organization-search .search-column .reg-search-input,.registered-agent-search .search-col .reg-search-input,.registered-agent-search .search-column .reg-search-input{flex:1 0 auto;width:auto}.organization-search.organization-search.organization-search .search-col .reg-search-input.live,.organization-search.organization-search.organization-search .search-column .reg-search-input.live,.registered-agent-search .search-col .reg-search-input.live,.registered-agent-search .search-column .reg-search-input.live{flex:1 1 auto}.organization-search.organization-search.organization-search .mailing-address,.organization-search.organization-search.organization-search .physical-address,.registered-agent-search .mailing-address,.registered-agent-search .physical-address{display:flex;flex-direction:column;margin:12px 0}.organization-search.organization-search.organization-search .mailing-address label,.organization-search.organization-search.organization-search .physical-address label,.registered-agent-search .mailing-address label,.registered-agent-search .physical-address label{margin-bottom:5px}.organization-search.organization-search.organization-search .mailing-address span,.organization-search.organization-search.organization-search .physical-address span,.registered-agent-search .mailing-address span,.registered-agent-search .physical-address span{font-style:normal;font-weight:600}.organization-search.organization-search.organization-search .static-selected-result,.registered-agent-search .static-selected-result{background:#c9c7c4;border-radius:3px;box-shadow:0 2px 3px rgba(0,0,0,.3)}.organization-search.organization-search.organization-search .static-selected-result:hover,.registered-agent-search .static-selected-result:hover{background:#c9c7c4}.organization-search.organization-search.organization-search .static-selected-result .close,.registered-agent-search .static-selected-result .close{width:24px;height:24px;background:#1c1c1c;color:#fff;border-radius:100%;border:none;font-size:1rem;padding:0;box-shadow:0 2px 4px rgba(0,0,0,.3);position:absolute;top:-7px;right:-7px;cursor:pointer;transition:outline-offset .2s;outline:3px solid rgba(191,164,75,0);outline-offset:7px}.organization-search.organization-search.organization-search .static-selected-result .close:hover,.registered-agent-search .static-selected-result .close:hover{background:#303030}.organization-search.organization-search.organization-search .static-selected-result .close:active,.registered-agent-search .static-selected-result .close:active{background:#000}.organization-search.organization-search.organization-search .static-selected-result .close:focus,.registered-agent-search .static-selected-result .close:focus{outline-color:rgba(191,164,75,.3);outline-offset:0}.organization-search.organization-search.organization-search .org-search-button,.registered-agent-search .org-search-button{max-width:33px;margin-left:10px}.organization-search.organization-search.organization-search .search-input-wrapper,.registered-agent-search .search-input-wrapper{display:flex;flex-direction:row;flex-wrap:nowrap;padding:0;align-items:center;height:auto}.organization-search.organization-search.organization-search .text-input,.registered-agent-search .text-input{flex:1 1 auto}.organization-search.organization-search.organization-search .search-button,.registered-agent-search .search-button{display:flex;margin-left:8px}.organization-search.organization-search.organization-search .search-button .svg-icon,.registered-agent-search .search-button .svg-icon{flex:0 0 auto;width:17px}.organization-search.organization-search.organization-search .ra-type,.organization-search.organization-search.organization-search .result-label,.registered-agent-search .ra-type,.registered-agent-search .result-label{display:block;font-size:.9rem;font-style:italic;margin-bottom:5px}.button-loading-wrapper{display:flex;flex-direction:row;justify-content:center;align-items:center}.button-loading-wrapper .orbit-loader{margin-right:15px;margin-top:-4px;transform:scale(.8)}.org-search-button{height:32px;margin-left:0;margin-top:1px;vertical-align:top;display:block;width:100%}@media only screen and (max-width:480px){.org-search-button{margin-top:0}}.dumb-org-search-button{height:32px;margin-left:0;margin-top:28px;display:block;width:120%}@media only screen and (max-width:480px){.dumb-org-search-button{margin-top:0}}.signatures.panel{min-height:auto}.signatures .label{display:flex;align-items:center}.signatures .attestation{margin-bottom:15px;font-size:14px}.signatures .attestation p{font-size:14px}.signatures .attestation:last-child{margin-bottom:0}.signatures .signature-row{margin-bottom:10px}.signatures .signature-row:last-child{margin-bottom:0}.summary-signatures.summary-signatures.summary-signatures.summary-signatures{padding-bottom:10px}.summary-signatures.summary-signatures.summary-signatures.summary-signatures .signature-row.signature-row{padding-bottom:0}.summary-signatures.summary-signatures.summary-signatures.summary-signatures .signature-row.signature-row div{padding:0}.summary-signatures.summary-signatures.summary-signatures.summary-signatures .signature-row.signature-row .name{text-align:left;display:inline-block;width:100%;padding:3px 10px 5px;font-weight:600}.summary-signatures.summary-signatures.summary-signatures.summary-signatures .signature-row.signature-row .signature{border-bottom:1px solid #666665;padding-bottom:3px;padding-left:10px;min-width:130px;height:18px;display:inline-block;text-align:left;margin-top:-5px;font-style:italic;position:relative;width:95%}.address-block,.name-margin-override{margin-bottom:-8px}.no-margin-bottom.no-margin-bottom.no-margin-bottom.no-margin-bottom.no-margin-bottom.no-margin-bottom{margin-bottom:0}.address-button{display:flex;flex-direction:column;padding:15px;border:none;width:100%;text-align:left;background:none;cursor:pointer;transition:outline-offset .2s;outline:3px solid rgba(191,164,75,0);outline-offset:7px}.address-button:nth-child(2n){background:#eeeeec}.address-button:hover{background:rgba(191,164,75,.2)}.address-button:active{background:#e4e4e3}.address-button:focus{outline-color:rgba(191,164,75,.3);outline-offset:0;outline-offset:-6px}.address-button .label{font-size:1rem;font-weight:600;font-style:italic;margin-bottom:8px;width:100%}.react-datepicker-popper{z-index:999}.changed .react-datepicker-popper{transform:scale(.98)}.indented{padding-left:15px}@keyframes pop-in-up{0%{opacity:0;transform:scale(.8) translateY(20px)}40%{opacity:1}to{transform:scale(1) translateY(0);opacity:1}}.date-picker-component{display:flex;flex-direction:row}.date-picker-component .date-picker-input{margin:0}.date-picker-component .picker-button{flex:0 0 auto;padding:5px;margin-left:5px;margin-right:10px;height:95%;margin-top:1px}.date-picker-component .picker-button .svg-icon{width:23px;height:23px}.date-picker-component .text-button{margin-right:0;padding:7px 7px 8px}.react-datepicker-portal{position:fixed;width:100%;height:100%;left:0;top:0;z-index:9999;display:flex;flex-direction:row;justify-content:center;align-items:center}.react-datepicker-portal .react-datepicker__input-container:after{display:none!important}.react-datepicker-portal .react-datepicker__input-container input{opacity:0;background:none;border:none;color:transparent}.react-datepicker-portal .react-datepicker__input-container input *{opacity:0}.react-datepicker-portal .react-datepicker{z-index:9}.react-datepicker-portal .react-datepicker button,.react-datepicker-portal .react-datepicker select{transition:outline-offset .2s;outline:3px solid rgba(191,164,75,0);outline-offset:7px}.react-datepicker-portal .react-datepicker button:focus,.react-datepicker-portal .react-datepicker select:focus{outline-color:rgba(191,164,75,.3);outline-offset:0}.react-datepicker-portal .shade{background:rgba(0,0,0,.5);width:100%;height:100%;position:absolute;left:0;top:0}.react-datepicker-portal .react-datepicker__day-names{display:flex;flex-direction:row;justify-content:space-around;padding:0 5px;font-weight:600;background:#1c1c1c}.react-datepicker-portal .react-datepicker__current-month{display:none}.react-datepicker-portal .react-datepicker{font-size:.85em;font-family:Open Sans,sans-serif;box-shadow:0 3px 6px rgba(0,0,0,.16),0 3px 6px rgba(0,0,0,.23);border:none}.react-datepicker-portal .react-datepicker .react-datepicker__week{flex:0 0 auto}.react-datepicker-portal .react-datepicker .react-datepicker__day.react-datepicker__day{margin:0;padding:5px;width:2.6rem;height:2.6rem;display:flex;justify-content:center;align-items:center;text-align:center;user-select:none}.react-datepicker-portal .react-datepicker .react-datepicker__day--today:not(.react-datepicker__day--selected){font-weight:800;background:#e4e4e3;border-radius:100px}.react-datepicker-portal .react-datepicker .react-datepicker__day--selected{background:#bfa44b!important;border-radius:100px}.react-datepicker-portal .react-datepicker .react-datepicker__header{border:none;background:#303030;padding-top:10px;text-align:right}.react-datepicker-portal .react-datepicker .react-datepicker__header__dropdown{margin-bottom:10px;margin-right:10px}.react-datepicker-portal .react-datepicker .react-datepicker__month-dropdown-container--select,.react-datepicker-portal .react-datepicker .react-datepicker__year-dropdown-container--select{background-color:#303030;margin:0 0 0 4px}.react-datepicker-portal .react-datepicker .react-datepicker__month-select,.react-datepicker-portal .react-datepicker .react-datepicker__year-select{background-color:hsla(0,0%,100%,.15);border:none;border-radius:3px;color:#fff;font-size:1em;font-weight:700;height:2em}.react-datepicker-portal .react-datepicker .react-datepicker__month-select option,.react-datepicker-portal .react-datepicker .react-datepicker__year-select option{background-color:#fff;color:#000}.react-datepicker-portal .react-datepicker .react-datepicker__day-name{color:#fff}.react-datepicker-portal .react-datepicker .react-datepicker__year-read-view{padding:5px;margin:2px 0 0;font-weight:800;font-size:1.1em}.react-datepicker-portal .react-datepicker .react-datepicker__year-read-view:hover{background:#444;border-radius:3px}.react-datepicker-portal .react-datepicker .react-datepicker__year-read-view--selected-year{color:#fff}.react-datepicker-portal .react-datepicker .react-datepicker__current-month{color:#fff;font-size:1.3em;margin-bottom:5px}.react-datepicker-portal .react-datepicker .react-datepicker__navigation:not(.react-datepicker__navigation--years){width:2em;height:2em;background:hsla(0,0%,100%,.15);border-radius:3px;border:none;color:transparent;overflow:hidden}.react-datepicker-portal .react-datepicker .react-datepicker__navigation:not(.react-datepicker__navigation--years):hover{background:#565656}.react-datepicker-portal .react-datepicker .react-datepicker__day--outside-month.react-datepicker__day--outside-month,.react-datepicker-portal .react-datepicker .react-datepicker__day--outside-month.react-datepicker__day--outside-month:hover{background:#eeeeec}.react-datepicker-portal .react-datepicker .react-datepicker__navigation--previous{border-right-color:hsla(0,0%,100%,.6);padding-right:.6em}.react-datepicker-portal .react-datepicker .react-datepicker__navigation--previous:hover{border-right-color:#fff}.react-datepicker-portal .react-datepicker .react-datepicker__navigation--previous:before{content:\"\";width:.45em;height:.45em;background:none;border:.45em solid transparent;border-right-color:hsla(0,0%,100%,.8);position:absolute;top:0.55em;right:0.775em}.react-datepicker-portal .react-datepicker .react-datepicker__navigation--next{border-left-color:hsla(0,0%,100%,.6);padding-left:.6em;left:calc(10px + 5px + 2em)}.react-datepicker-portal .react-datepicker .react-datepicker__navigation--next:hover{border-left-color:#fff}.react-datepicker-portal .react-datepicker .react-datepicker__navigation--next:before{content:\"\";width:.45em;height:.45em;background:none;border:.45em solid transparent;border-left-color:hsla(0,0%,100%,.8);position:absolute;top:0.55em;left:0.775em}.react-datepicker-portal .react-datepicker .react-datepicker__year-dropdown{border:none;box-shadow:0 10px 20px rgba(0,0,0,.19),0 6px 6px rgba(0,0,0,.23);z-index:10}.react-datepicker-portal .react-datepicker .react-datepicker__year-option:first-child,.react-datepicker-portal .react-datepicker .react-datepicker__year-option:last-child{padding:5px 0}.react-datepicker-portal .react-datepicker .react-datepicker__day{padding:.3em;width:2.2em;position:relative}.react-datepicker-portal .react-datepicker .react-datepicker__day:after{background:rgba(191,164,75,.2);content:\"\";position:absolute;width:100%;height:100%;left:0;top:0;border-radius:100%;transform:scale(0);transition:transform .1s}.react-datepicker-portal .react-datepicker .react-datepicker__day:hover{background:none}.react-datepicker-portal .react-datepicker .react-datepicker__day:hover:after{transform:scale(1)}.react-datepicker-portal .react-datepicker .react-datepicker__week{display:flex;flex-direction:row}.react-datepicker-portal .react-datepicker .react-datepicker__year-read-view--down-arrow{display:none}.react-datepicker-portal .react-datepicker .react-datepicker__year-dropdown{width:40%;left:30%;top:-100%;background:#fff}.react-datepicker-portal .react-datepicker .\\--selected_year{position:relative;background:rgba(191,164,75,.6);font-weight:800}.react-datepicker-portal .react-datepicker .\\--selected_year .react-datepicker__year-option--selected{display:none}.react-datepicker-portal .react-datepicker__input-container{position:relative}.react-datepicker-portal .react-datepicker__input-container:after{content:\"\\E907\";position:absolute;left:9px;top:9px;display:inline-block;color:#1c1c1c;font-family:icomoon!important;font-style:normal!important;font-weight:400!important;font-variant:normal!important;font-size:1.1rem;text-transform:none!important;speak:none;line-height:1;-webkit-font-smoothing:antialiased;pointer-events:none}.react-datepicker-portal .react-datepicker__input-container input{padding-left:30px}.__crash-error{display:flex;align-items:center;font-style:italic;font-weight:600;color:#c01027}.__crash-error svg{width:16px;margin-right:5px}.submit-shield{position:absolute;left:0;top:0;width:100%;height:100%;z-index:9}.visually-hidden{position:absolute;left:-10000px;top:auto;width:1px;height:1px;overflow:hidden;color:transparent;opacity:.01}.validation-loader{margin-right:11px;margin-left:2px;margin-top:-2px;transform:scale(.7)}.no-field-padding .field.field.field.field,.no-field-padding .row{margin:0}.ucc-box .button-row{padding-left:3px;margin-top:15px;margin-bottom:10px}.ucc-box .cache-table{margin-top:30px}.ucc-box .checkbox-padding{padding-left:10px}.ucc-box .top-box{margin-top:10px}label.sub-label{font-weight:600;margin-bottom:15px;display:block;margin-top:15px}.ucc-result{overflow-x:auto}.ucc-result button{margin-bottom:10px}.ucc-result button .svg-icon{width:18px}.time-input .field{padding-top:0}.time-input .period-select{margin-left:0}.time-input .colon{padding:5px;padding-top:0;padding-bottom:10px;display:flex;align-items:center}.ucc-search-display.ucc-search-display.ucc-search-display.ucc-search-display.ucc-search-display.ucc-search-display.ucc-search-display{display:flex;flex-direction:column;padding:0;margin-bottom:15px}.ucc-search-display.ucc-search-display.ucc-search-display.ucc-search-display.ucc-search-display.ucc-search-display.ucc-search-display .ucc-summary-row.ucc-summary-row.ucc-summary-row{padding:4px;border-bottom:1px dotted #999794}.ucc-search-display.ucc-search-display.ucc-search-display.ucc-search-display.ucc-search-display.ucc-search-display.ucc-search-display .ucc-summary-row.ucc-summary-row.ucc-summary-row:last-child{border-bottom:none}.ucc-search-display.ucc-search-display.ucc-search-display.ucc-search-display.ucc-search-display.ucc-search-display.ucc-search-display .ucc-label{width:50%;font-weight:600}.ucc-search-display.ucc-search-display.ucc-search-display.ucc-search-display.ucc-search-display.ucc-search-display.ucc-search-display .ucc-value{width:50%}.multi-complete-menu{position:fixed;top:100px;left:100px;border-radius:0 0 4px 4px;overflow:hidden;overflow-y:auto;box-shadow:0 1px 3px rgba(0,0,0,.12),0 1px 2px rgba(0,0,0,.24);background:#fff;z-index:9999;list-style:none;max-height:240px}.multi-complete-menu li{padding:6px 10px;margin:0}.multi-complete-menu .highlighted{background:rgba(191,164,75,.3)}.multi-complete{position:relative}.multi-complete .tags-wrapper{padding:5px 0}.multi-complete .multi-input-wrapper{position:relative}.multi-complete .menu-button{position:absolute;width:20px;height:20px;border-radius:100%;background:#e4e4e3;border:none;right:7px;top:7px;padding:2px;padding-top:3px;outline:none;color:#666665;transition:outline-offset .2s;outline:3px solid rgba(191,164,75,0);outline-offset:7px}.multi-complete .menu-button:focus{outline-color:rgba(191,164,75,.3);outline-offset:0}.multi-complete .menu-button.open svg{transform:rotate(180deg) translateY(2px)}.multi-tag{padding:6px 10px;padding-top:5px;background:#ae943e;color:#fff;margin:3px;border-radius:4px;display:inline-block;box-shadow:0 1px 3px rgba(0,0,0,.12),0 1px 2px rgba(0,0,0,.24);border-top:1px solid #eee7cf;border-bottom:1px solid #79672b}.multi-tag .remove-button{background:none;border:none;margin:-6px;margin-right:6px;margin-left:-9px;font-size:13px;border-right:1px solid hsla(0,0%,100%,.6);color:#fff}.multi-tag .remove-button:hover{background:hsla(0,0%,100%,.2)}.efs-crop-picker div[class^=col-]{padding:0}.efs-crop-picker div[class^=col-]:nth-child(2){padding-left:5px}.efs-crop-picker .multi-complete .multi-input-wrapper{width:25%}@media only screen and (max-width:992px){.efs-crop-picker .multi-complete .multi-input-wrapper{width:50%}}@media only screen and (max-width:768px){.efs-crop-picker .multi-complete .multi-input-wrapper{width:70%}}@media only screen and (max-width:480px){.efs-crop-picker .multi-complete .multi-input-wrapper{width:100%}}.droppable-animation{animation:droppable-animation .4s infinite;animation-direction:alternate}@keyframes droppable-animation{0%{transform:translateY(0)}to{transform:translateY(-30%)}}.scrollable-paragraph{overflow-y:auto}.scrollable-paragraph.markdown{background:#fff;border-radius:6px;padding:15px;border:1px solid #ddd}.modal .name-org-control .field{padding-left:0;padding-bottom:0}.date-pop-in-down{animation:date-pop-in-down .2s}@keyframes date-pop-in-down{0%{transform:translateY(-20px);opacity:0}to{transform:translateY(0);opacity:1}}.shimmer-result-placeholder{border-radius:6px;background:rgba(48,48,48,.3);padding:15px;min-height:110px;margin-bottom:15px;animation:loading-shimmer 1s infinite}@keyframes loading-shimmer{0%{background:rgba(48,48,48,.15)}50%{background:rgba(48,48,48,.4)}to{background:rgba(48,48,48,.15)}}", ""]);
	
	// exports


/***/ },
/* 888 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(10)();
	// imports
	
	
	// module
	exports.push([module.id, ".upload-submit .selectables{display:flex;margin-bottom:10px}.upload-submit .selectable{background:#949494;border-radius:5px;color:#fff;display:flex;flex-direction:row;justify-content:center;align-items:center;padding:15px;cursor:pointer;outline:none;user-select:none;position:relative;border:0 solid rgba(37,189,245,0);margin-left:10px;transition:outline-offset .2s;outline:3px solid rgba(191,164,75,0);outline-offset:7px}.upload-submit .selectable:hover{background:#a5a4a1}.upload-submit .selectable:focus{outline-color:rgba(191,164,75,.3);outline-offset:0}.upload-submit .selectable:first-of-type{margin-left:0}.upload-submit .selectable.selected{background:-webkit-linear-gradient(70deg,#7d7150,#e6cb73);background:-moz-linear-gradient(70deg,#7d7150,#e6cb73);background:-o-linear-gradient(70deg,#7d7150,#e6cb73);background:linear-gradient(20deg,#7d7150,#e6cb73);box-shadow:0 1px 3px rgba(0,0,0,.12),0 1px 2px rgba(0,0,0,.24);padding-bottom:25px;margin-bottom:-10px;border-radius:5px 5px 0 0}.upload-submit .selectable.selected .radio:after{content:\"\";width:14px;height:14px;position:absolute;left:3px;top:3px;background:#3d3d3d;border-radius:100%}.upload-submit .selectable .title{font-size:16px;font-weight:700}.upload-submit .selectable .radio{width:20px;height:20px;background:#fff;border-radius:100%;margin:0;margin-right:10px;position:relative;flex:0 0 auto}.upload-submit .repeater-wrapper{margin-top:15px}.panel{position:relative;min-height:100px;background:#dcdcdb;border-top:1px solid #d0d0ce;border-radius:0 5px 5px 5px;padding:20px;line-height:normal;box-shadow:0 1px 3px rgba(0,0,0,.12),0 1px 2px rgba(0,0,0,.24);z-index:9}.panel p{margin-bottom:10px}.panel p:last-child{margin-bottom:0}.panel .title{background:#303030;color:#fff;margin-left:-10px;margin-top:-10px;width:calc(100% + 20px);padding:10px;border-radius:3px 3px 0 0}", ""]);
	
	// exports


/***/ },
/* 889 */
/***/ function(module, exports, __webpack_require__) {

	// https://d3js.org/d3-color/ v1.4.0 Copyright 2019 Mike Bostock
	(function (global, factory) {
	 true ? factory(exports) :
	typeof define === 'function' && define.amd ? define(['exports'], factory) :
	(global = global || self, factory(global.d3 = global.d3 || {}));
	}(this, function (exports) { 'use strict';
	
	function define(constructor, factory, prototype) {
	  constructor.prototype = factory.prototype = prototype;
	  prototype.constructor = constructor;
	}
	
	function extend(parent, definition) {
	  var prototype = Object.create(parent.prototype);
	  for (var key in definition) prototype[key] = definition[key];
	  return prototype;
	}
	
	function Color() {}
	
	var darker = 0.7;
	var brighter = 1 / darker;
	
	var reI = "\\s*([+-]?\\d+)\\s*",
	    reN = "\\s*([+-]?\\d*\\.?\\d+(?:[eE][+-]?\\d+)?)\\s*",
	    reP = "\\s*([+-]?\\d*\\.?\\d+(?:[eE][+-]?\\d+)?)%\\s*",
	    reHex = /^#([0-9a-f]{3,8})$/,
	    reRgbInteger = new RegExp("^rgb\\(" + [reI, reI, reI] + "\\)$"),
	    reRgbPercent = new RegExp("^rgb\\(" + [reP, reP, reP] + "\\)$"),
	    reRgbaInteger = new RegExp("^rgba\\(" + [reI, reI, reI, reN] + "\\)$"),
	    reRgbaPercent = new RegExp("^rgba\\(" + [reP, reP, reP, reN] + "\\)$"),
	    reHslPercent = new RegExp("^hsl\\(" + [reN, reP, reP] + "\\)$"),
	    reHslaPercent = new RegExp("^hsla\\(" + [reN, reP, reP, reN] + "\\)$");
	
	var named = {
	  aliceblue: 0xf0f8ff,
	  antiquewhite: 0xfaebd7,
	  aqua: 0x00ffff,
	  aquamarine: 0x7fffd4,
	  azure: 0xf0ffff,
	  beige: 0xf5f5dc,
	  bisque: 0xffe4c4,
	  black: 0x000000,
	  blanchedalmond: 0xffebcd,
	  blue: 0x0000ff,
	  blueviolet: 0x8a2be2,
	  brown: 0xa52a2a,
	  burlywood: 0xdeb887,
	  cadetblue: 0x5f9ea0,
	  chartreuse: 0x7fff00,
	  chocolate: 0xd2691e,
	  coral: 0xff7f50,
	  cornflowerblue: 0x6495ed,
	  cornsilk: 0xfff8dc,
	  crimson: 0xdc143c,
	  cyan: 0x00ffff,
	  darkblue: 0x00008b,
	  darkcyan: 0x008b8b,
	  darkgoldenrod: 0xb8860b,
	  darkgray: 0xa9a9a9,
	  darkgreen: 0x006400,
	  darkgrey: 0xa9a9a9,
	  darkkhaki: 0xbdb76b,
	  darkmagenta: 0x8b008b,
	  darkolivegreen: 0x556b2f,
	  darkorange: 0xff8c00,
	  darkorchid: 0x9932cc,
	  darkred: 0x8b0000,
	  darksalmon: 0xe9967a,
	  darkseagreen: 0x8fbc8f,
	  darkslateblue: 0x483d8b,
	  darkslategray: 0x2f4f4f,
	  darkslategrey: 0x2f4f4f,
	  darkturquoise: 0x00ced1,
	  darkviolet: 0x9400d3,
	  deeppink: 0xff1493,
	  deepskyblue: 0x00bfff,
	  dimgray: 0x696969,
	  dimgrey: 0x696969,
	  dodgerblue: 0x1e90ff,
	  firebrick: 0xb22222,
	  floralwhite: 0xfffaf0,
	  forestgreen: 0x228b22,
	  fuchsia: 0xff00ff,
	  gainsboro: 0xdcdcdc,
	  ghostwhite: 0xf8f8ff,
	  gold: 0xffd700,
	  goldenrod: 0xdaa520,
	  gray: 0x808080,
	  green: 0x008000,
	  greenyellow: 0xadff2f,
	  grey: 0x808080,
	  honeydew: 0xf0fff0,
	  hotpink: 0xff69b4,
	  indianred: 0xcd5c5c,
	  indigo: 0x4b0082,
	  ivory: 0xfffff0,
	  khaki: 0xf0e68c,
	  lavender: 0xe6e6fa,
	  lavenderblush: 0xfff0f5,
	  lawngreen: 0x7cfc00,
	  lemonchiffon: 0xfffacd,
	  lightblue: 0xadd8e6,
	  lightcoral: 0xf08080,
	  lightcyan: 0xe0ffff,
	  lightgoldenrodyellow: 0xfafad2,
	  lightgray: 0xd3d3d3,
	  lightgreen: 0x90ee90,
	  lightgrey: 0xd3d3d3,
	  lightpink: 0xffb6c1,
	  lightsalmon: 0xffa07a,
	  lightseagreen: 0x20b2aa,
	  lightskyblue: 0x87cefa,
	  lightslategray: 0x778899,
	  lightslategrey: 0x778899,
	  lightsteelblue: 0xb0c4de,
	  lightyellow: 0xffffe0,
	  lime: 0x00ff00,
	  limegreen: 0x32cd32,
	  linen: 0xfaf0e6,
	  magenta: 0xff00ff,
	  maroon: 0x800000,
	  mediumaquamarine: 0x66cdaa,
	  mediumblue: 0x0000cd,
	  mediumorchid: 0xba55d3,
	  mediumpurple: 0x9370db,
	  mediumseagreen: 0x3cb371,
	  mediumslateblue: 0x7b68ee,
	  mediumspringgreen: 0x00fa9a,
	  mediumturquoise: 0x48d1cc,
	  mediumvioletred: 0xc71585,
	  midnightblue: 0x191970,
	  mintcream: 0xf5fffa,
	  mistyrose: 0xffe4e1,
	  moccasin: 0xffe4b5,
	  navajowhite: 0xffdead,
	  navy: 0x000080,
	  oldlace: 0xfdf5e6,
	  olive: 0x808000,
	  olivedrab: 0x6b8e23,
	  orange: 0xffa500,
	  orangered: 0xff4500,
	  orchid: 0xda70d6,
	  palegoldenrod: 0xeee8aa,
	  palegreen: 0x98fb98,
	  paleturquoise: 0xafeeee,
	  palevioletred: 0xdb7093,
	  papayawhip: 0xffefd5,
	  peachpuff: 0xffdab9,
	  peru: 0xcd853f,
	  pink: 0xffc0cb,
	  plum: 0xdda0dd,
	  powderblue: 0xb0e0e6,
	  purple: 0x800080,
	  rebeccapurple: 0x663399,
	  red: 0xff0000,
	  rosybrown: 0xbc8f8f,
	  royalblue: 0x4169e1,
	  saddlebrown: 0x8b4513,
	  salmon: 0xfa8072,
	  sandybrown: 0xf4a460,
	  seagreen: 0x2e8b57,
	  seashell: 0xfff5ee,
	  sienna: 0xa0522d,
	  silver: 0xc0c0c0,
	  skyblue: 0x87ceeb,
	  slateblue: 0x6a5acd,
	  slategray: 0x708090,
	  slategrey: 0x708090,
	  snow: 0xfffafa,
	  springgreen: 0x00ff7f,
	  steelblue: 0x4682b4,
	  tan: 0xd2b48c,
	  teal: 0x008080,
	  thistle: 0xd8bfd8,
	  tomato: 0xff6347,
	  turquoise: 0x40e0d0,
	  violet: 0xee82ee,
	  wheat: 0xf5deb3,
	  white: 0xffffff,
	  whitesmoke: 0xf5f5f5,
	  yellow: 0xffff00,
	  yellowgreen: 0x9acd32
	};
	
	define(Color, color, {
	  copy: function(channels) {
	    return Object.assign(new this.constructor, this, channels);
	  },
	  displayable: function() {
	    return this.rgb().displayable();
	  },
	  hex: color_formatHex, // Deprecated! Use color.formatHex.
	  formatHex: color_formatHex,
	  formatHsl: color_formatHsl,
	  formatRgb: color_formatRgb,
	  toString: color_formatRgb
	});
	
	function color_formatHex() {
	  return this.rgb().formatHex();
	}
	
	function color_formatHsl() {
	  return hslConvert(this).formatHsl();
	}
	
	function color_formatRgb() {
	  return this.rgb().formatRgb();
	}
	
	function color(format) {
	  var m, l;
	  format = (format + "").trim().toLowerCase();
	  return (m = reHex.exec(format)) ? (l = m[1].length, m = parseInt(m[1], 16), l === 6 ? rgbn(m) // #ff0000
	      : l === 3 ? new Rgb((m >> 8 & 0xf) | (m >> 4 & 0xf0), (m >> 4 & 0xf) | (m & 0xf0), ((m & 0xf) << 4) | (m & 0xf), 1) // #f00
	      : l === 8 ? new Rgb(m >> 24 & 0xff, m >> 16 & 0xff, m >> 8 & 0xff, (m & 0xff) / 0xff) // #ff000000
	      : l === 4 ? new Rgb((m >> 12 & 0xf) | (m >> 8 & 0xf0), (m >> 8 & 0xf) | (m >> 4 & 0xf0), (m >> 4 & 0xf) | (m & 0xf0), (((m & 0xf) << 4) | (m & 0xf)) / 0xff) // #f000
	      : null) // invalid hex
	      : (m = reRgbInteger.exec(format)) ? new Rgb(m[1], m[2], m[3], 1) // rgb(255, 0, 0)
	      : (m = reRgbPercent.exec(format)) ? new Rgb(m[1] * 255 / 100, m[2] * 255 / 100, m[3] * 255 / 100, 1) // rgb(100%, 0%, 0%)
	      : (m = reRgbaInteger.exec(format)) ? rgba(m[1], m[2], m[3], m[4]) // rgba(255, 0, 0, 1)
	      : (m = reRgbaPercent.exec(format)) ? rgba(m[1] * 255 / 100, m[2] * 255 / 100, m[3] * 255 / 100, m[4]) // rgb(100%, 0%, 0%, 1)
	      : (m = reHslPercent.exec(format)) ? hsla(m[1], m[2] / 100, m[3] / 100, 1) // hsl(120, 50%, 50%)
	      : (m = reHslaPercent.exec(format)) ? hsla(m[1], m[2] / 100, m[3] / 100, m[4]) // hsla(120, 50%, 50%, 1)
	      : named.hasOwnProperty(format) ? rgbn(named[format]) // eslint-disable-line no-prototype-builtins
	      : format === "transparent" ? new Rgb(NaN, NaN, NaN, 0)
	      : null;
	}
	
	function rgbn(n) {
	  return new Rgb(n >> 16 & 0xff, n >> 8 & 0xff, n & 0xff, 1);
	}
	
	function rgba(r, g, b, a) {
	  if (a <= 0) r = g = b = NaN;
	  return new Rgb(r, g, b, a);
	}
	
	function rgbConvert(o) {
	  if (!(o instanceof Color)) o = color(o);
	  if (!o) return new Rgb;
	  o = o.rgb();
	  return new Rgb(o.r, o.g, o.b, o.opacity);
	}
	
	function rgb(r, g, b, opacity) {
	  return arguments.length === 1 ? rgbConvert(r) : new Rgb(r, g, b, opacity == null ? 1 : opacity);
	}
	
	function Rgb(r, g, b, opacity) {
	  this.r = +r;
	  this.g = +g;
	  this.b = +b;
	  this.opacity = +opacity;
	}
	
	define(Rgb, rgb, extend(Color, {
	  brighter: function(k) {
	    k = k == null ? brighter : Math.pow(brighter, k);
	    return new Rgb(this.r * k, this.g * k, this.b * k, this.opacity);
	  },
	  darker: function(k) {
	    k = k == null ? darker : Math.pow(darker, k);
	    return new Rgb(this.r * k, this.g * k, this.b * k, this.opacity);
	  },
	  rgb: function() {
	    return this;
	  },
	  displayable: function() {
	    return (-0.5 <= this.r && this.r < 255.5)
	        && (-0.5 <= this.g && this.g < 255.5)
	        && (-0.5 <= this.b && this.b < 255.5)
	        && (0 <= this.opacity && this.opacity <= 1);
	  },
	  hex: rgb_formatHex, // Deprecated! Use color.formatHex.
	  formatHex: rgb_formatHex,
	  formatRgb: rgb_formatRgb,
	  toString: rgb_formatRgb
	}));
	
	function rgb_formatHex() {
	  return "#" + hex(this.r) + hex(this.g) + hex(this.b);
	}
	
	function rgb_formatRgb() {
	  var a = this.opacity; a = isNaN(a) ? 1 : Math.max(0, Math.min(1, a));
	  return (a === 1 ? "rgb(" : "rgba(")
	      + Math.max(0, Math.min(255, Math.round(this.r) || 0)) + ", "
	      + Math.max(0, Math.min(255, Math.round(this.g) || 0)) + ", "
	      + Math.max(0, Math.min(255, Math.round(this.b) || 0))
	      + (a === 1 ? ")" : ", " + a + ")");
	}
	
	function hex(value) {
	  value = Math.max(0, Math.min(255, Math.round(value) || 0));
	  return (value < 16 ? "0" : "") + value.toString(16);
	}
	
	function hsla(h, s, l, a) {
	  if (a <= 0) h = s = l = NaN;
	  else if (l <= 0 || l >= 1) h = s = NaN;
	  else if (s <= 0) h = NaN;
	  return new Hsl(h, s, l, a);
	}
	
	function hslConvert(o) {
	  if (o instanceof Hsl) return new Hsl(o.h, o.s, o.l, o.opacity);
	  if (!(o instanceof Color)) o = color(o);
	  if (!o) return new Hsl;
	  if (o instanceof Hsl) return o;
	  o = o.rgb();
	  var r = o.r / 255,
	      g = o.g / 255,
	      b = o.b / 255,
	      min = Math.min(r, g, b),
	      max = Math.max(r, g, b),
	      h = NaN,
	      s = max - min,
	      l = (max + min) / 2;
	  if (s) {
	    if (r === max) h = (g - b) / s + (g < b) * 6;
	    else if (g === max) h = (b - r) / s + 2;
	    else h = (r - g) / s + 4;
	    s /= l < 0.5 ? max + min : 2 - max - min;
	    h *= 60;
	  } else {
	    s = l > 0 && l < 1 ? 0 : h;
	  }
	  return new Hsl(h, s, l, o.opacity);
	}
	
	function hsl(h, s, l, opacity) {
	  return arguments.length === 1 ? hslConvert(h) : new Hsl(h, s, l, opacity == null ? 1 : opacity);
	}
	
	function Hsl(h, s, l, opacity) {
	  this.h = +h;
	  this.s = +s;
	  this.l = +l;
	  this.opacity = +opacity;
	}
	
	define(Hsl, hsl, extend(Color, {
	  brighter: function(k) {
	    k = k == null ? brighter : Math.pow(brighter, k);
	    return new Hsl(this.h, this.s, this.l * k, this.opacity);
	  },
	  darker: function(k) {
	    k = k == null ? darker : Math.pow(darker, k);
	    return new Hsl(this.h, this.s, this.l * k, this.opacity);
	  },
	  rgb: function() {
	    var h = this.h % 360 + (this.h < 0) * 360,
	        s = isNaN(h) || isNaN(this.s) ? 0 : this.s,
	        l = this.l,
	        m2 = l + (l < 0.5 ? l : 1 - l) * s,
	        m1 = 2 * l - m2;
	    return new Rgb(
	      hsl2rgb(h >= 240 ? h - 240 : h + 120, m1, m2),
	      hsl2rgb(h, m1, m2),
	      hsl2rgb(h < 120 ? h + 240 : h - 120, m1, m2),
	      this.opacity
	    );
	  },
	  displayable: function() {
	    return (0 <= this.s && this.s <= 1 || isNaN(this.s))
	        && (0 <= this.l && this.l <= 1)
	        && (0 <= this.opacity && this.opacity <= 1);
	  },
	  formatHsl: function() {
	    var a = this.opacity; a = isNaN(a) ? 1 : Math.max(0, Math.min(1, a));
	    return (a === 1 ? "hsl(" : "hsla(")
	        + (this.h || 0) + ", "
	        + (this.s || 0) * 100 + "%, "
	        + (this.l || 0) * 100 + "%"
	        + (a === 1 ? ")" : ", " + a + ")");
	  }
	}));
	
	/* From FvD 13.37, CSS Color Module Level 3 */
	function hsl2rgb(h, m1, m2) {
	  return (h < 60 ? m1 + (m2 - m1) * h / 60
	      : h < 180 ? m2
	      : h < 240 ? m1 + (m2 - m1) * (240 - h) / 60
	      : m1) * 255;
	}
	
	var deg2rad = Math.PI / 180;
	var rad2deg = 180 / Math.PI;
	
	// https://observablehq.com/@mbostock/lab-and-rgb
	var K = 18,
	    Xn = 0.96422,
	    Yn = 1,
	    Zn = 0.82521,
	    t0 = 4 / 29,
	    t1 = 6 / 29,
	    t2 = 3 * t1 * t1,
	    t3 = t1 * t1 * t1;
	
	function labConvert(o) {
	  if (o instanceof Lab) return new Lab(o.l, o.a, o.b, o.opacity);
	  if (o instanceof Hcl) return hcl2lab(o);
	  if (!(o instanceof Rgb)) o = rgbConvert(o);
	  var r = rgb2lrgb(o.r),
	      g = rgb2lrgb(o.g),
	      b = rgb2lrgb(o.b),
	      y = xyz2lab((0.2225045 * r + 0.7168786 * g + 0.0606169 * b) / Yn), x, z;
	  if (r === g && g === b) x = z = y; else {
	    x = xyz2lab((0.4360747 * r + 0.3850649 * g + 0.1430804 * b) / Xn);
	    z = xyz2lab((0.0139322 * r + 0.0971045 * g + 0.7141733 * b) / Zn);
	  }
	  return new Lab(116 * y - 16, 500 * (x - y), 200 * (y - z), o.opacity);
	}
	
	function gray(l, opacity) {
	  return new Lab(l, 0, 0, opacity == null ? 1 : opacity);
	}
	
	function lab(l, a, b, opacity) {
	  return arguments.length === 1 ? labConvert(l) : new Lab(l, a, b, opacity == null ? 1 : opacity);
	}
	
	function Lab(l, a, b, opacity) {
	  this.l = +l;
	  this.a = +a;
	  this.b = +b;
	  this.opacity = +opacity;
	}
	
	define(Lab, lab, extend(Color, {
	  brighter: function(k) {
	    return new Lab(this.l + K * (k == null ? 1 : k), this.a, this.b, this.opacity);
	  },
	  darker: function(k) {
	    return new Lab(this.l - K * (k == null ? 1 : k), this.a, this.b, this.opacity);
	  },
	  rgb: function() {
	    var y = (this.l + 16) / 116,
	        x = isNaN(this.a) ? y : y + this.a / 500,
	        z = isNaN(this.b) ? y : y - this.b / 200;
	    x = Xn * lab2xyz(x);
	    y = Yn * lab2xyz(y);
	    z = Zn * lab2xyz(z);
	    return new Rgb(
	      lrgb2rgb( 3.1338561 * x - 1.6168667 * y - 0.4906146 * z),
	      lrgb2rgb(-0.9787684 * x + 1.9161415 * y + 0.0334540 * z),
	      lrgb2rgb( 0.0719453 * x - 0.2289914 * y + 1.4052427 * z),
	      this.opacity
	    );
	  }
	}));
	
	function xyz2lab(t) {
	  return t > t3 ? Math.pow(t, 1 / 3) : t / t2 + t0;
	}
	
	function lab2xyz(t) {
	  return t > t1 ? t * t * t : t2 * (t - t0);
	}
	
	function lrgb2rgb(x) {
	  return 255 * (x <= 0.0031308 ? 12.92 * x : 1.055 * Math.pow(x, 1 / 2.4) - 0.055);
	}
	
	function rgb2lrgb(x) {
	  return (x /= 255) <= 0.04045 ? x / 12.92 : Math.pow((x + 0.055) / 1.055, 2.4);
	}
	
	function hclConvert(o) {
	  if (o instanceof Hcl) return new Hcl(o.h, o.c, o.l, o.opacity);
	  if (!(o instanceof Lab)) o = labConvert(o);
	  if (o.a === 0 && o.b === 0) return new Hcl(NaN, 0 < o.l && o.l < 100 ? 0 : NaN, o.l, o.opacity);
	  var h = Math.atan2(o.b, o.a) * rad2deg;
	  return new Hcl(h < 0 ? h + 360 : h, Math.sqrt(o.a * o.a + o.b * o.b), o.l, o.opacity);
	}
	
	function lch(l, c, h, opacity) {
	  return arguments.length === 1 ? hclConvert(l) : new Hcl(h, c, l, opacity == null ? 1 : opacity);
	}
	
	function hcl(h, c, l, opacity) {
	  return arguments.length === 1 ? hclConvert(h) : new Hcl(h, c, l, opacity == null ? 1 : opacity);
	}
	
	function Hcl(h, c, l, opacity) {
	  this.h = +h;
	  this.c = +c;
	  this.l = +l;
	  this.opacity = +opacity;
	}
	
	function hcl2lab(o) {
	  if (isNaN(o.h)) return new Lab(o.l, 0, 0, o.opacity);
	  var h = o.h * deg2rad;
	  return new Lab(o.l, Math.cos(h) * o.c, Math.sin(h) * o.c, o.opacity);
	}
	
	define(Hcl, hcl, extend(Color, {
	  brighter: function(k) {
	    return new Hcl(this.h, this.c, this.l + K * (k == null ? 1 : k), this.opacity);
	  },
	  darker: function(k) {
	    return new Hcl(this.h, this.c, this.l - K * (k == null ? 1 : k), this.opacity);
	  },
	  rgb: function() {
	    return hcl2lab(this).rgb();
	  }
	}));
	
	var A = -0.14861,
	    B = +1.78277,
	    C = -0.29227,
	    D = -0.90649,
	    E = +1.97294,
	    ED = E * D,
	    EB = E * B,
	    BC_DA = B * C - D * A;
	
	function cubehelixConvert(o) {
	  if (o instanceof Cubehelix) return new Cubehelix(o.h, o.s, o.l, o.opacity);
	  if (!(o instanceof Rgb)) o = rgbConvert(o);
	  var r = o.r / 255,
	      g = o.g / 255,
	      b = o.b / 255,
	      l = (BC_DA * b + ED * r - EB * g) / (BC_DA + ED - EB),
	      bl = b - l,
	      k = (E * (g - l) - C * bl) / D,
	      s = Math.sqrt(k * k + bl * bl) / (E * l * (1 - l)), // NaN if l=0 or l=1
	      h = s ? Math.atan2(k, bl) * rad2deg - 120 : NaN;
	  return new Cubehelix(h < 0 ? h + 360 : h, s, l, o.opacity);
	}
	
	function cubehelix(h, s, l, opacity) {
	  return arguments.length === 1 ? cubehelixConvert(h) : new Cubehelix(h, s, l, opacity == null ? 1 : opacity);
	}
	
	function Cubehelix(h, s, l, opacity) {
	  this.h = +h;
	  this.s = +s;
	  this.l = +l;
	  this.opacity = +opacity;
	}
	
	define(Cubehelix, cubehelix, extend(Color, {
	  brighter: function(k) {
	    k = k == null ? brighter : Math.pow(brighter, k);
	    return new Cubehelix(this.h, this.s, this.l * k, this.opacity);
	  },
	  darker: function(k) {
	    k = k == null ? darker : Math.pow(darker, k);
	    return new Cubehelix(this.h, this.s, this.l * k, this.opacity);
	  },
	  rgb: function() {
	    var h = isNaN(this.h) ? 0 : (this.h + 120) * deg2rad,
	        l = +this.l,
	        a = isNaN(this.s) ? 0 : this.s * l * (1 - l),
	        cosh = Math.cos(h),
	        sinh = Math.sin(h);
	    return new Rgb(
	      255 * (l + a * (A * cosh + B * sinh)),
	      255 * (l + a * (C * cosh + D * sinh)),
	      255 * (l + a * (E * cosh)),
	      this.opacity
	    );
	  }
	}));
	
	exports.color = color;
	exports.cubehelix = cubehelix;
	exports.gray = gray;
	exports.hcl = hcl;
	exports.hsl = hsl;
	exports.lab = lab;
	exports.lch = lch;
	exports.rgb = rgb;
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	}));


/***/ },
/* 890 */
/***/ function(module, exports, __webpack_require__) {

	// https://d3js.org/d3-ease/ v1.0.6 Copyright 2019 Mike Bostock
	(function (global, factory) {
	 true ? factory(exports) :
	typeof define === 'function' && define.amd ? define(['exports'], factory) :
	(global = global || self, factory(global.d3 = global.d3 || {}));
	}(this, function (exports) { 'use strict';
	
	function linear(t) {
	  return +t;
	}
	
	function quadIn(t) {
	  return t * t;
	}
	
	function quadOut(t) {
	  return t * (2 - t);
	}
	
	function quadInOut(t) {
	  return ((t *= 2) <= 1 ? t * t : --t * (2 - t) + 1) / 2;
	}
	
	function cubicIn(t) {
	  return t * t * t;
	}
	
	function cubicOut(t) {
	  return --t * t * t + 1;
	}
	
	function cubicInOut(t) {
	  return ((t *= 2) <= 1 ? t * t * t : (t -= 2) * t * t + 2) / 2;
	}
	
	var exponent = 3;
	
	var polyIn = (function custom(e) {
	  e = +e;
	
	  function polyIn(t) {
	    return Math.pow(t, e);
	  }
	
	  polyIn.exponent = custom;
	
	  return polyIn;
	})(exponent);
	
	var polyOut = (function custom(e) {
	  e = +e;
	
	  function polyOut(t) {
	    return 1 - Math.pow(1 - t, e);
	  }
	
	  polyOut.exponent = custom;
	
	  return polyOut;
	})(exponent);
	
	var polyInOut = (function custom(e) {
	  e = +e;
	
	  function polyInOut(t) {
	    return ((t *= 2) <= 1 ? Math.pow(t, e) : 2 - Math.pow(2 - t, e)) / 2;
	  }
	
	  polyInOut.exponent = custom;
	
	  return polyInOut;
	})(exponent);
	
	var pi = Math.PI,
	    halfPi = pi / 2;
	
	function sinIn(t) {
	  return 1 - Math.cos(t * halfPi);
	}
	
	function sinOut(t) {
	  return Math.sin(t * halfPi);
	}
	
	function sinInOut(t) {
	  return (1 - Math.cos(pi * t)) / 2;
	}
	
	function expIn(t) {
	  return Math.pow(2, 10 * t - 10);
	}
	
	function expOut(t) {
	  return 1 - Math.pow(2, -10 * t);
	}
	
	function expInOut(t) {
	  return ((t *= 2) <= 1 ? Math.pow(2, 10 * t - 10) : 2 - Math.pow(2, 10 - 10 * t)) / 2;
	}
	
	function circleIn(t) {
	  return 1 - Math.sqrt(1 - t * t);
	}
	
	function circleOut(t) {
	  return Math.sqrt(1 - --t * t);
	}
	
	function circleInOut(t) {
	  return ((t *= 2) <= 1 ? 1 - Math.sqrt(1 - t * t) : Math.sqrt(1 - (t -= 2) * t) + 1) / 2;
	}
	
	var b1 = 4 / 11,
	    b2 = 6 / 11,
	    b3 = 8 / 11,
	    b4 = 3 / 4,
	    b5 = 9 / 11,
	    b6 = 10 / 11,
	    b7 = 15 / 16,
	    b8 = 21 / 22,
	    b9 = 63 / 64,
	    b0 = 1 / b1 / b1;
	
	function bounceIn(t) {
	  return 1 - bounceOut(1 - t);
	}
	
	function bounceOut(t) {
	  return (t = +t) < b1 ? b0 * t * t : t < b3 ? b0 * (t -= b2) * t + b4 : t < b6 ? b0 * (t -= b5) * t + b7 : b0 * (t -= b8) * t + b9;
	}
	
	function bounceInOut(t) {
	  return ((t *= 2) <= 1 ? 1 - bounceOut(1 - t) : bounceOut(t - 1) + 1) / 2;
	}
	
	var overshoot = 1.70158;
	
	var backIn = (function custom(s) {
	  s = +s;
	
	  function backIn(t) {
	    return t * t * ((s + 1) * t - s);
	  }
	
	  backIn.overshoot = custom;
	
	  return backIn;
	})(overshoot);
	
	var backOut = (function custom(s) {
	  s = +s;
	
	  function backOut(t) {
	    return --t * t * ((s + 1) * t + s) + 1;
	  }
	
	  backOut.overshoot = custom;
	
	  return backOut;
	})(overshoot);
	
	var backInOut = (function custom(s) {
	  s = +s;
	
	  function backInOut(t) {
	    return ((t *= 2) < 1 ? t * t * ((s + 1) * t - s) : (t -= 2) * t * ((s + 1) * t + s) + 2) / 2;
	  }
	
	  backInOut.overshoot = custom;
	
	  return backInOut;
	})(overshoot);
	
	var tau = 2 * Math.PI,
	    amplitude = 1,
	    period = 0.3;
	
	var elasticIn = (function custom(a, p) {
	  var s = Math.asin(1 / (a = Math.max(1, a))) * (p /= tau);
	
	  function elasticIn(t) {
	    return a * Math.pow(2, 10 * --t) * Math.sin((s - t) / p);
	  }
	
	  elasticIn.amplitude = function(a) { return custom(a, p * tau); };
	  elasticIn.period = function(p) { return custom(a, p); };
	
	  return elasticIn;
	})(amplitude, period);
	
	var elasticOut = (function custom(a, p) {
	  var s = Math.asin(1 / (a = Math.max(1, a))) * (p /= tau);
	
	  function elasticOut(t) {
	    return 1 - a * Math.pow(2, -10 * (t = +t)) * Math.sin((t + s) / p);
	  }
	
	  elasticOut.amplitude = function(a) { return custom(a, p * tau); };
	  elasticOut.period = function(p) { return custom(a, p); };
	
	  return elasticOut;
	})(amplitude, period);
	
	var elasticInOut = (function custom(a, p) {
	  var s = Math.asin(1 / (a = Math.max(1, a))) * (p /= tau);
	
	  function elasticInOut(t) {
	    return ((t = t * 2 - 1) < 0
	        ? a * Math.pow(2, 10 * t) * Math.sin((s - t) / p)
	        : 2 - a * Math.pow(2, -10 * t) * Math.sin((s + t) / p)) / 2;
	  }
	
	  elasticInOut.amplitude = function(a) { return custom(a, p * tau); };
	  elasticInOut.period = function(p) { return custom(a, p); };
	
	  return elasticInOut;
	})(amplitude, period);
	
	exports.easeBack = backInOut;
	exports.easeBackIn = backIn;
	exports.easeBackInOut = backInOut;
	exports.easeBackOut = backOut;
	exports.easeBounce = bounceOut;
	exports.easeBounceIn = bounceIn;
	exports.easeBounceInOut = bounceInOut;
	exports.easeBounceOut = bounceOut;
	exports.easeCircle = circleInOut;
	exports.easeCircleIn = circleIn;
	exports.easeCircleInOut = circleInOut;
	exports.easeCircleOut = circleOut;
	exports.easeCubic = cubicInOut;
	exports.easeCubicIn = cubicIn;
	exports.easeCubicInOut = cubicInOut;
	exports.easeCubicOut = cubicOut;
	exports.easeElastic = elasticOut;
	exports.easeElasticIn = elasticIn;
	exports.easeElasticInOut = elasticInOut;
	exports.easeElasticOut = elasticOut;
	exports.easeExp = expInOut;
	exports.easeExpIn = expIn;
	exports.easeExpInOut = expInOut;
	exports.easeExpOut = expOut;
	exports.easeLinear = linear;
	exports.easePoly = polyInOut;
	exports.easePolyIn = polyIn;
	exports.easePolyInOut = polyInOut;
	exports.easePolyOut = polyOut;
	exports.easeQuad = quadInOut;
	exports.easeQuadIn = quadIn;
	exports.easeQuadInOut = quadInOut;
	exports.easeQuadOut = quadOut;
	exports.easeSin = sinInOut;
	exports.easeSinIn = sinIn;
	exports.easeSinInOut = sinInOut;
	exports.easeSinOut = sinOut;
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	}));


/***/ },
/* 891 */
/***/ function(module, exports, __webpack_require__) {

	// https://d3js.org/d3-interpolate/ v1.4.0 Copyright 2019 Mike Bostock
	(function (global, factory) {
	 true ? factory(exports, __webpack_require__(889)) :
	typeof define === 'function' && define.amd ? define(['exports', 'd3-color'], factory) :
	(global = global || self, factory(global.d3 = global.d3 || {}, global.d3));
	}(this, function (exports, d3Color) { 'use strict';
	
	function basis(t1, v0, v1, v2, v3) {
	  var t2 = t1 * t1, t3 = t2 * t1;
	  return ((1 - 3 * t1 + 3 * t2 - t3) * v0
	      + (4 - 6 * t2 + 3 * t3) * v1
	      + (1 + 3 * t1 + 3 * t2 - 3 * t3) * v2
	      + t3 * v3) / 6;
	}
	
	function basis$1(values) {
	  var n = values.length - 1;
	  return function(t) {
	    var i = t <= 0 ? (t = 0) : t >= 1 ? (t = 1, n - 1) : Math.floor(t * n),
	        v1 = values[i],
	        v2 = values[i + 1],
	        v0 = i > 0 ? values[i - 1] : 2 * v1 - v2,
	        v3 = i < n - 1 ? values[i + 2] : 2 * v2 - v1;
	    return basis((t - i / n) * n, v0, v1, v2, v3);
	  };
	}
	
	function basisClosed(values) {
	  var n = values.length;
	  return function(t) {
	    var i = Math.floor(((t %= 1) < 0 ? ++t : t) * n),
	        v0 = values[(i + n - 1) % n],
	        v1 = values[i % n],
	        v2 = values[(i + 1) % n],
	        v3 = values[(i + 2) % n];
	    return basis((t - i / n) * n, v0, v1, v2, v3);
	  };
	}
	
	function constant(x) {
	  return function() {
	    return x;
	  };
	}
	
	function linear(a, d) {
	  return function(t) {
	    return a + t * d;
	  };
	}
	
	function exponential(a, b, y) {
	  return a = Math.pow(a, y), b = Math.pow(b, y) - a, y = 1 / y, function(t) {
	    return Math.pow(a + t * b, y);
	  };
	}
	
	function hue(a, b) {
	  var d = b - a;
	  return d ? linear(a, d > 180 || d < -180 ? d - 360 * Math.round(d / 360) : d) : constant(isNaN(a) ? b : a);
	}
	
	function gamma(y) {
	  return (y = +y) === 1 ? nogamma : function(a, b) {
	    return b - a ? exponential(a, b, y) : constant(isNaN(a) ? b : a);
	  };
	}
	
	function nogamma(a, b) {
	  var d = b - a;
	  return d ? linear(a, d) : constant(isNaN(a) ? b : a);
	}
	
	var rgb = (function rgbGamma(y) {
	  var color = gamma(y);
	
	  function rgb(start, end) {
	    var r = color((start = d3Color.rgb(start)).r, (end = d3Color.rgb(end)).r),
	        g = color(start.g, end.g),
	        b = color(start.b, end.b),
	        opacity = nogamma(start.opacity, end.opacity);
	    return function(t) {
	      start.r = r(t);
	      start.g = g(t);
	      start.b = b(t);
	      start.opacity = opacity(t);
	      return start + "";
	    };
	  }
	
	  rgb.gamma = rgbGamma;
	
	  return rgb;
	})(1);
	
	function rgbSpline(spline) {
	  return function(colors) {
	    var n = colors.length,
	        r = new Array(n),
	        g = new Array(n),
	        b = new Array(n),
	        i, color;
	    for (i = 0; i < n; ++i) {
	      color = d3Color.rgb(colors[i]);
	      r[i] = color.r || 0;
	      g[i] = color.g || 0;
	      b[i] = color.b || 0;
	    }
	    r = spline(r);
	    g = spline(g);
	    b = spline(b);
	    color.opacity = 1;
	    return function(t) {
	      color.r = r(t);
	      color.g = g(t);
	      color.b = b(t);
	      return color + "";
	    };
	  };
	}
	
	var rgbBasis = rgbSpline(basis$1);
	var rgbBasisClosed = rgbSpline(basisClosed);
	
	function numberArray(a, b) {
	  if (!b) b = [];
	  var n = a ? Math.min(b.length, a.length) : 0,
	      c = b.slice(),
	      i;
	  return function(t) {
	    for (i = 0; i < n; ++i) c[i] = a[i] * (1 - t) + b[i] * t;
	    return c;
	  };
	}
	
	function isNumberArray(x) {
	  return ArrayBuffer.isView(x) && !(x instanceof DataView);
	}
	
	function array(a, b) {
	  return (isNumberArray(b) ? numberArray : genericArray)(a, b);
	}
	
	function genericArray(a, b) {
	  var nb = b ? b.length : 0,
	      na = a ? Math.min(nb, a.length) : 0,
	      x = new Array(na),
	      c = new Array(nb),
	      i;
	
	  for (i = 0; i < na; ++i) x[i] = value(a[i], b[i]);
	  for (; i < nb; ++i) c[i] = b[i];
	
	  return function(t) {
	    for (i = 0; i < na; ++i) c[i] = x[i](t);
	    return c;
	  };
	}
	
	function date(a, b) {
	  var d = new Date;
	  return a = +a, b = +b, function(t) {
	    return d.setTime(a * (1 - t) + b * t), d;
	  };
	}
	
	function number(a, b) {
	  return a = +a, b = +b, function(t) {
	    return a * (1 - t) + b * t;
	  };
	}
	
	function object(a, b) {
	  var i = {},
	      c = {},
	      k;
	
	  if (a === null || typeof a !== "object") a = {};
	  if (b === null || typeof b !== "object") b = {};
	
	  for (k in b) {
	    if (k in a) {
	      i[k] = value(a[k], b[k]);
	    } else {
	      c[k] = b[k];
	    }
	  }
	
	  return function(t) {
	    for (k in i) c[k] = i[k](t);
	    return c;
	  };
	}
	
	var reA = /[-+]?(?:\d+\.?\d*|\.?\d+)(?:[eE][-+]?\d+)?/g,
	    reB = new RegExp(reA.source, "g");
	
	function zero(b) {
	  return function() {
	    return b;
	  };
	}
	
	function one(b) {
	  return function(t) {
	    return b(t) + "";
	  };
	}
	
	function string(a, b) {
	  var bi = reA.lastIndex = reB.lastIndex = 0, // scan index for next number in b
	      am, // current match in a
	      bm, // current match in b
	      bs, // string preceding current number in b, if any
	      i = -1, // index in s
	      s = [], // string constants and placeholders
	      q = []; // number interpolators
	
	  // Coerce inputs to strings.
	  a = a + "", b = b + "";
	
	  // Interpolate pairs of numbers in a & b.
	  while ((am = reA.exec(a))
	      && (bm = reB.exec(b))) {
	    if ((bs = bm.index) > bi) { // a string precedes the next number in b
	      bs = b.slice(bi, bs);
	      if (s[i]) s[i] += bs; // coalesce with previous string
	      else s[++i] = bs;
	    }
	    if ((am = am[0]) === (bm = bm[0])) { // numbers in a & b match
	      if (s[i]) s[i] += bm; // coalesce with previous string
	      else s[++i] = bm;
	    } else { // interpolate non-matching numbers
	      s[++i] = null;
	      q.push({i: i, x: number(am, bm)});
	    }
	    bi = reB.lastIndex;
	  }
	
	  // Add remains of b.
	  if (bi < b.length) {
	    bs = b.slice(bi);
	    if (s[i]) s[i] += bs; // coalesce with previous string
	    else s[++i] = bs;
	  }
	
	  // Special optimization for only a single match.
	  // Otherwise, interpolate each of the numbers and rejoin the string.
	  return s.length < 2 ? (q[0]
	      ? one(q[0].x)
	      : zero(b))
	      : (b = q.length, function(t) {
	          for (var i = 0, o; i < b; ++i) s[(o = q[i]).i] = o.x(t);
	          return s.join("");
	        });
	}
	
	function value(a, b) {
	  var t = typeof b, c;
	  return b == null || t === "boolean" ? constant(b)
	      : (t === "number" ? number
	      : t === "string" ? ((c = d3Color.color(b)) ? (b = c, rgb) : string)
	      : b instanceof d3Color.color ? rgb
	      : b instanceof Date ? date
	      : isNumberArray(b) ? numberArray
	      : Array.isArray(b) ? genericArray
	      : typeof b.valueOf !== "function" && typeof b.toString !== "function" || isNaN(b) ? object
	      : number)(a, b);
	}
	
	function discrete(range) {
	  var n = range.length;
	  return function(t) {
	    return range[Math.max(0, Math.min(n - 1, Math.floor(t * n)))];
	  };
	}
	
	function hue$1(a, b) {
	  var i = hue(+a, +b);
	  return function(t) {
	    var x = i(t);
	    return x - 360 * Math.floor(x / 360);
	  };
	}
	
	function round(a, b) {
	  return a = +a, b = +b, function(t) {
	    return Math.round(a * (1 - t) + b * t);
	  };
	}
	
	var degrees = 180 / Math.PI;
	
	var identity = {
	  translateX: 0,
	  translateY: 0,
	  rotate: 0,
	  skewX: 0,
	  scaleX: 1,
	  scaleY: 1
	};
	
	function decompose(a, b, c, d, e, f) {
	  var scaleX, scaleY, skewX;
	  if (scaleX = Math.sqrt(a * a + b * b)) a /= scaleX, b /= scaleX;
	  if (skewX = a * c + b * d) c -= a * skewX, d -= b * skewX;
	  if (scaleY = Math.sqrt(c * c + d * d)) c /= scaleY, d /= scaleY, skewX /= scaleY;
	  if (a * d < b * c) a = -a, b = -b, skewX = -skewX, scaleX = -scaleX;
	  return {
	    translateX: e,
	    translateY: f,
	    rotate: Math.atan2(b, a) * degrees,
	    skewX: Math.atan(skewX) * degrees,
	    scaleX: scaleX,
	    scaleY: scaleY
	  };
	}
	
	var cssNode,
	    cssRoot,
	    cssView,
	    svgNode;
	
	function parseCss(value) {
	  if (value === "none") return identity;
	  if (!cssNode) cssNode = document.createElement("DIV"), cssRoot = document.documentElement, cssView = document.defaultView;
	  cssNode.style.transform = value;
	  value = cssView.getComputedStyle(cssRoot.appendChild(cssNode), null).getPropertyValue("transform");
	  cssRoot.removeChild(cssNode);
	  value = value.slice(7, -1).split(",");
	  return decompose(+value[0], +value[1], +value[2], +value[3], +value[4], +value[5]);
	}
	
	function parseSvg(value) {
	  if (value == null) return identity;
	  if (!svgNode) svgNode = document.createElementNS("http://www.w3.org/2000/svg", "g");
	  svgNode.setAttribute("transform", value);
	  if (!(value = svgNode.transform.baseVal.consolidate())) return identity;
	  value = value.matrix;
	  return decompose(value.a, value.b, value.c, value.d, value.e, value.f);
	}
	
	function interpolateTransform(parse, pxComma, pxParen, degParen) {
	
	  function pop(s) {
	    return s.length ? s.pop() + " " : "";
	  }
	
	  function translate(xa, ya, xb, yb, s, q) {
	    if (xa !== xb || ya !== yb) {
	      var i = s.push("translate(", null, pxComma, null, pxParen);
	      q.push({i: i - 4, x: number(xa, xb)}, {i: i - 2, x: number(ya, yb)});
	    } else if (xb || yb) {
	      s.push("translate(" + xb + pxComma + yb + pxParen);
	    }
	  }
	
	  function rotate(a, b, s, q) {
	    if (a !== b) {
	      if (a - b > 180) b += 360; else if (b - a > 180) a += 360; // shortest path
	      q.push({i: s.push(pop(s) + "rotate(", null, degParen) - 2, x: number(a, b)});
	    } else if (b) {
	      s.push(pop(s) + "rotate(" + b + degParen);
	    }
	  }
	
	  function skewX(a, b, s, q) {
	    if (a !== b) {
	      q.push({i: s.push(pop(s) + "skewX(", null, degParen) - 2, x: number(a, b)});
	    } else if (b) {
	      s.push(pop(s) + "skewX(" + b + degParen);
	    }
	  }
	
	  function scale(xa, ya, xb, yb, s, q) {
	    if (xa !== xb || ya !== yb) {
	      var i = s.push(pop(s) + "scale(", null, ",", null, ")");
	      q.push({i: i - 4, x: number(xa, xb)}, {i: i - 2, x: number(ya, yb)});
	    } else if (xb !== 1 || yb !== 1) {
	      s.push(pop(s) + "scale(" + xb + "," + yb + ")");
	    }
	  }
	
	  return function(a, b) {
	    var s = [], // string constants and placeholders
	        q = []; // number interpolators
	    a = parse(a), b = parse(b);
	    translate(a.translateX, a.translateY, b.translateX, b.translateY, s, q);
	    rotate(a.rotate, b.rotate, s, q);
	    skewX(a.skewX, b.skewX, s, q);
	    scale(a.scaleX, a.scaleY, b.scaleX, b.scaleY, s, q);
	    a = b = null; // gc
	    return function(t) {
	      var i = -1, n = q.length, o;
	      while (++i < n) s[(o = q[i]).i] = o.x(t);
	      return s.join("");
	    };
	  };
	}
	
	var interpolateTransformCss = interpolateTransform(parseCss, "px, ", "px)", "deg)");
	var interpolateTransformSvg = interpolateTransform(parseSvg, ", ", ")", ")");
	
	var rho = Math.SQRT2,
	    rho2 = 2,
	    rho4 = 4,
	    epsilon2 = 1e-12;
	
	function cosh(x) {
	  return ((x = Math.exp(x)) + 1 / x) / 2;
	}
	
	function sinh(x) {
	  return ((x = Math.exp(x)) - 1 / x) / 2;
	}
	
	function tanh(x) {
	  return ((x = Math.exp(2 * x)) - 1) / (x + 1);
	}
	
	// p0 = [ux0, uy0, w0]
	// p1 = [ux1, uy1, w1]
	function zoom(p0, p1) {
	  var ux0 = p0[0], uy0 = p0[1], w0 = p0[2],
	      ux1 = p1[0], uy1 = p1[1], w1 = p1[2],
	      dx = ux1 - ux0,
	      dy = uy1 - uy0,
	      d2 = dx * dx + dy * dy,
	      i,
	      S;
	
	  // Special case for u0 ≅ u1.
	  if (d2 < epsilon2) {
	    S = Math.log(w1 / w0) / rho;
	    i = function(t) {
	      return [
	        ux0 + t * dx,
	        uy0 + t * dy,
	        w0 * Math.exp(rho * t * S)
	      ];
	    };
	  }
	
	  // General case.
	  else {
	    var d1 = Math.sqrt(d2),
	        b0 = (w1 * w1 - w0 * w0 + rho4 * d2) / (2 * w0 * rho2 * d1),
	        b1 = (w1 * w1 - w0 * w0 - rho4 * d2) / (2 * w1 * rho2 * d1),
	        r0 = Math.log(Math.sqrt(b0 * b0 + 1) - b0),
	        r1 = Math.log(Math.sqrt(b1 * b1 + 1) - b1);
	    S = (r1 - r0) / rho;
	    i = function(t) {
	      var s = t * S,
	          coshr0 = cosh(r0),
	          u = w0 / (rho2 * d1) * (coshr0 * tanh(rho * s + r0) - sinh(r0));
	      return [
	        ux0 + u * dx,
	        uy0 + u * dy,
	        w0 * coshr0 / cosh(rho * s + r0)
	      ];
	    };
	  }
	
	  i.duration = S * 1000;
	
	  return i;
	}
	
	function hsl(hue) {
	  return function(start, end) {
	    var h = hue((start = d3Color.hsl(start)).h, (end = d3Color.hsl(end)).h),
	        s = nogamma(start.s, end.s),
	        l = nogamma(start.l, end.l),
	        opacity = nogamma(start.opacity, end.opacity);
	    return function(t) {
	      start.h = h(t);
	      start.s = s(t);
	      start.l = l(t);
	      start.opacity = opacity(t);
	      return start + "";
	    };
	  }
	}
	
	var hsl$1 = hsl(hue);
	var hslLong = hsl(nogamma);
	
	function lab(start, end) {
	  var l = nogamma((start = d3Color.lab(start)).l, (end = d3Color.lab(end)).l),
	      a = nogamma(start.a, end.a),
	      b = nogamma(start.b, end.b),
	      opacity = nogamma(start.opacity, end.opacity);
	  return function(t) {
	    start.l = l(t);
	    start.a = a(t);
	    start.b = b(t);
	    start.opacity = opacity(t);
	    return start + "";
	  };
	}
	
	function hcl(hue) {
	  return function(start, end) {
	    var h = hue((start = d3Color.hcl(start)).h, (end = d3Color.hcl(end)).h),
	        c = nogamma(start.c, end.c),
	        l = nogamma(start.l, end.l),
	        opacity = nogamma(start.opacity, end.opacity);
	    return function(t) {
	      start.h = h(t);
	      start.c = c(t);
	      start.l = l(t);
	      start.opacity = opacity(t);
	      return start + "";
	    };
	  }
	}
	
	var hcl$1 = hcl(hue);
	var hclLong = hcl(nogamma);
	
	function cubehelix(hue) {
	  return (function cubehelixGamma(y) {
	    y = +y;
	
	    function cubehelix(start, end) {
	      var h = hue((start = d3Color.cubehelix(start)).h, (end = d3Color.cubehelix(end)).h),
	          s = nogamma(start.s, end.s),
	          l = nogamma(start.l, end.l),
	          opacity = nogamma(start.opacity, end.opacity);
	      return function(t) {
	        start.h = h(t);
	        start.s = s(t);
	        start.l = l(Math.pow(t, y));
	        start.opacity = opacity(t);
	        return start + "";
	      };
	    }
	
	    cubehelix.gamma = cubehelixGamma;
	
	    return cubehelix;
	  })(1);
	}
	
	var cubehelix$1 = cubehelix(hue);
	var cubehelixLong = cubehelix(nogamma);
	
	function piecewise(interpolate, values) {
	  var i = 0, n = values.length - 1, v = values[0], I = new Array(n < 0 ? 0 : n);
	  while (i < n) I[i] = interpolate(v, v = values[++i]);
	  return function(t) {
	    var i = Math.max(0, Math.min(n - 1, Math.floor(t *= n)));
	    return I[i](t - i);
	  };
	}
	
	function quantize(interpolator, n) {
	  var samples = new Array(n);
	  for (var i = 0; i < n; ++i) samples[i] = interpolator(i / (n - 1));
	  return samples;
	}
	
	exports.interpolate = value;
	exports.interpolateArray = array;
	exports.interpolateBasis = basis$1;
	exports.interpolateBasisClosed = basisClosed;
	exports.interpolateCubehelix = cubehelix$1;
	exports.interpolateCubehelixLong = cubehelixLong;
	exports.interpolateDate = date;
	exports.interpolateDiscrete = discrete;
	exports.interpolateHcl = hcl$1;
	exports.interpolateHclLong = hclLong;
	exports.interpolateHsl = hsl$1;
	exports.interpolateHslLong = hslLong;
	exports.interpolateHue = hue$1;
	exports.interpolateLab = lab;
	exports.interpolateNumber = number;
	exports.interpolateNumberArray = numberArray;
	exports.interpolateObject = object;
	exports.interpolateRgb = rgb;
	exports.interpolateRgbBasis = rgbBasis;
	exports.interpolateRgbBasisClosed = rgbBasisClosed;
	exports.interpolateRound = round;
	exports.interpolateString = string;
	exports.interpolateTransformCss = interpolateTransformCss;
	exports.interpolateTransformSvg = interpolateTransformSvg;
	exports.interpolateZoom = zoom;
	exports.piecewise = piecewise;
	exports.quantize = quantize;
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	}));


/***/ },
/* 892 */
/***/ function(module, exports, __webpack_require__) {

	// https://d3js.org/d3-timer/ v1.0.10 Copyright 2019 Mike Bostock
	(function (global, factory) {
	 true ? factory(exports) :
	typeof define === 'function' && define.amd ? define(['exports'], factory) :
	(global = global || self, factory(global.d3 = global.d3 || {}));
	}(this, function (exports) { 'use strict';
	
	var frame = 0, // is an animation frame pending?
	    timeout = 0, // is a timeout pending?
	    interval = 0, // are any timers active?
	    pokeDelay = 1000, // how frequently we check for clock skew
	    taskHead,
	    taskTail,
	    clockLast = 0,
	    clockNow = 0,
	    clockSkew = 0,
	    clock = typeof performance === "object" && performance.now ? performance : Date,
	    setFrame = typeof window === "object" && window.requestAnimationFrame ? window.requestAnimationFrame.bind(window) : function(f) { setTimeout(f, 17); };
	
	function now() {
	  return clockNow || (setFrame(clearNow), clockNow = clock.now() + clockSkew);
	}
	
	function clearNow() {
	  clockNow = 0;
	}
	
	function Timer() {
	  this._call =
	  this._time =
	  this._next = null;
	}
	
	Timer.prototype = timer.prototype = {
	  constructor: Timer,
	  restart: function(callback, delay, time) {
	    if (typeof callback !== "function") throw new TypeError("callback is not a function");
	    time = (time == null ? now() : +time) + (delay == null ? 0 : +delay);
	    if (!this._next && taskTail !== this) {
	      if (taskTail) taskTail._next = this;
	      else taskHead = this;
	      taskTail = this;
	    }
	    this._call = callback;
	    this._time = time;
	    sleep();
	  },
	  stop: function() {
	    if (this._call) {
	      this._call = null;
	      this._time = Infinity;
	      sleep();
	    }
	  }
	};
	
	function timer(callback, delay, time) {
	  var t = new Timer;
	  t.restart(callback, delay, time);
	  return t;
	}
	
	function timerFlush() {
	  now(); // Get the current time, if not already set.
	  ++frame; // Pretend we’ve set an alarm, if we haven’t already.
	  var t = taskHead, e;
	  while (t) {
	    if ((e = clockNow - t._time) >= 0) t._call.call(null, e);
	    t = t._next;
	  }
	  --frame;
	}
	
	function wake() {
	  clockNow = (clockLast = clock.now()) + clockSkew;
	  frame = timeout = 0;
	  try {
	    timerFlush();
	  } finally {
	    frame = 0;
	    nap();
	    clockNow = 0;
	  }
	}
	
	function poke() {
	  var now = clock.now(), delay = now - clockLast;
	  if (delay > pokeDelay) clockSkew -= delay, clockLast = now;
	}
	
	function nap() {
	  var t0, t1 = taskHead, t2, time = Infinity;
	  while (t1) {
	    if (t1._call) {
	      if (time > t1._time) time = t1._time;
	      t0 = t1, t1 = t1._next;
	    } else {
	      t2 = t1._next, t1._next = null;
	      t1 = t0 ? t0._next = t2 : taskHead = t2;
	    }
	  }
	  taskTail = t0;
	  sleep(time);
	}
	
	function sleep(time) {
	  if (frame) return; // Soonest alarm already set, or will be.
	  if (timeout) timeout = clearTimeout(timeout);
	  var delay = time - clockNow; // Strictly less than if we recomputed clockNow.
	  if (delay > 24) {
	    if (time < Infinity) timeout = setTimeout(wake, time - clock.now() - clockSkew);
	    if (interval) interval = clearInterval(interval);
	  } else {
	    if (!interval) clockLast = clock.now(), interval = setInterval(poke, pokeDelay);
	    frame = 1, setFrame(wake);
	  }
	}
	
	function timeout$1(callback, delay, time) {
	  var t = new Timer;
	  delay = delay == null ? 0 : +delay;
	  t.restart(function(elapsed) {
	    t.stop();
	    callback(elapsed + delay);
	  }, delay, time);
	  return t;
	}
	
	function interval$1(callback, delay, time) {
	  var t = new Timer, total = delay;
	  if (delay == null) return t.restart(callback, delay, time), t;
	  delay = +delay, time = time == null ? now() : +time;
	  t.restart(function tick(elapsed) {
	    elapsed += total;
	    t.restart(tick, total += delay, time);
	    callback(elapsed);
	  }, delay, time);
	  return t;
	}
	
	exports.interval = interval$1;
	exports.now = now;
	exports.timeout = timeout$1;
	exports.timer = timer;
	exports.timerFlush = timerFlush;
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	}));


/***/ },
/* 893 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(391));
	
	var _index2 = _interopRequireDefault(__webpack_require__(894));
	
	var _index3 = _interopRequireDefault(__webpack_require__(394));
	
	var _index4 = _interopRequireDefault(__webpack_require__(393));
	
	var _index5 = _interopRequireDefault(__webpack_require__(395));
	
	var _index6 = _interopRequireDefault(__webpack_require__(260));
	
	var _index7 = _interopRequireDefault(__webpack_require__(111));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var dayPeriodEnum = {
	  am: 'am',
	  pm: 'pm',
	  midnight: 'midnight',
	  noon: 'noon',
	  morning: 'morning',
	  afternoon: 'afternoon',
	  evening: 'evening',
	  night: 'night'
	  /*
	   * |     | Unit                           |     | Unit                           |
	   * |-----|--------------------------------|-----|--------------------------------|
	   * |  a  | AM, PM                         |  A* | Milliseconds in day            |
	   * |  b  | AM, PM, noon, midnight         |  B  | Flexible day period            |
	   * |  c  | Stand-alone local day of week  |  C* | Localized hour w/ day period   |
	   * |  d  | Day of month                   |  D  | Day of year                    |
	   * |  e  | Local day of week              |  E  | Day of week                    |
	   * |  f  |                                |  F* | Day of week in month           |
	   * |  g* | Modified Julian day            |  G  | Era                            |
	   * |  h  | Hour [1-12]                    |  H  | Hour [0-23]                    |
	   * |  i! | ISO day of week                |  I! | ISO week of year               |
	   * |  j* | Localized hour w/ day period   |  J* | Localized hour w/o day period  |
	   * |  k  | Hour [1-24]                    |  K  | Hour [0-11]                    |
	   * |  l* | (deprecated)                   |  L  | Stand-alone month              |
	   * |  m  | Minute                         |  M  | Month                          |
	   * |  n  |                                |  N  |                                |
	   * |  o! | Ordinal number modifier        |  O  | Timezone (GMT)                 |
	   * |  p! | Long localized time            |  P! | Long localized date            |
	   * |  q  | Stand-alone quarter            |  Q  | Quarter                        |
	   * |  r* | Related Gregorian year         |  R! | ISO week-numbering year        |
	   * |  s  | Second                         |  S  | Fraction of second             |
	   * |  t! | Seconds timestamp              |  T! | Milliseconds timestamp         |
	   * |  u  | Extended year                  |  U* | Cyclic year                    |
	   * |  v* | Timezone (generic non-locat.)  |  V* | Timezone (location)            |
	   * |  w  | Local week of year             |  W* | Week of month                  |
	   * |  x  | Timezone (ISO-8601 w/o Z)      |  X  | Timezone (ISO-8601)            |
	   * |  y  | Year (abs)                     |  Y  | Local week-numbering year      |
	   * |  z  | Timezone (specific non-locat.) |  Z* | Timezone (aliases)             |
	   *
	   * Letters marked by * are not implemented but reserved by Unicode standard.
	   *
	   * Letters marked by ! are non-standard, but implemented by date-fns:
	   * - `o` modifies the previous token to turn it into an ordinal (see `format` docs)
	   * - `i` is ISO day of week. For `i` and `ii` is returns numeric ISO week days,
	   *   i.e. 7 for Sunday, 1 for Monday, etc.
	   * - `I` is ISO week of year, as opposed to `w` which is local week of year.
	   * - `R` is ISO week-numbering year, as opposed to `Y` which is local week-numbering year.
	   *   `R` is supposed to be used in conjunction with `I` and `i`
	   *   for universal ISO week-numbering date, whereas
	   *   `Y` is supposed to be used in conjunction with `w` and `e`
	   *   for week-numbering date specific to the locale.
	   * - `P` is long localized date format
	   * - `p` is long localized time format
	   */
	
	};
	var formatters = {
	  // Era
	  G: function (date, token, localize) {
	    var era = date.getUTCFullYear() > 0 ? 1 : 0;
	
	    switch (token) {
	      // AD, BC
	      case 'G':
	      case 'GG':
	      case 'GGG':
	        return localize.era(era, {
	          width: 'abbreviated'
	        });
	      // A, B
	
	      case 'GGGGG':
	        return localize.era(era, {
	          width: 'narrow'
	        });
	      // Anno Domini, Before Christ
	
	      case 'GGGG':
	      default:
	        return localize.era(era, {
	          width: 'wide'
	        });
	    }
	  },
	  // Year
	  y: function (date, token, localize) {
	    // Ordinal number
	    if (token === 'yo') {
	      var signedYear = date.getUTCFullYear(); // Returns 1 for 1 BC (which is year 0 in JavaScript)
	
	      var year = signedYear > 0 ? signedYear : 1 - signedYear;
	      return localize.ordinalNumber(year, {
	        unit: 'year'
	      });
	    }
	
	    return _index.default.y(date, token);
	  },
	  // Local week-numbering year
	  Y: function (date, token, localize, options) {
	    var signedWeekYear = (0, _index6.default)(date, options); // Returns 1 for 1 BC (which is year 0 in JavaScript)
	
	    var weekYear = signedWeekYear > 0 ? signedWeekYear : 1 - signedWeekYear; // Two digit year
	
	    if (token === 'YY') {
	      var twoDigitYear = weekYear % 100;
	      return (0, _index7.default)(twoDigitYear, 2);
	    } // Ordinal number
	
	
	    if (token === 'Yo') {
	      return localize.ordinalNumber(weekYear, {
	        unit: 'year'
	      });
	    } // Padding
	
	
	    return (0, _index7.default)(weekYear, token.length);
	  },
	  // ISO week-numbering year
	  R: function (date, token) {
	    var isoWeekYear = (0, _index4.default)(date); // Padding
	
	    return (0, _index7.default)(isoWeekYear, token.length);
	  },
	  // Extended year. This is a single number designating the year of this calendar system.
	  // The main difference between `y` and `u` localizers are B.C. years:
	  // | Year | `y` | `u` |
	  // |------|-----|-----|
	  // | AC 1 |   1 |   1 |
	  // | BC 1 |   1 |   0 |
	  // | BC 2 |   2 |  -1 |
	  // Also `yy` always returns the last two digits of a year,
	  // while `uu` pads single digit years to 2 characters and returns other years unchanged.
	  u: function (date, token) {
	    var year = date.getUTCFullYear();
	    return (0, _index7.default)(year, token.length);
	  },
	  // Quarter
	  Q: function (date, token, localize) {
	    var quarter = Math.ceil((date.getUTCMonth() + 1) / 3);
	
	    switch (token) {
	      // 1, 2, 3, 4
	      case 'Q':
	        return String(quarter);
	      // 01, 02, 03, 04
	
	      case 'QQ':
	        return (0, _index7.default)(quarter, 2);
	      // 1st, 2nd, 3rd, 4th
	
	      case 'Qo':
	        return localize.ordinalNumber(quarter, {
	          unit: 'quarter'
	        });
	      // Q1, Q2, Q3, Q4
	
	      case 'QQQ':
	        return localize.quarter(quarter, {
	          width: 'abbreviated',
	          context: 'formatting'
	        });
	      // 1, 2, 3, 4 (narrow quarter; could be not numerical)
	
	      case 'QQQQQ':
	        return localize.quarter(quarter, {
	          width: 'narrow',
	          context: 'formatting'
	        });
	      // 1st quarter, 2nd quarter, ...
	
	      case 'QQQQ':
	      default:
	        return localize.quarter(quarter, {
	          width: 'wide',
	          context: 'formatting'
	        });
	    }
	  },
	  // Stand-alone quarter
	  q: function (date, token, localize) {
	    var quarter = Math.ceil((date.getUTCMonth() + 1) / 3);
	
	    switch (token) {
	      // 1, 2, 3, 4
	      case 'q':
	        return String(quarter);
	      // 01, 02, 03, 04
	
	      case 'qq':
	        return (0, _index7.default)(quarter, 2);
	      // 1st, 2nd, 3rd, 4th
	
	      case 'qo':
	        return localize.ordinalNumber(quarter, {
	          unit: 'quarter'
	        });
	      // Q1, Q2, Q3, Q4
	
	      case 'qqq':
	        return localize.quarter(quarter, {
	          width: 'abbreviated',
	          context: 'standalone'
	        });
	      // 1, 2, 3, 4 (narrow quarter; could be not numerical)
	
	      case 'qqqqq':
	        return localize.quarter(quarter, {
	          width: 'narrow',
	          context: 'standalone'
	        });
	      // 1st quarter, 2nd quarter, ...
	
	      case 'qqqq':
	      default:
	        return localize.quarter(quarter, {
	          width: 'wide',
	          context: 'standalone'
	        });
	    }
	  },
	  // Month
	  M: function (date, token, localize) {
	    var month = date.getUTCMonth();
	
	    switch (token) {
	      case 'M':
	      case 'MM':
	        return _index.default.M(date, token);
	      // 1st, 2nd, ..., 12th
	
	      case 'Mo':
	        return localize.ordinalNumber(month + 1, {
	          unit: 'month'
	        });
	      // Jan, Feb, ..., Dec
	
	      case 'MMM':
	        return localize.month(month, {
	          width: 'abbreviated',
	          context: 'formatting'
	        });
	      // J, F, ..., D
	
	      case 'MMMMM':
	        return localize.month(month, {
	          width: 'narrow',
	          context: 'formatting'
	        });
	      // January, February, ..., December
	
	      case 'MMMM':
	      default:
	        return localize.month(month, {
	          width: 'wide',
	          context: 'formatting'
	        });
	    }
	  },
	  // Stand-alone month
	  L: function (date, token, localize) {
	    var month = date.getUTCMonth();
	
	    switch (token) {
	      // 1, 2, ..., 12
	      case 'L':
	        return String(month + 1);
	      // 01, 02, ..., 12
	
	      case 'LL':
	        return (0, _index7.default)(month + 1, 2);
	      // 1st, 2nd, ..., 12th
	
	      case 'Lo':
	        return localize.ordinalNumber(month + 1, {
	          unit: 'month'
	        });
	      // Jan, Feb, ..., Dec
	
	      case 'LLL':
	        return localize.month(month, {
	          width: 'abbreviated',
	          context: 'standalone'
	        });
	      // J, F, ..., D
	
	      case 'LLLLL':
	        return localize.month(month, {
	          width: 'narrow',
	          context: 'standalone'
	        });
	      // January, February, ..., December
	
	      case 'LLLL':
	      default:
	        return localize.month(month, {
	          width: 'wide',
	          context: 'standalone'
	        });
	    }
	  },
	  // Local week of year
	  w: function (date, token, localize, options) {
	    var week = (0, _index5.default)(date, options);
	
	    if (token === 'wo') {
	      return localize.ordinalNumber(week, {
	        unit: 'week'
	      });
	    }
	
	    return (0, _index7.default)(week, token.length);
	  },
	  // ISO week of year
	  I: function (date, token, localize) {
	    var isoWeek = (0, _index3.default)(date);
	
	    if (token === 'Io') {
	      return localize.ordinalNumber(isoWeek, {
	        unit: 'week'
	      });
	    }
	
	    return (0, _index7.default)(isoWeek, token.length);
	  },
	  // Day of the month
	  d: function (date, token, localize) {
	    if (token === 'do') {
	      return localize.ordinalNumber(date.getUTCDate(), {
	        unit: 'date'
	      });
	    }
	
	    return _index.default.d(date, token);
	  },
	  // Day of year
	  D: function (date, token, localize) {
	    var dayOfYear = (0, _index2.default)(date);
	
	    if (token === 'Do') {
	      return localize.ordinalNumber(dayOfYear, {
	        unit: 'dayOfYear'
	      });
	    }
	
	    return (0, _index7.default)(dayOfYear, token.length);
	  },
	  // Day of week
	  E: function (date, token, localize) {
	    var dayOfWeek = date.getUTCDay();
	
	    switch (token) {
	      // Tue
	      case 'E':
	      case 'EE':
	      case 'EEE':
	        return localize.day(dayOfWeek, {
	          width: 'abbreviated',
	          context: 'formatting'
	        });
	      // T
	
	      case 'EEEEE':
	        return localize.day(dayOfWeek, {
	          width: 'narrow',
	          context: 'formatting'
	        });
	      // Tu
	
	      case 'EEEEEE':
	        return localize.day(dayOfWeek, {
	          width: 'short',
	          context: 'formatting'
	        });
	      // Tuesday
	
	      case 'EEEE':
	      default:
	        return localize.day(dayOfWeek, {
	          width: 'wide',
	          context: 'formatting'
	        });
	    }
	  },
	  // Local day of week
	  e: function (date, token, localize, options) {
	    var dayOfWeek = date.getUTCDay();
	    var localDayOfWeek = (dayOfWeek - options.weekStartsOn + 8) % 7 || 7;
	
	    switch (token) {
	      // Numerical value (Nth day of week with current locale or weekStartsOn)
	      case 'e':
	        return String(localDayOfWeek);
	      // Padded numerical value
	
	      case 'ee':
	        return (0, _index7.default)(localDayOfWeek, 2);
	      // 1st, 2nd, ..., 7th
	
	      case 'eo':
	        return localize.ordinalNumber(localDayOfWeek, {
	          unit: 'day'
	        });
	
	      case 'eee':
	        return localize.day(dayOfWeek, {
	          width: 'abbreviated',
	          context: 'formatting'
	        });
	      // T
	
	      case 'eeeee':
	        return localize.day(dayOfWeek, {
	          width: 'narrow',
	          context: 'formatting'
	        });
	      // Tu
	
	      case 'eeeeee':
	        return localize.day(dayOfWeek, {
	          width: 'short',
	          context: 'formatting'
	        });
	      // Tuesday
	
	      case 'eeee':
	      default:
	        return localize.day(dayOfWeek, {
	          width: 'wide',
	          context: 'formatting'
	        });
	    }
	  },
	  // Stand-alone local day of week
	  c: function (date, token, localize, options) {
	    var dayOfWeek = date.getUTCDay();
	    var localDayOfWeek = (dayOfWeek - options.weekStartsOn + 8) % 7 || 7;
	
	    switch (token) {
	      // Numerical value (same as in `e`)
	      case 'c':
	        return String(localDayOfWeek);
	      // Padded numerical value
	
	      case 'cc':
	        return (0, _index7.default)(localDayOfWeek, token.length);
	      // 1st, 2nd, ..., 7th
	
	      case 'co':
	        return localize.ordinalNumber(localDayOfWeek, {
	          unit: 'day'
	        });
	
	      case 'ccc':
	        return localize.day(dayOfWeek, {
	          width: 'abbreviated',
	          context: 'standalone'
	        });
	      // T
	
	      case 'ccccc':
	        return localize.day(dayOfWeek, {
	          width: 'narrow',
	          context: 'standalone'
	        });
	      // Tu
	
	      case 'cccccc':
	        return localize.day(dayOfWeek, {
	          width: 'short',
	          context: 'standalone'
	        });
	      // Tuesday
	
	      case 'cccc':
	      default:
	        return localize.day(dayOfWeek, {
	          width: 'wide',
	          context: 'standalone'
	        });
	    }
	  },
	  // ISO day of week
	  i: function (date, token, localize) {
	    var dayOfWeek = date.getUTCDay();
	    var isoDayOfWeek = dayOfWeek === 0 ? 7 : dayOfWeek;
	
	    switch (token) {
	      // 2
	      case 'i':
	        return String(isoDayOfWeek);
	      // 02
	
	      case 'ii':
	        return (0, _index7.default)(isoDayOfWeek, token.length);
	      // 2nd
	
	      case 'io':
	        return localize.ordinalNumber(isoDayOfWeek, {
	          unit: 'day'
	        });
	      // Tue
	
	      case 'iii':
	        return localize.day(dayOfWeek, {
	          width: 'abbreviated',
	          context: 'formatting'
	        });
	      // T
	
	      case 'iiiii':
	        return localize.day(dayOfWeek, {
	          width: 'narrow',
	          context: 'formatting'
	        });
	      // Tu
	
	      case 'iiiiii':
	        return localize.day(dayOfWeek, {
	          width: 'short',
	          context: 'formatting'
	        });
	      // Tuesday
	
	      case 'iiii':
	      default:
	        return localize.day(dayOfWeek, {
	          width: 'wide',
	          context: 'formatting'
	        });
	    }
	  },
	  // AM or PM
	  a: function (date, token, localize) {
	    var hours = date.getUTCHours();
	    var dayPeriodEnumValue = hours / 12 >= 1 ? 'pm' : 'am';
	
	    switch (token) {
	      case 'a':
	      case 'aa':
	      case 'aaa':
	        return localize.dayPeriod(dayPeriodEnumValue, {
	          width: 'abbreviated',
	          context: 'formatting'
	        });
	
	      case 'aaaaa':
	        return localize.dayPeriod(dayPeriodEnumValue, {
	          width: 'narrow',
	          context: 'formatting'
	        });
	
	      case 'aaaa':
	      default:
	        return localize.dayPeriod(dayPeriodEnumValue, {
	          width: 'wide',
	          context: 'formatting'
	        });
	    }
	  },
	  // AM, PM, midnight, noon
	  b: function (date, token, localize) {
	    var hours = date.getUTCHours();
	    var dayPeriodEnumValue;
	
	    if (hours === 12) {
	      dayPeriodEnumValue = dayPeriodEnum.noon;
	    } else if (hours === 0) {
	      dayPeriodEnumValue = dayPeriodEnum.midnight;
	    } else {
	      dayPeriodEnumValue = hours / 12 >= 1 ? 'pm' : 'am';
	    }
	
	    switch (token) {
	      case 'b':
	      case 'bb':
	      case 'bbb':
	        return localize.dayPeriod(dayPeriodEnumValue, {
	          width: 'abbreviated',
	          context: 'formatting'
	        });
	
	      case 'bbbbb':
	        return localize.dayPeriod(dayPeriodEnumValue, {
	          width: 'narrow',
	          context: 'formatting'
	        });
	
	      case 'bbbb':
	      default:
	        return localize.dayPeriod(dayPeriodEnumValue, {
	          width: 'wide',
	          context: 'formatting'
	        });
	    }
	  },
	  // in the morning, in the afternoon, in the evening, at night
	  B: function (date, token, localize) {
	    var hours = date.getUTCHours();
	    var dayPeriodEnumValue;
	
	    if (hours >= 17) {
	      dayPeriodEnumValue = dayPeriodEnum.evening;
	    } else if (hours >= 12) {
	      dayPeriodEnumValue = dayPeriodEnum.afternoon;
	    } else if (hours >= 4) {
	      dayPeriodEnumValue = dayPeriodEnum.morning;
	    } else {
	      dayPeriodEnumValue = dayPeriodEnum.night;
	    }
	
	    switch (token) {
	      case 'B':
	      case 'BB':
	      case 'BBB':
	        return localize.dayPeriod(dayPeriodEnumValue, {
	          width: 'abbreviated',
	          context: 'formatting'
	        });
	
	      case 'BBBBB':
	        return localize.dayPeriod(dayPeriodEnumValue, {
	          width: 'narrow',
	          context: 'formatting'
	        });
	
	      case 'BBBB':
	      default:
	        return localize.dayPeriod(dayPeriodEnumValue, {
	          width: 'wide',
	          context: 'formatting'
	        });
	    }
	  },
	  // Hour [1-12]
	  h: function (date, token, localize) {
	    if (token === 'ho') {
	      var hours = date.getUTCHours() % 12;
	      if (hours === 0) hours = 12;
	      return localize.ordinalNumber(hours, {
	        unit: 'hour'
	      });
	    }
	
	    return _index.default.h(date, token);
	  },
	  // Hour [0-23]
	  H: function (date, token, localize) {
	    if (token === 'Ho') {
	      return localize.ordinalNumber(date.getUTCHours(), {
	        unit: 'hour'
	      });
	    }
	
	    return _index.default.H(date, token);
	  },
	  // Hour [0-11]
	  K: function (date, token, localize) {
	    var hours = date.getUTCHours() % 12;
	
	    if (token === 'Ko') {
	      return localize.ordinalNumber(hours, {
	        unit: 'hour'
	      });
	    }
	
	    return (0, _index7.default)(hours, token.length);
	  },
	  // Hour [1-24]
	  k: function (date, token, localize) {
	    var hours = date.getUTCHours();
	    if (hours === 0) hours = 24;
	
	    if (token === 'ko') {
	      return localize.ordinalNumber(hours, {
	        unit: 'hour'
	      });
	    }
	
	    return (0, _index7.default)(hours, token.length);
	  },
	  // Minute
	  m: function (date, token, localize) {
	    if (token === 'mo') {
	      return localize.ordinalNumber(date.getUTCMinutes(), {
	        unit: 'minute'
	      });
	    }
	
	    return _index.default.m(date, token);
	  },
	  // Second
	  s: function (date, token, localize) {
	    if (token === 'so') {
	      return localize.ordinalNumber(date.getUTCSeconds(), {
	        unit: 'second'
	      });
	    }
	
	    return _index.default.s(date, token);
	  },
	  // Fraction of second
	  S: function (date, token) {
	    return _index.default.S(date, token);
	  },
	  // Timezone (ISO-8601. If offset is 0, output is always `'Z'`)
	  X: function (date, token, _localize, options) {
	    var originalDate = options._originalDate || date;
	    var timezoneOffset = originalDate.getTimezoneOffset();
	
	    if (timezoneOffset === 0) {
	      return 'Z';
	    }
	
	    switch (token) {
	      // Hours and optional minutes
	      case 'X':
	        return formatTimezoneWithOptionalMinutes(timezoneOffset);
	      // Hours, minutes and optional seconds without `:` delimiter
	      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
	      // so this token always has the same output as `XX`
	
	      case 'XXXX':
	      case 'XX':
	        // Hours and minutes without `:` delimiter
	        return formatTimezone(timezoneOffset);
	      // Hours, minutes and optional seconds with `:` delimiter
	      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
	      // so this token always has the same output as `XXX`
	
	      case 'XXXXX':
	      case 'XXX': // Hours and minutes with `:` delimiter
	
	      default:
	        return formatTimezone(timezoneOffset, ':');
	    }
	  },
	  // Timezone (ISO-8601. If offset is 0, output is `'+00:00'` or equivalent)
	  x: function (date, token, _localize, options) {
	    var originalDate = options._originalDate || date;
	    var timezoneOffset = originalDate.getTimezoneOffset();
	
	    switch (token) {
	      // Hours and optional minutes
	      case 'x':
	        return formatTimezoneWithOptionalMinutes(timezoneOffset);
	      // Hours, minutes and optional seconds without `:` delimiter
	      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
	      // so this token always has the same output as `xx`
	
	      case 'xxxx':
	      case 'xx':
	        // Hours and minutes without `:` delimiter
	        return formatTimezone(timezoneOffset);
	      // Hours, minutes and optional seconds with `:` delimiter
	      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
	      // so this token always has the same output as `xxx`
	
	      case 'xxxxx':
	      case 'xxx': // Hours and minutes with `:` delimiter
	
	      default:
	        return formatTimezone(timezoneOffset, ':');
	    }
	  },
	  // Timezone (GMT)
	  O: function (date, token, _localize, options) {
	    var originalDate = options._originalDate || date;
	    var timezoneOffset = originalDate.getTimezoneOffset();
	
	    switch (token) {
	      // Short
	      case 'O':
	      case 'OO':
	      case 'OOO':
	        return 'GMT' + formatTimezoneShort(timezoneOffset, ':');
	      // Long
	
	      case 'OOOO':
	      default:
	        return 'GMT' + formatTimezone(timezoneOffset, ':');
	    }
	  },
	  // Timezone (specific non-location)
	  z: function (date, token, _localize, options) {
	    var originalDate = options._originalDate || date;
	    var timezoneOffset = originalDate.getTimezoneOffset();
	
	    switch (token) {
	      // Short
	      case 'z':
	      case 'zz':
	      case 'zzz':
	        return 'GMT' + formatTimezoneShort(timezoneOffset, ':');
	      // Long
	
	      case 'zzzz':
	      default:
	        return 'GMT' + formatTimezone(timezoneOffset, ':');
	    }
	  },
	  // Seconds timestamp
	  t: function (date, token, _localize, options) {
	    var originalDate = options._originalDate || date;
	    var timestamp = Math.floor(originalDate.getTime() / 1000);
	    return (0, _index7.default)(timestamp, token.length);
	  },
	  // Milliseconds timestamp
	  T: function (date, token, _localize, options) {
	    var originalDate = options._originalDate || date;
	    var timestamp = originalDate.getTime();
	    return (0, _index7.default)(timestamp, token.length);
	  }
	};
	
	function formatTimezoneShort(offset, dirtyDelimiter) {
	  var sign = offset > 0 ? '-' : '+';
	  var absOffset = Math.abs(offset);
	  var hours = Math.floor(absOffset / 60);
	  var minutes = absOffset % 60;
	
	  if (minutes === 0) {
	    return sign + String(hours);
	  }
	
	  var delimiter = dirtyDelimiter || '';
	  return sign + String(hours) + delimiter + (0, _index7.default)(minutes, 2);
	}
	
	function formatTimezoneWithOptionalMinutes(offset, dirtyDelimiter) {
	  if (offset % 60 === 0) {
	    var sign = offset > 0 ? '-' : '+';
	    return sign + (0, _index7.default)(Math.abs(offset) / 60, 2);
	  }
	
	  return formatTimezone(offset, dirtyDelimiter);
	}
	
	function formatTimezone(offset, dirtyDelimiter) {
	  var delimiter = dirtyDelimiter || '';
	  var sign = offset > 0 ? '-' : '+';
	  var absOffset = Math.abs(offset);
	  var hours = (0, _index7.default)(Math.floor(absOffset / 60), 2);
	  var minutes = (0, _index7.default)(absOffset % 60, 2);
	  return sign + hours + delimiter + minutes;
	}
	
	var _default = formatters;
	exports.default = _default;
	module.exports = exports.default;

/***/ },
/* 894 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = getUTCDayOfYear;
	
	var _index = _interopRequireDefault(__webpack_require__(3));
	
	var _index2 = _interopRequireDefault(__webpack_require__(2));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MILLISECONDS_IN_DAY = 86400000; // This function will be a part of public API when UTC function will be implemented.
	// See issue: https://github.com/date-fns/date-fns/issues/376
	
	function getUTCDayOfYear(dirtyDate) {
	  (0, _index2.default)(1, arguments);
	  var date = (0, _index.default)(dirtyDate);
	  var timestamp = date.getTime();
	  date.setUTCMonth(0, 1);
	  date.setUTCHours(0, 0, 0, 0);
	  var startOfYearTimestamp = date.getTime();
	  var difference = timestamp - startOfYearTimestamp;
	  return Math.floor(difference / MILLISECONDS_IN_DAY) + 1;
	}
	
	module.exports = exports.default;

/***/ },
/* 895 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = setUTCDay;
	
	var _index = _interopRequireDefault(__webpack_require__(9));
	
	var _index2 = _interopRequireDefault(__webpack_require__(3));
	
	var _index3 = _interopRequireDefault(__webpack_require__(2));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// This function will be a part of public API when UTC function will be implemented.
	// See issue: https://github.com/date-fns/date-fns/issues/376
	function setUTCDay(dirtyDate, dirtyDay, dirtyOptions) {
	  (0, _index3.default)(2, arguments);
	  var options = dirtyOptions || {};
	  var locale = options.locale;
	  var localeWeekStartsOn = locale && locale.options && locale.options.weekStartsOn;
	  var defaultWeekStartsOn = localeWeekStartsOn == null ? 0 : (0, _index.default)(localeWeekStartsOn);
	  var weekStartsOn = options.weekStartsOn == null ? defaultWeekStartsOn : (0, _index.default)(options.weekStartsOn); // Test if weekStartsOn is between 0 and 6 _and_ is not NaN
	
	  if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) {
	    throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
	  }
	
	  var date = (0, _index2.default)(dirtyDate);
	  var day = (0, _index.default)(dirtyDay);
	  var currentDay = date.getUTCDay();
	  var remainder = day % 7;
	  var dayIndex = (remainder + 7) % 7;
	  var diff = (dayIndex < weekStartsOn ? 7 : 0) + day - currentDay;
	  date.setUTCDate(date.getUTCDate() + diff);
	  return date;
	}
	
	module.exports = exports.default;

/***/ },
/* 896 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = setUTCISODay;
	
	var _index = _interopRequireDefault(__webpack_require__(9));
	
	var _index2 = _interopRequireDefault(__webpack_require__(3));
	
	var _index3 = _interopRequireDefault(__webpack_require__(2));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// This function will be a part of public API when UTC function will be implemented.
	// See issue: https://github.com/date-fns/date-fns/issues/376
	function setUTCISODay(dirtyDate, dirtyDay) {
	  (0, _index3.default)(2, arguments);
	  var day = (0, _index.default)(dirtyDay);
	
	  if (day % 7 === 0) {
	    day = day - 7;
	  }
	
	  var weekStartsOn = 1;
	  var date = (0, _index2.default)(dirtyDate);
	  var currentDay = date.getUTCDay();
	  var remainder = day % 7;
	  var dayIndex = (remainder + 7) % 7;
	  var diff = (dayIndex < weekStartsOn ? 7 : 0) + day - currentDay;
	  date.setUTCDate(date.getUTCDate() + diff);
	  return date;
	}
	
	module.exports = exports.default;

/***/ },
/* 897 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = setUTCISOWeek;
	
	var _index = _interopRequireDefault(__webpack_require__(9));
	
	var _index2 = _interopRequireDefault(__webpack_require__(3));
	
	var _index3 = _interopRequireDefault(__webpack_require__(394));
	
	var _index4 = _interopRequireDefault(__webpack_require__(2));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// This function will be a part of public API when UTC function will be implemented.
	// See issue: https://github.com/date-fns/date-fns/issues/376
	function setUTCISOWeek(dirtyDate, dirtyISOWeek) {
	  (0, _index4.default)(2, arguments);
	  var date = (0, _index2.default)(dirtyDate);
	  var isoWeek = (0, _index.default)(dirtyISOWeek);
	  var diff = (0, _index3.default)(date) - isoWeek;
	  date.setUTCDate(date.getUTCDate() - diff * 7);
	  return date;
	}
	
	module.exports = exports.default;

/***/ },
/* 898 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = setUTCWeek;
	
	var _index = _interopRequireDefault(__webpack_require__(9));
	
	var _index2 = _interopRequireDefault(__webpack_require__(3));
	
	var _index3 = _interopRequireDefault(__webpack_require__(395));
	
	var _index4 = _interopRequireDefault(__webpack_require__(2));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// This function will be a part of public API when UTC function will be implemented.
	// See issue: https://github.com/date-fns/date-fns/issues/376
	function setUTCWeek(dirtyDate, dirtyWeek, options) {
	  (0, _index4.default)(2, arguments);
	  var date = (0, _index2.default)(dirtyDate);
	  var week = (0, _index.default)(dirtyWeek);
	  var diff = (0, _index3.default)(date, options) - week;
	  date.setUTCDate(date.getUTCDate() - diff * 7);
	  return date;
	}
	
	module.exports = exports.default;

/***/ },
/* 899 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = startOfUTCISOWeekYear;
	
	var _index = _interopRequireDefault(__webpack_require__(393));
	
	var _index2 = _interopRequireDefault(__webpack_require__(179));
	
	var _index3 = _interopRequireDefault(__webpack_require__(2));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// This function will be a part of public API when UTC function will be implemented.
	// See issue: https://github.com/date-fns/date-fns/issues/376
	function startOfUTCISOWeekYear(dirtyDate) {
	  (0, _index3.default)(1, arguments);
	  var year = (0, _index.default)(dirtyDate);
	  var fourthOfJanuary = new Date(0);
	  fourthOfJanuary.setUTCFullYear(year, 0, 4);
	  fourthOfJanuary.setUTCHours(0, 0, 0, 0);
	  var date = (0, _index2.default)(fourthOfJanuary);
	  return date;
	}
	
	module.exports = exports.default;

/***/ },
/* 900 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = startOfUTCWeekYear;
	
	var _index = _interopRequireDefault(__webpack_require__(9));
	
	var _index2 = _interopRequireDefault(__webpack_require__(260));
	
	var _index3 = _interopRequireDefault(__webpack_require__(180));
	
	var _index4 = _interopRequireDefault(__webpack_require__(2));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// This function will be a part of public API when UTC function will be implemented.
	// See issue: https://github.com/date-fns/date-fns/issues/376
	function startOfUTCWeekYear(dirtyDate, dirtyOptions) {
	  (0, _index4.default)(1, arguments);
	  var options = dirtyOptions || {};
	  var locale = options.locale;
	  var localeFirstWeekContainsDate = locale && locale.options && locale.options.firstWeekContainsDate;
	  var defaultFirstWeekContainsDate = localeFirstWeekContainsDate == null ? 1 : (0, _index.default)(localeFirstWeekContainsDate);
	  var firstWeekContainsDate = options.firstWeekContainsDate == null ? defaultFirstWeekContainsDate : (0, _index.default)(options.firstWeekContainsDate);
	  var year = (0, _index2.default)(dirtyDate, dirtyOptions);
	  var firstWeek = new Date(0);
	  firstWeek.setUTCFullYear(year, 0, firstWeekContainsDate);
	  firstWeek.setUTCHours(0, 0, 0, 0);
	  var date = (0, _index3.default)(firstWeek, dirtyOptions);
	  return date;
	}
	
	module.exports = exports.default;

/***/ },
/* 901 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = add;
	
	var _index = _interopRequireDefault(__webpack_require__(74));
	
	var _index2 = _interopRequireDefault(__webpack_require__(112));
	
	var _index3 = _interopRequireDefault(__webpack_require__(3));
	
	var _index4 = _interopRequireDefault(__webpack_require__(2));
	
	var _index5 = _interopRequireDefault(__webpack_require__(9));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name add
	 * @category Common Helpers
	 * @summary Add the specified years, months, weeks, days, hours, minutes and seconds to the given date.
	 *
	 * @description
	 * Add the specified years, months, weeks, days, hours, minutes and seconds to the given date.
	 *
	 * @param {Date|Number} date - the date to be changed
	 * @param {Duration} duration - the object with years, months, weeks, days, hours, minutes and seconds to be added. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
	 *
	 * | Key            | Description                        |
	 * |----------------|------------------------------------|
	 * | years          | Amount of years to be added        |
	 * | months         | Amount of months to be added       |
	 * | weeks          | Amount of weeks to be added       |
	 * | days           | Amount of days to be added         |
	 * | hours          | Amount of hours to be added        |
	 * | minutes        | Amount of minutes to be added      |
	 * | seconds        | Amount of seconds to be added      |
	 *
	 * All values default to 0
	 *
	 * @returns {Date} the new date with the seconds added
	 * @throws {TypeError} 2 arguments required
	 *
	 * @example
	 * // Add the following duration to 1 September 2014, 10:19:50
	 * var result = add(new Date(2014, 8, 1, 10, 19, 50), {
	 *   years: 2,
	 *   months: 9,
	 *   weeks: 1,
	 *   days: 7,
	 *   hours: 5,
	 *   minutes: 9,
	 *   seconds: 30,
	 * })
	 * //=> Thu Jun 15 2017 15:29:20
	 */
	function add(dirtyDate, duration) {
	  (0, _index4.default)(2, arguments);
	  if (!duration || typeof duration !== 'object') return new Date(NaN);
	  var years = 'years' in duration ? (0, _index5.default)(duration.years) : 0;
	  var months = 'months' in duration ? (0, _index5.default)(duration.months) : 0;
	  var weeks = 'weeks' in duration ? (0, _index5.default)(duration.weeks) : 0;
	  var days = 'days' in duration ? (0, _index5.default)(duration.days) : 0;
	  var hours = 'hours' in duration ? (0, _index5.default)(duration.hours) : 0;
	  var minutes = 'minutes' in duration ? (0, _index5.default)(duration.minutes) : 0;
	  var seconds = 'seconds' in duration ? (0, _index5.default)(duration.seconds) : 0; // Add years and months
	
	  var date = (0, _index3.default)(dirtyDate);
	  var dateWithMonths = months || years ? (0, _index2.default)(date, months + years * 12) : date; // Add weeks and days
	
	  var dateWithDays = days || weeks ? (0, _index.default)(dateWithMonths, days + weeks * 7) : dateWithMonths; // Add days, hours, minutes and seconds
	
	  var minutesToAdd = minutes + hours * 60;
	  var secondsToAdd = seconds + minutesToAdd * 60;
	  var msToAdd = secondsToAdd * 1000;
	  var finalDate = new Date(dateWithDays.getTime() + msToAdd);
	  return finalDate;
	}
	
	module.exports = exports.default;

/***/ },
/* 902 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = areIntervalsOverlapping;
	
	var _index = _interopRequireDefault(__webpack_require__(3));
	
	var _index2 = _interopRequireDefault(__webpack_require__(2));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name areIntervalsOverlapping
	 * @category Interval Helpers
	 * @summary Is the given time interval overlapping with another time interval?
	 *
	 * @description
	 * Is the given time interval overlapping with another time interval? Adjacent intervals do not count as overlapping.
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * - The function was renamed from `areRangesOverlapping` to `areIntervalsOverlapping`.
	 *   This change was made to mirror the use of the word "interval" in standard ISO 8601:2004 terminology:
	 *
	 *   ```
	 *   2.1.3
	 *   time interval
	 *   part of the time axis limited by two instants
	 *   ```
	 *
	 *   Also, this function now accepts an object with `start` and `end` properties
	 *   instead of two arguments as an interval.
	 *   This function now throws `RangeError` if the start of the interval is after its end
	 *   or if any date in the interval is `Invalid Date`.
	 *
	 *   ```javascript
	 *   // Before v2.0.0
	 *
	 *   areRangesOverlapping(
	 *     new Date(2014, 0, 10), new Date(2014, 0, 20),
	 *     new Date(2014, 0, 17), new Date(2014, 0, 21)
	 *   )
	 *
	 *   // v2.0.0 onward
	 *
	 *   areIntervalsOverlapping(
	 *     { start: new Date(2014, 0, 10), end: new Date(2014, 0, 20) },
	 *     { start: new Date(2014, 0, 17), end: new Date(2014, 0, 21) }
	 *   )
	 *   ```
	 *
	 * @param {Interval} intervalLeft - the first interval to compare. See [Interval]{@link docs/types/Interval}
	 * @param {Interval} intervalRight - the second interval to compare. See [Interval]{@link docs/types/Interval}
	 * @param {Object} [options] - the object with options
	 * @param {Boolean} [options.inclusive=false] - whether the comparison is inclusive or not
	 * @returns {Boolean} whether the time intervals are overlapping
	 * @throws {TypeError} 2 arguments required
	 * @throws {RangeError} The start of an interval cannot be after its end
	 * @throws {RangeError} Date in interval cannot be `Invalid Date`
	 *
	 * @example
	 * // For overlapping time intervals:
	 * areIntervalsOverlapping(
	 *   { start: new Date(2014, 0, 10), end: new Date(2014, 0, 20) },
	 *   { start: new Date(2014, 0, 17), end: new Date(2014, 0, 21) }
	 * )
	 * //=> true
	 *
	 * @example
	 * // For non-overlapping time intervals:
	 * areIntervalsOverlapping(
	 *   { start: new Date(2014, 0, 10), end: new Date(2014, 0, 20) },
	 *   { start: new Date(2014, 0, 21), end: new Date(2014, 0, 22) }
	 * )
	 * //=> false
	 *
	 * @example
	 * // For adjacent time intervals:
	 * areIntervalsOverlapping(
	 *   { start: new Date(2014, 0, 10), end: new Date(2014, 0, 20) },
	 *   { start: new Date(2014, 0, 20), end: new Date(2014, 0, 30) }
	 * )
	 * //=> false
	 *
	 * @example
	 * // Using the inclusive option:
	 * areIntervalsOverlapping(
	 *   { start: new Date(2014, 0, 10), end: new Date(2014, 0, 20) },
	 *   { start: new Date(2014, 0, 20), end: new Date(2014, 0, 24) }
	 * )
	 * //=> false
	 * areIntervalsOverlapping(
	 *   { start: new Date(2014, 0, 10), end: new Date(2014, 0, 20) },
	 *   { start: new Date(2014, 0, 20), end: new Date(2014, 0, 24) },
	 *   { inclusive: true }
	 * )
	 * //=> true
	 */
	function areIntervalsOverlapping(dirtyIntervalLeft, dirtyIntervalRight) {
	  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	  (0, _index2.default)(2, arguments);
	  var intervalLeft = dirtyIntervalLeft || {};
	  var intervalRight = dirtyIntervalRight || {};
	  var leftStartTime = (0, _index.default)(intervalLeft.start).getTime();
	  var leftEndTime = (0, _index.default)(intervalLeft.end).getTime();
	  var rightStartTime = (0, _index.default)(intervalRight.start).getTime();
	  var rightEndTime = (0, _index.default)(intervalRight.end).getTime(); // Throw an exception if start date is after end date or if any date is `Invalid Date`
	
	  if (!(leftStartTime <= leftEndTime && rightStartTime <= rightEndTime)) {
	    throw new RangeError('Invalid interval');
	  }
	
	  if (options.inclusive) {
	    return leftStartTime <= rightEndTime && rightStartTime <= leftEndTime;
	  }
	
	  return leftStartTime < rightEndTime && rightStartTime < leftEndTime;
	}
	
	module.exports = exports.default;

/***/ },
/* 903 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = closestIndexTo;
	
	var _index = _interopRequireDefault(__webpack_require__(3));
	
	var _index2 = _interopRequireDefault(__webpack_require__(2));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name closestIndexTo
	 * @category Common Helpers
	 * @summary Return an index of the closest date from the array comparing to the given date.
	 *
	 * @description
	 * Return an index of the closest date from the array comparing to the given date.
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * - Now, `closestIndexTo` doesn't throw an exception
	 *   when the second argument is not an array, and returns Invalid Date instead.
	 *
	 * @param {Date|Number} dateToCompare - the date to compare with
	 * @param {Date[]|Number[]} datesArray - the array to search
	 * @returns {Number} an index of the date closest to the given date
	 * @throws {TypeError} 2 arguments required
	 *
	 * @example
	 * // Which date is closer to 6 September 2015?
	 * var dateToCompare = new Date(2015, 8, 6)
	 * var datesArray = [
	 *   new Date(2015, 0, 1),
	 *   new Date(2016, 0, 1),
	 *   new Date(2017, 0, 1)
	 * ]
	 * var result = closestIndexTo(dateToCompare, datesArray)
	 * //=> 1
	 */
	function closestIndexTo(dirtyDateToCompare, dirtyDatesArray) {
	  (0, _index2.default)(2, arguments);
	  var dateToCompare = (0, _index.default)(dirtyDateToCompare);
	
	  if (isNaN(dateToCompare)) {
	    return NaN;
	  }
	
	  var timeToCompare = dateToCompare.getTime();
	  var datesArray; // `dirtyDatesArray` is undefined or null
	
	  if (dirtyDatesArray == null) {
	    datesArray = []; // `dirtyDatesArray` is Array, Set or Map, or object with custom `forEach` method
	  } else if (typeof dirtyDatesArray.forEach === 'function') {
	    datesArray = dirtyDatesArray; // If `dirtyDatesArray` is Array-like Object, convert to Array. Otherwise, make it empty Array
	  } else {
	    datesArray = Array.prototype.slice.call(dirtyDatesArray);
	  }
	
	  var result;
	  var minDistance;
	  datesArray.forEach(function (dirtyDate, index) {
	    var currentDate = (0, _index.default)(dirtyDate);
	
	    if (isNaN(currentDate)) {
	      result = NaN;
	      minDistance = NaN;
	      return;
	    }
	
	    var distance = Math.abs(timeToCompare - currentDate.getTime());
	
	    if (result == null || distance < minDistance) {
	      result = index;
	      minDistance = distance;
	    }
	  });
	  return result;
	}
	
	module.exports = exports.default;

/***/ },
/* 904 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = closestTo;
	
	var _index = _interopRequireDefault(__webpack_require__(3));
	
	var _index2 = _interopRequireDefault(__webpack_require__(2));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name closestTo
	 * @category Common Helpers
	 * @summary Return a date from the array closest to the given date.
	 *
	 * @description
	 * Return a date from the array closest to the given date.
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * - Now, `closestTo` doesn't throw an exception
	 *   when the second argument is not an array, and returns Invalid Date instead.
	 *
	 * @param {Date|Number} dateToCompare - the date to compare with
	 * @param {Date[]|Number[]} datesArray - the array to search
	 * @returns {Date} the date from the array closest to the given date
	 * @throws {TypeError} 2 arguments required
	 *
	 * @example
	 * // Which date is closer to 6 September 2015: 1 January 2000 or 1 January 2030?
	 * var dateToCompare = new Date(2015, 8, 6)
	 * var result = closestTo(dateToCompare, [
	 *   new Date(2000, 0, 1),
	 *   new Date(2030, 0, 1)
	 * ])
	 * //=> Tue Jan 01 2030 00:00:00
	 */
	function closestTo(dirtyDateToCompare, dirtyDatesArray) {
	  (0, _index2.default)(2, arguments);
	  var dateToCompare = (0, _index.default)(dirtyDateToCompare);
	
	  if (isNaN(dateToCompare)) {
	    return new Date(NaN);
	  }
	
	  var timeToCompare = dateToCompare.getTime();
	  var datesArray; // `dirtyDatesArray` is undefined or null
	
	  if (dirtyDatesArray == null) {
	    datesArray = []; // `dirtyDatesArray` is Array, Set or Map, or object with custom `forEach` method
	  } else if (typeof dirtyDatesArray.forEach === 'function') {
	    datesArray = dirtyDatesArray; // If `dirtyDatesArray` is Array-like Object, convert to Array. Otherwise, make it empty Array
	  } else {
	    datesArray = Array.prototype.slice.call(dirtyDatesArray);
	  }
	
	  var result;
	  var minDistance;
	  datesArray.forEach(function (dirtyDate) {
	    var currentDate = (0, _index.default)(dirtyDate);
	
	    if (isNaN(currentDate)) {
	      result = new Date(NaN);
	      minDistance = NaN;
	      return;
	    }
	
	    var distance = Math.abs(timeToCompare - currentDate.getTime());
	
	    if (result == null || distance < minDistance) {
	      result = currentDate;
	      minDistance = distance;
	    }
	  });
	  return result;
	}
	
	module.exports = exports.default;

/***/ },
/* 905 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = compareDesc;
	
	var _index = _interopRequireDefault(__webpack_require__(3));
	
	var _index2 = _interopRequireDefault(__webpack_require__(2));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name compareDesc
	 * @category Common Helpers
	 * @summary Compare the two dates reverse chronologically and return -1, 0 or 1.
	 *
	 * @description
	 * Compare the two dates and return -1 if the first date is after the second,
	 * 1 if the first date is before the second or 0 if dates are equal.
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} dateLeft - the first date to compare
	 * @param {Date|Number} dateRight - the second date to compare
	 * @returns {Number} the result of the comparison
	 * @throws {TypeError} 2 arguments required
	 *
	 * @example
	 * // Compare 11 February 1987 and 10 July 1989 reverse chronologically:
	 * var result = compareDesc(new Date(1987, 1, 11), new Date(1989, 6, 10))
	 * //=> 1
	 *
	 * @example
	 * // Sort the array of dates in reverse chronological order:
	 * var result = [
	 *   new Date(1995, 6, 2),
	 *   new Date(1987, 1, 11),
	 *   new Date(1989, 6, 10)
	 * ].sort(compareDesc)
	 * //=> [
	 * //   Sun Jul 02 1995 00:00:00,
	 * //   Mon Jul 10 1989 00:00:00,
	 * //   Wed Feb 11 1987 00:00:00
	 * // ]
	 */
	function compareDesc(dirtyDateLeft, dirtyDateRight) {
	  (0, _index2.default)(2, arguments);
	  var dateLeft = (0, _index.default)(dirtyDateLeft);
	  var dateRight = (0, _index.default)(dirtyDateRight);
	  var diff = dateLeft.getTime() - dateRight.getTime();
	
	  if (diff > 0) {
	    return -1;
	  } else if (diff < 0) {
	    return 1; // Return 0 if diff is 0; return NaN if diff is NaN
	  } else {
	    return diff;
	  }
	}
	
	module.exports = exports.default;

/***/ },
/* 906 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.minTime = exports.maxTime = void 0;
	
	/**
	 *  Maximum allowed time.
	 *  @constant
	 *  @type {number}
	 *  @default
	 */
	var maxTime = Math.pow(10, 8) * 24 * 60 * 60 * 1000;
	/**
	 *  Minimum allowed time.
	 *  @constant
	 *  @type {number}
	 *  @default
	 */
	
	exports.maxTime = maxTime;
	var minTime = -maxTime;
	exports.minTime = minTime;

/***/ },
/* 907 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = differenceInBusinessDays;
	
	var _index = _interopRequireDefault(__webpack_require__(43));
	
	var _index2 = _interopRequireDefault(__webpack_require__(188));
	
	var _index3 = _interopRequireDefault(__webpack_require__(3));
	
	var _index4 = _interopRequireDefault(__webpack_require__(84));
	
	var _index5 = _interopRequireDefault(__webpack_require__(74));
	
	var _index6 = _interopRequireDefault(__webpack_require__(114));
	
	var _index7 = _interopRequireDefault(__webpack_require__(9));
	
	var _index8 = _interopRequireDefault(__webpack_require__(2));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name differenceInBusinessDays
	 * @category Day Helpers
	 * @summary Get the number of business days between the given dates.
	 *
	 * @description
	 * Get the number of business day periods between the given dates.
	 * Business days being days that arent in the weekend.
	 * Like `differenceInCalendarDays`, the function removes the times from
	 * the dates before calculating the difference.
	 *
	 * @param {Date|Number} dateLeft - the later date
	 * @param {Date|Number} dateRight - the earlier date
	 * @returns {Number} the number of business days
	 * @throws {TypeError} 2 arguments required
	 *
	 * @example
	 * // How many business days are between
	 * // 10 January 2014 and 20 July 2014?
	 * var result = differenceInBusinessDays(
	 *   new Date(2014, 6, 20),
	 *   new Date(2014, 0, 10)
	 * )
	 * //=> 136
	 */
	function differenceInBusinessDays(dirtyDateLeft, dirtyDateRight) {
	  (0, _index8.default)(2, arguments);
	  var dateLeft = (0, _index3.default)(dirtyDateLeft);
	  var dateRight = (0, _index3.default)(dirtyDateRight);
	  if (!(0, _index.default)(dateLeft) || !(0, _index.default)(dateRight)) return new Date(NaN);
	  var calendarDifference = (0, _index4.default)(dateLeft, dateRight);
	  var sign = calendarDifference < 0 ? -1 : 1;
	  var weeks = (0, _index7.default)(calendarDifference / 7);
	  var result = weeks * 5;
	  dateRight = (0, _index5.default)(dateRight, weeks * 7); // the loop below will run at most 6 times to account for the remaining days that don't makeup a full week
	
	  while (!(0, _index6.default)(dateLeft, dateRight)) {
	    // sign is used to account for both negative and positive differences
	    result += (0, _index2.default)(dateRight) ? 0 : sign;
	    dateRight = (0, _index5.default)(dateRight, sign);
	  }
	
	  return result === 0 ? 0 : result;
	}
	
	module.exports = exports.default;

/***/ },
/* 908 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = differenceInCalendarISOWeeks;
	
	var _index = _interopRequireDefault(__webpack_require__(73));
	
	var _index2 = _interopRequireDefault(__webpack_require__(99));
	
	var _index3 = _interopRequireDefault(__webpack_require__(2));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MILLISECONDS_IN_WEEK = 604800000;
	/**
	 * @name differenceInCalendarISOWeeks
	 * @category ISO Week Helpers
	 * @summary Get the number of calendar ISO weeks between the given dates.
	 *
	 * @description
	 * Get the number of calendar ISO weeks between the given dates.
	 *
	 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} dateLeft - the later date
	 * @param {Date|Number} dateRight - the earlier date
	 * @returns {Number} the number of calendar ISO weeks
	 * @throws {TypeError} 2 arguments required
	 *
	 * @example
	 * // How many calendar ISO weeks are between 6 July 2014 and 21 July 2014?
	 * var result = differenceInCalendarISOWeeks(
	 *   new Date(2014, 6, 21),
	 *   new Date(2014, 6, 6)
	 * )
	 * //=> 3
	 */
	
	function differenceInCalendarISOWeeks(dirtyDateLeft, dirtyDateRight) {
	  (0, _index3.default)(2, arguments);
	  var startOfISOWeekLeft = (0, _index2.default)(dirtyDateLeft);
	  var startOfISOWeekRight = (0, _index2.default)(dirtyDateRight);
	  var timestampLeft = startOfISOWeekLeft.getTime() - (0, _index.default)(startOfISOWeekLeft);
	  var timestampRight = startOfISOWeekRight.getTime() - (0, _index.default)(startOfISOWeekRight); // Round the number of days to the nearest integer
	  // because the number of milliseconds in a week is not constant
	  // (e.g. it's different in the week of the daylight saving time clock shift)
	
	  return Math.round((timestampLeft - timestampRight) / MILLISECONDS_IN_WEEK);
	}
	
	module.exports = exports.default;

/***/ },
/* 909 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = differenceInCalendarQuarters;
	
	var _index = _interopRequireDefault(__webpack_require__(271));
	
	var _index2 = _interopRequireDefault(__webpack_require__(3));
	
	var _index3 = _interopRequireDefault(__webpack_require__(2));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name differenceInCalendarQuarters
	 * @category Quarter Helpers
	 * @summary Get the number of calendar quarters between the given dates.
	 *
	 * @description
	 * Get the number of calendar quarters between the given dates.
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} dateLeft - the later date
	 * @param {Date|Number} dateRight - the earlier date
	 * @returns {Number} the number of calendar quarters
	 * @throws {TypeError} 2 arguments required
	 *
	 * @example
	 * // How many calendar quarters are between 31 December 2013 and 2 July 2014?
	 * var result = differenceInCalendarQuarters(
	 *   new Date(2014, 6, 2),
	 *   new Date(2013, 11, 31)
	 * )
	 * //=> 3
	 */
	function differenceInCalendarQuarters(dirtyDateLeft, dirtyDateRight) {
	  (0, _index3.default)(2, arguments);
	  var dateLeft = (0, _index2.default)(dirtyDateLeft);
	  var dateRight = (0, _index2.default)(dirtyDateRight);
	  var yearDiff = dateLeft.getFullYear() - dateRight.getFullYear();
	  var quarterDiff = (0, _index.default)(dateLeft) - (0, _index.default)(dateRight);
	  return yearDiff * 4 + quarterDiff;
	}
	
	module.exports = exports.default;

/***/ },
/* 910 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = differenceInISOWeekYears;
	
	var _index = _interopRequireDefault(__webpack_require__(3));
	
	var _index2 = _interopRequireDefault(__webpack_require__(400));
	
	var _index3 = _interopRequireDefault(__webpack_require__(98));
	
	var _index4 = _interopRequireDefault(__webpack_require__(440));
	
	var _index5 = _interopRequireDefault(__webpack_require__(2));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name differenceInISOWeekYears
	 * @category ISO Week-Numbering Year Helpers
	 * @summary Get the number of full ISO week-numbering years between the given dates.
	 *
	 * @description
	 * Get the number of full ISO week-numbering years between the given dates.
	 *
	 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * - The function was renamed from `differenceInISOYears` to `differenceInISOWeekYears`.
	 *   "ISO week year" is short for [ISO week-numbering year](https://en.wikipedia.org/wiki/ISO_week_date).
	 *   This change makes the name consistent with
	 *   locale-dependent week-numbering year helpers, e.g., `addWeekYears`.
	 *
	 * @param {Date|Number} dateLeft - the later date
	 * @param {Date|Number} dateRight - the earlier date
	 * @returns {Number} the number of full ISO week-numbering years
	 * @throws {TypeError} 2 arguments required
	 *
	 * @example
	 * // How many full ISO week-numbering years are between 1 January 2010 and 1 January 2012?
	 * var result = differenceInISOWeekYears(
	 *   new Date(2012, 0, 1),
	 *   new Date(2010, 0, 1)
	 * )
	 * //=> 1
	 */
	function differenceInISOWeekYears(dirtyDateLeft, dirtyDateRight) {
	  (0, _index5.default)(2, arguments);
	  var dateLeft = (0, _index.default)(dirtyDateLeft);
	  var dateRight = (0, _index.default)(dirtyDateRight);
	  var sign = (0, _index3.default)(dateLeft, dateRight);
	  var difference = Math.abs((0, _index2.default)(dateLeft, dateRight));
	  dateLeft = (0, _index4.default)(dateLeft, sign * difference); // Math.abs(diff in full ISO years - diff in calendar ISO years) === 1
	  // if last calendar ISO year is not full
	  // If so, result must be decreased by 1 in absolute value
	
	  var isLastISOWeekYearNotFull = (0, _index3.default)(dateLeft, dateRight) === -sign;
	  var result = sign * (difference - isLastISOWeekYearNotFull); // Prevent negative zero
	
	  return result === 0 ? 0 : result;
	}
	
	module.exports = exports.default;

/***/ },
/* 911 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = differenceInQuarters;
	
	var _index = _interopRequireDefault(__webpack_require__(140));
	
	var _index2 = _interopRequireDefault(__webpack_require__(2));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name differenceInQuarters
	 * @category Quarter Helpers
	 * @summary Get the number of full quarters between the given dates.
	 *
	 * @description
	 * Get the number of full quarters between the given dates.
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} dateLeft - the later date
	 * @param {Date|Number} dateRight - the earlier date
	 * @returns {Number} the number of full quarters
	 * @throws {TypeError} 2 arguments required
	 *
	 * @example
	 * // How many full quarters are between 31 December 2013 and 2 July 2014?
	 * var result = differenceInQuarters(new Date(2014, 6, 2), new Date(2013, 11, 31))
	 * //=> 2
	 */
	function differenceInQuarters(dirtyDateLeft, dirtyDateRight) {
	  (0, _index2.default)(2, arguments);
	  var diff = (0, _index.default)(dirtyDateLeft, dirtyDateRight) / 3;
	  return diff > 0 ? Math.floor(diff) : Math.ceil(diff);
	}
	
	module.exports = exports.default;

/***/ },
/* 912 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = differenceInWeeks;
	
	var _index = _interopRequireDefault(__webpack_require__(139));
	
	var _index2 = _interopRequireDefault(__webpack_require__(2));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name differenceInWeeks
	 * @category Week Helpers
	 * @summary Get the number of full weeks between the given dates.
	 *
	 * @description
	 * Get the number of full weeks between two dates. Fractional weeks are
	 * truncated towards zero.
	 *
	 * One "full week" is the distance between a local time in one day to the same
	 * local time 7 days earlier or later. A full week can sometimes be less than
	 * or more than 7*24 hours if a daylight savings change happens between two dates.
	 *
	 * To ignore DST and only measure exact 7*24-hour periods, use this instead:
	 * `Math.floor(differenceInHours(dateLeft, dateRight)/(7*24))|0`.
	 *
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} dateLeft - the later date
	 * @param {Date|Number} dateRight - the earlier date
	 * @returns {Number} the number of full weeks
	 * @throws {TypeError} 2 arguments required
	 *
	 * @example
	 * // How many full weeks are between 5 July 2014 and 20 July 2014?
	 * var result = differenceInWeeks(new Date(2014, 6, 20), new Date(2014, 6, 5))
	 * //=> 2
	 *
	 * // How many full weeks are between
	 * // 1 March 2020 0:00 and 6 June 2020 0:00 ?
	 * // Note: because local time is used, the
	 * // result will always be 8 weeks (54 days),
	 * // even if DST starts and the period has
	 * // only 54*24-1 hours.
	 * var result = differenceInWeeks(
	 *   new Date(2020, 5, 1),
	 *   new Date(2020, 2, 6)
	 * )
	 * //=> 8
	 */
	function differenceInWeeks(dirtyDateLeft, dirtyDateRight) {
	  (0, _index2.default)(2, arguments);
	  var diff = (0, _index.default)(dirtyDateLeft, dirtyDateRight) / 7;
	  return diff > 0 ? Math.floor(diff) : Math.ceil(diff);
	}
	
	module.exports = exports.default;

/***/ },
/* 913 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = eachHourOfInterval;
	
	var _index = _interopRequireDefault(__webpack_require__(181));
	
	var _index2 = _interopRequireDefault(__webpack_require__(3));
	
	var _index3 = _interopRequireDefault(__webpack_require__(2));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name eachHourOfInterval
	 * @category Interval Helpers
	 * @summary Return the array of hours within the specified time interval.
	 *
	 * @description
	 * Return the array of hours within the specified time interval.
	 *
	 * @param {Interval} interval - the interval. See [Interval]{@link docs/types/Interval}
	 * @param {Object} [options] - an object with options.
	 * @param {Number} [options.step=1] - the step to increment by. The value should be more than 1.
	 * @returns {Date[]} the array with starts of hours from the hour of the interval start to the hour of the interval end
	 * @throws {TypeError} 1 argument required
	 * @throws {RangeError} `options.step` must be a number greater than 1
	 * @throws {RangeError} The start of an interval cannot be after its end
	 * @throws {RangeError} Date in interval cannot be `Invalid Date`
	 *
	 * @example
	 * // Each hour between 6 October 2014, 12:00 and 10 October 2014, 15:00
	 * var result = eachHourOfInterval({
	 *   start: new Date(2014, 9, 6, 12),
	 *   end: new Date(2014, 9, 6, 15)
	 * })
	 * //=> [
	 * //   Mon Oct 06 2014 12:00:00,
	 * //   Mon Oct 06 2014 13:00:00,
	 * //   Mon Oct 06 2014 14:00:00,
	 * //   Mon Oct 06 2014 15:00:00
	 * // ]
	 */
	function eachHourOfInterval(dirtyInterval, options) {
	  (0, _index3.default)(1, arguments);
	  var interval = dirtyInterval || {};
	  var startDate = (0, _index2.default)(interval.start);
	  var endDate = (0, _index2.default)(interval.end);
	  var startTime = startDate.getTime();
	  var endTime = endDate.getTime(); // Throw an exception if start date is after end date or if any date is `Invalid Date`
	
	  if (!(startTime <= endTime)) {
	    throw new RangeError('Invalid interval');
	  }
	
	  var dates = [];
	  var currentDate = startDate;
	  currentDate.setMinutes(0, 0, 0);
	  var step = options && 'step' in options ? Number(options.step) : 1;
	  if (step < 1 || isNaN(step)) throw new RangeError('`options.step` must be a number greater than 1');
	
	  while (currentDate.getTime() <= endTime) {
	    dates.push((0, _index2.default)(currentDate));
	    currentDate = (0, _index.default)(currentDate, step);
	  }
	
	  return dates;
	}
	
	module.exports = exports.default;

/***/ },
/* 914 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = eachMonthOfInterval;
	
	var _index = _interopRequireDefault(__webpack_require__(3));
	
	var _index2 = _interopRequireDefault(__webpack_require__(2));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name eachMonthOfInterval
	 * @category Interval Helpers
	 * @summary Return the array of months within the specified time interval.
	 *
	 * @description
	 * Return the array of months within the specified time interval.
	 *
	 * @param {Interval} interval - the interval. See [Interval]{@link docs/types/Interval}
	 * @returns {Date[]} the array with starts of months from the month of the interval start to the month of the interval end
	 * @throws {TypeError} 1 argument required
	 * @throws {RangeError} The start of an interval cannot be after its end
	 * @throws {RangeError} Date in interval cannot be `Invalid Date`
	 *
	 * @example
	 * // Each month between 6 February 2014 and 10 August 2014:
	 * var result = eachMonthOfInterval({
	 *   start: new Date(2014, 1, 6),
	 *   end: new Date(2014, 7, 10)
	 * })
	 * //=> [
	 * //   Sat Feb 01 2014 00:00:00,
	 * //   Sat Mar 01 2014 00:00:00,
	 * //   Tue Apr 01 2014 00:00:00,
	 * //   Thu May 01 2014 00:00:00,
	 * //   Sun Jun 01 2014 00:00:00,
	 * //   Tue Jul 01 2014 00:00:00,
	 * //   Fri Aug 01 2014 00:00:00
	 * // ]
	 */
	function eachMonthOfInterval(dirtyInterval) {
	  (0, _index2.default)(1, arguments);
	  var interval = dirtyInterval || {};
	  var startDate = (0, _index.default)(interval.start);
	  var endDate = (0, _index.default)(interval.end);
	  var endTime = endDate.getTime(); // Throw an exception if start date is after end date or if any date is `Invalid Date`
	
	  if (!(startDate.getTime() <= endTime)) {
	    throw new RangeError('Invalid interval');
	  }
	
	  var dates = [];
	  var currentDate = startDate;
	  currentDate.setHours(0, 0, 0, 0);
	  currentDate.setDate(1);
	
	  while (currentDate.getTime() <= endTime) {
	    dates.push((0, _index.default)(currentDate));
	    currentDate.setMonth(currentDate.getMonth() + 1);
	  }
	
	  return dates;
	}
	
	module.exports = exports.default;

/***/ },
/* 915 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = eachQuarterOfInterval;
	
	var _index = _interopRequireDefault(__webpack_require__(262));
	
	var _index2 = _interopRequireDefault(__webpack_require__(190));
	
	var _index3 = _interopRequireDefault(__webpack_require__(3));
	
	var _index4 = _interopRequireDefault(__webpack_require__(2));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name eachQuarterOfInterval
	 * @category Interval Helpers
	 * @summary Return the array of quarters within the specified time interval.
	 *
	 * @description
	 * Return the array of quarters within the specified time interval.
	 *
	 * @param {Interval} interval - the interval. See [Interval]{@link docs/types/Interval}
	 * @returns {Date[]} the array with starts of quarters from the quarter of the interval start to the quarter of the interval end
	 * @throws {TypeError} 1 argument required
	 * @throws {RangeError} The start of an interval cannot be after its end
	 * @throws {RangeError} Date in interval cannot be `Invalid Date`
	 *
	 * @example
	 * // Each quarter within interval 6 February 2014 - 10 August 2014:
	 * var result = eachQuarterOfInterval({
	 *   start: new Date(2014, 1, 6),
	 *   end: new Date(2014, 7, 10)
	 * })
	 * //=> [
	 * //   Wed Jan 01 2014 00:00:00,
	 * //   Tue Apr 01 2014 00:00:00,
	 * //   Tue Jul 01 2014 00:00:00,
	 * // ]
	 */
	function eachQuarterOfInterval(dirtyInterval) {
	  (0, _index4.default)(1, arguments);
	  var interval = dirtyInterval || {};
	  var startDate = (0, _index3.default)(interval.start);
	  var endDate = (0, _index3.default)(interval.end);
	  var endTime = endDate.getTime(); // Throw an exception if start date is after end date or if any date is `Invalid Date`
	
	  if (!(startDate.getTime() <= endTime)) {
	    throw new RangeError('Invalid interval');
	  }
	
	  var startDateQuarter = (0, _index2.default)(startDate);
	  var endDateQuarter = (0, _index2.default)(endDate);
	  endTime = endDateQuarter.getTime();
	  var quarters = [];
	  var currentQuarter = startDateQuarter;
	
	  while (currentQuarter.getTime() <= endTime) {
	    quarters.push((0, _index3.default)(currentQuarter));
	    currentQuarter = (0, _index.default)(currentQuarter, 1);
	  }
	
	  return quarters;
	}
	
	module.exports = exports.default;

/***/ },
/* 916 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = eachWeekOfInterval;
	
	var _index = _interopRequireDefault(__webpack_require__(138));
	
	var _index2 = _interopRequireDefault(__webpack_require__(75));
	
	var _index3 = _interopRequireDefault(__webpack_require__(3));
	
	var _index4 = _interopRequireDefault(__webpack_require__(2));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name eachWeekOfInterval
	 * @category Interval Helpers
	 * @summary Return the array of weeks within the specified time interval.
	 *
	 * @description
	 * Return the array of weeks within the specified time interval.
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Interval} interval - the interval. See [Interval]{@link docs/types/Interval}
	 * @param {Object} [options] - an object with options.
	 * @param {Locale} [options.locale=defaultLocale] - the locale object. See [Locale]{@link https://date-fns.org/docs/Locale}
	 * @param {0|1|2|3|4|5|6} [options.weekStartsOn=0] - the index of the first day of the week (0 - Sunday)
	 * @returns {Date[]} the array with starts of weeks from the week of the interval start to the week of the interval end
	 * @throws {TypeError} 1 argument required
	 * @throws {RangeError} `options.weekStartsOn` must be 0, 1, ..., 6
	 * @throws {RangeError} The start of an interval cannot be after its end
	 * @throws {RangeError} Date in interval cannot be `Invalid Date`
	 *
	 * @example
	 * // Each week within interval 6 October 2014 - 23 November 2014:
	 * var result = eachWeekOfInterval({
	 *   start: new Date(2014, 9, 6),
	 *   end: new Date(2014, 10, 23)
	 * })
	 * //=> [
	 * //   Sun Oct 05 2014 00:00:00,
	 * //   Sun Oct 12 2014 00:00:00,
	 * //   Sun Oct 19 2014 00:00:00,
	 * //   Sun Oct 26 2014 00:00:00,
	 * //   Sun Nov 02 2014 00:00:00,
	 * //   Sun Nov 09 2014 00:00:00,
	 * //   Sun Nov 16 2014 00:00:00,
	 * //   Sun Nov 23 2014 00:00:00
	 * // ]
	 */
	function eachWeekOfInterval(dirtyInterval, options) {
	  (0, _index4.default)(1, arguments);
	  var interval = dirtyInterval || {};
	  var startDate = (0, _index3.default)(interval.start);
	  var endDate = (0, _index3.default)(interval.end);
	  var endTime = endDate.getTime(); // Throw an exception if start date is after end date or if any date is `Invalid Date`
	
	  if (!(startDate.getTime() <= endTime)) {
	    throw new RangeError('Invalid interval');
	  }
	
	  var startDateWeek = (0, _index2.default)(startDate, options);
	  var endDateWeek = (0, _index2.default)(endDate, options); // Some timezones switch DST at midnight, making start of day unreliable in these timezones, 3pm is a safe bet
	
	  startDateWeek.setHours(15);
	  endDateWeek.setHours(15);
	  endTime = endDateWeek.getTime();
	  var weeks = [];
	  var currentWeek = startDateWeek;
	
	  while (currentWeek.getTime() <= endTime) {
	    currentWeek.setHours(0);
	    weeks.push((0, _index3.default)(currentWeek));
	    currentWeek = (0, _index.default)(currentWeek, 1);
	    currentWeek.setHours(15);
	  }
	
	  return weeks;
	}
	
	module.exports = exports.default;

/***/ },
/* 917 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = eachWeekendOfMonth;
	
	var _index = _interopRequireDefault(__webpack_require__(267));
	
	var _index2 = _interopRequireDefault(__webpack_require__(142));
	
	var _index3 = _interopRequireDefault(__webpack_require__(185));
	
	var _index4 = _interopRequireDefault(__webpack_require__(2));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name eachWeekendOfMonth
	 * @category Month Helpers
	 * @summary List all the Saturdays and Sundays in the given month.
	 *
	 * @description
	 * Get all the Saturdays and Sundays in the given month.
	 *
	 * @param {Date|Number} date - the given month
	 * @returns {Date[]} an array containing all the Saturdays and Sundays
	 * @throws {TypeError} 1 argument required
	 * @throws {RangeError} The passed date is invalid
	 *
	 * @example
	 * // Lists all Saturdays and Sundays in the given month
	 * var result = eachWeekendOfMonth(new Date(2022, 1, 1))
	 * //=> [
	 * //   Sat Feb 05 2022 00:00:00,
	 * //   Sun Feb 06 2022 00:00:00,
	 * //   Sat Feb 12 2022 00:00:00,
	 * //   Sun Feb 13 2022 00:00:00,
	 * //   Sat Feb 19 2022 00:00:00,
	 * //   Sun Feb 20 2022 00:00:00,
	 * //   Sat Feb 26 2022 00:00:00,
	 * //   Sun Feb 27 2022 00:00:00
	 * // ]
	 */
	function eachWeekendOfMonth(dirtyDate) {
	  (0, _index4.default)(1, arguments);
	  var startDate = (0, _index2.default)(dirtyDate);
	  if (isNaN(startDate)) throw new RangeError('The passed date is invalid');
	  var endDate = (0, _index3.default)(dirtyDate);
	  return (0, _index.default)({
	    start: startDate,
	    end: endDate
	  });
	}
	
	module.exports = exports.default;

/***/ },
/* 918 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = eachWeekendOfYear;
	
	var _index = _interopRequireDefault(__webpack_require__(267));
	
	var _index2 = _interopRequireDefault(__webpack_require__(191));
	
	var _index3 = _interopRequireDefault(__webpack_require__(405));
	
	var _index4 = _interopRequireDefault(__webpack_require__(2));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name eachWeekendOfYear
	 * @category Year Helpers
	 * @summary List all the Saturdays and Sundays in the year.
	 *
	 * @description
	 * Get all the Saturdays and Sundays in the year.
	 *
	 * @param {Date|Number} date - the given year
	 * @returns {Date[]} an array containing all the Saturdays and Sundays
	 * @throws {TypeError} 1 argument required
	 * @throws {RangeError} The passed date is invalid
	 *
	 * @example
	 * // Lists all Saturdays and Sundays in the year
	 * var result = eachWeekendOfYear(new Date(2020, 1, 1))
	 * //=> [
	 * //   Sat Jan 03 2020 00:00:00,
	 * //   Sun Jan 04 2020 00:00:00,
	 * //   ...
	 * //   Sun Dec 27 2020 00:00:00
	 * // ]
	 * ]
	 */
	function eachWeekendOfYear(dirtyDate) {
	  (0, _index4.default)(1, arguments);
	  var startDate = (0, _index2.default)(dirtyDate);
	  if (isNaN(startDate)) throw new RangeError('The passed date is invalid');
	  var endDate = (0, _index3.default)(dirtyDate);
	  return (0, _index.default)({
	    start: startDate,
	    end: endDate
	  });
	}
	
	module.exports = exports.default;

/***/ },
/* 919 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = eachYearOfInterval;
	
	var _index = _interopRequireDefault(__webpack_require__(3));
	
	var _index2 = _interopRequireDefault(__webpack_require__(2));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name eachYearOfInterval
	 * @category Interval Helpers
	 * @summary Return the array of yearly timestamps within the specified time interval.
	 *
	 * @description
	 * Return the array of yearly timestamps within the specified time interval.
	 *
	 * @param {Interval} interval - the interval. See [Interval]{@link docs/types/Interval}
	 * @returns {Date[]} the array with starts of yearly timestamps from the month of the interval start to the month of the interval end
	 * @throws {TypeError} 1 argument required
	 * @throws {RangeError} The start of an interval cannot be after its end
	 * @throws {RangeError} Date in interval cannot be `Invalid Date`
	 *
	 * @example
	 * // Each year between 6 February 2014 and 10 August 2017:
	 * var result = eachYearOfInterval({
	 *   start: new Date(2014, 1, 6),
	 *   end: new Date(2017, 7, 10)
	 * })
	 * //=> [
	 * //   Wed Jan 01 2014 00:00:00,
	 * //   Thu Jan 01 2015 00:00:00,
	 * //   Fri Jan 01 2016 00:00:00,
	 * //   Sun Jan 01 2017 00:00:00
	 * // ]
	 */
	function eachYearOfInterval(dirtyInterval) {
	  (0, _index2.default)(1, arguments);
	  var interval = dirtyInterval || {};
	  var startDate = (0, _index.default)(interval.start);
	  var endDate = (0, _index.default)(interval.end);
	  var endTime = endDate.getTime(); // Throw an exception if start date is after end date or if any date is `Invalid Date`
	
	  if (!(startDate.getTime() <= endTime)) {
	    throw new RangeError('Invalid interval');
	  }
	
	  var dates = [];
	  var currentDate = startDate;
	  currentDate.setHours(0, 0, 0, 0);
	  currentDate.setMonth(0, 1);
	
	  while (currentDate.getTime() <= endTime) {
	    dates.push((0, _index.default)(currentDate));
	    currentDate.setFullYear(currentDate.getFullYear() + 1);
	  }
	
	  return dates;
	}
	
	module.exports = exports.default;

/***/ },
/* 920 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = endOfDecade;
	
	var _index = _interopRequireDefault(__webpack_require__(3));
	
	var _index2 = _interopRequireDefault(__webpack_require__(2));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name endOfDecade
	 * @category Decade Helpers
	 * @summary Return the end of a decade for the given date.
	 *
	 * @description
	 * Return the end of a decade for the given date.
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} date - the original date
	 * @returns {Date} the end of a decade
	 * @param {Object} [options] - an object with options.
	 * @param {0|1|2} [options.additionalDigits=2] - passed to `toDate`. See [toDate]{@link https://date-fns.org/docs/toDate}
	 * @throws {TypeError} 1 argument required
	 * @throws {RangeError} `options.additionalDigits` must be 0, 1 or 2
	 *
	 * @example
	 * // The end of a decade for 12 May 1984 00:00:00:
	 * var result = endOfDecade(new Date(1984, 4, 12, 00, 00, 00))
	 * //=> Dec 31 1989 23:59:59.999
	 */
	function endOfDecade(dirtyDate) {
	  (0, _index2.default)(1, arguments);
	  var date = (0, _index.default)(dirtyDate);
	  var year = date.getFullYear();
	  var decade = 9 + Math.floor(year / 10) * 10;
	  date.setFullYear(decade, 11, 31);
	  date.setHours(23, 59, 59, 999);
	  return date;
	}
	
	module.exports = exports.default;

/***/ },
/* 921 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = endOfHour;
	
	var _index = _interopRequireDefault(__webpack_require__(3));
	
	var _index2 = _interopRequireDefault(__webpack_require__(2));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name endOfHour
	 * @category Hour Helpers
	 * @summary Return the end of an hour for the given date.
	 *
	 * @description
	 * Return the end of an hour for the given date.
	 * The result will be in the local timezone.
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} date - the original date
	 * @returns {Date} the end of an hour
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // The end of an hour for 2 September 2014 11:55:00:
	 * var result = endOfHour(new Date(2014, 8, 2, 11, 55))
	 * //=> Tue Sep 02 2014 11:59:59.999
	 */
	function endOfHour(dirtyDate) {
	  (0, _index2.default)(1, arguments);
	  var date = (0, _index.default)(dirtyDate);
	  date.setMinutes(59, 59, 999);
	  return date;
	}
	
	module.exports = exports.default;

/***/ },
/* 922 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = endOfISOWeekYear;
	
	var _index = _interopRequireDefault(__webpack_require__(113));
	
	var _index2 = _interopRequireDefault(__webpack_require__(99));
	
	var _index3 = _interopRequireDefault(__webpack_require__(2));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name endOfISOWeekYear
	 * @category ISO Week-Numbering Year Helpers
	 * @summary Return the end of an ISO week-numbering year for the given date.
	 *
	 * @description
	 * Return the end of an ISO week-numbering year,
	 * which always starts 3 days before the year's first Thursday.
	 * The result will be in the local timezone.
	 *
	 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * - The function was renamed from `endOfISOYear` to `endOfISOWeekYear`.
	 *   "ISO week year" is short for [ISO week-numbering year](https://en.wikipedia.org/wiki/ISO_week_date).
	 *   This change makes the name consistent with
	 *   locale-dependent week-numbering year helpers, e.g., `addWeekYears`.
	 *
	 * @param {Date|Number} date - the original date
	 * @returns {Date} the end of an ISO week-numbering year
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // The end of an ISO week-numbering year for 2 July 2005:
	 * var result = endOfISOWeekYear(new Date(2005, 6, 2))
	 * //=> Sun Jan 01 2006 23:59:59.999
	 */
	function endOfISOWeekYear(dirtyDate) {
	  (0, _index3.default)(1, arguments);
	  var year = (0, _index.default)(dirtyDate);
	  var fourthOfJanuaryOfNextYear = new Date(0);
	  fourthOfJanuaryOfNextYear.setFullYear(year + 1, 0, 4);
	  fourthOfJanuaryOfNextYear.setHours(0, 0, 0, 0);
	  var date = (0, _index2.default)(fourthOfJanuaryOfNextYear);
	  date.setMilliseconds(date.getMilliseconds() - 1);
	  return date;
	}
	
	module.exports = exports.default;

/***/ },
/* 923 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = endOfISOWeek;
	
	var _index = _interopRequireDefault(__webpack_require__(268));
	
	var _index2 = _interopRequireDefault(__webpack_require__(2));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name endOfISOWeek
	 * @category ISO Week Helpers
	 * @summary Return the end of an ISO week for the given date.
	 *
	 * @description
	 * Return the end of an ISO week for the given date.
	 * The result will be in the local timezone.
	 *
	 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} date - the original date
	 * @returns {Date} the end of an ISO week
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // The end of an ISO week for 2 September 2014 11:55:00:
	 * var result = endOfISOWeek(new Date(2014, 8, 2, 11, 55, 0))
	 * //=> Sun Sep 07 2014 23:59:59.999
	 */
	function endOfISOWeek(dirtyDate) {
	  (0, _index2.default)(1, arguments);
	  return (0, _index.default)(dirtyDate, {
	    weekStartsOn: 1
	  });
	}
	
	module.exports = exports.default;

/***/ },
/* 924 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = endOfMinute;
	
	var _index = _interopRequireDefault(__webpack_require__(3));
	
	var _index2 = _interopRequireDefault(__webpack_require__(2));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name endOfMinute
	 * @category Minute Helpers
	 * @summary Return the end of a minute for the given date.
	 *
	 * @description
	 * Return the end of a minute for the given date.
	 * The result will be in the local timezone.
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} date - the original date
	 * @returns {Date} the end of a minute
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // The end of a minute for 1 December 2014 22:15:45.400:
	 * var result = endOfMinute(new Date(2014, 11, 1, 22, 15, 45, 400))
	 * //=> Mon Dec 01 2014 22:15:59.999
	 */
	function endOfMinute(dirtyDate) {
	  (0, _index2.default)(1, arguments);
	  var date = (0, _index.default)(dirtyDate);
	  date.setSeconds(59, 999);
	  return date;
	}
	
	module.exports = exports.default;

/***/ },
/* 925 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = endOfQuarter;
	
	var _index = _interopRequireDefault(__webpack_require__(3));
	
	var _index2 = _interopRequireDefault(__webpack_require__(2));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name endOfQuarter
	 * @category Quarter Helpers
	 * @summary Return the end of a year quarter for the given date.
	 *
	 * @description
	 * Return the end of a year quarter for the given date.
	 * The result will be in the local timezone.
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} date - the original date
	 * @returns {Date} the end of a quarter
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // The end of a quarter for 2 September 2014 11:55:00:
	 * var result = endOfQuarter(new Date(2014, 8, 2, 11, 55, 0))
	 * //=> Tue Sep 30 2014 23:59:59.999
	 */
	function endOfQuarter(dirtyDate) {
	  (0, _index2.default)(1, arguments);
	  var date = (0, _index.default)(dirtyDate);
	  var currentMonth = date.getMonth();
	  var month = currentMonth - currentMonth % 3 + 3;
	  date.setMonth(month, 0);
	  date.setHours(23, 59, 59, 999);
	  return date;
	}
	
	module.exports = exports.default;

/***/ },
/* 926 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = endOfSecond;
	
	var _index = _interopRequireDefault(__webpack_require__(3));
	
	var _index2 = _interopRequireDefault(__webpack_require__(2));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name endOfSecond
	 * @category Second Helpers
	 * @summary Return the end of a second for the given date.
	 *
	 * @description
	 * Return the end of a second for the given date.
	 * The result will be in the local timezone.
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} date - the original date
	 * @returns {Date} the end of a second
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // The end of a second for 1 December 2014 22:15:45.400:
	 * var result = endOfSecond(new Date(2014, 11, 1, 22, 15, 45, 400))
	 * //=> Mon Dec 01 2014 22:15:45.999
	 */
	function endOfSecond(dirtyDate) {
	  (0, _index2.default)(1, arguments);
	  var date = (0, _index.default)(dirtyDate);
	  date.setMilliseconds(999);
	  return date;
	}
	
	module.exports = exports.default;

/***/ },
/* 927 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = endOfToday;
	
	var _index = _interopRequireDefault(__webpack_require__(184));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name endOfToday
	 * @category Day Helpers
	 * @summary Return the end of today.
	 * @pure false
	 *
	 * @description
	 * Return the end of today.
	 *
	 * > ⚠️ Please note that this function is not present in the FP submodule as
	 * > it uses `Date.now()` internally hence impure and can't be safely curried.
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @returns {Date} the end of today
	 *
	 * @example
	 * // If today is 6 October 2014:
	 * var result = endOfToday()
	 * //=> Mon Oct 6 2014 23:59:59.999
	 */
	function endOfToday() {
	  return (0, _index.default)(Date.now());
	}
	
	module.exports = exports.default;

/***/ },
/* 928 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = endOfTomorrow;
	
	/**
	 * @name endOfTomorrow
	 * @category Day Helpers
	 * @summary Return the end of tomorrow.
	 * @pure false
	 *
	 * @description
	 * Return the end of tomorrow.
	 *
	 * > ⚠️ Please note that this function is not present in the FP submodule as
	 * > it uses `new Date()` internally hence impure and can't be safely curried.
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @returns {Date} the end of tomorrow
	 *
	 * @example
	 * // If today is 6 October 2014:
	 * var result = endOfTomorrow()
	 * //=> Tue Oct 7 2014 23:59:59.999
	 */
	function endOfTomorrow() {
	  var now = new Date();
	  var year = now.getFullYear();
	  var month = now.getMonth();
	  var day = now.getDate();
	  var date = new Date(0);
	  date.setFullYear(year, month, day + 1);
	  date.setHours(23, 59, 59, 999);
	  return date;
	}
	
	module.exports = exports.default;

/***/ },
/* 929 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = endOfYesterday;
	
	/**
	 * @name endOfYesterday
	 * @category Day Helpers
	 * @summary Return the end of yesterday.
	 * @pure false
	 *
	 * @description
	 * Return the end of yesterday.
	 *
	 * > ⚠️ Please note that this function is not present in the FP submodule as
	 * > it uses `new Date()` internally hence impure and can't be safely curried.
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @returns {Date} the end of yesterday
	 *
	 * @example
	 * // If today is 6 October 2014:
	 * var result = endOfYesterday()
	 * //=> Sun Oct 5 2014 23:59:59.999
	 */
	function endOfYesterday() {
	  var now = new Date();
	  var year = now.getFullYear();
	  var month = now.getMonth();
	  var day = now.getDate();
	  var date = new Date(0);
	  date.setFullYear(year, month, day - 1);
	  date.setHours(23, 59, 59, 999);
	  return date;
	}
	
	module.exports = exports.default;

/***/ },
/* 930 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = formatDistanceToNowStrict;
	
	var _index = _interopRequireDefault(__webpack_require__(406));
	
	var _index2 = _interopRequireDefault(__webpack_require__(2));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name formatDistanceToNowStrict
	 * @category Common Helpers
	 * @summary Return the distance between the given date and now in words.
	 * @pure false
	 *
	 * @description
	 * Return the distance between the given dates in words, using strict units.
	 * This is like `formatDistance`, but does not use helpers like 'almost', 'over',
	 * 'less than' and the like.
	 *
	 * | Distance between dates | Result              |
	 * |------------------------|---------------------|
	 * | 0 ... 59 secs          | [0..59] seconds     |
	 * | 1 ... 59 mins          | [1..59] minutes     |
	 * | 1 ... 23 hrs           | [1..23] hours       |
	 * | 1 ... 29 days          | [1..29] days        |
	 * | 1 ... 11 months        | [1..11] months      |
	 * | 1 ... N years          | [1..N]  years       |
	 *
	 * @param {Date|Number} date - the given date
	 * @param {Object} [options] - an object with options.
	 * @param {Boolean} [options.addSuffix=false] - result indicates if the second date is earlier or later than the first
	 * @param {'second'|'minute'|'hour'|'day'|'month'|'year'} [options.unit] - if specified, will force a unit
	 * @param {'floor'|'ceil'|'round'} [options.roundingMethod='round'] - which way to round partial units
	 * @param {Locale} [options.locale=defaultLocale] - the locale object. See [Locale]{@link https://date-fns.org/docs/Locale}
	 * @returns {String} the distance in words
	 * @throws {TypeError} 1 argument required
	 * @throws {RangeError} `date` must not be Invalid Date
	 * @throws {RangeError} `options.locale` must contain `formatDistance` property
	 *
	 * @example
	 * // If today is 1 January 2015, what is the distance to 2 July 2014?
	 * var result = formatDistanceToNowStrict(
	 *   new Date(2014, 6, 2)
	 * )
	 * //=> '6 months'
	 *
	 * @example
	 * // If now is 1 January 2015 00:00:00,
	 * // what is the distance to 1 January 2015 00:00:15, including seconds?
	 * var result = formatDistanceToNowStrict(
	 *   new Date(2015, 0, 1, 0, 0, 15)
	 * )
	 * //=> '20 seconds'
	 *
	 * @example
	 * // If today is 1 January 2015,
	 * // what is the distance to 1 January 2016, with a suffix?
	 * var result = formatDistanceToNowStrict(
	 *   new Date(2016, 0, 1),
	 *   {addSuffix: true}
	 * )
	 * //=> 'in 1 year'
	 *
	 * @example
	 * // If today is 28 January 2015,
	 * // what is the distance to 1 January 2015, in months, rounded up??
	 * var result = formatDistanceToNowStrict(new Date(2015, 0, 1), {
	 *   unit: 'month',
	 *   roundingMethod: 'ceil'
	 * })
	 * //=> '1 month'
	 *
	 * @example
	 * // If today is 1 January 2015,
	 * // what is the distance to 1 August 2016 in Esperanto?
	 * var eoLocale = require('date-fns/locale/eo')
	 * var result = formatDistanceToNowStrict(
	 *   new Date(2016, 7, 1),
	 *   {locale: eoLocale}
	 * )
	 * //=> '1 jaro'
	 */
	function formatDistanceToNowStrict(dirtyDate, dirtyOptions) {
	  (0, _index2.default)(1, arguments);
	  return (0, _index.default)(dirtyDate, Date.now(), dirtyOptions);
	}
	
	module.exports = exports.default;

/***/ },
/* 931 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = formatDistanceToNow;
	
	var _index = _interopRequireDefault(__webpack_require__(407));
	
	var _index2 = _interopRequireDefault(__webpack_require__(2));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name formatDistanceToNow
	 * @category Common Helpers
	 * @summary Return the distance between the given date and now in words.
	 * @pure false
	 *
	 * @description
	 * Return the distance between the given date and now in words.
	 *
	 * | Distance to now                                                   | Result              |
	 * |-------------------------------------------------------------------|---------------------|
	 * | 0 ... 30 secs                                                     | less than a minute  |
	 * | 30 secs ... 1 min 30 secs                                         | 1 minute            |
	 * | 1 min 30 secs ... 44 mins 30 secs                                 | [2..44] minutes     |
	 * | 44 mins ... 30 secs ... 89 mins 30 secs                           | about 1 hour        |
	 * | 89 mins 30 secs ... 23 hrs 59 mins 30 secs                        | about [2..24] hours |
	 * | 23 hrs 59 mins 30 secs ... 41 hrs 59 mins 30 secs                 | 1 day               |
	 * | 41 hrs 59 mins 30 secs ... 29 days 23 hrs 59 mins 30 secs         | [2..30] days        |
	 * | 29 days 23 hrs 59 mins 30 secs ... 44 days 23 hrs 59 mins 30 secs | about 1 month       |
	 * | 44 days 23 hrs 59 mins 30 secs ... 59 days 23 hrs 59 mins 30 secs | about 2 months      |
	 * | 59 days 23 hrs 59 mins 30 secs ... 1 yr                           | [2..12] months      |
	 * | 1 yr ... 1 yr 3 months                                            | about 1 year        |
	 * | 1 yr 3 months ... 1 yr 9 month s                                  | over 1 year         |
	 * | 1 yr 9 months ... 2 yrs                                           | almost 2 years      |
	 * | N yrs ... N yrs 3 months                                          | about N years       |
	 * | N yrs 3 months ... N yrs 9 months                                 | over N years        |
	 * | N yrs 9 months ... N+1 yrs                                        | almost N+1 years    |
	 *
	 * With `options.includeSeconds == true`:
	 * | Distance to now     | Result               |
	 * |---------------------|----------------------|
	 * | 0 secs ... 5 secs   | less than 5 seconds  |
	 * | 5 secs ... 10 secs  | less than 10 seconds |
	 * | 10 secs ... 20 secs | less than 20 seconds |
	 * | 20 secs ... 40 secs | half a minute        |
	 * | 40 secs ... 60 secs | less than a minute   |
	 * | 60 secs ... 90 secs | 1 minute             |
	 *
	 * > ⚠️ Please note that this function is not present in the FP submodule as
	 * > it uses `Date.now()` internally hence impure and can't be safely curried.
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * - The function was renamed from `distanceInWordsToNow ` to `formatDistanceToNow`
	 *   to make its name consistent with `format` and `formatRelative`.
	 *
	 *   ```javascript
	 *   // Before v2.0.0
	 *
	 *   distanceInWordsToNow(new Date(2014, 6, 2), { addSuffix: true })
	 *   //=> 'in 6 months'
	 *
	 *   // v2.0.0 onward
	 *
	 *   formatDistanceToNow(new Date(2014, 6, 2), { addSuffix: true })
	 *   //=> 'in 6 months'
	 *   ```
	 *
	 * @param {Date|Number} date - the given date
	 * @param {Object} [options] - the object with options
	 * @param {Boolean} [options.includeSeconds=false] - distances less than a minute are more detailed
	 * @param {Boolean} [options.addSuffix=false] - result specifies if now is earlier or later than the passed date
	 * @param {Locale} [options.locale=defaultLocale] - the locale object. See [Locale]{@link https://date-fns.org/docs/Locale}
	 * @returns {String} the distance in words
	 * @throws {TypeError} 1 argument required
	 * @throws {RangeError} `date` must not be Invalid Date
	 * @throws {RangeError} `options.locale` must contain `formatDistance` property
	 *
	 * @example
	 * // If today is 1 January 2015, what is the distance to 2 July 2014?
	 * var result = formatDistanceToNow(
	 *   new Date(2014, 6, 2)
	 * )
	 * //=> '6 months'
	 *
	 * @example
	 * // If now is 1 January 2015 00:00:00,
	 * // what is the distance to 1 January 2015 00:00:15, including seconds?
	 * var result = formatDistanceToNow(
	 *   new Date(2015, 0, 1, 0, 0, 15),
	 *   {includeSeconds: true}
	 * )
	 * //=> 'less than 20 seconds'
	 *
	 * @example
	 * // If today is 1 January 2015,
	 * // what is the distance to 1 January 2016, with a suffix?
	 * var result = formatDistanceToNow(
	 *   new Date(2016, 0, 1),
	 *   {addSuffix: true}
	 * )
	 * //=> 'in about 1 year'
	 *
	 * @example
	 * // If today is 1 January 2015,
	 * // what is the distance to 1 August 2016 in Esperanto?
	 * var eoLocale = require('date-fns/locale/eo')
	 * var result = formatDistanceToNow(
	 *   new Date(2016, 7, 1),
	 *   {locale: eoLocale}
	 * )
	 * //=> 'pli ol 1 jaro'
	 */
	function formatDistanceToNow(dirtyDate, dirtyOptions) {
	  (0, _index2.default)(1, arguments);
	  return (0, _index.default)(dirtyDate, Date.now(), dirtyOptions);
	}
	
	module.exports = exports.default;

/***/ },
/* 932 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = formatDuration;
	
	var _index = _interopRequireDefault(__webpack_require__(115));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var defaultFormat = ['years', 'months', 'weeks', 'days', 'hours', 'minutes', 'seconds'];
	/**
	 * @name formatDuration
	 * @category Common Helpers
	 * @summary Formats a duration in human-readable format
	 *
	 * @description
	 * Return human-readable duration string i.e. "9 months 2 days"
	 *
	 * @param {Duration} duration - the duration to format
	 * @param {Object} [options] - an object with options.
	
	 * @param {string[]} [options.format=['years', 'months', 'weeks', 'days', 'hours', 'minutes', 'seconds']] - the array of units to format
	 * @param {boolean} [options.zero=false] - should be zeros be included in the output?
	 * @param {string} [options.delimiter=' '] - delimiter string
	 * @returns {string} the formatted date string
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // Format full duration
	 * formatDuration({
	 *   years: 2,
	 *   months: 9,
	 *   weeks: 1,
	 *   days: 7,
	 *   hours: 5,
	 *   minutes: 9,
	 *   seconds: 30
	 * })
	 * //=> '2 years 9 months 1 week 7 days 5 hours 9 minutes 30 seconds
	 *
	 * @example
	 * // Format partial duration
	 * formatDuration({ months: 9, days: 2 })
	 * //=> '9 months 2 days'
	 *
	 * @example
	 * // Customize the format
	 * formatDuration(
	 *   {
	 *     years: 2,
	 *     months: 9,
	 *     weeks: 1,
	 *     days: 7,
	 *     hours: 5,
	 *     minutes: 9,
	 *     seconds: 30
	 *   },
	 *   { format: ['months', 'weeks'] }
	 * ) === '9 months 1 week'
	 *
	 * @example
	 * // Customize the zeros presence
	 * formatDuration({ years: 0, months: 9 })
	 * //=> '9 months'
	 * formatDuration({ years: 0, months: 9 }, null, { zero: true })
	 * //=> '0 years 9 months'
	 *
	 * @example
	 * // Customize the delimiter
	 * formatDuration({ years: 2, months: 9, weeks: 3 }, { delimiter: ', ' })
	 * //=> '2 years, 9 months, 3 weeks'
	 */
	
	function formatDuration(duration) {
	  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	  if (arguments.length < 1) {
	    throw new TypeError("1 argument required, but only ".concat(arguments.length, " present"));
	  }
	
	  var format = options.format || defaultFormat;
	  var locale = options.locale || _index.default;
	  var zero = options.zero || false;
	  var delimiter = options.delimiter || ' ';
	  var result = format.reduce(function (acc, unit) {
	    var token = "x".concat(unit.replace(/(^.)/, function (m) {
	      return m.toUpperCase();
	    }));
	    var addChunk = typeof duration[unit] === 'number' && (zero || duration[unit]);
	    return addChunk ? acc.concat(locale.formatDistance(token, duration[unit])) : acc;
	  }, []).join(delimiter);
	  return result;
	}
	
	module.exports = exports.default;

/***/ },
/* 933 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = formatISO9075;
	
	var _index = _interopRequireDefault(__webpack_require__(3));
	
	var _index2 = _interopRequireDefault(__webpack_require__(43));
	
	var _index3 = _interopRequireDefault(__webpack_require__(111));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name formatISO9075
	 * @category Common Helpers
	 * @summary Format the date according to the ISO 9075 standard (https://dev.mysql.com/doc/refman/5.7/en/date-and-time-functions.html#function_get-format).
	 *
	 * @description
	 * Return the formatted date string in ISO 9075 format. Options may be passed to control the parts and notations of the date.
	 *
	 * @param {Date|Number} date - the original date
	 * @param {Object} [options] - an object with options.
	 * @param {'extended'|'basic'} [options.format='extended'] - if 'basic', hide delimiters between date and time values.
	 * @param {'complete'|'date'|'time'} [options.representation='complete'] - format date, time, or both.
	 * @returns {String} the formatted date string
	 * @throws {TypeError} 1 argument required
	 * @throws {RangeError} `date` must not be Invalid Date
	 * @throws {RangeError} `options.format` must be 'extended' or 'basic'
	 * @throws {RangeError} `options.represenation` must be 'date', 'time' or 'complete'
	 *
	 * @example
	 * // Represent 18 September 2019 in ISO 9075 format:
	 * const result = formatISO9075(new Date(2019, 8, 18, 19, 0, 52))
	 * //=> '2019-09-18 19:00:52'
	 *
	 * @example
	 * // Represent 18 September 2019 in ISO 9075, short format:
	 * const result = formatISO9075(new Date(2019, 8, 18, 19, 0, 52), { format: 'basic' })
	 * //=> '20190918 190052'
	 *
	 * @example
	 * // Represent 18 September 2019 in ISO 9075 format, date only:
	 * const result = formatISO9075(new Date(2019, 8, 18, 19, 0, 52), { representation: 'date' })
	 * //=> '2019-09-18'
	 *
	 * @example
	 * // Represent 18 September 2019 in ISO 9075 format, time only:
	 * const result = formatISO9075(new Date(2019, 8, 18, 19, 0, 52), { representation: 'time' })
	 * //=> '19:00:52'
	 */
	function formatISO9075(dirtyDate, dirtyOptions) {
	  if (arguments.length < 1) {
	    throw new TypeError("1 argument required, but only ".concat(arguments.length, " present"));
	  }
	
	  var originalDate = (0, _index.default)(dirtyDate);
	
	  if (!(0, _index2.default)(originalDate)) {
	    throw new RangeError('Invalid time value');
	  }
	
	  var options = dirtyOptions || {};
	  var format = options.format == null ? 'extended' : String(options.format);
	  var representation = options.representation == null ? 'complete' : String(options.representation);
	
	  if (format !== 'extended' && format !== 'basic') {
	    throw new RangeError("format must be 'extended' or 'basic'");
	  }
	
	  if (representation !== 'date' && representation !== 'time' && representation !== 'complete') {
	    throw new RangeError("representation must be 'date', 'time', or 'complete'");
	  }
	
	  var result = '';
	  var dateDelimiter = format === 'extended' ? '-' : '';
	  var timeDelimiter = format === 'extended' ? ':' : ''; // Representation is either 'date' or 'complete'
	
	  if (representation !== 'time') {
	    var day = (0, _index3.default)(originalDate.getDate(), 2);
	    var month = (0, _index3.default)(originalDate.getMonth() + 1, 2);
	    var year = (0, _index3.default)(originalDate.getFullYear(), 4); // yyyyMMdd or yyyy-MM-dd.
	
	    result = "".concat(year).concat(dateDelimiter).concat(month).concat(dateDelimiter).concat(day);
	  } // Representation is either 'time' or 'complete'
	
	
	  if (representation !== 'date') {
	    var hour = (0, _index3.default)(originalDate.getHours(), 2);
	    var minute = (0, _index3.default)(originalDate.getMinutes(), 2);
	    var second = (0, _index3.default)(originalDate.getSeconds(), 2); // If there's also date, separate it with time with a space
	
	    var separator = result === '' ? '' : ' '; // HHmmss or HH:mm:ss.
	
	    result = "".concat(result).concat(separator).concat(hour).concat(timeDelimiter).concat(minute).concat(timeDelimiter).concat(second);
	  }
	
	  return result;
	}
	
	module.exports = exports.default;

/***/ },
/* 934 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = formatISODuration;
	
	var _index = _interopRequireDefault(__webpack_require__(2));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name formatISODuration
	 * @category Common Helpers
	 * @summary Format a duration object according as ISO 8601 duration string
	 *
	 * @description
	 * Format a duration object according to the ISO 8601 duration standard (https://www.digi.com/resources/documentation/digidocs/90001437-13/reference/r_iso_8601_duration_format.htm)
	 *
	 * @param {Duration} duration - the duration to format
	 *
	 * @returns {String} The ISO 8601 duration string
	 * @throws {TypeError} Requires 1 argument
	 * @throws {Error} Argument must be an object
	 *
	 * @example
	 * // Format the given duration as ISO 8601 string
	 * formatISODuration({
	 *   years: 39,
	 *   months: 2,
	 *   days: 20,
	 *   hours: 7,
	 *   minutes: 5,
	 *   seconds: 0
	 * })
	 * //=> 'P39Y2M20DT0H0M0S'
	 */
	function formatISODuration(duration) {
	  (0, _index.default)(1, arguments);
	  if (typeof duration !== 'object') throw new Error('Duration must be an object');
	  var _duration$years = duration.years,
	      years = _duration$years === void 0 ? 0 : _duration$years,
	      _duration$months = duration.months,
	      months = _duration$months === void 0 ? 0 : _duration$months,
	      _duration$days = duration.days,
	      days = _duration$days === void 0 ? 0 : _duration$days,
	      _duration$hours = duration.hours,
	      hours = _duration$hours === void 0 ? 0 : _duration$hours,
	      _duration$minutes = duration.minutes,
	      minutes = _duration$minutes === void 0 ? 0 : _duration$minutes,
	      _duration$seconds = duration.seconds,
	      seconds = _duration$seconds === void 0 ? 0 : _duration$seconds;
	  return "P".concat(years, "Y").concat(months, "M").concat(days, "DT").concat(hours, "H").concat(minutes, "M").concat(seconds, "S");
	}
	
	module.exports = exports.default;

/***/ },
/* 935 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = formatISO;
	
	var _index = _interopRequireDefault(__webpack_require__(3));
	
	var _index2 = _interopRequireDefault(__webpack_require__(43));
	
	var _index3 = _interopRequireDefault(__webpack_require__(111));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name formatISO
	 * @category Common Helpers
	 * @summary Format the date according to the ISO 8601 standard (http://support.sas.com/documentation/cdl/en/lrdict/64316/HTML/default/viewer.htm#a003169814.htm).
	 *
	 * @description
	 * Return the formatted date string in ISO 8601 format. Options may be passed to control the parts and notations of the date.
	 *
	 * @param {Date|Number} date - the original date
	 * @param {Object} [options] - an object with options.
	 * @param {'extended'|'basic'} [options.format='extended'] - if 'basic', hide delimiters between date and time values.
	 * @param {'complete'|'date'|'time'} [options.representation='complete'] - format date, time with time zone, or both.
	 * @returns {String} the formatted date string
	 * @throws {TypeError} 1 argument required
	 * @throws {RangeError} `date` must not be Invalid Date
	 * @throws {RangeError} `options.format` must be 'extended' or 'basic'
	 * @throws {RangeError} `options.represenation` must be 'date', 'time' or 'complete'
	 *
	 * @example
	 * // Represent 18 September 2019 in ISO 8601 format (UTC):
	 * const result = formatISO(new Date(2019, 8, 18, 19, 0, 52))
	 * //=> '2019-09-18T19:00:52Z'
	 *
	 * @example
	 * // Represent 18 September 2019 in ISO 8601, short format (UTC):
	 * const result = formatISO(new Date(2019, 8, 18, 19, 0, 52), { format: 'basic' })
	 * //=> '20190918T190052'
	 *
	 * @example
	 * // Represent 18 September 2019 in ISO 8601 format, date only:
	 * const result = formatISO(new Date(2019, 8, 18, 19, 0, 52), { representation: 'date' })
	 * //=> '2019-09-18'
	 *
	 * @example
	 * // Represent 18 September 2019 in ISO 8601 format, time only (UTC):
	 * const result = formatISO(new Date(2019, 8, 18, 19, 0, 52), { representation: 'time' })
	 * //=> '19:00:52Z'
	 */
	function formatISO(dirtyDate, dirtyOptions) {
	  if (arguments.length < 1) {
	    throw new TypeError("1 argument required, but only ".concat(arguments.length, " present"));
	  }
	
	  var originalDate = (0, _index.default)(dirtyDate);
	
	  if (!(0, _index2.default)(originalDate)) {
	    throw new RangeError('Invalid time value');
	  }
	
	  var options = dirtyOptions || {};
	  var format = options.format == null ? 'extended' : String(options.format);
	  var representation = options.representation == null ? 'complete' : String(options.representation);
	
	  if (format !== 'extended' && format !== 'basic') {
	    throw new RangeError("format must be 'extended' or 'basic'");
	  }
	
	  if (representation !== 'date' && representation !== 'time' && representation !== 'complete') {
	    throw new RangeError("representation must be 'date', 'time', or 'complete'");
	  }
	
	  var result = '';
	  var tzOffset = '';
	  var dateDelimiter = format === 'extended' ? '-' : '';
	  var timeDelimiter = format === 'extended' ? ':' : ''; // Representation is either 'date' or 'complete'
	
	  if (representation !== 'time') {
	    var day = (0, _index3.default)(originalDate.getDate(), 2);
	    var month = (0, _index3.default)(originalDate.getMonth() + 1, 2);
	    var year = (0, _index3.default)(originalDate.getFullYear(), 4); // yyyyMMdd or yyyy-MM-dd.
	
	    result = "".concat(year).concat(dateDelimiter).concat(month).concat(dateDelimiter).concat(day);
	  } // Representation is either 'time' or 'complete'
	
	
	  if (representation !== 'date') {
	    // Add the timezone.
	    var offset = originalDate.getTimezoneOffset();
	
	    if (offset !== 0) {
	      var absoluteOffset = Math.abs(offset);
	      var hourOffset = (0, _index3.default)(Math.floor(absoluteOffset / 60), 2);
	      var minuteOffset = (0, _index3.default)(absoluteOffset % 60, 2); // If less than 0, the sign is +, because it is ahead of time.
	
	      var sign = offset < 0 ? '+' : '-';
	      tzOffset = "".concat(sign).concat(hourOffset, ":").concat(minuteOffset);
	    } else {
	      tzOffset = 'Z';
	    }
	
	    var hour = (0, _index3.default)(originalDate.getHours(), 2);
	    var minute = (0, _index3.default)(originalDate.getMinutes(), 2);
	    var second = (0, _index3.default)(originalDate.getSeconds(), 2); // If there's also date, separate it with time with 'T'
	
	    var separator = result === '' ? '' : 'T'; // Creates a time string consisting of hour, minute, and second, separated by delimiters, if defined.
	
	    var time = [hour, minute, second].join(timeDelimiter); // HHmmss or HH:mm:ss.
	
	    result = "".concat(result).concat(separator).concat(time).concat(tzOffset);
	  }
	
	  return result;
	}
	
	module.exports = exports.default;

/***/ },
/* 936 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = formatRFC3339;
	
	var _index = _interopRequireDefault(__webpack_require__(3));
	
	var _index2 = _interopRequireDefault(__webpack_require__(43));
	
	var _index3 = _interopRequireDefault(__webpack_require__(111));
	
	var _index4 = _interopRequireDefault(__webpack_require__(9));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name formatRFC3339
	 * @category Common Helpers
	 * @summary Format the date according to the ISO 3339 standard (https://tools.ietf.org/html/rfc3339#section-5.6).
	 *
	 * @description
	 * Return the formatted date string in ISO 3339 format. Options may be passed to control the parts and notations of the date.
	 *
	 * @param {Date|Number} date - the original date
	 * @param {Object} [options] - an object with options.
	 * @param {0|1|2|3} [options.fractionDigits=0] - number of digits after the decimal point after seconds
	 * @returns {String} the formatted date string
	 * @throws {TypeError} 1 argument required
	 * @throws {RangeError} `date` must not be Invalid Date
	 * @throws {RangeError} `options.fractionDigits` must be between 0 and 3
	 *
	 * @example
	 * // Represent 18 September 2019 in ISO 3339 format:
	 * const result = formatRFC3339(new Date(2019, 8, 18, 19, 0, 52))
	 * //=> '2019-09-18T19:00:52Z'
	 *
	 * @example
	 * // Represent 18 September 2019 in ISO 3339 format, 2 digits of second fraction:
	 * const result = formatRFC3339(new Date(2019, 8, 18, 19, 0, 52, 234), { fractionDigits: 2 })
	 * //=> '2019-09-18T19:00:52.23Z'
	 *
	 * @example
	 * // Represent 18 September 2019 in ISO 3339 format, 3 digits of second fraction
	 * const result = formatRFC3339(new Date(2019, 8, 18, 19, 0, 52, 234), { fractionDigits: 3 })
	 * //=> '2019-09-18T19:00:52.234Z'
	 */
	function formatRFC3339(dirtyDate, dirtyOptions) {
	  if (arguments.length < 1) {
	    throw new TypeError("1 arguments required, but only ".concat(arguments.length, " present"));
	  }
	
	  var originalDate = (0, _index.default)(dirtyDate);
	
	  if (!(0, _index2.default)(originalDate)) {
	    throw new RangeError('Invalid time value');
	  }
	
	  var options = dirtyOptions || {};
	  var fractionDigits = options.fractionDigits == null ? 0 : (0, _index4.default)(options.fractionDigits); // Test if fractionDigits is between 0 and 3 _and_ is not NaN
	
	  if (!(fractionDigits >= 0 && fractionDigits <= 3)) {
	    throw new RangeError('fractionDigits must be between 0 and 3 inclusively');
	  }
	
	  var day = (0, _index3.default)(originalDate.getDate(), 2);
	  var month = (0, _index3.default)(originalDate.getMonth() + 1, 2);
	  var year = originalDate.getFullYear();
	  var hour = (0, _index3.default)(originalDate.getHours(), 2);
	  var minute = (0, _index3.default)(originalDate.getMinutes(), 2);
	  var second = (0, _index3.default)(originalDate.getSeconds(), 2);
	  var fractionalSecond = '';
	
	  if (fractionDigits > 0) {
	    var milliseconds = originalDate.getMilliseconds();
	    var fractionalSeconds = Math.floor(milliseconds * Math.pow(10, fractionDigits - 3));
	    fractionalSecond = '.' + (0, _index3.default)(fractionalSeconds, fractionDigits);
	  }
	
	  var offset = '';
	  var tzOffset = originalDate.getTimezoneOffset();
	
	  if (tzOffset !== 0) {
	    var absoluteOffset = Math.abs(tzOffset);
	    var hourOffset = (0, _index3.default)(absoluteOffset / 60, 2);
	    var minuteOffset = (0, _index3.default)(absoluteOffset % 60, 2); // If less than 0, the sign is +, because it is ahead of time.
	
	    var sign = tzOffset < 0 ? '+' : '-';
	    offset = "".concat(sign).concat(hourOffset, ":").concat(minuteOffset);
	  } else {
	    offset = 'Z';
	  }
	
	  return "".concat(year, "-").concat(month, "-").concat(day, "T").concat(hour, ":").concat(minute, ":").concat(second).concat(fractionalSecond).concat(offset);
	}
	
	module.exports = exports.default;

/***/ },
/* 937 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = formatRFC7231;
	
	var _index = _interopRequireDefault(__webpack_require__(3));
	
	var _index2 = _interopRequireDefault(__webpack_require__(43));
	
	var _index3 = _interopRequireDefault(__webpack_require__(111));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var days = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
	var months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
	/**
	 * @name formatRFC7231
	 * @category Common Helpers
	 * @summary Format the date according to the RFC 7231 standard (https://tools.ietf.org/html/rfc7231#section-7.1.1.1).
	 *
	 * @description
	 * Return the formatted date string in RFC 7231 format.
	 * The result will always be in UTC timezone.
	 *
	 * @param {Date|Number} date - the original date
	 * @returns {String} the formatted date string
	 * @throws {TypeError} 1 argument required
	 * @throws {RangeError} `date` must not be Invalid Date
	 *
	 * @example
	 * // Represent 18 September 2019 in RFC 7231 format:
	 * const result = formatRFC7231(new Date(2019, 8, 18, 19, 0, 52))
	 * //=> 'Wed, 18 Sep 2019 19:00:52 GMT'
	 */
	
	function formatRFC7231(dirtyDate) {
	  if (arguments.length < 1) {
	    throw new TypeError("1 arguments required, but only ".concat(arguments.length, " present"));
	  }
	
	  var originalDate = (0, _index.default)(dirtyDate);
	
	  if (!(0, _index2.default)(originalDate)) {
	    throw new RangeError('Invalid time value');
	  }
	
	  var dayName = days[originalDate.getUTCDay()];
	  var dayOfMonth = (0, _index3.default)(originalDate.getUTCDate(), 2);
	  var monthName = months[originalDate.getUTCMonth()];
	  var year = originalDate.getUTCFullYear();
	  var hour = (0, _index3.default)(originalDate.getUTCHours(), 2);
	  var minute = (0, _index3.default)(originalDate.getUTCMinutes(), 2);
	  var second = (0, _index3.default)(originalDate.getUTCSeconds(), 2); // Result variables.
	
	  return "".concat(dayName, ", ").concat(dayOfMonth, " ").concat(monthName, " ").concat(year, " ").concat(hour, ":").concat(minute, ":").concat(second, " GMT");
	}
	
	module.exports = exports.default;

/***/ },
/* 938 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = formatRelative;
	
	var _index = _interopRequireDefault(__webpack_require__(84));
	
	var _index2 = _interopRequireDefault(__webpack_require__(33));
	
	var _index3 = _interopRequireDefault(__webpack_require__(115));
	
	var _index4 = _interopRequireDefault(__webpack_require__(143));
	
	var _index5 = _interopRequireDefault(__webpack_require__(3));
	
	var _index6 = _interopRequireDefault(__webpack_require__(73));
	
	var _index7 = _interopRequireDefault(__webpack_require__(2));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name formatRelative
	 * @category Common Helpers
	 * @summary Represent the date in words relative to the given base date.
	 *
	 * @description
	 * Represent the date in words relative to the given base date.
	 *
	 * | Distance to the base date | Result                    |
	 * |---------------------------|---------------------------|
	 * | Previous 6 days           | last Sunday at 04:30 AM   |
	 * | Last day                  | yesterday at 04:30 AM     |
	 * | Same day                  | today at 04:30 AM         |
	 * | Next day                  | tomorrow at 04:30 AM      |
	 * | Next 6 days               | Sunday at 04:30 AM        |
	 * | Other                     | 12/31/2017                |
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} date - the date to format
	 * @param {Date|Number} baseDate - the date to compare with
	 * @param {Object} [options] - an object with options.
	 * @param {Locale} [options.locale=defaultLocale] - the locale object. See [Locale]{@link https://date-fns.org/docs/Locale}
	 * @param {0|1|2|3|4|5|6} [options.weekStartsOn=0] - the index of the first day of the week (0 - Sunday)
	 * @returns {String} the date in words
	 * @throws {TypeError} 2 arguments required
	 * @throws {RangeError} `date` must not be Invalid Date
	 * @throws {RangeError} `baseDate` must not be Invalid Date
	 * @throws {RangeError} `options.weekStartsOn` must be between 0 and 6
	 * @throws {RangeError} `options.locale` must contain `localize` property
	 * @throws {RangeError} `options.locale` must contain `formatLong` property
	 * @throws {RangeError} `options.locale` must contain `formatRelative` property
	 */
	function formatRelative(dirtyDate, dirtyBaseDate, dirtyOptions) {
	  (0, _index7.default)(2, arguments);
	  var date = (0, _index5.default)(dirtyDate);
	  var baseDate = (0, _index5.default)(dirtyBaseDate);
	  var options = dirtyOptions || {};
	  var locale = options.locale || _index3.default;
	
	  if (!locale.localize) {
	    throw new RangeError('locale must contain localize property');
	  }
	
	  if (!locale.formatLong) {
	    throw new RangeError('locale must contain formatLong property');
	  }
	
	  if (!locale.formatRelative) {
	    throw new RangeError('locale must contain formatRelative property');
	  }
	
	  var diff = (0, _index.default)(date, baseDate);
	
	  if (isNaN(diff)) {
	    throw new RangeError('Invalid time value');
	  }
	
	  var token;
	
	  if (diff < -6) {
	    token = 'other';
	  } else if (diff < -1) {
	    token = 'lastWeek';
	  } else if (diff < 0) {
	    token = 'yesterday';
	  } else if (diff < 1) {
	    token = 'today';
	  } else if (diff < 2) {
	    token = 'tomorrow';
	  } else if (diff < 7) {
	    token = 'nextWeek';
	  } else {
	    token = 'other';
	  }
	
	  var utcDate = (0, _index4.default)(date, (0, _index6.default)(date));
	  var utcBaseDate = (0, _index4.default)(baseDate, (0, _index6.default)(baseDate));
	  var formatStr = locale.formatRelative(token, utcDate, utcBaseDate, options);
	  return (0, _index2.default)(date, formatStr, options);
	}
	
	module.exports = exports.default;

/***/ },
/* 939 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = fromUnixTime;
	
	var _index = _interopRequireDefault(__webpack_require__(3));
	
	var _index2 = _interopRequireDefault(__webpack_require__(9));
	
	var _index3 = _interopRequireDefault(__webpack_require__(2));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name fromUnixTime
	 * @category Timestamp Helpers
	 * @summary Create a date from a Unix timestamp.
	 *
	 * @description
	 * Create a date from a Unix timestamp.
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Number} unixTime - the given Unix timestamp
	 * @returns {Date} the date
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // Create the date 29 February 2012 11:45:05:
	 * var result = fromUnixTime(1330515905)
	 * //=> Wed Feb 29 2012 11:45:05
	 */
	function fromUnixTime(dirtyUnixTime) {
	  (0, _index3.default)(1, arguments);
	  var unixTime = (0, _index2.default)(dirtyUnixTime);
	  return (0, _index.default)(unixTime * 1000);
	}
	
	module.exports = exports.default;

/***/ },
/* 940 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = getDayOfYear;
	
	var _index = _interopRequireDefault(__webpack_require__(3));
	
	var _index2 = _interopRequireDefault(__webpack_require__(191));
	
	var _index3 = _interopRequireDefault(__webpack_require__(84));
	
	var _index4 = _interopRequireDefault(__webpack_require__(2));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name getDayOfYear
	 * @category Day Helpers
	 * @summary Get the day of the year of the given date.
	 *
	 * @description
	 * Get the day of the year of the given date.
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} date - the given date
	 * @returns {Number} the day of year
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // Which day of the year is 2 July 2014?
	 * var result = getDayOfYear(new Date(2014, 6, 2))
	 * //=> 183
	 */
	function getDayOfYear(dirtyDate) {
	  (0, _index4.default)(1, arguments);
	  var date = (0, _index.default)(dirtyDate);
	  var diff = (0, _index3.default)(date, (0, _index2.default)(date));
	  var dayOfYear = diff + 1;
	  return dayOfYear;
	}
	
	module.exports = exports.default;

/***/ },
/* 941 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = getDaysInYear;
	
	var _index = _interopRequireDefault(__webpack_require__(3));
	
	var _index2 = _interopRequireDefault(__webpack_require__(418));
	
	var _index3 = _interopRequireDefault(__webpack_require__(2));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name getDaysInYear
	 * @category Year Helpers
	 * @summary Get the number of days in a year of the given date.
	 *
	 * @description
	 * Get the number of days in a year of the given date.
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} date - the given date
	 * @returns {Number} the number of days in a year
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // How many days are in 2012?
	 * var result = getDaysInYear(new Date(2012, 0, 1))
	 * //=> 366
	 */
	function getDaysInYear(dirtyDate) {
	  (0, _index3.default)(1, arguments);
	  var date = (0, _index.default)(dirtyDate);
	
	  if (isNaN(date)) {
	    return NaN;
	  }
	
	  return (0, _index2.default)(date) ? 366 : 365;
	}
	
	module.exports = exports.default;

/***/ },
/* 942 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = getDecade;
	
	var _index = _interopRequireDefault(__webpack_require__(3));
	
	var _index2 = _interopRequireDefault(__webpack_require__(2));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name getDecade
	 * @category Decade Helpers
	 * @summary Get the decade of the given date.
	 *
	 * @description
	 * Get the decade of the given date.
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} date - the given date
	 * @returns {Number} the year of decade
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // Which decade belongs 27 November 1942?
	 * var result = getDecade(new Date(1942, 10, 27))
	 * //=> 1940
	 */
	function getDecade(dirtyDate) {
	  (0, _index2.default)(1, arguments);
	  var date = (0, _index.default)(dirtyDate);
	  var year = date.getFullYear();
	  var decade = Math.floor(year / 10) * 10;
	  return decade;
	}
	
	module.exports = exports.default;

/***/ },
/* 943 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = getISOWeeksInYear;
	
	var _index = _interopRequireDefault(__webpack_require__(141));
	
	var _index2 = _interopRequireDefault(__webpack_require__(138));
	
	var _index3 = _interopRequireDefault(__webpack_require__(2));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MILLISECONDS_IN_WEEK = 604800000;
	/**
	 * @name getISOWeeksInYear
	 * @category ISO Week-Numbering Year Helpers
	 * @summary Get the number of weeks in an ISO week-numbering year of the given date.
	 *
	 * @description
	 * Get the number of weeks in an ISO week-numbering year of the given date.
	 *
	 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} date - the given date
	 * @returns {Number} the number of ISO weeks in a year
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // How many weeks are in ISO week-numbering year 2015?
	 * var result = getISOWeeksInYear(new Date(2015, 1, 11))
	 * //=> 53
	 */
	
	function getISOWeeksInYear(dirtyDate) {
	  (0, _index3.default)(1, arguments);
	  var thisYear = (0, _index.default)(dirtyDate);
	  var nextYear = (0, _index.default)((0, _index2.default)(thisYear, 60));
	  var diff = nextYear.valueOf() - thisYear.valueOf(); // Round the number of weeks to the nearest integer
	  // because the number of milliseconds in a week is not constant
	  // (e.g. it's different in the week of the daylight saving time clock shift)
	
	  return Math.round(diff / MILLISECONDS_IN_WEEK);
	}
	
	module.exports = exports.default;

/***/ },
/* 944 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = getMilliseconds;
	
	var _index = _interopRequireDefault(__webpack_require__(3));
	
	var _index2 = _interopRequireDefault(__webpack_require__(2));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name getMilliseconds
	 * @category Millisecond Helpers
	 * @summary Get the milliseconds of the given date.
	 *
	 * @description
	 * Get the milliseconds of the given date.
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} date - the given date
	 * @returns {Number} the milliseconds
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // Get the milliseconds of 29 February 2012 11:45:05.123:
	 * var result = getMilliseconds(new Date(2012, 1, 29, 11, 45, 5, 123))
	 * //=> 123
	 */
	function getMilliseconds(dirtyDate) {
	  (0, _index2.default)(1, arguments);
	  var date = (0, _index.default)(dirtyDate);
	  var milliseconds = date.getMilliseconds();
	  return milliseconds;
	}
	
	module.exports = exports.default;

/***/ },
/* 945 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = getOverlappingDaysInIntervals;
	
	var _index = _interopRequireDefault(__webpack_require__(3));
	
	var _index2 = _interopRequireDefault(__webpack_require__(2));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MILLISECONDS_IN_DAY = 24 * 60 * 60 * 1000;
	/**
	 * @name getOverlappingDaysInIntervals
	 * @category Interval Helpers
	 * @summary Get the number of days that overlap in two time intervals
	 *
	 * @description
	 * Get the number of days that overlap in two time intervals
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * - The function was renamed from `getOverlappingDaysInRanges` to `getOverlappingDaysInIntervals`.
	 *   This change was made to mirror the use of the word "interval" in standard ISO 8601:2004 terminology:
	 *
	 *   ```
	 *   2.1.3
	 *   time interval
	 *   part of the time axis limited by two instants
	 *   ```
	 *
	 *   Also, this function now accepts an object with `start` and `end` properties
	 *   instead of two arguments as an interval.
	 *   This function now throws `RangeError` if the start of the interval is after its end
	 *   or if any date in the interval is `Invalid Date`.
	 *
	 *   ```javascript
	 *   // Before v2.0.0
	 *
	 *   getOverlappingDaysInRanges(
	 *     new Date(2014, 0, 10), new Date(2014, 0, 20),
	 *     new Date(2014, 0, 17), new Date(2014, 0, 21)
	 *   )
	 *
	 *   // v2.0.0 onward
	 *
	 *   getOverlappingDaysInIntervals(
	 *     { start: new Date(2014, 0, 10), end: new Date(2014, 0, 20) },
	 *     { start: new Date(2014, 0, 17), end: new Date(2014, 0, 21) }
	 *   )
	 *   ```
	 *
	 * @param {Interval} intervalLeft - the first interval to compare. See [Interval]{@link docs/Interval}
	 * @param {Interval} intervalRight - the second interval to compare. See [Interval]{@link docs/Interval}
	 * @returns {Number} the number of days that overlap in two time intervals
	 * @throws {TypeError} 2 arguments required
	 * @throws {RangeError} The start of an interval cannot be after its end
	 * @throws {RangeError} Date in interval cannot be `Invalid Date`
	 *
	 * @example
	 * // For overlapping time intervals adds 1 for each started overlapping day:
	 * getOverlappingDaysInIntervals(
	 *   { start: new Date(2014, 0, 10), end: new Date(2014, 0, 20) },
	 *   { start: new Date(2014, 0, 17), end: new Date(2014, 0, 21) }
	 * )
	 * //=> 3
	 *
	 * @example
	 * // For non-overlapping time intervals returns 0:
	 * getOverlappingDaysInIntervals(
	 *   { start: new Date(2014, 0, 10), end: new Date(2014, 0, 20) },
	 *   { start: new Date(2014, 0, 21), end: new Date(2014, 0, 22) }
	 * )
	 * //=> 0
	 */
	
	function getOverlappingDaysInIntervals(dirtyIntervalLeft, dirtyIntervalRight) {
	  (0, _index2.default)(2, arguments);
	  var intervalLeft = dirtyIntervalLeft || {};
	  var intervalRight = dirtyIntervalRight || {};
	  var leftStartTime = (0, _index.default)(intervalLeft.start).getTime();
	  var leftEndTime = (0, _index.default)(intervalLeft.end).getTime();
	  var rightStartTime = (0, _index.default)(intervalRight.start).getTime();
	  var rightEndTime = (0, _index.default)(intervalRight.end).getTime(); // Throw an exception if start date is after end date or if any date is `Invalid Date`
	
	  if (!(leftStartTime <= leftEndTime && rightStartTime <= rightEndTime)) {
	    throw new RangeError('Invalid interval');
	  }
	
	  var isOverlapping = leftStartTime < rightEndTime && rightStartTime < leftEndTime;
	
	  if (!isOverlapping) {
	    return 0;
	  }
	
	  var overlapStartDate = rightStartTime < leftStartTime ? leftStartTime : rightStartTime;
	  var overlapEndDate = rightEndTime > leftEndTime ? leftEndTime : rightEndTime;
	  var differenceInMs = overlapEndDate - overlapStartDate;
	  return Math.ceil(differenceInMs / MILLISECONDS_IN_DAY);
	}
	
	module.exports = exports.default;

/***/ },
/* 946 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = getUnixTime;
	
	var _index = _interopRequireDefault(__webpack_require__(272));
	
	var _index2 = _interopRequireDefault(__webpack_require__(2));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name getUnixTime
	 * @category Timestamp Helpers
	 * @summary Get the seconds timestamp of the given date.
	 *
	 * @description
	 * Get the seconds timestamp of the given date.
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} date - the given date
	 * @returns {Number} the timestamp
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // Get the timestamp of 29 February 2012 11:45:05 CET:
	 * var result = getUnixTime(new Date(2012, 1, 29, 11, 45, 5))
	 * //=> 1330512305
	 */
	function getUnixTime(dirtyDate) {
	  (0, _index2.default)(1, arguments);
	  return Math.floor((0, _index.default)(dirtyDate) / 1000);
	}
	
	module.exports = exports.default;

/***/ },
/* 947 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = getWeekOfMonth;
	
	var _index = _interopRequireDefault(__webpack_require__(269));
	
	var _index2 = _interopRequireDefault(__webpack_require__(270));
	
	var _index3 = _interopRequireDefault(__webpack_require__(142));
	
	var _index4 = _interopRequireDefault(__webpack_require__(9));
	
	var _index5 = _interopRequireDefault(__webpack_require__(2));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name getWeekOfMonth
	 * @category Week Helpers
	 * @summary Get the week of the month of the given date.
	 *
	 * @description
	 * Get the week of the month of the given date.
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} date - the given date
	 * @param {Object} [options] - an object with options.
	 * @param {Locale} [options.locale=defaultLocale] - the locale object. See [Locale]{@link https://date-fns.org/docs/Locale}
	 * @param {0|1|2|3|4|5|6} [options.weekStartsOn=0] - the index of the first day of the week (0 - Sunday)
	 * @returns {Number} the week of month
	 * @throws {TypeError} 1 argument required
	 * @throws {RangeError} `options.weekStartsOn` must be between 0 and 6
	 *
	 * @example
	 * // Which week of the month is 9 November 2017?
	 * var result = getWeekOfMonth(new Date(2017, 10, 9))
	 * //=> 2
	 */
	function getWeekOfMonth(date, dirtyOptions) {
	  (0, _index5.default)(1, arguments);
	  var options = dirtyOptions || {};
	  var locale = options.locale;
	  var localeWeekStartsOn = locale && locale.options && locale.options.weekStartsOn;
	  var defaultWeekStartsOn = localeWeekStartsOn == null ? 0 : (0, _index4.default)(localeWeekStartsOn);
	  var weekStartsOn = options.weekStartsOn == null ? defaultWeekStartsOn : (0, _index4.default)(options.weekStartsOn); // Test if weekStartsOn is between 0 and 6 _and_ is not NaN
	
	  if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) {
	    throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
	  }
	
	  var currentDayOfMonth = (0, _index.default)(date);
	
	  if (isNaN(currentDayOfMonth)) {
	    return currentDayOfMonth;
	  }
	
	  var startWeekDay = (0, _index2.default)((0, _index3.default)(date));
	  var lastDayOfFirstWeek = 0;
	
	  if (startWeekDay >= weekStartsOn) {
	    lastDayOfFirstWeek = weekStartsOn + 7 - startWeekDay;
	  } else {
	    lastDayOfFirstWeek = weekStartsOn - startWeekDay;
	  }
	
	  var weekNumber = 1;
	
	  if (currentDayOfMonth > lastDayOfFirstWeek) {
	    var remainingDaysAfterFirstWeek = currentDayOfMonth - lastDayOfFirstWeek;
	    weekNumber = weekNumber + Math.ceil(remainingDaysAfterFirstWeek / 7);
	  }
	
	  return weekNumber;
	}
	
	module.exports = exports.default;

/***/ },
/* 948 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = getWeeksInMonth;
	
	var _index = _interopRequireDefault(__webpack_require__(265));
	
	var _index2 = _interopRequireDefault(__webpack_require__(425));
	
	var _index3 = _interopRequireDefault(__webpack_require__(142));
	
	var _index4 = _interopRequireDefault(__webpack_require__(2));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name getWeeksInMonth
	 * @category Week Helpers
	 * @summary Get the number of calendar weeks a month spans.
	 *
	 * @description
	 * Get the number of calendar weeks the month in the given date spans.
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} date - the given date
	 * @param {Object} [options] - an object with options.
	 * @param {Locale} [options.locale=defaultLocale] - the locale object. See [Locale]{@link https://date-fns.org/docs/Locale}
	 * @param {0|1|2|3|4|5|6} [options.weekStartsOn=0] - the index of the first day of the week (0 - Sunday)
	 * @returns {Number} the number of calendar weeks
	 * @throws {TypeError} 2 arguments required
	 * @throws {RangeError} `options.weekStartsOn` must be between 0 and 6
	 *
	 * @example
	 * // How many calendar weeks does February 2015 span?
	 * var result = getWeeksInMonth(new Date(2015, 1, 8))
	 * //=> 4
	 *
	 * @example
	 * // If the week starts on Monday,
	 * // how many calendar weeks does July 2017 span?
	 * var result = getWeeksInMonth(new Date(2017, 6, 5), { weekStartsOn: 1 })
	 * //=> 6
	 */
	function getWeeksInMonth(date, options) {
	  (0, _index4.default)(1, arguments);
	  return (0, _index.default)((0, _index2.default)(date), (0, _index3.default)(date), options) + 1;
	}
	
	module.exports = exports.default;

/***/ },
/* 949 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = intervalToDuration;
	
	var _index = _interopRequireDefault(__webpack_require__(98));
	
	var _index2 = _interopRequireDefault(__webpack_require__(403));
	
	var _index3 = _interopRequireDefault(__webpack_require__(140));
	
	var _index4 = _interopRequireDefault(__webpack_require__(139));
	
	var _index5 = _interopRequireDefault(__webpack_require__(401));
	
	var _index6 = _interopRequireDefault(__webpack_require__(402));
	
	var _index7 = _interopRequireDefault(__webpack_require__(183));
	
	var _index8 = _interopRequireDefault(__webpack_require__(43));
	
	var _index9 = _interopRequireDefault(__webpack_require__(2));
	
	var _index10 = _interopRequireDefault(__webpack_require__(3));
	
	var _index11 = _interopRequireDefault(__webpack_require__(283));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name intervalToDuration
	 * @category Common Helpers
	 * @summary Convert interval to duration
	 *
	 * @description
	 * Convert a interval object to a duration object.
	 *
	 * @param {Interval} interval - the interval to convert to duration
	 *
	 * @returns {Duration} The duration Object
	 * @throws {TypeError} Requires 2 arguments
	 * @throws {RangeError} `start` must not be Invalid Date
	 * @throws {RangeError} `end` must not be Invalid Date
	 *
	 * @example
	 * // Get the duration between January 15, 1929 and April 4, 1968.
	 * intervalToDuration({
	 *   start: new Date(1929, 0, 15, 12, 0, 0),
	 *   end: new Date(1968, 3, 4, 19, 5, 0)
	 * })
	 * // => { years: 39, months: 2, days: 20, hours: 7, minutes: 5, seconds: 0 }
	 */
	function intervalToDuration(_ref) {
	  var start = _ref.start,
	      end = _ref.end;
	  (0, _index9.default)(1, arguments);
	  var dateLeft = (0, _index10.default)(start);
	  var dateRight = (0, _index10.default)(end);
	
	  if (!(0, _index8.default)(dateLeft)) {
	    throw new RangeError('Start Date is invalid');
	  }
	
	  if (!(0, _index8.default)(dateRight)) {
	    throw new RangeError('End Date is invalid');
	  }
	
	  var duration = {
	    years: 0,
	    months: 0,
	    days: 0,
	    hours: 0,
	    minutes: 0,
	    seconds: 0
	  };
	  var sign = (0, _index.default)(dateLeft, dateRight);
	  duration.years = Math.abs((0, _index2.default)(dateLeft, dateRight));
	  var remainingMonths = (0, _index11.default)(dateLeft, {
	    years: sign * duration.years
	  });
	  duration.months = Math.abs((0, _index3.default)(remainingMonths, dateRight));
	  var remainingDays = (0, _index11.default)(remainingMonths, {
	    months: sign * duration.months
	  });
	  duration.days = Math.abs((0, _index4.default)(remainingDays, dateRight));
	  var remainingHours = (0, _index11.default)(remainingDays, {
	    days: sign * duration.days
	  });
	  duration.hours = Math.abs((0, _index5.default)(remainingHours, dateRight));
	  var remainingMinutes = (0, _index11.default)(remainingHours, {
	    hours: sign * duration.hours
	  });
	  duration.minutes = Math.abs((0, _index6.default)(remainingMinutes, dateRight));
	  var remainingSeconds = (0, _index11.default)(remainingMinutes, {
	    minutes: sign * duration.minutes
	  });
	  duration.seconds = Math.abs((0, _index7.default)(remainingSeconds, dateRight));
	  return duration;
	}
	
	module.exports = exports.default;

/***/ },
/* 950 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isExists;
	
	/**
	 * @name isExists
	 * @category Common Helpers
	 * @summary Is the given date exists?
	 *
	 * @description
	 * Checks if the given arguments convert to an existing date.
	 *
	 * @param {Number} year of the date to check
	 * @param {Number} month of the date to check
	 * @param {Number} day of the date to check
	 * @returns {Boolean} the date exists
	 * @throws {TypeError} 3 arguments required
	 *
	 * @example
	 * // For the valid date:
	 * var result = isExists(2018, 0, 31)
	 * //=> true
	 *
	 * @example
	 * // For the invalid date:
	 * var result = isExists(2018, 1, 31)
	 * //=> false
	 */
	function isExists(year, month, day) {
	  if (arguments.length < 3) {
	    throw new TypeError('3 argument required, but only ' + arguments.length + ' present');
	  }
	
	  var date = new Date(year, month, day);
	  return date.getFullYear() === year && date.getMonth() === month && date.getDate() === day;
	}
	
	module.exports = exports.default;

/***/ },
/* 951 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isFirstDayOfMonth;
	
	var _index = _interopRequireDefault(__webpack_require__(3));
	
	var _index2 = _interopRequireDefault(__webpack_require__(2));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name isFirstDayOfMonth
	 * @category Month Helpers
	 * @summary Is the given date the first day of a month?
	 *
	 * @description
	 * Is the given date the first day of a month?
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} date - the date to check
	 * @returns {Boolean} the date is the first day of a month
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // Is 1 September 2014 the first day of a month?
	 * var result = isFirstDayOfMonth(new Date(2014, 8, 1))
	 * //=> true
	 */
	function isFirstDayOfMonth(dirtyDate) {
	  (0, _index2.default)(1, arguments);
	  return (0, _index.default)(dirtyDate).getDate() === 1;
	}
	
	module.exports = exports.default;

/***/ },
/* 952 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isFriday;
	
	var _index = _interopRequireDefault(__webpack_require__(3));
	
	var _index2 = _interopRequireDefault(__webpack_require__(2));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name isFriday
	 * @category Weekday Helpers
	 * @summary Is the given date Friday?
	 *
	 * @description
	 * Is the given date Friday?
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} date - the date to check
	 * @returns {Boolean} the date is Friday
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // Is 26 September 2014 Friday?
	 * var result = isFriday(new Date(2014, 8, 26))
	 * //=> true
	 */
	function isFriday(dirtyDate) {
	  (0, _index2.default)(1, arguments);
	  return (0, _index.default)(dirtyDate).getDay() === 5;
	}
	
	module.exports = exports.default;

/***/ },
/* 953 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isFuture;
	
	var _index = _interopRequireDefault(__webpack_require__(3));
	
	var _index2 = _interopRequireDefault(__webpack_require__(2));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name isFuture
	 * @category Common Helpers
	 * @summary Is the given date in the future?
	 * @pure false
	 *
	 * @description
	 * Is the given date in the future?
	 *
	 * > ⚠️ Please note that this function is not present in the FP submodule as
	 * > it uses `Date.now()` internally hence impure and can't be safely curried.
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} date - the date to check
	 * @returns {Boolean} the date is in the future
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // If today is 6 October 2014, is 31 December 2014 in the future?
	 * var result = isFuture(new Date(2014, 11, 31))
	 * //=> true
	 */
	function isFuture(dirtyDate) {
	  (0, _index2.default)(1, arguments);
	  return (0, _index.default)(dirtyDate).getTime() > Date.now();
	}
	
	module.exports = exports.default;

/***/ },
/* 954 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isLastDayOfMonth;
	
	var _index = _interopRequireDefault(__webpack_require__(3));
	
	var _index2 = _interopRequireDefault(__webpack_require__(184));
	
	var _index3 = _interopRequireDefault(__webpack_require__(185));
	
	var _index4 = _interopRequireDefault(__webpack_require__(2));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name isLastDayOfMonth
	 * @category Month Helpers
	 * @summary Is the given date the last day of a month?
	 *
	 * @description
	 * Is the given date the last day of a month?
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} date - the date to check
	 * @returns {Boolean} the date is the last day of a month
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // Is 28 February 2014 the last day of a month?
	 * var result = isLastDayOfMonth(new Date(2014, 1, 28))
	 * //=> true
	 */
	function isLastDayOfMonth(dirtyDate) {
	  (0, _index4.default)(1, arguments);
	  var date = (0, _index.default)(dirtyDate);
	  return (0, _index2.default)(date).getTime() === (0, _index3.default)(date).getTime();
	}
	
	module.exports = exports.default;

/***/ },
/* 955 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isMonday;
	
	var _index = _interopRequireDefault(__webpack_require__(3));
	
	var _index2 = _interopRequireDefault(__webpack_require__(2));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name isMonday
	 * @category Weekday Helpers
	 * @summary Is the given date Monday?
	 *
	 * @description
	 * Is the given date Monday?
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} date - the date to check
	 * @returns {Boolean} the date is Monday
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // Is 22 September 2014 Monday?
	 * var result = isMonday(new Date(2014, 8, 22))
	 * //=> true
	 */
	function isMonday(dirtyDate) {
	  (0, _index2.default)(1, arguments);
	  return (0, _index.default)(dirtyDate).getDay() === 1;
	}
	
	module.exports = exports.default;

/***/ },
/* 956 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isPast;
	
	var _index = _interopRequireDefault(__webpack_require__(3));
	
	var _index2 = _interopRequireDefault(__webpack_require__(2));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name isPast
	 * @category Common Helpers
	 * @summary Is the given date in the past?
	 * @pure false
	 *
	 * @description
	 * Is the given date in the past?
	 *
	 * > ⚠️ Please note that this function is not present in the FP submodule as
	 * > it uses `Date.now()` internally hence impure and can't be safely curried.
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} date - the date to check
	 * @returns {Boolean} the date is in the past
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // If today is 6 October 2014, is 2 July 2014 in the past?
	 * var result = isPast(new Date(2014, 6, 2))
	 * //=> true
	 */
	function isPast(dirtyDate) {
	  (0, _index2.default)(1, arguments);
	  return (0, _index.default)(dirtyDate).getTime() < Date.now();
	}
	
	module.exports = exports.default;

/***/ },
/* 957 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isSameISOWeekYear;
	
	var _index = _interopRequireDefault(__webpack_require__(141));
	
	var _index2 = _interopRequireDefault(__webpack_require__(2));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name isSameISOWeekYear
	 * @category ISO Week-Numbering Year Helpers
	 * @summary Are the given dates in the same ISO week-numbering year?
	 *
	 * @description
	 * Are the given dates in the same ISO week-numbering year?
	 *
	 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * - The function was renamed from `isSameISOYear` to `isSameISOWeekYear`.
	 *   "ISO week year" is short for [ISO week-numbering year](https://en.wikipedia.org/wiki/ISO_week_date).
	 *   This change makes the name consistent with
	 *   locale-dependent week-numbering year helpers, e.g., `getWeekYear`.
	 *
	 * @param {Date|Number} dateLeft - the first date to check
	 * @param {Date|Number} dateRight - the second date to check
	 * @returns {Boolean} the dates are in the same ISO week-numbering year
	 * @throws {TypeError} 2 arguments required
	 *
	 * @example
	 * // Are 29 December 2003 and 2 January 2005 in the same ISO week-numbering year?
	 * var result = isSameISOWeekYear(new Date(2003, 11, 29), new Date(2005, 0, 2))
	 * //=> true
	 */
	function isSameISOWeekYear(dirtyDateLeft, dirtyDateRight) {
	  (0, _index2.default)(2, arguments);
	  var dateLeftStartOfYear = (0, _index.default)(dirtyDateLeft);
	  var dateRightStartOfYear = (0, _index.default)(dirtyDateRight);
	  return dateLeftStartOfYear.getTime() === dateRightStartOfYear.getTime();
	}
	
	module.exports = exports.default;

/***/ },
/* 958 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isSaturday;
	
	var _index = _interopRequireDefault(__webpack_require__(3));
	
	var _index2 = _interopRequireDefault(__webpack_require__(2));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name isSaturday
	 * @category Weekday Helpers
	 * @summary Is the given date Saturday?
	 *
	 * @description
	 * Is the given date Saturday?
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} date - the date to check
	 * @returns {Boolean} the date is Saturday
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // Is 27 September 2014 Saturday?
	 * var result = isSaturday(new Date(2014, 8, 27))
	 * //=> true
	 */
	function isSaturday(dirtyDate) {
	  (0, _index2.default)(1, arguments);
	  return (0, _index.default)(dirtyDate).getDay() === 6;
	}
	
	module.exports = exports.default;

/***/ },
/* 959 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isThisHour;
	
	var _index = _interopRequireDefault(__webpack_require__(419));
	
	var _index2 = _interopRequireDefault(__webpack_require__(2));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name isThisHour
	 * @category Hour Helpers
	 * @summary Is the given date in the same hour as the current date?
	 * @pure false
	 *
	 * @description
	 * Is the given date in the same hour as the current date?
	 *
	 * > ⚠️ Please note that this function is not present in the FP submodule as
	 * > it uses `Date.now()` internally hence impure and can't be safely curried.
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} date - the date to check
	 * @returns {Boolean} the date is in this hour
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // If now is 25 September 2014 18:30:15.500,
	 * // is 25 September 2014 18:00:00 in this hour?
	 * var result = isThisHour(new Date(2014, 8, 25, 18))
	 * //=> true
	 */
	function isThisHour(dirtyDate) {
	  (0, _index2.default)(1, arguments);
	  return (0, _index.default)(Date.now(), dirtyDate);
	}
	
	module.exports = exports.default;

/***/ },
/* 960 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isThisISOWeek;
	
	var _index = _interopRequireDefault(__webpack_require__(420));
	
	var _index2 = _interopRequireDefault(__webpack_require__(2));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name isThisISOWeek
	 * @category ISO Week Helpers
	 * @summary Is the given date in the same ISO week as the current date?
	 * @pure false
	 *
	 * @description
	 * Is the given date in the same ISO week as the current date?
	 *
	 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
	 *
	 * > ⚠️ Please note that this function is not present in the FP submodule as
	 * > it uses `Date.now()` internally hence impure and can't be safely curried.
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} date - the date to check
	 * @returns {Boolean} the date is in this ISO week
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // If today is 25 September 2014, is 22 September 2014 in this ISO week?
	 * var result = isThisISOWeek(new Date(2014, 8, 22))
	 * //=> true
	 */
	function isThisISOWeek(dirtyDate) {
	  (0, _index2.default)(1, arguments);
	  return (0, _index.default)(dirtyDate, Date.now());
	}
	
	module.exports = exports.default;

/***/ },
/* 961 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isThisMinute;
	
	var _index = _interopRequireDefault(__webpack_require__(421));
	
	var _index2 = _interopRequireDefault(__webpack_require__(2));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name isThisMinute
	 * @category Minute Helpers
	 * @summary Is the given date in the same minute as the current date?
	 * @pure false
	 *
	 * @description
	 * Is the given date in the same minute as the current date?
	 *
	 * > ⚠️ Please note that this function is not present in the FP submodule as
	 * > it uses `Date.now()` internally hence impure and can't be safely curried.
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} date - the date to check
	 * @returns {Boolean} the date is in this minute
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // If now is 25 September 2014 18:30:15.500,
	 * // is 25 September 2014 18:30:00 in this minute?
	 * var result = isThisMinute(new Date(2014, 8, 25, 18, 30))
	 * //=> true
	 */
	function isThisMinute(dirtyDate) {
	  (0, _index2.default)(1, arguments);
	  return (0, _index.default)(Date.now(), dirtyDate);
	}
	
	module.exports = exports.default;

/***/ },
/* 962 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isThisMonth;
	
	var _index = _interopRequireDefault(__webpack_require__(276));
	
	var _index2 = _interopRequireDefault(__webpack_require__(2));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name isThisMonth
	 * @category Month Helpers
	 * @summary Is the given date in the same month as the current date?
	 * @pure false
	 *
	 * @description
	 * Is the given date in the same month as the current date?
	 *
	 * > ⚠️ Please note that this function is not present in the FP submodule as
	 * > it uses `Date.now()` internally hence impure and can't be safely curried.
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} date - the date to check
	 * @returns {Boolean} the date is in this month
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // If today is 25 September 2014, is 15 September 2014 in this month?
	 * var result = isThisMonth(new Date(2014, 8, 15))
	 * //=> true
	 */
	function isThisMonth(dirtyDate) {
	  (0, _index2.default)(1, arguments);
	  return (0, _index.default)(Date.now(), dirtyDate);
	}
	
	module.exports = exports.default;

/***/ },
/* 963 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isThisQuarter;
	
	var _index = _interopRequireDefault(__webpack_require__(277));
	
	var _index2 = _interopRequireDefault(__webpack_require__(2));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name isThisQuarter
	 * @category Quarter Helpers
	 * @summary Is the given date in the same quarter as the current date?
	 * @pure false
	 *
	 * @description
	 * Is the given date in the same quarter as the current date?
	 *
	 * > ⚠️ Please note that this function is not present in the FP submodule as
	 * > it uses `Date.now()` internally hence impure and can't be safely curried.
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} date - the date to check
	 * @returns {Boolean} the date is in this quarter
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // If today is 25 September 2014, is 2 July 2014 in this quarter?
	 * var result = isThisQuarter(new Date(2014, 6, 2))
	 * //=> true
	 */
	function isThisQuarter(dirtyDate) {
	  (0, _index2.default)(1, arguments);
	  return (0, _index.default)(Date.now(), dirtyDate);
	}
	
	module.exports = exports.default;

/***/ },
/* 964 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isThisSecond;
	
	var _index = _interopRequireDefault(__webpack_require__(422));
	
	var _index2 = _interopRequireDefault(__webpack_require__(2));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name isThisSecond
	 * @category Second Helpers
	 * @summary Is the given date in the same second as the current date?
	 * @pure false
	 *
	 * @description
	 * Is the given date in the same second as the current date?
	 *
	 * > ⚠️ Please note that this function is not present in the FP submodule as
	 * > it uses `Date.now()` internally hence impure and can't be safely curried.
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} date - the date to check
	 * @returns {Boolean} the date is in this second
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // If now is 25 September 2014 18:30:15.500,
	 * // is 25 September 2014 18:30:15.000 in this second?
	 * var result = isThisSecond(new Date(2014, 8, 25, 18, 30, 15))
	 * //=> true
	 */
	function isThisSecond(dirtyDate) {
	  (0, _index2.default)(1, arguments);
	  return (0, _index.default)(Date.now(), dirtyDate);
	}
	
	module.exports = exports.default;

/***/ },
/* 965 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isThisWeek;
	
	var _index = _interopRequireDefault(__webpack_require__(278));
	
	var _index2 = _interopRequireDefault(__webpack_require__(2));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name isThisWeek
	 * @category Week Helpers
	 * @summary Is the given date in the same week as the current date?
	 * @pure false
	 *
	 * @description
	 * Is the given date in the same week as the current date?
	 *
	 * > ⚠️ Please note that this function is not present in the FP submodule as
	 * > it uses `Date.now()` internally hence impure and can't be safely curried.
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} date - the date to check
	 * @param {Object} [options] - the object with options
	 * @param {Locale} [options.locale=defaultLocale] - the locale object. See [Locale]{@link https://date-fns.org/docs/Locale}
	 * @param {0|1|2|3|4|5|6} [options.weekStartsOn=0] - the index of the first day of the week (0 - Sunday)
	 * @returns {Boolean} the date is in this week
	 * @throws {TypeError} 1 argument required
	 * @throws {RangeError} `options.weekStartsOn` must be between 0 and 6
	 *
	 * @example
	 * // If today is 25 September 2014, is 21 September 2014 in this week?
	 * var result = isThisWeek(new Date(2014, 8, 21))
	 * //=> true
	 *
	 * @example
	 * // If today is 25 September 2014 and week starts with Monday
	 * // is 21 September 2014 in this week?
	 * var result = isThisWeek(new Date(2014, 8, 21), { weekStartsOn: 1 })
	 * //=> false
	 */
	function isThisWeek(dirtyDate, options) {
	  (0, _index2.default)(1, arguments);
	  return (0, _index.default)(dirtyDate, Date.now(), options);
	}
	
	module.exports = exports.default;

/***/ },
/* 966 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isThisYear;
	
	var _index = _interopRequireDefault(__webpack_require__(279));
	
	var _index2 = _interopRequireDefault(__webpack_require__(2));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name isThisYear
	 * @category Year Helpers
	 * @summary Is the given date in the same year as the current date?
	 * @pure false
	 *
	 * @description
	 * Is the given date in the same year as the current date?
	 *
	 * > ⚠️ Please note that this function is not present in the FP submodule as
	 * > it uses `Date.now()` internally hence impure and can't be safely curried.
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} date - the date to check
	 * @returns {Boolean} the date is in this year
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // If today is 25 September 2014, is 2 July 2014 in this year?
	 * var result = isThisYear(new Date(2014, 6, 2))
	 * //=> true
	 */
	function isThisYear(dirtyDate) {
	  (0, _index2.default)(1, arguments);
	  return (0, _index.default)(dirtyDate, Date.now());
	}
	
	module.exports = exports.default;

/***/ },
/* 967 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isThursday;
	
	var _index = _interopRequireDefault(__webpack_require__(3));
	
	var _index2 = _interopRequireDefault(__webpack_require__(2));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name isThursday
	 * @category Weekday Helpers
	 * @summary Is the given date Thursday?
	 *
	 * @description
	 * Is the given date Thursday?
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} date - the date to check
	 * @returns {Boolean} the date is Thursday
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // Is 25 September 2014 Thursday?
	 * var result = isThursday(new Date(2014, 8, 25))
	 * //=> true
	 */
	function isThursday(dirtyDate) {
	  (0, _index2.default)(1, arguments);
	  return (0, _index.default)(dirtyDate).getDay() === 4;
	}
	
	module.exports = exports.default;

/***/ },
/* 968 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isToday;
	
	var _index = _interopRequireDefault(__webpack_require__(114));
	
	var _index2 = _interopRequireDefault(__webpack_require__(2));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name isToday
	 * @category Day Helpers
	 * @summary Is the given date today?
	 * @pure false
	 *
	 * @description
	 * Is the given date today?
	 *
	 * > ⚠️ Please note that this function is not present in the FP submodule as
	 * > it uses `Date.now()` internally hence impure and can't be safely curried.
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} date - the date to check
	 * @returns {Boolean} the date is today
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // If today is 6 October 2014, is 6 October 14:00:00 today?
	 * var result = isToday(new Date(2014, 9, 6, 14, 0))
	 * //=> true
	 */
	function isToday(dirtyDate) {
	  (0, _index2.default)(1, arguments);
	  return (0, _index.default)(dirtyDate, Date.now());
	}
	
	module.exports = exports.default;

/***/ },
/* 969 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isTomorrow;
	
	var _index = _interopRequireDefault(__webpack_require__(74));
	
	var _index2 = _interopRequireDefault(__webpack_require__(114));
	
	var _index3 = _interopRequireDefault(__webpack_require__(2));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name isTomorrow
	 * @category Day Helpers
	 * @summary Is the given date tomorrow?
	 * @pure false
	 *
	 * @description
	 * Is the given date tomorrow?
	 *
	 * > ⚠️ Please note that this function is not present in the FP submodule as
	 * > it uses `Date.now()` internally hence impure and can't be safely curried.
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} date - the date to check
	 * @returns {Boolean} the date is tomorrow
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // If today is 6 October 2014, is 7 October 14:00:00 tomorrow?
	 * var result = isTomorrow(new Date(2014, 9, 7, 14, 0))
	 * //=> true
	 */
	function isTomorrow(dirtyDate) {
	  (0, _index3.default)(1, arguments);
	  return (0, _index2.default)(dirtyDate, (0, _index.default)(Date.now(), 1));
	}
	
	module.exports = exports.default;

/***/ },
/* 970 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isTuesday;
	
	var _index = _interopRequireDefault(__webpack_require__(3));
	
	var _index2 = _interopRequireDefault(__webpack_require__(2));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name isTuesday
	 * @category Weekday Helpers
	 * @summary Is the given date Tuesday?
	 *
	 * @description
	 * Is the given date Tuesday?
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} date - the date to check
	 * @returns {Boolean} the date is Tuesday
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // Is 23 September 2014 Tuesday?
	 * var result = isTuesday(new Date(2014, 8, 23))
	 * //=> true
	 */
	function isTuesday(dirtyDate) {
	  (0, _index2.default)(1, arguments);
	  return (0, _index.default)(dirtyDate).getDay() === 2;
	}
	
	module.exports = exports.default;

/***/ },
/* 971 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isWednesday;
	
	var _index = _interopRequireDefault(__webpack_require__(3));
	
	var _index2 = _interopRequireDefault(__webpack_require__(2));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name isWednesday
	 * @category Weekday Helpers
	 * @summary Is the given date Wednesday?
	 *
	 * @description
	 * Is the given date Wednesday?
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} date - the date to check
	 * @returns {Boolean} the date is Wednesday
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // Is 24 September 2014 Wednesday?
	 * var result = isWednesday(new Date(2014, 8, 24))
	 * //=> true
	 */
	function isWednesday(dirtyDate) {
	  (0, _index2.default)(1, arguments);
	  return (0, _index.default)(dirtyDate).getDay() === 3;
	}
	
	module.exports = exports.default;

/***/ },
/* 972 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isYesterday;
	
	var _index = _interopRequireDefault(__webpack_require__(114));
	
	var _index2 = _interopRequireDefault(__webpack_require__(192));
	
	var _index3 = _interopRequireDefault(__webpack_require__(2));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name isYesterday
	 * @category Day Helpers
	 * @summary Is the given date yesterday?
	 * @pure false
	 *
	 * @description
	 * Is the given date yesterday?
	 *
	 * > ⚠️ Please note that this function is not present in the FP submodule as
	 * > it uses `Date.now()` internally hence impure and can't be safely curried.
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} date - the date to check
	 * @returns {Boolean} the date is yesterday
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // If today is 6 October 2014, is 5 October 14:00:00 yesterday?
	 * var result = isYesterday(new Date(2014, 9, 5, 14, 0))
	 * //=> true
	 */
	function isYesterday(dirtyDate) {
	  (0, _index3.default)(1, arguments);
	  return (0, _index.default)(dirtyDate, (0, _index2.default)(Date.now(), 1));
	}
	
	module.exports = exports.default;

/***/ },
/* 973 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = lastDayOfDecade;
	
	var _index = _interopRequireDefault(__webpack_require__(3));
	
	var _index2 = _interopRequireDefault(__webpack_require__(2));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name lastDayOfDecade
	 * @category Decade Helpers
	 * @summary Return the last day of a decade for the given date.
	 *
	 * @description
	 * Return the last day of a decade for the given date.
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} date - the original date
	 * @returns {Date} the last day of a decade
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // The last day of a decade for 21 December 2012 21:12:00:
	 * var result = lastDayOfDecade(new Date(2012, 11, 21, 21, 12, 00))
	 * //=> Wed Dec 31 2019 00:00:00
	 */
	function lastDayOfDecade(dirtyDate) {
	  (0, _index2.default)(1, arguments);
	  var date = (0, _index.default)(dirtyDate);
	  var year = date.getFullYear();
	  var decade = 9 + Math.floor(year / 10) * 10;
	  date.setFullYear(decade + 1, 0, 0);
	  date.setHours(0, 0, 0, 0);
	  return date;
	}
	
	module.exports = exports.default;

/***/ },
/* 974 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = lastDayOfISOWeekYear;
	
	var _index = _interopRequireDefault(__webpack_require__(113));
	
	var _index2 = _interopRequireDefault(__webpack_require__(99));
	
	var _index3 = _interopRequireDefault(__webpack_require__(2));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name lastDayOfISOWeekYear
	 * @category ISO Week-Numbering Year Helpers
	 * @summary Return the last day of an ISO week-numbering year for the given date.
	 *
	 * @description
	 * Return the last day of an ISO week-numbering year,
	 * which always starts 3 days before the year's first Thursday.
	 * The result will be in the local timezone.
	 *
	 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * - The function was renamed from `lastDayOfISOYear` to `lastDayOfISOWeekYear`.
	 *   "ISO week year" is short for [ISO week-numbering year](https://en.wikipedia.org/wiki/ISO_week_date).
	 *   This change makes the name consistent with
	 *   locale-dependent week-numbering year helpers, e.g., `getWeekYear`.
	 *
	 * @param {Date|Number} date - the original date
	 * @returns {Date} the end of an ISO week-numbering year
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // The last day of an ISO week-numbering year for 2 July 2005:
	 * var result = lastDayOfISOWeekYear(new Date(2005, 6, 2))
	 * //=> Sun Jan 01 2006 00:00:00
	 */
	function lastDayOfISOWeekYear(dirtyDate) {
	  (0, _index3.default)(1, arguments);
	  var year = (0, _index.default)(dirtyDate);
	  var fourthOfJanuary = new Date(0);
	  fourthOfJanuary.setFullYear(year + 1, 0, 4);
	  fourthOfJanuary.setHours(0, 0, 0, 0);
	  var date = (0, _index2.default)(fourthOfJanuary);
	  date.setDate(date.getDate() - 1);
	  return date;
	}
	
	module.exports = exports.default;

/***/ },
/* 975 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = lastDayOfISOWeek;
	
	var _index = _interopRequireDefault(__webpack_require__(426));
	
	var _index2 = _interopRequireDefault(__webpack_require__(2));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name lastDayOfISOWeek
	 * @category ISO Week Helpers
	 * @summary Return the last day of an ISO week for the given date.
	 *
	 * @description
	 * Return the last day of an ISO week for the given date.
	 * The result will be in the local timezone.
	 *
	 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} date - the original date
	 * @returns {Date} the last day of an ISO week
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // The last day of an ISO week for 2 September 2014 11:55:00:
	 * var result = lastDayOfISOWeek(new Date(2014, 8, 2, 11, 55, 0))
	 * //=> Sun Sep 07 2014 00:00:00
	 */
	function lastDayOfISOWeek(dirtyDate) {
	  (0, _index2.default)(1, arguments);
	  return (0, _index.default)(dirtyDate, {
	    weekStartsOn: 1
	  });
	}
	
	module.exports = exports.default;

/***/ },
/* 976 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = lastDayOfQuarter;
	
	var _index = _interopRequireDefault(__webpack_require__(3));
	
	var _index2 = _interopRequireDefault(__webpack_require__(2));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name lastDayOfQuarter
	 * @category Quarter Helpers
	 * @summary Return the last day of a year quarter for the given date.
	 *
	 * @description
	 * Return the last day of a year quarter for the given date.
	 * The result will be in the local timezone.
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} date - the original date
	 * @param {Object} [options] - an object with options.
	 * @param {0|1|2} [options.additionalDigits=2] - passed to `toDate`. See [toDate]{@link https://date-fns.org/docs/toDate}
	 * @returns {Date} the last day of a quarter
	 * @throws {TypeError} 1 argument required
	 * @throws {RangeError} `options.additionalDigits` must be 0, 1 or 2
	 *
	 * @example
	 * // The last day of a quarter for 2 September 2014 11:55:00:
	 * var result = lastDayOfQuarter(new Date(2014, 8, 2, 11, 55, 0))
	 * //=> Tue Sep 30 2014 00:00:00
	 */
	function lastDayOfQuarter(dirtyDate) {
	  (0, _index2.default)(1, arguments);
	  var date = (0, _index.default)(dirtyDate);
	  var currentMonth = date.getMonth();
	  var month = currentMonth - currentMonth % 3 + 3;
	  date.setMonth(month, 0);
	  date.setHours(0, 0, 0, 0);
	  return date;
	}
	
	module.exports = exports.default;

/***/ },
/* 977 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = lastDayOfYear;
	
	var _index = _interopRequireDefault(__webpack_require__(3));
	
	var _index2 = _interopRequireDefault(__webpack_require__(2));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name lastDayOfYear
	 * @category Year Helpers
	 * @summary Return the last day of a year for the given date.
	 *
	 * @description
	 * Return the last day of a year for the given date.
	 * The result will be in the local timezone.
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} date - the original date
	 * @returns {Date} the last day of a year
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // The last day of a year for 2 September 2014 11:55:00:
	 * var result = lastDayOfYear(new Date(2014, 8, 2, 11, 55, 00))
	 * //=> Wed Dec 31 2014 00:00:00
	 */
	function lastDayOfYear(dirtyDate) {
	  (0, _index2.default)(1, arguments);
	  var date = (0, _index.default)(dirtyDate);
	  var year = date.getFullYear();
	  date.setFullYear(year + 1, 0, 0);
	  date.setHours(0, 0, 0, 0);
	  return date;
	}
	
	module.exports = exports.default;

/***/ },
/* 978 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = lightFormat;
	
	var _index = _interopRequireDefault(__webpack_require__(3));
	
	var _index2 = _interopRequireDefault(__webpack_require__(391));
	
	var _index3 = _interopRequireDefault(__webpack_require__(73));
	
	var _index4 = _interopRequireDefault(__webpack_require__(43));
	
	var _index5 = _interopRequireDefault(__webpack_require__(143));
	
	var _index6 = _interopRequireDefault(__webpack_require__(2));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// This RegExp consists of three parts separated by `|`:
	// - (\w)\1* matches any sequences of the same letter
	// - '' matches two quote characters in a row
	// - '(''|[^'])+('|$) matches anything surrounded by two quote characters ('),
	//   except a single quote symbol, which ends the sequence.
	//   Two quote characters do not end the sequence.
	//   If there is no matching single quote
	//   then the sequence will continue until the end of the string.
	// - . matches any single character unmatched by previous parts of the RegExps
	var formattingTokensRegExp = /(\w)\1*|''|'(''|[^'])+('|$)|./g;
	var escapedStringRegExp = /^'([^]*?)'?$/;
	var doubleQuoteRegExp = /''/g;
	var unescapedLatinCharacterRegExp = /[a-zA-Z]/;
	/**
	 * @name lightFormat
	 * @category Common Helpers
	 * @summary Format the date.
	 *
	 * @description
	 * Return the formatted date string in the given format. Unlike `format`,
	 * `lightFormat` doesn't use locales and outputs date using the most popular tokens.
	 *
	 * > ⚠️ Please note that the `lightFormat` tokens differ from Moment.js and other libraries.
	 * > See: https://git.io/fxCyr
	 *
	 * The characters wrapped between two single quotes characters (') are escaped.
	 * Two single quotes in a row, whether inside or outside a quoted sequence, represent a 'real' single quote.
	 *
	 * Format of the string is based on Unicode Technical Standard #35:
	 * https://www.unicode.org/reports/tr35/tr35-dates.html#Date_Field_Symbol_Table
	 *
	 * Accepted patterns:
	 * | Unit                            | Pattern | Result examples                   |
	 * |---------------------------------|---------|-----------------------------------|
	 * | AM, PM                          | a..aaa  | AM, PM                            |
	 * |                                 | aaaa    | a.m., p.m.                        |
	 * |                                 | aaaaa   | a, p                              |
	 * | Calendar year                   | y       | 44, 1, 1900, 2017                 |
	 * |                                 | yy      | 44, 01, 00, 17                    |
	 * |                                 | yyy     | 044, 001, 000, 017                |
	 * |                                 | yyyy    | 0044, 0001, 1900, 2017            |
	 * | Month (formatting)              | M       | 1, 2, ..., 12                     |
	 * |                                 | MM      | 01, 02, ..., 12                   |
	 * | Day of month                    | d       | 1, 2, ..., 31                     |
	 * |                                 | dd      | 01, 02, ..., 31                   |
	 * | Hour [1-12]                     | h       | 1, 2, ..., 11, 12                 |
	 * |                                 | hh      | 01, 02, ..., 11, 12               |
	 * | Hour [0-23]                     | H       | 0, 1, 2, ..., 23                  |
	 * |                                 | HH      | 00, 01, 02, ..., 23               |
	 * | Minute                          | m       | 0, 1, ..., 59                     |
	 * |                                 | mm      | 00, 01, ..., 59                   |
	 * | Second                          | s       | 0, 1, ..., 59                     |
	 * |                                 | ss      | 00, 01, ..., 59                   |
	 * | Fraction of second              | S       | 0, 1, ..., 9                      |
	 * |                                 | SS      | 00, 01, ..., 99                   |
	 * |                                 | SSS     | 000, 0001, ..., 999               |
	 * |                                 | SSSS    | ...                               |
	 *
	 * @param {Date|Number} date - the original date
	 * @param {String} format - the string of tokens
	 * @returns {String} the formatted date string
	 * @throws {TypeError} 2 arguments required
	 * @throws {RangeError} format string contains an unescaped latin alphabet character
	 *
	 * @example
	 * var result = lightFormat(new Date(2014, 1, 11), 'yyyy-MM-dd')
	 * //=> '1987-02-11'
	 */
	
	function lightFormat(dirtyDate, dirtyFormatStr) {
	  (0, _index6.default)(2, arguments);
	  var formatStr = String(dirtyFormatStr);
	  var originalDate = (0, _index.default)(dirtyDate);
	
	  if (!(0, _index4.default)(originalDate)) {
	    throw new RangeError('Invalid time value');
	  } // Convert the date in system timezone to the same date in UTC+00:00 timezone.
	  // This ensures that when UTC functions will be implemented, locales will be compatible with them.
	  // See an issue about UTC functions: https://github.com/date-fns/date-fns/issues/376
	
	
	  var timezoneOffset = (0, _index3.default)(originalDate);
	  var utcDate = (0, _index5.default)(originalDate, timezoneOffset);
	  var result = formatStr.match(formattingTokensRegExp).map(function (substring) {
	    // Replace two single quote characters with one single quote character
	    if (substring === "''") {
	      return "'";
	    }
	
	    var firstCharacter = substring[0];
	
	    if (firstCharacter === "'") {
	      return cleanEscapedString(substring);
	    }
	
	    var formatter = _index2.default[firstCharacter];
	
	    if (formatter) {
	      return formatter(utcDate, substring, null, {});
	    }
	
	    if (firstCharacter.match(unescapedLatinCharacterRegExp)) {
	      throw new RangeError('Format string contains an unescaped latin alphabet character `' + firstCharacter + '`');
	    }
	
	    return substring;
	  }).join('');
	  return result;
	}
	
	function cleanEscapedString(input) {
	  return input.match(escapedStringRegExp)[1].replace(doubleQuoteRegExp, "'");
	}
	
	module.exports = exports.default;

/***/ },
/* 979 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = buildFormatLongFn;
	
	function buildFormatLongFn(args) {
	  return function (dirtyOptions) {
	    var options = dirtyOptions || {};
	    var width = options.width ? String(options.width) : args.defaultWidth;
	    var format = args.formats[width] || args.formats[args.defaultWidth];
	    return format;
	  };
	}
	
	module.exports = exports.default;

/***/ },
/* 980 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = buildLocalizeFn;
	
	function buildLocalizeFn(args) {
	  return function (dirtyIndex, dirtyOptions) {
	    var options = dirtyOptions || {};
	    var context = options.context ? String(options.context) : 'standalone';
	    var valuesArray;
	
	    if (context === 'formatting' && args.formattingValues) {
	      var defaultWidth = args.defaultFormattingWidth || args.defaultWidth;
	      var width = options.width ? String(options.width) : defaultWidth;
	      valuesArray = args.formattingValues[width] || args.formattingValues[defaultWidth];
	    } else {
	      var _defaultWidth = args.defaultWidth;
	
	      var _width = options.width ? String(options.width) : args.defaultWidth;
	
	      valuesArray = args.values[_width] || args.values[_defaultWidth];
	    }
	
	    var index = args.argumentCallback ? args.argumentCallback(dirtyIndex) : dirtyIndex;
	    return valuesArray[index];
	  };
	}
	
	module.exports = exports.default;

/***/ },
/* 981 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = buildMatchFn;
	
	function buildMatchFn(args) {
	  return function (dirtyString, dirtyOptions) {
	    var string = String(dirtyString);
	    var options = dirtyOptions || {};
	    var width = options.width;
	    var matchPattern = width && args.matchPatterns[width] || args.matchPatterns[args.defaultMatchWidth];
	    var matchResult = string.match(matchPattern);
	
	    if (!matchResult) {
	      return null;
	    }
	
	    var matchedString = matchResult[0];
	    var parsePatterns = width && args.parsePatterns[width] || args.parsePatterns[args.defaultParseWidth];
	    var value;
	
	    if (Object.prototype.toString.call(parsePatterns) === '[object Array]') {
	      value = findIndex(parsePatterns, function (pattern) {
	        return pattern.test(matchedString);
	      });
	    } else {
	      value = findKey(parsePatterns, function (pattern) {
	        return pattern.test(matchedString);
	      });
	    }
	
	    value = args.valueCallback ? args.valueCallback(value) : value;
	    value = options.valueCallback ? options.valueCallback(value) : value;
	    return {
	      value: value,
	      rest: string.slice(matchedString.length)
	    };
	  };
	}
	
	function findKey(object, predicate) {
	  for (var key in object) {
	    if (object.hasOwnProperty(key) && predicate(object[key])) {
	      return key;
	    }
	  }
	}
	
	function findIndex(array, predicate) {
	  for (var key = 0; key < array.length; key++) {
	    if (predicate(array[key])) {
	      return key;
	    }
	  }
	}
	
	module.exports = exports.default;

/***/ },
/* 982 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = buildMatchPatternFn;
	
	function buildMatchPatternFn(args) {
	  return function (dirtyString, dirtyOptions) {
	    var string = String(dirtyString);
	    var options = dirtyOptions || {};
	    var matchResult = string.match(args.matchPattern);
	
	    if (!matchResult) {
	      return null;
	    }
	
	    var matchedString = matchResult[0];
	    var parseResult = string.match(args.parsePattern);
	
	    if (!parseResult) {
	      return null;
	    }
	
	    var value = args.valueCallback ? args.valueCallback(parseResult[0]) : parseResult[0];
	    value = options.valueCallback ? options.valueCallback(value) : value;
	    return {
	      value: value,
	      rest: string.slice(matchedString.length)
	    };
	  };
	}
	
	module.exports = exports.default;

/***/ },
/* 983 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = formatDistance;
	var formatDistanceLocale = {
	  lessThanXSeconds: {
	    one: 'less than a second',
	    other: 'less than {{count}} seconds'
	  },
	  xSeconds: {
	    one: '1 second',
	    other: '{{count}} seconds'
	  },
	  halfAMinute: 'half a minute',
	  lessThanXMinutes: {
	    one: 'less than a minute',
	    other: 'less than {{count}} minutes'
	  },
	  xMinutes: {
	    one: '1 minute',
	    other: '{{count}} minutes'
	  },
	  aboutXHours: {
	    one: 'about 1 hour',
	    other: 'about {{count}} hours'
	  },
	  xHours: {
	    one: '1 hour',
	    other: '{{count}} hours'
	  },
	  xDays: {
	    one: '1 day',
	    other: '{{count}} days'
	  },
	  aboutXWeeks: {
	    one: 'about 1 week',
	    other: 'about {{count}} weeks'
	  },
	  xWeeks: {
	    one: '1 week',
	    other: '{{count}} weeks'
	  },
	  aboutXMonths: {
	    one: 'about 1 month',
	    other: 'about {{count}} months'
	  },
	  xMonths: {
	    one: '1 month',
	    other: '{{count}} months'
	  },
	  aboutXYears: {
	    one: 'about 1 year',
	    other: 'about {{count}} years'
	  },
	  xYears: {
	    one: '1 year',
	    other: '{{count}} years'
	  },
	  overXYears: {
	    one: 'over 1 year',
	    other: 'over {{count}} years'
	  },
	  almostXYears: {
	    one: 'almost 1 year',
	    other: 'almost {{count}} years'
	  }
	};
	
	function formatDistance(token, count, options) {
	  options = options || {};
	  var result;
	
	  if (typeof formatDistanceLocale[token] === 'string') {
	    result = formatDistanceLocale[token];
	  } else if (count === 1) {
	    result = formatDistanceLocale[token].one;
	  } else {
	    result = formatDistanceLocale[token].other.replace('{{count}}', count);
	  }
	
	  if (options.addSuffix) {
	    if (options.comparison > 0) {
	      return 'in ' + result;
	    } else {
	      return result + ' ago';
	    }
	  }
	
	  return result;
	}
	
	module.exports = exports.default;

/***/ },
/* 984 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(979));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var dateFormats = {
	  full: 'EEEE, MMMM do, y',
	  long: 'MMMM do, y',
	  medium: 'MMM d, y',
	  short: 'MM/dd/yyyy'
	};
	var timeFormats = {
	  full: 'h:mm:ss a zzzz',
	  long: 'h:mm:ss a z',
	  medium: 'h:mm:ss a',
	  short: 'h:mm a'
	};
	var dateTimeFormats = {
	  full: "{{date}} 'at' {{time}}",
	  long: "{{date}} 'at' {{time}}",
	  medium: '{{date}}, {{time}}',
	  short: '{{date}}, {{time}}'
	};
	var formatLong = {
	  date: (0, _index.default)({
	    formats: dateFormats,
	    defaultWidth: 'full'
	  }),
	  time: (0, _index.default)({
	    formats: timeFormats,
	    defaultWidth: 'full'
	  }),
	  dateTime: (0, _index.default)({
	    formats: dateTimeFormats,
	    defaultWidth: 'full'
	  })
	};
	var _default = formatLong;
	exports.default = _default;
	module.exports = exports.default;

/***/ },
/* 985 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = formatRelative;
	var formatRelativeLocale = {
	  lastWeek: "'last' eeee 'at' p",
	  yesterday: "'yesterday at' p",
	  today: "'today at' p",
	  tomorrow: "'tomorrow at' p",
	  nextWeek: "eeee 'at' p",
	  other: 'P'
	};
	
	function formatRelative(token, _date, _baseDate, _options) {
	  return formatRelativeLocale[token];
	}
	
	module.exports = exports.default;

/***/ },
/* 986 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(980));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var eraValues = {
	  narrow: ['B', 'A'],
	  abbreviated: ['BC', 'AD'],
	  wide: ['Before Christ', 'Anno Domini']
	};
	var quarterValues = {
	  narrow: ['1', '2', '3', '4'],
	  abbreviated: ['Q1', 'Q2', 'Q3', 'Q4'],
	  wide: ['1st quarter', '2nd quarter', '3rd quarter', '4th quarter'] // Note: in English, the names of days of the week and months are capitalized.
	  // If you are making a new locale based on this one, check if the same is true for the language you're working on.
	  // Generally, formatted dates should look like they are in the middle of a sentence,
	  // e.g. in Spanish language the weekdays and months should be in the lowercase.
	
	};
	var monthValues = {
	  narrow: ['J', 'F', 'M', 'A', 'M', 'J', 'J', 'A', 'S', 'O', 'N', 'D'],
	  abbreviated: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
	  wide: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December']
	};
	var dayValues = {
	  narrow: ['S', 'M', 'T', 'W', 'T', 'F', 'S'],
	  short: ['Su', 'Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa'],
	  abbreviated: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
	  wide: ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday']
	};
	var dayPeriodValues = {
	  narrow: {
	    am: 'a',
	    pm: 'p',
	    midnight: 'mi',
	    noon: 'n',
	    morning: 'morning',
	    afternoon: 'afternoon',
	    evening: 'evening',
	    night: 'night'
	  },
	  abbreviated: {
	    am: 'AM',
	    pm: 'PM',
	    midnight: 'midnight',
	    noon: 'noon',
	    morning: 'morning',
	    afternoon: 'afternoon',
	    evening: 'evening',
	    night: 'night'
	  },
	  wide: {
	    am: 'a.m.',
	    pm: 'p.m.',
	    midnight: 'midnight',
	    noon: 'noon',
	    morning: 'morning',
	    afternoon: 'afternoon',
	    evening: 'evening',
	    night: 'night'
	  }
	};
	var formattingDayPeriodValues = {
	  narrow: {
	    am: 'a',
	    pm: 'p',
	    midnight: 'mi',
	    noon: 'n',
	    morning: 'in the morning',
	    afternoon: 'in the afternoon',
	    evening: 'in the evening',
	    night: 'at night'
	  },
	  abbreviated: {
	    am: 'AM',
	    pm: 'PM',
	    midnight: 'midnight',
	    noon: 'noon',
	    morning: 'in the morning',
	    afternoon: 'in the afternoon',
	    evening: 'in the evening',
	    night: 'at night'
	  },
	  wide: {
	    am: 'a.m.',
	    pm: 'p.m.',
	    midnight: 'midnight',
	    noon: 'noon',
	    morning: 'in the morning',
	    afternoon: 'in the afternoon',
	    evening: 'in the evening',
	    night: 'at night'
	  }
	};
	
	function ordinalNumber(dirtyNumber, _dirtyOptions) {
	  var number = Number(dirtyNumber); // If ordinal numbers depend on context, for example,
	  // if they are different for different grammatical genders,
	  // use `options.unit`:
	  //
	  //   var options = dirtyOptions || {}
	  //   var unit = String(options.unit)
	  //
	  // where `unit` can be 'year', 'quarter', 'month', 'week', 'date', 'dayOfYear',
	  // 'day', 'hour', 'minute', 'second'
	
	  var rem100 = number % 100;
	
	  if (rem100 > 20 || rem100 < 10) {
	    switch (rem100 % 10) {
	      case 1:
	        return number + 'st';
	
	      case 2:
	        return number + 'nd';
	
	      case 3:
	        return number + 'rd';
	    }
	  }
	
	  return number + 'th';
	}
	
	var localize = {
	  ordinalNumber: ordinalNumber,
	  era: (0, _index.default)({
	    values: eraValues,
	    defaultWidth: 'wide'
	  }),
	  quarter: (0, _index.default)({
	    values: quarterValues,
	    defaultWidth: 'wide',
	    argumentCallback: function (quarter) {
	      return Number(quarter) - 1;
	    }
	  }),
	  month: (0, _index.default)({
	    values: monthValues,
	    defaultWidth: 'wide'
	  }),
	  day: (0, _index.default)({
	    values: dayValues,
	    defaultWidth: 'wide'
	  }),
	  dayPeriod: (0, _index.default)({
	    values: dayPeriodValues,
	    defaultWidth: 'wide',
	    formattingValues: formattingDayPeriodValues,
	    defaultFormattingWidth: 'wide'
	  })
	};
	var _default = localize;
	exports.default = _default;
	module.exports = exports.default;

/***/ },
/* 987 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(982));
	
	var _index2 = _interopRequireDefault(__webpack_require__(981));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var matchOrdinalNumberPattern = /^(\d+)(th|st|nd|rd)?/i;
	var parseOrdinalNumberPattern = /\d+/i;
	var matchEraPatterns = {
	  narrow: /^(b|a)/i,
	  abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
	  wide: /^(before christ|before common era|anno domini|common era)/i
	};
	var parseEraPatterns = {
	  any: [/^b/i, /^(a|c)/i]
	};
	var matchQuarterPatterns = {
	  narrow: /^[1234]/i,
	  abbreviated: /^q[1234]/i,
	  wide: /^[1234](th|st|nd|rd)? quarter/i
	};
	var parseQuarterPatterns = {
	  any: [/1/i, /2/i, /3/i, /4/i]
	};
	var matchMonthPatterns = {
	  narrow: /^[jfmasond]/i,
	  abbreviated: /^(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)/i,
	  wide: /^(january|february|march|april|may|june|july|august|september|october|november|december)/i
	};
	var parseMonthPatterns = {
	  narrow: [/^j/i, /^f/i, /^m/i, /^a/i, /^m/i, /^j/i, /^j/i, /^a/i, /^s/i, /^o/i, /^n/i, /^d/i],
	  any: [/^ja/i, /^f/i, /^mar/i, /^ap/i, /^may/i, /^jun/i, /^jul/i, /^au/i, /^s/i, /^o/i, /^n/i, /^d/i]
	};
	var matchDayPatterns = {
	  narrow: /^[smtwf]/i,
	  short: /^(su|mo|tu|we|th|fr|sa)/i,
	  abbreviated: /^(sun|mon|tue|wed|thu|fri|sat)/i,
	  wide: /^(sunday|monday|tuesday|wednesday|thursday|friday|saturday)/i
	};
	var parseDayPatterns = {
	  narrow: [/^s/i, /^m/i, /^t/i, /^w/i, /^t/i, /^f/i, /^s/i],
	  any: [/^su/i, /^m/i, /^tu/i, /^w/i, /^th/i, /^f/i, /^sa/i]
	};
	var matchDayPeriodPatterns = {
	  narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
	  any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
	};
	var parseDayPeriodPatterns = {
	  any: {
	    am: /^a/i,
	    pm: /^p/i,
	    midnight: /^mi/i,
	    noon: /^no/i,
	    morning: /morning/i,
	    afternoon: /afternoon/i,
	    evening: /evening/i,
	    night: /night/i
	  }
	};
	var match = {
	  ordinalNumber: (0, _index.default)({
	    matchPattern: matchOrdinalNumberPattern,
	    parsePattern: parseOrdinalNumberPattern,
	    valueCallback: function (value) {
	      return parseInt(value, 10);
	    }
	  }),
	  era: (0, _index2.default)({
	    matchPatterns: matchEraPatterns,
	    defaultMatchWidth: 'wide',
	    parsePatterns: parseEraPatterns,
	    defaultParseWidth: 'any'
	  }),
	  quarter: (0, _index2.default)({
	    matchPatterns: matchQuarterPatterns,
	    defaultMatchWidth: 'wide',
	    parsePatterns: parseQuarterPatterns,
	    defaultParseWidth: 'any',
	    valueCallback: function (index) {
	      return index + 1;
	    }
	  }),
	  month: (0, _index2.default)({
	    matchPatterns: matchMonthPatterns,
	    defaultMatchWidth: 'wide',
	    parsePatterns: parseMonthPatterns,
	    defaultParseWidth: 'any'
	  }),
	  day: (0, _index2.default)({
	    matchPatterns: matchDayPatterns,
	    defaultMatchWidth: 'wide',
	    parsePatterns: parseDayPatterns,
	    defaultParseWidth: 'any'
	  }),
	  dayPeriod: (0, _index2.default)({
	    matchPatterns: matchDayPeriodPatterns,
	    defaultMatchWidth: 'any',
	    parsePatterns: parseDayPeriodPatterns,
	    defaultParseWidth: 'any'
	  })
	};
	var _default = match;
	exports.default = _default;
	module.exports = exports.default;

/***/ },
/* 988 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = parseJSON;
	
	var _index = _interopRequireDefault(__webpack_require__(3));
	
	var _index2 = _interopRequireDefault(__webpack_require__(2));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name parseJSON
	 * @category Common Helpers
	 * @summary Parse a JSON date string
	 *
	 * @description
	 * Converts a complete ISO date string in UTC time, the typical format for transmitting
	 * a date in JSON, to a JavaScript `Date` instance.
	 *
	 * This is a minimal implementation for converting dates retrieved from a JSON API to
	 * a `Date` instance which can be used with other functions in the `date-fns` library.
	 * The following formats are supported:
	 *
	 *     - `2000-03-15T05:20:10.123Z`: The output of `.toISOString()` and `JSON.stringify(new Date())`
	 *     - `2000-03-15T05:20:10Z`: Without milliseconds
	 *     - `2000-03-15T05:20:10+00:00`: With a zero offset, the default JSON encoded format in some other languages
	 *     - `2000-03-15T05:20:10+0000`: With a zero offset without a colon
	 *     - `2000-03-15T05:20:10`: Without a trailing 'Z' symbol
	 *     - `2000-03-15T05:20:10.1234567`: Up to 7 digits in milliseconds field. Only first 3 are taken into account since JS does not allow fractional milliseconds
	 *     - `2000-03-15 05:20:10`: With a space instead of a 'T' separator for APIs returning a SQL date without reformatting
	 *
	 * For convenience and ease of use these other input types are also supported
	 * via [toDate]{@link https://date-fns.org/docs/toDate}:
	 *
	 *     - A `Date` instance will be cloned
	 *     - A `number` will be treated as a timestamp
	 *
	 * Any other input type or invalid date strings will return an `Invalid Date`.
	 *
	 * @param {String|Number|Date} argument A fully formed ISO8601 date string to convert
	 * @returns {Date} the parsed date in the local time zone
	 * @throws {TypeError} 1 argument required
	 */
	function parseJSON(argument) {
	  (0, _index2.default)(1, arguments);
	
	  if (typeof argument === 'string') {
	    var parts = argument.match(/(\d{4})-(\d{2})-(\d{2})[T ](\d{2}):(\d{2}):(\d{2})(?:\.(\d{0,7}))?(?:Z|\+00:?00)?/);
	
	    if (parts) {
	      return new Date(Date.UTC(+parts[1], parts[2] - 1, +parts[3], +parts[4], +parts[5], +parts[6], +((parts[7] || '0') + '00').substring(0, 3)));
	    }
	
	    return new Date(NaN);
	  }
	
	  return (0, _index.default)(argument);
	}
	
	module.exports = exports.default;

/***/ },
/* 989 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(260));
	
	var _index2 = _interopRequireDefault(__webpack_require__(895));
	
	var _index3 = _interopRequireDefault(__webpack_require__(896));
	
	var _index4 = _interopRequireDefault(__webpack_require__(897));
	
	var _index5 = _interopRequireDefault(__webpack_require__(898));
	
	var _index6 = _interopRequireDefault(__webpack_require__(179));
	
	var _index7 = _interopRequireDefault(__webpack_require__(180));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MILLISECONDS_IN_HOUR = 3600000;
	var MILLISECONDS_IN_MINUTE = 60000;
	var MILLISECONDS_IN_SECOND = 1000;
	var numericPatterns = {
	  month: /^(1[0-2]|0?\d)/,
	  // 0 to 12
	  date: /^(3[0-1]|[0-2]?\d)/,
	  // 0 to 31
	  dayOfYear: /^(36[0-6]|3[0-5]\d|[0-2]?\d?\d)/,
	  // 0 to 366
	  week: /^(5[0-3]|[0-4]?\d)/,
	  // 0 to 53
	  hour23h: /^(2[0-3]|[0-1]?\d)/,
	  // 0 to 23
	  hour24h: /^(2[0-4]|[0-1]?\d)/,
	  // 0 to 24
	  hour11h: /^(1[0-1]|0?\d)/,
	  // 0 to 11
	  hour12h: /^(1[0-2]|0?\d)/,
	  // 0 to 12
	  minute: /^[0-5]?\d/,
	  // 0 to 59
	  second: /^[0-5]?\d/,
	  // 0 to 59
	  singleDigit: /^\d/,
	  // 0 to 9
	  twoDigits: /^\d{1,2}/,
	  // 0 to 99
	  threeDigits: /^\d{1,3}/,
	  // 0 to 999
	  fourDigits: /^\d{1,4}/,
	  // 0 to 9999
	  anyDigitsSigned: /^-?\d+/,
	  singleDigitSigned: /^-?\d/,
	  // 0 to 9, -0 to -9
	  twoDigitsSigned: /^-?\d{1,2}/,
	  // 0 to 99, -0 to -99
	  threeDigitsSigned: /^-?\d{1,3}/,
	  // 0 to 999, -0 to -999
	  fourDigitsSigned: /^-?\d{1,4}/ // 0 to 9999, -0 to -9999
	
	};
	var timezonePatterns = {
	  basicOptionalMinutes: /^([+-])(\d{2})(\d{2})?|Z/,
	  basic: /^([+-])(\d{2})(\d{2})|Z/,
	  basicOptionalSeconds: /^([+-])(\d{2})(\d{2})((\d{2}))?|Z/,
	  extended: /^([+-])(\d{2}):(\d{2})|Z/,
	  extendedOptionalSeconds: /^([+-])(\d{2}):(\d{2})(:(\d{2}))?|Z/
	};
	
	function parseNumericPattern(pattern, string, valueCallback) {
	  var matchResult = string.match(pattern);
	
	  if (!matchResult) {
	    return null;
	  }
	
	  var value = parseInt(matchResult[0], 10);
	  return {
	    value: valueCallback ? valueCallback(value) : value,
	    rest: string.slice(matchResult[0].length)
	  };
	}
	
	function parseTimezonePattern(pattern, string) {
	  var matchResult = string.match(pattern);
	
	  if (!matchResult) {
	    return null;
	  } // Input is 'Z'
	
	
	  if (matchResult[0] === 'Z') {
	    return {
	      value: 0,
	      rest: string.slice(1)
	    };
	  }
	
	  var sign = matchResult[1] === '+' ? 1 : -1;
	  var hours = matchResult[2] ? parseInt(matchResult[2], 10) : 0;
	  var minutes = matchResult[3] ? parseInt(matchResult[3], 10) : 0;
	  var seconds = matchResult[5] ? parseInt(matchResult[5], 10) : 0;
	  return {
	    value: sign * (hours * MILLISECONDS_IN_HOUR + minutes * MILLISECONDS_IN_MINUTE + seconds * MILLISECONDS_IN_SECOND),
	    rest: string.slice(matchResult[0].length)
	  };
	}
	
	function parseAnyDigitsSigned(string, valueCallback) {
	  return parseNumericPattern(numericPatterns.anyDigitsSigned, string, valueCallback);
	}
	
	function parseNDigits(n, string, valueCallback) {
	  switch (n) {
	    case 1:
	      return parseNumericPattern(numericPatterns.singleDigit, string, valueCallback);
	
	    case 2:
	      return parseNumericPattern(numericPatterns.twoDigits, string, valueCallback);
	
	    case 3:
	      return parseNumericPattern(numericPatterns.threeDigits, string, valueCallback);
	
	    case 4:
	      return parseNumericPattern(numericPatterns.fourDigits, string, valueCallback);
	
	    default:
	      return parseNumericPattern(new RegExp('^\\d{1,' + n + '}'), string, valueCallback);
	  }
	}
	
	function parseNDigitsSigned(n, string, valueCallback) {
	  switch (n) {
	    case 1:
	      return parseNumericPattern(numericPatterns.singleDigitSigned, string, valueCallback);
	
	    case 2:
	      return parseNumericPattern(numericPatterns.twoDigitsSigned, string, valueCallback);
	
	    case 3:
	      return parseNumericPattern(numericPatterns.threeDigitsSigned, string, valueCallback);
	
	    case 4:
	      return parseNumericPattern(numericPatterns.fourDigitsSigned, string, valueCallback);
	
	    default:
	      return parseNumericPattern(new RegExp('^-?\\d{1,' + n + '}'), string, valueCallback);
	  }
	}
	
	function dayPeriodEnumToHours(enumValue) {
	  switch (enumValue) {
	    case 'morning':
	      return 4;
	
	    case 'evening':
	      return 17;
	
	    case 'pm':
	    case 'noon':
	    case 'afternoon':
	      return 12;
	
	    case 'am':
	    case 'midnight':
	    case 'night':
	    default:
	      return 0;
	  }
	}
	
	function normalizeTwoDigitYear(twoDigitYear, currentYear) {
	  var isCommonEra = currentYear > 0; // Absolute number of the current year:
	  // 1 -> 1 AC
	  // 0 -> 1 BC
	  // -1 -> 2 BC
	
	  var absCurrentYear = isCommonEra ? currentYear : 1 - currentYear;
	  var result;
	
	  if (absCurrentYear <= 50) {
	    result = twoDigitYear || 100;
	  } else {
	    var rangeEnd = absCurrentYear + 50;
	    var rangeEndCentury = Math.floor(rangeEnd / 100) * 100;
	    var isPreviousCentury = twoDigitYear >= rangeEnd % 100;
	    result = twoDigitYear + rangeEndCentury - (isPreviousCentury ? 100 : 0);
	  }
	
	  return isCommonEra ? result : 1 - result;
	}
	
	var DAYS_IN_MONTH = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
	var DAYS_IN_MONTH_LEAP_YEAR = [31, 29, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31]; // User for validation
	
	function isLeapYearIndex(year) {
	  return year % 400 === 0 || year % 4 === 0 && year % 100 !== 0;
	}
	/*
	 * |     | Unit                           |     | Unit                           |
	 * |-----|--------------------------------|-----|--------------------------------|
	 * |  a  | AM, PM                         |  A* | Milliseconds in day            |
	 * |  b  | AM, PM, noon, midnight         |  B  | Flexible day period            |
	 * |  c  | Stand-alone local day of week  |  C* | Localized hour w/ day period   |
	 * |  d  | Day of month                   |  D  | Day of year                    |
	 * |  e  | Local day of week              |  E  | Day of week                    |
	 * |  f  |                                |  F* | Day of week in month           |
	 * |  g* | Modified Julian day            |  G  | Era                            |
	 * |  h  | Hour [1-12]                    |  H  | Hour [0-23]                    |
	 * |  i! | ISO day of week                |  I! | ISO week of year               |
	 * |  j* | Localized hour w/ day period   |  J* | Localized hour w/o day period  |
	 * |  k  | Hour [1-24]                    |  K  | Hour [0-11]                    |
	 * |  l* | (deprecated)                   |  L  | Stand-alone month              |
	 * |  m  | Minute                         |  M  | Month                          |
	 * |  n  |                                |  N  |                                |
	 * |  o! | Ordinal number modifier        |  O* | Timezone (GMT)                 |
	 * |  p  |                                |  P  |                                |
	 * |  q  | Stand-alone quarter            |  Q  | Quarter                        |
	 * |  r* | Related Gregorian year         |  R! | ISO week-numbering year        |
	 * |  s  | Second                         |  S  | Fraction of second             |
	 * |  t! | Seconds timestamp              |  T! | Milliseconds timestamp         |
	 * |  u  | Extended year                  |  U* | Cyclic year                    |
	 * |  v* | Timezone (generic non-locat.)  |  V* | Timezone (location)            |
	 * |  w  | Local week of year             |  W* | Week of month                  |
	 * |  x  | Timezone (ISO-8601 w/o Z)      |  X  | Timezone (ISO-8601)            |
	 * |  y  | Year (abs)                     |  Y  | Local week-numbering year      |
	 * |  z* | Timezone (specific non-locat.) |  Z* | Timezone (aliases)             |
	 *
	 * Letters marked by * are not implemented but reserved by Unicode standard.
	 *
	 * Letters marked by ! are non-standard, but implemented by date-fns:
	 * - `o` modifies the previous token to turn it into an ordinal (see `parse` docs)
	 * - `i` is ISO day of week. For `i` and `ii` is returns numeric ISO week days,
	 *   i.e. 7 for Sunday, 1 for Monday, etc.
	 * - `I` is ISO week of year, as opposed to `w` which is local week of year.
	 * - `R` is ISO week-numbering year, as opposed to `Y` which is local week-numbering year.
	 *   `R` is supposed to be used in conjunction with `I` and `i`
	 *   for universal ISO week-numbering date, whereas
	 *   `Y` is supposed to be used in conjunction with `w` and `e`
	 *   for week-numbering date specific to the locale.
	 */
	
	
	var parsers = {
	  // Era
	  G: {
	    priority: 140,
	    parse: function (string, token, match, _options) {
	      switch (token) {
	        // AD, BC
	        case 'G':
	        case 'GG':
	        case 'GGG':
	          return match.era(string, {
	            width: 'abbreviated'
	          }) || match.era(string, {
	            width: 'narrow'
	          });
	        // A, B
	
	        case 'GGGGG':
	          return match.era(string, {
	            width: 'narrow'
	          });
	        // Anno Domini, Before Christ
	
	        case 'GGGG':
	        default:
	          return match.era(string, {
	            width: 'wide'
	          }) || match.era(string, {
	            width: 'abbreviated'
	          }) || match.era(string, {
	            width: 'narrow'
	          });
	      }
	    },
	    set: function (date, flags, value, _options) {
	      flags.era = value;
	      date.setUTCFullYear(value, 0, 1);
	      date.setUTCHours(0, 0, 0, 0);
	      return date;
	    },
	    incompatibleTokens: ['R', 'u', 't', 'T']
	  },
	  // Year
	  y: {
	    // From http://www.unicode.org/reports/tr35/tr35-31/tr35-dates.html#Date_Format_Patterns
	    // | Year     |     y | yy |   yyy |  yyyy | yyyyy |
	    // |----------|-------|----|-------|-------|-------|
	    // | AD 1     |     1 | 01 |   001 |  0001 | 00001 |
	    // | AD 12    |    12 | 12 |   012 |  0012 | 00012 |
	    // | AD 123   |   123 | 23 |   123 |  0123 | 00123 |
	    // | AD 1234  |  1234 | 34 |  1234 |  1234 | 01234 |
	    // | AD 12345 | 12345 | 45 | 12345 | 12345 | 12345 |
	    priority: 130,
	    parse: function (string, token, match, _options) {
	      var valueCallback = function (year) {
	        return {
	          year: year,
	          isTwoDigitYear: token === 'yy'
	        };
	      };
	
	      switch (token) {
	        case 'y':
	          return parseNDigits(4, string, valueCallback);
	
	        case 'yo':
	          return match.ordinalNumber(string, {
	            unit: 'year',
	            valueCallback: valueCallback
	          });
	
	        default:
	          return parseNDigits(token.length, string, valueCallback);
	      }
	    },
	    validate: function (_date, value, _options) {
	      return value.isTwoDigitYear || value.year > 0;
	    },
	    set: function (date, flags, value, _options) {
	      var currentYear = date.getUTCFullYear();
	
	      if (value.isTwoDigitYear) {
	        var normalizedTwoDigitYear = normalizeTwoDigitYear(value.year, currentYear);
	        date.setUTCFullYear(normalizedTwoDigitYear, 0, 1);
	        date.setUTCHours(0, 0, 0, 0);
	        return date;
	      }
	
	      var year = !('era' in flags) || flags.era === 1 ? value.year : 1 - value.year;
	      date.setUTCFullYear(year, 0, 1);
	      date.setUTCHours(0, 0, 0, 0);
	      return date;
	    },
	    incompatibleTokens: ['Y', 'R', 'u', 'w', 'I', 'i', 'e', 'c', 't', 'T']
	  },
	  // Local week-numbering year
	  Y: {
	    priority: 130,
	    parse: function (string, token, match, _options) {
	      var valueCallback = function (year) {
	        return {
	          year: year,
	          isTwoDigitYear: token === 'YY'
	        };
	      };
	
	      switch (token) {
	        case 'Y':
	          return parseNDigits(4, string, valueCallback);
	
	        case 'Yo':
	          return match.ordinalNumber(string, {
	            unit: 'year',
	            valueCallback: valueCallback
	          });
	
	        default:
	          return parseNDigits(token.length, string, valueCallback);
	      }
	    },
	    validate: function (_date, value, _options) {
	      return value.isTwoDigitYear || value.year > 0;
	    },
	    set: function (date, flags, value, options) {
	      var currentYear = (0, _index.default)(date, options);
	
	      if (value.isTwoDigitYear) {
	        var normalizedTwoDigitYear = normalizeTwoDigitYear(value.year, currentYear);
	        date.setUTCFullYear(normalizedTwoDigitYear, 0, options.firstWeekContainsDate);
	        date.setUTCHours(0, 0, 0, 0);
	        return (0, _index7.default)(date, options);
	      }
	
	      var year = !('era' in flags) || flags.era === 1 ? value.year : 1 - value.year;
	      date.setUTCFullYear(year, 0, options.firstWeekContainsDate);
	      date.setUTCHours(0, 0, 0, 0);
	      return (0, _index7.default)(date, options);
	    },
	    incompatibleTokens: ['y', 'R', 'u', 'Q', 'q', 'M', 'L', 'I', 'd', 'D', 'i', 't', 'T']
	  },
	  // ISO week-numbering year
	  R: {
	    priority: 130,
	    parse: function (string, token, _match, _options) {
	      if (token === 'R') {
	        return parseNDigitsSigned(4, string);
	      }
	
	      return parseNDigitsSigned(token.length, string);
	    },
	    set: function (_date, _flags, value, _options) {
	      var firstWeekOfYear = new Date(0);
	      firstWeekOfYear.setUTCFullYear(value, 0, 4);
	      firstWeekOfYear.setUTCHours(0, 0, 0, 0);
	      return (0, _index6.default)(firstWeekOfYear);
	    },
	    incompatibleTokens: ['G', 'y', 'Y', 'u', 'Q', 'q', 'M', 'L', 'w', 'd', 'D', 'e', 'c', 't', 'T']
	  },
	  // Extended year
	  u: {
	    priority: 130,
	    parse: function (string, token, _match, _options) {
	      if (token === 'u') {
	        return parseNDigitsSigned(4, string);
	      }
	
	      return parseNDigitsSigned(token.length, string);
	    },
	    set: function (date, _flags, value, _options) {
	      date.setUTCFullYear(value, 0, 1);
	      date.setUTCHours(0, 0, 0, 0);
	      return date;
	    },
	    incompatibleTokens: ['G', 'y', 'Y', 'R', 'w', 'I', 'i', 'e', 'c', 't', 'T']
	  },
	  // Quarter
	  Q: {
	    priority: 120,
	    parse: function (string, token, match, _options) {
	      switch (token) {
	        // 1, 2, 3, 4
	        case 'Q':
	        case 'QQ':
	          // 01, 02, 03, 04
	          return parseNDigits(token.length, string);
	        // 1st, 2nd, 3rd, 4th
	
	        case 'Qo':
	          return match.ordinalNumber(string, {
	            unit: 'quarter'
	          });
	        // Q1, Q2, Q3, Q4
	
	        case 'QQQ':
	          return match.quarter(string, {
	            width: 'abbreviated',
	            context: 'formatting'
	          }) || match.quarter(string, {
	            width: 'narrow',
	            context: 'formatting'
	          });
	        // 1, 2, 3, 4 (narrow quarter; could be not numerical)
	
	        case 'QQQQQ':
	          return match.quarter(string, {
	            width: 'narrow',
	            context: 'formatting'
	          });
	        // 1st quarter, 2nd quarter, ...
	
	        case 'QQQQ':
	        default:
	          return match.quarter(string, {
	            width: 'wide',
	            context: 'formatting'
	          }) || match.quarter(string, {
	            width: 'abbreviated',
	            context: 'formatting'
	          }) || match.quarter(string, {
	            width: 'narrow',
	            context: 'formatting'
	          });
	      }
	    },
	    validate: function (_date, value, _options) {
	      return value >= 1 && value <= 4;
	    },
	    set: function (date, _flags, value, _options) {
	      date.setUTCMonth((value - 1) * 3, 1);
	      date.setUTCHours(0, 0, 0, 0);
	      return date;
	    },
	    incompatibleTokens: ['Y', 'R', 'q', 'M', 'L', 'w', 'I', 'd', 'D', 'i', 'e', 'c', 't', 'T']
	  },
	  // Stand-alone quarter
	  q: {
	    priority: 120,
	    parse: function (string, token, match, _options) {
	      switch (token) {
	        // 1, 2, 3, 4
	        case 'q':
	        case 'qq':
	          // 01, 02, 03, 04
	          return parseNDigits(token.length, string);
	        // 1st, 2nd, 3rd, 4th
	
	        case 'qo':
	          return match.ordinalNumber(string, {
	            unit: 'quarter'
	          });
	        // Q1, Q2, Q3, Q4
	
	        case 'qqq':
	          return match.quarter(string, {
	            width: 'abbreviated',
	            context: 'standalone'
	          }) || match.quarter(string, {
	            width: 'narrow',
	            context: 'standalone'
	          });
	        // 1, 2, 3, 4 (narrow quarter; could be not numerical)
	
	        case 'qqqqq':
	          return match.quarter(string, {
	            width: 'narrow',
	            context: 'standalone'
	          });
	        // 1st quarter, 2nd quarter, ...
	
	        case 'qqqq':
	        default:
	          return match.quarter(string, {
	            width: 'wide',
	            context: 'standalone'
	          }) || match.quarter(string, {
	            width: 'abbreviated',
	            context: 'standalone'
	          }) || match.quarter(string, {
	            width: 'narrow',
	            context: 'standalone'
	          });
	      }
	    },
	    validate: function (_date, value, _options) {
	      return value >= 1 && value <= 4;
	    },
	    set: function (date, _flags, value, _options) {
	      date.setUTCMonth((value - 1) * 3, 1);
	      date.setUTCHours(0, 0, 0, 0);
	      return date;
	    },
	    incompatibleTokens: ['Y', 'R', 'Q', 'M', 'L', 'w', 'I', 'd', 'D', 'i', 'e', 'c', 't', 'T']
	  },
	  // Month
	  M: {
	    priority: 110,
	    parse: function (string, token, match, _options) {
	      var valueCallback = function (value) {
	        return value - 1;
	      };
	
	      switch (token) {
	        // 1, 2, ..., 12
	        case 'M':
	          return parseNumericPattern(numericPatterns.month, string, valueCallback);
	        // 01, 02, ..., 12
	
	        case 'MM':
	          return parseNDigits(2, string, valueCallback);
	        // 1st, 2nd, ..., 12th
	
	        case 'Mo':
	          return match.ordinalNumber(string, {
	            unit: 'month',
	            valueCallback: valueCallback
	          });
	        // Jan, Feb, ..., Dec
	
	        case 'MMM':
	          return match.month(string, {
	            width: 'abbreviated',
	            context: 'formatting'
	          }) || match.month(string, {
	            width: 'narrow',
	            context: 'formatting'
	          });
	        // J, F, ..., D
	
	        case 'MMMMM':
	          return match.month(string, {
	            width: 'narrow',
	            context: 'formatting'
	          });
	        // January, February, ..., December
	
	        case 'MMMM':
	        default:
	          return match.month(string, {
	            width: 'wide',
	            context: 'formatting'
	          }) || match.month(string, {
	            width: 'abbreviated',
	            context: 'formatting'
	          }) || match.month(string, {
	            width: 'narrow',
	            context: 'formatting'
	          });
	      }
	    },
	    validate: function (_date, value, _options) {
	      return value >= 0 && value <= 11;
	    },
	    set: function (date, _flags, value, _options) {
	      date.setUTCMonth(value, 1);
	      date.setUTCHours(0, 0, 0, 0);
	      return date;
	    },
	    incompatibleTokens: ['Y', 'R', 'q', 'Q', 'L', 'w', 'I', 'D', 'i', 'e', 'c', 't', 'T']
	  },
	  // Stand-alone month
	  L: {
	    priority: 110,
	    parse: function (string, token, match, _options) {
	      var valueCallback = function (value) {
	        return value - 1;
	      };
	
	      switch (token) {
	        // 1, 2, ..., 12
	        case 'L':
	          return parseNumericPattern(numericPatterns.month, string, valueCallback);
	        // 01, 02, ..., 12
	
	        case 'LL':
	          return parseNDigits(2, string, valueCallback);
	        // 1st, 2nd, ..., 12th
	
	        case 'Lo':
	          return match.ordinalNumber(string, {
	            unit: 'month',
	            valueCallback: valueCallback
	          });
	        // Jan, Feb, ..., Dec
	
	        case 'LLL':
	          return match.month(string, {
	            width: 'abbreviated',
	            context: 'standalone'
	          }) || match.month(string, {
	            width: 'narrow',
	            context: 'standalone'
	          });
	        // J, F, ..., D
	
	        case 'LLLLL':
	          return match.month(string, {
	            width: 'narrow',
	            context: 'standalone'
	          });
	        // January, February, ..., December
	
	        case 'LLLL':
	        default:
	          return match.month(string, {
	            width: 'wide',
	            context: 'standalone'
	          }) || match.month(string, {
	            width: 'abbreviated',
	            context: 'standalone'
	          }) || match.month(string, {
	            width: 'narrow',
	            context: 'standalone'
	          });
	      }
	    },
	    validate: function (_date, value, _options) {
	      return value >= 0 && value <= 11;
	    },
	    set: function (date, _flags, value, _options) {
	      date.setUTCMonth(value, 1);
	      date.setUTCHours(0, 0, 0, 0);
	      return date;
	    },
	    incompatibleTokens: ['Y', 'R', 'q', 'Q', 'M', 'w', 'I', 'D', 'i', 'e', 'c', 't', 'T']
	  },
	  // Local week of year
	  w: {
	    priority: 100,
	    parse: function (string, token, match, _options) {
	      switch (token) {
	        case 'w':
	          return parseNumericPattern(numericPatterns.week, string);
	
	        case 'wo':
	          return match.ordinalNumber(string, {
	            unit: 'week'
	          });
	
	        default:
	          return parseNDigits(token.length, string);
	      }
	    },
	    validate: function (_date, value, _options) {
	      return value >= 1 && value <= 53;
	    },
	    set: function (date, _flags, value, options) {
	      return (0, _index7.default)((0, _index5.default)(date, value, options), options);
	    },
	    incompatibleTokens: ['y', 'R', 'u', 'q', 'Q', 'M', 'L', 'I', 'd', 'D', 'i', 't', 'T']
	  },
	  // ISO week of year
	  I: {
	    priority: 100,
	    parse: function (string, token, match, _options) {
	      switch (token) {
	        case 'I':
	          return parseNumericPattern(numericPatterns.week, string);
	
	        case 'Io':
	          return match.ordinalNumber(string, {
	            unit: 'week'
	          });
	
	        default:
	          return parseNDigits(token.length, string);
	      }
	    },
	    validate: function (_date, value, _options) {
	      return value >= 1 && value <= 53;
	    },
	    set: function (date, _flags, value, options) {
	      return (0, _index6.default)((0, _index4.default)(date, value, options), options);
	    },
	    incompatibleTokens: ['y', 'Y', 'u', 'q', 'Q', 'M', 'L', 'w', 'd', 'D', 'e', 'c', 't', 'T']
	  },
	  // Day of the month
	  d: {
	    priority: 90,
	    parse: function (string, token, match, _options) {
	      switch (token) {
	        case 'd':
	          return parseNumericPattern(numericPatterns.date, string);
	
	        case 'do':
	          return match.ordinalNumber(string, {
	            unit: 'date'
	          });
	
	        default:
	          return parseNDigits(token.length, string);
	      }
	    },
	    validate: function (date, value, _options) {
	      var year = date.getUTCFullYear();
	      var isLeapYear = isLeapYearIndex(year);
	      var month = date.getUTCMonth();
	
	      if (isLeapYear) {
	        return value >= 1 && value <= DAYS_IN_MONTH_LEAP_YEAR[month];
	      } else {
	        return value >= 1 && value <= DAYS_IN_MONTH[month];
	      }
	    },
	    set: function (date, _flags, value, _options) {
	      date.setUTCDate(value);
	      date.setUTCHours(0, 0, 0, 0);
	      return date;
	    },
	    incompatibleTokens: ['Y', 'R', 'q', 'Q', 'w', 'I', 'D', 'i', 'e', 'c', 't', 'T']
	  },
	  // Day of year
	  D: {
	    priority: 90,
	    parse: function (string, token, match, _options) {
	      switch (token) {
	        case 'D':
	        case 'DD':
	          return parseNumericPattern(numericPatterns.dayOfYear, string);
	
	        case 'Do':
	          return match.ordinalNumber(string, {
	            unit: 'date'
	          });
	
	        default:
	          return parseNDigits(token.length, string);
	      }
	    },
	    validate: function (date, value, _options) {
	      var year = date.getUTCFullYear();
	      var isLeapYear = isLeapYearIndex(year);
	
	      if (isLeapYear) {
	        return value >= 1 && value <= 366;
	      } else {
	        return value >= 1 && value <= 365;
	      }
	    },
	    set: function (date, _flags, value, _options) {
	      date.setUTCMonth(0, value);
	      date.setUTCHours(0, 0, 0, 0);
	      return date;
	    },
	    incompatibleTokens: ['Y', 'R', 'q', 'Q', 'M', 'L', 'w', 'I', 'd', 'E', 'i', 'e', 'c', 't', 'T']
	  },
	  // Day of week
	  E: {
	    priority: 90,
	    parse: function (string, token, match, _options) {
	      switch (token) {
	        // Tue
	        case 'E':
	        case 'EE':
	        case 'EEE':
	          return match.day(string, {
	            width: 'abbreviated',
	            context: 'formatting'
	          }) || match.day(string, {
	            width: 'short',
	            context: 'formatting'
	          }) || match.day(string, {
	            width: 'narrow',
	            context: 'formatting'
	          });
	        // T
	
	        case 'EEEEE':
	          return match.day(string, {
	            width: 'narrow',
	            context: 'formatting'
	          });
	        // Tu
	
	        case 'EEEEEE':
	          return match.day(string, {
	            width: 'short',
	            context: 'formatting'
	          }) || match.day(string, {
	            width: 'narrow',
	            context: 'formatting'
	          });
	        // Tuesday
	
	        case 'EEEE':
	        default:
	          return match.day(string, {
	            width: 'wide',
	            context: 'formatting'
	          }) || match.day(string, {
	            width: 'abbreviated',
	            context: 'formatting'
	          }) || match.day(string, {
	            width: 'short',
	            context: 'formatting'
	          }) || match.day(string, {
	            width: 'narrow',
	            context: 'formatting'
	          });
	      }
	    },
	    validate: function (_date, value, _options) {
	      return value >= 0 && value <= 6;
	    },
	    set: function (date, _flags, value, options) {
	      date = (0, _index2.default)(date, value, options);
	      date.setUTCHours(0, 0, 0, 0);
	      return date;
	    },
	    incompatibleTokens: ['D', 'i', 'e', 'c', 't', 'T']
	  },
	  // Local day of week
	  e: {
	    priority: 90,
	    parse: function (string, token, match, options) {
	      var valueCallback = function (value) {
	        var wholeWeekDays = Math.floor((value - 1) / 7) * 7;
	        return (value + options.weekStartsOn + 6) % 7 + wholeWeekDays;
	      };
	
	      switch (token) {
	        // 3
	        case 'e':
	        case 'ee':
	          // 03
	          return parseNDigits(token.length, string, valueCallback);
	        // 3rd
	
	        case 'eo':
	          return match.ordinalNumber(string, {
	            unit: 'day',
	            valueCallback: valueCallback
	          });
	        // Tue
	
	        case 'eee':
	          return match.day(string, {
	            width: 'abbreviated',
	            context: 'formatting'
	          }) || match.day(string, {
	            width: 'short',
	            context: 'formatting'
	          }) || match.day(string, {
	            width: 'narrow',
	            context: 'formatting'
	          });
	        // T
	
	        case 'eeeee':
	          return match.day(string, {
	            width: 'narrow',
	            context: 'formatting'
	          });
	        // Tu
	
	        case 'eeeeee':
	          return match.day(string, {
	            width: 'short',
	            context: 'formatting'
	          }) || match.day(string, {
	            width: 'narrow',
	            context: 'formatting'
	          });
	        // Tuesday
	
	        case 'eeee':
	        default:
	          return match.day(string, {
	            width: 'wide',
	            context: 'formatting'
	          }) || match.day(string, {
	            width: 'abbreviated',
	            context: 'formatting'
	          }) || match.day(string, {
	            width: 'short',
	            context: 'formatting'
	          }) || match.day(string, {
	            width: 'narrow',
	            context: 'formatting'
	          });
	      }
	    },
	    validate: function (_date, value, _options) {
	      return value >= 0 && value <= 6;
	    },
	    set: function (date, _flags, value, options) {
	      date = (0, _index2.default)(date, value, options);
	      date.setUTCHours(0, 0, 0, 0);
	      return date;
	    },
	    incompatibleTokens: ['y', 'R', 'u', 'q', 'Q', 'M', 'L', 'I', 'd', 'D', 'E', 'i', 'c', 't', 'T']
	  },
	  // Stand-alone local day of week
	  c: {
	    priority: 90,
	    parse: function (string, token, match, options) {
	      var valueCallback = function (value) {
	        var wholeWeekDays = Math.floor((value - 1) / 7) * 7;
	        return (value + options.weekStartsOn + 6) % 7 + wholeWeekDays;
	      };
	
	      switch (token) {
	        // 3
	        case 'c':
	        case 'cc':
	          // 03
	          return parseNDigits(token.length, string, valueCallback);
	        // 3rd
	
	        case 'co':
	          return match.ordinalNumber(string, {
	            unit: 'day',
	            valueCallback: valueCallback
	          });
	        // Tue
	
	        case 'ccc':
	          return match.day(string, {
	            width: 'abbreviated',
	            context: 'standalone'
	          }) || match.day(string, {
	            width: 'short',
	            context: 'standalone'
	          }) || match.day(string, {
	            width: 'narrow',
	            context: 'standalone'
	          });
	        // T
	
	        case 'ccccc':
	          return match.day(string, {
	            width: 'narrow',
	            context: 'standalone'
	          });
	        // Tu
	
	        case 'cccccc':
	          return match.day(string, {
	            width: 'short',
	            context: 'standalone'
	          }) || match.day(string, {
	            width: 'narrow',
	            context: 'standalone'
	          });
	        // Tuesday
	
	        case 'cccc':
	        default:
	          return match.day(string, {
	            width: 'wide',
	            context: 'standalone'
	          }) || match.day(string, {
	            width: 'abbreviated',
	            context: 'standalone'
	          }) || match.day(string, {
	            width: 'short',
	            context: 'standalone'
	          }) || match.day(string, {
	            width: 'narrow',
	            context: 'standalone'
	          });
	      }
	    },
	    validate: function (_date, value, _options) {
	      return value >= 0 && value <= 6;
	    },
	    set: function (date, _flags, value, options) {
	      date = (0, _index2.default)(date, value, options);
	      date.setUTCHours(0, 0, 0, 0);
	      return date;
	    },
	    incompatibleTokens: ['y', 'R', 'u', 'q', 'Q', 'M', 'L', 'I', 'd', 'D', 'E', 'i', 'e', 't', 'T']
	  },
	  // ISO day of week
	  i: {
	    priority: 90,
	    parse: function (string, token, match, _options) {
	      var valueCallback = function (value) {
	        if (value === 0) {
	          return 7;
	        }
	
	        return value;
	      };
	
	      switch (token) {
	        // 2
	        case 'i':
	        case 'ii':
	          // 02
	          return parseNDigits(token.length, string);
	        // 2nd
	
	        case 'io':
	          return match.ordinalNumber(string, {
	            unit: 'day'
	          });
	        // Tue
	
	        case 'iii':
	          return match.day(string, {
	            width: 'abbreviated',
	            context: 'formatting',
	            valueCallback: valueCallback
	          }) || match.day(string, {
	            width: 'short',
	            context: 'formatting',
	            valueCallback: valueCallback
	          }) || match.day(string, {
	            width: 'narrow',
	            context: 'formatting',
	            valueCallback: valueCallback
	          });
	        // T
	
	        case 'iiiii':
	          return match.day(string, {
	            width: 'narrow',
	            context: 'formatting',
	            valueCallback: valueCallback
	          });
	        // Tu
	
	        case 'iiiiii':
	          return match.day(string, {
	            width: 'short',
	            context: 'formatting',
	            valueCallback: valueCallback
	          }) || match.day(string, {
	            width: 'narrow',
	            context: 'formatting',
	            valueCallback: valueCallback
	          });
	        // Tuesday
	
	        case 'iiii':
	        default:
	          return match.day(string, {
	            width: 'wide',
	            context: 'formatting',
	            valueCallback: valueCallback
	          }) || match.day(string, {
	            width: 'abbreviated',
	            context: 'formatting',
	            valueCallback: valueCallback
	          }) || match.day(string, {
	            width: 'short',
	            context: 'formatting',
	            valueCallback: valueCallback
	          }) || match.day(string, {
	            width: 'narrow',
	            context: 'formatting',
	            valueCallback: valueCallback
	          });
	      }
	    },
	    validate: function (_date, value, _options) {
	      return value >= 1 && value <= 7;
	    },
	    set: function (date, _flags, value, options) {
	      date = (0, _index3.default)(date, value, options);
	      date.setUTCHours(0, 0, 0, 0);
	      return date;
	    },
	    incompatibleTokens: ['y', 'Y', 'u', 'q', 'Q', 'M', 'L', 'w', 'd', 'D', 'E', 'e', 'c', 't', 'T']
	  },
	  // AM or PM
	  a: {
	    priority: 80,
	    parse: function (string, token, match, _options) {
	      switch (token) {
	        case 'a':
	        case 'aa':
	        case 'aaa':
	          return match.dayPeriod(string, {
	            width: 'abbreviated',
	            context: 'formatting'
	          }) || match.dayPeriod(string, {
	            width: 'narrow',
	            context: 'formatting'
	          });
	
	        case 'aaaaa':
	          return match.dayPeriod(string, {
	            width: 'narrow',
	            context: 'formatting'
	          });
	
	        case 'aaaa':
	        default:
	          return match.dayPeriod(string, {
	            width: 'wide',
	            context: 'formatting'
	          }) || match.dayPeriod(string, {
	            width: 'abbreviated',
	            context: 'formatting'
	          }) || match.dayPeriod(string, {
	            width: 'narrow',
	            context: 'formatting'
	          });
	      }
	    },
	    set: function (date, _flags, value, _options) {
	      date.setUTCHours(dayPeriodEnumToHours(value), 0, 0, 0);
	      return date;
	    },
	    incompatibleTokens: ['b', 'B', 'H', 'K', 'k', 't', 'T']
	  },
	  // AM, PM, midnight
	  b: {
	    priority: 80,
	    parse: function (string, token, match, _options) {
	      switch (token) {
	        case 'b':
	        case 'bb':
	        case 'bbb':
	          return match.dayPeriod(string, {
	            width: 'abbreviated',
	            context: 'formatting'
	          }) || match.dayPeriod(string, {
	            width: 'narrow',
	            context: 'formatting'
	          });
	
	        case 'bbbbb':
	          return match.dayPeriod(string, {
	            width: 'narrow',
	            context: 'formatting'
	          });
	
	        case 'bbbb':
	        default:
	          return match.dayPeriod(string, {
	            width: 'wide',
	            context: 'formatting'
	          }) || match.dayPeriod(string, {
	            width: 'abbreviated',
	            context: 'formatting'
	          }) || match.dayPeriod(string, {
	            width: 'narrow',
	            context: 'formatting'
	          });
	      }
	    },
	    set: function (date, _flags, value, _options) {
	      date.setUTCHours(dayPeriodEnumToHours(value), 0, 0, 0);
	      return date;
	    },
	    incompatibleTokens: ['a', 'B', 'H', 'K', 'k', 't', 'T']
	  },
	  // in the morning, in the afternoon, in the evening, at night
	  B: {
	    priority: 80,
	    parse: function (string, token, match, _options) {
	      switch (token) {
	        case 'B':
	        case 'BB':
	        case 'BBB':
	          return match.dayPeriod(string, {
	            width: 'abbreviated',
	            context: 'formatting'
	          }) || match.dayPeriod(string, {
	            width: 'narrow',
	            context: 'formatting'
	          });
	
	        case 'BBBBB':
	          return match.dayPeriod(string, {
	            width: 'narrow',
	            context: 'formatting'
	          });
	
	        case 'BBBB':
	        default:
	          return match.dayPeriod(string, {
	            width: 'wide',
	            context: 'formatting'
	          }) || match.dayPeriod(string, {
	            width: 'abbreviated',
	            context: 'formatting'
	          }) || match.dayPeriod(string, {
	            width: 'narrow',
	            context: 'formatting'
	          });
	      }
	    },
	    set: function (date, _flags, value, _options) {
	      date.setUTCHours(dayPeriodEnumToHours(value), 0, 0, 0);
	      return date;
	    },
	    incompatibleTokens: ['a', 'b', 't', 'T']
	  },
	  // Hour [1-12]
	  h: {
	    priority: 70,
	    parse: function (string, token, match, _options) {
	      switch (token) {
	        case 'h':
	          return parseNumericPattern(numericPatterns.hour12h, string);
	
	        case 'ho':
	          return match.ordinalNumber(string, {
	            unit: 'hour'
	          });
	
	        default:
	          return parseNDigits(token.length, string);
	      }
	    },
	    validate: function (_date, value, _options) {
	      return value >= 1 && value <= 12;
	    },
	    set: function (date, _flags, value, _options) {
	      var isPM = date.getUTCHours() >= 12;
	
	      if (isPM && value < 12) {
	        date.setUTCHours(value + 12, 0, 0, 0);
	      } else if (!isPM && value === 12) {
	        date.setUTCHours(0, 0, 0, 0);
	      } else {
	        date.setUTCHours(value, 0, 0, 0);
	      }
	
	      return date;
	    },
	    incompatibleTokens: ['H', 'K', 'k', 't', 'T']
	  },
	  // Hour [0-23]
	  H: {
	    priority: 70,
	    parse: function (string, token, match, _options) {
	      switch (token) {
	        case 'H':
	          return parseNumericPattern(numericPatterns.hour23h, string);
	
	        case 'Ho':
	          return match.ordinalNumber(string, {
	            unit: 'hour'
	          });
	
	        default:
	          return parseNDigits(token.length, string);
	      }
	    },
	    validate: function (_date, value, _options) {
	      return value >= 0 && value <= 23;
	    },
	    set: function (date, _flags, value, _options) {
	      date.setUTCHours(value, 0, 0, 0);
	      return date;
	    },
	    incompatibleTokens: ['a', 'b', 'h', 'K', 'k', 't', 'T']
	  },
	  // Hour [0-11]
	  K: {
	    priority: 70,
	    parse: function (string, token, match, _options) {
	      switch (token) {
	        case 'K':
	          return parseNumericPattern(numericPatterns.hour11h, string);
	
	        case 'Ko':
	          return match.ordinalNumber(string, {
	            unit: 'hour'
	          });
	
	        default:
	          return parseNDigits(token.length, string);
	      }
	    },
	    validate: function (_date, value, _options) {
	      return value >= 0 && value <= 11;
	    },
	    set: function (date, _flags, value, _options) {
	      var isPM = date.getUTCHours() >= 12;
	
	      if (isPM && value < 12) {
	        date.setUTCHours(value + 12, 0, 0, 0);
	      } else {
	        date.setUTCHours(value, 0, 0, 0);
	      }
	
	      return date;
	    },
	    incompatibleTokens: ['a', 'b', 'h', 'H', 'k', 't', 'T']
	  },
	  // Hour [1-24]
	  k: {
	    priority: 70,
	    parse: function (string, token, match, _options) {
	      switch (token) {
	        case 'k':
	          return parseNumericPattern(numericPatterns.hour24h, string);
	
	        case 'ko':
	          return match.ordinalNumber(string, {
	            unit: 'hour'
	          });
	
	        default:
	          return parseNDigits(token.length, string);
	      }
	    },
	    validate: function (_date, value, _options) {
	      return value >= 1 && value <= 24;
	    },
	    set: function (date, _flags, value, _options) {
	      var hours = value <= 24 ? value % 24 : value;
	      date.setUTCHours(hours, 0, 0, 0);
	      return date;
	    },
	    incompatibleTokens: ['a', 'b', 'h', 'H', 'K', 't', 'T']
	  },
	  // Minute
	  m: {
	    priority: 60,
	    parse: function (string, token, match, _options) {
	      switch (token) {
	        case 'm':
	          return parseNumericPattern(numericPatterns.minute, string);
	
	        case 'mo':
	          return match.ordinalNumber(string, {
	            unit: 'minute'
	          });
	
	        default:
	          return parseNDigits(token.length, string);
	      }
	    },
	    validate: function (_date, value, _options) {
	      return value >= 0 && value <= 59;
	    },
	    set: function (date, _flags, value, _options) {
	      date.setUTCMinutes(value, 0, 0);
	      return date;
	    },
	    incompatibleTokens: ['t', 'T']
	  },
	  // Second
	  s: {
	    priority: 50,
	    parse: function (string, token, match, _options) {
	      switch (token) {
	        case 's':
	          return parseNumericPattern(numericPatterns.second, string);
	
	        case 'so':
	          return match.ordinalNumber(string, {
	            unit: 'second'
	          });
	
	        default:
	          return parseNDigits(token.length, string);
	      }
	    },
	    validate: function (_date, value, _options) {
	      return value >= 0 && value <= 59;
	    },
	    set: function (date, _flags, value, _options) {
	      date.setUTCSeconds(value, 0);
	      return date;
	    },
	    incompatibleTokens: ['t', 'T']
	  },
	  // Fraction of second
	  S: {
	    priority: 30,
	    parse: function (string, token, _match, _options) {
	      var valueCallback = function (value) {
	        return Math.floor(value * Math.pow(10, -token.length + 3));
	      };
	
	      return parseNDigits(token.length, string, valueCallback);
	    },
	    set: function (date, _flags, value, _options) {
	      date.setUTCMilliseconds(value);
	      return date;
	    },
	    incompatibleTokens: ['t', 'T']
	  },
	  // Timezone (ISO-8601. +00:00 is `'Z'`)
	  X: {
	    priority: 10,
	    parse: function (string, token, _match, _options) {
	      switch (token) {
	        case 'X':
	          return parseTimezonePattern(timezonePatterns.basicOptionalMinutes, string);
	
	        case 'XX':
	          return parseTimezonePattern(timezonePatterns.basic, string);
	
	        case 'XXXX':
	          return parseTimezonePattern(timezonePatterns.basicOptionalSeconds, string);
	
	        case 'XXXXX':
	          return parseTimezonePattern(timezonePatterns.extendedOptionalSeconds, string);
	
	        case 'XXX':
	        default:
	          return parseTimezonePattern(timezonePatterns.extended, string);
	      }
	    },
	    set: function (date, flags, value, _options) {
	      if (flags.timestampIsSet) {
	        return date;
	      }
	
	      return new Date(date.getTime() - value);
	    },
	    incompatibleTokens: ['t', 'T', 'x']
	  },
	  // Timezone (ISO-8601)
	  x: {
	    priority: 10,
	    parse: function (string, token, _match, _options) {
	      switch (token) {
	        case 'x':
	          return parseTimezonePattern(timezonePatterns.basicOptionalMinutes, string);
	
	        case 'xx':
	          return parseTimezonePattern(timezonePatterns.basic, string);
	
	        case 'xxxx':
	          return parseTimezonePattern(timezonePatterns.basicOptionalSeconds, string);
	
	        case 'xxxxx':
	          return parseTimezonePattern(timezonePatterns.extendedOptionalSeconds, string);
	
	        case 'xxx':
	        default:
	          return parseTimezonePattern(timezonePatterns.extended, string);
	      }
	    },
	    set: function (date, flags, value, _options) {
	      if (flags.timestampIsSet) {
	        return date;
	      }
	
	      return new Date(date.getTime() - value);
	    },
	    incompatibleTokens: ['t', 'T', 'X']
	  },
	  // Seconds timestamp
	  t: {
	    priority: 40,
	    parse: function (string, _token, _match, _options) {
	      return parseAnyDigitsSigned(string);
	    },
	    set: function (_date, _flags, value, _options) {
	      return [new Date(value * 1000), {
	        timestampIsSet: true
	      }];
	    },
	    incompatibleTokens: '*'
	  },
	  // Milliseconds timestamp
	  T: {
	    priority: 20,
	    parse: function (string, _token, _match, _options) {
	      return parseAnyDigitsSigned(string);
	    },
	    set: function (_date, _flags, value, _options) {
	      return [new Date(value), {
	        timestampIsSet: true
	      }];
	    },
	    incompatibleTokens: '*'
	  }
	};
	var _default = parsers;
	exports.default = _default;
	module.exports = exports.default;

/***/ },
/* 990 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = roundToNearestMinutes;
	
	var _index = _interopRequireDefault(__webpack_require__(3));
	
	var _index2 = _interopRequireDefault(__webpack_require__(9));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name roundToNearestMinutes
	 * @category Minute Helpers
	 * @summary Rounds the given date to the nearest minute
	 *
	 * @description
	 * Rounds the given date to the nearest minute (or number of minutes).
	 * Rounds up when the given date is exactly between the nearest round minutes.
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} date - the date to round
	 * @param {Object} [options] - an object with options.
	 * @param {Number} [options.nearestTo=1] - nearest number of minutes to round to. E.g. `15` to round to quarter hours.
	 * @returns {Date} the new date rounded to the closest minute
	 * @throws {TypeError} 1 argument required
	 * @throws {RangeError} `options.nearestTo` must be between 1 and 30
	 *
	 * @example
	 * // Round 10 July 2014 12:12:34 to nearest minute:
	 * var result = roundToNearestMinutes(new Date(2014, 6, 10, 12, 12, 34))
	 * //=> Thu Jul 10 2014 12:13:00
	 *
	 * @example
	 * // Round 10 July 2014 12:07:30 to nearest quarter hour:
	 * var result = roundToNearestMinutes(new Date(2014, 6, 10, 12, 12, 34), { nearestTo: 15 })
	 * // rounds up because given date is exactly between 12:00:00 and 12:15:00
	 * //=> Thu Jul 10 2014 12:15:00
	 */
	function roundToNearestMinutes(dirtyDate, options) {
	  if (arguments.length < 1) {
	    throw new TypeError('1 argument required, but only none provided present');
	  }
	
	  var nearestTo = options && 'nearestTo' in options ? (0, _index2.default)(options.nearestTo) : 1;
	
	  if (nearestTo < 1 || nearestTo > 30) {
	    throw new RangeError('`options.nearestTo` must be between 1 and 30');
	  }
	
	  var date = (0, _index.default)(dirtyDate);
	  var seconds = date.getSeconds(); // relevant if nearestTo is 1, which is the default case
	
	  var minutes = date.getMinutes() + seconds / 60;
	  var roundedMinutes = Math.floor(minutes / nearestTo) * nearestTo;
	  var remainderMinutes = minutes % nearestTo;
	  var addedMinutes = Math.round(remainderMinutes / nearestTo) * nearestTo;
	  return new Date(date.getFullYear(), date.getMonth(), date.getDate(), date.getHours(), roundedMinutes + addedMinutes);
	}
	
	module.exports = exports.default;

/***/ },
/* 991 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = setDate;
	
	var _index = _interopRequireDefault(__webpack_require__(9));
	
	var _index2 = _interopRequireDefault(__webpack_require__(3));
	
	var _index3 = _interopRequireDefault(__webpack_require__(2));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name setDate
	 * @category Day Helpers
	 * @summary Set the day of the month to the given date.
	 *
	 * @description
	 * Set the day of the month to the given date.
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} date - the date to be changed
	 * @param {Number} dayOfMonth - the day of the month of the new date
	 * @returns {Date} the new date with the day of the month set
	 * @throws {TypeError} 2 arguments required
	 *
	 * @example
	 * // Set the 30th day of the month to 1 September 2014:
	 * var result = setDate(new Date(2014, 8, 1), 30)
	 * //=> Tue Sep 30 2014 00:00:00
	 */
	function setDate(dirtyDate, dirtyDayOfMonth) {
	  (0, _index3.default)(2, arguments);
	  var date = (0, _index2.default)(dirtyDate);
	  var dayOfMonth = (0, _index.default)(dirtyDayOfMonth);
	  date.setDate(dayOfMonth);
	  return date;
	}
	
	module.exports = exports.default;

/***/ },
/* 992 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = setDayOfYear;
	
	var _index = _interopRequireDefault(__webpack_require__(9));
	
	var _index2 = _interopRequireDefault(__webpack_require__(3));
	
	var _index3 = _interopRequireDefault(__webpack_require__(2));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name setDayOfYear
	 * @category Day Helpers
	 * @summary Set the day of the year to the given date.
	 *
	 * @description
	 * Set the day of the year to the given date.
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} date - the date to be changed
	 * @param {Number} dayOfYear - the day of the year of the new date
	 * @returns {Date} the new date with the day of the year set
	 * @throws {TypeError} 2 arguments required
	 *
	 * @example
	 * // Set the 2nd day of the year to 2 July 2014:
	 * var result = setDayOfYear(new Date(2014, 6, 2), 2)
	 * //=> Thu Jan 02 2014 00:00:00
	 */
	function setDayOfYear(dirtyDate, dirtyDayOfYear) {
	  (0, _index3.default)(2, arguments);
	  var date = (0, _index2.default)(dirtyDate);
	  var dayOfYear = (0, _index.default)(dirtyDayOfYear);
	  date.setMonth(0);
	  date.setDate(dayOfYear);
	  return date;
	}
	
	module.exports = exports.default;

/***/ },
/* 993 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = setDay;
	
	var _index = _interopRequireDefault(__webpack_require__(74));
	
	var _index2 = _interopRequireDefault(__webpack_require__(3));
	
	var _index3 = _interopRequireDefault(__webpack_require__(9));
	
	var _index4 = _interopRequireDefault(__webpack_require__(2));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name setDay
	 * @category Weekday Helpers
	 * @summary Set the day of the week to the given date.
	 *
	 * @description
	 * Set the day of the week to the given date.
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} date - the date to be changed
	 * @param {Number} day - the day of the week of the new date
	 * @param {Object} [options] - an object with options.
	 * @param {Locale} [options.locale=defaultLocale] - the locale object. See [Locale]{@link https://date-fns.org/docs/Locale}
	 * @param {0|1|2|3|4|5|6} [options.weekStartsOn=0] - the index of the first day of the week (0 - Sunday)
	 * @returns {Date} the new date with the day of the week set
	 * @throws {TypeError} 2 arguments required
	 * @throws {RangeError} `options.weekStartsOn` must be between 0 and 6
	 *
	 * @example
	 * // Set week day to Sunday, with the default weekStartsOn of Sunday:
	 * var result = setDay(new Date(2014, 8, 1), 0)
	 * //=> Sun Aug 31 2014 00:00:00
	 *
	 * @example
	 * // Set week day to Sunday, with a weekStartsOn of Monday:
	 * var result = setDay(new Date(2014, 8, 1), 0, { weekStartsOn: 1 })
	 * //=> Sun Sep 07 2014 00:00:00
	 */
	function setDay(dirtyDate, dirtyDay, dirtyOptions) {
	  (0, _index4.default)(2, arguments);
	  var options = dirtyOptions || {};
	  var locale = options.locale;
	  var localeWeekStartsOn = locale && locale.options && locale.options.weekStartsOn;
	  var defaultWeekStartsOn = localeWeekStartsOn == null ? 0 : (0, _index3.default)(localeWeekStartsOn);
	  var weekStartsOn = options.weekStartsOn == null ? defaultWeekStartsOn : (0, _index3.default)(options.weekStartsOn); // Test if weekStartsOn is between 0 and 6 _and_ is not NaN
	
	  if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) {
	    throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
	  }
	
	  var date = (0, _index2.default)(dirtyDate, options);
	  var day = (0, _index3.default)(dirtyDay);
	  var currentDay = date.getDay();
	  var remainder = day % 7;
	  var dayIndex = (remainder + 7) % 7;
	  var delta = 7 - weekStartsOn;
	  var diff = day < 0 || day > 6 ? day - (currentDay + delta) % 7 : (dayIndex + delta) % 7 - (currentDay + delta) % 7;
	  return (0, _index.default)(date, diff, options);
	}
	
	module.exports = exports.default;

/***/ },
/* 994 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = setISODay;
	
	var _index = _interopRequireDefault(__webpack_require__(9));
	
	var _index2 = _interopRequireDefault(__webpack_require__(3));
	
	var _index3 = _interopRequireDefault(__webpack_require__(74));
	
	var _index4 = _interopRequireDefault(__webpack_require__(410));
	
	var _index5 = _interopRequireDefault(__webpack_require__(2));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name setISODay
	 * @category Weekday Helpers
	 * @summary Set the day of the ISO week to the given date.
	 *
	 * @description
	 * Set the day of the ISO week to the given date.
	 * ISO week starts with Monday.
	 * 7 is the index of Sunday, 1 is the index of Monday etc.
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} date - the date to be changed
	 * @param {Number} day - the day of the ISO week of the new date
	 * @returns {Date} the new date with the day of the ISO week set
	 * @throws {TypeError} 2 arguments required
	 *
	 * @example
	 * // Set Sunday to 1 September 2014:
	 * var result = setISODay(new Date(2014, 8, 1), 7)
	 * //=> Sun Sep 07 2014 00:00:00
	 */
	function setISODay(dirtyDate, dirtyDay) {
	  (0, _index5.default)(2, arguments);
	  var date = (0, _index2.default)(dirtyDate);
	  var day = (0, _index.default)(dirtyDay);
	  var currentDay = (0, _index4.default)(date);
	  var diff = day - currentDay;
	  return (0, _index3.default)(date, diff);
	}
	
	module.exports = exports.default;

/***/ },
/* 995 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = setISOWeek;
	
	var _index = _interopRequireDefault(__webpack_require__(9));
	
	var _index2 = _interopRequireDefault(__webpack_require__(3));
	
	var _index3 = _interopRequireDefault(__webpack_require__(411));
	
	var _index4 = _interopRequireDefault(__webpack_require__(2));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name setISOWeek
	 * @category ISO Week Helpers
	 * @summary Set the ISO week to the given date.
	 *
	 * @description
	 * Set the ISO week to the given date, saving the weekday number.
	 *
	 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} date - the date to be changed
	 * @param {Number} isoWeek - the ISO week of the new date
	 * @returns {Date} the new date with the ISO week set
	 * @throws {TypeError} 2 arguments required
	 *
	 * @example
	 * // Set the 53rd ISO week to 7 August 2004:
	 * var result = setISOWeek(new Date(2004, 7, 7), 53)
	 * //=> Sat Jan 01 2005 00:00:00
	 */
	function setISOWeek(dirtyDate, dirtyISOWeek) {
	  (0, _index4.default)(2, arguments);
	  var date = (0, _index2.default)(dirtyDate);
	  var isoWeek = (0, _index.default)(dirtyISOWeek);
	  var diff = (0, _index3.default)(date) - isoWeek;
	  date.setDate(date.getDate() - diff * 7);
	  return date;
	}
	
	module.exports = exports.default;

/***/ },
/* 996 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = setMilliseconds;
	
	var _index = _interopRequireDefault(__webpack_require__(9));
	
	var _index2 = _interopRequireDefault(__webpack_require__(3));
	
	var _index3 = _interopRequireDefault(__webpack_require__(2));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name setMilliseconds
	 * @category Millisecond Helpers
	 * @summary Set the milliseconds to the given date.
	 *
	 * @description
	 * Set the milliseconds to the given date.
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} date - the date to be changed
	 * @param {Number} milliseconds - the milliseconds of the new date
	 * @returns {Date} the new date with the milliseconds set
	 * @throws {TypeError} 2 arguments required
	 *
	 * @example
	 * // Set 300 milliseconds to 1 September 2014 11:30:40.500:
	 * var result = setMilliseconds(new Date(2014, 8, 1, 11, 30, 40, 500), 300)
	 * //=> Mon Sep 01 2014 11:30:40.300
	 */
	function setMilliseconds(dirtyDate, dirtyMilliseconds) {
	  (0, _index3.default)(2, arguments);
	  var date = (0, _index2.default)(dirtyDate);
	  var milliseconds = (0, _index.default)(dirtyMilliseconds);
	  date.setMilliseconds(milliseconds);
	  return date;
	}
	
	module.exports = exports.default;

/***/ },
/* 997 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = setWeekYear;
	
	var _index = _interopRequireDefault(__webpack_require__(84));
	
	var _index2 = _interopRequireDefault(__webpack_require__(281));
	
	var _index3 = _interopRequireDefault(__webpack_require__(3));
	
	var _index4 = _interopRequireDefault(__webpack_require__(9));
	
	var _index5 = _interopRequireDefault(__webpack_require__(2));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name setWeekYear
	 * @category Week-Numbering Year Helpers
	 * @summary Set the local week-numbering year to the given date.
	 *
	 * @description
	 * Set the local week-numbering year to the given date,
	 * saving the week number and the weekday number.
	 * The exact calculation depends on the values of
	 * `options.weekStartsOn` (which is the index of the first day of the week)
	 * and `options.firstWeekContainsDate` (which is the day of January, which is always in
	 * the first week of the week-numbering year)
	 *
	 * Week numbering: https://en.wikipedia.org/wiki/Week#Week_numbering
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} date - the date to be changed
	 * @param {Number} weekYear - the local week-numbering year of the new date
	 * @param {Object} [options] - an object with options.
	 * @param {Locale} [options.locale=defaultLocale] - the locale object. See [Locale]{@link https://date-fns.org/docs/Locale}
	 * @param {0|1|2|3|4|5|6} [options.weekStartsOn=0] - the index of the first day of the week (0 - Sunday)
	 * @param {1|2|3|4|5|6|7} [options.firstWeekContainsDate=1] - the day of January, which is always in the first week of the year
	 * @returns {Date} the new date with the local week-numbering year set
	 * @throws {TypeError} 2 arguments required
	 * @throws {RangeError} `options.weekStartsOn` must be between 0 and 6
	 * @throws {RangeError} `options.firstWeekContainsDate` must be between 1 and 7
	 *
	 * @example
	 * // Set the local week-numbering year 2004 to 2 January 2010 with default options:
	 * var result = setWeekYear(new Date(2010, 0, 2), 2004)
	 * //=> Sat Jan 03 2004 00:00:00
	 *
	 * @example
	 * // Set the local week-numbering year 2004 to 2 January 2010,
	 * // if Monday is the first day of week
	 * // and 4 January is always in the first week of the year:
	 * var result = setWeekYear(new Date(2010, 0, 2), 2004, {
	 *   weekStartsOn: 1,
	 *   firstWeekContainsDate: 4
	 * })
	 * //=> Sat Jan 01 2005 00:00:00
	 */
	function setWeekYear(dirtyDate, dirtyWeekYear, dirtyOptions) {
	  (0, _index5.default)(2, arguments);
	  var options = dirtyOptions || {};
	  var locale = options.locale;
	  var localeFirstWeekContainsDate = locale && locale.options && locale.options.firstWeekContainsDate;
	  var defaultFirstWeekContainsDate = localeFirstWeekContainsDate == null ? 1 : (0, _index4.default)(localeFirstWeekContainsDate);
	  var firstWeekContainsDate = options.firstWeekContainsDate == null ? defaultFirstWeekContainsDate : (0, _index4.default)(options.firstWeekContainsDate);
	  var date = (0, _index3.default)(dirtyDate);
	  var weekYear = (0, _index4.default)(dirtyWeekYear);
	  var diff = (0, _index.default)(date, (0, _index2.default)(date, dirtyOptions));
	  var firstWeek = new Date(0);
	  firstWeek.setFullYear(weekYear, 0, firstWeekContainsDate);
	  firstWeek.setHours(0, 0, 0, 0);
	  date = (0, _index2.default)(firstWeek, dirtyOptions);
	  date.setDate(date.getDate() + diff);
	  return date;
	}
	
	module.exports = exports.default;

/***/ },
/* 998 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = setWeek;
	
	var _index = _interopRequireDefault(__webpack_require__(273));
	
	var _index2 = _interopRequireDefault(__webpack_require__(3));
	
	var _index3 = _interopRequireDefault(__webpack_require__(9));
	
	var _index4 = _interopRequireDefault(__webpack_require__(2));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name setWeek
	 * @category Week Helpers
	 * @summary Set the local week to the given date.
	 *
	 * @description
	 * Set the local week to the given date, saving the weekday number.
	 * The exact calculation depends on the values of
	 * `options.weekStartsOn` (which is the index of the first day of the week)
	 * and `options.firstWeekContainsDate` (which is the day of January, which is always in
	 * the first week of the week-numbering year)
	 *
	 * Week numbering: https://en.wikipedia.org/wiki/Week#Week_numbering
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} date - the date to be changed
	 * @param {Number} week - the week of the new date
	 * @param {Object} [options] - an object with options.
	 * @param {Locale} [options.locale=defaultLocale] - the locale object. See [Locale]{@link https://date-fns.org/docs/Locale}
	 * @param {0|1|2|3|4|5|6} [options.weekStartsOn=0] - the index of the first day of the week (0 - Sunday)
	 * @param {1|2|3|4|5|6|7} [options.firstWeekContainsDate=1] - the day of January, which is always in the first week of the year
	 * @returns {Date} the new date with the local week set
	 * @throws {TypeError} 2 arguments required
	 * @throws {RangeError} `options.weekStartsOn` must be between 0 and 6
	 * @throws {RangeError} `options.firstWeekContainsDate` must be between 1 and 7
	 *
	 * @example
	 * // Set the 1st week to 2 January 2005 with default options:
	 * var result = setWeek(new Date(2005, 0, 2), 1)
	 * //=> Sun Dec 26 2004 00:00:00
	 *
	 * @example
	 * // Set the 1st week to 2 January 2005,
	 * // if Monday is the first day of the week,
	 * // and the first week of the year always contains 4 January:
	 * var result = setWeek(new Date(2005, 0, 2), 1, {
	 *   weekStartsOn: 1,
	 *   firstWeekContainsDate: 4
	 * })
	 * //=> Sun Jan 4 2004 00:00:00
	 */
	function setWeek(dirtyDate, dirtyWeek, dirtyOptions) {
	  (0, _index4.default)(2, arguments);
	  var date = (0, _index2.default)(dirtyDate);
	  var week = (0, _index3.default)(dirtyWeek);
	  var diff = (0, _index.default)(date, dirtyOptions) - week;
	  date.setDate(date.getDate() - diff * 7);
	  return date;
	}
	
	module.exports = exports.default;

/***/ },
/* 999 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = set;
	
	var _index = _interopRequireDefault(__webpack_require__(3));
	
	var _index2 = _interopRequireDefault(__webpack_require__(189));
	
	var _index3 = _interopRequireDefault(__webpack_require__(9));
	
	var _index4 = _interopRequireDefault(__webpack_require__(2));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name set
	 * @category Common Helpers
	 * @summary Set date values to a given date.
	 *
	 * @description
	 * Set date values to a given date.
	 *
	 * Sets time values to date from object `values`.
	 * A value is not set if it is undefined or null or doesn't exist in `values`.
	 *
	 * Note about bundle size: `set` does not internally use `setX` functions from date-fns but instead opts
	 * to use native `Date#setX` methods. If you use this function, you may not want to include the
	 * other `setX` functions that date-fns provides if you are concerned about the bundle size.
	 *
	 * @param {Date|Number} date - the date to be changed
	 * @param {Object} values - an object with options
	 * @param {Number} [values.year] - the number of years to be set
	 * @param {Number} [values.month] - the number of months to be set
	 * @param {Number} [values.date] - the number of days to be set
	 * @param {Number} [values.hours] - the number of hours to be set
	 * @param {Number} [values.minutes] - the number of minutes to be set
	 * @param {Number} [values.seconds] - the number of seconds to be set
	 * @param {Number} [values.milliseconds] - the number of milliseconds to be set
	 * @returns {Date} the new date with options set
	 * @throws {TypeError} 2 arguments required
	 * @throws {RangeError} `values` must be an object
	 *
	 * @example
	 * // Transform 1 September 2014 into 20 October 2015 in a single line:
	 * var result = set(new Date(2014, 8, 20), { year: 2015, month: 9, date: 20 })
	 * //=> Tue Oct 20 2015 00:00:00
	 *
	 * @example
	 * // Set 12 PM to 1 September 2014 01:23:45 to 1 September 2014 12:00:00:
	 * var result = set(new Date(2014, 8, 1, 1, 23, 45), { hours: 12 })
	 * //=> Mon Sep 01 2014 12:23:45
	 */
	function set(dirtyDate, values) {
	  (0, _index4.default)(2, arguments);
	
	  if (typeof values !== 'object' || values === null) {
	    throw new RangeError('values parameter must be an object');
	  }
	
	  var date = (0, _index.default)(dirtyDate); // Check if date is Invalid Date because Date.prototype.setFullYear ignores the value of Invalid Date
	
	  if (isNaN(date)) {
	    return new Date(NaN);
	  }
	
	  if (values.year != null) {
	    date.setFullYear(values.year);
	  }
	
	  if (values.month != null) {
	    date = (0, _index2.default)(date, values.month);
	  }
	
	  if (values.date != null) {
	    date.setDate((0, _index3.default)(values.date));
	  }
	
	  if (values.hours != null) {
	    date.setHours((0, _index3.default)(values.hours));
	  }
	
	  if (values.minutes != null) {
	    date.setMinutes((0, _index3.default)(values.minutes));
	  }
	
	  if (values.seconds != null) {
	    date.setSeconds((0, _index3.default)(values.seconds));
	  }
	
	  if (values.milliseconds != null) {
	    date.setMilliseconds((0, _index3.default)(values.milliseconds));
	  }
	
	  return date;
	}
	
	module.exports = exports.default;

/***/ },
/* 1000 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = startOfDecade;
	
	var _index = _interopRequireDefault(__webpack_require__(3));
	
	var _index2 = _interopRequireDefault(__webpack_require__(2));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name startOfDecade
	 * @category Decade Helpers
	 * @summary Return the start of a decade for the given date.
	 *
	 * @description
	 * Return the start of a decade for the given date.
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} date - the original date
	 * @returns {Date} the start of a decade
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // The start of a decade for 21 October 2015 00:00:00:
	 * var result = startOfDecade(new Date(2015, 9, 21, 00, 00, 00))
	 * //=> Jan 01 2010 00:00:00
	 */
	function startOfDecade(dirtyDate) {
	  (0, _index2.default)(1, arguments);
	  var date = (0, _index.default)(dirtyDate);
	  var year = date.getFullYear();
	  var decade = Math.floor(year / 10) * 10;
	  date.setFullYear(decade, 0, 1);
	  date.setHours(0, 0, 0, 0);
	  return date;
	}
	
	module.exports = exports.default;

/***/ },
/* 1001 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = startOfToday;
	
	var _index = _interopRequireDefault(__webpack_require__(116));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name startOfToday
	 * @category Day Helpers
	 * @summary Return the start of today.
	 * @pure false
	 *
	 * @description
	 * Return the start of today.
	 *
	 * > ⚠️ Please note that this function is not present in the FP submodule as
	 * > it uses `Date.now()` internally hence impure and can't be safely curried.
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @returns {Date} the start of today
	 *
	 * @example
	 * // If today is 6 October 2014:
	 * var result = startOfToday()
	 * //=> Mon Oct 6 2014 00:00:00
	 */
	function startOfToday() {
	  return (0, _index.default)(Date.now());
	}
	
	module.exports = exports.default;

/***/ },
/* 1002 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = startOfTomorrow;
	
	/**
	 * @name startOfTomorrow
	 * @category Day Helpers
	 * @summary Return the start of tomorrow.
	 * @pure false
	 *
	 * @description
	 * Return the start of tomorrow.
	 *
	 * > ⚠️ Please note that this function is not present in the FP submodule as
	 * > it uses `new Date()` internally hence impure and can't be safely curried.
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @returns {Date} the start of tomorrow
	 *
	 * @example
	 * // If today is 6 October 2014:
	 * var result = startOfTomorrow()
	 * //=> Tue Oct 7 2014 00:00:00
	 */
	function startOfTomorrow() {
	  var now = new Date();
	  var year = now.getFullYear();
	  var month = now.getMonth();
	  var day = now.getDate();
	  var date = new Date(0);
	  date.setFullYear(year, month, day + 1);
	  date.setHours(0, 0, 0, 0);
	  return date;
	}
	
	module.exports = exports.default;

/***/ },
/* 1003 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = startOfYesterday;
	
	/**
	 * @name startOfYesterday
	 * @category Day Helpers
	 * @summary Return the start of yesterday.
	 * @pure false
	 *
	 * @description
	 * Return the start of yesterday.
	 *
	 * > ⚠️ Please note that this function is not present in the FP submodule as
	 * > it uses `new Date()` internally hence impure and can't be safely curried.
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @returns {Date} the start of yesterday
	 *
	 * @example
	 * // If today is 6 October 2014:
	 * var result = startOfYesterday()
	 * //=> Sun Oct 5 2014 00:00:00
	 */
	function startOfYesterday() {
	  var now = new Date();
	  var year = now.getFullYear();
	  var month = now.getMonth();
	  var day = now.getDate();
	  var date = new Date(0);
	  date.setFullYear(year, month, day - 1);
	  date.setHours(0, 0, 0, 0);
	  return date;
	}
	
	module.exports = exports.default;

/***/ },
/* 1004 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = subBusinessDays;
	
	var _index = _interopRequireDefault(__webpack_require__(9));
	
	var _index2 = _interopRequireDefault(__webpack_require__(397));
	
	var _index3 = _interopRequireDefault(__webpack_require__(2));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name subBusinessDays
	 * @category Day Helpers
	 * @summary Substract the specified number of business days (mon - fri) to the given date.
	 *
	 * @description
	 * Substract the specified number of business days (mon - fri) to the given date, ignoring weekends.
	 *
	 * @param {Date|Number} date - the date to be changed
	 * @param {Number} amount - the amount of business days to be subtracted. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
	 * @returns {Date} the new date with the business days subtracted
	 * @throws {TypeError} 2 arguments required
	 *
	 * @example
	 * // Substract 10 business days from 1 September 2014:
	 * var result = subBusinessDays(new Date(2014, 8, 1), 10)
	 * //=> Mon Aug 18 2014 00:00:00 (skipped weekend days)
	 */
	function subBusinessDays(dirtyDate, dirtyAmount) {
	  (0, _index3.default)(2, arguments);
	  var amount = (0, _index.default)(dirtyAmount);
	  return (0, _index2.default)(dirtyDate, -amount);
	}
	
	module.exports = exports.default;

/***/ },
/* 1005 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = subQuarters;
	
	var _index = _interopRequireDefault(__webpack_require__(9));
	
	var _index2 = _interopRequireDefault(__webpack_require__(262));
	
	var _index3 = _interopRequireDefault(__webpack_require__(2));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name subQuarters
	 * @category Quarter Helpers
	 * @summary Subtract the specified number of year quarters from the given date.
	 *
	 * @description
	 * Subtract the specified number of year quarters from the given date.
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} date - the date to be changed
	 * @param {Number} amount - the amount of quarters to be subtracted. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
	 * @returns {Date} the new date with the quarters subtracted
	 * @throws {TypeError} 2 arguments required
	 *
	 * @example
	 * // Subtract 3 quarters from 1 September 2014:
	 * var result = subQuarters(new Date(2014, 8, 1), 3)
	 * //=> Sun Dec 01 2013 00:00:00
	 */
	function subQuarters(dirtyDate, dirtyAmount) {
	  (0, _index3.default)(2, arguments);
	  var amount = (0, _index.default)(dirtyAmount);
	  return (0, _index2.default)(dirtyDate, -amount);
	}
	
	module.exports = exports.default;

/***/ },
/* 1006 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = subSeconds;
	
	var _index = _interopRequireDefault(__webpack_require__(9));
	
	var _index2 = _interopRequireDefault(__webpack_require__(399));
	
	var _index3 = _interopRequireDefault(__webpack_require__(2));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name subSeconds
	 * @category Second Helpers
	 * @summary Subtract the specified number of seconds from the given date.
	 *
	 * @description
	 * Subtract the specified number of seconds from the given date.
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} date - the date to be changed
	 * @param {Number} amount - the amount of seconds to be subtracted. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
	 * @returns {Date} the new date with the seconds subtracted
	 * @throws {TypeError} 2 arguments required
	 *
	 * @example
	 * // Subtract 30 seconds from 10 July 2014 12:45:00:
	 * var result = subSeconds(new Date(2014, 6, 10, 12, 45, 0), 30)
	 * //=> Thu Jul 10 2014 12:44:30
	 */
	function subSeconds(dirtyDate, dirtyAmount) {
	  (0, _index3.default)(2, arguments);
	  var amount = (0, _index.default)(dirtyAmount);
	  return (0, _index2.default)(dirtyDate, -amount);
	}
	
	module.exports = exports.default;

/***/ },
/* 1007 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }
	
	var _objectWithoutPropertiesLoose = _interopDefault(__webpack_require__(1011));
	var _extends = _interopDefault(__webpack_require__(1009));
	var _assertThisInitialized = _interopDefault(__webpack_require__(1008));
	var _inheritsLoose = _interopDefault(__webpack_require__(1010));
	var PropTypes = _interopDefault(__webpack_require__(20));
	var react = __webpack_require__(1);
	var reactIs = __webpack_require__(211);
	var computeScrollIntoView = _interopDefault(__webpack_require__(621));
	
	var idCounter = 0;
	/**
	 * Accepts a parameter and returns it if it's a function
	 * or a noop function if it's not. This allows us to
	 * accept a callback, but not worry about it if it's not
	 * passed.
	 * @param {Function} cb the callback
	 * @return {Function} a function
	 */
	
	function cbToCb(cb) {
	  return typeof cb === 'function' ? cb : noop;
	}
	
	function noop() {}
	/**
	 * Scroll node into view if necessary
	 * @param {HTMLElement} node the element that should scroll into view
	 * @param {HTMLElement} menuNode the menu element of the component
	 */
	
	
	function scrollIntoView(node, menuNode) {
	  if (node === null) {
	    return;
	  }
	
	  var actions = computeScrollIntoView(node, {
	    boundary: menuNode,
	    block: 'nearest',
	    scrollMode: 'if-needed'
	  });
	  actions.forEach(function (_ref) {
	    var el = _ref.el,
	        top = _ref.top,
	        left = _ref.left;
	    el.scrollTop = top;
	    el.scrollLeft = left;
	  });
	}
	/**
	 * @param {HTMLElement} parent the parent node
	 * @param {HTMLElement} child the child node
	 * @return {Boolean} whether the parent is the child or the child is in the parent
	 */
	
	
	function isOrContainsNode(parent, child) {
	  return parent === child || parent.contains && parent.contains(child);
	}
	/**
	 * Simple debounce implementation. Will call the given
	 * function once after the time given has passed since
	 * it was last called.
	 * @param {Function} fn the function to call after the time
	 * @param {Number} time the time to wait
	 * @return {Function} the debounced function
	 */
	
	
	function debounce(fn, time) {
	  var timeoutId;
	
	  function cancel() {
	    if (timeoutId) {
	      clearTimeout(timeoutId);
	    }
	  }
	
	  function wrapper() {
	    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    cancel();
	    timeoutId = setTimeout(function () {
	      timeoutId = null;
	      fn.apply(void 0, args);
	    }, time);
	  }
	
	  wrapper.cancel = cancel;
	  return wrapper;
	}
	/**
	 * This is intended to be used to compose event handlers.
	 * They are executed in order until one of them sets
	 * `event.preventDownshiftDefault = true`.
	 * @param {...Function} fns the event handler functions
	 * @return {Function} the event handler to add to an element
	 */
	
	
	function callAllEventHandlers() {
	  for (var _len2 = arguments.length, fns = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
	    fns[_key2] = arguments[_key2];
	  }
	
	  return function (event) {
	    for (var _len3 = arguments.length, args = new Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++) {
	      args[_key3 - 1] = arguments[_key3];
	    }
	
	    return fns.some(function (fn) {
	      if (fn) {
	        fn.apply(void 0, [event].concat(args));
	      }
	
	      return event.preventDownshiftDefault || event.hasOwnProperty('nativeEvent') && event.nativeEvent.preventDownshiftDefault;
	    });
	  };
	}
	
	function handleRefs() {
	  for (var _len4 = arguments.length, refs = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
	    refs[_key4] = arguments[_key4];
	  }
	
	  return function (node) {
	    refs.forEach(function (ref) {
	      if (typeof ref === 'function') {
	        ref(node);
	      } else if (ref) {
	        ref.current = node;
	      }
	    });
	  };
	}
	/**
	 * This generates a unique ID for an instance of Downshift
	 * @return {String} the unique ID
	 */
	
	
	function generateId() {
	  return String(idCounter++);
	}
	/**
	 * Resets idCounter to 0. Used for SSR.
	 */
	
	
	function resetIdCounter() {
	  idCounter = 0;
	}
	/**
	 * @param {Object} param the downshift state and other relevant properties
	 * @return {String} the a11y status message
	 */
	
	
	function getA11yStatusMessage(_ref2) {
	  var isOpen = _ref2.isOpen,
	      selectedItem = _ref2.selectedItem,
	      resultCount = _ref2.resultCount,
	      previousResultCount = _ref2.previousResultCount,
	      itemToString = _ref2.itemToString;
	
	  if (!isOpen) {
	    return selectedItem ? itemToString(selectedItem) : '';
	  }
	
	  if (!resultCount) {
	    return 'No results are available.';
	  }
	
	  if (resultCount !== previousResultCount) {
	    return resultCount + " result" + (resultCount === 1 ? ' is' : 's are') + " available, use up and down arrow keys to navigate. Press Enter key to select.";
	  }
	
	  return '';
	}
	/**
	 * Takes an argument and if it's an array, returns the first item in the array
	 * otherwise returns the argument
	 * @param {*} arg the maybe-array
	 * @param {*} defaultValue the value if arg is falsey not defined
	 * @return {*} the arg or it's first item
	 */
	
	
	function unwrapArray(arg, defaultValue) {
	  arg = Array.isArray(arg) ?
	  /* istanbul ignore next (preact) */
	  arg[0] : arg;
	
	  if (!arg && defaultValue) {
	    return defaultValue;
	  } else {
	    return arg;
	  }
	}
	/**
	 * @param {Object} element (P)react element
	 * @return {Boolean} whether it's a DOM element
	 */
	
	
	function isDOMElement(element) {
	  // then we assume this is react
	  return typeof element.type === 'string';
	}
	/**
	 * @param {Object} element (P)react element
	 * @return {Object} the props
	 */
	
	
	function getElementProps(element) {
	  return element.props;
	}
	/**
	 * Throws a helpful error message for required properties. Useful
	 * to be used as a default in destructuring or object params.
	 * @param {String} fnName the function name
	 * @param {String} propName the prop name
	 */
	
	
	function requiredProp(fnName, propName) {
	  // eslint-disable-next-line no-console
	  console.error("The property \"" + propName + "\" is required in \"" + fnName + "\"");
	}
	
	var stateKeys = ['highlightedIndex', 'inputValue', 'isOpen', 'selectedItem', 'type'];
	/**
	 * @param {Object} state the state object
	 * @return {Object} state that is relevant to downshift
	 */
	
	function pickState(state) {
	  if (state === void 0) {
	    state = {};
	  }
	
	  var result = {};
	  stateKeys.forEach(function (k) {
	    if (state.hasOwnProperty(k)) {
	      result[k] = state[k];
	    }
	  });
	  return result;
	}
	/**
	 * Normalizes the 'key' property of a KeyboardEvent in IE/Edge
	 * @param {Object} event a keyboardEvent object
	 * @return {String} keyboard key
	 */
	
	
	function normalizeArrowKey(event) {
	  var key = event.key,
	      keyCode = event.keyCode;
	  /* istanbul ignore next (ie) */
	
	  if (keyCode >= 37 && keyCode <= 40 && key.indexOf('Arrow') !== 0) {
	    return "Arrow" + key;
	  }
	
	  return key;
	}
	/**
	 * Simple check if the value passed is object literal
	 * @param {*} obj any things
	 * @return {Boolean} whether it's object literal
	 */
	
	
	function isPlainObject(obj) {
	  return Object.prototype.toString.call(obj) === '[object Object]';
	}
	/**
	 * Returns the new index in the list, in a circular way. If next value is out of bonds from the total,
	 * it will wrap to either 0 or itemCount - 1.
	 *
	 * @param {number} moveAmount Number of positions to move. Negative to move backwards, positive forwards.
	 * @param {number} baseIndex The initial position to move from.
	 * @param {number} itemCount The total number of items.
	 * @returns {number} The new index after the move.
	 */
	
	
	function getNextWrappingIndex(moveAmount, baseIndex, itemCount) {
	  var itemsLastIndex = itemCount - 1;
	
	  if (typeof baseIndex !== 'number' || baseIndex < 0 || baseIndex >= itemCount) {
	    baseIndex = moveAmount > 0 ? -1 : itemsLastIndex + 1;
	  }
	
	  var newIndex = baseIndex + moveAmount;
	
	  if (newIndex < 0) {
	    newIndex = itemsLastIndex;
	  } else if (newIndex > itemsLastIndex) {
	    newIndex = 0;
	  }
	
	  return newIndex;
	}
	
	var cleanupStatus = debounce(function () {
	  getStatusDiv().textContent = '';
	}, 500);
	/**
	 * @param {String} status the status message
	 * @param {Object} documentProp document passed by the user.
	 */
	
	function setStatus(status, documentProp) {
	  var div = getStatusDiv(documentProp);
	
	  if (!status) {
	    return;
	  }
	
	  div.textContent = status;
	  cleanupStatus();
	}
	/**
	 * Get the status node or create it if it does not already exist.
	 * @param {Object} documentProp document passed by the user.
	 * @return {HTMLElement} the status node.
	 */
	
	
	function getStatusDiv(documentProp) {
	  if (documentProp === void 0) {
	    documentProp = document;
	  }
	
	  var statusDiv = documentProp.getElementById('a11y-status-message');
	
	  if (statusDiv) {
	    return statusDiv;
	  }
	
	  statusDiv = documentProp.createElement('div');
	  statusDiv.setAttribute('id', 'a11y-status-message');
	  statusDiv.setAttribute('role', 'status');
	  statusDiv.setAttribute('aria-live', 'polite');
	  statusDiv.setAttribute('aria-relevant', 'additions text');
	  Object.assign(statusDiv.style, {
	    border: '0',
	    clip: 'rect(0 0 0 0)',
	    height: '1px',
	    margin: '-1px',
	    overflow: 'hidden',
	    padding: '0',
	    position: 'absolute',
	    width: '1px'
	  });
	  documentProp.body.appendChild(statusDiv);
	  return statusDiv;
	}
	
	var unknown =  false ? '__autocomplete_unknown__' : 0;
	var mouseUp =  false ? '__autocomplete_mouseup__' : 1;
	var itemMouseEnter =  false ? '__autocomplete_item_mouseenter__' : 2;
	var keyDownArrowUp =  false ? '__autocomplete_keydown_arrow_up__' : 3;
	var keyDownArrowDown =  false ? '__autocomplete_keydown_arrow_down__' : 4;
	var keyDownEscape =  false ? '__autocomplete_keydown_escape__' : 5;
	var keyDownEnter =  false ? '__autocomplete_keydown_enter__' : 6;
	var keyDownHome =  false ? '__autocomplete_keydown_home__' : 7;
	var keyDownEnd =  false ? '__autocomplete_keydown_end__' : 8;
	var clickItem =  false ? '__autocomplete_click_item__' : 9;
	var blurInput =  false ? '__autocomplete_blur_input__' : 10;
	var changeInput =  false ? '__autocomplete_change_input__' : 11;
	var keyDownSpaceButton =  false ? '__autocomplete_keydown_space_button__' : 12;
	var clickButton =  false ? '__autocomplete_click_button__' : 13;
	var blurButton =  false ? '__autocomplete_blur_button__' : 14;
	var controlledPropUpdatedSelectedItem =  false ? '__autocomplete_controlled_prop_updated_selected_item__' : 15;
	var touchEnd =  false ? '__autocomplete_touchend__' : 16;
	
	var stateChangeTypes = /*#__PURE__*/Object.freeze({
	  __proto__: null,
	  unknown: unknown,
	  mouseUp: mouseUp,
	  itemMouseEnter: itemMouseEnter,
	  keyDownArrowUp: keyDownArrowUp,
	  keyDownArrowDown: keyDownArrowDown,
	  keyDownEscape: keyDownEscape,
	  keyDownEnter: keyDownEnter,
	  keyDownHome: keyDownHome,
	  keyDownEnd: keyDownEnd,
	  clickItem: clickItem,
	  blurInput: blurInput,
	  changeInput: changeInput,
	  keyDownSpaceButton: keyDownSpaceButton,
	  clickButton: clickButton,
	  blurButton: blurButton,
	  controlledPropUpdatedSelectedItem: controlledPropUpdatedSelectedItem,
	  touchEnd: touchEnd
	});
	
	var Downshift =
	/*#__PURE__*/
	function () {
	  var Downshift =
	  /*#__PURE__*/
	  function (_Component) {
	    _inheritsLoose(Downshift, _Component);
	
	    function Downshift(_props) {
	      var _this = _Component.call(this, _props) || this;
	
	      _this.id = _this.props.id || "downshift-" + generateId();
	      _this.menuId = _this.props.menuId || _this.id + "-menu";
	      _this.labelId = _this.props.labelId || _this.id + "-label";
	      _this.inputId = _this.props.inputId || _this.id + "-input";
	
	      _this.getItemId = _this.props.getItemId || function (index) {
	        return _this.id + "-item-" + index;
	      };
	
	      _this.input = null;
	      _this.items = [];
	      _this.itemCount = null;
	      _this.previousResultCount = 0;
	      _this.timeoutIds = [];
	
	      _this.internalSetTimeout = function (fn, time) {
	        var id = setTimeout(function () {
	          _this.timeoutIds = _this.timeoutIds.filter(function (i) {
	            return i !== id;
	          });
	          fn();
	        }, time);
	
	        _this.timeoutIds.push(id);
	      };
	
	      _this.setItemCount = function (count) {
	        _this.itemCount = count;
	      };
	
	      _this.unsetItemCount = function () {
	        _this.itemCount = null;
	      };
	
	      _this.setHighlightedIndex = function (highlightedIndex, otherStateToSet) {
	        if (highlightedIndex === void 0) {
	          highlightedIndex = _this.props.defaultHighlightedIndex;
	        }
	
	        if (otherStateToSet === void 0) {
	          otherStateToSet = {};
	        }
	
	        otherStateToSet = pickState(otherStateToSet);
	
	        _this.internalSetState(_extends({
	          highlightedIndex: highlightedIndex
	        }, otherStateToSet));
	      };
	
	      _this.clearSelection = function (cb) {
	        _this.internalSetState({
	          selectedItem: null,
	          inputValue: '',
	          highlightedIndex: _this.props.defaultHighlightedIndex,
	          isOpen: _this.props.defaultIsOpen
	        }, cb);
	      };
	
	      _this.selectItem = function (item, otherStateToSet, cb) {
	        otherStateToSet = pickState(otherStateToSet);
	
	        _this.internalSetState(_extends({
	          isOpen: _this.props.defaultIsOpen,
	          highlightedIndex: _this.props.defaultHighlightedIndex,
	          selectedItem: item,
	          inputValue: _this.props.itemToString(item)
	        }, otherStateToSet), cb);
	      };
	
	      _this.selectItemAtIndex = function (itemIndex, otherStateToSet, cb) {
	        var item = _this.items[itemIndex];
	
	        if (item == null) {
	          return;
	        }
	
	        _this.selectItem(item, otherStateToSet, cb);
	      };
	
	      _this.selectHighlightedItem = function (otherStateToSet, cb) {
	        return _this.selectItemAtIndex(_this.getState().highlightedIndex, otherStateToSet, cb);
	      };
	
	      _this.internalSetState = function (stateToSet, cb) {
	        var isItemSelected, onChangeArg;
	        var onStateChangeArg = {};
	        var isStateToSetFunction = typeof stateToSet === 'function'; // we want to call `onInputValueChange` before the `setState` call
	        // so someone controlling the `inputValue` state gets notified of
	        // the input change as soon as possible. This avoids issues with
	        // preserving the cursor position.
	        // See https://github.com/downshift-js/downshift/issues/217 for more info.
	
	        if (!isStateToSetFunction && stateToSet.hasOwnProperty('inputValue')) {
	          _this.props.onInputValueChange(stateToSet.inputValue, _extends({}, _this.getStateAndHelpers(), {}, stateToSet));
	        }
	
	        return _this.setState(function (state) {
	          state = _this.getState(state);
	          var newStateToSet = isStateToSetFunction ? stateToSet(state) : stateToSet; // Your own function that could modify the state that will be set.
	
	          newStateToSet = _this.props.stateReducer(state, newStateToSet); // checks if an item is selected, regardless of if it's different from
	          // what was selected before
	          // used to determine if onSelect and onChange callbacks should be called
	
	          isItemSelected = newStateToSet.hasOwnProperty('selectedItem'); // this keeps track of the object we want to call with setState
	
	          var nextState = {}; // this is just used to tell whether the state changed
	
	          var nextFullState = {}; // we need to call on change if the outside world is controlling any of our state
	          // and we're trying to update that state. OR if the selection has changed and we're
	          // trying to update the selection
	
	          if (isItemSelected && newStateToSet.selectedItem !== state.selectedItem) {
	            onChangeArg = newStateToSet.selectedItem;
	          }
	
	          newStateToSet.type = newStateToSet.type || unknown;
	          Object.keys(newStateToSet).forEach(function (key) {
	            // onStateChangeArg should only have the state that is
	            // actually changing
	            if (state[key] !== newStateToSet[key]) {
	              onStateChangeArg[key] = newStateToSet[key];
	            } // the type is useful for the onStateChangeArg
	            // but we don't actually want to set it in internal state.
	            // this is an undocumented feature for now... Not all internalSetState
	            // calls support it and I'm not certain we want them to yet.
	            // But it enables users controlling the isOpen state to know when
	            // the isOpen state changes due to mouseup events which is quite handy.
	
	
	            if (key === 'type') {
	              return;
	            }
	
	            nextFullState[key] = newStateToSet[key]; // if it's coming from props, then we don't care to set it internally
	
	            if (!_this.isControlledProp(key)) {
	              nextState[key] = newStateToSet[key];
	            }
	          }); // if stateToSet is a function, then we weren't able to call onInputValueChange
	          // earlier, so we'll call it now that we know what the inputValue state will be.
	
	          if (isStateToSetFunction && newStateToSet.hasOwnProperty('inputValue')) {
	            _this.props.onInputValueChange(newStateToSet.inputValue, _extends({}, _this.getStateAndHelpers(), {}, newStateToSet));
	          }
	
	          return nextState;
	        }, function () {
	          // call the provided callback if it's a function
	          cbToCb(cb)(); // only call the onStateChange and onChange callbacks if
	          // we have relevant information to pass them.
	
	          var hasMoreStateThanType = Object.keys(onStateChangeArg).length > 1;
	
	          if (hasMoreStateThanType) {
	            _this.props.onStateChange(onStateChangeArg, _this.getStateAndHelpers());
	          }
	
	          if (isItemSelected) {
	            _this.props.onSelect(stateToSet.selectedItem, _this.getStateAndHelpers());
	          }
	
	          if (onChangeArg !== undefined) {
	            _this.props.onChange(onChangeArg, _this.getStateAndHelpers());
	          } // this is currently undocumented and therefore subject to change
	          // We'll try to not break it, but just be warned.
	
	
	          _this.props.onUserAction(onStateChangeArg, _this.getStateAndHelpers());
	        });
	      };
	
	      _this.rootRef = function (node) {
	        return _this._rootNode = node;
	      };
	
	      _this.getRootProps = function (_temp, _temp2) {
	        var _extends2;
	
	        var _ref = _temp === void 0 ? {} : _temp,
	            _ref$refKey = _ref.refKey,
	            refKey = _ref$refKey === void 0 ? 'ref' : _ref$refKey,
	            ref = _ref.ref,
	            rest = _objectWithoutPropertiesLoose(_ref, ["refKey", "ref"]);
	
	        var _ref2 = _temp2 === void 0 ? {} : _temp2,
	            _ref2$suppressRefErro = _ref2.suppressRefError,
	            suppressRefError = _ref2$suppressRefErro === void 0 ? false : _ref2$suppressRefErro;
	
	        // this is used in the render to know whether the user has called getRootProps.
	        // It uses that to know whether to apply the props automatically
	        _this.getRootProps.called = true;
	        _this.getRootProps.refKey = refKey;
	        _this.getRootProps.suppressRefError = suppressRefError;
	
	        var _this$getState = _this.getState(),
	            isOpen = _this$getState.isOpen;
	
	        return _extends((_extends2 = {}, _extends2[refKey] = handleRefs(ref, _this.rootRef), _extends2.role = 'combobox', _extends2['aria-expanded'] = isOpen, _extends2['aria-haspopup'] = 'listbox', _extends2['aria-owns'] = isOpen ? _this.menuId : null, _extends2['aria-labelledby'] = _this.labelId, _extends2), rest);
	      };
	
	      _this.keyDownHandlers = {
	        ArrowDown: function ArrowDown(event) {
	          var _this2 = this;
	
	          event.preventDefault();
	
	          if (this.getState().isOpen) {
	            var amount = event.shiftKey ? 5 : 1;
	            this.moveHighlightedIndex(amount, {
	              type: keyDownArrowDown
	            });
	          } else {
	            this.internalSetState({
	              isOpen: true,
	              type: keyDownArrowDown
	            }, function () {
	              var itemCount = _this2.getItemCount();
	
	              if (itemCount > 0) {
	                _this2.setHighlightedIndex(getNextWrappingIndex(1, _this2.getState().highlightedIndex, itemCount), {
	                  type: keyDownArrowDown
	                });
	              }
	            });
	          }
	        },
	        ArrowUp: function ArrowUp(event) {
	          var _this3 = this;
	
	          event.preventDefault();
	
	          if (this.getState().isOpen) {
	            var amount = event.shiftKey ? -5 : -1;
	            this.moveHighlightedIndex(amount, {
	              type: keyDownArrowUp
	            });
	          } else {
	            this.internalSetState({
	              isOpen: true,
	              type: keyDownArrowUp
	            }, function () {
	              var itemCount = _this3.getItemCount();
	
	              if (itemCount > 0) {
	                _this3.setHighlightedIndex(getNextWrappingIndex(-1, _this3.getState().highlightedIndex, itemCount), {
	                  type: keyDownArrowDown
	                });
	              }
	            });
	          }
	        },
	        Enter: function Enter(event) {
	          var _this$getState2 = this.getState(),
	              isOpen = _this$getState2.isOpen,
	              highlightedIndex = _this$getState2.highlightedIndex;
	
	          if (isOpen && highlightedIndex != null) {
	            event.preventDefault();
	            var item = this.items[highlightedIndex];
	            var itemNode = this.getItemNodeFromIndex(highlightedIndex);
	
	            if (item == null || itemNode && itemNode.hasAttribute('disabled')) {
	              return;
	            }
	
	            this.selectHighlightedItem({
	              type: keyDownEnter
	            });
	          }
	        },
	        Escape: function Escape(event) {
	          event.preventDefault();
	          this.reset({
	            type: keyDownEscape,
	            selectedItem: null,
	            inputValue: ''
	          });
	        }
	      };
	      _this.buttonKeyDownHandlers = _extends({}, _this.keyDownHandlers, {
	        ' ': function _(event) {
	          event.preventDefault();
	          this.toggleMenu({
	            type: keyDownSpaceButton
	          });
	        }
	      });
	      _this.inputKeyDownHandlers = _extends({}, _this.keyDownHandlers, {
	        Home: function Home(event) {
	          this.highlightFirstOrLastIndex(event, true, {
	            type: keyDownHome
	          });
	        },
	        End: function End(event) {
	          this.highlightFirstOrLastIndex(event, false, {
	            type: keyDownEnd
	          });
	        }
	      });
	
	      _this.getToggleButtonProps = function (_temp3) {
	        var _ref3 = _temp3 === void 0 ? {} : _temp3,
	            onClick = _ref3.onClick,
	            onPress = _ref3.onPress,
	            onKeyDown = _ref3.onKeyDown,
	            onKeyUp = _ref3.onKeyUp,
	            onBlur = _ref3.onBlur,
	            rest = _objectWithoutPropertiesLoose(_ref3, ["onClick", "onPress", "onKeyDown", "onKeyUp", "onBlur"]);
	
	        var _this$getState3 = _this.getState(),
	            isOpen = _this$getState3.isOpen;
	
	        var enabledEventHandlers = {
	          onClick: callAllEventHandlers(onClick, _this.buttonHandleClick),
	          onKeyDown: callAllEventHandlers(onKeyDown, _this.buttonHandleKeyDown),
	          onKeyUp: callAllEventHandlers(onKeyUp, _this.buttonHandleKeyUp),
	          onBlur: callAllEventHandlers(onBlur, _this.buttonHandleBlur)
	        };
	        var eventHandlers = rest.disabled ? {} : enabledEventHandlers;
	        return _extends({
	          type: 'button',
	          role: 'button',
	          'aria-label': isOpen ? 'close menu' : 'open menu',
	          'aria-haspopup': true,
	          'data-toggle': true
	        }, eventHandlers, {}, rest);
	      };
	
	      _this.buttonHandleKeyUp = function (event) {
	        // Prevent click event from emitting in Firefox
	        event.preventDefault();
	      };
	
	      _this.buttonHandleKeyDown = function (event) {
	        var key = normalizeArrowKey(event);
	
	        if (_this.buttonKeyDownHandlers[key]) {
	          _this.buttonKeyDownHandlers[key].call(_assertThisInitialized(_this), event);
	        }
	      };
	
	      _this.buttonHandleClick = function (event) {
	        event.preventDefault(); // handle odd case for Safari and Firefox which
	        // don't give the button the focus properly.
	
	        /* istanbul ignore if (can't reasonably test this) */
	
	        if ( _this.props.environment.document.activeElement === _this.props.environment.document.body) {
	          event.target.focus();
	        } // to simplify testing components that use downshift, we'll not wrap this in a setTimeout
	        // if the NODE_ENV is test. With the proper build system, this should be dead code eliminated
	        // when building for production and should therefore have no impact on production code.
	
	
	        if (false) {
	          _this.toggleMenu({
	            type: clickButton
	          });
	        } else {
	          // Ensure that toggle of menu occurs after the potential blur event in iOS
	          _this.internalSetTimeout(function () {
	            return _this.toggleMenu({
	              type: clickButton
	            });
	          });
	        }
	      };
	
	      _this.buttonHandleBlur = function (event) {
	        var blurTarget = event.target; // Save blur target for comparison with activeElement later
	        // Need setTimeout, so that when the user presses Tab, the activeElement is the next focused element, not body element
	
	        _this.internalSetTimeout(function () {
	          if (!_this.isMouseDown && (_this.props.environment.document.activeElement == null || _this.props.environment.document.activeElement.id !== _this.inputId) && _this.props.environment.document.activeElement !== blurTarget // Do nothing if we refocus the same element again (to solve issue in Safari on iOS)
	          ) {
	              _this.reset({
	                type: blurButton
	              });
	            }
	        });
	      };
	
	      _this.getLabelProps = function (props) {
	        return _extends({
	          htmlFor: _this.inputId,
	          id: _this.labelId
	        }, props);
	      };
	
	      _this.getInputProps = function (_temp4) {
	        var _ref4 = _temp4 === void 0 ? {} : _temp4,
	            onKeyDown = _ref4.onKeyDown,
	            onBlur = _ref4.onBlur,
	            onChange = _ref4.onChange,
	            onInput = _ref4.onInput,
	            onChangeText = _ref4.onChangeText,
	            rest = _objectWithoutPropertiesLoose(_ref4, ["onKeyDown", "onBlur", "onChange", "onInput", "onChangeText"]);
	
	        var onChangeKey;
	        var eventHandlers = {};
	        /* istanbul ignore next (preact) */
	
	        onChangeKey = 'onChange';
	
	        var _this$getState4 = _this.getState(),
	            inputValue = _this$getState4.inputValue,
	            isOpen = _this$getState4.isOpen,
	            highlightedIndex = _this$getState4.highlightedIndex;
	
	        if (!rest.disabled) {
	          var _eventHandlers;
	
	          eventHandlers = (_eventHandlers = {}, _eventHandlers[onChangeKey] = callAllEventHandlers(onChange, onInput, _this.inputHandleChange), _eventHandlers.onKeyDown = callAllEventHandlers(onKeyDown, _this.inputHandleKeyDown), _eventHandlers.onBlur = callAllEventHandlers(onBlur, _this.inputHandleBlur), _eventHandlers);
	        }
	        /* istanbul ignore if (react-native) */
	
	
	        return _extends({
	          'aria-autocomplete': 'list',
	          'aria-activedescendant': isOpen && typeof highlightedIndex === 'number' && highlightedIndex >= 0 ? _this.getItemId(highlightedIndex) : null,
	          'aria-controls': isOpen ? _this.menuId : null,
	          'aria-labelledby': _this.labelId,
	          // https://developer.mozilla.org/en-US/docs/Web/Security/Securing_your_site/Turning_off_form_autocompletion
	          // revert back since autocomplete="nope" is ignored on latest Chrome and Opera
	          autoComplete: 'off',
	          value: inputValue,
	          id: _this.inputId
	        }, eventHandlers, {}, rest);
	      };
	
	      _this.inputHandleKeyDown = function (event) {
	        var key = normalizeArrowKey(event);
	
	        if (key && _this.inputKeyDownHandlers[key]) {
	          _this.inputKeyDownHandlers[key].call(_assertThisInitialized(_this), event);
	        }
	      };
	
	      _this.inputHandleChange = function (event) {
	        _this.internalSetState({
	          type: changeInput,
	          isOpen: true,
	          inputValue: event.target.value,
	          highlightedIndex: _this.props.defaultHighlightedIndex
	        });
	      };
	
	      _this.inputHandleBlur = function () {
	        // Need setTimeout, so that when the user presses Tab, the activeElement is the next focused element, not the body element
	        _this.internalSetTimeout(function () {
	          var downshiftButtonIsActive = _this.props.environment.document && !!_this.props.environment.document.activeElement && !!_this.props.environment.document.activeElement.dataset && _this.props.environment.document.activeElement.dataset.toggle && _this._rootNode && _this._rootNode.contains(_this.props.environment.document.activeElement);
	
	          if (!_this.isMouseDown && !downshiftButtonIsActive) {
	            _this.reset({
	              type: blurInput
	            });
	          }
	        });
	      };
	
	      _this.menuRef = function (node) {
	        _this._menuNode = node;
	      };
	
	      _this.getMenuProps = function (_temp5, _temp6) {
	        var _extends3;
	
	        var _ref5 = _temp5 === void 0 ? {} : _temp5,
	            _ref5$refKey = _ref5.refKey,
	            refKey = _ref5$refKey === void 0 ? 'ref' : _ref5$refKey,
	            ref = _ref5.ref,
	            props = _objectWithoutPropertiesLoose(_ref5, ["refKey", "ref"]);
	
	        var _ref6 = _temp6 === void 0 ? {} : _temp6,
	            _ref6$suppressRefErro = _ref6.suppressRefError,
	            suppressRefError = _ref6$suppressRefErro === void 0 ? false : _ref6$suppressRefErro;
	
	        _this.getMenuProps.called = true;
	        _this.getMenuProps.refKey = refKey;
	        _this.getMenuProps.suppressRefError = suppressRefError;
	        return _extends((_extends3 = {}, _extends3[refKey] = handleRefs(ref, _this.menuRef), _extends3.role = 'listbox', _extends3['aria-labelledby'] = props && props['aria-label'] ? null : _this.labelId, _extends3.id = _this.menuId, _extends3), props);
	      };
	
	      _this.getItemProps = function (_temp7) {
	        var _enabledEventHandlers;
	
	        var _ref7 = _temp7 === void 0 ? {} : _temp7,
	            onMouseMove = _ref7.onMouseMove,
	            onMouseDown = _ref7.onMouseDown,
	            onClick = _ref7.onClick,
	            onPress = _ref7.onPress,
	            index = _ref7.index,
	            _ref7$item = _ref7.item,
	            item = _ref7$item === void 0 ?  true ?
	        /* istanbul ignore next */
	        undefined : requiredProp('getItemProps', 'item') : _ref7$item,
	            rest = _objectWithoutPropertiesLoose(_ref7, ["onMouseMove", "onMouseDown", "onClick", "onPress", "index", "item"]);
	
	        if (index === undefined) {
	          _this.items.push(item);
	
	          index = _this.items.indexOf(item);
	        } else {
	          _this.items[index] = item;
	        }
	
	        var onSelectKey = 'onClick';
	        var customClickHandler = onClick;
	        var enabledEventHandlers = (_enabledEventHandlers = {
	          // onMouseMove is used over onMouseEnter here. onMouseMove
	          // is only triggered on actual mouse movement while onMouseEnter
	          // can fire on DOM changes, interrupting keyboard navigation
	          onMouseMove: callAllEventHandlers(onMouseMove, function () {
	            if (index === _this.getState().highlightedIndex) {
	              return;
	            }
	
	            _this.setHighlightedIndex(index, {
	              type: itemMouseEnter
	            }); // We never want to manually scroll when changing state based
	            // on `onMouseMove` because we will be moving the element out
	            // from under the user which is currently scrolling/moving the
	            // cursor
	
	
	            _this.avoidScrolling = true;
	
	            _this.internalSetTimeout(function () {
	              return _this.avoidScrolling = false;
	            }, 250);
	          }),
	          onMouseDown: callAllEventHandlers(onMouseDown, function (event) {
	            // This prevents the activeElement from being changed
	            // to the item so it can remain with the current activeElement
	            // which is a more common use case.
	            event.preventDefault();
	          })
	        }, _enabledEventHandlers[onSelectKey] = callAllEventHandlers(customClickHandler, function () {
	          _this.selectItemAtIndex(index, {
	            type: clickItem
	          });
	        }), _enabledEventHandlers); // Passing down the onMouseDown handler to prevent redirect
	        // of the activeElement if clicking on disabled items
	
	        var eventHandlers = rest.disabled ? {
	          onMouseDown: enabledEventHandlers.onMouseDown
	        } : enabledEventHandlers;
	        return _extends({
	          id: _this.getItemId(index),
	          role: 'option',
	          'aria-selected': _this.getState().highlightedIndex === index
	        }, eventHandlers, {}, rest);
	      };
	
	      _this.clearItems = function () {
	        _this.items = [];
	      };
	
	      _this.reset = function (otherStateToSet, cb) {
	        if (otherStateToSet === void 0) {
	          otherStateToSet = {};
	        }
	
	        otherStateToSet = pickState(otherStateToSet);
	
	        _this.internalSetState(function (_ref8) {
	          var selectedItem = _ref8.selectedItem;
	          return _extends({
	            isOpen: _this.props.defaultIsOpen,
	            highlightedIndex: _this.props.defaultHighlightedIndex,
	            inputValue: _this.props.itemToString(selectedItem)
	          }, otherStateToSet);
	        }, cb);
	      };
	
	      _this.toggleMenu = function (otherStateToSet, cb) {
	        if (otherStateToSet === void 0) {
	          otherStateToSet = {};
	        }
	
	        otherStateToSet = pickState(otherStateToSet);
	
	        _this.internalSetState(function (_ref9) {
	          var isOpen = _ref9.isOpen;
	          return _extends({
	            isOpen: !isOpen
	          }, isOpen && {
	            highlightedIndex: _this.props.defaultHighlightedIndex
	          }, {}, otherStateToSet);
	        }, function () {
	          var _this$getState5 = _this.getState(),
	              isOpen = _this$getState5.isOpen,
	              highlightedIndex = _this$getState5.highlightedIndex;
	
	          if (isOpen) {
	            if (_this.getItemCount() > 0 && typeof highlightedIndex === 'number') {
	              _this.setHighlightedIndex(highlightedIndex, otherStateToSet);
	            }
	          }
	
	          cbToCb(cb)();
	        });
	      };
	
	      _this.openMenu = function (cb) {
	        _this.internalSetState({
	          isOpen: true
	        }, cb);
	      };
	
	      _this.closeMenu = function (cb) {
	        _this.internalSetState({
	          isOpen: false
	        }, cb);
	      };
	
	      _this.updateStatus = debounce(function () {
	        var state = _this.getState();
	
	        var item = _this.items[state.highlightedIndex];
	
	        var resultCount = _this.getItemCount();
	
	        var status = _this.props.getA11yStatusMessage(_extends({
	          itemToString: _this.props.itemToString,
	          previousResultCount: _this.previousResultCount,
	          resultCount: resultCount,
	          highlightedItem: item
	        }, state));
	
	        _this.previousResultCount = resultCount;
	        setStatus(status, _this.props.environment.document);
	      }, 200);
	
	      // fancy destructuring + defaults + aliases
	      // this basically says each value of state should either be set to
	      // the initial value or the default value if the initial value is not provided
	      var _this$props = _this.props,
	          defaultHighlightedIndex = _this$props.defaultHighlightedIndex,
	          _this$props$initialHi = _this$props.initialHighlightedIndex,
	          _highlightedIndex = _this$props$initialHi === void 0 ? defaultHighlightedIndex : _this$props$initialHi,
	          defaultIsOpen = _this$props.defaultIsOpen,
	          _this$props$initialIs = _this$props.initialIsOpen,
	          _isOpen = _this$props$initialIs === void 0 ? defaultIsOpen : _this$props$initialIs,
	          _this$props$initialIn = _this$props.initialInputValue,
	          _inputValue = _this$props$initialIn === void 0 ? '' : _this$props$initialIn,
	          _this$props$initialSe = _this$props.initialSelectedItem,
	          _selectedItem = _this$props$initialSe === void 0 ? null : _this$props$initialSe;
	
	      var _state = _this.getState({
	        highlightedIndex: _highlightedIndex,
	        isOpen: _isOpen,
	        inputValue: _inputValue,
	        selectedItem: _selectedItem
	      });
	
	      if (_state.selectedItem != null && _this.props.initialInputValue === undefined) {
	        _state.inputValue = _this.props.itemToString(_state.selectedItem);
	      }
	
	      _this.state = _state;
	      return _this;
	    }
	
	    var _proto = Downshift.prototype;
	
	    /**
	     * Clear all running timeouts
	     */
	    _proto.internalClearTimeouts = function internalClearTimeouts() {
	      this.timeoutIds.forEach(function (id) {
	        clearTimeout(id);
	      });
	      this.timeoutIds = [];
	    }
	    /**
	     * Gets the state based on internal state or props
	     * If a state value is passed via props, then that
	     * is the value given, otherwise it's retrieved from
	     * stateToMerge
	     *
	     * This will perform a shallow merge of the given state object
	     * with the state coming from props
	     * (for the controlled component scenario)
	     * This is used in state updater functions so they're referencing
	     * the right state regardless of where it comes from.
	     *
	     * @param {Object} stateToMerge defaults to this.state
	     * @return {Object} the state
	     */
	    ;
	
	    _proto.getState = function getState(stateToMerge) {
	      var _this4 = this;
	
	      if (stateToMerge === void 0) {
	        stateToMerge = this.state;
	      }
	
	      return Object.keys(stateToMerge).reduce(function (state, key) {
	        state[key] = _this4.isControlledProp(key) ? _this4.props[key] : stateToMerge[key];
	        return state;
	      }, {});
	    }
	    /**
	     * This determines whether a prop is a "controlled prop" meaning it is
	     * state which is controlled by the outside of this component rather
	     * than within this component.
	     * @param {String} key the key to check
	     * @return {Boolean} whether it is a controlled controlled prop
	     */
	    ;
	
	    _proto.isControlledProp = function isControlledProp(key) {
	      return this.props[key] !== undefined;
	    };
	
	    _proto.getItemCount = function getItemCount() {
	      // things read better this way. They're in priority order:
	      // 1. `this.itemCount`
	      // 2. `this.props.itemCount`
	      // 3. `this.items.length`
	      var itemCount = this.items.length;
	
	      if (this.itemCount != null) {
	        itemCount = this.itemCount;
	      } else if (this.props.itemCount !== undefined) {
	        itemCount = this.props.itemCount;
	      }
	
	      return itemCount;
	    };
	
	    _proto.getItemNodeFromIndex = function getItemNodeFromIndex(index) {
	      return this.props.environment.document.getElementById(this.getItemId(index));
	    };
	
	    _proto.scrollHighlightedItemIntoView = function scrollHighlightedItemIntoView() {
	      /* istanbul ignore else (react-native) */
	      {
	        var node = this.getItemNodeFromIndex(this.getState().highlightedIndex);
	        this.props.scrollIntoView(node, this._menuNode);
	      }
	    };
	
	    _proto.moveHighlightedIndex = function moveHighlightedIndex(amount, otherStateToSet) {
	      var itemCount = this.getItemCount();
	
	      if (itemCount > 0) {
	        var nextHighlightedIndex = getNextWrappingIndex(amount, this.getState().highlightedIndex, itemCount);
	        this.setHighlightedIndex(nextHighlightedIndex, otherStateToSet);
	      }
	    };
	
	    _proto.highlightFirstOrLastIndex = function highlightFirstOrLastIndex(event, first, otherStateToSet) {
	      var itemsLastIndex = this.getItemCount() - 1;
	
	      if (itemsLastIndex < 0 || !this.getState().isOpen) {
	        return;
	      }
	
	      event.preventDefault();
	      this.setHighlightedIndex(first ? 0 : itemsLastIndex, otherStateToSet);
	    };
	
	    _proto.getStateAndHelpers = function getStateAndHelpers() {
	      var _this$getState6 = this.getState(),
	          highlightedIndex = _this$getState6.highlightedIndex,
	          inputValue = _this$getState6.inputValue,
	          selectedItem = _this$getState6.selectedItem,
	          isOpen = _this$getState6.isOpen;
	
	      var itemToString = this.props.itemToString;
	      var id = this.id;
	      var getRootProps = this.getRootProps,
	          getToggleButtonProps = this.getToggleButtonProps,
	          getLabelProps = this.getLabelProps,
	          getMenuProps = this.getMenuProps,
	          getInputProps = this.getInputProps,
	          getItemProps = this.getItemProps,
	          openMenu = this.openMenu,
	          closeMenu = this.closeMenu,
	          toggleMenu = this.toggleMenu,
	          selectItem = this.selectItem,
	          selectItemAtIndex = this.selectItemAtIndex,
	          selectHighlightedItem = this.selectHighlightedItem,
	          setHighlightedIndex = this.setHighlightedIndex,
	          clearSelection = this.clearSelection,
	          clearItems = this.clearItems,
	          reset = this.reset,
	          setItemCount = this.setItemCount,
	          unsetItemCount = this.unsetItemCount,
	          setState = this.internalSetState;
	      return {
	        // prop getters
	        getRootProps: getRootProps,
	        getToggleButtonProps: getToggleButtonProps,
	        getLabelProps: getLabelProps,
	        getMenuProps: getMenuProps,
	        getInputProps: getInputProps,
	        getItemProps: getItemProps,
	        // actions
	        reset: reset,
	        openMenu: openMenu,
	        closeMenu: closeMenu,
	        toggleMenu: toggleMenu,
	        selectItem: selectItem,
	        selectItemAtIndex: selectItemAtIndex,
	        selectHighlightedItem: selectHighlightedItem,
	        setHighlightedIndex: setHighlightedIndex,
	        clearSelection: clearSelection,
	        clearItems: clearItems,
	        setItemCount: setItemCount,
	        unsetItemCount: unsetItemCount,
	        setState: setState,
	        // props
	        itemToString: itemToString,
	        // derived
	        id: id,
	        // state
	        highlightedIndex: highlightedIndex,
	        inputValue: inputValue,
	        isOpen: isOpen,
	        selectedItem: selectedItem
	      };
	    } //////////////////////////// ROOT
	    ;
	
	    _proto.componentDidMount = function componentDidMount() {
	      var _this5 = this;
	
	      /* istanbul ignore if (react-native) */
	      if (false) {
	        validateGetMenuPropsCalledCorrectly(this._menuNode, this.getMenuProps);
	      }
	      /* istanbul ignore if (react-native) */
	
	
	      {
	        var targetWithinDownshift = function (target, checkActiveElement) {
	          if (checkActiveElement === void 0) {
	            checkActiveElement = true;
	          }
	
	          var document = _this5.props.environment.document;
	          return [_this5._rootNode, _this5._menuNode].some(function (contextNode) {
	            return contextNode && (isOrContainsNode(contextNode, target) || checkActiveElement && isOrContainsNode(contextNode, document.activeElement));
	          });
	        }; // this.isMouseDown helps us track whether the mouse is currently held down.
	        // This is useful when the user clicks on an item in the list, but holds the mouse
	        // down long enough for the list to disappear (because the blur event fires on the input)
	        // this.isMouseDown is used in the blur handler on the input to determine whether the blur event should
	        // trigger hiding the menu.
	
	
	        var onMouseDown = function () {
	          _this5.isMouseDown = true;
	        };
	
	        var onMouseUp = function (event) {
	          _this5.isMouseDown = false; // if the target element or the activeElement is within a downshift node
	          // then we don't want to reset downshift
	
	          var contextWithinDownshift = targetWithinDownshift(event.target);
	
	          if (!contextWithinDownshift && _this5.getState().isOpen) {
	            _this5.reset({
	              type: mouseUp
	            }, function () {
	              return _this5.props.onOuterClick(_this5.getStateAndHelpers());
	            });
	          }
	        }; // Touching an element in iOS gives focus and hover states, but touching out of
	        // the element will remove hover, and persist the focus state, resulting in the
	        // blur event not being triggered.
	        // this.isTouchMove helps us track whether the user is tapping or swiping on a touch screen.
	        // If the user taps outside of Downshift, the component should be reset,
	        // but not if the user is swiping
	
	
	        var onTouchStart = function () {
	          _this5.isTouchMove = false;
	        };
	
	        var onTouchMove = function () {
	          _this5.isTouchMove = true;
	        };
	
	        var onTouchEnd = function (event) {
	          var contextWithinDownshift = targetWithinDownshift(event.target, false);
	
	          if (!_this5.isTouchMove && !contextWithinDownshift && _this5.getState().isOpen) {
	            _this5.reset({
	              type: touchEnd
	            }, function () {
	              return _this5.props.onOuterClick(_this5.getStateAndHelpers());
	            });
	          }
	        };
	
	        var environment = this.props.environment;
	        environment.addEventListener('mousedown', onMouseDown);
	        environment.addEventListener('mouseup', onMouseUp);
	        environment.addEventListener('touchstart', onTouchStart);
	        environment.addEventListener('touchmove', onTouchMove);
	        environment.addEventListener('touchend', onTouchEnd);
	
	        this.cleanup = function () {
	          _this5.internalClearTimeouts();
	
	          _this5.updateStatus.cancel();
	
	          environment.removeEventListener('mousedown', onMouseDown);
	          environment.removeEventListener('mouseup', onMouseUp);
	          environment.removeEventListener('touchstart', onTouchStart);
	          environment.removeEventListener('touchmove', onTouchMove);
	          environment.removeEventListener('touchend', onTouchEnd);
	        };
	      }
	    };
	
	    _proto.shouldScroll = function shouldScroll(prevState, prevProps) {
	      var _ref10 = this.props.highlightedIndex === undefined ? this.getState() : this.props,
	          currentHighlightedIndex = _ref10.highlightedIndex;
	
	      var _ref11 = prevProps.highlightedIndex === undefined ? prevState : prevProps,
	          prevHighlightedIndex = _ref11.highlightedIndex;
	
	      var scrollWhenOpen = currentHighlightedIndex && this.getState().isOpen && !prevState.isOpen;
	      return scrollWhenOpen || currentHighlightedIndex !== prevHighlightedIndex;
	    };
	
	    _proto.componentDidUpdate = function componentDidUpdate(prevProps, prevState) {
	      if (false) {
	        validateControlledUnchanged(prevProps, this.props);
	        /* istanbul ignore if (react-native) */
	
	        if ( this.getMenuProps.called && !this.getMenuProps.suppressRefError) {
	          validateGetMenuPropsCalledCorrectly(this._menuNode, this.getMenuProps);
	        }
	      }
	
	      if (this.isControlledProp('selectedItem') && this.props.selectedItemChanged(prevProps.selectedItem, this.props.selectedItem)) {
	        this.internalSetState({
	          type: controlledPropUpdatedSelectedItem,
	          inputValue: this.props.itemToString(this.props.selectedItem)
	        });
	      }
	
	      if (!this.avoidScrolling && this.shouldScroll(prevState, prevProps)) {
	        this.scrollHighlightedItemIntoView();
	      }
	      /* istanbul ignore else (react-native) */
	
	
	      this.updateStatus();
	    };
	
	    _proto.componentWillUnmount = function componentWillUnmount() {
	      this.cleanup(); // avoids memory leak
	    };
	
	    _proto.render = function render() {
	      var children = unwrapArray(this.props.children, noop); // because the items are rerendered every time we call the children
	      // we clear this out each render and it will be populated again as
	      // getItemProps is called.
	
	      this.clearItems(); // we reset this so we know whether the user calls getRootProps during
	      // this render. If they do then we don't need to do anything,
	      // if they don't then we need to clone the element they return and
	      // apply the props for them.
	
	      this.getRootProps.called = false;
	      this.getRootProps.refKey = undefined;
	      this.getRootProps.suppressRefError = undefined; // we do something similar for getMenuProps
	
	      this.getMenuProps.called = false;
	      this.getMenuProps.refKey = undefined;
	      this.getMenuProps.suppressRefError = undefined; // we do something similar for getLabelProps
	
	      this.getLabelProps.called = false; // and something similar for getInputProps
	
	      this.getInputProps.called = false;
	      var element = unwrapArray(children(this.getStateAndHelpers()));
	
	      if (!element) {
	        return null;
	      }
	
	      if (this.getRootProps.called || this.props.suppressRefError) {
	        if (false) {
	          validateGetRootPropsCalledCorrectly(element, this.getRootProps);
	        }
	
	        return element;
	      } else if (isDOMElement(element)) {
	        // they didn't apply the root props, but we can clone
	        // this and apply the props ourselves
	        return react.cloneElement(element, this.getRootProps(getElementProps(element)));
	      }
	      /* istanbul ignore else */
	
	
	      if (false) {
	        // they didn't apply the root props, but they need to
	        // otherwise we can't query around the autocomplete
	        throw new Error('downshift: If you return a non-DOM element, you must apply the getRootProps function');
	      }
	      /* istanbul ignore next */
	
	
	      return undefined;
	    };
	
	    return Downshift;
	  }(react.Component);
	
	  Downshift.defaultProps = {
	    defaultHighlightedIndex: null,
	    defaultIsOpen: false,
	    getA11yStatusMessage: getA11yStatusMessage,
	    itemToString: function itemToString(i) {
	      if (i == null) {
	        return '';
	      }
	
	      if (false) {
	        // eslint-disable-next-line no-console
	        console.warn('downshift: An object was passed to the default implementation of `itemToString`. You should probably provide your own `itemToString` implementation. Please refer to the `itemToString` API documentation.', 'The object that was passed:', i);
	      }
	
	      return String(i);
	    },
	    onStateChange: noop,
	    onInputValueChange: noop,
	    onUserAction: noop,
	    onChange: noop,
	    onSelect: noop,
	    onOuterClick: noop,
	    selectedItemChanged: function selectedItemChanged(prevItem, item) {
	      return prevItem !== item;
	    },
	    environment: typeof window === 'undefined'
	    /* istanbul ignore next (ssr) */
	    ? {} : window,
	    stateReducer: function stateReducer(state, stateToSet) {
	      return stateToSet;
	    },
	    suppressRefError: false,
	    scrollIntoView: scrollIntoView
	  };
	  Downshift.stateChangeTypes = stateChangeTypes;
	  return Downshift;
	}();
	
	 false ? Downshift.propTypes = {
	  children: PropTypes.func,
	  defaultHighlightedIndex: PropTypes.number,
	  defaultIsOpen: PropTypes.bool,
	  initialHighlightedIndex: PropTypes.number,
	  initialSelectedItem: PropTypes.any,
	  initialInputValue: PropTypes.string,
	  initialIsOpen: PropTypes.bool,
	  getA11yStatusMessage: PropTypes.func,
	  itemToString: PropTypes.func,
	  onChange: PropTypes.func,
	  onSelect: PropTypes.func,
	  onStateChange: PropTypes.func,
	  onInputValueChange: PropTypes.func,
	  onUserAction: PropTypes.func,
	  onOuterClick: PropTypes.func,
	  selectedItemChanged: PropTypes.func,
	  stateReducer: PropTypes.func,
	  itemCount: PropTypes.number,
	  id: PropTypes.string,
	  environment: PropTypes.shape({
	    addEventListener: PropTypes.func,
	    removeEventListener: PropTypes.func,
	    document: PropTypes.shape({
	      getElementById: PropTypes.func,
	      activeElement: PropTypes.any,
	      body: PropTypes.any
	    })
	  }),
	  suppressRefError: PropTypes.bool,
	  scrollIntoView: PropTypes.func,
	  // things we keep in state for uncontrolled components
	  // but can accept as props for controlled components
	
	  /* eslint-disable react/no-unused-prop-types */
	  selectedItem: PropTypes.any,
	  isOpen: PropTypes.bool,
	  inputValue: PropTypes.string,
	  highlightedIndex: PropTypes.number,
	  labelId: PropTypes.string,
	  inputId: PropTypes.string,
	  menuId: PropTypes.string,
	  getItemId: PropTypes.func
	  /* eslint-enable react/no-unused-prop-types */
	
	} : void 0;
	
	function validateGetMenuPropsCalledCorrectly(node, _ref12) {
	  var refKey = _ref12.refKey;
	
	  if (!node) {
	    // eslint-disable-next-line no-console
	    console.error("downshift: The ref prop \"" + refKey + "\" from getMenuProps was not applied correctly on your menu element.");
	  }
	}
	
	function validateGetRootPropsCalledCorrectly(element, _ref13) {
	  var refKey = _ref13.refKey;
	  var refKeySpecified = refKey !== 'ref';
	  var isComposite = !isDOMElement(element);
	
	  if (isComposite && !refKeySpecified && !reactIs.isForwardRef(element)) {
	    // eslint-disable-next-line no-console
	    console.error('downshift: You returned a non-DOM element. You must specify a refKey in getRootProps');
	  } else if (!isComposite && refKeySpecified) {
	    // eslint-disable-next-line no-console
	    console.error("downshift: You returned a DOM element. You should not specify a refKey in getRootProps. You specified \"" + refKey + "\"");
	  }
	
	  if (!reactIs.isForwardRef(element) && !getElementProps(element)[refKey]) {
	    // eslint-disable-next-line no-console
	    console.error("downshift: You must apply the ref prop \"" + refKey + "\" from getRootProps onto your root element.");
	  }
	}
	
	function validateControlledUnchanged(prevProps, nextProps) {
	  var warningDescription = "This prop should not switch from controlled to uncontrolled (or vice versa). Decide between using a controlled or uncontrolled Downshift element for the lifetime of the component. More info: https://github.com/downshift-js/downshift#control-props";
	  ['selectedItem', 'isOpen', 'inputValue', 'highlightedIndex'].forEach(function (propKey) {
	    if (prevProps[propKey] !== undefined && nextProps[propKey] === undefined) {
	      // eslint-disable-next-line no-console
	      console.error("downshift: A component has changed the controlled prop \"" + propKey + "\" to be uncontrolled. " + warningDescription);
	    } else if (prevProps[propKey] === undefined && nextProps[propKey] !== undefined) {
	      // eslint-disable-next-line no-console
	      console.error("downshift: A component has changed the uncontrolled prop \"" + propKey + "\" to be controlled. " + warningDescription);
	    }
	  });
	}
	
	function getElementIds(generateDefaultId, _temp) {
	  var _ref = _temp === void 0 ? {} : _temp,
	      id = _ref.id,
	      labelId = _ref.labelId,
	      menuId = _ref.menuId,
	      getItemId = _ref.getItemId,
	      toggleButtonId = _ref.toggleButtonId;
	
	  var uniqueId = id === undefined ? "downshift-" + generateDefaultId() : id;
	  return {
	    labelId: labelId || uniqueId + "-label",
	    menuId: menuId || uniqueId + "-menu",
	    getItemId: getItemId || function (index) {
	      return uniqueId + "-item-" + index;
	    },
	    toggleButtonId: toggleButtonId || uniqueId + "-toggle-button"
	  };
	}
	
	function getNextWrappingIndex$1(moveAmount, baseIndex, itemsLength, circular) {
	  if (baseIndex === -1) {
	    return moveAmount > 0 ? 0 : itemsLength - 1;
	  }
	
	  var nextIndex = baseIndex + moveAmount;
	
	  if (nextIndex < 0) {
	    return circular ? itemsLength - 1 : 0;
	  }
	
	  if (nextIndex >= itemsLength) {
	    return circular ? 0 : itemsLength - 1;
	  }
	
	  return nextIndex;
	}
	
	function getItemIndexByCharacterKey(keysSoFar, highlightedIndex, items, itemToStringParam) {
	  var newHighlightedIndex = -1;
	  var itemStrings = items.map(function (item) {
	    return itemToStringParam(item).toLowerCase();
	  });
	  var startPosition = highlightedIndex + 1;
	  newHighlightedIndex = itemStrings.slice(startPosition).findIndex(function (itemString) {
	    return itemString.startsWith(keysSoFar);
	  });
	
	  if (newHighlightedIndex > -1) {
	    return newHighlightedIndex + startPosition;
	  } else {
	    return itemStrings.slice(0, startPosition).findIndex(function (itemString) {
	      return itemString.startsWith(keysSoFar);
	    });
	  }
	}
	
	function getState(state, props) {
	  return Object.keys(state).reduce(function (prevState, key) {
	    // eslint-disable-next-line no-param-reassign
	    prevState[key] = key in props ? props[key] : state[key];
	    return prevState;
	  }, {});
	}
	
	function getItemIndex(index, item, items) {
	  if (index !== undefined) {
	    return index;
	  }
	
	  if (items.length === 0) {
	    return -1;
	  }
	
	  return items.indexOf(item);
	}
	
	function itemToString(item) {
	  return item ? String(item) : '';
	}
	
	function getPropTypesValidator(caller, propTypes) {
	  // istanbul ignore next
	  return function (options) {
	    if (options === void 0) {
	      options = {};
	    }
	
	    Object.entries(propTypes).forEach(function (_ref2) {
	      var key = _ref2[0];
	      PropTypes.checkPropTypes(propTypes, options, key, caller.name);
	    });
	  };
	}
	
	function isAcceptedCharacterKey(key) {
	  return /^\S{1}$/.test(key);
	}
	
	function capitalizeString(string) {
	  return "" + string.slice(0, 1).toUpperCase() + string.slice(1);
	}
	
	function invokeOnChangeHandler(propKey, props, state, changes) {
	  var handler = "on" + capitalizeString(propKey) + "Change";
	
	  if (props[handler] && changes[propKey] !== undefined && changes[propKey] !== state[propKey]) {
	    props[handler](changes);
	  }
	}
	
	function callOnChangeProps(props, state, changes) {
	  Object.keys(state).forEach(function (stateKey) {
	    invokeOnChangeHandler(stateKey, props, state, changes);
	  });
	
	  if (props.onStateChange && changes !== undefined) {
	    props.onStateChange(changes);
	  }
	}
	
	function useEnhancedReducer(reducer, initialState, props) {
	  var enhancedReducer = react.useCallback(function (state, action) {
	    state = getState(state, action.props);
	    var stateReducer = action.props.stateReducer;
	    var changes = reducer(state, action);
	    var newState = stateReducer(state, _extends({}, action, {
	      changes: changes
	    }));
	    callOnChangeProps(action.props, state, newState);
	    return newState;
	  }, [reducer]);
	
	  var _useReducer = react.useReducer(enhancedReducer, initialState),
	      state = _useReducer[0],
	      dispatch = _useReducer[1];
	
	  return [getState(state, props), dispatch];
	}
	
	var lastId = 0; // istanbul ignore next
	
	var genId = function () {
	  return ++lastId;
	};
	/**
	 * Autogenerate IDs to facilitate WAI-ARIA and server rendering.
	 * Taken from @reach/auto-id
	 * @see https://github.com/reach/reach-ui/blob/6e9dbcf716d5c9a3420e062e5bac1ac4671d01cb/packages/auto-id/src/index.js
	 */
	// istanbul ignore next
	
	
	function useId() {
	  var _useState = react.useState(null),
	      id = _useState[0],
	      setId = _useState[1];
	
	  react.useEffect(function () {
	    return setId(genId());
	  }, []);
	  return id;
	}
	/**
	 * Checks if nextElement receives focus after the blur event.
	 *
	 * @param {FocusEvent} event The blur event.
	 * @param {Element} nextElement The element to check that receive focus next.
	 * @returns {boolean} If the focus lands on nextElement.
	 */
	
	
	function focusLandsOnElement(event, nextElement) {
	  return event.relatedTarget === nextElement || // https://github.com/downshift-js/downshift/issues/832 - workaround for Firefox.
	  event.nativeEvent && (nextElement === event.nativeEvent.explicitOriginalTarget || nextElement.contains(event.nativeEvent.explicitOriginalTarget));
	}
	
	var defaultStateValues = {
	  highlightedIndex: -1,
	  isOpen: false,
	  selectedItem: null
	};
	
	function getA11yStatusMessage$1(_ref) {
	  var isOpen = _ref.isOpen,
	      items = _ref.items;
	
	  if (!items) {
	    return '';
	  }
	
	  var resultCount = items.length;
	
	  if (isOpen) {
	    if (resultCount === 0) {
	      return 'No results are available';
	    }
	
	    return resultCount + " result" + (resultCount === 1 ? ' is' : 's are') + " available, use up and down arrow keys to navigate. Press Enter key to select.";
	  }
	
	  return '';
	}
	
	function getA11ySelectionMessage(_ref2) {
	  var selectedItem = _ref2.selectedItem,
	      itemToString = _ref2.itemToString;
	  return itemToString(selectedItem) + " has been selected.";
	}
	
	function getHighlightedIndexOnOpen(props, state, offset) {
	  var items = props.items,
	      initialHighlightedIndex = props.initialHighlightedIndex,
	      defaultHighlightedIndex = props.defaultHighlightedIndex;
	  var selectedItem = state.selectedItem,
	      highlightedIndex = state.highlightedIndex; // initialHighlightedIndex will give value to highlightedIndex on initial state only.
	
	  if (initialHighlightedIndex !== undefined && highlightedIndex > -1) {
	    return initialHighlightedIndex;
	  }
	
	  if (defaultHighlightedIndex !== undefined) {
	    return defaultHighlightedIndex;
	  }
	
	  if (selectedItem) {
	    if (offset === 0) {
	      return items.indexOf(selectedItem);
	    }
	
	    return getNextWrappingIndex$1(offset, items.indexOf(selectedItem), items.length, false);
	  }
	
	  if (offset === 0) {
	    return -1;
	  }
	
	  return offset < 0 ? items.length - 1 : 0;
	}
	
	function getDefaultValue(props, propKey) {
	  var defaultPropKey = "default" + capitalizeString(propKey);
	
	  if (defaultPropKey in props) {
	    return props[defaultPropKey];
	  }
	
	  return defaultStateValues[propKey];
	}
	
	function getInitialValue(props, propKey) {
	  if (propKey in props) {
	    return props[propKey];
	  }
	
	  var initialPropKey = "initial" + capitalizeString(propKey);
	
	  if (initialPropKey in props) {
	    return props[initialPropKey];
	  }
	
	  return getDefaultValue(props, propKey);
	}
	
	function getInitialState(props) {
	  var selectedItem = getInitialValue(props, 'selectedItem');
	  var highlightedIndex = getInitialValue(props, 'highlightedIndex');
	  var isOpen = getInitialValue(props, 'isOpen');
	  return {
	    highlightedIndex: highlightedIndex < 0 && selectedItem ? props.items.indexOf(selectedItem) : highlightedIndex,
	    isOpen: isOpen,
	    selectedItem: selectedItem,
	    keysSoFar: ''
	  };
	}
	
	var propTypes = {
	  items: PropTypes.array.isRequired,
	  itemToString: PropTypes.func,
	  getA11yStatusMessage: PropTypes.func,
	  getA11ySelectionMessage: PropTypes.func,
	  circularNavigation: PropTypes.bool,
	  highlightedIndex: PropTypes.number,
	  defaultHighlightedIndex: PropTypes.number,
	  initialHighlightedIndex: PropTypes.number,
	  isOpen: PropTypes.bool,
	  defaultIsOpen: PropTypes.bool,
	  initialIsOpen: PropTypes.bool,
	  selectedItem: PropTypes.any,
	  initialSelectedItem: PropTypes.any,
	  defaultSelectedItem: PropTypes.any,
	  id: PropTypes.string,
	  labelId: PropTypes.string,
	  menuId: PropTypes.string,
	  getItemId: PropTypes.func,
	  toggleButtonId: PropTypes.string,
	  stateReducer: PropTypes.func,
	  onSelectedItemChange: PropTypes.func,
	  onHighlightedIndexChange: PropTypes.func,
	  onStateChange: PropTypes.func,
	  onIsOpenChange: PropTypes.func,
	  environment: PropTypes.shape({
	    addEventListener: PropTypes.func,
	    removeEventListener: PropTypes.func,
	    document: PropTypes.shape({
	      getElementById: PropTypes.func,
	      activeElement: PropTypes.any,
	      body: PropTypes.any
	    })
	  })
	};
	
	var MenuKeyDownArrowDown =  false ? '__menu_keydown_arrow_down__' : 0;
	var MenuKeyDownArrowUp =  false ? '__menu_keydown_arrow_up__' : 1;
	var MenuKeyDownEscape =  false ? '__menu_keydown_escape__' : 2;
	var MenuKeyDownHome =  false ? '__menu_keydown_home__' : 3;
	var MenuKeyDownEnd =  false ? '__menu_keydown_end__' : 4;
	var MenuKeyDownEnter =  false ? '__menu_keydown_enter__' : 5;
	var MenuKeyDownCharacter =  false ? '__menu_keydown_character__' : 6;
	var MenuBlur =  false ? '__menu_blur__' : 7;
	var MenuMouseLeave =  false ? '__menu_mouse_leave__' : 8;
	var ItemMouseMove =  false ? '__item_mouse_move__' : 9;
	var ItemClick =  false ? '__item_click__' : 10;
	var ToggleButtonKeyDownCharacter =  false ? '__togglebutton_keydown_character__' : 11;
	var ToggleButtonKeyDownArrowDown =  false ? '__togglebutton_keydown_arrow_down__' : 12;
	var ToggleButtonKeyDownArrowUp =  false ? '__togglebutton_keydown_arrow_up__' : 13;
	var ToggleButtonClick =  false ? '__togglebutton_click__' : 14;
	var FunctionToggleMenu =  false ? '__function_toggle_menu__' : 15;
	var FunctionOpenMenu =  false ? '__function_open_menu__' : 16;
	var FunctionCloseMenu =  false ? '__function_close_menu__' : 17;
	var FunctionSetHighlightedIndex =  false ? '__function_set_highlighted_index__' : 18;
	var FunctionSelectItem =  false ? '__function_select_item__' : 19;
	var FunctionClearKeysSoFar =  false ? '__function_clear_keys_so_far__' : 20;
	var FunctionReset =  false ? '__function_reset__' : 21;
	
	var stateChangeTypes$1 = /*#__PURE__*/Object.freeze({
	  __proto__: null,
	  MenuKeyDownArrowDown: MenuKeyDownArrowDown,
	  MenuKeyDownArrowUp: MenuKeyDownArrowUp,
	  MenuKeyDownEscape: MenuKeyDownEscape,
	  MenuKeyDownHome: MenuKeyDownHome,
	  MenuKeyDownEnd: MenuKeyDownEnd,
	  MenuKeyDownEnter: MenuKeyDownEnter,
	  MenuKeyDownCharacter: MenuKeyDownCharacter,
	  MenuBlur: MenuBlur,
	  MenuMouseLeave: MenuMouseLeave,
	  ItemMouseMove: ItemMouseMove,
	  ItemClick: ItemClick,
	  ToggleButtonKeyDownCharacter: ToggleButtonKeyDownCharacter,
	  ToggleButtonKeyDownArrowDown: ToggleButtonKeyDownArrowDown,
	  ToggleButtonKeyDownArrowUp: ToggleButtonKeyDownArrowUp,
	  ToggleButtonClick: ToggleButtonClick,
	  FunctionToggleMenu: FunctionToggleMenu,
	  FunctionOpenMenu: FunctionOpenMenu,
	  FunctionCloseMenu: FunctionCloseMenu,
	  FunctionSetHighlightedIndex: FunctionSetHighlightedIndex,
	  FunctionSelectItem: FunctionSelectItem,
	  FunctionClearKeysSoFar: FunctionClearKeysSoFar,
	  FunctionReset: FunctionReset
	});
	
	/* eslint-disable complexity */
	
	function downshiftSelectReducer(state, action) {
	  var type = action.type,
	      props = action.props,
	      shiftKey = action.shiftKey;
	  var changes;
	
	  switch (type) {
	    case ItemMouseMove:
	      changes = {
	        highlightedIndex: action.index
	      };
	      break;
	
	    case ItemClick:
	      changes = {
	        isOpen: getDefaultValue(props, 'isOpen'),
	        highlightedIndex: getDefaultValue(props, 'highlightedIndex'),
	        selectedItem: props.items[action.index]
	      };
	      break;
	
	    case MenuBlur:
	      changes = {
	        isOpen: false,
	        highlightedIndex: -1
	      };
	      break;
	
	    case MenuKeyDownArrowDown:
	      changes = {
	        highlightedIndex: getNextWrappingIndex$1(shiftKey ? 5 : 1, state.highlightedIndex, props.items.length, props.circularNavigation)
	      };
	      break;
	
	    case MenuKeyDownArrowUp:
	      changes = {
	        highlightedIndex: getNextWrappingIndex$1(shiftKey ? -5 : -1, state.highlightedIndex, props.items.length, props.circularNavigation)
	      };
	      break;
	
	    case MenuKeyDownHome:
	      changes = {
	        highlightedIndex: 0
	      };
	      break;
	
	    case MenuKeyDownEnd:
	      changes = {
	        highlightedIndex: props.items.length - 1
	      };
	      break;
	
	    case MenuKeyDownEscape:
	      changes = {
	        isOpen: false,
	        highlightedIndex: -1
	      };
	      break;
	
	    case MenuKeyDownEnter:
	      changes = _extends({
	        isOpen: getDefaultValue(props, 'isOpen'),
	        highlightedIndex: getDefaultValue(props, 'highlightedIndex')
	      }, state.highlightedIndex >= 0 && {
	        selectedItem: props.items[state.highlightedIndex]
	      });
	      break;
	
	    case MenuKeyDownCharacter:
	      {
	        var lowercasedKey = action.key;
	        var keysSoFar = "" + state.keysSoFar + lowercasedKey;
	        var highlightedIndex = getItemIndexByCharacterKey(keysSoFar, state.highlightedIndex, props.items, props.itemToString);
	        changes = _extends({
	          keysSoFar: keysSoFar
	        }, highlightedIndex >= 0 && {
	          highlightedIndex: highlightedIndex
	        });
	      }
	      break;
	
	    case MenuMouseLeave:
	      changes = {
	        highlightedIndex: -1
	      };
	      break;
	
	    case ToggleButtonKeyDownCharacter:
	      {
	        var _lowercasedKey = action.key;
	
	        var _keysSoFar = "" + state.keysSoFar + _lowercasedKey;
	
	        var itemIndex = getItemIndexByCharacterKey(_keysSoFar, state.selectedItem ? props.items.indexOf(state.selectedItem) : -1, props.items, props.itemToString);
	        changes = _extends({
	          keysSoFar: _keysSoFar
	        }, itemIndex >= 0 && {
	          selectedItem: props.items[itemIndex]
	        });
	      }
	      break;
	
	    case ToggleButtonKeyDownArrowDown:
	      {
	        changes = {
	          isOpen: true,
	          highlightedIndex: getHighlightedIndexOnOpen(props, state, 1)
	        };
	        break;
	      }
	
	    case ToggleButtonKeyDownArrowUp:
	      changes = {
	        isOpen: true,
	        highlightedIndex: getHighlightedIndexOnOpen(props, state, -1)
	      };
	      break;
	
	    case ToggleButtonClick:
	    case FunctionToggleMenu:
	      changes = {
	        isOpen: !state.isOpen,
	        highlightedIndex: state.isOpen ? -1 : getHighlightedIndexOnOpen(props, state, 0)
	      };
	      break;
	
	    case FunctionOpenMenu:
	      changes = {
	        isOpen: true,
	        highlightedIndex: getHighlightedIndexOnOpen(props, state, 0)
	      };
	      break;
	
	    case FunctionCloseMenu:
	      changes = {
	        isOpen: false
	      };
	      break;
	
	    case FunctionSetHighlightedIndex:
	      changes = {
	        highlightedIndex: action.highlightedIndex
	      };
	      break;
	
	    case FunctionSelectItem:
	      changes = {
	        selectedItem: action.selectedItem
	      };
	      break;
	
	    case FunctionClearKeysSoFar:
	      changes = {
	        keysSoFar: ''
	      };
	      break;
	
	    case FunctionReset:
	      changes = {
	        highlightedIndex: getDefaultValue(props, 'highlightedIndex'),
	        isOpen: getDefaultValue(props, 'isOpen'),
	        selectedItem: getDefaultValue(props, 'selectedItem')
	      };
	      break;
	
	    default:
	      throw new Error('Reducer called without proper action type.');
	  }
	
	  return _extends({}, state, {}, changes);
	}
	/* eslint-enable complexity */
	
	var validatePropTypes =  true ?
	/* istanbul ignore next */
	null : getPropTypesValidator(useSelect, propTypes);
	var defaultProps = {
	  itemToString: itemToString,
	  stateReducer: function stateReducer(s, a) {
	    return a.changes;
	  },
	  getA11yStatusMessage: getA11yStatusMessage$1,
	  getA11ySelectionMessage: getA11ySelectionMessage,
	  scrollIntoView: scrollIntoView,
	  environment: typeof window === 'undefined'
	  /* istanbul ignore next (ssr) */
	  ? {} : window
	};
	useSelect.stateChangeTypes = stateChangeTypes$1;
	
	function useSelect(userProps) {
	  if (userProps === void 0) {
	    userProps = {};
	  }
	
	  /* istanbul ignore else */
	  if (false) {
	    validatePropTypes(userProps);
	  } // Props defaults and destructuring.
	
	
	  var props = _extends({}, defaultProps, {}, userProps);
	
	  var items = props.items,
	      itemToString = props.itemToString,
	      getA11yStatusMessage = props.getA11yStatusMessage,
	      getA11ySelectionMessage = props.getA11ySelectionMessage,
	      initialIsOpen = props.initialIsOpen,
	      defaultIsOpen = props.defaultIsOpen,
	      scrollIntoView = props.scrollIntoView,
	      environment = props.environment; // Initial state depending on controlled props.
	
	  var initialState = getInitialState(props); // Reducer init.
	
	  var _useEnhancedReducer = useEnhancedReducer(downshiftSelectReducer, initialState, props),
	      _useEnhancedReducer$ = _useEnhancedReducer[0],
	      isOpen = _useEnhancedReducer$.isOpen,
	      highlightedIndex = _useEnhancedReducer$.highlightedIndex,
	      selectedItem = _useEnhancedReducer$.selectedItem,
	      keysSoFar = _useEnhancedReducer$.keysSoFar,
	      dispatchWithoutProps = _useEnhancedReducer[1];
	
	  var dispatch = function (action) {
	    return dispatchWithoutProps(_extends({
	      props: props
	    }, action));
	  }; // IDs generation.
	
	
	  var _getElementIds = getElementIds(useId, props),
	      labelId = _getElementIds.labelId,
	      getItemId = _getElementIds.getItemId,
	      menuId = _getElementIds.menuId,
	      toggleButtonId = _getElementIds.toggleButtonId;
	  /* Refs */
	
	
	  var toggleButtonRef = react.useRef(null);
	  var menuRef = react.useRef(null);
	  var itemRefs = react.useRef();
	  itemRefs.current = [];
	  var isInitialMount = react.useRef(true);
	  var shouldScroll = react.useRef(true);
	  var clearTimeout = react.useRef(null);
	  /* Effects */
	
	  /* Sets a11y status message on changes in isOpen. */
	
	  react.useEffect(function () {
	    if (isInitialMount.current) {
	      return;
	    }
	
	    setStatus(getA11yStatusMessage({
	      isOpen: isOpen,
	      items: items,
	      selectedItem: selectedItem,
	      itemToString: itemToString
	    }), environment.document); // eslint-disable-next-line react-hooks/exhaustive-deps
	  }, [isOpen]);
	  /* Sets a11y status message on changes in selectedItem. */
	
	  react.useEffect(function () {
	    if (isInitialMount.current) {
	      return;
	    }
	
	    setStatus(getA11ySelectionMessage({
	      isOpen: isOpen,
	      items: items,
	      selectedItem: selectedItem,
	      itemToString: itemToString
	    }), environment.document); // eslint-disable-next-line react-hooks/exhaustive-deps
	  }, [selectedItem]);
	  /* Sets cleanup for the keysSoFar after 500ms. */
	
	  react.useEffect(function () {
	    // init the clean function here as we need access to dispatch.
	    if (isInitialMount.current) {
	      clearTimeout.current = debounce(function () {
	        dispatch({
	          type: FunctionClearKeysSoFar
	        });
	      }, 500);
	    }
	
	    if (!keysSoFar) {
	      return;
	    }
	
	    clearTimeout.current(); // eslint-disable-next-line react-hooks/exhaustive-deps
	  }, [keysSoFar]);
	  /* Controls the focus on the menu or the toggle button. */
	
	  react.useEffect(function () {
	    // Don't focus menu on first render.
	    if (isInitialMount.current) {
	      // Unless it was initialised as open.
	      if (initialIsOpen || defaultIsOpen || isOpen) {
	        menuRef.current.focus();
	      }
	
	      return;
	    } // Focus menu on open.
	    // istanbul ignore next
	
	
	    if (isOpen) {
	      menuRef.current.focus(); // Focus toggleButton on close.
	    } else if (environment.document.activeElement === menuRef.current) {
	      toggleButtonRef.current.focus();
	    } // eslint-disable-next-line react-hooks/exhaustive-deps
	
	  }, [isOpen]);
	  /* Scroll on highlighted item if change comes from keyboard. */
	
	  react.useEffect(function () {
	    if (highlightedIndex < 0 || !isOpen || !itemRefs.current.length) {
	      return;
	    }
	
	    if (shouldScroll.current === false) {
	      shouldScroll.current = true;
	    } else {
	      scrollIntoView(itemRefs.current[highlightedIndex], menuRef.current);
	    } // eslint-disable-next-line react-hooks/exhaustive-deps
	
	  }, [highlightedIndex]);
	  /* Make initial ref false. */
	
	  react.useEffect(function () {
	    isInitialMount.current = false;
	  }, []);
	  /* Event handler functions */
	
	  var menuKeyDownHandlers = {
	    ArrowDown: function ArrowDown(event) {
	      event.preventDefault();
	      dispatch({
	        type: MenuKeyDownArrowDown,
	        shiftKey: event.shiftKey
	      });
	    },
	    ArrowUp: function ArrowUp(event) {
	      event.preventDefault();
	      dispatch({
	        type: MenuKeyDownArrowUp,
	        shiftKey: event.shiftKey
	      });
	    },
	    Home: function Home(event) {
	      event.preventDefault();
	      dispatch({
	        type: MenuKeyDownHome
	      });
	    },
	    End: function End(event) {
	      event.preventDefault();
	      dispatch({
	        type: MenuKeyDownEnd
	      });
	    },
	    Escape: function Escape() {
	      dispatch({
	        type: MenuKeyDownEscape
	      });
	    },
	    Enter: function Enter(event) {
	      event.preventDefault();
	      dispatch({
	        type: MenuKeyDownEnter
	      });
	    },
	    Tab: function Tab(event) {
	      // The exception that calls MenuBlur.
	      // istanbul ignore next
	      if (event.shiftKey) {
	        dispatch({
	          type: MenuBlur
	        });
	      }
	    }
	  };
	  var toggleButtonKeyDownHandlers = {
	    ArrowDown: function ArrowDown(event) {
	      event.preventDefault();
	      dispatch({
	        type: ToggleButtonKeyDownArrowDown
	      });
	    },
	    ArrowUp: function ArrowUp(event) {
	      event.preventDefault();
	      dispatch({
	        type: ToggleButtonKeyDownArrowUp
	      });
	    }
	  }; // Event handlers.
	
	  var menuHandleKeyDown = function (event) {
	    var key = normalizeArrowKey(event);
	
	    if (key && menuKeyDownHandlers[key]) {
	      menuKeyDownHandlers[key](event);
	    } else if (isAcceptedCharacterKey(key)) {
	      dispatch({
	        type: MenuKeyDownCharacter,
	        key: key
	      });
	    }
	  }; // Focus going back to the toggleButton is something we control (Escape, Enter, Click).
	  // We are toggleing special actions for these cases in reducer, not MenuBlur.
	  // Since Shift-Tab also lands focus on toggleButton, we will handle it as exception and call MenuBlur.
	
	
	  var menuHandleBlur = function (event) {
	    if (!focusLandsOnElement(event, toggleButtonRef.current)) {
	      dispatch({
	        type: MenuBlur
	      });
	    }
	  };
	
	  var menuHandleMouseLeave = function () {
	    dispatch({
	      type: MenuMouseLeave
	    });
	  };
	
	  var toggleButtonHandleClick = function () {
	    dispatch({
	      type: ToggleButtonClick
	    });
	  };
	
	  var toggleButtonHandleKeyDown = function (event) {
	    var key = normalizeArrowKey(event);
	
	    if (key && toggleButtonKeyDownHandlers[key]) {
	      toggleButtonKeyDownHandlers[key](event);
	    } else if (isAcceptedCharacterKey(key)) {
	      dispatch({
	        type: ToggleButtonKeyDownCharacter,
	        key: key
	      });
	    }
	  };
	
	  var itemHandleMouseMove = function (index) {
	    if (index === highlightedIndex) {
	      return;
	    }
	
	    shouldScroll.current = false;
	    dispatch({
	      type: ItemMouseMove,
	      index: index
	    });
	  };
	
	  var itemHandleClick = function (index) {
	    dispatch({
	      type: ItemClick,
	      index: index
	    });
	  }; // returns
	
	
	  return {
	    // prop getters.
	    getToggleButtonProps: function getToggleButtonProps(_temp2) {
	      var _extends3;
	
	      var _ref2 = _temp2 === void 0 ? {} : _temp2,
	          onClick = _ref2.onClick,
	          onKeyDown = _ref2.onKeyDown,
	          _ref2$refKey = _ref2.refKey,
	          refKey = _ref2$refKey === void 0 ? 'ref' : _ref2$refKey,
	          ref = _ref2.ref,
	          rest = _objectWithoutPropertiesLoose(_ref2, ["onClick", "onKeyDown", "refKey", "ref"]);
	
	      var toggleProps = _extends((_extends3 = {}, _extends3[refKey] = handleRefs(ref, function (toggleButtonNode) {
	        toggleButtonRef.current = toggleButtonNode;
	      }), _extends3.id = toggleButtonId, _extends3['aria-haspopup'] = 'listbox', _extends3['aria-expanded'] = isOpen, _extends3['aria-labelledby'] = labelId + " " + toggleButtonId, _extends3), rest);
	
	      if (!rest.disabled) {
	        toggleProps.onClick = callAllEventHandlers(onClick, toggleButtonHandleClick);
	        toggleProps.onKeyDown = callAllEventHandlers(onKeyDown, toggleButtonHandleKeyDown);
	      }
	
	      return toggleProps;
	    },
	    getLabelProps: function getLabelProps(labelProps) {
	      return _extends({
	        id: labelId,
	        htmlFor: toggleButtonId
	      }, labelProps);
	    },
	    getMenuProps: function getMenuProps(_temp) {
	      var _extends2;
	
	      var _ref = _temp === void 0 ? {} : _temp,
	          onKeyDown = _ref.onKeyDown,
	          onBlur = _ref.onBlur,
	          onMouseLeave = _ref.onMouseLeave,
	          _ref$refKey = _ref.refKey,
	          refKey = _ref$refKey === void 0 ? 'ref' : _ref$refKey,
	          ref = _ref.ref,
	          rest = _objectWithoutPropertiesLoose(_ref, ["onKeyDown", "onBlur", "onMouseLeave", "refKey", "ref"]);
	
	      return _extends((_extends2 = {}, _extends2[refKey] = handleRefs(ref, function (menuNode) {
	        menuRef.current = menuNode;
	      }), _extends2.id = menuId, _extends2.role = 'listbox', _extends2['aria-labelledby'] = labelId, _extends2.tabIndex = -1, _extends2), highlightedIndex > -1 && {
	        'aria-activedescendant': getItemId(highlightedIndex)
	      }, {
	        onKeyDown: callAllEventHandlers(onKeyDown, menuHandleKeyDown),
	        onBlur: callAllEventHandlers(onBlur, menuHandleBlur),
	        onMouseLeave: callAllEventHandlers(onMouseLeave, menuHandleMouseLeave)
	      }, rest);
	    },
	    getItemProps: function getItemProps(_temp3) {
	      var _extends4;
	
	      var _ref3 = _temp3 === void 0 ? {} : _temp3,
	          item = _ref3.item,
	          index = _ref3.index,
	          _ref3$refKey = _ref3.refKey,
	          refKey = _ref3$refKey === void 0 ? 'ref' : _ref3$refKey,
	          ref = _ref3.ref,
	          onMouseMove = _ref3.onMouseMove,
	          onClick = _ref3.onClick,
	          rest = _objectWithoutPropertiesLoose(_ref3, ["item", "index", "refKey", "ref", "onMouseMove", "onClick"]);
	
	      var itemIndex = getItemIndex(index, item, items);
	
	      if (itemIndex < 0) {
	        throw new Error('Pass either item or item index in getItemProps!');
	      }
	
	      var itemProps = _extends((_extends4 = {}, _extends4[refKey] = handleRefs(ref, function (itemNode) {
	        if (itemNode) {
	          itemRefs.current.push(itemNode);
	        }
	      }), _extends4.role = 'option', _extends4), itemIndex === highlightedIndex && {
	        'aria-selected': true
	      }, {
	        id: getItemId(itemIndex)
	      }, rest);
	
	      if (!rest.disabled) {
	        itemProps.onMouseMove = callAllEventHandlers(onMouseMove, function () {
	          return itemHandleMouseMove(itemIndex);
	        });
	        itemProps.onClick = callAllEventHandlers(onClick, function () {
	          return itemHandleClick(itemIndex);
	        });
	      }
	
	      return itemProps;
	    },
	    // actions.
	    toggleMenu: function toggleMenu() {
	      dispatch({
	        type: FunctionToggleMenu
	      });
	    },
	    openMenu: function openMenu() {
	      dispatch({
	        type: FunctionOpenMenu
	      });
	    },
	    closeMenu: function closeMenu() {
	      dispatch({
	        type: FunctionCloseMenu
	      });
	    },
	    setHighlightedIndex: function setHighlightedIndex(newHighlightedIndex) {
	      dispatch({
	        type: FunctionSetHighlightedIndex,
	        highlightedIndex: newHighlightedIndex
	      });
	    },
	    selectItem: function selectItem(newSelectedItem) {
	      dispatch({
	        type: FunctionSelectItem,
	        selectedItem: newSelectedItem
	      });
	    },
	    reset: function reset() {
	      dispatch({
	        type: FunctionReset
	      });
	    },
	    // state.
	    highlightedIndex: highlightedIndex,
	    isOpen: isOpen,
	    selectedItem: selectedItem
	  };
	}
	
	exports.default = Downshift;
	exports.resetIdCounter = resetIdCounter;
	exports.useSelect = useSelect;


/***/ },
/* 1008 */
/***/ function(module, exports) {

	function _assertThisInitialized(self) {
	  if (self === void 0) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }
	
	  return self;
	}
	
	module.exports = _assertThisInitialized;

/***/ },
/* 1009 */
/***/ function(module, exports) {

	function _extends() {
	  module.exports = _extends = Object.assign || function (target) {
	    for (var i = 1; i < arguments.length; i++) {
	      var source = arguments[i];
	
	      for (var key in source) {
	        if (Object.prototype.hasOwnProperty.call(source, key)) {
	          target[key] = source[key];
	        }
	      }
	    }
	
	    return target;
	  };
	
	  return _extends.apply(this, arguments);
	}
	
	module.exports = _extends;

/***/ },
/* 1010 */
/***/ function(module, exports) {

	function _inheritsLoose(subClass, superClass) {
	  subClass.prototype = Object.create(superClass.prototype);
	  subClass.prototype.constructor = subClass;
	  subClass.__proto__ = superClass;
	}
	
	module.exports = _inheritsLoose;

/***/ },
/* 1011 */
/***/ function(module, exports) {

	function _objectWithoutPropertiesLoose(source, excluded) {
	  if (source == null) return {};
	  var target = {};
	  var sourceKeys = Object.keys(source);
	  var key, i;
	
	  for (i = 0; i < sourceKeys.length; i++) {
	    key = sourceKeys[i];
	    if (excluded.indexOf(key) >= 0) continue;
	    target[key] = source[key];
	  }
	
	  return target;
	}
	
	module.exports = _objectWithoutPropertiesLoose;

/***/ },
/* 1012 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Resize detection strategy that injects objects to elements in order to detect resize events.
	 * Heavily inspired by: http://www.backalleycoder.com/2013/03/18/cross-browser-event-based-element-resize-detection/
	 */
	
	"use strict";
	
	var browserDetector = __webpack_require__(444);
	
	module.exports = function(options) {
	    options             = options || {};
	    var reporter        = options.reporter;
	    var batchProcessor  = options.batchProcessor;
	    var getState        = options.stateHandler.getState;
	
	    if(!reporter) {
	        throw new Error("Missing required dependency: reporter.");
	    }
	
	    /**
	     * Adds a resize event listener to the element.
	     * @public
	     * @param {element} element The element that should have the listener added.
	     * @param {function} listener The listener callback to be called for each resize event of the element. The element will be given as a parameter to the listener callback.
	     */
	    function addListener(element, listener) {
	        function listenerProxy() {
	            listener(element);
	        }
	
	        if(browserDetector.isIE(8)) {
	            //IE 8 does not support object, but supports the resize event directly on elements.
	            getState(element).object = {
	                proxy: listenerProxy
	            };
	            element.attachEvent("onresize", listenerProxy);
	        } else {
	            var object = getObject(element);
	
	            if(!object) {
	                throw new Error("Element is not detectable by this strategy.");
	            }
	
	            object.contentDocument.defaultView.addEventListener("resize", listenerProxy);
	        }
	    }
	
	    function buildCssTextString(rules) {
	        var seperator = options.important ? " !important; " : "; ";
	
	        return (rules.join(seperator) + seperator).trim();
	    }
	
	    /**
	     * Makes an element detectable and ready to be listened for resize events. Will call the callback when the element is ready to be listened for resize changes.
	     * @private
	     * @param {object} options Optional options object.
	     * @param {element} element The element to make detectable
	     * @param {function} callback The callback to be called when the element is ready to be listened for resize changes. Will be called with the element as first parameter.
	     */
	    function makeDetectable(options, element, callback) {
	        if (!callback) {
	            callback = element;
	            element = options;
	            options = null;
	        }
	
	        options = options || {};
	        var debug = options.debug;
	
	        function injectObject(element, callback) {
	            var OBJECT_STYLE = buildCssTextString(["display: block", "position: absolute", "top: 0", "left: 0", "width: 100%", "height: 100%", "border: none", "padding: 0", "margin: 0", "opacity: 0", "z-index: -1000", "pointer-events: none"]);
	
	            //The target element needs to be positioned (everything except static) so the absolute positioned object will be positioned relative to the target element.
	
	            // Position altering may be performed directly or on object load, depending on if style resolution is possible directly or not.
	            var positionCheckPerformed = false;
	
	            // The element may not yet be attached to the DOM, and therefore the style object may be empty in some browsers.
	            // Since the style object is a reference, it will be updated as soon as the element is attached to the DOM.
	            var style = window.getComputedStyle(element);
	            var width = element.offsetWidth;
	            var height = element.offsetHeight;
	
	            getState(element).startSize = {
	                width: width,
	                height: height
	            };
	
	            function mutateDom() {
	                function alterPositionStyles() {
	                    if(style.position === "static") {
	                        element.style.setProperty("position", "relative", options.important ? "important" : "");
	
	                        var removeRelativeStyles = function(reporter, element, style, property) {
	                            function getNumericalValue(value) {
	                                return value.replace(/[^-\d\.]/g, "");
	                            }
	
	                            var value = style[property];
	
	                            if(value !== "auto" && getNumericalValue(value) !== "0") {
	                                reporter.warn("An element that is positioned static has style." + property + "=" + value + " which is ignored due to the static positioning. The element will need to be positioned relative, so the style." + property + " will be set to 0. Element: ", element);
	                                element.style.setProperty(property, "0", options.important ? "important" : "");
	                            }
	                        };
	
	                        //Check so that there are no accidental styles that will make the element styled differently now that is is relative.
	                        //If there are any, set them to 0 (this should be okay with the user since the style properties did nothing before [since the element was positioned static] anyway).
	                        removeRelativeStyles(reporter, element, style, "top");
	                        removeRelativeStyles(reporter, element, style, "right");
	                        removeRelativeStyles(reporter, element, style, "bottom");
	                        removeRelativeStyles(reporter, element, style, "left");
	                    }
	                }
	
	                function onObjectLoad() {
	                    // The object has been loaded, which means that the element now is guaranteed to be attached to the DOM.
	                    if (!positionCheckPerformed) {
	                        alterPositionStyles();
	                    }
	
	                    /*jshint validthis: true */
	
	                    function getDocument(element, callback) {
	                        //Opera 12 seem to call the object.onload before the actual document has been created.
	                        //So if it is not present, poll it with an timeout until it is present.
	                        //TODO: Could maybe be handled better with object.onreadystatechange or similar.
	                        if(!element.contentDocument) {
	                            var state = getState(element);
	                            if (state.checkForObjectDocumentTimeoutId) {
	                                window.clearTimeout(state.checkForObjectDocumentTimeoutId);
	                            }
	                            state.checkForObjectDocumentTimeoutId = setTimeout(function checkForObjectDocument() {
	                                state.checkForObjectDocumentTimeoutId = 0;
	                                getDocument(element, callback);
	                            }, 100);
	
	                            return;
	                        }
	
	                        callback(element.contentDocument);
	                    }
	
	                    //Mutating the object element here seems to fire another load event.
	                    //Mutating the inner document of the object element is fine though.
	                    var objectElement = this;
	
	                    //Create the style element to be added to the object.
	                    getDocument(objectElement, function onObjectDocumentReady(objectDocument) {
	                        //Notify that the element is ready to be listened to.
	                        callback(element);
	                    });
	                }
	
	                // The element may be detached from the DOM, and some browsers does not support style resolving of detached elements.
	                // The alterPositionStyles needs to be delayed until we know the element has been attached to the DOM (which we are sure of when the onObjectLoad has been fired), if style resolution is not possible.
	                if (style.position !== "") {
	                    alterPositionStyles(style);
	                    positionCheckPerformed = true;
	                }
	
	                //Add an object element as a child to the target element that will be listened to for resize events.
	                var object = document.createElement("object");
	                object.style.cssText = OBJECT_STYLE;
	                object.tabIndex = -1;
	                object.type = "text/html";
	                object.setAttribute("aria-hidden", "true");
	                object.onload = onObjectLoad;
	
	                //Safari: This must occur before adding the object to the DOM.
	                //IE: Does not like that this happens before, even if it is also added after.
	                if(!browserDetector.isIE()) {
	                    object.data = "about:blank";
	                }
	
	                if (!getState(element)) {
	                    // The element has been uninstalled before the actual loading happened.
	                    return;
	                }
	
	                element.appendChild(object);
	                getState(element).object = object;
	
	                //IE: This must occur after adding the object to the DOM.
	                if(browserDetector.isIE()) {
	                    object.data = "about:blank";
	                }
	            }
	
	            if(batchProcessor) {
	                batchProcessor.add(mutateDom);
	            } else {
	                mutateDom();
	            }
	        }
	
	        if(browserDetector.isIE(8)) {
	            //IE 8 does not support objects properly. Luckily they do support the resize event.
	            //So do not inject the object and notify that the element is already ready to be listened to.
	            //The event handler for the resize event is attached in the utils.addListener instead.
	            callback(element);
	        } else {
	            injectObject(element, callback);
	        }
	    }
	
	    /**
	     * Returns the child object of the target element.
	     * @private
	     * @param {element} element The target element.
	     * @returns The object element of the target.
	     */
	    function getObject(element) {
	        return getState(element).object;
	    }
	
	    function uninstall(element) {
	        if (!getState(element)) {
	            return;
	        }
	
	        var object = getObject(element);
	
	        if (!object) {
	            return;
	        }
	
	        if (browserDetector.isIE(8)) {
	            element.detachEvent("onresize", object.proxy);
	        } else {
	            element.removeChild(object);
	        }
	
	        if (getState(element).checkForObjectDocumentTimeoutId) {
	            window.clearTimeout(getState(element).checkForObjectDocumentTimeoutId);
	        }
	
	        delete getState(element).object;
	    }
	
	    return {
	        makeDetectable: makeDetectable,
	        addListener: addListener,
	        uninstall: uninstall
	    };
	};


/***/ },
/* 1013 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Resize detection strategy that injects divs to elements in order to detect resize events on scroll events.
	 * Heavily inspired by: https://github.com/marcj/css-element-queries/blob/master/src/ResizeSensor.js
	 */
	
	"use strict";
	
	var forEach = __webpack_require__(445).forEach;
	
	module.exports = function(options) {
	    options             = options || {};
	    var reporter        = options.reporter;
	    var batchProcessor  = options.batchProcessor;
	    var getState        = options.stateHandler.getState;
	    var hasState        = options.stateHandler.hasState;
	    var idHandler       = options.idHandler;
	
	    if (!batchProcessor) {
	        throw new Error("Missing required dependency: batchProcessor");
	    }
	
	    if (!reporter) {
	        throw new Error("Missing required dependency: reporter.");
	    }
	
	    //TODO: Could this perhaps be done at installation time?
	    var scrollbarSizes = getScrollbarSizes();
	
	    var styleId = "erd_scroll_detection_scrollbar_style";
	    var detectionContainerClass = "erd_scroll_detection_container";
	
	    function initDocument(targetDocument) {
	        // Inject the scrollbar styling that prevents them from appearing sometimes in Chrome.
	        // The injected container needs to have a class, so that it may be styled with CSS (pseudo elements).
	        injectScrollStyle(targetDocument, styleId, detectionContainerClass);
	    }
	
	    initDocument(window.document);
	
	    function buildCssTextString(rules) {
	        var seperator = options.important ? " !important; " : "; ";
	
	        return (rules.join(seperator) + seperator).trim();
	    }
	
	    function getScrollbarSizes() {
	        var width = 500;
	        var height = 500;
	
	        var child = document.createElement("div");
	        child.style.cssText = buildCssTextString(["position: absolute", "width: " + width*2 + "px", "height: " + height*2 + "px", "visibility: hidden", "margin: 0", "padding: 0"]);
	
	        var container = document.createElement("div");
	        container.style.cssText = buildCssTextString(["position: absolute", "width: " + width + "px", "height: " + height + "px", "overflow: scroll", "visibility: none", "top: " + -width*3 + "px", "left: " + -height*3 + "px", "visibility: hidden", "margin: 0", "padding: 0"]);
	
	        container.appendChild(child);
	
	        document.body.insertBefore(container, document.body.firstChild);
	
	        var widthSize = width - container.clientWidth;
	        var heightSize = height - container.clientHeight;
	
	        document.body.removeChild(container);
	
	        return {
	            width: widthSize,
	            height: heightSize
	        };
	    }
	
	    function injectScrollStyle(targetDocument, styleId, containerClass) {
	        function injectStyle(style, method) {
	            method = method || function (element) {
	                targetDocument.head.appendChild(element);
	            };
	
	            var styleElement = targetDocument.createElement("style");
	            styleElement.innerHTML = style;
	            styleElement.id = styleId;
	            method(styleElement);
	            return styleElement;
	        }
	
	        if (!targetDocument.getElementById(styleId)) {
	            var containerAnimationClass = containerClass + "_animation";
	            var containerAnimationActiveClass = containerClass + "_animation_active";
	            var style = "/* Created by the element-resize-detector library. */\n";
	            style += "." + containerClass + " > div::-webkit-scrollbar { " + buildCssTextString(["display: none"]) + " }\n\n";
	            style += "." + containerAnimationActiveClass + " { " + buildCssTextString(["-webkit-animation-duration: 0.1s", "animation-duration: 0.1s", "-webkit-animation-name: " + containerAnimationClass, "animation-name: " + containerAnimationClass]) + " }\n";
	            style += "@-webkit-keyframes " + containerAnimationClass +  " { 0% { opacity: 1; } 50% { opacity: 0; } 100% { opacity: 1; } }\n";
	            style += "@keyframes " + containerAnimationClass +          " { 0% { opacity: 1; } 50% { opacity: 0; } 100% { opacity: 1; } }";
	            injectStyle(style);
	        }
	    }
	
	    function addAnimationClass(element) {
	        element.className += " " + detectionContainerClass + "_animation_active";
	    }
	
	    function addEvent(el, name, cb) {
	        if (el.addEventListener) {
	            el.addEventListener(name, cb);
	        } else if(el.attachEvent) {
	            el.attachEvent("on" + name, cb);
	        } else {
	            return reporter.error("[scroll] Don't know how to add event listeners.");
	        }
	    }
	
	    function removeEvent(el, name, cb) {
	        if (el.removeEventListener) {
	            el.removeEventListener(name, cb);
	        } else if(el.detachEvent) {
	            el.detachEvent("on" + name, cb);
	        } else {
	            return reporter.error("[scroll] Don't know how to remove event listeners.");
	        }
	    }
	
	    function getExpandElement(element) {
	        return getState(element).container.childNodes[0].childNodes[0].childNodes[0];
	    }
	
	    function getShrinkElement(element) {
	        return getState(element).container.childNodes[0].childNodes[0].childNodes[1];
	    }
	
	    /**
	     * Adds a resize event listener to the element.
	     * @public
	     * @param {element} element The element that should have the listener added.
	     * @param {function} listener The listener callback to be called for each resize event of the element. The element will be given as a parameter to the listener callback.
	     */
	    function addListener(element, listener) {
	        var listeners = getState(element).listeners;
	
	        if (!listeners.push) {
	            throw new Error("Cannot add listener to an element that is not detectable.");
	        }
	
	        getState(element).listeners.push(listener);
	    }
	
	    /**
	     * Makes an element detectable and ready to be listened for resize events. Will call the callback when the element is ready to be listened for resize changes.
	     * @private
	     * @param {object} options Optional options object.
	     * @param {element} element The element to make detectable
	     * @param {function} callback The callback to be called when the element is ready to be listened for resize changes. Will be called with the element as first parameter.
	     */
	    function makeDetectable(options, element, callback) {
	        if (!callback) {
	            callback = element;
	            element = options;
	            options = null;
	        }
	
	        options = options || {};
	
	        function debug() {
	            if (options.debug) {
	                var args = Array.prototype.slice.call(arguments);
	                args.unshift(idHandler.get(element), "Scroll: ");
	                if (reporter.log.apply) {
	                    reporter.log.apply(null, args);
	                } else {
	                    for (var i = 0; i < args.length; i++) {
	                        reporter.log(args[i]);
	                    }
	                }
	            }
	        }
	
	        function isDetached(element) {
	            function isInDocument(element) {
	                return element === element.ownerDocument.body || element.ownerDocument.body.contains(element);
	            }
	
	            if (!isInDocument(element)) {
	                return true;
	            }
	
	            // FireFox returns null style in hidden iframes. See https://github.com/wnr/element-resize-detector/issues/68 and https://bugzilla.mozilla.org/show_bug.cgi?id=795520
	            if (window.getComputedStyle(element) === null) {
	                return true;
	            }
	
	            return false;
	        }
	
	        function isUnrendered(element) {
	            // Check the absolute positioned container since the top level container is display: inline.
	            var container = getState(element).container.childNodes[0];
	            var style = window.getComputedStyle(container);
	            return !style.width || style.width.indexOf("px") === -1; //Can only compute pixel value when rendered.
	        }
	
	        function getStyle() {
	            // Some browsers only force layouts when actually reading the style properties of the style object, so make sure that they are all read here,
	            // so that the user of the function can be sure that it will perform the layout here, instead of later (important for batching).
	            var elementStyle            = window.getComputedStyle(element);
	            var style                   = {};
	            style.position              = elementStyle.position;
	            style.width                 = element.offsetWidth;
	            style.height                = element.offsetHeight;
	            style.top                   = elementStyle.top;
	            style.right                 = elementStyle.right;
	            style.bottom                = elementStyle.bottom;
	            style.left                  = elementStyle.left;
	            style.widthCSS              = elementStyle.width;
	            style.heightCSS             = elementStyle.height;
	            return style;
	        }
	
	        function storeStartSize() {
	            var style = getStyle();
	            getState(element).startSize = {
	                width: style.width,
	                height: style.height
	            };
	            debug("Element start size", getState(element).startSize);
	        }
	
	        function initListeners() {
	            getState(element).listeners = [];
	        }
	
	        function storeStyle() {
	            debug("storeStyle invoked.");
	            if (!getState(element)) {
	                debug("Aborting because element has been uninstalled");
	                return;
	            }
	
	            var style = getStyle();
	            getState(element).style = style;
	        }
	
	        function storeCurrentSize(element, width, height) {
	            getState(element).lastWidth = width;
	            getState(element).lastHeight  = height;
	        }
	
	        function getExpandChildElement(element) {
	            return getExpandElement(element).childNodes[0];
	        }
	
	        function getWidthOffset() {
	            return 2 * scrollbarSizes.width + 1;
	        }
	
	        function getHeightOffset() {
	            return 2 * scrollbarSizes.height + 1;
	        }
	
	        function getExpandWidth(width) {
	            return width + 10 + getWidthOffset();
	        }
	
	        function getExpandHeight(height) {
	            return height + 10 + getHeightOffset();
	        }
	
	        function getShrinkWidth(width) {
	            return width * 2 + getWidthOffset();
	        }
	
	        function getShrinkHeight(height) {
	            return height * 2 + getHeightOffset();
	        }
	
	        function positionScrollbars(element, width, height) {
	            var expand          = getExpandElement(element);
	            var shrink          = getShrinkElement(element);
	            var expandWidth     = getExpandWidth(width);
	            var expandHeight    = getExpandHeight(height);
	            var shrinkWidth     = getShrinkWidth(width);
	            var shrinkHeight    = getShrinkHeight(height);
	            expand.scrollLeft   = expandWidth;
	            expand.scrollTop    = expandHeight;
	            shrink.scrollLeft   = shrinkWidth;
	            shrink.scrollTop    = shrinkHeight;
	        }
	
	        function injectContainerElement() {
	            var container = getState(element).container;
	
	            if (!container) {
	                container                   = document.createElement("div");
	                container.className         = detectionContainerClass;
	                container.style.cssText     = buildCssTextString(["visibility: hidden", "display: inline", "width: 0px", "height: 0px", "z-index: -1", "overflow: hidden", "margin: 0", "padding: 0"]);
	                getState(element).container = container;
	                addAnimationClass(container);
	                element.appendChild(container);
	
	                var onAnimationStart = function () {
	                    getState(element).onRendered && getState(element).onRendered();
	                };
	
	                addEvent(container, "animationstart", onAnimationStart);
	
	                // Store the event handler here so that they may be removed when uninstall is called.
	                // See uninstall function for an explanation why it is needed.
	                getState(element).onAnimationStart = onAnimationStart;
	            }
	
	            return container;
	        }
	
	        function injectScrollElements() {
	            function alterPositionStyles() {
	                var style = getState(element).style;
	
	                if(style.position === "static") {
	                    element.style.setProperty("position", "relative",options.important ? "important" : "");
	
	                    var removeRelativeStyles = function(reporter, element, style, property) {
	                        function getNumericalValue(value) {
	                            return value.replace(/[^-\d\.]/g, "");
	                        }
	
	                        var value = style[property];
	
	                        if(value !== "auto" && getNumericalValue(value) !== "0") {
	                            reporter.warn("An element that is positioned static has style." + property + "=" + value + " which is ignored due to the static positioning. The element will need to be positioned relative, so the style." + property + " will be set to 0. Element: ", element);
	                            element.style[property] = 0;
	                        }
	                    };
	
	                    //Check so that there are no accidental styles that will make the element styled differently now that is is relative.
	                    //If there are any, set them to 0 (this should be okay with the user since the style properties did nothing before [since the element was positioned static] anyway).
	                    removeRelativeStyles(reporter, element, style, "top");
	                    removeRelativeStyles(reporter, element, style, "right");
	                    removeRelativeStyles(reporter, element, style, "bottom");
	                    removeRelativeStyles(reporter, element, style, "left");
	                }
	            }
	
	            function getLeftTopBottomRightCssText(left, top, bottom, right) {
	                left = (!left ? "0" : (left + "px"));
	                top = (!top ? "0" : (top + "px"));
	                bottom = (!bottom ? "0" : (bottom + "px"));
	                right = (!right ? "0" : (right + "px"));
	
	                return ["left: " + left, "top: " + top, "right: " + right, "bottom: " + bottom];
	            }
	
	            debug("Injecting elements");
	
	            if (!getState(element)) {
	                debug("Aborting because element has been uninstalled");
	                return;
	            }
	
	            alterPositionStyles();
	
	            var rootContainer = getState(element).container;
	
	            if (!rootContainer) {
	                rootContainer = injectContainerElement();
	            }
	
	            // Due to this WebKit bug https://bugs.webkit.org/show_bug.cgi?id=80808 (currently fixed in Blink, but still present in WebKit browsers such as Safari),
	            // we need to inject two containers, one that is width/height 100% and another that is left/top -1px so that the final container always is 1x1 pixels bigger than
	            // the targeted element.
	            // When the bug is resolved, "containerContainer" may be removed.
	
	            // The outer container can occasionally be less wide than the targeted when inside inline elements element in WebKit (see https://bugs.webkit.org/show_bug.cgi?id=152980).
	            // This should be no problem since the inner container either way makes sure the injected scroll elements are at least 1x1 px.
	
	            var scrollbarWidth          = scrollbarSizes.width;
	            var scrollbarHeight         = scrollbarSizes.height;
	            var containerContainerStyle = buildCssTextString(["position: absolute", "flex: none", "overflow: hidden", "z-index: -1", "visibility: hidden", "width: 100%", "height: 100%", "left: 0px", "top: 0px"]);
	            var containerStyle          = buildCssTextString(["position: absolute", "flex: none", "overflow: hidden", "z-index: -1", "visibility: hidden"].concat(getLeftTopBottomRightCssText(-(1 + scrollbarWidth), -(1 + scrollbarHeight), -scrollbarHeight, -scrollbarWidth)));
	            var expandStyle             = buildCssTextString(["position: absolute", "flex: none", "overflow: scroll", "z-index: -1", "visibility: hidden", "width: 100%", "height: 100%"]);
	            var shrinkStyle             = buildCssTextString(["position: absolute", "flex: none", "overflow: scroll", "z-index: -1", "visibility: hidden", "width: 100%", "height: 100%"]);
	            var expandChildStyle        = buildCssTextString(["position: absolute", "left: 0", "top: 0"]);
	            var shrinkChildStyle        = buildCssTextString(["position: absolute", "width: 200%", "height: 200%"]);
	
	            var containerContainer      = document.createElement("div");
	            var container               = document.createElement("div");
	            var expand                  = document.createElement("div");
	            var expandChild             = document.createElement("div");
	            var shrink                  = document.createElement("div");
	            var shrinkChild             = document.createElement("div");
	
	            // Some browsers choke on the resize system being rtl, so force it to ltr. https://github.com/wnr/element-resize-detector/issues/56
	            // However, dir should not be set on the top level container as it alters the dimensions of the target element in some browsers.
	            containerContainer.dir              = "ltr";
	
	            containerContainer.style.cssText    = containerContainerStyle;
	            containerContainer.className        = detectionContainerClass;
	            container.className                 = detectionContainerClass;
	            container.style.cssText             = containerStyle;
	            expand.style.cssText                = expandStyle;
	            expandChild.style.cssText           = expandChildStyle;
	            shrink.style.cssText                = shrinkStyle;
	            shrinkChild.style.cssText           = shrinkChildStyle;
	
	            expand.appendChild(expandChild);
	            shrink.appendChild(shrinkChild);
	            container.appendChild(expand);
	            container.appendChild(shrink);
	            containerContainer.appendChild(container);
	            rootContainer.appendChild(containerContainer);
	
	            function onExpandScroll() {
	                getState(element).onExpand && getState(element).onExpand();
	            }
	
	            function onShrinkScroll() {
	                getState(element).onShrink && getState(element).onShrink();
	            }
	
	            addEvent(expand, "scroll", onExpandScroll);
	            addEvent(shrink, "scroll", onShrinkScroll);
	
	            // Store the event handlers here so that they may be removed when uninstall is called.
	            // See uninstall function for an explanation why it is needed.
	            getState(element).onExpandScroll = onExpandScroll;
	            getState(element).onShrinkScroll = onShrinkScroll;
	        }
	
	        function registerListenersAndPositionElements() {
	            function updateChildSizes(element, width, height) {
	                var expandChild             = getExpandChildElement(element);
	                var expandWidth             = getExpandWidth(width);
	                var expandHeight            = getExpandHeight(height);
	                expandChild.style.setProperty("width", expandWidth + "px", options.important ? "important" : "");
	                expandChild.style.setProperty("height", expandHeight + "px", options.important ? "important" : "");
	            }
	
	            function updateDetectorElements(done) {
	                var width           = element.offsetWidth;
	                var height          = element.offsetHeight;
	
	                // Check whether the size has actually changed since last time the algorithm ran. If not, some steps may be skipped.
	                var sizeChanged = width !== getState(element).lastWidth || height !== getState(element).lastHeight;
	
	                debug("Storing current size", width, height);
	
	                // Store the size of the element sync here, so that multiple scroll events may be ignored in the event listeners.
	                // Otherwise the if-check in handleScroll is useless.
	                storeCurrentSize(element, width, height);
	
	                // Since we delay the processing of the batch, there is a risk that uninstall has been called before the batch gets to execute.
	                // Since there is no way to cancel the fn executions, we need to add an uninstall guard to all fns of the batch.
	
	                batchProcessor.add(0, function performUpdateChildSizes() {
	                    if (!sizeChanged) {
	                        return;
	                    }
	
	                    if (!getState(element)) {
	                        debug("Aborting because element has been uninstalled");
	                        return;
	                    }
	
	                    if (!areElementsInjected()) {
	                        debug("Aborting because element container has not been initialized");
	                        return;
	                    }
	
	                    if (options.debug) {
	                        var w = element.offsetWidth;
	                        var h = element.offsetHeight;
	
	                        if (w !== width || h !== height) {
	                            reporter.warn(idHandler.get(element), "Scroll: Size changed before updating detector elements.");
	                        }
	                    }
	
	                    updateChildSizes(element, width, height);
	                });
	
	                batchProcessor.add(1, function updateScrollbars() {
	                    // This function needs to be invoked event though the size is unchanged. The element could have been resized very quickly and then
	                    // been restored to the original size, which will have changed the scrollbar positions.
	
	                    if (!getState(element)) {
	                        debug("Aborting because element has been uninstalled");
	                        return;
	                    }
	
	                    if (!areElementsInjected()) {
	                        debug("Aborting because element container has not been initialized");
	                        return;
	                    }
	
	                    positionScrollbars(element, width, height);
	                });
	
	                if (sizeChanged && done) {
	                    batchProcessor.add(2, function () {
	                        if (!getState(element)) {
	                            debug("Aborting because element has been uninstalled");
	                            return;
	                        }
	
	                        if (!areElementsInjected()) {
	                          debug("Aborting because element container has not been initialized");
	                          return;
	                        }
	
	                        done();
	                    });
	                }
	            }
	
	            function areElementsInjected() {
	                return !!getState(element).container;
	            }
	
	            function notifyListenersIfNeeded() {
	                function isFirstNotify() {
	                    return getState(element).lastNotifiedWidth === undefined;
	                }
	
	                debug("notifyListenersIfNeeded invoked");
	
	                var state = getState(element);
	
	                // Don't notify if the current size is the start size, and this is the first notification.
	                if (isFirstNotify() && state.lastWidth === state.startSize.width && state.lastHeight === state.startSize.height) {
	                    return debug("Not notifying: Size is the same as the start size, and there has been no notification yet.");
	                }
	
	                // Don't notify if the size already has been notified.
	                if (state.lastWidth === state.lastNotifiedWidth && state.lastHeight === state.lastNotifiedHeight) {
	                    return debug("Not notifying: Size already notified");
	                }
	
	
	                debug("Current size not notified, notifying...");
	                state.lastNotifiedWidth = state.lastWidth;
	                state.lastNotifiedHeight = state.lastHeight;
	                forEach(getState(element).listeners, function (listener) {
	                    listener(element);
	                });
	            }
	
	            function handleRender() {
	                debug("startanimation triggered.");
	
	                if (isUnrendered(element)) {
	                    debug("Ignoring since element is still unrendered...");
	                    return;
	                }
	
	                debug("Element rendered.");
	                var expand = getExpandElement(element);
	                var shrink = getShrinkElement(element);
	                if (expand.scrollLeft === 0 || expand.scrollTop === 0 || shrink.scrollLeft === 0 || shrink.scrollTop === 0) {
	                    debug("Scrollbars out of sync. Updating detector elements...");
	                    updateDetectorElements(notifyListenersIfNeeded);
	                }
	            }
	
	            function handleScroll() {
	                debug("Scroll detected.");
	
	                if (isUnrendered(element)) {
	                    // Element is still unrendered. Skip this scroll event.
	                    debug("Scroll event fired while unrendered. Ignoring...");
	                    return;
	                }
	
	                updateDetectorElements(notifyListenersIfNeeded);
	            }
	
	            debug("registerListenersAndPositionElements invoked.");
	
	            if (!getState(element)) {
	                debug("Aborting because element has been uninstalled");
	                return;
	            }
	
	            getState(element).onRendered = handleRender;
	            getState(element).onExpand = handleScroll;
	            getState(element).onShrink = handleScroll;
	
	            var style = getState(element).style;
	            updateChildSizes(element, style.width, style.height);
	        }
	
	        function finalizeDomMutation() {
	            debug("finalizeDomMutation invoked.");
	
	            if (!getState(element)) {
	                debug("Aborting because element has been uninstalled");
	                return;
	            }
	
	            var style = getState(element).style;
	            storeCurrentSize(element, style.width, style.height);
	            positionScrollbars(element, style.width, style.height);
	        }
	
	        function ready() {
	            callback(element);
	        }
	
	        function install() {
	            debug("Installing...");
	            initListeners();
	            storeStartSize();
	
	            batchProcessor.add(0, storeStyle);
	            batchProcessor.add(1, injectScrollElements);
	            batchProcessor.add(2, registerListenersAndPositionElements);
	            batchProcessor.add(3, finalizeDomMutation);
	            batchProcessor.add(4, ready);
	        }
	
	        debug("Making detectable...");
	
	        if (isDetached(element)) {
	            debug("Element is detached");
	
	            injectContainerElement();
	
	            debug("Waiting until element is attached...");
	
	            getState(element).onRendered = function () {
	                debug("Element is now attached");
	                install();
	            };
	        } else {
	            install();
	        }
	    }
	
	    function uninstall(element) {
	        var state = getState(element);
	
	        if (!state) {
	            // Uninstall has been called on a non-erd element.
	            return;
	        }
	
	        // Uninstall may have been called in the following scenarios:
	        // (1) Right between the sync code and async batch (here state.busy = true, but nothing have been registered or injected).
	        // (2) In the ready callback of the last level of the batch by another element (here, state.busy = true, but all the stuff has been injected).
	        // (3) After the installation process (here, state.busy = false and all the stuff has been injected).
	        // So to be on the safe side, let's check for each thing before removing.
	
	        // We need to remove the event listeners, because otherwise the event might fire on an uninstall element which results in an error when trying to get the state of the element.
	        state.onExpandScroll && removeEvent(getExpandElement(element), "scroll", state.onExpandScroll);
	        state.onShrinkScroll && removeEvent(getShrinkElement(element), "scroll", state.onShrinkScroll);
	        state.onAnimationStart && removeEvent(state.container, "animationstart", state.onAnimationStart);
	
	        state.container && element.removeChild(state.container);
	    }
	
	    return {
	        makeDetectable: makeDetectable,
	        addListener: addListener,
	        uninstall: uninstall,
	        initDocument: initDocument
	    };
	};


/***/ },
/* 1014 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var forEach                 = __webpack_require__(445).forEach;
	var elementUtilsMaker       = __webpack_require__(1015);
	var listenerHandlerMaker    = __webpack_require__(1018);
	var idGeneratorMaker        = __webpack_require__(1016);
	var idHandlerMaker          = __webpack_require__(1017);
	var reporterMaker           = __webpack_require__(1019);
	var browserDetector         = __webpack_require__(444);
	var batchProcessorMaker     = __webpack_require__(615);
	var stateHandler            = __webpack_require__(1020);
	
	//Detection strategies.
	var objectStrategyMaker     = __webpack_require__(1012);
	var scrollStrategyMaker     = __webpack_require__(1013);
	
	function isCollection(obj) {
	    return Array.isArray(obj) || obj.length !== undefined;
	}
	
	function toArray(collection) {
	    if (!Array.isArray(collection)) {
	        var array = [];
	        forEach(collection, function (obj) {
	            array.push(obj);
	        });
	        return array;
	    } else {
	        return collection;
	    }
	}
	
	function isElement(obj) {
	    return obj && obj.nodeType === 1;
	}
	
	/**
	 * @typedef idHandler
	 * @type {object}
	 * @property {function} get Gets the resize detector id of the element.
	 * @property {function} set Generate and sets the resize detector id of the element.
	 */
	
	/**
	 * @typedef Options
	 * @type {object}
	 * @property {boolean} callOnAdd    Determines if listeners should be called when they are getting added.
	                                    Default is true. If true, the listener is guaranteed to be called when it has been added.
	                                    If false, the listener will not be guarenteed to be called when it has been added (does not prevent it from being called).
	 * @property {idHandler} idHandler  A custom id handler that is responsible for generating, setting and retrieving id's for elements.
	                                    If not provided, a default id handler will be used.
	 * @property {reporter} reporter    A custom reporter that handles reporting logs, warnings and errors.
	                                    If not provided, a default id handler will be used.
	                                    If set to false, then nothing will be reported.
	 * @property {boolean} debug        If set to true, the the system will report debug messages as default for the listenTo method.
	 */
	
	/**
	 * Creates an element resize detector instance.
	 * @public
	 * @param {Options?} options Optional global options object that will decide how this instance will work.
	 */
	module.exports = function(options) {
	    options = options || {};
	
	    //idHandler is currently not an option to the listenTo function, so it should not be added to globalOptions.
	    var idHandler;
	
	    if (options.idHandler) {
	        // To maintain compatability with idHandler.get(element, readonly), make sure to wrap the given idHandler
	        // so that readonly flag always is true when it's used here. This may be removed next major version bump.
	        idHandler = {
	            get: function (element) { return options.idHandler.get(element, true); },
	            set: options.idHandler.set
	        };
	    } else {
	        var idGenerator = idGeneratorMaker();
	        var defaultIdHandler = idHandlerMaker({
	            idGenerator: idGenerator,
	            stateHandler: stateHandler
	        });
	        idHandler = defaultIdHandler;
	    }
	
	    //reporter is currently not an option to the listenTo function, so it should not be added to globalOptions.
	    var reporter = options.reporter;
	
	    if(!reporter) {
	        //If options.reporter is false, then the reporter should be quiet.
	        var quiet = reporter === false;
	        reporter = reporterMaker(quiet);
	    }
	
	    //batchProcessor is currently not an option to the listenTo function, so it should not be added to globalOptions.
	    var batchProcessor = getOption(options, "batchProcessor", batchProcessorMaker({ reporter: reporter }));
	
	    //Options to be used as default for the listenTo function.
	    var globalOptions = {};
	    globalOptions.callOnAdd     = !!getOption(options, "callOnAdd", true);
	    globalOptions.debug         = !!getOption(options, "debug", false);
	
	    var eventListenerHandler    = listenerHandlerMaker(idHandler);
	    var elementUtils            = elementUtilsMaker({
	        stateHandler: stateHandler
	    });
	
	    //The detection strategy to be used.
	    var detectionStrategy;
	    var desiredStrategy = getOption(options, "strategy", "object");
	    var importantCssRules = getOption(options, "important", false);
	    var strategyOptions = {
	        reporter: reporter,
	        batchProcessor: batchProcessor,
	        stateHandler: stateHandler,
	        idHandler: idHandler,
	        important: importantCssRules
	    };
	
	    if(desiredStrategy === "scroll") {
	        if (browserDetector.isLegacyOpera()) {
	            reporter.warn("Scroll strategy is not supported on legacy Opera. Changing to object strategy.");
	            desiredStrategy = "object";
	        } else if (browserDetector.isIE(9)) {
	            reporter.warn("Scroll strategy is not supported on IE9. Changing to object strategy.");
	            desiredStrategy = "object";
	        }
	    }
	
	    if(desiredStrategy === "scroll") {
	        detectionStrategy = scrollStrategyMaker(strategyOptions);
	    } else if(desiredStrategy === "object") {
	        detectionStrategy = objectStrategyMaker(strategyOptions);
	    } else {
	        throw new Error("Invalid strategy name: " + desiredStrategy);
	    }
	
	    //Calls can be made to listenTo with elements that are still being installed.
	    //Also, same elements can occur in the elements list in the listenTo function.
	    //With this map, the ready callbacks can be synchronized between the calls
	    //so that the ready callback can always be called when an element is ready - even if
	    //it wasn't installed from the function itself.
	    var onReadyCallbacks = {};
	
	    /**
	     * Makes the given elements resize-detectable and starts listening to resize events on the elements. Calls the event callback for each event for each element.
	     * @public
	     * @param {Options?} options Optional options object. These options will override the global options. Some options may not be overriden, such as idHandler.
	     * @param {element[]|element} elements The given array of elements to detect resize events of. Single element is also valid.
	     * @param {function} listener The callback to be executed for each resize event for each element.
	     */
	    function listenTo(options, elements, listener) {
	        function onResizeCallback(element) {
	            var listeners = eventListenerHandler.get(element);
	            forEach(listeners, function callListenerProxy(listener) {
	                listener(element);
	            });
	        }
	
	        function addListener(callOnAdd, element, listener) {
	            eventListenerHandler.add(element, listener);
	
	            if(callOnAdd) {
	                listener(element);
	            }
	        }
	
	        //Options object may be omitted.
	        if(!listener) {
	            listener = elements;
	            elements = options;
	            options = {};
	        }
	
	        if(!elements) {
	            throw new Error("At least one element required.");
	        }
	
	        if(!listener) {
	            throw new Error("Listener required.");
	        }
	
	        if (isElement(elements)) {
	            // A single element has been passed in.
	            elements = [elements];
	        } else if (isCollection(elements)) {
	            // Convert collection to array for plugins.
	            // TODO: May want to check so that all the elements in the collection are valid elements.
	            elements = toArray(elements);
	        } else {
	            return reporter.error("Invalid arguments. Must be a DOM element or a collection of DOM elements.");
	        }
	
	        var elementsReady = 0;
	
	        var callOnAdd = getOption(options, "callOnAdd", globalOptions.callOnAdd);
	        var onReadyCallback = getOption(options, "onReady", function noop() {});
	        var debug = getOption(options, "debug", globalOptions.debug);
	
	        forEach(elements, function attachListenerToElement(element) {
	            if (!stateHandler.getState(element)) {
	                stateHandler.initState(element);
	                idHandler.set(element);
	            }
	
	            var id = idHandler.get(element);
	
	            debug && reporter.log("Attaching listener to element", id, element);
	
	            if(!elementUtils.isDetectable(element)) {
	                debug && reporter.log(id, "Not detectable.");
	                if(elementUtils.isBusy(element)) {
	                    debug && reporter.log(id, "System busy making it detectable");
	
	                    //The element is being prepared to be detectable. Do not make it detectable.
	                    //Just add the listener, because the element will soon be detectable.
	                    addListener(callOnAdd, element, listener);
	                    onReadyCallbacks[id] = onReadyCallbacks[id] || [];
	                    onReadyCallbacks[id].push(function onReady() {
	                        elementsReady++;
	
	                        if(elementsReady === elements.length) {
	                            onReadyCallback();
	                        }
	                    });
	                    return;
	                }
	
	                debug && reporter.log(id, "Making detectable...");
	                //The element is not prepared to be detectable, so do prepare it and add a listener to it.
	                elementUtils.markBusy(element, true);
	                return detectionStrategy.makeDetectable({ debug: debug, important: importantCssRules }, element, function onElementDetectable(element) {
	                    debug && reporter.log(id, "onElementDetectable");
	
	                    if (stateHandler.getState(element)) {
	                        elementUtils.markAsDetectable(element);
	                        elementUtils.markBusy(element, false);
	                        detectionStrategy.addListener(element, onResizeCallback);
	                        addListener(callOnAdd, element, listener);
	
	                        // Since the element size might have changed since the call to "listenTo", we need to check for this change,
	                        // so that a resize event may be emitted.
	                        // Having the startSize object is optional (since it does not make sense in some cases such as unrendered elements), so check for its existance before.
	                        // Also, check the state existance before since the element may have been uninstalled in the installation process.
	                        var state = stateHandler.getState(element);
	                        if (state && state.startSize) {
	                            var width = element.offsetWidth;
	                            var height = element.offsetHeight;
	                            if (state.startSize.width !== width || state.startSize.height !== height) {
	                                onResizeCallback(element);
	                            }
	                        }
	
	                        if(onReadyCallbacks[id]) {
	                            forEach(onReadyCallbacks[id], function(callback) {
	                                callback();
	                            });
	                        }
	                    } else {
	                        // The element has been unisntalled before being detectable.
	                        debug && reporter.log(id, "Element uninstalled before being detectable.");
	                    }
	
	                    delete onReadyCallbacks[id];
	
	                    elementsReady++;
	                    if(elementsReady === elements.length) {
	                        onReadyCallback();
	                    }
	                });
	            }
	
	            debug && reporter.log(id, "Already detecable, adding listener.");
	
	            //The element has been prepared to be detectable and is ready to be listened to.
	            addListener(callOnAdd, element, listener);
	            elementsReady++;
	        });
	
	        if(elementsReady === elements.length) {
	            onReadyCallback();
	        }
	    }
	
	    function uninstall(elements) {
	        if(!elements) {
	            return reporter.error("At least one element is required.");
	        }
	
	        if (isElement(elements)) {
	            // A single element has been passed in.
	            elements = [elements];
	        } else if (isCollection(elements)) {
	            // Convert collection to array for plugins.
	            // TODO: May want to check so that all the elements in the collection are valid elements.
	            elements = toArray(elements);
	        } else {
	            return reporter.error("Invalid arguments. Must be a DOM element or a collection of DOM elements.");
	        }
	
	        forEach(elements, function (element) {
	            eventListenerHandler.removeAllListeners(element);
	            detectionStrategy.uninstall(element);
	            stateHandler.cleanState(element);
	        });
	    }
	
	    function initDocument(targetDocument) {
	        detectionStrategy.initDocument && detectionStrategy.initDocument(targetDocument);
	    }
	
	    return {
	        listenTo: listenTo,
	        removeListener: eventListenerHandler.removeListener,
	        removeAllListeners: eventListenerHandler.removeAllListeners,
	        uninstall: uninstall,
	        initDocument: initDocument
	    };
	};
	
	function getOption(options, name, defaultValue) {
	    var value = options[name];
	
	    if((value === undefined || value === null) && defaultValue !== undefined) {
	        return defaultValue;
	    }
	
	    return value;
	}


/***/ },
/* 1015 */
/***/ function(module, exports) {

	"use strict";
	
	module.exports = function(options) {
	    var getState = options.stateHandler.getState;
	
	    /**
	     * Tells if the element has been made detectable and ready to be listened for resize events.
	     * @public
	     * @param {element} The element to check.
	     * @returns {boolean} True or false depending on if the element is detectable or not.
	     */
	    function isDetectable(element) {
	        var state = getState(element);
	        return state && !!state.isDetectable;
	    }
	
	    /**
	     * Marks the element that it has been made detectable and ready to be listened for resize events.
	     * @public
	     * @param {element} The element to mark.
	     */
	    function markAsDetectable(element) {
	        getState(element).isDetectable = true;
	    }
	
	    /**
	     * Tells if the element is busy or not.
	     * @public
	     * @param {element} The element to check.
	     * @returns {boolean} True or false depending on if the element is busy or not.
	     */
	    function isBusy(element) {
	        return !!getState(element).busy;
	    }
	
	    /**
	     * Marks the object is busy and should not be made detectable.
	     * @public
	     * @param {element} element The element to mark.
	     * @param {boolean} busy If the element is busy or not.
	     */
	    function markBusy(element, busy) {
	        getState(element).busy = !!busy;
	    }
	
	    return {
	        isDetectable: isDetectable,
	        markAsDetectable: markAsDetectable,
	        isBusy: isBusy,
	        markBusy: markBusy
	    };
	};


/***/ },
/* 1016 */
/***/ function(module, exports) {

	"use strict";
	
	module.exports = function() {
	    var idCount = 1;
	
	    /**
	     * Generates a new unique id in the context.
	     * @public
	     * @returns {number} A unique id in the context.
	     */
	    function generate() {
	        return idCount++;
	    }
	
	    return {
	        generate: generate
	    };
	};


/***/ },
/* 1017 */
/***/ function(module, exports) {

	"use strict";
	
	module.exports = function(options) {
	    var idGenerator     = options.idGenerator;
	    var getState        = options.stateHandler.getState;
	
	    /**
	     * Gets the resize detector id of the element.
	     * @public
	     * @param {element} element The target element to get the id of.
	     * @returns {string|number|null} The id of the element. Null if it has no id.
	     */
	    function getId(element) {
	        var state = getState(element);
	
	        if (state && state.id !== undefined) {
	            return state.id;
	        }
	
	        return null;
	    }
	
	    /**
	     * Sets the resize detector id of the element. Requires the element to have a resize detector state initialized.
	     * @public
	     * @param {element} element The target element to set the id of.
	     * @returns {string|number|null} The id of the element.
	     */
	    function setId(element) {
	        var state = getState(element);
	
	        if (!state) {
	            throw new Error("setId required the element to have a resize detection state.");
	        }
	
	        var id = idGenerator.generate();
	
	        state.id = id;
	
	        return id;
	    }
	
	    return {
	        get: getId,
	        set: setId
	    };
	};


/***/ },
/* 1018 */
/***/ function(module, exports) {

	"use strict";
	
	module.exports = function(idHandler) {
	    var eventListeners = {};
	
	    /**
	     * Gets all listeners for the given element.
	     * @public
	     * @param {element} element The element to get all listeners for.
	     * @returns All listeners for the given element.
	     */
	    function getListeners(element) {
	        var id = idHandler.get(element);
	
	        if (id === undefined) {
	            return [];
	        }
	
	        return eventListeners[id] || [];
	    }
	
	    /**
	     * Stores the given listener for the given element. Will not actually add the listener to the element.
	     * @public
	     * @param {element} element The element that should have the listener added.
	     * @param {function} listener The callback that the element has added.
	     */
	    function addListener(element, listener) {
	        var id = idHandler.get(element);
	
	        if(!eventListeners[id]) {
	            eventListeners[id] = [];
	        }
	
	        eventListeners[id].push(listener);
	    }
	
	    function removeListener(element, listener) {
	        var listeners = getListeners(element);
	        for (var i = 0, len = listeners.length; i < len; ++i) {
	            if (listeners[i] === listener) {
	              listeners.splice(i, 1);
	              break;
	            }
	        }
	    }
	
	    function removeAllListeners(element) {
	      var listeners = getListeners(element);
	      if (!listeners) { return; }
	      listeners.length = 0;
	    }
	
	    return {
	        get: getListeners,
	        add: addListener,
	        removeListener: removeListener,
	        removeAllListeners: removeAllListeners
	    };
	};


/***/ },
/* 1019 */
/***/ function(module, exports) {

	"use strict";
	
	/* global console: false */
	
	/**
	 * Reporter that handles the reporting of logs, warnings and errors.
	 * @public
	 * @param {boolean} quiet Tells if the reporter should be quiet or not.
	 */
	module.exports = function(quiet) {
	    function noop() {
	        //Does nothing.
	    }
	
	    var reporter = {
	        log: noop,
	        warn: noop,
	        error: noop
	    };
	
	    if(!quiet && window.console) {
	        var attachFunction = function(reporter, name) {
	            //The proxy is needed to be able to call the method with the console context,
	            //since we cannot use bind.
	            reporter[name] = function reporterProxy() {
	                var f = console[name];
	                if (f.apply) { //IE9 does not support console.log.apply :)
	                    f.apply(console, arguments);
	                } else {
	                    for (var i = 0; i < arguments.length; i++) {
	                        f(arguments[i]);
	                    }
	                }
	            };
	        };
	
	        attachFunction(reporter, "log");
	        attachFunction(reporter, "warn");
	        attachFunction(reporter, "error");
	    }
	
	    return reporter;
	};

/***/ },
/* 1020 */
/***/ function(module, exports) {

	"use strict";
	
	var prop = "_erd";
	
	function initState(element) {
	    element[prop] = {};
	    return getState(element);
	}
	
	function getState(element) {
	    return element[prop];
	}
	
	function cleanState(element) {
	    delete element[prop];
	}
	
	module.exports = {
	    initState: initState,
	    getState: getState,
	    cleanState: cleanState
	};


/***/ },
/* 1021 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/* globals
		Atomics,
		SharedArrayBuffer,
	*/
	
	var undefined;
	
	var $TypeError = TypeError;
	
	var $gOPD = Object.getOwnPropertyDescriptor;
	if ($gOPD) {
		try {
			$gOPD({}, '');
		} catch (e) {
			$gOPD = null; // this is IE 8, which has a broken gOPD
		}
	}
	
	var throwTypeError = function () { throw new $TypeError(); };
	var ThrowTypeError = $gOPD
		? (function () {
			try {
				// eslint-disable-next-line no-unused-expressions, no-caller, no-restricted-properties
				arguments.callee; // IE 8 does not throw here
				return throwTypeError;
			} catch (calleeThrows) {
				try {
					// IE 8 throws on Object.getOwnPropertyDescriptor(arguments, '')
					return $gOPD(arguments, 'callee').get;
				} catch (gOPDthrows) {
					return throwTypeError;
				}
			}
		}())
		: throwTypeError;
	
	var hasSymbols = __webpack_require__(1040)();
	
	var getProto = Object.getPrototypeOf || function (x) { return x.__proto__; }; // eslint-disable-line no-proto
	
	var generator; // = function * () {};
	var generatorFunction = generator ? getProto(generator) : undefined;
	var asyncFn; // async function() {};
	var asyncFunction = asyncFn ? asyncFn.constructor : undefined;
	var asyncGen; // async function * () {};
	var asyncGenFunction = asyncGen ? getProto(asyncGen) : undefined;
	var asyncGenIterator = asyncGen ? asyncGen() : undefined;
	
	var TypedArray = typeof Uint8Array === 'undefined' ? undefined : getProto(Uint8Array);
	
	var INTRINSICS = {
		'%Array%': Array,
		'%ArrayBuffer%': typeof ArrayBuffer === 'undefined' ? undefined : ArrayBuffer,
		'%ArrayBufferPrototype%': typeof ArrayBuffer === 'undefined' ? undefined : ArrayBuffer.prototype,
		'%ArrayIteratorPrototype%': hasSymbols ? getProto([][Symbol.iterator]()) : undefined,
		'%ArrayPrototype%': Array.prototype,
		'%ArrayProto_entries%': Array.prototype.entries,
		'%ArrayProto_forEach%': Array.prototype.forEach,
		'%ArrayProto_keys%': Array.prototype.keys,
		'%ArrayProto_values%': Array.prototype.values,
		'%AsyncFromSyncIteratorPrototype%': undefined,
		'%AsyncFunction%': asyncFunction,
		'%AsyncFunctionPrototype%': asyncFunction ? asyncFunction.prototype : undefined,
		'%AsyncGenerator%': asyncGen ? getProto(asyncGenIterator) : undefined,
		'%AsyncGeneratorFunction%': asyncGenFunction,
		'%AsyncGeneratorPrototype%': asyncGenFunction ? asyncGenFunction.prototype : undefined,
		'%AsyncIteratorPrototype%': asyncGenIterator && hasSymbols && Symbol.asyncIterator ? asyncGenIterator[Symbol.asyncIterator]() : undefined,
		'%Atomics%': typeof Atomics === 'undefined' ? undefined : Atomics,
		'%Boolean%': Boolean,
		'%BooleanPrototype%': Boolean.prototype,
		'%DataView%': typeof DataView === 'undefined' ? undefined : DataView,
		'%DataViewPrototype%': typeof DataView === 'undefined' ? undefined : DataView.prototype,
		'%Date%': Date,
		'%DatePrototype%': Date.prototype,
		'%decodeURI%': decodeURI,
		'%decodeURIComponent%': decodeURIComponent,
		'%encodeURI%': encodeURI,
		'%encodeURIComponent%': encodeURIComponent,
		'%Error%': Error,
		'%ErrorPrototype%': Error.prototype,
		'%eval%': eval, // eslint-disable-line no-eval
		'%EvalError%': EvalError,
		'%EvalErrorPrototype%': EvalError.prototype,
		'%Float32Array%': typeof Float32Array === 'undefined' ? undefined : Float32Array,
		'%Float32ArrayPrototype%': typeof Float32Array === 'undefined' ? undefined : Float32Array.prototype,
		'%Float64Array%': typeof Float64Array === 'undefined' ? undefined : Float64Array,
		'%Float64ArrayPrototype%': typeof Float64Array === 'undefined' ? undefined : Float64Array.prototype,
		'%Function%': Function,
		'%FunctionPrototype%': Function.prototype,
		'%Generator%': generator ? getProto(generator()) : undefined,
		'%GeneratorFunction%': generatorFunction,
		'%GeneratorPrototype%': generatorFunction ? generatorFunction.prototype : undefined,
		'%Int8Array%': typeof Int8Array === 'undefined' ? undefined : Int8Array,
		'%Int8ArrayPrototype%': typeof Int8Array === 'undefined' ? undefined : Int8Array.prototype,
		'%Int16Array%': typeof Int16Array === 'undefined' ? undefined : Int16Array,
		'%Int16ArrayPrototype%': typeof Int16Array === 'undefined' ? undefined : Int8Array.prototype,
		'%Int32Array%': typeof Int32Array === 'undefined' ? undefined : Int32Array,
		'%Int32ArrayPrototype%': typeof Int32Array === 'undefined' ? undefined : Int32Array.prototype,
		'%isFinite%': isFinite,
		'%isNaN%': isNaN,
		'%IteratorPrototype%': hasSymbols ? getProto(getProto([][Symbol.iterator]())) : undefined,
		'%JSON%': typeof JSON === 'object' ? JSON : undefined,
		'%JSONParse%': typeof JSON === 'object' ? JSON.parse : undefined,
		'%Map%': typeof Map === 'undefined' ? undefined : Map,
		'%MapIteratorPrototype%': typeof Map === 'undefined' || !hasSymbols ? undefined : getProto(new Map()[Symbol.iterator]()),
		'%MapPrototype%': typeof Map === 'undefined' ? undefined : Map.prototype,
		'%Math%': Math,
		'%Number%': Number,
		'%NumberPrototype%': Number.prototype,
		'%Object%': Object,
		'%ObjectPrototype%': Object.prototype,
		'%ObjProto_toString%': Object.prototype.toString,
		'%ObjProto_valueOf%': Object.prototype.valueOf,
		'%parseFloat%': parseFloat,
		'%parseInt%': parseInt,
		'%Promise%': typeof Promise === 'undefined' ? undefined : Promise,
		'%PromisePrototype%': typeof Promise === 'undefined' ? undefined : Promise.prototype,
		'%PromiseProto_then%': typeof Promise === 'undefined' ? undefined : Promise.prototype.then,
		'%Promise_all%': typeof Promise === 'undefined' ? undefined : Promise.all,
		'%Promise_reject%': typeof Promise === 'undefined' ? undefined : Promise.reject,
		'%Promise_resolve%': typeof Promise === 'undefined' ? undefined : Promise.resolve,
		'%Proxy%': typeof Proxy === 'undefined' ? undefined : Proxy,
		'%RangeError%': RangeError,
		'%RangeErrorPrototype%': RangeError.prototype,
		'%ReferenceError%': ReferenceError,
		'%ReferenceErrorPrototype%': ReferenceError.prototype,
		'%Reflect%': typeof Reflect === 'undefined' ? undefined : Reflect,
		'%RegExp%': RegExp,
		'%RegExpPrototype%': RegExp.prototype,
		'%Set%': typeof Set === 'undefined' ? undefined : Set,
		'%SetIteratorPrototype%': typeof Set === 'undefined' || !hasSymbols ? undefined : getProto(new Set()[Symbol.iterator]()),
		'%SetPrototype%': typeof Set === 'undefined' ? undefined : Set.prototype,
		'%SharedArrayBuffer%': typeof SharedArrayBuffer === 'undefined' ? undefined : SharedArrayBuffer,
		'%SharedArrayBufferPrototype%': typeof SharedArrayBuffer === 'undefined' ? undefined : SharedArrayBuffer.prototype,
		'%String%': String,
		'%StringIteratorPrototype%': hasSymbols ? getProto(''[Symbol.iterator]()) : undefined,
		'%StringPrototype%': String.prototype,
		'%Symbol%': hasSymbols ? Symbol : undefined,
		'%SymbolPrototype%': hasSymbols ? Symbol.prototype : undefined,
		'%SyntaxError%': SyntaxError,
		'%SyntaxErrorPrototype%': SyntaxError.prototype,
		'%ThrowTypeError%': ThrowTypeError,
		'%TypedArray%': TypedArray,
		'%TypedArrayPrototype%': TypedArray ? TypedArray.prototype : undefined,
		'%TypeError%': $TypeError,
		'%TypeErrorPrototype%': $TypeError.prototype,
		'%Uint8Array%': typeof Uint8Array === 'undefined' ? undefined : Uint8Array,
		'%Uint8ArrayPrototype%': typeof Uint8Array === 'undefined' ? undefined : Uint8Array.prototype,
		'%Uint8ClampedArray%': typeof Uint8ClampedArray === 'undefined' ? undefined : Uint8ClampedArray,
		'%Uint8ClampedArrayPrototype%': typeof Uint8ClampedArray === 'undefined' ? undefined : Uint8ClampedArray.prototype,
		'%Uint16Array%': typeof Uint16Array === 'undefined' ? undefined : Uint16Array,
		'%Uint16ArrayPrototype%': typeof Uint16Array === 'undefined' ? undefined : Uint16Array.prototype,
		'%Uint32Array%': typeof Uint32Array === 'undefined' ? undefined : Uint32Array,
		'%Uint32ArrayPrototype%': typeof Uint32Array === 'undefined' ? undefined : Uint32Array.prototype,
		'%URIError%': URIError,
		'%URIErrorPrototype%': URIError.prototype,
		'%WeakMap%': typeof WeakMap === 'undefined' ? undefined : WeakMap,
		'%WeakMapPrototype%': typeof WeakMap === 'undefined' ? undefined : WeakMap.prototype,
		'%WeakSet%': typeof WeakSet === 'undefined' ? undefined : WeakSet,
		'%WeakSetPrototype%': typeof WeakSet === 'undefined' ? undefined : WeakSet.prototype
	};
	
	var bind = __webpack_require__(287);
	var $replace = bind.call(Function.call, String.prototype.replace);
	
	/* adapted from https://github.com/lodash/lodash/blob/4.17.15/dist/lodash.js#L6735-L6744 */
	var rePropName = /[^%.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|%$))/g;
	var reEscapeChar = /\\(\\)?/g; /** Used to match backslashes in property paths. */
	var stringToPath = function stringToPath(string) {
		var result = [];
		$replace(string, rePropName, function (match, number, quote, subString) {
			result[result.length] = quote ? $replace(subString, reEscapeChar, '$1') : (number || match);
		});
		return result;
	};
	/* end adaptation */
	
	var getBaseIntrinsic = function getBaseIntrinsic(name, allowMissing) {
		if (!(name in INTRINSICS)) {
			throw new SyntaxError('intrinsic ' + name + ' does not exist!');
		}
	
		// istanbul ignore if // hopefully this is impossible to test :-)
		if (typeof INTRINSICS[name] === 'undefined' && !allowMissing) {
			throw new $TypeError('intrinsic ' + name + ' exists, but is not available. Please file an issue!');
		}
	
		return INTRINSICS[name];
	};
	
	module.exports = function GetIntrinsic(name, allowMissing) {
		if (typeof name !== 'string' || name.length === 0) {
			throw new TypeError('intrinsic name must be a non-empty string');
		}
		if (arguments.length > 1 && typeof allowMissing !== 'boolean') {
			throw new TypeError('"allowMissing" argument must be a boolean');
		}
	
		var parts = stringToPath(name);
	
		var value = getBaseIntrinsic('%' + (parts.length > 0 ? parts[0] : '') + '%', allowMissing);
		for (var i = 1; i < parts.length; i += 1) {
			if (value != null) {
				if ($gOPD && (i + 1) >= parts.length) {
					var desc = $gOPD(value, parts[i]);
					if (!allowMissing && !(parts[i] in value)) {
						throw new $TypeError('base intrinsic for ' + name + ' exists, but the property is not available.');
					}
					value = desc ? (desc.get || desc.value) : value[parts[i]];
				} else {
					value = value[parts[i]];
				}
			}
		}
		return value;
	};


/***/ },
/* 1022 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var bind = __webpack_require__(287);
	
	var GetIntrinsic = __webpack_require__(1021);
	
	var $Function = GetIntrinsic('%Function%');
	var $apply = $Function.apply;
	var $call = $Function.call;
	
	module.exports = function callBind() {
		return bind.apply($call, arguments);
	};
	
	module.exports.apply = function applyBind() {
		return bind.apply($apply, arguments);
	};


/***/ },
/* 1023 */
/***/ function(module, exports) {

	'use strict';
	
	var hasOwn = Object.prototype.hasOwnProperty;
	var toStr = Object.prototype.toString;
	var defineProperty = Object.defineProperty;
	var gOPD = Object.getOwnPropertyDescriptor;
	
	var isArray = function isArray(arr) {
		if (typeof Array.isArray === 'function') {
			return Array.isArray(arr);
		}
	
		return toStr.call(arr) === '[object Array]';
	};
	
	var isPlainObject = function isPlainObject(obj) {
		if (!obj || toStr.call(obj) !== '[object Object]') {
			return false;
		}
	
		var hasOwnConstructor = hasOwn.call(obj, 'constructor');
		var hasIsPrototypeOf = obj.constructor && obj.constructor.prototype && hasOwn.call(obj.constructor.prototype, 'isPrototypeOf');
		// Not own constructor property must be Object
		if (obj.constructor && !hasOwnConstructor && !hasIsPrototypeOf) {
			return false;
		}
	
		// Own properties are enumerated firstly, so to speed up,
		// if last one is own, then all properties are own.
		var key;
		for (key in obj) { /**/ }
	
		return typeof key === 'undefined' || hasOwn.call(obj, key);
	};
	
	// If name is '__proto__', and Object.defineProperty is available, define __proto__ as an own property on target
	var setProperty = function setProperty(target, options) {
		if (defineProperty && options.name === '__proto__') {
			defineProperty(target, options.name, {
				enumerable: true,
				configurable: true,
				value: options.newValue,
				writable: true
			});
		} else {
			target[options.name] = options.newValue;
		}
	};
	
	// Return undefined instead of __proto__ if '__proto__' is not an own property
	var getProperty = function getProperty(obj, name) {
		if (name === '__proto__') {
			if (!hasOwn.call(obj, name)) {
				return void 0;
			} else if (gOPD) {
				// In early versions of node, obj['__proto__'] is buggy when obj has
				// __proto__ as an own property. Object.getOwnPropertyDescriptor() works.
				return gOPD(obj, name).value;
			}
		}
	
		return obj[name];
	};
	
	module.exports = function extend() {
		var options, name, src, copy, copyIsArray, clone;
		var target = arguments[0];
		var i = 1;
		var length = arguments.length;
		var deep = false;
	
		// Handle a deep copy situation
		if (typeof target === 'boolean') {
			deep = target;
			target = arguments[1] || {};
			// skip the boolean and the target
			i = 2;
		}
		if (target == null || (typeof target !== 'object' && typeof target !== 'function')) {
			target = {};
		}
	
		for (; i < length; ++i) {
			options = arguments[i];
			// Only deal with non-null/undefined values
			if (options != null) {
				// Extend the base object
				for (name in options) {
					src = getProperty(target, name);
					copy = getProperty(options, name);
	
					// Prevent never-ending loop
					if (target !== copy) {
						// Recurse if we're merging plain objects or arrays
						if (deep && copy && (isPlainObject(copy) || (copyIsArray = isArray(copy)))) {
							if (copyIsArray) {
								copyIsArray = false;
								clone = src && isArray(src) ? src : [];
							} else {
								clone = src && isPlainObject(src) ? src : {};
							}
	
							// Never move original objects, clone them
							setProperty(target, { name: name, newValue: extend(deep, clone, copy) });
	
						// Don't bring in undefined values
						} else if (typeof copy !== 'undefined') {
							setProperty(target, { name: name, newValue: copy });
						}
					}
				}
			}
		}
	
		// Return the modified object
		return target;
	};


/***/ },
/* 1024 */
446,
/* 1025 */
446,
/* 1026 */
446,
/* 1027 */
446,
/* 1028 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/error-icon.5831796d.svg";

/***/ },
/* 1029 */,
/* 1030 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/seal.95a4b3f2.svg";

/***/ },
/* 1031 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/seal_reversed.dda5c060.svg";

/***/ },
/* 1032 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/seal.3e8dde9f.svg";

/***/ },
/* 1033 */
1031,
/* 1034 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/seal.5556e4d5.svg";

/***/ },
/* 1035 */
1034,
/* 1036 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/seal.2bf06a2d.svg";

/***/ },
/* 1037 */
/***/ function(module, exports, __webpack_require__) {

	var tabbable = __webpack_require__(1479);
	
	var listeningFocusTrap = null;
	
	function focusTrap(element, userOptions) {
	  var tabbableNodes = [];
	  var firstTabbableNode = null;
	  var lastTabbableNode = null;
	  var nodeFocusedBeforeActivation = null;
	  var active = false;
	  var paused = false;
	  var tabEvent = null;
	
	  var container = (typeof element === 'string')
	    ? document.querySelector(element)
	    : element;
	
	  var config = userOptions || {};
	  config.returnFocusOnDeactivate = (userOptions && userOptions.returnFocusOnDeactivate !== undefined)
	    ? userOptions.returnFocusOnDeactivate
	    : true;
	  config.escapeDeactivates = (userOptions && userOptions.escapeDeactivates !== undefined)
	    ? userOptions.escapeDeactivates
	    : true;
	
	  var trap = {
	    activate: activate,
	    deactivate: deactivate,
	    pause: pause,
	    unpause: unpause,
	  };
	
	  return trap;
	
	  function activate(activateOptions) {
	    if (active) return;
	
	    var defaultedActivateOptions = {
	      onActivate: (activateOptions && activateOptions.onActivate !== undefined)
	        ? activateOptions.onActivate
	        : config.onActivate,
	    };
	
	    active = true;
	    paused = false;
	    nodeFocusedBeforeActivation = document.activeElement;
	
	    if (defaultedActivateOptions.onActivate) {
	      defaultedActivateOptions.onActivate();
	    }
	
	    addListeners();
	    return trap;
	  }
	
	  function deactivate(deactivateOptions) {
	    if (!active) return;
	
	    var defaultedDeactivateOptions = {
	      returnFocus: (deactivateOptions && deactivateOptions.returnFocus !== undefined)
	        ? deactivateOptions.returnFocus
	        : config.returnFocusOnDeactivate,
	      onDeactivate: (deactivateOptions && deactivateOptions.onDeactivate !== undefined)
	        ? deactivateOptions.onDeactivate
	        : config.onDeactivate,
	    };
	
	    removeListeners();
	
	    if (defaultedDeactivateOptions.onDeactivate) {
	      defaultedDeactivateOptions.onDeactivate();
	    }
	
	    if (defaultedDeactivateOptions.returnFocus) {
	      setTimeout(function () {
	        tryFocus(nodeFocusedBeforeActivation);
	      }, 0);
	    }
	
	    active = false;
	    paused = false;
	    return this;
	  }
	
	  function pause() {
	    if (paused || !active) return;
	    paused = true;
	    removeListeners();
	  }
	
	  function unpause() {
	    if (!paused || !active) return;
	    paused = false;
	    addListeners();
	  }
	
	  function addListeners() {
	    if (!active) return;
	
	    // There can be only one listening focus trap at a time
	    if (listeningFocusTrap) {
	      listeningFocusTrap.pause();
	    }
	    listeningFocusTrap = trap;
	
	    updateTabbableNodes();
	    // Ensure that the focused element doesn't capture the event that caused the focus trap activation
	    setTimeout(function () {
	      tryFocus(firstFocusNode());
	    }, 0);
	    document.addEventListener('focus', checkFocus, true);
	    document.addEventListener('click', checkClick, true);
	    document.addEventListener('mousedown', checkPointerDown, true);
	    document.addEventListener('touchstart', checkPointerDown, true);
	    document.addEventListener('keydown', checkKey, true);
	
	    return trap;
	  }
	
	  function removeListeners() {
	    if (!active || listeningFocusTrap !== trap) return;
	
	    document.removeEventListener('focus', checkFocus, true);
	    document.removeEventListener('click', checkClick, true);
	    document.removeEventListener('mousedown', checkPointerDown, true);
	    document.removeEventListener('touchstart', checkPointerDown, true);
	    document.removeEventListener('keydown', checkKey, true);
	
	    listeningFocusTrap = null;
	
	    return trap;
	  }
	
	  function getNodeForOption(optionName) {
	    var optionValue = config[optionName];
	    var node = optionValue;
	    if (!optionValue) {
	      return null;
	    }
	    if (typeof optionValue === 'string') {
	      node = document.querySelector(optionValue);
	      if (!node) {
	        throw new Error('`' + optionName + '` refers to no known node');
	      }
	    }
	    if (typeof optionValue === 'function') {
	      node = optionValue();
	      if (!node) {
	        throw new Error('`' + optionName + '` did not return a node');
	      }
	    }
	    return node;
	  }
	
	  function firstFocusNode() {
	    var node;
	    if (getNodeForOption('initialFocus') !== null) {
	      node = getNodeForOption('initialFocus');
	    } else if (container.contains(document.activeElement)) {
	      node = document.activeElement;
	    } else {
	      node = tabbableNodes[0] || getNodeForOption('fallbackFocus');
	    }
	
	    if (!node) {
	      throw new Error('You can\'t have a focus-trap without at least one focusable element');
	    }
	
	    return node;
	  }
	
	  // This needs to be done on mousedown and touchstart instead of click
	  // so that it precedes the focus event
	  function checkPointerDown(e) {
	    if (config.clickOutsideDeactivates && !container.contains(e.target)) {
	      deactivate({ returnFocus: false });
	    }
	  }
	
	  function checkClick(e) {
	    if (config.clickOutsideDeactivates) return;
	    if (container.contains(e.target)) return;
	    e.preventDefault();
	    e.stopImmediatePropagation();
	  }
	
	  function checkFocus(e) {
	    if (container.contains(e.target)) return;
	    e.preventDefault();
	    e.stopImmediatePropagation();
	    // Checking for a blur method here resolves a Firefox issue (#15)
	    if (typeof e.target.blur === 'function') e.target.blur();
	
	    if (tabEvent) {
	      readjustFocus(tabEvent);
	    }
	  }
	
	  function checkKey(e) {
	    if (e.key === 'Tab' || e.keyCode === 9) {
	      handleTab(e);
	    }
	
	    if (config.escapeDeactivates !== false && isEscapeEvent(e)) {
	      deactivate();
	    }
	  }
	
	  function handleTab(e) {
	    updateTabbableNodes();
	
	    if (e.target.hasAttribute('tabindex') && Number(e.target.getAttribute('tabindex')) < 0) {
	      return tabEvent = e;
	    }
	
	    e.preventDefault();
	    var currentFocusIndex = tabbableNodes.indexOf(e.target);
	
	    if (e.shiftKey) {
	      if (e.target === firstTabbableNode || tabbableNodes.indexOf(e.target) === -1) {
	        return tryFocus(lastTabbableNode);
	      }
	      return tryFocus(tabbableNodes[currentFocusIndex - 1]);
	    }
	
	    if (e.target === lastTabbableNode) return tryFocus(firstTabbableNode);
	
	    tryFocus(tabbableNodes[currentFocusIndex + 1]);
	  }
	
	  function updateTabbableNodes() {
	    tabbableNodes = tabbable(container);
	    firstTabbableNode = tabbableNodes[0];
	    lastTabbableNode = tabbableNodes[tabbableNodes.length - 1];
	  }
	
	  function readjustFocus(e) {
	    if (e.shiftKey) return tryFocus(lastTabbableNode);
	
	    tryFocus(firstTabbableNode);
	  }
	}
	
	function isEscapeEvent(e) {
	  return e.key === 'Escape' || e.key === 'Esc' || e.keyCode === 27;
	}
	
	function tryFocus(node) {
	  if (!node || !node.focus) return;
	  if (node === document.activeElement)  return;
	
	  node.focus();
	  if (node.tagName.toLowerCase() === 'input') {
	    node.select();
	  }
	}
	
	module.exports = focusTrap;


/***/ },
/* 1038 */
/***/ function(module, exports) {

	'use strict';
	
	/* eslint no-invalid-this: 1 */
	
	var ERROR_MESSAGE = 'Function.prototype.bind called on incompatible ';
	var slice = Array.prototype.slice;
	var toStr = Object.prototype.toString;
	var funcType = '[object Function]';
	
	module.exports = function bind(that) {
	    var target = this;
	    if (typeof target !== 'function' || toStr.call(target) !== funcType) {
	        throw new TypeError(ERROR_MESSAGE + target);
	    }
	    var args = slice.call(arguments, 1);
	
	    var bound;
	    var binder = function () {
	        if (this instanceof bound) {
	            var result = target.apply(
	                this,
	                args.concat(slice.call(arguments))
	            );
	            if (Object(result) === result) {
	                return result;
	            }
	            return this;
	        } else {
	            return target.apply(
	                that,
	                args.concat(slice.call(arguments))
	            );
	        }
	    };
	
	    var boundLength = Math.max(0, target.length - args.length);
	    var boundArgs = [];
	    for (var i = 0; i < boundLength; i++) {
	        boundArgs.push('$' + i);
	    }
	
	    bound = Function('binder', 'return function (' + boundArgs.join(',') + '){ return binder.apply(this,arguments); }')(binder);
	
	    if (target.prototype) {
	        var Empty = function Empty() {};
	        Empty.prototype = target.prototype;
	        bound.prototype = new Empty();
	        Empty.prototype = null;
	    }
	
	    return bound;
	};


/***/ },
/* 1039 */
/***/ function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {// @flow
	'use strict';
	
	var key = '__global_unique_id__';
	
	module.exports = function() {
	  return global[key] = (global[key] || 0) + 1;
	};
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 1040 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {'use strict';
	
	var origSymbol = global.Symbol;
	var hasSymbolSham = __webpack_require__(1041);
	
	module.exports = function hasNativeSymbols() {
		if (typeof origSymbol !== 'function') { return false; }
		if (typeof Symbol !== 'function') { return false; }
		if (typeof origSymbol('foo') !== 'symbol') { return false; }
		if (typeof Symbol('bar') !== 'symbol') { return false; }
	
		return hasSymbolSham();
	};
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 1041 */
/***/ function(module, exports) {

	'use strict';
	
	/* eslint complexity: [2, 18], max-statements: [2, 33] */
	module.exports = function hasSymbols() {
		if (typeof Symbol !== 'function' || typeof Object.getOwnPropertySymbols !== 'function') { return false; }
		if (typeof Symbol.iterator === 'symbol') { return true; }
	
		var obj = {};
		var sym = Symbol('test');
		var symObj = Object(sym);
		if (typeof sym === 'string') { return false; }
	
		if (Object.prototype.toString.call(sym) !== '[object Symbol]') { return false; }
		if (Object.prototype.toString.call(symObj) !== '[object Symbol]') { return false; }
	
		// temp disabled per https://github.com/ljharb/object.assign/issues/17
		// if (sym instanceof Symbol) { return false; }
		// temp disabled per https://github.com/WebReflection/get-own-property-symbols/issues/4
		// if (!(symObj instanceof Symbol)) { return false; }
	
		// if (typeof Symbol.prototype.toString !== 'function') { return false; }
		// if (String(sym) !== Symbol.prototype.toString.call(sym)) { return false; }
	
		var symVal = 42;
		obj[sym] = symVal;
		for (sym in obj) { return false; } // eslint-disable-line no-restricted-syntax
		if (typeof Object.keys === 'function' && Object.keys(obj).length !== 0) { return false; }
	
		if (typeof Object.getOwnPropertyNames === 'function' && Object.getOwnPropertyNames(obj).length !== 0) { return false; }
	
		var syms = Object.getOwnPropertySymbols(obj);
		if (syms.length !== 1 || syms[0] !== sym) { return false; }
	
		if (!Object.prototype.propertyIsEnumerable.call(obj, sym)) { return false; }
	
		if (typeof Object.getOwnPropertyDescriptor === 'function') {
			var descriptor = Object.getOwnPropertyDescriptor(obj, sym);
			if (descriptor.value !== symVal || descriptor.enumerable !== true) { return false; }
		}
	
		return true;
	};


/***/ },
/* 1042 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var bind = __webpack_require__(287);
	
	module.exports = bind.call(Function.call, Object.prototype.hasOwnProperty);


/***/ },
/* 1043 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";function _interopDefault(t){return t&&"object"==typeof t&&"default"in t?t.default:t}Object.defineProperty(exports,"__esModule",{value:!0});var resolvePathname=_interopDefault(__webpack_require__(1411)),valueEqual=_interopDefault(__webpack_require__(1516));__webpack_require__(214);var invariant=_interopDefault(__webpack_require__(325));function _extends(){return(_extends=Object.assign||function(t){for(var n=1;n<arguments.length;n++){var e=arguments[n];for(var a in e)Object.prototype.hasOwnProperty.call(e,a)&&(t[a]=e[a])}return t}).apply(this,arguments)}function addLeadingSlash(t){return"/"===t.charAt(0)?t:"/"+t}function stripLeadingSlash(t){return"/"===t.charAt(0)?t.substr(1):t}function hasBasename(t,n){return 0===t.toLowerCase().indexOf(n.toLowerCase())&&-1!=="/?#".indexOf(t.charAt(n.length))}function stripBasename(t,n){return hasBasename(t,n)?t.substr(n.length):t}function stripTrailingSlash(t){return"/"===t.charAt(t.length-1)?t.slice(0,-1):t}function parsePath(t){var n=t||"/",e="",a="",r=n.indexOf("#");-1!==r&&(a=n.substr(r),n=n.substr(0,r));var o=n.indexOf("?");return-1!==o&&(e=n.substr(o),n=n.substr(0,o)),{pathname:n,search:"?"===e?"":e,hash:"#"===a?"":a}}function createPath(t){var n=t.pathname,e=t.search,a=t.hash,r=n||"/";return e&&"?"!==e&&(r+="?"===e.charAt(0)?e:"?"+e),a&&"#"!==a&&(r+="#"===a.charAt(0)?a:"#"+a),r}function createLocation(t,n,e,a){var r;"string"==typeof t?(r=parsePath(t)).state=n:(void 0===(r=_extends({},t)).pathname&&(r.pathname=""),r.search?"?"!==r.search.charAt(0)&&(r.search="?"+r.search):r.search="",r.hash?"#"!==r.hash.charAt(0)&&(r.hash="#"+r.hash):r.hash="",void 0!==n&&void 0===r.state&&(r.state=n));try{r.pathname=decodeURI(r.pathname)}catch(t){throw t instanceof URIError?new URIError('Pathname "'+r.pathname+'" could not be decoded. This is likely caused by an invalid percent-encoding.'):t}return e&&(r.key=e),a?r.pathname?"/"!==r.pathname.charAt(0)&&(r.pathname=resolvePathname(r.pathname,a.pathname)):r.pathname=a.pathname:r.pathname||(r.pathname="/"),r}function locationsAreEqual(t,n){return t.pathname===n.pathname&&t.search===n.search&&t.hash===n.hash&&t.key===n.key&&valueEqual(t.state,n.state)}function createTransitionManager(){var o=null;var a=[];return{setPrompt:function(t){return o=t,function(){o===t&&(o=null)}},confirmTransitionTo:function(t,n,e,a){if(null!=o){var r="function"==typeof o?o(t,n):o;"string"==typeof r?"function"==typeof e?e(r,a):a(!0):a(!1!==r)}else a(!0)},appendListener:function(t){var n=!0;function e(){n&&t.apply(void 0,arguments)}return a.push(e),function(){n=!1,a=a.filter(function(t){return t!==e})}},notifyListeners:function(){for(var t=arguments.length,n=new Array(t),e=0;e<t;e++)n[e]=arguments[e];a.forEach(function(t){return t.apply(void 0,n)})}}}var canUseDOM=!("undefined"==typeof window||!window.document||!window.document.createElement);function getConfirmation(t,n){n(window.confirm(t))}function supportsHistory(){var t=window.navigator.userAgent;return(-1===t.indexOf("Android 2.")&&-1===t.indexOf("Android 4.0")||-1===t.indexOf("Mobile Safari")||-1!==t.indexOf("Chrome")||-1!==t.indexOf("Windows Phone"))&&(window.history&&"pushState"in window.history)}function supportsPopStateOnHashChange(){return-1===window.navigator.userAgent.indexOf("Trident")}function supportsGoWithoutReloadUsingHash(){return-1===window.navigator.userAgent.indexOf("Firefox")}function isExtraneousPopstateEvent(t){return void 0===t.state&&-1===navigator.userAgent.indexOf("CriOS")}var PopStateEvent="popstate",HashChangeEvent="hashchange";function getHistoryState(){try{return window.history.state||{}}catch(t){return{}}}function createBrowserHistory(t){void 0===t&&(t={}),canUseDOM||invariant(!1);var s=window.history,c=supportsHistory(),n=!supportsPopStateOnHashChange(),e=t,a=e.forceRefresh,h=void 0!==a&&a,r=e.getUserConfirmation,u=void 0===r?getConfirmation:r,o=e.keyLength,i=void 0===o?6:o,f=t.basename?stripTrailingSlash(addLeadingSlash(t.basename)):"";function l(t){var n=t||{},e=n.key,a=n.state,r=window.location,o=r.pathname+r.search+r.hash;return f&&(o=stripBasename(o,f)),createLocation(o,a,e)}function d(){return Math.random().toString(36).substr(2,i)}var v=createTransitionManager();function p(t){_extends(T,t),T.length=s.length,v.notifyListeners(T.location,T.action)}function g(t){isExtraneousPopstateEvent(t)||w(l(t.state))}function P(){w(l(getHistoryState()))}var m=!1;function w(n){if(m)m=!1,p();else{v.confirmTransitionTo(n,"POP",u,function(t){t?p({action:"POP",location:n}):function(t){var n=T.location,e=H.indexOf(n.key);-1===e&&(e=0);var a=H.indexOf(t.key);-1===a&&(a=0);var r=e-a;r&&(m=!0,L(r))}(n)})}}var y=l(getHistoryState()),H=[y.key];function x(t){return f+createPath(t)}function L(t){s.go(t)}var O=0;function E(t){1===(O+=t)&&1===t?(window.addEventListener(PopStateEvent,g),n&&window.addEventListener(HashChangeEvent,P)):0===O&&(window.removeEventListener(PopStateEvent,g),n&&window.removeEventListener(HashChangeEvent,P))}var S=!1;var T={length:s.length,action:"POP",location:y,createHref:x,push:function(t,n){var i=createLocation(t,n,d(),T.location);v.confirmTransitionTo(i,"PUSH",u,function(t){if(t){var n=x(i),e=i.key,a=i.state;if(c)if(s.pushState({key:e,state:a},null,n),h)window.location.href=n;else{var r=H.indexOf(T.location.key),o=H.slice(0,r+1);o.push(i.key),H=o,p({action:"PUSH",location:i})}else window.location.href=n}})},replace:function(t,n){var o="REPLACE",i=createLocation(t,n,d(),T.location);v.confirmTransitionTo(i,o,u,function(t){if(t){var n=x(i),e=i.key,a=i.state;if(c)if(s.replaceState({key:e,state:a},null,n),h)window.location.replace(n);else{var r=H.indexOf(T.location.key);-1!==r&&(H[r]=i.key),p({action:o,location:i})}else window.location.replace(n)}})},go:L,goBack:function(){L(-1)},goForward:function(){L(1)},block:function(t){void 0===t&&(t=!1);var n=v.setPrompt(t);return S||(E(1),S=!0),function(){return S&&(S=!1,E(-1)),n()}},listen:function(t){var n=v.appendListener(t);return E(1),function(){E(-1),n()}}};return T}var HashChangeEvent$1="hashchange",HashPathCoders={hashbang:{encodePath:function(t){return"!"===t.charAt(0)?t:"!/"+stripLeadingSlash(t)},decodePath:function(t){return"!"===t.charAt(0)?t.substr(1):t}},noslash:{encodePath:stripLeadingSlash,decodePath:addLeadingSlash},slash:{encodePath:addLeadingSlash,decodePath:addLeadingSlash}};function stripHash(t){var n=t.indexOf("#");return-1===n?t:t.slice(0,n)}function getHashPath(){var t=window.location.href,n=t.indexOf("#");return-1===n?"":t.substring(n+1)}function pushHashPath(t){window.location.hash=t}function replaceHashPath(t){window.location.replace(stripHash(window.location.href)+"#"+t)}function createHashHistory(t){void 0===t&&(t={}),canUseDOM||invariant(!1);var n=window.history,e=(supportsGoWithoutReloadUsingHash(),t),a=e.getUserConfirmation,i=void 0===a?getConfirmation:a,r=e.hashType,o=void 0===r?"slash":r,s=t.basename?stripTrailingSlash(addLeadingSlash(t.basename)):"",c=HashPathCoders[o],h=c.encodePath,u=c.decodePath;function f(){var t=u(getHashPath());return s&&(t=stripBasename(t,s)),createLocation(t)}var l=createTransitionManager();function d(t){_extends(E,t),E.length=n.length,l.notifyListeners(E.location,E.action)}var v=!1,p=null;function g(){var t=getHashPath(),n=h(t);if(t!==n)replaceHashPath(n);else{var e=f(),a=E.location;if(!v&&function(t,n){return t.pathname===n.pathname&&t.search===n.search&&t.hash===n.hash}(a,e))return;if(p===createPath(e))return;p=null,function(n){if(v)v=!1,d();else{l.confirmTransitionTo(n,"POP",i,function(t){t?d({action:"POP",location:n}):function(t){var n=E.location,e=y.lastIndexOf(createPath(n));-1===e&&(e=0);var a=y.lastIndexOf(createPath(t));-1===a&&(a=0);var r=e-a;r&&(v=!0,H(r))}(n)})}}(e)}}var P=getHashPath(),m=h(P);P!==m&&replaceHashPath(m);var w=f(),y=[createPath(w)];function H(t){n.go(t)}var x=0;function L(t){1===(x+=t)&&1===t?window.addEventListener(HashChangeEvent$1,g):0===x&&window.removeEventListener(HashChangeEvent$1,g)}var O=!1;var E={length:n.length,action:"POP",location:w,createHref:function(t){var n=document.querySelector("base"),e="";return n&&n.getAttribute("href")&&(e=stripHash(window.location.href)),e+"#"+h(s+createPath(t))},push:function(t,n){var o=createLocation(t,void 0,void 0,E.location);l.confirmTransitionTo(o,"PUSH",i,function(t){if(t){var n=createPath(o),e=h(s+n);if(getHashPath()!==e){p=n,pushHashPath(e);var a=y.lastIndexOf(createPath(E.location)),r=y.slice(0,a+1);r.push(n),y=r,d({action:"PUSH",location:o})}else d()}})},replace:function(t,n){var r="REPLACE",o=createLocation(t,void 0,void 0,E.location);l.confirmTransitionTo(o,r,i,function(t){if(t){var n=createPath(o),e=h(s+n);getHashPath()!==e&&(p=n,replaceHashPath(e));var a=y.indexOf(createPath(E.location));-1!==a&&(y[a]=n),d({action:r,location:o})}})},go:H,goBack:function(){H(-1)},goForward:function(){H(1)},block:function(t){void 0===t&&(t=!1);var n=l.setPrompt(t);return O||(L(1),O=!0),function(){return O&&(O=!1,L(-1)),n()}},listen:function(t){var n=l.appendListener(t);return L(1),function(){L(-1),n()}}};return E}function clamp(t,n,e){return Math.min(Math.max(t,n),e)}function createMemoryHistory(t){void 0===t&&(t={});var n=t,r=n.getUserConfirmation,e=n.initialEntries,a=void 0===e?["/"]:e,o=n.initialIndex,i=void 0===o?0:o,s=n.keyLength,c=void 0===s?6:s,h=createTransitionManager();function u(t){_extends(g,t),g.length=g.entries.length,h.notifyListeners(g.location,g.action)}function f(){return Math.random().toString(36).substr(2,c)}var l=clamp(i,0,a.length-1),d=a.map(function(t){return createLocation(t,void 0,"string"==typeof t?f():t.key||f())}),v=createPath;function p(t){var n=clamp(g.index+t,0,g.entries.length-1),e=g.entries[n];h.confirmTransitionTo(e,"POP",r,function(t){t?u({action:"POP",location:e,index:n}):u()})}var g={length:d.length,action:"POP",location:d[l],index:l,entries:d,createHref:v,push:function(t,n){var a=createLocation(t,n,f(),g.location);h.confirmTransitionTo(a,"PUSH",r,function(t){if(t){var n=g.index+1,e=g.entries.slice(0);e.length>n?e.splice(n,e.length-n,a):e.push(a),u({action:"PUSH",location:a,index:n,entries:e})}})},replace:function(t,n){var e="REPLACE",a=createLocation(t,n,f(),g.location);h.confirmTransitionTo(a,e,r,function(t){t&&(g.entries[g.index]=a,u({action:e,location:a}))})},go:p,goBack:function(){p(-1)},goForward:function(){p(1)},canGo:function(t){var n=g.index+t;return 0<=n&&n<g.entries.length},block:function(t){return void 0===t&&(t=!1),h.setPrompt(t)},listen:function(t){return h.appendListener(t)}};return g}exports.createBrowserHistory=createBrowserHistory,exports.createHashHistory=createHashHistory,exports.createMemoryHistory=createMemoryHistory,exports.createLocation=createLocation,exports.locationsAreEqual=locationsAreEqual,exports.parsePath=parsePath,exports.createPath=createPath;


/***/ },
/* 1044 */
/***/ function(module, exports) {

	exports.read = function (buffer, offset, isLE, mLen, nBytes) {
	  var e, m
	  var eLen = (nBytes * 8) - mLen - 1
	  var eMax = (1 << eLen) - 1
	  var eBias = eMax >> 1
	  var nBits = -7
	  var i = isLE ? (nBytes - 1) : 0
	  var d = isLE ? -1 : 1
	  var s = buffer[offset + i]
	
	  i += d
	
	  e = s & ((1 << (-nBits)) - 1)
	  s >>= (-nBits)
	  nBits += eLen
	  for (; nBits > 0; e = (e * 256) + buffer[offset + i], i += d, nBits -= 8) {}
	
	  m = e & ((1 << (-nBits)) - 1)
	  e >>= (-nBits)
	  nBits += mLen
	  for (; nBits > 0; m = (m * 256) + buffer[offset + i], i += d, nBits -= 8) {}
	
	  if (e === 0) {
	    e = 1 - eBias
	  } else if (e === eMax) {
	    return m ? NaN : ((s ? -1 : 1) * Infinity)
	  } else {
	    m = m + Math.pow(2, mLen)
	    e = e - eBias
	  }
	  return (s ? -1 : 1) * m * Math.pow(2, e - mLen)
	}
	
	exports.write = function (buffer, value, offset, isLE, mLen, nBytes) {
	  var e, m, c
	  var eLen = (nBytes * 8) - mLen - 1
	  var eMax = (1 << eLen) - 1
	  var eBias = eMax >> 1
	  var rt = (mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0)
	  var i = isLE ? 0 : (nBytes - 1)
	  var d = isLE ? 1 : -1
	  var s = value < 0 || (value === 0 && 1 / value < 0) ? 1 : 0
	
	  value = Math.abs(value)
	
	  if (isNaN(value) || value === Infinity) {
	    m = isNaN(value) ? 1 : 0
	    e = eMax
	  } else {
	    e = Math.floor(Math.log(value) / Math.LN2)
	    if (value * (c = Math.pow(2, -e)) < 1) {
	      e--
	      c *= 2
	    }
	    if (e + eBias >= 1) {
	      value += rt / c
	    } else {
	      value += rt * Math.pow(2, 1 - eBias)
	    }
	    if (value * c >= 2) {
	      e++
	      c /= 2
	    }
	
	    if (e + eBias >= eMax) {
	      m = 0
	      e = eMax
	    } else if (e + eBias >= 1) {
	      m = ((value * c) - 1) * Math.pow(2, mLen)
	      e = e + eBias
	    } else {
	      m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen)
	      e = 0
	    }
	  }
	
	  for (; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8) {}
	
	  e = (e << mLen) | m
	  eLen += mLen
	  for (; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8) {}
	
	  buffer[offset + i - d] |= s * 128
	}


/***/ },
/* 1045 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var initialState = {
	  loggedIn: false,
	  FIRST_NAME: "",
	  MIDDLE_NAME: "",
	  LAST_NAME: "",
	  ORG_NAME: "",
	  USERNAME: "",
	  PHONE: "",
	  BUSINESS_NAME: "",
	  ADDR1: "",
	  ADDR2: "",
	  ADDR3: "",
	  CITY: "",
	  STATE: "",
	  POSTAL_CODE: "",
	  COUNTRY: "",
	  EMAIL: "",
	  WEB_USER_ID: 0,
	  USER_GROUP: 'PUBLIC',
	  isFrequentPayor: false,
	  checkingAuthState: false,
	  expires: null,
	  initialAuthCheck: true
	};
	
	var AuthReducer = function AuthReducer() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	  var action = arguments[1];
	
	  switch (action.type) {
	    case "SET_AUTH_ATTRIBUTE":
	      return Object.assign({}, state, _defineProperty({}, action.attribute, action.value));
	    case "SPREAD_AUTH_ATTRIBUTES":
	      return Object.assign({}, state, action.payload);
	    case "CLEAR_USER":
	      return Object.assign({}, state, initialState, { initialAuthCheck: false });
	    case "TOGGLE_LOGGED_IN":
	      return Object.assign({}, state, { loggedIn: action.loggedIn });
	    case "SET_EXPIRATION":
	      return Object.assign({}, state, { expires: action.expires });
	    default:
	      return state;
	  }
	};
	
	exports.default = AuthReducer;

/***/ },
/* 1046 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouterDom = __webpack_require__(30);
	
	var _connectedReactRouter = __webpack_require__(350);
	
	var _App = __webpack_require__(118);
	
	var _App2 = _interopRequireDefault(_App);
	
	var _store = __webpack_require__(18);
	
	var _store2 = _interopRequireDefault(_store);
	
	var _reactRedux = __webpack_require__(7);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Root = function (_Component) {
	  _inherits(Root, _Component);
	
	  function Root() {
	    _classCallCheck(this, Root);
	
	    return _possibleConstructorReturn(this, (Root.__proto__ || Object.getPrototypeOf(Root)).apply(this, arguments));
	  }
	
	  _createClass(Root, [{
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        _reactRedux.Provider,
	        { store: _store2.default },
	        _react2.default.createElement(
	          _connectedReactRouter.ConnectedRouter,
	          { history: _store.history },
	          _react2.default.createElement(_reactRouterDom.Route, { path: '/', component: _App2.default })
	        )
	      );
	    }
	  }]);
	
	  return Root;
	}(_react.Component);
	
	exports.default = Root;

/***/ },
/* 1047 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _requests = __webpack_require__(6);
	
	var _reactRedux = __webpack_require__(7);
	
	var _AuthActions = __webpack_require__(66);
	
	var _Shell = __webpack_require__(19);
	
	var _utilities = __webpack_require__(8);
	
	var _Loaders = __webpack_require__(16);
	
	var _PaymentCallback = __webpack_require__(119);
	
	var _localStorage = __webpack_require__(59);
	
	var _localStorage2 = _interopRequireDefault(_localStorage);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActiveDirectoryCallback = function ActiveDirectoryCallback(_ref) {
	  var dispatch = _ref.dispatch,
	      history = _ref.history;
	
	  var _React$useState = _react2.default.useState(null),
	      _React$useState2 = _slicedToArray(_React$useState, 2),
	      error = _React$useState2[0],
	      setError = _React$useState2[1];
	
	  _react2.default.useEffect(function () {
	    var code = (0, _utilities.parseUrlQuery)(location.search).code;
	    var error = (0, _utilities.parseUrlQuery)(location.search).error;
	    var error_description = (0, _utilities.parseUrlQuery)(location.search).error_description;
	    (0, _requests.GET_ACTIVE_DIRECTORY_LOGIN_CALLBACK)({ code: code, error: error, error_description: error_description }, function (user) {
	      (0, _AuthActions.storeAndDispatchLoginResponse)(user, dispatch);
	      var returnUrl = _localStorage2.default.get('ACTIVE_DIRECTORY_RETURN_URL') || '/';
	      history.replace(returnUrl);
	    }, function (err) {
	      console.error(err);
	      setError(err);
	    });
	  }, []);
	  return _react2.default.createElement(
	    _Shell.Body,
	    { className: 'login-redirector' },
	    error ? _react2.default.createElement(
	      'div',
	      { className: 'payment-callback' },
	      _react2.default.createElement(_PaymentCallback.PaymentError, { errorCode: error.code, children: error.message })
	    ) : _react2.default.createElement(_Loaders.Spinner, { className: 'page-loader' })
	  );
	};
	exports.default = (0, _reactRedux.connect)()(ActiveDirectoryCallback);

/***/ },
/* 1048 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _AuthActions = __webpack_require__(66);
	
	var _store = __webpack_require__(18);
	
	var _store2 = _interopRequireDefault(_store);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (_ref) {
	  var history = _ref.history;
	
	  _react2.default.useEffect(function () {
	    history.replace('/');
	    _store2.default.dispatch((0, _AuthActions.logoutWebUser)(true));
	  }, []);
	  return null;
	};

/***/ },
/* 1049 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(7);
	
	var _utilities = __webpack_require__(8);
	
	var _requests = __webpack_require__(6);
	
	var _localStorage = __webpack_require__(59);
	
	var _localStorage2 = _interopRequireDefault(_localStorage);
	
	var _reactRouterDom = __webpack_require__(30);
	
	var _actions = __webpack_require__(29);
	
	var _LoginRedirector = __webpack_require__(148);
	
	var _LoginRedirector2 = _interopRequireDefault(_LoginRedirector);
	
	var _Loaders = __webpack_require__(16);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActiveDirectoryRedirector = function ActiveDirectoryRedirector(_ref) {
	  var location = _ref.location,
	      history = _ref.history,
	      checkingAuthState = _ref.checkingAuthState,
	      loggedIn = _ref.loggedIn,
	      stateUser = _ref.stateUser;
	
	  var dispatch = (0, _reactRedux.useDispatch)();
	  _react2.default.useEffect(function () {
	    if (!checkingAuthState && !loggedIn && stateUser) {
	      var search = (0, _utilities.parseUrlQuery)(location.search);
	      var returnUrl = search.from || '/';
	      _localStorage2.default.set('ACTIVE_DIRECTORY_RETURN_URL', returnUrl);
	      (0, _requests.GET_ACTIVE_DIRECTORY_REDIRECT)(function (_ref2) {
	        var URLSTRING = _ref2.URLSTRING;
	
	        if (URLSTRING) {
	          window.location.href = URLSTRING;
	        }
	      }, function (err) {
	        dispatch((0, _actions.setErrorToast)(err.Message));
	      });
	    }
	  }, [checkingAuthState, loggedIn, stateUser]);
	  if (!checkingAuthState && loggedIn && stateUser) {
	    return _react2.default.createElement(_reactRouterDom.Redirect, { to: '/' });
	  }
	  if (!stateUser) {
	    return _react2.default.createElement(_LoginRedirector2.default, { location: location, history: history });
	  }
	  return _react2.default.createElement(_Loaders.Spinner, { className: 'loader', size: 'large' });
	};
	exports.default = (0, _reactRedux.connect)(function (state) {
	  return {
	    checkingAuthState: state.auth.checkingAuthState,
	    loggedIn: state.auth.loggedIn,
	    stateUser: state.app.stateUser
	  };
	})(ActiveDirectoryRedirector);

/***/ },
/* 1050 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _plus = __webpack_require__(337);
	
	var _plus2 = _interopRequireDefault(_plus);
	
	var _Home = __webpack_require__(297);
	
	var _Portal = __webpack_require__(12);
	
	var _Portal2 = _interopRequireDefault(_Portal);
	
	var _Modal = __webpack_require__(13);
	
	__webpack_require__(1430);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AddCategoryCard = function AddCategoryCard(_ref) {
	  var onCategoryAdded = _ref.onCategoryAdded;
	
	  var _React$useState = _react2.default.useState(false),
	      _React$useState2 = _slicedToArray(_React$useState, 2),
	      isAdding = _React$useState2[0],
	      setIsAdding = _React$useState2[1];
	
	  var editModal = _react2.default.useRef();
	
	  var handleSave = function handleSave() {
	    var category = editModal.current.getValues();
	    onCategoryAdded(category);
	  };
	
	  return _react2.default.createElement(
	    _react2.default.Fragment,
	    null,
	    _react2.default.createElement(
	      'div',
	      { className: 'edit-icon-wrapper flex-column center' },
	      _react2.default.createElement(
	        'div',
	        { className: 'edit-icon-positioner' },
	        _react2.default.createElement(
	          'button',
	          { className: 'edit-icon-wrapper', onClick: function onClick() {
	              return setIsAdding(true);
	            }, 'aria-label': 'Add Category Card' },
	          _react2.default.createElement(_plus2.default, null)
	        )
	      )
	    ),
	    _react2.default.createElement(
	      _Portal2.default,
	      { isOpened: isAdding },
	      _react2.default.createElement(
	        _Modal.Modal,
	        {
	          title: 'Add Category',
	          modalSize: 'large',
	          save: handleSave,
	          saveAndCloseButton: true,
	          cancelButton: true,
	          closeModal: function closeModal() {
	            return setIsAdding(false);
	          }
	        },
	        _react2.default.createElement(_Home.EditCategoryModal, {
	          ref: editModal,
	          id: 'new',
	          title: '',
	          description: '',
	          links: [{
	            label: "",
	            href: ""
	          }, {
	            type: "separator"
	          }, {
	            label: "",
	            href: ""
	          }],
	          icon: 'capital',
	          disabled: false
	        })
	      )
	    )
	  );
	};
	
	exports.default = AddCategoryCard;

/***/ },
/* 1051 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(7);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Announcer = function Announcer(_ref) {
	  var _ref$messages = _ref.messages,
	      messages = _ref$messages === undefined ? [] : _ref$messages;
	  return _react2.default.createElement(
	    'div',
	    { className: 'visually-hidden' },
	    messages.map(function (message) {
	      return _react2.default.createElement(
	        'span',
	        { role: 'alert' },
	        message
	      );
	    })
	  );
	};
	
	exports.default = (0, _reactRedux.connect)(function (state) {
	  return {
	    announcerMessages: state.app.announcerMessages
	  };
	})(Announcer);

/***/ },
/* 1052 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Shell = __webpack_require__(19);
	
	var _Field = __webpack_require__(25);
	
	var _Form = __webpack_require__(14);
	
	var _DetailHeader = __webpack_require__(455);
	
	var _DetailHeader2 = _interopRequireDefault(_DetailHeader);
	
	var _requests = __webpack_require__(6);
	
	__webpack_require__(540);
	
	var _DetailBlock = __webpack_require__(295);
	
	var _format = __webpack_require__(33);
	
	var _format2 = _interopRequireDefault(_format);
	
	var _FormCard = __webpack_require__(195);
	
	var _FormCard2 = _interopRequireDefault(_FormCard);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var APOSTILLE_FORM_TITLE = ({"NODE_ENV":"production","BUILD_DATE":"2025-08-27T15:15:31.687Z","BUILD_NUMBER":"Not Provided","GIT_VERSION":"v1.3.0-381-ga81e29b08","GIT_COMMIT_HASH":"a81e29b085c9268ffd96c78eb734365802722741","GIT_BRANCH":"beta","PUBLIC_URL":"","STATE_ABBR":"MT","STATE_NAME":"Montana","STATE_ORG_TITLE":"Secretary of State","LOGIN_HEADER_IMG_PATH":"","HOME_IMG_FILENAME":"montana.jpg","FAVICON_FILE_NAME":"favicon.ico","ALLOW_E_SIGN_ON_CORRECTIONS":true,"THIRD_PARTY_SIGNING_ALLOWED":false,"MY_ACCOUNT_SAVE_AND_CLOSE_BUTTON":true,"IE_DEPRECATED_MESSAGE":"Internet Explorer is not supported. Please select a supported browser below to access this website.","ADDITIONAL_ROUTES":{"dataRequests":true,"farmBill":true,"apostille":true,"externalHelp":"https://sosmt.gov/business/help-center/","systemAdministration":[{"title":"Saved Payments","parameter":"saved-payments","componentName":"SavedPayments"}]},"SUBROUTES":[{"label":"Business","component":"Business","parameter":"business","myWorkQueueSearch":false,"sourceTypeId":54,"searchMustHaveOneOf":["FILING_TYPE_ID","STATUS_ID","STATE","search"],"serverWebSearchDescription":true,"serverWorkQueueDescription":true,"serverMyRecordsDescription":true,"searchPlaceholder":"Search by name or filing number (X########)","allowEmptySearchTerm":true,"requestCertificateAlternateLabel":"Request Information","fileAmendmentButtonLabel":"Filing Actions","advancedSearchParameters":[{"type":"radio","name":"QUERY_TYPE_ID","defaultValue":1010,"options":[{"value":1010,"label":"Starts with"},{"value":1011,"label":"Contains"},{"value":1012,"label":" Word Contains"}]},{"type":"serverSelect","name":"FILING_TYPE_ID","optionsSrc":"FILING_TYPES","label":"Entity Type","placeholder":"All","defaultValue":"0"},{"type":"serverSelect","name":"FILING_SUBTYPE_ID","optionsSrc":"FILING_SUBTYPES","label":"Entity Subtype","overrideSubOptionsSrcFromParameterName":"FILING_TYPE_ID","placeholder":"All","defaultValue":"0"},{"type":"serverSelect","name":"STATUS_ID","optionsSrc":"FILING_STATUS_WITHOUT_ALL","label":"Status","placeholder":"All","defaultValue":"0"},{"type":"serverSelect","name":"STATE","optionsSrc":"STATE","label":"State","placeholder":"All","defaultValue":""},{"type":"serverSelect","name":"COUNTY","optionsSrc":"COUNTY_SUBOPTION","label":"County","overrideSubOptionsSrcFromParameterName":"STATE","placeholder":"All","defaultValue":""},{"type":"checkbox","name":"CRA_SEARCH_YN","defaultValue":false,"label":"Search by Registered Agent PID"},{"type":"dateRange","name":"FILING_DATE","label":"Registration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}},{"type":"dateRange","name":"EXPIRATION_DATE","label":"Expiration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}}],"myRecordsFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Active"},{"value":2,"label":"Inactive"},{"value":3,"label":"Pending"}]},{"type":"dateRange","name":"DATE_RANGE","label":"Date range","defaultValue":{"start":null,"end":null}}],"myWorkQueueFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Approved"},{"value":2,"label":"Pending Online Payment"},{"value":3,"label":"Pending Review"},{"value":4,"label":"Needs Correction"},{"value":5,"label":"Rejected"},{"value":6,"label":"Draft"}]},{"type":"dateRange","name":"DATE_RANGE","label":"Date range","defaultValue":{"start":null,"end":null}}]},{"label":"Notary","component":"Notary","parameter":"notary","sourceTypeId":850,"myWorkQueueSearch":false,"allowEmptySearchTerm":true,"requestCertificateAlternateLabel":"Download Certificate","fileAmendmentButtonLabel":"Filing Actions","hideNameRequestCertificate":true,"hideAddressRequestCertificate":true,"hideRecordUserManagment":true,"searchPlaceholder":"Search by name or commission number","searchMustHaveOneOf":["CITY","search","SERVICE_TYPE"],"advancedParametersStartOpen":true,"searchIsSortable":true,"advancedSearchParameters":[{"type":"radio","name":"STARTS_WITH_YN","defaultValue":false,"options":[{"value":true,"label":"Starts with"},{"value":false,"label":"Contains"}]},{"type":"checkbox","name":"ACTIVE_ONLY_YN","defaultValue":true,"label":"Active entities only"},{"type":"text","name":"CITY","defaultValue":"","label":"City"},{"type":"select","name":"SERVICE_TYPE","label":"Special Services Offered","defaultValue":0,"options":[{"value":0,"label":"(N/A)"},{"value":6165,"label":"In-Person Electronic Notarization (IPEN)"},{"value":6166,"label":"Remote Online Notarization (RON)"},{"value":6167,"label":"Mobile Notary Services"},{"value":6168,"label":"Remote Ink Notarization (RIN)"}]}]},{"label":"Apostille","component":"Apostille","parameter":"apostille","sourceTypeId":720,"myRecordsSearch":false,"myWorkQueueSearch":false,"disabled":false,"allowedRoutes":["/forms-manager/","/queue/","/forms/"]},{"label":"Liens","component":"UCC","parameter":"ucc","sourceTypeId":1999,"myRecordsSearch":true,"myWorkQueueSearch":true,"fileAmendmentButtonLabel":"Filing Actions","searchPlaceholder":"Search by name or file number","disabled":false,"serverWebSearchDescription":true,"myRecordsDescription":"","workQueueDescription":"","searchDescription":"","hideRecordUserManagment":true,"searchLiensCheckout":false,"advancedSearchParameters":[{"type":"radio","name":"STARTS_WITH_YN","defaultValue":false,"options":[{"value":true,"label":"Starts with"},{"value":false,"label":"Contains"}]},{"type":"select","name":"STATUS","defaultValue":"ALL","label":"Status","options":[{"value":"ACTIVE_UNLAPSED","label":"Active (unlapsed)"},{"value":"ACTIVE_LAPSED_UNLAPSED","label":"Active (lapsed and unlapsed)"}]},{"type":"text","name":"EXCLUDE_VALUES","label":"Exclude Debtor Names (comma separated list of names to exclude)","defaultValue":""},{"type":"dateRange","name":"FILING_DATE","label":"Financing Statement Date","defaultValue":{"start":null,"end":null}},{"type":"dateRange","name":"LAPSE_DATE","label":"Lapse Date","defaultValue":{"start":null,"end":null}},{"type":"text","name":"CITY","label":"Debtor City","defaultValue":""}],"myRecordsFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Approved"},{"value":2,"label":"Pending Online Payment"},{"value":3,"label":"Pending Review"}]},{"type":"select","name":"TYPE","defaultValue":0,"label":"Lien Type","options":[{"value":0,"label":"All"},{"value":1,"label":"UCC"},{"value":2,"label":"EFS"},{"value":3,"label":"Title 71"}]}],"myWorkQueueFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Approved"},{"value":2,"label":"Pending Online Payment"},{"value":3,"label":"Pending Review"},{"value":4,"label":"Pending Print and Mail"},{"value":5,"label":"Rejected"},{"value":6,"label":"Draft"}]},{"type":"select","name":"TYPE","defaultValue":0,"label":"Lien Type","options":[{"value":0,"label":"All"},{"value":1,"label":"UCC"},{"value":2,"label":"EFS"},{"value":3,"label":"Title 71"}]}]},{"label":"Copy Request","component":"copies","parameter":"copies","sourceTypeId":2001,"myRecordsSearch":false,"myWorkQueueSearch":false,"disabled":false,"allowedRoutes":["/forms-manager/","/queue/","/forms/"]},{"label":"Trademark","component":"Trademark","parameter":"trademark","sourceTypeId":810,"showRequestCertificate":true,"searchMustHaveOneOf":["search","EXPIRATION_DATE","FILING_DATE"],"allowEmptySearchTerm":true,"requestCertificateAlternateLabel":"Request Information","fileAmendmentButtonLabel":"Filing Actions","advancedSearchParameters":[{"type":"radio","name":"QUERY_TYPE_ID","defaultValue":1010,"options":[{"value":1010,"label":"Starts with"},{"value":1011,"label":"Contains"},{"value":1012,"label":" Word Contains"}]},{"type":"checkbox","name":"OWNER_SEARCH_YN","defaultValue":false,"label":"Search owners"},{"type":"radio","name":"SERVICE_MARK_YN","label":"Mark Type","defaultValue":"","options":[{"value":"","label":"All Marks"},{"value":"Y","label":"Service Mark"},{"value":"N","label":"Trademark"}]},{"type":"serverSelect","name":"STATUS_ID","optionsSrc":"TYPE_V|TRADEMARK_STATUS_TYPE","label":"Status","placeholder":"All","defaultValue":"0"},{"type":"select","name":"DESIGN_TYPE_ID","options":[{"value":0,"label":"All"},{"value":990,"label":"Words Only"},{"value":991,"label":"Design Only"},{"value":992,"label":"Words and Design"}],"label":"Design Type","defaultValue":"0"},{"type":"dateRange","name":"FILING_DATE","label":"Registered Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}},{"type":"dateRange","name":"EXPIRATION_DATE","label":"Expiration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}}]},{"label":"Business Info Request","component":"InfoRequests","parameter":"info-request","sourceTypeId":167,"allowedRoutes":["/forms-manager/","/queue/","/forms/"]},{"label":"Data Requests","component":"DataRequests","parameter":"data-request","sourceTypeId":0,"allowedRoutes":["/forms-manager/"]},{"label":"CRA","component":"CRA","parameter":"cra","sourceTypeId":157,"myRecordsSearch":false,"searchPlaceholder":"Search by name or registered agent number","allowedRoutes":["/forms-manager/","/forms/","/records/","/queue/","/search/"],"allowEmptySearchTerm":true,"fileAmendmentButtonLabel":"Filing Actions","advancedSearchParameters":[{"type":"radio","name":"QUERY_TYPE_ID","defaultValue":1010,"options":[{"value":1010,"label":"Starts with"},{"value":1011,"label":"Contains"},{"value":1012,"label":" Word Contains"}]},{"type":"dateRange","name":"CRA_DATE","label":"Registration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}},{"type":"select","name":"STATUS_ID","label":"Status","defaultValue":0,"options":[{"value":0,"label":"All"},{"value":121,"label":"Active"},{"value":122,"label":"Inactive"}]},{"type":"select","name":"AGENT_TYPE_ID","label":"Agent Type","defaultValue":0,"options":[{"value":0,"label":"All"},{"value":460,"label":"Registered Agent"},{"value":461,"label":"Commercial Registered Agent"}]}]},{"label":"Farm Bill","component":"FarmBill","parameter":"farm-bill","path":"/lists/farm-bill","sourceTypeId":0,"myRecordsSearch":false,"allowedRules":["/search/"],"disabled":true,"searchDescription":"To perform a search, enter a debtor name. Your search results may include: exact debtor name, variations of that name and any filing that includes your search criteria. Punctuation is ignored.\n\nYou can click on \"Advanced\" to refine your search. Under “Advanced” you can search by crop, year, county and SSN/FEIN. As a registered Farm Bill Buyer with the Montana Secretary of State’s office it is important to maintain the confidentiality of the information contained within the Farm Bill Master List. The Farm Bill Master List reflects personal data, such as Social Security Numbers, which are a key piece of personal identifiable information to assist you in determining the existence of a lien against a specific debtor. The distribution of this information beyond its intended purpose is strictly prohibited.\n\nThe debtor's tax identification number has been hidden for confidentiality reasons. You may continue to search on a tax ID number and return debtors that match your search criteria. The SSN/FEIN must be entered without dashes or spaces.","searchMustHaveOneOf":["search","UCC_FARM_PRODUCT_ID","COUNTY"],"searchPlaceholder":"Search by debtor name","advancedSearchParameters":[{"type":"ServerMultiComplete","label":"Product code name(s)","name":"UCC_FARM_PRODUCT_ID","defaultValue":"","optionsSrc":"UCC_FARM_PRODUCT_V"},{"type":"MultiComplete","label":"Year or Range of Years","name":"YEAR_NUM","optionsSrc":"years","startYear":"1968","defaultValue":[],"preMergeOptions":[{"value":"ALL","label":"All"}]},{"type":"serverSelect","label":"State","name":"STATE","defaultValue":"MONTANA","optionsSrc":"STATE"},{"type":"ServerMultiComplete","label":"County","name":"COUNTY","defaultValue":[],"optionsSrc":"COUNTY","overrideSubOptionsSrcFromParameterName":"STATE"},{"type":"checkbox","name":"TIN_SEARCH_YN","defaultValue":false,"label":"Tax Identification Number Search"},{"type":"checkbox","name":"TIN_SORT_YN","defaultValue":false,"label":"Unique ID Sort"}]}],"SYSTEM_NICKNAME":"Online Services Portal","PAYMENT_METHODS":[{"type":"bypass"},{"type":"iTransact"}],"PAYMENT_ALLOW_AMEX":true,"SYSTEM_ID_LABEL":"System Id","DOUBLE_COLUMN_PUBLIC_LOGIN":true,"INTERNAL_USER_MANAGEMENT":true,"ALLOW_PUBLIC_JSON_IMPORT":false,"MAX_FILE_UPLOAD_SIZE":10000000,"REFUND_TEXT":"","RETURN_TO_HOME_ON_LOGOUT":true,"CURRENT_SOS_NAME":"Christi Jacobsen","LOGO_FILENAME":"mt-sos-logo.png","LOGO_ALT":"Christi Jacobsen, Montana Secretary of State","LOGO_FULL_WIDTH":true,"HOME_HIDE_AUTH_HINT":true,"HOME_TITLE":"Montana Secretary of State","CUSTOM_TAB_TITLE":"Official Montana","HOME_SUBTITLE":"Online Business Services","ENTITY_NAME_CONSENT_DESCRIPTION":"","ALLOW_USER_PROFILE_EDITING":true,"COMPARE_FOREIGN_NAME_IN_ENTITY_NAME_VALIDATION":true,"FOREIGN_NAME_FIELD_NAME":"KIMA_PARENT_NAME_INFO","LOGIN_TITLE":"Montana Secretary of State Online Filing Portal Login","PUBLIC_LOGIN_LABEL":"Username","REVERSE_LOGIN_COLUMNS":true,"LOGIN_SEAL_FILENAME":"seal_white.png","SEPARATE_USERNAME_AND_EMAIL":true,"CREATE_ACCOUNT_BUTTON_ALIGN_LEFT":true,"CREATE_ACCOUNT_BUTTON_TEXT":"CREATE AN ACCOUNT","PASSWORD_CUSTOM_ERROR_TEXT":"The password must meet all requirements","ACCOUNT_CREATED_MESSAGE":"Please check your email to verify your account to login and allow a few minutes for this message to arrive. Check your junk/spam folders if you do not find the email in your inbox.","PUBLIC_LOGIN_PLACEHOLDER":" ","DISABLE_DEFAULT_PAYMENT_RADIO":true,"CUSTOM_RESET_PASSWORD_ERROR_MESSAGE":"Username invalid - no account found","PUBLIC_LOGIN_CREATE_DESCRIPTION":"### Existing User:\n\n  - Enter your username and password to login.  \n\n\n  #### - OR -  \n\n\n\n  - Forgot password? Click 'Reset Password' and follow the prompts.\n  - Forgot username? Click 'Forgot Username' and follow the prompts.  \n\n\n  ### New User:\n  ","LOGIN_HELP_LINK":"https://sosmt.gov/business/how-do-i/","LOGIN_HELP_LINK_TEXT":"Need Help?","FORGOT_USERNAME_TEXT":"Forgot Username?","LOGIN_ACTIVE_DIRECTORY_TEXT":"State User Login","MULTIPLE_LOGIN_METHODS":true,"HAS_ACTIVE_DIRECTORY_LOGIN":true,"RESET_PASSWORD_WITH_USERNAME":true,"DOWNLOAD_LINK":true,"SHOW_USERNAME_ACCOUNT_CREATE":true,"SHOW_SCROLL_DOWN_ARROW":true,"SHOW_ADDRESS_ACCOUNT_CREATE":true,"TWO_COLUMN_ACCOUNT_CREATE":true,"RESET_PASSWORD_TIP":"A link to change your password has been sent to your email. Please allow a few minutes for this message to arrive. Please check your junk/spam folders if you do not find the email in your inbox.","FORGOT_PASSWORD_LINK_TEXT":"Reset Password","PHONE_NUMBER_OPTIONAL_ACCOUNT_CREATE":true,"SHOW_REQUIRED_INDICATOR_ACCOUNT_CREATE":true,"PASSWORD_REQUIREMENTS_ACCOUNT_CREATE":"\n    <ul>\n      <li>MUST contain at least 8 characters (12+ recommended)</li>\n      <li>MUST contain at least one uppercase letter.</li>\n      <li>MUST contain at least one lowercase letter.</li>\n      <li>MUST contain at least one number.</li>\n      <li>MUST contain at least one special character (!”#$%&'()*+,-./:;<=>?</li>\n    </ul>\n  ","ALLOW_CERTIFICATION_REQUEST":true,"ALLOW_PUBLIC_CERTIFICATE_REQUEST":true,"ALLOW_COPY_REQUEST":false,"ALLOW_CORRECTION_STYLING":true,"HIDE_DEPRECATION_WARNING":false,"AMEND_ROUTE_PUBLIC":true,"SEAL_FILENAME":"seal.png","SHOPPING_CART":true,"ALLOW_PAYMENT_UPDATE_WITH_EMPTY_CART":true,"RA_EMAIL":true,"RA_WEBSITE":true,"RA_NO_DEFAULT_TYPE":true,"RA_ADDRESS_LABEL":"Street Address","RA_TYPE_SELECTION_DEFAULT":true,"RA_DEFAULT_TYPE":"460","RA_OVERRIDE_TYPE_WITH_DEFAULT":true,"RA_PRINCIPAL_ADDRESS_AMS":true,"UPLOAD_AND_SUBMIT_HIDE_IF_ONE_OPTION":true,"PAYMENT_PROCESSING_MESSAGE":"Your payment is processing - Do not close your browser or click the back button","CHECKOUT_BUTTON_WHEN_PROCESSING_TEXT":"Processing","EFS_CROP_PICKER_NONE_LABEL":"Lien Duration","DISALLOWED_WIZARD_PIECES":["FormationLocale"],"REPEATER_SHOW_EDIT_BUTTON":true,"DATA_REQUEST_PAGE_TITLE":"Data Requests and Subscriptions","DATA_REQUEST_SIDEBAR_LABEL":"Data Requests & Subscriptions","LOGIN_REDIRECTS_TO_EPASS":false,"LOGIN_REDIRECTS_TO_ACTIVE_DIRECTORY":true,"LOGIN_ACTIVE_DIRECTORY_LINK":true,"FETCH_EDIT_USER_LINK":false,"LISTS_FETCH_AVAILABLE_LISTS":true,"POST_WIZARD_SUBMIT_REDIRECT_URL":"/","PIN_REQUEST_ATTESTATIONS":true,"PIN_REQUEST_DESCRIPTION":"Click **Request PIN** to have a new PIN sent to the account holder's email address on file.","OWNERSHIP_REQUEST_DESCRIPTION":"To become an **authorized user** of this record, a current **AUTHORIZED USER** will need to grant you access. To request access, click **Request Access** below.","PIN_REQUEST_SUCCESS_MESSAGE":"The PIN you have requested for this entity has been sent to the email associated with your user account.  You should receive the PIN in approximately 3-5 minutes, depending on your email service provider.","APOSTILLE_HEADER_LABEL":"Verification Information","APOSTILLE_NUMBER_LABEL":"Apostille/Authentication","APOSTILLE_CITY_STATE_OVERRIDE":"HELENA, MT","APOSTILLE_FILING_DATE_LABEL":"Issue Date","APOSTILLE_CITY_STATE_IN_CERTIFIED":true,"NOTARY_EXISTING_FILING":true,"ALLOW_REVOKE_OWN_ACCESS_ONLY":false,"HIDE_CANCEL_ON_ONETIME_DATA_REQUESTS":true,"DATA_REQUESTS_IN_SHOPPING_CART":true,"WQ_ALLOW_EDIT_PENDING_PAYMENT":true,"WQ_CONFIRM_ON_DELETE":true,"WQ_DELETE_CONFIRM_MESSAGE":"Deleting this filing will forfeit any money already paid to the Secretary of State. This action is permanent and cannot be undone, are you sure you would like to delete?","PASS_ITEM_GUIDS_ON_CHECKOUT":true,"FORM_REVISION_HISTORY":true,"CHECKOUT_DISCLAIMER":"By entering your credit card and/or checking account information you (i) state that **you are an authorized user** of the credit card and/or electronic check and that the associated information entered (e.g., account holder name, account number, billing address) is accurate, (ii) **you authorize payment processor to charge the amount you have requested** to your credit card and/or funding account, and (iii) **acknowledge if a charge is declined or reversed you may also be assessed a customary charge** by the payment processor for such transactions.","FARM_BILL_SEARCH_CONFIDENTIAL":"As a registered Farm Bill Buyer with the Montana Secretary of State’s office it is important to maintain the confidentiality of the information contained within the Farm Bill Master List. The Farm Bill Master List reflects personal data, such as Social Security Numbers, which are a key piece of personal identifiable information to assist you in determining the existence of a lien against a specific debtor. The distribution of this information beyond its intended purpose is strictly prohibited.\n\n**The debtor's tax identification number has been hidden for confidentiality reasons. You may continue to search on a tax ID number and return debtors that match your search criteria. The SSN/FEIN must be entered without dashes or spaces.  If you need access to the tax identification number to clearly identify the debtor, please contact the UCC unit at (406) 444-3665.**","VIEW_HISTORY_BUTTON_ALT_TEXT":"View Filings","WIZARD_ERROR_TITLE_MESSAGE":"Form Error","FARM_BILL_SEARCH_INTERACTIVE":true,"USE_FARM_BILL_API":true,"DISALLOW_ASSIGN_SELF_AS_RA":true,"DISALLOW_ASSIGN_SELF_AS_PRINCIPAL":true,"USE_TRADEMARK_OWNER_VALIDATION":true,"USE_ALTERNATIVE_FOREIGN_ADDRESS_LABELS":true,"MY_RECEIPTS_FILTER":[{"type":"dateRange","name":"DATE_RANGE","label":"Date range","defaultValue":{"start":null,"end":null}},{"type":"text","name":"REF_NUM","defaultValue":"","label":"Reference Number"},{"type":"text","name":"RECEIPT_NUM","defaultValue":"","label":"Receipt Id"},{"type":"text","name":"AMOUNT","defaultValue":"","label":"Amount"},{"type":"select","name":"TYPE","defaultValue":"","label":"Payment Type","options":[{"value":"","label":"All"},{"value":"CC","label":"Credit Card"},{"value":"Check","label":"Check"}]}],"MY_RECEIPTS_SHOW_IN_SIDEBAR":true,"SHOW_MY_RECEIPTS_HELPER_TEXT":true,"MY_RECEIPTS_HELPER_LABEL":"About Receipt Search","MY_RECEIPTS_HELPER_TEXT":"You can search for receipts based on their descriptions, including the items paid for on the receipt. Use the filters to search for or filter specific information.","FARM_BILL_SUBLINK":{"label":"Farm Bill","component":"FarmBill","parameter":"farm-bill","path":"/lists/farm-bill","sourceTypeId":0,"myRecordsSearch":false,"allowedRules":["/search/"],"disabled":true,"searchDescription":"To perform a search, enter a debtor name. Your search results may include: exact debtor name, variations of that name and any filing that includes your search criteria. Punctuation is ignored.\n\nYou can click on \"Advanced\" to refine your search. Under “Advanced” you can search by crop, year, county and SSN/FEIN. As a registered Farm Bill Buyer with the Montana Secretary of State’s office it is important to maintain the confidentiality of the information contained within the Farm Bill Master List. The Farm Bill Master List reflects personal data, such as Social Security Numbers, which are a key piece of personal identifiable information to assist you in determining the existence of a lien against a specific debtor. The distribution of this information beyond its intended purpose is strictly prohibited.\n\nThe debtor's tax identification number has been hidden for confidentiality reasons. You may continue to search on a tax ID number and return debtors that match your search criteria. The SSN/FEIN must be entered without dashes or spaces.","searchMustHaveOneOf":["search","UCC_FARM_PRODUCT_ID","COUNTY"],"searchPlaceholder":"Search by debtor name","advancedSearchParameters":[{"type":"ServerMultiComplete","label":"Product code name(s)","name":"UCC_FARM_PRODUCT_ID","defaultValue":"","optionsSrc":"UCC_FARM_PRODUCT_V"},{"type":"MultiComplete","label":"Year or Range of Years","name":"YEAR_NUM","optionsSrc":"years","startYear":"1968","defaultValue":[],"preMergeOptions":[{"value":"ALL","label":"All"}]},{"type":"serverSelect","label":"State","name":"STATE","defaultValue":"MONTANA","optionsSrc":"STATE"},{"type":"ServerMultiComplete","label":"County","name":"COUNTY","defaultValue":[],"optionsSrc":"COUNTY","overrideSubOptionsSrcFromParameterName":"STATE"},{"type":"checkbox","name":"TIN_SEARCH_YN","defaultValue":false,"label":"Tax Identification Number Search"},{"type":"checkbox","name":"TIN_SORT_YN","defaultValue":false,"label":"Unique ID Sort"}]},"ALLOW_ADDRESS_VALIDATION_BYPASS_OPTION":true,"DEFAULT_ADDRESS_VALIDATION_BYPASS_OPTION_CHECKED":true}).APOSTILLE_FORM_TITLE;
	var APOSTILLE_NUMBER_INPUT_LABEL = ({"NODE_ENV":"production","BUILD_DATE":"2025-08-27T15:15:31.687Z","BUILD_NUMBER":"Not Provided","GIT_VERSION":"v1.3.0-381-ga81e29b08","GIT_COMMIT_HASH":"a81e29b085c9268ffd96c78eb734365802722741","GIT_BRANCH":"beta","PUBLIC_URL":"","STATE_ABBR":"MT","STATE_NAME":"Montana","STATE_ORG_TITLE":"Secretary of State","LOGIN_HEADER_IMG_PATH":"","HOME_IMG_FILENAME":"montana.jpg","FAVICON_FILE_NAME":"favicon.ico","ALLOW_E_SIGN_ON_CORRECTIONS":true,"THIRD_PARTY_SIGNING_ALLOWED":false,"MY_ACCOUNT_SAVE_AND_CLOSE_BUTTON":true,"IE_DEPRECATED_MESSAGE":"Internet Explorer is not supported. Please select a supported browser below to access this website.","ADDITIONAL_ROUTES":{"dataRequests":true,"farmBill":true,"apostille":true,"externalHelp":"https://sosmt.gov/business/help-center/","systemAdministration":[{"title":"Saved Payments","parameter":"saved-payments","componentName":"SavedPayments"}]},"SUBROUTES":[{"label":"Business","component":"Business","parameter":"business","myWorkQueueSearch":false,"sourceTypeId":54,"searchMustHaveOneOf":["FILING_TYPE_ID","STATUS_ID","STATE","search"],"serverWebSearchDescription":true,"serverWorkQueueDescription":true,"serverMyRecordsDescription":true,"searchPlaceholder":"Search by name or filing number (X########)","allowEmptySearchTerm":true,"requestCertificateAlternateLabel":"Request Information","fileAmendmentButtonLabel":"Filing Actions","advancedSearchParameters":[{"type":"radio","name":"QUERY_TYPE_ID","defaultValue":1010,"options":[{"value":1010,"label":"Starts with"},{"value":1011,"label":"Contains"},{"value":1012,"label":" Word Contains"}]},{"type":"serverSelect","name":"FILING_TYPE_ID","optionsSrc":"FILING_TYPES","label":"Entity Type","placeholder":"All","defaultValue":"0"},{"type":"serverSelect","name":"FILING_SUBTYPE_ID","optionsSrc":"FILING_SUBTYPES","label":"Entity Subtype","overrideSubOptionsSrcFromParameterName":"FILING_TYPE_ID","placeholder":"All","defaultValue":"0"},{"type":"serverSelect","name":"STATUS_ID","optionsSrc":"FILING_STATUS_WITHOUT_ALL","label":"Status","placeholder":"All","defaultValue":"0"},{"type":"serverSelect","name":"STATE","optionsSrc":"STATE","label":"State","placeholder":"All","defaultValue":""},{"type":"serverSelect","name":"COUNTY","optionsSrc":"COUNTY_SUBOPTION","label":"County","overrideSubOptionsSrcFromParameterName":"STATE","placeholder":"All","defaultValue":""},{"type":"checkbox","name":"CRA_SEARCH_YN","defaultValue":false,"label":"Search by Registered Agent PID"},{"type":"dateRange","name":"FILING_DATE","label":"Registration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}},{"type":"dateRange","name":"EXPIRATION_DATE","label":"Expiration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}}],"myRecordsFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Active"},{"value":2,"label":"Inactive"},{"value":3,"label":"Pending"}]},{"type":"dateRange","name":"DATE_RANGE","label":"Date range","defaultValue":{"start":null,"end":null}}],"myWorkQueueFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Approved"},{"value":2,"label":"Pending Online Payment"},{"value":3,"label":"Pending Review"},{"value":4,"label":"Needs Correction"},{"value":5,"label":"Rejected"},{"value":6,"label":"Draft"}]},{"type":"dateRange","name":"DATE_RANGE","label":"Date range","defaultValue":{"start":null,"end":null}}]},{"label":"Notary","component":"Notary","parameter":"notary","sourceTypeId":850,"myWorkQueueSearch":false,"allowEmptySearchTerm":true,"requestCertificateAlternateLabel":"Download Certificate","fileAmendmentButtonLabel":"Filing Actions","hideNameRequestCertificate":true,"hideAddressRequestCertificate":true,"hideRecordUserManagment":true,"searchPlaceholder":"Search by name or commission number","searchMustHaveOneOf":["CITY","search","SERVICE_TYPE"],"advancedParametersStartOpen":true,"searchIsSortable":true,"advancedSearchParameters":[{"type":"radio","name":"STARTS_WITH_YN","defaultValue":false,"options":[{"value":true,"label":"Starts with"},{"value":false,"label":"Contains"}]},{"type":"checkbox","name":"ACTIVE_ONLY_YN","defaultValue":true,"label":"Active entities only"},{"type":"text","name":"CITY","defaultValue":"","label":"City"},{"type":"select","name":"SERVICE_TYPE","label":"Special Services Offered","defaultValue":0,"options":[{"value":0,"label":"(N/A)"},{"value":6165,"label":"In-Person Electronic Notarization (IPEN)"},{"value":6166,"label":"Remote Online Notarization (RON)"},{"value":6167,"label":"Mobile Notary Services"},{"value":6168,"label":"Remote Ink Notarization (RIN)"}]}]},{"label":"Apostille","component":"Apostille","parameter":"apostille","sourceTypeId":720,"myRecordsSearch":false,"myWorkQueueSearch":false,"disabled":false,"allowedRoutes":["/forms-manager/","/queue/","/forms/"]},{"label":"Liens","component":"UCC","parameter":"ucc","sourceTypeId":1999,"myRecordsSearch":true,"myWorkQueueSearch":true,"fileAmendmentButtonLabel":"Filing Actions","searchPlaceholder":"Search by name or file number","disabled":false,"serverWebSearchDescription":true,"myRecordsDescription":"","workQueueDescription":"","searchDescription":"","hideRecordUserManagment":true,"searchLiensCheckout":false,"advancedSearchParameters":[{"type":"radio","name":"STARTS_WITH_YN","defaultValue":false,"options":[{"value":true,"label":"Starts with"},{"value":false,"label":"Contains"}]},{"type":"select","name":"STATUS","defaultValue":"ALL","label":"Status","options":[{"value":"ACTIVE_UNLAPSED","label":"Active (unlapsed)"},{"value":"ACTIVE_LAPSED_UNLAPSED","label":"Active (lapsed and unlapsed)"}]},{"type":"text","name":"EXCLUDE_VALUES","label":"Exclude Debtor Names (comma separated list of names to exclude)","defaultValue":""},{"type":"dateRange","name":"FILING_DATE","label":"Financing Statement Date","defaultValue":{"start":null,"end":null}},{"type":"dateRange","name":"LAPSE_DATE","label":"Lapse Date","defaultValue":{"start":null,"end":null}},{"type":"text","name":"CITY","label":"Debtor City","defaultValue":""}],"myRecordsFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Approved"},{"value":2,"label":"Pending Online Payment"},{"value":3,"label":"Pending Review"}]},{"type":"select","name":"TYPE","defaultValue":0,"label":"Lien Type","options":[{"value":0,"label":"All"},{"value":1,"label":"UCC"},{"value":2,"label":"EFS"},{"value":3,"label":"Title 71"}]}],"myWorkQueueFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Approved"},{"value":2,"label":"Pending Online Payment"},{"value":3,"label":"Pending Review"},{"value":4,"label":"Pending Print and Mail"},{"value":5,"label":"Rejected"},{"value":6,"label":"Draft"}]},{"type":"select","name":"TYPE","defaultValue":0,"label":"Lien Type","options":[{"value":0,"label":"All"},{"value":1,"label":"UCC"},{"value":2,"label":"EFS"},{"value":3,"label":"Title 71"}]}]},{"label":"Copy Request","component":"copies","parameter":"copies","sourceTypeId":2001,"myRecordsSearch":false,"myWorkQueueSearch":false,"disabled":false,"allowedRoutes":["/forms-manager/","/queue/","/forms/"]},{"label":"Trademark","component":"Trademark","parameter":"trademark","sourceTypeId":810,"showRequestCertificate":true,"searchMustHaveOneOf":["search","EXPIRATION_DATE","FILING_DATE"],"allowEmptySearchTerm":true,"requestCertificateAlternateLabel":"Request Information","fileAmendmentButtonLabel":"Filing Actions","advancedSearchParameters":[{"type":"radio","name":"QUERY_TYPE_ID","defaultValue":1010,"options":[{"value":1010,"label":"Starts with"},{"value":1011,"label":"Contains"},{"value":1012,"label":" Word Contains"}]},{"type":"checkbox","name":"OWNER_SEARCH_YN","defaultValue":false,"label":"Search owners"},{"type":"radio","name":"SERVICE_MARK_YN","label":"Mark Type","defaultValue":"","options":[{"value":"","label":"All Marks"},{"value":"Y","label":"Service Mark"},{"value":"N","label":"Trademark"}]},{"type":"serverSelect","name":"STATUS_ID","optionsSrc":"TYPE_V|TRADEMARK_STATUS_TYPE","label":"Status","placeholder":"All","defaultValue":"0"},{"type":"select","name":"DESIGN_TYPE_ID","options":[{"value":0,"label":"All"},{"value":990,"label":"Words Only"},{"value":991,"label":"Design Only"},{"value":992,"label":"Words and Design"}],"label":"Design Type","defaultValue":"0"},{"type":"dateRange","name":"FILING_DATE","label":"Registered Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}},{"type":"dateRange","name":"EXPIRATION_DATE","label":"Expiration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}}]},{"label":"Business Info Request","component":"InfoRequests","parameter":"info-request","sourceTypeId":167,"allowedRoutes":["/forms-manager/","/queue/","/forms/"]},{"label":"Data Requests","component":"DataRequests","parameter":"data-request","sourceTypeId":0,"allowedRoutes":["/forms-manager/"]},{"label":"CRA","component":"CRA","parameter":"cra","sourceTypeId":157,"myRecordsSearch":false,"searchPlaceholder":"Search by name or registered agent number","allowedRoutes":["/forms-manager/","/forms/","/records/","/queue/","/search/"],"allowEmptySearchTerm":true,"fileAmendmentButtonLabel":"Filing Actions","advancedSearchParameters":[{"type":"radio","name":"QUERY_TYPE_ID","defaultValue":1010,"options":[{"value":1010,"label":"Starts with"},{"value":1011,"label":"Contains"},{"value":1012,"label":" Word Contains"}]},{"type":"dateRange","name":"CRA_DATE","label":"Registration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}},{"type":"select","name":"STATUS_ID","label":"Status","defaultValue":0,"options":[{"value":0,"label":"All"},{"value":121,"label":"Active"},{"value":122,"label":"Inactive"}]},{"type":"select","name":"AGENT_TYPE_ID","label":"Agent Type","defaultValue":0,"options":[{"value":0,"label":"All"},{"value":460,"label":"Registered Agent"},{"value":461,"label":"Commercial Registered Agent"}]}]},{"label":"Farm Bill","component":"FarmBill","parameter":"farm-bill","path":"/lists/farm-bill","sourceTypeId":0,"myRecordsSearch":false,"allowedRules":["/search/"],"disabled":true,"searchDescription":"To perform a search, enter a debtor name. Your search results may include: exact debtor name, variations of that name and any filing that includes your search criteria. Punctuation is ignored.\n\nYou can click on \"Advanced\" to refine your search. Under “Advanced” you can search by crop, year, county and SSN/FEIN. As a registered Farm Bill Buyer with the Montana Secretary of State’s office it is important to maintain the confidentiality of the information contained within the Farm Bill Master List. The Farm Bill Master List reflects personal data, such as Social Security Numbers, which are a key piece of personal identifiable information to assist you in determining the existence of a lien against a specific debtor. The distribution of this information beyond its intended purpose is strictly prohibited.\n\nThe debtor's tax identification number has been hidden for confidentiality reasons. You may continue to search on a tax ID number and return debtors that match your search criteria. The SSN/FEIN must be entered without dashes or spaces.","searchMustHaveOneOf":["search","UCC_FARM_PRODUCT_ID","COUNTY"],"searchPlaceholder":"Search by debtor name","advancedSearchParameters":[{"type":"ServerMultiComplete","label":"Product code name(s)","name":"UCC_FARM_PRODUCT_ID","defaultValue":"","optionsSrc":"UCC_FARM_PRODUCT_V"},{"type":"MultiComplete","label":"Year or Range of Years","name":"YEAR_NUM","optionsSrc":"years","startYear":"1968","defaultValue":[],"preMergeOptions":[{"value":"ALL","label":"All"}]},{"type":"serverSelect","label":"State","name":"STATE","defaultValue":"MONTANA","optionsSrc":"STATE"},{"type":"ServerMultiComplete","label":"County","name":"COUNTY","defaultValue":[],"optionsSrc":"COUNTY","overrideSubOptionsSrcFromParameterName":"STATE"},{"type":"checkbox","name":"TIN_SEARCH_YN","defaultValue":false,"label":"Tax Identification Number Search"},{"type":"checkbox","name":"TIN_SORT_YN","defaultValue":false,"label":"Unique ID Sort"}]}],"SYSTEM_NICKNAME":"Online Services Portal","PAYMENT_METHODS":[{"type":"bypass"},{"type":"iTransact"}],"PAYMENT_ALLOW_AMEX":true,"SYSTEM_ID_LABEL":"System Id","DOUBLE_COLUMN_PUBLIC_LOGIN":true,"INTERNAL_USER_MANAGEMENT":true,"ALLOW_PUBLIC_JSON_IMPORT":false,"MAX_FILE_UPLOAD_SIZE":10000000,"REFUND_TEXT":"","RETURN_TO_HOME_ON_LOGOUT":true,"CURRENT_SOS_NAME":"Christi Jacobsen","LOGO_FILENAME":"mt-sos-logo.png","LOGO_ALT":"Christi Jacobsen, Montana Secretary of State","LOGO_FULL_WIDTH":true,"HOME_HIDE_AUTH_HINT":true,"HOME_TITLE":"Montana Secretary of State","CUSTOM_TAB_TITLE":"Official Montana","HOME_SUBTITLE":"Online Business Services","ENTITY_NAME_CONSENT_DESCRIPTION":"","ALLOW_USER_PROFILE_EDITING":true,"COMPARE_FOREIGN_NAME_IN_ENTITY_NAME_VALIDATION":true,"FOREIGN_NAME_FIELD_NAME":"KIMA_PARENT_NAME_INFO","LOGIN_TITLE":"Montana Secretary of State Online Filing Portal Login","PUBLIC_LOGIN_LABEL":"Username","REVERSE_LOGIN_COLUMNS":true,"LOGIN_SEAL_FILENAME":"seal_white.png","SEPARATE_USERNAME_AND_EMAIL":true,"CREATE_ACCOUNT_BUTTON_ALIGN_LEFT":true,"CREATE_ACCOUNT_BUTTON_TEXT":"CREATE AN ACCOUNT","PASSWORD_CUSTOM_ERROR_TEXT":"The password must meet all requirements","ACCOUNT_CREATED_MESSAGE":"Please check your email to verify your account to login and allow a few minutes for this message to arrive. Check your junk/spam folders if you do not find the email in your inbox.","PUBLIC_LOGIN_PLACEHOLDER":" ","DISABLE_DEFAULT_PAYMENT_RADIO":true,"CUSTOM_RESET_PASSWORD_ERROR_MESSAGE":"Username invalid - no account found","PUBLIC_LOGIN_CREATE_DESCRIPTION":"### Existing User:\n\n  - Enter your username and password to login.  \n\n\n  #### - OR -  \n\n\n\n  - Forgot password? Click 'Reset Password' and follow the prompts.\n  - Forgot username? Click 'Forgot Username' and follow the prompts.  \n\n\n  ### New User:\n  ","LOGIN_HELP_LINK":"https://sosmt.gov/business/how-do-i/","LOGIN_HELP_LINK_TEXT":"Need Help?","FORGOT_USERNAME_TEXT":"Forgot Username?","LOGIN_ACTIVE_DIRECTORY_TEXT":"State User Login","MULTIPLE_LOGIN_METHODS":true,"HAS_ACTIVE_DIRECTORY_LOGIN":true,"RESET_PASSWORD_WITH_USERNAME":true,"DOWNLOAD_LINK":true,"SHOW_USERNAME_ACCOUNT_CREATE":true,"SHOW_SCROLL_DOWN_ARROW":true,"SHOW_ADDRESS_ACCOUNT_CREATE":true,"TWO_COLUMN_ACCOUNT_CREATE":true,"RESET_PASSWORD_TIP":"A link to change your password has been sent to your email. Please allow a few minutes for this message to arrive. Please check your junk/spam folders if you do not find the email in your inbox.","FORGOT_PASSWORD_LINK_TEXT":"Reset Password","PHONE_NUMBER_OPTIONAL_ACCOUNT_CREATE":true,"SHOW_REQUIRED_INDICATOR_ACCOUNT_CREATE":true,"PASSWORD_REQUIREMENTS_ACCOUNT_CREATE":"\n    <ul>\n      <li>MUST contain at least 8 characters (12+ recommended)</li>\n      <li>MUST contain at least one uppercase letter.</li>\n      <li>MUST contain at least one lowercase letter.</li>\n      <li>MUST contain at least one number.</li>\n      <li>MUST contain at least one special character (!”#$%&'()*+,-./:;<=>?</li>\n    </ul>\n  ","ALLOW_CERTIFICATION_REQUEST":true,"ALLOW_PUBLIC_CERTIFICATE_REQUEST":true,"ALLOW_COPY_REQUEST":false,"ALLOW_CORRECTION_STYLING":true,"HIDE_DEPRECATION_WARNING":false,"AMEND_ROUTE_PUBLIC":true,"SEAL_FILENAME":"seal.png","SHOPPING_CART":true,"ALLOW_PAYMENT_UPDATE_WITH_EMPTY_CART":true,"RA_EMAIL":true,"RA_WEBSITE":true,"RA_NO_DEFAULT_TYPE":true,"RA_ADDRESS_LABEL":"Street Address","RA_TYPE_SELECTION_DEFAULT":true,"RA_DEFAULT_TYPE":"460","RA_OVERRIDE_TYPE_WITH_DEFAULT":true,"RA_PRINCIPAL_ADDRESS_AMS":true,"UPLOAD_AND_SUBMIT_HIDE_IF_ONE_OPTION":true,"PAYMENT_PROCESSING_MESSAGE":"Your payment is processing - Do not close your browser or click the back button","CHECKOUT_BUTTON_WHEN_PROCESSING_TEXT":"Processing","EFS_CROP_PICKER_NONE_LABEL":"Lien Duration","DISALLOWED_WIZARD_PIECES":["FormationLocale"],"REPEATER_SHOW_EDIT_BUTTON":true,"DATA_REQUEST_PAGE_TITLE":"Data Requests and Subscriptions","DATA_REQUEST_SIDEBAR_LABEL":"Data Requests & Subscriptions","LOGIN_REDIRECTS_TO_EPASS":false,"LOGIN_REDIRECTS_TO_ACTIVE_DIRECTORY":true,"LOGIN_ACTIVE_DIRECTORY_LINK":true,"FETCH_EDIT_USER_LINK":false,"LISTS_FETCH_AVAILABLE_LISTS":true,"POST_WIZARD_SUBMIT_REDIRECT_URL":"/","PIN_REQUEST_ATTESTATIONS":true,"PIN_REQUEST_DESCRIPTION":"Click **Request PIN** to have a new PIN sent to the account holder's email address on file.","OWNERSHIP_REQUEST_DESCRIPTION":"To become an **authorized user** of this record, a current **AUTHORIZED USER** will need to grant you access. To request access, click **Request Access** below.","PIN_REQUEST_SUCCESS_MESSAGE":"The PIN you have requested for this entity has been sent to the email associated with your user account.  You should receive the PIN in approximately 3-5 minutes, depending on your email service provider.","APOSTILLE_HEADER_LABEL":"Verification Information","APOSTILLE_NUMBER_LABEL":"Apostille/Authentication","APOSTILLE_CITY_STATE_OVERRIDE":"HELENA, MT","APOSTILLE_FILING_DATE_LABEL":"Issue Date","APOSTILLE_CITY_STATE_IN_CERTIFIED":true,"NOTARY_EXISTING_FILING":true,"ALLOW_REVOKE_OWN_ACCESS_ONLY":false,"HIDE_CANCEL_ON_ONETIME_DATA_REQUESTS":true,"DATA_REQUESTS_IN_SHOPPING_CART":true,"WQ_ALLOW_EDIT_PENDING_PAYMENT":true,"WQ_CONFIRM_ON_DELETE":true,"WQ_DELETE_CONFIRM_MESSAGE":"Deleting this filing will forfeit any money already paid to the Secretary of State. This action is permanent and cannot be undone, are you sure you would like to delete?","PASS_ITEM_GUIDS_ON_CHECKOUT":true,"FORM_REVISION_HISTORY":true,"CHECKOUT_DISCLAIMER":"By entering your credit card and/or checking account information you (i) state that **you are an authorized user** of the credit card and/or electronic check and that the associated information entered (e.g., account holder name, account number, billing address) is accurate, (ii) **you authorize payment processor to charge the amount you have requested** to your credit card and/or funding account, and (iii) **acknowledge if a charge is declined or reversed you may also be assessed a customary charge** by the payment processor for such transactions.","FARM_BILL_SEARCH_CONFIDENTIAL":"As a registered Farm Bill Buyer with the Montana Secretary of State’s office it is important to maintain the confidentiality of the information contained within the Farm Bill Master List. The Farm Bill Master List reflects personal data, such as Social Security Numbers, which are a key piece of personal identifiable information to assist you in determining the existence of a lien against a specific debtor. The distribution of this information beyond its intended purpose is strictly prohibited.\n\n**The debtor's tax identification number has been hidden for confidentiality reasons. You may continue to search on a tax ID number and return debtors that match your search criteria. The SSN/FEIN must be entered without dashes or spaces.  If you need access to the tax identification number to clearly identify the debtor, please contact the UCC unit at (406) 444-3665.**","VIEW_HISTORY_BUTTON_ALT_TEXT":"View Filings","WIZARD_ERROR_TITLE_MESSAGE":"Form Error","FARM_BILL_SEARCH_INTERACTIVE":true,"USE_FARM_BILL_API":true,"DISALLOW_ASSIGN_SELF_AS_RA":true,"DISALLOW_ASSIGN_SELF_AS_PRINCIPAL":true,"USE_TRADEMARK_OWNER_VALIDATION":true,"USE_ALTERNATIVE_FOREIGN_ADDRESS_LABELS":true,"MY_RECEIPTS_FILTER":[{"type":"dateRange","name":"DATE_RANGE","label":"Date range","defaultValue":{"start":null,"end":null}},{"type":"text","name":"REF_NUM","defaultValue":"","label":"Reference Number"},{"type":"text","name":"RECEIPT_NUM","defaultValue":"","label":"Receipt Id"},{"type":"text","name":"AMOUNT","defaultValue":"","label":"Amount"},{"type":"select","name":"TYPE","defaultValue":"","label":"Payment Type","options":[{"value":"","label":"All"},{"value":"CC","label":"Credit Card"},{"value":"Check","label":"Check"}]}],"MY_RECEIPTS_SHOW_IN_SIDEBAR":true,"SHOW_MY_RECEIPTS_HELPER_TEXT":true,"MY_RECEIPTS_HELPER_LABEL":"About Receipt Search","MY_RECEIPTS_HELPER_TEXT":"You can search for receipts based on their descriptions, including the items paid for on the receipt. Use the filters to search for or filter specific information.","FARM_BILL_SUBLINK":{"label":"Farm Bill","component":"FarmBill","parameter":"farm-bill","path":"/lists/farm-bill","sourceTypeId":0,"myRecordsSearch":false,"allowedRules":["/search/"],"disabled":true,"searchDescription":"To perform a search, enter a debtor name. Your search results may include: exact debtor name, variations of that name and any filing that includes your search criteria. Punctuation is ignored.\n\nYou can click on \"Advanced\" to refine your search. Under “Advanced” you can search by crop, year, county and SSN/FEIN. As a registered Farm Bill Buyer with the Montana Secretary of State’s office it is important to maintain the confidentiality of the information contained within the Farm Bill Master List. The Farm Bill Master List reflects personal data, such as Social Security Numbers, which are a key piece of personal identifiable information to assist you in determining the existence of a lien against a specific debtor. The distribution of this information beyond its intended purpose is strictly prohibited.\n\nThe debtor's tax identification number has been hidden for confidentiality reasons. You may continue to search on a tax ID number and return debtors that match your search criteria. The SSN/FEIN must be entered without dashes or spaces.","searchMustHaveOneOf":["search","UCC_FARM_PRODUCT_ID","COUNTY"],"searchPlaceholder":"Search by debtor name","advancedSearchParameters":[{"type":"ServerMultiComplete","label":"Product code name(s)","name":"UCC_FARM_PRODUCT_ID","defaultValue":"","optionsSrc":"UCC_FARM_PRODUCT_V"},{"type":"MultiComplete","label":"Year or Range of Years","name":"YEAR_NUM","optionsSrc":"years","startYear":"1968","defaultValue":[],"preMergeOptions":[{"value":"ALL","label":"All"}]},{"type":"serverSelect","label":"State","name":"STATE","defaultValue":"MONTANA","optionsSrc":"STATE"},{"type":"ServerMultiComplete","label":"County","name":"COUNTY","defaultValue":[],"optionsSrc":"COUNTY","overrideSubOptionsSrcFromParameterName":"STATE"},{"type":"checkbox","name":"TIN_SEARCH_YN","defaultValue":false,"label":"Tax Identification Number Search"},{"type":"checkbox","name":"TIN_SORT_YN","defaultValue":false,"label":"Unique ID Sort"}]},"ALLOW_ADDRESS_VALIDATION_BYPASS_OPTION":true,"DEFAULT_ADDRESS_VALIDATION_BYPASS_OPTION_CHECKED":true}).APOSTILLE_NUMBER_INPUT_LABEL;
	var APOSTILLE_INSTRUCTIONS = ({"NODE_ENV":"production","BUILD_DATE":"2025-08-27T15:15:31.687Z","BUILD_NUMBER":"Not Provided","GIT_VERSION":"v1.3.0-381-ga81e29b08","GIT_COMMIT_HASH":"a81e29b085c9268ffd96c78eb734365802722741","GIT_BRANCH":"beta","PUBLIC_URL":"","STATE_ABBR":"MT","STATE_NAME":"Montana","STATE_ORG_TITLE":"Secretary of State","LOGIN_HEADER_IMG_PATH":"","HOME_IMG_FILENAME":"montana.jpg","FAVICON_FILE_NAME":"favicon.ico","ALLOW_E_SIGN_ON_CORRECTIONS":true,"THIRD_PARTY_SIGNING_ALLOWED":false,"MY_ACCOUNT_SAVE_AND_CLOSE_BUTTON":true,"IE_DEPRECATED_MESSAGE":"Internet Explorer is not supported. Please select a supported browser below to access this website.","ADDITIONAL_ROUTES":{"dataRequests":true,"farmBill":true,"apostille":true,"externalHelp":"https://sosmt.gov/business/help-center/","systemAdministration":[{"title":"Saved Payments","parameter":"saved-payments","componentName":"SavedPayments"}]},"SUBROUTES":[{"label":"Business","component":"Business","parameter":"business","myWorkQueueSearch":false,"sourceTypeId":54,"searchMustHaveOneOf":["FILING_TYPE_ID","STATUS_ID","STATE","search"],"serverWebSearchDescription":true,"serverWorkQueueDescription":true,"serverMyRecordsDescription":true,"searchPlaceholder":"Search by name or filing number (X########)","allowEmptySearchTerm":true,"requestCertificateAlternateLabel":"Request Information","fileAmendmentButtonLabel":"Filing Actions","advancedSearchParameters":[{"type":"radio","name":"QUERY_TYPE_ID","defaultValue":1010,"options":[{"value":1010,"label":"Starts with"},{"value":1011,"label":"Contains"},{"value":1012,"label":" Word Contains"}]},{"type":"serverSelect","name":"FILING_TYPE_ID","optionsSrc":"FILING_TYPES","label":"Entity Type","placeholder":"All","defaultValue":"0"},{"type":"serverSelect","name":"FILING_SUBTYPE_ID","optionsSrc":"FILING_SUBTYPES","label":"Entity Subtype","overrideSubOptionsSrcFromParameterName":"FILING_TYPE_ID","placeholder":"All","defaultValue":"0"},{"type":"serverSelect","name":"STATUS_ID","optionsSrc":"FILING_STATUS_WITHOUT_ALL","label":"Status","placeholder":"All","defaultValue":"0"},{"type":"serverSelect","name":"STATE","optionsSrc":"STATE","label":"State","placeholder":"All","defaultValue":""},{"type":"serverSelect","name":"COUNTY","optionsSrc":"COUNTY_SUBOPTION","label":"County","overrideSubOptionsSrcFromParameterName":"STATE","placeholder":"All","defaultValue":""},{"type":"checkbox","name":"CRA_SEARCH_YN","defaultValue":false,"label":"Search by Registered Agent PID"},{"type":"dateRange","name":"FILING_DATE","label":"Registration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}},{"type":"dateRange","name":"EXPIRATION_DATE","label":"Expiration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}}],"myRecordsFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Active"},{"value":2,"label":"Inactive"},{"value":3,"label":"Pending"}]},{"type":"dateRange","name":"DATE_RANGE","label":"Date range","defaultValue":{"start":null,"end":null}}],"myWorkQueueFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Approved"},{"value":2,"label":"Pending Online Payment"},{"value":3,"label":"Pending Review"},{"value":4,"label":"Needs Correction"},{"value":5,"label":"Rejected"},{"value":6,"label":"Draft"}]},{"type":"dateRange","name":"DATE_RANGE","label":"Date range","defaultValue":{"start":null,"end":null}}]},{"label":"Notary","component":"Notary","parameter":"notary","sourceTypeId":850,"myWorkQueueSearch":false,"allowEmptySearchTerm":true,"requestCertificateAlternateLabel":"Download Certificate","fileAmendmentButtonLabel":"Filing Actions","hideNameRequestCertificate":true,"hideAddressRequestCertificate":true,"hideRecordUserManagment":true,"searchPlaceholder":"Search by name or commission number","searchMustHaveOneOf":["CITY","search","SERVICE_TYPE"],"advancedParametersStartOpen":true,"searchIsSortable":true,"advancedSearchParameters":[{"type":"radio","name":"STARTS_WITH_YN","defaultValue":false,"options":[{"value":true,"label":"Starts with"},{"value":false,"label":"Contains"}]},{"type":"checkbox","name":"ACTIVE_ONLY_YN","defaultValue":true,"label":"Active entities only"},{"type":"text","name":"CITY","defaultValue":"","label":"City"},{"type":"select","name":"SERVICE_TYPE","label":"Special Services Offered","defaultValue":0,"options":[{"value":0,"label":"(N/A)"},{"value":6165,"label":"In-Person Electronic Notarization (IPEN)"},{"value":6166,"label":"Remote Online Notarization (RON)"},{"value":6167,"label":"Mobile Notary Services"},{"value":6168,"label":"Remote Ink Notarization (RIN)"}]}]},{"label":"Apostille","component":"Apostille","parameter":"apostille","sourceTypeId":720,"myRecordsSearch":false,"myWorkQueueSearch":false,"disabled":false,"allowedRoutes":["/forms-manager/","/queue/","/forms/"]},{"label":"Liens","component":"UCC","parameter":"ucc","sourceTypeId":1999,"myRecordsSearch":true,"myWorkQueueSearch":true,"fileAmendmentButtonLabel":"Filing Actions","searchPlaceholder":"Search by name or file number","disabled":false,"serverWebSearchDescription":true,"myRecordsDescription":"","workQueueDescription":"","searchDescription":"","hideRecordUserManagment":true,"searchLiensCheckout":false,"advancedSearchParameters":[{"type":"radio","name":"STARTS_WITH_YN","defaultValue":false,"options":[{"value":true,"label":"Starts with"},{"value":false,"label":"Contains"}]},{"type":"select","name":"STATUS","defaultValue":"ALL","label":"Status","options":[{"value":"ACTIVE_UNLAPSED","label":"Active (unlapsed)"},{"value":"ACTIVE_LAPSED_UNLAPSED","label":"Active (lapsed and unlapsed)"}]},{"type":"text","name":"EXCLUDE_VALUES","label":"Exclude Debtor Names (comma separated list of names to exclude)","defaultValue":""},{"type":"dateRange","name":"FILING_DATE","label":"Financing Statement Date","defaultValue":{"start":null,"end":null}},{"type":"dateRange","name":"LAPSE_DATE","label":"Lapse Date","defaultValue":{"start":null,"end":null}},{"type":"text","name":"CITY","label":"Debtor City","defaultValue":""}],"myRecordsFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Approved"},{"value":2,"label":"Pending Online Payment"},{"value":3,"label":"Pending Review"}]},{"type":"select","name":"TYPE","defaultValue":0,"label":"Lien Type","options":[{"value":0,"label":"All"},{"value":1,"label":"UCC"},{"value":2,"label":"EFS"},{"value":3,"label":"Title 71"}]}],"myWorkQueueFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Approved"},{"value":2,"label":"Pending Online Payment"},{"value":3,"label":"Pending Review"},{"value":4,"label":"Pending Print and Mail"},{"value":5,"label":"Rejected"},{"value":6,"label":"Draft"}]},{"type":"select","name":"TYPE","defaultValue":0,"label":"Lien Type","options":[{"value":0,"label":"All"},{"value":1,"label":"UCC"},{"value":2,"label":"EFS"},{"value":3,"label":"Title 71"}]}]},{"label":"Copy Request","component":"copies","parameter":"copies","sourceTypeId":2001,"myRecordsSearch":false,"myWorkQueueSearch":false,"disabled":false,"allowedRoutes":["/forms-manager/","/queue/","/forms/"]},{"label":"Trademark","component":"Trademark","parameter":"trademark","sourceTypeId":810,"showRequestCertificate":true,"searchMustHaveOneOf":["search","EXPIRATION_DATE","FILING_DATE"],"allowEmptySearchTerm":true,"requestCertificateAlternateLabel":"Request Information","fileAmendmentButtonLabel":"Filing Actions","advancedSearchParameters":[{"type":"radio","name":"QUERY_TYPE_ID","defaultValue":1010,"options":[{"value":1010,"label":"Starts with"},{"value":1011,"label":"Contains"},{"value":1012,"label":" Word Contains"}]},{"type":"checkbox","name":"OWNER_SEARCH_YN","defaultValue":false,"label":"Search owners"},{"type":"radio","name":"SERVICE_MARK_YN","label":"Mark Type","defaultValue":"","options":[{"value":"","label":"All Marks"},{"value":"Y","label":"Service Mark"},{"value":"N","label":"Trademark"}]},{"type":"serverSelect","name":"STATUS_ID","optionsSrc":"TYPE_V|TRADEMARK_STATUS_TYPE","label":"Status","placeholder":"All","defaultValue":"0"},{"type":"select","name":"DESIGN_TYPE_ID","options":[{"value":0,"label":"All"},{"value":990,"label":"Words Only"},{"value":991,"label":"Design Only"},{"value":992,"label":"Words and Design"}],"label":"Design Type","defaultValue":"0"},{"type":"dateRange","name":"FILING_DATE","label":"Registered Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}},{"type":"dateRange","name":"EXPIRATION_DATE","label":"Expiration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}}]},{"label":"Business Info Request","component":"InfoRequests","parameter":"info-request","sourceTypeId":167,"allowedRoutes":["/forms-manager/","/queue/","/forms/"]},{"label":"Data Requests","component":"DataRequests","parameter":"data-request","sourceTypeId":0,"allowedRoutes":["/forms-manager/"]},{"label":"CRA","component":"CRA","parameter":"cra","sourceTypeId":157,"myRecordsSearch":false,"searchPlaceholder":"Search by name or registered agent number","allowedRoutes":["/forms-manager/","/forms/","/records/","/queue/","/search/"],"allowEmptySearchTerm":true,"fileAmendmentButtonLabel":"Filing Actions","advancedSearchParameters":[{"type":"radio","name":"QUERY_TYPE_ID","defaultValue":1010,"options":[{"value":1010,"label":"Starts with"},{"value":1011,"label":"Contains"},{"value":1012,"label":" Word Contains"}]},{"type":"dateRange","name":"CRA_DATE","label":"Registration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}},{"type":"select","name":"STATUS_ID","label":"Status","defaultValue":0,"options":[{"value":0,"label":"All"},{"value":121,"label":"Active"},{"value":122,"label":"Inactive"}]},{"type":"select","name":"AGENT_TYPE_ID","label":"Agent Type","defaultValue":0,"options":[{"value":0,"label":"All"},{"value":460,"label":"Registered Agent"},{"value":461,"label":"Commercial Registered Agent"}]}]},{"label":"Farm Bill","component":"FarmBill","parameter":"farm-bill","path":"/lists/farm-bill","sourceTypeId":0,"myRecordsSearch":false,"allowedRules":["/search/"],"disabled":true,"searchDescription":"To perform a search, enter a debtor name. Your search results may include: exact debtor name, variations of that name and any filing that includes your search criteria. Punctuation is ignored.\n\nYou can click on \"Advanced\" to refine your search. Under “Advanced” you can search by crop, year, county and SSN/FEIN. As a registered Farm Bill Buyer with the Montana Secretary of State’s office it is important to maintain the confidentiality of the information contained within the Farm Bill Master List. The Farm Bill Master List reflects personal data, such as Social Security Numbers, which are a key piece of personal identifiable information to assist you in determining the existence of a lien against a specific debtor. The distribution of this information beyond its intended purpose is strictly prohibited.\n\nThe debtor's tax identification number has been hidden for confidentiality reasons. You may continue to search on a tax ID number and return debtors that match your search criteria. The SSN/FEIN must be entered without dashes or spaces.","searchMustHaveOneOf":["search","UCC_FARM_PRODUCT_ID","COUNTY"],"searchPlaceholder":"Search by debtor name","advancedSearchParameters":[{"type":"ServerMultiComplete","label":"Product code name(s)","name":"UCC_FARM_PRODUCT_ID","defaultValue":"","optionsSrc":"UCC_FARM_PRODUCT_V"},{"type":"MultiComplete","label":"Year or Range of Years","name":"YEAR_NUM","optionsSrc":"years","startYear":"1968","defaultValue":[],"preMergeOptions":[{"value":"ALL","label":"All"}]},{"type":"serverSelect","label":"State","name":"STATE","defaultValue":"MONTANA","optionsSrc":"STATE"},{"type":"ServerMultiComplete","label":"County","name":"COUNTY","defaultValue":[],"optionsSrc":"COUNTY","overrideSubOptionsSrcFromParameterName":"STATE"},{"type":"checkbox","name":"TIN_SEARCH_YN","defaultValue":false,"label":"Tax Identification Number Search"},{"type":"checkbox","name":"TIN_SORT_YN","defaultValue":false,"label":"Unique ID Sort"}]}],"SYSTEM_NICKNAME":"Online Services Portal","PAYMENT_METHODS":[{"type":"bypass"},{"type":"iTransact"}],"PAYMENT_ALLOW_AMEX":true,"SYSTEM_ID_LABEL":"System Id","DOUBLE_COLUMN_PUBLIC_LOGIN":true,"INTERNAL_USER_MANAGEMENT":true,"ALLOW_PUBLIC_JSON_IMPORT":false,"MAX_FILE_UPLOAD_SIZE":10000000,"REFUND_TEXT":"","RETURN_TO_HOME_ON_LOGOUT":true,"CURRENT_SOS_NAME":"Christi Jacobsen","LOGO_FILENAME":"mt-sos-logo.png","LOGO_ALT":"Christi Jacobsen, Montana Secretary of State","LOGO_FULL_WIDTH":true,"HOME_HIDE_AUTH_HINT":true,"HOME_TITLE":"Montana Secretary of State","CUSTOM_TAB_TITLE":"Official Montana","HOME_SUBTITLE":"Online Business Services","ENTITY_NAME_CONSENT_DESCRIPTION":"","ALLOW_USER_PROFILE_EDITING":true,"COMPARE_FOREIGN_NAME_IN_ENTITY_NAME_VALIDATION":true,"FOREIGN_NAME_FIELD_NAME":"KIMA_PARENT_NAME_INFO","LOGIN_TITLE":"Montana Secretary of State Online Filing Portal Login","PUBLIC_LOGIN_LABEL":"Username","REVERSE_LOGIN_COLUMNS":true,"LOGIN_SEAL_FILENAME":"seal_white.png","SEPARATE_USERNAME_AND_EMAIL":true,"CREATE_ACCOUNT_BUTTON_ALIGN_LEFT":true,"CREATE_ACCOUNT_BUTTON_TEXT":"CREATE AN ACCOUNT","PASSWORD_CUSTOM_ERROR_TEXT":"The password must meet all requirements","ACCOUNT_CREATED_MESSAGE":"Please check your email to verify your account to login and allow a few minutes for this message to arrive. Check your junk/spam folders if you do not find the email in your inbox.","PUBLIC_LOGIN_PLACEHOLDER":" ","DISABLE_DEFAULT_PAYMENT_RADIO":true,"CUSTOM_RESET_PASSWORD_ERROR_MESSAGE":"Username invalid - no account found","PUBLIC_LOGIN_CREATE_DESCRIPTION":"### Existing User:\n\n  - Enter your username and password to login.  \n\n\n  #### - OR -  \n\n\n\n  - Forgot password? Click 'Reset Password' and follow the prompts.\n  - Forgot username? Click 'Forgot Username' and follow the prompts.  \n\n\n  ### New User:\n  ","LOGIN_HELP_LINK":"https://sosmt.gov/business/how-do-i/","LOGIN_HELP_LINK_TEXT":"Need Help?","FORGOT_USERNAME_TEXT":"Forgot Username?","LOGIN_ACTIVE_DIRECTORY_TEXT":"State User Login","MULTIPLE_LOGIN_METHODS":true,"HAS_ACTIVE_DIRECTORY_LOGIN":true,"RESET_PASSWORD_WITH_USERNAME":true,"DOWNLOAD_LINK":true,"SHOW_USERNAME_ACCOUNT_CREATE":true,"SHOW_SCROLL_DOWN_ARROW":true,"SHOW_ADDRESS_ACCOUNT_CREATE":true,"TWO_COLUMN_ACCOUNT_CREATE":true,"RESET_PASSWORD_TIP":"A link to change your password has been sent to your email. Please allow a few minutes for this message to arrive. Please check your junk/spam folders if you do not find the email in your inbox.","FORGOT_PASSWORD_LINK_TEXT":"Reset Password","PHONE_NUMBER_OPTIONAL_ACCOUNT_CREATE":true,"SHOW_REQUIRED_INDICATOR_ACCOUNT_CREATE":true,"PASSWORD_REQUIREMENTS_ACCOUNT_CREATE":"\n    <ul>\n      <li>MUST contain at least 8 characters (12+ recommended)</li>\n      <li>MUST contain at least one uppercase letter.</li>\n      <li>MUST contain at least one lowercase letter.</li>\n      <li>MUST contain at least one number.</li>\n      <li>MUST contain at least one special character (!”#$%&'()*+,-./:;<=>?</li>\n    </ul>\n  ","ALLOW_CERTIFICATION_REQUEST":true,"ALLOW_PUBLIC_CERTIFICATE_REQUEST":true,"ALLOW_COPY_REQUEST":false,"ALLOW_CORRECTION_STYLING":true,"HIDE_DEPRECATION_WARNING":false,"AMEND_ROUTE_PUBLIC":true,"SEAL_FILENAME":"seal.png","SHOPPING_CART":true,"ALLOW_PAYMENT_UPDATE_WITH_EMPTY_CART":true,"RA_EMAIL":true,"RA_WEBSITE":true,"RA_NO_DEFAULT_TYPE":true,"RA_ADDRESS_LABEL":"Street Address","RA_TYPE_SELECTION_DEFAULT":true,"RA_DEFAULT_TYPE":"460","RA_OVERRIDE_TYPE_WITH_DEFAULT":true,"RA_PRINCIPAL_ADDRESS_AMS":true,"UPLOAD_AND_SUBMIT_HIDE_IF_ONE_OPTION":true,"PAYMENT_PROCESSING_MESSAGE":"Your payment is processing - Do not close your browser or click the back button","CHECKOUT_BUTTON_WHEN_PROCESSING_TEXT":"Processing","EFS_CROP_PICKER_NONE_LABEL":"Lien Duration","DISALLOWED_WIZARD_PIECES":["FormationLocale"],"REPEATER_SHOW_EDIT_BUTTON":true,"DATA_REQUEST_PAGE_TITLE":"Data Requests and Subscriptions","DATA_REQUEST_SIDEBAR_LABEL":"Data Requests & Subscriptions","LOGIN_REDIRECTS_TO_EPASS":false,"LOGIN_REDIRECTS_TO_ACTIVE_DIRECTORY":true,"LOGIN_ACTIVE_DIRECTORY_LINK":true,"FETCH_EDIT_USER_LINK":false,"LISTS_FETCH_AVAILABLE_LISTS":true,"POST_WIZARD_SUBMIT_REDIRECT_URL":"/","PIN_REQUEST_ATTESTATIONS":true,"PIN_REQUEST_DESCRIPTION":"Click **Request PIN** to have a new PIN sent to the account holder's email address on file.","OWNERSHIP_REQUEST_DESCRIPTION":"To become an **authorized user** of this record, a current **AUTHORIZED USER** will need to grant you access. To request access, click **Request Access** below.","PIN_REQUEST_SUCCESS_MESSAGE":"The PIN you have requested for this entity has been sent to the email associated with your user account.  You should receive the PIN in approximately 3-5 minutes, depending on your email service provider.","APOSTILLE_HEADER_LABEL":"Verification Information","APOSTILLE_NUMBER_LABEL":"Apostille/Authentication","APOSTILLE_CITY_STATE_OVERRIDE":"HELENA, MT","APOSTILLE_FILING_DATE_LABEL":"Issue Date","APOSTILLE_CITY_STATE_IN_CERTIFIED":true,"NOTARY_EXISTING_FILING":true,"ALLOW_REVOKE_OWN_ACCESS_ONLY":false,"HIDE_CANCEL_ON_ONETIME_DATA_REQUESTS":true,"DATA_REQUESTS_IN_SHOPPING_CART":true,"WQ_ALLOW_EDIT_PENDING_PAYMENT":true,"WQ_CONFIRM_ON_DELETE":true,"WQ_DELETE_CONFIRM_MESSAGE":"Deleting this filing will forfeit any money already paid to the Secretary of State. This action is permanent and cannot be undone, are you sure you would like to delete?","PASS_ITEM_GUIDS_ON_CHECKOUT":true,"FORM_REVISION_HISTORY":true,"CHECKOUT_DISCLAIMER":"By entering your credit card and/or checking account information you (i) state that **you are an authorized user** of the credit card and/or electronic check and that the associated information entered (e.g., account holder name, account number, billing address) is accurate, (ii) **you authorize payment processor to charge the amount you have requested** to your credit card and/or funding account, and (iii) **acknowledge if a charge is declined or reversed you may also be assessed a customary charge** by the payment processor for such transactions.","FARM_BILL_SEARCH_CONFIDENTIAL":"As a registered Farm Bill Buyer with the Montana Secretary of State’s office it is important to maintain the confidentiality of the information contained within the Farm Bill Master List. The Farm Bill Master List reflects personal data, such as Social Security Numbers, which are a key piece of personal identifiable information to assist you in determining the existence of a lien against a specific debtor. The distribution of this information beyond its intended purpose is strictly prohibited.\n\n**The debtor's tax identification number has been hidden for confidentiality reasons. You may continue to search on a tax ID number and return debtors that match your search criteria. The SSN/FEIN must be entered without dashes or spaces.  If you need access to the tax identification number to clearly identify the debtor, please contact the UCC unit at (406) 444-3665.**","VIEW_HISTORY_BUTTON_ALT_TEXT":"View Filings","WIZARD_ERROR_TITLE_MESSAGE":"Form Error","FARM_BILL_SEARCH_INTERACTIVE":true,"USE_FARM_BILL_API":true,"DISALLOW_ASSIGN_SELF_AS_RA":true,"DISALLOW_ASSIGN_SELF_AS_PRINCIPAL":true,"USE_TRADEMARK_OWNER_VALIDATION":true,"USE_ALTERNATIVE_FOREIGN_ADDRESS_LABELS":true,"MY_RECEIPTS_FILTER":[{"type":"dateRange","name":"DATE_RANGE","label":"Date range","defaultValue":{"start":null,"end":null}},{"type":"text","name":"REF_NUM","defaultValue":"","label":"Reference Number"},{"type":"text","name":"RECEIPT_NUM","defaultValue":"","label":"Receipt Id"},{"type":"text","name":"AMOUNT","defaultValue":"","label":"Amount"},{"type":"select","name":"TYPE","defaultValue":"","label":"Payment Type","options":[{"value":"","label":"All"},{"value":"CC","label":"Credit Card"},{"value":"Check","label":"Check"}]}],"MY_RECEIPTS_SHOW_IN_SIDEBAR":true,"SHOW_MY_RECEIPTS_HELPER_TEXT":true,"MY_RECEIPTS_HELPER_LABEL":"About Receipt Search","MY_RECEIPTS_HELPER_TEXT":"You can search for receipts based on their descriptions, including the items paid for on the receipt. Use the filters to search for or filter specific information.","FARM_BILL_SUBLINK":{"label":"Farm Bill","component":"FarmBill","parameter":"farm-bill","path":"/lists/farm-bill","sourceTypeId":0,"myRecordsSearch":false,"allowedRules":["/search/"],"disabled":true,"searchDescription":"To perform a search, enter a debtor name. Your search results may include: exact debtor name, variations of that name and any filing that includes your search criteria. Punctuation is ignored.\n\nYou can click on \"Advanced\" to refine your search. Under “Advanced” you can search by crop, year, county and SSN/FEIN. As a registered Farm Bill Buyer with the Montana Secretary of State’s office it is important to maintain the confidentiality of the information contained within the Farm Bill Master List. The Farm Bill Master List reflects personal data, such as Social Security Numbers, which are a key piece of personal identifiable information to assist you in determining the existence of a lien against a specific debtor. The distribution of this information beyond its intended purpose is strictly prohibited.\n\nThe debtor's tax identification number has been hidden for confidentiality reasons. You may continue to search on a tax ID number and return debtors that match your search criteria. The SSN/FEIN must be entered without dashes or spaces.","searchMustHaveOneOf":["search","UCC_FARM_PRODUCT_ID","COUNTY"],"searchPlaceholder":"Search by debtor name","advancedSearchParameters":[{"type":"ServerMultiComplete","label":"Product code name(s)","name":"UCC_FARM_PRODUCT_ID","defaultValue":"","optionsSrc":"UCC_FARM_PRODUCT_V"},{"type":"MultiComplete","label":"Year or Range of Years","name":"YEAR_NUM","optionsSrc":"years","startYear":"1968","defaultValue":[],"preMergeOptions":[{"value":"ALL","label":"All"}]},{"type":"serverSelect","label":"State","name":"STATE","defaultValue":"MONTANA","optionsSrc":"STATE"},{"type":"ServerMultiComplete","label":"County","name":"COUNTY","defaultValue":[],"optionsSrc":"COUNTY","overrideSubOptionsSrcFromParameterName":"STATE"},{"type":"checkbox","name":"TIN_SEARCH_YN","defaultValue":false,"label":"Tax Identification Number Search"},{"type":"checkbox","name":"TIN_SORT_YN","defaultValue":false,"label":"Unique ID Sort"}]},"ALLOW_ADDRESS_VALIDATION_BYPASS_OPTION":true,"DEFAULT_ADDRESS_VALIDATION_BYPASS_OPTION_CHECKED":true}).APOSTILLE_INSTRUCTIONS;
	var APOSTILLE_CERTIFIED_DATE_INPUT = ({"NODE_ENV":"production","BUILD_DATE":"2025-08-27T15:15:31.687Z","BUILD_NUMBER":"Not Provided","GIT_VERSION":"v1.3.0-381-ga81e29b08","GIT_COMMIT_HASH":"a81e29b085c9268ffd96c78eb734365802722741","GIT_BRANCH":"beta","PUBLIC_URL":"","STATE_ABBR":"MT","STATE_NAME":"Montana","STATE_ORG_TITLE":"Secretary of State","LOGIN_HEADER_IMG_PATH":"","HOME_IMG_FILENAME":"montana.jpg","FAVICON_FILE_NAME":"favicon.ico","ALLOW_E_SIGN_ON_CORRECTIONS":true,"THIRD_PARTY_SIGNING_ALLOWED":false,"MY_ACCOUNT_SAVE_AND_CLOSE_BUTTON":true,"IE_DEPRECATED_MESSAGE":"Internet Explorer is not supported. Please select a supported browser below to access this website.","ADDITIONAL_ROUTES":{"dataRequests":true,"farmBill":true,"apostille":true,"externalHelp":"https://sosmt.gov/business/help-center/","systemAdministration":[{"title":"Saved Payments","parameter":"saved-payments","componentName":"SavedPayments"}]},"SUBROUTES":[{"label":"Business","component":"Business","parameter":"business","myWorkQueueSearch":false,"sourceTypeId":54,"searchMustHaveOneOf":["FILING_TYPE_ID","STATUS_ID","STATE","search"],"serverWebSearchDescription":true,"serverWorkQueueDescription":true,"serverMyRecordsDescription":true,"searchPlaceholder":"Search by name or filing number (X########)","allowEmptySearchTerm":true,"requestCertificateAlternateLabel":"Request Information","fileAmendmentButtonLabel":"Filing Actions","advancedSearchParameters":[{"type":"radio","name":"QUERY_TYPE_ID","defaultValue":1010,"options":[{"value":1010,"label":"Starts with"},{"value":1011,"label":"Contains"},{"value":1012,"label":" Word Contains"}]},{"type":"serverSelect","name":"FILING_TYPE_ID","optionsSrc":"FILING_TYPES","label":"Entity Type","placeholder":"All","defaultValue":"0"},{"type":"serverSelect","name":"FILING_SUBTYPE_ID","optionsSrc":"FILING_SUBTYPES","label":"Entity Subtype","overrideSubOptionsSrcFromParameterName":"FILING_TYPE_ID","placeholder":"All","defaultValue":"0"},{"type":"serverSelect","name":"STATUS_ID","optionsSrc":"FILING_STATUS_WITHOUT_ALL","label":"Status","placeholder":"All","defaultValue":"0"},{"type":"serverSelect","name":"STATE","optionsSrc":"STATE","label":"State","placeholder":"All","defaultValue":""},{"type":"serverSelect","name":"COUNTY","optionsSrc":"COUNTY_SUBOPTION","label":"County","overrideSubOptionsSrcFromParameterName":"STATE","placeholder":"All","defaultValue":""},{"type":"checkbox","name":"CRA_SEARCH_YN","defaultValue":false,"label":"Search by Registered Agent PID"},{"type":"dateRange","name":"FILING_DATE","label":"Registration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}},{"type":"dateRange","name":"EXPIRATION_DATE","label":"Expiration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}}],"myRecordsFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Active"},{"value":2,"label":"Inactive"},{"value":3,"label":"Pending"}]},{"type":"dateRange","name":"DATE_RANGE","label":"Date range","defaultValue":{"start":null,"end":null}}],"myWorkQueueFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Approved"},{"value":2,"label":"Pending Online Payment"},{"value":3,"label":"Pending Review"},{"value":4,"label":"Needs Correction"},{"value":5,"label":"Rejected"},{"value":6,"label":"Draft"}]},{"type":"dateRange","name":"DATE_RANGE","label":"Date range","defaultValue":{"start":null,"end":null}}]},{"label":"Notary","component":"Notary","parameter":"notary","sourceTypeId":850,"myWorkQueueSearch":false,"allowEmptySearchTerm":true,"requestCertificateAlternateLabel":"Download Certificate","fileAmendmentButtonLabel":"Filing Actions","hideNameRequestCertificate":true,"hideAddressRequestCertificate":true,"hideRecordUserManagment":true,"searchPlaceholder":"Search by name or commission number","searchMustHaveOneOf":["CITY","search","SERVICE_TYPE"],"advancedParametersStartOpen":true,"searchIsSortable":true,"advancedSearchParameters":[{"type":"radio","name":"STARTS_WITH_YN","defaultValue":false,"options":[{"value":true,"label":"Starts with"},{"value":false,"label":"Contains"}]},{"type":"checkbox","name":"ACTIVE_ONLY_YN","defaultValue":true,"label":"Active entities only"},{"type":"text","name":"CITY","defaultValue":"","label":"City"},{"type":"select","name":"SERVICE_TYPE","label":"Special Services Offered","defaultValue":0,"options":[{"value":0,"label":"(N/A)"},{"value":6165,"label":"In-Person Electronic Notarization (IPEN)"},{"value":6166,"label":"Remote Online Notarization (RON)"},{"value":6167,"label":"Mobile Notary Services"},{"value":6168,"label":"Remote Ink Notarization (RIN)"}]}]},{"label":"Apostille","component":"Apostille","parameter":"apostille","sourceTypeId":720,"myRecordsSearch":false,"myWorkQueueSearch":false,"disabled":false,"allowedRoutes":["/forms-manager/","/queue/","/forms/"]},{"label":"Liens","component":"UCC","parameter":"ucc","sourceTypeId":1999,"myRecordsSearch":true,"myWorkQueueSearch":true,"fileAmendmentButtonLabel":"Filing Actions","searchPlaceholder":"Search by name or file number","disabled":false,"serverWebSearchDescription":true,"myRecordsDescription":"","workQueueDescription":"","searchDescription":"","hideRecordUserManagment":true,"searchLiensCheckout":false,"advancedSearchParameters":[{"type":"radio","name":"STARTS_WITH_YN","defaultValue":false,"options":[{"value":true,"label":"Starts with"},{"value":false,"label":"Contains"}]},{"type":"select","name":"STATUS","defaultValue":"ALL","label":"Status","options":[{"value":"ACTIVE_UNLAPSED","label":"Active (unlapsed)"},{"value":"ACTIVE_LAPSED_UNLAPSED","label":"Active (lapsed and unlapsed)"}]},{"type":"text","name":"EXCLUDE_VALUES","label":"Exclude Debtor Names (comma separated list of names to exclude)","defaultValue":""},{"type":"dateRange","name":"FILING_DATE","label":"Financing Statement Date","defaultValue":{"start":null,"end":null}},{"type":"dateRange","name":"LAPSE_DATE","label":"Lapse Date","defaultValue":{"start":null,"end":null}},{"type":"text","name":"CITY","label":"Debtor City","defaultValue":""}],"myRecordsFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Approved"},{"value":2,"label":"Pending Online Payment"},{"value":3,"label":"Pending Review"}]},{"type":"select","name":"TYPE","defaultValue":0,"label":"Lien Type","options":[{"value":0,"label":"All"},{"value":1,"label":"UCC"},{"value":2,"label":"EFS"},{"value":3,"label":"Title 71"}]}],"myWorkQueueFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Approved"},{"value":2,"label":"Pending Online Payment"},{"value":3,"label":"Pending Review"},{"value":4,"label":"Pending Print and Mail"},{"value":5,"label":"Rejected"},{"value":6,"label":"Draft"}]},{"type":"select","name":"TYPE","defaultValue":0,"label":"Lien Type","options":[{"value":0,"label":"All"},{"value":1,"label":"UCC"},{"value":2,"label":"EFS"},{"value":3,"label":"Title 71"}]}]},{"label":"Copy Request","component":"copies","parameter":"copies","sourceTypeId":2001,"myRecordsSearch":false,"myWorkQueueSearch":false,"disabled":false,"allowedRoutes":["/forms-manager/","/queue/","/forms/"]},{"label":"Trademark","component":"Trademark","parameter":"trademark","sourceTypeId":810,"showRequestCertificate":true,"searchMustHaveOneOf":["search","EXPIRATION_DATE","FILING_DATE"],"allowEmptySearchTerm":true,"requestCertificateAlternateLabel":"Request Information","fileAmendmentButtonLabel":"Filing Actions","advancedSearchParameters":[{"type":"radio","name":"QUERY_TYPE_ID","defaultValue":1010,"options":[{"value":1010,"label":"Starts with"},{"value":1011,"label":"Contains"},{"value":1012,"label":" Word Contains"}]},{"type":"checkbox","name":"OWNER_SEARCH_YN","defaultValue":false,"label":"Search owners"},{"type":"radio","name":"SERVICE_MARK_YN","label":"Mark Type","defaultValue":"","options":[{"value":"","label":"All Marks"},{"value":"Y","label":"Service Mark"},{"value":"N","label":"Trademark"}]},{"type":"serverSelect","name":"STATUS_ID","optionsSrc":"TYPE_V|TRADEMARK_STATUS_TYPE","label":"Status","placeholder":"All","defaultValue":"0"},{"type":"select","name":"DESIGN_TYPE_ID","options":[{"value":0,"label":"All"},{"value":990,"label":"Words Only"},{"value":991,"label":"Design Only"},{"value":992,"label":"Words and Design"}],"label":"Design Type","defaultValue":"0"},{"type":"dateRange","name":"FILING_DATE","label":"Registered Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}},{"type":"dateRange","name":"EXPIRATION_DATE","label":"Expiration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}}]},{"label":"Business Info Request","component":"InfoRequests","parameter":"info-request","sourceTypeId":167,"allowedRoutes":["/forms-manager/","/queue/","/forms/"]},{"label":"Data Requests","component":"DataRequests","parameter":"data-request","sourceTypeId":0,"allowedRoutes":["/forms-manager/"]},{"label":"CRA","component":"CRA","parameter":"cra","sourceTypeId":157,"myRecordsSearch":false,"searchPlaceholder":"Search by name or registered agent number","allowedRoutes":["/forms-manager/","/forms/","/records/","/queue/","/search/"],"allowEmptySearchTerm":true,"fileAmendmentButtonLabel":"Filing Actions","advancedSearchParameters":[{"type":"radio","name":"QUERY_TYPE_ID","defaultValue":1010,"options":[{"value":1010,"label":"Starts with"},{"value":1011,"label":"Contains"},{"value":1012,"label":" Word Contains"}]},{"type":"dateRange","name":"CRA_DATE","label":"Registration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}},{"type":"select","name":"STATUS_ID","label":"Status","defaultValue":0,"options":[{"value":0,"label":"All"},{"value":121,"label":"Active"},{"value":122,"label":"Inactive"}]},{"type":"select","name":"AGENT_TYPE_ID","label":"Agent Type","defaultValue":0,"options":[{"value":0,"label":"All"},{"value":460,"label":"Registered Agent"},{"value":461,"label":"Commercial Registered Agent"}]}]},{"label":"Farm Bill","component":"FarmBill","parameter":"farm-bill","path":"/lists/farm-bill","sourceTypeId":0,"myRecordsSearch":false,"allowedRules":["/search/"],"disabled":true,"searchDescription":"To perform a search, enter a debtor name. Your search results may include: exact debtor name, variations of that name and any filing that includes your search criteria. Punctuation is ignored.\n\nYou can click on \"Advanced\" to refine your search. Under “Advanced” you can search by crop, year, county and SSN/FEIN. As a registered Farm Bill Buyer with the Montana Secretary of State’s office it is important to maintain the confidentiality of the information contained within the Farm Bill Master List. The Farm Bill Master List reflects personal data, such as Social Security Numbers, which are a key piece of personal identifiable information to assist you in determining the existence of a lien against a specific debtor. The distribution of this information beyond its intended purpose is strictly prohibited.\n\nThe debtor's tax identification number has been hidden for confidentiality reasons. You may continue to search on a tax ID number and return debtors that match your search criteria. The SSN/FEIN must be entered without dashes or spaces.","searchMustHaveOneOf":["search","UCC_FARM_PRODUCT_ID","COUNTY"],"searchPlaceholder":"Search by debtor name","advancedSearchParameters":[{"type":"ServerMultiComplete","label":"Product code name(s)","name":"UCC_FARM_PRODUCT_ID","defaultValue":"","optionsSrc":"UCC_FARM_PRODUCT_V"},{"type":"MultiComplete","label":"Year or Range of Years","name":"YEAR_NUM","optionsSrc":"years","startYear":"1968","defaultValue":[],"preMergeOptions":[{"value":"ALL","label":"All"}]},{"type":"serverSelect","label":"State","name":"STATE","defaultValue":"MONTANA","optionsSrc":"STATE"},{"type":"ServerMultiComplete","label":"County","name":"COUNTY","defaultValue":[],"optionsSrc":"COUNTY","overrideSubOptionsSrcFromParameterName":"STATE"},{"type":"checkbox","name":"TIN_SEARCH_YN","defaultValue":false,"label":"Tax Identification Number Search"},{"type":"checkbox","name":"TIN_SORT_YN","defaultValue":false,"label":"Unique ID Sort"}]}],"SYSTEM_NICKNAME":"Online Services Portal","PAYMENT_METHODS":[{"type":"bypass"},{"type":"iTransact"}],"PAYMENT_ALLOW_AMEX":true,"SYSTEM_ID_LABEL":"System Id","DOUBLE_COLUMN_PUBLIC_LOGIN":true,"INTERNAL_USER_MANAGEMENT":true,"ALLOW_PUBLIC_JSON_IMPORT":false,"MAX_FILE_UPLOAD_SIZE":10000000,"REFUND_TEXT":"","RETURN_TO_HOME_ON_LOGOUT":true,"CURRENT_SOS_NAME":"Christi Jacobsen","LOGO_FILENAME":"mt-sos-logo.png","LOGO_ALT":"Christi Jacobsen, Montana Secretary of State","LOGO_FULL_WIDTH":true,"HOME_HIDE_AUTH_HINT":true,"HOME_TITLE":"Montana Secretary of State","CUSTOM_TAB_TITLE":"Official Montana","HOME_SUBTITLE":"Online Business Services","ENTITY_NAME_CONSENT_DESCRIPTION":"","ALLOW_USER_PROFILE_EDITING":true,"COMPARE_FOREIGN_NAME_IN_ENTITY_NAME_VALIDATION":true,"FOREIGN_NAME_FIELD_NAME":"KIMA_PARENT_NAME_INFO","LOGIN_TITLE":"Montana Secretary of State Online Filing Portal Login","PUBLIC_LOGIN_LABEL":"Username","REVERSE_LOGIN_COLUMNS":true,"LOGIN_SEAL_FILENAME":"seal_white.png","SEPARATE_USERNAME_AND_EMAIL":true,"CREATE_ACCOUNT_BUTTON_ALIGN_LEFT":true,"CREATE_ACCOUNT_BUTTON_TEXT":"CREATE AN ACCOUNT","PASSWORD_CUSTOM_ERROR_TEXT":"The password must meet all requirements","ACCOUNT_CREATED_MESSAGE":"Please check your email to verify your account to login and allow a few minutes for this message to arrive. Check your junk/spam folders if you do not find the email in your inbox.","PUBLIC_LOGIN_PLACEHOLDER":" ","DISABLE_DEFAULT_PAYMENT_RADIO":true,"CUSTOM_RESET_PASSWORD_ERROR_MESSAGE":"Username invalid - no account found","PUBLIC_LOGIN_CREATE_DESCRIPTION":"### Existing User:\n\n  - Enter your username and password to login.  \n\n\n  #### - OR -  \n\n\n\n  - Forgot password? Click 'Reset Password' and follow the prompts.\n  - Forgot username? Click 'Forgot Username' and follow the prompts.  \n\n\n  ### New User:\n  ","LOGIN_HELP_LINK":"https://sosmt.gov/business/how-do-i/","LOGIN_HELP_LINK_TEXT":"Need Help?","FORGOT_USERNAME_TEXT":"Forgot Username?","LOGIN_ACTIVE_DIRECTORY_TEXT":"State User Login","MULTIPLE_LOGIN_METHODS":true,"HAS_ACTIVE_DIRECTORY_LOGIN":true,"RESET_PASSWORD_WITH_USERNAME":true,"DOWNLOAD_LINK":true,"SHOW_USERNAME_ACCOUNT_CREATE":true,"SHOW_SCROLL_DOWN_ARROW":true,"SHOW_ADDRESS_ACCOUNT_CREATE":true,"TWO_COLUMN_ACCOUNT_CREATE":true,"RESET_PASSWORD_TIP":"A link to change your password has been sent to your email. Please allow a few minutes for this message to arrive. Please check your junk/spam folders if you do not find the email in your inbox.","FORGOT_PASSWORD_LINK_TEXT":"Reset Password","PHONE_NUMBER_OPTIONAL_ACCOUNT_CREATE":true,"SHOW_REQUIRED_INDICATOR_ACCOUNT_CREATE":true,"PASSWORD_REQUIREMENTS_ACCOUNT_CREATE":"\n    <ul>\n      <li>MUST contain at least 8 characters (12+ recommended)</li>\n      <li>MUST contain at least one uppercase letter.</li>\n      <li>MUST contain at least one lowercase letter.</li>\n      <li>MUST contain at least one number.</li>\n      <li>MUST contain at least one special character (!”#$%&'()*+,-./:;<=>?</li>\n    </ul>\n  ","ALLOW_CERTIFICATION_REQUEST":true,"ALLOW_PUBLIC_CERTIFICATE_REQUEST":true,"ALLOW_COPY_REQUEST":false,"ALLOW_CORRECTION_STYLING":true,"HIDE_DEPRECATION_WARNING":false,"AMEND_ROUTE_PUBLIC":true,"SEAL_FILENAME":"seal.png","SHOPPING_CART":true,"ALLOW_PAYMENT_UPDATE_WITH_EMPTY_CART":true,"RA_EMAIL":true,"RA_WEBSITE":true,"RA_NO_DEFAULT_TYPE":true,"RA_ADDRESS_LABEL":"Street Address","RA_TYPE_SELECTION_DEFAULT":true,"RA_DEFAULT_TYPE":"460","RA_OVERRIDE_TYPE_WITH_DEFAULT":true,"RA_PRINCIPAL_ADDRESS_AMS":true,"UPLOAD_AND_SUBMIT_HIDE_IF_ONE_OPTION":true,"PAYMENT_PROCESSING_MESSAGE":"Your payment is processing - Do not close your browser or click the back button","CHECKOUT_BUTTON_WHEN_PROCESSING_TEXT":"Processing","EFS_CROP_PICKER_NONE_LABEL":"Lien Duration","DISALLOWED_WIZARD_PIECES":["FormationLocale"],"REPEATER_SHOW_EDIT_BUTTON":true,"DATA_REQUEST_PAGE_TITLE":"Data Requests and Subscriptions","DATA_REQUEST_SIDEBAR_LABEL":"Data Requests & Subscriptions","LOGIN_REDIRECTS_TO_EPASS":false,"LOGIN_REDIRECTS_TO_ACTIVE_DIRECTORY":true,"LOGIN_ACTIVE_DIRECTORY_LINK":true,"FETCH_EDIT_USER_LINK":false,"LISTS_FETCH_AVAILABLE_LISTS":true,"POST_WIZARD_SUBMIT_REDIRECT_URL":"/","PIN_REQUEST_ATTESTATIONS":true,"PIN_REQUEST_DESCRIPTION":"Click **Request PIN** to have a new PIN sent to the account holder's email address on file.","OWNERSHIP_REQUEST_DESCRIPTION":"To become an **authorized user** of this record, a current **AUTHORIZED USER** will need to grant you access. To request access, click **Request Access** below.","PIN_REQUEST_SUCCESS_MESSAGE":"The PIN you have requested for this entity has been sent to the email associated with your user account.  You should receive the PIN in approximately 3-5 minutes, depending on your email service provider.","APOSTILLE_HEADER_LABEL":"Verification Information","APOSTILLE_NUMBER_LABEL":"Apostille/Authentication","APOSTILLE_CITY_STATE_OVERRIDE":"HELENA, MT","APOSTILLE_FILING_DATE_LABEL":"Issue Date","APOSTILLE_CITY_STATE_IN_CERTIFIED":true,"NOTARY_EXISTING_FILING":true,"ALLOW_REVOKE_OWN_ACCESS_ONLY":false,"HIDE_CANCEL_ON_ONETIME_DATA_REQUESTS":true,"DATA_REQUESTS_IN_SHOPPING_CART":true,"WQ_ALLOW_EDIT_PENDING_PAYMENT":true,"WQ_CONFIRM_ON_DELETE":true,"WQ_DELETE_CONFIRM_MESSAGE":"Deleting this filing will forfeit any money already paid to the Secretary of State. This action is permanent and cannot be undone, are you sure you would like to delete?","PASS_ITEM_GUIDS_ON_CHECKOUT":true,"FORM_REVISION_HISTORY":true,"CHECKOUT_DISCLAIMER":"By entering your credit card and/or checking account information you (i) state that **you are an authorized user** of the credit card and/or electronic check and that the associated information entered (e.g., account holder name, account number, billing address) is accurate, (ii) **you authorize payment processor to charge the amount you have requested** to your credit card and/or funding account, and (iii) **acknowledge if a charge is declined or reversed you may also be assessed a customary charge** by the payment processor for such transactions.","FARM_BILL_SEARCH_CONFIDENTIAL":"As a registered Farm Bill Buyer with the Montana Secretary of State’s office it is important to maintain the confidentiality of the information contained within the Farm Bill Master List. The Farm Bill Master List reflects personal data, such as Social Security Numbers, which are a key piece of personal identifiable information to assist you in determining the existence of a lien against a specific debtor. The distribution of this information beyond its intended purpose is strictly prohibited.\n\n**The debtor's tax identification number has been hidden for confidentiality reasons. You may continue to search on a tax ID number and return debtors that match your search criteria. The SSN/FEIN must be entered without dashes or spaces.  If you need access to the tax identification number to clearly identify the debtor, please contact the UCC unit at (406) 444-3665.**","VIEW_HISTORY_BUTTON_ALT_TEXT":"View Filings","WIZARD_ERROR_TITLE_MESSAGE":"Form Error","FARM_BILL_SEARCH_INTERACTIVE":true,"USE_FARM_BILL_API":true,"DISALLOW_ASSIGN_SELF_AS_RA":true,"DISALLOW_ASSIGN_SELF_AS_PRINCIPAL":true,"USE_TRADEMARK_OWNER_VALIDATION":true,"USE_ALTERNATIVE_FOREIGN_ADDRESS_LABELS":true,"MY_RECEIPTS_FILTER":[{"type":"dateRange","name":"DATE_RANGE","label":"Date range","defaultValue":{"start":null,"end":null}},{"type":"text","name":"REF_NUM","defaultValue":"","label":"Reference Number"},{"type":"text","name":"RECEIPT_NUM","defaultValue":"","label":"Receipt Id"},{"type":"text","name":"AMOUNT","defaultValue":"","label":"Amount"},{"type":"select","name":"TYPE","defaultValue":"","label":"Payment Type","options":[{"value":"","label":"All"},{"value":"CC","label":"Credit Card"},{"value":"Check","label":"Check"}]}],"MY_RECEIPTS_SHOW_IN_SIDEBAR":true,"SHOW_MY_RECEIPTS_HELPER_TEXT":true,"MY_RECEIPTS_HELPER_LABEL":"About Receipt Search","MY_RECEIPTS_HELPER_TEXT":"You can search for receipts based on their descriptions, including the items paid for on the receipt. Use the filters to search for or filter specific information.","FARM_BILL_SUBLINK":{"label":"Farm Bill","component":"FarmBill","parameter":"farm-bill","path":"/lists/farm-bill","sourceTypeId":0,"myRecordsSearch":false,"allowedRules":["/search/"],"disabled":true,"searchDescription":"To perform a search, enter a debtor name. Your search results may include: exact debtor name, variations of that name and any filing that includes your search criteria. Punctuation is ignored.\n\nYou can click on \"Advanced\" to refine your search. Under “Advanced” you can search by crop, year, county and SSN/FEIN. As a registered Farm Bill Buyer with the Montana Secretary of State’s office it is important to maintain the confidentiality of the information contained within the Farm Bill Master List. The Farm Bill Master List reflects personal data, such as Social Security Numbers, which are a key piece of personal identifiable information to assist you in determining the existence of a lien against a specific debtor. The distribution of this information beyond its intended purpose is strictly prohibited.\n\nThe debtor's tax identification number has been hidden for confidentiality reasons. You may continue to search on a tax ID number and return debtors that match your search criteria. The SSN/FEIN must be entered without dashes or spaces.","searchMustHaveOneOf":["search","UCC_FARM_PRODUCT_ID","COUNTY"],"searchPlaceholder":"Search by debtor name","advancedSearchParameters":[{"type":"ServerMultiComplete","label":"Product code name(s)","name":"UCC_FARM_PRODUCT_ID","defaultValue":"","optionsSrc":"UCC_FARM_PRODUCT_V"},{"type":"MultiComplete","label":"Year or Range of Years","name":"YEAR_NUM","optionsSrc":"years","startYear":"1968","defaultValue":[],"preMergeOptions":[{"value":"ALL","label":"All"}]},{"type":"serverSelect","label":"State","name":"STATE","defaultValue":"MONTANA","optionsSrc":"STATE"},{"type":"ServerMultiComplete","label":"County","name":"COUNTY","defaultValue":[],"optionsSrc":"COUNTY","overrideSubOptionsSrcFromParameterName":"STATE"},{"type":"checkbox","name":"TIN_SEARCH_YN","defaultValue":false,"label":"Tax Identification Number Search"},{"type":"checkbox","name":"TIN_SORT_YN","defaultValue":false,"label":"Unique ID Sort"}]},"ALLOW_ADDRESS_VALIDATION_BYPASS_OPTION":true,"DEFAULT_ADDRESS_VALIDATION_BYPASS_OPTION_CHECKED":true}).APOSTILLE_CERTIFIED_DATE_INPUT;
	var APOSTILLE_HIDE_FILING_DATE = ({"NODE_ENV":"production","BUILD_DATE":"2025-08-27T15:15:31.687Z","BUILD_NUMBER":"Not Provided","GIT_VERSION":"v1.3.0-381-ga81e29b08","GIT_COMMIT_HASH":"a81e29b085c9268ffd96c78eb734365802722741","GIT_BRANCH":"beta","PUBLIC_URL":"","STATE_ABBR":"MT","STATE_NAME":"Montana","STATE_ORG_TITLE":"Secretary of State","LOGIN_HEADER_IMG_PATH":"","HOME_IMG_FILENAME":"montana.jpg","FAVICON_FILE_NAME":"favicon.ico","ALLOW_E_SIGN_ON_CORRECTIONS":true,"THIRD_PARTY_SIGNING_ALLOWED":false,"MY_ACCOUNT_SAVE_AND_CLOSE_BUTTON":true,"IE_DEPRECATED_MESSAGE":"Internet Explorer is not supported. Please select a supported browser below to access this website.","ADDITIONAL_ROUTES":{"dataRequests":true,"farmBill":true,"apostille":true,"externalHelp":"https://sosmt.gov/business/help-center/","systemAdministration":[{"title":"Saved Payments","parameter":"saved-payments","componentName":"SavedPayments"}]},"SUBROUTES":[{"label":"Business","component":"Business","parameter":"business","myWorkQueueSearch":false,"sourceTypeId":54,"searchMustHaveOneOf":["FILING_TYPE_ID","STATUS_ID","STATE","search"],"serverWebSearchDescription":true,"serverWorkQueueDescription":true,"serverMyRecordsDescription":true,"searchPlaceholder":"Search by name or filing number (X########)","allowEmptySearchTerm":true,"requestCertificateAlternateLabel":"Request Information","fileAmendmentButtonLabel":"Filing Actions","advancedSearchParameters":[{"type":"radio","name":"QUERY_TYPE_ID","defaultValue":1010,"options":[{"value":1010,"label":"Starts with"},{"value":1011,"label":"Contains"},{"value":1012,"label":" Word Contains"}]},{"type":"serverSelect","name":"FILING_TYPE_ID","optionsSrc":"FILING_TYPES","label":"Entity Type","placeholder":"All","defaultValue":"0"},{"type":"serverSelect","name":"FILING_SUBTYPE_ID","optionsSrc":"FILING_SUBTYPES","label":"Entity Subtype","overrideSubOptionsSrcFromParameterName":"FILING_TYPE_ID","placeholder":"All","defaultValue":"0"},{"type":"serverSelect","name":"STATUS_ID","optionsSrc":"FILING_STATUS_WITHOUT_ALL","label":"Status","placeholder":"All","defaultValue":"0"},{"type":"serverSelect","name":"STATE","optionsSrc":"STATE","label":"State","placeholder":"All","defaultValue":""},{"type":"serverSelect","name":"COUNTY","optionsSrc":"COUNTY_SUBOPTION","label":"County","overrideSubOptionsSrcFromParameterName":"STATE","placeholder":"All","defaultValue":""},{"type":"checkbox","name":"CRA_SEARCH_YN","defaultValue":false,"label":"Search by Registered Agent PID"},{"type":"dateRange","name":"FILING_DATE","label":"Registration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}},{"type":"dateRange","name":"EXPIRATION_DATE","label":"Expiration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}}],"myRecordsFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Active"},{"value":2,"label":"Inactive"},{"value":3,"label":"Pending"}]},{"type":"dateRange","name":"DATE_RANGE","label":"Date range","defaultValue":{"start":null,"end":null}}],"myWorkQueueFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Approved"},{"value":2,"label":"Pending Online Payment"},{"value":3,"label":"Pending Review"},{"value":4,"label":"Needs Correction"},{"value":5,"label":"Rejected"},{"value":6,"label":"Draft"}]},{"type":"dateRange","name":"DATE_RANGE","label":"Date range","defaultValue":{"start":null,"end":null}}]},{"label":"Notary","component":"Notary","parameter":"notary","sourceTypeId":850,"myWorkQueueSearch":false,"allowEmptySearchTerm":true,"requestCertificateAlternateLabel":"Download Certificate","fileAmendmentButtonLabel":"Filing Actions","hideNameRequestCertificate":true,"hideAddressRequestCertificate":true,"hideRecordUserManagment":true,"searchPlaceholder":"Search by name or commission number","searchMustHaveOneOf":["CITY","search","SERVICE_TYPE"],"advancedParametersStartOpen":true,"searchIsSortable":true,"advancedSearchParameters":[{"type":"radio","name":"STARTS_WITH_YN","defaultValue":false,"options":[{"value":true,"label":"Starts with"},{"value":false,"label":"Contains"}]},{"type":"checkbox","name":"ACTIVE_ONLY_YN","defaultValue":true,"label":"Active entities only"},{"type":"text","name":"CITY","defaultValue":"","label":"City"},{"type":"select","name":"SERVICE_TYPE","label":"Special Services Offered","defaultValue":0,"options":[{"value":0,"label":"(N/A)"},{"value":6165,"label":"In-Person Electronic Notarization (IPEN)"},{"value":6166,"label":"Remote Online Notarization (RON)"},{"value":6167,"label":"Mobile Notary Services"},{"value":6168,"label":"Remote Ink Notarization (RIN)"}]}]},{"label":"Apostille","component":"Apostille","parameter":"apostille","sourceTypeId":720,"myRecordsSearch":false,"myWorkQueueSearch":false,"disabled":false,"allowedRoutes":["/forms-manager/","/queue/","/forms/"]},{"label":"Liens","component":"UCC","parameter":"ucc","sourceTypeId":1999,"myRecordsSearch":true,"myWorkQueueSearch":true,"fileAmendmentButtonLabel":"Filing Actions","searchPlaceholder":"Search by name or file number","disabled":false,"serverWebSearchDescription":true,"myRecordsDescription":"","workQueueDescription":"","searchDescription":"","hideRecordUserManagment":true,"searchLiensCheckout":false,"advancedSearchParameters":[{"type":"radio","name":"STARTS_WITH_YN","defaultValue":false,"options":[{"value":true,"label":"Starts with"},{"value":false,"label":"Contains"}]},{"type":"select","name":"STATUS","defaultValue":"ALL","label":"Status","options":[{"value":"ACTIVE_UNLAPSED","label":"Active (unlapsed)"},{"value":"ACTIVE_LAPSED_UNLAPSED","label":"Active (lapsed and unlapsed)"}]},{"type":"text","name":"EXCLUDE_VALUES","label":"Exclude Debtor Names (comma separated list of names to exclude)","defaultValue":""},{"type":"dateRange","name":"FILING_DATE","label":"Financing Statement Date","defaultValue":{"start":null,"end":null}},{"type":"dateRange","name":"LAPSE_DATE","label":"Lapse Date","defaultValue":{"start":null,"end":null}},{"type":"text","name":"CITY","label":"Debtor City","defaultValue":""}],"myRecordsFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Approved"},{"value":2,"label":"Pending Online Payment"},{"value":3,"label":"Pending Review"}]},{"type":"select","name":"TYPE","defaultValue":0,"label":"Lien Type","options":[{"value":0,"label":"All"},{"value":1,"label":"UCC"},{"value":2,"label":"EFS"},{"value":3,"label":"Title 71"}]}],"myWorkQueueFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Approved"},{"value":2,"label":"Pending Online Payment"},{"value":3,"label":"Pending Review"},{"value":4,"label":"Pending Print and Mail"},{"value":5,"label":"Rejected"},{"value":6,"label":"Draft"}]},{"type":"select","name":"TYPE","defaultValue":0,"label":"Lien Type","options":[{"value":0,"label":"All"},{"value":1,"label":"UCC"},{"value":2,"label":"EFS"},{"value":3,"label":"Title 71"}]}]},{"label":"Copy Request","component":"copies","parameter":"copies","sourceTypeId":2001,"myRecordsSearch":false,"myWorkQueueSearch":false,"disabled":false,"allowedRoutes":["/forms-manager/","/queue/","/forms/"]},{"label":"Trademark","component":"Trademark","parameter":"trademark","sourceTypeId":810,"showRequestCertificate":true,"searchMustHaveOneOf":["search","EXPIRATION_DATE","FILING_DATE"],"allowEmptySearchTerm":true,"requestCertificateAlternateLabel":"Request Information","fileAmendmentButtonLabel":"Filing Actions","advancedSearchParameters":[{"type":"radio","name":"QUERY_TYPE_ID","defaultValue":1010,"options":[{"value":1010,"label":"Starts with"},{"value":1011,"label":"Contains"},{"value":1012,"label":" Word Contains"}]},{"type":"checkbox","name":"OWNER_SEARCH_YN","defaultValue":false,"label":"Search owners"},{"type":"radio","name":"SERVICE_MARK_YN","label":"Mark Type","defaultValue":"","options":[{"value":"","label":"All Marks"},{"value":"Y","label":"Service Mark"},{"value":"N","label":"Trademark"}]},{"type":"serverSelect","name":"STATUS_ID","optionsSrc":"TYPE_V|TRADEMARK_STATUS_TYPE","label":"Status","placeholder":"All","defaultValue":"0"},{"type":"select","name":"DESIGN_TYPE_ID","options":[{"value":0,"label":"All"},{"value":990,"label":"Words Only"},{"value":991,"label":"Design Only"},{"value":992,"label":"Words and Design"}],"label":"Design Type","defaultValue":"0"},{"type":"dateRange","name":"FILING_DATE","label":"Registered Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}},{"type":"dateRange","name":"EXPIRATION_DATE","label":"Expiration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}}]},{"label":"Business Info Request","component":"InfoRequests","parameter":"info-request","sourceTypeId":167,"allowedRoutes":["/forms-manager/","/queue/","/forms/"]},{"label":"Data Requests","component":"DataRequests","parameter":"data-request","sourceTypeId":0,"allowedRoutes":["/forms-manager/"]},{"label":"CRA","component":"CRA","parameter":"cra","sourceTypeId":157,"myRecordsSearch":false,"searchPlaceholder":"Search by name or registered agent number","allowedRoutes":["/forms-manager/","/forms/","/records/","/queue/","/search/"],"allowEmptySearchTerm":true,"fileAmendmentButtonLabel":"Filing Actions","advancedSearchParameters":[{"type":"radio","name":"QUERY_TYPE_ID","defaultValue":1010,"options":[{"value":1010,"label":"Starts with"},{"value":1011,"label":"Contains"},{"value":1012,"label":" Word Contains"}]},{"type":"dateRange","name":"CRA_DATE","label":"Registration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}},{"type":"select","name":"STATUS_ID","label":"Status","defaultValue":0,"options":[{"value":0,"label":"All"},{"value":121,"label":"Active"},{"value":122,"label":"Inactive"}]},{"type":"select","name":"AGENT_TYPE_ID","label":"Agent Type","defaultValue":0,"options":[{"value":0,"label":"All"},{"value":460,"label":"Registered Agent"},{"value":461,"label":"Commercial Registered Agent"}]}]},{"label":"Farm Bill","component":"FarmBill","parameter":"farm-bill","path":"/lists/farm-bill","sourceTypeId":0,"myRecordsSearch":false,"allowedRules":["/search/"],"disabled":true,"searchDescription":"To perform a search, enter a debtor name. Your search results may include: exact debtor name, variations of that name and any filing that includes your search criteria. Punctuation is ignored.\n\nYou can click on \"Advanced\" to refine your search. Under “Advanced” you can search by crop, year, county and SSN/FEIN. As a registered Farm Bill Buyer with the Montana Secretary of State’s office it is important to maintain the confidentiality of the information contained within the Farm Bill Master List. The Farm Bill Master List reflects personal data, such as Social Security Numbers, which are a key piece of personal identifiable information to assist you in determining the existence of a lien against a specific debtor. The distribution of this information beyond its intended purpose is strictly prohibited.\n\nThe debtor's tax identification number has been hidden for confidentiality reasons. You may continue to search on a tax ID number and return debtors that match your search criteria. The SSN/FEIN must be entered without dashes or spaces.","searchMustHaveOneOf":["search","UCC_FARM_PRODUCT_ID","COUNTY"],"searchPlaceholder":"Search by debtor name","advancedSearchParameters":[{"type":"ServerMultiComplete","label":"Product code name(s)","name":"UCC_FARM_PRODUCT_ID","defaultValue":"","optionsSrc":"UCC_FARM_PRODUCT_V"},{"type":"MultiComplete","label":"Year or Range of Years","name":"YEAR_NUM","optionsSrc":"years","startYear":"1968","defaultValue":[],"preMergeOptions":[{"value":"ALL","label":"All"}]},{"type":"serverSelect","label":"State","name":"STATE","defaultValue":"MONTANA","optionsSrc":"STATE"},{"type":"ServerMultiComplete","label":"County","name":"COUNTY","defaultValue":[],"optionsSrc":"COUNTY","overrideSubOptionsSrcFromParameterName":"STATE"},{"type":"checkbox","name":"TIN_SEARCH_YN","defaultValue":false,"label":"Tax Identification Number Search"},{"type":"checkbox","name":"TIN_SORT_YN","defaultValue":false,"label":"Unique ID Sort"}]}],"SYSTEM_NICKNAME":"Online Services Portal","PAYMENT_METHODS":[{"type":"bypass"},{"type":"iTransact"}],"PAYMENT_ALLOW_AMEX":true,"SYSTEM_ID_LABEL":"System Id","DOUBLE_COLUMN_PUBLIC_LOGIN":true,"INTERNAL_USER_MANAGEMENT":true,"ALLOW_PUBLIC_JSON_IMPORT":false,"MAX_FILE_UPLOAD_SIZE":10000000,"REFUND_TEXT":"","RETURN_TO_HOME_ON_LOGOUT":true,"CURRENT_SOS_NAME":"Christi Jacobsen","LOGO_FILENAME":"mt-sos-logo.png","LOGO_ALT":"Christi Jacobsen, Montana Secretary of State","LOGO_FULL_WIDTH":true,"HOME_HIDE_AUTH_HINT":true,"HOME_TITLE":"Montana Secretary of State","CUSTOM_TAB_TITLE":"Official Montana","HOME_SUBTITLE":"Online Business Services","ENTITY_NAME_CONSENT_DESCRIPTION":"","ALLOW_USER_PROFILE_EDITING":true,"COMPARE_FOREIGN_NAME_IN_ENTITY_NAME_VALIDATION":true,"FOREIGN_NAME_FIELD_NAME":"KIMA_PARENT_NAME_INFO","LOGIN_TITLE":"Montana Secretary of State Online Filing Portal Login","PUBLIC_LOGIN_LABEL":"Username","REVERSE_LOGIN_COLUMNS":true,"LOGIN_SEAL_FILENAME":"seal_white.png","SEPARATE_USERNAME_AND_EMAIL":true,"CREATE_ACCOUNT_BUTTON_ALIGN_LEFT":true,"CREATE_ACCOUNT_BUTTON_TEXT":"CREATE AN ACCOUNT","PASSWORD_CUSTOM_ERROR_TEXT":"The password must meet all requirements","ACCOUNT_CREATED_MESSAGE":"Please check your email to verify your account to login and allow a few minutes for this message to arrive. Check your junk/spam folders if you do not find the email in your inbox.","PUBLIC_LOGIN_PLACEHOLDER":" ","DISABLE_DEFAULT_PAYMENT_RADIO":true,"CUSTOM_RESET_PASSWORD_ERROR_MESSAGE":"Username invalid - no account found","PUBLIC_LOGIN_CREATE_DESCRIPTION":"### Existing User:\n\n  - Enter your username and password to login.  \n\n\n  #### - OR -  \n\n\n\n  - Forgot password? Click 'Reset Password' and follow the prompts.\n  - Forgot username? Click 'Forgot Username' and follow the prompts.  \n\n\n  ### New User:\n  ","LOGIN_HELP_LINK":"https://sosmt.gov/business/how-do-i/","LOGIN_HELP_LINK_TEXT":"Need Help?","FORGOT_USERNAME_TEXT":"Forgot Username?","LOGIN_ACTIVE_DIRECTORY_TEXT":"State User Login","MULTIPLE_LOGIN_METHODS":true,"HAS_ACTIVE_DIRECTORY_LOGIN":true,"RESET_PASSWORD_WITH_USERNAME":true,"DOWNLOAD_LINK":true,"SHOW_USERNAME_ACCOUNT_CREATE":true,"SHOW_SCROLL_DOWN_ARROW":true,"SHOW_ADDRESS_ACCOUNT_CREATE":true,"TWO_COLUMN_ACCOUNT_CREATE":true,"RESET_PASSWORD_TIP":"A link to change your password has been sent to your email. Please allow a few minutes for this message to arrive. Please check your junk/spam folders if you do not find the email in your inbox.","FORGOT_PASSWORD_LINK_TEXT":"Reset Password","PHONE_NUMBER_OPTIONAL_ACCOUNT_CREATE":true,"SHOW_REQUIRED_INDICATOR_ACCOUNT_CREATE":true,"PASSWORD_REQUIREMENTS_ACCOUNT_CREATE":"\n    <ul>\n      <li>MUST contain at least 8 characters (12+ recommended)</li>\n      <li>MUST contain at least one uppercase letter.</li>\n      <li>MUST contain at least one lowercase letter.</li>\n      <li>MUST contain at least one number.</li>\n      <li>MUST contain at least one special character (!”#$%&'()*+,-./:;<=>?</li>\n    </ul>\n  ","ALLOW_CERTIFICATION_REQUEST":true,"ALLOW_PUBLIC_CERTIFICATE_REQUEST":true,"ALLOW_COPY_REQUEST":false,"ALLOW_CORRECTION_STYLING":true,"HIDE_DEPRECATION_WARNING":false,"AMEND_ROUTE_PUBLIC":true,"SEAL_FILENAME":"seal.png","SHOPPING_CART":true,"ALLOW_PAYMENT_UPDATE_WITH_EMPTY_CART":true,"RA_EMAIL":true,"RA_WEBSITE":true,"RA_NO_DEFAULT_TYPE":true,"RA_ADDRESS_LABEL":"Street Address","RA_TYPE_SELECTION_DEFAULT":true,"RA_DEFAULT_TYPE":"460","RA_OVERRIDE_TYPE_WITH_DEFAULT":true,"RA_PRINCIPAL_ADDRESS_AMS":true,"UPLOAD_AND_SUBMIT_HIDE_IF_ONE_OPTION":true,"PAYMENT_PROCESSING_MESSAGE":"Your payment is processing - Do not close your browser or click the back button","CHECKOUT_BUTTON_WHEN_PROCESSING_TEXT":"Processing","EFS_CROP_PICKER_NONE_LABEL":"Lien Duration","DISALLOWED_WIZARD_PIECES":["FormationLocale"],"REPEATER_SHOW_EDIT_BUTTON":true,"DATA_REQUEST_PAGE_TITLE":"Data Requests and Subscriptions","DATA_REQUEST_SIDEBAR_LABEL":"Data Requests & Subscriptions","LOGIN_REDIRECTS_TO_EPASS":false,"LOGIN_REDIRECTS_TO_ACTIVE_DIRECTORY":true,"LOGIN_ACTIVE_DIRECTORY_LINK":true,"FETCH_EDIT_USER_LINK":false,"LISTS_FETCH_AVAILABLE_LISTS":true,"POST_WIZARD_SUBMIT_REDIRECT_URL":"/","PIN_REQUEST_ATTESTATIONS":true,"PIN_REQUEST_DESCRIPTION":"Click **Request PIN** to have a new PIN sent to the account holder's email address on file.","OWNERSHIP_REQUEST_DESCRIPTION":"To become an **authorized user** of this record, a current **AUTHORIZED USER** will need to grant you access. To request access, click **Request Access** below.","PIN_REQUEST_SUCCESS_MESSAGE":"The PIN you have requested for this entity has been sent to the email associated with your user account.  You should receive the PIN in approximately 3-5 minutes, depending on your email service provider.","APOSTILLE_HEADER_LABEL":"Verification Information","APOSTILLE_NUMBER_LABEL":"Apostille/Authentication","APOSTILLE_CITY_STATE_OVERRIDE":"HELENA, MT","APOSTILLE_FILING_DATE_LABEL":"Issue Date","APOSTILLE_CITY_STATE_IN_CERTIFIED":true,"NOTARY_EXISTING_FILING":true,"ALLOW_REVOKE_OWN_ACCESS_ONLY":false,"HIDE_CANCEL_ON_ONETIME_DATA_REQUESTS":true,"DATA_REQUESTS_IN_SHOPPING_CART":true,"WQ_ALLOW_EDIT_PENDING_PAYMENT":true,"WQ_CONFIRM_ON_DELETE":true,"WQ_DELETE_CONFIRM_MESSAGE":"Deleting this filing will forfeit any money already paid to the Secretary of State. This action is permanent and cannot be undone, are you sure you would like to delete?","PASS_ITEM_GUIDS_ON_CHECKOUT":true,"FORM_REVISION_HISTORY":true,"CHECKOUT_DISCLAIMER":"By entering your credit card and/or checking account information you (i) state that **you are an authorized user** of the credit card and/or electronic check and that the associated information entered (e.g., account holder name, account number, billing address) is accurate, (ii) **you authorize payment processor to charge the amount you have requested** to your credit card and/or funding account, and (iii) **acknowledge if a charge is declined or reversed you may also be assessed a customary charge** by the payment processor for such transactions.","FARM_BILL_SEARCH_CONFIDENTIAL":"As a registered Farm Bill Buyer with the Montana Secretary of State’s office it is important to maintain the confidentiality of the information contained within the Farm Bill Master List. The Farm Bill Master List reflects personal data, such as Social Security Numbers, which are a key piece of personal identifiable information to assist you in determining the existence of a lien against a specific debtor. The distribution of this information beyond its intended purpose is strictly prohibited.\n\n**The debtor's tax identification number has been hidden for confidentiality reasons. You may continue to search on a tax ID number and return debtors that match your search criteria. The SSN/FEIN must be entered without dashes or spaces.  If you need access to the tax identification number to clearly identify the debtor, please contact the UCC unit at (406) 444-3665.**","VIEW_HISTORY_BUTTON_ALT_TEXT":"View Filings","WIZARD_ERROR_TITLE_MESSAGE":"Form Error","FARM_BILL_SEARCH_INTERACTIVE":true,"USE_FARM_BILL_API":true,"DISALLOW_ASSIGN_SELF_AS_RA":true,"DISALLOW_ASSIGN_SELF_AS_PRINCIPAL":true,"USE_TRADEMARK_OWNER_VALIDATION":true,"USE_ALTERNATIVE_FOREIGN_ADDRESS_LABELS":true,"MY_RECEIPTS_FILTER":[{"type":"dateRange","name":"DATE_RANGE","label":"Date range","defaultValue":{"start":null,"end":null}},{"type":"text","name":"REF_NUM","defaultValue":"","label":"Reference Number"},{"type":"text","name":"RECEIPT_NUM","defaultValue":"","label":"Receipt Id"},{"type":"text","name":"AMOUNT","defaultValue":"","label":"Amount"},{"type":"select","name":"TYPE","defaultValue":"","label":"Payment Type","options":[{"value":"","label":"All"},{"value":"CC","label":"Credit Card"},{"value":"Check","label":"Check"}]}],"MY_RECEIPTS_SHOW_IN_SIDEBAR":true,"SHOW_MY_RECEIPTS_HELPER_TEXT":true,"MY_RECEIPTS_HELPER_LABEL":"About Receipt Search","MY_RECEIPTS_HELPER_TEXT":"You can search for receipts based on their descriptions, including the items paid for on the receipt. Use the filters to search for or filter specific information.","FARM_BILL_SUBLINK":{"label":"Farm Bill","component":"FarmBill","parameter":"farm-bill","path":"/lists/farm-bill","sourceTypeId":0,"myRecordsSearch":false,"allowedRules":["/search/"],"disabled":true,"searchDescription":"To perform a search, enter a debtor name. Your search results may include: exact debtor name, variations of that name and any filing that includes your search criteria. Punctuation is ignored.\n\nYou can click on \"Advanced\" to refine your search. Under “Advanced” you can search by crop, year, county and SSN/FEIN. As a registered Farm Bill Buyer with the Montana Secretary of State’s office it is important to maintain the confidentiality of the information contained within the Farm Bill Master List. The Farm Bill Master List reflects personal data, such as Social Security Numbers, which are a key piece of personal identifiable information to assist you in determining the existence of a lien against a specific debtor. The distribution of this information beyond its intended purpose is strictly prohibited.\n\nThe debtor's tax identification number has been hidden for confidentiality reasons. You may continue to search on a tax ID number and return debtors that match your search criteria. The SSN/FEIN must be entered without dashes or spaces.","searchMustHaveOneOf":["search","UCC_FARM_PRODUCT_ID","COUNTY"],"searchPlaceholder":"Search by debtor name","advancedSearchParameters":[{"type":"ServerMultiComplete","label":"Product code name(s)","name":"UCC_FARM_PRODUCT_ID","defaultValue":"","optionsSrc":"UCC_FARM_PRODUCT_V"},{"type":"MultiComplete","label":"Year or Range of Years","name":"YEAR_NUM","optionsSrc":"years","startYear":"1968","defaultValue":[],"preMergeOptions":[{"value":"ALL","label":"All"}]},{"type":"serverSelect","label":"State","name":"STATE","defaultValue":"MONTANA","optionsSrc":"STATE"},{"type":"ServerMultiComplete","label":"County","name":"COUNTY","defaultValue":[],"optionsSrc":"COUNTY","overrideSubOptionsSrcFromParameterName":"STATE"},{"type":"checkbox","name":"TIN_SEARCH_YN","defaultValue":false,"label":"Tax Identification Number Search"},{"type":"checkbox","name":"TIN_SORT_YN","defaultValue":false,"label":"Unique ID Sort"}]},"ALLOW_ADDRESS_VALIDATION_BYPASS_OPTION":true,"DEFAULT_ADDRESS_VALIDATION_BYPASS_OPTION_CHECKED":true}).APOSTILLE_HIDE_FILING_DATE;
	var APOSTILLE_CITY_STATE_OVERRIDE = ("HELENA, MT");
	
	exports.default = function () {
	  var _React$useState = _react2.default.useState(null),
	      _React$useState2 = _slicedToArray(_React$useState, 2),
	      record = _React$useState2[0],
	      setRecord = _React$useState2[1];
	
	  var clearRecord = function clearRecord() {
	    return setRecord(null);
	  };
	
	  return _react2.default.createElement(
	    _Shell.Body,
	    { className: 'health-care-directive-page ' + (record ? 'record-detail-page' : '') },
	    record === null ? _react2.default.createElement(ApostilleLookUp, { onRecordReceived: function onRecordReceived(record) {
	        return setRecord(record);
	      } }) : _react2.default.createElement(FilingDetails, { onLoginRequest: clearRecord, record: record })
	  );
	};
	
	var ApostilleLookUp = function ApostilleLookUp(_ref) {
	  var onRecordReceived = _ref.onRecordReceived;
	
	  var _React$useState3 = _react2.default.useState(''),
	      _React$useState4 = _slicedToArray(_React$useState3, 2),
	      apostilleNum = _React$useState4[0],
	      setApostilleNum = _React$useState4[1];
	
	  var _React$useState5 = _react2.default.useState(''),
	      _React$useState6 = _slicedToArray(_React$useState5, 2),
	      apostilleDate = _React$useState6[0],
	      setApostilleDate = _React$useState6[1];
	
	  var _React$useState7 = _react2.default.useState({}),
	      _React$useState8 = _slicedToArray(_React$useState7, 2),
	      errors = _React$useState8[0],
	      setErrors = _React$useState8[1];
	
	  var _React$useState9 = _react2.default.useState(null),
	      _React$useState10 = _slicedToArray(_React$useState9, 2),
	      serverError = _React$useState10[0],
	      setServerError = _React$useState10[1];
	
	  var checkEnter = function checkEnter(e) {
	    if (e.charCode === 13) {
	      validate();
	    }
	  };
	  var validate = function validate() {
	    var errors = {};
	    if (!apostilleNum) {
	      errors.apostilleNum = 'A number is required.';
	    }
	    if (APOSTILLE_CERTIFIED_DATE_INPUT && !apostilleDate) {
	      errors.apostilleDate = 'A certified date is required.';
	    }
	    if (Object.keys(errors).length === 0) {
	      setErrors(errors);
	      submit();
	    } else {
	      setErrors(errors);
	    }
	  };
	  var submit = function submit() {
	    (0, _requests.GET_APOSTILLE_RECORD)(Object.assign({
	      APOSTILLE_NUM: apostilleNum
	    }, APOSTILLE_CERTIFIED_DATE_INPUT ? { CERTIFIED_DATE: apostilleDate } : {}), function (record) {
	      setServerError(null);
	      onRecordReceived(record);
	    }, function (err) {
	      setServerError(err.message);
	      console.error(err);
	    });
	  };
	  return _react2.default.createElement(_FormCard2.default, {
	    title: APOSTILLE_FORM_TITLE || 'Apostille & Authentication Verification',
	    seal: true,
	    leftColumn: _react2.default.createElement(
	      _react2.default.Fragment,
	      null,
	      _react2.default.createElement(
	        _Field.DumbField,
	        {
	          label: APOSTILLE_NUMBER_INPUT_LABEL || 'Apostille/Authentication Number',
	          fieldId: 'apostilleNum',
	          errorMessage: errors.apostilleNum ? [errors.apostilleNum] : []
	        },
	        _react2.default.createElement(_Form.TextInput, {
	          fieldId: 'apostilleNum',
	          value: apostilleNum,
	          onChange: function onChange(v) {
	            setApostilleNum(v);
	          },
	          onKeyPress: checkEnter
	        })
	      ),
	      APOSTILLE_CERTIFIED_DATE_INPUT && _react2.default.createElement(
	        _Field.DumbField,
	        {
	          className: 'certified-date-wrapper',
	          label: 'Certified Date',
	          fieldId: 'apostilleDate',
	          errorMessage: errors.apostilleDate ? [errors.apostilleDate] : []
	        },
	        _react2.default.createElement(_Form.DateInput, {
	          fieldId: 'apostilleDate',
	          value: apostilleDate,
	          onChange: function onChange(v) {
	            setApostilleDate(v);
	          },
	          onKeyPress: checkEnter
	        })
	      ),
	      _react2.default.createElement(
	        'button',
	        { className: 'btn btn-primary btn-raised', onClick: validate },
	        'Submit'
	      ),
	      serverError && _react2.default.createElement(
	        'span',
	        { className: 'error animated fadeIn fast-animation' },
	        serverError
	      )
	    ),
	    rightColumn: _react2.default.createElement(
	      'p',
	      { className: 'hcd-description' },
	      APOSTILLE_INSTRUCTIONS || 'Please enter the Number on the form you were provided from the State of ' + ("Montana") + ' to verify the Apostille or Authentication.'
	    )
	  });
	};
	
	var FilingDetails = function FilingDetails(_ref2) {
	  var onLoginRequest = _ref2.onLoginRequest,
	      record = _ref2.record;
	  var ACTING_CAPACITY = record.ACTING_CAPACITY,
	      APOSTILLE_DATE = record.APOSTILLE_DATE,
	      APOSTILLE_NUM = record.APOSTILLE_NUM,
	      APOSTILLE_TYPE_ID = record.APOSTILLE_TYPE_ID,
	      CITY = record.CITY,
	      COUNTRY = record.COUNTRY,
	      SEAL_STAMP = record.SEAL_STAMP,
	      SIGNED_BY = record.SIGNED_BY,
	      STATE = record.STATE,
	      CERTIFYING_SOS_NAME = record.CERTIFYING_SOS_NAME;
	
	  var cityStateDetail = _react2.default.createElement(_DetailBlock.Detail, { label: 'City, State', value: '' + (APOSTILLE_CITY_STATE_OVERRIDE ? APOSTILLE_CITY_STATE_OVERRIDE : (CITY ? CITY + ',' : '') + ' ' + (STATE || '')) });
	  return _react2.default.createElement(
	    'div',
	    { className: 'detail-page-wrapper container' },
	    _react2.default.createElement(
	      'button',
	      { className: 'back-link', onClick: onLoginRequest },
	      '<',
	      ' Back to lookup'
	    ),
	    _react2.default.createElement(_DetailHeader2.default, {
	      name: name,
	      entityType: ("Verification Information") || (APOSTILLE_TYPE_ID === 726 ? 'Apostille' : 'Authentication'),
	      systemId: APOSTILLE_NUM,
	      systemIdLabel: (("Apostille/Authentication") || (APOSTILLE_TYPE_ID === 726 ? 'Apostille' : 'Authentication')) + ' Number',
	      filingDateLabel: ("Issue Date"),
	      filingDate: !APOSTILLE_HIDE_FILING_DATE ? (0, _format2.default)(new Date(APOSTILLE_DATE), 'MM/dd/yyyy') : "",
	      standingBlock: false
	    }),
	    _react2.default.createElement(
	      'div',
	      { className: 'general-info row' },
	      _react2.default.createElement(
	        'div',
	        { className: 'col-lg-6 col-sm-6 column' },
	        _react2.default.createElement(
	          _DetailBlock.DetailBlock,
	          { title: 'Signed Details' },
	          COUNTRY ? _react2.default.createElement(_DetailBlock.Detail, { label: 'Country', value: COUNTRY || '' }) : null,
	          _react2.default.createElement(_DetailBlock.Detail, { label: 'Signed By', value: SIGNED_BY || '' }),
	          _react2.default.createElement(_DetailBlock.Detail, { label: 'Acting Capacity', value: ACTING_CAPACITY || '' }),
	          _react2.default.createElement(_DetailBlock.Detail, { label: 'Seal/Stamp', value: SEAL_STAMP || '' }),
	          !({"NODE_ENV":"production","BUILD_DATE":"2025-08-27T15:15:31.687Z","BUILD_NUMBER":"Not Provided","GIT_VERSION":"v1.3.0-381-ga81e29b08","GIT_COMMIT_HASH":"a81e29b085c9268ffd96c78eb734365802722741","GIT_BRANCH":"beta","PUBLIC_URL":"","STATE_ABBR":"MT","STATE_NAME":"Montana","STATE_ORG_TITLE":"Secretary of State","LOGIN_HEADER_IMG_PATH":"","HOME_IMG_FILENAME":"montana.jpg","FAVICON_FILE_NAME":"favicon.ico","ALLOW_E_SIGN_ON_CORRECTIONS":true,"THIRD_PARTY_SIGNING_ALLOWED":false,"MY_ACCOUNT_SAVE_AND_CLOSE_BUTTON":true,"IE_DEPRECATED_MESSAGE":"Internet Explorer is not supported. Please select a supported browser below to access this website.","ADDITIONAL_ROUTES":{"dataRequests":true,"farmBill":true,"apostille":true,"externalHelp":"https://sosmt.gov/business/help-center/","systemAdministration":[{"title":"Saved Payments","parameter":"saved-payments","componentName":"SavedPayments"}]},"SUBROUTES":[{"label":"Business","component":"Business","parameter":"business","myWorkQueueSearch":false,"sourceTypeId":54,"searchMustHaveOneOf":["FILING_TYPE_ID","STATUS_ID","STATE","search"],"serverWebSearchDescription":true,"serverWorkQueueDescription":true,"serverMyRecordsDescription":true,"searchPlaceholder":"Search by name or filing number (X########)","allowEmptySearchTerm":true,"requestCertificateAlternateLabel":"Request Information","fileAmendmentButtonLabel":"Filing Actions","advancedSearchParameters":[{"type":"radio","name":"QUERY_TYPE_ID","defaultValue":1010,"options":[{"value":1010,"label":"Starts with"},{"value":1011,"label":"Contains"},{"value":1012,"label":" Word Contains"}]},{"type":"serverSelect","name":"FILING_TYPE_ID","optionsSrc":"FILING_TYPES","label":"Entity Type","placeholder":"All","defaultValue":"0"},{"type":"serverSelect","name":"FILING_SUBTYPE_ID","optionsSrc":"FILING_SUBTYPES","label":"Entity Subtype","overrideSubOptionsSrcFromParameterName":"FILING_TYPE_ID","placeholder":"All","defaultValue":"0"},{"type":"serverSelect","name":"STATUS_ID","optionsSrc":"FILING_STATUS_WITHOUT_ALL","label":"Status","placeholder":"All","defaultValue":"0"},{"type":"serverSelect","name":"STATE","optionsSrc":"STATE","label":"State","placeholder":"All","defaultValue":""},{"type":"serverSelect","name":"COUNTY","optionsSrc":"COUNTY_SUBOPTION","label":"County","overrideSubOptionsSrcFromParameterName":"STATE","placeholder":"All","defaultValue":""},{"type":"checkbox","name":"CRA_SEARCH_YN","defaultValue":false,"label":"Search by Registered Agent PID"},{"type":"dateRange","name":"FILING_DATE","label":"Registration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}},{"type":"dateRange","name":"EXPIRATION_DATE","label":"Expiration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}}],"myRecordsFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Active"},{"value":2,"label":"Inactive"},{"value":3,"label":"Pending"}]},{"type":"dateRange","name":"DATE_RANGE","label":"Date range","defaultValue":{"start":null,"end":null}}],"myWorkQueueFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Approved"},{"value":2,"label":"Pending Online Payment"},{"value":3,"label":"Pending Review"},{"value":4,"label":"Needs Correction"},{"value":5,"label":"Rejected"},{"value":6,"label":"Draft"}]},{"type":"dateRange","name":"DATE_RANGE","label":"Date range","defaultValue":{"start":null,"end":null}}]},{"label":"Notary","component":"Notary","parameter":"notary","sourceTypeId":850,"myWorkQueueSearch":false,"allowEmptySearchTerm":true,"requestCertificateAlternateLabel":"Download Certificate","fileAmendmentButtonLabel":"Filing Actions","hideNameRequestCertificate":true,"hideAddressRequestCertificate":true,"hideRecordUserManagment":true,"searchPlaceholder":"Search by name or commission number","searchMustHaveOneOf":["CITY","search","SERVICE_TYPE"],"advancedParametersStartOpen":true,"searchIsSortable":true,"advancedSearchParameters":[{"type":"radio","name":"STARTS_WITH_YN","defaultValue":false,"options":[{"value":true,"label":"Starts with"},{"value":false,"label":"Contains"}]},{"type":"checkbox","name":"ACTIVE_ONLY_YN","defaultValue":true,"label":"Active entities only"},{"type":"text","name":"CITY","defaultValue":"","label":"City"},{"type":"select","name":"SERVICE_TYPE","label":"Special Services Offered","defaultValue":0,"options":[{"value":0,"label":"(N/A)"},{"value":6165,"label":"In-Person Electronic Notarization (IPEN)"},{"value":6166,"label":"Remote Online Notarization (RON)"},{"value":6167,"label":"Mobile Notary Services"},{"value":6168,"label":"Remote Ink Notarization (RIN)"}]}]},{"label":"Apostille","component":"Apostille","parameter":"apostille","sourceTypeId":720,"myRecordsSearch":false,"myWorkQueueSearch":false,"disabled":false,"allowedRoutes":["/forms-manager/","/queue/","/forms/"]},{"label":"Liens","component":"UCC","parameter":"ucc","sourceTypeId":1999,"myRecordsSearch":true,"myWorkQueueSearch":true,"fileAmendmentButtonLabel":"Filing Actions","searchPlaceholder":"Search by name or file number","disabled":false,"serverWebSearchDescription":true,"myRecordsDescription":"","workQueueDescription":"","searchDescription":"","hideRecordUserManagment":true,"searchLiensCheckout":false,"advancedSearchParameters":[{"type":"radio","name":"STARTS_WITH_YN","defaultValue":false,"options":[{"value":true,"label":"Starts with"},{"value":false,"label":"Contains"}]},{"type":"select","name":"STATUS","defaultValue":"ALL","label":"Status","options":[{"value":"ACTIVE_UNLAPSED","label":"Active (unlapsed)"},{"value":"ACTIVE_LAPSED_UNLAPSED","label":"Active (lapsed and unlapsed)"}]},{"type":"text","name":"EXCLUDE_VALUES","label":"Exclude Debtor Names (comma separated list of names to exclude)","defaultValue":""},{"type":"dateRange","name":"FILING_DATE","label":"Financing Statement Date","defaultValue":{"start":null,"end":null}},{"type":"dateRange","name":"LAPSE_DATE","label":"Lapse Date","defaultValue":{"start":null,"end":null}},{"type":"text","name":"CITY","label":"Debtor City","defaultValue":""}],"myRecordsFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Approved"},{"value":2,"label":"Pending Online Payment"},{"value":3,"label":"Pending Review"}]},{"type":"select","name":"TYPE","defaultValue":0,"label":"Lien Type","options":[{"value":0,"label":"All"},{"value":1,"label":"UCC"},{"value":2,"label":"EFS"},{"value":3,"label":"Title 71"}]}],"myWorkQueueFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Approved"},{"value":2,"label":"Pending Online Payment"},{"value":3,"label":"Pending Review"},{"value":4,"label":"Pending Print and Mail"},{"value":5,"label":"Rejected"},{"value":6,"label":"Draft"}]},{"type":"select","name":"TYPE","defaultValue":0,"label":"Lien Type","options":[{"value":0,"label":"All"},{"value":1,"label":"UCC"},{"value":2,"label":"EFS"},{"value":3,"label":"Title 71"}]}]},{"label":"Copy Request","component":"copies","parameter":"copies","sourceTypeId":2001,"myRecordsSearch":false,"myWorkQueueSearch":false,"disabled":false,"allowedRoutes":["/forms-manager/","/queue/","/forms/"]},{"label":"Trademark","component":"Trademark","parameter":"trademark","sourceTypeId":810,"showRequestCertificate":true,"searchMustHaveOneOf":["search","EXPIRATION_DATE","FILING_DATE"],"allowEmptySearchTerm":true,"requestCertificateAlternateLabel":"Request Information","fileAmendmentButtonLabel":"Filing Actions","advancedSearchParameters":[{"type":"radio","name":"QUERY_TYPE_ID","defaultValue":1010,"options":[{"value":1010,"label":"Starts with"},{"value":1011,"label":"Contains"},{"value":1012,"label":" Word Contains"}]},{"type":"checkbox","name":"OWNER_SEARCH_YN","defaultValue":false,"label":"Search owners"},{"type":"radio","name":"SERVICE_MARK_YN","label":"Mark Type","defaultValue":"","options":[{"value":"","label":"All Marks"},{"value":"Y","label":"Service Mark"},{"value":"N","label":"Trademark"}]},{"type":"serverSelect","name":"STATUS_ID","optionsSrc":"TYPE_V|TRADEMARK_STATUS_TYPE","label":"Status","placeholder":"All","defaultValue":"0"},{"type":"select","name":"DESIGN_TYPE_ID","options":[{"value":0,"label":"All"},{"value":990,"label":"Words Only"},{"value":991,"label":"Design Only"},{"value":992,"label":"Words and Design"}],"label":"Design Type","defaultValue":"0"},{"type":"dateRange","name":"FILING_DATE","label":"Registered Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}},{"type":"dateRange","name":"EXPIRATION_DATE","label":"Expiration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}}]},{"label":"Business Info Request","component":"InfoRequests","parameter":"info-request","sourceTypeId":167,"allowedRoutes":["/forms-manager/","/queue/","/forms/"]},{"label":"Data Requests","component":"DataRequests","parameter":"data-request","sourceTypeId":0,"allowedRoutes":["/forms-manager/"]},{"label":"CRA","component":"CRA","parameter":"cra","sourceTypeId":157,"myRecordsSearch":false,"searchPlaceholder":"Search by name or registered agent number","allowedRoutes":["/forms-manager/","/forms/","/records/","/queue/","/search/"],"allowEmptySearchTerm":true,"fileAmendmentButtonLabel":"Filing Actions","advancedSearchParameters":[{"type":"radio","name":"QUERY_TYPE_ID","defaultValue":1010,"options":[{"value":1010,"label":"Starts with"},{"value":1011,"label":"Contains"},{"value":1012,"label":" Word Contains"}]},{"type":"dateRange","name":"CRA_DATE","label":"Registration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}},{"type":"select","name":"STATUS_ID","label":"Status","defaultValue":0,"options":[{"value":0,"label":"All"},{"value":121,"label":"Active"},{"value":122,"label":"Inactive"}]},{"type":"select","name":"AGENT_TYPE_ID","label":"Agent Type","defaultValue":0,"options":[{"value":0,"label":"All"},{"value":460,"label":"Registered Agent"},{"value":461,"label":"Commercial Registered Agent"}]}]},{"label":"Farm Bill","component":"FarmBill","parameter":"farm-bill","path":"/lists/farm-bill","sourceTypeId":0,"myRecordsSearch":false,"allowedRules":["/search/"],"disabled":true,"searchDescription":"To perform a search, enter a debtor name. Your search results may include: exact debtor name, variations of that name and any filing that includes your search criteria. Punctuation is ignored.\n\nYou can click on \"Advanced\" to refine your search. Under “Advanced” you can search by crop, year, county and SSN/FEIN. As a registered Farm Bill Buyer with the Montana Secretary of State’s office it is important to maintain the confidentiality of the information contained within the Farm Bill Master List. The Farm Bill Master List reflects personal data, such as Social Security Numbers, which are a key piece of personal identifiable information to assist you in determining the existence of a lien against a specific debtor. The distribution of this information beyond its intended purpose is strictly prohibited.\n\nThe debtor's tax identification number has been hidden for confidentiality reasons. You may continue to search on a tax ID number and return debtors that match your search criteria. The SSN/FEIN must be entered without dashes or spaces.","searchMustHaveOneOf":["search","UCC_FARM_PRODUCT_ID","COUNTY"],"searchPlaceholder":"Search by debtor name","advancedSearchParameters":[{"type":"ServerMultiComplete","label":"Product code name(s)","name":"UCC_FARM_PRODUCT_ID","defaultValue":"","optionsSrc":"UCC_FARM_PRODUCT_V"},{"type":"MultiComplete","label":"Year or Range of Years","name":"YEAR_NUM","optionsSrc":"years","startYear":"1968","defaultValue":[],"preMergeOptions":[{"value":"ALL","label":"All"}]},{"type":"serverSelect","label":"State","name":"STATE","defaultValue":"MONTANA","optionsSrc":"STATE"},{"type":"ServerMultiComplete","label":"County","name":"COUNTY","defaultValue":[],"optionsSrc":"COUNTY","overrideSubOptionsSrcFromParameterName":"STATE"},{"type":"checkbox","name":"TIN_SEARCH_YN","defaultValue":false,"label":"Tax Identification Number Search"},{"type":"checkbox","name":"TIN_SORT_YN","defaultValue":false,"label":"Unique ID Sort"}]}],"SYSTEM_NICKNAME":"Online Services Portal","PAYMENT_METHODS":[{"type":"bypass"},{"type":"iTransact"}],"PAYMENT_ALLOW_AMEX":true,"SYSTEM_ID_LABEL":"System Id","DOUBLE_COLUMN_PUBLIC_LOGIN":true,"INTERNAL_USER_MANAGEMENT":true,"ALLOW_PUBLIC_JSON_IMPORT":false,"MAX_FILE_UPLOAD_SIZE":10000000,"REFUND_TEXT":"","RETURN_TO_HOME_ON_LOGOUT":true,"CURRENT_SOS_NAME":"Christi Jacobsen","LOGO_FILENAME":"mt-sos-logo.png","LOGO_ALT":"Christi Jacobsen, Montana Secretary of State","LOGO_FULL_WIDTH":true,"HOME_HIDE_AUTH_HINT":true,"HOME_TITLE":"Montana Secretary of State","CUSTOM_TAB_TITLE":"Official Montana","HOME_SUBTITLE":"Online Business Services","ENTITY_NAME_CONSENT_DESCRIPTION":"","ALLOW_USER_PROFILE_EDITING":true,"COMPARE_FOREIGN_NAME_IN_ENTITY_NAME_VALIDATION":true,"FOREIGN_NAME_FIELD_NAME":"KIMA_PARENT_NAME_INFO","LOGIN_TITLE":"Montana Secretary of State Online Filing Portal Login","PUBLIC_LOGIN_LABEL":"Username","REVERSE_LOGIN_COLUMNS":true,"LOGIN_SEAL_FILENAME":"seal_white.png","SEPARATE_USERNAME_AND_EMAIL":true,"CREATE_ACCOUNT_BUTTON_ALIGN_LEFT":true,"CREATE_ACCOUNT_BUTTON_TEXT":"CREATE AN ACCOUNT","PASSWORD_CUSTOM_ERROR_TEXT":"The password must meet all requirements","ACCOUNT_CREATED_MESSAGE":"Please check your email to verify your account to login and allow a few minutes for this message to arrive. Check your junk/spam folders if you do not find the email in your inbox.","PUBLIC_LOGIN_PLACEHOLDER":" ","DISABLE_DEFAULT_PAYMENT_RADIO":true,"CUSTOM_RESET_PASSWORD_ERROR_MESSAGE":"Username invalid - no account found","PUBLIC_LOGIN_CREATE_DESCRIPTION":"### Existing User:\n\n  - Enter your username and password to login.  \n\n\n  #### - OR -  \n\n\n\n  - Forgot password? Click 'Reset Password' and follow the prompts.\n  - Forgot username? Click 'Forgot Username' and follow the prompts.  \n\n\n  ### New User:\n  ","LOGIN_HELP_LINK":"https://sosmt.gov/business/how-do-i/","LOGIN_HELP_LINK_TEXT":"Need Help?","FORGOT_USERNAME_TEXT":"Forgot Username?","LOGIN_ACTIVE_DIRECTORY_TEXT":"State User Login","MULTIPLE_LOGIN_METHODS":true,"HAS_ACTIVE_DIRECTORY_LOGIN":true,"RESET_PASSWORD_WITH_USERNAME":true,"DOWNLOAD_LINK":true,"SHOW_USERNAME_ACCOUNT_CREATE":true,"SHOW_SCROLL_DOWN_ARROW":true,"SHOW_ADDRESS_ACCOUNT_CREATE":true,"TWO_COLUMN_ACCOUNT_CREATE":true,"RESET_PASSWORD_TIP":"A link to change your password has been sent to your email. Please allow a few minutes for this message to arrive. Please check your junk/spam folders if you do not find the email in your inbox.","FORGOT_PASSWORD_LINK_TEXT":"Reset Password","PHONE_NUMBER_OPTIONAL_ACCOUNT_CREATE":true,"SHOW_REQUIRED_INDICATOR_ACCOUNT_CREATE":true,"PASSWORD_REQUIREMENTS_ACCOUNT_CREATE":"\n    <ul>\n      <li>MUST contain at least 8 characters (12+ recommended)</li>\n      <li>MUST contain at least one uppercase letter.</li>\n      <li>MUST contain at least one lowercase letter.</li>\n      <li>MUST contain at least one number.</li>\n      <li>MUST contain at least one special character (!”#$%&'()*+,-./:;<=>?</li>\n    </ul>\n  ","ALLOW_CERTIFICATION_REQUEST":true,"ALLOW_PUBLIC_CERTIFICATE_REQUEST":true,"ALLOW_COPY_REQUEST":false,"ALLOW_CORRECTION_STYLING":true,"HIDE_DEPRECATION_WARNING":false,"AMEND_ROUTE_PUBLIC":true,"SEAL_FILENAME":"seal.png","SHOPPING_CART":true,"ALLOW_PAYMENT_UPDATE_WITH_EMPTY_CART":true,"RA_EMAIL":true,"RA_WEBSITE":true,"RA_NO_DEFAULT_TYPE":true,"RA_ADDRESS_LABEL":"Street Address","RA_TYPE_SELECTION_DEFAULT":true,"RA_DEFAULT_TYPE":"460","RA_OVERRIDE_TYPE_WITH_DEFAULT":true,"RA_PRINCIPAL_ADDRESS_AMS":true,"UPLOAD_AND_SUBMIT_HIDE_IF_ONE_OPTION":true,"PAYMENT_PROCESSING_MESSAGE":"Your payment is processing - Do not close your browser or click the back button","CHECKOUT_BUTTON_WHEN_PROCESSING_TEXT":"Processing","EFS_CROP_PICKER_NONE_LABEL":"Lien Duration","DISALLOWED_WIZARD_PIECES":["FormationLocale"],"REPEATER_SHOW_EDIT_BUTTON":true,"DATA_REQUEST_PAGE_TITLE":"Data Requests and Subscriptions","DATA_REQUEST_SIDEBAR_LABEL":"Data Requests & Subscriptions","LOGIN_REDIRECTS_TO_EPASS":false,"LOGIN_REDIRECTS_TO_ACTIVE_DIRECTORY":true,"LOGIN_ACTIVE_DIRECTORY_LINK":true,"FETCH_EDIT_USER_LINK":false,"LISTS_FETCH_AVAILABLE_LISTS":true,"POST_WIZARD_SUBMIT_REDIRECT_URL":"/","PIN_REQUEST_ATTESTATIONS":true,"PIN_REQUEST_DESCRIPTION":"Click **Request PIN** to have a new PIN sent to the account holder's email address on file.","OWNERSHIP_REQUEST_DESCRIPTION":"To become an **authorized user** of this record, a current **AUTHORIZED USER** will need to grant you access. To request access, click **Request Access** below.","PIN_REQUEST_SUCCESS_MESSAGE":"The PIN you have requested for this entity has been sent to the email associated with your user account.  You should receive the PIN in approximately 3-5 minutes, depending on your email service provider.","APOSTILLE_HEADER_LABEL":"Verification Information","APOSTILLE_NUMBER_LABEL":"Apostille/Authentication","APOSTILLE_CITY_STATE_OVERRIDE":"HELENA, MT","APOSTILLE_FILING_DATE_LABEL":"Issue Date","APOSTILLE_CITY_STATE_IN_CERTIFIED":true,"NOTARY_EXISTING_FILING":true,"ALLOW_REVOKE_OWN_ACCESS_ONLY":false,"HIDE_CANCEL_ON_ONETIME_DATA_REQUESTS":true,"DATA_REQUESTS_IN_SHOPPING_CART":true,"WQ_ALLOW_EDIT_PENDING_PAYMENT":true,"WQ_CONFIRM_ON_DELETE":true,"WQ_DELETE_CONFIRM_MESSAGE":"Deleting this filing will forfeit any money already paid to the Secretary of State. This action is permanent and cannot be undone, are you sure you would like to delete?","PASS_ITEM_GUIDS_ON_CHECKOUT":true,"FORM_REVISION_HISTORY":true,"CHECKOUT_DISCLAIMER":"By entering your credit card and/or checking account information you (i) state that **you are an authorized user** of the credit card and/or electronic check and that the associated information entered (e.g., account holder name, account number, billing address) is accurate, (ii) **you authorize payment processor to charge the amount you have requested** to your credit card and/or funding account, and (iii) **acknowledge if a charge is declined or reversed you may also be assessed a customary charge** by the payment processor for such transactions.","FARM_BILL_SEARCH_CONFIDENTIAL":"As a registered Farm Bill Buyer with the Montana Secretary of State’s office it is important to maintain the confidentiality of the information contained within the Farm Bill Master List. The Farm Bill Master List reflects personal data, such as Social Security Numbers, which are a key piece of personal identifiable information to assist you in determining the existence of a lien against a specific debtor. The distribution of this information beyond its intended purpose is strictly prohibited.\n\n**The debtor's tax identification number has been hidden for confidentiality reasons. You may continue to search on a tax ID number and return debtors that match your search criteria. The SSN/FEIN must be entered without dashes or spaces.  If you need access to the tax identification number to clearly identify the debtor, please contact the UCC unit at (406) 444-3665.**","VIEW_HISTORY_BUTTON_ALT_TEXT":"View Filings","WIZARD_ERROR_TITLE_MESSAGE":"Form Error","FARM_BILL_SEARCH_INTERACTIVE":true,"USE_FARM_BILL_API":true,"DISALLOW_ASSIGN_SELF_AS_RA":true,"DISALLOW_ASSIGN_SELF_AS_PRINCIPAL":true,"USE_TRADEMARK_OWNER_VALIDATION":true,"USE_ALTERNATIVE_FOREIGN_ADDRESS_LABELS":true,"MY_RECEIPTS_FILTER":[{"type":"dateRange","name":"DATE_RANGE","label":"Date range","defaultValue":{"start":null,"end":null}},{"type":"text","name":"REF_NUM","defaultValue":"","label":"Reference Number"},{"type":"text","name":"RECEIPT_NUM","defaultValue":"","label":"Receipt Id"},{"type":"text","name":"AMOUNT","defaultValue":"","label":"Amount"},{"type":"select","name":"TYPE","defaultValue":"","label":"Payment Type","options":[{"value":"","label":"All"},{"value":"CC","label":"Credit Card"},{"value":"Check","label":"Check"}]}],"MY_RECEIPTS_SHOW_IN_SIDEBAR":true,"SHOW_MY_RECEIPTS_HELPER_TEXT":true,"MY_RECEIPTS_HELPER_LABEL":"About Receipt Search","MY_RECEIPTS_HELPER_TEXT":"You can search for receipts based on their descriptions, including the items paid for on the receipt. Use the filters to search for or filter specific information.","FARM_BILL_SUBLINK":{"label":"Farm Bill","component":"FarmBill","parameter":"farm-bill","path":"/lists/farm-bill","sourceTypeId":0,"myRecordsSearch":false,"allowedRules":["/search/"],"disabled":true,"searchDescription":"To perform a search, enter a debtor name. Your search results may include: exact debtor name, variations of that name and any filing that includes your search criteria. Punctuation is ignored.\n\nYou can click on \"Advanced\" to refine your search. Under “Advanced” you can search by crop, year, county and SSN/FEIN. As a registered Farm Bill Buyer with the Montana Secretary of State’s office it is important to maintain the confidentiality of the information contained within the Farm Bill Master List. The Farm Bill Master List reflects personal data, such as Social Security Numbers, which are a key piece of personal identifiable information to assist you in determining the existence of a lien against a specific debtor. The distribution of this information beyond its intended purpose is strictly prohibited.\n\nThe debtor's tax identification number has been hidden for confidentiality reasons. You may continue to search on a tax ID number and return debtors that match your search criteria. The SSN/FEIN must be entered without dashes or spaces.","searchMustHaveOneOf":["search","UCC_FARM_PRODUCT_ID","COUNTY"],"searchPlaceholder":"Search by debtor name","advancedSearchParameters":[{"type":"ServerMultiComplete","label":"Product code name(s)","name":"UCC_FARM_PRODUCT_ID","defaultValue":"","optionsSrc":"UCC_FARM_PRODUCT_V"},{"type":"MultiComplete","label":"Year or Range of Years","name":"YEAR_NUM","optionsSrc":"years","startYear":"1968","defaultValue":[],"preMergeOptions":[{"value":"ALL","label":"All"}]},{"type":"serverSelect","label":"State","name":"STATE","defaultValue":"MONTANA","optionsSrc":"STATE"},{"type":"ServerMultiComplete","label":"County","name":"COUNTY","defaultValue":[],"optionsSrc":"COUNTY","overrideSubOptionsSrcFromParameterName":"STATE"},{"type":"checkbox","name":"TIN_SEARCH_YN","defaultValue":false,"label":"Tax Identification Number Search"},{"type":"checkbox","name":"TIN_SORT_YN","defaultValue":false,"label":"Unique ID Sort"}]},"ALLOW_ADDRESS_VALIDATION_BYPASS_OPTION":true,"DEFAULT_ADDRESS_VALIDATION_BYPASS_OPTION_CHECKED":true}).APOSTILLE_HIDE_CITY_STATE && !(true) ? cityStateDetail : null
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'col-lg-6 col-sm-6 column' },
	        _react2.default.createElement(
	          _DetailBlock.DetailBlock,
	          { title: 'Certified Details' },
	          _react2.default.createElement(_DetailBlock.Detail, {
	            label: 'Certified Date',
	            value: (0, _format2.default)(new Date(APOSTILLE_DATE), 'MM/dd/yyyy') || ''
	          }),
	          _react2.default.createElement(_DetailBlock.Detail, {
	            label: 'Certified By',
	            value: (CERTIFYING_SOS_NAME || ("Christi Jacobsen")) + ', ' + ("Montana") + ', ' + ("Secretary of State")
	          }),
	          _react2.default.createElement(_DetailBlock.Detail, {
	            label: (("Apostille/Authentication") || (APOSTILLE_TYPE_ID === 726 ? 'Apostille' : 'Authentication')) + ' Number',
	            value: APOSTILLE_NUM
	          }),
	          !({"NODE_ENV":"production","BUILD_DATE":"2025-08-27T15:15:31.687Z","BUILD_NUMBER":"Not Provided","GIT_VERSION":"v1.3.0-381-ga81e29b08","GIT_COMMIT_HASH":"a81e29b085c9268ffd96c78eb734365802722741","GIT_BRANCH":"beta","PUBLIC_URL":"","STATE_ABBR":"MT","STATE_NAME":"Montana","STATE_ORG_TITLE":"Secretary of State","LOGIN_HEADER_IMG_PATH":"","HOME_IMG_FILENAME":"montana.jpg","FAVICON_FILE_NAME":"favicon.ico","ALLOW_E_SIGN_ON_CORRECTIONS":true,"THIRD_PARTY_SIGNING_ALLOWED":false,"MY_ACCOUNT_SAVE_AND_CLOSE_BUTTON":true,"IE_DEPRECATED_MESSAGE":"Internet Explorer is not supported. Please select a supported browser below to access this website.","ADDITIONAL_ROUTES":{"dataRequests":true,"farmBill":true,"apostille":true,"externalHelp":"https://sosmt.gov/business/help-center/","systemAdministration":[{"title":"Saved Payments","parameter":"saved-payments","componentName":"SavedPayments"}]},"SUBROUTES":[{"label":"Business","component":"Business","parameter":"business","myWorkQueueSearch":false,"sourceTypeId":54,"searchMustHaveOneOf":["FILING_TYPE_ID","STATUS_ID","STATE","search"],"serverWebSearchDescription":true,"serverWorkQueueDescription":true,"serverMyRecordsDescription":true,"searchPlaceholder":"Search by name or filing number (X########)","allowEmptySearchTerm":true,"requestCertificateAlternateLabel":"Request Information","fileAmendmentButtonLabel":"Filing Actions","advancedSearchParameters":[{"type":"radio","name":"QUERY_TYPE_ID","defaultValue":1010,"options":[{"value":1010,"label":"Starts with"},{"value":1011,"label":"Contains"},{"value":1012,"label":" Word Contains"}]},{"type":"serverSelect","name":"FILING_TYPE_ID","optionsSrc":"FILING_TYPES","label":"Entity Type","placeholder":"All","defaultValue":"0"},{"type":"serverSelect","name":"FILING_SUBTYPE_ID","optionsSrc":"FILING_SUBTYPES","label":"Entity Subtype","overrideSubOptionsSrcFromParameterName":"FILING_TYPE_ID","placeholder":"All","defaultValue":"0"},{"type":"serverSelect","name":"STATUS_ID","optionsSrc":"FILING_STATUS_WITHOUT_ALL","label":"Status","placeholder":"All","defaultValue":"0"},{"type":"serverSelect","name":"STATE","optionsSrc":"STATE","label":"State","placeholder":"All","defaultValue":""},{"type":"serverSelect","name":"COUNTY","optionsSrc":"COUNTY_SUBOPTION","label":"County","overrideSubOptionsSrcFromParameterName":"STATE","placeholder":"All","defaultValue":""},{"type":"checkbox","name":"CRA_SEARCH_YN","defaultValue":false,"label":"Search by Registered Agent PID"},{"type":"dateRange","name":"FILING_DATE","label":"Registration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}},{"type":"dateRange","name":"EXPIRATION_DATE","label":"Expiration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}}],"myRecordsFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Active"},{"value":2,"label":"Inactive"},{"value":3,"label":"Pending"}]},{"type":"dateRange","name":"DATE_RANGE","label":"Date range","defaultValue":{"start":null,"end":null}}],"myWorkQueueFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Approved"},{"value":2,"label":"Pending Online Payment"},{"value":3,"label":"Pending Review"},{"value":4,"label":"Needs Correction"},{"value":5,"label":"Rejected"},{"value":6,"label":"Draft"}]},{"type":"dateRange","name":"DATE_RANGE","label":"Date range","defaultValue":{"start":null,"end":null}}]},{"label":"Notary","component":"Notary","parameter":"notary","sourceTypeId":850,"myWorkQueueSearch":false,"allowEmptySearchTerm":true,"requestCertificateAlternateLabel":"Download Certificate","fileAmendmentButtonLabel":"Filing Actions","hideNameRequestCertificate":true,"hideAddressRequestCertificate":true,"hideRecordUserManagment":true,"searchPlaceholder":"Search by name or commission number","searchMustHaveOneOf":["CITY","search","SERVICE_TYPE"],"advancedParametersStartOpen":true,"searchIsSortable":true,"advancedSearchParameters":[{"type":"radio","name":"STARTS_WITH_YN","defaultValue":false,"options":[{"value":true,"label":"Starts with"},{"value":false,"label":"Contains"}]},{"type":"checkbox","name":"ACTIVE_ONLY_YN","defaultValue":true,"label":"Active entities only"},{"type":"text","name":"CITY","defaultValue":"","label":"City"},{"type":"select","name":"SERVICE_TYPE","label":"Special Services Offered","defaultValue":0,"options":[{"value":0,"label":"(N/A)"},{"value":6165,"label":"In-Person Electronic Notarization (IPEN)"},{"value":6166,"label":"Remote Online Notarization (RON)"},{"value":6167,"label":"Mobile Notary Services"},{"value":6168,"label":"Remote Ink Notarization (RIN)"}]}]},{"label":"Apostille","component":"Apostille","parameter":"apostille","sourceTypeId":720,"myRecordsSearch":false,"myWorkQueueSearch":false,"disabled":false,"allowedRoutes":["/forms-manager/","/queue/","/forms/"]},{"label":"Liens","component":"UCC","parameter":"ucc","sourceTypeId":1999,"myRecordsSearch":true,"myWorkQueueSearch":true,"fileAmendmentButtonLabel":"Filing Actions","searchPlaceholder":"Search by name or file number","disabled":false,"serverWebSearchDescription":true,"myRecordsDescription":"","workQueueDescription":"","searchDescription":"","hideRecordUserManagment":true,"searchLiensCheckout":false,"advancedSearchParameters":[{"type":"radio","name":"STARTS_WITH_YN","defaultValue":false,"options":[{"value":true,"label":"Starts with"},{"value":false,"label":"Contains"}]},{"type":"select","name":"STATUS","defaultValue":"ALL","label":"Status","options":[{"value":"ACTIVE_UNLAPSED","label":"Active (unlapsed)"},{"value":"ACTIVE_LAPSED_UNLAPSED","label":"Active (lapsed and unlapsed)"}]},{"type":"text","name":"EXCLUDE_VALUES","label":"Exclude Debtor Names (comma separated list of names to exclude)","defaultValue":""},{"type":"dateRange","name":"FILING_DATE","label":"Financing Statement Date","defaultValue":{"start":null,"end":null}},{"type":"dateRange","name":"LAPSE_DATE","label":"Lapse Date","defaultValue":{"start":null,"end":null}},{"type":"text","name":"CITY","label":"Debtor City","defaultValue":""}],"myRecordsFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Approved"},{"value":2,"label":"Pending Online Payment"},{"value":3,"label":"Pending Review"}]},{"type":"select","name":"TYPE","defaultValue":0,"label":"Lien Type","options":[{"value":0,"label":"All"},{"value":1,"label":"UCC"},{"value":2,"label":"EFS"},{"value":3,"label":"Title 71"}]}],"myWorkQueueFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Approved"},{"value":2,"label":"Pending Online Payment"},{"value":3,"label":"Pending Review"},{"value":4,"label":"Pending Print and Mail"},{"value":5,"label":"Rejected"},{"value":6,"label":"Draft"}]},{"type":"select","name":"TYPE","defaultValue":0,"label":"Lien Type","options":[{"value":0,"label":"All"},{"value":1,"label":"UCC"},{"value":2,"label":"EFS"},{"value":3,"label":"Title 71"}]}]},{"label":"Copy Request","component":"copies","parameter":"copies","sourceTypeId":2001,"myRecordsSearch":false,"myWorkQueueSearch":false,"disabled":false,"allowedRoutes":["/forms-manager/","/queue/","/forms/"]},{"label":"Trademark","component":"Trademark","parameter":"trademark","sourceTypeId":810,"showRequestCertificate":true,"searchMustHaveOneOf":["search","EXPIRATION_DATE","FILING_DATE"],"allowEmptySearchTerm":true,"requestCertificateAlternateLabel":"Request Information","fileAmendmentButtonLabel":"Filing Actions","advancedSearchParameters":[{"type":"radio","name":"QUERY_TYPE_ID","defaultValue":1010,"options":[{"value":1010,"label":"Starts with"},{"value":1011,"label":"Contains"},{"value":1012,"label":" Word Contains"}]},{"type":"checkbox","name":"OWNER_SEARCH_YN","defaultValue":false,"label":"Search owners"},{"type":"radio","name":"SERVICE_MARK_YN","label":"Mark Type","defaultValue":"","options":[{"value":"","label":"All Marks"},{"value":"Y","label":"Service Mark"},{"value":"N","label":"Trademark"}]},{"type":"serverSelect","name":"STATUS_ID","optionsSrc":"TYPE_V|TRADEMARK_STATUS_TYPE","label":"Status","placeholder":"All","defaultValue":"0"},{"type":"select","name":"DESIGN_TYPE_ID","options":[{"value":0,"label":"All"},{"value":990,"label":"Words Only"},{"value":991,"label":"Design Only"},{"value":992,"label":"Words and Design"}],"label":"Design Type","defaultValue":"0"},{"type":"dateRange","name":"FILING_DATE","label":"Registered Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}},{"type":"dateRange","name":"EXPIRATION_DATE","label":"Expiration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}}]},{"label":"Business Info Request","component":"InfoRequests","parameter":"info-request","sourceTypeId":167,"allowedRoutes":["/forms-manager/","/queue/","/forms/"]},{"label":"Data Requests","component":"DataRequests","parameter":"data-request","sourceTypeId":0,"allowedRoutes":["/forms-manager/"]},{"label":"CRA","component":"CRA","parameter":"cra","sourceTypeId":157,"myRecordsSearch":false,"searchPlaceholder":"Search by name or registered agent number","allowedRoutes":["/forms-manager/","/forms/","/records/","/queue/","/search/"],"allowEmptySearchTerm":true,"fileAmendmentButtonLabel":"Filing Actions","advancedSearchParameters":[{"type":"radio","name":"QUERY_TYPE_ID","defaultValue":1010,"options":[{"value":1010,"label":"Starts with"},{"value":1011,"label":"Contains"},{"value":1012,"label":" Word Contains"}]},{"type":"dateRange","name":"CRA_DATE","label":"Registration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}},{"type":"select","name":"STATUS_ID","label":"Status","defaultValue":0,"options":[{"value":0,"label":"All"},{"value":121,"label":"Active"},{"value":122,"label":"Inactive"}]},{"type":"select","name":"AGENT_TYPE_ID","label":"Agent Type","defaultValue":0,"options":[{"value":0,"label":"All"},{"value":460,"label":"Registered Agent"},{"value":461,"label":"Commercial Registered Agent"}]}]},{"label":"Farm Bill","component":"FarmBill","parameter":"farm-bill","path":"/lists/farm-bill","sourceTypeId":0,"myRecordsSearch":false,"allowedRules":["/search/"],"disabled":true,"searchDescription":"To perform a search, enter a debtor name. Your search results may include: exact debtor name, variations of that name and any filing that includes your search criteria. Punctuation is ignored.\n\nYou can click on \"Advanced\" to refine your search. Under “Advanced” you can search by crop, year, county and SSN/FEIN. As a registered Farm Bill Buyer with the Montana Secretary of State’s office it is important to maintain the confidentiality of the information contained within the Farm Bill Master List. The Farm Bill Master List reflects personal data, such as Social Security Numbers, which are a key piece of personal identifiable information to assist you in determining the existence of a lien against a specific debtor. The distribution of this information beyond its intended purpose is strictly prohibited.\n\nThe debtor's tax identification number has been hidden for confidentiality reasons. You may continue to search on a tax ID number and return debtors that match your search criteria. The SSN/FEIN must be entered without dashes or spaces.","searchMustHaveOneOf":["search","UCC_FARM_PRODUCT_ID","COUNTY"],"searchPlaceholder":"Search by debtor name","advancedSearchParameters":[{"type":"ServerMultiComplete","label":"Product code name(s)","name":"UCC_FARM_PRODUCT_ID","defaultValue":"","optionsSrc":"UCC_FARM_PRODUCT_V"},{"type":"MultiComplete","label":"Year or Range of Years","name":"YEAR_NUM","optionsSrc":"years","startYear":"1968","defaultValue":[],"preMergeOptions":[{"value":"ALL","label":"All"}]},{"type":"serverSelect","label":"State","name":"STATE","defaultValue":"MONTANA","optionsSrc":"STATE"},{"type":"ServerMultiComplete","label":"County","name":"COUNTY","defaultValue":[],"optionsSrc":"COUNTY","overrideSubOptionsSrcFromParameterName":"STATE"},{"type":"checkbox","name":"TIN_SEARCH_YN","defaultValue":false,"label":"Tax Identification Number Search"},{"type":"checkbox","name":"TIN_SORT_YN","defaultValue":false,"label":"Unique ID Sort"}]}],"SYSTEM_NICKNAME":"Online Services Portal","PAYMENT_METHODS":[{"type":"bypass"},{"type":"iTransact"}],"PAYMENT_ALLOW_AMEX":true,"SYSTEM_ID_LABEL":"System Id","DOUBLE_COLUMN_PUBLIC_LOGIN":true,"INTERNAL_USER_MANAGEMENT":true,"ALLOW_PUBLIC_JSON_IMPORT":false,"MAX_FILE_UPLOAD_SIZE":10000000,"REFUND_TEXT":"","RETURN_TO_HOME_ON_LOGOUT":true,"CURRENT_SOS_NAME":"Christi Jacobsen","LOGO_FILENAME":"mt-sos-logo.png","LOGO_ALT":"Christi Jacobsen, Montana Secretary of State","LOGO_FULL_WIDTH":true,"HOME_HIDE_AUTH_HINT":true,"HOME_TITLE":"Montana Secretary of State","CUSTOM_TAB_TITLE":"Official Montana","HOME_SUBTITLE":"Online Business Services","ENTITY_NAME_CONSENT_DESCRIPTION":"","ALLOW_USER_PROFILE_EDITING":true,"COMPARE_FOREIGN_NAME_IN_ENTITY_NAME_VALIDATION":true,"FOREIGN_NAME_FIELD_NAME":"KIMA_PARENT_NAME_INFO","LOGIN_TITLE":"Montana Secretary of State Online Filing Portal Login","PUBLIC_LOGIN_LABEL":"Username","REVERSE_LOGIN_COLUMNS":true,"LOGIN_SEAL_FILENAME":"seal_white.png","SEPARATE_USERNAME_AND_EMAIL":true,"CREATE_ACCOUNT_BUTTON_ALIGN_LEFT":true,"CREATE_ACCOUNT_BUTTON_TEXT":"CREATE AN ACCOUNT","PASSWORD_CUSTOM_ERROR_TEXT":"The password must meet all requirements","ACCOUNT_CREATED_MESSAGE":"Please check your email to verify your account to login and allow a few minutes for this message to arrive. Check your junk/spam folders if you do not find the email in your inbox.","PUBLIC_LOGIN_PLACEHOLDER":" ","DISABLE_DEFAULT_PAYMENT_RADIO":true,"CUSTOM_RESET_PASSWORD_ERROR_MESSAGE":"Username invalid - no account found","PUBLIC_LOGIN_CREATE_DESCRIPTION":"### Existing User:\n\n  - Enter your username and password to login.  \n\n\n  #### - OR -  \n\n\n\n  - Forgot password? Click 'Reset Password' and follow the prompts.\n  - Forgot username? Click 'Forgot Username' and follow the prompts.  \n\n\n  ### New User:\n  ","LOGIN_HELP_LINK":"https://sosmt.gov/business/how-do-i/","LOGIN_HELP_LINK_TEXT":"Need Help?","FORGOT_USERNAME_TEXT":"Forgot Username?","LOGIN_ACTIVE_DIRECTORY_TEXT":"State User Login","MULTIPLE_LOGIN_METHODS":true,"HAS_ACTIVE_DIRECTORY_LOGIN":true,"RESET_PASSWORD_WITH_USERNAME":true,"DOWNLOAD_LINK":true,"SHOW_USERNAME_ACCOUNT_CREATE":true,"SHOW_SCROLL_DOWN_ARROW":true,"SHOW_ADDRESS_ACCOUNT_CREATE":true,"TWO_COLUMN_ACCOUNT_CREATE":true,"RESET_PASSWORD_TIP":"A link to change your password has been sent to your email. Please allow a few minutes for this message to arrive. Please check your junk/spam folders if you do not find the email in your inbox.","FORGOT_PASSWORD_LINK_TEXT":"Reset Password","PHONE_NUMBER_OPTIONAL_ACCOUNT_CREATE":true,"SHOW_REQUIRED_INDICATOR_ACCOUNT_CREATE":true,"PASSWORD_REQUIREMENTS_ACCOUNT_CREATE":"\n    <ul>\n      <li>MUST contain at least 8 characters (12+ recommended)</li>\n      <li>MUST contain at least one uppercase letter.</li>\n      <li>MUST contain at least one lowercase letter.</li>\n      <li>MUST contain at least one number.</li>\n      <li>MUST contain at least one special character (!”#$%&'()*+,-./:;<=>?</li>\n    </ul>\n  ","ALLOW_CERTIFICATION_REQUEST":true,"ALLOW_PUBLIC_CERTIFICATE_REQUEST":true,"ALLOW_COPY_REQUEST":false,"ALLOW_CORRECTION_STYLING":true,"HIDE_DEPRECATION_WARNING":false,"AMEND_ROUTE_PUBLIC":true,"SEAL_FILENAME":"seal.png","SHOPPING_CART":true,"ALLOW_PAYMENT_UPDATE_WITH_EMPTY_CART":true,"RA_EMAIL":true,"RA_WEBSITE":true,"RA_NO_DEFAULT_TYPE":true,"RA_ADDRESS_LABEL":"Street Address","RA_TYPE_SELECTION_DEFAULT":true,"RA_DEFAULT_TYPE":"460","RA_OVERRIDE_TYPE_WITH_DEFAULT":true,"RA_PRINCIPAL_ADDRESS_AMS":true,"UPLOAD_AND_SUBMIT_HIDE_IF_ONE_OPTION":true,"PAYMENT_PROCESSING_MESSAGE":"Your payment is processing - Do not close your browser or click the back button","CHECKOUT_BUTTON_WHEN_PROCESSING_TEXT":"Processing","EFS_CROP_PICKER_NONE_LABEL":"Lien Duration","DISALLOWED_WIZARD_PIECES":["FormationLocale"],"REPEATER_SHOW_EDIT_BUTTON":true,"DATA_REQUEST_PAGE_TITLE":"Data Requests and Subscriptions","DATA_REQUEST_SIDEBAR_LABEL":"Data Requests & Subscriptions","LOGIN_REDIRECTS_TO_EPASS":false,"LOGIN_REDIRECTS_TO_ACTIVE_DIRECTORY":true,"LOGIN_ACTIVE_DIRECTORY_LINK":true,"FETCH_EDIT_USER_LINK":false,"LISTS_FETCH_AVAILABLE_LISTS":true,"POST_WIZARD_SUBMIT_REDIRECT_URL":"/","PIN_REQUEST_ATTESTATIONS":true,"PIN_REQUEST_DESCRIPTION":"Click **Request PIN** to have a new PIN sent to the account holder's email address on file.","OWNERSHIP_REQUEST_DESCRIPTION":"To become an **authorized user** of this record, a current **AUTHORIZED USER** will need to grant you access. To request access, click **Request Access** below.","PIN_REQUEST_SUCCESS_MESSAGE":"The PIN you have requested for this entity has been sent to the email associated with your user account.  You should receive the PIN in approximately 3-5 minutes, depending on your email service provider.","APOSTILLE_HEADER_LABEL":"Verification Information","APOSTILLE_NUMBER_LABEL":"Apostille/Authentication","APOSTILLE_CITY_STATE_OVERRIDE":"HELENA, MT","APOSTILLE_FILING_DATE_LABEL":"Issue Date","APOSTILLE_CITY_STATE_IN_CERTIFIED":true,"NOTARY_EXISTING_FILING":true,"ALLOW_REVOKE_OWN_ACCESS_ONLY":false,"HIDE_CANCEL_ON_ONETIME_DATA_REQUESTS":true,"DATA_REQUESTS_IN_SHOPPING_CART":true,"WQ_ALLOW_EDIT_PENDING_PAYMENT":true,"WQ_CONFIRM_ON_DELETE":true,"WQ_DELETE_CONFIRM_MESSAGE":"Deleting this filing will forfeit any money already paid to the Secretary of State. This action is permanent and cannot be undone, are you sure you would like to delete?","PASS_ITEM_GUIDS_ON_CHECKOUT":true,"FORM_REVISION_HISTORY":true,"CHECKOUT_DISCLAIMER":"By entering your credit card and/or checking account information you (i) state that **you are an authorized user** of the credit card and/or electronic check and that the associated information entered (e.g., account holder name, account number, billing address) is accurate, (ii) **you authorize payment processor to charge the amount you have requested** to your credit card and/or funding account, and (iii) **acknowledge if a charge is declined or reversed you may also be assessed a customary charge** by the payment processor for such transactions.","FARM_BILL_SEARCH_CONFIDENTIAL":"As a registered Farm Bill Buyer with the Montana Secretary of State’s office it is important to maintain the confidentiality of the information contained within the Farm Bill Master List. The Farm Bill Master List reflects personal data, such as Social Security Numbers, which are a key piece of personal identifiable information to assist you in determining the existence of a lien against a specific debtor. The distribution of this information beyond its intended purpose is strictly prohibited.\n\n**The debtor's tax identification number has been hidden for confidentiality reasons. You may continue to search on a tax ID number and return debtors that match your search criteria. The SSN/FEIN must be entered without dashes or spaces.  If you need access to the tax identification number to clearly identify the debtor, please contact the UCC unit at (406) 444-3665.**","VIEW_HISTORY_BUTTON_ALT_TEXT":"View Filings","WIZARD_ERROR_TITLE_MESSAGE":"Form Error","FARM_BILL_SEARCH_INTERACTIVE":true,"USE_FARM_BILL_API":true,"DISALLOW_ASSIGN_SELF_AS_RA":true,"DISALLOW_ASSIGN_SELF_AS_PRINCIPAL":true,"USE_TRADEMARK_OWNER_VALIDATION":true,"USE_ALTERNATIVE_FOREIGN_ADDRESS_LABELS":true,"MY_RECEIPTS_FILTER":[{"type":"dateRange","name":"DATE_RANGE","label":"Date range","defaultValue":{"start":null,"end":null}},{"type":"text","name":"REF_NUM","defaultValue":"","label":"Reference Number"},{"type":"text","name":"RECEIPT_NUM","defaultValue":"","label":"Receipt Id"},{"type":"text","name":"AMOUNT","defaultValue":"","label":"Amount"},{"type":"select","name":"TYPE","defaultValue":"","label":"Payment Type","options":[{"value":"","label":"All"},{"value":"CC","label":"Credit Card"},{"value":"Check","label":"Check"}]}],"MY_RECEIPTS_SHOW_IN_SIDEBAR":true,"SHOW_MY_RECEIPTS_HELPER_TEXT":true,"MY_RECEIPTS_HELPER_LABEL":"About Receipt Search","MY_RECEIPTS_HELPER_TEXT":"You can search for receipts based on their descriptions, including the items paid for on the receipt. Use the filters to search for or filter specific information.","FARM_BILL_SUBLINK":{"label":"Farm Bill","component":"FarmBill","parameter":"farm-bill","path":"/lists/farm-bill","sourceTypeId":0,"myRecordsSearch":false,"allowedRules":["/search/"],"disabled":true,"searchDescription":"To perform a search, enter a debtor name. Your search results may include: exact debtor name, variations of that name and any filing that includes your search criteria. Punctuation is ignored.\n\nYou can click on \"Advanced\" to refine your search. Under “Advanced” you can search by crop, year, county and SSN/FEIN. As a registered Farm Bill Buyer with the Montana Secretary of State’s office it is important to maintain the confidentiality of the information contained within the Farm Bill Master List. The Farm Bill Master List reflects personal data, such as Social Security Numbers, which are a key piece of personal identifiable information to assist you in determining the existence of a lien against a specific debtor. The distribution of this information beyond its intended purpose is strictly prohibited.\n\nThe debtor's tax identification number has been hidden for confidentiality reasons. You may continue to search on a tax ID number and return debtors that match your search criteria. The SSN/FEIN must be entered without dashes or spaces.","searchMustHaveOneOf":["search","UCC_FARM_PRODUCT_ID","COUNTY"],"searchPlaceholder":"Search by debtor name","advancedSearchParameters":[{"type":"ServerMultiComplete","label":"Product code name(s)","name":"UCC_FARM_PRODUCT_ID","defaultValue":"","optionsSrc":"UCC_FARM_PRODUCT_V"},{"type":"MultiComplete","label":"Year or Range of Years","name":"YEAR_NUM","optionsSrc":"years","startYear":"1968","defaultValue":[],"preMergeOptions":[{"value":"ALL","label":"All"}]},{"type":"serverSelect","label":"State","name":"STATE","defaultValue":"MONTANA","optionsSrc":"STATE"},{"type":"ServerMultiComplete","label":"County","name":"COUNTY","defaultValue":[],"optionsSrc":"COUNTY","overrideSubOptionsSrcFromParameterName":"STATE"},{"type":"checkbox","name":"TIN_SEARCH_YN","defaultValue":false,"label":"Tax Identification Number Search"},{"type":"checkbox","name":"TIN_SORT_YN","defaultValue":false,"label":"Unique ID Sort"}]},"ALLOW_ADDRESS_VALIDATION_BYPASS_OPTION":true,"DEFAULT_ADDRESS_VALIDATION_BYPASS_OPTION_CHECKED":true}).APOSTILLE_HIDE_CITY_STATE && (true) ? cityStateDetail : null
	        )
	      )
	    )
	  );
	};

/***/ },
/* 1053 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getAppSettingsByName = exports.getAppSettingByName = exports.setAppSettings = exports.setAppSetting = undefined;
	
	var _requests = __webpack_require__(6);
	
	var setAppSetting = exports.setAppSetting = function setAppSetting(setting) {
	  return {
	    type: 'SET_APP_SETTING',
	    setting: setting
	  };
	};
	
	var setAppSettings = exports.setAppSettings = function setAppSettings(settings) {
	  return {
	    type: 'SET_APP_SETTINGS',
	    settings: settings
	  };
	};
	
	var getAppSettingByName = exports.getAppSettingByName = function getAppSettingByName(name, callback, errorCallback, forceRefetch) {
	  return function (getState, dispatch) {
	    var existingSetting = getState().appSettings[name];
	
	    if (!existingSetting || forceRefetch) {
	      (0, _requests.GET_APP_SETTING_BY_NAME)(name, function (setting) {
	        dispatch(setAppSetting(setting));
	        if (typeof callback === "function") {
	          callback(setting);
	        }
	      }, function (err) {
	        console.error(err);
	        if (typeof errorCallback === "function") {
	          errorCallback(err);
	        }
	      });
	    } else {
	      if (typeof callback === "function") {
	        callback(existingSetting);
	      }
	    }
	  };
	};
	
	var reduceSettings = function reduceSettings(names, getState) {
	  return names.reduce(function (obj, name) {
	    obj[name] = getState().appSettings[name];
	    return obj;
	  }, {});
	};
	
	var getAppSettingsByName = exports.getAppSettingsByName = function getAppSettingsByName(names, callback, errorCallback, forceRefetch) {
	  return function (getState, dispatch) {
	    var missingSettings = names.filter(function (name) {
	      return !getState().appSettings[name];
	    });
	
	    if (missingSettings.length || forceRefetch) {
	      (0, _requests.GET_APP_SETTINGS_BY_NAME)(forceRefetch ? names : missingSettings, function (settings) {
	        dispatch(setAppSettings(settings));
	        var newSettings = Object.assign({}, reduceSettings(names, getState), settings);
	        if (typeof callback === "function") {
	          callback(newSettings);
	        }
	      }, function (err) {
	        console.error(err);
	        if (typeof errorCallback === "function") {
	          errorCallback(err);
	        }
	      });
	    } else {
	      var settings = reduceSettings(names, getState);
	      if (typeof callback === "function") {
	        callback(settings);
	      }
	    }
	  };
	};

/***/ },
/* 1054 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var initialState = {};
	
	exports.default = function () {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	  var action = arguments[1];
	
	  switch (action.type) {
	    case 'SET_APP_SETTING_TYPES':
	      return Object.assign({}, state, action.settingTypes);
	    default:
	      return state;
	  }
	};

/***/ },
/* 1055 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var initialState = {};
	
	exports.default = function () {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	  var action = arguments[1];
	
	  switch (action.type) {
	    case 'SET_APP_SETTING':
	      return Object.assign({}, state, _defineProperty({}, action.setting.NAME, action.setting));
	    case 'SET_APP_SETTINGS':
	      return Object.assign({}, state, action.settings);
	    default:
	      return state;
	  }
	};

/***/ },
/* 1056 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(7);
	
	var _cart = __webpack_require__(223);
	
	var _cart2 = _interopRequireDefault(_cart);
	
	var _SlidingPanel = __webpack_require__(101);
	
	var _SlidingPanel2 = _interopRequireDefault(_SlidingPanel);
	
	var _Portal = __webpack_require__(12);
	
	var _Portal2 = _interopRequireDefault(_Portal);
	
	var _Checkout = __webpack_require__(67);
	
	var _Checkout2 = _interopRequireDefault(_Checkout);
	
	var _requests = __webpack_require__(6);
	
	var _actions = __webpack_require__(29);
	
	var _store = __webpack_require__(18);
	
	__webpack_require__(1431);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CartButton = function CartButton(_ref) {
	  var loggedIn = _ref.loggedIn,
	      cartQuantity = _ref.cartQuantity,
	      setCartQuantity = _ref.setCartQuantity;
	
	  var _React$useState = _react2.default.useState(false),
	      _React$useState2 = _slicedToArray(_React$useState, 2),
	      checkoutOpen = _React$useState2[0],
	      setCheckoutOpen = _React$useState2[1];
	
	  var _React$useState3 = _react2.default.useState({}),
	      _React$useState4 = _slicedToArray(_React$useState3, 2),
	      currentCart = _React$useState4[0],
	      setCurrentCart = _React$useState4[1];
	
	  var slidingPanelRef = _react2.default.useRef();
	
	  var closeCheckout = function closeCheckout() {
	    slidingPanelRef.current.closeSlider(function () {
	      setCheckoutOpen(false);
	    });
	  };
	
	  var startCheckout = function startCheckout() {
	    (0, _requests.GET_WEB_USER_ACTIVE_CART)(function (cart) {
	      setCurrentCart(cart);
	      setCartQuantity(cart.RECEIPT_ITEM_CONTAINER_WEB_LIST.filter(function (x) {
	        return !x.IS_FREE;
	      }).length);
	      setCheckoutOpen(true);
	    });
	  };
	
	  var refreshCart = function refreshCart() {
	    (0, _requests.GET_WEB_USER_ACTIVE_CART)(function (cart) {
	      setCurrentCart(cart);
	      setCartQuantity(cart.RECEIPT_ITEM_CONTAINER_WEB_LIST.filter(function (x) {
	        return !x.IS_FREE;
	      }).length);
	    });
	  };
	
	  var redirectToReceipt = function redirectToReceipt(refNum) {
	    _store.history.push('/receipt?ref=' + (refNum || currentCart.REF_NUM));
	  };
	
	  return loggedIn && _react2.default.createElement(
	    'div',
	    { className: 'cart-button-wrapper' },
	    _react2.default.createElement(
	      'button',
	      { className: 'cart-button', onClick: startCheckout, 'aria-label': 'Open Shopping Cart' },
	      !!cartQuantity && _react2.default.createElement(
	        'div',
	        { className: 'cart-amount' },
	        _react2.default.createElement(
	          'span',
	          null,
	          cartQuantity
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'flex-center' },
	        _react2.default.createElement(_cart2.default, null)
	      )
	    ),
	    _react2.default.createElement(
	      _Portal2.default,
	      { isOpened: checkoutOpen },
	      _react2.default.createElement(
	        _SlidingPanel2.default,
	        { closeOnShadeClick: false, closeSlider: closeCheckout, ref: slidingPanelRef, ariaLabel: 'Checkout' },
	        _react2.default.createElement(_Checkout2.default, {
	          cancelCheckout: closeCheckout,
	          closeModal: closeCheckout,
	          redirectToReceipt: redirectToReceipt,
	          refNum: currentCart.REF_NUM
	          // category={match.params.category}
	          , receiptItemContainers: currentCart.RECEIPT_ITEM_CONTAINER_WEB_LIST,
	          onCartRefresh: refreshCart
	        })
	      )
	    )
	  );
	};
	CartButton = (0, _reactRedux.connect)(function (state) {
	  return {
	    loggedIn: state.auth.loggedIn,
	    cartQuantity: state.app.cartQuantity
	  };
	}, { setCartQuantity: _actions.setCartQuantity })(CartButton);
	
	exports.default = CartButton;

/***/ },
/* 1057 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Field = __webpack_require__(25);
	
	var _Form = __webpack_require__(14);
	
	var _AddressBlock = __webpack_require__(102);
	
	var _WizardClasses = __webpack_require__(35);
	
	var _Markdown = __webpack_require__(24);
	
	var _Markdown2 = _interopRequireDefault(_Markdown);
	
	var _validate = __webpack_require__(45);
	
	var _utilities = __webpack_require__(8);
	
	var _CreateAccount = __webpack_require__(149);
	
	__webpack_require__(1433);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var RequestCertificate = function (_React$Component) {
	  _inherits(RequestCertificate, _React$Component);
	
	  function RequestCertificate() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, RequestCertificate);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = RequestCertificate.__proto__ || Object.getPrototypeOf(RequestCertificate)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      values: {
	        requesterName: "",
	        certType: "",
	        certAmount: "1",
	        delivery: _this.props.config.ALLOW_MAIL && !_this.props.config.ALLOW_EMAIL ? "mail" : !_this.props.config.ALLOW_MAIL && _this.props.config.ALLOW_EMAIL ? "email" : "",
	        address: (0, _WizardClasses.getAddressObject)(),
	        email: ""
	      },
	      globalError: false,
	      errors: {}
	    }, _this.setError = function () {
	      _this.setState({
	        globalError: true
	      });
	    }, _this.setValue = function (value, key) {
	      _this.setState(function (state) {
	        return {
	          values: Object.assign({}, state.values, _defineProperty({}, key, value))
	        };
	      });
	    }, _this.validate = function () {
	      var errors = {};
	      var deferredValidators = [];
	
	      if (!_this.props.hideNameField && _this.state.values.requesterName === '') {
	        errors.requesterName = ["The name of the requester is required."];
	      }
	      if (_this.state.values.certType === '') {
	        errors.certType = ["A certificate type must be selected."];
	      }
	      if (_this.props.config.ALLOW_AMOUNT && (!_this.state.values.certAmount || _this.state.values.certAmount === "0")) {
	        errors.certAmount = ["You must input a number of certificates greater than 0."];
	      }
	      if (!_this.props.hideAddressBlock && _this.state.values.delivery === '') {
	        errors.delivery = ["A delivery address must be selected."];
	      }
	      if (_this.state.values.delivery === 'email') {
	        if (!_this.state.values.email) {
	          errors.email = ["An email is required"];
	        } else if (_this.state.values.email.split('@').length !== 2 || _this.state.values.email.split('.').length < 2) {
	          errors.email = ["Must be a properly formatted email"];
	        }
	      }
	      if (_this.state.values.delivery === 'mail') {
	        deferredValidators.push(new Promise(function (resolve, reject) {
	          _validate.VALIDATE.addressIsValid(_this.state.values.address, {}, {}, function (isValid, error) {
	            if (isValid === false) {
	              resolve(error);
	            } else {
	              resolve();
	            }
	          });
	        }));
	        deferredValidators.push(new Promise(function (resolve, reject) {
	          _validate.VALIDATE.addressIsRequired(_this.state.values.address, {}, {}, function (isValid, error) {
	            if (isValid === false) {
	              resolve(error);
	            } else {
	              resolve();
	            }
	          });
	        }));
	      }
	      Promise.all(deferredValidators).then(function (addressErrors) {
	        _this.setState({ errors: Object.assign({}, errors, {
	            address: addressErrors.filter(function (err) {
	              return err;
	            })
	          }) });
	        if (Object.keys(errors).length === 0) {
	          _this.props.onCertificateRequested(Object.assign({}, _this.state.values));
	        }
	      });
	    }, _this.getErrors = function (key) {
	      return _this.state.errors[key] ? _this.state.errors[key] : [];
	    }, _this.getIsValid = function (key) {
	      return (0, _Field.getValidityClass)(_this.state.errors[key] ? _this.state.errors[key].length > 0 ? false : null : null);
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(RequestCertificate, [{
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _ref2 = this.props.config || {},
	          ALLOW_EMAIL = _ref2.ALLOW_EMAIL,
	          ALLOW_MAIL = _ref2.ALLOW_MAIL,
	          ALLOW_AMOUNT = _ref2.ALLOW_AMOUNT,
	          _ref2$CERTIFICATION_T = _ref2.CERTIFICATION_TYPES,
	          CERTIFICATION_TYPES = _ref2$CERTIFICATION_T === undefined ? [] : _ref2$CERTIFICATION_T,
	          INSTRUCTIONS = _ref2.INSTRUCTIONS;
	
	      return _react2.default.createElement(
	        'form',
	        { className: 'request-certificate wizard' },
	        INSTRUCTIONS && _react2.default.createElement(_Markdown2.default, { className: 'instructions', source: INSTRUCTIONS }),
	        this.props.hideNameField ? null : _react2.default.createElement(
	          _Field.DumbField,
	          { label: 'Requester name', errorMessage: this.getErrors("requesterName"), required: true },
	          _react2.default.createElement(_Form.TextInput, {
	            validityClass: this.getIsValid("requesterName"),
	            width: '100%',
	            value: this.state.values.requesterName,
	            placeholder: 'John Doe',
	            onChange: function onChange(value) {
	              _this2.setValue(value, 'requesterName');
	            }
	          })
	        ),
	        _react2.default.createElement(
	          _Field.DumbField,
	          { label: 'Certificate type', errorMessage: this.getErrors("certType"), required: true },
	          _react2.default.createElement(_Form.Select, {
	            validityClass: this.getIsValid("certType"),
	            value: this.state.values.certType,
	            onChange: function onChange(value) {
	              _this2.setValue(value, 'certType');
	            },
	            onBlur: _utilities.noop,
	            options: [{ value: "", label: "[Select a certificate type]" }].concat(_toConsumableArray(CERTIFICATION_TYPES))
	          })
	        ),
	        ALLOW_AMOUNT && _react2.default.createElement(
	          _Field.DumbField,
	          { label: 'Number of Certificates', errorMessage: this.getErrors("certAmount"), required: true },
	          _react2.default.createElement(_Form.TextInput, {
	            validityClass: this.getIsValid("certAmount"),
	            value: this.state.values.certAmount,
	            onChange: function onChange(value) {
	              _this2.setValue(_validate.MASK.onlyNumbers(value), 'certAmount');
	            },
	            onBlur: _utilities.noop
	          })
	        ),
	        ALLOW_MAIL && ALLOW_EMAIL && _react2.default.createElement(
	          _Field.DumbField,
	          { label: 'Delivery method', errorMessage: this.getErrors("delivery"), required: true },
	          _react2.default.createElement(_Form.RadioInput, {
	            value: this.state.values.delivery,
	            onChange: function onChange(value) {
	              _this2.setValue(value, 'delivery');
	            },
	            onBlur: _utilities.noop,
	            options: [{ value: "email", label: "Email" }, { value: "mail", label: "Traditional mail" }]
	          })
	        ),
	        this.props.hideAddressBlock ? null : this.state.values.delivery === 'mail' && _react2.default.createElement(
	          _Field.DumbField,
	          { label: ({"NODE_ENV":"production","BUILD_DATE":"2025-08-27T15:15:31.687Z","BUILD_NUMBER":"Not Provided","GIT_VERSION":"v1.3.0-381-ga81e29b08","GIT_COMMIT_HASH":"a81e29b085c9268ffd96c78eb734365802722741","GIT_BRANCH":"beta","PUBLIC_URL":"","STATE_ABBR":"MT","STATE_NAME":"Montana","STATE_ORG_TITLE":"Secretary of State","LOGIN_HEADER_IMG_PATH":"","HOME_IMG_FILENAME":"montana.jpg","FAVICON_FILE_NAME":"favicon.ico","ALLOW_E_SIGN_ON_CORRECTIONS":true,"THIRD_PARTY_SIGNING_ALLOWED":false,"MY_ACCOUNT_SAVE_AND_CLOSE_BUTTON":true,"IE_DEPRECATED_MESSAGE":"Internet Explorer is not supported. Please select a supported browser below to access this website.","ADDITIONAL_ROUTES":{"dataRequests":true,"farmBill":true,"apostille":true,"externalHelp":"https://sosmt.gov/business/help-center/","systemAdministration":[{"title":"Saved Payments","parameter":"saved-payments","componentName":"SavedPayments"}]},"SUBROUTES":[{"label":"Business","component":"Business","parameter":"business","myWorkQueueSearch":false,"sourceTypeId":54,"searchMustHaveOneOf":["FILING_TYPE_ID","STATUS_ID","STATE","search"],"serverWebSearchDescription":true,"serverWorkQueueDescription":true,"serverMyRecordsDescription":true,"searchPlaceholder":"Search by name or filing number (X########)","allowEmptySearchTerm":true,"requestCertificateAlternateLabel":"Request Information","fileAmendmentButtonLabel":"Filing Actions","advancedSearchParameters":[{"type":"radio","name":"QUERY_TYPE_ID","defaultValue":1010,"options":[{"value":1010,"label":"Starts with"},{"value":1011,"label":"Contains"},{"value":1012,"label":" Word Contains"}]},{"type":"serverSelect","name":"FILING_TYPE_ID","optionsSrc":"FILING_TYPES","label":"Entity Type","placeholder":"All","defaultValue":"0"},{"type":"serverSelect","name":"FILING_SUBTYPE_ID","optionsSrc":"FILING_SUBTYPES","label":"Entity Subtype","overrideSubOptionsSrcFromParameterName":"FILING_TYPE_ID","placeholder":"All","defaultValue":"0"},{"type":"serverSelect","name":"STATUS_ID","optionsSrc":"FILING_STATUS_WITHOUT_ALL","label":"Status","placeholder":"All","defaultValue":"0"},{"type":"serverSelect","name":"STATE","optionsSrc":"STATE","label":"State","placeholder":"All","defaultValue":""},{"type":"serverSelect","name":"COUNTY","optionsSrc":"COUNTY_SUBOPTION","label":"County","overrideSubOptionsSrcFromParameterName":"STATE","placeholder":"All","defaultValue":""},{"type":"checkbox","name":"CRA_SEARCH_YN","defaultValue":false,"label":"Search by Registered Agent PID"},{"type":"dateRange","name":"FILING_DATE","label":"Registration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}},{"type":"dateRange","name":"EXPIRATION_DATE","label":"Expiration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}}],"myRecordsFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Active"},{"value":2,"label":"Inactive"},{"value":3,"label":"Pending"}]},{"type":"dateRange","name":"DATE_RANGE","label":"Date range","defaultValue":{"start":null,"end":null}}],"myWorkQueueFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Approved"},{"value":2,"label":"Pending Online Payment"},{"value":3,"label":"Pending Review"},{"value":4,"label":"Needs Correction"},{"value":5,"label":"Rejected"},{"value":6,"label":"Draft"}]},{"type":"dateRange","name":"DATE_RANGE","label":"Date range","defaultValue":{"start":null,"end":null}}]},{"label":"Notary","component":"Notary","parameter":"notary","sourceTypeId":850,"myWorkQueueSearch":false,"allowEmptySearchTerm":true,"requestCertificateAlternateLabel":"Download Certificate","fileAmendmentButtonLabel":"Filing Actions","hideNameRequestCertificate":true,"hideAddressRequestCertificate":true,"hideRecordUserManagment":true,"searchPlaceholder":"Search by name or commission number","searchMustHaveOneOf":["CITY","search","SERVICE_TYPE"],"advancedParametersStartOpen":true,"searchIsSortable":true,"advancedSearchParameters":[{"type":"radio","name":"STARTS_WITH_YN","defaultValue":false,"options":[{"value":true,"label":"Starts with"},{"value":false,"label":"Contains"}]},{"type":"checkbox","name":"ACTIVE_ONLY_YN","defaultValue":true,"label":"Active entities only"},{"type":"text","name":"CITY","defaultValue":"","label":"City"},{"type":"select","name":"SERVICE_TYPE","label":"Special Services Offered","defaultValue":0,"options":[{"value":0,"label":"(N/A)"},{"value":6165,"label":"In-Person Electronic Notarization (IPEN)"},{"value":6166,"label":"Remote Online Notarization (RON)"},{"value":6167,"label":"Mobile Notary Services"},{"value":6168,"label":"Remote Ink Notarization (RIN)"}]}]},{"label":"Apostille","component":"Apostille","parameter":"apostille","sourceTypeId":720,"myRecordsSearch":false,"myWorkQueueSearch":false,"disabled":false,"allowedRoutes":["/forms-manager/","/queue/","/forms/"]},{"label":"Liens","component":"UCC","parameter":"ucc","sourceTypeId":1999,"myRecordsSearch":true,"myWorkQueueSearch":true,"fileAmendmentButtonLabel":"Filing Actions","searchPlaceholder":"Search by name or file number","disabled":false,"serverWebSearchDescription":true,"myRecordsDescription":"","workQueueDescription":"","searchDescription":"","hideRecordUserManagment":true,"searchLiensCheckout":false,"advancedSearchParameters":[{"type":"radio","name":"STARTS_WITH_YN","defaultValue":false,"options":[{"value":true,"label":"Starts with"},{"value":false,"label":"Contains"}]},{"type":"select","name":"STATUS","defaultValue":"ALL","label":"Status","options":[{"value":"ACTIVE_UNLAPSED","label":"Active (unlapsed)"},{"value":"ACTIVE_LAPSED_UNLAPSED","label":"Active (lapsed and unlapsed)"}]},{"type":"text","name":"EXCLUDE_VALUES","label":"Exclude Debtor Names (comma separated list of names to exclude)","defaultValue":""},{"type":"dateRange","name":"FILING_DATE","label":"Financing Statement Date","defaultValue":{"start":null,"end":null}},{"type":"dateRange","name":"LAPSE_DATE","label":"Lapse Date","defaultValue":{"start":null,"end":null}},{"type":"text","name":"CITY","label":"Debtor City","defaultValue":""}],"myRecordsFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Approved"},{"value":2,"label":"Pending Online Payment"},{"value":3,"label":"Pending Review"}]},{"type":"select","name":"TYPE","defaultValue":0,"label":"Lien Type","options":[{"value":0,"label":"All"},{"value":1,"label":"UCC"},{"value":2,"label":"EFS"},{"value":3,"label":"Title 71"}]}],"myWorkQueueFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Approved"},{"value":2,"label":"Pending Online Payment"},{"value":3,"label":"Pending Review"},{"value":4,"label":"Pending Print and Mail"},{"value":5,"label":"Rejected"},{"value":6,"label":"Draft"}]},{"type":"select","name":"TYPE","defaultValue":0,"label":"Lien Type","options":[{"value":0,"label":"All"},{"value":1,"label":"UCC"},{"value":2,"label":"EFS"},{"value":3,"label":"Title 71"}]}]},{"label":"Copy Request","component":"copies","parameter":"copies","sourceTypeId":2001,"myRecordsSearch":false,"myWorkQueueSearch":false,"disabled":false,"allowedRoutes":["/forms-manager/","/queue/","/forms/"]},{"label":"Trademark","component":"Trademark","parameter":"trademark","sourceTypeId":810,"showRequestCertificate":true,"searchMustHaveOneOf":["search","EXPIRATION_DATE","FILING_DATE"],"allowEmptySearchTerm":true,"requestCertificateAlternateLabel":"Request Information","fileAmendmentButtonLabel":"Filing Actions","advancedSearchParameters":[{"type":"radio","name":"QUERY_TYPE_ID","defaultValue":1010,"options":[{"value":1010,"label":"Starts with"},{"value":1011,"label":"Contains"},{"value":1012,"label":" Word Contains"}]},{"type":"checkbox","name":"OWNER_SEARCH_YN","defaultValue":false,"label":"Search owners"},{"type":"radio","name":"SERVICE_MARK_YN","label":"Mark Type","defaultValue":"","options":[{"value":"","label":"All Marks"},{"value":"Y","label":"Service Mark"},{"value":"N","label":"Trademark"}]},{"type":"serverSelect","name":"STATUS_ID","optionsSrc":"TYPE_V|TRADEMARK_STATUS_TYPE","label":"Status","placeholder":"All","defaultValue":"0"},{"type":"select","name":"DESIGN_TYPE_ID","options":[{"value":0,"label":"All"},{"value":990,"label":"Words Only"},{"value":991,"label":"Design Only"},{"value":992,"label":"Words and Design"}],"label":"Design Type","defaultValue":"0"},{"type":"dateRange","name":"FILING_DATE","label":"Registered Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}},{"type":"dateRange","name":"EXPIRATION_DATE","label":"Expiration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}}]},{"label":"Business Info Request","component":"InfoRequests","parameter":"info-request","sourceTypeId":167,"allowedRoutes":["/forms-manager/","/queue/","/forms/"]},{"label":"Data Requests","component":"DataRequests","parameter":"data-request","sourceTypeId":0,"allowedRoutes":["/forms-manager/"]},{"label":"CRA","component":"CRA","parameter":"cra","sourceTypeId":157,"myRecordsSearch":false,"searchPlaceholder":"Search by name or registered agent number","allowedRoutes":["/forms-manager/","/forms/","/records/","/queue/","/search/"],"allowEmptySearchTerm":true,"fileAmendmentButtonLabel":"Filing Actions","advancedSearchParameters":[{"type":"radio","name":"QUERY_TYPE_ID","defaultValue":1010,"options":[{"value":1010,"label":"Starts with"},{"value":1011,"label":"Contains"},{"value":1012,"label":" Word Contains"}]},{"type":"dateRange","name":"CRA_DATE","label":"Registration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}},{"type":"select","name":"STATUS_ID","label":"Status","defaultValue":0,"options":[{"value":0,"label":"All"},{"value":121,"label":"Active"},{"value":122,"label":"Inactive"}]},{"type":"select","name":"AGENT_TYPE_ID","label":"Agent Type","defaultValue":0,"options":[{"value":0,"label":"All"},{"value":460,"label":"Registered Agent"},{"value":461,"label":"Commercial Registered Agent"}]}]},{"label":"Farm Bill","component":"FarmBill","parameter":"farm-bill","path":"/lists/farm-bill","sourceTypeId":0,"myRecordsSearch":false,"allowedRules":["/search/"],"disabled":true,"searchDescription":"To perform a search, enter a debtor name. Your search results may include: exact debtor name, variations of that name and any filing that includes your search criteria. Punctuation is ignored.\n\nYou can click on \"Advanced\" to refine your search. Under “Advanced” you can search by crop, year, county and SSN/FEIN. As a registered Farm Bill Buyer with the Montana Secretary of State’s office it is important to maintain the confidentiality of the information contained within the Farm Bill Master List. The Farm Bill Master List reflects personal data, such as Social Security Numbers, which are a key piece of personal identifiable information to assist you in determining the existence of a lien against a specific debtor. The distribution of this information beyond its intended purpose is strictly prohibited.\n\nThe debtor's tax identification number has been hidden for confidentiality reasons. You may continue to search on a tax ID number and return debtors that match your search criteria. The SSN/FEIN must be entered without dashes or spaces.","searchMustHaveOneOf":["search","UCC_FARM_PRODUCT_ID","COUNTY"],"searchPlaceholder":"Search by debtor name","advancedSearchParameters":[{"type":"ServerMultiComplete","label":"Product code name(s)","name":"UCC_FARM_PRODUCT_ID","defaultValue":"","optionsSrc":"UCC_FARM_PRODUCT_V"},{"type":"MultiComplete","label":"Year or Range of Years","name":"YEAR_NUM","optionsSrc":"years","startYear":"1968","defaultValue":[],"preMergeOptions":[{"value":"ALL","label":"All"}]},{"type":"serverSelect","label":"State","name":"STATE","defaultValue":"MONTANA","optionsSrc":"STATE"},{"type":"ServerMultiComplete","label":"County","name":"COUNTY","defaultValue":[],"optionsSrc":"COUNTY","overrideSubOptionsSrcFromParameterName":"STATE"},{"type":"checkbox","name":"TIN_SEARCH_YN","defaultValue":false,"label":"Tax Identification Number Search"},{"type":"checkbox","name":"TIN_SORT_YN","defaultValue":false,"label":"Unique ID Sort"}]}],"SYSTEM_NICKNAME":"Online Services Portal","PAYMENT_METHODS":[{"type":"bypass"},{"type":"iTransact"}],"PAYMENT_ALLOW_AMEX":true,"SYSTEM_ID_LABEL":"System Id","DOUBLE_COLUMN_PUBLIC_LOGIN":true,"INTERNAL_USER_MANAGEMENT":true,"ALLOW_PUBLIC_JSON_IMPORT":false,"MAX_FILE_UPLOAD_SIZE":10000000,"REFUND_TEXT":"","RETURN_TO_HOME_ON_LOGOUT":true,"CURRENT_SOS_NAME":"Christi Jacobsen","LOGO_FILENAME":"mt-sos-logo.png","LOGO_ALT":"Christi Jacobsen, Montana Secretary of State","LOGO_FULL_WIDTH":true,"HOME_HIDE_AUTH_HINT":true,"HOME_TITLE":"Montana Secretary of State","CUSTOM_TAB_TITLE":"Official Montana","HOME_SUBTITLE":"Online Business Services","ENTITY_NAME_CONSENT_DESCRIPTION":"","ALLOW_USER_PROFILE_EDITING":true,"COMPARE_FOREIGN_NAME_IN_ENTITY_NAME_VALIDATION":true,"FOREIGN_NAME_FIELD_NAME":"KIMA_PARENT_NAME_INFO","LOGIN_TITLE":"Montana Secretary of State Online Filing Portal Login","PUBLIC_LOGIN_LABEL":"Username","REVERSE_LOGIN_COLUMNS":true,"LOGIN_SEAL_FILENAME":"seal_white.png","SEPARATE_USERNAME_AND_EMAIL":true,"CREATE_ACCOUNT_BUTTON_ALIGN_LEFT":true,"CREATE_ACCOUNT_BUTTON_TEXT":"CREATE AN ACCOUNT","PASSWORD_CUSTOM_ERROR_TEXT":"The password must meet all requirements","ACCOUNT_CREATED_MESSAGE":"Please check your email to verify your account to login and allow a few minutes for this message to arrive. Check your junk/spam folders if you do not find the email in your inbox.","PUBLIC_LOGIN_PLACEHOLDER":" ","DISABLE_DEFAULT_PAYMENT_RADIO":true,"CUSTOM_RESET_PASSWORD_ERROR_MESSAGE":"Username invalid - no account found","PUBLIC_LOGIN_CREATE_DESCRIPTION":"### Existing User:\n\n  - Enter your username and password to login.  \n\n\n  #### - OR -  \n\n\n\n  - Forgot password? Click 'Reset Password' and follow the prompts.\n  - Forgot username? Click 'Forgot Username' and follow the prompts.  \n\n\n  ### New User:\n  ","LOGIN_HELP_LINK":"https://sosmt.gov/business/how-do-i/","LOGIN_HELP_LINK_TEXT":"Need Help?","FORGOT_USERNAME_TEXT":"Forgot Username?","LOGIN_ACTIVE_DIRECTORY_TEXT":"State User Login","MULTIPLE_LOGIN_METHODS":true,"HAS_ACTIVE_DIRECTORY_LOGIN":true,"RESET_PASSWORD_WITH_USERNAME":true,"DOWNLOAD_LINK":true,"SHOW_USERNAME_ACCOUNT_CREATE":true,"SHOW_SCROLL_DOWN_ARROW":true,"SHOW_ADDRESS_ACCOUNT_CREATE":true,"TWO_COLUMN_ACCOUNT_CREATE":true,"RESET_PASSWORD_TIP":"A link to change your password has been sent to your email. Please allow a few minutes for this message to arrive. Please check your junk/spam folders if you do not find the email in your inbox.","FORGOT_PASSWORD_LINK_TEXT":"Reset Password","PHONE_NUMBER_OPTIONAL_ACCOUNT_CREATE":true,"SHOW_REQUIRED_INDICATOR_ACCOUNT_CREATE":true,"PASSWORD_REQUIREMENTS_ACCOUNT_CREATE":"\n    <ul>\n      <li>MUST contain at least 8 characters (12+ recommended)</li>\n      <li>MUST contain at least one uppercase letter.</li>\n      <li>MUST contain at least one lowercase letter.</li>\n      <li>MUST contain at least one number.</li>\n      <li>MUST contain at least one special character (!”#$%&'()*+,-./:;<=>?</li>\n    </ul>\n  ","ALLOW_CERTIFICATION_REQUEST":true,"ALLOW_PUBLIC_CERTIFICATE_REQUEST":true,"ALLOW_COPY_REQUEST":false,"ALLOW_CORRECTION_STYLING":true,"HIDE_DEPRECATION_WARNING":false,"AMEND_ROUTE_PUBLIC":true,"SEAL_FILENAME":"seal.png","SHOPPING_CART":true,"ALLOW_PAYMENT_UPDATE_WITH_EMPTY_CART":true,"RA_EMAIL":true,"RA_WEBSITE":true,"RA_NO_DEFAULT_TYPE":true,"RA_ADDRESS_LABEL":"Street Address","RA_TYPE_SELECTION_DEFAULT":true,"RA_DEFAULT_TYPE":"460","RA_OVERRIDE_TYPE_WITH_DEFAULT":true,"RA_PRINCIPAL_ADDRESS_AMS":true,"UPLOAD_AND_SUBMIT_HIDE_IF_ONE_OPTION":true,"PAYMENT_PROCESSING_MESSAGE":"Your payment is processing - Do not close your browser or click the back button","CHECKOUT_BUTTON_WHEN_PROCESSING_TEXT":"Processing","EFS_CROP_PICKER_NONE_LABEL":"Lien Duration","DISALLOWED_WIZARD_PIECES":["FormationLocale"],"REPEATER_SHOW_EDIT_BUTTON":true,"DATA_REQUEST_PAGE_TITLE":"Data Requests and Subscriptions","DATA_REQUEST_SIDEBAR_LABEL":"Data Requests & Subscriptions","LOGIN_REDIRECTS_TO_EPASS":false,"LOGIN_REDIRECTS_TO_ACTIVE_DIRECTORY":true,"LOGIN_ACTIVE_DIRECTORY_LINK":true,"FETCH_EDIT_USER_LINK":false,"LISTS_FETCH_AVAILABLE_LISTS":true,"POST_WIZARD_SUBMIT_REDIRECT_URL":"/","PIN_REQUEST_ATTESTATIONS":true,"PIN_REQUEST_DESCRIPTION":"Click **Request PIN** to have a new PIN sent to the account holder's email address on file.","OWNERSHIP_REQUEST_DESCRIPTION":"To become an **authorized user** of this record, a current **AUTHORIZED USER** will need to grant you access. To request access, click **Request Access** below.","PIN_REQUEST_SUCCESS_MESSAGE":"The PIN you have requested for this entity has been sent to the email associated with your user account.  You should receive the PIN in approximately 3-5 minutes, depending on your email service provider.","APOSTILLE_HEADER_LABEL":"Verification Information","APOSTILLE_NUMBER_LABEL":"Apostille/Authentication","APOSTILLE_CITY_STATE_OVERRIDE":"HELENA, MT","APOSTILLE_FILING_DATE_LABEL":"Issue Date","APOSTILLE_CITY_STATE_IN_CERTIFIED":true,"NOTARY_EXISTING_FILING":true,"ALLOW_REVOKE_OWN_ACCESS_ONLY":false,"HIDE_CANCEL_ON_ONETIME_DATA_REQUESTS":true,"DATA_REQUESTS_IN_SHOPPING_CART":true,"WQ_ALLOW_EDIT_PENDING_PAYMENT":true,"WQ_CONFIRM_ON_DELETE":true,"WQ_DELETE_CONFIRM_MESSAGE":"Deleting this filing will forfeit any money already paid to the Secretary of State. This action is permanent and cannot be undone, are you sure you would like to delete?","PASS_ITEM_GUIDS_ON_CHECKOUT":true,"FORM_REVISION_HISTORY":true,"CHECKOUT_DISCLAIMER":"By entering your credit card and/or checking account information you (i) state that **you are an authorized user** of the credit card and/or electronic check and that the associated information entered (e.g., account holder name, account number, billing address) is accurate, (ii) **you authorize payment processor to charge the amount you have requested** to your credit card and/or funding account, and (iii) **acknowledge if a charge is declined or reversed you may also be assessed a customary charge** by the payment processor for such transactions.","FARM_BILL_SEARCH_CONFIDENTIAL":"As a registered Farm Bill Buyer with the Montana Secretary of State’s office it is important to maintain the confidentiality of the information contained within the Farm Bill Master List. The Farm Bill Master List reflects personal data, such as Social Security Numbers, which are a key piece of personal identifiable information to assist you in determining the existence of a lien against a specific debtor. The distribution of this information beyond its intended purpose is strictly prohibited.\n\n**The debtor's tax identification number has been hidden for confidentiality reasons. You may continue to search on a tax ID number and return debtors that match your search criteria. The SSN/FEIN must be entered without dashes or spaces.  If you need access to the tax identification number to clearly identify the debtor, please contact the UCC unit at (406) 444-3665.**","VIEW_HISTORY_BUTTON_ALT_TEXT":"View Filings","WIZARD_ERROR_TITLE_MESSAGE":"Form Error","FARM_BILL_SEARCH_INTERACTIVE":true,"USE_FARM_BILL_API":true,"DISALLOW_ASSIGN_SELF_AS_RA":true,"DISALLOW_ASSIGN_SELF_AS_PRINCIPAL":true,"USE_TRADEMARK_OWNER_VALIDATION":true,"USE_ALTERNATIVE_FOREIGN_ADDRESS_LABELS":true,"MY_RECEIPTS_FILTER":[{"type":"dateRange","name":"DATE_RANGE","label":"Date range","defaultValue":{"start":null,"end":null}},{"type":"text","name":"REF_NUM","defaultValue":"","label":"Reference Number"},{"type":"text","name":"RECEIPT_NUM","defaultValue":"","label":"Receipt Id"},{"type":"text","name":"AMOUNT","defaultValue":"","label":"Amount"},{"type":"select","name":"TYPE","defaultValue":"","label":"Payment Type","options":[{"value":"","label":"All"},{"value":"CC","label":"Credit Card"},{"value":"Check","label":"Check"}]}],"MY_RECEIPTS_SHOW_IN_SIDEBAR":true,"SHOW_MY_RECEIPTS_HELPER_TEXT":true,"MY_RECEIPTS_HELPER_LABEL":"About Receipt Search","MY_RECEIPTS_HELPER_TEXT":"You can search for receipts based on their descriptions, including the items paid for on the receipt. Use the filters to search for or filter specific information.","FARM_BILL_SUBLINK":{"label":"Farm Bill","component":"FarmBill","parameter":"farm-bill","path":"/lists/farm-bill","sourceTypeId":0,"myRecordsSearch":false,"allowedRules":["/search/"],"disabled":true,"searchDescription":"To perform a search, enter a debtor name. Your search results may include: exact debtor name, variations of that name and any filing that includes your search criteria. Punctuation is ignored.\n\nYou can click on \"Advanced\" to refine your search. Under “Advanced” you can search by crop, year, county and SSN/FEIN. As a registered Farm Bill Buyer with the Montana Secretary of State’s office it is important to maintain the confidentiality of the information contained within the Farm Bill Master List. The Farm Bill Master List reflects personal data, such as Social Security Numbers, which are a key piece of personal identifiable information to assist you in determining the existence of a lien against a specific debtor. The distribution of this information beyond its intended purpose is strictly prohibited.\n\nThe debtor's tax identification number has been hidden for confidentiality reasons. You may continue to search on a tax ID number and return debtors that match your search criteria. The SSN/FEIN must be entered without dashes or spaces.","searchMustHaveOneOf":["search","UCC_FARM_PRODUCT_ID","COUNTY"],"searchPlaceholder":"Search by debtor name","advancedSearchParameters":[{"type":"ServerMultiComplete","label":"Product code name(s)","name":"UCC_FARM_PRODUCT_ID","defaultValue":"","optionsSrc":"UCC_FARM_PRODUCT_V"},{"type":"MultiComplete","label":"Year or Range of Years","name":"YEAR_NUM","optionsSrc":"years","startYear":"1968","defaultValue":[],"preMergeOptions":[{"value":"ALL","label":"All"}]},{"type":"serverSelect","label":"State","name":"STATE","defaultValue":"MONTANA","optionsSrc":"STATE"},{"type":"ServerMultiComplete","label":"County","name":"COUNTY","defaultValue":[],"optionsSrc":"COUNTY","overrideSubOptionsSrcFromParameterName":"STATE"},{"type":"checkbox","name":"TIN_SEARCH_YN","defaultValue":false,"label":"Tax Identification Number Search"},{"type":"checkbox","name":"TIN_SORT_YN","defaultValue":false,"label":"Unique ID Sort"}]},"ALLOW_ADDRESS_VALIDATION_BYPASS_OPTION":true,"DEFAULT_ADDRESS_VALIDATION_BYPASS_OPTION_CHECKED":true}).CERTIFICATION_ADDRESS_LABEL || "Delivery address", errorMessage: this.getErrors("address"), required: true },
	          _react2.default.createElement(_AddressBlock.AddressBlock, {
	            isValid: (this.state.errors.address || []).length > 0 ? false : null,
	            width: '100%',
	            value: this.state.values.address,
	            onChange: function onChange(value) {
	              _this2.setValue(value, 'address');
	            },
	            showCityStateZip: true,
	            allowSelection: false,
	            singleColSize: 'col-12',
	            triColSizes: {
	              CITY: 'col-4',
	              STATE: 'col-4',
	              POSTAL_CODE: 'col-4'
	            }
	          })
	        ),
	        this.state.values.delivery === 'email' && _react2.default.createElement(
	          _Field.DumbField,
	          { label: 'Email address', errorMessage: this.getErrors("email"), required: true },
	          _react2.default.createElement(_Form.TextInput, {
	            validityClass: this.getIsValid("email"),
	            width: '100%',
	            value: this.state.values.email,
	            placeholder: 'example@email.com',
	            onChange: function onChange(value) {
	              _this2.setValue(value, 'email');
	            }
	          })
	        ),
	        this.state.globalError && _react2.default.createElement(
	          _CreateAccount.FieldError,
	          null,
	          'Something went wrong while requesting your certificate. Please try again later, and if the problem persists contact customer support.'
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'controls' },
	          _react2.default.createElement(
	            'button',
	            { type: 'button', className: 'btn btn-primary btn-raised', onClick: this.validate },
	            'Request a Certificate'
	          )
	        )
	      );
	    }
	  }]);
	
	  return RequestCertificate;
	}(_react2.default.Component);
	
	exports.default = RequestCertificate;

/***/ },
/* 1058 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Shell = __webpack_require__(19);
	
	var _Field = __webpack_require__(25);
	
	var _Form = __webpack_require__(14);
	
	var _FormCard = __webpack_require__(195);
	
	var _FormCard2 = _interopRequireDefault(_FormCard);
	
	var _requests = __webpack_require__(6);
	
	var _shield = __webpack_require__(338);
	
	var _shield2 = _interopRequireDefault(_shield);
	
	var _format = __webpack_require__(33);
	
	var _format2 = _interopRequireDefault(_format);
	
	__webpack_require__(1432);
	
	var _Form2 = __webpack_require__(14);
	
	var _Markdown = __webpack_require__(24);
	
	var _Markdown2 = _interopRequireDefault(_Markdown);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var VerifyCertificate = function (_React$Component) {
	  _inherits(VerifyCertificate, _React$Component);
	
	  function VerifyCertificate() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, VerifyCertificate);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = VerifyCertificate.__proto__ || Object.getPrototypeOf(VerifyCertificate)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      certificateId: '',
	      errors: {},
	      certificate: null,
	      certError: null,
	      category: 'business'
	    }, _this.setCertificateId = function (certificateId) {
	      _this.setState({ certificateId: certificateId });
	    }, _this.checkEnter = function (e) {
	      if (e.charCode === 13) {
	        _this.validate();
	      }
	    }, _this.validate = function () {
	      if (_this.state.certificateId === '') {
	        _this.setState({
	          errors: {
	            certificateId: ({"NODE_ENV":"production","BUILD_DATE":"2025-08-27T15:15:31.687Z","BUILD_NUMBER":"Not Provided","GIT_VERSION":"v1.3.0-381-ga81e29b08","GIT_COMMIT_HASH":"a81e29b085c9268ffd96c78eb734365802722741","GIT_BRANCH":"beta","PUBLIC_URL":"","STATE_ABBR":"MT","STATE_NAME":"Montana","STATE_ORG_TITLE":"Secretary of State","LOGIN_HEADER_IMG_PATH":"","HOME_IMG_FILENAME":"montana.jpg","FAVICON_FILE_NAME":"favicon.ico","ALLOW_E_SIGN_ON_CORRECTIONS":true,"THIRD_PARTY_SIGNING_ALLOWED":false,"MY_ACCOUNT_SAVE_AND_CLOSE_BUTTON":true,"IE_DEPRECATED_MESSAGE":"Internet Explorer is not supported. Please select a supported browser below to access this website.","ADDITIONAL_ROUTES":{"dataRequests":true,"farmBill":true,"apostille":true,"externalHelp":"https://sosmt.gov/business/help-center/","systemAdministration":[{"title":"Saved Payments","parameter":"saved-payments","componentName":"SavedPayments"}]},"SUBROUTES":[{"label":"Business","component":"Business","parameter":"business","myWorkQueueSearch":false,"sourceTypeId":54,"searchMustHaveOneOf":["FILING_TYPE_ID","STATUS_ID","STATE","search"],"serverWebSearchDescription":true,"serverWorkQueueDescription":true,"serverMyRecordsDescription":true,"searchPlaceholder":"Search by name or filing number (X########)","allowEmptySearchTerm":true,"requestCertificateAlternateLabel":"Request Information","fileAmendmentButtonLabel":"Filing Actions","advancedSearchParameters":[{"type":"radio","name":"QUERY_TYPE_ID","defaultValue":1010,"options":[{"value":1010,"label":"Starts with"},{"value":1011,"label":"Contains"},{"value":1012,"label":" Word Contains"}]},{"type":"serverSelect","name":"FILING_TYPE_ID","optionsSrc":"FILING_TYPES","label":"Entity Type","placeholder":"All","defaultValue":"0"},{"type":"serverSelect","name":"FILING_SUBTYPE_ID","optionsSrc":"FILING_SUBTYPES","label":"Entity Subtype","overrideSubOptionsSrcFromParameterName":"FILING_TYPE_ID","placeholder":"All","defaultValue":"0"},{"type":"serverSelect","name":"STATUS_ID","optionsSrc":"FILING_STATUS_WITHOUT_ALL","label":"Status","placeholder":"All","defaultValue":"0"},{"type":"serverSelect","name":"STATE","optionsSrc":"STATE","label":"State","placeholder":"All","defaultValue":""},{"type":"serverSelect","name":"COUNTY","optionsSrc":"COUNTY_SUBOPTION","label":"County","overrideSubOptionsSrcFromParameterName":"STATE","placeholder":"All","defaultValue":""},{"type":"checkbox","name":"CRA_SEARCH_YN","defaultValue":false,"label":"Search by Registered Agent PID"},{"type":"dateRange","name":"FILING_DATE","label":"Registration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}},{"type":"dateRange","name":"EXPIRATION_DATE","label":"Expiration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}}],"myRecordsFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Active"},{"value":2,"label":"Inactive"},{"value":3,"label":"Pending"}]},{"type":"dateRange","name":"DATE_RANGE","label":"Date range","defaultValue":{"start":null,"end":null}}],"myWorkQueueFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Approved"},{"value":2,"label":"Pending Online Payment"},{"value":3,"label":"Pending Review"},{"value":4,"label":"Needs Correction"},{"value":5,"label":"Rejected"},{"value":6,"label":"Draft"}]},{"type":"dateRange","name":"DATE_RANGE","label":"Date range","defaultValue":{"start":null,"end":null}}]},{"label":"Notary","component":"Notary","parameter":"notary","sourceTypeId":850,"myWorkQueueSearch":false,"allowEmptySearchTerm":true,"requestCertificateAlternateLabel":"Download Certificate","fileAmendmentButtonLabel":"Filing Actions","hideNameRequestCertificate":true,"hideAddressRequestCertificate":true,"hideRecordUserManagment":true,"searchPlaceholder":"Search by name or commission number","searchMustHaveOneOf":["CITY","search","SERVICE_TYPE"],"advancedParametersStartOpen":true,"searchIsSortable":true,"advancedSearchParameters":[{"type":"radio","name":"STARTS_WITH_YN","defaultValue":false,"options":[{"value":true,"label":"Starts with"},{"value":false,"label":"Contains"}]},{"type":"checkbox","name":"ACTIVE_ONLY_YN","defaultValue":true,"label":"Active entities only"},{"type":"text","name":"CITY","defaultValue":"","label":"City"},{"type":"select","name":"SERVICE_TYPE","label":"Special Services Offered","defaultValue":0,"options":[{"value":0,"label":"(N/A)"},{"value":6165,"label":"In-Person Electronic Notarization (IPEN)"},{"value":6166,"label":"Remote Online Notarization (RON)"},{"value":6167,"label":"Mobile Notary Services"},{"value":6168,"label":"Remote Ink Notarization (RIN)"}]}]},{"label":"Apostille","component":"Apostille","parameter":"apostille","sourceTypeId":720,"myRecordsSearch":false,"myWorkQueueSearch":false,"disabled":false,"allowedRoutes":["/forms-manager/","/queue/","/forms/"]},{"label":"Liens","component":"UCC","parameter":"ucc","sourceTypeId":1999,"myRecordsSearch":true,"myWorkQueueSearch":true,"fileAmendmentButtonLabel":"Filing Actions","searchPlaceholder":"Search by name or file number","disabled":false,"serverWebSearchDescription":true,"myRecordsDescription":"","workQueueDescription":"","searchDescription":"","hideRecordUserManagment":true,"searchLiensCheckout":false,"advancedSearchParameters":[{"type":"radio","name":"STARTS_WITH_YN","defaultValue":false,"options":[{"value":true,"label":"Starts with"},{"value":false,"label":"Contains"}]},{"type":"select","name":"STATUS","defaultValue":"ALL","label":"Status","options":[{"value":"ACTIVE_UNLAPSED","label":"Active (unlapsed)"},{"value":"ACTIVE_LAPSED_UNLAPSED","label":"Active (lapsed and unlapsed)"}]},{"type":"text","name":"EXCLUDE_VALUES","label":"Exclude Debtor Names (comma separated list of names to exclude)","defaultValue":""},{"type":"dateRange","name":"FILING_DATE","label":"Financing Statement Date","defaultValue":{"start":null,"end":null}},{"type":"dateRange","name":"LAPSE_DATE","label":"Lapse Date","defaultValue":{"start":null,"end":null}},{"type":"text","name":"CITY","label":"Debtor City","defaultValue":""}],"myRecordsFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Approved"},{"value":2,"label":"Pending Online Payment"},{"value":3,"label":"Pending Review"}]},{"type":"select","name":"TYPE","defaultValue":0,"label":"Lien Type","options":[{"value":0,"label":"All"},{"value":1,"label":"UCC"},{"value":2,"label":"EFS"},{"value":3,"label":"Title 71"}]}],"myWorkQueueFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Approved"},{"value":2,"label":"Pending Online Payment"},{"value":3,"label":"Pending Review"},{"value":4,"label":"Pending Print and Mail"},{"value":5,"label":"Rejected"},{"value":6,"label":"Draft"}]},{"type":"select","name":"TYPE","defaultValue":0,"label":"Lien Type","options":[{"value":0,"label":"All"},{"value":1,"label":"UCC"},{"value":2,"label":"EFS"},{"value":3,"label":"Title 71"}]}]},{"label":"Copy Request","component":"copies","parameter":"copies","sourceTypeId":2001,"myRecordsSearch":false,"myWorkQueueSearch":false,"disabled":false,"allowedRoutes":["/forms-manager/","/queue/","/forms/"]},{"label":"Trademark","component":"Trademark","parameter":"trademark","sourceTypeId":810,"showRequestCertificate":true,"searchMustHaveOneOf":["search","EXPIRATION_DATE","FILING_DATE"],"allowEmptySearchTerm":true,"requestCertificateAlternateLabel":"Request Information","fileAmendmentButtonLabel":"Filing Actions","advancedSearchParameters":[{"type":"radio","name":"QUERY_TYPE_ID","defaultValue":1010,"options":[{"value":1010,"label":"Starts with"},{"value":1011,"label":"Contains"},{"value":1012,"label":" Word Contains"}]},{"type":"checkbox","name":"OWNER_SEARCH_YN","defaultValue":false,"label":"Search owners"},{"type":"radio","name":"SERVICE_MARK_YN","label":"Mark Type","defaultValue":"","options":[{"value":"","label":"All Marks"},{"value":"Y","label":"Service Mark"},{"value":"N","label":"Trademark"}]},{"type":"serverSelect","name":"STATUS_ID","optionsSrc":"TYPE_V|TRADEMARK_STATUS_TYPE","label":"Status","placeholder":"All","defaultValue":"0"},{"type":"select","name":"DESIGN_TYPE_ID","options":[{"value":0,"label":"All"},{"value":990,"label":"Words Only"},{"value":991,"label":"Design Only"},{"value":992,"label":"Words and Design"}],"label":"Design Type","defaultValue":"0"},{"type":"dateRange","name":"FILING_DATE","label":"Registered Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}},{"type":"dateRange","name":"EXPIRATION_DATE","label":"Expiration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}}]},{"label":"Business Info Request","component":"InfoRequests","parameter":"info-request","sourceTypeId":167,"allowedRoutes":["/forms-manager/","/queue/","/forms/"]},{"label":"Data Requests","component":"DataRequests","parameter":"data-request","sourceTypeId":0,"allowedRoutes":["/forms-manager/"]},{"label":"CRA","component":"CRA","parameter":"cra","sourceTypeId":157,"myRecordsSearch":false,"searchPlaceholder":"Search by name or registered agent number","allowedRoutes":["/forms-manager/","/forms/","/records/","/queue/","/search/"],"allowEmptySearchTerm":true,"fileAmendmentButtonLabel":"Filing Actions","advancedSearchParameters":[{"type":"radio","name":"QUERY_TYPE_ID","defaultValue":1010,"options":[{"value":1010,"label":"Starts with"},{"value":1011,"label":"Contains"},{"value":1012,"label":" Word Contains"}]},{"type":"dateRange","name":"CRA_DATE","label":"Registration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}},{"type":"select","name":"STATUS_ID","label":"Status","defaultValue":0,"options":[{"value":0,"label":"All"},{"value":121,"label":"Active"},{"value":122,"label":"Inactive"}]},{"type":"select","name":"AGENT_TYPE_ID","label":"Agent Type","defaultValue":0,"options":[{"value":0,"label":"All"},{"value":460,"label":"Registered Agent"},{"value":461,"label":"Commercial Registered Agent"}]}]},{"label":"Farm Bill","component":"FarmBill","parameter":"farm-bill","path":"/lists/farm-bill","sourceTypeId":0,"myRecordsSearch":false,"allowedRules":["/search/"],"disabled":true,"searchDescription":"To perform a search, enter a debtor name. Your search results may include: exact debtor name, variations of that name and any filing that includes your search criteria. Punctuation is ignored.\n\nYou can click on \"Advanced\" to refine your search. Under “Advanced” you can search by crop, year, county and SSN/FEIN. As a registered Farm Bill Buyer with the Montana Secretary of State’s office it is important to maintain the confidentiality of the information contained within the Farm Bill Master List. The Farm Bill Master List reflects personal data, such as Social Security Numbers, which are a key piece of personal identifiable information to assist you in determining the existence of a lien against a specific debtor. The distribution of this information beyond its intended purpose is strictly prohibited.\n\nThe debtor's tax identification number has been hidden for confidentiality reasons. You may continue to search on a tax ID number and return debtors that match your search criteria. The SSN/FEIN must be entered without dashes or spaces.","searchMustHaveOneOf":["search","UCC_FARM_PRODUCT_ID","COUNTY"],"searchPlaceholder":"Search by debtor name","advancedSearchParameters":[{"type":"ServerMultiComplete","label":"Product code name(s)","name":"UCC_FARM_PRODUCT_ID","defaultValue":"","optionsSrc":"UCC_FARM_PRODUCT_V"},{"type":"MultiComplete","label":"Year or Range of Years","name":"YEAR_NUM","optionsSrc":"years","startYear":"1968","defaultValue":[],"preMergeOptions":[{"value":"ALL","label":"All"}]},{"type":"serverSelect","label":"State","name":"STATE","defaultValue":"MONTANA","optionsSrc":"STATE"},{"type":"ServerMultiComplete","label":"County","name":"COUNTY","defaultValue":[],"optionsSrc":"COUNTY","overrideSubOptionsSrcFromParameterName":"STATE"},{"type":"checkbox","name":"TIN_SEARCH_YN","defaultValue":false,"label":"Tax Identification Number Search"},{"type":"checkbox","name":"TIN_SORT_YN","defaultValue":false,"label":"Unique ID Sort"}]}],"SYSTEM_NICKNAME":"Online Services Portal","PAYMENT_METHODS":[{"type":"bypass"},{"type":"iTransact"}],"PAYMENT_ALLOW_AMEX":true,"SYSTEM_ID_LABEL":"System Id","DOUBLE_COLUMN_PUBLIC_LOGIN":true,"INTERNAL_USER_MANAGEMENT":true,"ALLOW_PUBLIC_JSON_IMPORT":false,"MAX_FILE_UPLOAD_SIZE":10000000,"REFUND_TEXT":"","RETURN_TO_HOME_ON_LOGOUT":true,"CURRENT_SOS_NAME":"Christi Jacobsen","LOGO_FILENAME":"mt-sos-logo.png","LOGO_ALT":"Christi Jacobsen, Montana Secretary of State","LOGO_FULL_WIDTH":true,"HOME_HIDE_AUTH_HINT":true,"HOME_TITLE":"Montana Secretary of State","CUSTOM_TAB_TITLE":"Official Montana","HOME_SUBTITLE":"Online Business Services","ENTITY_NAME_CONSENT_DESCRIPTION":"","ALLOW_USER_PROFILE_EDITING":true,"COMPARE_FOREIGN_NAME_IN_ENTITY_NAME_VALIDATION":true,"FOREIGN_NAME_FIELD_NAME":"KIMA_PARENT_NAME_INFO","LOGIN_TITLE":"Montana Secretary of State Online Filing Portal Login","PUBLIC_LOGIN_LABEL":"Username","REVERSE_LOGIN_COLUMNS":true,"LOGIN_SEAL_FILENAME":"seal_white.png","SEPARATE_USERNAME_AND_EMAIL":true,"CREATE_ACCOUNT_BUTTON_ALIGN_LEFT":true,"CREATE_ACCOUNT_BUTTON_TEXT":"CREATE AN ACCOUNT","PASSWORD_CUSTOM_ERROR_TEXT":"The password must meet all requirements","ACCOUNT_CREATED_MESSAGE":"Please check your email to verify your account to login and allow a few minutes for this message to arrive. Check your junk/spam folders if you do not find the email in your inbox.","PUBLIC_LOGIN_PLACEHOLDER":" ","DISABLE_DEFAULT_PAYMENT_RADIO":true,"CUSTOM_RESET_PASSWORD_ERROR_MESSAGE":"Username invalid - no account found","PUBLIC_LOGIN_CREATE_DESCRIPTION":"### Existing User:\n\n  - Enter your username and password to login.  \n\n\n  #### - OR -  \n\n\n\n  - Forgot password? Click 'Reset Password' and follow the prompts.\n  - Forgot username? Click 'Forgot Username' and follow the prompts.  \n\n\n  ### New User:\n  ","LOGIN_HELP_LINK":"https://sosmt.gov/business/how-do-i/","LOGIN_HELP_LINK_TEXT":"Need Help?","FORGOT_USERNAME_TEXT":"Forgot Username?","LOGIN_ACTIVE_DIRECTORY_TEXT":"State User Login","MULTIPLE_LOGIN_METHODS":true,"HAS_ACTIVE_DIRECTORY_LOGIN":true,"RESET_PASSWORD_WITH_USERNAME":true,"DOWNLOAD_LINK":true,"SHOW_USERNAME_ACCOUNT_CREATE":true,"SHOW_SCROLL_DOWN_ARROW":true,"SHOW_ADDRESS_ACCOUNT_CREATE":true,"TWO_COLUMN_ACCOUNT_CREATE":true,"RESET_PASSWORD_TIP":"A link to change your password has been sent to your email. Please allow a few minutes for this message to arrive. Please check your junk/spam folders if you do not find the email in your inbox.","FORGOT_PASSWORD_LINK_TEXT":"Reset Password","PHONE_NUMBER_OPTIONAL_ACCOUNT_CREATE":true,"SHOW_REQUIRED_INDICATOR_ACCOUNT_CREATE":true,"PASSWORD_REQUIREMENTS_ACCOUNT_CREATE":"\n    <ul>\n      <li>MUST contain at least 8 characters (12+ recommended)</li>\n      <li>MUST contain at least one uppercase letter.</li>\n      <li>MUST contain at least one lowercase letter.</li>\n      <li>MUST contain at least one number.</li>\n      <li>MUST contain at least one special character (!”#$%&'()*+,-./:;<=>?</li>\n    </ul>\n  ","ALLOW_CERTIFICATION_REQUEST":true,"ALLOW_PUBLIC_CERTIFICATE_REQUEST":true,"ALLOW_COPY_REQUEST":false,"ALLOW_CORRECTION_STYLING":true,"HIDE_DEPRECATION_WARNING":false,"AMEND_ROUTE_PUBLIC":true,"SEAL_FILENAME":"seal.png","SHOPPING_CART":true,"ALLOW_PAYMENT_UPDATE_WITH_EMPTY_CART":true,"RA_EMAIL":true,"RA_WEBSITE":true,"RA_NO_DEFAULT_TYPE":true,"RA_ADDRESS_LABEL":"Street Address","RA_TYPE_SELECTION_DEFAULT":true,"RA_DEFAULT_TYPE":"460","RA_OVERRIDE_TYPE_WITH_DEFAULT":true,"RA_PRINCIPAL_ADDRESS_AMS":true,"UPLOAD_AND_SUBMIT_HIDE_IF_ONE_OPTION":true,"PAYMENT_PROCESSING_MESSAGE":"Your payment is processing - Do not close your browser or click the back button","CHECKOUT_BUTTON_WHEN_PROCESSING_TEXT":"Processing","EFS_CROP_PICKER_NONE_LABEL":"Lien Duration","DISALLOWED_WIZARD_PIECES":["FormationLocale"],"REPEATER_SHOW_EDIT_BUTTON":true,"DATA_REQUEST_PAGE_TITLE":"Data Requests and Subscriptions","DATA_REQUEST_SIDEBAR_LABEL":"Data Requests & Subscriptions","LOGIN_REDIRECTS_TO_EPASS":false,"LOGIN_REDIRECTS_TO_ACTIVE_DIRECTORY":true,"LOGIN_ACTIVE_DIRECTORY_LINK":true,"FETCH_EDIT_USER_LINK":false,"LISTS_FETCH_AVAILABLE_LISTS":true,"POST_WIZARD_SUBMIT_REDIRECT_URL":"/","PIN_REQUEST_ATTESTATIONS":true,"PIN_REQUEST_DESCRIPTION":"Click **Request PIN** to have a new PIN sent to the account holder's email address on file.","OWNERSHIP_REQUEST_DESCRIPTION":"To become an **authorized user** of this record, a current **AUTHORIZED USER** will need to grant you access. To request access, click **Request Access** below.","PIN_REQUEST_SUCCESS_MESSAGE":"The PIN you have requested for this entity has been sent to the email associated with your user account.  You should receive the PIN in approximately 3-5 minutes, depending on your email service provider.","APOSTILLE_HEADER_LABEL":"Verification Information","APOSTILLE_NUMBER_LABEL":"Apostille/Authentication","APOSTILLE_CITY_STATE_OVERRIDE":"HELENA, MT","APOSTILLE_FILING_DATE_LABEL":"Issue Date","APOSTILLE_CITY_STATE_IN_CERTIFIED":true,"NOTARY_EXISTING_FILING":true,"ALLOW_REVOKE_OWN_ACCESS_ONLY":false,"HIDE_CANCEL_ON_ONETIME_DATA_REQUESTS":true,"DATA_REQUESTS_IN_SHOPPING_CART":true,"WQ_ALLOW_EDIT_PENDING_PAYMENT":true,"WQ_CONFIRM_ON_DELETE":true,"WQ_DELETE_CONFIRM_MESSAGE":"Deleting this filing will forfeit any money already paid to the Secretary of State. This action is permanent and cannot be undone, are you sure you would like to delete?","PASS_ITEM_GUIDS_ON_CHECKOUT":true,"FORM_REVISION_HISTORY":true,"CHECKOUT_DISCLAIMER":"By entering your credit card and/or checking account information you (i) state that **you are an authorized user** of the credit card and/or electronic check and that the associated information entered (e.g., account holder name, account number, billing address) is accurate, (ii) **you authorize payment processor to charge the amount you have requested** to your credit card and/or funding account, and (iii) **acknowledge if a charge is declined or reversed you may also be assessed a customary charge** by the payment processor for such transactions.","FARM_BILL_SEARCH_CONFIDENTIAL":"As a registered Farm Bill Buyer with the Montana Secretary of State’s office it is important to maintain the confidentiality of the information contained within the Farm Bill Master List. The Farm Bill Master List reflects personal data, such as Social Security Numbers, which are a key piece of personal identifiable information to assist you in determining the existence of a lien against a specific debtor. The distribution of this information beyond its intended purpose is strictly prohibited.\n\n**The debtor's tax identification number has been hidden for confidentiality reasons. You may continue to search on a tax ID number and return debtors that match your search criteria. The SSN/FEIN must be entered without dashes or spaces.  If you need access to the tax identification number to clearly identify the debtor, please contact the UCC unit at (406) 444-3665.**","VIEW_HISTORY_BUTTON_ALT_TEXT":"View Filings","WIZARD_ERROR_TITLE_MESSAGE":"Form Error","FARM_BILL_SEARCH_INTERACTIVE":true,"USE_FARM_BILL_API":true,"DISALLOW_ASSIGN_SELF_AS_RA":true,"DISALLOW_ASSIGN_SELF_AS_PRINCIPAL":true,"USE_TRADEMARK_OWNER_VALIDATION":true,"USE_ALTERNATIVE_FOREIGN_ADDRESS_LABELS":true,"MY_RECEIPTS_FILTER":[{"type":"dateRange","name":"DATE_RANGE","label":"Date range","defaultValue":{"start":null,"end":null}},{"type":"text","name":"REF_NUM","defaultValue":"","label":"Reference Number"},{"type":"text","name":"RECEIPT_NUM","defaultValue":"","label":"Receipt Id"},{"type":"text","name":"AMOUNT","defaultValue":"","label":"Amount"},{"type":"select","name":"TYPE","defaultValue":"","label":"Payment Type","options":[{"value":"","label":"All"},{"value":"CC","label":"Credit Card"},{"value":"Check","label":"Check"}]}],"MY_RECEIPTS_SHOW_IN_SIDEBAR":true,"SHOW_MY_RECEIPTS_HELPER_TEXT":true,"MY_RECEIPTS_HELPER_LABEL":"About Receipt Search","MY_RECEIPTS_HELPER_TEXT":"You can search for receipts based on their descriptions, including the items paid for on the receipt. Use the filters to search for or filter specific information.","FARM_BILL_SUBLINK":{"label":"Farm Bill","component":"FarmBill","parameter":"farm-bill","path":"/lists/farm-bill","sourceTypeId":0,"myRecordsSearch":false,"allowedRules":["/search/"],"disabled":true,"searchDescription":"To perform a search, enter a debtor name. Your search results may include: exact debtor name, variations of that name and any filing that includes your search criteria. Punctuation is ignored.\n\nYou can click on \"Advanced\" to refine your search. Under “Advanced” you can search by crop, year, county and SSN/FEIN. As a registered Farm Bill Buyer with the Montana Secretary of State’s office it is important to maintain the confidentiality of the information contained within the Farm Bill Master List. The Farm Bill Master List reflects personal data, such as Social Security Numbers, which are a key piece of personal identifiable information to assist you in determining the existence of a lien against a specific debtor. The distribution of this information beyond its intended purpose is strictly prohibited.\n\nThe debtor's tax identification number has been hidden for confidentiality reasons. You may continue to search on a tax ID number and return debtors that match your search criteria. The SSN/FEIN must be entered without dashes or spaces.","searchMustHaveOneOf":["search","UCC_FARM_PRODUCT_ID","COUNTY"],"searchPlaceholder":"Search by debtor name","advancedSearchParameters":[{"type":"ServerMultiComplete","label":"Product code name(s)","name":"UCC_FARM_PRODUCT_ID","defaultValue":"","optionsSrc":"UCC_FARM_PRODUCT_V"},{"type":"MultiComplete","label":"Year or Range of Years","name":"YEAR_NUM","optionsSrc":"years","startYear":"1968","defaultValue":[],"preMergeOptions":[{"value":"ALL","label":"All"}]},{"type":"serverSelect","label":"State","name":"STATE","defaultValue":"MONTANA","optionsSrc":"STATE"},{"type":"ServerMultiComplete","label":"County","name":"COUNTY","defaultValue":[],"optionsSrc":"COUNTY","overrideSubOptionsSrcFromParameterName":"STATE"},{"type":"checkbox","name":"TIN_SEARCH_YN","defaultValue":false,"label":"Tax Identification Number Search"},{"type":"checkbox","name":"TIN_SORT_YN","defaultValue":false,"label":"Unique ID Sort"}]},"ALLOW_ADDRESS_VALIDATION_BYPASS_OPTION":true,"DEFAULT_ADDRESS_VALIDATION_BYPASS_OPTION_CHECKED":true}).CERTIFICATE_VERIFICATION_ERROR || 'A certificate ID is required'
	          }
	        });
	      } else {
	        _this.setState({ errors: { certificateId: '' } });
	        _this.verifyCertificate(_this.state.certificateId);
	      }
	    }, _this.verifyCertificate = function (certificateId) {
	      _this.setState({ certError: null });
	      (0, _requests.VERIFY_CERTIFICATE)(certificateId, ({"NODE_ENV":"production","BUILD_DATE":"2025-08-27T15:15:31.687Z","BUILD_NUMBER":"Not Provided","GIT_VERSION":"v1.3.0-381-ga81e29b08","GIT_COMMIT_HASH":"a81e29b085c9268ffd96c78eb734365802722741","GIT_BRANCH":"beta","PUBLIC_URL":"","STATE_ABBR":"MT","STATE_NAME":"Montana","STATE_ORG_TITLE":"Secretary of State","LOGIN_HEADER_IMG_PATH":"","HOME_IMG_FILENAME":"montana.jpg","FAVICON_FILE_NAME":"favicon.ico","ALLOW_E_SIGN_ON_CORRECTIONS":true,"THIRD_PARTY_SIGNING_ALLOWED":false,"MY_ACCOUNT_SAVE_AND_CLOSE_BUTTON":true,"IE_DEPRECATED_MESSAGE":"Internet Explorer is not supported. Please select a supported browser below to access this website.","ADDITIONAL_ROUTES":{"dataRequests":true,"farmBill":true,"apostille":true,"externalHelp":"https://sosmt.gov/business/help-center/","systemAdministration":[{"title":"Saved Payments","parameter":"saved-payments","componentName":"SavedPayments"}]},"SUBROUTES":[{"label":"Business","component":"Business","parameter":"business","myWorkQueueSearch":false,"sourceTypeId":54,"searchMustHaveOneOf":["FILING_TYPE_ID","STATUS_ID","STATE","search"],"serverWebSearchDescription":true,"serverWorkQueueDescription":true,"serverMyRecordsDescription":true,"searchPlaceholder":"Search by name or filing number (X########)","allowEmptySearchTerm":true,"requestCertificateAlternateLabel":"Request Information","fileAmendmentButtonLabel":"Filing Actions","advancedSearchParameters":[{"type":"radio","name":"QUERY_TYPE_ID","defaultValue":1010,"options":[{"value":1010,"label":"Starts with"},{"value":1011,"label":"Contains"},{"value":1012,"label":" Word Contains"}]},{"type":"serverSelect","name":"FILING_TYPE_ID","optionsSrc":"FILING_TYPES","label":"Entity Type","placeholder":"All","defaultValue":"0"},{"type":"serverSelect","name":"FILING_SUBTYPE_ID","optionsSrc":"FILING_SUBTYPES","label":"Entity Subtype","overrideSubOptionsSrcFromParameterName":"FILING_TYPE_ID","placeholder":"All","defaultValue":"0"},{"type":"serverSelect","name":"STATUS_ID","optionsSrc":"FILING_STATUS_WITHOUT_ALL","label":"Status","placeholder":"All","defaultValue":"0"},{"type":"serverSelect","name":"STATE","optionsSrc":"STATE","label":"State","placeholder":"All","defaultValue":""},{"type":"serverSelect","name":"COUNTY","optionsSrc":"COUNTY_SUBOPTION","label":"County","overrideSubOptionsSrcFromParameterName":"STATE","placeholder":"All","defaultValue":""},{"type":"checkbox","name":"CRA_SEARCH_YN","defaultValue":false,"label":"Search by Registered Agent PID"},{"type":"dateRange","name":"FILING_DATE","label":"Registration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}},{"type":"dateRange","name":"EXPIRATION_DATE","label":"Expiration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}}],"myRecordsFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Active"},{"value":2,"label":"Inactive"},{"value":3,"label":"Pending"}]},{"type":"dateRange","name":"DATE_RANGE","label":"Date range","defaultValue":{"start":null,"end":null}}],"myWorkQueueFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Approved"},{"value":2,"label":"Pending Online Payment"},{"value":3,"label":"Pending Review"},{"value":4,"label":"Needs Correction"},{"value":5,"label":"Rejected"},{"value":6,"label":"Draft"}]},{"type":"dateRange","name":"DATE_RANGE","label":"Date range","defaultValue":{"start":null,"end":null}}]},{"label":"Notary","component":"Notary","parameter":"notary","sourceTypeId":850,"myWorkQueueSearch":false,"allowEmptySearchTerm":true,"requestCertificateAlternateLabel":"Download Certificate","fileAmendmentButtonLabel":"Filing Actions","hideNameRequestCertificate":true,"hideAddressRequestCertificate":true,"hideRecordUserManagment":true,"searchPlaceholder":"Search by name or commission number","searchMustHaveOneOf":["CITY","search","SERVICE_TYPE"],"advancedParametersStartOpen":true,"searchIsSortable":true,"advancedSearchParameters":[{"type":"radio","name":"STARTS_WITH_YN","defaultValue":false,"options":[{"value":true,"label":"Starts with"},{"value":false,"label":"Contains"}]},{"type":"checkbox","name":"ACTIVE_ONLY_YN","defaultValue":true,"label":"Active entities only"},{"type":"text","name":"CITY","defaultValue":"","label":"City"},{"type":"select","name":"SERVICE_TYPE","label":"Special Services Offered","defaultValue":0,"options":[{"value":0,"label":"(N/A)"},{"value":6165,"label":"In-Person Electronic Notarization (IPEN)"},{"value":6166,"label":"Remote Online Notarization (RON)"},{"value":6167,"label":"Mobile Notary Services"},{"value":6168,"label":"Remote Ink Notarization (RIN)"}]}]},{"label":"Apostille","component":"Apostille","parameter":"apostille","sourceTypeId":720,"myRecordsSearch":false,"myWorkQueueSearch":false,"disabled":false,"allowedRoutes":["/forms-manager/","/queue/","/forms/"]},{"label":"Liens","component":"UCC","parameter":"ucc","sourceTypeId":1999,"myRecordsSearch":true,"myWorkQueueSearch":true,"fileAmendmentButtonLabel":"Filing Actions","searchPlaceholder":"Search by name or file number","disabled":false,"serverWebSearchDescription":true,"myRecordsDescription":"","workQueueDescription":"","searchDescription":"","hideRecordUserManagment":true,"searchLiensCheckout":false,"advancedSearchParameters":[{"type":"radio","name":"STARTS_WITH_YN","defaultValue":false,"options":[{"value":true,"label":"Starts with"},{"value":false,"label":"Contains"}]},{"type":"select","name":"STATUS","defaultValue":"ALL","label":"Status","options":[{"value":"ACTIVE_UNLAPSED","label":"Active (unlapsed)"},{"value":"ACTIVE_LAPSED_UNLAPSED","label":"Active (lapsed and unlapsed)"}]},{"type":"text","name":"EXCLUDE_VALUES","label":"Exclude Debtor Names (comma separated list of names to exclude)","defaultValue":""},{"type":"dateRange","name":"FILING_DATE","label":"Financing Statement Date","defaultValue":{"start":null,"end":null}},{"type":"dateRange","name":"LAPSE_DATE","label":"Lapse Date","defaultValue":{"start":null,"end":null}},{"type":"text","name":"CITY","label":"Debtor City","defaultValue":""}],"myRecordsFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Approved"},{"value":2,"label":"Pending Online Payment"},{"value":3,"label":"Pending Review"}]},{"type":"select","name":"TYPE","defaultValue":0,"label":"Lien Type","options":[{"value":0,"label":"All"},{"value":1,"label":"UCC"},{"value":2,"label":"EFS"},{"value":3,"label":"Title 71"}]}],"myWorkQueueFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Approved"},{"value":2,"label":"Pending Online Payment"},{"value":3,"label":"Pending Review"},{"value":4,"label":"Pending Print and Mail"},{"value":5,"label":"Rejected"},{"value":6,"label":"Draft"}]},{"type":"select","name":"TYPE","defaultValue":0,"label":"Lien Type","options":[{"value":0,"label":"All"},{"value":1,"label":"UCC"},{"value":2,"label":"EFS"},{"value":3,"label":"Title 71"}]}]},{"label":"Copy Request","component":"copies","parameter":"copies","sourceTypeId":2001,"myRecordsSearch":false,"myWorkQueueSearch":false,"disabled":false,"allowedRoutes":["/forms-manager/","/queue/","/forms/"]},{"label":"Trademark","component":"Trademark","parameter":"trademark","sourceTypeId":810,"showRequestCertificate":true,"searchMustHaveOneOf":["search","EXPIRATION_DATE","FILING_DATE"],"allowEmptySearchTerm":true,"requestCertificateAlternateLabel":"Request Information","fileAmendmentButtonLabel":"Filing Actions","advancedSearchParameters":[{"type":"radio","name":"QUERY_TYPE_ID","defaultValue":1010,"options":[{"value":1010,"label":"Starts with"},{"value":1011,"label":"Contains"},{"value":1012,"label":" Word Contains"}]},{"type":"checkbox","name":"OWNER_SEARCH_YN","defaultValue":false,"label":"Search owners"},{"type":"radio","name":"SERVICE_MARK_YN","label":"Mark Type","defaultValue":"","options":[{"value":"","label":"All Marks"},{"value":"Y","label":"Service Mark"},{"value":"N","label":"Trademark"}]},{"type":"serverSelect","name":"STATUS_ID","optionsSrc":"TYPE_V|TRADEMARK_STATUS_TYPE","label":"Status","placeholder":"All","defaultValue":"0"},{"type":"select","name":"DESIGN_TYPE_ID","options":[{"value":0,"label":"All"},{"value":990,"label":"Words Only"},{"value":991,"label":"Design Only"},{"value":992,"label":"Words and Design"}],"label":"Design Type","defaultValue":"0"},{"type":"dateRange","name":"FILING_DATE","label":"Registered Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}},{"type":"dateRange","name":"EXPIRATION_DATE","label":"Expiration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}}]},{"label":"Business Info Request","component":"InfoRequests","parameter":"info-request","sourceTypeId":167,"allowedRoutes":["/forms-manager/","/queue/","/forms/"]},{"label":"Data Requests","component":"DataRequests","parameter":"data-request","sourceTypeId":0,"allowedRoutes":["/forms-manager/"]},{"label":"CRA","component":"CRA","parameter":"cra","sourceTypeId":157,"myRecordsSearch":false,"searchPlaceholder":"Search by name or registered agent number","allowedRoutes":["/forms-manager/","/forms/","/records/","/queue/","/search/"],"allowEmptySearchTerm":true,"fileAmendmentButtonLabel":"Filing Actions","advancedSearchParameters":[{"type":"radio","name":"QUERY_TYPE_ID","defaultValue":1010,"options":[{"value":1010,"label":"Starts with"},{"value":1011,"label":"Contains"},{"value":1012,"label":" Word Contains"}]},{"type":"dateRange","name":"CRA_DATE","label":"Registration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}},{"type":"select","name":"STATUS_ID","label":"Status","defaultValue":0,"options":[{"value":0,"label":"All"},{"value":121,"label":"Active"},{"value":122,"label":"Inactive"}]},{"type":"select","name":"AGENT_TYPE_ID","label":"Agent Type","defaultValue":0,"options":[{"value":0,"label":"All"},{"value":460,"label":"Registered Agent"},{"value":461,"label":"Commercial Registered Agent"}]}]},{"label":"Farm Bill","component":"FarmBill","parameter":"farm-bill","path":"/lists/farm-bill","sourceTypeId":0,"myRecordsSearch":false,"allowedRules":["/search/"],"disabled":true,"searchDescription":"To perform a search, enter a debtor name. Your search results may include: exact debtor name, variations of that name and any filing that includes your search criteria. Punctuation is ignored.\n\nYou can click on \"Advanced\" to refine your search. Under “Advanced” you can search by crop, year, county and SSN/FEIN. As a registered Farm Bill Buyer with the Montana Secretary of State’s office it is important to maintain the confidentiality of the information contained within the Farm Bill Master List. The Farm Bill Master List reflects personal data, such as Social Security Numbers, which are a key piece of personal identifiable information to assist you in determining the existence of a lien against a specific debtor. The distribution of this information beyond its intended purpose is strictly prohibited.\n\nThe debtor's tax identification number has been hidden for confidentiality reasons. You may continue to search on a tax ID number and return debtors that match your search criteria. The SSN/FEIN must be entered without dashes or spaces.","searchMustHaveOneOf":["search","UCC_FARM_PRODUCT_ID","COUNTY"],"searchPlaceholder":"Search by debtor name","advancedSearchParameters":[{"type":"ServerMultiComplete","label":"Product code name(s)","name":"UCC_FARM_PRODUCT_ID","defaultValue":"","optionsSrc":"UCC_FARM_PRODUCT_V"},{"type":"MultiComplete","label":"Year or Range of Years","name":"YEAR_NUM","optionsSrc":"years","startYear":"1968","defaultValue":[],"preMergeOptions":[{"value":"ALL","label":"All"}]},{"type":"serverSelect","label":"State","name":"STATE","defaultValue":"MONTANA","optionsSrc":"STATE"},{"type":"ServerMultiComplete","label":"County","name":"COUNTY","defaultValue":[],"optionsSrc":"COUNTY","overrideSubOptionsSrcFromParameterName":"STATE"},{"type":"checkbox","name":"TIN_SEARCH_YN","defaultValue":false,"label":"Tax Identification Number Search"},{"type":"checkbox","name":"TIN_SORT_YN","defaultValue":false,"label":"Unique ID Sort"}]}],"SYSTEM_NICKNAME":"Online Services Portal","PAYMENT_METHODS":[{"type":"bypass"},{"type":"iTransact"}],"PAYMENT_ALLOW_AMEX":true,"SYSTEM_ID_LABEL":"System Id","DOUBLE_COLUMN_PUBLIC_LOGIN":true,"INTERNAL_USER_MANAGEMENT":true,"ALLOW_PUBLIC_JSON_IMPORT":false,"MAX_FILE_UPLOAD_SIZE":10000000,"REFUND_TEXT":"","RETURN_TO_HOME_ON_LOGOUT":true,"CURRENT_SOS_NAME":"Christi Jacobsen","LOGO_FILENAME":"mt-sos-logo.png","LOGO_ALT":"Christi Jacobsen, Montana Secretary of State","LOGO_FULL_WIDTH":true,"HOME_HIDE_AUTH_HINT":true,"HOME_TITLE":"Montana Secretary of State","CUSTOM_TAB_TITLE":"Official Montana","HOME_SUBTITLE":"Online Business Services","ENTITY_NAME_CONSENT_DESCRIPTION":"","ALLOW_USER_PROFILE_EDITING":true,"COMPARE_FOREIGN_NAME_IN_ENTITY_NAME_VALIDATION":true,"FOREIGN_NAME_FIELD_NAME":"KIMA_PARENT_NAME_INFO","LOGIN_TITLE":"Montana Secretary of State Online Filing Portal Login","PUBLIC_LOGIN_LABEL":"Username","REVERSE_LOGIN_COLUMNS":true,"LOGIN_SEAL_FILENAME":"seal_white.png","SEPARATE_USERNAME_AND_EMAIL":true,"CREATE_ACCOUNT_BUTTON_ALIGN_LEFT":true,"CREATE_ACCOUNT_BUTTON_TEXT":"CREATE AN ACCOUNT","PASSWORD_CUSTOM_ERROR_TEXT":"The password must meet all requirements","ACCOUNT_CREATED_MESSAGE":"Please check your email to verify your account to login and allow a few minutes for this message to arrive. Check your junk/spam folders if you do not find the email in your inbox.","PUBLIC_LOGIN_PLACEHOLDER":" ","DISABLE_DEFAULT_PAYMENT_RADIO":true,"CUSTOM_RESET_PASSWORD_ERROR_MESSAGE":"Username invalid - no account found","PUBLIC_LOGIN_CREATE_DESCRIPTION":"### Existing User:\n\n  - Enter your username and password to login.  \n\n\n  #### - OR -  \n\n\n\n  - Forgot password? Click 'Reset Password' and follow the prompts.\n  - Forgot username? Click 'Forgot Username' and follow the prompts.  \n\n\n  ### New User:\n  ","LOGIN_HELP_LINK":"https://sosmt.gov/business/how-do-i/","LOGIN_HELP_LINK_TEXT":"Need Help?","FORGOT_USERNAME_TEXT":"Forgot Username?","LOGIN_ACTIVE_DIRECTORY_TEXT":"State User Login","MULTIPLE_LOGIN_METHODS":true,"HAS_ACTIVE_DIRECTORY_LOGIN":true,"RESET_PASSWORD_WITH_USERNAME":true,"DOWNLOAD_LINK":true,"SHOW_USERNAME_ACCOUNT_CREATE":true,"SHOW_SCROLL_DOWN_ARROW":true,"SHOW_ADDRESS_ACCOUNT_CREATE":true,"TWO_COLUMN_ACCOUNT_CREATE":true,"RESET_PASSWORD_TIP":"A link to change your password has been sent to your email. Please allow a few minutes for this message to arrive. Please check your junk/spam folders if you do not find the email in your inbox.","FORGOT_PASSWORD_LINK_TEXT":"Reset Password","PHONE_NUMBER_OPTIONAL_ACCOUNT_CREATE":true,"SHOW_REQUIRED_INDICATOR_ACCOUNT_CREATE":true,"PASSWORD_REQUIREMENTS_ACCOUNT_CREATE":"\n    <ul>\n      <li>MUST contain at least 8 characters (12+ recommended)</li>\n      <li>MUST contain at least one uppercase letter.</li>\n      <li>MUST contain at least one lowercase letter.</li>\n      <li>MUST contain at least one number.</li>\n      <li>MUST contain at least one special character (!”#$%&'()*+,-./:;<=>?</li>\n    </ul>\n  ","ALLOW_CERTIFICATION_REQUEST":true,"ALLOW_PUBLIC_CERTIFICATE_REQUEST":true,"ALLOW_COPY_REQUEST":false,"ALLOW_CORRECTION_STYLING":true,"HIDE_DEPRECATION_WARNING":false,"AMEND_ROUTE_PUBLIC":true,"SEAL_FILENAME":"seal.png","SHOPPING_CART":true,"ALLOW_PAYMENT_UPDATE_WITH_EMPTY_CART":true,"RA_EMAIL":true,"RA_WEBSITE":true,"RA_NO_DEFAULT_TYPE":true,"RA_ADDRESS_LABEL":"Street Address","RA_TYPE_SELECTION_DEFAULT":true,"RA_DEFAULT_TYPE":"460","RA_OVERRIDE_TYPE_WITH_DEFAULT":true,"RA_PRINCIPAL_ADDRESS_AMS":true,"UPLOAD_AND_SUBMIT_HIDE_IF_ONE_OPTION":true,"PAYMENT_PROCESSING_MESSAGE":"Your payment is processing - Do not close your browser or click the back button","CHECKOUT_BUTTON_WHEN_PROCESSING_TEXT":"Processing","EFS_CROP_PICKER_NONE_LABEL":"Lien Duration","DISALLOWED_WIZARD_PIECES":["FormationLocale"],"REPEATER_SHOW_EDIT_BUTTON":true,"DATA_REQUEST_PAGE_TITLE":"Data Requests and Subscriptions","DATA_REQUEST_SIDEBAR_LABEL":"Data Requests & Subscriptions","LOGIN_REDIRECTS_TO_EPASS":false,"LOGIN_REDIRECTS_TO_ACTIVE_DIRECTORY":true,"LOGIN_ACTIVE_DIRECTORY_LINK":true,"FETCH_EDIT_USER_LINK":false,"LISTS_FETCH_AVAILABLE_LISTS":true,"POST_WIZARD_SUBMIT_REDIRECT_URL":"/","PIN_REQUEST_ATTESTATIONS":true,"PIN_REQUEST_DESCRIPTION":"Click **Request PIN** to have a new PIN sent to the account holder's email address on file.","OWNERSHIP_REQUEST_DESCRIPTION":"To become an **authorized user** of this record, a current **AUTHORIZED USER** will need to grant you access. To request access, click **Request Access** below.","PIN_REQUEST_SUCCESS_MESSAGE":"The PIN you have requested for this entity has been sent to the email associated with your user account.  You should receive the PIN in approximately 3-5 minutes, depending on your email service provider.","APOSTILLE_HEADER_LABEL":"Verification Information","APOSTILLE_NUMBER_LABEL":"Apostille/Authentication","APOSTILLE_CITY_STATE_OVERRIDE":"HELENA, MT","APOSTILLE_FILING_DATE_LABEL":"Issue Date","APOSTILLE_CITY_STATE_IN_CERTIFIED":true,"NOTARY_EXISTING_FILING":true,"ALLOW_REVOKE_OWN_ACCESS_ONLY":false,"HIDE_CANCEL_ON_ONETIME_DATA_REQUESTS":true,"DATA_REQUESTS_IN_SHOPPING_CART":true,"WQ_ALLOW_EDIT_PENDING_PAYMENT":true,"WQ_CONFIRM_ON_DELETE":true,"WQ_DELETE_CONFIRM_MESSAGE":"Deleting this filing will forfeit any money already paid to the Secretary of State. This action is permanent and cannot be undone, are you sure you would like to delete?","PASS_ITEM_GUIDS_ON_CHECKOUT":true,"FORM_REVISION_HISTORY":true,"CHECKOUT_DISCLAIMER":"By entering your credit card and/or checking account information you (i) state that **you are an authorized user** of the credit card and/or electronic check and that the associated information entered (e.g., account holder name, account number, billing address) is accurate, (ii) **you authorize payment processor to charge the amount you have requested** to your credit card and/or funding account, and (iii) **acknowledge if a charge is declined or reversed you may also be assessed a customary charge** by the payment processor for such transactions.","FARM_BILL_SEARCH_CONFIDENTIAL":"As a registered Farm Bill Buyer with the Montana Secretary of State’s office it is important to maintain the confidentiality of the information contained within the Farm Bill Master List. The Farm Bill Master List reflects personal data, such as Social Security Numbers, which are a key piece of personal identifiable information to assist you in determining the existence of a lien against a specific debtor. The distribution of this information beyond its intended purpose is strictly prohibited.\n\n**The debtor's tax identification number has been hidden for confidentiality reasons. You may continue to search on a tax ID number and return debtors that match your search criteria. The SSN/FEIN must be entered without dashes or spaces.  If you need access to the tax identification number to clearly identify the debtor, please contact the UCC unit at (406) 444-3665.**","VIEW_HISTORY_BUTTON_ALT_TEXT":"View Filings","WIZARD_ERROR_TITLE_MESSAGE":"Form Error","FARM_BILL_SEARCH_INTERACTIVE":true,"USE_FARM_BILL_API":true,"DISALLOW_ASSIGN_SELF_AS_RA":true,"DISALLOW_ASSIGN_SELF_AS_PRINCIPAL":true,"USE_TRADEMARK_OWNER_VALIDATION":true,"USE_ALTERNATIVE_FOREIGN_ADDRESS_LABELS":true,"MY_RECEIPTS_FILTER":[{"type":"dateRange","name":"DATE_RANGE","label":"Date range","defaultValue":{"start":null,"end":null}},{"type":"text","name":"REF_NUM","defaultValue":"","label":"Reference Number"},{"type":"text","name":"RECEIPT_NUM","defaultValue":"","label":"Receipt Id"},{"type":"text","name":"AMOUNT","defaultValue":"","label":"Amount"},{"type":"select","name":"TYPE","defaultValue":"","label":"Payment Type","options":[{"value":"","label":"All"},{"value":"CC","label":"Credit Card"},{"value":"Check","label":"Check"}]}],"MY_RECEIPTS_SHOW_IN_SIDEBAR":true,"SHOW_MY_RECEIPTS_HELPER_TEXT":true,"MY_RECEIPTS_HELPER_LABEL":"About Receipt Search","MY_RECEIPTS_HELPER_TEXT":"You can search for receipts based on their descriptions, including the items paid for on the receipt. Use the filters to search for or filter specific information.","FARM_BILL_SUBLINK":{"label":"Farm Bill","component":"FarmBill","parameter":"farm-bill","path":"/lists/farm-bill","sourceTypeId":0,"myRecordsSearch":false,"allowedRules":["/search/"],"disabled":true,"searchDescription":"To perform a search, enter a debtor name. Your search results may include: exact debtor name, variations of that name and any filing that includes your search criteria. Punctuation is ignored.\n\nYou can click on \"Advanced\" to refine your search. Under “Advanced” you can search by crop, year, county and SSN/FEIN. As a registered Farm Bill Buyer with the Montana Secretary of State’s office it is important to maintain the confidentiality of the information contained within the Farm Bill Master List. The Farm Bill Master List reflects personal data, such as Social Security Numbers, which are a key piece of personal identifiable information to assist you in determining the existence of a lien against a specific debtor. The distribution of this information beyond its intended purpose is strictly prohibited.\n\nThe debtor's tax identification number has been hidden for confidentiality reasons. You may continue to search on a tax ID number and return debtors that match your search criteria. The SSN/FEIN must be entered without dashes or spaces.","searchMustHaveOneOf":["search","UCC_FARM_PRODUCT_ID","COUNTY"],"searchPlaceholder":"Search by debtor name","advancedSearchParameters":[{"type":"ServerMultiComplete","label":"Product code name(s)","name":"UCC_FARM_PRODUCT_ID","defaultValue":"","optionsSrc":"UCC_FARM_PRODUCT_V"},{"type":"MultiComplete","label":"Year or Range of Years","name":"YEAR_NUM","optionsSrc":"years","startYear":"1968","defaultValue":[],"preMergeOptions":[{"value":"ALL","label":"All"}]},{"type":"serverSelect","label":"State","name":"STATE","defaultValue":"MONTANA","optionsSrc":"STATE"},{"type":"ServerMultiComplete","label":"County","name":"COUNTY","defaultValue":[],"optionsSrc":"COUNTY","overrideSubOptionsSrcFromParameterName":"STATE"},{"type":"checkbox","name":"TIN_SEARCH_YN","defaultValue":false,"label":"Tax Identification Number Search"},{"type":"checkbox","name":"TIN_SORT_YN","defaultValue":false,"label":"Unique ID Sort"}]},"ALLOW_ADDRESS_VALIDATION_BYPASS_OPTION":true,"DEFAULT_ADDRESS_VALIDATION_BYPASS_OPTION_CHECKED":true}).COMBINED_CERTIFICATE_VERIFICATION ? _this.state.category : '', function (certificate) {
	        _this.setState({ certificate: certificate });
	      }, function (err) {
	        if (err.code === 'certification/certificateNotValid') {
	          _this.setState({ certError: err.message, certificate: null });
	        }
	      });
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(VerifyCertificate, [{
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      return _react2.default.createElement(
	        _Shell.Body,
	        { className: 'flex-center-page' },
	        _react2.default.createElement(_FormCard2.default, {
	          seal: true,
	          title: ({"NODE_ENV":"production","BUILD_DATE":"2025-08-27T15:15:31.687Z","BUILD_NUMBER":"Not Provided","GIT_VERSION":"v1.3.0-381-ga81e29b08","GIT_COMMIT_HASH":"a81e29b085c9268ffd96c78eb734365802722741","GIT_BRANCH":"beta","PUBLIC_URL":"","STATE_ABBR":"MT","STATE_NAME":"Montana","STATE_ORG_TITLE":"Secretary of State","LOGIN_HEADER_IMG_PATH":"","HOME_IMG_FILENAME":"montana.jpg","FAVICON_FILE_NAME":"favicon.ico","ALLOW_E_SIGN_ON_CORRECTIONS":true,"THIRD_PARTY_SIGNING_ALLOWED":false,"MY_ACCOUNT_SAVE_AND_CLOSE_BUTTON":true,"IE_DEPRECATED_MESSAGE":"Internet Explorer is not supported. Please select a supported browser below to access this website.","ADDITIONAL_ROUTES":{"dataRequests":true,"farmBill":true,"apostille":true,"externalHelp":"https://sosmt.gov/business/help-center/","systemAdministration":[{"title":"Saved Payments","parameter":"saved-payments","componentName":"SavedPayments"}]},"SUBROUTES":[{"label":"Business","component":"Business","parameter":"business","myWorkQueueSearch":false,"sourceTypeId":54,"searchMustHaveOneOf":["FILING_TYPE_ID","STATUS_ID","STATE","search"],"serverWebSearchDescription":true,"serverWorkQueueDescription":true,"serverMyRecordsDescription":true,"searchPlaceholder":"Search by name or filing number (X########)","allowEmptySearchTerm":true,"requestCertificateAlternateLabel":"Request Information","fileAmendmentButtonLabel":"Filing Actions","advancedSearchParameters":[{"type":"radio","name":"QUERY_TYPE_ID","defaultValue":1010,"options":[{"value":1010,"label":"Starts with"},{"value":1011,"label":"Contains"},{"value":1012,"label":" Word Contains"}]},{"type":"serverSelect","name":"FILING_TYPE_ID","optionsSrc":"FILING_TYPES","label":"Entity Type","placeholder":"All","defaultValue":"0"},{"type":"serverSelect","name":"FILING_SUBTYPE_ID","optionsSrc":"FILING_SUBTYPES","label":"Entity Subtype","overrideSubOptionsSrcFromParameterName":"FILING_TYPE_ID","placeholder":"All","defaultValue":"0"},{"type":"serverSelect","name":"STATUS_ID","optionsSrc":"FILING_STATUS_WITHOUT_ALL","label":"Status","placeholder":"All","defaultValue":"0"},{"type":"serverSelect","name":"STATE","optionsSrc":"STATE","label":"State","placeholder":"All","defaultValue":""},{"type":"serverSelect","name":"COUNTY","optionsSrc":"COUNTY_SUBOPTION","label":"County","overrideSubOptionsSrcFromParameterName":"STATE","placeholder":"All","defaultValue":""},{"type":"checkbox","name":"CRA_SEARCH_YN","defaultValue":false,"label":"Search by Registered Agent PID"},{"type":"dateRange","name":"FILING_DATE","label":"Registration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}},{"type":"dateRange","name":"EXPIRATION_DATE","label":"Expiration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}}],"myRecordsFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Active"},{"value":2,"label":"Inactive"},{"value":3,"label":"Pending"}]},{"type":"dateRange","name":"DATE_RANGE","label":"Date range","defaultValue":{"start":null,"end":null}}],"myWorkQueueFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Approved"},{"value":2,"label":"Pending Online Payment"},{"value":3,"label":"Pending Review"},{"value":4,"label":"Needs Correction"},{"value":5,"label":"Rejected"},{"value":6,"label":"Draft"}]},{"type":"dateRange","name":"DATE_RANGE","label":"Date range","defaultValue":{"start":null,"end":null}}]},{"label":"Notary","component":"Notary","parameter":"notary","sourceTypeId":850,"myWorkQueueSearch":false,"allowEmptySearchTerm":true,"requestCertificateAlternateLabel":"Download Certificate","fileAmendmentButtonLabel":"Filing Actions","hideNameRequestCertificate":true,"hideAddressRequestCertificate":true,"hideRecordUserManagment":true,"searchPlaceholder":"Search by name or commission number","searchMustHaveOneOf":["CITY","search","SERVICE_TYPE"],"advancedParametersStartOpen":true,"searchIsSortable":true,"advancedSearchParameters":[{"type":"radio","name":"STARTS_WITH_YN","defaultValue":false,"options":[{"value":true,"label":"Starts with"},{"value":false,"label":"Contains"}]},{"type":"checkbox","name":"ACTIVE_ONLY_YN","defaultValue":true,"label":"Active entities only"},{"type":"text","name":"CITY","defaultValue":"","label":"City"},{"type":"select","name":"SERVICE_TYPE","label":"Special Services Offered","defaultValue":0,"options":[{"value":0,"label":"(N/A)"},{"value":6165,"label":"In-Person Electronic Notarization (IPEN)"},{"value":6166,"label":"Remote Online Notarization (RON)"},{"value":6167,"label":"Mobile Notary Services"},{"value":6168,"label":"Remote Ink Notarization (RIN)"}]}]},{"label":"Apostille","component":"Apostille","parameter":"apostille","sourceTypeId":720,"myRecordsSearch":false,"myWorkQueueSearch":false,"disabled":false,"allowedRoutes":["/forms-manager/","/queue/","/forms/"]},{"label":"Liens","component":"UCC","parameter":"ucc","sourceTypeId":1999,"myRecordsSearch":true,"myWorkQueueSearch":true,"fileAmendmentButtonLabel":"Filing Actions","searchPlaceholder":"Search by name or file number","disabled":false,"serverWebSearchDescription":true,"myRecordsDescription":"","workQueueDescription":"","searchDescription":"","hideRecordUserManagment":true,"searchLiensCheckout":false,"advancedSearchParameters":[{"type":"radio","name":"STARTS_WITH_YN","defaultValue":false,"options":[{"value":true,"label":"Starts with"},{"value":false,"label":"Contains"}]},{"type":"select","name":"STATUS","defaultValue":"ALL","label":"Status","options":[{"value":"ACTIVE_UNLAPSED","label":"Active (unlapsed)"},{"value":"ACTIVE_LAPSED_UNLAPSED","label":"Active (lapsed and unlapsed)"}]},{"type":"text","name":"EXCLUDE_VALUES","label":"Exclude Debtor Names (comma separated list of names to exclude)","defaultValue":""},{"type":"dateRange","name":"FILING_DATE","label":"Financing Statement Date","defaultValue":{"start":null,"end":null}},{"type":"dateRange","name":"LAPSE_DATE","label":"Lapse Date","defaultValue":{"start":null,"end":null}},{"type":"text","name":"CITY","label":"Debtor City","defaultValue":""}],"myRecordsFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Approved"},{"value":2,"label":"Pending Online Payment"},{"value":3,"label":"Pending Review"}]},{"type":"select","name":"TYPE","defaultValue":0,"label":"Lien Type","options":[{"value":0,"label":"All"},{"value":1,"label":"UCC"},{"value":2,"label":"EFS"},{"value":3,"label":"Title 71"}]}],"myWorkQueueFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Approved"},{"value":2,"label":"Pending Online Payment"},{"value":3,"label":"Pending Review"},{"value":4,"label":"Pending Print and Mail"},{"value":5,"label":"Rejected"},{"value":6,"label":"Draft"}]},{"type":"select","name":"TYPE","defaultValue":0,"label":"Lien Type","options":[{"value":0,"label":"All"},{"value":1,"label":"UCC"},{"value":2,"label":"EFS"},{"value":3,"label":"Title 71"}]}]},{"label":"Copy Request","component":"copies","parameter":"copies","sourceTypeId":2001,"myRecordsSearch":false,"myWorkQueueSearch":false,"disabled":false,"allowedRoutes":["/forms-manager/","/queue/","/forms/"]},{"label":"Trademark","component":"Trademark","parameter":"trademark","sourceTypeId":810,"showRequestCertificate":true,"searchMustHaveOneOf":["search","EXPIRATION_DATE","FILING_DATE"],"allowEmptySearchTerm":true,"requestCertificateAlternateLabel":"Request Information","fileAmendmentButtonLabel":"Filing Actions","advancedSearchParameters":[{"type":"radio","name":"QUERY_TYPE_ID","defaultValue":1010,"options":[{"value":1010,"label":"Starts with"},{"value":1011,"label":"Contains"},{"value":1012,"label":" Word Contains"}]},{"type":"checkbox","name":"OWNER_SEARCH_YN","defaultValue":false,"label":"Search owners"},{"type":"radio","name":"SERVICE_MARK_YN","label":"Mark Type","defaultValue":"","options":[{"value":"","label":"All Marks"},{"value":"Y","label":"Service Mark"},{"value":"N","label":"Trademark"}]},{"type":"serverSelect","name":"STATUS_ID","optionsSrc":"TYPE_V|TRADEMARK_STATUS_TYPE","label":"Status","placeholder":"All","defaultValue":"0"},{"type":"select","name":"DESIGN_TYPE_ID","options":[{"value":0,"label":"All"},{"value":990,"label":"Words Only"},{"value":991,"label":"Design Only"},{"value":992,"label":"Words and Design"}],"label":"Design Type","defaultValue":"0"},{"type":"dateRange","name":"FILING_DATE","label":"Registered Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}},{"type":"dateRange","name":"EXPIRATION_DATE","label":"Expiration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}}]},{"label":"Business Info Request","component":"InfoRequests","parameter":"info-request","sourceTypeId":167,"allowedRoutes":["/forms-manager/","/queue/","/forms/"]},{"label":"Data Requests","component":"DataRequests","parameter":"data-request","sourceTypeId":0,"allowedRoutes":["/forms-manager/"]},{"label":"CRA","component":"CRA","parameter":"cra","sourceTypeId":157,"myRecordsSearch":false,"searchPlaceholder":"Search by name or registered agent number","allowedRoutes":["/forms-manager/","/forms/","/records/","/queue/","/search/"],"allowEmptySearchTerm":true,"fileAmendmentButtonLabel":"Filing Actions","advancedSearchParameters":[{"type":"radio","name":"QUERY_TYPE_ID","defaultValue":1010,"options":[{"value":1010,"label":"Starts with"},{"value":1011,"label":"Contains"},{"value":1012,"label":" Word Contains"}]},{"type":"dateRange","name":"CRA_DATE","label":"Registration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}},{"type":"select","name":"STATUS_ID","label":"Status","defaultValue":0,"options":[{"value":0,"label":"All"},{"value":121,"label":"Active"},{"value":122,"label":"Inactive"}]},{"type":"select","name":"AGENT_TYPE_ID","label":"Agent Type","defaultValue":0,"options":[{"value":0,"label":"All"},{"value":460,"label":"Registered Agent"},{"value":461,"label":"Commercial Registered Agent"}]}]},{"label":"Farm Bill","component":"FarmBill","parameter":"farm-bill","path":"/lists/farm-bill","sourceTypeId":0,"myRecordsSearch":false,"allowedRules":["/search/"],"disabled":true,"searchDescription":"To perform a search, enter a debtor name. Your search results may include: exact debtor name, variations of that name and any filing that includes your search criteria. Punctuation is ignored.\n\nYou can click on \"Advanced\" to refine your search. Under “Advanced” you can search by crop, year, county and SSN/FEIN. As a registered Farm Bill Buyer with the Montana Secretary of State’s office it is important to maintain the confidentiality of the information contained within the Farm Bill Master List. The Farm Bill Master List reflects personal data, such as Social Security Numbers, which are a key piece of personal identifiable information to assist you in determining the existence of a lien against a specific debtor. The distribution of this information beyond its intended purpose is strictly prohibited.\n\nThe debtor's tax identification number has been hidden for confidentiality reasons. You may continue to search on a tax ID number and return debtors that match your search criteria. The SSN/FEIN must be entered without dashes or spaces.","searchMustHaveOneOf":["search","UCC_FARM_PRODUCT_ID","COUNTY"],"searchPlaceholder":"Search by debtor name","advancedSearchParameters":[{"type":"ServerMultiComplete","label":"Product code name(s)","name":"UCC_FARM_PRODUCT_ID","defaultValue":"","optionsSrc":"UCC_FARM_PRODUCT_V"},{"type":"MultiComplete","label":"Year or Range of Years","name":"YEAR_NUM","optionsSrc":"years","startYear":"1968","defaultValue":[],"preMergeOptions":[{"value":"ALL","label":"All"}]},{"type":"serverSelect","label":"State","name":"STATE","defaultValue":"MONTANA","optionsSrc":"STATE"},{"type":"ServerMultiComplete","label":"County","name":"COUNTY","defaultValue":[],"optionsSrc":"COUNTY","overrideSubOptionsSrcFromParameterName":"STATE"},{"type":"checkbox","name":"TIN_SEARCH_YN","defaultValue":false,"label":"Tax Identification Number Search"},{"type":"checkbox","name":"TIN_SORT_YN","defaultValue":false,"label":"Unique ID Sort"}]}],"SYSTEM_NICKNAME":"Online Services Portal","PAYMENT_METHODS":[{"type":"bypass"},{"type":"iTransact"}],"PAYMENT_ALLOW_AMEX":true,"SYSTEM_ID_LABEL":"System Id","DOUBLE_COLUMN_PUBLIC_LOGIN":true,"INTERNAL_USER_MANAGEMENT":true,"ALLOW_PUBLIC_JSON_IMPORT":false,"MAX_FILE_UPLOAD_SIZE":10000000,"REFUND_TEXT":"","RETURN_TO_HOME_ON_LOGOUT":true,"CURRENT_SOS_NAME":"Christi Jacobsen","LOGO_FILENAME":"mt-sos-logo.png","LOGO_ALT":"Christi Jacobsen, Montana Secretary of State","LOGO_FULL_WIDTH":true,"HOME_HIDE_AUTH_HINT":true,"HOME_TITLE":"Montana Secretary of State","CUSTOM_TAB_TITLE":"Official Montana","HOME_SUBTITLE":"Online Business Services","ENTITY_NAME_CONSENT_DESCRIPTION":"","ALLOW_USER_PROFILE_EDITING":true,"COMPARE_FOREIGN_NAME_IN_ENTITY_NAME_VALIDATION":true,"FOREIGN_NAME_FIELD_NAME":"KIMA_PARENT_NAME_INFO","LOGIN_TITLE":"Montana Secretary of State Online Filing Portal Login","PUBLIC_LOGIN_LABEL":"Username","REVERSE_LOGIN_COLUMNS":true,"LOGIN_SEAL_FILENAME":"seal_white.png","SEPARATE_USERNAME_AND_EMAIL":true,"CREATE_ACCOUNT_BUTTON_ALIGN_LEFT":true,"CREATE_ACCOUNT_BUTTON_TEXT":"CREATE AN ACCOUNT","PASSWORD_CUSTOM_ERROR_TEXT":"The password must meet all requirements","ACCOUNT_CREATED_MESSAGE":"Please check your email to verify your account to login and allow a few minutes for this message to arrive. Check your junk/spam folders if you do not find the email in your inbox.","PUBLIC_LOGIN_PLACEHOLDER":" ","DISABLE_DEFAULT_PAYMENT_RADIO":true,"CUSTOM_RESET_PASSWORD_ERROR_MESSAGE":"Username invalid - no account found","PUBLIC_LOGIN_CREATE_DESCRIPTION":"### Existing User:\n\n  - Enter your username and password to login.  \n\n\n  #### - OR -  \n\n\n\n  - Forgot password? Click 'Reset Password' and follow the prompts.\n  - Forgot username? Click 'Forgot Username' and follow the prompts.  \n\n\n  ### New User:\n  ","LOGIN_HELP_LINK":"https://sosmt.gov/business/how-do-i/","LOGIN_HELP_LINK_TEXT":"Need Help?","FORGOT_USERNAME_TEXT":"Forgot Username?","LOGIN_ACTIVE_DIRECTORY_TEXT":"State User Login","MULTIPLE_LOGIN_METHODS":true,"HAS_ACTIVE_DIRECTORY_LOGIN":true,"RESET_PASSWORD_WITH_USERNAME":true,"DOWNLOAD_LINK":true,"SHOW_USERNAME_ACCOUNT_CREATE":true,"SHOW_SCROLL_DOWN_ARROW":true,"SHOW_ADDRESS_ACCOUNT_CREATE":true,"TWO_COLUMN_ACCOUNT_CREATE":true,"RESET_PASSWORD_TIP":"A link to change your password has been sent to your email. Please allow a few minutes for this message to arrive. Please check your junk/spam folders if you do not find the email in your inbox.","FORGOT_PASSWORD_LINK_TEXT":"Reset Password","PHONE_NUMBER_OPTIONAL_ACCOUNT_CREATE":true,"SHOW_REQUIRED_INDICATOR_ACCOUNT_CREATE":true,"PASSWORD_REQUIREMENTS_ACCOUNT_CREATE":"\n    <ul>\n      <li>MUST contain at least 8 characters (12+ recommended)</li>\n      <li>MUST contain at least one uppercase letter.</li>\n      <li>MUST contain at least one lowercase letter.</li>\n      <li>MUST contain at least one number.</li>\n      <li>MUST contain at least one special character (!”#$%&'()*+,-./:;<=>?</li>\n    </ul>\n  ","ALLOW_CERTIFICATION_REQUEST":true,"ALLOW_PUBLIC_CERTIFICATE_REQUEST":true,"ALLOW_COPY_REQUEST":false,"ALLOW_CORRECTION_STYLING":true,"HIDE_DEPRECATION_WARNING":false,"AMEND_ROUTE_PUBLIC":true,"SEAL_FILENAME":"seal.png","SHOPPING_CART":true,"ALLOW_PAYMENT_UPDATE_WITH_EMPTY_CART":true,"RA_EMAIL":true,"RA_WEBSITE":true,"RA_NO_DEFAULT_TYPE":true,"RA_ADDRESS_LABEL":"Street Address","RA_TYPE_SELECTION_DEFAULT":true,"RA_DEFAULT_TYPE":"460","RA_OVERRIDE_TYPE_WITH_DEFAULT":true,"RA_PRINCIPAL_ADDRESS_AMS":true,"UPLOAD_AND_SUBMIT_HIDE_IF_ONE_OPTION":true,"PAYMENT_PROCESSING_MESSAGE":"Your payment is processing - Do not close your browser or click the back button","CHECKOUT_BUTTON_WHEN_PROCESSING_TEXT":"Processing","EFS_CROP_PICKER_NONE_LABEL":"Lien Duration","DISALLOWED_WIZARD_PIECES":["FormationLocale"],"REPEATER_SHOW_EDIT_BUTTON":true,"DATA_REQUEST_PAGE_TITLE":"Data Requests and Subscriptions","DATA_REQUEST_SIDEBAR_LABEL":"Data Requests & Subscriptions","LOGIN_REDIRECTS_TO_EPASS":false,"LOGIN_REDIRECTS_TO_ACTIVE_DIRECTORY":true,"LOGIN_ACTIVE_DIRECTORY_LINK":true,"FETCH_EDIT_USER_LINK":false,"LISTS_FETCH_AVAILABLE_LISTS":true,"POST_WIZARD_SUBMIT_REDIRECT_URL":"/","PIN_REQUEST_ATTESTATIONS":true,"PIN_REQUEST_DESCRIPTION":"Click **Request PIN** to have a new PIN sent to the account holder's email address on file.","OWNERSHIP_REQUEST_DESCRIPTION":"To become an **authorized user** of this record, a current **AUTHORIZED USER** will need to grant you access. To request access, click **Request Access** below.","PIN_REQUEST_SUCCESS_MESSAGE":"The PIN you have requested for this entity has been sent to the email associated with your user account.  You should receive the PIN in approximately 3-5 minutes, depending on your email service provider.","APOSTILLE_HEADER_LABEL":"Verification Information","APOSTILLE_NUMBER_LABEL":"Apostille/Authentication","APOSTILLE_CITY_STATE_OVERRIDE":"HELENA, MT","APOSTILLE_FILING_DATE_LABEL":"Issue Date","APOSTILLE_CITY_STATE_IN_CERTIFIED":true,"NOTARY_EXISTING_FILING":true,"ALLOW_REVOKE_OWN_ACCESS_ONLY":false,"HIDE_CANCEL_ON_ONETIME_DATA_REQUESTS":true,"DATA_REQUESTS_IN_SHOPPING_CART":true,"WQ_ALLOW_EDIT_PENDING_PAYMENT":true,"WQ_CONFIRM_ON_DELETE":true,"WQ_DELETE_CONFIRM_MESSAGE":"Deleting this filing will forfeit any money already paid to the Secretary of State. This action is permanent and cannot be undone, are you sure you would like to delete?","PASS_ITEM_GUIDS_ON_CHECKOUT":true,"FORM_REVISION_HISTORY":true,"CHECKOUT_DISCLAIMER":"By entering your credit card and/or checking account information you (i) state that **you are an authorized user** of the credit card and/or electronic check and that the associated information entered (e.g., account holder name, account number, billing address) is accurate, (ii) **you authorize payment processor to charge the amount you have requested** to your credit card and/or funding account, and (iii) **acknowledge if a charge is declined or reversed you may also be assessed a customary charge** by the payment processor for such transactions.","FARM_BILL_SEARCH_CONFIDENTIAL":"As a registered Farm Bill Buyer with the Montana Secretary of State’s office it is important to maintain the confidentiality of the information contained within the Farm Bill Master List. The Farm Bill Master List reflects personal data, such as Social Security Numbers, which are a key piece of personal identifiable information to assist you in determining the existence of a lien against a specific debtor. The distribution of this information beyond its intended purpose is strictly prohibited.\n\n**The debtor's tax identification number has been hidden for confidentiality reasons. You may continue to search on a tax ID number and return debtors that match your search criteria. The SSN/FEIN must be entered without dashes or spaces.  If you need access to the tax identification number to clearly identify the debtor, please contact the UCC unit at (406) 444-3665.**","VIEW_HISTORY_BUTTON_ALT_TEXT":"View Filings","WIZARD_ERROR_TITLE_MESSAGE":"Form Error","FARM_BILL_SEARCH_INTERACTIVE":true,"USE_FARM_BILL_API":true,"DISALLOW_ASSIGN_SELF_AS_RA":true,"DISALLOW_ASSIGN_SELF_AS_PRINCIPAL":true,"USE_TRADEMARK_OWNER_VALIDATION":true,"USE_ALTERNATIVE_FOREIGN_ADDRESS_LABELS":true,"MY_RECEIPTS_FILTER":[{"type":"dateRange","name":"DATE_RANGE","label":"Date range","defaultValue":{"start":null,"end":null}},{"type":"text","name":"REF_NUM","defaultValue":"","label":"Reference Number"},{"type":"text","name":"RECEIPT_NUM","defaultValue":"","label":"Receipt Id"},{"type":"text","name":"AMOUNT","defaultValue":"","label":"Amount"},{"type":"select","name":"TYPE","defaultValue":"","label":"Payment Type","options":[{"value":"","label":"All"},{"value":"CC","label":"Credit Card"},{"value":"Check","label":"Check"}]}],"MY_RECEIPTS_SHOW_IN_SIDEBAR":true,"SHOW_MY_RECEIPTS_HELPER_TEXT":true,"MY_RECEIPTS_HELPER_LABEL":"About Receipt Search","MY_RECEIPTS_HELPER_TEXT":"You can search for receipts based on their descriptions, including the items paid for on the receipt. Use the filters to search for or filter specific information.","FARM_BILL_SUBLINK":{"label":"Farm Bill","component":"FarmBill","parameter":"farm-bill","path":"/lists/farm-bill","sourceTypeId":0,"myRecordsSearch":false,"allowedRules":["/search/"],"disabled":true,"searchDescription":"To perform a search, enter a debtor name. Your search results may include: exact debtor name, variations of that name and any filing that includes your search criteria. Punctuation is ignored.\n\nYou can click on \"Advanced\" to refine your search. Under “Advanced” you can search by crop, year, county and SSN/FEIN. As a registered Farm Bill Buyer with the Montana Secretary of State’s office it is important to maintain the confidentiality of the information contained within the Farm Bill Master List. The Farm Bill Master List reflects personal data, such as Social Security Numbers, which are a key piece of personal identifiable information to assist you in determining the existence of a lien against a specific debtor. The distribution of this information beyond its intended purpose is strictly prohibited.\n\nThe debtor's tax identification number has been hidden for confidentiality reasons. You may continue to search on a tax ID number and return debtors that match your search criteria. The SSN/FEIN must be entered without dashes or spaces.","searchMustHaveOneOf":["search","UCC_FARM_PRODUCT_ID","COUNTY"],"searchPlaceholder":"Search by debtor name","advancedSearchParameters":[{"type":"ServerMultiComplete","label":"Product code name(s)","name":"UCC_FARM_PRODUCT_ID","defaultValue":"","optionsSrc":"UCC_FARM_PRODUCT_V"},{"type":"MultiComplete","label":"Year or Range of Years","name":"YEAR_NUM","optionsSrc":"years","startYear":"1968","defaultValue":[],"preMergeOptions":[{"value":"ALL","label":"All"}]},{"type":"serverSelect","label":"State","name":"STATE","defaultValue":"MONTANA","optionsSrc":"STATE"},{"type":"ServerMultiComplete","label":"County","name":"COUNTY","defaultValue":[],"optionsSrc":"COUNTY","overrideSubOptionsSrcFromParameterName":"STATE"},{"type":"checkbox","name":"TIN_SEARCH_YN","defaultValue":false,"label":"Tax Identification Number Search"},{"type":"checkbox","name":"TIN_SORT_YN","defaultValue":false,"label":"Unique ID Sort"}]},"ALLOW_ADDRESS_VALIDATION_BYPASS_OPTION":true,"DEFAULT_ADDRESS_VALIDATION_BYPASS_OPTION_CHECKED":true}).CERTIFICATE_VERIFICATION_TITLE || 'Verify Certificate',
	          leftColumn: _react2.default.createElement(
	            _react2.default.Fragment,
	            null,
	            _react2.default.createElement(
	              _Field.DumbField,
	              {
	                label: ({"NODE_ENV":"production","BUILD_DATE":"2025-08-27T15:15:31.687Z","BUILD_NUMBER":"Not Provided","GIT_VERSION":"v1.3.0-381-ga81e29b08","GIT_COMMIT_HASH":"a81e29b085c9268ffd96c78eb734365802722741","GIT_BRANCH":"beta","PUBLIC_URL":"","STATE_ABBR":"MT","STATE_NAME":"Montana","STATE_ORG_TITLE":"Secretary of State","LOGIN_HEADER_IMG_PATH":"","HOME_IMG_FILENAME":"montana.jpg","FAVICON_FILE_NAME":"favicon.ico","ALLOW_E_SIGN_ON_CORRECTIONS":true,"THIRD_PARTY_SIGNING_ALLOWED":false,"MY_ACCOUNT_SAVE_AND_CLOSE_BUTTON":true,"IE_DEPRECATED_MESSAGE":"Internet Explorer is not supported. Please select a supported browser below to access this website.","ADDITIONAL_ROUTES":{"dataRequests":true,"farmBill":true,"apostille":true,"externalHelp":"https://sosmt.gov/business/help-center/","systemAdministration":[{"title":"Saved Payments","parameter":"saved-payments","componentName":"SavedPayments"}]},"SUBROUTES":[{"label":"Business","component":"Business","parameter":"business","myWorkQueueSearch":false,"sourceTypeId":54,"searchMustHaveOneOf":["FILING_TYPE_ID","STATUS_ID","STATE","search"],"serverWebSearchDescription":true,"serverWorkQueueDescription":true,"serverMyRecordsDescription":true,"searchPlaceholder":"Search by name or filing number (X########)","allowEmptySearchTerm":true,"requestCertificateAlternateLabel":"Request Information","fileAmendmentButtonLabel":"Filing Actions","advancedSearchParameters":[{"type":"radio","name":"QUERY_TYPE_ID","defaultValue":1010,"options":[{"value":1010,"label":"Starts with"},{"value":1011,"label":"Contains"},{"value":1012,"label":" Word Contains"}]},{"type":"serverSelect","name":"FILING_TYPE_ID","optionsSrc":"FILING_TYPES","label":"Entity Type","placeholder":"All","defaultValue":"0"},{"type":"serverSelect","name":"FILING_SUBTYPE_ID","optionsSrc":"FILING_SUBTYPES","label":"Entity Subtype","overrideSubOptionsSrcFromParameterName":"FILING_TYPE_ID","placeholder":"All","defaultValue":"0"},{"type":"serverSelect","name":"STATUS_ID","optionsSrc":"FILING_STATUS_WITHOUT_ALL","label":"Status","placeholder":"All","defaultValue":"0"},{"type":"serverSelect","name":"STATE","optionsSrc":"STATE","label":"State","placeholder":"All","defaultValue":""},{"type":"serverSelect","name":"COUNTY","optionsSrc":"COUNTY_SUBOPTION","label":"County","overrideSubOptionsSrcFromParameterName":"STATE","placeholder":"All","defaultValue":""},{"type":"checkbox","name":"CRA_SEARCH_YN","defaultValue":false,"label":"Search by Registered Agent PID"},{"type":"dateRange","name":"FILING_DATE","label":"Registration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}},{"type":"dateRange","name":"EXPIRATION_DATE","label":"Expiration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}}],"myRecordsFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Active"},{"value":2,"label":"Inactive"},{"value":3,"label":"Pending"}]},{"type":"dateRange","name":"DATE_RANGE","label":"Date range","defaultValue":{"start":null,"end":null}}],"myWorkQueueFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Approved"},{"value":2,"label":"Pending Online Payment"},{"value":3,"label":"Pending Review"},{"value":4,"label":"Needs Correction"},{"value":5,"label":"Rejected"},{"value":6,"label":"Draft"}]},{"type":"dateRange","name":"DATE_RANGE","label":"Date range","defaultValue":{"start":null,"end":null}}]},{"label":"Notary","component":"Notary","parameter":"notary","sourceTypeId":850,"myWorkQueueSearch":false,"allowEmptySearchTerm":true,"requestCertificateAlternateLabel":"Download Certificate","fileAmendmentButtonLabel":"Filing Actions","hideNameRequestCertificate":true,"hideAddressRequestCertificate":true,"hideRecordUserManagment":true,"searchPlaceholder":"Search by name or commission number","searchMustHaveOneOf":["CITY","search","SERVICE_TYPE"],"advancedParametersStartOpen":true,"searchIsSortable":true,"advancedSearchParameters":[{"type":"radio","name":"STARTS_WITH_YN","defaultValue":false,"options":[{"value":true,"label":"Starts with"},{"value":false,"label":"Contains"}]},{"type":"checkbox","name":"ACTIVE_ONLY_YN","defaultValue":true,"label":"Active entities only"},{"type":"text","name":"CITY","defaultValue":"","label":"City"},{"type":"select","name":"SERVICE_TYPE","label":"Special Services Offered","defaultValue":0,"options":[{"value":0,"label":"(N/A)"},{"value":6165,"label":"In-Person Electronic Notarization (IPEN)"},{"value":6166,"label":"Remote Online Notarization (RON)"},{"value":6167,"label":"Mobile Notary Services"},{"value":6168,"label":"Remote Ink Notarization (RIN)"}]}]},{"label":"Apostille","component":"Apostille","parameter":"apostille","sourceTypeId":720,"myRecordsSearch":false,"myWorkQueueSearch":false,"disabled":false,"allowedRoutes":["/forms-manager/","/queue/","/forms/"]},{"label":"Liens","component":"UCC","parameter":"ucc","sourceTypeId":1999,"myRecordsSearch":true,"myWorkQueueSearch":true,"fileAmendmentButtonLabel":"Filing Actions","searchPlaceholder":"Search by name or file number","disabled":false,"serverWebSearchDescription":true,"myRecordsDescription":"","workQueueDescription":"","searchDescription":"","hideRecordUserManagment":true,"searchLiensCheckout":false,"advancedSearchParameters":[{"type":"radio","name":"STARTS_WITH_YN","defaultValue":false,"options":[{"value":true,"label":"Starts with"},{"value":false,"label":"Contains"}]},{"type":"select","name":"STATUS","defaultValue":"ALL","label":"Status","options":[{"value":"ACTIVE_UNLAPSED","label":"Active (unlapsed)"},{"value":"ACTIVE_LAPSED_UNLAPSED","label":"Active (lapsed and unlapsed)"}]},{"type":"text","name":"EXCLUDE_VALUES","label":"Exclude Debtor Names (comma separated list of names to exclude)","defaultValue":""},{"type":"dateRange","name":"FILING_DATE","label":"Financing Statement Date","defaultValue":{"start":null,"end":null}},{"type":"dateRange","name":"LAPSE_DATE","label":"Lapse Date","defaultValue":{"start":null,"end":null}},{"type":"text","name":"CITY","label":"Debtor City","defaultValue":""}],"myRecordsFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Approved"},{"value":2,"label":"Pending Online Payment"},{"value":3,"label":"Pending Review"}]},{"type":"select","name":"TYPE","defaultValue":0,"label":"Lien Type","options":[{"value":0,"label":"All"},{"value":1,"label":"UCC"},{"value":2,"label":"EFS"},{"value":3,"label":"Title 71"}]}],"myWorkQueueFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Approved"},{"value":2,"label":"Pending Online Payment"},{"value":3,"label":"Pending Review"},{"value":4,"label":"Pending Print and Mail"},{"value":5,"label":"Rejected"},{"value":6,"label":"Draft"}]},{"type":"select","name":"TYPE","defaultValue":0,"label":"Lien Type","options":[{"value":0,"label":"All"},{"value":1,"label":"UCC"},{"value":2,"label":"EFS"},{"value":3,"label":"Title 71"}]}]},{"label":"Copy Request","component":"copies","parameter":"copies","sourceTypeId":2001,"myRecordsSearch":false,"myWorkQueueSearch":false,"disabled":false,"allowedRoutes":["/forms-manager/","/queue/","/forms/"]},{"label":"Trademark","component":"Trademark","parameter":"trademark","sourceTypeId":810,"showRequestCertificate":true,"searchMustHaveOneOf":["search","EXPIRATION_DATE","FILING_DATE"],"allowEmptySearchTerm":true,"requestCertificateAlternateLabel":"Request Information","fileAmendmentButtonLabel":"Filing Actions","advancedSearchParameters":[{"type":"radio","name":"QUERY_TYPE_ID","defaultValue":1010,"options":[{"value":1010,"label":"Starts with"},{"value":1011,"label":"Contains"},{"value":1012,"label":" Word Contains"}]},{"type":"checkbox","name":"OWNER_SEARCH_YN","defaultValue":false,"label":"Search owners"},{"type":"radio","name":"SERVICE_MARK_YN","label":"Mark Type","defaultValue":"","options":[{"value":"","label":"All Marks"},{"value":"Y","label":"Service Mark"},{"value":"N","label":"Trademark"}]},{"type":"serverSelect","name":"STATUS_ID","optionsSrc":"TYPE_V|TRADEMARK_STATUS_TYPE","label":"Status","placeholder":"All","defaultValue":"0"},{"type":"select","name":"DESIGN_TYPE_ID","options":[{"value":0,"label":"All"},{"value":990,"label":"Words Only"},{"value":991,"label":"Design Only"},{"value":992,"label":"Words and Design"}],"label":"Design Type","defaultValue":"0"},{"type":"dateRange","name":"FILING_DATE","label":"Registered Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}},{"type":"dateRange","name":"EXPIRATION_DATE","label":"Expiration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}}]},{"label":"Business Info Request","component":"InfoRequests","parameter":"info-request","sourceTypeId":167,"allowedRoutes":["/forms-manager/","/queue/","/forms/"]},{"label":"Data Requests","component":"DataRequests","parameter":"data-request","sourceTypeId":0,"allowedRoutes":["/forms-manager/"]},{"label":"CRA","component":"CRA","parameter":"cra","sourceTypeId":157,"myRecordsSearch":false,"searchPlaceholder":"Search by name or registered agent number","allowedRoutes":["/forms-manager/","/forms/","/records/","/queue/","/search/"],"allowEmptySearchTerm":true,"fileAmendmentButtonLabel":"Filing Actions","advancedSearchParameters":[{"type":"radio","name":"QUERY_TYPE_ID","defaultValue":1010,"options":[{"value":1010,"label":"Starts with"},{"value":1011,"label":"Contains"},{"value":1012,"label":" Word Contains"}]},{"type":"dateRange","name":"CRA_DATE","label":"Registration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}},{"type":"select","name":"STATUS_ID","label":"Status","defaultValue":0,"options":[{"value":0,"label":"All"},{"value":121,"label":"Active"},{"value":122,"label":"Inactive"}]},{"type":"select","name":"AGENT_TYPE_ID","label":"Agent Type","defaultValue":0,"options":[{"value":0,"label":"All"},{"value":460,"label":"Registered Agent"},{"value":461,"label":"Commercial Registered Agent"}]}]},{"label":"Farm Bill","component":"FarmBill","parameter":"farm-bill","path":"/lists/farm-bill","sourceTypeId":0,"myRecordsSearch":false,"allowedRules":["/search/"],"disabled":true,"searchDescription":"To perform a search, enter a debtor name. Your search results may include: exact debtor name, variations of that name and any filing that includes your search criteria. Punctuation is ignored.\n\nYou can click on \"Advanced\" to refine your search. Under “Advanced” you can search by crop, year, county and SSN/FEIN. As a registered Farm Bill Buyer with the Montana Secretary of State’s office it is important to maintain the confidentiality of the information contained within the Farm Bill Master List. The Farm Bill Master List reflects personal data, such as Social Security Numbers, which are a key piece of personal identifiable information to assist you in determining the existence of a lien against a specific debtor. The distribution of this information beyond its intended purpose is strictly prohibited.\n\nThe debtor's tax identification number has been hidden for confidentiality reasons. You may continue to search on a tax ID number and return debtors that match your search criteria. The SSN/FEIN must be entered without dashes or spaces.","searchMustHaveOneOf":["search","UCC_FARM_PRODUCT_ID","COUNTY"],"searchPlaceholder":"Search by debtor name","advancedSearchParameters":[{"type":"ServerMultiComplete","label":"Product code name(s)","name":"UCC_FARM_PRODUCT_ID","defaultValue":"","optionsSrc":"UCC_FARM_PRODUCT_V"},{"type":"MultiComplete","label":"Year or Range of Years","name":"YEAR_NUM","optionsSrc":"years","startYear":"1968","defaultValue":[],"preMergeOptions":[{"value":"ALL","label":"All"}]},{"type":"serverSelect","label":"State","name":"STATE","defaultValue":"MONTANA","optionsSrc":"STATE"},{"type":"ServerMultiComplete","label":"County","name":"COUNTY","defaultValue":[],"optionsSrc":"COUNTY","overrideSubOptionsSrcFromParameterName":"STATE"},{"type":"checkbox","name":"TIN_SEARCH_YN","defaultValue":false,"label":"Tax Identification Number Search"},{"type":"checkbox","name":"TIN_SORT_YN","defaultValue":false,"label":"Unique ID Sort"}]}],"SYSTEM_NICKNAME":"Online Services Portal","PAYMENT_METHODS":[{"type":"bypass"},{"type":"iTransact"}],"PAYMENT_ALLOW_AMEX":true,"SYSTEM_ID_LABEL":"System Id","DOUBLE_COLUMN_PUBLIC_LOGIN":true,"INTERNAL_USER_MANAGEMENT":true,"ALLOW_PUBLIC_JSON_IMPORT":false,"MAX_FILE_UPLOAD_SIZE":10000000,"REFUND_TEXT":"","RETURN_TO_HOME_ON_LOGOUT":true,"CURRENT_SOS_NAME":"Christi Jacobsen","LOGO_FILENAME":"mt-sos-logo.png","LOGO_ALT":"Christi Jacobsen, Montana Secretary of State","LOGO_FULL_WIDTH":true,"HOME_HIDE_AUTH_HINT":true,"HOME_TITLE":"Montana Secretary of State","CUSTOM_TAB_TITLE":"Official Montana","HOME_SUBTITLE":"Online Business Services","ENTITY_NAME_CONSENT_DESCRIPTION":"","ALLOW_USER_PROFILE_EDITING":true,"COMPARE_FOREIGN_NAME_IN_ENTITY_NAME_VALIDATION":true,"FOREIGN_NAME_FIELD_NAME":"KIMA_PARENT_NAME_INFO","LOGIN_TITLE":"Montana Secretary of State Online Filing Portal Login","PUBLIC_LOGIN_LABEL":"Username","REVERSE_LOGIN_COLUMNS":true,"LOGIN_SEAL_FILENAME":"seal_white.png","SEPARATE_USERNAME_AND_EMAIL":true,"CREATE_ACCOUNT_BUTTON_ALIGN_LEFT":true,"CREATE_ACCOUNT_BUTTON_TEXT":"CREATE AN ACCOUNT","PASSWORD_CUSTOM_ERROR_TEXT":"The password must meet all requirements","ACCOUNT_CREATED_MESSAGE":"Please check your email to verify your account to login and allow a few minutes for this message to arrive. Check your junk/spam folders if you do not find the email in your inbox.","PUBLIC_LOGIN_PLACEHOLDER":" ","DISABLE_DEFAULT_PAYMENT_RADIO":true,"CUSTOM_RESET_PASSWORD_ERROR_MESSAGE":"Username invalid - no account found","PUBLIC_LOGIN_CREATE_DESCRIPTION":"### Existing User:\n\n  - Enter your username and password to login.  \n\n\n  #### - OR -  \n\n\n\n  - Forgot password? Click 'Reset Password' and follow the prompts.\n  - Forgot username? Click 'Forgot Username' and follow the prompts.  \n\n\n  ### New User:\n  ","LOGIN_HELP_LINK":"https://sosmt.gov/business/how-do-i/","LOGIN_HELP_LINK_TEXT":"Need Help?","FORGOT_USERNAME_TEXT":"Forgot Username?","LOGIN_ACTIVE_DIRECTORY_TEXT":"State User Login","MULTIPLE_LOGIN_METHODS":true,"HAS_ACTIVE_DIRECTORY_LOGIN":true,"RESET_PASSWORD_WITH_USERNAME":true,"DOWNLOAD_LINK":true,"SHOW_USERNAME_ACCOUNT_CREATE":true,"SHOW_SCROLL_DOWN_ARROW":true,"SHOW_ADDRESS_ACCOUNT_CREATE":true,"TWO_COLUMN_ACCOUNT_CREATE":true,"RESET_PASSWORD_TIP":"A link to change your password has been sent to your email. Please allow a few minutes for this message to arrive. Please check your junk/spam folders if you do not find the email in your inbox.","FORGOT_PASSWORD_LINK_TEXT":"Reset Password","PHONE_NUMBER_OPTIONAL_ACCOUNT_CREATE":true,"SHOW_REQUIRED_INDICATOR_ACCOUNT_CREATE":true,"PASSWORD_REQUIREMENTS_ACCOUNT_CREATE":"\n    <ul>\n      <li>MUST contain at least 8 characters (12+ recommended)</li>\n      <li>MUST contain at least one uppercase letter.</li>\n      <li>MUST contain at least one lowercase letter.</li>\n      <li>MUST contain at least one number.</li>\n      <li>MUST contain at least one special character (!”#$%&'()*+,-./:;<=>?</li>\n    </ul>\n  ","ALLOW_CERTIFICATION_REQUEST":true,"ALLOW_PUBLIC_CERTIFICATE_REQUEST":true,"ALLOW_COPY_REQUEST":false,"ALLOW_CORRECTION_STYLING":true,"HIDE_DEPRECATION_WARNING":false,"AMEND_ROUTE_PUBLIC":true,"SEAL_FILENAME":"seal.png","SHOPPING_CART":true,"ALLOW_PAYMENT_UPDATE_WITH_EMPTY_CART":true,"RA_EMAIL":true,"RA_WEBSITE":true,"RA_NO_DEFAULT_TYPE":true,"RA_ADDRESS_LABEL":"Street Address","RA_TYPE_SELECTION_DEFAULT":true,"RA_DEFAULT_TYPE":"460","RA_OVERRIDE_TYPE_WITH_DEFAULT":true,"RA_PRINCIPAL_ADDRESS_AMS":true,"UPLOAD_AND_SUBMIT_HIDE_IF_ONE_OPTION":true,"PAYMENT_PROCESSING_MESSAGE":"Your payment is processing - Do not close your browser or click the back button","CHECKOUT_BUTTON_WHEN_PROCESSING_TEXT":"Processing","EFS_CROP_PICKER_NONE_LABEL":"Lien Duration","DISALLOWED_WIZARD_PIECES":["FormationLocale"],"REPEATER_SHOW_EDIT_BUTTON":true,"DATA_REQUEST_PAGE_TITLE":"Data Requests and Subscriptions","DATA_REQUEST_SIDEBAR_LABEL":"Data Requests & Subscriptions","LOGIN_REDIRECTS_TO_EPASS":false,"LOGIN_REDIRECTS_TO_ACTIVE_DIRECTORY":true,"LOGIN_ACTIVE_DIRECTORY_LINK":true,"FETCH_EDIT_USER_LINK":false,"LISTS_FETCH_AVAILABLE_LISTS":true,"POST_WIZARD_SUBMIT_REDIRECT_URL":"/","PIN_REQUEST_ATTESTATIONS":true,"PIN_REQUEST_DESCRIPTION":"Click **Request PIN** to have a new PIN sent to the account holder's email address on file.","OWNERSHIP_REQUEST_DESCRIPTION":"To become an **authorized user** of this record, a current **AUTHORIZED USER** will need to grant you access. To request access, click **Request Access** below.","PIN_REQUEST_SUCCESS_MESSAGE":"The PIN you have requested for this entity has been sent to the email associated with your user account.  You should receive the PIN in approximately 3-5 minutes, depending on your email service provider.","APOSTILLE_HEADER_LABEL":"Verification Information","APOSTILLE_NUMBER_LABEL":"Apostille/Authentication","APOSTILLE_CITY_STATE_OVERRIDE":"HELENA, MT","APOSTILLE_FILING_DATE_LABEL":"Issue Date","APOSTILLE_CITY_STATE_IN_CERTIFIED":true,"NOTARY_EXISTING_FILING":true,"ALLOW_REVOKE_OWN_ACCESS_ONLY":false,"HIDE_CANCEL_ON_ONETIME_DATA_REQUESTS":true,"DATA_REQUESTS_IN_SHOPPING_CART":true,"WQ_ALLOW_EDIT_PENDING_PAYMENT":true,"WQ_CONFIRM_ON_DELETE":true,"WQ_DELETE_CONFIRM_MESSAGE":"Deleting this filing will forfeit any money already paid to the Secretary of State. This action is permanent and cannot be undone, are you sure you would like to delete?","PASS_ITEM_GUIDS_ON_CHECKOUT":true,"FORM_REVISION_HISTORY":true,"CHECKOUT_DISCLAIMER":"By entering your credit card and/or checking account information you (i) state that **you are an authorized user** of the credit card and/or electronic check and that the associated information entered (e.g., account holder name, account number, billing address) is accurate, (ii) **you authorize payment processor to charge the amount you have requested** to your credit card and/or funding account, and (iii) **acknowledge if a charge is declined or reversed you may also be assessed a customary charge** by the payment processor for such transactions.","FARM_BILL_SEARCH_CONFIDENTIAL":"As a registered Farm Bill Buyer with the Montana Secretary of State’s office it is important to maintain the confidentiality of the information contained within the Farm Bill Master List. The Farm Bill Master List reflects personal data, such as Social Security Numbers, which are a key piece of personal identifiable information to assist you in determining the existence of a lien against a specific debtor. The distribution of this information beyond its intended purpose is strictly prohibited.\n\n**The debtor's tax identification number has been hidden for confidentiality reasons. You may continue to search on a tax ID number and return debtors that match your search criteria. The SSN/FEIN must be entered without dashes or spaces.  If you need access to the tax identification number to clearly identify the debtor, please contact the UCC unit at (406) 444-3665.**","VIEW_HISTORY_BUTTON_ALT_TEXT":"View Filings","WIZARD_ERROR_TITLE_MESSAGE":"Form Error","FARM_BILL_SEARCH_INTERACTIVE":true,"USE_FARM_BILL_API":true,"DISALLOW_ASSIGN_SELF_AS_RA":true,"DISALLOW_ASSIGN_SELF_AS_PRINCIPAL":true,"USE_TRADEMARK_OWNER_VALIDATION":true,"USE_ALTERNATIVE_FOREIGN_ADDRESS_LABELS":true,"MY_RECEIPTS_FILTER":[{"type":"dateRange","name":"DATE_RANGE","label":"Date range","defaultValue":{"start":null,"end":null}},{"type":"text","name":"REF_NUM","defaultValue":"","label":"Reference Number"},{"type":"text","name":"RECEIPT_NUM","defaultValue":"","label":"Receipt Id"},{"type":"text","name":"AMOUNT","defaultValue":"","label":"Amount"},{"type":"select","name":"TYPE","defaultValue":"","label":"Payment Type","options":[{"value":"","label":"All"},{"value":"CC","label":"Credit Card"},{"value":"Check","label":"Check"}]}],"MY_RECEIPTS_SHOW_IN_SIDEBAR":true,"SHOW_MY_RECEIPTS_HELPER_TEXT":true,"MY_RECEIPTS_HELPER_LABEL":"About Receipt Search","MY_RECEIPTS_HELPER_TEXT":"You can search for receipts based on their descriptions, including the items paid for on the receipt. Use the filters to search for or filter specific information.","FARM_BILL_SUBLINK":{"label":"Farm Bill","component":"FarmBill","parameter":"farm-bill","path":"/lists/farm-bill","sourceTypeId":0,"myRecordsSearch":false,"allowedRules":["/search/"],"disabled":true,"searchDescription":"To perform a search, enter a debtor name. Your search results may include: exact debtor name, variations of that name and any filing that includes your search criteria. Punctuation is ignored.\n\nYou can click on \"Advanced\" to refine your search. Under “Advanced” you can search by crop, year, county and SSN/FEIN. As a registered Farm Bill Buyer with the Montana Secretary of State’s office it is important to maintain the confidentiality of the information contained within the Farm Bill Master List. The Farm Bill Master List reflects personal data, such as Social Security Numbers, which are a key piece of personal identifiable information to assist you in determining the existence of a lien against a specific debtor. The distribution of this information beyond its intended purpose is strictly prohibited.\n\nThe debtor's tax identification number has been hidden for confidentiality reasons. You may continue to search on a tax ID number and return debtors that match your search criteria. The SSN/FEIN must be entered without dashes or spaces.","searchMustHaveOneOf":["search","UCC_FARM_PRODUCT_ID","COUNTY"],"searchPlaceholder":"Search by debtor name","advancedSearchParameters":[{"type":"ServerMultiComplete","label":"Product code name(s)","name":"UCC_FARM_PRODUCT_ID","defaultValue":"","optionsSrc":"UCC_FARM_PRODUCT_V"},{"type":"MultiComplete","label":"Year or Range of Years","name":"YEAR_NUM","optionsSrc":"years","startYear":"1968","defaultValue":[],"preMergeOptions":[{"value":"ALL","label":"All"}]},{"type":"serverSelect","label":"State","name":"STATE","defaultValue":"MONTANA","optionsSrc":"STATE"},{"type":"ServerMultiComplete","label":"County","name":"COUNTY","defaultValue":[],"optionsSrc":"COUNTY","overrideSubOptionsSrcFromParameterName":"STATE"},{"type":"checkbox","name":"TIN_SEARCH_YN","defaultValue":false,"label":"Tax Identification Number Search"},{"type":"checkbox","name":"TIN_SORT_YN","defaultValue":false,"label":"Unique ID Sort"}]},"ALLOW_ADDRESS_VALIDATION_BYPASS_OPTION":true,"DEFAULT_ADDRESS_VALIDATION_BYPASS_OPTION_CHECKED":true}).CERTIFICATE_VERIFICATION_LABEL || 'Certificate ID',
	                errorMessage: this.state.errors.certificateId ? [this.state.errors.certificateId] : []
	              },
	              _react2.default.createElement(_Form.TextInput, {
	                value: this.state.certificateId,
	                onChange: this.setCertificateId,
	                onKeyPress: this.checkEnter
	              })
	            ),
	            ({"NODE_ENV":"production","BUILD_DATE":"2025-08-27T15:15:31.687Z","BUILD_NUMBER":"Not Provided","GIT_VERSION":"v1.3.0-381-ga81e29b08","GIT_COMMIT_HASH":"a81e29b085c9268ffd96c78eb734365802722741","GIT_BRANCH":"beta","PUBLIC_URL":"","STATE_ABBR":"MT","STATE_NAME":"Montana","STATE_ORG_TITLE":"Secretary of State","LOGIN_HEADER_IMG_PATH":"","HOME_IMG_FILENAME":"montana.jpg","FAVICON_FILE_NAME":"favicon.ico","ALLOW_E_SIGN_ON_CORRECTIONS":true,"THIRD_PARTY_SIGNING_ALLOWED":false,"MY_ACCOUNT_SAVE_AND_CLOSE_BUTTON":true,"IE_DEPRECATED_MESSAGE":"Internet Explorer is not supported. Please select a supported browser below to access this website.","ADDITIONAL_ROUTES":{"dataRequests":true,"farmBill":true,"apostille":true,"externalHelp":"https://sosmt.gov/business/help-center/","systemAdministration":[{"title":"Saved Payments","parameter":"saved-payments","componentName":"SavedPayments"}]},"SUBROUTES":[{"label":"Business","component":"Business","parameter":"business","myWorkQueueSearch":false,"sourceTypeId":54,"searchMustHaveOneOf":["FILING_TYPE_ID","STATUS_ID","STATE","search"],"serverWebSearchDescription":true,"serverWorkQueueDescription":true,"serverMyRecordsDescription":true,"searchPlaceholder":"Search by name or filing number (X########)","allowEmptySearchTerm":true,"requestCertificateAlternateLabel":"Request Information","fileAmendmentButtonLabel":"Filing Actions","advancedSearchParameters":[{"type":"radio","name":"QUERY_TYPE_ID","defaultValue":1010,"options":[{"value":1010,"label":"Starts with"},{"value":1011,"label":"Contains"},{"value":1012,"label":" Word Contains"}]},{"type":"serverSelect","name":"FILING_TYPE_ID","optionsSrc":"FILING_TYPES","label":"Entity Type","placeholder":"All","defaultValue":"0"},{"type":"serverSelect","name":"FILING_SUBTYPE_ID","optionsSrc":"FILING_SUBTYPES","label":"Entity Subtype","overrideSubOptionsSrcFromParameterName":"FILING_TYPE_ID","placeholder":"All","defaultValue":"0"},{"type":"serverSelect","name":"STATUS_ID","optionsSrc":"FILING_STATUS_WITHOUT_ALL","label":"Status","placeholder":"All","defaultValue":"0"},{"type":"serverSelect","name":"STATE","optionsSrc":"STATE","label":"State","placeholder":"All","defaultValue":""},{"type":"serverSelect","name":"COUNTY","optionsSrc":"COUNTY_SUBOPTION","label":"County","overrideSubOptionsSrcFromParameterName":"STATE","placeholder":"All","defaultValue":""},{"type":"checkbox","name":"CRA_SEARCH_YN","defaultValue":false,"label":"Search by Registered Agent PID"},{"type":"dateRange","name":"FILING_DATE","label":"Registration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}},{"type":"dateRange","name":"EXPIRATION_DATE","label":"Expiration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}}],"myRecordsFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Active"},{"value":2,"label":"Inactive"},{"value":3,"label":"Pending"}]},{"type":"dateRange","name":"DATE_RANGE","label":"Date range","defaultValue":{"start":null,"end":null}}],"myWorkQueueFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Approved"},{"value":2,"label":"Pending Online Payment"},{"value":3,"label":"Pending Review"},{"value":4,"label":"Needs Correction"},{"value":5,"label":"Rejected"},{"value":6,"label":"Draft"}]},{"type":"dateRange","name":"DATE_RANGE","label":"Date range","defaultValue":{"start":null,"end":null}}]},{"label":"Notary","component":"Notary","parameter":"notary","sourceTypeId":850,"myWorkQueueSearch":false,"allowEmptySearchTerm":true,"requestCertificateAlternateLabel":"Download Certificate","fileAmendmentButtonLabel":"Filing Actions","hideNameRequestCertificate":true,"hideAddressRequestCertificate":true,"hideRecordUserManagment":true,"searchPlaceholder":"Search by name or commission number","searchMustHaveOneOf":["CITY","search","SERVICE_TYPE"],"advancedParametersStartOpen":true,"searchIsSortable":true,"advancedSearchParameters":[{"type":"radio","name":"STARTS_WITH_YN","defaultValue":false,"options":[{"value":true,"label":"Starts with"},{"value":false,"label":"Contains"}]},{"type":"checkbox","name":"ACTIVE_ONLY_YN","defaultValue":true,"label":"Active entities only"},{"type":"text","name":"CITY","defaultValue":"","label":"City"},{"type":"select","name":"SERVICE_TYPE","label":"Special Services Offered","defaultValue":0,"options":[{"value":0,"label":"(N/A)"},{"value":6165,"label":"In-Person Electronic Notarization (IPEN)"},{"value":6166,"label":"Remote Online Notarization (RON)"},{"value":6167,"label":"Mobile Notary Services"},{"value":6168,"label":"Remote Ink Notarization (RIN)"}]}]},{"label":"Apostille","component":"Apostille","parameter":"apostille","sourceTypeId":720,"myRecordsSearch":false,"myWorkQueueSearch":false,"disabled":false,"allowedRoutes":["/forms-manager/","/queue/","/forms/"]},{"label":"Liens","component":"UCC","parameter":"ucc","sourceTypeId":1999,"myRecordsSearch":true,"myWorkQueueSearch":true,"fileAmendmentButtonLabel":"Filing Actions","searchPlaceholder":"Search by name or file number","disabled":false,"serverWebSearchDescription":true,"myRecordsDescription":"","workQueueDescription":"","searchDescription":"","hideRecordUserManagment":true,"searchLiensCheckout":false,"advancedSearchParameters":[{"type":"radio","name":"STARTS_WITH_YN","defaultValue":false,"options":[{"value":true,"label":"Starts with"},{"value":false,"label":"Contains"}]},{"type":"select","name":"STATUS","defaultValue":"ALL","label":"Status","options":[{"value":"ACTIVE_UNLAPSED","label":"Active (unlapsed)"},{"value":"ACTIVE_LAPSED_UNLAPSED","label":"Active (lapsed and unlapsed)"}]},{"type":"text","name":"EXCLUDE_VALUES","label":"Exclude Debtor Names (comma separated list of names to exclude)","defaultValue":""},{"type":"dateRange","name":"FILING_DATE","label":"Financing Statement Date","defaultValue":{"start":null,"end":null}},{"type":"dateRange","name":"LAPSE_DATE","label":"Lapse Date","defaultValue":{"start":null,"end":null}},{"type":"text","name":"CITY","label":"Debtor City","defaultValue":""}],"myRecordsFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Approved"},{"value":2,"label":"Pending Online Payment"},{"value":3,"label":"Pending Review"}]},{"type":"select","name":"TYPE","defaultValue":0,"label":"Lien Type","options":[{"value":0,"label":"All"},{"value":1,"label":"UCC"},{"value":2,"label":"EFS"},{"value":3,"label":"Title 71"}]}],"myWorkQueueFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Approved"},{"value":2,"label":"Pending Online Payment"},{"value":3,"label":"Pending Review"},{"value":4,"label":"Pending Print and Mail"},{"value":5,"label":"Rejected"},{"value":6,"label":"Draft"}]},{"type":"select","name":"TYPE","defaultValue":0,"label":"Lien Type","options":[{"value":0,"label":"All"},{"value":1,"label":"UCC"},{"value":2,"label":"EFS"},{"value":3,"label":"Title 71"}]}]},{"label":"Copy Request","component":"copies","parameter":"copies","sourceTypeId":2001,"myRecordsSearch":false,"myWorkQueueSearch":false,"disabled":false,"allowedRoutes":["/forms-manager/","/queue/","/forms/"]},{"label":"Trademark","component":"Trademark","parameter":"trademark","sourceTypeId":810,"showRequestCertificate":true,"searchMustHaveOneOf":["search","EXPIRATION_DATE","FILING_DATE"],"allowEmptySearchTerm":true,"requestCertificateAlternateLabel":"Request Information","fileAmendmentButtonLabel":"Filing Actions","advancedSearchParameters":[{"type":"radio","name":"QUERY_TYPE_ID","defaultValue":1010,"options":[{"value":1010,"label":"Starts with"},{"value":1011,"label":"Contains"},{"value":1012,"label":" Word Contains"}]},{"type":"checkbox","name":"OWNER_SEARCH_YN","defaultValue":false,"label":"Search owners"},{"type":"radio","name":"SERVICE_MARK_YN","label":"Mark Type","defaultValue":"","options":[{"value":"","label":"All Marks"},{"value":"Y","label":"Service Mark"},{"value":"N","label":"Trademark"}]},{"type":"serverSelect","name":"STATUS_ID","optionsSrc":"TYPE_V|TRADEMARK_STATUS_TYPE","label":"Status","placeholder":"All","defaultValue":"0"},{"type":"select","name":"DESIGN_TYPE_ID","options":[{"value":0,"label":"All"},{"value":990,"label":"Words Only"},{"value":991,"label":"Design Only"},{"value":992,"label":"Words and Design"}],"label":"Design Type","defaultValue":"0"},{"type":"dateRange","name":"FILING_DATE","label":"Registered Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}},{"type":"dateRange","name":"EXPIRATION_DATE","label":"Expiration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}}]},{"label":"Business Info Request","component":"InfoRequests","parameter":"info-request","sourceTypeId":167,"allowedRoutes":["/forms-manager/","/queue/","/forms/"]},{"label":"Data Requests","component":"DataRequests","parameter":"data-request","sourceTypeId":0,"allowedRoutes":["/forms-manager/"]},{"label":"CRA","component":"CRA","parameter":"cra","sourceTypeId":157,"myRecordsSearch":false,"searchPlaceholder":"Search by name or registered agent number","allowedRoutes":["/forms-manager/","/forms/","/records/","/queue/","/search/"],"allowEmptySearchTerm":true,"fileAmendmentButtonLabel":"Filing Actions","advancedSearchParameters":[{"type":"radio","name":"QUERY_TYPE_ID","defaultValue":1010,"options":[{"value":1010,"label":"Starts with"},{"value":1011,"label":"Contains"},{"value":1012,"label":" Word Contains"}]},{"type":"dateRange","name":"CRA_DATE","label":"Registration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}},{"type":"select","name":"STATUS_ID","label":"Status","defaultValue":0,"options":[{"value":0,"label":"All"},{"value":121,"label":"Active"},{"value":122,"label":"Inactive"}]},{"type":"select","name":"AGENT_TYPE_ID","label":"Agent Type","defaultValue":0,"options":[{"value":0,"label":"All"},{"value":460,"label":"Registered Agent"},{"value":461,"label":"Commercial Registered Agent"}]}]},{"label":"Farm Bill","component":"FarmBill","parameter":"farm-bill","path":"/lists/farm-bill","sourceTypeId":0,"myRecordsSearch":false,"allowedRules":["/search/"],"disabled":true,"searchDescription":"To perform a search, enter a debtor name. Your search results may include: exact debtor name, variations of that name and any filing that includes your search criteria. Punctuation is ignored.\n\nYou can click on \"Advanced\" to refine your search. Under “Advanced” you can search by crop, year, county and SSN/FEIN. As a registered Farm Bill Buyer with the Montana Secretary of State’s office it is important to maintain the confidentiality of the information contained within the Farm Bill Master List. The Farm Bill Master List reflects personal data, such as Social Security Numbers, which are a key piece of personal identifiable information to assist you in determining the existence of a lien against a specific debtor. The distribution of this information beyond its intended purpose is strictly prohibited.\n\nThe debtor's tax identification number has been hidden for confidentiality reasons. You may continue to search on a tax ID number and return debtors that match your search criteria. The SSN/FEIN must be entered without dashes or spaces.","searchMustHaveOneOf":["search","UCC_FARM_PRODUCT_ID","COUNTY"],"searchPlaceholder":"Search by debtor name","advancedSearchParameters":[{"type":"ServerMultiComplete","label":"Product code name(s)","name":"UCC_FARM_PRODUCT_ID","defaultValue":"","optionsSrc":"UCC_FARM_PRODUCT_V"},{"type":"MultiComplete","label":"Year or Range of Years","name":"YEAR_NUM","optionsSrc":"years","startYear":"1968","defaultValue":[],"preMergeOptions":[{"value":"ALL","label":"All"}]},{"type":"serverSelect","label":"State","name":"STATE","defaultValue":"MONTANA","optionsSrc":"STATE"},{"type":"ServerMultiComplete","label":"County","name":"COUNTY","defaultValue":[],"optionsSrc":"COUNTY","overrideSubOptionsSrcFromParameterName":"STATE"},{"type":"checkbox","name":"TIN_SEARCH_YN","defaultValue":false,"label":"Tax Identification Number Search"},{"type":"checkbox","name":"TIN_SORT_YN","defaultValue":false,"label":"Unique ID Sort"}]}],"SYSTEM_NICKNAME":"Online Services Portal","PAYMENT_METHODS":[{"type":"bypass"},{"type":"iTransact"}],"PAYMENT_ALLOW_AMEX":true,"SYSTEM_ID_LABEL":"System Id","DOUBLE_COLUMN_PUBLIC_LOGIN":true,"INTERNAL_USER_MANAGEMENT":true,"ALLOW_PUBLIC_JSON_IMPORT":false,"MAX_FILE_UPLOAD_SIZE":10000000,"REFUND_TEXT":"","RETURN_TO_HOME_ON_LOGOUT":true,"CURRENT_SOS_NAME":"Christi Jacobsen","LOGO_FILENAME":"mt-sos-logo.png","LOGO_ALT":"Christi Jacobsen, Montana Secretary of State","LOGO_FULL_WIDTH":true,"HOME_HIDE_AUTH_HINT":true,"HOME_TITLE":"Montana Secretary of State","CUSTOM_TAB_TITLE":"Official Montana","HOME_SUBTITLE":"Online Business Services","ENTITY_NAME_CONSENT_DESCRIPTION":"","ALLOW_USER_PROFILE_EDITING":true,"COMPARE_FOREIGN_NAME_IN_ENTITY_NAME_VALIDATION":true,"FOREIGN_NAME_FIELD_NAME":"KIMA_PARENT_NAME_INFO","LOGIN_TITLE":"Montana Secretary of State Online Filing Portal Login","PUBLIC_LOGIN_LABEL":"Username","REVERSE_LOGIN_COLUMNS":true,"LOGIN_SEAL_FILENAME":"seal_white.png","SEPARATE_USERNAME_AND_EMAIL":true,"CREATE_ACCOUNT_BUTTON_ALIGN_LEFT":true,"CREATE_ACCOUNT_BUTTON_TEXT":"CREATE AN ACCOUNT","PASSWORD_CUSTOM_ERROR_TEXT":"The password must meet all requirements","ACCOUNT_CREATED_MESSAGE":"Please check your email to verify your account to login and allow a few minutes for this message to arrive. Check your junk/spam folders if you do not find the email in your inbox.","PUBLIC_LOGIN_PLACEHOLDER":" ","DISABLE_DEFAULT_PAYMENT_RADIO":true,"CUSTOM_RESET_PASSWORD_ERROR_MESSAGE":"Username invalid - no account found","PUBLIC_LOGIN_CREATE_DESCRIPTION":"### Existing User:\n\n  - Enter your username and password to login.  \n\n\n  #### - OR -  \n\n\n\n  - Forgot password? Click 'Reset Password' and follow the prompts.\n  - Forgot username? Click 'Forgot Username' and follow the prompts.  \n\n\n  ### New User:\n  ","LOGIN_HELP_LINK":"https://sosmt.gov/business/how-do-i/","LOGIN_HELP_LINK_TEXT":"Need Help?","FORGOT_USERNAME_TEXT":"Forgot Username?","LOGIN_ACTIVE_DIRECTORY_TEXT":"State User Login","MULTIPLE_LOGIN_METHODS":true,"HAS_ACTIVE_DIRECTORY_LOGIN":true,"RESET_PASSWORD_WITH_USERNAME":true,"DOWNLOAD_LINK":true,"SHOW_USERNAME_ACCOUNT_CREATE":true,"SHOW_SCROLL_DOWN_ARROW":true,"SHOW_ADDRESS_ACCOUNT_CREATE":true,"TWO_COLUMN_ACCOUNT_CREATE":true,"RESET_PASSWORD_TIP":"A link to change your password has been sent to your email. Please allow a few minutes for this message to arrive. Please check your junk/spam folders if you do not find the email in your inbox.","FORGOT_PASSWORD_LINK_TEXT":"Reset Password","PHONE_NUMBER_OPTIONAL_ACCOUNT_CREATE":true,"SHOW_REQUIRED_INDICATOR_ACCOUNT_CREATE":true,"PASSWORD_REQUIREMENTS_ACCOUNT_CREATE":"\n    <ul>\n      <li>MUST contain at least 8 characters (12+ recommended)</li>\n      <li>MUST contain at least one uppercase letter.</li>\n      <li>MUST contain at least one lowercase letter.</li>\n      <li>MUST contain at least one number.</li>\n      <li>MUST contain at least one special character (!”#$%&'()*+,-./:;<=>?</li>\n    </ul>\n  ","ALLOW_CERTIFICATION_REQUEST":true,"ALLOW_PUBLIC_CERTIFICATE_REQUEST":true,"ALLOW_COPY_REQUEST":false,"ALLOW_CORRECTION_STYLING":true,"HIDE_DEPRECATION_WARNING":false,"AMEND_ROUTE_PUBLIC":true,"SEAL_FILENAME":"seal.png","SHOPPING_CART":true,"ALLOW_PAYMENT_UPDATE_WITH_EMPTY_CART":true,"RA_EMAIL":true,"RA_WEBSITE":true,"RA_NO_DEFAULT_TYPE":true,"RA_ADDRESS_LABEL":"Street Address","RA_TYPE_SELECTION_DEFAULT":true,"RA_DEFAULT_TYPE":"460","RA_OVERRIDE_TYPE_WITH_DEFAULT":true,"RA_PRINCIPAL_ADDRESS_AMS":true,"UPLOAD_AND_SUBMIT_HIDE_IF_ONE_OPTION":true,"PAYMENT_PROCESSING_MESSAGE":"Your payment is processing - Do not close your browser or click the back button","CHECKOUT_BUTTON_WHEN_PROCESSING_TEXT":"Processing","EFS_CROP_PICKER_NONE_LABEL":"Lien Duration","DISALLOWED_WIZARD_PIECES":["FormationLocale"],"REPEATER_SHOW_EDIT_BUTTON":true,"DATA_REQUEST_PAGE_TITLE":"Data Requests and Subscriptions","DATA_REQUEST_SIDEBAR_LABEL":"Data Requests & Subscriptions","LOGIN_REDIRECTS_TO_EPASS":false,"LOGIN_REDIRECTS_TO_ACTIVE_DIRECTORY":true,"LOGIN_ACTIVE_DIRECTORY_LINK":true,"FETCH_EDIT_USER_LINK":false,"LISTS_FETCH_AVAILABLE_LISTS":true,"POST_WIZARD_SUBMIT_REDIRECT_URL":"/","PIN_REQUEST_ATTESTATIONS":true,"PIN_REQUEST_DESCRIPTION":"Click **Request PIN** to have a new PIN sent to the account holder's email address on file.","OWNERSHIP_REQUEST_DESCRIPTION":"To become an **authorized user** of this record, a current **AUTHORIZED USER** will need to grant you access. To request access, click **Request Access** below.","PIN_REQUEST_SUCCESS_MESSAGE":"The PIN you have requested for this entity has been sent to the email associated with your user account.  You should receive the PIN in approximately 3-5 minutes, depending on your email service provider.","APOSTILLE_HEADER_LABEL":"Verification Information","APOSTILLE_NUMBER_LABEL":"Apostille/Authentication","APOSTILLE_CITY_STATE_OVERRIDE":"HELENA, MT","APOSTILLE_FILING_DATE_LABEL":"Issue Date","APOSTILLE_CITY_STATE_IN_CERTIFIED":true,"NOTARY_EXISTING_FILING":true,"ALLOW_REVOKE_OWN_ACCESS_ONLY":false,"HIDE_CANCEL_ON_ONETIME_DATA_REQUESTS":true,"DATA_REQUESTS_IN_SHOPPING_CART":true,"WQ_ALLOW_EDIT_PENDING_PAYMENT":true,"WQ_CONFIRM_ON_DELETE":true,"WQ_DELETE_CONFIRM_MESSAGE":"Deleting this filing will forfeit any money already paid to the Secretary of State. This action is permanent and cannot be undone, are you sure you would like to delete?","PASS_ITEM_GUIDS_ON_CHECKOUT":true,"FORM_REVISION_HISTORY":true,"CHECKOUT_DISCLAIMER":"By entering your credit card and/or checking account information you (i) state that **you are an authorized user** of the credit card and/or electronic check and that the associated information entered (e.g., account holder name, account number, billing address) is accurate, (ii) **you authorize payment processor to charge the amount you have requested** to your credit card and/or funding account, and (iii) **acknowledge if a charge is declined or reversed you may also be assessed a customary charge** by the payment processor for such transactions.","FARM_BILL_SEARCH_CONFIDENTIAL":"As a registered Farm Bill Buyer with the Montana Secretary of State’s office it is important to maintain the confidentiality of the information contained within the Farm Bill Master List. The Farm Bill Master List reflects personal data, such as Social Security Numbers, which are a key piece of personal identifiable information to assist you in determining the existence of a lien against a specific debtor. The distribution of this information beyond its intended purpose is strictly prohibited.\n\n**The debtor's tax identification number has been hidden for confidentiality reasons. You may continue to search on a tax ID number and return debtors that match your search criteria. The SSN/FEIN must be entered without dashes or spaces.  If you need access to the tax identification number to clearly identify the debtor, please contact the UCC unit at (406) 444-3665.**","VIEW_HISTORY_BUTTON_ALT_TEXT":"View Filings","WIZARD_ERROR_TITLE_MESSAGE":"Form Error","FARM_BILL_SEARCH_INTERACTIVE":true,"USE_FARM_BILL_API":true,"DISALLOW_ASSIGN_SELF_AS_RA":true,"DISALLOW_ASSIGN_SELF_AS_PRINCIPAL":true,"USE_TRADEMARK_OWNER_VALIDATION":true,"USE_ALTERNATIVE_FOREIGN_ADDRESS_LABELS":true,"MY_RECEIPTS_FILTER":[{"type":"dateRange","name":"DATE_RANGE","label":"Date range","defaultValue":{"start":null,"end":null}},{"type":"text","name":"REF_NUM","defaultValue":"","label":"Reference Number"},{"type":"text","name":"RECEIPT_NUM","defaultValue":"","label":"Receipt Id"},{"type":"text","name":"AMOUNT","defaultValue":"","label":"Amount"},{"type":"select","name":"TYPE","defaultValue":"","label":"Payment Type","options":[{"value":"","label":"All"},{"value":"CC","label":"Credit Card"},{"value":"Check","label":"Check"}]}],"MY_RECEIPTS_SHOW_IN_SIDEBAR":true,"SHOW_MY_RECEIPTS_HELPER_TEXT":true,"MY_RECEIPTS_HELPER_LABEL":"About Receipt Search","MY_RECEIPTS_HELPER_TEXT":"You can search for receipts based on their descriptions, including the items paid for on the receipt. Use the filters to search for or filter specific information.","FARM_BILL_SUBLINK":{"label":"Farm Bill","component":"FarmBill","parameter":"farm-bill","path":"/lists/farm-bill","sourceTypeId":0,"myRecordsSearch":false,"allowedRules":["/search/"],"disabled":true,"searchDescription":"To perform a search, enter a debtor name. Your search results may include: exact debtor name, variations of that name and any filing that includes your search criteria. Punctuation is ignored.\n\nYou can click on \"Advanced\" to refine your search. Under “Advanced” you can search by crop, year, county and SSN/FEIN. As a registered Farm Bill Buyer with the Montana Secretary of State’s office it is important to maintain the confidentiality of the information contained within the Farm Bill Master List. The Farm Bill Master List reflects personal data, such as Social Security Numbers, which are a key piece of personal identifiable information to assist you in determining the existence of a lien against a specific debtor. The distribution of this information beyond its intended purpose is strictly prohibited.\n\nThe debtor's tax identification number has been hidden for confidentiality reasons. You may continue to search on a tax ID number and return debtors that match your search criteria. The SSN/FEIN must be entered without dashes or spaces.","searchMustHaveOneOf":["search","UCC_FARM_PRODUCT_ID","COUNTY"],"searchPlaceholder":"Search by debtor name","advancedSearchParameters":[{"type":"ServerMultiComplete","label":"Product code name(s)","name":"UCC_FARM_PRODUCT_ID","defaultValue":"","optionsSrc":"UCC_FARM_PRODUCT_V"},{"type":"MultiComplete","label":"Year or Range of Years","name":"YEAR_NUM","optionsSrc":"years","startYear":"1968","defaultValue":[],"preMergeOptions":[{"value":"ALL","label":"All"}]},{"type":"serverSelect","label":"State","name":"STATE","defaultValue":"MONTANA","optionsSrc":"STATE"},{"type":"ServerMultiComplete","label":"County","name":"COUNTY","defaultValue":[],"optionsSrc":"COUNTY","overrideSubOptionsSrcFromParameterName":"STATE"},{"type":"checkbox","name":"TIN_SEARCH_YN","defaultValue":false,"label":"Tax Identification Number Search"},{"type":"checkbox","name":"TIN_SORT_YN","defaultValue":false,"label":"Unique ID Sort"}]},"ALLOW_ADDRESS_VALIDATION_BYPASS_OPTION":true,"DEFAULT_ADDRESS_VALIDATION_BYPASS_OPTION_CHECKED":true}).COMBINED_CERTIFICATE_VERIFICATION ? _react2.default.createElement(
	              _Field.DumbField,
	              { label: 'Select a Certificate Type' },
	              _react2.default.createElement(_Form2.RadioInput, {
	                value: this.state.category,
	                onChange: function onChange(value) {
	                  _this2.setState({ category: value });
	                },
	                options: [{ value: 'business', label: 'Business' }, { value: 'ucc', label: 'UCC' }]
	              })
	            ) : null,
	            _react2.default.createElement(
	              'button',
	              { className: 'btn btn-primary btn-raised', onClick: this.validate },
	              'Verify Certificate'
	            )
	          ),
	          rightColumn: _react2.default.createElement(
	            _react2.default.Fragment,
	            null,
	            this.state.certificate ? null : _react2.default.createElement(
	              'p',
	              { className: 'description' },
	              ({"NODE_ENV":"production","BUILD_DATE":"2025-08-27T15:15:31.687Z","BUILD_NUMBER":"Not Provided","GIT_VERSION":"v1.3.0-381-ga81e29b08","GIT_COMMIT_HASH":"a81e29b085c9268ffd96c78eb734365802722741","GIT_BRANCH":"beta","PUBLIC_URL":"","STATE_ABBR":"MT","STATE_NAME":"Montana","STATE_ORG_TITLE":"Secretary of State","LOGIN_HEADER_IMG_PATH":"","HOME_IMG_FILENAME":"montana.jpg","FAVICON_FILE_NAME":"favicon.ico","ALLOW_E_SIGN_ON_CORRECTIONS":true,"THIRD_PARTY_SIGNING_ALLOWED":false,"MY_ACCOUNT_SAVE_AND_CLOSE_BUTTON":true,"IE_DEPRECATED_MESSAGE":"Internet Explorer is not supported. Please select a supported browser below to access this website.","ADDITIONAL_ROUTES":{"dataRequests":true,"farmBill":true,"apostille":true,"externalHelp":"https://sosmt.gov/business/help-center/","systemAdministration":[{"title":"Saved Payments","parameter":"saved-payments","componentName":"SavedPayments"}]},"SUBROUTES":[{"label":"Business","component":"Business","parameter":"business","myWorkQueueSearch":false,"sourceTypeId":54,"searchMustHaveOneOf":["FILING_TYPE_ID","STATUS_ID","STATE","search"],"serverWebSearchDescription":true,"serverWorkQueueDescription":true,"serverMyRecordsDescription":true,"searchPlaceholder":"Search by name or filing number (X########)","allowEmptySearchTerm":true,"requestCertificateAlternateLabel":"Request Information","fileAmendmentButtonLabel":"Filing Actions","advancedSearchParameters":[{"type":"radio","name":"QUERY_TYPE_ID","defaultValue":1010,"options":[{"value":1010,"label":"Starts with"},{"value":1011,"label":"Contains"},{"value":1012,"label":" Word Contains"}]},{"type":"serverSelect","name":"FILING_TYPE_ID","optionsSrc":"FILING_TYPES","label":"Entity Type","placeholder":"All","defaultValue":"0"},{"type":"serverSelect","name":"FILING_SUBTYPE_ID","optionsSrc":"FILING_SUBTYPES","label":"Entity Subtype","overrideSubOptionsSrcFromParameterName":"FILING_TYPE_ID","placeholder":"All","defaultValue":"0"},{"type":"serverSelect","name":"STATUS_ID","optionsSrc":"FILING_STATUS_WITHOUT_ALL","label":"Status","placeholder":"All","defaultValue":"0"},{"type":"serverSelect","name":"STATE","optionsSrc":"STATE","label":"State","placeholder":"All","defaultValue":""},{"type":"serverSelect","name":"COUNTY","optionsSrc":"COUNTY_SUBOPTION","label":"County","overrideSubOptionsSrcFromParameterName":"STATE","placeholder":"All","defaultValue":""},{"type":"checkbox","name":"CRA_SEARCH_YN","defaultValue":false,"label":"Search by Registered Agent PID"},{"type":"dateRange","name":"FILING_DATE","label":"Registration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}},{"type":"dateRange","name":"EXPIRATION_DATE","label":"Expiration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}}],"myRecordsFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Active"},{"value":2,"label":"Inactive"},{"value":3,"label":"Pending"}]},{"type":"dateRange","name":"DATE_RANGE","label":"Date range","defaultValue":{"start":null,"end":null}}],"myWorkQueueFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Approved"},{"value":2,"label":"Pending Online Payment"},{"value":3,"label":"Pending Review"},{"value":4,"label":"Needs Correction"},{"value":5,"label":"Rejected"},{"value":6,"label":"Draft"}]},{"type":"dateRange","name":"DATE_RANGE","label":"Date range","defaultValue":{"start":null,"end":null}}]},{"label":"Notary","component":"Notary","parameter":"notary","sourceTypeId":850,"myWorkQueueSearch":false,"allowEmptySearchTerm":true,"requestCertificateAlternateLabel":"Download Certificate","fileAmendmentButtonLabel":"Filing Actions","hideNameRequestCertificate":true,"hideAddressRequestCertificate":true,"hideRecordUserManagment":true,"searchPlaceholder":"Search by name or commission number","searchMustHaveOneOf":["CITY","search","SERVICE_TYPE"],"advancedParametersStartOpen":true,"searchIsSortable":true,"advancedSearchParameters":[{"type":"radio","name":"STARTS_WITH_YN","defaultValue":false,"options":[{"value":true,"label":"Starts with"},{"value":false,"label":"Contains"}]},{"type":"checkbox","name":"ACTIVE_ONLY_YN","defaultValue":true,"label":"Active entities only"},{"type":"text","name":"CITY","defaultValue":"","label":"City"},{"type":"select","name":"SERVICE_TYPE","label":"Special Services Offered","defaultValue":0,"options":[{"value":0,"label":"(N/A)"},{"value":6165,"label":"In-Person Electronic Notarization (IPEN)"},{"value":6166,"label":"Remote Online Notarization (RON)"},{"value":6167,"label":"Mobile Notary Services"},{"value":6168,"label":"Remote Ink Notarization (RIN)"}]}]},{"label":"Apostille","component":"Apostille","parameter":"apostille","sourceTypeId":720,"myRecordsSearch":false,"myWorkQueueSearch":false,"disabled":false,"allowedRoutes":["/forms-manager/","/queue/","/forms/"]},{"label":"Liens","component":"UCC","parameter":"ucc","sourceTypeId":1999,"myRecordsSearch":true,"myWorkQueueSearch":true,"fileAmendmentButtonLabel":"Filing Actions","searchPlaceholder":"Search by name or file number","disabled":false,"serverWebSearchDescription":true,"myRecordsDescription":"","workQueueDescription":"","searchDescription":"","hideRecordUserManagment":true,"searchLiensCheckout":false,"advancedSearchParameters":[{"type":"radio","name":"STARTS_WITH_YN","defaultValue":false,"options":[{"value":true,"label":"Starts with"},{"value":false,"label":"Contains"}]},{"type":"select","name":"STATUS","defaultValue":"ALL","label":"Status","options":[{"value":"ACTIVE_UNLAPSED","label":"Active (unlapsed)"},{"value":"ACTIVE_LAPSED_UNLAPSED","label":"Active (lapsed and unlapsed)"}]},{"type":"text","name":"EXCLUDE_VALUES","label":"Exclude Debtor Names (comma separated list of names to exclude)","defaultValue":""},{"type":"dateRange","name":"FILING_DATE","label":"Financing Statement Date","defaultValue":{"start":null,"end":null}},{"type":"dateRange","name":"LAPSE_DATE","label":"Lapse Date","defaultValue":{"start":null,"end":null}},{"type":"text","name":"CITY","label":"Debtor City","defaultValue":""}],"myRecordsFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Approved"},{"value":2,"label":"Pending Online Payment"},{"value":3,"label":"Pending Review"}]},{"type":"select","name":"TYPE","defaultValue":0,"label":"Lien Type","options":[{"value":0,"label":"All"},{"value":1,"label":"UCC"},{"value":2,"label":"EFS"},{"value":3,"label":"Title 71"}]}],"myWorkQueueFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Approved"},{"value":2,"label":"Pending Online Payment"},{"value":3,"label":"Pending Review"},{"value":4,"label":"Pending Print and Mail"},{"value":5,"label":"Rejected"},{"value":6,"label":"Draft"}]},{"type":"select","name":"TYPE","defaultValue":0,"label":"Lien Type","options":[{"value":0,"label":"All"},{"value":1,"label":"UCC"},{"value":2,"label":"EFS"},{"value":3,"label":"Title 71"}]}]},{"label":"Copy Request","component":"copies","parameter":"copies","sourceTypeId":2001,"myRecordsSearch":false,"myWorkQueueSearch":false,"disabled":false,"allowedRoutes":["/forms-manager/","/queue/","/forms/"]},{"label":"Trademark","component":"Trademark","parameter":"trademark","sourceTypeId":810,"showRequestCertificate":true,"searchMustHaveOneOf":["search","EXPIRATION_DATE","FILING_DATE"],"allowEmptySearchTerm":true,"requestCertificateAlternateLabel":"Request Information","fileAmendmentButtonLabel":"Filing Actions","advancedSearchParameters":[{"type":"radio","name":"QUERY_TYPE_ID","defaultValue":1010,"options":[{"value":1010,"label":"Starts with"},{"value":1011,"label":"Contains"},{"value":1012,"label":" Word Contains"}]},{"type":"checkbox","name":"OWNER_SEARCH_YN","defaultValue":false,"label":"Search owners"},{"type":"radio","name":"SERVICE_MARK_YN","label":"Mark Type","defaultValue":"","options":[{"value":"","label":"All Marks"},{"value":"Y","label":"Service Mark"},{"value":"N","label":"Trademark"}]},{"type":"serverSelect","name":"STATUS_ID","optionsSrc":"TYPE_V|TRADEMARK_STATUS_TYPE","label":"Status","placeholder":"All","defaultValue":"0"},{"type":"select","name":"DESIGN_TYPE_ID","options":[{"value":0,"label":"All"},{"value":990,"label":"Words Only"},{"value":991,"label":"Design Only"},{"value":992,"label":"Words and Design"}],"label":"Design Type","defaultValue":"0"},{"type":"dateRange","name":"FILING_DATE","label":"Registered Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}},{"type":"dateRange","name":"EXPIRATION_DATE","label":"Expiration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}}]},{"label":"Business Info Request","component":"InfoRequests","parameter":"info-request","sourceTypeId":167,"allowedRoutes":["/forms-manager/","/queue/","/forms/"]},{"label":"Data Requests","component":"DataRequests","parameter":"data-request","sourceTypeId":0,"allowedRoutes":["/forms-manager/"]},{"label":"CRA","component":"CRA","parameter":"cra","sourceTypeId":157,"myRecordsSearch":false,"searchPlaceholder":"Search by name or registered agent number","allowedRoutes":["/forms-manager/","/forms/","/records/","/queue/","/search/"],"allowEmptySearchTerm":true,"fileAmendmentButtonLabel":"Filing Actions","advancedSearchParameters":[{"type":"radio","name":"QUERY_TYPE_ID","defaultValue":1010,"options":[{"value":1010,"label":"Starts with"},{"value":1011,"label":"Contains"},{"value":1012,"label":" Word Contains"}]},{"type":"dateRange","name":"CRA_DATE","label":"Registration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}},{"type":"select","name":"STATUS_ID","label":"Status","defaultValue":0,"options":[{"value":0,"label":"All"},{"value":121,"label":"Active"},{"value":122,"label":"Inactive"}]},{"type":"select","name":"AGENT_TYPE_ID","label":"Agent Type","defaultValue":0,"options":[{"value":0,"label":"All"},{"value":460,"label":"Registered Agent"},{"value":461,"label":"Commercial Registered Agent"}]}]},{"label":"Farm Bill","component":"FarmBill","parameter":"farm-bill","path":"/lists/farm-bill","sourceTypeId":0,"myRecordsSearch":false,"allowedRules":["/search/"],"disabled":true,"searchDescription":"To perform a search, enter a debtor name. Your search results may include: exact debtor name, variations of that name and any filing that includes your search criteria. Punctuation is ignored.\n\nYou can click on \"Advanced\" to refine your search. Under “Advanced” you can search by crop, year, county and SSN/FEIN. As a registered Farm Bill Buyer with the Montana Secretary of State’s office it is important to maintain the confidentiality of the information contained within the Farm Bill Master List. The Farm Bill Master List reflects personal data, such as Social Security Numbers, which are a key piece of personal identifiable information to assist you in determining the existence of a lien against a specific debtor. The distribution of this information beyond its intended purpose is strictly prohibited.\n\nThe debtor's tax identification number has been hidden for confidentiality reasons. You may continue to search on a tax ID number and return debtors that match your search criteria. The SSN/FEIN must be entered without dashes or spaces.","searchMustHaveOneOf":["search","UCC_FARM_PRODUCT_ID","COUNTY"],"searchPlaceholder":"Search by debtor name","advancedSearchParameters":[{"type":"ServerMultiComplete","label":"Product code name(s)","name":"UCC_FARM_PRODUCT_ID","defaultValue":"","optionsSrc":"UCC_FARM_PRODUCT_V"},{"type":"MultiComplete","label":"Year or Range of Years","name":"YEAR_NUM","optionsSrc":"years","startYear":"1968","defaultValue":[],"preMergeOptions":[{"value":"ALL","label":"All"}]},{"type":"serverSelect","label":"State","name":"STATE","defaultValue":"MONTANA","optionsSrc":"STATE"},{"type":"ServerMultiComplete","label":"County","name":"COUNTY","defaultValue":[],"optionsSrc":"COUNTY","overrideSubOptionsSrcFromParameterName":"STATE"},{"type":"checkbox","name":"TIN_SEARCH_YN","defaultValue":false,"label":"Tax Identification Number Search"},{"type":"checkbox","name":"TIN_SORT_YN","defaultValue":false,"label":"Unique ID Sort"}]}],"SYSTEM_NICKNAME":"Online Services Portal","PAYMENT_METHODS":[{"type":"bypass"},{"type":"iTransact"}],"PAYMENT_ALLOW_AMEX":true,"SYSTEM_ID_LABEL":"System Id","DOUBLE_COLUMN_PUBLIC_LOGIN":true,"INTERNAL_USER_MANAGEMENT":true,"ALLOW_PUBLIC_JSON_IMPORT":false,"MAX_FILE_UPLOAD_SIZE":10000000,"REFUND_TEXT":"","RETURN_TO_HOME_ON_LOGOUT":true,"CURRENT_SOS_NAME":"Christi Jacobsen","LOGO_FILENAME":"mt-sos-logo.png","LOGO_ALT":"Christi Jacobsen, Montana Secretary of State","LOGO_FULL_WIDTH":true,"HOME_HIDE_AUTH_HINT":true,"HOME_TITLE":"Montana Secretary of State","CUSTOM_TAB_TITLE":"Official Montana","HOME_SUBTITLE":"Online Business Services","ENTITY_NAME_CONSENT_DESCRIPTION":"","ALLOW_USER_PROFILE_EDITING":true,"COMPARE_FOREIGN_NAME_IN_ENTITY_NAME_VALIDATION":true,"FOREIGN_NAME_FIELD_NAME":"KIMA_PARENT_NAME_INFO","LOGIN_TITLE":"Montana Secretary of State Online Filing Portal Login","PUBLIC_LOGIN_LABEL":"Username","REVERSE_LOGIN_COLUMNS":true,"LOGIN_SEAL_FILENAME":"seal_white.png","SEPARATE_USERNAME_AND_EMAIL":true,"CREATE_ACCOUNT_BUTTON_ALIGN_LEFT":true,"CREATE_ACCOUNT_BUTTON_TEXT":"CREATE AN ACCOUNT","PASSWORD_CUSTOM_ERROR_TEXT":"The password must meet all requirements","ACCOUNT_CREATED_MESSAGE":"Please check your email to verify your account to login and allow a few minutes for this message to arrive. Check your junk/spam folders if you do not find the email in your inbox.","PUBLIC_LOGIN_PLACEHOLDER":" ","DISABLE_DEFAULT_PAYMENT_RADIO":true,"CUSTOM_RESET_PASSWORD_ERROR_MESSAGE":"Username invalid - no account found","PUBLIC_LOGIN_CREATE_DESCRIPTION":"### Existing User:\n\n  - Enter your username and password to login.  \n\n\n  #### - OR -  \n\n\n\n  - Forgot password? Click 'Reset Password' and follow the prompts.\n  - Forgot username? Click 'Forgot Username' and follow the prompts.  \n\n\n  ### New User:\n  ","LOGIN_HELP_LINK":"https://sosmt.gov/business/how-do-i/","LOGIN_HELP_LINK_TEXT":"Need Help?","FORGOT_USERNAME_TEXT":"Forgot Username?","LOGIN_ACTIVE_DIRECTORY_TEXT":"State User Login","MULTIPLE_LOGIN_METHODS":true,"HAS_ACTIVE_DIRECTORY_LOGIN":true,"RESET_PASSWORD_WITH_USERNAME":true,"DOWNLOAD_LINK":true,"SHOW_USERNAME_ACCOUNT_CREATE":true,"SHOW_SCROLL_DOWN_ARROW":true,"SHOW_ADDRESS_ACCOUNT_CREATE":true,"TWO_COLUMN_ACCOUNT_CREATE":true,"RESET_PASSWORD_TIP":"A link to change your password has been sent to your email. Please allow a few minutes for this message to arrive. Please check your junk/spam folders if you do not find the email in your inbox.","FORGOT_PASSWORD_LINK_TEXT":"Reset Password","PHONE_NUMBER_OPTIONAL_ACCOUNT_CREATE":true,"SHOW_REQUIRED_INDICATOR_ACCOUNT_CREATE":true,"PASSWORD_REQUIREMENTS_ACCOUNT_CREATE":"\n    <ul>\n      <li>MUST contain at least 8 characters (12+ recommended)</li>\n      <li>MUST contain at least one uppercase letter.</li>\n      <li>MUST contain at least one lowercase letter.</li>\n      <li>MUST contain at least one number.</li>\n      <li>MUST contain at least one special character (!”#$%&'()*+,-./:;<=>?</li>\n    </ul>\n  ","ALLOW_CERTIFICATION_REQUEST":true,"ALLOW_PUBLIC_CERTIFICATE_REQUEST":true,"ALLOW_COPY_REQUEST":false,"ALLOW_CORRECTION_STYLING":true,"HIDE_DEPRECATION_WARNING":false,"AMEND_ROUTE_PUBLIC":true,"SEAL_FILENAME":"seal.png","SHOPPING_CART":true,"ALLOW_PAYMENT_UPDATE_WITH_EMPTY_CART":true,"RA_EMAIL":true,"RA_WEBSITE":true,"RA_NO_DEFAULT_TYPE":true,"RA_ADDRESS_LABEL":"Street Address","RA_TYPE_SELECTION_DEFAULT":true,"RA_DEFAULT_TYPE":"460","RA_OVERRIDE_TYPE_WITH_DEFAULT":true,"RA_PRINCIPAL_ADDRESS_AMS":true,"UPLOAD_AND_SUBMIT_HIDE_IF_ONE_OPTION":true,"PAYMENT_PROCESSING_MESSAGE":"Your payment is processing - Do not close your browser or click the back button","CHECKOUT_BUTTON_WHEN_PROCESSING_TEXT":"Processing","EFS_CROP_PICKER_NONE_LABEL":"Lien Duration","DISALLOWED_WIZARD_PIECES":["FormationLocale"],"REPEATER_SHOW_EDIT_BUTTON":true,"DATA_REQUEST_PAGE_TITLE":"Data Requests and Subscriptions","DATA_REQUEST_SIDEBAR_LABEL":"Data Requests & Subscriptions","LOGIN_REDIRECTS_TO_EPASS":false,"LOGIN_REDIRECTS_TO_ACTIVE_DIRECTORY":true,"LOGIN_ACTIVE_DIRECTORY_LINK":true,"FETCH_EDIT_USER_LINK":false,"LISTS_FETCH_AVAILABLE_LISTS":true,"POST_WIZARD_SUBMIT_REDIRECT_URL":"/","PIN_REQUEST_ATTESTATIONS":true,"PIN_REQUEST_DESCRIPTION":"Click **Request PIN** to have a new PIN sent to the account holder's email address on file.","OWNERSHIP_REQUEST_DESCRIPTION":"To become an **authorized user** of this record, a current **AUTHORIZED USER** will need to grant you access. To request access, click **Request Access** below.","PIN_REQUEST_SUCCESS_MESSAGE":"The PIN you have requested for this entity has been sent to the email associated with your user account.  You should receive the PIN in approximately 3-5 minutes, depending on your email service provider.","APOSTILLE_HEADER_LABEL":"Verification Information","APOSTILLE_NUMBER_LABEL":"Apostille/Authentication","APOSTILLE_CITY_STATE_OVERRIDE":"HELENA, MT","APOSTILLE_FILING_DATE_LABEL":"Issue Date","APOSTILLE_CITY_STATE_IN_CERTIFIED":true,"NOTARY_EXISTING_FILING":true,"ALLOW_REVOKE_OWN_ACCESS_ONLY":false,"HIDE_CANCEL_ON_ONETIME_DATA_REQUESTS":true,"DATA_REQUESTS_IN_SHOPPING_CART":true,"WQ_ALLOW_EDIT_PENDING_PAYMENT":true,"WQ_CONFIRM_ON_DELETE":true,"WQ_DELETE_CONFIRM_MESSAGE":"Deleting this filing will forfeit any money already paid to the Secretary of State. This action is permanent and cannot be undone, are you sure you would like to delete?","PASS_ITEM_GUIDS_ON_CHECKOUT":true,"FORM_REVISION_HISTORY":true,"CHECKOUT_DISCLAIMER":"By entering your credit card and/or checking account information you (i) state that **you are an authorized user** of the credit card and/or electronic check and that the associated information entered (e.g., account holder name, account number, billing address) is accurate, (ii) **you authorize payment processor to charge the amount you have requested** to your credit card and/or funding account, and (iii) **acknowledge if a charge is declined or reversed you may also be assessed a customary charge** by the payment processor for such transactions.","FARM_BILL_SEARCH_CONFIDENTIAL":"As a registered Farm Bill Buyer with the Montana Secretary of State’s office it is important to maintain the confidentiality of the information contained within the Farm Bill Master List. The Farm Bill Master List reflects personal data, such as Social Security Numbers, which are a key piece of personal identifiable information to assist you in determining the existence of a lien against a specific debtor. The distribution of this information beyond its intended purpose is strictly prohibited.\n\n**The debtor's tax identification number has been hidden for confidentiality reasons. You may continue to search on a tax ID number and return debtors that match your search criteria. The SSN/FEIN must be entered without dashes or spaces.  If you need access to the tax identification number to clearly identify the debtor, please contact the UCC unit at (406) 444-3665.**","VIEW_HISTORY_BUTTON_ALT_TEXT":"View Filings","WIZARD_ERROR_TITLE_MESSAGE":"Form Error","FARM_BILL_SEARCH_INTERACTIVE":true,"USE_FARM_BILL_API":true,"DISALLOW_ASSIGN_SELF_AS_RA":true,"DISALLOW_ASSIGN_SELF_AS_PRINCIPAL":true,"USE_TRADEMARK_OWNER_VALIDATION":true,"USE_ALTERNATIVE_FOREIGN_ADDRESS_LABELS":true,"MY_RECEIPTS_FILTER":[{"type":"dateRange","name":"DATE_RANGE","label":"Date range","defaultValue":{"start":null,"end":null}},{"type":"text","name":"REF_NUM","defaultValue":"","label":"Reference Number"},{"type":"text","name":"RECEIPT_NUM","defaultValue":"","label":"Receipt Id"},{"type":"text","name":"AMOUNT","defaultValue":"","label":"Amount"},{"type":"select","name":"TYPE","defaultValue":"","label":"Payment Type","options":[{"value":"","label":"All"},{"value":"CC","label":"Credit Card"},{"value":"Check","label":"Check"}]}],"MY_RECEIPTS_SHOW_IN_SIDEBAR":true,"SHOW_MY_RECEIPTS_HELPER_TEXT":true,"MY_RECEIPTS_HELPER_LABEL":"About Receipt Search","MY_RECEIPTS_HELPER_TEXT":"You can search for receipts based on their descriptions, including the items paid for on the receipt. Use the filters to search for or filter specific information.","FARM_BILL_SUBLINK":{"label":"Farm Bill","component":"FarmBill","parameter":"farm-bill","path":"/lists/farm-bill","sourceTypeId":0,"myRecordsSearch":false,"allowedRules":["/search/"],"disabled":true,"searchDescription":"To perform a search, enter a debtor name. Your search results may include: exact debtor name, variations of that name and any filing that includes your search criteria. Punctuation is ignored.\n\nYou can click on \"Advanced\" to refine your search. Under “Advanced” you can search by crop, year, county and SSN/FEIN. As a registered Farm Bill Buyer with the Montana Secretary of State’s office it is important to maintain the confidentiality of the information contained within the Farm Bill Master List. The Farm Bill Master List reflects personal data, such as Social Security Numbers, which are a key piece of personal identifiable information to assist you in determining the existence of a lien against a specific debtor. The distribution of this information beyond its intended purpose is strictly prohibited.\n\nThe debtor's tax identification number has been hidden for confidentiality reasons. You may continue to search on a tax ID number and return debtors that match your search criteria. The SSN/FEIN must be entered without dashes or spaces.","searchMustHaveOneOf":["search","UCC_FARM_PRODUCT_ID","COUNTY"],"searchPlaceholder":"Search by debtor name","advancedSearchParameters":[{"type":"ServerMultiComplete","label":"Product code name(s)","name":"UCC_FARM_PRODUCT_ID","defaultValue":"","optionsSrc":"UCC_FARM_PRODUCT_V"},{"type":"MultiComplete","label":"Year or Range of Years","name":"YEAR_NUM","optionsSrc":"years","startYear":"1968","defaultValue":[],"preMergeOptions":[{"value":"ALL","label":"All"}]},{"type":"serverSelect","label":"State","name":"STATE","defaultValue":"MONTANA","optionsSrc":"STATE"},{"type":"ServerMultiComplete","label":"County","name":"COUNTY","defaultValue":[],"optionsSrc":"COUNTY","overrideSubOptionsSrcFromParameterName":"STATE"},{"type":"checkbox","name":"TIN_SEARCH_YN","defaultValue":false,"label":"Tax Identification Number Search"},{"type":"checkbox","name":"TIN_SORT_YN","defaultValue":false,"label":"Unique ID Sort"}]},"ALLOW_ADDRESS_VALIDATION_BYPASS_OPTION":true,"DEFAULT_ADDRESS_VALIDATION_BYPASS_OPTION_CHECKED":true}).CERTIFICATE_VERIFICATION_DESCR || 'To verify a certificate, input the certificate ID found in the bottom left corner of your certificate.'
	            ),
	            this.state.certError && _react2.default.createElement(
	              'p',
	              { className: 'description danger-text' },
	              this.state.certError
	            ),
	            this.state.certificate && _react2.default.createElement(Certificate, { certificate: this.state.certificate, searchRoute: this.searchRoute })
	          )
	        })
	      );
	    }
	  }]);
	
	  return VerifyCertificate;
	}(_react2.default.Component);
	
	exports.default = VerifyCertificate;
	
	
	var Certificate = function Certificate(_ref2) {
	  var _ref2$certificate = _ref2.certificate,
	      CERTIFICATION_TYPE_DESCR = _ref2$certificate.CERTIFICATION_TYPE_DESCR,
	      COPIES_FILING_DESCR = _ref2$certificate.COPIES_FILING_DESCR,
	      FILING_NUM = _ref2$certificate.FILING_NUM,
	      FILING_DATE = _ref2$certificate.FILING_DATE,
	      DISPLAY_TYPE = _ref2$certificate.DISPLAY_TYPE,
	      _ref2$certificate$DET = _ref2$certificate.DETAIL_LIST,
	      DETAIL_LIST = _ref2$certificate$DET === undefined ? [] : _ref2$certificate$DET,
	      COMMENT = _ref2$certificate.COMMENT;
	  return _react2.default.createElement(
	    'div',
	    { className: 'certificate-success' },
	    _react2.default.createElement(
	      'p',
	      { className: 'description message' },
	      _react2.default.createElement(_shield2.default, null),
	      ' This certificate has been verified.'
	    ),
	    DISPLAY_TYPE === 'DETAIL_LIST' ? _react2.default.createElement(
	      'div',
	      null,
	      _react2.default.createElement(
	        'table',
	        { className: 'verify-certificate-table' },
	        _react2.default.createElement(
	          'tbody',
	          null,
	          DETAIL_LIST.map(function (detail, i) {
	            return _react2.default.createElement(
	              'tr',
	              { key: i },
	              _react2.default.createElement(
	                'td',
	                { className: 'label' },
	                _react2.default.createElement(
	                  'strong',
	                  null,
	                  detail.label,
	                  ':'
	                )
	              ),
	              _react2.default.createElement(
	                'td',
	                { className: 'value' },
	                detail.value
	              )
	            );
	          })
	        )
	      ),
	      _react2.default.createElement('br', null),
	      COMMENT && _react2.default.createElement(_Markdown2.default, { className: 'description', source: COMMENT })
	    ) : _react2.default.createElement(
	      _react2.default.Fragment,
	      null,
	      _react2.default.createElement(
	        'span',
	        { className: 'num' },
	        FILING_NUM,
	        ' - '
	      ),
	      _react2.default.createElement(
	        'span',
	        { className: 'date' },
	        (0, _format2.default)(new Date(FILING_DATE), 'MM/dd/yyyy')
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        CERTIFICATION_TYPE_DESCR
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        COPIES_FILING_DESCR
	      )
	    )
	  );
	};

/***/ },
/* 1059 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Portal = __webpack_require__(12);
	
	var _Portal2 = _interopRequireDefault(_Portal);
	
	var _SlidingPanel = __webpack_require__(101);
	
	var _SlidingPanel2 = _interopRequireDefault(_SlidingPanel);
	
	var _Checkout = __webpack_require__(67);
	
	var _Checkout2 = _interopRequireDefault(_Checkout);
	
	var _propTypes = __webpack_require__(20);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CheckoutSlider = function CheckoutSlider(_ref) {
	  var isOpen = _ref.isOpen,
	      onRequestClose = _ref.onRequestClose,
	      onCancel = _ref.onCancel,
	      onTransactionComplete = _ref.onTransactionComplete,
	      amendmentNum = _ref.amendmentNum,
	      formDefinitionId = _ref.formDefinitionId,
	      category = _ref.category,
	      correctionMode = _ref.correctionMode,
	      webCart = _ref.webCart,
	      skipCartQuantityUpdate = _ref.skipCartQuantityUpdate;
	
	  var slider = _react2.default.useRef();
	
	  var handleCancel = function handleCancel() {
	    slider.current.closeSlider(function () {
	      if (typeof onCancel === 'function') {
	        onCancel();
	      }
	      onRequestClose();
	    });
	  };
	
	  return _react2.default.createElement(
	    _Portal2.default,
	    { isOpened: isOpen },
	    _react2.default.createElement(
	      _SlidingPanel2.default,
	      {
	        closeOnShadeClick: false,
	        closeSlider: onRequestClose,
	        ref: slider,
	        ariaLabel: 'Checkout'
	      },
	      webCart && _react2.default.createElement(_Checkout2.default, {
	        cancelCheckout: handleCancel,
	        closeModal: onRequestClose,
	        redirectToReceipt: function redirectToReceipt(refNum) {
	          onTransactionComplete(function (callback) {
	            slider.current.closeSlider(callback);
	          }, refNum);
	        },
	        amendmentNum: amendmentNum,
	        formDefinitionId: formDefinitionId,
	        category: category,
	        correctionMode: correctionMode,
	        receiptItems: webCart.RECEIPT_ITEM_WEB_LIST,
	        receiptItemContainers: webCart.RECEIPT_ITEM_CONTAINER_WEB_LIST,
	        refNum: webCart.REF_NUM,
	        availableMethods: webCart.PAYMENT_METHOD_STATUS_LIST,
	        skipCartQuantityUpdate: skipCartQuantityUpdate
	      })
	    )
	  );
	};
	
	CheckoutSlider.propTypes = {
	  isOpen: _propTypes2.default.bool,
	  onRequestClose: _propTypes2.default.func.isRequired,
	  onCancel: _propTypes2.default.func,
	  onTransactionComplete: _propTypes2.default.func,
	  amendmentNum: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
	  formDefinitionId: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
	  category: _propTypes2.default.string,
	  correctionMode: _propTypes2.default.bool,
	  webCart: _propTypes2.default.object
	};
	
	exports.default = CheckoutSlider;

/***/ },
/* 1060 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _utilities = __webpack_require__(8);
	
	var _Shell = __webpack_require__(19);
	
	var _requests = __webpack_require__(6);
	
	var _PaymentCallback = __webpack_require__(119);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Error = function (_React$Component) {
	  _inherits(Error, _React$Component);
	
	  function Error() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, Error);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Error.__proto__ || Object.getPrototypeOf(Error)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      error: null,
	      errorCode: null,
	      errorMessage: null
	    }, _this.componentDidMount = function () {
	      var query = (0, _utilities.parseUrlQuery)(_this.props.location.search);
	      var method = _this.props.match.params.method;
	      _this.getErrorByMethod(method, query);
	    }, _this.getErrorByMethod = function (method, query) {
	      switch (method) {
	        case 'paypal':
	        default:
	          _this.getPaypalError();
	          _this.setState({ errorCode: query.RESULT, errorMessage: query.RESPMSG });
	      }
	    }, _this.getPaypalError = function () {
	      (0, _requests.GET_APP_SETTING_BY_NAME)("PAYMENT_ONLINE_ERROR_MESSAGE_POST_paypal", function (_ref2) {
	        var VALUE = _ref2.VALUE;
	
	        _this.setState({ error: VALUE });
	      });
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(Error, [{
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        _Shell.Body,
	        { className: 'login-redirector payment-callback' },
	        this.state.error && _react2.default.createElement(
	          _PaymentCallback.PaymentError,
	          { errorCode: this.state.errorCode, errorMessage: this.state.errorMessage },
	          this.state.error
	        )
	      );
	    }
	  }]);
	
	  return Error;
	}(_react2.default.Component);
	
	exports.default = Error;

/***/ },
/* 1061 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Field = __webpack_require__(25);
	
	var _Form = __webpack_require__(14);
	
	var _WizardClasses = __webpack_require__(35);
	
	var _AddressBlock = __webpack_require__(102);
	
	var _AddressBlock2 = _interopRequireDefault(_AddressBlock);
	
	var _validate = __webpack_require__(45);
	
	var _Checkout = __webpack_require__(67);
	
	var _visa_mastercard = __webpack_require__(1498);
	
	var _visa_mastercard2 = _interopRequireDefault(_visa_mastercard);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var ALLOW_NATIVE_CHECKOUT = ({"NODE_ENV":"production","BUILD_DATE":"2025-08-27T15:15:31.687Z","BUILD_NUMBER":"Not Provided","GIT_VERSION":"v1.3.0-381-ga81e29b08","GIT_COMMIT_HASH":"a81e29b085c9268ffd96c78eb734365802722741","GIT_BRANCH":"beta","PUBLIC_URL":"","STATE_ABBR":"MT","STATE_NAME":"Montana","STATE_ORG_TITLE":"Secretary of State","LOGIN_HEADER_IMG_PATH":"","HOME_IMG_FILENAME":"montana.jpg","FAVICON_FILE_NAME":"favicon.ico","ALLOW_E_SIGN_ON_CORRECTIONS":true,"THIRD_PARTY_SIGNING_ALLOWED":false,"MY_ACCOUNT_SAVE_AND_CLOSE_BUTTON":true,"IE_DEPRECATED_MESSAGE":"Internet Explorer is not supported. Please select a supported browser below to access this website.","ADDITIONAL_ROUTES":{"dataRequests":true,"farmBill":true,"apostille":true,"externalHelp":"https://sosmt.gov/business/help-center/","systemAdministration":[{"title":"Saved Payments","parameter":"saved-payments","componentName":"SavedPayments"}]},"SUBROUTES":[{"label":"Business","component":"Business","parameter":"business","myWorkQueueSearch":false,"sourceTypeId":54,"searchMustHaveOneOf":["FILING_TYPE_ID","STATUS_ID","STATE","search"],"serverWebSearchDescription":true,"serverWorkQueueDescription":true,"serverMyRecordsDescription":true,"searchPlaceholder":"Search by name or filing number (X########)","allowEmptySearchTerm":true,"requestCertificateAlternateLabel":"Request Information","fileAmendmentButtonLabel":"Filing Actions","advancedSearchParameters":[{"type":"radio","name":"QUERY_TYPE_ID","defaultValue":1010,"options":[{"value":1010,"label":"Starts with"},{"value":1011,"label":"Contains"},{"value":1012,"label":" Word Contains"}]},{"type":"serverSelect","name":"FILING_TYPE_ID","optionsSrc":"FILING_TYPES","label":"Entity Type","placeholder":"All","defaultValue":"0"},{"type":"serverSelect","name":"FILING_SUBTYPE_ID","optionsSrc":"FILING_SUBTYPES","label":"Entity Subtype","overrideSubOptionsSrcFromParameterName":"FILING_TYPE_ID","placeholder":"All","defaultValue":"0"},{"type":"serverSelect","name":"STATUS_ID","optionsSrc":"FILING_STATUS_WITHOUT_ALL","label":"Status","placeholder":"All","defaultValue":"0"},{"type":"serverSelect","name":"STATE","optionsSrc":"STATE","label":"State","placeholder":"All","defaultValue":""},{"type":"serverSelect","name":"COUNTY","optionsSrc":"COUNTY_SUBOPTION","label":"County","overrideSubOptionsSrcFromParameterName":"STATE","placeholder":"All","defaultValue":""},{"type":"checkbox","name":"CRA_SEARCH_YN","defaultValue":false,"label":"Search by Registered Agent PID"},{"type":"dateRange","name":"FILING_DATE","label":"Registration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}},{"type":"dateRange","name":"EXPIRATION_DATE","label":"Expiration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}}],"myRecordsFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Active"},{"value":2,"label":"Inactive"},{"value":3,"label":"Pending"}]},{"type":"dateRange","name":"DATE_RANGE","label":"Date range","defaultValue":{"start":null,"end":null}}],"myWorkQueueFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Approved"},{"value":2,"label":"Pending Online Payment"},{"value":3,"label":"Pending Review"},{"value":4,"label":"Needs Correction"},{"value":5,"label":"Rejected"},{"value":6,"label":"Draft"}]},{"type":"dateRange","name":"DATE_RANGE","label":"Date range","defaultValue":{"start":null,"end":null}}]},{"label":"Notary","component":"Notary","parameter":"notary","sourceTypeId":850,"myWorkQueueSearch":false,"allowEmptySearchTerm":true,"requestCertificateAlternateLabel":"Download Certificate","fileAmendmentButtonLabel":"Filing Actions","hideNameRequestCertificate":true,"hideAddressRequestCertificate":true,"hideRecordUserManagment":true,"searchPlaceholder":"Search by name or commission number","searchMustHaveOneOf":["CITY","search","SERVICE_TYPE"],"advancedParametersStartOpen":true,"searchIsSortable":true,"advancedSearchParameters":[{"type":"radio","name":"STARTS_WITH_YN","defaultValue":false,"options":[{"value":true,"label":"Starts with"},{"value":false,"label":"Contains"}]},{"type":"checkbox","name":"ACTIVE_ONLY_YN","defaultValue":true,"label":"Active entities only"},{"type":"text","name":"CITY","defaultValue":"","label":"City"},{"type":"select","name":"SERVICE_TYPE","label":"Special Services Offered","defaultValue":0,"options":[{"value":0,"label":"(N/A)"},{"value":6165,"label":"In-Person Electronic Notarization (IPEN)"},{"value":6166,"label":"Remote Online Notarization (RON)"},{"value":6167,"label":"Mobile Notary Services"},{"value":6168,"label":"Remote Ink Notarization (RIN)"}]}]},{"label":"Apostille","component":"Apostille","parameter":"apostille","sourceTypeId":720,"myRecordsSearch":false,"myWorkQueueSearch":false,"disabled":false,"allowedRoutes":["/forms-manager/","/queue/","/forms/"]},{"label":"Liens","component":"UCC","parameter":"ucc","sourceTypeId":1999,"myRecordsSearch":true,"myWorkQueueSearch":true,"fileAmendmentButtonLabel":"Filing Actions","searchPlaceholder":"Search by name or file number","disabled":false,"serverWebSearchDescription":true,"myRecordsDescription":"","workQueueDescription":"","searchDescription":"","hideRecordUserManagment":true,"searchLiensCheckout":false,"advancedSearchParameters":[{"type":"radio","name":"STARTS_WITH_YN","defaultValue":false,"options":[{"value":true,"label":"Starts with"},{"value":false,"label":"Contains"}]},{"type":"select","name":"STATUS","defaultValue":"ALL","label":"Status","options":[{"value":"ACTIVE_UNLAPSED","label":"Active (unlapsed)"},{"value":"ACTIVE_LAPSED_UNLAPSED","label":"Active (lapsed and unlapsed)"}]},{"type":"text","name":"EXCLUDE_VALUES","label":"Exclude Debtor Names (comma separated list of names to exclude)","defaultValue":""},{"type":"dateRange","name":"FILING_DATE","label":"Financing Statement Date","defaultValue":{"start":null,"end":null}},{"type":"dateRange","name":"LAPSE_DATE","label":"Lapse Date","defaultValue":{"start":null,"end":null}},{"type":"text","name":"CITY","label":"Debtor City","defaultValue":""}],"myRecordsFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Approved"},{"value":2,"label":"Pending Online Payment"},{"value":3,"label":"Pending Review"}]},{"type":"select","name":"TYPE","defaultValue":0,"label":"Lien Type","options":[{"value":0,"label":"All"},{"value":1,"label":"UCC"},{"value":2,"label":"EFS"},{"value":3,"label":"Title 71"}]}],"myWorkQueueFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Approved"},{"value":2,"label":"Pending Online Payment"},{"value":3,"label":"Pending Review"},{"value":4,"label":"Pending Print and Mail"},{"value":5,"label":"Rejected"},{"value":6,"label":"Draft"}]},{"type":"select","name":"TYPE","defaultValue":0,"label":"Lien Type","options":[{"value":0,"label":"All"},{"value":1,"label":"UCC"},{"value":2,"label":"EFS"},{"value":3,"label":"Title 71"}]}]},{"label":"Copy Request","component":"copies","parameter":"copies","sourceTypeId":2001,"myRecordsSearch":false,"myWorkQueueSearch":false,"disabled":false,"allowedRoutes":["/forms-manager/","/queue/","/forms/"]},{"label":"Trademark","component":"Trademark","parameter":"trademark","sourceTypeId":810,"showRequestCertificate":true,"searchMustHaveOneOf":["search","EXPIRATION_DATE","FILING_DATE"],"allowEmptySearchTerm":true,"requestCertificateAlternateLabel":"Request Information","fileAmendmentButtonLabel":"Filing Actions","advancedSearchParameters":[{"type":"radio","name":"QUERY_TYPE_ID","defaultValue":1010,"options":[{"value":1010,"label":"Starts with"},{"value":1011,"label":"Contains"},{"value":1012,"label":" Word Contains"}]},{"type":"checkbox","name":"OWNER_SEARCH_YN","defaultValue":false,"label":"Search owners"},{"type":"radio","name":"SERVICE_MARK_YN","label":"Mark Type","defaultValue":"","options":[{"value":"","label":"All Marks"},{"value":"Y","label":"Service Mark"},{"value":"N","label":"Trademark"}]},{"type":"serverSelect","name":"STATUS_ID","optionsSrc":"TYPE_V|TRADEMARK_STATUS_TYPE","label":"Status","placeholder":"All","defaultValue":"0"},{"type":"select","name":"DESIGN_TYPE_ID","options":[{"value":0,"label":"All"},{"value":990,"label":"Words Only"},{"value":991,"label":"Design Only"},{"value":992,"label":"Words and Design"}],"label":"Design Type","defaultValue":"0"},{"type":"dateRange","name":"FILING_DATE","label":"Registered Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}},{"type":"dateRange","name":"EXPIRATION_DATE","label":"Expiration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}}]},{"label":"Business Info Request","component":"InfoRequests","parameter":"info-request","sourceTypeId":167,"allowedRoutes":["/forms-manager/","/queue/","/forms/"]},{"label":"Data Requests","component":"DataRequests","parameter":"data-request","sourceTypeId":0,"allowedRoutes":["/forms-manager/"]},{"label":"CRA","component":"CRA","parameter":"cra","sourceTypeId":157,"myRecordsSearch":false,"searchPlaceholder":"Search by name or registered agent number","allowedRoutes":["/forms-manager/","/forms/","/records/","/queue/","/search/"],"allowEmptySearchTerm":true,"fileAmendmentButtonLabel":"Filing Actions","advancedSearchParameters":[{"type":"radio","name":"QUERY_TYPE_ID","defaultValue":1010,"options":[{"value":1010,"label":"Starts with"},{"value":1011,"label":"Contains"},{"value":1012,"label":" Word Contains"}]},{"type":"dateRange","name":"CRA_DATE","label":"Registration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}},{"type":"select","name":"STATUS_ID","label":"Status","defaultValue":0,"options":[{"value":0,"label":"All"},{"value":121,"label":"Active"},{"value":122,"label":"Inactive"}]},{"type":"select","name":"AGENT_TYPE_ID","label":"Agent Type","defaultValue":0,"options":[{"value":0,"label":"All"},{"value":460,"label":"Registered Agent"},{"value":461,"label":"Commercial Registered Agent"}]}]},{"label":"Farm Bill","component":"FarmBill","parameter":"farm-bill","path":"/lists/farm-bill","sourceTypeId":0,"myRecordsSearch":false,"allowedRules":["/search/"],"disabled":true,"searchDescription":"To perform a search, enter a debtor name. Your search results may include: exact debtor name, variations of that name and any filing that includes your search criteria. Punctuation is ignored.\n\nYou can click on \"Advanced\" to refine your search. Under “Advanced” you can search by crop, year, county and SSN/FEIN. As a registered Farm Bill Buyer with the Montana Secretary of State’s office it is important to maintain the confidentiality of the information contained within the Farm Bill Master List. The Farm Bill Master List reflects personal data, such as Social Security Numbers, which are a key piece of personal identifiable information to assist you in determining the existence of a lien against a specific debtor. The distribution of this information beyond its intended purpose is strictly prohibited.\n\nThe debtor's tax identification number has been hidden for confidentiality reasons. You may continue to search on a tax ID number and return debtors that match your search criteria. The SSN/FEIN must be entered without dashes or spaces.","searchMustHaveOneOf":["search","UCC_FARM_PRODUCT_ID","COUNTY"],"searchPlaceholder":"Search by debtor name","advancedSearchParameters":[{"type":"ServerMultiComplete","label":"Product code name(s)","name":"UCC_FARM_PRODUCT_ID","defaultValue":"","optionsSrc":"UCC_FARM_PRODUCT_V"},{"type":"MultiComplete","label":"Year or Range of Years","name":"YEAR_NUM","optionsSrc":"years","startYear":"1968","defaultValue":[],"preMergeOptions":[{"value":"ALL","label":"All"}]},{"type":"serverSelect","label":"State","name":"STATE","defaultValue":"MONTANA","optionsSrc":"STATE"},{"type":"ServerMultiComplete","label":"County","name":"COUNTY","defaultValue":[],"optionsSrc":"COUNTY","overrideSubOptionsSrcFromParameterName":"STATE"},{"type":"checkbox","name":"TIN_SEARCH_YN","defaultValue":false,"label":"Tax Identification Number Search"},{"type":"checkbox","name":"TIN_SORT_YN","defaultValue":false,"label":"Unique ID Sort"}]}],"SYSTEM_NICKNAME":"Online Services Portal","PAYMENT_METHODS":[{"type":"bypass"},{"type":"iTransact"}],"PAYMENT_ALLOW_AMEX":true,"SYSTEM_ID_LABEL":"System Id","DOUBLE_COLUMN_PUBLIC_LOGIN":true,"INTERNAL_USER_MANAGEMENT":true,"ALLOW_PUBLIC_JSON_IMPORT":false,"MAX_FILE_UPLOAD_SIZE":10000000,"REFUND_TEXT":"","RETURN_TO_HOME_ON_LOGOUT":true,"CURRENT_SOS_NAME":"Christi Jacobsen","LOGO_FILENAME":"mt-sos-logo.png","LOGO_ALT":"Christi Jacobsen, Montana Secretary of State","LOGO_FULL_WIDTH":true,"HOME_HIDE_AUTH_HINT":true,"HOME_TITLE":"Montana Secretary of State","CUSTOM_TAB_TITLE":"Official Montana","HOME_SUBTITLE":"Online Business Services","ENTITY_NAME_CONSENT_DESCRIPTION":"","ALLOW_USER_PROFILE_EDITING":true,"COMPARE_FOREIGN_NAME_IN_ENTITY_NAME_VALIDATION":true,"FOREIGN_NAME_FIELD_NAME":"KIMA_PARENT_NAME_INFO","LOGIN_TITLE":"Montana Secretary of State Online Filing Portal Login","PUBLIC_LOGIN_LABEL":"Username","REVERSE_LOGIN_COLUMNS":true,"LOGIN_SEAL_FILENAME":"seal_white.png","SEPARATE_USERNAME_AND_EMAIL":true,"CREATE_ACCOUNT_BUTTON_ALIGN_LEFT":true,"CREATE_ACCOUNT_BUTTON_TEXT":"CREATE AN ACCOUNT","PASSWORD_CUSTOM_ERROR_TEXT":"The password must meet all requirements","ACCOUNT_CREATED_MESSAGE":"Please check your email to verify your account to login and allow a few minutes for this message to arrive. Check your junk/spam folders if you do not find the email in your inbox.","PUBLIC_LOGIN_PLACEHOLDER":" ","DISABLE_DEFAULT_PAYMENT_RADIO":true,"CUSTOM_RESET_PASSWORD_ERROR_MESSAGE":"Username invalid - no account found","PUBLIC_LOGIN_CREATE_DESCRIPTION":"### Existing User:\n\n  - Enter your username and password to login.  \n\n\n  #### - OR -  \n\n\n\n  - Forgot password? Click 'Reset Password' and follow the prompts.\n  - Forgot username? Click 'Forgot Username' and follow the prompts.  \n\n\n  ### New User:\n  ","LOGIN_HELP_LINK":"https://sosmt.gov/business/how-do-i/","LOGIN_HELP_LINK_TEXT":"Need Help?","FORGOT_USERNAME_TEXT":"Forgot Username?","LOGIN_ACTIVE_DIRECTORY_TEXT":"State User Login","MULTIPLE_LOGIN_METHODS":true,"HAS_ACTIVE_DIRECTORY_LOGIN":true,"RESET_PASSWORD_WITH_USERNAME":true,"DOWNLOAD_LINK":true,"SHOW_USERNAME_ACCOUNT_CREATE":true,"SHOW_SCROLL_DOWN_ARROW":true,"SHOW_ADDRESS_ACCOUNT_CREATE":true,"TWO_COLUMN_ACCOUNT_CREATE":true,"RESET_PASSWORD_TIP":"A link to change your password has been sent to your email. Please allow a few minutes for this message to arrive. Please check your junk/spam folders if you do not find the email in your inbox.","FORGOT_PASSWORD_LINK_TEXT":"Reset Password","PHONE_NUMBER_OPTIONAL_ACCOUNT_CREATE":true,"SHOW_REQUIRED_INDICATOR_ACCOUNT_CREATE":true,"PASSWORD_REQUIREMENTS_ACCOUNT_CREATE":"\n    <ul>\n      <li>MUST contain at least 8 characters (12+ recommended)</li>\n      <li>MUST contain at least one uppercase letter.</li>\n      <li>MUST contain at least one lowercase letter.</li>\n      <li>MUST contain at least one number.</li>\n      <li>MUST contain at least one special character (!”#$%&'()*+,-./:;<=>?</li>\n    </ul>\n  ","ALLOW_CERTIFICATION_REQUEST":true,"ALLOW_PUBLIC_CERTIFICATE_REQUEST":true,"ALLOW_COPY_REQUEST":false,"ALLOW_CORRECTION_STYLING":true,"HIDE_DEPRECATION_WARNING":false,"AMEND_ROUTE_PUBLIC":true,"SEAL_FILENAME":"seal.png","SHOPPING_CART":true,"ALLOW_PAYMENT_UPDATE_WITH_EMPTY_CART":true,"RA_EMAIL":true,"RA_WEBSITE":true,"RA_NO_DEFAULT_TYPE":true,"RA_ADDRESS_LABEL":"Street Address","RA_TYPE_SELECTION_DEFAULT":true,"RA_DEFAULT_TYPE":"460","RA_OVERRIDE_TYPE_WITH_DEFAULT":true,"RA_PRINCIPAL_ADDRESS_AMS":true,"UPLOAD_AND_SUBMIT_HIDE_IF_ONE_OPTION":true,"PAYMENT_PROCESSING_MESSAGE":"Your payment is processing - Do not close your browser or click the back button","CHECKOUT_BUTTON_WHEN_PROCESSING_TEXT":"Processing","EFS_CROP_PICKER_NONE_LABEL":"Lien Duration","DISALLOWED_WIZARD_PIECES":["FormationLocale"],"REPEATER_SHOW_EDIT_BUTTON":true,"DATA_REQUEST_PAGE_TITLE":"Data Requests and Subscriptions","DATA_REQUEST_SIDEBAR_LABEL":"Data Requests & Subscriptions","LOGIN_REDIRECTS_TO_EPASS":false,"LOGIN_REDIRECTS_TO_ACTIVE_DIRECTORY":true,"LOGIN_ACTIVE_DIRECTORY_LINK":true,"FETCH_EDIT_USER_LINK":false,"LISTS_FETCH_AVAILABLE_LISTS":true,"POST_WIZARD_SUBMIT_REDIRECT_URL":"/","PIN_REQUEST_ATTESTATIONS":true,"PIN_REQUEST_DESCRIPTION":"Click **Request PIN** to have a new PIN sent to the account holder's email address on file.","OWNERSHIP_REQUEST_DESCRIPTION":"To become an **authorized user** of this record, a current **AUTHORIZED USER** will need to grant you access. To request access, click **Request Access** below.","PIN_REQUEST_SUCCESS_MESSAGE":"The PIN you have requested for this entity has been sent to the email associated with your user account.  You should receive the PIN in approximately 3-5 minutes, depending on your email service provider.","APOSTILLE_HEADER_LABEL":"Verification Information","APOSTILLE_NUMBER_LABEL":"Apostille/Authentication","APOSTILLE_CITY_STATE_OVERRIDE":"HELENA, MT","APOSTILLE_FILING_DATE_LABEL":"Issue Date","APOSTILLE_CITY_STATE_IN_CERTIFIED":true,"NOTARY_EXISTING_FILING":true,"ALLOW_REVOKE_OWN_ACCESS_ONLY":false,"HIDE_CANCEL_ON_ONETIME_DATA_REQUESTS":true,"DATA_REQUESTS_IN_SHOPPING_CART":true,"WQ_ALLOW_EDIT_PENDING_PAYMENT":true,"WQ_CONFIRM_ON_DELETE":true,"WQ_DELETE_CONFIRM_MESSAGE":"Deleting this filing will forfeit any money already paid to the Secretary of State. This action is permanent and cannot be undone, are you sure you would like to delete?","PASS_ITEM_GUIDS_ON_CHECKOUT":true,"FORM_REVISION_HISTORY":true,"CHECKOUT_DISCLAIMER":"By entering your credit card and/or checking account information you (i) state that **you are an authorized user** of the credit card and/or electronic check and that the associated information entered (e.g., account holder name, account number, billing address) is accurate, (ii) **you authorize payment processor to charge the amount you have requested** to your credit card and/or funding account, and (iii) **acknowledge if a charge is declined or reversed you may also be assessed a customary charge** by the payment processor for such transactions.","FARM_BILL_SEARCH_CONFIDENTIAL":"As a registered Farm Bill Buyer with the Montana Secretary of State’s office it is important to maintain the confidentiality of the information contained within the Farm Bill Master List. The Farm Bill Master List reflects personal data, such as Social Security Numbers, which are a key piece of personal identifiable information to assist you in determining the existence of a lien against a specific debtor. The distribution of this information beyond its intended purpose is strictly prohibited.\n\n**The debtor's tax identification number has been hidden for confidentiality reasons. You may continue to search on a tax ID number and return debtors that match your search criteria. The SSN/FEIN must be entered without dashes or spaces.  If you need access to the tax identification number to clearly identify the debtor, please contact the UCC unit at (406) 444-3665.**","VIEW_HISTORY_BUTTON_ALT_TEXT":"View Filings","WIZARD_ERROR_TITLE_MESSAGE":"Form Error","FARM_BILL_SEARCH_INTERACTIVE":true,"USE_FARM_BILL_API":true,"DISALLOW_ASSIGN_SELF_AS_RA":true,"DISALLOW_ASSIGN_SELF_AS_PRINCIPAL":true,"USE_TRADEMARK_OWNER_VALIDATION":true,"USE_ALTERNATIVE_FOREIGN_ADDRESS_LABELS":true,"MY_RECEIPTS_FILTER":[{"type":"dateRange","name":"DATE_RANGE","label":"Date range","defaultValue":{"start":null,"end":null}},{"type":"text","name":"REF_NUM","defaultValue":"","label":"Reference Number"},{"type":"text","name":"RECEIPT_NUM","defaultValue":"","label":"Receipt Id"},{"type":"text","name":"AMOUNT","defaultValue":"","label":"Amount"},{"type":"select","name":"TYPE","defaultValue":"","label":"Payment Type","options":[{"value":"","label":"All"},{"value":"CC","label":"Credit Card"},{"value":"Check","label":"Check"}]}],"MY_RECEIPTS_SHOW_IN_SIDEBAR":true,"SHOW_MY_RECEIPTS_HELPER_TEXT":true,"MY_RECEIPTS_HELPER_LABEL":"About Receipt Search","MY_RECEIPTS_HELPER_TEXT":"You can search for receipts based on their descriptions, including the items paid for on the receipt. Use the filters to search for or filter specific information.","FARM_BILL_SUBLINK":{"label":"Farm Bill","component":"FarmBill","parameter":"farm-bill","path":"/lists/farm-bill","sourceTypeId":0,"myRecordsSearch":false,"allowedRules":["/search/"],"disabled":true,"searchDescription":"To perform a search, enter a debtor name. Your search results may include: exact debtor name, variations of that name and any filing that includes your search criteria. Punctuation is ignored.\n\nYou can click on \"Advanced\" to refine your search. Under “Advanced” you can search by crop, year, county and SSN/FEIN. As a registered Farm Bill Buyer with the Montana Secretary of State’s office it is important to maintain the confidentiality of the information contained within the Farm Bill Master List. The Farm Bill Master List reflects personal data, such as Social Security Numbers, which are a key piece of personal identifiable information to assist you in determining the existence of a lien against a specific debtor. The distribution of this information beyond its intended purpose is strictly prohibited.\n\nThe debtor's tax identification number has been hidden for confidentiality reasons. You may continue to search on a tax ID number and return debtors that match your search criteria. The SSN/FEIN must be entered without dashes or spaces.","searchMustHaveOneOf":["search","UCC_FARM_PRODUCT_ID","COUNTY"],"searchPlaceholder":"Search by debtor name","advancedSearchParameters":[{"type":"ServerMultiComplete","label":"Product code name(s)","name":"UCC_FARM_PRODUCT_ID","defaultValue":"","optionsSrc":"UCC_FARM_PRODUCT_V"},{"type":"MultiComplete","label":"Year or Range of Years","name":"YEAR_NUM","optionsSrc":"years","startYear":"1968","defaultValue":[],"preMergeOptions":[{"value":"ALL","label":"All"}]},{"type":"serverSelect","label":"State","name":"STATE","defaultValue":"MONTANA","optionsSrc":"STATE"},{"type":"ServerMultiComplete","label":"County","name":"COUNTY","defaultValue":[],"optionsSrc":"COUNTY","overrideSubOptionsSrcFromParameterName":"STATE"},{"type":"checkbox","name":"TIN_SEARCH_YN","defaultValue":false,"label":"Tax Identification Number Search"},{"type":"checkbox","name":"TIN_SORT_YN","defaultValue":false,"label":"Unique ID Sort"}]},"ALLOW_ADDRESS_VALIDATION_BYPASS_OPTION":true,"DEFAULT_ADDRESS_VALIDATION_BYPASS_OPTION_CHECKED":true}).ALLOW_NATIVE_CHECKOUT;
	var PAYMENT_ALLOW_AMEX = (true);
	
	var initialValues = {
	  FIRST_NAME: '',
	  LAST_NAME: '',
	  COMPANY: '',
	  PHONE_NUMBER: '',
	  PHONE_EXTENSION: '',
	  CC_NUMBER: '',
	  CC_EXPIRATION: '',
	  CC_CVV: '',
	  BILLING_ADDRESS: new _WizardClasses.AddressBlock({}).value
	};
	
	exports.default = function (_ref) {
	  var children = _ref.children,
	      active = _ref.active,
	      disabled = _ref.disabled,
	      error = _ref.error,
	      processing = _ref.processing,
	      onDeactivateRequested = _ref.onDeactivateRequested,
	      onSubmit = _ref.onSubmit;
	
	  var _React$useReducer = _react2.default.useReducer(function (state, action) {
	    switch (action.type) {
	      case 'SET_VALUE':
	        return Object.assign({}, state, _defineProperty({}, action.name, action.value));
	      default:
	        return state;
	    }
	  }, initialValues),
	      _React$useReducer2 = _slicedToArray(_React$useReducer, 2),
	      values = _React$useReducer2[0],
	      dispatchValues = _React$useReducer2[1];
	
	  var _React$useState = _react2.default.useState({}),
	      _React$useState2 = _slicedToArray(_React$useState, 2),
	      errors = _React$useState2[0],
	      setErrors = _React$useState2[1];
	
	  var wrapperRef = _react2.default.useRef();
	  var firstNameRef = _react2.default.useRef();
	  var shouldFocusFirst = _react2.default.useRef(false);
	
	  var setValue = function setValue(value, e) {
	    return dispatchValues({ type: 'SET_VALUE', name: (typeof e === 'undefined' ? 'undefined' : _typeof(e)) === 'object' ? e.target.name : e, value: value });
	  };
	
	  var validateAndSubmit = function validateAndSubmit() {
	    getEntryIsValid(values).then(function (allValid) {
	      if (allValid) {
	        onSubmit(values);
	      }
	    });
	  };
	
	  var getEntryIsValid = function getEntryIsValid(values) {
	    return new Promise(function (resolve, reject) {
	      setErrors({});
	      var errors = {};
	
	      var setError = function setError(name, message) {
	        if (!errors[name]) {
	          errors[name] = [message];
	        }
	      };['FIRST_NAME', 'LAST_NAME', 'PHONE_NUMBER', 'CC_NUMBER', 'CC_EXPIRATION', 'CC_CVV'].forEach(function (v) {
	        if (!values[v]) setError(v, 'This field is required.');
	      });
	
	      if (values.CC_NUMBER.length < 13) {
	        setError('CC_NUMBER', 'Credit card number must be at least 13 numbers.');
	      }
	
	      var month = parseInt(values.CC_EXPIRATION.slice(0, 2), 10);
	      var year = parseInt(values.CC_EXPIRATION.slice(2, 4), 10);
	      if (values.CC_EXPIRATION.length !== 4 && month <= 12 && month > 0 && year > 0) {
	        setError('CC_EXPIRATION', 'Please provide an expiration in the format MM/YY');
	      }
	
	      var promises = [new Promise(function (res, rej) {
	        return _validate.VALIDATE.addressIsRequired(values.BILLING_ADDRESS, {}, {}, function (isValid, errorMessage) {
	          res({
	            isValid: isValid,
	            errorMessage: errorMessage,
	            name: 'BILLING_ADDRESS'
	          });
	        });
	      }), new Promise(function (res, rej) {
	        return _validate.VALIDATE.validPhoneNumber(values.PHONE_NUMBER, {}, { errorMessage: 'Enter a valid phone number.' }, function (isValid, errorMessage) {
	          res({
	            isValid: isValid,
	            errorMessage: errorMessage,
	            name: 'PHONE_NUMBER'
	          });
	        });
	      })];
	
	      Promise.all(promises).then(function (results) {
	        results.forEach(function (result) {
	          if (!result.isValid) {
	            setError(result.name, result.errorMessage);
	          }
	        });
	        setErrors(errors);
	        resolve(Object.keys(errors).length === 0);
	      });
	    });
	  };
	
	  var getMaskedExpiration = function getMaskedExpiration(value) {
	    return value.slice(0, 4).replace(/(?:([0-9]{2})([0-9{1}])|([0-9]{2})([0-9]{2}))/, '$1/$2');
	  };
	
	  var calculatedDisabled = !active || disabled;
	
	  _react2.default.useEffect(function () {
	    if (error) {
	      document.getElementById('sliding-panel-scrollable').scrollTop = wrapperRef.current.offsetHeight;
	    }
	  }, [error]);
	
	  _react2.default.useEffect(function () {
	    if (active) {
	      shouldFocusFirst.current = true;
	    } else {
	      shouldFocusFirst.current = false;
	    }
	  }, [active]);
	
	  var focusFirstField = function focusFirstField() {
	    if (shouldFocusFirst.current) {
	      firstNameRef.current.focus();
	      shouldFocusFirst.current = false;
	    }
	  };
	
	  return _react2.default.createElement(
	    'div',
	    { className: 'checkout-body native-checkout' },
	    _react2.default.createElement(
	      'div',
	      {
	        className: 'checkout-body-inner-wrapper',
	        style: { transform: 'translateX(' + (active ? -50 : 0) + '%)' },
	        ref: wrapperRef,
	        onTransitionEnd: focusFirstField
	      },
	      _react2.default.createElement(
	        'fieldset',
	        { className: 'main-wrapper', disabled: active, 'aria-hidden': active },
	        children
	      ),
	      ALLOW_NATIVE_CHECKOUT && _react2.default.createElement(
	        'fieldset',
	        {
	          className: 'secondary-wrapper wizard',
	          disabled: calculatedDisabled,
	          'aria-hidden': !active
	        },
	        _react2.default.createElement(
	          'div',
	          { style: { marginBottom: 10 } },
	          _react2.default.createElement(
	            'button',
	            {
	              onClick: onDeactivateRequested,
	              disabled: calculatedDisabled,
	              className: 'return-button'
	            },
	            '<',
	            ' Choose a different payment method'
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'flex-row' },
	          _react2.default.createElement(
	            _Field.DumbField,
	            {
	              fieldId: 'co-first-name',
	              label: 'First Name',
	              required: true,
	              errorMessage: errors.FIRST_NAME
	            },
	            _react2.default.createElement(_Form.TextInput, {
	              fieldId: 'co-first-name',
	              value: values.FIRST_NAME,
	              name: 'FIRST_NAME',
	              onChange: setValue,
	              ariaLabel: 'First Name',
	              disabled: calculatedDisabled,
	              ref: firstNameRef
	            })
	          ),
	          _react2.default.createElement(
	            _Field.DumbField,
	            {
	              fieldId: 'co-last-name',
	              label: 'Last Name',
	              required: true,
	              errorMessage: errors.LAST_NAME
	            },
	            _react2.default.createElement(_Form.TextInput, {
	              fieldId: 'co-last-name',
	              value: values.LAST_NAME,
	              name: 'LAST_NAME',
	              onChange: setValue,
	              ariaLabel: 'Last Name',
	              disabled: calculatedDisabled
	            })
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'flex-row' },
	          _react2.default.createElement(
	            _Field.DumbField,
	            { fieldId: 'co-company', label: 'Company' },
	            _react2.default.createElement(_Form.TextInput, {
	              fieldId: 'co-company',
	              value: values.COMPANY,
	              name: 'COMPANY',
	              onChange: setValue,
	              ariaLabel: 'Company',
	              width: '100%',
	              disabled: calculatedDisabled
	            })
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'flex-row' },
	          _react2.default.createElement(
	            _Field.DumbField,
	            {
	              fieldId: 'co-cc-number',
	              label: 'Credit Card Number',
	              required: true,
	              errorMessage: errors.CC_NUMBER
	            },
	            _react2.default.createElement(_Form.TextInput, {
	              fieldId: 'co-cc-number',
	              value: values.CC_NUMBER,
	              name: 'CC_NUMBER',
	              onChange: function onChange(value, e) {
	                return setValue(_validate.MASK.onlyNumbers(value), e.target.name);
	              },
	              maxLength: 16,
	              ariaLabel: 'Credit Card Number',
	              width: '100%',
	              disabled: calculatedDisabled
	            })
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'flex-row exp-row' },
	          _react2.default.createElement(
	            _Field.DumbField,
	            { fieldId: 'co-cc-exp', label: 'Expiration', required: true },
	            _react2.default.createElement(_Form.TextInput, {
	              fieldId: 'co-cc-exp',
	              value: getMaskedExpiration(values.CC_EXPIRATION),
	              name: 'CC_EXPIRATION',
	              placeholder: 'MM/YY',
	              onChange: function onChange(value, e) {
	                return setValue(_validate.MASK.onlyNumbers(value).slice(0, 4), e.target.name);
	              },
	              ariaLabel: 'Credit Card Expiration Date',
	              disabled: calculatedDisabled,
	              disableSelectionRestoration: true
	            })
	          ),
	          _react2.default.createElement(
	            _Field.DumbField,
	            { fieldId: 'co-cc-cvv', label: 'CVV', required: true },
	            _react2.default.createElement(_Form.TextInput, {
	              fieldId: 'co-cc-cvv',
	              value: values.CC_CVV,
	              name: 'CC_CVV',
	              onChange: function onChange(value, e) {
	                return setValue(_validate.MASK.onlyNumbers(value), e.target.name);
	              },
	              ariaLabel: 'Credit Card CVV',
	              maxLength: PAYMENT_ALLOW_AMEX ? 4 : 3,
	              disabled: calculatedDisabled
	            })
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'flex-column' },
	          _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(
	              'p',
	              {
	                className: 'field-error',
	                'aria-live': 'polite',
	                style: { display: !errors.CC_EXPIRATION ? 'none' : '' }
	              },
	              errors.CC_EXPIRATION
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(
	              'p',
	              {
	                className: 'field-error',
	                'aria-live': 'polite',
	                style: { display: !errors.CC_CVV ? 'none' : '' }
	              },
	              errors.CC_CVV
	            )
	          )
	        ),
	        _react2.default.createElement('div', { className: 'separator', style: { marginTop: 10, marginBottom: 0 } }),
	        _react2.default.createElement(
	          'div',
	          { className: 'flex-row', style: { marginTop: 15 } },
	          _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement('img', { className: 'card-icons', alt: 'Visa & Mastercard accepted', src: _visa_mastercard2.default })
	          ),
	          _react2.default.createElement(
	            'p',
	            { className: 'credit-card-description' },
	            'We accept Visa and Mastercard'
	          )
	        ),
	        _react2.default.createElement('div', { className: 'separator', style: { marginTop: 10, marginBottom: -5 } }),
	        _react2.default.createElement(
	          _Field.DumbField,
	          { errorMessage: errors.BILLING_ADDRESS },
	          _react2.default.createElement(_AddressBlock2.default, {
	            required: true,
	            value: values.BILLING_ADDRESS,
	            name: 'BILLING_ADDRESS',
	            onChange: function onChange(value) {
	              return setValue(value, 'BILLING_ADDRESS');
	            },
	            allowSelection: false,
	            showCityStateZip: true,
	            singleColSize: 'col-12',
	            triColSizes: { CITY: 'col-12 no-padding', STATE: 'col-4', ZIP: 'col-8' },
	            address1Label: 'Billing Address',
	            disabled: calculatedDisabled,
	            showAddress3: false,
	            classNames: {
	              STATE: 'state-select'
	            }
	          })
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'flex-row phone-row' },
	          _react2.default.createElement(
	            _Field.DumbField,
	            {
	              fieldId: 'co-phone',
	              label: 'Phone Number',
	              required: true,
	              errorMessage: errors.PHONE_NUMBER
	            },
	            _react2.default.createElement(_Form.TextInput, {
	              fieldId: 'co-phone',
	              value: _validate.MASK.phone(values.PHONE_NUMBER),
	              name: 'PHONE_NUMBER',
	              onChange: function onChange(value, e) {
	                return setValue(_validate.MASK.phone(value), e.target.name);
	              },
	              ariaLabel: 'Phone Number',
	              maxLength: 30,
	              width: '100%',
	              disabled: calculatedDisabled,
	              disableSelectionRestoration: true
	            })
	          ),
	          _react2.default.createElement(
	            _Field.DumbField,
	            { fieldId: 'co-extension', label: 'Extension' },
	            _react2.default.createElement(_Form.TextInput, {
	              fieldId: 'co-extension',
	              value: values.PHONE_EXTENSION,
	              name: 'PHONE_EXTENSION',
	              onChange: function onChange(value, e) {
	                return setValue(_validate.MASK.onlyNumbers(value), e.target.name);
	              },
	              ariaLabel: 'Phone Extension',
	              maxLength: 10,
	              autocomplete: 'tel-extension',
	              width: '100%',
	              disabled: calculatedDisabled
	            })
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { style: { marginTop: 15 } },
	          _react2.default.createElement(
	            _Checkout.PaymentButton,
	            {
	              bypassLoadingStyles: true,
	              disabled: calculatedDisabled,
	              loading: processing,
	              onClick: validateAndSubmit
	            },
	            'Submit Payment'
	          )
	        ),
	        _react2.default.createElement(
	          'p',
	          {
	            className: 'method-error native-method-error',
	            style: { display: !error ? 'none' : '', marginTop: 15 },
	            'aria-live': 'assertive'
	          },
	          error
	        )
	      )
	    )
	  );
	};
	
	// const CreditCard = () => (
	//   <div className="credit-card">
	//     <div className="flex-row">
	//
	//     </div>
	//   </div>
	// )

/***/ },
/* 1062 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Receipt = exports.ReceiptModal = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Shell = __webpack_require__(19);
	
	var _utilities = __webpack_require__(8);
	
	var _Modal = __webpack_require__(13);
	
	var _Portal = __webpack_require__(12);
	
	var _Portal2 = _interopRequireDefault(_Portal);
	
	var _downloadBox = __webpack_require__(219);
	
	var _downloadBox2 = _interopRequireDefault(_downloadBox);
	
	var _ReportsList = __webpack_require__(300);
	
	var _Markdown = __webpack_require__(24);
	
	var _Markdown2 = _interopRequireDefault(_Markdown);
	
	var _requests = __webpack_require__(6);
	
	var _actions = __webpack_require__(29);
	
	var _reactRedux = __webpack_require__(7);
	
	__webpack_require__(1435);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var RECEIPT_PAGE_DOWNLOADS_HEADER = ({"NODE_ENV":"production","BUILD_DATE":"2025-08-27T15:15:31.687Z","BUILD_NUMBER":"Not Provided","GIT_VERSION":"v1.3.0-381-ga81e29b08","GIT_COMMIT_HASH":"a81e29b085c9268ffd96c78eb734365802722741","GIT_BRANCH":"beta","PUBLIC_URL":"","STATE_ABBR":"MT","STATE_NAME":"Montana","STATE_ORG_TITLE":"Secretary of State","LOGIN_HEADER_IMG_PATH":"","HOME_IMG_FILENAME":"montana.jpg","FAVICON_FILE_NAME":"favicon.ico","ALLOW_E_SIGN_ON_CORRECTIONS":true,"THIRD_PARTY_SIGNING_ALLOWED":false,"MY_ACCOUNT_SAVE_AND_CLOSE_BUTTON":true,"IE_DEPRECATED_MESSAGE":"Internet Explorer is not supported. Please select a supported browser below to access this website.","ADDITIONAL_ROUTES":{"dataRequests":true,"farmBill":true,"apostille":true,"externalHelp":"https://sosmt.gov/business/help-center/","systemAdministration":[{"title":"Saved Payments","parameter":"saved-payments","componentName":"SavedPayments"}]},"SUBROUTES":[{"label":"Business","component":"Business","parameter":"business","myWorkQueueSearch":false,"sourceTypeId":54,"searchMustHaveOneOf":["FILING_TYPE_ID","STATUS_ID","STATE","search"],"serverWebSearchDescription":true,"serverWorkQueueDescription":true,"serverMyRecordsDescription":true,"searchPlaceholder":"Search by name or filing number (X########)","allowEmptySearchTerm":true,"requestCertificateAlternateLabel":"Request Information","fileAmendmentButtonLabel":"Filing Actions","advancedSearchParameters":[{"type":"radio","name":"QUERY_TYPE_ID","defaultValue":1010,"options":[{"value":1010,"label":"Starts with"},{"value":1011,"label":"Contains"},{"value":1012,"label":" Word Contains"}]},{"type":"serverSelect","name":"FILING_TYPE_ID","optionsSrc":"FILING_TYPES","label":"Entity Type","placeholder":"All","defaultValue":"0"},{"type":"serverSelect","name":"FILING_SUBTYPE_ID","optionsSrc":"FILING_SUBTYPES","label":"Entity Subtype","overrideSubOptionsSrcFromParameterName":"FILING_TYPE_ID","placeholder":"All","defaultValue":"0"},{"type":"serverSelect","name":"STATUS_ID","optionsSrc":"FILING_STATUS_WITHOUT_ALL","label":"Status","placeholder":"All","defaultValue":"0"},{"type":"serverSelect","name":"STATE","optionsSrc":"STATE","label":"State","placeholder":"All","defaultValue":""},{"type":"serverSelect","name":"COUNTY","optionsSrc":"COUNTY_SUBOPTION","label":"County","overrideSubOptionsSrcFromParameterName":"STATE","placeholder":"All","defaultValue":""},{"type":"checkbox","name":"CRA_SEARCH_YN","defaultValue":false,"label":"Search by Registered Agent PID"},{"type":"dateRange","name":"FILING_DATE","label":"Registration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}},{"type":"dateRange","name":"EXPIRATION_DATE","label":"Expiration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}}],"myRecordsFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Active"},{"value":2,"label":"Inactive"},{"value":3,"label":"Pending"}]},{"type":"dateRange","name":"DATE_RANGE","label":"Date range","defaultValue":{"start":null,"end":null}}],"myWorkQueueFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Approved"},{"value":2,"label":"Pending Online Payment"},{"value":3,"label":"Pending Review"},{"value":4,"label":"Needs Correction"},{"value":5,"label":"Rejected"},{"value":6,"label":"Draft"}]},{"type":"dateRange","name":"DATE_RANGE","label":"Date range","defaultValue":{"start":null,"end":null}}]},{"label":"Notary","component":"Notary","parameter":"notary","sourceTypeId":850,"myWorkQueueSearch":false,"allowEmptySearchTerm":true,"requestCertificateAlternateLabel":"Download Certificate","fileAmendmentButtonLabel":"Filing Actions","hideNameRequestCertificate":true,"hideAddressRequestCertificate":true,"hideRecordUserManagment":true,"searchPlaceholder":"Search by name or commission number","searchMustHaveOneOf":["CITY","search","SERVICE_TYPE"],"advancedParametersStartOpen":true,"searchIsSortable":true,"advancedSearchParameters":[{"type":"radio","name":"STARTS_WITH_YN","defaultValue":false,"options":[{"value":true,"label":"Starts with"},{"value":false,"label":"Contains"}]},{"type":"checkbox","name":"ACTIVE_ONLY_YN","defaultValue":true,"label":"Active entities only"},{"type":"text","name":"CITY","defaultValue":"","label":"City"},{"type":"select","name":"SERVICE_TYPE","label":"Special Services Offered","defaultValue":0,"options":[{"value":0,"label":"(N/A)"},{"value":6165,"label":"In-Person Electronic Notarization (IPEN)"},{"value":6166,"label":"Remote Online Notarization (RON)"},{"value":6167,"label":"Mobile Notary Services"},{"value":6168,"label":"Remote Ink Notarization (RIN)"}]}]},{"label":"Apostille","component":"Apostille","parameter":"apostille","sourceTypeId":720,"myRecordsSearch":false,"myWorkQueueSearch":false,"disabled":false,"allowedRoutes":["/forms-manager/","/queue/","/forms/"]},{"label":"Liens","component":"UCC","parameter":"ucc","sourceTypeId":1999,"myRecordsSearch":true,"myWorkQueueSearch":true,"fileAmendmentButtonLabel":"Filing Actions","searchPlaceholder":"Search by name or file number","disabled":false,"serverWebSearchDescription":true,"myRecordsDescription":"","workQueueDescription":"","searchDescription":"","hideRecordUserManagment":true,"searchLiensCheckout":false,"advancedSearchParameters":[{"type":"radio","name":"STARTS_WITH_YN","defaultValue":false,"options":[{"value":true,"label":"Starts with"},{"value":false,"label":"Contains"}]},{"type":"select","name":"STATUS","defaultValue":"ALL","label":"Status","options":[{"value":"ACTIVE_UNLAPSED","label":"Active (unlapsed)"},{"value":"ACTIVE_LAPSED_UNLAPSED","label":"Active (lapsed and unlapsed)"}]},{"type":"text","name":"EXCLUDE_VALUES","label":"Exclude Debtor Names (comma separated list of names to exclude)","defaultValue":""},{"type":"dateRange","name":"FILING_DATE","label":"Financing Statement Date","defaultValue":{"start":null,"end":null}},{"type":"dateRange","name":"LAPSE_DATE","label":"Lapse Date","defaultValue":{"start":null,"end":null}},{"type":"text","name":"CITY","label":"Debtor City","defaultValue":""}],"myRecordsFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Approved"},{"value":2,"label":"Pending Online Payment"},{"value":3,"label":"Pending Review"}]},{"type":"select","name":"TYPE","defaultValue":0,"label":"Lien Type","options":[{"value":0,"label":"All"},{"value":1,"label":"UCC"},{"value":2,"label":"EFS"},{"value":3,"label":"Title 71"}]}],"myWorkQueueFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Approved"},{"value":2,"label":"Pending Online Payment"},{"value":3,"label":"Pending Review"},{"value":4,"label":"Pending Print and Mail"},{"value":5,"label":"Rejected"},{"value":6,"label":"Draft"}]},{"type":"select","name":"TYPE","defaultValue":0,"label":"Lien Type","options":[{"value":0,"label":"All"},{"value":1,"label":"UCC"},{"value":2,"label":"EFS"},{"value":3,"label":"Title 71"}]}]},{"label":"Copy Request","component":"copies","parameter":"copies","sourceTypeId":2001,"myRecordsSearch":false,"myWorkQueueSearch":false,"disabled":false,"allowedRoutes":["/forms-manager/","/queue/","/forms/"]},{"label":"Trademark","component":"Trademark","parameter":"trademark","sourceTypeId":810,"showRequestCertificate":true,"searchMustHaveOneOf":["search","EXPIRATION_DATE","FILING_DATE"],"allowEmptySearchTerm":true,"requestCertificateAlternateLabel":"Request Information","fileAmendmentButtonLabel":"Filing Actions","advancedSearchParameters":[{"type":"radio","name":"QUERY_TYPE_ID","defaultValue":1010,"options":[{"value":1010,"label":"Starts with"},{"value":1011,"label":"Contains"},{"value":1012,"label":" Word Contains"}]},{"type":"checkbox","name":"OWNER_SEARCH_YN","defaultValue":false,"label":"Search owners"},{"type":"radio","name":"SERVICE_MARK_YN","label":"Mark Type","defaultValue":"","options":[{"value":"","label":"All Marks"},{"value":"Y","label":"Service Mark"},{"value":"N","label":"Trademark"}]},{"type":"serverSelect","name":"STATUS_ID","optionsSrc":"TYPE_V|TRADEMARK_STATUS_TYPE","label":"Status","placeholder":"All","defaultValue":"0"},{"type":"select","name":"DESIGN_TYPE_ID","options":[{"value":0,"label":"All"},{"value":990,"label":"Words Only"},{"value":991,"label":"Design Only"},{"value":992,"label":"Words and Design"}],"label":"Design Type","defaultValue":"0"},{"type":"dateRange","name":"FILING_DATE","label":"Registered Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}},{"type":"dateRange","name":"EXPIRATION_DATE","label":"Expiration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}}]},{"label":"Business Info Request","component":"InfoRequests","parameter":"info-request","sourceTypeId":167,"allowedRoutes":["/forms-manager/","/queue/","/forms/"]},{"label":"Data Requests","component":"DataRequests","parameter":"data-request","sourceTypeId":0,"allowedRoutes":["/forms-manager/"]},{"label":"CRA","component":"CRA","parameter":"cra","sourceTypeId":157,"myRecordsSearch":false,"searchPlaceholder":"Search by name or registered agent number","allowedRoutes":["/forms-manager/","/forms/","/records/","/queue/","/search/"],"allowEmptySearchTerm":true,"fileAmendmentButtonLabel":"Filing Actions","advancedSearchParameters":[{"type":"radio","name":"QUERY_TYPE_ID","defaultValue":1010,"options":[{"value":1010,"label":"Starts with"},{"value":1011,"label":"Contains"},{"value":1012,"label":" Word Contains"}]},{"type":"dateRange","name":"CRA_DATE","label":"Registration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}},{"type":"select","name":"STATUS_ID","label":"Status","defaultValue":0,"options":[{"value":0,"label":"All"},{"value":121,"label":"Active"},{"value":122,"label":"Inactive"}]},{"type":"select","name":"AGENT_TYPE_ID","label":"Agent Type","defaultValue":0,"options":[{"value":0,"label":"All"},{"value":460,"label":"Registered Agent"},{"value":461,"label":"Commercial Registered Agent"}]}]},{"label":"Farm Bill","component":"FarmBill","parameter":"farm-bill","path":"/lists/farm-bill","sourceTypeId":0,"myRecordsSearch":false,"allowedRules":["/search/"],"disabled":true,"searchDescription":"To perform a search, enter a debtor name. Your search results may include: exact debtor name, variations of that name and any filing that includes your search criteria. Punctuation is ignored.\n\nYou can click on \"Advanced\" to refine your search. Under “Advanced” you can search by crop, year, county and SSN/FEIN. As a registered Farm Bill Buyer with the Montana Secretary of State’s office it is important to maintain the confidentiality of the information contained within the Farm Bill Master List. The Farm Bill Master List reflects personal data, such as Social Security Numbers, which are a key piece of personal identifiable information to assist you in determining the existence of a lien against a specific debtor. The distribution of this information beyond its intended purpose is strictly prohibited.\n\nThe debtor's tax identification number has been hidden for confidentiality reasons. You may continue to search on a tax ID number and return debtors that match your search criteria. The SSN/FEIN must be entered without dashes or spaces.","searchMustHaveOneOf":["search","UCC_FARM_PRODUCT_ID","COUNTY"],"searchPlaceholder":"Search by debtor name","advancedSearchParameters":[{"type":"ServerMultiComplete","label":"Product code name(s)","name":"UCC_FARM_PRODUCT_ID","defaultValue":"","optionsSrc":"UCC_FARM_PRODUCT_V"},{"type":"MultiComplete","label":"Year or Range of Years","name":"YEAR_NUM","optionsSrc":"years","startYear":"1968","defaultValue":[],"preMergeOptions":[{"value":"ALL","label":"All"}]},{"type":"serverSelect","label":"State","name":"STATE","defaultValue":"MONTANA","optionsSrc":"STATE"},{"type":"ServerMultiComplete","label":"County","name":"COUNTY","defaultValue":[],"optionsSrc":"COUNTY","overrideSubOptionsSrcFromParameterName":"STATE"},{"type":"checkbox","name":"TIN_SEARCH_YN","defaultValue":false,"label":"Tax Identification Number Search"},{"type":"checkbox","name":"TIN_SORT_YN","defaultValue":false,"label":"Unique ID Sort"}]}],"SYSTEM_NICKNAME":"Online Services Portal","PAYMENT_METHODS":[{"type":"bypass"},{"type":"iTransact"}],"PAYMENT_ALLOW_AMEX":true,"SYSTEM_ID_LABEL":"System Id","DOUBLE_COLUMN_PUBLIC_LOGIN":true,"INTERNAL_USER_MANAGEMENT":true,"ALLOW_PUBLIC_JSON_IMPORT":false,"MAX_FILE_UPLOAD_SIZE":10000000,"REFUND_TEXT":"","RETURN_TO_HOME_ON_LOGOUT":true,"CURRENT_SOS_NAME":"Christi Jacobsen","LOGO_FILENAME":"mt-sos-logo.png","LOGO_ALT":"Christi Jacobsen, Montana Secretary of State","LOGO_FULL_WIDTH":true,"HOME_HIDE_AUTH_HINT":true,"HOME_TITLE":"Montana Secretary of State","CUSTOM_TAB_TITLE":"Official Montana","HOME_SUBTITLE":"Online Business Services","ENTITY_NAME_CONSENT_DESCRIPTION":"","ALLOW_USER_PROFILE_EDITING":true,"COMPARE_FOREIGN_NAME_IN_ENTITY_NAME_VALIDATION":true,"FOREIGN_NAME_FIELD_NAME":"KIMA_PARENT_NAME_INFO","LOGIN_TITLE":"Montana Secretary of State Online Filing Portal Login","PUBLIC_LOGIN_LABEL":"Username","REVERSE_LOGIN_COLUMNS":true,"LOGIN_SEAL_FILENAME":"seal_white.png","SEPARATE_USERNAME_AND_EMAIL":true,"CREATE_ACCOUNT_BUTTON_ALIGN_LEFT":true,"CREATE_ACCOUNT_BUTTON_TEXT":"CREATE AN ACCOUNT","PASSWORD_CUSTOM_ERROR_TEXT":"The password must meet all requirements","ACCOUNT_CREATED_MESSAGE":"Please check your email to verify your account to login and allow a few minutes for this message to arrive. Check your junk/spam folders if you do not find the email in your inbox.","PUBLIC_LOGIN_PLACEHOLDER":" ","DISABLE_DEFAULT_PAYMENT_RADIO":true,"CUSTOM_RESET_PASSWORD_ERROR_MESSAGE":"Username invalid - no account found","PUBLIC_LOGIN_CREATE_DESCRIPTION":"### Existing User:\n\n  - Enter your username and password to login.  \n\n\n  #### - OR -  \n\n\n\n  - Forgot password? Click 'Reset Password' and follow the prompts.\n  - Forgot username? Click 'Forgot Username' and follow the prompts.  \n\n\n  ### New User:\n  ","LOGIN_HELP_LINK":"https://sosmt.gov/business/how-do-i/","LOGIN_HELP_LINK_TEXT":"Need Help?","FORGOT_USERNAME_TEXT":"Forgot Username?","LOGIN_ACTIVE_DIRECTORY_TEXT":"State User Login","MULTIPLE_LOGIN_METHODS":true,"HAS_ACTIVE_DIRECTORY_LOGIN":true,"RESET_PASSWORD_WITH_USERNAME":true,"DOWNLOAD_LINK":true,"SHOW_USERNAME_ACCOUNT_CREATE":true,"SHOW_SCROLL_DOWN_ARROW":true,"SHOW_ADDRESS_ACCOUNT_CREATE":true,"TWO_COLUMN_ACCOUNT_CREATE":true,"RESET_PASSWORD_TIP":"A link to change your password has been sent to your email. Please allow a few minutes for this message to arrive. Please check your junk/spam folders if you do not find the email in your inbox.","FORGOT_PASSWORD_LINK_TEXT":"Reset Password","PHONE_NUMBER_OPTIONAL_ACCOUNT_CREATE":true,"SHOW_REQUIRED_INDICATOR_ACCOUNT_CREATE":true,"PASSWORD_REQUIREMENTS_ACCOUNT_CREATE":"\n    <ul>\n      <li>MUST contain at least 8 characters (12+ recommended)</li>\n      <li>MUST contain at least one uppercase letter.</li>\n      <li>MUST contain at least one lowercase letter.</li>\n      <li>MUST contain at least one number.</li>\n      <li>MUST contain at least one special character (!”#$%&'()*+,-./:;<=>?</li>\n    </ul>\n  ","ALLOW_CERTIFICATION_REQUEST":true,"ALLOW_PUBLIC_CERTIFICATE_REQUEST":true,"ALLOW_COPY_REQUEST":false,"ALLOW_CORRECTION_STYLING":true,"HIDE_DEPRECATION_WARNING":false,"AMEND_ROUTE_PUBLIC":true,"SEAL_FILENAME":"seal.png","SHOPPING_CART":true,"ALLOW_PAYMENT_UPDATE_WITH_EMPTY_CART":true,"RA_EMAIL":true,"RA_WEBSITE":true,"RA_NO_DEFAULT_TYPE":true,"RA_ADDRESS_LABEL":"Street Address","RA_TYPE_SELECTION_DEFAULT":true,"RA_DEFAULT_TYPE":"460","RA_OVERRIDE_TYPE_WITH_DEFAULT":true,"RA_PRINCIPAL_ADDRESS_AMS":true,"UPLOAD_AND_SUBMIT_HIDE_IF_ONE_OPTION":true,"PAYMENT_PROCESSING_MESSAGE":"Your payment is processing - Do not close your browser or click the back button","CHECKOUT_BUTTON_WHEN_PROCESSING_TEXT":"Processing","EFS_CROP_PICKER_NONE_LABEL":"Lien Duration","DISALLOWED_WIZARD_PIECES":["FormationLocale"],"REPEATER_SHOW_EDIT_BUTTON":true,"DATA_REQUEST_PAGE_TITLE":"Data Requests and Subscriptions","DATA_REQUEST_SIDEBAR_LABEL":"Data Requests & Subscriptions","LOGIN_REDIRECTS_TO_EPASS":false,"LOGIN_REDIRECTS_TO_ACTIVE_DIRECTORY":true,"LOGIN_ACTIVE_DIRECTORY_LINK":true,"FETCH_EDIT_USER_LINK":false,"LISTS_FETCH_AVAILABLE_LISTS":true,"POST_WIZARD_SUBMIT_REDIRECT_URL":"/","PIN_REQUEST_ATTESTATIONS":true,"PIN_REQUEST_DESCRIPTION":"Click **Request PIN** to have a new PIN sent to the account holder's email address on file.","OWNERSHIP_REQUEST_DESCRIPTION":"To become an **authorized user** of this record, a current **AUTHORIZED USER** will need to grant you access. To request access, click **Request Access** below.","PIN_REQUEST_SUCCESS_MESSAGE":"The PIN you have requested for this entity has been sent to the email associated with your user account.  You should receive the PIN in approximately 3-5 minutes, depending on your email service provider.","APOSTILLE_HEADER_LABEL":"Verification Information","APOSTILLE_NUMBER_LABEL":"Apostille/Authentication","APOSTILLE_CITY_STATE_OVERRIDE":"HELENA, MT","APOSTILLE_FILING_DATE_LABEL":"Issue Date","APOSTILLE_CITY_STATE_IN_CERTIFIED":true,"NOTARY_EXISTING_FILING":true,"ALLOW_REVOKE_OWN_ACCESS_ONLY":false,"HIDE_CANCEL_ON_ONETIME_DATA_REQUESTS":true,"DATA_REQUESTS_IN_SHOPPING_CART":true,"WQ_ALLOW_EDIT_PENDING_PAYMENT":true,"WQ_CONFIRM_ON_DELETE":true,"WQ_DELETE_CONFIRM_MESSAGE":"Deleting this filing will forfeit any money already paid to the Secretary of State. This action is permanent and cannot be undone, are you sure you would like to delete?","PASS_ITEM_GUIDS_ON_CHECKOUT":true,"FORM_REVISION_HISTORY":true,"CHECKOUT_DISCLAIMER":"By entering your credit card and/or checking account information you (i) state that **you are an authorized user** of the credit card and/or electronic check and that the associated information entered (e.g., account holder name, account number, billing address) is accurate, (ii) **you authorize payment processor to charge the amount you have requested** to your credit card and/or funding account, and (iii) **acknowledge if a charge is declined or reversed you may also be assessed a customary charge** by the payment processor for such transactions.","FARM_BILL_SEARCH_CONFIDENTIAL":"As a registered Farm Bill Buyer with the Montana Secretary of State’s office it is important to maintain the confidentiality of the information contained within the Farm Bill Master List. The Farm Bill Master List reflects personal data, such as Social Security Numbers, which are a key piece of personal identifiable information to assist you in determining the existence of a lien against a specific debtor. The distribution of this information beyond its intended purpose is strictly prohibited.\n\n**The debtor's tax identification number has been hidden for confidentiality reasons. You may continue to search on a tax ID number and return debtors that match your search criteria. The SSN/FEIN must be entered without dashes or spaces.  If you need access to the tax identification number to clearly identify the debtor, please contact the UCC unit at (406) 444-3665.**","VIEW_HISTORY_BUTTON_ALT_TEXT":"View Filings","WIZARD_ERROR_TITLE_MESSAGE":"Form Error","FARM_BILL_SEARCH_INTERACTIVE":true,"USE_FARM_BILL_API":true,"DISALLOW_ASSIGN_SELF_AS_RA":true,"DISALLOW_ASSIGN_SELF_AS_PRINCIPAL":true,"USE_TRADEMARK_OWNER_VALIDATION":true,"USE_ALTERNATIVE_FOREIGN_ADDRESS_LABELS":true,"MY_RECEIPTS_FILTER":[{"type":"dateRange","name":"DATE_RANGE","label":"Date range","defaultValue":{"start":null,"end":null}},{"type":"text","name":"REF_NUM","defaultValue":"","label":"Reference Number"},{"type":"text","name":"RECEIPT_NUM","defaultValue":"","label":"Receipt Id"},{"type":"text","name":"AMOUNT","defaultValue":"","label":"Amount"},{"type":"select","name":"TYPE","defaultValue":"","label":"Payment Type","options":[{"value":"","label":"All"},{"value":"CC","label":"Credit Card"},{"value":"Check","label":"Check"}]}],"MY_RECEIPTS_SHOW_IN_SIDEBAR":true,"SHOW_MY_RECEIPTS_HELPER_TEXT":true,"MY_RECEIPTS_HELPER_LABEL":"About Receipt Search","MY_RECEIPTS_HELPER_TEXT":"You can search for receipts based on their descriptions, including the items paid for on the receipt. Use the filters to search for or filter specific information.","FARM_BILL_SUBLINK":{"label":"Farm Bill","component":"FarmBill","parameter":"farm-bill","path":"/lists/farm-bill","sourceTypeId":0,"myRecordsSearch":false,"allowedRules":["/search/"],"disabled":true,"searchDescription":"To perform a search, enter a debtor name. Your search results may include: exact debtor name, variations of that name and any filing that includes your search criteria. Punctuation is ignored.\n\nYou can click on \"Advanced\" to refine your search. Under “Advanced” you can search by crop, year, county and SSN/FEIN. As a registered Farm Bill Buyer with the Montana Secretary of State’s office it is important to maintain the confidentiality of the information contained within the Farm Bill Master List. The Farm Bill Master List reflects personal data, such as Social Security Numbers, which are a key piece of personal identifiable information to assist you in determining the existence of a lien against a specific debtor. The distribution of this information beyond its intended purpose is strictly prohibited.\n\nThe debtor's tax identification number has been hidden for confidentiality reasons. You may continue to search on a tax ID number and return debtors that match your search criteria. The SSN/FEIN must be entered without dashes or spaces.","searchMustHaveOneOf":["search","UCC_FARM_PRODUCT_ID","COUNTY"],"searchPlaceholder":"Search by debtor name","advancedSearchParameters":[{"type":"ServerMultiComplete","label":"Product code name(s)","name":"UCC_FARM_PRODUCT_ID","defaultValue":"","optionsSrc":"UCC_FARM_PRODUCT_V"},{"type":"MultiComplete","label":"Year or Range of Years","name":"YEAR_NUM","optionsSrc":"years","startYear":"1968","defaultValue":[],"preMergeOptions":[{"value":"ALL","label":"All"}]},{"type":"serverSelect","label":"State","name":"STATE","defaultValue":"MONTANA","optionsSrc":"STATE"},{"type":"ServerMultiComplete","label":"County","name":"COUNTY","defaultValue":[],"optionsSrc":"COUNTY","overrideSubOptionsSrcFromParameterName":"STATE"},{"type":"checkbox","name":"TIN_SEARCH_YN","defaultValue":false,"label":"Tax Identification Number Search"},{"type":"checkbox","name":"TIN_SORT_YN","defaultValue":false,"label":"Unique ID Sort"}]},"ALLOW_ADDRESS_VALIDATION_BYPASS_OPTION":true,"DEFAULT_ADDRESS_VALIDATION_BYPASS_OPTION_CHECKED":true}).RECEIPT_PAGE_DOWNLOADS_HEADER;
	
	var ReceiptPage = function (_Component) {
	  _inherits(ReceiptPage, _Component);
	
	  function ReceiptPage() {
	    _classCallCheck(this, ReceiptPage);
	
	    return _possibleConstructorReturn(this, (ReceiptPage.__proto__ || Object.getPrototypeOf(ReceiptPage)).apply(this, arguments));
	  }
	
	  _createClass(ReceiptPage, [{
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        _Shell.Body,
	        { className: 'receipt-wrapper' },
	        _react2.default.createElement(Receipt, null)
	      );
	    }
	  }]);
	
	  return ReceiptPage;
	}(_react.Component);
	
	exports.default = ReceiptPage;
	
	var ReceiptModal = exports.ReceiptModal = function (_React$Component) {
	  _inherits(ReceiptModal, _React$Component);
	
	  function ReceiptModal() {
	    var _ref;
	
	    var _temp, _this2, _ret;
	
	    _classCallCheck(this, ReceiptModal);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this2 = _possibleConstructorReturn(this, (_ref = ReceiptModal.__proto__ || Object.getPrototypeOf(ReceiptModal)).call.apply(_ref, [this].concat(args))), _this2), _this2.state = {
	      isOpened: _this2.props.isOpened || false
	    }, _this2.componentWillReceiveProps = function (nextProps) {
	      if (_this2.props.isOpened === false && nextProps.isOpened === true) {
	        _this2.setState({
	          isOpened: true
	        });
	      }
	    }, _this2.closeModal = function () {
	      _this2.setState({ isOpened: false });
	      _this2.props.onRequestModalClose();
	    }, _temp), _possibleConstructorReturn(_this2, _ret);
	  }
	
	  _createClass(ReceiptModal, [{
	    key: 'render',
	    value: function render() {
	      var _this3 = this;
	
	      return _react2.default.createElement(
	        _Portal2.default,
	        { isOpened: this.state.isOpened },
	        _react2.default.createElement(
	          _Modal.Modal,
	          {
	            hideHeader: true,
	            closeModal: this.closeModal,
	            modalSize: 'fullscreen',
	            noBackground: true,
	            disableEntranceAnimation: true,
	            modalBodyClassName: 'login-modal-body',
	            save: _utilities.noop,
	            cancel: _utilities.noop,
	            ref: function ref(_ref2) {
	              return _this3.modal = _ref2;
	            }
	          },
	          _react2.default.createElement(Receipt, null)
	        )
	      );
	    }
	  }]);
	
	  return ReceiptModal;
	}(_react2.default.Component);
	
	var Receipt = exports.Receipt = function Receipt(_ref3) {
	  var animated = _ref3.animated,
	      receiptItems = _ref3.receiptItems,
	      receiptItemContainers = _ref3.receiptItemContainers,
	      downloads = _ref3.downloads,
	      groupedDownloads = _ref3.groupedDownloads,
	      _ref3$refNum = _ref3.refNum,
	      refNum = _ref3$refNum === undefined ? '' : _ref3$refNum,
	      isFree = _ref3.isFree,
	      _ref3$additionalProps = _ref3.additionalProps,
	      additionalProps = _ref3$additionalProps === undefined ? {} : _ref3$additionalProps;
	
	  var dispatch = (0, _reactRedux.useDispatch)();
	
	  _react2.default.useEffect(function () {
	    dispatch((0, _actions.getAndSetCartQuantity)());
	  }, []);
	
	  var total = (receiptItemContainers ? (0, _utilities.calculateReceiptItemContainersTotal)(receiptItemContainers) : (0, _utilities.calculateReceiptItemsTotal)(receiptItems)).toFixed(2);
	  return _react2.default.createElement(
	    'div',
	    { className: 'receipt zig-zag ' + (animated !== false ? 'animated fadeInUp' : '') },
	    _react2.default.createElement(
	      'div',
	      { className: 'success-badge animated zoomIn fast-animation' },
	      _react2.default.createElement('span', { className: 'icon icon-check' })
	    ),
	    !isFree && _react2.default.createElement(
	      'a',
	      {
	        download: true,
	        href: _requests.BASE_URL + '/api/Report/GetReceiptByCartRefNum/' + refNum,
	        className: 'receipt-download'
	      },
	      _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(_downloadBox2.default, null),
	        ' Download Receipt'
	      )
	    ),
	    _react2.default.createElement(
	      'h2',
	      null,
	      additionalProps.RECEIPT_CONFIRMATION_HEADER_TEXT || (!isFree > 0 ? 'Payment' : 'Submission') + ' Successful',
	      additionalProps.RECEIPT_CONFIRMATION_ADDITIONAL_TEXT && _react2.default.createElement(_Markdown2.default, {
	        className: 'markdown',
	        source: additionalProps.RECEIPT_CONFIRMATION_ADDITIONAL_TEXT
	      })
	    ),
	    !isFree && _react2.default.createElement(
	      _react2.default.Fragment,
	      null,
	      _react2.default.createElement(
	        'div',
	        { className: 'line-items' },
	        receiptItemContainers ? receiptItemContainers.map(function (container, i) {
	          var mainItem = container.RECEIPT_ITEM_WEB_LIST[0];
	          return mainItem ? _react2.default.createElement(LineItem, {
	            product: mainItem.DESCR_DISPLAY ? mainItem.DESCR_DISPLAY : mainItem.DESCR,
	            details: container.RECEIPT_ITEM_WEB_LIST.slice(1).map(function (item, k) {
	              return {
	                description: item.DESCR_DISPLAY ? item.DESCR_DISPLAY : item.DESCR,
	                price: item.LINE_TOTAL
	              };
	            }),
	            price: mainItem.LINE_TOTAL,
	            key: '' + mainItem.REF_NUM + i
	          }) : null;
	        }) : receiptItems.map(function (item, i) {
	          return _react2.default.createElement(LineItem, {
	            product: item.DESCR_DISPLAY ? item.DESCR_DISPLAY : item.DESCR,
	            details: [],
	            price: item.LINE_TOTAL,
	            key: '' + item.REF_NUM + i
	          });
	        })
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'total-row' },
	        _react2.default.createElement(
	          'div',
	          { className: 'total-col' },
	          _react2.default.createElement(
	            'label',
	            { htmlFor: 'total' },
	            'Total'
	          ),
	          _react2.default.createElement(
	            'span',
	            { id: 'total' },
	            '$' + total
	          )
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'refund-text' },
	        total < 0 ? _react2.default.createElement(
	          'span',
	          null,
	          ("")
	        ) : null
	      )
	    ),
	    downloads && downloads.length > 0 && _react2.default.createElement(
	      'div',
	      { className: 'downloads-wrapper' },
	      _react2.default.createElement(
	        'h2',
	        null,
	        RECEIPT_PAGE_DOWNLOADS_HEADER ? RECEIPT_PAGE_DOWNLOADS_HEADER : "Available Downloads"
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'flex-column' },
	        downloads.map(function (download, i) {
	          return _react2.default.createElement(_ReportsList.Report, { report: download, key: '' + download.APP_REPORT_ID + i, animated: false });
	        })
	      )
	    ),
	    groupedDownloads && groupedDownloads.LIST.length > 0 && _react2.default.createElement(
	      'div',
	      { className: 'downloads-wrapper download-groups' },
	      _react2.default.createElement(
	        'h2',
	        null,
	        RECEIPT_PAGE_DOWNLOADS_HEADER ? RECEIPT_PAGE_DOWNLOADS_HEADER : "Available Downloads"
	      ),
	      groupedDownloads.LIST.map(function (group) {
	        return _react2.default.createElement(
	          'div',
	          { className: 'flex-column download-group', key: group.GUID },
	          _react2.default.createElement(
	            'h3',
	            null,
	            group.DESCR
	          ),
	          group.STATUS_DESCR ? _react2.default.createElement(
	            'p',
	            null,
	            'Status: ',
	            group.STATUS_DESCR
	          ) : null,
	          group.WORK_QUEUE_DOCUMENT_LIST.map(function (download, i) {
	            return _react2.default.createElement(_ReportsList.Report, { report: download, key: '' + download.APP_REPORT_ID + i, animated: false });
	          })
	        );
	      })
	    )
	  );
	};
	
	var LineItem = function LineItem(_ref4) {
	  var product = _ref4.product,
	      actions = _ref4.actions,
	      details = _ref4.details,
	      price = _ref4.price;
	  return _react2.default.createElement(
	    'div',
	    { className: 'line-item' },
	    _react2.default.createElement(
	      'div',
	      { className: 'flex-row' },
	      _react2.default.createElement(
	        'div',
	        { className: 'details' },
	        _react2.default.createElement(
	          'span',
	          { className: 'product' },
	          product
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'price' },
	        '$' + parseFloat(price, 10).toFixed(2)
	      )
	    ),
	    _react2.default.createElement(
	      'span',
	      { className: 'details' },
	      details.map(function (detail, i) {
	        return _react2.default.createElement(
	          'span',
	          { className: 'detail', key: i },
	          detail.description,
	          _react2.default.createElement(
	            'div',
	            { className: 'detail-price' },
	            '$' + parseFloat(detail.price, 10).toFixed(2)
	          )
	        );
	      })
	    )
	  );
	};

/***/ },
/* 1063 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Shell = __webpack_require__(19);
	
	var _Receipt = __webpack_require__(1062);
	
	var _utilities = __webpack_require__(8);
	
	var _requests = __webpack_require__(6);
	
	var _PaymentCallback = __webpack_require__(119);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ReceiptPage = function (_React$Component) {
	  _inherits(ReceiptPage, _React$Component);
	
	  function ReceiptPage() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, ReceiptPage);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = ReceiptPage.__proto__ || Object.getPrototypeOf(ReceiptPage)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      receiptItems: null,
	      receiptItemContainers: null,
	      downloads: null,
	      refNum: null,
	      loading: true,
	      downloadsLoading: true,
	      error: false,
	      errorCode: null,
	      errorMessage: null,
	      paymentMessage: "",
	      isFree: true,
	      additionalProps: {}
	    }, _this.componentDidMount = function () {
	      var query = (0, _utilities.parseUrlQuery)(_this.props.location.search);
	      if (query.ref) {
	        _this.setState({ refNum: query.ref });
	        Promise.all([_this.getWebCart(query.ref), _this.getDownloads(query.ref)]).then(function () {
	          _this.setState({
	            loading: false
	          });
	        }).catch(function (errs) {
	          console.error(errs);
	          _this.setState({
	            error: true,
	            errorCode: query.RESULT,
	            errorMessage: query.RESPMSG
	          });
	        });
	      }
	    }, _this.getWebCart = function (refNum) {
	      return new Promise(function (resolve, reject) {
	        (0, _requests.GET_WEB_CART_BY_REF_NUM)(refNum, function (webCart) {
	          if (webCart) {
	            _this.setState({
	              receiptItems: webCart.RECEIPT_ITEM_WEB_LIST,
	              receiptItemContainers: webCart.RECEIPT_ITEM_CONTAINER_WEB_LIST,
	              loading: false,
	              isFree: webCart.IS_FREE,
	              additionalProps: webCart.WEB_CART_ADDITIONAL_PROPS || {}
	            });
	            resolve();
	          }
	        }, function (err) {
	          reject(err);
	        });
	      });
	    }, _this.getDownloads = function (refNum) {
	      return new Promise(function (resolve, reject) {
	        (0, _requests.GET_REPORTS_BY_WEB_CART_REF_NUM)(refNum, function (downloads) {
	          _this.setState({ downloads: downloads, downloadsLoading: false });
	          resolve();
	        }, function (err) {
	          reject(err);
	        });
	      });
	    }, _this.getSuccessMessage = function () {
	      return new Promise(function (resolve, reject) {
	        (0, _requests.GET_APP_SETTING_BY_NAME)('WEB_POST_FILING_MSG_COMPLETE', function (setting) {});
	      });
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(ReceiptPage, [{
	    key: "render",
	    value: function render() {
	      return _react2.default.createElement(
	        _Shell.Body,
	        { className: "receipt-wrapper", backgroundThemeColor: "light-neutral" },
	        !this.state.loading && !this.state.downloadsLoading && _react2.default.createElement(_Receipt.Receipt, {
	          animated: true,
	          receiptItems: this.state.receiptItems,
	          receiptItemContainers: this.state.receiptItemContainers,
	          downloads: !Array.isArray(this.state.downloads) ? undefined : this.state.downloads,
	          groupedDownloads: !Array.isArray(this.state.downloads) ? this.state.downloads : undefined,
	          refNum: this.state.refNum,
	          isFree: this.state.isFree,
	          additionalProps: this.state.additionalProps
	        }),
	        this.state.error && _react2.default.createElement(
	          "div",
	          { className: "payment-callback" },
	          _react2.default.createElement(_PaymentCallback.PaymentError, {
	            errorCode: this.state.errorCode,
	            errorMessage: this.state.errorMessage
	          })
	        )
	      );
	    }
	  }]);
	
	  return ReceiptPage;
	}(_react2.default.Component);
	
	exports.default = ReceiptPage;

/***/ },
/* 1064 */,
/* 1065 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(7);
	
	var _Shell = __webpack_require__(19);
	
	var _actions = __webpack_require__(29);
	
	__webpack_require__(538);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	// import ls from 'local-storage'
	
	// import FloatingMenu from 'components/FloatingMenu/FloatingMenu'
	// import DotMenuIcon from "@tecuity/sos-icons/react/dot-menu"
	// import { GET_DASHBOARD_DATA } from 'requests'
	// import { colors as mixColors } from 'just-mix'
	
	
	var Dashboard = {};
	
	var DeferredDashboard = function (_React$Component) {
	  _inherits(DeferredDashboard, _React$Component);
	
	  function DeferredDashboard(props) {
	    _classCallCheck(this, DeferredDashboard);
	
	    var _this = _possibleConstructorReturn(this, (DeferredDashboard.__proto__ || Object.getPrototypeOf(DeferredDashboard)).call(this, props));
	
	    _this.componentDidMount = function () {
	      _this.fetchBundle();
	      // this.props.overrideSidebarResizing(true)
	      // this.props.toggleSidebarCollapse(true)
	    };
	
	    _this.componentWillUnmount = function () {
	      // if (document.body.clientWidth > 800) this.props.overrideSidebarResizing(false);
	      // this.props.toggleSidebarCollapse(false)
	    };
	
	    _this.fetchBundle = function () {
	      __webpack_require__.e/* nsure */(2, function (require) {
	        Dashboard = __webpack_require__(448).default;
	        _this.setState({ fetchingBundle: false });
	      });
	    };
	
	    _this.state = {
	      fetchingBundle: true
	    };
	    return _this;
	  }
	
	  _createClass(DeferredDashboard, [{
	    key: 'render',
	    value: function render() {
	      var username = this.props.username;
	
	      return _react2.default.createElement(
	        _Shell.Body,
	        { className: 'dashboard-wrapper full-height-page' },
	        !this.state.fetchingBundle && _react2.default.createElement(Dashboard, { username: username })
	      );
	    }
	  }]);
	
	  return DeferredDashboard;
	}(_react2.default.Component);
	
	exports.default = (0, _reactRedux.connect)(function (state) {
	  var username = state.auth.FIRST_NAME || state.auth.USERNAME;
	  return { username: username };
	}, {
	  toggleSidebarCollapse: _actions.toggleSidebarCollapse,
	  overrideSidebarResizing: _actions.overrideSidebarResizing
	})(DeferredDashboard);

/***/ },
/* 1066 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Loaders = __webpack_require__(16);
	
	var _cart = __webpack_require__(223);
	
	var _cart2 = _interopRequireDefault(_cart);
	
	var _gears = __webpack_require__(225);
	
	var _gears2 = _interopRequireDefault(_gears);
	
	var _database = __webpack_require__(330);
	
	var _database2 = _interopRequireDefault(_database);
	
	var _rss = __webpack_require__(588);
	
	var _rss2 = _interopRequireDefault(_rss);
	
	var _reactTooltip = __webpack_require__(78);
	
	var _reactTooltip2 = _interopRequireDefault(_reactTooltip);
	
	var _format = __webpack_require__(33);
	
	var _format2 = _interopRequireDefault(_format);
	
	var _shortid = __webpack_require__(22);
	
	var _shortid2 = _interopRequireDefault(_shortid);
	
	var _hooks = __webpack_require__(144);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DATA_REQUEST_TOOLTIP = ({"NODE_ENV":"production","BUILD_DATE":"2025-08-27T15:15:31.687Z","BUILD_NUMBER":"Not Provided","GIT_VERSION":"v1.3.0-381-ga81e29b08","GIT_COMMIT_HASH":"a81e29b085c9268ffd96c78eb734365802722741","GIT_BRANCH":"beta","PUBLIC_URL":"","STATE_ABBR":"MT","STATE_NAME":"Montana","STATE_ORG_TITLE":"Secretary of State","LOGIN_HEADER_IMG_PATH":"","HOME_IMG_FILENAME":"montana.jpg","FAVICON_FILE_NAME":"favicon.ico","ALLOW_E_SIGN_ON_CORRECTIONS":true,"THIRD_PARTY_SIGNING_ALLOWED":false,"MY_ACCOUNT_SAVE_AND_CLOSE_BUTTON":true,"IE_DEPRECATED_MESSAGE":"Internet Explorer is not supported. Please select a supported browser below to access this website.","ADDITIONAL_ROUTES":{"dataRequests":true,"farmBill":true,"apostille":true,"externalHelp":"https://sosmt.gov/business/help-center/","systemAdministration":[{"title":"Saved Payments","parameter":"saved-payments","componentName":"SavedPayments"}]},"SUBROUTES":[{"label":"Business","component":"Business","parameter":"business","myWorkQueueSearch":false,"sourceTypeId":54,"searchMustHaveOneOf":["FILING_TYPE_ID","STATUS_ID","STATE","search"],"serverWebSearchDescription":true,"serverWorkQueueDescription":true,"serverMyRecordsDescription":true,"searchPlaceholder":"Search by name or filing number (X########)","allowEmptySearchTerm":true,"requestCertificateAlternateLabel":"Request Information","fileAmendmentButtonLabel":"Filing Actions","advancedSearchParameters":[{"type":"radio","name":"QUERY_TYPE_ID","defaultValue":1010,"options":[{"value":1010,"label":"Starts with"},{"value":1011,"label":"Contains"},{"value":1012,"label":" Word Contains"}]},{"type":"serverSelect","name":"FILING_TYPE_ID","optionsSrc":"FILING_TYPES","label":"Entity Type","placeholder":"All","defaultValue":"0"},{"type":"serverSelect","name":"FILING_SUBTYPE_ID","optionsSrc":"FILING_SUBTYPES","label":"Entity Subtype","overrideSubOptionsSrcFromParameterName":"FILING_TYPE_ID","placeholder":"All","defaultValue":"0"},{"type":"serverSelect","name":"STATUS_ID","optionsSrc":"FILING_STATUS_WITHOUT_ALL","label":"Status","placeholder":"All","defaultValue":"0"},{"type":"serverSelect","name":"STATE","optionsSrc":"STATE","label":"State","placeholder":"All","defaultValue":""},{"type":"serverSelect","name":"COUNTY","optionsSrc":"COUNTY_SUBOPTION","label":"County","overrideSubOptionsSrcFromParameterName":"STATE","placeholder":"All","defaultValue":""},{"type":"checkbox","name":"CRA_SEARCH_YN","defaultValue":false,"label":"Search by Registered Agent PID"},{"type":"dateRange","name":"FILING_DATE","label":"Registration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}},{"type":"dateRange","name":"EXPIRATION_DATE","label":"Expiration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}}],"myRecordsFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Active"},{"value":2,"label":"Inactive"},{"value":3,"label":"Pending"}]},{"type":"dateRange","name":"DATE_RANGE","label":"Date range","defaultValue":{"start":null,"end":null}}],"myWorkQueueFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Approved"},{"value":2,"label":"Pending Online Payment"},{"value":3,"label":"Pending Review"},{"value":4,"label":"Needs Correction"},{"value":5,"label":"Rejected"},{"value":6,"label":"Draft"}]},{"type":"dateRange","name":"DATE_RANGE","label":"Date range","defaultValue":{"start":null,"end":null}}]},{"label":"Notary","component":"Notary","parameter":"notary","sourceTypeId":850,"myWorkQueueSearch":false,"allowEmptySearchTerm":true,"requestCertificateAlternateLabel":"Download Certificate","fileAmendmentButtonLabel":"Filing Actions","hideNameRequestCertificate":true,"hideAddressRequestCertificate":true,"hideRecordUserManagment":true,"searchPlaceholder":"Search by name or commission number","searchMustHaveOneOf":["CITY","search","SERVICE_TYPE"],"advancedParametersStartOpen":true,"searchIsSortable":true,"advancedSearchParameters":[{"type":"radio","name":"STARTS_WITH_YN","defaultValue":false,"options":[{"value":true,"label":"Starts with"},{"value":false,"label":"Contains"}]},{"type":"checkbox","name":"ACTIVE_ONLY_YN","defaultValue":true,"label":"Active entities only"},{"type":"text","name":"CITY","defaultValue":"","label":"City"},{"type":"select","name":"SERVICE_TYPE","label":"Special Services Offered","defaultValue":0,"options":[{"value":0,"label":"(N/A)"},{"value":6165,"label":"In-Person Electronic Notarization (IPEN)"},{"value":6166,"label":"Remote Online Notarization (RON)"},{"value":6167,"label":"Mobile Notary Services"},{"value":6168,"label":"Remote Ink Notarization (RIN)"}]}]},{"label":"Apostille","component":"Apostille","parameter":"apostille","sourceTypeId":720,"myRecordsSearch":false,"myWorkQueueSearch":false,"disabled":false,"allowedRoutes":["/forms-manager/","/queue/","/forms/"]},{"label":"Liens","component":"UCC","parameter":"ucc","sourceTypeId":1999,"myRecordsSearch":true,"myWorkQueueSearch":true,"fileAmendmentButtonLabel":"Filing Actions","searchPlaceholder":"Search by name or file number","disabled":false,"serverWebSearchDescription":true,"myRecordsDescription":"","workQueueDescription":"","searchDescription":"","hideRecordUserManagment":true,"searchLiensCheckout":false,"advancedSearchParameters":[{"type":"radio","name":"STARTS_WITH_YN","defaultValue":false,"options":[{"value":true,"label":"Starts with"},{"value":false,"label":"Contains"}]},{"type":"select","name":"STATUS","defaultValue":"ALL","label":"Status","options":[{"value":"ACTIVE_UNLAPSED","label":"Active (unlapsed)"},{"value":"ACTIVE_LAPSED_UNLAPSED","label":"Active (lapsed and unlapsed)"}]},{"type":"text","name":"EXCLUDE_VALUES","label":"Exclude Debtor Names (comma separated list of names to exclude)","defaultValue":""},{"type":"dateRange","name":"FILING_DATE","label":"Financing Statement Date","defaultValue":{"start":null,"end":null}},{"type":"dateRange","name":"LAPSE_DATE","label":"Lapse Date","defaultValue":{"start":null,"end":null}},{"type":"text","name":"CITY","label":"Debtor City","defaultValue":""}],"myRecordsFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Approved"},{"value":2,"label":"Pending Online Payment"},{"value":3,"label":"Pending Review"}]},{"type":"select","name":"TYPE","defaultValue":0,"label":"Lien Type","options":[{"value":0,"label":"All"},{"value":1,"label":"UCC"},{"value":2,"label":"EFS"},{"value":3,"label":"Title 71"}]}],"myWorkQueueFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Approved"},{"value":2,"label":"Pending Online Payment"},{"value":3,"label":"Pending Review"},{"value":4,"label":"Pending Print and Mail"},{"value":5,"label":"Rejected"},{"value":6,"label":"Draft"}]},{"type":"select","name":"TYPE","defaultValue":0,"label":"Lien Type","options":[{"value":0,"label":"All"},{"value":1,"label":"UCC"},{"value":2,"label":"EFS"},{"value":3,"label":"Title 71"}]}]},{"label":"Copy Request","component":"copies","parameter":"copies","sourceTypeId":2001,"myRecordsSearch":false,"myWorkQueueSearch":false,"disabled":false,"allowedRoutes":["/forms-manager/","/queue/","/forms/"]},{"label":"Trademark","component":"Trademark","parameter":"trademark","sourceTypeId":810,"showRequestCertificate":true,"searchMustHaveOneOf":["search","EXPIRATION_DATE","FILING_DATE"],"allowEmptySearchTerm":true,"requestCertificateAlternateLabel":"Request Information","fileAmendmentButtonLabel":"Filing Actions","advancedSearchParameters":[{"type":"radio","name":"QUERY_TYPE_ID","defaultValue":1010,"options":[{"value":1010,"label":"Starts with"},{"value":1011,"label":"Contains"},{"value":1012,"label":" Word Contains"}]},{"type":"checkbox","name":"OWNER_SEARCH_YN","defaultValue":false,"label":"Search owners"},{"type":"radio","name":"SERVICE_MARK_YN","label":"Mark Type","defaultValue":"","options":[{"value":"","label":"All Marks"},{"value":"Y","label":"Service Mark"},{"value":"N","label":"Trademark"}]},{"type":"serverSelect","name":"STATUS_ID","optionsSrc":"TYPE_V|TRADEMARK_STATUS_TYPE","label":"Status","placeholder":"All","defaultValue":"0"},{"type":"select","name":"DESIGN_TYPE_ID","options":[{"value":0,"label":"All"},{"value":990,"label":"Words Only"},{"value":991,"label":"Design Only"},{"value":992,"label":"Words and Design"}],"label":"Design Type","defaultValue":"0"},{"type":"dateRange","name":"FILING_DATE","label":"Registered Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}},{"type":"dateRange","name":"EXPIRATION_DATE","label":"Expiration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}}]},{"label":"Business Info Request","component":"InfoRequests","parameter":"info-request","sourceTypeId":167,"allowedRoutes":["/forms-manager/","/queue/","/forms/"]},{"label":"Data Requests","component":"DataRequests","parameter":"data-request","sourceTypeId":0,"allowedRoutes":["/forms-manager/"]},{"label":"CRA","component":"CRA","parameter":"cra","sourceTypeId":157,"myRecordsSearch":false,"searchPlaceholder":"Search by name or registered agent number","allowedRoutes":["/forms-manager/","/forms/","/records/","/queue/","/search/"],"allowEmptySearchTerm":true,"fileAmendmentButtonLabel":"Filing Actions","advancedSearchParameters":[{"type":"radio","name":"QUERY_TYPE_ID","defaultValue":1010,"options":[{"value":1010,"label":"Starts with"},{"value":1011,"label":"Contains"},{"value":1012,"label":" Word Contains"}]},{"type":"dateRange","name":"CRA_DATE","label":"Registration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}},{"type":"select","name":"STATUS_ID","label":"Status","defaultValue":0,"options":[{"value":0,"label":"All"},{"value":121,"label":"Active"},{"value":122,"label":"Inactive"}]},{"type":"select","name":"AGENT_TYPE_ID","label":"Agent Type","defaultValue":0,"options":[{"value":0,"label":"All"},{"value":460,"label":"Registered Agent"},{"value":461,"label":"Commercial Registered Agent"}]}]},{"label":"Farm Bill","component":"FarmBill","parameter":"farm-bill","path":"/lists/farm-bill","sourceTypeId":0,"myRecordsSearch":false,"allowedRules":["/search/"],"disabled":true,"searchDescription":"To perform a search, enter a debtor name. Your search results may include: exact debtor name, variations of that name and any filing that includes your search criteria. Punctuation is ignored.\n\nYou can click on \"Advanced\" to refine your search. Under “Advanced” you can search by crop, year, county and SSN/FEIN. As a registered Farm Bill Buyer with the Montana Secretary of State’s office it is important to maintain the confidentiality of the information contained within the Farm Bill Master List. The Farm Bill Master List reflects personal data, such as Social Security Numbers, which are a key piece of personal identifiable information to assist you in determining the existence of a lien against a specific debtor. The distribution of this information beyond its intended purpose is strictly prohibited.\n\nThe debtor's tax identification number has been hidden for confidentiality reasons. You may continue to search on a tax ID number and return debtors that match your search criteria. The SSN/FEIN must be entered without dashes or spaces.","searchMustHaveOneOf":["search","UCC_FARM_PRODUCT_ID","COUNTY"],"searchPlaceholder":"Search by debtor name","advancedSearchParameters":[{"type":"ServerMultiComplete","label":"Product code name(s)","name":"UCC_FARM_PRODUCT_ID","defaultValue":"","optionsSrc":"UCC_FARM_PRODUCT_V"},{"type":"MultiComplete","label":"Year or Range of Years","name":"YEAR_NUM","optionsSrc":"years","startYear":"1968","defaultValue":[],"preMergeOptions":[{"value":"ALL","label":"All"}]},{"type":"serverSelect","label":"State","name":"STATE","defaultValue":"MONTANA","optionsSrc":"STATE"},{"type":"ServerMultiComplete","label":"County","name":"COUNTY","defaultValue":[],"optionsSrc":"COUNTY","overrideSubOptionsSrcFromParameterName":"STATE"},{"type":"checkbox","name":"TIN_SEARCH_YN","defaultValue":false,"label":"Tax Identification Number Search"},{"type":"checkbox","name":"TIN_SORT_YN","defaultValue":false,"label":"Unique ID Sort"}]}],"SYSTEM_NICKNAME":"Online Services Portal","PAYMENT_METHODS":[{"type":"bypass"},{"type":"iTransact"}],"PAYMENT_ALLOW_AMEX":true,"SYSTEM_ID_LABEL":"System Id","DOUBLE_COLUMN_PUBLIC_LOGIN":true,"INTERNAL_USER_MANAGEMENT":true,"ALLOW_PUBLIC_JSON_IMPORT":false,"MAX_FILE_UPLOAD_SIZE":10000000,"REFUND_TEXT":"","RETURN_TO_HOME_ON_LOGOUT":true,"CURRENT_SOS_NAME":"Christi Jacobsen","LOGO_FILENAME":"mt-sos-logo.png","LOGO_ALT":"Christi Jacobsen, Montana Secretary of State","LOGO_FULL_WIDTH":true,"HOME_HIDE_AUTH_HINT":true,"HOME_TITLE":"Montana Secretary of State","CUSTOM_TAB_TITLE":"Official Montana","HOME_SUBTITLE":"Online Business Services","ENTITY_NAME_CONSENT_DESCRIPTION":"","ALLOW_USER_PROFILE_EDITING":true,"COMPARE_FOREIGN_NAME_IN_ENTITY_NAME_VALIDATION":true,"FOREIGN_NAME_FIELD_NAME":"KIMA_PARENT_NAME_INFO","LOGIN_TITLE":"Montana Secretary of State Online Filing Portal Login","PUBLIC_LOGIN_LABEL":"Username","REVERSE_LOGIN_COLUMNS":true,"LOGIN_SEAL_FILENAME":"seal_white.png","SEPARATE_USERNAME_AND_EMAIL":true,"CREATE_ACCOUNT_BUTTON_ALIGN_LEFT":true,"CREATE_ACCOUNT_BUTTON_TEXT":"CREATE AN ACCOUNT","PASSWORD_CUSTOM_ERROR_TEXT":"The password must meet all requirements","ACCOUNT_CREATED_MESSAGE":"Please check your email to verify your account to login and allow a few minutes for this message to arrive. Check your junk/spam folders if you do not find the email in your inbox.","PUBLIC_LOGIN_PLACEHOLDER":" ","DISABLE_DEFAULT_PAYMENT_RADIO":true,"CUSTOM_RESET_PASSWORD_ERROR_MESSAGE":"Username invalid - no account found","PUBLIC_LOGIN_CREATE_DESCRIPTION":"### Existing User:\n\n  - Enter your username and password to login.  \n\n\n  #### - OR -  \n\n\n\n  - Forgot password? Click 'Reset Password' and follow the prompts.\n  - Forgot username? Click 'Forgot Username' and follow the prompts.  \n\n\n  ### New User:\n  ","LOGIN_HELP_LINK":"https://sosmt.gov/business/how-do-i/","LOGIN_HELP_LINK_TEXT":"Need Help?","FORGOT_USERNAME_TEXT":"Forgot Username?","LOGIN_ACTIVE_DIRECTORY_TEXT":"State User Login","MULTIPLE_LOGIN_METHODS":true,"HAS_ACTIVE_DIRECTORY_LOGIN":true,"RESET_PASSWORD_WITH_USERNAME":true,"DOWNLOAD_LINK":true,"SHOW_USERNAME_ACCOUNT_CREATE":true,"SHOW_SCROLL_DOWN_ARROW":true,"SHOW_ADDRESS_ACCOUNT_CREATE":true,"TWO_COLUMN_ACCOUNT_CREATE":true,"RESET_PASSWORD_TIP":"A link to change your password has been sent to your email. Please allow a few minutes for this message to arrive. Please check your junk/spam folders if you do not find the email in your inbox.","FORGOT_PASSWORD_LINK_TEXT":"Reset Password","PHONE_NUMBER_OPTIONAL_ACCOUNT_CREATE":true,"SHOW_REQUIRED_INDICATOR_ACCOUNT_CREATE":true,"PASSWORD_REQUIREMENTS_ACCOUNT_CREATE":"\n    <ul>\n      <li>MUST contain at least 8 characters (12+ recommended)</li>\n      <li>MUST contain at least one uppercase letter.</li>\n      <li>MUST contain at least one lowercase letter.</li>\n      <li>MUST contain at least one number.</li>\n      <li>MUST contain at least one special character (!”#$%&'()*+,-./:;<=>?</li>\n    </ul>\n  ","ALLOW_CERTIFICATION_REQUEST":true,"ALLOW_PUBLIC_CERTIFICATE_REQUEST":true,"ALLOW_COPY_REQUEST":false,"ALLOW_CORRECTION_STYLING":true,"HIDE_DEPRECATION_WARNING":false,"AMEND_ROUTE_PUBLIC":true,"SEAL_FILENAME":"seal.png","SHOPPING_CART":true,"ALLOW_PAYMENT_UPDATE_WITH_EMPTY_CART":true,"RA_EMAIL":true,"RA_WEBSITE":true,"RA_NO_DEFAULT_TYPE":true,"RA_ADDRESS_LABEL":"Street Address","RA_TYPE_SELECTION_DEFAULT":true,"RA_DEFAULT_TYPE":"460","RA_OVERRIDE_TYPE_WITH_DEFAULT":true,"RA_PRINCIPAL_ADDRESS_AMS":true,"UPLOAD_AND_SUBMIT_HIDE_IF_ONE_OPTION":true,"PAYMENT_PROCESSING_MESSAGE":"Your payment is processing - Do not close your browser or click the back button","CHECKOUT_BUTTON_WHEN_PROCESSING_TEXT":"Processing","EFS_CROP_PICKER_NONE_LABEL":"Lien Duration","DISALLOWED_WIZARD_PIECES":["FormationLocale"],"REPEATER_SHOW_EDIT_BUTTON":true,"DATA_REQUEST_PAGE_TITLE":"Data Requests and Subscriptions","DATA_REQUEST_SIDEBAR_LABEL":"Data Requests & Subscriptions","LOGIN_REDIRECTS_TO_EPASS":false,"LOGIN_REDIRECTS_TO_ACTIVE_DIRECTORY":true,"LOGIN_ACTIVE_DIRECTORY_LINK":true,"FETCH_EDIT_USER_LINK":false,"LISTS_FETCH_AVAILABLE_LISTS":true,"POST_WIZARD_SUBMIT_REDIRECT_URL":"/","PIN_REQUEST_ATTESTATIONS":true,"PIN_REQUEST_DESCRIPTION":"Click **Request PIN** to have a new PIN sent to the account holder's email address on file.","OWNERSHIP_REQUEST_DESCRIPTION":"To become an **authorized user** of this record, a current **AUTHORIZED USER** will need to grant you access. To request access, click **Request Access** below.","PIN_REQUEST_SUCCESS_MESSAGE":"The PIN you have requested for this entity has been sent to the email associated with your user account.  You should receive the PIN in approximately 3-5 minutes, depending on your email service provider.","APOSTILLE_HEADER_LABEL":"Verification Information","APOSTILLE_NUMBER_LABEL":"Apostille/Authentication","APOSTILLE_CITY_STATE_OVERRIDE":"HELENA, MT","APOSTILLE_FILING_DATE_LABEL":"Issue Date","APOSTILLE_CITY_STATE_IN_CERTIFIED":true,"NOTARY_EXISTING_FILING":true,"ALLOW_REVOKE_OWN_ACCESS_ONLY":false,"HIDE_CANCEL_ON_ONETIME_DATA_REQUESTS":true,"DATA_REQUESTS_IN_SHOPPING_CART":true,"WQ_ALLOW_EDIT_PENDING_PAYMENT":true,"WQ_CONFIRM_ON_DELETE":true,"WQ_DELETE_CONFIRM_MESSAGE":"Deleting this filing will forfeit any money already paid to the Secretary of State. This action is permanent and cannot be undone, are you sure you would like to delete?","PASS_ITEM_GUIDS_ON_CHECKOUT":true,"FORM_REVISION_HISTORY":true,"CHECKOUT_DISCLAIMER":"By entering your credit card and/or checking account information you (i) state that **you are an authorized user** of the credit card and/or electronic check and that the associated information entered (e.g., account holder name, account number, billing address) is accurate, (ii) **you authorize payment processor to charge the amount you have requested** to your credit card and/or funding account, and (iii) **acknowledge if a charge is declined or reversed you may also be assessed a customary charge** by the payment processor for such transactions.","FARM_BILL_SEARCH_CONFIDENTIAL":"As a registered Farm Bill Buyer with the Montana Secretary of State’s office it is important to maintain the confidentiality of the information contained within the Farm Bill Master List. The Farm Bill Master List reflects personal data, such as Social Security Numbers, which are a key piece of personal identifiable information to assist you in determining the existence of a lien against a specific debtor. The distribution of this information beyond its intended purpose is strictly prohibited.\n\n**The debtor's tax identification number has been hidden for confidentiality reasons. You may continue to search on a tax ID number and return debtors that match your search criteria. The SSN/FEIN must be entered without dashes or spaces.  If you need access to the tax identification number to clearly identify the debtor, please contact the UCC unit at (406) 444-3665.**","VIEW_HISTORY_BUTTON_ALT_TEXT":"View Filings","WIZARD_ERROR_TITLE_MESSAGE":"Form Error","FARM_BILL_SEARCH_INTERACTIVE":true,"USE_FARM_BILL_API":true,"DISALLOW_ASSIGN_SELF_AS_RA":true,"DISALLOW_ASSIGN_SELF_AS_PRINCIPAL":true,"USE_TRADEMARK_OWNER_VALIDATION":true,"USE_ALTERNATIVE_FOREIGN_ADDRESS_LABELS":true,"MY_RECEIPTS_FILTER":[{"type":"dateRange","name":"DATE_RANGE","label":"Date range","defaultValue":{"start":null,"end":null}},{"type":"text","name":"REF_NUM","defaultValue":"","label":"Reference Number"},{"type":"text","name":"RECEIPT_NUM","defaultValue":"","label":"Receipt Id"},{"type":"text","name":"AMOUNT","defaultValue":"","label":"Amount"},{"type":"select","name":"TYPE","defaultValue":"","label":"Payment Type","options":[{"value":"","label":"All"},{"value":"CC","label":"Credit Card"},{"value":"Check","label":"Check"}]}],"MY_RECEIPTS_SHOW_IN_SIDEBAR":true,"SHOW_MY_RECEIPTS_HELPER_TEXT":true,"MY_RECEIPTS_HELPER_LABEL":"About Receipt Search","MY_RECEIPTS_HELPER_TEXT":"You can search for receipts based on their descriptions, including the items paid for on the receipt. Use the filters to search for or filter specific information.","FARM_BILL_SUBLINK":{"label":"Farm Bill","component":"FarmBill","parameter":"farm-bill","path":"/lists/farm-bill","sourceTypeId":0,"myRecordsSearch":false,"allowedRules":["/search/"],"disabled":true,"searchDescription":"To perform a search, enter a debtor name. Your search results may include: exact debtor name, variations of that name and any filing that includes your search criteria. Punctuation is ignored.\n\nYou can click on \"Advanced\" to refine your search. Under “Advanced” you can search by crop, year, county and SSN/FEIN. As a registered Farm Bill Buyer with the Montana Secretary of State’s office it is important to maintain the confidentiality of the information contained within the Farm Bill Master List. The Farm Bill Master List reflects personal data, such as Social Security Numbers, which are a key piece of personal identifiable information to assist you in determining the existence of a lien against a specific debtor. The distribution of this information beyond its intended purpose is strictly prohibited.\n\nThe debtor's tax identification number has been hidden for confidentiality reasons. You may continue to search on a tax ID number and return debtors that match your search criteria. The SSN/FEIN must be entered without dashes or spaces.","searchMustHaveOneOf":["search","UCC_FARM_PRODUCT_ID","COUNTY"],"searchPlaceholder":"Search by debtor name","advancedSearchParameters":[{"type":"ServerMultiComplete","label":"Product code name(s)","name":"UCC_FARM_PRODUCT_ID","defaultValue":"","optionsSrc":"UCC_FARM_PRODUCT_V"},{"type":"MultiComplete","label":"Year or Range of Years","name":"YEAR_NUM","optionsSrc":"years","startYear":"1968","defaultValue":[],"preMergeOptions":[{"value":"ALL","label":"All"}]},{"type":"serverSelect","label":"State","name":"STATE","defaultValue":"MONTANA","optionsSrc":"STATE"},{"type":"ServerMultiComplete","label":"County","name":"COUNTY","defaultValue":[],"optionsSrc":"COUNTY","overrideSubOptionsSrcFromParameterName":"STATE"},{"type":"checkbox","name":"TIN_SEARCH_YN","defaultValue":false,"label":"Tax Identification Number Search"},{"type":"checkbox","name":"TIN_SORT_YN","defaultValue":false,"label":"Unique ID Sort"}]},"ALLOW_ADDRESS_VALIDATION_BYPASS_OPTION":true,"DEFAULT_ADDRESS_VALIDATION_BYPASS_OPTION_CHECKED":true}).DATA_REQUEST_TOOLTIP;
	var DATA_REQUESTS_IN_SHOPPING_CART = (true);
	
	var DATA_REQUEST_PENDING_INVALID_STATUS = 1075;
	
	var STATUSES = {
	  1071: {
	    text: 'Active',
	    className: 'dr-active'
	  },
	  1072: {
	    text: 'Cancelled',
	    className: 'dr-cancelled'
	  },
	  1073: {
	    text: 'Cancelled - Failed Payment',
	    className: 'dr-failed'
	  },
	  1074: {
	    text: 'Complete',
	    className: 'dr-complete'
	  },
	  1077: {
	    text: 'Paused',
	    className: 'dr-paused'
	  }
	};
	
	var TYPES = {
	  1080: {
	    text: 'Existing',
	    className: 'existing',
	    icon: _database2.default
	  },
	  1081: {
	    text: 'current',
	    className: 'single',
	    icon: _database2.default
	  },
	  1082: {
	    text: 'reocurring',
	    className: 'subscription',
	    icon: _rss2.default
	  }
	};
	
	var getStatusById = function getStatusById(id) {
	  return STATUSES[id] || { className: '', text: '' };
	};
	var getTypeById = function getTypeById(id) {
	  return TYPES[id] || { className: '', text: '' };
	};
	
	exports.default = function (_ref) {
	  var NAME = _ref.NAME,
	      NAME_OVERRIDE = _ref.NAME_OVERRIDE,
	      STATUS_RO = _ref.STATUS_RO,
	      STATUS_ID = _ref.STATUS_ID,
	      DATA_REQUEST_TYPE_ID = _ref.DATA_REQUEST_TYPE_ID,
	      CREATED_DATE = _ref.CREATED_DATE,
	      onManageClicked = _ref.onManageClicked,
	      onDownloadsClicked = _ref.onDownloadsClicked,
	      onAddToCartClicked = _ref.onAddToCartClicked,
	      isActive = _ref.isActive,
	      checkoutOpen = _ref.checkoutOpen;
	
	  var _React$useState = _react2.default.useState(false),
	      _React$useState2 = _slicedToArray(_React$useState, 2),
	      checkoutPending = _React$useState2[0],
	      setCheckoutPending = _React$useState2[1];
	
	  var status = getStatusById(STATUS_ID);
	  var type = getTypeById(DATA_REQUEST_TYPE_ID);
	  var id = (0, _react.useRef)(_shortid2.default.generate());
	  var prevCheckoutOpen = (0, _hooks.usePrevious)(checkoutOpen);
	
	  var handleCartClicked = function handleCartClicked(e) {
	    setCheckoutPending(true);
	    onAddToCartClicked(e);
	  };
	
	  _react2.default.useEffect(function () {
	    if (prevCheckoutOpen === false && checkoutOpen === true) {
	      setCheckoutPending(false);
	    }
	  }, [checkoutOpen, prevCheckoutOpen]);
	
	  return _react2.default.createElement(
	    'li',
	    {
	      className: 'data-request-block ' + status.className + ' ' + type.className + ' ' + (isActive ? 'active' : '')
	    },
	    _react2.default.createElement(
	      'h1',
	      { className: 'dr-title-wrapper' },
	      _react2.default.createElement(
	        'span',
	        { className: 'dr-title' },
	        NAME_OVERRIDE || NAME
	      ),
	      _react2.default.createElement(
	        'span',
	        { className: 'dr-subtitle' },
	        type.icon ? _react2.default.createElement(type.icon, null) : null,
	        _react2.default.createElement(
	          'span',
	          { className: 'date' },
	          (0, _format2.default)(new Date(CREATED_DATE), 'MM/dd/yyyy'),
	          ' - '
	        ),
	        _react2.default.createElement(
	          'span',
	          { className: 'visually-hidden' },
	          'Status: '
	        ),
	        STATUS_RO
	      )
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'dr-buttons' },
	      STATUS_ID === DATA_REQUEST_PENDING_INVALID_STATUS && DATA_REQUESTS_IN_SHOPPING_CART ? _react2.default.createElement(
	        'button',
	        {
	          className: 'fixed cart-button',
	          'aria-label': 'Add request ' + NAME + ' to cart',
	          onClick: handleCartClicked,
	          'data-for': id.current,
	          'data-tip': "Add to Cart",
	          disabled: checkoutPending
	        },
	        checkoutPending && !checkoutOpen ? _react2.default.createElement(_Loaders.Spinner, { size: 'medium', themeColor: 'dark-neutral' }) : _react2.default.createElement(_cart2.default, null)
	      ) : null,
	      _react2.default.createElement(
	        'button',
	        {
	          className: 'fixed',
	          'aria-label': 'Manage data request for ' + NAME,
	          onClick: onManageClicked,
	          'data-for': id.current,
	          'data-tip': DATA_REQUEST_TOOLTIP || "View Details"
	        },
	        _react2.default.createElement(_gears2.default, null)
	      ),
	      _react2.default.createElement(_reactTooltip2.default, { effect: 'solid', id: id.current, delayShow: 1000 }),
	      _react2.default.createElement(
	        'button',
	        { 'aria-label': 'View downloads for ' + NAME, onClick: onDownloadsClicked },
	        'View Downloads'
	      )
	    )
	  );
	};

/***/ },
/* 1067 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(7);
	
	var _Shell = __webpack_require__(19);
	
	var _Modal = __webpack_require__(13);
	
	var _Portal = __webpack_require__(12);
	
	var _Portal2 = _interopRequireDefault(_Portal);
	
	var _Toolbar = __webpack_require__(304);
	
	var _Toolbar2 = _interopRequireDefault(_Toolbar);
	
	var _DataRequestBlock = __webpack_require__(1066);
	
	var _DataRequestBlock2 = _interopRequireDefault(_DataRequestBlock);
	
	var _ReportsList = __webpack_require__(300);
	
	var _ReportsList2 = _interopRequireDefault(_ReportsList);
	
	var _AmendmentLauncher = __webpack_require__(460);
	
	var _AmendmentLauncher2 = _interopRequireDefault(_AmendmentLauncher);
	
	var _store = __webpack_require__(18);
	
	var _Markdown = __webpack_require__(24);
	
	var _Markdown2 = _interopRequireDefault(_Markdown);
	
	var _requests = __webpack_require__(6);
	
	var _ManageDrawer = __webpack_require__(1068);
	
	var _ManageDrawer2 = _interopRequireDefault(_ManageDrawer);
	
	var _SlidingPanel = __webpack_require__(101);
	
	var _SlidingPanel2 = _interopRequireDefault(_SlidingPanel);
	
	var _Checkout = __webpack_require__(67);
	
	var _Checkout2 = _interopRequireDefault(_Checkout);
	
	var _actions = __webpack_require__(29);
	
	var _Loaders = __webpack_require__(16);
	
	var _utilities = __webpack_require__(8);
	
	__webpack_require__(1436);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var DATA_REQUEST_PAGE_TITLE = ("Data Requests and Subscriptions");
	var DATA_REQUEST_LABEL = ({"NODE_ENV":"production","BUILD_DATE":"2025-08-27T15:15:31.687Z","BUILD_NUMBER":"Not Provided","GIT_VERSION":"v1.3.0-381-ga81e29b08","GIT_COMMIT_HASH":"a81e29b085c9268ffd96c78eb734365802722741","GIT_BRANCH":"beta","PUBLIC_URL":"","STATE_ABBR":"MT","STATE_NAME":"Montana","STATE_ORG_TITLE":"Secretary of State","LOGIN_HEADER_IMG_PATH":"","HOME_IMG_FILENAME":"montana.jpg","FAVICON_FILE_NAME":"favicon.ico","ALLOW_E_SIGN_ON_CORRECTIONS":true,"THIRD_PARTY_SIGNING_ALLOWED":false,"MY_ACCOUNT_SAVE_AND_CLOSE_BUTTON":true,"IE_DEPRECATED_MESSAGE":"Internet Explorer is not supported. Please select a supported browser below to access this website.","ADDITIONAL_ROUTES":{"dataRequests":true,"farmBill":true,"apostille":true,"externalHelp":"https://sosmt.gov/business/help-center/","systemAdministration":[{"title":"Saved Payments","parameter":"saved-payments","componentName":"SavedPayments"}]},"SUBROUTES":[{"label":"Business","component":"Business","parameter":"business","myWorkQueueSearch":false,"sourceTypeId":54,"searchMustHaveOneOf":["FILING_TYPE_ID","STATUS_ID","STATE","search"],"serverWebSearchDescription":true,"serverWorkQueueDescription":true,"serverMyRecordsDescription":true,"searchPlaceholder":"Search by name or filing number (X########)","allowEmptySearchTerm":true,"requestCertificateAlternateLabel":"Request Information","fileAmendmentButtonLabel":"Filing Actions","advancedSearchParameters":[{"type":"radio","name":"QUERY_TYPE_ID","defaultValue":1010,"options":[{"value":1010,"label":"Starts with"},{"value":1011,"label":"Contains"},{"value":1012,"label":" Word Contains"}]},{"type":"serverSelect","name":"FILING_TYPE_ID","optionsSrc":"FILING_TYPES","label":"Entity Type","placeholder":"All","defaultValue":"0"},{"type":"serverSelect","name":"FILING_SUBTYPE_ID","optionsSrc":"FILING_SUBTYPES","label":"Entity Subtype","overrideSubOptionsSrcFromParameterName":"FILING_TYPE_ID","placeholder":"All","defaultValue":"0"},{"type":"serverSelect","name":"STATUS_ID","optionsSrc":"FILING_STATUS_WITHOUT_ALL","label":"Status","placeholder":"All","defaultValue":"0"},{"type":"serverSelect","name":"STATE","optionsSrc":"STATE","label":"State","placeholder":"All","defaultValue":""},{"type":"serverSelect","name":"COUNTY","optionsSrc":"COUNTY_SUBOPTION","label":"County","overrideSubOptionsSrcFromParameterName":"STATE","placeholder":"All","defaultValue":""},{"type":"checkbox","name":"CRA_SEARCH_YN","defaultValue":false,"label":"Search by Registered Agent PID"},{"type":"dateRange","name":"FILING_DATE","label":"Registration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}},{"type":"dateRange","name":"EXPIRATION_DATE","label":"Expiration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}}],"myRecordsFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Active"},{"value":2,"label":"Inactive"},{"value":3,"label":"Pending"}]},{"type":"dateRange","name":"DATE_RANGE","label":"Date range","defaultValue":{"start":null,"end":null}}],"myWorkQueueFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Approved"},{"value":2,"label":"Pending Online Payment"},{"value":3,"label":"Pending Review"},{"value":4,"label":"Needs Correction"},{"value":5,"label":"Rejected"},{"value":6,"label":"Draft"}]},{"type":"dateRange","name":"DATE_RANGE","label":"Date range","defaultValue":{"start":null,"end":null}}]},{"label":"Notary","component":"Notary","parameter":"notary","sourceTypeId":850,"myWorkQueueSearch":false,"allowEmptySearchTerm":true,"requestCertificateAlternateLabel":"Download Certificate","fileAmendmentButtonLabel":"Filing Actions","hideNameRequestCertificate":true,"hideAddressRequestCertificate":true,"hideRecordUserManagment":true,"searchPlaceholder":"Search by name or commission number","searchMustHaveOneOf":["CITY","search","SERVICE_TYPE"],"advancedParametersStartOpen":true,"searchIsSortable":true,"advancedSearchParameters":[{"type":"radio","name":"STARTS_WITH_YN","defaultValue":false,"options":[{"value":true,"label":"Starts with"},{"value":false,"label":"Contains"}]},{"type":"checkbox","name":"ACTIVE_ONLY_YN","defaultValue":true,"label":"Active entities only"},{"type":"text","name":"CITY","defaultValue":"","label":"City"},{"type":"select","name":"SERVICE_TYPE","label":"Special Services Offered","defaultValue":0,"options":[{"value":0,"label":"(N/A)"},{"value":6165,"label":"In-Person Electronic Notarization (IPEN)"},{"value":6166,"label":"Remote Online Notarization (RON)"},{"value":6167,"label":"Mobile Notary Services"},{"value":6168,"label":"Remote Ink Notarization (RIN)"}]}]},{"label":"Apostille","component":"Apostille","parameter":"apostille","sourceTypeId":720,"myRecordsSearch":false,"myWorkQueueSearch":false,"disabled":false,"allowedRoutes":["/forms-manager/","/queue/","/forms/"]},{"label":"Liens","component":"UCC","parameter":"ucc","sourceTypeId":1999,"myRecordsSearch":true,"myWorkQueueSearch":true,"fileAmendmentButtonLabel":"Filing Actions","searchPlaceholder":"Search by name or file number","disabled":false,"serverWebSearchDescription":true,"myRecordsDescription":"","workQueueDescription":"","searchDescription":"","hideRecordUserManagment":true,"searchLiensCheckout":false,"advancedSearchParameters":[{"type":"radio","name":"STARTS_WITH_YN","defaultValue":false,"options":[{"value":true,"label":"Starts with"},{"value":false,"label":"Contains"}]},{"type":"select","name":"STATUS","defaultValue":"ALL","label":"Status","options":[{"value":"ACTIVE_UNLAPSED","label":"Active (unlapsed)"},{"value":"ACTIVE_LAPSED_UNLAPSED","label":"Active (lapsed and unlapsed)"}]},{"type":"text","name":"EXCLUDE_VALUES","label":"Exclude Debtor Names (comma separated list of names to exclude)","defaultValue":""},{"type":"dateRange","name":"FILING_DATE","label":"Financing Statement Date","defaultValue":{"start":null,"end":null}},{"type":"dateRange","name":"LAPSE_DATE","label":"Lapse Date","defaultValue":{"start":null,"end":null}},{"type":"text","name":"CITY","label":"Debtor City","defaultValue":""}],"myRecordsFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Approved"},{"value":2,"label":"Pending Online Payment"},{"value":3,"label":"Pending Review"}]},{"type":"select","name":"TYPE","defaultValue":0,"label":"Lien Type","options":[{"value":0,"label":"All"},{"value":1,"label":"UCC"},{"value":2,"label":"EFS"},{"value":3,"label":"Title 71"}]}],"myWorkQueueFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Approved"},{"value":2,"label":"Pending Online Payment"},{"value":3,"label":"Pending Review"},{"value":4,"label":"Pending Print and Mail"},{"value":5,"label":"Rejected"},{"value":6,"label":"Draft"}]},{"type":"select","name":"TYPE","defaultValue":0,"label":"Lien Type","options":[{"value":0,"label":"All"},{"value":1,"label":"UCC"},{"value":2,"label":"EFS"},{"value":3,"label":"Title 71"}]}]},{"label":"Copy Request","component":"copies","parameter":"copies","sourceTypeId":2001,"myRecordsSearch":false,"myWorkQueueSearch":false,"disabled":false,"allowedRoutes":["/forms-manager/","/queue/","/forms/"]},{"label":"Trademark","component":"Trademark","parameter":"trademark","sourceTypeId":810,"showRequestCertificate":true,"searchMustHaveOneOf":["search","EXPIRATION_DATE","FILING_DATE"],"allowEmptySearchTerm":true,"requestCertificateAlternateLabel":"Request Information","fileAmendmentButtonLabel":"Filing Actions","advancedSearchParameters":[{"type":"radio","name":"QUERY_TYPE_ID","defaultValue":1010,"options":[{"value":1010,"label":"Starts with"},{"value":1011,"label":"Contains"},{"value":1012,"label":" Word Contains"}]},{"type":"checkbox","name":"OWNER_SEARCH_YN","defaultValue":false,"label":"Search owners"},{"type":"radio","name":"SERVICE_MARK_YN","label":"Mark Type","defaultValue":"","options":[{"value":"","label":"All Marks"},{"value":"Y","label":"Service Mark"},{"value":"N","label":"Trademark"}]},{"type":"serverSelect","name":"STATUS_ID","optionsSrc":"TYPE_V|TRADEMARK_STATUS_TYPE","label":"Status","placeholder":"All","defaultValue":"0"},{"type":"select","name":"DESIGN_TYPE_ID","options":[{"value":0,"label":"All"},{"value":990,"label":"Words Only"},{"value":991,"label":"Design Only"},{"value":992,"label":"Words and Design"}],"label":"Design Type","defaultValue":"0"},{"type":"dateRange","name":"FILING_DATE","label":"Registered Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}},{"type":"dateRange","name":"EXPIRATION_DATE","label":"Expiration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}}]},{"label":"Business Info Request","component":"InfoRequests","parameter":"info-request","sourceTypeId":167,"allowedRoutes":["/forms-manager/","/queue/","/forms/"]},{"label":"Data Requests","component":"DataRequests","parameter":"data-request","sourceTypeId":0,"allowedRoutes":["/forms-manager/"]},{"label":"CRA","component":"CRA","parameter":"cra","sourceTypeId":157,"myRecordsSearch":false,"searchPlaceholder":"Search by name or registered agent number","allowedRoutes":["/forms-manager/","/forms/","/records/","/queue/","/search/"],"allowEmptySearchTerm":true,"fileAmendmentButtonLabel":"Filing Actions","advancedSearchParameters":[{"type":"radio","name":"QUERY_TYPE_ID","defaultValue":1010,"options":[{"value":1010,"label":"Starts with"},{"value":1011,"label":"Contains"},{"value":1012,"label":" Word Contains"}]},{"type":"dateRange","name":"CRA_DATE","label":"Registration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}},{"type":"select","name":"STATUS_ID","label":"Status","defaultValue":0,"options":[{"value":0,"label":"All"},{"value":121,"label":"Active"},{"value":122,"label":"Inactive"}]},{"type":"select","name":"AGENT_TYPE_ID","label":"Agent Type","defaultValue":0,"options":[{"value":0,"label":"All"},{"value":460,"label":"Registered Agent"},{"value":461,"label":"Commercial Registered Agent"}]}]},{"label":"Farm Bill","component":"FarmBill","parameter":"farm-bill","path":"/lists/farm-bill","sourceTypeId":0,"myRecordsSearch":false,"allowedRules":["/search/"],"disabled":true,"searchDescription":"To perform a search, enter a debtor name. Your search results may include: exact debtor name, variations of that name and any filing that includes your search criteria. Punctuation is ignored.\n\nYou can click on \"Advanced\" to refine your search. Under “Advanced” you can search by crop, year, county and SSN/FEIN. As a registered Farm Bill Buyer with the Montana Secretary of State’s office it is important to maintain the confidentiality of the information contained within the Farm Bill Master List. The Farm Bill Master List reflects personal data, such as Social Security Numbers, which are a key piece of personal identifiable information to assist you in determining the existence of a lien against a specific debtor. The distribution of this information beyond its intended purpose is strictly prohibited.\n\nThe debtor's tax identification number has been hidden for confidentiality reasons. You may continue to search on a tax ID number and return debtors that match your search criteria. The SSN/FEIN must be entered without dashes or spaces.","searchMustHaveOneOf":["search","UCC_FARM_PRODUCT_ID","COUNTY"],"searchPlaceholder":"Search by debtor name","advancedSearchParameters":[{"type":"ServerMultiComplete","label":"Product code name(s)","name":"UCC_FARM_PRODUCT_ID","defaultValue":"","optionsSrc":"UCC_FARM_PRODUCT_V"},{"type":"MultiComplete","label":"Year or Range of Years","name":"YEAR_NUM","optionsSrc":"years","startYear":"1968","defaultValue":[],"preMergeOptions":[{"value":"ALL","label":"All"}]},{"type":"serverSelect","label":"State","name":"STATE","defaultValue":"MONTANA","optionsSrc":"STATE"},{"type":"ServerMultiComplete","label":"County","name":"COUNTY","defaultValue":[],"optionsSrc":"COUNTY","overrideSubOptionsSrcFromParameterName":"STATE"},{"type":"checkbox","name":"TIN_SEARCH_YN","defaultValue":false,"label":"Tax Identification Number Search"},{"type":"checkbox","name":"TIN_SORT_YN","defaultValue":false,"label":"Unique ID Sort"}]}],"SYSTEM_NICKNAME":"Online Services Portal","PAYMENT_METHODS":[{"type":"bypass"},{"type":"iTransact"}],"PAYMENT_ALLOW_AMEX":true,"SYSTEM_ID_LABEL":"System Id","DOUBLE_COLUMN_PUBLIC_LOGIN":true,"INTERNAL_USER_MANAGEMENT":true,"ALLOW_PUBLIC_JSON_IMPORT":false,"MAX_FILE_UPLOAD_SIZE":10000000,"REFUND_TEXT":"","RETURN_TO_HOME_ON_LOGOUT":true,"CURRENT_SOS_NAME":"Christi Jacobsen","LOGO_FILENAME":"mt-sos-logo.png","LOGO_ALT":"Christi Jacobsen, Montana Secretary of State","LOGO_FULL_WIDTH":true,"HOME_HIDE_AUTH_HINT":true,"HOME_TITLE":"Montana Secretary of State","CUSTOM_TAB_TITLE":"Official Montana","HOME_SUBTITLE":"Online Business Services","ENTITY_NAME_CONSENT_DESCRIPTION":"","ALLOW_USER_PROFILE_EDITING":true,"COMPARE_FOREIGN_NAME_IN_ENTITY_NAME_VALIDATION":true,"FOREIGN_NAME_FIELD_NAME":"KIMA_PARENT_NAME_INFO","LOGIN_TITLE":"Montana Secretary of State Online Filing Portal Login","PUBLIC_LOGIN_LABEL":"Username","REVERSE_LOGIN_COLUMNS":true,"LOGIN_SEAL_FILENAME":"seal_white.png","SEPARATE_USERNAME_AND_EMAIL":true,"CREATE_ACCOUNT_BUTTON_ALIGN_LEFT":true,"CREATE_ACCOUNT_BUTTON_TEXT":"CREATE AN ACCOUNT","PASSWORD_CUSTOM_ERROR_TEXT":"The password must meet all requirements","ACCOUNT_CREATED_MESSAGE":"Please check your email to verify your account to login and allow a few minutes for this message to arrive. Check your junk/spam folders if you do not find the email in your inbox.","PUBLIC_LOGIN_PLACEHOLDER":" ","DISABLE_DEFAULT_PAYMENT_RADIO":true,"CUSTOM_RESET_PASSWORD_ERROR_MESSAGE":"Username invalid - no account found","PUBLIC_LOGIN_CREATE_DESCRIPTION":"### Existing User:\n\n  - Enter your username and password to login.  \n\n\n  #### - OR -  \n\n\n\n  - Forgot password? Click 'Reset Password' and follow the prompts.\n  - Forgot username? Click 'Forgot Username' and follow the prompts.  \n\n\n  ### New User:\n  ","LOGIN_HELP_LINK":"https://sosmt.gov/business/how-do-i/","LOGIN_HELP_LINK_TEXT":"Need Help?","FORGOT_USERNAME_TEXT":"Forgot Username?","LOGIN_ACTIVE_DIRECTORY_TEXT":"State User Login","MULTIPLE_LOGIN_METHODS":true,"HAS_ACTIVE_DIRECTORY_LOGIN":true,"RESET_PASSWORD_WITH_USERNAME":true,"DOWNLOAD_LINK":true,"SHOW_USERNAME_ACCOUNT_CREATE":true,"SHOW_SCROLL_DOWN_ARROW":true,"SHOW_ADDRESS_ACCOUNT_CREATE":true,"TWO_COLUMN_ACCOUNT_CREATE":true,"RESET_PASSWORD_TIP":"A link to change your password has been sent to your email. Please allow a few minutes for this message to arrive. Please check your junk/spam folders if you do not find the email in your inbox.","FORGOT_PASSWORD_LINK_TEXT":"Reset Password","PHONE_NUMBER_OPTIONAL_ACCOUNT_CREATE":true,"SHOW_REQUIRED_INDICATOR_ACCOUNT_CREATE":true,"PASSWORD_REQUIREMENTS_ACCOUNT_CREATE":"\n    <ul>\n      <li>MUST contain at least 8 characters (12+ recommended)</li>\n      <li>MUST contain at least one uppercase letter.</li>\n      <li>MUST contain at least one lowercase letter.</li>\n      <li>MUST contain at least one number.</li>\n      <li>MUST contain at least one special character (!”#$%&'()*+,-./:;<=>?</li>\n    </ul>\n  ","ALLOW_CERTIFICATION_REQUEST":true,"ALLOW_PUBLIC_CERTIFICATE_REQUEST":true,"ALLOW_COPY_REQUEST":false,"ALLOW_CORRECTION_STYLING":true,"HIDE_DEPRECATION_WARNING":false,"AMEND_ROUTE_PUBLIC":true,"SEAL_FILENAME":"seal.png","SHOPPING_CART":true,"ALLOW_PAYMENT_UPDATE_WITH_EMPTY_CART":true,"RA_EMAIL":true,"RA_WEBSITE":true,"RA_NO_DEFAULT_TYPE":true,"RA_ADDRESS_LABEL":"Street Address","RA_TYPE_SELECTION_DEFAULT":true,"RA_DEFAULT_TYPE":"460","RA_OVERRIDE_TYPE_WITH_DEFAULT":true,"RA_PRINCIPAL_ADDRESS_AMS":true,"UPLOAD_AND_SUBMIT_HIDE_IF_ONE_OPTION":true,"PAYMENT_PROCESSING_MESSAGE":"Your payment is processing - Do not close your browser or click the back button","CHECKOUT_BUTTON_WHEN_PROCESSING_TEXT":"Processing","EFS_CROP_PICKER_NONE_LABEL":"Lien Duration","DISALLOWED_WIZARD_PIECES":["FormationLocale"],"REPEATER_SHOW_EDIT_BUTTON":true,"DATA_REQUEST_PAGE_TITLE":"Data Requests and Subscriptions","DATA_REQUEST_SIDEBAR_LABEL":"Data Requests & Subscriptions","LOGIN_REDIRECTS_TO_EPASS":false,"LOGIN_REDIRECTS_TO_ACTIVE_DIRECTORY":true,"LOGIN_ACTIVE_DIRECTORY_LINK":true,"FETCH_EDIT_USER_LINK":false,"LISTS_FETCH_AVAILABLE_LISTS":true,"POST_WIZARD_SUBMIT_REDIRECT_URL":"/","PIN_REQUEST_ATTESTATIONS":true,"PIN_REQUEST_DESCRIPTION":"Click **Request PIN** to have a new PIN sent to the account holder's email address on file.","OWNERSHIP_REQUEST_DESCRIPTION":"To become an **authorized user** of this record, a current **AUTHORIZED USER** will need to grant you access. To request access, click **Request Access** below.","PIN_REQUEST_SUCCESS_MESSAGE":"The PIN you have requested for this entity has been sent to the email associated with your user account.  You should receive the PIN in approximately 3-5 minutes, depending on your email service provider.","APOSTILLE_HEADER_LABEL":"Verification Information","APOSTILLE_NUMBER_LABEL":"Apostille/Authentication","APOSTILLE_CITY_STATE_OVERRIDE":"HELENA, MT","APOSTILLE_FILING_DATE_LABEL":"Issue Date","APOSTILLE_CITY_STATE_IN_CERTIFIED":true,"NOTARY_EXISTING_FILING":true,"ALLOW_REVOKE_OWN_ACCESS_ONLY":false,"HIDE_CANCEL_ON_ONETIME_DATA_REQUESTS":true,"DATA_REQUESTS_IN_SHOPPING_CART":true,"WQ_ALLOW_EDIT_PENDING_PAYMENT":true,"WQ_CONFIRM_ON_DELETE":true,"WQ_DELETE_CONFIRM_MESSAGE":"Deleting this filing will forfeit any money already paid to the Secretary of State. This action is permanent and cannot be undone, are you sure you would like to delete?","PASS_ITEM_GUIDS_ON_CHECKOUT":true,"FORM_REVISION_HISTORY":true,"CHECKOUT_DISCLAIMER":"By entering your credit card and/or checking account information you (i) state that **you are an authorized user** of the credit card and/or electronic check and that the associated information entered (e.g., account holder name, account number, billing address) is accurate, (ii) **you authorize payment processor to charge the amount you have requested** to your credit card and/or funding account, and (iii) **acknowledge if a charge is declined or reversed you may also be assessed a customary charge** by the payment processor for such transactions.","FARM_BILL_SEARCH_CONFIDENTIAL":"As a registered Farm Bill Buyer with the Montana Secretary of State’s office it is important to maintain the confidentiality of the information contained within the Farm Bill Master List. The Farm Bill Master List reflects personal data, such as Social Security Numbers, which are a key piece of personal identifiable information to assist you in determining the existence of a lien against a specific debtor. The distribution of this information beyond its intended purpose is strictly prohibited.\n\n**The debtor's tax identification number has been hidden for confidentiality reasons. You may continue to search on a tax ID number and return debtors that match your search criteria. The SSN/FEIN must be entered without dashes or spaces.  If you need access to the tax identification number to clearly identify the debtor, please contact the UCC unit at (406) 444-3665.**","VIEW_HISTORY_BUTTON_ALT_TEXT":"View Filings","WIZARD_ERROR_TITLE_MESSAGE":"Form Error","FARM_BILL_SEARCH_INTERACTIVE":true,"USE_FARM_BILL_API":true,"DISALLOW_ASSIGN_SELF_AS_RA":true,"DISALLOW_ASSIGN_SELF_AS_PRINCIPAL":true,"USE_TRADEMARK_OWNER_VALIDATION":true,"USE_ALTERNATIVE_FOREIGN_ADDRESS_LABELS":true,"MY_RECEIPTS_FILTER":[{"type":"dateRange","name":"DATE_RANGE","label":"Date range","defaultValue":{"start":null,"end":null}},{"type":"text","name":"REF_NUM","defaultValue":"","label":"Reference Number"},{"type":"text","name":"RECEIPT_NUM","defaultValue":"","label":"Receipt Id"},{"type":"text","name":"AMOUNT","defaultValue":"","label":"Amount"},{"type":"select","name":"TYPE","defaultValue":"","label":"Payment Type","options":[{"value":"","label":"All"},{"value":"CC","label":"Credit Card"},{"value":"Check","label":"Check"}]}],"MY_RECEIPTS_SHOW_IN_SIDEBAR":true,"SHOW_MY_RECEIPTS_HELPER_TEXT":true,"MY_RECEIPTS_HELPER_LABEL":"About Receipt Search","MY_RECEIPTS_HELPER_TEXT":"You can search for receipts based on their descriptions, including the items paid for on the receipt. Use the filters to search for or filter specific information.","FARM_BILL_SUBLINK":{"label":"Farm Bill","component":"FarmBill","parameter":"farm-bill","path":"/lists/farm-bill","sourceTypeId":0,"myRecordsSearch":false,"allowedRules":["/search/"],"disabled":true,"searchDescription":"To perform a search, enter a debtor name. Your search results may include: exact debtor name, variations of that name and any filing that includes your search criteria. Punctuation is ignored.\n\nYou can click on \"Advanced\" to refine your search. Under “Advanced” you can search by crop, year, county and SSN/FEIN. As a registered Farm Bill Buyer with the Montana Secretary of State’s office it is important to maintain the confidentiality of the information contained within the Farm Bill Master List. The Farm Bill Master List reflects personal data, such as Social Security Numbers, which are a key piece of personal identifiable information to assist you in determining the existence of a lien against a specific debtor. The distribution of this information beyond its intended purpose is strictly prohibited.\n\nThe debtor's tax identification number has been hidden for confidentiality reasons. You may continue to search on a tax ID number and return debtors that match your search criteria. The SSN/FEIN must be entered without dashes or spaces.","searchMustHaveOneOf":["search","UCC_FARM_PRODUCT_ID","COUNTY"],"searchPlaceholder":"Search by debtor name","advancedSearchParameters":[{"type":"ServerMultiComplete","label":"Product code name(s)","name":"UCC_FARM_PRODUCT_ID","defaultValue":"","optionsSrc":"UCC_FARM_PRODUCT_V"},{"type":"MultiComplete","label":"Year or Range of Years","name":"YEAR_NUM","optionsSrc":"years","startYear":"1968","defaultValue":[],"preMergeOptions":[{"value":"ALL","label":"All"}]},{"type":"serverSelect","label":"State","name":"STATE","defaultValue":"MONTANA","optionsSrc":"STATE"},{"type":"ServerMultiComplete","label":"County","name":"COUNTY","defaultValue":[],"optionsSrc":"COUNTY","overrideSubOptionsSrcFromParameterName":"STATE"},{"type":"checkbox","name":"TIN_SEARCH_YN","defaultValue":false,"label":"Tax Identification Number Search"},{"type":"checkbox","name":"TIN_SORT_YN","defaultValue":false,"label":"Unique ID Sort"}]},"ALLOW_ADDRESS_VALIDATION_BYPASS_OPTION":true,"DEFAULT_ADDRESS_VALIDATION_BYPASS_OPTION_CHECKED":true}).DATA_REQUEST_LABEL;
	var DATA_REQUEST_DESCRIPTION = ({"NODE_ENV":"production","BUILD_DATE":"2025-08-27T15:15:31.687Z","BUILD_NUMBER":"Not Provided","GIT_VERSION":"v1.3.0-381-ga81e29b08","GIT_COMMIT_HASH":"a81e29b085c9268ffd96c78eb734365802722741","GIT_BRANCH":"beta","PUBLIC_URL":"","STATE_ABBR":"MT","STATE_NAME":"Montana","STATE_ORG_TITLE":"Secretary of State","LOGIN_HEADER_IMG_PATH":"","HOME_IMG_FILENAME":"montana.jpg","FAVICON_FILE_NAME":"favicon.ico","ALLOW_E_SIGN_ON_CORRECTIONS":true,"THIRD_PARTY_SIGNING_ALLOWED":false,"MY_ACCOUNT_SAVE_AND_CLOSE_BUTTON":true,"IE_DEPRECATED_MESSAGE":"Internet Explorer is not supported. Please select a supported browser below to access this website.","ADDITIONAL_ROUTES":{"dataRequests":true,"farmBill":true,"apostille":true,"externalHelp":"https://sosmt.gov/business/help-center/","systemAdministration":[{"title":"Saved Payments","parameter":"saved-payments","componentName":"SavedPayments"}]},"SUBROUTES":[{"label":"Business","component":"Business","parameter":"business","myWorkQueueSearch":false,"sourceTypeId":54,"searchMustHaveOneOf":["FILING_TYPE_ID","STATUS_ID","STATE","search"],"serverWebSearchDescription":true,"serverWorkQueueDescription":true,"serverMyRecordsDescription":true,"searchPlaceholder":"Search by name or filing number (X########)","allowEmptySearchTerm":true,"requestCertificateAlternateLabel":"Request Information","fileAmendmentButtonLabel":"Filing Actions","advancedSearchParameters":[{"type":"radio","name":"QUERY_TYPE_ID","defaultValue":1010,"options":[{"value":1010,"label":"Starts with"},{"value":1011,"label":"Contains"},{"value":1012,"label":" Word Contains"}]},{"type":"serverSelect","name":"FILING_TYPE_ID","optionsSrc":"FILING_TYPES","label":"Entity Type","placeholder":"All","defaultValue":"0"},{"type":"serverSelect","name":"FILING_SUBTYPE_ID","optionsSrc":"FILING_SUBTYPES","label":"Entity Subtype","overrideSubOptionsSrcFromParameterName":"FILING_TYPE_ID","placeholder":"All","defaultValue":"0"},{"type":"serverSelect","name":"STATUS_ID","optionsSrc":"FILING_STATUS_WITHOUT_ALL","label":"Status","placeholder":"All","defaultValue":"0"},{"type":"serverSelect","name":"STATE","optionsSrc":"STATE","label":"State","placeholder":"All","defaultValue":""},{"type":"serverSelect","name":"COUNTY","optionsSrc":"COUNTY_SUBOPTION","label":"County","overrideSubOptionsSrcFromParameterName":"STATE","placeholder":"All","defaultValue":""},{"type":"checkbox","name":"CRA_SEARCH_YN","defaultValue":false,"label":"Search by Registered Agent PID"},{"type":"dateRange","name":"FILING_DATE","label":"Registration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}},{"type":"dateRange","name":"EXPIRATION_DATE","label":"Expiration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}}],"myRecordsFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Active"},{"value":2,"label":"Inactive"},{"value":3,"label":"Pending"}]},{"type":"dateRange","name":"DATE_RANGE","label":"Date range","defaultValue":{"start":null,"end":null}}],"myWorkQueueFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Approved"},{"value":2,"label":"Pending Online Payment"},{"value":3,"label":"Pending Review"},{"value":4,"label":"Needs Correction"},{"value":5,"label":"Rejected"},{"value":6,"label":"Draft"}]},{"type":"dateRange","name":"DATE_RANGE","label":"Date range","defaultValue":{"start":null,"end":null}}]},{"label":"Notary","component":"Notary","parameter":"notary","sourceTypeId":850,"myWorkQueueSearch":false,"allowEmptySearchTerm":true,"requestCertificateAlternateLabel":"Download Certificate","fileAmendmentButtonLabel":"Filing Actions","hideNameRequestCertificate":true,"hideAddressRequestCertificate":true,"hideRecordUserManagment":true,"searchPlaceholder":"Search by name or commission number","searchMustHaveOneOf":["CITY","search","SERVICE_TYPE"],"advancedParametersStartOpen":true,"searchIsSortable":true,"advancedSearchParameters":[{"type":"radio","name":"STARTS_WITH_YN","defaultValue":false,"options":[{"value":true,"label":"Starts with"},{"value":false,"label":"Contains"}]},{"type":"checkbox","name":"ACTIVE_ONLY_YN","defaultValue":true,"label":"Active entities only"},{"type":"text","name":"CITY","defaultValue":"","label":"City"},{"type":"select","name":"SERVICE_TYPE","label":"Special Services Offered","defaultValue":0,"options":[{"value":0,"label":"(N/A)"},{"value":6165,"label":"In-Person Electronic Notarization (IPEN)"},{"value":6166,"label":"Remote Online Notarization (RON)"},{"value":6167,"label":"Mobile Notary Services"},{"value":6168,"label":"Remote Ink Notarization (RIN)"}]}]},{"label":"Apostille","component":"Apostille","parameter":"apostille","sourceTypeId":720,"myRecordsSearch":false,"myWorkQueueSearch":false,"disabled":false,"allowedRoutes":["/forms-manager/","/queue/","/forms/"]},{"label":"Liens","component":"UCC","parameter":"ucc","sourceTypeId":1999,"myRecordsSearch":true,"myWorkQueueSearch":true,"fileAmendmentButtonLabel":"Filing Actions","searchPlaceholder":"Search by name or file number","disabled":false,"serverWebSearchDescription":true,"myRecordsDescription":"","workQueueDescription":"","searchDescription":"","hideRecordUserManagment":true,"searchLiensCheckout":false,"advancedSearchParameters":[{"type":"radio","name":"STARTS_WITH_YN","defaultValue":false,"options":[{"value":true,"label":"Starts with"},{"value":false,"label":"Contains"}]},{"type":"select","name":"STATUS","defaultValue":"ALL","label":"Status","options":[{"value":"ACTIVE_UNLAPSED","label":"Active (unlapsed)"},{"value":"ACTIVE_LAPSED_UNLAPSED","label":"Active (lapsed and unlapsed)"}]},{"type":"text","name":"EXCLUDE_VALUES","label":"Exclude Debtor Names (comma separated list of names to exclude)","defaultValue":""},{"type":"dateRange","name":"FILING_DATE","label":"Financing Statement Date","defaultValue":{"start":null,"end":null}},{"type":"dateRange","name":"LAPSE_DATE","label":"Lapse Date","defaultValue":{"start":null,"end":null}},{"type":"text","name":"CITY","label":"Debtor City","defaultValue":""}],"myRecordsFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Approved"},{"value":2,"label":"Pending Online Payment"},{"value":3,"label":"Pending Review"}]},{"type":"select","name":"TYPE","defaultValue":0,"label":"Lien Type","options":[{"value":0,"label":"All"},{"value":1,"label":"UCC"},{"value":2,"label":"EFS"},{"value":3,"label":"Title 71"}]}],"myWorkQueueFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Approved"},{"value":2,"label":"Pending Online Payment"},{"value":3,"label":"Pending Review"},{"value":4,"label":"Pending Print and Mail"},{"value":5,"label":"Rejected"},{"value":6,"label":"Draft"}]},{"type":"select","name":"TYPE","defaultValue":0,"label":"Lien Type","options":[{"value":0,"label":"All"},{"value":1,"label":"UCC"},{"value":2,"label":"EFS"},{"value":3,"label":"Title 71"}]}]},{"label":"Copy Request","component":"copies","parameter":"copies","sourceTypeId":2001,"myRecordsSearch":false,"myWorkQueueSearch":false,"disabled":false,"allowedRoutes":["/forms-manager/","/queue/","/forms/"]},{"label":"Trademark","component":"Trademark","parameter":"trademark","sourceTypeId":810,"showRequestCertificate":true,"searchMustHaveOneOf":["search","EXPIRATION_DATE","FILING_DATE"],"allowEmptySearchTerm":true,"requestCertificateAlternateLabel":"Request Information","fileAmendmentButtonLabel":"Filing Actions","advancedSearchParameters":[{"type":"radio","name":"QUERY_TYPE_ID","defaultValue":1010,"options":[{"value":1010,"label":"Starts with"},{"value":1011,"label":"Contains"},{"value":1012,"label":" Word Contains"}]},{"type":"checkbox","name":"OWNER_SEARCH_YN","defaultValue":false,"label":"Search owners"},{"type":"radio","name":"SERVICE_MARK_YN","label":"Mark Type","defaultValue":"","options":[{"value":"","label":"All Marks"},{"value":"Y","label":"Service Mark"},{"value":"N","label":"Trademark"}]},{"type":"serverSelect","name":"STATUS_ID","optionsSrc":"TYPE_V|TRADEMARK_STATUS_TYPE","label":"Status","placeholder":"All","defaultValue":"0"},{"type":"select","name":"DESIGN_TYPE_ID","options":[{"value":0,"label":"All"},{"value":990,"label":"Words Only"},{"value":991,"label":"Design Only"},{"value":992,"label":"Words and Design"}],"label":"Design Type","defaultValue":"0"},{"type":"dateRange","name":"FILING_DATE","label":"Registered Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}},{"type":"dateRange","name":"EXPIRATION_DATE","label":"Expiration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}}]},{"label":"Business Info Request","component":"InfoRequests","parameter":"info-request","sourceTypeId":167,"allowedRoutes":["/forms-manager/","/queue/","/forms/"]},{"label":"Data Requests","component":"DataRequests","parameter":"data-request","sourceTypeId":0,"allowedRoutes":["/forms-manager/"]},{"label":"CRA","component":"CRA","parameter":"cra","sourceTypeId":157,"myRecordsSearch":false,"searchPlaceholder":"Search by name or registered agent number","allowedRoutes":["/forms-manager/","/forms/","/records/","/queue/","/search/"],"allowEmptySearchTerm":true,"fileAmendmentButtonLabel":"Filing Actions","advancedSearchParameters":[{"type":"radio","name":"QUERY_TYPE_ID","defaultValue":1010,"options":[{"value":1010,"label":"Starts with"},{"value":1011,"label":"Contains"},{"value":1012,"label":" Word Contains"}]},{"type":"dateRange","name":"CRA_DATE","label":"Registration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}},{"type":"select","name":"STATUS_ID","label":"Status","defaultValue":0,"options":[{"value":0,"label":"All"},{"value":121,"label":"Active"},{"value":122,"label":"Inactive"}]},{"type":"select","name":"AGENT_TYPE_ID","label":"Agent Type","defaultValue":0,"options":[{"value":0,"label":"All"},{"value":460,"label":"Registered Agent"},{"value":461,"label":"Commercial Registered Agent"}]}]},{"label":"Farm Bill","component":"FarmBill","parameter":"farm-bill","path":"/lists/farm-bill","sourceTypeId":0,"myRecordsSearch":false,"allowedRules":["/search/"],"disabled":true,"searchDescription":"To perform a search, enter a debtor name. Your search results may include: exact debtor name, variations of that name and any filing that includes your search criteria. Punctuation is ignored.\n\nYou can click on \"Advanced\" to refine your search. Under “Advanced” you can search by crop, year, county and SSN/FEIN. As a registered Farm Bill Buyer with the Montana Secretary of State’s office it is important to maintain the confidentiality of the information contained within the Farm Bill Master List. The Farm Bill Master List reflects personal data, such as Social Security Numbers, which are a key piece of personal identifiable information to assist you in determining the existence of a lien against a specific debtor. The distribution of this information beyond its intended purpose is strictly prohibited.\n\nThe debtor's tax identification number has been hidden for confidentiality reasons. You may continue to search on a tax ID number and return debtors that match your search criteria. The SSN/FEIN must be entered without dashes or spaces.","searchMustHaveOneOf":["search","UCC_FARM_PRODUCT_ID","COUNTY"],"searchPlaceholder":"Search by debtor name","advancedSearchParameters":[{"type":"ServerMultiComplete","label":"Product code name(s)","name":"UCC_FARM_PRODUCT_ID","defaultValue":"","optionsSrc":"UCC_FARM_PRODUCT_V"},{"type":"MultiComplete","label":"Year or Range of Years","name":"YEAR_NUM","optionsSrc":"years","startYear":"1968","defaultValue":[],"preMergeOptions":[{"value":"ALL","label":"All"}]},{"type":"serverSelect","label":"State","name":"STATE","defaultValue":"MONTANA","optionsSrc":"STATE"},{"type":"ServerMultiComplete","label":"County","name":"COUNTY","defaultValue":[],"optionsSrc":"COUNTY","overrideSubOptionsSrcFromParameterName":"STATE"},{"type":"checkbox","name":"TIN_SEARCH_YN","defaultValue":false,"label":"Tax Identification Number Search"},{"type":"checkbox","name":"TIN_SORT_YN","defaultValue":false,"label":"Unique ID Sort"}]}],"SYSTEM_NICKNAME":"Online Services Portal","PAYMENT_METHODS":[{"type":"bypass"},{"type":"iTransact"}],"PAYMENT_ALLOW_AMEX":true,"SYSTEM_ID_LABEL":"System Id","DOUBLE_COLUMN_PUBLIC_LOGIN":true,"INTERNAL_USER_MANAGEMENT":true,"ALLOW_PUBLIC_JSON_IMPORT":false,"MAX_FILE_UPLOAD_SIZE":10000000,"REFUND_TEXT":"","RETURN_TO_HOME_ON_LOGOUT":true,"CURRENT_SOS_NAME":"Christi Jacobsen","LOGO_FILENAME":"mt-sos-logo.png","LOGO_ALT":"Christi Jacobsen, Montana Secretary of State","LOGO_FULL_WIDTH":true,"HOME_HIDE_AUTH_HINT":true,"HOME_TITLE":"Montana Secretary of State","CUSTOM_TAB_TITLE":"Official Montana","HOME_SUBTITLE":"Online Business Services","ENTITY_NAME_CONSENT_DESCRIPTION":"","ALLOW_USER_PROFILE_EDITING":true,"COMPARE_FOREIGN_NAME_IN_ENTITY_NAME_VALIDATION":true,"FOREIGN_NAME_FIELD_NAME":"KIMA_PARENT_NAME_INFO","LOGIN_TITLE":"Montana Secretary of State Online Filing Portal Login","PUBLIC_LOGIN_LABEL":"Username","REVERSE_LOGIN_COLUMNS":true,"LOGIN_SEAL_FILENAME":"seal_white.png","SEPARATE_USERNAME_AND_EMAIL":true,"CREATE_ACCOUNT_BUTTON_ALIGN_LEFT":true,"CREATE_ACCOUNT_BUTTON_TEXT":"CREATE AN ACCOUNT","PASSWORD_CUSTOM_ERROR_TEXT":"The password must meet all requirements","ACCOUNT_CREATED_MESSAGE":"Please check your email to verify your account to login and allow a few minutes for this message to arrive. Check your junk/spam folders if you do not find the email in your inbox.","PUBLIC_LOGIN_PLACEHOLDER":" ","DISABLE_DEFAULT_PAYMENT_RADIO":true,"CUSTOM_RESET_PASSWORD_ERROR_MESSAGE":"Username invalid - no account found","PUBLIC_LOGIN_CREATE_DESCRIPTION":"### Existing User:\n\n  - Enter your username and password to login.  \n\n\n  #### - OR -  \n\n\n\n  - Forgot password? Click 'Reset Password' and follow the prompts.\n  - Forgot username? Click 'Forgot Username' and follow the prompts.  \n\n\n  ### New User:\n  ","LOGIN_HELP_LINK":"https://sosmt.gov/business/how-do-i/","LOGIN_HELP_LINK_TEXT":"Need Help?","FORGOT_USERNAME_TEXT":"Forgot Username?","LOGIN_ACTIVE_DIRECTORY_TEXT":"State User Login","MULTIPLE_LOGIN_METHODS":true,"HAS_ACTIVE_DIRECTORY_LOGIN":true,"RESET_PASSWORD_WITH_USERNAME":true,"DOWNLOAD_LINK":true,"SHOW_USERNAME_ACCOUNT_CREATE":true,"SHOW_SCROLL_DOWN_ARROW":true,"SHOW_ADDRESS_ACCOUNT_CREATE":true,"TWO_COLUMN_ACCOUNT_CREATE":true,"RESET_PASSWORD_TIP":"A link to change your password has been sent to your email. Please allow a few minutes for this message to arrive. Please check your junk/spam folders if you do not find the email in your inbox.","FORGOT_PASSWORD_LINK_TEXT":"Reset Password","PHONE_NUMBER_OPTIONAL_ACCOUNT_CREATE":true,"SHOW_REQUIRED_INDICATOR_ACCOUNT_CREATE":true,"PASSWORD_REQUIREMENTS_ACCOUNT_CREATE":"\n    <ul>\n      <li>MUST contain at least 8 characters (12+ recommended)</li>\n      <li>MUST contain at least one uppercase letter.</li>\n      <li>MUST contain at least one lowercase letter.</li>\n      <li>MUST contain at least one number.</li>\n      <li>MUST contain at least one special character (!”#$%&'()*+,-./:;<=>?</li>\n    </ul>\n  ","ALLOW_CERTIFICATION_REQUEST":true,"ALLOW_PUBLIC_CERTIFICATE_REQUEST":true,"ALLOW_COPY_REQUEST":false,"ALLOW_CORRECTION_STYLING":true,"HIDE_DEPRECATION_WARNING":false,"AMEND_ROUTE_PUBLIC":true,"SEAL_FILENAME":"seal.png","SHOPPING_CART":true,"ALLOW_PAYMENT_UPDATE_WITH_EMPTY_CART":true,"RA_EMAIL":true,"RA_WEBSITE":true,"RA_NO_DEFAULT_TYPE":true,"RA_ADDRESS_LABEL":"Street Address","RA_TYPE_SELECTION_DEFAULT":true,"RA_DEFAULT_TYPE":"460","RA_OVERRIDE_TYPE_WITH_DEFAULT":true,"RA_PRINCIPAL_ADDRESS_AMS":true,"UPLOAD_AND_SUBMIT_HIDE_IF_ONE_OPTION":true,"PAYMENT_PROCESSING_MESSAGE":"Your payment is processing - Do not close your browser or click the back button","CHECKOUT_BUTTON_WHEN_PROCESSING_TEXT":"Processing","EFS_CROP_PICKER_NONE_LABEL":"Lien Duration","DISALLOWED_WIZARD_PIECES":["FormationLocale"],"REPEATER_SHOW_EDIT_BUTTON":true,"DATA_REQUEST_PAGE_TITLE":"Data Requests and Subscriptions","DATA_REQUEST_SIDEBAR_LABEL":"Data Requests & Subscriptions","LOGIN_REDIRECTS_TO_EPASS":false,"LOGIN_REDIRECTS_TO_ACTIVE_DIRECTORY":true,"LOGIN_ACTIVE_DIRECTORY_LINK":true,"FETCH_EDIT_USER_LINK":false,"LISTS_FETCH_AVAILABLE_LISTS":true,"POST_WIZARD_SUBMIT_REDIRECT_URL":"/","PIN_REQUEST_ATTESTATIONS":true,"PIN_REQUEST_DESCRIPTION":"Click **Request PIN** to have a new PIN sent to the account holder's email address on file.","OWNERSHIP_REQUEST_DESCRIPTION":"To become an **authorized user** of this record, a current **AUTHORIZED USER** will need to grant you access. To request access, click **Request Access** below.","PIN_REQUEST_SUCCESS_MESSAGE":"The PIN you have requested for this entity has been sent to the email associated with your user account.  You should receive the PIN in approximately 3-5 minutes, depending on your email service provider.","APOSTILLE_HEADER_LABEL":"Verification Information","APOSTILLE_NUMBER_LABEL":"Apostille/Authentication","APOSTILLE_CITY_STATE_OVERRIDE":"HELENA, MT","APOSTILLE_FILING_DATE_LABEL":"Issue Date","APOSTILLE_CITY_STATE_IN_CERTIFIED":true,"NOTARY_EXISTING_FILING":true,"ALLOW_REVOKE_OWN_ACCESS_ONLY":false,"HIDE_CANCEL_ON_ONETIME_DATA_REQUESTS":true,"DATA_REQUESTS_IN_SHOPPING_CART":true,"WQ_ALLOW_EDIT_PENDING_PAYMENT":true,"WQ_CONFIRM_ON_DELETE":true,"WQ_DELETE_CONFIRM_MESSAGE":"Deleting this filing will forfeit any money already paid to the Secretary of State. This action is permanent and cannot be undone, are you sure you would like to delete?","PASS_ITEM_GUIDS_ON_CHECKOUT":true,"FORM_REVISION_HISTORY":true,"CHECKOUT_DISCLAIMER":"By entering your credit card and/or checking account information you (i) state that **you are an authorized user** of the credit card and/or electronic check and that the associated information entered (e.g., account holder name, account number, billing address) is accurate, (ii) **you authorize payment processor to charge the amount you have requested** to your credit card and/or funding account, and (iii) **acknowledge if a charge is declined or reversed you may also be assessed a customary charge** by the payment processor for such transactions.","FARM_BILL_SEARCH_CONFIDENTIAL":"As a registered Farm Bill Buyer with the Montana Secretary of State’s office it is important to maintain the confidentiality of the information contained within the Farm Bill Master List. The Farm Bill Master List reflects personal data, such as Social Security Numbers, which are a key piece of personal identifiable information to assist you in determining the existence of a lien against a specific debtor. The distribution of this information beyond its intended purpose is strictly prohibited.\n\n**The debtor's tax identification number has been hidden for confidentiality reasons. You may continue to search on a tax ID number and return debtors that match your search criteria. The SSN/FEIN must be entered without dashes or spaces.  If you need access to the tax identification number to clearly identify the debtor, please contact the UCC unit at (406) 444-3665.**","VIEW_HISTORY_BUTTON_ALT_TEXT":"View Filings","WIZARD_ERROR_TITLE_MESSAGE":"Form Error","FARM_BILL_SEARCH_INTERACTIVE":true,"USE_FARM_BILL_API":true,"DISALLOW_ASSIGN_SELF_AS_RA":true,"DISALLOW_ASSIGN_SELF_AS_PRINCIPAL":true,"USE_TRADEMARK_OWNER_VALIDATION":true,"USE_ALTERNATIVE_FOREIGN_ADDRESS_LABELS":true,"MY_RECEIPTS_FILTER":[{"type":"dateRange","name":"DATE_RANGE","label":"Date range","defaultValue":{"start":null,"end":null}},{"type":"text","name":"REF_NUM","defaultValue":"","label":"Reference Number"},{"type":"text","name":"RECEIPT_NUM","defaultValue":"","label":"Receipt Id"},{"type":"text","name":"AMOUNT","defaultValue":"","label":"Amount"},{"type":"select","name":"TYPE","defaultValue":"","label":"Payment Type","options":[{"value":"","label":"All"},{"value":"CC","label":"Credit Card"},{"value":"Check","label":"Check"}]}],"MY_RECEIPTS_SHOW_IN_SIDEBAR":true,"SHOW_MY_RECEIPTS_HELPER_TEXT":true,"MY_RECEIPTS_HELPER_LABEL":"About Receipt Search","MY_RECEIPTS_HELPER_TEXT":"You can search for receipts based on their descriptions, including the items paid for on the receipt. Use the filters to search for or filter specific information.","FARM_BILL_SUBLINK":{"label":"Farm Bill","component":"FarmBill","parameter":"farm-bill","path":"/lists/farm-bill","sourceTypeId":0,"myRecordsSearch":false,"allowedRules":["/search/"],"disabled":true,"searchDescription":"To perform a search, enter a debtor name. Your search results may include: exact debtor name, variations of that name and any filing that includes your search criteria. Punctuation is ignored.\n\nYou can click on \"Advanced\" to refine your search. Under “Advanced” you can search by crop, year, county and SSN/FEIN. As a registered Farm Bill Buyer with the Montana Secretary of State’s office it is important to maintain the confidentiality of the information contained within the Farm Bill Master List. The Farm Bill Master List reflects personal data, such as Social Security Numbers, which are a key piece of personal identifiable information to assist you in determining the existence of a lien against a specific debtor. The distribution of this information beyond its intended purpose is strictly prohibited.\n\nThe debtor's tax identification number has been hidden for confidentiality reasons. You may continue to search on a tax ID number and return debtors that match your search criteria. The SSN/FEIN must be entered without dashes or spaces.","searchMustHaveOneOf":["search","UCC_FARM_PRODUCT_ID","COUNTY"],"searchPlaceholder":"Search by debtor name","advancedSearchParameters":[{"type":"ServerMultiComplete","label":"Product code name(s)","name":"UCC_FARM_PRODUCT_ID","defaultValue":"","optionsSrc":"UCC_FARM_PRODUCT_V"},{"type":"MultiComplete","label":"Year or Range of Years","name":"YEAR_NUM","optionsSrc":"years","startYear":"1968","defaultValue":[],"preMergeOptions":[{"value":"ALL","label":"All"}]},{"type":"serverSelect","label":"State","name":"STATE","defaultValue":"MONTANA","optionsSrc":"STATE"},{"type":"ServerMultiComplete","label":"County","name":"COUNTY","defaultValue":[],"optionsSrc":"COUNTY","overrideSubOptionsSrcFromParameterName":"STATE"},{"type":"checkbox","name":"TIN_SEARCH_YN","defaultValue":false,"label":"Tax Identification Number Search"},{"type":"checkbox","name":"TIN_SORT_YN","defaultValue":false,"label":"Unique ID Sort"}]},"ALLOW_ADDRESS_VALIDATION_BYPASS_OPTION":true,"DEFAULT_ADDRESS_VALIDATION_BYPASS_OPTION_CHECKED":true}).DATA_REQUEST_DESCRIPTION;
	var SHOPPING_CART = (true);
	
	var DataRequests = function (_React$Component) {
	  _inherits(DataRequests, _React$Component);
	
	  function DataRequests() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, DataRequests);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = DataRequests.__proto__ || Object.getPrototypeOf(DataRequests)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      filter: '',
	      activeDrawerProps: null,
	      drawerTitleCache: '',
	      drawerSubtitleCache: '',
	      drawerType: null,
	      drawerOpen: false,
	      modalOpen: false,
	      checkoutOpen: false,
	      requests: []
	    }, _this.componentDidMount = function () {
	      _this.getDataRequests();
	    }, _this.getDataRequests = function (updateManagementDrawer) {
	      new Promise(function (resolve, reject) {
	        (0, _requests.GET_MY_DATA_REQUESTS)(function (requests) {
	          resolve(_this.setState({ requests: requests }));
	          if (updateManagementDrawer) {
	            var activeRequest = requests.find(function (x) {
	              return x.DATA_REQUEST_ID === _this.state.activeDrawerProps.id;
	            });
	            if (activeRequest) {
	              _this.startManagementDrawer(activeRequest, true);
	            }
	          }
	        }, function (err) {
	          console.error(err);
	          reject(err);
	        });
	      });
	    }, _this.closeDrawer = function () {
	      return _this.setState({ activeDrawerProps: null });
	    }, _this.clearFilter = function () {
	      return _this.setState({ filter: '' });
	    }, _this.startManagementDrawer = function (dr, keepDrawerOpen) {
	      _this.setState(function (state) {
	        return state.drawerType === 'manage' && state.activeDrawerProps && state.activeDrawerProps.id === dr.DATA_REQUEST_ID && state.drawerOpen && keepDrawerOpen !== true ? { drawerOpen: false } : {
	          activeDrawerProps: {
	            id: dr.DATA_REQUEST_ID,
	            formDefinitionId: dr.FORM_DEFINITION_ID,
	            nickname: dr.NAME_OVERRIDE,
	            frequencyTypeId: dr.FREQUENCY_TYPE_ID,
	            statusId: dr.STATUS_ID,
	            canEdit: dr.ALLOW_EDIT_ONLINE_RO_YN,
	            canPause: dr.PAUSE_ENABLED_RO_YN,
	            canUnpause: dr.UNPAUSE_ENABLED_RO_YN,
	            canEditPayment: dr.ALLOW_EDIT_PAYMENT_RO_YN
	          },
	          drawerTitleCache: dr.NAME,
	          drawerNicknameCache: dr.NAME_OVERRIDE,
	          drawerSubtitleCache: dr.STATUS_RO,
	          drawerType: 'manage',
	          drawerOpen: true
	        };
	      });
	    }, _this.startDownloadsDrawer = function (dr) {
	      return _this.setState(function (state) {
	        return state.drawerType === 'downloads' && state.activeDrawerProps && state.activeDrawerProps.id === dr.DATA_REQUEST_ID && state.drawerOpen ? { drawerOpen: false } : {
	          activeDrawerProps: {
	            id: dr.DATA_REQUEST_ID,
	            formDefinitionId: dr.FORM_DEFINITION_ID,
	            nickname: dr.NAME_OVERRIDE,
	            frequencyTypeId: dr.FREQUENCY_TYPE_ID,
	            statusId: dr.STATUS_ID,
	            canEdit: dr.ALLOW_EDIT_ONLINE_RO_YN,
	            canPause: dr.PAUSE_ENABLED_RO_YN,
	            canUnpause: dr.UNPAUSE_ENABLED_RO_YN,
	            canEditPayment: dr.ALLOW_EDIT_PAYMENT_RO_YN
	          },
	          drawerTitleCache: dr.NAME,
	          drawerNicknameCache: dr.NAME_OVERRIDE,
	          drawerSubtitleCache: dr.STATUS_RO,
	          drawerType: 'downloads',
	          drawerOpen: true
	        };
	      });
	    }, _this.getReceiptItems = function (amendmentNum) {
	      return new Promise(function (resolve, reject) {
	        (0, _requests.GET_RECEIPT_ITEMS_BY_ADMENDMENT_NUM)(amendmentNum, 'data-request', false, function (receiptItems) {
	          resolve(receiptItems);
	        }, function (error) {
	          reject(error);
	          _this.props.setErrorToast(error.message);
	        });
	      });
	    }, _this.startCheckout = function (dr) {
	      var dataRequestItemId = dr.DATA_REQUEST_ITEM_LIST[0].DATA_REQUEST_ITEM_ID;
	      _this.getReceiptItems(dataRequestItemId).then(function (_ref2) {
	        var RECEIPT_ITEM_WEB_LIST = _ref2.RECEIPT_ITEM_WEB_LIST,
	            RECEIPT_ITEM_CONTAINER_WEB_LIST = _ref2.RECEIPT_ITEM_CONTAINER_WEB_LIST,
	            REF_NUM = _ref2.REF_NUM;
	
	        var total = RECEIPT_ITEM_CONTAINER_WEB_LIST ? (0, _utilities.calculateReceiptItemContainersTotal)(RECEIPT_ITEM_CONTAINER_WEB_LIST) : (0, _utilities.calculateReceiptItemsTotal)(RECEIPT_ITEM_WEB_LIST);
	
	        _this.setState({
	          checkoutOpen: total > 0 ? true : false,
	          checkoutDetails: {
	            amendmentNum: dr.DATA_REQUEST_ID,
	            receiptItems: RECEIPT_ITEM_WEB_LIST,
	            receiptItemContainers: RECEIPT_ITEM_CONTAINER_WEB_LIST,
	            refNum: REF_NUM
	          }
	        }, function () {
	          if (SHOPPING_CART) {
	            (0, _actions.setCartQuantity)(RECEIPT_ITEM_CONTAINER_WEB_LIST.filter(function (x) {
	              return !x.IS_FREE;
	            }).length);
	            _this.getDataRequests(true);
	          }
	          if (total <= 0) {
	            _this.openReceipt();
	          }
	        });
	      }).catch(function (error) {
	        _this.getDataRequests(false);
	      });
	    }, _this.closeCheckout = function () {
	      console.log('closing');
	      _this.getDataRequests(true);
	      _this.setState({ checkoutOpen: false });
	    }, _this.cancelCheckout = function () {
	      console.log('cancelling');
	      _this.slider.closeSlider(function () {
	        _this.closeCheckout();
	      });
	    }, _this.openReceipt = function (refNum) {
	      if (_this.slider) {
	        _this.slider.closeSlider(function () {
	          _this.props.history.push('/receipt?ref=' + (refNum || _this.state.checkoutDetails.refNum));
	        });
	      } else {
	        _this.props.history.push('/receipt?ref=' + (refNum || _this.state.checkoutDetails.refNum));
	      }
	    }, _this.toggleSelectorModal = function () {
	      return _this.setState(function (state) {
	        return { modalOpen: !state.modalOpen };
	      });
	    }, _this.getAvailableAmendments = function () {
	      return new Promise(function (resolve, reject) {
	        (0, _requests.GET_DATA_REQUEST_WIZARDS)(function (amendments) {
	          resolve(amendments);
	        }, function (err) {
	          console.error(err);
	          reject(err);
	        });
	      });
	    }, _this.openAmendment = function (formDefinitionId) {
	      _store.history.push('/forms/new/' + formDefinitionId);
	    }, _this.toggleHelpModal = function () {
	      _this.setState(function (state) {
	        return state.drawerType === 'help' && state.drawerOpen ? {
	          drawerOpen: false
	        } : {
	          drawerType: 'help',
	          drawerTitleCache: (DATA_REQUEST_LABEL ? DATA_REQUEST_LABEL : 'Data Requests') + ' Help',
	          drawerSubtitleCache: '',
	          activeDrawerProps: {},
	          drawerOpen: true
	        };
	      });
	    }, _this.setNicknameById = function (dataRequestId, nickname) {
	      _this.setState(function (state) {
	        var index = state.requests.findIndex(function (x) {
	          return x.DATA_REQUEST_ID === dataRequestId;
	        });
	        return {
	          drawerNicknameCache: nickname ? nickname : state.drawerTitleCache,
	          requests: [].concat(_toConsumableArray(state.requests.slice(0, index)), [Object.assign({}, state.requests[index], { NAME_OVERRIDE: nickname })], _toConsumableArray(state.requests.slice(index + 1)))
	        };
	      });
	    }, _this.handleSidebarDismissed = function () {
	      switch (_this.state.drawerType) {
	        case "help":
	          _this.toggleHelpModal();
	          break;
	        case "manage":
	        case "downloads":
	        default:
	          _this.setState({ drawerOpen: false });
	      }
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(DataRequests, [{
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      return _react2.default.createElement(
	        _Shell.Body,
	        { className: 'data-requests', showDrawer: !!this.state.drawerOpen },
	        _react2.default.createElement(_Toolbar2.default, {
	          title: _react2.default.createElement(
	            _react2.default.Fragment,
	            null,
	            DATA_REQUEST_PAGE_TITLE ? DATA_REQUEST_PAGE_TITLE + ':' : 'Data Requests',
	            _react2.default.createElement(
	              'button',
	              { className: 'help-button', 'aria-label': 'View Help', onClick: this.toggleHelpModal },
	              '?'
	            )
	          ),
	          underToolbar: DATA_REQUEST_DESCRIPTION ? _react2.default.createElement(
	            'p',
	            { className: 'description' },
	            DATA_REQUEST_DESCRIPTION
	          ) : null,
	          className: 'center-container',
	          searchable: false,
	          rightAlignChildren: _react2.default.createElement(
	            'button',
	            { className: 'btn btn-primary btn-raised', onClick: this.toggleSelectorModal },
	            '+ New ' + (DATA_REQUEST_LABEL ? DATA_REQUEST_LABEL : "Data Request")
	          )
	        }),
	        _react2.default.createElement(
	          'ul',
	          { className: 'data-request-blocks' },
	          this.state.requests.map(function (dr) {
	            return _react2.default.createElement(_DataRequestBlock2.default, Object.assign({}, dr, {
	              isActive: _this2.state.activeDrawerProps && _this2.state.activeDrawerProps.id === dr.DATA_REQUEST_ID && _this2.state.drawerOpen,
	              onManageClicked: function onManageClicked() {
	                return _this2.startManagementDrawer(dr);
	              },
	              onDownloadsClicked: function onDownloadsClicked() {
	                return _this2.startDownloadsDrawer(dr);
	              },
	              onAddToCartClicked: function onAddToCartClicked() {
	                return _this2.startCheckout(dr);
	              },
	              checkoutOpen: _this2.state.checkoutOpen,
	              key: dr.DATA_REQUEST_ID
	            }));
	          })
	        ),
	        _react2.default.createElement(
	          _Portal2.default,
	          { isOpened: this.state.modalOpen },
	          _react2.default.createElement(
	            _Modal.Modal,
	            {
	              modalSize: 'small',
	              title: 'Select a ' + (DATA_REQUEST_LABEL ? DATA_REQUEST_LABEL : "Data Request"),
	              closeButton: true,
	              closeModal: this.toggleSelectorModal
	            },
	            _react2.default.createElement(_AmendmentLauncher2.default, {
	              getAvailableAmendments: this.getAvailableAmendments,
	              openAmendment: this.openAmendment
	            })
	          )
	        ),
	        _react2.default.createElement(
	          _Portal2.default,
	          { isOpened: this.state.checkoutOpen },
	          _react2.default.createElement(
	            _SlidingPanel2.default,
	            {
	              closeOnShadeClick: false,
	              closeSlider: this.closeCheckout,
	              ref: function ref(_ref3) {
	                _this2.slider = _ref3;
	              }
	            },
	            _react2.default.createElement(_Checkout2.default, {
	              cancelCheckout: this.cancelCheckout,
	              closeModal: this.closeCheckout,
	              redirectToReceipt: this.openReceipt,
	              amendmentNum: this.state.checkoutOpen && this.state.checkoutDetails.amendmentNum,
	              refNum: this.state.checkoutOpen && this.state.checkoutDetails.refNum,
	              formDefinitionId: this.state.checkoutOpen && this.state.checkoutDetails.formDefinitionId,
	              category: 'data-request',
	              receiptItems: this.state.checkoutOpen && this.state.checkoutDetails.receiptItems,
	              receiptItemContainers: this.state.checkoutOpen && this.state.checkoutDetails.receiptItemContainers,
	              onReceiptItemContainerRemoved: function onReceiptItemContainerRemoved() {
	                return _this2.getDataRequests(true);
	              }
	            })
	          )
	        ),
	        _react2.default.createElement(
	          _Shell.Drawer,
	          {
	            show: this.state.drawerOpen,
	            showCloseButton: true,
	            title: this.state.drawerNicknameCache || this.state.drawerTitleCache,
	            subtitle: this.state.drawerSubtitleCache,
	            onSidebarDismiss: this.handleSidebarDismissed,
	            ariaCloseLabel: this.state.drawerType === 'help' ? "Close Help" : "Close"
	          },
	          this.state.drawerType === 'manage' && _react2.default.createElement(_ManageDrawer2.default, {
	            formDefinitionId: this.state.activeDrawerProps.formDefinitionId,
	            dataRequestId: this.state.activeDrawerProps.id,
	            frequencyTypeId: this.state.activeDrawerProps.frequencyTypeId,
	            statusId: this.state.activeDrawerProps.statusId,
	            canEdit: this.state.activeDrawerProps.canEdit,
	            canEditPayment: this.state.activeDrawerProps.canEditPayment,
	            canPause: this.state.activeDrawerProps.canPause,
	            canUnpause: this.state.activeDrawerProps.canUnpause,
	            nickname: this.state.activeDrawerProps.nickname,
	            onNicknameChange: function onNicknameChange(nickname) {
	              return _this2.setNicknameById(_this2.state.activeDrawerProps.id, nickname);
	            },
	            onCanceled: function onCanceled() {
	              return _this2.getDataRequests(true);
	            },
	            onPause: function onPause() {
	              return _this2.getDataRequests(true);
	            },
	            onUnpause: function onUnpause() {
	              return _this2.getDataRequests(true);
	            }
	          }),
	          this.state.drawerType === 'downloads' && _react2.default.createElement(_ReportsList2.default, {
	            amendmentNum: this.state.activeDrawerProps.id,
	            formDefinitionId: this.state.activeDrawerProps.formDefinitionId
	          }),
	          this.state.drawerType === 'help' && _react2.default.createElement(Help, null)
	        )
	      );
	    }
	  }]);
	
	  return DataRequests;
	}(_react2.default.Component);
	
	exports.default = (0, _reactRedux.connect)(null, { setErrorToast: _actions.setErrorToast })(DataRequests);
	
	
	var helpCache = null;
	
	var Help = function Help() {
	  var _useState = (0, _react.useState)(helpCache),
	      _useState2 = _slicedToArray(_useState, 2),
	      help = _useState2[0],
	      setHelp = _useState2[1];
	
	  var _useState3 = (0, _react.useState)(!helpCache),
	      _useState4 = _slicedToArray(_useState3, 2),
	      loading = _useState4[0],
	      setLoading = _useState4[1];
	
	  (0, _react.useEffect)(function () {
	    if (!help) {
	      setLoading(true);
	      (0, _requests.GET_APP_SETTING_BY_NAME)('HELP_ICON_TEXT_DATA_REQUEST', function (_ref4) {
	        var VALUE = _ref4.VALUE;
	
	        helpCache = VALUE;
	        setHelp(VALUE);
	        setLoading(false);
	      });
	    }
	  }, []);
	
	  return loading ? _react2.default.createElement(
	    'div',
	    { className: 'reports-spinner animated fadeIn' },
	    _react2.default.createElement(_Loaders.Spinner, { size: 'medium', themeColor: 'secondary' })
	  ) : _react2.default.createElement(_Markdown2.default, { className: 'markdown', source: help || '' });
	};

/***/ },
/* 1068 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _requests = __webpack_require__(6);
	
	var _PayrocGenericModal = __webpack_require__(1124);
	
	var _PayrocGenericModal2 = _interopRequireDefault(_PayrocGenericModal);
	
	var _DetailsList = __webpack_require__(454);
	
	var _DetailsList2 = _interopRequireDefault(_DetailsList);
	
	var _ActionButton = __webpack_require__(194);
	
	var _ActionButton2 = _interopRequireDefault(_ActionButton);
	
	var _documentEdit = __webpack_require__(332);
	
	var _documentEdit2 = _interopRequireDefault(_documentEdit);
	
	var _trash = __webpack_require__(60);
	
	var _trash2 = _interopRequireDefault(_trash);
	
	var _visible = __webpack_require__(600);
	
	var _visible2 = _interopRequireDefault(_visible);
	
	var _pause = __webpack_require__(579);
	
	var _pause2 = _interopRequireDefault(_pause);
	
	var _play = __webpack_require__(582);
	
	var _play2 = _interopRequireDefault(_play);
	
	var _creditCardSolid = __webpack_require__(158);
	
	var _creditCardSolid2 = _interopRequireDefault(_creditCardSolid);
	
	var _Portal = __webpack_require__(12);
	
	var _Portal2 = _interopRequireDefault(_Portal);
	
	var _Modal = __webpack_require__(13);
	
	var _Field = __webpack_require__(25);
	
	var _Form = __webpack_require__(14);
	
	var _utilities = __webpack_require__(8);
	
	var _store = __webpack_require__(18);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var PAYMENT_METHODS = ([{"type":"bypass"},{"type":"iTransact"}]);
	var PAYROC_METHOD_AVAILABLE = !!PAYMENT_METHODS.find(function (method) {
	  return method.type === 'iTransact';
	});
	var HIDE_CANCEL_ON_ONETIME_DATA_REQUESTS = (true) || false;
	
	exports.default = function (_ref) {
	  var formDefinitionId = _ref.formDefinitionId,
	      dataRequestId = _ref.dataRequestId,
	      initialNickname = _ref.nickname,
	      onNicknameChange = _ref.onNicknameChange,
	      frequencyTypeId = _ref.frequencyTypeId,
	      onCanceled = _ref.onCanceled,
	      statusId = _ref.statusId,
	      canEdit = _ref.canEdit,
	      canPause = _ref.canPause,
	      onPause = _ref.onPause,
	      canUnpause = _ref.canUnpause,
	      onUnpause = _ref.onUnpause,
	      canEditPayment = _ref.canEditPayment;
	
	  var _useState = (0, _react.useState)([]),
	      _useState2 = _slicedToArray(_useState, 2),
	      details = _useState2[0],
	      setDetails = _useState2[1];
	
	  var _useState3 = (0, _react.useState)(true),
	      _useState4 = _slicedToArray(_useState3, 2),
	      loading = _useState4[0],
	      setLoading = _useState4[1];
	
	  var _useState5 = (0, _react.useState)(false),
	      _useState6 = _slicedToArray(_useState5, 2),
	      editingNickname = _useState6[0],
	      setEditingNickname = _useState6[1];
	
	  var _useState7 = (0, _react.useState)(initialNickname),
	      _useState8 = _slicedToArray(_useState7, 2),
	      nickname = _useState8[0],
	      setNickname = _useState8[1];
	
	  var _useState9 = (0, _react.useState)(false),
	      _useState10 = _slicedToArray(_useState9, 2),
	      confirmingCancel = _useState10[0],
	      setConfirmingCancel = _useState10[1];
	
	  var _useState11 = (0, _react.useState)(false),
	      _useState12 = _slicedToArray(_useState11, 2),
	      confirmingPause = _useState12[0],
	      setConfirmingPause = _useState12[1];
	
	  var _useState13 = (0, _react.useState)(false),
	      _useState14 = _slicedToArray(_useState13, 2),
	      confirmingUnpause = _useState14[0],
	      setConfirmingUnpause = _useState14[1];
	
	  var _useState15 = (0, _react.useState)(false),
	      _useState16 = _slicedToArray(_useState15, 2),
	      canceled = _useState16[0],
	      setCanceled = _useState16[1];
	
	  var _useState17 = (0, _react.useState)(""),
	      _useState18 = _slicedToArray(_useState17, 2),
	      error = _useState18[0],
	      setError = _useState18[1];
	
	  var _useState19 = (0, _react.useState)(false),
	      _useState20 = _slicedToArray(_useState19, 2),
	      editingPaymentSource = _useState20[0],
	      setEditingPaymentSource = _useState20[1];
	
	  (0, _react.useEffect)(function () {
	    setCanceled(false);
	    setError("");
	    getDetails();
	  }, [dataRequestId]);
	
	  var getDetails = function getDetails() {
	    setLoading(true);
	    (0, _requests.GET_FILING_DETAILS)('data-request', dataRequestId, false, function () {}, function (_ref2) {
	      var DRAWER_DETAIL_LIST = _ref2.DRAWER_DETAIL_LIST;
	
	      setDetails(DRAWER_DETAIL_LIST);
	      setLoading(false);
	    }, function (err) {
	      console.error(err);
	      setLoading(false);
	    });
	  };
	
	  _react2.default.useEffect(function () {
	    setNickname(initialNickname);
	  }, [dataRequestId]);
	
	  var updateNickname = function updateNickname(closeModal) {
	    setError("");
	    (0, _requests.UPDATE_DATA_REQUEST)({
	      DATA_REQUEST_ID: dataRequestId,
	      action: 'UPDATE_NAME',
	      NAME_OVERRIDE: nickname
	    }, function () {
	      onNicknameChange(nickname);
	      getDetails();
	      closeModal();
	    }, function (err) {
	      setLoading(false);
	      setError(err.internalerror);
	    });
	  };
	
	  var cancelSubscription = function cancelSubscription() {
	    setError("");
	    (0, _requests.UPDATE_DATA_REQUEST)({
	      DATA_REQUEST_ID: dataRequestId,
	      action: 'CANCEL'
	    }, function () {
	      onCanceled();
	      setCanceled(true);
	      getDetails();
	    }, function (err) {
	      setLoading(false);
	      setError(err.internalerror);
	    });
	  };
	
	  var pauseSubscription = function pauseSubscription() {
	    setError("");
	    (0, _requests.UPDATE_DATA_REQUEST)({
	      DATA_REQUEST_ID: dataRequestId,
	      action: 'PAUSE'
	    }, function () {
	      onPause();
	      getDetails();
	    }, function (err) {
	      setLoading(false);
	      setError(err.internalerror);
	    });
	  };
	
	  var unpauseSubscription = function unpauseSubscription() {
	    setError("");
	    (0, _requests.UPDATE_DATA_REQUEST)({
	      DATA_REQUEST_ID: dataRequestId,
	      action: 'UNPAUSE'
	    }, function () {
	      onUnpause();
	      getDetails();
	    }, function (err) {
	      setLoading(false);
	      setError(err.internalerror);
	    });
	  };
	
	  var setPaymentMethod = function setPaymentMethod(TOKEN) {
	    setEditingPaymentSource(false);
	    setError("");
	    (0, _requests.UPDATE_DATA_REQUEST)({
	      DATA_REQUEST_ID: dataRequestId,
	      TOKEN: TOKEN,
	      action: 'UPDATE_PAYMENT'
	    }, function () {
	      getDetails();
	    }, function (err) {
	      setLoading(false);
	      setError(err.internalerror);
	    });
	  };
	
	  var toggleNicknameEdit = function toggleNicknameEdit() {
	    return setEditingNickname(function (x) {
	      return !x;
	    });
	  };
	  var toggleConfirmingCancel = function toggleConfirmingCancel() {
	    return setConfirmingCancel(function (x) {
	      return !x;
	    });
	  };
	  var toggleConfirmingPause = function toggleConfirmingPause() {
	    return setConfirmingPause(function (x) {
	      return !x;
	    });
	  };
	  var toggleConfirmingUnpause = function toggleConfirmingUnpause() {
	    return setConfirmingUnpause(function (x) {
	      return !x;
	    });
	  };
	  var startReadOnlyWizard = function startReadOnlyWizard() {
	    _store.history.push('/view/' + formDefinitionId + '/' + dataRequestId);
	  };
	  var startEditWizard = function startEditWizard() {
	    _store.history.push('/correct/' + formDefinitionId + '/' + dataRequestId);
	  };
	
	  return _react2.default.createElement(
	    'div',
	    { className: 'dr-management-drawer ' + (loading ? 'loading' : '') },
	    _react2.default.createElement(
	      _ActionButton.ActionButtonGroup,
	      null,
	      canEdit ? _react2.default.createElement(_ActionButton2.default, {
	        label: 'Edit Details',
	        children: _react2.default.createElement(_documentEdit2.default, null),
	        onClick: startEditWizard
	      }) : null,
	      canPause ? _react2.default.createElement(_ActionButton2.default, {
	        label: 'Pause Subscription',
	        children: _react2.default.createElement(_pause2.default, null),
	        onClick: toggleConfirmingPause
	      }) : null,
	      canUnpause ? _react2.default.createElement(_ActionButton2.default, {
	        label: 'Unpause Subscription',
	        children: _react2.default.createElement(_play2.default, null),
	        onClick: toggleConfirmingUnpause
	      }) : null,
	      canEditPayment ? _react2.default.createElement(_ActionButton2.default, {
	        label: 'Select / Add Payment Method',
	        children: _react2.default.createElement(_creditCardSolid2.default, null),
	        onClick: function onClick() {
	          return setEditingPaymentSource(true);
	        }
	      }) : null
	    ),
	    _react2.default.createElement(
	      'p',
	      { className: 'error-message', 'aria-live': 'polite' },
	      error
	    ),
	    _react2.default.createElement(_DetailsList2.default, { details: details }),
	    _react2.default.createElement(
	      _ActionButton.ActionButtonGroup,
	      null,
	      _react2.default.createElement(_ActionButton2.default, {
	        label: 'View Details',
	        children: _react2.default.createElement(_visible2.default, null),
	        onClick: startReadOnlyWizard
	      }),
	      _react2.default.createElement(_ActionButton2.default, {
	        label: 'Edit Nickname',
	        children: _react2.default.createElement(_documentEdit2.default, null),
	        onClick: toggleNicknameEdit
	      }),
	      frequencyTypeId !== 0 && !(HIDE_CANCEL_ON_ONETIME_DATA_REQUESTS && frequencyTypeId === 3500) && statusId === 1071 && !canceled && _react2.default.createElement(_ActionButton2.default, {
	        label: 'Cancel Subscription',
	        children: _react2.default.createElement(_trash2.default, null),
	        onClick: toggleConfirmingCancel
	      })
	    ),
	    _react2.default.createElement(
	      _Portal2.default,
	      { isOpened: editingNickname },
	      _react2.default.createElement(
	        _Modal.Modal,
	        {
	          title: 'Edit Nickname',
	          closeModal: toggleNicknameEdit,
	          cancelButton: true,
	          saveButton: true,
	          autoHeight: true,
	          save: updateNickname
	        },
	        _react2.default.createElement(NicknameEditor, { onNicknameChange: setNickname, nickname: nickname, key: dataRequestId })
	      )
	    ),
	    _react2.default.createElement(
	      _Portal2.default,
	      { isOpened: confirmingCancel },
	      _react2.default.createElement(_Modal.ConfirmDialog, {
	        closeModal: toggleConfirmingCancel,
	        onModalClosed: _utilities.noop,
	        message: 'Are you sure you want to cancel this subscription? This cannot be undone.',
	        buttons: [{ label: 'No', onClick: _utilities.noop, className: 'btn-default' }, {
	          label: 'Yes',
	          onClick: cancelSubscription,
	          className: 'btn-danger'
	        }],
	        modalStyle: { borderRadius: 3 }
	      })
	    ),
	    _react2.default.createElement(
	      _Portal2.default,
	      { isOpened: confirmingPause },
	      _react2.default.createElement(_Modal.ConfirmDialog, {
	        closeModal: toggleConfirmingPause,
	        onModalClosed: _utilities.noop,
	        message: 'Are you sure you want to pause this subscription?  Access to the Farm Bill search will be temporarily suspended while your pause is in effect.',
	        buttons: [{ label: 'No', onClick: _utilities.noop, className: 'btn-default' }, {
	          label: 'Yes',
	          onClick: pauseSubscription,
	          className: 'btn-danger'
	        }],
	        modalStyle: { borderRadius: 3 }
	      })
	    ),
	    _react2.default.createElement(
	      _Portal2.default,
	      { isOpened: confirmingUnpause },
	      _react2.default.createElement(_Modal.ConfirmDialog, {
	        closeModal: toggleConfirmingUnpause,
	        onModalClosed: _utilities.noop,
	        message: 'Are you sure you want to unpause your subscription?  A monthly charge will automatically be applied to resume Farm Bill search services.',
	        buttons: [{ label: 'No', onClick: _utilities.noop, className: 'btn-default' }, {
	          label: 'Yes',
	          onClick: unpauseSubscription,
	          className: 'btn-danger'
	        }],
	        modalStyle: { borderRadius: 3 }
	      })
	    ),
	    PAYROC_METHOD_AVAILABLE && _react2.default.createElement(_PayrocGenericModal2.default, {
	      title: 'Select / Add Payment Method',
	      isOpen: editingPaymentSource,
	      onRequestClose: function onRequestClose() {
	        return setEditingPaymentSource(false);
	      },
	      instructions: 'Select an existing payment method, or add a new payment method below.',
	      onPaymentSelected: setPaymentMethod
	    })
	  );
	};
	
	var NicknameEditor = function NicknameEditor(_ref3) {
	  var nickname = _ref3.nickname,
	      onNicknameChange = _ref3.onNicknameChange;
	
	  return _react2.default.createElement(
	    'div',
	    { className: 'wizard nickname-editor' },
	    _react2.default.createElement(
	      _Field.DumbField,
	      { label: 'Set a new nickname' },
	      _react2.default.createElement(_Form.TextInput, { value: nickname, isFirst: true, onChange: function onChange(v) {
	          return onNicknameChange(v);
	        } })
	    )
	  );
	};

/***/ },
/* 1069 */,
/* 1070 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Form = __webpack_require__(14);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	exports.default = function (_ref) {
	  var value = _ref.value,
	      onChange = _ref.onChange,
	      props = _objectWithoutProperties(_ref, ['value', 'onChange']);
	
	  return _react2.default.createElement(
	    'div',
	    { className: 'flume-calendar-input-wrapper' },
	    props.label && _react2.default.createElement(
	      'label',
	      null,
	      props.label
	    ),
	    _react2.default.createElement(_Form.DateInput, Object.assign({ value: value, onChange: onChange, buttonClassName: 'flume-button' }, props))
	  );
	};

/***/ },
/* 1071 */,
/* 1072 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(7);
	
	var _crossHeavy = __webpack_require__(51);
	
	var _crossHeavy2 = _interopRequireDefault(_crossHeavy);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var allowedFieldTypes = ["text", "select", "radio", "checkbox", "textArea", "addressBlock", "serverSelect", "serverRadio", "date", "DateRange", "FullName", "NameOrg", "NameQualifiedOrg"];
	
	var ConstraintsEditor = function (_React$Component) {
	  _inherits(ConstraintsEditor, _React$Component);
	
	  function ConstraintsEditor() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, ConstraintsEditor);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = ConstraintsEditor.__proto__ || Object.getPrototypeOf(ConstraintsEditor)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      allowedFields: _this.props.parentField ? _this.props.parentField.template.filter(function (fieldId) {
	        return _this.props.fields[fieldId];
	      }).filter(function (fieldId) {
	        return allowedFieldTypes.includes(_this.props.fields[fieldId].type);
	      }).map(function (fieldId) {
	        return {
	          value: fieldId,
	          label: _this.props.fields[fieldId].label || _this.props.fields[fieldId].name
	        };
	      }) : [],
	      addingConstraint: false
	    }, _this.toggleAddingConstraint = function () {
	      _this.setState(function (state) {
	        return { addingConstraint: !state.addingConstraint };
	      });
	    }, _this.addConstraint = function (fieldId) {
	      _this.props.onChange([].concat(_toConsumableArray(_this.props.value), [{ fields: [fieldId], errorMessage: "" }]));
	      _this.setState({ addingConstraint: false });
	    }, _this.addFieldByIndex = function (fieldId, cIndex) {
	      _this.props.onChange([].concat(_toConsumableArray(_this.props.value.slice(0, cIndex)), [Object.assign({}, _this.props.value[cIndex], {
	        fields: [].concat(_toConsumableArray(_this.props.value[cIndex].fields), [fieldId])
	      })], _toConsumableArray(_this.props.value.slice(cIndex + 1))));
	    }, _this.deleteConstraintByIndex = function (index) {
	      _this.props.onChange([].concat(_toConsumableArray(_this.props.value.slice(0, index)), _toConsumableArray(_this.props.value.slice(index + 1))));
	    }, _this.deleteFieldByIndex = function (cI, fI) {
	      var isLastField = _this.props.value[cI].fields.length === 1;
	      if (isLastField) {
	        _this.deleteConstraintByIndex(cI);
	      } else {
	        _this.props.onChange([].concat(_toConsumableArray(_this.props.value.slice(0, cI)), [Object.assign({}, _this.props.value[cI], {
	          fields: [].concat(_toConsumableArray(_this.props.value[cI].fields.slice(0, fI)), _toConsumableArray(_this.props.value[cI].fields.slice(fI + 1)))
	        })], _toConsumableArray(_this.props.value.slice(cI + 1))));
	      }
	    }, _this.setErrorMessageByIndex = function (errorMessage, index) {
	      _this.props.onChange([].concat(_toConsumableArray(_this.props.value.slice(0, index)), [Object.assign({}, _this.props.value[index], {
	        errorMessage: errorMessage
	      })], _toConsumableArray(_this.props.value.slice(index + 1))));
	    }, _this.constructConstraints = function () {
	      return _this.props.value.map(function (constraint) {
	        return Object.assign({}, constraint, {
	          fields: constraint.fields.map(function (fieldId) {
	            var field = _this.state.allowedFields.find(function (field) {
	              return field.value === fieldId;
	            });
	            if (!field) return null;
	            return field;
	          }).filter(function (field) {
	            return field;
	          })
	        });
	      });
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(ConstraintsEditor, [{
	    key: "render",
	    value: function render() {
	      var _this2 = this;
	
	      var constraints = this.constructConstraints();
	      return _react2.default.createElement(
	        "div",
	        { className: "constraints-editor" },
	        _react2.default.createElement(
	          "p",
	          { className: "description" },
	          "Constraints allow you to require that one or more fields, or a combination of fields, be unique per repeater row."
	        ),
	        this.state.allowedFields.length === 0 && _react2.default.createElement(
	          "p",
	          { className: "error" },
	          "In order to create constraints, you must add at least one constrainable field to the repeater."
	        ),
	        constraints.map(function (constraint, i) {
	          return _react2.default.createElement(ConstraintRow, {
	            fieldList: constraint.fields,
	            errorMessage: constraint.errorMessage,
	            onErrorChange: _this2.setErrorMessageByIndex,
	            allowedFields: _this2.state.allowedFields,
	            addField: _this2.addFieldByIndex,
	            onFieldDelete: _this2.deleteFieldByIndex,
	            onConstraintDelete: _this2.deleteConstraintByIndex,
	            index: i,
	            key: i
	          });
	        }),
	        !this.state.addingConstraint && this.state.allowedFields.length > 0 ? _react2.default.createElement(
	          "button",
	          {
	            className: "add-constraint",
	            onClick: this.toggleAddingConstraint
	          },
	          "+ Add New Constraint"
	        ) : this.state.allowedFields.length > 0 ? _react2.default.createElement(ConstraintRow, {
	          fieldList: [],
	          allowedFields: this.state.allowedFields,
	          addField: this.addConstraint,
	          onOutsideClick: this.toggleAddingConstraint,
	          index: 0
	        }) : null
	      );
	    }
	  }]);
	
	  return ConstraintsEditor;
	}(_react2.default.Component);
	
	exports.default = (0, _reactRedux.connect)(function (state) {
	  return {
	    fields: state.designer.wizard.fields
	  };
	})(ConstraintsEditor);
	
	var ConstraintRow = function (_React$Component2) {
	  _inherits(ConstraintRow, _React$Component2);
	
	  function ConstraintRow() {
	    var _ref2;
	
	    var _temp2, _this3, _ret2;
	
	    _classCallCheck(this, ConstraintRow);
	
	    for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
	      args[_key2] = arguments[_key2];
	    }
	
	    return _ret2 = (_temp2 = (_this3 = _possibleConstructorReturn(this, (_ref2 = ConstraintRow.__proto__ || Object.getPrototypeOf(ConstraintRow)).call.apply(_ref2, [this].concat(args))), _this3), _this3.componentDidMount = function () {
	      if (_this3.props.onOutsideClick) {
	        document.addEventListener('click', _this3.handleOutsideClick);
	      }
	    }, _this3.handleOutsideClick = function (e) {
	      if (!_this3.wrapper.contains(e.target)) {
	        _this3.props.onOutsideClick();
	      }
	    }, _this3.componentWillUnmount = function () {
	      document.removeEventListener('click', _this3.handleOutsideClick);
	    }, _temp2), _possibleConstructorReturn(_this3, _ret2);
	  }
	
	  _createClass(ConstraintRow, [{
	    key: "render",
	    value: function render() {
	      var _this4 = this;
	
	      var _props = this.props,
	          fieldList = _props.fieldList,
	          allowedFields = _props.allowedFields,
	          addField = _props.addField,
	          index = _props.index,
	          onFieldDelete = _props.onFieldDelete,
	          errorMessage = _props.errorMessage,
	          onErrorChange = _props.onErrorChange,
	          onConstraintDelete = _props.onConstraintDelete;
	
	      var options = allowedFields.filter(function (opt) {
	        return !fieldList.find(function (field) {
	          return field.value === opt.value;
	        });
	      });
	      return _react2.default.createElement(
	        "div",
	        { className: "constraints-row", ref: function ref(_ref3) {
	            _this4.wrapper = _ref3;
	          } },
	        fieldList.length > 0 && _react2.default.createElement(
	          "button",
	          { className: "delete-constraint", onClick: function onClick() {
	              onConstraintDelete(index);
	            } },
	          _react2.default.createElement(_crossHeavy2.default, null)
	        ),
	        fieldList.length > 0 && _react2.default.createElement(
	          "div",
	          { className: "field-list" },
	          fieldList.map(function (field, i) {
	            return _react2.default.createElement(FieldChip, Object.assign({}, field, { onDelete: function onDelete() {
	                onFieldDelete(index, i);
	              }, key: i }));
	          })
	        ),
	        options.length > 0 && _react2.default.createElement(FieldSelector, {
	          numFields: fieldList.length,
	          options: options,
	          onChange: function onChange(value) {
	            addField(value, index);
	          }
	        }),
	        fieldList.length > 0 && _react2.default.createElement(ErrorMessage, { value: errorMessage, onChange: function onChange(value) {
	            onErrorChange(value, index);
	          } })
	      );
	    }
	  }]);
	
	  return ConstraintRow;
	}(_react2.default.Component);
	
	var FieldSelector = function FieldSelector(_ref4) {
	  var _onChange = _ref4.onChange,
	      _ref4$options = _ref4.options,
	      options = _ref4$options === undefined ? [] : _ref4$options,
	      numFields = _ref4.numFields;
	  return _react2.default.createElement(
	    "div",
	    { className: "select-wrapper" },
	    _react2.default.createElement(
	      "select",
	      {
	        value: "",
	        onChange: function onChange(e) {
	          _onChange(e.target.value);
	        }
	      },
	      _react2.default.createElement(
	        "option",
	        { value: "" },
	        "[Select " + (numFields > 0 ? 'another' : 'a') + " field to constrain]"
	      ),
	      options.map(function (option, i) {
	        return _react2.default.createElement(
	          "option",
	          { value: option.value, key: i },
	          option.label
	        );
	      })
	    )
	  );
	};
	
	var FieldChip = function FieldChip(_ref5) {
	  var label = _ref5.label,
	      onDelete = _ref5.onDelete;
	  return _react2.default.createElement(
	    "div",
	    { className: "field-chip-wrapper" },
	    _react2.default.createElement(
	      "div",
	      { className: "field-chip" },
	      _react2.default.createElement(
	        "button",
	        { className: "delete-wrapper", onClick: onDelete },
	        _react2.default.createElement(
	          "div",
	          { className: "delete-chip" },
	          _react2.default.createElement(_crossHeavy2.default, null)
	        )
	      ),
	      _react2.default.createElement(
	        "span",
	        { className: "label" },
	        label
	      )
	    )
	  );
	};
	
	var ErrorMessage = function ErrorMessage(_ref6) {
	  var value = _ref6.value,
	      _onChange2 = _ref6.onChange;
	  return _react2.default.createElement(
	    "div",
	    { className: "error-message" },
	    _react2.default.createElement("input", { type: "text", placeholder: "Enter error message (leave blank for default)", value: value, onChange: function onChange(e) {
	        _onChange2(e.target.value);
	      } })
	  );
	};

/***/ },
/* 1073 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _shortid = __webpack_require__(22);
	
	var _shortid2 = _interopRequireDefault(_shortid);
	
	var _Modal = __webpack_require__(13);
	
	var _Form = __webpack_require__(14);
	
	var _flume = __webpack_require__(117);
	
	var _fieldFlumeConfig = __webpack_require__(146);
	
	var _fieldFlumeConfig2 = _interopRequireDefault(_fieldFlumeConfig);
	
	var _trash = __webpack_require__(60);
	
	var _trash2 = _interopRequireDefault(_trash);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	exports.default = function (_ref) {
	  var name = _ref.name,
	      value = _ref.value,
	      allowCurrentRepeaterFields = _ref.allowCurrentRepeaterFields,
	      allowCurrentField = _ref.allowCurrentField,
	      parentField = _ref.parentField,
	      onChange = _ref.onChange;
	
	  var isRepeaterChild = parentField.parent.type === 'REPEATER';
	
	  var addRule = function addRule() {
	    onChange(name, [].concat(_toConsumableArray(value), [{
	      id: _shortid2.default.generate(),
	      label: '',
	      logicNodes: {},
	      logicComments: {}
	    }]));
	  };
	
	  var deleteRule = function deleteRule(index) {
	    onChange(name, [].concat(_toConsumableArray(value.slice(0, index)), _toConsumableArray(value.slice(index + 1))));
	  };
	
	  var setByKey = function setByKey(key, index, newValue) {
	    onChange(name, [].concat(_toConsumableArray(value.slice(0, index)), [Object.assign({}, value[index], _defineProperty({}, key, newValue))], _toConsumableArray(value.slice(index + 1))));
	  };
	
	  var setLogic = function setLogic(logicNodes, logicComments, index) {
	    onChange(name, [].concat(_toConsumableArray(value.slice(0, index)), [Object.assign({}, value[index], {
	      logicNodes: logicNodes,
	      logicComments: logicComments
	    })], _toConsumableArray(value.slice(index + 1))));
	  };
	
	  return _react2.default.createElement(
	    'div',
	    { className: 'flex-column custom-business-rules' },
	    _react2.default.createElement(
	      'p',
	      { className: 'description' },
	      'Custom business rules defined in this section will be applied when advancing to the next step and submitting the form.'
	    ),
	    value.map(function (rule, i) {
	      return _react2.default.createElement(RuleRow, Object.assign({}, rule, {
	        onLabelChange: function onLabelChange(value) {
	          return setByKey('label', i, value);
	        },
	        onLogicChange: function onLogicChange(nodes, comments) {
	          setLogic(nodes, comments, i);
	        },
	        onRequestDelete: function onRequestDelete() {
	          return deleteRule(i);
	        },
	        allowCurrentRepeaterFields: isRepeaterChild ? true : allowCurrentRepeaterFields,
	        allowCurrentField: allowCurrentField,
	        hostFieldId: parentField.fieldId,
	        parentFieldId: parentField.parent.id,
	        key: rule.id
	      }));
	    }),
	    _react2.default.createElement(
	      'button',
	      { className: 'add-rule', onClick: addRule },
	      '+ Add New Rule'
	    )
	  );
	};
	
	var RuleRow = function RuleRow(_ref2) {
	  var label = _ref2.label,
	      logicNodes = _ref2.logicNodes,
	      logicComments = _ref2.logicComments,
	      onLabelChange = _ref2.onLabelChange,
	      onLogicChange = _ref2.onLogicChange,
	      onRequestDelete = _ref2.onRequestDelete,
	      allowCurrentRepeaterFields = _ref2.allowCurrentRepeaterFields,
	      allowCurrentField = _ref2.allowCurrentField,
	      hostFieldId = _ref2.hostFieldId,
	      parentFieldId = _ref2.parentFieldId;
	
	  var _React$useState = _react2.default.useState(false),
	      _React$useState2 = _slicedToArray(_React$useState, 2),
	      logicEditorOpen = _React$useState2[0],
	      setLogicEditorOpen = _React$useState2[1];
	
	  var nodeEditor = _react2.default.useRef();
	
	  var handleSave = function handleSave() {
	    var nodes = nodeEditor.current.getNodes();
	    var comments = nodeEditor.current.getComments();
	    onLogicChange(nodes, comments);
	  };
	
	  return _react2.default.createElement(
	    'div',
	    { className: 'flex-row custom-rule-row' },
	    _react2.default.createElement(_Form.TextInput, {
	      className: 'rule-label',
	      value: label,
	      onChange: onLabelChange,
	      placeholder: 'Rule Label',
	      ariaLabel: 'Rule Label'
	    }),
	    _react2.default.createElement(
	      'button',
	      { className: 'btn btn-primary btn-raised', onClick: function onClick() {
	          return setLogicEditorOpen(true);
	        } },
	      'Edit Logic'
	    ),
	    _react2.default.createElement(
	      'button',
	      { className: 'btn btn-danger btn-raised delete-button', onClick: onRequestDelete },
	      _react2.default.createElement(_trash2.default, null)
	    ),
	    _react2.default.createElement(
	      _Modal.ControlledModal,
	      {
	        title: label.trim() + ' Logic',
	        size: 'fullscreen',
	        isOpen: logicEditorOpen,
	        onModalClosed: function onModalClosed() {
	          return setLogicEditorOpen(false);
	        },
	        onRequestModalClose: function onRequestModalClose() {
	          return setLogicEditorOpen(false);
	        },
	        saveAndCloseButton: true,
	        cancelButton: true,
	        closeButton: false,
	        save: handleSave,
	        cancel: function cancel() {},
	        autoHeight: false,
	        className: ''
	      },
	      _react2.default.createElement(
	        'div',
	        { style: { height: 'calc(100% - 51px)' }, className: 'logic-editor-wrapper' },
	        _react2.default.createElement(_flume.NodeEditor, {
	          nodeTypes: _fieldFlumeConfig2.default.nodeTypes,
	          portTypes: _fieldFlumeConfig2.default.portTypes,
	          nodes: logicNodes,
	          comments: logicComments,
	          context: { allowCurrentRepeaterFields: allowCurrentRepeaterFields, allowCurrentField: allowCurrentField, hostFieldId: hostFieldId, parentFieldId: parentFieldId },
	          defaultNodes: [{
	            type: 'businessRuleOutput',
	            x: 400,
	            y: -100
	          }],
	          ref: nodeEditor,
	          debug: true
	        })
	      )
	    )
	  );
	};

/***/ },
/* 1074 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	__webpack_require__(1437);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Designer = void 0;
	
	var DeferredDesigner = function (_React$Component) {
	  _inherits(DeferredDesigner, _React$Component);
	
	  function DeferredDesigner() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, DeferredDesigner);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = DeferredDesigner.__proto__ || Object.getPrototypeOf(DeferredDesigner)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      fetchingBundle: true
	    }, _this.componentDidMount = function () {
	      _this.fetchDesignerBundle();
	    }, _this.fetchDesignerBundle = function () {
	      __webpack_require__.e/* nsure */(1, function (require) {
	        Designer = __webpack_require__(292).default;
	        _this.setState({ fetchingBundle: false });
	      });
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(DeferredDesigner, [{
	    key: 'render',
	    value: function render() {
	      return this.state.fetchingBundle ? null : _react2.default.createElement(Designer, this.props);
	    }
	  }]);
	
	  return DeferredDesigner;
	}(_react2.default.Component);
	
	exports.default = DeferredDesigner;

/***/ },
/* 1075 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.initialDesigner = undefined;
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _WizardClasses = __webpack_require__(35);
	
	var Classes = _interopRequireWildcard(_WizardClasses);
	
	var _shortid = __webpack_require__(22);
	
	var _shortid2 = _interopRequireDefault(_shortid);
	
	var _deepCopy = __webpack_require__(284);
	
	var _deepCopy2 = _interopRequireDefault(_deepCopy);
	
	var _utilities = __webpack_require__(8);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var initialStepId = _shortid2.default.generate();
	var initialSectionId = _shortid2.default.generate();
	var initialFieldId = _shortid2.default.generate();
	
	var initialDesigner = exports.initialDesigner = {
	  loading: true,
	  activeStep: 0,
	  wizard: {
	    title: "New Wizard",
	    description: "Description",
	    lastModifiedDate: null,
	    formDefinitionId: 0,
	    category: "business",
	    entityTypeId: 54,
	    entitySubTypeId: 202,
	    sourceId: 0,
	    webUserAccessLevelTypeId: 100,
	    webUserAccessLevelAfterActivation: 100,
	    meta: {},
	    globalVariables: {
	      boolean: {
	        order: [],
	        variables: {}
	      },
	      string: {
	        order: [],
	        variables: {}
	      },
	      number: {
	        order: [],
	        variables: {}
	      },
	      businessRule: {
	        order: [],
	        variables: {}
	      }
	    },
	    wizardAttributesLogic: { nodes: {}, comments: {} },
	    abbreviation: '',
	    docTitleSrc: '',
	    docId: '',
	    formTitle: '',
	    noLoginRequired: false,
	    internalReviewRequired: false,
	    notAvailableOnline: false,
	    stepOrder: [initialStepId],
	    steps: _defineProperty({}, initialStepId, new _WizardClasses.Step({ stepId: initialStepId, sectionOrder: [initialSectionId] })),
	    sections: _defineProperty({}, initialSectionId, new _WizardClasses.Section({ sectionId: initialSectionId, stepId: initialStepId, fieldOrder: [initialFieldId] })),
	    fields: _defineProperty({}, initialFieldId, new _WizardClasses.Field({ fieldId: initialFieldId, parent: { type: "SECTION", id: initialSectionId } }))
	  },
	  clipboard: null,
	  selected: {},
	  previewing: false,
	  dirty: false,
	  hoverId: null,
	  auditLogs: [],
	  auditError: null,
	  serverOptionsCache: {}
	};
	
	var copyFieldAndSubFieldsByField = function copyFieldAndSubFieldsByField(state, incomingField, incomingSubfields) {
	  var field = (0, _deepCopy2.default)(incomingField);
	  var newFieldId = _shortid2.default.generate();
	  field.fieldId = newFieldId;
	  // field.conditions = null;
	  field.conditions = cacheConditionParentNames(field.conditions, state.wizard.fields);
	  var subfields = {};
	
	  if (field.hasOptionFields) {
	    var options = [];
	    field.options.forEach(function (option) {
	      var optionFields = [];
	      option.fields.forEach(function (fieldId) {
	        console.log(state);
	        var subfield = incomingSubfields ? incomingSubfields[fieldId] : (0, _deepCopy2.default)(state.wizard.fields[fieldId]);
	        var newId = _shortid2.default.generate();
	        subfield.fieldId = newId;
	        subfield.parent.id = newFieldId;
	        // subfield.conditions = null;
	        subfield.conditions = cacheConditionParentNames(subfield.conditions, state.wizard.fields);
	        subfields[newId] = subfield;
	        optionFields.push(newId);
	      });
	      option.fields = optionFields;
	      options.push(option);
	    });
	    field.options = options;
	  }
	
	  if (field.type === 'repeater') {
	    var template = [];
	    field.template.forEach(function (fieldId) {
	      var newId = _shortid2.default.generate();
	      var subfield = incomingSubfields ? incomingSubfields[fieldId] : (0, _deepCopy2.default)(state.wizard.fields[fieldId]);
	      subfield.fieldId = newId;
	      subfield.parent.id = newFieldId;
	      // subfield.conditions = null;
	      subfield.conditions = cacheConditionParentNames(subfield.conditions, state.wizard.fields);
	      subfields[newId] = subfield;
	      template.push(newId);
	    });
	    field.template = template;
	  }
	
	  if (field.hasCheckFields) {
	    var checkedFields = [];
	    var uncheckedFields = [];
	    field.checkedFields.forEach(function (fieldId) {
	      var newId = _shortid2.default.generate();
	      var subfield = incomingSubfields ? incomingSubfields[fieldId] : (0, _deepCopy2.default)(state.wizard.fields[fieldId]);
	      subfield.fieldId = newId;
	      subfield.parent.id = newFieldId;
	      // subfield.conditions = null;
	      subfield.conditions = cacheConditionParentNames(subfield.conditions, state.wizard.fields);
	      subfields[newId] = subfield;
	      checkedFields.push(newId);
	    });
	    field.uncheckedFields.forEach(function (fieldId) {
	      var newId = _shortid2.default.generate();
	      var subfield = incomingSubfields ? incomingSubfields[fieldId] : (0, _deepCopy2.default)(state.wizard.fields[fieldId]);
	      subfield.fieldId = newId;
	      subfield.parent.id = newFieldId;
	      // subfield.conditions = null;
	      subfield.conditions = cacheConditionParentNames(subfield.conditions, state.wizard.fields);
	      subfields[newId] = subfield;
	      uncheckedFields.push(newId);
	    });
	    field.checkedFields = checkedFields;
	    field.uncheckedFields = uncheckedFields;
	  }
	  return { field: field, subfields: subfields };
	};
	
	var cacheConditionParentNames = function cacheConditionParentNames(conditions, fields) {
	  return conditions ? conditions.map(function (c) {
	    return Object.assign({}, c, { parentName: (fields[c.parentId] || {}).name });
	  }) : conditions;
	};
	
	var getFieldsWithFilteredConditions = function getFieldsWithFilteredConditions() {
	  var fields = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	  var allFields = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	  return Object.entries(fields).reduce(function (obj, _ref) {
	    var _ref2 = _slicedToArray(_ref, 2),
	        key = _ref2[0],
	        field = _ref2[1];
	
	    return Object.assign({}, obj, _defineProperty({}, key, Object.assign({}, field, { conditions: filterUnresolvableConditons(field.conditions, allFields) })));
	  }, {});
	};
	
	var filterUnresolvableConditons = function filterUnresolvableConditons(conditions, fields) {
	  if (conditions) {
	    var filtered = conditions.map(function (c) {
	      var parentName = c.parentName,
	          condition = _objectWithoutProperties(c, ['parentName']);
	
	      var parents = (0, _utilities.getFieldByKey)(parentName, 'name', fields, 'array');
	      if (parents.length === 1) {
	        var parent = parents[0];
	        if (parent.type === condition.parentType) {
	          return Object.assign({}, condition, { parentId: parent.fieldId });
	        } else {
	          return null;
	        }
	      } else {
	        return null;
	      }
	    }).filter(function (x) {
	      return x !== null;
	    });
	    if (filtered.length === 0) {
	      return null;
	    } else {
	      return filtered;
	    }
	  }
	  return conditions;
	};
	
	// const getArrayOfAllFieldIdsByStepId = (state, stepId) => {
	//   let fields = []
	//   state.wizard.steps[stepId].sectionOrder.forEach(sectionId=>{
	//     fields = [...fields, ...state.wizard.sections[sectionId].fieldOrder]
	//   })
	//   return fields;
	// }
	
	var copySectionAndFieldsBySectionId = function copySectionAndFieldsBySectionId(state, sectionId) {
	  var fields = {};
	  var subfields = {};
	
	  var newSectionId = _shortid2.default.generate();
	  var newSection = Object.assign({}, state.wizard.sections[sectionId], { sectionId: newSectionId, fieldOrder: [], stepId: null });
	  state.wizard.sections[sectionId].fieldOrder.forEach(function (fieldId) {
	    var _copyFieldAndSubField = copyFieldAndSubFieldsByField(state, state.wizard.fields[fieldId]),
	        newField = _copyFieldAndSubField.field,
	        newSubFields = _copyFieldAndSubField.subfields;
	
	    newSection.fieldOrder.push(newField.fieldId);
	    fields = Object.assign({}, fields, _defineProperty({}, newField.fieldId, Object.assign({}, newField, { parent: { type: 'SECTION', id: newSectionId } })));
	    subfields = Object.assign({}, subfields, newSubFields);
	  });
	  var section = newSection;
	
	  return { section: section, fields: fields, subfields: subfields };
	};
	
	var copySectionsFieldsAndSubFieldsByStepId = function copySectionsFieldsAndSubFieldsByStepId(state, stepId) {
	  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	
	  var sectionIds = state.wizard.steps[stepId].sectionOrder;
	  var sections = {};
	  var fields = {};
	  var subfields = {};
	  sectionIds.forEach(function (sectionId) {
	    var newSectionId = _shortid2.default.generate();
	    var newSection = Object.assign({}, state.wizard.sections[sectionId], {
	      sectionId: newSectionId,
	      fieldOrder: [],
	      stepId: stepId
	    });
	    state.wizard.sections[sectionId].fieldOrder.forEach(function (fieldId) {
	      var _ref3 = options.preserveFieldIds ? { field: state.wizard.fields[fieldId], subfields: subfields } : copyFieldAndSubFieldsByField(state, state.wizard.fields[fieldId]),
	          newField = _ref3.field,
	          newSubFields = _ref3.subfields;
	
	      newSection.fieldOrder.push(newField.fieldId);
	      fields = Object.assign({}, fields, _defineProperty({}, newField.fieldId, Object.assign({}, newField, { parent: { type: 'SECTION', id: newSectionId } })));
	      subfields = Object.assign({}, subfields, newSubFields);
	    });
	    sections[newSectionId] = newSection;
	  });
	  return { sections: sections, fields: fields, subfields: subfields };
	};
	
	var getFieldsWithoutSubFields = function getFieldsWithoutSubFields(field, fields) {
	  if (field.hasOptionFields) {
	    field.options.forEach(function (option) {
	      option.fields.forEach(function (fieldId) {
	        fields = deleteChildConditions(fields[fieldId], fields);
	        delete fields[fieldId];
	      });
	    });
	  }
	  if (field.hasCheckFields) {
	    field.checkedFields.forEach(function (fieldId) {
	      fields = deleteChildConditions(fields[fieldId], fields);
	      delete fields[fieldId];
	    });
	    field.uncheckedFields.forEach(function (fieldId) {
	      fields = deleteChildConditions(fields[fieldId], fields);
	      delete fields[fieldId];
	    });
	  }
	  if (field.template) {
	    field.template.forEach(function (fieldId) {
	      fields = deleteChildConditions(fields[fieldId], fields);
	      delete fields[fieldId];
	    });
	  }
	  fields = deleteChildConditions(field, Object.assign({}, fields));
	  return fields;
	};
	
	var recursivelyDeleteFields = function recursivelyDeleteFields(fieldId, fields, index, fieldOrder, callback) {
	  var computedFields = getFieldsWithoutSubFields(fields[fieldId], fields);
	  delete computedFields[fieldId];
	  if (fieldOrder[index + 1]) {
	    recursivelyDeleteFields(fieldOrder[index + 1], computedFields, index + 1, fieldOrder, callback);
	  } else {
	    callback(computedFields);
	  }
	};
	
	var deleteStepByStepId = function deleteStepByStepId(state, stepId) {
	  var step = state.wizard.steps[stepId];
	  var stepIndex = state.wizard.stepOrder.findIndex(function (fstepId) {
	    return fstepId === stepId;
	  });
	  var fields = Object.assign({}, state.wizard.fields);
	  var sections = Object.assign({}, state.wizard.sections);
	  var steps = Object.assign({}, state.wizard.steps);
	  var sectionOrder = step.sectionOrder;
	
	  sectionOrder.forEach(function (sectionId) {
	    var fieldOrder = sections[sectionId].fieldOrder;
	    if (fieldOrder.length > 0) {
	      recursivelyDeleteFields(fieldOrder[0], fields, 0, fieldOrder, function (computedFields) {
	        fields = computedFields;
	      });
	    }
	    delete sections[sectionId];
	  });
	  delete steps[stepId];
	
	  return Object.assign({}, state, { dirty: true,
	    wizard: Object.assign({}, state.wizard, {
	      fields: fields,
	      sections: sections,
	      steps: steps,
	      stepOrder: [].concat(_toConsumableArray(state.wizard.stepOrder.slice(0, stepIndex)), _toConsumableArray(state.wizard.stepOrder.slice(stepIndex + 1)))
	    }),
	    selected: {},
	    activeStep: null
	  });
	};
	
	var deleteChildConditions = function deleteChildConditions(field, fields) {
	  Object.keys(fields).forEach(function (fieldId) {
	    var subfield = fields[fieldId];
	    if (subfield.conditions) {
	      fields[fieldId] = Object.assign({}, fields[fieldId], {
	        conditions: subfield.conditions.filter(function (cond) {
	          return field ? cond.parentId !== field.fieldId : false;
	        })
	      });
	    }
	  });
	  return fields;
	};
	
	var designer2Reducer = function designer2Reducer() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialDesigner;
	  var action = arguments[1];
	
	  switch (action.type) {
	    case "@@DESIGNER_RESET_STATE":
	      return initialDesigner;
	    case "POPULATE_DESIGNER_STEPS":
	      return Object.assign({}, state, {
	        wizard: Object.assign({}, state.wizard, {
	          stepOrder: action.stepOrder,
	          steps: action.steps,
	          sections: action.sections,
	          fields: action.fields
	        })
	      });
	    case "POPULATE_DESIGNER":
	      return Object.assign({}, state, {
	        loading: false,
	        steps: action.steps,
	        wizard: Object.assign({}, state.wizard, {
	          title: action.title,
	          formDefinitionId: action.formDefinitionId,
	          description: action.description,
	          lastModifiedDate: action.lastModifiedDate,
	          lastModifiedName: action.lastModifiedName,
	          category: action.category,
	          stepOrder: action.stepOrder,
	          steps: action.steps,
	          sections: action.sections,
	          fields: action.fields,
	          sourceId: action.sourceId,
	          abbreviation: action.abbreviation,
	          meta: action.meta ? action.meta : {},
	          mode: action.mode ? action.mode : '',
	          docTitleSrc: action.docTitleSrc,
	          docId: action.docId,
	          formTitle: action.formTitle,
	          internalReviewRequired: action.internalReviewRequired,
	          noLoginRequired: action.noLoginRequired,
	          notAvailableOnline: action.notAvailableOnline,
	          onlyRenderChangedFieldsOnForm: action.onlyRenderChangedFieldsOnForm,
	          feeDescription: action.feeDescription,
	          webUserAccessLevelTypeId: action.webUserAccessLevelTypeId,
	          webUserAccessLevelAfterActivation: action.webUserAccessLevelAfterActivation,
	          draftsDisabled: action.draftsDisabled
	        }, action.globalVariables ? { globalVariables: action.globalVariables } : {}, action.wizardAttributesLogic ? { wizardAttributesLogic: action.wizardAttributesLogic } : {}),
	        selected: {},
	        previewing: false
	      });
	    case "@@ds/SET_LOADING":
	      return Object.assign({}, state, { loading: action.loading });
	    case "RESET_DESIGNER_STATE":
	      return Object.assign({}, initialDesigner, { clipboard: state.clipboard, loading: false });
	    case "SET_FORM_DEFINITION_ID":
	      return Object.assign({}, state, { wizard: Object.assign({}, state.wizard, { formDefinitionId: action.formDefinitionId }) });
	    case "SET_CURRENT_REVISION_ID":
	      return Object.assign({}, state, { wizard: Object.assign({}, state.wizard, { currentRevisionId: action.currentRevisionId }) });
	    case "SET_WIZARD_REVISION_HISTORY":
	      return Object.assign({}, state, { wizard: Object.assign({}, state.wizard, { revisionList: action.revisionList }) });
	    case "@@ds/SET_WIZARD_CATEGORY":
	      return Object.assign({}, state, { dirty: true, wizard: Object.assign({}, state.wizard, { category: action.category }) });
	    case "@@ds/SET_AUDIT_LOGS":
	      return Object.assign({}, state, { auditLogs: action.auditLogs, auditError: null });
	    case "@@ds/SET_AUDIT_ERROR":
	      return Object.assign({}, state, { auditError: action.auditError });
	    case "TOGGLE_PREVIEW":
	      return Object.assign({}, state, { previewing: action.previewing });
	    case "ADD_STEP":
	      {
	        var stepId = _shortid2.default.generate();
	        return Object.assign({}, state, { dirty: true, wizard: Object.assign({}, state.wizard, {
	            steps: Object.assign({}, state.wizard.steps, _defineProperty({}, stepId, new _WizardClasses.Step({ stepId: stepId }))),
	            stepOrder: [].concat(_toConsumableArray(state.wizard.stepOrder), [stepId])
	          })
	        });
	      }
	    case "ADD_SECTION":
	      {
	        var sectionId = _shortid2.default.generate();
	        return Object.assign({}, state, { dirty: true, wizard: Object.assign({}, state.wizard, {
	            sections: Object.assign({}, state.wizard.sections, _defineProperty({}, sectionId, new _WizardClasses.Section({ sectionId: sectionId, stepId: state.wizard.steps[state.wizard.stepOrder[state.activeStep]].stepId }))),
	            steps: Object.assign({}, state.wizard.steps, _defineProperty({}, state.wizard.stepOrder[state.activeStep], Object.assign({}, state.wizard.steps[state.wizard.stepOrder[state.activeStep]], {
	              sectionOrder: [].concat(_toConsumableArray(state.wizard.steps[state.wizard.stepOrder[state.activeStep]].sectionOrder), [sectionId])
	            })))
	          })
	        });
	      }
	    case "ADD_FIELD":
	      {
	        var fieldId = _shortid2.default.generate();
	        return Object.assign({}, state, { dirty: true,
	          selected: { type: 'FIELD', id: fieldId },
	          wizard: Object.assign({}, state.wizard, {
	            fields: Object.assign({}, state.wizard.fields, _defineProperty({}, fieldId, new Classes[action.fieldClass](Object.assign({}, action.properties, { fieldId: fieldId, parent: { type: "SECTION", id: action.sectionId } })))),
	            sections: Object.assign({}, state.wizard.sections, _defineProperty({}, action.sectionId, Object.assign({}, state.wizard.sections[action.sectionId], {
	              fieldOrder: [].concat(_toConsumableArray(state.wizard.sections[action.sectionId].fieldOrder), [fieldId])
	            })))
	          })
	        });
	      }
	    case "ADD_FIELD_ABOVE":
	      {
	        var _fieldId = _shortid2.default.generate();
	        var fieldIndex = state.wizard.sections[action.sectionId].fieldOrder.findIndex(function (id) {
	          return id === action.fieldId;
	        });
	        return Object.assign({}, state, {
	          dirty: true,
	          selected: { type: 'FIELD', id: _fieldId },
	          wizard: Object.assign({}, state.wizard, {
	            fields: Object.assign({}, state.wizard.fields, _defineProperty({}, _fieldId, new Classes[action.fieldClass](Object.assign({}, action.properties, {
	              fieldId: _fieldId,
	              parent: { type: 'SECTION', id: action.sectionId }
	            })))),
	            sections: Object.assign({}, state.wizard.sections, _defineProperty({}, action.sectionId, Object.assign({}, state.wizard.sections[action.sectionId], {
	              fieldOrder: [].concat(_toConsumableArray(state.wizard.sections[action.sectionId].fieldOrder.slice(0, fieldIndex)), [_fieldId], _toConsumableArray(state.wizard.sections[action.sectionId].fieldOrder.slice(fieldIndex)))
	            })))
	          })
	        });
	      }
	    case "ADD_FIELD_UNDER":
	      {
	        var _fieldId2 = _shortid2.default.generate();
	        var _fieldIndex = state.wizard.sections[action.sectionId].fieldOrder.findIndex(function (id) {
	          return id === action.fieldId;
	        });
	        return Object.assign({}, state, {
	          dirty: true,
	          selected: { type: 'FIELD', id: _fieldId2 },
	          wizard: Object.assign({}, state.wizard, {
	            fields: Object.assign({}, state.wizard.fields, _defineProperty({}, _fieldId2, new Classes[action.fieldClass](Object.assign({}, action.properties, {
	              fieldId: _fieldId2,
	              parent: { type: 'SECTION', id: action.sectionId }
	            })))),
	            sections: Object.assign({}, state.wizard.sections, _defineProperty({}, action.sectionId, Object.assign({}, state.wizard.sections[action.sectionId], {
	              fieldOrder: [].concat(_toConsumableArray(state.wizard.sections[action.sectionId].fieldOrder.slice(0, _fieldIndex + 1)), [_fieldId2], _toConsumableArray(state.wizard.sections[action.sectionId].fieldOrder.slice(_fieldIndex + 1)))
	            })))
	          })
	        });
	      }
	    case "DELETE_FIELD":
	      {
	        var field = state.wizard.fields[action.fieldId];
	        var sections = Object.assign({}, state.wizard.sections);
	        var selected = Object.assign({}, state.selected);
	
	        var _state$wizard$fields = state.wizard.fields,
	            toDelete = _state$wizard$fields[action.fieldId],
	            fields = _objectWithoutProperties(_state$wizard$fields, [action.fieldId]);
	
	        fields = getFieldsWithoutSubFields(field, fields);
	
	        if (field.parent) {
	          switch (field.parent.type.toUpperCase()) {
	            case "SECTION":
	              var section = state.wizard.sections[field.parent.id];
	              var fieldOrderIndex = section.fieldOrder.indexOf(action.fieldId);
	              sections = Object.assign({}, sections, _defineProperty({}, field.parent.id, Object.assign({}, section, {
	                fieldOrder: [].concat(_toConsumableArray(section.fieldOrder.slice(0, fieldOrderIndex)), _toConsumableArray(section.fieldOrder.slice(fieldOrderIndex + 1)))
	              })));
	              selected = {};
	              break;
	            case "OPTION":
	              var optionIndex = null;
	              var _fieldIndex2 = null;
	              var selectedField = fields[state.selected.id] || {};
	              var selectedFieldOptions = selectedField.options || [];
	              selectedFieldOptions.forEach(function (option, i) {
	                var index = option.fields.findIndex(function (fieldId) {
	                  return fieldId === action.fieldId;
	                });
	                if (index >= 0) {
	                  optionIndex = i;
	                  _fieldIndex2 = option.fields.indexOf(action.fieldId);
	                }
	              });
	              fields = Object.assign({}, fields, _defineProperty({}, state.selected.id, Object.assign({}, selectedField, {
	                options: [].concat(_toConsumableArray(selectedFieldOptions.slice(0, optionIndex)), [Object.assign({}, selectedFieldOptions[optionIndex], {
	                  fields: [].concat(_toConsumableArray(((selectedFieldOptions[optionIndex] || {}).fields || []).slice(0, _fieldIndex2)), _toConsumableArray(((selectedFieldOptions[optionIndex] || {}).fields || []).slice(_fieldIndex2 + 1)))
	                })], _toConsumableArray(selectedFieldOptions.slice(optionIndex + 1)))
	              })));
	              break;
	            case "CHECKBOX":
	              var parentField = Object.assign({}, fields[state.selected.id]);
	              var checkedFieldIndex = parentField.checkedFields.findIndex(function (id) {
	                return id === action.fieldId;
	              });
	              var uncheckedFieldIndex = parentField.uncheckedFields.findIndex(function (id) {
	                return id === action.fieldId;
	              });
	              var checkIndex = checkedFieldIndex >= 0 ? checkedFieldIndex : uncheckedFieldIndex;
	              var checkType = checkedFieldIndex >= 0 ? "checkedFields" : "uncheckedFields";
	              fields = Object.assign({}, fields, _defineProperty({}, state.selected.id, Object.assign({}, parentField, _defineProperty({}, checkType, [].concat(_toConsumableArray(parentField[checkType].slice(0, checkIndex)), _toConsumableArray(parentField[checkType].slice(checkIndex + 1)))))));
	              break;
	            case "REPEATER":
	              {
	                var parentId = state.selected.id;
	                var _parentField = state.wizard.fields[parentId];
	                var templateIndex = _parentField.template.findIndex(function (id) {
	                  return id === action.fieldId;
	                });
	                //let templateName = state.wizard.fields[action.fieldId].name;
	                //const { [parentId]: deletedValue, ...value } = fields[parentId].value;
	                fields = Object.assign({}, fields, _defineProperty({}, parentId, Object.assign({}, _parentField, {
	                  template: [].concat(_toConsumableArray(_parentField.template.slice(0, templateIndex)), _toConsumableArray(_parentField.template.slice(templateIndex + 1)))
	                  //value
	                })));
	                break;
	              }
	            default:
	          }
	        }
	        return Object.assign({}, state, { dirty: true, wizard: Object.assign({}, state.wizard, {
	            sections: sections,
	            fields: fields
	          }),
	          selected: selected
	        });
	      }
	    case "DELETE_NESTED_OPTION":
	      {
	        var _parentField2 = state.wizard.fields[action.parentId];
	        var option = _parentField2.options[action.optionIndex];
	        var _fields2 = Object.assign({}, state.wizard.fields);
	        option.fields.forEach(function (fieldId) {
	          delete _fields2[fieldId];
	        });
	        return Object.assign({}, state, {
	          wizard: Object.assign({}, state.wizard, {
	            fields: Object.assign({}, _fields2, _defineProperty({}, action.parentId, Object.assign({}, _parentField2, {
	              options: [].concat(_toConsumableArray(_parentField2.options.slice(0, action.optionIndex)), _toConsumableArray(_parentField2.options.slice(action.optionIndex + 1)))
	            })))
	          })
	        });
	      }
	    case "SELECT":
	      return Object.assign({}, state, { selected: { type: action.selectType, id: action.id } });
	    case "SET_ACTIVE_STEP":
	      return Object.assign({}, state, { activeStep: action.stepIndex });
	    case "SET_FIELD_ATTRIBUTE":
	      if (action.subName) {
	        if (action.subSubName) {
	          return Object.assign({}, state, {
	            dirty: true,
	            wizard: Object.assign({}, state.wizard, {
	              fields: Object.assign({}, state.wizard.fields, _defineProperty({}, action.fieldId, Object.assign({}, state.wizard.fields[action.fieldId], _defineProperty({}, action.attributeName, Object.assign({}, state.wizard.fields[action.fieldId][action.attributeName], _defineProperty({}, action.subName, Object.assign({}, state.wizard.fields[action.fieldId][action.attributeName][action.subName], _defineProperty({}, action.subSubName, action.value))))), action.payload)))
	            })
	          });
	        }
	        return Object.assign({}, state, {
	          dirty: true,
	          wizard: Object.assign({}, state.wizard, {
	            fields: Object.assign({}, state.wizard.fields, _defineProperty({}, action.fieldId, Object.assign({}, state.wizard.fields[action.fieldId], _defineProperty({}, action.attributeName, Object.assign({}, state.wizard.fields[action.fieldId][action.attributeName], _defineProperty({}, action.subName, action.value))), action.payload)))
	          })
	        });
	      } else {
	        return Object.assign({}, state, {
	          dirty: true,
	          wizard: Object.assign({}, state.wizard, {
	            fields: Object.assign({}, state.wizard.fields, _defineProperty({}, action.fieldId, Object.assign({}, state.wizard.fields[action.fieldId], _defineProperty({}, action.attributeName, action.value), action.payload)))
	          })
	        });
	      }
	    case "SET_SECTION_ATTRIBUTE":
	      return Object.assign({}, state, { dirty: true, wizard: Object.assign({}, state.wizard, { sections: Object.assign({}, state.wizard.sections, _defineProperty({}, action.sectionId, Object.assign({}, state.wizard.sections[action.sectionId], _defineProperty({}, action.attributeName, action.value)))) }) });
	    case "SET_STEP_ATTRIBUTE":
	      return Object.assign({}, state, { dirty: true, wizard: Object.assign({}, state.wizard, { steps: Object.assign({}, state.wizard.steps, _defineProperty({}, action.stepId, Object.assign({}, state.wizard.steps[action.stepId], _defineProperty({}, action.attributeName, action.value)))) }) });
	    case "SET_WIZARD_ATTRIBUTE":
	      return Object.assign({}, state, { dirty: true, wizard: Object.assign({}, state.wizard, _defineProperty({}, action.attributeName, action.value)) });
	    case "SET_FIELD_OPTION_PROPERTY":
	      return Object.assign({}, state, { dirty: true, wizard: Object.assign({}, state.wizard, { fields: Object.assign({}, state.wizard.fields, _defineProperty({}, action.selectedFieldId, Object.assign({}, state.wizard.fields[action.selectedFieldId], {
	            options: [].concat(_toConsumableArray(state.wizard.fields[action.selectedFieldId].options.slice(0, action.optionIndex)), [Object.assign({}, state.wizard.fields[action.selectedFieldId].options[action.optionIndex], _defineProperty({}, action.attributeName, action.value))], _toConsumableArray(state.wizard.fields[action.selectedFieldId].options.slice(action.optionIndex + 1)))
	          }))) }) });
	    case "TOGGLE_VALIDATION_EDITOR":
	      return Object.assign({}, state, { validationEditorOpen: action.value });
	    case "ADD_OPTION_SUBFIELD":
	      {
	        var _Object$assign35;
	
	        var _fieldId3 = _shortid2.default.generate();
	        var _fieldIndex3 = state.wizard.fields[state.selected.id].options[action.optionIndex].fields.findIndex(function (id) {
	          return id === action.fieldId;
	        });
	        if (_fieldIndex3 < 0) _fieldIndex3 = 0;
	        var _option = Object.assign({}, state.wizard.fields[state.selected.id].options[action.optionIndex], {
	          fields: [].concat(_toConsumableArray(state.wizard.fields[state.selected.id].options[action.optionIndex].fields.slice(0, _fieldIndex3 + (action.direction === 'under' ? 1 : 0))), [_fieldId3], _toConsumableArray(state.wizard.fields[state.selected.id].options[action.optionIndex].fields.slice(_fieldIndex3 + (action.direction === 'under' ? 1 : 0))))
	        });
	        return Object.assign({}, state, { dirty: true,
	          wizard: Object.assign({}, state.wizard, {
	            fields: Object.assign({}, state.wizard.fields, (_Object$assign35 = {}, _defineProperty(_Object$assign35, state.selected.id, Object.assign({}, state.wizard.fields[state.selected.id], {
	              options: [].concat(_toConsumableArray(state.wizard.fields[state.selected.id].options.slice(0, action.optionIndex)), [_option], _toConsumableArray(state.wizard.fields[state.selected.id].options.slice(action.optionIndex + 1)))
	            })), _defineProperty(_Object$assign35, _fieldId3, new Classes[action.fieldClass](Object.assign({}, action.properties, { fieldId: _fieldId3, parent: { type: "OPTION", id: state.selected.id } }))), _Object$assign35))
	          })
	        });
	      }
	    case "ADD_CHECK_SUBFIELD":
	      {
	        var _Object$assign37;
	
	        var _fieldId4 = _shortid2.default.generate();
	        var _fieldIndex4 = state.wizard.fields[state.selected.id][action.checkType].findIndex(function (id) {
	          return id === action.fieldId;
	        });
	        if (_fieldIndex4 < 0) _fieldIndex4 = 0;
	        return Object.assign({}, state, { dirty: true,
	          wizard: Object.assign({}, state.wizard, {
	            fields: Object.assign({}, state.wizard.fields, (_Object$assign37 = {}, _defineProperty(_Object$assign37, state.selected.id, Object.assign({}, state.wizard.fields[state.selected.id], _defineProperty({}, action.checkType, [].concat(_toConsumableArray(state.wizard.fields[state.selected.id][action.checkType].slice(0, _fieldIndex4 + (action.direction === 'under' ? 1 : 0))), [_fieldId4], _toConsumableArray(state.wizard.fields[state.selected.id][action.checkType].slice(_fieldIndex4 + (action.direction === 'under' ? 1 : 0))))))), _defineProperty(_Object$assign37, _fieldId4, new Classes[action.fieldClass](Object.assign({}, action.properties, { fieldId: _fieldId4, parent: { type: "CHECKBOX", id: state.selected.id } }))), _Object$assign37))
	          })
	        });
	      }
	    case "ADD_REPEATER_SUBFIELD":
	      {
	        var _Object$assign38;
	
	        var _fieldId5 = _shortid2.default.generate();
	        var _fieldIndex5 = state.wizard.fields[state.selected.id].template.findIndex(function (id) {
	          return id === action.fieldId;
	        });
	        if (_fieldIndex5 < 0) _fieldIndex5 = 0;
	        return Object.assign({}, state, {
	          dirty: true,
	          wizard: Object.assign({}, state.wizard, {
	            fields: Object.assign({}, state.wizard.fields, (_Object$assign38 = {}, _defineProperty(_Object$assign38, state.selected.id, Object.assign({}, state.wizard.fields[state.selected.id], {
	              template: [].concat(_toConsumableArray(state.wizard.fields[state.selected.id].template.slice(0, _fieldIndex5 + (action.direction === 'under' ? 1 : 0))), [_fieldId5], _toConsumableArray(state.wizard.fields[state.selected.id].template.slice(_fieldIndex5 + (action.direction === 'under' ? 1 : 0))))
	            })), _defineProperty(_Object$assign38, _fieldId5, new Classes[action.fieldClass](Object.assign({}, action.properties, {
	              fieldId: _fieldId5,
	              parent: { type: 'REPEATER', id: state.selected.id }
	            }))), _Object$assign38))
	          })
	        });
	      }
	    case "ADD_NESTED_FIELD_OPTION":
	      {
	        return Object.assign({}, state, { dirty: true,
	          wizard: Object.assign({}, state.wizard, {
	            fields: Object.assign({}, state.wizard.fields, _defineProperty({}, action.fieldId, Object.assign({}, state.wizard.fields[action.fieldId], {
	              options: [].concat(_toConsumableArray(state.wizard.fields[action.fieldId].options), [{ value: "NEW_OPTION", label: "New Option", fields: [] }])
	            })))
	          })
	        });
	      }
	    case "REORDER_FIELD":
	      {
	        var _field = state.wizard.fields[action.fieldId];
	        var newState = state;
	        switch (_field.parent.type) {
	          case 'SECTION':
	            {
	              var currentFieldOrder = state.wizard.sections[_field.parent.id].fieldOrder;
	              var currentIndex = currentFieldOrder.findIndex(function (fieldId) {
	                return fieldId === action.fieldId;
	              });
	              var newFieldOrder = void 0;
	
	              if (action.direction === "up") {
	                newFieldOrder = [].concat(_toConsumableArray(currentFieldOrder.slice(0, currentIndex - 1)), [action.fieldId, currentFieldOrder[currentIndex - 1]], _toConsumableArray(currentFieldOrder.slice(currentIndex + 1)));
	              } else {
	                newFieldOrder = [].concat(_toConsumableArray(currentFieldOrder.slice(0, currentIndex)), [currentFieldOrder[currentIndex + 1], action.fieldId], _toConsumableArray(currentFieldOrder.slice(currentIndex + 2)));
	              }
	
	              newState = Object.assign({}, state, { dirty: true,
	                wizard: Object.assign({}, state.wizard, {
	                  sections: Object.assign({}, state.wizard.sections, _defineProperty({}, _field.parent.id, Object.assign({}, state.wizard.sections[_field.parent.id], {
	                    fieldOrder: newFieldOrder
	                  })))
	                })
	              });
	              break;
	            }
	          case 'REPEATER':
	            {
	              var _currentFieldOrder = state.wizard.fields[_field.parent.id].template;
	              var _currentIndex = _currentFieldOrder.findIndex(function (fieldId) {
	                return fieldId === action.fieldId;
	              });
	              var template = void 0;
	
	              if (action.direction === "up") {
	                template = [].concat(_toConsumableArray(_currentFieldOrder.slice(0, _currentIndex - 1)), [action.fieldId, _currentFieldOrder[_currentIndex - 1]], _toConsumableArray(_currentFieldOrder.slice(_currentIndex + 1)));
	              } else {
	                template = [].concat(_toConsumableArray(_currentFieldOrder.slice(0, _currentIndex)), [_currentFieldOrder[_currentIndex + 1], action.fieldId], _toConsumableArray(_currentFieldOrder.slice(_currentIndex + 2)));
	              }
	
	              newState = Object.assign({}, state, { dirty: true,
	                wizard: Object.assign({}, state.wizard, {
	                  fields: Object.assign({}, state.wizard.fields, _defineProperty({}, _field.parent.id, Object.assign({}, state.wizard.fields[_field.parent.id], {
	                    template: template
	                  })))
	                })
	              });
	              break;
	            }
	          case 'OPTION':
	            {
	              var parentOptions = state.wizard.fields[_field.parent.id].options;
	              var _optionIndex = parentOptions.findIndex(function (opt) {
	                return opt.fields.includes(action.fieldId);
	              });
	              var _currentIndex2 = parentOptions[_optionIndex].fields.findIndex(function (id) {
	                return id === action.fieldId;
	              });
	              var options = [].concat(_toConsumableArray(parentOptions));
	
	              if (action.direction === "up" && _currentIndex2 !== 0) {
	                options = [].concat(_toConsumableArray(parentOptions.slice(0, _optionIndex)), [Object.assign({}, parentOptions[_optionIndex], {
	                  fields: [].concat(_toConsumableArray(parentOptions[_optionIndex].fields.slice(0, _currentIndex2 - 1)), [action.fieldId, parentOptions[_optionIndex].fields[_currentIndex2 - 1]], _toConsumableArray(parentOptions[_optionIndex].fields.slice(_currentIndex2 + 1)))
	                })], _toConsumableArray(parentOptions.slice(_optionIndex + 1)));
	              }
	              if (action.direction === 'down' && _currentIndex2 !== parentOptions[_optionIndex].fields.length - 1) {
	                options = [].concat(_toConsumableArray(parentOptions.slice(0, _optionIndex)), [Object.assign({}, parentOptions[_optionIndex], {
	                  fields: [].concat(_toConsumableArray(parentOptions[_optionIndex].fields.slice(0, _currentIndex2)), [parentOptions[_optionIndex].fields[_currentIndex2 + 1], action.fieldId], _toConsumableArray(parentOptions[_optionIndex].fields.slice(_currentIndex2 + 2)))
	                })], _toConsumableArray(parentOptions.slice(_optionIndex + 1)));
	              }
	
	              newState = Object.assign({}, state, { dirty: true,
	                wizard: Object.assign({}, state.wizard, {
	                  fields: Object.assign({}, state.wizard.fields, _defineProperty({}, _field.parent.id, Object.assign({}, state.wizard.fields[_field.parent.id], {
	                    options: options
	                  })))
	                })
	              });
	              break;
	            }
	          case 'CHECKBOX':
	            {
	              var parent = state.wizard.fields[state.wizard.fields[action.fieldId].parent.id];
	              var _checkType = 'uncheckedFields';
	              if (parent.checkedFields.find(function (f) {
	                return f === action.fieldId;
	              })) {
	                _checkType = 'checkedFields';
	              }
	
	              var index = state.wizard.fields[_field.parent.id][_checkType].findIndex(function (f) {
	                return f === action.fieldId;
	              });
	              var _currentFieldOrder2 = state.wizard.fields[_field.parent.id][_checkType];
	
	              if (action.direction === 'up') {
	                newState = Object.assign({}, state, { dirty: true,
	                  wizard: Object.assign({}, state.wizard, {
	                    fields: Object.assign({}, state.wizard.fields, _defineProperty({}, _field.parent.id, Object.assign({}, state.wizard.fields[_field.parent.id], _defineProperty({}, _checkType, [].concat(_toConsumableArray(_currentFieldOrder2.slice(0, index - 1)), [action.fieldId, _currentFieldOrder2[index - 1]], _toConsumableArray(_currentFieldOrder2.slice(index + 1)))))))
	                  })
	                });
	              } else {
	                newState = Object.assign({}, state, { dirty: true,
	                  wizard: Object.assign({}, state.wizard, {
	                    fields: Object.assign({}, state.wizard.fields, _defineProperty({}, _field.parent.id, Object.assign({}, state.wizard.fields[_field.parent.id], _defineProperty({}, _checkType, [].concat(_toConsumableArray(_currentFieldOrder2.slice(0, index)), [_currentFieldOrder2[index + 1], action.fieldId], _toConsumableArray(_currentFieldOrder2.slice(index + 2)))))))
	                  })
	                });
	              }
	              break;
	            }
	          default:
	        }
	        return newState;
	      }
	    case "DELETE_SECTION":
	      {
	        var _sections2 = Object.assign({}, state.wizard.sections);
	        var _section = _sections2[action.sectionId];
	        var _fields3 = state.wizard.fields;
	        var fieldOrder = _section.fieldOrder;
	        var _stepId = state.wizard.steps[_section.stepId] ? _section.stepId : Object.keys(state.wizard.steps).find(function (stepId) {
	          return state.wizard.steps[stepId].sectionOrder.find(function (sId) {
	            return _section.sectionId === sId;
	          }) ? true : false;
	        });
	        var step = Object.assign({}, state.wizard.steps[_stepId]);
	        // console.log(section)
	        var sectionOrderIndex = step.sectionOrder.findIndex(function (sectionId) {
	          return sectionId === action.sectionId;
	        });
	
	        var newFields = void 0;
	        if (fieldOrder.length > 0) {
	          recursivelyDeleteFields(fieldOrder[0], _fields3, 0, fieldOrder, function (computedFields) {
	            newFields = computedFields;
	          });
	        } else {
	          newFields = _fields3;
	        }
	
	        step.sectionOrder = [].concat(_toConsumableArray(step.sectionOrder.slice(0, sectionOrderIndex)), _toConsumableArray(step.sectionOrder.slice(sectionOrderIndex + 1)));
	        delete _sections2[action.sectionId];
	
	        return Object.assign({}, state, { dirty: true,
	          wizard: Object.assign({}, state.wizard, {
	            fields: newFields,
	            sections: _sections2,
	            steps: Object.assign({}, state.wizard.steps, _defineProperty({}, _stepId, step))
	          }),
	          selected: {}
	        });
	      }
	    case "DELETE_STEP":
	      {
	        return deleteStepByStepId(state, action.stepId);
	      }
	    case "REORDER_STEP":
	      {
	        var newStepOrder = [];
	        var currentStepOrder = state.wizard.stepOrder;
	        var _currentIndex3 = action.stepIndex;
	        var activeStep = state.activeStep;
	
	        if (action.direction === "up") {
	          newStepOrder = [].concat(_toConsumableArray(currentStepOrder.slice(0, _currentIndex3 - 1)), [action.stepId, currentStepOrder[_currentIndex3 - 1]], _toConsumableArray(currentStepOrder.slice(_currentIndex3 + 1)));
	          activeStep--;
	        } else {
	          newStepOrder = [].concat(_toConsumableArray(currentStepOrder.slice(0, _currentIndex3)), [currentStepOrder[_currentIndex3 + 1], action.stepId], _toConsumableArray(currentStepOrder.slice(_currentIndex3 + 2)));
	          activeStep++;
	        }
	
	        return Object.assign({}, state, { dirty: true,
	          wizard: Object.assign({}, state.wizard, {
	            stepOrder: newStepOrder
	          }),
	          activeStep: activeStep
	        });
	      }
	    case "RECALCULATE_STEP_ORDER":
	      {
	        var _newStepOrder = [];
	        var _currentStepOrder = state.wizard.stepOrder;
	        var _currentIndex4 = _currentStepOrder.findIndex(function (id) {
	          return id === action.reorderedStep;
	        });
	        var _activeStep = _currentStepOrder[state.activeStep];
	
	        // Remove the step
	        _newStepOrder = [].concat(_toConsumableArray(_currentStepOrder.slice(0, _currentIndex4)), _toConsumableArray(_currentStepOrder.slice(_currentIndex4 + 1)));
	
	        var displacedIndex = _newStepOrder.findIndex(function (id) {
	          return id === action.displacedStep;
	        });
	
	        // Replace the step
	        _newStepOrder = [].concat(_toConsumableArray(_newStepOrder.slice(0, displacedIndex + (action.placeBefore ? 0 : 1))), [action.reorderedStep], _toConsumableArray(_newStepOrder.slice(displacedIndex + (action.placeBefore ? 0 : 1))));
	
	        return Object.assign({}, state, { dirty: true,
	          wizard: Object.assign({}, state.wizard, {
	            stepOrder: _newStepOrder
	          }),
	          activeStep: _newStepOrder.findIndex(function (id) {
	            return id === _activeStep;
	          })
	        });
	      }
	    case "REORDER_SECTION":
	      {
	        var newSectionOrder = [];
	        var _section2 = state.wizard.sections[action.sectionId];
	        var currentStepId = _section2.stepId ? _section2.stepId : state.wizard.stepOrder[state.activeStep];
	        var currentSectionOrder = state.wizard.steps[currentStepId].sectionOrder;
	        var _currentIndex5 = action.sectionIndex;
	
	        if (action.direction === "up") {
	          newSectionOrder = [].concat(_toConsumableArray(currentSectionOrder.slice(0, _currentIndex5 - 1)), [action.sectionId, currentSectionOrder[_currentIndex5 - 1]], _toConsumableArray(currentSectionOrder.slice(_currentIndex5 + 1)));
	        } else {
	          newSectionOrder = [].concat(_toConsumableArray(currentSectionOrder.slice(0, _currentIndex5)), [currentSectionOrder[_currentIndex5 + 1], action.sectionId], _toConsumableArray(currentSectionOrder.slice(_currentIndex5 + 2)));
	        }
	
	        return Object.assign({}, state, { dirty: true,
	          wizard: Object.assign({}, state.wizard, {
	            steps: Object.assign({}, state.wizard.steps, _defineProperty({}, currentStepId, Object.assign({}, state.wizard.steps[currentStepId], {
	              sectionOrder: newSectionOrder
	            })))
	          })
	        });
	      }
	    case "COPY_FIELD":
	      {
	        localStorage.setItem('CLIPBOARD', JSON.stringify(copyFieldAndSubFieldsByField(state, state.wizard.fields[action.fieldId])));
	        return state;
	      }
	    case "COPY_SECTION":
	      {
	        var copies = JSON.stringify(copySectionAndFieldsBySectionId(state, action.sectionId));
	        localStorage.setItem('SECTION_CLIPBOARD', copies);
	        return state;
	      }
	    case "COPY_STEP_CONTENTS":
	      {
	        var _copies = copySectionsFieldsAndSubFieldsByStepId(state, action.stepId, { preserveFieldIds: action.preserveFieldIds });
	        localStorage.setItem('STEP_CONTENTS_CLIPBOARD', JSON.stringify(_copies));
	        console.log(_copies);
	        return state;
	      }
	    case "PASTE_SECTION":
	      {
	        var CLIPBOARD = (0, _utilities.getSanitizedLocalStorageValue)('SECTION_CLIPBOARD', true);
	        var _fields4 = getFieldsWithFilteredConditions(CLIPBOARD.fields, state.wizard.fields);
	        var subfields = getFieldsWithFilteredConditions(CLIPBOARD.subfields, state.wizard.fields);
	        var _step = state.wizard.steps[state.wizard.stepOrder[state.activeStep]];
	        localStorage.removeItem('SECTION_CLIPBOARD');
	        return Object.assign({}, state, {
	          dirty: true,
	          selected: { type: 'SECTION', id: CLIPBOARD.section.sectionId },
	          wizard: Object.assign({}, state.wizard, {
	            steps: Object.assign({}, state.wizard.steps, _defineProperty({}, _step.stepId, Object.assign({}, _step, {
	              sectionOrder: [].concat(_toConsumableArray(state.wizard.steps[_step.stepId].sectionOrder), [CLIPBOARD.section.sectionId])
	            }))),
	            sections: Object.assign({}, state.wizard.sections, _defineProperty({}, CLIPBOARD.section.sectionId, Object.assign({}, CLIPBOARD.section, {
	              stepId: _step.stepId
	            }))),
	            fields: Object.assign({}, state.wizard.fields, _fields4, subfields)
	          })
	        });
	      }
	    case "PASTE_STEP_CONTENTS":
	      {
	        var STEP_CONTENTS = (0, _utilities.getSanitizedLocalStorageValue)('STEP_CONTENTS_CLIPBOARD');
	        STEP_CONTENTS = STEP_CONTENTS ? JSON.parse(STEP_CONTENTS) : null;
	        if (STEP_CONTENTS) {
	          var _STEP_CONTENTS = STEP_CONTENTS,
	              incomingSections = _STEP_CONTENTS.sections,
	              _fields5 = _STEP_CONTENTS.fields,
	              _subfields = _STEP_CONTENTS.subfields;
	
	          _fields5 = getFieldsWithFilteredConditions(_fields5, state.wizard.fields);
	          _subfields = getFieldsWithFilteredConditions(_subfields, state.wizard.fields);
	          var _sections3 = {};
	          Object.keys(incomingSections).forEach(function (sectionId) {
	            _sections3[sectionId] = Object.assign({}, incomingSections[sectionId], { stepId: action.stepId });
	          });
	          var _step2 = Object.assign({}, state.wizard.steps[action.stepId]);
	          var _newState = deleteStepByStepId(state, action.stepId);
	          return Object.assign({}, _newState, {
	            dirty: true,
	            selected: { type: 'STEP', id: action.stepId },
	            activeStep: state.wizard.stepOrder.findIndex(function (stepId) {
	              return stepId === action.stepId;
	            }),
	            wizard: Object.assign({}, state.wizard, {
	              steps: Object.assign({}, state.wizard.steps, _defineProperty({}, _step2.stepId, Object.assign({}, _step2, {
	                sectionOrder: Object.keys(_sections3).map(function (sectionId) {
	                  return sectionId;
	                })
	              }))),
	              sections: Object.assign({}, state.wizard.sections, _sections3),
	              fields: Object.assign({}, state.wizard.fields, _fields5, _subfields)
	            })
	          });
	        } else {
	          return state;
	        }
	      }
	    case "PASTE_FIELD":
	      {
	        var _CLIPBOARD = (0, _utilities.getSanitizedLocalStorageValue)('CLIPBOARD');
	        _CLIPBOARD = _CLIPBOARD ? JSON.parse(_CLIPBOARD) : null;
	        if (_CLIPBOARD) {
	          var newfields = copyFieldAndSubFieldsByField(state, _CLIPBOARD.field, _CLIPBOARD.subfields);
	          var _field2 = getFieldsWithFilteredConditions(_defineProperty({}, newfields.field.fieldId, newfields.field), state.wizard.fields)[newfields.field.fieldId];
	          var _subfields2 = getFieldsWithFilteredConditions(newfields.subfields, state.wizard.fields);
	          return Object.assign({}, state, { dirty: true, wizard: Object.assign({}, state.wizard, {
	              fields: Object.assign({}, state.wizard.fields, _defineProperty({}, _field2.fieldId, Object.assign({}, _field2, { parent: Object.assign({}, _field2.parent, { type: 'SECTION', id: action.sectionId }) })), _subfields2),
	              sections: Object.assign({}, state.wizard.sections, _defineProperty({}, action.sectionId, Object.assign({}, state.wizard.sections[action.sectionId], {
	                fieldOrder: [].concat(_toConsumableArray(state.wizard.sections[action.sectionId].fieldOrder), [_field2.fieldId])
	              })))
	            })
	          });
	        } else {
	          return state;
	        }
	      }
	    case 'SET_DIRTY':
	      return Object.assign({}, state, { dirty: action.dirty });
	    case 'SET_HOVER_ID':
	      return Object.assign({}, state, { hoverId: action.hoverId });
	    case '@@ds/SET_GLOBAL_VARIABLES':
	      return Object.assign({}, state, { wizard: Object.assign({}, state.wizard, {
	          globalVariables: action.globalVariables
	        }) });
	    case '@@ds/SET_OPTIONS_CACHE':
	      return Object.assign({}, state, {
	        serverOptionsCache: action.serverOptionsCache
	      });
	    case '@@ds/SET_OPTIONS_CACHE_BY_ID':
	      return Object.assign({}, state, {
	        serverOptionsCache: Object.assign({}, state.serverOptionsCache, _defineProperty({}, action.id, action.options))
	      });
	    default:
	      return state;
	  }
	};
	
	exports.default = designer2Reducer;

/***/ },
/* 1076 */,
/* 1077 */,
/* 1078 */,
/* 1079 */,
/* 1080 */,
/* 1081 */,
/* 1082 */,
/* 1083 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRadioGroup = __webpack_require__(1329);
	
	var _utilities = __webpack_require__(8);
	
	var _Attribute = __webpack_require__(290);
	
	var _shortid = __webpack_require__(22);
	
	var _shortid2 = _interopRequireDefault(_shortid);
	
	var _masks = __webpack_require__(1166);
	
	var _masks2 = _interopRequireDefault(_masks);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var MaskEditor = function (_Component) {
		_inherits(MaskEditor, _Component);
	
		function MaskEditor(props) {
			_classCallCheck(this, MaskEditor);
	
			var _this = _possibleConstructorReturn(this, (MaskEditor.__proto__ || Object.getPrototypeOf(MaskEditor)).call(this, props));
	
			_initialiseProps.call(_this);
	
			_this.name = _shortid2.default.generate();
			_this.state = {
				selected: props.field.mask[0] ? props.field.mask[0].fn : '',
				props: _this.buildMaskObject(props),
				allowedMasks: props.field.allowedMasks
			};
			return _this;
		}
	
		_createClass(MaskEditor, [{
			key: 'render',
			value: function render() {
				var _this2 = this;
	
				var _props = this.props,
				    disabled = _props.disabled,
				    leftAlign = _props.leftAlign;
				var _state = this.state,
				    selected = _state.selected,
				    props = _state.props,
				    allowedMasks = _state.allowedMasks;
	
				return _react2.default.createElement(
					'div',
					{ className: 'validation-editor' },
					_react2.default.createElement(
						'div',
						{ className: 'row' },
						_react2.default.createElement(
							'div',
							{ className: 'col-6 rule-container' },
							_react2.default.createElement(
								_reactRadioGroup.RadioGroup,
								{
									name: this.name,
									selectedValue: selected,
									className: 'radio-group ' + (disabled ? 'disabled' : ''),
									onChange: this.setMaskValue
								},
								_react2.default.createElement(
									'div',
									null,
									_react2.default.createElement(
										'div',
										{ role: 'tablist', 'aria-label': 'Input Mask Options', 'aria-orientation': 'vertical' },
										allowedMasks.map(function (maskId, i) {
											return _react2.default.createElement(
												'div',
												{ 'aria-selected': selected === _masks2.default[maskId].fn, role: 'tab' },
												_react2.default.createElement(OptionRow, Object.assign({
													leftAlign: leftAlign,
													disabled: disabled
												}, _masks2.default[maskId], {
													selected: selected === _masks2.default[maskId].fn,
													onChange: _this2.setMaskValue,
													key: maskId
												}))
											);
										})
									)
								)
							)
						),
						_react2.default.createElement(
							'div',
							{ className: 'attribute-container col-6' },
							_react2.default.createElement(
								'div',
								{ className: 'no-outline', tabIndex: '0', role: 'tabpanel' },
								selected !== "" && props ? Object.keys(props).length === 0 ? _react2.default.createElement(
									'div',
									{ className: 'options-message' },
									'This mask has no additional options.'
								) : Object.keys(props).map(function (propId) {
									var prop = props[propId];
									return _react2.default.createElement(
										'div',
										null,
										_react2.default.createElement(_Attribute.Attribute, {
											label: prop.label,
											type: prop.type,
											name: propId,
											value: prop.value,
											maxValue: prop.maxValue,
											minValue: prop.minValue,
											step: prop.step,
											handleChange: _this2.setPropValue,
											key: propId
										})
									);
								}) : null
							)
						)
					)
				);
			}
		}]);
	
		return MaskEditor;
	}(_react.Component);
	
	var _initialiseProps = function _initialiseProps() {
		var _this3 = this;
	
		this.buildMaskObject = function (props) {
			var maskProps = {};
			if (props.field.mask[0]) {
				Object.keys(_masks2.default[props.field.mask[0].fn].props).forEach(function (propId) {
					maskProps[propId] = Object.assign({}, _masks2.default[props.field.mask[0].fn].props[propId], { value: (props.field.mask[0].props || {})[propId] });
				});
			}
			return maskProps;
		};
	
		this.clearState = function () {
			_this3.setState({
				selected: _this3.props.field.mask[0] ? _this3.props.field.mask[0].fn : '',
				props: _this3.buildMaskObject(_this3.props)
			});
		};
	
		this.setMaskValue = function (fn) {
			_this3.setState({
				selected: _this3.state.selected === fn ? '' : fn,
				props: _masks2.default[fn].props
			});
			var firstElement = (0, _utilities.getFirstFocusableScopedElement)(".attribute-container");
			if (firstElement) {
				firstElement.focus();
			}
		};
	
		this.saveRules = function () {
			var newProps = {};
			Object.keys(_this3.state.props).forEach(function (propId) {
				newProps[propId] = _this3.state.props[propId].value;
			});
			_this3.props.handleChange('mask', _this3.state.selected !== '' ? [{ fn: _this3.state.selected, props: newProps }] : []);
		};
	
		this.setPropValue = function (name, value) {
			_this3.setState(function (state) {
				return {
					props: Object.assign({}, state.props, _defineProperty({}, name, Object.assign({}, state.props[name], { value: value })))
				};
			});
		};
	};
	
	exports.default = MaskEditor;
	
	var OptionRow = function (_Component2) {
		_inherits(OptionRow, _Component2);
	
		function OptionRow() {
			_classCallCheck(this, OptionRow);
	
			var _this4 = _possibleConstructorReturn(this, (OptionRow.__proto__ || Object.getPrototypeOf(OptionRow)).call(this));
	
			_this4.setMaskValue = function () {
				_this4.props.onChange(_this4.props.fn);
			};
	
			_this4.handleKeyDown = function (e) {
				if (e.keyCode === 13 || e.keyCode === 32) {
					_this4.setMaskValue();
				}
			};
	
			_this4.name = _shortid2.default.generate();
			return _this4;
		}
	
		_createClass(OptionRow, [{
			key: 'render',
			value: function render() {
				var _props2 = this.props,
				    leftAlign = _props2.leftAlign,
				    name = _props2.name,
				    selected = _props2.selected;
	
				return _react2.default.createElement(
					'div',
					{ tabIndex: '0', onKeyDown: this.handleKeyDown,
						className: 'custom-focus ' + 'option-wrapper rule ' + (leftAlign ? 'left-align ' : ' ') + (selected ? 'checked ' : ''),
						onClick: this.setMaskValue
					},
					_react2.default.createElement(
						'label',
						{
							className: 'field-label radio-label rule-name',
							htmlFor: this.name
						},
						name
					)
				);
			}
		}]);
	
		return OptionRow;
	}(_react.Component);

/***/ },
/* 1084 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Modal = __webpack_require__(13);
	
	var _Portal = __webpack_require__(12);
	
	var _Portal2 = _interopRequireDefault(_Portal);
	
	var _utilities = __webpack_require__(8);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var MetaEditor = function (_Component) {
	  _inherits(MetaEditor, _Component);
	
	  function MetaEditor(props) {
	    _classCallCheck(this, MetaEditor);
	
	    var _this = _possibleConstructorReturn(this, (MetaEditor.__proto__ || Object.getPrototypeOf(MetaEditor)).call(this));
	
	    _initialiseProps.call(_this);
	
	    var pairs = Object.keys(props.pairs).map(function (key) {
	      return { key: key, value: props.pairs[key] };
	    });
	    _this.state = { modalOpen: false, pairs: pairs };
	    return _this;
	  }
	
	  _createClass(MetaEditor, [{
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'meta-editor block-wrapper' },
	        _react2.default.createElement(
	          'button',
	          { className: 'attribute-button', onClick: this.toggleModal },
	          this.props.buttonLabel || "Edit Metadata"
	        ),
	        _react2.default.createElement(
	          _Portal2.default,
	          { isOpened: this.state.modalOpen },
	          _react2.default.createElement(
	            _Modal.Modal,
	            { title: 'Edit Metadata', closeModal: this.toggleModal, modalSize: 'small', saveAndCloseButton: true, cancelButton: true, save: this.save, cancel: _utilities.noop },
	            this.state.pairs.length > 0 ? _react2.default.createElement(
	              'div',
	              { className: 'modal-head meta-head' },
	              _react2.default.createElement(
	                'div',
	                { className: 'head key-head' },
	                'Key'
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'head value-head' },
	                'Value'
	              )
	            ) : null,
	            _react2.default.createElement(
	              'div',
	              { className: 'block-wrapper padded pairs' },
	              this.state.pairs.map(function (pair, i) {
	                return _react2.default.createElement(MetaPair, {
	                  pair: pair,
	                  pairIndex: i,
	                  setKey: _this2.setKey,
	                  setValue: _this2.setValue,
	                  deletePair: _this2.deletePair,
	                  isLast: i === 0 && _this2.state.pairs.length - 1 === 0,
	                  key: i
	                });
	              }),
	              _react2.default.createElement(
	                'button',
	                { className: 'add-pair', onClick: this.addPair },
	                '+ Add New Meta Value'
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return MetaEditor;
	}(_react.Component);
	
	var _initialiseProps = function _initialiseProps() {
	  var _this3 = this;
	
	  this.componentDidUpdate = function (prevProps) {
	    if (prevProps.id !== _this3.props.id) {
	      var pairs = Object.keys(_this3.props.pairs).map(function (key) {
	        return { key: key, value: _this3.props.pairs[key] };
	      });
	      _this3.setState({ pairs: pairs });
	    }
	  };
	
	  this.toggleModal = function () {
	    _this3.setState({ modalOpen: !_this3.state.modalOpen });
	  };
	
	  this.addPair = function () {
	    var pairs = [].concat(_toConsumableArray(_this3.state.pairs), [{ key: "", value: "" }]);
	    _this3.setState({ pairs: pairs });
	  };
	
	  this.setKey = function (value, index) {
	    value = value.replace(" ", "_").replace("-", "_").toUpperCase();
	    var pairs = [].concat(_toConsumableArray(_this3.state.pairs.slice(0, index)), [Object.assign({}, _this3.state.pairs[index], { key: value })], _toConsumableArray(_this3.state.pairs.slice(index + 1)));
	    _this3.setState({ pairs: pairs });
	  };
	
	  this.setValue = function (value, index) {
	    var pairs = [].concat(_toConsumableArray(_this3.state.pairs.slice(0, index)), [Object.assign({}, _this3.state.pairs[index], { value: value })], _toConsumableArray(_this3.state.pairs.slice(index + 1)));
	    _this3.setState({ pairs: pairs });
	  };
	
	  this.save = function () {
	    var pairs = {};
	    _this3.state.pairs.map(function (pair, i) {
	      if (pair.key !== "") {
	        pairs[pair.key] = pair.value;
	      }return null;
	    });
	    _this3.props.onChange(_this3.props.name, pairs);
	  };
	
	  this.deletePair = function (index) {
	    var pairs = [].concat(_toConsumableArray(_this3.state.pairs.slice(0, index)), _toConsumableArray(_this3.state.pairs.slice(index + 1)));
	    _this3.setState({ pairs: pairs });
	  };
	};
	
	exports.default = MetaEditor;
	
	var MetaPair = function (_Component2) {
	  _inherits(MetaPair, _Component2);
	
	  function MetaPair() {
	    var _ref;
	
	    var _temp, _this4, _ret;
	
	    _classCallCheck(this, MetaPair);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this4 = _possibleConstructorReturn(this, (_ref = MetaPair.__proto__ || Object.getPrototypeOf(MetaPair)).call.apply(_ref, [this].concat(args))), _this4), _this4.setKey = function (e) {
	      _this4.props.setKey(e.target.value, _this4.props.pairIndex);
	    }, _this4.setValue = function (e) {
	      _this4.props.setValue(e.target.value, _this4.props.pairIndex);
	    }, _this4.deletePair = function () {
	      _this4.props.deletePair(_this4.props.pairIndex);
	    }, _temp), _possibleConstructorReturn(_this4, _ret);
	  }
	
	  _createClass(MetaPair, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          isLast = _props.isLast,
	          pair = _props.pair;
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'block-wrapper pair' },
	        _react2.default.createElement(
	          'button',
	          { className: 'delete-button', onClick: this.deletePair, disabled: isLast, tabIndex: '-1' },
	          _react2.default.createElement('span', { className: 'icon icon-close' })
	        ),
	        _react2.default.createElement('input', { type: 'text', className: 'key', placeholder: 'Key', onChange: this.setKey, value: pair.key }),
	        _react2.default.createElement('input', { type: 'text', className: 'value', placeholder: 'Value', onChange: this.setValue, value: pair.value })
	      );
	    }
	  }]);
	
	  return MetaPair;
	}(_react.Component);

/***/ },
/* 1085 */,
/* 1086 */,
/* 1087 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _MultiComplete = __webpack_require__(120);
	
	var _MultiComplete2 = _interopRequireDefault(_MultiComplete);
	
	var _requests = __webpack_require__(6);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var RegulatedWordsSelector = function RegulatedWordsSelector(_ref) {
	  var value = _ref.value,
	      onChange = _ref.onChange,
	      id = _ref.id;
	
	  var _React$useState = _react2.default.useState([]),
	      _React$useState2 = _slicedToArray(_React$useState, 2),
	      regulatedWordLists = _React$useState2[0],
	      setRegulatedWordLists = _React$useState2[1];
	
	  _react2.default.useEffect(function () {
	    (0, _requests.GET_REGULATED_WORD_LISTS)(function (lists) {
	      setRegulatedWordLists(lists.map(function (list) {
	        return {
	          value: list.CATEGORY,
	          label: list.DISPLAY_DESCR
	        };
	      }));
	    });
	  }, []);
	
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(_MultiComplete2.default, {
	      value: value,
	      onChange: onChange,
	      options: regulatedWordLists,
	      width: '70%',
	      disabled: !regulatedWordLists.length
	    })
	  );
	};
	
	exports.default = RegulatedWordsSelector;

/***/ },
/* 1088 */,
/* 1089 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Form = __webpack_require__(14);
	
	var _validate = __webpack_require__(45);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	exports.default = function (_ref) {
	  var options = _ref.parentField.options,
	      value = _ref.value,
	      onChange = _ref.onChange;
	
	  var handleNumChange = function handleNumChange(inputValue, name) {
	    var maskedValue = _validate.MASK.onlyNumbers(inputValue);
	    if (_typeof(value[name]) !== 'object') {
	      onChange(Object.assign({}, value, _defineProperty({}, name, {
	        num: maskedValue,
	        error: ''
	      })));
	    } else {
	      onChange(Object.assign({}, value, _defineProperty({}, name, Object.assign({}, value[name], {
	        num: maskedValue
	      }))));
	    }
	  };
	
	  var handleErrorChange = function handleErrorChange(inputValue, name) {
	    if (_typeof(value[name]) !== 'object') {
	      onChange(Object.assign({}, value, _defineProperty({}, name, {
	        num: value[name],
	        error: inputValue
	      })));
	    } else {
	      onChange(Object.assign({}, value, _defineProperty({}, name, Object.assign({}, value[name], {
	        error: inputValue
	      }))));
	    }
	  };
	
	  return _react2.default.createElement(
	    _react2.default.Fragment,
	    null,
	    options.map(function (option, i) {
	      return _react2.default.createElement(
	        'div',
	        { key: option.value + i, className: 'select-option-constrainer' },
	        _react2.default.createElement(
	          'label',
	          null,
	          option.label
	        ),
	        _react2.default.createElement(_Form.TextInput, {
	          width: '60px',
	          value: _typeof(value[option.value]) === 'object' ? value[option.value].num : value[option.value],
	          onChange: function onChange(value) {
	            return handleNumChange(value, option.value);
	          }
	        }),
	        _react2.default.createElement(_Form.TextInput, {
	          style: { marginLeft: 5 },
	          width: 'auto',
	          value: _typeof(value[option.value]) === 'object' ? value[option.value].error : '',
	          onChange: function onChange(value) {
	            return handleErrorChange(value, option.value);
	          },
	          placeholder: 'Error message'
	        })
	      );
	    })
	  );
	};

/***/ },
/* 1090 */,
/* 1091 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.ElavonCheckoutSection = exports.submitElavonCheckout = exports.clearFailedWebCart = exports.getElavonTokenByRefNum = exports.getElavonTokenByItemGuids = exports.ElavonProvider = exports.useElavon = undefined;
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _requests = __webpack_require__(6);
	
	var _Checkout = __webpack_require__(67);
	
	var _hooks = __webpack_require__(144);
	
	var _propTypes = __webpack_require__(20);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var PASS_ITEM_GUIDS_ON_CHECKOUT = (true);
	
	var useElavon = exports.useElavon = function useElavon(_ref) {
	  var method = _ref.method;
	
	  var _React$useState = _react2.default.useState(false),
	      _React$useState2 = _slicedToArray(_React$useState, 2),
	      jQueryLoaded = _React$useState2[0],
	      setJQueryLoaded = _React$useState2[1];
	
	  var _React$useState3 = _react2.default.useState(false),
	      _React$useState4 = _slicedToArray(_React$useState3, 2),
	      convergeLoaded = _React$useState4[0],
	      setConvergeLoaded = _React$useState4[1];
	
	  var _useAppSetting = (0, _hooks.useAppSetting)('ELAVON_CONVERGE_SCRIPT_SRC'),
	      scriptSrc = _useAppSetting.setting;
	
	  var jqueryScript = _react2.default.useRef();
	  var convergeScript = _react2.default.useRef();
	
	  _react2.default.useEffect(function () {
	    if (scriptSrc) {
	      if (!window.jQuery || window.jQuery && window.jQuery.fn.jquery === '3.4.1') {
	        jqueryScript.current = document.createElement('script');
	        jqueryScript.current.type = 'text/javascript';
	        jqueryScript.current.src = 'https://ajax.googleapis.com/ajax/libs/jquery/3.4.1/jquery.min.js';
	        document.head.appendChild(jqueryScript.current);
	        jqueryScript.current.onload = function (e) {
	          setJQueryLoaded(true);
	        };
	      } else {
	        setJQueryLoaded(true);
	      }
	      if (method === 'checkout' ? !window.ConvergeEmbeddedPayment : !window.PayWithConverge) {
	        convergeScript.current = document.createElement('script');
	        convergeScript.current.type = 'text/javascript';
	        convergeScript.current.src = '' + scriptSrc.VALUE + (method === 'checkout' ? 'Checkout' : 'PayWithConverge') + '.js';
	        document.head.appendChild(convergeScript.current);
	        convergeScript.current.onload = function (e) {
	          setConvergeLoaded(true);
	        };
	      } else {
	        setConvergeLoaded(true);
	      }
	    }
	  }, [scriptSrc]);
	  return jQueryLoaded && convergeLoaded;
	};
	
	var ElavonProvider = exports.ElavonProvider = function ElavonProvider(_ref2) {
	  var method = _ref2.method,
	      children = _ref2.children;
	
	  var elavonLoaded = useElavon({ method: method });
	
	  return typeof children === 'function' ? children(elavonLoaded) : children;
	};
	ElavonProvider.propTypes = {
	  children: _propTypes2.default.func.isRequired
	};
	
	var getElavonTokenByItemGuids = exports.getElavonTokenByItemGuids = function getElavonTokenByItemGuids(guids) {
	  return new Promise(function (resolve, reject) {
	    (0, _requests.GET_ELAVON_TOKEN_BY_ITEM_GUIDS)(guids, resolve, reject);
	  });
	};
	
	var getElavonTokenByRefNum = exports.getElavonTokenByRefNum = function getElavonTokenByRefNum(refNum) {
	  return new Promise(function (resolve, reject) {
	    (0, _requests.GET_ELAVON_TOKEN_BY_REF_NUM)(refNum, resolve, reject);
	  });
	};
	
	var clearFailedWebCart = exports.clearFailedWebCart = function clearFailedWebCart(refNum, errorMessage, callback) {
	  return new Promise(function (resolve, reject) {
	    (0, _requests.CLEAR_FAILED_WEB_CART_BY_REF_NUM)(refNum, function () {
	      return callback(errorMessage);
	    }, reject);
	  });
	};
	
	var submitElavonCheckout = exports.submitElavonCheckout = function submitElavonCheckout(values, guids) {
	  if (PASS_ITEM_GUIDS_ON_CHECKOUT) {
	    return new Promise(function (resolve, reject) {
	      getElavonTokenByItemGuids({ ITEMIDS: guids }).then(function (cart) {
	        var FIRST_NAME = values.FIRST_NAME,
	            LAST_NAME = values.LAST_NAME,
	            COMPANY = values.COMPANY,
	            CC_NUMBER = values.CC_NUMBER,
	            CC_EXPIRATION = values.CC_EXPIRATION,
	            CC_CVV = values.CC_CVV,
	            BILLING_ADDRESS = values.BILLING_ADDRESS,
	            PHONE_NUMBER = values.PHONE_NUMBER,
	            PHONE_EXTENSION = values.PHONE_EXTENSION;
	
	
	        var maskedPhone = PHONE_NUMBER.replace(/\D+/g, '');
	
	        window.ConvergeEmbeddedPayment.pay({
	          ssl_txn_auth_token: cart.PAY_TOKEN,
	          ssl_card_number: CC_NUMBER,
	          ssl_exp_date: CC_EXPIRATION,
	          ssl_first_name: FIRST_NAME,
	          ssl_last_name: LAST_NAME,
	          ssl_company: COMPANY,
	          ssl_phone: maskedPhone,
	          ssl_avs_address: BILLING_ADDRESS.ADDR1,
	          ssl_address2: BILLING_ADDRESS.ADDR2,
	          ssl_city: BILLING_ADDRESS.CITY,
	          ssl_state: BILLING_ADDRESS.STATE,
	          ssl_avs_zip: BILLING_ADDRESS.POSTAL_CODE.replace(/[^a-z0-9]/g, ''),
	          ssl_cvv2cvc2: CC_CVV,
	          ssl_merchant_id: cart.WEB_CART_ADDITIONAL_PROPS.ELAVON_API_MERCHANT_ID,
	          ssl_user_id: cart.WEB_CART_ADDITIONAL_PROPS.ELAVON_API_USER_ID,
	          ssl_pin: cart.WEB_CART_ADDITIONAL_PROPS.ELAVON_API_PIN,
	          ssl_transaction_type: 'ccsale',
	          ssl_description: cart.REF_NUM
	        }, {
	          onError: function onError(err) {
	            return clearFailedWebCart(cart.REF_NUM, err, reject);
	          },
	          onDeclined: function onDeclined(err) {
	            return clearFailedWebCart(cart.REF_NUM, err, reject);
	          },
	          onApproval: function onApproval(res) {
	            (0, _requests.PROCESS_ELAVON_PAYMENT)(Object.assign({}, res, {
	              VALUES: {
	                FIRST_NAME: FIRST_NAME,
	                LAST_NAME: LAST_NAME,
	                COMPANY: COMPANY,
	                PHONE_NUMBER: maskedPhone,
	                BILLING_ADDRESS: BILLING_ADDRESS,
	                PHONE_EXTENSION: PHONE_EXTENSION
	              }
	            }), resolve, reject);
	          }
	        });
	      }).catch(reject);
	    });
	  } else {
	    var refNum = guids;
	    return new Promise(function (resolve, reject) {
	      (0, _requests.GET_WEB_CART_BY_REF_NUM)(refNum, function (_ref3) {
	        var _ref3$WEB_CART_ADDITI = _ref3.WEB_CART_ADDITIONAL_PROPS,
	            ELAVON_API_MERCHANT_ID = _ref3$WEB_CART_ADDITI.ELAVON_API_MERCHANT_ID,
	            ELAVON_API_USER_ID = _ref3$WEB_CART_ADDITI.ELAVON_API_USER_ID,
	            ELAVON_API_PIN = _ref3$WEB_CART_ADDITI.ELAVON_API_PIN;
	
	        getElavonTokenByRefNum(refNum).then(function (token) {
	          var FIRST_NAME = values.FIRST_NAME,
	              LAST_NAME = values.LAST_NAME,
	              COMPANY = values.COMPANY,
	              CC_NUMBER = values.CC_NUMBER,
	              CC_EXPIRATION = values.CC_EXPIRATION,
	              CC_CVV = values.CC_CVV,
	              BILLING_ADDRESS = values.BILLING_ADDRESS,
	              PHONE_NUMBER = values.PHONE_NUMBER,
	              PHONE_EXTENSION = values.PHONE_EXTENSION;
	
	
	          var maskedPhone = PHONE_NUMBER.replace(/\D+/g, '');
	
	          window.ConvergeEmbeddedPayment.pay({
	            ssl_txn_auth_token: token,
	            ssl_card_number: CC_NUMBER,
	            ssl_exp_date: CC_EXPIRATION,
	            ssl_first_name: FIRST_NAME,
	            ssl_last_name: LAST_NAME,
	            ssl_company: COMPANY,
	            ssl_phone: maskedPhone,
	            ssl_avs_address: BILLING_ADDRESS.ADDR1,
	            ssl_address2: BILLING_ADDRESS.ADDR2,
	            ssl_city: BILLING_ADDRESS.CITY,
	            ssl_state: BILLING_ADDRESS.STATE,
	            ssl_avs_zip: BILLING_ADDRESS.POSTAL_CODE.replace(/[^a-z0-9]/g, ''),
	            ssl_cvv2cvc2: CC_CVV,
	            ssl_merchant_id: ELAVON_API_MERCHANT_ID,
	            ssl_user_id: ELAVON_API_USER_ID,
	            ssl_pin: ELAVON_API_PIN,
	            ssl_transaction_type: 'ccsale',
	            ssl_description: refNum
	          }, {
	            onError: reject,
	            onDeclined: reject,
	            onApproval: function onApproval(res) {
	              (0, _requests.PROCESS_ELAVON_PAYMENT)(Object.assign({}, res, {
	                VALUES: {
	                  FIRST_NAME: FIRST_NAME,
	                  LAST_NAME: LAST_NAME,
	                  COMPANY: COMPANY,
	                  PHONE_NUMBER: maskedPhone,
	                  BILLING_ADDRESS: BILLING_ADDRESS,
	                  PHONE_EXTENSION: PHONE_EXTENSION
	                }
	              }), resolve, reject);
	            }
	          });
	        }).catch(reject);
	      }, reject);
	    });
	  }
	};
	
	var ElavonCheckoutSection = exports.ElavonCheckoutSection = function ElavonCheckoutSection(_ref4) {
	  var refNum = _ref4.refNum,
	      error = _ref4.error,
	      onPrePaymentError = _ref4.onPrePaymentError,
	      onComplete = _ref4.onComplete;
	
	  var elavonLoaded = useElavon();
	
	  var _React$useState5 = _react2.default.useState(null),
	      _React$useState6 = _slicedToArray(_React$useState5, 2),
	      postPaymentError = _React$useState6[0],
	      setPostPaymentError = _React$useState6[1];
	
	  var startTransaction = function startTransaction() {
	    getElavonTokenByItemGuids(refNum).then(function (token) {
	      var paymentFields = {
	        ssl_txn_auth_token: token
	      };
	      var callback = {
	        onError: function onError(err) {
	          return onPrePaymentError;
	        },
	        onCancelled: function onCancelled() {},
	        onDeclined: function onDeclined(err) {
	          return setPostPaymentError(err);
	        },
	        onApproval: function onApproval(res) {
	          (0, _requests.PROCESS_ELAVON_PAYMENT)(res, function (res) {
	            return onComplete(res);
	          }, function (err) {
	            return setPostPaymentError(err);
	          });
	        }
	      };
	      window.PayWithConverge.open(paymentFields, callback);
	    });
	  };
	
	  return _react2.default.createElement(
	    'div',
	    { className: 'flex-column' },
	    _react2.default.createElement(
	      _Checkout.PaymentButton,
	      { error: error, onClick: startTransaction, disabled: !elavonLoaded },
	      'Pay with Credit Card'
	    ),
	    postPaymentError ? _react2.default.createElement(
	      'p',
	      { className: 'payment-error' },
	      postPaymentError
	    ) : null
	  );
	};

/***/ },
/* 1092 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _requests = __webpack_require__(6);
	
	var _reactRedux = __webpack_require__(7);
	
	var _AuthActions = __webpack_require__(66);
	
	var _Shell = __webpack_require__(19);
	
	var _Loaders = __webpack_require__(16);
	
	var _PaymentCallback = __webpack_require__(119);
	
	var _localStorage = __webpack_require__(59);
	
	var _localStorage2 = _interopRequireDefault(_localStorage);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var EpassCallback = function EpassCallback(_ref) {
	  var dispatch = _ref.dispatch,
	      history = _ref.history;
	
	  var _React$useState = _react2.default.useState(null),
	      _React$useState2 = _slicedToArray(_React$useState, 2),
	      error = _React$useState2[0],
	      setError = _React$useState2[1];
	
	  _react2.default.useEffect(function () {
	    (0, _requests.GET_EPASS_LOGIN_CALLBACK)(function (user) {
	      (0, _AuthActions.storeAndDispatchLoginResponse)(user, dispatch);
	      var returnUrl = _localStorage2.default.get('EPASS_RETURN_URL') || '/';
	      history.replace(returnUrl);
	    }, function (err) {
	      console.error(err);
	      setError(err);
	    });
	  }, []);
	  return _react2.default.createElement(
	    _Shell.Body,
	    { className: 'login-redirector' },
	    error ? _react2.default.createElement(
	      'div',
	      { className: 'payment-callback' },
	      _react2.default.createElement(_PaymentCallback.PaymentError, { errorCode: error.code, children: error.message })
	    ) : _react2.default.createElement(_Loaders.Spinner, { className: 'page-loader' })
	  );
	};
	exports.default = (0, _reactRedux.connect)()(EpassCallback);

/***/ },
/* 1093 */
1048,
/* 1094 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(7);
	
	var _requests = __webpack_require__(6);
	
	var _utilities = __webpack_require__(8);
	
	var _localStorage = __webpack_require__(59);
	
	var _localStorage2 = _interopRequireDefault(_localStorage);
	
	var _reactRouterDom = __webpack_require__(30);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var EpassRedirector = function EpassRedirector(_ref) {
	  var match = _ref.match,
	      location = _ref.location,
	      checkingAuthState = _ref.checkingAuthState,
	      loggedIn = _ref.loggedIn;
	
	  _react2.default.useEffect(function () {
	    if (!checkingAuthState && !loggedIn) {
	      var search = (0, _utilities.parseUrlQuery)(location.search);
	      var returnUrl = search.from || '/';
	      _localStorage2.default.set('EPASS_RETURN_URL', returnUrl);
	      window.location.href = _requests.BASE_URL + '/api/Login.epass';
	    }
	  }, [checkingAuthState, loggedIn]);
	  if (!checkingAuthState && loggedIn) {
	    return _react2.default.createElement(_reactRouterDom.Redirect, { to: '/' });
	  }
	  return null;
	};
	exports.default = (0, _reactRedux.connect)(function (state) {
	  return {
	    checkingAuthState: state.auth.checkingAuthState,
	    loggedIn: state.auth.loggedIn
	  };
	})(EpassRedirector);

/***/ },
/* 1095 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.AnimatedCard = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactPropTransition = __webpack_require__(317);
	
	var _reactPropTransition2 = _interopRequireDefault(_reactPropTransition);
	
	var _reactOnclickoutside = __webpack_require__(153);
	
	var _reactOnclickoutside2 = _interopRequireDefault(_reactOnclickoutside);
	
	__webpack_require__(1439);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ExpandableCard = function (_React$Component) {
	  _inherits(ExpandableCard, _React$Component);
	
	  function ExpandableCard() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, ExpandableCard);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = ExpandableCard.__proto__ || Object.getPrototypeOf(ExpandableCard)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      expanded: false,
	      initialHeight: null,
	      closing: false
	    }, _this.expandCard = function () {
	      if (_this.props.onStartExpand) {
	        _this.props.onStartExpand();
	      }
	      var size = _this.block.getBoundingClientRect();
	      _this.setState({
	        expanded: true,
	        initialHeight: size.height
	      });
	    }, _this.collapseCard = function () {
	      _this.setState({
	        expanded: false,
	        closing: false
	      });
	    }, _this.startCollapse = function () {
	      if (_this.props.onStartCollapse) {
	        _this.props.onStartCollapse();
	      }
	      _this.setState({
	        closing: true
	      });
	      _this.card.getInstance().close();
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(ExpandableCard, [{
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _props = this.props,
	          onPrimaryButtonClick = _props.onPrimaryButtonClick,
	          _props$className = _props.className,
	          className = _props$className === undefined ? '' : _props$className,
	          expandedChildren = _props.expandedChildren,
	          collapsedChildren = _props.collapsedChildren,
	          _props$cardClassName = _props.cardClassName,
	          cardClassName = _props$cardClassName === undefined ? '' : _props$cardClassName;
	
	      return _react2.default.createElement(
	        'div',
	        {
	          className: 'expandable-card-wrapper ' + className,
	          style: {
	            zIndex: this.state.expanded ? 9999 : ''
	          }
	        },
	        this.state.expanded && _react2.default.createElement(
	          AnimatedCard,
	          {
	            ref: function ref(_ref2) {
	              _this2.card = _ref2;
	            },
	            cardClassName: cardClassName,
	            onCloseAnimationFinished: this.collapseCard,
	            onPrimaryButtonClick: onPrimaryButtonClick,
	            initialHeight: this.state.initialHeight,
	            onRequestClose: this.startCollapse,
	            animated: true
	          },
	          expandedChildren({ expand: this.expandCard, collapse: this.startCollapse })
	        ),
	        collapsedChildren({ innerRef: function innerRef(ref) {
	            _this2.block = ref;
	          }, expand: this.expandCard, collapse: this.startCollapse })
	      );
	    }
	  }]);
	
	  return ExpandableCard;
	}(_react2.default.Component);
	
	exports.default = ExpandableCard;
	
	var AnimatedCard = exports.AnimatedCard = function (_React$PureComponent) {
	  _inherits(AnimatedCard, _React$PureComponent);
	
	  function AnimatedCard() {
	    var _ref3;
	
	    var _temp2, _this3, _ret2;
	
	    _classCallCheck(this, AnimatedCard);
	
	    for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
	      args[_key2] = arguments[_key2];
	    }
	
	    return _ret2 = (_temp2 = (_this3 = _possibleConstructorReturn(this, (_ref3 = AnimatedCard.__proto__ || Object.getPrototypeOf(AnimatedCard)).call.apply(_ref3, [this].concat(args))), _this3), _this3.state = {
	      visible: false,
	      targetHeight: _this3.props.initialHeight,
	      closing: false
	    }, _this3.componentDidMount = function () {
	      _this3.calculateTargetHeight();
	      _this3.setVisible(true);
	    }, _this3.close = function () {
	      _this3.setState({
	        targetHeight: _this3.props.initialHeight,
	        closing: true
	      });
	    }, _this3.setVisible = function (visible) {
	      _this3.setState({
	        visible: visible
	      });
	    }, _this3.calculateTargetHeight = function () {
	      var card = _this3.card.getBoundingClientRect();
	      _this3.setState({
	        targetHeight: card.height
	      });
	    }, _this3.handleClickOutside = function () {
	      _this3.props.onRequestClose();
	    }, _this3.onPrimaryButtonClick = function (e) {
	      e.stopPropagation();
	      _this3.props.onPrimaryButtonClick(_this3.props.formDefinitionId);
	    }, _temp2), _possibleConstructorReturn(_this3, _ret2);
	  }
	
	  _createClass(AnimatedCard, [{
	    key: 'render',
	    value: function render() {
	      var _this4 = this;
	
	      var _props2 = this.props,
	          animated = _props2.animated,
	          children = _props2.children,
	          cardClassName = _props2.cardClassName;
	
	      return _react2.default.createElement(
	        _reactPropTransition2.default,
	        { props: { height: this.state.targetHeight }, duration: 300 },
	        function (props) {
	          return _react2.default.createElement(
	            'div',
	            {
	              ref: function ref(_ref4) {
	                _this4.card = _ref4;
	              },
	              className: 'expandable-card ' + cardClassName + ' ' + (animated ? _this4.state.closing ? 'collapse-out' : 'expand-in' : ''),
	              style: {
	                height: _this4.state.visible ? props.height : '',
	                opacity: _this4.state.visible ? 1 : 0
	              }
	            },
	            children,
	            _this4.state.closing && _react2.default.createElement(RestDetector, { target: _this4.props.initialHeight, current: props.height, onRest: _this4.props.onCloseAnimationFinished })
	          );
	        }
	      );
	    }
	  }]);
	
	  return AnimatedCard;
	}(_react2.default.PureComponent);
	
	exports.AnimatedCard = AnimatedCard = (0, _reactOnclickoutside2.default)(AnimatedCard);
	
	var RestDetector = function (_React$Component2) {
	  _inherits(RestDetector, _React$Component2);
	
	  function RestDetector() {
	    var _ref5;
	
	    var _temp3, _this5, _ret3;
	
	    _classCallCheck(this, RestDetector);
	
	    for (var _len3 = arguments.length, args = Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
	      args[_key3] = arguments[_key3];
	    }
	
	    return _ret3 = (_temp3 = (_this5 = _possibleConstructorReturn(this, (_ref5 = RestDetector.__proto__ || Object.getPrototypeOf(RestDetector)).call.apply(_ref5, [this].concat(args))), _this5), _this5.componentWillReceiveProps = function (nextProps) {
	      if (nextProps.current === _this5.props.target) {
	        _this5.props.onRest();
	      }
	    }, _temp3), _possibleConstructorReturn(_this5, _ret3);
	  }
	
	  _createClass(RestDetector, [{
	    key: 'render',
	    value: function render() {
	      return null;
	    }
	  }]);
	
	  return RestDetector;
	}(_react2.default.Component);

/***/ },
/* 1096 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouterDom = __webpack_require__(30);
	
	var _Shell = __webpack_require__(19);
	
	var _Loaders = __webpack_require__(16);
	
	var _Search = __webpack_require__(468);
	
	var _Search2 = _interopRequireDefault(_Search);
	
	var _requests = __webpack_require__(6);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FarmBill = function FarmBill(props) {
	  var _React$useState = _react2.default.useState(null),
	      _React$useState2 = _slicedToArray(_React$useState, 2),
	      hasSubscription = _React$useState2[0],
	      setHasSubscription = _React$useState2[1];
	
	  var _React$useState3 = _react2.default.useState(null),
	      _React$useState4 = _slicedToArray(_React$useState3, 2),
	      sortBy = _React$useState4[0],
	      setSortBy = _React$useState4[1];
	
	  var _React$useState5 = _react2.default.useState(null),
	      _React$useState6 = _slicedToArray(_React$useState5, 2),
	      sortByDirection = _React$useState6[0],
	      setSortByDirection = _React$useState6[1];
	
	  var _React$useState7 = _react2.default.useState(false),
	      _React$useState8 = _slicedToArray(_React$useState7, 2),
	      searchOnNextTick = _React$useState8[0],
	      setSearchOnNextTick = _React$useState8[1];
	
	  var searchTrigger = _react2.default.useRef();
	
	  _react2.default.useEffect(function () {
	    (0, _requests.GET_HAS_FARM_BILL_SUBSCRIPTION)(function (response) {
	      setHasSubscription(response);
	    }, function (err) {
	      console.error(err);
	      setHasSubscription(false);
	    });
	  }, []);
	
	  _react2.default.useEffect(function () {
	    if (searchOnNextTick) {
	      searchTrigger.current();
	      setSearchOnNextTick(false);
	    }
	  }, [searchOnNextTick]);
	
	  var setSorting = function setSorting(sortId) {
	    setSortBy(sortId);
	    if (!sortByDirection || sortId !== sortBy) {
	      setSortByDirection('DESC');
	    } else {
	      setSortByDirection(sortByDirection === 'DESC' ? 'ASC' : 'DESC');
	    }
	    setSearchOnNextTick(true);
	  };
	
	  return hasSubscription === null ? _react2.default.createElement(
	    _Shell.Body,
	    { className: 'flex-center-page' },
	    _react2.default.createElement(_Loaders.Spinner, { className: 'page-loader', themeColor: 'dark-neutral' })
	  ) : hasSubscription ? _react2.default.createElement(_Search2.default, Object.assign({}, props, {
	    allowEmptySearchTerm: true,
	    sortBy: sortBy,
	    sortByDirection: sortByDirection,
	    onHeaderLabelClicked: setSorting,
	    sortable: true,
	    getSearchTrigger: function getSearchTrigger(x) {
	      return searchTrigger.current = x;
	    },
	    firstCellInteractive: (true)
	  })) : _react2.default.createElement(_reactRouterDom.Redirect, { to: '/' });
	};
	
	exports.default = FarmBill;

/***/ },
/* 1097 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(7);
	
	var _requests = __webpack_require__(6);
	
	var _FormManagerActions = __webpack_require__(196);
	
	var _Switch = __webpack_require__(1142);
	
	var _Switch2 = _interopRequireDefault(_Switch);
	
	var _reactTooltip = __webpack_require__(78);
	
	var _reactTooltip2 = _interopRequireDefault(_reactTooltip);
	
	var _Portal = __webpack_require__(12);
	
	var _Portal2 = _interopRequireDefault(_Portal);
	
	var _Modal = __webpack_require__(13);
	
	var _ImportDialog = __webpack_require__(456);
	
	var _ImportDialog2 = _interopRequireDefault(_ImportDialog);
	
	var _import = __webpack_require__(160);
	
	var _import2 = _interopRequireDefault(_import);
	
	var _caretUp = __webpack_require__(80);
	
	var _caretUp2 = _interopRequireDefault(_caretUp);
	
	var _caretDown = __webpack_require__(38);
	
	var _caretDown2 = _interopRequireDefault(_caretDown);
	
	var _DraggableWizard = __webpack_require__(1098);
	
	var _DraggableWizard2 = _interopRequireDefault(_DraggableWizard);
	
	var _Droppable = __webpack_require__(100);
	
	var _Droppable2 = _interopRequireDefault(_Droppable);
	
	var _FileDownloader = __webpack_require__(147);
	
	var _FileDownloader2 = _interopRequireDefault(_FileDownloader);
	
	var _utilities = __webpack_require__(8);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var getTitleWidth = function getTitleWidth() {
	  var title = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
	
	  return (title.length + 1) * 13;
	};
	
	var Category = function Category(_ref) {
	  var title = _ref.title,
	      id = _ref.id,
	      filter = _ref.filter,
	      icon = _ref.icon,
	      uncategorized = _ref.uncategorized,
	      wizards = _ref.wizards,
	      canReorderUp = _ref.canReorderUp,
	      canReorderDown = _ref.canReorderDown,
	      visible = _ref.visible,
	      onVisibilityChange = _ref.onVisibilityChange,
	      onTitleChange = _ref.onTitleChange,
	      onReorderUp = _ref.onReorderUp,
	      onReorderDown = _ref.onReorderDown,
	      onRequestDelete = _ref.onRequestDelete,
	      onRequestRefetch = _ref.onRequestRefetch,
	      cloneWizard = _ref.cloneWizard,
	      archiveWizard = _ref.archiveWizard,
	      moveWizardToEmptyCategory = _ref.moveWizardToEmptyCategory,
	      publishWizardToEmptyCategory = _ref.publishWizardToEmptyCategory;
	
	  var titleInput = _react2.default.useRef();
	
	  var _React$useState = _react2.default.useState(false),
	      _React$useState2 = _slicedToArray(_React$useState, 2),
	      deleteConfirmOpen = _React$useState2[0],
	      setDeleteConfirmOpen = _React$useState2[1];
	
	  var _React$useState3 = _react2.default.useState(''),
	      _React$useState4 = _slicedToArray(_React$useState3, 2),
	      fileString = _React$useState4[0],
	      setFileString = _React$useState4[1];
	
	  var _React$useState5 = _react2.default.useState(''),
	      _React$useState6 = _slicedToArray(_React$useState5, 2),
	      fileName = _React$useState6[0],
	      setFileName = _React$useState6[1];
	
	  var downloader = _react2.default.useRef();
	
	  var _React$useState7 = _react2.default.useState(false),
	      _React$useState8 = _slicedToArray(_React$useState7, 2),
	      downloadOnNextText = _React$useState8[0],
	      setDownloadOnNextTick = _React$useState8[1];
	
	  var _React$useState9 = _react2.default.useState(false),
	      _React$useState10 = _slicedToArray(_React$useState9, 2),
	      importDialogOpen = _React$useState10[0],
	      setImportDialogOpen = _React$useState10[1];
	
	  var _React$useState11 = _react2.default.useState(title),
	      _React$useState12 = _slicedToArray(_React$useState11, 2),
	      categoryTitle = _React$useState12[0],
	      setCategoryTitle = _React$useState12[1];
	
	  _react2.default.useEffect(function () {
	    if (title && title !== categoryTitle) {
	      setCategoryTitle(title);
	    }
	  }, [title]);
	
	  var checkSubmit = function checkSubmit(e) {
	    if (e.which === 13) {
	      titleInput.current.blur();
	    }
	  };
	
	  var exportJson = function exportJson(formDefinitionId) {
	    (0, _requests.LOAD_WIZARD_BY_ID)(formDefinitionId, function (response) {
	      var jsonString = JSON.stringify(response);
	      setFileName(response.FORM_DEFINITION_ID + ' - ' + response.TITLE.replace(/ of /g, ' ').replace(/ and /g, ' ').replace(/ the /g, ' ') + '.json');
	      setFileString(jsonString);
	      setDownloadOnNextTick(true);
	    });
	  };
	
	  var filteredWizards = wizards.filter(function (wizard) {
	    return wizard.TITLE.toLowerCase().includes(filter);
	  });
	  var mappedWizards = filteredWizards.map(function (wizard, i) {
	    var next = i < filteredWizards.length - 1 ? filteredWizards[i + 1] : wizard;
	    return _react2.default.createElement(_DraggableWizard2.default, {
	      draggable: !filter,
	      droppable: !uncategorized,
	      title: wizard.TITLE,
	      description: wizard.DESCR,
	      categoryId: id,
	      formDefinitionId: wizard.FORM_DEFINITION_ID,
	      lastModifiedDate: wizard.LAST_MODIFIED_DATE,
	      lastModifiedName: wizard.LAST_MODIFIED_BY_NAME,
	      onRequestExport: function onRequestExport() {
	        return exportJson(wizard.FORM_DEFINITION_ID);
	      },
	      onRequestClone: function onRequestClone(values) {
	        return cloneWizard(wizard.FORM_DEFINITION_ID, values.title);
	      },
	      onRequestArchive: function onRequestArchive() {
	        return archiveWizard(wizard.FORM_DEFINITION_ID);
	      },
	      next: next,
	      icon: icon,
	      key: wizard.FORM_DEFINITION_ID
	    });
	  });
	
	  _react2.default.useEffect(function () {
	    if (downloadOnNextText) {
	      downloader.current.download();
	      setDownloadOnNextTick(false);
	    }
	  }, [downloadOnNextText]);
	
	  var addToEmptyCategory = function addToEmptyCategory(data) {
	    if (data.categoryId !== 'uncategorized') {
	      moveWizardToEmptyCategory({ origin: data, target: id });
	    } else {
	      publishWizardToEmptyCategory({ origin: data, target: id });
	    }
	  };
	
	  if (!mappedWizards.length && filter && !uncategorized) {
	    return null;
	  }
	
	  return _react2.default.createElement(
	    'div',
	    { className: 'category editable ' + (uncategorized ? 'uncategorized' : '') },
	    _react2.default.createElement(
	      'div',
	      { className: 'title-wrapper' },
	      !uncategorized && _react2.default.createElement(_Switch2.default, {
	        onChange: onVisibilityChange,
	        className: 'visibility-toggle',
	        on: visible,
	        tooltip: 'Toggle Visibility'
	      }),
	      _react2.default.createElement(
	        'h2',
	        { className: 'visually-hidden' },
	        categoryTitle
	      ),
	      !uncategorized ? _react2.default.createElement('input', {
	        className: 'title',
	        ref: titleInput,
	        value: categoryTitle,
	        onChange: function onChange(e) {
	          return setCategoryTitle(e.target.value);
	        },
	        style: {
	          width: getTitleWidth(categoryTitle)
	        },
	        placeholder: 'Category Title',
	        onFocus: function onFocus() {
	          return titleInput.current.select();
	        },
	        onBlur: function onBlur(e) {
	          return onTitleChange(categoryTitle);
	        },
	        onKeyPress: checkSubmit,
	        'aria-label': 'Category Title'
	      }) : _react2.default.createElement(
	        'h2',
	        { className: 'title' },
	        categoryTitle
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'actions' },
	        !uncategorized ? _react2.default.createElement(
	          'button',
	          {
	            className: 'btn btn-primary btn-text icon-wrapper delete',
	            onClick: function onClick() {
	              return setDeleteConfirmOpen(true);
	            },
	            'data-tip': 'Delete Category',
	            'data-for': id + 'd-c',
	            'aria-label': 'Delete Category'
	          },
	          _react2.default.createElement('span', { className: 'icon icon-cross' }),
	          _react2.default.createElement(_reactTooltip2.default, { effect: 'solid', place: 'top', id: id + 'd-c', delayShow: 700 })
	        ) : null,
	        !uncategorized ? _react2.default.createElement(
	          'button',
	          {
	            className: 'btn btn-primary btn-text icon-wrapper',
	            onClick: function onClick() {
	              return setImportDialogOpen(true);
	            },
	            'data-tip': 'Import into Category',
	            'data-for': id + 'imp',
	            'aria-label': 'Import into Category'
	          },
	          _react2.default.createElement(_import2.default, null),
	          _react2.default.createElement(_reactTooltip2.default, { effect: 'solid', place: 'top', id: id + 'imp', delayShow: 700 })
	        ) : null,
	        canReorderDown && !uncategorized ? _react2.default.createElement(
	          'button',
	          {
	            className: 'btn btn-primary btn-text down icon-wrapper',
	            onClick: onReorderDown,
	            'data-tip': 'Move Down',
	            'data-for': id + 'r-down',
	            'aria-label': 'Move Category Down'
	          },
	          _react2.default.createElement(_caretDown2.default, null),
	          _react2.default.createElement(_reactTooltip2.default, { effect: 'solid', place: 'top', id: id + 'r-down', delayShow: 700 })
	        ) : null,
	        canReorderUp && !uncategorized ? _react2.default.createElement(
	          'button',
	          {
	            className: 'btn btn-primary btn-text up icon-wrapper',
	            onClick: onReorderUp,
	            'data-tip': 'Move Up',
	            'data-for': id + 'r-up',
	            'aria-label': 'Move Category Up'
	          },
	          _react2.default.createElement(_caretUp2.default, null),
	          _react2.default.createElement(_reactTooltip2.default, { effect: 'solid', place: 'top', id: id + 'r-up', delayShow: 700 })
	        ) : null
	      ),
	      deleteConfirmOpen && _react2.default.createElement(
	        _Portal2.default,
	        { isOpened: deleteConfirmOpen },
	        _react2.default.createElement(_Modal.ConfirmDialog, {
	          closeModal: function closeModal() {
	            return setDeleteConfirmOpen(false);
	          },
	          message: 'Are you sure you want to delete the category: "' + categoryTitle + '"? This cannot be undone.',
	          modalStyle: { borderRadius: 3 },
	          buttons: [{ label: 'Cancel', onClick: _utilities.noop, className: 'btn-default' }, {
	            label: 'Delete Category',
	            className: 'btn-danger',
	            onClick: onRequestDelete,
	            fireAfterClose: true
	          }]
	        })
	      )
	    ),
	    mappedWizards.length ? _react2.default.createElement(
	      'div',
	      { className: 'form-blocks' },
	      mappedWizards
	    ) : _react2.default.createElement(_Droppable2.default, {
	      accepts: 'WIZARD',
	      onDrop: addToEmptyCategory,
	      className: 'form-manager-end-spacer'
	    }),
	    _react2.default.createElement(_FileDownloader2.default, {
	      fileString: fileString,
	      fileName: fileName,
	      contentType: 'text/json',
	      ref: downloader
	    }),
	    _react2.default.createElement(_ImportDialog2.default, {
	      isOpened: importDialogOpen,
	      closeModal: function closeModal() {
	        return setImportDialogOpen(false);
	      },
	      categoryTarget: id,
	      closeAndReload: function closeAndReload() {
	        setImportDialogOpen(false);
	        onRequestRefetch();
	      }
	    })
	  );
	};
	exports.default = (0, _reactRedux.connect)(null, { cloneWizard: _FormManagerActions.cloneWizard, archiveWizard: _FormManagerActions.archiveWizard, moveWizardToEmptyCategory: _FormManagerActions.moveWizardToEmptyCategory, publishWizardToEmptyCategory: _FormManagerActions.publishWizardToEmptyCategory })(Category);

/***/ },
/* 1098 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(7);
	
	var _Droppable = __webpack_require__(100);
	
	var _Droppable2 = _interopRequireDefault(_Droppable);
	
	var _Draggable = __webpack_require__(294);
	
	var _Draggable2 = _interopRequireDefault(_Draggable);
	
	var _DragContext = __webpack_require__(85);
	
	var _Forms = __webpack_require__(296);
	
	var _Portal = __webpack_require__(12);
	
	var _Portal2 = _interopRequireDefault(_Portal);
	
	var _Modal = __webpack_require__(13);
	
	var _clone = __webpack_require__(559);
	
	var _clone2 = _interopRequireDefault(_clone);
	
	var _export = __webpack_require__(333);
	
	var _export2 = _interopRequireDefault(_export);
	
	var _pencil = __webpack_require__(161);
	
	var _pencil2 = _interopRequireDefault(_pencil);
	
	var _archive = __webpack_require__(551);
	
	var _archive2 = _interopRequireDefault(_archive);
	
	var _format = __webpack_require__(33);
	
	var _format2 = _interopRequireDefault(_format);
	
	var _FormManagerActions = __webpack_require__(196);
	
	var _utilities = __webpack_require__(8);
	
	var _store = __webpack_require__(18);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DraggableWizard = function DraggableWizard(_ref) {
	  var droppable = _ref.droppable,
	      draggable = _ref.draggable,
	      title = _ref.title,
	      formDefinitionId = _ref.formDefinitionId,
	      categoryId = _ref.categoryId,
	      next = _ref.next,
	      description = _ref.description,
	      icon = _ref.icon,
	      hasFilter = _ref.hasFilter,
	      lastModifiedDate = _ref.lastModifiedDate,
	      lastModifiedName = _ref.lastModifiedName,
	      stopScroll = _ref.stopScroll,
	      onRequestExport = _ref.onRequestExport,
	      onRequestClone = _ref.onRequestClone,
	      onRequestArchive = _ref.onRequestArchive,
	      onRequestImport = _ref.onRequestImport,
	      moveWizard = _ref.moveWizard,
	      publishWizard = _ref.publishWizard;
	
	  var _useDragStore = (0, _DragContext.useDragStore)(),
	      dragState = _useDragStore.state;
	
	  var _React$useState = _react2.default.useState(false),
	      _React$useState2 = _slicedToArray(_React$useState, 2),
	      cloneModalOpen = _React$useState2[0],
	      setCloneModalOpen = _React$useState2[1];
	
	  var _React$useState3 = _react2.default.useState(false),
	      _React$useState4 = _slicedToArray(_React$useState3, 2),
	      archiveModalOpen = _React$useState4[0],
	      setArchiveModalOpen = _React$useState4[1];
	
	  var _React$useState5 = _react2.default.useState(false),
	      _React$useState6 = _slicedToArray(_React$useState5, 2),
	      expanded = _React$useState6[0],
	      _setExpanded = _React$useState6[1];
	
	  var _React$useState7 = _react2.default.useState(false),
	      _React$useState8 = _slicedToArray(_React$useState7, 2),
	      isDragging = _React$useState8[0],
	      setIsDragging = _React$useState8[1];
	
	  var _React$useState9 = _react2.default.useState(null),
	      _React$useState10 = _slicedToArray(_React$useState9, 2),
	      dragOverDirection = _React$useState10[0],
	      setDragOverDirection = _React$useState10[1];
	
	  var dummyForm = _react2.default.useRef();
	
	  var onDragStart = function onDragStart() {
	    setIsDragging(true);
	  };
	  var onDragEnd = function onDragEnd() {
	    setIsDragging(false);
	    // stopScroll()
	  };
	  var handleDropAccepted = function handleDropAccepted(data) {
	    if (data.formDefinitionId !== formDefinitionId) {
	      var target = dragOverDirection === 'right' ? { categoryId: categoryId, formDefinitionId: next.FORM_DEFINITION_ID } : { categoryId: categoryId, formDefinitionId: formDefinitionId };
	      if (data.categoryId !== 'uncategorized') {
	        moveWizard({ origin: data, target: target });
	      } else {
	        publishWizard({ origin: data, target: target });
	      }
	    }
	  };
	  var editWizard = function editWizard() {
	    return _store.history.push('edit/' + formDefinitionId);
	  };
	
	  var openCloneModal = function openCloneModal() {
	    setCloneModalOpen(true);
	  };
	
	  var handleDrag = function handleDrag(_ref2) {
	    var x = _ref2.x,
	        y = _ref2.y;
	
	    dummyForm.current.style.transform = 'translate(' + (x - 40) + 'px,' + (y - 40) + 'px)';
	  };
	
	  var handleDragLeftEnter = function handleDragLeftEnter() {
	    setDragOverDirection('left');
	  };
	
	  var handleDragExit = function handleDragExit() {
	    setDragOverDirection(null);
	  };
	
	  var handleDragRightEnter = function handleDragRightEnter() {
	    setDragOverDirection('right');
	  };
	
	  return _react2.default.createElement(
	    'div',
	    {
	      className: 'draggable-wizard form-block-wrapper',
	      'data-drag-over-direction': dragOverDirection
	    },
	    _react2.default.createElement(
	      _Draggable2.default,
	      {
	        disabled: !draggable,
	        onDragStart: onDragStart,
	        onDrag: handleDrag,
	        onDragEnd: onDragEnd,
	        type: 'WIZARD',
	        data: { formDefinitionId: formDefinitionId, categoryId: categoryId },
	        className: 'full-width'
	      },
	      _react2.default.createElement(WizardBlock
	      // isActive={isActive}
	      // isDragging={isDragging}
	      , { description: description,
	        formDefinitionId: formDefinitionId,
	        icon: icon,
	        label: title,
	        onRequestClone: openCloneModal,
	        onRequestArchive: function onRequestArchive(e) {
	          e.stopPropagation();
	          setArchiveModalOpen(true);
	        },
	        onRequestExport: onRequestExport,
	        expanded: expanded,
	        setCollapsed: function setCollapsed() {
	          return _setExpanded(false);
	        },
	        setExpanded: function setExpanded() {
	          return _setExpanded(true);
	        },
	        lastModifiedDate: lastModifiedDate,
	        lastModifiedName: lastModifiedName,
	        onRequestEdit: editWizard
	      })
	    ),
	    isDragging && _react2.default.createElement(_Forms.DummyFormIcon, {
	      innerRef: dummyForm,
	      icon: icon,
	      className: 'wizard-dragging',
	      style: {
	        transform: 'translate(0px, 0px)'
	      }
	    }),
	    cloneModalOpen && _react2.default.createElement(
	      _Portal2.default,
	      { isOpened: cloneModalOpen },
	      _react2.default.createElement(_Modal.ConfirmDialog, {
	        closeModal: function closeModal() {
	          return setCloneModalOpen(false);
	        },
	        message: 'Choose a title for the new wizard.',
	        buttons: [{ label: 'Cancel', onClick: _utilities.noop, className: 'btn-default' }, { label: 'Clone', onClick: onRequestClone, submit: true }],
	        inputs: [{ label: '', type: 'text', name: 'title', placeholder: 'New Wizard Title' }],
	        modalStyle: { borderRadius: 3 }
	      })
	    ),
	    archiveModalOpen && _react2.default.createElement(
	      _Portal2.default,
	      { isOpened: archiveModalOpen },
	      _react2.default.createElement(_Modal.ConfirmDialog, {
	        closeModal: function closeModal() {
	          return setArchiveModalOpen(false);
	        },
	        message: 'Are you sure you want to archive "' + title + '"?',
	        buttons: [{ label: 'No', onClick: _utilities.noop, className: 'btn-default' }, { label: 'Yes', onClick: onRequestArchive, className: 'btn-danger' }],
	        modalStyle: { borderRadius: 3 }
	      })
	    ),
	    dragState.isDragging && _react2.default.createElement(
	      _react2.default.Fragment,
	      null,
	      _react2.default.createElement(_Droppable2.default, {
	        onDragEnter: handleDragLeftEnter,
	        onDragExit: handleDragExit,
	        onDrop: handleDragExit,
	        onDropAccepted: handleDropAccepted,
	        accepts: 'WIZARD',
	        className: 'drag-over-trigger',
	        disabled: droppable === false
	      }),
	      _react2.default.createElement(_Droppable2.default, {
	        onDragEnter: handleDragRightEnter,
	        onDragExit: handleDragExit,
	        onDrop: handleDragExit,
	        onDropAccepted: handleDropAccepted,
	        accepts: 'WIZARD',
	        className: 'drag-over-trigger right',
	        disabled: droppable === false
	      })
	    )
	  );
	};
	
	exports.default = (0, _reactRedux.connect)(null, {
	  toggleDragging: _FormManagerActions.toggleDragging,
	  moveWizard: _FormManagerActions.moveWizard,
	  publishWizard: _FormManagerActions.publishWizard,
	  unpublishWizard: _FormManagerActions.unpublishWizard
	})(DraggableWizard);
	
	
	var Label = function Label(_ref3) {
	  var tip = _ref3.tip;
	  return _react2.default.createElement(
	    'span',
	    { className: 'label' },
	    tip
	  );
	};
	
	var WizardBlock = function WizardBlock(_ref4) {
	  var events = _ref4.events,
	      isActive = _ref4.isActive,
	      label = _ref4.label,
	      description = _ref4.description,
	      formDefinitionId = _ref4.formDefinitionId,
	      icon = _ref4.icon,
	      isDragging = _ref4.isDragging,
	      onRequestClone = _ref4.onRequestClone,
	      onRequestArchive = _ref4.onRequestArchive,
	      onRequestExport = _ref4.onRequestExport,
	      expanded = _ref4.expanded,
	      setCollapsed = _ref4.setCollapsed,
	      setExpanded = _ref4.setExpanded,
	      lastModifiedDate = _ref4.lastModifiedDate,
	      lastModifiedName = _ref4.lastModifiedName,
	      onRequestEdit = _ref4.onRequestEdit;
	
	  return _react2.default.createElement(_Forms.ExpandableFormBlock, {
	    className: 'inner-block ' + (!isActive ? 'transition' : 'faded'),
	    label: label,
	    description: description,
	    onStartCollapse: setCollapsed,
	    onStartExpand: setExpanded,
	    formDefinitionId: formDefinitionId,
	    icon: icon,
	    hideButtons: isDragging,
	    collapsedChildren: _react2.default.createElement(
	      'div',
	      { className: 'hover-edit-wrapper', onClick: onRequestEdit },
	      _react2.default.createElement(
	        'span',
	        { className: 'hover-edit' },
	        _react2.default.createElement(_pencil2.default, null)
	      )
	    ),
	    metadata: _react2.default.createElement(
	      'div',
	      { className: 'metadata-row' },
	      _react2.default.createElement(
	        'p',
	        { className: 'description' },
	        'Last Modified Date: ' + (0, _format2.default)(new Date(lastModifiedDate), 'MM/dd/yyyy h:mm a')
	      ),
	      lastModifiedName ? _react2.default.createElement(
	        'p',
	        { className: 'description' },
	        'Last Modified By: ' + lastModifiedName
	      ) : null
	    ),
	    actions: _react2.default.createElement(
	      'div',
	      { className: 'actions-row' },
	      _react2.default.createElement(
	        'button',
	        { className: 'btn btn-primary btn-text', onClick: onRequestArchive, alt: 'Delete' },
	        _react2.default.createElement(Label, { tip: 'Delete' }),
	        _react2.default.createElement(_archive2.default, null)
	      ),
	      _react2.default.createElement(
	        'button',
	        { className: 'btn btn-primary btn-text', onClick: onRequestClone, alt: 'Clone' },
	        _react2.default.createElement(Label, { tip: 'Clone' }),
	        _react2.default.createElement(_clone2.default, null)
	      ),
	      _react2.default.createElement(
	        'button',
	        { className: 'btn btn-primary btn-text', onClick: onRequestExport, alt: 'Export' },
	        _react2.default.createElement(Label, { tip: 'Export' }),
	        _react2.default.createElement(_export2.default, null)
	      ),
	      _react2.default.createElement(
	        'button',
	        { className: 'btn btn-primary btn-text', onClick: onRequestEdit, alt: 'Edit' },
	        _react2.default.createElement(Label, { tip: 'Edit' }),
	        _react2.default.createElement(_pencil2.default, null)
	      )
	    )
	  });
	};

/***/ },
/* 1099 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(7);
	
	var _reactRouterDom = __webpack_require__(30);
	
	var _Shell = __webpack_require__(19);
	
	var _FloatingMenu = __webpack_require__(86);
	
	var _FloatingMenu2 = _interopRequireDefault(_FloatingMenu);
	
	var _Loaders = __webpack_require__(16);
	
	var _Icons = __webpack_require__(298);
	
	var _Icons2 = _interopRequireDefault(_Icons);
	
	var _ImportDialog = __webpack_require__(456);
	
	var _ImportDialog2 = _interopRequireDefault(_ImportDialog);
	
	var _FabButton = __webpack_require__(1136);
	
	var _FabButton2 = _interopRequireDefault(_FabButton);
	
	var _DragContext = __webpack_require__(85);
	
	var _Droppable = __webpack_require__(100);
	
	var _Droppable2 = _interopRequireDefault(_Droppable);
	
	var _crossHeavy = __webpack_require__(51);
	
	var _crossHeavy2 = _interopRequireDefault(_crossHeavy);
	
	var _import = __webpack_require__(160);
	
	var _import2 = _interopRequireDefault(_import);
	
	var _addWizard = __webpack_require__(549);
	
	var _addWizard2 = _interopRequireDefault(_addWizard);
	
	var _addCategory = __webpack_require__(548);
	
	var _addCategory2 = _interopRequireDefault(_addCategory);
	
	var _Portal = __webpack_require__(12);
	
	var _Portal2 = _interopRequireDefault(_Portal);
	
	var _FormManagerActions = __webpack_require__(196);
	
	var _Category = __webpack_require__(1097);
	
	var _Category2 = _interopRequireDefault(_Category);
	
	var _store = __webpack_require__(18);
	
	__webpack_require__(1442);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ConnectedFormManager = function ConnectedFormManager(_ref) {
	  var match = _ref.match,
	      location = _ref.location,
	      wizards = _ref.wizards,
	      categories = _ref.categories,
	      categoriesOrder = _ref.categoriesOrder,
	      categoryIcons = _ref.categoryIcons,
	      activeCategory = _ref.activeCategory,
	      getAllWizards = _ref.getAllWizards,
	      fetchStructure = _ref.fetchStructure;
	
	  _react2.default.useEffect(function () {
	    if (match.params.category) {
	      (0, _FormManagerActions.setActiveCategory)(match.params.category);
	      getAllWizards(match.params.category);
	    }
	  }, [match.params.category]);
	
	  _react2.default.useEffect(function () {
	    if (!categories) {
	      fetchStructure();
	    }
	  }, [categories]);
	
	  _react2.default.useEffect(function () {
	    var interval = setInterval(function () {
	      return fetchStructure();
	    }, 15000);
	    return function () {
	      clearInterval(interval);
	    };
	  }, []);
	
	  var _React$useMemo = _react2.default.useMemo(function () {
	    if (categoriesOrder && categories && categoriesOrder[match.params.category] && match.params.category && wizards[match.params.category]) {
	      var ordered = categoriesOrder[match.params.category].map(function (id) {
	        return Object.assign({}, categories[match.params.category][id], {
	          id: id,
	          wizards: (categories[match.params.category][id].wizardsOrder || []).map(function (wizardId) {
	            return wizards[match.params.category][wizardId];
	          }).filter(function (x) {
	            return x;
	          })
	        });
	      });
	      var uncategorized = Object.values(wizards[match.params.category]).filter(function (wizard) {
	        return !ordered.flatMap(function (cat) {
	          return cat.wizards.map(function (w) {
	            return w.FORM_DEFINITION_ID;
	          });
	        }).includes(wizard.FORM_DEFINITION_ID);
	      });
	      return [ordered, uncategorized];
	    } else {
	      return [[], []];
	    }
	  }, [categoriesOrder, categories, match.params.category, wizards]),
	      _React$useMemo2 = _slicedToArray(_React$useMemo, 2),
	      orderedCategories = _React$useMemo2[0],
	      uncategorizedWizards = _React$useMemo2[1];
	
	  if (!categories || !match.params.category || !wizards[match.params.category]) {
	    return _react2.default.createElement(
	      _Shell.Body,
	      null,
	      !match.params.category ? _react2.default.createElement(_reactRouterDom.Redirect, { to: location.pathname + '/' + activeCategory }) : null,
	      _react2.default.createElement(
	        'div',
	        { className: 'form-manager forms loader-wrapper' },
	        _react2.default.createElement(_Loaders.Spinner, { className: 'page-loader', themeColor: 'primary' })
	      )
	    );
	  }
	
	  var icon = categoryIcons[match.params.category];
	
	  return _react2.default.createElement(FormManager, {
	    activeCategory: activeCategory,
	    categories: orderedCategories,
	    uncategorizedWizards: uncategorizedWizards,
	    onRequestRefetch: function onRequestRefetch() {
	      return getAllWizards(match.params.category);
	    },
	    icon: icon
	  });
	};
	exports.default = (0, _reactRedux.connect)(function (state) {
	  return {
	    categories: state.formManager.categories,
	    categoriesOrder: state.formManager.categoriesOrder,
	    categoryIcons: state.formManager.categoryIcons,
	    activeCategory: state.formManager.activeCategory,
	    wizards: state.formManager.wizards
	  };
	}, { getAllWizards: _FormManagerActions.getAllWizards, fetchStructure: _FormManagerActions.fetchStructure, setActiveCategory: _FormManagerActions.setActiveCategory })(ConnectedFormManager);
	
	
	var FormManager = function FormManager(_ref2) {
	  var filter = _ref2.filter,
	      activeCategory = _ref2.activeCategory,
	      _ref2$categories = _ref2.categories,
	      categories = _ref2$categories === undefined ? [] : _ref2$categories,
	      _ref2$uncategorizedWi = _ref2.uncategorizedWizards,
	      uncategorizedWizards = _ref2$uncategorizedWi === undefined ? [] : _ref2$uncategorizedWi,
	      icon = _ref2.icon,
	      setCategoryTitle = _ref2.setCategoryTitle,
	      toggleVisibility = _ref2.toggleVisibility,
	      reorderCategory = _ref2.reorderCategory,
	      addCategory = _ref2.addCategory,
	      deleteCategory = _ref2.deleteCategory,
	      onRequestRefetch = _ref2.onRequestRefetch,
	      unpublishWizard = _ref2.unpublishWizard;
	
	  var _React$useState = _react2.default.useState(false),
	      _React$useState2 = _slicedToArray(_React$useState, 2),
	      importDialogOpen = _React$useState2[0],
	      setImportDialogOpen = _React$useState2[1];
	
	  var scrollInterval = _react2.default.useRef();
	
	  var startNewWizard = function startNewWizard() {
	    return _store.history.push('edit/0?category=' + activeCategory);
	  };
	
	  var closeImportDialog = function closeImportDialog() {
	    return setImportDialogOpen(false);
	  };
	
	  var closeAndReload = function closeAndReload() {
	    closeImportDialog();
	    onRequestRefetch();
	  };
	
	  var scrollUp = function scrollUp() {
	    if (window.scrollY > 0) {
	      document.documentElement.scrollTop = window.scrollY - 15;
	      scrollInterval.current = requestAnimationFrame(scrollUp);
	    } else {
	      stopScroll();
	    }
	  };
	  var scrollDown = function scrollDown() {
	    if (window.scrollY < document.body.clientHeight) {
	      document.documentElement.scrollTop = window.scrollY + 15;
	      scrollInterval.current = requestAnimationFrame(scrollDown);
	    } else {
	      stopScroll();
	    }
	  };
	  var registerScrollUp = function registerScrollUp(e) {
	    scrollInterval.current = requestAnimationFrame(scrollUp);
	  };
	  var registerScrollDown = function registerScrollDown(e) {
	    scrollInterval.current = requestAnimationFrame(scrollDown);
	  };
	  var stopScroll = function stopScroll() {
	    cancelAnimationFrame(scrollInterval.current);
	  };
	
	  return _react2.default.createElement(
	    _Shell.Body,
	    { className: 'form-manager forms' },
	    _react2.default.createElement(
	      _DragContext.DragProvider,
	      null,
	      _react2.default.createElement(Toolbar, { selectedIcon: icon }),
	      _react2.default.createElement(
	        _Shell.FlexWrapper,
	        { direction: 'column' },
	        categories.map(function (category, i) {
	          return _react2.default.createElement(_Category2.default, Object.assign({}, category, {
	            filter: filter,
	            icon: icon,
	            onVisibilityChange: function onVisibilityChange(on) {
	              return toggleVisibility({ on: on, categoryId: category.id });
	            },
	            onTitleChange: function onTitleChange(title) {
	              return setCategoryTitle({ title: title, categoryId: category.id });
	            },
	            onReorderUp: function onReorderUp() {
	              return reorderCategory({
	                direction: 'up',
	                categoryId: category.id,
	                categoryIndex: i
	              });
	            },
	            onReorderDown: function onReorderDown() {
	              return reorderCategory({
	                direction: 'down',
	                categoryId: category.id,
	                categoryIndex: i
	              });
	            },
	            onRequestDelete: function onRequestDelete() {
	              return deleteCategory({ categoryId: category.id, categoryIndex: i });
	            },
	            onRequestRefetch: onRequestRefetch,
	            canReorderUp: i !== 0,
	            canReorderDown: i !== categories.length - 1,
	            key: category.id
	          }));
	        })
	      ),
	      _react2.default.createElement(
	        _Droppable2.default,
	        {
	          accepts: 'WIZARD',
	          onDropAccepted: function onDropAccepted(data) {
	            return unpublishWizard({ origin: data });
	          },
	          className: 'uncategorized-wrapper'
	        },
	        _react2.default.createElement(
	          _DragContext.DragState,
	          null,
	          function (_ref3) {
	            var isDragging = _ref3.isDragging;
	            return isDragging && _react2.default.createElement(
	              'div',
	              { className: 'unpublish-shade animated fadeIn fast-animation' },
	              'Unpublish Form'
	            );
	          }
	        ),
	        _react2.default.createElement(_Category2.default, {
	          filter: filter,
	          title: 'Unpublished Forms',
	          id: 'uncategorized',
	          uncategorized: true,
	          activeCategory: activeCategory,
	          icon: icon,
	          canReorderUp: false,
	          canReorderDown: false,
	          wizards: uncategorizedWizards
	        })
	      ),
	      _react2.default.createElement(
	        _FabButton2.default,
	        { ariaLabel: 'Expand available actions' },
	        _react2.default.createElement(
	          _FabButton.FabSubButton,
	          { tooltip: 'Create New Category', onClick: addCategory },
	          _react2.default.createElement(_addCategory2.default, null)
	        ),
	        _react2.default.createElement(
	          _FabButton.FabSubButton,
	          {
	            tooltip: 'Create New ' + activeCategory.charAt(0).toUpperCase() + activeCategory.slice(1) + ' Form',
	            onClick: startNewWizard
	          },
	          _react2.default.createElement(_addWizard2.default, null)
	        ),
	        _react2.default.createElement(
	          _FabButton.FabSubButton,
	          { tooltip: 'Import', onClick: function onClick() {
	              return setImportDialogOpen(true);
	            } },
	          _react2.default.createElement(_import2.default, null)
	        )
	      ),
	      _react2.default.createElement(_ImportDialog2.default, {
	        isOpened: importDialogOpen,
	        closeModal: closeImportDialog,
	        closeAndReload: closeAndReload
	      }),
	      _react2.default.createElement(
	        _DragContext.DragState,
	        null,
	        function (state) {
	          return state.isDragging && _react2.default.createElement(
	            _Portal2.default,
	            { isOpened: true },
	            _react2.default.createElement(
	              _react2.default.Fragment,
	              null,
	              _react2.default.createElement('div', {
	                className: 'form-manager-scroll-zone',
	                onMouseEnter: registerScrollUp,
	                onMouseLeave: stopScroll
	              }),
	              _react2.default.createElement('div', {
	                className: 'form-manager-scroll-zone bottom',
	                onMouseEnter: registerScrollDown,
	                onMouseLeave: stopScroll
	              })
	            )
	          );
	        }
	      )
	    )
	  );
	};
	FormManager = (0, _reactRedux.connect)(function (state) {
	  return {
	    filter: state.formManager.filter
	  };
	}, {
	  setCategoryTitle: _FormManagerActions.setCategoryTitle,
	  toggleVisibility: _FormManagerActions.toggleVisibility,
	  reorderCategory: _FormManagerActions.reorderCategory,
	  addCategory: _FormManagerActions.addCategory,
	  deleteCategory: _FormManagerActions.deleteCategory,
	  unpublishWizard: _FormManagerActions.unpublishWizard
	})(FormManager);
	
	var Toolbar = function Toolbar(_ref4) {
	  var selectedIcon = _ref4.selectedIcon,
	      setFilter = _ref4.setFilter,
	      setAndPushIcon = _ref4.setAndPushIcon,
	      filter = _ref4.filter;
	
	  var _React$useState3 = _react2.default.useState(null),
	      _React$useState4 = _slicedToArray(_React$useState3, 2),
	      menuAnchor = _React$useState4[0],
	      setMenuAnchor = _React$useState4[1];
	
	  var _React$useState5 = _react2.default.useState(false),
	      _React$useState6 = _slicedToArray(_React$useState5, 2),
	      iconMenuOpen = _React$useState6[0],
	      setIconMenuOpen = _React$useState6[1];
	
	  var iconButton = _react2.default.useRef();
	  var input = _react2.default.useRef();
	
	  var openIconMenu = function openIconMenu() {
	    setMenuAnchor(iconButton.current);
	    setIconMenuOpen(true);
	  };
	  var closeIconMenu = function closeIconMenu() {
	    setIconMenuOpen(false);
	  };
	  var setIcon = function setIcon(_ref5) {
	    var value = _ref5.value;
	
	    setAndPushIcon(value);
	  };
	  var selectInput = function selectInput() {
	    input.current.select();
	  };
	  var clearFilter = function clearFilter() {
	    setFilter('');
	    input.current.focus();
	  };
	  return _react2.default.createElement(
	    'div',
	    { className: 'toolbar' },
	    _react2.default.createElement(
	      'div',
	      { className: 'icon-wrapper' },
	      _react2.default.createElement(
	        'div',
	        { className: 'selected-icon', ref: iconButton, onClick: openIconMenu },
	        _Icons2.default[selectedIcon]
	      ),
	      _react2.default.createElement(_FloatingMenu2.default, {
	        className: 'fm-icon-menu',
	        isOpen: iconMenuOpen,
	        alignTo: menuAnchor,
	        align: 'right',
	        onRequestClose: closeIconMenu,
	        options: [{ value: 'business', label: _Icons2.default.business, onClick: setIcon }, { value: 'shield', label: _Icons2.default.shield, onClick: setIcon }, { value: 'tools', label: _Icons2.default.tools, onClick: setIcon }, { value: 'capital', label: _Icons2.default.capital, onClick: setIcon }, { value: 'charity', label: _Icons2.default.charity, onClick: setIcon }, { value: 'stamp', label: _Icons2.default.stamp, onClick: setIcon }]
	      })
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'filter-wrapper' },
	      _react2.default.createElement('input', {
	        ref: input,
	        className: 'filter',
	        type: 'text',
	        placeholder: 'Filter',
	        value: filter,
	        onChange: function onChange(e) {
	          return setFilter(e.target.value);
	        },
	        onFocus: selectInput,
	        'aria-label': 'Filter Forms'
	      }),
	      filter && _react2.default.createElement(
	        'button',
	        { 'aria-label': 'clear filter', className: 'clear', onClick: clearFilter },
	        _react2.default.createElement(_crossHeavy2.default, null)
	      )
	    )
	  );
	};
	Toolbar = (0, _reactRedux.connect)(function (state) {
	  return {
	    filter: state.formManager.filter
	  };
	}, { setAndPushIcon: _FormManagerActions.setAndPushIcon, setFilter: _FormManagerActions.setFilter })(Toolbar);

/***/ },
/* 1100 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.initialState = undefined;
	
	var _shortid = __webpack_require__(22);
	
	var _shortid2 = _interopRequireDefault(_shortid);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var SUBROUTES = Array.isArray(([{"label":"Business","component":"Business","parameter":"business","myWorkQueueSearch":false,"sourceTypeId":54,"searchMustHaveOneOf":["FILING_TYPE_ID","STATUS_ID","STATE","search"],"serverWebSearchDescription":true,"serverWorkQueueDescription":true,"serverMyRecordsDescription":true,"searchPlaceholder":"Search by name or filing number (X########)","allowEmptySearchTerm":true,"requestCertificateAlternateLabel":"Request Information","fileAmendmentButtonLabel":"Filing Actions","advancedSearchParameters":[{"type":"radio","name":"QUERY_TYPE_ID","defaultValue":1010,"options":[{"value":1010,"label":"Starts with"},{"value":1011,"label":"Contains"},{"value":1012,"label":" Word Contains"}]},{"type":"serverSelect","name":"FILING_TYPE_ID","optionsSrc":"FILING_TYPES","label":"Entity Type","placeholder":"All","defaultValue":"0"},{"type":"serverSelect","name":"FILING_SUBTYPE_ID","optionsSrc":"FILING_SUBTYPES","label":"Entity Subtype","overrideSubOptionsSrcFromParameterName":"FILING_TYPE_ID","placeholder":"All","defaultValue":"0"},{"type":"serverSelect","name":"STATUS_ID","optionsSrc":"FILING_STATUS_WITHOUT_ALL","label":"Status","placeholder":"All","defaultValue":"0"},{"type":"serverSelect","name":"STATE","optionsSrc":"STATE","label":"State","placeholder":"All","defaultValue":""},{"type":"serverSelect","name":"COUNTY","optionsSrc":"COUNTY_SUBOPTION","label":"County","overrideSubOptionsSrcFromParameterName":"STATE","placeholder":"All","defaultValue":""},{"type":"checkbox","name":"CRA_SEARCH_YN","defaultValue":false,"label":"Search by Registered Agent PID"},{"type":"dateRange","name":"FILING_DATE","label":"Registration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}},{"type":"dateRange","name":"EXPIRATION_DATE","label":"Expiration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}}],"myRecordsFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Active"},{"value":2,"label":"Inactive"},{"value":3,"label":"Pending"}]},{"type":"dateRange","name":"DATE_RANGE","label":"Date range","defaultValue":{"start":null,"end":null}}],"myWorkQueueFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Approved"},{"value":2,"label":"Pending Online Payment"},{"value":3,"label":"Pending Review"},{"value":4,"label":"Needs Correction"},{"value":5,"label":"Rejected"},{"value":6,"label":"Draft"}]},{"type":"dateRange","name":"DATE_RANGE","label":"Date range","defaultValue":{"start":null,"end":null}}]},{"label":"Notary","component":"Notary","parameter":"notary","sourceTypeId":850,"myWorkQueueSearch":false,"allowEmptySearchTerm":true,"requestCertificateAlternateLabel":"Download Certificate","fileAmendmentButtonLabel":"Filing Actions","hideNameRequestCertificate":true,"hideAddressRequestCertificate":true,"hideRecordUserManagment":true,"searchPlaceholder":"Search by name or commission number","searchMustHaveOneOf":["CITY","search","SERVICE_TYPE"],"advancedParametersStartOpen":true,"searchIsSortable":true,"advancedSearchParameters":[{"type":"radio","name":"STARTS_WITH_YN","defaultValue":false,"options":[{"value":true,"label":"Starts with"},{"value":false,"label":"Contains"}]},{"type":"checkbox","name":"ACTIVE_ONLY_YN","defaultValue":true,"label":"Active entities only"},{"type":"text","name":"CITY","defaultValue":"","label":"City"},{"type":"select","name":"SERVICE_TYPE","label":"Special Services Offered","defaultValue":0,"options":[{"value":0,"label":"(N/A)"},{"value":6165,"label":"In-Person Electronic Notarization (IPEN)"},{"value":6166,"label":"Remote Online Notarization (RON)"},{"value":6167,"label":"Mobile Notary Services"},{"value":6168,"label":"Remote Ink Notarization (RIN)"}]}]},{"label":"Apostille","component":"Apostille","parameter":"apostille","sourceTypeId":720,"myRecordsSearch":false,"myWorkQueueSearch":false,"disabled":false,"allowedRoutes":["/forms-manager/","/queue/","/forms/"]},{"label":"Liens","component":"UCC","parameter":"ucc","sourceTypeId":1999,"myRecordsSearch":true,"myWorkQueueSearch":true,"fileAmendmentButtonLabel":"Filing Actions","searchPlaceholder":"Search by name or file number","disabled":false,"serverWebSearchDescription":true,"myRecordsDescription":"","workQueueDescription":"","searchDescription":"","hideRecordUserManagment":true,"searchLiensCheckout":false,"advancedSearchParameters":[{"type":"radio","name":"STARTS_WITH_YN","defaultValue":false,"options":[{"value":true,"label":"Starts with"},{"value":false,"label":"Contains"}]},{"type":"select","name":"STATUS","defaultValue":"ALL","label":"Status","options":[{"value":"ACTIVE_UNLAPSED","label":"Active (unlapsed)"},{"value":"ACTIVE_LAPSED_UNLAPSED","label":"Active (lapsed and unlapsed)"}]},{"type":"text","name":"EXCLUDE_VALUES","label":"Exclude Debtor Names (comma separated list of names to exclude)","defaultValue":""},{"type":"dateRange","name":"FILING_DATE","label":"Financing Statement Date","defaultValue":{"start":null,"end":null}},{"type":"dateRange","name":"LAPSE_DATE","label":"Lapse Date","defaultValue":{"start":null,"end":null}},{"type":"text","name":"CITY","label":"Debtor City","defaultValue":""}],"myRecordsFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Approved"},{"value":2,"label":"Pending Online Payment"},{"value":3,"label":"Pending Review"}]},{"type":"select","name":"TYPE","defaultValue":0,"label":"Lien Type","options":[{"value":0,"label":"All"},{"value":1,"label":"UCC"},{"value":2,"label":"EFS"},{"value":3,"label":"Title 71"}]}],"myWorkQueueFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Approved"},{"value":2,"label":"Pending Online Payment"},{"value":3,"label":"Pending Review"},{"value":4,"label":"Pending Print and Mail"},{"value":5,"label":"Rejected"},{"value":6,"label":"Draft"}]},{"type":"select","name":"TYPE","defaultValue":0,"label":"Lien Type","options":[{"value":0,"label":"All"},{"value":1,"label":"UCC"},{"value":2,"label":"EFS"},{"value":3,"label":"Title 71"}]}]},{"label":"Copy Request","component":"copies","parameter":"copies","sourceTypeId":2001,"myRecordsSearch":false,"myWorkQueueSearch":false,"disabled":false,"allowedRoutes":["/forms-manager/","/queue/","/forms/"]},{"label":"Trademark","component":"Trademark","parameter":"trademark","sourceTypeId":810,"showRequestCertificate":true,"searchMustHaveOneOf":["search","EXPIRATION_DATE","FILING_DATE"],"allowEmptySearchTerm":true,"requestCertificateAlternateLabel":"Request Information","fileAmendmentButtonLabel":"Filing Actions","advancedSearchParameters":[{"type":"radio","name":"QUERY_TYPE_ID","defaultValue":1010,"options":[{"value":1010,"label":"Starts with"},{"value":1011,"label":"Contains"},{"value":1012,"label":" Word Contains"}]},{"type":"checkbox","name":"OWNER_SEARCH_YN","defaultValue":false,"label":"Search owners"},{"type":"radio","name":"SERVICE_MARK_YN","label":"Mark Type","defaultValue":"","options":[{"value":"","label":"All Marks"},{"value":"Y","label":"Service Mark"},{"value":"N","label":"Trademark"}]},{"type":"serverSelect","name":"STATUS_ID","optionsSrc":"TYPE_V|TRADEMARK_STATUS_TYPE","label":"Status","placeholder":"All","defaultValue":"0"},{"type":"select","name":"DESIGN_TYPE_ID","options":[{"value":0,"label":"All"},{"value":990,"label":"Words Only"},{"value":991,"label":"Design Only"},{"value":992,"label":"Words and Design"}],"label":"Design Type","defaultValue":"0"},{"type":"dateRange","name":"FILING_DATE","label":"Registered Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}},{"type":"dateRange","name":"EXPIRATION_DATE","label":"Expiration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}}]},{"label":"Business Info Request","component":"InfoRequests","parameter":"info-request","sourceTypeId":167,"allowedRoutes":["/forms-manager/","/queue/","/forms/"]},{"label":"Data Requests","component":"DataRequests","parameter":"data-request","sourceTypeId":0,"allowedRoutes":["/forms-manager/"]},{"label":"CRA","component":"CRA","parameter":"cra","sourceTypeId":157,"myRecordsSearch":false,"searchPlaceholder":"Search by name or registered agent number","allowedRoutes":["/forms-manager/","/forms/","/records/","/queue/","/search/"],"allowEmptySearchTerm":true,"fileAmendmentButtonLabel":"Filing Actions","advancedSearchParameters":[{"type":"radio","name":"QUERY_TYPE_ID","defaultValue":1010,"options":[{"value":1010,"label":"Starts with"},{"value":1011,"label":"Contains"},{"value":1012,"label":" Word Contains"}]},{"type":"dateRange","name":"CRA_DATE","label":"Registration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}},{"type":"select","name":"STATUS_ID","label":"Status","defaultValue":0,"options":[{"value":0,"label":"All"},{"value":121,"label":"Active"},{"value":122,"label":"Inactive"}]},{"type":"select","name":"AGENT_TYPE_ID","label":"Agent Type","defaultValue":0,"options":[{"value":0,"label":"All"},{"value":460,"label":"Registered Agent"},{"value":461,"label":"Commercial Registered Agent"}]}]},{"label":"Farm Bill","component":"FarmBill","parameter":"farm-bill","path":"/lists/farm-bill","sourceTypeId":0,"myRecordsSearch":false,"allowedRules":["/search/"],"disabled":true,"searchDescription":"To perform a search, enter a debtor name. Your search results may include: exact debtor name, variations of that name and any filing that includes your search criteria. Punctuation is ignored.\n\nYou can click on \"Advanced\" to refine your search. Under “Advanced” you can search by crop, year, county and SSN/FEIN. As a registered Farm Bill Buyer with the Montana Secretary of State’s office it is important to maintain the confidentiality of the information contained within the Farm Bill Master List. The Farm Bill Master List reflects personal data, such as Social Security Numbers, which are a key piece of personal identifiable information to assist you in determining the existence of a lien against a specific debtor. The distribution of this information beyond its intended purpose is strictly prohibited.\n\nThe debtor's tax identification number has been hidden for confidentiality reasons. You may continue to search on a tax ID number and return debtors that match your search criteria. The SSN/FEIN must be entered without dashes or spaces.","searchMustHaveOneOf":["search","UCC_FARM_PRODUCT_ID","COUNTY"],"searchPlaceholder":"Search by debtor name","advancedSearchParameters":[{"type":"ServerMultiComplete","label":"Product code name(s)","name":"UCC_FARM_PRODUCT_ID","defaultValue":"","optionsSrc":"UCC_FARM_PRODUCT_V"},{"type":"MultiComplete","label":"Year or Range of Years","name":"YEAR_NUM","optionsSrc":"years","startYear":"1968","defaultValue":[],"preMergeOptions":[{"value":"ALL","label":"All"}]},{"type":"serverSelect","label":"State","name":"STATE","defaultValue":"MONTANA","optionsSrc":"STATE"},{"type":"ServerMultiComplete","label":"County","name":"COUNTY","defaultValue":[],"optionsSrc":"COUNTY","overrideSubOptionsSrcFromParameterName":"STATE"},{"type":"checkbox","name":"TIN_SEARCH_YN","defaultValue":false,"label":"Tax Identification Number Search"},{"type":"checkbox","name":"TIN_SORT_YN","defaultValue":false,"label":"Unique ID Sort"}]}])) ? ([{"label":"Business","component":"Business","parameter":"business","myWorkQueueSearch":false,"sourceTypeId":54,"searchMustHaveOneOf":["FILING_TYPE_ID","STATUS_ID","STATE","search"],"serverWebSearchDescription":true,"serverWorkQueueDescription":true,"serverMyRecordsDescription":true,"searchPlaceholder":"Search by name or filing number (X########)","allowEmptySearchTerm":true,"requestCertificateAlternateLabel":"Request Information","fileAmendmentButtonLabel":"Filing Actions","advancedSearchParameters":[{"type":"radio","name":"QUERY_TYPE_ID","defaultValue":1010,"options":[{"value":1010,"label":"Starts with"},{"value":1011,"label":"Contains"},{"value":1012,"label":" Word Contains"}]},{"type":"serverSelect","name":"FILING_TYPE_ID","optionsSrc":"FILING_TYPES","label":"Entity Type","placeholder":"All","defaultValue":"0"},{"type":"serverSelect","name":"FILING_SUBTYPE_ID","optionsSrc":"FILING_SUBTYPES","label":"Entity Subtype","overrideSubOptionsSrcFromParameterName":"FILING_TYPE_ID","placeholder":"All","defaultValue":"0"},{"type":"serverSelect","name":"STATUS_ID","optionsSrc":"FILING_STATUS_WITHOUT_ALL","label":"Status","placeholder":"All","defaultValue":"0"},{"type":"serverSelect","name":"STATE","optionsSrc":"STATE","label":"State","placeholder":"All","defaultValue":""},{"type":"serverSelect","name":"COUNTY","optionsSrc":"COUNTY_SUBOPTION","label":"County","overrideSubOptionsSrcFromParameterName":"STATE","placeholder":"All","defaultValue":""},{"type":"checkbox","name":"CRA_SEARCH_YN","defaultValue":false,"label":"Search by Registered Agent PID"},{"type":"dateRange","name":"FILING_DATE","label":"Registration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}},{"type":"dateRange","name":"EXPIRATION_DATE","label":"Expiration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}}],"myRecordsFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Active"},{"value":2,"label":"Inactive"},{"value":3,"label":"Pending"}]},{"type":"dateRange","name":"DATE_RANGE","label":"Date range","defaultValue":{"start":null,"end":null}}],"myWorkQueueFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Approved"},{"value":2,"label":"Pending Online Payment"},{"value":3,"label":"Pending Review"},{"value":4,"label":"Needs Correction"},{"value":5,"label":"Rejected"},{"value":6,"label":"Draft"}]},{"type":"dateRange","name":"DATE_RANGE","label":"Date range","defaultValue":{"start":null,"end":null}}]},{"label":"Notary","component":"Notary","parameter":"notary","sourceTypeId":850,"myWorkQueueSearch":false,"allowEmptySearchTerm":true,"requestCertificateAlternateLabel":"Download Certificate","fileAmendmentButtonLabel":"Filing Actions","hideNameRequestCertificate":true,"hideAddressRequestCertificate":true,"hideRecordUserManagment":true,"searchPlaceholder":"Search by name or commission number","searchMustHaveOneOf":["CITY","search","SERVICE_TYPE"],"advancedParametersStartOpen":true,"searchIsSortable":true,"advancedSearchParameters":[{"type":"radio","name":"STARTS_WITH_YN","defaultValue":false,"options":[{"value":true,"label":"Starts with"},{"value":false,"label":"Contains"}]},{"type":"checkbox","name":"ACTIVE_ONLY_YN","defaultValue":true,"label":"Active entities only"},{"type":"text","name":"CITY","defaultValue":"","label":"City"},{"type":"select","name":"SERVICE_TYPE","label":"Special Services Offered","defaultValue":0,"options":[{"value":0,"label":"(N/A)"},{"value":6165,"label":"In-Person Electronic Notarization (IPEN)"},{"value":6166,"label":"Remote Online Notarization (RON)"},{"value":6167,"label":"Mobile Notary Services"},{"value":6168,"label":"Remote Ink Notarization (RIN)"}]}]},{"label":"Apostille","component":"Apostille","parameter":"apostille","sourceTypeId":720,"myRecordsSearch":false,"myWorkQueueSearch":false,"disabled":false,"allowedRoutes":["/forms-manager/","/queue/","/forms/"]},{"label":"Liens","component":"UCC","parameter":"ucc","sourceTypeId":1999,"myRecordsSearch":true,"myWorkQueueSearch":true,"fileAmendmentButtonLabel":"Filing Actions","searchPlaceholder":"Search by name or file number","disabled":false,"serverWebSearchDescription":true,"myRecordsDescription":"","workQueueDescription":"","searchDescription":"","hideRecordUserManagment":true,"searchLiensCheckout":false,"advancedSearchParameters":[{"type":"radio","name":"STARTS_WITH_YN","defaultValue":false,"options":[{"value":true,"label":"Starts with"},{"value":false,"label":"Contains"}]},{"type":"select","name":"STATUS","defaultValue":"ALL","label":"Status","options":[{"value":"ACTIVE_UNLAPSED","label":"Active (unlapsed)"},{"value":"ACTIVE_LAPSED_UNLAPSED","label":"Active (lapsed and unlapsed)"}]},{"type":"text","name":"EXCLUDE_VALUES","label":"Exclude Debtor Names (comma separated list of names to exclude)","defaultValue":""},{"type":"dateRange","name":"FILING_DATE","label":"Financing Statement Date","defaultValue":{"start":null,"end":null}},{"type":"dateRange","name":"LAPSE_DATE","label":"Lapse Date","defaultValue":{"start":null,"end":null}},{"type":"text","name":"CITY","label":"Debtor City","defaultValue":""}],"myRecordsFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Approved"},{"value":2,"label":"Pending Online Payment"},{"value":3,"label":"Pending Review"}]},{"type":"select","name":"TYPE","defaultValue":0,"label":"Lien Type","options":[{"value":0,"label":"All"},{"value":1,"label":"UCC"},{"value":2,"label":"EFS"},{"value":3,"label":"Title 71"}]}],"myWorkQueueFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Approved"},{"value":2,"label":"Pending Online Payment"},{"value":3,"label":"Pending Review"},{"value":4,"label":"Pending Print and Mail"},{"value":5,"label":"Rejected"},{"value":6,"label":"Draft"}]},{"type":"select","name":"TYPE","defaultValue":0,"label":"Lien Type","options":[{"value":0,"label":"All"},{"value":1,"label":"UCC"},{"value":2,"label":"EFS"},{"value":3,"label":"Title 71"}]}]},{"label":"Copy Request","component":"copies","parameter":"copies","sourceTypeId":2001,"myRecordsSearch":false,"myWorkQueueSearch":false,"disabled":false,"allowedRoutes":["/forms-manager/","/queue/","/forms/"]},{"label":"Trademark","component":"Trademark","parameter":"trademark","sourceTypeId":810,"showRequestCertificate":true,"searchMustHaveOneOf":["search","EXPIRATION_DATE","FILING_DATE"],"allowEmptySearchTerm":true,"requestCertificateAlternateLabel":"Request Information","fileAmendmentButtonLabel":"Filing Actions","advancedSearchParameters":[{"type":"radio","name":"QUERY_TYPE_ID","defaultValue":1010,"options":[{"value":1010,"label":"Starts with"},{"value":1011,"label":"Contains"},{"value":1012,"label":" Word Contains"}]},{"type":"checkbox","name":"OWNER_SEARCH_YN","defaultValue":false,"label":"Search owners"},{"type":"radio","name":"SERVICE_MARK_YN","label":"Mark Type","defaultValue":"","options":[{"value":"","label":"All Marks"},{"value":"Y","label":"Service Mark"},{"value":"N","label":"Trademark"}]},{"type":"serverSelect","name":"STATUS_ID","optionsSrc":"TYPE_V|TRADEMARK_STATUS_TYPE","label":"Status","placeholder":"All","defaultValue":"0"},{"type":"select","name":"DESIGN_TYPE_ID","options":[{"value":0,"label":"All"},{"value":990,"label":"Words Only"},{"value":991,"label":"Design Only"},{"value":992,"label":"Words and Design"}],"label":"Design Type","defaultValue":"0"},{"type":"dateRange","name":"FILING_DATE","label":"Registered Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}},{"type":"dateRange","name":"EXPIRATION_DATE","label":"Expiration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}}]},{"label":"Business Info Request","component":"InfoRequests","parameter":"info-request","sourceTypeId":167,"allowedRoutes":["/forms-manager/","/queue/","/forms/"]},{"label":"Data Requests","component":"DataRequests","parameter":"data-request","sourceTypeId":0,"allowedRoutes":["/forms-manager/"]},{"label":"CRA","component":"CRA","parameter":"cra","sourceTypeId":157,"myRecordsSearch":false,"searchPlaceholder":"Search by name or registered agent number","allowedRoutes":["/forms-manager/","/forms/","/records/","/queue/","/search/"],"allowEmptySearchTerm":true,"fileAmendmentButtonLabel":"Filing Actions","advancedSearchParameters":[{"type":"radio","name":"QUERY_TYPE_ID","defaultValue":1010,"options":[{"value":1010,"label":"Starts with"},{"value":1011,"label":"Contains"},{"value":1012,"label":" Word Contains"}]},{"type":"dateRange","name":"CRA_DATE","label":"Registration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}},{"type":"select","name":"STATUS_ID","label":"Status","defaultValue":0,"options":[{"value":0,"label":"All"},{"value":121,"label":"Active"},{"value":122,"label":"Inactive"}]},{"type":"select","name":"AGENT_TYPE_ID","label":"Agent Type","defaultValue":0,"options":[{"value":0,"label":"All"},{"value":460,"label":"Registered Agent"},{"value":461,"label":"Commercial Registered Agent"}]}]},{"label":"Farm Bill","component":"FarmBill","parameter":"farm-bill","path":"/lists/farm-bill","sourceTypeId":0,"myRecordsSearch":false,"allowedRules":["/search/"],"disabled":true,"searchDescription":"To perform a search, enter a debtor name. Your search results may include: exact debtor name, variations of that name and any filing that includes your search criteria. Punctuation is ignored.\n\nYou can click on \"Advanced\" to refine your search. Under “Advanced” you can search by crop, year, county and SSN/FEIN. As a registered Farm Bill Buyer with the Montana Secretary of State’s office it is important to maintain the confidentiality of the information contained within the Farm Bill Master List. The Farm Bill Master List reflects personal data, such as Social Security Numbers, which are a key piece of personal identifiable information to assist you in determining the existence of a lien against a specific debtor. The distribution of this information beyond its intended purpose is strictly prohibited.\n\nThe debtor's tax identification number has been hidden for confidentiality reasons. You may continue to search on a tax ID number and return debtors that match your search criteria. The SSN/FEIN must be entered without dashes or spaces.","searchMustHaveOneOf":["search","UCC_FARM_PRODUCT_ID","COUNTY"],"searchPlaceholder":"Search by debtor name","advancedSearchParameters":[{"type":"ServerMultiComplete","label":"Product code name(s)","name":"UCC_FARM_PRODUCT_ID","defaultValue":"","optionsSrc":"UCC_FARM_PRODUCT_V"},{"type":"MultiComplete","label":"Year or Range of Years","name":"YEAR_NUM","optionsSrc":"years","startYear":"1968","defaultValue":[],"preMergeOptions":[{"value":"ALL","label":"All"}]},{"type":"serverSelect","label":"State","name":"STATE","defaultValue":"MONTANA","optionsSrc":"STATE"},{"type":"ServerMultiComplete","label":"County","name":"COUNTY","defaultValue":[],"optionsSrc":"COUNTY","overrideSubOptionsSrcFromParameterName":"STATE"},{"type":"checkbox","name":"TIN_SEARCH_YN","defaultValue":false,"label":"Tax Identification Number Search"},{"type":"checkbox","name":"TIN_SORT_YN","defaultValue":false,"label":"Unique ID Sort"}]}]) : [];
	var FIRST_SUBROUTE = SUBROUTES.filter(function (s) {
	  return !s.allowedRoutes || s.allowedRoutes.includes('/forms-manager/');
	})[0];
	
	var initialState = exports.initialState = {
	  wizards: {},
	  activeCategory: FIRST_SUBROUTE ? FIRST_SUBROUTE.parameter : '',
	  categoriesOrder: {},
	  categories: null,
	  categoryIcons: {},
	  loading: true,
	  dragging: null,
	  isOver: null,
	  wasOver: null,
	  saving: null,
	  importDialogOpen: false,
	  filter: ''
	};
	
	var managerReducer = function managerReducer() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	  var action = arguments[1];
	
	  switch (action.type) {
	    case "@@fm/RESET_STATE":
	      return initialState;
	    case "@@fm/POPULATE_STRUCTURE":
	      return Object.assign({}, state, action.payload, { isOver: null, wasOver: null, saving: null });
	    case "@@fm/SET_ALL_WIZARDS":
	      return Object.assign({}, state, { wizards: Object.assign({}, state.wizards, _defineProperty({}, action.category, action.wizards)), activeCategory: action.category });
	    case "@@fm/TOGGLE_LOADING":
	      return Object.assign({}, state, { loading: state.loading !== false ? action.loading : false });
	    case "@@fm/SET_FILTER":
	      return Object.assign({}, state, { filter: action.filter });
	    case "@@fm/SET_ACTIVE_CATEGORY":
	      return Object.assign({}, state, { activeCategory: action.category });
	    case "@@fm/ADD_CATEGORY":
	      {
	        var id = _shortid2.default.generate();
	        var currentCategoriesOrder = state.categoriesOrder[state.activeCategory] || {};
	        return Object.assign({}, state, {
	          categoriesOrder: Object.assign({}, state.categoriesOrder, _defineProperty({}, state.activeCategory, [].concat(_toConsumableArray(currentCategoriesOrder), [id]))),
	          categories: Object.assign({}, state.categories, _defineProperty({}, state.activeCategory, Object.assign({}, state.categories[state.activeCategory], _defineProperty({}, id, {
	            title: "New Category",
	            wizardsOrder: [],
	            visible: true,
	            abbreviation: ''
	          }))))
	        });
	      }
	    case "@@fm/DELETE_CATEGORY":
	      {
	        var _state$categories$sta = state.categories[state.activeCategory],
	            toDelete = _state$categories$sta[action.categoryId],
	            category = _objectWithoutProperties(_state$categories$sta, [action.categoryId]);
	
	        return Object.assign({}, state, {
	          categories: Object.assign({}, state.categories, _defineProperty({}, state.activeCategory, category)),
	          categoriesOrder: Object.assign({}, state.categoriesOrder, _defineProperty({}, state.activeCategory, [].concat(_toConsumableArray(state.categoriesOrder[state.activeCategory].slice(0, action.categoryIndex)), _toConsumableArray(state.categoriesOrder[state.activeCategory].slice(action.categoryIndex + 1)))))
	        });
	      }
	    case '@@fm/SET_ICON':
	      return Object.assign({}, state, { categoryIcons: Object.assign({}, state.categoryIcons, _defineProperty({}, state.activeCategory, action.icon)) });
	    case "@@fm/TOGGLE_DRAGGING":
	      return Object.assign({}, state, { dragging: action.dragging });
	    case "@@fm/TOGGLE_SAVING":
	      return Object.assign({}, state, { saving: action.saving });
	    case "@@fm/TOGGLE_IMPORT_DIALOG":
	      return Object.assign({}, state, { importDialogOpen: action.isOpen });
	    case '@@fm/SET_ISOVER':
	      return Object.assign({}, state, { isOver: action.isOver, wasOver: state.isOver });
	    case '@@fm/SET_WASOVER':
	      return Object.assign({}, state, { wasOver: action.wasOver });
	    case '@@fm/SET_CATEGORY_TITLE':
	      return Object.assign({}, state, {
	        categories: Object.assign({}, state.categories, _defineProperty({}, state.activeCategory, Object.assign({}, state.categories[state.activeCategory], _defineProperty({}, action.categoryId, Object.assign({}, state.categories[state.activeCategory][action.categoryId], {
	          title: action.title
	        })))))
	      });
	    case '@@fm/SET_CATEGORY_ABBREVIATION':
	      return Object.assign({}, state, {
	        categories: Object.assign({}, state.categories, _defineProperty({}, state.activeCategory, Object.assign({}, state.categories[state.activeCategory], _defineProperty({}, action.categoryId, Object.assign({}, state.categories[state.activeCategory][action.categoryId], {
	          abbreviation: action.abbreviation
	        })))))
	      });
	    case '@@fm/TOGGLE_VISIBILITY':
	      return Object.assign({}, state, {
	        categories: Object.assign({}, state.categories, _defineProperty({}, state.activeCategory, Object.assign({}, state.categories[state.activeCategory], _defineProperty({}, action.categoryId, Object.assign({}, state.categories[state.activeCategory][action.categoryId], {
	          visible: action.on
	        })))))
	      });
	    case "@@fm/MOVE_WIZARD":
	      {
	        var originWizardsOrder = state.categories[state.activeCategory][action.origin.categoryId].wizardsOrder;
	        var targetWizardsOrder = state.categories[state.activeCategory][action.target.categoryId].wizardsOrder;
	        var originWizardIndex = originWizardsOrder.findIndex(function (id) {
	          return action.origin.formDefinitionId === id;
	        });
	        var targetWizardIndex = targetWizardsOrder.findIndex(function (id) {
	          return action.target.formDefinitionId === id;
	        });
	        var newOriginWizardsOrder = void 0,
	            newTargetWizardsOrder = void 0,
	            categories = void 0;
	        if (action.origin.categoryId !== action.target.categoryId) {
	          var _Object$assign14;
	
	          newOriginWizardsOrder = [].concat(_toConsumableArray(originWizardsOrder.slice(0, originWizardIndex)), _toConsumableArray(originWizardsOrder.slice(originWizardIndex + 1)));
	          newTargetWizardsOrder = [].concat(_toConsumableArray(targetWizardsOrder.slice(0, targetWizardIndex)), [action.origin.formDefinitionId], _toConsumableArray(targetWizardsOrder.slice(targetWizardIndex)));
	          categories = Object.assign({}, state.categories, _defineProperty({}, state.activeCategory, Object.assign({}, state.categories[state.activeCategory], (_Object$assign14 = {}, _defineProperty(_Object$assign14, action.origin.categoryId, Object.assign({}, state.categories[state.activeCategory][action.origin.categoryId], {
	            wizardsOrder: newOriginWizardsOrder
	          })), _defineProperty(_Object$assign14, action.target.categoryId, Object.assign({}, state.categories[state.activeCategory][action.target.categoryId], {
	            wizardsOrder: newTargetWizardsOrder
	          })), _Object$assign14))));
	        } else {
	          newTargetWizardsOrder = [].concat(_toConsumableArray(targetWizardsOrder.slice(0, originWizardIndex)), _toConsumableArray(targetWizardsOrder.slice(originWizardIndex + 1)));
	          newTargetWizardsOrder = [].concat(_toConsumableArray(newTargetWizardsOrder.slice(0, targetWizardIndex + (originWizardIndex > targetWizardIndex ? 0 : -1))), [action.origin.formDefinitionId], _toConsumableArray(newTargetWizardsOrder.slice(targetWizardIndex + (originWizardIndex > targetWizardIndex ? 0 : -1))));
	          categories = Object.assign({}, state.categories, _defineProperty({}, state.activeCategory, Object.assign({}, state.categories[state.activeCategory], _defineProperty({}, action.target.categoryId, Object.assign({}, state.categories[state.activeCategory][action.target.categoryId], {
	            wizardsOrder: newTargetWizardsOrder
	          })))));
	        }
	        return Object.assign({}, state, {
	          categories: categories
	        });
	      }
	    case "@@fm/MOVE_WIZARD_TO_EMPTY_CATEGORY":
	      {
	        var _Object$assign18;
	
	        var _originWizardsOrder = state.categories[state.activeCategory][action.origin.categoryId].wizardsOrder;
	        var _originWizardIndex = _originWizardsOrder.findIndex(function (id) {
	          return action.origin.formDefinitionId === id;
	        });
	        var originCategory = [].concat(_toConsumableArray(state.categories[state.activeCategory][action.origin.categoryId].wizardsOrder.slice(0, _originWizardIndex)), _toConsumableArray(state.categories[state.activeCategory][action.origin.categoryId].wizardsOrder.slice(_originWizardIndex + 1)));
	        return Object.assign({}, state, {
	          categories: Object.assign({}, state.categories, _defineProperty({}, state.activeCategory, Object.assign({}, state.categories[state.activeCategory], (_Object$assign18 = {}, _defineProperty(_Object$assign18, action.origin.categoryId, Object.assign({}, state.categories[state.activeCategory][action.origin.categoryId], {
	            wizardsOrder: originCategory
	          })), _defineProperty(_Object$assign18, action.target, Object.assign({}, state.categories[state.activeCategory][action.target], {
	            wizardsOrder: [action.origin.formDefinitionId]
	          })), _Object$assign18))))
	        });
	      }
	    case "@@fm/REORDER_CATEGORY":
	      {
	        var categoriesOrder = void 0;
	        if (action.direction === "up") {
	          categoriesOrder = [].concat(_toConsumableArray(state.categoriesOrder[state.activeCategory].slice(0, action.categoryIndex - 1)), [action.categoryId, state.categoriesOrder[state.activeCategory][action.categoryIndex - 1]], _toConsumableArray(state.categoriesOrder[state.activeCategory].slice(action.categoryIndex + 1)));
	        } else {
	          categoriesOrder = [].concat(_toConsumableArray(state.categoriesOrder[state.activeCategory].slice(0, action.categoryIndex)), [state.categoriesOrder[state.activeCategory][action.categoryIndex + 1], action.categoryId], _toConsumableArray(state.categoriesOrder[state.activeCategory].slice(action.categoryIndex + 2)));
	        }
	        return Object.assign({}, state, {
	          categoriesOrder: Object.assign({}, state.categoriesOrder, _defineProperty({}, state.activeCategory, categoriesOrder))
	        });
	      }
	    case "@@fm/MOVE_WIZARD_TO_LAST":
	      {
	        var _originWizardsOrder2 = state.categories[state.activeCategory][action.origin.categoryId].wizardsOrder;
	        var _originWizardIndex2 = _originWizardsOrder2.findIndex(function (id) {
	          return action.origin.formDefinitionId === id;
	        });
	        var _categories = void 0;
	        if (action.origin.categoryId !== action.target) {
	          var _Object$assign21;
	
	          _categories = Object.assign({}, state.categories, _defineProperty({}, state.activeCategory, Object.assign({}, state.categories[state.activeCategory], (_Object$assign21 = {}, _defineProperty(_Object$assign21, action.origin.categoryId, Object.assign({}, state.categories[state.activeCategory][action.origin.categoryId], {
	            wizardsOrder: [].concat(_toConsumableArray(state.categories[state.activeCategory][action.origin.categoryId].wizardsOrder.slice(0, _originWizardIndex2)), _toConsumableArray(state.categories[state.activeCategory][action.origin.categoryId].wizardsOrder.slice(_originWizardIndex2 + 1)))
	          })), _defineProperty(_Object$assign21, action.target, Object.assign({}, state.categories[state.activeCategory][action.target], {
	            wizardsOrder: [].concat(_toConsumableArray(state.categories[state.activeCategory][action.target].wizardsOrder), [action.origin.formDefinitionId])
	          })), _Object$assign21))));
	        } else {
	          var _newOriginWizardsOrder = [].concat(_toConsumableArray(_originWizardsOrder2.slice(0, _originWizardIndex2)), _toConsumableArray(_originWizardsOrder2.slice(_originWizardIndex2 + 1)));
	          _categories = Object.assign({}, state.categories, _defineProperty({}, state.activeCategory, Object.assign({}, state.categories[state.activeCategory], _defineProperty({}, action.origin.categoryId, Object.assign({}, state.categories[state.activeCategory][action.origin.categoryId], {
	            wizardsOrder: [].concat(_toConsumableArray(_newOriginWizardsOrder), [action.origin.formDefinitionId])
	          })))));
	        }
	        return Object.assign({}, state, {
	          categories: _categories
	        });
	      }
	    case "@@fm/PUBLISH_WIZARD":
	      {
	        var originformDefinitionId = action.origin.formDefinitionId;
	        var _targetWizardIndex = state.categories[state.activeCategory][action.target.categoryId].wizardsOrder.findIndex(function (id) {
	          return action.target.formDefinitionId === id;
	        });
	        return Object.assign({}, state, {
	          categories: Object.assign({}, state.categories, _defineProperty({}, state.activeCategory, Object.assign({}, state.categories[state.activeCategory], _defineProperty({}, action.target.categoryId, Object.assign({}, state.categories[state.activeCategory][action.target.categoryId], {
	            wizardsOrder: [].concat(_toConsumableArray(state.categories[state.activeCategory][action.target.categoryId].wizardsOrder.slice(0, _targetWizardIndex)), [originformDefinitionId], _toConsumableArray(state.categories[state.activeCategory][action.target.categoryId].wizardsOrder.slice(_targetWizardIndex)))
	          })))))
	        });
	      }
	    case "@@fm/PUBLISH_WIZARD_TO_LAST":
	      return Object.assign({}, state, {
	        categories: Object.assign({}, state.categories, _defineProperty({}, state.activeCategory, Object.assign({}, state.categories[state.activeCategory], _defineProperty({}, action.target, Object.assign({}, state.categories[state.activeCategory][action.target], {
	          wizardsOrder: [].concat(_toConsumableArray(state.categories[state.activeCategory][action.target].wizardsOrder), [action.origin.formDefinitionId])
	        })))))
	      });
	    case "@@fm/PUBLISH_WIZARD_TO_EMPTY_CATEGORY":
	      return Object.assign({}, state, {
	        categories: Object.assign({}, state.categories, _defineProperty({}, state.activeCategory, Object.assign({}, state.categories[state.activeCategory], _defineProperty({}, action.target, Object.assign({}, state.categories[state.activeCategory][action.target], {
	          wizardsOrder: [action.origin.formDefinitionId]
	        })))))
	      });
	    case "@@fm/UNPUBLISH_WIZARD":
	      {
	        var _originWizardIndex3 = state.categories[state.activeCategory][action.origin.categoryId].wizardsOrder.findIndex(function (id) {
	          return action.origin.formDefinitionId === id;
	        });
	        return Object.assign({}, state, {
	          categories: Object.assign({}, state.categories, _defineProperty({}, state.activeCategory, Object.assign({}, state.categories[state.activeCategory], _defineProperty({}, action.origin.categoryId, Object.assign({}, state.categories[state.activeCategory][action.origin.categoryId], {
	            wizardsOrder: [].concat(_toConsumableArray(state.categories[state.activeCategory][action.origin.categoryId].wizardsOrder.slice(0, _originWizardIndex3)), _toConsumableArray(state.categories[state.activeCategory][action.origin.categoryId].wizardsOrder.slice(_originWizardIndex3 + 1)))
	          })))))
	        });
	      }
	    case "@@fm/IMPORT_TO_LAST":
	      {
	        return Object.assign({}, state, {
	          categories: Object.assign({}, state.categories, _defineProperty({}, state.activeCategory, Object.assign({}, state.categories[state.activeCategory], _defineProperty({}, action.categoryId, Object.assign({}, state.categories[state.activeCategory][action.categoryId], {
	            wizardsOrder: [].concat(_toConsumableArray(state.categories[state.activeCategory][action.categoryId].wizardsOrder), [action.formDefinitionId])
	          })))))
	        });
	      }
	    default:
	      return state;
	  }
	};
	
	exports.default = managerReducer;

/***/ },
/* 1101 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var setActiveCategory = exports.setActiveCategory = function setActiveCategory(category) {
	  return function (dispatch) {
	    dispatch({
	      type: 'SET_ACTIVE_CATEGORY',
	      category: category
	    });
	    dispatch({
	      type: 'SET_CURRENT_CATEGORY',
	      category: category
	    });
	  };
	};

/***/ },
/* 1102 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var initialState = {
	  activeCategory: null
	};
	
	exports.default = function () {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	  var action = arguments[1];
	
	  switch (action.type) {
	    case 'SET_ACTIVE_CATEGORY':
	      return Object.assign({}, state, { activeCategory: action.category });
	    default:
	      return state;
	  }
	};

/***/ },
/* 1103 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var HealthCareDirective = void 0;
	
	var DeferredHealthCareDirective = function (_React$Component) {
	  _inherits(DeferredHealthCareDirective, _React$Component);
	
	  function DeferredHealthCareDirective() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, DeferredHealthCareDirective);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = DeferredHealthCareDirective.__proto__ || Object.getPrototypeOf(DeferredHealthCareDirective)).call.apply(_ref, [this].concat(args))), _this), _this.state = { fetchingBundle: true }, _this.componentDidMount = function () {
	      _this.fetchDesignerBundle();
	    }, _this.fetchDesignerBundle = function () {
	      __webpack_require__.e/* nsure */(3, function (require) {
	        HealthCareDirective = __webpack_require__(458).default;
	        _this.setState({ fetchingBundle: false });
	      });
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(DeferredHealthCareDirective, [{
	    key: 'render',
	    value: function render() {
	      return this.state.fetchingBundle ? null : _react2.default.createElement(HealthCareDirective, this.props);
	    }
	  }]);
	
	  return DeferredHealthCareDirective;
	}(_react2.default.Component);
	
	exports.default = DeferredHealthCareDirective;

/***/ },
/* 1104 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.updateAndPushFoldLinks = exports.updateFoldLinks = exports.updateMessage = exports.updateAndPushSystemMessage = exports.populateSystemMessage = exports.getSystemMessage = exports.updateCategories = exports.updateAndPushCategories = exports.setHomeStructure = exports.getHomeStructure = undefined;
	
	var _requests = __webpack_require__(6);
	
	var api = _interopRequireWildcard(_requests);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	var getHomeStructure = exports.getHomeStructure = function getHomeStructure() {
	  return function (dispatch) {
	    api.GET_HOME_PAGE_STRUCTURE(function (_ref) {
	      var MERGED = _ref.MERGED,
	          RAW = _ref.RAW;
	
	      var _JSON$parse = JSON.parse(MERGED.VALUE),
	          foldLinks = _JSON$parse.foldLinks,
	          categories = _JSON$parse.categories;
	
	      var _JSON$parse2 = JSON.parse(RAW.VALUE),
	          rawFoldLinks = _JSON$parse2.foldLinks,
	          rawCategories = _JSON$parse2.categories;
	
	      dispatch(setHomeStructure({
	        foldLinks: foldLinks,
	        categories: categories,
	        appSettingId: MERGED.APP_SETTING_ID,
	        rawStructure: { foldLinks: rawFoldLinks, categories: rawCategories }
	      }));
	    });
	  };
	};
	
	var setHomeStructure = exports.setHomeStructure = function setHomeStructure(_ref2) {
	  var foldLinks = _ref2.foldLinks,
	      categories = _ref2.categories,
	      appSettingId = _ref2.appSettingId,
	      rawStructure = _ref2.rawStructure;
	  return {
	    type: '@@h/SET_HOME_STRUCTURE',
	    foldLinks: foldLinks,
	    categories: categories,
	    appSettingId: appSettingId,
	    rawStructure: rawStructure
	  };
	};
	
	var updateAndPushCategories = exports.updateAndPushCategories = function updateAndPushCategories(categories) {
	  return function (dispatch, getState) {
	
	    var state = getState().home;
	    api.UPDATE_APP_SETTING_BY_ID(state.appSettingId, {
	      NAME: 'HOME_PAGE_LINKS',
	      VALUE: JSON.stringify({
	        categories: categories,
	        foldLinks: state.foldLinks
	      }),
	      CATEGORY: 'ADMIN',
	      DESCR: ''
	    }, function () {
	      dispatch(getHomeStructure());
	    }, function (e) {
	      console.error(e);
	    });
	  };
	};
	
	var updateCategories = exports.updateCategories = function updateCategories(categories) {
	  return {
	    type: '@@h/UPDATE_CATEGORIES',
	    categories: categories
	  };
	};
	
	var getSystemMessage = exports.getSystemMessage = function getSystemMessage() {
	  return function (dispatch) {
	    api.GET_APP_SETTING_BY_NAME('HOME_PAGE_MESSAGE', function (setting) {
	      dispatch(populateSystemMessage({
	        systemMessage: setting.VALUE,
	        messageAppSettingId: setting.APP_SETTING_ID
	      }));
	    });
	  };
	};
	
	var populateSystemMessage = exports.populateSystemMessage = function populateSystemMessage(_ref3) {
	  var systemMessage = _ref3.systemMessage,
	      messageAppSettingId = _ref3.messageAppSettingId;
	  return {
	    type: '@@h/POPULATE_SYSTEM_MESSAGE',
	    systemMessage: systemMessage,
	    messageAppSettingId: messageAppSettingId
	  };
	};
	
	var updateAndPushSystemMessage = exports.updateAndPushSystemMessage = function updateAndPushSystemMessage(message) {
	  return function (dispatch, getState) {
	    dispatch(updateMessage(message));
	    var state = getState().home;
	    api.UPDATE_APP_SETTING_BY_ID(state.messageAppSettingId, {
	      NAME: 'HOME_PAGE_MESSAGE',
	      VALUE: message,
	      CATEGORY: 'ADMIN',
	      DESCR: ''
	    }, function () {});
	  };
	};
	
	var updateMessage = exports.updateMessage = function updateMessage(message) {
	  return {
	    type: '@@h/UPDATE_SYSTEM_MESSAGE',
	    message: message
	  };
	};
	
	var updateFoldLinks = exports.updateFoldLinks = function updateFoldLinks(foldLinks) {
	  return {
	    type: '@@h/UPDATE_FOLD_LINKS',
	    foldLinks: foldLinks
	  };
	};
	
	var updateAndPushFoldLinks = exports.updateAndPushFoldLinks = function updateAndPushFoldLinks(foldLinks) {
	  return function (dispatch, getState) {
	    dispatch(updateFoldLinks(foldLinks));
	    var state = getState().home;
	    api.UPDATE_APP_SETTING_BY_ID(state.appSettingId, {
	      NAME: 'HOME_PAGE_LINKS',
	      VALUE: JSON.stringify({
	        categories: state.categories,
	        foldLinks: foldLinks
	      }),
	      CATEGORY: 'ADMIN',
	      DESCR: ''
	    }, function () {});
	  };
	};

/***/ },
/* 1105 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var initialState = {
	  foldLinks: [],
	  categories: [],
	  loading: true,
	  appSettingId: null,
	  systemMessage: null,
	  messageAppSettingId: '',
	  rawStructure: {
	    foldLinks: [],
	    categories: []
	  }
	};
	
	var HomeReducer = function HomeReducer() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	  var action = arguments[1];
	
	  switch (action.type) {
	    case '@@h/RESET_STATE':
	      return initialState;
	    case '@@h/SET_HOME_STRUCTURE':
	      var newState = Object.assign({}, state, {
	        foldLinks: action.foldLinks,
	        categories: action.categories,
	        appSettingId: action.appSettingId
	      });
	      if (action.rawStructure) {
	        newState.rawStructure = action.rawStructure;
	      }
	      return newState;
	    case '@@h/UPDATE_CATEGORIES':
	      return Object.assign({}, state, { categories: action.categories });
	    case '@@h/POPULATE_SYSTEM_MESSAGE':
	      return Object.assign({}, state, {
	        systemMessage: action.systemMessage,
	        messageAppSettingId: action.messageAppSettingId
	      });
	    case '@@h/UPDATE_SYSTEM_MESSAGE':
	      return Object.assign({}, state, { systemMessage: action.message });
	    case '@@h/UPDATE_FOLD_LINKS':
	      return Object.assign({}, state, { foldLinks: action.foldLinks });
	    default:
	      return state;
	  }
	};
	exports.default = HomeReducer;

/***/ },
/* 1106 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Home = __webpack_require__(297);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var QuickLinksEditor = function (_React$Component) {
	  _inherits(QuickLinksEditor, _React$Component);
	
	  function QuickLinksEditor(props) {
	    _classCallCheck(this, QuickLinksEditor);
	
	    var _this = _possibleConstructorReturn(this, (QuickLinksEditor.__proto__ || Object.getPrototypeOf(QuickLinksEditor)).call(this, props));
	
	    _this.getLinks = function () {
	      return _this.state.links;
	    };
	
	    _this.insertAbove = function (index) {
	      _this.setState(function (state) {
	        return {
	          links: [].concat(_toConsumableArray(state.links.slice(0, index)), [{ label: "", href: "", targetBlank: false }], _toConsumableArray(state.links.slice(index))),
	          newIconIndex: index
	        };
	      });
	    };
	
	    _this.insertBelow = function (index) {
	      _this.setState(function (state) {
	        return {
	          links: [].concat(_toConsumableArray(state.links.slice(0, index + 1)), [{ label: "", href: "", targetBlank: false }], _toConsumableArray(state.links.slice(index + 1))),
	          newIconIndex: index + 1
	        };
	      });
	    };
	
	    _this.deleteLink = function (index) {
	      _this.setState(function (state) {
	        return {
	          links: [].concat(_toConsumableArray(state.links.slice(0, index)), _toConsumableArray(state.links.slice(index + 1)))
	        };
	      });
	    };
	
	    _this.addNewLink = function () {
	      _this.setState(function (state) {
	        return {
	          links: [].concat(_toConsumableArray(state.links), [{ label: "", href: "", targetBlank: false }]),
	          newIconIndex: state.links.length
	        };
	      });
	    };
	
	    _this.setRowValueByIndex = function (_ref) {
	      var name = _ref.name,
	          value = _ref.value,
	          index = _ref.index;
	
	      _this.setState(function (state) {
	        return {
	          links: [].concat(_toConsumableArray(state.links.slice(0, index)), [Object.assign({}, state.links[index], _defineProperty({}, name, value))], _toConsumableArray(state.links.slice(index + 1)))
	        };
	      });
	    };
	
	    _this.clearNewIcon = function () {
	      _this.setState({
	        newIconIndex: null
	      });
	    };
	
	    _this.state = {
	      links: [].concat(_toConsumableArray(props.links)),
	      newIconIndex: null
	    };
	    return _this;
	  }
	
	  _createClass(QuickLinksEditor, [{
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _state$links = this.state.links,
	          links = _state$links === undefined ? [] : _state$links;
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'quick-links-editor wizard' },
	        links.map(function (link, i) {
	          return _react2.default.createElement(_Home.EditLink, Object.assign({
	            themeable: true,
	            onChange: _this2.setRowValueByIndex,
	            insertAbove: _this2.insertAbove,
	            insertBelow: _this2.insertBelow,
	            deleteLink: _this2.deleteLink,
	            clearNewIcon: _this2.clearNewIcon,
	            isNew: _this2.state.newIconIndex === i
	          }, link, {
	            index: i,
	            key: i
	          }));
	        }),
	        _react2.default.createElement(
	          'button',
	          { type: 'button', onClick: this.addNewLink, className: 'add-link custom-focus' },
	          'Add new link'
	        )
	      );
	    }
	  }]);
	
	  return QuickLinksEditor;
	}(_react2.default.Component);
	
	exports.default = QuickLinksEditor;

/***/ },
/* 1107 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	__webpack_require__(1446);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (_ref) {
	  var title = _ref.title,
	      subtitle = _ref.subtitle,
	      _ref$buttons = _ref.buttons,
	      buttons = _ref$buttons === undefined ? [] : _ref$buttons;
	
	  return _react2.default.createElement(
	    'li',
	    { className: 'list-block' },
	    _react2.default.createElement(
	      'h1',
	      { className: 'list-title-wrapper' },
	      _react2.default.createElement(
	        'span',
	        { className: 'list-title' },
	        title
	      ),
	      _react2.default.createElement(
	        'span',
	        { className: 'list-subtitle' },
	        subtitle
	      )
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'list-buttons' },
	      buttons.map(function (button, i) {
	        return _react2.default.createElement(
	          'button',
	          { onClick: button.onClick, className: 'fixed', key: button.id || i },
	          button.label
	        );
	      })
	    )
	  );
	};

/***/ },
/* 1108 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.LobbyistList = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Shell = __webpack_require__(19);
	
	var _shortid = __webpack_require__(22);
	
	var _shortid2 = _interopRequireDefault(_shortid);
	
	var _CollapsibleTable = __webpack_require__(1146);
	
	var _CollapsibleTable2 = _interopRequireDefault(_CollapsibleTable);
	
	var _Toolbar = __webpack_require__(304);
	
	var _Toolbar2 = _interopRequireDefault(_Toolbar);
	
	var _utilities = __webpack_require__(8);
	
	var _debounce = __webpack_require__(495);
	
	var _debounce2 = _interopRequireDefault(_debounce);
	
	var _orderBy = __webpack_require__(103);
	
	var _orderBy2 = _interopRequireDefault(_orderBy);
	
	var _caretDown = __webpack_require__(38);
	
	var _caretDown2 = _interopRequireDefault(_caretDown);
	
	var _requests = __webpack_require__(6);
	
	var _FloatingMenu = __webpack_require__(86);
	
	var _FloatingMenu2 = _interopRequireDefault(_FloatingMenu);
	
	var _downloadBox = __webpack_require__(127);
	
	var _downloadBox2 = _interopRequireDefault(_downloadBox);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var CURRENT_YEAR = new Date().getMonth() > 7 ? new Date().getFullYear() + 1 : new Date().getFullYear();
	
	var List = function (_React$Component) {
	  _inherits(List, _React$Component);
	
	  function List() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, List);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = List.__proto__ || Object.getPrototypeOf(List)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      filter: '',
	      expanded: false
	    }, _this.setFilter = (0, _debounce2.default)(function (filter) {
	      _this.setState({ filter: filter, expanded: filter.length > 1 });
	    }), _this.componentDidMount = function () {
	      _this.forceScrollbar(true);
	    }, _this.componentWillUnmount = function () {
	      _this.forceScrollbar(false);
	    }, _this.forceScrollbar = function (force) {
	      if (force) {
	        document.body.style.overflowY = 'scroll';
	      } else {
	        document.body.style.overflowY = '';
	      }
	    }, _this.getFilteredRows = function () {
	      var filter = _this.state.filter.toLowerCase();
	      // console.log(filter);
	      return _this.props.rows.filter(function (row) {
	        return _this.rowIncludesFilter(row.CELLS, filter) || _this.childIncludesFilter(row.CHILDREN, filter);
	      }, 100);
	    }, _this.rowIncludesFilter = function (cells, filter) {
	      var filterableIndecies = _this.props.filterableIndecies;
	      var i = 0;
	      while (true) {
	        if (i === filterableIndecies.length) {
	          return false;
	        }
	        if (cells[filterableIndecies[i]].toLowerCase().includes(filter)) {
	          return true;
	        }
	        i++;
	      }
	    }, _this.childIncludesFilter = function (rows, filter) {
	      var i = 0;
	      while (true) {
	        if (i === rows.length) {
	          return false;
	        }
	        if (rows[i][0].toLowerCase().includes(filter)) {
	          return true;
	        }
	        i++;
	      }
	    }, _this.toggleExpansion = function () {
	      _this.setState(function (state) {
	        return { expanded: !state.expanded };
	      });
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(List, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          headers = _props.headers,
	          rows = _props.rows,
	          title = _props.title,
	          getChildren = _props.getChildren,
	          onSearchBlur = _props.onSearchBlur,
	          tableKey = _props.tableKey,
	          searching = _props.searching,
	          underToolbar = _props.underToolbar;
	
	      return _react2.default.createElement(
	        _Shell.Body,
	        null,
	        _react2.default.createElement(_Toolbar2.default, {
	          filter: this.state.filter,
	          onExpansionChange: this.toggleExpansion,
	          title: title,
	          onSearchBlur: onSearchBlur,
	          searchPlaceholder: 'Search by Lobbyist or Entity',
	          className: 'center-container',
	          searching: searching,
	          underToolbar: underToolbar
	        }),
	        _react2.default.createElement(_CollapsibleTable2.default, {
	          className: 'center-container',
	          rows: this.state.filter !== '' ? this.getFilteredRows() : rows,
	          expanded: this.state.expanded,
	          getChildren: getChildren,
	          headers: headers,
	          key: tableKey || undefined,
	          expandable: true
	        })
	      );
	    }
	  }]);
	
	  return List;
	}(_react2.default.Component);
	
	exports.default = List;
	
	var LobbyistList = exports.LobbyistList = function (_React$Component2) {
	  _inherits(LobbyistList, _React$Component2);
	
	  function LobbyistList() {
	    var _ref2;
	
	    var _temp2, _this2, _ret2;
	
	    _classCallCheck(this, LobbyistList);
	
	    for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
	      args[_key2] = arguments[_key2];
	    }
	
	    return _ret2 = (_temp2 = (_this2 = _possibleConstructorReturn(this, (_ref2 = LobbyistList.__proto__ || Object.getPrototypeOf(LobbyistList)).call.apply(_ref2, [this].concat(args))), _this2), _this2.state = {
	      rows: [],
	      template: [],
	      rawRows: [],
	      headers: [],
	      year: (0, _utilities.parseUrlQuery)(_this2.props.location.search).year,
	      search: '',
	      yearMenuOpen: false,
	      searching: false
	    }, _this2.componentDidMount = function () {
	      var search = (0, _utilities.parseUrlQuery)(_this2.props.location.search);
	      _this2.getLobbyistsbyRange(search.year, _this2.state.search);
	    }, _this2.getLobbyistsbyRange = function (year) {
	      var search = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
	
	      if (search) {
	        _this2.setState({ searching: true });
	      }
	      (0, _requests.GET_LOBBYISTS_BY_SEARCH_AND_RANGE)(year, search, function (lobbyists) {
	        var rawRows = Object.values(lobbyists.rows).reduce(function (arr, val) {
	          return [].concat(_toConsumableArray(arr), [val]);
	        }, []);
	        _this2.setState({
	          rows: (0, _orderBy2.default)(rawRows, ['SORT_INDEX']).map(function (l) {
	            return {
	              render: lobbyists.template.map(function (t) {
	                if (Array.isArray(l[t.id])) {
	                  return _react2.default.createElement(
	                    'span',
	                    { className: 'stack' },
	                    l[t.id].map(function (x, i) {
	                      return _react2.default.createElement(
	                        'span',
	                        { key: i },
	                        x
	                      );
	                    })
	                  );
	                } else {
	                  return l[t.id];
	                }
	              }),
	              id: l.ID
	            };
	          }),
	          tableKey: _shortid2.default.generate(),
	          rawRows: (0, _orderBy2.default)(rawRows, ['SORT_INDEX']),
	          template: lobbyists.template,
	          headers: lobbyists.template.map(function (t) {
	            return t.label;
	          }),
	          searching: false
	        });
	      });
	    }, _this2.refetchBySearch = function (search) {
	      if (search !== _this2.state.search) {
	        _this2.setState({ search: search });
	        _this2.getLobbyistsbyRange(_this2.state.year, search);
	      }
	    }, _this2.getEntities = function (row, index) {
	      return new Promise(function (resolve, reject) {
	        (0, _requests.GET_LOBBYIST_ENTITIES_BY_ID)(_this2.state.rawRows[index].LOBBYIST_ID, _this2.state.year, function (_ref3) {
	          var ENTITIES = _ref3.ENTITIES,
	              EXPENDITURES = _ref3.EXPENDITURES;
	
	          if (ENTITIES.rows.length > 0) {
	            resolve(_react2.default.createElement(SubTable, {
	              headers: ENTITIES.template.map(function (t) {
	                return t.label;
	              }),
	              rows: ENTITIES.rows.map(function (row) {
	                return ENTITIES.template.map(function (t) {
	                  return _react2.default.createElement(HistoryCell, {
	                    from: row[t.id].CHANGED_FROM,
	                    to: row[t.id].CHANGED_TO,
	                    key: t.id
	                  });
	                });
	              })
	            }));
	          } else {
	            resolve(_react2.default.createElement(
	              'div',
	              { className: 'message' },
	              'This lobbyist does not represent any entities in ',
	              _this2.state.year
	            ));
	          }
	        }, function (err) {
	          reject(err);
	        });
	      });
	    }, _this2.toggleYearMenu = function () {
	      _this2.setState(function (state) {
	        return { yearMenuOpen: !state.yearMenuOpen };
	      });
	    }, _this2.setYear = function (_ref4) {
	      var year = _ref4.value;
	
	      _this2.props.history.replace({
	        pathname: _this2.props.location.pathname,
	        search: '?year=' + year
	      });
	      _this2.setState({ year: year });
	      _this2.getLobbyistsbyRange(year, _this2.state.search);
	    }, _temp2), _possibleConstructorReturn(_this2, _ret2);
	  }
	
	  _createClass(LobbyistList, [{
	    key: 'render',
	    value: function render() {
	      var _this3 = this;
	
	      return _react2.default.createElement(List, {
	        title: _react2.default.createElement(
	          _react.Fragment,
	          null,
	          'Registered Lobbyists:',
	          ' ',
	          _react2.default.createElement(
	            'span',
	            {
	              className: 'subtitle',
	              ref: function ref(_ref5) {
	                return _this3.yearTitle = _ref5;
	              },
	              onClick: this.toggleYearMenu
	            },
	            this.state.year,
	            ' - ',
	            parseInt(this.state.year, 10) + 1,
	            _react2.default.createElement(_caretDown2.default, null)
	          ),
	          _react2.default.createElement(_FloatingMenu2.default, {
	            className: 'fm-icon-menu',
	            isOpen: this.state.yearMenuOpen,
	            alignTo: this.yearTitle,
	            align: 'right',
	            onRequestClose: this.toggleYearMenu,
	            options: Array(5).fill(0).map(function (_, i) {
	              return {
	                value: CURRENT_YEAR - 5 + i,
	                label: CURRENT_YEAR - 5 + i + ' - ' + (CURRENT_YEAR - 4 + i),
	                onClick: _this3.setYear
	              };
	            })
	          })
	        ),
	        tableKey: this.state.tableKey,
	        getChildren: this.getEntities,
	        onSearchBlur: this.refetchBySearch,
	        headers: this.state.headers,
	        rows: this.state.rows,
	        searching: this.state.searching,
	        underToolbar: _react2.default.createElement(
	          'div',
	          { className: 'download-link' },
	          _react2.default.createElement(
	            'a',
	            { href: _requests.BASE_URL + '/api/list/csv/' + this.state.year, target: '_blank', download: true },
	            _react2.default.createElement(_downloadBox2.default, null),
	            ' ',
	            _react2.default.createElement(
	              'span',
	              null,
	              'Download as .csv'
	            )
	          )
	        )
	        // rows={testData}
	      });
	    }
	  }]);
	
	  return LobbyistList;
	}(_react2.default.Component);
	
	var SubTable = function SubTable(_ref6) {
	  var rows = _ref6.rows,
	      headers = _ref6.headers;
	  return _react2.default.createElement(
	    'table',
	    null,
	    headers && _react2.default.createElement(
	      'thead',
	      null,
	      _react2.default.createElement(
	        'tr',
	        null,
	        headers.map(function (h, i) {
	          return _react2.default.createElement(
	            'th',
	            { key: i },
	            h
	          );
	        })
	      )
	    ),
	    _react2.default.createElement(
	      'tbody',
	      null,
	      rows.map(function (row, i) {
	        return _react2.default.createElement(
	          'tr',
	          { key: i },
	          row.map(function (cell, k) {
	            return _react2.default.createElement(
	              'td',
	              { key: k },
	              cell
	            );
	          })
	        );
	      })
	    )
	  );
	};
	
	var HistoryCell = function HistoryCell(_ref7) {
	  var from = _ref7.from,
	      to = _ref7.to;
	  return _react2.default.createElement(
	    'div',
	    { className: 'history-cell' },
	    from !== null && _react2.default.createElement(
	      _react2.default.Fragment,
	      null,
	      _react2.default.createElement(
	        'label',
	        null,
	        'Changed From:'
	      ),
	      _react2.default.createElement(
	        'span',
	        { className: 'value' },
	        from
	      )
	    ),
	    from !== null ? _react2.default.createElement(
	      _react2.default.Fragment,
	      null,
	      _react2.default.createElement(
	        'label',
	        null,
	        'Changed To:'
	      ),
	      _react2.default.createElement(
	        'span',
	        { className: 'value' },
	        to
	      )
	    ) : to
	  );
	};

/***/ },
/* 1109 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Shell = __webpack_require__(19);
	
	var _requests = __webpack_require__(6);
	
	var _reactRouterDom = __webpack_require__(30);
	
	__webpack_require__(1447);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var MONTH_INDEX = ({"NODE_ENV":"production","BUILD_DATE":"2025-08-27T15:15:31.687Z","BUILD_NUMBER":"Not Provided","GIT_VERSION":"v1.3.0-381-ga81e29b08","GIT_COMMIT_HASH":"a81e29b085c9268ffd96c78eb734365802722741","GIT_BRANCH":"beta","PUBLIC_URL":"","STATE_ABBR":"MT","STATE_NAME":"Montana","STATE_ORG_TITLE":"Secretary of State","LOGIN_HEADER_IMG_PATH":"","HOME_IMG_FILENAME":"montana.jpg","FAVICON_FILE_NAME":"favicon.ico","ALLOW_E_SIGN_ON_CORRECTIONS":true,"THIRD_PARTY_SIGNING_ALLOWED":false,"MY_ACCOUNT_SAVE_AND_CLOSE_BUTTON":true,"IE_DEPRECATED_MESSAGE":"Internet Explorer is not supported. Please select a supported browser below to access this website.","ADDITIONAL_ROUTES":{"dataRequests":true,"farmBill":true,"apostille":true,"externalHelp":"https://sosmt.gov/business/help-center/","systemAdministration":[{"title":"Saved Payments","parameter":"saved-payments","componentName":"SavedPayments"}]},"SUBROUTES":[{"label":"Business","component":"Business","parameter":"business","myWorkQueueSearch":false,"sourceTypeId":54,"searchMustHaveOneOf":["FILING_TYPE_ID","STATUS_ID","STATE","search"],"serverWebSearchDescription":true,"serverWorkQueueDescription":true,"serverMyRecordsDescription":true,"searchPlaceholder":"Search by name or filing number (X########)","allowEmptySearchTerm":true,"requestCertificateAlternateLabel":"Request Information","fileAmendmentButtonLabel":"Filing Actions","advancedSearchParameters":[{"type":"radio","name":"QUERY_TYPE_ID","defaultValue":1010,"options":[{"value":1010,"label":"Starts with"},{"value":1011,"label":"Contains"},{"value":1012,"label":" Word Contains"}]},{"type":"serverSelect","name":"FILING_TYPE_ID","optionsSrc":"FILING_TYPES","label":"Entity Type","placeholder":"All","defaultValue":"0"},{"type":"serverSelect","name":"FILING_SUBTYPE_ID","optionsSrc":"FILING_SUBTYPES","label":"Entity Subtype","overrideSubOptionsSrcFromParameterName":"FILING_TYPE_ID","placeholder":"All","defaultValue":"0"},{"type":"serverSelect","name":"STATUS_ID","optionsSrc":"FILING_STATUS_WITHOUT_ALL","label":"Status","placeholder":"All","defaultValue":"0"},{"type":"serverSelect","name":"STATE","optionsSrc":"STATE","label":"State","placeholder":"All","defaultValue":""},{"type":"serverSelect","name":"COUNTY","optionsSrc":"COUNTY_SUBOPTION","label":"County","overrideSubOptionsSrcFromParameterName":"STATE","placeholder":"All","defaultValue":""},{"type":"checkbox","name":"CRA_SEARCH_YN","defaultValue":false,"label":"Search by Registered Agent PID"},{"type":"dateRange","name":"FILING_DATE","label":"Registration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}},{"type":"dateRange","name":"EXPIRATION_DATE","label":"Expiration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}}],"myRecordsFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Active"},{"value":2,"label":"Inactive"},{"value":3,"label":"Pending"}]},{"type":"dateRange","name":"DATE_RANGE","label":"Date range","defaultValue":{"start":null,"end":null}}],"myWorkQueueFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Approved"},{"value":2,"label":"Pending Online Payment"},{"value":3,"label":"Pending Review"},{"value":4,"label":"Needs Correction"},{"value":5,"label":"Rejected"},{"value":6,"label":"Draft"}]},{"type":"dateRange","name":"DATE_RANGE","label":"Date range","defaultValue":{"start":null,"end":null}}]},{"label":"Notary","component":"Notary","parameter":"notary","sourceTypeId":850,"myWorkQueueSearch":false,"allowEmptySearchTerm":true,"requestCertificateAlternateLabel":"Download Certificate","fileAmendmentButtonLabel":"Filing Actions","hideNameRequestCertificate":true,"hideAddressRequestCertificate":true,"hideRecordUserManagment":true,"searchPlaceholder":"Search by name or commission number","searchMustHaveOneOf":["CITY","search","SERVICE_TYPE"],"advancedParametersStartOpen":true,"searchIsSortable":true,"advancedSearchParameters":[{"type":"radio","name":"STARTS_WITH_YN","defaultValue":false,"options":[{"value":true,"label":"Starts with"},{"value":false,"label":"Contains"}]},{"type":"checkbox","name":"ACTIVE_ONLY_YN","defaultValue":true,"label":"Active entities only"},{"type":"text","name":"CITY","defaultValue":"","label":"City"},{"type":"select","name":"SERVICE_TYPE","label":"Special Services Offered","defaultValue":0,"options":[{"value":0,"label":"(N/A)"},{"value":6165,"label":"In-Person Electronic Notarization (IPEN)"},{"value":6166,"label":"Remote Online Notarization (RON)"},{"value":6167,"label":"Mobile Notary Services"},{"value":6168,"label":"Remote Ink Notarization (RIN)"}]}]},{"label":"Apostille","component":"Apostille","parameter":"apostille","sourceTypeId":720,"myRecordsSearch":false,"myWorkQueueSearch":false,"disabled":false,"allowedRoutes":["/forms-manager/","/queue/","/forms/"]},{"label":"Liens","component":"UCC","parameter":"ucc","sourceTypeId":1999,"myRecordsSearch":true,"myWorkQueueSearch":true,"fileAmendmentButtonLabel":"Filing Actions","searchPlaceholder":"Search by name or file number","disabled":false,"serverWebSearchDescription":true,"myRecordsDescription":"","workQueueDescription":"","searchDescription":"","hideRecordUserManagment":true,"searchLiensCheckout":false,"advancedSearchParameters":[{"type":"radio","name":"STARTS_WITH_YN","defaultValue":false,"options":[{"value":true,"label":"Starts with"},{"value":false,"label":"Contains"}]},{"type":"select","name":"STATUS","defaultValue":"ALL","label":"Status","options":[{"value":"ACTIVE_UNLAPSED","label":"Active (unlapsed)"},{"value":"ACTIVE_LAPSED_UNLAPSED","label":"Active (lapsed and unlapsed)"}]},{"type":"text","name":"EXCLUDE_VALUES","label":"Exclude Debtor Names (comma separated list of names to exclude)","defaultValue":""},{"type":"dateRange","name":"FILING_DATE","label":"Financing Statement Date","defaultValue":{"start":null,"end":null}},{"type":"dateRange","name":"LAPSE_DATE","label":"Lapse Date","defaultValue":{"start":null,"end":null}},{"type":"text","name":"CITY","label":"Debtor City","defaultValue":""}],"myRecordsFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Approved"},{"value":2,"label":"Pending Online Payment"},{"value":3,"label":"Pending Review"}]},{"type":"select","name":"TYPE","defaultValue":0,"label":"Lien Type","options":[{"value":0,"label":"All"},{"value":1,"label":"UCC"},{"value":2,"label":"EFS"},{"value":3,"label":"Title 71"}]}],"myWorkQueueFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Approved"},{"value":2,"label":"Pending Online Payment"},{"value":3,"label":"Pending Review"},{"value":4,"label":"Pending Print and Mail"},{"value":5,"label":"Rejected"},{"value":6,"label":"Draft"}]},{"type":"select","name":"TYPE","defaultValue":0,"label":"Lien Type","options":[{"value":0,"label":"All"},{"value":1,"label":"UCC"},{"value":2,"label":"EFS"},{"value":3,"label":"Title 71"}]}]},{"label":"Copy Request","component":"copies","parameter":"copies","sourceTypeId":2001,"myRecordsSearch":false,"myWorkQueueSearch":false,"disabled":false,"allowedRoutes":["/forms-manager/","/queue/","/forms/"]},{"label":"Trademark","component":"Trademark","parameter":"trademark","sourceTypeId":810,"showRequestCertificate":true,"searchMustHaveOneOf":["search","EXPIRATION_DATE","FILING_DATE"],"allowEmptySearchTerm":true,"requestCertificateAlternateLabel":"Request Information","fileAmendmentButtonLabel":"Filing Actions","advancedSearchParameters":[{"type":"radio","name":"QUERY_TYPE_ID","defaultValue":1010,"options":[{"value":1010,"label":"Starts with"},{"value":1011,"label":"Contains"},{"value":1012,"label":" Word Contains"}]},{"type":"checkbox","name":"OWNER_SEARCH_YN","defaultValue":false,"label":"Search owners"},{"type":"radio","name":"SERVICE_MARK_YN","label":"Mark Type","defaultValue":"","options":[{"value":"","label":"All Marks"},{"value":"Y","label":"Service Mark"},{"value":"N","label":"Trademark"}]},{"type":"serverSelect","name":"STATUS_ID","optionsSrc":"TYPE_V|TRADEMARK_STATUS_TYPE","label":"Status","placeholder":"All","defaultValue":"0"},{"type":"select","name":"DESIGN_TYPE_ID","options":[{"value":0,"label":"All"},{"value":990,"label":"Words Only"},{"value":991,"label":"Design Only"},{"value":992,"label":"Words and Design"}],"label":"Design Type","defaultValue":"0"},{"type":"dateRange","name":"FILING_DATE","label":"Registered Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}},{"type":"dateRange","name":"EXPIRATION_DATE","label":"Expiration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}}]},{"label":"Business Info Request","component":"InfoRequests","parameter":"info-request","sourceTypeId":167,"allowedRoutes":["/forms-manager/","/queue/","/forms/"]},{"label":"Data Requests","component":"DataRequests","parameter":"data-request","sourceTypeId":0,"allowedRoutes":["/forms-manager/"]},{"label":"CRA","component":"CRA","parameter":"cra","sourceTypeId":157,"myRecordsSearch":false,"searchPlaceholder":"Search by name or registered agent number","allowedRoutes":["/forms-manager/","/forms/","/records/","/queue/","/search/"],"allowEmptySearchTerm":true,"fileAmendmentButtonLabel":"Filing Actions","advancedSearchParameters":[{"type":"radio","name":"QUERY_TYPE_ID","defaultValue":1010,"options":[{"value":1010,"label":"Starts with"},{"value":1011,"label":"Contains"},{"value":1012,"label":" Word Contains"}]},{"type":"dateRange","name":"CRA_DATE","label":"Registration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}},{"type":"select","name":"STATUS_ID","label":"Status","defaultValue":0,"options":[{"value":0,"label":"All"},{"value":121,"label":"Active"},{"value":122,"label":"Inactive"}]},{"type":"select","name":"AGENT_TYPE_ID","label":"Agent Type","defaultValue":0,"options":[{"value":0,"label":"All"},{"value":460,"label":"Registered Agent"},{"value":461,"label":"Commercial Registered Agent"}]}]},{"label":"Farm Bill","component":"FarmBill","parameter":"farm-bill","path":"/lists/farm-bill","sourceTypeId":0,"myRecordsSearch":false,"allowedRules":["/search/"],"disabled":true,"searchDescription":"To perform a search, enter a debtor name. Your search results may include: exact debtor name, variations of that name and any filing that includes your search criteria. Punctuation is ignored.\n\nYou can click on \"Advanced\" to refine your search. Under “Advanced” you can search by crop, year, county and SSN/FEIN. As a registered Farm Bill Buyer with the Montana Secretary of State’s office it is important to maintain the confidentiality of the information contained within the Farm Bill Master List. The Farm Bill Master List reflects personal data, such as Social Security Numbers, which are a key piece of personal identifiable information to assist you in determining the existence of a lien against a specific debtor. The distribution of this information beyond its intended purpose is strictly prohibited.\n\nThe debtor's tax identification number has been hidden for confidentiality reasons. You may continue to search on a tax ID number and return debtors that match your search criteria. The SSN/FEIN must be entered without dashes or spaces.","searchMustHaveOneOf":["search","UCC_FARM_PRODUCT_ID","COUNTY"],"searchPlaceholder":"Search by debtor name","advancedSearchParameters":[{"type":"ServerMultiComplete","label":"Product code name(s)","name":"UCC_FARM_PRODUCT_ID","defaultValue":"","optionsSrc":"UCC_FARM_PRODUCT_V"},{"type":"MultiComplete","label":"Year or Range of Years","name":"YEAR_NUM","optionsSrc":"years","startYear":"1968","defaultValue":[],"preMergeOptions":[{"value":"ALL","label":"All"}]},{"type":"serverSelect","label":"State","name":"STATE","defaultValue":"MONTANA","optionsSrc":"STATE"},{"type":"ServerMultiComplete","label":"County","name":"COUNTY","defaultValue":[],"optionsSrc":"COUNTY","overrideSubOptionsSrcFromParameterName":"STATE"},{"type":"checkbox","name":"TIN_SEARCH_YN","defaultValue":false,"label":"Tax Identification Number Search"},{"type":"checkbox","name":"TIN_SORT_YN","defaultValue":false,"label":"Unique ID Sort"}]}],"SYSTEM_NICKNAME":"Online Services Portal","PAYMENT_METHODS":[{"type":"bypass"},{"type":"iTransact"}],"PAYMENT_ALLOW_AMEX":true,"SYSTEM_ID_LABEL":"System Id","DOUBLE_COLUMN_PUBLIC_LOGIN":true,"INTERNAL_USER_MANAGEMENT":true,"ALLOW_PUBLIC_JSON_IMPORT":false,"MAX_FILE_UPLOAD_SIZE":10000000,"REFUND_TEXT":"","RETURN_TO_HOME_ON_LOGOUT":true,"CURRENT_SOS_NAME":"Christi Jacobsen","LOGO_FILENAME":"mt-sos-logo.png","LOGO_ALT":"Christi Jacobsen, Montana Secretary of State","LOGO_FULL_WIDTH":true,"HOME_HIDE_AUTH_HINT":true,"HOME_TITLE":"Montana Secretary of State","CUSTOM_TAB_TITLE":"Official Montana","HOME_SUBTITLE":"Online Business Services","ENTITY_NAME_CONSENT_DESCRIPTION":"","ALLOW_USER_PROFILE_EDITING":true,"COMPARE_FOREIGN_NAME_IN_ENTITY_NAME_VALIDATION":true,"FOREIGN_NAME_FIELD_NAME":"KIMA_PARENT_NAME_INFO","LOGIN_TITLE":"Montana Secretary of State Online Filing Portal Login","PUBLIC_LOGIN_LABEL":"Username","REVERSE_LOGIN_COLUMNS":true,"LOGIN_SEAL_FILENAME":"seal_white.png","SEPARATE_USERNAME_AND_EMAIL":true,"CREATE_ACCOUNT_BUTTON_ALIGN_LEFT":true,"CREATE_ACCOUNT_BUTTON_TEXT":"CREATE AN ACCOUNT","PASSWORD_CUSTOM_ERROR_TEXT":"The password must meet all requirements","ACCOUNT_CREATED_MESSAGE":"Please check your email to verify your account to login and allow a few minutes for this message to arrive. Check your junk/spam folders if you do not find the email in your inbox.","PUBLIC_LOGIN_PLACEHOLDER":" ","DISABLE_DEFAULT_PAYMENT_RADIO":true,"CUSTOM_RESET_PASSWORD_ERROR_MESSAGE":"Username invalid - no account found","PUBLIC_LOGIN_CREATE_DESCRIPTION":"### Existing User:\n\n  - Enter your username and password to login.  \n\n\n  #### - OR -  \n\n\n\n  - Forgot password? Click 'Reset Password' and follow the prompts.\n  - Forgot username? Click 'Forgot Username' and follow the prompts.  \n\n\n  ### New User:\n  ","LOGIN_HELP_LINK":"https://sosmt.gov/business/how-do-i/","LOGIN_HELP_LINK_TEXT":"Need Help?","FORGOT_USERNAME_TEXT":"Forgot Username?","LOGIN_ACTIVE_DIRECTORY_TEXT":"State User Login","MULTIPLE_LOGIN_METHODS":true,"HAS_ACTIVE_DIRECTORY_LOGIN":true,"RESET_PASSWORD_WITH_USERNAME":true,"DOWNLOAD_LINK":true,"SHOW_USERNAME_ACCOUNT_CREATE":true,"SHOW_SCROLL_DOWN_ARROW":true,"SHOW_ADDRESS_ACCOUNT_CREATE":true,"TWO_COLUMN_ACCOUNT_CREATE":true,"RESET_PASSWORD_TIP":"A link to change your password has been sent to your email. Please allow a few minutes for this message to arrive. Please check your junk/spam folders if you do not find the email in your inbox.","FORGOT_PASSWORD_LINK_TEXT":"Reset Password","PHONE_NUMBER_OPTIONAL_ACCOUNT_CREATE":true,"SHOW_REQUIRED_INDICATOR_ACCOUNT_CREATE":true,"PASSWORD_REQUIREMENTS_ACCOUNT_CREATE":"\n    <ul>\n      <li>MUST contain at least 8 characters (12+ recommended)</li>\n      <li>MUST contain at least one uppercase letter.</li>\n      <li>MUST contain at least one lowercase letter.</li>\n      <li>MUST contain at least one number.</li>\n      <li>MUST contain at least one special character (!”#$%&'()*+,-./:;<=>?</li>\n    </ul>\n  ","ALLOW_CERTIFICATION_REQUEST":true,"ALLOW_PUBLIC_CERTIFICATE_REQUEST":true,"ALLOW_COPY_REQUEST":false,"ALLOW_CORRECTION_STYLING":true,"HIDE_DEPRECATION_WARNING":false,"AMEND_ROUTE_PUBLIC":true,"SEAL_FILENAME":"seal.png","SHOPPING_CART":true,"ALLOW_PAYMENT_UPDATE_WITH_EMPTY_CART":true,"RA_EMAIL":true,"RA_WEBSITE":true,"RA_NO_DEFAULT_TYPE":true,"RA_ADDRESS_LABEL":"Street Address","RA_TYPE_SELECTION_DEFAULT":true,"RA_DEFAULT_TYPE":"460","RA_OVERRIDE_TYPE_WITH_DEFAULT":true,"RA_PRINCIPAL_ADDRESS_AMS":true,"UPLOAD_AND_SUBMIT_HIDE_IF_ONE_OPTION":true,"PAYMENT_PROCESSING_MESSAGE":"Your payment is processing - Do not close your browser or click the back button","CHECKOUT_BUTTON_WHEN_PROCESSING_TEXT":"Processing","EFS_CROP_PICKER_NONE_LABEL":"Lien Duration","DISALLOWED_WIZARD_PIECES":["FormationLocale"],"REPEATER_SHOW_EDIT_BUTTON":true,"DATA_REQUEST_PAGE_TITLE":"Data Requests and Subscriptions","DATA_REQUEST_SIDEBAR_LABEL":"Data Requests & Subscriptions","LOGIN_REDIRECTS_TO_EPASS":false,"LOGIN_REDIRECTS_TO_ACTIVE_DIRECTORY":true,"LOGIN_ACTIVE_DIRECTORY_LINK":true,"FETCH_EDIT_USER_LINK":false,"LISTS_FETCH_AVAILABLE_LISTS":true,"POST_WIZARD_SUBMIT_REDIRECT_URL":"/","PIN_REQUEST_ATTESTATIONS":true,"PIN_REQUEST_DESCRIPTION":"Click **Request PIN** to have a new PIN sent to the account holder's email address on file.","OWNERSHIP_REQUEST_DESCRIPTION":"To become an **authorized user** of this record, a current **AUTHORIZED USER** will need to grant you access. To request access, click **Request Access** below.","PIN_REQUEST_SUCCESS_MESSAGE":"The PIN you have requested for this entity has been sent to the email associated with your user account.  You should receive the PIN in approximately 3-5 minutes, depending on your email service provider.","APOSTILLE_HEADER_LABEL":"Verification Information","APOSTILLE_NUMBER_LABEL":"Apostille/Authentication","APOSTILLE_CITY_STATE_OVERRIDE":"HELENA, MT","APOSTILLE_FILING_DATE_LABEL":"Issue Date","APOSTILLE_CITY_STATE_IN_CERTIFIED":true,"NOTARY_EXISTING_FILING":true,"ALLOW_REVOKE_OWN_ACCESS_ONLY":false,"HIDE_CANCEL_ON_ONETIME_DATA_REQUESTS":true,"DATA_REQUESTS_IN_SHOPPING_CART":true,"WQ_ALLOW_EDIT_PENDING_PAYMENT":true,"WQ_CONFIRM_ON_DELETE":true,"WQ_DELETE_CONFIRM_MESSAGE":"Deleting this filing will forfeit any money already paid to the Secretary of State. This action is permanent and cannot be undone, are you sure you would like to delete?","PASS_ITEM_GUIDS_ON_CHECKOUT":true,"FORM_REVISION_HISTORY":true,"CHECKOUT_DISCLAIMER":"By entering your credit card and/or checking account information you (i) state that **you are an authorized user** of the credit card and/or electronic check and that the associated information entered (e.g., account holder name, account number, billing address) is accurate, (ii) **you authorize payment processor to charge the amount you have requested** to your credit card and/or funding account, and (iii) **acknowledge if a charge is declined or reversed you may also be assessed a customary charge** by the payment processor for such transactions.","FARM_BILL_SEARCH_CONFIDENTIAL":"As a registered Farm Bill Buyer with the Montana Secretary of State’s office it is important to maintain the confidentiality of the information contained within the Farm Bill Master List. The Farm Bill Master List reflects personal data, such as Social Security Numbers, which are a key piece of personal identifiable information to assist you in determining the existence of a lien against a specific debtor. The distribution of this information beyond its intended purpose is strictly prohibited.\n\n**The debtor's tax identification number has been hidden for confidentiality reasons. You may continue to search on a tax ID number and return debtors that match your search criteria. The SSN/FEIN must be entered without dashes or spaces.  If you need access to the tax identification number to clearly identify the debtor, please contact the UCC unit at (406) 444-3665.**","VIEW_HISTORY_BUTTON_ALT_TEXT":"View Filings","WIZARD_ERROR_TITLE_MESSAGE":"Form Error","FARM_BILL_SEARCH_INTERACTIVE":true,"USE_FARM_BILL_API":true,"DISALLOW_ASSIGN_SELF_AS_RA":true,"DISALLOW_ASSIGN_SELF_AS_PRINCIPAL":true,"USE_TRADEMARK_OWNER_VALIDATION":true,"USE_ALTERNATIVE_FOREIGN_ADDRESS_LABELS":true,"MY_RECEIPTS_FILTER":[{"type":"dateRange","name":"DATE_RANGE","label":"Date range","defaultValue":{"start":null,"end":null}},{"type":"text","name":"REF_NUM","defaultValue":"","label":"Reference Number"},{"type":"text","name":"RECEIPT_NUM","defaultValue":"","label":"Receipt Id"},{"type":"text","name":"AMOUNT","defaultValue":"","label":"Amount"},{"type":"select","name":"TYPE","defaultValue":"","label":"Payment Type","options":[{"value":"","label":"All"},{"value":"CC","label":"Credit Card"},{"value":"Check","label":"Check"}]}],"MY_RECEIPTS_SHOW_IN_SIDEBAR":true,"SHOW_MY_RECEIPTS_HELPER_TEXT":true,"MY_RECEIPTS_HELPER_LABEL":"About Receipt Search","MY_RECEIPTS_HELPER_TEXT":"You can search for receipts based on their descriptions, including the items paid for on the receipt. Use the filters to search for or filter specific information.","FARM_BILL_SUBLINK":{"label":"Farm Bill","component":"FarmBill","parameter":"farm-bill","path":"/lists/farm-bill","sourceTypeId":0,"myRecordsSearch":false,"allowedRules":["/search/"],"disabled":true,"searchDescription":"To perform a search, enter a debtor name. Your search results may include: exact debtor name, variations of that name and any filing that includes your search criteria. Punctuation is ignored.\n\nYou can click on \"Advanced\" to refine your search. Under “Advanced” you can search by crop, year, county and SSN/FEIN. As a registered Farm Bill Buyer with the Montana Secretary of State’s office it is important to maintain the confidentiality of the information contained within the Farm Bill Master List. The Farm Bill Master List reflects personal data, such as Social Security Numbers, which are a key piece of personal identifiable information to assist you in determining the existence of a lien against a specific debtor. The distribution of this information beyond its intended purpose is strictly prohibited.\n\nThe debtor's tax identification number has been hidden for confidentiality reasons. You may continue to search on a tax ID number and return debtors that match your search criteria. The SSN/FEIN must be entered without dashes or spaces.","searchMustHaveOneOf":["search","UCC_FARM_PRODUCT_ID","COUNTY"],"searchPlaceholder":"Search by debtor name","advancedSearchParameters":[{"type":"ServerMultiComplete","label":"Product code name(s)","name":"UCC_FARM_PRODUCT_ID","defaultValue":"","optionsSrc":"UCC_FARM_PRODUCT_V"},{"type":"MultiComplete","label":"Year or Range of Years","name":"YEAR_NUM","optionsSrc":"years","startYear":"1968","defaultValue":[],"preMergeOptions":[{"value":"ALL","label":"All"}]},{"type":"serverSelect","label":"State","name":"STATE","defaultValue":"MONTANA","optionsSrc":"STATE"},{"type":"ServerMultiComplete","label":"County","name":"COUNTY","defaultValue":[],"optionsSrc":"COUNTY","overrideSubOptionsSrcFromParameterName":"STATE"},{"type":"checkbox","name":"TIN_SEARCH_YN","defaultValue":false,"label":"Tax Identification Number Search"},{"type":"checkbox","name":"TIN_SORT_YN","defaultValue":false,"label":"Unique ID Sort"}]},"ALLOW_ADDRESS_VALIDATION_BYPASS_OPTION":true,"DEFAULT_ADDRESS_VALIDATION_BYPASS_OPTION_CHECKED":true}).LISTS_CURRENT_YEAR_MONTH_INDEX ? ({"NODE_ENV":"production","BUILD_DATE":"2025-08-27T15:15:31.687Z","BUILD_NUMBER":"Not Provided","GIT_VERSION":"v1.3.0-381-ga81e29b08","GIT_COMMIT_HASH":"a81e29b085c9268ffd96c78eb734365802722741","GIT_BRANCH":"beta","PUBLIC_URL":"","STATE_ABBR":"MT","STATE_NAME":"Montana","STATE_ORG_TITLE":"Secretary of State","LOGIN_HEADER_IMG_PATH":"","HOME_IMG_FILENAME":"montana.jpg","FAVICON_FILE_NAME":"favicon.ico","ALLOW_E_SIGN_ON_CORRECTIONS":true,"THIRD_PARTY_SIGNING_ALLOWED":false,"MY_ACCOUNT_SAVE_AND_CLOSE_BUTTON":true,"IE_DEPRECATED_MESSAGE":"Internet Explorer is not supported. Please select a supported browser below to access this website.","ADDITIONAL_ROUTES":{"dataRequests":true,"farmBill":true,"apostille":true,"externalHelp":"https://sosmt.gov/business/help-center/","systemAdministration":[{"title":"Saved Payments","parameter":"saved-payments","componentName":"SavedPayments"}]},"SUBROUTES":[{"label":"Business","component":"Business","parameter":"business","myWorkQueueSearch":false,"sourceTypeId":54,"searchMustHaveOneOf":["FILING_TYPE_ID","STATUS_ID","STATE","search"],"serverWebSearchDescription":true,"serverWorkQueueDescription":true,"serverMyRecordsDescription":true,"searchPlaceholder":"Search by name or filing number (X########)","allowEmptySearchTerm":true,"requestCertificateAlternateLabel":"Request Information","fileAmendmentButtonLabel":"Filing Actions","advancedSearchParameters":[{"type":"radio","name":"QUERY_TYPE_ID","defaultValue":1010,"options":[{"value":1010,"label":"Starts with"},{"value":1011,"label":"Contains"},{"value":1012,"label":" Word Contains"}]},{"type":"serverSelect","name":"FILING_TYPE_ID","optionsSrc":"FILING_TYPES","label":"Entity Type","placeholder":"All","defaultValue":"0"},{"type":"serverSelect","name":"FILING_SUBTYPE_ID","optionsSrc":"FILING_SUBTYPES","label":"Entity Subtype","overrideSubOptionsSrcFromParameterName":"FILING_TYPE_ID","placeholder":"All","defaultValue":"0"},{"type":"serverSelect","name":"STATUS_ID","optionsSrc":"FILING_STATUS_WITHOUT_ALL","label":"Status","placeholder":"All","defaultValue":"0"},{"type":"serverSelect","name":"STATE","optionsSrc":"STATE","label":"State","placeholder":"All","defaultValue":""},{"type":"serverSelect","name":"COUNTY","optionsSrc":"COUNTY_SUBOPTION","label":"County","overrideSubOptionsSrcFromParameterName":"STATE","placeholder":"All","defaultValue":""},{"type":"checkbox","name":"CRA_SEARCH_YN","defaultValue":false,"label":"Search by Registered Agent PID"},{"type":"dateRange","name":"FILING_DATE","label":"Registration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}},{"type":"dateRange","name":"EXPIRATION_DATE","label":"Expiration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}}],"myRecordsFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Active"},{"value":2,"label":"Inactive"},{"value":3,"label":"Pending"}]},{"type":"dateRange","name":"DATE_RANGE","label":"Date range","defaultValue":{"start":null,"end":null}}],"myWorkQueueFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Approved"},{"value":2,"label":"Pending Online Payment"},{"value":3,"label":"Pending Review"},{"value":4,"label":"Needs Correction"},{"value":5,"label":"Rejected"},{"value":6,"label":"Draft"}]},{"type":"dateRange","name":"DATE_RANGE","label":"Date range","defaultValue":{"start":null,"end":null}}]},{"label":"Notary","component":"Notary","parameter":"notary","sourceTypeId":850,"myWorkQueueSearch":false,"allowEmptySearchTerm":true,"requestCertificateAlternateLabel":"Download Certificate","fileAmendmentButtonLabel":"Filing Actions","hideNameRequestCertificate":true,"hideAddressRequestCertificate":true,"hideRecordUserManagment":true,"searchPlaceholder":"Search by name or commission number","searchMustHaveOneOf":["CITY","search","SERVICE_TYPE"],"advancedParametersStartOpen":true,"searchIsSortable":true,"advancedSearchParameters":[{"type":"radio","name":"STARTS_WITH_YN","defaultValue":false,"options":[{"value":true,"label":"Starts with"},{"value":false,"label":"Contains"}]},{"type":"checkbox","name":"ACTIVE_ONLY_YN","defaultValue":true,"label":"Active entities only"},{"type":"text","name":"CITY","defaultValue":"","label":"City"},{"type":"select","name":"SERVICE_TYPE","label":"Special Services Offered","defaultValue":0,"options":[{"value":0,"label":"(N/A)"},{"value":6165,"label":"In-Person Electronic Notarization (IPEN)"},{"value":6166,"label":"Remote Online Notarization (RON)"},{"value":6167,"label":"Mobile Notary Services"},{"value":6168,"label":"Remote Ink Notarization (RIN)"}]}]},{"label":"Apostille","component":"Apostille","parameter":"apostille","sourceTypeId":720,"myRecordsSearch":false,"myWorkQueueSearch":false,"disabled":false,"allowedRoutes":["/forms-manager/","/queue/","/forms/"]},{"label":"Liens","component":"UCC","parameter":"ucc","sourceTypeId":1999,"myRecordsSearch":true,"myWorkQueueSearch":true,"fileAmendmentButtonLabel":"Filing Actions","searchPlaceholder":"Search by name or file number","disabled":false,"serverWebSearchDescription":true,"myRecordsDescription":"","workQueueDescription":"","searchDescription":"","hideRecordUserManagment":true,"searchLiensCheckout":false,"advancedSearchParameters":[{"type":"radio","name":"STARTS_WITH_YN","defaultValue":false,"options":[{"value":true,"label":"Starts with"},{"value":false,"label":"Contains"}]},{"type":"select","name":"STATUS","defaultValue":"ALL","label":"Status","options":[{"value":"ACTIVE_UNLAPSED","label":"Active (unlapsed)"},{"value":"ACTIVE_LAPSED_UNLAPSED","label":"Active (lapsed and unlapsed)"}]},{"type":"text","name":"EXCLUDE_VALUES","label":"Exclude Debtor Names (comma separated list of names to exclude)","defaultValue":""},{"type":"dateRange","name":"FILING_DATE","label":"Financing Statement Date","defaultValue":{"start":null,"end":null}},{"type":"dateRange","name":"LAPSE_DATE","label":"Lapse Date","defaultValue":{"start":null,"end":null}},{"type":"text","name":"CITY","label":"Debtor City","defaultValue":""}],"myRecordsFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Approved"},{"value":2,"label":"Pending Online Payment"},{"value":3,"label":"Pending Review"}]},{"type":"select","name":"TYPE","defaultValue":0,"label":"Lien Type","options":[{"value":0,"label":"All"},{"value":1,"label":"UCC"},{"value":2,"label":"EFS"},{"value":3,"label":"Title 71"}]}],"myWorkQueueFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Approved"},{"value":2,"label":"Pending Online Payment"},{"value":3,"label":"Pending Review"},{"value":4,"label":"Pending Print and Mail"},{"value":5,"label":"Rejected"},{"value":6,"label":"Draft"}]},{"type":"select","name":"TYPE","defaultValue":0,"label":"Lien Type","options":[{"value":0,"label":"All"},{"value":1,"label":"UCC"},{"value":2,"label":"EFS"},{"value":3,"label":"Title 71"}]}]},{"label":"Copy Request","component":"copies","parameter":"copies","sourceTypeId":2001,"myRecordsSearch":false,"myWorkQueueSearch":false,"disabled":false,"allowedRoutes":["/forms-manager/","/queue/","/forms/"]},{"label":"Trademark","component":"Trademark","parameter":"trademark","sourceTypeId":810,"showRequestCertificate":true,"searchMustHaveOneOf":["search","EXPIRATION_DATE","FILING_DATE"],"allowEmptySearchTerm":true,"requestCertificateAlternateLabel":"Request Information","fileAmendmentButtonLabel":"Filing Actions","advancedSearchParameters":[{"type":"radio","name":"QUERY_TYPE_ID","defaultValue":1010,"options":[{"value":1010,"label":"Starts with"},{"value":1011,"label":"Contains"},{"value":1012,"label":" Word Contains"}]},{"type":"checkbox","name":"OWNER_SEARCH_YN","defaultValue":false,"label":"Search owners"},{"type":"radio","name":"SERVICE_MARK_YN","label":"Mark Type","defaultValue":"","options":[{"value":"","label":"All Marks"},{"value":"Y","label":"Service Mark"},{"value":"N","label":"Trademark"}]},{"type":"serverSelect","name":"STATUS_ID","optionsSrc":"TYPE_V|TRADEMARK_STATUS_TYPE","label":"Status","placeholder":"All","defaultValue":"0"},{"type":"select","name":"DESIGN_TYPE_ID","options":[{"value":0,"label":"All"},{"value":990,"label":"Words Only"},{"value":991,"label":"Design Only"},{"value":992,"label":"Words and Design"}],"label":"Design Type","defaultValue":"0"},{"type":"dateRange","name":"FILING_DATE","label":"Registered Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}},{"type":"dateRange","name":"EXPIRATION_DATE","label":"Expiration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}}]},{"label":"Business Info Request","component":"InfoRequests","parameter":"info-request","sourceTypeId":167,"allowedRoutes":["/forms-manager/","/queue/","/forms/"]},{"label":"Data Requests","component":"DataRequests","parameter":"data-request","sourceTypeId":0,"allowedRoutes":["/forms-manager/"]},{"label":"CRA","component":"CRA","parameter":"cra","sourceTypeId":157,"myRecordsSearch":false,"searchPlaceholder":"Search by name or registered agent number","allowedRoutes":["/forms-manager/","/forms/","/records/","/queue/","/search/"],"allowEmptySearchTerm":true,"fileAmendmentButtonLabel":"Filing Actions","advancedSearchParameters":[{"type":"radio","name":"QUERY_TYPE_ID","defaultValue":1010,"options":[{"value":1010,"label":"Starts with"},{"value":1011,"label":"Contains"},{"value":1012,"label":" Word Contains"}]},{"type":"dateRange","name":"CRA_DATE","label":"Registration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}},{"type":"select","name":"STATUS_ID","label":"Status","defaultValue":0,"options":[{"value":0,"label":"All"},{"value":121,"label":"Active"},{"value":122,"label":"Inactive"}]},{"type":"select","name":"AGENT_TYPE_ID","label":"Agent Type","defaultValue":0,"options":[{"value":0,"label":"All"},{"value":460,"label":"Registered Agent"},{"value":461,"label":"Commercial Registered Agent"}]}]},{"label":"Farm Bill","component":"FarmBill","parameter":"farm-bill","path":"/lists/farm-bill","sourceTypeId":0,"myRecordsSearch":false,"allowedRules":["/search/"],"disabled":true,"searchDescription":"To perform a search, enter a debtor name. Your search results may include: exact debtor name, variations of that name and any filing that includes your search criteria. Punctuation is ignored.\n\nYou can click on \"Advanced\" to refine your search. Under “Advanced” you can search by crop, year, county and SSN/FEIN. As a registered Farm Bill Buyer with the Montana Secretary of State’s office it is important to maintain the confidentiality of the information contained within the Farm Bill Master List. The Farm Bill Master List reflects personal data, such as Social Security Numbers, which are a key piece of personal identifiable information to assist you in determining the existence of a lien against a specific debtor. The distribution of this information beyond its intended purpose is strictly prohibited.\n\nThe debtor's tax identification number has been hidden for confidentiality reasons. You may continue to search on a tax ID number and return debtors that match your search criteria. The SSN/FEIN must be entered without dashes or spaces.","searchMustHaveOneOf":["search","UCC_FARM_PRODUCT_ID","COUNTY"],"searchPlaceholder":"Search by debtor name","advancedSearchParameters":[{"type":"ServerMultiComplete","label":"Product code name(s)","name":"UCC_FARM_PRODUCT_ID","defaultValue":"","optionsSrc":"UCC_FARM_PRODUCT_V"},{"type":"MultiComplete","label":"Year or Range of Years","name":"YEAR_NUM","optionsSrc":"years","startYear":"1968","defaultValue":[],"preMergeOptions":[{"value":"ALL","label":"All"}]},{"type":"serverSelect","label":"State","name":"STATE","defaultValue":"MONTANA","optionsSrc":"STATE"},{"type":"ServerMultiComplete","label":"County","name":"COUNTY","defaultValue":[],"optionsSrc":"COUNTY","overrideSubOptionsSrcFromParameterName":"STATE"},{"type":"checkbox","name":"TIN_SEARCH_YN","defaultValue":false,"label":"Tax Identification Number Search"},{"type":"checkbox","name":"TIN_SORT_YN","defaultValue":false,"label":"Unique ID Sort"}]}],"SYSTEM_NICKNAME":"Online Services Portal","PAYMENT_METHODS":[{"type":"bypass"},{"type":"iTransact"}],"PAYMENT_ALLOW_AMEX":true,"SYSTEM_ID_LABEL":"System Id","DOUBLE_COLUMN_PUBLIC_LOGIN":true,"INTERNAL_USER_MANAGEMENT":true,"ALLOW_PUBLIC_JSON_IMPORT":false,"MAX_FILE_UPLOAD_SIZE":10000000,"REFUND_TEXT":"","RETURN_TO_HOME_ON_LOGOUT":true,"CURRENT_SOS_NAME":"Christi Jacobsen","LOGO_FILENAME":"mt-sos-logo.png","LOGO_ALT":"Christi Jacobsen, Montana Secretary of State","LOGO_FULL_WIDTH":true,"HOME_HIDE_AUTH_HINT":true,"HOME_TITLE":"Montana Secretary of State","CUSTOM_TAB_TITLE":"Official Montana","HOME_SUBTITLE":"Online Business Services","ENTITY_NAME_CONSENT_DESCRIPTION":"","ALLOW_USER_PROFILE_EDITING":true,"COMPARE_FOREIGN_NAME_IN_ENTITY_NAME_VALIDATION":true,"FOREIGN_NAME_FIELD_NAME":"KIMA_PARENT_NAME_INFO","LOGIN_TITLE":"Montana Secretary of State Online Filing Portal Login","PUBLIC_LOGIN_LABEL":"Username","REVERSE_LOGIN_COLUMNS":true,"LOGIN_SEAL_FILENAME":"seal_white.png","SEPARATE_USERNAME_AND_EMAIL":true,"CREATE_ACCOUNT_BUTTON_ALIGN_LEFT":true,"CREATE_ACCOUNT_BUTTON_TEXT":"CREATE AN ACCOUNT","PASSWORD_CUSTOM_ERROR_TEXT":"The password must meet all requirements","ACCOUNT_CREATED_MESSAGE":"Please check your email to verify your account to login and allow a few minutes for this message to arrive. Check your junk/spam folders if you do not find the email in your inbox.","PUBLIC_LOGIN_PLACEHOLDER":" ","DISABLE_DEFAULT_PAYMENT_RADIO":true,"CUSTOM_RESET_PASSWORD_ERROR_MESSAGE":"Username invalid - no account found","PUBLIC_LOGIN_CREATE_DESCRIPTION":"### Existing User:\n\n  - Enter your username and password to login.  \n\n\n  #### - OR -  \n\n\n\n  - Forgot password? Click 'Reset Password' and follow the prompts.\n  - Forgot username? Click 'Forgot Username' and follow the prompts.  \n\n\n  ### New User:\n  ","LOGIN_HELP_LINK":"https://sosmt.gov/business/how-do-i/","LOGIN_HELP_LINK_TEXT":"Need Help?","FORGOT_USERNAME_TEXT":"Forgot Username?","LOGIN_ACTIVE_DIRECTORY_TEXT":"State User Login","MULTIPLE_LOGIN_METHODS":true,"HAS_ACTIVE_DIRECTORY_LOGIN":true,"RESET_PASSWORD_WITH_USERNAME":true,"DOWNLOAD_LINK":true,"SHOW_USERNAME_ACCOUNT_CREATE":true,"SHOW_SCROLL_DOWN_ARROW":true,"SHOW_ADDRESS_ACCOUNT_CREATE":true,"TWO_COLUMN_ACCOUNT_CREATE":true,"RESET_PASSWORD_TIP":"A link to change your password has been sent to your email. Please allow a few minutes for this message to arrive. Please check your junk/spam folders if you do not find the email in your inbox.","FORGOT_PASSWORD_LINK_TEXT":"Reset Password","PHONE_NUMBER_OPTIONAL_ACCOUNT_CREATE":true,"SHOW_REQUIRED_INDICATOR_ACCOUNT_CREATE":true,"PASSWORD_REQUIREMENTS_ACCOUNT_CREATE":"\n    <ul>\n      <li>MUST contain at least 8 characters (12+ recommended)</li>\n      <li>MUST contain at least one uppercase letter.</li>\n      <li>MUST contain at least one lowercase letter.</li>\n      <li>MUST contain at least one number.</li>\n      <li>MUST contain at least one special character (!”#$%&'()*+,-./:;<=>?</li>\n    </ul>\n  ","ALLOW_CERTIFICATION_REQUEST":true,"ALLOW_PUBLIC_CERTIFICATE_REQUEST":true,"ALLOW_COPY_REQUEST":false,"ALLOW_CORRECTION_STYLING":true,"HIDE_DEPRECATION_WARNING":false,"AMEND_ROUTE_PUBLIC":true,"SEAL_FILENAME":"seal.png","SHOPPING_CART":true,"ALLOW_PAYMENT_UPDATE_WITH_EMPTY_CART":true,"RA_EMAIL":true,"RA_WEBSITE":true,"RA_NO_DEFAULT_TYPE":true,"RA_ADDRESS_LABEL":"Street Address","RA_TYPE_SELECTION_DEFAULT":true,"RA_DEFAULT_TYPE":"460","RA_OVERRIDE_TYPE_WITH_DEFAULT":true,"RA_PRINCIPAL_ADDRESS_AMS":true,"UPLOAD_AND_SUBMIT_HIDE_IF_ONE_OPTION":true,"PAYMENT_PROCESSING_MESSAGE":"Your payment is processing - Do not close your browser or click the back button","CHECKOUT_BUTTON_WHEN_PROCESSING_TEXT":"Processing","EFS_CROP_PICKER_NONE_LABEL":"Lien Duration","DISALLOWED_WIZARD_PIECES":["FormationLocale"],"REPEATER_SHOW_EDIT_BUTTON":true,"DATA_REQUEST_PAGE_TITLE":"Data Requests and Subscriptions","DATA_REQUEST_SIDEBAR_LABEL":"Data Requests & Subscriptions","LOGIN_REDIRECTS_TO_EPASS":false,"LOGIN_REDIRECTS_TO_ACTIVE_DIRECTORY":true,"LOGIN_ACTIVE_DIRECTORY_LINK":true,"FETCH_EDIT_USER_LINK":false,"LISTS_FETCH_AVAILABLE_LISTS":true,"POST_WIZARD_SUBMIT_REDIRECT_URL":"/","PIN_REQUEST_ATTESTATIONS":true,"PIN_REQUEST_DESCRIPTION":"Click **Request PIN** to have a new PIN sent to the account holder's email address on file.","OWNERSHIP_REQUEST_DESCRIPTION":"To become an **authorized user** of this record, a current **AUTHORIZED USER** will need to grant you access. To request access, click **Request Access** below.","PIN_REQUEST_SUCCESS_MESSAGE":"The PIN you have requested for this entity has been sent to the email associated with your user account.  You should receive the PIN in approximately 3-5 minutes, depending on your email service provider.","APOSTILLE_HEADER_LABEL":"Verification Information","APOSTILLE_NUMBER_LABEL":"Apostille/Authentication","APOSTILLE_CITY_STATE_OVERRIDE":"HELENA, MT","APOSTILLE_FILING_DATE_LABEL":"Issue Date","APOSTILLE_CITY_STATE_IN_CERTIFIED":true,"NOTARY_EXISTING_FILING":true,"ALLOW_REVOKE_OWN_ACCESS_ONLY":false,"HIDE_CANCEL_ON_ONETIME_DATA_REQUESTS":true,"DATA_REQUESTS_IN_SHOPPING_CART":true,"WQ_ALLOW_EDIT_PENDING_PAYMENT":true,"WQ_CONFIRM_ON_DELETE":true,"WQ_DELETE_CONFIRM_MESSAGE":"Deleting this filing will forfeit any money already paid to the Secretary of State. This action is permanent and cannot be undone, are you sure you would like to delete?","PASS_ITEM_GUIDS_ON_CHECKOUT":true,"FORM_REVISION_HISTORY":true,"CHECKOUT_DISCLAIMER":"By entering your credit card and/or checking account information you (i) state that **you are an authorized user** of the credit card and/or electronic check and that the associated information entered (e.g., account holder name, account number, billing address) is accurate, (ii) **you authorize payment processor to charge the amount you have requested** to your credit card and/or funding account, and (iii) **acknowledge if a charge is declined or reversed you may also be assessed a customary charge** by the payment processor for such transactions.","FARM_BILL_SEARCH_CONFIDENTIAL":"As a registered Farm Bill Buyer with the Montana Secretary of State’s office it is important to maintain the confidentiality of the information contained within the Farm Bill Master List. The Farm Bill Master List reflects personal data, such as Social Security Numbers, which are a key piece of personal identifiable information to assist you in determining the existence of a lien against a specific debtor. The distribution of this information beyond its intended purpose is strictly prohibited.\n\n**The debtor's tax identification number has been hidden for confidentiality reasons. You may continue to search on a tax ID number and return debtors that match your search criteria. The SSN/FEIN must be entered without dashes or spaces.  If you need access to the tax identification number to clearly identify the debtor, please contact the UCC unit at (406) 444-3665.**","VIEW_HISTORY_BUTTON_ALT_TEXT":"View Filings","WIZARD_ERROR_TITLE_MESSAGE":"Form Error","FARM_BILL_SEARCH_INTERACTIVE":true,"USE_FARM_BILL_API":true,"DISALLOW_ASSIGN_SELF_AS_RA":true,"DISALLOW_ASSIGN_SELF_AS_PRINCIPAL":true,"USE_TRADEMARK_OWNER_VALIDATION":true,"USE_ALTERNATIVE_FOREIGN_ADDRESS_LABELS":true,"MY_RECEIPTS_FILTER":[{"type":"dateRange","name":"DATE_RANGE","label":"Date range","defaultValue":{"start":null,"end":null}},{"type":"text","name":"REF_NUM","defaultValue":"","label":"Reference Number"},{"type":"text","name":"RECEIPT_NUM","defaultValue":"","label":"Receipt Id"},{"type":"text","name":"AMOUNT","defaultValue":"","label":"Amount"},{"type":"select","name":"TYPE","defaultValue":"","label":"Payment Type","options":[{"value":"","label":"All"},{"value":"CC","label":"Credit Card"},{"value":"Check","label":"Check"}]}],"MY_RECEIPTS_SHOW_IN_SIDEBAR":true,"SHOW_MY_RECEIPTS_HELPER_TEXT":true,"MY_RECEIPTS_HELPER_LABEL":"About Receipt Search","MY_RECEIPTS_HELPER_TEXT":"You can search for receipts based on their descriptions, including the items paid for on the receipt. Use the filters to search for or filter specific information.","FARM_BILL_SUBLINK":{"label":"Farm Bill","component":"FarmBill","parameter":"farm-bill","path":"/lists/farm-bill","sourceTypeId":0,"myRecordsSearch":false,"allowedRules":["/search/"],"disabled":true,"searchDescription":"To perform a search, enter a debtor name. Your search results may include: exact debtor name, variations of that name and any filing that includes your search criteria. Punctuation is ignored.\n\nYou can click on \"Advanced\" to refine your search. Under “Advanced” you can search by crop, year, county and SSN/FEIN. As a registered Farm Bill Buyer with the Montana Secretary of State’s office it is important to maintain the confidentiality of the information contained within the Farm Bill Master List. The Farm Bill Master List reflects personal data, such as Social Security Numbers, which are a key piece of personal identifiable information to assist you in determining the existence of a lien against a specific debtor. The distribution of this information beyond its intended purpose is strictly prohibited.\n\nThe debtor's tax identification number has been hidden for confidentiality reasons. You may continue to search on a tax ID number and return debtors that match your search criteria. The SSN/FEIN must be entered without dashes or spaces.","searchMustHaveOneOf":["search","UCC_FARM_PRODUCT_ID","COUNTY"],"searchPlaceholder":"Search by debtor name","advancedSearchParameters":[{"type":"ServerMultiComplete","label":"Product code name(s)","name":"UCC_FARM_PRODUCT_ID","defaultValue":"","optionsSrc":"UCC_FARM_PRODUCT_V"},{"type":"MultiComplete","label":"Year or Range of Years","name":"YEAR_NUM","optionsSrc":"years","startYear":"1968","defaultValue":[],"preMergeOptions":[{"value":"ALL","label":"All"}]},{"type":"serverSelect","label":"State","name":"STATE","defaultValue":"MONTANA","optionsSrc":"STATE"},{"type":"ServerMultiComplete","label":"County","name":"COUNTY","defaultValue":[],"optionsSrc":"COUNTY","overrideSubOptionsSrcFromParameterName":"STATE"},{"type":"checkbox","name":"TIN_SEARCH_YN","defaultValue":false,"label":"Tax Identification Number Search"},{"type":"checkbox","name":"TIN_SORT_YN","defaultValue":false,"label":"Unique ID Sort"}]},"ALLOW_ADDRESS_VALIDATION_BYPASS_OPTION":true,"DEFAULT_ADDRESS_VALIDATION_BYPASS_OPTION_CHECKED":true}).LISTS_CURRENT_YEAR_MONTH_INDEX : 7;
	var CURRENT_YEAR = new Date().getMonth() > MONTH_INDEX ? new Date().getFullYear() + 1 : new Date().getFullYear();
	var LISTS_FETCH_AVAILABLE_LISTS = (true);
	
	var Lists = function (_Component) {
	  _inherits(Lists, _Component);
	
	  function Lists() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, Lists);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Lists.__proto__ || Object.getPrototypeOf(Lists)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      listGroups: [],
	      loading: LISTS_FETCH_AVAILABLE_LISTS || false
	    }, _this.componentDidMount = function () {
	      if (LISTS_FETCH_AVAILABLE_LISTS) {
	        _this.getAvailableLists();
	      }
	    }, _this.getAvailableLists = function () {
	      _this.setState({
	        loading: true
	      });
	      (0, _requests.GET_AVAILABLE_LISTS)(function (listGroups) {
	        _this.setState({
	          listGroups: listGroups,
	          loading: false
	        });
	      }, function (err) {
	        console.error(err);
	        _this.setState({ loading: false });
	      });
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(Lists, [{
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        _Shell.Body,
	        { className: 'lists-page' },
	        !({"NODE_ENV":"production","BUILD_DATE":"2025-08-27T15:15:31.687Z","BUILD_NUMBER":"Not Provided","GIT_VERSION":"v1.3.0-381-ga81e29b08","GIT_COMMIT_HASH":"a81e29b085c9268ffd96c78eb734365802722741","GIT_BRANCH":"beta","PUBLIC_URL":"","STATE_ABBR":"MT","STATE_NAME":"Montana","STATE_ORG_TITLE":"Secretary of State","LOGIN_HEADER_IMG_PATH":"","HOME_IMG_FILENAME":"montana.jpg","FAVICON_FILE_NAME":"favicon.ico","ALLOW_E_SIGN_ON_CORRECTIONS":true,"THIRD_PARTY_SIGNING_ALLOWED":false,"MY_ACCOUNT_SAVE_AND_CLOSE_BUTTON":true,"IE_DEPRECATED_MESSAGE":"Internet Explorer is not supported. Please select a supported browser below to access this website.","ADDITIONAL_ROUTES":{"dataRequests":true,"farmBill":true,"apostille":true,"externalHelp":"https://sosmt.gov/business/help-center/","systemAdministration":[{"title":"Saved Payments","parameter":"saved-payments","componentName":"SavedPayments"}]},"SUBROUTES":[{"label":"Business","component":"Business","parameter":"business","myWorkQueueSearch":false,"sourceTypeId":54,"searchMustHaveOneOf":["FILING_TYPE_ID","STATUS_ID","STATE","search"],"serverWebSearchDescription":true,"serverWorkQueueDescription":true,"serverMyRecordsDescription":true,"searchPlaceholder":"Search by name or filing number (X########)","allowEmptySearchTerm":true,"requestCertificateAlternateLabel":"Request Information","fileAmendmentButtonLabel":"Filing Actions","advancedSearchParameters":[{"type":"radio","name":"QUERY_TYPE_ID","defaultValue":1010,"options":[{"value":1010,"label":"Starts with"},{"value":1011,"label":"Contains"},{"value":1012,"label":" Word Contains"}]},{"type":"serverSelect","name":"FILING_TYPE_ID","optionsSrc":"FILING_TYPES","label":"Entity Type","placeholder":"All","defaultValue":"0"},{"type":"serverSelect","name":"FILING_SUBTYPE_ID","optionsSrc":"FILING_SUBTYPES","label":"Entity Subtype","overrideSubOptionsSrcFromParameterName":"FILING_TYPE_ID","placeholder":"All","defaultValue":"0"},{"type":"serverSelect","name":"STATUS_ID","optionsSrc":"FILING_STATUS_WITHOUT_ALL","label":"Status","placeholder":"All","defaultValue":"0"},{"type":"serverSelect","name":"STATE","optionsSrc":"STATE","label":"State","placeholder":"All","defaultValue":""},{"type":"serverSelect","name":"COUNTY","optionsSrc":"COUNTY_SUBOPTION","label":"County","overrideSubOptionsSrcFromParameterName":"STATE","placeholder":"All","defaultValue":""},{"type":"checkbox","name":"CRA_SEARCH_YN","defaultValue":false,"label":"Search by Registered Agent PID"},{"type":"dateRange","name":"FILING_DATE","label":"Registration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}},{"type":"dateRange","name":"EXPIRATION_DATE","label":"Expiration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}}],"myRecordsFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Active"},{"value":2,"label":"Inactive"},{"value":3,"label":"Pending"}]},{"type":"dateRange","name":"DATE_RANGE","label":"Date range","defaultValue":{"start":null,"end":null}}],"myWorkQueueFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Approved"},{"value":2,"label":"Pending Online Payment"},{"value":3,"label":"Pending Review"},{"value":4,"label":"Needs Correction"},{"value":5,"label":"Rejected"},{"value":6,"label":"Draft"}]},{"type":"dateRange","name":"DATE_RANGE","label":"Date range","defaultValue":{"start":null,"end":null}}]},{"label":"Notary","component":"Notary","parameter":"notary","sourceTypeId":850,"myWorkQueueSearch":false,"allowEmptySearchTerm":true,"requestCertificateAlternateLabel":"Download Certificate","fileAmendmentButtonLabel":"Filing Actions","hideNameRequestCertificate":true,"hideAddressRequestCertificate":true,"hideRecordUserManagment":true,"searchPlaceholder":"Search by name or commission number","searchMustHaveOneOf":["CITY","search","SERVICE_TYPE"],"advancedParametersStartOpen":true,"searchIsSortable":true,"advancedSearchParameters":[{"type":"radio","name":"STARTS_WITH_YN","defaultValue":false,"options":[{"value":true,"label":"Starts with"},{"value":false,"label":"Contains"}]},{"type":"checkbox","name":"ACTIVE_ONLY_YN","defaultValue":true,"label":"Active entities only"},{"type":"text","name":"CITY","defaultValue":"","label":"City"},{"type":"select","name":"SERVICE_TYPE","label":"Special Services Offered","defaultValue":0,"options":[{"value":0,"label":"(N/A)"},{"value":6165,"label":"In-Person Electronic Notarization (IPEN)"},{"value":6166,"label":"Remote Online Notarization (RON)"},{"value":6167,"label":"Mobile Notary Services"},{"value":6168,"label":"Remote Ink Notarization (RIN)"}]}]},{"label":"Apostille","component":"Apostille","parameter":"apostille","sourceTypeId":720,"myRecordsSearch":false,"myWorkQueueSearch":false,"disabled":false,"allowedRoutes":["/forms-manager/","/queue/","/forms/"]},{"label":"Liens","component":"UCC","parameter":"ucc","sourceTypeId":1999,"myRecordsSearch":true,"myWorkQueueSearch":true,"fileAmendmentButtonLabel":"Filing Actions","searchPlaceholder":"Search by name or file number","disabled":false,"serverWebSearchDescription":true,"myRecordsDescription":"","workQueueDescription":"","searchDescription":"","hideRecordUserManagment":true,"searchLiensCheckout":false,"advancedSearchParameters":[{"type":"radio","name":"STARTS_WITH_YN","defaultValue":false,"options":[{"value":true,"label":"Starts with"},{"value":false,"label":"Contains"}]},{"type":"select","name":"STATUS","defaultValue":"ALL","label":"Status","options":[{"value":"ACTIVE_UNLAPSED","label":"Active (unlapsed)"},{"value":"ACTIVE_LAPSED_UNLAPSED","label":"Active (lapsed and unlapsed)"}]},{"type":"text","name":"EXCLUDE_VALUES","label":"Exclude Debtor Names (comma separated list of names to exclude)","defaultValue":""},{"type":"dateRange","name":"FILING_DATE","label":"Financing Statement Date","defaultValue":{"start":null,"end":null}},{"type":"dateRange","name":"LAPSE_DATE","label":"Lapse Date","defaultValue":{"start":null,"end":null}},{"type":"text","name":"CITY","label":"Debtor City","defaultValue":""}],"myRecordsFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Approved"},{"value":2,"label":"Pending Online Payment"},{"value":3,"label":"Pending Review"}]},{"type":"select","name":"TYPE","defaultValue":0,"label":"Lien Type","options":[{"value":0,"label":"All"},{"value":1,"label":"UCC"},{"value":2,"label":"EFS"},{"value":3,"label":"Title 71"}]}],"myWorkQueueFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Approved"},{"value":2,"label":"Pending Online Payment"},{"value":3,"label":"Pending Review"},{"value":4,"label":"Pending Print and Mail"},{"value":5,"label":"Rejected"},{"value":6,"label":"Draft"}]},{"type":"select","name":"TYPE","defaultValue":0,"label":"Lien Type","options":[{"value":0,"label":"All"},{"value":1,"label":"UCC"},{"value":2,"label":"EFS"},{"value":3,"label":"Title 71"}]}]},{"label":"Copy Request","component":"copies","parameter":"copies","sourceTypeId":2001,"myRecordsSearch":false,"myWorkQueueSearch":false,"disabled":false,"allowedRoutes":["/forms-manager/","/queue/","/forms/"]},{"label":"Trademark","component":"Trademark","parameter":"trademark","sourceTypeId":810,"showRequestCertificate":true,"searchMustHaveOneOf":["search","EXPIRATION_DATE","FILING_DATE"],"allowEmptySearchTerm":true,"requestCertificateAlternateLabel":"Request Information","fileAmendmentButtonLabel":"Filing Actions","advancedSearchParameters":[{"type":"radio","name":"QUERY_TYPE_ID","defaultValue":1010,"options":[{"value":1010,"label":"Starts with"},{"value":1011,"label":"Contains"},{"value":1012,"label":" Word Contains"}]},{"type":"checkbox","name":"OWNER_SEARCH_YN","defaultValue":false,"label":"Search owners"},{"type":"radio","name":"SERVICE_MARK_YN","label":"Mark Type","defaultValue":"","options":[{"value":"","label":"All Marks"},{"value":"Y","label":"Service Mark"},{"value":"N","label":"Trademark"}]},{"type":"serverSelect","name":"STATUS_ID","optionsSrc":"TYPE_V|TRADEMARK_STATUS_TYPE","label":"Status","placeholder":"All","defaultValue":"0"},{"type":"select","name":"DESIGN_TYPE_ID","options":[{"value":0,"label":"All"},{"value":990,"label":"Words Only"},{"value":991,"label":"Design Only"},{"value":992,"label":"Words and Design"}],"label":"Design Type","defaultValue":"0"},{"type":"dateRange","name":"FILING_DATE","label":"Registered Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}},{"type":"dateRange","name":"EXPIRATION_DATE","label":"Expiration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}}]},{"label":"Business Info Request","component":"InfoRequests","parameter":"info-request","sourceTypeId":167,"allowedRoutes":["/forms-manager/","/queue/","/forms/"]},{"label":"Data Requests","component":"DataRequests","parameter":"data-request","sourceTypeId":0,"allowedRoutes":["/forms-manager/"]},{"label":"CRA","component":"CRA","parameter":"cra","sourceTypeId":157,"myRecordsSearch":false,"searchPlaceholder":"Search by name or registered agent number","allowedRoutes":["/forms-manager/","/forms/","/records/","/queue/","/search/"],"allowEmptySearchTerm":true,"fileAmendmentButtonLabel":"Filing Actions","advancedSearchParameters":[{"type":"radio","name":"QUERY_TYPE_ID","defaultValue":1010,"options":[{"value":1010,"label":"Starts with"},{"value":1011,"label":"Contains"},{"value":1012,"label":" Word Contains"}]},{"type":"dateRange","name":"CRA_DATE","label":"Registration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}},{"type":"select","name":"STATUS_ID","label":"Status","defaultValue":0,"options":[{"value":0,"label":"All"},{"value":121,"label":"Active"},{"value":122,"label":"Inactive"}]},{"type":"select","name":"AGENT_TYPE_ID","label":"Agent Type","defaultValue":0,"options":[{"value":0,"label":"All"},{"value":460,"label":"Registered Agent"},{"value":461,"label":"Commercial Registered Agent"}]}]},{"label":"Farm Bill","component":"FarmBill","parameter":"farm-bill","path":"/lists/farm-bill","sourceTypeId":0,"myRecordsSearch":false,"allowedRules":["/search/"],"disabled":true,"searchDescription":"To perform a search, enter a debtor name. Your search results may include: exact debtor name, variations of that name and any filing that includes your search criteria. Punctuation is ignored.\n\nYou can click on \"Advanced\" to refine your search. Under “Advanced” you can search by crop, year, county and SSN/FEIN. As a registered Farm Bill Buyer with the Montana Secretary of State’s office it is important to maintain the confidentiality of the information contained within the Farm Bill Master List. The Farm Bill Master List reflects personal data, such as Social Security Numbers, which are a key piece of personal identifiable information to assist you in determining the existence of a lien against a specific debtor. The distribution of this information beyond its intended purpose is strictly prohibited.\n\nThe debtor's tax identification number has been hidden for confidentiality reasons. You may continue to search on a tax ID number and return debtors that match your search criteria. The SSN/FEIN must be entered without dashes or spaces.","searchMustHaveOneOf":["search","UCC_FARM_PRODUCT_ID","COUNTY"],"searchPlaceholder":"Search by debtor name","advancedSearchParameters":[{"type":"ServerMultiComplete","label":"Product code name(s)","name":"UCC_FARM_PRODUCT_ID","defaultValue":"","optionsSrc":"UCC_FARM_PRODUCT_V"},{"type":"MultiComplete","label":"Year or Range of Years","name":"YEAR_NUM","optionsSrc":"years","startYear":"1968","defaultValue":[],"preMergeOptions":[{"value":"ALL","label":"All"}]},{"type":"serverSelect","label":"State","name":"STATE","defaultValue":"MONTANA","optionsSrc":"STATE"},{"type":"ServerMultiComplete","label":"County","name":"COUNTY","defaultValue":[],"optionsSrc":"COUNTY","overrideSubOptionsSrcFromParameterName":"STATE"},{"type":"checkbox","name":"TIN_SEARCH_YN","defaultValue":false,"label":"Tax Identification Number Search"},{"type":"checkbox","name":"TIN_SORT_YN","defaultValue":false,"label":"Unique ID Sort"}]}],"SYSTEM_NICKNAME":"Online Services Portal","PAYMENT_METHODS":[{"type":"bypass"},{"type":"iTransact"}],"PAYMENT_ALLOW_AMEX":true,"SYSTEM_ID_LABEL":"System Id","DOUBLE_COLUMN_PUBLIC_LOGIN":true,"INTERNAL_USER_MANAGEMENT":true,"ALLOW_PUBLIC_JSON_IMPORT":false,"MAX_FILE_UPLOAD_SIZE":10000000,"REFUND_TEXT":"","RETURN_TO_HOME_ON_LOGOUT":true,"CURRENT_SOS_NAME":"Christi Jacobsen","LOGO_FILENAME":"mt-sos-logo.png","LOGO_ALT":"Christi Jacobsen, Montana Secretary of State","LOGO_FULL_WIDTH":true,"HOME_HIDE_AUTH_HINT":true,"HOME_TITLE":"Montana Secretary of State","CUSTOM_TAB_TITLE":"Official Montana","HOME_SUBTITLE":"Online Business Services","ENTITY_NAME_CONSENT_DESCRIPTION":"","ALLOW_USER_PROFILE_EDITING":true,"COMPARE_FOREIGN_NAME_IN_ENTITY_NAME_VALIDATION":true,"FOREIGN_NAME_FIELD_NAME":"KIMA_PARENT_NAME_INFO","LOGIN_TITLE":"Montana Secretary of State Online Filing Portal Login","PUBLIC_LOGIN_LABEL":"Username","REVERSE_LOGIN_COLUMNS":true,"LOGIN_SEAL_FILENAME":"seal_white.png","SEPARATE_USERNAME_AND_EMAIL":true,"CREATE_ACCOUNT_BUTTON_ALIGN_LEFT":true,"CREATE_ACCOUNT_BUTTON_TEXT":"CREATE AN ACCOUNT","PASSWORD_CUSTOM_ERROR_TEXT":"The password must meet all requirements","ACCOUNT_CREATED_MESSAGE":"Please check your email to verify your account to login and allow a few minutes for this message to arrive. Check your junk/spam folders if you do not find the email in your inbox.","PUBLIC_LOGIN_PLACEHOLDER":" ","DISABLE_DEFAULT_PAYMENT_RADIO":true,"CUSTOM_RESET_PASSWORD_ERROR_MESSAGE":"Username invalid - no account found","PUBLIC_LOGIN_CREATE_DESCRIPTION":"### Existing User:\n\n  - Enter your username and password to login.  \n\n\n  #### - OR -  \n\n\n\n  - Forgot password? Click 'Reset Password' and follow the prompts.\n  - Forgot username? Click 'Forgot Username' and follow the prompts.  \n\n\n  ### New User:\n  ","LOGIN_HELP_LINK":"https://sosmt.gov/business/how-do-i/","LOGIN_HELP_LINK_TEXT":"Need Help?","FORGOT_USERNAME_TEXT":"Forgot Username?","LOGIN_ACTIVE_DIRECTORY_TEXT":"State User Login","MULTIPLE_LOGIN_METHODS":true,"HAS_ACTIVE_DIRECTORY_LOGIN":true,"RESET_PASSWORD_WITH_USERNAME":true,"DOWNLOAD_LINK":true,"SHOW_USERNAME_ACCOUNT_CREATE":true,"SHOW_SCROLL_DOWN_ARROW":true,"SHOW_ADDRESS_ACCOUNT_CREATE":true,"TWO_COLUMN_ACCOUNT_CREATE":true,"RESET_PASSWORD_TIP":"A link to change your password has been sent to your email. Please allow a few minutes for this message to arrive. Please check your junk/spam folders if you do not find the email in your inbox.","FORGOT_PASSWORD_LINK_TEXT":"Reset Password","PHONE_NUMBER_OPTIONAL_ACCOUNT_CREATE":true,"SHOW_REQUIRED_INDICATOR_ACCOUNT_CREATE":true,"PASSWORD_REQUIREMENTS_ACCOUNT_CREATE":"\n    <ul>\n      <li>MUST contain at least 8 characters (12+ recommended)</li>\n      <li>MUST contain at least one uppercase letter.</li>\n      <li>MUST contain at least one lowercase letter.</li>\n      <li>MUST contain at least one number.</li>\n      <li>MUST contain at least one special character (!”#$%&'()*+,-./:;<=>?</li>\n    </ul>\n  ","ALLOW_CERTIFICATION_REQUEST":true,"ALLOW_PUBLIC_CERTIFICATE_REQUEST":true,"ALLOW_COPY_REQUEST":false,"ALLOW_CORRECTION_STYLING":true,"HIDE_DEPRECATION_WARNING":false,"AMEND_ROUTE_PUBLIC":true,"SEAL_FILENAME":"seal.png","SHOPPING_CART":true,"ALLOW_PAYMENT_UPDATE_WITH_EMPTY_CART":true,"RA_EMAIL":true,"RA_WEBSITE":true,"RA_NO_DEFAULT_TYPE":true,"RA_ADDRESS_LABEL":"Street Address","RA_TYPE_SELECTION_DEFAULT":true,"RA_DEFAULT_TYPE":"460","RA_OVERRIDE_TYPE_WITH_DEFAULT":true,"RA_PRINCIPAL_ADDRESS_AMS":true,"UPLOAD_AND_SUBMIT_HIDE_IF_ONE_OPTION":true,"PAYMENT_PROCESSING_MESSAGE":"Your payment is processing - Do not close your browser or click the back button","CHECKOUT_BUTTON_WHEN_PROCESSING_TEXT":"Processing","EFS_CROP_PICKER_NONE_LABEL":"Lien Duration","DISALLOWED_WIZARD_PIECES":["FormationLocale"],"REPEATER_SHOW_EDIT_BUTTON":true,"DATA_REQUEST_PAGE_TITLE":"Data Requests and Subscriptions","DATA_REQUEST_SIDEBAR_LABEL":"Data Requests & Subscriptions","LOGIN_REDIRECTS_TO_EPASS":false,"LOGIN_REDIRECTS_TO_ACTIVE_DIRECTORY":true,"LOGIN_ACTIVE_DIRECTORY_LINK":true,"FETCH_EDIT_USER_LINK":false,"LISTS_FETCH_AVAILABLE_LISTS":true,"POST_WIZARD_SUBMIT_REDIRECT_URL":"/","PIN_REQUEST_ATTESTATIONS":true,"PIN_REQUEST_DESCRIPTION":"Click **Request PIN** to have a new PIN sent to the account holder's email address on file.","OWNERSHIP_REQUEST_DESCRIPTION":"To become an **authorized user** of this record, a current **AUTHORIZED USER** will need to grant you access. To request access, click **Request Access** below.","PIN_REQUEST_SUCCESS_MESSAGE":"The PIN you have requested for this entity has been sent to the email associated with your user account.  You should receive the PIN in approximately 3-5 minutes, depending on your email service provider.","APOSTILLE_HEADER_LABEL":"Verification Information","APOSTILLE_NUMBER_LABEL":"Apostille/Authentication","APOSTILLE_CITY_STATE_OVERRIDE":"HELENA, MT","APOSTILLE_FILING_DATE_LABEL":"Issue Date","APOSTILLE_CITY_STATE_IN_CERTIFIED":true,"NOTARY_EXISTING_FILING":true,"ALLOW_REVOKE_OWN_ACCESS_ONLY":false,"HIDE_CANCEL_ON_ONETIME_DATA_REQUESTS":true,"DATA_REQUESTS_IN_SHOPPING_CART":true,"WQ_ALLOW_EDIT_PENDING_PAYMENT":true,"WQ_CONFIRM_ON_DELETE":true,"WQ_DELETE_CONFIRM_MESSAGE":"Deleting this filing will forfeit any money already paid to the Secretary of State. This action is permanent and cannot be undone, are you sure you would like to delete?","PASS_ITEM_GUIDS_ON_CHECKOUT":true,"FORM_REVISION_HISTORY":true,"CHECKOUT_DISCLAIMER":"By entering your credit card and/or checking account information you (i) state that **you are an authorized user** of the credit card and/or electronic check and that the associated information entered (e.g., account holder name, account number, billing address) is accurate, (ii) **you authorize payment processor to charge the amount you have requested** to your credit card and/or funding account, and (iii) **acknowledge if a charge is declined or reversed you may also be assessed a customary charge** by the payment processor for such transactions.","FARM_BILL_SEARCH_CONFIDENTIAL":"As a registered Farm Bill Buyer with the Montana Secretary of State’s office it is important to maintain the confidentiality of the information contained within the Farm Bill Master List. The Farm Bill Master List reflects personal data, such as Social Security Numbers, which are a key piece of personal identifiable information to assist you in determining the existence of a lien against a specific debtor. The distribution of this information beyond its intended purpose is strictly prohibited.\n\n**The debtor's tax identification number has been hidden for confidentiality reasons. You may continue to search on a tax ID number and return debtors that match your search criteria. The SSN/FEIN must be entered without dashes or spaces.  If you need access to the tax identification number to clearly identify the debtor, please contact the UCC unit at (406) 444-3665.**","VIEW_HISTORY_BUTTON_ALT_TEXT":"View Filings","WIZARD_ERROR_TITLE_MESSAGE":"Form Error","FARM_BILL_SEARCH_INTERACTIVE":true,"USE_FARM_BILL_API":true,"DISALLOW_ASSIGN_SELF_AS_RA":true,"DISALLOW_ASSIGN_SELF_AS_PRINCIPAL":true,"USE_TRADEMARK_OWNER_VALIDATION":true,"USE_ALTERNATIVE_FOREIGN_ADDRESS_LABELS":true,"MY_RECEIPTS_FILTER":[{"type":"dateRange","name":"DATE_RANGE","label":"Date range","defaultValue":{"start":null,"end":null}},{"type":"text","name":"REF_NUM","defaultValue":"","label":"Reference Number"},{"type":"text","name":"RECEIPT_NUM","defaultValue":"","label":"Receipt Id"},{"type":"text","name":"AMOUNT","defaultValue":"","label":"Amount"},{"type":"select","name":"TYPE","defaultValue":"","label":"Payment Type","options":[{"value":"","label":"All"},{"value":"CC","label":"Credit Card"},{"value":"Check","label":"Check"}]}],"MY_RECEIPTS_SHOW_IN_SIDEBAR":true,"SHOW_MY_RECEIPTS_HELPER_TEXT":true,"MY_RECEIPTS_HELPER_LABEL":"About Receipt Search","MY_RECEIPTS_HELPER_TEXT":"You can search for receipts based on their descriptions, including the items paid for on the receipt. Use the filters to search for or filter specific information.","FARM_BILL_SUBLINK":{"label":"Farm Bill","component":"FarmBill","parameter":"farm-bill","path":"/lists/farm-bill","sourceTypeId":0,"myRecordsSearch":false,"allowedRules":["/search/"],"disabled":true,"searchDescription":"To perform a search, enter a debtor name. Your search results may include: exact debtor name, variations of that name and any filing that includes your search criteria. Punctuation is ignored.\n\nYou can click on \"Advanced\" to refine your search. Under “Advanced” you can search by crop, year, county and SSN/FEIN. As a registered Farm Bill Buyer with the Montana Secretary of State’s office it is important to maintain the confidentiality of the information contained within the Farm Bill Master List. The Farm Bill Master List reflects personal data, such as Social Security Numbers, which are a key piece of personal identifiable information to assist you in determining the existence of a lien against a specific debtor. The distribution of this information beyond its intended purpose is strictly prohibited.\n\nThe debtor's tax identification number has been hidden for confidentiality reasons. You may continue to search on a tax ID number and return debtors that match your search criteria. The SSN/FEIN must be entered without dashes or spaces.","searchMustHaveOneOf":["search","UCC_FARM_PRODUCT_ID","COUNTY"],"searchPlaceholder":"Search by debtor name","advancedSearchParameters":[{"type":"ServerMultiComplete","label":"Product code name(s)","name":"UCC_FARM_PRODUCT_ID","defaultValue":"","optionsSrc":"UCC_FARM_PRODUCT_V"},{"type":"MultiComplete","label":"Year or Range of Years","name":"YEAR_NUM","optionsSrc":"years","startYear":"1968","defaultValue":[],"preMergeOptions":[{"value":"ALL","label":"All"}]},{"type":"serverSelect","label":"State","name":"STATE","defaultValue":"MONTANA","optionsSrc":"STATE"},{"type":"ServerMultiComplete","label":"County","name":"COUNTY","defaultValue":[],"optionsSrc":"COUNTY","overrideSubOptionsSrcFromParameterName":"STATE"},{"type":"checkbox","name":"TIN_SEARCH_YN","defaultValue":false,"label":"Tax Identification Number Search"},{"type":"checkbox","name":"TIN_SORT_YN","defaultValue":false,"label":"Unique ID Sort"}]},"ALLOW_ADDRESS_VALIDATION_BYPASS_OPTION":true,"DEFAULT_ADDRESS_VALIDATION_BYPASS_OPTION_CHECKED":true}).HIDE_REGISTERED_AGENT_LIST && _react2.default.createElement(
	          ListWrapper,
	          { title: 'Registered Agents' },
	          _react2.default.createElement(
	            'ul',
	            null,
	             false ? _react2.default.createElement(
	              'div',
	              null,
	              _react2.default.createElement(
	                'li',
	                null,
	                _react2.default.createElement(
	                  'a',
	                  { href: _requests.BASE_URL + '/api/report/FromActiveReport/0/RARecentlyAppointed/0' },
	                  'Recently Appointed Registered Agents'
	                )
	              )
	            ) : _react2.default.createElement(
	              'li',
	              null,
	              _react2.default.createElement(
	                'a',
	                { href: _requests.BASE_URL + '/api/report/FromActiveReport/0/Agents/0' },
	                'List of Commercial Registered Agents'
	              )
	            )
	          )
	        ),
	        !this.state.loading ? this.state.listGroups.map(function (group, i) {
	          return _react2.default.createElement(
	            ListWrapper,
	            { title: group.label, key: i },
	            _react2.default.createElement(
	              'ul',
	              null,
	              group.lists.map(function (list, k) {
	                return _react2.default.createElement(
	                  'li',
	                  { key: k },
	                  _react2.default.createElement(
	                    _reactRouterDom.Link,
	                    { to: list.path },
	                    list.label
	                  )
	                );
	              })
	            )
	          );
	        }) : null,
	         false ? _react2.default.createElement(
	          ListWrapper,
	          { title: 'Lobbyists' },
	          _react2.default.createElement(
	            'ul',
	            null,
	            Array(5).fill(0).map(function (_, i) {
	              return _react2.default.createElement(
	                'li',
	                { key: i },
	                _react2.default.createElement(
	                  _reactRouterDom.Link,
	                  { to: 'lists/lobbyist?year=' + (CURRENT_YEAR - 5 + i) },
	                  'List of Registered Lobbyists ',
	                  CURRENT_YEAR - 5 + i,
	                  '-',
	                  CURRENT_YEAR - 4 + i
	                )
	              );
	            })
	          )
	        ) : null
	      );
	    }
	  }]);
	
	  return Lists;
	}(_react.Component);
	
	exports.default = Lists;
	
	
	var ListWrapper = function ListWrapper(_ref2) {
	  var title = _ref2.title,
	      children = _ref2.children;
	  return _react2.default.createElement(
	    'div',
	    { className: 'list-wrapper' },
	    _react2.default.createElement(
	      'h2',
	      null,
	      title
	    ),
	    children
	  );
	};

/***/ },
/* 1110 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(162);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Shell = __webpack_require__(19);
	
	var _requests = __webpack_require__(6);
	
	var api = _interopRequireWildcard(_requests);
	
	var _WizardClasses = __webpack_require__(35);
	
	var _x2js = __webpack_require__(155);
	
	var _x2js2 = _interopRequireDefault(_x2js);
	
	var _Field = __webpack_require__(25);
	
	var _Form = __webpack_require__(14);
	
	var _DesignerActions = __webpack_require__(44);
	
	var _store = __webpack_require__(18);
	
	var _store2 = _interopRequireDefault(_store);
	
	__webpack_require__(1449);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var convert = new _x2js2.default();
	
	var Migrate = function (_Component) {
	  _inherits(Migrate, _Component);
	
	  function Migrate() {
	    var _this2 = this;
	
	    _classCallCheck(this, Migrate);
	
	    var _this = _possibleConstructorReturn(this, (Migrate.__proto__ || Object.getPrototypeOf(Migrate)).call(this));
	
	    _this.startMigration = _asyncToGenerator(_regenerator2.default.mark(function _callee() {
	      return _regenerator2.default.wrap(function _callee$(_context) {
	        while (1) {
	          switch (_context.prev = _context.next) {
	            case 0:
	              _context.next = 2;
	              return new Promise(function (resolve) {
	                api.GET_ALL_WIZARDS(null, function (response) {
	                  // console.log(response)
	                  var wizards = {};
	                  response.forEach(function (wizard) {
	                    wizards[wizard.FORM_DEFINITION_ID] = wizard;
	                  });
	                  _this.setState({ wizards: wizards }, function () {
	                    resolve();
	                  });
	                });
	              });
	
	            case 2:
	              _context.next = 4;
	              return _this.replaceDefinitionJson();
	
	            case 4:
	              _context.next = 6;
	              return _this.saveNewDefinitions();
	
	            case 6:
	            case 'end':
	              return _context.stop();
	          }
	        }
	      }, _callee, _this2);
	    }));
	
	    _this.replaceDefinitionJson = function () {
	      return new Promise(function (resolve) {
	        console.log('Started replacing json');
	        var wizards = Object.assign({}, _this.state.wizards);
	        // console.log(this.state.wizards)
	        Object.keys(_this.state.wizards).forEach(function (formDefinitionId) {
	          var wizard = Object.assign({}, _this.state.wizards[formDefinitionId]);
	          // this.setState({ currentWizard: wizard.TITLE });
	          console.log(wizard.TITLE);
	          var parsed = (0, _WizardClasses.CreateInstancesFromJson)(JSON.parse(wizard.STEPS_JSON));
	          var metadata = _this.resolveMetadataStructure(wizard.METADATA);
	          wizard.METADATA = convert.js2xml(metadata);
	          wizard.STEPS_JSON = JSON.stringify(parsed);
	          wizards[formDefinitionId] = wizard;
	        });
	        _this.setState(function (state) {
	          return {
	            wizards: wizards
	          };
	        }, function () {
	          resolve();
	        });
	      });
	    };
	
	    _this.resolveMetadataStructure = function (METADATA) {
	      if (METADATA) {
	        var metadata = convert.xml2js(METADATA);
	        return _this.recursivelyRemoveMetadataTags(metadata);
	      } else {
	        return '';
	      }
	    };
	
	    _this.recursivelyRemoveMetadataTags = function (metadata) {
	      if (metadata.METADATA !== undefined) {
	        return _this.recursivelyRemoveMetadataTags(metadata.METADATA);
	      } else {
	        return metadata;
	      }
	    };
	
	    _this.saveNewDefinitions = function () {
	      var promises = Object.keys(_this.state.wizards).map(function (formDefinitionId) {
	        return new Promise(function (resolve) {
	          api.SAVE_WIZARD(_this.state.wizards[formDefinitionId], function (id) {
	            _this.setState({ currentWizard: _this.state.wizards[formDefinitionId].TITLE });
	            resolve(id);
	          });
	        });
	      });
	      Promise.all(promises).then(function () {
	        _this.setState({
	          finished: true
	        });
	      });
	    };
	
	    _this.setCategoryId = function (e) {
	      _this.setState({
	        categoryId: e.target.value,
	        categoryAdded: false
	      });
	    };
	
	    _this.addFormCategory = function () {
	      api.GET_APP_SETTING_BY_NAME('FORM_MANAGER_STRUCTURE', function (setting) {
	        var structure = JSON.parse(setting.VALUE);
	        // console.log(structure);
	        var newStructure = Object.assign({}, structure, {
	          categories: Object.assign({}, structure.categories, _defineProperty({}, _this.state.categoryId, {})),
	          categoriesOrder: Object.assign({}, structure.categoriesOrder, _defineProperty({}, _this.state.categoryId, []))
	          // console.log(newStructure);
	        });api.UPDATE_APP_SETTING_BY_ID(setting.APP_SETTING_ID, {
	          NAME: 'FORM_MANAGER_STRUCTURE',
	          VALUE: JSON.stringify(newStructure),
	          CATEGORY: 'ADMIN',
	          DESCR: ''
	        }, function (data) {
	          _this.setState({
	            categoryAdded: true
	          });
	        });
	      });
	    };
	
	    _this.state = {
	      wizards: null,
	      currentWizard: '',
	      finished: false,
	      categoryId: '',
	      categoryAdded: false
	    };
	    return _this;
	  }
	
	  _createClass(Migrate, [{
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        _Shell.Body,
	        { className: 'wizard migration-page' },
	        _react2.default.createElement(
	          'div',
	          { style: rowStyle, className: 'section' },
	          _react2.default.createElement(
	            'h3',
	            { style: labelStyle },
	            'Download and self-clean all wizards'
	          ),
	          _react2.default.createElement(
	            'button',
	            { className: 'btn btn-primary btn-raised', onClick: this.startMigration },
	            'Start Migration'
	          ),
	          this.state.finished ? _react2.default.createElement(
	            'p',
	            { style: { color: 'rgb(41, 187, 11)', fontStyle: 'italic' } },
	            'Finished'
	          ) : _react2.default.createElement(
	            'p',
	            null,
	            'Currently Migrating: ' + this.state.currentWizard
	          )
	        ),
	        _react2.default.createElement('hr', null),
	        _react2.default.createElement(StepTemplateSection, null)
	      );
	    }
	  }]);
	
	  return Migrate;
	}(_react.Component);
	
	exports.default = Migrate;
	
	
	var rowStyle = {
	  display: 'flex',
	  flexDirection: 'column',
	  alignItems: 'flex-start',
	  padding: '10px 0px'
	};
	
	var labelStyle = { fontWeight: 800, fontSize: 18 };
	
	var StepTemplateSection = function StepTemplateSection() {
	  var _React$useState = _react2.default.useState({}),
	      _React$useState2 = _slicedToArray(_React$useState, 2),
	      wizards = _React$useState2[0],
	      setWizards = _React$useState2[1];
	
	  var _React$useState3 = _react2.default.useState(''),
	      _React$useState4 = _slicedToArray(_React$useState3, 2),
	      selectedWizard = _React$useState4[0],
	      setSelectedWizard = _React$useState4[1];
	
	  var _React$useState5 = _react2.default.useState(''),
	      _React$useState6 = _slicedToArray(_React$useState5, 2),
	      selectedStep = _React$useState6[0],
	      setSelectedStep = _React$useState6[1];
	
	  var _React$useState7 = _react2.default.useState(null),
	      _React$useState8 = _slicedToArray(_React$useState7, 2),
	      migrationStarted = _React$useState8[0],
	      setMigrationStarted = _React$useState8[1];
	
	  var _React$useState9 = _react2.default.useState(null),
	      _React$useState10 = _slicedToArray(_React$useState9, 2),
	      migrationSucceeded = _React$useState10[0],
	      setMigrationSucceeded = _React$useState10[1];
	
	  var _React$useState11 = _react2.default.useState({}),
	      _React$useState12 = _slicedToArray(_React$useState11, 2),
	      selectedWizards = _React$useState12[0],
	      setSelectedWizards = _React$useState12[1];
	
	  _react2.default.useEffect(function () {
	    api.GET_ALL_WIZARDS(null, function (response) {
	      // console.log(response)
	      var wizards = response.reduce(function (wizards, wizard) {
	        wizards[wizard.FORM_DEFINITION_ID] = Object.assign({}, wizard, {
	          STEPS_JSON: JSON.parse(wizard.STEPS_JSON)
	        });
	        return wizards;
	      }, {});
	      setWizards(wizards);
	    }, function (err) {
	      console.error(err);
	    });
	  }, []);
	
	  var hasLoaded = Object.keys(wizards).length;
	
	  var wizardOptions = _react2.default.useMemo(function () {
	    return Object.values(wizards).filter(function (opt) {
	      var wizard = opt.STEPS_JSON;
	      return Object.values(wizard.steps).some(function (step) {
	        return !!step.templateId;
	      });
	    }).map(function (wizard) {
	      return {
	        value: wizard.FORM_DEFINITION_ID,
	        label: wizard.TITLE
	      };
	    });
	  }, [wizards]);
	
	  var stepOptions = _react2.default.useMemo(function () {
	    return selectedWizard ? Object.values(wizards[selectedWizard].STEPS_JSON.steps).filter(function (step) {
	      return step.templateId;
	    }).map(function (step) {
	      return {
	        value: step.stepId,
	        label: step.templateId + ' | ' + step.title
	      };
	    }) : [];
	  }, [selectedWizard, wizards]);
	
	  var wizardsToMigrate = _react2.default.useMemo(function () {
	    if (!selectedWizard || !selectedStep) {
	      return [];
	    }
	    var templateId = wizards[selectedWizard].STEPS_JSON.steps[selectedStep].templateId;
	    return Object.values(wizards).filter(function (wizard) {
	      return wizard.FORM_DEFINITION_ID.toString() !== selectedWizard;
	    }).filter(function (wizard) {
	      return Object.values(wizard.STEPS_JSON.steps).some(function (step) {
	        return step.templateId === templateId;
	      });
	    });
	  }, [wizards, selectedWizard, selectedStep]);
	
	  var selectAllWizards = function selectAllWizards(wizards) {
	    setSelectedWizards(wizards.reduce(function (obj, wizard) {
	      obj[wizard.FORM_DEFINITION_ID] = true;
	      return obj;
	    }, {}));
	  };
	
	  var deselectAllWizards = function deselectAllWizards() {
	    setSelectedWizards({});
	  };
	
	  _react2.default.useEffect(function () {
	    selectAllWizards(wizardsToMigrate);
	  }, [wizardsToMigrate]);
	
	  var startMigration = function startMigration() {
	    setMigrationStarted(true);
	    var donorWizard = (0, _WizardClasses.CreateInstancesFromJson)(wizards[selectedWizard].STEPS_JSON);
	    var templateId = donorWizard.steps[selectedStep].templateId;
	    _store2.default.dispatch((0, _DesignerActions.populateDesigner)(wizards[selectedWizard], donorWizard));
	    _store2.default.dispatch({
	      type: 'COPY_STEP_CONTENTS',
	      stepId: selectedStep,
	      preserveFieldIds: true
	    });
	    var promises = wizardsToMigrate.filter(function (wizard) {
	      return selectedWizards[wizard.FORM_DEFINITION_ID];
	    }).map(function (wizard) {
	      var parsedWizard = (0, _WizardClasses.CreateInstancesFromJson)(wizard.STEPS_JSON);
	      _store2.default.dispatch((0, _DesignerActions.populateDesigner)(wizard, parsedWizard));
	      var targetStepId = Object.values(parsedWizard.steps).find(function (step) {
	        return step.templateId === templateId;
	      }).stepId;
	      _store2.default.dispatch({
	        type: 'PASTE_STEP_CONTENTS',
	        stepId: targetStepId
	      });
	      var extractedWizard = _store2.default.getState().designer.wizard;
	      var migratedWizard = Object.assign({}, wizard, {
	        STEPS_JSON: JSON.stringify({
	          stepOrder: extractedWizard.stepOrder,
	          steps: extractedWizard.steps,
	          sections: extractedWizard.sections,
	          fields: extractedWizard.fields
	        })
	      });
	      return new Promise(function (resolve, reject) {
	        api.SAVE_WIZARD(migratedWizard, resolve, reject);
	      });
	    });
	    Promise.all(promises).then(function () {
	      setMigrationSucceeded(true);
	    });
	  };
	
	  return _react2.default.createElement(
	    'div',
	    {
	      className: 'section',
	      style: Object.assign({}, rowStyle, { opacity: hasLoaded ? 1 : 0.2, pointerEvents: hasLoaded ? '' : 'none' })
	    },
	    !hasLoaded ? _react2.default.createElement(
	      'span',
	      null,
	      'Loading...'
	    ) : null,
	    _react2.default.createElement(
	      'h3',
	      { style: labelStyle },
	      'Update all wizard step templates'
	    ),
	    _react2.default.createElement(
	      'p',
	      { className: 'description' },
	      'Use this tool to migrate a chosen template step for all wizards. Select a wizard to copy from, and a template step, and this tool will find all wizards with the same template id and replace their contents with the contents of the selected step. Please do not use this tool unless you understand exactly what it will do.'
	    ),
	    _react2.default.createElement(
	      'p',
	      { className: 'description' },
	      'Here are some general guidlines for using this tool successfully:'
	    ),
	    _react2.default.createElement(
	      'ul',
	      null,
	      _react2.default.createElement(
	        'li',
	        null,
	        'Backup the form defintions before starting the migration as a precaution.'
	      ),
	      _react2.default.createElement(
	        'li',
	        null,
	        'Step template IDs may only be used ',
	        _react2.default.createElement(
	          'strong',
	          null,
	          'ONCE'
	        ),
	        ' per wizard.'
	      ),
	      _react2.default.createElement(
	        'li',
	        null,
	        'Ensure that the logic and conditions of fields in the step you will be copying from, are all self-contained. Meaning, they do not reference any fields outside of the step they are in. Non-self-contained logic will still be copied, but will need to be manually updated with references to the external fields.'
	      ),
	      _react2.default.createElement(
	        'li',
	        null,
	        'This migration occurs in your browser. ',
	        _react2.default.createElement(
	          'strong',
	          null,
	          'Do not'
	        ),
	        ' close your browser window until the migration is completed.'
	      ),
	      _react2.default.createElement(
	        'li',
	        null,
	        'Avoid overusing this tool for bulk copy/paste actions. Used correctly this tool can speed up migrating wizard steps significantly, but there\'s a high surface-area for potential bugs and errors. While the tool is not known to be unstable, it is advised to only use it when it will save significant amounts of time.'
	      ),
	      _react2.default.createElement(
	        'li',
	        null,
	        'Note that this migration will add a new entry in the version history for each affected wizard.'
	      ),
	      _react2.default.createElement(
	        'li',
	        null,
	        'May God have mercy on your soul.'
	      )
	    ),
	    _react2.default.createElement(
	      _Field.DumbField,
	      { label: 'Pick a wizard from which to copy' },
	      _react2.default.createElement(_Form.Select, {
	        options: [{ value: '', label: '[Pick a Wizard]' }].concat(_toConsumableArray(wizardOptions)),
	        value: selectedWizard,
	        onChange: function onChange(value) {
	          setSelectedWizard(value);
	          setSelectedStep('');
	          setSelectedWizards({});
	        }
	      })
	    ),
	    _react2.default.createElement(
	      _Field.DumbField,
	      { label: 'Pick a template step from which to copy' },
	      _react2.default.createElement(_Form.Select, {
	        options: [{ value: '', label: '[Pick a Template Step]' }].concat(_toConsumableArray(stepOptions)),
	        value: selectedStep,
	        onChange: function onChange(value) {
	          return setSelectedStep(value);
	        },
	        disabled: !selectedWizard
	      })
	    ),
	    selectedWizard && selectedStep ? _react2.default.createElement(
	      _react2.default.Fragment,
	      null,
	      _react2.default.createElement(
	        'h4',
	        null,
	        'Select which wizards will be affected by this migration:'
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'flex-row' },
	        _react2.default.createElement(
	          'button',
	          {
	            onClick: function onClick() {
	              return selectAllWizards(wizardsToMigrate);
	            },
	            className: 'btn btn-primary btn-raised',
	            style: { marginRight: 10 }
	          },
	          'Select All'
	        ),
	        _react2.default.createElement(
	          'button',
	          { onClick: deselectAllWizards, className: 'btn btn-primary btn-raised' },
	          'Select None'
	        )
	      ),
	      _react2.default.createElement(
	        'ul',
	        null,
	        wizardsToMigrate.map(function (wiz, i) {
	          return _react2.default.createElement(
	            'li',
	            { key: i },
	            _react2.default.createElement('input', {
	              type: 'checkbox',
	              style: { verticalAlign: 'text-top', display: 'inline-block', marginRight: 10 },
	              value: !!selectedWizards[wiz.FORM_DEFINITION_ID],
	              checked: !!selectedWizards[wiz.FORM_DEFINITION_ID],
	              onChange: function onChange(e) {
	                var selected = e.target.checked;
	                setSelectedWizards(function (s) {
	                  return Object.assign({}, s, _defineProperty({}, wiz.FORM_DEFINITION_ID, selected));
	                });
	              }
	            }),
	            wiz.FORM_DEFINITION_ID,
	            ' - ',
	            wiz.TITLE
	          );
	        })
	      )
	    ) : null,
	    selectedWizard && selectedStep ? _react2.default.createElement(
	      'p',
	      { className: 'danger-text' },
	      'Warning: This action is ',
	      _react2.default.createElement(
	        'u',
	        null,
	        'permanent'
	      ),
	      ' and potentially destructive. It is highly advised that you ',
	      _react2.default.createElement(
	        'u',
	        null,
	        'backup all form definitions'
	      ),
	      ' before starting this migration. While the migration is running ',
	      _react2.default.createElement(
	        'u',
	        null,
	        'do not close your browser window'
	      ),
	      '.'
	    ) : null,
	    _react2.default.createElement(
	      'button',
	      {
	        className: 'btn btn-danger btn-raised',
	        disabled: !selectedWizard || !selectedStep,
	        onClick: startMigration
	      },
	      'Start Migration'
	    ),
	    migrationStarted && migrationSucceeded ? _react2.default.createElement(
	      'p',
	      null,
	      'Migration completed successfully'
	    ) : null,
	    migrationStarted && migrationSucceeded === null ? _react2.default.createElement(
	      'p',
	      null,
	      'Migration running, ',
	      _react2.default.createElement(
	        'strong',
	        null,
	        'do not close this browser window'
	      )
	    ) : null
	  );
	};

/***/ },
/* 1111 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	__webpack_require__(1451);
	
	var _MyReceiptsActions = __webpack_require__(459);
	
	var _reactRedux = __webpack_require__(7);
	
	var _Loaders = __webpack_require__(16);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var MyReceiptDetails = function (_Component) {
	  _inherits(MyReceiptDetails, _Component);
	
	  function MyReceiptDetails() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, MyReceiptDetails);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = MyReceiptDetails.__proto__ || Object.getPrototypeOf(MyReceiptDetails)).call.apply(_ref, [this].concat(args))), _this), _this.renderDetailList = function (detailList) {
	      if (_this.props.myReceiptDetailsLoading) {
	        return _react2.default.createElement(
	          'div',
	          { className: 'reports-spinner animated fadeIn' },
	          _react2.default.createElement(_Loaders.Spinner, { size: 'medium', themeColor: 'secondary' })
	        );
	      }
	
	      if (_this.props.myReceiptDetailError && _this.props.myReceiptDetailErrorMessage.message) {
	        return _react2.default.createElement(
	          'p',
	          { className: 'error-message', 'aria-live': 'polite' },
	          _this.props.myReceiptDetailErrorMessage.message,
	          ' Please try reloading.'
	        );
	      }
	
	      return detailList.map(function (element, index) {
	        return _react2.default.createElement(
	          _react2.default.Fragment,
	          { key: index },
	          _react2.default.createElement('div', { className: 'receipt-details-divider' }),
	          _react2.default.createElement(
	            'table',
	            null,
	            _react2.default.createElement(
	              'tbody',
	              null,
	              element.map(function (detailItem, index) {
	                if (detailItem.LABEL == 'Charge') {
	                  detailItem.VALUE = parseFloat(detailItem.VALUE).toFixed(2);
	                }
	                return _react2.default.createElement(
	                  'tr',
	                  { className: 'receipt-detail', key: Math.random() + index },
	                  _react2.default.createElement(
	                    'td',
	                    { className: 'receipt-label' },
	                    detailItem.LABEL
	                  ),
	                  _react2.default.createElement(
	                    'td',
	                    { className: 'receipt-value' },
	                    detailItem.VALUE
	                  )
	                );
	              })
	            )
	          ),
	          _react2.default.createElement('div', { className: 'receipt-details-divider' })
	        );
	      });
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(MyReceiptDetails, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      if (!this.props.selectedReceipt) {
	        (0, _MyReceiptsActions.setReceiptsError)({ message: 'Could not find selected receipt item.', code: null });
	        return;
	      }
	
	      if (this.props.selectedReceipt) {
	        this.getDetails(this.props.selectedReceipt);
	      }
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate(prevProps) {
	      if (!this.props.selectedReceipt) return;
	
	      try {
	        if (prevProps.selectedReceipt.REF_NUM != this.props.selectedReceipt.REF_NUM) {
	          this.getDetails(this.props.selectedReceipt);
	        }
	      } catch (error) {
	        (0, _MyReceiptsActions.setReceiptsError)({ message: 'Could not find selected receipt item.', code: null });
	        return;
	      }
	    }
	  }, {
	    key: 'getDetails',
	    value: function getDetails(selectedReceipt) {
	      if (selectedReceipt) {
	        this.props.pullAndSetReceiptDetails(selectedReceipt.RECEIPT_ID);
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var myReceiptDetails = this.props.myReceiptDetails;
	
	      return _react2.default.createElement(
	        _react2.default.Fragment,
	        null,
	        _react2.default.createElement(
	          'div',
	          { className: 'receipt-details-list' },
	          _react2.default.createElement(
	            'h5',
	            null,
	            'Receipt Items'
	          ),
	          this.renderDetailList(myReceiptDetails)
	        )
	      );
	    }
	  }]);
	
	  return MyReceiptDetails;
	}(_react.Component);
	
	MyReceiptDetails = (0, _reactRedux.connect)(function (state, props) {
	  return {
	    myReceiptDetails: state.myReceipts.myReceiptDetails,
	    myReceiptDetailsLoading: state.myReceipts.myReceiptDetailsLoading,
	    myReceiptDetailError: state.myReceipts.myReceiptDetailError,
	    myReceiptDetailErrorMessage: state.myReceipts.myReceiptDetailErrorMessage
	  };
	}, {
	  pullAndSetReceiptDetails: _MyReceiptsActions.pullAndSetReceiptDetails
	})(MyReceiptDetails);
	
	exports.default = MyReceiptDetails;

/***/ },
/* 1112 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(7);
	
	var _orderBy = __webpack_require__(103);
	
	var _orderBy2 = _interopRequireDefault(_orderBy);
	
	var _MyReceiptsActions = __webpack_require__(459);
	
	var _Shell = __webpack_require__(19);
	
	var _PageError = __webpack_require__(301);
	
	var _Table = __webpack_require__(150);
	
	var _Table2 = _interopRequireDefault(_Table);
	
	var _TableControls = __webpack_require__(303);
	
	var _TableControls2 = _interopRequireDefault(_TableControls);
	
	var _EmptyBox = __webpack_require__(197);
	
	var _EmptyBox2 = _interopRequireDefault(_EmptyBox);
	
	var _ReportDownload = __webpack_require__(1114);
	
	var _ReportDownload2 = _interopRequireDefault(_ReportDownload);
	
	var _NotFound = __webpack_require__(464);
	
	var _NotFound2 = _interopRequireDefault(_NotFound);
	
	var _MyReceiptDetails = __webpack_require__(1111);
	
	var _MyReceiptDetails2 = _interopRequireDefault(_MyReceiptDetails);
	
	var _lodash = __webpack_require__(1264);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var MyReceipts = function (_Component) {
	  _inherits(MyReceipts, _Component);
	
	  function MyReceipts() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, MyReceipts);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = MyReceipts.__proto__ || Object.getPrototypeOf(MyReceipts)).call.apply(_ref, [this].concat(args))), _this), _this.getRecords = function () {
	      _this.props.pullAndSetMyReceipts(_this.props.match.params.subParam);
	    }, _this.debounced = _lodash2.default.debounce(function () {
	      _this.getRecords();
	    }, 700), _this.setFilters = function (filters) {
	      var props = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	      _this.props.setFilters('myReceipts', filters);
	      _this.debounced();
	    }, _this.selectRow = function (row) {
	      if (_this.props.selectedId === row.RECEIPT_ID) {
	        return;
	      } else if (_this.props.selectedId) {
	        _this.clearSelection();
	      } else {
	        _this.props.selectMyReceiptsRowAndGetDetails(_this.props.selectedId === row.RECEIPT_ID ? null : row.RECEIPT_ID, row);
	      }
	    }, _this.clearSelection = function () {
	      _this.props.selectMyReceiptsRowAndGetDetails(null, null);
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(MyReceipts, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.getRecords();
	    }
	  }, {
	    key: 'renderEmptyResults',
	    value: function renderEmptyResults() {
	      return _react2.default.createElement(
	        'div',
	        { className: 'empty-placeholder-wrapper' },
	        _react2.default.createElement(_EmptyBox2.default, null),
	        _react2.default.createElement(
	          'h3',
	          null,
	          'No Receipts Found.'
	        ),
	        _react2.default.createElement('div', { className: 'flex-row center' })
	      );
	    }
	  }, {
	    key: 'renderPageData',
	    value: function renderPageData(props) {
	      var _this2 = this;
	
	      if (!_lodash2.default.isEmpty(props.rows)) {
	        var rows = (0, _orderBy2.default)(Object.keys(props.rows).map(function (rowId) {
	          return props.rows[rowId];
	        }), 'REF_NUM', 'desc');
	        rows.forEach(function (row, index) {
	          if (Number.isInteger(row.AMOUNT)) {
	            row.AMOUNT = parseInt(row.AMOUNT, 10).toFixed(2);
	          }
	        });
	
	        return _react2.default.createElement(_Table2.default, {
	          rows: rows,
	          template: props.template,
	          className: 'center-container',
	          onCellClick: this.selectRow,
	          selectedRowIndex: rows ? rows.findIndex(function (row) {
	            return row.RECEIPT_ID === _this2.props.selectedId;
	          }) : false,
	          animated: false,
	          rowCount: true
	        });
	      } else if (!props.loading) {
	        if (props.error) {
	          return _react2.default.createElement(_PageError.PageError, { errorDetails: props.errorDetails });
	        }
	
	        return this.renderEmptyResults();
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          selectedId = _props.selectedId,
	          selectedReceipt = _props.selectedReceipt,
	          showSelected = _props.showSelected,
	          filters = _props.filters,
	          loading = _props.loading;
	
	
	      var activeFilter = filters.myReceipts || {
	        SEARCH: '',
	        DATE_RANGE: { start: null, end: null },
	        REF_NUM: '',
	        RECEIPT_NUM: '',
	        DESCRIPTION: '',
	        AMOUNT: '',
	        TYPE: ''
	      };
	
	      var filterTemplate = ([{"type":"dateRange","name":"DATE_RANGE","label":"Date range","defaultValue":{"start":null,"end":null}},{"type":"text","name":"REF_NUM","defaultValue":"","label":"Reference Number"},{"type":"text","name":"RECEIPT_NUM","defaultValue":"","label":"Receipt Id"},{"type":"text","name":"AMOUNT","defaultValue":"","label":"Amount"},{"type":"select","name":"TYPE","defaultValue":"","label":"Payment Type","options":[{"value":"","label":"All"},{"value":"CC","label":"Credit Card"},{"value":"Check","label":"Check"}]}]);
	      var showHelpText = (true);
	      var helpLabel = ("About Receipt Search");
	      var helpText = ("You can search for receipts based on their descriptions, including the items paid for on the receipt. Use the filters to search for or filter specific information.");
	
	      return _react2.default.createElement(
	        _Shell.Body,
	        {
	          className: 'my-records',
	          showDrawer: showSelected,
	          onResize: this.onBodyResize,
	          hiddenTitle: 'My Records'
	        },
	         true ? _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement(_TableControls2.default, {
	            title: 'My Receipts',
	            filterTemplates: filterTemplate,
	            filters: activeFilter,
	            allowSearch: true,
	            onFilterChange: this.setFilters,
	            loading: loading,
	            showHelpText: showHelpText ? true : false,
	            helpLabel: helpLabel ? helpLabel : '',
	            helpText: helpText ? helpText : ''
	          }),
	          this.renderPageData(this.props),
	          _react2.default.createElement(
	            _Shell.Drawer,
	            {
	              title: 'Receipt Details',
	              showCloseButton: true,
	              show: selectedId ? true : false,
	              onSidebarDismiss: this.clearSelection
	            },
	            _react2.default.createElement(_ReportDownload2.default, {
	              id: selectedId,
	              formDefinitionId: selectedReceipt ? selectedReceipt.FORM_DEFINITION_ID : -1,
	              selectedReceipt: selectedReceipt
	            }),
	            _react2.default.createElement(_MyReceiptDetails2.default, { selectedReceipt: selectedReceipt })
	          )
	        ) : _react2.default.createElement(_NotFound2.default, null)
	      );
	    }
	  }]);
	
	  return MyReceipts;
	}(_react.Component);
	
	MyReceipts = (0, _reactRedux.connect)(function (state, props) {
	  return {
	    rows: state.myReceipts.rows,
	    template: state.myReceipts.template,
	    loading: state.myReceipts.loading,
	    selectedId: state.myReceipts.selected[props.match.params.subParam],
	    showSelected: state.myReceipts.showSelected,
	    selectedReceipt: state.myReceipts.selectedReceipt,
	    filters: state.myReceipts.filters,
	    error: state.myReceipts.error,
	    errorDetails: state.myReceipts.errorDetails,
	    awaitFilter: 800
	  };
	}, {
	  pullAndSetMyReceipts: _MyReceiptsActions.pullAndSetMyReceipts,
	  setFilters: _MyReceiptsActions.setFilters,
	  selectMyReceiptsRowAndGetDetails: _MyReceiptsActions.selectMyReceiptsRowAndGetDetails
	})(MyReceipts);
	
	exports.default = MyReceipts;

/***/ },
/* 1113 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _FilterUtilities = __webpack_require__(289);
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var initialState = {
	  activeCategory: null,
	  error: false,
	  errorDetails: {
	    message: null,
	    code: null
	  },
	  filters: (0, _FilterUtilities.getFiltersByLocalStorageKey)('MY_RECEIPTS_FILTERS'),
	  lastRequestId: null,
	  loading: false,
	  receiptDetailsLoading: false,
	  results: null,
	  resultsMode: 'table',
	  selected: {},
	  selectedReceipt: null,
	  selectedOwnershipReceipts: [],
	  selectedReceiptHasOwners: null,
	  showSelected: false,
	  templates: {},
	  userOwnsSelectedReceipt: null,
	  myReceiptDetails: [],
	  myReceiptDetailError: false,
	  myReceiptDetailErrorMessage: {
	    message: null,
	    code: null
	  }
	};
	var MyReceiptsReducer = function MyReceiptsReducer() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	  var action = arguments[1];
	
	  switch (action.type) {
	    case '@@mrcpt/RESET_STATE':
	      return initialState;
	    case '@@mrcpt/INVALIDATE_CACHE':
	      return Object.assign({}, state, {
	        results: null,
	        selected: {},
	        selectedReceipt: null,
	        showSelected: false
	      });
	    case '@@mrcpt/SET_ACTIVE_CATEGORY':
	      return Object.assign({}, state, {
	        activeCategory: action.category
	      });
	    case 'SET_MY_RECEIPTS':
	      return Object.assign({}, state, {
	        rows: action.rows,
	        template: action.template
	      });
	    case 'SELECT_MY_RECEIPTS_ROW':
	      return Object.assign({}, state, {
	        selected: Object.assign({}, state.selected, _defineProperty({}, action.category, action.selected)),
	        selectedReceipt: action.row,
	        showSelected: state.selected[action.category] !== action.selected && action.selected !== null ? true : !state.showSelected
	      });
	    case 'SELECT_MY_RECEIPT_RECORD':
	      return Object.assign({}, state, { selected: action.selected });
	    case 'SET_MY_RECEIPTS_RESULTS_MODE':
	      return Object.assign({}, state, { resultsMode: action.mode });
	    case 'SET_MY_RECEIPTS_SELECTED_OWNERSHIP_RECEIPTS':
	      return Object.assign({}, state, {
	        selectedOwnershipReceipts: action.selectedOwnershipReceipts
	      });
	    case 'SET_RECEIPT_DETAILS_LOADING':
	      return Object.assign({}, state, { receiptDetailsLoading: action.loading });
	    case 'SET_USER_OWNS_SELECTED_RECEIPT':
	      return Object.assign({}, state, { userOwnsSelectedReceipt: action.isOwner });
	    case 'SET_SELECTED_RECEIPT_HAS_OWNERS':
	      return Object.assign({}, state, { selectedReceiptHasOwners: action.hasOwners });
	    case '@@mrcpt/SET_FILTERS':
	      return Object.assign({}, state, {
	        filters: Object.assign({}, state.filters, _defineProperty({}, action.category, action.filters))
	      });
	    case 'SET_MY_RECEIPTS_LOADING':
	      return Object.assign({}, state, {
	        loading: action.loading
	      });
	    case 'SET_MY_RECEIPT_DETAIL_LOADING':
	      return Object.assign({}, state, {
	        myReceiptDetailsLoading: action.loading
	      });
	    case 'SET_MY_RECEIPTS_ERROR':
	      return Object.assign({}, state, {
	        error: action.error
	      });
	    case 'SET_MY_RECEIPTS_ERROR_DETAILS':
	      return Object.assign({}, state, {
	        errorDetails: action.errorDetails
	      });
	    case '@@mrcpt/SET_REQUEST_ID':
	      return Object.assign({}, state, { lastRequestId: action.requestId });
	    case 'SET_MY_RECEIPT_DETAILS':
	      return Object.assign({}, state, {
	        myReceiptDetails: action.details
	      });
	    case 'SET_MY_RECEIPT_DETAIL_ERROR':
	      return Object.assign({}, state, {
	        myReceiptDetailError: action.error
	      });
	    case 'SET_MY_RECEIPT_DETAIL_ERROR_MESSAGE':
	      return Object.assign({}, state, {
	        myReceiptDetailErrorMessage: action.errorDetail
	      });
	    default:
	      return state;
	  }
	};
	
	exports.default = MyReceiptsReducer;

/***/ },
/* 1114 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(162);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _utilities = __webpack_require__(8);
	
	var _requests = __webpack_require__(6);
	
	var _FileDownloader = __webpack_require__(147);
	
	var _FileDownloader2 = _interopRequireDefault(_FileDownloader);
	
	var _downloadBox = __webpack_require__(219);
	
	var _downloadBox2 = _interopRequireDefault(_downloadBox);
	
	var _Loaders = __webpack_require__(16);
	
	__webpack_require__(1452);
	
	var _shortid = __webpack_require__(22);
	
	var _shortid2 = _interopRequireDefault(_shortid);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ReportsDownload = function (_React$Component) {
	  _inherits(ReportsDownload, _React$Component);
	
	  function ReportsDownload() {
	    var _this2 = this;
	
	    _classCallCheck(this, ReportsDownload);
	
	    var _this = _possibleConstructorReturn(this, (ReportsDownload.__proto__ || Object.getPrototypeOf(ReportsDownload)).call(this));
	
	    _this.componentDidMount = _asyncToGenerator(_regenerator2.default.mark(function _callee() {
	      return _regenerator2.default.wrap(function _callee$(_context) {
	        while (1) {
	          switch (_context.prev = _context.next) {
	            case 0:
	              if (_this.props.selectedReceipt) {
	                _this.getFormDefinition();
	                _this.setState(Object.assign({}, _this.state, {
	                  downloading: false,
	                  oldValue: _this.props.selectedReceipt.REF_NUM,
	                  loading: true,
	                  formDefinitionId: null,
	                  isMounted: true
	                }));
	              }
	
	            case 1:
	            case 'end':
	              return _context.stop();
	          }
	        }
	      }, _callee, _this2);
	    }));
	
	    _this.componentDidUpdate = function (prevProps) {
	      if (!_this.props.selectedReceipt || _this.state.oldValue == !_this.props.selectedReceipt.REF_NUM || !_this.state.isMounted) {
	        return;
	      }
	
	      try {
	        if (prevProps.selectedReceipt.REF_NUM != _this.props.selectedReceipt.REF_NUM) {
	          _this.setState(Object.assign({}, _this.state, {
	            downloading: false,
	            loading: true
	          }));
	          _this.getFormDefinition();
	        }
	      } catch (error) {
	        _this.setState({ emptyResult: true });
	        console.log(error);
	      }
	    };
	
	    _this.componentWillUnmount = function () {
	      _this.setState({ isMounted: false });
	    };
	
	    _this.getFormDefinition = function () {
	      _this.setState(Object.assign({}, _this.state, { loading: true }));
	      var reportDetailRequest = {
	        RECEIPT_ITEM_ID: _this.props.selectedReceipt.RECEIPT_ITEM_ID,
	        SOURCE_TYPE_ID: _this.props.selectedReceipt.SOURCE_TYPE_ID
	      };
	      var requestId = _shortid2.default.generate();
	      try {
	        (0, _requests.GET_MY_RECEIPT_REPORT_DETAILS)(requestId, reportDetailRequest, function (formDefinition) {
	          if (!_this.state.isMounted) {
	            return;
	          }
	
	          if (typeof formDefinition == 'string') {
	            _this.setState(Object.assign({}, _this.state, {
	              formDefinitionId: formDefinition
	            }));
	            _this.getReports();
	          } else {
	            _this.setState(Object.assign({}, _this.state, { emptyResult: true, loading: false }));
	          }
	        });
	      } catch (error) {
	        _this.setState(Object.assign({}, _this.state, { emptyResult: true, loading: false }));
	      }
	    };
	
	    _this.getReports = function () {
	      // this.setState({ loading: true })
	      if (_this.state.formDefinitionId) {
	        (0, _requests.GET_REPORTS)(_this.state.formDefinitionId, _this.props.selectedReceipt.RECORD_NUM, function (reports) {
	          if (!_this.state.isMounted || !reports) {
	            return;
	          }
	
	          var receiptReport = reports.filter(function (obj) {
	            return obj.REPORT_NAME == 'Receipt';
	          });
	
	          _this.setState({
	            reports: !reports || !Array.isArray(reports) ? [] : reports,
	            downloadError: false,
	            emptyResult: receiptReport.length >= 1 ? false : true,
	            loading: false
	          });
	        });
	      } else {
	        _this.setState(Object.assign({}, _this.state, {
	          emptyResult: true,
	          downloadError: false,
	          reports: [],
	          loading: false,
	          oldValue: null
	        }));
	      }
	    };
	
	    _this.getDownload = function () {
	      if (_this.state.reports.length < 1) {
	        _this.setState(Object.assign({}, _this.state, { downloadError: true }));
	        return;
	      }
	
	      _this.setState({ downloading: true, downloadError: false, fresh: false });
	
	      var receiptReport = _this.state.reports.filter(function (obj) {
	        return obj.REPORT_NAME == 'Receipt';
	      });
	      (0, _requests.GET_REPORT_BY_REPORT_OBJECT)(receiptReport[0], function (res) {
	        if (!_this.state.isMounted) {
	          return;
	        }
	        if (res.ok) {
	          if (receiptReport[0].RETURN_TYPE === 'URL') {
	            res.text().then(function (url) {
	              _this.setState({
	                blob: url,
	                downloading: false,
	                downloadError: false
	              }, function () {
	                _this.downloader.download();
	              });
	            });
	          } else if (_this.downloader != null) {
	            res.blob().then(function (blob) {
	              var blobObject = window.URL.createObjectURL(blob);
	              _this.setState({ blob: blobObject, rawBlob: blob, downloading: false, downloadError: false }, function () {
	                _this.downloader.download();
	              });
	            });
	          } else {
	            _this.setState({ downloadError: true, downloading: false });
	          }
	        } else {
	          _this.setState({ downloadError: true, downloading: false });
	        }
	      }, function (err) {
	        _this.setState({ downloadError: true, downloading: false });
	      });
	    };
	
	    _this.state = {
	      loading: true,
	      blob: null,
	      downloading: false,
	      fresh: false,
	      oldValue: null,
	      rawBlob: null,
	      downloadError: false,
	      emptyResult: false,
	      reportDetails: null,
	      reports: null,
	      recordNum: null,
	      formDefinitionId: null,
	      isMounted: false
	    };
	    return _this;
	  }
	
	  _createClass(ReportsDownload, [{
	    key: 'render',
	    value: function render() {
	      var _this3 = this;
	
	      var _props = this.props,
	          animated = _props.animated,
	          delay = _props.delay,
	          selectedReceipt = _props.selectedReceipt;
	
	      var DOWNLOAD_ERROR = 'Something went wrong while downloading this file. Try again later.';
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'report-download' },
	        _react2.default.createElement(
	          'h5',
	          null,
	          'Available Downloads'
	        ),
	        this.state.loading === true ? _react2.default.createElement(
	          'div',
	          { className: 'reports-spinner animated fadeIn' },
	          _react2.default.createElement(_Loaders.Spinner, { size: 'medium', themeColor: 'secondary' })
	        ) : this.state.emptyResult == false && this.state.loading === false ? _react2.default.createElement(
	          'button',
	          {
	            className: 'report ' + (animated !== false ? 'animated fadeInUp extra-fast-animation' : '') + ' ' + (this.state.downloadError ? 'error' : ''),
	            style: { animationDelay: delay + 'ms' },
	            onClick: this.state.downloading ? _utilities.noop : this.getDownload
	          },
	          _react2.default.createElement(
	            'div',
	            { className: 'download-icon' },
	            this.state.downloading && _react2.default.createElement('div', { className: 'shine-spinner' }),
	            _react2.default.createElement(_downloadBox2.default, {
	              className: 'icon ' + (this.state.fresh ? '' : this.state.downloading ? 'spin-out' : 'spin-in')
	            })
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'labels' },
	            _react2.default.createElement(
	              'p',
	              {
	                style: { opacity: this.state.downloadError ? 1 : 0 },
	                className: 'download-error',
	                'aria-hidden': true
	              },
	              DOWNLOAD_ERROR
	            ),
	            _react2.default.createElement(
	              'span',
	              null,
	              'Download Receipt ' + (selectedReceipt ? '' + selectedReceipt.REF_NUM : '')
	            )
	          ),
	          _react2.default.createElement(_FileDownloader2.default, {
	            ref: function ref(downloader) {
	              _this3.downloader = downloader;
	            },
	            href: this.state.blob,
	            blob: this.state.rawBlob,
	            fileName: (selectedReceipt ? 'Receipt_' + selectedReceipt.REF_NUM : '') + '.pdf',
	            overrideFileName: true
	          })
	        ) : _react2.default.createElement(
	          'p',
	          { className: 'error-message', 'aria-live': 'polite' },
	          'No receipt document available for download.'
	        )
	      );
	    }
	  }]);
	
	  return ReportsDownload;
	}(_react2.default.Component);
	
	exports.default = ReportsDownload;

/***/ },
/* 1115 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(7);
	
	var _reactRouterDom = __webpack_require__(30);
	
	var _Table = __webpack_require__(150);
	
	var _Table2 = _interopRequireDefault(_Table);
	
	var _TableControls = __webpack_require__(303);
	
	var _TableControls2 = _interopRequireDefault(_TableControls);
	
	var _document = __webpack_require__(126);
	
	var _document2 = _interopRequireDefault(_document);
	
	var _Shell = __webpack_require__(19);
	
	var _Loaders = __webpack_require__(16);
	
	var _PageError = __webpack_require__(301);
	
	var _MyRecordsActions = __webpack_require__(461);
	
	var _utilities = __webpack_require__(8);
	
	var _RecordDrawer = __webpack_require__(465);
	
	var _RecordDrawer2 = _interopRequireDefault(_RecordDrawer);
	
	var _EmptyBox = __webpack_require__(197);
	
	var _EmptyBox2 = _interopRequireDefault(_EmptyBox);
	
	__webpack_require__(1453);
	
	var _App = __webpack_require__(118);
	
	var _requests = __webpack_require__(6);
	
	var api = _interopRequireWildcard(_requests);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var MY_RECORDS_DISABLE_EMPTY_STATE = ({"NODE_ENV":"production","BUILD_DATE":"2025-08-27T15:15:31.687Z","BUILD_NUMBER":"Not Provided","GIT_VERSION":"v1.3.0-381-ga81e29b08","GIT_COMMIT_HASH":"a81e29b085c9268ffd96c78eb734365802722741","GIT_BRANCH":"beta","PUBLIC_URL":"","STATE_ABBR":"MT","STATE_NAME":"Montana","STATE_ORG_TITLE":"Secretary of State","LOGIN_HEADER_IMG_PATH":"","HOME_IMG_FILENAME":"montana.jpg","FAVICON_FILE_NAME":"favicon.ico","ALLOW_E_SIGN_ON_CORRECTIONS":true,"THIRD_PARTY_SIGNING_ALLOWED":false,"MY_ACCOUNT_SAVE_AND_CLOSE_BUTTON":true,"IE_DEPRECATED_MESSAGE":"Internet Explorer is not supported. Please select a supported browser below to access this website.","ADDITIONAL_ROUTES":{"dataRequests":true,"farmBill":true,"apostille":true,"externalHelp":"https://sosmt.gov/business/help-center/","systemAdministration":[{"title":"Saved Payments","parameter":"saved-payments","componentName":"SavedPayments"}]},"SUBROUTES":[{"label":"Business","component":"Business","parameter":"business","myWorkQueueSearch":false,"sourceTypeId":54,"searchMustHaveOneOf":["FILING_TYPE_ID","STATUS_ID","STATE","search"],"serverWebSearchDescription":true,"serverWorkQueueDescription":true,"serverMyRecordsDescription":true,"searchPlaceholder":"Search by name or filing number (X########)","allowEmptySearchTerm":true,"requestCertificateAlternateLabel":"Request Information","fileAmendmentButtonLabel":"Filing Actions","advancedSearchParameters":[{"type":"radio","name":"QUERY_TYPE_ID","defaultValue":1010,"options":[{"value":1010,"label":"Starts with"},{"value":1011,"label":"Contains"},{"value":1012,"label":" Word Contains"}]},{"type":"serverSelect","name":"FILING_TYPE_ID","optionsSrc":"FILING_TYPES","label":"Entity Type","placeholder":"All","defaultValue":"0"},{"type":"serverSelect","name":"FILING_SUBTYPE_ID","optionsSrc":"FILING_SUBTYPES","label":"Entity Subtype","overrideSubOptionsSrcFromParameterName":"FILING_TYPE_ID","placeholder":"All","defaultValue":"0"},{"type":"serverSelect","name":"STATUS_ID","optionsSrc":"FILING_STATUS_WITHOUT_ALL","label":"Status","placeholder":"All","defaultValue":"0"},{"type":"serverSelect","name":"STATE","optionsSrc":"STATE","label":"State","placeholder":"All","defaultValue":""},{"type":"serverSelect","name":"COUNTY","optionsSrc":"COUNTY_SUBOPTION","label":"County","overrideSubOptionsSrcFromParameterName":"STATE","placeholder":"All","defaultValue":""},{"type":"checkbox","name":"CRA_SEARCH_YN","defaultValue":false,"label":"Search by Registered Agent PID"},{"type":"dateRange","name":"FILING_DATE","label":"Registration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}},{"type":"dateRange","name":"EXPIRATION_DATE","label":"Expiration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}}],"myRecordsFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Active"},{"value":2,"label":"Inactive"},{"value":3,"label":"Pending"}]},{"type":"dateRange","name":"DATE_RANGE","label":"Date range","defaultValue":{"start":null,"end":null}}],"myWorkQueueFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Approved"},{"value":2,"label":"Pending Online Payment"},{"value":3,"label":"Pending Review"},{"value":4,"label":"Needs Correction"},{"value":5,"label":"Rejected"},{"value":6,"label":"Draft"}]},{"type":"dateRange","name":"DATE_RANGE","label":"Date range","defaultValue":{"start":null,"end":null}}]},{"label":"Notary","component":"Notary","parameter":"notary","sourceTypeId":850,"myWorkQueueSearch":false,"allowEmptySearchTerm":true,"requestCertificateAlternateLabel":"Download Certificate","fileAmendmentButtonLabel":"Filing Actions","hideNameRequestCertificate":true,"hideAddressRequestCertificate":true,"hideRecordUserManagment":true,"searchPlaceholder":"Search by name or commission number","searchMustHaveOneOf":["CITY","search","SERVICE_TYPE"],"advancedParametersStartOpen":true,"searchIsSortable":true,"advancedSearchParameters":[{"type":"radio","name":"STARTS_WITH_YN","defaultValue":false,"options":[{"value":true,"label":"Starts with"},{"value":false,"label":"Contains"}]},{"type":"checkbox","name":"ACTIVE_ONLY_YN","defaultValue":true,"label":"Active entities only"},{"type":"text","name":"CITY","defaultValue":"","label":"City"},{"type":"select","name":"SERVICE_TYPE","label":"Special Services Offered","defaultValue":0,"options":[{"value":0,"label":"(N/A)"},{"value":6165,"label":"In-Person Electronic Notarization (IPEN)"},{"value":6166,"label":"Remote Online Notarization (RON)"},{"value":6167,"label":"Mobile Notary Services"},{"value":6168,"label":"Remote Ink Notarization (RIN)"}]}]},{"label":"Apostille","component":"Apostille","parameter":"apostille","sourceTypeId":720,"myRecordsSearch":false,"myWorkQueueSearch":false,"disabled":false,"allowedRoutes":["/forms-manager/","/queue/","/forms/"]},{"label":"Liens","component":"UCC","parameter":"ucc","sourceTypeId":1999,"myRecordsSearch":true,"myWorkQueueSearch":true,"fileAmendmentButtonLabel":"Filing Actions","searchPlaceholder":"Search by name or file number","disabled":false,"serverWebSearchDescription":true,"myRecordsDescription":"","workQueueDescription":"","searchDescription":"","hideRecordUserManagment":true,"searchLiensCheckout":false,"advancedSearchParameters":[{"type":"radio","name":"STARTS_WITH_YN","defaultValue":false,"options":[{"value":true,"label":"Starts with"},{"value":false,"label":"Contains"}]},{"type":"select","name":"STATUS","defaultValue":"ALL","label":"Status","options":[{"value":"ACTIVE_UNLAPSED","label":"Active (unlapsed)"},{"value":"ACTIVE_LAPSED_UNLAPSED","label":"Active (lapsed and unlapsed)"}]},{"type":"text","name":"EXCLUDE_VALUES","label":"Exclude Debtor Names (comma separated list of names to exclude)","defaultValue":""},{"type":"dateRange","name":"FILING_DATE","label":"Financing Statement Date","defaultValue":{"start":null,"end":null}},{"type":"dateRange","name":"LAPSE_DATE","label":"Lapse Date","defaultValue":{"start":null,"end":null}},{"type":"text","name":"CITY","label":"Debtor City","defaultValue":""}],"myRecordsFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Approved"},{"value":2,"label":"Pending Online Payment"},{"value":3,"label":"Pending Review"}]},{"type":"select","name":"TYPE","defaultValue":0,"label":"Lien Type","options":[{"value":0,"label":"All"},{"value":1,"label":"UCC"},{"value":2,"label":"EFS"},{"value":3,"label":"Title 71"}]}],"myWorkQueueFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Approved"},{"value":2,"label":"Pending Online Payment"},{"value":3,"label":"Pending Review"},{"value":4,"label":"Pending Print and Mail"},{"value":5,"label":"Rejected"},{"value":6,"label":"Draft"}]},{"type":"select","name":"TYPE","defaultValue":0,"label":"Lien Type","options":[{"value":0,"label":"All"},{"value":1,"label":"UCC"},{"value":2,"label":"EFS"},{"value":3,"label":"Title 71"}]}]},{"label":"Copy Request","component":"copies","parameter":"copies","sourceTypeId":2001,"myRecordsSearch":false,"myWorkQueueSearch":false,"disabled":false,"allowedRoutes":["/forms-manager/","/queue/","/forms/"]},{"label":"Trademark","component":"Trademark","parameter":"trademark","sourceTypeId":810,"showRequestCertificate":true,"searchMustHaveOneOf":["search","EXPIRATION_DATE","FILING_DATE"],"allowEmptySearchTerm":true,"requestCertificateAlternateLabel":"Request Information","fileAmendmentButtonLabel":"Filing Actions","advancedSearchParameters":[{"type":"radio","name":"QUERY_TYPE_ID","defaultValue":1010,"options":[{"value":1010,"label":"Starts with"},{"value":1011,"label":"Contains"},{"value":1012,"label":" Word Contains"}]},{"type":"checkbox","name":"OWNER_SEARCH_YN","defaultValue":false,"label":"Search owners"},{"type":"radio","name":"SERVICE_MARK_YN","label":"Mark Type","defaultValue":"","options":[{"value":"","label":"All Marks"},{"value":"Y","label":"Service Mark"},{"value":"N","label":"Trademark"}]},{"type":"serverSelect","name":"STATUS_ID","optionsSrc":"TYPE_V|TRADEMARK_STATUS_TYPE","label":"Status","placeholder":"All","defaultValue":"0"},{"type":"select","name":"DESIGN_TYPE_ID","options":[{"value":0,"label":"All"},{"value":990,"label":"Words Only"},{"value":991,"label":"Design Only"},{"value":992,"label":"Words and Design"}],"label":"Design Type","defaultValue":"0"},{"type":"dateRange","name":"FILING_DATE","label":"Registered Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}},{"type":"dateRange","name":"EXPIRATION_DATE","label":"Expiration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}}]},{"label":"Business Info Request","component":"InfoRequests","parameter":"info-request","sourceTypeId":167,"allowedRoutes":["/forms-manager/","/queue/","/forms/"]},{"label":"Data Requests","component":"DataRequests","parameter":"data-request","sourceTypeId":0,"allowedRoutes":["/forms-manager/"]},{"label":"CRA","component":"CRA","parameter":"cra","sourceTypeId":157,"myRecordsSearch":false,"searchPlaceholder":"Search by name or registered agent number","allowedRoutes":["/forms-manager/","/forms/","/records/","/queue/","/search/"],"allowEmptySearchTerm":true,"fileAmendmentButtonLabel":"Filing Actions","advancedSearchParameters":[{"type":"radio","name":"QUERY_TYPE_ID","defaultValue":1010,"options":[{"value":1010,"label":"Starts with"},{"value":1011,"label":"Contains"},{"value":1012,"label":" Word Contains"}]},{"type":"dateRange","name":"CRA_DATE","label":"Registration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}},{"type":"select","name":"STATUS_ID","label":"Status","defaultValue":0,"options":[{"value":0,"label":"All"},{"value":121,"label":"Active"},{"value":122,"label":"Inactive"}]},{"type":"select","name":"AGENT_TYPE_ID","label":"Agent Type","defaultValue":0,"options":[{"value":0,"label":"All"},{"value":460,"label":"Registered Agent"},{"value":461,"label":"Commercial Registered Agent"}]}]},{"label":"Farm Bill","component":"FarmBill","parameter":"farm-bill","path":"/lists/farm-bill","sourceTypeId":0,"myRecordsSearch":false,"allowedRules":["/search/"],"disabled":true,"searchDescription":"To perform a search, enter a debtor name. Your search results may include: exact debtor name, variations of that name and any filing that includes your search criteria. Punctuation is ignored.\n\nYou can click on \"Advanced\" to refine your search. Under “Advanced” you can search by crop, year, county and SSN/FEIN. As a registered Farm Bill Buyer with the Montana Secretary of State’s office it is important to maintain the confidentiality of the information contained within the Farm Bill Master List. The Farm Bill Master List reflects personal data, such as Social Security Numbers, which are a key piece of personal identifiable information to assist you in determining the existence of a lien against a specific debtor. The distribution of this information beyond its intended purpose is strictly prohibited.\n\nThe debtor's tax identification number has been hidden for confidentiality reasons. You may continue to search on a tax ID number and return debtors that match your search criteria. The SSN/FEIN must be entered without dashes or spaces.","searchMustHaveOneOf":["search","UCC_FARM_PRODUCT_ID","COUNTY"],"searchPlaceholder":"Search by debtor name","advancedSearchParameters":[{"type":"ServerMultiComplete","label":"Product code name(s)","name":"UCC_FARM_PRODUCT_ID","defaultValue":"","optionsSrc":"UCC_FARM_PRODUCT_V"},{"type":"MultiComplete","label":"Year or Range of Years","name":"YEAR_NUM","optionsSrc":"years","startYear":"1968","defaultValue":[],"preMergeOptions":[{"value":"ALL","label":"All"}]},{"type":"serverSelect","label":"State","name":"STATE","defaultValue":"MONTANA","optionsSrc":"STATE"},{"type":"ServerMultiComplete","label":"County","name":"COUNTY","defaultValue":[],"optionsSrc":"COUNTY","overrideSubOptionsSrcFromParameterName":"STATE"},{"type":"checkbox","name":"TIN_SEARCH_YN","defaultValue":false,"label":"Tax Identification Number Search"},{"type":"checkbox","name":"TIN_SORT_YN","defaultValue":false,"label":"Unique ID Sort"}]}],"SYSTEM_NICKNAME":"Online Services Portal","PAYMENT_METHODS":[{"type":"bypass"},{"type":"iTransact"}],"PAYMENT_ALLOW_AMEX":true,"SYSTEM_ID_LABEL":"System Id","DOUBLE_COLUMN_PUBLIC_LOGIN":true,"INTERNAL_USER_MANAGEMENT":true,"ALLOW_PUBLIC_JSON_IMPORT":false,"MAX_FILE_UPLOAD_SIZE":10000000,"REFUND_TEXT":"","RETURN_TO_HOME_ON_LOGOUT":true,"CURRENT_SOS_NAME":"Christi Jacobsen","LOGO_FILENAME":"mt-sos-logo.png","LOGO_ALT":"Christi Jacobsen, Montana Secretary of State","LOGO_FULL_WIDTH":true,"HOME_HIDE_AUTH_HINT":true,"HOME_TITLE":"Montana Secretary of State","CUSTOM_TAB_TITLE":"Official Montana","HOME_SUBTITLE":"Online Business Services","ENTITY_NAME_CONSENT_DESCRIPTION":"","ALLOW_USER_PROFILE_EDITING":true,"COMPARE_FOREIGN_NAME_IN_ENTITY_NAME_VALIDATION":true,"FOREIGN_NAME_FIELD_NAME":"KIMA_PARENT_NAME_INFO","LOGIN_TITLE":"Montana Secretary of State Online Filing Portal Login","PUBLIC_LOGIN_LABEL":"Username","REVERSE_LOGIN_COLUMNS":true,"LOGIN_SEAL_FILENAME":"seal_white.png","SEPARATE_USERNAME_AND_EMAIL":true,"CREATE_ACCOUNT_BUTTON_ALIGN_LEFT":true,"CREATE_ACCOUNT_BUTTON_TEXT":"CREATE AN ACCOUNT","PASSWORD_CUSTOM_ERROR_TEXT":"The password must meet all requirements","ACCOUNT_CREATED_MESSAGE":"Please check your email to verify your account to login and allow a few minutes for this message to arrive. Check your junk/spam folders if you do not find the email in your inbox.","PUBLIC_LOGIN_PLACEHOLDER":" ","DISABLE_DEFAULT_PAYMENT_RADIO":true,"CUSTOM_RESET_PASSWORD_ERROR_MESSAGE":"Username invalid - no account found","PUBLIC_LOGIN_CREATE_DESCRIPTION":"### Existing User:\n\n  - Enter your username and password to login.  \n\n\n  #### - OR -  \n\n\n\n  - Forgot password? Click 'Reset Password' and follow the prompts.\n  - Forgot username? Click 'Forgot Username' and follow the prompts.  \n\n\n  ### New User:\n  ","LOGIN_HELP_LINK":"https://sosmt.gov/business/how-do-i/","LOGIN_HELP_LINK_TEXT":"Need Help?","FORGOT_USERNAME_TEXT":"Forgot Username?","LOGIN_ACTIVE_DIRECTORY_TEXT":"State User Login","MULTIPLE_LOGIN_METHODS":true,"HAS_ACTIVE_DIRECTORY_LOGIN":true,"RESET_PASSWORD_WITH_USERNAME":true,"DOWNLOAD_LINK":true,"SHOW_USERNAME_ACCOUNT_CREATE":true,"SHOW_SCROLL_DOWN_ARROW":true,"SHOW_ADDRESS_ACCOUNT_CREATE":true,"TWO_COLUMN_ACCOUNT_CREATE":true,"RESET_PASSWORD_TIP":"A link to change your password has been sent to your email. Please allow a few minutes for this message to arrive. Please check your junk/spam folders if you do not find the email in your inbox.","FORGOT_PASSWORD_LINK_TEXT":"Reset Password","PHONE_NUMBER_OPTIONAL_ACCOUNT_CREATE":true,"SHOW_REQUIRED_INDICATOR_ACCOUNT_CREATE":true,"PASSWORD_REQUIREMENTS_ACCOUNT_CREATE":"\n    <ul>\n      <li>MUST contain at least 8 characters (12+ recommended)</li>\n      <li>MUST contain at least one uppercase letter.</li>\n      <li>MUST contain at least one lowercase letter.</li>\n      <li>MUST contain at least one number.</li>\n      <li>MUST contain at least one special character (!”#$%&'()*+,-./:;<=>?</li>\n    </ul>\n  ","ALLOW_CERTIFICATION_REQUEST":true,"ALLOW_PUBLIC_CERTIFICATE_REQUEST":true,"ALLOW_COPY_REQUEST":false,"ALLOW_CORRECTION_STYLING":true,"HIDE_DEPRECATION_WARNING":false,"AMEND_ROUTE_PUBLIC":true,"SEAL_FILENAME":"seal.png","SHOPPING_CART":true,"ALLOW_PAYMENT_UPDATE_WITH_EMPTY_CART":true,"RA_EMAIL":true,"RA_WEBSITE":true,"RA_NO_DEFAULT_TYPE":true,"RA_ADDRESS_LABEL":"Street Address","RA_TYPE_SELECTION_DEFAULT":true,"RA_DEFAULT_TYPE":"460","RA_OVERRIDE_TYPE_WITH_DEFAULT":true,"RA_PRINCIPAL_ADDRESS_AMS":true,"UPLOAD_AND_SUBMIT_HIDE_IF_ONE_OPTION":true,"PAYMENT_PROCESSING_MESSAGE":"Your payment is processing - Do not close your browser or click the back button","CHECKOUT_BUTTON_WHEN_PROCESSING_TEXT":"Processing","EFS_CROP_PICKER_NONE_LABEL":"Lien Duration","DISALLOWED_WIZARD_PIECES":["FormationLocale"],"REPEATER_SHOW_EDIT_BUTTON":true,"DATA_REQUEST_PAGE_TITLE":"Data Requests and Subscriptions","DATA_REQUEST_SIDEBAR_LABEL":"Data Requests & Subscriptions","LOGIN_REDIRECTS_TO_EPASS":false,"LOGIN_REDIRECTS_TO_ACTIVE_DIRECTORY":true,"LOGIN_ACTIVE_DIRECTORY_LINK":true,"FETCH_EDIT_USER_LINK":false,"LISTS_FETCH_AVAILABLE_LISTS":true,"POST_WIZARD_SUBMIT_REDIRECT_URL":"/","PIN_REQUEST_ATTESTATIONS":true,"PIN_REQUEST_DESCRIPTION":"Click **Request PIN** to have a new PIN sent to the account holder's email address on file.","OWNERSHIP_REQUEST_DESCRIPTION":"To become an **authorized user** of this record, a current **AUTHORIZED USER** will need to grant you access. To request access, click **Request Access** below.","PIN_REQUEST_SUCCESS_MESSAGE":"The PIN you have requested for this entity has been sent to the email associated with your user account.  You should receive the PIN in approximately 3-5 minutes, depending on your email service provider.","APOSTILLE_HEADER_LABEL":"Verification Information","APOSTILLE_NUMBER_LABEL":"Apostille/Authentication","APOSTILLE_CITY_STATE_OVERRIDE":"HELENA, MT","APOSTILLE_FILING_DATE_LABEL":"Issue Date","APOSTILLE_CITY_STATE_IN_CERTIFIED":true,"NOTARY_EXISTING_FILING":true,"ALLOW_REVOKE_OWN_ACCESS_ONLY":false,"HIDE_CANCEL_ON_ONETIME_DATA_REQUESTS":true,"DATA_REQUESTS_IN_SHOPPING_CART":true,"WQ_ALLOW_EDIT_PENDING_PAYMENT":true,"WQ_CONFIRM_ON_DELETE":true,"WQ_DELETE_CONFIRM_MESSAGE":"Deleting this filing will forfeit any money already paid to the Secretary of State. This action is permanent and cannot be undone, are you sure you would like to delete?","PASS_ITEM_GUIDS_ON_CHECKOUT":true,"FORM_REVISION_HISTORY":true,"CHECKOUT_DISCLAIMER":"By entering your credit card and/or checking account information you (i) state that **you are an authorized user** of the credit card and/or electronic check and that the associated information entered (e.g., account holder name, account number, billing address) is accurate, (ii) **you authorize payment processor to charge the amount you have requested** to your credit card and/or funding account, and (iii) **acknowledge if a charge is declined or reversed you may also be assessed a customary charge** by the payment processor for such transactions.","FARM_BILL_SEARCH_CONFIDENTIAL":"As a registered Farm Bill Buyer with the Montana Secretary of State’s office it is important to maintain the confidentiality of the information contained within the Farm Bill Master List. The Farm Bill Master List reflects personal data, such as Social Security Numbers, which are a key piece of personal identifiable information to assist you in determining the existence of a lien against a specific debtor. The distribution of this information beyond its intended purpose is strictly prohibited.\n\n**The debtor's tax identification number has been hidden for confidentiality reasons. You may continue to search on a tax ID number and return debtors that match your search criteria. The SSN/FEIN must be entered without dashes or spaces.  If you need access to the tax identification number to clearly identify the debtor, please contact the UCC unit at (406) 444-3665.**","VIEW_HISTORY_BUTTON_ALT_TEXT":"View Filings","WIZARD_ERROR_TITLE_MESSAGE":"Form Error","FARM_BILL_SEARCH_INTERACTIVE":true,"USE_FARM_BILL_API":true,"DISALLOW_ASSIGN_SELF_AS_RA":true,"DISALLOW_ASSIGN_SELF_AS_PRINCIPAL":true,"USE_TRADEMARK_OWNER_VALIDATION":true,"USE_ALTERNATIVE_FOREIGN_ADDRESS_LABELS":true,"MY_RECEIPTS_FILTER":[{"type":"dateRange","name":"DATE_RANGE","label":"Date range","defaultValue":{"start":null,"end":null}},{"type":"text","name":"REF_NUM","defaultValue":"","label":"Reference Number"},{"type":"text","name":"RECEIPT_NUM","defaultValue":"","label":"Receipt Id"},{"type":"text","name":"AMOUNT","defaultValue":"","label":"Amount"},{"type":"select","name":"TYPE","defaultValue":"","label":"Payment Type","options":[{"value":"","label":"All"},{"value":"CC","label":"Credit Card"},{"value":"Check","label":"Check"}]}],"MY_RECEIPTS_SHOW_IN_SIDEBAR":true,"SHOW_MY_RECEIPTS_HELPER_TEXT":true,"MY_RECEIPTS_HELPER_LABEL":"About Receipt Search","MY_RECEIPTS_HELPER_TEXT":"You can search for receipts based on their descriptions, including the items paid for on the receipt. Use the filters to search for or filter specific information.","FARM_BILL_SUBLINK":{"label":"Farm Bill","component":"FarmBill","parameter":"farm-bill","path":"/lists/farm-bill","sourceTypeId":0,"myRecordsSearch":false,"allowedRules":["/search/"],"disabled":true,"searchDescription":"To perform a search, enter a debtor name. Your search results may include: exact debtor name, variations of that name and any filing that includes your search criteria. Punctuation is ignored.\n\nYou can click on \"Advanced\" to refine your search. Under “Advanced” you can search by crop, year, county and SSN/FEIN. As a registered Farm Bill Buyer with the Montana Secretary of State’s office it is important to maintain the confidentiality of the information contained within the Farm Bill Master List. The Farm Bill Master List reflects personal data, such as Social Security Numbers, which are a key piece of personal identifiable information to assist you in determining the existence of a lien against a specific debtor. The distribution of this information beyond its intended purpose is strictly prohibited.\n\nThe debtor's tax identification number has been hidden for confidentiality reasons. You may continue to search on a tax ID number and return debtors that match your search criteria. The SSN/FEIN must be entered without dashes or spaces.","searchMustHaveOneOf":["search","UCC_FARM_PRODUCT_ID","COUNTY"],"searchPlaceholder":"Search by debtor name","advancedSearchParameters":[{"type":"ServerMultiComplete","label":"Product code name(s)","name":"UCC_FARM_PRODUCT_ID","defaultValue":"","optionsSrc":"UCC_FARM_PRODUCT_V"},{"type":"MultiComplete","label":"Year or Range of Years","name":"YEAR_NUM","optionsSrc":"years","startYear":"1968","defaultValue":[],"preMergeOptions":[{"value":"ALL","label":"All"}]},{"type":"serverSelect","label":"State","name":"STATE","defaultValue":"MONTANA","optionsSrc":"STATE"},{"type":"ServerMultiComplete","label":"County","name":"COUNTY","defaultValue":[],"optionsSrc":"COUNTY","overrideSubOptionsSrcFromParameterName":"STATE"},{"type":"checkbox","name":"TIN_SEARCH_YN","defaultValue":false,"label":"Tax Identification Number Search"},{"type":"checkbox","name":"TIN_SORT_YN","defaultValue":false,"label":"Unique ID Sort"}]},"ALLOW_ADDRESS_VALIDATION_BYPASS_OPTION":true,"DEFAULT_ADDRESS_VALIDATION_BYPASS_OPTION_CHECKED":true}).MY_RECORDS_DISABLE_EMPTY_STATE;
	var MY_RECORDS_EMPTY_STATE_LINE_1 = ({"NODE_ENV":"production","BUILD_DATE":"2025-08-27T15:15:31.687Z","BUILD_NUMBER":"Not Provided","GIT_VERSION":"v1.3.0-381-ga81e29b08","GIT_COMMIT_HASH":"a81e29b085c9268ffd96c78eb734365802722741","GIT_BRANCH":"beta","PUBLIC_URL":"","STATE_ABBR":"MT","STATE_NAME":"Montana","STATE_ORG_TITLE":"Secretary of State","LOGIN_HEADER_IMG_PATH":"","HOME_IMG_FILENAME":"montana.jpg","FAVICON_FILE_NAME":"favicon.ico","ALLOW_E_SIGN_ON_CORRECTIONS":true,"THIRD_PARTY_SIGNING_ALLOWED":false,"MY_ACCOUNT_SAVE_AND_CLOSE_BUTTON":true,"IE_DEPRECATED_MESSAGE":"Internet Explorer is not supported. Please select a supported browser below to access this website.","ADDITIONAL_ROUTES":{"dataRequests":true,"farmBill":true,"apostille":true,"externalHelp":"https://sosmt.gov/business/help-center/","systemAdministration":[{"title":"Saved Payments","parameter":"saved-payments","componentName":"SavedPayments"}]},"SUBROUTES":[{"label":"Business","component":"Business","parameter":"business","myWorkQueueSearch":false,"sourceTypeId":54,"searchMustHaveOneOf":["FILING_TYPE_ID","STATUS_ID","STATE","search"],"serverWebSearchDescription":true,"serverWorkQueueDescription":true,"serverMyRecordsDescription":true,"searchPlaceholder":"Search by name or filing number (X########)","allowEmptySearchTerm":true,"requestCertificateAlternateLabel":"Request Information","fileAmendmentButtonLabel":"Filing Actions","advancedSearchParameters":[{"type":"radio","name":"QUERY_TYPE_ID","defaultValue":1010,"options":[{"value":1010,"label":"Starts with"},{"value":1011,"label":"Contains"},{"value":1012,"label":" Word Contains"}]},{"type":"serverSelect","name":"FILING_TYPE_ID","optionsSrc":"FILING_TYPES","label":"Entity Type","placeholder":"All","defaultValue":"0"},{"type":"serverSelect","name":"FILING_SUBTYPE_ID","optionsSrc":"FILING_SUBTYPES","label":"Entity Subtype","overrideSubOptionsSrcFromParameterName":"FILING_TYPE_ID","placeholder":"All","defaultValue":"0"},{"type":"serverSelect","name":"STATUS_ID","optionsSrc":"FILING_STATUS_WITHOUT_ALL","label":"Status","placeholder":"All","defaultValue":"0"},{"type":"serverSelect","name":"STATE","optionsSrc":"STATE","label":"State","placeholder":"All","defaultValue":""},{"type":"serverSelect","name":"COUNTY","optionsSrc":"COUNTY_SUBOPTION","label":"County","overrideSubOptionsSrcFromParameterName":"STATE","placeholder":"All","defaultValue":""},{"type":"checkbox","name":"CRA_SEARCH_YN","defaultValue":false,"label":"Search by Registered Agent PID"},{"type":"dateRange","name":"FILING_DATE","label":"Registration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}},{"type":"dateRange","name":"EXPIRATION_DATE","label":"Expiration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}}],"myRecordsFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Active"},{"value":2,"label":"Inactive"},{"value":3,"label":"Pending"}]},{"type":"dateRange","name":"DATE_RANGE","label":"Date range","defaultValue":{"start":null,"end":null}}],"myWorkQueueFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Approved"},{"value":2,"label":"Pending Online Payment"},{"value":3,"label":"Pending Review"},{"value":4,"label":"Needs Correction"},{"value":5,"label":"Rejected"},{"value":6,"label":"Draft"}]},{"type":"dateRange","name":"DATE_RANGE","label":"Date range","defaultValue":{"start":null,"end":null}}]},{"label":"Notary","component":"Notary","parameter":"notary","sourceTypeId":850,"myWorkQueueSearch":false,"allowEmptySearchTerm":true,"requestCertificateAlternateLabel":"Download Certificate","fileAmendmentButtonLabel":"Filing Actions","hideNameRequestCertificate":true,"hideAddressRequestCertificate":true,"hideRecordUserManagment":true,"searchPlaceholder":"Search by name or commission number","searchMustHaveOneOf":["CITY","search","SERVICE_TYPE"],"advancedParametersStartOpen":true,"searchIsSortable":true,"advancedSearchParameters":[{"type":"radio","name":"STARTS_WITH_YN","defaultValue":false,"options":[{"value":true,"label":"Starts with"},{"value":false,"label":"Contains"}]},{"type":"checkbox","name":"ACTIVE_ONLY_YN","defaultValue":true,"label":"Active entities only"},{"type":"text","name":"CITY","defaultValue":"","label":"City"},{"type":"select","name":"SERVICE_TYPE","label":"Special Services Offered","defaultValue":0,"options":[{"value":0,"label":"(N/A)"},{"value":6165,"label":"In-Person Electronic Notarization (IPEN)"},{"value":6166,"label":"Remote Online Notarization (RON)"},{"value":6167,"label":"Mobile Notary Services"},{"value":6168,"label":"Remote Ink Notarization (RIN)"}]}]},{"label":"Apostille","component":"Apostille","parameter":"apostille","sourceTypeId":720,"myRecordsSearch":false,"myWorkQueueSearch":false,"disabled":false,"allowedRoutes":["/forms-manager/","/queue/","/forms/"]},{"label":"Liens","component":"UCC","parameter":"ucc","sourceTypeId":1999,"myRecordsSearch":true,"myWorkQueueSearch":true,"fileAmendmentButtonLabel":"Filing Actions","searchPlaceholder":"Search by name or file number","disabled":false,"serverWebSearchDescription":true,"myRecordsDescription":"","workQueueDescription":"","searchDescription":"","hideRecordUserManagment":true,"searchLiensCheckout":false,"advancedSearchParameters":[{"type":"radio","name":"STARTS_WITH_YN","defaultValue":false,"options":[{"value":true,"label":"Starts with"},{"value":false,"label":"Contains"}]},{"type":"select","name":"STATUS","defaultValue":"ALL","label":"Status","options":[{"value":"ACTIVE_UNLAPSED","label":"Active (unlapsed)"},{"value":"ACTIVE_LAPSED_UNLAPSED","label":"Active (lapsed and unlapsed)"}]},{"type":"text","name":"EXCLUDE_VALUES","label":"Exclude Debtor Names (comma separated list of names to exclude)","defaultValue":""},{"type":"dateRange","name":"FILING_DATE","label":"Financing Statement Date","defaultValue":{"start":null,"end":null}},{"type":"dateRange","name":"LAPSE_DATE","label":"Lapse Date","defaultValue":{"start":null,"end":null}},{"type":"text","name":"CITY","label":"Debtor City","defaultValue":""}],"myRecordsFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Approved"},{"value":2,"label":"Pending Online Payment"},{"value":3,"label":"Pending Review"}]},{"type":"select","name":"TYPE","defaultValue":0,"label":"Lien Type","options":[{"value":0,"label":"All"},{"value":1,"label":"UCC"},{"value":2,"label":"EFS"},{"value":3,"label":"Title 71"}]}],"myWorkQueueFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Approved"},{"value":2,"label":"Pending Online Payment"},{"value":3,"label":"Pending Review"},{"value":4,"label":"Pending Print and Mail"},{"value":5,"label":"Rejected"},{"value":6,"label":"Draft"}]},{"type":"select","name":"TYPE","defaultValue":0,"label":"Lien Type","options":[{"value":0,"label":"All"},{"value":1,"label":"UCC"},{"value":2,"label":"EFS"},{"value":3,"label":"Title 71"}]}]},{"label":"Copy Request","component":"copies","parameter":"copies","sourceTypeId":2001,"myRecordsSearch":false,"myWorkQueueSearch":false,"disabled":false,"allowedRoutes":["/forms-manager/","/queue/","/forms/"]},{"label":"Trademark","component":"Trademark","parameter":"trademark","sourceTypeId":810,"showRequestCertificate":true,"searchMustHaveOneOf":["search","EXPIRATION_DATE","FILING_DATE"],"allowEmptySearchTerm":true,"requestCertificateAlternateLabel":"Request Information","fileAmendmentButtonLabel":"Filing Actions","advancedSearchParameters":[{"type":"radio","name":"QUERY_TYPE_ID","defaultValue":1010,"options":[{"value":1010,"label":"Starts with"},{"value":1011,"label":"Contains"},{"value":1012,"label":" Word Contains"}]},{"type":"checkbox","name":"OWNER_SEARCH_YN","defaultValue":false,"label":"Search owners"},{"type":"radio","name":"SERVICE_MARK_YN","label":"Mark Type","defaultValue":"","options":[{"value":"","label":"All Marks"},{"value":"Y","label":"Service Mark"},{"value":"N","label":"Trademark"}]},{"type":"serverSelect","name":"STATUS_ID","optionsSrc":"TYPE_V|TRADEMARK_STATUS_TYPE","label":"Status","placeholder":"All","defaultValue":"0"},{"type":"select","name":"DESIGN_TYPE_ID","options":[{"value":0,"label":"All"},{"value":990,"label":"Words Only"},{"value":991,"label":"Design Only"},{"value":992,"label":"Words and Design"}],"label":"Design Type","defaultValue":"0"},{"type":"dateRange","name":"FILING_DATE","label":"Registered Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}},{"type":"dateRange","name":"EXPIRATION_DATE","label":"Expiration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}}]},{"label":"Business Info Request","component":"InfoRequests","parameter":"info-request","sourceTypeId":167,"allowedRoutes":["/forms-manager/","/queue/","/forms/"]},{"label":"Data Requests","component":"DataRequests","parameter":"data-request","sourceTypeId":0,"allowedRoutes":["/forms-manager/"]},{"label":"CRA","component":"CRA","parameter":"cra","sourceTypeId":157,"myRecordsSearch":false,"searchPlaceholder":"Search by name or registered agent number","allowedRoutes":["/forms-manager/","/forms/","/records/","/queue/","/search/"],"allowEmptySearchTerm":true,"fileAmendmentButtonLabel":"Filing Actions","advancedSearchParameters":[{"type":"radio","name":"QUERY_TYPE_ID","defaultValue":1010,"options":[{"value":1010,"label":"Starts with"},{"value":1011,"label":"Contains"},{"value":1012,"label":" Word Contains"}]},{"type":"dateRange","name":"CRA_DATE","label":"Registration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}},{"type":"select","name":"STATUS_ID","label":"Status","defaultValue":0,"options":[{"value":0,"label":"All"},{"value":121,"label":"Active"},{"value":122,"label":"Inactive"}]},{"type":"select","name":"AGENT_TYPE_ID","label":"Agent Type","defaultValue":0,"options":[{"value":0,"label":"All"},{"value":460,"label":"Registered Agent"},{"value":461,"label":"Commercial Registered Agent"}]}]},{"label":"Farm Bill","component":"FarmBill","parameter":"farm-bill","path":"/lists/farm-bill","sourceTypeId":0,"myRecordsSearch":false,"allowedRules":["/search/"],"disabled":true,"searchDescription":"To perform a search, enter a debtor name. Your search results may include: exact debtor name, variations of that name and any filing that includes your search criteria. Punctuation is ignored.\n\nYou can click on \"Advanced\" to refine your search. Under “Advanced” you can search by crop, year, county and SSN/FEIN. As a registered Farm Bill Buyer with the Montana Secretary of State’s office it is important to maintain the confidentiality of the information contained within the Farm Bill Master List. The Farm Bill Master List reflects personal data, such as Social Security Numbers, which are a key piece of personal identifiable information to assist you in determining the existence of a lien against a specific debtor. The distribution of this information beyond its intended purpose is strictly prohibited.\n\nThe debtor's tax identification number has been hidden for confidentiality reasons. You may continue to search on a tax ID number and return debtors that match your search criteria. The SSN/FEIN must be entered without dashes or spaces.","searchMustHaveOneOf":["search","UCC_FARM_PRODUCT_ID","COUNTY"],"searchPlaceholder":"Search by debtor name","advancedSearchParameters":[{"type":"ServerMultiComplete","label":"Product code name(s)","name":"UCC_FARM_PRODUCT_ID","defaultValue":"","optionsSrc":"UCC_FARM_PRODUCT_V"},{"type":"MultiComplete","label":"Year or Range of Years","name":"YEAR_NUM","optionsSrc":"years","startYear":"1968","defaultValue":[],"preMergeOptions":[{"value":"ALL","label":"All"}]},{"type":"serverSelect","label":"State","name":"STATE","defaultValue":"MONTANA","optionsSrc":"STATE"},{"type":"ServerMultiComplete","label":"County","name":"COUNTY","defaultValue":[],"optionsSrc":"COUNTY","overrideSubOptionsSrcFromParameterName":"STATE"},{"type":"checkbox","name":"TIN_SEARCH_YN","defaultValue":false,"label":"Tax Identification Number Search"},{"type":"checkbox","name":"TIN_SORT_YN","defaultValue":false,"label":"Unique ID Sort"}]}],"SYSTEM_NICKNAME":"Online Services Portal","PAYMENT_METHODS":[{"type":"bypass"},{"type":"iTransact"}],"PAYMENT_ALLOW_AMEX":true,"SYSTEM_ID_LABEL":"System Id","DOUBLE_COLUMN_PUBLIC_LOGIN":true,"INTERNAL_USER_MANAGEMENT":true,"ALLOW_PUBLIC_JSON_IMPORT":false,"MAX_FILE_UPLOAD_SIZE":10000000,"REFUND_TEXT":"","RETURN_TO_HOME_ON_LOGOUT":true,"CURRENT_SOS_NAME":"Christi Jacobsen","LOGO_FILENAME":"mt-sos-logo.png","LOGO_ALT":"Christi Jacobsen, Montana Secretary of State","LOGO_FULL_WIDTH":true,"HOME_HIDE_AUTH_HINT":true,"HOME_TITLE":"Montana Secretary of State","CUSTOM_TAB_TITLE":"Official Montana","HOME_SUBTITLE":"Online Business Services","ENTITY_NAME_CONSENT_DESCRIPTION":"","ALLOW_USER_PROFILE_EDITING":true,"COMPARE_FOREIGN_NAME_IN_ENTITY_NAME_VALIDATION":true,"FOREIGN_NAME_FIELD_NAME":"KIMA_PARENT_NAME_INFO","LOGIN_TITLE":"Montana Secretary of State Online Filing Portal Login","PUBLIC_LOGIN_LABEL":"Username","REVERSE_LOGIN_COLUMNS":true,"LOGIN_SEAL_FILENAME":"seal_white.png","SEPARATE_USERNAME_AND_EMAIL":true,"CREATE_ACCOUNT_BUTTON_ALIGN_LEFT":true,"CREATE_ACCOUNT_BUTTON_TEXT":"CREATE AN ACCOUNT","PASSWORD_CUSTOM_ERROR_TEXT":"The password must meet all requirements","ACCOUNT_CREATED_MESSAGE":"Please check your email to verify your account to login and allow a few minutes for this message to arrive. Check your junk/spam folders if you do not find the email in your inbox.","PUBLIC_LOGIN_PLACEHOLDER":" ","DISABLE_DEFAULT_PAYMENT_RADIO":true,"CUSTOM_RESET_PASSWORD_ERROR_MESSAGE":"Username invalid - no account found","PUBLIC_LOGIN_CREATE_DESCRIPTION":"### Existing User:\n\n  - Enter your username and password to login.  \n\n\n  #### - OR -  \n\n\n\n  - Forgot password? Click 'Reset Password' and follow the prompts.\n  - Forgot username? Click 'Forgot Username' and follow the prompts.  \n\n\n  ### New User:\n  ","LOGIN_HELP_LINK":"https://sosmt.gov/business/how-do-i/","LOGIN_HELP_LINK_TEXT":"Need Help?","FORGOT_USERNAME_TEXT":"Forgot Username?","LOGIN_ACTIVE_DIRECTORY_TEXT":"State User Login","MULTIPLE_LOGIN_METHODS":true,"HAS_ACTIVE_DIRECTORY_LOGIN":true,"RESET_PASSWORD_WITH_USERNAME":true,"DOWNLOAD_LINK":true,"SHOW_USERNAME_ACCOUNT_CREATE":true,"SHOW_SCROLL_DOWN_ARROW":true,"SHOW_ADDRESS_ACCOUNT_CREATE":true,"TWO_COLUMN_ACCOUNT_CREATE":true,"RESET_PASSWORD_TIP":"A link to change your password has been sent to your email. Please allow a few minutes for this message to arrive. Please check your junk/spam folders if you do not find the email in your inbox.","FORGOT_PASSWORD_LINK_TEXT":"Reset Password","PHONE_NUMBER_OPTIONAL_ACCOUNT_CREATE":true,"SHOW_REQUIRED_INDICATOR_ACCOUNT_CREATE":true,"PASSWORD_REQUIREMENTS_ACCOUNT_CREATE":"\n    <ul>\n      <li>MUST contain at least 8 characters (12+ recommended)</li>\n      <li>MUST contain at least one uppercase letter.</li>\n      <li>MUST contain at least one lowercase letter.</li>\n      <li>MUST contain at least one number.</li>\n      <li>MUST contain at least one special character (!”#$%&'()*+,-./:;<=>?</li>\n    </ul>\n  ","ALLOW_CERTIFICATION_REQUEST":true,"ALLOW_PUBLIC_CERTIFICATE_REQUEST":true,"ALLOW_COPY_REQUEST":false,"ALLOW_CORRECTION_STYLING":true,"HIDE_DEPRECATION_WARNING":false,"AMEND_ROUTE_PUBLIC":true,"SEAL_FILENAME":"seal.png","SHOPPING_CART":true,"ALLOW_PAYMENT_UPDATE_WITH_EMPTY_CART":true,"RA_EMAIL":true,"RA_WEBSITE":true,"RA_NO_DEFAULT_TYPE":true,"RA_ADDRESS_LABEL":"Street Address","RA_TYPE_SELECTION_DEFAULT":true,"RA_DEFAULT_TYPE":"460","RA_OVERRIDE_TYPE_WITH_DEFAULT":true,"RA_PRINCIPAL_ADDRESS_AMS":true,"UPLOAD_AND_SUBMIT_HIDE_IF_ONE_OPTION":true,"PAYMENT_PROCESSING_MESSAGE":"Your payment is processing - Do not close your browser or click the back button","CHECKOUT_BUTTON_WHEN_PROCESSING_TEXT":"Processing","EFS_CROP_PICKER_NONE_LABEL":"Lien Duration","DISALLOWED_WIZARD_PIECES":["FormationLocale"],"REPEATER_SHOW_EDIT_BUTTON":true,"DATA_REQUEST_PAGE_TITLE":"Data Requests and Subscriptions","DATA_REQUEST_SIDEBAR_LABEL":"Data Requests & Subscriptions","LOGIN_REDIRECTS_TO_EPASS":false,"LOGIN_REDIRECTS_TO_ACTIVE_DIRECTORY":true,"LOGIN_ACTIVE_DIRECTORY_LINK":true,"FETCH_EDIT_USER_LINK":false,"LISTS_FETCH_AVAILABLE_LISTS":true,"POST_WIZARD_SUBMIT_REDIRECT_URL":"/","PIN_REQUEST_ATTESTATIONS":true,"PIN_REQUEST_DESCRIPTION":"Click **Request PIN** to have a new PIN sent to the account holder's email address on file.","OWNERSHIP_REQUEST_DESCRIPTION":"To become an **authorized user** of this record, a current **AUTHORIZED USER** will need to grant you access. To request access, click **Request Access** below.","PIN_REQUEST_SUCCESS_MESSAGE":"The PIN you have requested for this entity has been sent to the email associated with your user account.  You should receive the PIN in approximately 3-5 minutes, depending on your email service provider.","APOSTILLE_HEADER_LABEL":"Verification Information","APOSTILLE_NUMBER_LABEL":"Apostille/Authentication","APOSTILLE_CITY_STATE_OVERRIDE":"HELENA, MT","APOSTILLE_FILING_DATE_LABEL":"Issue Date","APOSTILLE_CITY_STATE_IN_CERTIFIED":true,"NOTARY_EXISTING_FILING":true,"ALLOW_REVOKE_OWN_ACCESS_ONLY":false,"HIDE_CANCEL_ON_ONETIME_DATA_REQUESTS":true,"DATA_REQUESTS_IN_SHOPPING_CART":true,"WQ_ALLOW_EDIT_PENDING_PAYMENT":true,"WQ_CONFIRM_ON_DELETE":true,"WQ_DELETE_CONFIRM_MESSAGE":"Deleting this filing will forfeit any money already paid to the Secretary of State. This action is permanent and cannot be undone, are you sure you would like to delete?","PASS_ITEM_GUIDS_ON_CHECKOUT":true,"FORM_REVISION_HISTORY":true,"CHECKOUT_DISCLAIMER":"By entering your credit card and/or checking account information you (i) state that **you are an authorized user** of the credit card and/or electronic check and that the associated information entered (e.g., account holder name, account number, billing address) is accurate, (ii) **you authorize payment processor to charge the amount you have requested** to your credit card and/or funding account, and (iii) **acknowledge if a charge is declined or reversed you may also be assessed a customary charge** by the payment processor for such transactions.","FARM_BILL_SEARCH_CONFIDENTIAL":"As a registered Farm Bill Buyer with the Montana Secretary of State’s office it is important to maintain the confidentiality of the information contained within the Farm Bill Master List. The Farm Bill Master List reflects personal data, such as Social Security Numbers, which are a key piece of personal identifiable information to assist you in determining the existence of a lien against a specific debtor. The distribution of this information beyond its intended purpose is strictly prohibited.\n\n**The debtor's tax identification number has been hidden for confidentiality reasons. You may continue to search on a tax ID number and return debtors that match your search criteria. The SSN/FEIN must be entered without dashes or spaces.  If you need access to the tax identification number to clearly identify the debtor, please contact the UCC unit at (406) 444-3665.**","VIEW_HISTORY_BUTTON_ALT_TEXT":"View Filings","WIZARD_ERROR_TITLE_MESSAGE":"Form Error","FARM_BILL_SEARCH_INTERACTIVE":true,"USE_FARM_BILL_API":true,"DISALLOW_ASSIGN_SELF_AS_RA":true,"DISALLOW_ASSIGN_SELF_AS_PRINCIPAL":true,"USE_TRADEMARK_OWNER_VALIDATION":true,"USE_ALTERNATIVE_FOREIGN_ADDRESS_LABELS":true,"MY_RECEIPTS_FILTER":[{"type":"dateRange","name":"DATE_RANGE","label":"Date range","defaultValue":{"start":null,"end":null}},{"type":"text","name":"REF_NUM","defaultValue":"","label":"Reference Number"},{"type":"text","name":"RECEIPT_NUM","defaultValue":"","label":"Receipt Id"},{"type":"text","name":"AMOUNT","defaultValue":"","label":"Amount"},{"type":"select","name":"TYPE","defaultValue":"","label":"Payment Type","options":[{"value":"","label":"All"},{"value":"CC","label":"Credit Card"},{"value":"Check","label":"Check"}]}],"MY_RECEIPTS_SHOW_IN_SIDEBAR":true,"SHOW_MY_RECEIPTS_HELPER_TEXT":true,"MY_RECEIPTS_HELPER_LABEL":"About Receipt Search","MY_RECEIPTS_HELPER_TEXT":"You can search for receipts based on their descriptions, including the items paid for on the receipt. Use the filters to search for or filter specific information.","FARM_BILL_SUBLINK":{"label":"Farm Bill","component":"FarmBill","parameter":"farm-bill","path":"/lists/farm-bill","sourceTypeId":0,"myRecordsSearch":false,"allowedRules":["/search/"],"disabled":true,"searchDescription":"To perform a search, enter a debtor name. Your search results may include: exact debtor name, variations of that name and any filing that includes your search criteria. Punctuation is ignored.\n\nYou can click on \"Advanced\" to refine your search. Under “Advanced” you can search by crop, year, county and SSN/FEIN. As a registered Farm Bill Buyer with the Montana Secretary of State’s office it is important to maintain the confidentiality of the information contained within the Farm Bill Master List. The Farm Bill Master List reflects personal data, such as Social Security Numbers, which are a key piece of personal identifiable information to assist you in determining the existence of a lien against a specific debtor. The distribution of this information beyond its intended purpose is strictly prohibited.\n\nThe debtor's tax identification number has been hidden for confidentiality reasons. You may continue to search on a tax ID number and return debtors that match your search criteria. The SSN/FEIN must be entered without dashes or spaces.","searchMustHaveOneOf":["search","UCC_FARM_PRODUCT_ID","COUNTY"],"searchPlaceholder":"Search by debtor name","advancedSearchParameters":[{"type":"ServerMultiComplete","label":"Product code name(s)","name":"UCC_FARM_PRODUCT_ID","defaultValue":"","optionsSrc":"UCC_FARM_PRODUCT_V"},{"type":"MultiComplete","label":"Year or Range of Years","name":"YEAR_NUM","optionsSrc":"years","startYear":"1968","defaultValue":[],"preMergeOptions":[{"value":"ALL","label":"All"}]},{"type":"serverSelect","label":"State","name":"STATE","defaultValue":"MONTANA","optionsSrc":"STATE"},{"type":"ServerMultiComplete","label":"County","name":"COUNTY","defaultValue":[],"optionsSrc":"COUNTY","overrideSubOptionsSrcFromParameterName":"STATE"},{"type":"checkbox","name":"TIN_SEARCH_YN","defaultValue":false,"label":"Tax Identification Number Search"},{"type":"checkbox","name":"TIN_SORT_YN","defaultValue":false,"label":"Unique ID Sort"}]},"ALLOW_ADDRESS_VALIDATION_BYPASS_OPTION":true,"DEFAULT_ADDRESS_VALIDATION_BYPASS_OPTION_CHECKED":true}).MY_RECORDS_EMPTY_STATE_LINE_1;
	var MY_RECORDS_EMPTY_STATE_LINE_2 = ({"NODE_ENV":"production","BUILD_DATE":"2025-08-27T15:15:31.687Z","BUILD_NUMBER":"Not Provided","GIT_VERSION":"v1.3.0-381-ga81e29b08","GIT_COMMIT_HASH":"a81e29b085c9268ffd96c78eb734365802722741","GIT_BRANCH":"beta","PUBLIC_URL":"","STATE_ABBR":"MT","STATE_NAME":"Montana","STATE_ORG_TITLE":"Secretary of State","LOGIN_HEADER_IMG_PATH":"","HOME_IMG_FILENAME":"montana.jpg","FAVICON_FILE_NAME":"favicon.ico","ALLOW_E_SIGN_ON_CORRECTIONS":true,"THIRD_PARTY_SIGNING_ALLOWED":false,"MY_ACCOUNT_SAVE_AND_CLOSE_BUTTON":true,"IE_DEPRECATED_MESSAGE":"Internet Explorer is not supported. Please select a supported browser below to access this website.","ADDITIONAL_ROUTES":{"dataRequests":true,"farmBill":true,"apostille":true,"externalHelp":"https://sosmt.gov/business/help-center/","systemAdministration":[{"title":"Saved Payments","parameter":"saved-payments","componentName":"SavedPayments"}]},"SUBROUTES":[{"label":"Business","component":"Business","parameter":"business","myWorkQueueSearch":false,"sourceTypeId":54,"searchMustHaveOneOf":["FILING_TYPE_ID","STATUS_ID","STATE","search"],"serverWebSearchDescription":true,"serverWorkQueueDescription":true,"serverMyRecordsDescription":true,"searchPlaceholder":"Search by name or filing number (X########)","allowEmptySearchTerm":true,"requestCertificateAlternateLabel":"Request Information","fileAmendmentButtonLabel":"Filing Actions","advancedSearchParameters":[{"type":"radio","name":"QUERY_TYPE_ID","defaultValue":1010,"options":[{"value":1010,"label":"Starts with"},{"value":1011,"label":"Contains"},{"value":1012,"label":" Word Contains"}]},{"type":"serverSelect","name":"FILING_TYPE_ID","optionsSrc":"FILING_TYPES","label":"Entity Type","placeholder":"All","defaultValue":"0"},{"type":"serverSelect","name":"FILING_SUBTYPE_ID","optionsSrc":"FILING_SUBTYPES","label":"Entity Subtype","overrideSubOptionsSrcFromParameterName":"FILING_TYPE_ID","placeholder":"All","defaultValue":"0"},{"type":"serverSelect","name":"STATUS_ID","optionsSrc":"FILING_STATUS_WITHOUT_ALL","label":"Status","placeholder":"All","defaultValue":"0"},{"type":"serverSelect","name":"STATE","optionsSrc":"STATE","label":"State","placeholder":"All","defaultValue":""},{"type":"serverSelect","name":"COUNTY","optionsSrc":"COUNTY_SUBOPTION","label":"County","overrideSubOptionsSrcFromParameterName":"STATE","placeholder":"All","defaultValue":""},{"type":"checkbox","name":"CRA_SEARCH_YN","defaultValue":false,"label":"Search by Registered Agent PID"},{"type":"dateRange","name":"FILING_DATE","label":"Registration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}},{"type":"dateRange","name":"EXPIRATION_DATE","label":"Expiration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}}],"myRecordsFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Active"},{"value":2,"label":"Inactive"},{"value":3,"label":"Pending"}]},{"type":"dateRange","name":"DATE_RANGE","label":"Date range","defaultValue":{"start":null,"end":null}}],"myWorkQueueFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Approved"},{"value":2,"label":"Pending Online Payment"},{"value":3,"label":"Pending Review"},{"value":4,"label":"Needs Correction"},{"value":5,"label":"Rejected"},{"value":6,"label":"Draft"}]},{"type":"dateRange","name":"DATE_RANGE","label":"Date range","defaultValue":{"start":null,"end":null}}]},{"label":"Notary","component":"Notary","parameter":"notary","sourceTypeId":850,"myWorkQueueSearch":false,"allowEmptySearchTerm":true,"requestCertificateAlternateLabel":"Download Certificate","fileAmendmentButtonLabel":"Filing Actions","hideNameRequestCertificate":true,"hideAddressRequestCertificate":true,"hideRecordUserManagment":true,"searchPlaceholder":"Search by name or commission number","searchMustHaveOneOf":["CITY","search","SERVICE_TYPE"],"advancedParametersStartOpen":true,"searchIsSortable":true,"advancedSearchParameters":[{"type":"radio","name":"STARTS_WITH_YN","defaultValue":false,"options":[{"value":true,"label":"Starts with"},{"value":false,"label":"Contains"}]},{"type":"checkbox","name":"ACTIVE_ONLY_YN","defaultValue":true,"label":"Active entities only"},{"type":"text","name":"CITY","defaultValue":"","label":"City"},{"type":"select","name":"SERVICE_TYPE","label":"Special Services Offered","defaultValue":0,"options":[{"value":0,"label":"(N/A)"},{"value":6165,"label":"In-Person Electronic Notarization (IPEN)"},{"value":6166,"label":"Remote Online Notarization (RON)"},{"value":6167,"label":"Mobile Notary Services"},{"value":6168,"label":"Remote Ink Notarization (RIN)"}]}]},{"label":"Apostille","component":"Apostille","parameter":"apostille","sourceTypeId":720,"myRecordsSearch":false,"myWorkQueueSearch":false,"disabled":false,"allowedRoutes":["/forms-manager/","/queue/","/forms/"]},{"label":"Liens","component":"UCC","parameter":"ucc","sourceTypeId":1999,"myRecordsSearch":true,"myWorkQueueSearch":true,"fileAmendmentButtonLabel":"Filing Actions","searchPlaceholder":"Search by name or file number","disabled":false,"serverWebSearchDescription":true,"myRecordsDescription":"","workQueueDescription":"","searchDescription":"","hideRecordUserManagment":true,"searchLiensCheckout":false,"advancedSearchParameters":[{"type":"radio","name":"STARTS_WITH_YN","defaultValue":false,"options":[{"value":true,"label":"Starts with"},{"value":false,"label":"Contains"}]},{"type":"select","name":"STATUS","defaultValue":"ALL","label":"Status","options":[{"value":"ACTIVE_UNLAPSED","label":"Active (unlapsed)"},{"value":"ACTIVE_LAPSED_UNLAPSED","label":"Active (lapsed and unlapsed)"}]},{"type":"text","name":"EXCLUDE_VALUES","label":"Exclude Debtor Names (comma separated list of names to exclude)","defaultValue":""},{"type":"dateRange","name":"FILING_DATE","label":"Financing Statement Date","defaultValue":{"start":null,"end":null}},{"type":"dateRange","name":"LAPSE_DATE","label":"Lapse Date","defaultValue":{"start":null,"end":null}},{"type":"text","name":"CITY","label":"Debtor City","defaultValue":""}],"myRecordsFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Approved"},{"value":2,"label":"Pending Online Payment"},{"value":3,"label":"Pending Review"}]},{"type":"select","name":"TYPE","defaultValue":0,"label":"Lien Type","options":[{"value":0,"label":"All"},{"value":1,"label":"UCC"},{"value":2,"label":"EFS"},{"value":3,"label":"Title 71"}]}],"myWorkQueueFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Approved"},{"value":2,"label":"Pending Online Payment"},{"value":3,"label":"Pending Review"},{"value":4,"label":"Pending Print and Mail"},{"value":5,"label":"Rejected"},{"value":6,"label":"Draft"}]},{"type":"select","name":"TYPE","defaultValue":0,"label":"Lien Type","options":[{"value":0,"label":"All"},{"value":1,"label":"UCC"},{"value":2,"label":"EFS"},{"value":3,"label":"Title 71"}]}]},{"label":"Copy Request","component":"copies","parameter":"copies","sourceTypeId":2001,"myRecordsSearch":false,"myWorkQueueSearch":false,"disabled":false,"allowedRoutes":["/forms-manager/","/queue/","/forms/"]},{"label":"Trademark","component":"Trademark","parameter":"trademark","sourceTypeId":810,"showRequestCertificate":true,"searchMustHaveOneOf":["search","EXPIRATION_DATE","FILING_DATE"],"allowEmptySearchTerm":true,"requestCertificateAlternateLabel":"Request Information","fileAmendmentButtonLabel":"Filing Actions","advancedSearchParameters":[{"type":"radio","name":"QUERY_TYPE_ID","defaultValue":1010,"options":[{"value":1010,"label":"Starts with"},{"value":1011,"label":"Contains"},{"value":1012,"label":" Word Contains"}]},{"type":"checkbox","name":"OWNER_SEARCH_YN","defaultValue":false,"label":"Search owners"},{"type":"radio","name":"SERVICE_MARK_YN","label":"Mark Type","defaultValue":"","options":[{"value":"","label":"All Marks"},{"value":"Y","label":"Service Mark"},{"value":"N","label":"Trademark"}]},{"type":"serverSelect","name":"STATUS_ID","optionsSrc":"TYPE_V|TRADEMARK_STATUS_TYPE","label":"Status","placeholder":"All","defaultValue":"0"},{"type":"select","name":"DESIGN_TYPE_ID","options":[{"value":0,"label":"All"},{"value":990,"label":"Words Only"},{"value":991,"label":"Design Only"},{"value":992,"label":"Words and Design"}],"label":"Design Type","defaultValue":"0"},{"type":"dateRange","name":"FILING_DATE","label":"Registered Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}},{"type":"dateRange","name":"EXPIRATION_DATE","label":"Expiration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}}]},{"label":"Business Info Request","component":"InfoRequests","parameter":"info-request","sourceTypeId":167,"allowedRoutes":["/forms-manager/","/queue/","/forms/"]},{"label":"Data Requests","component":"DataRequests","parameter":"data-request","sourceTypeId":0,"allowedRoutes":["/forms-manager/"]},{"label":"CRA","component":"CRA","parameter":"cra","sourceTypeId":157,"myRecordsSearch":false,"searchPlaceholder":"Search by name or registered agent number","allowedRoutes":["/forms-manager/","/forms/","/records/","/queue/","/search/"],"allowEmptySearchTerm":true,"fileAmendmentButtonLabel":"Filing Actions","advancedSearchParameters":[{"type":"radio","name":"QUERY_TYPE_ID","defaultValue":1010,"options":[{"value":1010,"label":"Starts with"},{"value":1011,"label":"Contains"},{"value":1012,"label":" Word Contains"}]},{"type":"dateRange","name":"CRA_DATE","label":"Registration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}},{"type":"select","name":"STATUS_ID","label":"Status","defaultValue":0,"options":[{"value":0,"label":"All"},{"value":121,"label":"Active"},{"value":122,"label":"Inactive"}]},{"type":"select","name":"AGENT_TYPE_ID","label":"Agent Type","defaultValue":0,"options":[{"value":0,"label":"All"},{"value":460,"label":"Registered Agent"},{"value":461,"label":"Commercial Registered Agent"}]}]},{"label":"Farm Bill","component":"FarmBill","parameter":"farm-bill","path":"/lists/farm-bill","sourceTypeId":0,"myRecordsSearch":false,"allowedRules":["/search/"],"disabled":true,"searchDescription":"To perform a search, enter a debtor name. Your search results may include: exact debtor name, variations of that name and any filing that includes your search criteria. Punctuation is ignored.\n\nYou can click on \"Advanced\" to refine your search. Under “Advanced” you can search by crop, year, county and SSN/FEIN. As a registered Farm Bill Buyer with the Montana Secretary of State’s office it is important to maintain the confidentiality of the information contained within the Farm Bill Master List. The Farm Bill Master List reflects personal data, such as Social Security Numbers, which are a key piece of personal identifiable information to assist you in determining the existence of a lien against a specific debtor. The distribution of this information beyond its intended purpose is strictly prohibited.\n\nThe debtor's tax identification number has been hidden for confidentiality reasons. You may continue to search on a tax ID number and return debtors that match your search criteria. The SSN/FEIN must be entered without dashes or spaces.","searchMustHaveOneOf":["search","UCC_FARM_PRODUCT_ID","COUNTY"],"searchPlaceholder":"Search by debtor name","advancedSearchParameters":[{"type":"ServerMultiComplete","label":"Product code name(s)","name":"UCC_FARM_PRODUCT_ID","defaultValue":"","optionsSrc":"UCC_FARM_PRODUCT_V"},{"type":"MultiComplete","label":"Year or Range of Years","name":"YEAR_NUM","optionsSrc":"years","startYear":"1968","defaultValue":[],"preMergeOptions":[{"value":"ALL","label":"All"}]},{"type":"serverSelect","label":"State","name":"STATE","defaultValue":"MONTANA","optionsSrc":"STATE"},{"type":"ServerMultiComplete","label":"County","name":"COUNTY","defaultValue":[],"optionsSrc":"COUNTY","overrideSubOptionsSrcFromParameterName":"STATE"},{"type":"checkbox","name":"TIN_SEARCH_YN","defaultValue":false,"label":"Tax Identification Number Search"},{"type":"checkbox","name":"TIN_SORT_YN","defaultValue":false,"label":"Unique ID Sort"}]}],"SYSTEM_NICKNAME":"Online Services Portal","PAYMENT_METHODS":[{"type":"bypass"},{"type":"iTransact"}],"PAYMENT_ALLOW_AMEX":true,"SYSTEM_ID_LABEL":"System Id","DOUBLE_COLUMN_PUBLIC_LOGIN":true,"INTERNAL_USER_MANAGEMENT":true,"ALLOW_PUBLIC_JSON_IMPORT":false,"MAX_FILE_UPLOAD_SIZE":10000000,"REFUND_TEXT":"","RETURN_TO_HOME_ON_LOGOUT":true,"CURRENT_SOS_NAME":"Christi Jacobsen","LOGO_FILENAME":"mt-sos-logo.png","LOGO_ALT":"Christi Jacobsen, Montana Secretary of State","LOGO_FULL_WIDTH":true,"HOME_HIDE_AUTH_HINT":true,"HOME_TITLE":"Montana Secretary of State","CUSTOM_TAB_TITLE":"Official Montana","HOME_SUBTITLE":"Online Business Services","ENTITY_NAME_CONSENT_DESCRIPTION":"","ALLOW_USER_PROFILE_EDITING":true,"COMPARE_FOREIGN_NAME_IN_ENTITY_NAME_VALIDATION":true,"FOREIGN_NAME_FIELD_NAME":"KIMA_PARENT_NAME_INFO","LOGIN_TITLE":"Montana Secretary of State Online Filing Portal Login","PUBLIC_LOGIN_LABEL":"Username","REVERSE_LOGIN_COLUMNS":true,"LOGIN_SEAL_FILENAME":"seal_white.png","SEPARATE_USERNAME_AND_EMAIL":true,"CREATE_ACCOUNT_BUTTON_ALIGN_LEFT":true,"CREATE_ACCOUNT_BUTTON_TEXT":"CREATE AN ACCOUNT","PASSWORD_CUSTOM_ERROR_TEXT":"The password must meet all requirements","ACCOUNT_CREATED_MESSAGE":"Please check your email to verify your account to login and allow a few minutes for this message to arrive. Check your junk/spam folders if you do not find the email in your inbox.","PUBLIC_LOGIN_PLACEHOLDER":" ","DISABLE_DEFAULT_PAYMENT_RADIO":true,"CUSTOM_RESET_PASSWORD_ERROR_MESSAGE":"Username invalid - no account found","PUBLIC_LOGIN_CREATE_DESCRIPTION":"### Existing User:\n\n  - Enter your username and password to login.  \n\n\n  #### - OR -  \n\n\n\n  - Forgot password? Click 'Reset Password' and follow the prompts.\n  - Forgot username? Click 'Forgot Username' and follow the prompts.  \n\n\n  ### New User:\n  ","LOGIN_HELP_LINK":"https://sosmt.gov/business/how-do-i/","LOGIN_HELP_LINK_TEXT":"Need Help?","FORGOT_USERNAME_TEXT":"Forgot Username?","LOGIN_ACTIVE_DIRECTORY_TEXT":"State User Login","MULTIPLE_LOGIN_METHODS":true,"HAS_ACTIVE_DIRECTORY_LOGIN":true,"RESET_PASSWORD_WITH_USERNAME":true,"DOWNLOAD_LINK":true,"SHOW_USERNAME_ACCOUNT_CREATE":true,"SHOW_SCROLL_DOWN_ARROW":true,"SHOW_ADDRESS_ACCOUNT_CREATE":true,"TWO_COLUMN_ACCOUNT_CREATE":true,"RESET_PASSWORD_TIP":"A link to change your password has been sent to your email. Please allow a few minutes for this message to arrive. Please check your junk/spam folders if you do not find the email in your inbox.","FORGOT_PASSWORD_LINK_TEXT":"Reset Password","PHONE_NUMBER_OPTIONAL_ACCOUNT_CREATE":true,"SHOW_REQUIRED_INDICATOR_ACCOUNT_CREATE":true,"PASSWORD_REQUIREMENTS_ACCOUNT_CREATE":"\n    <ul>\n      <li>MUST contain at least 8 characters (12+ recommended)</li>\n      <li>MUST contain at least one uppercase letter.</li>\n      <li>MUST contain at least one lowercase letter.</li>\n      <li>MUST contain at least one number.</li>\n      <li>MUST contain at least one special character (!”#$%&'()*+,-./:;<=>?</li>\n    </ul>\n  ","ALLOW_CERTIFICATION_REQUEST":true,"ALLOW_PUBLIC_CERTIFICATE_REQUEST":true,"ALLOW_COPY_REQUEST":false,"ALLOW_CORRECTION_STYLING":true,"HIDE_DEPRECATION_WARNING":false,"AMEND_ROUTE_PUBLIC":true,"SEAL_FILENAME":"seal.png","SHOPPING_CART":true,"ALLOW_PAYMENT_UPDATE_WITH_EMPTY_CART":true,"RA_EMAIL":true,"RA_WEBSITE":true,"RA_NO_DEFAULT_TYPE":true,"RA_ADDRESS_LABEL":"Street Address","RA_TYPE_SELECTION_DEFAULT":true,"RA_DEFAULT_TYPE":"460","RA_OVERRIDE_TYPE_WITH_DEFAULT":true,"RA_PRINCIPAL_ADDRESS_AMS":true,"UPLOAD_AND_SUBMIT_HIDE_IF_ONE_OPTION":true,"PAYMENT_PROCESSING_MESSAGE":"Your payment is processing - Do not close your browser or click the back button","CHECKOUT_BUTTON_WHEN_PROCESSING_TEXT":"Processing","EFS_CROP_PICKER_NONE_LABEL":"Lien Duration","DISALLOWED_WIZARD_PIECES":["FormationLocale"],"REPEATER_SHOW_EDIT_BUTTON":true,"DATA_REQUEST_PAGE_TITLE":"Data Requests and Subscriptions","DATA_REQUEST_SIDEBAR_LABEL":"Data Requests & Subscriptions","LOGIN_REDIRECTS_TO_EPASS":false,"LOGIN_REDIRECTS_TO_ACTIVE_DIRECTORY":true,"LOGIN_ACTIVE_DIRECTORY_LINK":true,"FETCH_EDIT_USER_LINK":false,"LISTS_FETCH_AVAILABLE_LISTS":true,"POST_WIZARD_SUBMIT_REDIRECT_URL":"/","PIN_REQUEST_ATTESTATIONS":true,"PIN_REQUEST_DESCRIPTION":"Click **Request PIN** to have a new PIN sent to the account holder's email address on file.","OWNERSHIP_REQUEST_DESCRIPTION":"To become an **authorized user** of this record, a current **AUTHORIZED USER** will need to grant you access. To request access, click **Request Access** below.","PIN_REQUEST_SUCCESS_MESSAGE":"The PIN you have requested for this entity has been sent to the email associated with your user account.  You should receive the PIN in approximately 3-5 minutes, depending on your email service provider.","APOSTILLE_HEADER_LABEL":"Verification Information","APOSTILLE_NUMBER_LABEL":"Apostille/Authentication","APOSTILLE_CITY_STATE_OVERRIDE":"HELENA, MT","APOSTILLE_FILING_DATE_LABEL":"Issue Date","APOSTILLE_CITY_STATE_IN_CERTIFIED":true,"NOTARY_EXISTING_FILING":true,"ALLOW_REVOKE_OWN_ACCESS_ONLY":false,"HIDE_CANCEL_ON_ONETIME_DATA_REQUESTS":true,"DATA_REQUESTS_IN_SHOPPING_CART":true,"WQ_ALLOW_EDIT_PENDING_PAYMENT":true,"WQ_CONFIRM_ON_DELETE":true,"WQ_DELETE_CONFIRM_MESSAGE":"Deleting this filing will forfeit any money already paid to the Secretary of State. This action is permanent and cannot be undone, are you sure you would like to delete?","PASS_ITEM_GUIDS_ON_CHECKOUT":true,"FORM_REVISION_HISTORY":true,"CHECKOUT_DISCLAIMER":"By entering your credit card and/or checking account information you (i) state that **you are an authorized user** of the credit card and/or electronic check and that the associated information entered (e.g., account holder name, account number, billing address) is accurate, (ii) **you authorize payment processor to charge the amount you have requested** to your credit card and/or funding account, and (iii) **acknowledge if a charge is declined or reversed you may also be assessed a customary charge** by the payment processor for such transactions.","FARM_BILL_SEARCH_CONFIDENTIAL":"As a registered Farm Bill Buyer with the Montana Secretary of State’s office it is important to maintain the confidentiality of the information contained within the Farm Bill Master List. The Farm Bill Master List reflects personal data, such as Social Security Numbers, which are a key piece of personal identifiable information to assist you in determining the existence of a lien against a specific debtor. The distribution of this information beyond its intended purpose is strictly prohibited.\n\n**The debtor's tax identification number has been hidden for confidentiality reasons. You may continue to search on a tax ID number and return debtors that match your search criteria. The SSN/FEIN must be entered without dashes or spaces.  If you need access to the tax identification number to clearly identify the debtor, please contact the UCC unit at (406) 444-3665.**","VIEW_HISTORY_BUTTON_ALT_TEXT":"View Filings","WIZARD_ERROR_TITLE_MESSAGE":"Form Error","FARM_BILL_SEARCH_INTERACTIVE":true,"USE_FARM_BILL_API":true,"DISALLOW_ASSIGN_SELF_AS_RA":true,"DISALLOW_ASSIGN_SELF_AS_PRINCIPAL":true,"USE_TRADEMARK_OWNER_VALIDATION":true,"USE_ALTERNATIVE_FOREIGN_ADDRESS_LABELS":true,"MY_RECEIPTS_FILTER":[{"type":"dateRange","name":"DATE_RANGE","label":"Date range","defaultValue":{"start":null,"end":null}},{"type":"text","name":"REF_NUM","defaultValue":"","label":"Reference Number"},{"type":"text","name":"RECEIPT_NUM","defaultValue":"","label":"Receipt Id"},{"type":"text","name":"AMOUNT","defaultValue":"","label":"Amount"},{"type":"select","name":"TYPE","defaultValue":"","label":"Payment Type","options":[{"value":"","label":"All"},{"value":"CC","label":"Credit Card"},{"value":"Check","label":"Check"}]}],"MY_RECEIPTS_SHOW_IN_SIDEBAR":true,"SHOW_MY_RECEIPTS_HELPER_TEXT":true,"MY_RECEIPTS_HELPER_LABEL":"About Receipt Search","MY_RECEIPTS_HELPER_TEXT":"You can search for receipts based on their descriptions, including the items paid for on the receipt. Use the filters to search for or filter specific information.","FARM_BILL_SUBLINK":{"label":"Farm Bill","component":"FarmBill","parameter":"farm-bill","path":"/lists/farm-bill","sourceTypeId":0,"myRecordsSearch":false,"allowedRules":["/search/"],"disabled":true,"searchDescription":"To perform a search, enter a debtor name. Your search results may include: exact debtor name, variations of that name and any filing that includes your search criteria. Punctuation is ignored.\n\nYou can click on \"Advanced\" to refine your search. Under “Advanced” you can search by crop, year, county and SSN/FEIN. As a registered Farm Bill Buyer with the Montana Secretary of State’s office it is important to maintain the confidentiality of the information contained within the Farm Bill Master List. The Farm Bill Master List reflects personal data, such as Social Security Numbers, which are a key piece of personal identifiable information to assist you in determining the existence of a lien against a specific debtor. The distribution of this information beyond its intended purpose is strictly prohibited.\n\nThe debtor's tax identification number has been hidden for confidentiality reasons. You may continue to search on a tax ID number and return debtors that match your search criteria. The SSN/FEIN must be entered without dashes or spaces.","searchMustHaveOneOf":["search","UCC_FARM_PRODUCT_ID","COUNTY"],"searchPlaceholder":"Search by debtor name","advancedSearchParameters":[{"type":"ServerMultiComplete","label":"Product code name(s)","name":"UCC_FARM_PRODUCT_ID","defaultValue":"","optionsSrc":"UCC_FARM_PRODUCT_V"},{"type":"MultiComplete","label":"Year or Range of Years","name":"YEAR_NUM","optionsSrc":"years","startYear":"1968","defaultValue":[],"preMergeOptions":[{"value":"ALL","label":"All"}]},{"type":"serverSelect","label":"State","name":"STATE","defaultValue":"MONTANA","optionsSrc":"STATE"},{"type":"ServerMultiComplete","label":"County","name":"COUNTY","defaultValue":[],"optionsSrc":"COUNTY","overrideSubOptionsSrcFromParameterName":"STATE"},{"type":"checkbox","name":"TIN_SEARCH_YN","defaultValue":false,"label":"Tax Identification Number Search"},{"type":"checkbox","name":"TIN_SORT_YN","defaultValue":false,"label":"Unique ID Sort"}]},"ALLOW_ADDRESS_VALIDATION_BYPASS_OPTION":true,"DEFAULT_ADDRESS_VALIDATION_BYPASS_OPTION_CHECKED":true}).MY_RECORDS_EMPTY_STATE_LINE_2;
	var MY_RECORDS_SEARCH_PLACEHOLDER = ({"NODE_ENV":"production","BUILD_DATE":"2025-08-27T15:15:31.687Z","BUILD_NUMBER":"Not Provided","GIT_VERSION":"v1.3.0-381-ga81e29b08","GIT_COMMIT_HASH":"a81e29b085c9268ffd96c78eb734365802722741","GIT_BRANCH":"beta","PUBLIC_URL":"","STATE_ABBR":"MT","STATE_NAME":"Montana","STATE_ORG_TITLE":"Secretary of State","LOGIN_HEADER_IMG_PATH":"","HOME_IMG_FILENAME":"montana.jpg","FAVICON_FILE_NAME":"favicon.ico","ALLOW_E_SIGN_ON_CORRECTIONS":true,"THIRD_PARTY_SIGNING_ALLOWED":false,"MY_ACCOUNT_SAVE_AND_CLOSE_BUTTON":true,"IE_DEPRECATED_MESSAGE":"Internet Explorer is not supported. Please select a supported browser below to access this website.","ADDITIONAL_ROUTES":{"dataRequests":true,"farmBill":true,"apostille":true,"externalHelp":"https://sosmt.gov/business/help-center/","systemAdministration":[{"title":"Saved Payments","parameter":"saved-payments","componentName":"SavedPayments"}]},"SUBROUTES":[{"label":"Business","component":"Business","parameter":"business","myWorkQueueSearch":false,"sourceTypeId":54,"searchMustHaveOneOf":["FILING_TYPE_ID","STATUS_ID","STATE","search"],"serverWebSearchDescription":true,"serverWorkQueueDescription":true,"serverMyRecordsDescription":true,"searchPlaceholder":"Search by name or filing number (X########)","allowEmptySearchTerm":true,"requestCertificateAlternateLabel":"Request Information","fileAmendmentButtonLabel":"Filing Actions","advancedSearchParameters":[{"type":"radio","name":"QUERY_TYPE_ID","defaultValue":1010,"options":[{"value":1010,"label":"Starts with"},{"value":1011,"label":"Contains"},{"value":1012,"label":" Word Contains"}]},{"type":"serverSelect","name":"FILING_TYPE_ID","optionsSrc":"FILING_TYPES","label":"Entity Type","placeholder":"All","defaultValue":"0"},{"type":"serverSelect","name":"FILING_SUBTYPE_ID","optionsSrc":"FILING_SUBTYPES","label":"Entity Subtype","overrideSubOptionsSrcFromParameterName":"FILING_TYPE_ID","placeholder":"All","defaultValue":"0"},{"type":"serverSelect","name":"STATUS_ID","optionsSrc":"FILING_STATUS_WITHOUT_ALL","label":"Status","placeholder":"All","defaultValue":"0"},{"type":"serverSelect","name":"STATE","optionsSrc":"STATE","label":"State","placeholder":"All","defaultValue":""},{"type":"serverSelect","name":"COUNTY","optionsSrc":"COUNTY_SUBOPTION","label":"County","overrideSubOptionsSrcFromParameterName":"STATE","placeholder":"All","defaultValue":""},{"type":"checkbox","name":"CRA_SEARCH_YN","defaultValue":false,"label":"Search by Registered Agent PID"},{"type":"dateRange","name":"FILING_DATE","label":"Registration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}},{"type":"dateRange","name":"EXPIRATION_DATE","label":"Expiration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}}],"myRecordsFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Active"},{"value":2,"label":"Inactive"},{"value":3,"label":"Pending"}]},{"type":"dateRange","name":"DATE_RANGE","label":"Date range","defaultValue":{"start":null,"end":null}}],"myWorkQueueFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Approved"},{"value":2,"label":"Pending Online Payment"},{"value":3,"label":"Pending Review"},{"value":4,"label":"Needs Correction"},{"value":5,"label":"Rejected"},{"value":6,"label":"Draft"}]},{"type":"dateRange","name":"DATE_RANGE","label":"Date range","defaultValue":{"start":null,"end":null}}]},{"label":"Notary","component":"Notary","parameter":"notary","sourceTypeId":850,"myWorkQueueSearch":false,"allowEmptySearchTerm":true,"requestCertificateAlternateLabel":"Download Certificate","fileAmendmentButtonLabel":"Filing Actions","hideNameRequestCertificate":true,"hideAddressRequestCertificate":true,"hideRecordUserManagment":true,"searchPlaceholder":"Search by name or commission number","searchMustHaveOneOf":["CITY","search","SERVICE_TYPE"],"advancedParametersStartOpen":true,"searchIsSortable":true,"advancedSearchParameters":[{"type":"radio","name":"STARTS_WITH_YN","defaultValue":false,"options":[{"value":true,"label":"Starts with"},{"value":false,"label":"Contains"}]},{"type":"checkbox","name":"ACTIVE_ONLY_YN","defaultValue":true,"label":"Active entities only"},{"type":"text","name":"CITY","defaultValue":"","label":"City"},{"type":"select","name":"SERVICE_TYPE","label":"Special Services Offered","defaultValue":0,"options":[{"value":0,"label":"(N/A)"},{"value":6165,"label":"In-Person Electronic Notarization (IPEN)"},{"value":6166,"label":"Remote Online Notarization (RON)"},{"value":6167,"label":"Mobile Notary Services"},{"value":6168,"label":"Remote Ink Notarization (RIN)"}]}]},{"label":"Apostille","component":"Apostille","parameter":"apostille","sourceTypeId":720,"myRecordsSearch":false,"myWorkQueueSearch":false,"disabled":false,"allowedRoutes":["/forms-manager/","/queue/","/forms/"]},{"label":"Liens","component":"UCC","parameter":"ucc","sourceTypeId":1999,"myRecordsSearch":true,"myWorkQueueSearch":true,"fileAmendmentButtonLabel":"Filing Actions","searchPlaceholder":"Search by name or file number","disabled":false,"serverWebSearchDescription":true,"myRecordsDescription":"","workQueueDescription":"","searchDescription":"","hideRecordUserManagment":true,"searchLiensCheckout":false,"advancedSearchParameters":[{"type":"radio","name":"STARTS_WITH_YN","defaultValue":false,"options":[{"value":true,"label":"Starts with"},{"value":false,"label":"Contains"}]},{"type":"select","name":"STATUS","defaultValue":"ALL","label":"Status","options":[{"value":"ACTIVE_UNLAPSED","label":"Active (unlapsed)"},{"value":"ACTIVE_LAPSED_UNLAPSED","label":"Active (lapsed and unlapsed)"}]},{"type":"text","name":"EXCLUDE_VALUES","label":"Exclude Debtor Names (comma separated list of names to exclude)","defaultValue":""},{"type":"dateRange","name":"FILING_DATE","label":"Financing Statement Date","defaultValue":{"start":null,"end":null}},{"type":"dateRange","name":"LAPSE_DATE","label":"Lapse Date","defaultValue":{"start":null,"end":null}},{"type":"text","name":"CITY","label":"Debtor City","defaultValue":""}],"myRecordsFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Approved"},{"value":2,"label":"Pending Online Payment"},{"value":3,"label":"Pending Review"}]},{"type":"select","name":"TYPE","defaultValue":0,"label":"Lien Type","options":[{"value":0,"label":"All"},{"value":1,"label":"UCC"},{"value":2,"label":"EFS"},{"value":3,"label":"Title 71"}]}],"myWorkQueueFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Approved"},{"value":2,"label":"Pending Online Payment"},{"value":3,"label":"Pending Review"},{"value":4,"label":"Pending Print and Mail"},{"value":5,"label":"Rejected"},{"value":6,"label":"Draft"}]},{"type":"select","name":"TYPE","defaultValue":0,"label":"Lien Type","options":[{"value":0,"label":"All"},{"value":1,"label":"UCC"},{"value":2,"label":"EFS"},{"value":3,"label":"Title 71"}]}]},{"label":"Copy Request","component":"copies","parameter":"copies","sourceTypeId":2001,"myRecordsSearch":false,"myWorkQueueSearch":false,"disabled":false,"allowedRoutes":["/forms-manager/","/queue/","/forms/"]},{"label":"Trademark","component":"Trademark","parameter":"trademark","sourceTypeId":810,"showRequestCertificate":true,"searchMustHaveOneOf":["search","EXPIRATION_DATE","FILING_DATE"],"allowEmptySearchTerm":true,"requestCertificateAlternateLabel":"Request Information","fileAmendmentButtonLabel":"Filing Actions","advancedSearchParameters":[{"type":"radio","name":"QUERY_TYPE_ID","defaultValue":1010,"options":[{"value":1010,"label":"Starts with"},{"value":1011,"label":"Contains"},{"value":1012,"label":" Word Contains"}]},{"type":"checkbox","name":"OWNER_SEARCH_YN","defaultValue":false,"label":"Search owners"},{"type":"radio","name":"SERVICE_MARK_YN","label":"Mark Type","defaultValue":"","options":[{"value":"","label":"All Marks"},{"value":"Y","label":"Service Mark"},{"value":"N","label":"Trademark"}]},{"type":"serverSelect","name":"STATUS_ID","optionsSrc":"TYPE_V|TRADEMARK_STATUS_TYPE","label":"Status","placeholder":"All","defaultValue":"0"},{"type":"select","name":"DESIGN_TYPE_ID","options":[{"value":0,"label":"All"},{"value":990,"label":"Words Only"},{"value":991,"label":"Design Only"},{"value":992,"label":"Words and Design"}],"label":"Design Type","defaultValue":"0"},{"type":"dateRange","name":"FILING_DATE","label":"Registered Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}},{"type":"dateRange","name":"EXPIRATION_DATE","label":"Expiration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}}]},{"label":"Business Info Request","component":"InfoRequests","parameter":"info-request","sourceTypeId":167,"allowedRoutes":["/forms-manager/","/queue/","/forms/"]},{"label":"Data Requests","component":"DataRequests","parameter":"data-request","sourceTypeId":0,"allowedRoutes":["/forms-manager/"]},{"label":"CRA","component":"CRA","parameter":"cra","sourceTypeId":157,"myRecordsSearch":false,"searchPlaceholder":"Search by name or registered agent number","allowedRoutes":["/forms-manager/","/forms/","/records/","/queue/","/search/"],"allowEmptySearchTerm":true,"fileAmendmentButtonLabel":"Filing Actions","advancedSearchParameters":[{"type":"radio","name":"QUERY_TYPE_ID","defaultValue":1010,"options":[{"value":1010,"label":"Starts with"},{"value":1011,"label":"Contains"},{"value":1012,"label":" Word Contains"}]},{"type":"dateRange","name":"CRA_DATE","label":"Registration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}},{"type":"select","name":"STATUS_ID","label":"Status","defaultValue":0,"options":[{"value":0,"label":"All"},{"value":121,"label":"Active"},{"value":122,"label":"Inactive"}]},{"type":"select","name":"AGENT_TYPE_ID","label":"Agent Type","defaultValue":0,"options":[{"value":0,"label":"All"},{"value":460,"label":"Registered Agent"},{"value":461,"label":"Commercial Registered Agent"}]}]},{"label":"Farm Bill","component":"FarmBill","parameter":"farm-bill","path":"/lists/farm-bill","sourceTypeId":0,"myRecordsSearch":false,"allowedRules":["/search/"],"disabled":true,"searchDescription":"To perform a search, enter a debtor name. Your search results may include: exact debtor name, variations of that name and any filing that includes your search criteria. Punctuation is ignored.\n\nYou can click on \"Advanced\" to refine your search. Under “Advanced” you can search by crop, year, county and SSN/FEIN. As a registered Farm Bill Buyer with the Montana Secretary of State’s office it is important to maintain the confidentiality of the information contained within the Farm Bill Master List. The Farm Bill Master List reflects personal data, such as Social Security Numbers, which are a key piece of personal identifiable information to assist you in determining the existence of a lien against a specific debtor. The distribution of this information beyond its intended purpose is strictly prohibited.\n\nThe debtor's tax identification number has been hidden for confidentiality reasons. You may continue to search on a tax ID number and return debtors that match your search criteria. The SSN/FEIN must be entered without dashes or spaces.","searchMustHaveOneOf":["search","UCC_FARM_PRODUCT_ID","COUNTY"],"searchPlaceholder":"Search by debtor name","advancedSearchParameters":[{"type":"ServerMultiComplete","label":"Product code name(s)","name":"UCC_FARM_PRODUCT_ID","defaultValue":"","optionsSrc":"UCC_FARM_PRODUCT_V"},{"type":"MultiComplete","label":"Year or Range of Years","name":"YEAR_NUM","optionsSrc":"years","startYear":"1968","defaultValue":[],"preMergeOptions":[{"value":"ALL","label":"All"}]},{"type":"serverSelect","label":"State","name":"STATE","defaultValue":"MONTANA","optionsSrc":"STATE"},{"type":"ServerMultiComplete","label":"County","name":"COUNTY","defaultValue":[],"optionsSrc":"COUNTY","overrideSubOptionsSrcFromParameterName":"STATE"},{"type":"checkbox","name":"TIN_SEARCH_YN","defaultValue":false,"label":"Tax Identification Number Search"},{"type":"checkbox","name":"TIN_SORT_YN","defaultValue":false,"label":"Unique ID Sort"}]}],"SYSTEM_NICKNAME":"Online Services Portal","PAYMENT_METHODS":[{"type":"bypass"},{"type":"iTransact"}],"PAYMENT_ALLOW_AMEX":true,"SYSTEM_ID_LABEL":"System Id","DOUBLE_COLUMN_PUBLIC_LOGIN":true,"INTERNAL_USER_MANAGEMENT":true,"ALLOW_PUBLIC_JSON_IMPORT":false,"MAX_FILE_UPLOAD_SIZE":10000000,"REFUND_TEXT":"","RETURN_TO_HOME_ON_LOGOUT":true,"CURRENT_SOS_NAME":"Christi Jacobsen","LOGO_FILENAME":"mt-sos-logo.png","LOGO_ALT":"Christi Jacobsen, Montana Secretary of State","LOGO_FULL_WIDTH":true,"HOME_HIDE_AUTH_HINT":true,"HOME_TITLE":"Montana Secretary of State","CUSTOM_TAB_TITLE":"Official Montana","HOME_SUBTITLE":"Online Business Services","ENTITY_NAME_CONSENT_DESCRIPTION":"","ALLOW_USER_PROFILE_EDITING":true,"COMPARE_FOREIGN_NAME_IN_ENTITY_NAME_VALIDATION":true,"FOREIGN_NAME_FIELD_NAME":"KIMA_PARENT_NAME_INFO","LOGIN_TITLE":"Montana Secretary of State Online Filing Portal Login","PUBLIC_LOGIN_LABEL":"Username","REVERSE_LOGIN_COLUMNS":true,"LOGIN_SEAL_FILENAME":"seal_white.png","SEPARATE_USERNAME_AND_EMAIL":true,"CREATE_ACCOUNT_BUTTON_ALIGN_LEFT":true,"CREATE_ACCOUNT_BUTTON_TEXT":"CREATE AN ACCOUNT","PASSWORD_CUSTOM_ERROR_TEXT":"The password must meet all requirements","ACCOUNT_CREATED_MESSAGE":"Please check your email to verify your account to login and allow a few minutes for this message to arrive. Check your junk/spam folders if you do not find the email in your inbox.","PUBLIC_LOGIN_PLACEHOLDER":" ","DISABLE_DEFAULT_PAYMENT_RADIO":true,"CUSTOM_RESET_PASSWORD_ERROR_MESSAGE":"Username invalid - no account found","PUBLIC_LOGIN_CREATE_DESCRIPTION":"### Existing User:\n\n  - Enter your username and password to login.  \n\n\n  #### - OR -  \n\n\n\n  - Forgot password? Click 'Reset Password' and follow the prompts.\n  - Forgot username? Click 'Forgot Username' and follow the prompts.  \n\n\n  ### New User:\n  ","LOGIN_HELP_LINK":"https://sosmt.gov/business/how-do-i/","LOGIN_HELP_LINK_TEXT":"Need Help?","FORGOT_USERNAME_TEXT":"Forgot Username?","LOGIN_ACTIVE_DIRECTORY_TEXT":"State User Login","MULTIPLE_LOGIN_METHODS":true,"HAS_ACTIVE_DIRECTORY_LOGIN":true,"RESET_PASSWORD_WITH_USERNAME":true,"DOWNLOAD_LINK":true,"SHOW_USERNAME_ACCOUNT_CREATE":true,"SHOW_SCROLL_DOWN_ARROW":true,"SHOW_ADDRESS_ACCOUNT_CREATE":true,"TWO_COLUMN_ACCOUNT_CREATE":true,"RESET_PASSWORD_TIP":"A link to change your password has been sent to your email. Please allow a few minutes for this message to arrive. Please check your junk/spam folders if you do not find the email in your inbox.","FORGOT_PASSWORD_LINK_TEXT":"Reset Password","PHONE_NUMBER_OPTIONAL_ACCOUNT_CREATE":true,"SHOW_REQUIRED_INDICATOR_ACCOUNT_CREATE":true,"PASSWORD_REQUIREMENTS_ACCOUNT_CREATE":"\n    <ul>\n      <li>MUST contain at least 8 characters (12+ recommended)</li>\n      <li>MUST contain at least one uppercase letter.</li>\n      <li>MUST contain at least one lowercase letter.</li>\n      <li>MUST contain at least one number.</li>\n      <li>MUST contain at least one special character (!”#$%&'()*+,-./:;<=>?</li>\n    </ul>\n  ","ALLOW_CERTIFICATION_REQUEST":true,"ALLOW_PUBLIC_CERTIFICATE_REQUEST":true,"ALLOW_COPY_REQUEST":false,"ALLOW_CORRECTION_STYLING":true,"HIDE_DEPRECATION_WARNING":false,"AMEND_ROUTE_PUBLIC":true,"SEAL_FILENAME":"seal.png","SHOPPING_CART":true,"ALLOW_PAYMENT_UPDATE_WITH_EMPTY_CART":true,"RA_EMAIL":true,"RA_WEBSITE":true,"RA_NO_DEFAULT_TYPE":true,"RA_ADDRESS_LABEL":"Street Address","RA_TYPE_SELECTION_DEFAULT":true,"RA_DEFAULT_TYPE":"460","RA_OVERRIDE_TYPE_WITH_DEFAULT":true,"RA_PRINCIPAL_ADDRESS_AMS":true,"UPLOAD_AND_SUBMIT_HIDE_IF_ONE_OPTION":true,"PAYMENT_PROCESSING_MESSAGE":"Your payment is processing - Do not close your browser or click the back button","CHECKOUT_BUTTON_WHEN_PROCESSING_TEXT":"Processing","EFS_CROP_PICKER_NONE_LABEL":"Lien Duration","DISALLOWED_WIZARD_PIECES":["FormationLocale"],"REPEATER_SHOW_EDIT_BUTTON":true,"DATA_REQUEST_PAGE_TITLE":"Data Requests and Subscriptions","DATA_REQUEST_SIDEBAR_LABEL":"Data Requests & Subscriptions","LOGIN_REDIRECTS_TO_EPASS":false,"LOGIN_REDIRECTS_TO_ACTIVE_DIRECTORY":true,"LOGIN_ACTIVE_DIRECTORY_LINK":true,"FETCH_EDIT_USER_LINK":false,"LISTS_FETCH_AVAILABLE_LISTS":true,"POST_WIZARD_SUBMIT_REDIRECT_URL":"/","PIN_REQUEST_ATTESTATIONS":true,"PIN_REQUEST_DESCRIPTION":"Click **Request PIN** to have a new PIN sent to the account holder's email address on file.","OWNERSHIP_REQUEST_DESCRIPTION":"To become an **authorized user** of this record, a current **AUTHORIZED USER** will need to grant you access. To request access, click **Request Access** below.","PIN_REQUEST_SUCCESS_MESSAGE":"The PIN you have requested for this entity has been sent to the email associated with your user account.  You should receive the PIN in approximately 3-5 minutes, depending on your email service provider.","APOSTILLE_HEADER_LABEL":"Verification Information","APOSTILLE_NUMBER_LABEL":"Apostille/Authentication","APOSTILLE_CITY_STATE_OVERRIDE":"HELENA, MT","APOSTILLE_FILING_DATE_LABEL":"Issue Date","APOSTILLE_CITY_STATE_IN_CERTIFIED":true,"NOTARY_EXISTING_FILING":true,"ALLOW_REVOKE_OWN_ACCESS_ONLY":false,"HIDE_CANCEL_ON_ONETIME_DATA_REQUESTS":true,"DATA_REQUESTS_IN_SHOPPING_CART":true,"WQ_ALLOW_EDIT_PENDING_PAYMENT":true,"WQ_CONFIRM_ON_DELETE":true,"WQ_DELETE_CONFIRM_MESSAGE":"Deleting this filing will forfeit any money already paid to the Secretary of State. This action is permanent and cannot be undone, are you sure you would like to delete?","PASS_ITEM_GUIDS_ON_CHECKOUT":true,"FORM_REVISION_HISTORY":true,"CHECKOUT_DISCLAIMER":"By entering your credit card and/or checking account information you (i) state that **you are an authorized user** of the credit card and/or electronic check and that the associated information entered (e.g., account holder name, account number, billing address) is accurate, (ii) **you authorize payment processor to charge the amount you have requested** to your credit card and/or funding account, and (iii) **acknowledge if a charge is declined or reversed you may also be assessed a customary charge** by the payment processor for such transactions.","FARM_BILL_SEARCH_CONFIDENTIAL":"As a registered Farm Bill Buyer with the Montana Secretary of State’s office it is important to maintain the confidentiality of the information contained within the Farm Bill Master List. The Farm Bill Master List reflects personal data, such as Social Security Numbers, which are a key piece of personal identifiable information to assist you in determining the existence of a lien against a specific debtor. The distribution of this information beyond its intended purpose is strictly prohibited.\n\n**The debtor's tax identification number has been hidden for confidentiality reasons. You may continue to search on a tax ID number and return debtors that match your search criteria. The SSN/FEIN must be entered without dashes or spaces.  If you need access to the tax identification number to clearly identify the debtor, please contact the UCC unit at (406) 444-3665.**","VIEW_HISTORY_BUTTON_ALT_TEXT":"View Filings","WIZARD_ERROR_TITLE_MESSAGE":"Form Error","FARM_BILL_SEARCH_INTERACTIVE":true,"USE_FARM_BILL_API":true,"DISALLOW_ASSIGN_SELF_AS_RA":true,"DISALLOW_ASSIGN_SELF_AS_PRINCIPAL":true,"USE_TRADEMARK_OWNER_VALIDATION":true,"USE_ALTERNATIVE_FOREIGN_ADDRESS_LABELS":true,"MY_RECEIPTS_FILTER":[{"type":"dateRange","name":"DATE_RANGE","label":"Date range","defaultValue":{"start":null,"end":null}},{"type":"text","name":"REF_NUM","defaultValue":"","label":"Reference Number"},{"type":"text","name":"RECEIPT_NUM","defaultValue":"","label":"Receipt Id"},{"type":"text","name":"AMOUNT","defaultValue":"","label":"Amount"},{"type":"select","name":"TYPE","defaultValue":"","label":"Payment Type","options":[{"value":"","label":"All"},{"value":"CC","label":"Credit Card"},{"value":"Check","label":"Check"}]}],"MY_RECEIPTS_SHOW_IN_SIDEBAR":true,"SHOW_MY_RECEIPTS_HELPER_TEXT":true,"MY_RECEIPTS_HELPER_LABEL":"About Receipt Search","MY_RECEIPTS_HELPER_TEXT":"You can search for receipts based on their descriptions, including the items paid for on the receipt. Use the filters to search for or filter specific information.","FARM_BILL_SUBLINK":{"label":"Farm Bill","component":"FarmBill","parameter":"farm-bill","path":"/lists/farm-bill","sourceTypeId":0,"myRecordsSearch":false,"allowedRules":["/search/"],"disabled":true,"searchDescription":"To perform a search, enter a debtor name. Your search results may include: exact debtor name, variations of that name and any filing that includes your search criteria. Punctuation is ignored.\n\nYou can click on \"Advanced\" to refine your search. Under “Advanced” you can search by crop, year, county and SSN/FEIN. As a registered Farm Bill Buyer with the Montana Secretary of State’s office it is important to maintain the confidentiality of the information contained within the Farm Bill Master List. The Farm Bill Master List reflects personal data, such as Social Security Numbers, which are a key piece of personal identifiable information to assist you in determining the existence of a lien against a specific debtor. The distribution of this information beyond its intended purpose is strictly prohibited.\n\nThe debtor's tax identification number has been hidden for confidentiality reasons. You may continue to search on a tax ID number and return debtors that match your search criteria. The SSN/FEIN must be entered without dashes or spaces.","searchMustHaveOneOf":["search","UCC_FARM_PRODUCT_ID","COUNTY"],"searchPlaceholder":"Search by debtor name","advancedSearchParameters":[{"type":"ServerMultiComplete","label":"Product code name(s)","name":"UCC_FARM_PRODUCT_ID","defaultValue":"","optionsSrc":"UCC_FARM_PRODUCT_V"},{"type":"MultiComplete","label":"Year or Range of Years","name":"YEAR_NUM","optionsSrc":"years","startYear":"1968","defaultValue":[],"preMergeOptions":[{"value":"ALL","label":"All"}]},{"type":"serverSelect","label":"State","name":"STATE","defaultValue":"MONTANA","optionsSrc":"STATE"},{"type":"ServerMultiComplete","label":"County","name":"COUNTY","defaultValue":[],"optionsSrc":"COUNTY","overrideSubOptionsSrcFromParameterName":"STATE"},{"type":"checkbox","name":"TIN_SEARCH_YN","defaultValue":false,"label":"Tax Identification Number Search"},{"type":"checkbox","name":"TIN_SORT_YN","defaultValue":false,"label":"Unique ID Sort"}]},"ALLOW_ADDRESS_VALIDATION_BYPASS_OPTION":true,"DEFAULT_ADDRESS_VALIDATION_BYPASS_OPTION_CHECKED":true}).MY_RECORDS_SEARCH_PLACEHOLDER;
	var MY_RECORDS_DESCRIPTION = ({"NODE_ENV":"production","BUILD_DATE":"2025-08-27T15:15:31.687Z","BUILD_NUMBER":"Not Provided","GIT_VERSION":"v1.3.0-381-ga81e29b08","GIT_COMMIT_HASH":"a81e29b085c9268ffd96c78eb734365802722741","GIT_BRANCH":"beta","PUBLIC_URL":"","STATE_ABBR":"MT","STATE_NAME":"Montana","STATE_ORG_TITLE":"Secretary of State","LOGIN_HEADER_IMG_PATH":"","HOME_IMG_FILENAME":"montana.jpg","FAVICON_FILE_NAME":"favicon.ico","ALLOW_E_SIGN_ON_CORRECTIONS":true,"THIRD_PARTY_SIGNING_ALLOWED":false,"MY_ACCOUNT_SAVE_AND_CLOSE_BUTTON":true,"IE_DEPRECATED_MESSAGE":"Internet Explorer is not supported. Please select a supported browser below to access this website.","ADDITIONAL_ROUTES":{"dataRequests":true,"farmBill":true,"apostille":true,"externalHelp":"https://sosmt.gov/business/help-center/","systemAdministration":[{"title":"Saved Payments","parameter":"saved-payments","componentName":"SavedPayments"}]},"SUBROUTES":[{"label":"Business","component":"Business","parameter":"business","myWorkQueueSearch":false,"sourceTypeId":54,"searchMustHaveOneOf":["FILING_TYPE_ID","STATUS_ID","STATE","search"],"serverWebSearchDescription":true,"serverWorkQueueDescription":true,"serverMyRecordsDescription":true,"searchPlaceholder":"Search by name or filing number (X########)","allowEmptySearchTerm":true,"requestCertificateAlternateLabel":"Request Information","fileAmendmentButtonLabel":"Filing Actions","advancedSearchParameters":[{"type":"radio","name":"QUERY_TYPE_ID","defaultValue":1010,"options":[{"value":1010,"label":"Starts with"},{"value":1011,"label":"Contains"},{"value":1012,"label":" Word Contains"}]},{"type":"serverSelect","name":"FILING_TYPE_ID","optionsSrc":"FILING_TYPES","label":"Entity Type","placeholder":"All","defaultValue":"0"},{"type":"serverSelect","name":"FILING_SUBTYPE_ID","optionsSrc":"FILING_SUBTYPES","label":"Entity Subtype","overrideSubOptionsSrcFromParameterName":"FILING_TYPE_ID","placeholder":"All","defaultValue":"0"},{"type":"serverSelect","name":"STATUS_ID","optionsSrc":"FILING_STATUS_WITHOUT_ALL","label":"Status","placeholder":"All","defaultValue":"0"},{"type":"serverSelect","name":"STATE","optionsSrc":"STATE","label":"State","placeholder":"All","defaultValue":""},{"type":"serverSelect","name":"COUNTY","optionsSrc":"COUNTY_SUBOPTION","label":"County","overrideSubOptionsSrcFromParameterName":"STATE","placeholder":"All","defaultValue":""},{"type":"checkbox","name":"CRA_SEARCH_YN","defaultValue":false,"label":"Search by Registered Agent PID"},{"type":"dateRange","name":"FILING_DATE","label":"Registration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}},{"type":"dateRange","name":"EXPIRATION_DATE","label":"Expiration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}}],"myRecordsFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Active"},{"value":2,"label":"Inactive"},{"value":3,"label":"Pending"}]},{"type":"dateRange","name":"DATE_RANGE","label":"Date range","defaultValue":{"start":null,"end":null}}],"myWorkQueueFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Approved"},{"value":2,"label":"Pending Online Payment"},{"value":3,"label":"Pending Review"},{"value":4,"label":"Needs Correction"},{"value":5,"label":"Rejected"},{"value":6,"label":"Draft"}]},{"type":"dateRange","name":"DATE_RANGE","label":"Date range","defaultValue":{"start":null,"end":null}}]},{"label":"Notary","component":"Notary","parameter":"notary","sourceTypeId":850,"myWorkQueueSearch":false,"allowEmptySearchTerm":true,"requestCertificateAlternateLabel":"Download Certificate","fileAmendmentButtonLabel":"Filing Actions","hideNameRequestCertificate":true,"hideAddressRequestCertificate":true,"hideRecordUserManagment":true,"searchPlaceholder":"Search by name or commission number","searchMustHaveOneOf":["CITY","search","SERVICE_TYPE"],"advancedParametersStartOpen":true,"searchIsSortable":true,"advancedSearchParameters":[{"type":"radio","name":"STARTS_WITH_YN","defaultValue":false,"options":[{"value":true,"label":"Starts with"},{"value":false,"label":"Contains"}]},{"type":"checkbox","name":"ACTIVE_ONLY_YN","defaultValue":true,"label":"Active entities only"},{"type":"text","name":"CITY","defaultValue":"","label":"City"},{"type":"select","name":"SERVICE_TYPE","label":"Special Services Offered","defaultValue":0,"options":[{"value":0,"label":"(N/A)"},{"value":6165,"label":"In-Person Electronic Notarization (IPEN)"},{"value":6166,"label":"Remote Online Notarization (RON)"},{"value":6167,"label":"Mobile Notary Services"},{"value":6168,"label":"Remote Ink Notarization (RIN)"}]}]},{"label":"Apostille","component":"Apostille","parameter":"apostille","sourceTypeId":720,"myRecordsSearch":false,"myWorkQueueSearch":false,"disabled":false,"allowedRoutes":["/forms-manager/","/queue/","/forms/"]},{"label":"Liens","component":"UCC","parameter":"ucc","sourceTypeId":1999,"myRecordsSearch":true,"myWorkQueueSearch":true,"fileAmendmentButtonLabel":"Filing Actions","searchPlaceholder":"Search by name or file number","disabled":false,"serverWebSearchDescription":true,"myRecordsDescription":"","workQueueDescription":"","searchDescription":"","hideRecordUserManagment":true,"searchLiensCheckout":false,"advancedSearchParameters":[{"type":"radio","name":"STARTS_WITH_YN","defaultValue":false,"options":[{"value":true,"label":"Starts with"},{"value":false,"label":"Contains"}]},{"type":"select","name":"STATUS","defaultValue":"ALL","label":"Status","options":[{"value":"ACTIVE_UNLAPSED","label":"Active (unlapsed)"},{"value":"ACTIVE_LAPSED_UNLAPSED","label":"Active (lapsed and unlapsed)"}]},{"type":"text","name":"EXCLUDE_VALUES","label":"Exclude Debtor Names (comma separated list of names to exclude)","defaultValue":""},{"type":"dateRange","name":"FILING_DATE","label":"Financing Statement Date","defaultValue":{"start":null,"end":null}},{"type":"dateRange","name":"LAPSE_DATE","label":"Lapse Date","defaultValue":{"start":null,"end":null}},{"type":"text","name":"CITY","label":"Debtor City","defaultValue":""}],"myRecordsFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Approved"},{"value":2,"label":"Pending Online Payment"},{"value":3,"label":"Pending Review"}]},{"type":"select","name":"TYPE","defaultValue":0,"label":"Lien Type","options":[{"value":0,"label":"All"},{"value":1,"label":"UCC"},{"value":2,"label":"EFS"},{"value":3,"label":"Title 71"}]}],"myWorkQueueFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Approved"},{"value":2,"label":"Pending Online Payment"},{"value":3,"label":"Pending Review"},{"value":4,"label":"Pending Print and Mail"},{"value":5,"label":"Rejected"},{"value":6,"label":"Draft"}]},{"type":"select","name":"TYPE","defaultValue":0,"label":"Lien Type","options":[{"value":0,"label":"All"},{"value":1,"label":"UCC"},{"value":2,"label":"EFS"},{"value":3,"label":"Title 71"}]}]},{"label":"Copy Request","component":"copies","parameter":"copies","sourceTypeId":2001,"myRecordsSearch":false,"myWorkQueueSearch":false,"disabled":false,"allowedRoutes":["/forms-manager/","/queue/","/forms/"]},{"label":"Trademark","component":"Trademark","parameter":"trademark","sourceTypeId":810,"showRequestCertificate":true,"searchMustHaveOneOf":["search","EXPIRATION_DATE","FILING_DATE"],"allowEmptySearchTerm":true,"requestCertificateAlternateLabel":"Request Information","fileAmendmentButtonLabel":"Filing Actions","advancedSearchParameters":[{"type":"radio","name":"QUERY_TYPE_ID","defaultValue":1010,"options":[{"value":1010,"label":"Starts with"},{"value":1011,"label":"Contains"},{"value":1012,"label":" Word Contains"}]},{"type":"checkbox","name":"OWNER_SEARCH_YN","defaultValue":false,"label":"Search owners"},{"type":"radio","name":"SERVICE_MARK_YN","label":"Mark Type","defaultValue":"","options":[{"value":"","label":"All Marks"},{"value":"Y","label":"Service Mark"},{"value":"N","label":"Trademark"}]},{"type":"serverSelect","name":"STATUS_ID","optionsSrc":"TYPE_V|TRADEMARK_STATUS_TYPE","label":"Status","placeholder":"All","defaultValue":"0"},{"type":"select","name":"DESIGN_TYPE_ID","options":[{"value":0,"label":"All"},{"value":990,"label":"Words Only"},{"value":991,"label":"Design Only"},{"value":992,"label":"Words and Design"}],"label":"Design Type","defaultValue":"0"},{"type":"dateRange","name":"FILING_DATE","label":"Registered Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}},{"type":"dateRange","name":"EXPIRATION_DATE","label":"Expiration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}}]},{"label":"Business Info Request","component":"InfoRequests","parameter":"info-request","sourceTypeId":167,"allowedRoutes":["/forms-manager/","/queue/","/forms/"]},{"label":"Data Requests","component":"DataRequests","parameter":"data-request","sourceTypeId":0,"allowedRoutes":["/forms-manager/"]},{"label":"CRA","component":"CRA","parameter":"cra","sourceTypeId":157,"myRecordsSearch":false,"searchPlaceholder":"Search by name or registered agent number","allowedRoutes":["/forms-manager/","/forms/","/records/","/queue/","/search/"],"allowEmptySearchTerm":true,"fileAmendmentButtonLabel":"Filing Actions","advancedSearchParameters":[{"type":"radio","name":"QUERY_TYPE_ID","defaultValue":1010,"options":[{"value":1010,"label":"Starts with"},{"value":1011,"label":"Contains"},{"value":1012,"label":" Word Contains"}]},{"type":"dateRange","name":"CRA_DATE","label":"Registration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}},{"type":"select","name":"STATUS_ID","label":"Status","defaultValue":0,"options":[{"value":0,"label":"All"},{"value":121,"label":"Active"},{"value":122,"label":"Inactive"}]},{"type":"select","name":"AGENT_TYPE_ID","label":"Agent Type","defaultValue":0,"options":[{"value":0,"label":"All"},{"value":460,"label":"Registered Agent"},{"value":461,"label":"Commercial Registered Agent"}]}]},{"label":"Farm Bill","component":"FarmBill","parameter":"farm-bill","path":"/lists/farm-bill","sourceTypeId":0,"myRecordsSearch":false,"allowedRules":["/search/"],"disabled":true,"searchDescription":"To perform a search, enter a debtor name. Your search results may include: exact debtor name, variations of that name and any filing that includes your search criteria. Punctuation is ignored.\n\nYou can click on \"Advanced\" to refine your search. Under “Advanced” you can search by crop, year, county and SSN/FEIN. As a registered Farm Bill Buyer with the Montana Secretary of State’s office it is important to maintain the confidentiality of the information contained within the Farm Bill Master List. The Farm Bill Master List reflects personal data, such as Social Security Numbers, which are a key piece of personal identifiable information to assist you in determining the existence of a lien against a specific debtor. The distribution of this information beyond its intended purpose is strictly prohibited.\n\nThe debtor's tax identification number has been hidden for confidentiality reasons. You may continue to search on a tax ID number and return debtors that match your search criteria. The SSN/FEIN must be entered without dashes or spaces.","searchMustHaveOneOf":["search","UCC_FARM_PRODUCT_ID","COUNTY"],"searchPlaceholder":"Search by debtor name","advancedSearchParameters":[{"type":"ServerMultiComplete","label":"Product code name(s)","name":"UCC_FARM_PRODUCT_ID","defaultValue":"","optionsSrc":"UCC_FARM_PRODUCT_V"},{"type":"MultiComplete","label":"Year or Range of Years","name":"YEAR_NUM","optionsSrc":"years","startYear":"1968","defaultValue":[],"preMergeOptions":[{"value":"ALL","label":"All"}]},{"type":"serverSelect","label":"State","name":"STATE","defaultValue":"MONTANA","optionsSrc":"STATE"},{"type":"ServerMultiComplete","label":"County","name":"COUNTY","defaultValue":[],"optionsSrc":"COUNTY","overrideSubOptionsSrcFromParameterName":"STATE"},{"type":"checkbox","name":"TIN_SEARCH_YN","defaultValue":false,"label":"Tax Identification Number Search"},{"type":"checkbox","name":"TIN_SORT_YN","defaultValue":false,"label":"Unique ID Sort"}]}],"SYSTEM_NICKNAME":"Online Services Portal","PAYMENT_METHODS":[{"type":"bypass"},{"type":"iTransact"}],"PAYMENT_ALLOW_AMEX":true,"SYSTEM_ID_LABEL":"System Id","DOUBLE_COLUMN_PUBLIC_LOGIN":true,"INTERNAL_USER_MANAGEMENT":true,"ALLOW_PUBLIC_JSON_IMPORT":false,"MAX_FILE_UPLOAD_SIZE":10000000,"REFUND_TEXT":"","RETURN_TO_HOME_ON_LOGOUT":true,"CURRENT_SOS_NAME":"Christi Jacobsen","LOGO_FILENAME":"mt-sos-logo.png","LOGO_ALT":"Christi Jacobsen, Montana Secretary of State","LOGO_FULL_WIDTH":true,"HOME_HIDE_AUTH_HINT":true,"HOME_TITLE":"Montana Secretary of State","CUSTOM_TAB_TITLE":"Official Montana","HOME_SUBTITLE":"Online Business Services","ENTITY_NAME_CONSENT_DESCRIPTION":"","ALLOW_USER_PROFILE_EDITING":true,"COMPARE_FOREIGN_NAME_IN_ENTITY_NAME_VALIDATION":true,"FOREIGN_NAME_FIELD_NAME":"KIMA_PARENT_NAME_INFO","LOGIN_TITLE":"Montana Secretary of State Online Filing Portal Login","PUBLIC_LOGIN_LABEL":"Username","REVERSE_LOGIN_COLUMNS":true,"LOGIN_SEAL_FILENAME":"seal_white.png","SEPARATE_USERNAME_AND_EMAIL":true,"CREATE_ACCOUNT_BUTTON_ALIGN_LEFT":true,"CREATE_ACCOUNT_BUTTON_TEXT":"CREATE AN ACCOUNT","PASSWORD_CUSTOM_ERROR_TEXT":"The password must meet all requirements","ACCOUNT_CREATED_MESSAGE":"Please check your email to verify your account to login and allow a few minutes for this message to arrive. Check your junk/spam folders if you do not find the email in your inbox.","PUBLIC_LOGIN_PLACEHOLDER":" ","DISABLE_DEFAULT_PAYMENT_RADIO":true,"CUSTOM_RESET_PASSWORD_ERROR_MESSAGE":"Username invalid - no account found","PUBLIC_LOGIN_CREATE_DESCRIPTION":"### Existing User:\n\n  - Enter your username and password to login.  \n\n\n  #### - OR -  \n\n\n\n  - Forgot password? Click 'Reset Password' and follow the prompts.\n  - Forgot username? Click 'Forgot Username' and follow the prompts.  \n\n\n  ### New User:\n  ","LOGIN_HELP_LINK":"https://sosmt.gov/business/how-do-i/","LOGIN_HELP_LINK_TEXT":"Need Help?","FORGOT_USERNAME_TEXT":"Forgot Username?","LOGIN_ACTIVE_DIRECTORY_TEXT":"State User Login","MULTIPLE_LOGIN_METHODS":true,"HAS_ACTIVE_DIRECTORY_LOGIN":true,"RESET_PASSWORD_WITH_USERNAME":true,"DOWNLOAD_LINK":true,"SHOW_USERNAME_ACCOUNT_CREATE":true,"SHOW_SCROLL_DOWN_ARROW":true,"SHOW_ADDRESS_ACCOUNT_CREATE":true,"TWO_COLUMN_ACCOUNT_CREATE":true,"RESET_PASSWORD_TIP":"A link to change your password has been sent to your email. Please allow a few minutes for this message to arrive. Please check your junk/spam folders if you do not find the email in your inbox.","FORGOT_PASSWORD_LINK_TEXT":"Reset Password","PHONE_NUMBER_OPTIONAL_ACCOUNT_CREATE":true,"SHOW_REQUIRED_INDICATOR_ACCOUNT_CREATE":true,"PASSWORD_REQUIREMENTS_ACCOUNT_CREATE":"\n    <ul>\n      <li>MUST contain at least 8 characters (12+ recommended)</li>\n      <li>MUST contain at least one uppercase letter.</li>\n      <li>MUST contain at least one lowercase letter.</li>\n      <li>MUST contain at least one number.</li>\n      <li>MUST contain at least one special character (!”#$%&'()*+,-./:;<=>?</li>\n    </ul>\n  ","ALLOW_CERTIFICATION_REQUEST":true,"ALLOW_PUBLIC_CERTIFICATE_REQUEST":true,"ALLOW_COPY_REQUEST":false,"ALLOW_CORRECTION_STYLING":true,"HIDE_DEPRECATION_WARNING":false,"AMEND_ROUTE_PUBLIC":true,"SEAL_FILENAME":"seal.png","SHOPPING_CART":true,"ALLOW_PAYMENT_UPDATE_WITH_EMPTY_CART":true,"RA_EMAIL":true,"RA_WEBSITE":true,"RA_NO_DEFAULT_TYPE":true,"RA_ADDRESS_LABEL":"Street Address","RA_TYPE_SELECTION_DEFAULT":true,"RA_DEFAULT_TYPE":"460","RA_OVERRIDE_TYPE_WITH_DEFAULT":true,"RA_PRINCIPAL_ADDRESS_AMS":true,"UPLOAD_AND_SUBMIT_HIDE_IF_ONE_OPTION":true,"PAYMENT_PROCESSING_MESSAGE":"Your payment is processing - Do not close your browser or click the back button","CHECKOUT_BUTTON_WHEN_PROCESSING_TEXT":"Processing","EFS_CROP_PICKER_NONE_LABEL":"Lien Duration","DISALLOWED_WIZARD_PIECES":["FormationLocale"],"REPEATER_SHOW_EDIT_BUTTON":true,"DATA_REQUEST_PAGE_TITLE":"Data Requests and Subscriptions","DATA_REQUEST_SIDEBAR_LABEL":"Data Requests & Subscriptions","LOGIN_REDIRECTS_TO_EPASS":false,"LOGIN_REDIRECTS_TO_ACTIVE_DIRECTORY":true,"LOGIN_ACTIVE_DIRECTORY_LINK":true,"FETCH_EDIT_USER_LINK":false,"LISTS_FETCH_AVAILABLE_LISTS":true,"POST_WIZARD_SUBMIT_REDIRECT_URL":"/","PIN_REQUEST_ATTESTATIONS":true,"PIN_REQUEST_DESCRIPTION":"Click **Request PIN** to have a new PIN sent to the account holder's email address on file.","OWNERSHIP_REQUEST_DESCRIPTION":"To become an **authorized user** of this record, a current **AUTHORIZED USER** will need to grant you access. To request access, click **Request Access** below.","PIN_REQUEST_SUCCESS_MESSAGE":"The PIN you have requested for this entity has been sent to the email associated with your user account.  You should receive the PIN in approximately 3-5 minutes, depending on your email service provider.","APOSTILLE_HEADER_LABEL":"Verification Information","APOSTILLE_NUMBER_LABEL":"Apostille/Authentication","APOSTILLE_CITY_STATE_OVERRIDE":"HELENA, MT","APOSTILLE_FILING_DATE_LABEL":"Issue Date","APOSTILLE_CITY_STATE_IN_CERTIFIED":true,"NOTARY_EXISTING_FILING":true,"ALLOW_REVOKE_OWN_ACCESS_ONLY":false,"HIDE_CANCEL_ON_ONETIME_DATA_REQUESTS":true,"DATA_REQUESTS_IN_SHOPPING_CART":true,"WQ_ALLOW_EDIT_PENDING_PAYMENT":true,"WQ_CONFIRM_ON_DELETE":true,"WQ_DELETE_CONFIRM_MESSAGE":"Deleting this filing will forfeit any money already paid to the Secretary of State. This action is permanent and cannot be undone, are you sure you would like to delete?","PASS_ITEM_GUIDS_ON_CHECKOUT":true,"FORM_REVISION_HISTORY":true,"CHECKOUT_DISCLAIMER":"By entering your credit card and/or checking account information you (i) state that **you are an authorized user** of the credit card and/or electronic check and that the associated information entered (e.g., account holder name, account number, billing address) is accurate, (ii) **you authorize payment processor to charge the amount you have requested** to your credit card and/or funding account, and (iii) **acknowledge if a charge is declined or reversed you may also be assessed a customary charge** by the payment processor for such transactions.","FARM_BILL_SEARCH_CONFIDENTIAL":"As a registered Farm Bill Buyer with the Montana Secretary of State’s office it is important to maintain the confidentiality of the information contained within the Farm Bill Master List. The Farm Bill Master List reflects personal data, such as Social Security Numbers, which are a key piece of personal identifiable information to assist you in determining the existence of a lien against a specific debtor. The distribution of this information beyond its intended purpose is strictly prohibited.\n\n**The debtor's tax identification number has been hidden for confidentiality reasons. You may continue to search on a tax ID number and return debtors that match your search criteria. The SSN/FEIN must be entered without dashes or spaces.  If you need access to the tax identification number to clearly identify the debtor, please contact the UCC unit at (406) 444-3665.**","VIEW_HISTORY_BUTTON_ALT_TEXT":"View Filings","WIZARD_ERROR_TITLE_MESSAGE":"Form Error","FARM_BILL_SEARCH_INTERACTIVE":true,"USE_FARM_BILL_API":true,"DISALLOW_ASSIGN_SELF_AS_RA":true,"DISALLOW_ASSIGN_SELF_AS_PRINCIPAL":true,"USE_TRADEMARK_OWNER_VALIDATION":true,"USE_ALTERNATIVE_FOREIGN_ADDRESS_LABELS":true,"MY_RECEIPTS_FILTER":[{"type":"dateRange","name":"DATE_RANGE","label":"Date range","defaultValue":{"start":null,"end":null}},{"type":"text","name":"REF_NUM","defaultValue":"","label":"Reference Number"},{"type":"text","name":"RECEIPT_NUM","defaultValue":"","label":"Receipt Id"},{"type":"text","name":"AMOUNT","defaultValue":"","label":"Amount"},{"type":"select","name":"TYPE","defaultValue":"","label":"Payment Type","options":[{"value":"","label":"All"},{"value":"CC","label":"Credit Card"},{"value":"Check","label":"Check"}]}],"MY_RECEIPTS_SHOW_IN_SIDEBAR":true,"SHOW_MY_RECEIPTS_HELPER_TEXT":true,"MY_RECEIPTS_HELPER_LABEL":"About Receipt Search","MY_RECEIPTS_HELPER_TEXT":"You can search for receipts based on their descriptions, including the items paid for on the receipt. Use the filters to search for or filter specific information.","FARM_BILL_SUBLINK":{"label":"Farm Bill","component":"FarmBill","parameter":"farm-bill","path":"/lists/farm-bill","sourceTypeId":0,"myRecordsSearch":false,"allowedRules":["/search/"],"disabled":true,"searchDescription":"To perform a search, enter a debtor name. Your search results may include: exact debtor name, variations of that name and any filing that includes your search criteria. Punctuation is ignored.\n\nYou can click on \"Advanced\" to refine your search. Under “Advanced” you can search by crop, year, county and SSN/FEIN. As a registered Farm Bill Buyer with the Montana Secretary of State’s office it is important to maintain the confidentiality of the information contained within the Farm Bill Master List. The Farm Bill Master List reflects personal data, such as Social Security Numbers, which are a key piece of personal identifiable information to assist you in determining the existence of a lien against a specific debtor. The distribution of this information beyond its intended purpose is strictly prohibited.\n\nThe debtor's tax identification number has been hidden for confidentiality reasons. You may continue to search on a tax ID number and return debtors that match your search criteria. The SSN/FEIN must be entered without dashes or spaces.","searchMustHaveOneOf":["search","UCC_FARM_PRODUCT_ID","COUNTY"],"searchPlaceholder":"Search by debtor name","advancedSearchParameters":[{"type":"ServerMultiComplete","label":"Product code name(s)","name":"UCC_FARM_PRODUCT_ID","defaultValue":"","optionsSrc":"UCC_FARM_PRODUCT_V"},{"type":"MultiComplete","label":"Year or Range of Years","name":"YEAR_NUM","optionsSrc":"years","startYear":"1968","defaultValue":[],"preMergeOptions":[{"value":"ALL","label":"All"}]},{"type":"serverSelect","label":"State","name":"STATE","defaultValue":"MONTANA","optionsSrc":"STATE"},{"type":"ServerMultiComplete","label":"County","name":"COUNTY","defaultValue":[],"optionsSrc":"COUNTY","overrideSubOptionsSrcFromParameterName":"STATE"},{"type":"checkbox","name":"TIN_SEARCH_YN","defaultValue":false,"label":"Tax Identification Number Search"},{"type":"checkbox","name":"TIN_SORT_YN","defaultValue":false,"label":"Unique ID Sort"}]},"ALLOW_ADDRESS_VALIDATION_BYPASS_OPTION":true,"DEFAULT_ADDRESS_VALIDATION_BYPASS_OPTION_CHECKED":true}).MY_RECORDS_DESCRIPTION;
	
	var MyRecords = function (_Component) {
	  _inherits(MyRecords, _Component);
	
	  function MyRecords(props) {
	    _classCallCheck(this, MyRecords);
	
	    var _this = _possibleConstructorReturn(this, (MyRecords.__proto__ || Object.getPrototypeOf(MyRecords)).call(this, props));
	
	    _initialiseProps.call(_this);
	
	    _this.state = {
	      ownershipModalOpen: false,
	      amendmentLauncherOpen: false,
	      reinstatementModelOpen: false
	    };
	    return _this;
	  }
	
	  _createClass(MyRecords, [{
	    key: 'renderEmptyResults',
	    value: function renderEmptyResults(props, sublink) {
	      var renderEmpty = !MY_RECORDS_DISABLE_EMPTY_STATE && !props.loading && props.orderedRecords && !props.orderedRecords.rows.length;
	
	      if (renderEmpty) {
	        var line1 = 'Looks like you don\'t have any ' + this.getLowercaseSublinkLabel(sublink) + ' records yet';
	        var line2 = 'Visit ' + this.getLowercaseSublinkLabel(sublink) + ' forms to create your first record';
	        if (MY_RECORDS_EMPTY_STATE_LINE_1) {
	          line1 = this.getMergedEmptyStateText(MY_RECORDS_EMPTY_STATE_LINE_1, sublink);
	        }
	        if (MY_RECORDS_EMPTY_STATE_LINE_2) {
	          line2 = this.getMergedEmptyStateText(MY_RECORDS_EMPTY_STATE_LINE_2, sublink);
	        }
	        return _react2.default.createElement(
	          'div',
	          { className: 'empty-placeholder-wrapper' },
	          _react2.default.createElement(_EmptyBox2.default, null),
	          _react2.default.createElement(
	            'h2',
	            null,
	            line1
	          ),
	          _react2.default.createElement(
	            'p',
	            null,
	            line2
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'flex-row center' },
	            _react2.default.createElement(
	              _reactRouterDom.Link,
	              { className: 'btn btn-primary btn-raised', to: '/forms/' + sublink.parameter },
	              'Go to ',
	              this.getLowercaseSublinkLabel(sublink),
	              ' forms'
	            ),
	            _react2.default.createElement(
	              'p',
	              { className: 'or' },
	              'or'
	            ),
	            _react2.default.createElement(
	              _reactRouterDom.Link,
	              { className: 'btn btn-neutral', to: '/search/' + sublink.parameter },
	              'Search ',
	              this.getLowercaseSublinkLabel(sublink),
	              ' records'
	            )
	          )
	        );
	      } else {
	        return null;
	      }
	    }
	  }, {
	    key: 'renderPageData',
	    value: function renderPageData(props) {
	      if (props.error) {
	        return _react2.default.createElement(_PageError.PageError, { errorDetails: props.errorDetails });
	      } else if (!props.orderedRecords) {
	        return _react2.default.createElement(_Loaders.Spinner, { className: 'page-loader' });
	      } else {
	        var actionMap = {
	          default: [{
	            iconClass: '',
	            label: 'View Filing',
	            className: 'primary',
	            onClick: this.selectRow,
	            children: _react2.default.createElement(_document2.default, null)
	          }]
	        };
	        return _react2.default.createElement(_Table2.default, {
	          label: 'My Records',
	          template: props.orderedRecords.template,
	          rows: props.orderedRecords.rows,
	          className: 'center-container',
	          actionMap: actionMap,
	          actionCell: true,
	          onCellClick: this.selectRow,
	          selectedRowIndex: props.orderedRecords.rows ? props.orderedRecords.rows.findIndex(function (row) {
	            return row.ID === props.selectedId;
	          }) : false,
	          animated: false,
	          rowCount: true
	        });
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          loading = _props.loading,
	          records = _props.records,
	          selectedId = _props.selectedId,
	          showSelected = _props.showSelected,
	          activeCategory = _props.activeCategory,
	          sublinks = _props.sublinks,
	          serverDescription = _props.serverDescription,
	          filters = _props.filters,
	          isMobile = _props.isMobile;
	
	      var category = this.props.match.params.subParam;
	      var selectedRecord = records[selectedId];
	      var selectedTitle = selectedRecord ? selectedRecord.TITLE[0] : '';
	      var selectedSubtitle = selectedRecord ? selectedRecord.TITLE[1] : '';
	      var sublink = sublinks.find(function (l) {
	        return l.parameter === category;
	      }) || {};
	      var activeFilters = filters[category] || {};
	
	      return _react2.default.createElement(
	        _Shell.Body,
	        {
	          className: 'my-records',
	          showDrawer: showSelected,
	          onResize: this.onBodyResize,
	          hiddenTitle: 'My Records'
	        },
	        !this.props.match.params.subParam && _react2.default.createElement(_reactRouterDom.Redirect, {
	          to: this.props.location.pathname + '/' + (activeCategory ? activeCategory : this.props.sublinks[0].parameter)
	        }),
	        _react2.default.createElement(_TableControls2.default, {
	          title: 'My ' + sublink.label + ' Records',
	          description: serverDescription || sublink.myRecordsDescription || MY_RECORDS_DESCRIPTION || '',
	          filterTemplates: sublink.myRecordsFilters,
	          filters: activeFilters,
	          onFilterChange: this.setFilters,
	          allowSearch: sublink.myRecordsSearch !== false,
	          loading: loading,
	          searchPlaceholder: MY_RECORDS_SEARCH_PLACEHOLDER || 'Search My Records'
	        }),
	        this.renderPageData(this.props),
	        this.renderEmptyResults(this.props, sublink),
	        _react2.default.createElement(_RecordDrawer2.default, {
	          show: isMobile ? selectedId ? true : false : showSelected,
	          title: selectedTitle,
	          subtitle: selectedSubtitle,
	          category: category,
	          sourceId: selectedRecord && selectedRecord.ID,
	          recordNum: selectedRecord && selectedRecord.RECORD_NUM,
	          canFileAR: selectedRecord && selectedRecord.CAN_FILE_AR,
	          canReinstate: selectedRecord && selectedRecord.CAN_REINSTATE,
	          canFileReinstatement: selectedRecord && selectedRecord.CAN_FILE_REINSTATEMENT,
	          showCopyRequests: selectedRecord && selectedRecord.SHOW_COPY_REQUESTS,
	          userOwnsCurrentRecord: ({"NODE_ENV":"production","BUILD_DATE":"2025-08-27T15:15:31.687Z","BUILD_NUMBER":"Not Provided","GIT_VERSION":"v1.3.0-381-ga81e29b08","GIT_COMMIT_HASH":"a81e29b085c9268ffd96c78eb734365802722741","GIT_BRANCH":"beta","PUBLIC_URL":"","STATE_ABBR":"MT","STATE_NAME":"Montana","STATE_ORG_TITLE":"Secretary of State","LOGIN_HEADER_IMG_PATH":"","HOME_IMG_FILENAME":"montana.jpg","FAVICON_FILE_NAME":"favicon.ico","ALLOW_E_SIGN_ON_CORRECTIONS":true,"THIRD_PARTY_SIGNING_ALLOWED":false,"MY_ACCOUNT_SAVE_AND_CLOSE_BUTTON":true,"IE_DEPRECATED_MESSAGE":"Internet Explorer is not supported. Please select a supported browser below to access this website.","ADDITIONAL_ROUTES":{"dataRequests":true,"farmBill":true,"apostille":true,"externalHelp":"https://sosmt.gov/business/help-center/","systemAdministration":[{"title":"Saved Payments","parameter":"saved-payments","componentName":"SavedPayments"}]},"SUBROUTES":[{"label":"Business","component":"Business","parameter":"business","myWorkQueueSearch":false,"sourceTypeId":54,"searchMustHaveOneOf":["FILING_TYPE_ID","STATUS_ID","STATE","search"],"serverWebSearchDescription":true,"serverWorkQueueDescription":true,"serverMyRecordsDescription":true,"searchPlaceholder":"Search by name or filing number (X########)","allowEmptySearchTerm":true,"requestCertificateAlternateLabel":"Request Information","fileAmendmentButtonLabel":"Filing Actions","advancedSearchParameters":[{"type":"radio","name":"QUERY_TYPE_ID","defaultValue":1010,"options":[{"value":1010,"label":"Starts with"},{"value":1011,"label":"Contains"},{"value":1012,"label":" Word Contains"}]},{"type":"serverSelect","name":"FILING_TYPE_ID","optionsSrc":"FILING_TYPES","label":"Entity Type","placeholder":"All","defaultValue":"0"},{"type":"serverSelect","name":"FILING_SUBTYPE_ID","optionsSrc":"FILING_SUBTYPES","label":"Entity Subtype","overrideSubOptionsSrcFromParameterName":"FILING_TYPE_ID","placeholder":"All","defaultValue":"0"},{"type":"serverSelect","name":"STATUS_ID","optionsSrc":"FILING_STATUS_WITHOUT_ALL","label":"Status","placeholder":"All","defaultValue":"0"},{"type":"serverSelect","name":"STATE","optionsSrc":"STATE","label":"State","placeholder":"All","defaultValue":""},{"type":"serverSelect","name":"COUNTY","optionsSrc":"COUNTY_SUBOPTION","label":"County","overrideSubOptionsSrcFromParameterName":"STATE","placeholder":"All","defaultValue":""},{"type":"checkbox","name":"CRA_SEARCH_YN","defaultValue":false,"label":"Search by Registered Agent PID"},{"type":"dateRange","name":"FILING_DATE","label":"Registration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}},{"type":"dateRange","name":"EXPIRATION_DATE","label":"Expiration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}}],"myRecordsFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Active"},{"value":2,"label":"Inactive"},{"value":3,"label":"Pending"}]},{"type":"dateRange","name":"DATE_RANGE","label":"Date range","defaultValue":{"start":null,"end":null}}],"myWorkQueueFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Approved"},{"value":2,"label":"Pending Online Payment"},{"value":3,"label":"Pending Review"},{"value":4,"label":"Needs Correction"},{"value":5,"label":"Rejected"},{"value":6,"label":"Draft"}]},{"type":"dateRange","name":"DATE_RANGE","label":"Date range","defaultValue":{"start":null,"end":null}}]},{"label":"Notary","component":"Notary","parameter":"notary","sourceTypeId":850,"myWorkQueueSearch":false,"allowEmptySearchTerm":true,"requestCertificateAlternateLabel":"Download Certificate","fileAmendmentButtonLabel":"Filing Actions","hideNameRequestCertificate":true,"hideAddressRequestCertificate":true,"hideRecordUserManagment":true,"searchPlaceholder":"Search by name or commission number","searchMustHaveOneOf":["CITY","search","SERVICE_TYPE"],"advancedParametersStartOpen":true,"searchIsSortable":true,"advancedSearchParameters":[{"type":"radio","name":"STARTS_WITH_YN","defaultValue":false,"options":[{"value":true,"label":"Starts with"},{"value":false,"label":"Contains"}]},{"type":"checkbox","name":"ACTIVE_ONLY_YN","defaultValue":true,"label":"Active entities only"},{"type":"text","name":"CITY","defaultValue":"","label":"City"},{"type":"select","name":"SERVICE_TYPE","label":"Special Services Offered","defaultValue":0,"options":[{"value":0,"label":"(N/A)"},{"value":6165,"label":"In-Person Electronic Notarization (IPEN)"},{"value":6166,"label":"Remote Online Notarization (RON)"},{"value":6167,"label":"Mobile Notary Services"},{"value":6168,"label":"Remote Ink Notarization (RIN)"}]}]},{"label":"Apostille","component":"Apostille","parameter":"apostille","sourceTypeId":720,"myRecordsSearch":false,"myWorkQueueSearch":false,"disabled":false,"allowedRoutes":["/forms-manager/","/queue/","/forms/"]},{"label":"Liens","component":"UCC","parameter":"ucc","sourceTypeId":1999,"myRecordsSearch":true,"myWorkQueueSearch":true,"fileAmendmentButtonLabel":"Filing Actions","searchPlaceholder":"Search by name or file number","disabled":false,"serverWebSearchDescription":true,"myRecordsDescription":"","workQueueDescription":"","searchDescription":"","hideRecordUserManagment":true,"searchLiensCheckout":false,"advancedSearchParameters":[{"type":"radio","name":"STARTS_WITH_YN","defaultValue":false,"options":[{"value":true,"label":"Starts with"},{"value":false,"label":"Contains"}]},{"type":"select","name":"STATUS","defaultValue":"ALL","label":"Status","options":[{"value":"ACTIVE_UNLAPSED","label":"Active (unlapsed)"},{"value":"ACTIVE_LAPSED_UNLAPSED","label":"Active (lapsed and unlapsed)"}]},{"type":"text","name":"EXCLUDE_VALUES","label":"Exclude Debtor Names (comma separated list of names to exclude)","defaultValue":""},{"type":"dateRange","name":"FILING_DATE","label":"Financing Statement Date","defaultValue":{"start":null,"end":null}},{"type":"dateRange","name":"LAPSE_DATE","label":"Lapse Date","defaultValue":{"start":null,"end":null}},{"type":"text","name":"CITY","label":"Debtor City","defaultValue":""}],"myRecordsFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Approved"},{"value":2,"label":"Pending Online Payment"},{"value":3,"label":"Pending Review"}]},{"type":"select","name":"TYPE","defaultValue":0,"label":"Lien Type","options":[{"value":0,"label":"All"},{"value":1,"label":"UCC"},{"value":2,"label":"EFS"},{"value":3,"label":"Title 71"}]}],"myWorkQueueFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Approved"},{"value":2,"label":"Pending Online Payment"},{"value":3,"label":"Pending Review"},{"value":4,"label":"Pending Print and Mail"},{"value":5,"label":"Rejected"},{"value":6,"label":"Draft"}]},{"type":"select","name":"TYPE","defaultValue":0,"label":"Lien Type","options":[{"value":0,"label":"All"},{"value":1,"label":"UCC"},{"value":2,"label":"EFS"},{"value":3,"label":"Title 71"}]}]},{"label":"Copy Request","component":"copies","parameter":"copies","sourceTypeId":2001,"myRecordsSearch":false,"myWorkQueueSearch":false,"disabled":false,"allowedRoutes":["/forms-manager/","/queue/","/forms/"]},{"label":"Trademark","component":"Trademark","parameter":"trademark","sourceTypeId":810,"showRequestCertificate":true,"searchMustHaveOneOf":["search","EXPIRATION_DATE","FILING_DATE"],"allowEmptySearchTerm":true,"requestCertificateAlternateLabel":"Request Information","fileAmendmentButtonLabel":"Filing Actions","advancedSearchParameters":[{"type":"radio","name":"QUERY_TYPE_ID","defaultValue":1010,"options":[{"value":1010,"label":"Starts with"},{"value":1011,"label":"Contains"},{"value":1012,"label":" Word Contains"}]},{"type":"checkbox","name":"OWNER_SEARCH_YN","defaultValue":false,"label":"Search owners"},{"type":"radio","name":"SERVICE_MARK_YN","label":"Mark Type","defaultValue":"","options":[{"value":"","label":"All Marks"},{"value":"Y","label":"Service Mark"},{"value":"N","label":"Trademark"}]},{"type":"serverSelect","name":"STATUS_ID","optionsSrc":"TYPE_V|TRADEMARK_STATUS_TYPE","label":"Status","placeholder":"All","defaultValue":"0"},{"type":"select","name":"DESIGN_TYPE_ID","options":[{"value":0,"label":"All"},{"value":990,"label":"Words Only"},{"value":991,"label":"Design Only"},{"value":992,"label":"Words and Design"}],"label":"Design Type","defaultValue":"0"},{"type":"dateRange","name":"FILING_DATE","label":"Registered Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}},{"type":"dateRange","name":"EXPIRATION_DATE","label":"Expiration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}}]},{"label":"Business Info Request","component":"InfoRequests","parameter":"info-request","sourceTypeId":167,"allowedRoutes":["/forms-manager/","/queue/","/forms/"]},{"label":"Data Requests","component":"DataRequests","parameter":"data-request","sourceTypeId":0,"allowedRoutes":["/forms-manager/"]},{"label":"CRA","component":"CRA","parameter":"cra","sourceTypeId":157,"myRecordsSearch":false,"searchPlaceholder":"Search by name or registered agent number","allowedRoutes":["/forms-manager/","/forms/","/records/","/queue/","/search/"],"allowEmptySearchTerm":true,"fileAmendmentButtonLabel":"Filing Actions","advancedSearchParameters":[{"type":"radio","name":"QUERY_TYPE_ID","defaultValue":1010,"options":[{"value":1010,"label":"Starts with"},{"value":1011,"label":"Contains"},{"value":1012,"label":" Word Contains"}]},{"type":"dateRange","name":"CRA_DATE","label":"Registration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}},{"type":"select","name":"STATUS_ID","label":"Status","defaultValue":0,"options":[{"value":0,"label":"All"},{"value":121,"label":"Active"},{"value":122,"label":"Inactive"}]},{"type":"select","name":"AGENT_TYPE_ID","label":"Agent Type","defaultValue":0,"options":[{"value":0,"label":"All"},{"value":460,"label":"Registered Agent"},{"value":461,"label":"Commercial Registered Agent"}]}]},{"label":"Farm Bill","component":"FarmBill","parameter":"farm-bill","path":"/lists/farm-bill","sourceTypeId":0,"myRecordsSearch":false,"allowedRules":["/search/"],"disabled":true,"searchDescription":"To perform a search, enter a debtor name. Your search results may include: exact debtor name, variations of that name and any filing that includes your search criteria. Punctuation is ignored.\n\nYou can click on \"Advanced\" to refine your search. Under “Advanced” you can search by crop, year, county and SSN/FEIN. As a registered Farm Bill Buyer with the Montana Secretary of State’s office it is important to maintain the confidentiality of the information contained within the Farm Bill Master List. The Farm Bill Master List reflects personal data, such as Social Security Numbers, which are a key piece of personal identifiable information to assist you in determining the existence of a lien against a specific debtor. The distribution of this information beyond its intended purpose is strictly prohibited.\n\nThe debtor's tax identification number has been hidden for confidentiality reasons. You may continue to search on a tax ID number and return debtors that match your search criteria. The SSN/FEIN must be entered without dashes or spaces.","searchMustHaveOneOf":["search","UCC_FARM_PRODUCT_ID","COUNTY"],"searchPlaceholder":"Search by debtor name","advancedSearchParameters":[{"type":"ServerMultiComplete","label":"Product code name(s)","name":"UCC_FARM_PRODUCT_ID","defaultValue":"","optionsSrc":"UCC_FARM_PRODUCT_V"},{"type":"MultiComplete","label":"Year or Range of Years","name":"YEAR_NUM","optionsSrc":"years","startYear":"1968","defaultValue":[],"preMergeOptions":[{"value":"ALL","label":"All"}]},{"type":"serverSelect","label":"State","name":"STATE","defaultValue":"MONTANA","optionsSrc":"STATE"},{"type":"ServerMultiComplete","label":"County","name":"COUNTY","defaultValue":[],"optionsSrc":"COUNTY","overrideSubOptionsSrcFromParameterName":"STATE"},{"type":"checkbox","name":"TIN_SEARCH_YN","defaultValue":false,"label":"Tax Identification Number Search"},{"type":"checkbox","name":"TIN_SORT_YN","defaultValue":false,"label":"Unique ID Sort"}]}],"SYSTEM_NICKNAME":"Online Services Portal","PAYMENT_METHODS":[{"type":"bypass"},{"type":"iTransact"}],"PAYMENT_ALLOW_AMEX":true,"SYSTEM_ID_LABEL":"System Id","DOUBLE_COLUMN_PUBLIC_LOGIN":true,"INTERNAL_USER_MANAGEMENT":true,"ALLOW_PUBLIC_JSON_IMPORT":false,"MAX_FILE_UPLOAD_SIZE":10000000,"REFUND_TEXT":"","RETURN_TO_HOME_ON_LOGOUT":true,"CURRENT_SOS_NAME":"Christi Jacobsen","LOGO_FILENAME":"mt-sos-logo.png","LOGO_ALT":"Christi Jacobsen, Montana Secretary of State","LOGO_FULL_WIDTH":true,"HOME_HIDE_AUTH_HINT":true,"HOME_TITLE":"Montana Secretary of State","CUSTOM_TAB_TITLE":"Official Montana","HOME_SUBTITLE":"Online Business Services","ENTITY_NAME_CONSENT_DESCRIPTION":"","ALLOW_USER_PROFILE_EDITING":true,"COMPARE_FOREIGN_NAME_IN_ENTITY_NAME_VALIDATION":true,"FOREIGN_NAME_FIELD_NAME":"KIMA_PARENT_NAME_INFO","LOGIN_TITLE":"Montana Secretary of State Online Filing Portal Login","PUBLIC_LOGIN_LABEL":"Username","REVERSE_LOGIN_COLUMNS":true,"LOGIN_SEAL_FILENAME":"seal_white.png","SEPARATE_USERNAME_AND_EMAIL":true,"CREATE_ACCOUNT_BUTTON_ALIGN_LEFT":true,"CREATE_ACCOUNT_BUTTON_TEXT":"CREATE AN ACCOUNT","PASSWORD_CUSTOM_ERROR_TEXT":"The password must meet all requirements","ACCOUNT_CREATED_MESSAGE":"Please check your email to verify your account to login and allow a few minutes for this message to arrive. Check your junk/spam folders if you do not find the email in your inbox.","PUBLIC_LOGIN_PLACEHOLDER":" ","DISABLE_DEFAULT_PAYMENT_RADIO":true,"CUSTOM_RESET_PASSWORD_ERROR_MESSAGE":"Username invalid - no account found","PUBLIC_LOGIN_CREATE_DESCRIPTION":"### Existing User:\n\n  - Enter your username and password to login.  \n\n\n  #### - OR -  \n\n\n\n  - Forgot password? Click 'Reset Password' and follow the prompts.\n  - Forgot username? Click 'Forgot Username' and follow the prompts.  \n\n\n  ### New User:\n  ","LOGIN_HELP_LINK":"https://sosmt.gov/business/how-do-i/","LOGIN_HELP_LINK_TEXT":"Need Help?","FORGOT_USERNAME_TEXT":"Forgot Username?","LOGIN_ACTIVE_DIRECTORY_TEXT":"State User Login","MULTIPLE_LOGIN_METHODS":true,"HAS_ACTIVE_DIRECTORY_LOGIN":true,"RESET_PASSWORD_WITH_USERNAME":true,"DOWNLOAD_LINK":true,"SHOW_USERNAME_ACCOUNT_CREATE":true,"SHOW_SCROLL_DOWN_ARROW":true,"SHOW_ADDRESS_ACCOUNT_CREATE":true,"TWO_COLUMN_ACCOUNT_CREATE":true,"RESET_PASSWORD_TIP":"A link to change your password has been sent to your email. Please allow a few minutes for this message to arrive. Please check your junk/spam folders if you do not find the email in your inbox.","FORGOT_PASSWORD_LINK_TEXT":"Reset Password","PHONE_NUMBER_OPTIONAL_ACCOUNT_CREATE":true,"SHOW_REQUIRED_INDICATOR_ACCOUNT_CREATE":true,"PASSWORD_REQUIREMENTS_ACCOUNT_CREATE":"\n    <ul>\n      <li>MUST contain at least 8 characters (12+ recommended)</li>\n      <li>MUST contain at least one uppercase letter.</li>\n      <li>MUST contain at least one lowercase letter.</li>\n      <li>MUST contain at least one number.</li>\n      <li>MUST contain at least one special character (!”#$%&'()*+,-./:;<=>?</li>\n    </ul>\n  ","ALLOW_CERTIFICATION_REQUEST":true,"ALLOW_PUBLIC_CERTIFICATE_REQUEST":true,"ALLOW_COPY_REQUEST":false,"ALLOW_CORRECTION_STYLING":true,"HIDE_DEPRECATION_WARNING":false,"AMEND_ROUTE_PUBLIC":true,"SEAL_FILENAME":"seal.png","SHOPPING_CART":true,"ALLOW_PAYMENT_UPDATE_WITH_EMPTY_CART":true,"RA_EMAIL":true,"RA_WEBSITE":true,"RA_NO_DEFAULT_TYPE":true,"RA_ADDRESS_LABEL":"Street Address","RA_TYPE_SELECTION_DEFAULT":true,"RA_DEFAULT_TYPE":"460","RA_OVERRIDE_TYPE_WITH_DEFAULT":true,"RA_PRINCIPAL_ADDRESS_AMS":true,"UPLOAD_AND_SUBMIT_HIDE_IF_ONE_OPTION":true,"PAYMENT_PROCESSING_MESSAGE":"Your payment is processing - Do not close your browser or click the back button","CHECKOUT_BUTTON_WHEN_PROCESSING_TEXT":"Processing","EFS_CROP_PICKER_NONE_LABEL":"Lien Duration","DISALLOWED_WIZARD_PIECES":["FormationLocale"],"REPEATER_SHOW_EDIT_BUTTON":true,"DATA_REQUEST_PAGE_TITLE":"Data Requests and Subscriptions","DATA_REQUEST_SIDEBAR_LABEL":"Data Requests & Subscriptions","LOGIN_REDIRECTS_TO_EPASS":false,"LOGIN_REDIRECTS_TO_ACTIVE_DIRECTORY":true,"LOGIN_ACTIVE_DIRECTORY_LINK":true,"FETCH_EDIT_USER_LINK":false,"LISTS_FETCH_AVAILABLE_LISTS":true,"POST_WIZARD_SUBMIT_REDIRECT_URL":"/","PIN_REQUEST_ATTESTATIONS":true,"PIN_REQUEST_DESCRIPTION":"Click **Request PIN** to have a new PIN sent to the account holder's email address on file.","OWNERSHIP_REQUEST_DESCRIPTION":"To become an **authorized user** of this record, a current **AUTHORIZED USER** will need to grant you access. To request access, click **Request Access** below.","PIN_REQUEST_SUCCESS_MESSAGE":"The PIN you have requested for this entity has been sent to the email associated with your user account.  You should receive the PIN in approximately 3-5 minutes, depending on your email service provider.","APOSTILLE_HEADER_LABEL":"Verification Information","APOSTILLE_NUMBER_LABEL":"Apostille/Authentication","APOSTILLE_CITY_STATE_OVERRIDE":"HELENA, MT","APOSTILLE_FILING_DATE_LABEL":"Issue Date","APOSTILLE_CITY_STATE_IN_CERTIFIED":true,"NOTARY_EXISTING_FILING":true,"ALLOW_REVOKE_OWN_ACCESS_ONLY":false,"HIDE_CANCEL_ON_ONETIME_DATA_REQUESTS":true,"DATA_REQUESTS_IN_SHOPPING_CART":true,"WQ_ALLOW_EDIT_PENDING_PAYMENT":true,"WQ_CONFIRM_ON_DELETE":true,"WQ_DELETE_CONFIRM_MESSAGE":"Deleting this filing will forfeit any money already paid to the Secretary of State. This action is permanent and cannot be undone, are you sure you would like to delete?","PASS_ITEM_GUIDS_ON_CHECKOUT":true,"FORM_REVISION_HISTORY":true,"CHECKOUT_DISCLAIMER":"By entering your credit card and/or checking account information you (i) state that **you are an authorized user** of the credit card and/or electronic check and that the associated information entered (e.g., account holder name, account number, billing address) is accurate, (ii) **you authorize payment processor to charge the amount you have requested** to your credit card and/or funding account, and (iii) **acknowledge if a charge is declined or reversed you may also be assessed a customary charge** by the payment processor for such transactions.","FARM_BILL_SEARCH_CONFIDENTIAL":"As a registered Farm Bill Buyer with the Montana Secretary of State’s office it is important to maintain the confidentiality of the information contained within the Farm Bill Master List. The Farm Bill Master List reflects personal data, such as Social Security Numbers, which are a key piece of personal identifiable information to assist you in determining the existence of a lien against a specific debtor. The distribution of this information beyond its intended purpose is strictly prohibited.\n\n**The debtor's tax identification number has been hidden for confidentiality reasons. You may continue to search on a tax ID number and return debtors that match your search criteria. The SSN/FEIN must be entered without dashes or spaces.  If you need access to the tax identification number to clearly identify the debtor, please contact the UCC unit at (406) 444-3665.**","VIEW_HISTORY_BUTTON_ALT_TEXT":"View Filings","WIZARD_ERROR_TITLE_MESSAGE":"Form Error","FARM_BILL_SEARCH_INTERACTIVE":true,"USE_FARM_BILL_API":true,"DISALLOW_ASSIGN_SELF_AS_RA":true,"DISALLOW_ASSIGN_SELF_AS_PRINCIPAL":true,"USE_TRADEMARK_OWNER_VALIDATION":true,"USE_ALTERNATIVE_FOREIGN_ADDRESS_LABELS":true,"MY_RECEIPTS_FILTER":[{"type":"dateRange","name":"DATE_RANGE","label":"Date range","defaultValue":{"start":null,"end":null}},{"type":"text","name":"REF_NUM","defaultValue":"","label":"Reference Number"},{"type":"text","name":"RECEIPT_NUM","defaultValue":"","label":"Receipt Id"},{"type":"text","name":"AMOUNT","defaultValue":"","label":"Amount"},{"type":"select","name":"TYPE","defaultValue":"","label":"Payment Type","options":[{"value":"","label":"All"},{"value":"CC","label":"Credit Card"},{"value":"Check","label":"Check"}]}],"MY_RECEIPTS_SHOW_IN_SIDEBAR":true,"SHOW_MY_RECEIPTS_HELPER_TEXT":true,"MY_RECEIPTS_HELPER_LABEL":"About Receipt Search","MY_RECEIPTS_HELPER_TEXT":"You can search for receipts based on their descriptions, including the items paid for on the receipt. Use the filters to search for or filter specific information.","FARM_BILL_SUBLINK":{"label":"Farm Bill","component":"FarmBill","parameter":"farm-bill","path":"/lists/farm-bill","sourceTypeId":0,"myRecordsSearch":false,"allowedRules":["/search/"],"disabled":true,"searchDescription":"To perform a search, enter a debtor name. Your search results may include: exact debtor name, variations of that name and any filing that includes your search criteria. Punctuation is ignored.\n\nYou can click on \"Advanced\" to refine your search. Under “Advanced” you can search by crop, year, county and SSN/FEIN. As a registered Farm Bill Buyer with the Montana Secretary of State’s office it is important to maintain the confidentiality of the information contained within the Farm Bill Master List. The Farm Bill Master List reflects personal data, such as Social Security Numbers, which are a key piece of personal identifiable information to assist you in determining the existence of a lien against a specific debtor. The distribution of this information beyond its intended purpose is strictly prohibited.\n\nThe debtor's tax identification number has been hidden for confidentiality reasons. You may continue to search on a tax ID number and return debtors that match your search criteria. The SSN/FEIN must be entered without dashes or spaces.","searchMustHaveOneOf":["search","UCC_FARM_PRODUCT_ID","COUNTY"],"searchPlaceholder":"Search by debtor name","advancedSearchParameters":[{"type":"ServerMultiComplete","label":"Product code name(s)","name":"UCC_FARM_PRODUCT_ID","defaultValue":"","optionsSrc":"UCC_FARM_PRODUCT_V"},{"type":"MultiComplete","label":"Year or Range of Years","name":"YEAR_NUM","optionsSrc":"years","startYear":"1968","defaultValue":[],"preMergeOptions":[{"value":"ALL","label":"All"}]},{"type":"serverSelect","label":"State","name":"STATE","defaultValue":"MONTANA","optionsSrc":"STATE"},{"type":"ServerMultiComplete","label":"County","name":"COUNTY","defaultValue":[],"optionsSrc":"COUNTY","overrideSubOptionsSrcFromParameterName":"STATE"},{"type":"checkbox","name":"TIN_SEARCH_YN","defaultValue":false,"label":"Tax Identification Number Search"},{"type":"checkbox","name":"TIN_SORT_YN","defaultValue":false,"label":"Unique ID Sort"}]},"ALLOW_ADDRESS_VALIDATION_BYPASS_OPTION":true,"DEFAULT_ADDRESS_VALIDATION_BYPASS_OPTION_CHECKED":true}).USER_ACCESS_LEVEL_MANAGEMENT ? false : true,
	          canAlwaysFileAR: selectedRecord && selectedRecord.CAN_ALWAYS_FILE_AR,
	          onRequestRecordsRefresh: this.getRecords,
	          sublink: sublink,
	          onSidebarDismiss: this.clearSelection
	        })
	      );
	    }
	  }]);
	
	  return MyRecords;
	}(_react.Component);
	
	var _initialiseProps = function _initialiseProps() {
	  var _this2 = this;
	
	  this.componentDidMount = function () {
	    if (_this2.props.match.params.subParam) {
	      if (!_App.SUBROUTES_OBJ[_this2.props.match.params.subParam] || !(_App.SUBROUTES_OBJ[_this2.props.match.params.subParam].allowedRoutes || ['/records/']).includes('/records/')) {
	        _this2.props.history.replace('/records/' + _this2.props.sublinks.find(function (x) {
	          return (x.allowedRoutes || ['/records/']).includes('/records/');
	        }).parameter);
	      } else {
	        _this2.props.setActiveCategory(_this2.props.match.params.subParam);
	        _this2.getRecords();
	        if (_App.SUBROUTES_OBJ[_this2.props.match.params.subParam].serverMyRecordsDescription && !_this2.props.serverDescription) {
	          _this2.props.getMyRecordsDescription(_this2.props.match.params.subParam);
	        }
	      }
	    }
	  };
	
	  this.componentDidUpdate = function (prevProps) {
	    var module = window.location.href.split('/').pop();
	    if (module !== _this2.state.module) _this2.setState(function (state) {
	      return state = Object.assign({}, state, { module: module });
	    });
	    if (_this2.props.match.params.subParam !== prevProps.match.params.subParam) {
	      if (_App.SUBROUTES_OBJ[_this2.props.match.params.subParam] && (_App.SUBROUTES_OBJ[_this2.props.match.params.subParam].allowedRoutes || ['/records/']).includes('/records/')) {
	        _this2.props.setActiveCategory(_this2.props.match.params.subParam);
	        _this2.getRecords(_this2.props.match.params.subParam);
	      } else {
	        _this2.props.history.replace('/records/' + _this2.props.sublinks.find(function (x) {
	          return (x.allowedRoutes || ['/records/']).includes('/records/');
	        }).parameter);
	      }
	    }
	  };
	
	  this.getRecords = function (nextCategory) {
	    _this2.props.pullAndSetMyRecords(nextCategory || _this2.props.match.params.subParam || _this2.props.sublinks[0].parameter);
	  };
	
	  this.onBodyResize = function (_ref) {
	    var width = _ref.width,
	        height = _ref.height;
	
	    if (width < 500 && _this2.props.resultsMode === 'table') {
	      _this2.props.setMyRecordsResultsMode('cards');
	    } else if (width >= 500 && _this2.props.resultsMode === 'cards') {
	      _this2.props.setMyRecordsResultsMode('table');
	    }
	  };
	
	  this.selectRow = function (row) {
	    _this2.props.selectMyRecordsRowAndGetDetails(_this2.props.match.params.subParam, _this2.props.selectedId === row.ID ? null : row.ID);
	  };
	
	  this.formatForCards = function (template, rows) {
	    var cards = rows.map(function (row, i) {
	      return {
	        title: row[template[0].id],
	        alert: row.ALERT_YN,
	        details: _this2.formatRowDetails(template.slice(1), row),
	        recordId: row.RECORD_ID,
	        data: row
	      };
	    });
	    return cards;
	  };
	
	  this.clearSelection = function () {
	    _this2.props.selectMyRecordsRow(_this2.props.match.params.subParam, null);
	  };
	
	  this.closeOwnershipModalAndRefreshRecords = function () {
	    _this2.ownershipModal.closeModal();
	    _this2.getRecords();
	  };
	
	  this.setFilters = function (filters) {
	    var props = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	    _this2.props.setFilters(_this2.props.match.params.subParam, filters);
	    if (props.getRecords !== false) {
	      _this2.getRecords();
	    }
	  };
	
	  this.getLowercaseSublinkLabel = function (sublink) {
	    return sublink.preserveCasing ? sublink.label || '' : (sublink.label || '').toLowerCase();
	  };
	
	  this.getMergedEmptyStateText = function (text, sublink) {
	    return text.replace(/{{CATEGORY}}/g, _this2.getLowercaseSublinkLabel(sublink));
	  };
	};
	
	MyRecords = (0, _reactRedux.connect)(function (state, props) {
	  return {
	    orderedRecords: props.match.params.subParam && state.myRecords.results ? (0, _utilities.getOrderedResultsByCategory)(props.match.params.subParam, state.myRecords.results, state.myRecords.templates) : null,
	    records: props.match.params.subParam && state.myRecords.results ? state.myRecords.results[props.match.params.subParam] ? state.myRecords.results[props.match.params.subParam] : {} : {},
	    resultsMode: state.myRecords.resultsMode,
	    loading: state.myRecords.loading,
	    selectedId: props.match.params.subParam ? state.myRecords.selected[props.match.params.subParam] : null,
	    showSelected: state.myRecords.showSelected,
	    selectedDetails: state.myRecords.selectedDetails,
	    isMobile: state.app.isMobile,
	    recordDetailsLoading: state.myRecords.recordDetailsLoading,
	    activeCategory: state.myRecords.activeCategory || state.app.currentCategory,
	    filters: state.myRecords.filters,
	    error: state.myRecords.error,
	    errorDetails: state.myRecords.errorDetails,
	    serverDescription: props.match.params.subParam && state.myRecords.descriptions[props.match.params.subParam] || ''
	  };
	}, {
	  pullAndSetMyRecords: _MyRecordsActions.pullAndSetMyRecords,
	  setMyRecordsResultsMode: _MyRecordsActions.setMyRecordsResultsMode,
	  selectMyRecordsRowAndGetDetails: _MyRecordsActions.selectMyRecordsRowAndGetDetails,
	  selectMyRecordsRow: _MyRecordsActions.selectMyRecordsRow,
	  setActiveCategory: _MyRecordsActions.setActiveCategory,
	  setFilters: _MyRecordsActions.setFilters,
	  getMyRecordsDescription: _MyRecordsActions.getMyRecordsDescription
	})(MyRecords);
	
	exports.default = MyRecords;

/***/ },
/* 1116 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _FilterUtilities = __webpack_require__(289);
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var initialState = {
	  activeCategory: null,
	  descriptions: {},
	  error: false,
	  errorDetails: {
	    message: null,
	    code: null
	  },
	  filters: (0, _FilterUtilities.getFiltersByLocalStorageKey)('MY_RECORDS_FILTERS'),
	  lastRequestId: null,
	  loading: false,
	  recordDetailsLoading: false,
	  results: null,
	  resultsMode: 'table',
	  selected: {},
	  selectedDetails: null,
	  selectedOwnershipRecords: [],
	  selectedRecordHasOwners: null,
	  showSelected: false,
	  templates: {},
	  userOwnsSelectedRecord: null
	};
	
	var MyRecordsReducer = function MyRecordsReducer() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	  var action = arguments[1];
	
	  switch (action.type) {
	    case '@@mr/RESET_STATE':
	      return initialState;
	    case "@@mr/INVALIDATE_CACHE":
	      return Object.assign({}, state, {
	        results: null,
	        selected: {},
	        selectedDetails: null,
	        showSelected: false
	      });
	    case '@@mr/SET_ACTIVE_CATEGORY':
	      return Object.assign({}, state, {
	        activeCategory: action.category
	      });
	    case 'SET_MY_RECORDS':
	      return Object.assign({}, state, {
	        results: Object.assign({}, state.results, _defineProperty({}, action.category, action.results.rows)),
	        templates: Object.assign({}, state.templates, _defineProperty({}, action.category, action.results.template))
	      });
	    case 'SELECT_MY_RECORDS_ROW':
	      return Object.assign({}, state, {
	        selected: Object.assign({}, state.selected, _defineProperty({}, action.category, action.selected)),
	        showSelected: state.selected[action.category] !== action.selected && action.selected !== null ? true : !state.showSelected
	      });
	    case 'SET_MY_RECORDS_SELECTED_DETAILS':
	      return Object.assign({}, state, { selectedDetails: action.details });
	    case 'SET_MY_RECORDS_RESULTS_MODE':
	      return Object.assign({}, state, { resultsMode: action.mode });
	    case 'SET_MY_RECORDS_SELECTED_OWNERSHIP_RECORDS':
	      return Object.assign({}, state, {
	        selectedOwnershipRecords: action.selectedOwnershipRecords
	      });
	    case 'SET_RECORD_DETAILS_LOADING':
	      return Object.assign({}, state, { recordDetailsLoading: action.loading });
	    case 'SET_USER_OWNS_SELECTED_RECORD':
	      return Object.assign({}, state, { userOwnsSelectedRecord: action.isOwner });
	    case 'SET_SELECTED_RECORD_HAS_OWNERS':
	      return Object.assign({}, state, { selectedRecordHasOwners: action.hasOwners });
	    case '@@mr/SET_FILTERS':
	      return Object.assign({}, state, {
	        filters: Object.assign({}, state.filters, _defineProperty({}, action.category, action.filters))
	      });
	    case 'SET_MY_RECORDS_LOADING':
	      return Object.assign({}, state, {
	        loading: action.loading
	      });
	    case 'SET_MY_RECORDS_ERROR':
	      return Object.assign({}, state, {
	        error: action.error
	      });
	    case 'SET_MY_RECORDS_ERROR_DETAILS':
	      return Object.assign({}, state, {
	        errorDetails: action.errorDetails
	      });
	    case '@@mr/SET_REQUEST_ID':
	      return Object.assign({}, state, { lastRequestId: action.requestId });
	    case '@@MY_RECORDS_SET_DESCRIPTION':
	      return Object.assign({}, state, { descriptions: Object.assign({}, state.descriptions, _defineProperty({}, action.category, action.description)) });
	    default:
	      return state;
	  }
	};
	
	exports.default = MyRecordsReducer;

/***/ },
/* 1117 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(7);
	
	var _Form = __webpack_require__(14);
	
	var _Table = __webpack_require__(150);
	
	var _Table2 = _interopRequireDefault(_Table);
	
	var _format = __webpack_require__(33);
	
	var _format2 = _interopRequireDefault(_format);
	
	var _Loaders = __webpack_require__(16);
	
	var _requests = __webpack_require__(6);
	
	var _Modal = __webpack_require__(13);
	
	var _Portal = __webpack_require__(12);
	
	var _Portal2 = _interopRequireDefault(_Portal);
	
	var _utilities = __webpack_require__(8);
	
	var _reactTooltip = __webpack_require__(78);
	
	var _reactTooltip2 = _interopRequireDefault(_reactTooltip);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var USER_ACCESS_LEVEL_MANAGEMENT = ({"NODE_ENV":"production","BUILD_DATE":"2025-08-27T15:15:31.687Z","BUILD_NUMBER":"Not Provided","GIT_VERSION":"v1.3.0-381-ga81e29b08","GIT_COMMIT_HASH":"a81e29b085c9268ffd96c78eb734365802722741","GIT_BRANCH":"beta","PUBLIC_URL":"","STATE_ABBR":"MT","STATE_NAME":"Montana","STATE_ORG_TITLE":"Secretary of State","LOGIN_HEADER_IMG_PATH":"","HOME_IMG_FILENAME":"montana.jpg","FAVICON_FILE_NAME":"favicon.ico","ALLOW_E_SIGN_ON_CORRECTIONS":true,"THIRD_PARTY_SIGNING_ALLOWED":false,"MY_ACCOUNT_SAVE_AND_CLOSE_BUTTON":true,"IE_DEPRECATED_MESSAGE":"Internet Explorer is not supported. Please select a supported browser below to access this website.","ADDITIONAL_ROUTES":{"dataRequests":true,"farmBill":true,"apostille":true,"externalHelp":"https://sosmt.gov/business/help-center/","systemAdministration":[{"title":"Saved Payments","parameter":"saved-payments","componentName":"SavedPayments"}]},"SUBROUTES":[{"label":"Business","component":"Business","parameter":"business","myWorkQueueSearch":false,"sourceTypeId":54,"searchMustHaveOneOf":["FILING_TYPE_ID","STATUS_ID","STATE","search"],"serverWebSearchDescription":true,"serverWorkQueueDescription":true,"serverMyRecordsDescription":true,"searchPlaceholder":"Search by name or filing number (X########)","allowEmptySearchTerm":true,"requestCertificateAlternateLabel":"Request Information","fileAmendmentButtonLabel":"Filing Actions","advancedSearchParameters":[{"type":"radio","name":"QUERY_TYPE_ID","defaultValue":1010,"options":[{"value":1010,"label":"Starts with"},{"value":1011,"label":"Contains"},{"value":1012,"label":" Word Contains"}]},{"type":"serverSelect","name":"FILING_TYPE_ID","optionsSrc":"FILING_TYPES","label":"Entity Type","placeholder":"All","defaultValue":"0"},{"type":"serverSelect","name":"FILING_SUBTYPE_ID","optionsSrc":"FILING_SUBTYPES","label":"Entity Subtype","overrideSubOptionsSrcFromParameterName":"FILING_TYPE_ID","placeholder":"All","defaultValue":"0"},{"type":"serverSelect","name":"STATUS_ID","optionsSrc":"FILING_STATUS_WITHOUT_ALL","label":"Status","placeholder":"All","defaultValue":"0"},{"type":"serverSelect","name":"STATE","optionsSrc":"STATE","label":"State","placeholder":"All","defaultValue":""},{"type":"serverSelect","name":"COUNTY","optionsSrc":"COUNTY_SUBOPTION","label":"County","overrideSubOptionsSrcFromParameterName":"STATE","placeholder":"All","defaultValue":""},{"type":"checkbox","name":"CRA_SEARCH_YN","defaultValue":false,"label":"Search by Registered Agent PID"},{"type":"dateRange","name":"FILING_DATE","label":"Registration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}},{"type":"dateRange","name":"EXPIRATION_DATE","label":"Expiration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}}],"myRecordsFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Active"},{"value":2,"label":"Inactive"},{"value":3,"label":"Pending"}]},{"type":"dateRange","name":"DATE_RANGE","label":"Date range","defaultValue":{"start":null,"end":null}}],"myWorkQueueFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Approved"},{"value":2,"label":"Pending Online Payment"},{"value":3,"label":"Pending Review"},{"value":4,"label":"Needs Correction"},{"value":5,"label":"Rejected"},{"value":6,"label":"Draft"}]},{"type":"dateRange","name":"DATE_RANGE","label":"Date range","defaultValue":{"start":null,"end":null}}]},{"label":"Notary","component":"Notary","parameter":"notary","sourceTypeId":850,"myWorkQueueSearch":false,"allowEmptySearchTerm":true,"requestCertificateAlternateLabel":"Download Certificate","fileAmendmentButtonLabel":"Filing Actions","hideNameRequestCertificate":true,"hideAddressRequestCertificate":true,"hideRecordUserManagment":true,"searchPlaceholder":"Search by name or commission number","searchMustHaveOneOf":["CITY","search","SERVICE_TYPE"],"advancedParametersStartOpen":true,"searchIsSortable":true,"advancedSearchParameters":[{"type":"radio","name":"STARTS_WITH_YN","defaultValue":false,"options":[{"value":true,"label":"Starts with"},{"value":false,"label":"Contains"}]},{"type":"checkbox","name":"ACTIVE_ONLY_YN","defaultValue":true,"label":"Active entities only"},{"type":"text","name":"CITY","defaultValue":"","label":"City"},{"type":"select","name":"SERVICE_TYPE","label":"Special Services Offered","defaultValue":0,"options":[{"value":0,"label":"(N/A)"},{"value":6165,"label":"In-Person Electronic Notarization (IPEN)"},{"value":6166,"label":"Remote Online Notarization (RON)"},{"value":6167,"label":"Mobile Notary Services"},{"value":6168,"label":"Remote Ink Notarization (RIN)"}]}]},{"label":"Apostille","component":"Apostille","parameter":"apostille","sourceTypeId":720,"myRecordsSearch":false,"myWorkQueueSearch":false,"disabled":false,"allowedRoutes":["/forms-manager/","/queue/","/forms/"]},{"label":"Liens","component":"UCC","parameter":"ucc","sourceTypeId":1999,"myRecordsSearch":true,"myWorkQueueSearch":true,"fileAmendmentButtonLabel":"Filing Actions","searchPlaceholder":"Search by name or file number","disabled":false,"serverWebSearchDescription":true,"myRecordsDescription":"","workQueueDescription":"","searchDescription":"","hideRecordUserManagment":true,"searchLiensCheckout":false,"advancedSearchParameters":[{"type":"radio","name":"STARTS_WITH_YN","defaultValue":false,"options":[{"value":true,"label":"Starts with"},{"value":false,"label":"Contains"}]},{"type":"select","name":"STATUS","defaultValue":"ALL","label":"Status","options":[{"value":"ACTIVE_UNLAPSED","label":"Active (unlapsed)"},{"value":"ACTIVE_LAPSED_UNLAPSED","label":"Active (lapsed and unlapsed)"}]},{"type":"text","name":"EXCLUDE_VALUES","label":"Exclude Debtor Names (comma separated list of names to exclude)","defaultValue":""},{"type":"dateRange","name":"FILING_DATE","label":"Financing Statement Date","defaultValue":{"start":null,"end":null}},{"type":"dateRange","name":"LAPSE_DATE","label":"Lapse Date","defaultValue":{"start":null,"end":null}},{"type":"text","name":"CITY","label":"Debtor City","defaultValue":""}],"myRecordsFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Approved"},{"value":2,"label":"Pending Online Payment"},{"value":3,"label":"Pending Review"}]},{"type":"select","name":"TYPE","defaultValue":0,"label":"Lien Type","options":[{"value":0,"label":"All"},{"value":1,"label":"UCC"},{"value":2,"label":"EFS"},{"value":3,"label":"Title 71"}]}],"myWorkQueueFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Approved"},{"value":2,"label":"Pending Online Payment"},{"value":3,"label":"Pending Review"},{"value":4,"label":"Pending Print and Mail"},{"value":5,"label":"Rejected"},{"value":6,"label":"Draft"}]},{"type":"select","name":"TYPE","defaultValue":0,"label":"Lien Type","options":[{"value":0,"label":"All"},{"value":1,"label":"UCC"},{"value":2,"label":"EFS"},{"value":3,"label":"Title 71"}]}]},{"label":"Copy Request","component":"copies","parameter":"copies","sourceTypeId":2001,"myRecordsSearch":false,"myWorkQueueSearch":false,"disabled":false,"allowedRoutes":["/forms-manager/","/queue/","/forms/"]},{"label":"Trademark","component":"Trademark","parameter":"trademark","sourceTypeId":810,"showRequestCertificate":true,"searchMustHaveOneOf":["search","EXPIRATION_DATE","FILING_DATE"],"allowEmptySearchTerm":true,"requestCertificateAlternateLabel":"Request Information","fileAmendmentButtonLabel":"Filing Actions","advancedSearchParameters":[{"type":"radio","name":"QUERY_TYPE_ID","defaultValue":1010,"options":[{"value":1010,"label":"Starts with"},{"value":1011,"label":"Contains"},{"value":1012,"label":" Word Contains"}]},{"type":"checkbox","name":"OWNER_SEARCH_YN","defaultValue":false,"label":"Search owners"},{"type":"radio","name":"SERVICE_MARK_YN","label":"Mark Type","defaultValue":"","options":[{"value":"","label":"All Marks"},{"value":"Y","label":"Service Mark"},{"value":"N","label":"Trademark"}]},{"type":"serverSelect","name":"STATUS_ID","optionsSrc":"TYPE_V|TRADEMARK_STATUS_TYPE","label":"Status","placeholder":"All","defaultValue":"0"},{"type":"select","name":"DESIGN_TYPE_ID","options":[{"value":0,"label":"All"},{"value":990,"label":"Words Only"},{"value":991,"label":"Design Only"},{"value":992,"label":"Words and Design"}],"label":"Design Type","defaultValue":"0"},{"type":"dateRange","name":"FILING_DATE","label":"Registered Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}},{"type":"dateRange","name":"EXPIRATION_DATE","label":"Expiration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}}]},{"label":"Business Info Request","component":"InfoRequests","parameter":"info-request","sourceTypeId":167,"allowedRoutes":["/forms-manager/","/queue/","/forms/"]},{"label":"Data Requests","component":"DataRequests","parameter":"data-request","sourceTypeId":0,"allowedRoutes":["/forms-manager/"]},{"label":"CRA","component":"CRA","parameter":"cra","sourceTypeId":157,"myRecordsSearch":false,"searchPlaceholder":"Search by name or registered agent number","allowedRoutes":["/forms-manager/","/forms/","/records/","/queue/","/search/"],"allowEmptySearchTerm":true,"fileAmendmentButtonLabel":"Filing Actions","advancedSearchParameters":[{"type":"radio","name":"QUERY_TYPE_ID","defaultValue":1010,"options":[{"value":1010,"label":"Starts with"},{"value":1011,"label":"Contains"},{"value":1012,"label":" Word Contains"}]},{"type":"dateRange","name":"CRA_DATE","label":"Registration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}},{"type":"select","name":"STATUS_ID","label":"Status","defaultValue":0,"options":[{"value":0,"label":"All"},{"value":121,"label":"Active"},{"value":122,"label":"Inactive"}]},{"type":"select","name":"AGENT_TYPE_ID","label":"Agent Type","defaultValue":0,"options":[{"value":0,"label":"All"},{"value":460,"label":"Registered Agent"},{"value":461,"label":"Commercial Registered Agent"}]}]},{"label":"Farm Bill","component":"FarmBill","parameter":"farm-bill","path":"/lists/farm-bill","sourceTypeId":0,"myRecordsSearch":false,"allowedRules":["/search/"],"disabled":true,"searchDescription":"To perform a search, enter a debtor name. Your search results may include: exact debtor name, variations of that name and any filing that includes your search criteria. Punctuation is ignored.\n\nYou can click on \"Advanced\" to refine your search. Under “Advanced” you can search by crop, year, county and SSN/FEIN. As a registered Farm Bill Buyer with the Montana Secretary of State’s office it is important to maintain the confidentiality of the information contained within the Farm Bill Master List. The Farm Bill Master List reflects personal data, such as Social Security Numbers, which are a key piece of personal identifiable information to assist you in determining the existence of a lien against a specific debtor. The distribution of this information beyond its intended purpose is strictly prohibited.\n\nThe debtor's tax identification number has been hidden for confidentiality reasons. You may continue to search on a tax ID number and return debtors that match your search criteria. The SSN/FEIN must be entered without dashes or spaces.","searchMustHaveOneOf":["search","UCC_FARM_PRODUCT_ID","COUNTY"],"searchPlaceholder":"Search by debtor name","advancedSearchParameters":[{"type":"ServerMultiComplete","label":"Product code name(s)","name":"UCC_FARM_PRODUCT_ID","defaultValue":"","optionsSrc":"UCC_FARM_PRODUCT_V"},{"type":"MultiComplete","label":"Year or Range of Years","name":"YEAR_NUM","optionsSrc":"years","startYear":"1968","defaultValue":[],"preMergeOptions":[{"value":"ALL","label":"All"}]},{"type":"serverSelect","label":"State","name":"STATE","defaultValue":"MONTANA","optionsSrc":"STATE"},{"type":"ServerMultiComplete","label":"County","name":"COUNTY","defaultValue":[],"optionsSrc":"COUNTY","overrideSubOptionsSrcFromParameterName":"STATE"},{"type":"checkbox","name":"TIN_SEARCH_YN","defaultValue":false,"label":"Tax Identification Number Search"},{"type":"checkbox","name":"TIN_SORT_YN","defaultValue":false,"label":"Unique ID Sort"}]}],"SYSTEM_NICKNAME":"Online Services Portal","PAYMENT_METHODS":[{"type":"bypass"},{"type":"iTransact"}],"PAYMENT_ALLOW_AMEX":true,"SYSTEM_ID_LABEL":"System Id","DOUBLE_COLUMN_PUBLIC_LOGIN":true,"INTERNAL_USER_MANAGEMENT":true,"ALLOW_PUBLIC_JSON_IMPORT":false,"MAX_FILE_UPLOAD_SIZE":10000000,"REFUND_TEXT":"","RETURN_TO_HOME_ON_LOGOUT":true,"CURRENT_SOS_NAME":"Christi Jacobsen","LOGO_FILENAME":"mt-sos-logo.png","LOGO_ALT":"Christi Jacobsen, Montana Secretary of State","LOGO_FULL_WIDTH":true,"HOME_HIDE_AUTH_HINT":true,"HOME_TITLE":"Montana Secretary of State","CUSTOM_TAB_TITLE":"Official Montana","HOME_SUBTITLE":"Online Business Services","ENTITY_NAME_CONSENT_DESCRIPTION":"","ALLOW_USER_PROFILE_EDITING":true,"COMPARE_FOREIGN_NAME_IN_ENTITY_NAME_VALIDATION":true,"FOREIGN_NAME_FIELD_NAME":"KIMA_PARENT_NAME_INFO","LOGIN_TITLE":"Montana Secretary of State Online Filing Portal Login","PUBLIC_LOGIN_LABEL":"Username","REVERSE_LOGIN_COLUMNS":true,"LOGIN_SEAL_FILENAME":"seal_white.png","SEPARATE_USERNAME_AND_EMAIL":true,"CREATE_ACCOUNT_BUTTON_ALIGN_LEFT":true,"CREATE_ACCOUNT_BUTTON_TEXT":"CREATE AN ACCOUNT","PASSWORD_CUSTOM_ERROR_TEXT":"The password must meet all requirements","ACCOUNT_CREATED_MESSAGE":"Please check your email to verify your account to login and allow a few minutes for this message to arrive. Check your junk/spam folders if you do not find the email in your inbox.","PUBLIC_LOGIN_PLACEHOLDER":" ","DISABLE_DEFAULT_PAYMENT_RADIO":true,"CUSTOM_RESET_PASSWORD_ERROR_MESSAGE":"Username invalid - no account found","PUBLIC_LOGIN_CREATE_DESCRIPTION":"### Existing User:\n\n  - Enter your username and password to login.  \n\n\n  #### - OR -  \n\n\n\n  - Forgot password? Click 'Reset Password' and follow the prompts.\n  - Forgot username? Click 'Forgot Username' and follow the prompts.  \n\n\n  ### New User:\n  ","LOGIN_HELP_LINK":"https://sosmt.gov/business/how-do-i/","LOGIN_HELP_LINK_TEXT":"Need Help?","FORGOT_USERNAME_TEXT":"Forgot Username?","LOGIN_ACTIVE_DIRECTORY_TEXT":"State User Login","MULTIPLE_LOGIN_METHODS":true,"HAS_ACTIVE_DIRECTORY_LOGIN":true,"RESET_PASSWORD_WITH_USERNAME":true,"DOWNLOAD_LINK":true,"SHOW_USERNAME_ACCOUNT_CREATE":true,"SHOW_SCROLL_DOWN_ARROW":true,"SHOW_ADDRESS_ACCOUNT_CREATE":true,"TWO_COLUMN_ACCOUNT_CREATE":true,"RESET_PASSWORD_TIP":"A link to change your password has been sent to your email. Please allow a few minutes for this message to arrive. Please check your junk/spam folders if you do not find the email in your inbox.","FORGOT_PASSWORD_LINK_TEXT":"Reset Password","PHONE_NUMBER_OPTIONAL_ACCOUNT_CREATE":true,"SHOW_REQUIRED_INDICATOR_ACCOUNT_CREATE":true,"PASSWORD_REQUIREMENTS_ACCOUNT_CREATE":"\n    <ul>\n      <li>MUST contain at least 8 characters (12+ recommended)</li>\n      <li>MUST contain at least one uppercase letter.</li>\n      <li>MUST contain at least one lowercase letter.</li>\n      <li>MUST contain at least one number.</li>\n      <li>MUST contain at least one special character (!”#$%&'()*+,-./:;<=>?</li>\n    </ul>\n  ","ALLOW_CERTIFICATION_REQUEST":true,"ALLOW_PUBLIC_CERTIFICATE_REQUEST":true,"ALLOW_COPY_REQUEST":false,"ALLOW_CORRECTION_STYLING":true,"HIDE_DEPRECATION_WARNING":false,"AMEND_ROUTE_PUBLIC":true,"SEAL_FILENAME":"seal.png","SHOPPING_CART":true,"ALLOW_PAYMENT_UPDATE_WITH_EMPTY_CART":true,"RA_EMAIL":true,"RA_WEBSITE":true,"RA_NO_DEFAULT_TYPE":true,"RA_ADDRESS_LABEL":"Street Address","RA_TYPE_SELECTION_DEFAULT":true,"RA_DEFAULT_TYPE":"460","RA_OVERRIDE_TYPE_WITH_DEFAULT":true,"RA_PRINCIPAL_ADDRESS_AMS":true,"UPLOAD_AND_SUBMIT_HIDE_IF_ONE_OPTION":true,"PAYMENT_PROCESSING_MESSAGE":"Your payment is processing - Do not close your browser or click the back button","CHECKOUT_BUTTON_WHEN_PROCESSING_TEXT":"Processing","EFS_CROP_PICKER_NONE_LABEL":"Lien Duration","DISALLOWED_WIZARD_PIECES":["FormationLocale"],"REPEATER_SHOW_EDIT_BUTTON":true,"DATA_REQUEST_PAGE_TITLE":"Data Requests and Subscriptions","DATA_REQUEST_SIDEBAR_LABEL":"Data Requests & Subscriptions","LOGIN_REDIRECTS_TO_EPASS":false,"LOGIN_REDIRECTS_TO_ACTIVE_DIRECTORY":true,"LOGIN_ACTIVE_DIRECTORY_LINK":true,"FETCH_EDIT_USER_LINK":false,"LISTS_FETCH_AVAILABLE_LISTS":true,"POST_WIZARD_SUBMIT_REDIRECT_URL":"/","PIN_REQUEST_ATTESTATIONS":true,"PIN_REQUEST_DESCRIPTION":"Click **Request PIN** to have a new PIN sent to the account holder's email address on file.","OWNERSHIP_REQUEST_DESCRIPTION":"To become an **authorized user** of this record, a current **AUTHORIZED USER** will need to grant you access. To request access, click **Request Access** below.","PIN_REQUEST_SUCCESS_MESSAGE":"The PIN you have requested for this entity has been sent to the email associated with your user account.  You should receive the PIN in approximately 3-5 minutes, depending on your email service provider.","APOSTILLE_HEADER_LABEL":"Verification Information","APOSTILLE_NUMBER_LABEL":"Apostille/Authentication","APOSTILLE_CITY_STATE_OVERRIDE":"HELENA, MT","APOSTILLE_FILING_DATE_LABEL":"Issue Date","APOSTILLE_CITY_STATE_IN_CERTIFIED":true,"NOTARY_EXISTING_FILING":true,"ALLOW_REVOKE_OWN_ACCESS_ONLY":false,"HIDE_CANCEL_ON_ONETIME_DATA_REQUESTS":true,"DATA_REQUESTS_IN_SHOPPING_CART":true,"WQ_ALLOW_EDIT_PENDING_PAYMENT":true,"WQ_CONFIRM_ON_DELETE":true,"WQ_DELETE_CONFIRM_MESSAGE":"Deleting this filing will forfeit any money already paid to the Secretary of State. This action is permanent and cannot be undone, are you sure you would like to delete?","PASS_ITEM_GUIDS_ON_CHECKOUT":true,"FORM_REVISION_HISTORY":true,"CHECKOUT_DISCLAIMER":"By entering your credit card and/or checking account information you (i) state that **you are an authorized user** of the credit card and/or electronic check and that the associated information entered (e.g., account holder name, account number, billing address) is accurate, (ii) **you authorize payment processor to charge the amount you have requested** to your credit card and/or funding account, and (iii) **acknowledge if a charge is declined or reversed you may also be assessed a customary charge** by the payment processor for such transactions.","FARM_BILL_SEARCH_CONFIDENTIAL":"As a registered Farm Bill Buyer with the Montana Secretary of State’s office it is important to maintain the confidentiality of the information contained within the Farm Bill Master List. The Farm Bill Master List reflects personal data, such as Social Security Numbers, which are a key piece of personal identifiable information to assist you in determining the existence of a lien against a specific debtor. The distribution of this information beyond its intended purpose is strictly prohibited.\n\n**The debtor's tax identification number has been hidden for confidentiality reasons. You may continue to search on a tax ID number and return debtors that match your search criteria. The SSN/FEIN must be entered without dashes or spaces.  If you need access to the tax identification number to clearly identify the debtor, please contact the UCC unit at (406) 444-3665.**","VIEW_HISTORY_BUTTON_ALT_TEXT":"View Filings","WIZARD_ERROR_TITLE_MESSAGE":"Form Error","FARM_BILL_SEARCH_INTERACTIVE":true,"USE_FARM_BILL_API":true,"DISALLOW_ASSIGN_SELF_AS_RA":true,"DISALLOW_ASSIGN_SELF_AS_PRINCIPAL":true,"USE_TRADEMARK_OWNER_VALIDATION":true,"USE_ALTERNATIVE_FOREIGN_ADDRESS_LABELS":true,"MY_RECEIPTS_FILTER":[{"type":"dateRange","name":"DATE_RANGE","label":"Date range","defaultValue":{"start":null,"end":null}},{"type":"text","name":"REF_NUM","defaultValue":"","label":"Reference Number"},{"type":"text","name":"RECEIPT_NUM","defaultValue":"","label":"Receipt Id"},{"type":"text","name":"AMOUNT","defaultValue":"","label":"Amount"},{"type":"select","name":"TYPE","defaultValue":"","label":"Payment Type","options":[{"value":"","label":"All"},{"value":"CC","label":"Credit Card"},{"value":"Check","label":"Check"}]}],"MY_RECEIPTS_SHOW_IN_SIDEBAR":true,"SHOW_MY_RECEIPTS_HELPER_TEXT":true,"MY_RECEIPTS_HELPER_LABEL":"About Receipt Search","MY_RECEIPTS_HELPER_TEXT":"You can search for receipts based on their descriptions, including the items paid for on the receipt. Use the filters to search for or filter specific information.","FARM_BILL_SUBLINK":{"label":"Farm Bill","component":"FarmBill","parameter":"farm-bill","path":"/lists/farm-bill","sourceTypeId":0,"myRecordsSearch":false,"allowedRules":["/search/"],"disabled":true,"searchDescription":"To perform a search, enter a debtor name. Your search results may include: exact debtor name, variations of that name and any filing that includes your search criteria. Punctuation is ignored.\n\nYou can click on \"Advanced\" to refine your search. Under “Advanced” you can search by crop, year, county and SSN/FEIN. As a registered Farm Bill Buyer with the Montana Secretary of State’s office it is important to maintain the confidentiality of the information contained within the Farm Bill Master List. The Farm Bill Master List reflects personal data, such as Social Security Numbers, which are a key piece of personal identifiable information to assist you in determining the existence of a lien against a specific debtor. The distribution of this information beyond its intended purpose is strictly prohibited.\n\nThe debtor's tax identification number has been hidden for confidentiality reasons. You may continue to search on a tax ID number and return debtors that match your search criteria. The SSN/FEIN must be entered without dashes or spaces.","searchMustHaveOneOf":["search","UCC_FARM_PRODUCT_ID","COUNTY"],"searchPlaceholder":"Search by debtor name","advancedSearchParameters":[{"type":"ServerMultiComplete","label":"Product code name(s)","name":"UCC_FARM_PRODUCT_ID","defaultValue":"","optionsSrc":"UCC_FARM_PRODUCT_V"},{"type":"MultiComplete","label":"Year or Range of Years","name":"YEAR_NUM","optionsSrc":"years","startYear":"1968","defaultValue":[],"preMergeOptions":[{"value":"ALL","label":"All"}]},{"type":"serverSelect","label":"State","name":"STATE","defaultValue":"MONTANA","optionsSrc":"STATE"},{"type":"ServerMultiComplete","label":"County","name":"COUNTY","defaultValue":[],"optionsSrc":"COUNTY","overrideSubOptionsSrcFromParameterName":"STATE"},{"type":"checkbox","name":"TIN_SEARCH_YN","defaultValue":false,"label":"Tax Identification Number Search"},{"type":"checkbox","name":"TIN_SORT_YN","defaultValue":false,"label":"Unique ID Sort"}]},"ALLOW_ADDRESS_VALIDATION_BYPASS_OPTION":true,"DEFAULT_ADDRESS_VALIDATION_BYPASS_OPTION_CHECKED":true}).USER_ACCESS_LEVEL_MANAGEMENT;
	var ALLOW_REVOKE_OWN_ACCESS_ONLY = (false);
	var SHOW_ACCESS_LEVEL_TYPE_DROPDOWN = ({"NODE_ENV":"production","BUILD_DATE":"2025-08-27T15:15:31.687Z","BUILD_NUMBER":"Not Provided","GIT_VERSION":"v1.3.0-381-ga81e29b08","GIT_COMMIT_HASH":"a81e29b085c9268ffd96c78eb734365802722741","GIT_BRANCH":"beta","PUBLIC_URL":"","STATE_ABBR":"MT","STATE_NAME":"Montana","STATE_ORG_TITLE":"Secretary of State","LOGIN_HEADER_IMG_PATH":"","HOME_IMG_FILENAME":"montana.jpg","FAVICON_FILE_NAME":"favicon.ico","ALLOW_E_SIGN_ON_CORRECTIONS":true,"THIRD_PARTY_SIGNING_ALLOWED":false,"MY_ACCOUNT_SAVE_AND_CLOSE_BUTTON":true,"IE_DEPRECATED_MESSAGE":"Internet Explorer is not supported. Please select a supported browser below to access this website.","ADDITIONAL_ROUTES":{"dataRequests":true,"farmBill":true,"apostille":true,"externalHelp":"https://sosmt.gov/business/help-center/","systemAdministration":[{"title":"Saved Payments","parameter":"saved-payments","componentName":"SavedPayments"}]},"SUBROUTES":[{"label":"Business","component":"Business","parameter":"business","myWorkQueueSearch":false,"sourceTypeId":54,"searchMustHaveOneOf":["FILING_TYPE_ID","STATUS_ID","STATE","search"],"serverWebSearchDescription":true,"serverWorkQueueDescription":true,"serverMyRecordsDescription":true,"searchPlaceholder":"Search by name or filing number (X########)","allowEmptySearchTerm":true,"requestCertificateAlternateLabel":"Request Information","fileAmendmentButtonLabel":"Filing Actions","advancedSearchParameters":[{"type":"radio","name":"QUERY_TYPE_ID","defaultValue":1010,"options":[{"value":1010,"label":"Starts with"},{"value":1011,"label":"Contains"},{"value":1012,"label":" Word Contains"}]},{"type":"serverSelect","name":"FILING_TYPE_ID","optionsSrc":"FILING_TYPES","label":"Entity Type","placeholder":"All","defaultValue":"0"},{"type":"serverSelect","name":"FILING_SUBTYPE_ID","optionsSrc":"FILING_SUBTYPES","label":"Entity Subtype","overrideSubOptionsSrcFromParameterName":"FILING_TYPE_ID","placeholder":"All","defaultValue":"0"},{"type":"serverSelect","name":"STATUS_ID","optionsSrc":"FILING_STATUS_WITHOUT_ALL","label":"Status","placeholder":"All","defaultValue":"0"},{"type":"serverSelect","name":"STATE","optionsSrc":"STATE","label":"State","placeholder":"All","defaultValue":""},{"type":"serverSelect","name":"COUNTY","optionsSrc":"COUNTY_SUBOPTION","label":"County","overrideSubOptionsSrcFromParameterName":"STATE","placeholder":"All","defaultValue":""},{"type":"checkbox","name":"CRA_SEARCH_YN","defaultValue":false,"label":"Search by Registered Agent PID"},{"type":"dateRange","name":"FILING_DATE","label":"Registration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}},{"type":"dateRange","name":"EXPIRATION_DATE","label":"Expiration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}}],"myRecordsFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Active"},{"value":2,"label":"Inactive"},{"value":3,"label":"Pending"}]},{"type":"dateRange","name":"DATE_RANGE","label":"Date range","defaultValue":{"start":null,"end":null}}],"myWorkQueueFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Approved"},{"value":2,"label":"Pending Online Payment"},{"value":3,"label":"Pending Review"},{"value":4,"label":"Needs Correction"},{"value":5,"label":"Rejected"},{"value":6,"label":"Draft"}]},{"type":"dateRange","name":"DATE_RANGE","label":"Date range","defaultValue":{"start":null,"end":null}}]},{"label":"Notary","component":"Notary","parameter":"notary","sourceTypeId":850,"myWorkQueueSearch":false,"allowEmptySearchTerm":true,"requestCertificateAlternateLabel":"Download Certificate","fileAmendmentButtonLabel":"Filing Actions","hideNameRequestCertificate":true,"hideAddressRequestCertificate":true,"hideRecordUserManagment":true,"searchPlaceholder":"Search by name or commission number","searchMustHaveOneOf":["CITY","search","SERVICE_TYPE"],"advancedParametersStartOpen":true,"searchIsSortable":true,"advancedSearchParameters":[{"type":"radio","name":"STARTS_WITH_YN","defaultValue":false,"options":[{"value":true,"label":"Starts with"},{"value":false,"label":"Contains"}]},{"type":"checkbox","name":"ACTIVE_ONLY_YN","defaultValue":true,"label":"Active entities only"},{"type":"text","name":"CITY","defaultValue":"","label":"City"},{"type":"select","name":"SERVICE_TYPE","label":"Special Services Offered","defaultValue":0,"options":[{"value":0,"label":"(N/A)"},{"value":6165,"label":"In-Person Electronic Notarization (IPEN)"},{"value":6166,"label":"Remote Online Notarization (RON)"},{"value":6167,"label":"Mobile Notary Services"},{"value":6168,"label":"Remote Ink Notarization (RIN)"}]}]},{"label":"Apostille","component":"Apostille","parameter":"apostille","sourceTypeId":720,"myRecordsSearch":false,"myWorkQueueSearch":false,"disabled":false,"allowedRoutes":["/forms-manager/","/queue/","/forms/"]},{"label":"Liens","component":"UCC","parameter":"ucc","sourceTypeId":1999,"myRecordsSearch":true,"myWorkQueueSearch":true,"fileAmendmentButtonLabel":"Filing Actions","searchPlaceholder":"Search by name or file number","disabled":false,"serverWebSearchDescription":true,"myRecordsDescription":"","workQueueDescription":"","searchDescription":"","hideRecordUserManagment":true,"searchLiensCheckout":false,"advancedSearchParameters":[{"type":"radio","name":"STARTS_WITH_YN","defaultValue":false,"options":[{"value":true,"label":"Starts with"},{"value":false,"label":"Contains"}]},{"type":"select","name":"STATUS","defaultValue":"ALL","label":"Status","options":[{"value":"ACTIVE_UNLAPSED","label":"Active (unlapsed)"},{"value":"ACTIVE_LAPSED_UNLAPSED","label":"Active (lapsed and unlapsed)"}]},{"type":"text","name":"EXCLUDE_VALUES","label":"Exclude Debtor Names (comma separated list of names to exclude)","defaultValue":""},{"type":"dateRange","name":"FILING_DATE","label":"Financing Statement Date","defaultValue":{"start":null,"end":null}},{"type":"dateRange","name":"LAPSE_DATE","label":"Lapse Date","defaultValue":{"start":null,"end":null}},{"type":"text","name":"CITY","label":"Debtor City","defaultValue":""}],"myRecordsFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Approved"},{"value":2,"label":"Pending Online Payment"},{"value":3,"label":"Pending Review"}]},{"type":"select","name":"TYPE","defaultValue":0,"label":"Lien Type","options":[{"value":0,"label":"All"},{"value":1,"label":"UCC"},{"value":2,"label":"EFS"},{"value":3,"label":"Title 71"}]}],"myWorkQueueFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Approved"},{"value":2,"label":"Pending Online Payment"},{"value":3,"label":"Pending Review"},{"value":4,"label":"Pending Print and Mail"},{"value":5,"label":"Rejected"},{"value":6,"label":"Draft"}]},{"type":"select","name":"TYPE","defaultValue":0,"label":"Lien Type","options":[{"value":0,"label":"All"},{"value":1,"label":"UCC"},{"value":2,"label":"EFS"},{"value":3,"label":"Title 71"}]}]},{"label":"Copy Request","component":"copies","parameter":"copies","sourceTypeId":2001,"myRecordsSearch":false,"myWorkQueueSearch":false,"disabled":false,"allowedRoutes":["/forms-manager/","/queue/","/forms/"]},{"label":"Trademark","component":"Trademark","parameter":"trademark","sourceTypeId":810,"showRequestCertificate":true,"searchMustHaveOneOf":["search","EXPIRATION_DATE","FILING_DATE"],"allowEmptySearchTerm":true,"requestCertificateAlternateLabel":"Request Information","fileAmendmentButtonLabel":"Filing Actions","advancedSearchParameters":[{"type":"radio","name":"QUERY_TYPE_ID","defaultValue":1010,"options":[{"value":1010,"label":"Starts with"},{"value":1011,"label":"Contains"},{"value":1012,"label":" Word Contains"}]},{"type":"checkbox","name":"OWNER_SEARCH_YN","defaultValue":false,"label":"Search owners"},{"type":"radio","name":"SERVICE_MARK_YN","label":"Mark Type","defaultValue":"","options":[{"value":"","label":"All Marks"},{"value":"Y","label":"Service Mark"},{"value":"N","label":"Trademark"}]},{"type":"serverSelect","name":"STATUS_ID","optionsSrc":"TYPE_V|TRADEMARK_STATUS_TYPE","label":"Status","placeholder":"All","defaultValue":"0"},{"type":"select","name":"DESIGN_TYPE_ID","options":[{"value":0,"label":"All"},{"value":990,"label":"Words Only"},{"value":991,"label":"Design Only"},{"value":992,"label":"Words and Design"}],"label":"Design Type","defaultValue":"0"},{"type":"dateRange","name":"FILING_DATE","label":"Registered Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}},{"type":"dateRange","name":"EXPIRATION_DATE","label":"Expiration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}}]},{"label":"Business Info Request","component":"InfoRequests","parameter":"info-request","sourceTypeId":167,"allowedRoutes":["/forms-manager/","/queue/","/forms/"]},{"label":"Data Requests","component":"DataRequests","parameter":"data-request","sourceTypeId":0,"allowedRoutes":["/forms-manager/"]},{"label":"CRA","component":"CRA","parameter":"cra","sourceTypeId":157,"myRecordsSearch":false,"searchPlaceholder":"Search by name or registered agent number","allowedRoutes":["/forms-manager/","/forms/","/records/","/queue/","/search/"],"allowEmptySearchTerm":true,"fileAmendmentButtonLabel":"Filing Actions","advancedSearchParameters":[{"type":"radio","name":"QUERY_TYPE_ID","defaultValue":1010,"options":[{"value":1010,"label":"Starts with"},{"value":1011,"label":"Contains"},{"value":1012,"label":" Word Contains"}]},{"type":"dateRange","name":"CRA_DATE","label":"Registration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}},{"type":"select","name":"STATUS_ID","label":"Status","defaultValue":0,"options":[{"value":0,"label":"All"},{"value":121,"label":"Active"},{"value":122,"label":"Inactive"}]},{"type":"select","name":"AGENT_TYPE_ID","label":"Agent Type","defaultValue":0,"options":[{"value":0,"label":"All"},{"value":460,"label":"Registered Agent"},{"value":461,"label":"Commercial Registered Agent"}]}]},{"label":"Farm Bill","component":"FarmBill","parameter":"farm-bill","path":"/lists/farm-bill","sourceTypeId":0,"myRecordsSearch":false,"allowedRules":["/search/"],"disabled":true,"searchDescription":"To perform a search, enter a debtor name. Your search results may include: exact debtor name, variations of that name and any filing that includes your search criteria. Punctuation is ignored.\n\nYou can click on \"Advanced\" to refine your search. Under “Advanced” you can search by crop, year, county and SSN/FEIN. As a registered Farm Bill Buyer with the Montana Secretary of State’s office it is important to maintain the confidentiality of the information contained within the Farm Bill Master List. The Farm Bill Master List reflects personal data, such as Social Security Numbers, which are a key piece of personal identifiable information to assist you in determining the existence of a lien against a specific debtor. The distribution of this information beyond its intended purpose is strictly prohibited.\n\nThe debtor's tax identification number has been hidden for confidentiality reasons. You may continue to search on a tax ID number and return debtors that match your search criteria. The SSN/FEIN must be entered without dashes or spaces.","searchMustHaveOneOf":["search","UCC_FARM_PRODUCT_ID","COUNTY"],"searchPlaceholder":"Search by debtor name","advancedSearchParameters":[{"type":"ServerMultiComplete","label":"Product code name(s)","name":"UCC_FARM_PRODUCT_ID","defaultValue":"","optionsSrc":"UCC_FARM_PRODUCT_V"},{"type":"MultiComplete","label":"Year or Range of Years","name":"YEAR_NUM","optionsSrc":"years","startYear":"1968","defaultValue":[],"preMergeOptions":[{"value":"ALL","label":"All"}]},{"type":"serverSelect","label":"State","name":"STATE","defaultValue":"MONTANA","optionsSrc":"STATE"},{"type":"ServerMultiComplete","label":"County","name":"COUNTY","defaultValue":[],"optionsSrc":"COUNTY","overrideSubOptionsSrcFromParameterName":"STATE"},{"type":"checkbox","name":"TIN_SEARCH_YN","defaultValue":false,"label":"Tax Identification Number Search"},{"type":"checkbox","name":"TIN_SORT_YN","defaultValue":false,"label":"Unique ID Sort"}]}],"SYSTEM_NICKNAME":"Online Services Portal","PAYMENT_METHODS":[{"type":"bypass"},{"type":"iTransact"}],"PAYMENT_ALLOW_AMEX":true,"SYSTEM_ID_LABEL":"System Id","DOUBLE_COLUMN_PUBLIC_LOGIN":true,"INTERNAL_USER_MANAGEMENT":true,"ALLOW_PUBLIC_JSON_IMPORT":false,"MAX_FILE_UPLOAD_SIZE":10000000,"REFUND_TEXT":"","RETURN_TO_HOME_ON_LOGOUT":true,"CURRENT_SOS_NAME":"Christi Jacobsen","LOGO_FILENAME":"mt-sos-logo.png","LOGO_ALT":"Christi Jacobsen, Montana Secretary of State","LOGO_FULL_WIDTH":true,"HOME_HIDE_AUTH_HINT":true,"HOME_TITLE":"Montana Secretary of State","CUSTOM_TAB_TITLE":"Official Montana","HOME_SUBTITLE":"Online Business Services","ENTITY_NAME_CONSENT_DESCRIPTION":"","ALLOW_USER_PROFILE_EDITING":true,"COMPARE_FOREIGN_NAME_IN_ENTITY_NAME_VALIDATION":true,"FOREIGN_NAME_FIELD_NAME":"KIMA_PARENT_NAME_INFO","LOGIN_TITLE":"Montana Secretary of State Online Filing Portal Login","PUBLIC_LOGIN_LABEL":"Username","REVERSE_LOGIN_COLUMNS":true,"LOGIN_SEAL_FILENAME":"seal_white.png","SEPARATE_USERNAME_AND_EMAIL":true,"CREATE_ACCOUNT_BUTTON_ALIGN_LEFT":true,"CREATE_ACCOUNT_BUTTON_TEXT":"CREATE AN ACCOUNT","PASSWORD_CUSTOM_ERROR_TEXT":"The password must meet all requirements","ACCOUNT_CREATED_MESSAGE":"Please check your email to verify your account to login and allow a few minutes for this message to arrive. Check your junk/spam folders if you do not find the email in your inbox.","PUBLIC_LOGIN_PLACEHOLDER":" ","DISABLE_DEFAULT_PAYMENT_RADIO":true,"CUSTOM_RESET_PASSWORD_ERROR_MESSAGE":"Username invalid - no account found","PUBLIC_LOGIN_CREATE_DESCRIPTION":"### Existing User:\n\n  - Enter your username and password to login.  \n\n\n  #### - OR -  \n\n\n\n  - Forgot password? Click 'Reset Password' and follow the prompts.\n  - Forgot username? Click 'Forgot Username' and follow the prompts.  \n\n\n  ### New User:\n  ","LOGIN_HELP_LINK":"https://sosmt.gov/business/how-do-i/","LOGIN_HELP_LINK_TEXT":"Need Help?","FORGOT_USERNAME_TEXT":"Forgot Username?","LOGIN_ACTIVE_DIRECTORY_TEXT":"State User Login","MULTIPLE_LOGIN_METHODS":true,"HAS_ACTIVE_DIRECTORY_LOGIN":true,"RESET_PASSWORD_WITH_USERNAME":true,"DOWNLOAD_LINK":true,"SHOW_USERNAME_ACCOUNT_CREATE":true,"SHOW_SCROLL_DOWN_ARROW":true,"SHOW_ADDRESS_ACCOUNT_CREATE":true,"TWO_COLUMN_ACCOUNT_CREATE":true,"RESET_PASSWORD_TIP":"A link to change your password has been sent to your email. Please allow a few minutes for this message to arrive. Please check your junk/spam folders if you do not find the email in your inbox.","FORGOT_PASSWORD_LINK_TEXT":"Reset Password","PHONE_NUMBER_OPTIONAL_ACCOUNT_CREATE":true,"SHOW_REQUIRED_INDICATOR_ACCOUNT_CREATE":true,"PASSWORD_REQUIREMENTS_ACCOUNT_CREATE":"\n    <ul>\n      <li>MUST contain at least 8 characters (12+ recommended)</li>\n      <li>MUST contain at least one uppercase letter.</li>\n      <li>MUST contain at least one lowercase letter.</li>\n      <li>MUST contain at least one number.</li>\n      <li>MUST contain at least one special character (!”#$%&'()*+,-./:;<=>?</li>\n    </ul>\n  ","ALLOW_CERTIFICATION_REQUEST":true,"ALLOW_PUBLIC_CERTIFICATE_REQUEST":true,"ALLOW_COPY_REQUEST":false,"ALLOW_CORRECTION_STYLING":true,"HIDE_DEPRECATION_WARNING":false,"AMEND_ROUTE_PUBLIC":true,"SEAL_FILENAME":"seal.png","SHOPPING_CART":true,"ALLOW_PAYMENT_UPDATE_WITH_EMPTY_CART":true,"RA_EMAIL":true,"RA_WEBSITE":true,"RA_NO_DEFAULT_TYPE":true,"RA_ADDRESS_LABEL":"Street Address","RA_TYPE_SELECTION_DEFAULT":true,"RA_DEFAULT_TYPE":"460","RA_OVERRIDE_TYPE_WITH_DEFAULT":true,"RA_PRINCIPAL_ADDRESS_AMS":true,"UPLOAD_AND_SUBMIT_HIDE_IF_ONE_OPTION":true,"PAYMENT_PROCESSING_MESSAGE":"Your payment is processing - Do not close your browser or click the back button","CHECKOUT_BUTTON_WHEN_PROCESSING_TEXT":"Processing","EFS_CROP_PICKER_NONE_LABEL":"Lien Duration","DISALLOWED_WIZARD_PIECES":["FormationLocale"],"REPEATER_SHOW_EDIT_BUTTON":true,"DATA_REQUEST_PAGE_TITLE":"Data Requests and Subscriptions","DATA_REQUEST_SIDEBAR_LABEL":"Data Requests & Subscriptions","LOGIN_REDIRECTS_TO_EPASS":false,"LOGIN_REDIRECTS_TO_ACTIVE_DIRECTORY":true,"LOGIN_ACTIVE_DIRECTORY_LINK":true,"FETCH_EDIT_USER_LINK":false,"LISTS_FETCH_AVAILABLE_LISTS":true,"POST_WIZARD_SUBMIT_REDIRECT_URL":"/","PIN_REQUEST_ATTESTATIONS":true,"PIN_REQUEST_DESCRIPTION":"Click **Request PIN** to have a new PIN sent to the account holder's email address on file.","OWNERSHIP_REQUEST_DESCRIPTION":"To become an **authorized user** of this record, a current **AUTHORIZED USER** will need to grant you access. To request access, click **Request Access** below.","PIN_REQUEST_SUCCESS_MESSAGE":"The PIN you have requested for this entity has been sent to the email associated with your user account.  You should receive the PIN in approximately 3-5 minutes, depending on your email service provider.","APOSTILLE_HEADER_LABEL":"Verification Information","APOSTILLE_NUMBER_LABEL":"Apostille/Authentication","APOSTILLE_CITY_STATE_OVERRIDE":"HELENA, MT","APOSTILLE_FILING_DATE_LABEL":"Issue Date","APOSTILLE_CITY_STATE_IN_CERTIFIED":true,"NOTARY_EXISTING_FILING":true,"ALLOW_REVOKE_OWN_ACCESS_ONLY":false,"HIDE_CANCEL_ON_ONETIME_DATA_REQUESTS":true,"DATA_REQUESTS_IN_SHOPPING_CART":true,"WQ_ALLOW_EDIT_PENDING_PAYMENT":true,"WQ_CONFIRM_ON_DELETE":true,"WQ_DELETE_CONFIRM_MESSAGE":"Deleting this filing will forfeit any money already paid to the Secretary of State. This action is permanent and cannot be undone, are you sure you would like to delete?","PASS_ITEM_GUIDS_ON_CHECKOUT":true,"FORM_REVISION_HISTORY":true,"CHECKOUT_DISCLAIMER":"By entering your credit card and/or checking account information you (i) state that **you are an authorized user** of the credit card and/or electronic check and that the associated information entered (e.g., account holder name, account number, billing address) is accurate, (ii) **you authorize payment processor to charge the amount you have requested** to your credit card and/or funding account, and (iii) **acknowledge if a charge is declined or reversed you may also be assessed a customary charge** by the payment processor for such transactions.","FARM_BILL_SEARCH_CONFIDENTIAL":"As a registered Farm Bill Buyer with the Montana Secretary of State’s office it is important to maintain the confidentiality of the information contained within the Farm Bill Master List. The Farm Bill Master List reflects personal data, such as Social Security Numbers, which are a key piece of personal identifiable information to assist you in determining the existence of a lien against a specific debtor. The distribution of this information beyond its intended purpose is strictly prohibited.\n\n**The debtor's tax identification number has been hidden for confidentiality reasons. You may continue to search on a tax ID number and return debtors that match your search criteria. The SSN/FEIN must be entered without dashes or spaces.  If you need access to the tax identification number to clearly identify the debtor, please contact the UCC unit at (406) 444-3665.**","VIEW_HISTORY_BUTTON_ALT_TEXT":"View Filings","WIZARD_ERROR_TITLE_MESSAGE":"Form Error","FARM_BILL_SEARCH_INTERACTIVE":true,"USE_FARM_BILL_API":true,"DISALLOW_ASSIGN_SELF_AS_RA":true,"DISALLOW_ASSIGN_SELF_AS_PRINCIPAL":true,"USE_TRADEMARK_OWNER_VALIDATION":true,"USE_ALTERNATIVE_FOREIGN_ADDRESS_LABELS":true,"MY_RECEIPTS_FILTER":[{"type":"dateRange","name":"DATE_RANGE","label":"Date range","defaultValue":{"start":null,"end":null}},{"type":"text","name":"REF_NUM","defaultValue":"","label":"Reference Number"},{"type":"text","name":"RECEIPT_NUM","defaultValue":"","label":"Receipt Id"},{"type":"text","name":"AMOUNT","defaultValue":"","label":"Amount"},{"type":"select","name":"TYPE","defaultValue":"","label":"Payment Type","options":[{"value":"","label":"All"},{"value":"CC","label":"Credit Card"},{"value":"Check","label":"Check"}]}],"MY_RECEIPTS_SHOW_IN_SIDEBAR":true,"SHOW_MY_RECEIPTS_HELPER_TEXT":true,"MY_RECEIPTS_HELPER_LABEL":"About Receipt Search","MY_RECEIPTS_HELPER_TEXT":"You can search for receipts based on their descriptions, including the items paid for on the receipt. Use the filters to search for or filter specific information.","FARM_BILL_SUBLINK":{"label":"Farm Bill","component":"FarmBill","parameter":"farm-bill","path":"/lists/farm-bill","sourceTypeId":0,"myRecordsSearch":false,"allowedRules":["/search/"],"disabled":true,"searchDescription":"To perform a search, enter a debtor name. Your search results may include: exact debtor name, variations of that name and any filing that includes your search criteria. Punctuation is ignored.\n\nYou can click on \"Advanced\" to refine your search. Under “Advanced” you can search by crop, year, county and SSN/FEIN. As a registered Farm Bill Buyer with the Montana Secretary of State’s office it is important to maintain the confidentiality of the information contained within the Farm Bill Master List. The Farm Bill Master List reflects personal data, such as Social Security Numbers, which are a key piece of personal identifiable information to assist you in determining the existence of a lien against a specific debtor. The distribution of this information beyond its intended purpose is strictly prohibited.\n\nThe debtor's tax identification number has been hidden for confidentiality reasons. You may continue to search on a tax ID number and return debtors that match your search criteria. The SSN/FEIN must be entered without dashes or spaces.","searchMustHaveOneOf":["search","UCC_FARM_PRODUCT_ID","COUNTY"],"searchPlaceholder":"Search by debtor name","advancedSearchParameters":[{"type":"ServerMultiComplete","label":"Product code name(s)","name":"UCC_FARM_PRODUCT_ID","defaultValue":"","optionsSrc":"UCC_FARM_PRODUCT_V"},{"type":"MultiComplete","label":"Year or Range of Years","name":"YEAR_NUM","optionsSrc":"years","startYear":"1968","defaultValue":[],"preMergeOptions":[{"value":"ALL","label":"All"}]},{"type":"serverSelect","label":"State","name":"STATE","defaultValue":"MONTANA","optionsSrc":"STATE"},{"type":"ServerMultiComplete","label":"County","name":"COUNTY","defaultValue":[],"optionsSrc":"COUNTY","overrideSubOptionsSrcFromParameterName":"STATE"},{"type":"checkbox","name":"TIN_SEARCH_YN","defaultValue":false,"label":"Tax Identification Number Search"},{"type":"checkbox","name":"TIN_SORT_YN","defaultValue":false,"label":"Unique ID Sort"}]},"ALLOW_ADDRESS_VALIDATION_BYPASS_OPTION":true,"DEFAULT_ADDRESS_VALIDATION_BYPASS_OPTION_CHECKED":true}).SHOW_ACCESS_LEVEL_TYPE_DROPDOWN;
	
	var Ownership = function (_Component) {
	  _inherits(Ownership, _Component);
	
	  function Ownership() {
	    _classCallCheck(this, Ownership);
	
	    var _this = _possibleConstructorReturn(this, (Ownership.__proto__ || Object.getPrototypeOf(Ownership)).call(this));
	
	    _this.componentDidMount = function () {
	      _this.getWebUserAccessList();
	    };
	
	    _this.getWebUserAccessList = function () {
	      (0, _requests.GET_WEB_USER_ACCESS_LIST)(_this.props.category, _this.props.source_id, function (owners) {
	        _this.setState({
	          owners: _this.formatOwnersForTableRows(owners),
	          accessSelectDisabled: false,
	          currentOwnerAccessLevel: (owners.find(function (x) {
	            return x.WEB_USER_ID === _this.props.currentUserId;
	          }) || {}).WEB_USER_ACCESS_LEVEL_TYPE_ID
	        });
	      });
	    };
	
	    _this.formatOwnersForTableRows = function (owners) {
	      return owners.map(function (owner, i) {
	        return Object.assign({}, owner, {
	          TYPE: owner.STATUS,
	          RECORD_ID: owner.WEB_USER_ACCESS_ID,
	          LAST_MODIFIED_DATE: (0, _format2.default)(new Date(owner.LAST_MODIFIED_DATE), 'MM/dd/yyyy')
	        }, USER_ACCESS_LEVEL_MANAGEMENT ? {
	          WEB_USER_ACCESS_LEVEL_TYPE_ID: owner
	        } : {});
	      });
	    };
	
	    _this.getAccessEditorCell = function (owner) {
	      var userAccess = [{ value: 100, label: 'Full access', tooltip: 'Ability to file any online form.' }, { value: 30, label: 'Basic access', tooltip: 'Ability to file business annual report only.' }].find(function (x) {
	        return owner.WEB_USER_ACCESS_LEVEL_TYPE_ID === x.value;
	      });
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'flex-row' },
	        SHOW_ACCESS_LEVEL_TYPE_DROPDOWN ? _react2.default.createElement(_Form.Select, {
	          value: owner.WEB_USER_ACCESS_LEVEL_TYPE_ID,
	          options: [{ value: 100, label: 'Full access' }, { value: 30, label: 'Basic access' }],
	          disabled: _this.state.accessSelectDisabled || owner.WEB_USER_ID === _this.props.currentUserId || _this.state.currentOwnerAccessLevel !== 100,
	          onBlur: function onBlur() {},
	          onChange: function onChange(typeId) {
	            return _this.setAccessLevel({
	              RECORD_ID: owner.WEB_USER_ACCESS_ID,
	              WEB_USER_ACCESS_LEVEL_TYPE_ID: typeId
	            });
	          }
	        }) : _react2.default.createElement(
	          'div',
	          null,
	          userAccess.label
	        ),
	        _react2.default.createElement(
	          'a',
	          { 'data-tip': userAccess.tooltip, className: 'tip' },
	          'i'
	        ),
	        _react2.default.createElement(_reactTooltip2.default, { place: 'bottom', effect: 'float', type: 'none', className: 'tooltip-wrapper' })
	      );
	    };
	
	    _this.setAccessLevel = function (payload) {
	      _this.setState({ accessSelectDisabled: true });
	      (0, _requests.SET_WEB_USER_ACCESS_LEVEL)(payload, function () {
	        _this.getWebUserAccessList();
	      }, function (err) {
	        _this.setState({ accessSelectDisabled: false });
	        console.error(err);
	      });
	    };
	
	    _this.rejectRequest = function (row) {
	      (0, _requests.REJECT_RECORD_ACCESS_REQUEST)(row.WEB_USER_ACCESS_ID, function (successful) {
	        if (successful) {
	          _this.setState({ owners: null });
	          _this.getWebUserAccessList();
	        }
	      });
	    };
	
	    _this.acceptRequest = function (row) {
	      (0, _requests.ACCEPT_RECORD_ACCESS_REQUEST)(row.WEB_USER_ACCESS_ID, function (successful) {
	        if (successful) {
	          _this.setState({ owners: null });
	          _this.getWebUserAccessList();
	        }
	      });
	    };
	
	    _this.startRevokeAccess = function (row) {
	      _this.setState({
	        revokeDialogOpen: true,
	        revokingName: row.FULL_NAME,
	        revokingOwnAccess: row.WEB_USER_ID === _this.props.currentUserId,
	        revokingId: row.WEB_USER_ACCESS_ID
	      });
	    };
	
	    _this.closeRevokeDialog = function () {
	      _this.setState({ revokeDialogOpen: false, revokingName: '', revokingOwnAccess: false });
	    };
	
	    _this.revokeAccess = function () {
	      (0, _requests.REVOKE_RECORD_ACCESS)(_this.state.revokingId, function (successful) {
	        if (successful) {
	          _this.setState({ revokingId: null });
	          if (_this.state.revokingOwnAccess) {
	            _this.props.onAccessRevoked();
	            // this.props.onRequestModalClose()
	          } else {
	            _this.getWebUserAccessList();
	          }
	        } else {
	          _this.setState({
	            revokingId: null,
	            error: 'Something went wrong while trying to revoke access. Try again later.'
	          });
	        }
	      });
	    };
	
	    _this.state = {
	      owners: null,
	      revokeDialogOpen: false,
	      revokingName: '',
	      revokingOwnAccess: false,
	      revokingId: null,
	      error: null,
	      accessSelectDisabled: true,
	      currentOwnerAccessLevel: null
	    };
	    return _this;
	  }
	
	  _createClass(Ownership, [{
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var ACTION_MAP = {
	        Accepted: function Accepted(row) {
	          // If ALLOW_REVOKE_OWN_ACCESS_ONLY is true, only allow the user to revoke their own access.
	          return !ALLOW_REVOKE_OWN_ACCESS_ONLY || row.WEB_USER_ID === _this2.props.currentUserId ? [{
	            label: _react2.default.createElement(
	              'span',
	              null,
	              'Revoke'
	            ),
	            className: 'primary',
	            hideLabel: false,
	            tooltip: false,
	            style: 'inner',
	            onClick: _this2.startRevokeAccess
	          }] : null;
	        },
	        Requested: [{
	          label: _react2.default.createElement(
	            'span',
	            null,
	            _react2.default.createElement('span', { className: 'icon icon-check' }),
	            ' Accept'
	          ),
	          className: 'success',
	          hideLabel: false,
	          tooltip: false,
	          style: 'inner',
	          onClick: this.acceptRequest
	        }, {
	          label: _react2.default.createElement(
	            'span',
	            null,
	            _react2.default.createElement('span', { className: 'icon icon-cross' }),
	            ' Reject'
	          ),
	          className: 'danger',
	          hideLabel: false,
	          tooltip: false,
	          style: 'inner',
	          onClick: this.rejectRequest
	        }]
	      };
	      return _react2.default.createElement(
	        'div',
	        { className: 'ownership' },
	        this.state.error && _react2.default.createElement(
	          'p',
	          { className: 'error' },
	          this.state.error
	        ),
	        this.state.owners ? _react2.default.createElement(_Table2.default, {
	          template: [{ label: 'User', id: 'FULL_NAME' }, { label: 'Status', id: 'STATUS' }, { label: 'Date', id: 'LAST_MODIFIED_DATE' }].concat(_toConsumableArray(USER_ACCESS_LEVEL_MANAGEMENT ? [{
	            label: 'Access Level',
	            id: 'WEB_USER_ACCESS_LEVEL_TYPE_ID',
	            render: this.getAccessEditorCell
	          }] : [])),
	          rows: this.state.owners,
	          className: 'center-container',
	          onCellClick: null,
	          actionCell: true,
	          actionMap: ACTION_MAP,
	          actionCellClassName: 'ownership-action-cell',
	          selectedRowIndex: null,
	          animated: false,
	          firstCellInteractive: false
	        }) : _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement(_Loaders.Spinner, { themeColor: 'medium-neutral-color' })
	        ),
	        _react2.default.createElement(
	          _Portal2.default,
	          { isOpened: this.state.revokeDialogOpen },
	          _react2.default.createElement(_Modal.ConfirmDialog, {
	            closeModal: this.closeRevokeDialog,
	            message: 'Are you sure you want to revoke ' + (this.state.revokingOwnAccess ? 'your own access to this record? To manage this record, you' : this.state.revokingName + '\'s access to this record? To become an owner, they') + ' will be required to request access again.',
	            buttons: [{ label: 'No', onClick: _utilities.noop, className: 'btn-default' }, { label: 'Yes', onClick: this.revokeAccess, className: 'btn-danger' }],
	            modalStyle: { borderRadius: 3 }
	          })
	        )
	      );
	    }
	  }]);
	
	  return Ownership;
	}(_react.Component);
	
	exports.default = Ownership = (0, _reactRedux.connect)(function (state) {
	  return {
	    currentUserId: state.auth.WEB_USER_ID
	  };
	})(Ownership);

/***/ },
/* 1118 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Shell = __webpack_require__(19);
	
	var _reactRouterDom = __webpack_require__(30);
	
	var _reactRedux = __webpack_require__(7);
	
	var _Pins = __webpack_require__(462);
	
	var _FormCard = __webpack_require__(195);
	
	var _FormCard2 = _interopRequireDefault(_FormCard);
	
	var _utilities = __webpack_require__(8);
	
	var _requests = __webpack_require__(6);
	
	var _Markdown = __webpack_require__(24);
	
	var _Markdown2 = _interopRequireDefault(_Markdown);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var PIN_GENERIC_DESCRIPTION = ({"NODE_ENV":"production","BUILD_DATE":"2025-08-27T15:15:31.687Z","BUILD_NUMBER":"Not Provided","GIT_VERSION":"v1.3.0-381-ga81e29b08","GIT_COMMIT_HASH":"a81e29b085c9268ffd96c78eb734365802722741","GIT_BRANCH":"beta","PUBLIC_URL":"","STATE_ABBR":"MT","STATE_NAME":"Montana","STATE_ORG_TITLE":"Secretary of State","LOGIN_HEADER_IMG_PATH":"","HOME_IMG_FILENAME":"montana.jpg","FAVICON_FILE_NAME":"favicon.ico","ALLOW_E_SIGN_ON_CORRECTIONS":true,"THIRD_PARTY_SIGNING_ALLOWED":false,"MY_ACCOUNT_SAVE_AND_CLOSE_BUTTON":true,"IE_DEPRECATED_MESSAGE":"Internet Explorer is not supported. Please select a supported browser below to access this website.","ADDITIONAL_ROUTES":{"dataRequests":true,"farmBill":true,"apostille":true,"externalHelp":"https://sosmt.gov/business/help-center/","systemAdministration":[{"title":"Saved Payments","parameter":"saved-payments","componentName":"SavedPayments"}]},"SUBROUTES":[{"label":"Business","component":"Business","parameter":"business","myWorkQueueSearch":false,"sourceTypeId":54,"searchMustHaveOneOf":["FILING_TYPE_ID","STATUS_ID","STATE","search"],"serverWebSearchDescription":true,"serverWorkQueueDescription":true,"serverMyRecordsDescription":true,"searchPlaceholder":"Search by name or filing number (X########)","allowEmptySearchTerm":true,"requestCertificateAlternateLabel":"Request Information","fileAmendmentButtonLabel":"Filing Actions","advancedSearchParameters":[{"type":"radio","name":"QUERY_TYPE_ID","defaultValue":1010,"options":[{"value":1010,"label":"Starts with"},{"value":1011,"label":"Contains"},{"value":1012,"label":" Word Contains"}]},{"type":"serverSelect","name":"FILING_TYPE_ID","optionsSrc":"FILING_TYPES","label":"Entity Type","placeholder":"All","defaultValue":"0"},{"type":"serverSelect","name":"FILING_SUBTYPE_ID","optionsSrc":"FILING_SUBTYPES","label":"Entity Subtype","overrideSubOptionsSrcFromParameterName":"FILING_TYPE_ID","placeholder":"All","defaultValue":"0"},{"type":"serverSelect","name":"STATUS_ID","optionsSrc":"FILING_STATUS_WITHOUT_ALL","label":"Status","placeholder":"All","defaultValue":"0"},{"type":"serverSelect","name":"STATE","optionsSrc":"STATE","label":"State","placeholder":"All","defaultValue":""},{"type":"serverSelect","name":"COUNTY","optionsSrc":"COUNTY_SUBOPTION","label":"County","overrideSubOptionsSrcFromParameterName":"STATE","placeholder":"All","defaultValue":""},{"type":"checkbox","name":"CRA_SEARCH_YN","defaultValue":false,"label":"Search by Registered Agent PID"},{"type":"dateRange","name":"FILING_DATE","label":"Registration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}},{"type":"dateRange","name":"EXPIRATION_DATE","label":"Expiration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}}],"myRecordsFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Active"},{"value":2,"label":"Inactive"},{"value":3,"label":"Pending"}]},{"type":"dateRange","name":"DATE_RANGE","label":"Date range","defaultValue":{"start":null,"end":null}}],"myWorkQueueFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Approved"},{"value":2,"label":"Pending Online Payment"},{"value":3,"label":"Pending Review"},{"value":4,"label":"Needs Correction"},{"value":5,"label":"Rejected"},{"value":6,"label":"Draft"}]},{"type":"dateRange","name":"DATE_RANGE","label":"Date range","defaultValue":{"start":null,"end":null}}]},{"label":"Notary","component":"Notary","parameter":"notary","sourceTypeId":850,"myWorkQueueSearch":false,"allowEmptySearchTerm":true,"requestCertificateAlternateLabel":"Download Certificate","fileAmendmentButtonLabel":"Filing Actions","hideNameRequestCertificate":true,"hideAddressRequestCertificate":true,"hideRecordUserManagment":true,"searchPlaceholder":"Search by name or commission number","searchMustHaveOneOf":["CITY","search","SERVICE_TYPE"],"advancedParametersStartOpen":true,"searchIsSortable":true,"advancedSearchParameters":[{"type":"radio","name":"STARTS_WITH_YN","defaultValue":false,"options":[{"value":true,"label":"Starts with"},{"value":false,"label":"Contains"}]},{"type":"checkbox","name":"ACTIVE_ONLY_YN","defaultValue":true,"label":"Active entities only"},{"type":"text","name":"CITY","defaultValue":"","label":"City"},{"type":"select","name":"SERVICE_TYPE","label":"Special Services Offered","defaultValue":0,"options":[{"value":0,"label":"(N/A)"},{"value":6165,"label":"In-Person Electronic Notarization (IPEN)"},{"value":6166,"label":"Remote Online Notarization (RON)"},{"value":6167,"label":"Mobile Notary Services"},{"value":6168,"label":"Remote Ink Notarization (RIN)"}]}]},{"label":"Apostille","component":"Apostille","parameter":"apostille","sourceTypeId":720,"myRecordsSearch":false,"myWorkQueueSearch":false,"disabled":false,"allowedRoutes":["/forms-manager/","/queue/","/forms/"]},{"label":"Liens","component":"UCC","parameter":"ucc","sourceTypeId":1999,"myRecordsSearch":true,"myWorkQueueSearch":true,"fileAmendmentButtonLabel":"Filing Actions","searchPlaceholder":"Search by name or file number","disabled":false,"serverWebSearchDescription":true,"myRecordsDescription":"","workQueueDescription":"","searchDescription":"","hideRecordUserManagment":true,"searchLiensCheckout":false,"advancedSearchParameters":[{"type":"radio","name":"STARTS_WITH_YN","defaultValue":false,"options":[{"value":true,"label":"Starts with"},{"value":false,"label":"Contains"}]},{"type":"select","name":"STATUS","defaultValue":"ALL","label":"Status","options":[{"value":"ACTIVE_UNLAPSED","label":"Active (unlapsed)"},{"value":"ACTIVE_LAPSED_UNLAPSED","label":"Active (lapsed and unlapsed)"}]},{"type":"text","name":"EXCLUDE_VALUES","label":"Exclude Debtor Names (comma separated list of names to exclude)","defaultValue":""},{"type":"dateRange","name":"FILING_DATE","label":"Financing Statement Date","defaultValue":{"start":null,"end":null}},{"type":"dateRange","name":"LAPSE_DATE","label":"Lapse Date","defaultValue":{"start":null,"end":null}},{"type":"text","name":"CITY","label":"Debtor City","defaultValue":""}],"myRecordsFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Approved"},{"value":2,"label":"Pending Online Payment"},{"value":3,"label":"Pending Review"}]},{"type":"select","name":"TYPE","defaultValue":0,"label":"Lien Type","options":[{"value":0,"label":"All"},{"value":1,"label":"UCC"},{"value":2,"label":"EFS"},{"value":3,"label":"Title 71"}]}],"myWorkQueueFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Approved"},{"value":2,"label":"Pending Online Payment"},{"value":3,"label":"Pending Review"},{"value":4,"label":"Pending Print and Mail"},{"value":5,"label":"Rejected"},{"value":6,"label":"Draft"}]},{"type":"select","name":"TYPE","defaultValue":0,"label":"Lien Type","options":[{"value":0,"label":"All"},{"value":1,"label":"UCC"},{"value":2,"label":"EFS"},{"value":3,"label":"Title 71"}]}]},{"label":"Copy Request","component":"copies","parameter":"copies","sourceTypeId":2001,"myRecordsSearch":false,"myWorkQueueSearch":false,"disabled":false,"allowedRoutes":["/forms-manager/","/queue/","/forms/"]},{"label":"Trademark","component":"Trademark","parameter":"trademark","sourceTypeId":810,"showRequestCertificate":true,"searchMustHaveOneOf":["search","EXPIRATION_DATE","FILING_DATE"],"allowEmptySearchTerm":true,"requestCertificateAlternateLabel":"Request Information","fileAmendmentButtonLabel":"Filing Actions","advancedSearchParameters":[{"type":"radio","name":"QUERY_TYPE_ID","defaultValue":1010,"options":[{"value":1010,"label":"Starts with"},{"value":1011,"label":"Contains"},{"value":1012,"label":" Word Contains"}]},{"type":"checkbox","name":"OWNER_SEARCH_YN","defaultValue":false,"label":"Search owners"},{"type":"radio","name":"SERVICE_MARK_YN","label":"Mark Type","defaultValue":"","options":[{"value":"","label":"All Marks"},{"value":"Y","label":"Service Mark"},{"value":"N","label":"Trademark"}]},{"type":"serverSelect","name":"STATUS_ID","optionsSrc":"TYPE_V|TRADEMARK_STATUS_TYPE","label":"Status","placeholder":"All","defaultValue":"0"},{"type":"select","name":"DESIGN_TYPE_ID","options":[{"value":0,"label":"All"},{"value":990,"label":"Words Only"},{"value":991,"label":"Design Only"},{"value":992,"label":"Words and Design"}],"label":"Design Type","defaultValue":"0"},{"type":"dateRange","name":"FILING_DATE","label":"Registered Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}},{"type":"dateRange","name":"EXPIRATION_DATE","label":"Expiration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}}]},{"label":"Business Info Request","component":"InfoRequests","parameter":"info-request","sourceTypeId":167,"allowedRoutes":["/forms-manager/","/queue/","/forms/"]},{"label":"Data Requests","component":"DataRequests","parameter":"data-request","sourceTypeId":0,"allowedRoutes":["/forms-manager/"]},{"label":"CRA","component":"CRA","parameter":"cra","sourceTypeId":157,"myRecordsSearch":false,"searchPlaceholder":"Search by name or registered agent number","allowedRoutes":["/forms-manager/","/forms/","/records/","/queue/","/search/"],"allowEmptySearchTerm":true,"fileAmendmentButtonLabel":"Filing Actions","advancedSearchParameters":[{"type":"radio","name":"QUERY_TYPE_ID","defaultValue":1010,"options":[{"value":1010,"label":"Starts with"},{"value":1011,"label":"Contains"},{"value":1012,"label":" Word Contains"}]},{"type":"dateRange","name":"CRA_DATE","label":"Registration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}},{"type":"select","name":"STATUS_ID","label":"Status","defaultValue":0,"options":[{"value":0,"label":"All"},{"value":121,"label":"Active"},{"value":122,"label":"Inactive"}]},{"type":"select","name":"AGENT_TYPE_ID","label":"Agent Type","defaultValue":0,"options":[{"value":0,"label":"All"},{"value":460,"label":"Registered Agent"},{"value":461,"label":"Commercial Registered Agent"}]}]},{"label":"Farm Bill","component":"FarmBill","parameter":"farm-bill","path":"/lists/farm-bill","sourceTypeId":0,"myRecordsSearch":false,"allowedRules":["/search/"],"disabled":true,"searchDescription":"To perform a search, enter a debtor name. Your search results may include: exact debtor name, variations of that name and any filing that includes your search criteria. Punctuation is ignored.\n\nYou can click on \"Advanced\" to refine your search. Under “Advanced” you can search by crop, year, county and SSN/FEIN. As a registered Farm Bill Buyer with the Montana Secretary of State’s office it is important to maintain the confidentiality of the information contained within the Farm Bill Master List. The Farm Bill Master List reflects personal data, such as Social Security Numbers, which are a key piece of personal identifiable information to assist you in determining the existence of a lien against a specific debtor. The distribution of this information beyond its intended purpose is strictly prohibited.\n\nThe debtor's tax identification number has been hidden for confidentiality reasons. You may continue to search on a tax ID number and return debtors that match your search criteria. The SSN/FEIN must be entered without dashes or spaces.","searchMustHaveOneOf":["search","UCC_FARM_PRODUCT_ID","COUNTY"],"searchPlaceholder":"Search by debtor name","advancedSearchParameters":[{"type":"ServerMultiComplete","label":"Product code name(s)","name":"UCC_FARM_PRODUCT_ID","defaultValue":"","optionsSrc":"UCC_FARM_PRODUCT_V"},{"type":"MultiComplete","label":"Year or Range of Years","name":"YEAR_NUM","optionsSrc":"years","startYear":"1968","defaultValue":[],"preMergeOptions":[{"value":"ALL","label":"All"}]},{"type":"serverSelect","label":"State","name":"STATE","defaultValue":"MONTANA","optionsSrc":"STATE"},{"type":"ServerMultiComplete","label":"County","name":"COUNTY","defaultValue":[],"optionsSrc":"COUNTY","overrideSubOptionsSrcFromParameterName":"STATE"},{"type":"checkbox","name":"TIN_SEARCH_YN","defaultValue":false,"label":"Tax Identification Number Search"},{"type":"checkbox","name":"TIN_SORT_YN","defaultValue":false,"label":"Unique ID Sort"}]}],"SYSTEM_NICKNAME":"Online Services Portal","PAYMENT_METHODS":[{"type":"bypass"},{"type":"iTransact"}],"PAYMENT_ALLOW_AMEX":true,"SYSTEM_ID_LABEL":"System Id","DOUBLE_COLUMN_PUBLIC_LOGIN":true,"INTERNAL_USER_MANAGEMENT":true,"ALLOW_PUBLIC_JSON_IMPORT":false,"MAX_FILE_UPLOAD_SIZE":10000000,"REFUND_TEXT":"","RETURN_TO_HOME_ON_LOGOUT":true,"CURRENT_SOS_NAME":"Christi Jacobsen","LOGO_FILENAME":"mt-sos-logo.png","LOGO_ALT":"Christi Jacobsen, Montana Secretary of State","LOGO_FULL_WIDTH":true,"HOME_HIDE_AUTH_HINT":true,"HOME_TITLE":"Montana Secretary of State","CUSTOM_TAB_TITLE":"Official Montana","HOME_SUBTITLE":"Online Business Services","ENTITY_NAME_CONSENT_DESCRIPTION":"","ALLOW_USER_PROFILE_EDITING":true,"COMPARE_FOREIGN_NAME_IN_ENTITY_NAME_VALIDATION":true,"FOREIGN_NAME_FIELD_NAME":"KIMA_PARENT_NAME_INFO","LOGIN_TITLE":"Montana Secretary of State Online Filing Portal Login","PUBLIC_LOGIN_LABEL":"Username","REVERSE_LOGIN_COLUMNS":true,"LOGIN_SEAL_FILENAME":"seal_white.png","SEPARATE_USERNAME_AND_EMAIL":true,"CREATE_ACCOUNT_BUTTON_ALIGN_LEFT":true,"CREATE_ACCOUNT_BUTTON_TEXT":"CREATE AN ACCOUNT","PASSWORD_CUSTOM_ERROR_TEXT":"The password must meet all requirements","ACCOUNT_CREATED_MESSAGE":"Please check your email to verify your account to login and allow a few minutes for this message to arrive. Check your junk/spam folders if you do not find the email in your inbox.","PUBLIC_LOGIN_PLACEHOLDER":" ","DISABLE_DEFAULT_PAYMENT_RADIO":true,"CUSTOM_RESET_PASSWORD_ERROR_MESSAGE":"Username invalid - no account found","PUBLIC_LOGIN_CREATE_DESCRIPTION":"### Existing User:\n\n  - Enter your username and password to login.  \n\n\n  #### - OR -  \n\n\n\n  - Forgot password? Click 'Reset Password' and follow the prompts.\n  - Forgot username? Click 'Forgot Username' and follow the prompts.  \n\n\n  ### New User:\n  ","LOGIN_HELP_LINK":"https://sosmt.gov/business/how-do-i/","LOGIN_HELP_LINK_TEXT":"Need Help?","FORGOT_USERNAME_TEXT":"Forgot Username?","LOGIN_ACTIVE_DIRECTORY_TEXT":"State User Login","MULTIPLE_LOGIN_METHODS":true,"HAS_ACTIVE_DIRECTORY_LOGIN":true,"RESET_PASSWORD_WITH_USERNAME":true,"DOWNLOAD_LINK":true,"SHOW_USERNAME_ACCOUNT_CREATE":true,"SHOW_SCROLL_DOWN_ARROW":true,"SHOW_ADDRESS_ACCOUNT_CREATE":true,"TWO_COLUMN_ACCOUNT_CREATE":true,"RESET_PASSWORD_TIP":"A link to change your password has been sent to your email. Please allow a few minutes for this message to arrive. Please check your junk/spam folders if you do not find the email in your inbox.","FORGOT_PASSWORD_LINK_TEXT":"Reset Password","PHONE_NUMBER_OPTIONAL_ACCOUNT_CREATE":true,"SHOW_REQUIRED_INDICATOR_ACCOUNT_CREATE":true,"PASSWORD_REQUIREMENTS_ACCOUNT_CREATE":"\n    <ul>\n      <li>MUST contain at least 8 characters (12+ recommended)</li>\n      <li>MUST contain at least one uppercase letter.</li>\n      <li>MUST contain at least one lowercase letter.</li>\n      <li>MUST contain at least one number.</li>\n      <li>MUST contain at least one special character (!”#$%&'()*+,-./:;<=>?</li>\n    </ul>\n  ","ALLOW_CERTIFICATION_REQUEST":true,"ALLOW_PUBLIC_CERTIFICATE_REQUEST":true,"ALLOW_COPY_REQUEST":false,"ALLOW_CORRECTION_STYLING":true,"HIDE_DEPRECATION_WARNING":false,"AMEND_ROUTE_PUBLIC":true,"SEAL_FILENAME":"seal.png","SHOPPING_CART":true,"ALLOW_PAYMENT_UPDATE_WITH_EMPTY_CART":true,"RA_EMAIL":true,"RA_WEBSITE":true,"RA_NO_DEFAULT_TYPE":true,"RA_ADDRESS_LABEL":"Street Address","RA_TYPE_SELECTION_DEFAULT":true,"RA_DEFAULT_TYPE":"460","RA_OVERRIDE_TYPE_WITH_DEFAULT":true,"RA_PRINCIPAL_ADDRESS_AMS":true,"UPLOAD_AND_SUBMIT_HIDE_IF_ONE_OPTION":true,"PAYMENT_PROCESSING_MESSAGE":"Your payment is processing - Do not close your browser or click the back button","CHECKOUT_BUTTON_WHEN_PROCESSING_TEXT":"Processing","EFS_CROP_PICKER_NONE_LABEL":"Lien Duration","DISALLOWED_WIZARD_PIECES":["FormationLocale"],"REPEATER_SHOW_EDIT_BUTTON":true,"DATA_REQUEST_PAGE_TITLE":"Data Requests and Subscriptions","DATA_REQUEST_SIDEBAR_LABEL":"Data Requests & Subscriptions","LOGIN_REDIRECTS_TO_EPASS":false,"LOGIN_REDIRECTS_TO_ACTIVE_DIRECTORY":true,"LOGIN_ACTIVE_DIRECTORY_LINK":true,"FETCH_EDIT_USER_LINK":false,"LISTS_FETCH_AVAILABLE_LISTS":true,"POST_WIZARD_SUBMIT_REDIRECT_URL":"/","PIN_REQUEST_ATTESTATIONS":true,"PIN_REQUEST_DESCRIPTION":"Click **Request PIN** to have a new PIN sent to the account holder's email address on file.","OWNERSHIP_REQUEST_DESCRIPTION":"To become an **authorized user** of this record, a current **AUTHORIZED USER** will need to grant you access. To request access, click **Request Access** below.","PIN_REQUEST_SUCCESS_MESSAGE":"The PIN you have requested for this entity has been sent to the email associated with your user account.  You should receive the PIN in approximately 3-5 minutes, depending on your email service provider.","APOSTILLE_HEADER_LABEL":"Verification Information","APOSTILLE_NUMBER_LABEL":"Apostille/Authentication","APOSTILLE_CITY_STATE_OVERRIDE":"HELENA, MT","APOSTILLE_FILING_DATE_LABEL":"Issue Date","APOSTILLE_CITY_STATE_IN_CERTIFIED":true,"NOTARY_EXISTING_FILING":true,"ALLOW_REVOKE_OWN_ACCESS_ONLY":false,"HIDE_CANCEL_ON_ONETIME_DATA_REQUESTS":true,"DATA_REQUESTS_IN_SHOPPING_CART":true,"WQ_ALLOW_EDIT_PENDING_PAYMENT":true,"WQ_CONFIRM_ON_DELETE":true,"WQ_DELETE_CONFIRM_MESSAGE":"Deleting this filing will forfeit any money already paid to the Secretary of State. This action is permanent and cannot be undone, are you sure you would like to delete?","PASS_ITEM_GUIDS_ON_CHECKOUT":true,"FORM_REVISION_HISTORY":true,"CHECKOUT_DISCLAIMER":"By entering your credit card and/or checking account information you (i) state that **you are an authorized user** of the credit card and/or electronic check and that the associated information entered (e.g., account holder name, account number, billing address) is accurate, (ii) **you authorize payment processor to charge the amount you have requested** to your credit card and/or funding account, and (iii) **acknowledge if a charge is declined or reversed you may also be assessed a customary charge** by the payment processor for such transactions.","FARM_BILL_SEARCH_CONFIDENTIAL":"As a registered Farm Bill Buyer with the Montana Secretary of State’s office it is important to maintain the confidentiality of the information contained within the Farm Bill Master List. The Farm Bill Master List reflects personal data, such as Social Security Numbers, which are a key piece of personal identifiable information to assist you in determining the existence of a lien against a specific debtor. The distribution of this information beyond its intended purpose is strictly prohibited.\n\n**The debtor's tax identification number has been hidden for confidentiality reasons. You may continue to search on a tax ID number and return debtors that match your search criteria. The SSN/FEIN must be entered without dashes or spaces.  If you need access to the tax identification number to clearly identify the debtor, please contact the UCC unit at (406) 444-3665.**","VIEW_HISTORY_BUTTON_ALT_TEXT":"View Filings","WIZARD_ERROR_TITLE_MESSAGE":"Form Error","FARM_BILL_SEARCH_INTERACTIVE":true,"USE_FARM_BILL_API":true,"DISALLOW_ASSIGN_SELF_AS_RA":true,"DISALLOW_ASSIGN_SELF_AS_PRINCIPAL":true,"USE_TRADEMARK_OWNER_VALIDATION":true,"USE_ALTERNATIVE_FOREIGN_ADDRESS_LABELS":true,"MY_RECEIPTS_FILTER":[{"type":"dateRange","name":"DATE_RANGE","label":"Date range","defaultValue":{"start":null,"end":null}},{"type":"text","name":"REF_NUM","defaultValue":"","label":"Reference Number"},{"type":"text","name":"RECEIPT_NUM","defaultValue":"","label":"Receipt Id"},{"type":"text","name":"AMOUNT","defaultValue":"","label":"Amount"},{"type":"select","name":"TYPE","defaultValue":"","label":"Payment Type","options":[{"value":"","label":"All"},{"value":"CC","label":"Credit Card"},{"value":"Check","label":"Check"}]}],"MY_RECEIPTS_SHOW_IN_SIDEBAR":true,"SHOW_MY_RECEIPTS_HELPER_TEXT":true,"MY_RECEIPTS_HELPER_LABEL":"About Receipt Search","MY_RECEIPTS_HELPER_TEXT":"You can search for receipts based on their descriptions, including the items paid for on the receipt. Use the filters to search for or filter specific information.","FARM_BILL_SUBLINK":{"label":"Farm Bill","component":"FarmBill","parameter":"farm-bill","path":"/lists/farm-bill","sourceTypeId":0,"myRecordsSearch":false,"allowedRules":["/search/"],"disabled":true,"searchDescription":"To perform a search, enter a debtor name. Your search results may include: exact debtor name, variations of that name and any filing that includes your search criteria. Punctuation is ignored.\n\nYou can click on \"Advanced\" to refine your search. Under “Advanced” you can search by crop, year, county and SSN/FEIN. As a registered Farm Bill Buyer with the Montana Secretary of State’s office it is important to maintain the confidentiality of the information contained within the Farm Bill Master List. The Farm Bill Master List reflects personal data, such as Social Security Numbers, which are a key piece of personal identifiable information to assist you in determining the existence of a lien against a specific debtor. The distribution of this information beyond its intended purpose is strictly prohibited.\n\nThe debtor's tax identification number has been hidden for confidentiality reasons. You may continue to search on a tax ID number and return debtors that match your search criteria. The SSN/FEIN must be entered without dashes or spaces.","searchMustHaveOneOf":["search","UCC_FARM_PRODUCT_ID","COUNTY"],"searchPlaceholder":"Search by debtor name","advancedSearchParameters":[{"type":"ServerMultiComplete","label":"Product code name(s)","name":"UCC_FARM_PRODUCT_ID","defaultValue":"","optionsSrc":"UCC_FARM_PRODUCT_V"},{"type":"MultiComplete","label":"Year or Range of Years","name":"YEAR_NUM","optionsSrc":"years","startYear":"1968","defaultValue":[],"preMergeOptions":[{"value":"ALL","label":"All"}]},{"type":"serverSelect","label":"State","name":"STATE","defaultValue":"MONTANA","optionsSrc":"STATE"},{"type":"ServerMultiComplete","label":"County","name":"COUNTY","defaultValue":[],"optionsSrc":"COUNTY","overrideSubOptionsSrcFromParameterName":"STATE"},{"type":"checkbox","name":"TIN_SEARCH_YN","defaultValue":false,"label":"Tax Identification Number Search"},{"type":"checkbox","name":"TIN_SORT_YN","defaultValue":false,"label":"Unique ID Sort"}]},"ALLOW_ADDRESS_VALIDATION_BYPASS_OPTION":true,"DEFAULT_ADDRESS_VALIDATION_BYPASS_OPTION_CHECKED":true}).PIN_GENERIC_DESCRIPTION;
	var PIN_NOT_LOGGED_IN_DESCRIPTION = ({"NODE_ENV":"production","BUILD_DATE":"2025-08-27T15:15:31.687Z","BUILD_NUMBER":"Not Provided","GIT_VERSION":"v1.3.0-381-ga81e29b08","GIT_COMMIT_HASH":"a81e29b085c9268ffd96c78eb734365802722741","GIT_BRANCH":"beta","PUBLIC_URL":"","STATE_ABBR":"MT","STATE_NAME":"Montana","STATE_ORG_TITLE":"Secretary of State","LOGIN_HEADER_IMG_PATH":"","HOME_IMG_FILENAME":"montana.jpg","FAVICON_FILE_NAME":"favicon.ico","ALLOW_E_SIGN_ON_CORRECTIONS":true,"THIRD_PARTY_SIGNING_ALLOWED":false,"MY_ACCOUNT_SAVE_AND_CLOSE_BUTTON":true,"IE_DEPRECATED_MESSAGE":"Internet Explorer is not supported. Please select a supported browser below to access this website.","ADDITIONAL_ROUTES":{"dataRequests":true,"farmBill":true,"apostille":true,"externalHelp":"https://sosmt.gov/business/help-center/","systemAdministration":[{"title":"Saved Payments","parameter":"saved-payments","componentName":"SavedPayments"}]},"SUBROUTES":[{"label":"Business","component":"Business","parameter":"business","myWorkQueueSearch":false,"sourceTypeId":54,"searchMustHaveOneOf":["FILING_TYPE_ID","STATUS_ID","STATE","search"],"serverWebSearchDescription":true,"serverWorkQueueDescription":true,"serverMyRecordsDescription":true,"searchPlaceholder":"Search by name or filing number (X########)","allowEmptySearchTerm":true,"requestCertificateAlternateLabel":"Request Information","fileAmendmentButtonLabel":"Filing Actions","advancedSearchParameters":[{"type":"radio","name":"QUERY_TYPE_ID","defaultValue":1010,"options":[{"value":1010,"label":"Starts with"},{"value":1011,"label":"Contains"},{"value":1012,"label":" Word Contains"}]},{"type":"serverSelect","name":"FILING_TYPE_ID","optionsSrc":"FILING_TYPES","label":"Entity Type","placeholder":"All","defaultValue":"0"},{"type":"serverSelect","name":"FILING_SUBTYPE_ID","optionsSrc":"FILING_SUBTYPES","label":"Entity Subtype","overrideSubOptionsSrcFromParameterName":"FILING_TYPE_ID","placeholder":"All","defaultValue":"0"},{"type":"serverSelect","name":"STATUS_ID","optionsSrc":"FILING_STATUS_WITHOUT_ALL","label":"Status","placeholder":"All","defaultValue":"0"},{"type":"serverSelect","name":"STATE","optionsSrc":"STATE","label":"State","placeholder":"All","defaultValue":""},{"type":"serverSelect","name":"COUNTY","optionsSrc":"COUNTY_SUBOPTION","label":"County","overrideSubOptionsSrcFromParameterName":"STATE","placeholder":"All","defaultValue":""},{"type":"checkbox","name":"CRA_SEARCH_YN","defaultValue":false,"label":"Search by Registered Agent PID"},{"type":"dateRange","name":"FILING_DATE","label":"Registration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}},{"type":"dateRange","name":"EXPIRATION_DATE","label":"Expiration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}}],"myRecordsFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Active"},{"value":2,"label":"Inactive"},{"value":3,"label":"Pending"}]},{"type":"dateRange","name":"DATE_RANGE","label":"Date range","defaultValue":{"start":null,"end":null}}],"myWorkQueueFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Approved"},{"value":2,"label":"Pending Online Payment"},{"value":3,"label":"Pending Review"},{"value":4,"label":"Needs Correction"},{"value":5,"label":"Rejected"},{"value":6,"label":"Draft"}]},{"type":"dateRange","name":"DATE_RANGE","label":"Date range","defaultValue":{"start":null,"end":null}}]},{"label":"Notary","component":"Notary","parameter":"notary","sourceTypeId":850,"myWorkQueueSearch":false,"allowEmptySearchTerm":true,"requestCertificateAlternateLabel":"Download Certificate","fileAmendmentButtonLabel":"Filing Actions","hideNameRequestCertificate":true,"hideAddressRequestCertificate":true,"hideRecordUserManagment":true,"searchPlaceholder":"Search by name or commission number","searchMustHaveOneOf":["CITY","search","SERVICE_TYPE"],"advancedParametersStartOpen":true,"searchIsSortable":true,"advancedSearchParameters":[{"type":"radio","name":"STARTS_WITH_YN","defaultValue":false,"options":[{"value":true,"label":"Starts with"},{"value":false,"label":"Contains"}]},{"type":"checkbox","name":"ACTIVE_ONLY_YN","defaultValue":true,"label":"Active entities only"},{"type":"text","name":"CITY","defaultValue":"","label":"City"},{"type":"select","name":"SERVICE_TYPE","label":"Special Services Offered","defaultValue":0,"options":[{"value":0,"label":"(N/A)"},{"value":6165,"label":"In-Person Electronic Notarization (IPEN)"},{"value":6166,"label":"Remote Online Notarization (RON)"},{"value":6167,"label":"Mobile Notary Services"},{"value":6168,"label":"Remote Ink Notarization (RIN)"}]}]},{"label":"Apostille","component":"Apostille","parameter":"apostille","sourceTypeId":720,"myRecordsSearch":false,"myWorkQueueSearch":false,"disabled":false,"allowedRoutes":["/forms-manager/","/queue/","/forms/"]},{"label":"Liens","component":"UCC","parameter":"ucc","sourceTypeId":1999,"myRecordsSearch":true,"myWorkQueueSearch":true,"fileAmendmentButtonLabel":"Filing Actions","searchPlaceholder":"Search by name or file number","disabled":false,"serverWebSearchDescription":true,"myRecordsDescription":"","workQueueDescription":"","searchDescription":"","hideRecordUserManagment":true,"searchLiensCheckout":false,"advancedSearchParameters":[{"type":"radio","name":"STARTS_WITH_YN","defaultValue":false,"options":[{"value":true,"label":"Starts with"},{"value":false,"label":"Contains"}]},{"type":"select","name":"STATUS","defaultValue":"ALL","label":"Status","options":[{"value":"ACTIVE_UNLAPSED","label":"Active (unlapsed)"},{"value":"ACTIVE_LAPSED_UNLAPSED","label":"Active (lapsed and unlapsed)"}]},{"type":"text","name":"EXCLUDE_VALUES","label":"Exclude Debtor Names (comma separated list of names to exclude)","defaultValue":""},{"type":"dateRange","name":"FILING_DATE","label":"Financing Statement Date","defaultValue":{"start":null,"end":null}},{"type":"dateRange","name":"LAPSE_DATE","label":"Lapse Date","defaultValue":{"start":null,"end":null}},{"type":"text","name":"CITY","label":"Debtor City","defaultValue":""}],"myRecordsFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Approved"},{"value":2,"label":"Pending Online Payment"},{"value":3,"label":"Pending Review"}]},{"type":"select","name":"TYPE","defaultValue":0,"label":"Lien Type","options":[{"value":0,"label":"All"},{"value":1,"label":"UCC"},{"value":2,"label":"EFS"},{"value":3,"label":"Title 71"}]}],"myWorkQueueFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Approved"},{"value":2,"label":"Pending Online Payment"},{"value":3,"label":"Pending Review"},{"value":4,"label":"Pending Print and Mail"},{"value":5,"label":"Rejected"},{"value":6,"label":"Draft"}]},{"type":"select","name":"TYPE","defaultValue":0,"label":"Lien Type","options":[{"value":0,"label":"All"},{"value":1,"label":"UCC"},{"value":2,"label":"EFS"},{"value":3,"label":"Title 71"}]}]},{"label":"Copy Request","component":"copies","parameter":"copies","sourceTypeId":2001,"myRecordsSearch":false,"myWorkQueueSearch":false,"disabled":false,"allowedRoutes":["/forms-manager/","/queue/","/forms/"]},{"label":"Trademark","component":"Trademark","parameter":"trademark","sourceTypeId":810,"showRequestCertificate":true,"searchMustHaveOneOf":["search","EXPIRATION_DATE","FILING_DATE"],"allowEmptySearchTerm":true,"requestCertificateAlternateLabel":"Request Information","fileAmendmentButtonLabel":"Filing Actions","advancedSearchParameters":[{"type":"radio","name":"QUERY_TYPE_ID","defaultValue":1010,"options":[{"value":1010,"label":"Starts with"},{"value":1011,"label":"Contains"},{"value":1012,"label":" Word Contains"}]},{"type":"checkbox","name":"OWNER_SEARCH_YN","defaultValue":false,"label":"Search owners"},{"type":"radio","name":"SERVICE_MARK_YN","label":"Mark Type","defaultValue":"","options":[{"value":"","label":"All Marks"},{"value":"Y","label":"Service Mark"},{"value":"N","label":"Trademark"}]},{"type":"serverSelect","name":"STATUS_ID","optionsSrc":"TYPE_V|TRADEMARK_STATUS_TYPE","label":"Status","placeholder":"All","defaultValue":"0"},{"type":"select","name":"DESIGN_TYPE_ID","options":[{"value":0,"label":"All"},{"value":990,"label":"Words Only"},{"value":991,"label":"Design Only"},{"value":992,"label":"Words and Design"}],"label":"Design Type","defaultValue":"0"},{"type":"dateRange","name":"FILING_DATE","label":"Registered Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}},{"type":"dateRange","name":"EXPIRATION_DATE","label":"Expiration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}}]},{"label":"Business Info Request","component":"InfoRequests","parameter":"info-request","sourceTypeId":167,"allowedRoutes":["/forms-manager/","/queue/","/forms/"]},{"label":"Data Requests","component":"DataRequests","parameter":"data-request","sourceTypeId":0,"allowedRoutes":["/forms-manager/"]},{"label":"CRA","component":"CRA","parameter":"cra","sourceTypeId":157,"myRecordsSearch":false,"searchPlaceholder":"Search by name or registered agent number","allowedRoutes":["/forms-manager/","/forms/","/records/","/queue/","/search/"],"allowEmptySearchTerm":true,"fileAmendmentButtonLabel":"Filing Actions","advancedSearchParameters":[{"type":"radio","name":"QUERY_TYPE_ID","defaultValue":1010,"options":[{"value":1010,"label":"Starts with"},{"value":1011,"label":"Contains"},{"value":1012,"label":" Word Contains"}]},{"type":"dateRange","name":"CRA_DATE","label":"Registration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}},{"type":"select","name":"STATUS_ID","label":"Status","defaultValue":0,"options":[{"value":0,"label":"All"},{"value":121,"label":"Active"},{"value":122,"label":"Inactive"}]},{"type":"select","name":"AGENT_TYPE_ID","label":"Agent Type","defaultValue":0,"options":[{"value":0,"label":"All"},{"value":460,"label":"Registered Agent"},{"value":461,"label":"Commercial Registered Agent"}]}]},{"label":"Farm Bill","component":"FarmBill","parameter":"farm-bill","path":"/lists/farm-bill","sourceTypeId":0,"myRecordsSearch":false,"allowedRules":["/search/"],"disabled":true,"searchDescription":"To perform a search, enter a debtor name. Your search results may include: exact debtor name, variations of that name and any filing that includes your search criteria. Punctuation is ignored.\n\nYou can click on \"Advanced\" to refine your search. Under “Advanced” you can search by crop, year, county and SSN/FEIN. As a registered Farm Bill Buyer with the Montana Secretary of State’s office it is important to maintain the confidentiality of the information contained within the Farm Bill Master List. The Farm Bill Master List reflects personal data, such as Social Security Numbers, which are a key piece of personal identifiable information to assist you in determining the existence of a lien against a specific debtor. The distribution of this information beyond its intended purpose is strictly prohibited.\n\nThe debtor's tax identification number has been hidden for confidentiality reasons. You may continue to search on a tax ID number and return debtors that match your search criteria. The SSN/FEIN must be entered without dashes or spaces.","searchMustHaveOneOf":["search","UCC_FARM_PRODUCT_ID","COUNTY"],"searchPlaceholder":"Search by debtor name","advancedSearchParameters":[{"type":"ServerMultiComplete","label":"Product code name(s)","name":"UCC_FARM_PRODUCT_ID","defaultValue":"","optionsSrc":"UCC_FARM_PRODUCT_V"},{"type":"MultiComplete","label":"Year or Range of Years","name":"YEAR_NUM","optionsSrc":"years","startYear":"1968","defaultValue":[],"preMergeOptions":[{"value":"ALL","label":"All"}]},{"type":"serverSelect","label":"State","name":"STATE","defaultValue":"MONTANA","optionsSrc":"STATE"},{"type":"ServerMultiComplete","label":"County","name":"COUNTY","defaultValue":[],"optionsSrc":"COUNTY","overrideSubOptionsSrcFromParameterName":"STATE"},{"type":"checkbox","name":"TIN_SEARCH_YN","defaultValue":false,"label":"Tax Identification Number Search"},{"type":"checkbox","name":"TIN_SORT_YN","defaultValue":false,"label":"Unique ID Sort"}]}],"SYSTEM_NICKNAME":"Online Services Portal","PAYMENT_METHODS":[{"type":"bypass"},{"type":"iTransact"}],"PAYMENT_ALLOW_AMEX":true,"SYSTEM_ID_LABEL":"System Id","DOUBLE_COLUMN_PUBLIC_LOGIN":true,"INTERNAL_USER_MANAGEMENT":true,"ALLOW_PUBLIC_JSON_IMPORT":false,"MAX_FILE_UPLOAD_SIZE":10000000,"REFUND_TEXT":"","RETURN_TO_HOME_ON_LOGOUT":true,"CURRENT_SOS_NAME":"Christi Jacobsen","LOGO_FILENAME":"mt-sos-logo.png","LOGO_ALT":"Christi Jacobsen, Montana Secretary of State","LOGO_FULL_WIDTH":true,"HOME_HIDE_AUTH_HINT":true,"HOME_TITLE":"Montana Secretary of State","CUSTOM_TAB_TITLE":"Official Montana","HOME_SUBTITLE":"Online Business Services","ENTITY_NAME_CONSENT_DESCRIPTION":"","ALLOW_USER_PROFILE_EDITING":true,"COMPARE_FOREIGN_NAME_IN_ENTITY_NAME_VALIDATION":true,"FOREIGN_NAME_FIELD_NAME":"KIMA_PARENT_NAME_INFO","LOGIN_TITLE":"Montana Secretary of State Online Filing Portal Login","PUBLIC_LOGIN_LABEL":"Username","REVERSE_LOGIN_COLUMNS":true,"LOGIN_SEAL_FILENAME":"seal_white.png","SEPARATE_USERNAME_AND_EMAIL":true,"CREATE_ACCOUNT_BUTTON_ALIGN_LEFT":true,"CREATE_ACCOUNT_BUTTON_TEXT":"CREATE AN ACCOUNT","PASSWORD_CUSTOM_ERROR_TEXT":"The password must meet all requirements","ACCOUNT_CREATED_MESSAGE":"Please check your email to verify your account to login and allow a few minutes for this message to arrive. Check your junk/spam folders if you do not find the email in your inbox.","PUBLIC_LOGIN_PLACEHOLDER":" ","DISABLE_DEFAULT_PAYMENT_RADIO":true,"CUSTOM_RESET_PASSWORD_ERROR_MESSAGE":"Username invalid - no account found","PUBLIC_LOGIN_CREATE_DESCRIPTION":"### Existing User:\n\n  - Enter your username and password to login.  \n\n\n  #### - OR -  \n\n\n\n  - Forgot password? Click 'Reset Password' and follow the prompts.\n  - Forgot username? Click 'Forgot Username' and follow the prompts.  \n\n\n  ### New User:\n  ","LOGIN_HELP_LINK":"https://sosmt.gov/business/how-do-i/","LOGIN_HELP_LINK_TEXT":"Need Help?","FORGOT_USERNAME_TEXT":"Forgot Username?","LOGIN_ACTIVE_DIRECTORY_TEXT":"State User Login","MULTIPLE_LOGIN_METHODS":true,"HAS_ACTIVE_DIRECTORY_LOGIN":true,"RESET_PASSWORD_WITH_USERNAME":true,"DOWNLOAD_LINK":true,"SHOW_USERNAME_ACCOUNT_CREATE":true,"SHOW_SCROLL_DOWN_ARROW":true,"SHOW_ADDRESS_ACCOUNT_CREATE":true,"TWO_COLUMN_ACCOUNT_CREATE":true,"RESET_PASSWORD_TIP":"A link to change your password has been sent to your email. Please allow a few minutes for this message to arrive. Please check your junk/spam folders if you do not find the email in your inbox.","FORGOT_PASSWORD_LINK_TEXT":"Reset Password","PHONE_NUMBER_OPTIONAL_ACCOUNT_CREATE":true,"SHOW_REQUIRED_INDICATOR_ACCOUNT_CREATE":true,"PASSWORD_REQUIREMENTS_ACCOUNT_CREATE":"\n    <ul>\n      <li>MUST contain at least 8 characters (12+ recommended)</li>\n      <li>MUST contain at least one uppercase letter.</li>\n      <li>MUST contain at least one lowercase letter.</li>\n      <li>MUST contain at least one number.</li>\n      <li>MUST contain at least one special character (!”#$%&'()*+,-./:;<=>?</li>\n    </ul>\n  ","ALLOW_CERTIFICATION_REQUEST":true,"ALLOW_PUBLIC_CERTIFICATE_REQUEST":true,"ALLOW_COPY_REQUEST":false,"ALLOW_CORRECTION_STYLING":true,"HIDE_DEPRECATION_WARNING":false,"AMEND_ROUTE_PUBLIC":true,"SEAL_FILENAME":"seal.png","SHOPPING_CART":true,"ALLOW_PAYMENT_UPDATE_WITH_EMPTY_CART":true,"RA_EMAIL":true,"RA_WEBSITE":true,"RA_NO_DEFAULT_TYPE":true,"RA_ADDRESS_LABEL":"Street Address","RA_TYPE_SELECTION_DEFAULT":true,"RA_DEFAULT_TYPE":"460","RA_OVERRIDE_TYPE_WITH_DEFAULT":true,"RA_PRINCIPAL_ADDRESS_AMS":true,"UPLOAD_AND_SUBMIT_HIDE_IF_ONE_OPTION":true,"PAYMENT_PROCESSING_MESSAGE":"Your payment is processing - Do not close your browser or click the back button","CHECKOUT_BUTTON_WHEN_PROCESSING_TEXT":"Processing","EFS_CROP_PICKER_NONE_LABEL":"Lien Duration","DISALLOWED_WIZARD_PIECES":["FormationLocale"],"REPEATER_SHOW_EDIT_BUTTON":true,"DATA_REQUEST_PAGE_TITLE":"Data Requests and Subscriptions","DATA_REQUEST_SIDEBAR_LABEL":"Data Requests & Subscriptions","LOGIN_REDIRECTS_TO_EPASS":false,"LOGIN_REDIRECTS_TO_ACTIVE_DIRECTORY":true,"LOGIN_ACTIVE_DIRECTORY_LINK":true,"FETCH_EDIT_USER_LINK":false,"LISTS_FETCH_AVAILABLE_LISTS":true,"POST_WIZARD_SUBMIT_REDIRECT_URL":"/","PIN_REQUEST_ATTESTATIONS":true,"PIN_REQUEST_DESCRIPTION":"Click **Request PIN** to have a new PIN sent to the account holder's email address on file.","OWNERSHIP_REQUEST_DESCRIPTION":"To become an **authorized user** of this record, a current **AUTHORIZED USER** will need to grant you access. To request access, click **Request Access** below.","PIN_REQUEST_SUCCESS_MESSAGE":"The PIN you have requested for this entity has been sent to the email associated with your user account.  You should receive the PIN in approximately 3-5 minutes, depending on your email service provider.","APOSTILLE_HEADER_LABEL":"Verification Information","APOSTILLE_NUMBER_LABEL":"Apostille/Authentication","APOSTILLE_CITY_STATE_OVERRIDE":"HELENA, MT","APOSTILLE_FILING_DATE_LABEL":"Issue Date","APOSTILLE_CITY_STATE_IN_CERTIFIED":true,"NOTARY_EXISTING_FILING":true,"ALLOW_REVOKE_OWN_ACCESS_ONLY":false,"HIDE_CANCEL_ON_ONETIME_DATA_REQUESTS":true,"DATA_REQUESTS_IN_SHOPPING_CART":true,"WQ_ALLOW_EDIT_PENDING_PAYMENT":true,"WQ_CONFIRM_ON_DELETE":true,"WQ_DELETE_CONFIRM_MESSAGE":"Deleting this filing will forfeit any money already paid to the Secretary of State. This action is permanent and cannot be undone, are you sure you would like to delete?","PASS_ITEM_GUIDS_ON_CHECKOUT":true,"FORM_REVISION_HISTORY":true,"CHECKOUT_DISCLAIMER":"By entering your credit card and/or checking account information you (i) state that **you are an authorized user** of the credit card and/or electronic check and that the associated information entered (e.g., account holder name, account number, billing address) is accurate, (ii) **you authorize payment processor to charge the amount you have requested** to your credit card and/or funding account, and (iii) **acknowledge if a charge is declined or reversed you may also be assessed a customary charge** by the payment processor for such transactions.","FARM_BILL_SEARCH_CONFIDENTIAL":"As a registered Farm Bill Buyer with the Montana Secretary of State’s office it is important to maintain the confidentiality of the information contained within the Farm Bill Master List. The Farm Bill Master List reflects personal data, such as Social Security Numbers, which are a key piece of personal identifiable information to assist you in determining the existence of a lien against a specific debtor. The distribution of this information beyond its intended purpose is strictly prohibited.\n\n**The debtor's tax identification number has been hidden for confidentiality reasons. You may continue to search on a tax ID number and return debtors that match your search criteria. The SSN/FEIN must be entered without dashes or spaces.  If you need access to the tax identification number to clearly identify the debtor, please contact the UCC unit at (406) 444-3665.**","VIEW_HISTORY_BUTTON_ALT_TEXT":"View Filings","WIZARD_ERROR_TITLE_MESSAGE":"Form Error","FARM_BILL_SEARCH_INTERACTIVE":true,"USE_FARM_BILL_API":true,"DISALLOW_ASSIGN_SELF_AS_RA":true,"DISALLOW_ASSIGN_SELF_AS_PRINCIPAL":true,"USE_TRADEMARK_OWNER_VALIDATION":true,"USE_ALTERNATIVE_FOREIGN_ADDRESS_LABELS":true,"MY_RECEIPTS_FILTER":[{"type":"dateRange","name":"DATE_RANGE","label":"Date range","defaultValue":{"start":null,"end":null}},{"type":"text","name":"REF_NUM","defaultValue":"","label":"Reference Number"},{"type":"text","name":"RECEIPT_NUM","defaultValue":"","label":"Receipt Id"},{"type":"text","name":"AMOUNT","defaultValue":"","label":"Amount"},{"type":"select","name":"TYPE","defaultValue":"","label":"Payment Type","options":[{"value":"","label":"All"},{"value":"CC","label":"Credit Card"},{"value":"Check","label":"Check"}]}],"MY_RECEIPTS_SHOW_IN_SIDEBAR":true,"SHOW_MY_RECEIPTS_HELPER_TEXT":true,"MY_RECEIPTS_HELPER_LABEL":"About Receipt Search","MY_RECEIPTS_HELPER_TEXT":"You can search for receipts based on their descriptions, including the items paid for on the receipt. Use the filters to search for or filter specific information.","FARM_BILL_SUBLINK":{"label":"Farm Bill","component":"FarmBill","parameter":"farm-bill","path":"/lists/farm-bill","sourceTypeId":0,"myRecordsSearch":false,"allowedRules":["/search/"],"disabled":true,"searchDescription":"To perform a search, enter a debtor name. Your search results may include: exact debtor name, variations of that name and any filing that includes your search criteria. Punctuation is ignored.\n\nYou can click on \"Advanced\" to refine your search. Under “Advanced” you can search by crop, year, county and SSN/FEIN. As a registered Farm Bill Buyer with the Montana Secretary of State’s office it is important to maintain the confidentiality of the information contained within the Farm Bill Master List. The Farm Bill Master List reflects personal data, such as Social Security Numbers, which are a key piece of personal identifiable information to assist you in determining the existence of a lien against a specific debtor. The distribution of this information beyond its intended purpose is strictly prohibited.\n\nThe debtor's tax identification number has been hidden for confidentiality reasons. You may continue to search on a tax ID number and return debtors that match your search criteria. The SSN/FEIN must be entered without dashes or spaces.","searchMustHaveOneOf":["search","UCC_FARM_PRODUCT_ID","COUNTY"],"searchPlaceholder":"Search by debtor name","advancedSearchParameters":[{"type":"ServerMultiComplete","label":"Product code name(s)","name":"UCC_FARM_PRODUCT_ID","defaultValue":"","optionsSrc":"UCC_FARM_PRODUCT_V"},{"type":"MultiComplete","label":"Year or Range of Years","name":"YEAR_NUM","optionsSrc":"years","startYear":"1968","defaultValue":[],"preMergeOptions":[{"value":"ALL","label":"All"}]},{"type":"serverSelect","label":"State","name":"STATE","defaultValue":"MONTANA","optionsSrc":"STATE"},{"type":"ServerMultiComplete","label":"County","name":"COUNTY","defaultValue":[],"optionsSrc":"COUNTY","overrideSubOptionsSrcFromParameterName":"STATE"},{"type":"checkbox","name":"TIN_SEARCH_YN","defaultValue":false,"label":"Tax Identification Number Search"},{"type":"checkbox","name":"TIN_SORT_YN","defaultValue":false,"label":"Unique ID Sort"}]},"ALLOW_ADDRESS_VALIDATION_BYPASS_OPTION":true,"DEFAULT_ADDRESS_VALIDATION_BYPASS_OPTION_CHECKED":true}).PIN_NOT_LOGGED_IN_DESCRIPTION;
	
	var PinsPage = function (_React$Component) {
	  _inherits(PinsPage, _React$Component);
	
	  function PinsPage() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, PinsPage);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = PinsPage.__proto__ || Object.getPrototypeOf(PinsPage)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      pinCorrect: null,
	      loading: false,
	      currentPin: null,
	      errorMessage: null,
	      successMessage: null,
	      sourceTypeId: null
	    }, _this.checkPin = function (pin) {
	      _this.setState({ loading: true, pinCorrect: null, errorMessage: null, successMessage: null });
	      (0, _requests.GET_WEB_USER_ACCESS_WITH_GENERIC_PIN)(pin, function (pinObject) {
	        _this.setState({ loading: false, pinCorrect: true, currentPin: pin, successMessage: pinObject.successMessage, sourceTypeId: pinObject.sourceTypeId });
	      }, function (err) {
	        _this.setState({ pinCorrect: false, errorMessage: err.message, loading: false });
	      });
	    }, _this.getParameter = function () {
	      var parameter = (_utilities.SUBROUTES.find(function (l) {
	        return l.sourceTypeId === _this.state.sourceTypeId;
	      }) || {}).parameter;
	      return parameter ? '/' + parameter : '';
	    }, _this.restart = function () {
	      _this.setState({ pinCorrect: null, currentPin: null, errorMessage: null, sourceTypeId: null });
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(PinsPage, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          loggedIn = _props.loggedIn,
	          location = _props.location;
	
	      return _react2.default.createElement(
	        _Shell.Body,
	        { className: 'pins-page' },
	        _react2.default.createElement(
	          _FormCard2.default,
	          {
	            title: !loggedIn ? 'Enter PIN' : this.state.pinCorrect ? 'PIN Accepted' : 'Enter PIN',
	            seal: true
	          },
	          loggedIn ? _react2.default.createElement(PinEntry, {
	            successMessage: this.state.successMessage,
	            checkPin: this.checkPin,
	            loading: this.state.loading,
	            pinCorrect: this.state.pinCorrect,
	            errorMessage: this.state.errorMessage,
	            getParameter: this.getParameter,
	            restart: this.restart
	          }) : _react2.default.createElement(NotLoggedInModal, { location: location })
	        )
	      );
	    }
	  }]);
	
	  return PinsPage;
	}(_react2.default.Component);
	
	exports.default = (0, _reactRedux.connect)(function (state) {
	  return {
	    loggedIn: state.auth.loggedIn
	  };
	})(PinsPage);
	
	
	var NotLoggedInModal = function NotLoggedInModal(_ref2) {
	  var location = _ref2.location;
	  return _react2.default.createElement(
	    'div',
	    { className: 'pins-body' },
	    _react2.default.createElement(_Markdown2.default, { source: PIN_NOT_LOGGED_IN_DESCRIPTION, className: 'markdown description' })
	  );
	};
	
	var PinEntry = function PinEntry(_ref3) {
	  var checkPin = _ref3.checkPin,
	      loading = _ref3.loading,
	      pinCorrect = _ref3.pinCorrect,
	      successMessage = _ref3.successMessage,
	      errorMessage = _ref3.errorMessage,
	      getParameter = _ref3.getParameter,
	      restart = _ref3.restart;
	  return _react2.default.createElement(
	    'div',
	    { className: 'pins-body' },
	    pinCorrect ? _react2.default.createElement(
	      'div',
	      { className: 'success-wrapper' },
	      successMessage ? _react2.default.createElement(
	        'p',
	        { className: 'text-success' },
	        successMessage
	      ) : _react2.default.createElement(
	        'p',
	        { className: 'text-success' },
	        'Your PIN has been accepted. Click ',
	        _react2.default.createElement(
	          'strong',
	          null,
	          'Continue'
	        ),
	        ' to proceed to My Records to complete filings and update information online for your record, or click ',
	        _react2.default.createElement(
	          'strong',
	          null,
	          'Enter Another PIN'
	        ),
	        ' if you have additional PINs to enter.'
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'continue-wrapper' },
	        _react2.default.createElement(
	          _reactRouterDom.Link,
	          { className: 'btn btn-raised', to: '/records' + getParameter() },
	          'Continue'
	        ),
	        _react2.default.createElement(
	          'button',
	          { className: 'btn btn-raised', onClick: restart },
	          'Enter Another PIN'
	        )
	      )
	    ) : _react2.default.createElement(
	      _react2.default.Fragment,
	      null,
	      _react2.default.createElement(_Markdown2.default, { source: PIN_GENERIC_DESCRIPTION, className: 'markdown description enter-pin-description' }),
	      _react2.default.createElement(_Pins.PinInputSection, {
	        onCheckPinRequest: function onCheckPinRequest(_ref4) {
	          var value = _ref4.value;
	          return checkPin(value);
	        },
	        sendValue: true,
	        submitDisabled: loading,
	        error: pinCorrect === false ? _react2.default.createElement(_Markdown2.default, {
	          source: errorMessage || ({"NODE_ENV":"production","BUILD_DATE":"2025-08-27T15:15:31.687Z","BUILD_NUMBER":"Not Provided","GIT_VERSION":"v1.3.0-381-ga81e29b08","GIT_COMMIT_HASH":"a81e29b085c9268ffd96c78eb734365802722741","GIT_BRANCH":"beta","PUBLIC_URL":"","STATE_ABBR":"MT","STATE_NAME":"Montana","STATE_ORG_TITLE":"Secretary of State","LOGIN_HEADER_IMG_PATH":"","HOME_IMG_FILENAME":"montana.jpg","FAVICON_FILE_NAME":"favicon.ico","ALLOW_E_SIGN_ON_CORRECTIONS":true,"THIRD_PARTY_SIGNING_ALLOWED":false,"MY_ACCOUNT_SAVE_AND_CLOSE_BUTTON":true,"IE_DEPRECATED_MESSAGE":"Internet Explorer is not supported. Please select a supported browser below to access this website.","ADDITIONAL_ROUTES":{"dataRequests":true,"farmBill":true,"apostille":true,"externalHelp":"https://sosmt.gov/business/help-center/","systemAdministration":[{"title":"Saved Payments","parameter":"saved-payments","componentName":"SavedPayments"}]},"SUBROUTES":[{"label":"Business","component":"Business","parameter":"business","myWorkQueueSearch":false,"sourceTypeId":54,"searchMustHaveOneOf":["FILING_TYPE_ID","STATUS_ID","STATE","search"],"serverWebSearchDescription":true,"serverWorkQueueDescription":true,"serverMyRecordsDescription":true,"searchPlaceholder":"Search by name or filing number (X########)","allowEmptySearchTerm":true,"requestCertificateAlternateLabel":"Request Information","fileAmendmentButtonLabel":"Filing Actions","advancedSearchParameters":[{"type":"radio","name":"QUERY_TYPE_ID","defaultValue":1010,"options":[{"value":1010,"label":"Starts with"},{"value":1011,"label":"Contains"},{"value":1012,"label":" Word Contains"}]},{"type":"serverSelect","name":"FILING_TYPE_ID","optionsSrc":"FILING_TYPES","label":"Entity Type","placeholder":"All","defaultValue":"0"},{"type":"serverSelect","name":"FILING_SUBTYPE_ID","optionsSrc":"FILING_SUBTYPES","label":"Entity Subtype","overrideSubOptionsSrcFromParameterName":"FILING_TYPE_ID","placeholder":"All","defaultValue":"0"},{"type":"serverSelect","name":"STATUS_ID","optionsSrc":"FILING_STATUS_WITHOUT_ALL","label":"Status","placeholder":"All","defaultValue":"0"},{"type":"serverSelect","name":"STATE","optionsSrc":"STATE","label":"State","placeholder":"All","defaultValue":""},{"type":"serverSelect","name":"COUNTY","optionsSrc":"COUNTY_SUBOPTION","label":"County","overrideSubOptionsSrcFromParameterName":"STATE","placeholder":"All","defaultValue":""},{"type":"checkbox","name":"CRA_SEARCH_YN","defaultValue":false,"label":"Search by Registered Agent PID"},{"type":"dateRange","name":"FILING_DATE","label":"Registration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}},{"type":"dateRange","name":"EXPIRATION_DATE","label":"Expiration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}}],"myRecordsFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Active"},{"value":2,"label":"Inactive"},{"value":3,"label":"Pending"}]},{"type":"dateRange","name":"DATE_RANGE","label":"Date range","defaultValue":{"start":null,"end":null}}],"myWorkQueueFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Approved"},{"value":2,"label":"Pending Online Payment"},{"value":3,"label":"Pending Review"},{"value":4,"label":"Needs Correction"},{"value":5,"label":"Rejected"},{"value":6,"label":"Draft"}]},{"type":"dateRange","name":"DATE_RANGE","label":"Date range","defaultValue":{"start":null,"end":null}}]},{"label":"Notary","component":"Notary","parameter":"notary","sourceTypeId":850,"myWorkQueueSearch":false,"allowEmptySearchTerm":true,"requestCertificateAlternateLabel":"Download Certificate","fileAmendmentButtonLabel":"Filing Actions","hideNameRequestCertificate":true,"hideAddressRequestCertificate":true,"hideRecordUserManagment":true,"searchPlaceholder":"Search by name or commission number","searchMustHaveOneOf":["CITY","search","SERVICE_TYPE"],"advancedParametersStartOpen":true,"searchIsSortable":true,"advancedSearchParameters":[{"type":"radio","name":"STARTS_WITH_YN","defaultValue":false,"options":[{"value":true,"label":"Starts with"},{"value":false,"label":"Contains"}]},{"type":"checkbox","name":"ACTIVE_ONLY_YN","defaultValue":true,"label":"Active entities only"},{"type":"text","name":"CITY","defaultValue":"","label":"City"},{"type":"select","name":"SERVICE_TYPE","label":"Special Services Offered","defaultValue":0,"options":[{"value":0,"label":"(N/A)"},{"value":6165,"label":"In-Person Electronic Notarization (IPEN)"},{"value":6166,"label":"Remote Online Notarization (RON)"},{"value":6167,"label":"Mobile Notary Services"},{"value":6168,"label":"Remote Ink Notarization (RIN)"}]}]},{"label":"Apostille","component":"Apostille","parameter":"apostille","sourceTypeId":720,"myRecordsSearch":false,"myWorkQueueSearch":false,"disabled":false,"allowedRoutes":["/forms-manager/","/queue/","/forms/"]},{"label":"Liens","component":"UCC","parameter":"ucc","sourceTypeId":1999,"myRecordsSearch":true,"myWorkQueueSearch":true,"fileAmendmentButtonLabel":"Filing Actions","searchPlaceholder":"Search by name or file number","disabled":false,"serverWebSearchDescription":true,"myRecordsDescription":"","workQueueDescription":"","searchDescription":"","hideRecordUserManagment":true,"searchLiensCheckout":false,"advancedSearchParameters":[{"type":"radio","name":"STARTS_WITH_YN","defaultValue":false,"options":[{"value":true,"label":"Starts with"},{"value":false,"label":"Contains"}]},{"type":"select","name":"STATUS","defaultValue":"ALL","label":"Status","options":[{"value":"ACTIVE_UNLAPSED","label":"Active (unlapsed)"},{"value":"ACTIVE_LAPSED_UNLAPSED","label":"Active (lapsed and unlapsed)"}]},{"type":"text","name":"EXCLUDE_VALUES","label":"Exclude Debtor Names (comma separated list of names to exclude)","defaultValue":""},{"type":"dateRange","name":"FILING_DATE","label":"Financing Statement Date","defaultValue":{"start":null,"end":null}},{"type":"dateRange","name":"LAPSE_DATE","label":"Lapse Date","defaultValue":{"start":null,"end":null}},{"type":"text","name":"CITY","label":"Debtor City","defaultValue":""}],"myRecordsFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Approved"},{"value":2,"label":"Pending Online Payment"},{"value":3,"label":"Pending Review"}]},{"type":"select","name":"TYPE","defaultValue":0,"label":"Lien Type","options":[{"value":0,"label":"All"},{"value":1,"label":"UCC"},{"value":2,"label":"EFS"},{"value":3,"label":"Title 71"}]}],"myWorkQueueFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Approved"},{"value":2,"label":"Pending Online Payment"},{"value":3,"label":"Pending Review"},{"value":4,"label":"Pending Print and Mail"},{"value":5,"label":"Rejected"},{"value":6,"label":"Draft"}]},{"type":"select","name":"TYPE","defaultValue":0,"label":"Lien Type","options":[{"value":0,"label":"All"},{"value":1,"label":"UCC"},{"value":2,"label":"EFS"},{"value":3,"label":"Title 71"}]}]},{"label":"Copy Request","component":"copies","parameter":"copies","sourceTypeId":2001,"myRecordsSearch":false,"myWorkQueueSearch":false,"disabled":false,"allowedRoutes":["/forms-manager/","/queue/","/forms/"]},{"label":"Trademark","component":"Trademark","parameter":"trademark","sourceTypeId":810,"showRequestCertificate":true,"searchMustHaveOneOf":["search","EXPIRATION_DATE","FILING_DATE"],"allowEmptySearchTerm":true,"requestCertificateAlternateLabel":"Request Information","fileAmendmentButtonLabel":"Filing Actions","advancedSearchParameters":[{"type":"radio","name":"QUERY_TYPE_ID","defaultValue":1010,"options":[{"value":1010,"label":"Starts with"},{"value":1011,"label":"Contains"},{"value":1012,"label":" Word Contains"}]},{"type":"checkbox","name":"OWNER_SEARCH_YN","defaultValue":false,"label":"Search owners"},{"type":"radio","name":"SERVICE_MARK_YN","label":"Mark Type","defaultValue":"","options":[{"value":"","label":"All Marks"},{"value":"Y","label":"Service Mark"},{"value":"N","label":"Trademark"}]},{"type":"serverSelect","name":"STATUS_ID","optionsSrc":"TYPE_V|TRADEMARK_STATUS_TYPE","label":"Status","placeholder":"All","defaultValue":"0"},{"type":"select","name":"DESIGN_TYPE_ID","options":[{"value":0,"label":"All"},{"value":990,"label":"Words Only"},{"value":991,"label":"Design Only"},{"value":992,"label":"Words and Design"}],"label":"Design Type","defaultValue":"0"},{"type":"dateRange","name":"FILING_DATE","label":"Registered Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}},{"type":"dateRange","name":"EXPIRATION_DATE","label":"Expiration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}}]},{"label":"Business Info Request","component":"InfoRequests","parameter":"info-request","sourceTypeId":167,"allowedRoutes":["/forms-manager/","/queue/","/forms/"]},{"label":"Data Requests","component":"DataRequests","parameter":"data-request","sourceTypeId":0,"allowedRoutes":["/forms-manager/"]},{"label":"CRA","component":"CRA","parameter":"cra","sourceTypeId":157,"myRecordsSearch":false,"searchPlaceholder":"Search by name or registered agent number","allowedRoutes":["/forms-manager/","/forms/","/records/","/queue/","/search/"],"allowEmptySearchTerm":true,"fileAmendmentButtonLabel":"Filing Actions","advancedSearchParameters":[{"type":"radio","name":"QUERY_TYPE_ID","defaultValue":1010,"options":[{"value":1010,"label":"Starts with"},{"value":1011,"label":"Contains"},{"value":1012,"label":" Word Contains"}]},{"type":"dateRange","name":"CRA_DATE","label":"Registration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}},{"type":"select","name":"STATUS_ID","label":"Status","defaultValue":0,"options":[{"value":0,"label":"All"},{"value":121,"label":"Active"},{"value":122,"label":"Inactive"}]},{"type":"select","name":"AGENT_TYPE_ID","label":"Agent Type","defaultValue":0,"options":[{"value":0,"label":"All"},{"value":460,"label":"Registered Agent"},{"value":461,"label":"Commercial Registered Agent"}]}]},{"label":"Farm Bill","component":"FarmBill","parameter":"farm-bill","path":"/lists/farm-bill","sourceTypeId":0,"myRecordsSearch":false,"allowedRules":["/search/"],"disabled":true,"searchDescription":"To perform a search, enter a debtor name. Your search results may include: exact debtor name, variations of that name and any filing that includes your search criteria. Punctuation is ignored.\n\nYou can click on \"Advanced\" to refine your search. Under “Advanced” you can search by crop, year, county and SSN/FEIN. As a registered Farm Bill Buyer with the Montana Secretary of State’s office it is important to maintain the confidentiality of the information contained within the Farm Bill Master List. The Farm Bill Master List reflects personal data, such as Social Security Numbers, which are a key piece of personal identifiable information to assist you in determining the existence of a lien against a specific debtor. The distribution of this information beyond its intended purpose is strictly prohibited.\n\nThe debtor's tax identification number has been hidden for confidentiality reasons. You may continue to search on a tax ID number and return debtors that match your search criteria. The SSN/FEIN must be entered without dashes or spaces.","searchMustHaveOneOf":["search","UCC_FARM_PRODUCT_ID","COUNTY"],"searchPlaceholder":"Search by debtor name","advancedSearchParameters":[{"type":"ServerMultiComplete","label":"Product code name(s)","name":"UCC_FARM_PRODUCT_ID","defaultValue":"","optionsSrc":"UCC_FARM_PRODUCT_V"},{"type":"MultiComplete","label":"Year or Range of Years","name":"YEAR_NUM","optionsSrc":"years","startYear":"1968","defaultValue":[],"preMergeOptions":[{"value":"ALL","label":"All"}]},{"type":"serverSelect","label":"State","name":"STATE","defaultValue":"MONTANA","optionsSrc":"STATE"},{"type":"ServerMultiComplete","label":"County","name":"COUNTY","defaultValue":[],"optionsSrc":"COUNTY","overrideSubOptionsSrcFromParameterName":"STATE"},{"type":"checkbox","name":"TIN_SEARCH_YN","defaultValue":false,"label":"Tax Identification Number Search"},{"type":"checkbox","name":"TIN_SORT_YN","defaultValue":false,"label":"Unique ID Sort"}]}],"SYSTEM_NICKNAME":"Online Services Portal","PAYMENT_METHODS":[{"type":"bypass"},{"type":"iTransact"}],"PAYMENT_ALLOW_AMEX":true,"SYSTEM_ID_LABEL":"System Id","DOUBLE_COLUMN_PUBLIC_LOGIN":true,"INTERNAL_USER_MANAGEMENT":true,"ALLOW_PUBLIC_JSON_IMPORT":false,"MAX_FILE_UPLOAD_SIZE":10000000,"REFUND_TEXT":"","RETURN_TO_HOME_ON_LOGOUT":true,"CURRENT_SOS_NAME":"Christi Jacobsen","LOGO_FILENAME":"mt-sos-logo.png","LOGO_ALT":"Christi Jacobsen, Montana Secretary of State","LOGO_FULL_WIDTH":true,"HOME_HIDE_AUTH_HINT":true,"HOME_TITLE":"Montana Secretary of State","CUSTOM_TAB_TITLE":"Official Montana","HOME_SUBTITLE":"Online Business Services","ENTITY_NAME_CONSENT_DESCRIPTION":"","ALLOW_USER_PROFILE_EDITING":true,"COMPARE_FOREIGN_NAME_IN_ENTITY_NAME_VALIDATION":true,"FOREIGN_NAME_FIELD_NAME":"KIMA_PARENT_NAME_INFO","LOGIN_TITLE":"Montana Secretary of State Online Filing Portal Login","PUBLIC_LOGIN_LABEL":"Username","REVERSE_LOGIN_COLUMNS":true,"LOGIN_SEAL_FILENAME":"seal_white.png","SEPARATE_USERNAME_AND_EMAIL":true,"CREATE_ACCOUNT_BUTTON_ALIGN_LEFT":true,"CREATE_ACCOUNT_BUTTON_TEXT":"CREATE AN ACCOUNT","PASSWORD_CUSTOM_ERROR_TEXT":"The password must meet all requirements","ACCOUNT_CREATED_MESSAGE":"Please check your email to verify your account to login and allow a few minutes for this message to arrive. Check your junk/spam folders if you do not find the email in your inbox.","PUBLIC_LOGIN_PLACEHOLDER":" ","DISABLE_DEFAULT_PAYMENT_RADIO":true,"CUSTOM_RESET_PASSWORD_ERROR_MESSAGE":"Username invalid - no account found","PUBLIC_LOGIN_CREATE_DESCRIPTION":"### Existing User:\n\n  - Enter your username and password to login.  \n\n\n  #### - OR -  \n\n\n\n  - Forgot password? Click 'Reset Password' and follow the prompts.\n  - Forgot username? Click 'Forgot Username' and follow the prompts.  \n\n\n  ### New User:\n  ","LOGIN_HELP_LINK":"https://sosmt.gov/business/how-do-i/","LOGIN_HELP_LINK_TEXT":"Need Help?","FORGOT_USERNAME_TEXT":"Forgot Username?","LOGIN_ACTIVE_DIRECTORY_TEXT":"State User Login","MULTIPLE_LOGIN_METHODS":true,"HAS_ACTIVE_DIRECTORY_LOGIN":true,"RESET_PASSWORD_WITH_USERNAME":true,"DOWNLOAD_LINK":true,"SHOW_USERNAME_ACCOUNT_CREATE":true,"SHOW_SCROLL_DOWN_ARROW":true,"SHOW_ADDRESS_ACCOUNT_CREATE":true,"TWO_COLUMN_ACCOUNT_CREATE":true,"RESET_PASSWORD_TIP":"A link to change your password has been sent to your email. Please allow a few minutes for this message to arrive. Please check your junk/spam folders if you do not find the email in your inbox.","FORGOT_PASSWORD_LINK_TEXT":"Reset Password","PHONE_NUMBER_OPTIONAL_ACCOUNT_CREATE":true,"SHOW_REQUIRED_INDICATOR_ACCOUNT_CREATE":true,"PASSWORD_REQUIREMENTS_ACCOUNT_CREATE":"\n    <ul>\n      <li>MUST contain at least 8 characters (12+ recommended)</li>\n      <li>MUST contain at least one uppercase letter.</li>\n      <li>MUST contain at least one lowercase letter.</li>\n      <li>MUST contain at least one number.</li>\n      <li>MUST contain at least one special character (!”#$%&'()*+,-./:;<=>?</li>\n    </ul>\n  ","ALLOW_CERTIFICATION_REQUEST":true,"ALLOW_PUBLIC_CERTIFICATE_REQUEST":true,"ALLOW_COPY_REQUEST":false,"ALLOW_CORRECTION_STYLING":true,"HIDE_DEPRECATION_WARNING":false,"AMEND_ROUTE_PUBLIC":true,"SEAL_FILENAME":"seal.png","SHOPPING_CART":true,"ALLOW_PAYMENT_UPDATE_WITH_EMPTY_CART":true,"RA_EMAIL":true,"RA_WEBSITE":true,"RA_NO_DEFAULT_TYPE":true,"RA_ADDRESS_LABEL":"Street Address","RA_TYPE_SELECTION_DEFAULT":true,"RA_DEFAULT_TYPE":"460","RA_OVERRIDE_TYPE_WITH_DEFAULT":true,"RA_PRINCIPAL_ADDRESS_AMS":true,"UPLOAD_AND_SUBMIT_HIDE_IF_ONE_OPTION":true,"PAYMENT_PROCESSING_MESSAGE":"Your payment is processing - Do not close your browser or click the back button","CHECKOUT_BUTTON_WHEN_PROCESSING_TEXT":"Processing","EFS_CROP_PICKER_NONE_LABEL":"Lien Duration","DISALLOWED_WIZARD_PIECES":["FormationLocale"],"REPEATER_SHOW_EDIT_BUTTON":true,"DATA_REQUEST_PAGE_TITLE":"Data Requests and Subscriptions","DATA_REQUEST_SIDEBAR_LABEL":"Data Requests & Subscriptions","LOGIN_REDIRECTS_TO_EPASS":false,"LOGIN_REDIRECTS_TO_ACTIVE_DIRECTORY":true,"LOGIN_ACTIVE_DIRECTORY_LINK":true,"FETCH_EDIT_USER_LINK":false,"LISTS_FETCH_AVAILABLE_LISTS":true,"POST_WIZARD_SUBMIT_REDIRECT_URL":"/","PIN_REQUEST_ATTESTATIONS":true,"PIN_REQUEST_DESCRIPTION":"Click **Request PIN** to have a new PIN sent to the account holder's email address on file.","OWNERSHIP_REQUEST_DESCRIPTION":"To become an **authorized user** of this record, a current **AUTHORIZED USER** will need to grant you access. To request access, click **Request Access** below.","PIN_REQUEST_SUCCESS_MESSAGE":"The PIN you have requested for this entity has been sent to the email associated with your user account.  You should receive the PIN in approximately 3-5 minutes, depending on your email service provider.","APOSTILLE_HEADER_LABEL":"Verification Information","APOSTILLE_NUMBER_LABEL":"Apostille/Authentication","APOSTILLE_CITY_STATE_OVERRIDE":"HELENA, MT","APOSTILLE_FILING_DATE_LABEL":"Issue Date","APOSTILLE_CITY_STATE_IN_CERTIFIED":true,"NOTARY_EXISTING_FILING":true,"ALLOW_REVOKE_OWN_ACCESS_ONLY":false,"HIDE_CANCEL_ON_ONETIME_DATA_REQUESTS":true,"DATA_REQUESTS_IN_SHOPPING_CART":true,"WQ_ALLOW_EDIT_PENDING_PAYMENT":true,"WQ_CONFIRM_ON_DELETE":true,"WQ_DELETE_CONFIRM_MESSAGE":"Deleting this filing will forfeit any money already paid to the Secretary of State. This action is permanent and cannot be undone, are you sure you would like to delete?","PASS_ITEM_GUIDS_ON_CHECKOUT":true,"FORM_REVISION_HISTORY":true,"CHECKOUT_DISCLAIMER":"By entering your credit card and/or checking account information you (i) state that **you are an authorized user** of the credit card and/or electronic check and that the associated information entered (e.g., account holder name, account number, billing address) is accurate, (ii) **you authorize payment processor to charge the amount you have requested** to your credit card and/or funding account, and (iii) **acknowledge if a charge is declined or reversed you may also be assessed a customary charge** by the payment processor for such transactions.","FARM_BILL_SEARCH_CONFIDENTIAL":"As a registered Farm Bill Buyer with the Montana Secretary of State’s office it is important to maintain the confidentiality of the information contained within the Farm Bill Master List. The Farm Bill Master List reflects personal data, such as Social Security Numbers, which are a key piece of personal identifiable information to assist you in determining the existence of a lien against a specific debtor. The distribution of this information beyond its intended purpose is strictly prohibited.\n\n**The debtor's tax identification number has been hidden for confidentiality reasons. You may continue to search on a tax ID number and return debtors that match your search criteria. The SSN/FEIN must be entered without dashes or spaces.  If you need access to the tax identification number to clearly identify the debtor, please contact the UCC unit at (406) 444-3665.**","VIEW_HISTORY_BUTTON_ALT_TEXT":"View Filings","WIZARD_ERROR_TITLE_MESSAGE":"Form Error","FARM_BILL_SEARCH_INTERACTIVE":true,"USE_FARM_BILL_API":true,"DISALLOW_ASSIGN_SELF_AS_RA":true,"DISALLOW_ASSIGN_SELF_AS_PRINCIPAL":true,"USE_TRADEMARK_OWNER_VALIDATION":true,"USE_ALTERNATIVE_FOREIGN_ADDRESS_LABELS":true,"MY_RECEIPTS_FILTER":[{"type":"dateRange","name":"DATE_RANGE","label":"Date range","defaultValue":{"start":null,"end":null}},{"type":"text","name":"REF_NUM","defaultValue":"","label":"Reference Number"},{"type":"text","name":"RECEIPT_NUM","defaultValue":"","label":"Receipt Id"},{"type":"text","name":"AMOUNT","defaultValue":"","label":"Amount"},{"type":"select","name":"TYPE","defaultValue":"","label":"Payment Type","options":[{"value":"","label":"All"},{"value":"CC","label":"Credit Card"},{"value":"Check","label":"Check"}]}],"MY_RECEIPTS_SHOW_IN_SIDEBAR":true,"SHOW_MY_RECEIPTS_HELPER_TEXT":true,"MY_RECEIPTS_HELPER_LABEL":"About Receipt Search","MY_RECEIPTS_HELPER_TEXT":"You can search for receipts based on their descriptions, including the items paid for on the receipt. Use the filters to search for or filter specific information.","FARM_BILL_SUBLINK":{"label":"Farm Bill","component":"FarmBill","parameter":"farm-bill","path":"/lists/farm-bill","sourceTypeId":0,"myRecordsSearch":false,"allowedRules":["/search/"],"disabled":true,"searchDescription":"To perform a search, enter a debtor name. Your search results may include: exact debtor name, variations of that name and any filing that includes your search criteria. Punctuation is ignored.\n\nYou can click on \"Advanced\" to refine your search. Under “Advanced” you can search by crop, year, county and SSN/FEIN. As a registered Farm Bill Buyer with the Montana Secretary of State’s office it is important to maintain the confidentiality of the information contained within the Farm Bill Master List. The Farm Bill Master List reflects personal data, such as Social Security Numbers, which are a key piece of personal identifiable information to assist you in determining the existence of a lien against a specific debtor. The distribution of this information beyond its intended purpose is strictly prohibited.\n\nThe debtor's tax identification number has been hidden for confidentiality reasons. You may continue to search on a tax ID number and return debtors that match your search criteria. The SSN/FEIN must be entered without dashes or spaces.","searchMustHaveOneOf":["search","UCC_FARM_PRODUCT_ID","COUNTY"],"searchPlaceholder":"Search by debtor name","advancedSearchParameters":[{"type":"ServerMultiComplete","label":"Product code name(s)","name":"UCC_FARM_PRODUCT_ID","defaultValue":"","optionsSrc":"UCC_FARM_PRODUCT_V"},{"type":"MultiComplete","label":"Year or Range of Years","name":"YEAR_NUM","optionsSrc":"years","startYear":"1968","defaultValue":[],"preMergeOptions":[{"value":"ALL","label":"All"}]},{"type":"serverSelect","label":"State","name":"STATE","defaultValue":"MONTANA","optionsSrc":"STATE"},{"type":"ServerMultiComplete","label":"County","name":"COUNTY","defaultValue":[],"optionsSrc":"COUNTY","overrideSubOptionsSrcFromParameterName":"STATE"},{"type":"checkbox","name":"TIN_SEARCH_YN","defaultValue":false,"label":"Tax Identification Number Search"},{"type":"checkbox","name":"TIN_SORT_YN","defaultValue":false,"label":"Unique ID Sort"}]},"ALLOW_ADDRESS_VALIDATION_BYPASS_OPTION":true,"DEFAULT_ADDRESS_VALIDATION_BYPASS_OPTION_CHECKED":true}).PIN_PAGE_ERROR || 'The pin you have entered is not valid.',
	          className: 'markdown'
	        }) : null
	      })
	    )
	  );
	};

/***/ },
/* 1119 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _requests = __webpack_require__(6);
	
	var _reactRouterDom = __webpack_require__(30);
	
	var _Markdown = __webpack_require__(24);
	
	var _Markdown2 = _interopRequireDefault(_Markdown);
	
	var _Loaders = __webpack_require__(16);
	
	var _ActionButton = __webpack_require__(194);
	
	var _ActionButton2 = _interopRequireDefault(_ActionButton);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ReinstatementLauncher = function (_React$Component) {
		_inherits(ReinstatementLauncher, _React$Component);
	
		function ReinstatementLauncher() {
			var _ref;
	
			var _temp, _this, _ret;
	
			_classCallCheck(this, ReinstatementLauncher);
	
			for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
				args[_key] = arguments[_key];
			}
	
			return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = ReinstatementLauncher.__proto__ || Object.getPrototypeOf(ReinstatementLauncher)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
				textLoading: true,
				reinstatementFormDefinitionId: null,
				annualReportFormDefinitionId: null,
				fIdLoading: true,
				arIdLoading: true,
				text: ""
			}, _this.componentDidMount = function () {
				if (_this.state.textLoading === true) {
					_this.getReinstatementText();
					if (_this.props.canFileReinstatement) {
						_this.GetReinstatementFormDefinitionId();
					} else {
						_this.setState({ fIdLoading: false });
					}
					if (_this.props.canFileAR) {
						_this.GetAnnualReportFormDefinitionId();
					} else {
						_this.setState({ arIdLoading: false });
					}
				}
			}, _this.getReinstatementText = function () {
				(0, _requests.GET_APP_SETTING_BY_NAME)('REINSTATEMENT_INSTRUCTIONS_PARAGRAPH', function (res) {
					_this.setState({
						textLoading: false,
						text: res.VALUE
					});
				});
			}, _this.GetReinstatementFormDefinitionId = function () {
				(0, _requests.GET_REINSTATEMENT_FORM_DEFINITION_ID)(_this.props.filingNum, function (formDefinitionId) {
					_this.setState({
						fIdLoading: false,
						reinstatementFormDefinitionId: formDefinitionId
					});
				}, function (err) {
					console.error(err);
				});
			}, _this.GetAnnualReportFormDefinitionId = function () {
				(0, _requests.GET_AR_FORM_DEFINITION_ID)(_this.props.filingNum, function (formDefinitionId) {
					_this.setState({
						arIdLoading: false,
						annualReportFormDefinitionId: formDefinitionId
					});
				}, function (err) {
					console.error(err);
				});
			}, _temp), _possibleConstructorReturn(_this, _ret);
		}
	
		_createClass(ReinstatementLauncher, [{
			key: 'render',
			value: function render() {
				var _state = this.state,
				    text = _state.text,
				    textLoading = _state.textLoading,
				    fIdLoading = _state.fIdLoading,
				    arIdLoading = _state.arIdLoading;
				var _props = this.props,
				    filingNum = _props.filingNum,
				    canFileAR = _props.canFileAR,
				    canFileReinstatement = _props.canFileReinstatement,
				    unavailableARMessage = _props.unavailableARMessage,
				    unavailableReinstatementMessage = _props.unavailableReinstatementMessage;
	
				return textLoading || fIdLoading || arIdLoading ? _react2.default.createElement(
					'div',
					{ className: 'reinstatement center' },
					_react2.default.createElement(_Loaders.Spinner, { themeColor: 'medium-neutral' })
				) : _react2.default.createElement(
					'div',
					{ className: 'reinstatement' },
					_react2.default.createElement(_Markdown2.default, { source: text, className: 'markdown instructions' }),
					_react2.default.createElement(
						_ActionButton.ActionButtonGroup,
						{ className: 'details-actions-bottom' },
						_react2.default.createElement(
							_reactRouterDom.Link,
							{ to: '/amend/' + this.state.annualReportFormDefinitionId + '/' + filingNum, className: canFileAR && !unavailableARMessage ? null : "disabled-link" },
							_react2.default.createElement(_ActionButton2.default, { label: 'File Annual Report', iconClass: 'icon icon-report', onClick: null })
						),
						_react2.default.createElement(
							_reactRouterDom.Link,
							{ to: '/amend/' + this.state.reinstatementFormDefinitionId + '/' + filingNum, className: canFileReinstatement && !unavailableReinstatementMessage ? null : "disabled-link" },
							_react2.default.createElement(_ActionButton2.default, { label: 'File Reinstatement', iconClass: 'icon icon-report', onClick: null })
						)
					)
				);
			}
		}]);
	
		return ReinstatementLauncher;
	}(_react2.default.Component);
	
	exports.default = ReinstatementLauncher;

/***/ },
/* 1120 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Modal = __webpack_require__(13);
	
	var _Loaders = __webpack_require__(16);
	
	var _Markdown = __webpack_require__(24);
	
	var _Markdown2 = _interopRequireDefault(_Markdown);
	
	var _requests = __webpack_require__(6);
	
	var _Form = __webpack_require__(14);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var OWNERSHIP_REQUEST_DESCRIPTION = ("To become an **authorized user** of this record, a current **AUTHORIZED USER** will need to grant you access. To request access, click **Request Access** below.");
	var OWNERSHIP_REQUEST_ATTESTATIONS = ({"NODE_ENV":"production","BUILD_DATE":"2025-08-27T15:15:31.687Z","BUILD_NUMBER":"Not Provided","GIT_VERSION":"v1.3.0-381-ga81e29b08","GIT_COMMIT_HASH":"a81e29b085c9268ffd96c78eb734365802722741","GIT_BRANCH":"beta","PUBLIC_URL":"","STATE_ABBR":"MT","STATE_NAME":"Montana","STATE_ORG_TITLE":"Secretary of State","LOGIN_HEADER_IMG_PATH":"","HOME_IMG_FILENAME":"montana.jpg","FAVICON_FILE_NAME":"favicon.ico","ALLOW_E_SIGN_ON_CORRECTIONS":true,"THIRD_PARTY_SIGNING_ALLOWED":false,"MY_ACCOUNT_SAVE_AND_CLOSE_BUTTON":true,"IE_DEPRECATED_MESSAGE":"Internet Explorer is not supported. Please select a supported browser below to access this website.","ADDITIONAL_ROUTES":{"dataRequests":true,"farmBill":true,"apostille":true,"externalHelp":"https://sosmt.gov/business/help-center/","systemAdministration":[{"title":"Saved Payments","parameter":"saved-payments","componentName":"SavedPayments"}]},"SUBROUTES":[{"label":"Business","component":"Business","parameter":"business","myWorkQueueSearch":false,"sourceTypeId":54,"searchMustHaveOneOf":["FILING_TYPE_ID","STATUS_ID","STATE","search"],"serverWebSearchDescription":true,"serverWorkQueueDescription":true,"serverMyRecordsDescription":true,"searchPlaceholder":"Search by name or filing number (X########)","allowEmptySearchTerm":true,"requestCertificateAlternateLabel":"Request Information","fileAmendmentButtonLabel":"Filing Actions","advancedSearchParameters":[{"type":"radio","name":"QUERY_TYPE_ID","defaultValue":1010,"options":[{"value":1010,"label":"Starts with"},{"value":1011,"label":"Contains"},{"value":1012,"label":" Word Contains"}]},{"type":"serverSelect","name":"FILING_TYPE_ID","optionsSrc":"FILING_TYPES","label":"Entity Type","placeholder":"All","defaultValue":"0"},{"type":"serverSelect","name":"FILING_SUBTYPE_ID","optionsSrc":"FILING_SUBTYPES","label":"Entity Subtype","overrideSubOptionsSrcFromParameterName":"FILING_TYPE_ID","placeholder":"All","defaultValue":"0"},{"type":"serverSelect","name":"STATUS_ID","optionsSrc":"FILING_STATUS_WITHOUT_ALL","label":"Status","placeholder":"All","defaultValue":"0"},{"type":"serverSelect","name":"STATE","optionsSrc":"STATE","label":"State","placeholder":"All","defaultValue":""},{"type":"serverSelect","name":"COUNTY","optionsSrc":"COUNTY_SUBOPTION","label":"County","overrideSubOptionsSrcFromParameterName":"STATE","placeholder":"All","defaultValue":""},{"type":"checkbox","name":"CRA_SEARCH_YN","defaultValue":false,"label":"Search by Registered Agent PID"},{"type":"dateRange","name":"FILING_DATE","label":"Registration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}},{"type":"dateRange","name":"EXPIRATION_DATE","label":"Expiration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}}],"myRecordsFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Active"},{"value":2,"label":"Inactive"},{"value":3,"label":"Pending"}]},{"type":"dateRange","name":"DATE_RANGE","label":"Date range","defaultValue":{"start":null,"end":null}}],"myWorkQueueFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Approved"},{"value":2,"label":"Pending Online Payment"},{"value":3,"label":"Pending Review"},{"value":4,"label":"Needs Correction"},{"value":5,"label":"Rejected"},{"value":6,"label":"Draft"}]},{"type":"dateRange","name":"DATE_RANGE","label":"Date range","defaultValue":{"start":null,"end":null}}]},{"label":"Notary","component":"Notary","parameter":"notary","sourceTypeId":850,"myWorkQueueSearch":false,"allowEmptySearchTerm":true,"requestCertificateAlternateLabel":"Download Certificate","fileAmendmentButtonLabel":"Filing Actions","hideNameRequestCertificate":true,"hideAddressRequestCertificate":true,"hideRecordUserManagment":true,"searchPlaceholder":"Search by name or commission number","searchMustHaveOneOf":["CITY","search","SERVICE_TYPE"],"advancedParametersStartOpen":true,"searchIsSortable":true,"advancedSearchParameters":[{"type":"radio","name":"STARTS_WITH_YN","defaultValue":false,"options":[{"value":true,"label":"Starts with"},{"value":false,"label":"Contains"}]},{"type":"checkbox","name":"ACTIVE_ONLY_YN","defaultValue":true,"label":"Active entities only"},{"type":"text","name":"CITY","defaultValue":"","label":"City"},{"type":"select","name":"SERVICE_TYPE","label":"Special Services Offered","defaultValue":0,"options":[{"value":0,"label":"(N/A)"},{"value":6165,"label":"In-Person Electronic Notarization (IPEN)"},{"value":6166,"label":"Remote Online Notarization (RON)"},{"value":6167,"label":"Mobile Notary Services"},{"value":6168,"label":"Remote Ink Notarization (RIN)"}]}]},{"label":"Apostille","component":"Apostille","parameter":"apostille","sourceTypeId":720,"myRecordsSearch":false,"myWorkQueueSearch":false,"disabled":false,"allowedRoutes":["/forms-manager/","/queue/","/forms/"]},{"label":"Liens","component":"UCC","parameter":"ucc","sourceTypeId":1999,"myRecordsSearch":true,"myWorkQueueSearch":true,"fileAmendmentButtonLabel":"Filing Actions","searchPlaceholder":"Search by name or file number","disabled":false,"serverWebSearchDescription":true,"myRecordsDescription":"","workQueueDescription":"","searchDescription":"","hideRecordUserManagment":true,"searchLiensCheckout":false,"advancedSearchParameters":[{"type":"radio","name":"STARTS_WITH_YN","defaultValue":false,"options":[{"value":true,"label":"Starts with"},{"value":false,"label":"Contains"}]},{"type":"select","name":"STATUS","defaultValue":"ALL","label":"Status","options":[{"value":"ACTIVE_UNLAPSED","label":"Active (unlapsed)"},{"value":"ACTIVE_LAPSED_UNLAPSED","label":"Active (lapsed and unlapsed)"}]},{"type":"text","name":"EXCLUDE_VALUES","label":"Exclude Debtor Names (comma separated list of names to exclude)","defaultValue":""},{"type":"dateRange","name":"FILING_DATE","label":"Financing Statement Date","defaultValue":{"start":null,"end":null}},{"type":"dateRange","name":"LAPSE_DATE","label":"Lapse Date","defaultValue":{"start":null,"end":null}},{"type":"text","name":"CITY","label":"Debtor City","defaultValue":""}],"myRecordsFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Approved"},{"value":2,"label":"Pending Online Payment"},{"value":3,"label":"Pending Review"}]},{"type":"select","name":"TYPE","defaultValue":0,"label":"Lien Type","options":[{"value":0,"label":"All"},{"value":1,"label":"UCC"},{"value":2,"label":"EFS"},{"value":3,"label":"Title 71"}]}],"myWorkQueueFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Approved"},{"value":2,"label":"Pending Online Payment"},{"value":3,"label":"Pending Review"},{"value":4,"label":"Pending Print and Mail"},{"value":5,"label":"Rejected"},{"value":6,"label":"Draft"}]},{"type":"select","name":"TYPE","defaultValue":0,"label":"Lien Type","options":[{"value":0,"label":"All"},{"value":1,"label":"UCC"},{"value":2,"label":"EFS"},{"value":3,"label":"Title 71"}]}]},{"label":"Copy Request","component":"copies","parameter":"copies","sourceTypeId":2001,"myRecordsSearch":false,"myWorkQueueSearch":false,"disabled":false,"allowedRoutes":["/forms-manager/","/queue/","/forms/"]},{"label":"Trademark","component":"Trademark","parameter":"trademark","sourceTypeId":810,"showRequestCertificate":true,"searchMustHaveOneOf":["search","EXPIRATION_DATE","FILING_DATE"],"allowEmptySearchTerm":true,"requestCertificateAlternateLabel":"Request Information","fileAmendmentButtonLabel":"Filing Actions","advancedSearchParameters":[{"type":"radio","name":"QUERY_TYPE_ID","defaultValue":1010,"options":[{"value":1010,"label":"Starts with"},{"value":1011,"label":"Contains"},{"value":1012,"label":" Word Contains"}]},{"type":"checkbox","name":"OWNER_SEARCH_YN","defaultValue":false,"label":"Search owners"},{"type":"radio","name":"SERVICE_MARK_YN","label":"Mark Type","defaultValue":"","options":[{"value":"","label":"All Marks"},{"value":"Y","label":"Service Mark"},{"value":"N","label":"Trademark"}]},{"type":"serverSelect","name":"STATUS_ID","optionsSrc":"TYPE_V|TRADEMARK_STATUS_TYPE","label":"Status","placeholder":"All","defaultValue":"0"},{"type":"select","name":"DESIGN_TYPE_ID","options":[{"value":0,"label":"All"},{"value":990,"label":"Words Only"},{"value":991,"label":"Design Only"},{"value":992,"label":"Words and Design"}],"label":"Design Type","defaultValue":"0"},{"type":"dateRange","name":"FILING_DATE","label":"Registered Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}},{"type":"dateRange","name":"EXPIRATION_DATE","label":"Expiration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}}]},{"label":"Business Info Request","component":"InfoRequests","parameter":"info-request","sourceTypeId":167,"allowedRoutes":["/forms-manager/","/queue/","/forms/"]},{"label":"Data Requests","component":"DataRequests","parameter":"data-request","sourceTypeId":0,"allowedRoutes":["/forms-manager/"]},{"label":"CRA","component":"CRA","parameter":"cra","sourceTypeId":157,"myRecordsSearch":false,"searchPlaceholder":"Search by name or registered agent number","allowedRoutes":["/forms-manager/","/forms/","/records/","/queue/","/search/"],"allowEmptySearchTerm":true,"fileAmendmentButtonLabel":"Filing Actions","advancedSearchParameters":[{"type":"radio","name":"QUERY_TYPE_ID","defaultValue":1010,"options":[{"value":1010,"label":"Starts with"},{"value":1011,"label":"Contains"},{"value":1012,"label":" Word Contains"}]},{"type":"dateRange","name":"CRA_DATE","label":"Registration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}},{"type":"select","name":"STATUS_ID","label":"Status","defaultValue":0,"options":[{"value":0,"label":"All"},{"value":121,"label":"Active"},{"value":122,"label":"Inactive"}]},{"type":"select","name":"AGENT_TYPE_ID","label":"Agent Type","defaultValue":0,"options":[{"value":0,"label":"All"},{"value":460,"label":"Registered Agent"},{"value":461,"label":"Commercial Registered Agent"}]}]},{"label":"Farm Bill","component":"FarmBill","parameter":"farm-bill","path":"/lists/farm-bill","sourceTypeId":0,"myRecordsSearch":false,"allowedRules":["/search/"],"disabled":true,"searchDescription":"To perform a search, enter a debtor name. Your search results may include: exact debtor name, variations of that name and any filing that includes your search criteria. Punctuation is ignored.\n\nYou can click on \"Advanced\" to refine your search. Under “Advanced” you can search by crop, year, county and SSN/FEIN. As a registered Farm Bill Buyer with the Montana Secretary of State’s office it is important to maintain the confidentiality of the information contained within the Farm Bill Master List. The Farm Bill Master List reflects personal data, such as Social Security Numbers, which are a key piece of personal identifiable information to assist you in determining the existence of a lien against a specific debtor. The distribution of this information beyond its intended purpose is strictly prohibited.\n\nThe debtor's tax identification number has been hidden for confidentiality reasons. You may continue to search on a tax ID number and return debtors that match your search criteria. The SSN/FEIN must be entered without dashes or spaces.","searchMustHaveOneOf":["search","UCC_FARM_PRODUCT_ID","COUNTY"],"searchPlaceholder":"Search by debtor name","advancedSearchParameters":[{"type":"ServerMultiComplete","label":"Product code name(s)","name":"UCC_FARM_PRODUCT_ID","defaultValue":"","optionsSrc":"UCC_FARM_PRODUCT_V"},{"type":"MultiComplete","label":"Year or Range of Years","name":"YEAR_NUM","optionsSrc":"years","startYear":"1968","defaultValue":[],"preMergeOptions":[{"value":"ALL","label":"All"}]},{"type":"serverSelect","label":"State","name":"STATE","defaultValue":"MONTANA","optionsSrc":"STATE"},{"type":"ServerMultiComplete","label":"County","name":"COUNTY","defaultValue":[],"optionsSrc":"COUNTY","overrideSubOptionsSrcFromParameterName":"STATE"},{"type":"checkbox","name":"TIN_SEARCH_YN","defaultValue":false,"label":"Tax Identification Number Search"},{"type":"checkbox","name":"TIN_SORT_YN","defaultValue":false,"label":"Unique ID Sort"}]}],"SYSTEM_NICKNAME":"Online Services Portal","PAYMENT_METHODS":[{"type":"bypass"},{"type":"iTransact"}],"PAYMENT_ALLOW_AMEX":true,"SYSTEM_ID_LABEL":"System Id","DOUBLE_COLUMN_PUBLIC_LOGIN":true,"INTERNAL_USER_MANAGEMENT":true,"ALLOW_PUBLIC_JSON_IMPORT":false,"MAX_FILE_UPLOAD_SIZE":10000000,"REFUND_TEXT":"","RETURN_TO_HOME_ON_LOGOUT":true,"CURRENT_SOS_NAME":"Christi Jacobsen","LOGO_FILENAME":"mt-sos-logo.png","LOGO_ALT":"Christi Jacobsen, Montana Secretary of State","LOGO_FULL_WIDTH":true,"HOME_HIDE_AUTH_HINT":true,"HOME_TITLE":"Montana Secretary of State","CUSTOM_TAB_TITLE":"Official Montana","HOME_SUBTITLE":"Online Business Services","ENTITY_NAME_CONSENT_DESCRIPTION":"","ALLOW_USER_PROFILE_EDITING":true,"COMPARE_FOREIGN_NAME_IN_ENTITY_NAME_VALIDATION":true,"FOREIGN_NAME_FIELD_NAME":"KIMA_PARENT_NAME_INFO","LOGIN_TITLE":"Montana Secretary of State Online Filing Portal Login","PUBLIC_LOGIN_LABEL":"Username","REVERSE_LOGIN_COLUMNS":true,"LOGIN_SEAL_FILENAME":"seal_white.png","SEPARATE_USERNAME_AND_EMAIL":true,"CREATE_ACCOUNT_BUTTON_ALIGN_LEFT":true,"CREATE_ACCOUNT_BUTTON_TEXT":"CREATE AN ACCOUNT","PASSWORD_CUSTOM_ERROR_TEXT":"The password must meet all requirements","ACCOUNT_CREATED_MESSAGE":"Please check your email to verify your account to login and allow a few minutes for this message to arrive. Check your junk/spam folders if you do not find the email in your inbox.","PUBLIC_LOGIN_PLACEHOLDER":" ","DISABLE_DEFAULT_PAYMENT_RADIO":true,"CUSTOM_RESET_PASSWORD_ERROR_MESSAGE":"Username invalid - no account found","PUBLIC_LOGIN_CREATE_DESCRIPTION":"### Existing User:\n\n  - Enter your username and password to login.  \n\n\n  #### - OR -  \n\n\n\n  - Forgot password? Click 'Reset Password' and follow the prompts.\n  - Forgot username? Click 'Forgot Username' and follow the prompts.  \n\n\n  ### New User:\n  ","LOGIN_HELP_LINK":"https://sosmt.gov/business/how-do-i/","LOGIN_HELP_LINK_TEXT":"Need Help?","FORGOT_USERNAME_TEXT":"Forgot Username?","LOGIN_ACTIVE_DIRECTORY_TEXT":"State User Login","MULTIPLE_LOGIN_METHODS":true,"HAS_ACTIVE_DIRECTORY_LOGIN":true,"RESET_PASSWORD_WITH_USERNAME":true,"DOWNLOAD_LINK":true,"SHOW_USERNAME_ACCOUNT_CREATE":true,"SHOW_SCROLL_DOWN_ARROW":true,"SHOW_ADDRESS_ACCOUNT_CREATE":true,"TWO_COLUMN_ACCOUNT_CREATE":true,"RESET_PASSWORD_TIP":"A link to change your password has been sent to your email. Please allow a few minutes for this message to arrive. Please check your junk/spam folders if you do not find the email in your inbox.","FORGOT_PASSWORD_LINK_TEXT":"Reset Password","PHONE_NUMBER_OPTIONAL_ACCOUNT_CREATE":true,"SHOW_REQUIRED_INDICATOR_ACCOUNT_CREATE":true,"PASSWORD_REQUIREMENTS_ACCOUNT_CREATE":"\n    <ul>\n      <li>MUST contain at least 8 characters (12+ recommended)</li>\n      <li>MUST contain at least one uppercase letter.</li>\n      <li>MUST contain at least one lowercase letter.</li>\n      <li>MUST contain at least one number.</li>\n      <li>MUST contain at least one special character (!”#$%&'()*+,-./:;<=>?</li>\n    </ul>\n  ","ALLOW_CERTIFICATION_REQUEST":true,"ALLOW_PUBLIC_CERTIFICATE_REQUEST":true,"ALLOW_COPY_REQUEST":false,"ALLOW_CORRECTION_STYLING":true,"HIDE_DEPRECATION_WARNING":false,"AMEND_ROUTE_PUBLIC":true,"SEAL_FILENAME":"seal.png","SHOPPING_CART":true,"ALLOW_PAYMENT_UPDATE_WITH_EMPTY_CART":true,"RA_EMAIL":true,"RA_WEBSITE":true,"RA_NO_DEFAULT_TYPE":true,"RA_ADDRESS_LABEL":"Street Address","RA_TYPE_SELECTION_DEFAULT":true,"RA_DEFAULT_TYPE":"460","RA_OVERRIDE_TYPE_WITH_DEFAULT":true,"RA_PRINCIPAL_ADDRESS_AMS":true,"UPLOAD_AND_SUBMIT_HIDE_IF_ONE_OPTION":true,"PAYMENT_PROCESSING_MESSAGE":"Your payment is processing - Do not close your browser or click the back button","CHECKOUT_BUTTON_WHEN_PROCESSING_TEXT":"Processing","EFS_CROP_PICKER_NONE_LABEL":"Lien Duration","DISALLOWED_WIZARD_PIECES":["FormationLocale"],"REPEATER_SHOW_EDIT_BUTTON":true,"DATA_REQUEST_PAGE_TITLE":"Data Requests and Subscriptions","DATA_REQUEST_SIDEBAR_LABEL":"Data Requests & Subscriptions","LOGIN_REDIRECTS_TO_EPASS":false,"LOGIN_REDIRECTS_TO_ACTIVE_DIRECTORY":true,"LOGIN_ACTIVE_DIRECTORY_LINK":true,"FETCH_EDIT_USER_LINK":false,"LISTS_FETCH_AVAILABLE_LISTS":true,"POST_WIZARD_SUBMIT_REDIRECT_URL":"/","PIN_REQUEST_ATTESTATIONS":true,"PIN_REQUEST_DESCRIPTION":"Click **Request PIN** to have a new PIN sent to the account holder's email address on file.","OWNERSHIP_REQUEST_DESCRIPTION":"To become an **authorized user** of this record, a current **AUTHORIZED USER** will need to grant you access. To request access, click **Request Access** below.","PIN_REQUEST_SUCCESS_MESSAGE":"The PIN you have requested for this entity has been sent to the email associated with your user account.  You should receive the PIN in approximately 3-5 minutes, depending on your email service provider.","APOSTILLE_HEADER_LABEL":"Verification Information","APOSTILLE_NUMBER_LABEL":"Apostille/Authentication","APOSTILLE_CITY_STATE_OVERRIDE":"HELENA, MT","APOSTILLE_FILING_DATE_LABEL":"Issue Date","APOSTILLE_CITY_STATE_IN_CERTIFIED":true,"NOTARY_EXISTING_FILING":true,"ALLOW_REVOKE_OWN_ACCESS_ONLY":false,"HIDE_CANCEL_ON_ONETIME_DATA_REQUESTS":true,"DATA_REQUESTS_IN_SHOPPING_CART":true,"WQ_ALLOW_EDIT_PENDING_PAYMENT":true,"WQ_CONFIRM_ON_DELETE":true,"WQ_DELETE_CONFIRM_MESSAGE":"Deleting this filing will forfeit any money already paid to the Secretary of State. This action is permanent and cannot be undone, are you sure you would like to delete?","PASS_ITEM_GUIDS_ON_CHECKOUT":true,"FORM_REVISION_HISTORY":true,"CHECKOUT_DISCLAIMER":"By entering your credit card and/or checking account information you (i) state that **you are an authorized user** of the credit card and/or electronic check and that the associated information entered (e.g., account holder name, account number, billing address) is accurate, (ii) **you authorize payment processor to charge the amount you have requested** to your credit card and/or funding account, and (iii) **acknowledge if a charge is declined or reversed you may also be assessed a customary charge** by the payment processor for such transactions.","FARM_BILL_SEARCH_CONFIDENTIAL":"As a registered Farm Bill Buyer with the Montana Secretary of State’s office it is important to maintain the confidentiality of the information contained within the Farm Bill Master List. The Farm Bill Master List reflects personal data, such as Social Security Numbers, which are a key piece of personal identifiable information to assist you in determining the existence of a lien against a specific debtor. The distribution of this information beyond its intended purpose is strictly prohibited.\n\n**The debtor's tax identification number has been hidden for confidentiality reasons. You may continue to search on a tax ID number and return debtors that match your search criteria. The SSN/FEIN must be entered without dashes or spaces.  If you need access to the tax identification number to clearly identify the debtor, please contact the UCC unit at (406) 444-3665.**","VIEW_HISTORY_BUTTON_ALT_TEXT":"View Filings","WIZARD_ERROR_TITLE_MESSAGE":"Form Error","FARM_BILL_SEARCH_INTERACTIVE":true,"USE_FARM_BILL_API":true,"DISALLOW_ASSIGN_SELF_AS_RA":true,"DISALLOW_ASSIGN_SELF_AS_PRINCIPAL":true,"USE_TRADEMARK_OWNER_VALIDATION":true,"USE_ALTERNATIVE_FOREIGN_ADDRESS_LABELS":true,"MY_RECEIPTS_FILTER":[{"type":"dateRange","name":"DATE_RANGE","label":"Date range","defaultValue":{"start":null,"end":null}},{"type":"text","name":"REF_NUM","defaultValue":"","label":"Reference Number"},{"type":"text","name":"RECEIPT_NUM","defaultValue":"","label":"Receipt Id"},{"type":"text","name":"AMOUNT","defaultValue":"","label":"Amount"},{"type":"select","name":"TYPE","defaultValue":"","label":"Payment Type","options":[{"value":"","label":"All"},{"value":"CC","label":"Credit Card"},{"value":"Check","label":"Check"}]}],"MY_RECEIPTS_SHOW_IN_SIDEBAR":true,"SHOW_MY_RECEIPTS_HELPER_TEXT":true,"MY_RECEIPTS_HELPER_LABEL":"About Receipt Search","MY_RECEIPTS_HELPER_TEXT":"You can search for receipts based on their descriptions, including the items paid for on the receipt. Use the filters to search for or filter specific information.","FARM_BILL_SUBLINK":{"label":"Farm Bill","component":"FarmBill","parameter":"farm-bill","path":"/lists/farm-bill","sourceTypeId":0,"myRecordsSearch":false,"allowedRules":["/search/"],"disabled":true,"searchDescription":"To perform a search, enter a debtor name. Your search results may include: exact debtor name, variations of that name and any filing that includes your search criteria. Punctuation is ignored.\n\nYou can click on \"Advanced\" to refine your search. Under “Advanced” you can search by crop, year, county and SSN/FEIN. As a registered Farm Bill Buyer with the Montana Secretary of State’s office it is important to maintain the confidentiality of the information contained within the Farm Bill Master List. The Farm Bill Master List reflects personal data, such as Social Security Numbers, which are a key piece of personal identifiable information to assist you in determining the existence of a lien against a specific debtor. The distribution of this information beyond its intended purpose is strictly prohibited.\n\nThe debtor's tax identification number has been hidden for confidentiality reasons. You may continue to search on a tax ID number and return debtors that match your search criteria. The SSN/FEIN must be entered without dashes or spaces.","searchMustHaveOneOf":["search","UCC_FARM_PRODUCT_ID","COUNTY"],"searchPlaceholder":"Search by debtor name","advancedSearchParameters":[{"type":"ServerMultiComplete","label":"Product code name(s)","name":"UCC_FARM_PRODUCT_ID","defaultValue":"","optionsSrc":"UCC_FARM_PRODUCT_V"},{"type":"MultiComplete","label":"Year or Range of Years","name":"YEAR_NUM","optionsSrc":"years","startYear":"1968","defaultValue":[],"preMergeOptions":[{"value":"ALL","label":"All"}]},{"type":"serverSelect","label":"State","name":"STATE","defaultValue":"MONTANA","optionsSrc":"STATE"},{"type":"ServerMultiComplete","label":"County","name":"COUNTY","defaultValue":[],"optionsSrc":"COUNTY","overrideSubOptionsSrcFromParameterName":"STATE"},{"type":"checkbox","name":"TIN_SEARCH_YN","defaultValue":false,"label":"Tax Identification Number Search"},{"type":"checkbox","name":"TIN_SORT_YN","defaultValue":false,"label":"Unique ID Sort"}]},"ALLOW_ADDRESS_VALIDATION_BYPASS_OPTION":true,"DEFAULT_ADDRESS_VALIDATION_BYPASS_OPTION_CHECKED":true}).OWNERSHIP_REQUEST_ATTESTATIONS;
	var REQUEST_PIN_EVEN_WITH_OWNERSHIP = ({"NODE_ENV":"production","BUILD_DATE":"2025-08-27T15:15:31.687Z","BUILD_NUMBER":"Not Provided","GIT_VERSION":"v1.3.0-381-ga81e29b08","GIT_COMMIT_HASH":"a81e29b085c9268ffd96c78eb734365802722741","GIT_BRANCH":"beta","PUBLIC_URL":"","STATE_ABBR":"MT","STATE_NAME":"Montana","STATE_ORG_TITLE":"Secretary of State","LOGIN_HEADER_IMG_PATH":"","HOME_IMG_FILENAME":"montana.jpg","FAVICON_FILE_NAME":"favicon.ico","ALLOW_E_SIGN_ON_CORRECTIONS":true,"THIRD_PARTY_SIGNING_ALLOWED":false,"MY_ACCOUNT_SAVE_AND_CLOSE_BUTTON":true,"IE_DEPRECATED_MESSAGE":"Internet Explorer is not supported. Please select a supported browser below to access this website.","ADDITIONAL_ROUTES":{"dataRequests":true,"farmBill":true,"apostille":true,"externalHelp":"https://sosmt.gov/business/help-center/","systemAdministration":[{"title":"Saved Payments","parameter":"saved-payments","componentName":"SavedPayments"}]},"SUBROUTES":[{"label":"Business","component":"Business","parameter":"business","myWorkQueueSearch":false,"sourceTypeId":54,"searchMustHaveOneOf":["FILING_TYPE_ID","STATUS_ID","STATE","search"],"serverWebSearchDescription":true,"serverWorkQueueDescription":true,"serverMyRecordsDescription":true,"searchPlaceholder":"Search by name or filing number (X########)","allowEmptySearchTerm":true,"requestCertificateAlternateLabel":"Request Information","fileAmendmentButtonLabel":"Filing Actions","advancedSearchParameters":[{"type":"radio","name":"QUERY_TYPE_ID","defaultValue":1010,"options":[{"value":1010,"label":"Starts with"},{"value":1011,"label":"Contains"},{"value":1012,"label":" Word Contains"}]},{"type":"serverSelect","name":"FILING_TYPE_ID","optionsSrc":"FILING_TYPES","label":"Entity Type","placeholder":"All","defaultValue":"0"},{"type":"serverSelect","name":"FILING_SUBTYPE_ID","optionsSrc":"FILING_SUBTYPES","label":"Entity Subtype","overrideSubOptionsSrcFromParameterName":"FILING_TYPE_ID","placeholder":"All","defaultValue":"0"},{"type":"serverSelect","name":"STATUS_ID","optionsSrc":"FILING_STATUS_WITHOUT_ALL","label":"Status","placeholder":"All","defaultValue":"0"},{"type":"serverSelect","name":"STATE","optionsSrc":"STATE","label":"State","placeholder":"All","defaultValue":""},{"type":"serverSelect","name":"COUNTY","optionsSrc":"COUNTY_SUBOPTION","label":"County","overrideSubOptionsSrcFromParameterName":"STATE","placeholder":"All","defaultValue":""},{"type":"checkbox","name":"CRA_SEARCH_YN","defaultValue":false,"label":"Search by Registered Agent PID"},{"type":"dateRange","name":"FILING_DATE","label":"Registration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}},{"type":"dateRange","name":"EXPIRATION_DATE","label":"Expiration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}}],"myRecordsFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Active"},{"value":2,"label":"Inactive"},{"value":3,"label":"Pending"}]},{"type":"dateRange","name":"DATE_RANGE","label":"Date range","defaultValue":{"start":null,"end":null}}],"myWorkQueueFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Approved"},{"value":2,"label":"Pending Online Payment"},{"value":3,"label":"Pending Review"},{"value":4,"label":"Needs Correction"},{"value":5,"label":"Rejected"},{"value":6,"label":"Draft"}]},{"type":"dateRange","name":"DATE_RANGE","label":"Date range","defaultValue":{"start":null,"end":null}}]},{"label":"Notary","component":"Notary","parameter":"notary","sourceTypeId":850,"myWorkQueueSearch":false,"allowEmptySearchTerm":true,"requestCertificateAlternateLabel":"Download Certificate","fileAmendmentButtonLabel":"Filing Actions","hideNameRequestCertificate":true,"hideAddressRequestCertificate":true,"hideRecordUserManagment":true,"searchPlaceholder":"Search by name or commission number","searchMustHaveOneOf":["CITY","search","SERVICE_TYPE"],"advancedParametersStartOpen":true,"searchIsSortable":true,"advancedSearchParameters":[{"type":"radio","name":"STARTS_WITH_YN","defaultValue":false,"options":[{"value":true,"label":"Starts with"},{"value":false,"label":"Contains"}]},{"type":"checkbox","name":"ACTIVE_ONLY_YN","defaultValue":true,"label":"Active entities only"},{"type":"text","name":"CITY","defaultValue":"","label":"City"},{"type":"select","name":"SERVICE_TYPE","label":"Special Services Offered","defaultValue":0,"options":[{"value":0,"label":"(N/A)"},{"value":6165,"label":"In-Person Electronic Notarization (IPEN)"},{"value":6166,"label":"Remote Online Notarization (RON)"},{"value":6167,"label":"Mobile Notary Services"},{"value":6168,"label":"Remote Ink Notarization (RIN)"}]}]},{"label":"Apostille","component":"Apostille","parameter":"apostille","sourceTypeId":720,"myRecordsSearch":false,"myWorkQueueSearch":false,"disabled":false,"allowedRoutes":["/forms-manager/","/queue/","/forms/"]},{"label":"Liens","component":"UCC","parameter":"ucc","sourceTypeId":1999,"myRecordsSearch":true,"myWorkQueueSearch":true,"fileAmendmentButtonLabel":"Filing Actions","searchPlaceholder":"Search by name or file number","disabled":false,"serverWebSearchDescription":true,"myRecordsDescription":"","workQueueDescription":"","searchDescription":"","hideRecordUserManagment":true,"searchLiensCheckout":false,"advancedSearchParameters":[{"type":"radio","name":"STARTS_WITH_YN","defaultValue":false,"options":[{"value":true,"label":"Starts with"},{"value":false,"label":"Contains"}]},{"type":"select","name":"STATUS","defaultValue":"ALL","label":"Status","options":[{"value":"ACTIVE_UNLAPSED","label":"Active (unlapsed)"},{"value":"ACTIVE_LAPSED_UNLAPSED","label":"Active (lapsed and unlapsed)"}]},{"type":"text","name":"EXCLUDE_VALUES","label":"Exclude Debtor Names (comma separated list of names to exclude)","defaultValue":""},{"type":"dateRange","name":"FILING_DATE","label":"Financing Statement Date","defaultValue":{"start":null,"end":null}},{"type":"dateRange","name":"LAPSE_DATE","label":"Lapse Date","defaultValue":{"start":null,"end":null}},{"type":"text","name":"CITY","label":"Debtor City","defaultValue":""}],"myRecordsFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Approved"},{"value":2,"label":"Pending Online Payment"},{"value":3,"label":"Pending Review"}]},{"type":"select","name":"TYPE","defaultValue":0,"label":"Lien Type","options":[{"value":0,"label":"All"},{"value":1,"label":"UCC"},{"value":2,"label":"EFS"},{"value":3,"label":"Title 71"}]}],"myWorkQueueFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Approved"},{"value":2,"label":"Pending Online Payment"},{"value":3,"label":"Pending Review"},{"value":4,"label":"Pending Print and Mail"},{"value":5,"label":"Rejected"},{"value":6,"label":"Draft"}]},{"type":"select","name":"TYPE","defaultValue":0,"label":"Lien Type","options":[{"value":0,"label":"All"},{"value":1,"label":"UCC"},{"value":2,"label":"EFS"},{"value":3,"label":"Title 71"}]}]},{"label":"Copy Request","component":"copies","parameter":"copies","sourceTypeId":2001,"myRecordsSearch":false,"myWorkQueueSearch":false,"disabled":false,"allowedRoutes":["/forms-manager/","/queue/","/forms/"]},{"label":"Trademark","component":"Trademark","parameter":"trademark","sourceTypeId":810,"showRequestCertificate":true,"searchMustHaveOneOf":["search","EXPIRATION_DATE","FILING_DATE"],"allowEmptySearchTerm":true,"requestCertificateAlternateLabel":"Request Information","fileAmendmentButtonLabel":"Filing Actions","advancedSearchParameters":[{"type":"radio","name":"QUERY_TYPE_ID","defaultValue":1010,"options":[{"value":1010,"label":"Starts with"},{"value":1011,"label":"Contains"},{"value":1012,"label":" Word Contains"}]},{"type":"checkbox","name":"OWNER_SEARCH_YN","defaultValue":false,"label":"Search owners"},{"type":"radio","name":"SERVICE_MARK_YN","label":"Mark Type","defaultValue":"","options":[{"value":"","label":"All Marks"},{"value":"Y","label":"Service Mark"},{"value":"N","label":"Trademark"}]},{"type":"serverSelect","name":"STATUS_ID","optionsSrc":"TYPE_V|TRADEMARK_STATUS_TYPE","label":"Status","placeholder":"All","defaultValue":"0"},{"type":"select","name":"DESIGN_TYPE_ID","options":[{"value":0,"label":"All"},{"value":990,"label":"Words Only"},{"value":991,"label":"Design Only"},{"value":992,"label":"Words and Design"}],"label":"Design Type","defaultValue":"0"},{"type":"dateRange","name":"FILING_DATE","label":"Registered Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}},{"type":"dateRange","name":"EXPIRATION_DATE","label":"Expiration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}}]},{"label":"Business Info Request","component":"InfoRequests","parameter":"info-request","sourceTypeId":167,"allowedRoutes":["/forms-manager/","/queue/","/forms/"]},{"label":"Data Requests","component":"DataRequests","parameter":"data-request","sourceTypeId":0,"allowedRoutes":["/forms-manager/"]},{"label":"CRA","component":"CRA","parameter":"cra","sourceTypeId":157,"myRecordsSearch":false,"searchPlaceholder":"Search by name or registered agent number","allowedRoutes":["/forms-manager/","/forms/","/records/","/queue/","/search/"],"allowEmptySearchTerm":true,"fileAmendmentButtonLabel":"Filing Actions","advancedSearchParameters":[{"type":"radio","name":"QUERY_TYPE_ID","defaultValue":1010,"options":[{"value":1010,"label":"Starts with"},{"value":1011,"label":"Contains"},{"value":1012,"label":" Word Contains"}]},{"type":"dateRange","name":"CRA_DATE","label":"Registration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}},{"type":"select","name":"STATUS_ID","label":"Status","defaultValue":0,"options":[{"value":0,"label":"All"},{"value":121,"label":"Active"},{"value":122,"label":"Inactive"}]},{"type":"select","name":"AGENT_TYPE_ID","label":"Agent Type","defaultValue":0,"options":[{"value":0,"label":"All"},{"value":460,"label":"Registered Agent"},{"value":461,"label":"Commercial Registered Agent"}]}]},{"label":"Farm Bill","component":"FarmBill","parameter":"farm-bill","path":"/lists/farm-bill","sourceTypeId":0,"myRecordsSearch":false,"allowedRules":["/search/"],"disabled":true,"searchDescription":"To perform a search, enter a debtor name. Your search results may include: exact debtor name, variations of that name and any filing that includes your search criteria. Punctuation is ignored.\n\nYou can click on \"Advanced\" to refine your search. Under “Advanced” you can search by crop, year, county and SSN/FEIN. As a registered Farm Bill Buyer with the Montana Secretary of State’s office it is important to maintain the confidentiality of the information contained within the Farm Bill Master List. The Farm Bill Master List reflects personal data, such as Social Security Numbers, which are a key piece of personal identifiable information to assist you in determining the existence of a lien against a specific debtor. The distribution of this information beyond its intended purpose is strictly prohibited.\n\nThe debtor's tax identification number has been hidden for confidentiality reasons. You may continue to search on a tax ID number and return debtors that match your search criteria. The SSN/FEIN must be entered without dashes or spaces.","searchMustHaveOneOf":["search","UCC_FARM_PRODUCT_ID","COUNTY"],"searchPlaceholder":"Search by debtor name","advancedSearchParameters":[{"type":"ServerMultiComplete","label":"Product code name(s)","name":"UCC_FARM_PRODUCT_ID","defaultValue":"","optionsSrc":"UCC_FARM_PRODUCT_V"},{"type":"MultiComplete","label":"Year or Range of Years","name":"YEAR_NUM","optionsSrc":"years","startYear":"1968","defaultValue":[],"preMergeOptions":[{"value":"ALL","label":"All"}]},{"type":"serverSelect","label":"State","name":"STATE","defaultValue":"MONTANA","optionsSrc":"STATE"},{"type":"ServerMultiComplete","label":"County","name":"COUNTY","defaultValue":[],"optionsSrc":"COUNTY","overrideSubOptionsSrcFromParameterName":"STATE"},{"type":"checkbox","name":"TIN_SEARCH_YN","defaultValue":false,"label":"Tax Identification Number Search"},{"type":"checkbox","name":"TIN_SORT_YN","defaultValue":false,"label":"Unique ID Sort"}]}],"SYSTEM_NICKNAME":"Online Services Portal","PAYMENT_METHODS":[{"type":"bypass"},{"type":"iTransact"}],"PAYMENT_ALLOW_AMEX":true,"SYSTEM_ID_LABEL":"System Id","DOUBLE_COLUMN_PUBLIC_LOGIN":true,"INTERNAL_USER_MANAGEMENT":true,"ALLOW_PUBLIC_JSON_IMPORT":false,"MAX_FILE_UPLOAD_SIZE":10000000,"REFUND_TEXT":"","RETURN_TO_HOME_ON_LOGOUT":true,"CURRENT_SOS_NAME":"Christi Jacobsen","LOGO_FILENAME":"mt-sos-logo.png","LOGO_ALT":"Christi Jacobsen, Montana Secretary of State","LOGO_FULL_WIDTH":true,"HOME_HIDE_AUTH_HINT":true,"HOME_TITLE":"Montana Secretary of State","CUSTOM_TAB_TITLE":"Official Montana","HOME_SUBTITLE":"Online Business Services","ENTITY_NAME_CONSENT_DESCRIPTION":"","ALLOW_USER_PROFILE_EDITING":true,"COMPARE_FOREIGN_NAME_IN_ENTITY_NAME_VALIDATION":true,"FOREIGN_NAME_FIELD_NAME":"KIMA_PARENT_NAME_INFO","LOGIN_TITLE":"Montana Secretary of State Online Filing Portal Login","PUBLIC_LOGIN_LABEL":"Username","REVERSE_LOGIN_COLUMNS":true,"LOGIN_SEAL_FILENAME":"seal_white.png","SEPARATE_USERNAME_AND_EMAIL":true,"CREATE_ACCOUNT_BUTTON_ALIGN_LEFT":true,"CREATE_ACCOUNT_BUTTON_TEXT":"CREATE AN ACCOUNT","PASSWORD_CUSTOM_ERROR_TEXT":"The password must meet all requirements","ACCOUNT_CREATED_MESSAGE":"Please check your email to verify your account to login and allow a few minutes for this message to arrive. Check your junk/spam folders if you do not find the email in your inbox.","PUBLIC_LOGIN_PLACEHOLDER":" ","DISABLE_DEFAULT_PAYMENT_RADIO":true,"CUSTOM_RESET_PASSWORD_ERROR_MESSAGE":"Username invalid - no account found","PUBLIC_LOGIN_CREATE_DESCRIPTION":"### Existing User:\n\n  - Enter your username and password to login.  \n\n\n  #### - OR -  \n\n\n\n  - Forgot password? Click 'Reset Password' and follow the prompts.\n  - Forgot username? Click 'Forgot Username' and follow the prompts.  \n\n\n  ### New User:\n  ","LOGIN_HELP_LINK":"https://sosmt.gov/business/how-do-i/","LOGIN_HELP_LINK_TEXT":"Need Help?","FORGOT_USERNAME_TEXT":"Forgot Username?","LOGIN_ACTIVE_DIRECTORY_TEXT":"State User Login","MULTIPLE_LOGIN_METHODS":true,"HAS_ACTIVE_DIRECTORY_LOGIN":true,"RESET_PASSWORD_WITH_USERNAME":true,"DOWNLOAD_LINK":true,"SHOW_USERNAME_ACCOUNT_CREATE":true,"SHOW_SCROLL_DOWN_ARROW":true,"SHOW_ADDRESS_ACCOUNT_CREATE":true,"TWO_COLUMN_ACCOUNT_CREATE":true,"RESET_PASSWORD_TIP":"A link to change your password has been sent to your email. Please allow a few minutes for this message to arrive. Please check your junk/spam folders if you do not find the email in your inbox.","FORGOT_PASSWORD_LINK_TEXT":"Reset Password","PHONE_NUMBER_OPTIONAL_ACCOUNT_CREATE":true,"SHOW_REQUIRED_INDICATOR_ACCOUNT_CREATE":true,"PASSWORD_REQUIREMENTS_ACCOUNT_CREATE":"\n    <ul>\n      <li>MUST contain at least 8 characters (12+ recommended)</li>\n      <li>MUST contain at least one uppercase letter.</li>\n      <li>MUST contain at least one lowercase letter.</li>\n      <li>MUST contain at least one number.</li>\n      <li>MUST contain at least one special character (!”#$%&'()*+,-./:;<=>?</li>\n    </ul>\n  ","ALLOW_CERTIFICATION_REQUEST":true,"ALLOW_PUBLIC_CERTIFICATE_REQUEST":true,"ALLOW_COPY_REQUEST":false,"ALLOW_CORRECTION_STYLING":true,"HIDE_DEPRECATION_WARNING":false,"AMEND_ROUTE_PUBLIC":true,"SEAL_FILENAME":"seal.png","SHOPPING_CART":true,"ALLOW_PAYMENT_UPDATE_WITH_EMPTY_CART":true,"RA_EMAIL":true,"RA_WEBSITE":true,"RA_NO_DEFAULT_TYPE":true,"RA_ADDRESS_LABEL":"Street Address","RA_TYPE_SELECTION_DEFAULT":true,"RA_DEFAULT_TYPE":"460","RA_OVERRIDE_TYPE_WITH_DEFAULT":true,"RA_PRINCIPAL_ADDRESS_AMS":true,"UPLOAD_AND_SUBMIT_HIDE_IF_ONE_OPTION":true,"PAYMENT_PROCESSING_MESSAGE":"Your payment is processing - Do not close your browser or click the back button","CHECKOUT_BUTTON_WHEN_PROCESSING_TEXT":"Processing","EFS_CROP_PICKER_NONE_LABEL":"Lien Duration","DISALLOWED_WIZARD_PIECES":["FormationLocale"],"REPEATER_SHOW_EDIT_BUTTON":true,"DATA_REQUEST_PAGE_TITLE":"Data Requests and Subscriptions","DATA_REQUEST_SIDEBAR_LABEL":"Data Requests & Subscriptions","LOGIN_REDIRECTS_TO_EPASS":false,"LOGIN_REDIRECTS_TO_ACTIVE_DIRECTORY":true,"LOGIN_ACTIVE_DIRECTORY_LINK":true,"FETCH_EDIT_USER_LINK":false,"LISTS_FETCH_AVAILABLE_LISTS":true,"POST_WIZARD_SUBMIT_REDIRECT_URL":"/","PIN_REQUEST_ATTESTATIONS":true,"PIN_REQUEST_DESCRIPTION":"Click **Request PIN** to have a new PIN sent to the account holder's email address on file.","OWNERSHIP_REQUEST_DESCRIPTION":"To become an **authorized user** of this record, a current **AUTHORIZED USER** will need to grant you access. To request access, click **Request Access** below.","PIN_REQUEST_SUCCESS_MESSAGE":"The PIN you have requested for this entity has been sent to the email associated with your user account.  You should receive the PIN in approximately 3-5 minutes, depending on your email service provider.","APOSTILLE_HEADER_LABEL":"Verification Information","APOSTILLE_NUMBER_LABEL":"Apostille/Authentication","APOSTILLE_CITY_STATE_OVERRIDE":"HELENA, MT","APOSTILLE_FILING_DATE_LABEL":"Issue Date","APOSTILLE_CITY_STATE_IN_CERTIFIED":true,"NOTARY_EXISTING_FILING":true,"ALLOW_REVOKE_OWN_ACCESS_ONLY":false,"HIDE_CANCEL_ON_ONETIME_DATA_REQUESTS":true,"DATA_REQUESTS_IN_SHOPPING_CART":true,"WQ_ALLOW_EDIT_PENDING_PAYMENT":true,"WQ_CONFIRM_ON_DELETE":true,"WQ_DELETE_CONFIRM_MESSAGE":"Deleting this filing will forfeit any money already paid to the Secretary of State. This action is permanent and cannot be undone, are you sure you would like to delete?","PASS_ITEM_GUIDS_ON_CHECKOUT":true,"FORM_REVISION_HISTORY":true,"CHECKOUT_DISCLAIMER":"By entering your credit card and/or checking account information you (i) state that **you are an authorized user** of the credit card and/or electronic check and that the associated information entered (e.g., account holder name, account number, billing address) is accurate, (ii) **you authorize payment processor to charge the amount you have requested** to your credit card and/or funding account, and (iii) **acknowledge if a charge is declined or reversed you may also be assessed a customary charge** by the payment processor for such transactions.","FARM_BILL_SEARCH_CONFIDENTIAL":"As a registered Farm Bill Buyer with the Montana Secretary of State’s office it is important to maintain the confidentiality of the information contained within the Farm Bill Master List. The Farm Bill Master List reflects personal data, such as Social Security Numbers, which are a key piece of personal identifiable information to assist you in determining the existence of a lien against a specific debtor. The distribution of this information beyond its intended purpose is strictly prohibited.\n\n**The debtor's tax identification number has been hidden for confidentiality reasons. You may continue to search on a tax ID number and return debtors that match your search criteria. The SSN/FEIN must be entered without dashes or spaces.  If you need access to the tax identification number to clearly identify the debtor, please contact the UCC unit at (406) 444-3665.**","VIEW_HISTORY_BUTTON_ALT_TEXT":"View Filings","WIZARD_ERROR_TITLE_MESSAGE":"Form Error","FARM_BILL_SEARCH_INTERACTIVE":true,"USE_FARM_BILL_API":true,"DISALLOW_ASSIGN_SELF_AS_RA":true,"DISALLOW_ASSIGN_SELF_AS_PRINCIPAL":true,"USE_TRADEMARK_OWNER_VALIDATION":true,"USE_ALTERNATIVE_FOREIGN_ADDRESS_LABELS":true,"MY_RECEIPTS_FILTER":[{"type":"dateRange","name":"DATE_RANGE","label":"Date range","defaultValue":{"start":null,"end":null}},{"type":"text","name":"REF_NUM","defaultValue":"","label":"Reference Number"},{"type":"text","name":"RECEIPT_NUM","defaultValue":"","label":"Receipt Id"},{"type":"text","name":"AMOUNT","defaultValue":"","label":"Amount"},{"type":"select","name":"TYPE","defaultValue":"","label":"Payment Type","options":[{"value":"","label":"All"},{"value":"CC","label":"Credit Card"},{"value":"Check","label":"Check"}]}],"MY_RECEIPTS_SHOW_IN_SIDEBAR":true,"SHOW_MY_RECEIPTS_HELPER_TEXT":true,"MY_RECEIPTS_HELPER_LABEL":"About Receipt Search","MY_RECEIPTS_HELPER_TEXT":"You can search for receipts based on their descriptions, including the items paid for on the receipt. Use the filters to search for or filter specific information.","FARM_BILL_SUBLINK":{"label":"Farm Bill","component":"FarmBill","parameter":"farm-bill","path":"/lists/farm-bill","sourceTypeId":0,"myRecordsSearch":false,"allowedRules":["/search/"],"disabled":true,"searchDescription":"To perform a search, enter a debtor name. Your search results may include: exact debtor name, variations of that name and any filing that includes your search criteria. Punctuation is ignored.\n\nYou can click on \"Advanced\" to refine your search. Under “Advanced” you can search by crop, year, county and SSN/FEIN. As a registered Farm Bill Buyer with the Montana Secretary of State’s office it is important to maintain the confidentiality of the information contained within the Farm Bill Master List. The Farm Bill Master List reflects personal data, such as Social Security Numbers, which are a key piece of personal identifiable information to assist you in determining the existence of a lien against a specific debtor. The distribution of this information beyond its intended purpose is strictly prohibited.\n\nThe debtor's tax identification number has been hidden for confidentiality reasons. You may continue to search on a tax ID number and return debtors that match your search criteria. The SSN/FEIN must be entered without dashes or spaces.","searchMustHaveOneOf":["search","UCC_FARM_PRODUCT_ID","COUNTY"],"searchPlaceholder":"Search by debtor name","advancedSearchParameters":[{"type":"ServerMultiComplete","label":"Product code name(s)","name":"UCC_FARM_PRODUCT_ID","defaultValue":"","optionsSrc":"UCC_FARM_PRODUCT_V"},{"type":"MultiComplete","label":"Year or Range of Years","name":"YEAR_NUM","optionsSrc":"years","startYear":"1968","defaultValue":[],"preMergeOptions":[{"value":"ALL","label":"All"}]},{"type":"serverSelect","label":"State","name":"STATE","defaultValue":"MONTANA","optionsSrc":"STATE"},{"type":"ServerMultiComplete","label":"County","name":"COUNTY","defaultValue":[],"optionsSrc":"COUNTY","overrideSubOptionsSrcFromParameterName":"STATE"},{"type":"checkbox","name":"TIN_SEARCH_YN","defaultValue":false,"label":"Tax Identification Number Search"},{"type":"checkbox","name":"TIN_SORT_YN","defaultValue":false,"label":"Unique ID Sort"}]},"ALLOW_ADDRESS_VALIDATION_BYPASS_OPTION":true,"DEFAULT_ADDRESS_VALIDATION_BYPASS_OPTION_CHECKED":true}).REQUEST_PIN_EVEN_WITH_OWNERSHIP;
	var OWNERSHIP_REQUEST_SUCCESSFUL_MESSAGE = ({"NODE_ENV":"production","BUILD_DATE":"2025-08-27T15:15:31.687Z","BUILD_NUMBER":"Not Provided","GIT_VERSION":"v1.3.0-381-ga81e29b08","GIT_COMMIT_HASH":"a81e29b085c9268ffd96c78eb734365802722741","GIT_BRANCH":"beta","PUBLIC_URL":"","STATE_ABBR":"MT","STATE_NAME":"Montana","STATE_ORG_TITLE":"Secretary of State","LOGIN_HEADER_IMG_PATH":"","HOME_IMG_FILENAME":"montana.jpg","FAVICON_FILE_NAME":"favicon.ico","ALLOW_E_SIGN_ON_CORRECTIONS":true,"THIRD_PARTY_SIGNING_ALLOWED":false,"MY_ACCOUNT_SAVE_AND_CLOSE_BUTTON":true,"IE_DEPRECATED_MESSAGE":"Internet Explorer is not supported. Please select a supported browser below to access this website.","ADDITIONAL_ROUTES":{"dataRequests":true,"farmBill":true,"apostille":true,"externalHelp":"https://sosmt.gov/business/help-center/","systemAdministration":[{"title":"Saved Payments","parameter":"saved-payments","componentName":"SavedPayments"}]},"SUBROUTES":[{"label":"Business","component":"Business","parameter":"business","myWorkQueueSearch":false,"sourceTypeId":54,"searchMustHaveOneOf":["FILING_TYPE_ID","STATUS_ID","STATE","search"],"serverWebSearchDescription":true,"serverWorkQueueDescription":true,"serverMyRecordsDescription":true,"searchPlaceholder":"Search by name or filing number (X########)","allowEmptySearchTerm":true,"requestCertificateAlternateLabel":"Request Information","fileAmendmentButtonLabel":"Filing Actions","advancedSearchParameters":[{"type":"radio","name":"QUERY_TYPE_ID","defaultValue":1010,"options":[{"value":1010,"label":"Starts with"},{"value":1011,"label":"Contains"},{"value":1012,"label":" Word Contains"}]},{"type":"serverSelect","name":"FILING_TYPE_ID","optionsSrc":"FILING_TYPES","label":"Entity Type","placeholder":"All","defaultValue":"0"},{"type":"serverSelect","name":"FILING_SUBTYPE_ID","optionsSrc":"FILING_SUBTYPES","label":"Entity Subtype","overrideSubOptionsSrcFromParameterName":"FILING_TYPE_ID","placeholder":"All","defaultValue":"0"},{"type":"serverSelect","name":"STATUS_ID","optionsSrc":"FILING_STATUS_WITHOUT_ALL","label":"Status","placeholder":"All","defaultValue":"0"},{"type":"serverSelect","name":"STATE","optionsSrc":"STATE","label":"State","placeholder":"All","defaultValue":""},{"type":"serverSelect","name":"COUNTY","optionsSrc":"COUNTY_SUBOPTION","label":"County","overrideSubOptionsSrcFromParameterName":"STATE","placeholder":"All","defaultValue":""},{"type":"checkbox","name":"CRA_SEARCH_YN","defaultValue":false,"label":"Search by Registered Agent PID"},{"type":"dateRange","name":"FILING_DATE","label":"Registration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}},{"type":"dateRange","name":"EXPIRATION_DATE","label":"Expiration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}}],"myRecordsFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Active"},{"value":2,"label":"Inactive"},{"value":3,"label":"Pending"}]},{"type":"dateRange","name":"DATE_RANGE","label":"Date range","defaultValue":{"start":null,"end":null}}],"myWorkQueueFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Approved"},{"value":2,"label":"Pending Online Payment"},{"value":3,"label":"Pending Review"},{"value":4,"label":"Needs Correction"},{"value":5,"label":"Rejected"},{"value":6,"label":"Draft"}]},{"type":"dateRange","name":"DATE_RANGE","label":"Date range","defaultValue":{"start":null,"end":null}}]},{"label":"Notary","component":"Notary","parameter":"notary","sourceTypeId":850,"myWorkQueueSearch":false,"allowEmptySearchTerm":true,"requestCertificateAlternateLabel":"Download Certificate","fileAmendmentButtonLabel":"Filing Actions","hideNameRequestCertificate":true,"hideAddressRequestCertificate":true,"hideRecordUserManagment":true,"searchPlaceholder":"Search by name or commission number","searchMustHaveOneOf":["CITY","search","SERVICE_TYPE"],"advancedParametersStartOpen":true,"searchIsSortable":true,"advancedSearchParameters":[{"type":"radio","name":"STARTS_WITH_YN","defaultValue":false,"options":[{"value":true,"label":"Starts with"},{"value":false,"label":"Contains"}]},{"type":"checkbox","name":"ACTIVE_ONLY_YN","defaultValue":true,"label":"Active entities only"},{"type":"text","name":"CITY","defaultValue":"","label":"City"},{"type":"select","name":"SERVICE_TYPE","label":"Special Services Offered","defaultValue":0,"options":[{"value":0,"label":"(N/A)"},{"value":6165,"label":"In-Person Electronic Notarization (IPEN)"},{"value":6166,"label":"Remote Online Notarization (RON)"},{"value":6167,"label":"Mobile Notary Services"},{"value":6168,"label":"Remote Ink Notarization (RIN)"}]}]},{"label":"Apostille","component":"Apostille","parameter":"apostille","sourceTypeId":720,"myRecordsSearch":false,"myWorkQueueSearch":false,"disabled":false,"allowedRoutes":["/forms-manager/","/queue/","/forms/"]},{"label":"Liens","component":"UCC","parameter":"ucc","sourceTypeId":1999,"myRecordsSearch":true,"myWorkQueueSearch":true,"fileAmendmentButtonLabel":"Filing Actions","searchPlaceholder":"Search by name or file number","disabled":false,"serverWebSearchDescription":true,"myRecordsDescription":"","workQueueDescription":"","searchDescription":"","hideRecordUserManagment":true,"searchLiensCheckout":false,"advancedSearchParameters":[{"type":"radio","name":"STARTS_WITH_YN","defaultValue":false,"options":[{"value":true,"label":"Starts with"},{"value":false,"label":"Contains"}]},{"type":"select","name":"STATUS","defaultValue":"ALL","label":"Status","options":[{"value":"ACTIVE_UNLAPSED","label":"Active (unlapsed)"},{"value":"ACTIVE_LAPSED_UNLAPSED","label":"Active (lapsed and unlapsed)"}]},{"type":"text","name":"EXCLUDE_VALUES","label":"Exclude Debtor Names (comma separated list of names to exclude)","defaultValue":""},{"type":"dateRange","name":"FILING_DATE","label":"Financing Statement Date","defaultValue":{"start":null,"end":null}},{"type":"dateRange","name":"LAPSE_DATE","label":"Lapse Date","defaultValue":{"start":null,"end":null}},{"type":"text","name":"CITY","label":"Debtor City","defaultValue":""}],"myRecordsFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Approved"},{"value":2,"label":"Pending Online Payment"},{"value":3,"label":"Pending Review"}]},{"type":"select","name":"TYPE","defaultValue":0,"label":"Lien Type","options":[{"value":0,"label":"All"},{"value":1,"label":"UCC"},{"value":2,"label":"EFS"},{"value":3,"label":"Title 71"}]}],"myWorkQueueFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Approved"},{"value":2,"label":"Pending Online Payment"},{"value":3,"label":"Pending Review"},{"value":4,"label":"Pending Print and Mail"},{"value":5,"label":"Rejected"},{"value":6,"label":"Draft"}]},{"type":"select","name":"TYPE","defaultValue":0,"label":"Lien Type","options":[{"value":0,"label":"All"},{"value":1,"label":"UCC"},{"value":2,"label":"EFS"},{"value":3,"label":"Title 71"}]}]},{"label":"Copy Request","component":"copies","parameter":"copies","sourceTypeId":2001,"myRecordsSearch":false,"myWorkQueueSearch":false,"disabled":false,"allowedRoutes":["/forms-manager/","/queue/","/forms/"]},{"label":"Trademark","component":"Trademark","parameter":"trademark","sourceTypeId":810,"showRequestCertificate":true,"searchMustHaveOneOf":["search","EXPIRATION_DATE","FILING_DATE"],"allowEmptySearchTerm":true,"requestCertificateAlternateLabel":"Request Information","fileAmendmentButtonLabel":"Filing Actions","advancedSearchParameters":[{"type":"radio","name":"QUERY_TYPE_ID","defaultValue":1010,"options":[{"value":1010,"label":"Starts with"},{"value":1011,"label":"Contains"},{"value":1012,"label":" Word Contains"}]},{"type":"checkbox","name":"OWNER_SEARCH_YN","defaultValue":false,"label":"Search owners"},{"type":"radio","name":"SERVICE_MARK_YN","label":"Mark Type","defaultValue":"","options":[{"value":"","label":"All Marks"},{"value":"Y","label":"Service Mark"},{"value":"N","label":"Trademark"}]},{"type":"serverSelect","name":"STATUS_ID","optionsSrc":"TYPE_V|TRADEMARK_STATUS_TYPE","label":"Status","placeholder":"All","defaultValue":"0"},{"type":"select","name":"DESIGN_TYPE_ID","options":[{"value":0,"label":"All"},{"value":990,"label":"Words Only"},{"value":991,"label":"Design Only"},{"value":992,"label":"Words and Design"}],"label":"Design Type","defaultValue":"0"},{"type":"dateRange","name":"FILING_DATE","label":"Registered Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}},{"type":"dateRange","name":"EXPIRATION_DATE","label":"Expiration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}}]},{"label":"Business Info Request","component":"InfoRequests","parameter":"info-request","sourceTypeId":167,"allowedRoutes":["/forms-manager/","/queue/","/forms/"]},{"label":"Data Requests","component":"DataRequests","parameter":"data-request","sourceTypeId":0,"allowedRoutes":["/forms-manager/"]},{"label":"CRA","component":"CRA","parameter":"cra","sourceTypeId":157,"myRecordsSearch":false,"searchPlaceholder":"Search by name or registered agent number","allowedRoutes":["/forms-manager/","/forms/","/records/","/queue/","/search/"],"allowEmptySearchTerm":true,"fileAmendmentButtonLabel":"Filing Actions","advancedSearchParameters":[{"type":"radio","name":"QUERY_TYPE_ID","defaultValue":1010,"options":[{"value":1010,"label":"Starts with"},{"value":1011,"label":"Contains"},{"value":1012,"label":" Word Contains"}]},{"type":"dateRange","name":"CRA_DATE","label":"Registration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}},{"type":"select","name":"STATUS_ID","label":"Status","defaultValue":0,"options":[{"value":0,"label":"All"},{"value":121,"label":"Active"},{"value":122,"label":"Inactive"}]},{"type":"select","name":"AGENT_TYPE_ID","label":"Agent Type","defaultValue":0,"options":[{"value":0,"label":"All"},{"value":460,"label":"Registered Agent"},{"value":461,"label":"Commercial Registered Agent"}]}]},{"label":"Farm Bill","component":"FarmBill","parameter":"farm-bill","path":"/lists/farm-bill","sourceTypeId":0,"myRecordsSearch":false,"allowedRules":["/search/"],"disabled":true,"searchDescription":"To perform a search, enter a debtor name. Your search results may include: exact debtor name, variations of that name and any filing that includes your search criteria. Punctuation is ignored.\n\nYou can click on \"Advanced\" to refine your search. Under “Advanced” you can search by crop, year, county and SSN/FEIN. As a registered Farm Bill Buyer with the Montana Secretary of State’s office it is important to maintain the confidentiality of the information contained within the Farm Bill Master List. The Farm Bill Master List reflects personal data, such as Social Security Numbers, which are a key piece of personal identifiable information to assist you in determining the existence of a lien against a specific debtor. The distribution of this information beyond its intended purpose is strictly prohibited.\n\nThe debtor's tax identification number has been hidden for confidentiality reasons. You may continue to search on a tax ID number and return debtors that match your search criteria. The SSN/FEIN must be entered without dashes or spaces.","searchMustHaveOneOf":["search","UCC_FARM_PRODUCT_ID","COUNTY"],"searchPlaceholder":"Search by debtor name","advancedSearchParameters":[{"type":"ServerMultiComplete","label":"Product code name(s)","name":"UCC_FARM_PRODUCT_ID","defaultValue":"","optionsSrc":"UCC_FARM_PRODUCT_V"},{"type":"MultiComplete","label":"Year or Range of Years","name":"YEAR_NUM","optionsSrc":"years","startYear":"1968","defaultValue":[],"preMergeOptions":[{"value":"ALL","label":"All"}]},{"type":"serverSelect","label":"State","name":"STATE","defaultValue":"MONTANA","optionsSrc":"STATE"},{"type":"ServerMultiComplete","label":"County","name":"COUNTY","defaultValue":[],"optionsSrc":"COUNTY","overrideSubOptionsSrcFromParameterName":"STATE"},{"type":"checkbox","name":"TIN_SEARCH_YN","defaultValue":false,"label":"Tax Identification Number Search"},{"type":"checkbox","name":"TIN_SORT_YN","defaultValue":false,"label":"Unique ID Sort"}]}],"SYSTEM_NICKNAME":"Online Services Portal","PAYMENT_METHODS":[{"type":"bypass"},{"type":"iTransact"}],"PAYMENT_ALLOW_AMEX":true,"SYSTEM_ID_LABEL":"System Id","DOUBLE_COLUMN_PUBLIC_LOGIN":true,"INTERNAL_USER_MANAGEMENT":true,"ALLOW_PUBLIC_JSON_IMPORT":false,"MAX_FILE_UPLOAD_SIZE":10000000,"REFUND_TEXT":"","RETURN_TO_HOME_ON_LOGOUT":true,"CURRENT_SOS_NAME":"Christi Jacobsen","LOGO_FILENAME":"mt-sos-logo.png","LOGO_ALT":"Christi Jacobsen, Montana Secretary of State","LOGO_FULL_WIDTH":true,"HOME_HIDE_AUTH_HINT":true,"HOME_TITLE":"Montana Secretary of State","CUSTOM_TAB_TITLE":"Official Montana","HOME_SUBTITLE":"Online Business Services","ENTITY_NAME_CONSENT_DESCRIPTION":"","ALLOW_USER_PROFILE_EDITING":true,"COMPARE_FOREIGN_NAME_IN_ENTITY_NAME_VALIDATION":true,"FOREIGN_NAME_FIELD_NAME":"KIMA_PARENT_NAME_INFO","LOGIN_TITLE":"Montana Secretary of State Online Filing Portal Login","PUBLIC_LOGIN_LABEL":"Username","REVERSE_LOGIN_COLUMNS":true,"LOGIN_SEAL_FILENAME":"seal_white.png","SEPARATE_USERNAME_AND_EMAIL":true,"CREATE_ACCOUNT_BUTTON_ALIGN_LEFT":true,"CREATE_ACCOUNT_BUTTON_TEXT":"CREATE AN ACCOUNT","PASSWORD_CUSTOM_ERROR_TEXT":"The password must meet all requirements","ACCOUNT_CREATED_MESSAGE":"Please check your email to verify your account to login and allow a few minutes for this message to arrive. Check your junk/spam folders if you do not find the email in your inbox.","PUBLIC_LOGIN_PLACEHOLDER":" ","DISABLE_DEFAULT_PAYMENT_RADIO":true,"CUSTOM_RESET_PASSWORD_ERROR_MESSAGE":"Username invalid - no account found","PUBLIC_LOGIN_CREATE_DESCRIPTION":"### Existing User:\n\n  - Enter your username and password to login.  \n\n\n  #### - OR -  \n\n\n\n  - Forgot password? Click 'Reset Password' and follow the prompts.\n  - Forgot username? Click 'Forgot Username' and follow the prompts.  \n\n\n  ### New User:\n  ","LOGIN_HELP_LINK":"https://sosmt.gov/business/how-do-i/","LOGIN_HELP_LINK_TEXT":"Need Help?","FORGOT_USERNAME_TEXT":"Forgot Username?","LOGIN_ACTIVE_DIRECTORY_TEXT":"State User Login","MULTIPLE_LOGIN_METHODS":true,"HAS_ACTIVE_DIRECTORY_LOGIN":true,"RESET_PASSWORD_WITH_USERNAME":true,"DOWNLOAD_LINK":true,"SHOW_USERNAME_ACCOUNT_CREATE":true,"SHOW_SCROLL_DOWN_ARROW":true,"SHOW_ADDRESS_ACCOUNT_CREATE":true,"TWO_COLUMN_ACCOUNT_CREATE":true,"RESET_PASSWORD_TIP":"A link to change your password has been sent to your email. Please allow a few minutes for this message to arrive. Please check your junk/spam folders if you do not find the email in your inbox.","FORGOT_PASSWORD_LINK_TEXT":"Reset Password","PHONE_NUMBER_OPTIONAL_ACCOUNT_CREATE":true,"SHOW_REQUIRED_INDICATOR_ACCOUNT_CREATE":true,"PASSWORD_REQUIREMENTS_ACCOUNT_CREATE":"\n    <ul>\n      <li>MUST contain at least 8 characters (12+ recommended)</li>\n      <li>MUST contain at least one uppercase letter.</li>\n      <li>MUST contain at least one lowercase letter.</li>\n      <li>MUST contain at least one number.</li>\n      <li>MUST contain at least one special character (!”#$%&'()*+,-./:;<=>?</li>\n    </ul>\n  ","ALLOW_CERTIFICATION_REQUEST":true,"ALLOW_PUBLIC_CERTIFICATE_REQUEST":true,"ALLOW_COPY_REQUEST":false,"ALLOW_CORRECTION_STYLING":true,"HIDE_DEPRECATION_WARNING":false,"AMEND_ROUTE_PUBLIC":true,"SEAL_FILENAME":"seal.png","SHOPPING_CART":true,"ALLOW_PAYMENT_UPDATE_WITH_EMPTY_CART":true,"RA_EMAIL":true,"RA_WEBSITE":true,"RA_NO_DEFAULT_TYPE":true,"RA_ADDRESS_LABEL":"Street Address","RA_TYPE_SELECTION_DEFAULT":true,"RA_DEFAULT_TYPE":"460","RA_OVERRIDE_TYPE_WITH_DEFAULT":true,"RA_PRINCIPAL_ADDRESS_AMS":true,"UPLOAD_AND_SUBMIT_HIDE_IF_ONE_OPTION":true,"PAYMENT_PROCESSING_MESSAGE":"Your payment is processing - Do not close your browser or click the back button","CHECKOUT_BUTTON_WHEN_PROCESSING_TEXT":"Processing","EFS_CROP_PICKER_NONE_LABEL":"Lien Duration","DISALLOWED_WIZARD_PIECES":["FormationLocale"],"REPEATER_SHOW_EDIT_BUTTON":true,"DATA_REQUEST_PAGE_TITLE":"Data Requests and Subscriptions","DATA_REQUEST_SIDEBAR_LABEL":"Data Requests & Subscriptions","LOGIN_REDIRECTS_TO_EPASS":false,"LOGIN_REDIRECTS_TO_ACTIVE_DIRECTORY":true,"LOGIN_ACTIVE_DIRECTORY_LINK":true,"FETCH_EDIT_USER_LINK":false,"LISTS_FETCH_AVAILABLE_LISTS":true,"POST_WIZARD_SUBMIT_REDIRECT_URL":"/","PIN_REQUEST_ATTESTATIONS":true,"PIN_REQUEST_DESCRIPTION":"Click **Request PIN** to have a new PIN sent to the account holder's email address on file.","OWNERSHIP_REQUEST_DESCRIPTION":"To become an **authorized user** of this record, a current **AUTHORIZED USER** will need to grant you access. To request access, click **Request Access** below.","PIN_REQUEST_SUCCESS_MESSAGE":"The PIN you have requested for this entity has been sent to the email associated with your user account.  You should receive the PIN in approximately 3-5 minutes, depending on your email service provider.","APOSTILLE_HEADER_LABEL":"Verification Information","APOSTILLE_NUMBER_LABEL":"Apostille/Authentication","APOSTILLE_CITY_STATE_OVERRIDE":"HELENA, MT","APOSTILLE_FILING_DATE_LABEL":"Issue Date","APOSTILLE_CITY_STATE_IN_CERTIFIED":true,"NOTARY_EXISTING_FILING":true,"ALLOW_REVOKE_OWN_ACCESS_ONLY":false,"HIDE_CANCEL_ON_ONETIME_DATA_REQUESTS":true,"DATA_REQUESTS_IN_SHOPPING_CART":true,"WQ_ALLOW_EDIT_PENDING_PAYMENT":true,"WQ_CONFIRM_ON_DELETE":true,"WQ_DELETE_CONFIRM_MESSAGE":"Deleting this filing will forfeit any money already paid to the Secretary of State. This action is permanent and cannot be undone, are you sure you would like to delete?","PASS_ITEM_GUIDS_ON_CHECKOUT":true,"FORM_REVISION_HISTORY":true,"CHECKOUT_DISCLAIMER":"By entering your credit card and/or checking account information you (i) state that **you are an authorized user** of the credit card and/or electronic check and that the associated information entered (e.g., account holder name, account number, billing address) is accurate, (ii) **you authorize payment processor to charge the amount you have requested** to your credit card and/or funding account, and (iii) **acknowledge if a charge is declined or reversed you may also be assessed a customary charge** by the payment processor for such transactions.","FARM_BILL_SEARCH_CONFIDENTIAL":"As a registered Farm Bill Buyer with the Montana Secretary of State’s office it is important to maintain the confidentiality of the information contained within the Farm Bill Master List. The Farm Bill Master List reflects personal data, such as Social Security Numbers, which are a key piece of personal identifiable information to assist you in determining the existence of a lien against a specific debtor. The distribution of this information beyond its intended purpose is strictly prohibited.\n\n**The debtor's tax identification number has been hidden for confidentiality reasons. You may continue to search on a tax ID number and return debtors that match your search criteria. The SSN/FEIN must be entered without dashes or spaces.  If you need access to the tax identification number to clearly identify the debtor, please contact the UCC unit at (406) 444-3665.**","VIEW_HISTORY_BUTTON_ALT_TEXT":"View Filings","WIZARD_ERROR_TITLE_MESSAGE":"Form Error","FARM_BILL_SEARCH_INTERACTIVE":true,"USE_FARM_BILL_API":true,"DISALLOW_ASSIGN_SELF_AS_RA":true,"DISALLOW_ASSIGN_SELF_AS_PRINCIPAL":true,"USE_TRADEMARK_OWNER_VALIDATION":true,"USE_ALTERNATIVE_FOREIGN_ADDRESS_LABELS":true,"MY_RECEIPTS_FILTER":[{"type":"dateRange","name":"DATE_RANGE","label":"Date range","defaultValue":{"start":null,"end":null}},{"type":"text","name":"REF_NUM","defaultValue":"","label":"Reference Number"},{"type":"text","name":"RECEIPT_NUM","defaultValue":"","label":"Receipt Id"},{"type":"text","name":"AMOUNT","defaultValue":"","label":"Amount"},{"type":"select","name":"TYPE","defaultValue":"","label":"Payment Type","options":[{"value":"","label":"All"},{"value":"CC","label":"Credit Card"},{"value":"Check","label":"Check"}]}],"MY_RECEIPTS_SHOW_IN_SIDEBAR":true,"SHOW_MY_RECEIPTS_HELPER_TEXT":true,"MY_RECEIPTS_HELPER_LABEL":"About Receipt Search","MY_RECEIPTS_HELPER_TEXT":"You can search for receipts based on their descriptions, including the items paid for on the receipt. Use the filters to search for or filter specific information.","FARM_BILL_SUBLINK":{"label":"Farm Bill","component":"FarmBill","parameter":"farm-bill","path":"/lists/farm-bill","sourceTypeId":0,"myRecordsSearch":false,"allowedRules":["/search/"],"disabled":true,"searchDescription":"To perform a search, enter a debtor name. Your search results may include: exact debtor name, variations of that name and any filing that includes your search criteria. Punctuation is ignored.\n\nYou can click on \"Advanced\" to refine your search. Under “Advanced” you can search by crop, year, county and SSN/FEIN. As a registered Farm Bill Buyer with the Montana Secretary of State’s office it is important to maintain the confidentiality of the information contained within the Farm Bill Master List. The Farm Bill Master List reflects personal data, such as Social Security Numbers, which are a key piece of personal identifiable information to assist you in determining the existence of a lien against a specific debtor. The distribution of this information beyond its intended purpose is strictly prohibited.\n\nThe debtor's tax identification number has been hidden for confidentiality reasons. You may continue to search on a tax ID number and return debtors that match your search criteria. The SSN/FEIN must be entered without dashes or spaces.","searchMustHaveOneOf":["search","UCC_FARM_PRODUCT_ID","COUNTY"],"searchPlaceholder":"Search by debtor name","advancedSearchParameters":[{"type":"ServerMultiComplete","label":"Product code name(s)","name":"UCC_FARM_PRODUCT_ID","defaultValue":"","optionsSrc":"UCC_FARM_PRODUCT_V"},{"type":"MultiComplete","label":"Year or Range of Years","name":"YEAR_NUM","optionsSrc":"years","startYear":"1968","defaultValue":[],"preMergeOptions":[{"value":"ALL","label":"All"}]},{"type":"serverSelect","label":"State","name":"STATE","defaultValue":"MONTANA","optionsSrc":"STATE"},{"type":"ServerMultiComplete","label":"County","name":"COUNTY","defaultValue":[],"optionsSrc":"COUNTY","overrideSubOptionsSrcFromParameterName":"STATE"},{"type":"checkbox","name":"TIN_SEARCH_YN","defaultValue":false,"label":"Tax Identification Number Search"},{"type":"checkbox","name":"TIN_SORT_YN","defaultValue":false,"label":"Unique ID Sort"}]},"ALLOW_ADDRESS_VALIDATION_BYPASS_OPTION":true,"DEFAULT_ADDRESS_VALIDATION_BYPASS_OPTION_CHECKED":true}).OWNERSHIP_REQUEST_SUCCESSFUL_MESSAGE;
	var HIDE_REQUIRED_PIN_ATTESTATION_MESSAGE = ({"NODE_ENV":"production","BUILD_DATE":"2025-08-27T15:15:31.687Z","BUILD_NUMBER":"Not Provided","GIT_VERSION":"v1.3.0-381-ga81e29b08","GIT_COMMIT_HASH":"a81e29b085c9268ffd96c78eb734365802722741","GIT_BRANCH":"beta","PUBLIC_URL":"","STATE_ABBR":"MT","STATE_NAME":"Montana","STATE_ORG_TITLE":"Secretary of State","LOGIN_HEADER_IMG_PATH":"","HOME_IMG_FILENAME":"montana.jpg","FAVICON_FILE_NAME":"favicon.ico","ALLOW_E_SIGN_ON_CORRECTIONS":true,"THIRD_PARTY_SIGNING_ALLOWED":false,"MY_ACCOUNT_SAVE_AND_CLOSE_BUTTON":true,"IE_DEPRECATED_MESSAGE":"Internet Explorer is not supported. Please select a supported browser below to access this website.","ADDITIONAL_ROUTES":{"dataRequests":true,"farmBill":true,"apostille":true,"externalHelp":"https://sosmt.gov/business/help-center/","systemAdministration":[{"title":"Saved Payments","parameter":"saved-payments","componentName":"SavedPayments"}]},"SUBROUTES":[{"label":"Business","component":"Business","parameter":"business","myWorkQueueSearch":false,"sourceTypeId":54,"searchMustHaveOneOf":["FILING_TYPE_ID","STATUS_ID","STATE","search"],"serverWebSearchDescription":true,"serverWorkQueueDescription":true,"serverMyRecordsDescription":true,"searchPlaceholder":"Search by name or filing number (X########)","allowEmptySearchTerm":true,"requestCertificateAlternateLabel":"Request Information","fileAmendmentButtonLabel":"Filing Actions","advancedSearchParameters":[{"type":"radio","name":"QUERY_TYPE_ID","defaultValue":1010,"options":[{"value":1010,"label":"Starts with"},{"value":1011,"label":"Contains"},{"value":1012,"label":" Word Contains"}]},{"type":"serverSelect","name":"FILING_TYPE_ID","optionsSrc":"FILING_TYPES","label":"Entity Type","placeholder":"All","defaultValue":"0"},{"type":"serverSelect","name":"FILING_SUBTYPE_ID","optionsSrc":"FILING_SUBTYPES","label":"Entity Subtype","overrideSubOptionsSrcFromParameterName":"FILING_TYPE_ID","placeholder":"All","defaultValue":"0"},{"type":"serverSelect","name":"STATUS_ID","optionsSrc":"FILING_STATUS_WITHOUT_ALL","label":"Status","placeholder":"All","defaultValue":"0"},{"type":"serverSelect","name":"STATE","optionsSrc":"STATE","label":"State","placeholder":"All","defaultValue":""},{"type":"serverSelect","name":"COUNTY","optionsSrc":"COUNTY_SUBOPTION","label":"County","overrideSubOptionsSrcFromParameterName":"STATE","placeholder":"All","defaultValue":""},{"type":"checkbox","name":"CRA_SEARCH_YN","defaultValue":false,"label":"Search by Registered Agent PID"},{"type":"dateRange","name":"FILING_DATE","label":"Registration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}},{"type":"dateRange","name":"EXPIRATION_DATE","label":"Expiration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}}],"myRecordsFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Active"},{"value":2,"label":"Inactive"},{"value":3,"label":"Pending"}]},{"type":"dateRange","name":"DATE_RANGE","label":"Date range","defaultValue":{"start":null,"end":null}}],"myWorkQueueFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Approved"},{"value":2,"label":"Pending Online Payment"},{"value":3,"label":"Pending Review"},{"value":4,"label":"Needs Correction"},{"value":5,"label":"Rejected"},{"value":6,"label":"Draft"}]},{"type":"dateRange","name":"DATE_RANGE","label":"Date range","defaultValue":{"start":null,"end":null}}]},{"label":"Notary","component":"Notary","parameter":"notary","sourceTypeId":850,"myWorkQueueSearch":false,"allowEmptySearchTerm":true,"requestCertificateAlternateLabel":"Download Certificate","fileAmendmentButtonLabel":"Filing Actions","hideNameRequestCertificate":true,"hideAddressRequestCertificate":true,"hideRecordUserManagment":true,"searchPlaceholder":"Search by name or commission number","searchMustHaveOneOf":["CITY","search","SERVICE_TYPE"],"advancedParametersStartOpen":true,"searchIsSortable":true,"advancedSearchParameters":[{"type":"radio","name":"STARTS_WITH_YN","defaultValue":false,"options":[{"value":true,"label":"Starts with"},{"value":false,"label":"Contains"}]},{"type":"checkbox","name":"ACTIVE_ONLY_YN","defaultValue":true,"label":"Active entities only"},{"type":"text","name":"CITY","defaultValue":"","label":"City"},{"type":"select","name":"SERVICE_TYPE","label":"Special Services Offered","defaultValue":0,"options":[{"value":0,"label":"(N/A)"},{"value":6165,"label":"In-Person Electronic Notarization (IPEN)"},{"value":6166,"label":"Remote Online Notarization (RON)"},{"value":6167,"label":"Mobile Notary Services"},{"value":6168,"label":"Remote Ink Notarization (RIN)"}]}]},{"label":"Apostille","component":"Apostille","parameter":"apostille","sourceTypeId":720,"myRecordsSearch":false,"myWorkQueueSearch":false,"disabled":false,"allowedRoutes":["/forms-manager/","/queue/","/forms/"]},{"label":"Liens","component":"UCC","parameter":"ucc","sourceTypeId":1999,"myRecordsSearch":true,"myWorkQueueSearch":true,"fileAmendmentButtonLabel":"Filing Actions","searchPlaceholder":"Search by name or file number","disabled":false,"serverWebSearchDescription":true,"myRecordsDescription":"","workQueueDescription":"","searchDescription":"","hideRecordUserManagment":true,"searchLiensCheckout":false,"advancedSearchParameters":[{"type":"radio","name":"STARTS_WITH_YN","defaultValue":false,"options":[{"value":true,"label":"Starts with"},{"value":false,"label":"Contains"}]},{"type":"select","name":"STATUS","defaultValue":"ALL","label":"Status","options":[{"value":"ACTIVE_UNLAPSED","label":"Active (unlapsed)"},{"value":"ACTIVE_LAPSED_UNLAPSED","label":"Active (lapsed and unlapsed)"}]},{"type":"text","name":"EXCLUDE_VALUES","label":"Exclude Debtor Names (comma separated list of names to exclude)","defaultValue":""},{"type":"dateRange","name":"FILING_DATE","label":"Financing Statement Date","defaultValue":{"start":null,"end":null}},{"type":"dateRange","name":"LAPSE_DATE","label":"Lapse Date","defaultValue":{"start":null,"end":null}},{"type":"text","name":"CITY","label":"Debtor City","defaultValue":""}],"myRecordsFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Approved"},{"value":2,"label":"Pending Online Payment"},{"value":3,"label":"Pending Review"}]},{"type":"select","name":"TYPE","defaultValue":0,"label":"Lien Type","options":[{"value":0,"label":"All"},{"value":1,"label":"UCC"},{"value":2,"label":"EFS"},{"value":3,"label":"Title 71"}]}],"myWorkQueueFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Approved"},{"value":2,"label":"Pending Online Payment"},{"value":3,"label":"Pending Review"},{"value":4,"label":"Pending Print and Mail"},{"value":5,"label":"Rejected"},{"value":6,"label":"Draft"}]},{"type":"select","name":"TYPE","defaultValue":0,"label":"Lien Type","options":[{"value":0,"label":"All"},{"value":1,"label":"UCC"},{"value":2,"label":"EFS"},{"value":3,"label":"Title 71"}]}]},{"label":"Copy Request","component":"copies","parameter":"copies","sourceTypeId":2001,"myRecordsSearch":false,"myWorkQueueSearch":false,"disabled":false,"allowedRoutes":["/forms-manager/","/queue/","/forms/"]},{"label":"Trademark","component":"Trademark","parameter":"trademark","sourceTypeId":810,"showRequestCertificate":true,"searchMustHaveOneOf":["search","EXPIRATION_DATE","FILING_DATE"],"allowEmptySearchTerm":true,"requestCertificateAlternateLabel":"Request Information","fileAmendmentButtonLabel":"Filing Actions","advancedSearchParameters":[{"type":"radio","name":"QUERY_TYPE_ID","defaultValue":1010,"options":[{"value":1010,"label":"Starts with"},{"value":1011,"label":"Contains"},{"value":1012,"label":" Word Contains"}]},{"type":"checkbox","name":"OWNER_SEARCH_YN","defaultValue":false,"label":"Search owners"},{"type":"radio","name":"SERVICE_MARK_YN","label":"Mark Type","defaultValue":"","options":[{"value":"","label":"All Marks"},{"value":"Y","label":"Service Mark"},{"value":"N","label":"Trademark"}]},{"type":"serverSelect","name":"STATUS_ID","optionsSrc":"TYPE_V|TRADEMARK_STATUS_TYPE","label":"Status","placeholder":"All","defaultValue":"0"},{"type":"select","name":"DESIGN_TYPE_ID","options":[{"value":0,"label":"All"},{"value":990,"label":"Words Only"},{"value":991,"label":"Design Only"},{"value":992,"label":"Words and Design"}],"label":"Design Type","defaultValue":"0"},{"type":"dateRange","name":"FILING_DATE","label":"Registered Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}},{"type":"dateRange","name":"EXPIRATION_DATE","label":"Expiration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}}]},{"label":"Business Info Request","component":"InfoRequests","parameter":"info-request","sourceTypeId":167,"allowedRoutes":["/forms-manager/","/queue/","/forms/"]},{"label":"Data Requests","component":"DataRequests","parameter":"data-request","sourceTypeId":0,"allowedRoutes":["/forms-manager/"]},{"label":"CRA","component":"CRA","parameter":"cra","sourceTypeId":157,"myRecordsSearch":false,"searchPlaceholder":"Search by name or registered agent number","allowedRoutes":["/forms-manager/","/forms/","/records/","/queue/","/search/"],"allowEmptySearchTerm":true,"fileAmendmentButtonLabel":"Filing Actions","advancedSearchParameters":[{"type":"radio","name":"QUERY_TYPE_ID","defaultValue":1010,"options":[{"value":1010,"label":"Starts with"},{"value":1011,"label":"Contains"},{"value":1012,"label":" Word Contains"}]},{"type":"dateRange","name":"CRA_DATE","label":"Registration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}},{"type":"select","name":"STATUS_ID","label":"Status","defaultValue":0,"options":[{"value":0,"label":"All"},{"value":121,"label":"Active"},{"value":122,"label":"Inactive"}]},{"type":"select","name":"AGENT_TYPE_ID","label":"Agent Type","defaultValue":0,"options":[{"value":0,"label":"All"},{"value":460,"label":"Registered Agent"},{"value":461,"label":"Commercial Registered Agent"}]}]},{"label":"Farm Bill","component":"FarmBill","parameter":"farm-bill","path":"/lists/farm-bill","sourceTypeId":0,"myRecordsSearch":false,"allowedRules":["/search/"],"disabled":true,"searchDescription":"To perform a search, enter a debtor name. Your search results may include: exact debtor name, variations of that name and any filing that includes your search criteria. Punctuation is ignored.\n\nYou can click on \"Advanced\" to refine your search. Under “Advanced” you can search by crop, year, county and SSN/FEIN. As a registered Farm Bill Buyer with the Montana Secretary of State’s office it is important to maintain the confidentiality of the information contained within the Farm Bill Master List. The Farm Bill Master List reflects personal data, such as Social Security Numbers, which are a key piece of personal identifiable information to assist you in determining the existence of a lien against a specific debtor. The distribution of this information beyond its intended purpose is strictly prohibited.\n\nThe debtor's tax identification number has been hidden for confidentiality reasons. You may continue to search on a tax ID number and return debtors that match your search criteria. The SSN/FEIN must be entered without dashes or spaces.","searchMustHaveOneOf":["search","UCC_FARM_PRODUCT_ID","COUNTY"],"searchPlaceholder":"Search by debtor name","advancedSearchParameters":[{"type":"ServerMultiComplete","label":"Product code name(s)","name":"UCC_FARM_PRODUCT_ID","defaultValue":"","optionsSrc":"UCC_FARM_PRODUCT_V"},{"type":"MultiComplete","label":"Year or Range of Years","name":"YEAR_NUM","optionsSrc":"years","startYear":"1968","defaultValue":[],"preMergeOptions":[{"value":"ALL","label":"All"}]},{"type":"serverSelect","label":"State","name":"STATE","defaultValue":"MONTANA","optionsSrc":"STATE"},{"type":"ServerMultiComplete","label":"County","name":"COUNTY","defaultValue":[],"optionsSrc":"COUNTY","overrideSubOptionsSrcFromParameterName":"STATE"},{"type":"checkbox","name":"TIN_SEARCH_YN","defaultValue":false,"label":"Tax Identification Number Search"},{"type":"checkbox","name":"TIN_SORT_YN","defaultValue":false,"label":"Unique ID Sort"}]}],"SYSTEM_NICKNAME":"Online Services Portal","PAYMENT_METHODS":[{"type":"bypass"},{"type":"iTransact"}],"PAYMENT_ALLOW_AMEX":true,"SYSTEM_ID_LABEL":"System Id","DOUBLE_COLUMN_PUBLIC_LOGIN":true,"INTERNAL_USER_MANAGEMENT":true,"ALLOW_PUBLIC_JSON_IMPORT":false,"MAX_FILE_UPLOAD_SIZE":10000000,"REFUND_TEXT":"","RETURN_TO_HOME_ON_LOGOUT":true,"CURRENT_SOS_NAME":"Christi Jacobsen","LOGO_FILENAME":"mt-sos-logo.png","LOGO_ALT":"Christi Jacobsen, Montana Secretary of State","LOGO_FULL_WIDTH":true,"HOME_HIDE_AUTH_HINT":true,"HOME_TITLE":"Montana Secretary of State","CUSTOM_TAB_TITLE":"Official Montana","HOME_SUBTITLE":"Online Business Services","ENTITY_NAME_CONSENT_DESCRIPTION":"","ALLOW_USER_PROFILE_EDITING":true,"COMPARE_FOREIGN_NAME_IN_ENTITY_NAME_VALIDATION":true,"FOREIGN_NAME_FIELD_NAME":"KIMA_PARENT_NAME_INFO","LOGIN_TITLE":"Montana Secretary of State Online Filing Portal Login","PUBLIC_LOGIN_LABEL":"Username","REVERSE_LOGIN_COLUMNS":true,"LOGIN_SEAL_FILENAME":"seal_white.png","SEPARATE_USERNAME_AND_EMAIL":true,"CREATE_ACCOUNT_BUTTON_ALIGN_LEFT":true,"CREATE_ACCOUNT_BUTTON_TEXT":"CREATE AN ACCOUNT","PASSWORD_CUSTOM_ERROR_TEXT":"The password must meet all requirements","ACCOUNT_CREATED_MESSAGE":"Please check your email to verify your account to login and allow a few minutes for this message to arrive. Check your junk/spam folders if you do not find the email in your inbox.","PUBLIC_LOGIN_PLACEHOLDER":" ","DISABLE_DEFAULT_PAYMENT_RADIO":true,"CUSTOM_RESET_PASSWORD_ERROR_MESSAGE":"Username invalid - no account found","PUBLIC_LOGIN_CREATE_DESCRIPTION":"### Existing User:\n\n  - Enter your username and password to login.  \n\n\n  #### - OR -  \n\n\n\n  - Forgot password? Click 'Reset Password' and follow the prompts.\n  - Forgot username? Click 'Forgot Username' and follow the prompts.  \n\n\n  ### New User:\n  ","LOGIN_HELP_LINK":"https://sosmt.gov/business/how-do-i/","LOGIN_HELP_LINK_TEXT":"Need Help?","FORGOT_USERNAME_TEXT":"Forgot Username?","LOGIN_ACTIVE_DIRECTORY_TEXT":"State User Login","MULTIPLE_LOGIN_METHODS":true,"HAS_ACTIVE_DIRECTORY_LOGIN":true,"RESET_PASSWORD_WITH_USERNAME":true,"DOWNLOAD_LINK":true,"SHOW_USERNAME_ACCOUNT_CREATE":true,"SHOW_SCROLL_DOWN_ARROW":true,"SHOW_ADDRESS_ACCOUNT_CREATE":true,"TWO_COLUMN_ACCOUNT_CREATE":true,"RESET_PASSWORD_TIP":"A link to change your password has been sent to your email. Please allow a few minutes for this message to arrive. Please check your junk/spam folders if you do not find the email in your inbox.","FORGOT_PASSWORD_LINK_TEXT":"Reset Password","PHONE_NUMBER_OPTIONAL_ACCOUNT_CREATE":true,"SHOW_REQUIRED_INDICATOR_ACCOUNT_CREATE":true,"PASSWORD_REQUIREMENTS_ACCOUNT_CREATE":"\n    <ul>\n      <li>MUST contain at least 8 characters (12+ recommended)</li>\n      <li>MUST contain at least one uppercase letter.</li>\n      <li>MUST contain at least one lowercase letter.</li>\n      <li>MUST contain at least one number.</li>\n      <li>MUST contain at least one special character (!”#$%&'()*+,-./:;<=>?</li>\n    </ul>\n  ","ALLOW_CERTIFICATION_REQUEST":true,"ALLOW_PUBLIC_CERTIFICATE_REQUEST":true,"ALLOW_COPY_REQUEST":false,"ALLOW_CORRECTION_STYLING":true,"HIDE_DEPRECATION_WARNING":false,"AMEND_ROUTE_PUBLIC":true,"SEAL_FILENAME":"seal.png","SHOPPING_CART":true,"ALLOW_PAYMENT_UPDATE_WITH_EMPTY_CART":true,"RA_EMAIL":true,"RA_WEBSITE":true,"RA_NO_DEFAULT_TYPE":true,"RA_ADDRESS_LABEL":"Street Address","RA_TYPE_SELECTION_DEFAULT":true,"RA_DEFAULT_TYPE":"460","RA_OVERRIDE_TYPE_WITH_DEFAULT":true,"RA_PRINCIPAL_ADDRESS_AMS":true,"UPLOAD_AND_SUBMIT_HIDE_IF_ONE_OPTION":true,"PAYMENT_PROCESSING_MESSAGE":"Your payment is processing - Do not close your browser or click the back button","CHECKOUT_BUTTON_WHEN_PROCESSING_TEXT":"Processing","EFS_CROP_PICKER_NONE_LABEL":"Lien Duration","DISALLOWED_WIZARD_PIECES":["FormationLocale"],"REPEATER_SHOW_EDIT_BUTTON":true,"DATA_REQUEST_PAGE_TITLE":"Data Requests and Subscriptions","DATA_REQUEST_SIDEBAR_LABEL":"Data Requests & Subscriptions","LOGIN_REDIRECTS_TO_EPASS":false,"LOGIN_REDIRECTS_TO_ACTIVE_DIRECTORY":true,"LOGIN_ACTIVE_DIRECTORY_LINK":true,"FETCH_EDIT_USER_LINK":false,"LISTS_FETCH_AVAILABLE_LISTS":true,"POST_WIZARD_SUBMIT_REDIRECT_URL":"/","PIN_REQUEST_ATTESTATIONS":true,"PIN_REQUEST_DESCRIPTION":"Click **Request PIN** to have a new PIN sent to the account holder's email address on file.","OWNERSHIP_REQUEST_DESCRIPTION":"To become an **authorized user** of this record, a current **AUTHORIZED USER** will need to grant you access. To request access, click **Request Access** below.","PIN_REQUEST_SUCCESS_MESSAGE":"The PIN you have requested for this entity has been sent to the email associated with your user account.  You should receive the PIN in approximately 3-5 minutes, depending on your email service provider.","APOSTILLE_HEADER_LABEL":"Verification Information","APOSTILLE_NUMBER_LABEL":"Apostille/Authentication","APOSTILLE_CITY_STATE_OVERRIDE":"HELENA, MT","APOSTILLE_FILING_DATE_LABEL":"Issue Date","APOSTILLE_CITY_STATE_IN_CERTIFIED":true,"NOTARY_EXISTING_FILING":true,"ALLOW_REVOKE_OWN_ACCESS_ONLY":false,"HIDE_CANCEL_ON_ONETIME_DATA_REQUESTS":true,"DATA_REQUESTS_IN_SHOPPING_CART":true,"WQ_ALLOW_EDIT_PENDING_PAYMENT":true,"WQ_CONFIRM_ON_DELETE":true,"WQ_DELETE_CONFIRM_MESSAGE":"Deleting this filing will forfeit any money already paid to the Secretary of State. This action is permanent and cannot be undone, are you sure you would like to delete?","PASS_ITEM_GUIDS_ON_CHECKOUT":true,"FORM_REVISION_HISTORY":true,"CHECKOUT_DISCLAIMER":"By entering your credit card and/or checking account information you (i) state that **you are an authorized user** of the credit card and/or electronic check and that the associated information entered (e.g., account holder name, account number, billing address) is accurate, (ii) **you authorize payment processor to charge the amount you have requested** to your credit card and/or funding account, and (iii) **acknowledge if a charge is declined or reversed you may also be assessed a customary charge** by the payment processor for such transactions.","FARM_BILL_SEARCH_CONFIDENTIAL":"As a registered Farm Bill Buyer with the Montana Secretary of State’s office it is important to maintain the confidentiality of the information contained within the Farm Bill Master List. The Farm Bill Master List reflects personal data, such as Social Security Numbers, which are a key piece of personal identifiable information to assist you in determining the existence of a lien against a specific debtor. The distribution of this information beyond its intended purpose is strictly prohibited.\n\n**The debtor's tax identification number has been hidden for confidentiality reasons. You may continue to search on a tax ID number and return debtors that match your search criteria. The SSN/FEIN must be entered without dashes or spaces.  If you need access to the tax identification number to clearly identify the debtor, please contact the UCC unit at (406) 444-3665.**","VIEW_HISTORY_BUTTON_ALT_TEXT":"View Filings","WIZARD_ERROR_TITLE_MESSAGE":"Form Error","FARM_BILL_SEARCH_INTERACTIVE":true,"USE_FARM_BILL_API":true,"DISALLOW_ASSIGN_SELF_AS_RA":true,"DISALLOW_ASSIGN_SELF_AS_PRINCIPAL":true,"USE_TRADEMARK_OWNER_VALIDATION":true,"USE_ALTERNATIVE_FOREIGN_ADDRESS_LABELS":true,"MY_RECEIPTS_FILTER":[{"type":"dateRange","name":"DATE_RANGE","label":"Date range","defaultValue":{"start":null,"end":null}},{"type":"text","name":"REF_NUM","defaultValue":"","label":"Reference Number"},{"type":"text","name":"RECEIPT_NUM","defaultValue":"","label":"Receipt Id"},{"type":"text","name":"AMOUNT","defaultValue":"","label":"Amount"},{"type":"select","name":"TYPE","defaultValue":"","label":"Payment Type","options":[{"value":"","label":"All"},{"value":"CC","label":"Credit Card"},{"value":"Check","label":"Check"}]}],"MY_RECEIPTS_SHOW_IN_SIDEBAR":true,"SHOW_MY_RECEIPTS_HELPER_TEXT":true,"MY_RECEIPTS_HELPER_LABEL":"About Receipt Search","MY_RECEIPTS_HELPER_TEXT":"You can search for receipts based on their descriptions, including the items paid for on the receipt. Use the filters to search for or filter specific information.","FARM_BILL_SUBLINK":{"label":"Farm Bill","component":"FarmBill","parameter":"farm-bill","path":"/lists/farm-bill","sourceTypeId":0,"myRecordsSearch":false,"allowedRules":["/search/"],"disabled":true,"searchDescription":"To perform a search, enter a debtor name. Your search results may include: exact debtor name, variations of that name and any filing that includes your search criteria. Punctuation is ignored.\n\nYou can click on \"Advanced\" to refine your search. Under “Advanced” you can search by crop, year, county and SSN/FEIN. As a registered Farm Bill Buyer with the Montana Secretary of State’s office it is important to maintain the confidentiality of the information contained within the Farm Bill Master List. The Farm Bill Master List reflects personal data, such as Social Security Numbers, which are a key piece of personal identifiable information to assist you in determining the existence of a lien against a specific debtor. The distribution of this information beyond its intended purpose is strictly prohibited.\n\nThe debtor's tax identification number has been hidden for confidentiality reasons. You may continue to search on a tax ID number and return debtors that match your search criteria. The SSN/FEIN must be entered without dashes or spaces.","searchMustHaveOneOf":["search","UCC_FARM_PRODUCT_ID","COUNTY"],"searchPlaceholder":"Search by debtor name","advancedSearchParameters":[{"type":"ServerMultiComplete","label":"Product code name(s)","name":"UCC_FARM_PRODUCT_ID","defaultValue":"","optionsSrc":"UCC_FARM_PRODUCT_V"},{"type":"MultiComplete","label":"Year or Range of Years","name":"YEAR_NUM","optionsSrc":"years","startYear":"1968","defaultValue":[],"preMergeOptions":[{"value":"ALL","label":"All"}]},{"type":"serverSelect","label":"State","name":"STATE","defaultValue":"MONTANA","optionsSrc":"STATE"},{"type":"ServerMultiComplete","label":"County","name":"COUNTY","defaultValue":[],"optionsSrc":"COUNTY","overrideSubOptionsSrcFromParameterName":"STATE"},{"type":"checkbox","name":"TIN_SEARCH_YN","defaultValue":false,"label":"Tax Identification Number Search"},{"type":"checkbox","name":"TIN_SORT_YN","defaultValue":false,"label":"Unique ID Sort"}]},"ALLOW_ADDRESS_VALIDATION_BYPASS_OPTION":true,"DEFAULT_ADDRESS_VALIDATION_BYPASS_OPTION_CHECKED":true}).HIDE_REQUIRED_PIN_ATTESTATION_MESSAGE;
	var HIDE_ICON_CIRCLE_CHECK = ({"NODE_ENV":"production","BUILD_DATE":"2025-08-27T15:15:31.687Z","BUILD_NUMBER":"Not Provided","GIT_VERSION":"v1.3.0-381-ga81e29b08","GIT_COMMIT_HASH":"a81e29b085c9268ffd96c78eb734365802722741","GIT_BRANCH":"beta","PUBLIC_URL":"","STATE_ABBR":"MT","STATE_NAME":"Montana","STATE_ORG_TITLE":"Secretary of State","LOGIN_HEADER_IMG_PATH":"","HOME_IMG_FILENAME":"montana.jpg","FAVICON_FILE_NAME":"favicon.ico","ALLOW_E_SIGN_ON_CORRECTIONS":true,"THIRD_PARTY_SIGNING_ALLOWED":false,"MY_ACCOUNT_SAVE_AND_CLOSE_BUTTON":true,"IE_DEPRECATED_MESSAGE":"Internet Explorer is not supported. Please select a supported browser below to access this website.","ADDITIONAL_ROUTES":{"dataRequests":true,"farmBill":true,"apostille":true,"externalHelp":"https://sosmt.gov/business/help-center/","systemAdministration":[{"title":"Saved Payments","parameter":"saved-payments","componentName":"SavedPayments"}]},"SUBROUTES":[{"label":"Business","component":"Business","parameter":"business","myWorkQueueSearch":false,"sourceTypeId":54,"searchMustHaveOneOf":["FILING_TYPE_ID","STATUS_ID","STATE","search"],"serverWebSearchDescription":true,"serverWorkQueueDescription":true,"serverMyRecordsDescription":true,"searchPlaceholder":"Search by name or filing number (X########)","allowEmptySearchTerm":true,"requestCertificateAlternateLabel":"Request Information","fileAmendmentButtonLabel":"Filing Actions","advancedSearchParameters":[{"type":"radio","name":"QUERY_TYPE_ID","defaultValue":1010,"options":[{"value":1010,"label":"Starts with"},{"value":1011,"label":"Contains"},{"value":1012,"label":" Word Contains"}]},{"type":"serverSelect","name":"FILING_TYPE_ID","optionsSrc":"FILING_TYPES","label":"Entity Type","placeholder":"All","defaultValue":"0"},{"type":"serverSelect","name":"FILING_SUBTYPE_ID","optionsSrc":"FILING_SUBTYPES","label":"Entity Subtype","overrideSubOptionsSrcFromParameterName":"FILING_TYPE_ID","placeholder":"All","defaultValue":"0"},{"type":"serverSelect","name":"STATUS_ID","optionsSrc":"FILING_STATUS_WITHOUT_ALL","label":"Status","placeholder":"All","defaultValue":"0"},{"type":"serverSelect","name":"STATE","optionsSrc":"STATE","label":"State","placeholder":"All","defaultValue":""},{"type":"serverSelect","name":"COUNTY","optionsSrc":"COUNTY_SUBOPTION","label":"County","overrideSubOptionsSrcFromParameterName":"STATE","placeholder":"All","defaultValue":""},{"type":"checkbox","name":"CRA_SEARCH_YN","defaultValue":false,"label":"Search by Registered Agent PID"},{"type":"dateRange","name":"FILING_DATE","label":"Registration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}},{"type":"dateRange","name":"EXPIRATION_DATE","label":"Expiration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}}],"myRecordsFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Active"},{"value":2,"label":"Inactive"},{"value":3,"label":"Pending"}]},{"type":"dateRange","name":"DATE_RANGE","label":"Date range","defaultValue":{"start":null,"end":null}}],"myWorkQueueFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Approved"},{"value":2,"label":"Pending Online Payment"},{"value":3,"label":"Pending Review"},{"value":4,"label":"Needs Correction"},{"value":5,"label":"Rejected"},{"value":6,"label":"Draft"}]},{"type":"dateRange","name":"DATE_RANGE","label":"Date range","defaultValue":{"start":null,"end":null}}]},{"label":"Notary","component":"Notary","parameter":"notary","sourceTypeId":850,"myWorkQueueSearch":false,"allowEmptySearchTerm":true,"requestCertificateAlternateLabel":"Download Certificate","fileAmendmentButtonLabel":"Filing Actions","hideNameRequestCertificate":true,"hideAddressRequestCertificate":true,"hideRecordUserManagment":true,"searchPlaceholder":"Search by name or commission number","searchMustHaveOneOf":["CITY","search","SERVICE_TYPE"],"advancedParametersStartOpen":true,"searchIsSortable":true,"advancedSearchParameters":[{"type":"radio","name":"STARTS_WITH_YN","defaultValue":false,"options":[{"value":true,"label":"Starts with"},{"value":false,"label":"Contains"}]},{"type":"checkbox","name":"ACTIVE_ONLY_YN","defaultValue":true,"label":"Active entities only"},{"type":"text","name":"CITY","defaultValue":"","label":"City"},{"type":"select","name":"SERVICE_TYPE","label":"Special Services Offered","defaultValue":0,"options":[{"value":0,"label":"(N/A)"},{"value":6165,"label":"In-Person Electronic Notarization (IPEN)"},{"value":6166,"label":"Remote Online Notarization (RON)"},{"value":6167,"label":"Mobile Notary Services"},{"value":6168,"label":"Remote Ink Notarization (RIN)"}]}]},{"label":"Apostille","component":"Apostille","parameter":"apostille","sourceTypeId":720,"myRecordsSearch":false,"myWorkQueueSearch":false,"disabled":false,"allowedRoutes":["/forms-manager/","/queue/","/forms/"]},{"label":"Liens","component":"UCC","parameter":"ucc","sourceTypeId":1999,"myRecordsSearch":true,"myWorkQueueSearch":true,"fileAmendmentButtonLabel":"Filing Actions","searchPlaceholder":"Search by name or file number","disabled":false,"serverWebSearchDescription":true,"myRecordsDescription":"","workQueueDescription":"","searchDescription":"","hideRecordUserManagment":true,"searchLiensCheckout":false,"advancedSearchParameters":[{"type":"radio","name":"STARTS_WITH_YN","defaultValue":false,"options":[{"value":true,"label":"Starts with"},{"value":false,"label":"Contains"}]},{"type":"select","name":"STATUS","defaultValue":"ALL","label":"Status","options":[{"value":"ACTIVE_UNLAPSED","label":"Active (unlapsed)"},{"value":"ACTIVE_LAPSED_UNLAPSED","label":"Active (lapsed and unlapsed)"}]},{"type":"text","name":"EXCLUDE_VALUES","label":"Exclude Debtor Names (comma separated list of names to exclude)","defaultValue":""},{"type":"dateRange","name":"FILING_DATE","label":"Financing Statement Date","defaultValue":{"start":null,"end":null}},{"type":"dateRange","name":"LAPSE_DATE","label":"Lapse Date","defaultValue":{"start":null,"end":null}},{"type":"text","name":"CITY","label":"Debtor City","defaultValue":""}],"myRecordsFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Approved"},{"value":2,"label":"Pending Online Payment"},{"value":3,"label":"Pending Review"}]},{"type":"select","name":"TYPE","defaultValue":0,"label":"Lien Type","options":[{"value":0,"label":"All"},{"value":1,"label":"UCC"},{"value":2,"label":"EFS"},{"value":3,"label":"Title 71"}]}],"myWorkQueueFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Approved"},{"value":2,"label":"Pending Online Payment"},{"value":3,"label":"Pending Review"},{"value":4,"label":"Pending Print and Mail"},{"value":5,"label":"Rejected"},{"value":6,"label":"Draft"}]},{"type":"select","name":"TYPE","defaultValue":0,"label":"Lien Type","options":[{"value":0,"label":"All"},{"value":1,"label":"UCC"},{"value":2,"label":"EFS"},{"value":3,"label":"Title 71"}]}]},{"label":"Copy Request","component":"copies","parameter":"copies","sourceTypeId":2001,"myRecordsSearch":false,"myWorkQueueSearch":false,"disabled":false,"allowedRoutes":["/forms-manager/","/queue/","/forms/"]},{"label":"Trademark","component":"Trademark","parameter":"trademark","sourceTypeId":810,"showRequestCertificate":true,"searchMustHaveOneOf":["search","EXPIRATION_DATE","FILING_DATE"],"allowEmptySearchTerm":true,"requestCertificateAlternateLabel":"Request Information","fileAmendmentButtonLabel":"Filing Actions","advancedSearchParameters":[{"type":"radio","name":"QUERY_TYPE_ID","defaultValue":1010,"options":[{"value":1010,"label":"Starts with"},{"value":1011,"label":"Contains"},{"value":1012,"label":" Word Contains"}]},{"type":"checkbox","name":"OWNER_SEARCH_YN","defaultValue":false,"label":"Search owners"},{"type":"radio","name":"SERVICE_MARK_YN","label":"Mark Type","defaultValue":"","options":[{"value":"","label":"All Marks"},{"value":"Y","label":"Service Mark"},{"value":"N","label":"Trademark"}]},{"type":"serverSelect","name":"STATUS_ID","optionsSrc":"TYPE_V|TRADEMARK_STATUS_TYPE","label":"Status","placeholder":"All","defaultValue":"0"},{"type":"select","name":"DESIGN_TYPE_ID","options":[{"value":0,"label":"All"},{"value":990,"label":"Words Only"},{"value":991,"label":"Design Only"},{"value":992,"label":"Words and Design"}],"label":"Design Type","defaultValue":"0"},{"type":"dateRange","name":"FILING_DATE","label":"Registered Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}},{"type":"dateRange","name":"EXPIRATION_DATE","label":"Expiration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}}]},{"label":"Business Info Request","component":"InfoRequests","parameter":"info-request","sourceTypeId":167,"allowedRoutes":["/forms-manager/","/queue/","/forms/"]},{"label":"Data Requests","component":"DataRequests","parameter":"data-request","sourceTypeId":0,"allowedRoutes":["/forms-manager/"]},{"label":"CRA","component":"CRA","parameter":"cra","sourceTypeId":157,"myRecordsSearch":false,"searchPlaceholder":"Search by name or registered agent number","allowedRoutes":["/forms-manager/","/forms/","/records/","/queue/","/search/"],"allowEmptySearchTerm":true,"fileAmendmentButtonLabel":"Filing Actions","advancedSearchParameters":[{"type":"radio","name":"QUERY_TYPE_ID","defaultValue":1010,"options":[{"value":1010,"label":"Starts with"},{"value":1011,"label":"Contains"},{"value":1012,"label":" Word Contains"}]},{"type":"dateRange","name":"CRA_DATE","label":"Registration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}},{"type":"select","name":"STATUS_ID","label":"Status","defaultValue":0,"options":[{"value":0,"label":"All"},{"value":121,"label":"Active"},{"value":122,"label":"Inactive"}]},{"type":"select","name":"AGENT_TYPE_ID","label":"Agent Type","defaultValue":0,"options":[{"value":0,"label":"All"},{"value":460,"label":"Registered Agent"},{"value":461,"label":"Commercial Registered Agent"}]}]},{"label":"Farm Bill","component":"FarmBill","parameter":"farm-bill","path":"/lists/farm-bill","sourceTypeId":0,"myRecordsSearch":false,"allowedRules":["/search/"],"disabled":true,"searchDescription":"To perform a search, enter a debtor name. Your search results may include: exact debtor name, variations of that name and any filing that includes your search criteria. Punctuation is ignored.\n\nYou can click on \"Advanced\" to refine your search. Under “Advanced” you can search by crop, year, county and SSN/FEIN. As a registered Farm Bill Buyer with the Montana Secretary of State’s office it is important to maintain the confidentiality of the information contained within the Farm Bill Master List. The Farm Bill Master List reflects personal data, such as Social Security Numbers, which are a key piece of personal identifiable information to assist you in determining the existence of a lien against a specific debtor. The distribution of this information beyond its intended purpose is strictly prohibited.\n\nThe debtor's tax identification number has been hidden for confidentiality reasons. You may continue to search on a tax ID number and return debtors that match your search criteria. The SSN/FEIN must be entered without dashes or spaces.","searchMustHaveOneOf":["search","UCC_FARM_PRODUCT_ID","COUNTY"],"searchPlaceholder":"Search by debtor name","advancedSearchParameters":[{"type":"ServerMultiComplete","label":"Product code name(s)","name":"UCC_FARM_PRODUCT_ID","defaultValue":"","optionsSrc":"UCC_FARM_PRODUCT_V"},{"type":"MultiComplete","label":"Year or Range of Years","name":"YEAR_NUM","optionsSrc":"years","startYear":"1968","defaultValue":[],"preMergeOptions":[{"value":"ALL","label":"All"}]},{"type":"serverSelect","label":"State","name":"STATE","defaultValue":"MONTANA","optionsSrc":"STATE"},{"type":"ServerMultiComplete","label":"County","name":"COUNTY","defaultValue":[],"optionsSrc":"COUNTY","overrideSubOptionsSrcFromParameterName":"STATE"},{"type":"checkbox","name":"TIN_SEARCH_YN","defaultValue":false,"label":"Tax Identification Number Search"},{"type":"checkbox","name":"TIN_SORT_YN","defaultValue":false,"label":"Unique ID Sort"}]}],"SYSTEM_NICKNAME":"Online Services Portal","PAYMENT_METHODS":[{"type":"bypass"},{"type":"iTransact"}],"PAYMENT_ALLOW_AMEX":true,"SYSTEM_ID_LABEL":"System Id","DOUBLE_COLUMN_PUBLIC_LOGIN":true,"INTERNAL_USER_MANAGEMENT":true,"ALLOW_PUBLIC_JSON_IMPORT":false,"MAX_FILE_UPLOAD_SIZE":10000000,"REFUND_TEXT":"","RETURN_TO_HOME_ON_LOGOUT":true,"CURRENT_SOS_NAME":"Christi Jacobsen","LOGO_FILENAME":"mt-sos-logo.png","LOGO_ALT":"Christi Jacobsen, Montana Secretary of State","LOGO_FULL_WIDTH":true,"HOME_HIDE_AUTH_HINT":true,"HOME_TITLE":"Montana Secretary of State","CUSTOM_TAB_TITLE":"Official Montana","HOME_SUBTITLE":"Online Business Services","ENTITY_NAME_CONSENT_DESCRIPTION":"","ALLOW_USER_PROFILE_EDITING":true,"COMPARE_FOREIGN_NAME_IN_ENTITY_NAME_VALIDATION":true,"FOREIGN_NAME_FIELD_NAME":"KIMA_PARENT_NAME_INFO","LOGIN_TITLE":"Montana Secretary of State Online Filing Portal Login","PUBLIC_LOGIN_LABEL":"Username","REVERSE_LOGIN_COLUMNS":true,"LOGIN_SEAL_FILENAME":"seal_white.png","SEPARATE_USERNAME_AND_EMAIL":true,"CREATE_ACCOUNT_BUTTON_ALIGN_LEFT":true,"CREATE_ACCOUNT_BUTTON_TEXT":"CREATE AN ACCOUNT","PASSWORD_CUSTOM_ERROR_TEXT":"The password must meet all requirements","ACCOUNT_CREATED_MESSAGE":"Please check your email to verify your account to login and allow a few minutes for this message to arrive. Check your junk/spam folders if you do not find the email in your inbox.","PUBLIC_LOGIN_PLACEHOLDER":" ","DISABLE_DEFAULT_PAYMENT_RADIO":true,"CUSTOM_RESET_PASSWORD_ERROR_MESSAGE":"Username invalid - no account found","PUBLIC_LOGIN_CREATE_DESCRIPTION":"### Existing User:\n\n  - Enter your username and password to login.  \n\n\n  #### - OR -  \n\n\n\n  - Forgot password? Click 'Reset Password' and follow the prompts.\n  - Forgot username? Click 'Forgot Username' and follow the prompts.  \n\n\n  ### New User:\n  ","LOGIN_HELP_LINK":"https://sosmt.gov/business/how-do-i/","LOGIN_HELP_LINK_TEXT":"Need Help?","FORGOT_USERNAME_TEXT":"Forgot Username?","LOGIN_ACTIVE_DIRECTORY_TEXT":"State User Login","MULTIPLE_LOGIN_METHODS":true,"HAS_ACTIVE_DIRECTORY_LOGIN":true,"RESET_PASSWORD_WITH_USERNAME":true,"DOWNLOAD_LINK":true,"SHOW_USERNAME_ACCOUNT_CREATE":true,"SHOW_SCROLL_DOWN_ARROW":true,"SHOW_ADDRESS_ACCOUNT_CREATE":true,"TWO_COLUMN_ACCOUNT_CREATE":true,"RESET_PASSWORD_TIP":"A link to change your password has been sent to your email. Please allow a few minutes for this message to arrive. Please check your junk/spam folders if you do not find the email in your inbox.","FORGOT_PASSWORD_LINK_TEXT":"Reset Password","PHONE_NUMBER_OPTIONAL_ACCOUNT_CREATE":true,"SHOW_REQUIRED_INDICATOR_ACCOUNT_CREATE":true,"PASSWORD_REQUIREMENTS_ACCOUNT_CREATE":"\n    <ul>\n      <li>MUST contain at least 8 characters (12+ recommended)</li>\n      <li>MUST contain at least one uppercase letter.</li>\n      <li>MUST contain at least one lowercase letter.</li>\n      <li>MUST contain at least one number.</li>\n      <li>MUST contain at least one special character (!”#$%&'()*+,-./:;<=>?</li>\n    </ul>\n  ","ALLOW_CERTIFICATION_REQUEST":true,"ALLOW_PUBLIC_CERTIFICATE_REQUEST":true,"ALLOW_COPY_REQUEST":false,"ALLOW_CORRECTION_STYLING":true,"HIDE_DEPRECATION_WARNING":false,"AMEND_ROUTE_PUBLIC":true,"SEAL_FILENAME":"seal.png","SHOPPING_CART":true,"ALLOW_PAYMENT_UPDATE_WITH_EMPTY_CART":true,"RA_EMAIL":true,"RA_WEBSITE":true,"RA_NO_DEFAULT_TYPE":true,"RA_ADDRESS_LABEL":"Street Address","RA_TYPE_SELECTION_DEFAULT":true,"RA_DEFAULT_TYPE":"460","RA_OVERRIDE_TYPE_WITH_DEFAULT":true,"RA_PRINCIPAL_ADDRESS_AMS":true,"UPLOAD_AND_SUBMIT_HIDE_IF_ONE_OPTION":true,"PAYMENT_PROCESSING_MESSAGE":"Your payment is processing - Do not close your browser or click the back button","CHECKOUT_BUTTON_WHEN_PROCESSING_TEXT":"Processing","EFS_CROP_PICKER_NONE_LABEL":"Lien Duration","DISALLOWED_WIZARD_PIECES":["FormationLocale"],"REPEATER_SHOW_EDIT_BUTTON":true,"DATA_REQUEST_PAGE_TITLE":"Data Requests and Subscriptions","DATA_REQUEST_SIDEBAR_LABEL":"Data Requests & Subscriptions","LOGIN_REDIRECTS_TO_EPASS":false,"LOGIN_REDIRECTS_TO_ACTIVE_DIRECTORY":true,"LOGIN_ACTIVE_DIRECTORY_LINK":true,"FETCH_EDIT_USER_LINK":false,"LISTS_FETCH_AVAILABLE_LISTS":true,"POST_WIZARD_SUBMIT_REDIRECT_URL":"/","PIN_REQUEST_ATTESTATIONS":true,"PIN_REQUEST_DESCRIPTION":"Click **Request PIN** to have a new PIN sent to the account holder's email address on file.","OWNERSHIP_REQUEST_DESCRIPTION":"To become an **authorized user** of this record, a current **AUTHORIZED USER** will need to grant you access. To request access, click **Request Access** below.","PIN_REQUEST_SUCCESS_MESSAGE":"The PIN you have requested for this entity has been sent to the email associated with your user account.  You should receive the PIN in approximately 3-5 minutes, depending on your email service provider.","APOSTILLE_HEADER_LABEL":"Verification Information","APOSTILLE_NUMBER_LABEL":"Apostille/Authentication","APOSTILLE_CITY_STATE_OVERRIDE":"HELENA, MT","APOSTILLE_FILING_DATE_LABEL":"Issue Date","APOSTILLE_CITY_STATE_IN_CERTIFIED":true,"NOTARY_EXISTING_FILING":true,"ALLOW_REVOKE_OWN_ACCESS_ONLY":false,"HIDE_CANCEL_ON_ONETIME_DATA_REQUESTS":true,"DATA_REQUESTS_IN_SHOPPING_CART":true,"WQ_ALLOW_EDIT_PENDING_PAYMENT":true,"WQ_CONFIRM_ON_DELETE":true,"WQ_DELETE_CONFIRM_MESSAGE":"Deleting this filing will forfeit any money already paid to the Secretary of State. This action is permanent and cannot be undone, are you sure you would like to delete?","PASS_ITEM_GUIDS_ON_CHECKOUT":true,"FORM_REVISION_HISTORY":true,"CHECKOUT_DISCLAIMER":"By entering your credit card and/or checking account information you (i) state that **you are an authorized user** of the credit card and/or electronic check and that the associated information entered (e.g., account holder name, account number, billing address) is accurate, (ii) **you authorize payment processor to charge the amount you have requested** to your credit card and/or funding account, and (iii) **acknowledge if a charge is declined or reversed you may also be assessed a customary charge** by the payment processor for such transactions.","FARM_BILL_SEARCH_CONFIDENTIAL":"As a registered Farm Bill Buyer with the Montana Secretary of State’s office it is important to maintain the confidentiality of the information contained within the Farm Bill Master List. The Farm Bill Master List reflects personal data, such as Social Security Numbers, which are a key piece of personal identifiable information to assist you in determining the existence of a lien against a specific debtor. The distribution of this information beyond its intended purpose is strictly prohibited.\n\n**The debtor's tax identification number has been hidden for confidentiality reasons. You may continue to search on a tax ID number and return debtors that match your search criteria. The SSN/FEIN must be entered without dashes or spaces.  If you need access to the tax identification number to clearly identify the debtor, please contact the UCC unit at (406) 444-3665.**","VIEW_HISTORY_BUTTON_ALT_TEXT":"View Filings","WIZARD_ERROR_TITLE_MESSAGE":"Form Error","FARM_BILL_SEARCH_INTERACTIVE":true,"USE_FARM_BILL_API":true,"DISALLOW_ASSIGN_SELF_AS_RA":true,"DISALLOW_ASSIGN_SELF_AS_PRINCIPAL":true,"USE_TRADEMARK_OWNER_VALIDATION":true,"USE_ALTERNATIVE_FOREIGN_ADDRESS_LABELS":true,"MY_RECEIPTS_FILTER":[{"type":"dateRange","name":"DATE_RANGE","label":"Date range","defaultValue":{"start":null,"end":null}},{"type":"text","name":"REF_NUM","defaultValue":"","label":"Reference Number"},{"type":"text","name":"RECEIPT_NUM","defaultValue":"","label":"Receipt Id"},{"type":"text","name":"AMOUNT","defaultValue":"","label":"Amount"},{"type":"select","name":"TYPE","defaultValue":"","label":"Payment Type","options":[{"value":"","label":"All"},{"value":"CC","label":"Credit Card"},{"value":"Check","label":"Check"}]}],"MY_RECEIPTS_SHOW_IN_SIDEBAR":true,"SHOW_MY_RECEIPTS_HELPER_TEXT":true,"MY_RECEIPTS_HELPER_LABEL":"About Receipt Search","MY_RECEIPTS_HELPER_TEXT":"You can search for receipts based on their descriptions, including the items paid for on the receipt. Use the filters to search for or filter specific information.","FARM_BILL_SUBLINK":{"label":"Farm Bill","component":"FarmBill","parameter":"farm-bill","path":"/lists/farm-bill","sourceTypeId":0,"myRecordsSearch":false,"allowedRules":["/search/"],"disabled":true,"searchDescription":"To perform a search, enter a debtor name. Your search results may include: exact debtor name, variations of that name and any filing that includes your search criteria. Punctuation is ignored.\n\nYou can click on \"Advanced\" to refine your search. Under “Advanced” you can search by crop, year, county and SSN/FEIN. As a registered Farm Bill Buyer with the Montana Secretary of State’s office it is important to maintain the confidentiality of the information contained within the Farm Bill Master List. The Farm Bill Master List reflects personal data, such as Social Security Numbers, which are a key piece of personal identifiable information to assist you in determining the existence of a lien against a specific debtor. The distribution of this information beyond its intended purpose is strictly prohibited.\n\nThe debtor's tax identification number has been hidden for confidentiality reasons. You may continue to search on a tax ID number and return debtors that match your search criteria. The SSN/FEIN must be entered without dashes or spaces.","searchMustHaveOneOf":["search","UCC_FARM_PRODUCT_ID","COUNTY"],"searchPlaceholder":"Search by debtor name","advancedSearchParameters":[{"type":"ServerMultiComplete","label":"Product code name(s)","name":"UCC_FARM_PRODUCT_ID","defaultValue":"","optionsSrc":"UCC_FARM_PRODUCT_V"},{"type":"MultiComplete","label":"Year or Range of Years","name":"YEAR_NUM","optionsSrc":"years","startYear":"1968","defaultValue":[],"preMergeOptions":[{"value":"ALL","label":"All"}]},{"type":"serverSelect","label":"State","name":"STATE","defaultValue":"MONTANA","optionsSrc":"STATE"},{"type":"ServerMultiComplete","label":"County","name":"COUNTY","defaultValue":[],"optionsSrc":"COUNTY","overrideSubOptionsSrcFromParameterName":"STATE"},{"type":"checkbox","name":"TIN_SEARCH_YN","defaultValue":false,"label":"Tax Identification Number Search"},{"type":"checkbox","name":"TIN_SORT_YN","defaultValue":false,"label":"Unique ID Sort"}]},"ALLOW_ADDRESS_VALIDATION_BYPASS_OPTION":true,"DEFAULT_ADDRESS_VALIDATION_BYPASS_OPTION_CHECKED":true}).HIDE_ICON_CIRCLE_CHECK;
	var EXISTING_PIN_REQUEST_FOR_AUTH_USER_MESSAGE = ({"NODE_ENV":"production","BUILD_DATE":"2025-08-27T15:15:31.687Z","BUILD_NUMBER":"Not Provided","GIT_VERSION":"v1.3.0-381-ga81e29b08","GIT_COMMIT_HASH":"a81e29b085c9268ffd96c78eb734365802722741","GIT_BRANCH":"beta","PUBLIC_URL":"","STATE_ABBR":"MT","STATE_NAME":"Montana","STATE_ORG_TITLE":"Secretary of State","LOGIN_HEADER_IMG_PATH":"","HOME_IMG_FILENAME":"montana.jpg","FAVICON_FILE_NAME":"favicon.ico","ALLOW_E_SIGN_ON_CORRECTIONS":true,"THIRD_PARTY_SIGNING_ALLOWED":false,"MY_ACCOUNT_SAVE_AND_CLOSE_BUTTON":true,"IE_DEPRECATED_MESSAGE":"Internet Explorer is not supported. Please select a supported browser below to access this website.","ADDITIONAL_ROUTES":{"dataRequests":true,"farmBill":true,"apostille":true,"externalHelp":"https://sosmt.gov/business/help-center/","systemAdministration":[{"title":"Saved Payments","parameter":"saved-payments","componentName":"SavedPayments"}]},"SUBROUTES":[{"label":"Business","component":"Business","parameter":"business","myWorkQueueSearch":false,"sourceTypeId":54,"searchMustHaveOneOf":["FILING_TYPE_ID","STATUS_ID","STATE","search"],"serverWebSearchDescription":true,"serverWorkQueueDescription":true,"serverMyRecordsDescription":true,"searchPlaceholder":"Search by name or filing number (X########)","allowEmptySearchTerm":true,"requestCertificateAlternateLabel":"Request Information","fileAmendmentButtonLabel":"Filing Actions","advancedSearchParameters":[{"type":"radio","name":"QUERY_TYPE_ID","defaultValue":1010,"options":[{"value":1010,"label":"Starts with"},{"value":1011,"label":"Contains"},{"value":1012,"label":" Word Contains"}]},{"type":"serverSelect","name":"FILING_TYPE_ID","optionsSrc":"FILING_TYPES","label":"Entity Type","placeholder":"All","defaultValue":"0"},{"type":"serverSelect","name":"FILING_SUBTYPE_ID","optionsSrc":"FILING_SUBTYPES","label":"Entity Subtype","overrideSubOptionsSrcFromParameterName":"FILING_TYPE_ID","placeholder":"All","defaultValue":"0"},{"type":"serverSelect","name":"STATUS_ID","optionsSrc":"FILING_STATUS_WITHOUT_ALL","label":"Status","placeholder":"All","defaultValue":"0"},{"type":"serverSelect","name":"STATE","optionsSrc":"STATE","label":"State","placeholder":"All","defaultValue":""},{"type":"serverSelect","name":"COUNTY","optionsSrc":"COUNTY_SUBOPTION","label":"County","overrideSubOptionsSrcFromParameterName":"STATE","placeholder":"All","defaultValue":""},{"type":"checkbox","name":"CRA_SEARCH_YN","defaultValue":false,"label":"Search by Registered Agent PID"},{"type":"dateRange","name":"FILING_DATE","label":"Registration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}},{"type":"dateRange","name":"EXPIRATION_DATE","label":"Expiration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}}],"myRecordsFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Active"},{"value":2,"label":"Inactive"},{"value":3,"label":"Pending"}]},{"type":"dateRange","name":"DATE_RANGE","label":"Date range","defaultValue":{"start":null,"end":null}}],"myWorkQueueFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Approved"},{"value":2,"label":"Pending Online Payment"},{"value":3,"label":"Pending Review"},{"value":4,"label":"Needs Correction"},{"value":5,"label":"Rejected"},{"value":6,"label":"Draft"}]},{"type":"dateRange","name":"DATE_RANGE","label":"Date range","defaultValue":{"start":null,"end":null}}]},{"label":"Notary","component":"Notary","parameter":"notary","sourceTypeId":850,"myWorkQueueSearch":false,"allowEmptySearchTerm":true,"requestCertificateAlternateLabel":"Download Certificate","fileAmendmentButtonLabel":"Filing Actions","hideNameRequestCertificate":true,"hideAddressRequestCertificate":true,"hideRecordUserManagment":true,"searchPlaceholder":"Search by name or commission number","searchMustHaveOneOf":["CITY","search","SERVICE_TYPE"],"advancedParametersStartOpen":true,"searchIsSortable":true,"advancedSearchParameters":[{"type":"radio","name":"STARTS_WITH_YN","defaultValue":false,"options":[{"value":true,"label":"Starts with"},{"value":false,"label":"Contains"}]},{"type":"checkbox","name":"ACTIVE_ONLY_YN","defaultValue":true,"label":"Active entities only"},{"type":"text","name":"CITY","defaultValue":"","label":"City"},{"type":"select","name":"SERVICE_TYPE","label":"Special Services Offered","defaultValue":0,"options":[{"value":0,"label":"(N/A)"},{"value":6165,"label":"In-Person Electronic Notarization (IPEN)"},{"value":6166,"label":"Remote Online Notarization (RON)"},{"value":6167,"label":"Mobile Notary Services"},{"value":6168,"label":"Remote Ink Notarization (RIN)"}]}]},{"label":"Apostille","component":"Apostille","parameter":"apostille","sourceTypeId":720,"myRecordsSearch":false,"myWorkQueueSearch":false,"disabled":false,"allowedRoutes":["/forms-manager/","/queue/","/forms/"]},{"label":"Liens","component":"UCC","parameter":"ucc","sourceTypeId":1999,"myRecordsSearch":true,"myWorkQueueSearch":true,"fileAmendmentButtonLabel":"Filing Actions","searchPlaceholder":"Search by name or file number","disabled":false,"serverWebSearchDescription":true,"myRecordsDescription":"","workQueueDescription":"","searchDescription":"","hideRecordUserManagment":true,"searchLiensCheckout":false,"advancedSearchParameters":[{"type":"radio","name":"STARTS_WITH_YN","defaultValue":false,"options":[{"value":true,"label":"Starts with"},{"value":false,"label":"Contains"}]},{"type":"select","name":"STATUS","defaultValue":"ALL","label":"Status","options":[{"value":"ACTIVE_UNLAPSED","label":"Active (unlapsed)"},{"value":"ACTIVE_LAPSED_UNLAPSED","label":"Active (lapsed and unlapsed)"}]},{"type":"text","name":"EXCLUDE_VALUES","label":"Exclude Debtor Names (comma separated list of names to exclude)","defaultValue":""},{"type":"dateRange","name":"FILING_DATE","label":"Financing Statement Date","defaultValue":{"start":null,"end":null}},{"type":"dateRange","name":"LAPSE_DATE","label":"Lapse Date","defaultValue":{"start":null,"end":null}},{"type":"text","name":"CITY","label":"Debtor City","defaultValue":""}],"myRecordsFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Approved"},{"value":2,"label":"Pending Online Payment"},{"value":3,"label":"Pending Review"}]},{"type":"select","name":"TYPE","defaultValue":0,"label":"Lien Type","options":[{"value":0,"label":"All"},{"value":1,"label":"UCC"},{"value":2,"label":"EFS"},{"value":3,"label":"Title 71"}]}],"myWorkQueueFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Approved"},{"value":2,"label":"Pending Online Payment"},{"value":3,"label":"Pending Review"},{"value":4,"label":"Pending Print and Mail"},{"value":5,"label":"Rejected"},{"value":6,"label":"Draft"}]},{"type":"select","name":"TYPE","defaultValue":0,"label":"Lien Type","options":[{"value":0,"label":"All"},{"value":1,"label":"UCC"},{"value":2,"label":"EFS"},{"value":3,"label":"Title 71"}]}]},{"label":"Copy Request","component":"copies","parameter":"copies","sourceTypeId":2001,"myRecordsSearch":false,"myWorkQueueSearch":false,"disabled":false,"allowedRoutes":["/forms-manager/","/queue/","/forms/"]},{"label":"Trademark","component":"Trademark","parameter":"trademark","sourceTypeId":810,"showRequestCertificate":true,"searchMustHaveOneOf":["search","EXPIRATION_DATE","FILING_DATE"],"allowEmptySearchTerm":true,"requestCertificateAlternateLabel":"Request Information","fileAmendmentButtonLabel":"Filing Actions","advancedSearchParameters":[{"type":"radio","name":"QUERY_TYPE_ID","defaultValue":1010,"options":[{"value":1010,"label":"Starts with"},{"value":1011,"label":"Contains"},{"value":1012,"label":" Word Contains"}]},{"type":"checkbox","name":"OWNER_SEARCH_YN","defaultValue":false,"label":"Search owners"},{"type":"radio","name":"SERVICE_MARK_YN","label":"Mark Type","defaultValue":"","options":[{"value":"","label":"All Marks"},{"value":"Y","label":"Service Mark"},{"value":"N","label":"Trademark"}]},{"type":"serverSelect","name":"STATUS_ID","optionsSrc":"TYPE_V|TRADEMARK_STATUS_TYPE","label":"Status","placeholder":"All","defaultValue":"0"},{"type":"select","name":"DESIGN_TYPE_ID","options":[{"value":0,"label":"All"},{"value":990,"label":"Words Only"},{"value":991,"label":"Design Only"},{"value":992,"label":"Words and Design"}],"label":"Design Type","defaultValue":"0"},{"type":"dateRange","name":"FILING_DATE","label":"Registered Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}},{"type":"dateRange","name":"EXPIRATION_DATE","label":"Expiration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}}]},{"label":"Business Info Request","component":"InfoRequests","parameter":"info-request","sourceTypeId":167,"allowedRoutes":["/forms-manager/","/queue/","/forms/"]},{"label":"Data Requests","component":"DataRequests","parameter":"data-request","sourceTypeId":0,"allowedRoutes":["/forms-manager/"]},{"label":"CRA","component":"CRA","parameter":"cra","sourceTypeId":157,"myRecordsSearch":false,"searchPlaceholder":"Search by name or registered agent number","allowedRoutes":["/forms-manager/","/forms/","/records/","/queue/","/search/"],"allowEmptySearchTerm":true,"fileAmendmentButtonLabel":"Filing Actions","advancedSearchParameters":[{"type":"radio","name":"QUERY_TYPE_ID","defaultValue":1010,"options":[{"value":1010,"label":"Starts with"},{"value":1011,"label":"Contains"},{"value":1012,"label":" Word Contains"}]},{"type":"dateRange","name":"CRA_DATE","label":"Registration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}},{"type":"select","name":"STATUS_ID","label":"Status","defaultValue":0,"options":[{"value":0,"label":"All"},{"value":121,"label":"Active"},{"value":122,"label":"Inactive"}]},{"type":"select","name":"AGENT_TYPE_ID","label":"Agent Type","defaultValue":0,"options":[{"value":0,"label":"All"},{"value":460,"label":"Registered Agent"},{"value":461,"label":"Commercial Registered Agent"}]}]},{"label":"Farm Bill","component":"FarmBill","parameter":"farm-bill","path":"/lists/farm-bill","sourceTypeId":0,"myRecordsSearch":false,"allowedRules":["/search/"],"disabled":true,"searchDescription":"To perform a search, enter a debtor name. Your search results may include: exact debtor name, variations of that name and any filing that includes your search criteria. Punctuation is ignored.\n\nYou can click on \"Advanced\" to refine your search. Under “Advanced” you can search by crop, year, county and SSN/FEIN. As a registered Farm Bill Buyer with the Montana Secretary of State’s office it is important to maintain the confidentiality of the information contained within the Farm Bill Master List. The Farm Bill Master List reflects personal data, such as Social Security Numbers, which are a key piece of personal identifiable information to assist you in determining the existence of a lien against a specific debtor. The distribution of this information beyond its intended purpose is strictly prohibited.\n\nThe debtor's tax identification number has been hidden for confidentiality reasons. You may continue to search on a tax ID number and return debtors that match your search criteria. The SSN/FEIN must be entered without dashes or spaces.","searchMustHaveOneOf":["search","UCC_FARM_PRODUCT_ID","COUNTY"],"searchPlaceholder":"Search by debtor name","advancedSearchParameters":[{"type":"ServerMultiComplete","label":"Product code name(s)","name":"UCC_FARM_PRODUCT_ID","defaultValue":"","optionsSrc":"UCC_FARM_PRODUCT_V"},{"type":"MultiComplete","label":"Year or Range of Years","name":"YEAR_NUM","optionsSrc":"years","startYear":"1968","defaultValue":[],"preMergeOptions":[{"value":"ALL","label":"All"}]},{"type":"serverSelect","label":"State","name":"STATE","defaultValue":"MONTANA","optionsSrc":"STATE"},{"type":"ServerMultiComplete","label":"County","name":"COUNTY","defaultValue":[],"optionsSrc":"COUNTY","overrideSubOptionsSrcFromParameterName":"STATE"},{"type":"checkbox","name":"TIN_SEARCH_YN","defaultValue":false,"label":"Tax Identification Number Search"},{"type":"checkbox","name":"TIN_SORT_YN","defaultValue":false,"label":"Unique ID Sort"}]}],"SYSTEM_NICKNAME":"Online Services Portal","PAYMENT_METHODS":[{"type":"bypass"},{"type":"iTransact"}],"PAYMENT_ALLOW_AMEX":true,"SYSTEM_ID_LABEL":"System Id","DOUBLE_COLUMN_PUBLIC_LOGIN":true,"INTERNAL_USER_MANAGEMENT":true,"ALLOW_PUBLIC_JSON_IMPORT":false,"MAX_FILE_UPLOAD_SIZE":10000000,"REFUND_TEXT":"","RETURN_TO_HOME_ON_LOGOUT":true,"CURRENT_SOS_NAME":"Christi Jacobsen","LOGO_FILENAME":"mt-sos-logo.png","LOGO_ALT":"Christi Jacobsen, Montana Secretary of State","LOGO_FULL_WIDTH":true,"HOME_HIDE_AUTH_HINT":true,"HOME_TITLE":"Montana Secretary of State","CUSTOM_TAB_TITLE":"Official Montana","HOME_SUBTITLE":"Online Business Services","ENTITY_NAME_CONSENT_DESCRIPTION":"","ALLOW_USER_PROFILE_EDITING":true,"COMPARE_FOREIGN_NAME_IN_ENTITY_NAME_VALIDATION":true,"FOREIGN_NAME_FIELD_NAME":"KIMA_PARENT_NAME_INFO","LOGIN_TITLE":"Montana Secretary of State Online Filing Portal Login","PUBLIC_LOGIN_LABEL":"Username","REVERSE_LOGIN_COLUMNS":true,"LOGIN_SEAL_FILENAME":"seal_white.png","SEPARATE_USERNAME_AND_EMAIL":true,"CREATE_ACCOUNT_BUTTON_ALIGN_LEFT":true,"CREATE_ACCOUNT_BUTTON_TEXT":"CREATE AN ACCOUNT","PASSWORD_CUSTOM_ERROR_TEXT":"The password must meet all requirements","ACCOUNT_CREATED_MESSAGE":"Please check your email to verify your account to login and allow a few minutes for this message to arrive. Check your junk/spam folders if you do not find the email in your inbox.","PUBLIC_LOGIN_PLACEHOLDER":" ","DISABLE_DEFAULT_PAYMENT_RADIO":true,"CUSTOM_RESET_PASSWORD_ERROR_MESSAGE":"Username invalid - no account found","PUBLIC_LOGIN_CREATE_DESCRIPTION":"### Existing User:\n\n  - Enter your username and password to login.  \n\n\n  #### - OR -  \n\n\n\n  - Forgot password? Click 'Reset Password' and follow the prompts.\n  - Forgot username? Click 'Forgot Username' and follow the prompts.  \n\n\n  ### New User:\n  ","LOGIN_HELP_LINK":"https://sosmt.gov/business/how-do-i/","LOGIN_HELP_LINK_TEXT":"Need Help?","FORGOT_USERNAME_TEXT":"Forgot Username?","LOGIN_ACTIVE_DIRECTORY_TEXT":"State User Login","MULTIPLE_LOGIN_METHODS":true,"HAS_ACTIVE_DIRECTORY_LOGIN":true,"RESET_PASSWORD_WITH_USERNAME":true,"DOWNLOAD_LINK":true,"SHOW_USERNAME_ACCOUNT_CREATE":true,"SHOW_SCROLL_DOWN_ARROW":true,"SHOW_ADDRESS_ACCOUNT_CREATE":true,"TWO_COLUMN_ACCOUNT_CREATE":true,"RESET_PASSWORD_TIP":"A link to change your password has been sent to your email. Please allow a few minutes for this message to arrive. Please check your junk/spam folders if you do not find the email in your inbox.","FORGOT_PASSWORD_LINK_TEXT":"Reset Password","PHONE_NUMBER_OPTIONAL_ACCOUNT_CREATE":true,"SHOW_REQUIRED_INDICATOR_ACCOUNT_CREATE":true,"PASSWORD_REQUIREMENTS_ACCOUNT_CREATE":"\n    <ul>\n      <li>MUST contain at least 8 characters (12+ recommended)</li>\n      <li>MUST contain at least one uppercase letter.</li>\n      <li>MUST contain at least one lowercase letter.</li>\n      <li>MUST contain at least one number.</li>\n      <li>MUST contain at least one special character (!”#$%&'()*+,-./:;<=>?</li>\n    </ul>\n  ","ALLOW_CERTIFICATION_REQUEST":true,"ALLOW_PUBLIC_CERTIFICATE_REQUEST":true,"ALLOW_COPY_REQUEST":false,"ALLOW_CORRECTION_STYLING":true,"HIDE_DEPRECATION_WARNING":false,"AMEND_ROUTE_PUBLIC":true,"SEAL_FILENAME":"seal.png","SHOPPING_CART":true,"ALLOW_PAYMENT_UPDATE_WITH_EMPTY_CART":true,"RA_EMAIL":true,"RA_WEBSITE":true,"RA_NO_DEFAULT_TYPE":true,"RA_ADDRESS_LABEL":"Street Address","RA_TYPE_SELECTION_DEFAULT":true,"RA_DEFAULT_TYPE":"460","RA_OVERRIDE_TYPE_WITH_DEFAULT":true,"RA_PRINCIPAL_ADDRESS_AMS":true,"UPLOAD_AND_SUBMIT_HIDE_IF_ONE_OPTION":true,"PAYMENT_PROCESSING_MESSAGE":"Your payment is processing - Do not close your browser or click the back button","CHECKOUT_BUTTON_WHEN_PROCESSING_TEXT":"Processing","EFS_CROP_PICKER_NONE_LABEL":"Lien Duration","DISALLOWED_WIZARD_PIECES":["FormationLocale"],"REPEATER_SHOW_EDIT_BUTTON":true,"DATA_REQUEST_PAGE_TITLE":"Data Requests and Subscriptions","DATA_REQUEST_SIDEBAR_LABEL":"Data Requests & Subscriptions","LOGIN_REDIRECTS_TO_EPASS":false,"LOGIN_REDIRECTS_TO_ACTIVE_DIRECTORY":true,"LOGIN_ACTIVE_DIRECTORY_LINK":true,"FETCH_EDIT_USER_LINK":false,"LISTS_FETCH_AVAILABLE_LISTS":true,"POST_WIZARD_SUBMIT_REDIRECT_URL":"/","PIN_REQUEST_ATTESTATIONS":true,"PIN_REQUEST_DESCRIPTION":"Click **Request PIN** to have a new PIN sent to the account holder's email address on file.","OWNERSHIP_REQUEST_DESCRIPTION":"To become an **authorized user** of this record, a current **AUTHORIZED USER** will need to grant you access. To request access, click **Request Access** below.","PIN_REQUEST_SUCCESS_MESSAGE":"The PIN you have requested for this entity has been sent to the email associated with your user account.  You should receive the PIN in approximately 3-5 minutes, depending on your email service provider.","APOSTILLE_HEADER_LABEL":"Verification Information","APOSTILLE_NUMBER_LABEL":"Apostille/Authentication","APOSTILLE_CITY_STATE_OVERRIDE":"HELENA, MT","APOSTILLE_FILING_DATE_LABEL":"Issue Date","APOSTILLE_CITY_STATE_IN_CERTIFIED":true,"NOTARY_EXISTING_FILING":true,"ALLOW_REVOKE_OWN_ACCESS_ONLY":false,"HIDE_CANCEL_ON_ONETIME_DATA_REQUESTS":true,"DATA_REQUESTS_IN_SHOPPING_CART":true,"WQ_ALLOW_EDIT_PENDING_PAYMENT":true,"WQ_CONFIRM_ON_DELETE":true,"WQ_DELETE_CONFIRM_MESSAGE":"Deleting this filing will forfeit any money already paid to the Secretary of State. This action is permanent and cannot be undone, are you sure you would like to delete?","PASS_ITEM_GUIDS_ON_CHECKOUT":true,"FORM_REVISION_HISTORY":true,"CHECKOUT_DISCLAIMER":"By entering your credit card and/or checking account information you (i) state that **you are an authorized user** of the credit card and/or electronic check and that the associated information entered (e.g., account holder name, account number, billing address) is accurate, (ii) **you authorize payment processor to charge the amount you have requested** to your credit card and/or funding account, and (iii) **acknowledge if a charge is declined or reversed you may also be assessed a customary charge** by the payment processor for such transactions.","FARM_BILL_SEARCH_CONFIDENTIAL":"As a registered Farm Bill Buyer with the Montana Secretary of State’s office it is important to maintain the confidentiality of the information contained within the Farm Bill Master List. The Farm Bill Master List reflects personal data, such as Social Security Numbers, which are a key piece of personal identifiable information to assist you in determining the existence of a lien against a specific debtor. The distribution of this information beyond its intended purpose is strictly prohibited.\n\n**The debtor's tax identification number has been hidden for confidentiality reasons. You may continue to search on a tax ID number and return debtors that match your search criteria. The SSN/FEIN must be entered without dashes or spaces.  If you need access to the tax identification number to clearly identify the debtor, please contact the UCC unit at (406) 444-3665.**","VIEW_HISTORY_BUTTON_ALT_TEXT":"View Filings","WIZARD_ERROR_TITLE_MESSAGE":"Form Error","FARM_BILL_SEARCH_INTERACTIVE":true,"USE_FARM_BILL_API":true,"DISALLOW_ASSIGN_SELF_AS_RA":true,"DISALLOW_ASSIGN_SELF_AS_PRINCIPAL":true,"USE_TRADEMARK_OWNER_VALIDATION":true,"USE_ALTERNATIVE_FOREIGN_ADDRESS_LABELS":true,"MY_RECEIPTS_FILTER":[{"type":"dateRange","name":"DATE_RANGE","label":"Date range","defaultValue":{"start":null,"end":null}},{"type":"text","name":"REF_NUM","defaultValue":"","label":"Reference Number"},{"type":"text","name":"RECEIPT_NUM","defaultValue":"","label":"Receipt Id"},{"type":"text","name":"AMOUNT","defaultValue":"","label":"Amount"},{"type":"select","name":"TYPE","defaultValue":"","label":"Payment Type","options":[{"value":"","label":"All"},{"value":"CC","label":"Credit Card"},{"value":"Check","label":"Check"}]}],"MY_RECEIPTS_SHOW_IN_SIDEBAR":true,"SHOW_MY_RECEIPTS_HELPER_TEXT":true,"MY_RECEIPTS_HELPER_LABEL":"About Receipt Search","MY_RECEIPTS_HELPER_TEXT":"You can search for receipts based on their descriptions, including the items paid for on the receipt. Use the filters to search for or filter specific information.","FARM_BILL_SUBLINK":{"label":"Farm Bill","component":"FarmBill","parameter":"farm-bill","path":"/lists/farm-bill","sourceTypeId":0,"myRecordsSearch":false,"allowedRules":["/search/"],"disabled":true,"searchDescription":"To perform a search, enter a debtor name. Your search results may include: exact debtor name, variations of that name and any filing that includes your search criteria. Punctuation is ignored.\n\nYou can click on \"Advanced\" to refine your search. Under “Advanced” you can search by crop, year, county and SSN/FEIN. As a registered Farm Bill Buyer with the Montana Secretary of State’s office it is important to maintain the confidentiality of the information contained within the Farm Bill Master List. The Farm Bill Master List reflects personal data, such as Social Security Numbers, which are a key piece of personal identifiable information to assist you in determining the existence of a lien against a specific debtor. The distribution of this information beyond its intended purpose is strictly prohibited.\n\nThe debtor's tax identification number has been hidden for confidentiality reasons. You may continue to search on a tax ID number and return debtors that match your search criteria. The SSN/FEIN must be entered without dashes or spaces.","searchMustHaveOneOf":["search","UCC_FARM_PRODUCT_ID","COUNTY"],"searchPlaceholder":"Search by debtor name","advancedSearchParameters":[{"type":"ServerMultiComplete","label":"Product code name(s)","name":"UCC_FARM_PRODUCT_ID","defaultValue":"","optionsSrc":"UCC_FARM_PRODUCT_V"},{"type":"MultiComplete","label":"Year or Range of Years","name":"YEAR_NUM","optionsSrc":"years","startYear":"1968","defaultValue":[],"preMergeOptions":[{"value":"ALL","label":"All"}]},{"type":"serverSelect","label":"State","name":"STATE","defaultValue":"MONTANA","optionsSrc":"STATE"},{"type":"ServerMultiComplete","label":"County","name":"COUNTY","defaultValue":[],"optionsSrc":"COUNTY","overrideSubOptionsSrcFromParameterName":"STATE"},{"type":"checkbox","name":"TIN_SEARCH_YN","defaultValue":false,"label":"Tax Identification Number Search"},{"type":"checkbox","name":"TIN_SORT_YN","defaultValue":false,"label":"Unique ID Sort"}]},"ALLOW_ADDRESS_VALIDATION_BYPASS_OPTION":true,"DEFAULT_ADDRESS_VALIDATION_BYPASS_OPTION_CHECKED":true}).EXISTING_PIN_REQUEST_FOR_AUTH_USER_MESSAGE;
	
	var RequestOwnership = function (_Component) {
	  _inherits(RequestOwnership, _Component);
	
	  function RequestOwnership() {
	    _classCallCheck(this, RequestOwnership);
	
	    var _this = _possibleConstructorReturn(this, (RequestOwnership.__proto__ || Object.getPrototypeOf(RequestOwnership)).call(this));
	
	    _this.componentDidMount = function () {
	      (0, _requests.GET_USER_HAS_ALREADY_REQUESTED_WEB_USER_ACCESS)(_this.props.category, _this.props.source_id, function (hasRequested) {
	        _this.setState({ hasRequested: hasRequested });
	      });
	      _this.getNumActivePins();
	    };
	
	    _this.getNumActivePins = function () {
	      (0, _requests.GET_RECORD_HAS_ACTIVE_PIN)(_this.props.category, _this.props.source_id, function (recordHasActivePin) {
	        _this.setState({ recordHasActivePin: recordHasActivePin });
	      });
	    };
	
	    _this.setValue = function (name, checked) {
	      _this.setState(_defineProperty({}, name, checked));
	    };
	
	    _this.requestAccess = function () {
	      (0, _requests.REQUEST_RECORD_ACCESS)(_this.props.category, _this.props.source_id, function (successful) {
	        if (successful) {
	          _this.setState({ requestSuccessful: true });
	          // window.setTimeout(this.props.onRequestModalClose, 3000)
	        } else {
	          _this.setState({ requestSuccessful: false });
	        }
	      });
	    };
	
	    _this.requestPin = function () {
	      (0, _requests.REQUEST_NEW_PIN)(_this.props.category, _this.props.source_id, function (success) {
	        _this.setState({ pinRequestSuccessful: success });
	        _this.getNumActivePins();
	      }, function (err) {
	        _this.setState({
	          error: "Something went wrong. Please try again later, and if the problem persists please contact customer support."
	        });
	      });
	    };
	
	    _this.state = {
	      requestSuccessful: null,
	      hasRequested: null,
	      attestation1Checked: false,
	      pinRequestSuccessful: null,
	      error: null,
	      recordHasActivePin: null
	    };
	    return _this;
	  }
	
	  _createClass(RequestOwnership, [{
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'request-ownership' },
	        REQUEST_PIN_EVEN_WITH_OWNERSHIP && (this.state.pinRequestSuccessful || this.state.recordHasActivePin) && _react2.default.createElement(
	          'div',
	          { className: 'row' },
	          _react2.default.createElement(
	            'div',
	            { className: 'col-12' },
	            _react2.default.createElement(
	              'p',
	              { className: 'center-text' },
	              'PIN has been requested. A PIN letter will be sent to the record\'s mailing address on file. Follow the instructions provided in the letter to enter the PIN and obtain access to this record.'
	            )
	          )
	        ),
	
	        //b-63093
	        //adding the CA condition since in CA, we might still have an active PIN even with an active onwer.
	        this.state.requestSuccessful !== true && this.state.hasRequested === false && this.state.pinRequestSuccessful !== true && (("MT") === "CA" || this.state.recordHasActivePin !== true) && _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement(
	            'div',
	            { className: 'row' },
	            _react2.default.createElement(
	              'div',
	              { className: 'col-12' },
	              _react2.default.createElement(
	                'p',
	                { className: 'center-text' },
	                OWNERSHIP_REQUEST_DESCRIPTION ? _react2.default.createElement(_Markdown2.default, { source: OWNERSHIP_REQUEST_DESCRIPTION, className: 'markdown' }) : _react2.default.createElement(
	                  'span',
	                  null,
	                  'To become an owner of this record, a current owner will need to grant you access. To request access, click ',
	                  _react2.default.createElement(
	                    'strong',
	                    null,
	                    'Request Access'
	                  ),
	                  ' below.'
	                )
	              )
	            )
	          ),
	          OWNERSHIP_REQUEST_ATTESTATIONS && _react2.default.createElement(
	            'div',
	            { className: 'wizard' },
	            _react2.default.createElement(
	              'div',
	              { className: 'row margin-top' },
	              _react2.default.createElement(
	                'div',
	                { className: 'col-12' },
	                !HIDE_REQUIRED_PIN_ATTESTATION_MESSAGE && _react2.default.createElement(
	                  'p',
	                  { className: 'attestation-hint' },
	                  'You ',
	                  _react2.default.createElement(
	                    'strong',
	                    null,
	                    'must'
	                  ),
	                  ' check the box below to proceed'
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'row' },
	              _react2.default.createElement(
	                'div',
	                { className: 'col-12 checkbox-column' },
	                _react2.default.createElement(_Form.Checkbox, {
	                  fieldId: 'attestation1',
	                  value: this.state.attestation1Checked,
	                  onChange: function onChange(checked) {
	                    _this2.setValue("attestation1Checked", checked);
	                  },
	                  label: 'I certify that I am authorized to request and obtain access to this record.'
	                })
	              )
	            )
	          ),
	          REQUEST_PIN_EVEN_WITH_OWNERSHIP && _react2.default.createElement(
	            'div',
	            { className: 'row margin-top' },
	            _react2.default.createElement(
	              'div',
	              { className: 'col-12 button-column' },
	              _react2.default.createElement(_Modal.DialogButton, { label: 'Request PIN', disabled: !(!OWNERSHIP_REQUEST_ATTESTATIONS || this.state.attestation1Checked), className: 'btn-raised', customClickHandler: true, onClick: this.requestPin })
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'row margin-top' },
	            _react2.default.createElement(
	              'div',
	              { className: 'col-12 button-column' },
	              _react2.default.createElement(_Modal.DialogButton, { label: REQUEST_PIN_EVEN_WITH_OWNERSHIP ? 'Request Access from Current Authorized User' : 'Request Access', disabled: !(!OWNERSHIP_REQUEST_ATTESTATIONS || this.state.attestation1Checked), className: 'btn-raised', customClickHandler: true, onClick: this.requestAccess })
	            )
	          ),
	          this.state.requestSuccessful === false && _react2.default.createElement(
	            'div',
	            { className: 'row margin-top' },
	            _react2.default.createElement(
	              'div',
	              { className: 'col-12 button-column' },
	              _react2.default.createElement(
	                'p',
	                { className: 'error' },
	                'Something went wrong while trying to request access. Try again later.'
	              )
	            )
	          )
	        ),
	        this.state.hasRequested === null && _react2.default.createElement(
	          'div',
	          { className: 'loader-wrapper' },
	          _react2.default.createElement(_Loaders.Spinner, { themeColor: 'medium-neutral', size: 'small' })
	        ),
	        this.state.hasRequested === true && !REQUEST_PIN_EVEN_WITH_OWNERSHIP && _react2.default.createElement(
	          'div',
	          { className: 'row' },
	          _react2.default.createElement(
	            'div',
	            { className: 'col-12' },
	            _react2.default.createElement(
	              'p',
	              { className: 'center-text' },
	              'You\'ve already requested access to this record.'
	            )
	          )
	        ),
	        this.state.hasRequested === true && REQUEST_PIN_EVEN_WITH_OWNERSHIP && !this.state.recordHasActivePin && _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement(
	            'div',
	            { className: 'row' },
	            _react2.default.createElement(
	              'div',
	              { className: 'col-12' },
	              _react2.default.createElement(
	                'p',
	                { className: 'center-text' },
	                EXISTING_PIN_REQUEST_FOR_AUTH_USER_MESSAGE || "Access from a current authorized user has already been requested. If the request for access has not been accepted, a PIN may be requested."
	              )
	            )
	          ),
	          OWNERSHIP_REQUEST_ATTESTATIONS && _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(
	              'div',
	              { className: 'wizard' },
	              _react2.default.createElement(
	                'div',
	                { className: 'row margin-top' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'col-12 checkbox-column' },
	                  _react2.default.createElement(_Form.Checkbox, {
	                    fieldId: 'attestation1',
	                    value: this.state.attestation1Checked,
	                    onChange: function onChange(checked) {
	                      _this2.setValue("attestation1Checked", checked);
	                    },
	                    label: 'I certify that I am authorized to request and obtain access to this record.'
	                  })
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'row margin-top' },
	              _react2.default.createElement(
	                'div',
	                { className: 'col-12 button-column' },
	                _react2.default.createElement(_Modal.DialogButton, { label: 'Request PIN', disabled: !(!OWNERSHIP_REQUEST_ATTESTATIONS || this.state.attestation1Checked), className: 'btn-raised', customClickHandler: true, onClick: this.requestPin })
	              )
	            )
	          )
	        ),
	        this.state.requestSuccessful === true && OWNERSHIP_REQUEST_SUCCESSFUL_MESSAGE && _react2.default.createElement(
	          'div',
	          { className: 'row' },
	          _react2.default.createElement(
	            'div',
	            { className: 'col-12' },
	            _react2.default.createElement(
	              'p',
	              { className: 'center-text' },
	              _react2.default.createElement('span', { className: HIDE_ICON_CIRCLE_CHECK ? "" : "icon icon-circle-check" }),
	              _react2.default.createElement(_Markdown2.default, { source: OWNERSHIP_REQUEST_SUCCESSFUL_MESSAGE, className: 'markdown' })
	            )
	          )
	        ),
	        this.state.requestSuccessful === true && !OWNERSHIP_REQUEST_SUCCESSFUL_MESSAGE && _react2.default.createElement(
	          'div',
	          { className: 'row' },
	          _react2.default.createElement(
	            'div',
	            { className: 'col-12' },
	            _react2.default.createElement(
	              'p',
	              { className: 'center-text error success' },
	              _react2.default.createElement('span', { className: HIDE_ICON_CIRCLE_CHECK ? "" : "icon icon-circle-check" }),
	              'You\'ve successfully requested access to this record.'
	            )
	          )
	        ),
	        this.state.error && _react2.default.createElement(
	          'p',
	          { className: 'error' },
	          this.state.error
	        )
	      );
	    }
	  }]);
	
	  return RequestOwnership;
	}(_react.Component);
	
	exports.default = RequestOwnership;

/***/ },
/* 1121 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouterDom = __webpack_require__(30);
	
	var _reactRedux = __webpack_require__(7);
	
	var _Shell = __webpack_require__(19);
	
	var _Table = __webpack_require__(150);
	
	var _Table2 = _interopRequireDefault(_Table);
	
	var _TableControls = __webpack_require__(303);
	
	var _TableControls2 = _interopRequireDefault(_TableControls);
	
	var _Modal = __webpack_require__(13);
	
	var _PageError = __webpack_require__(301);
	
	var _MyWorkQueueActions = __webpack_require__(463);
	
	var _actions = __webpack_require__(29);
	
	var _Loaders = __webpack_require__(16);
	
	__webpack_require__(1454);
	
	var _requests = __webpack_require__(6);
	
	var api = _interopRequireWildcard(_requests);
	
	var _ReportsList = __webpack_require__(300);
	
	var _ReportsList2 = _interopRequireDefault(_ReportsList);
	
	var _EmptyBox = __webpack_require__(197);
	
	var _EmptyBox2 = _interopRequireDefault(_EmptyBox);
	
	var _utilities = __webpack_require__(8);
	
	var _cart = __webpack_require__(223);
	
	var _cart2 = _interopRequireDefault(_cart);
	
	var _trash = __webpack_require__(60);
	
	var _trash2 = _interopRequireDefault(_trash);
	
	var _document = __webpack_require__(126);
	
	var _document2 = _interopRequireDefault(_document);
	
	var _pencil = __webpack_require__(161);
	
	var _pencil2 = _interopRequireDefault(_pencil);
	
	var _downloadBox = __webpack_require__(127);
	
	var _downloadBox2 = _interopRequireDefault(_downloadBox);
	
	var _signature = __webpack_require__(339);
	
	var _signature2 = _interopRequireDefault(_signature);
	
	var _SlidingPanel = __webpack_require__(101);
	
	var _SlidingPanel2 = _interopRequireDefault(_SlidingPanel);
	
	var _Portal = __webpack_require__(12);
	
	var _Portal2 = _interopRequireDefault(_Portal);
	
	var _Checkout = __webpack_require__(67);
	
	var _Checkout2 = _interopRequireDefault(_Checkout);
	
	var _App = __webpack_require__(118);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	// import orderBy from 'lodash/orderBy'
	
	// import { ReceiptModal } from "components/Checkout/Receipt"
	
	
	var MY_WORK_QUEUE_SEARCH_PLACEHOLDER = ({"NODE_ENV":"production","BUILD_DATE":"2025-08-27T15:15:31.687Z","BUILD_NUMBER":"Not Provided","GIT_VERSION":"v1.3.0-381-ga81e29b08","GIT_COMMIT_HASH":"a81e29b085c9268ffd96c78eb734365802722741","GIT_BRANCH":"beta","PUBLIC_URL":"","STATE_ABBR":"MT","STATE_NAME":"Montana","STATE_ORG_TITLE":"Secretary of State","LOGIN_HEADER_IMG_PATH":"","HOME_IMG_FILENAME":"montana.jpg","FAVICON_FILE_NAME":"favicon.ico","ALLOW_E_SIGN_ON_CORRECTIONS":true,"THIRD_PARTY_SIGNING_ALLOWED":false,"MY_ACCOUNT_SAVE_AND_CLOSE_BUTTON":true,"IE_DEPRECATED_MESSAGE":"Internet Explorer is not supported. Please select a supported browser below to access this website.","ADDITIONAL_ROUTES":{"dataRequests":true,"farmBill":true,"apostille":true,"externalHelp":"https://sosmt.gov/business/help-center/","systemAdministration":[{"title":"Saved Payments","parameter":"saved-payments","componentName":"SavedPayments"}]},"SUBROUTES":[{"label":"Business","component":"Business","parameter":"business","myWorkQueueSearch":false,"sourceTypeId":54,"searchMustHaveOneOf":["FILING_TYPE_ID","STATUS_ID","STATE","search"],"serverWebSearchDescription":true,"serverWorkQueueDescription":true,"serverMyRecordsDescription":true,"searchPlaceholder":"Search by name or filing number (X########)","allowEmptySearchTerm":true,"requestCertificateAlternateLabel":"Request Information","fileAmendmentButtonLabel":"Filing Actions","advancedSearchParameters":[{"type":"radio","name":"QUERY_TYPE_ID","defaultValue":1010,"options":[{"value":1010,"label":"Starts with"},{"value":1011,"label":"Contains"},{"value":1012,"label":" Word Contains"}]},{"type":"serverSelect","name":"FILING_TYPE_ID","optionsSrc":"FILING_TYPES","label":"Entity Type","placeholder":"All","defaultValue":"0"},{"type":"serverSelect","name":"FILING_SUBTYPE_ID","optionsSrc":"FILING_SUBTYPES","label":"Entity Subtype","overrideSubOptionsSrcFromParameterName":"FILING_TYPE_ID","placeholder":"All","defaultValue":"0"},{"type":"serverSelect","name":"STATUS_ID","optionsSrc":"FILING_STATUS_WITHOUT_ALL","label":"Status","placeholder":"All","defaultValue":"0"},{"type":"serverSelect","name":"STATE","optionsSrc":"STATE","label":"State","placeholder":"All","defaultValue":""},{"type":"serverSelect","name":"COUNTY","optionsSrc":"COUNTY_SUBOPTION","label":"County","overrideSubOptionsSrcFromParameterName":"STATE","placeholder":"All","defaultValue":""},{"type":"checkbox","name":"CRA_SEARCH_YN","defaultValue":false,"label":"Search by Registered Agent PID"},{"type":"dateRange","name":"FILING_DATE","label":"Registration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}},{"type":"dateRange","name":"EXPIRATION_DATE","label":"Expiration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}}],"myRecordsFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Active"},{"value":2,"label":"Inactive"},{"value":3,"label":"Pending"}]},{"type":"dateRange","name":"DATE_RANGE","label":"Date range","defaultValue":{"start":null,"end":null}}],"myWorkQueueFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Approved"},{"value":2,"label":"Pending Online Payment"},{"value":3,"label":"Pending Review"},{"value":4,"label":"Needs Correction"},{"value":5,"label":"Rejected"},{"value":6,"label":"Draft"}]},{"type":"dateRange","name":"DATE_RANGE","label":"Date range","defaultValue":{"start":null,"end":null}}]},{"label":"Notary","component":"Notary","parameter":"notary","sourceTypeId":850,"myWorkQueueSearch":false,"allowEmptySearchTerm":true,"requestCertificateAlternateLabel":"Download Certificate","fileAmendmentButtonLabel":"Filing Actions","hideNameRequestCertificate":true,"hideAddressRequestCertificate":true,"hideRecordUserManagment":true,"searchPlaceholder":"Search by name or commission number","searchMustHaveOneOf":["CITY","search","SERVICE_TYPE"],"advancedParametersStartOpen":true,"searchIsSortable":true,"advancedSearchParameters":[{"type":"radio","name":"STARTS_WITH_YN","defaultValue":false,"options":[{"value":true,"label":"Starts with"},{"value":false,"label":"Contains"}]},{"type":"checkbox","name":"ACTIVE_ONLY_YN","defaultValue":true,"label":"Active entities only"},{"type":"text","name":"CITY","defaultValue":"","label":"City"},{"type":"select","name":"SERVICE_TYPE","label":"Special Services Offered","defaultValue":0,"options":[{"value":0,"label":"(N/A)"},{"value":6165,"label":"In-Person Electronic Notarization (IPEN)"},{"value":6166,"label":"Remote Online Notarization (RON)"},{"value":6167,"label":"Mobile Notary Services"},{"value":6168,"label":"Remote Ink Notarization (RIN)"}]}]},{"label":"Apostille","component":"Apostille","parameter":"apostille","sourceTypeId":720,"myRecordsSearch":false,"myWorkQueueSearch":false,"disabled":false,"allowedRoutes":["/forms-manager/","/queue/","/forms/"]},{"label":"Liens","component":"UCC","parameter":"ucc","sourceTypeId":1999,"myRecordsSearch":true,"myWorkQueueSearch":true,"fileAmendmentButtonLabel":"Filing Actions","searchPlaceholder":"Search by name or file number","disabled":false,"serverWebSearchDescription":true,"myRecordsDescription":"","workQueueDescription":"","searchDescription":"","hideRecordUserManagment":true,"searchLiensCheckout":false,"advancedSearchParameters":[{"type":"radio","name":"STARTS_WITH_YN","defaultValue":false,"options":[{"value":true,"label":"Starts with"},{"value":false,"label":"Contains"}]},{"type":"select","name":"STATUS","defaultValue":"ALL","label":"Status","options":[{"value":"ACTIVE_UNLAPSED","label":"Active (unlapsed)"},{"value":"ACTIVE_LAPSED_UNLAPSED","label":"Active (lapsed and unlapsed)"}]},{"type":"text","name":"EXCLUDE_VALUES","label":"Exclude Debtor Names (comma separated list of names to exclude)","defaultValue":""},{"type":"dateRange","name":"FILING_DATE","label":"Financing Statement Date","defaultValue":{"start":null,"end":null}},{"type":"dateRange","name":"LAPSE_DATE","label":"Lapse Date","defaultValue":{"start":null,"end":null}},{"type":"text","name":"CITY","label":"Debtor City","defaultValue":""}],"myRecordsFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Approved"},{"value":2,"label":"Pending Online Payment"},{"value":3,"label":"Pending Review"}]},{"type":"select","name":"TYPE","defaultValue":0,"label":"Lien Type","options":[{"value":0,"label":"All"},{"value":1,"label":"UCC"},{"value":2,"label":"EFS"},{"value":3,"label":"Title 71"}]}],"myWorkQueueFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Approved"},{"value":2,"label":"Pending Online Payment"},{"value":3,"label":"Pending Review"},{"value":4,"label":"Pending Print and Mail"},{"value":5,"label":"Rejected"},{"value":6,"label":"Draft"}]},{"type":"select","name":"TYPE","defaultValue":0,"label":"Lien Type","options":[{"value":0,"label":"All"},{"value":1,"label":"UCC"},{"value":2,"label":"EFS"},{"value":3,"label":"Title 71"}]}]},{"label":"Copy Request","component":"copies","parameter":"copies","sourceTypeId":2001,"myRecordsSearch":false,"myWorkQueueSearch":false,"disabled":false,"allowedRoutes":["/forms-manager/","/queue/","/forms/"]},{"label":"Trademark","component":"Trademark","parameter":"trademark","sourceTypeId":810,"showRequestCertificate":true,"searchMustHaveOneOf":["search","EXPIRATION_DATE","FILING_DATE"],"allowEmptySearchTerm":true,"requestCertificateAlternateLabel":"Request Information","fileAmendmentButtonLabel":"Filing Actions","advancedSearchParameters":[{"type":"radio","name":"QUERY_TYPE_ID","defaultValue":1010,"options":[{"value":1010,"label":"Starts with"},{"value":1011,"label":"Contains"},{"value":1012,"label":" Word Contains"}]},{"type":"checkbox","name":"OWNER_SEARCH_YN","defaultValue":false,"label":"Search owners"},{"type":"radio","name":"SERVICE_MARK_YN","label":"Mark Type","defaultValue":"","options":[{"value":"","label":"All Marks"},{"value":"Y","label":"Service Mark"},{"value":"N","label":"Trademark"}]},{"type":"serverSelect","name":"STATUS_ID","optionsSrc":"TYPE_V|TRADEMARK_STATUS_TYPE","label":"Status","placeholder":"All","defaultValue":"0"},{"type":"select","name":"DESIGN_TYPE_ID","options":[{"value":0,"label":"All"},{"value":990,"label":"Words Only"},{"value":991,"label":"Design Only"},{"value":992,"label":"Words and Design"}],"label":"Design Type","defaultValue":"0"},{"type":"dateRange","name":"FILING_DATE","label":"Registered Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}},{"type":"dateRange","name":"EXPIRATION_DATE","label":"Expiration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}}]},{"label":"Business Info Request","component":"InfoRequests","parameter":"info-request","sourceTypeId":167,"allowedRoutes":["/forms-manager/","/queue/","/forms/"]},{"label":"Data Requests","component":"DataRequests","parameter":"data-request","sourceTypeId":0,"allowedRoutes":["/forms-manager/"]},{"label":"CRA","component":"CRA","parameter":"cra","sourceTypeId":157,"myRecordsSearch":false,"searchPlaceholder":"Search by name or registered agent number","allowedRoutes":["/forms-manager/","/forms/","/records/","/queue/","/search/"],"allowEmptySearchTerm":true,"fileAmendmentButtonLabel":"Filing Actions","advancedSearchParameters":[{"type":"radio","name":"QUERY_TYPE_ID","defaultValue":1010,"options":[{"value":1010,"label":"Starts with"},{"value":1011,"label":"Contains"},{"value":1012,"label":" Word Contains"}]},{"type":"dateRange","name":"CRA_DATE","label":"Registration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}},{"type":"select","name":"STATUS_ID","label":"Status","defaultValue":0,"options":[{"value":0,"label":"All"},{"value":121,"label":"Active"},{"value":122,"label":"Inactive"}]},{"type":"select","name":"AGENT_TYPE_ID","label":"Agent Type","defaultValue":0,"options":[{"value":0,"label":"All"},{"value":460,"label":"Registered Agent"},{"value":461,"label":"Commercial Registered Agent"}]}]},{"label":"Farm Bill","component":"FarmBill","parameter":"farm-bill","path":"/lists/farm-bill","sourceTypeId":0,"myRecordsSearch":false,"allowedRules":["/search/"],"disabled":true,"searchDescription":"To perform a search, enter a debtor name. Your search results may include: exact debtor name, variations of that name and any filing that includes your search criteria. Punctuation is ignored.\n\nYou can click on \"Advanced\" to refine your search. Under “Advanced” you can search by crop, year, county and SSN/FEIN. As a registered Farm Bill Buyer with the Montana Secretary of State’s office it is important to maintain the confidentiality of the information contained within the Farm Bill Master List. The Farm Bill Master List reflects personal data, such as Social Security Numbers, which are a key piece of personal identifiable information to assist you in determining the existence of a lien against a specific debtor. The distribution of this information beyond its intended purpose is strictly prohibited.\n\nThe debtor's tax identification number has been hidden for confidentiality reasons. You may continue to search on a tax ID number and return debtors that match your search criteria. The SSN/FEIN must be entered without dashes or spaces.","searchMustHaveOneOf":["search","UCC_FARM_PRODUCT_ID","COUNTY"],"searchPlaceholder":"Search by debtor name","advancedSearchParameters":[{"type":"ServerMultiComplete","label":"Product code name(s)","name":"UCC_FARM_PRODUCT_ID","defaultValue":"","optionsSrc":"UCC_FARM_PRODUCT_V"},{"type":"MultiComplete","label":"Year or Range of Years","name":"YEAR_NUM","optionsSrc":"years","startYear":"1968","defaultValue":[],"preMergeOptions":[{"value":"ALL","label":"All"}]},{"type":"serverSelect","label":"State","name":"STATE","defaultValue":"MONTANA","optionsSrc":"STATE"},{"type":"ServerMultiComplete","label":"County","name":"COUNTY","defaultValue":[],"optionsSrc":"COUNTY","overrideSubOptionsSrcFromParameterName":"STATE"},{"type":"checkbox","name":"TIN_SEARCH_YN","defaultValue":false,"label":"Tax Identification Number Search"},{"type":"checkbox","name":"TIN_SORT_YN","defaultValue":false,"label":"Unique ID Sort"}]}],"SYSTEM_NICKNAME":"Online Services Portal","PAYMENT_METHODS":[{"type":"bypass"},{"type":"iTransact"}],"PAYMENT_ALLOW_AMEX":true,"SYSTEM_ID_LABEL":"System Id","DOUBLE_COLUMN_PUBLIC_LOGIN":true,"INTERNAL_USER_MANAGEMENT":true,"ALLOW_PUBLIC_JSON_IMPORT":false,"MAX_FILE_UPLOAD_SIZE":10000000,"REFUND_TEXT":"","RETURN_TO_HOME_ON_LOGOUT":true,"CURRENT_SOS_NAME":"Christi Jacobsen","LOGO_FILENAME":"mt-sos-logo.png","LOGO_ALT":"Christi Jacobsen, Montana Secretary of State","LOGO_FULL_WIDTH":true,"HOME_HIDE_AUTH_HINT":true,"HOME_TITLE":"Montana Secretary of State","CUSTOM_TAB_TITLE":"Official Montana","HOME_SUBTITLE":"Online Business Services","ENTITY_NAME_CONSENT_DESCRIPTION":"","ALLOW_USER_PROFILE_EDITING":true,"COMPARE_FOREIGN_NAME_IN_ENTITY_NAME_VALIDATION":true,"FOREIGN_NAME_FIELD_NAME":"KIMA_PARENT_NAME_INFO","LOGIN_TITLE":"Montana Secretary of State Online Filing Portal Login","PUBLIC_LOGIN_LABEL":"Username","REVERSE_LOGIN_COLUMNS":true,"LOGIN_SEAL_FILENAME":"seal_white.png","SEPARATE_USERNAME_AND_EMAIL":true,"CREATE_ACCOUNT_BUTTON_ALIGN_LEFT":true,"CREATE_ACCOUNT_BUTTON_TEXT":"CREATE AN ACCOUNT","PASSWORD_CUSTOM_ERROR_TEXT":"The password must meet all requirements","ACCOUNT_CREATED_MESSAGE":"Please check your email to verify your account to login and allow a few minutes for this message to arrive. Check your junk/spam folders if you do not find the email in your inbox.","PUBLIC_LOGIN_PLACEHOLDER":" ","DISABLE_DEFAULT_PAYMENT_RADIO":true,"CUSTOM_RESET_PASSWORD_ERROR_MESSAGE":"Username invalid - no account found","PUBLIC_LOGIN_CREATE_DESCRIPTION":"### Existing User:\n\n  - Enter your username and password to login.  \n\n\n  #### - OR -  \n\n\n\n  - Forgot password? Click 'Reset Password' and follow the prompts.\n  - Forgot username? Click 'Forgot Username' and follow the prompts.  \n\n\n  ### New User:\n  ","LOGIN_HELP_LINK":"https://sosmt.gov/business/how-do-i/","LOGIN_HELP_LINK_TEXT":"Need Help?","FORGOT_USERNAME_TEXT":"Forgot Username?","LOGIN_ACTIVE_DIRECTORY_TEXT":"State User Login","MULTIPLE_LOGIN_METHODS":true,"HAS_ACTIVE_DIRECTORY_LOGIN":true,"RESET_PASSWORD_WITH_USERNAME":true,"DOWNLOAD_LINK":true,"SHOW_USERNAME_ACCOUNT_CREATE":true,"SHOW_SCROLL_DOWN_ARROW":true,"SHOW_ADDRESS_ACCOUNT_CREATE":true,"TWO_COLUMN_ACCOUNT_CREATE":true,"RESET_PASSWORD_TIP":"A link to change your password has been sent to your email. Please allow a few minutes for this message to arrive. Please check your junk/spam folders if you do not find the email in your inbox.","FORGOT_PASSWORD_LINK_TEXT":"Reset Password","PHONE_NUMBER_OPTIONAL_ACCOUNT_CREATE":true,"SHOW_REQUIRED_INDICATOR_ACCOUNT_CREATE":true,"PASSWORD_REQUIREMENTS_ACCOUNT_CREATE":"\n    <ul>\n      <li>MUST contain at least 8 characters (12+ recommended)</li>\n      <li>MUST contain at least one uppercase letter.</li>\n      <li>MUST contain at least one lowercase letter.</li>\n      <li>MUST contain at least one number.</li>\n      <li>MUST contain at least one special character (!”#$%&'()*+,-./:;<=>?</li>\n    </ul>\n  ","ALLOW_CERTIFICATION_REQUEST":true,"ALLOW_PUBLIC_CERTIFICATE_REQUEST":true,"ALLOW_COPY_REQUEST":false,"ALLOW_CORRECTION_STYLING":true,"HIDE_DEPRECATION_WARNING":false,"AMEND_ROUTE_PUBLIC":true,"SEAL_FILENAME":"seal.png","SHOPPING_CART":true,"ALLOW_PAYMENT_UPDATE_WITH_EMPTY_CART":true,"RA_EMAIL":true,"RA_WEBSITE":true,"RA_NO_DEFAULT_TYPE":true,"RA_ADDRESS_LABEL":"Street Address","RA_TYPE_SELECTION_DEFAULT":true,"RA_DEFAULT_TYPE":"460","RA_OVERRIDE_TYPE_WITH_DEFAULT":true,"RA_PRINCIPAL_ADDRESS_AMS":true,"UPLOAD_AND_SUBMIT_HIDE_IF_ONE_OPTION":true,"PAYMENT_PROCESSING_MESSAGE":"Your payment is processing - Do not close your browser or click the back button","CHECKOUT_BUTTON_WHEN_PROCESSING_TEXT":"Processing","EFS_CROP_PICKER_NONE_LABEL":"Lien Duration","DISALLOWED_WIZARD_PIECES":["FormationLocale"],"REPEATER_SHOW_EDIT_BUTTON":true,"DATA_REQUEST_PAGE_TITLE":"Data Requests and Subscriptions","DATA_REQUEST_SIDEBAR_LABEL":"Data Requests & Subscriptions","LOGIN_REDIRECTS_TO_EPASS":false,"LOGIN_REDIRECTS_TO_ACTIVE_DIRECTORY":true,"LOGIN_ACTIVE_DIRECTORY_LINK":true,"FETCH_EDIT_USER_LINK":false,"LISTS_FETCH_AVAILABLE_LISTS":true,"POST_WIZARD_SUBMIT_REDIRECT_URL":"/","PIN_REQUEST_ATTESTATIONS":true,"PIN_REQUEST_DESCRIPTION":"Click **Request PIN** to have a new PIN sent to the account holder's email address on file.","OWNERSHIP_REQUEST_DESCRIPTION":"To become an **authorized user** of this record, a current **AUTHORIZED USER** will need to grant you access. To request access, click **Request Access** below.","PIN_REQUEST_SUCCESS_MESSAGE":"The PIN you have requested for this entity has been sent to the email associated with your user account.  You should receive the PIN in approximately 3-5 minutes, depending on your email service provider.","APOSTILLE_HEADER_LABEL":"Verification Information","APOSTILLE_NUMBER_LABEL":"Apostille/Authentication","APOSTILLE_CITY_STATE_OVERRIDE":"HELENA, MT","APOSTILLE_FILING_DATE_LABEL":"Issue Date","APOSTILLE_CITY_STATE_IN_CERTIFIED":true,"NOTARY_EXISTING_FILING":true,"ALLOW_REVOKE_OWN_ACCESS_ONLY":false,"HIDE_CANCEL_ON_ONETIME_DATA_REQUESTS":true,"DATA_REQUESTS_IN_SHOPPING_CART":true,"WQ_ALLOW_EDIT_PENDING_PAYMENT":true,"WQ_CONFIRM_ON_DELETE":true,"WQ_DELETE_CONFIRM_MESSAGE":"Deleting this filing will forfeit any money already paid to the Secretary of State. This action is permanent and cannot be undone, are you sure you would like to delete?","PASS_ITEM_GUIDS_ON_CHECKOUT":true,"FORM_REVISION_HISTORY":true,"CHECKOUT_DISCLAIMER":"By entering your credit card and/or checking account information you (i) state that **you are an authorized user** of the credit card and/or electronic check and that the associated information entered (e.g., account holder name, account number, billing address) is accurate, (ii) **you authorize payment processor to charge the amount you have requested** to your credit card and/or funding account, and (iii) **acknowledge if a charge is declined or reversed you may also be assessed a customary charge** by the payment processor for such transactions.","FARM_BILL_SEARCH_CONFIDENTIAL":"As a registered Farm Bill Buyer with the Montana Secretary of State’s office it is important to maintain the confidentiality of the information contained within the Farm Bill Master List. The Farm Bill Master List reflects personal data, such as Social Security Numbers, which are a key piece of personal identifiable information to assist you in determining the existence of a lien against a specific debtor. The distribution of this information beyond its intended purpose is strictly prohibited.\n\n**The debtor's tax identification number has been hidden for confidentiality reasons. You may continue to search on a tax ID number and return debtors that match your search criteria. The SSN/FEIN must be entered without dashes or spaces.  If you need access to the tax identification number to clearly identify the debtor, please contact the UCC unit at (406) 444-3665.**","VIEW_HISTORY_BUTTON_ALT_TEXT":"View Filings","WIZARD_ERROR_TITLE_MESSAGE":"Form Error","FARM_BILL_SEARCH_INTERACTIVE":true,"USE_FARM_BILL_API":true,"DISALLOW_ASSIGN_SELF_AS_RA":true,"DISALLOW_ASSIGN_SELF_AS_PRINCIPAL":true,"USE_TRADEMARK_OWNER_VALIDATION":true,"USE_ALTERNATIVE_FOREIGN_ADDRESS_LABELS":true,"MY_RECEIPTS_FILTER":[{"type":"dateRange","name":"DATE_RANGE","label":"Date range","defaultValue":{"start":null,"end":null}},{"type":"text","name":"REF_NUM","defaultValue":"","label":"Reference Number"},{"type":"text","name":"RECEIPT_NUM","defaultValue":"","label":"Receipt Id"},{"type":"text","name":"AMOUNT","defaultValue":"","label":"Amount"},{"type":"select","name":"TYPE","defaultValue":"","label":"Payment Type","options":[{"value":"","label":"All"},{"value":"CC","label":"Credit Card"},{"value":"Check","label":"Check"}]}],"MY_RECEIPTS_SHOW_IN_SIDEBAR":true,"SHOW_MY_RECEIPTS_HELPER_TEXT":true,"MY_RECEIPTS_HELPER_LABEL":"About Receipt Search","MY_RECEIPTS_HELPER_TEXT":"You can search for receipts based on their descriptions, including the items paid for on the receipt. Use the filters to search for or filter specific information.","FARM_BILL_SUBLINK":{"label":"Farm Bill","component":"FarmBill","parameter":"farm-bill","path":"/lists/farm-bill","sourceTypeId":0,"myRecordsSearch":false,"allowedRules":["/search/"],"disabled":true,"searchDescription":"To perform a search, enter a debtor name. Your search results may include: exact debtor name, variations of that name and any filing that includes your search criteria. Punctuation is ignored.\n\nYou can click on \"Advanced\" to refine your search. Under “Advanced” you can search by crop, year, county and SSN/FEIN. As a registered Farm Bill Buyer with the Montana Secretary of State’s office it is important to maintain the confidentiality of the information contained within the Farm Bill Master List. The Farm Bill Master List reflects personal data, such as Social Security Numbers, which are a key piece of personal identifiable information to assist you in determining the existence of a lien against a specific debtor. The distribution of this information beyond its intended purpose is strictly prohibited.\n\nThe debtor's tax identification number has been hidden for confidentiality reasons. You may continue to search on a tax ID number and return debtors that match your search criteria. The SSN/FEIN must be entered without dashes or spaces.","searchMustHaveOneOf":["search","UCC_FARM_PRODUCT_ID","COUNTY"],"searchPlaceholder":"Search by debtor name","advancedSearchParameters":[{"type":"ServerMultiComplete","label":"Product code name(s)","name":"UCC_FARM_PRODUCT_ID","defaultValue":"","optionsSrc":"UCC_FARM_PRODUCT_V"},{"type":"MultiComplete","label":"Year or Range of Years","name":"YEAR_NUM","optionsSrc":"years","startYear":"1968","defaultValue":[],"preMergeOptions":[{"value":"ALL","label":"All"}]},{"type":"serverSelect","label":"State","name":"STATE","defaultValue":"MONTANA","optionsSrc":"STATE"},{"type":"ServerMultiComplete","label":"County","name":"COUNTY","defaultValue":[],"optionsSrc":"COUNTY","overrideSubOptionsSrcFromParameterName":"STATE"},{"type":"checkbox","name":"TIN_SEARCH_YN","defaultValue":false,"label":"Tax Identification Number Search"},{"type":"checkbox","name":"TIN_SORT_YN","defaultValue":false,"label":"Unique ID Sort"}]},"ALLOW_ADDRESS_VALIDATION_BYPASS_OPTION":true,"DEFAULT_ADDRESS_VALIDATION_BYPASS_OPTION_CHECKED":true}).MY_WORK_QUEUE_SEARCH_PLACEHOLDER;
	var WQ_ALLOW_DELETE_PRINT_MAIL = ({"NODE_ENV":"production","BUILD_DATE":"2025-08-27T15:15:31.687Z","BUILD_NUMBER":"Not Provided","GIT_VERSION":"v1.3.0-381-ga81e29b08","GIT_COMMIT_HASH":"a81e29b085c9268ffd96c78eb734365802722741","GIT_BRANCH":"beta","PUBLIC_URL":"","STATE_ABBR":"MT","STATE_NAME":"Montana","STATE_ORG_TITLE":"Secretary of State","LOGIN_HEADER_IMG_PATH":"","HOME_IMG_FILENAME":"montana.jpg","FAVICON_FILE_NAME":"favicon.ico","ALLOW_E_SIGN_ON_CORRECTIONS":true,"THIRD_PARTY_SIGNING_ALLOWED":false,"MY_ACCOUNT_SAVE_AND_CLOSE_BUTTON":true,"IE_DEPRECATED_MESSAGE":"Internet Explorer is not supported. Please select a supported browser below to access this website.","ADDITIONAL_ROUTES":{"dataRequests":true,"farmBill":true,"apostille":true,"externalHelp":"https://sosmt.gov/business/help-center/","systemAdministration":[{"title":"Saved Payments","parameter":"saved-payments","componentName":"SavedPayments"}]},"SUBROUTES":[{"label":"Business","component":"Business","parameter":"business","myWorkQueueSearch":false,"sourceTypeId":54,"searchMustHaveOneOf":["FILING_TYPE_ID","STATUS_ID","STATE","search"],"serverWebSearchDescription":true,"serverWorkQueueDescription":true,"serverMyRecordsDescription":true,"searchPlaceholder":"Search by name or filing number (X########)","allowEmptySearchTerm":true,"requestCertificateAlternateLabel":"Request Information","fileAmendmentButtonLabel":"Filing Actions","advancedSearchParameters":[{"type":"radio","name":"QUERY_TYPE_ID","defaultValue":1010,"options":[{"value":1010,"label":"Starts with"},{"value":1011,"label":"Contains"},{"value":1012,"label":" Word Contains"}]},{"type":"serverSelect","name":"FILING_TYPE_ID","optionsSrc":"FILING_TYPES","label":"Entity Type","placeholder":"All","defaultValue":"0"},{"type":"serverSelect","name":"FILING_SUBTYPE_ID","optionsSrc":"FILING_SUBTYPES","label":"Entity Subtype","overrideSubOptionsSrcFromParameterName":"FILING_TYPE_ID","placeholder":"All","defaultValue":"0"},{"type":"serverSelect","name":"STATUS_ID","optionsSrc":"FILING_STATUS_WITHOUT_ALL","label":"Status","placeholder":"All","defaultValue":"0"},{"type":"serverSelect","name":"STATE","optionsSrc":"STATE","label":"State","placeholder":"All","defaultValue":""},{"type":"serverSelect","name":"COUNTY","optionsSrc":"COUNTY_SUBOPTION","label":"County","overrideSubOptionsSrcFromParameterName":"STATE","placeholder":"All","defaultValue":""},{"type":"checkbox","name":"CRA_SEARCH_YN","defaultValue":false,"label":"Search by Registered Agent PID"},{"type":"dateRange","name":"FILING_DATE","label":"Registration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}},{"type":"dateRange","name":"EXPIRATION_DATE","label":"Expiration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}}],"myRecordsFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Active"},{"value":2,"label":"Inactive"},{"value":3,"label":"Pending"}]},{"type":"dateRange","name":"DATE_RANGE","label":"Date range","defaultValue":{"start":null,"end":null}}],"myWorkQueueFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Approved"},{"value":2,"label":"Pending Online Payment"},{"value":3,"label":"Pending Review"},{"value":4,"label":"Needs Correction"},{"value":5,"label":"Rejected"},{"value":6,"label":"Draft"}]},{"type":"dateRange","name":"DATE_RANGE","label":"Date range","defaultValue":{"start":null,"end":null}}]},{"label":"Notary","component":"Notary","parameter":"notary","sourceTypeId":850,"myWorkQueueSearch":false,"allowEmptySearchTerm":true,"requestCertificateAlternateLabel":"Download Certificate","fileAmendmentButtonLabel":"Filing Actions","hideNameRequestCertificate":true,"hideAddressRequestCertificate":true,"hideRecordUserManagment":true,"searchPlaceholder":"Search by name or commission number","searchMustHaveOneOf":["CITY","search","SERVICE_TYPE"],"advancedParametersStartOpen":true,"searchIsSortable":true,"advancedSearchParameters":[{"type":"radio","name":"STARTS_WITH_YN","defaultValue":false,"options":[{"value":true,"label":"Starts with"},{"value":false,"label":"Contains"}]},{"type":"checkbox","name":"ACTIVE_ONLY_YN","defaultValue":true,"label":"Active entities only"},{"type":"text","name":"CITY","defaultValue":"","label":"City"},{"type":"select","name":"SERVICE_TYPE","label":"Special Services Offered","defaultValue":0,"options":[{"value":0,"label":"(N/A)"},{"value":6165,"label":"In-Person Electronic Notarization (IPEN)"},{"value":6166,"label":"Remote Online Notarization (RON)"},{"value":6167,"label":"Mobile Notary Services"},{"value":6168,"label":"Remote Ink Notarization (RIN)"}]}]},{"label":"Apostille","component":"Apostille","parameter":"apostille","sourceTypeId":720,"myRecordsSearch":false,"myWorkQueueSearch":false,"disabled":false,"allowedRoutes":["/forms-manager/","/queue/","/forms/"]},{"label":"Liens","component":"UCC","parameter":"ucc","sourceTypeId":1999,"myRecordsSearch":true,"myWorkQueueSearch":true,"fileAmendmentButtonLabel":"Filing Actions","searchPlaceholder":"Search by name or file number","disabled":false,"serverWebSearchDescription":true,"myRecordsDescription":"","workQueueDescription":"","searchDescription":"","hideRecordUserManagment":true,"searchLiensCheckout":false,"advancedSearchParameters":[{"type":"radio","name":"STARTS_WITH_YN","defaultValue":false,"options":[{"value":true,"label":"Starts with"},{"value":false,"label":"Contains"}]},{"type":"select","name":"STATUS","defaultValue":"ALL","label":"Status","options":[{"value":"ACTIVE_UNLAPSED","label":"Active (unlapsed)"},{"value":"ACTIVE_LAPSED_UNLAPSED","label":"Active (lapsed and unlapsed)"}]},{"type":"text","name":"EXCLUDE_VALUES","label":"Exclude Debtor Names (comma separated list of names to exclude)","defaultValue":""},{"type":"dateRange","name":"FILING_DATE","label":"Financing Statement Date","defaultValue":{"start":null,"end":null}},{"type":"dateRange","name":"LAPSE_DATE","label":"Lapse Date","defaultValue":{"start":null,"end":null}},{"type":"text","name":"CITY","label":"Debtor City","defaultValue":""}],"myRecordsFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Approved"},{"value":2,"label":"Pending Online Payment"},{"value":3,"label":"Pending Review"}]},{"type":"select","name":"TYPE","defaultValue":0,"label":"Lien Type","options":[{"value":0,"label":"All"},{"value":1,"label":"UCC"},{"value":2,"label":"EFS"},{"value":3,"label":"Title 71"}]}],"myWorkQueueFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Approved"},{"value":2,"label":"Pending Online Payment"},{"value":3,"label":"Pending Review"},{"value":4,"label":"Pending Print and Mail"},{"value":5,"label":"Rejected"},{"value":6,"label":"Draft"}]},{"type":"select","name":"TYPE","defaultValue":0,"label":"Lien Type","options":[{"value":0,"label":"All"},{"value":1,"label":"UCC"},{"value":2,"label":"EFS"},{"value":3,"label":"Title 71"}]}]},{"label":"Copy Request","component":"copies","parameter":"copies","sourceTypeId":2001,"myRecordsSearch":false,"myWorkQueueSearch":false,"disabled":false,"allowedRoutes":["/forms-manager/","/queue/","/forms/"]},{"label":"Trademark","component":"Trademark","parameter":"trademark","sourceTypeId":810,"showRequestCertificate":true,"searchMustHaveOneOf":["search","EXPIRATION_DATE","FILING_DATE"],"allowEmptySearchTerm":true,"requestCertificateAlternateLabel":"Request Information","fileAmendmentButtonLabel":"Filing Actions","advancedSearchParameters":[{"type":"radio","name":"QUERY_TYPE_ID","defaultValue":1010,"options":[{"value":1010,"label":"Starts with"},{"value":1011,"label":"Contains"},{"value":1012,"label":" Word Contains"}]},{"type":"checkbox","name":"OWNER_SEARCH_YN","defaultValue":false,"label":"Search owners"},{"type":"radio","name":"SERVICE_MARK_YN","label":"Mark Type","defaultValue":"","options":[{"value":"","label":"All Marks"},{"value":"Y","label":"Service Mark"},{"value":"N","label":"Trademark"}]},{"type":"serverSelect","name":"STATUS_ID","optionsSrc":"TYPE_V|TRADEMARK_STATUS_TYPE","label":"Status","placeholder":"All","defaultValue":"0"},{"type":"select","name":"DESIGN_TYPE_ID","options":[{"value":0,"label":"All"},{"value":990,"label":"Words Only"},{"value":991,"label":"Design Only"},{"value":992,"label":"Words and Design"}],"label":"Design Type","defaultValue":"0"},{"type":"dateRange","name":"FILING_DATE","label":"Registered Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}},{"type":"dateRange","name":"EXPIRATION_DATE","label":"Expiration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}}]},{"label":"Business Info Request","component":"InfoRequests","parameter":"info-request","sourceTypeId":167,"allowedRoutes":["/forms-manager/","/queue/","/forms/"]},{"label":"Data Requests","component":"DataRequests","parameter":"data-request","sourceTypeId":0,"allowedRoutes":["/forms-manager/"]},{"label":"CRA","component":"CRA","parameter":"cra","sourceTypeId":157,"myRecordsSearch":false,"searchPlaceholder":"Search by name or registered agent number","allowedRoutes":["/forms-manager/","/forms/","/records/","/queue/","/search/"],"allowEmptySearchTerm":true,"fileAmendmentButtonLabel":"Filing Actions","advancedSearchParameters":[{"type":"radio","name":"QUERY_TYPE_ID","defaultValue":1010,"options":[{"value":1010,"label":"Starts with"},{"value":1011,"label":"Contains"},{"value":1012,"label":" Word Contains"}]},{"type":"dateRange","name":"CRA_DATE","label":"Registration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}},{"type":"select","name":"STATUS_ID","label":"Status","defaultValue":0,"options":[{"value":0,"label":"All"},{"value":121,"label":"Active"},{"value":122,"label":"Inactive"}]},{"type":"select","name":"AGENT_TYPE_ID","label":"Agent Type","defaultValue":0,"options":[{"value":0,"label":"All"},{"value":460,"label":"Registered Agent"},{"value":461,"label":"Commercial Registered Agent"}]}]},{"label":"Farm Bill","component":"FarmBill","parameter":"farm-bill","path":"/lists/farm-bill","sourceTypeId":0,"myRecordsSearch":false,"allowedRules":["/search/"],"disabled":true,"searchDescription":"To perform a search, enter a debtor name. Your search results may include: exact debtor name, variations of that name and any filing that includes your search criteria. Punctuation is ignored.\n\nYou can click on \"Advanced\" to refine your search. Under “Advanced” you can search by crop, year, county and SSN/FEIN. As a registered Farm Bill Buyer with the Montana Secretary of State’s office it is important to maintain the confidentiality of the information contained within the Farm Bill Master List. The Farm Bill Master List reflects personal data, such as Social Security Numbers, which are a key piece of personal identifiable information to assist you in determining the existence of a lien against a specific debtor. The distribution of this information beyond its intended purpose is strictly prohibited.\n\nThe debtor's tax identification number has been hidden for confidentiality reasons. You may continue to search on a tax ID number and return debtors that match your search criteria. The SSN/FEIN must be entered without dashes or spaces.","searchMustHaveOneOf":["search","UCC_FARM_PRODUCT_ID","COUNTY"],"searchPlaceholder":"Search by debtor name","advancedSearchParameters":[{"type":"ServerMultiComplete","label":"Product code name(s)","name":"UCC_FARM_PRODUCT_ID","defaultValue":"","optionsSrc":"UCC_FARM_PRODUCT_V"},{"type":"MultiComplete","label":"Year or Range of Years","name":"YEAR_NUM","optionsSrc":"years","startYear":"1968","defaultValue":[],"preMergeOptions":[{"value":"ALL","label":"All"}]},{"type":"serverSelect","label":"State","name":"STATE","defaultValue":"MONTANA","optionsSrc":"STATE"},{"type":"ServerMultiComplete","label":"County","name":"COUNTY","defaultValue":[],"optionsSrc":"COUNTY","overrideSubOptionsSrcFromParameterName":"STATE"},{"type":"checkbox","name":"TIN_SEARCH_YN","defaultValue":false,"label":"Tax Identification Number Search"},{"type":"checkbox","name":"TIN_SORT_YN","defaultValue":false,"label":"Unique ID Sort"}]}],"SYSTEM_NICKNAME":"Online Services Portal","PAYMENT_METHODS":[{"type":"bypass"},{"type":"iTransact"}],"PAYMENT_ALLOW_AMEX":true,"SYSTEM_ID_LABEL":"System Id","DOUBLE_COLUMN_PUBLIC_LOGIN":true,"INTERNAL_USER_MANAGEMENT":true,"ALLOW_PUBLIC_JSON_IMPORT":false,"MAX_FILE_UPLOAD_SIZE":10000000,"REFUND_TEXT":"","RETURN_TO_HOME_ON_LOGOUT":true,"CURRENT_SOS_NAME":"Christi Jacobsen","LOGO_FILENAME":"mt-sos-logo.png","LOGO_ALT":"Christi Jacobsen, Montana Secretary of State","LOGO_FULL_WIDTH":true,"HOME_HIDE_AUTH_HINT":true,"HOME_TITLE":"Montana Secretary of State","CUSTOM_TAB_TITLE":"Official Montana","HOME_SUBTITLE":"Online Business Services","ENTITY_NAME_CONSENT_DESCRIPTION":"","ALLOW_USER_PROFILE_EDITING":true,"COMPARE_FOREIGN_NAME_IN_ENTITY_NAME_VALIDATION":true,"FOREIGN_NAME_FIELD_NAME":"KIMA_PARENT_NAME_INFO","LOGIN_TITLE":"Montana Secretary of State Online Filing Portal Login","PUBLIC_LOGIN_LABEL":"Username","REVERSE_LOGIN_COLUMNS":true,"LOGIN_SEAL_FILENAME":"seal_white.png","SEPARATE_USERNAME_AND_EMAIL":true,"CREATE_ACCOUNT_BUTTON_ALIGN_LEFT":true,"CREATE_ACCOUNT_BUTTON_TEXT":"CREATE AN ACCOUNT","PASSWORD_CUSTOM_ERROR_TEXT":"The password must meet all requirements","ACCOUNT_CREATED_MESSAGE":"Please check your email to verify your account to login and allow a few minutes for this message to arrive. Check your junk/spam folders if you do not find the email in your inbox.","PUBLIC_LOGIN_PLACEHOLDER":" ","DISABLE_DEFAULT_PAYMENT_RADIO":true,"CUSTOM_RESET_PASSWORD_ERROR_MESSAGE":"Username invalid - no account found","PUBLIC_LOGIN_CREATE_DESCRIPTION":"### Existing User:\n\n  - Enter your username and password to login.  \n\n\n  #### - OR -  \n\n\n\n  - Forgot password? Click 'Reset Password' and follow the prompts.\n  - Forgot username? Click 'Forgot Username' and follow the prompts.  \n\n\n  ### New User:\n  ","LOGIN_HELP_LINK":"https://sosmt.gov/business/how-do-i/","LOGIN_HELP_LINK_TEXT":"Need Help?","FORGOT_USERNAME_TEXT":"Forgot Username?","LOGIN_ACTIVE_DIRECTORY_TEXT":"State User Login","MULTIPLE_LOGIN_METHODS":true,"HAS_ACTIVE_DIRECTORY_LOGIN":true,"RESET_PASSWORD_WITH_USERNAME":true,"DOWNLOAD_LINK":true,"SHOW_USERNAME_ACCOUNT_CREATE":true,"SHOW_SCROLL_DOWN_ARROW":true,"SHOW_ADDRESS_ACCOUNT_CREATE":true,"TWO_COLUMN_ACCOUNT_CREATE":true,"RESET_PASSWORD_TIP":"A link to change your password has been sent to your email. Please allow a few minutes for this message to arrive. Please check your junk/spam folders if you do not find the email in your inbox.","FORGOT_PASSWORD_LINK_TEXT":"Reset Password","PHONE_NUMBER_OPTIONAL_ACCOUNT_CREATE":true,"SHOW_REQUIRED_INDICATOR_ACCOUNT_CREATE":true,"PASSWORD_REQUIREMENTS_ACCOUNT_CREATE":"\n    <ul>\n      <li>MUST contain at least 8 characters (12+ recommended)</li>\n      <li>MUST contain at least one uppercase letter.</li>\n      <li>MUST contain at least one lowercase letter.</li>\n      <li>MUST contain at least one number.</li>\n      <li>MUST contain at least one special character (!”#$%&'()*+,-./:;<=>?</li>\n    </ul>\n  ","ALLOW_CERTIFICATION_REQUEST":true,"ALLOW_PUBLIC_CERTIFICATE_REQUEST":true,"ALLOW_COPY_REQUEST":false,"ALLOW_CORRECTION_STYLING":true,"HIDE_DEPRECATION_WARNING":false,"AMEND_ROUTE_PUBLIC":true,"SEAL_FILENAME":"seal.png","SHOPPING_CART":true,"ALLOW_PAYMENT_UPDATE_WITH_EMPTY_CART":true,"RA_EMAIL":true,"RA_WEBSITE":true,"RA_NO_DEFAULT_TYPE":true,"RA_ADDRESS_LABEL":"Street Address","RA_TYPE_SELECTION_DEFAULT":true,"RA_DEFAULT_TYPE":"460","RA_OVERRIDE_TYPE_WITH_DEFAULT":true,"RA_PRINCIPAL_ADDRESS_AMS":true,"UPLOAD_AND_SUBMIT_HIDE_IF_ONE_OPTION":true,"PAYMENT_PROCESSING_MESSAGE":"Your payment is processing - Do not close your browser or click the back button","CHECKOUT_BUTTON_WHEN_PROCESSING_TEXT":"Processing","EFS_CROP_PICKER_NONE_LABEL":"Lien Duration","DISALLOWED_WIZARD_PIECES":["FormationLocale"],"REPEATER_SHOW_EDIT_BUTTON":true,"DATA_REQUEST_PAGE_TITLE":"Data Requests and Subscriptions","DATA_REQUEST_SIDEBAR_LABEL":"Data Requests & Subscriptions","LOGIN_REDIRECTS_TO_EPASS":false,"LOGIN_REDIRECTS_TO_ACTIVE_DIRECTORY":true,"LOGIN_ACTIVE_DIRECTORY_LINK":true,"FETCH_EDIT_USER_LINK":false,"LISTS_FETCH_AVAILABLE_LISTS":true,"POST_WIZARD_SUBMIT_REDIRECT_URL":"/","PIN_REQUEST_ATTESTATIONS":true,"PIN_REQUEST_DESCRIPTION":"Click **Request PIN** to have a new PIN sent to the account holder's email address on file.","OWNERSHIP_REQUEST_DESCRIPTION":"To become an **authorized user** of this record, a current **AUTHORIZED USER** will need to grant you access. To request access, click **Request Access** below.","PIN_REQUEST_SUCCESS_MESSAGE":"The PIN you have requested for this entity has been sent to the email associated with your user account.  You should receive the PIN in approximately 3-5 minutes, depending on your email service provider.","APOSTILLE_HEADER_LABEL":"Verification Information","APOSTILLE_NUMBER_LABEL":"Apostille/Authentication","APOSTILLE_CITY_STATE_OVERRIDE":"HELENA, MT","APOSTILLE_FILING_DATE_LABEL":"Issue Date","APOSTILLE_CITY_STATE_IN_CERTIFIED":true,"NOTARY_EXISTING_FILING":true,"ALLOW_REVOKE_OWN_ACCESS_ONLY":false,"HIDE_CANCEL_ON_ONETIME_DATA_REQUESTS":true,"DATA_REQUESTS_IN_SHOPPING_CART":true,"WQ_ALLOW_EDIT_PENDING_PAYMENT":true,"WQ_CONFIRM_ON_DELETE":true,"WQ_DELETE_CONFIRM_MESSAGE":"Deleting this filing will forfeit any money already paid to the Secretary of State. This action is permanent and cannot be undone, are you sure you would like to delete?","PASS_ITEM_GUIDS_ON_CHECKOUT":true,"FORM_REVISION_HISTORY":true,"CHECKOUT_DISCLAIMER":"By entering your credit card and/or checking account information you (i) state that **you are an authorized user** of the credit card and/or electronic check and that the associated information entered (e.g., account holder name, account number, billing address) is accurate, (ii) **you authorize payment processor to charge the amount you have requested** to your credit card and/or funding account, and (iii) **acknowledge if a charge is declined or reversed you may also be assessed a customary charge** by the payment processor for such transactions.","FARM_BILL_SEARCH_CONFIDENTIAL":"As a registered Farm Bill Buyer with the Montana Secretary of State’s office it is important to maintain the confidentiality of the information contained within the Farm Bill Master List. The Farm Bill Master List reflects personal data, such as Social Security Numbers, which are a key piece of personal identifiable information to assist you in determining the existence of a lien against a specific debtor. The distribution of this information beyond its intended purpose is strictly prohibited.\n\n**The debtor's tax identification number has been hidden for confidentiality reasons. You may continue to search on a tax ID number and return debtors that match your search criteria. The SSN/FEIN must be entered without dashes or spaces.  If you need access to the tax identification number to clearly identify the debtor, please contact the UCC unit at (406) 444-3665.**","VIEW_HISTORY_BUTTON_ALT_TEXT":"View Filings","WIZARD_ERROR_TITLE_MESSAGE":"Form Error","FARM_BILL_SEARCH_INTERACTIVE":true,"USE_FARM_BILL_API":true,"DISALLOW_ASSIGN_SELF_AS_RA":true,"DISALLOW_ASSIGN_SELF_AS_PRINCIPAL":true,"USE_TRADEMARK_OWNER_VALIDATION":true,"USE_ALTERNATIVE_FOREIGN_ADDRESS_LABELS":true,"MY_RECEIPTS_FILTER":[{"type":"dateRange","name":"DATE_RANGE","label":"Date range","defaultValue":{"start":null,"end":null}},{"type":"text","name":"REF_NUM","defaultValue":"","label":"Reference Number"},{"type":"text","name":"RECEIPT_NUM","defaultValue":"","label":"Receipt Id"},{"type":"text","name":"AMOUNT","defaultValue":"","label":"Amount"},{"type":"select","name":"TYPE","defaultValue":"","label":"Payment Type","options":[{"value":"","label":"All"},{"value":"CC","label":"Credit Card"},{"value":"Check","label":"Check"}]}],"MY_RECEIPTS_SHOW_IN_SIDEBAR":true,"SHOW_MY_RECEIPTS_HELPER_TEXT":true,"MY_RECEIPTS_HELPER_LABEL":"About Receipt Search","MY_RECEIPTS_HELPER_TEXT":"You can search for receipts based on their descriptions, including the items paid for on the receipt. Use the filters to search for or filter specific information.","FARM_BILL_SUBLINK":{"label":"Farm Bill","component":"FarmBill","parameter":"farm-bill","path":"/lists/farm-bill","sourceTypeId":0,"myRecordsSearch":false,"allowedRules":["/search/"],"disabled":true,"searchDescription":"To perform a search, enter a debtor name. Your search results may include: exact debtor name, variations of that name and any filing that includes your search criteria. Punctuation is ignored.\n\nYou can click on \"Advanced\" to refine your search. Under “Advanced” you can search by crop, year, county and SSN/FEIN. As a registered Farm Bill Buyer with the Montana Secretary of State’s office it is important to maintain the confidentiality of the information contained within the Farm Bill Master List. The Farm Bill Master List reflects personal data, such as Social Security Numbers, which are a key piece of personal identifiable information to assist you in determining the existence of a lien against a specific debtor. The distribution of this information beyond its intended purpose is strictly prohibited.\n\nThe debtor's tax identification number has been hidden for confidentiality reasons. You may continue to search on a tax ID number and return debtors that match your search criteria. The SSN/FEIN must be entered without dashes or spaces.","searchMustHaveOneOf":["search","UCC_FARM_PRODUCT_ID","COUNTY"],"searchPlaceholder":"Search by debtor name","advancedSearchParameters":[{"type":"ServerMultiComplete","label":"Product code name(s)","name":"UCC_FARM_PRODUCT_ID","defaultValue":"","optionsSrc":"UCC_FARM_PRODUCT_V"},{"type":"MultiComplete","label":"Year or Range of Years","name":"YEAR_NUM","optionsSrc":"years","startYear":"1968","defaultValue":[],"preMergeOptions":[{"value":"ALL","label":"All"}]},{"type":"serverSelect","label":"State","name":"STATE","defaultValue":"MONTANA","optionsSrc":"STATE"},{"type":"ServerMultiComplete","label":"County","name":"COUNTY","defaultValue":[],"optionsSrc":"COUNTY","overrideSubOptionsSrcFromParameterName":"STATE"},{"type":"checkbox","name":"TIN_SEARCH_YN","defaultValue":false,"label":"Tax Identification Number Search"},{"type":"checkbox","name":"TIN_SORT_YN","defaultValue":false,"label":"Unique ID Sort"}]},"ALLOW_ADDRESS_VALIDATION_BYPASS_OPTION":true,"DEFAULT_ADDRESS_VALIDATION_BYPASS_OPTION_CHECKED":true}).WQ_ALLOW_DELETE_PRINT_MAIL;
	var WQ_ALLOW_EDIT_PENDING_PAYMENT = (true);
	var WQ_CONFIRM_ON_DELETE = (true);
	var WQ_DELETE_CONFIRM_MESSAGE = ("Deleting this filing will forfeit any money already paid to the Secretary of State. This action is permanent and cannot be undone, are you sure you would like to delete?");
	var SHOPPING_CART = (true);
	var MY_WORK_QUEUE_DISABLE_EMPTY_STATE = ({"NODE_ENV":"production","BUILD_DATE":"2025-08-27T15:15:31.687Z","BUILD_NUMBER":"Not Provided","GIT_VERSION":"v1.3.0-381-ga81e29b08","GIT_COMMIT_HASH":"a81e29b085c9268ffd96c78eb734365802722741","GIT_BRANCH":"beta","PUBLIC_URL":"","STATE_ABBR":"MT","STATE_NAME":"Montana","STATE_ORG_TITLE":"Secretary of State","LOGIN_HEADER_IMG_PATH":"","HOME_IMG_FILENAME":"montana.jpg","FAVICON_FILE_NAME":"favicon.ico","ALLOW_E_SIGN_ON_CORRECTIONS":true,"THIRD_PARTY_SIGNING_ALLOWED":false,"MY_ACCOUNT_SAVE_AND_CLOSE_BUTTON":true,"IE_DEPRECATED_MESSAGE":"Internet Explorer is not supported. Please select a supported browser below to access this website.","ADDITIONAL_ROUTES":{"dataRequests":true,"farmBill":true,"apostille":true,"externalHelp":"https://sosmt.gov/business/help-center/","systemAdministration":[{"title":"Saved Payments","parameter":"saved-payments","componentName":"SavedPayments"}]},"SUBROUTES":[{"label":"Business","component":"Business","parameter":"business","myWorkQueueSearch":false,"sourceTypeId":54,"searchMustHaveOneOf":["FILING_TYPE_ID","STATUS_ID","STATE","search"],"serverWebSearchDescription":true,"serverWorkQueueDescription":true,"serverMyRecordsDescription":true,"searchPlaceholder":"Search by name or filing number (X########)","allowEmptySearchTerm":true,"requestCertificateAlternateLabel":"Request Information","fileAmendmentButtonLabel":"Filing Actions","advancedSearchParameters":[{"type":"radio","name":"QUERY_TYPE_ID","defaultValue":1010,"options":[{"value":1010,"label":"Starts with"},{"value":1011,"label":"Contains"},{"value":1012,"label":" Word Contains"}]},{"type":"serverSelect","name":"FILING_TYPE_ID","optionsSrc":"FILING_TYPES","label":"Entity Type","placeholder":"All","defaultValue":"0"},{"type":"serverSelect","name":"FILING_SUBTYPE_ID","optionsSrc":"FILING_SUBTYPES","label":"Entity Subtype","overrideSubOptionsSrcFromParameterName":"FILING_TYPE_ID","placeholder":"All","defaultValue":"0"},{"type":"serverSelect","name":"STATUS_ID","optionsSrc":"FILING_STATUS_WITHOUT_ALL","label":"Status","placeholder":"All","defaultValue":"0"},{"type":"serverSelect","name":"STATE","optionsSrc":"STATE","label":"State","placeholder":"All","defaultValue":""},{"type":"serverSelect","name":"COUNTY","optionsSrc":"COUNTY_SUBOPTION","label":"County","overrideSubOptionsSrcFromParameterName":"STATE","placeholder":"All","defaultValue":""},{"type":"checkbox","name":"CRA_SEARCH_YN","defaultValue":false,"label":"Search by Registered Agent PID"},{"type":"dateRange","name":"FILING_DATE","label":"Registration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}},{"type":"dateRange","name":"EXPIRATION_DATE","label":"Expiration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}}],"myRecordsFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Active"},{"value":2,"label":"Inactive"},{"value":3,"label":"Pending"}]},{"type":"dateRange","name":"DATE_RANGE","label":"Date range","defaultValue":{"start":null,"end":null}}],"myWorkQueueFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Approved"},{"value":2,"label":"Pending Online Payment"},{"value":3,"label":"Pending Review"},{"value":4,"label":"Needs Correction"},{"value":5,"label":"Rejected"},{"value":6,"label":"Draft"}]},{"type":"dateRange","name":"DATE_RANGE","label":"Date range","defaultValue":{"start":null,"end":null}}]},{"label":"Notary","component":"Notary","parameter":"notary","sourceTypeId":850,"myWorkQueueSearch":false,"allowEmptySearchTerm":true,"requestCertificateAlternateLabel":"Download Certificate","fileAmendmentButtonLabel":"Filing Actions","hideNameRequestCertificate":true,"hideAddressRequestCertificate":true,"hideRecordUserManagment":true,"searchPlaceholder":"Search by name or commission number","searchMustHaveOneOf":["CITY","search","SERVICE_TYPE"],"advancedParametersStartOpen":true,"searchIsSortable":true,"advancedSearchParameters":[{"type":"radio","name":"STARTS_WITH_YN","defaultValue":false,"options":[{"value":true,"label":"Starts with"},{"value":false,"label":"Contains"}]},{"type":"checkbox","name":"ACTIVE_ONLY_YN","defaultValue":true,"label":"Active entities only"},{"type":"text","name":"CITY","defaultValue":"","label":"City"},{"type":"select","name":"SERVICE_TYPE","label":"Special Services Offered","defaultValue":0,"options":[{"value":0,"label":"(N/A)"},{"value":6165,"label":"In-Person Electronic Notarization (IPEN)"},{"value":6166,"label":"Remote Online Notarization (RON)"},{"value":6167,"label":"Mobile Notary Services"},{"value":6168,"label":"Remote Ink Notarization (RIN)"}]}]},{"label":"Apostille","component":"Apostille","parameter":"apostille","sourceTypeId":720,"myRecordsSearch":false,"myWorkQueueSearch":false,"disabled":false,"allowedRoutes":["/forms-manager/","/queue/","/forms/"]},{"label":"Liens","component":"UCC","parameter":"ucc","sourceTypeId":1999,"myRecordsSearch":true,"myWorkQueueSearch":true,"fileAmendmentButtonLabel":"Filing Actions","searchPlaceholder":"Search by name or file number","disabled":false,"serverWebSearchDescription":true,"myRecordsDescription":"","workQueueDescription":"","searchDescription":"","hideRecordUserManagment":true,"searchLiensCheckout":false,"advancedSearchParameters":[{"type":"radio","name":"STARTS_WITH_YN","defaultValue":false,"options":[{"value":true,"label":"Starts with"},{"value":false,"label":"Contains"}]},{"type":"select","name":"STATUS","defaultValue":"ALL","label":"Status","options":[{"value":"ACTIVE_UNLAPSED","label":"Active (unlapsed)"},{"value":"ACTIVE_LAPSED_UNLAPSED","label":"Active (lapsed and unlapsed)"}]},{"type":"text","name":"EXCLUDE_VALUES","label":"Exclude Debtor Names (comma separated list of names to exclude)","defaultValue":""},{"type":"dateRange","name":"FILING_DATE","label":"Financing Statement Date","defaultValue":{"start":null,"end":null}},{"type":"dateRange","name":"LAPSE_DATE","label":"Lapse Date","defaultValue":{"start":null,"end":null}},{"type":"text","name":"CITY","label":"Debtor City","defaultValue":""}],"myRecordsFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Approved"},{"value":2,"label":"Pending Online Payment"},{"value":3,"label":"Pending Review"}]},{"type":"select","name":"TYPE","defaultValue":0,"label":"Lien Type","options":[{"value":0,"label":"All"},{"value":1,"label":"UCC"},{"value":2,"label":"EFS"},{"value":3,"label":"Title 71"}]}],"myWorkQueueFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Approved"},{"value":2,"label":"Pending Online Payment"},{"value":3,"label":"Pending Review"},{"value":4,"label":"Pending Print and Mail"},{"value":5,"label":"Rejected"},{"value":6,"label":"Draft"}]},{"type":"select","name":"TYPE","defaultValue":0,"label":"Lien Type","options":[{"value":0,"label":"All"},{"value":1,"label":"UCC"},{"value":2,"label":"EFS"},{"value":3,"label":"Title 71"}]}]},{"label":"Copy Request","component":"copies","parameter":"copies","sourceTypeId":2001,"myRecordsSearch":false,"myWorkQueueSearch":false,"disabled":false,"allowedRoutes":["/forms-manager/","/queue/","/forms/"]},{"label":"Trademark","component":"Trademark","parameter":"trademark","sourceTypeId":810,"showRequestCertificate":true,"searchMustHaveOneOf":["search","EXPIRATION_DATE","FILING_DATE"],"allowEmptySearchTerm":true,"requestCertificateAlternateLabel":"Request Information","fileAmendmentButtonLabel":"Filing Actions","advancedSearchParameters":[{"type":"radio","name":"QUERY_TYPE_ID","defaultValue":1010,"options":[{"value":1010,"label":"Starts with"},{"value":1011,"label":"Contains"},{"value":1012,"label":" Word Contains"}]},{"type":"checkbox","name":"OWNER_SEARCH_YN","defaultValue":false,"label":"Search owners"},{"type":"radio","name":"SERVICE_MARK_YN","label":"Mark Type","defaultValue":"","options":[{"value":"","label":"All Marks"},{"value":"Y","label":"Service Mark"},{"value":"N","label":"Trademark"}]},{"type":"serverSelect","name":"STATUS_ID","optionsSrc":"TYPE_V|TRADEMARK_STATUS_TYPE","label":"Status","placeholder":"All","defaultValue":"0"},{"type":"select","name":"DESIGN_TYPE_ID","options":[{"value":0,"label":"All"},{"value":990,"label":"Words Only"},{"value":991,"label":"Design Only"},{"value":992,"label":"Words and Design"}],"label":"Design Type","defaultValue":"0"},{"type":"dateRange","name":"FILING_DATE","label":"Registered Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}},{"type":"dateRange","name":"EXPIRATION_DATE","label":"Expiration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}}]},{"label":"Business Info Request","component":"InfoRequests","parameter":"info-request","sourceTypeId":167,"allowedRoutes":["/forms-manager/","/queue/","/forms/"]},{"label":"Data Requests","component":"DataRequests","parameter":"data-request","sourceTypeId":0,"allowedRoutes":["/forms-manager/"]},{"label":"CRA","component":"CRA","parameter":"cra","sourceTypeId":157,"myRecordsSearch":false,"searchPlaceholder":"Search by name or registered agent number","allowedRoutes":["/forms-manager/","/forms/","/records/","/queue/","/search/"],"allowEmptySearchTerm":true,"fileAmendmentButtonLabel":"Filing Actions","advancedSearchParameters":[{"type":"radio","name":"QUERY_TYPE_ID","defaultValue":1010,"options":[{"value":1010,"label":"Starts with"},{"value":1011,"label":"Contains"},{"value":1012,"label":" Word Contains"}]},{"type":"dateRange","name":"CRA_DATE","label":"Registration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}},{"type":"select","name":"STATUS_ID","label":"Status","defaultValue":0,"options":[{"value":0,"label":"All"},{"value":121,"label":"Active"},{"value":122,"label":"Inactive"}]},{"type":"select","name":"AGENT_TYPE_ID","label":"Agent Type","defaultValue":0,"options":[{"value":0,"label":"All"},{"value":460,"label":"Registered Agent"},{"value":461,"label":"Commercial Registered Agent"}]}]},{"label":"Farm Bill","component":"FarmBill","parameter":"farm-bill","path":"/lists/farm-bill","sourceTypeId":0,"myRecordsSearch":false,"allowedRules":["/search/"],"disabled":true,"searchDescription":"To perform a search, enter a debtor name. Your search results may include: exact debtor name, variations of that name and any filing that includes your search criteria. Punctuation is ignored.\n\nYou can click on \"Advanced\" to refine your search. Under “Advanced” you can search by crop, year, county and SSN/FEIN. As a registered Farm Bill Buyer with the Montana Secretary of State’s office it is important to maintain the confidentiality of the information contained within the Farm Bill Master List. The Farm Bill Master List reflects personal data, such as Social Security Numbers, which are a key piece of personal identifiable information to assist you in determining the existence of a lien against a specific debtor. The distribution of this information beyond its intended purpose is strictly prohibited.\n\nThe debtor's tax identification number has been hidden for confidentiality reasons. You may continue to search on a tax ID number and return debtors that match your search criteria. The SSN/FEIN must be entered without dashes or spaces.","searchMustHaveOneOf":["search","UCC_FARM_PRODUCT_ID","COUNTY"],"searchPlaceholder":"Search by debtor name","advancedSearchParameters":[{"type":"ServerMultiComplete","label":"Product code name(s)","name":"UCC_FARM_PRODUCT_ID","defaultValue":"","optionsSrc":"UCC_FARM_PRODUCT_V"},{"type":"MultiComplete","label":"Year or Range of Years","name":"YEAR_NUM","optionsSrc":"years","startYear":"1968","defaultValue":[],"preMergeOptions":[{"value":"ALL","label":"All"}]},{"type":"serverSelect","label":"State","name":"STATE","defaultValue":"MONTANA","optionsSrc":"STATE"},{"type":"ServerMultiComplete","label":"County","name":"COUNTY","defaultValue":[],"optionsSrc":"COUNTY","overrideSubOptionsSrcFromParameterName":"STATE"},{"type":"checkbox","name":"TIN_SEARCH_YN","defaultValue":false,"label":"Tax Identification Number Search"},{"type":"checkbox","name":"TIN_SORT_YN","defaultValue":false,"label":"Unique ID Sort"}]}],"SYSTEM_NICKNAME":"Online Services Portal","PAYMENT_METHODS":[{"type":"bypass"},{"type":"iTransact"}],"PAYMENT_ALLOW_AMEX":true,"SYSTEM_ID_LABEL":"System Id","DOUBLE_COLUMN_PUBLIC_LOGIN":true,"INTERNAL_USER_MANAGEMENT":true,"ALLOW_PUBLIC_JSON_IMPORT":false,"MAX_FILE_UPLOAD_SIZE":10000000,"REFUND_TEXT":"","RETURN_TO_HOME_ON_LOGOUT":true,"CURRENT_SOS_NAME":"Christi Jacobsen","LOGO_FILENAME":"mt-sos-logo.png","LOGO_ALT":"Christi Jacobsen, Montana Secretary of State","LOGO_FULL_WIDTH":true,"HOME_HIDE_AUTH_HINT":true,"HOME_TITLE":"Montana Secretary of State","CUSTOM_TAB_TITLE":"Official Montana","HOME_SUBTITLE":"Online Business Services","ENTITY_NAME_CONSENT_DESCRIPTION":"","ALLOW_USER_PROFILE_EDITING":true,"COMPARE_FOREIGN_NAME_IN_ENTITY_NAME_VALIDATION":true,"FOREIGN_NAME_FIELD_NAME":"KIMA_PARENT_NAME_INFO","LOGIN_TITLE":"Montana Secretary of State Online Filing Portal Login","PUBLIC_LOGIN_LABEL":"Username","REVERSE_LOGIN_COLUMNS":true,"LOGIN_SEAL_FILENAME":"seal_white.png","SEPARATE_USERNAME_AND_EMAIL":true,"CREATE_ACCOUNT_BUTTON_ALIGN_LEFT":true,"CREATE_ACCOUNT_BUTTON_TEXT":"CREATE AN ACCOUNT","PASSWORD_CUSTOM_ERROR_TEXT":"The password must meet all requirements","ACCOUNT_CREATED_MESSAGE":"Please check your email to verify your account to login and allow a few minutes for this message to arrive. Check your junk/spam folders if you do not find the email in your inbox.","PUBLIC_LOGIN_PLACEHOLDER":" ","DISABLE_DEFAULT_PAYMENT_RADIO":true,"CUSTOM_RESET_PASSWORD_ERROR_MESSAGE":"Username invalid - no account found","PUBLIC_LOGIN_CREATE_DESCRIPTION":"### Existing User:\n\n  - Enter your username and password to login.  \n\n\n  #### - OR -  \n\n\n\n  - Forgot password? Click 'Reset Password' and follow the prompts.\n  - Forgot username? Click 'Forgot Username' and follow the prompts.  \n\n\n  ### New User:\n  ","LOGIN_HELP_LINK":"https://sosmt.gov/business/how-do-i/","LOGIN_HELP_LINK_TEXT":"Need Help?","FORGOT_USERNAME_TEXT":"Forgot Username?","LOGIN_ACTIVE_DIRECTORY_TEXT":"State User Login","MULTIPLE_LOGIN_METHODS":true,"HAS_ACTIVE_DIRECTORY_LOGIN":true,"RESET_PASSWORD_WITH_USERNAME":true,"DOWNLOAD_LINK":true,"SHOW_USERNAME_ACCOUNT_CREATE":true,"SHOW_SCROLL_DOWN_ARROW":true,"SHOW_ADDRESS_ACCOUNT_CREATE":true,"TWO_COLUMN_ACCOUNT_CREATE":true,"RESET_PASSWORD_TIP":"A link to change your password has been sent to your email. Please allow a few minutes for this message to arrive. Please check your junk/spam folders if you do not find the email in your inbox.","FORGOT_PASSWORD_LINK_TEXT":"Reset Password","PHONE_NUMBER_OPTIONAL_ACCOUNT_CREATE":true,"SHOW_REQUIRED_INDICATOR_ACCOUNT_CREATE":true,"PASSWORD_REQUIREMENTS_ACCOUNT_CREATE":"\n    <ul>\n      <li>MUST contain at least 8 characters (12+ recommended)</li>\n      <li>MUST contain at least one uppercase letter.</li>\n      <li>MUST contain at least one lowercase letter.</li>\n      <li>MUST contain at least one number.</li>\n      <li>MUST contain at least one special character (!”#$%&'()*+,-./:;<=>?</li>\n    </ul>\n  ","ALLOW_CERTIFICATION_REQUEST":true,"ALLOW_PUBLIC_CERTIFICATE_REQUEST":true,"ALLOW_COPY_REQUEST":false,"ALLOW_CORRECTION_STYLING":true,"HIDE_DEPRECATION_WARNING":false,"AMEND_ROUTE_PUBLIC":true,"SEAL_FILENAME":"seal.png","SHOPPING_CART":true,"ALLOW_PAYMENT_UPDATE_WITH_EMPTY_CART":true,"RA_EMAIL":true,"RA_WEBSITE":true,"RA_NO_DEFAULT_TYPE":true,"RA_ADDRESS_LABEL":"Street Address","RA_TYPE_SELECTION_DEFAULT":true,"RA_DEFAULT_TYPE":"460","RA_OVERRIDE_TYPE_WITH_DEFAULT":true,"RA_PRINCIPAL_ADDRESS_AMS":true,"UPLOAD_AND_SUBMIT_HIDE_IF_ONE_OPTION":true,"PAYMENT_PROCESSING_MESSAGE":"Your payment is processing - Do not close your browser or click the back button","CHECKOUT_BUTTON_WHEN_PROCESSING_TEXT":"Processing","EFS_CROP_PICKER_NONE_LABEL":"Lien Duration","DISALLOWED_WIZARD_PIECES":["FormationLocale"],"REPEATER_SHOW_EDIT_BUTTON":true,"DATA_REQUEST_PAGE_TITLE":"Data Requests and Subscriptions","DATA_REQUEST_SIDEBAR_LABEL":"Data Requests & Subscriptions","LOGIN_REDIRECTS_TO_EPASS":false,"LOGIN_REDIRECTS_TO_ACTIVE_DIRECTORY":true,"LOGIN_ACTIVE_DIRECTORY_LINK":true,"FETCH_EDIT_USER_LINK":false,"LISTS_FETCH_AVAILABLE_LISTS":true,"POST_WIZARD_SUBMIT_REDIRECT_URL":"/","PIN_REQUEST_ATTESTATIONS":true,"PIN_REQUEST_DESCRIPTION":"Click **Request PIN** to have a new PIN sent to the account holder's email address on file.","OWNERSHIP_REQUEST_DESCRIPTION":"To become an **authorized user** of this record, a current **AUTHORIZED USER** will need to grant you access. To request access, click **Request Access** below.","PIN_REQUEST_SUCCESS_MESSAGE":"The PIN you have requested for this entity has been sent to the email associated with your user account.  You should receive the PIN in approximately 3-5 minutes, depending on your email service provider.","APOSTILLE_HEADER_LABEL":"Verification Information","APOSTILLE_NUMBER_LABEL":"Apostille/Authentication","APOSTILLE_CITY_STATE_OVERRIDE":"HELENA, MT","APOSTILLE_FILING_DATE_LABEL":"Issue Date","APOSTILLE_CITY_STATE_IN_CERTIFIED":true,"NOTARY_EXISTING_FILING":true,"ALLOW_REVOKE_OWN_ACCESS_ONLY":false,"HIDE_CANCEL_ON_ONETIME_DATA_REQUESTS":true,"DATA_REQUESTS_IN_SHOPPING_CART":true,"WQ_ALLOW_EDIT_PENDING_PAYMENT":true,"WQ_CONFIRM_ON_DELETE":true,"WQ_DELETE_CONFIRM_MESSAGE":"Deleting this filing will forfeit any money already paid to the Secretary of State. This action is permanent and cannot be undone, are you sure you would like to delete?","PASS_ITEM_GUIDS_ON_CHECKOUT":true,"FORM_REVISION_HISTORY":true,"CHECKOUT_DISCLAIMER":"By entering your credit card and/or checking account information you (i) state that **you are an authorized user** of the credit card and/or electronic check and that the associated information entered (e.g., account holder name, account number, billing address) is accurate, (ii) **you authorize payment processor to charge the amount you have requested** to your credit card and/or funding account, and (iii) **acknowledge if a charge is declined or reversed you may also be assessed a customary charge** by the payment processor for such transactions.","FARM_BILL_SEARCH_CONFIDENTIAL":"As a registered Farm Bill Buyer with the Montana Secretary of State’s office it is important to maintain the confidentiality of the information contained within the Farm Bill Master List. The Farm Bill Master List reflects personal data, such as Social Security Numbers, which are a key piece of personal identifiable information to assist you in determining the existence of a lien against a specific debtor. The distribution of this information beyond its intended purpose is strictly prohibited.\n\n**The debtor's tax identification number has been hidden for confidentiality reasons. You may continue to search on a tax ID number and return debtors that match your search criteria. The SSN/FEIN must be entered without dashes or spaces.  If you need access to the tax identification number to clearly identify the debtor, please contact the UCC unit at (406) 444-3665.**","VIEW_HISTORY_BUTTON_ALT_TEXT":"View Filings","WIZARD_ERROR_TITLE_MESSAGE":"Form Error","FARM_BILL_SEARCH_INTERACTIVE":true,"USE_FARM_BILL_API":true,"DISALLOW_ASSIGN_SELF_AS_RA":true,"DISALLOW_ASSIGN_SELF_AS_PRINCIPAL":true,"USE_TRADEMARK_OWNER_VALIDATION":true,"USE_ALTERNATIVE_FOREIGN_ADDRESS_LABELS":true,"MY_RECEIPTS_FILTER":[{"type":"dateRange","name":"DATE_RANGE","label":"Date range","defaultValue":{"start":null,"end":null}},{"type":"text","name":"REF_NUM","defaultValue":"","label":"Reference Number"},{"type":"text","name":"RECEIPT_NUM","defaultValue":"","label":"Receipt Id"},{"type":"text","name":"AMOUNT","defaultValue":"","label":"Amount"},{"type":"select","name":"TYPE","defaultValue":"","label":"Payment Type","options":[{"value":"","label":"All"},{"value":"CC","label":"Credit Card"},{"value":"Check","label":"Check"}]}],"MY_RECEIPTS_SHOW_IN_SIDEBAR":true,"SHOW_MY_RECEIPTS_HELPER_TEXT":true,"MY_RECEIPTS_HELPER_LABEL":"About Receipt Search","MY_RECEIPTS_HELPER_TEXT":"You can search for receipts based on their descriptions, including the items paid for on the receipt. Use the filters to search for or filter specific information.","FARM_BILL_SUBLINK":{"label":"Farm Bill","component":"FarmBill","parameter":"farm-bill","path":"/lists/farm-bill","sourceTypeId":0,"myRecordsSearch":false,"allowedRules":["/search/"],"disabled":true,"searchDescription":"To perform a search, enter a debtor name. Your search results may include: exact debtor name, variations of that name and any filing that includes your search criteria. Punctuation is ignored.\n\nYou can click on \"Advanced\" to refine your search. Under “Advanced” you can search by crop, year, county and SSN/FEIN. As a registered Farm Bill Buyer with the Montana Secretary of State’s office it is important to maintain the confidentiality of the information contained within the Farm Bill Master List. The Farm Bill Master List reflects personal data, such as Social Security Numbers, which are a key piece of personal identifiable information to assist you in determining the existence of a lien against a specific debtor. The distribution of this information beyond its intended purpose is strictly prohibited.\n\nThe debtor's tax identification number has been hidden for confidentiality reasons. You may continue to search on a tax ID number and return debtors that match your search criteria. The SSN/FEIN must be entered without dashes or spaces.","searchMustHaveOneOf":["search","UCC_FARM_PRODUCT_ID","COUNTY"],"searchPlaceholder":"Search by debtor name","advancedSearchParameters":[{"type":"ServerMultiComplete","label":"Product code name(s)","name":"UCC_FARM_PRODUCT_ID","defaultValue":"","optionsSrc":"UCC_FARM_PRODUCT_V"},{"type":"MultiComplete","label":"Year or Range of Years","name":"YEAR_NUM","optionsSrc":"years","startYear":"1968","defaultValue":[],"preMergeOptions":[{"value":"ALL","label":"All"}]},{"type":"serverSelect","label":"State","name":"STATE","defaultValue":"MONTANA","optionsSrc":"STATE"},{"type":"ServerMultiComplete","label":"County","name":"COUNTY","defaultValue":[],"optionsSrc":"COUNTY","overrideSubOptionsSrcFromParameterName":"STATE"},{"type":"checkbox","name":"TIN_SEARCH_YN","defaultValue":false,"label":"Tax Identification Number Search"},{"type":"checkbox","name":"TIN_SORT_YN","defaultValue":false,"label":"Unique ID Sort"}]},"ALLOW_ADDRESS_VALIDATION_BYPASS_OPTION":true,"DEFAULT_ADDRESS_VALIDATION_BYPASS_OPTION_CHECKED":true}).MY_WORK_QUEUE_DISABLE_EMPTY_STATE;
	var MY_WORK_QUEUE_EMPTY_STATE_LINE_1 = ({"NODE_ENV":"production","BUILD_DATE":"2025-08-27T15:15:31.687Z","BUILD_NUMBER":"Not Provided","GIT_VERSION":"v1.3.0-381-ga81e29b08","GIT_COMMIT_HASH":"a81e29b085c9268ffd96c78eb734365802722741","GIT_BRANCH":"beta","PUBLIC_URL":"","STATE_ABBR":"MT","STATE_NAME":"Montana","STATE_ORG_TITLE":"Secretary of State","LOGIN_HEADER_IMG_PATH":"","HOME_IMG_FILENAME":"montana.jpg","FAVICON_FILE_NAME":"favicon.ico","ALLOW_E_SIGN_ON_CORRECTIONS":true,"THIRD_PARTY_SIGNING_ALLOWED":false,"MY_ACCOUNT_SAVE_AND_CLOSE_BUTTON":true,"IE_DEPRECATED_MESSAGE":"Internet Explorer is not supported. Please select a supported browser below to access this website.","ADDITIONAL_ROUTES":{"dataRequests":true,"farmBill":true,"apostille":true,"externalHelp":"https://sosmt.gov/business/help-center/","systemAdministration":[{"title":"Saved Payments","parameter":"saved-payments","componentName":"SavedPayments"}]},"SUBROUTES":[{"label":"Business","component":"Business","parameter":"business","myWorkQueueSearch":false,"sourceTypeId":54,"searchMustHaveOneOf":["FILING_TYPE_ID","STATUS_ID","STATE","search"],"serverWebSearchDescription":true,"serverWorkQueueDescription":true,"serverMyRecordsDescription":true,"searchPlaceholder":"Search by name or filing number (X########)","allowEmptySearchTerm":true,"requestCertificateAlternateLabel":"Request Information","fileAmendmentButtonLabel":"Filing Actions","advancedSearchParameters":[{"type":"radio","name":"QUERY_TYPE_ID","defaultValue":1010,"options":[{"value":1010,"label":"Starts with"},{"value":1011,"label":"Contains"},{"value":1012,"label":" Word Contains"}]},{"type":"serverSelect","name":"FILING_TYPE_ID","optionsSrc":"FILING_TYPES","label":"Entity Type","placeholder":"All","defaultValue":"0"},{"type":"serverSelect","name":"FILING_SUBTYPE_ID","optionsSrc":"FILING_SUBTYPES","label":"Entity Subtype","overrideSubOptionsSrcFromParameterName":"FILING_TYPE_ID","placeholder":"All","defaultValue":"0"},{"type":"serverSelect","name":"STATUS_ID","optionsSrc":"FILING_STATUS_WITHOUT_ALL","label":"Status","placeholder":"All","defaultValue":"0"},{"type":"serverSelect","name":"STATE","optionsSrc":"STATE","label":"State","placeholder":"All","defaultValue":""},{"type":"serverSelect","name":"COUNTY","optionsSrc":"COUNTY_SUBOPTION","label":"County","overrideSubOptionsSrcFromParameterName":"STATE","placeholder":"All","defaultValue":""},{"type":"checkbox","name":"CRA_SEARCH_YN","defaultValue":false,"label":"Search by Registered Agent PID"},{"type":"dateRange","name":"FILING_DATE","label":"Registration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}},{"type":"dateRange","name":"EXPIRATION_DATE","label":"Expiration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}}],"myRecordsFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Active"},{"value":2,"label":"Inactive"},{"value":3,"label":"Pending"}]},{"type":"dateRange","name":"DATE_RANGE","label":"Date range","defaultValue":{"start":null,"end":null}}],"myWorkQueueFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Approved"},{"value":2,"label":"Pending Online Payment"},{"value":3,"label":"Pending Review"},{"value":4,"label":"Needs Correction"},{"value":5,"label":"Rejected"},{"value":6,"label":"Draft"}]},{"type":"dateRange","name":"DATE_RANGE","label":"Date range","defaultValue":{"start":null,"end":null}}]},{"label":"Notary","component":"Notary","parameter":"notary","sourceTypeId":850,"myWorkQueueSearch":false,"allowEmptySearchTerm":true,"requestCertificateAlternateLabel":"Download Certificate","fileAmendmentButtonLabel":"Filing Actions","hideNameRequestCertificate":true,"hideAddressRequestCertificate":true,"hideRecordUserManagment":true,"searchPlaceholder":"Search by name or commission number","searchMustHaveOneOf":["CITY","search","SERVICE_TYPE"],"advancedParametersStartOpen":true,"searchIsSortable":true,"advancedSearchParameters":[{"type":"radio","name":"STARTS_WITH_YN","defaultValue":false,"options":[{"value":true,"label":"Starts with"},{"value":false,"label":"Contains"}]},{"type":"checkbox","name":"ACTIVE_ONLY_YN","defaultValue":true,"label":"Active entities only"},{"type":"text","name":"CITY","defaultValue":"","label":"City"},{"type":"select","name":"SERVICE_TYPE","label":"Special Services Offered","defaultValue":0,"options":[{"value":0,"label":"(N/A)"},{"value":6165,"label":"In-Person Electronic Notarization (IPEN)"},{"value":6166,"label":"Remote Online Notarization (RON)"},{"value":6167,"label":"Mobile Notary Services"},{"value":6168,"label":"Remote Ink Notarization (RIN)"}]}]},{"label":"Apostille","component":"Apostille","parameter":"apostille","sourceTypeId":720,"myRecordsSearch":false,"myWorkQueueSearch":false,"disabled":false,"allowedRoutes":["/forms-manager/","/queue/","/forms/"]},{"label":"Liens","component":"UCC","parameter":"ucc","sourceTypeId":1999,"myRecordsSearch":true,"myWorkQueueSearch":true,"fileAmendmentButtonLabel":"Filing Actions","searchPlaceholder":"Search by name or file number","disabled":false,"serverWebSearchDescription":true,"myRecordsDescription":"","workQueueDescription":"","searchDescription":"","hideRecordUserManagment":true,"searchLiensCheckout":false,"advancedSearchParameters":[{"type":"radio","name":"STARTS_WITH_YN","defaultValue":false,"options":[{"value":true,"label":"Starts with"},{"value":false,"label":"Contains"}]},{"type":"select","name":"STATUS","defaultValue":"ALL","label":"Status","options":[{"value":"ACTIVE_UNLAPSED","label":"Active (unlapsed)"},{"value":"ACTIVE_LAPSED_UNLAPSED","label":"Active (lapsed and unlapsed)"}]},{"type":"text","name":"EXCLUDE_VALUES","label":"Exclude Debtor Names (comma separated list of names to exclude)","defaultValue":""},{"type":"dateRange","name":"FILING_DATE","label":"Financing Statement Date","defaultValue":{"start":null,"end":null}},{"type":"dateRange","name":"LAPSE_DATE","label":"Lapse Date","defaultValue":{"start":null,"end":null}},{"type":"text","name":"CITY","label":"Debtor City","defaultValue":""}],"myRecordsFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Approved"},{"value":2,"label":"Pending Online Payment"},{"value":3,"label":"Pending Review"}]},{"type":"select","name":"TYPE","defaultValue":0,"label":"Lien Type","options":[{"value":0,"label":"All"},{"value":1,"label":"UCC"},{"value":2,"label":"EFS"},{"value":3,"label":"Title 71"}]}],"myWorkQueueFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Approved"},{"value":2,"label":"Pending Online Payment"},{"value":3,"label":"Pending Review"},{"value":4,"label":"Pending Print and Mail"},{"value":5,"label":"Rejected"},{"value":6,"label":"Draft"}]},{"type":"select","name":"TYPE","defaultValue":0,"label":"Lien Type","options":[{"value":0,"label":"All"},{"value":1,"label":"UCC"},{"value":2,"label":"EFS"},{"value":3,"label":"Title 71"}]}]},{"label":"Copy Request","component":"copies","parameter":"copies","sourceTypeId":2001,"myRecordsSearch":false,"myWorkQueueSearch":false,"disabled":false,"allowedRoutes":["/forms-manager/","/queue/","/forms/"]},{"label":"Trademark","component":"Trademark","parameter":"trademark","sourceTypeId":810,"showRequestCertificate":true,"searchMustHaveOneOf":["search","EXPIRATION_DATE","FILING_DATE"],"allowEmptySearchTerm":true,"requestCertificateAlternateLabel":"Request Information","fileAmendmentButtonLabel":"Filing Actions","advancedSearchParameters":[{"type":"radio","name":"QUERY_TYPE_ID","defaultValue":1010,"options":[{"value":1010,"label":"Starts with"},{"value":1011,"label":"Contains"},{"value":1012,"label":" Word Contains"}]},{"type":"checkbox","name":"OWNER_SEARCH_YN","defaultValue":false,"label":"Search owners"},{"type":"radio","name":"SERVICE_MARK_YN","label":"Mark Type","defaultValue":"","options":[{"value":"","label":"All Marks"},{"value":"Y","label":"Service Mark"},{"value":"N","label":"Trademark"}]},{"type":"serverSelect","name":"STATUS_ID","optionsSrc":"TYPE_V|TRADEMARK_STATUS_TYPE","label":"Status","placeholder":"All","defaultValue":"0"},{"type":"select","name":"DESIGN_TYPE_ID","options":[{"value":0,"label":"All"},{"value":990,"label":"Words Only"},{"value":991,"label":"Design Only"},{"value":992,"label":"Words and Design"}],"label":"Design Type","defaultValue":"0"},{"type":"dateRange","name":"FILING_DATE","label":"Registered Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}},{"type":"dateRange","name":"EXPIRATION_DATE","label":"Expiration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}}]},{"label":"Business Info Request","component":"InfoRequests","parameter":"info-request","sourceTypeId":167,"allowedRoutes":["/forms-manager/","/queue/","/forms/"]},{"label":"Data Requests","component":"DataRequests","parameter":"data-request","sourceTypeId":0,"allowedRoutes":["/forms-manager/"]},{"label":"CRA","component":"CRA","parameter":"cra","sourceTypeId":157,"myRecordsSearch":false,"searchPlaceholder":"Search by name or registered agent number","allowedRoutes":["/forms-manager/","/forms/","/records/","/queue/","/search/"],"allowEmptySearchTerm":true,"fileAmendmentButtonLabel":"Filing Actions","advancedSearchParameters":[{"type":"radio","name":"QUERY_TYPE_ID","defaultValue":1010,"options":[{"value":1010,"label":"Starts with"},{"value":1011,"label":"Contains"},{"value":1012,"label":" Word Contains"}]},{"type":"dateRange","name":"CRA_DATE","label":"Registration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}},{"type":"select","name":"STATUS_ID","label":"Status","defaultValue":0,"options":[{"value":0,"label":"All"},{"value":121,"label":"Active"},{"value":122,"label":"Inactive"}]},{"type":"select","name":"AGENT_TYPE_ID","label":"Agent Type","defaultValue":0,"options":[{"value":0,"label":"All"},{"value":460,"label":"Registered Agent"},{"value":461,"label":"Commercial Registered Agent"}]}]},{"label":"Farm Bill","component":"FarmBill","parameter":"farm-bill","path":"/lists/farm-bill","sourceTypeId":0,"myRecordsSearch":false,"allowedRules":["/search/"],"disabled":true,"searchDescription":"To perform a search, enter a debtor name. Your search results may include: exact debtor name, variations of that name and any filing that includes your search criteria. Punctuation is ignored.\n\nYou can click on \"Advanced\" to refine your search. Under “Advanced” you can search by crop, year, county and SSN/FEIN. As a registered Farm Bill Buyer with the Montana Secretary of State’s office it is important to maintain the confidentiality of the information contained within the Farm Bill Master List. The Farm Bill Master List reflects personal data, such as Social Security Numbers, which are a key piece of personal identifiable information to assist you in determining the existence of a lien against a specific debtor. The distribution of this information beyond its intended purpose is strictly prohibited.\n\nThe debtor's tax identification number has been hidden for confidentiality reasons. You may continue to search on a tax ID number and return debtors that match your search criteria. The SSN/FEIN must be entered without dashes or spaces.","searchMustHaveOneOf":["search","UCC_FARM_PRODUCT_ID","COUNTY"],"searchPlaceholder":"Search by debtor name","advancedSearchParameters":[{"type":"ServerMultiComplete","label":"Product code name(s)","name":"UCC_FARM_PRODUCT_ID","defaultValue":"","optionsSrc":"UCC_FARM_PRODUCT_V"},{"type":"MultiComplete","label":"Year or Range of Years","name":"YEAR_NUM","optionsSrc":"years","startYear":"1968","defaultValue":[],"preMergeOptions":[{"value":"ALL","label":"All"}]},{"type":"serverSelect","label":"State","name":"STATE","defaultValue":"MONTANA","optionsSrc":"STATE"},{"type":"ServerMultiComplete","label":"County","name":"COUNTY","defaultValue":[],"optionsSrc":"COUNTY","overrideSubOptionsSrcFromParameterName":"STATE"},{"type":"checkbox","name":"TIN_SEARCH_YN","defaultValue":false,"label":"Tax Identification Number Search"},{"type":"checkbox","name":"TIN_SORT_YN","defaultValue":false,"label":"Unique ID Sort"}]}],"SYSTEM_NICKNAME":"Online Services Portal","PAYMENT_METHODS":[{"type":"bypass"},{"type":"iTransact"}],"PAYMENT_ALLOW_AMEX":true,"SYSTEM_ID_LABEL":"System Id","DOUBLE_COLUMN_PUBLIC_LOGIN":true,"INTERNAL_USER_MANAGEMENT":true,"ALLOW_PUBLIC_JSON_IMPORT":false,"MAX_FILE_UPLOAD_SIZE":10000000,"REFUND_TEXT":"","RETURN_TO_HOME_ON_LOGOUT":true,"CURRENT_SOS_NAME":"Christi Jacobsen","LOGO_FILENAME":"mt-sos-logo.png","LOGO_ALT":"Christi Jacobsen, Montana Secretary of State","LOGO_FULL_WIDTH":true,"HOME_HIDE_AUTH_HINT":true,"HOME_TITLE":"Montana Secretary of State","CUSTOM_TAB_TITLE":"Official Montana","HOME_SUBTITLE":"Online Business Services","ENTITY_NAME_CONSENT_DESCRIPTION":"","ALLOW_USER_PROFILE_EDITING":true,"COMPARE_FOREIGN_NAME_IN_ENTITY_NAME_VALIDATION":true,"FOREIGN_NAME_FIELD_NAME":"KIMA_PARENT_NAME_INFO","LOGIN_TITLE":"Montana Secretary of State Online Filing Portal Login","PUBLIC_LOGIN_LABEL":"Username","REVERSE_LOGIN_COLUMNS":true,"LOGIN_SEAL_FILENAME":"seal_white.png","SEPARATE_USERNAME_AND_EMAIL":true,"CREATE_ACCOUNT_BUTTON_ALIGN_LEFT":true,"CREATE_ACCOUNT_BUTTON_TEXT":"CREATE AN ACCOUNT","PASSWORD_CUSTOM_ERROR_TEXT":"The password must meet all requirements","ACCOUNT_CREATED_MESSAGE":"Please check your email to verify your account to login and allow a few minutes for this message to arrive. Check your junk/spam folders if you do not find the email in your inbox.","PUBLIC_LOGIN_PLACEHOLDER":" ","DISABLE_DEFAULT_PAYMENT_RADIO":true,"CUSTOM_RESET_PASSWORD_ERROR_MESSAGE":"Username invalid - no account found","PUBLIC_LOGIN_CREATE_DESCRIPTION":"### Existing User:\n\n  - Enter your username and password to login.  \n\n\n  #### - OR -  \n\n\n\n  - Forgot password? Click 'Reset Password' and follow the prompts.\n  - Forgot username? Click 'Forgot Username' and follow the prompts.  \n\n\n  ### New User:\n  ","LOGIN_HELP_LINK":"https://sosmt.gov/business/how-do-i/","LOGIN_HELP_LINK_TEXT":"Need Help?","FORGOT_USERNAME_TEXT":"Forgot Username?","LOGIN_ACTIVE_DIRECTORY_TEXT":"State User Login","MULTIPLE_LOGIN_METHODS":true,"HAS_ACTIVE_DIRECTORY_LOGIN":true,"RESET_PASSWORD_WITH_USERNAME":true,"DOWNLOAD_LINK":true,"SHOW_USERNAME_ACCOUNT_CREATE":true,"SHOW_SCROLL_DOWN_ARROW":true,"SHOW_ADDRESS_ACCOUNT_CREATE":true,"TWO_COLUMN_ACCOUNT_CREATE":true,"RESET_PASSWORD_TIP":"A link to change your password has been sent to your email. Please allow a few minutes for this message to arrive. Please check your junk/spam folders if you do not find the email in your inbox.","FORGOT_PASSWORD_LINK_TEXT":"Reset Password","PHONE_NUMBER_OPTIONAL_ACCOUNT_CREATE":true,"SHOW_REQUIRED_INDICATOR_ACCOUNT_CREATE":true,"PASSWORD_REQUIREMENTS_ACCOUNT_CREATE":"\n    <ul>\n      <li>MUST contain at least 8 characters (12+ recommended)</li>\n      <li>MUST contain at least one uppercase letter.</li>\n      <li>MUST contain at least one lowercase letter.</li>\n      <li>MUST contain at least one number.</li>\n      <li>MUST contain at least one special character (!”#$%&'()*+,-./:;<=>?</li>\n    </ul>\n  ","ALLOW_CERTIFICATION_REQUEST":true,"ALLOW_PUBLIC_CERTIFICATE_REQUEST":true,"ALLOW_COPY_REQUEST":false,"ALLOW_CORRECTION_STYLING":true,"HIDE_DEPRECATION_WARNING":false,"AMEND_ROUTE_PUBLIC":true,"SEAL_FILENAME":"seal.png","SHOPPING_CART":true,"ALLOW_PAYMENT_UPDATE_WITH_EMPTY_CART":true,"RA_EMAIL":true,"RA_WEBSITE":true,"RA_NO_DEFAULT_TYPE":true,"RA_ADDRESS_LABEL":"Street Address","RA_TYPE_SELECTION_DEFAULT":true,"RA_DEFAULT_TYPE":"460","RA_OVERRIDE_TYPE_WITH_DEFAULT":true,"RA_PRINCIPAL_ADDRESS_AMS":true,"UPLOAD_AND_SUBMIT_HIDE_IF_ONE_OPTION":true,"PAYMENT_PROCESSING_MESSAGE":"Your payment is processing - Do not close your browser or click the back button","CHECKOUT_BUTTON_WHEN_PROCESSING_TEXT":"Processing","EFS_CROP_PICKER_NONE_LABEL":"Lien Duration","DISALLOWED_WIZARD_PIECES":["FormationLocale"],"REPEATER_SHOW_EDIT_BUTTON":true,"DATA_REQUEST_PAGE_TITLE":"Data Requests and Subscriptions","DATA_REQUEST_SIDEBAR_LABEL":"Data Requests & Subscriptions","LOGIN_REDIRECTS_TO_EPASS":false,"LOGIN_REDIRECTS_TO_ACTIVE_DIRECTORY":true,"LOGIN_ACTIVE_DIRECTORY_LINK":true,"FETCH_EDIT_USER_LINK":false,"LISTS_FETCH_AVAILABLE_LISTS":true,"POST_WIZARD_SUBMIT_REDIRECT_URL":"/","PIN_REQUEST_ATTESTATIONS":true,"PIN_REQUEST_DESCRIPTION":"Click **Request PIN** to have a new PIN sent to the account holder's email address on file.","OWNERSHIP_REQUEST_DESCRIPTION":"To become an **authorized user** of this record, a current **AUTHORIZED USER** will need to grant you access. To request access, click **Request Access** below.","PIN_REQUEST_SUCCESS_MESSAGE":"The PIN you have requested for this entity has been sent to the email associated with your user account.  You should receive the PIN in approximately 3-5 minutes, depending on your email service provider.","APOSTILLE_HEADER_LABEL":"Verification Information","APOSTILLE_NUMBER_LABEL":"Apostille/Authentication","APOSTILLE_CITY_STATE_OVERRIDE":"HELENA, MT","APOSTILLE_FILING_DATE_LABEL":"Issue Date","APOSTILLE_CITY_STATE_IN_CERTIFIED":true,"NOTARY_EXISTING_FILING":true,"ALLOW_REVOKE_OWN_ACCESS_ONLY":false,"HIDE_CANCEL_ON_ONETIME_DATA_REQUESTS":true,"DATA_REQUESTS_IN_SHOPPING_CART":true,"WQ_ALLOW_EDIT_PENDING_PAYMENT":true,"WQ_CONFIRM_ON_DELETE":true,"WQ_DELETE_CONFIRM_MESSAGE":"Deleting this filing will forfeit any money already paid to the Secretary of State. This action is permanent and cannot be undone, are you sure you would like to delete?","PASS_ITEM_GUIDS_ON_CHECKOUT":true,"FORM_REVISION_HISTORY":true,"CHECKOUT_DISCLAIMER":"By entering your credit card and/or checking account information you (i) state that **you are an authorized user** of the credit card and/or electronic check and that the associated information entered (e.g., account holder name, account number, billing address) is accurate, (ii) **you authorize payment processor to charge the amount you have requested** to your credit card and/or funding account, and (iii) **acknowledge if a charge is declined or reversed you may also be assessed a customary charge** by the payment processor for such transactions.","FARM_BILL_SEARCH_CONFIDENTIAL":"As a registered Farm Bill Buyer with the Montana Secretary of State’s office it is important to maintain the confidentiality of the information contained within the Farm Bill Master List. The Farm Bill Master List reflects personal data, such as Social Security Numbers, which are a key piece of personal identifiable information to assist you in determining the existence of a lien against a specific debtor. The distribution of this information beyond its intended purpose is strictly prohibited.\n\n**The debtor's tax identification number has been hidden for confidentiality reasons. You may continue to search on a tax ID number and return debtors that match your search criteria. The SSN/FEIN must be entered without dashes or spaces.  If you need access to the tax identification number to clearly identify the debtor, please contact the UCC unit at (406) 444-3665.**","VIEW_HISTORY_BUTTON_ALT_TEXT":"View Filings","WIZARD_ERROR_TITLE_MESSAGE":"Form Error","FARM_BILL_SEARCH_INTERACTIVE":true,"USE_FARM_BILL_API":true,"DISALLOW_ASSIGN_SELF_AS_RA":true,"DISALLOW_ASSIGN_SELF_AS_PRINCIPAL":true,"USE_TRADEMARK_OWNER_VALIDATION":true,"USE_ALTERNATIVE_FOREIGN_ADDRESS_LABELS":true,"MY_RECEIPTS_FILTER":[{"type":"dateRange","name":"DATE_RANGE","label":"Date range","defaultValue":{"start":null,"end":null}},{"type":"text","name":"REF_NUM","defaultValue":"","label":"Reference Number"},{"type":"text","name":"RECEIPT_NUM","defaultValue":"","label":"Receipt Id"},{"type":"text","name":"AMOUNT","defaultValue":"","label":"Amount"},{"type":"select","name":"TYPE","defaultValue":"","label":"Payment Type","options":[{"value":"","label":"All"},{"value":"CC","label":"Credit Card"},{"value":"Check","label":"Check"}]}],"MY_RECEIPTS_SHOW_IN_SIDEBAR":true,"SHOW_MY_RECEIPTS_HELPER_TEXT":true,"MY_RECEIPTS_HELPER_LABEL":"About Receipt Search","MY_RECEIPTS_HELPER_TEXT":"You can search for receipts based on their descriptions, including the items paid for on the receipt. Use the filters to search for or filter specific information.","FARM_BILL_SUBLINK":{"label":"Farm Bill","component":"FarmBill","parameter":"farm-bill","path":"/lists/farm-bill","sourceTypeId":0,"myRecordsSearch":false,"allowedRules":["/search/"],"disabled":true,"searchDescription":"To perform a search, enter a debtor name. Your search results may include: exact debtor name, variations of that name and any filing that includes your search criteria. Punctuation is ignored.\n\nYou can click on \"Advanced\" to refine your search. Under “Advanced” you can search by crop, year, county and SSN/FEIN. As a registered Farm Bill Buyer with the Montana Secretary of State’s office it is important to maintain the confidentiality of the information contained within the Farm Bill Master List. The Farm Bill Master List reflects personal data, such as Social Security Numbers, which are a key piece of personal identifiable information to assist you in determining the existence of a lien against a specific debtor. The distribution of this information beyond its intended purpose is strictly prohibited.\n\nThe debtor's tax identification number has been hidden for confidentiality reasons. You may continue to search on a tax ID number and return debtors that match your search criteria. The SSN/FEIN must be entered without dashes or spaces.","searchMustHaveOneOf":["search","UCC_FARM_PRODUCT_ID","COUNTY"],"searchPlaceholder":"Search by debtor name","advancedSearchParameters":[{"type":"ServerMultiComplete","label":"Product code name(s)","name":"UCC_FARM_PRODUCT_ID","defaultValue":"","optionsSrc":"UCC_FARM_PRODUCT_V"},{"type":"MultiComplete","label":"Year or Range of Years","name":"YEAR_NUM","optionsSrc":"years","startYear":"1968","defaultValue":[],"preMergeOptions":[{"value":"ALL","label":"All"}]},{"type":"serverSelect","label":"State","name":"STATE","defaultValue":"MONTANA","optionsSrc":"STATE"},{"type":"ServerMultiComplete","label":"County","name":"COUNTY","defaultValue":[],"optionsSrc":"COUNTY","overrideSubOptionsSrcFromParameterName":"STATE"},{"type":"checkbox","name":"TIN_SEARCH_YN","defaultValue":false,"label":"Tax Identification Number Search"},{"type":"checkbox","name":"TIN_SORT_YN","defaultValue":false,"label":"Unique ID Sort"}]},"ALLOW_ADDRESS_VALIDATION_BYPASS_OPTION":true,"DEFAULT_ADDRESS_VALIDATION_BYPASS_OPTION_CHECKED":true}).MY_WORK_QUEUE_EMPTY_STATE_LINE_1;
	var MY_WORK_QUEUE_EMPTY_STATE_LINE_2 = ({"NODE_ENV":"production","BUILD_DATE":"2025-08-27T15:15:31.687Z","BUILD_NUMBER":"Not Provided","GIT_VERSION":"v1.3.0-381-ga81e29b08","GIT_COMMIT_HASH":"a81e29b085c9268ffd96c78eb734365802722741","GIT_BRANCH":"beta","PUBLIC_URL":"","STATE_ABBR":"MT","STATE_NAME":"Montana","STATE_ORG_TITLE":"Secretary of State","LOGIN_HEADER_IMG_PATH":"","HOME_IMG_FILENAME":"montana.jpg","FAVICON_FILE_NAME":"favicon.ico","ALLOW_E_SIGN_ON_CORRECTIONS":true,"THIRD_PARTY_SIGNING_ALLOWED":false,"MY_ACCOUNT_SAVE_AND_CLOSE_BUTTON":true,"IE_DEPRECATED_MESSAGE":"Internet Explorer is not supported. Please select a supported browser below to access this website.","ADDITIONAL_ROUTES":{"dataRequests":true,"farmBill":true,"apostille":true,"externalHelp":"https://sosmt.gov/business/help-center/","systemAdministration":[{"title":"Saved Payments","parameter":"saved-payments","componentName":"SavedPayments"}]},"SUBROUTES":[{"label":"Business","component":"Business","parameter":"business","myWorkQueueSearch":false,"sourceTypeId":54,"searchMustHaveOneOf":["FILING_TYPE_ID","STATUS_ID","STATE","search"],"serverWebSearchDescription":true,"serverWorkQueueDescription":true,"serverMyRecordsDescription":true,"searchPlaceholder":"Search by name or filing number (X########)","allowEmptySearchTerm":true,"requestCertificateAlternateLabel":"Request Information","fileAmendmentButtonLabel":"Filing Actions","advancedSearchParameters":[{"type":"radio","name":"QUERY_TYPE_ID","defaultValue":1010,"options":[{"value":1010,"label":"Starts with"},{"value":1011,"label":"Contains"},{"value":1012,"label":" Word Contains"}]},{"type":"serverSelect","name":"FILING_TYPE_ID","optionsSrc":"FILING_TYPES","label":"Entity Type","placeholder":"All","defaultValue":"0"},{"type":"serverSelect","name":"FILING_SUBTYPE_ID","optionsSrc":"FILING_SUBTYPES","label":"Entity Subtype","overrideSubOptionsSrcFromParameterName":"FILING_TYPE_ID","placeholder":"All","defaultValue":"0"},{"type":"serverSelect","name":"STATUS_ID","optionsSrc":"FILING_STATUS_WITHOUT_ALL","label":"Status","placeholder":"All","defaultValue":"0"},{"type":"serverSelect","name":"STATE","optionsSrc":"STATE","label":"State","placeholder":"All","defaultValue":""},{"type":"serverSelect","name":"COUNTY","optionsSrc":"COUNTY_SUBOPTION","label":"County","overrideSubOptionsSrcFromParameterName":"STATE","placeholder":"All","defaultValue":""},{"type":"checkbox","name":"CRA_SEARCH_YN","defaultValue":false,"label":"Search by Registered Agent PID"},{"type":"dateRange","name":"FILING_DATE","label":"Registration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}},{"type":"dateRange","name":"EXPIRATION_DATE","label":"Expiration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}}],"myRecordsFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Active"},{"value":2,"label":"Inactive"},{"value":3,"label":"Pending"}]},{"type":"dateRange","name":"DATE_RANGE","label":"Date range","defaultValue":{"start":null,"end":null}}],"myWorkQueueFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Approved"},{"value":2,"label":"Pending Online Payment"},{"value":3,"label":"Pending Review"},{"value":4,"label":"Needs Correction"},{"value":5,"label":"Rejected"},{"value":6,"label":"Draft"}]},{"type":"dateRange","name":"DATE_RANGE","label":"Date range","defaultValue":{"start":null,"end":null}}]},{"label":"Notary","component":"Notary","parameter":"notary","sourceTypeId":850,"myWorkQueueSearch":false,"allowEmptySearchTerm":true,"requestCertificateAlternateLabel":"Download Certificate","fileAmendmentButtonLabel":"Filing Actions","hideNameRequestCertificate":true,"hideAddressRequestCertificate":true,"hideRecordUserManagment":true,"searchPlaceholder":"Search by name or commission number","searchMustHaveOneOf":["CITY","search","SERVICE_TYPE"],"advancedParametersStartOpen":true,"searchIsSortable":true,"advancedSearchParameters":[{"type":"radio","name":"STARTS_WITH_YN","defaultValue":false,"options":[{"value":true,"label":"Starts with"},{"value":false,"label":"Contains"}]},{"type":"checkbox","name":"ACTIVE_ONLY_YN","defaultValue":true,"label":"Active entities only"},{"type":"text","name":"CITY","defaultValue":"","label":"City"},{"type":"select","name":"SERVICE_TYPE","label":"Special Services Offered","defaultValue":0,"options":[{"value":0,"label":"(N/A)"},{"value":6165,"label":"In-Person Electronic Notarization (IPEN)"},{"value":6166,"label":"Remote Online Notarization (RON)"},{"value":6167,"label":"Mobile Notary Services"},{"value":6168,"label":"Remote Ink Notarization (RIN)"}]}]},{"label":"Apostille","component":"Apostille","parameter":"apostille","sourceTypeId":720,"myRecordsSearch":false,"myWorkQueueSearch":false,"disabled":false,"allowedRoutes":["/forms-manager/","/queue/","/forms/"]},{"label":"Liens","component":"UCC","parameter":"ucc","sourceTypeId":1999,"myRecordsSearch":true,"myWorkQueueSearch":true,"fileAmendmentButtonLabel":"Filing Actions","searchPlaceholder":"Search by name or file number","disabled":false,"serverWebSearchDescription":true,"myRecordsDescription":"","workQueueDescription":"","searchDescription":"","hideRecordUserManagment":true,"searchLiensCheckout":false,"advancedSearchParameters":[{"type":"radio","name":"STARTS_WITH_YN","defaultValue":false,"options":[{"value":true,"label":"Starts with"},{"value":false,"label":"Contains"}]},{"type":"select","name":"STATUS","defaultValue":"ALL","label":"Status","options":[{"value":"ACTIVE_UNLAPSED","label":"Active (unlapsed)"},{"value":"ACTIVE_LAPSED_UNLAPSED","label":"Active (lapsed and unlapsed)"}]},{"type":"text","name":"EXCLUDE_VALUES","label":"Exclude Debtor Names (comma separated list of names to exclude)","defaultValue":""},{"type":"dateRange","name":"FILING_DATE","label":"Financing Statement Date","defaultValue":{"start":null,"end":null}},{"type":"dateRange","name":"LAPSE_DATE","label":"Lapse Date","defaultValue":{"start":null,"end":null}},{"type":"text","name":"CITY","label":"Debtor City","defaultValue":""}],"myRecordsFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Approved"},{"value":2,"label":"Pending Online Payment"},{"value":3,"label":"Pending Review"}]},{"type":"select","name":"TYPE","defaultValue":0,"label":"Lien Type","options":[{"value":0,"label":"All"},{"value":1,"label":"UCC"},{"value":2,"label":"EFS"},{"value":3,"label":"Title 71"}]}],"myWorkQueueFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Approved"},{"value":2,"label":"Pending Online Payment"},{"value":3,"label":"Pending Review"},{"value":4,"label":"Pending Print and Mail"},{"value":5,"label":"Rejected"},{"value":6,"label":"Draft"}]},{"type":"select","name":"TYPE","defaultValue":0,"label":"Lien Type","options":[{"value":0,"label":"All"},{"value":1,"label":"UCC"},{"value":2,"label":"EFS"},{"value":3,"label":"Title 71"}]}]},{"label":"Copy Request","component":"copies","parameter":"copies","sourceTypeId":2001,"myRecordsSearch":false,"myWorkQueueSearch":false,"disabled":false,"allowedRoutes":["/forms-manager/","/queue/","/forms/"]},{"label":"Trademark","component":"Trademark","parameter":"trademark","sourceTypeId":810,"showRequestCertificate":true,"searchMustHaveOneOf":["search","EXPIRATION_DATE","FILING_DATE"],"allowEmptySearchTerm":true,"requestCertificateAlternateLabel":"Request Information","fileAmendmentButtonLabel":"Filing Actions","advancedSearchParameters":[{"type":"radio","name":"QUERY_TYPE_ID","defaultValue":1010,"options":[{"value":1010,"label":"Starts with"},{"value":1011,"label":"Contains"},{"value":1012,"label":" Word Contains"}]},{"type":"checkbox","name":"OWNER_SEARCH_YN","defaultValue":false,"label":"Search owners"},{"type":"radio","name":"SERVICE_MARK_YN","label":"Mark Type","defaultValue":"","options":[{"value":"","label":"All Marks"},{"value":"Y","label":"Service Mark"},{"value":"N","label":"Trademark"}]},{"type":"serverSelect","name":"STATUS_ID","optionsSrc":"TYPE_V|TRADEMARK_STATUS_TYPE","label":"Status","placeholder":"All","defaultValue":"0"},{"type":"select","name":"DESIGN_TYPE_ID","options":[{"value":0,"label":"All"},{"value":990,"label":"Words Only"},{"value":991,"label":"Design Only"},{"value":992,"label":"Words and Design"}],"label":"Design Type","defaultValue":"0"},{"type":"dateRange","name":"FILING_DATE","label":"Registered Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}},{"type":"dateRange","name":"EXPIRATION_DATE","label":"Expiration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}}]},{"label":"Business Info Request","component":"InfoRequests","parameter":"info-request","sourceTypeId":167,"allowedRoutes":["/forms-manager/","/queue/","/forms/"]},{"label":"Data Requests","component":"DataRequests","parameter":"data-request","sourceTypeId":0,"allowedRoutes":["/forms-manager/"]},{"label":"CRA","component":"CRA","parameter":"cra","sourceTypeId":157,"myRecordsSearch":false,"searchPlaceholder":"Search by name or registered agent number","allowedRoutes":["/forms-manager/","/forms/","/records/","/queue/","/search/"],"allowEmptySearchTerm":true,"fileAmendmentButtonLabel":"Filing Actions","advancedSearchParameters":[{"type":"radio","name":"QUERY_TYPE_ID","defaultValue":1010,"options":[{"value":1010,"label":"Starts with"},{"value":1011,"label":"Contains"},{"value":1012,"label":" Word Contains"}]},{"type":"dateRange","name":"CRA_DATE","label":"Registration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}},{"type":"select","name":"STATUS_ID","label":"Status","defaultValue":0,"options":[{"value":0,"label":"All"},{"value":121,"label":"Active"},{"value":122,"label":"Inactive"}]},{"type":"select","name":"AGENT_TYPE_ID","label":"Agent Type","defaultValue":0,"options":[{"value":0,"label":"All"},{"value":460,"label":"Registered Agent"},{"value":461,"label":"Commercial Registered Agent"}]}]},{"label":"Farm Bill","component":"FarmBill","parameter":"farm-bill","path":"/lists/farm-bill","sourceTypeId":0,"myRecordsSearch":false,"allowedRules":["/search/"],"disabled":true,"searchDescription":"To perform a search, enter a debtor name. Your search results may include: exact debtor name, variations of that name and any filing that includes your search criteria. Punctuation is ignored.\n\nYou can click on \"Advanced\" to refine your search. Under “Advanced” you can search by crop, year, county and SSN/FEIN. As a registered Farm Bill Buyer with the Montana Secretary of State’s office it is important to maintain the confidentiality of the information contained within the Farm Bill Master List. The Farm Bill Master List reflects personal data, such as Social Security Numbers, which are a key piece of personal identifiable information to assist you in determining the existence of a lien against a specific debtor. The distribution of this information beyond its intended purpose is strictly prohibited.\n\nThe debtor's tax identification number has been hidden for confidentiality reasons. You may continue to search on a tax ID number and return debtors that match your search criteria. The SSN/FEIN must be entered without dashes or spaces.","searchMustHaveOneOf":["search","UCC_FARM_PRODUCT_ID","COUNTY"],"searchPlaceholder":"Search by debtor name","advancedSearchParameters":[{"type":"ServerMultiComplete","label":"Product code name(s)","name":"UCC_FARM_PRODUCT_ID","defaultValue":"","optionsSrc":"UCC_FARM_PRODUCT_V"},{"type":"MultiComplete","label":"Year or Range of Years","name":"YEAR_NUM","optionsSrc":"years","startYear":"1968","defaultValue":[],"preMergeOptions":[{"value":"ALL","label":"All"}]},{"type":"serverSelect","label":"State","name":"STATE","defaultValue":"MONTANA","optionsSrc":"STATE"},{"type":"ServerMultiComplete","label":"County","name":"COUNTY","defaultValue":[],"optionsSrc":"COUNTY","overrideSubOptionsSrcFromParameterName":"STATE"},{"type":"checkbox","name":"TIN_SEARCH_YN","defaultValue":false,"label":"Tax Identification Number Search"},{"type":"checkbox","name":"TIN_SORT_YN","defaultValue":false,"label":"Unique ID Sort"}]}],"SYSTEM_NICKNAME":"Online Services Portal","PAYMENT_METHODS":[{"type":"bypass"},{"type":"iTransact"}],"PAYMENT_ALLOW_AMEX":true,"SYSTEM_ID_LABEL":"System Id","DOUBLE_COLUMN_PUBLIC_LOGIN":true,"INTERNAL_USER_MANAGEMENT":true,"ALLOW_PUBLIC_JSON_IMPORT":false,"MAX_FILE_UPLOAD_SIZE":10000000,"REFUND_TEXT":"","RETURN_TO_HOME_ON_LOGOUT":true,"CURRENT_SOS_NAME":"Christi Jacobsen","LOGO_FILENAME":"mt-sos-logo.png","LOGO_ALT":"Christi Jacobsen, Montana Secretary of State","LOGO_FULL_WIDTH":true,"HOME_HIDE_AUTH_HINT":true,"HOME_TITLE":"Montana Secretary of State","CUSTOM_TAB_TITLE":"Official Montana","HOME_SUBTITLE":"Online Business Services","ENTITY_NAME_CONSENT_DESCRIPTION":"","ALLOW_USER_PROFILE_EDITING":true,"COMPARE_FOREIGN_NAME_IN_ENTITY_NAME_VALIDATION":true,"FOREIGN_NAME_FIELD_NAME":"KIMA_PARENT_NAME_INFO","LOGIN_TITLE":"Montana Secretary of State Online Filing Portal Login","PUBLIC_LOGIN_LABEL":"Username","REVERSE_LOGIN_COLUMNS":true,"LOGIN_SEAL_FILENAME":"seal_white.png","SEPARATE_USERNAME_AND_EMAIL":true,"CREATE_ACCOUNT_BUTTON_ALIGN_LEFT":true,"CREATE_ACCOUNT_BUTTON_TEXT":"CREATE AN ACCOUNT","PASSWORD_CUSTOM_ERROR_TEXT":"The password must meet all requirements","ACCOUNT_CREATED_MESSAGE":"Please check your email to verify your account to login and allow a few minutes for this message to arrive. Check your junk/spam folders if you do not find the email in your inbox.","PUBLIC_LOGIN_PLACEHOLDER":" ","DISABLE_DEFAULT_PAYMENT_RADIO":true,"CUSTOM_RESET_PASSWORD_ERROR_MESSAGE":"Username invalid - no account found","PUBLIC_LOGIN_CREATE_DESCRIPTION":"### Existing User:\n\n  - Enter your username and password to login.  \n\n\n  #### - OR -  \n\n\n\n  - Forgot password? Click 'Reset Password' and follow the prompts.\n  - Forgot username? Click 'Forgot Username' and follow the prompts.  \n\n\n  ### New User:\n  ","LOGIN_HELP_LINK":"https://sosmt.gov/business/how-do-i/","LOGIN_HELP_LINK_TEXT":"Need Help?","FORGOT_USERNAME_TEXT":"Forgot Username?","LOGIN_ACTIVE_DIRECTORY_TEXT":"State User Login","MULTIPLE_LOGIN_METHODS":true,"HAS_ACTIVE_DIRECTORY_LOGIN":true,"RESET_PASSWORD_WITH_USERNAME":true,"DOWNLOAD_LINK":true,"SHOW_USERNAME_ACCOUNT_CREATE":true,"SHOW_SCROLL_DOWN_ARROW":true,"SHOW_ADDRESS_ACCOUNT_CREATE":true,"TWO_COLUMN_ACCOUNT_CREATE":true,"RESET_PASSWORD_TIP":"A link to change your password has been sent to your email. Please allow a few minutes for this message to arrive. Please check your junk/spam folders if you do not find the email in your inbox.","FORGOT_PASSWORD_LINK_TEXT":"Reset Password","PHONE_NUMBER_OPTIONAL_ACCOUNT_CREATE":true,"SHOW_REQUIRED_INDICATOR_ACCOUNT_CREATE":true,"PASSWORD_REQUIREMENTS_ACCOUNT_CREATE":"\n    <ul>\n      <li>MUST contain at least 8 characters (12+ recommended)</li>\n      <li>MUST contain at least one uppercase letter.</li>\n      <li>MUST contain at least one lowercase letter.</li>\n      <li>MUST contain at least one number.</li>\n      <li>MUST contain at least one special character (!”#$%&'()*+,-./:;<=>?</li>\n    </ul>\n  ","ALLOW_CERTIFICATION_REQUEST":true,"ALLOW_PUBLIC_CERTIFICATE_REQUEST":true,"ALLOW_COPY_REQUEST":false,"ALLOW_CORRECTION_STYLING":true,"HIDE_DEPRECATION_WARNING":false,"AMEND_ROUTE_PUBLIC":true,"SEAL_FILENAME":"seal.png","SHOPPING_CART":true,"ALLOW_PAYMENT_UPDATE_WITH_EMPTY_CART":true,"RA_EMAIL":true,"RA_WEBSITE":true,"RA_NO_DEFAULT_TYPE":true,"RA_ADDRESS_LABEL":"Street Address","RA_TYPE_SELECTION_DEFAULT":true,"RA_DEFAULT_TYPE":"460","RA_OVERRIDE_TYPE_WITH_DEFAULT":true,"RA_PRINCIPAL_ADDRESS_AMS":true,"UPLOAD_AND_SUBMIT_HIDE_IF_ONE_OPTION":true,"PAYMENT_PROCESSING_MESSAGE":"Your payment is processing - Do not close your browser or click the back button","CHECKOUT_BUTTON_WHEN_PROCESSING_TEXT":"Processing","EFS_CROP_PICKER_NONE_LABEL":"Lien Duration","DISALLOWED_WIZARD_PIECES":["FormationLocale"],"REPEATER_SHOW_EDIT_BUTTON":true,"DATA_REQUEST_PAGE_TITLE":"Data Requests and Subscriptions","DATA_REQUEST_SIDEBAR_LABEL":"Data Requests & Subscriptions","LOGIN_REDIRECTS_TO_EPASS":false,"LOGIN_REDIRECTS_TO_ACTIVE_DIRECTORY":true,"LOGIN_ACTIVE_DIRECTORY_LINK":true,"FETCH_EDIT_USER_LINK":false,"LISTS_FETCH_AVAILABLE_LISTS":true,"POST_WIZARD_SUBMIT_REDIRECT_URL":"/","PIN_REQUEST_ATTESTATIONS":true,"PIN_REQUEST_DESCRIPTION":"Click **Request PIN** to have a new PIN sent to the account holder's email address on file.","OWNERSHIP_REQUEST_DESCRIPTION":"To become an **authorized user** of this record, a current **AUTHORIZED USER** will need to grant you access. To request access, click **Request Access** below.","PIN_REQUEST_SUCCESS_MESSAGE":"The PIN you have requested for this entity has been sent to the email associated with your user account.  You should receive the PIN in approximately 3-5 minutes, depending on your email service provider.","APOSTILLE_HEADER_LABEL":"Verification Information","APOSTILLE_NUMBER_LABEL":"Apostille/Authentication","APOSTILLE_CITY_STATE_OVERRIDE":"HELENA, MT","APOSTILLE_FILING_DATE_LABEL":"Issue Date","APOSTILLE_CITY_STATE_IN_CERTIFIED":true,"NOTARY_EXISTING_FILING":true,"ALLOW_REVOKE_OWN_ACCESS_ONLY":false,"HIDE_CANCEL_ON_ONETIME_DATA_REQUESTS":true,"DATA_REQUESTS_IN_SHOPPING_CART":true,"WQ_ALLOW_EDIT_PENDING_PAYMENT":true,"WQ_CONFIRM_ON_DELETE":true,"WQ_DELETE_CONFIRM_MESSAGE":"Deleting this filing will forfeit any money already paid to the Secretary of State. This action is permanent and cannot be undone, are you sure you would like to delete?","PASS_ITEM_GUIDS_ON_CHECKOUT":true,"FORM_REVISION_HISTORY":true,"CHECKOUT_DISCLAIMER":"By entering your credit card and/or checking account information you (i) state that **you are an authorized user** of the credit card and/or electronic check and that the associated information entered (e.g., account holder name, account number, billing address) is accurate, (ii) **you authorize payment processor to charge the amount you have requested** to your credit card and/or funding account, and (iii) **acknowledge if a charge is declined or reversed you may also be assessed a customary charge** by the payment processor for such transactions.","FARM_BILL_SEARCH_CONFIDENTIAL":"As a registered Farm Bill Buyer with the Montana Secretary of State’s office it is important to maintain the confidentiality of the information contained within the Farm Bill Master List. The Farm Bill Master List reflects personal data, such as Social Security Numbers, which are a key piece of personal identifiable information to assist you in determining the existence of a lien against a specific debtor. The distribution of this information beyond its intended purpose is strictly prohibited.\n\n**The debtor's tax identification number has been hidden for confidentiality reasons. You may continue to search on a tax ID number and return debtors that match your search criteria. The SSN/FEIN must be entered without dashes or spaces.  If you need access to the tax identification number to clearly identify the debtor, please contact the UCC unit at (406) 444-3665.**","VIEW_HISTORY_BUTTON_ALT_TEXT":"View Filings","WIZARD_ERROR_TITLE_MESSAGE":"Form Error","FARM_BILL_SEARCH_INTERACTIVE":true,"USE_FARM_BILL_API":true,"DISALLOW_ASSIGN_SELF_AS_RA":true,"DISALLOW_ASSIGN_SELF_AS_PRINCIPAL":true,"USE_TRADEMARK_OWNER_VALIDATION":true,"USE_ALTERNATIVE_FOREIGN_ADDRESS_LABELS":true,"MY_RECEIPTS_FILTER":[{"type":"dateRange","name":"DATE_RANGE","label":"Date range","defaultValue":{"start":null,"end":null}},{"type":"text","name":"REF_NUM","defaultValue":"","label":"Reference Number"},{"type":"text","name":"RECEIPT_NUM","defaultValue":"","label":"Receipt Id"},{"type":"text","name":"AMOUNT","defaultValue":"","label":"Amount"},{"type":"select","name":"TYPE","defaultValue":"","label":"Payment Type","options":[{"value":"","label":"All"},{"value":"CC","label":"Credit Card"},{"value":"Check","label":"Check"}]}],"MY_RECEIPTS_SHOW_IN_SIDEBAR":true,"SHOW_MY_RECEIPTS_HELPER_TEXT":true,"MY_RECEIPTS_HELPER_LABEL":"About Receipt Search","MY_RECEIPTS_HELPER_TEXT":"You can search for receipts based on their descriptions, including the items paid for on the receipt. Use the filters to search for or filter specific information.","FARM_BILL_SUBLINK":{"label":"Farm Bill","component":"FarmBill","parameter":"farm-bill","path":"/lists/farm-bill","sourceTypeId":0,"myRecordsSearch":false,"allowedRules":["/search/"],"disabled":true,"searchDescription":"To perform a search, enter a debtor name. Your search results may include: exact debtor name, variations of that name and any filing that includes your search criteria. Punctuation is ignored.\n\nYou can click on \"Advanced\" to refine your search. Under “Advanced” you can search by crop, year, county and SSN/FEIN. As a registered Farm Bill Buyer with the Montana Secretary of State’s office it is important to maintain the confidentiality of the information contained within the Farm Bill Master List. The Farm Bill Master List reflects personal data, such as Social Security Numbers, which are a key piece of personal identifiable information to assist you in determining the existence of a lien against a specific debtor. The distribution of this information beyond its intended purpose is strictly prohibited.\n\nThe debtor's tax identification number has been hidden for confidentiality reasons. You may continue to search on a tax ID number and return debtors that match your search criteria. The SSN/FEIN must be entered without dashes or spaces.","searchMustHaveOneOf":["search","UCC_FARM_PRODUCT_ID","COUNTY"],"searchPlaceholder":"Search by debtor name","advancedSearchParameters":[{"type":"ServerMultiComplete","label":"Product code name(s)","name":"UCC_FARM_PRODUCT_ID","defaultValue":"","optionsSrc":"UCC_FARM_PRODUCT_V"},{"type":"MultiComplete","label":"Year or Range of Years","name":"YEAR_NUM","optionsSrc":"years","startYear":"1968","defaultValue":[],"preMergeOptions":[{"value":"ALL","label":"All"}]},{"type":"serverSelect","label":"State","name":"STATE","defaultValue":"MONTANA","optionsSrc":"STATE"},{"type":"ServerMultiComplete","label":"County","name":"COUNTY","defaultValue":[],"optionsSrc":"COUNTY","overrideSubOptionsSrcFromParameterName":"STATE"},{"type":"checkbox","name":"TIN_SEARCH_YN","defaultValue":false,"label":"Tax Identification Number Search"},{"type":"checkbox","name":"TIN_SORT_YN","defaultValue":false,"label":"Unique ID Sort"}]},"ALLOW_ADDRESS_VALIDATION_BYPASS_OPTION":true,"DEFAULT_ADDRESS_VALIDATION_BYPASS_OPTION_CHECKED":true}).MY_WORK_QUEUE_EMPTY_STATE_LINE_2;
	var ALLOW_CORRECTION_STYLING = (true);
	var MY_WORK_QUEUE_DESCRIPTION = ({"NODE_ENV":"production","BUILD_DATE":"2025-08-27T15:15:31.687Z","BUILD_NUMBER":"Not Provided","GIT_VERSION":"v1.3.0-381-ga81e29b08","GIT_COMMIT_HASH":"a81e29b085c9268ffd96c78eb734365802722741","GIT_BRANCH":"beta","PUBLIC_URL":"","STATE_ABBR":"MT","STATE_NAME":"Montana","STATE_ORG_TITLE":"Secretary of State","LOGIN_HEADER_IMG_PATH":"","HOME_IMG_FILENAME":"montana.jpg","FAVICON_FILE_NAME":"favicon.ico","ALLOW_E_SIGN_ON_CORRECTIONS":true,"THIRD_PARTY_SIGNING_ALLOWED":false,"MY_ACCOUNT_SAVE_AND_CLOSE_BUTTON":true,"IE_DEPRECATED_MESSAGE":"Internet Explorer is not supported. Please select a supported browser below to access this website.","ADDITIONAL_ROUTES":{"dataRequests":true,"farmBill":true,"apostille":true,"externalHelp":"https://sosmt.gov/business/help-center/","systemAdministration":[{"title":"Saved Payments","parameter":"saved-payments","componentName":"SavedPayments"}]},"SUBROUTES":[{"label":"Business","component":"Business","parameter":"business","myWorkQueueSearch":false,"sourceTypeId":54,"searchMustHaveOneOf":["FILING_TYPE_ID","STATUS_ID","STATE","search"],"serverWebSearchDescription":true,"serverWorkQueueDescription":true,"serverMyRecordsDescription":true,"searchPlaceholder":"Search by name or filing number (X########)","allowEmptySearchTerm":true,"requestCertificateAlternateLabel":"Request Information","fileAmendmentButtonLabel":"Filing Actions","advancedSearchParameters":[{"type":"radio","name":"QUERY_TYPE_ID","defaultValue":1010,"options":[{"value":1010,"label":"Starts with"},{"value":1011,"label":"Contains"},{"value":1012,"label":" Word Contains"}]},{"type":"serverSelect","name":"FILING_TYPE_ID","optionsSrc":"FILING_TYPES","label":"Entity Type","placeholder":"All","defaultValue":"0"},{"type":"serverSelect","name":"FILING_SUBTYPE_ID","optionsSrc":"FILING_SUBTYPES","label":"Entity Subtype","overrideSubOptionsSrcFromParameterName":"FILING_TYPE_ID","placeholder":"All","defaultValue":"0"},{"type":"serverSelect","name":"STATUS_ID","optionsSrc":"FILING_STATUS_WITHOUT_ALL","label":"Status","placeholder":"All","defaultValue":"0"},{"type":"serverSelect","name":"STATE","optionsSrc":"STATE","label":"State","placeholder":"All","defaultValue":""},{"type":"serverSelect","name":"COUNTY","optionsSrc":"COUNTY_SUBOPTION","label":"County","overrideSubOptionsSrcFromParameterName":"STATE","placeholder":"All","defaultValue":""},{"type":"checkbox","name":"CRA_SEARCH_YN","defaultValue":false,"label":"Search by Registered Agent PID"},{"type":"dateRange","name":"FILING_DATE","label":"Registration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}},{"type":"dateRange","name":"EXPIRATION_DATE","label":"Expiration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}}],"myRecordsFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Active"},{"value":2,"label":"Inactive"},{"value":3,"label":"Pending"}]},{"type":"dateRange","name":"DATE_RANGE","label":"Date range","defaultValue":{"start":null,"end":null}}],"myWorkQueueFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Approved"},{"value":2,"label":"Pending Online Payment"},{"value":3,"label":"Pending Review"},{"value":4,"label":"Needs Correction"},{"value":5,"label":"Rejected"},{"value":6,"label":"Draft"}]},{"type":"dateRange","name":"DATE_RANGE","label":"Date range","defaultValue":{"start":null,"end":null}}]},{"label":"Notary","component":"Notary","parameter":"notary","sourceTypeId":850,"myWorkQueueSearch":false,"allowEmptySearchTerm":true,"requestCertificateAlternateLabel":"Download Certificate","fileAmendmentButtonLabel":"Filing Actions","hideNameRequestCertificate":true,"hideAddressRequestCertificate":true,"hideRecordUserManagment":true,"searchPlaceholder":"Search by name or commission number","searchMustHaveOneOf":["CITY","search","SERVICE_TYPE"],"advancedParametersStartOpen":true,"searchIsSortable":true,"advancedSearchParameters":[{"type":"radio","name":"STARTS_WITH_YN","defaultValue":false,"options":[{"value":true,"label":"Starts with"},{"value":false,"label":"Contains"}]},{"type":"checkbox","name":"ACTIVE_ONLY_YN","defaultValue":true,"label":"Active entities only"},{"type":"text","name":"CITY","defaultValue":"","label":"City"},{"type":"select","name":"SERVICE_TYPE","label":"Special Services Offered","defaultValue":0,"options":[{"value":0,"label":"(N/A)"},{"value":6165,"label":"In-Person Electronic Notarization (IPEN)"},{"value":6166,"label":"Remote Online Notarization (RON)"},{"value":6167,"label":"Mobile Notary Services"},{"value":6168,"label":"Remote Ink Notarization (RIN)"}]}]},{"label":"Apostille","component":"Apostille","parameter":"apostille","sourceTypeId":720,"myRecordsSearch":false,"myWorkQueueSearch":false,"disabled":false,"allowedRoutes":["/forms-manager/","/queue/","/forms/"]},{"label":"Liens","component":"UCC","parameter":"ucc","sourceTypeId":1999,"myRecordsSearch":true,"myWorkQueueSearch":true,"fileAmendmentButtonLabel":"Filing Actions","searchPlaceholder":"Search by name or file number","disabled":false,"serverWebSearchDescription":true,"myRecordsDescription":"","workQueueDescription":"","searchDescription":"","hideRecordUserManagment":true,"searchLiensCheckout":false,"advancedSearchParameters":[{"type":"radio","name":"STARTS_WITH_YN","defaultValue":false,"options":[{"value":true,"label":"Starts with"},{"value":false,"label":"Contains"}]},{"type":"select","name":"STATUS","defaultValue":"ALL","label":"Status","options":[{"value":"ACTIVE_UNLAPSED","label":"Active (unlapsed)"},{"value":"ACTIVE_LAPSED_UNLAPSED","label":"Active (lapsed and unlapsed)"}]},{"type":"text","name":"EXCLUDE_VALUES","label":"Exclude Debtor Names (comma separated list of names to exclude)","defaultValue":""},{"type":"dateRange","name":"FILING_DATE","label":"Financing Statement Date","defaultValue":{"start":null,"end":null}},{"type":"dateRange","name":"LAPSE_DATE","label":"Lapse Date","defaultValue":{"start":null,"end":null}},{"type":"text","name":"CITY","label":"Debtor City","defaultValue":""}],"myRecordsFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Approved"},{"value":2,"label":"Pending Online Payment"},{"value":3,"label":"Pending Review"}]},{"type":"select","name":"TYPE","defaultValue":0,"label":"Lien Type","options":[{"value":0,"label":"All"},{"value":1,"label":"UCC"},{"value":2,"label":"EFS"},{"value":3,"label":"Title 71"}]}],"myWorkQueueFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Approved"},{"value":2,"label":"Pending Online Payment"},{"value":3,"label":"Pending Review"},{"value":4,"label":"Pending Print and Mail"},{"value":5,"label":"Rejected"},{"value":6,"label":"Draft"}]},{"type":"select","name":"TYPE","defaultValue":0,"label":"Lien Type","options":[{"value":0,"label":"All"},{"value":1,"label":"UCC"},{"value":2,"label":"EFS"},{"value":3,"label":"Title 71"}]}]},{"label":"Copy Request","component":"copies","parameter":"copies","sourceTypeId":2001,"myRecordsSearch":false,"myWorkQueueSearch":false,"disabled":false,"allowedRoutes":["/forms-manager/","/queue/","/forms/"]},{"label":"Trademark","component":"Trademark","parameter":"trademark","sourceTypeId":810,"showRequestCertificate":true,"searchMustHaveOneOf":["search","EXPIRATION_DATE","FILING_DATE"],"allowEmptySearchTerm":true,"requestCertificateAlternateLabel":"Request Information","fileAmendmentButtonLabel":"Filing Actions","advancedSearchParameters":[{"type":"radio","name":"QUERY_TYPE_ID","defaultValue":1010,"options":[{"value":1010,"label":"Starts with"},{"value":1011,"label":"Contains"},{"value":1012,"label":" Word Contains"}]},{"type":"checkbox","name":"OWNER_SEARCH_YN","defaultValue":false,"label":"Search owners"},{"type":"radio","name":"SERVICE_MARK_YN","label":"Mark Type","defaultValue":"","options":[{"value":"","label":"All Marks"},{"value":"Y","label":"Service Mark"},{"value":"N","label":"Trademark"}]},{"type":"serverSelect","name":"STATUS_ID","optionsSrc":"TYPE_V|TRADEMARK_STATUS_TYPE","label":"Status","placeholder":"All","defaultValue":"0"},{"type":"select","name":"DESIGN_TYPE_ID","options":[{"value":0,"label":"All"},{"value":990,"label":"Words Only"},{"value":991,"label":"Design Only"},{"value":992,"label":"Words and Design"}],"label":"Design Type","defaultValue":"0"},{"type":"dateRange","name":"FILING_DATE","label":"Registered Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}},{"type":"dateRange","name":"EXPIRATION_DATE","label":"Expiration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}}]},{"label":"Business Info Request","component":"InfoRequests","parameter":"info-request","sourceTypeId":167,"allowedRoutes":["/forms-manager/","/queue/","/forms/"]},{"label":"Data Requests","component":"DataRequests","parameter":"data-request","sourceTypeId":0,"allowedRoutes":["/forms-manager/"]},{"label":"CRA","component":"CRA","parameter":"cra","sourceTypeId":157,"myRecordsSearch":false,"searchPlaceholder":"Search by name or registered agent number","allowedRoutes":["/forms-manager/","/forms/","/records/","/queue/","/search/"],"allowEmptySearchTerm":true,"fileAmendmentButtonLabel":"Filing Actions","advancedSearchParameters":[{"type":"radio","name":"QUERY_TYPE_ID","defaultValue":1010,"options":[{"value":1010,"label":"Starts with"},{"value":1011,"label":"Contains"},{"value":1012,"label":" Word Contains"}]},{"type":"dateRange","name":"CRA_DATE","label":"Registration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}},{"type":"select","name":"STATUS_ID","label":"Status","defaultValue":0,"options":[{"value":0,"label":"All"},{"value":121,"label":"Active"},{"value":122,"label":"Inactive"}]},{"type":"select","name":"AGENT_TYPE_ID","label":"Agent Type","defaultValue":0,"options":[{"value":0,"label":"All"},{"value":460,"label":"Registered Agent"},{"value":461,"label":"Commercial Registered Agent"}]}]},{"label":"Farm Bill","component":"FarmBill","parameter":"farm-bill","path":"/lists/farm-bill","sourceTypeId":0,"myRecordsSearch":false,"allowedRules":["/search/"],"disabled":true,"searchDescription":"To perform a search, enter a debtor name. Your search results may include: exact debtor name, variations of that name and any filing that includes your search criteria. Punctuation is ignored.\n\nYou can click on \"Advanced\" to refine your search. Under “Advanced” you can search by crop, year, county and SSN/FEIN. As a registered Farm Bill Buyer with the Montana Secretary of State’s office it is important to maintain the confidentiality of the information contained within the Farm Bill Master List. The Farm Bill Master List reflects personal data, such as Social Security Numbers, which are a key piece of personal identifiable information to assist you in determining the existence of a lien against a specific debtor. The distribution of this information beyond its intended purpose is strictly prohibited.\n\nThe debtor's tax identification number has been hidden for confidentiality reasons. You may continue to search on a tax ID number and return debtors that match your search criteria. The SSN/FEIN must be entered without dashes or spaces.","searchMustHaveOneOf":["search","UCC_FARM_PRODUCT_ID","COUNTY"],"searchPlaceholder":"Search by debtor name","advancedSearchParameters":[{"type":"ServerMultiComplete","label":"Product code name(s)","name":"UCC_FARM_PRODUCT_ID","defaultValue":"","optionsSrc":"UCC_FARM_PRODUCT_V"},{"type":"MultiComplete","label":"Year or Range of Years","name":"YEAR_NUM","optionsSrc":"years","startYear":"1968","defaultValue":[],"preMergeOptions":[{"value":"ALL","label":"All"}]},{"type":"serverSelect","label":"State","name":"STATE","defaultValue":"MONTANA","optionsSrc":"STATE"},{"type":"ServerMultiComplete","label":"County","name":"COUNTY","defaultValue":[],"optionsSrc":"COUNTY","overrideSubOptionsSrcFromParameterName":"STATE"},{"type":"checkbox","name":"TIN_SEARCH_YN","defaultValue":false,"label":"Tax Identification Number Search"},{"type":"checkbox","name":"TIN_SORT_YN","defaultValue":false,"label":"Unique ID Sort"}]}],"SYSTEM_NICKNAME":"Online Services Portal","PAYMENT_METHODS":[{"type":"bypass"},{"type":"iTransact"}],"PAYMENT_ALLOW_AMEX":true,"SYSTEM_ID_LABEL":"System Id","DOUBLE_COLUMN_PUBLIC_LOGIN":true,"INTERNAL_USER_MANAGEMENT":true,"ALLOW_PUBLIC_JSON_IMPORT":false,"MAX_FILE_UPLOAD_SIZE":10000000,"REFUND_TEXT":"","RETURN_TO_HOME_ON_LOGOUT":true,"CURRENT_SOS_NAME":"Christi Jacobsen","LOGO_FILENAME":"mt-sos-logo.png","LOGO_ALT":"Christi Jacobsen, Montana Secretary of State","LOGO_FULL_WIDTH":true,"HOME_HIDE_AUTH_HINT":true,"HOME_TITLE":"Montana Secretary of State","CUSTOM_TAB_TITLE":"Official Montana","HOME_SUBTITLE":"Online Business Services","ENTITY_NAME_CONSENT_DESCRIPTION":"","ALLOW_USER_PROFILE_EDITING":true,"COMPARE_FOREIGN_NAME_IN_ENTITY_NAME_VALIDATION":true,"FOREIGN_NAME_FIELD_NAME":"KIMA_PARENT_NAME_INFO","LOGIN_TITLE":"Montana Secretary of State Online Filing Portal Login","PUBLIC_LOGIN_LABEL":"Username","REVERSE_LOGIN_COLUMNS":true,"LOGIN_SEAL_FILENAME":"seal_white.png","SEPARATE_USERNAME_AND_EMAIL":true,"CREATE_ACCOUNT_BUTTON_ALIGN_LEFT":true,"CREATE_ACCOUNT_BUTTON_TEXT":"CREATE AN ACCOUNT","PASSWORD_CUSTOM_ERROR_TEXT":"The password must meet all requirements","ACCOUNT_CREATED_MESSAGE":"Please check your email to verify your account to login and allow a few minutes for this message to arrive. Check your junk/spam folders if you do not find the email in your inbox.","PUBLIC_LOGIN_PLACEHOLDER":" ","DISABLE_DEFAULT_PAYMENT_RADIO":true,"CUSTOM_RESET_PASSWORD_ERROR_MESSAGE":"Username invalid - no account found","PUBLIC_LOGIN_CREATE_DESCRIPTION":"### Existing User:\n\n  - Enter your username and password to login.  \n\n\n  #### - OR -  \n\n\n\n  - Forgot password? Click 'Reset Password' and follow the prompts.\n  - Forgot username? Click 'Forgot Username' and follow the prompts.  \n\n\n  ### New User:\n  ","LOGIN_HELP_LINK":"https://sosmt.gov/business/how-do-i/","LOGIN_HELP_LINK_TEXT":"Need Help?","FORGOT_USERNAME_TEXT":"Forgot Username?","LOGIN_ACTIVE_DIRECTORY_TEXT":"State User Login","MULTIPLE_LOGIN_METHODS":true,"HAS_ACTIVE_DIRECTORY_LOGIN":true,"RESET_PASSWORD_WITH_USERNAME":true,"DOWNLOAD_LINK":true,"SHOW_USERNAME_ACCOUNT_CREATE":true,"SHOW_SCROLL_DOWN_ARROW":true,"SHOW_ADDRESS_ACCOUNT_CREATE":true,"TWO_COLUMN_ACCOUNT_CREATE":true,"RESET_PASSWORD_TIP":"A link to change your password has been sent to your email. Please allow a few minutes for this message to arrive. Please check your junk/spam folders if you do not find the email in your inbox.","FORGOT_PASSWORD_LINK_TEXT":"Reset Password","PHONE_NUMBER_OPTIONAL_ACCOUNT_CREATE":true,"SHOW_REQUIRED_INDICATOR_ACCOUNT_CREATE":true,"PASSWORD_REQUIREMENTS_ACCOUNT_CREATE":"\n    <ul>\n      <li>MUST contain at least 8 characters (12+ recommended)</li>\n      <li>MUST contain at least one uppercase letter.</li>\n      <li>MUST contain at least one lowercase letter.</li>\n      <li>MUST contain at least one number.</li>\n      <li>MUST contain at least one special character (!”#$%&'()*+,-./:;<=>?</li>\n    </ul>\n  ","ALLOW_CERTIFICATION_REQUEST":true,"ALLOW_PUBLIC_CERTIFICATE_REQUEST":true,"ALLOW_COPY_REQUEST":false,"ALLOW_CORRECTION_STYLING":true,"HIDE_DEPRECATION_WARNING":false,"AMEND_ROUTE_PUBLIC":true,"SEAL_FILENAME":"seal.png","SHOPPING_CART":true,"ALLOW_PAYMENT_UPDATE_WITH_EMPTY_CART":true,"RA_EMAIL":true,"RA_WEBSITE":true,"RA_NO_DEFAULT_TYPE":true,"RA_ADDRESS_LABEL":"Street Address","RA_TYPE_SELECTION_DEFAULT":true,"RA_DEFAULT_TYPE":"460","RA_OVERRIDE_TYPE_WITH_DEFAULT":true,"RA_PRINCIPAL_ADDRESS_AMS":true,"UPLOAD_AND_SUBMIT_HIDE_IF_ONE_OPTION":true,"PAYMENT_PROCESSING_MESSAGE":"Your payment is processing - Do not close your browser or click the back button","CHECKOUT_BUTTON_WHEN_PROCESSING_TEXT":"Processing","EFS_CROP_PICKER_NONE_LABEL":"Lien Duration","DISALLOWED_WIZARD_PIECES":["FormationLocale"],"REPEATER_SHOW_EDIT_BUTTON":true,"DATA_REQUEST_PAGE_TITLE":"Data Requests and Subscriptions","DATA_REQUEST_SIDEBAR_LABEL":"Data Requests & Subscriptions","LOGIN_REDIRECTS_TO_EPASS":false,"LOGIN_REDIRECTS_TO_ACTIVE_DIRECTORY":true,"LOGIN_ACTIVE_DIRECTORY_LINK":true,"FETCH_EDIT_USER_LINK":false,"LISTS_FETCH_AVAILABLE_LISTS":true,"POST_WIZARD_SUBMIT_REDIRECT_URL":"/","PIN_REQUEST_ATTESTATIONS":true,"PIN_REQUEST_DESCRIPTION":"Click **Request PIN** to have a new PIN sent to the account holder's email address on file.","OWNERSHIP_REQUEST_DESCRIPTION":"To become an **authorized user** of this record, a current **AUTHORIZED USER** will need to grant you access. To request access, click **Request Access** below.","PIN_REQUEST_SUCCESS_MESSAGE":"The PIN you have requested for this entity has been sent to the email associated with your user account.  You should receive the PIN in approximately 3-5 minutes, depending on your email service provider.","APOSTILLE_HEADER_LABEL":"Verification Information","APOSTILLE_NUMBER_LABEL":"Apostille/Authentication","APOSTILLE_CITY_STATE_OVERRIDE":"HELENA, MT","APOSTILLE_FILING_DATE_LABEL":"Issue Date","APOSTILLE_CITY_STATE_IN_CERTIFIED":true,"NOTARY_EXISTING_FILING":true,"ALLOW_REVOKE_OWN_ACCESS_ONLY":false,"HIDE_CANCEL_ON_ONETIME_DATA_REQUESTS":true,"DATA_REQUESTS_IN_SHOPPING_CART":true,"WQ_ALLOW_EDIT_PENDING_PAYMENT":true,"WQ_CONFIRM_ON_DELETE":true,"WQ_DELETE_CONFIRM_MESSAGE":"Deleting this filing will forfeit any money already paid to the Secretary of State. This action is permanent and cannot be undone, are you sure you would like to delete?","PASS_ITEM_GUIDS_ON_CHECKOUT":true,"FORM_REVISION_HISTORY":true,"CHECKOUT_DISCLAIMER":"By entering your credit card and/or checking account information you (i) state that **you are an authorized user** of the credit card and/or electronic check and that the associated information entered (e.g., account holder name, account number, billing address) is accurate, (ii) **you authorize payment processor to charge the amount you have requested** to your credit card and/or funding account, and (iii) **acknowledge if a charge is declined or reversed you may also be assessed a customary charge** by the payment processor for such transactions.","FARM_BILL_SEARCH_CONFIDENTIAL":"As a registered Farm Bill Buyer with the Montana Secretary of State’s office it is important to maintain the confidentiality of the information contained within the Farm Bill Master List. The Farm Bill Master List reflects personal data, such as Social Security Numbers, which are a key piece of personal identifiable information to assist you in determining the existence of a lien against a specific debtor. The distribution of this information beyond its intended purpose is strictly prohibited.\n\n**The debtor's tax identification number has been hidden for confidentiality reasons. You may continue to search on a tax ID number and return debtors that match your search criteria. The SSN/FEIN must be entered without dashes or spaces.  If you need access to the tax identification number to clearly identify the debtor, please contact the UCC unit at (406) 444-3665.**","VIEW_HISTORY_BUTTON_ALT_TEXT":"View Filings","WIZARD_ERROR_TITLE_MESSAGE":"Form Error","FARM_BILL_SEARCH_INTERACTIVE":true,"USE_FARM_BILL_API":true,"DISALLOW_ASSIGN_SELF_AS_RA":true,"DISALLOW_ASSIGN_SELF_AS_PRINCIPAL":true,"USE_TRADEMARK_OWNER_VALIDATION":true,"USE_ALTERNATIVE_FOREIGN_ADDRESS_LABELS":true,"MY_RECEIPTS_FILTER":[{"type":"dateRange","name":"DATE_RANGE","label":"Date range","defaultValue":{"start":null,"end":null}},{"type":"text","name":"REF_NUM","defaultValue":"","label":"Reference Number"},{"type":"text","name":"RECEIPT_NUM","defaultValue":"","label":"Receipt Id"},{"type":"text","name":"AMOUNT","defaultValue":"","label":"Amount"},{"type":"select","name":"TYPE","defaultValue":"","label":"Payment Type","options":[{"value":"","label":"All"},{"value":"CC","label":"Credit Card"},{"value":"Check","label":"Check"}]}],"MY_RECEIPTS_SHOW_IN_SIDEBAR":true,"SHOW_MY_RECEIPTS_HELPER_TEXT":true,"MY_RECEIPTS_HELPER_LABEL":"About Receipt Search","MY_RECEIPTS_HELPER_TEXT":"You can search for receipts based on their descriptions, including the items paid for on the receipt. Use the filters to search for or filter specific information.","FARM_BILL_SUBLINK":{"label":"Farm Bill","component":"FarmBill","parameter":"farm-bill","path":"/lists/farm-bill","sourceTypeId":0,"myRecordsSearch":false,"allowedRules":["/search/"],"disabled":true,"searchDescription":"To perform a search, enter a debtor name. Your search results may include: exact debtor name, variations of that name and any filing that includes your search criteria. Punctuation is ignored.\n\nYou can click on \"Advanced\" to refine your search. Under “Advanced” you can search by crop, year, county and SSN/FEIN. As a registered Farm Bill Buyer with the Montana Secretary of State’s office it is important to maintain the confidentiality of the information contained within the Farm Bill Master List. The Farm Bill Master List reflects personal data, such as Social Security Numbers, which are a key piece of personal identifiable information to assist you in determining the existence of a lien against a specific debtor. The distribution of this information beyond its intended purpose is strictly prohibited.\n\nThe debtor's tax identification number has been hidden for confidentiality reasons. You may continue to search on a tax ID number and return debtors that match your search criteria. The SSN/FEIN must be entered without dashes or spaces.","searchMustHaveOneOf":["search","UCC_FARM_PRODUCT_ID","COUNTY"],"searchPlaceholder":"Search by debtor name","advancedSearchParameters":[{"type":"ServerMultiComplete","label":"Product code name(s)","name":"UCC_FARM_PRODUCT_ID","defaultValue":"","optionsSrc":"UCC_FARM_PRODUCT_V"},{"type":"MultiComplete","label":"Year or Range of Years","name":"YEAR_NUM","optionsSrc":"years","startYear":"1968","defaultValue":[],"preMergeOptions":[{"value":"ALL","label":"All"}]},{"type":"serverSelect","label":"State","name":"STATE","defaultValue":"MONTANA","optionsSrc":"STATE"},{"type":"ServerMultiComplete","label":"County","name":"COUNTY","defaultValue":[],"optionsSrc":"COUNTY","overrideSubOptionsSrcFromParameterName":"STATE"},{"type":"checkbox","name":"TIN_SEARCH_YN","defaultValue":false,"label":"Tax Identification Number Search"},{"type":"checkbox","name":"TIN_SORT_YN","defaultValue":false,"label":"Unique ID Sort"}]},"ALLOW_ADDRESS_VALIDATION_BYPASS_OPTION":true,"DEFAULT_ADDRESS_VALIDATION_BYPASS_OPTION_CHECKED":true}).MY_WORK_QUEUE_DESCRIPTION;
	
	var MyWorkQueue = function (_Component) {
	  _inherits(MyWorkQueue, _Component);
	
	  function MyWorkQueue() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, MyWorkQueue);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = MyWorkQueue.__proto__ || Object.getPrototypeOf(MyWorkQueue)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      receiptOpen: false,
	      highlightId: null,
	      checkoutOpen: false,
	      paymentDisabled: false,
	      paymentDisabledId: null,
	      deleteDialogOpen: false,
	      deletingId: null
	    }, _this.componentDidMount = function () {
	      if (_this.props.match.params.category) {
	        if (!_App.SUBROUTES_OBJ[_this.props.match.params.category] || !(_App.SUBROUTES_OBJ[_this.props.match.params.category].allowedRoutes || ['/queue/']).includes('/queue/')) {
	          _this.props.history.replace('/404');
	        } else {
	          _this.props.setActiveCategory(_this.props.match.params.category);
	          _this.getRecords(_this.props.match.params.category);
	          if (_App.SUBROUTES_OBJ[_this.props.match.params.category].serverWorkQueueDescription && !_this.props.serverDescription) {
	            _this.props.getWorkQueueDescription(_this.props.match.params.category);
	          }
	        }
	      }
	      // const params = parseUrlQuery(this.props.location.search)
	      // if(params.receipt){
	      //   this.setState({receiptOpen: true, highlightId: params.hid})
	      //   this.props.history.replace(this.props.location.pathname)
	      // }
	    }, _this.componentDidUpdate = function (prevProps) {
	      var module = window.location.href.split('/').pop();
	      if (module !== _this.state.module) _this.setState(function (state) {
	        return state = Object.assign({}, state, { module: module });
	      });
	      (0, _MyWorkQueueActions.setFilters)({});
	      if (_this.props.match.params.category !== prevProps.match.params.category) {
	        if (_App.SUBROUTES_OBJ[_this.props.match.params.category] && (_App.SUBROUTES_OBJ[_this.props.match.params.category].allowedRoutes || ['/queue/']).includes('/queue/')) {
	          _this.props.setActiveCategory(_this.props.match.params.category);
	          _this.getRecords(_this.props.match.params.category);
	          if (_App.SUBROUTES_OBJ[_this.props.match.params.category].serverWorkQueueDescription && !_this.props.serverDescription) {
	            _this.props.getWorkQueueDescription(_this.props.match.params.category);
	          }
	        } else {
	          _this.props.history.replace('/404');
	        }
	      }
	    }, _this.getRecords = function (nextCategory, callback) {
	      _this.props.fetchAndSetWorkQueueItems(nextCategory, callback);
	    }, _this.edit = function (e) {
	      console.log(e);
	    }, _this.editDraft = function (row) {
	      _this.props.history.push('/draft/' + row.ID);
	    }, _this.deleteDraft = function (row) {
	      (0, _requests.DELETE_DRAFT_BY_ID)(row.ID, function (response) {
	        _this.getRecords(_this.props.match.params.category);
	      });
	    }, _this.confirmDelete = function (row) {
	      _this.setState({ deletingId: row.ID, deleteDialogOpen: true });
	    }, _this.deleteRecordById = function () {
	      (0, _requests.DELETE_RECORD_BY_ID)(_this.state.deletingId, _this.props.match.params.category, function (response) {
	        _this.getRecords(_this.props.match.params.category);
	      }, function (error) {
	        if (error.displayInWizard) {
	          _this.props.setErrorToast(error.message);
	        }
	        _this.getRecords(_this.props.match.params.category);
	      });
	    }, _this.closeDeleteDialog = function () {
	      _this.setState({ deleteDialogOpen: false, deletingId: null });
	    }, _this.deleteRecord = function (row) {
	      (0, _requests.DELETE_RECORD_BY_ID)(row.ID, _this.props.match.params.category, function (response) {
	        _this.getRecords(_this.props.match.params.category);
	      }, function (error) {
	        if (error.displayInWizard) {
	          _this.props.setErrorToast(error.message);
	        }
	        _this.getRecords(_this.props.match.params.category);
	      });
	    }, _this.downloadForm = function (row) {
	      window.location.assign(_requests.BASE_URL + '/api/Report/FromReactPDF/' + row.FORM_DEFINITION_ID + '/' + row.AMENDMENT_NUM);
	    }, _this.correct = function (row) {
	      _this.props.history.push('/correct/' + row.FORM_DEFINITION_ID + '/' + row.AMENDMENT_NUM);
	    }, _this.viewReadOnlyForm = function (row) {
	      _this.props.history.push('/view/' + row.FORM_DEFINITION_ID + '/' + row.AMENDMENT_NUM);
	    }, _this.downloadCorrectionLetter = function (row) {
	      var correspondenceSourceId = 637;
	      window.location.assign(_requests.BASE_URL + '/api/Report/FromDatabase/' + row.IMAGE_DATA.CORRESPONDENCE_ID + '/' + correspondenceSourceId);
	    }, _this.manageSignatures = function (row) {
	      _this.props.history.push('/signatures/' + row.GROUP_TOKEN);
	    }, _this.amend = function (row) {
	      _this.props.history.push('/amend/' + row.FORM_DEFINITION_ID + '/' + row.AMENDMENT_NUM);
	    }, _this.getReceiptItems = function (amendmentNum) {
	      return new Promise(function (resolve, reject) {
	        (0, _requests.GET_RECEIPT_ITEMS_BY_ADMENDMENT_NUM)(amendmentNum, _this.props.match.params.category, false, function (receiptItems) {
	          resolve(receiptItems);
	        }, function (error) {
	          reject(error);
	          _this.props.setErrorToast(error.message);
	        });
	      });
	    }, _this.startCheckout = function (_ref2) {
	      var AMENDMENT_NUM = _ref2.AMENDMENT_NUM,
	          FORM_DEFINITION_ID = _ref2.FORM_DEFINITION_ID;
	
	      _this.disablePaymentButtons(AMENDMENT_NUM);
	      _this.getReceiptItems(AMENDMENT_NUM).then(function (_ref3) {
	        var RECEIPT_ITEM_WEB_LIST = _ref3.RECEIPT_ITEM_WEB_LIST,
	            RECEIPT_ITEM_CONTAINER_WEB_LIST = _ref3.RECEIPT_ITEM_CONTAINER_WEB_LIST,
	            REF_NUM = _ref3.REF_NUM;
	
	        var total = RECEIPT_ITEM_CONTAINER_WEB_LIST ? (0, _utilities.calculateReceiptItemContainersTotal)(RECEIPT_ITEM_CONTAINER_WEB_LIST) : (0, _utilities.calculateReceiptItemsTotal)(RECEIPT_ITEM_WEB_LIST);
	
	        _this.setState({
	          checkoutOpen: total > 0 ? true : false,
	          checkoutDetails: {
	            amendmentNum: AMENDMENT_NUM,
	            formDefinitionId: FORM_DEFINITION_ID,
	            receiptItems: RECEIPT_ITEM_WEB_LIST,
	            receiptItemContainers: RECEIPT_ITEM_CONTAINER_WEB_LIST,
	            refNum: REF_NUM
	          }
	        }, function () {
	          if (SHOPPING_CART) {
	            _this.props.setCartQuantity(RECEIPT_ITEM_CONTAINER_WEB_LIST.filter(function (x) {
	              return !x.IS_FREE;
	            }).length);
	            _this.getRecords(_this.props.match.params.category);
	          }
	          if (total <= 0) {
	            _this.openReceipt();
	          }
	        });
	      }).catch(function (error) {
	        _this.enablePaymentButtons();
	        _this.getRecords(_this.props.match.params.category);
	      });
	    }, _this.closeCheckout = function () {
	      _this.setState({ checkoutOpen: false });
	      _this.enablePaymentButtons();
	    }, _this.cancelCheckout = function () {
	      _this.slider.closeSlider(function () {
	        _this.closeCheckout();
	      });
	    }, _this.disablePaymentButtons = function (paymentDisabledId) {
	      _this.setState({ paymentDisabled: true, paymentDisabledId: paymentDisabledId });
	    }, _this.enablePaymentButtons = function () {
	      _this.setState({ paymentDisabled: false, paymentDisabledId: null });
	    }, _this.openReceipt = function (refNum) {
	      // this.disablePaymentButtons()
	      // this.getRecords(this.props.match.params.category, () => {
	      //   this.enablePaymentButtons()
	      // })
	      if (_this.slider) {
	        _this.slider.closeSlider(function () {
	          // this.setState({checkoutOpen: false})
	          _this.props.history.push('/receipt?ref=' + (refNum || _this.state.checkoutDetails.refNum));
	        });
	      } else {
	        _this.props.history.push('/receipt?ref=' + (refNum || _this.state.checkoutDetails.refNum));
	      }
	    }, _this.selectItem = function (row) {
	      _this.props.selectWorkQueueItem(_this.props.match.params.category, row.ID);
	    }, _this.setFilters = function (filters) {
	      var props = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	      _this.props.setFilters(_this.props.match.params.category, filters);
	      if (props.getRecords !== false) {
	        _this.getRecords(_this.props.match.params.category);
	      }
	    }, _this.onSidebarDismiss = function () {
	      _this.props.selectWorkQueueItem(_this.props.match.params.category, null);
	    }, _this.highlightByIndex = function (index) {
	      _this.table.highlightRowByIndex(index);
	    }, _this.viewAction = {
	      iconClass: '',
	      label: 'View Filing',
	      className: 'primary',
	      onClick: _this.viewReadOnlyForm,
	      children: _react2.default.createElement(_document2.default, null)
	    }, _this.deleteAction = {
	      iconClass: '',
	      label: 'Delete',
	      className: 'primary',
	      onClick: WQ_CONFIRM_ON_DELETE ? _this.confirmDelete : _this.deleteRecord,
	      children: _react2.default.createElement(_trash2.default, null)
	    }, _this.correctAction = {
	      iconClass: '',
	      label: 'Make a Correction',
	      className: 'primary',
	      onClick: _this.correct,
	      children: _react2.default.createElement(_pencil2.default, null)
	    }, _this.viewDownloadsAction = {
	      iconClass: '',
	      label: 'View Downloads',
	      className: function className(row) {
	        return row.TYPE == 'Needs_Correction' && ALLOW_CORRECTION_STYLING ? 'primary danger' : 'primary';
	      },
	      onClick: _this.selectItem,
	      children: _react2.default.createElement(_downloadBox2.default, null),
	      getIsVisible: function getIsVisible(row) {
	        return row.HAS_DOWNLOADS_AVAILABLE !== false;
	      }
	    }, _this.manageSignaturesAction = {
	      iconClass: '',
	      label: function label(row) {
	        return row.TYPE === 'Pending_Review' ? 'Review Signatures' : 'Manage Signatures';
	      },
	      className: 'primary',
	      onClick: _this.manageSignatures,
	      children: _react2.default.createElement(_signature2.default, null),
	      getIsVisible: function getIsVisible(row) {
	        return !!row.GROUP_TOKEN;
	      }
	    }, _this.getLowercaseSublinkLabel = function (sublink) {
	      return sublink.preserveCasing ? sublink.label || '' : (sublink.label || '').toLowerCase();
	    }, _this.getMergedEmptyStateText = function (text, sublink) {
	      return text.replace(/{{CATEGORY}}/g, _this.getLowercaseSublinkLabel(sublink));
	    }, _this.refreshCart = function () {
	      (0, _requests.GET_WEB_USER_ACTIVE_CART)(function (cart) {
	        _this.setState({
	          receiptItemContainers: cart.RECEIPT_ITEM_CONTAINER_WEB_LIST,
	          receiptItems: cart.RECEIPT_ITEM_WEB_LIST,
	          refNum: _this.cart.REF_NUM
	        });
	      });
	      _this.getRecords();
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	  // closeReceipt = () => {
	  //   const highlightId = this.state.highlightId;
	  //   this.setState(state => ({receiptOpen: false, highlightId: null}))
	  //   const rowIndex = this.props.orderedItems.rows.findIndex(row => row.RECORD_NUM === highlightId)
	  //   if(rowIndex >= 0){
	  //     this.highlightByIndex(rowIndex)
	  //   }
	  // }
	
	
	  _createClass(MyWorkQueue, [{
	    key: 'renderEmptyResults',
	    value: function renderEmptyResults(props, sublink) {
	      var _this2 = this;
	
	      var renderEmpty = !MY_WORK_QUEUE_DISABLE_EMPTY_STATE && !props.loading && props.orderedItems && props.orderedItems.rows && !props.orderedItems.rows.length;
	
	      if (renderEmpty) {
	        var line1 = 'Looks like you don\'t have any ' + this.getLowercaseSublinkLabel(sublink) + ' records in progress';
	        var line2 = 'Visit ' + this.getLowercaseSublinkLabel(sublink) + ' forms to create your first record';
	        if (MY_WORK_QUEUE_EMPTY_STATE_LINE_1) {
	          line1 = this.getMergedEmptyStateText(MY_WORK_QUEUE_EMPTY_STATE_LINE_1, sublink);
	        }
	        if (MY_WORK_QUEUE_EMPTY_STATE_LINE_2) {
	          line2 = this.getMergedEmptyStateText(MY_WORK_QUEUE_EMPTY_STATE_LINE_2, sublink);
	        }
	        return _react2.default.createElement(
	          'div',
	          { className: 'empty-placeholder-wrapper' },
	          _react2.default.createElement(_EmptyBox2.default, null),
	          _react2.default.createElement(
	            'h2',
	            null,
	            line1
	          ),
	          _react2.default.createElement(
	            'p',
	            null,
	            line2
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'flex-row center' },
	            _react2.default.createElement(
	              _reactRouterDom.Link,
	              {
	                className: 'btn btn-primary btn-raised',
	                to: '/forms/' + sublink.parameter,
	                innerRef: function innerRef(r) {
	                  return _this2.emptyLink = r;
	                }
	              },
	              'Go to ',
	              this.getLowercaseSublinkLabel(sublink),
	              ' forms'
	            )
	          )
	        );
	      } else {
	        return null;
	      }
	    }
	  }, {
	    key: 'renderPageData',
	    value: function renderPageData(props) {
	      var _this3 = this;
	
	      if (props.error) {
	        return _react2.default.createElement(_PageError.PageError, { errorDetails: props.errorDetails });
	      } else if (!props.orderedItems) {
	        return _react2.default.createElement(_Loaders.Spinner, { className: 'page-loader' });
	      } else {
	        var actionMap = {
	          default: [{
	            iconClass: '',
	            label: 'View Filing',
	            className: 'primary',
	            onClick: this.viewReadOnlyForm,
	            children: _react2.default.createElement(_document2.default, null)
	          }, this.viewDownloadsAction],
	          Needs_Correction: [this.correctAction, this.viewDownloadsAction],
	          Rejected: [{
	            iconClass: '',
	            label: 'View Filing',
	            className: 'primary',
	            onClick: this.viewReadOnlyForm,
	            children: _react2.default.createElement(_document2.default, null)
	          }, this.viewDownloadsAction],
	          Draft: [{
	            iconClass: '',
	            label: 'Resume Editing',
	            className: 'primary',
	            onClick: this.editDraft,
	            children: _react2.default.createElement(_pencil2.default, null)
	          }, {
	            iconClass: '',
	            label: 'Delete',
	            className: 'primary',
	            onClick: this.deleteDraft,
	            children: _react2.default.createElement(_trash2.default, null)
	          }, this.viewDownloadsAction],
	          Pending_Review: [this.viewAction, this.manageSignaturesAction, this.viewDownloadsAction],
	          Approved: [this.viewAction, this.viewDownloadsAction],
	          Pending_Print_and_Mail: [this.viewAction].concat(_toConsumableArray(WQ_ALLOW_DELETE_PRINT_MAIL ? [this.deleteAction] : []), [this.viewDownloadsAction]),
	          Pending_Signature: [this.viewAction, this.manageSignaturesAction],
	          Pending_Online_Payment: function Pending_Online_Payment(row) {
	            return [{
	              iconClass: '',
	              label: SHOPPING_CART ? 'Add to Cart' : 'Make Payment',
	              className: 'primary',
	              onClick: _this3.startCheckout,
	              disabled: _this3.state.paymentDisabled,
	              children: _this3.state.paymentDisabled && _this3.state.paymentDisabledId === row.AMENDMENT_NUM ? !_this3.state.checkoutOpen ? _react2.default.createElement(
	                'div',
	                { className: 'spinner-wrapper' },
	                _react2.default.createElement(_Loaders.Spinner, { size: 'small', themeColor: 'dark-neutral' })
	              ) : _react2.default.createElement(_cart2.default, null) : _react2.default.createElement(_cart2.default, null)
	            }, _this3.viewAction, _this3.manageSignaturesAction, _this3.viewDownloadsAction, _this3.deleteAction].concat(_toConsumableArray(WQ_ALLOW_EDIT_PENDING_PAYMENT || _App.SUBROUTES_OBJ[_this3.props.match.params.category].wqAllowEditPendingPayment ? [_this3.correctAction] : []));
	          },
	          Static: []
	        };
	        return _react2.default.createElement(
	          'div',
	          { className: 'table-wrapper' },
	          _react2.default.createElement(_Table2.default, {
	            label: 'My Work Queue',
	            className: 'center-container',
	            template: props.orderedItems.template,
	            rows: props.orderedItems.rows,
	            actionCell: true,
	            onCellClick: this.selectItem,
	            actionMap: actionMap,
	            selectedRowIndex: props.selectedId ? props.orderedItems.rows.findIndex(function (row) {
	              return row.ID === props.selectedId;
	            }) : false,
	            animated: false,
	            ref: function ref(_ref4) {
	              _this3.table = _ref4;
	            },
	            rowCount: true
	          })
	        );
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this4 = this;
	
	      var _props = this.props,
	          selectedId = _props.selectedId,
	          _props$items = _props.items,
	          items = _props$items === undefined ? {} : _props$items,
	          activeCategory = _props.activeCategory,
	          location = _props.location,
	          sublinks = _props.sublinks,
	          match = _props.match,
	          serverDescription = _props.serverDescription,
	          _props$filters = _props.filters,
	          filters = _props$filters === undefined ? {} : _props$filters,
	          loading = _props.loading;
	
	      var category = match.params.category;
	      var selectedItem = items[selectedId] || {};
	      var selectedTitle = selectedItem.TITLE ? selectedItem.TITLE[0] : '';
	      var selectedSubtitle = selectedItem.TITLE ? selectedItem.TITLE[1] : '';
	      var sublink = sublinks.find(function (l) {
	        return l.parameter === category;
	      }) || {};
	      var activeFilters = filters[category] || {};
	      return _react2.default.createElement(
	        _Shell.Body,
	        {
	          className: 'work-queue',
	          showDrawer: selectedId,
	          hiddenTitle: 'My Work Queue'
	        },
	        !match.params.category && _react2.default.createElement(_reactRouterDom.Redirect, {
	          to: location.pathname + '/' + (activeCategory ? activeCategory : sublinks[0].parameter)
	        }),
	        _react2.default.createElement(_TableControls2.default, {
	          title: 'My ' + sublink.label + ' Work Queue',
	          description: serverDescription || sublink.myWorkQueueDescription || MY_WORK_QUEUE_DESCRIPTION || '',
	          filterTemplates: sublink.myWorkQueueFilters,
	          filters: activeFilters,
	          onFilterChange: this.setFilters,
	          allowSearch: sublink.myWorkQueueSearch !== false,
	          searchPlaceholder: MY_WORK_QUEUE_SEARCH_PLACEHOLDER || 'Search My Work Queue',
	          loading: loading
	        }),
	        this.renderPageData(this.props),
	        this.renderEmptyResults(this.props, sublink),
	        _react2.default.createElement(
	          _Shell.Drawer,
	          {
	            showCloseButton: true,
	            show: selectedId ? true : false,
	            title: selectedTitle,
	            subtitle: selectedSubtitle,
	            onSidebarDismiss: this.onSidebarDismiss
	          },
	          selectedItem.DRAWER_MESSAGE ? _react2.default.createElement(
	            'p',
	            { className: 'drawer-message' },
	            selectedItem.DRAWER_MESSAGE
	          ) : null,
	          _react2.default.createElement(_ReportsList2.default, {
	            formDefinitionId: selectedItem.FORM_DEFINITION_ID,
	            amendmentNum: selectedItem.AMENDMENT_NUM,
	            id: selectedItem.RECORD_NUM
	          })
	        ),
	        _react2.default.createElement(
	          _Portal2.default,
	          { isOpened: this.state.checkoutOpen },
	          _react2.default.createElement(
	            _SlidingPanel2.default,
	            {
	              closeOnShadeClick: false,
	              closeSlider: this.closeCheckout,
	              ref: function ref(_ref5) {
	                _this4.slider = _ref5;
	              }
	            },
	            _react2.default.createElement(_Checkout2.default, {
	              cancelCheckout: this.cancelCheckout,
	              closeModal: this.closeCheckout,
	              redirectToReceipt: this.openReceipt,
	              amendmentNum: this.state.checkoutOpen && this.state.checkoutDetails.amendmentNum,
	              refNum: this.state.checkoutOpen && this.state.checkoutDetails.refNum,
	              formDefinitionId: this.state.checkoutOpen && this.state.checkoutDetails.formDefinitionId,
	              category: this.props.match.params.category,
	              receiptItems: this.state.checkoutOpen && this.state.checkoutDetails.receiptItems,
	              receiptItemContainers: this.state.checkoutOpen && this.state.checkoutDetails.receiptItemContainers,
	              onReceiptItemContainerRemoved: function onReceiptItemContainerRemoved() {
	                return _this4.getRecords(category);
	              },
	              onCartRefresh: this.refreshCart
	            })
	          )
	        ),
	        _react2.default.createElement(
	          _Portal2.default,
	          { isOpened: this.state.deleteDialogOpen },
	          _react2.default.createElement(_Modal.ConfirmDialog, {
	            closeModal: this.closeDeleteDialog,
	            message: WQ_DELETE_CONFIRM_MESSAGE ? WQ_DELETE_CONFIRM_MESSAGE : 'Are you sure you want to delete this filing?',
	            buttons: [{ label: 'No', onClick: _utilities.noop, className: 'btn-default' }, { label: 'Yes', onClick: this.deleteRecordById, className: 'btn-danger' }],
	            modalStyle: { borderRadius: 3 }
	          })
	        )
	      );
	    }
	  }]);
	
	  return MyWorkQueue;
	}(_react.Component);
	
	exports.default = (0, _reactRedux.connect)(function (state, props) {
	  return {
	    items: props.match.params.category && state.queue.items ? state.queue.items[props.match.params.category] : {},
	    orderedItems: state.queue.items ? (0, _utilities.getOrderedResultsByCategory)(props.match.params.category, state.queue.items, state.queue.templates) : {},
	    selectedId: props.match.params.category ? state.queue.selected[props.match.params.category] : null,
	    activeCategory: state.queue.activeCategory || state.app.currentCategory,
	    filters: state.queue.filters,
	    loading: state.queue.loading,
	    error: state.queue.error,
	    errorDetails: state.queue.errorDetails,
	    serverDescription: props.match.params.category && state.queue.descriptions[props.match.params.category] || ''
	  };
	}, { fetchAndSetWorkQueueItems: _MyWorkQueueActions.fetchAndSetWorkQueueItems, selectWorkQueueItem: _MyWorkQueueActions.selectWorkQueueItem, setActiveCategory: _MyWorkQueueActions.setActiveCategory, setFilters: _MyWorkQueueActions.setFilters, setCartQuantity: _actions.setCartQuantity, setErrorToast: _actions.setErrorToast, getWorkQueueDescription: _MyWorkQueueActions.getWorkQueueDescription })(MyWorkQueue);

/***/ },
/* 1122 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.initialState = undefined;
	
	var _FilterUtilities = __webpack_require__(289);
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var initialState = exports.initialState = {
	  activeCategory: null,
	  descriptions: {},
	  error: false,
	  errorDetails: {
	    code: null,
	    message: null
	  },
	  filters: (0, _FilterUtilities.getFiltersByLocalStorageKey)('MY_WORK_QUEUE_FILTERS'),
	  items: null,
	  lastRequestId: null,
	  loading: false,
	  resultsMode: 'table',
	  selected: {},
	  selectedDetails: null,
	  selectedIndex: null,
	  templates: {}
	};
	
	var MyWorkQueueReducer = function MyWorkQueueReducer() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	  var action = arguments[1];
	
	  switch (action.type) {
	    case 'RESET_WORK_QUEUE_STATE':
	      return initialState;
	    case 'SET_WORK_QUEUE_ITEMS':
	      return Object.assign({}, state, {
	        items: Object.assign({}, state.items, _defineProperty({}, action.category, action.items)),
	        templates: Object.assign({}, state.templates, _defineProperty({}, action.category, action.template))
	      });
	    case 'SET_WORK_QUEUE_ERROR':
	      return Object.assign({}, state, {
	        error: action.error
	      });
	    case 'SET_WORK_QUEUE_ERROR_DETAILS':
	      return Object.assign({}, state, {
	        errorDetails: action.errorDetails
	      });
	    case 'SELECT_WORK_QUEUE_ITEM':
	      return Object.assign({}, state, {
	        selected: _defineProperty({}, action.category, state.selected[action.category] !== action.selected ? action.selected : null)
	      });
	    case '@@wq/SET_ACTIVE_CATEGORY':
	      return Object.assign({}, state, { activeCategory: action.category });
	    case '@@wq/SET_FILTERS':
	      return Object.assign({}, state, {
	        filters: Object.assign({}, state.filters, _defineProperty({}, action.category, action.filters))
	      });
	    case '@@wq/SET_REQUEST_ID':
	      return Object.assign({}, state, { lastRequestId: action.requestId });
	    case '@@wq/SET_LOADING':
	      return Object.assign({}, state, {
	        loading: action.loading
	      });
	    case '@@wq/INVALIDATE_CACHE':
	      return Object.assign({}, state, {
	        selected: {},
	        selectedDetails: null,
	        selectedIndex: null
	      });
	    case '@@WORK_QUEUE_SET_DESCRIPTION':
	      return Object.assign({}, state, { descriptions: Object.assign({}, state.descriptions, _defineProperty({}, action.category, action.description)) });
	    default:
	      return state;
	  }
	};
	
	exports.default = MyWorkQueueReducer;

/***/ },
/* 1123 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _caretLeft = __webpack_require__(222);
	
	var _caretLeft2 = _interopRequireDefault(_caretLeft);
	
	var _caretRight = __webpack_require__(554);
	
	var _caretRight2 = _interopRequireDefault(_caretRight);
	
	var _propTypes = __webpack_require__(20);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	__webpack_require__(1458);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Pager = function Pager(_ref) {
	  var _ref$numPages = _ref.numPages,
	      numPages = _ref$numPages === undefined ? 0 : _ref$numPages,
	      activePage = _ref.activePage,
	      onPrevClicked = _ref.onPrevClicked,
	      onNextClicked = _ref.onNextClicked,
	      onPageClicked = _ref.onPageClicked;
	
	  return _react2.default.createElement(
	    'div',
	    { className: 'pager' },
	    activePage === 1 ? null : _react2.default.createElement(
	      'button',
	      { onClick: function onClick(e) {
	          return onPrevClicked(e);
	        }, 'aria-label': 'Previous Page' },
	      _react2.default.createElement(_caretLeft2.default, null)
	    ),
	    new Array(numPages).fill(null).map(function (_, i) {
	      return _react2.default.createElement(
	        'button',
	        {
	          onClick: function onClick(e) {
	            return onPageClicked(e, i + 1);
	          },
	          className: '' + (activePage === i + 1 ? 'active' : ''),
	          key: i
	        },
	        i + 1
	      );
	    }),
	    activePage === numPages ? null : _react2.default.createElement(
	      'button',
	      { onClick: function onClick(e) {
	          return onNextClicked(e);
	        }, 'aria-label': 'Next Page' },
	      _react2.default.createElement(_caretRight2.default, null)
	    )
	  );
	};
	Pager.propTypes = {
	  numPages: _propTypes2.default.number.isRequired,
	  activePage: _propTypes2.default.number,
	  onPrevClicked: _propTypes2.default.func.isRequired,
	  onNextClicked: _propTypes2.default.func.isRequired,
	  onPageClicked: _propTypes2.default.func.isRequired
	};
	
	exports.default = Pager;

/***/ },
/* 1124 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	// import TrashIcon from '@tecuity/sos-icons/react/trash'
	
	// import { Spinner } from '../Loaders/Loaders'
	
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Portal = __webpack_require__(12);
	
	var _Portal2 = _interopRequireDefault(_Portal);
	
	var _Modal = __webpack_require__(13);
	
	var _propTypes = __webpack_require__(20);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _bankSolid = __webpack_require__(220);
	
	var _bankSolid2 = _interopRequireDefault(_bankSolid);
	
	var _creditCardSolid = __webpack_require__(158);
	
	var _creditCardSolid2 = _interopRequireDefault(_creditCardSolid);
	
	var _requests = __webpack_require__(6);
	
	var _useItransact = __webpack_require__(467);
	
	var _useItransact2 = _interopRequireDefault(_useItransact);
	
	var _plusHeavy = __webpack_require__(128);
	
	var _plusHeavy2 = _interopRequireDefault(_plusHeavy);
	
	var _trash = __webpack_require__(60);
	
	var _trash2 = _interopRequireDefault(_trash);
	
	var _hooks = __webpack_require__(144);
	
	__webpack_require__(1459);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	var PayrocGenericModal = function PayrocGenericModal(_ref) {
	  var _ref$title = _ref.title,
	      title = _ref$title === undefined ? 'Payment' : _ref$title,
	      _ref$instructions = _ref.instructions,
	      instructions = _ref$instructions === undefined ? '' : _ref$instructions,
	      _ref$isOpen = _ref.isOpen,
	      isOpen = _ref$isOpen === undefined ? false : _ref$isOpen,
	      onRequestClose = _ref.onRequestClose,
	      onPaymentSelected = _ref.onPaymentSelected;
	
	  var _React$useState = _react2.default.useState(false),
	      _React$useState2 = _slicedToArray(_React$useState, 2),
	      modalIsOpen = _React$useState2[0],
	      setModalIsOpen = _React$useState2[1];
	
	  var _React$useState3 = _react2.default.useState(null),
	      _React$useState4 = _slicedToArray(_React$useState3, 2),
	      customer = _React$useState4[0],
	      setCustomer = _React$useState4[1];
	
	  var _React$useState5 = _react2.default.useState(null),
	      _React$useState6 = _slicedToArray(_React$useState5, 2),
	      deletingId = _React$useState6[0],
	      setDeletingId = _React$useState6[1];
	
	  var _React$useState7 = _react2.default.useState(false),
	      _React$useState8 = _slicedToArray(_React$useState7, 2),
	      addingPaymentMethod = _React$useState8[0],
	      setAddingPaymentMethod = _React$useState8[1];
	
	  var iTransactIsLoaded = (0, _useItransact2.default)();
	  var apiUsername = (0, _hooks.useAppSetting)('PAYROC_API_USERNAME');
	  var achEnabled = (0, _hooks.useAppSetting)('PAYROC_ACH_ENABLED_YN');
	  var modal = _react2.default.useRef();
	
	  _react2.default.useEffect(function () {
	    if (isOpen === true) {
	      setModalIsOpen(true);
	    } else if (modalIsOpen) {
	      modal.current.closeModal(function () {
	        setModalIsOpen(false);
	      });
	    }
	  }, [isOpen]);
	
	  var getCustomer = function getCustomer() {
	    (0, _requests.GET_PAYROC_CUSTOMER)(function (customer) {
	      if (customer) setCustomer(customer);
	    }, console.error);
	  };
	
	  _react2.default.useEffect(function () {
	    getCustomer();
	  }, []);
	
	  var openItransact = function openItransact() {
	    var handler = window.iTransact.Checkout.init({
	      apiUsername: apiUsername.setting.VALUE,
	      name: 'Add new payment method',
	      description: '',
	      panelButtonText: 'Add method',
	      billingAddress: true,
	      ach: achEnabled.setting.VALUE,
	      onToken: function onToken(_ref2, args) {
	        var token = _ref2.token;
	
	        setAddingPaymentMethod(true);
	        (0, _requests.CREATE_PAYROC_CUSTOMER_PAYMENT_SOURCE)({
	          token: token,
	          address: args
	        }, function (success) {
	          if (success) {
	            getCustomer();
	          }
	          onPaymentSelected(token);
	          setAddingPaymentMethod(false);
	        }, function (err) {
	          console.error(err);
	          setAddingPaymentMethod(false);
	        });
	      }
	    });
	    handler.render({
	      amount: 0
	    });
	  };
	
	  var startPaymentDelete = function startPaymentDelete(paySourceNum) {
	    setDeletingId(paySourceNum);
	  };
	
	  var deletePaymentMethod = function deletePaymentMethod(paySourceNum) {
	    var cachedMethods = null;
	    setCustomer(function (customer) {
	      cachedMethods = [].concat(_toConsumableArray(customer.payment_sources.map(function (x) {
	        return Object.assign({}, x);
	      })));
	      var toDeleteIndex = customer.payment_sources.findIndex(function (x) {
	        return x.id === paySourceNum;
	      });
	      return Object.assign({}, customer, {
	        payment_sources: [].concat(_toConsumableArray(customer.payment_sources.slice(0, toDeleteIndex)), _toConsumableArray(customer.payment_sources.slice(toDeleteIndex + 1)))
	      });
	    });
	    (0, _requests.DELETE_PAYROC_CUSTOMER_PAYMENT_SOURCE)(deletingId, function () {}, function (err) {
	      console.error(err);
	      setCustomer(function (customer) {
	        return Object.assign({}, customer, {
	          payment_sources: cachedMethods
	        });
	      });
	    });
	  };
	
	  return _react2.default.createElement(
	    _react2.default.Fragment,
	    null,
	    _react2.default.createElement(
	      _Portal2.default,
	      { isOpened: modalIsOpen },
	      _react2.default.createElement(
	        _Modal.Modal,
	        {
	          title: title,
	          closeModal: function closeModal() {
	            setModalIsOpen(false);
	            if (onRequestClose) onRequestClose();
	          },
	          modalSize: 'small',
	          closeButton: true,
	          autoHeight: true,
	          ref: modal
	        },
	        customer && iTransactIsLoaded && !apiUsername.loading && !achEnabled.loading && _react2.default.createElement(
	          'div',
	          { className: 'itransact-checkout generic-itransact' },
	          instructions ? _react2.default.createElement(
	            'p',
	            { className: 'instructions' },
	            instructions
	          ) : null,
	          customer.payment_sources.map(function (source) {
	            return _react2.default.createElement(
	              'div',
	              { className: 'payment-source', key: source.id },
	              _react2.default.createElement(
	                'button',
	                {
	                  className: 'btn btn-neutral select-button',
	                  onClick: function onClick() {
	                    return onPaymentSelected(source.id);
	                  }
	                },
	                'Select'
	              ),
	              source.type === 'ach' ? _react2.default.createElement(
	                'span',
	                { className: 'label-wrapper' },
	                _react2.default.createElement(_bankSolid2.default, null),
	                (source.savings_account === 'true' ? 'Savings' : 'Checking') + ' ****' + source.last_four_digits,
	                _react2.default.createElement(
	                  'button',
	                  {
	                    className: 'btn btn-solid btn-neutral delete-method-button',
	                    type: 'button',
	                    onClick: function onClick() {
	                      return startPaymentDelete(source.id);
	                    }
	                  },
	                  _react2.default.createElement(_trash2.default, null)
	                )
	              ) : _react2.default.createElement(
	                'span',
	                { className: 'label-wrapper' },
	                _react2.default.createElement(_creditCardSolid2.default, null),
	                source.brand.charAt(0).toUpperCase() + source.brand.slice(1) + ' ****' + source.last_four_digits,
	                _react2.default.createElement(
	                  'button',
	                  {
	                    className: 'btn btn-solid btn-neutral delete-method-button',
	                    type: 'button',
	                    onClick: function onClick() {
	                      return startPaymentDelete(source.id);
	                    }
	                  },
	                  _react2.default.createElement(_trash2.default, null)
	                )
	              )
	            );
	          }),
	          _react2.default.createElement(
	            'button',
	            {
	              type: 'button',
	              className: 'btn btn-solid btn-neutral add-button',
	              onClick: openItransact,
	              disabled: addingPaymentMethod
	            },
	            _react2.default.createElement(
	              'div',
	              { className: 'flex-center' },
	              _react2.default.createElement(
	                _react2.default.Fragment,
	                null,
	                _react2.default.createElement(_plusHeavy2.default, null),
	                ' ',
	                addingPaymentMethod ? 'Adding Payment Method' : 'Add New Payment Method'
	              )
	            )
	          )
	        )
	      )
	    ),
	    _react2.default.createElement(
	      _Portal2.default,
	      { isOpened: !!deletingId },
	      _react2.default.createElement(_Modal.ConfirmDialog, {
	        closeModal: function closeModal() {
	          return setDeletingId(null);
	        },
	        onModalClosed: function onModalClosed() {},
	        message: 'Are you sure you want to delete this payment method? Any active subscriptions using this payment method will be canceled. This cannot be undone.',
	        buttons: [{ label: 'No', onClick: function onClick() {}, className: 'btn-default' }, {
	          label: 'Yes',
	          onClick: function onClick() {
	            return deletePaymentMethod(deletingId);
	          },
	          className: 'btn-danger'
	        }],
	        modalStyle: { borderRadius: 3 }
	      })
	    )
	  );
	};
	PayrocGenericModal.propTypes = {
	  title: _propTypes2.default.string,
	  instructions: _propTypes2.default.string,
	  isOpen: _propTypes2.default.bool.isRequired,
	  onRequestClose: _propTypes2.default.func,
	  onPaymentSelected: _propTypes2.default.func.isRequired
	};
	
	exports.default = PayrocGenericModal;

/***/ },
/* 1125 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _PrintTable = __webpack_require__(1126);
	
	var _PrintTable2 = _interopRequireDefault(_PrintTable);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var PrintResults = function PrintResults(_ref) {
	  var history = _ref.history;
	
	  var _React$useState = _react2.default.useState(null),
	      _React$useState2 = _slicedToArray(_React$useState, 2),
	      results = _React$useState2[0],
	      setResults = _React$useState2[1];
	
	  _react2.default.useEffect(function () {
	    window.setPrintResults = setResults;
	    if (window.opener.onPrintPageReady) {
	      window.opener.onPrintPageReady();
	    } else {
	      history.replace('/');
	    }
	    return function () {
	      delete window.setPrintResults;
	    };
	  }, []);
	
	  console.log('Results', results);
	  return _react2.default.createElement(
	    'div',
	    null,
	    results ? _react2.default.createElement(_PrintTable2.default, {
	      template: results.template,
	      rows: results.rows
	    }) : null
	  );
	};
	
	exports.default = PrintResults;

/***/ },
/* 1126 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _orderBy = __webpack_require__(103);
	
	var _orderBy2 = _interopRequireDefault(_orderBy);
	
	__webpack_require__(1460);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var PrintTable = function PrintTable(_ref) {
	  var template = _ref.template,
	      rows = _ref.rows;
	
	  _react2.default.useEffect(function () {
	    window.print();
	  }, []);
	
	  var sortedRows = (0, _orderBy2.default)(Object.entries(rows).map(function (_ref2) {
	    var _ref3 = _slicedToArray(_ref2, 2),
	        key = _ref3[0],
	        value = _ref3[1];
	
	    return Object.assign({}, value, { id: key });
	  }), ['SORT_INDEX']);
	
	  return _react2.default.createElement(
	    'div',
	    { className: 'print-table' },
	    _react2.default.createElement(
	      'table',
	      null,
	      _react2.default.createElement(
	        'thead',
	        null,
	        _react2.default.createElement(
	          'tr',
	          null,
	          template.map(function (t) {
	            return _react2.default.createElement(
	              'th',
	              { key: t.id },
	              t.label
	            );
	          })
	        )
	      ),
	      _react2.default.createElement(
	        'tbody',
	        null,
	        sortedRows.map(function (row) {
	          return _react2.default.createElement(
	            'tr',
	            { key: row.id },
	            template.map(function (t) {
	              return _react2.default.createElement(
	                'td',
	                { key: t.id },
	                row[t.id]
	              );
	            })
	          );
	        })
	      )
	    )
	  );
	};
	
	exports.default = PrintTable;

/***/ },
/* 1127 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.ConnectedRecordHistory = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Portal = __webpack_require__(12);
	
	var _Portal2 = _interopRequireDefault(_Portal);
	
	var _Modal = __webpack_require__(13);
	
	var _caretDown = __webpack_require__(38);
	
	var _caretDown2 = _interopRequireDefault(_caretDown);
	
	var _caretUp = __webpack_require__(80);
	
	var _caretUp2 = _interopRequireDefault(_caretUp);
	
	var _downloadBox = __webpack_require__(127);
	
	var _downloadBox2 = _interopRequireDefault(_downloadBox);
	
	var _requests = __webpack_require__(6);
	
	__webpack_require__(1461);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var isIE11 = !!window.MSInputMethodContext && !!document.documentMode;
	
	var ConnectedRecordHistory = exports.ConnectedRecordHistory = function (_React$Component) {
	  _inherits(ConnectedRecordHistory, _React$Component);
	
	  function ConnectedRecordHistory() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, ConnectedRecordHistory);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = ConnectedRecordHistory.__proto__ || Object.getPrototypeOf(ConnectedRecordHistory)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      modalOpen: false,
	      history: null,
	      loading: false
	    }, _this.startModalOpen = function () {
	      if (_this.props.category && _this.props.amendmentNum) {
	        _this.fetchHistory();
	      }
	    }, _this.fetchHistory = function () {
	      _this.setState({ loading: true });
	      (0, _requests.GET_RECORD_HISTORY)(_this.props.category, _this.props.amendmentNum, function (history) {
	        // console.log(history)
	        _this.setState({
	          loading: false,
	          history: {
	            amendments: history.AMENDMENT_LIST,
	            history: history.HISTORY_LIST,
	            template: history.TEMPLATE
	          },
	          modalOpen: true
	        });
	      }, function (err) {
	        console.error(err);
	        _this.setState({ loading: false });
	      });
	    }, _this.openModal = function () {
	      _this.setState({
	        modalOpen: true
	      });
	    }, _this.closeModal = function () {
	      _this.setState({
	        modalOpen: false
	      });
	    }, _this.forceWindowRepaint = function () {
	      if (isIE11) {
	        _this.scrollable.style.overflow = "hidden";
	        window.setTimeout(function () {
	          _this.scrollable.style.overflow = "auto";
	        }, 100);
	      }
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(ConnectedRecordHistory, [{
	    key: "render",
	    value: function render() {
	      var _this2 = this;
	
	      var _props = this.props,
	          children = _props.children,
	          restProps = _objectWithoutProperties(_props, ["children"]);
	
	      return _react2.default.createElement(
	        _react.Fragment,
	        null,
	        children({ openModal: this.startModalOpen, loading: this.state.loading }),
	        _react2.default.createElement(
	          _Portal2.default,
	          { isOpened: this.state.modalOpen },
	          _react2.default.createElement(
	            _Modal.Modal,
	            {
	              modalSize: "fullscreen",
	              closeModal: this.closeModal,
	              title: "History",
	              closeButton: true,
	              modalBodyClassName: "history-modal"
	            },
	            _react2.default.createElement(
	              "div",
	              { className: "scrollable", ref: function ref(_ref2) {
	                  _this2.scrollable = _ref2;
	                } },
	              _react2.default.createElement(RecordHistory, Object.assign({ history: this.state.history, onDrawerUpdate: this.forceWindowRepaint }, restProps))
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return ConnectedRecordHistory;
	}(_react2.default.Component);
	
	var RecordHistory = function (_React$Component2) {
	  _inherits(RecordHistory, _React$Component2);
	
	  function RecordHistory(props) {
	    _classCallCheck(this, RecordHistory);
	
	    var _this3 = _possibleConstructorReturn(this, (RecordHistory.__proto__ || Object.getPrototypeOf(RecordHistory)).call(this, props));
	
	    _initialiseProps.call(_this3);
	
	    var amendments = _this3.memoizeHistoryStructure(props.history);
	    // console.log(props.history);
	    _this3.state = {
	      amendments: amendments,
	      allExpanded: props.history.history.length < 5 && props.history.amendments.length <= 4,
	      reset: false
	    };
	    return _this3;
	  }
	
	  _createClass(RecordHistory, [{
	    key: "render",
	    value: function render() {
	      var _this4 = this;
	
	      var amendments = this.state.amendments;
	      var _props2 = this.props,
	          template = _props2.history.template,
	          userOwnsRecord = _props2.userOwnsRecord;
	
	      return _react2.default.createElement(
	        "div",
	        { className: "record-history", style: this.state.reset ? { transform: 'translateY(1px)' } : undefined },
	        _react2.default.createElement(
	          "div",
	          { className: "toolbar" },
	          _react2.default.createElement(
	            "button",
	            {
	              className: "btn btn-raised btn-primary",
	              onClick: this.toggleDrawers
	            },
	            this.state.allExpanded ? "Collapse All" : "Expand All"
	          )
	        ),
	        amendments.map(function (amd, i) {
	          return _react2.default.createElement(CollapsibleAmendment, {
	            amendment: amd,
	            index: i,
	            template: template,
	            expanded: _this4.state.allExpanded,
	            userOwnsRecord: userOwnsRecord,
	            onDrawerUpdate: _this4.props.onDrawerUpdate,
	            key: amd.AMENDMENT_ID
	          });
	        })
	      );
	    }
	  }]);
	
	  return RecordHistory;
	}(_react2.default.Component);
	
	var _initialiseProps = function _initialiseProps() {
	  var _this5 = this;
	
	  this.componentWillReceiveProps = function (nextProps) {
	    if (_this5.props.history !== nextProps.history) {
	      var amendments = _this5.memoizeHistoryStructure(nextProps.history);
	      _this5.setState({
	        amendments: amendments,
	        allExpanded: nextProps.history.history.length < 5 && nextProps.history.amendments.length < 5
	      });
	    }
	  };
	
	  this.memoizeHistoryStructure = function (_ref3) {
	    var amendments = _ref3.amendments,
	        history = _ref3.history;
	
	    return amendments.map(function (amd) {
	      return Object.assign({}, amd, {
	        HISTORY: history.filter(function (h) {
	          return h.AMENDMENT_ID === amd.AMENDMENT_ID;
	        })
	      });
	    });
	  };
	
	  this.toggleDrawers = function () {
	    _this5.setState(function (state) {
	      return { allExpanded: !state.allExpanded };
	    }, function () {
	      if (isIE11) {
	        _this5.props.onDrawerUpdate();
	      }
	    });
	  };
	};
	
	exports.default = RecordHistory;
	
	var CollapsibleAmendment = function (_React$Component3) {
	  _inherits(CollapsibleAmendment, _React$Component3);
	
	  function CollapsibleAmendment(props) {
	    _classCallCheck(this, CollapsibleAmendment);
	
	    var _this6 = _possibleConstructorReturn(this, (CollapsibleAmendment.__proto__ || Object.getPrototypeOf(CollapsibleAmendment)).call(this, props));
	
	    _this6.toggleDrawer = function () {
	      _this6.setState(function (state) {
	        return {
	          expanded: !state.expanded
	        };
	      }, function () {
	        if (isIE11) {
	          _this6.props.onDrawerUpdate();
	        }
	      });
	    };
	
	    _this6.componentWillReceiveProps = function (nextProps) {
	      if (_this6.props.expanded !== nextProps.expanded) {
	        _this6.setState({
	          expanded: nextProps.expanded
	        });
	      }
	    };
	
	    _this6.getDetailByType = function (t, value, amendment) {
	      switch (t.type) {
	        case 'customLabel':
	          return _react2.default.createElement(Detail, { label: amendment[t.labelKey] || t.label, value: value, key: t.id });
	        case 'download':
	          return value ? _react2.default.createElement(
	            Detail,
	            { label: t.label, key: t.id },
	            _react2.default.createElement(
	              "a",
	              { download: t.label + ".pdf", target: "blank", href: "" + _requests.BASE_URL + value },
	              _react2.default.createElement(_downloadBox2.default, null),
	              t.linkLabel || 'Download'
	            )
	          ) : null;
	        default:
	          return _react2.default.createElement(Detail, { label: t.label, value: value, key: t.id });
	      }
	    };
	
	    _this6.getAmendmentDelayedDate = function (amendment) {
	      if (({"NODE_ENV":"production","BUILD_DATE":"2025-08-27T15:15:31.687Z","BUILD_NUMBER":"Not Provided","GIT_VERSION":"v1.3.0-381-ga81e29b08","GIT_COMMIT_HASH":"a81e29b085c9268ffd96c78eb734365802722741","GIT_BRANCH":"beta","PUBLIC_URL":"","STATE_ABBR":"MT","STATE_NAME":"Montana","STATE_ORG_TITLE":"Secretary of State","LOGIN_HEADER_IMG_PATH":"","HOME_IMG_FILENAME":"montana.jpg","FAVICON_FILE_NAME":"favicon.ico","ALLOW_E_SIGN_ON_CORRECTIONS":true,"THIRD_PARTY_SIGNING_ALLOWED":false,"MY_ACCOUNT_SAVE_AND_CLOSE_BUTTON":true,"IE_DEPRECATED_MESSAGE":"Internet Explorer is not supported. Please select a supported browser below to access this website.","ADDITIONAL_ROUTES":{"dataRequests":true,"farmBill":true,"apostille":true,"externalHelp":"https://sosmt.gov/business/help-center/","systemAdministration":[{"title":"Saved Payments","parameter":"saved-payments","componentName":"SavedPayments"}]},"SUBROUTES":[{"label":"Business","component":"Business","parameter":"business","myWorkQueueSearch":false,"sourceTypeId":54,"searchMustHaveOneOf":["FILING_TYPE_ID","STATUS_ID","STATE","search"],"serverWebSearchDescription":true,"serverWorkQueueDescription":true,"serverMyRecordsDescription":true,"searchPlaceholder":"Search by name or filing number (X########)","allowEmptySearchTerm":true,"requestCertificateAlternateLabel":"Request Information","fileAmendmentButtonLabel":"Filing Actions","advancedSearchParameters":[{"type":"radio","name":"QUERY_TYPE_ID","defaultValue":1010,"options":[{"value":1010,"label":"Starts with"},{"value":1011,"label":"Contains"},{"value":1012,"label":" Word Contains"}]},{"type":"serverSelect","name":"FILING_TYPE_ID","optionsSrc":"FILING_TYPES","label":"Entity Type","placeholder":"All","defaultValue":"0"},{"type":"serverSelect","name":"FILING_SUBTYPE_ID","optionsSrc":"FILING_SUBTYPES","label":"Entity Subtype","overrideSubOptionsSrcFromParameterName":"FILING_TYPE_ID","placeholder":"All","defaultValue":"0"},{"type":"serverSelect","name":"STATUS_ID","optionsSrc":"FILING_STATUS_WITHOUT_ALL","label":"Status","placeholder":"All","defaultValue":"0"},{"type":"serverSelect","name":"STATE","optionsSrc":"STATE","label":"State","placeholder":"All","defaultValue":""},{"type":"serverSelect","name":"COUNTY","optionsSrc":"COUNTY_SUBOPTION","label":"County","overrideSubOptionsSrcFromParameterName":"STATE","placeholder":"All","defaultValue":""},{"type":"checkbox","name":"CRA_SEARCH_YN","defaultValue":false,"label":"Search by Registered Agent PID"},{"type":"dateRange","name":"FILING_DATE","label":"Registration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}},{"type":"dateRange","name":"EXPIRATION_DATE","label":"Expiration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}}],"myRecordsFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Active"},{"value":2,"label":"Inactive"},{"value":3,"label":"Pending"}]},{"type":"dateRange","name":"DATE_RANGE","label":"Date range","defaultValue":{"start":null,"end":null}}],"myWorkQueueFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Approved"},{"value":2,"label":"Pending Online Payment"},{"value":3,"label":"Pending Review"},{"value":4,"label":"Needs Correction"},{"value":5,"label":"Rejected"},{"value":6,"label":"Draft"}]},{"type":"dateRange","name":"DATE_RANGE","label":"Date range","defaultValue":{"start":null,"end":null}}]},{"label":"Notary","component":"Notary","parameter":"notary","sourceTypeId":850,"myWorkQueueSearch":false,"allowEmptySearchTerm":true,"requestCertificateAlternateLabel":"Download Certificate","fileAmendmentButtonLabel":"Filing Actions","hideNameRequestCertificate":true,"hideAddressRequestCertificate":true,"hideRecordUserManagment":true,"searchPlaceholder":"Search by name or commission number","searchMustHaveOneOf":["CITY","search","SERVICE_TYPE"],"advancedParametersStartOpen":true,"searchIsSortable":true,"advancedSearchParameters":[{"type":"radio","name":"STARTS_WITH_YN","defaultValue":false,"options":[{"value":true,"label":"Starts with"},{"value":false,"label":"Contains"}]},{"type":"checkbox","name":"ACTIVE_ONLY_YN","defaultValue":true,"label":"Active entities only"},{"type":"text","name":"CITY","defaultValue":"","label":"City"},{"type":"select","name":"SERVICE_TYPE","label":"Special Services Offered","defaultValue":0,"options":[{"value":0,"label":"(N/A)"},{"value":6165,"label":"In-Person Electronic Notarization (IPEN)"},{"value":6166,"label":"Remote Online Notarization (RON)"},{"value":6167,"label":"Mobile Notary Services"},{"value":6168,"label":"Remote Ink Notarization (RIN)"}]}]},{"label":"Apostille","component":"Apostille","parameter":"apostille","sourceTypeId":720,"myRecordsSearch":false,"myWorkQueueSearch":false,"disabled":false,"allowedRoutes":["/forms-manager/","/queue/","/forms/"]},{"label":"Liens","component":"UCC","parameter":"ucc","sourceTypeId":1999,"myRecordsSearch":true,"myWorkQueueSearch":true,"fileAmendmentButtonLabel":"Filing Actions","searchPlaceholder":"Search by name or file number","disabled":false,"serverWebSearchDescription":true,"myRecordsDescription":"","workQueueDescription":"","searchDescription":"","hideRecordUserManagment":true,"searchLiensCheckout":false,"advancedSearchParameters":[{"type":"radio","name":"STARTS_WITH_YN","defaultValue":false,"options":[{"value":true,"label":"Starts with"},{"value":false,"label":"Contains"}]},{"type":"select","name":"STATUS","defaultValue":"ALL","label":"Status","options":[{"value":"ACTIVE_UNLAPSED","label":"Active (unlapsed)"},{"value":"ACTIVE_LAPSED_UNLAPSED","label":"Active (lapsed and unlapsed)"}]},{"type":"text","name":"EXCLUDE_VALUES","label":"Exclude Debtor Names (comma separated list of names to exclude)","defaultValue":""},{"type":"dateRange","name":"FILING_DATE","label":"Financing Statement Date","defaultValue":{"start":null,"end":null}},{"type":"dateRange","name":"LAPSE_DATE","label":"Lapse Date","defaultValue":{"start":null,"end":null}},{"type":"text","name":"CITY","label":"Debtor City","defaultValue":""}],"myRecordsFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Approved"},{"value":2,"label":"Pending Online Payment"},{"value":3,"label":"Pending Review"}]},{"type":"select","name":"TYPE","defaultValue":0,"label":"Lien Type","options":[{"value":0,"label":"All"},{"value":1,"label":"UCC"},{"value":2,"label":"EFS"},{"value":3,"label":"Title 71"}]}],"myWorkQueueFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Approved"},{"value":2,"label":"Pending Online Payment"},{"value":3,"label":"Pending Review"},{"value":4,"label":"Pending Print and Mail"},{"value":5,"label":"Rejected"},{"value":6,"label":"Draft"}]},{"type":"select","name":"TYPE","defaultValue":0,"label":"Lien Type","options":[{"value":0,"label":"All"},{"value":1,"label":"UCC"},{"value":2,"label":"EFS"},{"value":3,"label":"Title 71"}]}]},{"label":"Copy Request","component":"copies","parameter":"copies","sourceTypeId":2001,"myRecordsSearch":false,"myWorkQueueSearch":false,"disabled":false,"allowedRoutes":["/forms-manager/","/queue/","/forms/"]},{"label":"Trademark","component":"Trademark","parameter":"trademark","sourceTypeId":810,"showRequestCertificate":true,"searchMustHaveOneOf":["search","EXPIRATION_DATE","FILING_DATE"],"allowEmptySearchTerm":true,"requestCertificateAlternateLabel":"Request Information","fileAmendmentButtonLabel":"Filing Actions","advancedSearchParameters":[{"type":"radio","name":"QUERY_TYPE_ID","defaultValue":1010,"options":[{"value":1010,"label":"Starts with"},{"value":1011,"label":"Contains"},{"value":1012,"label":" Word Contains"}]},{"type":"checkbox","name":"OWNER_SEARCH_YN","defaultValue":false,"label":"Search owners"},{"type":"radio","name":"SERVICE_MARK_YN","label":"Mark Type","defaultValue":"","options":[{"value":"","label":"All Marks"},{"value":"Y","label":"Service Mark"},{"value":"N","label":"Trademark"}]},{"type":"serverSelect","name":"STATUS_ID","optionsSrc":"TYPE_V|TRADEMARK_STATUS_TYPE","label":"Status","placeholder":"All","defaultValue":"0"},{"type":"select","name":"DESIGN_TYPE_ID","options":[{"value":0,"label":"All"},{"value":990,"label":"Words Only"},{"value":991,"label":"Design Only"},{"value":992,"label":"Words and Design"}],"label":"Design Type","defaultValue":"0"},{"type":"dateRange","name":"FILING_DATE","label":"Registered Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}},{"type":"dateRange","name":"EXPIRATION_DATE","label":"Expiration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}}]},{"label":"Business Info Request","component":"InfoRequests","parameter":"info-request","sourceTypeId":167,"allowedRoutes":["/forms-manager/","/queue/","/forms/"]},{"label":"Data Requests","component":"DataRequests","parameter":"data-request","sourceTypeId":0,"allowedRoutes":["/forms-manager/"]},{"label":"CRA","component":"CRA","parameter":"cra","sourceTypeId":157,"myRecordsSearch":false,"searchPlaceholder":"Search by name or registered agent number","allowedRoutes":["/forms-manager/","/forms/","/records/","/queue/","/search/"],"allowEmptySearchTerm":true,"fileAmendmentButtonLabel":"Filing Actions","advancedSearchParameters":[{"type":"radio","name":"QUERY_TYPE_ID","defaultValue":1010,"options":[{"value":1010,"label":"Starts with"},{"value":1011,"label":"Contains"},{"value":1012,"label":" Word Contains"}]},{"type":"dateRange","name":"CRA_DATE","label":"Registration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}},{"type":"select","name":"STATUS_ID","label":"Status","defaultValue":0,"options":[{"value":0,"label":"All"},{"value":121,"label":"Active"},{"value":122,"label":"Inactive"}]},{"type":"select","name":"AGENT_TYPE_ID","label":"Agent Type","defaultValue":0,"options":[{"value":0,"label":"All"},{"value":460,"label":"Registered Agent"},{"value":461,"label":"Commercial Registered Agent"}]}]},{"label":"Farm Bill","component":"FarmBill","parameter":"farm-bill","path":"/lists/farm-bill","sourceTypeId":0,"myRecordsSearch":false,"allowedRules":["/search/"],"disabled":true,"searchDescription":"To perform a search, enter a debtor name. Your search results may include: exact debtor name, variations of that name and any filing that includes your search criteria. Punctuation is ignored.\n\nYou can click on \"Advanced\" to refine your search. Under “Advanced” you can search by crop, year, county and SSN/FEIN. As a registered Farm Bill Buyer with the Montana Secretary of State’s office it is important to maintain the confidentiality of the information contained within the Farm Bill Master List. The Farm Bill Master List reflects personal data, such as Social Security Numbers, which are a key piece of personal identifiable information to assist you in determining the existence of a lien against a specific debtor. The distribution of this information beyond its intended purpose is strictly prohibited.\n\nThe debtor's tax identification number has been hidden for confidentiality reasons. You may continue to search on a tax ID number and return debtors that match your search criteria. The SSN/FEIN must be entered without dashes or spaces.","searchMustHaveOneOf":["search","UCC_FARM_PRODUCT_ID","COUNTY"],"searchPlaceholder":"Search by debtor name","advancedSearchParameters":[{"type":"ServerMultiComplete","label":"Product code name(s)","name":"UCC_FARM_PRODUCT_ID","defaultValue":"","optionsSrc":"UCC_FARM_PRODUCT_V"},{"type":"MultiComplete","label":"Year or Range of Years","name":"YEAR_NUM","optionsSrc":"years","startYear":"1968","defaultValue":[],"preMergeOptions":[{"value":"ALL","label":"All"}]},{"type":"serverSelect","label":"State","name":"STATE","defaultValue":"MONTANA","optionsSrc":"STATE"},{"type":"ServerMultiComplete","label":"County","name":"COUNTY","defaultValue":[],"optionsSrc":"COUNTY","overrideSubOptionsSrcFromParameterName":"STATE"},{"type":"checkbox","name":"TIN_SEARCH_YN","defaultValue":false,"label":"Tax Identification Number Search"},{"type":"checkbox","name":"TIN_SORT_YN","defaultValue":false,"label":"Unique ID Sort"}]}],"SYSTEM_NICKNAME":"Online Services Portal","PAYMENT_METHODS":[{"type":"bypass"},{"type":"iTransact"}],"PAYMENT_ALLOW_AMEX":true,"SYSTEM_ID_LABEL":"System Id","DOUBLE_COLUMN_PUBLIC_LOGIN":true,"INTERNAL_USER_MANAGEMENT":true,"ALLOW_PUBLIC_JSON_IMPORT":false,"MAX_FILE_UPLOAD_SIZE":10000000,"REFUND_TEXT":"","RETURN_TO_HOME_ON_LOGOUT":true,"CURRENT_SOS_NAME":"Christi Jacobsen","LOGO_FILENAME":"mt-sos-logo.png","LOGO_ALT":"Christi Jacobsen, Montana Secretary of State","LOGO_FULL_WIDTH":true,"HOME_HIDE_AUTH_HINT":true,"HOME_TITLE":"Montana Secretary of State","CUSTOM_TAB_TITLE":"Official Montana","HOME_SUBTITLE":"Online Business Services","ENTITY_NAME_CONSENT_DESCRIPTION":"","ALLOW_USER_PROFILE_EDITING":true,"COMPARE_FOREIGN_NAME_IN_ENTITY_NAME_VALIDATION":true,"FOREIGN_NAME_FIELD_NAME":"KIMA_PARENT_NAME_INFO","LOGIN_TITLE":"Montana Secretary of State Online Filing Portal Login","PUBLIC_LOGIN_LABEL":"Username","REVERSE_LOGIN_COLUMNS":true,"LOGIN_SEAL_FILENAME":"seal_white.png","SEPARATE_USERNAME_AND_EMAIL":true,"CREATE_ACCOUNT_BUTTON_ALIGN_LEFT":true,"CREATE_ACCOUNT_BUTTON_TEXT":"CREATE AN ACCOUNT","PASSWORD_CUSTOM_ERROR_TEXT":"The password must meet all requirements","ACCOUNT_CREATED_MESSAGE":"Please check your email to verify your account to login and allow a few minutes for this message to arrive. Check your junk/spam folders if you do not find the email in your inbox.","PUBLIC_LOGIN_PLACEHOLDER":" ","DISABLE_DEFAULT_PAYMENT_RADIO":true,"CUSTOM_RESET_PASSWORD_ERROR_MESSAGE":"Username invalid - no account found","PUBLIC_LOGIN_CREATE_DESCRIPTION":"### Existing User:\n\n  - Enter your username and password to login.  \n\n\n  #### - OR -  \n\n\n\n  - Forgot password? Click 'Reset Password' and follow the prompts.\n  - Forgot username? Click 'Forgot Username' and follow the prompts.  \n\n\n  ### New User:\n  ","LOGIN_HELP_LINK":"https://sosmt.gov/business/how-do-i/","LOGIN_HELP_LINK_TEXT":"Need Help?","FORGOT_USERNAME_TEXT":"Forgot Username?","LOGIN_ACTIVE_DIRECTORY_TEXT":"State User Login","MULTIPLE_LOGIN_METHODS":true,"HAS_ACTIVE_DIRECTORY_LOGIN":true,"RESET_PASSWORD_WITH_USERNAME":true,"DOWNLOAD_LINK":true,"SHOW_USERNAME_ACCOUNT_CREATE":true,"SHOW_SCROLL_DOWN_ARROW":true,"SHOW_ADDRESS_ACCOUNT_CREATE":true,"TWO_COLUMN_ACCOUNT_CREATE":true,"RESET_PASSWORD_TIP":"A link to change your password has been sent to your email. Please allow a few minutes for this message to arrive. Please check your junk/spam folders if you do not find the email in your inbox.","FORGOT_PASSWORD_LINK_TEXT":"Reset Password","PHONE_NUMBER_OPTIONAL_ACCOUNT_CREATE":true,"SHOW_REQUIRED_INDICATOR_ACCOUNT_CREATE":true,"PASSWORD_REQUIREMENTS_ACCOUNT_CREATE":"\n    <ul>\n      <li>MUST contain at least 8 characters (12+ recommended)</li>\n      <li>MUST contain at least one uppercase letter.</li>\n      <li>MUST contain at least one lowercase letter.</li>\n      <li>MUST contain at least one number.</li>\n      <li>MUST contain at least one special character (!”#$%&'()*+,-./:;<=>?</li>\n    </ul>\n  ","ALLOW_CERTIFICATION_REQUEST":true,"ALLOW_PUBLIC_CERTIFICATE_REQUEST":true,"ALLOW_COPY_REQUEST":false,"ALLOW_CORRECTION_STYLING":true,"HIDE_DEPRECATION_WARNING":false,"AMEND_ROUTE_PUBLIC":true,"SEAL_FILENAME":"seal.png","SHOPPING_CART":true,"ALLOW_PAYMENT_UPDATE_WITH_EMPTY_CART":true,"RA_EMAIL":true,"RA_WEBSITE":true,"RA_NO_DEFAULT_TYPE":true,"RA_ADDRESS_LABEL":"Street Address","RA_TYPE_SELECTION_DEFAULT":true,"RA_DEFAULT_TYPE":"460","RA_OVERRIDE_TYPE_WITH_DEFAULT":true,"RA_PRINCIPAL_ADDRESS_AMS":true,"UPLOAD_AND_SUBMIT_HIDE_IF_ONE_OPTION":true,"PAYMENT_PROCESSING_MESSAGE":"Your payment is processing - Do not close your browser or click the back button","CHECKOUT_BUTTON_WHEN_PROCESSING_TEXT":"Processing","EFS_CROP_PICKER_NONE_LABEL":"Lien Duration","DISALLOWED_WIZARD_PIECES":["FormationLocale"],"REPEATER_SHOW_EDIT_BUTTON":true,"DATA_REQUEST_PAGE_TITLE":"Data Requests and Subscriptions","DATA_REQUEST_SIDEBAR_LABEL":"Data Requests & Subscriptions","LOGIN_REDIRECTS_TO_EPASS":false,"LOGIN_REDIRECTS_TO_ACTIVE_DIRECTORY":true,"LOGIN_ACTIVE_DIRECTORY_LINK":true,"FETCH_EDIT_USER_LINK":false,"LISTS_FETCH_AVAILABLE_LISTS":true,"POST_WIZARD_SUBMIT_REDIRECT_URL":"/","PIN_REQUEST_ATTESTATIONS":true,"PIN_REQUEST_DESCRIPTION":"Click **Request PIN** to have a new PIN sent to the account holder's email address on file.","OWNERSHIP_REQUEST_DESCRIPTION":"To become an **authorized user** of this record, a current **AUTHORIZED USER** will need to grant you access. To request access, click **Request Access** below.","PIN_REQUEST_SUCCESS_MESSAGE":"The PIN you have requested for this entity has been sent to the email associated with your user account.  You should receive the PIN in approximately 3-5 minutes, depending on your email service provider.","APOSTILLE_HEADER_LABEL":"Verification Information","APOSTILLE_NUMBER_LABEL":"Apostille/Authentication","APOSTILLE_CITY_STATE_OVERRIDE":"HELENA, MT","APOSTILLE_FILING_DATE_LABEL":"Issue Date","APOSTILLE_CITY_STATE_IN_CERTIFIED":true,"NOTARY_EXISTING_FILING":true,"ALLOW_REVOKE_OWN_ACCESS_ONLY":false,"HIDE_CANCEL_ON_ONETIME_DATA_REQUESTS":true,"DATA_REQUESTS_IN_SHOPPING_CART":true,"WQ_ALLOW_EDIT_PENDING_PAYMENT":true,"WQ_CONFIRM_ON_DELETE":true,"WQ_DELETE_CONFIRM_MESSAGE":"Deleting this filing will forfeit any money already paid to the Secretary of State. This action is permanent and cannot be undone, are you sure you would like to delete?","PASS_ITEM_GUIDS_ON_CHECKOUT":true,"FORM_REVISION_HISTORY":true,"CHECKOUT_DISCLAIMER":"By entering your credit card and/or checking account information you (i) state that **you are an authorized user** of the credit card and/or electronic check and that the associated information entered (e.g., account holder name, account number, billing address) is accurate, (ii) **you authorize payment processor to charge the amount you have requested** to your credit card and/or funding account, and (iii) **acknowledge if a charge is declined or reversed you may also be assessed a customary charge** by the payment processor for such transactions.","FARM_BILL_SEARCH_CONFIDENTIAL":"As a registered Farm Bill Buyer with the Montana Secretary of State’s office it is important to maintain the confidentiality of the information contained within the Farm Bill Master List. The Farm Bill Master List reflects personal data, such as Social Security Numbers, which are a key piece of personal identifiable information to assist you in determining the existence of a lien against a specific debtor. The distribution of this information beyond its intended purpose is strictly prohibited.\n\n**The debtor's tax identification number has been hidden for confidentiality reasons. You may continue to search on a tax ID number and return debtors that match your search criteria. The SSN/FEIN must be entered without dashes or spaces.  If you need access to the tax identification number to clearly identify the debtor, please contact the UCC unit at (406) 444-3665.**","VIEW_HISTORY_BUTTON_ALT_TEXT":"View Filings","WIZARD_ERROR_TITLE_MESSAGE":"Form Error","FARM_BILL_SEARCH_INTERACTIVE":true,"USE_FARM_BILL_API":true,"DISALLOW_ASSIGN_SELF_AS_RA":true,"DISALLOW_ASSIGN_SELF_AS_PRINCIPAL":true,"USE_TRADEMARK_OWNER_VALIDATION":true,"USE_ALTERNATIVE_FOREIGN_ADDRESS_LABELS":true,"MY_RECEIPTS_FILTER":[{"type":"dateRange","name":"DATE_RANGE","label":"Date range","defaultValue":{"start":null,"end":null}},{"type":"text","name":"REF_NUM","defaultValue":"","label":"Reference Number"},{"type":"text","name":"RECEIPT_NUM","defaultValue":"","label":"Receipt Id"},{"type":"text","name":"AMOUNT","defaultValue":"","label":"Amount"},{"type":"select","name":"TYPE","defaultValue":"","label":"Payment Type","options":[{"value":"","label":"All"},{"value":"CC","label":"Credit Card"},{"value":"Check","label":"Check"}]}],"MY_RECEIPTS_SHOW_IN_SIDEBAR":true,"SHOW_MY_RECEIPTS_HELPER_TEXT":true,"MY_RECEIPTS_HELPER_LABEL":"About Receipt Search","MY_RECEIPTS_HELPER_TEXT":"You can search for receipts based on their descriptions, including the items paid for on the receipt. Use the filters to search for or filter specific information.","FARM_BILL_SUBLINK":{"label":"Farm Bill","component":"FarmBill","parameter":"farm-bill","path":"/lists/farm-bill","sourceTypeId":0,"myRecordsSearch":false,"allowedRules":["/search/"],"disabled":true,"searchDescription":"To perform a search, enter a debtor name. Your search results may include: exact debtor name, variations of that name and any filing that includes your search criteria. Punctuation is ignored.\n\nYou can click on \"Advanced\" to refine your search. Under “Advanced” you can search by crop, year, county and SSN/FEIN. As a registered Farm Bill Buyer with the Montana Secretary of State’s office it is important to maintain the confidentiality of the information contained within the Farm Bill Master List. The Farm Bill Master List reflects personal data, such as Social Security Numbers, which are a key piece of personal identifiable information to assist you in determining the existence of a lien against a specific debtor. The distribution of this information beyond its intended purpose is strictly prohibited.\n\nThe debtor's tax identification number has been hidden for confidentiality reasons. You may continue to search on a tax ID number and return debtors that match your search criteria. The SSN/FEIN must be entered without dashes or spaces.","searchMustHaveOneOf":["search","UCC_FARM_PRODUCT_ID","COUNTY"],"searchPlaceholder":"Search by debtor name","advancedSearchParameters":[{"type":"ServerMultiComplete","label":"Product code name(s)","name":"UCC_FARM_PRODUCT_ID","defaultValue":"","optionsSrc":"UCC_FARM_PRODUCT_V"},{"type":"MultiComplete","label":"Year or Range of Years","name":"YEAR_NUM","optionsSrc":"years","startYear":"1968","defaultValue":[],"preMergeOptions":[{"value":"ALL","label":"All"}]},{"type":"serverSelect","label":"State","name":"STATE","defaultValue":"MONTANA","optionsSrc":"STATE"},{"type":"ServerMultiComplete","label":"County","name":"COUNTY","defaultValue":[],"optionsSrc":"COUNTY","overrideSubOptionsSrcFromParameterName":"STATE"},{"type":"checkbox","name":"TIN_SEARCH_YN","defaultValue":false,"label":"Tax Identification Number Search"},{"type":"checkbox","name":"TIN_SORT_YN","defaultValue":false,"label":"Unique ID Sort"}]},"ALLOW_ADDRESS_VALIDATION_BYPASS_OPTION":true,"DEFAULT_ADDRESS_VALIDATION_BYPASS_OPTION_CHECKED":true}).DISPLAY_AMENDMENT_DELAYED_DATE && amendment.DELAYED_EFFECTIVE_DATE) {
	        return _react2.default.createElement(
	          "div",
	          { style: { marginLeft: '10px' } },
	          "(Delayed Date ",
	          _react2.default.createElement(
	            "span",
	            null,
	            "- ",
	            amendment.DELAYED_EFFECTIVE_DATE
	          ),
	          ")"
	        );
	      }
	    };
	
	    _this6.state = { expanded: props.expanded || false };
	    return _this6;
	  }
	
	  _createClass(CollapsibleAmendment, [{
	    key: "render",
	    value: function render() {
	      var _this7 = this;
	
	      var _props3 = this.props,
	          amendment = _props3.amendment,
	          template = _props3.template;
	
	      return _react2.default.createElement(
	        "div",
	        { className: "amendment-wrapper" },
	        _react2.default.createElement(
	          "button",
	          { className: "title " + (this.state.expanded ? '' : 'collapsed'), role: "button", onClick: this.toggleDrawer },
	          _react2.default.createElement(
	            "div",
	            null,
	            amendment.AMENDMENT_TYPE,
	            " ",
	            _react2.default.createElement(
	              "span",
	              null,
	              "- ",
	              amendment.AMENDMENT_DATE
	            )
	          ),
	          this.getAmendmentDelayedDate(amendment),
	          this.state.expanded ? _react2.default.createElement(_caretUp2.default, null) : _react2.default.createElement(_caretDown2.default, null)
	        ),
	        this.state.expanded && _react2.default.createElement(
	          "div",
	          { className: "amendment-drawer" },
	          _react2.default.createElement(
	            "div",
	            {
	              className: "amendment " + (amendment.HISTORY.length === 0 ? "no-history" : "")
	            },
	            template.map(function (t) {
	              return amendment[t.id] === null ? null : _this7.getDetailByType(t, amendment[t.id], amendment);
	            })
	          ),
	          amendment.HISTORY.length > 0 && _react2.default.createElement(
	            "div",
	            { className: "table-wrapper" },
	            _react2.default.createElement(
	              "table",
	              null,
	              _react2.default.createElement(
	                "thead",
	                null,
	                _react2.default.createElement(
	                  "tr",
	                  null,
	                  _react2.default.createElement(
	                    "th",
	                    null,
	                    "Field Name"
	                  ),
	                  _react2.default.createElement(
	                    "th",
	                    null,
	                    "Changed From"
	                  ),
	                  _react2.default.createElement(
	                    "th",
	                    null,
	                    "Changed To"
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                "tbody",
	                null,
	                amendment.HISTORY.map(function (h) {
	                  return _react2.default.createElement(
	                    "tr",
	                    { key: h.HISTORY_TYPE_ID },
	                    _react2.default.createElement(
	                      "td",
	                      null,
	                      h.DISPLAY_NAME
	                    ),
	                    _react2.default.createElement(
	                      "td",
	                      null,
	                      h.CHANGED_FROM
	                    ),
	                    _react2.default.createElement(
	                      "td",
	                      null,
	                      h.CHANGED_TO
	                    )
	                  );
	                })
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return CollapsibleAmendment;
	}(_react2.default.Component);
	
	var Detail = function Detail(_ref4) {
	  var label = _ref4.label,
	      value = _ref4.value,
	      children = _ref4.children;
	  return _react2.default.createElement(
	    "div",
	    { className: "detail" },
	    _react2.default.createElement(
	      "label",
	      null,
	      label
	    ),
	    _react2.default.createElement(
	      "span",
	      null,
	      children || value
	    )
	  );
	};

/***/ },
/* 1128 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _creditCardSolid = __webpack_require__(158);
	
	var _creditCardSolid2 = _interopRequireDefault(_creditCardSolid);
	
	var _bankSolid = __webpack_require__(220);
	
	var _bankSolid2 = _interopRequireDefault(_bankSolid);
	
	var _star = __webpack_require__(592);
	
	var _star2 = _interopRequireDefault(_star);
	
	var _starSolid = __webpack_require__(591);
	
	var _starSolid2 = _interopRequireDefault(_starSolid);
	
	var _trash = __webpack_require__(60);
	
	var _trash2 = _interopRequireDefault(_trash);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (_ref) {
	  var type = _ref.type,
	      brand = _ref.brand,
	      last4Digits = _ref.last4Digits,
	      isDefault = _ref.isDefault,
	      onRequestDefault = _ref.onRequestDefault,
	      onRequestDelete = _ref.onRequestDelete,
	      savingsAccount = _ref.savingsAccount;
	
	  var brandDescr = type === "ach" ? savingsAccount === "true" ? "savings" : "checking" : brand ? brand : type;
	  return _react2.default.createElement(
	    'div',
	    { className: 'payment-method' },
	    type === 'card' && _react2.default.createElement(_creditCardSolid2.default, null),
	    type === 'ach' && _react2.default.createElement(_bankSolid2.default, null),
	    _react2.default.createElement(
	      'span',
	      { className: 'text' },
	      _react2.default.createElement(
	        'span',
	        { className: 'brand' },
	        brandDescr
	      ),
	      _react2.default.createElement(
	        'em',
	        null,
	        'ending in'
	      ),
	      _react2.default.createElement(
	        'span',
	        { className: 'digits' },
	        last4Digits
	      )
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'buttons' },
	      _react2.default.createElement(
	        'button',
	        {
	          className: 'control star ' + (isDefault ? 'default' : ''),
	          onClick: onRequestDefault,
	          disabled: isDefault
	        },
	        _react2.default.createElement(
	          'div',
	          { className: 'center' },
	          isDefault ? _react2.default.createElement(_starSolid2.default, null) : _react2.default.createElement(_star2.default, null)
	        )
	      ),
	      _react2.default.createElement(
	        'button',
	        { className: 'control danger', onClick: onRequestDelete },
	        _react2.default.createElement(
	          'div',
	          { className: 'center' },
	          _react2.default.createElement(_trash2.default, null)
	        )
	      )
	    )
	  );
	};

/***/ },
/* 1129 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _requests = __webpack_require__(6);
	
	var _Toolbar = __webpack_require__(304);
	
	var _Toolbar2 = _interopRequireDefault(_Toolbar);
	
	var _ListBlock = __webpack_require__(1107);
	
	var _ListBlock2 = _interopRequireDefault(_ListBlock);
	
	var _gears = __webpack_require__(225);
	
	var _gears2 = _interopRequireDefault(_gears);
	
	var _Shell = __webpack_require__(19);
	
	var _SavedPaymentsDrawer = __webpack_require__(1130);
	
	var _SavedPaymentsDrawer2 = _interopRequireDefault(_SavedPaymentsDrawer);
	
	__webpack_require__(1463);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SavedPayments = function SavedPayments(_ref) {
	  var setDrawerShown = _ref.setDrawerShown,
	      drawerShown = _ref.drawerShown;
	
	  var _React$useState = _react2.default.useState([]),
	      _React$useState2 = _slicedToArray(_React$useState, 2),
	      users = _React$useState2[0],
	      setUsers = _React$useState2[1];
	
	  var _React$useState3 = _react2.default.useState(null),
	      _React$useState4 = _slicedToArray(_React$useState3, 2),
	      selectedProfileId = _React$useState4[0],
	      setSelectedProfileId = _React$useState4[1];
	
	  var _React$useState5 = _react2.default.useState(''),
	      _React$useState6 = _slicedToArray(_React$useState5, 2),
	      drawerTitle = _React$useState6[0],
	      setDrawerTitle = _React$useState6[1];
	
	  var _React$useState7 = _react2.default.useState(''),
	      _React$useState8 = _slicedToArray(_React$useState7, 2),
	      drawerSubtitle = _React$useState8[0],
	      setDrawerSubtitle = _React$useState8[1];
	
	  _react2.default.useEffect(function () {
	    (0, _requests.GET_UCC_XML_USERS)(function (users) {
	      setUsers(users);
	    }, function (err) {
	      console.error(err);
	    });
	  }, []);
	
	  var selectUser = function selectUser(profileId, title, subtitle) {
	    if (profileId === selectedProfileId) {
	      setSelectedProfileId(null);
	      setDrawerShown(false);
	    } else {
	      setSelectedProfileId(profileId);
	      setDrawerTitle(title);
	      setDrawerSubtitle(subtitle);
	      setDrawerShown(true);
	    }
	  };
	  return _react2.default.createElement(
	    'div',
	    { className: 'saved-payments' },
	    _react2.default.createElement(_Toolbar2.default, { title: 'Saved Payments', searchable: false }),
	    _react2.default.createElement(
	      'ul',
	      { className: 'list-wrapper' },
	      users.map(function (user) {
	        return _react2.default.createElement(_ListBlock2.default, {
	          title: user.USER_NAME,
	          subtitle: user.EMAIL,
	          buttons: [{
	            label: _react2.default.createElement(_gears2.default, null),
	            ariaLabel: 'Edit User Payments',
	            id: 'view',
	            onClick: function onClick() {
	              return selectUser(user.CUSTOMER_PROFILE_ID, user.USER_NAME, user.EMAIL);
	            }
	          }],
	          key: user.CUSTOMER_PROFILE_ID
	        });
	      })
	    ),
	    _react2.default.createElement(
	      _Shell.Drawer,
	      {
	        show: drawerShown,
	        title: drawerTitle,
	        subtitle: drawerSubtitle,
	        onSidebarDismiss: function onSidebarDismiss() {
	          return setDrawerShown(false);
	        }
	      },
	      _react2.default.createElement(_SavedPaymentsDrawer2.default, { profileId: selectedProfileId })
	    )
	  );
	};
	
	exports.default = SavedPayments;

/***/ },
/* 1130 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _requests = __webpack_require__(6);
	
	var _hooks = __webpack_require__(144);
	
	var _useItransact = __webpack_require__(467);
	
	var _useItransact2 = _interopRequireDefault(_useItransact);
	
	var _PaymentMethod = __webpack_require__(1128);
	
	var _PaymentMethod2 = _interopRequireDefault(_PaymentMethod);
	
	var _Modal = __webpack_require__(13);
	
	var _Portal = __webpack_require__(12);
	
	var _Portal2 = _interopRequireDefault(_Portal);
	
	var _plusHeavy = __webpack_require__(128);
	
	var _plusHeavy2 = _interopRequireDefault(_plusHeavy);
	
	var _Loaders = __webpack_require__(16);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	exports.default = function (_ref) {
	  var profileId = _ref.profileId;
	
	  var _React$useState = _react2.default.useState(null),
	      _React$useState2 = _slicedToArray(_React$useState, 2),
	      paymentMethods = _React$useState2[0],
	      setPaymentMethods = _React$useState2[1];
	
	  var _React$useState3 = _react2.default.useState(false),
	      _React$useState4 = _slicedToArray(_React$useState3, 2),
	      paymentMethodsLoading = _React$useState4[0],
	      setPaymentMethodsLoading = _React$useState4[1];
	
	  var _React$useState5 = _react2.default.useState(null),
	      _React$useState6 = _slicedToArray(_React$useState5, 2),
	      deletingId = _React$useState6[0],
	      setDeletingId = _React$useState6[1];
	
	  var iTransactLoaded = (0, _useItransact2.default)();
	  var apiUsername = (0, _hooks.useAppSetting)('PAYROC_API_USERNAME');
	
	  var getPaymentMethods = function getPaymentMethods(id) {
	    setPaymentMethodsLoading(true);
	    (0, _requests.GET_XML_PAYROC_CUSTOMER)(id, function (customer) {
	      if (customer === false) {
	        setPaymentMethods([]);
	        setPaymentMethodsLoading(false);
	      } else {
	        setPaymentMethods(customer.payment_sources);
	        setPaymentMethodsLoading(false);
	      }
	    }, function (err) {
	      console.error(err);
	    });
	  };
	
	  var openItransact = function openItransact() {
	    var handler = window.iTransact.Checkout.init({
	      apiUsername: apiUsername.setting.VALUE,
	      name: 'Add new payment method',
	      description: '',
	      panelButtonText: 'Add method',
	      billingAddress: true,
	      ach: true,
	      onToken: function onToken(data) {
	        setPaymentMethodsLoading(true);
	        (0, _requests.ADD_XML_PAYROC_PAYMENT_METHOD)({
	          profileId: profileId,
	          token: data.token
	        }, function (success) {
	          if (success) {
	            getPaymentMethods(profileId);
	          }
	        });
	      }
	    });
	    handler.render({
	      amount: 0
	    });
	  };
	
	  var setAsDefaultPaymentMethod = function setAsDefaultPaymentMethod(paySourceNum) {
	    var cachedMethods = null;
	    setPaymentMethods(function (methods) {
	      cachedMethods = [].concat(_toConsumableArray(methods.map(function (x) {
	        return Object.assign({}, x);
	      })));
	      var newDefaultIndex = methods.findIndex(function (x) {
	        return x.id === paySourceNum;
	      });
	      var noDefaults = methods.map(function (x) {
	        return Object.assign({}, x, { default: false });
	      });
	      return [].concat(_toConsumableArray(noDefaults.slice(0, newDefaultIndex)), [Object.assign({}, noDefaults[newDefaultIndex], { default: true })], _toConsumableArray(noDefaults.slice(newDefaultIndex + 1)));
	    });
	    (0, _requests.SET_XML_PAYROC_DEFAULT_PAYMENT_METHOD)({ profileId: profileId, paySourceNum: paySourceNum }, function (response) {}, function (err) {
	      setPaymentMethods(cachedMethods);
	    });
	  };
	
	  var startPaymentDelete = function startPaymentDelete(paySourceNum) {
	    setDeletingId(paySourceNum);
	  };
	
	  var deletePaymentMethod = function deletePaymentMethod(paySourceNum) {
	    var cachedMethods = null;
	    setPaymentMethods(function (methods) {
	      cachedMethods = [].concat(_toConsumableArray(methods.map(function (x) {
	        return Object.assign({}, x);
	      })));
	      var toDeleteIndex = methods.findIndex(function (x) {
	        return x.id === paySourceNum;
	      });
	      return [].concat(_toConsumableArray(methods.slice(0, toDeleteIndex)), _toConsumableArray(methods.slice(toDeleteIndex + 1)));
	    });
	    (0, _requests.SET_XML_PAYROC_DELETE_PAYMENT_METHOD)({ profileId: profileId, paySourceNum: paySourceNum }, function (response) {}, function (err) {
	      setPaymentMethods(cachedMethods);
	    });
	  };
	
	  _react2.default.useEffect(function () {
	    if (profileId !== null) {
	      getPaymentMethods(profileId);
	    }
	  }, [profileId]);
	
	  return _react2.default.createElement(
	    'div',
	    {
	      className: 'saved-payments-editor',
	      style: {
	        opacity: paymentMethodsLoading ? 0.5 : 1,
	        pointerEvents: paymentMethodsLoading ? 'none' : ''
	      }
	    },
	    iTransactLoaded && !apiUsername.loading && apiUsername.setting && (paymentMethods !== null ? _react2.default.createElement(
	      _react2.default.Fragment,
	      null,
	      paymentMethods.map(function (method) {
	        return _react2.default.createElement(_PaymentMethod2.default, {
	          type: method.type,
	          brand: method.brand,
	          last4Digits: method.last_four_digits,
	          isDefault: method.default,
	          onRequestDefault: function onRequestDefault() {
	            return setAsDefaultPaymentMethod(method.id);
	          },
	          onRequestDelete: function onRequestDelete() {
	            return startPaymentDelete(method.id);
	          },
	          key: method.id,
	          savingsAccount: method.savings_account
	        });
	      }),
	      _react2.default.createElement(
	        'div',
	        { className: 'center' },
	        _react2.default.createElement(
	          'button',
	          {
	            className: 'btn btn-primary btn-raised add-button',
	            disabled: paymentMethodsLoading,
	            onClick: openItransact
	          },
	          _react2.default.createElement(
	            'div',
	            { className: 'center' },
	            _react2.default.createElement(_plusHeavy2.default, null),
	            ' Add New Payment Method'
	          )
	        )
	      )
	    ) : _react2.default.createElement(
	      'div',
	      { className: 'center', style: { marginTop: 100 } },
	      _react2.default.createElement(_Loaders.Spinner, { themeColor: 'medium-neutral' })
	    )),
	    _react2.default.createElement(
	      _Portal2.default,
	      { isOpened: !!deletingId },
	      _react2.default.createElement(_Modal.ConfirmDialog, {
	        closeModal: function closeModal() {
	          return setDeletingId(null);
	        },
	        onModalClosed: function onModalClosed() {},
	        message: 'Are you sure you want to delete this payment method? This cannot be undone.',
	        buttons: [{ label: 'No', onClick: function onClick() {}, className: 'btn-default' }, {
	          label: 'Yes',
	          onClick: function onClick() {
	            return deletePaymentMethod(deletingId);
	          },
	          className: 'btn-danger'
	        }],
	        modalStyle: { borderRadius: 3 }
	      })
	    )
	  );
	};

/***/ },
/* 1131 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Field = __webpack_require__(25);
	
	var _Form = __webpack_require__(14);
	
	var _ServerControls = __webpack_require__(475);
	
	var _ServerControls2 = _interopRequireDefault(_ServerControls);
	
	var _MultiComplete = __webpack_require__(120);
	
	var _MultiComplete2 = _interopRequireDefault(_MultiComplete);
	
	var _DateRange = __webpack_require__(306);
	
	var _DateRange2 = _interopRequireDefault(_DateRange);
	
	var _MountDetector = __webpack_require__(299);
	
	var _MountDetector2 = _interopRequireDefault(_MountDetector);
	
	var _caretDown = __webpack_require__(38);
	
	var _caretDown2 = _interopRequireDefault(_caretDown);
	
	var _caretUp = __webpack_require__(80);
	
	var _caretUp2 = _interopRequireDefault(_caretUp);
	
	var _searchHeavy = __webpack_require__(129);
	
	var _searchHeavy2 = _interopRequireDefault(_searchHeavy);
	
	var _utilities = __webpack_require__(8);
	
	var _reactShow = __webpack_require__(1343);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var AdvancedParameters = function (_React$Component) {
	  _inherits(AdvancedParameters, _React$Component);
	
	  function AdvancedParameters() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, AdvancedParameters);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = AdvancedParameters.__proto__ || Object.getPrototypeOf(AdvancedParameters)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      optionsCache: {},
	      optionGroupsCache: {},
	      searchHint: null
	    }, _this.focusFirstElement = function () {
	      var firstElement = (0, _utilities.getFirstFocusableScopedElement)('.search-advanced-animation-wrapper');
	      if (firstElement) {
	        firstElement.focus();
	        var scrollWrapper = document.querySelector('.search-advanced-animation-wrapper');
	        if (scrollWrapper) {
	          scrollWrapper.scrollTop = 0;
	        }
	      }
	    }, _this.toggleAdvanced = function () {
	      _this.props.onRequestToggleDrawer(undefined, function (open) {
	        if (!open && typeof _this.props.onClose === 'function') {
	          _this.props.onClose();
	        }
	        if (open) {
	          _this.focusFirstElement();
	        }
	      });
	    }, _this.hide = function () {
	      _this.props.onRequestToggleDrawer(false);
	    }, _this.setValue = function (value, name) {
	      var param = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	
	      var calculatedValue = param.setValue ? param.setValue(value) : value;
	      _this.props.onChange(Object.assign({}, _this.props.values, _defineProperty({}, name, calculatedValue)));
	    }, _this.getYearOptions = function (startYear) {
	      var currentYear = new Date().getFullYear();
	      return Array(currentYear - parseInt(startYear || 1950, 10) + 1).fill(null).map(function (_, i) {
	        var year = (currentYear - i).toString();
	        return { value: year, label: year };
	      });
	    }, _this.getOptionsBySrc = function (src, param) {
	      switch (src) {
	        case 'years':
	          return [].concat(_toConsumableArray(param.preMergeOptions || []), _toConsumableArray(_this.getYearOptions(param.startYear)), _toConsumableArray(param.postMergeOptions || []));
	        default:
	          return [];
	      }
	    }, _this.getOptionsSrcOverrideValue = function (param) {
	      return _this.props.values[param.overrideOptionsSrcFromParameterName];
	    }, _this.getSubOptionsSrcOverrideValue = function (param) {
	      return _this.props.values[param.overrideSubOptionsSrcFromParameterName];
	    }, _this.showDisabledHint = function () {
	      _this.setState({
	        searchHint: 'Please provide valid search criteria to perform a search.'
	      });
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(AdvancedParameters, [{
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _props = this.props,
	          _props$parameters = _props.parameters,
	          parameters = _props$parameters === undefined ? [] : _props$parameters,
	          onSearchRequested = _props.onSearchRequested,
	          searching = _props.searching,
	          startOpen = _props.startOpen,
	          searchDisabled = _props.searchDisabled;
	
	      var sharedTabIndex = this.props.open ? undefined : '-1';
	      return _react2.default.createElement(
	        _react2.default.Fragment,
	        null,
	        _react2.default.createElement(
	          _reactShow.Animate,
	          {
	            show: this.props.open,
	            duration: 350,
	            transitionOnMount: startOpen ? false : true,
	            className: 'search-advanced-animation-wrapper',
	            style: { height: 'auto' },
	            start: { height: 0 }
	          },
	          _react2.default.createElement(
	            'div',
	            { className: 'search-advanced-parameters-wrapper', 'aria-hidden': !this.props.open },
	            _react2.default.createElement(
	              'div',
	              { className: 'search-advanced-parameters wizard' },
	              _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(
	                  'div',
	                  { className: 'clear-wrapper' },
	                  _react2.default.createElement(
	                    'h2',
	                    null,
	                    'Advanced Search'
	                  )
	                ),
	                _react2.default.createElement(_MountDetector2.default, { onMounted: this.focusFirstElement }),
	                parameters.map(function (rawParam) {
	                  var props = typeof rawParam.getProps === 'function' ? rawParam.getProps(_this2.props.values) : {};
	                  var param = Object.assign({}, rawParam, props);
	                  if (param.visible === false) return null;
	
	                  switch (param.type) {
	                    case 'h3':
	                      return _react2.default.createElement(
	                        'h3',
	                        { key: param.name },
	                        param.text
	                      );
	                    case 'h4':
	                      return _react2.default.createElement(
	                        'h4',
	                        { key: param.name },
	                        param.text
	                      );
	                    case 'text':
	                      return _react2.default.createElement(
	                        _Field.DumbField,
	                        {
	                          key: param.name,
	                          label: param.label,
	                          description: param.description
	                        },
	                        _react2.default.createElement(_Form.TextInput, {
	                          onChange: function onChange(value) {
	                            _this2.setValue(value, param.name, param);
	                          },
	                          value: _this2.props.values[param.name],
	                          width: param.width || '40%',
	                          tabIndex: sharedTabIndex,
	                          ariaLabel: param.ariaLabel
	                        })
	                      );
	                    case 'radio':
	                      return _react2.default.createElement(
	                        _Field.DumbField,
	                        {
	                          key: param.name,
	                          label: param.label,
	                          description: param.description
	                        },
	                        _react2.default.createElement(_Form.RadioInput, {
	                          onChange: function onChange(value) {
	                            _this2.setValue(value, param.name, param);
	                          },
	                          options: param.options,
	                          value: _this2.props.values[param.name],
	                          tabIndex: sharedTabIndex,
	                          ariaLabel: param.ariaLabel
	                        })
	                      );
	                    case 'select':
	                      return _react2.default.createElement(
	                        _Field.DumbField,
	                        {
	                          fieldId: param.name,
	                          label: param.label,
	                          description: param.description,
	                          key: param.name
	                        },
	                        _react2.default.createElement(_Form.Select, {
	                          fieldId: param.name,
	                          onChange: function onChange(value) {
	                            _this2.setValue(value, param.name, param);
	                          },
	                          options: param.options,
	                          value: _this2.props.values[param.name],
	                          width: param.width || '40%',
	                          tabIndex: sharedTabIndex,
	                          ariaLabel: param.ariaLabel
	                        })
	                      );
	                    case 'checkbox':
	                      return _react2.default.createElement(
	                        _Field.DumbField,
	                        { className: 'checkbox', fieldId: param.name, key: param.name },
	                        _react2.default.createElement(_Form.Checkbox, {
	                          name: param.name,
	                          fieldId: param.name,
	                          onChange: function onChange(value) {
	                            _this2.setValue(value, param.name, param);
	                          },
	                          value: _this2.props.values[param.name],
	                          label: param.label,
	                          tabIndex: sharedTabIndex,
	                          ariaLabel: param.ariaLabel
	                        })
	                      );
	                    case 'dateRange':
	                      return _react2.default.createElement(
	                        _Field.DumbField,
	                        {
	                          className: 'date-range',
	                          label: param.label,
	                          description: param.description,
	                          key: param.name
	                        },
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'date-range-wrapper' },
	                          _react2.default.createElement(_DateRange2.default, {
	                            fieldId: param.name,
	                            onChange: function onChange(value) {
	                              _this2.setValue(value, param.name, param);
	                            },
	                            value: _this2.props.values[param.name],
	                            label: param.label,
	                            startLabel: 'Start',
	                            endLabel: 'End',
	                            tabIndex: sharedTabIndex,
	                            ariaLabel: param.ariaLabel
	                          })
	                        )
	                      );
	                    case 'serverSelect':
	                      return _react2.default.createElement(
	                        _Field.DumbField,
	                        {
	                          fieldId: param.name,
	                          label: param.label,
	                          description: param.description,
	                          key: param.name
	                        },
	                        _react2.default.createElement(_ServerControls2.default, {
	                          fieldId: param.name,
	                          controlType: 'select',
	                          ariaLabel: param.ariaLabel,
	                          onChange: function onChange(value) {
	                            _this2.setValue(value, param.name, param);
	                          },
	                          onBlur: function onBlur() {},
	                          value: _this2.props.values[param.name],
	                          options: _this2.state.optionsCache[param.name] || [],
	                          optionGroups: _this2.state.optionGroupsCache[param.name] || [],
	                          optionsSrc: param.optionsSrc,
	                          optionsFetched: !!_this2.state.optionsCache[param.name],
	                          passFieldToOptionsHandler: true,
	                          disabled: !_this2.state.optionsCache[param.name] || !_this2.state.optionsCache[param.name].length,
	                          tabIndex: sharedTabIndex,
	                          placeholder: param.placeholder || '[Select an option]',
	                          optionsSrcOverrideValue: _this2.getOptionsSrcOverrideValue(param),
	                          subOptionsSrcOverrideValue: _this2.getSubOptionsSrcOverrideValue(param),
	                          onOptionsFetchStarted: function onOptionsFetchStarted() {
	                            _this2.setState(function (state) {
	                              var _state$optionsCache = state.optionsCache,
	                                  deletedOpt = _state$optionsCache[param.name],
	                                  optionsCache = _objectWithoutProperties(_state$optionsCache, [param.name]);
	
	                              var _state$optionGroupsCa = state.optionGroupsCache,
	                                  deletedOptGroup = _state$optionGroupsCa[param.name],
	                                  optionGroupsCache = _objectWithoutProperties(_state$optionGroupsCa, [param.name]);
	
	                              return { optionsCache: optionsCache, optionGroupsCache: optionGroupsCache };
	                            });
	                          },
	                          onOptionsFetched: function onOptionsFetched(options, optionGroups) {
	                            _this2.setState(function (state) {
	                              return {
	                                optionsCache: Object.assign({}, state.optionsCache, _defineProperty({}, param.name, options)),
	                                optionGroupsCache: Object.assign({}, state.optionGroupsCache, _defineProperty({}, param.name, optionGroups))
	                              };
	                            });
	                          }
	                        })
	                      );
	                    case 'ServerMultiComplete':
	                      return _react2.default.createElement(
	                        _Field.DumbField,
	                        {
	                          label: param.label,
	                          description: param.description,
	                          key: param.name
	                        },
	                        _react2.default.createElement(_ServerControls2.default, {
	                          ariaLabel: param.label,
	                          controlType: 'ServerMultiComplete',
	                          onChange: function onChange(value) {
	                            _this2.setValue(value, param.name, param);
	                          },
	                          onBlur: function onBlur() {},
	                          value: _this2.props.values[param.name],
	                          options: _this2.state.optionsCache[param.name] || [],
	                          optionGroups: _this2.state.optionGroupsCache[param.name] || [],
	                          optionsSrc: param.optionsSrc,
	                          optionsFetched: !!_this2.state.optionsCache[param.name],
	                          passFieldToOptionsHandler: true,
	                          tabIndex: sharedTabIndex,
	                          disabled: !_this2.state.optionsCache[param.name] || !_this2.state.optionsCache[param.name].length,
	                          placeholder: param.placeholder || '[Select an option]',
	                          optionsSrcOverrideValue: _this2.getOptionsSrcOverrideValue(param),
	                          subOptionsSrcOverrideValue: _this2.getSubOptionsSrcOverrideValue(param),
	                          onOptionsFetchStarted: function onOptionsFetchStarted() {
	                            _this2.setState(function (state) {
	                              var _state$optionsCache2 = state.optionsCache,
	                                  deletedOpt = _state$optionsCache2[param.name],
	                                  optionsCache = _objectWithoutProperties(_state$optionsCache2, [param.name]);
	
	                              var _state$optionGroupsCa2 = state.optionGroupsCache,
	                                  deletedOptGroup = _state$optionGroupsCa2[param.name],
	                                  optionGroupsCache = _objectWithoutProperties(_state$optionGroupsCa2, [param.name]);
	
	                              return { optionsCache: optionsCache, optionGroupsCache: optionGroupsCache };
	                            });
	                          },
	                          onOptionsFetched: function onOptionsFetched(options, optionGroups) {
	                            _this2.setState(function (state) {
	                              return {
	                                optionsCache: Object.assign({}, state.optionsCache, _defineProperty({}, param.name, options)),
	                                optionGroupsCache: Object.assign({}, state.optionGroupsCache, _defineProperty({}, param.name, optionGroups))
	                              };
	                            });
	                          },
	                          fieldId: param.name
	                        })
	                      );
	                    case 'MultiComplete':
	                      return _react2.default.createElement(
	                        _Field.DumbField,
	                        {
	                          label: param.label,
	                          description: param.description,
	                          fieldId: param.name,
	                          key: param.name
	                        },
	                        _react2.default.createElement(_MultiComplete2.default, {
	                          ariaLabel: param.label,
	                          fieldId: param.name,
	                          tabIndex: sharedTabIndex,
	                          options: param.optionsSrc ? _this2.getOptionsBySrc(param.optionsSrc, param) : param.options,
	                          value: _this2.props.values[param.name],
	                          onBlur: function onBlur() {},
	                          onChange: function onChange(value) {
	                            _this2.setValue(value, param.name, param);
	                          }
	                        })
	                      );
	                    case 'FullName':
	                      return _react2.default.createElement(
	                        _Field.DumbField,
	                        {
	                          label: param.label,
	                          description: param.description,
	                          fieldId: param.name,
	                          key: param.name
	                        },
	                        _react2.default.createElement(_Form.FullName, {
	                          tabIndex: sharedTabIndex,
	                          onBlur: function onBlur() {},
	                          onChange: function onChange(value) {
	                            return _this2.setValue(value, param.name, param);
	                          },
	                          value: _this2.props.values[param.name],
	                          fieldId: param.name,
	                          classNameMap: {
	                            firstName: 'col-sm-5 col-md-5 col-lg-4',
	                            middleName: 'col-sm-4 col-md-3 col-lg-3',
	                            lastName: 'col-sm-6 col-md-4 col-lg-4'
	                          }
	                        })
	                      );
	                    case 'NameOrg':
	                      return _react2.default.createElement(
	                        _Field.DumbField,
	                        {
	                          label: param.label,
	                          description: param.description,
	                          fieldId: param.name,
	                          key: param.name
	                        },
	                        _react2.default.createElement(_Form.NameOrg, {
	                          tabIndex: sharedTabIndex,
	                          onBlur: function onBlur() {},
	                          onChange: function onChange(value) {
	                            return _this2.setValue(value, param.name, param);
	                          },
	                          value: _this2.props.values[param.name],
	                          fieldId: param.name,
	                          classNameMap: {
	                            firstName: 'col-sm-5 col-md-5 col-lg-4',
	                            middleName: 'col-sm-4 col-md-3 col-lg-3',
	                            lastName: 'col-sm-6 col-md-4 col-lg-4'
	                          }
	                        })
	                      );
	                    default:
	                      return null;
	                  }
	                }),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'advanced-toolbar' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'flex-row' },
	                    _react2.default.createElement(
	                      'button',
	                      {
	                        className: 'btn btn-primary btn-raised advanced-search-button',
	                        'aria-disabled': searching || searchDisabled,
	                        onClick: searching || searchDisabled ? this.showDisabledHint : onSearchRequested,
	                        tabIndex: sharedTabIndex,
	                        'aria-busy': searching,
	                        'aria-invalid': searchDisabled,
	                        'aria-describedby': 'search-disabled-hint'
	                      },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'center' },
	                        _react2.default.createElement(_searchHeavy2.default, null),
	                        ' Search'
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'button',
	                      {
	                        className: 'btn clear-button',
	                        tabIndex: sharedTabIndex,
	                        onClick: this.props.clearFilters
	                      },
	                      'Clear Filters'
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'p',
	                    { id: 'search-disabled-hint danger-text', 'aria-live': 'polite' },
	                    this.state.searchHint ? _react2.default.createElement(
	                      'span',
	                      { className: 'search-disabled-hint' },
	                      this.state.searchHint
	                    ) : null
	                  )
	                )
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'flex-row advanced-search-toggle-wrapper' },
	          _react2.default.createElement(
	            'button',
	            {
	              className: 'advanced-search-toggle',
	              'aria-expanded': this.props.open,
	              onClick: this.toggleAdvanced,
	              style: { transform: 'translateY(' + (this.props.open ? -15 : 0) + 'px)' }
	            },
	            _react2.default.createElement(
	              'span',
	              null,
	              ({"NODE_ENV":"production","BUILD_DATE":"2025-08-27T15:15:31.687Z","BUILD_NUMBER":"Not Provided","GIT_VERSION":"v1.3.0-381-ga81e29b08","GIT_COMMIT_HASH":"a81e29b085c9268ffd96c78eb734365802722741","GIT_BRANCH":"beta","PUBLIC_URL":"","STATE_ABBR":"MT","STATE_NAME":"Montana","STATE_ORG_TITLE":"Secretary of State","LOGIN_HEADER_IMG_PATH":"","HOME_IMG_FILENAME":"montana.jpg","FAVICON_FILE_NAME":"favicon.ico","ALLOW_E_SIGN_ON_CORRECTIONS":true,"THIRD_PARTY_SIGNING_ALLOWED":false,"MY_ACCOUNT_SAVE_AND_CLOSE_BUTTON":true,"IE_DEPRECATED_MESSAGE":"Internet Explorer is not supported. Please select a supported browser below to access this website.","ADDITIONAL_ROUTES":{"dataRequests":true,"farmBill":true,"apostille":true,"externalHelp":"https://sosmt.gov/business/help-center/","systemAdministration":[{"title":"Saved Payments","parameter":"saved-payments","componentName":"SavedPayments"}]},"SUBROUTES":[{"label":"Business","component":"Business","parameter":"business","myWorkQueueSearch":false,"sourceTypeId":54,"searchMustHaveOneOf":["FILING_TYPE_ID","STATUS_ID","STATE","search"],"serverWebSearchDescription":true,"serverWorkQueueDescription":true,"serverMyRecordsDescription":true,"searchPlaceholder":"Search by name or filing number (X########)","allowEmptySearchTerm":true,"requestCertificateAlternateLabel":"Request Information","fileAmendmentButtonLabel":"Filing Actions","advancedSearchParameters":[{"type":"radio","name":"QUERY_TYPE_ID","defaultValue":1010,"options":[{"value":1010,"label":"Starts with"},{"value":1011,"label":"Contains"},{"value":1012,"label":" Word Contains"}]},{"type":"serverSelect","name":"FILING_TYPE_ID","optionsSrc":"FILING_TYPES","label":"Entity Type","placeholder":"All","defaultValue":"0"},{"type":"serverSelect","name":"FILING_SUBTYPE_ID","optionsSrc":"FILING_SUBTYPES","label":"Entity Subtype","overrideSubOptionsSrcFromParameterName":"FILING_TYPE_ID","placeholder":"All","defaultValue":"0"},{"type":"serverSelect","name":"STATUS_ID","optionsSrc":"FILING_STATUS_WITHOUT_ALL","label":"Status","placeholder":"All","defaultValue":"0"},{"type":"serverSelect","name":"STATE","optionsSrc":"STATE","label":"State","placeholder":"All","defaultValue":""},{"type":"serverSelect","name":"COUNTY","optionsSrc":"COUNTY_SUBOPTION","label":"County","overrideSubOptionsSrcFromParameterName":"STATE","placeholder":"All","defaultValue":""},{"type":"checkbox","name":"CRA_SEARCH_YN","defaultValue":false,"label":"Search by Registered Agent PID"},{"type":"dateRange","name":"FILING_DATE","label":"Registration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}},{"type":"dateRange","name":"EXPIRATION_DATE","label":"Expiration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}}],"myRecordsFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Active"},{"value":2,"label":"Inactive"},{"value":3,"label":"Pending"}]},{"type":"dateRange","name":"DATE_RANGE","label":"Date range","defaultValue":{"start":null,"end":null}}],"myWorkQueueFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Approved"},{"value":2,"label":"Pending Online Payment"},{"value":3,"label":"Pending Review"},{"value":4,"label":"Needs Correction"},{"value":5,"label":"Rejected"},{"value":6,"label":"Draft"}]},{"type":"dateRange","name":"DATE_RANGE","label":"Date range","defaultValue":{"start":null,"end":null}}]},{"label":"Notary","component":"Notary","parameter":"notary","sourceTypeId":850,"myWorkQueueSearch":false,"allowEmptySearchTerm":true,"requestCertificateAlternateLabel":"Download Certificate","fileAmendmentButtonLabel":"Filing Actions","hideNameRequestCertificate":true,"hideAddressRequestCertificate":true,"hideRecordUserManagment":true,"searchPlaceholder":"Search by name or commission number","searchMustHaveOneOf":["CITY","search","SERVICE_TYPE"],"advancedParametersStartOpen":true,"searchIsSortable":true,"advancedSearchParameters":[{"type":"radio","name":"STARTS_WITH_YN","defaultValue":false,"options":[{"value":true,"label":"Starts with"},{"value":false,"label":"Contains"}]},{"type":"checkbox","name":"ACTIVE_ONLY_YN","defaultValue":true,"label":"Active entities only"},{"type":"text","name":"CITY","defaultValue":"","label":"City"},{"type":"select","name":"SERVICE_TYPE","label":"Special Services Offered","defaultValue":0,"options":[{"value":0,"label":"(N/A)"},{"value":6165,"label":"In-Person Electronic Notarization (IPEN)"},{"value":6166,"label":"Remote Online Notarization (RON)"},{"value":6167,"label":"Mobile Notary Services"},{"value":6168,"label":"Remote Ink Notarization (RIN)"}]}]},{"label":"Apostille","component":"Apostille","parameter":"apostille","sourceTypeId":720,"myRecordsSearch":false,"myWorkQueueSearch":false,"disabled":false,"allowedRoutes":["/forms-manager/","/queue/","/forms/"]},{"label":"Liens","component":"UCC","parameter":"ucc","sourceTypeId":1999,"myRecordsSearch":true,"myWorkQueueSearch":true,"fileAmendmentButtonLabel":"Filing Actions","searchPlaceholder":"Search by name or file number","disabled":false,"serverWebSearchDescription":true,"myRecordsDescription":"","workQueueDescription":"","searchDescription":"","hideRecordUserManagment":true,"searchLiensCheckout":false,"advancedSearchParameters":[{"type":"radio","name":"STARTS_WITH_YN","defaultValue":false,"options":[{"value":true,"label":"Starts with"},{"value":false,"label":"Contains"}]},{"type":"select","name":"STATUS","defaultValue":"ALL","label":"Status","options":[{"value":"ACTIVE_UNLAPSED","label":"Active (unlapsed)"},{"value":"ACTIVE_LAPSED_UNLAPSED","label":"Active (lapsed and unlapsed)"}]},{"type":"text","name":"EXCLUDE_VALUES","label":"Exclude Debtor Names (comma separated list of names to exclude)","defaultValue":""},{"type":"dateRange","name":"FILING_DATE","label":"Financing Statement Date","defaultValue":{"start":null,"end":null}},{"type":"dateRange","name":"LAPSE_DATE","label":"Lapse Date","defaultValue":{"start":null,"end":null}},{"type":"text","name":"CITY","label":"Debtor City","defaultValue":""}],"myRecordsFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Approved"},{"value":2,"label":"Pending Online Payment"},{"value":3,"label":"Pending Review"}]},{"type":"select","name":"TYPE","defaultValue":0,"label":"Lien Type","options":[{"value":0,"label":"All"},{"value":1,"label":"UCC"},{"value":2,"label":"EFS"},{"value":3,"label":"Title 71"}]}],"myWorkQueueFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Approved"},{"value":2,"label":"Pending Online Payment"},{"value":3,"label":"Pending Review"},{"value":4,"label":"Pending Print and Mail"},{"value":5,"label":"Rejected"},{"value":6,"label":"Draft"}]},{"type":"select","name":"TYPE","defaultValue":0,"label":"Lien Type","options":[{"value":0,"label":"All"},{"value":1,"label":"UCC"},{"value":2,"label":"EFS"},{"value":3,"label":"Title 71"}]}]},{"label":"Copy Request","component":"copies","parameter":"copies","sourceTypeId":2001,"myRecordsSearch":false,"myWorkQueueSearch":false,"disabled":false,"allowedRoutes":["/forms-manager/","/queue/","/forms/"]},{"label":"Trademark","component":"Trademark","parameter":"trademark","sourceTypeId":810,"showRequestCertificate":true,"searchMustHaveOneOf":["search","EXPIRATION_DATE","FILING_DATE"],"allowEmptySearchTerm":true,"requestCertificateAlternateLabel":"Request Information","fileAmendmentButtonLabel":"Filing Actions","advancedSearchParameters":[{"type":"radio","name":"QUERY_TYPE_ID","defaultValue":1010,"options":[{"value":1010,"label":"Starts with"},{"value":1011,"label":"Contains"},{"value":1012,"label":" Word Contains"}]},{"type":"checkbox","name":"OWNER_SEARCH_YN","defaultValue":false,"label":"Search owners"},{"type":"radio","name":"SERVICE_MARK_YN","label":"Mark Type","defaultValue":"","options":[{"value":"","label":"All Marks"},{"value":"Y","label":"Service Mark"},{"value":"N","label":"Trademark"}]},{"type":"serverSelect","name":"STATUS_ID","optionsSrc":"TYPE_V|TRADEMARK_STATUS_TYPE","label":"Status","placeholder":"All","defaultValue":"0"},{"type":"select","name":"DESIGN_TYPE_ID","options":[{"value":0,"label":"All"},{"value":990,"label":"Words Only"},{"value":991,"label":"Design Only"},{"value":992,"label":"Words and Design"}],"label":"Design Type","defaultValue":"0"},{"type":"dateRange","name":"FILING_DATE","label":"Registered Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}},{"type":"dateRange","name":"EXPIRATION_DATE","label":"Expiration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}}]},{"label":"Business Info Request","component":"InfoRequests","parameter":"info-request","sourceTypeId":167,"allowedRoutes":["/forms-manager/","/queue/","/forms/"]},{"label":"Data Requests","component":"DataRequests","parameter":"data-request","sourceTypeId":0,"allowedRoutes":["/forms-manager/"]},{"label":"CRA","component":"CRA","parameter":"cra","sourceTypeId":157,"myRecordsSearch":false,"searchPlaceholder":"Search by name or registered agent number","allowedRoutes":["/forms-manager/","/forms/","/records/","/queue/","/search/"],"allowEmptySearchTerm":true,"fileAmendmentButtonLabel":"Filing Actions","advancedSearchParameters":[{"type":"radio","name":"QUERY_TYPE_ID","defaultValue":1010,"options":[{"value":1010,"label":"Starts with"},{"value":1011,"label":"Contains"},{"value":1012,"label":" Word Contains"}]},{"type":"dateRange","name":"CRA_DATE","label":"Registration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}},{"type":"select","name":"STATUS_ID","label":"Status","defaultValue":0,"options":[{"value":0,"label":"All"},{"value":121,"label":"Active"},{"value":122,"label":"Inactive"}]},{"type":"select","name":"AGENT_TYPE_ID","label":"Agent Type","defaultValue":0,"options":[{"value":0,"label":"All"},{"value":460,"label":"Registered Agent"},{"value":461,"label":"Commercial Registered Agent"}]}]},{"label":"Farm Bill","component":"FarmBill","parameter":"farm-bill","path":"/lists/farm-bill","sourceTypeId":0,"myRecordsSearch":false,"allowedRules":["/search/"],"disabled":true,"searchDescription":"To perform a search, enter a debtor name. Your search results may include: exact debtor name, variations of that name and any filing that includes your search criteria. Punctuation is ignored.\n\nYou can click on \"Advanced\" to refine your search. Under “Advanced” you can search by crop, year, county and SSN/FEIN. As a registered Farm Bill Buyer with the Montana Secretary of State’s office it is important to maintain the confidentiality of the information contained within the Farm Bill Master List. The Farm Bill Master List reflects personal data, such as Social Security Numbers, which are a key piece of personal identifiable information to assist you in determining the existence of a lien against a specific debtor. The distribution of this information beyond its intended purpose is strictly prohibited.\n\nThe debtor's tax identification number has been hidden for confidentiality reasons. You may continue to search on a tax ID number and return debtors that match your search criteria. The SSN/FEIN must be entered without dashes or spaces.","searchMustHaveOneOf":["search","UCC_FARM_PRODUCT_ID","COUNTY"],"searchPlaceholder":"Search by debtor name","advancedSearchParameters":[{"type":"ServerMultiComplete","label":"Product code name(s)","name":"UCC_FARM_PRODUCT_ID","defaultValue":"","optionsSrc":"UCC_FARM_PRODUCT_V"},{"type":"MultiComplete","label":"Year or Range of Years","name":"YEAR_NUM","optionsSrc":"years","startYear":"1968","defaultValue":[],"preMergeOptions":[{"value":"ALL","label":"All"}]},{"type":"serverSelect","label":"State","name":"STATE","defaultValue":"MONTANA","optionsSrc":"STATE"},{"type":"ServerMultiComplete","label":"County","name":"COUNTY","defaultValue":[],"optionsSrc":"COUNTY","overrideSubOptionsSrcFromParameterName":"STATE"},{"type":"checkbox","name":"TIN_SEARCH_YN","defaultValue":false,"label":"Tax Identification Number Search"},{"type":"checkbox","name":"TIN_SORT_YN","defaultValue":false,"label":"Unique ID Sort"}]}],"SYSTEM_NICKNAME":"Online Services Portal","PAYMENT_METHODS":[{"type":"bypass"},{"type":"iTransact"}],"PAYMENT_ALLOW_AMEX":true,"SYSTEM_ID_LABEL":"System Id","DOUBLE_COLUMN_PUBLIC_LOGIN":true,"INTERNAL_USER_MANAGEMENT":true,"ALLOW_PUBLIC_JSON_IMPORT":false,"MAX_FILE_UPLOAD_SIZE":10000000,"REFUND_TEXT":"","RETURN_TO_HOME_ON_LOGOUT":true,"CURRENT_SOS_NAME":"Christi Jacobsen","LOGO_FILENAME":"mt-sos-logo.png","LOGO_ALT":"Christi Jacobsen, Montana Secretary of State","LOGO_FULL_WIDTH":true,"HOME_HIDE_AUTH_HINT":true,"HOME_TITLE":"Montana Secretary of State","CUSTOM_TAB_TITLE":"Official Montana","HOME_SUBTITLE":"Online Business Services","ENTITY_NAME_CONSENT_DESCRIPTION":"","ALLOW_USER_PROFILE_EDITING":true,"COMPARE_FOREIGN_NAME_IN_ENTITY_NAME_VALIDATION":true,"FOREIGN_NAME_FIELD_NAME":"KIMA_PARENT_NAME_INFO","LOGIN_TITLE":"Montana Secretary of State Online Filing Portal Login","PUBLIC_LOGIN_LABEL":"Username","REVERSE_LOGIN_COLUMNS":true,"LOGIN_SEAL_FILENAME":"seal_white.png","SEPARATE_USERNAME_AND_EMAIL":true,"CREATE_ACCOUNT_BUTTON_ALIGN_LEFT":true,"CREATE_ACCOUNT_BUTTON_TEXT":"CREATE AN ACCOUNT","PASSWORD_CUSTOM_ERROR_TEXT":"The password must meet all requirements","ACCOUNT_CREATED_MESSAGE":"Please check your email to verify your account to login and allow a few minutes for this message to arrive. Check your junk/spam folders if you do not find the email in your inbox.","PUBLIC_LOGIN_PLACEHOLDER":" ","DISABLE_DEFAULT_PAYMENT_RADIO":true,"CUSTOM_RESET_PASSWORD_ERROR_MESSAGE":"Username invalid - no account found","PUBLIC_LOGIN_CREATE_DESCRIPTION":"### Existing User:\n\n  - Enter your username and password to login.  \n\n\n  #### - OR -  \n\n\n\n  - Forgot password? Click 'Reset Password' and follow the prompts.\n  - Forgot username? Click 'Forgot Username' and follow the prompts.  \n\n\n  ### New User:\n  ","LOGIN_HELP_LINK":"https://sosmt.gov/business/how-do-i/","LOGIN_HELP_LINK_TEXT":"Need Help?","FORGOT_USERNAME_TEXT":"Forgot Username?","LOGIN_ACTIVE_DIRECTORY_TEXT":"State User Login","MULTIPLE_LOGIN_METHODS":true,"HAS_ACTIVE_DIRECTORY_LOGIN":true,"RESET_PASSWORD_WITH_USERNAME":true,"DOWNLOAD_LINK":true,"SHOW_USERNAME_ACCOUNT_CREATE":true,"SHOW_SCROLL_DOWN_ARROW":true,"SHOW_ADDRESS_ACCOUNT_CREATE":true,"TWO_COLUMN_ACCOUNT_CREATE":true,"RESET_PASSWORD_TIP":"A link to change your password has been sent to your email. Please allow a few minutes for this message to arrive. Please check your junk/spam folders if you do not find the email in your inbox.","FORGOT_PASSWORD_LINK_TEXT":"Reset Password","PHONE_NUMBER_OPTIONAL_ACCOUNT_CREATE":true,"SHOW_REQUIRED_INDICATOR_ACCOUNT_CREATE":true,"PASSWORD_REQUIREMENTS_ACCOUNT_CREATE":"\n    <ul>\n      <li>MUST contain at least 8 characters (12+ recommended)</li>\n      <li>MUST contain at least one uppercase letter.</li>\n      <li>MUST contain at least one lowercase letter.</li>\n      <li>MUST contain at least one number.</li>\n      <li>MUST contain at least one special character (!”#$%&'()*+,-./:;<=>?</li>\n    </ul>\n  ","ALLOW_CERTIFICATION_REQUEST":true,"ALLOW_PUBLIC_CERTIFICATE_REQUEST":true,"ALLOW_COPY_REQUEST":false,"ALLOW_CORRECTION_STYLING":true,"HIDE_DEPRECATION_WARNING":false,"AMEND_ROUTE_PUBLIC":true,"SEAL_FILENAME":"seal.png","SHOPPING_CART":true,"ALLOW_PAYMENT_UPDATE_WITH_EMPTY_CART":true,"RA_EMAIL":true,"RA_WEBSITE":true,"RA_NO_DEFAULT_TYPE":true,"RA_ADDRESS_LABEL":"Street Address","RA_TYPE_SELECTION_DEFAULT":true,"RA_DEFAULT_TYPE":"460","RA_OVERRIDE_TYPE_WITH_DEFAULT":true,"RA_PRINCIPAL_ADDRESS_AMS":true,"UPLOAD_AND_SUBMIT_HIDE_IF_ONE_OPTION":true,"PAYMENT_PROCESSING_MESSAGE":"Your payment is processing - Do not close your browser or click the back button","CHECKOUT_BUTTON_WHEN_PROCESSING_TEXT":"Processing","EFS_CROP_PICKER_NONE_LABEL":"Lien Duration","DISALLOWED_WIZARD_PIECES":["FormationLocale"],"REPEATER_SHOW_EDIT_BUTTON":true,"DATA_REQUEST_PAGE_TITLE":"Data Requests and Subscriptions","DATA_REQUEST_SIDEBAR_LABEL":"Data Requests & Subscriptions","LOGIN_REDIRECTS_TO_EPASS":false,"LOGIN_REDIRECTS_TO_ACTIVE_DIRECTORY":true,"LOGIN_ACTIVE_DIRECTORY_LINK":true,"FETCH_EDIT_USER_LINK":false,"LISTS_FETCH_AVAILABLE_LISTS":true,"POST_WIZARD_SUBMIT_REDIRECT_URL":"/","PIN_REQUEST_ATTESTATIONS":true,"PIN_REQUEST_DESCRIPTION":"Click **Request PIN** to have a new PIN sent to the account holder's email address on file.","OWNERSHIP_REQUEST_DESCRIPTION":"To become an **authorized user** of this record, a current **AUTHORIZED USER** will need to grant you access. To request access, click **Request Access** below.","PIN_REQUEST_SUCCESS_MESSAGE":"The PIN you have requested for this entity has been sent to the email associated with your user account.  You should receive the PIN in approximately 3-5 minutes, depending on your email service provider.","APOSTILLE_HEADER_LABEL":"Verification Information","APOSTILLE_NUMBER_LABEL":"Apostille/Authentication","APOSTILLE_CITY_STATE_OVERRIDE":"HELENA, MT","APOSTILLE_FILING_DATE_LABEL":"Issue Date","APOSTILLE_CITY_STATE_IN_CERTIFIED":true,"NOTARY_EXISTING_FILING":true,"ALLOW_REVOKE_OWN_ACCESS_ONLY":false,"HIDE_CANCEL_ON_ONETIME_DATA_REQUESTS":true,"DATA_REQUESTS_IN_SHOPPING_CART":true,"WQ_ALLOW_EDIT_PENDING_PAYMENT":true,"WQ_CONFIRM_ON_DELETE":true,"WQ_DELETE_CONFIRM_MESSAGE":"Deleting this filing will forfeit any money already paid to the Secretary of State. This action is permanent and cannot be undone, are you sure you would like to delete?","PASS_ITEM_GUIDS_ON_CHECKOUT":true,"FORM_REVISION_HISTORY":true,"CHECKOUT_DISCLAIMER":"By entering your credit card and/or checking account information you (i) state that **you are an authorized user** of the credit card and/or electronic check and that the associated information entered (e.g., account holder name, account number, billing address) is accurate, (ii) **you authorize payment processor to charge the amount you have requested** to your credit card and/or funding account, and (iii) **acknowledge if a charge is declined or reversed you may also be assessed a customary charge** by the payment processor for such transactions.","FARM_BILL_SEARCH_CONFIDENTIAL":"As a registered Farm Bill Buyer with the Montana Secretary of State’s office it is important to maintain the confidentiality of the information contained within the Farm Bill Master List. The Farm Bill Master List reflects personal data, such as Social Security Numbers, which are a key piece of personal identifiable information to assist you in determining the existence of a lien against a specific debtor. The distribution of this information beyond its intended purpose is strictly prohibited.\n\n**The debtor's tax identification number has been hidden for confidentiality reasons. You may continue to search on a tax ID number and return debtors that match your search criteria. The SSN/FEIN must be entered without dashes or spaces.  If you need access to the tax identification number to clearly identify the debtor, please contact the UCC unit at (406) 444-3665.**","VIEW_HISTORY_BUTTON_ALT_TEXT":"View Filings","WIZARD_ERROR_TITLE_MESSAGE":"Form Error","FARM_BILL_SEARCH_INTERACTIVE":true,"USE_FARM_BILL_API":true,"DISALLOW_ASSIGN_SELF_AS_RA":true,"DISALLOW_ASSIGN_SELF_AS_PRINCIPAL":true,"USE_TRADEMARK_OWNER_VALIDATION":true,"USE_ALTERNATIVE_FOREIGN_ADDRESS_LABELS":true,"MY_RECEIPTS_FILTER":[{"type":"dateRange","name":"DATE_RANGE","label":"Date range","defaultValue":{"start":null,"end":null}},{"type":"text","name":"REF_NUM","defaultValue":"","label":"Reference Number"},{"type":"text","name":"RECEIPT_NUM","defaultValue":"","label":"Receipt Id"},{"type":"text","name":"AMOUNT","defaultValue":"","label":"Amount"},{"type":"select","name":"TYPE","defaultValue":"","label":"Payment Type","options":[{"value":"","label":"All"},{"value":"CC","label":"Credit Card"},{"value":"Check","label":"Check"}]}],"MY_RECEIPTS_SHOW_IN_SIDEBAR":true,"SHOW_MY_RECEIPTS_HELPER_TEXT":true,"MY_RECEIPTS_HELPER_LABEL":"About Receipt Search","MY_RECEIPTS_HELPER_TEXT":"You can search for receipts based on their descriptions, including the items paid for on the receipt. Use the filters to search for or filter specific information.","FARM_BILL_SUBLINK":{"label":"Farm Bill","component":"FarmBill","parameter":"farm-bill","path":"/lists/farm-bill","sourceTypeId":0,"myRecordsSearch":false,"allowedRules":["/search/"],"disabled":true,"searchDescription":"To perform a search, enter a debtor name. Your search results may include: exact debtor name, variations of that name and any filing that includes your search criteria. Punctuation is ignored.\n\nYou can click on \"Advanced\" to refine your search. Under “Advanced” you can search by crop, year, county and SSN/FEIN. As a registered Farm Bill Buyer with the Montana Secretary of State’s office it is important to maintain the confidentiality of the information contained within the Farm Bill Master List. The Farm Bill Master List reflects personal data, such as Social Security Numbers, which are a key piece of personal identifiable information to assist you in determining the existence of a lien against a specific debtor. The distribution of this information beyond its intended purpose is strictly prohibited.\n\nThe debtor's tax identification number has been hidden for confidentiality reasons. You may continue to search on a tax ID number and return debtors that match your search criteria. The SSN/FEIN must be entered without dashes or spaces.","searchMustHaveOneOf":["search","UCC_FARM_PRODUCT_ID","COUNTY"],"searchPlaceholder":"Search by debtor name","advancedSearchParameters":[{"type":"ServerMultiComplete","label":"Product code name(s)","name":"UCC_FARM_PRODUCT_ID","defaultValue":"","optionsSrc":"UCC_FARM_PRODUCT_V"},{"type":"MultiComplete","label":"Year or Range of Years","name":"YEAR_NUM","optionsSrc":"years","startYear":"1968","defaultValue":[],"preMergeOptions":[{"value":"ALL","label":"All"}]},{"type":"serverSelect","label":"State","name":"STATE","defaultValue":"MONTANA","optionsSrc":"STATE"},{"type":"ServerMultiComplete","label":"County","name":"COUNTY","defaultValue":[],"optionsSrc":"COUNTY","overrideSubOptionsSrcFromParameterName":"STATE"},{"type":"checkbox","name":"TIN_SEARCH_YN","defaultValue":false,"label":"Tax Identification Number Search"},{"type":"checkbox","name":"TIN_SORT_YN","defaultValue":false,"label":"Unique ID Sort"}]},"ALLOW_ADDRESS_VALIDATION_BYPASS_OPTION":true,"DEFAULT_ADDRESS_VALIDATION_BYPASS_OPTION_CHECKED":true}).ID_ADVANCED_SEARCH_LABEL ? 'Advanced Search Options' : 'Advanced',
	              this.props.open ? _react2.default.createElement(_caretUp2.default, null) : _react2.default.createElement(_caretDown2.default, null)
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return AdvancedParameters;
	}(_react2.default.Component);
	
	exports.default = AdvancedParameters;

/***/ },
/* 1132 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _EmptyBox = __webpack_require__(197);
	
	var _EmptyBox2 = _interopRequireDefault(_EmptyBox);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (_ref) {
	  var searchTerm = _ref.searchTerm;
	  return _react2.default.createElement(
	    'div',
	    { className: 'empty-placeholder-wrapper' },
	    _react2.default.createElement(_EmptyBox2.default, null),
	    _react2.default.createElement(
	      'h3',
	      null,
	      'No results were found for "',
	      searchTerm,
	      '"'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'Try your search again with different filters or a different search term.'
	    )
	  );
	};

/***/ },
/* 1133 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var React = _interopRequireWildcard(_react);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function ErrorBox(props) {
	  return React.createElement(
	    "svg",
	    Object.assign({ viewBox: "0 0 554.75 486.06" }, props),
	    React.createElement(
	      "defs",
	      null,
	      React.createElement(
	        "style",
	        null,
	        ".prefix__cls-1{fill:#f4d3d3}.prefix__cls-2{fill:#d89a9a}"
	      )
	    ),
	    React.createElement(
	      "g",
	      { id: "prefix__Layer_2", "data-name": "Layer 2" },
	      React.createElement(
	        "g",
	        { id: "prefix__Layer_1-2", "data-name": "Layer 1" },
	        React.createElement(
	          "g",
	          { id: "prefix__Layer_2-2", "data-name": "Layer 2" },
	          React.createElement(
	            "g",
	            { id: "prefix__Layer_1-2-2", "data-name": "Layer 1-2" },
	            React.createElement("path", {
	              className: "prefix__cls-1",
	              d: "M29.84 252h130.79a16.58 16.58 0 0115.13 9.82l16 35.53a10 10 0 009.09 5.9h153.08a10 10 0 009.09-5.9l16-35.57a16.55 16.55 0 0115.1-9.78h130.79a28.88 28.88 0 018.16 1.15L458.83 106A23.22 23.22 0 00438 93.14H116.73A23.18 23.18 0 0095.92 106L21.68 253.05a29.62 29.62 0 018.16-1.05z"
	            }),
	            React.createElement("path", {
	              className: "prefix__cls-2",
	              d: "M554.75 281.44a32.85 32.85 0 00-4.65-16.84l-82.35-163.18A33.13 33.13 0 00438 83.14H116.73A33.13 33.13 0 0087 101.43L4.67 264.6A32.82 32.82 0 000 280.27v175.89a29.9 29.9 0 0029.84 29.9h495.07a29.9 29.9 0 0029.84-29.9v-102zm-10 174.72a19.89 19.89 0 01-19.84 19.9H29.84A19.89 19.89 0 0110 456.16V281.82A19.89 19.89 0 0129.84 262h130.79a6.55 6.55 0 016 3.91l16 35.54a20 20 0 0018.21 11.8h153.09a20 20 0 0018.21-11.8l16-35.58a6.55 6.55 0 016-3.87h130.77a19.89 19.89 0 0119.84 19.91zM96 105.94a23.2 23.2 0 0120.81-12.8H438A23.22 23.22 0 01458.83 106l74.24 147.1a28.88 28.88 0 00-8.16-1.15H394.12a16.54 16.54 0 00-15.12 9.74l-16 35.57a10 10 0 01-9.09 5.9H200.82a10 10 0 01-9.09-5.9l-16-35.53a16.57 16.57 0 00-15.1-9.77H29.84a29.24 29.24 0 00-8.16 1.14z"
	            }),
	            React.createElement("path", {
	              d: "M544.75 281.82A19.89 19.89 0 00524.91 262H394.12a6.55 6.55 0 00-6 3.87l-16 35.58a20 20 0 01-18.21 11.8H200.82a20 20 0 01-18.21-11.8l-16-35.54a6.55 6.55 0 00-6-3.91H29.84A19.89 19.89 0 0010 281.82v174.34a19.89 19.89 0 0019.84 19.9h495.07a19.89 19.89 0 0019.84-19.9zM354.38 409.1a16.48 16.48 0 01-16.47 16.46H216.84a16.48 16.48 0 01-16.46-16.46V376a16.48 16.48 0 0116.46-16.47h121.07A16.48 16.48 0 01354.38 376z",
	              fill: "#ffebeb"
	            }),
	            React.createElement("rect", {
	              x: 210.38,
	              y: 369.56,
	              width: 134,
	              height: 46,
	              rx: 6.47,
	              fill: "#ffe1e1"
	            }),
	            React.createElement("path", {
	              className: "prefix__cls-2",
	              d: "M337.91 359.56H216.84A16.48 16.48 0 00200.38 376v33.1a16.48 16.48 0 0016.46 16.46h121.07a16.48 16.48 0 0016.47-16.46V376a16.48 16.48 0 00-16.47-16.44zm6.47 49.54a6.48 6.48 0 01-6.47 6.46H216.84a6.48 6.48 0 01-6.46-6.46V376a6.48 6.48 0 016.46-6.47h121.07a6.49 6.49 0 016.47 6.47z"
	            })
	          )
	        ),
	        React.createElement("path", {
	          className: "prefix__cls-1",
	          d: "M449.14 88.27l54.48-54.48a8.66 8.66 0 000-12.26l-9-9a8.67 8.67 0 00-12.26 0L427.89 67l-54.48-54.46a8.67 8.67 0 00-12.26 0l-9 9a8.66 8.66 0 000 12.26l54.49 54.48-54.49 54.49a8.65 8.65 0 000 12.25l9 9a8.67 8.67 0 0012.26 0l54.48-54.48L482.38 164a8.67 8.67 0 0012.26 0l9-9a8.65 8.65 0 000-12.25z"
	        }),
	        React.createElement("path", {
	          className: "prefix__cls-2",
	          d: "M510.69 135.69l-47.41-47.42 47.41-47.41a18.69 18.69 0 000-26.4l-9-9a18.66 18.66 0 00-26.4 0l-47.4 47.42-47.41-47.41a18.66 18.66 0 00-26.4 0l-9 9a18.66 18.66 0 000 26.4l47.42 47.4-47.41 47.42a18.66 18.66 0 000 26.4l9 9a18.66 18.66 0 0026.4 0l47.41-47.41 47.42 47.41a18.66 18.66 0 0026.4 0l9-9a18.69 18.69 0 00-.03-26.4zM503.62 155l-9 9a8.67 8.67 0 01-12.26 0l-54.49-54.48L373.41 164a8.67 8.67 0 01-12.26 0l-9-9a8.65 8.65 0 010-12.25l54.49-54.49-54.48-54.47a8.66 8.66 0 010-12.26l9-9a8.67 8.67 0 0112.26 0L427.89 67l54.49-54.48a8.67 8.67 0 0112.26 0l9 9a8.66 8.66 0 010 12.26l-54.5 54.49 54.48 54.49a8.65 8.65 0 010 12.24z"
	        })
	      )
	    )
	  );
	}
	
	exports.default = ErrorBox;

/***/ },
/* 1134 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _ErrorBox = __webpack_require__(1133);
	
	var _ErrorBox2 = _interopRequireDefault(_ErrorBox);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (_ref) {
	  var title = _ref.title,
	      message = _ref.message;
	  return _react2.default.createElement(
	    'div',
	    { className: 'empty-placeholder-wrapper error' },
	    _react2.default.createElement(_ErrorBox2.default, null),
	    _react2.default.createElement(
	      'h3',
	      null,
	      title || 'An error has occurred.'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      message || 'Please try your search again, and contact support if the problem persists.'
	    )
	  );
	};

/***/ },
/* 1135 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var SUBROUTES = Array.isArray(([{"label":"Business","component":"Business","parameter":"business","myWorkQueueSearch":false,"sourceTypeId":54,"searchMustHaveOneOf":["FILING_TYPE_ID","STATUS_ID","STATE","search"],"serverWebSearchDescription":true,"serverWorkQueueDescription":true,"serverMyRecordsDescription":true,"searchPlaceholder":"Search by name or filing number (X########)","allowEmptySearchTerm":true,"requestCertificateAlternateLabel":"Request Information","fileAmendmentButtonLabel":"Filing Actions","advancedSearchParameters":[{"type":"radio","name":"QUERY_TYPE_ID","defaultValue":1010,"options":[{"value":1010,"label":"Starts with"},{"value":1011,"label":"Contains"},{"value":1012,"label":" Word Contains"}]},{"type":"serverSelect","name":"FILING_TYPE_ID","optionsSrc":"FILING_TYPES","label":"Entity Type","placeholder":"All","defaultValue":"0"},{"type":"serverSelect","name":"FILING_SUBTYPE_ID","optionsSrc":"FILING_SUBTYPES","label":"Entity Subtype","overrideSubOptionsSrcFromParameterName":"FILING_TYPE_ID","placeholder":"All","defaultValue":"0"},{"type":"serverSelect","name":"STATUS_ID","optionsSrc":"FILING_STATUS_WITHOUT_ALL","label":"Status","placeholder":"All","defaultValue":"0"},{"type":"serverSelect","name":"STATE","optionsSrc":"STATE","label":"State","placeholder":"All","defaultValue":""},{"type":"serverSelect","name":"COUNTY","optionsSrc":"COUNTY_SUBOPTION","label":"County","overrideSubOptionsSrcFromParameterName":"STATE","placeholder":"All","defaultValue":""},{"type":"checkbox","name":"CRA_SEARCH_YN","defaultValue":false,"label":"Search by Registered Agent PID"},{"type":"dateRange","name":"FILING_DATE","label":"Registration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}},{"type":"dateRange","name":"EXPIRATION_DATE","label":"Expiration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}}],"myRecordsFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Active"},{"value":2,"label":"Inactive"},{"value":3,"label":"Pending"}]},{"type":"dateRange","name":"DATE_RANGE","label":"Date range","defaultValue":{"start":null,"end":null}}],"myWorkQueueFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Approved"},{"value":2,"label":"Pending Online Payment"},{"value":3,"label":"Pending Review"},{"value":4,"label":"Needs Correction"},{"value":5,"label":"Rejected"},{"value":6,"label":"Draft"}]},{"type":"dateRange","name":"DATE_RANGE","label":"Date range","defaultValue":{"start":null,"end":null}}]},{"label":"Notary","component":"Notary","parameter":"notary","sourceTypeId":850,"myWorkQueueSearch":false,"allowEmptySearchTerm":true,"requestCertificateAlternateLabel":"Download Certificate","fileAmendmentButtonLabel":"Filing Actions","hideNameRequestCertificate":true,"hideAddressRequestCertificate":true,"hideRecordUserManagment":true,"searchPlaceholder":"Search by name or commission number","searchMustHaveOneOf":["CITY","search","SERVICE_TYPE"],"advancedParametersStartOpen":true,"searchIsSortable":true,"advancedSearchParameters":[{"type":"radio","name":"STARTS_WITH_YN","defaultValue":false,"options":[{"value":true,"label":"Starts with"},{"value":false,"label":"Contains"}]},{"type":"checkbox","name":"ACTIVE_ONLY_YN","defaultValue":true,"label":"Active entities only"},{"type":"text","name":"CITY","defaultValue":"","label":"City"},{"type":"select","name":"SERVICE_TYPE","label":"Special Services Offered","defaultValue":0,"options":[{"value":0,"label":"(N/A)"},{"value":6165,"label":"In-Person Electronic Notarization (IPEN)"},{"value":6166,"label":"Remote Online Notarization (RON)"},{"value":6167,"label":"Mobile Notary Services"},{"value":6168,"label":"Remote Ink Notarization (RIN)"}]}]},{"label":"Apostille","component":"Apostille","parameter":"apostille","sourceTypeId":720,"myRecordsSearch":false,"myWorkQueueSearch":false,"disabled":false,"allowedRoutes":["/forms-manager/","/queue/","/forms/"]},{"label":"Liens","component":"UCC","parameter":"ucc","sourceTypeId":1999,"myRecordsSearch":true,"myWorkQueueSearch":true,"fileAmendmentButtonLabel":"Filing Actions","searchPlaceholder":"Search by name or file number","disabled":false,"serverWebSearchDescription":true,"myRecordsDescription":"","workQueueDescription":"","searchDescription":"","hideRecordUserManagment":true,"searchLiensCheckout":false,"advancedSearchParameters":[{"type":"radio","name":"STARTS_WITH_YN","defaultValue":false,"options":[{"value":true,"label":"Starts with"},{"value":false,"label":"Contains"}]},{"type":"select","name":"STATUS","defaultValue":"ALL","label":"Status","options":[{"value":"ACTIVE_UNLAPSED","label":"Active (unlapsed)"},{"value":"ACTIVE_LAPSED_UNLAPSED","label":"Active (lapsed and unlapsed)"}]},{"type":"text","name":"EXCLUDE_VALUES","label":"Exclude Debtor Names (comma separated list of names to exclude)","defaultValue":""},{"type":"dateRange","name":"FILING_DATE","label":"Financing Statement Date","defaultValue":{"start":null,"end":null}},{"type":"dateRange","name":"LAPSE_DATE","label":"Lapse Date","defaultValue":{"start":null,"end":null}},{"type":"text","name":"CITY","label":"Debtor City","defaultValue":""}],"myRecordsFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Approved"},{"value":2,"label":"Pending Online Payment"},{"value":3,"label":"Pending Review"}]},{"type":"select","name":"TYPE","defaultValue":0,"label":"Lien Type","options":[{"value":0,"label":"All"},{"value":1,"label":"UCC"},{"value":2,"label":"EFS"},{"value":3,"label":"Title 71"}]}],"myWorkQueueFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Approved"},{"value":2,"label":"Pending Online Payment"},{"value":3,"label":"Pending Review"},{"value":4,"label":"Pending Print and Mail"},{"value":5,"label":"Rejected"},{"value":6,"label":"Draft"}]},{"type":"select","name":"TYPE","defaultValue":0,"label":"Lien Type","options":[{"value":0,"label":"All"},{"value":1,"label":"UCC"},{"value":2,"label":"EFS"},{"value":3,"label":"Title 71"}]}]},{"label":"Copy Request","component":"copies","parameter":"copies","sourceTypeId":2001,"myRecordsSearch":false,"myWorkQueueSearch":false,"disabled":false,"allowedRoutes":["/forms-manager/","/queue/","/forms/"]},{"label":"Trademark","component":"Trademark","parameter":"trademark","sourceTypeId":810,"showRequestCertificate":true,"searchMustHaveOneOf":["search","EXPIRATION_DATE","FILING_DATE"],"allowEmptySearchTerm":true,"requestCertificateAlternateLabel":"Request Information","fileAmendmentButtonLabel":"Filing Actions","advancedSearchParameters":[{"type":"radio","name":"QUERY_TYPE_ID","defaultValue":1010,"options":[{"value":1010,"label":"Starts with"},{"value":1011,"label":"Contains"},{"value":1012,"label":" Word Contains"}]},{"type":"checkbox","name":"OWNER_SEARCH_YN","defaultValue":false,"label":"Search owners"},{"type":"radio","name":"SERVICE_MARK_YN","label":"Mark Type","defaultValue":"","options":[{"value":"","label":"All Marks"},{"value":"Y","label":"Service Mark"},{"value":"N","label":"Trademark"}]},{"type":"serverSelect","name":"STATUS_ID","optionsSrc":"TYPE_V|TRADEMARK_STATUS_TYPE","label":"Status","placeholder":"All","defaultValue":"0"},{"type":"select","name":"DESIGN_TYPE_ID","options":[{"value":0,"label":"All"},{"value":990,"label":"Words Only"},{"value":991,"label":"Design Only"},{"value":992,"label":"Words and Design"}],"label":"Design Type","defaultValue":"0"},{"type":"dateRange","name":"FILING_DATE","label":"Registered Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}},{"type":"dateRange","name":"EXPIRATION_DATE","label":"Expiration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}}]},{"label":"Business Info Request","component":"InfoRequests","parameter":"info-request","sourceTypeId":167,"allowedRoutes":["/forms-manager/","/queue/","/forms/"]},{"label":"Data Requests","component":"DataRequests","parameter":"data-request","sourceTypeId":0,"allowedRoutes":["/forms-manager/"]},{"label":"CRA","component":"CRA","parameter":"cra","sourceTypeId":157,"myRecordsSearch":false,"searchPlaceholder":"Search by name or registered agent number","allowedRoutes":["/forms-manager/","/forms/","/records/","/queue/","/search/"],"allowEmptySearchTerm":true,"fileAmendmentButtonLabel":"Filing Actions","advancedSearchParameters":[{"type":"radio","name":"QUERY_TYPE_ID","defaultValue":1010,"options":[{"value":1010,"label":"Starts with"},{"value":1011,"label":"Contains"},{"value":1012,"label":" Word Contains"}]},{"type":"dateRange","name":"CRA_DATE","label":"Registration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}},{"type":"select","name":"STATUS_ID","label":"Status","defaultValue":0,"options":[{"value":0,"label":"All"},{"value":121,"label":"Active"},{"value":122,"label":"Inactive"}]},{"type":"select","name":"AGENT_TYPE_ID","label":"Agent Type","defaultValue":0,"options":[{"value":0,"label":"All"},{"value":460,"label":"Registered Agent"},{"value":461,"label":"Commercial Registered Agent"}]}]},{"label":"Farm Bill","component":"FarmBill","parameter":"farm-bill","path":"/lists/farm-bill","sourceTypeId":0,"myRecordsSearch":false,"allowedRules":["/search/"],"disabled":true,"searchDescription":"To perform a search, enter a debtor name. Your search results may include: exact debtor name, variations of that name and any filing that includes your search criteria. Punctuation is ignored.\n\nYou can click on \"Advanced\" to refine your search. Under “Advanced” you can search by crop, year, county and SSN/FEIN. As a registered Farm Bill Buyer with the Montana Secretary of State’s office it is important to maintain the confidentiality of the information contained within the Farm Bill Master List. The Farm Bill Master List reflects personal data, such as Social Security Numbers, which are a key piece of personal identifiable information to assist you in determining the existence of a lien against a specific debtor. The distribution of this information beyond its intended purpose is strictly prohibited.\n\nThe debtor's tax identification number has been hidden for confidentiality reasons. You may continue to search on a tax ID number and return debtors that match your search criteria. The SSN/FEIN must be entered without dashes or spaces.","searchMustHaveOneOf":["search","UCC_FARM_PRODUCT_ID","COUNTY"],"searchPlaceholder":"Search by debtor name","advancedSearchParameters":[{"type":"ServerMultiComplete","label":"Product code name(s)","name":"UCC_FARM_PRODUCT_ID","defaultValue":"","optionsSrc":"UCC_FARM_PRODUCT_V"},{"type":"MultiComplete","label":"Year or Range of Years","name":"YEAR_NUM","optionsSrc":"years","startYear":"1968","defaultValue":[],"preMergeOptions":[{"value":"ALL","label":"All"}]},{"type":"serverSelect","label":"State","name":"STATE","defaultValue":"MONTANA","optionsSrc":"STATE"},{"type":"ServerMultiComplete","label":"County","name":"COUNTY","defaultValue":[],"optionsSrc":"COUNTY","overrideSubOptionsSrcFromParameterName":"STATE"},{"type":"checkbox","name":"TIN_SEARCH_YN","defaultValue":false,"label":"Tax Identification Number Search"},{"type":"checkbox","name":"TIN_SORT_YN","defaultValue":false,"label":"Unique ID Sort"}]}])) ? ([{"label":"Business","component":"Business","parameter":"business","myWorkQueueSearch":false,"sourceTypeId":54,"searchMustHaveOneOf":["FILING_TYPE_ID","STATUS_ID","STATE","search"],"serverWebSearchDescription":true,"serverWorkQueueDescription":true,"serverMyRecordsDescription":true,"searchPlaceholder":"Search by name or filing number (X########)","allowEmptySearchTerm":true,"requestCertificateAlternateLabel":"Request Information","fileAmendmentButtonLabel":"Filing Actions","advancedSearchParameters":[{"type":"radio","name":"QUERY_TYPE_ID","defaultValue":1010,"options":[{"value":1010,"label":"Starts with"},{"value":1011,"label":"Contains"},{"value":1012,"label":" Word Contains"}]},{"type":"serverSelect","name":"FILING_TYPE_ID","optionsSrc":"FILING_TYPES","label":"Entity Type","placeholder":"All","defaultValue":"0"},{"type":"serverSelect","name":"FILING_SUBTYPE_ID","optionsSrc":"FILING_SUBTYPES","label":"Entity Subtype","overrideSubOptionsSrcFromParameterName":"FILING_TYPE_ID","placeholder":"All","defaultValue":"0"},{"type":"serverSelect","name":"STATUS_ID","optionsSrc":"FILING_STATUS_WITHOUT_ALL","label":"Status","placeholder":"All","defaultValue":"0"},{"type":"serverSelect","name":"STATE","optionsSrc":"STATE","label":"State","placeholder":"All","defaultValue":""},{"type":"serverSelect","name":"COUNTY","optionsSrc":"COUNTY_SUBOPTION","label":"County","overrideSubOptionsSrcFromParameterName":"STATE","placeholder":"All","defaultValue":""},{"type":"checkbox","name":"CRA_SEARCH_YN","defaultValue":false,"label":"Search by Registered Agent PID"},{"type":"dateRange","name":"FILING_DATE","label":"Registration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}},{"type":"dateRange","name":"EXPIRATION_DATE","label":"Expiration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}}],"myRecordsFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Active"},{"value":2,"label":"Inactive"},{"value":3,"label":"Pending"}]},{"type":"dateRange","name":"DATE_RANGE","label":"Date range","defaultValue":{"start":null,"end":null}}],"myWorkQueueFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Approved"},{"value":2,"label":"Pending Online Payment"},{"value":3,"label":"Pending Review"},{"value":4,"label":"Needs Correction"},{"value":5,"label":"Rejected"},{"value":6,"label":"Draft"}]},{"type":"dateRange","name":"DATE_RANGE","label":"Date range","defaultValue":{"start":null,"end":null}}]},{"label":"Notary","component":"Notary","parameter":"notary","sourceTypeId":850,"myWorkQueueSearch":false,"allowEmptySearchTerm":true,"requestCertificateAlternateLabel":"Download Certificate","fileAmendmentButtonLabel":"Filing Actions","hideNameRequestCertificate":true,"hideAddressRequestCertificate":true,"hideRecordUserManagment":true,"searchPlaceholder":"Search by name or commission number","searchMustHaveOneOf":["CITY","search","SERVICE_TYPE"],"advancedParametersStartOpen":true,"searchIsSortable":true,"advancedSearchParameters":[{"type":"radio","name":"STARTS_WITH_YN","defaultValue":false,"options":[{"value":true,"label":"Starts with"},{"value":false,"label":"Contains"}]},{"type":"checkbox","name":"ACTIVE_ONLY_YN","defaultValue":true,"label":"Active entities only"},{"type":"text","name":"CITY","defaultValue":"","label":"City"},{"type":"select","name":"SERVICE_TYPE","label":"Special Services Offered","defaultValue":0,"options":[{"value":0,"label":"(N/A)"},{"value":6165,"label":"In-Person Electronic Notarization (IPEN)"},{"value":6166,"label":"Remote Online Notarization (RON)"},{"value":6167,"label":"Mobile Notary Services"},{"value":6168,"label":"Remote Ink Notarization (RIN)"}]}]},{"label":"Apostille","component":"Apostille","parameter":"apostille","sourceTypeId":720,"myRecordsSearch":false,"myWorkQueueSearch":false,"disabled":false,"allowedRoutes":["/forms-manager/","/queue/","/forms/"]},{"label":"Liens","component":"UCC","parameter":"ucc","sourceTypeId":1999,"myRecordsSearch":true,"myWorkQueueSearch":true,"fileAmendmentButtonLabel":"Filing Actions","searchPlaceholder":"Search by name or file number","disabled":false,"serverWebSearchDescription":true,"myRecordsDescription":"","workQueueDescription":"","searchDescription":"","hideRecordUserManagment":true,"searchLiensCheckout":false,"advancedSearchParameters":[{"type":"radio","name":"STARTS_WITH_YN","defaultValue":false,"options":[{"value":true,"label":"Starts with"},{"value":false,"label":"Contains"}]},{"type":"select","name":"STATUS","defaultValue":"ALL","label":"Status","options":[{"value":"ACTIVE_UNLAPSED","label":"Active (unlapsed)"},{"value":"ACTIVE_LAPSED_UNLAPSED","label":"Active (lapsed and unlapsed)"}]},{"type":"text","name":"EXCLUDE_VALUES","label":"Exclude Debtor Names (comma separated list of names to exclude)","defaultValue":""},{"type":"dateRange","name":"FILING_DATE","label":"Financing Statement Date","defaultValue":{"start":null,"end":null}},{"type":"dateRange","name":"LAPSE_DATE","label":"Lapse Date","defaultValue":{"start":null,"end":null}},{"type":"text","name":"CITY","label":"Debtor City","defaultValue":""}],"myRecordsFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Approved"},{"value":2,"label":"Pending Online Payment"},{"value":3,"label":"Pending Review"}]},{"type":"select","name":"TYPE","defaultValue":0,"label":"Lien Type","options":[{"value":0,"label":"All"},{"value":1,"label":"UCC"},{"value":2,"label":"EFS"},{"value":3,"label":"Title 71"}]}],"myWorkQueueFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Approved"},{"value":2,"label":"Pending Online Payment"},{"value":3,"label":"Pending Review"},{"value":4,"label":"Pending Print and Mail"},{"value":5,"label":"Rejected"},{"value":6,"label":"Draft"}]},{"type":"select","name":"TYPE","defaultValue":0,"label":"Lien Type","options":[{"value":0,"label":"All"},{"value":1,"label":"UCC"},{"value":2,"label":"EFS"},{"value":3,"label":"Title 71"}]}]},{"label":"Copy Request","component":"copies","parameter":"copies","sourceTypeId":2001,"myRecordsSearch":false,"myWorkQueueSearch":false,"disabled":false,"allowedRoutes":["/forms-manager/","/queue/","/forms/"]},{"label":"Trademark","component":"Trademark","parameter":"trademark","sourceTypeId":810,"showRequestCertificate":true,"searchMustHaveOneOf":["search","EXPIRATION_DATE","FILING_DATE"],"allowEmptySearchTerm":true,"requestCertificateAlternateLabel":"Request Information","fileAmendmentButtonLabel":"Filing Actions","advancedSearchParameters":[{"type":"radio","name":"QUERY_TYPE_ID","defaultValue":1010,"options":[{"value":1010,"label":"Starts with"},{"value":1011,"label":"Contains"},{"value":1012,"label":" Word Contains"}]},{"type":"checkbox","name":"OWNER_SEARCH_YN","defaultValue":false,"label":"Search owners"},{"type":"radio","name":"SERVICE_MARK_YN","label":"Mark Type","defaultValue":"","options":[{"value":"","label":"All Marks"},{"value":"Y","label":"Service Mark"},{"value":"N","label":"Trademark"}]},{"type":"serverSelect","name":"STATUS_ID","optionsSrc":"TYPE_V|TRADEMARK_STATUS_TYPE","label":"Status","placeholder":"All","defaultValue":"0"},{"type":"select","name":"DESIGN_TYPE_ID","options":[{"value":0,"label":"All"},{"value":990,"label":"Words Only"},{"value":991,"label":"Design Only"},{"value":992,"label":"Words and Design"}],"label":"Design Type","defaultValue":"0"},{"type":"dateRange","name":"FILING_DATE","label":"Registered Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}},{"type":"dateRange","name":"EXPIRATION_DATE","label":"Expiration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}}]},{"label":"Business Info Request","component":"InfoRequests","parameter":"info-request","sourceTypeId":167,"allowedRoutes":["/forms-manager/","/queue/","/forms/"]},{"label":"Data Requests","component":"DataRequests","parameter":"data-request","sourceTypeId":0,"allowedRoutes":["/forms-manager/"]},{"label":"CRA","component":"CRA","parameter":"cra","sourceTypeId":157,"myRecordsSearch":false,"searchPlaceholder":"Search by name or registered agent number","allowedRoutes":["/forms-manager/","/forms/","/records/","/queue/","/search/"],"allowEmptySearchTerm":true,"fileAmendmentButtonLabel":"Filing Actions","advancedSearchParameters":[{"type":"radio","name":"QUERY_TYPE_ID","defaultValue":1010,"options":[{"value":1010,"label":"Starts with"},{"value":1011,"label":"Contains"},{"value":1012,"label":" Word Contains"}]},{"type":"dateRange","name":"CRA_DATE","label":"Registration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}},{"type":"select","name":"STATUS_ID","label":"Status","defaultValue":0,"options":[{"value":0,"label":"All"},{"value":121,"label":"Active"},{"value":122,"label":"Inactive"}]},{"type":"select","name":"AGENT_TYPE_ID","label":"Agent Type","defaultValue":0,"options":[{"value":0,"label":"All"},{"value":460,"label":"Registered Agent"},{"value":461,"label":"Commercial Registered Agent"}]}]},{"label":"Farm Bill","component":"FarmBill","parameter":"farm-bill","path":"/lists/farm-bill","sourceTypeId":0,"myRecordsSearch":false,"allowedRules":["/search/"],"disabled":true,"searchDescription":"To perform a search, enter a debtor name. Your search results may include: exact debtor name, variations of that name and any filing that includes your search criteria. Punctuation is ignored.\n\nYou can click on \"Advanced\" to refine your search. Under “Advanced” you can search by crop, year, county and SSN/FEIN. As a registered Farm Bill Buyer with the Montana Secretary of State’s office it is important to maintain the confidentiality of the information contained within the Farm Bill Master List. The Farm Bill Master List reflects personal data, such as Social Security Numbers, which are a key piece of personal identifiable information to assist you in determining the existence of a lien against a specific debtor. The distribution of this information beyond its intended purpose is strictly prohibited.\n\nThe debtor's tax identification number has been hidden for confidentiality reasons. You may continue to search on a tax ID number and return debtors that match your search criteria. The SSN/FEIN must be entered without dashes or spaces.","searchMustHaveOneOf":["search","UCC_FARM_PRODUCT_ID","COUNTY"],"searchPlaceholder":"Search by debtor name","advancedSearchParameters":[{"type":"ServerMultiComplete","label":"Product code name(s)","name":"UCC_FARM_PRODUCT_ID","defaultValue":"","optionsSrc":"UCC_FARM_PRODUCT_V"},{"type":"MultiComplete","label":"Year or Range of Years","name":"YEAR_NUM","optionsSrc":"years","startYear":"1968","defaultValue":[],"preMergeOptions":[{"value":"ALL","label":"All"}]},{"type":"serverSelect","label":"State","name":"STATE","defaultValue":"MONTANA","optionsSrc":"STATE"},{"type":"ServerMultiComplete","label":"County","name":"COUNTY","defaultValue":[],"optionsSrc":"COUNTY","overrideSubOptionsSrcFromParameterName":"STATE"},{"type":"checkbox","name":"TIN_SEARCH_YN","defaultValue":false,"label":"Tax Identification Number Search"},{"type":"checkbox","name":"TIN_SORT_YN","defaultValue":false,"label":"Unique ID Sort"}]}]) : [];
	
	var initialState = {
	  results: null,
	  templates: {},
	  edges: {},
	  descriptions: {},
	  searching: false,
	  selected: {},
	  selectedDetails: null,
	  sorts: {},
	  resultsMode: "table",
	  recordDetailsLoading: false,
	  userOwnsSelectedRecord: null,
	  selectedRecordHasOwners: null,
	  activeCategory: null,
	  searchValueCache: SUBROUTES.reduce(function (obj, r) {
	    return Object.assign({}, obj, _defineProperty({}, r.parameter, ''));
	  }, {}),
	  searchError: {},
	  stales: SUBROUTES.reduce(function (obj, r) {
	    return Object.assign({}, obj, _defineProperty({}, r.parameter, false));
	  }, {})
	};
	
	var searchReducer = function searchReducer() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	  var action = arguments[1];
	
	  switch (action.type) {
	    case "@@SEARCH_RESET_STATE":
	      return initialState;
	    case "@@SEARCH_SET_RESULTS":
	      return Object.assign({}, state, {
	        results: Object.assign({}, state.results, _defineProperty({}, action.category, action.results.rows)),
	        templates: Object.assign({}, state.templates, _defineProperty({}, action.category, action.results.template)),
	        searchValueCache: Object.assign({}, state.searchValueCache, _defineProperty({}, action.category, action.searchValue)),
	        edges: Object.assign({}, state.edges, _defineProperty({}, action.category, action.results.edge)),
	        stales: Object.assign({}, state.stales, _defineProperty({}, action.category, false))
	      });
	    case "@@SEARCH_SET_ACTIVE_CATEGORY":
	      return Object.assign({}, state, {
	        activeCategory: action.category
	      });
	    case "@@SEARCH_SELECT_ROW":
	      return Object.assign({}, state, { selected: Object.assign({}, state.selected, _defineProperty({}, action.category, state.selected[action.category] !== action.recordId ? action.recordId : null)) });
	    case "@@SEARCH_SET_SELECTED_DETAILS":
	      return Object.assign({}, state, { selectedDetails: action.details });
	    case "@@SEARCH_SET_RESULTS_MODE":
	      return Object.assign({}, state, { resultsMode: action.mode });
	    case "@@SEARCH_TOGGLE_SEARCHING":
	      return Object.assign({}, state, { searching: action.searching });
	    case "@@SEARCH_SET_SELECTED_OWNERSHIP_RECORDS":
	      return Object.assign({}, state, { selectedOwnershipRecords: action.selectedOwnershipRecords });
	    case "@@SEARCH_SET_RECORD_DETAILS_LOADING":
	      return Object.assign({}, state, { recordDetailsLoading: action.loading });
	    case "@@SEARCH_SET_USER_OWNS_SELECTED_RECORD":
	      return Object.assign({}, state, { userOwnsSelectedRecord: action.isOwner });
	    case '@@SEARCH_SET_SELECTED_RECORD_HAS_OWNERS':
	      return Object.assign({}, state, { selectedRecordHasOwners: action.hasOwners });
	    case '@@SEARCH_SET_SORT':
	      return Object.assign({}, state, { sorts: Object.assign({}, state.sorts, _defineProperty({}, action.category, { sortBy: action.sortBy, sortByDirection: action.sortByDirection })) });
	    case '@@SEARCH_SET_DESCRIPTION':
	      return Object.assign({}, state, { descriptions: Object.assign({}, state.descriptions, _defineProperty({}, action.category, action.description)) });
	    case '@@SEARCH_SET_SEARCH_ERROR':
	      {
	        var _ref = state.results || {},
	            deletedResults = _ref[action.category],
	            results = _objectWithoutProperties(_ref, [action.category]);
	
	        var _state$templates = state.templates,
	            deletedTemplates = _state$templates[action.category],
	            templates = _objectWithoutProperties(_state$templates, [action.category]);
	
	        var _state$searchValueCac = state.searchValueCache,
	            deletedSearchValueCache = _state$searchValueCac[action.category],
	            searchValueCache = _objectWithoutProperties(_state$searchValueCac, [action.category]);
	
	        var _state$edges = state.edges,
	            deletedEdges = _state$edges[action.category],
	            edges = _objectWithoutProperties(_state$edges, [action.category]);
	
	        return Object.assign({}, state, {
	          searchError: Object.assign({}, state.searchError, _defineProperty({}, action.category, action.searchError)),
	          results: results,
	          templates: templates,
	          searchValueCache: searchValueCache,
	          edges: edges
	        });
	      }
	    case '@@SEARCH_CLEAR_SEARCH_ERROR':
	      return Object.assign({}, state, { searchError: Object.assign({}, state.searchError, _defineProperty({}, action.category, null)) });
	    case '@@SEARCH_INVALIDATE_CACHE':
	      return Object.assign({}, state, {
	        stales: Object.keys(state.stales).reduce(function (obj, key) {
	          obj[key] = true;
	          return obj;
	        }, {}),
	        selected: {}
	      });
	    default:
	      return state;
	  }
	};
	
	exports.default = searchReducer;

/***/ },
/* 1136 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.FabSubButton = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactTooltip = __webpack_require__(78);
	
	var _reactTooltip2 = _interopRequireDefault(_reactTooltip);
	
	var _shortid = __webpack_require__(22);
	
	var _shortid2 = _interopRequireDefault(_shortid);
	
	var _reactOnclickoutside = __webpack_require__(153);
	
	var _reactOnclickoutside2 = _interopRequireDefault(_reactOnclickoutside);
	
	var _plus = __webpack_require__(337);
	
	var _plus2 = _interopRequireDefault(_plus);
	
	__webpack_require__(1465);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var FabButton = function (_Component) {
	  _inherits(FabButton, _Component);
	
	  function FabButton() {
	    _classCallCheck(this, FabButton);
	
	    var _this = _possibleConstructorReturn(this, (FabButton.__proto__ || Object.getPrototypeOf(FabButton)).call(this));
	
	    _this.onClick = function (e) {
	      if (_this.props.onClick) {
	        _this.props.onClick(e);
	      }
	    };
	
	    _this.handleClickOutside = function (e) {
	      if (_this.state.open) {
	        _this.setState({ open: false });
	      }
	    };
	
	    _this.state = { open: false };
	    return _this;
	  }
	
	  _createClass(FabButton, [{
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _props = this.props,
	          _props$className = _props.className,
	          className = _props$className === undefined ? '' : _props$className,
	          ariaLabel = _props.ariaLabel,
	          tooltip = _props.tooltip,
	          _props$tooltipPlaceme = _props.tooltipPlacement,
	          tooltipPlacement = _props$tooltipPlaceme === undefined ? 'left' : _props$tooltipPlaceme,
	          mainButton = _props.mainButton,
	          children = _props.children;
	      var open = this.state.open;
	
	      var id = _shortid2.default.generate();
	      var subButtons = _react2.default.Children.toArray(children);
	      return _react2.default.createElement(
	        'div',
	        {
	          className: 'fab-button',
	          onClick: function onClick() {
	            _this2.setState({ open: !open });
	          }
	        },
	        _react2.default.createElement(
	          'button',
	          {
	            className: 'main ' + className + (open ? ' open ' : ' '),
	            onClick: this.onClick,
	            'data-tip': tooltip,
	            'data-for': id,
	            'aria-label': ariaLabel || tooltip
	          },
	          mainButton ? mainButton : _react2.default.createElement(_plus2.default, null),
	          _react2.default.createElement(_reactTooltip2.default, { effect: 'solid', place: tooltipPlacement, id: id })
	        ),
	        subButtons.map(function (button, i) {
	          return _react2.default.createElement(
	            'div',
	            { className: 'sub-wrapper', key: i },
	            _react2.default.cloneElement(button, {
	              tabIndex: open ? 0 : -1,
	              style: Object.assign({}, button.props.style, {
	                transform: 'translateY(-' + (open ? (i + 1) * 50 + 12 : 10) + 'px)',
	                transitionDelay: open ? (subButtons.length - i - 1) * 100 + 'ms' : '',
	                opacity: open ? 1 : 0
	              })
	            })
	          );
	        })
	      );
	    }
	  }]);
	
	  return FabButton;
	}(_react.Component);
	
	exports.default = (0, _reactOnclickoutside2.default)(FabButton);
	
	var FabSubButton = exports.FabSubButton = function (_Component2) {
	  _inherits(FabSubButton, _Component2);
	
	  function FabSubButton() {
	    var _ref;
	
	    var _temp, _this3, _ret;
	
	    _classCallCheck(this, FabSubButton);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this3 = _possibleConstructorReturn(this, (_ref = FabSubButton.__proto__ || Object.getPrototypeOf(FabSubButton)).call.apply(_ref, [this].concat(args))), _this3), _this3.onClick = function (e) {
	      if (_this3.props.onClick) {
	        _this3.props.onClick(e);
	      }
	    }, _temp), _possibleConstructorReturn(_this3, _ret);
	  }
	
	  _createClass(FabSubButton, [{
	    key: 'render',
	    value: function render() {
	      var _props2 = this.props,
	          _props2$className = _props2.className,
	          className = _props2$className === undefined ? '' : _props2$className,
	          children = _props2.children,
	          style = _props2.style,
	          _props2$tooltip = _props2.tooltip,
	          tooltip = _props2$tooltip === undefined ? '' : _props2$tooltip,
	          _props2$tooltipPlacem = _props2.tooltipPlacement,
	          tooltipPlacement = _props2$tooltipPlacem === undefined ? 'left' : _props2$tooltipPlacem,
	          tabIndex = _props2.tabIndex;
	
	      var id = _shortid2.default.generate();
	      return _react2.default.createElement(
	        'button',
	        {
	          className: 'sub ' + className,
	          style: style,
	          'data-for': id,
	          'data-tip': tooltip,
	          onClick: this.onClick,
	          'aria-label': tooltip,
	          tabIndex: tabIndex
	        },
	        children,
	        tooltip !== '' ? _react2.default.createElement(_reactTooltip2.default, { effect: 'solid', place: tooltipPlacement, id: id }) : null
	      );
	    }
	  }]);
	
	  return FabSubButton;
	}(_react.Component);

/***/ },
/* 1137 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(7);
	
	var _Portal = __webpack_require__(12);
	
	var _Portal2 = _interopRequireDefault(_Portal);
	
	var _store = __webpack_require__(18);
	
	var _AuthActions = __webpack_require__(66);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	////////////////////////
	////////////////////////////////////////////////////
	///////////////////////////////////////////
	//////////
	
	var AuthTimer = function (_React$Component) {
	  _inherits(AuthTimer, _React$Component);
	
	  function AuthTimer() {
	    _classCallCheck(this, AuthTimer);
	
	    return _possibleConstructorReturn(this, (AuthTimer.__proto__ || Object.getPrototypeOf(AuthTimer)).apply(this, arguments));
	  }
	
	  _createClass(AuthTimer, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          modalShown = _props.modalShown,
	          expires = _props.expires;
	
	      return _react2.default.createElement(
	        _Portal2.default,
	        { isOpened: modalShown },
	        modalShown ? _react2.default.createElement(
	          'div',
	          { className: 'auth-timer animated fadeIn fast-animation' },
	          _react2.default.createElement(Timer, { initialTime: expires })
	        ) : _react2.default.createElement('div', null)
	      );
	    }
	  }]);
	
	  return AuthTimer;
	}(_react2.default.Component);
	
	exports.default = (0, _reactRedux.connect)(function (state) {
	  return {
	    modalShown: state.auth.expires ? state.auth.expires <= 30 : false,
	    expires: state.auth.expires
	  };
	})(AuthTimer);
	
	var Timer = function (_React$Component2) {
	  _inherits(Timer, _React$Component2);
	
	  function Timer(props) {
	    _classCallCheck(this, Timer);
	
	    var _this2 = _possibleConstructorReturn(this, (Timer.__proto__ || Object.getPrototypeOf(Timer)).call(this, props));
	
	    _this2.componentDidMount = function () {
	      _this2.interval = window.setInterval(_this2.decrement, 1000);
	      (0, _AuthActions.attachEventCheck)();
	      // window.addEventListener('mousemove', this.extendSession)
	    };
	
	    _this2.componentWillUnmount = function () {
	      _this2.mounted = false;
	      window.clearInterval(_this2.interval);
	      // window.removeEventListener('mousemove', this.extendSession)
	      (0, _AuthActions.detachEventCheck)();
	    };
	
	    _this2.decrement = function () {
	      if (_this2.state.time > 0 && _this2.mounted) {
	        _this2.setState(function (state) {
	          return {
	            time: state.time - 1
	          };
	        });
	      } else if (!_this2.mounted) {
	        window.clearInterval(_this2.interval);
	      } else {
	        window.clearInterval(_this2.interval);
	        _this2.props.setExpiration(null);
	        (0, _AuthActions.detachEventCheck)();
	        if (false) {
	          _store.history.push('/');
	        }
	        (0, _AuthActions.clearLocalUser)(true);
	////////////////////////////////
	///////////////////////////////
	//////////////////
	      }
	    };
	
	    _this2.extendSession = function () {
	      _this2.mounted = false;
	      // window.removeEventListener('mousemove', this.extendSession)
	      _this2.props.extendUserSession(false);
	    };
	
	    _this2.state = { time: props.initialTime };
	    _this2.mounted = true;
	    return _this2;
	  }
	
	  _createClass(Timer, [{
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'div',
	        { className: 'timer' },
	        _react2.default.createElement(
	          'h4',
	          null,
	          'Your session will expire in:'
	        ),
	        _react2.default.createElement(
	          'span',
	          null,
	          this.state.time
	        )
	      );
	    }
	  }]);
	
	  return Timer;
	}(_react2.default.Component);
	
	Timer = (0, _reactRedux.connect)(null, { extendUserSession: _AuthActions.extendUserSession, setExpiration: _AuthActions.setExpiration })(Timer);

/***/ },
/* 1138 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouterDom = __webpack_require__(30);
	
	var _Shell = __webpack_require__(19);
	
	var _CreateAccount = __webpack_require__(149);
	
	var _utilities = __webpack_require__(8);
	
	var _requests = __webpack_require__(6);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ChangePassword = function (_React$Component) {
	  _inherits(ChangePassword, _React$Component);
	
	  function ChangePassword() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, ChangePassword);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = ChangePassword.__proto__ || Object.getPrototypeOf(ChangePassword)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      errors: {},
	      token: null,
	      tokenExpired: false,
	      parsing: true,
	      username: ""
	    }, _this.componentDidMount = function () {
	      var search = _this.props.location.search;
	
	      var _parseUrlQuery = (0, _utilities.parseUrlQuery)(search),
	          token = _parseUrlQuery.token;
	
	      if (!token) {
	        _this.props.history.replace("/auth");
	      } else {
	        _this.setState({ token: token });
	        _this.parseToken(token);
	      }
	    }, _this.validate = function () {
	      var password = _this.password.value;
	      var confirmPassword = _this.confirmPassword.value;
	      var errors = {};
	      if (!password) {
	        errors.password = "A password is required";
	      } else if (password.length < 8) {
	        errors.password = ("The password must meet all requirements") || "Password must be at least 8 characters";
	      }
	      if (password !== confirmPassword) {
	        errors.confirmPassword = "Passwords must match";
	      }
	      if (Object.keys(errors).length > 0 && _this.state.token !== null) {
	        _this.setState({ errors: errors });
	      } else {
	        _this.setState({ errors: {} });
	        _this.changePassword(password);
	      }
	    }, _this.parseToken = function (token) {
	      (0, _requests.PARSE_PASSWORD_RESET_TOKEN)(token, function (_ref2) {
	        var username = _ref2.username,
	            expired = _ref2.expired;
	
	        _this.setState({ username: username, parsing: false });
	      }, function (err) {
	        console.error(err);
	        if (err.code === "auth/resetTokenExpired") {
	          _this.setState({
	            token: null,
	            tokenExpired: true,
	            parsing: false
	          });
	        } else {
	          _this.setGenericGlobalError();
	        }
	      });
	    }, _this.changePassword = function (password) {
	      (0, _requests.CHANGE_PASSWORD)({ token: _this.state.token, password: password }, function () {
	        _this.props.history.replace('/auth?changed=true');
	      }, function (err) {
	        console.error(err);
	        if (err.code === "auth/passwordRequirementsNotMet") {
	          _this.setState(function (state) {
	            return {
	              errors: Object.assign({}, state.errors, {
	                submit: err.message
	              })
	            };
	          });
	        } else {
	          _this.setGenericGlobalError();
	        }
	      });
	    }, _this.setGenericGlobalError = function () {
	      _this.setState(function (state) {
	        return {
	          errors: Object.assign({}, state.errors, {
	            submit: "Oops, something went wrong. You can try submitting again later. If the problem persists please contact customer support."
	          })
	        };
	      });
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(ChangePassword, [{
	    key: "render",
	    value: function render() {
	      var _this2 = this;
	
	      return _react2.default.createElement(
	        _Shell.Body,
	        { className: "login-redirector" },
	        !this.state.parsing && _react2.default.createElement(
	          "div",
	          {
	            className: "admin-login-wrapper login-modal-new animated fadeInDown fast-animation"
	          },
	          _react2.default.createElement(
	            "div",
	            { className: "login-column", style: { paddingTop: 95 } },
	            _react2.default.createElement(
	              "div",
	              { className: "banner" },
	              "Change Password"
	            ),
	            this.state.tokenExpired ? _react2.default.createElement(
	              _CreateAccount.FieldError,
	              null,
	              "This password link has expired, you can",
	              " ",
	              _react2.default.createElement(
	                _reactRouterDom.Link,
	                { to: "/auth?page=forgot" },
	                "request a new one"
	              ),
	              ", or",
	              " ",
	              _react2.default.createElement(
	                _reactRouterDom.Link,
	                { to: "/auth" },
	                "login here"
	              ),
	              "."
	            ) : _react2.default.createElement(
	              "form",
	              { className: "login forgot-password" },
	              _react2.default.createElement(
	                "p",
	                { className: "description" },
	                "Please pick a new password for the account associated with",
	                _react2.default.createElement(
	                  "strong",
	                  null,
	                  " " + this.state.username
	                ),
	                "."
	              ),
	              _react2.default.createElement(
	                "div",
	                { className: "field" },
	                _react2.default.createElement(
	                  "label",
	                  null,
	                  "New Password"
	                ),
	                _react2.default.createElement(
	                  "p",
	                  { className: "description" },
	                   true ? _react2.default.createElement("span", { dangerouslySetInnerHTML: { __html: ("\n    <ul>\n      <li>MUST contain at least 8 characters (12+ recommended)</li>\n      <li>MUST contain at least one uppercase letter.</li>\n      <li>MUST contain at least one lowercase letter.</li>\n      <li>MUST contain at least one number.</li>\n      <li>MUST contain at least one special character (!”#$%&'()*+,-./:;<=>?</li>\n    </ul>\n  ") } }) : 'Password must be at least 8 characters'
	                ),
	                _react2.default.createElement("input", {
	                  type: "password",
	                  ref: function ref(_ref3) {
	                    _this2.password = _ref3;
	                  },
	                  onKeyDown: this.checkEnter,
	                  placeholder: ""
	                }),
	                _react2.default.createElement(
	                  _CreateAccount.FieldError,
	                  null,
	                  this.state.errors.password
	                )
	              ),
	              _react2.default.createElement(
	                "div",
	                { className: "field" },
	                _react2.default.createElement(
	                  "label",
	                  null,
	                  "Confirm New Password"
	                ),
	                _react2.default.createElement("input", {
	                  type: "password",
	                  ref: function ref(_ref4) {
	                    _this2.confirmPassword = _ref4;
	                  },
	                  onKeyDown: this.checkEnter,
	                  placeholder: ""
	                }),
	                _react2.default.createElement(
	                  _CreateAccount.FieldError,
	                  null,
	                  this.state.errors.confirmPassword
	                )
	              ),
	              _react2.default.createElement(
	                "div",
	                { className: "button-wrapper create-wrapper" },
	                _react2.default.createElement(
	                  "button",
	                  {
	                    type: "button",
	                    className: "btn-raised btn-light-primary submit",
	                    onClick: this.validate
	                  },
	                  "SAVE CHANGES"
	                ),
	                _react2.default.createElement(
	                  _CreateAccount.FieldError,
	                  null,
	                  this.state.errors.submit
	                )
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return ChangePassword;
	}(_react2.default.Component);
	
	exports.default = ChangePassword;

/***/ },
/* 1139 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _CreateAccount = __webpack_require__(149);
	
	var _requests = __webpack_require__(6);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ForgotPasswordForm = function (_React$Component) {
	    _inherits(ForgotPasswordForm, _React$Component);
	
	    function ForgotPasswordForm() {
	        var _ref;
	
	        var _temp, _this, _ret;
	
	        _classCallCheck(this, ForgotPasswordForm);
	
	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	            args[_key] = arguments[_key];
	        }
	
	        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = ForgotPasswordForm.__proto__ || Object.getPrototypeOf(ForgotPasswordForm)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	            errors: {},
	            emailValidationAttempts: 0
	        }, _this.sendPasswordEmail = function () {
	            var emailValidationAttempts = _this.state.emailValidationAttempts;
	
	
	            if (({"NODE_ENV":"production","BUILD_DATE":"2025-08-27T15:15:31.687Z","BUILD_NUMBER":"Not Provided","GIT_VERSION":"v1.3.0-381-ga81e29b08","GIT_COMMIT_HASH":"a81e29b085c9268ffd96c78eb734365802722741","GIT_BRANCH":"beta","PUBLIC_URL":"","STATE_ABBR":"MT","STATE_NAME":"Montana","STATE_ORG_TITLE":"Secretary of State","LOGIN_HEADER_IMG_PATH":"","HOME_IMG_FILENAME":"montana.jpg","FAVICON_FILE_NAME":"favicon.ico","ALLOW_E_SIGN_ON_CORRECTIONS":true,"THIRD_PARTY_SIGNING_ALLOWED":false,"MY_ACCOUNT_SAVE_AND_CLOSE_BUTTON":true,"IE_DEPRECATED_MESSAGE":"Internet Explorer is not supported. Please select a supported browser below to access this website.","ADDITIONAL_ROUTES":{"dataRequests":true,"farmBill":true,"apostille":true,"externalHelp":"https://sosmt.gov/business/help-center/","systemAdministration":[{"title":"Saved Payments","parameter":"saved-payments","componentName":"SavedPayments"}]},"SUBROUTES":[{"label":"Business","component":"Business","parameter":"business","myWorkQueueSearch":false,"sourceTypeId":54,"searchMustHaveOneOf":["FILING_TYPE_ID","STATUS_ID","STATE","search"],"serverWebSearchDescription":true,"serverWorkQueueDescription":true,"serverMyRecordsDescription":true,"searchPlaceholder":"Search by name or filing number (X########)","allowEmptySearchTerm":true,"requestCertificateAlternateLabel":"Request Information","fileAmendmentButtonLabel":"Filing Actions","advancedSearchParameters":[{"type":"radio","name":"QUERY_TYPE_ID","defaultValue":1010,"options":[{"value":1010,"label":"Starts with"},{"value":1011,"label":"Contains"},{"value":1012,"label":" Word Contains"}]},{"type":"serverSelect","name":"FILING_TYPE_ID","optionsSrc":"FILING_TYPES","label":"Entity Type","placeholder":"All","defaultValue":"0"},{"type":"serverSelect","name":"FILING_SUBTYPE_ID","optionsSrc":"FILING_SUBTYPES","label":"Entity Subtype","overrideSubOptionsSrcFromParameterName":"FILING_TYPE_ID","placeholder":"All","defaultValue":"0"},{"type":"serverSelect","name":"STATUS_ID","optionsSrc":"FILING_STATUS_WITHOUT_ALL","label":"Status","placeholder":"All","defaultValue":"0"},{"type":"serverSelect","name":"STATE","optionsSrc":"STATE","label":"State","placeholder":"All","defaultValue":""},{"type":"serverSelect","name":"COUNTY","optionsSrc":"COUNTY_SUBOPTION","label":"County","overrideSubOptionsSrcFromParameterName":"STATE","placeholder":"All","defaultValue":""},{"type":"checkbox","name":"CRA_SEARCH_YN","defaultValue":false,"label":"Search by Registered Agent PID"},{"type":"dateRange","name":"FILING_DATE","label":"Registration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}},{"type":"dateRange","name":"EXPIRATION_DATE","label":"Expiration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}}],"myRecordsFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Active"},{"value":2,"label":"Inactive"},{"value":3,"label":"Pending"}]},{"type":"dateRange","name":"DATE_RANGE","label":"Date range","defaultValue":{"start":null,"end":null}}],"myWorkQueueFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Approved"},{"value":2,"label":"Pending Online Payment"},{"value":3,"label":"Pending Review"},{"value":4,"label":"Needs Correction"},{"value":5,"label":"Rejected"},{"value":6,"label":"Draft"}]},{"type":"dateRange","name":"DATE_RANGE","label":"Date range","defaultValue":{"start":null,"end":null}}]},{"label":"Notary","component":"Notary","parameter":"notary","sourceTypeId":850,"myWorkQueueSearch":false,"allowEmptySearchTerm":true,"requestCertificateAlternateLabel":"Download Certificate","fileAmendmentButtonLabel":"Filing Actions","hideNameRequestCertificate":true,"hideAddressRequestCertificate":true,"hideRecordUserManagment":true,"searchPlaceholder":"Search by name or commission number","searchMustHaveOneOf":["CITY","search","SERVICE_TYPE"],"advancedParametersStartOpen":true,"searchIsSortable":true,"advancedSearchParameters":[{"type":"radio","name":"STARTS_WITH_YN","defaultValue":false,"options":[{"value":true,"label":"Starts with"},{"value":false,"label":"Contains"}]},{"type":"checkbox","name":"ACTIVE_ONLY_YN","defaultValue":true,"label":"Active entities only"},{"type":"text","name":"CITY","defaultValue":"","label":"City"},{"type":"select","name":"SERVICE_TYPE","label":"Special Services Offered","defaultValue":0,"options":[{"value":0,"label":"(N/A)"},{"value":6165,"label":"In-Person Electronic Notarization (IPEN)"},{"value":6166,"label":"Remote Online Notarization (RON)"},{"value":6167,"label":"Mobile Notary Services"},{"value":6168,"label":"Remote Ink Notarization (RIN)"}]}]},{"label":"Apostille","component":"Apostille","parameter":"apostille","sourceTypeId":720,"myRecordsSearch":false,"myWorkQueueSearch":false,"disabled":false,"allowedRoutes":["/forms-manager/","/queue/","/forms/"]},{"label":"Liens","component":"UCC","parameter":"ucc","sourceTypeId":1999,"myRecordsSearch":true,"myWorkQueueSearch":true,"fileAmendmentButtonLabel":"Filing Actions","searchPlaceholder":"Search by name or file number","disabled":false,"serverWebSearchDescription":true,"myRecordsDescription":"","workQueueDescription":"","searchDescription":"","hideRecordUserManagment":true,"searchLiensCheckout":false,"advancedSearchParameters":[{"type":"radio","name":"STARTS_WITH_YN","defaultValue":false,"options":[{"value":true,"label":"Starts with"},{"value":false,"label":"Contains"}]},{"type":"select","name":"STATUS","defaultValue":"ALL","label":"Status","options":[{"value":"ACTIVE_UNLAPSED","label":"Active (unlapsed)"},{"value":"ACTIVE_LAPSED_UNLAPSED","label":"Active (lapsed and unlapsed)"}]},{"type":"text","name":"EXCLUDE_VALUES","label":"Exclude Debtor Names (comma separated list of names to exclude)","defaultValue":""},{"type":"dateRange","name":"FILING_DATE","label":"Financing Statement Date","defaultValue":{"start":null,"end":null}},{"type":"dateRange","name":"LAPSE_DATE","label":"Lapse Date","defaultValue":{"start":null,"end":null}},{"type":"text","name":"CITY","label":"Debtor City","defaultValue":""}],"myRecordsFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Approved"},{"value":2,"label":"Pending Online Payment"},{"value":3,"label":"Pending Review"}]},{"type":"select","name":"TYPE","defaultValue":0,"label":"Lien Type","options":[{"value":0,"label":"All"},{"value":1,"label":"UCC"},{"value":2,"label":"EFS"},{"value":3,"label":"Title 71"}]}],"myWorkQueueFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Approved"},{"value":2,"label":"Pending Online Payment"},{"value":3,"label":"Pending Review"},{"value":4,"label":"Pending Print and Mail"},{"value":5,"label":"Rejected"},{"value":6,"label":"Draft"}]},{"type":"select","name":"TYPE","defaultValue":0,"label":"Lien Type","options":[{"value":0,"label":"All"},{"value":1,"label":"UCC"},{"value":2,"label":"EFS"},{"value":3,"label":"Title 71"}]}]},{"label":"Copy Request","component":"copies","parameter":"copies","sourceTypeId":2001,"myRecordsSearch":false,"myWorkQueueSearch":false,"disabled":false,"allowedRoutes":["/forms-manager/","/queue/","/forms/"]},{"label":"Trademark","component":"Trademark","parameter":"trademark","sourceTypeId":810,"showRequestCertificate":true,"searchMustHaveOneOf":["search","EXPIRATION_DATE","FILING_DATE"],"allowEmptySearchTerm":true,"requestCertificateAlternateLabel":"Request Information","fileAmendmentButtonLabel":"Filing Actions","advancedSearchParameters":[{"type":"radio","name":"QUERY_TYPE_ID","defaultValue":1010,"options":[{"value":1010,"label":"Starts with"},{"value":1011,"label":"Contains"},{"value":1012,"label":" Word Contains"}]},{"type":"checkbox","name":"OWNER_SEARCH_YN","defaultValue":false,"label":"Search owners"},{"type":"radio","name":"SERVICE_MARK_YN","label":"Mark Type","defaultValue":"","options":[{"value":"","label":"All Marks"},{"value":"Y","label":"Service Mark"},{"value":"N","label":"Trademark"}]},{"type":"serverSelect","name":"STATUS_ID","optionsSrc":"TYPE_V|TRADEMARK_STATUS_TYPE","label":"Status","placeholder":"All","defaultValue":"0"},{"type":"select","name":"DESIGN_TYPE_ID","options":[{"value":0,"label":"All"},{"value":990,"label":"Words Only"},{"value":991,"label":"Design Only"},{"value":992,"label":"Words and Design"}],"label":"Design Type","defaultValue":"0"},{"type":"dateRange","name":"FILING_DATE","label":"Registered Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}},{"type":"dateRange","name":"EXPIRATION_DATE","label":"Expiration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}}]},{"label":"Business Info Request","component":"InfoRequests","parameter":"info-request","sourceTypeId":167,"allowedRoutes":["/forms-manager/","/queue/","/forms/"]},{"label":"Data Requests","component":"DataRequests","parameter":"data-request","sourceTypeId":0,"allowedRoutes":["/forms-manager/"]},{"label":"CRA","component":"CRA","parameter":"cra","sourceTypeId":157,"myRecordsSearch":false,"searchPlaceholder":"Search by name or registered agent number","allowedRoutes":["/forms-manager/","/forms/","/records/","/queue/","/search/"],"allowEmptySearchTerm":true,"fileAmendmentButtonLabel":"Filing Actions","advancedSearchParameters":[{"type":"radio","name":"QUERY_TYPE_ID","defaultValue":1010,"options":[{"value":1010,"label":"Starts with"},{"value":1011,"label":"Contains"},{"value":1012,"label":" Word Contains"}]},{"type":"dateRange","name":"CRA_DATE","label":"Registration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}},{"type":"select","name":"STATUS_ID","label":"Status","defaultValue":0,"options":[{"value":0,"label":"All"},{"value":121,"label":"Active"},{"value":122,"label":"Inactive"}]},{"type":"select","name":"AGENT_TYPE_ID","label":"Agent Type","defaultValue":0,"options":[{"value":0,"label":"All"},{"value":460,"label":"Registered Agent"},{"value":461,"label":"Commercial Registered Agent"}]}]},{"label":"Farm Bill","component":"FarmBill","parameter":"farm-bill","path":"/lists/farm-bill","sourceTypeId":0,"myRecordsSearch":false,"allowedRules":["/search/"],"disabled":true,"searchDescription":"To perform a search, enter a debtor name. Your search results may include: exact debtor name, variations of that name and any filing that includes your search criteria. Punctuation is ignored.\n\nYou can click on \"Advanced\" to refine your search. Under “Advanced” you can search by crop, year, county and SSN/FEIN. As a registered Farm Bill Buyer with the Montana Secretary of State’s office it is important to maintain the confidentiality of the information contained within the Farm Bill Master List. The Farm Bill Master List reflects personal data, such as Social Security Numbers, which are a key piece of personal identifiable information to assist you in determining the existence of a lien against a specific debtor. The distribution of this information beyond its intended purpose is strictly prohibited.\n\nThe debtor's tax identification number has been hidden for confidentiality reasons. You may continue to search on a tax ID number and return debtors that match your search criteria. The SSN/FEIN must be entered without dashes or spaces.","searchMustHaveOneOf":["search","UCC_FARM_PRODUCT_ID","COUNTY"],"searchPlaceholder":"Search by debtor name","advancedSearchParameters":[{"type":"ServerMultiComplete","label":"Product code name(s)","name":"UCC_FARM_PRODUCT_ID","defaultValue":"","optionsSrc":"UCC_FARM_PRODUCT_V"},{"type":"MultiComplete","label":"Year or Range of Years","name":"YEAR_NUM","optionsSrc":"years","startYear":"1968","defaultValue":[],"preMergeOptions":[{"value":"ALL","label":"All"}]},{"type":"serverSelect","label":"State","name":"STATE","defaultValue":"MONTANA","optionsSrc":"STATE"},{"type":"ServerMultiComplete","label":"County","name":"COUNTY","defaultValue":[],"optionsSrc":"COUNTY","overrideSubOptionsSrcFromParameterName":"STATE"},{"type":"checkbox","name":"TIN_SEARCH_YN","defaultValue":false,"label":"Tax Identification Number Search"},{"type":"checkbox","name":"TIN_SORT_YN","defaultValue":false,"label":"Unique ID Sort"}]}],"SYSTEM_NICKNAME":"Online Services Portal","PAYMENT_METHODS":[{"type":"bypass"},{"type":"iTransact"}],"PAYMENT_ALLOW_AMEX":true,"SYSTEM_ID_LABEL":"System Id","DOUBLE_COLUMN_PUBLIC_LOGIN":true,"INTERNAL_USER_MANAGEMENT":true,"ALLOW_PUBLIC_JSON_IMPORT":false,"MAX_FILE_UPLOAD_SIZE":10000000,"REFUND_TEXT":"","RETURN_TO_HOME_ON_LOGOUT":true,"CURRENT_SOS_NAME":"Christi Jacobsen","LOGO_FILENAME":"mt-sos-logo.png","LOGO_ALT":"Christi Jacobsen, Montana Secretary of State","LOGO_FULL_WIDTH":true,"HOME_HIDE_AUTH_HINT":true,"HOME_TITLE":"Montana Secretary of State","CUSTOM_TAB_TITLE":"Official Montana","HOME_SUBTITLE":"Online Business Services","ENTITY_NAME_CONSENT_DESCRIPTION":"","ALLOW_USER_PROFILE_EDITING":true,"COMPARE_FOREIGN_NAME_IN_ENTITY_NAME_VALIDATION":true,"FOREIGN_NAME_FIELD_NAME":"KIMA_PARENT_NAME_INFO","LOGIN_TITLE":"Montana Secretary of State Online Filing Portal Login","PUBLIC_LOGIN_LABEL":"Username","REVERSE_LOGIN_COLUMNS":true,"LOGIN_SEAL_FILENAME":"seal_white.png","SEPARATE_USERNAME_AND_EMAIL":true,"CREATE_ACCOUNT_BUTTON_ALIGN_LEFT":true,"CREATE_ACCOUNT_BUTTON_TEXT":"CREATE AN ACCOUNT","PASSWORD_CUSTOM_ERROR_TEXT":"The password must meet all requirements","ACCOUNT_CREATED_MESSAGE":"Please check your email to verify your account to login and allow a few minutes for this message to arrive. Check your junk/spam folders if you do not find the email in your inbox.","PUBLIC_LOGIN_PLACEHOLDER":" ","DISABLE_DEFAULT_PAYMENT_RADIO":true,"CUSTOM_RESET_PASSWORD_ERROR_MESSAGE":"Username invalid - no account found","PUBLIC_LOGIN_CREATE_DESCRIPTION":"### Existing User:\n\n  - Enter your username and password to login.  \n\n\n  #### - OR -  \n\n\n\n  - Forgot password? Click 'Reset Password' and follow the prompts.\n  - Forgot username? Click 'Forgot Username' and follow the prompts.  \n\n\n  ### New User:\n  ","LOGIN_HELP_LINK":"https://sosmt.gov/business/how-do-i/","LOGIN_HELP_LINK_TEXT":"Need Help?","FORGOT_USERNAME_TEXT":"Forgot Username?","LOGIN_ACTIVE_DIRECTORY_TEXT":"State User Login","MULTIPLE_LOGIN_METHODS":true,"HAS_ACTIVE_DIRECTORY_LOGIN":true,"RESET_PASSWORD_WITH_USERNAME":true,"DOWNLOAD_LINK":true,"SHOW_USERNAME_ACCOUNT_CREATE":true,"SHOW_SCROLL_DOWN_ARROW":true,"SHOW_ADDRESS_ACCOUNT_CREATE":true,"TWO_COLUMN_ACCOUNT_CREATE":true,"RESET_PASSWORD_TIP":"A link to change your password has been sent to your email. Please allow a few minutes for this message to arrive. Please check your junk/spam folders if you do not find the email in your inbox.","FORGOT_PASSWORD_LINK_TEXT":"Reset Password","PHONE_NUMBER_OPTIONAL_ACCOUNT_CREATE":true,"SHOW_REQUIRED_INDICATOR_ACCOUNT_CREATE":true,"PASSWORD_REQUIREMENTS_ACCOUNT_CREATE":"\n    <ul>\n      <li>MUST contain at least 8 characters (12+ recommended)</li>\n      <li>MUST contain at least one uppercase letter.</li>\n      <li>MUST contain at least one lowercase letter.</li>\n      <li>MUST contain at least one number.</li>\n      <li>MUST contain at least one special character (!”#$%&'()*+,-./:;<=>?</li>\n    </ul>\n  ","ALLOW_CERTIFICATION_REQUEST":true,"ALLOW_PUBLIC_CERTIFICATE_REQUEST":true,"ALLOW_COPY_REQUEST":false,"ALLOW_CORRECTION_STYLING":true,"HIDE_DEPRECATION_WARNING":false,"AMEND_ROUTE_PUBLIC":true,"SEAL_FILENAME":"seal.png","SHOPPING_CART":true,"ALLOW_PAYMENT_UPDATE_WITH_EMPTY_CART":true,"RA_EMAIL":true,"RA_WEBSITE":true,"RA_NO_DEFAULT_TYPE":true,"RA_ADDRESS_LABEL":"Street Address","RA_TYPE_SELECTION_DEFAULT":true,"RA_DEFAULT_TYPE":"460","RA_OVERRIDE_TYPE_WITH_DEFAULT":true,"RA_PRINCIPAL_ADDRESS_AMS":true,"UPLOAD_AND_SUBMIT_HIDE_IF_ONE_OPTION":true,"PAYMENT_PROCESSING_MESSAGE":"Your payment is processing - Do not close your browser or click the back button","CHECKOUT_BUTTON_WHEN_PROCESSING_TEXT":"Processing","EFS_CROP_PICKER_NONE_LABEL":"Lien Duration","DISALLOWED_WIZARD_PIECES":["FormationLocale"],"REPEATER_SHOW_EDIT_BUTTON":true,"DATA_REQUEST_PAGE_TITLE":"Data Requests and Subscriptions","DATA_REQUEST_SIDEBAR_LABEL":"Data Requests & Subscriptions","LOGIN_REDIRECTS_TO_EPASS":false,"LOGIN_REDIRECTS_TO_ACTIVE_DIRECTORY":true,"LOGIN_ACTIVE_DIRECTORY_LINK":true,"FETCH_EDIT_USER_LINK":false,"LISTS_FETCH_AVAILABLE_LISTS":true,"POST_WIZARD_SUBMIT_REDIRECT_URL":"/","PIN_REQUEST_ATTESTATIONS":true,"PIN_REQUEST_DESCRIPTION":"Click **Request PIN** to have a new PIN sent to the account holder's email address on file.","OWNERSHIP_REQUEST_DESCRIPTION":"To become an **authorized user** of this record, a current **AUTHORIZED USER** will need to grant you access. To request access, click **Request Access** below.","PIN_REQUEST_SUCCESS_MESSAGE":"The PIN you have requested for this entity has been sent to the email associated with your user account.  You should receive the PIN in approximately 3-5 minutes, depending on your email service provider.","APOSTILLE_HEADER_LABEL":"Verification Information","APOSTILLE_NUMBER_LABEL":"Apostille/Authentication","APOSTILLE_CITY_STATE_OVERRIDE":"HELENA, MT","APOSTILLE_FILING_DATE_LABEL":"Issue Date","APOSTILLE_CITY_STATE_IN_CERTIFIED":true,"NOTARY_EXISTING_FILING":true,"ALLOW_REVOKE_OWN_ACCESS_ONLY":false,"HIDE_CANCEL_ON_ONETIME_DATA_REQUESTS":true,"DATA_REQUESTS_IN_SHOPPING_CART":true,"WQ_ALLOW_EDIT_PENDING_PAYMENT":true,"WQ_CONFIRM_ON_DELETE":true,"WQ_DELETE_CONFIRM_MESSAGE":"Deleting this filing will forfeit any money already paid to the Secretary of State. This action is permanent and cannot be undone, are you sure you would like to delete?","PASS_ITEM_GUIDS_ON_CHECKOUT":true,"FORM_REVISION_HISTORY":true,"CHECKOUT_DISCLAIMER":"By entering your credit card and/or checking account information you (i) state that **you are an authorized user** of the credit card and/or electronic check and that the associated information entered (e.g., account holder name, account number, billing address) is accurate, (ii) **you authorize payment processor to charge the amount you have requested** to your credit card and/or funding account, and (iii) **acknowledge if a charge is declined or reversed you may also be assessed a customary charge** by the payment processor for such transactions.","FARM_BILL_SEARCH_CONFIDENTIAL":"As a registered Farm Bill Buyer with the Montana Secretary of State’s office it is important to maintain the confidentiality of the information contained within the Farm Bill Master List. The Farm Bill Master List reflects personal data, such as Social Security Numbers, which are a key piece of personal identifiable information to assist you in determining the existence of a lien against a specific debtor. The distribution of this information beyond its intended purpose is strictly prohibited.\n\n**The debtor's tax identification number has been hidden for confidentiality reasons. You may continue to search on a tax ID number and return debtors that match your search criteria. The SSN/FEIN must be entered without dashes or spaces.  If you need access to the tax identification number to clearly identify the debtor, please contact the UCC unit at (406) 444-3665.**","VIEW_HISTORY_BUTTON_ALT_TEXT":"View Filings","WIZARD_ERROR_TITLE_MESSAGE":"Form Error","FARM_BILL_SEARCH_INTERACTIVE":true,"USE_FARM_BILL_API":true,"DISALLOW_ASSIGN_SELF_AS_RA":true,"DISALLOW_ASSIGN_SELF_AS_PRINCIPAL":true,"USE_TRADEMARK_OWNER_VALIDATION":true,"USE_ALTERNATIVE_FOREIGN_ADDRESS_LABELS":true,"MY_RECEIPTS_FILTER":[{"type":"dateRange","name":"DATE_RANGE","label":"Date range","defaultValue":{"start":null,"end":null}},{"type":"text","name":"REF_NUM","defaultValue":"","label":"Reference Number"},{"type":"text","name":"RECEIPT_NUM","defaultValue":"","label":"Receipt Id"},{"type":"text","name":"AMOUNT","defaultValue":"","label":"Amount"},{"type":"select","name":"TYPE","defaultValue":"","label":"Payment Type","options":[{"value":"","label":"All"},{"value":"CC","label":"Credit Card"},{"value":"Check","label":"Check"}]}],"MY_RECEIPTS_SHOW_IN_SIDEBAR":true,"SHOW_MY_RECEIPTS_HELPER_TEXT":true,"MY_RECEIPTS_HELPER_LABEL":"About Receipt Search","MY_RECEIPTS_HELPER_TEXT":"You can search for receipts based on their descriptions, including the items paid for on the receipt. Use the filters to search for or filter specific information.","FARM_BILL_SUBLINK":{"label":"Farm Bill","component":"FarmBill","parameter":"farm-bill","path":"/lists/farm-bill","sourceTypeId":0,"myRecordsSearch":false,"allowedRules":["/search/"],"disabled":true,"searchDescription":"To perform a search, enter a debtor name. Your search results may include: exact debtor name, variations of that name and any filing that includes your search criteria. Punctuation is ignored.\n\nYou can click on \"Advanced\" to refine your search. Under “Advanced” you can search by crop, year, county and SSN/FEIN. As a registered Farm Bill Buyer with the Montana Secretary of State’s office it is important to maintain the confidentiality of the information contained within the Farm Bill Master List. The Farm Bill Master List reflects personal data, such as Social Security Numbers, which are a key piece of personal identifiable information to assist you in determining the existence of a lien against a specific debtor. The distribution of this information beyond its intended purpose is strictly prohibited.\n\nThe debtor's tax identification number has been hidden for confidentiality reasons. You may continue to search on a tax ID number and return debtors that match your search criteria. The SSN/FEIN must be entered without dashes or spaces.","searchMustHaveOneOf":["search","UCC_FARM_PRODUCT_ID","COUNTY"],"searchPlaceholder":"Search by debtor name","advancedSearchParameters":[{"type":"ServerMultiComplete","label":"Product code name(s)","name":"UCC_FARM_PRODUCT_ID","defaultValue":"","optionsSrc":"UCC_FARM_PRODUCT_V"},{"type":"MultiComplete","label":"Year or Range of Years","name":"YEAR_NUM","optionsSrc":"years","startYear":"1968","defaultValue":[],"preMergeOptions":[{"value":"ALL","label":"All"}]},{"type":"serverSelect","label":"State","name":"STATE","defaultValue":"MONTANA","optionsSrc":"STATE"},{"type":"ServerMultiComplete","label":"County","name":"COUNTY","defaultValue":[],"optionsSrc":"COUNTY","overrideSubOptionsSrcFromParameterName":"STATE"},{"type":"checkbox","name":"TIN_SEARCH_YN","defaultValue":false,"label":"Tax Identification Number Search"},{"type":"checkbox","name":"TIN_SORT_YN","defaultValue":false,"label":"Unique ID Sort"}]},"ALLOW_ADDRESS_VALIDATION_BYPASS_OPTION":true,"DEFAULT_ADDRESS_VALIDATION_BYPASS_OPTION_CHECKED":true}).VALIDATE_EMAIL_BEFORE_SENDING) {
	                if (!_this.validateEmail(_this.email.value)) {
	                    _this.setState(function (state) {
	                        return {
	                            errors: Object.assign({}, state.errors, {
	                                email: 'Invalid Format'
	                            }),
	                            emailValidationAttempts: state.emailValidationAttempts + 1
	                        };
	                    });
	
	                    //Redirect to the home page if they put in a poorly formatted email address 4 times
	                    if (emailValidationAttempts >= 3) {
	                        window.location.href = '/';
	                    }
	                    return;
	                }
	            }
	
	            (0, _requests.SEND_PASSWORD_RESET_EMAIL)({ userId: _this.email.value }, function () {
	                _this.props.returnAndDisplaySuccess();
	            }, function (err) {
	                console.error(err);
	                _this.setState(function (state) {
	                    return {
	                        errors: Object.assign({}, state.errors, {
	                            submit: ("Username invalid - no account found") || 'Something went wrong, please try again later.'
	                        })
	                    };
	                });
	            });
	        }, _this.validateEmail = function (email) {
	            var regex = /^[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?!.*@)(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?$/gi;
	            return email.trim().length > 0 && regex.test(email);
	        }, _temp), _possibleConstructorReturn(_this, _ret);
	    }
	
	    _createClass(ForgotPasswordForm, [{
	        key: 'render',
	        value: function render() {
	            var _this2 = this;
	
	            var returnToLogin = this.props.returnToLogin;
	
	            return _react2.default.createElement(
	                'div',
	                { className: 'login forgot-password' },
	                _react2.default.createElement(
	                    'p',
	                    { className: 'description' },
	                    'In order to change your password, please input the ' + ( true ? 'username' : 'email') + ' associated with your account.'
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'field' },
	                    _react2.default.createElement(
	                        'label',
	                        null,
	                         true ? 'Username' : 'Email'
	                    ),
	                    _react2.default.createElement('input', {
	                        type: 'text',
	                        ref: function ref(_ref2) {
	                            _this2.email = _ref2;
	                        },
	                        onKeyDown: this.checkEnter,
	                        placeholder:  true ? 'username' : 'example@email.com'
	                    }),
	                    _react2.default.createElement(
	                        _CreateAccount.FieldError,
	                        null,
	                         true ? this.state.errors.username : this.state.errors.email
	                    )
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'button-wrapper create-wrapper' },
	                    _react2.default.createElement(
	                        'button',
	                        {
	                            type: 'button',
	                            className: 'btn-raised btn-light-primary submit',
	                            onClick: this.sendPasswordEmail
	                        },
	                        'SUBMIT'
	                    )
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'button-wrapper create-wrapper' },
	                    _react2.default.createElement(
	                        'button',
	                        {
	                            type: 'button',
	                            className: 'create-account-button',
	                            onClick: returnToLogin
	                        },
	                        'Return to login'
	                    )
	                ),
	                _react2.default.createElement(
	                    _CreateAccount.FieldError,
	                    null,
	                    this.state.errors.submit
	                )
	            );
	        }
	    }]);
	
	    return ForgotPasswordForm;
	}(_react2.default.Component);
	
	exports.default = ForgotPasswordForm;

/***/ },
/* 1140 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _CreateAccount = __webpack_require__(149);
	
	var _requests = __webpack_require__(6);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var ForgotUsernameForm = function ForgotUsernameForm(_ref) {
	  var returnToLogin = _ref.returnToLogin,
	      checkEnter = _ref.checkEnter,
	      props = _objectWithoutProperties(_ref, ['returnToLogin', 'checkEnter']);
	
	  var _React$useState = _react2.default.useState(''),
	      _React$useState2 = _slicedToArray(_React$useState, 2),
	      error = _React$useState2[0],
	      setError = _React$useState2[1];
	
	  var emailRef = _react2.default.useRef();
	
	  var sendUsernameEmail = function sendUsernameEmail() {
	    setError('');
	    (0, _requests.SEND_FORGOT_USERNAME_EMAIL)({ email: emailRef.current.value }, function (response) {
	      props.returnAndDisplaySuccess();
	    }, function (err) {
	      console.error(err);
	      setError(err.message);
	    });
	  };
	
	  return _react2.default.createElement(
	    'div',
	    { className: 'login forgot-password' },
	    _react2.default.createElement(
	      'p',
	      { className: 'description' },
	      'In order to retrieve your username(s), please input the email address associated with your account.'
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'field' },
	      _react2.default.createElement(
	        'label',
	        null,
	        'Email'
	      ),
	      _react2.default.createElement('input', {
	        type: 'text',
	        ref: emailRef,
	        onKeyDown: checkEnter,
	        placeholder: 'example@email.com'
	      }),
	      _react2.default.createElement(
	        _CreateAccount.FieldError,
	        null,
	        error
	      )
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'button-wrapper create-wrapper' },
	      _react2.default.createElement(
	        'button',
	        {
	          type: 'button',
	          className: 'btn-raised btn-light-primary submit',
	          onClick: sendUsernameEmail
	        },
	        'SUBMIT'
	      )
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'button-wrapper create-wrapper' },
	      _react2.default.createElement(
	        'button',
	        {
	          type: 'button',
	          className: 'create-account-button',
	          onClick: returnToLogin
	        },
	        'Return to login'
	      )
	    )
	  );
	};
	
	exports.default = ForgotUsernameForm;

/***/ },
/* 1141 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _utilities = __webpack_require__(8);
	
	var _actions = __webpack_require__(29);
	
	var _reactRedux = __webpack_require__(7);
	
	var _requests = __webpack_require__(6);
	
	var _Loaders = __webpack_require__(16);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var VerifyEmailAddress = function VerifyEmailAddress(_ref) {
	  var history = _ref.history,
	      props = _objectWithoutProperties(_ref, ['history']);
	
	  var search = props.location.search;
	
	  var _parseUrlQuery = (0, _utilities.parseUrlQuery)(search),
	      token = _parseUrlQuery.token;
	
	  var dispatch = (0, _reactRedux.useDispatch)();
	
	  console.log(props, token);
	
	  var verifyEmail = function verifyEmail() {
	    (0, _requests.VERIFY_EMAIL_ADDRESS)({ token: token }, function (res) {
	      console.log(res);
	      dispatch((0, _actions.setSuccessToast)('Successfully verified user: ' + res.username));
	      history.push('/auth');
	    }, function (err) {
	      console.log(err);
	      dispatch((0, _actions.setErrorToast)('Had trouble verifying account. Please try again.'));
	    });
	  };
	
	  _react2.default.useEffect(function () {
	    token ? verifyEmail() : history.push('/auth');
	  }, [token]);
	
	  return _react2.default.createElement(
	    'div',
	    { style: { display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', gap: '50px', fontWeight: 'bold', marginTop: '100px' } },
	    _react2.default.createElement(_Loaders.Spinner, { size: 'large', linear: true, themeColor: 'dark-neutral' }),
	    'Verifying email account, please wait...'
	  );
	};
	
	exports.default = VerifyEmailAddress;

/***/ },
/* 1142 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactTooltip = __webpack_require__(78);
	
	var _reactTooltip2 = _interopRequireDefault(_reactTooltip);
	
	var _shortid = __webpack_require__(22);
	
	var _shortid2 = _interopRequireDefault(_shortid);
	
	var _propTypes = __webpack_require__(20);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Switch = function (_React$Component) {
	  _inherits(Switch, _React$Component);
	
	  function Switch() {
	    _classCallCheck(this, Switch);
	
	    var _this = _possibleConstructorReturn(this, (Switch.__proto__ || Object.getPrototypeOf(Switch)).call(this));
	
	    _this.switchId = _shortid2.default.generate();
	    return _this;
	  }
	
	  _createClass(Switch, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          onChange = _props.onChange,
	          on = _props.on,
	          _props$className = _props.className,
	          className = _props$className === undefined ? '' : _props$className,
	          tooltip = _props.tooltip;
	
	      return _react2.default.createElement(
	        'button',
	        {
	          className: 'switch ' + (on ? 'on' : 'off') + ' ' + className,
	          onClick: function onClick(e) {
	            onChange(!on, e);
	          },
	          'data-tip': tooltip,
	          'data-for': this.switchId,
	          'aria-label': tooltip + ' switch ' + (on ? 'on' : 'off')
	        },
	        _react2.default.createElement('div', { className: 'fob' }),
	        tooltip && _react2.default.createElement(_reactTooltip2.default, { effect: 'solid', place: 'top', id: this.switchId })
	      );
	    }
	  }]);
	
	  return Switch;
	}(_react2.default.Component);
	
	Switch.propTypes = {
	  onChange: _propTypes2.default.func.isRequired,
	  on: _propTypes2.default.bool.isRequired,
	  className: _propTypes2.default.string,
	  tooltip: _propTypes2.default.string,
	  ariaLabel: _propTypes2.default.string
	};
	
	exports.default = Switch;

/***/ },
/* 1143 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Shell = __webpack_require__(19);
	
	var _requests = __webpack_require__(6);
	
	var _MessageCard = __webpack_require__(470);
	
	var _MessageCard2 = _interopRequireDefault(_MessageCard);
	
	var _userSquareSolid = __webpack_require__(599);
	
	var _userSquareSolid2 = _interopRequireDefault(_userSquareSolid);
	
	var _check = __webpack_require__(224);
	
	var _check2 = _interopRequireDefault(_check);
	
	var _pencilSolid = __webpack_require__(580);
	
	var _pencilSolid2 = _interopRequireDefault(_pencilSolid);
	
	var _Loaders = __webpack_require__(16);
	
	var _Portal = __webpack_require__(12);
	
	var _Portal2 = _interopRequireDefault(_Portal);
	
	var _Modal = __webpack_require__(13);
	
	var _validate = __webpack_require__(45);
	
	var _Markdown = __webpack_require__(24);
	
	var _Markdown2 = _interopRequireDefault(_Markdown);
	
	__webpack_require__(1468);
	
	var _dateFns = __webpack_require__(417);
	
	var _actions = __webpack_require__(29);
	
	var _reactRedux = __webpack_require__(7);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var EMAIL_ERROR = 'The email you provided was not a valid email. Please try again.';
	var SUCCESS_MESSAGE = 'Your document was successfully sent for signatures. \n\nEach signer will receive an email requesting their signature. When all the signers have signed you will receive an email with instructions to complete your filing.\n\nYou may return to this page anytime to view the status of each signer.';
	var ADD_REMOVE_MESSAGE = 'Adding or removing signers will require any signers who have previously signed this document, to re-sign.\n\n Are you sure you wish to add or remove signers?';
	
	var ManageSignaturesPage = function ManageSignaturesPage(_ref) {
	  var _ref$location$state = _ref.location.state,
	      locationState = _ref$location$state === undefined ? {} : _ref$location$state,
	      groupToken = _ref.match.params.groupToken,
	      history = _ref.history;
	
	  var _React$useState = _react2.default.useState(false),
	      _React$useState2 = _slicedToArray(_React$useState, 2),
	      loading = _React$useState2[0],
	      setLoading = _React$useState2[1];
	
	  var _React$useState3 = _react2.default.useState(true),
	      _React$useState4 = _slicedToArray(_React$useState3, 2),
	      signersLoading = _React$useState4[0],
	      setSignersLoading = _React$useState4[1];
	
	  var _React$useState5 = _react2.default.useState(false),
	      _React$useState6 = _slicedToArray(_React$useState5, 2),
	      confirmingCorrection = _React$useState6[0],
	      setConfirmingCorrection = _React$useState6[1];
	
	  var _React$useState7 = _react2.default.useState(''),
	      _React$useState8 = _slicedToArray(_React$useState7, 2),
	      amendmentNum = _React$useState8[0],
	      setAmendmentNum = _React$useState8[1];
	
	  var _React$useState9 = _react2.default.useState(''),
	      _React$useState10 = _slicedToArray(_React$useState9, 2),
	      formDefinitionId = _React$useState10[0],
	      setFormDefinitionId = _React$useState10[1];
	
	  var _React$useState11 = _react2.default.useState(true),
	      _React$useState12 = _slicedToArray(_React$useState11, 2),
	      showAddRemove = _React$useState12[0],
	      setShowAddRemove = _React$useState12[1];
	
	  var startCorrection = function startCorrection() {
	    history.push('/correct/' + formDefinitionId + '/' + amendmentNum);
	  };
	
	  return _react2.default.createElement(
	    _Shell.Body,
	    {
	      className: 'receipt-wrapper flex-center-page manage-signers-page',
	      backgroundThemeColor: 'light-neutral'
	    },
	    locationState.showSuccessMessage && !signersLoading && _react2.default.createElement(_MessageCard2.default, {
	      title: _react2.default.createElement(
	        'span',
	        { className: 'signer-success-title' },
	        _react2.default.createElement(
	          'div',
	          { className: 'signer-success-icon' },
	          _react2.default.createElement(_check2.default, null)
	        ),
	        'Successfully Sent'
	      ),
	      content: SUCCESS_MESSAGE,
	      className: 'signatures-success-message animated fadeInDown'
	    }),
	    _react2.default.createElement(
	      _MessageCard2.default,
	      {
	        style: { display: signersLoading ? 'none' : '' },
	        className: 'animated ' + (signersLoading ? '' : 'fadeInUp'),
	        title: _react2.default.createElement(
	          'span',
	          { className: 'signers-manage-title' },
	          'Manage Signatures',
	          ' ',
	          loading && _react2.default.createElement(_Loaders.Spinner, { className: 'animated fadeIn', themeColor: 'medium-neutral', size: 'small' })
	        )
	        // content={``}
	      },
	      _react2.default.createElement(ConnectedSignersManager, {
	        groupToken: groupToken,
	        setFormDefinitionId: setFormDefinitionId,
	        setAmendmentNum: setAmendmentNum,
	        setShowAddRemove: setShowAddRemove,
	        onLoadStarted: function onLoadStarted() {
	          return setLoading(true);
	        },
	        onLoadEnded: function onLoadEnded() {
	          return setLoading(false);
	        },
	        onInitialized: function onInitialized() {
	          return setSignersLoading(false);
	        },
	        disabled: loading
	      }),
	      showAddRemove && _react2.default.createElement(
	        'div',
	        { className: 'flex-row add-wrapper' },
	        _react2.default.createElement(
	          'button',
	          { className: 'btn btn-neutral', onClick: function onClick() {
	              return setConfirmingCorrection(true);
	            } },
	          'Add or Remove Signers'
	        )
	      )
	    ),
	    _react2.default.createElement(
	      _Portal2.default,
	      { isOpened: confirmingCorrection },
	      _react2.default.createElement(_Modal.ConfirmDialog, {
	        closeModal: function closeModal() {
	          return setConfirmingCorrection(false);
	        },
	        leftAligned: true,
	        onModalClosed: function onModalClosed() {},
	        message: _react2.default.createElement(_Markdown2.default, { source: ADD_REMOVE_MESSAGE, className: 'markdown' }),
	        buttons: [{
	          label: 'Yes',
	          onClick: startCorrection,
	          className: 'btn-primary'
	        }, { label: 'No', onClick: function onClick() {}, className: 'btn-default' }],
	        modalStyle: { borderRadius: 3 }
	      })
	    )
	  );
	};
	
	exports.default = ManageSignaturesPage;
	
	
	var SignersManager = function SignersManager(_ref2) {
	  var groupToken = _ref2.groupToken,
	      onLoadStarted = _ref2.onLoadStarted,
	      onLoadEnded = _ref2.onLoadEnded,
	      onInitialized = _ref2.onInitialized,
	      disabled = _ref2.disabled,
	      setFormDefinitionId = _ref2.setFormDefinitionId,
	      setAmendmentNum = _ref2.setAmendmentNum,
	      setShowAddRemove = _ref2.setShowAddRemove,
	      setErrorToast = _ref2.setErrorToast,
	      setSuccessToast = _ref2.setSuccessToast;
	
	  var _React$useState13 = _react2.default.useState(null),
	      _React$useState14 = _slicedToArray(_React$useState13, 2),
	      signers = _React$useState14[0],
	      setSigners = _React$useState14[1];
	
	  var _React$useState15 = _react2.default.useState(true),
	      _React$useState16 = _slicedToArray(_React$useState15, 2),
	      initialLoading = _React$useState16[0],
	      setInitialLoading = _React$useState16[1];
	
	  var handleErrorToastRequested = function handleErrorToastRequested(errorMessage) {
	    setErrorToast(errorMessage);
	  };
	
	  var handleSuccessToastRequested = function handleSuccessToastRequested(message) {
	    setSuccessToast(message);
	  };
	
	  _react2.default.useEffect(function () {
	    (0, _requests.GET_SIGNATURES_BY_GROUP_TOKEN)(groupToken, function (signers) {
	      setSigners(signers);
	      setInitialLoading(false);
	      onInitialized();
	      setFormDefinitionId(signers[0].FORM_DEFINITION_ID);
	      setAmendmentNum(signers[0].SOURCE_NUM);
	      setShowAddRemove(({"NODE_ENV":"production","BUILD_DATE":"2025-08-27T15:15:31.687Z","BUILD_NUMBER":"Not Provided","GIT_VERSION":"v1.3.0-381-ga81e29b08","GIT_COMMIT_HASH":"a81e29b085c9268ffd96c78eb734365802722741","GIT_BRANCH":"beta","PUBLIC_URL":"","STATE_ABBR":"MT","STATE_NAME":"Montana","STATE_ORG_TITLE":"Secretary of State","LOGIN_HEADER_IMG_PATH":"","HOME_IMG_FILENAME":"montana.jpg","FAVICON_FILE_NAME":"favicon.ico","ALLOW_E_SIGN_ON_CORRECTIONS":true,"THIRD_PARTY_SIGNING_ALLOWED":false,"MY_ACCOUNT_SAVE_AND_CLOSE_BUTTON":true,"IE_DEPRECATED_MESSAGE":"Internet Explorer is not supported. Please select a supported browser below to access this website.","ADDITIONAL_ROUTES":{"dataRequests":true,"farmBill":true,"apostille":true,"externalHelp":"https://sosmt.gov/business/help-center/","systemAdministration":[{"title":"Saved Payments","parameter":"saved-payments","componentName":"SavedPayments"}]},"SUBROUTES":[{"label":"Business","component":"Business","parameter":"business","myWorkQueueSearch":false,"sourceTypeId":54,"searchMustHaveOneOf":["FILING_TYPE_ID","STATUS_ID","STATE","search"],"serverWebSearchDescription":true,"serverWorkQueueDescription":true,"serverMyRecordsDescription":true,"searchPlaceholder":"Search by name or filing number (X########)","allowEmptySearchTerm":true,"requestCertificateAlternateLabel":"Request Information","fileAmendmentButtonLabel":"Filing Actions","advancedSearchParameters":[{"type":"radio","name":"QUERY_TYPE_ID","defaultValue":1010,"options":[{"value":1010,"label":"Starts with"},{"value":1011,"label":"Contains"},{"value":1012,"label":" Word Contains"}]},{"type":"serverSelect","name":"FILING_TYPE_ID","optionsSrc":"FILING_TYPES","label":"Entity Type","placeholder":"All","defaultValue":"0"},{"type":"serverSelect","name":"FILING_SUBTYPE_ID","optionsSrc":"FILING_SUBTYPES","label":"Entity Subtype","overrideSubOptionsSrcFromParameterName":"FILING_TYPE_ID","placeholder":"All","defaultValue":"0"},{"type":"serverSelect","name":"STATUS_ID","optionsSrc":"FILING_STATUS_WITHOUT_ALL","label":"Status","placeholder":"All","defaultValue":"0"},{"type":"serverSelect","name":"STATE","optionsSrc":"STATE","label":"State","placeholder":"All","defaultValue":""},{"type":"serverSelect","name":"COUNTY","optionsSrc":"COUNTY_SUBOPTION","label":"County","overrideSubOptionsSrcFromParameterName":"STATE","placeholder":"All","defaultValue":""},{"type":"checkbox","name":"CRA_SEARCH_YN","defaultValue":false,"label":"Search by Registered Agent PID"},{"type":"dateRange","name":"FILING_DATE","label":"Registration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}},{"type":"dateRange","name":"EXPIRATION_DATE","label":"Expiration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}}],"myRecordsFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Active"},{"value":2,"label":"Inactive"},{"value":3,"label":"Pending"}]},{"type":"dateRange","name":"DATE_RANGE","label":"Date range","defaultValue":{"start":null,"end":null}}],"myWorkQueueFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Approved"},{"value":2,"label":"Pending Online Payment"},{"value":3,"label":"Pending Review"},{"value":4,"label":"Needs Correction"},{"value":5,"label":"Rejected"},{"value":6,"label":"Draft"}]},{"type":"dateRange","name":"DATE_RANGE","label":"Date range","defaultValue":{"start":null,"end":null}}]},{"label":"Notary","component":"Notary","parameter":"notary","sourceTypeId":850,"myWorkQueueSearch":false,"allowEmptySearchTerm":true,"requestCertificateAlternateLabel":"Download Certificate","fileAmendmentButtonLabel":"Filing Actions","hideNameRequestCertificate":true,"hideAddressRequestCertificate":true,"hideRecordUserManagment":true,"searchPlaceholder":"Search by name or commission number","searchMustHaveOneOf":["CITY","search","SERVICE_TYPE"],"advancedParametersStartOpen":true,"searchIsSortable":true,"advancedSearchParameters":[{"type":"radio","name":"STARTS_WITH_YN","defaultValue":false,"options":[{"value":true,"label":"Starts with"},{"value":false,"label":"Contains"}]},{"type":"checkbox","name":"ACTIVE_ONLY_YN","defaultValue":true,"label":"Active entities only"},{"type":"text","name":"CITY","defaultValue":"","label":"City"},{"type":"select","name":"SERVICE_TYPE","label":"Special Services Offered","defaultValue":0,"options":[{"value":0,"label":"(N/A)"},{"value":6165,"label":"In-Person Electronic Notarization (IPEN)"},{"value":6166,"label":"Remote Online Notarization (RON)"},{"value":6167,"label":"Mobile Notary Services"},{"value":6168,"label":"Remote Ink Notarization (RIN)"}]}]},{"label":"Apostille","component":"Apostille","parameter":"apostille","sourceTypeId":720,"myRecordsSearch":false,"myWorkQueueSearch":false,"disabled":false,"allowedRoutes":["/forms-manager/","/queue/","/forms/"]},{"label":"Liens","component":"UCC","parameter":"ucc","sourceTypeId":1999,"myRecordsSearch":true,"myWorkQueueSearch":true,"fileAmendmentButtonLabel":"Filing Actions","searchPlaceholder":"Search by name or file number","disabled":false,"serverWebSearchDescription":true,"myRecordsDescription":"","workQueueDescription":"","searchDescription":"","hideRecordUserManagment":true,"searchLiensCheckout":false,"advancedSearchParameters":[{"type":"radio","name":"STARTS_WITH_YN","defaultValue":false,"options":[{"value":true,"label":"Starts with"},{"value":false,"label":"Contains"}]},{"type":"select","name":"STATUS","defaultValue":"ALL","label":"Status","options":[{"value":"ACTIVE_UNLAPSED","label":"Active (unlapsed)"},{"value":"ACTIVE_LAPSED_UNLAPSED","label":"Active (lapsed and unlapsed)"}]},{"type":"text","name":"EXCLUDE_VALUES","label":"Exclude Debtor Names (comma separated list of names to exclude)","defaultValue":""},{"type":"dateRange","name":"FILING_DATE","label":"Financing Statement Date","defaultValue":{"start":null,"end":null}},{"type":"dateRange","name":"LAPSE_DATE","label":"Lapse Date","defaultValue":{"start":null,"end":null}},{"type":"text","name":"CITY","label":"Debtor City","defaultValue":""}],"myRecordsFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Approved"},{"value":2,"label":"Pending Online Payment"},{"value":3,"label":"Pending Review"}]},{"type":"select","name":"TYPE","defaultValue":0,"label":"Lien Type","options":[{"value":0,"label":"All"},{"value":1,"label":"UCC"},{"value":2,"label":"EFS"},{"value":3,"label":"Title 71"}]}],"myWorkQueueFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Approved"},{"value":2,"label":"Pending Online Payment"},{"value":3,"label":"Pending Review"},{"value":4,"label":"Pending Print and Mail"},{"value":5,"label":"Rejected"},{"value":6,"label":"Draft"}]},{"type":"select","name":"TYPE","defaultValue":0,"label":"Lien Type","options":[{"value":0,"label":"All"},{"value":1,"label":"UCC"},{"value":2,"label":"EFS"},{"value":3,"label":"Title 71"}]}]},{"label":"Copy Request","component":"copies","parameter":"copies","sourceTypeId":2001,"myRecordsSearch":false,"myWorkQueueSearch":false,"disabled":false,"allowedRoutes":["/forms-manager/","/queue/","/forms/"]},{"label":"Trademark","component":"Trademark","parameter":"trademark","sourceTypeId":810,"showRequestCertificate":true,"searchMustHaveOneOf":["search","EXPIRATION_DATE","FILING_DATE"],"allowEmptySearchTerm":true,"requestCertificateAlternateLabel":"Request Information","fileAmendmentButtonLabel":"Filing Actions","advancedSearchParameters":[{"type":"radio","name":"QUERY_TYPE_ID","defaultValue":1010,"options":[{"value":1010,"label":"Starts with"},{"value":1011,"label":"Contains"},{"value":1012,"label":" Word Contains"}]},{"type":"checkbox","name":"OWNER_SEARCH_YN","defaultValue":false,"label":"Search owners"},{"type":"radio","name":"SERVICE_MARK_YN","label":"Mark Type","defaultValue":"","options":[{"value":"","label":"All Marks"},{"value":"Y","label":"Service Mark"},{"value":"N","label":"Trademark"}]},{"type":"serverSelect","name":"STATUS_ID","optionsSrc":"TYPE_V|TRADEMARK_STATUS_TYPE","label":"Status","placeholder":"All","defaultValue":"0"},{"type":"select","name":"DESIGN_TYPE_ID","options":[{"value":0,"label":"All"},{"value":990,"label":"Words Only"},{"value":991,"label":"Design Only"},{"value":992,"label":"Words and Design"}],"label":"Design Type","defaultValue":"0"},{"type":"dateRange","name":"FILING_DATE","label":"Registered Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}},{"type":"dateRange","name":"EXPIRATION_DATE","label":"Expiration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}}]},{"label":"Business Info Request","component":"InfoRequests","parameter":"info-request","sourceTypeId":167,"allowedRoutes":["/forms-manager/","/queue/","/forms/"]},{"label":"Data Requests","component":"DataRequests","parameter":"data-request","sourceTypeId":0,"allowedRoutes":["/forms-manager/"]},{"label":"CRA","component":"CRA","parameter":"cra","sourceTypeId":157,"myRecordsSearch":false,"searchPlaceholder":"Search by name or registered agent number","allowedRoutes":["/forms-manager/","/forms/","/records/","/queue/","/search/"],"allowEmptySearchTerm":true,"fileAmendmentButtonLabel":"Filing Actions","advancedSearchParameters":[{"type":"radio","name":"QUERY_TYPE_ID","defaultValue":1010,"options":[{"value":1010,"label":"Starts with"},{"value":1011,"label":"Contains"},{"value":1012,"label":" Word Contains"}]},{"type":"dateRange","name":"CRA_DATE","label":"Registration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}},{"type":"select","name":"STATUS_ID","label":"Status","defaultValue":0,"options":[{"value":0,"label":"All"},{"value":121,"label":"Active"},{"value":122,"label":"Inactive"}]},{"type":"select","name":"AGENT_TYPE_ID","label":"Agent Type","defaultValue":0,"options":[{"value":0,"label":"All"},{"value":460,"label":"Registered Agent"},{"value":461,"label":"Commercial Registered Agent"}]}]},{"label":"Farm Bill","component":"FarmBill","parameter":"farm-bill","path":"/lists/farm-bill","sourceTypeId":0,"myRecordsSearch":false,"allowedRules":["/search/"],"disabled":true,"searchDescription":"To perform a search, enter a debtor name. Your search results may include: exact debtor name, variations of that name and any filing that includes your search criteria. Punctuation is ignored.\n\nYou can click on \"Advanced\" to refine your search. Under “Advanced” you can search by crop, year, county and SSN/FEIN. As a registered Farm Bill Buyer with the Montana Secretary of State’s office it is important to maintain the confidentiality of the information contained within the Farm Bill Master List. The Farm Bill Master List reflects personal data, such as Social Security Numbers, which are a key piece of personal identifiable information to assist you in determining the existence of a lien against a specific debtor. The distribution of this information beyond its intended purpose is strictly prohibited.\n\nThe debtor's tax identification number has been hidden for confidentiality reasons. You may continue to search on a tax ID number and return debtors that match your search criteria. The SSN/FEIN must be entered without dashes or spaces.","searchMustHaveOneOf":["search","UCC_FARM_PRODUCT_ID","COUNTY"],"searchPlaceholder":"Search by debtor name","advancedSearchParameters":[{"type":"ServerMultiComplete","label":"Product code name(s)","name":"UCC_FARM_PRODUCT_ID","defaultValue":"","optionsSrc":"UCC_FARM_PRODUCT_V"},{"type":"MultiComplete","label":"Year or Range of Years","name":"YEAR_NUM","optionsSrc":"years","startYear":"1968","defaultValue":[],"preMergeOptions":[{"value":"ALL","label":"All"}]},{"type":"serverSelect","label":"State","name":"STATE","defaultValue":"MONTANA","optionsSrc":"STATE"},{"type":"ServerMultiComplete","label":"County","name":"COUNTY","defaultValue":[],"optionsSrc":"COUNTY","overrideSubOptionsSrcFromParameterName":"STATE"},{"type":"checkbox","name":"TIN_SEARCH_YN","defaultValue":false,"label":"Tax Identification Number Search"},{"type":"checkbox","name":"TIN_SORT_YN","defaultValue":false,"label":"Unique ID Sort"}]}],"SYSTEM_NICKNAME":"Online Services Portal","PAYMENT_METHODS":[{"type":"bypass"},{"type":"iTransact"}],"PAYMENT_ALLOW_AMEX":true,"SYSTEM_ID_LABEL":"System Id","DOUBLE_COLUMN_PUBLIC_LOGIN":true,"INTERNAL_USER_MANAGEMENT":true,"ALLOW_PUBLIC_JSON_IMPORT":false,"MAX_FILE_UPLOAD_SIZE":10000000,"REFUND_TEXT":"","RETURN_TO_HOME_ON_LOGOUT":true,"CURRENT_SOS_NAME":"Christi Jacobsen","LOGO_FILENAME":"mt-sos-logo.png","LOGO_ALT":"Christi Jacobsen, Montana Secretary of State","LOGO_FULL_WIDTH":true,"HOME_HIDE_AUTH_HINT":true,"HOME_TITLE":"Montana Secretary of State","CUSTOM_TAB_TITLE":"Official Montana","HOME_SUBTITLE":"Online Business Services","ENTITY_NAME_CONSENT_DESCRIPTION":"","ALLOW_USER_PROFILE_EDITING":true,"COMPARE_FOREIGN_NAME_IN_ENTITY_NAME_VALIDATION":true,"FOREIGN_NAME_FIELD_NAME":"KIMA_PARENT_NAME_INFO","LOGIN_TITLE":"Montana Secretary of State Online Filing Portal Login","PUBLIC_LOGIN_LABEL":"Username","REVERSE_LOGIN_COLUMNS":true,"LOGIN_SEAL_FILENAME":"seal_white.png","SEPARATE_USERNAME_AND_EMAIL":true,"CREATE_ACCOUNT_BUTTON_ALIGN_LEFT":true,"CREATE_ACCOUNT_BUTTON_TEXT":"CREATE AN ACCOUNT","PASSWORD_CUSTOM_ERROR_TEXT":"The password must meet all requirements","ACCOUNT_CREATED_MESSAGE":"Please check your email to verify your account to login and allow a few minutes for this message to arrive. Check your junk/spam folders if you do not find the email in your inbox.","PUBLIC_LOGIN_PLACEHOLDER":" ","DISABLE_DEFAULT_PAYMENT_RADIO":true,"CUSTOM_RESET_PASSWORD_ERROR_MESSAGE":"Username invalid - no account found","PUBLIC_LOGIN_CREATE_DESCRIPTION":"### Existing User:\n\n  - Enter your username and password to login.  \n\n\n  #### - OR -  \n\n\n\n  - Forgot password? Click 'Reset Password' and follow the prompts.\n  - Forgot username? Click 'Forgot Username' and follow the prompts.  \n\n\n  ### New User:\n  ","LOGIN_HELP_LINK":"https://sosmt.gov/business/how-do-i/","LOGIN_HELP_LINK_TEXT":"Need Help?","FORGOT_USERNAME_TEXT":"Forgot Username?","LOGIN_ACTIVE_DIRECTORY_TEXT":"State User Login","MULTIPLE_LOGIN_METHODS":true,"HAS_ACTIVE_DIRECTORY_LOGIN":true,"RESET_PASSWORD_WITH_USERNAME":true,"DOWNLOAD_LINK":true,"SHOW_USERNAME_ACCOUNT_CREATE":true,"SHOW_SCROLL_DOWN_ARROW":true,"SHOW_ADDRESS_ACCOUNT_CREATE":true,"TWO_COLUMN_ACCOUNT_CREATE":true,"RESET_PASSWORD_TIP":"A link to change your password has been sent to your email. Please allow a few minutes for this message to arrive. Please check your junk/spam folders if you do not find the email in your inbox.","FORGOT_PASSWORD_LINK_TEXT":"Reset Password","PHONE_NUMBER_OPTIONAL_ACCOUNT_CREATE":true,"SHOW_REQUIRED_INDICATOR_ACCOUNT_CREATE":true,"PASSWORD_REQUIREMENTS_ACCOUNT_CREATE":"\n    <ul>\n      <li>MUST contain at least 8 characters (12+ recommended)</li>\n      <li>MUST contain at least one uppercase letter.</li>\n      <li>MUST contain at least one lowercase letter.</li>\n      <li>MUST contain at least one number.</li>\n      <li>MUST contain at least one special character (!”#$%&'()*+,-./:;<=>?</li>\n    </ul>\n  ","ALLOW_CERTIFICATION_REQUEST":true,"ALLOW_PUBLIC_CERTIFICATE_REQUEST":true,"ALLOW_COPY_REQUEST":false,"ALLOW_CORRECTION_STYLING":true,"HIDE_DEPRECATION_WARNING":false,"AMEND_ROUTE_PUBLIC":true,"SEAL_FILENAME":"seal.png","SHOPPING_CART":true,"ALLOW_PAYMENT_UPDATE_WITH_EMPTY_CART":true,"RA_EMAIL":true,"RA_WEBSITE":true,"RA_NO_DEFAULT_TYPE":true,"RA_ADDRESS_LABEL":"Street Address","RA_TYPE_SELECTION_DEFAULT":true,"RA_DEFAULT_TYPE":"460","RA_OVERRIDE_TYPE_WITH_DEFAULT":true,"RA_PRINCIPAL_ADDRESS_AMS":true,"UPLOAD_AND_SUBMIT_HIDE_IF_ONE_OPTION":true,"PAYMENT_PROCESSING_MESSAGE":"Your payment is processing - Do not close your browser or click the back button","CHECKOUT_BUTTON_WHEN_PROCESSING_TEXT":"Processing","EFS_CROP_PICKER_NONE_LABEL":"Lien Duration","DISALLOWED_WIZARD_PIECES":["FormationLocale"],"REPEATER_SHOW_EDIT_BUTTON":true,"DATA_REQUEST_PAGE_TITLE":"Data Requests and Subscriptions","DATA_REQUEST_SIDEBAR_LABEL":"Data Requests & Subscriptions","LOGIN_REDIRECTS_TO_EPASS":false,"LOGIN_REDIRECTS_TO_ACTIVE_DIRECTORY":true,"LOGIN_ACTIVE_DIRECTORY_LINK":true,"FETCH_EDIT_USER_LINK":false,"LISTS_FETCH_AVAILABLE_LISTS":true,"POST_WIZARD_SUBMIT_REDIRECT_URL":"/","PIN_REQUEST_ATTESTATIONS":true,"PIN_REQUEST_DESCRIPTION":"Click **Request PIN** to have a new PIN sent to the account holder's email address on file.","OWNERSHIP_REQUEST_DESCRIPTION":"To become an **authorized user** of this record, a current **AUTHORIZED USER** will need to grant you access. To request access, click **Request Access** below.","PIN_REQUEST_SUCCESS_MESSAGE":"The PIN you have requested for this entity has been sent to the email associated with your user account.  You should receive the PIN in approximately 3-5 minutes, depending on your email service provider.","APOSTILLE_HEADER_LABEL":"Verification Information","APOSTILLE_NUMBER_LABEL":"Apostille/Authentication","APOSTILLE_CITY_STATE_OVERRIDE":"HELENA, MT","APOSTILLE_FILING_DATE_LABEL":"Issue Date","APOSTILLE_CITY_STATE_IN_CERTIFIED":true,"NOTARY_EXISTING_FILING":true,"ALLOW_REVOKE_OWN_ACCESS_ONLY":false,"HIDE_CANCEL_ON_ONETIME_DATA_REQUESTS":true,"DATA_REQUESTS_IN_SHOPPING_CART":true,"WQ_ALLOW_EDIT_PENDING_PAYMENT":true,"WQ_CONFIRM_ON_DELETE":true,"WQ_DELETE_CONFIRM_MESSAGE":"Deleting this filing will forfeit any money already paid to the Secretary of State. This action is permanent and cannot be undone, are you sure you would like to delete?","PASS_ITEM_GUIDS_ON_CHECKOUT":true,"FORM_REVISION_HISTORY":true,"CHECKOUT_DISCLAIMER":"By entering your credit card and/or checking account information you (i) state that **you are an authorized user** of the credit card and/or electronic check and that the associated information entered (e.g., account holder name, account number, billing address) is accurate, (ii) **you authorize payment processor to charge the amount you have requested** to your credit card and/or funding account, and (iii) **acknowledge if a charge is declined or reversed you may also be assessed a customary charge** by the payment processor for such transactions.","FARM_BILL_SEARCH_CONFIDENTIAL":"As a registered Farm Bill Buyer with the Montana Secretary of State’s office it is important to maintain the confidentiality of the information contained within the Farm Bill Master List. The Farm Bill Master List reflects personal data, such as Social Security Numbers, which are a key piece of personal identifiable information to assist you in determining the existence of a lien against a specific debtor. The distribution of this information beyond its intended purpose is strictly prohibited.\n\n**The debtor's tax identification number has been hidden for confidentiality reasons. You may continue to search on a tax ID number and return debtors that match your search criteria. The SSN/FEIN must be entered without dashes or spaces.  If you need access to the tax identification number to clearly identify the debtor, please contact the UCC unit at (406) 444-3665.**","VIEW_HISTORY_BUTTON_ALT_TEXT":"View Filings","WIZARD_ERROR_TITLE_MESSAGE":"Form Error","FARM_BILL_SEARCH_INTERACTIVE":true,"USE_FARM_BILL_API":true,"DISALLOW_ASSIGN_SELF_AS_RA":true,"DISALLOW_ASSIGN_SELF_AS_PRINCIPAL":true,"USE_TRADEMARK_OWNER_VALIDATION":true,"USE_ALTERNATIVE_FOREIGN_ADDRESS_LABELS":true,"MY_RECEIPTS_FILTER":[{"type":"dateRange","name":"DATE_RANGE","label":"Date range","defaultValue":{"start":null,"end":null}},{"type":"text","name":"REF_NUM","defaultValue":"","label":"Reference Number"},{"type":"text","name":"RECEIPT_NUM","defaultValue":"","label":"Receipt Id"},{"type":"text","name":"AMOUNT","defaultValue":"","label":"Amount"},{"type":"select","name":"TYPE","defaultValue":"","label":"Payment Type","options":[{"value":"","label":"All"},{"value":"CC","label":"Credit Card"},{"value":"Check","label":"Check"}]}],"MY_RECEIPTS_SHOW_IN_SIDEBAR":true,"SHOW_MY_RECEIPTS_HELPER_TEXT":true,"MY_RECEIPTS_HELPER_LABEL":"About Receipt Search","MY_RECEIPTS_HELPER_TEXT":"You can search for receipts based on their descriptions, including the items paid for on the receipt. Use the filters to search for or filter specific information.","FARM_BILL_SUBLINK":{"label":"Farm Bill","component":"FarmBill","parameter":"farm-bill","path":"/lists/farm-bill","sourceTypeId":0,"myRecordsSearch":false,"allowedRules":["/search/"],"disabled":true,"searchDescription":"To perform a search, enter a debtor name. Your search results may include: exact debtor name, variations of that name and any filing that includes your search criteria. Punctuation is ignored.\n\nYou can click on \"Advanced\" to refine your search. Under “Advanced” you can search by crop, year, county and SSN/FEIN. As a registered Farm Bill Buyer with the Montana Secretary of State’s office it is important to maintain the confidentiality of the information contained within the Farm Bill Master List. The Farm Bill Master List reflects personal data, such as Social Security Numbers, which are a key piece of personal identifiable information to assist you in determining the existence of a lien against a specific debtor. The distribution of this information beyond its intended purpose is strictly prohibited.\n\nThe debtor's tax identification number has been hidden for confidentiality reasons. You may continue to search on a tax ID number and return debtors that match your search criteria. The SSN/FEIN must be entered without dashes or spaces.","searchMustHaveOneOf":["search","UCC_FARM_PRODUCT_ID","COUNTY"],"searchPlaceholder":"Search by debtor name","advancedSearchParameters":[{"type":"ServerMultiComplete","label":"Product code name(s)","name":"UCC_FARM_PRODUCT_ID","defaultValue":"","optionsSrc":"UCC_FARM_PRODUCT_V"},{"type":"MultiComplete","label":"Year or Range of Years","name":"YEAR_NUM","optionsSrc":"years","startYear":"1968","defaultValue":[],"preMergeOptions":[{"value":"ALL","label":"All"}]},{"type":"serverSelect","label":"State","name":"STATE","defaultValue":"MONTANA","optionsSrc":"STATE"},{"type":"ServerMultiComplete","label":"County","name":"COUNTY","defaultValue":[],"optionsSrc":"COUNTY","overrideSubOptionsSrcFromParameterName":"STATE"},{"type":"checkbox","name":"TIN_SEARCH_YN","defaultValue":false,"label":"Tax Identification Number Search"},{"type":"checkbox","name":"TIN_SORT_YN","defaultValue":false,"label":"Unique ID Sort"}]},"ALLOW_ADDRESS_VALIDATION_BYPASS_OPTION":true,"DEFAULT_ADDRESS_VALIDATION_BYPASS_OPTION_CHECKED":true}).CONTROL_ADD_OR_REMOVE_SIGNERS ? signers[0].CAN_ADD_OR_REMOVE_YN : true);
	    }, function (err) {
	      console.error(err);
	      setInitialLoading(false);
	      onInitialized();
	    });
	  }, [groupToken]);
	
	  return _react2.default.createElement(
	    'div',
	    { className: 'signers-display-wrapper' },
	    !initialLoading ? signers ? signers.map(function (signer) {
	      return _react2.default.createElement(SignerRow, {
	        name: signer.SIGNER_NAME,
	        email: signer.EMAIL,
	        hasSigned: !!signer.SIGNED_DATE,
	        signedDate: (0, _dateFns.format)(new Date(signer.SIGNED_DATE), 'MM/dd/yyyy'),
	        token: signer.TOKEN,
	        onErrorToastRequested: handleErrorToastRequested,
	        onSuccessToastRequested: handleSuccessToastRequested,
	        onLoadStarted: onLoadStarted,
	        onLoadEnded: onLoadEnded,
	        disabled: disabled,
	        key: signer.TOKEN
	      });
	    }) : _react2.default.createElement(
	      'p',
	      { className: 'danger-text' },
	      'Something went wrong while loading this page. Please try again later.'
	    ) : _react2.default.createElement(
	      'div',
	      { className: 'loader-wrapper' },
	      _react2.default.createElement(_Loaders.Spinner, { themeColor: 'neutral' })
	    )
	  );
	};
	
	var ConnectedSignersManager = (0, _reactRedux.connect)(null, {
	  setErrorToast: _actions.setErrorToast,
	  setSuccessToast: _actions.setSuccessToast
	})(SignersManager);
	
	var SignerRow = function SignerRow(_ref3) {
	  var name = _ref3.name,
	      email = _ref3.email,
	      hasSigned = _ref3.hasSigned,
	      signedDate = _ref3.signedDate,
	      token = _ref3.token,
	      disabled = _ref3.disabled,
	      onErrorToastRequested = _ref3.onErrorToastRequested,
	      onSuccessToastRequested = _ref3.onSuccessToastRequested,
	      onLoadStarted = _ref3.onLoadStarted,
	      onLoadEnded = _ref3.onLoadEnded;
	
	  var _React$useState17 = _react2.default.useState(false),
	      _React$useState18 = _slicedToArray(_React$useState17, 2),
	      editingEmail = _React$useState18[0],
	      setEditingEmail = _React$useState18[1];
	
	  var _React$useState19 = _react2.default.useState(null),
	      _React$useState20 = _slicedToArray(_React$useState19, 2),
	      optimisticEmail = _React$useState20[0],
	      setOptimisticEmail = _React$useState20[1];
	
	  var _React$useState21 = _react2.default.useState(false),
	      _React$useState22 = _slicedToArray(_React$useState21, 2),
	      didResend = _React$useState22[0],
	      setDidResend = _React$useState22[1];
	
	  var inputRef = _react2.default.useRef();
	
	  _react2.default.useEffect(function () {
	    if (editingEmail) {
	      inputRef.current.select();
	    }
	  }, [editingEmail]);
	
	  var startEmailEdit = function startEmailEdit() {
	    return setEditingEmail(true);
	  };
	
	  var handleBlur = function handleBlur() {
	    var newEmail = inputRef.current.value;
	    if (!newEmail) {
	      setEditingEmail(false);
	      onErrorToastRequested(EMAIL_ERROR);
	    } else if (newEmail === (optimisticEmail || email)) {
	      setEditingEmail(false);
	    } else {
	      _validate.VALIDATE.isValidEmailFormat(newEmail, { type: 'text' }, {}, function (isValid) {
	        if (isValid) {
	          onLoadStarted();
	          setOptimisticEmail(newEmail);
	          setEditingEmail(false);
	          (0, _requests.SET_SIGNER_EMAIL_BY_TOKEN)({ SIGNER_EMAIL: newEmail, TOKEN: token }, function () {
	            onLoadEnded();
	            onSuccessToastRequested('New email for ' + name + ' successfully saved');
	          }, function (err) {
	            console.error(err);
	            onLoadEnded();
	            setOptimisticEmail(null);
	            onErrorToastRequested('Something went wrong while updating this email. Please try again later.');
	          });
	        } else {
	          onErrorToastRequested(EMAIL_ERROR);
	          setEditingEmail(false);
	        }
	      });
	    }
	  };
	
	  var checkEnter = function checkEnter(e) {
	    if (e.keyCode === 13) {
	      handleBlur();
	    }
	  };
	
	  var resendEmail = function resendEmail() {
	    onLoadStarted();
	    (0, _requests.RESEND_SIGNER_EMAIL)(token, function () {
	      setDidResend(true);
	      onLoadEnded();
	    }, function (err) {
	      console.error(err);
	      onLoadEnded();
	      onErrorToastRequested('The email could not be sent at this time, please try again later.');
	    });
	  };
	
	  return _react2.default.createElement(
	    'div',
	    { className: 'signer-display-row flex-row ' + (hasSigned ? 'signed' : '') },
	    _react2.default.createElement(
	      'div',
	      { className: 'signer-icon' },
	      hasSigned ? _react2.default.createElement(_check2.default, null) : _react2.default.createElement(_userSquareSolid2.default, null)
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'flex-column signer-info' },
	      _react2.default.createElement(
	        'span',
	        null,
	        name
	      ),
	      editingEmail ? _react2.default.createElement('input', {
	        type: 'text',
	        defaultValue: optimisticEmail || email,
	        onBlur: handleBlur,
	        onKeyDown: checkEnter,
	        autoFocus: true,
	        ref: inputRef
	      }) : _react2.default.createElement(
	        'span',
	        {
	          className: hasSigned || disabled ? 'disabled' : '',
	          role: !hasSigned && !disabled ? 'button' : '',
	          tabIndex: !hasSigned && !disabled ? 0 : undefined,
	          onClick: hasSigned || disabled ? undefined : startEmailEdit,
	          onKeyDown: function onKeyDown(e) {
	            if (!disabled && !hasSigned && (e.keyCode === 13 || e.keyCode === 32)) {
	              startEmailEdit();
	            }
	          }
	        },
	        optimisticEmail || email,
	        ' ',
	        _react2.default.createElement(_pencilSolid2.default, null)
	      )
	    ),
	    !hasSigned ? _react2.default.createElement(
	      'button',
	      { disabled: disabled || didResend, className: 'btn btn-default', onClick: resendEmail },
	      didResend ? 'Resent' : 'Resend'
	    ) : _react2.default.createElement(
	      'div',
	      { className: 'signed-date' },
	      _react2.default.createElement(
	        'span',
	        { className: 'label' },
	        'Signed On:'
	      ),
	      _react2.default.createElement('br', null),
	      _react2.default.createElement(
	        'span',
	        null,
	        signedDate
	      )
	    )
	  );
	};

/***/ },
/* 1144 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function () {
	
	  var skipLink = {
	    selector: 'main.body a, main.body button:not(:disabled), main.body input:not(:disabled), main.body select:not(:disabled), main.body textarea:not(:disabled), main.body [tabIndex]:not([tabIndex="-1"]):not([tabIndex=""])',
	    label: 'main content'
	  };
	  var setFocus = function setFocus() {
	    var focusable = document.querySelector(skipLink.selector);
	    if (focusable) {
	      focusable.focus();
	    }
	  };
	  var handleKeyPress = function handleKeyPress(e) {
	    if (e.keyCode === 32 || e.keyCode === 13) {
	      e.preventDefault();
	      setFocus();
	    }
	  };
	  var handleClick = function handleClick(e) {
	    e.preventDefault();
	    setFocus();
	    return false;
	  };
	  return _react2.default.createElement(
	    'a',
	    {
	      tabIndex: '1',
	      onKeyDown: handleKeyPress,
	      className: 'skip-link',
	      href: '',
	      onClick: handleClick
	    },
	    'Skip to ',
	    skipLink.label
	  );
	};

/***/ },
/* 1145 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Shell = __webpack_require__(19);
	
	var _reactRouterDom = __webpack_require__(30);
	
	var _SavedPayments = __webpack_require__(1129);
	
	var _SavedPayments2 = _interopRequireDefault(_SavedPayments);
	
	__webpack_require__(1470);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ROUTES = ({"dataRequests":true,"farmBill":true,"apostille":true,"externalHelp":"https://sosmt.gov/business/help-center/","systemAdministration":[{"title":"Saved Payments","parameter":"saved-payments","componentName":"SavedPayments"}]}).systemAdministration;
	
	var Components = {
	  SavedPayments: _SavedPayments2.default
	};
	
	var SystemAdmin = function SystemAdmin(_ref) {
	  var match = _ref.match,
	      history = _ref.history;
	
	  var _React$useState = _react2.default.useState(false),
	      _React$useState2 = _slicedToArray(_React$useState, 2),
	      drawerShown = _React$useState2[0],
	      setDrawerShown = _React$useState2[1];
	
	  var routeProps = { setDrawerShown: setDrawerShown, drawerShown: drawerShown };
	
	  _react2.default.useEffect(function () {
	    if (!match.params.parameter) {
	      history.replace('/system-admin/' + (ROUTES[0].parameter || ''));
	    }
	  }, []);
	
	  return _react2.default.createElement(
	    _Shell.Body,
	    { className: 'no-padding system-admin', showDrawer: drawerShown },
	    _react2.default.createElement(Sidebar, null),
	    _react2.default.createElement(
	      InnerBody,
	      null,
	      ROUTES.map(function (route, i) {
	        var Component = Components[route.componentName];
	        return _react2.default.createElement(_reactRouterDom.Route, {
	          path: '/system-admin/' + route.parameter,
	          exact: true,
	          render: function render(props) {
	            return _react2.default.createElement(Component, Object.assign({}, props, routeProps));
	          },
	          key: route.component || i
	        });
	      })
	    )
	  );
	};
	
	exports.default = SystemAdmin;
	
	
	var Sidebar = function Sidebar() {
	  return _react2.default.createElement(
	    'aside',
	    { className: 'body-sidebar' },
	    ROUTES.map(function (route, i) {
	      return _react2.default.createElement(
	        _reactRouterDom.NavLink,
	        { to: '/system-admin/' + route.parameter, key: route.parameter || i },
	        route.title
	      );
	    })
	  );
	};
	
	var InnerBody = function InnerBody(_ref2) {
	  var children = _ref2.children;
	  return _react2.default.createElement(
	    'div',
	    { className: 'inner-body' },
	    children
	  );
	};

/***/ },
/* 1146 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _caretDown = __webpack_require__(38);
	
	var _caretDown2 = _interopRequireDefault(_caretDown);
	
	var _Loaders = __webpack_require__(16);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var CollapsibleTable = function CollapsibleTable(_ref) {
	  var rows = _ref.rows,
	      headers = _ref.headers,
	      _ref$className = _ref.className,
	      className = _ref$className === undefined ? '' : _ref$className,
	      getChildren = _ref.getChildren,
	      expandable = _ref.expandable;
	  return _react2.default.createElement(
	    'table',
	    { className: 'styled-table ' + className },
	    _react2.default.createElement(TableHeader, { headers: headers, expandable: expandable }),
	    _react2.default.createElement(TableBody, { rows: rows, getChildren: getChildren, expandable: expandable })
	  );
	};
	
	exports.default = CollapsibleTable;
	
	
	var TableHeader = function TableHeader(_ref2) {
	  var headers = _ref2.headers,
	      expandable = _ref2.expandable;
	  return _react2.default.createElement(
	    'thead',
	    null,
	    _react2.default.createElement(
	      'tr',
	      { className: expandable ? "expandable" : '' },
	      headers.map(function (h, i) {
	        return _react2.default.createElement(
	          'th',
	          { key: i },
	          h
	        );
	      }),
	      expandable && _react2.default.createElement('th', null)
	    )
	  );
	};
	
	var TableBody = function TableBody(_ref3) {
	  var rows = _ref3.rows,
	      childType = _ref3.childType,
	      getChildren = _ref3.getChildren,
	      expanded = _ref3.expanded,
	      expandable = _ref3.expandable;
	  return _react2.default.createElement(
	    'tbody',
	    null,
	    rows.map(function (row, i) {
	      return _react2.default.createElement(Row, { cells: row.render, getChildren: getChildren, expandable: expandable, index: i, key: row.id || i });
	    })
	  );
	};
	
	var Row = function (_React$Component) {
	  _inherits(Row, _React$Component);
	
	  function Row() {
	    var _ref4;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, Row);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref4 = Row.__proto__ || Object.getPrototypeOf(Row)).call.apply(_ref4, [this].concat(args))), _this), _this.state = { expanded: false, fetching: false, children: null, error: false }, _this.toggleExpansion = function () {
	      if (_this.state.expanded) {
	        _this.setState({ expanded: false });
	      } else {
	        _this.setState({ fetching: true, error: false });
	        _this.props.getChildren(_this.props.cells, _this.props.index).then(function (children) {
	          _this.setState({ expanded: true, fetching: false, children: children });
	        }).catch(function (err) {
	          console.error(err);
	          _this.setState({ error: true, fetching: false, expanded: true });
	        });
	      }
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(Row, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          cells = _props.cells,
	          expandable = _props.expandable;
	
	      return _react2.default.createElement(
	        _react.Fragment,
	        null,
	        _react2.default.createElement(
	          'tr',
	          { className: 'clickable', onClick: this.toggleExpansion },
	          cells.map(function (cell, i) {
	            return _react2.default.createElement(
	              'td',
	              { key: i },
	              cell
	            );
	          }),
	          expandable && _react2.default.createElement(
	            'td',
	            { className: 'expand-cell' },
	            this.state.fetching ? _react2.default.createElement(_Loaders.Spinner, { size: 'small', themeColor: 'inherit' }) : _react2.default.createElement(
	              'div',
	              { className: 'expand-wrapper' },
	              _react2.default.createElement(_caretDown2.default, { className: this.state.expanded ? 'expanded' : '' })
	            )
	          )
	        ),
	        this.state.expanded && _react2.default.createElement(
	          'tr',
	          { className: 'expansion-spacer' },
	          _react2.default.createElement('td', { colSpan: cells.length })
	        ),
	        this.state.expanded && _react2.default.createElement(
	          'tr',
	          { className: 'expanded-row' },
	          _react2.default.createElement(
	            'td',
	            { colSpan: cells.length + (expandable ? 1 : 0) },
	            _react2.default.createElement(
	              'div',
	              { className: 'child-wrapper' },
	              !this.state.fetching ? this.state.children : "Loading...",
	              this.state.error && _react2.default.createElement(
	                'span',
	                { className: 'message danger-text' },
	                'Something went wrong.'
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return Row;
	}(_react2.default.Component);

/***/ },
/* 1147 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Field = __webpack_require__(25);
	
	var _Form = __webpack_require__(14);
	
	var _DateRange = __webpack_require__(306);
	
	var _DateRange2 = _interopRequireDefault(_DateRange);
	
	var _utilities = __webpack_require__(8);
	
	var _Form2 = __webpack_require__(14);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var FilterPopout = function (_React$Component) {
	  _inherits(FilterPopout, _React$Component);
	
	  function FilterPopout() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, FilterPopout);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = FilterPopout.__proto__ || Object.getPrototypeOf(FilterPopout)).call.apply(_ref, [this].concat(args))), _this), _this.setValue = function (value, key) {
	      var props = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	
	      _this.props.onChange(Object.assign({}, _this.props.filters, _defineProperty({}, key, value)), props);
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(FilterPopout, [{
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _props = this.props,
	          onRequestClose = _props.onRequestClose,
	          _props$filters = _props.filters,
	          filters = _props$filters === undefined ? {} : _props$filters,
	          _props$filterTemplate = _props.filterTemplates,
	          filterTemplates = _props$filterTemplate === undefined ? [] : _props$filterTemplate;
	
	      var mergedFilters = filterTemplates.map(function (ft) {
	        return Object.assign({}, ft, {
	          value: filters[ft.name] !== undefined ? filters[ft.name] : ft.defaultValue
	        });
	      });
	      return _react2.default.createElement(
	        _react2.default.Fragment,
	        null,
	        _react2.default.createElement(
	          'div',
	          { className: 'filter-popout wizard' },
	          _react2.default.createElement(
	            'h3',
	            null,
	            'Filters'
	          ),
	          mergedFilters.map(function (f) {
	            switch (f.type) {
	              case 'radio':
	                return _react2.default.createElement(
	                  _Field.DumbField,
	                  { label: f.label, key: f.name },
	                  _react2.default.createElement(_Form.RadioInput, {
	                    onChange: function onChange(value) {
	                      _this2.setValue(value, f.name);
	                    },
	                    options: f.options,
	                    value: f.value
	                  })
	                );
	              case 'select':
	                return _react2.default.createElement(
	                  _Field.DumbField,
	                  { label: f.label, key: f.name },
	                  _react2.default.createElement(_Form.Select, {
	                    onChange: function onChange(value) {
	                      _this2.setValue(value, f.name);
	                    },
	                    onBlur: _utilities.noop,
	                    options: f.options,
	                    value: f.value
	                  })
	                );
	              case 'dateRange':
	                return _react2.default.createElement(
	                  _Field.DumbField,
	                  { className: 'date-range', label: f.label, key: f.name },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'date-range-wrapper' },
	                    _react2.default.createElement(_DateRange2.default, {
	                      stacked: true,
	                      onChange: function onChange(value) {
	                        _this2.setValue(value, f.name, { getRecords: false });
	                      },
	                      onBlur: function onBlur(value) {
	                        _this2.setValue(value, f.name);
	                      },
	                      onButtonClicked: function onButtonClicked(value) {
	                        _this2.setValue(value, f.name);
	                      },
	                      value: f.value,
	                      startLabel: 'Start',
	                      endLabel: 'End'
	                    })
	                  )
	                );
	              case 'checkbox':
	                return _react2.default.createElement(
	                  _Field.DumbField,
	                  { className: 'checkbox', key: f.name },
	                  _react2.default.createElement(_Form.Checkbox, {
	                    name: f.name,
	                    onChange: function onChange(value) {
	                      _this2.setValue(value, f.name);
	                    },
	                    value: f.value,
	                    label: f.label
	                  })
	                );
	              case 'text':
	                return _react2.default.createElement(
	                  _Field.DumbField,
	                  { className: 'textinput', label: f.label, key: f.name },
	                  _react2.default.createElement(_Form2.TextInput, {
	                    name: f.name,
	                    onChange: function onChange(value) {
	                      _this2.setValue(value, f.name);
	                    },
	                    value: f.value,
	                    label: f.label
	                  })
	                );
	              default:
	                return null;
	            }
	          })
	        ),
	        _react2.default.createElement('div', {
	          className: 'filter-popout-shade animated fadeIn extra-fast-animation',
	          onClick: onRequestClose
	        })
	      );
	    }
	  }]);
	
	  return FilterPopout;
	}(_react2.default.Component);
	
	exports.default = FilterPopout;

/***/ },
/* 1148 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _crossHeavy = __webpack_require__(51);
	
	var _crossHeavy2 = _interopRequireDefault(_crossHeavy);
	
	__webpack_require__(1472);
	
	var _reactRedux = __webpack_require__(7);
	
	var _actions = __webpack_require__(29);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Toast = function (_React$Component) {
	  _inherits(Toast, _React$Component);
	
	  function Toast() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, Toast);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Toast.__proto__ || Object.getPrototypeOf(Toast)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      animationClass: 'float-in-up',
	      exiting: false,
	      message: _this.props.message,
	      visible: _this.props.message ? true : false
	    }, _this.timer = null, _this.componentDidMount = function () {
	      if (_this.state.visible) {
	        _this.startTimer();
	      }
	    }, _this.startTimer = function () {
	      _this.cancelTimer();
	      _this.timer = window.setTimeout(_this.startExiting, _this.props.timeout);
	    }, _this.cancelTimer = function () {
	      window.clearTimeout(_this.timer);
	    }, _this.componentWillReceiveProps = function (nextProps) {
	      if (!_this.props.manual && nextProps.message !== _this.state.message) {
	        _this.setState({
	          message: nextProps.message,
	          animationClass: 'float-in-up',
	          visible: true
	        });
	        _this.startTimer();
	      }
	    }, _this.startExiting = function () {
	      if (_this.props.message) {
	        _this.setState({
	          animationClass: 'float-out-down',
	          exiting: true
	        });
	      }
	      _this.cancelTimer();
	    }, _this.dismiss = function () {
	      if (_this.state.exiting === true) {
	        _this.setState({
	          visible: false,
	          exiting: false,
	          message: null
	        });
	        _this.cancelTimer();
	        _this.props.danger && _this.props.clearErrorToast();
	        _this.props.success && _this.props.clearSuccessToast();
	      }
	    }, _this.trigger = function () {
	      _this.cancelTimer();
	      _this.setState({
	        message: _this.props.message,
	        animationClass: 'float-in-up',
	        visible: true,
	        exiting: false
	      });
	      _this.startTimer();
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(Toast, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          message = _props.message,
	          danger = _props.danger,
	          success = _props.success;
	
	      return this.state.visible && message ? _react2.default.createElement(
	        'div',
	        { className: 'toast-wrapper ' + this.state.animationClass, onAnimationEnd: this.dismiss },
	        _react2.default.createElement(
	          'div',
	          { className: 'toast ' + (danger ? 'danger' : '') + ' ' + (success ? 'success' : ''), onMouseEnter: this.cancelTimer, onMouseLeave: this.startTimer },
	          _react2.default.createElement(
	            'span',
	            { className: 'message' },
	            message
	          ),
	          _react2.default.createElement(
	            'button',
	            { className: 'dismiss-btn', onClick: this.startExiting },
	            _react2.default.createElement(_crossHeavy2.default, null)
	          )
	        )
	      ) : null;
	    }
	  }]);
	
	  return Toast;
	}(_react2.default.Component);
	
	Toast.defaultProps = {
	  timeout: 5000
	};
	exports.default = (0, _reactRedux.connect)(null, { clearErrorToast: _actions.clearErrorToast, clearSuccessToast: _actions.clearSuccessToast })(Toast);

/***/ },
/* 1149 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Portal = __webpack_require__(12);
	
	var _Portal2 = _interopRequireDefault(_Portal);
	
	__webpack_require__(1473);
	
	var _chrome = __webpack_require__(1493);
	
	var _chrome2 = _interopRequireDefault(_chrome);
	
	var _opera = __webpack_require__(1496);
	
	var _opera2 = _interopRequireDefault(_opera);
	
	var _safari = __webpack_require__(1497);
	
	var _safari2 = _interopRequireDefault(_safari);
	
	var _edge = __webpack_require__(1494);
	
	var _edge2 = _interopRequireDefault(_edge);
	
	var _firefox = __webpack_require__(1495);
	
	var _firefox2 = _interopRequireDefault(_firefox);
	
	var _Markdown = __webpack_require__(24);
	
	var _Markdown2 = _interopRequireDefault(_Markdown);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var STATE_ABBR = ("MT");
	STATE_ABBR = STATE_ABBR.toUpperCase();
	var LOGO_FILENAME = ("mt-sos-logo.png");
	var SEAL_FILENAME = ("seal.png");
	var Logo = __webpack_require__(216)("./" + STATE_ABBR + (LOGO_FILENAME ? '/' + LOGO_FILENAME : SEAL_FILENAME ? '/' + SEAL_FILENAME : "/seal.svg"));
	var LOGO_ALT = ("Christi Jacobsen, Montana Secretary of State") || ("Montana") + ' ' + ("Secretary of State");
	
	var BROWSERS = [{
	  name: "Google Chrome",
	  link: "https://www.google.com/chrome/",
	  icon: _chrome2.default,
	  color: 'red'
	}, {
	  name: "Microsoft Edge",
	  link: "https://www.microsoft.com/en-us/edge",
	  icon: _edge2.default,
	  color: 'teal'
	}, {
	  name: "MacOS Safari",
	  link: "https://support.apple.com/en-us/HT204416",
	  icon: _safari2.default,
	  color: 'blue'
	}, {
	  name: "Mozilla Firefox",
	  link: "https://www.mozilla.org/en-US/firefox/new/",
	  icon: _firefox2.default,
	  color: 'orange'
	}, {
	  name: "Opera",
	  link: "https://www.opera.com/",
	  icon: _opera2.default,
	  color: 'red'
	}];
	
	exports.default = function () {
	
	  return _react2.default.createElement(
	    _Portal2.default,
	    { isOpened: true },
	    _react2.default.createElement(
	      'div',
	      { className: 'unsupported-browser-wrapper', role: 'alert' },
	      _react2.default.createElement(
	        'div',
	        { className: 'inner-wrapper' },
	        _react2.default.createElement(
	          'header',
	          null,
	          _react2.default.createElement('img', { src: Logo, alt: LOGO_ALT }),
	          _react2.default.createElement(
	            'div',
	            { className: 'flex-column title-wrapper' },
	            _react2.default.createElement(
	              'h1',
	              { className: 'statetitle' },
	              ("Montana")
	            ),
	            _react2.default.createElement(
	              'span',
	              { className: 'subtext' },
	              ("Secretary of State")
	            )
	          ),
	          _react2.default.createElement(
	            'p',
	            null,
	            ("Online Services Portal")
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'message-wrapper' },
	          _react2.default.createElement(
	            'p',
	            null,
	            ("Internet Explorer is not supported. Please select a supported browser below to access this website.")
	          ),
	          _react2.default.createElement(_Markdown2.default, { source: ({"NODE_ENV":"production","BUILD_DATE":"2025-08-27T15:15:31.687Z","BUILD_NUMBER":"Not Provided","GIT_VERSION":"v1.3.0-381-ga81e29b08","GIT_COMMIT_HASH":"a81e29b085c9268ffd96c78eb734365802722741","GIT_BRANCH":"beta","PUBLIC_URL":"","STATE_ABBR":"MT","STATE_NAME":"Montana","STATE_ORG_TITLE":"Secretary of State","LOGIN_HEADER_IMG_PATH":"","HOME_IMG_FILENAME":"montana.jpg","FAVICON_FILE_NAME":"favicon.ico","ALLOW_E_SIGN_ON_CORRECTIONS":true,"THIRD_PARTY_SIGNING_ALLOWED":false,"MY_ACCOUNT_SAVE_AND_CLOSE_BUTTON":true,"IE_DEPRECATED_MESSAGE":"Internet Explorer is not supported. Please select a supported browser below to access this website.","ADDITIONAL_ROUTES":{"dataRequests":true,"farmBill":true,"apostille":true,"externalHelp":"https://sosmt.gov/business/help-center/","systemAdministration":[{"title":"Saved Payments","parameter":"saved-payments","componentName":"SavedPayments"}]},"SUBROUTES":[{"label":"Business","component":"Business","parameter":"business","myWorkQueueSearch":false,"sourceTypeId":54,"searchMustHaveOneOf":["FILING_TYPE_ID","STATUS_ID","STATE","search"],"serverWebSearchDescription":true,"serverWorkQueueDescription":true,"serverMyRecordsDescription":true,"searchPlaceholder":"Search by name or filing number (X########)","allowEmptySearchTerm":true,"requestCertificateAlternateLabel":"Request Information","fileAmendmentButtonLabel":"Filing Actions","advancedSearchParameters":[{"type":"radio","name":"QUERY_TYPE_ID","defaultValue":1010,"options":[{"value":1010,"label":"Starts with"},{"value":1011,"label":"Contains"},{"value":1012,"label":" Word Contains"}]},{"type":"serverSelect","name":"FILING_TYPE_ID","optionsSrc":"FILING_TYPES","label":"Entity Type","placeholder":"All","defaultValue":"0"},{"type":"serverSelect","name":"FILING_SUBTYPE_ID","optionsSrc":"FILING_SUBTYPES","label":"Entity Subtype","overrideSubOptionsSrcFromParameterName":"FILING_TYPE_ID","placeholder":"All","defaultValue":"0"},{"type":"serverSelect","name":"STATUS_ID","optionsSrc":"FILING_STATUS_WITHOUT_ALL","label":"Status","placeholder":"All","defaultValue":"0"},{"type":"serverSelect","name":"STATE","optionsSrc":"STATE","label":"State","placeholder":"All","defaultValue":""},{"type":"serverSelect","name":"COUNTY","optionsSrc":"COUNTY_SUBOPTION","label":"County","overrideSubOptionsSrcFromParameterName":"STATE","placeholder":"All","defaultValue":""},{"type":"checkbox","name":"CRA_SEARCH_YN","defaultValue":false,"label":"Search by Registered Agent PID"},{"type":"dateRange","name":"FILING_DATE","label":"Registration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}},{"type":"dateRange","name":"EXPIRATION_DATE","label":"Expiration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}}],"myRecordsFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Active"},{"value":2,"label":"Inactive"},{"value":3,"label":"Pending"}]},{"type":"dateRange","name":"DATE_RANGE","label":"Date range","defaultValue":{"start":null,"end":null}}],"myWorkQueueFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Approved"},{"value":2,"label":"Pending Online Payment"},{"value":3,"label":"Pending Review"},{"value":4,"label":"Needs Correction"},{"value":5,"label":"Rejected"},{"value":6,"label":"Draft"}]},{"type":"dateRange","name":"DATE_RANGE","label":"Date range","defaultValue":{"start":null,"end":null}}]},{"label":"Notary","component":"Notary","parameter":"notary","sourceTypeId":850,"myWorkQueueSearch":false,"allowEmptySearchTerm":true,"requestCertificateAlternateLabel":"Download Certificate","fileAmendmentButtonLabel":"Filing Actions","hideNameRequestCertificate":true,"hideAddressRequestCertificate":true,"hideRecordUserManagment":true,"searchPlaceholder":"Search by name or commission number","searchMustHaveOneOf":["CITY","search","SERVICE_TYPE"],"advancedParametersStartOpen":true,"searchIsSortable":true,"advancedSearchParameters":[{"type":"radio","name":"STARTS_WITH_YN","defaultValue":false,"options":[{"value":true,"label":"Starts with"},{"value":false,"label":"Contains"}]},{"type":"checkbox","name":"ACTIVE_ONLY_YN","defaultValue":true,"label":"Active entities only"},{"type":"text","name":"CITY","defaultValue":"","label":"City"},{"type":"select","name":"SERVICE_TYPE","label":"Special Services Offered","defaultValue":0,"options":[{"value":0,"label":"(N/A)"},{"value":6165,"label":"In-Person Electronic Notarization (IPEN)"},{"value":6166,"label":"Remote Online Notarization (RON)"},{"value":6167,"label":"Mobile Notary Services"},{"value":6168,"label":"Remote Ink Notarization (RIN)"}]}]},{"label":"Apostille","component":"Apostille","parameter":"apostille","sourceTypeId":720,"myRecordsSearch":false,"myWorkQueueSearch":false,"disabled":false,"allowedRoutes":["/forms-manager/","/queue/","/forms/"]},{"label":"Liens","component":"UCC","parameter":"ucc","sourceTypeId":1999,"myRecordsSearch":true,"myWorkQueueSearch":true,"fileAmendmentButtonLabel":"Filing Actions","searchPlaceholder":"Search by name or file number","disabled":false,"serverWebSearchDescription":true,"myRecordsDescription":"","workQueueDescription":"","searchDescription":"","hideRecordUserManagment":true,"searchLiensCheckout":false,"advancedSearchParameters":[{"type":"radio","name":"STARTS_WITH_YN","defaultValue":false,"options":[{"value":true,"label":"Starts with"},{"value":false,"label":"Contains"}]},{"type":"select","name":"STATUS","defaultValue":"ALL","label":"Status","options":[{"value":"ACTIVE_UNLAPSED","label":"Active (unlapsed)"},{"value":"ACTIVE_LAPSED_UNLAPSED","label":"Active (lapsed and unlapsed)"}]},{"type":"text","name":"EXCLUDE_VALUES","label":"Exclude Debtor Names (comma separated list of names to exclude)","defaultValue":""},{"type":"dateRange","name":"FILING_DATE","label":"Financing Statement Date","defaultValue":{"start":null,"end":null}},{"type":"dateRange","name":"LAPSE_DATE","label":"Lapse Date","defaultValue":{"start":null,"end":null}},{"type":"text","name":"CITY","label":"Debtor City","defaultValue":""}],"myRecordsFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Approved"},{"value":2,"label":"Pending Online Payment"},{"value":3,"label":"Pending Review"}]},{"type":"select","name":"TYPE","defaultValue":0,"label":"Lien Type","options":[{"value":0,"label":"All"},{"value":1,"label":"UCC"},{"value":2,"label":"EFS"},{"value":3,"label":"Title 71"}]}],"myWorkQueueFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Approved"},{"value":2,"label":"Pending Online Payment"},{"value":3,"label":"Pending Review"},{"value":4,"label":"Pending Print and Mail"},{"value":5,"label":"Rejected"},{"value":6,"label":"Draft"}]},{"type":"select","name":"TYPE","defaultValue":0,"label":"Lien Type","options":[{"value":0,"label":"All"},{"value":1,"label":"UCC"},{"value":2,"label":"EFS"},{"value":3,"label":"Title 71"}]}]},{"label":"Copy Request","component":"copies","parameter":"copies","sourceTypeId":2001,"myRecordsSearch":false,"myWorkQueueSearch":false,"disabled":false,"allowedRoutes":["/forms-manager/","/queue/","/forms/"]},{"label":"Trademark","component":"Trademark","parameter":"trademark","sourceTypeId":810,"showRequestCertificate":true,"searchMustHaveOneOf":["search","EXPIRATION_DATE","FILING_DATE"],"allowEmptySearchTerm":true,"requestCertificateAlternateLabel":"Request Information","fileAmendmentButtonLabel":"Filing Actions","advancedSearchParameters":[{"type":"radio","name":"QUERY_TYPE_ID","defaultValue":1010,"options":[{"value":1010,"label":"Starts with"},{"value":1011,"label":"Contains"},{"value":1012,"label":" Word Contains"}]},{"type":"checkbox","name":"OWNER_SEARCH_YN","defaultValue":false,"label":"Search owners"},{"type":"radio","name":"SERVICE_MARK_YN","label":"Mark Type","defaultValue":"","options":[{"value":"","label":"All Marks"},{"value":"Y","label":"Service Mark"},{"value":"N","label":"Trademark"}]},{"type":"serverSelect","name":"STATUS_ID","optionsSrc":"TYPE_V|TRADEMARK_STATUS_TYPE","label":"Status","placeholder":"All","defaultValue":"0"},{"type":"select","name":"DESIGN_TYPE_ID","options":[{"value":0,"label":"All"},{"value":990,"label":"Words Only"},{"value":991,"label":"Design Only"},{"value":992,"label":"Words and Design"}],"label":"Design Type","defaultValue":"0"},{"type":"dateRange","name":"FILING_DATE","label":"Registered Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}},{"type":"dateRange","name":"EXPIRATION_DATE","label":"Expiration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}}]},{"label":"Business Info Request","component":"InfoRequests","parameter":"info-request","sourceTypeId":167,"allowedRoutes":["/forms-manager/","/queue/","/forms/"]},{"label":"Data Requests","component":"DataRequests","parameter":"data-request","sourceTypeId":0,"allowedRoutes":["/forms-manager/"]},{"label":"CRA","component":"CRA","parameter":"cra","sourceTypeId":157,"myRecordsSearch":false,"searchPlaceholder":"Search by name or registered agent number","allowedRoutes":["/forms-manager/","/forms/","/records/","/queue/","/search/"],"allowEmptySearchTerm":true,"fileAmendmentButtonLabel":"Filing Actions","advancedSearchParameters":[{"type":"radio","name":"QUERY_TYPE_ID","defaultValue":1010,"options":[{"value":1010,"label":"Starts with"},{"value":1011,"label":"Contains"},{"value":1012,"label":" Word Contains"}]},{"type":"dateRange","name":"CRA_DATE","label":"Registration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}},{"type":"select","name":"STATUS_ID","label":"Status","defaultValue":0,"options":[{"value":0,"label":"All"},{"value":121,"label":"Active"},{"value":122,"label":"Inactive"}]},{"type":"select","name":"AGENT_TYPE_ID","label":"Agent Type","defaultValue":0,"options":[{"value":0,"label":"All"},{"value":460,"label":"Registered Agent"},{"value":461,"label":"Commercial Registered Agent"}]}]},{"label":"Farm Bill","component":"FarmBill","parameter":"farm-bill","path":"/lists/farm-bill","sourceTypeId":0,"myRecordsSearch":false,"allowedRules":["/search/"],"disabled":true,"searchDescription":"To perform a search, enter a debtor name. Your search results may include: exact debtor name, variations of that name and any filing that includes your search criteria. Punctuation is ignored.\n\nYou can click on \"Advanced\" to refine your search. Under “Advanced” you can search by crop, year, county and SSN/FEIN. As a registered Farm Bill Buyer with the Montana Secretary of State’s office it is important to maintain the confidentiality of the information contained within the Farm Bill Master List. The Farm Bill Master List reflects personal data, such as Social Security Numbers, which are a key piece of personal identifiable information to assist you in determining the existence of a lien against a specific debtor. The distribution of this information beyond its intended purpose is strictly prohibited.\n\nThe debtor's tax identification number has been hidden for confidentiality reasons. You may continue to search on a tax ID number and return debtors that match your search criteria. The SSN/FEIN must be entered without dashes or spaces.","searchMustHaveOneOf":["search","UCC_FARM_PRODUCT_ID","COUNTY"],"searchPlaceholder":"Search by debtor name","advancedSearchParameters":[{"type":"ServerMultiComplete","label":"Product code name(s)","name":"UCC_FARM_PRODUCT_ID","defaultValue":"","optionsSrc":"UCC_FARM_PRODUCT_V"},{"type":"MultiComplete","label":"Year or Range of Years","name":"YEAR_NUM","optionsSrc":"years","startYear":"1968","defaultValue":[],"preMergeOptions":[{"value":"ALL","label":"All"}]},{"type":"serverSelect","label":"State","name":"STATE","defaultValue":"MONTANA","optionsSrc":"STATE"},{"type":"ServerMultiComplete","label":"County","name":"COUNTY","defaultValue":[],"optionsSrc":"COUNTY","overrideSubOptionsSrcFromParameterName":"STATE"},{"type":"checkbox","name":"TIN_SEARCH_YN","defaultValue":false,"label":"Tax Identification Number Search"},{"type":"checkbox","name":"TIN_SORT_YN","defaultValue":false,"label":"Unique ID Sort"}]}],"SYSTEM_NICKNAME":"Online Services Portal","PAYMENT_METHODS":[{"type":"bypass"},{"type":"iTransact"}],"PAYMENT_ALLOW_AMEX":true,"SYSTEM_ID_LABEL":"System Id","DOUBLE_COLUMN_PUBLIC_LOGIN":true,"INTERNAL_USER_MANAGEMENT":true,"ALLOW_PUBLIC_JSON_IMPORT":false,"MAX_FILE_UPLOAD_SIZE":10000000,"REFUND_TEXT":"","RETURN_TO_HOME_ON_LOGOUT":true,"CURRENT_SOS_NAME":"Christi Jacobsen","LOGO_FILENAME":"mt-sos-logo.png","LOGO_ALT":"Christi Jacobsen, Montana Secretary of State","LOGO_FULL_WIDTH":true,"HOME_HIDE_AUTH_HINT":true,"HOME_TITLE":"Montana Secretary of State","CUSTOM_TAB_TITLE":"Official Montana","HOME_SUBTITLE":"Online Business Services","ENTITY_NAME_CONSENT_DESCRIPTION":"","ALLOW_USER_PROFILE_EDITING":true,"COMPARE_FOREIGN_NAME_IN_ENTITY_NAME_VALIDATION":true,"FOREIGN_NAME_FIELD_NAME":"KIMA_PARENT_NAME_INFO","LOGIN_TITLE":"Montana Secretary of State Online Filing Portal Login","PUBLIC_LOGIN_LABEL":"Username","REVERSE_LOGIN_COLUMNS":true,"LOGIN_SEAL_FILENAME":"seal_white.png","SEPARATE_USERNAME_AND_EMAIL":true,"CREATE_ACCOUNT_BUTTON_ALIGN_LEFT":true,"CREATE_ACCOUNT_BUTTON_TEXT":"CREATE AN ACCOUNT","PASSWORD_CUSTOM_ERROR_TEXT":"The password must meet all requirements","ACCOUNT_CREATED_MESSAGE":"Please check your email to verify your account to login and allow a few minutes for this message to arrive. Check your junk/spam folders if you do not find the email in your inbox.","PUBLIC_LOGIN_PLACEHOLDER":" ","DISABLE_DEFAULT_PAYMENT_RADIO":true,"CUSTOM_RESET_PASSWORD_ERROR_MESSAGE":"Username invalid - no account found","PUBLIC_LOGIN_CREATE_DESCRIPTION":"### Existing User:\n\n  - Enter your username and password to login.  \n\n\n  #### - OR -  \n\n\n\n  - Forgot password? Click 'Reset Password' and follow the prompts.\n  - Forgot username? Click 'Forgot Username' and follow the prompts.  \n\n\n  ### New User:\n  ","LOGIN_HELP_LINK":"https://sosmt.gov/business/how-do-i/","LOGIN_HELP_LINK_TEXT":"Need Help?","FORGOT_USERNAME_TEXT":"Forgot Username?","LOGIN_ACTIVE_DIRECTORY_TEXT":"State User Login","MULTIPLE_LOGIN_METHODS":true,"HAS_ACTIVE_DIRECTORY_LOGIN":true,"RESET_PASSWORD_WITH_USERNAME":true,"DOWNLOAD_LINK":true,"SHOW_USERNAME_ACCOUNT_CREATE":true,"SHOW_SCROLL_DOWN_ARROW":true,"SHOW_ADDRESS_ACCOUNT_CREATE":true,"TWO_COLUMN_ACCOUNT_CREATE":true,"RESET_PASSWORD_TIP":"A link to change your password has been sent to your email. Please allow a few minutes for this message to arrive. Please check your junk/spam folders if you do not find the email in your inbox.","FORGOT_PASSWORD_LINK_TEXT":"Reset Password","PHONE_NUMBER_OPTIONAL_ACCOUNT_CREATE":true,"SHOW_REQUIRED_INDICATOR_ACCOUNT_CREATE":true,"PASSWORD_REQUIREMENTS_ACCOUNT_CREATE":"\n    <ul>\n      <li>MUST contain at least 8 characters (12+ recommended)</li>\n      <li>MUST contain at least one uppercase letter.</li>\n      <li>MUST contain at least one lowercase letter.</li>\n      <li>MUST contain at least one number.</li>\n      <li>MUST contain at least one special character (!”#$%&'()*+,-./:;<=>?</li>\n    </ul>\n  ","ALLOW_CERTIFICATION_REQUEST":true,"ALLOW_PUBLIC_CERTIFICATE_REQUEST":true,"ALLOW_COPY_REQUEST":false,"ALLOW_CORRECTION_STYLING":true,"HIDE_DEPRECATION_WARNING":false,"AMEND_ROUTE_PUBLIC":true,"SEAL_FILENAME":"seal.png","SHOPPING_CART":true,"ALLOW_PAYMENT_UPDATE_WITH_EMPTY_CART":true,"RA_EMAIL":true,"RA_WEBSITE":true,"RA_NO_DEFAULT_TYPE":true,"RA_ADDRESS_LABEL":"Street Address","RA_TYPE_SELECTION_DEFAULT":true,"RA_DEFAULT_TYPE":"460","RA_OVERRIDE_TYPE_WITH_DEFAULT":true,"RA_PRINCIPAL_ADDRESS_AMS":true,"UPLOAD_AND_SUBMIT_HIDE_IF_ONE_OPTION":true,"PAYMENT_PROCESSING_MESSAGE":"Your payment is processing - Do not close your browser or click the back button","CHECKOUT_BUTTON_WHEN_PROCESSING_TEXT":"Processing","EFS_CROP_PICKER_NONE_LABEL":"Lien Duration","DISALLOWED_WIZARD_PIECES":["FormationLocale"],"REPEATER_SHOW_EDIT_BUTTON":true,"DATA_REQUEST_PAGE_TITLE":"Data Requests and Subscriptions","DATA_REQUEST_SIDEBAR_LABEL":"Data Requests & Subscriptions","LOGIN_REDIRECTS_TO_EPASS":false,"LOGIN_REDIRECTS_TO_ACTIVE_DIRECTORY":true,"LOGIN_ACTIVE_DIRECTORY_LINK":true,"FETCH_EDIT_USER_LINK":false,"LISTS_FETCH_AVAILABLE_LISTS":true,"POST_WIZARD_SUBMIT_REDIRECT_URL":"/","PIN_REQUEST_ATTESTATIONS":true,"PIN_REQUEST_DESCRIPTION":"Click **Request PIN** to have a new PIN sent to the account holder's email address on file.","OWNERSHIP_REQUEST_DESCRIPTION":"To become an **authorized user** of this record, a current **AUTHORIZED USER** will need to grant you access. To request access, click **Request Access** below.","PIN_REQUEST_SUCCESS_MESSAGE":"The PIN you have requested for this entity has been sent to the email associated with your user account.  You should receive the PIN in approximately 3-5 minutes, depending on your email service provider.","APOSTILLE_HEADER_LABEL":"Verification Information","APOSTILLE_NUMBER_LABEL":"Apostille/Authentication","APOSTILLE_CITY_STATE_OVERRIDE":"HELENA, MT","APOSTILLE_FILING_DATE_LABEL":"Issue Date","APOSTILLE_CITY_STATE_IN_CERTIFIED":true,"NOTARY_EXISTING_FILING":true,"ALLOW_REVOKE_OWN_ACCESS_ONLY":false,"HIDE_CANCEL_ON_ONETIME_DATA_REQUESTS":true,"DATA_REQUESTS_IN_SHOPPING_CART":true,"WQ_ALLOW_EDIT_PENDING_PAYMENT":true,"WQ_CONFIRM_ON_DELETE":true,"WQ_DELETE_CONFIRM_MESSAGE":"Deleting this filing will forfeit any money already paid to the Secretary of State. This action is permanent and cannot be undone, are you sure you would like to delete?","PASS_ITEM_GUIDS_ON_CHECKOUT":true,"FORM_REVISION_HISTORY":true,"CHECKOUT_DISCLAIMER":"By entering your credit card and/or checking account information you (i) state that **you are an authorized user** of the credit card and/or electronic check and that the associated information entered (e.g., account holder name, account number, billing address) is accurate, (ii) **you authorize payment processor to charge the amount you have requested** to your credit card and/or funding account, and (iii) **acknowledge if a charge is declined or reversed you may also be assessed a customary charge** by the payment processor for such transactions.","FARM_BILL_SEARCH_CONFIDENTIAL":"As a registered Farm Bill Buyer with the Montana Secretary of State’s office it is important to maintain the confidentiality of the information contained within the Farm Bill Master List. The Farm Bill Master List reflects personal data, such as Social Security Numbers, which are a key piece of personal identifiable information to assist you in determining the existence of a lien against a specific debtor. The distribution of this information beyond its intended purpose is strictly prohibited.\n\n**The debtor's tax identification number has been hidden for confidentiality reasons. You may continue to search on a tax ID number and return debtors that match your search criteria. The SSN/FEIN must be entered without dashes or spaces.  If you need access to the tax identification number to clearly identify the debtor, please contact the UCC unit at (406) 444-3665.**","VIEW_HISTORY_BUTTON_ALT_TEXT":"View Filings","WIZARD_ERROR_TITLE_MESSAGE":"Form Error","FARM_BILL_SEARCH_INTERACTIVE":true,"USE_FARM_BILL_API":true,"DISALLOW_ASSIGN_SELF_AS_RA":true,"DISALLOW_ASSIGN_SELF_AS_PRINCIPAL":true,"USE_TRADEMARK_OWNER_VALIDATION":true,"USE_ALTERNATIVE_FOREIGN_ADDRESS_LABELS":true,"MY_RECEIPTS_FILTER":[{"type":"dateRange","name":"DATE_RANGE","label":"Date range","defaultValue":{"start":null,"end":null}},{"type":"text","name":"REF_NUM","defaultValue":"","label":"Reference Number"},{"type":"text","name":"RECEIPT_NUM","defaultValue":"","label":"Receipt Id"},{"type":"text","name":"AMOUNT","defaultValue":"","label":"Amount"},{"type":"select","name":"TYPE","defaultValue":"","label":"Payment Type","options":[{"value":"","label":"All"},{"value":"CC","label":"Credit Card"},{"value":"Check","label":"Check"}]}],"MY_RECEIPTS_SHOW_IN_SIDEBAR":true,"SHOW_MY_RECEIPTS_HELPER_TEXT":true,"MY_RECEIPTS_HELPER_LABEL":"About Receipt Search","MY_RECEIPTS_HELPER_TEXT":"You can search for receipts based on their descriptions, including the items paid for on the receipt. Use the filters to search for or filter specific information.","FARM_BILL_SUBLINK":{"label":"Farm Bill","component":"FarmBill","parameter":"farm-bill","path":"/lists/farm-bill","sourceTypeId":0,"myRecordsSearch":false,"allowedRules":["/search/"],"disabled":true,"searchDescription":"To perform a search, enter a debtor name. Your search results may include: exact debtor name, variations of that name and any filing that includes your search criteria. Punctuation is ignored.\n\nYou can click on \"Advanced\" to refine your search. Under “Advanced” you can search by crop, year, county and SSN/FEIN. As a registered Farm Bill Buyer with the Montana Secretary of State’s office it is important to maintain the confidentiality of the information contained within the Farm Bill Master List. The Farm Bill Master List reflects personal data, such as Social Security Numbers, which are a key piece of personal identifiable information to assist you in determining the existence of a lien against a specific debtor. The distribution of this information beyond its intended purpose is strictly prohibited.\n\nThe debtor's tax identification number has been hidden for confidentiality reasons. You may continue to search on a tax ID number and return debtors that match your search criteria. The SSN/FEIN must be entered without dashes or spaces.","searchMustHaveOneOf":["search","UCC_FARM_PRODUCT_ID","COUNTY"],"searchPlaceholder":"Search by debtor name","advancedSearchParameters":[{"type":"ServerMultiComplete","label":"Product code name(s)","name":"UCC_FARM_PRODUCT_ID","defaultValue":"","optionsSrc":"UCC_FARM_PRODUCT_V"},{"type":"MultiComplete","label":"Year or Range of Years","name":"YEAR_NUM","optionsSrc":"years","startYear":"1968","defaultValue":[],"preMergeOptions":[{"value":"ALL","label":"All"}]},{"type":"serverSelect","label":"State","name":"STATE","defaultValue":"MONTANA","optionsSrc":"STATE"},{"type":"ServerMultiComplete","label":"County","name":"COUNTY","defaultValue":[],"optionsSrc":"COUNTY","overrideSubOptionsSrcFromParameterName":"STATE"},{"type":"checkbox","name":"TIN_SEARCH_YN","defaultValue":false,"label":"Tax Identification Number Search"},{"type":"checkbox","name":"TIN_SORT_YN","defaultValue":false,"label":"Unique ID Sort"}]},"ALLOW_ADDRESS_VALIDATION_BYPASS_OPTION":true,"DEFAULT_ADDRESS_VALIDATION_BYPASS_OPTION_CHECKED":true}).UNSUPPORTED_BROWSER_MESSAGE }),
	          _react2.default.createElement(
	            'div',
	            { className: 'browser-list' },
	            _react2.default.createElement(
	              'div',
	              { className: 'browser-column' },
	              BROWSERS.slice(0, 3).map(function (browser) {
	                return _react2.default.createElement(
	                  'a',
	                  { href: browser.link, 'data-hover-color': browser.color, target: '_blank' },
	                  _react2.default.createElement('img', { src: browser.icon, alt: '' }),
	                  _react2.default.createElement(
	                    'span',
	                    null,
	                    browser.name
	                  )
	                );
	              })
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'browser-column' },
	              BROWSERS.slice(3, 5).map(function (browser) {
	                return _react2.default.createElement(
	                  'a',
	                  { href: browser.link, 'data-hover-color': browser.color, target: '_blank' },
	                  _react2.default.createElement('img', { src: browser.icon, alt: '' }),
	                  _react2.default.createElement(
	                    'span',
	                    null,
	                    browser.name
	                  )
	                );
	              })
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'unsupported-footer' },
	          _react2.default.createElement(
	            'span',
	            null,
	            'Icons by ',
	            _react2.default.createElement(
	              'a',
	              { target: '_blank', href: 'https://icons8.com' },
	              'Icons8'
	            )
	          )
	        )
	      )
	    )
	  );
	};

/***/ },
/* 1150 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Portal = __webpack_require__(12);
	
	var _Portal2 = _interopRequireDefault(_Portal);
	
	var _Modal = __webpack_require__(13);
	
	var _reactRedux = __webpack_require__(7);
	
	var _Field = __webpack_require__(25);
	
	var _Form = __webpack_require__(14);
	
	var _FrequentPayor = __webpack_require__(457);
	
	var _requests = __webpack_require__(6);
	
	var _AuthActions = __webpack_require__(66);
	
	__webpack_require__(1474);
	
	var _validate = __webpack_require__(45);
	
	var _requests2 = __webpack_require__(6);
	
	var _Loaders = __webpack_require__(16);
	
	var _toggleModalObscuredContext = __webpack_require__(471);
	
	var _toggleModalObscuredContext2 = _interopRequireDefault(_toggleModalObscuredContext);
	
	var _AddressBlock = __webpack_require__(102);
	
	var _AddressBlock2 = _interopRequireDefault(_AddressBlock);
	
	var _WizardClasses = __webpack_require__(35);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var UserAccountEditor = function (_React$Component) {
	  _inherits(UserAccountEditor, _React$Component);
	
	  function UserAccountEditor() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, UserAccountEditor);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = UserAccountEditor.__proto__ || Object.getPrototypeOf(UserAccountEditor)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      error: null,
	      obscured: false
	    }, _this.componentWillReceiveProps = function (nextProps) {
	      if (_this.props.isOpen === false && nextProps.isOpen === true) {
	        _this.setState({ error: null });
	      }
	    }, _this.saveUser = function (closeModal) {
	      _this.setState({ error: null });
	      var values = _this.getEditorState();
	      (0, _requests.UPDATE_WEB_USER)({
	        firstName: values.FIRST_NAME,
	        middleName: values.MIDDLE_NAME,
	        lastName: values.LAST_NAME,
	        orgName: values.ORG_NAME,
	        email:  true ? values.EMAIL : values.USERNAME,
	        username:  true ? values.USERNAME : '',
	        phone: values.PHONE,
	        addr1: values.ADDRESS ? values.ADDRESS.ADDR1 : '',
	        addr2: values.ADDRESS ? values.ADDRESS.ADDR2 : '',
	        addr3: values.ADDRESS ? values.ADDRESS.ADDR3 : '',
	        city: values.ADDRESS ? values.ADDRESS.CITY : '',
	        state: values.ADDRESS ? values.ADDRESS.STATE : '',
	        postal_code: values.ADDRESS ? values.ADDRESS.POSTAL_CODE : '',
	        country: values.ADDRESS ? values.ADDRESS.COUNTRY : ''
	      }, function (success) {
	        if (success) {
	          closeModal();
	          localStorage.setItem('WEB_USER', JSON.stringify(values));
	          var FIRST_NAME = values.FIRST_NAME,
	              MIDDLE_NAME = values.MIDDLE_NAME,
	              LAST_NAME = values.LAST_NAME,
	              ORG_NAME = values.ORG_NAME,
	              USERNAME = values.USERNAME,
	              EMAIL = values.EMAIL,
	              ADDRESS = values.ADDRESS,
	              PHONE = values.PHONE;
	
	          _this.props.spreadAuthAttributes(Object.assign({
	            FIRST_NAME: FIRST_NAME,
	            LAST_NAME: LAST_NAME,
	            MIDDLE_NAME: MIDDLE_NAME,
	            ORG_NAME: ORG_NAME,
	            USERNAME: USERNAME,
	            EMAIL: EMAIL
	          }, ADDRESS, {
	            PHONE: PHONE
	          }));
	        }
	      }, function (err) {
	        _this.setState({ error: err.message || err.Message });
	      });
	    }, _this.cancel = function () {}, _this.toggleModalObscured = function (obscured) {
	      _this.setState(function (state) {
	        return {
	          obscured: obscured !== undefined ? obscured : !state.obscured
	        };
	      });
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(UserAccountEditor, [{
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _props = this.props,
	          isOpen = _props.isOpen,
	          onClose = _props.onClose;
	
	      var showSaveAndClose = (true);
	      return _react2.default.createElement(
	        _Portal2.default,
	        { isOpened: isOpen },
	        _react2.default.createElement(
	          _toggleModalObscuredContext2.default.Provider,
	          { value: this.toggleModalObscured },
	          _react2.default.createElement(
	            _Modal.Modal,
	            {
	              closeModal: onClose,
	              modalSize: 'small',
	              title: ({"NODE_ENV":"production","BUILD_DATE":"2025-08-27T15:15:31.687Z","BUILD_NUMBER":"Not Provided","GIT_VERSION":"v1.3.0-381-ga81e29b08","GIT_COMMIT_HASH":"a81e29b085c9268ffd96c78eb734365802722741","GIT_BRANCH":"beta","PUBLIC_URL":"","STATE_ABBR":"MT","STATE_NAME":"Montana","STATE_ORG_TITLE":"Secretary of State","LOGIN_HEADER_IMG_PATH":"","HOME_IMG_FILENAME":"montana.jpg","FAVICON_FILE_NAME":"favicon.ico","ALLOW_E_SIGN_ON_CORRECTIONS":true,"THIRD_PARTY_SIGNING_ALLOWED":false,"MY_ACCOUNT_SAVE_AND_CLOSE_BUTTON":true,"IE_DEPRECATED_MESSAGE":"Internet Explorer is not supported. Please select a supported browser below to access this website.","ADDITIONAL_ROUTES":{"dataRequests":true,"farmBill":true,"apostille":true,"externalHelp":"https://sosmt.gov/business/help-center/","systemAdministration":[{"title":"Saved Payments","parameter":"saved-payments","componentName":"SavedPayments"}]},"SUBROUTES":[{"label":"Business","component":"Business","parameter":"business","myWorkQueueSearch":false,"sourceTypeId":54,"searchMustHaveOneOf":["FILING_TYPE_ID","STATUS_ID","STATE","search"],"serverWebSearchDescription":true,"serverWorkQueueDescription":true,"serverMyRecordsDescription":true,"searchPlaceholder":"Search by name or filing number (X########)","allowEmptySearchTerm":true,"requestCertificateAlternateLabel":"Request Information","fileAmendmentButtonLabel":"Filing Actions","advancedSearchParameters":[{"type":"radio","name":"QUERY_TYPE_ID","defaultValue":1010,"options":[{"value":1010,"label":"Starts with"},{"value":1011,"label":"Contains"},{"value":1012,"label":" Word Contains"}]},{"type":"serverSelect","name":"FILING_TYPE_ID","optionsSrc":"FILING_TYPES","label":"Entity Type","placeholder":"All","defaultValue":"0"},{"type":"serverSelect","name":"FILING_SUBTYPE_ID","optionsSrc":"FILING_SUBTYPES","label":"Entity Subtype","overrideSubOptionsSrcFromParameterName":"FILING_TYPE_ID","placeholder":"All","defaultValue":"0"},{"type":"serverSelect","name":"STATUS_ID","optionsSrc":"FILING_STATUS_WITHOUT_ALL","label":"Status","placeholder":"All","defaultValue":"0"},{"type":"serverSelect","name":"STATE","optionsSrc":"STATE","label":"State","placeholder":"All","defaultValue":""},{"type":"serverSelect","name":"COUNTY","optionsSrc":"COUNTY_SUBOPTION","label":"County","overrideSubOptionsSrcFromParameterName":"STATE","placeholder":"All","defaultValue":""},{"type":"checkbox","name":"CRA_SEARCH_YN","defaultValue":false,"label":"Search by Registered Agent PID"},{"type":"dateRange","name":"FILING_DATE","label":"Registration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}},{"type":"dateRange","name":"EXPIRATION_DATE","label":"Expiration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}}],"myRecordsFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Active"},{"value":2,"label":"Inactive"},{"value":3,"label":"Pending"}]},{"type":"dateRange","name":"DATE_RANGE","label":"Date range","defaultValue":{"start":null,"end":null}}],"myWorkQueueFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Approved"},{"value":2,"label":"Pending Online Payment"},{"value":3,"label":"Pending Review"},{"value":4,"label":"Needs Correction"},{"value":5,"label":"Rejected"},{"value":6,"label":"Draft"}]},{"type":"dateRange","name":"DATE_RANGE","label":"Date range","defaultValue":{"start":null,"end":null}}]},{"label":"Notary","component":"Notary","parameter":"notary","sourceTypeId":850,"myWorkQueueSearch":false,"allowEmptySearchTerm":true,"requestCertificateAlternateLabel":"Download Certificate","fileAmendmentButtonLabel":"Filing Actions","hideNameRequestCertificate":true,"hideAddressRequestCertificate":true,"hideRecordUserManagment":true,"searchPlaceholder":"Search by name or commission number","searchMustHaveOneOf":["CITY","search","SERVICE_TYPE"],"advancedParametersStartOpen":true,"searchIsSortable":true,"advancedSearchParameters":[{"type":"radio","name":"STARTS_WITH_YN","defaultValue":false,"options":[{"value":true,"label":"Starts with"},{"value":false,"label":"Contains"}]},{"type":"checkbox","name":"ACTIVE_ONLY_YN","defaultValue":true,"label":"Active entities only"},{"type":"text","name":"CITY","defaultValue":"","label":"City"},{"type":"select","name":"SERVICE_TYPE","label":"Special Services Offered","defaultValue":0,"options":[{"value":0,"label":"(N/A)"},{"value":6165,"label":"In-Person Electronic Notarization (IPEN)"},{"value":6166,"label":"Remote Online Notarization (RON)"},{"value":6167,"label":"Mobile Notary Services"},{"value":6168,"label":"Remote Ink Notarization (RIN)"}]}]},{"label":"Apostille","component":"Apostille","parameter":"apostille","sourceTypeId":720,"myRecordsSearch":false,"myWorkQueueSearch":false,"disabled":false,"allowedRoutes":["/forms-manager/","/queue/","/forms/"]},{"label":"Liens","component":"UCC","parameter":"ucc","sourceTypeId":1999,"myRecordsSearch":true,"myWorkQueueSearch":true,"fileAmendmentButtonLabel":"Filing Actions","searchPlaceholder":"Search by name or file number","disabled":false,"serverWebSearchDescription":true,"myRecordsDescription":"","workQueueDescription":"","searchDescription":"","hideRecordUserManagment":true,"searchLiensCheckout":false,"advancedSearchParameters":[{"type":"radio","name":"STARTS_WITH_YN","defaultValue":false,"options":[{"value":true,"label":"Starts with"},{"value":false,"label":"Contains"}]},{"type":"select","name":"STATUS","defaultValue":"ALL","label":"Status","options":[{"value":"ACTIVE_UNLAPSED","label":"Active (unlapsed)"},{"value":"ACTIVE_LAPSED_UNLAPSED","label":"Active (lapsed and unlapsed)"}]},{"type":"text","name":"EXCLUDE_VALUES","label":"Exclude Debtor Names (comma separated list of names to exclude)","defaultValue":""},{"type":"dateRange","name":"FILING_DATE","label":"Financing Statement Date","defaultValue":{"start":null,"end":null}},{"type":"dateRange","name":"LAPSE_DATE","label":"Lapse Date","defaultValue":{"start":null,"end":null}},{"type":"text","name":"CITY","label":"Debtor City","defaultValue":""}],"myRecordsFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Approved"},{"value":2,"label":"Pending Online Payment"},{"value":3,"label":"Pending Review"}]},{"type":"select","name":"TYPE","defaultValue":0,"label":"Lien Type","options":[{"value":0,"label":"All"},{"value":1,"label":"UCC"},{"value":2,"label":"EFS"},{"value":3,"label":"Title 71"}]}],"myWorkQueueFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Approved"},{"value":2,"label":"Pending Online Payment"},{"value":3,"label":"Pending Review"},{"value":4,"label":"Pending Print and Mail"},{"value":5,"label":"Rejected"},{"value":6,"label":"Draft"}]},{"type":"select","name":"TYPE","defaultValue":0,"label":"Lien Type","options":[{"value":0,"label":"All"},{"value":1,"label":"UCC"},{"value":2,"label":"EFS"},{"value":3,"label":"Title 71"}]}]},{"label":"Copy Request","component":"copies","parameter":"copies","sourceTypeId":2001,"myRecordsSearch":false,"myWorkQueueSearch":false,"disabled":false,"allowedRoutes":["/forms-manager/","/queue/","/forms/"]},{"label":"Trademark","component":"Trademark","parameter":"trademark","sourceTypeId":810,"showRequestCertificate":true,"searchMustHaveOneOf":["search","EXPIRATION_DATE","FILING_DATE"],"allowEmptySearchTerm":true,"requestCertificateAlternateLabel":"Request Information","fileAmendmentButtonLabel":"Filing Actions","advancedSearchParameters":[{"type":"radio","name":"QUERY_TYPE_ID","defaultValue":1010,"options":[{"value":1010,"label":"Starts with"},{"value":1011,"label":"Contains"},{"value":1012,"label":" Word Contains"}]},{"type":"checkbox","name":"OWNER_SEARCH_YN","defaultValue":false,"label":"Search owners"},{"type":"radio","name":"SERVICE_MARK_YN","label":"Mark Type","defaultValue":"","options":[{"value":"","label":"All Marks"},{"value":"Y","label":"Service Mark"},{"value":"N","label":"Trademark"}]},{"type":"serverSelect","name":"STATUS_ID","optionsSrc":"TYPE_V|TRADEMARK_STATUS_TYPE","label":"Status","placeholder":"All","defaultValue":"0"},{"type":"select","name":"DESIGN_TYPE_ID","options":[{"value":0,"label":"All"},{"value":990,"label":"Words Only"},{"value":991,"label":"Design Only"},{"value":992,"label":"Words and Design"}],"label":"Design Type","defaultValue":"0"},{"type":"dateRange","name":"FILING_DATE","label":"Registered Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}},{"type":"dateRange","name":"EXPIRATION_DATE","label":"Expiration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}}]},{"label":"Business Info Request","component":"InfoRequests","parameter":"info-request","sourceTypeId":167,"allowedRoutes":["/forms-manager/","/queue/","/forms/"]},{"label":"Data Requests","component":"DataRequests","parameter":"data-request","sourceTypeId":0,"allowedRoutes":["/forms-manager/"]},{"label":"CRA","component":"CRA","parameter":"cra","sourceTypeId":157,"myRecordsSearch":false,"searchPlaceholder":"Search by name or registered agent number","allowedRoutes":["/forms-manager/","/forms/","/records/","/queue/","/search/"],"allowEmptySearchTerm":true,"fileAmendmentButtonLabel":"Filing Actions","advancedSearchParameters":[{"type":"radio","name":"QUERY_TYPE_ID","defaultValue":1010,"options":[{"value":1010,"label":"Starts with"},{"value":1011,"label":"Contains"},{"value":1012,"label":" Word Contains"}]},{"type":"dateRange","name":"CRA_DATE","label":"Registration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}},{"type":"select","name":"STATUS_ID","label":"Status","defaultValue":0,"options":[{"value":0,"label":"All"},{"value":121,"label":"Active"},{"value":122,"label":"Inactive"}]},{"type":"select","name":"AGENT_TYPE_ID","label":"Agent Type","defaultValue":0,"options":[{"value":0,"label":"All"},{"value":460,"label":"Registered Agent"},{"value":461,"label":"Commercial Registered Agent"}]}]},{"label":"Farm Bill","component":"FarmBill","parameter":"farm-bill","path":"/lists/farm-bill","sourceTypeId":0,"myRecordsSearch":false,"allowedRules":["/search/"],"disabled":true,"searchDescription":"To perform a search, enter a debtor name. Your search results may include: exact debtor name, variations of that name and any filing that includes your search criteria. Punctuation is ignored.\n\nYou can click on \"Advanced\" to refine your search. Under “Advanced” you can search by crop, year, county and SSN/FEIN. As a registered Farm Bill Buyer with the Montana Secretary of State’s office it is important to maintain the confidentiality of the information contained within the Farm Bill Master List. The Farm Bill Master List reflects personal data, such as Social Security Numbers, which are a key piece of personal identifiable information to assist you in determining the existence of a lien against a specific debtor. The distribution of this information beyond its intended purpose is strictly prohibited.\n\nThe debtor's tax identification number has been hidden for confidentiality reasons. You may continue to search on a tax ID number and return debtors that match your search criteria. The SSN/FEIN must be entered without dashes or spaces.","searchMustHaveOneOf":["search","UCC_FARM_PRODUCT_ID","COUNTY"],"searchPlaceholder":"Search by debtor name","advancedSearchParameters":[{"type":"ServerMultiComplete","label":"Product code name(s)","name":"UCC_FARM_PRODUCT_ID","defaultValue":"","optionsSrc":"UCC_FARM_PRODUCT_V"},{"type":"MultiComplete","label":"Year or Range of Years","name":"YEAR_NUM","optionsSrc":"years","startYear":"1968","defaultValue":[],"preMergeOptions":[{"value":"ALL","label":"All"}]},{"type":"serverSelect","label":"State","name":"STATE","defaultValue":"MONTANA","optionsSrc":"STATE"},{"type":"ServerMultiComplete","label":"County","name":"COUNTY","defaultValue":[],"optionsSrc":"COUNTY","overrideSubOptionsSrcFromParameterName":"STATE"},{"type":"checkbox","name":"TIN_SEARCH_YN","defaultValue":false,"label":"Tax Identification Number Search"},{"type":"checkbox","name":"TIN_SORT_YN","defaultValue":false,"label":"Unique ID Sort"}]}],"SYSTEM_NICKNAME":"Online Services Portal","PAYMENT_METHODS":[{"type":"bypass"},{"type":"iTransact"}],"PAYMENT_ALLOW_AMEX":true,"SYSTEM_ID_LABEL":"System Id","DOUBLE_COLUMN_PUBLIC_LOGIN":true,"INTERNAL_USER_MANAGEMENT":true,"ALLOW_PUBLIC_JSON_IMPORT":false,"MAX_FILE_UPLOAD_SIZE":10000000,"REFUND_TEXT":"","RETURN_TO_HOME_ON_LOGOUT":true,"CURRENT_SOS_NAME":"Christi Jacobsen","LOGO_FILENAME":"mt-sos-logo.png","LOGO_ALT":"Christi Jacobsen, Montana Secretary of State","LOGO_FULL_WIDTH":true,"HOME_HIDE_AUTH_HINT":true,"HOME_TITLE":"Montana Secretary of State","CUSTOM_TAB_TITLE":"Official Montana","HOME_SUBTITLE":"Online Business Services","ENTITY_NAME_CONSENT_DESCRIPTION":"","ALLOW_USER_PROFILE_EDITING":true,"COMPARE_FOREIGN_NAME_IN_ENTITY_NAME_VALIDATION":true,"FOREIGN_NAME_FIELD_NAME":"KIMA_PARENT_NAME_INFO","LOGIN_TITLE":"Montana Secretary of State Online Filing Portal Login","PUBLIC_LOGIN_LABEL":"Username","REVERSE_LOGIN_COLUMNS":true,"LOGIN_SEAL_FILENAME":"seal_white.png","SEPARATE_USERNAME_AND_EMAIL":true,"CREATE_ACCOUNT_BUTTON_ALIGN_LEFT":true,"CREATE_ACCOUNT_BUTTON_TEXT":"CREATE AN ACCOUNT","PASSWORD_CUSTOM_ERROR_TEXT":"The password must meet all requirements","ACCOUNT_CREATED_MESSAGE":"Please check your email to verify your account to login and allow a few minutes for this message to arrive. Check your junk/spam folders if you do not find the email in your inbox.","PUBLIC_LOGIN_PLACEHOLDER":" ","DISABLE_DEFAULT_PAYMENT_RADIO":true,"CUSTOM_RESET_PASSWORD_ERROR_MESSAGE":"Username invalid - no account found","PUBLIC_LOGIN_CREATE_DESCRIPTION":"### Existing User:\n\n  - Enter your username and password to login.  \n\n\n  #### - OR -  \n\n\n\n  - Forgot password? Click 'Reset Password' and follow the prompts.\n  - Forgot username? Click 'Forgot Username' and follow the prompts.  \n\n\n  ### New User:\n  ","LOGIN_HELP_LINK":"https://sosmt.gov/business/how-do-i/","LOGIN_HELP_LINK_TEXT":"Need Help?","FORGOT_USERNAME_TEXT":"Forgot Username?","LOGIN_ACTIVE_DIRECTORY_TEXT":"State User Login","MULTIPLE_LOGIN_METHODS":true,"HAS_ACTIVE_DIRECTORY_LOGIN":true,"RESET_PASSWORD_WITH_USERNAME":true,"DOWNLOAD_LINK":true,"SHOW_USERNAME_ACCOUNT_CREATE":true,"SHOW_SCROLL_DOWN_ARROW":true,"SHOW_ADDRESS_ACCOUNT_CREATE":true,"TWO_COLUMN_ACCOUNT_CREATE":true,"RESET_PASSWORD_TIP":"A link to change your password has been sent to your email. Please allow a few minutes for this message to arrive. Please check your junk/spam folders if you do not find the email in your inbox.","FORGOT_PASSWORD_LINK_TEXT":"Reset Password","PHONE_NUMBER_OPTIONAL_ACCOUNT_CREATE":true,"SHOW_REQUIRED_INDICATOR_ACCOUNT_CREATE":true,"PASSWORD_REQUIREMENTS_ACCOUNT_CREATE":"\n    <ul>\n      <li>MUST contain at least 8 characters (12+ recommended)</li>\n      <li>MUST contain at least one uppercase letter.</li>\n      <li>MUST contain at least one lowercase letter.</li>\n      <li>MUST contain at least one number.</li>\n      <li>MUST contain at least one special character (!”#$%&'()*+,-./:;<=>?</li>\n    </ul>\n  ","ALLOW_CERTIFICATION_REQUEST":true,"ALLOW_PUBLIC_CERTIFICATE_REQUEST":true,"ALLOW_COPY_REQUEST":false,"ALLOW_CORRECTION_STYLING":true,"HIDE_DEPRECATION_WARNING":false,"AMEND_ROUTE_PUBLIC":true,"SEAL_FILENAME":"seal.png","SHOPPING_CART":true,"ALLOW_PAYMENT_UPDATE_WITH_EMPTY_CART":true,"RA_EMAIL":true,"RA_WEBSITE":true,"RA_NO_DEFAULT_TYPE":true,"RA_ADDRESS_LABEL":"Street Address","RA_TYPE_SELECTION_DEFAULT":true,"RA_DEFAULT_TYPE":"460","RA_OVERRIDE_TYPE_WITH_DEFAULT":true,"RA_PRINCIPAL_ADDRESS_AMS":true,"UPLOAD_AND_SUBMIT_HIDE_IF_ONE_OPTION":true,"PAYMENT_PROCESSING_MESSAGE":"Your payment is processing - Do not close your browser or click the back button","CHECKOUT_BUTTON_WHEN_PROCESSING_TEXT":"Processing","EFS_CROP_PICKER_NONE_LABEL":"Lien Duration","DISALLOWED_WIZARD_PIECES":["FormationLocale"],"REPEATER_SHOW_EDIT_BUTTON":true,"DATA_REQUEST_PAGE_TITLE":"Data Requests and Subscriptions","DATA_REQUEST_SIDEBAR_LABEL":"Data Requests & Subscriptions","LOGIN_REDIRECTS_TO_EPASS":false,"LOGIN_REDIRECTS_TO_ACTIVE_DIRECTORY":true,"LOGIN_ACTIVE_DIRECTORY_LINK":true,"FETCH_EDIT_USER_LINK":false,"LISTS_FETCH_AVAILABLE_LISTS":true,"POST_WIZARD_SUBMIT_REDIRECT_URL":"/","PIN_REQUEST_ATTESTATIONS":true,"PIN_REQUEST_DESCRIPTION":"Click **Request PIN** to have a new PIN sent to the account holder's email address on file.","OWNERSHIP_REQUEST_DESCRIPTION":"To become an **authorized user** of this record, a current **AUTHORIZED USER** will need to grant you access. To request access, click **Request Access** below.","PIN_REQUEST_SUCCESS_MESSAGE":"The PIN you have requested for this entity has been sent to the email associated with your user account.  You should receive the PIN in approximately 3-5 minutes, depending on your email service provider.","APOSTILLE_HEADER_LABEL":"Verification Information","APOSTILLE_NUMBER_LABEL":"Apostille/Authentication","APOSTILLE_CITY_STATE_OVERRIDE":"HELENA, MT","APOSTILLE_FILING_DATE_LABEL":"Issue Date","APOSTILLE_CITY_STATE_IN_CERTIFIED":true,"NOTARY_EXISTING_FILING":true,"ALLOW_REVOKE_OWN_ACCESS_ONLY":false,"HIDE_CANCEL_ON_ONETIME_DATA_REQUESTS":true,"DATA_REQUESTS_IN_SHOPPING_CART":true,"WQ_ALLOW_EDIT_PENDING_PAYMENT":true,"WQ_CONFIRM_ON_DELETE":true,"WQ_DELETE_CONFIRM_MESSAGE":"Deleting this filing will forfeit any money already paid to the Secretary of State. This action is permanent and cannot be undone, are you sure you would like to delete?","PASS_ITEM_GUIDS_ON_CHECKOUT":true,"FORM_REVISION_HISTORY":true,"CHECKOUT_DISCLAIMER":"By entering your credit card and/or checking account information you (i) state that **you are an authorized user** of the credit card and/or electronic check and that the associated information entered (e.g., account holder name, account number, billing address) is accurate, (ii) **you authorize payment processor to charge the amount you have requested** to your credit card and/or funding account, and (iii) **acknowledge if a charge is declined or reversed you may also be assessed a customary charge** by the payment processor for such transactions.","FARM_BILL_SEARCH_CONFIDENTIAL":"As a registered Farm Bill Buyer with the Montana Secretary of State’s office it is important to maintain the confidentiality of the information contained within the Farm Bill Master List. The Farm Bill Master List reflects personal data, such as Social Security Numbers, which are a key piece of personal identifiable information to assist you in determining the existence of a lien against a specific debtor. The distribution of this information beyond its intended purpose is strictly prohibited.\n\n**The debtor's tax identification number has been hidden for confidentiality reasons. You may continue to search on a tax ID number and return debtors that match your search criteria. The SSN/FEIN must be entered without dashes or spaces.  If you need access to the tax identification number to clearly identify the debtor, please contact the UCC unit at (406) 444-3665.**","VIEW_HISTORY_BUTTON_ALT_TEXT":"View Filings","WIZARD_ERROR_TITLE_MESSAGE":"Form Error","FARM_BILL_SEARCH_INTERACTIVE":true,"USE_FARM_BILL_API":true,"DISALLOW_ASSIGN_SELF_AS_RA":true,"DISALLOW_ASSIGN_SELF_AS_PRINCIPAL":true,"USE_TRADEMARK_OWNER_VALIDATION":true,"USE_ALTERNATIVE_FOREIGN_ADDRESS_LABELS":true,"MY_RECEIPTS_FILTER":[{"type":"dateRange","name":"DATE_RANGE","label":"Date range","defaultValue":{"start":null,"end":null}},{"type":"text","name":"REF_NUM","defaultValue":"","label":"Reference Number"},{"type":"text","name":"RECEIPT_NUM","defaultValue":"","label":"Receipt Id"},{"type":"text","name":"AMOUNT","defaultValue":"","label":"Amount"},{"type":"select","name":"TYPE","defaultValue":"","label":"Payment Type","options":[{"value":"","label":"All"},{"value":"CC","label":"Credit Card"},{"value":"Check","label":"Check"}]}],"MY_RECEIPTS_SHOW_IN_SIDEBAR":true,"SHOW_MY_RECEIPTS_HELPER_TEXT":true,"MY_RECEIPTS_HELPER_LABEL":"About Receipt Search","MY_RECEIPTS_HELPER_TEXT":"You can search for receipts based on their descriptions, including the items paid for on the receipt. Use the filters to search for or filter specific information.","FARM_BILL_SUBLINK":{"label":"Farm Bill","component":"FarmBill","parameter":"farm-bill","path":"/lists/farm-bill","sourceTypeId":0,"myRecordsSearch":false,"allowedRules":["/search/"],"disabled":true,"searchDescription":"To perform a search, enter a debtor name. Your search results may include: exact debtor name, variations of that name and any filing that includes your search criteria. Punctuation is ignored.\n\nYou can click on \"Advanced\" to refine your search. Under “Advanced” you can search by crop, year, county and SSN/FEIN. As a registered Farm Bill Buyer with the Montana Secretary of State’s office it is important to maintain the confidentiality of the information contained within the Farm Bill Master List. The Farm Bill Master List reflects personal data, such as Social Security Numbers, which are a key piece of personal identifiable information to assist you in determining the existence of a lien against a specific debtor. The distribution of this information beyond its intended purpose is strictly prohibited.\n\nThe debtor's tax identification number has been hidden for confidentiality reasons. You may continue to search on a tax ID number and return debtors that match your search criteria. The SSN/FEIN must be entered without dashes or spaces.","searchMustHaveOneOf":["search","UCC_FARM_PRODUCT_ID","COUNTY"],"searchPlaceholder":"Search by debtor name","advancedSearchParameters":[{"type":"ServerMultiComplete","label":"Product code name(s)","name":"UCC_FARM_PRODUCT_ID","defaultValue":"","optionsSrc":"UCC_FARM_PRODUCT_V"},{"type":"MultiComplete","label":"Year or Range of Years","name":"YEAR_NUM","optionsSrc":"years","startYear":"1968","defaultValue":[],"preMergeOptions":[{"value":"ALL","label":"All"}]},{"type":"serverSelect","label":"State","name":"STATE","defaultValue":"MONTANA","optionsSrc":"STATE"},{"type":"ServerMultiComplete","label":"County","name":"COUNTY","defaultValue":[],"optionsSrc":"COUNTY","overrideSubOptionsSrcFromParameterName":"STATE"},{"type":"checkbox","name":"TIN_SEARCH_YN","defaultValue":false,"label":"Tax Identification Number Search"},{"type":"checkbox","name":"TIN_SORT_YN","defaultValue":false,"label":"Unique ID Sort"}]},"ALLOW_ADDRESS_VALIDATION_BYPASS_OPTION":true,"DEFAULT_ADDRESS_VALIDATION_BYPASS_OPTION_CHECKED":true}).EDIT_ACCOUNT_LABEL || 'Edit My Account',
	              cancelButton: true,
	              cancelButtonText: showSaveAndClose ? 'Cancel' : 'Close',
	              saveButton: showSaveAndClose,
	              save: this.saveUser,
	              cancel: this.cancel,
	              ref: function ref(_ref2) {
	                return _this2.modal = _ref2;
	              },
	              autoHeight: true,
	              rootClassName: this.state.obscured ? 'modal-obscured' : ''
	            },
	            _react2.default.createElement(EditorForm, {
	              getStateCallback: function getStateCallback(r) {
	                return _this2.getEditorState = r;
	              },
	              error: this.state.error
	            })
	          )
	        )
	      );
	    }
	  }]);
	
	  return UserAccountEditor;
	}(_react2.default.Component);
	
	exports.default = (0, _reactRedux.connect)(null, { spreadAuthAttributes: _AuthActions.spreadAuthAttributes })(UserAccountEditor);
	
	var EditorForm = function (_React$Component2) {
	  _inherits(EditorForm, _React$Component2);
	
	  function EditorForm() {
	    var _ref3;
	
	    var _temp2, _this3, _ret2;
	
	    _classCallCheck(this, EditorForm);
	
	    for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
	      args[_key2] = arguments[_key2];
	    }
	
	    return _ret2 = (_temp2 = (_this3 = _possibleConstructorReturn(this, (_ref3 = EditorForm.__proto__ || Object.getPrototypeOf(EditorForm)).call.apply(_ref3, [this].concat(args))), _this3), _this3.state = Object.assign({}, _this3.props.user, {
	      oktaDomainError: null,
	      oktaDomainLoading: ({"NODE_ENV":"production","BUILD_DATE":"2025-08-27T15:15:31.687Z","BUILD_NUMBER":"Not Provided","GIT_VERSION":"v1.3.0-381-ga81e29b08","GIT_COMMIT_HASH":"a81e29b085c9268ffd96c78eb734365802722741","GIT_BRANCH":"beta","PUBLIC_URL":"","STATE_ABBR":"MT","STATE_NAME":"Montana","STATE_ORG_TITLE":"Secretary of State","LOGIN_HEADER_IMG_PATH":"","HOME_IMG_FILENAME":"montana.jpg","FAVICON_FILE_NAME":"favicon.ico","ALLOW_E_SIGN_ON_CORRECTIONS":true,"THIRD_PARTY_SIGNING_ALLOWED":false,"MY_ACCOUNT_SAVE_AND_CLOSE_BUTTON":true,"IE_DEPRECATED_MESSAGE":"Internet Explorer is not supported. Please select a supported browser below to access this website.","ADDITIONAL_ROUTES":{"dataRequests":true,"farmBill":true,"apostille":true,"externalHelp":"https://sosmt.gov/business/help-center/","systemAdministration":[{"title":"Saved Payments","parameter":"saved-payments","componentName":"SavedPayments"}]},"SUBROUTES":[{"label":"Business","component":"Business","parameter":"business","myWorkQueueSearch":false,"sourceTypeId":54,"searchMustHaveOneOf":["FILING_TYPE_ID","STATUS_ID","STATE","search"],"serverWebSearchDescription":true,"serverWorkQueueDescription":true,"serverMyRecordsDescription":true,"searchPlaceholder":"Search by name or filing number (X########)","allowEmptySearchTerm":true,"requestCertificateAlternateLabel":"Request Information","fileAmendmentButtonLabel":"Filing Actions","advancedSearchParameters":[{"type":"radio","name":"QUERY_TYPE_ID","defaultValue":1010,"options":[{"value":1010,"label":"Starts with"},{"value":1011,"label":"Contains"},{"value":1012,"label":" Word Contains"}]},{"type":"serverSelect","name":"FILING_TYPE_ID","optionsSrc":"FILING_TYPES","label":"Entity Type","placeholder":"All","defaultValue":"0"},{"type":"serverSelect","name":"FILING_SUBTYPE_ID","optionsSrc":"FILING_SUBTYPES","label":"Entity Subtype","overrideSubOptionsSrcFromParameterName":"FILING_TYPE_ID","placeholder":"All","defaultValue":"0"},{"type":"serverSelect","name":"STATUS_ID","optionsSrc":"FILING_STATUS_WITHOUT_ALL","label":"Status","placeholder":"All","defaultValue":"0"},{"type":"serverSelect","name":"STATE","optionsSrc":"STATE","label":"State","placeholder":"All","defaultValue":""},{"type":"serverSelect","name":"COUNTY","optionsSrc":"COUNTY_SUBOPTION","label":"County","overrideSubOptionsSrcFromParameterName":"STATE","placeholder":"All","defaultValue":""},{"type":"checkbox","name":"CRA_SEARCH_YN","defaultValue":false,"label":"Search by Registered Agent PID"},{"type":"dateRange","name":"FILING_DATE","label":"Registration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}},{"type":"dateRange","name":"EXPIRATION_DATE","label":"Expiration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}}],"myRecordsFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Active"},{"value":2,"label":"Inactive"},{"value":3,"label":"Pending"}]},{"type":"dateRange","name":"DATE_RANGE","label":"Date range","defaultValue":{"start":null,"end":null}}],"myWorkQueueFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Approved"},{"value":2,"label":"Pending Online Payment"},{"value":3,"label":"Pending Review"},{"value":4,"label":"Needs Correction"},{"value":5,"label":"Rejected"},{"value":6,"label":"Draft"}]},{"type":"dateRange","name":"DATE_RANGE","label":"Date range","defaultValue":{"start":null,"end":null}}]},{"label":"Notary","component":"Notary","parameter":"notary","sourceTypeId":850,"myWorkQueueSearch":false,"allowEmptySearchTerm":true,"requestCertificateAlternateLabel":"Download Certificate","fileAmendmentButtonLabel":"Filing Actions","hideNameRequestCertificate":true,"hideAddressRequestCertificate":true,"hideRecordUserManagment":true,"searchPlaceholder":"Search by name or commission number","searchMustHaveOneOf":["CITY","search","SERVICE_TYPE"],"advancedParametersStartOpen":true,"searchIsSortable":true,"advancedSearchParameters":[{"type":"radio","name":"STARTS_WITH_YN","defaultValue":false,"options":[{"value":true,"label":"Starts with"},{"value":false,"label":"Contains"}]},{"type":"checkbox","name":"ACTIVE_ONLY_YN","defaultValue":true,"label":"Active entities only"},{"type":"text","name":"CITY","defaultValue":"","label":"City"},{"type":"select","name":"SERVICE_TYPE","label":"Special Services Offered","defaultValue":0,"options":[{"value":0,"label":"(N/A)"},{"value":6165,"label":"In-Person Electronic Notarization (IPEN)"},{"value":6166,"label":"Remote Online Notarization (RON)"},{"value":6167,"label":"Mobile Notary Services"},{"value":6168,"label":"Remote Ink Notarization (RIN)"}]}]},{"label":"Apostille","component":"Apostille","parameter":"apostille","sourceTypeId":720,"myRecordsSearch":false,"myWorkQueueSearch":false,"disabled":false,"allowedRoutes":["/forms-manager/","/queue/","/forms/"]},{"label":"Liens","component":"UCC","parameter":"ucc","sourceTypeId":1999,"myRecordsSearch":true,"myWorkQueueSearch":true,"fileAmendmentButtonLabel":"Filing Actions","searchPlaceholder":"Search by name or file number","disabled":false,"serverWebSearchDescription":true,"myRecordsDescription":"","workQueueDescription":"","searchDescription":"","hideRecordUserManagment":true,"searchLiensCheckout":false,"advancedSearchParameters":[{"type":"radio","name":"STARTS_WITH_YN","defaultValue":false,"options":[{"value":true,"label":"Starts with"},{"value":false,"label":"Contains"}]},{"type":"select","name":"STATUS","defaultValue":"ALL","label":"Status","options":[{"value":"ACTIVE_UNLAPSED","label":"Active (unlapsed)"},{"value":"ACTIVE_LAPSED_UNLAPSED","label":"Active (lapsed and unlapsed)"}]},{"type":"text","name":"EXCLUDE_VALUES","label":"Exclude Debtor Names (comma separated list of names to exclude)","defaultValue":""},{"type":"dateRange","name":"FILING_DATE","label":"Financing Statement Date","defaultValue":{"start":null,"end":null}},{"type":"dateRange","name":"LAPSE_DATE","label":"Lapse Date","defaultValue":{"start":null,"end":null}},{"type":"text","name":"CITY","label":"Debtor City","defaultValue":""}],"myRecordsFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Approved"},{"value":2,"label":"Pending Online Payment"},{"value":3,"label":"Pending Review"}]},{"type":"select","name":"TYPE","defaultValue":0,"label":"Lien Type","options":[{"value":0,"label":"All"},{"value":1,"label":"UCC"},{"value":2,"label":"EFS"},{"value":3,"label":"Title 71"}]}],"myWorkQueueFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Approved"},{"value":2,"label":"Pending Online Payment"},{"value":3,"label":"Pending Review"},{"value":4,"label":"Pending Print and Mail"},{"value":5,"label":"Rejected"},{"value":6,"label":"Draft"}]},{"type":"select","name":"TYPE","defaultValue":0,"label":"Lien Type","options":[{"value":0,"label":"All"},{"value":1,"label":"UCC"},{"value":2,"label":"EFS"},{"value":3,"label":"Title 71"}]}]},{"label":"Copy Request","component":"copies","parameter":"copies","sourceTypeId":2001,"myRecordsSearch":false,"myWorkQueueSearch":false,"disabled":false,"allowedRoutes":["/forms-manager/","/queue/","/forms/"]},{"label":"Trademark","component":"Trademark","parameter":"trademark","sourceTypeId":810,"showRequestCertificate":true,"searchMustHaveOneOf":["search","EXPIRATION_DATE","FILING_DATE"],"allowEmptySearchTerm":true,"requestCertificateAlternateLabel":"Request Information","fileAmendmentButtonLabel":"Filing Actions","advancedSearchParameters":[{"type":"radio","name":"QUERY_TYPE_ID","defaultValue":1010,"options":[{"value":1010,"label":"Starts with"},{"value":1011,"label":"Contains"},{"value":1012,"label":" Word Contains"}]},{"type":"checkbox","name":"OWNER_SEARCH_YN","defaultValue":false,"label":"Search owners"},{"type":"radio","name":"SERVICE_MARK_YN","label":"Mark Type","defaultValue":"","options":[{"value":"","label":"All Marks"},{"value":"Y","label":"Service Mark"},{"value":"N","label":"Trademark"}]},{"type":"serverSelect","name":"STATUS_ID","optionsSrc":"TYPE_V|TRADEMARK_STATUS_TYPE","label":"Status","placeholder":"All","defaultValue":"0"},{"type":"select","name":"DESIGN_TYPE_ID","options":[{"value":0,"label":"All"},{"value":990,"label":"Words Only"},{"value":991,"label":"Design Only"},{"value":992,"label":"Words and Design"}],"label":"Design Type","defaultValue":"0"},{"type":"dateRange","name":"FILING_DATE","label":"Registered Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}},{"type":"dateRange","name":"EXPIRATION_DATE","label":"Expiration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}}]},{"label":"Business Info Request","component":"InfoRequests","parameter":"info-request","sourceTypeId":167,"allowedRoutes":["/forms-manager/","/queue/","/forms/"]},{"label":"Data Requests","component":"DataRequests","parameter":"data-request","sourceTypeId":0,"allowedRoutes":["/forms-manager/"]},{"label":"CRA","component":"CRA","parameter":"cra","sourceTypeId":157,"myRecordsSearch":false,"searchPlaceholder":"Search by name or registered agent number","allowedRoutes":["/forms-manager/","/forms/","/records/","/queue/","/search/"],"allowEmptySearchTerm":true,"fileAmendmentButtonLabel":"Filing Actions","advancedSearchParameters":[{"type":"radio","name":"QUERY_TYPE_ID","defaultValue":1010,"options":[{"value":1010,"label":"Starts with"},{"value":1011,"label":"Contains"},{"value":1012,"label":" Word Contains"}]},{"type":"dateRange","name":"CRA_DATE","label":"Registration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}},{"type":"select","name":"STATUS_ID","label":"Status","defaultValue":0,"options":[{"value":0,"label":"All"},{"value":121,"label":"Active"},{"value":122,"label":"Inactive"}]},{"type":"select","name":"AGENT_TYPE_ID","label":"Agent Type","defaultValue":0,"options":[{"value":0,"label":"All"},{"value":460,"label":"Registered Agent"},{"value":461,"label":"Commercial Registered Agent"}]}]},{"label":"Farm Bill","component":"FarmBill","parameter":"farm-bill","path":"/lists/farm-bill","sourceTypeId":0,"myRecordsSearch":false,"allowedRules":["/search/"],"disabled":true,"searchDescription":"To perform a search, enter a debtor name. Your search results may include: exact debtor name, variations of that name and any filing that includes your search criteria. Punctuation is ignored.\n\nYou can click on \"Advanced\" to refine your search. Under “Advanced” you can search by crop, year, county and SSN/FEIN. As a registered Farm Bill Buyer with the Montana Secretary of State’s office it is important to maintain the confidentiality of the information contained within the Farm Bill Master List. The Farm Bill Master List reflects personal data, such as Social Security Numbers, which are a key piece of personal identifiable information to assist you in determining the existence of a lien against a specific debtor. The distribution of this information beyond its intended purpose is strictly prohibited.\n\nThe debtor's tax identification number has been hidden for confidentiality reasons. You may continue to search on a tax ID number and return debtors that match your search criteria. The SSN/FEIN must be entered without dashes or spaces.","searchMustHaveOneOf":["search","UCC_FARM_PRODUCT_ID","COUNTY"],"searchPlaceholder":"Search by debtor name","advancedSearchParameters":[{"type":"ServerMultiComplete","label":"Product code name(s)","name":"UCC_FARM_PRODUCT_ID","defaultValue":"","optionsSrc":"UCC_FARM_PRODUCT_V"},{"type":"MultiComplete","label":"Year or Range of Years","name":"YEAR_NUM","optionsSrc":"years","startYear":"1968","defaultValue":[],"preMergeOptions":[{"value":"ALL","label":"All"}]},{"type":"serverSelect","label":"State","name":"STATE","defaultValue":"MONTANA","optionsSrc":"STATE"},{"type":"ServerMultiComplete","label":"County","name":"COUNTY","defaultValue":[],"optionsSrc":"COUNTY","overrideSubOptionsSrcFromParameterName":"STATE"},{"type":"checkbox","name":"TIN_SEARCH_YN","defaultValue":false,"label":"Tax Identification Number Search"},{"type":"checkbox","name":"TIN_SORT_YN","defaultValue":false,"label":"Unique ID Sort"}]}],"SYSTEM_NICKNAME":"Online Services Portal","PAYMENT_METHODS":[{"type":"bypass"},{"type":"iTransact"}],"PAYMENT_ALLOW_AMEX":true,"SYSTEM_ID_LABEL":"System Id","DOUBLE_COLUMN_PUBLIC_LOGIN":true,"INTERNAL_USER_MANAGEMENT":true,"ALLOW_PUBLIC_JSON_IMPORT":false,"MAX_FILE_UPLOAD_SIZE":10000000,"REFUND_TEXT":"","RETURN_TO_HOME_ON_LOGOUT":true,"CURRENT_SOS_NAME":"Christi Jacobsen","LOGO_FILENAME":"mt-sos-logo.png","LOGO_ALT":"Christi Jacobsen, Montana Secretary of State","LOGO_FULL_WIDTH":true,"HOME_HIDE_AUTH_HINT":true,"HOME_TITLE":"Montana Secretary of State","CUSTOM_TAB_TITLE":"Official Montana","HOME_SUBTITLE":"Online Business Services","ENTITY_NAME_CONSENT_DESCRIPTION":"","ALLOW_USER_PROFILE_EDITING":true,"COMPARE_FOREIGN_NAME_IN_ENTITY_NAME_VALIDATION":true,"FOREIGN_NAME_FIELD_NAME":"KIMA_PARENT_NAME_INFO","LOGIN_TITLE":"Montana Secretary of State Online Filing Portal Login","PUBLIC_LOGIN_LABEL":"Username","REVERSE_LOGIN_COLUMNS":true,"LOGIN_SEAL_FILENAME":"seal_white.png","SEPARATE_USERNAME_AND_EMAIL":true,"CREATE_ACCOUNT_BUTTON_ALIGN_LEFT":true,"CREATE_ACCOUNT_BUTTON_TEXT":"CREATE AN ACCOUNT","PASSWORD_CUSTOM_ERROR_TEXT":"The password must meet all requirements","ACCOUNT_CREATED_MESSAGE":"Please check your email to verify your account to login and allow a few minutes for this message to arrive. Check your junk/spam folders if you do not find the email in your inbox.","PUBLIC_LOGIN_PLACEHOLDER":" ","DISABLE_DEFAULT_PAYMENT_RADIO":true,"CUSTOM_RESET_PASSWORD_ERROR_MESSAGE":"Username invalid - no account found","PUBLIC_LOGIN_CREATE_DESCRIPTION":"### Existing User:\n\n  - Enter your username and password to login.  \n\n\n  #### - OR -  \n\n\n\n  - Forgot password? Click 'Reset Password' and follow the prompts.\n  - Forgot username? Click 'Forgot Username' and follow the prompts.  \n\n\n  ### New User:\n  ","LOGIN_HELP_LINK":"https://sosmt.gov/business/how-do-i/","LOGIN_HELP_LINK_TEXT":"Need Help?","FORGOT_USERNAME_TEXT":"Forgot Username?","LOGIN_ACTIVE_DIRECTORY_TEXT":"State User Login","MULTIPLE_LOGIN_METHODS":true,"HAS_ACTIVE_DIRECTORY_LOGIN":true,"RESET_PASSWORD_WITH_USERNAME":true,"DOWNLOAD_LINK":true,"SHOW_USERNAME_ACCOUNT_CREATE":true,"SHOW_SCROLL_DOWN_ARROW":true,"SHOW_ADDRESS_ACCOUNT_CREATE":true,"TWO_COLUMN_ACCOUNT_CREATE":true,"RESET_PASSWORD_TIP":"A link to change your password has been sent to your email. Please allow a few minutes for this message to arrive. Please check your junk/spam folders if you do not find the email in your inbox.","FORGOT_PASSWORD_LINK_TEXT":"Reset Password","PHONE_NUMBER_OPTIONAL_ACCOUNT_CREATE":true,"SHOW_REQUIRED_INDICATOR_ACCOUNT_CREATE":true,"PASSWORD_REQUIREMENTS_ACCOUNT_CREATE":"\n    <ul>\n      <li>MUST contain at least 8 characters (12+ recommended)</li>\n      <li>MUST contain at least one uppercase letter.</li>\n      <li>MUST contain at least one lowercase letter.</li>\n      <li>MUST contain at least one number.</li>\n      <li>MUST contain at least one special character (!”#$%&'()*+,-./:;<=>?</li>\n    </ul>\n  ","ALLOW_CERTIFICATION_REQUEST":true,"ALLOW_PUBLIC_CERTIFICATE_REQUEST":true,"ALLOW_COPY_REQUEST":false,"ALLOW_CORRECTION_STYLING":true,"HIDE_DEPRECATION_WARNING":false,"AMEND_ROUTE_PUBLIC":true,"SEAL_FILENAME":"seal.png","SHOPPING_CART":true,"ALLOW_PAYMENT_UPDATE_WITH_EMPTY_CART":true,"RA_EMAIL":true,"RA_WEBSITE":true,"RA_NO_DEFAULT_TYPE":true,"RA_ADDRESS_LABEL":"Street Address","RA_TYPE_SELECTION_DEFAULT":true,"RA_DEFAULT_TYPE":"460","RA_OVERRIDE_TYPE_WITH_DEFAULT":true,"RA_PRINCIPAL_ADDRESS_AMS":true,"UPLOAD_AND_SUBMIT_HIDE_IF_ONE_OPTION":true,"PAYMENT_PROCESSING_MESSAGE":"Your payment is processing - Do not close your browser or click the back button","CHECKOUT_BUTTON_WHEN_PROCESSING_TEXT":"Processing","EFS_CROP_PICKER_NONE_LABEL":"Lien Duration","DISALLOWED_WIZARD_PIECES":["FormationLocale"],"REPEATER_SHOW_EDIT_BUTTON":true,"DATA_REQUEST_PAGE_TITLE":"Data Requests and Subscriptions","DATA_REQUEST_SIDEBAR_LABEL":"Data Requests & Subscriptions","LOGIN_REDIRECTS_TO_EPASS":false,"LOGIN_REDIRECTS_TO_ACTIVE_DIRECTORY":true,"LOGIN_ACTIVE_DIRECTORY_LINK":true,"FETCH_EDIT_USER_LINK":false,"LISTS_FETCH_AVAILABLE_LISTS":true,"POST_WIZARD_SUBMIT_REDIRECT_URL":"/","PIN_REQUEST_ATTESTATIONS":true,"PIN_REQUEST_DESCRIPTION":"Click **Request PIN** to have a new PIN sent to the account holder's email address on file.","OWNERSHIP_REQUEST_DESCRIPTION":"To become an **authorized user** of this record, a current **AUTHORIZED USER** will need to grant you access. To request access, click **Request Access** below.","PIN_REQUEST_SUCCESS_MESSAGE":"The PIN you have requested for this entity has been sent to the email associated with your user account.  You should receive the PIN in approximately 3-5 minutes, depending on your email service provider.","APOSTILLE_HEADER_LABEL":"Verification Information","APOSTILLE_NUMBER_LABEL":"Apostille/Authentication","APOSTILLE_CITY_STATE_OVERRIDE":"HELENA, MT","APOSTILLE_FILING_DATE_LABEL":"Issue Date","APOSTILLE_CITY_STATE_IN_CERTIFIED":true,"NOTARY_EXISTING_FILING":true,"ALLOW_REVOKE_OWN_ACCESS_ONLY":false,"HIDE_CANCEL_ON_ONETIME_DATA_REQUESTS":true,"DATA_REQUESTS_IN_SHOPPING_CART":true,"WQ_ALLOW_EDIT_PENDING_PAYMENT":true,"WQ_CONFIRM_ON_DELETE":true,"WQ_DELETE_CONFIRM_MESSAGE":"Deleting this filing will forfeit any money already paid to the Secretary of State. This action is permanent and cannot be undone, are you sure you would like to delete?","PASS_ITEM_GUIDS_ON_CHECKOUT":true,"FORM_REVISION_HISTORY":true,"CHECKOUT_DISCLAIMER":"By entering your credit card and/or checking account information you (i) state that **you are an authorized user** of the credit card and/or electronic check and that the associated information entered (e.g., account holder name, account number, billing address) is accurate, (ii) **you authorize payment processor to charge the amount you have requested** to your credit card and/or funding account, and (iii) **acknowledge if a charge is declined or reversed you may also be assessed a customary charge** by the payment processor for such transactions.","FARM_BILL_SEARCH_CONFIDENTIAL":"As a registered Farm Bill Buyer with the Montana Secretary of State’s office it is important to maintain the confidentiality of the information contained within the Farm Bill Master List. The Farm Bill Master List reflects personal data, such as Social Security Numbers, which are a key piece of personal identifiable information to assist you in determining the existence of a lien against a specific debtor. The distribution of this information beyond its intended purpose is strictly prohibited.\n\n**The debtor's tax identification number has been hidden for confidentiality reasons. You may continue to search on a tax ID number and return debtors that match your search criteria. The SSN/FEIN must be entered without dashes or spaces.  If you need access to the tax identification number to clearly identify the debtor, please contact the UCC unit at (406) 444-3665.**","VIEW_HISTORY_BUTTON_ALT_TEXT":"View Filings","WIZARD_ERROR_TITLE_MESSAGE":"Form Error","FARM_BILL_SEARCH_INTERACTIVE":true,"USE_FARM_BILL_API":true,"DISALLOW_ASSIGN_SELF_AS_RA":true,"DISALLOW_ASSIGN_SELF_AS_PRINCIPAL":true,"USE_TRADEMARK_OWNER_VALIDATION":true,"USE_ALTERNATIVE_FOREIGN_ADDRESS_LABELS":true,"MY_RECEIPTS_FILTER":[{"type":"dateRange","name":"DATE_RANGE","label":"Date range","defaultValue":{"start":null,"end":null}},{"type":"text","name":"REF_NUM","defaultValue":"","label":"Reference Number"},{"type":"text","name":"RECEIPT_NUM","defaultValue":"","label":"Receipt Id"},{"type":"text","name":"AMOUNT","defaultValue":"","label":"Amount"},{"type":"select","name":"TYPE","defaultValue":"","label":"Payment Type","options":[{"value":"","label":"All"},{"value":"CC","label":"Credit Card"},{"value":"Check","label":"Check"}]}],"MY_RECEIPTS_SHOW_IN_SIDEBAR":true,"SHOW_MY_RECEIPTS_HELPER_TEXT":true,"MY_RECEIPTS_HELPER_LABEL":"About Receipt Search","MY_RECEIPTS_HELPER_TEXT":"You can search for receipts based on their descriptions, including the items paid for on the receipt. Use the filters to search for or filter specific information.","FARM_BILL_SUBLINK":{"label":"Farm Bill","component":"FarmBill","parameter":"farm-bill","path":"/lists/farm-bill","sourceTypeId":0,"myRecordsSearch":false,"allowedRules":["/search/"],"disabled":true,"searchDescription":"To perform a search, enter a debtor name. Your search results may include: exact debtor name, variations of that name and any filing that includes your search criteria. Punctuation is ignored.\n\nYou can click on \"Advanced\" to refine your search. Under “Advanced” you can search by crop, year, county and SSN/FEIN. As a registered Farm Bill Buyer with the Montana Secretary of State’s office it is important to maintain the confidentiality of the information contained within the Farm Bill Master List. The Farm Bill Master List reflects personal data, such as Social Security Numbers, which are a key piece of personal identifiable information to assist you in determining the existence of a lien against a specific debtor. The distribution of this information beyond its intended purpose is strictly prohibited.\n\nThe debtor's tax identification number has been hidden for confidentiality reasons. You may continue to search on a tax ID number and return debtors that match your search criteria. The SSN/FEIN must be entered without dashes or spaces.","searchMustHaveOneOf":["search","UCC_FARM_PRODUCT_ID","COUNTY"],"searchPlaceholder":"Search by debtor name","advancedSearchParameters":[{"type":"ServerMultiComplete","label":"Product code name(s)","name":"UCC_FARM_PRODUCT_ID","defaultValue":"","optionsSrc":"UCC_FARM_PRODUCT_V"},{"type":"MultiComplete","label":"Year or Range of Years","name":"YEAR_NUM","optionsSrc":"years","startYear":"1968","defaultValue":[],"preMergeOptions":[{"value":"ALL","label":"All"}]},{"type":"serverSelect","label":"State","name":"STATE","defaultValue":"MONTANA","optionsSrc":"STATE"},{"type":"ServerMultiComplete","label":"County","name":"COUNTY","defaultValue":[],"optionsSrc":"COUNTY","overrideSubOptionsSrcFromParameterName":"STATE"},{"type":"checkbox","name":"TIN_SEARCH_YN","defaultValue":false,"label":"Tax Identification Number Search"},{"type":"checkbox","name":"TIN_SORT_YN","defaultValue":false,"label":"Unique ID Sort"}]},"ALLOW_ADDRESS_VALIDATION_BYPASS_OPTION":true,"DEFAULT_ADDRESS_VALIDATION_BYPASS_OPTION_CHECKED":true}).HAS_OKTA_LOGIN,
	      oktaDomain: '',
	      ADDRESS:  true ? {
	        ADDR1: _this3.props.user.ADDR1 || '',
	        ADDR2: _this3.props.user.ADDR2 || '',
	        ADDR3: _this3.props.user.ADDR3 || '',
	        CITY: _this3.props.user.CITY || '',
	        STATE: _this3.props.user.STATE || '',
	        POSTAL_CODE: _this3.props.user.POSTAL_CODE || '',
	        COUNTRY: _this3.props.user.COUNTRY || ''
	      } : null
	    }), _this3.componentDidMount = function () {
	      if (({"NODE_ENV":"production","BUILD_DATE":"2025-08-27T15:15:31.687Z","BUILD_NUMBER":"Not Provided","GIT_VERSION":"v1.3.0-381-ga81e29b08","GIT_COMMIT_HASH":"a81e29b085c9268ffd96c78eb734365802722741","GIT_BRANCH":"beta","PUBLIC_URL":"","STATE_ABBR":"MT","STATE_NAME":"Montana","STATE_ORG_TITLE":"Secretary of State","LOGIN_HEADER_IMG_PATH":"","HOME_IMG_FILENAME":"montana.jpg","FAVICON_FILE_NAME":"favicon.ico","ALLOW_E_SIGN_ON_CORRECTIONS":true,"THIRD_PARTY_SIGNING_ALLOWED":false,"MY_ACCOUNT_SAVE_AND_CLOSE_BUTTON":true,"IE_DEPRECATED_MESSAGE":"Internet Explorer is not supported. Please select a supported browser below to access this website.","ADDITIONAL_ROUTES":{"dataRequests":true,"farmBill":true,"apostille":true,"externalHelp":"https://sosmt.gov/business/help-center/","systemAdministration":[{"title":"Saved Payments","parameter":"saved-payments","componentName":"SavedPayments"}]},"SUBROUTES":[{"label":"Business","component":"Business","parameter":"business","myWorkQueueSearch":false,"sourceTypeId":54,"searchMustHaveOneOf":["FILING_TYPE_ID","STATUS_ID","STATE","search"],"serverWebSearchDescription":true,"serverWorkQueueDescription":true,"serverMyRecordsDescription":true,"searchPlaceholder":"Search by name or filing number (X########)","allowEmptySearchTerm":true,"requestCertificateAlternateLabel":"Request Information","fileAmendmentButtonLabel":"Filing Actions","advancedSearchParameters":[{"type":"radio","name":"QUERY_TYPE_ID","defaultValue":1010,"options":[{"value":1010,"label":"Starts with"},{"value":1011,"label":"Contains"},{"value":1012,"label":" Word Contains"}]},{"type":"serverSelect","name":"FILING_TYPE_ID","optionsSrc":"FILING_TYPES","label":"Entity Type","placeholder":"All","defaultValue":"0"},{"type":"serverSelect","name":"FILING_SUBTYPE_ID","optionsSrc":"FILING_SUBTYPES","label":"Entity Subtype","overrideSubOptionsSrcFromParameterName":"FILING_TYPE_ID","placeholder":"All","defaultValue":"0"},{"type":"serverSelect","name":"STATUS_ID","optionsSrc":"FILING_STATUS_WITHOUT_ALL","label":"Status","placeholder":"All","defaultValue":"0"},{"type":"serverSelect","name":"STATE","optionsSrc":"STATE","label":"State","placeholder":"All","defaultValue":""},{"type":"serverSelect","name":"COUNTY","optionsSrc":"COUNTY_SUBOPTION","label":"County","overrideSubOptionsSrcFromParameterName":"STATE","placeholder":"All","defaultValue":""},{"type":"checkbox","name":"CRA_SEARCH_YN","defaultValue":false,"label":"Search by Registered Agent PID"},{"type":"dateRange","name":"FILING_DATE","label":"Registration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}},{"type":"dateRange","name":"EXPIRATION_DATE","label":"Expiration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}}],"myRecordsFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Active"},{"value":2,"label":"Inactive"},{"value":3,"label":"Pending"}]},{"type":"dateRange","name":"DATE_RANGE","label":"Date range","defaultValue":{"start":null,"end":null}}],"myWorkQueueFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Approved"},{"value":2,"label":"Pending Online Payment"},{"value":3,"label":"Pending Review"},{"value":4,"label":"Needs Correction"},{"value":5,"label":"Rejected"},{"value":6,"label":"Draft"}]},{"type":"dateRange","name":"DATE_RANGE","label":"Date range","defaultValue":{"start":null,"end":null}}]},{"label":"Notary","component":"Notary","parameter":"notary","sourceTypeId":850,"myWorkQueueSearch":false,"allowEmptySearchTerm":true,"requestCertificateAlternateLabel":"Download Certificate","fileAmendmentButtonLabel":"Filing Actions","hideNameRequestCertificate":true,"hideAddressRequestCertificate":true,"hideRecordUserManagment":true,"searchPlaceholder":"Search by name or commission number","searchMustHaveOneOf":["CITY","search","SERVICE_TYPE"],"advancedParametersStartOpen":true,"searchIsSortable":true,"advancedSearchParameters":[{"type":"radio","name":"STARTS_WITH_YN","defaultValue":false,"options":[{"value":true,"label":"Starts with"},{"value":false,"label":"Contains"}]},{"type":"checkbox","name":"ACTIVE_ONLY_YN","defaultValue":true,"label":"Active entities only"},{"type":"text","name":"CITY","defaultValue":"","label":"City"},{"type":"select","name":"SERVICE_TYPE","label":"Special Services Offered","defaultValue":0,"options":[{"value":0,"label":"(N/A)"},{"value":6165,"label":"In-Person Electronic Notarization (IPEN)"},{"value":6166,"label":"Remote Online Notarization (RON)"},{"value":6167,"label":"Mobile Notary Services"},{"value":6168,"label":"Remote Ink Notarization (RIN)"}]}]},{"label":"Apostille","component":"Apostille","parameter":"apostille","sourceTypeId":720,"myRecordsSearch":false,"myWorkQueueSearch":false,"disabled":false,"allowedRoutes":["/forms-manager/","/queue/","/forms/"]},{"label":"Liens","component":"UCC","parameter":"ucc","sourceTypeId":1999,"myRecordsSearch":true,"myWorkQueueSearch":true,"fileAmendmentButtonLabel":"Filing Actions","searchPlaceholder":"Search by name or file number","disabled":false,"serverWebSearchDescription":true,"myRecordsDescription":"","workQueueDescription":"","searchDescription":"","hideRecordUserManagment":true,"searchLiensCheckout":false,"advancedSearchParameters":[{"type":"radio","name":"STARTS_WITH_YN","defaultValue":false,"options":[{"value":true,"label":"Starts with"},{"value":false,"label":"Contains"}]},{"type":"select","name":"STATUS","defaultValue":"ALL","label":"Status","options":[{"value":"ACTIVE_UNLAPSED","label":"Active (unlapsed)"},{"value":"ACTIVE_LAPSED_UNLAPSED","label":"Active (lapsed and unlapsed)"}]},{"type":"text","name":"EXCLUDE_VALUES","label":"Exclude Debtor Names (comma separated list of names to exclude)","defaultValue":""},{"type":"dateRange","name":"FILING_DATE","label":"Financing Statement Date","defaultValue":{"start":null,"end":null}},{"type":"dateRange","name":"LAPSE_DATE","label":"Lapse Date","defaultValue":{"start":null,"end":null}},{"type":"text","name":"CITY","label":"Debtor City","defaultValue":""}],"myRecordsFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Approved"},{"value":2,"label":"Pending Online Payment"},{"value":3,"label":"Pending Review"}]},{"type":"select","name":"TYPE","defaultValue":0,"label":"Lien Type","options":[{"value":0,"label":"All"},{"value":1,"label":"UCC"},{"value":2,"label":"EFS"},{"value":3,"label":"Title 71"}]}],"myWorkQueueFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Approved"},{"value":2,"label":"Pending Online Payment"},{"value":3,"label":"Pending Review"},{"value":4,"label":"Pending Print and Mail"},{"value":5,"label":"Rejected"},{"value":6,"label":"Draft"}]},{"type":"select","name":"TYPE","defaultValue":0,"label":"Lien Type","options":[{"value":0,"label":"All"},{"value":1,"label":"UCC"},{"value":2,"label":"EFS"},{"value":3,"label":"Title 71"}]}]},{"label":"Copy Request","component":"copies","parameter":"copies","sourceTypeId":2001,"myRecordsSearch":false,"myWorkQueueSearch":false,"disabled":false,"allowedRoutes":["/forms-manager/","/queue/","/forms/"]},{"label":"Trademark","component":"Trademark","parameter":"trademark","sourceTypeId":810,"showRequestCertificate":true,"searchMustHaveOneOf":["search","EXPIRATION_DATE","FILING_DATE"],"allowEmptySearchTerm":true,"requestCertificateAlternateLabel":"Request Information","fileAmendmentButtonLabel":"Filing Actions","advancedSearchParameters":[{"type":"radio","name":"QUERY_TYPE_ID","defaultValue":1010,"options":[{"value":1010,"label":"Starts with"},{"value":1011,"label":"Contains"},{"value":1012,"label":" Word Contains"}]},{"type":"checkbox","name":"OWNER_SEARCH_YN","defaultValue":false,"label":"Search owners"},{"type":"radio","name":"SERVICE_MARK_YN","label":"Mark Type","defaultValue":"","options":[{"value":"","label":"All Marks"},{"value":"Y","label":"Service Mark"},{"value":"N","label":"Trademark"}]},{"type":"serverSelect","name":"STATUS_ID","optionsSrc":"TYPE_V|TRADEMARK_STATUS_TYPE","label":"Status","placeholder":"All","defaultValue":"0"},{"type":"select","name":"DESIGN_TYPE_ID","options":[{"value":0,"label":"All"},{"value":990,"label":"Words Only"},{"value":991,"label":"Design Only"},{"value":992,"label":"Words and Design"}],"label":"Design Type","defaultValue":"0"},{"type":"dateRange","name":"FILING_DATE","label":"Registered Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}},{"type":"dateRange","name":"EXPIRATION_DATE","label":"Expiration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}}]},{"label":"Business Info Request","component":"InfoRequests","parameter":"info-request","sourceTypeId":167,"allowedRoutes":["/forms-manager/","/queue/","/forms/"]},{"label":"Data Requests","component":"DataRequests","parameter":"data-request","sourceTypeId":0,"allowedRoutes":["/forms-manager/"]},{"label":"CRA","component":"CRA","parameter":"cra","sourceTypeId":157,"myRecordsSearch":false,"searchPlaceholder":"Search by name or registered agent number","allowedRoutes":["/forms-manager/","/forms/","/records/","/queue/","/search/"],"allowEmptySearchTerm":true,"fileAmendmentButtonLabel":"Filing Actions","advancedSearchParameters":[{"type":"radio","name":"QUERY_TYPE_ID","defaultValue":1010,"options":[{"value":1010,"label":"Starts with"},{"value":1011,"label":"Contains"},{"value":1012,"label":" Word Contains"}]},{"type":"dateRange","name":"CRA_DATE","label":"Registration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}},{"type":"select","name":"STATUS_ID","label":"Status","defaultValue":0,"options":[{"value":0,"label":"All"},{"value":121,"label":"Active"},{"value":122,"label":"Inactive"}]},{"type":"select","name":"AGENT_TYPE_ID","label":"Agent Type","defaultValue":0,"options":[{"value":0,"label":"All"},{"value":460,"label":"Registered Agent"},{"value":461,"label":"Commercial Registered Agent"}]}]},{"label":"Farm Bill","component":"FarmBill","parameter":"farm-bill","path":"/lists/farm-bill","sourceTypeId":0,"myRecordsSearch":false,"allowedRules":["/search/"],"disabled":true,"searchDescription":"To perform a search, enter a debtor name. Your search results may include: exact debtor name, variations of that name and any filing that includes your search criteria. Punctuation is ignored.\n\nYou can click on \"Advanced\" to refine your search. Under “Advanced” you can search by crop, year, county and SSN/FEIN. As a registered Farm Bill Buyer with the Montana Secretary of State’s office it is important to maintain the confidentiality of the information contained within the Farm Bill Master List. The Farm Bill Master List reflects personal data, such as Social Security Numbers, which are a key piece of personal identifiable information to assist you in determining the existence of a lien against a specific debtor. The distribution of this information beyond its intended purpose is strictly prohibited.\n\nThe debtor's tax identification number has been hidden for confidentiality reasons. You may continue to search on a tax ID number and return debtors that match your search criteria. The SSN/FEIN must be entered without dashes or spaces.","searchMustHaveOneOf":["search","UCC_FARM_PRODUCT_ID","COUNTY"],"searchPlaceholder":"Search by debtor name","advancedSearchParameters":[{"type":"ServerMultiComplete","label":"Product code name(s)","name":"UCC_FARM_PRODUCT_ID","defaultValue":"","optionsSrc":"UCC_FARM_PRODUCT_V"},{"type":"MultiComplete","label":"Year or Range of Years","name":"YEAR_NUM","optionsSrc":"years","startYear":"1968","defaultValue":[],"preMergeOptions":[{"value":"ALL","label":"All"}]},{"type":"serverSelect","label":"State","name":"STATE","defaultValue":"MONTANA","optionsSrc":"STATE"},{"type":"ServerMultiComplete","label":"County","name":"COUNTY","defaultValue":[],"optionsSrc":"COUNTY","overrideSubOptionsSrcFromParameterName":"STATE"},{"type":"checkbox","name":"TIN_SEARCH_YN","defaultValue":false,"label":"Tax Identification Number Search"},{"type":"checkbox","name":"TIN_SORT_YN","defaultValue":false,"label":"Unique ID Sort"}]}],"SYSTEM_NICKNAME":"Online Services Portal","PAYMENT_METHODS":[{"type":"bypass"},{"type":"iTransact"}],"PAYMENT_ALLOW_AMEX":true,"SYSTEM_ID_LABEL":"System Id","DOUBLE_COLUMN_PUBLIC_LOGIN":true,"INTERNAL_USER_MANAGEMENT":true,"ALLOW_PUBLIC_JSON_IMPORT":false,"MAX_FILE_UPLOAD_SIZE":10000000,"REFUND_TEXT":"","RETURN_TO_HOME_ON_LOGOUT":true,"CURRENT_SOS_NAME":"Christi Jacobsen","LOGO_FILENAME":"mt-sos-logo.png","LOGO_ALT":"Christi Jacobsen, Montana Secretary of State","LOGO_FULL_WIDTH":true,"HOME_HIDE_AUTH_HINT":true,"HOME_TITLE":"Montana Secretary of State","CUSTOM_TAB_TITLE":"Official Montana","HOME_SUBTITLE":"Online Business Services","ENTITY_NAME_CONSENT_DESCRIPTION":"","ALLOW_USER_PROFILE_EDITING":true,"COMPARE_FOREIGN_NAME_IN_ENTITY_NAME_VALIDATION":true,"FOREIGN_NAME_FIELD_NAME":"KIMA_PARENT_NAME_INFO","LOGIN_TITLE":"Montana Secretary of State Online Filing Portal Login","PUBLIC_LOGIN_LABEL":"Username","REVERSE_LOGIN_COLUMNS":true,"LOGIN_SEAL_FILENAME":"seal_white.png","SEPARATE_USERNAME_AND_EMAIL":true,"CREATE_ACCOUNT_BUTTON_ALIGN_LEFT":true,"CREATE_ACCOUNT_BUTTON_TEXT":"CREATE AN ACCOUNT","PASSWORD_CUSTOM_ERROR_TEXT":"The password must meet all requirements","ACCOUNT_CREATED_MESSAGE":"Please check your email to verify your account to login and allow a few minutes for this message to arrive. Check your junk/spam folders if you do not find the email in your inbox.","PUBLIC_LOGIN_PLACEHOLDER":" ","DISABLE_DEFAULT_PAYMENT_RADIO":true,"CUSTOM_RESET_PASSWORD_ERROR_MESSAGE":"Username invalid - no account found","PUBLIC_LOGIN_CREATE_DESCRIPTION":"### Existing User:\n\n  - Enter your username and password to login.  \n\n\n  #### - OR -  \n\n\n\n  - Forgot password? Click 'Reset Password' and follow the prompts.\n  - Forgot username? Click 'Forgot Username' and follow the prompts.  \n\n\n  ### New User:\n  ","LOGIN_HELP_LINK":"https://sosmt.gov/business/how-do-i/","LOGIN_HELP_LINK_TEXT":"Need Help?","FORGOT_USERNAME_TEXT":"Forgot Username?","LOGIN_ACTIVE_DIRECTORY_TEXT":"State User Login","MULTIPLE_LOGIN_METHODS":true,"HAS_ACTIVE_DIRECTORY_LOGIN":true,"RESET_PASSWORD_WITH_USERNAME":true,"DOWNLOAD_LINK":true,"SHOW_USERNAME_ACCOUNT_CREATE":true,"SHOW_SCROLL_DOWN_ARROW":true,"SHOW_ADDRESS_ACCOUNT_CREATE":true,"TWO_COLUMN_ACCOUNT_CREATE":true,"RESET_PASSWORD_TIP":"A link to change your password has been sent to your email. Please allow a few minutes for this message to arrive. Please check your junk/spam folders if you do not find the email in your inbox.","FORGOT_PASSWORD_LINK_TEXT":"Reset Password","PHONE_NUMBER_OPTIONAL_ACCOUNT_CREATE":true,"SHOW_REQUIRED_INDICATOR_ACCOUNT_CREATE":true,"PASSWORD_REQUIREMENTS_ACCOUNT_CREATE":"\n    <ul>\n      <li>MUST contain at least 8 characters (12+ recommended)</li>\n      <li>MUST contain at least one uppercase letter.</li>\n      <li>MUST contain at least one lowercase letter.</li>\n      <li>MUST contain at least one number.</li>\n      <li>MUST contain at least one special character (!”#$%&'()*+,-./:;<=>?</li>\n    </ul>\n  ","ALLOW_CERTIFICATION_REQUEST":true,"ALLOW_PUBLIC_CERTIFICATE_REQUEST":true,"ALLOW_COPY_REQUEST":false,"ALLOW_CORRECTION_STYLING":true,"HIDE_DEPRECATION_WARNING":false,"AMEND_ROUTE_PUBLIC":true,"SEAL_FILENAME":"seal.png","SHOPPING_CART":true,"ALLOW_PAYMENT_UPDATE_WITH_EMPTY_CART":true,"RA_EMAIL":true,"RA_WEBSITE":true,"RA_NO_DEFAULT_TYPE":true,"RA_ADDRESS_LABEL":"Street Address","RA_TYPE_SELECTION_DEFAULT":true,"RA_DEFAULT_TYPE":"460","RA_OVERRIDE_TYPE_WITH_DEFAULT":true,"RA_PRINCIPAL_ADDRESS_AMS":true,"UPLOAD_AND_SUBMIT_HIDE_IF_ONE_OPTION":true,"PAYMENT_PROCESSING_MESSAGE":"Your payment is processing - Do not close your browser or click the back button","CHECKOUT_BUTTON_WHEN_PROCESSING_TEXT":"Processing","EFS_CROP_PICKER_NONE_LABEL":"Lien Duration","DISALLOWED_WIZARD_PIECES":["FormationLocale"],"REPEATER_SHOW_EDIT_BUTTON":true,"DATA_REQUEST_PAGE_TITLE":"Data Requests and Subscriptions","DATA_REQUEST_SIDEBAR_LABEL":"Data Requests & Subscriptions","LOGIN_REDIRECTS_TO_EPASS":false,"LOGIN_REDIRECTS_TO_ACTIVE_DIRECTORY":true,"LOGIN_ACTIVE_DIRECTORY_LINK":true,"FETCH_EDIT_USER_LINK":false,"LISTS_FETCH_AVAILABLE_LISTS":true,"POST_WIZARD_SUBMIT_REDIRECT_URL":"/","PIN_REQUEST_ATTESTATIONS":true,"PIN_REQUEST_DESCRIPTION":"Click **Request PIN** to have a new PIN sent to the account holder's email address on file.","OWNERSHIP_REQUEST_DESCRIPTION":"To become an **authorized user** of this record, a current **AUTHORIZED USER** will need to grant you access. To request access, click **Request Access** below.","PIN_REQUEST_SUCCESS_MESSAGE":"The PIN you have requested for this entity has been sent to the email associated with your user account.  You should receive the PIN in approximately 3-5 minutes, depending on your email service provider.","APOSTILLE_HEADER_LABEL":"Verification Information","APOSTILLE_NUMBER_LABEL":"Apostille/Authentication","APOSTILLE_CITY_STATE_OVERRIDE":"HELENA, MT","APOSTILLE_FILING_DATE_LABEL":"Issue Date","APOSTILLE_CITY_STATE_IN_CERTIFIED":true,"NOTARY_EXISTING_FILING":true,"ALLOW_REVOKE_OWN_ACCESS_ONLY":false,"HIDE_CANCEL_ON_ONETIME_DATA_REQUESTS":true,"DATA_REQUESTS_IN_SHOPPING_CART":true,"WQ_ALLOW_EDIT_PENDING_PAYMENT":true,"WQ_CONFIRM_ON_DELETE":true,"WQ_DELETE_CONFIRM_MESSAGE":"Deleting this filing will forfeit any money already paid to the Secretary of State. This action is permanent and cannot be undone, are you sure you would like to delete?","PASS_ITEM_GUIDS_ON_CHECKOUT":true,"FORM_REVISION_HISTORY":true,"CHECKOUT_DISCLAIMER":"By entering your credit card and/or checking account information you (i) state that **you are an authorized user** of the credit card and/or electronic check and that the associated information entered (e.g., account holder name, account number, billing address) is accurate, (ii) **you authorize payment processor to charge the amount you have requested** to your credit card and/or funding account, and (iii) **acknowledge if a charge is declined or reversed you may also be assessed a customary charge** by the payment processor for such transactions.","FARM_BILL_SEARCH_CONFIDENTIAL":"As a registered Farm Bill Buyer with the Montana Secretary of State’s office it is important to maintain the confidentiality of the information contained within the Farm Bill Master List. The Farm Bill Master List reflects personal data, such as Social Security Numbers, which are a key piece of personal identifiable information to assist you in determining the existence of a lien against a specific debtor. The distribution of this information beyond its intended purpose is strictly prohibited.\n\n**The debtor's tax identification number has been hidden for confidentiality reasons. You may continue to search on a tax ID number and return debtors that match your search criteria. The SSN/FEIN must be entered without dashes or spaces.  If you need access to the tax identification number to clearly identify the debtor, please contact the UCC unit at (406) 444-3665.**","VIEW_HISTORY_BUTTON_ALT_TEXT":"View Filings","WIZARD_ERROR_TITLE_MESSAGE":"Form Error","FARM_BILL_SEARCH_INTERACTIVE":true,"USE_FARM_BILL_API":true,"DISALLOW_ASSIGN_SELF_AS_RA":true,"DISALLOW_ASSIGN_SELF_AS_PRINCIPAL":true,"USE_TRADEMARK_OWNER_VALIDATION":true,"USE_ALTERNATIVE_FOREIGN_ADDRESS_LABELS":true,"MY_RECEIPTS_FILTER":[{"type":"dateRange","name":"DATE_RANGE","label":"Date range","defaultValue":{"start":null,"end":null}},{"type":"text","name":"REF_NUM","defaultValue":"","label":"Reference Number"},{"type":"text","name":"RECEIPT_NUM","defaultValue":"","label":"Receipt Id"},{"type":"text","name":"AMOUNT","defaultValue":"","label":"Amount"},{"type":"select","name":"TYPE","defaultValue":"","label":"Payment Type","options":[{"value":"","label":"All"},{"value":"CC","label":"Credit Card"},{"value":"Check","label":"Check"}]}],"MY_RECEIPTS_SHOW_IN_SIDEBAR":true,"SHOW_MY_RECEIPTS_HELPER_TEXT":true,"MY_RECEIPTS_HELPER_LABEL":"About Receipt Search","MY_RECEIPTS_HELPER_TEXT":"You can search for receipts based on their descriptions, including the items paid for on the receipt. Use the filters to search for or filter specific information.","FARM_BILL_SUBLINK":{"label":"Farm Bill","component":"FarmBill","parameter":"farm-bill","path":"/lists/farm-bill","sourceTypeId":0,"myRecordsSearch":false,"allowedRules":["/search/"],"disabled":true,"searchDescription":"To perform a search, enter a debtor name. Your search results may include: exact debtor name, variations of that name and any filing that includes your search criteria. Punctuation is ignored.\n\nYou can click on \"Advanced\" to refine your search. Under “Advanced” you can search by crop, year, county and SSN/FEIN. As a registered Farm Bill Buyer with the Montana Secretary of State’s office it is important to maintain the confidentiality of the information contained within the Farm Bill Master List. The Farm Bill Master List reflects personal data, such as Social Security Numbers, which are a key piece of personal identifiable information to assist you in determining the existence of a lien against a specific debtor. The distribution of this information beyond its intended purpose is strictly prohibited.\n\nThe debtor's tax identification number has been hidden for confidentiality reasons. You may continue to search on a tax ID number and return debtors that match your search criteria. The SSN/FEIN must be entered without dashes or spaces.","searchMustHaveOneOf":["search","UCC_FARM_PRODUCT_ID","COUNTY"],"searchPlaceholder":"Search by debtor name","advancedSearchParameters":[{"type":"ServerMultiComplete","label":"Product code name(s)","name":"UCC_FARM_PRODUCT_ID","defaultValue":"","optionsSrc":"UCC_FARM_PRODUCT_V"},{"type":"MultiComplete","label":"Year or Range of Years","name":"YEAR_NUM","optionsSrc":"years","startYear":"1968","defaultValue":[],"preMergeOptions":[{"value":"ALL","label":"All"}]},{"type":"serverSelect","label":"State","name":"STATE","defaultValue":"MONTANA","optionsSrc":"STATE"},{"type":"ServerMultiComplete","label":"County","name":"COUNTY","defaultValue":[],"optionsSrc":"COUNTY","overrideSubOptionsSrcFromParameterName":"STATE"},{"type":"checkbox","name":"TIN_SEARCH_YN","defaultValue":false,"label":"Tax Identification Number Search"},{"type":"checkbox","name":"TIN_SORT_YN","defaultValue":false,"label":"Unique ID Sort"}]},"ALLOW_ADDRESS_VALIDATION_BYPASS_OPTION":true,"DEFAULT_ADDRESS_VALIDATION_BYPASS_OPTION_CHECKED":true}).HAS_OKTA_LOGIN) {
	        _this3.fetchOktaDomain();
	      }
	    }, _this3.fetchOktaDomain = function () {
	      (0, _requests2.GET_APP_SETTING_BY_NAME)('OKTA_DOMAIN', function (setting) {
	        if (setting) {
	          _this3.setState({
	            oktaDomain: setting.VALUE,
	            oktaDomainLoading: false
	          });
	        }
	      }, function (err) {
	        console.error(err);
	        _this3.setState({ oktaDomainError: err, oktaDomainLoading: false });
	      });
	    }, _this3.getState = function () {
	      return Object.assign({}, _this3.state);
	    }, _this3.componentWillReceiveProps = function (nextProps) {
	      if (_this3.props.user.WEB_USER_ID !== nextProps.user.WEB_USER_ID) {
	        _this3.setState(Object.assign({}, nextProps.user));
	      }
	    }, _this3.setValue = function (value, key) {
	      return _this3.setState(_defineProperty({}, key, value));
	    }, _temp2), _possibleConstructorReturn(_this3, _ret2);
	  }
	
	  _createClass(EditorForm, [{
	    key: 'render',
	    value: function render() {
	      var _this4 = this;
	
	      var _props2 = this.props,
	          error = _props2.error,
	          getStateCallback = _props2.getStateCallback;
	
	      var fieldDisabled = ({"NODE_ENV":"production","BUILD_DATE":"2025-08-27T15:15:31.687Z","BUILD_NUMBER":"Not Provided","GIT_VERSION":"v1.3.0-381-ga81e29b08","GIT_COMMIT_HASH":"a81e29b085c9268ffd96c78eb734365802722741","GIT_BRANCH":"beta","PUBLIC_URL":"","STATE_ABBR":"MT","STATE_NAME":"Montana","STATE_ORG_TITLE":"Secretary of State","LOGIN_HEADER_IMG_PATH":"","HOME_IMG_FILENAME":"montana.jpg","FAVICON_FILE_NAME":"favicon.ico","ALLOW_E_SIGN_ON_CORRECTIONS":true,"THIRD_PARTY_SIGNING_ALLOWED":false,"MY_ACCOUNT_SAVE_AND_CLOSE_BUTTON":true,"IE_DEPRECATED_MESSAGE":"Internet Explorer is not supported. Please select a supported browser below to access this website.","ADDITIONAL_ROUTES":{"dataRequests":true,"farmBill":true,"apostille":true,"externalHelp":"https://sosmt.gov/business/help-center/","systemAdministration":[{"title":"Saved Payments","parameter":"saved-payments","componentName":"SavedPayments"}]},"SUBROUTES":[{"label":"Business","component":"Business","parameter":"business","myWorkQueueSearch":false,"sourceTypeId":54,"searchMustHaveOneOf":["FILING_TYPE_ID","STATUS_ID","STATE","search"],"serverWebSearchDescription":true,"serverWorkQueueDescription":true,"serverMyRecordsDescription":true,"searchPlaceholder":"Search by name or filing number (X########)","allowEmptySearchTerm":true,"requestCertificateAlternateLabel":"Request Information","fileAmendmentButtonLabel":"Filing Actions","advancedSearchParameters":[{"type":"radio","name":"QUERY_TYPE_ID","defaultValue":1010,"options":[{"value":1010,"label":"Starts with"},{"value":1011,"label":"Contains"},{"value":1012,"label":" Word Contains"}]},{"type":"serverSelect","name":"FILING_TYPE_ID","optionsSrc":"FILING_TYPES","label":"Entity Type","placeholder":"All","defaultValue":"0"},{"type":"serverSelect","name":"FILING_SUBTYPE_ID","optionsSrc":"FILING_SUBTYPES","label":"Entity Subtype","overrideSubOptionsSrcFromParameterName":"FILING_TYPE_ID","placeholder":"All","defaultValue":"0"},{"type":"serverSelect","name":"STATUS_ID","optionsSrc":"FILING_STATUS_WITHOUT_ALL","label":"Status","placeholder":"All","defaultValue":"0"},{"type":"serverSelect","name":"STATE","optionsSrc":"STATE","label":"State","placeholder":"All","defaultValue":""},{"type":"serverSelect","name":"COUNTY","optionsSrc":"COUNTY_SUBOPTION","label":"County","overrideSubOptionsSrcFromParameterName":"STATE","placeholder":"All","defaultValue":""},{"type":"checkbox","name":"CRA_SEARCH_YN","defaultValue":false,"label":"Search by Registered Agent PID"},{"type":"dateRange","name":"FILING_DATE","label":"Registration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}},{"type":"dateRange","name":"EXPIRATION_DATE","label":"Expiration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}}],"myRecordsFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Active"},{"value":2,"label":"Inactive"},{"value":3,"label":"Pending"}]},{"type":"dateRange","name":"DATE_RANGE","label":"Date range","defaultValue":{"start":null,"end":null}}],"myWorkQueueFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Approved"},{"value":2,"label":"Pending Online Payment"},{"value":3,"label":"Pending Review"},{"value":4,"label":"Needs Correction"},{"value":5,"label":"Rejected"},{"value":6,"label":"Draft"}]},{"type":"dateRange","name":"DATE_RANGE","label":"Date range","defaultValue":{"start":null,"end":null}}]},{"label":"Notary","component":"Notary","parameter":"notary","sourceTypeId":850,"myWorkQueueSearch":false,"allowEmptySearchTerm":true,"requestCertificateAlternateLabel":"Download Certificate","fileAmendmentButtonLabel":"Filing Actions","hideNameRequestCertificate":true,"hideAddressRequestCertificate":true,"hideRecordUserManagment":true,"searchPlaceholder":"Search by name or commission number","searchMustHaveOneOf":["CITY","search","SERVICE_TYPE"],"advancedParametersStartOpen":true,"searchIsSortable":true,"advancedSearchParameters":[{"type":"radio","name":"STARTS_WITH_YN","defaultValue":false,"options":[{"value":true,"label":"Starts with"},{"value":false,"label":"Contains"}]},{"type":"checkbox","name":"ACTIVE_ONLY_YN","defaultValue":true,"label":"Active entities only"},{"type":"text","name":"CITY","defaultValue":"","label":"City"},{"type":"select","name":"SERVICE_TYPE","label":"Special Services Offered","defaultValue":0,"options":[{"value":0,"label":"(N/A)"},{"value":6165,"label":"In-Person Electronic Notarization (IPEN)"},{"value":6166,"label":"Remote Online Notarization (RON)"},{"value":6167,"label":"Mobile Notary Services"},{"value":6168,"label":"Remote Ink Notarization (RIN)"}]}]},{"label":"Apostille","component":"Apostille","parameter":"apostille","sourceTypeId":720,"myRecordsSearch":false,"myWorkQueueSearch":false,"disabled":false,"allowedRoutes":["/forms-manager/","/queue/","/forms/"]},{"label":"Liens","component":"UCC","parameter":"ucc","sourceTypeId":1999,"myRecordsSearch":true,"myWorkQueueSearch":true,"fileAmendmentButtonLabel":"Filing Actions","searchPlaceholder":"Search by name or file number","disabled":false,"serverWebSearchDescription":true,"myRecordsDescription":"","workQueueDescription":"","searchDescription":"","hideRecordUserManagment":true,"searchLiensCheckout":false,"advancedSearchParameters":[{"type":"radio","name":"STARTS_WITH_YN","defaultValue":false,"options":[{"value":true,"label":"Starts with"},{"value":false,"label":"Contains"}]},{"type":"select","name":"STATUS","defaultValue":"ALL","label":"Status","options":[{"value":"ACTIVE_UNLAPSED","label":"Active (unlapsed)"},{"value":"ACTIVE_LAPSED_UNLAPSED","label":"Active (lapsed and unlapsed)"}]},{"type":"text","name":"EXCLUDE_VALUES","label":"Exclude Debtor Names (comma separated list of names to exclude)","defaultValue":""},{"type":"dateRange","name":"FILING_DATE","label":"Financing Statement Date","defaultValue":{"start":null,"end":null}},{"type":"dateRange","name":"LAPSE_DATE","label":"Lapse Date","defaultValue":{"start":null,"end":null}},{"type":"text","name":"CITY","label":"Debtor City","defaultValue":""}],"myRecordsFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Approved"},{"value":2,"label":"Pending Online Payment"},{"value":3,"label":"Pending Review"}]},{"type":"select","name":"TYPE","defaultValue":0,"label":"Lien Type","options":[{"value":0,"label":"All"},{"value":1,"label":"UCC"},{"value":2,"label":"EFS"},{"value":3,"label":"Title 71"}]}],"myWorkQueueFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Approved"},{"value":2,"label":"Pending Online Payment"},{"value":3,"label":"Pending Review"},{"value":4,"label":"Pending Print and Mail"},{"value":5,"label":"Rejected"},{"value":6,"label":"Draft"}]},{"type":"select","name":"TYPE","defaultValue":0,"label":"Lien Type","options":[{"value":0,"label":"All"},{"value":1,"label":"UCC"},{"value":2,"label":"EFS"},{"value":3,"label":"Title 71"}]}]},{"label":"Copy Request","component":"copies","parameter":"copies","sourceTypeId":2001,"myRecordsSearch":false,"myWorkQueueSearch":false,"disabled":false,"allowedRoutes":["/forms-manager/","/queue/","/forms/"]},{"label":"Trademark","component":"Trademark","parameter":"trademark","sourceTypeId":810,"showRequestCertificate":true,"searchMustHaveOneOf":["search","EXPIRATION_DATE","FILING_DATE"],"allowEmptySearchTerm":true,"requestCertificateAlternateLabel":"Request Information","fileAmendmentButtonLabel":"Filing Actions","advancedSearchParameters":[{"type":"radio","name":"QUERY_TYPE_ID","defaultValue":1010,"options":[{"value":1010,"label":"Starts with"},{"value":1011,"label":"Contains"},{"value":1012,"label":" Word Contains"}]},{"type":"checkbox","name":"OWNER_SEARCH_YN","defaultValue":false,"label":"Search owners"},{"type":"radio","name":"SERVICE_MARK_YN","label":"Mark Type","defaultValue":"","options":[{"value":"","label":"All Marks"},{"value":"Y","label":"Service Mark"},{"value":"N","label":"Trademark"}]},{"type":"serverSelect","name":"STATUS_ID","optionsSrc":"TYPE_V|TRADEMARK_STATUS_TYPE","label":"Status","placeholder":"All","defaultValue":"0"},{"type":"select","name":"DESIGN_TYPE_ID","options":[{"value":0,"label":"All"},{"value":990,"label":"Words Only"},{"value":991,"label":"Design Only"},{"value":992,"label":"Words and Design"}],"label":"Design Type","defaultValue":"0"},{"type":"dateRange","name":"FILING_DATE","label":"Registered Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}},{"type":"dateRange","name":"EXPIRATION_DATE","label":"Expiration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}}]},{"label":"Business Info Request","component":"InfoRequests","parameter":"info-request","sourceTypeId":167,"allowedRoutes":["/forms-manager/","/queue/","/forms/"]},{"label":"Data Requests","component":"DataRequests","parameter":"data-request","sourceTypeId":0,"allowedRoutes":["/forms-manager/"]},{"label":"CRA","component":"CRA","parameter":"cra","sourceTypeId":157,"myRecordsSearch":false,"searchPlaceholder":"Search by name or registered agent number","allowedRoutes":["/forms-manager/","/forms/","/records/","/queue/","/search/"],"allowEmptySearchTerm":true,"fileAmendmentButtonLabel":"Filing Actions","advancedSearchParameters":[{"type":"radio","name":"QUERY_TYPE_ID","defaultValue":1010,"options":[{"value":1010,"label":"Starts with"},{"value":1011,"label":"Contains"},{"value":1012,"label":" Word Contains"}]},{"type":"dateRange","name":"CRA_DATE","label":"Registration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}},{"type":"select","name":"STATUS_ID","label":"Status","defaultValue":0,"options":[{"value":0,"label":"All"},{"value":121,"label":"Active"},{"value":122,"label":"Inactive"}]},{"type":"select","name":"AGENT_TYPE_ID","label":"Agent Type","defaultValue":0,"options":[{"value":0,"label":"All"},{"value":460,"label":"Registered Agent"},{"value":461,"label":"Commercial Registered Agent"}]}]},{"label":"Farm Bill","component":"FarmBill","parameter":"farm-bill","path":"/lists/farm-bill","sourceTypeId":0,"myRecordsSearch":false,"allowedRules":["/search/"],"disabled":true,"searchDescription":"To perform a search, enter a debtor name. Your search results may include: exact debtor name, variations of that name and any filing that includes your search criteria. Punctuation is ignored.\n\nYou can click on \"Advanced\" to refine your search. Under “Advanced” you can search by crop, year, county and SSN/FEIN. As a registered Farm Bill Buyer with the Montana Secretary of State’s office it is important to maintain the confidentiality of the information contained within the Farm Bill Master List. The Farm Bill Master List reflects personal data, such as Social Security Numbers, which are a key piece of personal identifiable information to assist you in determining the existence of a lien against a specific debtor. The distribution of this information beyond its intended purpose is strictly prohibited.\n\nThe debtor's tax identification number has been hidden for confidentiality reasons. You may continue to search on a tax ID number and return debtors that match your search criteria. The SSN/FEIN must be entered without dashes or spaces.","searchMustHaveOneOf":["search","UCC_FARM_PRODUCT_ID","COUNTY"],"searchPlaceholder":"Search by debtor name","advancedSearchParameters":[{"type":"ServerMultiComplete","label":"Product code name(s)","name":"UCC_FARM_PRODUCT_ID","defaultValue":"","optionsSrc":"UCC_FARM_PRODUCT_V"},{"type":"MultiComplete","label":"Year or Range of Years","name":"YEAR_NUM","optionsSrc":"years","startYear":"1968","defaultValue":[],"preMergeOptions":[{"value":"ALL","label":"All"}]},{"type":"serverSelect","label":"State","name":"STATE","defaultValue":"MONTANA","optionsSrc":"STATE"},{"type":"ServerMultiComplete","label":"County","name":"COUNTY","defaultValue":[],"optionsSrc":"COUNTY","overrideSubOptionsSrcFromParameterName":"STATE"},{"type":"checkbox","name":"TIN_SEARCH_YN","defaultValue":false,"label":"Tax Identification Number Search"},{"type":"checkbox","name":"TIN_SORT_YN","defaultValue":false,"label":"Unique ID Sort"}]}],"SYSTEM_NICKNAME":"Online Services Portal","PAYMENT_METHODS":[{"type":"bypass"},{"type":"iTransact"}],"PAYMENT_ALLOW_AMEX":true,"SYSTEM_ID_LABEL":"System Id","DOUBLE_COLUMN_PUBLIC_LOGIN":true,"INTERNAL_USER_MANAGEMENT":true,"ALLOW_PUBLIC_JSON_IMPORT":false,"MAX_FILE_UPLOAD_SIZE":10000000,"REFUND_TEXT":"","RETURN_TO_HOME_ON_LOGOUT":true,"CURRENT_SOS_NAME":"Christi Jacobsen","LOGO_FILENAME":"mt-sos-logo.png","LOGO_ALT":"Christi Jacobsen, Montana Secretary of State","LOGO_FULL_WIDTH":true,"HOME_HIDE_AUTH_HINT":true,"HOME_TITLE":"Montana Secretary of State","CUSTOM_TAB_TITLE":"Official Montana","HOME_SUBTITLE":"Online Business Services","ENTITY_NAME_CONSENT_DESCRIPTION":"","ALLOW_USER_PROFILE_EDITING":true,"COMPARE_FOREIGN_NAME_IN_ENTITY_NAME_VALIDATION":true,"FOREIGN_NAME_FIELD_NAME":"KIMA_PARENT_NAME_INFO","LOGIN_TITLE":"Montana Secretary of State Online Filing Portal Login","PUBLIC_LOGIN_LABEL":"Username","REVERSE_LOGIN_COLUMNS":true,"LOGIN_SEAL_FILENAME":"seal_white.png","SEPARATE_USERNAME_AND_EMAIL":true,"CREATE_ACCOUNT_BUTTON_ALIGN_LEFT":true,"CREATE_ACCOUNT_BUTTON_TEXT":"CREATE AN ACCOUNT","PASSWORD_CUSTOM_ERROR_TEXT":"The password must meet all requirements","ACCOUNT_CREATED_MESSAGE":"Please check your email to verify your account to login and allow a few minutes for this message to arrive. Check your junk/spam folders if you do not find the email in your inbox.","PUBLIC_LOGIN_PLACEHOLDER":" ","DISABLE_DEFAULT_PAYMENT_RADIO":true,"CUSTOM_RESET_PASSWORD_ERROR_MESSAGE":"Username invalid - no account found","PUBLIC_LOGIN_CREATE_DESCRIPTION":"### Existing User:\n\n  - Enter your username and password to login.  \n\n\n  #### - OR -  \n\n\n\n  - Forgot password? Click 'Reset Password' and follow the prompts.\n  - Forgot username? Click 'Forgot Username' and follow the prompts.  \n\n\n  ### New User:\n  ","LOGIN_HELP_LINK":"https://sosmt.gov/business/how-do-i/","LOGIN_HELP_LINK_TEXT":"Need Help?","FORGOT_USERNAME_TEXT":"Forgot Username?","LOGIN_ACTIVE_DIRECTORY_TEXT":"State User Login","MULTIPLE_LOGIN_METHODS":true,"HAS_ACTIVE_DIRECTORY_LOGIN":true,"RESET_PASSWORD_WITH_USERNAME":true,"DOWNLOAD_LINK":true,"SHOW_USERNAME_ACCOUNT_CREATE":true,"SHOW_SCROLL_DOWN_ARROW":true,"SHOW_ADDRESS_ACCOUNT_CREATE":true,"TWO_COLUMN_ACCOUNT_CREATE":true,"RESET_PASSWORD_TIP":"A link to change your password has been sent to your email. Please allow a few minutes for this message to arrive. Please check your junk/spam folders if you do not find the email in your inbox.","FORGOT_PASSWORD_LINK_TEXT":"Reset Password","PHONE_NUMBER_OPTIONAL_ACCOUNT_CREATE":true,"SHOW_REQUIRED_INDICATOR_ACCOUNT_CREATE":true,"PASSWORD_REQUIREMENTS_ACCOUNT_CREATE":"\n    <ul>\n      <li>MUST contain at least 8 characters (12+ recommended)</li>\n      <li>MUST contain at least one uppercase letter.</li>\n      <li>MUST contain at least one lowercase letter.</li>\n      <li>MUST contain at least one number.</li>\n      <li>MUST contain at least one special character (!”#$%&'()*+,-./:;<=>?</li>\n    </ul>\n  ","ALLOW_CERTIFICATION_REQUEST":true,"ALLOW_PUBLIC_CERTIFICATE_REQUEST":true,"ALLOW_COPY_REQUEST":false,"ALLOW_CORRECTION_STYLING":true,"HIDE_DEPRECATION_WARNING":false,"AMEND_ROUTE_PUBLIC":true,"SEAL_FILENAME":"seal.png","SHOPPING_CART":true,"ALLOW_PAYMENT_UPDATE_WITH_EMPTY_CART":true,"RA_EMAIL":true,"RA_WEBSITE":true,"RA_NO_DEFAULT_TYPE":true,"RA_ADDRESS_LABEL":"Street Address","RA_TYPE_SELECTION_DEFAULT":true,"RA_DEFAULT_TYPE":"460","RA_OVERRIDE_TYPE_WITH_DEFAULT":true,"RA_PRINCIPAL_ADDRESS_AMS":true,"UPLOAD_AND_SUBMIT_HIDE_IF_ONE_OPTION":true,"PAYMENT_PROCESSING_MESSAGE":"Your payment is processing - Do not close your browser or click the back button","CHECKOUT_BUTTON_WHEN_PROCESSING_TEXT":"Processing","EFS_CROP_PICKER_NONE_LABEL":"Lien Duration","DISALLOWED_WIZARD_PIECES":["FormationLocale"],"REPEATER_SHOW_EDIT_BUTTON":true,"DATA_REQUEST_PAGE_TITLE":"Data Requests and Subscriptions","DATA_REQUEST_SIDEBAR_LABEL":"Data Requests & Subscriptions","LOGIN_REDIRECTS_TO_EPASS":false,"LOGIN_REDIRECTS_TO_ACTIVE_DIRECTORY":true,"LOGIN_ACTIVE_DIRECTORY_LINK":true,"FETCH_EDIT_USER_LINK":false,"LISTS_FETCH_AVAILABLE_LISTS":true,"POST_WIZARD_SUBMIT_REDIRECT_URL":"/","PIN_REQUEST_ATTESTATIONS":true,"PIN_REQUEST_DESCRIPTION":"Click **Request PIN** to have a new PIN sent to the account holder's email address on file.","OWNERSHIP_REQUEST_DESCRIPTION":"To become an **authorized user** of this record, a current **AUTHORIZED USER** will need to grant you access. To request access, click **Request Access** below.","PIN_REQUEST_SUCCESS_MESSAGE":"The PIN you have requested for this entity has been sent to the email associated with your user account.  You should receive the PIN in approximately 3-5 minutes, depending on your email service provider.","APOSTILLE_HEADER_LABEL":"Verification Information","APOSTILLE_NUMBER_LABEL":"Apostille/Authentication","APOSTILLE_CITY_STATE_OVERRIDE":"HELENA, MT","APOSTILLE_FILING_DATE_LABEL":"Issue Date","APOSTILLE_CITY_STATE_IN_CERTIFIED":true,"NOTARY_EXISTING_FILING":true,"ALLOW_REVOKE_OWN_ACCESS_ONLY":false,"HIDE_CANCEL_ON_ONETIME_DATA_REQUESTS":true,"DATA_REQUESTS_IN_SHOPPING_CART":true,"WQ_ALLOW_EDIT_PENDING_PAYMENT":true,"WQ_CONFIRM_ON_DELETE":true,"WQ_DELETE_CONFIRM_MESSAGE":"Deleting this filing will forfeit any money already paid to the Secretary of State. This action is permanent and cannot be undone, are you sure you would like to delete?","PASS_ITEM_GUIDS_ON_CHECKOUT":true,"FORM_REVISION_HISTORY":true,"CHECKOUT_DISCLAIMER":"By entering your credit card and/or checking account information you (i) state that **you are an authorized user** of the credit card and/or electronic check and that the associated information entered (e.g., account holder name, account number, billing address) is accurate, (ii) **you authorize payment processor to charge the amount you have requested** to your credit card and/or funding account, and (iii) **acknowledge if a charge is declined or reversed you may also be assessed a customary charge** by the payment processor for such transactions.","FARM_BILL_SEARCH_CONFIDENTIAL":"As a registered Farm Bill Buyer with the Montana Secretary of State’s office it is important to maintain the confidentiality of the information contained within the Farm Bill Master List. The Farm Bill Master List reflects personal data, such as Social Security Numbers, which are a key piece of personal identifiable information to assist you in determining the existence of a lien against a specific debtor. The distribution of this information beyond its intended purpose is strictly prohibited.\n\n**The debtor's tax identification number has been hidden for confidentiality reasons. You may continue to search on a tax ID number and return debtors that match your search criteria. The SSN/FEIN must be entered without dashes or spaces.  If you need access to the tax identification number to clearly identify the debtor, please contact the UCC unit at (406) 444-3665.**","VIEW_HISTORY_BUTTON_ALT_TEXT":"View Filings","WIZARD_ERROR_TITLE_MESSAGE":"Form Error","FARM_BILL_SEARCH_INTERACTIVE":true,"USE_FARM_BILL_API":true,"DISALLOW_ASSIGN_SELF_AS_RA":true,"DISALLOW_ASSIGN_SELF_AS_PRINCIPAL":true,"USE_TRADEMARK_OWNER_VALIDATION":true,"USE_ALTERNATIVE_FOREIGN_ADDRESS_LABELS":true,"MY_RECEIPTS_FILTER":[{"type":"dateRange","name":"DATE_RANGE","label":"Date range","defaultValue":{"start":null,"end":null}},{"type":"text","name":"REF_NUM","defaultValue":"","label":"Reference Number"},{"type":"text","name":"RECEIPT_NUM","defaultValue":"","label":"Receipt Id"},{"type":"text","name":"AMOUNT","defaultValue":"","label":"Amount"},{"type":"select","name":"TYPE","defaultValue":"","label":"Payment Type","options":[{"value":"","label":"All"},{"value":"CC","label":"Credit Card"},{"value":"Check","label":"Check"}]}],"MY_RECEIPTS_SHOW_IN_SIDEBAR":true,"SHOW_MY_RECEIPTS_HELPER_TEXT":true,"MY_RECEIPTS_HELPER_LABEL":"About Receipt Search","MY_RECEIPTS_HELPER_TEXT":"You can search for receipts based on their descriptions, including the items paid for on the receipt. Use the filters to search for or filter specific information.","FARM_BILL_SUBLINK":{"label":"Farm Bill","component":"FarmBill","parameter":"farm-bill","path":"/lists/farm-bill","sourceTypeId":0,"myRecordsSearch":false,"allowedRules":["/search/"],"disabled":true,"searchDescription":"To perform a search, enter a debtor name. Your search results may include: exact debtor name, variations of that name and any filing that includes your search criteria. Punctuation is ignored.\n\nYou can click on \"Advanced\" to refine your search. Under “Advanced” you can search by crop, year, county and SSN/FEIN. As a registered Farm Bill Buyer with the Montana Secretary of State’s office it is important to maintain the confidentiality of the information contained within the Farm Bill Master List. The Farm Bill Master List reflects personal data, such as Social Security Numbers, which are a key piece of personal identifiable information to assist you in determining the existence of a lien against a specific debtor. The distribution of this information beyond its intended purpose is strictly prohibited.\n\nThe debtor's tax identification number has been hidden for confidentiality reasons. You may continue to search on a tax ID number and return debtors that match your search criteria. The SSN/FEIN must be entered without dashes or spaces.","searchMustHaveOneOf":["search","UCC_FARM_PRODUCT_ID","COUNTY"],"searchPlaceholder":"Search by debtor name","advancedSearchParameters":[{"type":"ServerMultiComplete","label":"Product code name(s)","name":"UCC_FARM_PRODUCT_ID","defaultValue":"","optionsSrc":"UCC_FARM_PRODUCT_V"},{"type":"MultiComplete","label":"Year or Range of Years","name":"YEAR_NUM","optionsSrc":"years","startYear":"1968","defaultValue":[],"preMergeOptions":[{"value":"ALL","label":"All"}]},{"type":"serverSelect","label":"State","name":"STATE","defaultValue":"MONTANA","optionsSrc":"STATE"},{"type":"ServerMultiComplete","label":"County","name":"COUNTY","defaultValue":[],"optionsSrc":"COUNTY","overrideSubOptionsSrcFromParameterName":"STATE"},{"type":"checkbox","name":"TIN_SEARCH_YN","defaultValue":false,"label":"Tax Identification Number Search"},{"type":"checkbox","name":"TIN_SORT_YN","defaultValue":false,"label":"Unique ID Sort"}]},"ALLOW_ADDRESS_VALIDATION_BYPASS_OPTION":true,"DEFAULT_ADDRESS_VALIDATION_BYPASS_OPTION_CHECKED":true}).HAS_OKTA_LOGIN;
	      getStateCallback(this.getState);
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'user-account-editor wizard' },
	         true ? _react2.default.createElement(
	          _react2.default.Fragment,
	          null,
	          _react2.default.createElement(
	            _Field.DumbField,
	            { label: 'Username' + ( true ? '*' : ''), fieldId: 'username' },
	            _react2.default.createElement(_Form.TextInput, {
	              width: '100%',
	              fieldId: 'username',
	              onChange: function onChange(value) {
	                return _this4.setValue(value, 'USERNAME');
	              },
	              value: this.state.USERNAME,
	              disabled: true
	            })
	          ),
	          _react2.default.createElement(
	            _Field.DumbField,
	            { label: 'Email' + ( true ? '*' : ''), fieldId: 'email' },
	            _react2.default.createElement(_Form.TextInput, {
	              width: '100%',
	              fieldId: 'email',
	              onChange: function onChange(value) {
	                return _this4.setValue(value, 'EMAIL');
	              },
	              value: this.state.EMAIL,
	              disabled: fieldDisabled
	            })
	          )
	        ) : _react2.default.createElement(
	          _Field.DumbField,
	          { label: 'Email' + (process.env.SHOW_REQUIRED_INDICATOR_ACCOUNT_CREATE ? '*' : ''), fieldId: 'email' },
	          _react2.default.createElement(_Form.TextInput, {
	            width: '100%',
	            fieldId: 'email',
	            onChange: function onChange(value) {
	              return _this4.setValue(value, 'USERNAME');
	            },
	            value: this.state.USERNAME,
	            disabled: fieldDisabled
	          })
	        ),
	        _react2.default.createElement(
	          _Field.DumbField,
	          { label: 'Phone', fieldId: 'phone' },
	          _react2.default.createElement(_Form.TextInput, {
	            width: '100%',
	            fieldId: 'phone',
	            onChange: function onChange(value) {
	              return _this4.setValue(_validate.MASK.phone(value), 'PHONE');
	            },
	            value: this.state.PHONE,
	            disabled: fieldDisabled,
	            disableSelectionRestoration: true
	          })
	        ),
	        ({"NODE_ENV":"production","BUILD_DATE":"2025-08-27T15:15:31.687Z","BUILD_NUMBER":"Not Provided","GIT_VERSION":"v1.3.0-381-ga81e29b08","GIT_COMMIT_HASH":"a81e29b085c9268ffd96c78eb734365802722741","GIT_BRANCH":"beta","PUBLIC_URL":"","STATE_ABBR":"MT","STATE_NAME":"Montana","STATE_ORG_TITLE":"Secretary of State","LOGIN_HEADER_IMG_PATH":"","HOME_IMG_FILENAME":"montana.jpg","FAVICON_FILE_NAME":"favicon.ico","ALLOW_E_SIGN_ON_CORRECTIONS":true,"THIRD_PARTY_SIGNING_ALLOWED":false,"MY_ACCOUNT_SAVE_AND_CLOSE_BUTTON":true,"IE_DEPRECATED_MESSAGE":"Internet Explorer is not supported. Please select a supported browser below to access this website.","ADDITIONAL_ROUTES":{"dataRequests":true,"farmBill":true,"apostille":true,"externalHelp":"https://sosmt.gov/business/help-center/","systemAdministration":[{"title":"Saved Payments","parameter":"saved-payments","componentName":"SavedPayments"}]},"SUBROUTES":[{"label":"Business","component":"Business","parameter":"business","myWorkQueueSearch":false,"sourceTypeId":54,"searchMustHaveOneOf":["FILING_TYPE_ID","STATUS_ID","STATE","search"],"serverWebSearchDescription":true,"serverWorkQueueDescription":true,"serverMyRecordsDescription":true,"searchPlaceholder":"Search by name or filing number (X########)","allowEmptySearchTerm":true,"requestCertificateAlternateLabel":"Request Information","fileAmendmentButtonLabel":"Filing Actions","advancedSearchParameters":[{"type":"radio","name":"QUERY_TYPE_ID","defaultValue":1010,"options":[{"value":1010,"label":"Starts with"},{"value":1011,"label":"Contains"},{"value":1012,"label":" Word Contains"}]},{"type":"serverSelect","name":"FILING_TYPE_ID","optionsSrc":"FILING_TYPES","label":"Entity Type","placeholder":"All","defaultValue":"0"},{"type":"serverSelect","name":"FILING_SUBTYPE_ID","optionsSrc":"FILING_SUBTYPES","label":"Entity Subtype","overrideSubOptionsSrcFromParameterName":"FILING_TYPE_ID","placeholder":"All","defaultValue":"0"},{"type":"serverSelect","name":"STATUS_ID","optionsSrc":"FILING_STATUS_WITHOUT_ALL","label":"Status","placeholder":"All","defaultValue":"0"},{"type":"serverSelect","name":"STATE","optionsSrc":"STATE","label":"State","placeholder":"All","defaultValue":""},{"type":"serverSelect","name":"COUNTY","optionsSrc":"COUNTY_SUBOPTION","label":"County","overrideSubOptionsSrcFromParameterName":"STATE","placeholder":"All","defaultValue":""},{"type":"checkbox","name":"CRA_SEARCH_YN","defaultValue":false,"label":"Search by Registered Agent PID"},{"type":"dateRange","name":"FILING_DATE","label":"Registration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}},{"type":"dateRange","name":"EXPIRATION_DATE","label":"Expiration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}}],"myRecordsFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Active"},{"value":2,"label":"Inactive"},{"value":3,"label":"Pending"}]},{"type":"dateRange","name":"DATE_RANGE","label":"Date range","defaultValue":{"start":null,"end":null}}],"myWorkQueueFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Approved"},{"value":2,"label":"Pending Online Payment"},{"value":3,"label":"Pending Review"},{"value":4,"label":"Needs Correction"},{"value":5,"label":"Rejected"},{"value":6,"label":"Draft"}]},{"type":"dateRange","name":"DATE_RANGE","label":"Date range","defaultValue":{"start":null,"end":null}}]},{"label":"Notary","component":"Notary","parameter":"notary","sourceTypeId":850,"myWorkQueueSearch":false,"allowEmptySearchTerm":true,"requestCertificateAlternateLabel":"Download Certificate","fileAmendmentButtonLabel":"Filing Actions","hideNameRequestCertificate":true,"hideAddressRequestCertificate":true,"hideRecordUserManagment":true,"searchPlaceholder":"Search by name or commission number","searchMustHaveOneOf":["CITY","search","SERVICE_TYPE"],"advancedParametersStartOpen":true,"searchIsSortable":true,"advancedSearchParameters":[{"type":"radio","name":"STARTS_WITH_YN","defaultValue":false,"options":[{"value":true,"label":"Starts with"},{"value":false,"label":"Contains"}]},{"type":"checkbox","name":"ACTIVE_ONLY_YN","defaultValue":true,"label":"Active entities only"},{"type":"text","name":"CITY","defaultValue":"","label":"City"},{"type":"select","name":"SERVICE_TYPE","label":"Special Services Offered","defaultValue":0,"options":[{"value":0,"label":"(N/A)"},{"value":6165,"label":"In-Person Electronic Notarization (IPEN)"},{"value":6166,"label":"Remote Online Notarization (RON)"},{"value":6167,"label":"Mobile Notary Services"},{"value":6168,"label":"Remote Ink Notarization (RIN)"}]}]},{"label":"Apostille","component":"Apostille","parameter":"apostille","sourceTypeId":720,"myRecordsSearch":false,"myWorkQueueSearch":false,"disabled":false,"allowedRoutes":["/forms-manager/","/queue/","/forms/"]},{"label":"Liens","component":"UCC","parameter":"ucc","sourceTypeId":1999,"myRecordsSearch":true,"myWorkQueueSearch":true,"fileAmendmentButtonLabel":"Filing Actions","searchPlaceholder":"Search by name or file number","disabled":false,"serverWebSearchDescription":true,"myRecordsDescription":"","workQueueDescription":"","searchDescription":"","hideRecordUserManagment":true,"searchLiensCheckout":false,"advancedSearchParameters":[{"type":"radio","name":"STARTS_WITH_YN","defaultValue":false,"options":[{"value":true,"label":"Starts with"},{"value":false,"label":"Contains"}]},{"type":"select","name":"STATUS","defaultValue":"ALL","label":"Status","options":[{"value":"ACTIVE_UNLAPSED","label":"Active (unlapsed)"},{"value":"ACTIVE_LAPSED_UNLAPSED","label":"Active (lapsed and unlapsed)"}]},{"type":"text","name":"EXCLUDE_VALUES","label":"Exclude Debtor Names (comma separated list of names to exclude)","defaultValue":""},{"type":"dateRange","name":"FILING_DATE","label":"Financing Statement Date","defaultValue":{"start":null,"end":null}},{"type":"dateRange","name":"LAPSE_DATE","label":"Lapse Date","defaultValue":{"start":null,"end":null}},{"type":"text","name":"CITY","label":"Debtor City","defaultValue":""}],"myRecordsFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Approved"},{"value":2,"label":"Pending Online Payment"},{"value":3,"label":"Pending Review"}]},{"type":"select","name":"TYPE","defaultValue":0,"label":"Lien Type","options":[{"value":0,"label":"All"},{"value":1,"label":"UCC"},{"value":2,"label":"EFS"},{"value":3,"label":"Title 71"}]}],"myWorkQueueFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Approved"},{"value":2,"label":"Pending Online Payment"},{"value":3,"label":"Pending Review"},{"value":4,"label":"Pending Print and Mail"},{"value":5,"label":"Rejected"},{"value":6,"label":"Draft"}]},{"type":"select","name":"TYPE","defaultValue":0,"label":"Lien Type","options":[{"value":0,"label":"All"},{"value":1,"label":"UCC"},{"value":2,"label":"EFS"},{"value":3,"label":"Title 71"}]}]},{"label":"Copy Request","component":"copies","parameter":"copies","sourceTypeId":2001,"myRecordsSearch":false,"myWorkQueueSearch":false,"disabled":false,"allowedRoutes":["/forms-manager/","/queue/","/forms/"]},{"label":"Trademark","component":"Trademark","parameter":"trademark","sourceTypeId":810,"showRequestCertificate":true,"searchMustHaveOneOf":["search","EXPIRATION_DATE","FILING_DATE"],"allowEmptySearchTerm":true,"requestCertificateAlternateLabel":"Request Information","fileAmendmentButtonLabel":"Filing Actions","advancedSearchParameters":[{"type":"radio","name":"QUERY_TYPE_ID","defaultValue":1010,"options":[{"value":1010,"label":"Starts with"},{"value":1011,"label":"Contains"},{"value":1012,"label":" Word Contains"}]},{"type":"checkbox","name":"OWNER_SEARCH_YN","defaultValue":false,"label":"Search owners"},{"type":"radio","name":"SERVICE_MARK_YN","label":"Mark Type","defaultValue":"","options":[{"value":"","label":"All Marks"},{"value":"Y","label":"Service Mark"},{"value":"N","label":"Trademark"}]},{"type":"serverSelect","name":"STATUS_ID","optionsSrc":"TYPE_V|TRADEMARK_STATUS_TYPE","label":"Status","placeholder":"All","defaultValue":"0"},{"type":"select","name":"DESIGN_TYPE_ID","options":[{"value":0,"label":"All"},{"value":990,"label":"Words Only"},{"value":991,"label":"Design Only"},{"value":992,"label":"Words and Design"}],"label":"Design Type","defaultValue":"0"},{"type":"dateRange","name":"FILING_DATE","label":"Registered Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}},{"type":"dateRange","name":"EXPIRATION_DATE","label":"Expiration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}}]},{"label":"Business Info Request","component":"InfoRequests","parameter":"info-request","sourceTypeId":167,"allowedRoutes":["/forms-manager/","/queue/","/forms/"]},{"label":"Data Requests","component":"DataRequests","parameter":"data-request","sourceTypeId":0,"allowedRoutes":["/forms-manager/"]},{"label":"CRA","component":"CRA","parameter":"cra","sourceTypeId":157,"myRecordsSearch":false,"searchPlaceholder":"Search by name or registered agent number","allowedRoutes":["/forms-manager/","/forms/","/records/","/queue/","/search/"],"allowEmptySearchTerm":true,"fileAmendmentButtonLabel":"Filing Actions","advancedSearchParameters":[{"type":"radio","name":"QUERY_TYPE_ID","defaultValue":1010,"options":[{"value":1010,"label":"Starts with"},{"value":1011,"label":"Contains"},{"value":1012,"label":" Word Contains"}]},{"type":"dateRange","name":"CRA_DATE","label":"Registration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}},{"type":"select","name":"STATUS_ID","label":"Status","defaultValue":0,"options":[{"value":0,"label":"All"},{"value":121,"label":"Active"},{"value":122,"label":"Inactive"}]},{"type":"select","name":"AGENT_TYPE_ID","label":"Agent Type","defaultValue":0,"options":[{"value":0,"label":"All"},{"value":460,"label":"Registered Agent"},{"value":461,"label":"Commercial Registered Agent"}]}]},{"label":"Farm Bill","component":"FarmBill","parameter":"farm-bill","path":"/lists/farm-bill","sourceTypeId":0,"myRecordsSearch":false,"allowedRules":["/search/"],"disabled":true,"searchDescription":"To perform a search, enter a debtor name. Your search results may include: exact debtor name, variations of that name and any filing that includes your search criteria. Punctuation is ignored.\n\nYou can click on \"Advanced\" to refine your search. Under “Advanced” you can search by crop, year, county and SSN/FEIN. As a registered Farm Bill Buyer with the Montana Secretary of State’s office it is important to maintain the confidentiality of the information contained within the Farm Bill Master List. The Farm Bill Master List reflects personal data, such as Social Security Numbers, which are a key piece of personal identifiable information to assist you in determining the existence of a lien against a specific debtor. The distribution of this information beyond its intended purpose is strictly prohibited.\n\nThe debtor's tax identification number has been hidden for confidentiality reasons. You may continue to search on a tax ID number and return debtors that match your search criteria. The SSN/FEIN must be entered without dashes or spaces.","searchMustHaveOneOf":["search","UCC_FARM_PRODUCT_ID","COUNTY"],"searchPlaceholder":"Search by debtor name","advancedSearchParameters":[{"type":"ServerMultiComplete","label":"Product code name(s)","name":"UCC_FARM_PRODUCT_ID","defaultValue":"","optionsSrc":"UCC_FARM_PRODUCT_V"},{"type":"MultiComplete","label":"Year or Range of Years","name":"YEAR_NUM","optionsSrc":"years","startYear":"1968","defaultValue":[],"preMergeOptions":[{"value":"ALL","label":"All"}]},{"type":"serverSelect","label":"State","name":"STATE","defaultValue":"MONTANA","optionsSrc":"STATE"},{"type":"ServerMultiComplete","label":"County","name":"COUNTY","defaultValue":[],"optionsSrc":"COUNTY","overrideSubOptionsSrcFromParameterName":"STATE"},{"type":"checkbox","name":"TIN_SEARCH_YN","defaultValue":false,"label":"Tax Identification Number Search"},{"type":"checkbox","name":"TIN_SORT_YN","defaultValue":false,"label":"Unique ID Sort"}]}],"SYSTEM_NICKNAME":"Online Services Portal","PAYMENT_METHODS":[{"type":"bypass"},{"type":"iTransact"}],"PAYMENT_ALLOW_AMEX":true,"SYSTEM_ID_LABEL":"System Id","DOUBLE_COLUMN_PUBLIC_LOGIN":true,"INTERNAL_USER_MANAGEMENT":true,"ALLOW_PUBLIC_JSON_IMPORT":false,"MAX_FILE_UPLOAD_SIZE":10000000,"REFUND_TEXT":"","RETURN_TO_HOME_ON_LOGOUT":true,"CURRENT_SOS_NAME":"Christi Jacobsen","LOGO_FILENAME":"mt-sos-logo.png","LOGO_ALT":"Christi Jacobsen, Montana Secretary of State","LOGO_FULL_WIDTH":true,"HOME_HIDE_AUTH_HINT":true,"HOME_TITLE":"Montana Secretary of State","CUSTOM_TAB_TITLE":"Official Montana","HOME_SUBTITLE":"Online Business Services","ENTITY_NAME_CONSENT_DESCRIPTION":"","ALLOW_USER_PROFILE_EDITING":true,"COMPARE_FOREIGN_NAME_IN_ENTITY_NAME_VALIDATION":true,"FOREIGN_NAME_FIELD_NAME":"KIMA_PARENT_NAME_INFO","LOGIN_TITLE":"Montana Secretary of State Online Filing Portal Login","PUBLIC_LOGIN_LABEL":"Username","REVERSE_LOGIN_COLUMNS":true,"LOGIN_SEAL_FILENAME":"seal_white.png","SEPARATE_USERNAME_AND_EMAIL":true,"CREATE_ACCOUNT_BUTTON_ALIGN_LEFT":true,"CREATE_ACCOUNT_BUTTON_TEXT":"CREATE AN ACCOUNT","PASSWORD_CUSTOM_ERROR_TEXT":"The password must meet all requirements","ACCOUNT_CREATED_MESSAGE":"Please check your email to verify your account to login and allow a few minutes for this message to arrive. Check your junk/spam folders if you do not find the email in your inbox.","PUBLIC_LOGIN_PLACEHOLDER":" ","DISABLE_DEFAULT_PAYMENT_RADIO":true,"CUSTOM_RESET_PASSWORD_ERROR_MESSAGE":"Username invalid - no account found","PUBLIC_LOGIN_CREATE_DESCRIPTION":"### Existing User:\n\n  - Enter your username and password to login.  \n\n\n  #### - OR -  \n\n\n\n  - Forgot password? Click 'Reset Password' and follow the prompts.\n  - Forgot username? Click 'Forgot Username' and follow the prompts.  \n\n\n  ### New User:\n  ","LOGIN_HELP_LINK":"https://sosmt.gov/business/how-do-i/","LOGIN_HELP_LINK_TEXT":"Need Help?","FORGOT_USERNAME_TEXT":"Forgot Username?","LOGIN_ACTIVE_DIRECTORY_TEXT":"State User Login","MULTIPLE_LOGIN_METHODS":true,"HAS_ACTIVE_DIRECTORY_LOGIN":true,"RESET_PASSWORD_WITH_USERNAME":true,"DOWNLOAD_LINK":true,"SHOW_USERNAME_ACCOUNT_CREATE":true,"SHOW_SCROLL_DOWN_ARROW":true,"SHOW_ADDRESS_ACCOUNT_CREATE":true,"TWO_COLUMN_ACCOUNT_CREATE":true,"RESET_PASSWORD_TIP":"A link to change your password has been sent to your email. Please allow a few minutes for this message to arrive. Please check your junk/spam folders if you do not find the email in your inbox.","FORGOT_PASSWORD_LINK_TEXT":"Reset Password","PHONE_NUMBER_OPTIONAL_ACCOUNT_CREATE":true,"SHOW_REQUIRED_INDICATOR_ACCOUNT_CREATE":true,"PASSWORD_REQUIREMENTS_ACCOUNT_CREATE":"\n    <ul>\n      <li>MUST contain at least 8 characters (12+ recommended)</li>\n      <li>MUST contain at least one uppercase letter.</li>\n      <li>MUST contain at least one lowercase letter.</li>\n      <li>MUST contain at least one number.</li>\n      <li>MUST contain at least one special character (!”#$%&'()*+,-./:;<=>?</li>\n    </ul>\n  ","ALLOW_CERTIFICATION_REQUEST":true,"ALLOW_PUBLIC_CERTIFICATE_REQUEST":true,"ALLOW_COPY_REQUEST":false,"ALLOW_CORRECTION_STYLING":true,"HIDE_DEPRECATION_WARNING":false,"AMEND_ROUTE_PUBLIC":true,"SEAL_FILENAME":"seal.png","SHOPPING_CART":true,"ALLOW_PAYMENT_UPDATE_WITH_EMPTY_CART":true,"RA_EMAIL":true,"RA_WEBSITE":true,"RA_NO_DEFAULT_TYPE":true,"RA_ADDRESS_LABEL":"Street Address","RA_TYPE_SELECTION_DEFAULT":true,"RA_DEFAULT_TYPE":"460","RA_OVERRIDE_TYPE_WITH_DEFAULT":true,"RA_PRINCIPAL_ADDRESS_AMS":true,"UPLOAD_AND_SUBMIT_HIDE_IF_ONE_OPTION":true,"PAYMENT_PROCESSING_MESSAGE":"Your payment is processing - Do not close your browser or click the back button","CHECKOUT_BUTTON_WHEN_PROCESSING_TEXT":"Processing","EFS_CROP_PICKER_NONE_LABEL":"Lien Duration","DISALLOWED_WIZARD_PIECES":["FormationLocale"],"REPEATER_SHOW_EDIT_BUTTON":true,"DATA_REQUEST_PAGE_TITLE":"Data Requests and Subscriptions","DATA_REQUEST_SIDEBAR_LABEL":"Data Requests & Subscriptions","LOGIN_REDIRECTS_TO_EPASS":false,"LOGIN_REDIRECTS_TO_ACTIVE_DIRECTORY":true,"LOGIN_ACTIVE_DIRECTORY_LINK":true,"FETCH_EDIT_USER_LINK":false,"LISTS_FETCH_AVAILABLE_LISTS":true,"POST_WIZARD_SUBMIT_REDIRECT_URL":"/","PIN_REQUEST_ATTESTATIONS":true,"PIN_REQUEST_DESCRIPTION":"Click **Request PIN** to have a new PIN sent to the account holder's email address on file.","OWNERSHIP_REQUEST_DESCRIPTION":"To become an **authorized user** of this record, a current **AUTHORIZED USER** will need to grant you access. To request access, click **Request Access** below.","PIN_REQUEST_SUCCESS_MESSAGE":"The PIN you have requested for this entity has been sent to the email associated with your user account.  You should receive the PIN in approximately 3-5 minutes, depending on your email service provider.","APOSTILLE_HEADER_LABEL":"Verification Information","APOSTILLE_NUMBER_LABEL":"Apostille/Authentication","APOSTILLE_CITY_STATE_OVERRIDE":"HELENA, MT","APOSTILLE_FILING_DATE_LABEL":"Issue Date","APOSTILLE_CITY_STATE_IN_CERTIFIED":true,"NOTARY_EXISTING_FILING":true,"ALLOW_REVOKE_OWN_ACCESS_ONLY":false,"HIDE_CANCEL_ON_ONETIME_DATA_REQUESTS":true,"DATA_REQUESTS_IN_SHOPPING_CART":true,"WQ_ALLOW_EDIT_PENDING_PAYMENT":true,"WQ_CONFIRM_ON_DELETE":true,"WQ_DELETE_CONFIRM_MESSAGE":"Deleting this filing will forfeit any money already paid to the Secretary of State. This action is permanent and cannot be undone, are you sure you would like to delete?","PASS_ITEM_GUIDS_ON_CHECKOUT":true,"FORM_REVISION_HISTORY":true,"CHECKOUT_DISCLAIMER":"By entering your credit card and/or checking account information you (i) state that **you are an authorized user** of the credit card and/or electronic check and that the associated information entered (e.g., account holder name, account number, billing address) is accurate, (ii) **you authorize payment processor to charge the amount you have requested** to your credit card and/or funding account, and (iii) **acknowledge if a charge is declined or reversed you may also be assessed a customary charge** by the payment processor for such transactions.","FARM_BILL_SEARCH_CONFIDENTIAL":"As a registered Farm Bill Buyer with the Montana Secretary of State’s office it is important to maintain the confidentiality of the information contained within the Farm Bill Master List. The Farm Bill Master List reflects personal data, such as Social Security Numbers, which are a key piece of personal identifiable information to assist you in determining the existence of a lien against a specific debtor. The distribution of this information beyond its intended purpose is strictly prohibited.\n\n**The debtor's tax identification number has been hidden for confidentiality reasons. You may continue to search on a tax ID number and return debtors that match your search criteria. The SSN/FEIN must be entered without dashes or spaces.  If you need access to the tax identification number to clearly identify the debtor, please contact the UCC unit at (406) 444-3665.**","VIEW_HISTORY_BUTTON_ALT_TEXT":"View Filings","WIZARD_ERROR_TITLE_MESSAGE":"Form Error","FARM_BILL_SEARCH_INTERACTIVE":true,"USE_FARM_BILL_API":true,"DISALLOW_ASSIGN_SELF_AS_RA":true,"DISALLOW_ASSIGN_SELF_AS_PRINCIPAL":true,"USE_TRADEMARK_OWNER_VALIDATION":true,"USE_ALTERNATIVE_FOREIGN_ADDRESS_LABELS":true,"MY_RECEIPTS_FILTER":[{"type":"dateRange","name":"DATE_RANGE","label":"Date range","defaultValue":{"start":null,"end":null}},{"type":"text","name":"REF_NUM","defaultValue":"","label":"Reference Number"},{"type":"text","name":"RECEIPT_NUM","defaultValue":"","label":"Receipt Id"},{"type":"text","name":"AMOUNT","defaultValue":"","label":"Amount"},{"type":"select","name":"TYPE","defaultValue":"","label":"Payment Type","options":[{"value":"","label":"All"},{"value":"CC","label":"Credit Card"},{"value":"Check","label":"Check"}]}],"MY_RECEIPTS_SHOW_IN_SIDEBAR":true,"SHOW_MY_RECEIPTS_HELPER_TEXT":true,"MY_RECEIPTS_HELPER_LABEL":"About Receipt Search","MY_RECEIPTS_HELPER_TEXT":"You can search for receipts based on their descriptions, including the items paid for on the receipt. Use the filters to search for or filter specific information.","FARM_BILL_SUBLINK":{"label":"Farm Bill","component":"FarmBill","parameter":"farm-bill","path":"/lists/farm-bill","sourceTypeId":0,"myRecordsSearch":false,"allowedRules":["/search/"],"disabled":true,"searchDescription":"To perform a search, enter a debtor name. Your search results may include: exact debtor name, variations of that name and any filing that includes your search criteria. Punctuation is ignored.\n\nYou can click on \"Advanced\" to refine your search. Under “Advanced” you can search by crop, year, county and SSN/FEIN. As a registered Farm Bill Buyer with the Montana Secretary of State’s office it is important to maintain the confidentiality of the information contained within the Farm Bill Master List. The Farm Bill Master List reflects personal data, such as Social Security Numbers, which are a key piece of personal identifiable information to assist you in determining the existence of a lien against a specific debtor. The distribution of this information beyond its intended purpose is strictly prohibited.\n\nThe debtor's tax identification number has been hidden for confidentiality reasons. You may continue to search on a tax ID number and return debtors that match your search criteria. The SSN/FEIN must be entered without dashes or spaces.","searchMustHaveOneOf":["search","UCC_FARM_PRODUCT_ID","COUNTY"],"searchPlaceholder":"Search by debtor name","advancedSearchParameters":[{"type":"ServerMultiComplete","label":"Product code name(s)","name":"UCC_FARM_PRODUCT_ID","defaultValue":"","optionsSrc":"UCC_FARM_PRODUCT_V"},{"type":"MultiComplete","label":"Year or Range of Years","name":"YEAR_NUM","optionsSrc":"years","startYear":"1968","defaultValue":[],"preMergeOptions":[{"value":"ALL","label":"All"}]},{"type":"serverSelect","label":"State","name":"STATE","defaultValue":"MONTANA","optionsSrc":"STATE"},{"type":"ServerMultiComplete","label":"County","name":"COUNTY","defaultValue":[],"optionsSrc":"COUNTY","overrideSubOptionsSrcFromParameterName":"STATE"},{"type":"checkbox","name":"TIN_SEARCH_YN","defaultValue":false,"label":"Tax Identification Number Search"},{"type":"checkbox","name":"TIN_SORT_YN","defaultValue":false,"label":"Unique ID Sort"}]},"ALLOW_ADDRESS_VALIDATION_BYPASS_OPTION":true,"DEFAULT_ADDRESS_VALIDATION_BYPASS_OPTION_CHECKED":true}).SHOW_ORG_NAME_ACCOUNT_CREATE ? _react2.default.createElement(
	          _Field.DumbField,
	          { label: 'Organization Name', fieldId: 'orgName' },
	          _react2.default.createElement(_Form.TextInput, {
	            width: '100%',
	            fieldId: 'orgName',
	            onChange: function onChange(value) {
	              return _this4.setValue(value, 'ORG_NAME');
	            },
	            value: this.state.ORG_NAME,
	            disabled: fieldDisabled
	          })
	        ) : null,
	        _react2.default.createElement(
	          'div',
	          { className: 'flex-row flex-3-column' },
	          _react2.default.createElement(
	            _Field.DumbField,
	            { label: 'First name' + ( true ? '*' : ''), fieldId: 'firstname' },
	            _react2.default.createElement(_Form.TextInput, {
	              width: '100%',
	              fieldId: 'firstname',
	              onChange: function onChange(value) {
	                return _this4.setValue(value, 'FIRST_NAME');
	              },
	              value: this.state.FIRST_NAME,
	              disabled: fieldDisabled
	            })
	          ),
	          _react2.default.createElement(
	            _Field.DumbField,
	            { label: 'Middle name', fieldId: 'middleName' },
	            _react2.default.createElement(_Form.TextInput, {
	              width: '100%',
	              fieldId: 'middleName',
	              onChange: function onChange(value) {
	                return _this4.setValue(value, 'MIDDLE_NAME');
	              },
	              value: this.state.MIDDLE_NAME,
	              disabled: fieldDisabled
	            })
	          ),
	          _react2.default.createElement(
	            _Field.DumbField,
	            { label: 'Last name' + ( true ? '*' : ''), fieldId: 'lastname' },
	            _react2.default.createElement(_Form.TextInput, {
	              width: '100%',
	              fieldId: 'lastname',
	              onChange: function onChange(value) {
	                return _this4.setValue(value, 'LAST_NAME');
	              },
	              value: this.state.LAST_NAME,
	              disabled: fieldDisabled
	            })
	          )
	        ),
	         true ? _react2.default.createElement(_AddressBlock2.default, {
	          value: this.state.ADDRESS,
	          onChange: function onChange(value) {
	            _this4.setValue(value, 'ADDRESS');
	          },
	          width: '100%',
	          showCityStateZip: true,
	          allowSelection: false,
	          singleColSize: 'col-12',
	          showCountry: true,
	          hideAttention: true,
	          triColSizes: {
	            CITY: 'col-4',
	            STATE: 'col-4',
	            POSTAL_CODE: 'col-4',
	            ZIP: 'col-4'
	          }
	        }) : null,
	        ({"NODE_ENV":"production","BUILD_DATE":"2025-08-27T15:15:31.687Z","BUILD_NUMBER":"Not Provided","GIT_VERSION":"v1.3.0-381-ga81e29b08","GIT_COMMIT_HASH":"a81e29b085c9268ffd96c78eb734365802722741","GIT_BRANCH":"beta","PUBLIC_URL":"","STATE_ABBR":"MT","STATE_NAME":"Montana","STATE_ORG_TITLE":"Secretary of State","LOGIN_HEADER_IMG_PATH":"","HOME_IMG_FILENAME":"montana.jpg","FAVICON_FILE_NAME":"favicon.ico","ALLOW_E_SIGN_ON_CORRECTIONS":true,"THIRD_PARTY_SIGNING_ALLOWED":false,"MY_ACCOUNT_SAVE_AND_CLOSE_BUTTON":true,"IE_DEPRECATED_MESSAGE":"Internet Explorer is not supported. Please select a supported browser below to access this website.","ADDITIONAL_ROUTES":{"dataRequests":true,"farmBill":true,"apostille":true,"externalHelp":"https://sosmt.gov/business/help-center/","systemAdministration":[{"title":"Saved Payments","parameter":"saved-payments","componentName":"SavedPayments"}]},"SUBROUTES":[{"label":"Business","component":"Business","parameter":"business","myWorkQueueSearch":false,"sourceTypeId":54,"searchMustHaveOneOf":["FILING_TYPE_ID","STATUS_ID","STATE","search"],"serverWebSearchDescription":true,"serverWorkQueueDescription":true,"serverMyRecordsDescription":true,"searchPlaceholder":"Search by name or filing number (X########)","allowEmptySearchTerm":true,"requestCertificateAlternateLabel":"Request Information","fileAmendmentButtonLabel":"Filing Actions","advancedSearchParameters":[{"type":"radio","name":"QUERY_TYPE_ID","defaultValue":1010,"options":[{"value":1010,"label":"Starts with"},{"value":1011,"label":"Contains"},{"value":1012,"label":" Word Contains"}]},{"type":"serverSelect","name":"FILING_TYPE_ID","optionsSrc":"FILING_TYPES","label":"Entity Type","placeholder":"All","defaultValue":"0"},{"type":"serverSelect","name":"FILING_SUBTYPE_ID","optionsSrc":"FILING_SUBTYPES","label":"Entity Subtype","overrideSubOptionsSrcFromParameterName":"FILING_TYPE_ID","placeholder":"All","defaultValue":"0"},{"type":"serverSelect","name":"STATUS_ID","optionsSrc":"FILING_STATUS_WITHOUT_ALL","label":"Status","placeholder":"All","defaultValue":"0"},{"type":"serverSelect","name":"STATE","optionsSrc":"STATE","label":"State","placeholder":"All","defaultValue":""},{"type":"serverSelect","name":"COUNTY","optionsSrc":"COUNTY_SUBOPTION","label":"County","overrideSubOptionsSrcFromParameterName":"STATE","placeholder":"All","defaultValue":""},{"type":"checkbox","name":"CRA_SEARCH_YN","defaultValue":false,"label":"Search by Registered Agent PID"},{"type":"dateRange","name":"FILING_DATE","label":"Registration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}},{"type":"dateRange","name":"EXPIRATION_DATE","label":"Expiration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}}],"myRecordsFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Active"},{"value":2,"label":"Inactive"},{"value":3,"label":"Pending"}]},{"type":"dateRange","name":"DATE_RANGE","label":"Date range","defaultValue":{"start":null,"end":null}}],"myWorkQueueFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Approved"},{"value":2,"label":"Pending Online Payment"},{"value":3,"label":"Pending Review"},{"value":4,"label":"Needs Correction"},{"value":5,"label":"Rejected"},{"value":6,"label":"Draft"}]},{"type":"dateRange","name":"DATE_RANGE","label":"Date range","defaultValue":{"start":null,"end":null}}]},{"label":"Notary","component":"Notary","parameter":"notary","sourceTypeId":850,"myWorkQueueSearch":false,"allowEmptySearchTerm":true,"requestCertificateAlternateLabel":"Download Certificate","fileAmendmentButtonLabel":"Filing Actions","hideNameRequestCertificate":true,"hideAddressRequestCertificate":true,"hideRecordUserManagment":true,"searchPlaceholder":"Search by name or commission number","searchMustHaveOneOf":["CITY","search","SERVICE_TYPE"],"advancedParametersStartOpen":true,"searchIsSortable":true,"advancedSearchParameters":[{"type":"radio","name":"STARTS_WITH_YN","defaultValue":false,"options":[{"value":true,"label":"Starts with"},{"value":false,"label":"Contains"}]},{"type":"checkbox","name":"ACTIVE_ONLY_YN","defaultValue":true,"label":"Active entities only"},{"type":"text","name":"CITY","defaultValue":"","label":"City"},{"type":"select","name":"SERVICE_TYPE","label":"Special Services Offered","defaultValue":0,"options":[{"value":0,"label":"(N/A)"},{"value":6165,"label":"In-Person Electronic Notarization (IPEN)"},{"value":6166,"label":"Remote Online Notarization (RON)"},{"value":6167,"label":"Mobile Notary Services"},{"value":6168,"label":"Remote Ink Notarization (RIN)"}]}]},{"label":"Apostille","component":"Apostille","parameter":"apostille","sourceTypeId":720,"myRecordsSearch":false,"myWorkQueueSearch":false,"disabled":false,"allowedRoutes":["/forms-manager/","/queue/","/forms/"]},{"label":"Liens","component":"UCC","parameter":"ucc","sourceTypeId":1999,"myRecordsSearch":true,"myWorkQueueSearch":true,"fileAmendmentButtonLabel":"Filing Actions","searchPlaceholder":"Search by name or file number","disabled":false,"serverWebSearchDescription":true,"myRecordsDescription":"","workQueueDescription":"","searchDescription":"","hideRecordUserManagment":true,"searchLiensCheckout":false,"advancedSearchParameters":[{"type":"radio","name":"STARTS_WITH_YN","defaultValue":false,"options":[{"value":true,"label":"Starts with"},{"value":false,"label":"Contains"}]},{"type":"select","name":"STATUS","defaultValue":"ALL","label":"Status","options":[{"value":"ACTIVE_UNLAPSED","label":"Active (unlapsed)"},{"value":"ACTIVE_LAPSED_UNLAPSED","label":"Active (lapsed and unlapsed)"}]},{"type":"text","name":"EXCLUDE_VALUES","label":"Exclude Debtor Names (comma separated list of names to exclude)","defaultValue":""},{"type":"dateRange","name":"FILING_DATE","label":"Financing Statement Date","defaultValue":{"start":null,"end":null}},{"type":"dateRange","name":"LAPSE_DATE","label":"Lapse Date","defaultValue":{"start":null,"end":null}},{"type":"text","name":"CITY","label":"Debtor City","defaultValue":""}],"myRecordsFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Approved"},{"value":2,"label":"Pending Online Payment"},{"value":3,"label":"Pending Review"}]},{"type":"select","name":"TYPE","defaultValue":0,"label":"Lien Type","options":[{"value":0,"label":"All"},{"value":1,"label":"UCC"},{"value":2,"label":"EFS"},{"value":3,"label":"Title 71"}]}],"myWorkQueueFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Approved"},{"value":2,"label":"Pending Online Payment"},{"value":3,"label":"Pending Review"},{"value":4,"label":"Pending Print and Mail"},{"value":5,"label":"Rejected"},{"value":6,"label":"Draft"}]},{"type":"select","name":"TYPE","defaultValue":0,"label":"Lien Type","options":[{"value":0,"label":"All"},{"value":1,"label":"UCC"},{"value":2,"label":"EFS"},{"value":3,"label":"Title 71"}]}]},{"label":"Copy Request","component":"copies","parameter":"copies","sourceTypeId":2001,"myRecordsSearch":false,"myWorkQueueSearch":false,"disabled":false,"allowedRoutes":["/forms-manager/","/queue/","/forms/"]},{"label":"Trademark","component":"Trademark","parameter":"trademark","sourceTypeId":810,"showRequestCertificate":true,"searchMustHaveOneOf":["search","EXPIRATION_DATE","FILING_DATE"],"allowEmptySearchTerm":true,"requestCertificateAlternateLabel":"Request Information","fileAmendmentButtonLabel":"Filing Actions","advancedSearchParameters":[{"type":"radio","name":"QUERY_TYPE_ID","defaultValue":1010,"options":[{"value":1010,"label":"Starts with"},{"value":1011,"label":"Contains"},{"value":1012,"label":" Word Contains"}]},{"type":"checkbox","name":"OWNER_SEARCH_YN","defaultValue":false,"label":"Search owners"},{"type":"radio","name":"SERVICE_MARK_YN","label":"Mark Type","defaultValue":"","options":[{"value":"","label":"All Marks"},{"value":"Y","label":"Service Mark"},{"value":"N","label":"Trademark"}]},{"type":"serverSelect","name":"STATUS_ID","optionsSrc":"TYPE_V|TRADEMARK_STATUS_TYPE","label":"Status","placeholder":"All","defaultValue":"0"},{"type":"select","name":"DESIGN_TYPE_ID","options":[{"value":0,"label":"All"},{"value":990,"label":"Words Only"},{"value":991,"label":"Design Only"},{"value":992,"label":"Words and Design"}],"label":"Design Type","defaultValue":"0"},{"type":"dateRange","name":"FILING_DATE","label":"Registered Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}},{"type":"dateRange","name":"EXPIRATION_DATE","label":"Expiration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}}]},{"label":"Business Info Request","component":"InfoRequests","parameter":"info-request","sourceTypeId":167,"allowedRoutes":["/forms-manager/","/queue/","/forms/"]},{"label":"Data Requests","component":"DataRequests","parameter":"data-request","sourceTypeId":0,"allowedRoutes":["/forms-manager/"]},{"label":"CRA","component":"CRA","parameter":"cra","sourceTypeId":157,"myRecordsSearch":false,"searchPlaceholder":"Search by name or registered agent number","allowedRoutes":["/forms-manager/","/forms/","/records/","/queue/","/search/"],"allowEmptySearchTerm":true,"fileAmendmentButtonLabel":"Filing Actions","advancedSearchParameters":[{"type":"radio","name":"QUERY_TYPE_ID","defaultValue":1010,"options":[{"value":1010,"label":"Starts with"},{"value":1011,"label":"Contains"},{"value":1012,"label":" Word Contains"}]},{"type":"dateRange","name":"CRA_DATE","label":"Registration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}},{"type":"select","name":"STATUS_ID","label":"Status","defaultValue":0,"options":[{"value":0,"label":"All"},{"value":121,"label":"Active"},{"value":122,"label":"Inactive"}]},{"type":"select","name":"AGENT_TYPE_ID","label":"Agent Type","defaultValue":0,"options":[{"value":0,"label":"All"},{"value":460,"label":"Registered Agent"},{"value":461,"label":"Commercial Registered Agent"}]}]},{"label":"Farm Bill","component":"FarmBill","parameter":"farm-bill","path":"/lists/farm-bill","sourceTypeId":0,"myRecordsSearch":false,"allowedRules":["/search/"],"disabled":true,"searchDescription":"To perform a search, enter a debtor name. Your search results may include: exact debtor name, variations of that name and any filing that includes your search criteria. Punctuation is ignored.\n\nYou can click on \"Advanced\" to refine your search. Under “Advanced” you can search by crop, year, county and SSN/FEIN. As a registered Farm Bill Buyer with the Montana Secretary of State’s office it is important to maintain the confidentiality of the information contained within the Farm Bill Master List. The Farm Bill Master List reflects personal data, such as Social Security Numbers, which are a key piece of personal identifiable information to assist you in determining the existence of a lien against a specific debtor. The distribution of this information beyond its intended purpose is strictly prohibited.\n\nThe debtor's tax identification number has been hidden for confidentiality reasons. You may continue to search on a tax ID number and return debtors that match your search criteria. The SSN/FEIN must be entered without dashes or spaces.","searchMustHaveOneOf":["search","UCC_FARM_PRODUCT_ID","COUNTY"],"searchPlaceholder":"Search by debtor name","advancedSearchParameters":[{"type":"ServerMultiComplete","label":"Product code name(s)","name":"UCC_FARM_PRODUCT_ID","defaultValue":"","optionsSrc":"UCC_FARM_PRODUCT_V"},{"type":"MultiComplete","label":"Year or Range of Years","name":"YEAR_NUM","optionsSrc":"years","startYear":"1968","defaultValue":[],"preMergeOptions":[{"value":"ALL","label":"All"}]},{"type":"serverSelect","label":"State","name":"STATE","defaultValue":"MONTANA","optionsSrc":"STATE"},{"type":"ServerMultiComplete","label":"County","name":"COUNTY","defaultValue":[],"optionsSrc":"COUNTY","overrideSubOptionsSrcFromParameterName":"STATE"},{"type":"checkbox","name":"TIN_SEARCH_YN","defaultValue":false,"label":"Tax Identification Number Search"},{"type":"checkbox","name":"TIN_SORT_YN","defaultValue":false,"label":"Unique ID Sort"}]}],"SYSTEM_NICKNAME":"Online Services Portal","PAYMENT_METHODS":[{"type":"bypass"},{"type":"iTransact"}],"PAYMENT_ALLOW_AMEX":true,"SYSTEM_ID_LABEL":"System Id","DOUBLE_COLUMN_PUBLIC_LOGIN":true,"INTERNAL_USER_MANAGEMENT":true,"ALLOW_PUBLIC_JSON_IMPORT":false,"MAX_FILE_UPLOAD_SIZE":10000000,"REFUND_TEXT":"","RETURN_TO_HOME_ON_LOGOUT":true,"CURRENT_SOS_NAME":"Christi Jacobsen","LOGO_FILENAME":"mt-sos-logo.png","LOGO_ALT":"Christi Jacobsen, Montana Secretary of State","LOGO_FULL_WIDTH":true,"HOME_HIDE_AUTH_HINT":true,"HOME_TITLE":"Montana Secretary of State","CUSTOM_TAB_TITLE":"Official Montana","HOME_SUBTITLE":"Online Business Services","ENTITY_NAME_CONSENT_DESCRIPTION":"","ALLOW_USER_PROFILE_EDITING":true,"COMPARE_FOREIGN_NAME_IN_ENTITY_NAME_VALIDATION":true,"FOREIGN_NAME_FIELD_NAME":"KIMA_PARENT_NAME_INFO","LOGIN_TITLE":"Montana Secretary of State Online Filing Portal Login","PUBLIC_LOGIN_LABEL":"Username","REVERSE_LOGIN_COLUMNS":true,"LOGIN_SEAL_FILENAME":"seal_white.png","SEPARATE_USERNAME_AND_EMAIL":true,"CREATE_ACCOUNT_BUTTON_ALIGN_LEFT":true,"CREATE_ACCOUNT_BUTTON_TEXT":"CREATE AN ACCOUNT","PASSWORD_CUSTOM_ERROR_TEXT":"The password must meet all requirements","ACCOUNT_CREATED_MESSAGE":"Please check your email to verify your account to login and allow a few minutes for this message to arrive. Check your junk/spam folders if you do not find the email in your inbox.","PUBLIC_LOGIN_PLACEHOLDER":" ","DISABLE_DEFAULT_PAYMENT_RADIO":true,"CUSTOM_RESET_PASSWORD_ERROR_MESSAGE":"Username invalid - no account found","PUBLIC_LOGIN_CREATE_DESCRIPTION":"### Existing User:\n\n  - Enter your username and password to login.  \n\n\n  #### - OR -  \n\n\n\n  - Forgot password? Click 'Reset Password' and follow the prompts.\n  - Forgot username? Click 'Forgot Username' and follow the prompts.  \n\n\n  ### New User:\n  ","LOGIN_HELP_LINK":"https://sosmt.gov/business/how-do-i/","LOGIN_HELP_LINK_TEXT":"Need Help?","FORGOT_USERNAME_TEXT":"Forgot Username?","LOGIN_ACTIVE_DIRECTORY_TEXT":"State User Login","MULTIPLE_LOGIN_METHODS":true,"HAS_ACTIVE_DIRECTORY_LOGIN":true,"RESET_PASSWORD_WITH_USERNAME":true,"DOWNLOAD_LINK":true,"SHOW_USERNAME_ACCOUNT_CREATE":true,"SHOW_SCROLL_DOWN_ARROW":true,"SHOW_ADDRESS_ACCOUNT_CREATE":true,"TWO_COLUMN_ACCOUNT_CREATE":true,"RESET_PASSWORD_TIP":"A link to change your password has been sent to your email. Please allow a few minutes for this message to arrive. Please check your junk/spam folders if you do not find the email in your inbox.","FORGOT_PASSWORD_LINK_TEXT":"Reset Password","PHONE_NUMBER_OPTIONAL_ACCOUNT_CREATE":true,"SHOW_REQUIRED_INDICATOR_ACCOUNT_CREATE":true,"PASSWORD_REQUIREMENTS_ACCOUNT_CREATE":"\n    <ul>\n      <li>MUST contain at least 8 characters (12+ recommended)</li>\n      <li>MUST contain at least one uppercase letter.</li>\n      <li>MUST contain at least one lowercase letter.</li>\n      <li>MUST contain at least one number.</li>\n      <li>MUST contain at least one special character (!”#$%&'()*+,-./:;<=>?</li>\n    </ul>\n  ","ALLOW_CERTIFICATION_REQUEST":true,"ALLOW_PUBLIC_CERTIFICATE_REQUEST":true,"ALLOW_COPY_REQUEST":false,"ALLOW_CORRECTION_STYLING":true,"HIDE_DEPRECATION_WARNING":false,"AMEND_ROUTE_PUBLIC":true,"SEAL_FILENAME":"seal.png","SHOPPING_CART":true,"ALLOW_PAYMENT_UPDATE_WITH_EMPTY_CART":true,"RA_EMAIL":true,"RA_WEBSITE":true,"RA_NO_DEFAULT_TYPE":true,"RA_ADDRESS_LABEL":"Street Address","RA_TYPE_SELECTION_DEFAULT":true,"RA_DEFAULT_TYPE":"460","RA_OVERRIDE_TYPE_WITH_DEFAULT":true,"RA_PRINCIPAL_ADDRESS_AMS":true,"UPLOAD_AND_SUBMIT_HIDE_IF_ONE_OPTION":true,"PAYMENT_PROCESSING_MESSAGE":"Your payment is processing - Do not close your browser or click the back button","CHECKOUT_BUTTON_WHEN_PROCESSING_TEXT":"Processing","EFS_CROP_PICKER_NONE_LABEL":"Lien Duration","DISALLOWED_WIZARD_PIECES":["FormationLocale"],"REPEATER_SHOW_EDIT_BUTTON":true,"DATA_REQUEST_PAGE_TITLE":"Data Requests and Subscriptions","DATA_REQUEST_SIDEBAR_LABEL":"Data Requests & Subscriptions","LOGIN_REDIRECTS_TO_EPASS":false,"LOGIN_REDIRECTS_TO_ACTIVE_DIRECTORY":true,"LOGIN_ACTIVE_DIRECTORY_LINK":true,"FETCH_EDIT_USER_LINK":false,"LISTS_FETCH_AVAILABLE_LISTS":true,"POST_WIZARD_SUBMIT_REDIRECT_URL":"/","PIN_REQUEST_ATTESTATIONS":true,"PIN_REQUEST_DESCRIPTION":"Click **Request PIN** to have a new PIN sent to the account holder's email address on file.","OWNERSHIP_REQUEST_DESCRIPTION":"To become an **authorized user** of this record, a current **AUTHORIZED USER** will need to grant you access. To request access, click **Request Access** below.","PIN_REQUEST_SUCCESS_MESSAGE":"The PIN you have requested for this entity has been sent to the email associated with your user account.  You should receive the PIN in approximately 3-5 minutes, depending on your email service provider.","APOSTILLE_HEADER_LABEL":"Verification Information","APOSTILLE_NUMBER_LABEL":"Apostille/Authentication","APOSTILLE_CITY_STATE_OVERRIDE":"HELENA, MT","APOSTILLE_FILING_DATE_LABEL":"Issue Date","APOSTILLE_CITY_STATE_IN_CERTIFIED":true,"NOTARY_EXISTING_FILING":true,"ALLOW_REVOKE_OWN_ACCESS_ONLY":false,"HIDE_CANCEL_ON_ONETIME_DATA_REQUESTS":true,"DATA_REQUESTS_IN_SHOPPING_CART":true,"WQ_ALLOW_EDIT_PENDING_PAYMENT":true,"WQ_CONFIRM_ON_DELETE":true,"WQ_DELETE_CONFIRM_MESSAGE":"Deleting this filing will forfeit any money already paid to the Secretary of State. This action is permanent and cannot be undone, are you sure you would like to delete?","PASS_ITEM_GUIDS_ON_CHECKOUT":true,"FORM_REVISION_HISTORY":true,"CHECKOUT_DISCLAIMER":"By entering your credit card and/or checking account information you (i) state that **you are an authorized user** of the credit card and/or electronic check and that the associated information entered (e.g., account holder name, account number, billing address) is accurate, (ii) **you authorize payment processor to charge the amount you have requested** to your credit card and/or funding account, and (iii) **acknowledge if a charge is declined or reversed you may also be assessed a customary charge** by the payment processor for such transactions.","FARM_BILL_SEARCH_CONFIDENTIAL":"As a registered Farm Bill Buyer with the Montana Secretary of State’s office it is important to maintain the confidentiality of the information contained within the Farm Bill Master List. The Farm Bill Master List reflects personal data, such as Social Security Numbers, which are a key piece of personal identifiable information to assist you in determining the existence of a lien against a specific debtor. The distribution of this information beyond its intended purpose is strictly prohibited.\n\n**The debtor's tax identification number has been hidden for confidentiality reasons. You may continue to search on a tax ID number and return debtors that match your search criteria. The SSN/FEIN must be entered without dashes or spaces.  If you need access to the tax identification number to clearly identify the debtor, please contact the UCC unit at (406) 444-3665.**","VIEW_HISTORY_BUTTON_ALT_TEXT":"View Filings","WIZARD_ERROR_TITLE_MESSAGE":"Form Error","FARM_BILL_SEARCH_INTERACTIVE":true,"USE_FARM_BILL_API":true,"DISALLOW_ASSIGN_SELF_AS_RA":true,"DISALLOW_ASSIGN_SELF_AS_PRINCIPAL":true,"USE_TRADEMARK_OWNER_VALIDATION":true,"USE_ALTERNATIVE_FOREIGN_ADDRESS_LABELS":true,"MY_RECEIPTS_FILTER":[{"type":"dateRange","name":"DATE_RANGE","label":"Date range","defaultValue":{"start":null,"end":null}},{"type":"text","name":"REF_NUM","defaultValue":"","label":"Reference Number"},{"type":"text","name":"RECEIPT_NUM","defaultValue":"","label":"Receipt Id"},{"type":"text","name":"AMOUNT","defaultValue":"","label":"Amount"},{"type":"select","name":"TYPE","defaultValue":"","label":"Payment Type","options":[{"value":"","label":"All"},{"value":"CC","label":"Credit Card"},{"value":"Check","label":"Check"}]}],"MY_RECEIPTS_SHOW_IN_SIDEBAR":true,"SHOW_MY_RECEIPTS_HELPER_TEXT":true,"MY_RECEIPTS_HELPER_LABEL":"About Receipt Search","MY_RECEIPTS_HELPER_TEXT":"You can search for receipts based on their descriptions, including the items paid for on the receipt. Use the filters to search for or filter specific information.","FARM_BILL_SUBLINK":{"label":"Farm Bill","component":"FarmBill","parameter":"farm-bill","path":"/lists/farm-bill","sourceTypeId":0,"myRecordsSearch":false,"allowedRules":["/search/"],"disabled":true,"searchDescription":"To perform a search, enter a debtor name. Your search results may include: exact debtor name, variations of that name and any filing that includes your search criteria. Punctuation is ignored.\n\nYou can click on \"Advanced\" to refine your search. Under “Advanced” you can search by crop, year, county and SSN/FEIN. As a registered Farm Bill Buyer with the Montana Secretary of State’s office it is important to maintain the confidentiality of the information contained within the Farm Bill Master List. The Farm Bill Master List reflects personal data, such as Social Security Numbers, which are a key piece of personal identifiable information to assist you in determining the existence of a lien against a specific debtor. The distribution of this information beyond its intended purpose is strictly prohibited.\n\nThe debtor's tax identification number has been hidden for confidentiality reasons. You may continue to search on a tax ID number and return debtors that match your search criteria. The SSN/FEIN must be entered without dashes or spaces.","searchMustHaveOneOf":["search","UCC_FARM_PRODUCT_ID","COUNTY"],"searchPlaceholder":"Search by debtor name","advancedSearchParameters":[{"type":"ServerMultiComplete","label":"Product code name(s)","name":"UCC_FARM_PRODUCT_ID","defaultValue":"","optionsSrc":"UCC_FARM_PRODUCT_V"},{"type":"MultiComplete","label":"Year or Range of Years","name":"YEAR_NUM","optionsSrc":"years","startYear":"1968","defaultValue":[],"preMergeOptions":[{"value":"ALL","label":"All"}]},{"type":"serverSelect","label":"State","name":"STATE","defaultValue":"MONTANA","optionsSrc":"STATE"},{"type":"ServerMultiComplete","label":"County","name":"COUNTY","defaultValue":[],"optionsSrc":"COUNTY","overrideSubOptionsSrcFromParameterName":"STATE"},{"type":"checkbox","name":"TIN_SEARCH_YN","defaultValue":false,"label":"Tax Identification Number Search"},{"type":"checkbox","name":"TIN_SORT_YN","defaultValue":false,"label":"Unique ID Sort"}]},"ALLOW_ADDRESS_VALIDATION_BYPASS_OPTION":true,"DEFAULT_ADDRESS_VALIDATION_BYPASS_OPTION_CHECKED":true}).HAS_OKTA_LOGIN && !this.state.oktaDomainError ? _react2.default.createElement(
	          'div',
	          { className: 'flex-row', style: { marginLeft: 8, marginTop: 11 } },
	          _react2.default.createElement(
	            'a',
	            {
	              'aria-disabled': this.state.oktaDomainLoading || true,
	              href: this.state.oktaDomain + '/enduser/settings',
	              className: 'btn btn-primary btn-raised btn-nowrap ' + (this.state.oktaDomainLoading ? 'btn-disabled' : ''),
	              style: { pointerEvents: this.state.oktaDomainLoading ? 'none' : '' }
	            },
	            'Edit my account',
	            this.state.oktaDomainLoading && _react2.default.createElement(
	              'div',
	              {
	                className: 'flex-center',
	                style: { marginLeft: 10, transform: 'scale(.7)', marginTop: -2 }
	              },
	              _react2.default.createElement(_Loaders.Spinner, { themeColor: 'inherit', size: 'small' })
	            )
	          )
	        ) : null,
	        error && _react2.default.createElement(
	          'p',
	          { className: 'danger-text' },
	          _react2.default.createElement(
	            'em',
	            null,
	            error
	          )
	        ),
	        this.state.isFrequentPayor ? _react2.default.createElement(_FrequentPayor.FrequentPayorUserEditorSection, null) : null
	      );
	    }
	  }]);
	
	  return EditorForm;
	}(_react2.default.Component);
	
	EditorForm = (0, _reactRedux.connect)(function (state) {
	  return {
	    user: state.auth
	
	  };
	})(EditorForm);

/***/ },
/* 1151 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(7);
	
	var _requests = __webpack_require__(6);
	
	var _format = __webpack_require__(33);
	
	var _format2 = _interopRequireDefault(_format);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var VersionPage = function VersionPage(_ref) {
	  var isAdmin = _ref.isAdmin;
	
	  var _React$useState = _react2.default.useState(null),
	      _React$useState2 = _slicedToArray(_React$useState, 2),
	      versionHTML = _React$useState2[0],
	      setVersionHTML = _React$useState2[1];
	
	  _react2.default.useEffect(function () {
	    if (isAdmin) {
	      (0, _requests.GET_VERSION_INFO)(function (html) {
	        setVersionHTML(html);
	      }, function (err) {
	        console.error(err);
	      });
	    }
	  }, [isAdmin]);
	
	  return _react2.default.createElement(
	    'div',
	    { className: 'body' },
	    _react2.default.createElement(
	      'strong',
	      null,
	      'Build Number:'
	    ),
	    ' ',
	    ("Not Provided"),
	    _react2.default.createElement('br', null),
	    _react2.default.createElement('br', null),
	    _react2.default.createElement(
	      'strong',
	      null,
	      'Build Date:'
	    ),
	    ' ',
	    (0, _format2.default)(new Date(("2025-08-27T15:15:31.687Z")), 'MM/dd/yyyy h:mm:ss a'),
	    _react2.default.createElement('br', null),
	    _react2.default.createElement('br', null),
	    _react2.default.createElement(
	      'strong',
	      null,
	      'Git Version:'
	    ),
	    ' ',
	    ("v1.3.0-381-ga81e29b08"),
	    _react2.default.createElement('br', null),
	    _react2.default.createElement('br', null),
	    _react2.default.createElement(
	      'strong',
	      null,
	      'Git Commit Hash:'
	    ),
	    ' ',
	    ("a81e29b085c9268ffd96c78eb734365802722741"),
	    _react2.default.createElement('br', null),
	    _react2.default.createElement('br', null),
	    _react2.default.createElement(
	      'strong',
	      null,
	      'Git Branch:'
	    ),
	    ' ',
	    ("beta"),
	    versionHTML && isAdmin && _react2.default.createElement('div', { className: 'version-table', dangerouslySetInnerHTML: { __html: versionHTML } })
	  );
	};
	
	exports.default = (0, _reactRedux.connect)(function (state) {
	  return {
	    isAdmin: state.auth.USER_GROUP === 'ADMIN_WEB' || state.auth.USER_GROUP === 'ADMIN'
	  };
	})(VersionPage);

/***/ },
/* 1152 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(7);
	
	var _Markdown = __webpack_require__(24);
	
	var _Markdown2 = _interopRequireDefault(_Markdown);
	
	var _Field = __webpack_require__(25);
	
	var _Form = __webpack_require__(14);
	
	var _WizardActions = __webpack_require__(36);
	
	var _utilities = __webpack_require__(8);
	
	var _wizardUtilities = __webpack_require__(52);
	
	var _Summary = __webpack_require__(476);
	
	var _Summary2 = _interopRequireDefault(_Summary);
	
	var _store = __webpack_require__(18);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var SignatureSection = function SignatureSection(_ref) {
	  var signerAttestations = _ref.signerAttestations,
	      signatureValues = _ref.signatureValues,
	      setWizardSignatureValues = _ref.setWizardSignatureValues,
	      signatureErrors = _ref.signatureErrors,
	      signatureTextLabel = _ref.signatureTextLabel,
	      signatureDateLabel = _ref.signatureDateLabel;
	
	  var setAttestationByIndex = function setAttestationByIndex(checked, i) {
	    setWizardSignatureValues(Object.assign({}, signatureValues, {
	      attestations: Object.assign({}, signatureValues.attestations, _defineProperty({}, i, checked))
	    }));
	  };
	
	  return _react2.default.createElement(
	    _react2.default.Fragment,
	    null,
	    _react2.default.createElement(
	      'div',
	      { className: 'section' },
	      _react2.default.createElement(
	        'h2',
	        null,
	        'Review & Sign'
	      ),
	      _react2.default.createElement(_Markdown2.default, {
	        className: 'description',
	        source: 'Review the following information for accuracy and then sign below.'
	      }),
	      _react2.default.createElement(_Summary2.default, null),
	      _react2.default.createElement('div', { className: 'bottom-divider' })
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'section' },
	      _react2.default.createElement(
	        'h2',
	        null,
	        'Sign & Submit'
	      ),
	      signerAttestations.map(function (att, i) {
	        return _react2.default.createElement(
	          _Field.DumbField,
	          { key: i },
	          _react2.default.createElement(_Form.Checkbox, {
	            fieldId: 'attestation_' + i,
	            label: att,
	            value: signatureValues.attestations[i] || false,
	            onChange: function onChange(checked) {
	              return setAttestationByIndex(checked, i);
	            }
	          })
	        );
	      }),
	      signatureErrors.ATTESTATIONS ? _react2.default.createElement(
	        'p',
	        { className: 'field-error animated fadeIn fast-animation', style: { marginBottom: 15 } },
	        signatureErrors.ATTESTATIONS
	      ) : null,
	      _react2.default.createElement(Signature, {
	        signatureTextLabel: signatureTextLabel,
	        signatureDateLabel: signatureDateLabel
	      })
	    )
	  );
	};
	SignatureSection = (0, _reactRedux.connect)(function (state) {
	  var filingMethod = state.wizard.requirePrintMailMethod.size > 0 ? [{ value: { method: 'mail' } }] : (0, _utilities.getFieldsByType)('UploadAndSubmit', state.wizard.wizard.fields);
	  var activeFilingMethods = filingMethod && filingMethod.filter(function (field) {
	    return (0, _wizardUtilities.resolveFieldConditions)(field.conditions, state.wizard.wizard.fields, field.conditionsOperator) && (field.logicNodes ? (0, _store.resolveFieldLogic)(field).active : true);
	  });
	  var method = activeFilingMethods[0];
	  return {
	    signatureValues: state.wizard.signatureValues,
	    signerAttestations: method ? method.signerAttestations : [],
	    signatureErrors: state.wizard.signatureErrors,
	    signatureTextLabel: method ? method.signatureTextLabel : '',
	    signatureDateLabel: method ? method.signatureDateLabel : ''
	  };
	}, { setWizardSignatureValues: _WizardActions.setWizardSignatureValues })(SignatureSection);
	exports.default = SignatureSection;
	
	
	var Signature = function Signature(_ref2) {
	  var signatureValues = _ref2.signatureValues,
	      signatureErrors = _ref2.signatureErrors,
	      setWizardSignatureValues = _ref2.setWizardSignatureValues,
	      signatureTextLabel = _ref2.signatureTextLabel,
	      signatureDateLabel = _ref2.signatureDateLabel;
	
	  var THIRD_PARTY_SIGNATURE_DEFAULT_DATE = ({"NODE_ENV":"production","BUILD_DATE":"2025-08-27T15:15:31.687Z","BUILD_NUMBER":"Not Provided","GIT_VERSION":"v1.3.0-381-ga81e29b08","GIT_COMMIT_HASH":"a81e29b085c9268ffd96c78eb734365802722741","GIT_BRANCH":"beta","PUBLIC_URL":"","STATE_ABBR":"MT","STATE_NAME":"Montana","STATE_ORG_TITLE":"Secretary of State","LOGIN_HEADER_IMG_PATH":"","HOME_IMG_FILENAME":"montana.jpg","FAVICON_FILE_NAME":"favicon.ico","ALLOW_E_SIGN_ON_CORRECTIONS":true,"THIRD_PARTY_SIGNING_ALLOWED":false,"MY_ACCOUNT_SAVE_AND_CLOSE_BUTTON":true,"IE_DEPRECATED_MESSAGE":"Internet Explorer is not supported. Please select a supported browser below to access this website.","ADDITIONAL_ROUTES":{"dataRequests":true,"farmBill":true,"apostille":true,"externalHelp":"https://sosmt.gov/business/help-center/","systemAdministration":[{"title":"Saved Payments","parameter":"saved-payments","componentName":"SavedPayments"}]},"SUBROUTES":[{"label":"Business","component":"Business","parameter":"business","myWorkQueueSearch":false,"sourceTypeId":54,"searchMustHaveOneOf":["FILING_TYPE_ID","STATUS_ID","STATE","search"],"serverWebSearchDescription":true,"serverWorkQueueDescription":true,"serverMyRecordsDescription":true,"searchPlaceholder":"Search by name or filing number (X########)","allowEmptySearchTerm":true,"requestCertificateAlternateLabel":"Request Information","fileAmendmentButtonLabel":"Filing Actions","advancedSearchParameters":[{"type":"radio","name":"QUERY_TYPE_ID","defaultValue":1010,"options":[{"value":1010,"label":"Starts with"},{"value":1011,"label":"Contains"},{"value":1012,"label":" Word Contains"}]},{"type":"serverSelect","name":"FILING_TYPE_ID","optionsSrc":"FILING_TYPES","label":"Entity Type","placeholder":"All","defaultValue":"0"},{"type":"serverSelect","name":"FILING_SUBTYPE_ID","optionsSrc":"FILING_SUBTYPES","label":"Entity Subtype","overrideSubOptionsSrcFromParameterName":"FILING_TYPE_ID","placeholder":"All","defaultValue":"0"},{"type":"serverSelect","name":"STATUS_ID","optionsSrc":"FILING_STATUS_WITHOUT_ALL","label":"Status","placeholder":"All","defaultValue":"0"},{"type":"serverSelect","name":"STATE","optionsSrc":"STATE","label":"State","placeholder":"All","defaultValue":""},{"type":"serverSelect","name":"COUNTY","optionsSrc":"COUNTY_SUBOPTION","label":"County","overrideSubOptionsSrcFromParameterName":"STATE","placeholder":"All","defaultValue":""},{"type":"checkbox","name":"CRA_SEARCH_YN","defaultValue":false,"label":"Search by Registered Agent PID"},{"type":"dateRange","name":"FILING_DATE","label":"Registration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}},{"type":"dateRange","name":"EXPIRATION_DATE","label":"Expiration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}}],"myRecordsFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Active"},{"value":2,"label":"Inactive"},{"value":3,"label":"Pending"}]},{"type":"dateRange","name":"DATE_RANGE","label":"Date range","defaultValue":{"start":null,"end":null}}],"myWorkQueueFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Approved"},{"value":2,"label":"Pending Online Payment"},{"value":3,"label":"Pending Review"},{"value":4,"label":"Needs Correction"},{"value":5,"label":"Rejected"},{"value":6,"label":"Draft"}]},{"type":"dateRange","name":"DATE_RANGE","label":"Date range","defaultValue":{"start":null,"end":null}}]},{"label":"Notary","component":"Notary","parameter":"notary","sourceTypeId":850,"myWorkQueueSearch":false,"allowEmptySearchTerm":true,"requestCertificateAlternateLabel":"Download Certificate","fileAmendmentButtonLabel":"Filing Actions","hideNameRequestCertificate":true,"hideAddressRequestCertificate":true,"hideRecordUserManagment":true,"searchPlaceholder":"Search by name or commission number","searchMustHaveOneOf":["CITY","search","SERVICE_TYPE"],"advancedParametersStartOpen":true,"searchIsSortable":true,"advancedSearchParameters":[{"type":"radio","name":"STARTS_WITH_YN","defaultValue":false,"options":[{"value":true,"label":"Starts with"},{"value":false,"label":"Contains"}]},{"type":"checkbox","name":"ACTIVE_ONLY_YN","defaultValue":true,"label":"Active entities only"},{"type":"text","name":"CITY","defaultValue":"","label":"City"},{"type":"select","name":"SERVICE_TYPE","label":"Special Services Offered","defaultValue":0,"options":[{"value":0,"label":"(N/A)"},{"value":6165,"label":"In-Person Electronic Notarization (IPEN)"},{"value":6166,"label":"Remote Online Notarization (RON)"},{"value":6167,"label":"Mobile Notary Services"},{"value":6168,"label":"Remote Ink Notarization (RIN)"}]}]},{"label":"Apostille","component":"Apostille","parameter":"apostille","sourceTypeId":720,"myRecordsSearch":false,"myWorkQueueSearch":false,"disabled":false,"allowedRoutes":["/forms-manager/","/queue/","/forms/"]},{"label":"Liens","component":"UCC","parameter":"ucc","sourceTypeId":1999,"myRecordsSearch":true,"myWorkQueueSearch":true,"fileAmendmentButtonLabel":"Filing Actions","searchPlaceholder":"Search by name or file number","disabled":false,"serverWebSearchDescription":true,"myRecordsDescription":"","workQueueDescription":"","searchDescription":"","hideRecordUserManagment":true,"searchLiensCheckout":false,"advancedSearchParameters":[{"type":"radio","name":"STARTS_WITH_YN","defaultValue":false,"options":[{"value":true,"label":"Starts with"},{"value":false,"label":"Contains"}]},{"type":"select","name":"STATUS","defaultValue":"ALL","label":"Status","options":[{"value":"ACTIVE_UNLAPSED","label":"Active (unlapsed)"},{"value":"ACTIVE_LAPSED_UNLAPSED","label":"Active (lapsed and unlapsed)"}]},{"type":"text","name":"EXCLUDE_VALUES","label":"Exclude Debtor Names (comma separated list of names to exclude)","defaultValue":""},{"type":"dateRange","name":"FILING_DATE","label":"Financing Statement Date","defaultValue":{"start":null,"end":null}},{"type":"dateRange","name":"LAPSE_DATE","label":"Lapse Date","defaultValue":{"start":null,"end":null}},{"type":"text","name":"CITY","label":"Debtor City","defaultValue":""}],"myRecordsFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Approved"},{"value":2,"label":"Pending Online Payment"},{"value":3,"label":"Pending Review"}]},{"type":"select","name":"TYPE","defaultValue":0,"label":"Lien Type","options":[{"value":0,"label":"All"},{"value":1,"label":"UCC"},{"value":2,"label":"EFS"},{"value":3,"label":"Title 71"}]}],"myWorkQueueFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Approved"},{"value":2,"label":"Pending Online Payment"},{"value":3,"label":"Pending Review"},{"value":4,"label":"Pending Print and Mail"},{"value":5,"label":"Rejected"},{"value":6,"label":"Draft"}]},{"type":"select","name":"TYPE","defaultValue":0,"label":"Lien Type","options":[{"value":0,"label":"All"},{"value":1,"label":"UCC"},{"value":2,"label":"EFS"},{"value":3,"label":"Title 71"}]}]},{"label":"Copy Request","component":"copies","parameter":"copies","sourceTypeId":2001,"myRecordsSearch":false,"myWorkQueueSearch":false,"disabled":false,"allowedRoutes":["/forms-manager/","/queue/","/forms/"]},{"label":"Trademark","component":"Trademark","parameter":"trademark","sourceTypeId":810,"showRequestCertificate":true,"searchMustHaveOneOf":["search","EXPIRATION_DATE","FILING_DATE"],"allowEmptySearchTerm":true,"requestCertificateAlternateLabel":"Request Information","fileAmendmentButtonLabel":"Filing Actions","advancedSearchParameters":[{"type":"radio","name":"QUERY_TYPE_ID","defaultValue":1010,"options":[{"value":1010,"label":"Starts with"},{"value":1011,"label":"Contains"},{"value":1012,"label":" Word Contains"}]},{"type":"checkbox","name":"OWNER_SEARCH_YN","defaultValue":false,"label":"Search owners"},{"type":"radio","name":"SERVICE_MARK_YN","label":"Mark Type","defaultValue":"","options":[{"value":"","label":"All Marks"},{"value":"Y","label":"Service Mark"},{"value":"N","label":"Trademark"}]},{"type":"serverSelect","name":"STATUS_ID","optionsSrc":"TYPE_V|TRADEMARK_STATUS_TYPE","label":"Status","placeholder":"All","defaultValue":"0"},{"type":"select","name":"DESIGN_TYPE_ID","options":[{"value":0,"label":"All"},{"value":990,"label":"Words Only"},{"value":991,"label":"Design Only"},{"value":992,"label":"Words and Design"}],"label":"Design Type","defaultValue":"0"},{"type":"dateRange","name":"FILING_DATE","label":"Registered Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}},{"type":"dateRange","name":"EXPIRATION_DATE","label":"Expiration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}}]},{"label":"Business Info Request","component":"InfoRequests","parameter":"info-request","sourceTypeId":167,"allowedRoutes":["/forms-manager/","/queue/","/forms/"]},{"label":"Data Requests","component":"DataRequests","parameter":"data-request","sourceTypeId":0,"allowedRoutes":["/forms-manager/"]},{"label":"CRA","component":"CRA","parameter":"cra","sourceTypeId":157,"myRecordsSearch":false,"searchPlaceholder":"Search by name or registered agent number","allowedRoutes":["/forms-manager/","/forms/","/records/","/queue/","/search/"],"allowEmptySearchTerm":true,"fileAmendmentButtonLabel":"Filing Actions","advancedSearchParameters":[{"type":"radio","name":"QUERY_TYPE_ID","defaultValue":1010,"options":[{"value":1010,"label":"Starts with"},{"value":1011,"label":"Contains"},{"value":1012,"label":" Word Contains"}]},{"type":"dateRange","name":"CRA_DATE","label":"Registration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}},{"type":"select","name":"STATUS_ID","label":"Status","defaultValue":0,"options":[{"value":0,"label":"All"},{"value":121,"label":"Active"},{"value":122,"label":"Inactive"}]},{"type":"select","name":"AGENT_TYPE_ID","label":"Agent Type","defaultValue":0,"options":[{"value":0,"label":"All"},{"value":460,"label":"Registered Agent"},{"value":461,"label":"Commercial Registered Agent"}]}]},{"label":"Farm Bill","component":"FarmBill","parameter":"farm-bill","path":"/lists/farm-bill","sourceTypeId":0,"myRecordsSearch":false,"allowedRules":["/search/"],"disabled":true,"searchDescription":"To perform a search, enter a debtor name. Your search results may include: exact debtor name, variations of that name and any filing that includes your search criteria. Punctuation is ignored.\n\nYou can click on \"Advanced\" to refine your search. Under “Advanced” you can search by crop, year, county and SSN/FEIN. As a registered Farm Bill Buyer with the Montana Secretary of State’s office it is important to maintain the confidentiality of the information contained within the Farm Bill Master List. The Farm Bill Master List reflects personal data, such as Social Security Numbers, which are a key piece of personal identifiable information to assist you in determining the existence of a lien against a specific debtor. The distribution of this information beyond its intended purpose is strictly prohibited.\n\nThe debtor's tax identification number has been hidden for confidentiality reasons. You may continue to search on a tax ID number and return debtors that match your search criteria. The SSN/FEIN must be entered without dashes or spaces.","searchMustHaveOneOf":["search","UCC_FARM_PRODUCT_ID","COUNTY"],"searchPlaceholder":"Search by debtor name","advancedSearchParameters":[{"type":"ServerMultiComplete","label":"Product code name(s)","name":"UCC_FARM_PRODUCT_ID","defaultValue":"","optionsSrc":"UCC_FARM_PRODUCT_V"},{"type":"MultiComplete","label":"Year or Range of Years","name":"YEAR_NUM","optionsSrc":"years","startYear":"1968","defaultValue":[],"preMergeOptions":[{"value":"ALL","label":"All"}]},{"type":"serverSelect","label":"State","name":"STATE","defaultValue":"MONTANA","optionsSrc":"STATE"},{"type":"ServerMultiComplete","label":"County","name":"COUNTY","defaultValue":[],"optionsSrc":"COUNTY","overrideSubOptionsSrcFromParameterName":"STATE"},{"type":"checkbox","name":"TIN_SEARCH_YN","defaultValue":false,"label":"Tax Identification Number Search"},{"type":"checkbox","name":"TIN_SORT_YN","defaultValue":false,"label":"Unique ID Sort"}]}],"SYSTEM_NICKNAME":"Online Services Portal","PAYMENT_METHODS":[{"type":"bypass"},{"type":"iTransact"}],"PAYMENT_ALLOW_AMEX":true,"SYSTEM_ID_LABEL":"System Id","DOUBLE_COLUMN_PUBLIC_LOGIN":true,"INTERNAL_USER_MANAGEMENT":true,"ALLOW_PUBLIC_JSON_IMPORT":false,"MAX_FILE_UPLOAD_SIZE":10000000,"REFUND_TEXT":"","RETURN_TO_HOME_ON_LOGOUT":true,"CURRENT_SOS_NAME":"Christi Jacobsen","LOGO_FILENAME":"mt-sos-logo.png","LOGO_ALT":"Christi Jacobsen, Montana Secretary of State","LOGO_FULL_WIDTH":true,"HOME_HIDE_AUTH_HINT":true,"HOME_TITLE":"Montana Secretary of State","CUSTOM_TAB_TITLE":"Official Montana","HOME_SUBTITLE":"Online Business Services","ENTITY_NAME_CONSENT_DESCRIPTION":"","ALLOW_USER_PROFILE_EDITING":true,"COMPARE_FOREIGN_NAME_IN_ENTITY_NAME_VALIDATION":true,"FOREIGN_NAME_FIELD_NAME":"KIMA_PARENT_NAME_INFO","LOGIN_TITLE":"Montana Secretary of State Online Filing Portal Login","PUBLIC_LOGIN_LABEL":"Username","REVERSE_LOGIN_COLUMNS":true,"LOGIN_SEAL_FILENAME":"seal_white.png","SEPARATE_USERNAME_AND_EMAIL":true,"CREATE_ACCOUNT_BUTTON_ALIGN_LEFT":true,"CREATE_ACCOUNT_BUTTON_TEXT":"CREATE AN ACCOUNT","PASSWORD_CUSTOM_ERROR_TEXT":"The password must meet all requirements","ACCOUNT_CREATED_MESSAGE":"Please check your email to verify your account to login and allow a few minutes for this message to arrive. Check your junk/spam folders if you do not find the email in your inbox.","PUBLIC_LOGIN_PLACEHOLDER":" ","DISABLE_DEFAULT_PAYMENT_RADIO":true,"CUSTOM_RESET_PASSWORD_ERROR_MESSAGE":"Username invalid - no account found","PUBLIC_LOGIN_CREATE_DESCRIPTION":"### Existing User:\n\n  - Enter your username and password to login.  \n\n\n  #### - OR -  \n\n\n\n  - Forgot password? Click 'Reset Password' and follow the prompts.\n  - Forgot username? Click 'Forgot Username' and follow the prompts.  \n\n\n  ### New User:\n  ","LOGIN_HELP_LINK":"https://sosmt.gov/business/how-do-i/","LOGIN_HELP_LINK_TEXT":"Need Help?","FORGOT_USERNAME_TEXT":"Forgot Username?","LOGIN_ACTIVE_DIRECTORY_TEXT":"State User Login","MULTIPLE_LOGIN_METHODS":true,"HAS_ACTIVE_DIRECTORY_LOGIN":true,"RESET_PASSWORD_WITH_USERNAME":true,"DOWNLOAD_LINK":true,"SHOW_USERNAME_ACCOUNT_CREATE":true,"SHOW_SCROLL_DOWN_ARROW":true,"SHOW_ADDRESS_ACCOUNT_CREATE":true,"TWO_COLUMN_ACCOUNT_CREATE":true,"RESET_PASSWORD_TIP":"A link to change your password has been sent to your email. Please allow a few minutes for this message to arrive. Please check your junk/spam folders if you do not find the email in your inbox.","FORGOT_PASSWORD_LINK_TEXT":"Reset Password","PHONE_NUMBER_OPTIONAL_ACCOUNT_CREATE":true,"SHOW_REQUIRED_INDICATOR_ACCOUNT_CREATE":true,"PASSWORD_REQUIREMENTS_ACCOUNT_CREATE":"\n    <ul>\n      <li>MUST contain at least 8 characters (12+ recommended)</li>\n      <li>MUST contain at least one uppercase letter.</li>\n      <li>MUST contain at least one lowercase letter.</li>\n      <li>MUST contain at least one number.</li>\n      <li>MUST contain at least one special character (!”#$%&'()*+,-./:;<=>?</li>\n    </ul>\n  ","ALLOW_CERTIFICATION_REQUEST":true,"ALLOW_PUBLIC_CERTIFICATE_REQUEST":true,"ALLOW_COPY_REQUEST":false,"ALLOW_CORRECTION_STYLING":true,"HIDE_DEPRECATION_WARNING":false,"AMEND_ROUTE_PUBLIC":true,"SEAL_FILENAME":"seal.png","SHOPPING_CART":true,"ALLOW_PAYMENT_UPDATE_WITH_EMPTY_CART":true,"RA_EMAIL":true,"RA_WEBSITE":true,"RA_NO_DEFAULT_TYPE":true,"RA_ADDRESS_LABEL":"Street Address","RA_TYPE_SELECTION_DEFAULT":true,"RA_DEFAULT_TYPE":"460","RA_OVERRIDE_TYPE_WITH_DEFAULT":true,"RA_PRINCIPAL_ADDRESS_AMS":true,"UPLOAD_AND_SUBMIT_HIDE_IF_ONE_OPTION":true,"PAYMENT_PROCESSING_MESSAGE":"Your payment is processing - Do not close your browser or click the back button","CHECKOUT_BUTTON_WHEN_PROCESSING_TEXT":"Processing","EFS_CROP_PICKER_NONE_LABEL":"Lien Duration","DISALLOWED_WIZARD_PIECES":["FormationLocale"],"REPEATER_SHOW_EDIT_BUTTON":true,"DATA_REQUEST_PAGE_TITLE":"Data Requests and Subscriptions","DATA_REQUEST_SIDEBAR_LABEL":"Data Requests & Subscriptions","LOGIN_REDIRECTS_TO_EPASS":false,"LOGIN_REDIRECTS_TO_ACTIVE_DIRECTORY":true,"LOGIN_ACTIVE_DIRECTORY_LINK":true,"FETCH_EDIT_USER_LINK":false,"LISTS_FETCH_AVAILABLE_LISTS":true,"POST_WIZARD_SUBMIT_REDIRECT_URL":"/","PIN_REQUEST_ATTESTATIONS":true,"PIN_REQUEST_DESCRIPTION":"Click **Request PIN** to have a new PIN sent to the account holder's email address on file.","OWNERSHIP_REQUEST_DESCRIPTION":"To become an **authorized user** of this record, a current **AUTHORIZED USER** will need to grant you access. To request access, click **Request Access** below.","PIN_REQUEST_SUCCESS_MESSAGE":"The PIN you have requested for this entity has been sent to the email associated with your user account.  You should receive the PIN in approximately 3-5 minutes, depending on your email service provider.","APOSTILLE_HEADER_LABEL":"Verification Information","APOSTILLE_NUMBER_LABEL":"Apostille/Authentication","APOSTILLE_CITY_STATE_OVERRIDE":"HELENA, MT","APOSTILLE_FILING_DATE_LABEL":"Issue Date","APOSTILLE_CITY_STATE_IN_CERTIFIED":true,"NOTARY_EXISTING_FILING":true,"ALLOW_REVOKE_OWN_ACCESS_ONLY":false,"HIDE_CANCEL_ON_ONETIME_DATA_REQUESTS":true,"DATA_REQUESTS_IN_SHOPPING_CART":true,"WQ_ALLOW_EDIT_PENDING_PAYMENT":true,"WQ_CONFIRM_ON_DELETE":true,"WQ_DELETE_CONFIRM_MESSAGE":"Deleting this filing will forfeit any money already paid to the Secretary of State. This action is permanent and cannot be undone, are you sure you would like to delete?","PASS_ITEM_GUIDS_ON_CHECKOUT":true,"FORM_REVISION_HISTORY":true,"CHECKOUT_DISCLAIMER":"By entering your credit card and/or checking account information you (i) state that **you are an authorized user** of the credit card and/or electronic check and that the associated information entered (e.g., account holder name, account number, billing address) is accurate, (ii) **you authorize payment processor to charge the amount you have requested** to your credit card and/or funding account, and (iii) **acknowledge if a charge is declined or reversed you may also be assessed a customary charge** by the payment processor for such transactions.","FARM_BILL_SEARCH_CONFIDENTIAL":"As a registered Farm Bill Buyer with the Montana Secretary of State’s office it is important to maintain the confidentiality of the information contained within the Farm Bill Master List. The Farm Bill Master List reflects personal data, such as Social Security Numbers, which are a key piece of personal identifiable information to assist you in determining the existence of a lien against a specific debtor. The distribution of this information beyond its intended purpose is strictly prohibited.\n\n**The debtor's tax identification number has been hidden for confidentiality reasons. You may continue to search on a tax ID number and return debtors that match your search criteria. The SSN/FEIN must be entered without dashes or spaces.  If you need access to the tax identification number to clearly identify the debtor, please contact the UCC unit at (406) 444-3665.**","VIEW_HISTORY_BUTTON_ALT_TEXT":"View Filings","WIZARD_ERROR_TITLE_MESSAGE":"Form Error","FARM_BILL_SEARCH_INTERACTIVE":true,"USE_FARM_BILL_API":true,"DISALLOW_ASSIGN_SELF_AS_RA":true,"DISALLOW_ASSIGN_SELF_AS_PRINCIPAL":true,"USE_TRADEMARK_OWNER_VALIDATION":true,"USE_ALTERNATIVE_FOREIGN_ADDRESS_LABELS":true,"MY_RECEIPTS_FILTER":[{"type":"dateRange","name":"DATE_RANGE","label":"Date range","defaultValue":{"start":null,"end":null}},{"type":"text","name":"REF_NUM","defaultValue":"","label":"Reference Number"},{"type":"text","name":"RECEIPT_NUM","defaultValue":"","label":"Receipt Id"},{"type":"text","name":"AMOUNT","defaultValue":"","label":"Amount"},{"type":"select","name":"TYPE","defaultValue":"","label":"Payment Type","options":[{"value":"","label":"All"},{"value":"CC","label":"Credit Card"},{"value":"Check","label":"Check"}]}],"MY_RECEIPTS_SHOW_IN_SIDEBAR":true,"SHOW_MY_RECEIPTS_HELPER_TEXT":true,"MY_RECEIPTS_HELPER_LABEL":"About Receipt Search","MY_RECEIPTS_HELPER_TEXT":"You can search for receipts based on their descriptions, including the items paid for on the receipt. Use the filters to search for or filter specific information.","FARM_BILL_SUBLINK":{"label":"Farm Bill","component":"FarmBill","parameter":"farm-bill","path":"/lists/farm-bill","sourceTypeId":0,"myRecordsSearch":false,"allowedRules":["/search/"],"disabled":true,"searchDescription":"To perform a search, enter a debtor name. Your search results may include: exact debtor name, variations of that name and any filing that includes your search criteria. Punctuation is ignored.\n\nYou can click on \"Advanced\" to refine your search. Under “Advanced” you can search by crop, year, county and SSN/FEIN. As a registered Farm Bill Buyer with the Montana Secretary of State’s office it is important to maintain the confidentiality of the information contained within the Farm Bill Master List. The Farm Bill Master List reflects personal data, such as Social Security Numbers, which are a key piece of personal identifiable information to assist you in determining the existence of a lien against a specific debtor. The distribution of this information beyond its intended purpose is strictly prohibited.\n\nThe debtor's tax identification number has been hidden for confidentiality reasons. You may continue to search on a tax ID number and return debtors that match your search criteria. The SSN/FEIN must be entered without dashes or spaces.","searchMustHaveOneOf":["search","UCC_FARM_PRODUCT_ID","COUNTY"],"searchPlaceholder":"Search by debtor name","advancedSearchParameters":[{"type":"ServerMultiComplete","label":"Product code name(s)","name":"UCC_FARM_PRODUCT_ID","defaultValue":"","optionsSrc":"UCC_FARM_PRODUCT_V"},{"type":"MultiComplete","label":"Year or Range of Years","name":"YEAR_NUM","optionsSrc":"years","startYear":"1968","defaultValue":[],"preMergeOptions":[{"value":"ALL","label":"All"}]},{"type":"serverSelect","label":"State","name":"STATE","defaultValue":"MONTANA","optionsSrc":"STATE"},{"type":"ServerMultiComplete","label":"County","name":"COUNTY","defaultValue":[],"optionsSrc":"COUNTY","overrideSubOptionsSrcFromParameterName":"STATE"},{"type":"checkbox","name":"TIN_SEARCH_YN","defaultValue":false,"label":"Tax Identification Number Search"},{"type":"checkbox","name":"TIN_SORT_YN","defaultValue":false,"label":"Unique ID Sort"}]},"ALLOW_ADDRESS_VALIDATION_BYPASS_OPTION":true,"DEFAULT_ADDRESS_VALIDATION_BYPASS_OPTION_CHECKED":true}).THIRD_PARTY_SIGNATURE_DEFAULT_DATE;
	
	  return _react2.default.createElement(
	    'div',
	    { className: 'panel signatures' },
	    _react2.default.createElement(
	      'div',
	      { className: 'row' },
	      _react2.default.createElement(
	        'div',
	        { className: 'col-sm-7' },
	        _react2.default.createElement(
	          _Field.DumbField,
	          {
	            label: signatureTextLabel || 'Full name',
	            errorMessage: [signatureErrors.SIGNATURE]
	          },
	          _react2.default.createElement(_Form.TextInput, {
	            value: signatureValues.SIGNATURE,
	            onChange: function onChange(value) {
	              return setWizardSignatureValues(Object.assign({}, signatureValues, { SIGNATURE: value }));
	            },
	            width: '100%',
	            validityClass: (0, _Field.getValidityClass)(!signatureErrors.SIGNATURE ? null : false)
	          })
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'col-sm-5' },
	        _react2.default.createElement(
	          _Field.DumbField,
	          {
	            label: signatureDateLabel || 'Date of signing',
	            errorMessage: [signatureErrors.SIGNED_DATE]
	          },
	          _react2.default.createElement(_Form.DateInput, {
	            value: signatureValues.SIGNED_DATE,
	            onChange: function onChange(value) {
	              return setWizardSignatureValues(Object.assign({}, signatureValues, { SIGNED_DATE: value }));
	            },
	            width: '100%',
	            todayButton: THIRD_PARTY_SIGNATURE_DEFAULT_DATE ? false : true,
	            disabled: THIRD_PARTY_SIGNATURE_DEFAULT_DATE,
	            validityClass: (0, _Field.getValidityClass)(!signatureErrors.SIGNED_DATE ? null : false)
	          })
	        )
	      )
	    )
	  );
	};
	Signature = (0, _reactRedux.connect)(function (state) {
	  return {
	    signature: state.wizard.signature,
	    signatureValues: state.wizard.signatureValues,
	    signatureErrors: state.wizard.signatureErrors
	  };
	}, { setWizardSignatureValues: _WizardActions.setWizardSignatureValues })(Signature);

/***/ },
/* 1153 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.initialState = undefined;
	
	var _STATIC_FIELDS;
	
	var _WizardClasses = __webpack_require__(35);
	
	var WizardClasses = _interopRequireWildcard(_WizardClasses);
	
	var _staticFields = __webpack_require__(479);
	
	var _staticFields2 = _interopRequireDefault(_staticFields);
	
	var _shortid = __webpack_require__(22);
	
	var _shortid2 = _interopRequireDefault(_shortid);
	
	var _dateFns = __webpack_require__(417);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var initialStepId = _shortid2.default.generate();
	var initialSectionId = _shortid2.default.generate();
	var initialFieldId = _shortid2.default.generate();
	
	var _getStaticFields = (0, _staticFields2.default)(WizardClasses),
	    SIGNER_EMAIL = _getStaticFields.SIGNER_EMAIL,
	    SIGNER_NAME = _getStaticFields.SIGNER_NAME;
	
	var STATIC_FIELDS = (_STATIC_FIELDS = {}, _defineProperty(_STATIC_FIELDS, SIGNER_EMAIL.fieldId, SIGNER_EMAIL), _defineProperty(_STATIC_FIELDS, SIGNER_NAME.fieldId, SIGNER_NAME), _STATIC_FIELDS);
	
	var getInitialSignatureValues = function getInitialSignatureValues() {
	  return {
	    SIGNATURE: '',
	    SIGNED_DATE: ({"NODE_ENV":"production","BUILD_DATE":"2025-08-27T15:15:31.687Z","BUILD_NUMBER":"Not Provided","GIT_VERSION":"v1.3.0-381-ga81e29b08","GIT_COMMIT_HASH":"a81e29b085c9268ffd96c78eb734365802722741","GIT_BRANCH":"beta","PUBLIC_URL":"","STATE_ABBR":"MT","STATE_NAME":"Montana","STATE_ORG_TITLE":"Secretary of State","LOGIN_HEADER_IMG_PATH":"","HOME_IMG_FILENAME":"montana.jpg","FAVICON_FILE_NAME":"favicon.ico","ALLOW_E_SIGN_ON_CORRECTIONS":true,"THIRD_PARTY_SIGNING_ALLOWED":false,"MY_ACCOUNT_SAVE_AND_CLOSE_BUTTON":true,"IE_DEPRECATED_MESSAGE":"Internet Explorer is not supported. Please select a supported browser below to access this website.","ADDITIONAL_ROUTES":{"dataRequests":true,"farmBill":true,"apostille":true,"externalHelp":"https://sosmt.gov/business/help-center/","systemAdministration":[{"title":"Saved Payments","parameter":"saved-payments","componentName":"SavedPayments"}]},"SUBROUTES":[{"label":"Business","component":"Business","parameter":"business","myWorkQueueSearch":false,"sourceTypeId":54,"searchMustHaveOneOf":["FILING_TYPE_ID","STATUS_ID","STATE","search"],"serverWebSearchDescription":true,"serverWorkQueueDescription":true,"serverMyRecordsDescription":true,"searchPlaceholder":"Search by name or filing number (X########)","allowEmptySearchTerm":true,"requestCertificateAlternateLabel":"Request Information","fileAmendmentButtonLabel":"Filing Actions","advancedSearchParameters":[{"type":"radio","name":"QUERY_TYPE_ID","defaultValue":1010,"options":[{"value":1010,"label":"Starts with"},{"value":1011,"label":"Contains"},{"value":1012,"label":" Word Contains"}]},{"type":"serverSelect","name":"FILING_TYPE_ID","optionsSrc":"FILING_TYPES","label":"Entity Type","placeholder":"All","defaultValue":"0"},{"type":"serverSelect","name":"FILING_SUBTYPE_ID","optionsSrc":"FILING_SUBTYPES","label":"Entity Subtype","overrideSubOptionsSrcFromParameterName":"FILING_TYPE_ID","placeholder":"All","defaultValue":"0"},{"type":"serverSelect","name":"STATUS_ID","optionsSrc":"FILING_STATUS_WITHOUT_ALL","label":"Status","placeholder":"All","defaultValue":"0"},{"type":"serverSelect","name":"STATE","optionsSrc":"STATE","label":"State","placeholder":"All","defaultValue":""},{"type":"serverSelect","name":"COUNTY","optionsSrc":"COUNTY_SUBOPTION","label":"County","overrideSubOptionsSrcFromParameterName":"STATE","placeholder":"All","defaultValue":""},{"type":"checkbox","name":"CRA_SEARCH_YN","defaultValue":false,"label":"Search by Registered Agent PID"},{"type":"dateRange","name":"FILING_DATE","label":"Registration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}},{"type":"dateRange","name":"EXPIRATION_DATE","label":"Expiration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}}],"myRecordsFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Active"},{"value":2,"label":"Inactive"},{"value":3,"label":"Pending"}]},{"type":"dateRange","name":"DATE_RANGE","label":"Date range","defaultValue":{"start":null,"end":null}}],"myWorkQueueFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Approved"},{"value":2,"label":"Pending Online Payment"},{"value":3,"label":"Pending Review"},{"value":4,"label":"Needs Correction"},{"value":5,"label":"Rejected"},{"value":6,"label":"Draft"}]},{"type":"dateRange","name":"DATE_RANGE","label":"Date range","defaultValue":{"start":null,"end":null}}]},{"label":"Notary","component":"Notary","parameter":"notary","sourceTypeId":850,"myWorkQueueSearch":false,"allowEmptySearchTerm":true,"requestCertificateAlternateLabel":"Download Certificate","fileAmendmentButtonLabel":"Filing Actions","hideNameRequestCertificate":true,"hideAddressRequestCertificate":true,"hideRecordUserManagment":true,"searchPlaceholder":"Search by name or commission number","searchMustHaveOneOf":["CITY","search","SERVICE_TYPE"],"advancedParametersStartOpen":true,"searchIsSortable":true,"advancedSearchParameters":[{"type":"radio","name":"STARTS_WITH_YN","defaultValue":false,"options":[{"value":true,"label":"Starts with"},{"value":false,"label":"Contains"}]},{"type":"checkbox","name":"ACTIVE_ONLY_YN","defaultValue":true,"label":"Active entities only"},{"type":"text","name":"CITY","defaultValue":"","label":"City"},{"type":"select","name":"SERVICE_TYPE","label":"Special Services Offered","defaultValue":0,"options":[{"value":0,"label":"(N/A)"},{"value":6165,"label":"In-Person Electronic Notarization (IPEN)"},{"value":6166,"label":"Remote Online Notarization (RON)"},{"value":6167,"label":"Mobile Notary Services"},{"value":6168,"label":"Remote Ink Notarization (RIN)"}]}]},{"label":"Apostille","component":"Apostille","parameter":"apostille","sourceTypeId":720,"myRecordsSearch":false,"myWorkQueueSearch":false,"disabled":false,"allowedRoutes":["/forms-manager/","/queue/","/forms/"]},{"label":"Liens","component":"UCC","parameter":"ucc","sourceTypeId":1999,"myRecordsSearch":true,"myWorkQueueSearch":true,"fileAmendmentButtonLabel":"Filing Actions","searchPlaceholder":"Search by name or file number","disabled":false,"serverWebSearchDescription":true,"myRecordsDescription":"","workQueueDescription":"","searchDescription":"","hideRecordUserManagment":true,"searchLiensCheckout":false,"advancedSearchParameters":[{"type":"radio","name":"STARTS_WITH_YN","defaultValue":false,"options":[{"value":true,"label":"Starts with"},{"value":false,"label":"Contains"}]},{"type":"select","name":"STATUS","defaultValue":"ALL","label":"Status","options":[{"value":"ACTIVE_UNLAPSED","label":"Active (unlapsed)"},{"value":"ACTIVE_LAPSED_UNLAPSED","label":"Active (lapsed and unlapsed)"}]},{"type":"text","name":"EXCLUDE_VALUES","label":"Exclude Debtor Names (comma separated list of names to exclude)","defaultValue":""},{"type":"dateRange","name":"FILING_DATE","label":"Financing Statement Date","defaultValue":{"start":null,"end":null}},{"type":"dateRange","name":"LAPSE_DATE","label":"Lapse Date","defaultValue":{"start":null,"end":null}},{"type":"text","name":"CITY","label":"Debtor City","defaultValue":""}],"myRecordsFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Approved"},{"value":2,"label":"Pending Online Payment"},{"value":3,"label":"Pending Review"}]},{"type":"select","name":"TYPE","defaultValue":0,"label":"Lien Type","options":[{"value":0,"label":"All"},{"value":1,"label":"UCC"},{"value":2,"label":"EFS"},{"value":3,"label":"Title 71"}]}],"myWorkQueueFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Approved"},{"value":2,"label":"Pending Online Payment"},{"value":3,"label":"Pending Review"},{"value":4,"label":"Pending Print and Mail"},{"value":5,"label":"Rejected"},{"value":6,"label":"Draft"}]},{"type":"select","name":"TYPE","defaultValue":0,"label":"Lien Type","options":[{"value":0,"label":"All"},{"value":1,"label":"UCC"},{"value":2,"label":"EFS"},{"value":3,"label":"Title 71"}]}]},{"label":"Copy Request","component":"copies","parameter":"copies","sourceTypeId":2001,"myRecordsSearch":false,"myWorkQueueSearch":false,"disabled":false,"allowedRoutes":["/forms-manager/","/queue/","/forms/"]},{"label":"Trademark","component":"Trademark","parameter":"trademark","sourceTypeId":810,"showRequestCertificate":true,"searchMustHaveOneOf":["search","EXPIRATION_DATE","FILING_DATE"],"allowEmptySearchTerm":true,"requestCertificateAlternateLabel":"Request Information","fileAmendmentButtonLabel":"Filing Actions","advancedSearchParameters":[{"type":"radio","name":"QUERY_TYPE_ID","defaultValue":1010,"options":[{"value":1010,"label":"Starts with"},{"value":1011,"label":"Contains"},{"value":1012,"label":" Word Contains"}]},{"type":"checkbox","name":"OWNER_SEARCH_YN","defaultValue":false,"label":"Search owners"},{"type":"radio","name":"SERVICE_MARK_YN","label":"Mark Type","defaultValue":"","options":[{"value":"","label":"All Marks"},{"value":"Y","label":"Service Mark"},{"value":"N","label":"Trademark"}]},{"type":"serverSelect","name":"STATUS_ID","optionsSrc":"TYPE_V|TRADEMARK_STATUS_TYPE","label":"Status","placeholder":"All","defaultValue":"0"},{"type":"select","name":"DESIGN_TYPE_ID","options":[{"value":0,"label":"All"},{"value":990,"label":"Words Only"},{"value":991,"label":"Design Only"},{"value":992,"label":"Words and Design"}],"label":"Design Type","defaultValue":"0"},{"type":"dateRange","name":"FILING_DATE","label":"Registered Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}},{"type":"dateRange","name":"EXPIRATION_DATE","label":"Expiration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}}]},{"label":"Business Info Request","component":"InfoRequests","parameter":"info-request","sourceTypeId":167,"allowedRoutes":["/forms-manager/","/queue/","/forms/"]},{"label":"Data Requests","component":"DataRequests","parameter":"data-request","sourceTypeId":0,"allowedRoutes":["/forms-manager/"]},{"label":"CRA","component":"CRA","parameter":"cra","sourceTypeId":157,"myRecordsSearch":false,"searchPlaceholder":"Search by name or registered agent number","allowedRoutes":["/forms-manager/","/forms/","/records/","/queue/","/search/"],"allowEmptySearchTerm":true,"fileAmendmentButtonLabel":"Filing Actions","advancedSearchParameters":[{"type":"radio","name":"QUERY_TYPE_ID","defaultValue":1010,"options":[{"value":1010,"label":"Starts with"},{"value":1011,"label":"Contains"},{"value":1012,"label":" Word Contains"}]},{"type":"dateRange","name":"CRA_DATE","label":"Registration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}},{"type":"select","name":"STATUS_ID","label":"Status","defaultValue":0,"options":[{"value":0,"label":"All"},{"value":121,"label":"Active"},{"value":122,"label":"Inactive"}]},{"type":"select","name":"AGENT_TYPE_ID","label":"Agent Type","defaultValue":0,"options":[{"value":0,"label":"All"},{"value":460,"label":"Registered Agent"},{"value":461,"label":"Commercial Registered Agent"}]}]},{"label":"Farm Bill","component":"FarmBill","parameter":"farm-bill","path":"/lists/farm-bill","sourceTypeId":0,"myRecordsSearch":false,"allowedRules":["/search/"],"disabled":true,"searchDescription":"To perform a search, enter a debtor name. Your search results may include: exact debtor name, variations of that name and any filing that includes your search criteria. Punctuation is ignored.\n\nYou can click on \"Advanced\" to refine your search. Under “Advanced” you can search by crop, year, county and SSN/FEIN. As a registered Farm Bill Buyer with the Montana Secretary of State’s office it is important to maintain the confidentiality of the information contained within the Farm Bill Master List. The Farm Bill Master List reflects personal data, such as Social Security Numbers, which are a key piece of personal identifiable information to assist you in determining the existence of a lien against a specific debtor. The distribution of this information beyond its intended purpose is strictly prohibited.\n\nThe debtor's tax identification number has been hidden for confidentiality reasons. You may continue to search on a tax ID number and return debtors that match your search criteria. The SSN/FEIN must be entered without dashes or spaces.","searchMustHaveOneOf":["search","UCC_FARM_PRODUCT_ID","COUNTY"],"searchPlaceholder":"Search by debtor name","advancedSearchParameters":[{"type":"ServerMultiComplete","label":"Product code name(s)","name":"UCC_FARM_PRODUCT_ID","defaultValue":"","optionsSrc":"UCC_FARM_PRODUCT_V"},{"type":"MultiComplete","label":"Year or Range of Years","name":"YEAR_NUM","optionsSrc":"years","startYear":"1968","defaultValue":[],"preMergeOptions":[{"value":"ALL","label":"All"}]},{"type":"serverSelect","label":"State","name":"STATE","defaultValue":"MONTANA","optionsSrc":"STATE"},{"type":"ServerMultiComplete","label":"County","name":"COUNTY","defaultValue":[],"optionsSrc":"COUNTY","overrideSubOptionsSrcFromParameterName":"STATE"},{"type":"checkbox","name":"TIN_SEARCH_YN","defaultValue":false,"label":"Tax Identification Number Search"},{"type":"checkbox","name":"TIN_SORT_YN","defaultValue":false,"label":"Unique ID Sort"}]}],"SYSTEM_NICKNAME":"Online Services Portal","PAYMENT_METHODS":[{"type":"bypass"},{"type":"iTransact"}],"PAYMENT_ALLOW_AMEX":true,"SYSTEM_ID_LABEL":"System Id","DOUBLE_COLUMN_PUBLIC_LOGIN":true,"INTERNAL_USER_MANAGEMENT":true,"ALLOW_PUBLIC_JSON_IMPORT":false,"MAX_FILE_UPLOAD_SIZE":10000000,"REFUND_TEXT":"","RETURN_TO_HOME_ON_LOGOUT":true,"CURRENT_SOS_NAME":"Christi Jacobsen","LOGO_FILENAME":"mt-sos-logo.png","LOGO_ALT":"Christi Jacobsen, Montana Secretary of State","LOGO_FULL_WIDTH":true,"HOME_HIDE_AUTH_HINT":true,"HOME_TITLE":"Montana Secretary of State","CUSTOM_TAB_TITLE":"Official Montana","HOME_SUBTITLE":"Online Business Services","ENTITY_NAME_CONSENT_DESCRIPTION":"","ALLOW_USER_PROFILE_EDITING":true,"COMPARE_FOREIGN_NAME_IN_ENTITY_NAME_VALIDATION":true,"FOREIGN_NAME_FIELD_NAME":"KIMA_PARENT_NAME_INFO","LOGIN_TITLE":"Montana Secretary of State Online Filing Portal Login","PUBLIC_LOGIN_LABEL":"Username","REVERSE_LOGIN_COLUMNS":true,"LOGIN_SEAL_FILENAME":"seal_white.png","SEPARATE_USERNAME_AND_EMAIL":true,"CREATE_ACCOUNT_BUTTON_ALIGN_LEFT":true,"CREATE_ACCOUNT_BUTTON_TEXT":"CREATE AN ACCOUNT","PASSWORD_CUSTOM_ERROR_TEXT":"The password must meet all requirements","ACCOUNT_CREATED_MESSAGE":"Please check your email to verify your account to login and allow a few minutes for this message to arrive. Check your junk/spam folders if you do not find the email in your inbox.","PUBLIC_LOGIN_PLACEHOLDER":" ","DISABLE_DEFAULT_PAYMENT_RADIO":true,"CUSTOM_RESET_PASSWORD_ERROR_MESSAGE":"Username invalid - no account found","PUBLIC_LOGIN_CREATE_DESCRIPTION":"### Existing User:\n\n  - Enter your username and password to login.  \n\n\n  #### - OR -  \n\n\n\n  - Forgot password? Click 'Reset Password' and follow the prompts.\n  - Forgot username? Click 'Forgot Username' and follow the prompts.  \n\n\n  ### New User:\n  ","LOGIN_HELP_LINK":"https://sosmt.gov/business/how-do-i/","LOGIN_HELP_LINK_TEXT":"Need Help?","FORGOT_USERNAME_TEXT":"Forgot Username?","LOGIN_ACTIVE_DIRECTORY_TEXT":"State User Login","MULTIPLE_LOGIN_METHODS":true,"HAS_ACTIVE_DIRECTORY_LOGIN":true,"RESET_PASSWORD_WITH_USERNAME":true,"DOWNLOAD_LINK":true,"SHOW_USERNAME_ACCOUNT_CREATE":true,"SHOW_SCROLL_DOWN_ARROW":true,"SHOW_ADDRESS_ACCOUNT_CREATE":true,"TWO_COLUMN_ACCOUNT_CREATE":true,"RESET_PASSWORD_TIP":"A link to change your password has been sent to your email. Please allow a few minutes for this message to arrive. Please check your junk/spam folders if you do not find the email in your inbox.","FORGOT_PASSWORD_LINK_TEXT":"Reset Password","PHONE_NUMBER_OPTIONAL_ACCOUNT_CREATE":true,"SHOW_REQUIRED_INDICATOR_ACCOUNT_CREATE":true,"PASSWORD_REQUIREMENTS_ACCOUNT_CREATE":"\n    <ul>\n      <li>MUST contain at least 8 characters (12+ recommended)</li>\n      <li>MUST contain at least one uppercase letter.</li>\n      <li>MUST contain at least one lowercase letter.</li>\n      <li>MUST contain at least one number.</li>\n      <li>MUST contain at least one special character (!”#$%&'()*+,-./:;<=>?</li>\n    </ul>\n  ","ALLOW_CERTIFICATION_REQUEST":true,"ALLOW_PUBLIC_CERTIFICATE_REQUEST":true,"ALLOW_COPY_REQUEST":false,"ALLOW_CORRECTION_STYLING":true,"HIDE_DEPRECATION_WARNING":false,"AMEND_ROUTE_PUBLIC":true,"SEAL_FILENAME":"seal.png","SHOPPING_CART":true,"ALLOW_PAYMENT_UPDATE_WITH_EMPTY_CART":true,"RA_EMAIL":true,"RA_WEBSITE":true,"RA_NO_DEFAULT_TYPE":true,"RA_ADDRESS_LABEL":"Street Address","RA_TYPE_SELECTION_DEFAULT":true,"RA_DEFAULT_TYPE":"460","RA_OVERRIDE_TYPE_WITH_DEFAULT":true,"RA_PRINCIPAL_ADDRESS_AMS":true,"UPLOAD_AND_SUBMIT_HIDE_IF_ONE_OPTION":true,"PAYMENT_PROCESSING_MESSAGE":"Your payment is processing - Do not close your browser or click the back button","CHECKOUT_BUTTON_WHEN_PROCESSING_TEXT":"Processing","EFS_CROP_PICKER_NONE_LABEL":"Lien Duration","DISALLOWED_WIZARD_PIECES":["FormationLocale"],"REPEATER_SHOW_EDIT_BUTTON":true,"DATA_REQUEST_PAGE_TITLE":"Data Requests and Subscriptions","DATA_REQUEST_SIDEBAR_LABEL":"Data Requests & Subscriptions","LOGIN_REDIRECTS_TO_EPASS":false,"LOGIN_REDIRECTS_TO_ACTIVE_DIRECTORY":true,"LOGIN_ACTIVE_DIRECTORY_LINK":true,"FETCH_EDIT_USER_LINK":false,"LISTS_FETCH_AVAILABLE_LISTS":true,"POST_WIZARD_SUBMIT_REDIRECT_URL":"/","PIN_REQUEST_ATTESTATIONS":true,"PIN_REQUEST_DESCRIPTION":"Click **Request PIN** to have a new PIN sent to the account holder's email address on file.","OWNERSHIP_REQUEST_DESCRIPTION":"To become an **authorized user** of this record, a current **AUTHORIZED USER** will need to grant you access. To request access, click **Request Access** below.","PIN_REQUEST_SUCCESS_MESSAGE":"The PIN you have requested for this entity has been sent to the email associated with your user account.  You should receive the PIN in approximately 3-5 minutes, depending on your email service provider.","APOSTILLE_HEADER_LABEL":"Verification Information","APOSTILLE_NUMBER_LABEL":"Apostille/Authentication","APOSTILLE_CITY_STATE_OVERRIDE":"HELENA, MT","APOSTILLE_FILING_DATE_LABEL":"Issue Date","APOSTILLE_CITY_STATE_IN_CERTIFIED":true,"NOTARY_EXISTING_FILING":true,"ALLOW_REVOKE_OWN_ACCESS_ONLY":false,"HIDE_CANCEL_ON_ONETIME_DATA_REQUESTS":true,"DATA_REQUESTS_IN_SHOPPING_CART":true,"WQ_ALLOW_EDIT_PENDING_PAYMENT":true,"WQ_CONFIRM_ON_DELETE":true,"WQ_DELETE_CONFIRM_MESSAGE":"Deleting this filing will forfeit any money already paid to the Secretary of State. This action is permanent and cannot be undone, are you sure you would like to delete?","PASS_ITEM_GUIDS_ON_CHECKOUT":true,"FORM_REVISION_HISTORY":true,"CHECKOUT_DISCLAIMER":"By entering your credit card and/or checking account information you (i) state that **you are an authorized user** of the credit card and/or electronic check and that the associated information entered (e.g., account holder name, account number, billing address) is accurate, (ii) **you authorize payment processor to charge the amount you have requested** to your credit card and/or funding account, and (iii) **acknowledge if a charge is declined or reversed you may also be assessed a customary charge** by the payment processor for such transactions.","FARM_BILL_SEARCH_CONFIDENTIAL":"As a registered Farm Bill Buyer with the Montana Secretary of State’s office it is important to maintain the confidentiality of the information contained within the Farm Bill Master List. The Farm Bill Master List reflects personal data, such as Social Security Numbers, which are a key piece of personal identifiable information to assist you in determining the existence of a lien against a specific debtor. The distribution of this information beyond its intended purpose is strictly prohibited.\n\n**The debtor's tax identification number has been hidden for confidentiality reasons. You may continue to search on a tax ID number and return debtors that match your search criteria. The SSN/FEIN must be entered without dashes or spaces.  If you need access to the tax identification number to clearly identify the debtor, please contact the UCC unit at (406) 444-3665.**","VIEW_HISTORY_BUTTON_ALT_TEXT":"View Filings","WIZARD_ERROR_TITLE_MESSAGE":"Form Error","FARM_BILL_SEARCH_INTERACTIVE":true,"USE_FARM_BILL_API":true,"DISALLOW_ASSIGN_SELF_AS_RA":true,"DISALLOW_ASSIGN_SELF_AS_PRINCIPAL":true,"USE_TRADEMARK_OWNER_VALIDATION":true,"USE_ALTERNATIVE_FOREIGN_ADDRESS_LABELS":true,"MY_RECEIPTS_FILTER":[{"type":"dateRange","name":"DATE_RANGE","label":"Date range","defaultValue":{"start":null,"end":null}},{"type":"text","name":"REF_NUM","defaultValue":"","label":"Reference Number"},{"type":"text","name":"RECEIPT_NUM","defaultValue":"","label":"Receipt Id"},{"type":"text","name":"AMOUNT","defaultValue":"","label":"Amount"},{"type":"select","name":"TYPE","defaultValue":"","label":"Payment Type","options":[{"value":"","label":"All"},{"value":"CC","label":"Credit Card"},{"value":"Check","label":"Check"}]}],"MY_RECEIPTS_SHOW_IN_SIDEBAR":true,"SHOW_MY_RECEIPTS_HELPER_TEXT":true,"MY_RECEIPTS_HELPER_LABEL":"About Receipt Search","MY_RECEIPTS_HELPER_TEXT":"You can search for receipts based on their descriptions, including the items paid for on the receipt. Use the filters to search for or filter specific information.","FARM_BILL_SUBLINK":{"label":"Farm Bill","component":"FarmBill","parameter":"farm-bill","path":"/lists/farm-bill","sourceTypeId":0,"myRecordsSearch":false,"allowedRules":["/search/"],"disabled":true,"searchDescription":"To perform a search, enter a debtor name. Your search results may include: exact debtor name, variations of that name and any filing that includes your search criteria. Punctuation is ignored.\n\nYou can click on \"Advanced\" to refine your search. Under “Advanced” you can search by crop, year, county and SSN/FEIN. As a registered Farm Bill Buyer with the Montana Secretary of State’s office it is important to maintain the confidentiality of the information contained within the Farm Bill Master List. The Farm Bill Master List reflects personal data, such as Social Security Numbers, which are a key piece of personal identifiable information to assist you in determining the existence of a lien against a specific debtor. The distribution of this information beyond its intended purpose is strictly prohibited.\n\nThe debtor's tax identification number has been hidden for confidentiality reasons. You may continue to search on a tax ID number and return debtors that match your search criteria. The SSN/FEIN must be entered without dashes or spaces.","searchMustHaveOneOf":["search","UCC_FARM_PRODUCT_ID","COUNTY"],"searchPlaceholder":"Search by debtor name","advancedSearchParameters":[{"type":"ServerMultiComplete","label":"Product code name(s)","name":"UCC_FARM_PRODUCT_ID","defaultValue":"","optionsSrc":"UCC_FARM_PRODUCT_V"},{"type":"MultiComplete","label":"Year or Range of Years","name":"YEAR_NUM","optionsSrc":"years","startYear":"1968","defaultValue":[],"preMergeOptions":[{"value":"ALL","label":"All"}]},{"type":"serverSelect","label":"State","name":"STATE","defaultValue":"MONTANA","optionsSrc":"STATE"},{"type":"ServerMultiComplete","label":"County","name":"COUNTY","defaultValue":[],"optionsSrc":"COUNTY","overrideSubOptionsSrcFromParameterName":"STATE"},{"type":"checkbox","name":"TIN_SEARCH_YN","defaultValue":false,"label":"Tax Identification Number Search"},{"type":"checkbox","name":"TIN_SORT_YN","defaultValue":false,"label":"Unique ID Sort"}]},"ALLOW_ADDRESS_VALIDATION_BYPASS_OPTION":true,"DEFAULT_ADDRESS_VALIDATION_BYPASS_OPTION_CHECKED":true}).THIRD_PARTY_SIGNATURE_DEFAULT_DATE ? ({"NODE_ENV":"production","BUILD_DATE":"2025-08-27T15:15:31.687Z","BUILD_NUMBER":"Not Provided","GIT_VERSION":"v1.3.0-381-ga81e29b08","GIT_COMMIT_HASH":"a81e29b085c9268ffd96c78eb734365802722741","GIT_BRANCH":"beta","PUBLIC_URL":"","STATE_ABBR":"MT","STATE_NAME":"Montana","STATE_ORG_TITLE":"Secretary of State","LOGIN_HEADER_IMG_PATH":"","HOME_IMG_FILENAME":"montana.jpg","FAVICON_FILE_NAME":"favicon.ico","ALLOW_E_SIGN_ON_CORRECTIONS":true,"THIRD_PARTY_SIGNING_ALLOWED":false,"MY_ACCOUNT_SAVE_AND_CLOSE_BUTTON":true,"IE_DEPRECATED_MESSAGE":"Internet Explorer is not supported. Please select a supported browser below to access this website.","ADDITIONAL_ROUTES":{"dataRequests":true,"farmBill":true,"apostille":true,"externalHelp":"https://sosmt.gov/business/help-center/","systemAdministration":[{"title":"Saved Payments","parameter":"saved-payments","componentName":"SavedPayments"}]},"SUBROUTES":[{"label":"Business","component":"Business","parameter":"business","myWorkQueueSearch":false,"sourceTypeId":54,"searchMustHaveOneOf":["FILING_TYPE_ID","STATUS_ID","STATE","search"],"serverWebSearchDescription":true,"serverWorkQueueDescription":true,"serverMyRecordsDescription":true,"searchPlaceholder":"Search by name or filing number (X########)","allowEmptySearchTerm":true,"requestCertificateAlternateLabel":"Request Information","fileAmendmentButtonLabel":"Filing Actions","advancedSearchParameters":[{"type":"radio","name":"QUERY_TYPE_ID","defaultValue":1010,"options":[{"value":1010,"label":"Starts with"},{"value":1011,"label":"Contains"},{"value":1012,"label":" Word Contains"}]},{"type":"serverSelect","name":"FILING_TYPE_ID","optionsSrc":"FILING_TYPES","label":"Entity Type","placeholder":"All","defaultValue":"0"},{"type":"serverSelect","name":"FILING_SUBTYPE_ID","optionsSrc":"FILING_SUBTYPES","label":"Entity Subtype","overrideSubOptionsSrcFromParameterName":"FILING_TYPE_ID","placeholder":"All","defaultValue":"0"},{"type":"serverSelect","name":"STATUS_ID","optionsSrc":"FILING_STATUS_WITHOUT_ALL","label":"Status","placeholder":"All","defaultValue":"0"},{"type":"serverSelect","name":"STATE","optionsSrc":"STATE","label":"State","placeholder":"All","defaultValue":""},{"type":"serverSelect","name":"COUNTY","optionsSrc":"COUNTY_SUBOPTION","label":"County","overrideSubOptionsSrcFromParameterName":"STATE","placeholder":"All","defaultValue":""},{"type":"checkbox","name":"CRA_SEARCH_YN","defaultValue":false,"label":"Search by Registered Agent PID"},{"type":"dateRange","name":"FILING_DATE","label":"Registration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}},{"type":"dateRange","name":"EXPIRATION_DATE","label":"Expiration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}}],"myRecordsFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Active"},{"value":2,"label":"Inactive"},{"value":3,"label":"Pending"}]},{"type":"dateRange","name":"DATE_RANGE","label":"Date range","defaultValue":{"start":null,"end":null}}],"myWorkQueueFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Approved"},{"value":2,"label":"Pending Online Payment"},{"value":3,"label":"Pending Review"},{"value":4,"label":"Needs Correction"},{"value":5,"label":"Rejected"},{"value":6,"label":"Draft"}]},{"type":"dateRange","name":"DATE_RANGE","label":"Date range","defaultValue":{"start":null,"end":null}}]},{"label":"Notary","component":"Notary","parameter":"notary","sourceTypeId":850,"myWorkQueueSearch":false,"allowEmptySearchTerm":true,"requestCertificateAlternateLabel":"Download Certificate","fileAmendmentButtonLabel":"Filing Actions","hideNameRequestCertificate":true,"hideAddressRequestCertificate":true,"hideRecordUserManagment":true,"searchPlaceholder":"Search by name or commission number","searchMustHaveOneOf":["CITY","search","SERVICE_TYPE"],"advancedParametersStartOpen":true,"searchIsSortable":true,"advancedSearchParameters":[{"type":"radio","name":"STARTS_WITH_YN","defaultValue":false,"options":[{"value":true,"label":"Starts with"},{"value":false,"label":"Contains"}]},{"type":"checkbox","name":"ACTIVE_ONLY_YN","defaultValue":true,"label":"Active entities only"},{"type":"text","name":"CITY","defaultValue":"","label":"City"},{"type":"select","name":"SERVICE_TYPE","label":"Special Services Offered","defaultValue":0,"options":[{"value":0,"label":"(N/A)"},{"value":6165,"label":"In-Person Electronic Notarization (IPEN)"},{"value":6166,"label":"Remote Online Notarization (RON)"},{"value":6167,"label":"Mobile Notary Services"},{"value":6168,"label":"Remote Ink Notarization (RIN)"}]}]},{"label":"Apostille","component":"Apostille","parameter":"apostille","sourceTypeId":720,"myRecordsSearch":false,"myWorkQueueSearch":false,"disabled":false,"allowedRoutes":["/forms-manager/","/queue/","/forms/"]},{"label":"Liens","component":"UCC","parameter":"ucc","sourceTypeId":1999,"myRecordsSearch":true,"myWorkQueueSearch":true,"fileAmendmentButtonLabel":"Filing Actions","searchPlaceholder":"Search by name or file number","disabled":false,"serverWebSearchDescription":true,"myRecordsDescription":"","workQueueDescription":"","searchDescription":"","hideRecordUserManagment":true,"searchLiensCheckout":false,"advancedSearchParameters":[{"type":"radio","name":"STARTS_WITH_YN","defaultValue":false,"options":[{"value":true,"label":"Starts with"},{"value":false,"label":"Contains"}]},{"type":"select","name":"STATUS","defaultValue":"ALL","label":"Status","options":[{"value":"ACTIVE_UNLAPSED","label":"Active (unlapsed)"},{"value":"ACTIVE_LAPSED_UNLAPSED","label":"Active (lapsed and unlapsed)"}]},{"type":"text","name":"EXCLUDE_VALUES","label":"Exclude Debtor Names (comma separated list of names to exclude)","defaultValue":""},{"type":"dateRange","name":"FILING_DATE","label":"Financing Statement Date","defaultValue":{"start":null,"end":null}},{"type":"dateRange","name":"LAPSE_DATE","label":"Lapse Date","defaultValue":{"start":null,"end":null}},{"type":"text","name":"CITY","label":"Debtor City","defaultValue":""}],"myRecordsFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Approved"},{"value":2,"label":"Pending Online Payment"},{"value":3,"label":"Pending Review"}]},{"type":"select","name":"TYPE","defaultValue":0,"label":"Lien Type","options":[{"value":0,"label":"All"},{"value":1,"label":"UCC"},{"value":2,"label":"EFS"},{"value":3,"label":"Title 71"}]}],"myWorkQueueFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Approved"},{"value":2,"label":"Pending Online Payment"},{"value":3,"label":"Pending Review"},{"value":4,"label":"Pending Print and Mail"},{"value":5,"label":"Rejected"},{"value":6,"label":"Draft"}]},{"type":"select","name":"TYPE","defaultValue":0,"label":"Lien Type","options":[{"value":0,"label":"All"},{"value":1,"label":"UCC"},{"value":2,"label":"EFS"},{"value":3,"label":"Title 71"}]}]},{"label":"Copy Request","component":"copies","parameter":"copies","sourceTypeId":2001,"myRecordsSearch":false,"myWorkQueueSearch":false,"disabled":false,"allowedRoutes":["/forms-manager/","/queue/","/forms/"]},{"label":"Trademark","component":"Trademark","parameter":"trademark","sourceTypeId":810,"showRequestCertificate":true,"searchMustHaveOneOf":["search","EXPIRATION_DATE","FILING_DATE"],"allowEmptySearchTerm":true,"requestCertificateAlternateLabel":"Request Information","fileAmendmentButtonLabel":"Filing Actions","advancedSearchParameters":[{"type":"radio","name":"QUERY_TYPE_ID","defaultValue":1010,"options":[{"value":1010,"label":"Starts with"},{"value":1011,"label":"Contains"},{"value":1012,"label":" Word Contains"}]},{"type":"checkbox","name":"OWNER_SEARCH_YN","defaultValue":false,"label":"Search owners"},{"type":"radio","name":"SERVICE_MARK_YN","label":"Mark Type","defaultValue":"","options":[{"value":"","label":"All Marks"},{"value":"Y","label":"Service Mark"},{"value":"N","label":"Trademark"}]},{"type":"serverSelect","name":"STATUS_ID","optionsSrc":"TYPE_V|TRADEMARK_STATUS_TYPE","label":"Status","placeholder":"All","defaultValue":"0"},{"type":"select","name":"DESIGN_TYPE_ID","options":[{"value":0,"label":"All"},{"value":990,"label":"Words Only"},{"value":991,"label":"Design Only"},{"value":992,"label":"Words and Design"}],"label":"Design Type","defaultValue":"0"},{"type":"dateRange","name":"FILING_DATE","label":"Registered Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}},{"type":"dateRange","name":"EXPIRATION_DATE","label":"Expiration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}}]},{"label":"Business Info Request","component":"InfoRequests","parameter":"info-request","sourceTypeId":167,"allowedRoutes":["/forms-manager/","/queue/","/forms/"]},{"label":"Data Requests","component":"DataRequests","parameter":"data-request","sourceTypeId":0,"allowedRoutes":["/forms-manager/"]},{"label":"CRA","component":"CRA","parameter":"cra","sourceTypeId":157,"myRecordsSearch":false,"searchPlaceholder":"Search by name or registered agent number","allowedRoutes":["/forms-manager/","/forms/","/records/","/queue/","/search/"],"allowEmptySearchTerm":true,"fileAmendmentButtonLabel":"Filing Actions","advancedSearchParameters":[{"type":"radio","name":"QUERY_TYPE_ID","defaultValue":1010,"options":[{"value":1010,"label":"Starts with"},{"value":1011,"label":"Contains"},{"value":1012,"label":" Word Contains"}]},{"type":"dateRange","name":"CRA_DATE","label":"Registration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}},{"type":"select","name":"STATUS_ID","label":"Status","defaultValue":0,"options":[{"value":0,"label":"All"},{"value":121,"label":"Active"},{"value":122,"label":"Inactive"}]},{"type":"select","name":"AGENT_TYPE_ID","label":"Agent Type","defaultValue":0,"options":[{"value":0,"label":"All"},{"value":460,"label":"Registered Agent"},{"value":461,"label":"Commercial Registered Agent"}]}]},{"label":"Farm Bill","component":"FarmBill","parameter":"farm-bill","path":"/lists/farm-bill","sourceTypeId":0,"myRecordsSearch":false,"allowedRules":["/search/"],"disabled":true,"searchDescription":"To perform a search, enter a debtor name. Your search results may include: exact debtor name, variations of that name and any filing that includes your search criteria. Punctuation is ignored.\n\nYou can click on \"Advanced\" to refine your search. Under “Advanced” you can search by crop, year, county and SSN/FEIN. As a registered Farm Bill Buyer with the Montana Secretary of State’s office it is important to maintain the confidentiality of the information contained within the Farm Bill Master List. The Farm Bill Master List reflects personal data, such as Social Security Numbers, which are a key piece of personal identifiable information to assist you in determining the existence of a lien against a specific debtor. The distribution of this information beyond its intended purpose is strictly prohibited.\n\nThe debtor's tax identification number has been hidden for confidentiality reasons. You may continue to search on a tax ID number and return debtors that match your search criteria. The SSN/FEIN must be entered without dashes or spaces.","searchMustHaveOneOf":["search","UCC_FARM_PRODUCT_ID","COUNTY"],"searchPlaceholder":"Search by debtor name","advancedSearchParameters":[{"type":"ServerMultiComplete","label":"Product code name(s)","name":"UCC_FARM_PRODUCT_ID","defaultValue":"","optionsSrc":"UCC_FARM_PRODUCT_V"},{"type":"MultiComplete","label":"Year or Range of Years","name":"YEAR_NUM","optionsSrc":"years","startYear":"1968","defaultValue":[],"preMergeOptions":[{"value":"ALL","label":"All"}]},{"type":"serverSelect","label":"State","name":"STATE","defaultValue":"MONTANA","optionsSrc":"STATE"},{"type":"ServerMultiComplete","label":"County","name":"COUNTY","defaultValue":[],"optionsSrc":"COUNTY","overrideSubOptionsSrcFromParameterName":"STATE"},{"type":"checkbox","name":"TIN_SEARCH_YN","defaultValue":false,"label":"Tax Identification Number Search"},{"type":"checkbox","name":"TIN_SORT_YN","defaultValue":false,"label":"Unique ID Sort"}]}],"SYSTEM_NICKNAME":"Online Services Portal","PAYMENT_METHODS":[{"type":"bypass"},{"type":"iTransact"}],"PAYMENT_ALLOW_AMEX":true,"SYSTEM_ID_LABEL":"System Id","DOUBLE_COLUMN_PUBLIC_LOGIN":true,"INTERNAL_USER_MANAGEMENT":true,"ALLOW_PUBLIC_JSON_IMPORT":false,"MAX_FILE_UPLOAD_SIZE":10000000,"REFUND_TEXT":"","RETURN_TO_HOME_ON_LOGOUT":true,"CURRENT_SOS_NAME":"Christi Jacobsen","LOGO_FILENAME":"mt-sos-logo.png","LOGO_ALT":"Christi Jacobsen, Montana Secretary of State","LOGO_FULL_WIDTH":true,"HOME_HIDE_AUTH_HINT":true,"HOME_TITLE":"Montana Secretary of State","CUSTOM_TAB_TITLE":"Official Montana","HOME_SUBTITLE":"Online Business Services","ENTITY_NAME_CONSENT_DESCRIPTION":"","ALLOW_USER_PROFILE_EDITING":true,"COMPARE_FOREIGN_NAME_IN_ENTITY_NAME_VALIDATION":true,"FOREIGN_NAME_FIELD_NAME":"KIMA_PARENT_NAME_INFO","LOGIN_TITLE":"Montana Secretary of State Online Filing Portal Login","PUBLIC_LOGIN_LABEL":"Username","REVERSE_LOGIN_COLUMNS":true,"LOGIN_SEAL_FILENAME":"seal_white.png","SEPARATE_USERNAME_AND_EMAIL":true,"CREATE_ACCOUNT_BUTTON_ALIGN_LEFT":true,"CREATE_ACCOUNT_BUTTON_TEXT":"CREATE AN ACCOUNT","PASSWORD_CUSTOM_ERROR_TEXT":"The password must meet all requirements","ACCOUNT_CREATED_MESSAGE":"Please check your email to verify your account to login and allow a few minutes for this message to arrive. Check your junk/spam folders if you do not find the email in your inbox.","PUBLIC_LOGIN_PLACEHOLDER":" ","DISABLE_DEFAULT_PAYMENT_RADIO":true,"CUSTOM_RESET_PASSWORD_ERROR_MESSAGE":"Username invalid - no account found","PUBLIC_LOGIN_CREATE_DESCRIPTION":"### Existing User:\n\n  - Enter your username and password to login.  \n\n\n  #### - OR -  \n\n\n\n  - Forgot password? Click 'Reset Password' and follow the prompts.\n  - Forgot username? Click 'Forgot Username' and follow the prompts.  \n\n\n  ### New User:\n  ","LOGIN_HELP_LINK":"https://sosmt.gov/business/how-do-i/","LOGIN_HELP_LINK_TEXT":"Need Help?","FORGOT_USERNAME_TEXT":"Forgot Username?","LOGIN_ACTIVE_DIRECTORY_TEXT":"State User Login","MULTIPLE_LOGIN_METHODS":true,"HAS_ACTIVE_DIRECTORY_LOGIN":true,"RESET_PASSWORD_WITH_USERNAME":true,"DOWNLOAD_LINK":true,"SHOW_USERNAME_ACCOUNT_CREATE":true,"SHOW_SCROLL_DOWN_ARROW":true,"SHOW_ADDRESS_ACCOUNT_CREATE":true,"TWO_COLUMN_ACCOUNT_CREATE":true,"RESET_PASSWORD_TIP":"A link to change your password has been sent to your email. Please allow a few minutes for this message to arrive. Please check your junk/spam folders if you do not find the email in your inbox.","FORGOT_PASSWORD_LINK_TEXT":"Reset Password","PHONE_NUMBER_OPTIONAL_ACCOUNT_CREATE":true,"SHOW_REQUIRED_INDICATOR_ACCOUNT_CREATE":true,"PASSWORD_REQUIREMENTS_ACCOUNT_CREATE":"\n    <ul>\n      <li>MUST contain at least 8 characters (12+ recommended)</li>\n      <li>MUST contain at least one uppercase letter.</li>\n      <li>MUST contain at least one lowercase letter.</li>\n      <li>MUST contain at least one number.</li>\n      <li>MUST contain at least one special character (!”#$%&'()*+,-./:;<=>?</li>\n    </ul>\n  ","ALLOW_CERTIFICATION_REQUEST":true,"ALLOW_PUBLIC_CERTIFICATE_REQUEST":true,"ALLOW_COPY_REQUEST":false,"ALLOW_CORRECTION_STYLING":true,"HIDE_DEPRECATION_WARNING":false,"AMEND_ROUTE_PUBLIC":true,"SEAL_FILENAME":"seal.png","SHOPPING_CART":true,"ALLOW_PAYMENT_UPDATE_WITH_EMPTY_CART":true,"RA_EMAIL":true,"RA_WEBSITE":true,"RA_NO_DEFAULT_TYPE":true,"RA_ADDRESS_LABEL":"Street Address","RA_TYPE_SELECTION_DEFAULT":true,"RA_DEFAULT_TYPE":"460","RA_OVERRIDE_TYPE_WITH_DEFAULT":true,"RA_PRINCIPAL_ADDRESS_AMS":true,"UPLOAD_AND_SUBMIT_HIDE_IF_ONE_OPTION":true,"PAYMENT_PROCESSING_MESSAGE":"Your payment is processing - Do not close your browser or click the back button","CHECKOUT_BUTTON_WHEN_PROCESSING_TEXT":"Processing","EFS_CROP_PICKER_NONE_LABEL":"Lien Duration","DISALLOWED_WIZARD_PIECES":["FormationLocale"],"REPEATER_SHOW_EDIT_BUTTON":true,"DATA_REQUEST_PAGE_TITLE":"Data Requests and Subscriptions","DATA_REQUEST_SIDEBAR_LABEL":"Data Requests & Subscriptions","LOGIN_REDIRECTS_TO_EPASS":false,"LOGIN_REDIRECTS_TO_ACTIVE_DIRECTORY":true,"LOGIN_ACTIVE_DIRECTORY_LINK":true,"FETCH_EDIT_USER_LINK":false,"LISTS_FETCH_AVAILABLE_LISTS":true,"POST_WIZARD_SUBMIT_REDIRECT_URL":"/","PIN_REQUEST_ATTESTATIONS":true,"PIN_REQUEST_DESCRIPTION":"Click **Request PIN** to have a new PIN sent to the account holder's email address on file.","OWNERSHIP_REQUEST_DESCRIPTION":"To become an **authorized user** of this record, a current **AUTHORIZED USER** will need to grant you access. To request access, click **Request Access** below.","PIN_REQUEST_SUCCESS_MESSAGE":"The PIN you have requested for this entity has been sent to the email associated with your user account.  You should receive the PIN in approximately 3-5 minutes, depending on your email service provider.","APOSTILLE_HEADER_LABEL":"Verification Information","APOSTILLE_NUMBER_LABEL":"Apostille/Authentication","APOSTILLE_CITY_STATE_OVERRIDE":"HELENA, MT","APOSTILLE_FILING_DATE_LABEL":"Issue Date","APOSTILLE_CITY_STATE_IN_CERTIFIED":true,"NOTARY_EXISTING_FILING":true,"ALLOW_REVOKE_OWN_ACCESS_ONLY":false,"HIDE_CANCEL_ON_ONETIME_DATA_REQUESTS":true,"DATA_REQUESTS_IN_SHOPPING_CART":true,"WQ_ALLOW_EDIT_PENDING_PAYMENT":true,"WQ_CONFIRM_ON_DELETE":true,"WQ_DELETE_CONFIRM_MESSAGE":"Deleting this filing will forfeit any money already paid to the Secretary of State. This action is permanent and cannot be undone, are you sure you would like to delete?","PASS_ITEM_GUIDS_ON_CHECKOUT":true,"FORM_REVISION_HISTORY":true,"CHECKOUT_DISCLAIMER":"By entering your credit card and/or checking account information you (i) state that **you are an authorized user** of the credit card and/or electronic check and that the associated information entered (e.g., account holder name, account number, billing address) is accurate, (ii) **you authorize payment processor to charge the amount you have requested** to your credit card and/or funding account, and (iii) **acknowledge if a charge is declined or reversed you may also be assessed a customary charge** by the payment processor for such transactions.","FARM_BILL_SEARCH_CONFIDENTIAL":"As a registered Farm Bill Buyer with the Montana Secretary of State’s office it is important to maintain the confidentiality of the information contained within the Farm Bill Master List. The Farm Bill Master List reflects personal data, such as Social Security Numbers, which are a key piece of personal identifiable information to assist you in determining the existence of a lien against a specific debtor. The distribution of this information beyond its intended purpose is strictly prohibited.\n\n**The debtor's tax identification number has been hidden for confidentiality reasons. You may continue to search on a tax ID number and return debtors that match your search criteria. The SSN/FEIN must be entered without dashes or spaces.  If you need access to the tax identification number to clearly identify the debtor, please contact the UCC unit at (406) 444-3665.**","VIEW_HISTORY_BUTTON_ALT_TEXT":"View Filings","WIZARD_ERROR_TITLE_MESSAGE":"Form Error","FARM_BILL_SEARCH_INTERACTIVE":true,"USE_FARM_BILL_API":true,"DISALLOW_ASSIGN_SELF_AS_RA":true,"DISALLOW_ASSIGN_SELF_AS_PRINCIPAL":true,"USE_TRADEMARK_OWNER_VALIDATION":true,"USE_ALTERNATIVE_FOREIGN_ADDRESS_LABELS":true,"MY_RECEIPTS_FILTER":[{"type":"dateRange","name":"DATE_RANGE","label":"Date range","defaultValue":{"start":null,"end":null}},{"type":"text","name":"REF_NUM","defaultValue":"","label":"Reference Number"},{"type":"text","name":"RECEIPT_NUM","defaultValue":"","label":"Receipt Id"},{"type":"text","name":"AMOUNT","defaultValue":"","label":"Amount"},{"type":"select","name":"TYPE","defaultValue":"","label":"Payment Type","options":[{"value":"","label":"All"},{"value":"CC","label":"Credit Card"},{"value":"Check","label":"Check"}]}],"MY_RECEIPTS_SHOW_IN_SIDEBAR":true,"SHOW_MY_RECEIPTS_HELPER_TEXT":true,"MY_RECEIPTS_HELPER_LABEL":"About Receipt Search","MY_RECEIPTS_HELPER_TEXT":"You can search for receipts based on their descriptions, including the items paid for on the receipt. Use the filters to search for or filter specific information.","FARM_BILL_SUBLINK":{"label":"Farm Bill","component":"FarmBill","parameter":"farm-bill","path":"/lists/farm-bill","sourceTypeId":0,"myRecordsSearch":false,"allowedRules":["/search/"],"disabled":true,"searchDescription":"To perform a search, enter a debtor name. Your search results may include: exact debtor name, variations of that name and any filing that includes your search criteria. Punctuation is ignored.\n\nYou can click on \"Advanced\" to refine your search. Under “Advanced” you can search by crop, year, county and SSN/FEIN. As a registered Farm Bill Buyer with the Montana Secretary of State’s office it is important to maintain the confidentiality of the information contained within the Farm Bill Master List. The Farm Bill Master List reflects personal data, such as Social Security Numbers, which are a key piece of personal identifiable information to assist you in determining the existence of a lien against a specific debtor. The distribution of this information beyond its intended purpose is strictly prohibited.\n\nThe debtor's tax identification number has been hidden for confidentiality reasons. You may continue to search on a tax ID number and return debtors that match your search criteria. The SSN/FEIN must be entered without dashes or spaces.","searchMustHaveOneOf":["search","UCC_FARM_PRODUCT_ID","COUNTY"],"searchPlaceholder":"Search by debtor name","advancedSearchParameters":[{"type":"ServerMultiComplete","label":"Product code name(s)","name":"UCC_FARM_PRODUCT_ID","defaultValue":"","optionsSrc":"UCC_FARM_PRODUCT_V"},{"type":"MultiComplete","label":"Year or Range of Years","name":"YEAR_NUM","optionsSrc":"years","startYear":"1968","defaultValue":[],"preMergeOptions":[{"value":"ALL","label":"All"}]},{"type":"serverSelect","label":"State","name":"STATE","defaultValue":"MONTANA","optionsSrc":"STATE"},{"type":"ServerMultiComplete","label":"County","name":"COUNTY","defaultValue":[],"optionsSrc":"COUNTY","overrideSubOptionsSrcFromParameterName":"STATE"},{"type":"checkbox","name":"TIN_SEARCH_YN","defaultValue":false,"label":"Tax Identification Number Search"},{"type":"checkbox","name":"TIN_SORT_YN","defaultValue":false,"label":"Unique ID Sort"}]},"ALLOW_ADDRESS_VALIDATION_BYPASS_OPTION":true,"DEFAULT_ADDRESS_VALIDATION_BYPASS_OPTION_CHECKED":true}).STATE_TIMEZONE ? (0, _dateFns.format)(new Date(new Date().toLocaleString('en-US', { timeZone: ({"NODE_ENV":"production","BUILD_DATE":"2025-08-27T15:15:31.687Z","BUILD_NUMBER":"Not Provided","GIT_VERSION":"v1.3.0-381-ga81e29b08","GIT_COMMIT_HASH":"a81e29b085c9268ffd96c78eb734365802722741","GIT_BRANCH":"beta","PUBLIC_URL":"","STATE_ABBR":"MT","STATE_NAME":"Montana","STATE_ORG_TITLE":"Secretary of State","LOGIN_HEADER_IMG_PATH":"","HOME_IMG_FILENAME":"montana.jpg","FAVICON_FILE_NAME":"favicon.ico","ALLOW_E_SIGN_ON_CORRECTIONS":true,"THIRD_PARTY_SIGNING_ALLOWED":false,"MY_ACCOUNT_SAVE_AND_CLOSE_BUTTON":true,"IE_DEPRECATED_MESSAGE":"Internet Explorer is not supported. Please select a supported browser below to access this website.","ADDITIONAL_ROUTES":{"dataRequests":true,"farmBill":true,"apostille":true,"externalHelp":"https://sosmt.gov/business/help-center/","systemAdministration":[{"title":"Saved Payments","parameter":"saved-payments","componentName":"SavedPayments"}]},"SUBROUTES":[{"label":"Business","component":"Business","parameter":"business","myWorkQueueSearch":false,"sourceTypeId":54,"searchMustHaveOneOf":["FILING_TYPE_ID","STATUS_ID","STATE","search"],"serverWebSearchDescription":true,"serverWorkQueueDescription":true,"serverMyRecordsDescription":true,"searchPlaceholder":"Search by name or filing number (X########)","allowEmptySearchTerm":true,"requestCertificateAlternateLabel":"Request Information","fileAmendmentButtonLabel":"Filing Actions","advancedSearchParameters":[{"type":"radio","name":"QUERY_TYPE_ID","defaultValue":1010,"options":[{"value":1010,"label":"Starts with"},{"value":1011,"label":"Contains"},{"value":1012,"label":" Word Contains"}]},{"type":"serverSelect","name":"FILING_TYPE_ID","optionsSrc":"FILING_TYPES","label":"Entity Type","placeholder":"All","defaultValue":"0"},{"type":"serverSelect","name":"FILING_SUBTYPE_ID","optionsSrc":"FILING_SUBTYPES","label":"Entity Subtype","overrideSubOptionsSrcFromParameterName":"FILING_TYPE_ID","placeholder":"All","defaultValue":"0"},{"type":"serverSelect","name":"STATUS_ID","optionsSrc":"FILING_STATUS_WITHOUT_ALL","label":"Status","placeholder":"All","defaultValue":"0"},{"type":"serverSelect","name":"STATE","optionsSrc":"STATE","label":"State","placeholder":"All","defaultValue":""},{"type":"serverSelect","name":"COUNTY","optionsSrc":"COUNTY_SUBOPTION","label":"County","overrideSubOptionsSrcFromParameterName":"STATE","placeholder":"All","defaultValue":""},{"type":"checkbox","name":"CRA_SEARCH_YN","defaultValue":false,"label":"Search by Registered Agent PID"},{"type":"dateRange","name":"FILING_DATE","label":"Registration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}},{"type":"dateRange","name":"EXPIRATION_DATE","label":"Expiration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}}],"myRecordsFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Active"},{"value":2,"label":"Inactive"},{"value":3,"label":"Pending"}]},{"type":"dateRange","name":"DATE_RANGE","label":"Date range","defaultValue":{"start":null,"end":null}}],"myWorkQueueFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Approved"},{"value":2,"label":"Pending Online Payment"},{"value":3,"label":"Pending Review"},{"value":4,"label":"Needs Correction"},{"value":5,"label":"Rejected"},{"value":6,"label":"Draft"}]},{"type":"dateRange","name":"DATE_RANGE","label":"Date range","defaultValue":{"start":null,"end":null}}]},{"label":"Notary","component":"Notary","parameter":"notary","sourceTypeId":850,"myWorkQueueSearch":false,"allowEmptySearchTerm":true,"requestCertificateAlternateLabel":"Download Certificate","fileAmendmentButtonLabel":"Filing Actions","hideNameRequestCertificate":true,"hideAddressRequestCertificate":true,"hideRecordUserManagment":true,"searchPlaceholder":"Search by name or commission number","searchMustHaveOneOf":["CITY","search","SERVICE_TYPE"],"advancedParametersStartOpen":true,"searchIsSortable":true,"advancedSearchParameters":[{"type":"radio","name":"STARTS_WITH_YN","defaultValue":false,"options":[{"value":true,"label":"Starts with"},{"value":false,"label":"Contains"}]},{"type":"checkbox","name":"ACTIVE_ONLY_YN","defaultValue":true,"label":"Active entities only"},{"type":"text","name":"CITY","defaultValue":"","label":"City"},{"type":"select","name":"SERVICE_TYPE","label":"Special Services Offered","defaultValue":0,"options":[{"value":0,"label":"(N/A)"},{"value":6165,"label":"In-Person Electronic Notarization (IPEN)"},{"value":6166,"label":"Remote Online Notarization (RON)"},{"value":6167,"label":"Mobile Notary Services"},{"value":6168,"label":"Remote Ink Notarization (RIN)"}]}]},{"label":"Apostille","component":"Apostille","parameter":"apostille","sourceTypeId":720,"myRecordsSearch":false,"myWorkQueueSearch":false,"disabled":false,"allowedRoutes":["/forms-manager/","/queue/","/forms/"]},{"label":"Liens","component":"UCC","parameter":"ucc","sourceTypeId":1999,"myRecordsSearch":true,"myWorkQueueSearch":true,"fileAmendmentButtonLabel":"Filing Actions","searchPlaceholder":"Search by name or file number","disabled":false,"serverWebSearchDescription":true,"myRecordsDescription":"","workQueueDescription":"","searchDescription":"","hideRecordUserManagment":true,"searchLiensCheckout":false,"advancedSearchParameters":[{"type":"radio","name":"STARTS_WITH_YN","defaultValue":false,"options":[{"value":true,"label":"Starts with"},{"value":false,"label":"Contains"}]},{"type":"select","name":"STATUS","defaultValue":"ALL","label":"Status","options":[{"value":"ACTIVE_UNLAPSED","label":"Active (unlapsed)"},{"value":"ACTIVE_LAPSED_UNLAPSED","label":"Active (lapsed and unlapsed)"}]},{"type":"text","name":"EXCLUDE_VALUES","label":"Exclude Debtor Names (comma separated list of names to exclude)","defaultValue":""},{"type":"dateRange","name":"FILING_DATE","label":"Financing Statement Date","defaultValue":{"start":null,"end":null}},{"type":"dateRange","name":"LAPSE_DATE","label":"Lapse Date","defaultValue":{"start":null,"end":null}},{"type":"text","name":"CITY","label":"Debtor City","defaultValue":""}],"myRecordsFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Approved"},{"value":2,"label":"Pending Online Payment"},{"value":3,"label":"Pending Review"}]},{"type":"select","name":"TYPE","defaultValue":0,"label":"Lien Type","options":[{"value":0,"label":"All"},{"value":1,"label":"UCC"},{"value":2,"label":"EFS"},{"value":3,"label":"Title 71"}]}],"myWorkQueueFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Approved"},{"value":2,"label":"Pending Online Payment"},{"value":3,"label":"Pending Review"},{"value":4,"label":"Pending Print and Mail"},{"value":5,"label":"Rejected"},{"value":6,"label":"Draft"}]},{"type":"select","name":"TYPE","defaultValue":0,"label":"Lien Type","options":[{"value":0,"label":"All"},{"value":1,"label":"UCC"},{"value":2,"label":"EFS"},{"value":3,"label":"Title 71"}]}]},{"label":"Copy Request","component":"copies","parameter":"copies","sourceTypeId":2001,"myRecordsSearch":false,"myWorkQueueSearch":false,"disabled":false,"allowedRoutes":["/forms-manager/","/queue/","/forms/"]},{"label":"Trademark","component":"Trademark","parameter":"trademark","sourceTypeId":810,"showRequestCertificate":true,"searchMustHaveOneOf":["search","EXPIRATION_DATE","FILING_DATE"],"allowEmptySearchTerm":true,"requestCertificateAlternateLabel":"Request Information","fileAmendmentButtonLabel":"Filing Actions","advancedSearchParameters":[{"type":"radio","name":"QUERY_TYPE_ID","defaultValue":1010,"options":[{"value":1010,"label":"Starts with"},{"value":1011,"label":"Contains"},{"value":1012,"label":" Word Contains"}]},{"type":"checkbox","name":"OWNER_SEARCH_YN","defaultValue":false,"label":"Search owners"},{"type":"radio","name":"SERVICE_MARK_YN","label":"Mark Type","defaultValue":"","options":[{"value":"","label":"All Marks"},{"value":"Y","label":"Service Mark"},{"value":"N","label":"Trademark"}]},{"type":"serverSelect","name":"STATUS_ID","optionsSrc":"TYPE_V|TRADEMARK_STATUS_TYPE","label":"Status","placeholder":"All","defaultValue":"0"},{"type":"select","name":"DESIGN_TYPE_ID","options":[{"value":0,"label":"All"},{"value":990,"label":"Words Only"},{"value":991,"label":"Design Only"},{"value":992,"label":"Words and Design"}],"label":"Design Type","defaultValue":"0"},{"type":"dateRange","name":"FILING_DATE","label":"Registered Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}},{"type":"dateRange","name":"EXPIRATION_DATE","label":"Expiration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}}]},{"label":"Business Info Request","component":"InfoRequests","parameter":"info-request","sourceTypeId":167,"allowedRoutes":["/forms-manager/","/queue/","/forms/"]},{"label":"Data Requests","component":"DataRequests","parameter":"data-request","sourceTypeId":0,"allowedRoutes":["/forms-manager/"]},{"label":"CRA","component":"CRA","parameter":"cra","sourceTypeId":157,"myRecordsSearch":false,"searchPlaceholder":"Search by name or registered agent number","allowedRoutes":["/forms-manager/","/forms/","/records/","/queue/","/search/"],"allowEmptySearchTerm":true,"fileAmendmentButtonLabel":"Filing Actions","advancedSearchParameters":[{"type":"radio","name":"QUERY_TYPE_ID","defaultValue":1010,"options":[{"value":1010,"label":"Starts with"},{"value":1011,"label":"Contains"},{"value":1012,"label":" Word Contains"}]},{"type":"dateRange","name":"CRA_DATE","label":"Registration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}},{"type":"select","name":"STATUS_ID","label":"Status","defaultValue":0,"options":[{"value":0,"label":"All"},{"value":121,"label":"Active"},{"value":122,"label":"Inactive"}]},{"type":"select","name":"AGENT_TYPE_ID","label":"Agent Type","defaultValue":0,"options":[{"value":0,"label":"All"},{"value":460,"label":"Registered Agent"},{"value":461,"label":"Commercial Registered Agent"}]}]},{"label":"Farm Bill","component":"FarmBill","parameter":"farm-bill","path":"/lists/farm-bill","sourceTypeId":0,"myRecordsSearch":false,"allowedRules":["/search/"],"disabled":true,"searchDescription":"To perform a search, enter a debtor name. Your search results may include: exact debtor name, variations of that name and any filing that includes your search criteria. Punctuation is ignored.\n\nYou can click on \"Advanced\" to refine your search. Under “Advanced” you can search by crop, year, county and SSN/FEIN. As a registered Farm Bill Buyer with the Montana Secretary of State’s office it is important to maintain the confidentiality of the information contained within the Farm Bill Master List. The Farm Bill Master List reflects personal data, such as Social Security Numbers, which are a key piece of personal identifiable information to assist you in determining the existence of a lien against a specific debtor. The distribution of this information beyond its intended purpose is strictly prohibited.\n\nThe debtor's tax identification number has been hidden for confidentiality reasons. You may continue to search on a tax ID number and return debtors that match your search criteria. The SSN/FEIN must be entered without dashes or spaces.","searchMustHaveOneOf":["search","UCC_FARM_PRODUCT_ID","COUNTY"],"searchPlaceholder":"Search by debtor name","advancedSearchParameters":[{"type":"ServerMultiComplete","label":"Product code name(s)","name":"UCC_FARM_PRODUCT_ID","defaultValue":"","optionsSrc":"UCC_FARM_PRODUCT_V"},{"type":"MultiComplete","label":"Year or Range of Years","name":"YEAR_NUM","optionsSrc":"years","startYear":"1968","defaultValue":[],"preMergeOptions":[{"value":"ALL","label":"All"}]},{"type":"serverSelect","label":"State","name":"STATE","defaultValue":"MONTANA","optionsSrc":"STATE"},{"type":"ServerMultiComplete","label":"County","name":"COUNTY","defaultValue":[],"optionsSrc":"COUNTY","overrideSubOptionsSrcFromParameterName":"STATE"},{"type":"checkbox","name":"TIN_SEARCH_YN","defaultValue":false,"label":"Tax Identification Number Search"},{"type":"checkbox","name":"TIN_SORT_YN","defaultValue":false,"label":"Unique ID Sort"}]}],"SYSTEM_NICKNAME":"Online Services Portal","PAYMENT_METHODS":[{"type":"bypass"},{"type":"iTransact"}],"PAYMENT_ALLOW_AMEX":true,"SYSTEM_ID_LABEL":"System Id","DOUBLE_COLUMN_PUBLIC_LOGIN":true,"INTERNAL_USER_MANAGEMENT":true,"ALLOW_PUBLIC_JSON_IMPORT":false,"MAX_FILE_UPLOAD_SIZE":10000000,"REFUND_TEXT":"","RETURN_TO_HOME_ON_LOGOUT":true,"CURRENT_SOS_NAME":"Christi Jacobsen","LOGO_FILENAME":"mt-sos-logo.png","LOGO_ALT":"Christi Jacobsen, Montana Secretary of State","LOGO_FULL_WIDTH":true,"HOME_HIDE_AUTH_HINT":true,"HOME_TITLE":"Montana Secretary of State","CUSTOM_TAB_TITLE":"Official Montana","HOME_SUBTITLE":"Online Business Services","ENTITY_NAME_CONSENT_DESCRIPTION":"","ALLOW_USER_PROFILE_EDITING":true,"COMPARE_FOREIGN_NAME_IN_ENTITY_NAME_VALIDATION":true,"FOREIGN_NAME_FIELD_NAME":"KIMA_PARENT_NAME_INFO","LOGIN_TITLE":"Montana Secretary of State Online Filing Portal Login","PUBLIC_LOGIN_LABEL":"Username","REVERSE_LOGIN_COLUMNS":true,"LOGIN_SEAL_FILENAME":"seal_white.png","SEPARATE_USERNAME_AND_EMAIL":true,"CREATE_ACCOUNT_BUTTON_ALIGN_LEFT":true,"CREATE_ACCOUNT_BUTTON_TEXT":"CREATE AN ACCOUNT","PASSWORD_CUSTOM_ERROR_TEXT":"The password must meet all requirements","ACCOUNT_CREATED_MESSAGE":"Please check your email to verify your account to login and allow a few minutes for this message to arrive. Check your junk/spam folders if you do not find the email in your inbox.","PUBLIC_LOGIN_PLACEHOLDER":" ","DISABLE_DEFAULT_PAYMENT_RADIO":true,"CUSTOM_RESET_PASSWORD_ERROR_MESSAGE":"Username invalid - no account found","PUBLIC_LOGIN_CREATE_DESCRIPTION":"### Existing User:\n\n  - Enter your username and password to login.  \n\n\n  #### - OR -  \n\n\n\n  - Forgot password? Click 'Reset Password' and follow the prompts.\n  - Forgot username? Click 'Forgot Username' and follow the prompts.  \n\n\n  ### New User:\n  ","LOGIN_HELP_LINK":"https://sosmt.gov/business/how-do-i/","LOGIN_HELP_LINK_TEXT":"Need Help?","FORGOT_USERNAME_TEXT":"Forgot Username?","LOGIN_ACTIVE_DIRECTORY_TEXT":"State User Login","MULTIPLE_LOGIN_METHODS":true,"HAS_ACTIVE_DIRECTORY_LOGIN":true,"RESET_PASSWORD_WITH_USERNAME":true,"DOWNLOAD_LINK":true,"SHOW_USERNAME_ACCOUNT_CREATE":true,"SHOW_SCROLL_DOWN_ARROW":true,"SHOW_ADDRESS_ACCOUNT_CREATE":true,"TWO_COLUMN_ACCOUNT_CREATE":true,"RESET_PASSWORD_TIP":"A link to change your password has been sent to your email. Please allow a few minutes for this message to arrive. Please check your junk/spam folders if you do not find the email in your inbox.","FORGOT_PASSWORD_LINK_TEXT":"Reset Password","PHONE_NUMBER_OPTIONAL_ACCOUNT_CREATE":true,"SHOW_REQUIRED_INDICATOR_ACCOUNT_CREATE":true,"PASSWORD_REQUIREMENTS_ACCOUNT_CREATE":"\n    <ul>\n      <li>MUST contain at least 8 characters (12+ recommended)</li>\n      <li>MUST contain at least one uppercase letter.</li>\n      <li>MUST contain at least one lowercase letter.</li>\n      <li>MUST contain at least one number.</li>\n      <li>MUST contain at least one special character (!”#$%&'()*+,-./:;<=>?</li>\n    </ul>\n  ","ALLOW_CERTIFICATION_REQUEST":true,"ALLOW_PUBLIC_CERTIFICATE_REQUEST":true,"ALLOW_COPY_REQUEST":false,"ALLOW_CORRECTION_STYLING":true,"HIDE_DEPRECATION_WARNING":false,"AMEND_ROUTE_PUBLIC":true,"SEAL_FILENAME":"seal.png","SHOPPING_CART":true,"ALLOW_PAYMENT_UPDATE_WITH_EMPTY_CART":true,"RA_EMAIL":true,"RA_WEBSITE":true,"RA_NO_DEFAULT_TYPE":true,"RA_ADDRESS_LABEL":"Street Address","RA_TYPE_SELECTION_DEFAULT":true,"RA_DEFAULT_TYPE":"460","RA_OVERRIDE_TYPE_WITH_DEFAULT":true,"RA_PRINCIPAL_ADDRESS_AMS":true,"UPLOAD_AND_SUBMIT_HIDE_IF_ONE_OPTION":true,"PAYMENT_PROCESSING_MESSAGE":"Your payment is processing - Do not close your browser or click the back button","CHECKOUT_BUTTON_WHEN_PROCESSING_TEXT":"Processing","EFS_CROP_PICKER_NONE_LABEL":"Lien Duration","DISALLOWED_WIZARD_PIECES":["FormationLocale"],"REPEATER_SHOW_EDIT_BUTTON":true,"DATA_REQUEST_PAGE_TITLE":"Data Requests and Subscriptions","DATA_REQUEST_SIDEBAR_LABEL":"Data Requests & Subscriptions","LOGIN_REDIRECTS_TO_EPASS":false,"LOGIN_REDIRECTS_TO_ACTIVE_DIRECTORY":true,"LOGIN_ACTIVE_DIRECTORY_LINK":true,"FETCH_EDIT_USER_LINK":false,"LISTS_FETCH_AVAILABLE_LISTS":true,"POST_WIZARD_SUBMIT_REDIRECT_URL":"/","PIN_REQUEST_ATTESTATIONS":true,"PIN_REQUEST_DESCRIPTION":"Click **Request PIN** to have a new PIN sent to the account holder's email address on file.","OWNERSHIP_REQUEST_DESCRIPTION":"To become an **authorized user** of this record, a current **AUTHORIZED USER** will need to grant you access. To request access, click **Request Access** below.","PIN_REQUEST_SUCCESS_MESSAGE":"The PIN you have requested for this entity has been sent to the email associated with your user account.  You should receive the PIN in approximately 3-5 minutes, depending on your email service provider.","APOSTILLE_HEADER_LABEL":"Verification Information","APOSTILLE_NUMBER_LABEL":"Apostille/Authentication","APOSTILLE_CITY_STATE_OVERRIDE":"HELENA, MT","APOSTILLE_FILING_DATE_LABEL":"Issue Date","APOSTILLE_CITY_STATE_IN_CERTIFIED":true,"NOTARY_EXISTING_FILING":true,"ALLOW_REVOKE_OWN_ACCESS_ONLY":false,"HIDE_CANCEL_ON_ONETIME_DATA_REQUESTS":true,"DATA_REQUESTS_IN_SHOPPING_CART":true,"WQ_ALLOW_EDIT_PENDING_PAYMENT":true,"WQ_CONFIRM_ON_DELETE":true,"WQ_DELETE_CONFIRM_MESSAGE":"Deleting this filing will forfeit any money already paid to the Secretary of State. This action is permanent and cannot be undone, are you sure you would like to delete?","PASS_ITEM_GUIDS_ON_CHECKOUT":true,"FORM_REVISION_HISTORY":true,"CHECKOUT_DISCLAIMER":"By entering your credit card and/or checking account information you (i) state that **you are an authorized user** of the credit card and/or electronic check and that the associated information entered (e.g., account holder name, account number, billing address) is accurate, (ii) **you authorize payment processor to charge the amount you have requested** to your credit card and/or funding account, and (iii) **acknowledge if a charge is declined or reversed you may also be assessed a customary charge** by the payment processor for such transactions.","FARM_BILL_SEARCH_CONFIDENTIAL":"As a registered Farm Bill Buyer with the Montana Secretary of State’s office it is important to maintain the confidentiality of the information contained within the Farm Bill Master List. The Farm Bill Master List reflects personal data, such as Social Security Numbers, which are a key piece of personal identifiable information to assist you in determining the existence of a lien against a specific debtor. The distribution of this information beyond its intended purpose is strictly prohibited.\n\n**The debtor's tax identification number has been hidden for confidentiality reasons. You may continue to search on a tax ID number and return debtors that match your search criteria. The SSN/FEIN must be entered without dashes or spaces.  If you need access to the tax identification number to clearly identify the debtor, please contact the UCC unit at (406) 444-3665.**","VIEW_HISTORY_BUTTON_ALT_TEXT":"View Filings","WIZARD_ERROR_TITLE_MESSAGE":"Form Error","FARM_BILL_SEARCH_INTERACTIVE":true,"USE_FARM_BILL_API":true,"DISALLOW_ASSIGN_SELF_AS_RA":true,"DISALLOW_ASSIGN_SELF_AS_PRINCIPAL":true,"USE_TRADEMARK_OWNER_VALIDATION":true,"USE_ALTERNATIVE_FOREIGN_ADDRESS_LABELS":true,"MY_RECEIPTS_FILTER":[{"type":"dateRange","name":"DATE_RANGE","label":"Date range","defaultValue":{"start":null,"end":null}},{"type":"text","name":"REF_NUM","defaultValue":"","label":"Reference Number"},{"type":"text","name":"RECEIPT_NUM","defaultValue":"","label":"Receipt Id"},{"type":"text","name":"AMOUNT","defaultValue":"","label":"Amount"},{"type":"select","name":"TYPE","defaultValue":"","label":"Payment Type","options":[{"value":"","label":"All"},{"value":"CC","label":"Credit Card"},{"value":"Check","label":"Check"}]}],"MY_RECEIPTS_SHOW_IN_SIDEBAR":true,"SHOW_MY_RECEIPTS_HELPER_TEXT":true,"MY_RECEIPTS_HELPER_LABEL":"About Receipt Search","MY_RECEIPTS_HELPER_TEXT":"You can search for receipts based on their descriptions, including the items paid for on the receipt. Use the filters to search for or filter specific information.","FARM_BILL_SUBLINK":{"label":"Farm Bill","component":"FarmBill","parameter":"farm-bill","path":"/lists/farm-bill","sourceTypeId":0,"myRecordsSearch":false,"allowedRules":["/search/"],"disabled":true,"searchDescription":"To perform a search, enter a debtor name. Your search results may include: exact debtor name, variations of that name and any filing that includes your search criteria. Punctuation is ignored.\n\nYou can click on \"Advanced\" to refine your search. Under “Advanced” you can search by crop, year, county and SSN/FEIN. As a registered Farm Bill Buyer with the Montana Secretary of State’s office it is important to maintain the confidentiality of the information contained within the Farm Bill Master List. The Farm Bill Master List reflects personal data, such as Social Security Numbers, which are a key piece of personal identifiable information to assist you in determining the existence of a lien against a specific debtor. The distribution of this information beyond its intended purpose is strictly prohibited.\n\nThe debtor's tax identification number has been hidden for confidentiality reasons. You may continue to search on a tax ID number and return debtors that match your search criteria. The SSN/FEIN must be entered without dashes or spaces.","searchMustHaveOneOf":["search","UCC_FARM_PRODUCT_ID","COUNTY"],"searchPlaceholder":"Search by debtor name","advancedSearchParameters":[{"type":"ServerMultiComplete","label":"Product code name(s)","name":"UCC_FARM_PRODUCT_ID","defaultValue":"","optionsSrc":"UCC_FARM_PRODUCT_V"},{"type":"MultiComplete","label":"Year or Range of Years","name":"YEAR_NUM","optionsSrc":"years","startYear":"1968","defaultValue":[],"preMergeOptions":[{"value":"ALL","label":"All"}]},{"type":"serverSelect","label":"State","name":"STATE","defaultValue":"MONTANA","optionsSrc":"STATE"},{"type":"ServerMultiComplete","label":"County","name":"COUNTY","defaultValue":[],"optionsSrc":"COUNTY","overrideSubOptionsSrcFromParameterName":"STATE"},{"type":"checkbox","name":"TIN_SEARCH_YN","defaultValue":false,"label":"Tax Identification Number Search"},{"type":"checkbox","name":"TIN_SORT_YN","defaultValue":false,"label":"Unique ID Sort"}]},"ALLOW_ADDRESS_VALIDATION_BYPASS_OPTION":true,"DEFAULT_ADDRESS_VALIDATION_BYPASS_OPTION_CHECKED":true}).STATE_TIMEZONE })), 'MM/dd/yyyy') : (0, _dateFns.format)(new Date(), 'MM/dd/yyyy') : '',
	    attestations: {}
	  };
	};
	
	var initialState = exports.initialState = {
	  wizard: {
	    title: "New Wizard",
	    description: "Description",
	    formDefinitionId: 0,
	    category: "",
	    entityTypeId: 54,
	    entitySubTypeId: 202,
	    stepOrder: [initialStepId],
	    sourceId: 0,
	    docTitleSrc: '',
	    docId: '',
	    formTitle: '',
	    internalReviewRequired: false,
	    internalReviewRequiredSet: new Set(),
	    noLoginRequired: true,
	    onlyRenderChangedFieldsOnForm: false,
	    draftsDisabled: false,
	    feeDescription: '',
	    steps: _defineProperty({}, initialStepId, new _WizardClasses.Step({ stepId: initialStepId, sectionOrder: [initialSectionId] })),
	    sections: _defineProperty({}, initialSectionId, new _WizardClasses.Section({ sectionId: initialSectionId, stepId: initialStepId, fieldOrder: [initialFieldId] })),
	    fields: Object.assign(_defineProperty({}, initialFieldId, new _WizardClasses.Field({ fieldId: initialFieldId, sectionId: initialSectionId })), STATIC_FIELDS),
	    amendmentNum: 0,
	    meta: {},
	    globalVariables: {
	      boolean: {
	        order: [],
	        variables: {}
	      },
	      string: {
	        order: [],
	        variables: {}
	      },
	      number: {
	        order: [],
	        variables: {}
	      },
	      businessRule: {
	        order: [],
	        variables: {}
	      }
	    },
	    wizardAttributesLogic: { nodes: {}, comments: {} }
	  },
	  loadingWizard: true,
	  activeStep: 0,
	  targetStep: 0,
	  validating: false,
	  repeaterAdding: null,
	  repeaterEditing: false,
	  helpShown: false,
	  draftId: false,
	  savingDraft: null,
	  readOnly: false,
	  mode: 'live',
	  diff: { original: {}, current: {}, originalByFieldId: {} },
	  preview: false,
	  uploading: false,
	  correctionMode: false,
	  showDiff: false,
	  infoMessages: [],
	  requirePrintMailMethod: new Set(),
	  submitted: false,
	  submitting: false,
	  canChangeEntryType: false,
	  canChangeCorrectionEntryType: null,
	  wizardLoadFailed: false,
	  wizardLoadErrorMessage: null,
	  wizardLoadErrorTitle: null,
	  signature: null,
	  signatureValues: getInitialSignatureValues(),
	  signatureErrors: { SIGNATURE: null, SIGNED_DATE: null },
	  genericSuccess: null,
	  thirdPartySigningAllowed: false
	};
	
	var WizardReducer = function WizardReducer() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	  var action = arguments[1];
	
	  //deepFreeze(state)
	  switch (action.type) {
	    case "RESET_WIZARD_STATE":
	      return Object.assign({}, initialState);
	    case "POPULATE_WIZARD":
	      return Object.assign({}, state, {
	        loadingWizard: false,
	        wizard: Object.assign({}, state.wizard, {
	          title: action.title,
	          formDefinitionId: action.formDefinitionId,
	          stepOrder: action.stepOrder,
	          steps: action.steps,
	          sections: action.sections,
	          fields: Object.assign({}, STATIC_FIELDS, action.fields),
	          category: action.category,
	          sourceId: action.sourceId,
	          meta: action.meta ? action.meta : {},
	          docTitleSrc: action.docTitleSrc,
	          docId: action.docId,
	          formTitle: action.formTitle,
	          amendmentNum: action.amendmentNum,
	          internalReviewRequired: action.internalReviewRequired,
	          noLoginRequired: action.noLoginRequired,
	          feeDescription: action.feeDescription,
	          onlyRenderChangedFieldsOnForm: action.onlyRenderChangedFieldsOnForm,
	          draftsDisabled: action.draftsDisabled || false
	        }, action.globalVariables ? { globalVariables: action.globalVariables } : {}, action.wizardAttributesLogic ? { wizardAttributesLogic: action.wizardAttributesLogic } : {}),
	        helpShown: false,
	        activeStep: action.activeStep ? action.activeStep : 0,
	        draftId: action.draftId,
	        readOnly: action.readOnly,
	        mode: action.mode ? action.mode : "live",
	        preview: action.preview,
	        diff: Object.assign({}, state.diff, {
	          original: action.original ? action.original : {},
	          originalByFieldId: action.originalByFieldId ? action.originalByFieldId : {}
	        }),
	        correctionMode: action.correctionMode ? true : false,
	        showDiff: action.showDiff,
	        requirePrintMailMethod: action.requirePrintMailMethod ? new Set(["GLOBAL"]) : action.fieldsRequirePrintMailMethod ? new Set(action.fieldsRequirePrintMailMethod) : new Set(),
	        canChangeEntryType: action.canChangeEntryType || false,
	        canChangeCorrectionEntryType: action.canChangeCorrectionEntryType !== undefined ? action.canChangeCorrectionEntryType : null,
	        signature: action.signature || null,
	        thirdPartySigningAllowed: action.thirdPartySigningAllowed || false
	      });
	    case "SPREAD_WIZARD_ATTRIBUTES":
	      return Object.assign({}, state, {
	        wizard: Object.assign({}, state.wizard, action.payload)
	      });
	    case "TOGGLE_WIZARD_LOADING":
	      return Object.assign({}, state, { loadingWizard: action.loading });
	    case "SET_WIZARD_LOAD_FAILED":
	      return Object.assign({}, state, { wizardLoadFailed: action.wizardLoadFailed });
	    case "SET_WIZARD_ERROR_MESSAGE":
	      return Object.assign({}, state, { wizardLoadErrorMessage: action.message, wizardLoadErrorTitle: action.title ? action.title : null });
	    case "SET_SUBMITTED":
	      return Object.assign({}, state, { submitted: action.submitted });
	    case "SET_SUBMITTING":
	      return Object.assign({}, state, { submitting: action.submitting });
	    case "SET_ACTIVE_WIZARD_STEP":
	      return Object.assign({}, state, { activeStep: action.activeStep });
	    case "SET_TARGET_STEP":
	      return Object.assign({}, state, { targetStep: action.targetStep });
	    case "SET_FIELD_ATTRIBUTES":
	      return Object.assign({}, state, { wizard: Object.assign({}, state.wizard, { fields: Object.assign({}, state.wizard.fields, _defineProperty({}, action.fieldId, Object.assign({}, state.wizard.fields[action.fieldId], action.payload))) }) });
	    case "SET_STEP_ATTRIBUTES":
	      return Object.assign({}, state, { wizard: Object.assign({}, state.wizard, {
	          steps: Object.assign({}, state.wizard.steps, _defineProperty({}, action.stepId, Object.assign({}, state.wizard.steps[action.stepId], action.payload)))
	        }) });
	    case "SET_WIZARD_ATTRIBUTES":
	      return Object.assign({}, state, { wizard: Object.assign({}, state.wizard, action.payload) });
	    case "SET_WIZARD_SIGNATURE_VALUES":
	      return Object.assign({}, state, { signatureValues: action.signatureValues });
	    case "RESET_WIZARD_SIGNATURE_VALUES":
	      return Object.assign({}, state, { signatureValues: getInitialSignatureValues() });
	    case "SET_WIZARD_SIGNATURE_ERRORS":
	      return Object.assign({}, state, { signatureErrors: action.signatureErrors });
	    case "SET_GENERIC_SUCCESS":
	      return Object.assign({}, state, { genericSuccess: action.message });
	    case "TOGGLE_HELP_MODAL":
	      return Object.assign({}, state, { helpShown: action.helpShown });
	    case "TOGGLE_VALIDATING":
	      return Object.assign({}, state, { validating: action.validating });
	    case "TOGGLE_SAVING_DRAFT":
	      return Object.assign({}, state, { savingDraft: action.savingDraft });
	    case "SET_DRAFT_ID":
	      return Object.assign({}, state, { draftId: action.draftId });
	    case "SET_UPLOADING":
	      return Object.assign({}, state, { uploading: action.uploading });
	    case "CLEAR_INFO_MESSAGES":
	      return Object.assign({}, state, { infoMessages: [] });
	    case "ADD_INFO_MESSAGE":
	      return Object.assign({}, state, { infoMessages: [].concat(_toConsumableArray(state.infoMessages), [action.message]) });
	    case "ADD_REQUIRE_PRINT_MAIL_METHOD":
	      {
	        if (!state.requirePrintMailMethod.has(action.fieldId)) {
	          var requirePrintMailMethod = new Set(state.requirePrintMailMethod);
	          requirePrintMailMethod.add(action.fieldId);
	          return Object.assign({}, state, { requirePrintMailMethod: requirePrintMailMethod });
	        } else {
	          return state;
	        }
	      }
	    case "REMOVE_REQUIRE_PRINT_MAIL_METHOD":
	      {
	        if (state.requirePrintMailMethod.has(action.fieldId)) {
	          var _requirePrintMailMethod = new Set(state.requirePrintMailMethod);
	          _requirePrintMailMethod.delete(action.fieldId);
	          return Object.assign({}, state, { requirePrintMailMethod: _requirePrintMailMethod });
	        } else {
	          return state;
	        }
	      }
	    case "ADD_INTERNAL_REVIEW_REQUIRED":
	      {
	        if (!state.wizard.internalReviewRequiredSet.has(action.fieldId)) {
	          var internalReviewRequiredSet = new Set(state.wizard.internalReviewRequiredSet);
	          internalReviewRequiredSet.add(action.fieldId);
	          return Object.assign({}, state, {
	            wizard: Object.assign({}, state.wizard, {
	              internalReviewRequiredSet: internalReviewRequiredSet
	            })
	          });
	        } else {
	          return state;
	        }
	      }
	    case "REMOVE_INTERNAL_REVIEW_REQUIRED":
	      {
	        if (state.wizard.internalReviewRequiredSet.has(action.fieldId)) {
	          var _internalReviewRequiredSet = new Set(state.wizard.internalReviewRequiredSet);
	          _internalReviewRequiredSet.delete(action.fieldId);
	          return Object.assign({}, state, {
	            wizard: Object.assign({}, state.wizard, {
	              internalReviewRequiredSet: _internalReviewRequiredSet
	            })
	          });
	        } else {
	          return state;
	        }
	      }
	    case 'UPDATE_WIZARD_META':
	      return Object.assign({}, state, {
	        wizard: Object.assign({}, state.wizard, {
	          meta: action.newMeta
	        })
	      });
	    case 'SET_REPEATER_EDITING':
	      return Object.assign({}, state, {
	        repeaterEditing: action.repeaterEditing
	      });
	    default:
	      return state;
	  }
	};
	
	exports.default = WizardReducer;

/***/ },
/* 1154 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(7);
	
	var _utilities = __webpack_require__(8);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var AddressSelector = function (_React$Component) {
		_inherits(AddressSelector, _React$Component);
	
		function AddressSelector() {
			_classCallCheck(this, AddressSelector);
	
			return _possibleConstructorReturn(this, (AddressSelector.__proto__ || Object.getPrototypeOf(AddressSelector)).apply(this, arguments));
		}
	
		_createClass(AddressSelector, [{
			key: 'render',
			value: function render() {
				var _this2 = this;
	
				var _props = this.props,
				    addresses = _props.addresses,
				    children = _props.children;
				// console.log(addresses)
	
				return _react2.default.createElement(
					'div',
					{ className: 'address-selector ' },
					children,
					addresses.length > 0 ? addresses.map(function (address, i) {
						return _react2.default.createElement(AddressButton, {
							isFirst: i === 0,
							label: address.label,
							value: address.value,
							showCounty: address.showCounty,
							showCountry: address.showCountry,
							onSelect: _this2.props.onSelect,
							key: address.fieldId
						});
					}) : _react2.default.createElement(
						'div',
						{ style: { padding: 15 } },
						'None available.'
					)
				);
			}
		}]);
	
		return AddressSelector;
	}(_react2.default.Component);
	
	exports.default = (0, _reactRedux.connect)(function (state, props) {
		return {
			addresses: props.addresses ? props.addresses : (0, _utilities.getFieldsByType)(['addressBlock', 'registeredAgentSearch'], state.wizard.wizard.fields).reduce(function (addresses, address) {
				if (address.type === 'registeredAgentSearch') {
					return [].concat(_toConsumableArray(addresses), [Object.assign({}, address, {
						fieldId: address.fieldId + '_PRIMARY',
						label: address.label + ' (Physical)',
						value: {
							ADDR1: address.value.ADDR1,
							ADDR2: address.value.ADDR2,
							ADDR3: address.value.ADDR3,
							CITY: address.value.CITY,
							STATE: address.value.STATE,
							COUNTY: address.value.COUNTY,
							POSTAL_CODE: address.value.POSTAL_CODE,
							COUNTRY: address.value.COUNTRY
						}
					}), Object.assign({}, address, {
						fieldId: address.fieldId + '_MAIL',
						label: address.label + ' (Mailing)',
						value: {
							ADDR1: address.value.MAIL_ADDR.ADDR1,
							ADDR2: address.value.MAIL_ADDR.ADDR2,
							ADDR3: address.value.MAIL_ADDR.ADDR3,
							CITY: address.value.MAIL_ADDR.CITY,
							STATE: address.value.MAIL_ADDR.STATE,
							COUNTY: address.value.MAIL_ADDR.COUNTY,
							POSTAL_CODE: address.value.MAIL_ADDR.POSTAL_CODE,
							COUNTRY: address.value.MAIL_ADDR.COUNTRY
						}
					})]);
				} else {
					return [].concat(_toConsumableArray(addresses), [address]);
				}
			}, []).filter(function (address) {
				return address.parent.type !== 'REPEATER' && address.fieldId !== props.fieldId && address.value.ADDR1 !== '' && address.active === true;
			}).filter(function (address) {
				return (0, _utilities.getControlIsRenderable)(address, state.wizard.wizard.fields);
			})
		};
	})(AddressSelector);
	
	var AddressButton = function (_React$Component2) {
		_inherits(AddressButton, _React$Component2);
	
		function AddressButton() {
			var _ref;
	
			var _temp, _this3, _ret;
	
			_classCallCheck(this, AddressButton);
	
			for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
				args[_key] = arguments[_key];
			}
	
			return _ret = (_temp = (_this3 = _possibleConstructorReturn(this, (_ref = AddressButton.__proto__ || Object.getPrototypeOf(AddressButton)).call.apply(_ref, [this].concat(args))), _this3), _this3.select = function () {
				_this3.props.onSelect(_this3.props.value);
			}, _temp), _possibleConstructorReturn(_this3, _ret);
		}
	
		_createClass(AddressButton, [{
			key: 'render',
			value: function render() {
				var _props2 = this.props,
				    label = _props2.label,
				    value = _props2.value,
				    showCounty = _props2.showCounty,
				    showCountry = _props2.showCountry;
	
				return _react2.default.createElement(
					'button',
					{ type: 'button', className: 'address-button', onClick: this.select },
					_react2.default.createElement(
						'span',
						{ className: 'label' },
						label
					),
					_react2.default.createElement(_utilities.FormattedAddress, {
						value: value,
						showCounty: showCounty,
						showCountry: showCountry,
						className: 'address'
					})
				);
			}
		}]);
	
		return AddressButton;
	}(_react2.default.Component);

/***/ },
/* 1155 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(7);
	
	var _requests = __webpack_require__(6);
	
	var _Loaders = __webpack_require__(16);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var DataTable = function (_React$Component) {
	  _inherits(DataTable, _React$Component);
	
	  function DataTable() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, DataTable);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = DataTable.__proto__ || Object.getPrototypeOf(DataTable)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      template: [{
	        LABEL: _react2.default.createElement(
	          'span',
	          { className: 'loading' },
	          'Loading ',
	          _react2.default.createElement(_Loaders.Spinner, { size: 'small', color: '#fff' })
	        ),
	        id: 'loading'
	      }],
	      rows: []
	    }, _this.componentDidMount = function () {
	      _this.getDataTable();
	    }, _this.getDataTable = function () {
	      (0, _requests.GET_DATA_TABLE_BY_ID)(_this.props.dataSrc, _this.props.metadata, function (table) {
	        // console.log(table);
	        _this.setState({ template: table.TEMPLATE, rows: table.ROWS });
	        _this.props.onChange({ template: table.TEMPLATE, rows: table.ROWS });
	      });
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(DataTable, [{
	    key: 'render',
	    value: function render() {
	      var _state = this.state,
	          template = _state.template,
	          rows = _state.rows;
	
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(DumbTable, { template: template, rows: rows })
	      );
	    }
	  }]);
	
	  return DataTable;
	}(_react2.default.Component);
	
	var ConnectedDataTable = (0, _reactRedux.connect)(function (state) {
	  return {
	    metadata: state.wizard.wizard.meta
	  };
	})(DataTable);
	
	exports.default = ConnectedDataTable;
	
	
	var DumbTable = function DumbTable(_ref2) {
	  var template = _ref2.template,
	      rows = _ref2.rows;
	  return _react2.default.createElement(
	    'table',
	    { className: 'form-table' },
	    _react2.default.createElement(
	      'thead',
	      null,
	      _react2.default.createElement(
	        'tr',
	        null,
	        template.map(function (_ref3, i) {
	          var LABEL = _ref3.LABEL;
	          return _react2.default.createElement(
	            'th',
	            { key: i },
	            LABEL
	          );
	        })
	      )
	    ),
	    _react2.default.createElement(
	      'tbody',
	      null,
	      rows.map(function (row, i) {
	        return _react2.default.createElement(Row, { template: template, row: row, key: i });
	      })
	    )
	  );
	};
	
	var Row = function Row(_ref4) {
	  var row = _ref4.row,
	      template = _ref4.template;
	  return _react2.default.createElement(
	    'tr',
	    null,
	    template.map(function (_ref5) {
	      var ID = _ref5.ID;
	      return _react2.default.createElement(
	        'td',
	        { key: ID },
	        row[ID]
	      );
	    })
	  );
	};

/***/ },
/* 1156 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Field = __webpack_require__(25);
	
	var _Form = __webpack_require__(14);
	
	var _MultiComplete = __webpack_require__(120);
	
	var _MultiComplete2 = _interopRequireDefault(_MultiComplete);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var DEFAULT_OPTION = { value: '', label: '[Select a year]' };
	
	var EFSCropPicker = function (_React$Component) {
	  _inherits(EFSCropPicker, _React$Component);
	
	  function EFSCropPicker() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, EFSCropPicker);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = EFSCropPicker.__proto__ || Object.getPrototypeOf(EFSCropPicker)).call.apply(_ref, [this].concat(args))), _this), _this.setByKey = function (value, key) {
	      _this.props.onChange(Object.assign({}, _this.props.value, _defineProperty({}, key, value)));
	    }, _this.generateAllYears = function (startYear, endYear) {
	      var years = [];
	      for (var step = startYear; step <= endYear; ++step) {
	        years.push({
	          value: step,
	          label: step.toString()
	        });
	      }
	      return years;
	    }, _this.startYear = 1970, _this.currentYear = new Date().getFullYear(), _this.endYear = _this.currentYear + 100, _this.allYears = _this.generateAllYears(_this.startYear, _this.endYear), _this.getStartYearOptions = function () {
	      var endYear = _this.props.value.endYear;
	
	      if (endYear) {
	        var stringYear = endYear.toString();
	        var yearIndex = _this.allYears.findIndex(function (y) {
	          return y.label == stringYear;
	        });
	        return _this.allYears.slice(0, yearIndex);
	      }
	      return _this.allYears;
	    }, _this.getEndYearOptions = function () {
	      var startYear = _this.props.value.startYear;
	
	      if (startYear) {
	        var stringYear = startYear.toString();
	        var yearIndex = _this.allYears.findIndex(function (y) {
	          return y.label == stringYear;
	        });
	        return _this.allYears.slice(yearIndex + 1);
	      }
	      return _this.allYears;
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(EFSCropPicker, [{
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _props = this.props,
	          fieldId = _props.fieldId,
	          value = _props.value,
	          required = _props.required,
	          disabled = _props.disabled,
	          label = _props.label;
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'efs-crop-picker' },
	        _react2.default.createElement(
	          _Field.DumbField,
	          { fieldId: fieldId + '-radio', label: label, required: required },
	          _react2.default.createElement(_Form.RadioInput, {
	            disabled: disabled,
	            value: value.yearType,
	            onChange: function onChange(value) {
	              return _this2.setByKey(value, 'yearType');
	            },
	            options: [{ value: 'all', label: 'All Years' }, { value: 'none', label: ("Lien Duration") || 'None' }, { value: 'duration', label: 'Specified Year Through Duration' }, { value: 'arbitrary', label: 'Specified Years' }]
	          })
	        ),
	        value.yearType === 'duration' && _react2.default.createElement(
	          'div',
	          { className: 'flex-row' },
	          _react2.default.createElement(
	            'div',
	            { className: 'col-sm-6 col-md-4 col-lg-3' },
	            _react2.default.createElement(
	              _Field.DumbField,
	              { label: 'Starting year', fieldId: fieldId + '-start', required: required },
	              _react2.default.createElement(_Form.Select, {
	                disabled: disabled,
	                options: [DEFAULT_OPTION].concat(_toConsumableArray(this.getStartYearOptions())),
	                value: value.startYear,
	                onChange: function onChange(value) {
	                  return _this2.setByKey(value, 'startYear');
	                }
	              })
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'col-sm-6 col-md-4 col-lg-3' },
	            _react2.default.createElement(
	              _Field.DumbField,
	              { label: 'Ending year', fieldId: fieldId + '-end', required: required },
	              _react2.default.createElement(_Form.Select, {
	                disabled: disabled,
	                options: [DEFAULT_OPTION].concat(_toConsumableArray(this.getEndYearOptions())),
	                value: value.endYear,
	                onChange: function onChange(value) {
	                  return _this2.setByKey(value, 'endYear');
	                }
	              })
	            )
	          )
	        ),
	        value.yearType === 'arbitrary' && _react2.default.createElement(
	          _Field.DumbField,
	          null,
	          _react2.default.createElement(_MultiComplete2.default, {
	            required: required,
	            disabled: disabled,
	            fieldId: fieldId + '-arbitrary',
	            label: 'Select years',
	            value: value.years,
	            onChange: function onChange(value) {
	              return _this2.setByKey(value, 'years');
	            },
	            options: this.allYears
	          })
	        )
	      );
	    }
	  }]);
	
	  return EFSCropPicker;
	}(_react2.default.Component);
	
	exports.default = EFSCropPicker;

/***/ },
/* 1157 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(7);
	
	var _Form = __webpack_require__(14);
	
	var _Field = __webpack_require__(25);
	
	var _WizardActions = __webpack_require__(36);
	
	var _Markdown = __webpack_require__(24);
	
	var _Markdown2 = _interopRequireDefault(_Markdown);
	
	var _validate = __webpack_require__(45);
	
	var _utilities = __webpack_require__(8);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ADDITIONAL = {
	  'trade': {
	    label: 'Trade',
	    optionsSrc: 'tradeNames'
	  },
	  'fictitious': {
	    label: 'Fictitious',
	    optionsSrc: 'fictitiousNames'
	  }
	};
	
	var emptyOption = { value: '', label: '[Select an Option]' };
	
	var EntityNameSearch = function (_Component) {
	  _inherits(EntityNameSearch, _Component);
	
	  function EntityNameSearch() {
	    _classCallCheck(this, EntityNameSearch);
	
	    var _this = _possibleConstructorReturn(this, (EntityNameSearch.__proto__ || Object.getPrototypeOf(EntityNameSearch)).call(this));
	
	    _this.componentDidMount = function () {
	      if (_this.props.isFirst) {
	        try {
	          _this.focusTarget.focus();
	        } catch (e) {
	          console.warn('Attempted to focus unfocusable element', e);
	        }
	      }
	      _this.props.getWebUserRecordByType('RESERVED_NAME', function (reservedNames) {
	        _this.setState({
	          reservedNames: (reservedNames && Array.isArray(reservedNames) ? reservedNames : []).map(function (name) {
	            return {
	              value: name.SOURCE_ID,
	              label: '' + name.NAME,
	              num: name.SOURCE_NUM,
	              name: name.NAME
	            };
	          })
	        });
	      });
	      _this.props.getWebUserRecordByType('TRADE_NAME', function (tradeNames) {
	        _this.setState({
	          tradeNames: (tradeNames && Array.isArray(tradeNames) ? tradeNames : []).map(function (name) {
	            return {
	              value: name.SOURCE_ID,
	              label: '' + name.NAME,
	              name: name.NAME
	            };
	          })
	        });
	      });
	      _this.props.getWebUserRecordByType('PARTNERSHIP_FICTITIOUS_NAME', function (ficNames) {
	        _this.setState({
	          fictitiousNames: (ficNames && Array.isArray(ficNames) ? ficNames : []).map(function (name) {
	            return {
	              value: name.SOURCE_ID,
	              label: '' + name.NAME,
	              name: name.NAME
	            };
	          })
	        });
	      });
	    };
	
	    _this.setAdditionalName = function (value, e) {
	      var _Object$assign;
	
	      var foundNameTrade = _this.state.tradeNames.find(function (name) {
	        return name.value == value;
	      });
	      var additionalName = foundNameTrade ? foundNameTrade.name : '';
	      _this.props.onChange(Object.assign({}, _this.props.value, (_Object$assign = {}, _defineProperty(_Object$assign, e.target.name, value), _defineProperty(_Object$assign, 'additionalName', additionalName), _Object$assign)));
	    };
	
	    _this.setFieldValueByName = function (value, e) {
	      _this.props.onChange(Object.assign({}, _this.props.value, _defineProperty({}, e.target.name, value)));
	    };
	
	    _this.setReservedName = function (reservedId, e) {
	      var _Object$assign3;
	
	      var foundName = _this.state.reservedNames.find(function (name) {
	        return name.value == reservedId;
	      });
	      var reservedName = foundName ? foundName.name : '';
	      var reservedNum = foundName ? foundName.num : '';
	      _this.props.onChange(Object.assign({}, _this.props.value, (_Object$assign3 = {}, _defineProperty(_Object$assign3, e.target.name, reservedId), _defineProperty(_Object$assign3, 'reservedName', reservedName), _defineProperty(_Object$assign3, 'reservedNum', reservedNum), _Object$assign3), _this.props.allowReservedNameEditing ? {
	        val1: reservedName,
	        val2: reservedName
	      } : {}));
	    };
	
	    _this.setAdditionalName = function (value, e) {
	      var _Object$assign4;
	
	      var foundNameTrade = _this.state[_this.props.value.additionalMode + 'Names'].find(function (name) {
	        return name.value == value;
	      });
	      var additionalName = foundNameTrade ? foundNameTrade.name : '';
	      _this.props.onChange(Object.assign({}, _this.props.value, (_Object$assign4 = {}, _defineProperty(_Object$assign4, e.target.name, value), _defineProperty(_Object$assign4, 'additionalName', additionalName), _Object$assign4)));
	    };
	
	    _this.setConfirmFieldsValue = function (value, e) {
	      _this.props.onChange(Object.assign({}, _this.props.value, value), e);
	    };
	
	    _this.getValidityClass = function (ruleId) {
	      var errors = _this.getErrors();
	      return (0, _Field.getValidityClass)(errors[ruleId] ? errors[ruleId].isValid : null);
	    };
	
	    _this.getErrorMessage = function (ruleId) {
	      var errors = _this.getErrors();
	      return errors[ruleId] ? errors[ruleId].errorMessage : [];
	    };
	
	    _this.applyMaskByMaskId = function (maskId, value, e) {
	      switch (maskId) {
	        case 'onlyNumbers':
	          _this.setFieldValueByName(_validate.MASK.onlyNumbers(value), e);
	          break;
	      }
	    };
	
	    _this.onBlur = function (value, e, extraPayload, overrideSetValue, options) {
	      _this.props.onBlur(_this.props.value, e, extraPayload, overrideSetValue, options);
	    };
	
	    _this.reduceErrors = function (errors) {
	      return errors.reduce(function (isValid, err) {
	        if (isValid === false) return isValid;
	        if (err) return err.isValid;
	        return isValid;
	      }, null);
	    };
	
	    _this.state = {
	      reservedNames: [],
	      tradeNames: [],
	      fictitiousNames: []
	    };
	    return _this;
	  }
	  // bubbleBlurEvent = (value, e) => {
	  //   this.props.onBlur(this.props.value, e)
	  // }
	
	
	  _createClass(EntityNameSearch, [{
	    key: 'getErrors',
	    value: function getErrors() {
	      if (this.props.errorMessage) {
	        if (this.props.errorMessage[0]) {
	          if (typeof this.props.errorMessage[0] === 'string') {
	            return this.props.errorMessage[1];
	          }
	          return this.props.errorMessage[0];
	        } else {
	          return {};
	        }
	      } else {
	        return {};
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _props = this.props,
	          value = _props.value,
	          errorMessage = _props.errorMessage,
	          hideReserved = _props.hideReserved,
	          reservedLabel = _props.reservedLabel,
	          allowReservedNameEditing = _props.allowReservedNameEditing,
	          hideAdditionalName = _props.hideAdditionalName,
	          additionalLabel = _props.additionalLabel,
	          additionalDescription = _props.additionalDescription,
	          nameLabel = _props.nameLabel,
	          nameDescription = _props.nameDescription,
	          nameConfirmLabel = _props.nameConfirmLabel,
	          nameMatch = _props.nameMatch,
	          hideConsent = _props.hideConsent,
	          hideNumConsent = _props.hideNumConsent,
	          consentLabel = _props.consentLabel,
	          required = _props.required,
	          disabled = _props.disabled,
	          tradeOptionLabel1 = _props.tradeOptionLabel1,
	          tradeOptionLabel2 = _props.tradeOptionLabel2,
	          consentOptionLabel1 = _props.consentOptionLabel1,
	          consentOptionLabel2 = _props.consentOptionLabel2,
	          consentDescription = _props.consentDescription,
	          consentInstructions = _props.consentInstructions,
	          nameWidth = _props.nameWidth,
	          infoMessage = _props.infoMessage;
	
	      var additionalNameShown = !hideAdditionalName;
	      var errors = errorMessage ? errorMessage[0] ? typeof errorMessage[0] === 'string' ? errorMessage[1] : errorMessage[0] : {} : {};
	      return _react2.default.createElement(
	        'div',
	        null,
	        !hideReserved && _react2.default.createElement(
	          _Field.DumbField,
	          { label: reservedLabel, errorMessage: this.getErrorMessage('mustSelectReservedOption'), required: required },
	          _react2.default.createElement(_Form.RadioInput, {
	            label: reservedLabel,
	            validityClass: this.getValidityClass('mustSelectReservedOption'),
	            options: [{ value: 'Y', label: 'Yes' }, { value: 'N', label: 'No' }],
	            value: value.reservedYN,
	            name: 'reservedYN',
	            fieldId: 'reservedYN',
	            onChange: this.setFieldValueByName,
	            ref: function ref(focusTarget) {
	              _this2.focusTarget = focusTarget;
	            },
	            disabled: disabled
	          })
	        ),
	        value.reservedYN === 'Y' && !hideReserved && _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement(
	            _Field.DumbField,
	            { label: 'Select a reserved name', errorMessage: this.getErrorMessage('mustSelectReservedName'), required: required },
	            _react2.default.createElement(_Form.Select, {
	              validityClass: this.getValidityClass('mustSelectReservedName'),
	              width: '40%',
	              onBlur: _utilities.noop,
	              options: [emptyOption].concat(_toConsumableArray(this.state.reservedNames)),
	              onChange: this.setReservedName,
	              value: value.reservedNameId,
	              name: 'reservedNameId',
	              disabled: disabled
	            })
	          )
	        ),
	        (value.reservedYN === 'N' || hideReserved || allowReservedNameEditing && value.reservedYN === 'Y') && _react2.default.createElement(
	          _Field.DumbField,
	          {
	            hideLabel: true,
	            errorMessage: [].concat(_toConsumableArray(this.getErrorMessage('entityNameRequired')), _toConsumableArray(this.getErrorMessage('entityValuesMatch')), _toConsumableArray(this.getErrorMessage('entityNameNotTaken')), _toConsumableArray(this.getErrorMessage('customBusinessRules')), _toConsumableArray(this.getErrorMessage('entityIsValidName'))),
	            infoMessage: infoMessage !== "" && infoMessage ? [infoMessage] : ''
	          },
	          _react2.default.createElement(_Form.ConfirmFields, {
	            isValid: this.reduceErrors([errors.entityNameRequired, errors.entityValuesMatch, errors.entityNameNotTaken, errors.entityIsValidName, errors.customBusinessRules]),
	            label: nameLabel,
	            confirmFieldLabel: nameConfirmLabel,
	            description: nameDescription,
	            value: value,
	            match: nameMatch,
	            width: nameWidth,
	            onChange: this.setConfirmFieldsValue,
	            onBlur: this.onBlur,
	            required: required,
	            disabled: disabled
	          })
	        ),
	        (value.reservedYN === 'N' || hideReserved) && additionalNameShown && _react2.default.createElement(
	          _Field.DumbField,
	          {
	            label: additionalLabel,
	            description: additionalDescription,
	            errorMessage: this.getErrorMessage('mustSelectAdditionalOption'),
	            required: required
	          },
	          _react2.default.createElement(_Form.RadioInput, {
	            validityClass: this.getValidityClass('mustSelectAdditionalOption'),
	            options: [{ value: 'N', label: tradeOptionLabel1 }, { value: 'Y', label: tradeOptionLabel2 }],
	            value: value.additionalYN,
	            name: 'additionalYN',
	            onChange: this.setFieldValueByName,
	            disabled: disabled
	          })
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'dependent-field' },
	          (value.reservedYN === 'N' || hideReserved) && value.additionalYN === 'Y' && additionalNameShown && _react2.default.createElement(
	            _Field.DumbField,
	            { label: 'Select a ' + ADDITIONAL[value.additionalMode].label.toLowerCase() + ' name', errorMessage: this.getErrorMessage('mustSelectAdditionalName'), required: required },
	            _react2.default.createElement(_Form.Select, {
	              validityClass: this.getValidityClass('mustSelectAdditionalName'),
	              width: '40%',
	              onBlur: _utilities.noop,
	              options: [emptyOption].concat(_toConsumableArray(this.state[ADDITIONAL[value.additionalMode].optionsSrc])),
	              onChange: this.setAdditionalName,
	              name: 'additionalNameId',
	              value: value.additionalNameId
	            })
	          )
	        ),
	        (value.reservedYN === 'N' || hideReserved) && (value.additionalYN === 'N' || !additionalNameShown) && !hideConsent && _react2.default.createElement(
	          _Field.DumbField,
	          {
	            className: additionalNameShown ? 'consent' : '',
	            label: consentLabel,
	            description: consentDescription,
	            errorMessage: this.getErrorMessage('mustSelectConsentOption'),
	            required: required
	          },
	          _react2.default.createElement(_Form.RadioInput, {
	            validityClass: this.getValidityClass('mustSelectConsentOption'),
	            options: [{ value: 'N', label: consentOptionLabel1 }, { value: 'Y', label: consentOptionLabel2 }],
	            value: value.consentYN,
	            name: 'consentYN',
	            onChange: this.setFieldValueByName,
	            disabled: disabled
	          })
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'dependent-field' },
	          (value.reservedYN === 'N' || hideReserved) && (value.additionalYN === 'N' || !additionalNameShown) && value.consentYN === 'Y' && !hideConsent && !hideNumConsent && _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(_Markdown2.default, { source: consentInstructions, className: 'markdown' }),
	            _react2.default.createElement(
	              _Field.DumbField,
	              {
	                label: 'Number of consents',
	                className: '',
	                description: 'Enter the number of consents required.\n\nIf multiple Consents are needed, each Consent is to be counted as one Consent.  However, if the same holder is authorized to sign, these may be combined and counted as one Consent.',
	                errorMessage: this.getErrorMessage('numConsentsRequired'),
	                required: required
	              },
	              _react2.default.createElement(_Form.TextInput, {
	                validityClass: this.getValidityClass('numConsentsRequired'),
	                value: value.numConsents,
	                name: 'numConsents',
	                onChange: function onChange(value, e) {
	                  _this2.applyMaskByMaskId('onlyNumbers', value, e);
	                },
	                onBlur: _utilities.noop,
	                placeholder: '(Enter number of consents required)',
	                width: '40%',
	                disabled: disabled
	              })
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return EntityNameSearch;
	}(_react.Component);
	
	exports.default = (0, _reactRedux.connect)(null, { getWebUserRecordByType: _WizardActions.getWebUserRecordByType })(EntityNameSearch);

/***/ },
/* 1158 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Form = __webpack_require__(14);
	
	var _Field = __webpack_require__(25);
	
	var _requests = __webpack_require__(6);
	
	var _selectOptions = __webpack_require__(68);
	
	var _utilities = __webpack_require__(8);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var STATE_NAME = ("Montana").toUpperCase();
	
	var FormationLocale = function (_Component) {
	  _inherits(FormationLocale, _Component);
	
	  function FormationLocale() {
	    _classCallCheck(this, FormationLocale);
	
	    var _this = _possibleConstructorReturn(this, (FormationLocale.__proto__ || Object.getPrototypeOf(FormationLocale)).call(this));
	
	    _this.componentDidMount = function () {
	      _this.focus();
	    };
	
	    _this.setFieldValue = function (value, e) {
	      _this.props.onChange(Object.assign({}, _this.props.value, _defineProperty({}, e.target.name, value)), e);
	    };
	
	    _this.componentDidMount = function () {
	      _this.getOptionsByType('STATE').then(function (options) {
	        var computedOptions = options;
	        if (_this.props.excludeCurrentState) {
	          computedOptions = options.filter(function (_ref) {
	            var value = _ref.value;
	            return value !== STATE_NAME;
	          });
	        }
	        _this.setState({ stateOptions: computedOptions });
	      });
	    };
	
	    _this.getOptionsByType = function (type) {
	      return new Promise(function (resolve, reject) {
	        (0, _requests.GET_GROUP_ITEMS)(type, function (res) {
	          if (Array.isArray(res)) {
	            resolve(res.map(function (option) {
	              return Object.assign({}, option, { value: option.label });
	            }));
	          } else {
	            resolve(res.options.map(function (option) {
	              return Object.assign({}, option, { value: option.label });
	            }));
	          }
	        });
	      });
	    };
	
	    _this.focus = function () {
	      _this.radio.focus();
	    };
	
	    _this.state = {
	      stateOptions: [{ value: '0', label: 'loading...' }],
	      countryOptions: (0, _selectOptions.getCountryOptions)()
	    };
	    return _this;
	  }
	
	  _createClass(FormationLocale, [{
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _props = this.props,
	          value = _props.value,
	          disabled = _props.disabled,
	          fieldId = _props.fieldId,
	          label = _props.label;
	      var _state = this.state,
	          stateOptions = _state.stateOptions,
	          countryOptions = _state.countryOptions;
	
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(_Form.RadioInput, {
	          value: value.FORMATION_TYPE,
	          name: 'FORMATION_TYPE',
	          fieldId: fieldId,
	          options: [{ value: 'STATE', label: 'United States' }, { value: 'COUNTRY', label: 'Country' }, { value: 'OTHER', label: 'Other Jurisdiction' }],
	          label: label,
	          onChange: this.setFieldValue,
	          disabled: disabled,
	          ref: function ref(radio) {
	            _this2.radio = radio;
	          }
	        }),
	        _react2.default.createElement(
	          'div',
	          { className: 'row' },
	          _react2.default.createElement(
	            'div',
	            { className: 'col-sm-7 col-md-6 col-lg-5' },
	            _react2.default.createElement(
	              'div',
	              { className: 'dependent-field no-margin-bottom' },
	              value.FORMATION_TYPE === 'STATE' && _react2.default.createElement(
	                _Field.DumbField,
	                { label: 'State', className: 'no-margin-bottom' },
	                _react2.default.createElement(_Form.Select, {
	                  value: value.STATE,
	                  name: 'STATE',
	                  options: [{ value: '', label: '[Select a State]' }].concat(_toConsumableArray(stateOptions)),
	                  onChange: this.setFieldValue,
	                  onBlur: _utilities.noop,
	                  disabled: disabled
	                })
	              ),
	              value.FORMATION_TYPE === 'COUNTRY' && _react2.default.createElement(
	                _Field.DumbField,
	                { label: 'Country', className: 'no-margin-bottom' },
	                _react2.default.createElement(_Form.Select, {
	                  value: value.COUNTRY,
	                  name: 'COUNTRY',
	                  options: [{ value: '', label: '[Select a Country]' }].concat(_toConsumableArray(countryOptions)),
	                  onChange: this.setFieldValue,
	                  onBlur: _utilities.noop,
	                  disabled: disabled
	                })
	              ),
	              value.FORMATION_TYPE === 'OTHER' && _react2.default.createElement(
	                _Field.DumbField,
	                { label: 'Other Jurisdiction', className: 'no-margin-bottom' },
	                _react2.default.createElement(_Form.TextInput, {
	                  value: value.OTHER,
	                  name: 'OTHER',
	                  width: '100%',
	                  onChange: this.setFieldValue,
	                  onBlur: _utilities.noop,
	                  disabled: disabled
	                })
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return FormationLocale;
	}(_react.Component);
	
	exports.default = FormationLocale;

/***/ },
/* 1159 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.HelpTooltip = HelpTooltip;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function HelpTooltip(props) {
	  return _react2.default.createElement(
	    "span",
	    {
	      "aria-live": "assertive",
	      "aria-describedBy": props.ariaDescribedBy,
	      className: "helpful-tooltip"
	    },
	    props.message
	  );
	}

/***/ },
/* 1160 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(7);
	
	var _WizardClasses = __webpack_require__(35);
	
	var WizardClasses = _interopRequireWildcard(_WizardClasses);
	
	var _Form = __webpack_require__(14);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var LocalSelect = function (_React$Component) {
	  _inherits(LocalSelect, _React$Component);
	
	  function LocalSelect() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, LocalSelect);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = LocalSelect.__proto__ || Object.getPrototypeOf(LocalSelect)).call.apply(_ref, [this].concat(args))), _this), _this.getRepeaterOptions = function () {
	      return [{ value: '', label: '[Select an option]' }].concat(_toConsumableArray(_this.props.srcRepeater.value.map(function (row) {
	        return {
	          value: row._rowId,
	          label: new WizardClasses[_this.props.srcField.fieldClass]().getHumanReadableValue(_this.props.srcField, row[_this.props.srcField.fieldId])
	        };
	      })));
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(LocalSelect, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          value = _props.value,
	          onChange = _props.onChange,
	          onBlur = _props.onBlur,
	          width = _props.width,
	          disabled = _props.disabled;
	
	      var options = this.getRepeaterOptions();
	      return _react2.default.createElement(_Form.Select, { width: width, value: value, disabled: disabled, options: options, onChange: onChange, onBlur: onBlur });
	    }
	  }]);
	
	  return LocalSelect;
	}(_react2.default.Component);
	
	exports.default = (0, _reactRedux.connect)(function (state, props) {
	  var srcRepeater = state.wizard.wizard.fields[props.srcRepeater];
	  var srcField = srcRepeater ? state.wizard.wizard.fields[props.srcField] : null;
	  return {
	    srcRepeater: srcRepeater,
	    srcField: srcField,
	    fields: state.wizard.wizard.fields
	  };
	})(LocalSelect);

/***/ },
/* 1161 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Form = __webpack_require__(14);
	
	var _Field = __webpack_require__(25);
	
	var _SearchControl = __webpack_require__(307);
	
	var _SearchControl2 = _interopRequireDefault(_SearchControl);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var NameQualifiedOrg = function (_Component) {
	  _inherits(NameQualifiedOrg, _Component);
	
	  function NameQualifiedOrg(props) {
	    _classCallCheck(this, NameQualifiedOrg);
	
	    var _this = _possibleConstructorReturn(this, (NameQualifiedOrg.__proto__ || Object.getPrototypeOf(NameQualifiedOrg)).call(this));
	
	    _this.componentDidMount = function () {
	      if (_this.props.isFirst) {
	        _this.focus();
	      }
	    };
	
	    _this.selectResult = function (SELECTED) {
	      _this.props.onChange(Object.assign({}, _this.props.value, {
	        SELECTED: SELECTED
	      }));
	    };
	
	    _this.checkForSubmit = function (_ref) {
	      var charCode = _ref.charCode;
	
	      if (charCode === 13) {
	        _this.search();
	      }
	    };
	
	    _this.deSelect = function () {
	      _this.props.onChange(Object.assign({}, _this.props.value, { SELECTED: null, SOURCE_ID: "0" }), {});
	    };
	
	    _this.setFieldValue = function (value, e) {
	      var val = Object.assign({}, _this.props.value, _defineProperty({}, e.target.name, value));
	      _this.props.onChange(val, { target: { name: _this.props.name, value: val } });
	    };
	
	    _this.onBlur = function (value, e) {
	      _this.props.onBlur(_this.props.value, e);
	    };
	
	    _this.setNameValue = function (value, e) {
	      _this.props.onChange(Object.assign({}, _this.props.value, value), e);
	    };
	
	    _this.getFilteredOptions = function (labels) {
	      return labels.reduce(function (options, label, index) {
	        if (label !== "") {
	          return [].concat(_toConsumableArray(options), [{ value: index.toString(), label: label }]);
	        } else {
	          return options;
	        }
	      }, []);
	    };
	
	    _this.getDefaultOrgType = function (currentValue, filteredOptions) {
	      if (filteredOptions.length) {
	        filteredOptions.forEach(function (option) {
	          if (option.value === currentValue) {
	            return option.value;
	          }
	        });
	        return filteredOptions[0].value;
	      }
	    };
	
	    _this.focus = function () {
	      _this.radio.focus();
	    };
	
	    _this.state = {
	      search: "",
	      modalOpen: false,
	      results: [],
	      filter: "",
	      loading: props.value.SOURCE_ID !== 0 && props.value.SOURCE_ID !== "0"
	    };
	    return _this;
	  }
	
	  _createClass(NameQualifiedOrg, [{
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _props = this.props,
	          value = _props.value,
	          required = _props.required,
	          disabled = _props.disabled,
	          individualLabel = _props.individualLabel,
	          qualifiedLabel = _props.qualifiedLabel,
	          unqualifiedLabel = _props.unqualifiedLabel,
	          modalTitle = _props.modalTitle,
	          qualifiedPlaceholder = _props.qualifiedPlaceholder,
	          unqualifiedPlaceholder = _props.unqualifiedPlaceholder,
	          parameterFields = _props.parameterFields,
	          additionalParameters = _props.additionalParameters;
	
	      var filteredOptions = this.getFilteredOptions([individualLabel, qualifiedLabel, unqualifiedLabel]);
	      var orgType = value.ORG_TYPE.toString();
	      var isOrganization = orgType === "1" || orgType === "2" ? true : false;
	      return _react2.default.createElement(
	        'div',
	        { className: 'block-wrapper organization-search' },
	        _react2.default.createElement(
	          'div',
	          { className: 'org-type' },
	          _react2.default.createElement(_Form.RadioInput, {
	            onChange: this.setFieldValue,
	            name: 'ORG_TYPE',
	            fieldId: 'ORG_TYPE',
	            options: filteredOptions,
	            value: orgType,
	            disabled: disabled,
	            leftAlign: false,
	            ref: function ref(radio) {
	              _this2.radio = radio;
	            }
	          })
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'dependent-field no-margin-bottom' },
	          isOrganization && _react2.default.createElement(
	            _Field.DumbField,
	            {
	              label: orgType === "1" ? qualifiedLabel : unqualifiedLabel,
	              required: required,
	              description: '',
	              hideLabel: value.selected ? true : false
	            },
	            orgType === "1" ? _react2.default.createElement(
	              'div',
	              { className: 'row' },
	              _react2.default.createElement(
	                'div',
	                { className: 'col-sm-9 col-md-8 col-lg-7' },
	                _react2.default.createElement(_SearchControl2.default, { required: required,
	                  searchType: this.props.searchType,
	                  onChange: this.selectResult,
	                  fieldLabel: qualifiedLabel,
	                  modalTitle: modalTitle,
	                  value: value.SELECTED ? Object.assign({}, value.SELECTED, { SOURCE_ID: value.SOURCE_ID }) : null,
	                  fullWidthResult: true,
	                  placeholder: qualifiedPlaceholder,
	                  disabled: disabled,
	                  parameterFields: parameterFields,
	                  additionalParameters: additionalParameters
	                })
	              )
	            ) : _react2.default.createElement(
	              'div',
	              { className: 'row' },
	              _react2.default.createElement(
	                'div',
	                { className: 'col-sm-9 col-md-8 col-lg-7' },
	                _react2.default.createElement(_Form.TextInput, Object.assign({}, this.props, { value: value.ORG_NAME,
	                  name: 'ORG_NAME',
	                  onBlur: this.onBlur,
	                  width: '100%',
	                  onKeyPress: this.checkForSubmit,
	                  onChange: this.setFieldValue,
	                  placeholder: unqualifiedPlaceholder }))
	              )
	            )
	          ),
	          orgType === '0' && _react2.default.createElement(
	            'div',
	            { className: 'name-margin-override' },
	            _react2.default.createElement(_Form.FullName, Object.assign({}, this.props, { onChange: this.setNameValue, onBlur: this.onBlur }))
	          )
	        )
	      );
	    }
	  }]);
	
	  return NameQualifiedOrg;
	}(_react.Component);
	
	exports.default = NameQualifiedOrg;

/***/ },
/* 1162 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(7);
	
	var _Markdown = __webpack_require__(24);
	
	var _Markdown2 = _interopRequireDefault(_Markdown);
	
	var _utilities = __webpack_require__(8);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Paragraph = function (_React$PureComponent) {
	  _inherits(Paragraph, _React$PureComponent);
	
	  function Paragraph() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, Paragraph);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Paragraph.__proto__ || Object.getPrototypeOf(Paragraph)).call.apply(_ref, [this].concat(args))), _this), _this.getMergedFields = function (value) {
	      return value.replace(/{{FIELD:(.*?)}}/g, function (_, name) {
	        var field = Object.values(_this.props.fields).find(function (f) {
	          return f.name === name;
	        });
	        if (field) {
	          return (0, _utilities.getHumanReadableValueByField)(field);
	        }
	        return '';
	      });
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(Paragraph, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          textAlign = _props.textAlign,
	          width = _props.width,
	          rawValue = _props.value,
	          displayType = _props.displayType,
	          scrollable = _props.scrollable,
	          maxHeight = _props.maxHeight;
	
	      var value = this.getMergedFields(rawValue);
	      return displayType === 'input' ? _react2.default.createElement(
	        'div',
	        {
	          className: 'dummy-text-input ' + (scrollable ? 'scrollable-paragraph' : ''),
	          style: {
	            width: width,
	            maxHeight: scrollable ? maxHeight + 'px' : ''
	          }
	        },
	        value
	      ) : _react2.default.createElement(_Markdown2.default, {
	        className: 'paragraph markdown ' + (scrollable ? 'scrollable-paragraph' : ''),
	        style: {
	          textAlign: textAlign,
	          width: width,
	          maxHeight: scrollable ? maxHeight + 'px' : ''
	        },
	        source: value
	      });
	    }
	  }]);
	
	  return Paragraph;
	}(_react2.default.PureComponent);
	
	exports.default = (0, _reactRedux.connect)(function (state) {
	  return {
	    fields: state.wizard.wizard.fields
	  };
	})(Paragraph);

/***/ },
/* 1163 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _AddressBlock = __webpack_require__(102);
	
	var _AddressBlock2 = _interopRequireDefault(_AddressBlock);
	
	var _Form = __webpack_require__(14);
	
	var _Field = __webpack_require__(25);
	
	var _ResultsDrawer = __webpack_require__(466);
	
	var _Portal = __webpack_require__(12);
	
	var _Portal2 = _interopRequireDefault(_Portal);
	
	var _Modal = __webpack_require__(13);
	
	var _SearchControl = __webpack_require__(307);
	
	var _SearchControl2 = _interopRequireDefault(_SearchControl);
	
	var _plusHeavy = __webpack_require__(128);
	
	var _plusHeavy2 = _interopRequireDefault(_plusHeavy);
	
	var _WizardActions = __webpack_require__(36);
	
	var _utilities = __webpack_require__(8);
	
	var _WizardClasses = __webpack_require__(35);
	
	var _caretDown = __webpack_require__(38);
	
	var _caretDown2 = _interopRequireDefault(_caretDown);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// import filter from 'lodash/filter';
	// import ResultsDrawer from '../../ResultsDrawer/ResultsDrawer';
	
	var RA_NONCOMMERCIAL_LABEL = ({"NODE_ENV":"production","BUILD_DATE":"2025-08-27T15:15:31.687Z","BUILD_NUMBER":"Not Provided","GIT_VERSION":"v1.3.0-381-ga81e29b08","GIT_COMMIT_HASH":"a81e29b085c9268ffd96c78eb734365802722741","GIT_BRANCH":"beta","PUBLIC_URL":"","STATE_ABBR":"MT","STATE_NAME":"Montana","STATE_ORG_TITLE":"Secretary of State","LOGIN_HEADER_IMG_PATH":"","HOME_IMG_FILENAME":"montana.jpg","FAVICON_FILE_NAME":"favicon.ico","ALLOW_E_SIGN_ON_CORRECTIONS":true,"THIRD_PARTY_SIGNING_ALLOWED":false,"MY_ACCOUNT_SAVE_AND_CLOSE_BUTTON":true,"IE_DEPRECATED_MESSAGE":"Internet Explorer is not supported. Please select a supported browser below to access this website.","ADDITIONAL_ROUTES":{"dataRequests":true,"farmBill":true,"apostille":true,"externalHelp":"https://sosmt.gov/business/help-center/","systemAdministration":[{"title":"Saved Payments","parameter":"saved-payments","componentName":"SavedPayments"}]},"SUBROUTES":[{"label":"Business","component":"Business","parameter":"business","myWorkQueueSearch":false,"sourceTypeId":54,"searchMustHaveOneOf":["FILING_TYPE_ID","STATUS_ID","STATE","search"],"serverWebSearchDescription":true,"serverWorkQueueDescription":true,"serverMyRecordsDescription":true,"searchPlaceholder":"Search by name or filing number (X########)","allowEmptySearchTerm":true,"requestCertificateAlternateLabel":"Request Information","fileAmendmentButtonLabel":"Filing Actions","advancedSearchParameters":[{"type":"radio","name":"QUERY_TYPE_ID","defaultValue":1010,"options":[{"value":1010,"label":"Starts with"},{"value":1011,"label":"Contains"},{"value":1012,"label":" Word Contains"}]},{"type":"serverSelect","name":"FILING_TYPE_ID","optionsSrc":"FILING_TYPES","label":"Entity Type","placeholder":"All","defaultValue":"0"},{"type":"serverSelect","name":"FILING_SUBTYPE_ID","optionsSrc":"FILING_SUBTYPES","label":"Entity Subtype","overrideSubOptionsSrcFromParameterName":"FILING_TYPE_ID","placeholder":"All","defaultValue":"0"},{"type":"serverSelect","name":"STATUS_ID","optionsSrc":"FILING_STATUS_WITHOUT_ALL","label":"Status","placeholder":"All","defaultValue":"0"},{"type":"serverSelect","name":"STATE","optionsSrc":"STATE","label":"State","placeholder":"All","defaultValue":""},{"type":"serverSelect","name":"COUNTY","optionsSrc":"COUNTY_SUBOPTION","label":"County","overrideSubOptionsSrcFromParameterName":"STATE","placeholder":"All","defaultValue":""},{"type":"checkbox","name":"CRA_SEARCH_YN","defaultValue":false,"label":"Search by Registered Agent PID"},{"type":"dateRange","name":"FILING_DATE","label":"Registration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}},{"type":"dateRange","name":"EXPIRATION_DATE","label":"Expiration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}}],"myRecordsFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Active"},{"value":2,"label":"Inactive"},{"value":3,"label":"Pending"}]},{"type":"dateRange","name":"DATE_RANGE","label":"Date range","defaultValue":{"start":null,"end":null}}],"myWorkQueueFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Approved"},{"value":2,"label":"Pending Online Payment"},{"value":3,"label":"Pending Review"},{"value":4,"label":"Needs Correction"},{"value":5,"label":"Rejected"},{"value":6,"label":"Draft"}]},{"type":"dateRange","name":"DATE_RANGE","label":"Date range","defaultValue":{"start":null,"end":null}}]},{"label":"Notary","component":"Notary","parameter":"notary","sourceTypeId":850,"myWorkQueueSearch":false,"allowEmptySearchTerm":true,"requestCertificateAlternateLabel":"Download Certificate","fileAmendmentButtonLabel":"Filing Actions","hideNameRequestCertificate":true,"hideAddressRequestCertificate":true,"hideRecordUserManagment":true,"searchPlaceholder":"Search by name or commission number","searchMustHaveOneOf":["CITY","search","SERVICE_TYPE"],"advancedParametersStartOpen":true,"searchIsSortable":true,"advancedSearchParameters":[{"type":"radio","name":"STARTS_WITH_YN","defaultValue":false,"options":[{"value":true,"label":"Starts with"},{"value":false,"label":"Contains"}]},{"type":"checkbox","name":"ACTIVE_ONLY_YN","defaultValue":true,"label":"Active entities only"},{"type":"text","name":"CITY","defaultValue":"","label":"City"},{"type":"select","name":"SERVICE_TYPE","label":"Special Services Offered","defaultValue":0,"options":[{"value":0,"label":"(N/A)"},{"value":6165,"label":"In-Person Electronic Notarization (IPEN)"},{"value":6166,"label":"Remote Online Notarization (RON)"},{"value":6167,"label":"Mobile Notary Services"},{"value":6168,"label":"Remote Ink Notarization (RIN)"}]}]},{"label":"Apostille","component":"Apostille","parameter":"apostille","sourceTypeId":720,"myRecordsSearch":false,"myWorkQueueSearch":false,"disabled":false,"allowedRoutes":["/forms-manager/","/queue/","/forms/"]},{"label":"Liens","component":"UCC","parameter":"ucc","sourceTypeId":1999,"myRecordsSearch":true,"myWorkQueueSearch":true,"fileAmendmentButtonLabel":"Filing Actions","searchPlaceholder":"Search by name or file number","disabled":false,"serverWebSearchDescription":true,"myRecordsDescription":"","workQueueDescription":"","searchDescription":"","hideRecordUserManagment":true,"searchLiensCheckout":false,"advancedSearchParameters":[{"type":"radio","name":"STARTS_WITH_YN","defaultValue":false,"options":[{"value":true,"label":"Starts with"},{"value":false,"label":"Contains"}]},{"type":"select","name":"STATUS","defaultValue":"ALL","label":"Status","options":[{"value":"ACTIVE_UNLAPSED","label":"Active (unlapsed)"},{"value":"ACTIVE_LAPSED_UNLAPSED","label":"Active (lapsed and unlapsed)"}]},{"type":"text","name":"EXCLUDE_VALUES","label":"Exclude Debtor Names (comma separated list of names to exclude)","defaultValue":""},{"type":"dateRange","name":"FILING_DATE","label":"Financing Statement Date","defaultValue":{"start":null,"end":null}},{"type":"dateRange","name":"LAPSE_DATE","label":"Lapse Date","defaultValue":{"start":null,"end":null}},{"type":"text","name":"CITY","label":"Debtor City","defaultValue":""}],"myRecordsFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Approved"},{"value":2,"label":"Pending Online Payment"},{"value":3,"label":"Pending Review"}]},{"type":"select","name":"TYPE","defaultValue":0,"label":"Lien Type","options":[{"value":0,"label":"All"},{"value":1,"label":"UCC"},{"value":2,"label":"EFS"},{"value":3,"label":"Title 71"}]}],"myWorkQueueFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Approved"},{"value":2,"label":"Pending Online Payment"},{"value":3,"label":"Pending Review"},{"value":4,"label":"Pending Print and Mail"},{"value":5,"label":"Rejected"},{"value":6,"label":"Draft"}]},{"type":"select","name":"TYPE","defaultValue":0,"label":"Lien Type","options":[{"value":0,"label":"All"},{"value":1,"label":"UCC"},{"value":2,"label":"EFS"},{"value":3,"label":"Title 71"}]}]},{"label":"Copy Request","component":"copies","parameter":"copies","sourceTypeId":2001,"myRecordsSearch":false,"myWorkQueueSearch":false,"disabled":false,"allowedRoutes":["/forms-manager/","/queue/","/forms/"]},{"label":"Trademark","component":"Trademark","parameter":"trademark","sourceTypeId":810,"showRequestCertificate":true,"searchMustHaveOneOf":["search","EXPIRATION_DATE","FILING_DATE"],"allowEmptySearchTerm":true,"requestCertificateAlternateLabel":"Request Information","fileAmendmentButtonLabel":"Filing Actions","advancedSearchParameters":[{"type":"radio","name":"QUERY_TYPE_ID","defaultValue":1010,"options":[{"value":1010,"label":"Starts with"},{"value":1011,"label":"Contains"},{"value":1012,"label":" Word Contains"}]},{"type":"checkbox","name":"OWNER_SEARCH_YN","defaultValue":false,"label":"Search owners"},{"type":"radio","name":"SERVICE_MARK_YN","label":"Mark Type","defaultValue":"","options":[{"value":"","label":"All Marks"},{"value":"Y","label":"Service Mark"},{"value":"N","label":"Trademark"}]},{"type":"serverSelect","name":"STATUS_ID","optionsSrc":"TYPE_V|TRADEMARK_STATUS_TYPE","label":"Status","placeholder":"All","defaultValue":"0"},{"type":"select","name":"DESIGN_TYPE_ID","options":[{"value":0,"label":"All"},{"value":990,"label":"Words Only"},{"value":991,"label":"Design Only"},{"value":992,"label":"Words and Design"}],"label":"Design Type","defaultValue":"0"},{"type":"dateRange","name":"FILING_DATE","label":"Registered Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}},{"type":"dateRange","name":"EXPIRATION_DATE","label":"Expiration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}}]},{"label":"Business Info Request","component":"InfoRequests","parameter":"info-request","sourceTypeId":167,"allowedRoutes":["/forms-manager/","/queue/","/forms/"]},{"label":"Data Requests","component":"DataRequests","parameter":"data-request","sourceTypeId":0,"allowedRoutes":["/forms-manager/"]},{"label":"CRA","component":"CRA","parameter":"cra","sourceTypeId":157,"myRecordsSearch":false,"searchPlaceholder":"Search by name or registered agent number","allowedRoutes":["/forms-manager/","/forms/","/records/","/queue/","/search/"],"allowEmptySearchTerm":true,"fileAmendmentButtonLabel":"Filing Actions","advancedSearchParameters":[{"type":"radio","name":"QUERY_TYPE_ID","defaultValue":1010,"options":[{"value":1010,"label":"Starts with"},{"value":1011,"label":"Contains"},{"value":1012,"label":" Word Contains"}]},{"type":"dateRange","name":"CRA_DATE","label":"Registration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}},{"type":"select","name":"STATUS_ID","label":"Status","defaultValue":0,"options":[{"value":0,"label":"All"},{"value":121,"label":"Active"},{"value":122,"label":"Inactive"}]},{"type":"select","name":"AGENT_TYPE_ID","label":"Agent Type","defaultValue":0,"options":[{"value":0,"label":"All"},{"value":460,"label":"Registered Agent"},{"value":461,"label":"Commercial Registered Agent"}]}]},{"label":"Farm Bill","component":"FarmBill","parameter":"farm-bill","path":"/lists/farm-bill","sourceTypeId":0,"myRecordsSearch":false,"allowedRules":["/search/"],"disabled":true,"searchDescription":"To perform a search, enter a debtor name. Your search results may include: exact debtor name, variations of that name and any filing that includes your search criteria. Punctuation is ignored.\n\nYou can click on \"Advanced\" to refine your search. Under “Advanced” you can search by crop, year, county and SSN/FEIN. As a registered Farm Bill Buyer with the Montana Secretary of State’s office it is important to maintain the confidentiality of the information contained within the Farm Bill Master List. The Farm Bill Master List reflects personal data, such as Social Security Numbers, which are a key piece of personal identifiable information to assist you in determining the existence of a lien against a specific debtor. The distribution of this information beyond its intended purpose is strictly prohibited.\n\nThe debtor's tax identification number has been hidden for confidentiality reasons. You may continue to search on a tax ID number and return debtors that match your search criteria. The SSN/FEIN must be entered without dashes or spaces.","searchMustHaveOneOf":["search","UCC_FARM_PRODUCT_ID","COUNTY"],"searchPlaceholder":"Search by debtor name","advancedSearchParameters":[{"type":"ServerMultiComplete","label":"Product code name(s)","name":"UCC_FARM_PRODUCT_ID","defaultValue":"","optionsSrc":"UCC_FARM_PRODUCT_V"},{"type":"MultiComplete","label":"Year or Range of Years","name":"YEAR_NUM","optionsSrc":"years","startYear":"1968","defaultValue":[],"preMergeOptions":[{"value":"ALL","label":"All"}]},{"type":"serverSelect","label":"State","name":"STATE","defaultValue":"MONTANA","optionsSrc":"STATE"},{"type":"ServerMultiComplete","label":"County","name":"COUNTY","defaultValue":[],"optionsSrc":"COUNTY","overrideSubOptionsSrcFromParameterName":"STATE"},{"type":"checkbox","name":"TIN_SEARCH_YN","defaultValue":false,"label":"Tax Identification Number Search"},{"type":"checkbox","name":"TIN_SORT_YN","defaultValue":false,"label":"Unique ID Sort"}]}],"SYSTEM_NICKNAME":"Online Services Portal","PAYMENT_METHODS":[{"type":"bypass"},{"type":"iTransact"}],"PAYMENT_ALLOW_AMEX":true,"SYSTEM_ID_LABEL":"System Id","DOUBLE_COLUMN_PUBLIC_LOGIN":true,"INTERNAL_USER_MANAGEMENT":true,"ALLOW_PUBLIC_JSON_IMPORT":false,"MAX_FILE_UPLOAD_SIZE":10000000,"REFUND_TEXT":"","RETURN_TO_HOME_ON_LOGOUT":true,"CURRENT_SOS_NAME":"Christi Jacobsen","LOGO_FILENAME":"mt-sos-logo.png","LOGO_ALT":"Christi Jacobsen, Montana Secretary of State","LOGO_FULL_WIDTH":true,"HOME_HIDE_AUTH_HINT":true,"HOME_TITLE":"Montana Secretary of State","CUSTOM_TAB_TITLE":"Official Montana","HOME_SUBTITLE":"Online Business Services","ENTITY_NAME_CONSENT_DESCRIPTION":"","ALLOW_USER_PROFILE_EDITING":true,"COMPARE_FOREIGN_NAME_IN_ENTITY_NAME_VALIDATION":true,"FOREIGN_NAME_FIELD_NAME":"KIMA_PARENT_NAME_INFO","LOGIN_TITLE":"Montana Secretary of State Online Filing Portal Login","PUBLIC_LOGIN_LABEL":"Username","REVERSE_LOGIN_COLUMNS":true,"LOGIN_SEAL_FILENAME":"seal_white.png","SEPARATE_USERNAME_AND_EMAIL":true,"CREATE_ACCOUNT_BUTTON_ALIGN_LEFT":true,"CREATE_ACCOUNT_BUTTON_TEXT":"CREATE AN ACCOUNT","PASSWORD_CUSTOM_ERROR_TEXT":"The password must meet all requirements","ACCOUNT_CREATED_MESSAGE":"Please check your email to verify your account to login and allow a few minutes for this message to arrive. Check your junk/spam folders if you do not find the email in your inbox.","PUBLIC_LOGIN_PLACEHOLDER":" ","DISABLE_DEFAULT_PAYMENT_RADIO":true,"CUSTOM_RESET_PASSWORD_ERROR_MESSAGE":"Username invalid - no account found","PUBLIC_LOGIN_CREATE_DESCRIPTION":"### Existing User:\n\n  - Enter your username and password to login.  \n\n\n  #### - OR -  \n\n\n\n  - Forgot password? Click 'Reset Password' and follow the prompts.\n  - Forgot username? Click 'Forgot Username' and follow the prompts.  \n\n\n  ### New User:\n  ","LOGIN_HELP_LINK":"https://sosmt.gov/business/how-do-i/","LOGIN_HELP_LINK_TEXT":"Need Help?","FORGOT_USERNAME_TEXT":"Forgot Username?","LOGIN_ACTIVE_DIRECTORY_TEXT":"State User Login","MULTIPLE_LOGIN_METHODS":true,"HAS_ACTIVE_DIRECTORY_LOGIN":true,"RESET_PASSWORD_WITH_USERNAME":true,"DOWNLOAD_LINK":true,"SHOW_USERNAME_ACCOUNT_CREATE":true,"SHOW_SCROLL_DOWN_ARROW":true,"SHOW_ADDRESS_ACCOUNT_CREATE":true,"TWO_COLUMN_ACCOUNT_CREATE":true,"RESET_PASSWORD_TIP":"A link to change your password has been sent to your email. Please allow a few minutes for this message to arrive. Please check your junk/spam folders if you do not find the email in your inbox.","FORGOT_PASSWORD_LINK_TEXT":"Reset Password","PHONE_NUMBER_OPTIONAL_ACCOUNT_CREATE":true,"SHOW_REQUIRED_INDICATOR_ACCOUNT_CREATE":true,"PASSWORD_REQUIREMENTS_ACCOUNT_CREATE":"\n    <ul>\n      <li>MUST contain at least 8 characters (12+ recommended)</li>\n      <li>MUST contain at least one uppercase letter.</li>\n      <li>MUST contain at least one lowercase letter.</li>\n      <li>MUST contain at least one number.</li>\n      <li>MUST contain at least one special character (!”#$%&'()*+,-./:;<=>?</li>\n    </ul>\n  ","ALLOW_CERTIFICATION_REQUEST":true,"ALLOW_PUBLIC_CERTIFICATE_REQUEST":true,"ALLOW_COPY_REQUEST":false,"ALLOW_CORRECTION_STYLING":true,"HIDE_DEPRECATION_WARNING":false,"AMEND_ROUTE_PUBLIC":true,"SEAL_FILENAME":"seal.png","SHOPPING_CART":true,"ALLOW_PAYMENT_UPDATE_WITH_EMPTY_CART":true,"RA_EMAIL":true,"RA_WEBSITE":true,"RA_NO_DEFAULT_TYPE":true,"RA_ADDRESS_LABEL":"Street Address","RA_TYPE_SELECTION_DEFAULT":true,"RA_DEFAULT_TYPE":"460","RA_OVERRIDE_TYPE_WITH_DEFAULT":true,"RA_PRINCIPAL_ADDRESS_AMS":true,"UPLOAD_AND_SUBMIT_HIDE_IF_ONE_OPTION":true,"PAYMENT_PROCESSING_MESSAGE":"Your payment is processing - Do not close your browser or click the back button","CHECKOUT_BUTTON_WHEN_PROCESSING_TEXT":"Processing","EFS_CROP_PICKER_NONE_LABEL":"Lien Duration","DISALLOWED_WIZARD_PIECES":["FormationLocale"],"REPEATER_SHOW_EDIT_BUTTON":true,"DATA_REQUEST_PAGE_TITLE":"Data Requests and Subscriptions","DATA_REQUEST_SIDEBAR_LABEL":"Data Requests & Subscriptions","LOGIN_REDIRECTS_TO_EPASS":false,"LOGIN_REDIRECTS_TO_ACTIVE_DIRECTORY":true,"LOGIN_ACTIVE_DIRECTORY_LINK":true,"FETCH_EDIT_USER_LINK":false,"LISTS_FETCH_AVAILABLE_LISTS":true,"POST_WIZARD_SUBMIT_REDIRECT_URL":"/","PIN_REQUEST_ATTESTATIONS":true,"PIN_REQUEST_DESCRIPTION":"Click **Request PIN** to have a new PIN sent to the account holder's email address on file.","OWNERSHIP_REQUEST_DESCRIPTION":"To become an **authorized user** of this record, a current **AUTHORIZED USER** will need to grant you access. To request access, click **Request Access** below.","PIN_REQUEST_SUCCESS_MESSAGE":"The PIN you have requested for this entity has been sent to the email associated with your user account.  You should receive the PIN in approximately 3-5 minutes, depending on your email service provider.","APOSTILLE_HEADER_LABEL":"Verification Information","APOSTILLE_NUMBER_LABEL":"Apostille/Authentication","APOSTILLE_CITY_STATE_OVERRIDE":"HELENA, MT","APOSTILLE_FILING_DATE_LABEL":"Issue Date","APOSTILLE_CITY_STATE_IN_CERTIFIED":true,"NOTARY_EXISTING_FILING":true,"ALLOW_REVOKE_OWN_ACCESS_ONLY":false,"HIDE_CANCEL_ON_ONETIME_DATA_REQUESTS":true,"DATA_REQUESTS_IN_SHOPPING_CART":true,"WQ_ALLOW_EDIT_PENDING_PAYMENT":true,"WQ_CONFIRM_ON_DELETE":true,"WQ_DELETE_CONFIRM_MESSAGE":"Deleting this filing will forfeit any money already paid to the Secretary of State. This action is permanent and cannot be undone, are you sure you would like to delete?","PASS_ITEM_GUIDS_ON_CHECKOUT":true,"FORM_REVISION_HISTORY":true,"CHECKOUT_DISCLAIMER":"By entering your credit card and/or checking account information you (i) state that **you are an authorized user** of the credit card and/or electronic check and that the associated information entered (e.g., account holder name, account number, billing address) is accurate, (ii) **you authorize payment processor to charge the amount you have requested** to your credit card and/or funding account, and (iii) **acknowledge if a charge is declined or reversed you may also be assessed a customary charge** by the payment processor for such transactions.","FARM_BILL_SEARCH_CONFIDENTIAL":"As a registered Farm Bill Buyer with the Montana Secretary of State’s office it is important to maintain the confidentiality of the information contained within the Farm Bill Master List. The Farm Bill Master List reflects personal data, such as Social Security Numbers, which are a key piece of personal identifiable information to assist you in determining the existence of a lien against a specific debtor. The distribution of this information beyond its intended purpose is strictly prohibited.\n\n**The debtor's tax identification number has been hidden for confidentiality reasons. You may continue to search on a tax ID number and return debtors that match your search criteria. The SSN/FEIN must be entered without dashes or spaces.  If you need access to the tax identification number to clearly identify the debtor, please contact the UCC unit at (406) 444-3665.**","VIEW_HISTORY_BUTTON_ALT_TEXT":"View Filings","WIZARD_ERROR_TITLE_MESSAGE":"Form Error","FARM_BILL_SEARCH_INTERACTIVE":true,"USE_FARM_BILL_API":true,"DISALLOW_ASSIGN_SELF_AS_RA":true,"DISALLOW_ASSIGN_SELF_AS_PRINCIPAL":true,"USE_TRADEMARK_OWNER_VALIDATION":true,"USE_ALTERNATIVE_FOREIGN_ADDRESS_LABELS":true,"MY_RECEIPTS_FILTER":[{"type":"dateRange","name":"DATE_RANGE","label":"Date range","defaultValue":{"start":null,"end":null}},{"type":"text","name":"REF_NUM","defaultValue":"","label":"Reference Number"},{"type":"text","name":"RECEIPT_NUM","defaultValue":"","label":"Receipt Id"},{"type":"text","name":"AMOUNT","defaultValue":"","label":"Amount"},{"type":"select","name":"TYPE","defaultValue":"","label":"Payment Type","options":[{"value":"","label":"All"},{"value":"CC","label":"Credit Card"},{"value":"Check","label":"Check"}]}],"MY_RECEIPTS_SHOW_IN_SIDEBAR":true,"SHOW_MY_RECEIPTS_HELPER_TEXT":true,"MY_RECEIPTS_HELPER_LABEL":"About Receipt Search","MY_RECEIPTS_HELPER_TEXT":"You can search for receipts based on their descriptions, including the items paid for on the receipt. Use the filters to search for or filter specific information.","FARM_BILL_SUBLINK":{"label":"Farm Bill","component":"FarmBill","parameter":"farm-bill","path":"/lists/farm-bill","sourceTypeId":0,"myRecordsSearch":false,"allowedRules":["/search/"],"disabled":true,"searchDescription":"To perform a search, enter a debtor name. Your search results may include: exact debtor name, variations of that name and any filing that includes your search criteria. Punctuation is ignored.\n\nYou can click on \"Advanced\" to refine your search. Under “Advanced” you can search by crop, year, county and SSN/FEIN. As a registered Farm Bill Buyer with the Montana Secretary of State’s office it is important to maintain the confidentiality of the information contained within the Farm Bill Master List. The Farm Bill Master List reflects personal data, such as Social Security Numbers, which are a key piece of personal identifiable information to assist you in determining the existence of a lien against a specific debtor. The distribution of this information beyond its intended purpose is strictly prohibited.\n\nThe debtor's tax identification number has been hidden for confidentiality reasons. You may continue to search on a tax ID number and return debtors that match your search criteria. The SSN/FEIN must be entered without dashes or spaces.","searchMustHaveOneOf":["search","UCC_FARM_PRODUCT_ID","COUNTY"],"searchPlaceholder":"Search by debtor name","advancedSearchParameters":[{"type":"ServerMultiComplete","label":"Product code name(s)","name":"UCC_FARM_PRODUCT_ID","defaultValue":"","optionsSrc":"UCC_FARM_PRODUCT_V"},{"type":"MultiComplete","label":"Year or Range of Years","name":"YEAR_NUM","optionsSrc":"years","startYear":"1968","defaultValue":[],"preMergeOptions":[{"value":"ALL","label":"All"}]},{"type":"serverSelect","label":"State","name":"STATE","defaultValue":"MONTANA","optionsSrc":"STATE"},{"type":"ServerMultiComplete","label":"County","name":"COUNTY","defaultValue":[],"optionsSrc":"COUNTY","overrideSubOptionsSrcFromParameterName":"STATE"},{"type":"checkbox","name":"TIN_SEARCH_YN","defaultValue":false,"label":"Tax Identification Number Search"},{"type":"checkbox","name":"TIN_SORT_YN","defaultValue":false,"label":"Unique ID Sort"}]},"ALLOW_ADDRESS_VALIDATION_BYPASS_OPTION":true,"DEFAULT_ADDRESS_VALIDATION_BYPASS_OPTION_CHECKED":true}).RA_NONCOMMERCIAL_LABEL;
	var RA_ADDRESS_LABEL = ("Street Address");
	
	var RegisteredAgentSearch = function (_Component) {
	  _inherits(RegisteredAgentSearch, _Component);
	
	  function RegisteredAgentSearch(props) {
	    _classCallCheck(this, RegisteredAgentSearch);
	
	    var _this = _possibleConstructorReturn(this, (RegisteredAgentSearch.__proto__ || Object.getPrototypeOf(RegisteredAgentSearch)).call(this));
	
	    _this.componentDidMount = function () {
	      if (_this.props.isFirst && !_this.props.disabled && _this.focusTarget) {
	        _this.focusTarget.focus();
	      }
	    };
	
	    _this.onChange = function (value, e) {
	      _this.props.onChange(Object.assign({}, _this.props.value, _defineProperty({}, e.target.name, value)), e);
	    };
	
	    _this.setAddressValue = function (address) {
	      _this.props.onChange(Object.assign({}, _this.props.value, address), {});
	    };
	
	    _this.setMailAddressValue = function (address) {
	      _this.props.value.MAIL_ADDR = address;
	      _this.props.onChange(Object.assign({}, _this.props.value), {});
	    };
	
	    _this.toggleModal = function () {
	      _this.setState({ modalOpen: !_this.state.modalOpen });
	    };
	
	    _this.checkForSubmit = function (_ref) {
	      var charCode = _ref.charCode;
	
	      if (charCode === 13) {
	        _this.search();
	      }
	    };
	
	    _this.filter = function (e) {
	      _this.setState({ filter: e.target.value });
	    };
	
	    _this.onFilterKeyUp = function (_ref2) {
	      var keyCode = _ref2.keyCode;
	
	      if (keyCode === 27) {
	        _this.setState({ modalOpen: false });
	        _this.searchRef.current.focus();
	      }
	    };
	
	    _this.selectResult = function (result) {
	      // console.log(result);
	      _this.props.onChange(Object.assign({}, _this.props.value, { SELECTED: result, CRA_ID: result.SOURCE_ID }), {});
	      _this.toggleModal();
	    };
	
	    _this.deSelect = function () {
	      _this.props.onChange(Object.assign({}, _this.props.value, { SELECTED: null, CRA_ID: '0', STATE: _this.props.defaultState }), {});
	    };
	
	    _this.openAgentModal = function () {
	      _this.props.onChange(_this.props.value, {}, { addingAgent: true });
	      _this.agentModal.open();
	    };
	
	    _this.setGlobalModalFlagOff = function () {
	      _this.props.onChange(_this.props.value, {}, { addingAgent: false });
	      // this.clearNewAgent()
	    };
	
	    _this.setNewAgentResult = function () {
	      _this.props.onChange(Object.assign({}, _this.props.value, {
	        NEW: true,
	        ORGANIZATION: _this.props.value.INDIVIDUAL_YN == 'y' ? null : _this.props.value.ORGANIZATION,
	        FIRST_NAME: _this.props.value.INDIVIDUAL_YN == 'y' ? _this.props.value.FIRST_NAME : '',
	        MIDDLE_NAME: _this.props.value.INDIVIDUAL_YN == 'y' ? _this.props.value.MIDDLE_NAME : '',
	        LAST_NAME: _this.props.value.INDIVIDUAL_YN == 'y' ? _this.props.value.LAST_NAME : '',
	        SUFFIX: _this.props.value.INDIVIDUAL_YN == 'y' ? _this.props.value.SUFFIX : ''
	      }), {}, { selected: null });
	    };
	
	    _this.clearNewAgent = function () {
	      _this.props.onChange(Object.assign({}, _this.props.value, {
	        NEW: false,
	        INDIVIDUAL_YN: 'y',
	        FIRST_NAME: '',
	        MIDDLE_NAME: '',
	        LAST_NAME: '',
	        SUFFIX: '',
	        ORGANIZATION: ''
	      }, (0, _WizardClasses.getAddressObject)(), {
	        STATE: _this.props.value.STATE,
	        MAIL_ADDR_BYPASS_YN: null,
	        MAIL_ADDR: (0, _WizardClasses.resolveAgentMailingAddress)(null)
	      }));
	    };
	
	    _this.state = {
	      search: '',
	      modalOpen: false,
	      results: {},
	      filter: ''
	    };
	    _this.searchRef = _react2.default.createRef();
	    return _this;
	  }
	
	  _createClass(RegisteredAgentSearch, [{
	    key: 'toggleResultsDrawer',
	    value: function toggleResultsDrawer() {
	      console.log('Toggled');
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _props = this.props,
	          value = _props.value,
	          required = _props.required,
	          disabled = _props.disabled,
	          showMailingAddress = _props.showMailingAddress,
	          searchPlaceholder = _props.searchPlaceholder,
	          metadata = _props.metadata,
	          fieldId = _props.fieldId,
	          errorMessage = _props.errorMessage,
	          description = _props.description,
	          sectionLabel = _props.sectionLabel,
	          agentType1Label = _props.agentType1Label,
	          agentType2Label = _props.agentType2Label,
	          tooltip = _props.tooltip,
	          modalOrgLabel = _props.modalOrgLabel,
	          modalShowSuffix = _props.modalShowSuffix,
	          typeSelectionDisabled = _props.typeSelectionDisabled;
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'block-wrapper registered-agent-search' },
	        !value.SELECTED && !value.NEW ? _react2.default.createElement(
	          'div',
	          { className: 'row' },
	          _react2.default.createElement(
	            'div',
	            { className: 'col-12' },
	            _react2.default.createElement(
	              'div',
	              { className: 'sub-section ' + (required ? 'required' : '') },
	              _react2.default.createElement(
	                'h3',
	                null,
	                sectionLabel || 'Search for registered agent',
	                tooltip && _react2.default.createElement(_Field.FieldTooltip, { tooltip: tooltip })
	              ),
	              description && _react2.default.createElement(
	                'p',
	                { className: 'description' },
	                description
	              ),
	              !typeSelectionDisabled && _react2.default.createElement(
	                _Field.DumbField,
	                { label: 'Select an agent type', className: 'reg-type' },
	                _react2.default.createElement(_Form.RadioInput, {
	                  label: 'Select an agent type',
	                  onChange: this.onChange,
	                  name: 'TYPE_ID',
	                  options: [{ value: '461', label: agentType1Label || 'Commercial' }, {
	                    value: '460',
	                    label: RA_NONCOMMERCIAL_LABEL || agentType2Label || 'Noncommercial'
	                  }],
	                  fieldId: 'TYPE_ID',
	                  value: value.TYPE_ID.toString(),
	                  disabled: disabled,
	                  leftAlign: true,
	                  ref: function ref(focusTarget) {
	                    _this2.focusTarget = focusTarget;
	                  }
	                })
	              ),
	              value.TYPE_ID && _react2.default.createElement(
	                'div',
	                { className: 'row' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'col-lg-8 col-md-9 col-sm-10 col-xs-12 search-column' },
	                  _react2.default.createElement(
	                    _Field.DumbField,
	                    {
	                      label: 'Name of individual or organization',
	                      fieldId: 'cra-search-' + fieldId
	                    },
	                    _react2.default.createElement(_SearchControl2.default, {
	                      fieldId: 'cra-search-' + fieldId,
	                      name: 'ORGANIZATION',
	                      placeholder: searchPlaceholder,
	                      additionalParameters: {
	                        INCLUDE_CRA_0_YN: 'N',
	                        INCLUDE_CRA_1_YN: 'N',
	                        TYPE_ID: value.TYPE_ID
	                      },
	                      searchType: 'ACTIVE_CRAS',
	                      onChange: this.selectResult,
	                      modalTitle: 'Select a Registered Agent',
	                      value: value.SELECTED,
	                      width: '100%',
	                      disabled: disabled
	                    })
	                  )
	                )
	              ),
	              (value.TYPE_ID === '460' || value.TYPE_ID === 460 || typeSelectionDisabled) && _react2.default.createElement(
	                'div',
	                { className: 'row' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'col-12 new-col' },
	                  _react2.default.createElement(
	                    'span',
	                    null,
	                    'or '
	                  ),
	                  _react2.default.createElement(
	                    'button',
	                    {
	                      type: 'button',
	                      className: 'btn btn-medium-neutral add',
	                      onClick: this.openAgentModal,
	                      disabled: disabled
	                    },
	                    _react2.default.createElement(_plusHeavy2.default, null),
	                    ' Add New Agent'
	                  )
	                )
	              )
	            )
	          )
	        ) : null,
	        value.TYPE_ID.toString() === '460' && !value.SELECTED && !this.state.loading ? _react2.default.createElement('div', { className: 'block-wrapper' }) : value.SELECTED && _react2.default.createElement(
	          'div',
	          { className: 'row' },
	          _react2.default.createElement(
	            'div',
	            { className: 'col-md-8 col-lg-7' },
	            _react2.default.createElement(
	              _ResultsDrawer.Result,
	              {
	                className: 'static static-selected-result animated ' + (!disabled ? 'fadeInUp' : '') + ' fast-animation',
	                data: value.SELECTED
	              },
	              !disabled && _react2.default.createElement(
	                'button',
	                {
	                  type: 'button',
	                  className: 'close',
	                  onClick: this.deSelect,
	                  ref: function ref(focusTarget) {
	                    _this2.focusTarget = focusTarget;
	                  }
	                },
	                _react2.default.createElement('span', { className: 'icon icon-close' })
	              )
	            )
	          )
	        ),
	        value.NEW && _react2.default.createElement(
	          'div',
	          { className: 'row' },
	          _react2.default.createElement(
	            'div',
	            { className: 'col-md-8 col-lg-7' },
	            _react2.default.createElement(
	              _ResultsDrawer.Result,
	              {
	                className: 'static static-selected-result animated ' + (!disabled ? 'fadeInUp' : '') + ' fast-animation',
	                data: {
	                  HEADER1: value.INDIVIDUAL_YN === 'y' ? value.FIRST_NAME + ' ' + (value.MIDDLE_NAME ? value.MIDDLE_NAME + ' ' : '') + value.LAST_NAME + ' ' + (value.SUFFIX ? '' + value.SUFFIX : '') : value.ORGANIZATION.HEADER1,
	                  HEADER2: 'Registered Agent',
	                  SECTIONS: [].concat(_toConsumableArray( true ? [{
	                    label: 'Email',
	                    lines: [{
	                      line: value.EMAIL
	                    }]
	                  }] : []), _toConsumableArray((true) && value.WEBSITE ? [{
	                    label: 'Website',
	                    lines: [{
	                      line: value.WEBSITE
	                    }]
	                  }] : []), [{
	                    label: RA_ADDRESS_LABEL || 'Physical Address',
	                    lines: [{
	                      line: _react2.default.createElement(_utilities.FormattedAddress, { value: value })
	                    }]
	                  }], _toConsumableArray(showMailingAddress ? [{
	                    label: 'Mailing Address',
	                    lines: [{
	                      line: _react2.default.createElement(_utilities.FormattedAddress, { value: value.MAIL_ADDR })
	                    }]
	                  }] : []))
	                }
	              },
	              !disabled && _react2.default.createElement(
	                'button',
	                {
	                  type: 'button',
	                  className: 'close',
	                  onClick: this.clearNewAgent,
	                  ref: function ref(focusTarget) {
	                    _this2.focusTarget = focusTarget;
	                  }
	                },
	                _react2.default.createElement('span', { className: 'icon icon-close' })
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(AddAgentModal, {
	          modalOrgLabel: modalOrgLabel,
	          modalShowSuffix: modalShowSuffix,
	          value: value,
	          metadata: metadata,
	          showMailingAddress: showMailingAddress,
	          fieldId: fieldId,
	          onFieldChange: this.onChange,
	          onPrimaryAddressChange: this.setAddressValue,
	          onMailingAddressChange: this.setMailAddressValue,
	          errorMessage: errorMessage,
	          onSave: this.setNewAgentResult,
	          onClose: this.setGlobalModalFlagOff,
	          onCancel: this.clearNewAgent
	          // onRequestClose={this.closeAgentModal}
	          , parentProps: this.props,
	          ref: function ref(_ref3) {
	            _this2.agentModal = _ref3;
	          }
	        })
	      );
	    }
	  }]);
	
	  return RegisteredAgentSearch;
	}(_react.Component);
	
	exports.default = RegisteredAgentSearch;
	
	var AddAgentModal = function (_Component2) {
	  _inherits(AddAgentModal, _Component2);
	
	  function AddAgentModal() {
	    var _ref4;
	
	    var _temp, _this3, _ret;
	
	    _classCallCheck(this, AddAgentModal);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this3 = _possibleConstructorReturn(this, (_ref4 = AddAgentModal.__proto__ || Object.getPrototypeOf(AddAgentModal)).call.apply(_ref4, [this].concat(args))), _this3), _this3.state = {
	      open: false
	    }, _this3.open = function () {
	      return _this3.setState({ open: true });
	    }, _this3.close = function () {
	      _this3.setState({ open: false });
	      _this3.props.onClose();
	    }, _this3.save = function () {
	      (0, _WizardActions.validateFieldArray)((0, _WizardActions.buildFieldIdList)([_this3.props.fieldId]), function (isValid) {
	        if (isValid) {
	          _this3.modal.closeModal();
	          _this3.props.onSave();
	        }
	      });
	    }, _this3.removeErrorDuplicates = function () {
	      var errorMessage = _this3.props.errorMessage;
	
	      var hashTable = errorMessage.reduce(function (obj, e) {
	        return Object.assign({}, obj, _defineProperty({}, e, true));
	      }, {});
	      return Object.keys(hashTable);
	    }, _this3.componentDidMount = function () {
	      if (true) {
	        window.addEventListener('resize', _this3.handleScroll);
	        _this3.handleScrollUpdate();
	      }
	    }, _this3.componentDidUpdate = function () {
	      if (true) {
	        _this3.handleScrollUpdate();
	      }
	    }, _this3.handleScroll = function (e) {
	      if (true) {
	        var bottom = e.target.scrollHeight - (e.target.scrollTop + e.target.clientHeight) < 10;
	        var scrollable = e.target.scrollHeight - (e.target.scrollTop + e.target.clientHeight) >= 10;
	        _this3.setState(Object.assign({}, _this3.state, {
	          reachedBottom: bottom,
	          isScrollable: scrollable
	        }));
	      }
	    }, _temp), _possibleConstructorReturn(_this3, _ret);
	  }
	
	  _createClass(AddAgentModal, [{
	    key: 'handleScrollUpdate',
	    value: function handleScrollUpdate() {
	      if (true) {
	        var elements = document.getElementsByClassName('registered-agent-modal');
	        if (elements[0]) {
	          var position = elements[0].scrollHeight - (elements[0].clientHeight + elements[0].scrollTop);
	          if (position < 10 && this.state.isScrollable) {
	            this.setState(Object.assign({}, this.state, { isScrollable: false }));
	          } else if (!this.state.isScrollable && position >= 10) {
	            this.setState(Object.assign({}, this.state, { isScrollable: true }));
	          }
	        }
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this4 = this;
	
	      var _props2 = this.props,
	          value = _props2.value,
	          modalOrgLabel = _props2.modalOrgLabel,
	          modalShowSuffix = _props2.modalShowSuffix,
	          showMailingAddress = _props2.showMailingAddress,
	          metadata = _props2.metadata,
	          fieldId = _props2.fieldId,
	          parentProps = _props2.parentProps,
	          onFieldChange = _props2.onFieldChange,
	          onPrimaryAddressChange = _props2.onPrimaryAddressChange,
	          onMailingAddressChange = _props2.onMailingAddressChange,
	          searchPlaceholder = _props2.searchPlaceholder,
	          errorMessage = _props2.errorMessage;
	
	
	      return _react2.default.createElement(
	        _Portal2.default,
	        { isOpened: this.state.open },
	        _react2.default.createElement(
	          _Modal.Modal,
	          {
	            title: 'Add New Agent',
	            closeModal: this.close,
	            cancel: this.props.onCancel,
	            modalSize: 'medium',
	            modalBodyClassName: 'wizard relative-modal',
	            saveAndCloseButton: false,
	            cancelButton: true
	            // closeButton
	            , ref: function ref(_ref5) {
	              _this4.modal = _ref5;
	            }
	          },
	          _react2.default.createElement(
	            'div',
	            {
	              className: 'template sub-section registered-agent-modal',
	              onScroll:  true ? this.handleScroll : null
	            },
	            (true) && this.state.isScrollable ? _react2.default.createElement(
	              _react.Fragment,
	              null,
	              _react2.default.createElement(
	                'div',
	                { className: 'scroll-down-container-bottom-right' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'scroll-down-text' },
	                  'Scroll Down'
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'scroll-down-icon' },
	                  _react2.default.createElement(_caretDown2.default, null)
	                )
	              )
	            ) : null,
	            _react2.default.createElement(
	              _Field.DumbField,
	              { validityClass: parentProps.validityClass, label: 'This Agent is an: ' },
	              _react2.default.createElement(_Form.RadioInput, {
	                onChange: onFieldChange,
	                name: 'INDIVIDUAL_YN',
	                fieldId: 'INDIVIDUAL_YN',
	                options: [{ value: 'y', label: 'Individual' }, { value: 'n', label: modalOrgLabel || 'Organization' }],
	                value: value.INDIVIDUAL_YN,
	                leftAlign: true
	              })
	            ),
	            value.INDIVIDUAL_YN === 'y' ? _react2.default.createElement(
	              'div',
	              { className: 'row' },
	              _react2.default.createElement(
	                'div',
	                { className: 'col-sm-4' },
	                _react2.default.createElement(
	                  _Field.DumbField,
	                  { label: 'First Name', required: true },
	                  _react2.default.createElement(_Form.TextInput, {
	                    autoComplete: 'given-name',
	                    validityClass: parentProps.validityClass,
	                    value: value.FIRST_NAME,
	                    name: 'FIRST_NAME',
	                    onChange: onFieldChange,
	                    onBlur: _utilities.noop,
	                    width: '100%'
	                  })
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'col-sm-3 col-md-2' },
	                _react2.default.createElement(
	                  _Field.DumbField,
	                  { label: 'Middle/Initial' },
	                  _react2.default.createElement(_Form.TextInput, {
	                    autoComplete: 'additional-name',
	                    value: value.MIDDLE_NAME,
	                    name: 'MIDDLE_NAME',
	                    onChange: onFieldChange,
	                    onBlur: _utilities.noop,
	                    width: '100%'
	                  })
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'col-sm-4 col-md-4' },
	                _react2.default.createElement(
	                  _Field.DumbField,
	                  { label: 'Last Name', required: true },
	                  _react2.default.createElement(_Form.TextInput, {
	                    autoComplete: 'family-name',
	                    validityClass: parentProps.validityClass,
	                    value: value.LAST_NAME,
	                    name: 'LAST_NAME',
	                    onChange: onFieldChange,
	                    onBlur: _utilities.noop,
	                    width: '100%'
	                  })
	                )
	              ),
	              modalShowSuffix && _react2.default.createElement(
	                'div',
	                { className: 'col-sm-2 col-md-2' },
	                _react2.default.createElement(
	                  _Field.DumbField,
	                  { label: 'Suffix' },
	                  _react2.default.createElement(_Form.TextInput, {
	                    autoComplete: 'honorific-suffix',
	                    value: value.SUFFIX,
	                    name: 'SUFFIX',
	                    onChange: onFieldChange,
	                    onBlur: _utilities.noop,
	                    width: '100%'
	                  })
	                )
	              )
	            ) : _react2.default.createElement(
	              'div',
	              { className: 'row' },
	              _react2.default.createElement(
	                'div',
	                { className: 'col-sm-11 col-md-10 col-lg-9' },
	                _react2.default.createElement(
	                  _Field.DumbField,
	                  { label: 'Organization', required: true },
	                  _react2.default.createElement(_SearchControl2.default, {
	                    validityClass: parentProps.validityClass,
	                    name: 'ORGANIZATION',
	                    searchType: 'ACTIVE_FILINGS|CRA',
	                    metadata: metadata,
	                    onChange: onFieldChange,
	                    modalTitle: 'Search Valid Organizations',
	                    value: value.ORGANIZATION,
	                    placeholder: searchPlaceholder,
	                    width: '100%'
	                  })
	                )
	              )
	            ),
	            (true) && _react2.default.createElement(
	              'div',
	              { className: 'row' },
	              _react2.default.createElement(
	                'div',
	                { className: 'col-md-7 col-lg-5' },
	                _react2.default.createElement(
	                  _Field.DumbField,
	                  { label: 'Email', required: true },
	                  _react2.default.createElement(_Form.TextInput, {
	                    validityClass: parentProps.validityClass,
	                    value: value.EMAIL,
	                    name: 'EMAIL',
	                    onChange: onFieldChange,
	                    onBlur: _utilities.noop,
	                    width: '100%'
	                  })
	                )
	              )
	            ),
	            (true) && _react2.default.createElement(
	              'div',
	              { className: 'row' },
	              _react2.default.createElement(
	                'div',
	                { className: 'col-md-7 col-lg-5' },
	                _react2.default.createElement(
	                  _Field.DumbField,
	                  { label: 'Website' },
	                  _react2.default.createElement(_Form.TextInput, {
	                    value: value.WEBSITE,
	                    name: 'WEBSITE',
	                    onChange: onFieldChange,
	                    onBlur: _utilities.noop,
	                    width: '100%'
	                  })
	                )
	              )
	            ),
	            _react2.default.createElement(
	              _Field.DumbField,
	              {
	                className: 'cra-address',
	                label: RA_ADDRESS_LABEL ? RA_ADDRESS_LABEL + ':' : 'Physical Address:'
	              },
	              _react2.default.createElement(_AddressBlock2.default, Object.assign({}, parentProps, {
	                singleColSize: 'col-sm-11 col-md-10 col-lg-9',
	                triColSizes: {
	                  CITY: 'col-sm-5 col-md-4 col-lg-3',
	                  STATE: 'col-sm-3 col-md-3 col-lg-3',
	                  POSTAL_CODE: '"col-sm-3 col-md-3 col-lg-3"'
	                },
	                isFirst: false,
	                fieldId: fieldId + '_PRIMARY',
	                disableState: ({"NODE_ENV":"production","BUILD_DATE":"2025-08-27T15:15:31.687Z","BUILD_NUMBER":"Not Provided","GIT_VERSION":"v1.3.0-381-ga81e29b08","GIT_COMMIT_HASH":"a81e29b085c9268ffd96c78eb734365802722741","GIT_BRANCH":"beta","PUBLIC_URL":"","STATE_ABBR":"MT","STATE_NAME":"Montana","STATE_ORG_TITLE":"Secretary of State","LOGIN_HEADER_IMG_PATH":"","HOME_IMG_FILENAME":"montana.jpg","FAVICON_FILE_NAME":"favicon.ico","ALLOW_E_SIGN_ON_CORRECTIONS":true,"THIRD_PARTY_SIGNING_ALLOWED":false,"MY_ACCOUNT_SAVE_AND_CLOSE_BUTTON":true,"IE_DEPRECATED_MESSAGE":"Internet Explorer is not supported. Please select a supported browser below to access this website.","ADDITIONAL_ROUTES":{"dataRequests":true,"farmBill":true,"apostille":true,"externalHelp":"https://sosmt.gov/business/help-center/","systemAdministration":[{"title":"Saved Payments","parameter":"saved-payments","componentName":"SavedPayments"}]},"SUBROUTES":[{"label":"Business","component":"Business","parameter":"business","myWorkQueueSearch":false,"sourceTypeId":54,"searchMustHaveOneOf":["FILING_TYPE_ID","STATUS_ID","STATE","search"],"serverWebSearchDescription":true,"serverWorkQueueDescription":true,"serverMyRecordsDescription":true,"searchPlaceholder":"Search by name or filing number (X########)","allowEmptySearchTerm":true,"requestCertificateAlternateLabel":"Request Information","fileAmendmentButtonLabel":"Filing Actions","advancedSearchParameters":[{"type":"radio","name":"QUERY_TYPE_ID","defaultValue":1010,"options":[{"value":1010,"label":"Starts with"},{"value":1011,"label":"Contains"},{"value":1012,"label":" Word Contains"}]},{"type":"serverSelect","name":"FILING_TYPE_ID","optionsSrc":"FILING_TYPES","label":"Entity Type","placeholder":"All","defaultValue":"0"},{"type":"serverSelect","name":"FILING_SUBTYPE_ID","optionsSrc":"FILING_SUBTYPES","label":"Entity Subtype","overrideSubOptionsSrcFromParameterName":"FILING_TYPE_ID","placeholder":"All","defaultValue":"0"},{"type":"serverSelect","name":"STATUS_ID","optionsSrc":"FILING_STATUS_WITHOUT_ALL","label":"Status","placeholder":"All","defaultValue":"0"},{"type":"serverSelect","name":"STATE","optionsSrc":"STATE","label":"State","placeholder":"All","defaultValue":""},{"type":"serverSelect","name":"COUNTY","optionsSrc":"COUNTY_SUBOPTION","label":"County","overrideSubOptionsSrcFromParameterName":"STATE","placeholder":"All","defaultValue":""},{"type":"checkbox","name":"CRA_SEARCH_YN","defaultValue":false,"label":"Search by Registered Agent PID"},{"type":"dateRange","name":"FILING_DATE","label":"Registration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}},{"type":"dateRange","name":"EXPIRATION_DATE","label":"Expiration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}}],"myRecordsFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Active"},{"value":2,"label":"Inactive"},{"value":3,"label":"Pending"}]},{"type":"dateRange","name":"DATE_RANGE","label":"Date range","defaultValue":{"start":null,"end":null}}],"myWorkQueueFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Approved"},{"value":2,"label":"Pending Online Payment"},{"value":3,"label":"Pending Review"},{"value":4,"label":"Needs Correction"},{"value":5,"label":"Rejected"},{"value":6,"label":"Draft"}]},{"type":"dateRange","name":"DATE_RANGE","label":"Date range","defaultValue":{"start":null,"end":null}}]},{"label":"Notary","component":"Notary","parameter":"notary","sourceTypeId":850,"myWorkQueueSearch":false,"allowEmptySearchTerm":true,"requestCertificateAlternateLabel":"Download Certificate","fileAmendmentButtonLabel":"Filing Actions","hideNameRequestCertificate":true,"hideAddressRequestCertificate":true,"hideRecordUserManagment":true,"searchPlaceholder":"Search by name or commission number","searchMustHaveOneOf":["CITY","search","SERVICE_TYPE"],"advancedParametersStartOpen":true,"searchIsSortable":true,"advancedSearchParameters":[{"type":"radio","name":"STARTS_WITH_YN","defaultValue":false,"options":[{"value":true,"label":"Starts with"},{"value":false,"label":"Contains"}]},{"type":"checkbox","name":"ACTIVE_ONLY_YN","defaultValue":true,"label":"Active entities only"},{"type":"text","name":"CITY","defaultValue":"","label":"City"},{"type":"select","name":"SERVICE_TYPE","label":"Special Services Offered","defaultValue":0,"options":[{"value":0,"label":"(N/A)"},{"value":6165,"label":"In-Person Electronic Notarization (IPEN)"},{"value":6166,"label":"Remote Online Notarization (RON)"},{"value":6167,"label":"Mobile Notary Services"},{"value":6168,"label":"Remote Ink Notarization (RIN)"}]}]},{"label":"Apostille","component":"Apostille","parameter":"apostille","sourceTypeId":720,"myRecordsSearch":false,"myWorkQueueSearch":false,"disabled":false,"allowedRoutes":["/forms-manager/","/queue/","/forms/"]},{"label":"Liens","component":"UCC","parameter":"ucc","sourceTypeId":1999,"myRecordsSearch":true,"myWorkQueueSearch":true,"fileAmendmentButtonLabel":"Filing Actions","searchPlaceholder":"Search by name or file number","disabled":false,"serverWebSearchDescription":true,"myRecordsDescription":"","workQueueDescription":"","searchDescription":"","hideRecordUserManagment":true,"searchLiensCheckout":false,"advancedSearchParameters":[{"type":"radio","name":"STARTS_WITH_YN","defaultValue":false,"options":[{"value":true,"label":"Starts with"},{"value":false,"label":"Contains"}]},{"type":"select","name":"STATUS","defaultValue":"ALL","label":"Status","options":[{"value":"ACTIVE_UNLAPSED","label":"Active (unlapsed)"},{"value":"ACTIVE_LAPSED_UNLAPSED","label":"Active (lapsed and unlapsed)"}]},{"type":"text","name":"EXCLUDE_VALUES","label":"Exclude Debtor Names (comma separated list of names to exclude)","defaultValue":""},{"type":"dateRange","name":"FILING_DATE","label":"Financing Statement Date","defaultValue":{"start":null,"end":null}},{"type":"dateRange","name":"LAPSE_DATE","label":"Lapse Date","defaultValue":{"start":null,"end":null}},{"type":"text","name":"CITY","label":"Debtor City","defaultValue":""}],"myRecordsFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Approved"},{"value":2,"label":"Pending Online Payment"},{"value":3,"label":"Pending Review"}]},{"type":"select","name":"TYPE","defaultValue":0,"label":"Lien Type","options":[{"value":0,"label":"All"},{"value":1,"label":"UCC"},{"value":2,"label":"EFS"},{"value":3,"label":"Title 71"}]}],"myWorkQueueFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Approved"},{"value":2,"label":"Pending Online Payment"},{"value":3,"label":"Pending Review"},{"value":4,"label":"Pending Print and Mail"},{"value":5,"label":"Rejected"},{"value":6,"label":"Draft"}]},{"type":"select","name":"TYPE","defaultValue":0,"label":"Lien Type","options":[{"value":0,"label":"All"},{"value":1,"label":"UCC"},{"value":2,"label":"EFS"},{"value":3,"label":"Title 71"}]}]},{"label":"Copy Request","component":"copies","parameter":"copies","sourceTypeId":2001,"myRecordsSearch":false,"myWorkQueueSearch":false,"disabled":false,"allowedRoutes":["/forms-manager/","/queue/","/forms/"]},{"label":"Trademark","component":"Trademark","parameter":"trademark","sourceTypeId":810,"showRequestCertificate":true,"searchMustHaveOneOf":["search","EXPIRATION_DATE","FILING_DATE"],"allowEmptySearchTerm":true,"requestCertificateAlternateLabel":"Request Information","fileAmendmentButtonLabel":"Filing Actions","advancedSearchParameters":[{"type":"radio","name":"QUERY_TYPE_ID","defaultValue":1010,"options":[{"value":1010,"label":"Starts with"},{"value":1011,"label":"Contains"},{"value":1012,"label":" Word Contains"}]},{"type":"checkbox","name":"OWNER_SEARCH_YN","defaultValue":false,"label":"Search owners"},{"type":"radio","name":"SERVICE_MARK_YN","label":"Mark Type","defaultValue":"","options":[{"value":"","label":"All Marks"},{"value":"Y","label":"Service Mark"},{"value":"N","label":"Trademark"}]},{"type":"serverSelect","name":"STATUS_ID","optionsSrc":"TYPE_V|TRADEMARK_STATUS_TYPE","label":"Status","placeholder":"All","defaultValue":"0"},{"type":"select","name":"DESIGN_TYPE_ID","options":[{"value":0,"label":"All"},{"value":990,"label":"Words Only"},{"value":991,"label":"Design Only"},{"value":992,"label":"Words and Design"}],"label":"Design Type","defaultValue":"0"},{"type":"dateRange","name":"FILING_DATE","label":"Registered Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}},{"type":"dateRange","name":"EXPIRATION_DATE","label":"Expiration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}}]},{"label":"Business Info Request","component":"InfoRequests","parameter":"info-request","sourceTypeId":167,"allowedRoutes":["/forms-manager/","/queue/","/forms/"]},{"label":"Data Requests","component":"DataRequests","parameter":"data-request","sourceTypeId":0,"allowedRoutes":["/forms-manager/"]},{"label":"CRA","component":"CRA","parameter":"cra","sourceTypeId":157,"myRecordsSearch":false,"searchPlaceholder":"Search by name or registered agent number","allowedRoutes":["/forms-manager/","/forms/","/records/","/queue/","/search/"],"allowEmptySearchTerm":true,"fileAmendmentButtonLabel":"Filing Actions","advancedSearchParameters":[{"type":"radio","name":"QUERY_TYPE_ID","defaultValue":1010,"options":[{"value":1010,"label":"Starts with"},{"value":1011,"label":"Contains"},{"value":1012,"label":" Word Contains"}]},{"type":"dateRange","name":"CRA_DATE","label":"Registration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}},{"type":"select","name":"STATUS_ID","label":"Status","defaultValue":0,"options":[{"value":0,"label":"All"},{"value":121,"label":"Active"},{"value":122,"label":"Inactive"}]},{"type":"select","name":"AGENT_TYPE_ID","label":"Agent Type","defaultValue":0,"options":[{"value":0,"label":"All"},{"value":460,"label":"Registered Agent"},{"value":461,"label":"Commercial Registered Agent"}]}]},{"label":"Farm Bill","component":"FarmBill","parameter":"farm-bill","path":"/lists/farm-bill","sourceTypeId":0,"myRecordsSearch":false,"allowedRules":["/search/"],"disabled":true,"searchDescription":"To perform a search, enter a debtor name. Your search results may include: exact debtor name, variations of that name and any filing that includes your search criteria. Punctuation is ignored.\n\nYou can click on \"Advanced\" to refine your search. Under “Advanced” you can search by crop, year, county and SSN/FEIN. As a registered Farm Bill Buyer with the Montana Secretary of State’s office it is important to maintain the confidentiality of the information contained within the Farm Bill Master List. The Farm Bill Master List reflects personal data, such as Social Security Numbers, which are a key piece of personal identifiable information to assist you in determining the existence of a lien against a specific debtor. The distribution of this information beyond its intended purpose is strictly prohibited.\n\nThe debtor's tax identification number has been hidden for confidentiality reasons. You may continue to search on a tax ID number and return debtors that match your search criteria. The SSN/FEIN must be entered without dashes or spaces.","searchMustHaveOneOf":["search","UCC_FARM_PRODUCT_ID","COUNTY"],"searchPlaceholder":"Search by debtor name","advancedSearchParameters":[{"type":"ServerMultiComplete","label":"Product code name(s)","name":"UCC_FARM_PRODUCT_ID","defaultValue":"","optionsSrc":"UCC_FARM_PRODUCT_V"},{"type":"MultiComplete","label":"Year or Range of Years","name":"YEAR_NUM","optionsSrc":"years","startYear":"1968","defaultValue":[],"preMergeOptions":[{"value":"ALL","label":"All"}]},{"type":"serverSelect","label":"State","name":"STATE","defaultValue":"MONTANA","optionsSrc":"STATE"},{"type":"ServerMultiComplete","label":"County","name":"COUNTY","defaultValue":[],"optionsSrc":"COUNTY","overrideSubOptionsSrcFromParameterName":"STATE"},{"type":"checkbox","name":"TIN_SEARCH_YN","defaultValue":false,"label":"Tax Identification Number Search"},{"type":"checkbox","name":"TIN_SORT_YN","defaultValue":false,"label":"Unique ID Sort"}]}],"SYSTEM_NICKNAME":"Online Services Portal","PAYMENT_METHODS":[{"type":"bypass"},{"type":"iTransact"}],"PAYMENT_ALLOW_AMEX":true,"SYSTEM_ID_LABEL":"System Id","DOUBLE_COLUMN_PUBLIC_LOGIN":true,"INTERNAL_USER_MANAGEMENT":true,"ALLOW_PUBLIC_JSON_IMPORT":false,"MAX_FILE_UPLOAD_SIZE":10000000,"REFUND_TEXT":"","RETURN_TO_HOME_ON_LOGOUT":true,"CURRENT_SOS_NAME":"Christi Jacobsen","LOGO_FILENAME":"mt-sos-logo.png","LOGO_ALT":"Christi Jacobsen, Montana Secretary of State","LOGO_FULL_WIDTH":true,"HOME_HIDE_AUTH_HINT":true,"HOME_TITLE":"Montana Secretary of State","CUSTOM_TAB_TITLE":"Official Montana","HOME_SUBTITLE":"Online Business Services","ENTITY_NAME_CONSENT_DESCRIPTION":"","ALLOW_USER_PROFILE_EDITING":true,"COMPARE_FOREIGN_NAME_IN_ENTITY_NAME_VALIDATION":true,"FOREIGN_NAME_FIELD_NAME":"KIMA_PARENT_NAME_INFO","LOGIN_TITLE":"Montana Secretary of State Online Filing Portal Login","PUBLIC_LOGIN_LABEL":"Username","REVERSE_LOGIN_COLUMNS":true,"LOGIN_SEAL_FILENAME":"seal_white.png","SEPARATE_USERNAME_AND_EMAIL":true,"CREATE_ACCOUNT_BUTTON_ALIGN_LEFT":true,"CREATE_ACCOUNT_BUTTON_TEXT":"CREATE AN ACCOUNT","PASSWORD_CUSTOM_ERROR_TEXT":"The password must meet all requirements","ACCOUNT_CREATED_MESSAGE":"Please check your email to verify your account to login and allow a few minutes for this message to arrive. Check your junk/spam folders if you do not find the email in your inbox.","PUBLIC_LOGIN_PLACEHOLDER":" ","DISABLE_DEFAULT_PAYMENT_RADIO":true,"CUSTOM_RESET_PASSWORD_ERROR_MESSAGE":"Username invalid - no account found","PUBLIC_LOGIN_CREATE_DESCRIPTION":"### Existing User:\n\n  - Enter your username and password to login.  \n\n\n  #### - OR -  \n\n\n\n  - Forgot password? Click 'Reset Password' and follow the prompts.\n  - Forgot username? Click 'Forgot Username' and follow the prompts.  \n\n\n  ### New User:\n  ","LOGIN_HELP_LINK":"https://sosmt.gov/business/how-do-i/","LOGIN_HELP_LINK_TEXT":"Need Help?","FORGOT_USERNAME_TEXT":"Forgot Username?","LOGIN_ACTIVE_DIRECTORY_TEXT":"State User Login","MULTIPLE_LOGIN_METHODS":true,"HAS_ACTIVE_DIRECTORY_LOGIN":true,"RESET_PASSWORD_WITH_USERNAME":true,"DOWNLOAD_LINK":true,"SHOW_USERNAME_ACCOUNT_CREATE":true,"SHOW_SCROLL_DOWN_ARROW":true,"SHOW_ADDRESS_ACCOUNT_CREATE":true,"TWO_COLUMN_ACCOUNT_CREATE":true,"RESET_PASSWORD_TIP":"A link to change your password has been sent to your email. Please allow a few minutes for this message to arrive. Please check your junk/spam folders if you do not find the email in your inbox.","FORGOT_PASSWORD_LINK_TEXT":"Reset Password","PHONE_NUMBER_OPTIONAL_ACCOUNT_CREATE":true,"SHOW_REQUIRED_INDICATOR_ACCOUNT_CREATE":true,"PASSWORD_REQUIREMENTS_ACCOUNT_CREATE":"\n    <ul>\n      <li>MUST contain at least 8 characters (12+ recommended)</li>\n      <li>MUST contain at least one uppercase letter.</li>\n      <li>MUST contain at least one lowercase letter.</li>\n      <li>MUST contain at least one number.</li>\n      <li>MUST contain at least one special character (!”#$%&'()*+,-./:;<=>?</li>\n    </ul>\n  ","ALLOW_CERTIFICATION_REQUEST":true,"ALLOW_PUBLIC_CERTIFICATE_REQUEST":true,"ALLOW_COPY_REQUEST":false,"ALLOW_CORRECTION_STYLING":true,"HIDE_DEPRECATION_WARNING":false,"AMEND_ROUTE_PUBLIC":true,"SEAL_FILENAME":"seal.png","SHOPPING_CART":true,"ALLOW_PAYMENT_UPDATE_WITH_EMPTY_CART":true,"RA_EMAIL":true,"RA_WEBSITE":true,"RA_NO_DEFAULT_TYPE":true,"RA_ADDRESS_LABEL":"Street Address","RA_TYPE_SELECTION_DEFAULT":true,"RA_DEFAULT_TYPE":"460","RA_OVERRIDE_TYPE_WITH_DEFAULT":true,"RA_PRINCIPAL_ADDRESS_AMS":true,"UPLOAD_AND_SUBMIT_HIDE_IF_ONE_OPTION":true,"PAYMENT_PROCESSING_MESSAGE":"Your payment is processing - Do not close your browser or click the back button","CHECKOUT_BUTTON_WHEN_PROCESSING_TEXT":"Processing","EFS_CROP_PICKER_NONE_LABEL":"Lien Duration","DISALLOWED_WIZARD_PIECES":["FormationLocale"],"REPEATER_SHOW_EDIT_BUTTON":true,"DATA_REQUEST_PAGE_TITLE":"Data Requests and Subscriptions","DATA_REQUEST_SIDEBAR_LABEL":"Data Requests & Subscriptions","LOGIN_REDIRECTS_TO_EPASS":false,"LOGIN_REDIRECTS_TO_ACTIVE_DIRECTORY":true,"LOGIN_ACTIVE_DIRECTORY_LINK":true,"FETCH_EDIT_USER_LINK":false,"LISTS_FETCH_AVAILABLE_LISTS":true,"POST_WIZARD_SUBMIT_REDIRECT_URL":"/","PIN_REQUEST_ATTESTATIONS":true,"PIN_REQUEST_DESCRIPTION":"Click **Request PIN** to have a new PIN sent to the account holder's email address on file.","OWNERSHIP_REQUEST_DESCRIPTION":"To become an **authorized user** of this record, a current **AUTHORIZED USER** will need to grant you access. To request access, click **Request Access** below.","PIN_REQUEST_SUCCESS_MESSAGE":"The PIN you have requested for this entity has been sent to the email associated with your user account.  You should receive the PIN in approximately 3-5 minutes, depending on your email service provider.","APOSTILLE_HEADER_LABEL":"Verification Information","APOSTILLE_NUMBER_LABEL":"Apostille/Authentication","APOSTILLE_CITY_STATE_OVERRIDE":"HELENA, MT","APOSTILLE_FILING_DATE_LABEL":"Issue Date","APOSTILLE_CITY_STATE_IN_CERTIFIED":true,"NOTARY_EXISTING_FILING":true,"ALLOW_REVOKE_OWN_ACCESS_ONLY":false,"HIDE_CANCEL_ON_ONETIME_DATA_REQUESTS":true,"DATA_REQUESTS_IN_SHOPPING_CART":true,"WQ_ALLOW_EDIT_PENDING_PAYMENT":true,"WQ_CONFIRM_ON_DELETE":true,"WQ_DELETE_CONFIRM_MESSAGE":"Deleting this filing will forfeit any money already paid to the Secretary of State. This action is permanent and cannot be undone, are you sure you would like to delete?","PASS_ITEM_GUIDS_ON_CHECKOUT":true,"FORM_REVISION_HISTORY":true,"CHECKOUT_DISCLAIMER":"By entering your credit card and/or checking account information you (i) state that **you are an authorized user** of the credit card and/or electronic check and that the associated information entered (e.g., account holder name, account number, billing address) is accurate, (ii) **you authorize payment processor to charge the amount you have requested** to your credit card and/or funding account, and (iii) **acknowledge if a charge is declined or reversed you may also be assessed a customary charge** by the payment processor for such transactions.","FARM_BILL_SEARCH_CONFIDENTIAL":"As a registered Farm Bill Buyer with the Montana Secretary of State’s office it is important to maintain the confidentiality of the information contained within the Farm Bill Master List. The Farm Bill Master List reflects personal data, such as Social Security Numbers, which are a key piece of personal identifiable information to assist you in determining the existence of a lien against a specific debtor. The distribution of this information beyond its intended purpose is strictly prohibited.\n\n**The debtor's tax identification number has been hidden for confidentiality reasons. You may continue to search on a tax ID number and return debtors that match your search criteria. The SSN/FEIN must be entered without dashes or spaces.  If you need access to the tax identification number to clearly identify the debtor, please contact the UCC unit at (406) 444-3665.**","VIEW_HISTORY_BUTTON_ALT_TEXT":"View Filings","WIZARD_ERROR_TITLE_MESSAGE":"Form Error","FARM_BILL_SEARCH_INTERACTIVE":true,"USE_FARM_BILL_API":true,"DISALLOW_ASSIGN_SELF_AS_RA":true,"DISALLOW_ASSIGN_SELF_AS_PRINCIPAL":true,"USE_TRADEMARK_OWNER_VALIDATION":true,"USE_ALTERNATIVE_FOREIGN_ADDRESS_LABELS":true,"MY_RECEIPTS_FILTER":[{"type":"dateRange","name":"DATE_RANGE","label":"Date range","defaultValue":{"start":null,"end":null}},{"type":"text","name":"REF_NUM","defaultValue":"","label":"Reference Number"},{"type":"text","name":"RECEIPT_NUM","defaultValue":"","label":"Receipt Id"},{"type":"text","name":"AMOUNT","defaultValue":"","label":"Amount"},{"type":"select","name":"TYPE","defaultValue":"","label":"Payment Type","options":[{"value":"","label":"All"},{"value":"CC","label":"Credit Card"},{"value":"Check","label":"Check"}]}],"MY_RECEIPTS_SHOW_IN_SIDEBAR":true,"SHOW_MY_RECEIPTS_HELPER_TEXT":true,"MY_RECEIPTS_HELPER_LABEL":"About Receipt Search","MY_RECEIPTS_HELPER_TEXT":"You can search for receipts based on their descriptions, including the items paid for on the receipt. Use the filters to search for or filter specific information.","FARM_BILL_SUBLINK":{"label":"Farm Bill","component":"FarmBill","parameter":"farm-bill","path":"/lists/farm-bill","sourceTypeId":0,"myRecordsSearch":false,"allowedRules":["/search/"],"disabled":true,"searchDescription":"To perform a search, enter a debtor name. Your search results may include: exact debtor name, variations of that name and any filing that includes your search criteria. Punctuation is ignored.\n\nYou can click on \"Advanced\" to refine your search. Under “Advanced” you can search by crop, year, county and SSN/FEIN. As a registered Farm Bill Buyer with the Montana Secretary of State’s office it is important to maintain the confidentiality of the information contained within the Farm Bill Master List. The Farm Bill Master List reflects personal data, such as Social Security Numbers, which are a key piece of personal identifiable information to assist you in determining the existence of a lien against a specific debtor. The distribution of this information beyond its intended purpose is strictly prohibited.\n\nThe debtor's tax identification number has been hidden for confidentiality reasons. You may continue to search on a tax ID number and return debtors that match your search criteria. The SSN/FEIN must be entered without dashes or spaces.","searchMustHaveOneOf":["search","UCC_FARM_PRODUCT_ID","COUNTY"],"searchPlaceholder":"Search by debtor name","advancedSearchParameters":[{"type":"ServerMultiComplete","label":"Product code name(s)","name":"UCC_FARM_PRODUCT_ID","defaultValue":"","optionsSrc":"UCC_FARM_PRODUCT_V"},{"type":"MultiComplete","label":"Year or Range of Years","name":"YEAR_NUM","optionsSrc":"years","startYear":"1968","defaultValue":[],"preMergeOptions":[{"value":"ALL","label":"All"}]},{"type":"serverSelect","label":"State","name":"STATE","defaultValue":"MONTANA","optionsSrc":"STATE"},{"type":"ServerMultiComplete","label":"County","name":"COUNTY","defaultValue":[],"optionsSrc":"COUNTY","overrideSubOptionsSrcFromParameterName":"STATE"},{"type":"checkbox","name":"TIN_SEARCH_YN","defaultValue":false,"label":"Tax Identification Number Search"},{"type":"checkbox","name":"TIN_SORT_YN","defaultValue":false,"label":"Unique ID Sort"}]},"ALLOW_ADDRESS_VALIDATION_BYPASS_OPTION":true,"DEFAULT_ADDRESS_VALIDATION_BYPASS_OPTION_CHECKED":true}).RA_PRINCIPLE_STATE_DISABLED !== undefined ? ({"NODE_ENV":"production","BUILD_DATE":"2025-08-27T15:15:31.687Z","BUILD_NUMBER":"Not Provided","GIT_VERSION":"v1.3.0-381-ga81e29b08","GIT_COMMIT_HASH":"a81e29b085c9268ffd96c78eb734365802722741","GIT_BRANCH":"beta","PUBLIC_URL":"","STATE_ABBR":"MT","STATE_NAME":"Montana","STATE_ORG_TITLE":"Secretary of State","LOGIN_HEADER_IMG_PATH":"","HOME_IMG_FILENAME":"montana.jpg","FAVICON_FILE_NAME":"favicon.ico","ALLOW_E_SIGN_ON_CORRECTIONS":true,"THIRD_PARTY_SIGNING_ALLOWED":false,"MY_ACCOUNT_SAVE_AND_CLOSE_BUTTON":true,"IE_DEPRECATED_MESSAGE":"Internet Explorer is not supported. Please select a supported browser below to access this website.","ADDITIONAL_ROUTES":{"dataRequests":true,"farmBill":true,"apostille":true,"externalHelp":"https://sosmt.gov/business/help-center/","systemAdministration":[{"title":"Saved Payments","parameter":"saved-payments","componentName":"SavedPayments"}]},"SUBROUTES":[{"label":"Business","component":"Business","parameter":"business","myWorkQueueSearch":false,"sourceTypeId":54,"searchMustHaveOneOf":["FILING_TYPE_ID","STATUS_ID","STATE","search"],"serverWebSearchDescription":true,"serverWorkQueueDescription":true,"serverMyRecordsDescription":true,"searchPlaceholder":"Search by name or filing number (X########)","allowEmptySearchTerm":true,"requestCertificateAlternateLabel":"Request Information","fileAmendmentButtonLabel":"Filing Actions","advancedSearchParameters":[{"type":"radio","name":"QUERY_TYPE_ID","defaultValue":1010,"options":[{"value":1010,"label":"Starts with"},{"value":1011,"label":"Contains"},{"value":1012,"label":" Word Contains"}]},{"type":"serverSelect","name":"FILING_TYPE_ID","optionsSrc":"FILING_TYPES","label":"Entity Type","placeholder":"All","defaultValue":"0"},{"type":"serverSelect","name":"FILING_SUBTYPE_ID","optionsSrc":"FILING_SUBTYPES","label":"Entity Subtype","overrideSubOptionsSrcFromParameterName":"FILING_TYPE_ID","placeholder":"All","defaultValue":"0"},{"type":"serverSelect","name":"STATUS_ID","optionsSrc":"FILING_STATUS_WITHOUT_ALL","label":"Status","placeholder":"All","defaultValue":"0"},{"type":"serverSelect","name":"STATE","optionsSrc":"STATE","label":"State","placeholder":"All","defaultValue":""},{"type":"serverSelect","name":"COUNTY","optionsSrc":"COUNTY_SUBOPTION","label":"County","overrideSubOptionsSrcFromParameterName":"STATE","placeholder":"All","defaultValue":""},{"type":"checkbox","name":"CRA_SEARCH_YN","defaultValue":false,"label":"Search by Registered Agent PID"},{"type":"dateRange","name":"FILING_DATE","label":"Registration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}},{"type":"dateRange","name":"EXPIRATION_DATE","label":"Expiration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}}],"myRecordsFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Active"},{"value":2,"label":"Inactive"},{"value":3,"label":"Pending"}]},{"type":"dateRange","name":"DATE_RANGE","label":"Date range","defaultValue":{"start":null,"end":null}}],"myWorkQueueFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Approved"},{"value":2,"label":"Pending Online Payment"},{"value":3,"label":"Pending Review"},{"value":4,"label":"Needs Correction"},{"value":5,"label":"Rejected"},{"value":6,"label":"Draft"}]},{"type":"dateRange","name":"DATE_RANGE","label":"Date range","defaultValue":{"start":null,"end":null}}]},{"label":"Notary","component":"Notary","parameter":"notary","sourceTypeId":850,"myWorkQueueSearch":false,"allowEmptySearchTerm":true,"requestCertificateAlternateLabel":"Download Certificate","fileAmendmentButtonLabel":"Filing Actions","hideNameRequestCertificate":true,"hideAddressRequestCertificate":true,"hideRecordUserManagment":true,"searchPlaceholder":"Search by name or commission number","searchMustHaveOneOf":["CITY","search","SERVICE_TYPE"],"advancedParametersStartOpen":true,"searchIsSortable":true,"advancedSearchParameters":[{"type":"radio","name":"STARTS_WITH_YN","defaultValue":false,"options":[{"value":true,"label":"Starts with"},{"value":false,"label":"Contains"}]},{"type":"checkbox","name":"ACTIVE_ONLY_YN","defaultValue":true,"label":"Active entities only"},{"type":"text","name":"CITY","defaultValue":"","label":"City"},{"type":"select","name":"SERVICE_TYPE","label":"Special Services Offered","defaultValue":0,"options":[{"value":0,"label":"(N/A)"},{"value":6165,"label":"In-Person Electronic Notarization (IPEN)"},{"value":6166,"label":"Remote Online Notarization (RON)"},{"value":6167,"label":"Mobile Notary Services"},{"value":6168,"label":"Remote Ink Notarization (RIN)"}]}]},{"label":"Apostille","component":"Apostille","parameter":"apostille","sourceTypeId":720,"myRecordsSearch":false,"myWorkQueueSearch":false,"disabled":false,"allowedRoutes":["/forms-manager/","/queue/","/forms/"]},{"label":"Liens","component":"UCC","parameter":"ucc","sourceTypeId":1999,"myRecordsSearch":true,"myWorkQueueSearch":true,"fileAmendmentButtonLabel":"Filing Actions","searchPlaceholder":"Search by name or file number","disabled":false,"serverWebSearchDescription":true,"myRecordsDescription":"","workQueueDescription":"","searchDescription":"","hideRecordUserManagment":true,"searchLiensCheckout":false,"advancedSearchParameters":[{"type":"radio","name":"STARTS_WITH_YN","defaultValue":false,"options":[{"value":true,"label":"Starts with"},{"value":false,"label":"Contains"}]},{"type":"select","name":"STATUS","defaultValue":"ALL","label":"Status","options":[{"value":"ACTIVE_UNLAPSED","label":"Active (unlapsed)"},{"value":"ACTIVE_LAPSED_UNLAPSED","label":"Active (lapsed and unlapsed)"}]},{"type":"text","name":"EXCLUDE_VALUES","label":"Exclude Debtor Names (comma separated list of names to exclude)","defaultValue":""},{"type":"dateRange","name":"FILING_DATE","label":"Financing Statement Date","defaultValue":{"start":null,"end":null}},{"type":"dateRange","name":"LAPSE_DATE","label":"Lapse Date","defaultValue":{"start":null,"end":null}},{"type":"text","name":"CITY","label":"Debtor City","defaultValue":""}],"myRecordsFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Approved"},{"value":2,"label":"Pending Online Payment"},{"value":3,"label":"Pending Review"}]},{"type":"select","name":"TYPE","defaultValue":0,"label":"Lien Type","options":[{"value":0,"label":"All"},{"value":1,"label":"UCC"},{"value":2,"label":"EFS"},{"value":3,"label":"Title 71"}]}],"myWorkQueueFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Approved"},{"value":2,"label":"Pending Online Payment"},{"value":3,"label":"Pending Review"},{"value":4,"label":"Pending Print and Mail"},{"value":5,"label":"Rejected"},{"value":6,"label":"Draft"}]},{"type":"select","name":"TYPE","defaultValue":0,"label":"Lien Type","options":[{"value":0,"label":"All"},{"value":1,"label":"UCC"},{"value":2,"label":"EFS"},{"value":3,"label":"Title 71"}]}]},{"label":"Copy Request","component":"copies","parameter":"copies","sourceTypeId":2001,"myRecordsSearch":false,"myWorkQueueSearch":false,"disabled":false,"allowedRoutes":["/forms-manager/","/queue/","/forms/"]},{"label":"Trademark","component":"Trademark","parameter":"trademark","sourceTypeId":810,"showRequestCertificate":true,"searchMustHaveOneOf":["search","EXPIRATION_DATE","FILING_DATE"],"allowEmptySearchTerm":true,"requestCertificateAlternateLabel":"Request Information","fileAmendmentButtonLabel":"Filing Actions","advancedSearchParameters":[{"type":"radio","name":"QUERY_TYPE_ID","defaultValue":1010,"options":[{"value":1010,"label":"Starts with"},{"value":1011,"label":"Contains"},{"value":1012,"label":" Word Contains"}]},{"type":"checkbox","name":"OWNER_SEARCH_YN","defaultValue":false,"label":"Search owners"},{"type":"radio","name":"SERVICE_MARK_YN","label":"Mark Type","defaultValue":"","options":[{"value":"","label":"All Marks"},{"value":"Y","label":"Service Mark"},{"value":"N","label":"Trademark"}]},{"type":"serverSelect","name":"STATUS_ID","optionsSrc":"TYPE_V|TRADEMARK_STATUS_TYPE","label":"Status","placeholder":"All","defaultValue":"0"},{"type":"select","name":"DESIGN_TYPE_ID","options":[{"value":0,"label":"All"},{"value":990,"label":"Words Only"},{"value":991,"label":"Design Only"},{"value":992,"label":"Words and Design"}],"label":"Design Type","defaultValue":"0"},{"type":"dateRange","name":"FILING_DATE","label":"Registered Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}},{"type":"dateRange","name":"EXPIRATION_DATE","label":"Expiration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}}]},{"label":"Business Info Request","component":"InfoRequests","parameter":"info-request","sourceTypeId":167,"allowedRoutes":["/forms-manager/","/queue/","/forms/"]},{"label":"Data Requests","component":"DataRequests","parameter":"data-request","sourceTypeId":0,"allowedRoutes":["/forms-manager/"]},{"label":"CRA","component":"CRA","parameter":"cra","sourceTypeId":157,"myRecordsSearch":false,"searchPlaceholder":"Search by name or registered agent number","allowedRoutes":["/forms-manager/","/forms/","/records/","/queue/","/search/"],"allowEmptySearchTerm":true,"fileAmendmentButtonLabel":"Filing Actions","advancedSearchParameters":[{"type":"radio","name":"QUERY_TYPE_ID","defaultValue":1010,"options":[{"value":1010,"label":"Starts with"},{"value":1011,"label":"Contains"},{"value":1012,"label":" Word Contains"}]},{"type":"dateRange","name":"CRA_DATE","label":"Registration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}},{"type":"select","name":"STATUS_ID","label":"Status","defaultValue":0,"options":[{"value":0,"label":"All"},{"value":121,"label":"Active"},{"value":122,"label":"Inactive"}]},{"type":"select","name":"AGENT_TYPE_ID","label":"Agent Type","defaultValue":0,"options":[{"value":0,"label":"All"},{"value":460,"label":"Registered Agent"},{"value":461,"label":"Commercial Registered Agent"}]}]},{"label":"Farm Bill","component":"FarmBill","parameter":"farm-bill","path":"/lists/farm-bill","sourceTypeId":0,"myRecordsSearch":false,"allowedRules":["/search/"],"disabled":true,"searchDescription":"To perform a search, enter a debtor name. Your search results may include: exact debtor name, variations of that name and any filing that includes your search criteria. Punctuation is ignored.\n\nYou can click on \"Advanced\" to refine your search. Under “Advanced” you can search by crop, year, county and SSN/FEIN. As a registered Farm Bill Buyer with the Montana Secretary of State’s office it is important to maintain the confidentiality of the information contained within the Farm Bill Master List. The Farm Bill Master List reflects personal data, such as Social Security Numbers, which are a key piece of personal identifiable information to assist you in determining the existence of a lien against a specific debtor. The distribution of this information beyond its intended purpose is strictly prohibited.\n\nThe debtor's tax identification number has been hidden for confidentiality reasons. You may continue to search on a tax ID number and return debtors that match your search criteria. The SSN/FEIN must be entered without dashes or spaces.","searchMustHaveOneOf":["search","UCC_FARM_PRODUCT_ID","COUNTY"],"searchPlaceholder":"Search by debtor name","advancedSearchParameters":[{"type":"ServerMultiComplete","label":"Product code name(s)","name":"UCC_FARM_PRODUCT_ID","defaultValue":"","optionsSrc":"UCC_FARM_PRODUCT_V"},{"type":"MultiComplete","label":"Year or Range of Years","name":"YEAR_NUM","optionsSrc":"years","startYear":"1968","defaultValue":[],"preMergeOptions":[{"value":"ALL","label":"All"}]},{"type":"serverSelect","label":"State","name":"STATE","defaultValue":"MONTANA","optionsSrc":"STATE"},{"type":"ServerMultiComplete","label":"County","name":"COUNTY","defaultValue":[],"optionsSrc":"COUNTY","overrideSubOptionsSrcFromParameterName":"STATE"},{"type":"checkbox","name":"TIN_SEARCH_YN","defaultValue":false,"label":"Tax Identification Number Search"},{"type":"checkbox","name":"TIN_SORT_YN","defaultValue":false,"label":"Unique ID Sort"}]}],"SYSTEM_NICKNAME":"Online Services Portal","PAYMENT_METHODS":[{"type":"bypass"},{"type":"iTransact"}],"PAYMENT_ALLOW_AMEX":true,"SYSTEM_ID_LABEL":"System Id","DOUBLE_COLUMN_PUBLIC_LOGIN":true,"INTERNAL_USER_MANAGEMENT":true,"ALLOW_PUBLIC_JSON_IMPORT":false,"MAX_FILE_UPLOAD_SIZE":10000000,"REFUND_TEXT":"","RETURN_TO_HOME_ON_LOGOUT":true,"CURRENT_SOS_NAME":"Christi Jacobsen","LOGO_FILENAME":"mt-sos-logo.png","LOGO_ALT":"Christi Jacobsen, Montana Secretary of State","LOGO_FULL_WIDTH":true,"HOME_HIDE_AUTH_HINT":true,"HOME_TITLE":"Montana Secretary of State","CUSTOM_TAB_TITLE":"Official Montana","HOME_SUBTITLE":"Online Business Services","ENTITY_NAME_CONSENT_DESCRIPTION":"","ALLOW_USER_PROFILE_EDITING":true,"COMPARE_FOREIGN_NAME_IN_ENTITY_NAME_VALIDATION":true,"FOREIGN_NAME_FIELD_NAME":"KIMA_PARENT_NAME_INFO","LOGIN_TITLE":"Montana Secretary of State Online Filing Portal Login","PUBLIC_LOGIN_LABEL":"Username","REVERSE_LOGIN_COLUMNS":true,"LOGIN_SEAL_FILENAME":"seal_white.png","SEPARATE_USERNAME_AND_EMAIL":true,"CREATE_ACCOUNT_BUTTON_ALIGN_LEFT":true,"CREATE_ACCOUNT_BUTTON_TEXT":"CREATE AN ACCOUNT","PASSWORD_CUSTOM_ERROR_TEXT":"The password must meet all requirements","ACCOUNT_CREATED_MESSAGE":"Please check your email to verify your account to login and allow a few minutes for this message to arrive. Check your junk/spam folders if you do not find the email in your inbox.","PUBLIC_LOGIN_PLACEHOLDER":" ","DISABLE_DEFAULT_PAYMENT_RADIO":true,"CUSTOM_RESET_PASSWORD_ERROR_MESSAGE":"Username invalid - no account found","PUBLIC_LOGIN_CREATE_DESCRIPTION":"### Existing User:\n\n  - Enter your username and password to login.  \n\n\n  #### - OR -  \n\n\n\n  - Forgot password? Click 'Reset Password' and follow the prompts.\n  - Forgot username? Click 'Forgot Username' and follow the prompts.  \n\n\n  ### New User:\n  ","LOGIN_HELP_LINK":"https://sosmt.gov/business/how-do-i/","LOGIN_HELP_LINK_TEXT":"Need Help?","FORGOT_USERNAME_TEXT":"Forgot Username?","LOGIN_ACTIVE_DIRECTORY_TEXT":"State User Login","MULTIPLE_LOGIN_METHODS":true,"HAS_ACTIVE_DIRECTORY_LOGIN":true,"RESET_PASSWORD_WITH_USERNAME":true,"DOWNLOAD_LINK":true,"SHOW_USERNAME_ACCOUNT_CREATE":true,"SHOW_SCROLL_DOWN_ARROW":true,"SHOW_ADDRESS_ACCOUNT_CREATE":true,"TWO_COLUMN_ACCOUNT_CREATE":true,"RESET_PASSWORD_TIP":"A link to change your password has been sent to your email. Please allow a few minutes for this message to arrive. Please check your junk/spam folders if you do not find the email in your inbox.","FORGOT_PASSWORD_LINK_TEXT":"Reset Password","PHONE_NUMBER_OPTIONAL_ACCOUNT_CREATE":true,"SHOW_REQUIRED_INDICATOR_ACCOUNT_CREATE":true,"PASSWORD_REQUIREMENTS_ACCOUNT_CREATE":"\n    <ul>\n      <li>MUST contain at least 8 characters (12+ recommended)</li>\n      <li>MUST contain at least one uppercase letter.</li>\n      <li>MUST contain at least one lowercase letter.</li>\n      <li>MUST contain at least one number.</li>\n      <li>MUST contain at least one special character (!”#$%&'()*+,-./:;<=>?</li>\n    </ul>\n  ","ALLOW_CERTIFICATION_REQUEST":true,"ALLOW_PUBLIC_CERTIFICATE_REQUEST":true,"ALLOW_COPY_REQUEST":false,"ALLOW_CORRECTION_STYLING":true,"HIDE_DEPRECATION_WARNING":false,"AMEND_ROUTE_PUBLIC":true,"SEAL_FILENAME":"seal.png","SHOPPING_CART":true,"ALLOW_PAYMENT_UPDATE_WITH_EMPTY_CART":true,"RA_EMAIL":true,"RA_WEBSITE":true,"RA_NO_DEFAULT_TYPE":true,"RA_ADDRESS_LABEL":"Street Address","RA_TYPE_SELECTION_DEFAULT":true,"RA_DEFAULT_TYPE":"460","RA_OVERRIDE_TYPE_WITH_DEFAULT":true,"RA_PRINCIPAL_ADDRESS_AMS":true,"UPLOAD_AND_SUBMIT_HIDE_IF_ONE_OPTION":true,"PAYMENT_PROCESSING_MESSAGE":"Your payment is processing - Do not close your browser or click the back button","CHECKOUT_BUTTON_WHEN_PROCESSING_TEXT":"Processing","EFS_CROP_PICKER_NONE_LABEL":"Lien Duration","DISALLOWED_WIZARD_PIECES":["FormationLocale"],"REPEATER_SHOW_EDIT_BUTTON":true,"DATA_REQUEST_PAGE_TITLE":"Data Requests and Subscriptions","DATA_REQUEST_SIDEBAR_LABEL":"Data Requests & Subscriptions","LOGIN_REDIRECTS_TO_EPASS":false,"LOGIN_REDIRECTS_TO_ACTIVE_DIRECTORY":true,"LOGIN_ACTIVE_DIRECTORY_LINK":true,"FETCH_EDIT_USER_LINK":false,"LISTS_FETCH_AVAILABLE_LISTS":true,"POST_WIZARD_SUBMIT_REDIRECT_URL":"/","PIN_REQUEST_ATTESTATIONS":true,"PIN_REQUEST_DESCRIPTION":"Click **Request PIN** to have a new PIN sent to the account holder's email address on file.","OWNERSHIP_REQUEST_DESCRIPTION":"To become an **authorized user** of this record, a current **AUTHORIZED USER** will need to grant you access. To request access, click **Request Access** below.","PIN_REQUEST_SUCCESS_MESSAGE":"The PIN you have requested for this entity has been sent to the email associated with your user account.  You should receive the PIN in approximately 3-5 minutes, depending on your email service provider.","APOSTILLE_HEADER_LABEL":"Verification Information","APOSTILLE_NUMBER_LABEL":"Apostille/Authentication","APOSTILLE_CITY_STATE_OVERRIDE":"HELENA, MT","APOSTILLE_FILING_DATE_LABEL":"Issue Date","APOSTILLE_CITY_STATE_IN_CERTIFIED":true,"NOTARY_EXISTING_FILING":true,"ALLOW_REVOKE_OWN_ACCESS_ONLY":false,"HIDE_CANCEL_ON_ONETIME_DATA_REQUESTS":true,"DATA_REQUESTS_IN_SHOPPING_CART":true,"WQ_ALLOW_EDIT_PENDING_PAYMENT":true,"WQ_CONFIRM_ON_DELETE":true,"WQ_DELETE_CONFIRM_MESSAGE":"Deleting this filing will forfeit any money already paid to the Secretary of State. This action is permanent and cannot be undone, are you sure you would like to delete?","PASS_ITEM_GUIDS_ON_CHECKOUT":true,"FORM_REVISION_HISTORY":true,"CHECKOUT_DISCLAIMER":"By entering your credit card and/or checking account information you (i) state that **you are an authorized user** of the credit card and/or electronic check and that the associated information entered (e.g., account holder name, account number, billing address) is accurate, (ii) **you authorize payment processor to charge the amount you have requested** to your credit card and/or funding account, and (iii) **acknowledge if a charge is declined or reversed you may also be assessed a customary charge** by the payment processor for such transactions.","FARM_BILL_SEARCH_CONFIDENTIAL":"As a registered Farm Bill Buyer with the Montana Secretary of State’s office it is important to maintain the confidentiality of the information contained within the Farm Bill Master List. The Farm Bill Master List reflects personal data, such as Social Security Numbers, which are a key piece of personal identifiable information to assist you in determining the existence of a lien against a specific debtor. The distribution of this information beyond its intended purpose is strictly prohibited.\n\n**The debtor's tax identification number has been hidden for confidentiality reasons. You may continue to search on a tax ID number and return debtors that match your search criteria. The SSN/FEIN must be entered without dashes or spaces.  If you need access to the tax identification number to clearly identify the debtor, please contact the UCC unit at (406) 444-3665.**","VIEW_HISTORY_BUTTON_ALT_TEXT":"View Filings","WIZARD_ERROR_TITLE_MESSAGE":"Form Error","FARM_BILL_SEARCH_INTERACTIVE":true,"USE_FARM_BILL_API":true,"DISALLOW_ASSIGN_SELF_AS_RA":true,"DISALLOW_ASSIGN_SELF_AS_PRINCIPAL":true,"USE_TRADEMARK_OWNER_VALIDATION":true,"USE_ALTERNATIVE_FOREIGN_ADDRESS_LABELS":true,"MY_RECEIPTS_FILTER":[{"type":"dateRange","name":"DATE_RANGE","label":"Date range","defaultValue":{"start":null,"end":null}},{"type":"text","name":"REF_NUM","defaultValue":"","label":"Reference Number"},{"type":"text","name":"RECEIPT_NUM","defaultValue":"","label":"Receipt Id"},{"type":"text","name":"AMOUNT","defaultValue":"","label":"Amount"},{"type":"select","name":"TYPE","defaultValue":"","label":"Payment Type","options":[{"value":"","label":"All"},{"value":"CC","label":"Credit Card"},{"value":"Check","label":"Check"}]}],"MY_RECEIPTS_SHOW_IN_SIDEBAR":true,"SHOW_MY_RECEIPTS_HELPER_TEXT":true,"MY_RECEIPTS_HELPER_LABEL":"About Receipt Search","MY_RECEIPTS_HELPER_TEXT":"You can search for receipts based on their descriptions, including the items paid for on the receipt. Use the filters to search for or filter specific information.","FARM_BILL_SUBLINK":{"label":"Farm Bill","component":"FarmBill","parameter":"farm-bill","path":"/lists/farm-bill","sourceTypeId":0,"myRecordsSearch":false,"allowedRules":["/search/"],"disabled":true,"searchDescription":"To perform a search, enter a debtor name. Your search results may include: exact debtor name, variations of that name and any filing that includes your search criteria. Punctuation is ignored.\n\nYou can click on \"Advanced\" to refine your search. Under “Advanced” you can search by crop, year, county and SSN/FEIN. As a registered Farm Bill Buyer with the Montana Secretary of State’s office it is important to maintain the confidentiality of the information contained within the Farm Bill Master List. The Farm Bill Master List reflects personal data, such as Social Security Numbers, which are a key piece of personal identifiable information to assist you in determining the existence of a lien against a specific debtor. The distribution of this information beyond its intended purpose is strictly prohibited.\n\nThe debtor's tax identification number has been hidden for confidentiality reasons. You may continue to search on a tax ID number and return debtors that match your search criteria. The SSN/FEIN must be entered without dashes or spaces.","searchMustHaveOneOf":["search","UCC_FARM_PRODUCT_ID","COUNTY"],"searchPlaceholder":"Search by debtor name","advancedSearchParameters":[{"type":"ServerMultiComplete","label":"Product code name(s)","name":"UCC_FARM_PRODUCT_ID","defaultValue":"","optionsSrc":"UCC_FARM_PRODUCT_V"},{"type":"MultiComplete","label":"Year or Range of Years","name":"YEAR_NUM","optionsSrc":"years","startYear":"1968","defaultValue":[],"preMergeOptions":[{"value":"ALL","label":"All"}]},{"type":"serverSelect","label":"State","name":"STATE","defaultValue":"MONTANA","optionsSrc":"STATE"},{"type":"ServerMultiComplete","label":"County","name":"COUNTY","defaultValue":[],"optionsSrc":"COUNTY","overrideSubOptionsSrcFromParameterName":"STATE"},{"type":"checkbox","name":"TIN_SEARCH_YN","defaultValue":false,"label":"Tax Identification Number Search"},{"type":"checkbox","name":"TIN_SORT_YN","defaultValue":false,"label":"Unique ID Sort"}]},"ALLOW_ADDRESS_VALIDATION_BYPASS_OPTION":true,"DEFAULT_ADDRESS_VALIDATION_BYPASS_OPTION_CHECKED":true}).RA_PRINCIPLE_STATE_DISABLED : parentProps.disableState,
	                value: {
	                  ADDR1: value.ADDR1,
	                  ADDR2: value.ADDR2,
	                  ADDR3: value.ADDR3,
	                  CITY: value.CITY,
	                  STATE: value.STATE,
	                  COUNTY: value.COUNTY,
	                  COUNTRY: value.COUNTRY,
	                  POSTAL_CODE: value.POSTAL_CODE,
	                  MAIL_ADDR_BYPASS_YN: value.MAIL_ADDR_BYPASS_YN
	                },
	                onChange: onPrimaryAddressChange
	              }))
	            ),
	            showMailingAddress ? _react2.default.createElement(
	              _Field.DumbField,
	              { className: 'cra-address', label: 'Mailing Address:' },
	              _react2.default.createElement(_AddressBlock2.default, Object.assign({}, parentProps, {
	                singleColSize: 'col-sm-11 col-md-10 col-lg-9',
	                triColSizes: {
	                  CITY: 'col-sm-5 col-md-4 col-lg-3',
	                  STATE: 'col-sm-3 col-md-3 col-lg-3',
	                  POSTAL_CODE: '"col-sm-3 col-md-3 col-lg-3"'
	                },
	                isFirst: false,
	                fieldId: fieldId + '_MAIL',
	                required: true,
	                disableState: ({"NODE_ENV":"production","BUILD_DATE":"2025-08-27T15:15:31.687Z","BUILD_NUMBER":"Not Provided","GIT_VERSION":"v1.3.0-381-ga81e29b08","GIT_COMMIT_HASH":"a81e29b085c9268ffd96c78eb734365802722741","GIT_BRANCH":"beta","PUBLIC_URL":"","STATE_ABBR":"MT","STATE_NAME":"Montana","STATE_ORG_TITLE":"Secretary of State","LOGIN_HEADER_IMG_PATH":"","HOME_IMG_FILENAME":"montana.jpg","FAVICON_FILE_NAME":"favicon.ico","ALLOW_E_SIGN_ON_CORRECTIONS":true,"THIRD_PARTY_SIGNING_ALLOWED":false,"MY_ACCOUNT_SAVE_AND_CLOSE_BUTTON":true,"IE_DEPRECATED_MESSAGE":"Internet Explorer is not supported. Please select a supported browser below to access this website.","ADDITIONAL_ROUTES":{"dataRequests":true,"farmBill":true,"apostille":true,"externalHelp":"https://sosmt.gov/business/help-center/","systemAdministration":[{"title":"Saved Payments","parameter":"saved-payments","componentName":"SavedPayments"}]},"SUBROUTES":[{"label":"Business","component":"Business","parameter":"business","myWorkQueueSearch":false,"sourceTypeId":54,"searchMustHaveOneOf":["FILING_TYPE_ID","STATUS_ID","STATE","search"],"serverWebSearchDescription":true,"serverWorkQueueDescription":true,"serverMyRecordsDescription":true,"searchPlaceholder":"Search by name or filing number (X########)","allowEmptySearchTerm":true,"requestCertificateAlternateLabel":"Request Information","fileAmendmentButtonLabel":"Filing Actions","advancedSearchParameters":[{"type":"radio","name":"QUERY_TYPE_ID","defaultValue":1010,"options":[{"value":1010,"label":"Starts with"},{"value":1011,"label":"Contains"},{"value":1012,"label":" Word Contains"}]},{"type":"serverSelect","name":"FILING_TYPE_ID","optionsSrc":"FILING_TYPES","label":"Entity Type","placeholder":"All","defaultValue":"0"},{"type":"serverSelect","name":"FILING_SUBTYPE_ID","optionsSrc":"FILING_SUBTYPES","label":"Entity Subtype","overrideSubOptionsSrcFromParameterName":"FILING_TYPE_ID","placeholder":"All","defaultValue":"0"},{"type":"serverSelect","name":"STATUS_ID","optionsSrc":"FILING_STATUS_WITHOUT_ALL","label":"Status","placeholder":"All","defaultValue":"0"},{"type":"serverSelect","name":"STATE","optionsSrc":"STATE","label":"State","placeholder":"All","defaultValue":""},{"type":"serverSelect","name":"COUNTY","optionsSrc":"COUNTY_SUBOPTION","label":"County","overrideSubOptionsSrcFromParameterName":"STATE","placeholder":"All","defaultValue":""},{"type":"checkbox","name":"CRA_SEARCH_YN","defaultValue":false,"label":"Search by Registered Agent PID"},{"type":"dateRange","name":"FILING_DATE","label":"Registration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}},{"type":"dateRange","name":"EXPIRATION_DATE","label":"Expiration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}}],"myRecordsFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Active"},{"value":2,"label":"Inactive"},{"value":3,"label":"Pending"}]},{"type":"dateRange","name":"DATE_RANGE","label":"Date range","defaultValue":{"start":null,"end":null}}],"myWorkQueueFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Approved"},{"value":2,"label":"Pending Online Payment"},{"value":3,"label":"Pending Review"},{"value":4,"label":"Needs Correction"},{"value":5,"label":"Rejected"},{"value":6,"label":"Draft"}]},{"type":"dateRange","name":"DATE_RANGE","label":"Date range","defaultValue":{"start":null,"end":null}}]},{"label":"Notary","component":"Notary","parameter":"notary","sourceTypeId":850,"myWorkQueueSearch":false,"allowEmptySearchTerm":true,"requestCertificateAlternateLabel":"Download Certificate","fileAmendmentButtonLabel":"Filing Actions","hideNameRequestCertificate":true,"hideAddressRequestCertificate":true,"hideRecordUserManagment":true,"searchPlaceholder":"Search by name or commission number","searchMustHaveOneOf":["CITY","search","SERVICE_TYPE"],"advancedParametersStartOpen":true,"searchIsSortable":true,"advancedSearchParameters":[{"type":"radio","name":"STARTS_WITH_YN","defaultValue":false,"options":[{"value":true,"label":"Starts with"},{"value":false,"label":"Contains"}]},{"type":"checkbox","name":"ACTIVE_ONLY_YN","defaultValue":true,"label":"Active entities only"},{"type":"text","name":"CITY","defaultValue":"","label":"City"},{"type":"select","name":"SERVICE_TYPE","label":"Special Services Offered","defaultValue":0,"options":[{"value":0,"label":"(N/A)"},{"value":6165,"label":"In-Person Electronic Notarization (IPEN)"},{"value":6166,"label":"Remote Online Notarization (RON)"},{"value":6167,"label":"Mobile Notary Services"},{"value":6168,"label":"Remote Ink Notarization (RIN)"}]}]},{"label":"Apostille","component":"Apostille","parameter":"apostille","sourceTypeId":720,"myRecordsSearch":false,"myWorkQueueSearch":false,"disabled":false,"allowedRoutes":["/forms-manager/","/queue/","/forms/"]},{"label":"Liens","component":"UCC","parameter":"ucc","sourceTypeId":1999,"myRecordsSearch":true,"myWorkQueueSearch":true,"fileAmendmentButtonLabel":"Filing Actions","searchPlaceholder":"Search by name or file number","disabled":false,"serverWebSearchDescription":true,"myRecordsDescription":"","workQueueDescription":"","searchDescription":"","hideRecordUserManagment":true,"searchLiensCheckout":false,"advancedSearchParameters":[{"type":"radio","name":"STARTS_WITH_YN","defaultValue":false,"options":[{"value":true,"label":"Starts with"},{"value":false,"label":"Contains"}]},{"type":"select","name":"STATUS","defaultValue":"ALL","label":"Status","options":[{"value":"ACTIVE_UNLAPSED","label":"Active (unlapsed)"},{"value":"ACTIVE_LAPSED_UNLAPSED","label":"Active (lapsed and unlapsed)"}]},{"type":"text","name":"EXCLUDE_VALUES","label":"Exclude Debtor Names (comma separated list of names to exclude)","defaultValue":""},{"type":"dateRange","name":"FILING_DATE","label":"Financing Statement Date","defaultValue":{"start":null,"end":null}},{"type":"dateRange","name":"LAPSE_DATE","label":"Lapse Date","defaultValue":{"start":null,"end":null}},{"type":"text","name":"CITY","label":"Debtor City","defaultValue":""}],"myRecordsFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Approved"},{"value":2,"label":"Pending Online Payment"},{"value":3,"label":"Pending Review"}]},{"type":"select","name":"TYPE","defaultValue":0,"label":"Lien Type","options":[{"value":0,"label":"All"},{"value":1,"label":"UCC"},{"value":2,"label":"EFS"},{"value":3,"label":"Title 71"}]}],"myWorkQueueFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Approved"},{"value":2,"label":"Pending Online Payment"},{"value":3,"label":"Pending Review"},{"value":4,"label":"Pending Print and Mail"},{"value":5,"label":"Rejected"},{"value":6,"label":"Draft"}]},{"type":"select","name":"TYPE","defaultValue":0,"label":"Lien Type","options":[{"value":0,"label":"All"},{"value":1,"label":"UCC"},{"value":2,"label":"EFS"},{"value":3,"label":"Title 71"}]}]},{"label":"Copy Request","component":"copies","parameter":"copies","sourceTypeId":2001,"myRecordsSearch":false,"myWorkQueueSearch":false,"disabled":false,"allowedRoutes":["/forms-manager/","/queue/","/forms/"]},{"label":"Trademark","component":"Trademark","parameter":"trademark","sourceTypeId":810,"showRequestCertificate":true,"searchMustHaveOneOf":["search","EXPIRATION_DATE","FILING_DATE"],"allowEmptySearchTerm":true,"requestCertificateAlternateLabel":"Request Information","fileAmendmentButtonLabel":"Filing Actions","advancedSearchParameters":[{"type":"radio","name":"QUERY_TYPE_ID","defaultValue":1010,"options":[{"value":1010,"label":"Starts with"},{"value":1011,"label":"Contains"},{"value":1012,"label":" Word Contains"}]},{"type":"checkbox","name":"OWNER_SEARCH_YN","defaultValue":false,"label":"Search owners"},{"type":"radio","name":"SERVICE_MARK_YN","label":"Mark Type","defaultValue":"","options":[{"value":"","label":"All Marks"},{"value":"Y","label":"Service Mark"},{"value":"N","label":"Trademark"}]},{"type":"serverSelect","name":"STATUS_ID","optionsSrc":"TYPE_V|TRADEMARK_STATUS_TYPE","label":"Status","placeholder":"All","defaultValue":"0"},{"type":"select","name":"DESIGN_TYPE_ID","options":[{"value":0,"label":"All"},{"value":990,"label":"Words Only"},{"value":991,"label":"Design Only"},{"value":992,"label":"Words and Design"}],"label":"Design Type","defaultValue":"0"},{"type":"dateRange","name":"FILING_DATE","label":"Registered Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}},{"type":"dateRange","name":"EXPIRATION_DATE","label":"Expiration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}}]},{"label":"Business Info Request","component":"InfoRequests","parameter":"info-request","sourceTypeId":167,"allowedRoutes":["/forms-manager/","/queue/","/forms/"]},{"label":"Data Requests","component":"DataRequests","parameter":"data-request","sourceTypeId":0,"allowedRoutes":["/forms-manager/"]},{"label":"CRA","component":"CRA","parameter":"cra","sourceTypeId":157,"myRecordsSearch":false,"searchPlaceholder":"Search by name or registered agent number","allowedRoutes":["/forms-manager/","/forms/","/records/","/queue/","/search/"],"allowEmptySearchTerm":true,"fileAmendmentButtonLabel":"Filing Actions","advancedSearchParameters":[{"type":"radio","name":"QUERY_TYPE_ID","defaultValue":1010,"options":[{"value":1010,"label":"Starts with"},{"value":1011,"label":"Contains"},{"value":1012,"label":" Word Contains"}]},{"type":"dateRange","name":"CRA_DATE","label":"Registration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}},{"type":"select","name":"STATUS_ID","label":"Status","defaultValue":0,"options":[{"value":0,"label":"All"},{"value":121,"label":"Active"},{"value":122,"label":"Inactive"}]},{"type":"select","name":"AGENT_TYPE_ID","label":"Agent Type","defaultValue":0,"options":[{"value":0,"label":"All"},{"value":460,"label":"Registered Agent"},{"value":461,"label":"Commercial Registered Agent"}]}]},{"label":"Farm Bill","component":"FarmBill","parameter":"farm-bill","path":"/lists/farm-bill","sourceTypeId":0,"myRecordsSearch":false,"allowedRules":["/search/"],"disabled":true,"searchDescription":"To perform a search, enter a debtor name. Your search results may include: exact debtor name, variations of that name and any filing that includes your search criteria. Punctuation is ignored.\n\nYou can click on \"Advanced\" to refine your search. Under “Advanced” you can search by crop, year, county and SSN/FEIN. As a registered Farm Bill Buyer with the Montana Secretary of State’s office it is important to maintain the confidentiality of the information contained within the Farm Bill Master List. The Farm Bill Master List reflects personal data, such as Social Security Numbers, which are a key piece of personal identifiable information to assist you in determining the existence of a lien against a specific debtor. The distribution of this information beyond its intended purpose is strictly prohibited.\n\nThe debtor's tax identification number has been hidden for confidentiality reasons. You may continue to search on a tax ID number and return debtors that match your search criteria. The SSN/FEIN must be entered without dashes or spaces.","searchMustHaveOneOf":["search","UCC_FARM_PRODUCT_ID","COUNTY"],"searchPlaceholder":"Search by debtor name","advancedSearchParameters":[{"type":"ServerMultiComplete","label":"Product code name(s)","name":"UCC_FARM_PRODUCT_ID","defaultValue":"","optionsSrc":"UCC_FARM_PRODUCT_V"},{"type":"MultiComplete","label":"Year or Range of Years","name":"YEAR_NUM","optionsSrc":"years","startYear":"1968","defaultValue":[],"preMergeOptions":[{"value":"ALL","label":"All"}]},{"type":"serverSelect","label":"State","name":"STATE","defaultValue":"MONTANA","optionsSrc":"STATE"},{"type":"ServerMultiComplete","label":"County","name":"COUNTY","defaultValue":[],"optionsSrc":"COUNTY","overrideSubOptionsSrcFromParameterName":"STATE"},{"type":"checkbox","name":"TIN_SEARCH_YN","defaultValue":false,"label":"Tax Identification Number Search"},{"type":"checkbox","name":"TIN_SORT_YN","defaultValue":false,"label":"Unique ID Sort"}]}],"SYSTEM_NICKNAME":"Online Services Portal","PAYMENT_METHODS":[{"type":"bypass"},{"type":"iTransact"}],"PAYMENT_ALLOW_AMEX":true,"SYSTEM_ID_LABEL":"System Id","DOUBLE_COLUMN_PUBLIC_LOGIN":true,"INTERNAL_USER_MANAGEMENT":true,"ALLOW_PUBLIC_JSON_IMPORT":false,"MAX_FILE_UPLOAD_SIZE":10000000,"REFUND_TEXT":"","RETURN_TO_HOME_ON_LOGOUT":true,"CURRENT_SOS_NAME":"Christi Jacobsen","LOGO_FILENAME":"mt-sos-logo.png","LOGO_ALT":"Christi Jacobsen, Montana Secretary of State","LOGO_FULL_WIDTH":true,"HOME_HIDE_AUTH_HINT":true,"HOME_TITLE":"Montana Secretary of State","CUSTOM_TAB_TITLE":"Official Montana","HOME_SUBTITLE":"Online Business Services","ENTITY_NAME_CONSENT_DESCRIPTION":"","ALLOW_USER_PROFILE_EDITING":true,"COMPARE_FOREIGN_NAME_IN_ENTITY_NAME_VALIDATION":true,"FOREIGN_NAME_FIELD_NAME":"KIMA_PARENT_NAME_INFO","LOGIN_TITLE":"Montana Secretary of State Online Filing Portal Login","PUBLIC_LOGIN_LABEL":"Username","REVERSE_LOGIN_COLUMNS":true,"LOGIN_SEAL_FILENAME":"seal_white.png","SEPARATE_USERNAME_AND_EMAIL":true,"CREATE_ACCOUNT_BUTTON_ALIGN_LEFT":true,"CREATE_ACCOUNT_BUTTON_TEXT":"CREATE AN ACCOUNT","PASSWORD_CUSTOM_ERROR_TEXT":"The password must meet all requirements","ACCOUNT_CREATED_MESSAGE":"Please check your email to verify your account to login and allow a few minutes for this message to arrive. Check your junk/spam folders if you do not find the email in your inbox.","PUBLIC_LOGIN_PLACEHOLDER":" ","DISABLE_DEFAULT_PAYMENT_RADIO":true,"CUSTOM_RESET_PASSWORD_ERROR_MESSAGE":"Username invalid - no account found","PUBLIC_LOGIN_CREATE_DESCRIPTION":"### Existing User:\n\n  - Enter your username and password to login.  \n\n\n  #### - OR -  \n\n\n\n  - Forgot password? Click 'Reset Password' and follow the prompts.\n  - Forgot username? Click 'Forgot Username' and follow the prompts.  \n\n\n  ### New User:\n  ","LOGIN_HELP_LINK":"https://sosmt.gov/business/how-do-i/","LOGIN_HELP_LINK_TEXT":"Need Help?","FORGOT_USERNAME_TEXT":"Forgot Username?","LOGIN_ACTIVE_DIRECTORY_TEXT":"State User Login","MULTIPLE_LOGIN_METHODS":true,"HAS_ACTIVE_DIRECTORY_LOGIN":true,"RESET_PASSWORD_WITH_USERNAME":true,"DOWNLOAD_LINK":true,"SHOW_USERNAME_ACCOUNT_CREATE":true,"SHOW_SCROLL_DOWN_ARROW":true,"SHOW_ADDRESS_ACCOUNT_CREATE":true,"TWO_COLUMN_ACCOUNT_CREATE":true,"RESET_PASSWORD_TIP":"A link to change your password has been sent to your email. Please allow a few minutes for this message to arrive. Please check your junk/spam folders if you do not find the email in your inbox.","FORGOT_PASSWORD_LINK_TEXT":"Reset Password","PHONE_NUMBER_OPTIONAL_ACCOUNT_CREATE":true,"SHOW_REQUIRED_INDICATOR_ACCOUNT_CREATE":true,"PASSWORD_REQUIREMENTS_ACCOUNT_CREATE":"\n    <ul>\n      <li>MUST contain at least 8 characters (12+ recommended)</li>\n      <li>MUST contain at least one uppercase letter.</li>\n      <li>MUST contain at least one lowercase letter.</li>\n      <li>MUST contain at least one number.</li>\n      <li>MUST contain at least one special character (!”#$%&'()*+,-./:;<=>?</li>\n    </ul>\n  ","ALLOW_CERTIFICATION_REQUEST":true,"ALLOW_PUBLIC_CERTIFICATE_REQUEST":true,"ALLOW_COPY_REQUEST":false,"ALLOW_CORRECTION_STYLING":true,"HIDE_DEPRECATION_WARNING":false,"AMEND_ROUTE_PUBLIC":true,"SEAL_FILENAME":"seal.png","SHOPPING_CART":true,"ALLOW_PAYMENT_UPDATE_WITH_EMPTY_CART":true,"RA_EMAIL":true,"RA_WEBSITE":true,"RA_NO_DEFAULT_TYPE":true,"RA_ADDRESS_LABEL":"Street Address","RA_TYPE_SELECTION_DEFAULT":true,"RA_DEFAULT_TYPE":"460","RA_OVERRIDE_TYPE_WITH_DEFAULT":true,"RA_PRINCIPAL_ADDRESS_AMS":true,"UPLOAD_AND_SUBMIT_HIDE_IF_ONE_OPTION":true,"PAYMENT_PROCESSING_MESSAGE":"Your payment is processing - Do not close your browser or click the back button","CHECKOUT_BUTTON_WHEN_PROCESSING_TEXT":"Processing","EFS_CROP_PICKER_NONE_LABEL":"Lien Duration","DISALLOWED_WIZARD_PIECES":["FormationLocale"],"REPEATER_SHOW_EDIT_BUTTON":true,"DATA_REQUEST_PAGE_TITLE":"Data Requests and Subscriptions","DATA_REQUEST_SIDEBAR_LABEL":"Data Requests & Subscriptions","LOGIN_REDIRECTS_TO_EPASS":false,"LOGIN_REDIRECTS_TO_ACTIVE_DIRECTORY":true,"LOGIN_ACTIVE_DIRECTORY_LINK":true,"FETCH_EDIT_USER_LINK":false,"LISTS_FETCH_AVAILABLE_LISTS":true,"POST_WIZARD_SUBMIT_REDIRECT_URL":"/","PIN_REQUEST_ATTESTATIONS":true,"PIN_REQUEST_DESCRIPTION":"Click **Request PIN** to have a new PIN sent to the account holder's email address on file.","OWNERSHIP_REQUEST_DESCRIPTION":"To become an **authorized user** of this record, a current **AUTHORIZED USER** will need to grant you access. To request access, click **Request Access** below.","PIN_REQUEST_SUCCESS_MESSAGE":"The PIN you have requested for this entity has been sent to the email associated with your user account.  You should receive the PIN in approximately 3-5 minutes, depending on your email service provider.","APOSTILLE_HEADER_LABEL":"Verification Information","APOSTILLE_NUMBER_LABEL":"Apostille/Authentication","APOSTILLE_CITY_STATE_OVERRIDE":"HELENA, MT","APOSTILLE_FILING_DATE_LABEL":"Issue Date","APOSTILLE_CITY_STATE_IN_CERTIFIED":true,"NOTARY_EXISTING_FILING":true,"ALLOW_REVOKE_OWN_ACCESS_ONLY":false,"HIDE_CANCEL_ON_ONETIME_DATA_REQUESTS":true,"DATA_REQUESTS_IN_SHOPPING_CART":true,"WQ_ALLOW_EDIT_PENDING_PAYMENT":true,"WQ_CONFIRM_ON_DELETE":true,"WQ_DELETE_CONFIRM_MESSAGE":"Deleting this filing will forfeit any money already paid to the Secretary of State. This action is permanent and cannot be undone, are you sure you would like to delete?","PASS_ITEM_GUIDS_ON_CHECKOUT":true,"FORM_REVISION_HISTORY":true,"CHECKOUT_DISCLAIMER":"By entering your credit card and/or checking account information you (i) state that **you are an authorized user** of the credit card and/or electronic check and that the associated information entered (e.g., account holder name, account number, billing address) is accurate, (ii) **you authorize payment processor to charge the amount you have requested** to your credit card and/or funding account, and (iii) **acknowledge if a charge is declined or reversed you may also be assessed a customary charge** by the payment processor for such transactions.","FARM_BILL_SEARCH_CONFIDENTIAL":"As a registered Farm Bill Buyer with the Montana Secretary of State’s office it is important to maintain the confidentiality of the information contained within the Farm Bill Master List. The Farm Bill Master List reflects personal data, such as Social Security Numbers, which are a key piece of personal identifiable information to assist you in determining the existence of a lien against a specific debtor. The distribution of this information beyond its intended purpose is strictly prohibited.\n\n**The debtor's tax identification number has been hidden for confidentiality reasons. You may continue to search on a tax ID number and return debtors that match your search criteria. The SSN/FEIN must be entered without dashes or spaces.  If you need access to the tax identification number to clearly identify the debtor, please contact the UCC unit at (406) 444-3665.**","VIEW_HISTORY_BUTTON_ALT_TEXT":"View Filings","WIZARD_ERROR_TITLE_MESSAGE":"Form Error","FARM_BILL_SEARCH_INTERACTIVE":true,"USE_FARM_BILL_API":true,"DISALLOW_ASSIGN_SELF_AS_RA":true,"DISALLOW_ASSIGN_SELF_AS_PRINCIPAL":true,"USE_TRADEMARK_OWNER_VALIDATION":true,"USE_ALTERNATIVE_FOREIGN_ADDRESS_LABELS":true,"MY_RECEIPTS_FILTER":[{"type":"dateRange","name":"DATE_RANGE","label":"Date range","defaultValue":{"start":null,"end":null}},{"type":"text","name":"REF_NUM","defaultValue":"","label":"Reference Number"},{"type":"text","name":"RECEIPT_NUM","defaultValue":"","label":"Receipt Id"},{"type":"text","name":"AMOUNT","defaultValue":"","label":"Amount"},{"type":"select","name":"TYPE","defaultValue":"","label":"Payment Type","options":[{"value":"","label":"All"},{"value":"CC","label":"Credit Card"},{"value":"Check","label":"Check"}]}],"MY_RECEIPTS_SHOW_IN_SIDEBAR":true,"SHOW_MY_RECEIPTS_HELPER_TEXT":true,"MY_RECEIPTS_HELPER_LABEL":"About Receipt Search","MY_RECEIPTS_HELPER_TEXT":"You can search for receipts based on their descriptions, including the items paid for on the receipt. Use the filters to search for or filter specific information.","FARM_BILL_SUBLINK":{"label":"Farm Bill","component":"FarmBill","parameter":"farm-bill","path":"/lists/farm-bill","sourceTypeId":0,"myRecordsSearch":false,"allowedRules":["/search/"],"disabled":true,"searchDescription":"To perform a search, enter a debtor name. Your search results may include: exact debtor name, variations of that name and any filing that includes your search criteria. Punctuation is ignored.\n\nYou can click on \"Advanced\" to refine your search. Under “Advanced” you can search by crop, year, county and SSN/FEIN. As a registered Farm Bill Buyer with the Montana Secretary of State’s office it is important to maintain the confidentiality of the information contained within the Farm Bill Master List. The Farm Bill Master List reflects personal data, such as Social Security Numbers, which are a key piece of personal identifiable information to assist you in determining the existence of a lien against a specific debtor. The distribution of this information beyond its intended purpose is strictly prohibited.\n\nThe debtor's tax identification number has been hidden for confidentiality reasons. You may continue to search on a tax ID number and return debtors that match your search criteria. The SSN/FEIN must be entered without dashes or spaces.","searchMustHaveOneOf":["search","UCC_FARM_PRODUCT_ID","COUNTY"],"searchPlaceholder":"Search by debtor name","advancedSearchParameters":[{"type":"ServerMultiComplete","label":"Product code name(s)","name":"UCC_FARM_PRODUCT_ID","defaultValue":"","optionsSrc":"UCC_FARM_PRODUCT_V"},{"type":"MultiComplete","label":"Year or Range of Years","name":"YEAR_NUM","optionsSrc":"years","startYear":"1968","defaultValue":[],"preMergeOptions":[{"value":"ALL","label":"All"}]},{"type":"serverSelect","label":"State","name":"STATE","defaultValue":"MONTANA","optionsSrc":"STATE"},{"type":"ServerMultiComplete","label":"County","name":"COUNTY","defaultValue":[],"optionsSrc":"COUNTY","overrideSubOptionsSrcFromParameterName":"STATE"},{"type":"checkbox","name":"TIN_SEARCH_YN","defaultValue":false,"label":"Tax Identification Number Search"},{"type":"checkbox","name":"TIN_SORT_YN","defaultValue":false,"label":"Unique ID Sort"}]},"ALLOW_ADDRESS_VALIDATION_BYPASS_OPTION":true,"DEFAULT_ADDRESS_VALIDATION_BYPASS_OPTION_CHECKED":true}).RA_MAILING_STATE_DISABLED !== undefined ? ({"NODE_ENV":"production","BUILD_DATE":"2025-08-27T15:15:31.687Z","BUILD_NUMBER":"Not Provided","GIT_VERSION":"v1.3.0-381-ga81e29b08","GIT_COMMIT_HASH":"a81e29b085c9268ffd96c78eb734365802722741","GIT_BRANCH":"beta","PUBLIC_URL":"","STATE_ABBR":"MT","STATE_NAME":"Montana","STATE_ORG_TITLE":"Secretary of State","LOGIN_HEADER_IMG_PATH":"","HOME_IMG_FILENAME":"montana.jpg","FAVICON_FILE_NAME":"favicon.ico","ALLOW_E_SIGN_ON_CORRECTIONS":true,"THIRD_PARTY_SIGNING_ALLOWED":false,"MY_ACCOUNT_SAVE_AND_CLOSE_BUTTON":true,"IE_DEPRECATED_MESSAGE":"Internet Explorer is not supported. Please select a supported browser below to access this website.","ADDITIONAL_ROUTES":{"dataRequests":true,"farmBill":true,"apostille":true,"externalHelp":"https://sosmt.gov/business/help-center/","systemAdministration":[{"title":"Saved Payments","parameter":"saved-payments","componentName":"SavedPayments"}]},"SUBROUTES":[{"label":"Business","component":"Business","parameter":"business","myWorkQueueSearch":false,"sourceTypeId":54,"searchMustHaveOneOf":["FILING_TYPE_ID","STATUS_ID","STATE","search"],"serverWebSearchDescription":true,"serverWorkQueueDescription":true,"serverMyRecordsDescription":true,"searchPlaceholder":"Search by name or filing number (X########)","allowEmptySearchTerm":true,"requestCertificateAlternateLabel":"Request Information","fileAmendmentButtonLabel":"Filing Actions","advancedSearchParameters":[{"type":"radio","name":"QUERY_TYPE_ID","defaultValue":1010,"options":[{"value":1010,"label":"Starts with"},{"value":1011,"label":"Contains"},{"value":1012,"label":" Word Contains"}]},{"type":"serverSelect","name":"FILING_TYPE_ID","optionsSrc":"FILING_TYPES","label":"Entity Type","placeholder":"All","defaultValue":"0"},{"type":"serverSelect","name":"FILING_SUBTYPE_ID","optionsSrc":"FILING_SUBTYPES","label":"Entity Subtype","overrideSubOptionsSrcFromParameterName":"FILING_TYPE_ID","placeholder":"All","defaultValue":"0"},{"type":"serverSelect","name":"STATUS_ID","optionsSrc":"FILING_STATUS_WITHOUT_ALL","label":"Status","placeholder":"All","defaultValue":"0"},{"type":"serverSelect","name":"STATE","optionsSrc":"STATE","label":"State","placeholder":"All","defaultValue":""},{"type":"serverSelect","name":"COUNTY","optionsSrc":"COUNTY_SUBOPTION","label":"County","overrideSubOptionsSrcFromParameterName":"STATE","placeholder":"All","defaultValue":""},{"type":"checkbox","name":"CRA_SEARCH_YN","defaultValue":false,"label":"Search by Registered Agent PID"},{"type":"dateRange","name":"FILING_DATE","label":"Registration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}},{"type":"dateRange","name":"EXPIRATION_DATE","label":"Expiration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}}],"myRecordsFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Active"},{"value":2,"label":"Inactive"},{"value":3,"label":"Pending"}]},{"type":"dateRange","name":"DATE_RANGE","label":"Date range","defaultValue":{"start":null,"end":null}}],"myWorkQueueFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Approved"},{"value":2,"label":"Pending Online Payment"},{"value":3,"label":"Pending Review"},{"value":4,"label":"Needs Correction"},{"value":5,"label":"Rejected"},{"value":6,"label":"Draft"}]},{"type":"dateRange","name":"DATE_RANGE","label":"Date range","defaultValue":{"start":null,"end":null}}]},{"label":"Notary","component":"Notary","parameter":"notary","sourceTypeId":850,"myWorkQueueSearch":false,"allowEmptySearchTerm":true,"requestCertificateAlternateLabel":"Download Certificate","fileAmendmentButtonLabel":"Filing Actions","hideNameRequestCertificate":true,"hideAddressRequestCertificate":true,"hideRecordUserManagment":true,"searchPlaceholder":"Search by name or commission number","searchMustHaveOneOf":["CITY","search","SERVICE_TYPE"],"advancedParametersStartOpen":true,"searchIsSortable":true,"advancedSearchParameters":[{"type":"radio","name":"STARTS_WITH_YN","defaultValue":false,"options":[{"value":true,"label":"Starts with"},{"value":false,"label":"Contains"}]},{"type":"checkbox","name":"ACTIVE_ONLY_YN","defaultValue":true,"label":"Active entities only"},{"type":"text","name":"CITY","defaultValue":"","label":"City"},{"type":"select","name":"SERVICE_TYPE","label":"Special Services Offered","defaultValue":0,"options":[{"value":0,"label":"(N/A)"},{"value":6165,"label":"In-Person Electronic Notarization (IPEN)"},{"value":6166,"label":"Remote Online Notarization (RON)"},{"value":6167,"label":"Mobile Notary Services"},{"value":6168,"label":"Remote Ink Notarization (RIN)"}]}]},{"label":"Apostille","component":"Apostille","parameter":"apostille","sourceTypeId":720,"myRecordsSearch":false,"myWorkQueueSearch":false,"disabled":false,"allowedRoutes":["/forms-manager/","/queue/","/forms/"]},{"label":"Liens","component":"UCC","parameter":"ucc","sourceTypeId":1999,"myRecordsSearch":true,"myWorkQueueSearch":true,"fileAmendmentButtonLabel":"Filing Actions","searchPlaceholder":"Search by name or file number","disabled":false,"serverWebSearchDescription":true,"myRecordsDescription":"","workQueueDescription":"","searchDescription":"","hideRecordUserManagment":true,"searchLiensCheckout":false,"advancedSearchParameters":[{"type":"radio","name":"STARTS_WITH_YN","defaultValue":false,"options":[{"value":true,"label":"Starts with"},{"value":false,"label":"Contains"}]},{"type":"select","name":"STATUS","defaultValue":"ALL","label":"Status","options":[{"value":"ACTIVE_UNLAPSED","label":"Active (unlapsed)"},{"value":"ACTIVE_LAPSED_UNLAPSED","label":"Active (lapsed and unlapsed)"}]},{"type":"text","name":"EXCLUDE_VALUES","label":"Exclude Debtor Names (comma separated list of names to exclude)","defaultValue":""},{"type":"dateRange","name":"FILING_DATE","label":"Financing Statement Date","defaultValue":{"start":null,"end":null}},{"type":"dateRange","name":"LAPSE_DATE","label":"Lapse Date","defaultValue":{"start":null,"end":null}},{"type":"text","name":"CITY","label":"Debtor City","defaultValue":""}],"myRecordsFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Approved"},{"value":2,"label":"Pending Online Payment"},{"value":3,"label":"Pending Review"}]},{"type":"select","name":"TYPE","defaultValue":0,"label":"Lien Type","options":[{"value":0,"label":"All"},{"value":1,"label":"UCC"},{"value":2,"label":"EFS"},{"value":3,"label":"Title 71"}]}],"myWorkQueueFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Approved"},{"value":2,"label":"Pending Online Payment"},{"value":3,"label":"Pending Review"},{"value":4,"label":"Pending Print and Mail"},{"value":5,"label":"Rejected"},{"value":6,"label":"Draft"}]},{"type":"select","name":"TYPE","defaultValue":0,"label":"Lien Type","options":[{"value":0,"label":"All"},{"value":1,"label":"UCC"},{"value":2,"label":"EFS"},{"value":3,"label":"Title 71"}]}]},{"label":"Copy Request","component":"copies","parameter":"copies","sourceTypeId":2001,"myRecordsSearch":false,"myWorkQueueSearch":false,"disabled":false,"allowedRoutes":["/forms-manager/","/queue/","/forms/"]},{"label":"Trademark","component":"Trademark","parameter":"trademark","sourceTypeId":810,"showRequestCertificate":true,"searchMustHaveOneOf":["search","EXPIRATION_DATE","FILING_DATE"],"allowEmptySearchTerm":true,"requestCertificateAlternateLabel":"Request Information","fileAmendmentButtonLabel":"Filing Actions","advancedSearchParameters":[{"type":"radio","name":"QUERY_TYPE_ID","defaultValue":1010,"options":[{"value":1010,"label":"Starts with"},{"value":1011,"label":"Contains"},{"value":1012,"label":" Word Contains"}]},{"type":"checkbox","name":"OWNER_SEARCH_YN","defaultValue":false,"label":"Search owners"},{"type":"radio","name":"SERVICE_MARK_YN","label":"Mark Type","defaultValue":"","options":[{"value":"","label":"All Marks"},{"value":"Y","label":"Service Mark"},{"value":"N","label":"Trademark"}]},{"type":"serverSelect","name":"STATUS_ID","optionsSrc":"TYPE_V|TRADEMARK_STATUS_TYPE","label":"Status","placeholder":"All","defaultValue":"0"},{"type":"select","name":"DESIGN_TYPE_ID","options":[{"value":0,"label":"All"},{"value":990,"label":"Words Only"},{"value":991,"label":"Design Only"},{"value":992,"label":"Words and Design"}],"label":"Design Type","defaultValue":"0"},{"type":"dateRange","name":"FILING_DATE","label":"Registered Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}},{"type":"dateRange","name":"EXPIRATION_DATE","label":"Expiration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}}]},{"label":"Business Info Request","component":"InfoRequests","parameter":"info-request","sourceTypeId":167,"allowedRoutes":["/forms-manager/","/queue/","/forms/"]},{"label":"Data Requests","component":"DataRequests","parameter":"data-request","sourceTypeId":0,"allowedRoutes":["/forms-manager/"]},{"label":"CRA","component":"CRA","parameter":"cra","sourceTypeId":157,"myRecordsSearch":false,"searchPlaceholder":"Search by name or registered agent number","allowedRoutes":["/forms-manager/","/forms/","/records/","/queue/","/search/"],"allowEmptySearchTerm":true,"fileAmendmentButtonLabel":"Filing Actions","advancedSearchParameters":[{"type":"radio","name":"QUERY_TYPE_ID","defaultValue":1010,"options":[{"value":1010,"label":"Starts with"},{"value":1011,"label":"Contains"},{"value":1012,"label":" Word Contains"}]},{"type":"dateRange","name":"CRA_DATE","label":"Registration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}},{"type":"select","name":"STATUS_ID","label":"Status","defaultValue":0,"options":[{"value":0,"label":"All"},{"value":121,"label":"Active"},{"value":122,"label":"Inactive"}]},{"type":"select","name":"AGENT_TYPE_ID","label":"Agent Type","defaultValue":0,"options":[{"value":0,"label":"All"},{"value":460,"label":"Registered Agent"},{"value":461,"label":"Commercial Registered Agent"}]}]},{"label":"Farm Bill","component":"FarmBill","parameter":"farm-bill","path":"/lists/farm-bill","sourceTypeId":0,"myRecordsSearch":false,"allowedRules":["/search/"],"disabled":true,"searchDescription":"To perform a search, enter a debtor name. Your search results may include: exact debtor name, variations of that name and any filing that includes your search criteria. Punctuation is ignored.\n\nYou can click on \"Advanced\" to refine your search. Under “Advanced” you can search by crop, year, county and SSN/FEIN. As a registered Farm Bill Buyer with the Montana Secretary of State’s office it is important to maintain the confidentiality of the information contained within the Farm Bill Master List. The Farm Bill Master List reflects personal data, such as Social Security Numbers, which are a key piece of personal identifiable information to assist you in determining the existence of a lien against a specific debtor. The distribution of this information beyond its intended purpose is strictly prohibited.\n\nThe debtor's tax identification number has been hidden for confidentiality reasons. You may continue to search on a tax ID number and return debtors that match your search criteria. The SSN/FEIN must be entered without dashes or spaces.","searchMustHaveOneOf":["search","UCC_FARM_PRODUCT_ID","COUNTY"],"searchPlaceholder":"Search by debtor name","advancedSearchParameters":[{"type":"ServerMultiComplete","label":"Product code name(s)","name":"UCC_FARM_PRODUCT_ID","defaultValue":"","optionsSrc":"UCC_FARM_PRODUCT_V"},{"type":"MultiComplete","label":"Year or Range of Years","name":"YEAR_NUM","optionsSrc":"years","startYear":"1968","defaultValue":[],"preMergeOptions":[{"value":"ALL","label":"All"}]},{"type":"serverSelect","label":"State","name":"STATE","defaultValue":"MONTANA","optionsSrc":"STATE"},{"type":"ServerMultiComplete","label":"County","name":"COUNTY","defaultValue":[],"optionsSrc":"COUNTY","overrideSubOptionsSrcFromParameterName":"STATE"},{"type":"checkbox","name":"TIN_SEARCH_YN","defaultValue":false,"label":"Tax Identification Number Search"},{"type":"checkbox","name":"TIN_SORT_YN","defaultValue":false,"label":"Unique ID Sort"}]}],"SYSTEM_NICKNAME":"Online Services Portal","PAYMENT_METHODS":[{"type":"bypass"},{"type":"iTransact"}],"PAYMENT_ALLOW_AMEX":true,"SYSTEM_ID_LABEL":"System Id","DOUBLE_COLUMN_PUBLIC_LOGIN":true,"INTERNAL_USER_MANAGEMENT":true,"ALLOW_PUBLIC_JSON_IMPORT":false,"MAX_FILE_UPLOAD_SIZE":10000000,"REFUND_TEXT":"","RETURN_TO_HOME_ON_LOGOUT":true,"CURRENT_SOS_NAME":"Christi Jacobsen","LOGO_FILENAME":"mt-sos-logo.png","LOGO_ALT":"Christi Jacobsen, Montana Secretary of State","LOGO_FULL_WIDTH":true,"HOME_HIDE_AUTH_HINT":true,"HOME_TITLE":"Montana Secretary of State","CUSTOM_TAB_TITLE":"Official Montana","HOME_SUBTITLE":"Online Business Services","ENTITY_NAME_CONSENT_DESCRIPTION":"","ALLOW_USER_PROFILE_EDITING":true,"COMPARE_FOREIGN_NAME_IN_ENTITY_NAME_VALIDATION":true,"FOREIGN_NAME_FIELD_NAME":"KIMA_PARENT_NAME_INFO","LOGIN_TITLE":"Montana Secretary of State Online Filing Portal Login","PUBLIC_LOGIN_LABEL":"Username","REVERSE_LOGIN_COLUMNS":true,"LOGIN_SEAL_FILENAME":"seal_white.png","SEPARATE_USERNAME_AND_EMAIL":true,"CREATE_ACCOUNT_BUTTON_ALIGN_LEFT":true,"CREATE_ACCOUNT_BUTTON_TEXT":"CREATE AN ACCOUNT","PASSWORD_CUSTOM_ERROR_TEXT":"The password must meet all requirements","ACCOUNT_CREATED_MESSAGE":"Please check your email to verify your account to login and allow a few minutes for this message to arrive. Check your junk/spam folders if you do not find the email in your inbox.","PUBLIC_LOGIN_PLACEHOLDER":" ","DISABLE_DEFAULT_PAYMENT_RADIO":true,"CUSTOM_RESET_PASSWORD_ERROR_MESSAGE":"Username invalid - no account found","PUBLIC_LOGIN_CREATE_DESCRIPTION":"### Existing User:\n\n  - Enter your username and password to login.  \n\n\n  #### - OR -  \n\n\n\n  - Forgot password? Click 'Reset Password' and follow the prompts.\n  - Forgot username? Click 'Forgot Username' and follow the prompts.  \n\n\n  ### New User:\n  ","LOGIN_HELP_LINK":"https://sosmt.gov/business/how-do-i/","LOGIN_HELP_LINK_TEXT":"Need Help?","FORGOT_USERNAME_TEXT":"Forgot Username?","LOGIN_ACTIVE_DIRECTORY_TEXT":"State User Login","MULTIPLE_LOGIN_METHODS":true,"HAS_ACTIVE_DIRECTORY_LOGIN":true,"RESET_PASSWORD_WITH_USERNAME":true,"DOWNLOAD_LINK":true,"SHOW_USERNAME_ACCOUNT_CREATE":true,"SHOW_SCROLL_DOWN_ARROW":true,"SHOW_ADDRESS_ACCOUNT_CREATE":true,"TWO_COLUMN_ACCOUNT_CREATE":true,"RESET_PASSWORD_TIP":"A link to change your password has been sent to your email. Please allow a few minutes for this message to arrive. Please check your junk/spam folders if you do not find the email in your inbox.","FORGOT_PASSWORD_LINK_TEXT":"Reset Password","PHONE_NUMBER_OPTIONAL_ACCOUNT_CREATE":true,"SHOW_REQUIRED_INDICATOR_ACCOUNT_CREATE":true,"PASSWORD_REQUIREMENTS_ACCOUNT_CREATE":"\n    <ul>\n      <li>MUST contain at least 8 characters (12+ recommended)</li>\n      <li>MUST contain at least one uppercase letter.</li>\n      <li>MUST contain at least one lowercase letter.</li>\n      <li>MUST contain at least one number.</li>\n      <li>MUST contain at least one special character (!”#$%&'()*+,-./:;<=>?</li>\n    </ul>\n  ","ALLOW_CERTIFICATION_REQUEST":true,"ALLOW_PUBLIC_CERTIFICATE_REQUEST":true,"ALLOW_COPY_REQUEST":false,"ALLOW_CORRECTION_STYLING":true,"HIDE_DEPRECATION_WARNING":false,"AMEND_ROUTE_PUBLIC":true,"SEAL_FILENAME":"seal.png","SHOPPING_CART":true,"ALLOW_PAYMENT_UPDATE_WITH_EMPTY_CART":true,"RA_EMAIL":true,"RA_WEBSITE":true,"RA_NO_DEFAULT_TYPE":true,"RA_ADDRESS_LABEL":"Street Address","RA_TYPE_SELECTION_DEFAULT":true,"RA_DEFAULT_TYPE":"460","RA_OVERRIDE_TYPE_WITH_DEFAULT":true,"RA_PRINCIPAL_ADDRESS_AMS":true,"UPLOAD_AND_SUBMIT_HIDE_IF_ONE_OPTION":true,"PAYMENT_PROCESSING_MESSAGE":"Your payment is processing - Do not close your browser or click the back button","CHECKOUT_BUTTON_WHEN_PROCESSING_TEXT":"Processing","EFS_CROP_PICKER_NONE_LABEL":"Lien Duration","DISALLOWED_WIZARD_PIECES":["FormationLocale"],"REPEATER_SHOW_EDIT_BUTTON":true,"DATA_REQUEST_PAGE_TITLE":"Data Requests and Subscriptions","DATA_REQUEST_SIDEBAR_LABEL":"Data Requests & Subscriptions","LOGIN_REDIRECTS_TO_EPASS":false,"LOGIN_REDIRECTS_TO_ACTIVE_DIRECTORY":true,"LOGIN_ACTIVE_DIRECTORY_LINK":true,"FETCH_EDIT_USER_LINK":false,"LISTS_FETCH_AVAILABLE_LISTS":true,"POST_WIZARD_SUBMIT_REDIRECT_URL":"/","PIN_REQUEST_ATTESTATIONS":true,"PIN_REQUEST_DESCRIPTION":"Click **Request PIN** to have a new PIN sent to the account holder's email address on file.","OWNERSHIP_REQUEST_DESCRIPTION":"To become an **authorized user** of this record, a current **AUTHORIZED USER** will need to grant you access. To request access, click **Request Access** below.","PIN_REQUEST_SUCCESS_MESSAGE":"The PIN you have requested for this entity has been sent to the email associated with your user account.  You should receive the PIN in approximately 3-5 minutes, depending on your email service provider.","APOSTILLE_HEADER_LABEL":"Verification Information","APOSTILLE_NUMBER_LABEL":"Apostille/Authentication","APOSTILLE_CITY_STATE_OVERRIDE":"HELENA, MT","APOSTILLE_FILING_DATE_LABEL":"Issue Date","APOSTILLE_CITY_STATE_IN_CERTIFIED":true,"NOTARY_EXISTING_FILING":true,"ALLOW_REVOKE_OWN_ACCESS_ONLY":false,"HIDE_CANCEL_ON_ONETIME_DATA_REQUESTS":true,"DATA_REQUESTS_IN_SHOPPING_CART":true,"WQ_ALLOW_EDIT_PENDING_PAYMENT":true,"WQ_CONFIRM_ON_DELETE":true,"WQ_DELETE_CONFIRM_MESSAGE":"Deleting this filing will forfeit any money already paid to the Secretary of State. This action is permanent and cannot be undone, are you sure you would like to delete?","PASS_ITEM_GUIDS_ON_CHECKOUT":true,"FORM_REVISION_HISTORY":true,"CHECKOUT_DISCLAIMER":"By entering your credit card and/or checking account information you (i) state that **you are an authorized user** of the credit card and/or electronic check and that the associated information entered (e.g., account holder name, account number, billing address) is accurate, (ii) **you authorize payment processor to charge the amount you have requested** to your credit card and/or funding account, and (iii) **acknowledge if a charge is declined or reversed you may also be assessed a customary charge** by the payment processor for such transactions.","FARM_BILL_SEARCH_CONFIDENTIAL":"As a registered Farm Bill Buyer with the Montana Secretary of State’s office it is important to maintain the confidentiality of the information contained within the Farm Bill Master List. The Farm Bill Master List reflects personal data, such as Social Security Numbers, which are a key piece of personal identifiable information to assist you in determining the existence of a lien against a specific debtor. The distribution of this information beyond its intended purpose is strictly prohibited.\n\n**The debtor's tax identification number has been hidden for confidentiality reasons. You may continue to search on a tax ID number and return debtors that match your search criteria. The SSN/FEIN must be entered without dashes or spaces.  If you need access to the tax identification number to clearly identify the debtor, please contact the UCC unit at (406) 444-3665.**","VIEW_HISTORY_BUTTON_ALT_TEXT":"View Filings","WIZARD_ERROR_TITLE_MESSAGE":"Form Error","FARM_BILL_SEARCH_INTERACTIVE":true,"USE_FARM_BILL_API":true,"DISALLOW_ASSIGN_SELF_AS_RA":true,"DISALLOW_ASSIGN_SELF_AS_PRINCIPAL":true,"USE_TRADEMARK_OWNER_VALIDATION":true,"USE_ALTERNATIVE_FOREIGN_ADDRESS_LABELS":true,"MY_RECEIPTS_FILTER":[{"type":"dateRange","name":"DATE_RANGE","label":"Date range","defaultValue":{"start":null,"end":null}},{"type":"text","name":"REF_NUM","defaultValue":"","label":"Reference Number"},{"type":"text","name":"RECEIPT_NUM","defaultValue":"","label":"Receipt Id"},{"type":"text","name":"AMOUNT","defaultValue":"","label":"Amount"},{"type":"select","name":"TYPE","defaultValue":"","label":"Payment Type","options":[{"value":"","label":"All"},{"value":"CC","label":"Credit Card"},{"value":"Check","label":"Check"}]}],"MY_RECEIPTS_SHOW_IN_SIDEBAR":true,"SHOW_MY_RECEIPTS_HELPER_TEXT":true,"MY_RECEIPTS_HELPER_LABEL":"About Receipt Search","MY_RECEIPTS_HELPER_TEXT":"You can search for receipts based on their descriptions, including the items paid for on the receipt. Use the filters to search for or filter specific information.","FARM_BILL_SUBLINK":{"label":"Farm Bill","component":"FarmBill","parameter":"farm-bill","path":"/lists/farm-bill","sourceTypeId":0,"myRecordsSearch":false,"allowedRules":["/search/"],"disabled":true,"searchDescription":"To perform a search, enter a debtor name. Your search results may include: exact debtor name, variations of that name and any filing that includes your search criteria. Punctuation is ignored.\n\nYou can click on \"Advanced\" to refine your search. Under “Advanced” you can search by crop, year, county and SSN/FEIN. As a registered Farm Bill Buyer with the Montana Secretary of State’s office it is important to maintain the confidentiality of the information contained within the Farm Bill Master List. The Farm Bill Master List reflects personal data, such as Social Security Numbers, which are a key piece of personal identifiable information to assist you in determining the existence of a lien against a specific debtor. The distribution of this information beyond its intended purpose is strictly prohibited.\n\nThe debtor's tax identification number has been hidden for confidentiality reasons. You may continue to search on a tax ID number and return debtors that match your search criteria. The SSN/FEIN must be entered without dashes or spaces.","searchMustHaveOneOf":["search","UCC_FARM_PRODUCT_ID","COUNTY"],"searchPlaceholder":"Search by debtor name","advancedSearchParameters":[{"type":"ServerMultiComplete","label":"Product code name(s)","name":"UCC_FARM_PRODUCT_ID","defaultValue":"","optionsSrc":"UCC_FARM_PRODUCT_V"},{"type":"MultiComplete","label":"Year or Range of Years","name":"YEAR_NUM","optionsSrc":"years","startYear":"1968","defaultValue":[],"preMergeOptions":[{"value":"ALL","label":"All"}]},{"type":"serverSelect","label":"State","name":"STATE","defaultValue":"MONTANA","optionsSrc":"STATE"},{"type":"ServerMultiComplete","label":"County","name":"COUNTY","defaultValue":[],"optionsSrc":"COUNTY","overrideSubOptionsSrcFromParameterName":"STATE"},{"type":"checkbox","name":"TIN_SEARCH_YN","defaultValue":false,"label":"Tax Identification Number Search"},{"type":"checkbox","name":"TIN_SORT_YN","defaultValue":false,"label":"Unique ID Sort"}]},"ALLOW_ADDRESS_VALIDATION_BYPASS_OPTION":true,"DEFAULT_ADDRESS_VALIDATION_BYPASS_OPTION_CHECKED":true}).RA_MAILING_STATE_DISABLED : parentProps.disableMailingState,
	                value: {
	                  ADDR1: value.MAIL_ADDR.ADDR1,
	                  ADDR2: value.MAIL_ADDR.ADDR2,
	                  ADDR3: value.MAIL_ADDR.ADDR3,
	                  CITY: value.MAIL_ADDR.CITY,
	                  STATE: value.MAIL_ADDR.STATE,
	                  COUNTY: value.MAIL_ADDR.COUNTY,
	                  COUNTRY: value.MAIL_ADDR.COUNTRY,
	                  POSTAL_CODE: value.MAIL_ADDR.POSTAL_CODE,
	                  MAIL_ADDR_BYPASS_YN: value.MAIL_ADDR.MAIL_ADDR_BYPASS_YN
	                },
	                onChange: onMailingAddressChange
	              }))
	            ) : null,
	            errorMessage && this.removeErrorDuplicates().map(function (e, i) {
	              return _react2.default.createElement(
	                'p',
	                { className: 'field-error animated fadeIn fast-animation standalone-error', key: i },
	                e
	              );
	            }),
	            _react2.default.createElement(
	              'div',
	              { className: 'controls' },
	              _react2.default.createElement(
	                'button',
	                { type: 'button', className: 'btn btn-raised btn-primary', onClick: this.save },
	                'Save'
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return AddAgentModal;
	}(_react.Component);

/***/ },
/* 1164 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(7);
	
	var _WizardClasses = __webpack_require__(35);
	
	var WizardClasses = _interopRequireWildcard(_WizardClasses);
	
	var _Field = __webpack_require__(25);
	
	var _Form = __webpack_require__(14);
	
	var _Markdown = __webpack_require__(24);
	
	var _Markdown2 = _interopRequireDefault(_Markdown);
	
	var _utilities = __webpack_require__(8);
	
	var _format = __webpack_require__(33);
	
	var _format2 = _interopRequireDefault(_format);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var SIGNATURE_CAPACITY_LABEL = ({"NODE_ENV":"production","BUILD_DATE":"2025-08-27T15:15:31.687Z","BUILD_NUMBER":"Not Provided","GIT_VERSION":"v1.3.0-381-ga81e29b08","GIT_COMMIT_HASH":"a81e29b085c9268ffd96c78eb734365802722741","GIT_BRANCH":"beta","PUBLIC_URL":"","STATE_ABBR":"MT","STATE_NAME":"Montana","STATE_ORG_TITLE":"Secretary of State","LOGIN_HEADER_IMG_PATH":"","HOME_IMG_FILENAME":"montana.jpg","FAVICON_FILE_NAME":"favicon.ico","ALLOW_E_SIGN_ON_CORRECTIONS":true,"THIRD_PARTY_SIGNING_ALLOWED":false,"MY_ACCOUNT_SAVE_AND_CLOSE_BUTTON":true,"IE_DEPRECATED_MESSAGE":"Internet Explorer is not supported. Please select a supported browser below to access this website.","ADDITIONAL_ROUTES":{"dataRequests":true,"farmBill":true,"apostille":true,"externalHelp":"https://sosmt.gov/business/help-center/","systemAdministration":[{"title":"Saved Payments","parameter":"saved-payments","componentName":"SavedPayments"}]},"SUBROUTES":[{"label":"Business","component":"Business","parameter":"business","myWorkQueueSearch":false,"sourceTypeId":54,"searchMustHaveOneOf":["FILING_TYPE_ID","STATUS_ID","STATE","search"],"serverWebSearchDescription":true,"serverWorkQueueDescription":true,"serverMyRecordsDescription":true,"searchPlaceholder":"Search by name or filing number (X########)","allowEmptySearchTerm":true,"requestCertificateAlternateLabel":"Request Information","fileAmendmentButtonLabel":"Filing Actions","advancedSearchParameters":[{"type":"radio","name":"QUERY_TYPE_ID","defaultValue":1010,"options":[{"value":1010,"label":"Starts with"},{"value":1011,"label":"Contains"},{"value":1012,"label":" Word Contains"}]},{"type":"serverSelect","name":"FILING_TYPE_ID","optionsSrc":"FILING_TYPES","label":"Entity Type","placeholder":"All","defaultValue":"0"},{"type":"serverSelect","name":"FILING_SUBTYPE_ID","optionsSrc":"FILING_SUBTYPES","label":"Entity Subtype","overrideSubOptionsSrcFromParameterName":"FILING_TYPE_ID","placeholder":"All","defaultValue":"0"},{"type":"serverSelect","name":"STATUS_ID","optionsSrc":"FILING_STATUS_WITHOUT_ALL","label":"Status","placeholder":"All","defaultValue":"0"},{"type":"serverSelect","name":"STATE","optionsSrc":"STATE","label":"State","placeholder":"All","defaultValue":""},{"type":"serverSelect","name":"COUNTY","optionsSrc":"COUNTY_SUBOPTION","label":"County","overrideSubOptionsSrcFromParameterName":"STATE","placeholder":"All","defaultValue":""},{"type":"checkbox","name":"CRA_SEARCH_YN","defaultValue":false,"label":"Search by Registered Agent PID"},{"type":"dateRange","name":"FILING_DATE","label":"Registration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}},{"type":"dateRange","name":"EXPIRATION_DATE","label":"Expiration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}}],"myRecordsFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Active"},{"value":2,"label":"Inactive"},{"value":3,"label":"Pending"}]},{"type":"dateRange","name":"DATE_RANGE","label":"Date range","defaultValue":{"start":null,"end":null}}],"myWorkQueueFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Approved"},{"value":2,"label":"Pending Online Payment"},{"value":3,"label":"Pending Review"},{"value":4,"label":"Needs Correction"},{"value":5,"label":"Rejected"},{"value":6,"label":"Draft"}]},{"type":"dateRange","name":"DATE_RANGE","label":"Date range","defaultValue":{"start":null,"end":null}}]},{"label":"Notary","component":"Notary","parameter":"notary","sourceTypeId":850,"myWorkQueueSearch":false,"allowEmptySearchTerm":true,"requestCertificateAlternateLabel":"Download Certificate","fileAmendmentButtonLabel":"Filing Actions","hideNameRequestCertificate":true,"hideAddressRequestCertificate":true,"hideRecordUserManagment":true,"searchPlaceholder":"Search by name or commission number","searchMustHaveOneOf":["CITY","search","SERVICE_TYPE"],"advancedParametersStartOpen":true,"searchIsSortable":true,"advancedSearchParameters":[{"type":"radio","name":"STARTS_WITH_YN","defaultValue":false,"options":[{"value":true,"label":"Starts with"},{"value":false,"label":"Contains"}]},{"type":"checkbox","name":"ACTIVE_ONLY_YN","defaultValue":true,"label":"Active entities only"},{"type":"text","name":"CITY","defaultValue":"","label":"City"},{"type":"select","name":"SERVICE_TYPE","label":"Special Services Offered","defaultValue":0,"options":[{"value":0,"label":"(N/A)"},{"value":6165,"label":"In-Person Electronic Notarization (IPEN)"},{"value":6166,"label":"Remote Online Notarization (RON)"},{"value":6167,"label":"Mobile Notary Services"},{"value":6168,"label":"Remote Ink Notarization (RIN)"}]}]},{"label":"Apostille","component":"Apostille","parameter":"apostille","sourceTypeId":720,"myRecordsSearch":false,"myWorkQueueSearch":false,"disabled":false,"allowedRoutes":["/forms-manager/","/queue/","/forms/"]},{"label":"Liens","component":"UCC","parameter":"ucc","sourceTypeId":1999,"myRecordsSearch":true,"myWorkQueueSearch":true,"fileAmendmentButtonLabel":"Filing Actions","searchPlaceholder":"Search by name or file number","disabled":false,"serverWebSearchDescription":true,"myRecordsDescription":"","workQueueDescription":"","searchDescription":"","hideRecordUserManagment":true,"searchLiensCheckout":false,"advancedSearchParameters":[{"type":"radio","name":"STARTS_WITH_YN","defaultValue":false,"options":[{"value":true,"label":"Starts with"},{"value":false,"label":"Contains"}]},{"type":"select","name":"STATUS","defaultValue":"ALL","label":"Status","options":[{"value":"ACTIVE_UNLAPSED","label":"Active (unlapsed)"},{"value":"ACTIVE_LAPSED_UNLAPSED","label":"Active (lapsed and unlapsed)"}]},{"type":"text","name":"EXCLUDE_VALUES","label":"Exclude Debtor Names (comma separated list of names to exclude)","defaultValue":""},{"type":"dateRange","name":"FILING_DATE","label":"Financing Statement Date","defaultValue":{"start":null,"end":null}},{"type":"dateRange","name":"LAPSE_DATE","label":"Lapse Date","defaultValue":{"start":null,"end":null}},{"type":"text","name":"CITY","label":"Debtor City","defaultValue":""}],"myRecordsFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Approved"},{"value":2,"label":"Pending Online Payment"},{"value":3,"label":"Pending Review"}]},{"type":"select","name":"TYPE","defaultValue":0,"label":"Lien Type","options":[{"value":0,"label":"All"},{"value":1,"label":"UCC"},{"value":2,"label":"EFS"},{"value":3,"label":"Title 71"}]}],"myWorkQueueFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Approved"},{"value":2,"label":"Pending Online Payment"},{"value":3,"label":"Pending Review"},{"value":4,"label":"Pending Print and Mail"},{"value":5,"label":"Rejected"},{"value":6,"label":"Draft"}]},{"type":"select","name":"TYPE","defaultValue":0,"label":"Lien Type","options":[{"value":0,"label":"All"},{"value":1,"label":"UCC"},{"value":2,"label":"EFS"},{"value":3,"label":"Title 71"}]}]},{"label":"Copy Request","component":"copies","parameter":"copies","sourceTypeId":2001,"myRecordsSearch":false,"myWorkQueueSearch":false,"disabled":false,"allowedRoutes":["/forms-manager/","/queue/","/forms/"]},{"label":"Trademark","component":"Trademark","parameter":"trademark","sourceTypeId":810,"showRequestCertificate":true,"searchMustHaveOneOf":["search","EXPIRATION_DATE","FILING_DATE"],"allowEmptySearchTerm":true,"requestCertificateAlternateLabel":"Request Information","fileAmendmentButtonLabel":"Filing Actions","advancedSearchParameters":[{"type":"radio","name":"QUERY_TYPE_ID","defaultValue":1010,"options":[{"value":1010,"label":"Starts with"},{"value":1011,"label":"Contains"},{"value":1012,"label":" Word Contains"}]},{"type":"checkbox","name":"OWNER_SEARCH_YN","defaultValue":false,"label":"Search owners"},{"type":"radio","name":"SERVICE_MARK_YN","label":"Mark Type","defaultValue":"","options":[{"value":"","label":"All Marks"},{"value":"Y","label":"Service Mark"},{"value":"N","label":"Trademark"}]},{"type":"serverSelect","name":"STATUS_ID","optionsSrc":"TYPE_V|TRADEMARK_STATUS_TYPE","label":"Status","placeholder":"All","defaultValue":"0"},{"type":"select","name":"DESIGN_TYPE_ID","options":[{"value":0,"label":"All"},{"value":990,"label":"Words Only"},{"value":991,"label":"Design Only"},{"value":992,"label":"Words and Design"}],"label":"Design Type","defaultValue":"0"},{"type":"dateRange","name":"FILING_DATE","label":"Registered Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}},{"type":"dateRange","name":"EXPIRATION_DATE","label":"Expiration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}}]},{"label":"Business Info Request","component":"InfoRequests","parameter":"info-request","sourceTypeId":167,"allowedRoutes":["/forms-manager/","/queue/","/forms/"]},{"label":"Data Requests","component":"DataRequests","parameter":"data-request","sourceTypeId":0,"allowedRoutes":["/forms-manager/"]},{"label":"CRA","component":"CRA","parameter":"cra","sourceTypeId":157,"myRecordsSearch":false,"searchPlaceholder":"Search by name or registered agent number","allowedRoutes":["/forms-manager/","/forms/","/records/","/queue/","/search/"],"allowEmptySearchTerm":true,"fileAmendmentButtonLabel":"Filing Actions","advancedSearchParameters":[{"type":"radio","name":"QUERY_TYPE_ID","defaultValue":1010,"options":[{"value":1010,"label":"Starts with"},{"value":1011,"label":"Contains"},{"value":1012,"label":" Word Contains"}]},{"type":"dateRange","name":"CRA_DATE","label":"Registration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}},{"type":"select","name":"STATUS_ID","label":"Status","defaultValue":0,"options":[{"value":0,"label":"All"},{"value":121,"label":"Active"},{"value":122,"label":"Inactive"}]},{"type":"select","name":"AGENT_TYPE_ID","label":"Agent Type","defaultValue":0,"options":[{"value":0,"label":"All"},{"value":460,"label":"Registered Agent"},{"value":461,"label":"Commercial Registered Agent"}]}]},{"label":"Farm Bill","component":"FarmBill","parameter":"farm-bill","path":"/lists/farm-bill","sourceTypeId":0,"myRecordsSearch":false,"allowedRules":["/search/"],"disabled":true,"searchDescription":"To perform a search, enter a debtor name. Your search results may include: exact debtor name, variations of that name and any filing that includes your search criteria. Punctuation is ignored.\n\nYou can click on \"Advanced\" to refine your search. Under “Advanced” you can search by crop, year, county and SSN/FEIN. As a registered Farm Bill Buyer with the Montana Secretary of State’s office it is important to maintain the confidentiality of the information contained within the Farm Bill Master List. The Farm Bill Master List reflects personal data, such as Social Security Numbers, which are a key piece of personal identifiable information to assist you in determining the existence of a lien against a specific debtor. The distribution of this information beyond its intended purpose is strictly prohibited.\n\nThe debtor's tax identification number has been hidden for confidentiality reasons. You may continue to search on a tax ID number and return debtors that match your search criteria. The SSN/FEIN must be entered without dashes or spaces.","searchMustHaveOneOf":["search","UCC_FARM_PRODUCT_ID","COUNTY"],"searchPlaceholder":"Search by debtor name","advancedSearchParameters":[{"type":"ServerMultiComplete","label":"Product code name(s)","name":"UCC_FARM_PRODUCT_ID","defaultValue":"","optionsSrc":"UCC_FARM_PRODUCT_V"},{"type":"MultiComplete","label":"Year or Range of Years","name":"YEAR_NUM","optionsSrc":"years","startYear":"1968","defaultValue":[],"preMergeOptions":[{"value":"ALL","label":"All"}]},{"type":"serverSelect","label":"State","name":"STATE","defaultValue":"MONTANA","optionsSrc":"STATE"},{"type":"ServerMultiComplete","label":"County","name":"COUNTY","defaultValue":[],"optionsSrc":"COUNTY","overrideSubOptionsSrcFromParameterName":"STATE"},{"type":"checkbox","name":"TIN_SEARCH_YN","defaultValue":false,"label":"Tax Identification Number Search"},{"type":"checkbox","name":"TIN_SORT_YN","defaultValue":false,"label":"Unique ID Sort"}]}],"SYSTEM_NICKNAME":"Online Services Portal","PAYMENT_METHODS":[{"type":"bypass"},{"type":"iTransact"}],"PAYMENT_ALLOW_AMEX":true,"SYSTEM_ID_LABEL":"System Id","DOUBLE_COLUMN_PUBLIC_LOGIN":true,"INTERNAL_USER_MANAGEMENT":true,"ALLOW_PUBLIC_JSON_IMPORT":false,"MAX_FILE_UPLOAD_SIZE":10000000,"REFUND_TEXT":"","RETURN_TO_HOME_ON_LOGOUT":true,"CURRENT_SOS_NAME":"Christi Jacobsen","LOGO_FILENAME":"mt-sos-logo.png","LOGO_ALT":"Christi Jacobsen, Montana Secretary of State","LOGO_FULL_WIDTH":true,"HOME_HIDE_AUTH_HINT":true,"HOME_TITLE":"Montana Secretary of State","CUSTOM_TAB_TITLE":"Official Montana","HOME_SUBTITLE":"Online Business Services","ENTITY_NAME_CONSENT_DESCRIPTION":"","ALLOW_USER_PROFILE_EDITING":true,"COMPARE_FOREIGN_NAME_IN_ENTITY_NAME_VALIDATION":true,"FOREIGN_NAME_FIELD_NAME":"KIMA_PARENT_NAME_INFO","LOGIN_TITLE":"Montana Secretary of State Online Filing Portal Login","PUBLIC_LOGIN_LABEL":"Username","REVERSE_LOGIN_COLUMNS":true,"LOGIN_SEAL_FILENAME":"seal_white.png","SEPARATE_USERNAME_AND_EMAIL":true,"CREATE_ACCOUNT_BUTTON_ALIGN_LEFT":true,"CREATE_ACCOUNT_BUTTON_TEXT":"CREATE AN ACCOUNT","PASSWORD_CUSTOM_ERROR_TEXT":"The password must meet all requirements","ACCOUNT_CREATED_MESSAGE":"Please check your email to verify your account to login and allow a few minutes for this message to arrive. Check your junk/spam folders if you do not find the email in your inbox.","PUBLIC_LOGIN_PLACEHOLDER":" ","DISABLE_DEFAULT_PAYMENT_RADIO":true,"CUSTOM_RESET_PASSWORD_ERROR_MESSAGE":"Username invalid - no account found","PUBLIC_LOGIN_CREATE_DESCRIPTION":"### Existing User:\n\n  - Enter your username and password to login.  \n\n\n  #### - OR -  \n\n\n\n  - Forgot password? Click 'Reset Password' and follow the prompts.\n  - Forgot username? Click 'Forgot Username' and follow the prompts.  \n\n\n  ### New User:\n  ","LOGIN_HELP_LINK":"https://sosmt.gov/business/how-do-i/","LOGIN_HELP_LINK_TEXT":"Need Help?","FORGOT_USERNAME_TEXT":"Forgot Username?","LOGIN_ACTIVE_DIRECTORY_TEXT":"State User Login","MULTIPLE_LOGIN_METHODS":true,"HAS_ACTIVE_DIRECTORY_LOGIN":true,"RESET_PASSWORD_WITH_USERNAME":true,"DOWNLOAD_LINK":true,"SHOW_USERNAME_ACCOUNT_CREATE":true,"SHOW_SCROLL_DOWN_ARROW":true,"SHOW_ADDRESS_ACCOUNT_CREATE":true,"TWO_COLUMN_ACCOUNT_CREATE":true,"RESET_PASSWORD_TIP":"A link to change your password has been sent to your email. Please allow a few minutes for this message to arrive. Please check your junk/spam folders if you do not find the email in your inbox.","FORGOT_PASSWORD_LINK_TEXT":"Reset Password","PHONE_NUMBER_OPTIONAL_ACCOUNT_CREATE":true,"SHOW_REQUIRED_INDICATOR_ACCOUNT_CREATE":true,"PASSWORD_REQUIREMENTS_ACCOUNT_CREATE":"\n    <ul>\n      <li>MUST contain at least 8 characters (12+ recommended)</li>\n      <li>MUST contain at least one uppercase letter.</li>\n      <li>MUST contain at least one lowercase letter.</li>\n      <li>MUST contain at least one number.</li>\n      <li>MUST contain at least one special character (!”#$%&'()*+,-./:;<=>?</li>\n    </ul>\n  ","ALLOW_CERTIFICATION_REQUEST":true,"ALLOW_PUBLIC_CERTIFICATE_REQUEST":true,"ALLOW_COPY_REQUEST":false,"ALLOW_CORRECTION_STYLING":true,"HIDE_DEPRECATION_WARNING":false,"AMEND_ROUTE_PUBLIC":true,"SEAL_FILENAME":"seal.png","SHOPPING_CART":true,"ALLOW_PAYMENT_UPDATE_WITH_EMPTY_CART":true,"RA_EMAIL":true,"RA_WEBSITE":true,"RA_NO_DEFAULT_TYPE":true,"RA_ADDRESS_LABEL":"Street Address","RA_TYPE_SELECTION_DEFAULT":true,"RA_DEFAULT_TYPE":"460","RA_OVERRIDE_TYPE_WITH_DEFAULT":true,"RA_PRINCIPAL_ADDRESS_AMS":true,"UPLOAD_AND_SUBMIT_HIDE_IF_ONE_OPTION":true,"PAYMENT_PROCESSING_MESSAGE":"Your payment is processing - Do not close your browser or click the back button","CHECKOUT_BUTTON_WHEN_PROCESSING_TEXT":"Processing","EFS_CROP_PICKER_NONE_LABEL":"Lien Duration","DISALLOWED_WIZARD_PIECES":["FormationLocale"],"REPEATER_SHOW_EDIT_BUTTON":true,"DATA_REQUEST_PAGE_TITLE":"Data Requests and Subscriptions","DATA_REQUEST_SIDEBAR_LABEL":"Data Requests & Subscriptions","LOGIN_REDIRECTS_TO_EPASS":false,"LOGIN_REDIRECTS_TO_ACTIVE_DIRECTORY":true,"LOGIN_ACTIVE_DIRECTORY_LINK":true,"FETCH_EDIT_USER_LINK":false,"LISTS_FETCH_AVAILABLE_LISTS":true,"POST_WIZARD_SUBMIT_REDIRECT_URL":"/","PIN_REQUEST_ATTESTATIONS":true,"PIN_REQUEST_DESCRIPTION":"Click **Request PIN** to have a new PIN sent to the account holder's email address on file.","OWNERSHIP_REQUEST_DESCRIPTION":"To become an **authorized user** of this record, a current **AUTHORIZED USER** will need to grant you access. To request access, click **Request Access** below.","PIN_REQUEST_SUCCESS_MESSAGE":"The PIN you have requested for this entity has been sent to the email associated with your user account.  You should receive the PIN in approximately 3-5 minutes, depending on your email service provider.","APOSTILLE_HEADER_LABEL":"Verification Information","APOSTILLE_NUMBER_LABEL":"Apostille/Authentication","APOSTILLE_CITY_STATE_OVERRIDE":"HELENA, MT","APOSTILLE_FILING_DATE_LABEL":"Issue Date","APOSTILLE_CITY_STATE_IN_CERTIFIED":true,"NOTARY_EXISTING_FILING":true,"ALLOW_REVOKE_OWN_ACCESS_ONLY":false,"HIDE_CANCEL_ON_ONETIME_DATA_REQUESTS":true,"DATA_REQUESTS_IN_SHOPPING_CART":true,"WQ_ALLOW_EDIT_PENDING_PAYMENT":true,"WQ_CONFIRM_ON_DELETE":true,"WQ_DELETE_CONFIRM_MESSAGE":"Deleting this filing will forfeit any money already paid to the Secretary of State. This action is permanent and cannot be undone, are you sure you would like to delete?","PASS_ITEM_GUIDS_ON_CHECKOUT":true,"FORM_REVISION_HISTORY":true,"CHECKOUT_DISCLAIMER":"By entering your credit card and/or checking account information you (i) state that **you are an authorized user** of the credit card and/or electronic check and that the associated information entered (e.g., account holder name, account number, billing address) is accurate, (ii) **you authorize payment processor to charge the amount you have requested** to your credit card and/or funding account, and (iii) **acknowledge if a charge is declined or reversed you may also be assessed a customary charge** by the payment processor for such transactions.","FARM_BILL_SEARCH_CONFIDENTIAL":"As a registered Farm Bill Buyer with the Montana Secretary of State’s office it is important to maintain the confidentiality of the information contained within the Farm Bill Master List. The Farm Bill Master List reflects personal data, such as Social Security Numbers, which are a key piece of personal identifiable information to assist you in determining the existence of a lien against a specific debtor. The distribution of this information beyond its intended purpose is strictly prohibited.\n\n**The debtor's tax identification number has been hidden for confidentiality reasons. You may continue to search on a tax ID number and return debtors that match your search criteria. The SSN/FEIN must be entered without dashes or spaces.  If you need access to the tax identification number to clearly identify the debtor, please contact the UCC unit at (406) 444-3665.**","VIEW_HISTORY_BUTTON_ALT_TEXT":"View Filings","WIZARD_ERROR_TITLE_MESSAGE":"Form Error","FARM_BILL_SEARCH_INTERACTIVE":true,"USE_FARM_BILL_API":true,"DISALLOW_ASSIGN_SELF_AS_RA":true,"DISALLOW_ASSIGN_SELF_AS_PRINCIPAL":true,"USE_TRADEMARK_OWNER_VALIDATION":true,"USE_ALTERNATIVE_FOREIGN_ADDRESS_LABELS":true,"MY_RECEIPTS_FILTER":[{"type":"dateRange","name":"DATE_RANGE","label":"Date range","defaultValue":{"start":null,"end":null}},{"type":"text","name":"REF_NUM","defaultValue":"","label":"Reference Number"},{"type":"text","name":"RECEIPT_NUM","defaultValue":"","label":"Receipt Id"},{"type":"text","name":"AMOUNT","defaultValue":"","label":"Amount"},{"type":"select","name":"TYPE","defaultValue":"","label":"Payment Type","options":[{"value":"","label":"All"},{"value":"CC","label":"Credit Card"},{"value":"Check","label":"Check"}]}],"MY_RECEIPTS_SHOW_IN_SIDEBAR":true,"SHOW_MY_RECEIPTS_HELPER_TEXT":true,"MY_RECEIPTS_HELPER_LABEL":"About Receipt Search","MY_RECEIPTS_HELPER_TEXT":"You can search for receipts based on their descriptions, including the items paid for on the receipt. Use the filters to search for or filter specific information.","FARM_BILL_SUBLINK":{"label":"Farm Bill","component":"FarmBill","parameter":"farm-bill","path":"/lists/farm-bill","sourceTypeId":0,"myRecordsSearch":false,"allowedRules":["/search/"],"disabled":true,"searchDescription":"To perform a search, enter a debtor name. Your search results may include: exact debtor name, variations of that name and any filing that includes your search criteria. Punctuation is ignored.\n\nYou can click on \"Advanced\" to refine your search. Under “Advanced” you can search by crop, year, county and SSN/FEIN. As a registered Farm Bill Buyer with the Montana Secretary of State’s office it is important to maintain the confidentiality of the information contained within the Farm Bill Master List. The Farm Bill Master List reflects personal data, such as Social Security Numbers, which are a key piece of personal identifiable information to assist you in determining the existence of a lien against a specific debtor. The distribution of this information beyond its intended purpose is strictly prohibited.\n\nThe debtor's tax identification number has been hidden for confidentiality reasons. You may continue to search on a tax ID number and return debtors that match your search criteria. The SSN/FEIN must be entered without dashes or spaces.","searchMustHaveOneOf":["search","UCC_FARM_PRODUCT_ID","COUNTY"],"searchPlaceholder":"Search by debtor name","advancedSearchParameters":[{"type":"ServerMultiComplete","label":"Product code name(s)","name":"UCC_FARM_PRODUCT_ID","defaultValue":"","optionsSrc":"UCC_FARM_PRODUCT_V"},{"type":"MultiComplete","label":"Year or Range of Years","name":"YEAR_NUM","optionsSrc":"years","startYear":"1968","defaultValue":[],"preMergeOptions":[{"value":"ALL","label":"All"}]},{"type":"serverSelect","label":"State","name":"STATE","defaultValue":"MONTANA","optionsSrc":"STATE"},{"type":"ServerMultiComplete","label":"County","name":"COUNTY","defaultValue":[],"optionsSrc":"COUNTY","overrideSubOptionsSrcFromParameterName":"STATE"},{"type":"checkbox","name":"TIN_SEARCH_YN","defaultValue":false,"label":"Tax Identification Number Search"},{"type":"checkbox","name":"TIN_SORT_YN","defaultValue":false,"label":"Unique ID Sort"}]},"ALLOW_ADDRESS_VALIDATION_BYPASS_OPTION":true,"DEFAULT_ADDRESS_VALIDATION_BYPASS_OPTION_CHECKED":true}).SIGNATURE_CAPACITY_LABEL;
	
	var Signatures = function (_Component) {
	  _inherits(Signatures, _Component);
	
	  function Signatures() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, Signatures);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Signatures.__proto__ || Object.getPrototypeOf(Signatures)).call.apply(_ref, [this].concat(args))), _this), _this.componentWillReceiveProps = function (nextProps) {
	      if (nextProps.multiple && _this.props.srcRepeater) {
	        _this.resolveSignatureStructure(nextProps);
	      }
	    }, _this.resolveSignatureStructure = function (nextProps) {
	      if (nextProps.multiple) {
	        var currentRepeaterRows = _this.props.srcRepeater.value;
	        var incomingRepeaterRows = nextProps.srcRepeater.value;
	        var repeaterRowWasDeleted = currentRepeaterRows.length > incomingRepeaterRows.length;
	        if (repeaterRowWasDeleted) {
	          var deletedRowId = _this.getDeletedRowId(currentRepeaterRows, incomingRepeaterRows);
	          var deletedRowIndex = currentRepeaterRows.findIndex(function (row) {
	            return row._rowId === deletedRowId;
	          });
	          _this.deleteValueRowByRowIndex(deletedRowIndex);
	        }
	      }
	    }, _this.deleteValueRowByRowIndex = function (deletedRowIndex) {
	      var rows = [].concat(_toConsumableArray(_this.props.value.slice(0, deletedRowIndex)), _toConsumableArray(_this.props.value.slice(deletedRowIndex + 1)));
	      _this.props.onChange(rows, {});
	    }, _this.getDeletedRowId = function (currentRepeaterRows, incomingRepeaterRows) {
	      return currentRepeaterRows.filter(function (row) {
	        return incomingRepeaterRows.find(function (incRow) {
	          return incRow._rowId === row._rowId;
	        }) ? false : true;
	      })[0]._rowId;
	    }, _this.setSignatureValueByIndex = function (value, index) {
	      var currentValue = _this.getValueArray();
	      var rows = [].concat(_toConsumableArray(currentValue.slice(0, index)), [value], _toConsumableArray(currentValue.slice(index + 1)));
	      _this.props.onChange(rows, {});
	    }, _this.getErrorMessageByIndex = function (index) {
	      var errors = _this.getErrors();
	      //Only check errors at indexes that are arrays that have been validated
	      if (errors == undefined) {
	        return "";
	      }
	      if (errors.length <= index || errors == "") {
	        return "";
	      }
	      if (errors[index].bothValid) {
	        return "";
	      } else {
	        var returnError = [];
	        returnError.push(errors[index].errorMessage);
	        return returnError;
	      }
	    }, _this.getErrors = function () {
	      if (_this.props.errorMessage == "") return "";
	      for (var i = 0; i < _this.props.errorMessage.length; i++) {
	        if (Array.isArray(_this.props.errorMessage[i])) {
	          return _this.props.errorMessage[i];
	        }
	      }
	    }, _this.getOuterErrors = function () {
	      var errorlist = [];
	      for (var i = 0; i < _this.props.errorMessage.length; i++) {
	        if (typeof _this.props.errorMessage[i] === 'string') {
	          errorlist.push(_this.props.errorMessage[i]);
	        }
	      }
	      return errorlist;
	    }, _this.getValueArray = function () {
	      return _this.props.srcRepeater.value.map(function (c, i) {
	        return _this.props.value[i] ? _this.props.value[i] : { name: '', sig: '', date: ({"NODE_ENV":"production","BUILD_DATE":"2025-08-27T15:15:31.687Z","BUILD_NUMBER":"Not Provided","GIT_VERSION":"v1.3.0-381-ga81e29b08","GIT_COMMIT_HASH":"a81e29b085c9268ffd96c78eb734365802722741","GIT_BRANCH":"beta","PUBLIC_URL":"","STATE_ABBR":"MT","STATE_NAME":"Montana","STATE_ORG_TITLE":"Secretary of State","LOGIN_HEADER_IMG_PATH":"","HOME_IMG_FILENAME":"montana.jpg","FAVICON_FILE_NAME":"favicon.ico","ALLOW_E_SIGN_ON_CORRECTIONS":true,"THIRD_PARTY_SIGNING_ALLOWED":false,"MY_ACCOUNT_SAVE_AND_CLOSE_BUTTON":true,"IE_DEPRECATED_MESSAGE":"Internet Explorer is not supported. Please select a supported browser below to access this website.","ADDITIONAL_ROUTES":{"dataRequests":true,"farmBill":true,"apostille":true,"externalHelp":"https://sosmt.gov/business/help-center/","systemAdministration":[{"title":"Saved Payments","parameter":"saved-payments","componentName":"SavedPayments"}]},"SUBROUTES":[{"label":"Business","component":"Business","parameter":"business","myWorkQueueSearch":false,"sourceTypeId":54,"searchMustHaveOneOf":["FILING_TYPE_ID","STATUS_ID","STATE","search"],"serverWebSearchDescription":true,"serverWorkQueueDescription":true,"serverMyRecordsDescription":true,"searchPlaceholder":"Search by name or filing number (X########)","allowEmptySearchTerm":true,"requestCertificateAlternateLabel":"Request Information","fileAmendmentButtonLabel":"Filing Actions","advancedSearchParameters":[{"type":"radio","name":"QUERY_TYPE_ID","defaultValue":1010,"options":[{"value":1010,"label":"Starts with"},{"value":1011,"label":"Contains"},{"value":1012,"label":" Word Contains"}]},{"type":"serverSelect","name":"FILING_TYPE_ID","optionsSrc":"FILING_TYPES","label":"Entity Type","placeholder":"All","defaultValue":"0"},{"type":"serverSelect","name":"FILING_SUBTYPE_ID","optionsSrc":"FILING_SUBTYPES","label":"Entity Subtype","overrideSubOptionsSrcFromParameterName":"FILING_TYPE_ID","placeholder":"All","defaultValue":"0"},{"type":"serverSelect","name":"STATUS_ID","optionsSrc":"FILING_STATUS_WITHOUT_ALL","label":"Status","placeholder":"All","defaultValue":"0"},{"type":"serverSelect","name":"STATE","optionsSrc":"STATE","label":"State","placeholder":"All","defaultValue":""},{"type":"serverSelect","name":"COUNTY","optionsSrc":"COUNTY_SUBOPTION","label":"County","overrideSubOptionsSrcFromParameterName":"STATE","placeholder":"All","defaultValue":""},{"type":"checkbox","name":"CRA_SEARCH_YN","defaultValue":false,"label":"Search by Registered Agent PID"},{"type":"dateRange","name":"FILING_DATE","label":"Registration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}},{"type":"dateRange","name":"EXPIRATION_DATE","label":"Expiration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}}],"myRecordsFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Active"},{"value":2,"label":"Inactive"},{"value":3,"label":"Pending"}]},{"type":"dateRange","name":"DATE_RANGE","label":"Date range","defaultValue":{"start":null,"end":null}}],"myWorkQueueFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Approved"},{"value":2,"label":"Pending Online Payment"},{"value":3,"label":"Pending Review"},{"value":4,"label":"Needs Correction"},{"value":5,"label":"Rejected"},{"value":6,"label":"Draft"}]},{"type":"dateRange","name":"DATE_RANGE","label":"Date range","defaultValue":{"start":null,"end":null}}]},{"label":"Notary","component":"Notary","parameter":"notary","sourceTypeId":850,"myWorkQueueSearch":false,"allowEmptySearchTerm":true,"requestCertificateAlternateLabel":"Download Certificate","fileAmendmentButtonLabel":"Filing Actions","hideNameRequestCertificate":true,"hideAddressRequestCertificate":true,"hideRecordUserManagment":true,"searchPlaceholder":"Search by name or commission number","searchMustHaveOneOf":["CITY","search","SERVICE_TYPE"],"advancedParametersStartOpen":true,"searchIsSortable":true,"advancedSearchParameters":[{"type":"radio","name":"STARTS_WITH_YN","defaultValue":false,"options":[{"value":true,"label":"Starts with"},{"value":false,"label":"Contains"}]},{"type":"checkbox","name":"ACTIVE_ONLY_YN","defaultValue":true,"label":"Active entities only"},{"type":"text","name":"CITY","defaultValue":"","label":"City"},{"type":"select","name":"SERVICE_TYPE","label":"Special Services Offered","defaultValue":0,"options":[{"value":0,"label":"(N/A)"},{"value":6165,"label":"In-Person Electronic Notarization (IPEN)"},{"value":6166,"label":"Remote Online Notarization (RON)"},{"value":6167,"label":"Mobile Notary Services"},{"value":6168,"label":"Remote Ink Notarization (RIN)"}]}]},{"label":"Apostille","component":"Apostille","parameter":"apostille","sourceTypeId":720,"myRecordsSearch":false,"myWorkQueueSearch":false,"disabled":false,"allowedRoutes":["/forms-manager/","/queue/","/forms/"]},{"label":"Liens","component":"UCC","parameter":"ucc","sourceTypeId":1999,"myRecordsSearch":true,"myWorkQueueSearch":true,"fileAmendmentButtonLabel":"Filing Actions","searchPlaceholder":"Search by name or file number","disabled":false,"serverWebSearchDescription":true,"myRecordsDescription":"","workQueueDescription":"","searchDescription":"","hideRecordUserManagment":true,"searchLiensCheckout":false,"advancedSearchParameters":[{"type":"radio","name":"STARTS_WITH_YN","defaultValue":false,"options":[{"value":true,"label":"Starts with"},{"value":false,"label":"Contains"}]},{"type":"select","name":"STATUS","defaultValue":"ALL","label":"Status","options":[{"value":"ACTIVE_UNLAPSED","label":"Active (unlapsed)"},{"value":"ACTIVE_LAPSED_UNLAPSED","label":"Active (lapsed and unlapsed)"}]},{"type":"text","name":"EXCLUDE_VALUES","label":"Exclude Debtor Names (comma separated list of names to exclude)","defaultValue":""},{"type":"dateRange","name":"FILING_DATE","label":"Financing Statement Date","defaultValue":{"start":null,"end":null}},{"type":"dateRange","name":"LAPSE_DATE","label":"Lapse Date","defaultValue":{"start":null,"end":null}},{"type":"text","name":"CITY","label":"Debtor City","defaultValue":""}],"myRecordsFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Approved"},{"value":2,"label":"Pending Online Payment"},{"value":3,"label":"Pending Review"}]},{"type":"select","name":"TYPE","defaultValue":0,"label":"Lien Type","options":[{"value":0,"label":"All"},{"value":1,"label":"UCC"},{"value":2,"label":"EFS"},{"value":3,"label":"Title 71"}]}],"myWorkQueueFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Approved"},{"value":2,"label":"Pending Online Payment"},{"value":3,"label":"Pending Review"},{"value":4,"label":"Pending Print and Mail"},{"value":5,"label":"Rejected"},{"value":6,"label":"Draft"}]},{"type":"select","name":"TYPE","defaultValue":0,"label":"Lien Type","options":[{"value":0,"label":"All"},{"value":1,"label":"UCC"},{"value":2,"label":"EFS"},{"value":3,"label":"Title 71"}]}]},{"label":"Copy Request","component":"copies","parameter":"copies","sourceTypeId":2001,"myRecordsSearch":false,"myWorkQueueSearch":false,"disabled":false,"allowedRoutes":["/forms-manager/","/queue/","/forms/"]},{"label":"Trademark","component":"Trademark","parameter":"trademark","sourceTypeId":810,"showRequestCertificate":true,"searchMustHaveOneOf":["search","EXPIRATION_DATE","FILING_DATE"],"allowEmptySearchTerm":true,"requestCertificateAlternateLabel":"Request Information","fileAmendmentButtonLabel":"Filing Actions","advancedSearchParameters":[{"type":"radio","name":"QUERY_TYPE_ID","defaultValue":1010,"options":[{"value":1010,"label":"Starts with"},{"value":1011,"label":"Contains"},{"value":1012,"label":" Word Contains"}]},{"type":"checkbox","name":"OWNER_SEARCH_YN","defaultValue":false,"label":"Search owners"},{"type":"radio","name":"SERVICE_MARK_YN","label":"Mark Type","defaultValue":"","options":[{"value":"","label":"All Marks"},{"value":"Y","label":"Service Mark"},{"value":"N","label":"Trademark"}]},{"type":"serverSelect","name":"STATUS_ID","optionsSrc":"TYPE_V|TRADEMARK_STATUS_TYPE","label":"Status","placeholder":"All","defaultValue":"0"},{"type":"select","name":"DESIGN_TYPE_ID","options":[{"value":0,"label":"All"},{"value":990,"label":"Words Only"},{"value":991,"label":"Design Only"},{"value":992,"label":"Words and Design"}],"label":"Design Type","defaultValue":"0"},{"type":"dateRange","name":"FILING_DATE","label":"Registered Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}},{"type":"dateRange","name":"EXPIRATION_DATE","label":"Expiration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}}]},{"label":"Business Info Request","component":"InfoRequests","parameter":"info-request","sourceTypeId":167,"allowedRoutes":["/forms-manager/","/queue/","/forms/"]},{"label":"Data Requests","component":"DataRequests","parameter":"data-request","sourceTypeId":0,"allowedRoutes":["/forms-manager/"]},{"label":"CRA","component":"CRA","parameter":"cra","sourceTypeId":157,"myRecordsSearch":false,"searchPlaceholder":"Search by name or registered agent number","allowedRoutes":["/forms-manager/","/forms/","/records/","/queue/","/search/"],"allowEmptySearchTerm":true,"fileAmendmentButtonLabel":"Filing Actions","advancedSearchParameters":[{"type":"radio","name":"QUERY_TYPE_ID","defaultValue":1010,"options":[{"value":1010,"label":"Starts with"},{"value":1011,"label":"Contains"},{"value":1012,"label":" Word Contains"}]},{"type":"dateRange","name":"CRA_DATE","label":"Registration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}},{"type":"select","name":"STATUS_ID","label":"Status","defaultValue":0,"options":[{"value":0,"label":"All"},{"value":121,"label":"Active"},{"value":122,"label":"Inactive"}]},{"type":"select","name":"AGENT_TYPE_ID","label":"Agent Type","defaultValue":0,"options":[{"value":0,"label":"All"},{"value":460,"label":"Registered Agent"},{"value":461,"label":"Commercial Registered Agent"}]}]},{"label":"Farm Bill","component":"FarmBill","parameter":"farm-bill","path":"/lists/farm-bill","sourceTypeId":0,"myRecordsSearch":false,"allowedRules":["/search/"],"disabled":true,"searchDescription":"To perform a search, enter a debtor name. Your search results may include: exact debtor name, variations of that name and any filing that includes your search criteria. Punctuation is ignored.\n\nYou can click on \"Advanced\" to refine your search. Under “Advanced” you can search by crop, year, county and SSN/FEIN. As a registered Farm Bill Buyer with the Montana Secretary of State’s office it is important to maintain the confidentiality of the information contained within the Farm Bill Master List. The Farm Bill Master List reflects personal data, such as Social Security Numbers, which are a key piece of personal identifiable information to assist you in determining the existence of a lien against a specific debtor. The distribution of this information beyond its intended purpose is strictly prohibited.\n\nThe debtor's tax identification number has been hidden for confidentiality reasons. You may continue to search on a tax ID number and return debtors that match your search criteria. The SSN/FEIN must be entered without dashes or spaces.","searchMustHaveOneOf":["search","UCC_FARM_PRODUCT_ID","COUNTY"],"searchPlaceholder":"Search by debtor name","advancedSearchParameters":[{"type":"ServerMultiComplete","label":"Product code name(s)","name":"UCC_FARM_PRODUCT_ID","defaultValue":"","optionsSrc":"UCC_FARM_PRODUCT_V"},{"type":"MultiComplete","label":"Year or Range of Years","name":"YEAR_NUM","optionsSrc":"years","startYear":"1968","defaultValue":[],"preMergeOptions":[{"value":"ALL","label":"All"}]},{"type":"serverSelect","label":"State","name":"STATE","defaultValue":"MONTANA","optionsSrc":"STATE"},{"type":"ServerMultiComplete","label":"County","name":"COUNTY","defaultValue":[],"optionsSrc":"COUNTY","overrideSubOptionsSrcFromParameterName":"STATE"},{"type":"checkbox","name":"TIN_SEARCH_YN","defaultValue":false,"label":"Tax Identification Number Search"},{"type":"checkbox","name":"TIN_SORT_YN","defaultValue":false,"label":"Unique ID Sort"}]}],"SYSTEM_NICKNAME":"Online Services Portal","PAYMENT_METHODS":[{"type":"bypass"},{"type":"iTransact"}],"PAYMENT_ALLOW_AMEX":true,"SYSTEM_ID_LABEL":"System Id","DOUBLE_COLUMN_PUBLIC_LOGIN":true,"INTERNAL_USER_MANAGEMENT":true,"ALLOW_PUBLIC_JSON_IMPORT":false,"MAX_FILE_UPLOAD_SIZE":10000000,"REFUND_TEXT":"","RETURN_TO_HOME_ON_LOGOUT":true,"CURRENT_SOS_NAME":"Christi Jacobsen","LOGO_FILENAME":"mt-sos-logo.png","LOGO_ALT":"Christi Jacobsen, Montana Secretary of State","LOGO_FULL_WIDTH":true,"HOME_HIDE_AUTH_HINT":true,"HOME_TITLE":"Montana Secretary of State","CUSTOM_TAB_TITLE":"Official Montana","HOME_SUBTITLE":"Online Business Services","ENTITY_NAME_CONSENT_DESCRIPTION":"","ALLOW_USER_PROFILE_EDITING":true,"COMPARE_FOREIGN_NAME_IN_ENTITY_NAME_VALIDATION":true,"FOREIGN_NAME_FIELD_NAME":"KIMA_PARENT_NAME_INFO","LOGIN_TITLE":"Montana Secretary of State Online Filing Portal Login","PUBLIC_LOGIN_LABEL":"Username","REVERSE_LOGIN_COLUMNS":true,"LOGIN_SEAL_FILENAME":"seal_white.png","SEPARATE_USERNAME_AND_EMAIL":true,"CREATE_ACCOUNT_BUTTON_ALIGN_LEFT":true,"CREATE_ACCOUNT_BUTTON_TEXT":"CREATE AN ACCOUNT","PASSWORD_CUSTOM_ERROR_TEXT":"The password must meet all requirements","ACCOUNT_CREATED_MESSAGE":"Please check your email to verify your account to login and allow a few minutes for this message to arrive. Check your junk/spam folders if you do not find the email in your inbox.","PUBLIC_LOGIN_PLACEHOLDER":" ","DISABLE_DEFAULT_PAYMENT_RADIO":true,"CUSTOM_RESET_PASSWORD_ERROR_MESSAGE":"Username invalid - no account found","PUBLIC_LOGIN_CREATE_DESCRIPTION":"### Existing User:\n\n  - Enter your username and password to login.  \n\n\n  #### - OR -  \n\n\n\n  - Forgot password? Click 'Reset Password' and follow the prompts.\n  - Forgot username? Click 'Forgot Username' and follow the prompts.  \n\n\n  ### New User:\n  ","LOGIN_HELP_LINK":"https://sosmt.gov/business/how-do-i/","LOGIN_HELP_LINK_TEXT":"Need Help?","FORGOT_USERNAME_TEXT":"Forgot Username?","LOGIN_ACTIVE_DIRECTORY_TEXT":"State User Login","MULTIPLE_LOGIN_METHODS":true,"HAS_ACTIVE_DIRECTORY_LOGIN":true,"RESET_PASSWORD_WITH_USERNAME":true,"DOWNLOAD_LINK":true,"SHOW_USERNAME_ACCOUNT_CREATE":true,"SHOW_SCROLL_DOWN_ARROW":true,"SHOW_ADDRESS_ACCOUNT_CREATE":true,"TWO_COLUMN_ACCOUNT_CREATE":true,"RESET_PASSWORD_TIP":"A link to change your password has been sent to your email. Please allow a few minutes for this message to arrive. Please check your junk/spam folders if you do not find the email in your inbox.","FORGOT_PASSWORD_LINK_TEXT":"Reset Password","PHONE_NUMBER_OPTIONAL_ACCOUNT_CREATE":true,"SHOW_REQUIRED_INDICATOR_ACCOUNT_CREATE":true,"PASSWORD_REQUIREMENTS_ACCOUNT_CREATE":"\n    <ul>\n      <li>MUST contain at least 8 characters (12+ recommended)</li>\n      <li>MUST contain at least one uppercase letter.</li>\n      <li>MUST contain at least one lowercase letter.</li>\n      <li>MUST contain at least one number.</li>\n      <li>MUST contain at least one special character (!”#$%&'()*+,-./:;<=>?</li>\n    </ul>\n  ","ALLOW_CERTIFICATION_REQUEST":true,"ALLOW_PUBLIC_CERTIFICATE_REQUEST":true,"ALLOW_COPY_REQUEST":false,"ALLOW_CORRECTION_STYLING":true,"HIDE_DEPRECATION_WARNING":false,"AMEND_ROUTE_PUBLIC":true,"SEAL_FILENAME":"seal.png","SHOPPING_CART":true,"ALLOW_PAYMENT_UPDATE_WITH_EMPTY_CART":true,"RA_EMAIL":true,"RA_WEBSITE":true,"RA_NO_DEFAULT_TYPE":true,"RA_ADDRESS_LABEL":"Street Address","RA_TYPE_SELECTION_DEFAULT":true,"RA_DEFAULT_TYPE":"460","RA_OVERRIDE_TYPE_WITH_DEFAULT":true,"RA_PRINCIPAL_ADDRESS_AMS":true,"UPLOAD_AND_SUBMIT_HIDE_IF_ONE_OPTION":true,"PAYMENT_PROCESSING_MESSAGE":"Your payment is processing - Do not close your browser or click the back button","CHECKOUT_BUTTON_WHEN_PROCESSING_TEXT":"Processing","EFS_CROP_PICKER_NONE_LABEL":"Lien Duration","DISALLOWED_WIZARD_PIECES":["FormationLocale"],"REPEATER_SHOW_EDIT_BUTTON":true,"DATA_REQUEST_PAGE_TITLE":"Data Requests and Subscriptions","DATA_REQUEST_SIDEBAR_LABEL":"Data Requests & Subscriptions","LOGIN_REDIRECTS_TO_EPASS":false,"LOGIN_REDIRECTS_TO_ACTIVE_DIRECTORY":true,"LOGIN_ACTIVE_DIRECTORY_LINK":true,"FETCH_EDIT_USER_LINK":false,"LISTS_FETCH_AVAILABLE_LISTS":true,"POST_WIZARD_SUBMIT_REDIRECT_URL":"/","PIN_REQUEST_ATTESTATIONS":true,"PIN_REQUEST_DESCRIPTION":"Click **Request PIN** to have a new PIN sent to the account holder's email address on file.","OWNERSHIP_REQUEST_DESCRIPTION":"To become an **authorized user** of this record, a current **AUTHORIZED USER** will need to grant you access. To request access, click **Request Access** below.","PIN_REQUEST_SUCCESS_MESSAGE":"The PIN you have requested for this entity has been sent to the email associated with your user account.  You should receive the PIN in approximately 3-5 minutes, depending on your email service provider.","APOSTILLE_HEADER_LABEL":"Verification Information","APOSTILLE_NUMBER_LABEL":"Apostille/Authentication","APOSTILLE_CITY_STATE_OVERRIDE":"HELENA, MT","APOSTILLE_FILING_DATE_LABEL":"Issue Date","APOSTILLE_CITY_STATE_IN_CERTIFIED":true,"NOTARY_EXISTING_FILING":true,"ALLOW_REVOKE_OWN_ACCESS_ONLY":false,"HIDE_CANCEL_ON_ONETIME_DATA_REQUESTS":true,"DATA_REQUESTS_IN_SHOPPING_CART":true,"WQ_ALLOW_EDIT_PENDING_PAYMENT":true,"WQ_CONFIRM_ON_DELETE":true,"WQ_DELETE_CONFIRM_MESSAGE":"Deleting this filing will forfeit any money already paid to the Secretary of State. This action is permanent and cannot be undone, are you sure you would like to delete?","PASS_ITEM_GUIDS_ON_CHECKOUT":true,"FORM_REVISION_HISTORY":true,"CHECKOUT_DISCLAIMER":"By entering your credit card and/or checking account information you (i) state that **you are an authorized user** of the credit card and/or electronic check and that the associated information entered (e.g., account holder name, account number, billing address) is accurate, (ii) **you authorize payment processor to charge the amount you have requested** to your credit card and/or funding account, and (iii) **acknowledge if a charge is declined or reversed you may also be assessed a customary charge** by the payment processor for such transactions.","FARM_BILL_SEARCH_CONFIDENTIAL":"As a registered Farm Bill Buyer with the Montana Secretary of State’s office it is important to maintain the confidentiality of the information contained within the Farm Bill Master List. The Farm Bill Master List reflects personal data, such as Social Security Numbers, which are a key piece of personal identifiable information to assist you in determining the existence of a lien against a specific debtor. The distribution of this information beyond its intended purpose is strictly prohibited.\n\n**The debtor's tax identification number has been hidden for confidentiality reasons. You may continue to search on a tax ID number and return debtors that match your search criteria. The SSN/FEIN must be entered without dashes or spaces.  If you need access to the tax identification number to clearly identify the debtor, please contact the UCC unit at (406) 444-3665.**","VIEW_HISTORY_BUTTON_ALT_TEXT":"View Filings","WIZARD_ERROR_TITLE_MESSAGE":"Form Error","FARM_BILL_SEARCH_INTERACTIVE":true,"USE_FARM_BILL_API":true,"DISALLOW_ASSIGN_SELF_AS_RA":true,"DISALLOW_ASSIGN_SELF_AS_PRINCIPAL":true,"USE_TRADEMARK_OWNER_VALIDATION":true,"USE_ALTERNATIVE_FOREIGN_ADDRESS_LABELS":true,"MY_RECEIPTS_FILTER":[{"type":"dateRange","name":"DATE_RANGE","label":"Date range","defaultValue":{"start":null,"end":null}},{"type":"text","name":"REF_NUM","defaultValue":"","label":"Reference Number"},{"type":"text","name":"RECEIPT_NUM","defaultValue":"","label":"Receipt Id"},{"type":"text","name":"AMOUNT","defaultValue":"","label":"Amount"},{"type":"select","name":"TYPE","defaultValue":"","label":"Payment Type","options":[{"value":"","label":"All"},{"value":"CC","label":"Credit Card"},{"value":"Check","label":"Check"}]}],"MY_RECEIPTS_SHOW_IN_SIDEBAR":true,"SHOW_MY_RECEIPTS_HELPER_TEXT":true,"MY_RECEIPTS_HELPER_LABEL":"About Receipt Search","MY_RECEIPTS_HELPER_TEXT":"You can search for receipts based on their descriptions, including the items paid for on the receipt. Use the filters to search for or filter specific information.","FARM_BILL_SUBLINK":{"label":"Farm Bill","component":"FarmBill","parameter":"farm-bill","path":"/lists/farm-bill","sourceTypeId":0,"myRecordsSearch":false,"allowedRules":["/search/"],"disabled":true,"searchDescription":"To perform a search, enter a debtor name. Your search results may include: exact debtor name, variations of that name and any filing that includes your search criteria. Punctuation is ignored.\n\nYou can click on \"Advanced\" to refine your search. Under “Advanced” you can search by crop, year, county and SSN/FEIN. As a registered Farm Bill Buyer with the Montana Secretary of State’s office it is important to maintain the confidentiality of the information contained within the Farm Bill Master List. The Farm Bill Master List reflects personal data, such as Social Security Numbers, which are a key piece of personal identifiable information to assist you in determining the existence of a lien against a specific debtor. The distribution of this information beyond its intended purpose is strictly prohibited.\n\nThe debtor's tax identification number has been hidden for confidentiality reasons. You may continue to search on a tax ID number and return debtors that match your search criteria. The SSN/FEIN must be entered without dashes or spaces.","searchMustHaveOneOf":["search","UCC_FARM_PRODUCT_ID","COUNTY"],"searchPlaceholder":"Search by debtor name","advancedSearchParameters":[{"type":"ServerMultiComplete","label":"Product code name(s)","name":"UCC_FARM_PRODUCT_ID","defaultValue":"","optionsSrc":"UCC_FARM_PRODUCT_V"},{"type":"MultiComplete","label":"Year or Range of Years","name":"YEAR_NUM","optionsSrc":"years","startYear":"1968","defaultValue":[],"preMergeOptions":[{"value":"ALL","label":"All"}]},{"type":"serverSelect","label":"State","name":"STATE","defaultValue":"MONTANA","optionsSrc":"STATE"},{"type":"ServerMultiComplete","label":"County","name":"COUNTY","defaultValue":[],"optionsSrc":"COUNTY","overrideSubOptionsSrcFromParameterName":"STATE"},{"type":"checkbox","name":"TIN_SEARCH_YN","defaultValue":false,"label":"Tax Identification Number Search"},{"type":"checkbox","name":"TIN_SORT_YN","defaultValue":false,"label":"Unique ID Sort"}]},"ALLOW_ADDRESS_VALIDATION_BYPASS_OPTION":true,"DEFAULT_ADDRESS_VALIDATION_BYPASS_OPTION_CHECKED":true}).SIGNATURE_DEFAULT_DATE ? (0, _format2.default)(new Date(), 'MM/dd/yyyy') : null, capacity: '', behalf: '' };
	      });
	    }, _this.setSingleSignature = function (value) {
	      _this.props.onChange([value], {});
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(Signatures, [{
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _props = this.props,
	          srcRepeater = _props.srcRepeater,
	          srcField = _props.srcField,
	          value = _props.value,
	          emptyText = _props.emptyText,
	          description = _props.description,
	          placeholder = _props.placeholder,
	          disabled = _props.disabled,
	          printMailRequired = _props.printMailRequired,
	          correctionMode = _props.correctionMode,
	          multiple = _props.multiple,
	          required = _props.required,
	          todayButton = _props.todayButton,
	          showCapacity = _props.showCapacity,
	          showOnBehalfOf = _props.showOnBehalfOf,
	          capacityFreeText = _props.capacityFreeText;
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'panel signatures' },
	        description !== '' && _react2.default.createElement(_Markdown2.default, { source: description, className: 'markdown attestation' }),
	        _react2.default.createElement(
	          'div',
	          { className: 'row' },
	          multiple && !showCapacity && _react2.default.createElement(
	            'div',
	            { className: 'field-label col-sm-3' },
	            'Name'
	          ),
	          showCapacity && _react2.default.createElement(
	            _react2.default.Fragment,
	            null,
	            _react2.default.createElement(
	              'div',
	              { className: 'field-label col-sm-2' },
	              _react2.default.createElement(
	                'span',
	                { className: 'label-text' },
	                '' + (SIGNATURE_CAPACITY_LABEL || "Signer's Capacity"),
	                required && _react2.default.createElement(
	                  'span',
	                  { className: 'required' },
	                  '*'
	                )
	              )
	            ),
	            showOnBehalfOf && _react2.default.createElement(
	              'div',
	              { className: 'field-label col-sm-3' },
	              _react2.default.createElement(
	                'span',
	                { className: 'label-text' },
	                'On behalf of',
	                required && _react2.default.createElement(
	                  'span',
	                  { className: 'required' },
	                  '*'
	                )
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'field-label col-sm-' + (showCapacity ? showOnBehalfOf ? '3' : '5' : multiple ? '5' : '7') },
	            _react2.default.createElement(
	              'span',
	              { className: 'label-text' },
	              'Signature',
	              required && _react2.default.createElement(
	                'span',
	                { className: 'required' },
	                '*'
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'field-label col-sm-' + (showCapacity ? '3' : multiple ? '4' : '5') },
	            _react2.default.createElement(
	              'span',
	              { className: 'label-text' },
	              'Date',
	              required && _react2.default.createElement(
	                'span',
	                { className: 'required' },
	                '*'
	              )
	            )
	          )
	        ),
	        multiple ? srcRepeater && srcField ? srcRepeater.value.length === 0 ? _react2.default.createElement(_Markdown2.default, { source: emptyText, className: 'markdown' }) : srcRepeater.value.map(function (row, i) {
	          return _react2.default.createElement(
	            _Field.DumbField,
	            { errorMessage: _this2.getErrorMessageByIndex(i), key: i },
	            _react2.default.createElement(SignatureRow, {
	              label: row[srcField.fieldId],
	              disabled: disabled || ((true) && correctionMode ? false : printMailRequired),
	              placeholder: placeholder,
	              onChange: _this2.setSignatureValueByIndex,
	              value: ({"NODE_ENV":"production","BUILD_DATE":"2025-08-27T15:15:31.687Z","BUILD_NUMBER":"Not Provided","GIT_VERSION":"v1.3.0-381-ga81e29b08","GIT_COMMIT_HASH":"a81e29b085c9268ffd96c78eb734365802722741","GIT_BRANCH":"beta","PUBLIC_URL":"","STATE_ABBR":"MT","STATE_NAME":"Montana","STATE_ORG_TITLE":"Secretary of State","LOGIN_HEADER_IMG_PATH":"","HOME_IMG_FILENAME":"montana.jpg","FAVICON_FILE_NAME":"favicon.ico","ALLOW_E_SIGN_ON_CORRECTIONS":true,"THIRD_PARTY_SIGNING_ALLOWED":false,"MY_ACCOUNT_SAVE_AND_CLOSE_BUTTON":true,"IE_DEPRECATED_MESSAGE":"Internet Explorer is not supported. Please select a supported browser below to access this website.","ADDITIONAL_ROUTES":{"dataRequests":true,"farmBill":true,"apostille":true,"externalHelp":"https://sosmt.gov/business/help-center/","systemAdministration":[{"title":"Saved Payments","parameter":"saved-payments","componentName":"SavedPayments"}]},"SUBROUTES":[{"label":"Business","component":"Business","parameter":"business","myWorkQueueSearch":false,"sourceTypeId":54,"searchMustHaveOneOf":["FILING_TYPE_ID","STATUS_ID","STATE","search"],"serverWebSearchDescription":true,"serverWorkQueueDescription":true,"serverMyRecordsDescription":true,"searchPlaceholder":"Search by name or filing number (X########)","allowEmptySearchTerm":true,"requestCertificateAlternateLabel":"Request Information","fileAmendmentButtonLabel":"Filing Actions","advancedSearchParameters":[{"type":"radio","name":"QUERY_TYPE_ID","defaultValue":1010,"options":[{"value":1010,"label":"Starts with"},{"value":1011,"label":"Contains"},{"value":1012,"label":" Word Contains"}]},{"type":"serverSelect","name":"FILING_TYPE_ID","optionsSrc":"FILING_TYPES","label":"Entity Type","placeholder":"All","defaultValue":"0"},{"type":"serverSelect","name":"FILING_SUBTYPE_ID","optionsSrc":"FILING_SUBTYPES","label":"Entity Subtype","overrideSubOptionsSrcFromParameterName":"FILING_TYPE_ID","placeholder":"All","defaultValue":"0"},{"type":"serverSelect","name":"STATUS_ID","optionsSrc":"FILING_STATUS_WITHOUT_ALL","label":"Status","placeholder":"All","defaultValue":"0"},{"type":"serverSelect","name":"STATE","optionsSrc":"STATE","label":"State","placeholder":"All","defaultValue":""},{"type":"serverSelect","name":"COUNTY","optionsSrc":"COUNTY_SUBOPTION","label":"County","overrideSubOptionsSrcFromParameterName":"STATE","placeholder":"All","defaultValue":""},{"type":"checkbox","name":"CRA_SEARCH_YN","defaultValue":false,"label":"Search by Registered Agent PID"},{"type":"dateRange","name":"FILING_DATE","label":"Registration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}},{"type":"dateRange","name":"EXPIRATION_DATE","label":"Expiration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}}],"myRecordsFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Active"},{"value":2,"label":"Inactive"},{"value":3,"label":"Pending"}]},{"type":"dateRange","name":"DATE_RANGE","label":"Date range","defaultValue":{"start":null,"end":null}}],"myWorkQueueFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Approved"},{"value":2,"label":"Pending Online Payment"},{"value":3,"label":"Pending Review"},{"value":4,"label":"Needs Correction"},{"value":5,"label":"Rejected"},{"value":6,"label":"Draft"}]},{"type":"dateRange","name":"DATE_RANGE","label":"Date range","defaultValue":{"start":null,"end":null}}]},{"label":"Notary","component":"Notary","parameter":"notary","sourceTypeId":850,"myWorkQueueSearch":false,"allowEmptySearchTerm":true,"requestCertificateAlternateLabel":"Download Certificate","fileAmendmentButtonLabel":"Filing Actions","hideNameRequestCertificate":true,"hideAddressRequestCertificate":true,"hideRecordUserManagment":true,"searchPlaceholder":"Search by name or commission number","searchMustHaveOneOf":["CITY","search","SERVICE_TYPE"],"advancedParametersStartOpen":true,"searchIsSortable":true,"advancedSearchParameters":[{"type":"radio","name":"STARTS_WITH_YN","defaultValue":false,"options":[{"value":true,"label":"Starts with"},{"value":false,"label":"Contains"}]},{"type":"checkbox","name":"ACTIVE_ONLY_YN","defaultValue":true,"label":"Active entities only"},{"type":"text","name":"CITY","defaultValue":"","label":"City"},{"type":"select","name":"SERVICE_TYPE","label":"Special Services Offered","defaultValue":0,"options":[{"value":0,"label":"(N/A)"},{"value":6165,"label":"In-Person Electronic Notarization (IPEN)"},{"value":6166,"label":"Remote Online Notarization (RON)"},{"value":6167,"label":"Mobile Notary Services"},{"value":6168,"label":"Remote Ink Notarization (RIN)"}]}]},{"label":"Apostille","component":"Apostille","parameter":"apostille","sourceTypeId":720,"myRecordsSearch":false,"myWorkQueueSearch":false,"disabled":false,"allowedRoutes":["/forms-manager/","/queue/","/forms/"]},{"label":"Liens","component":"UCC","parameter":"ucc","sourceTypeId":1999,"myRecordsSearch":true,"myWorkQueueSearch":true,"fileAmendmentButtonLabel":"Filing Actions","searchPlaceholder":"Search by name or file number","disabled":false,"serverWebSearchDescription":true,"myRecordsDescription":"","workQueueDescription":"","searchDescription":"","hideRecordUserManagment":true,"searchLiensCheckout":false,"advancedSearchParameters":[{"type":"radio","name":"STARTS_WITH_YN","defaultValue":false,"options":[{"value":true,"label":"Starts with"},{"value":false,"label":"Contains"}]},{"type":"select","name":"STATUS","defaultValue":"ALL","label":"Status","options":[{"value":"ACTIVE_UNLAPSED","label":"Active (unlapsed)"},{"value":"ACTIVE_LAPSED_UNLAPSED","label":"Active (lapsed and unlapsed)"}]},{"type":"text","name":"EXCLUDE_VALUES","label":"Exclude Debtor Names (comma separated list of names to exclude)","defaultValue":""},{"type":"dateRange","name":"FILING_DATE","label":"Financing Statement Date","defaultValue":{"start":null,"end":null}},{"type":"dateRange","name":"LAPSE_DATE","label":"Lapse Date","defaultValue":{"start":null,"end":null}},{"type":"text","name":"CITY","label":"Debtor City","defaultValue":""}],"myRecordsFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Approved"},{"value":2,"label":"Pending Online Payment"},{"value":3,"label":"Pending Review"}]},{"type":"select","name":"TYPE","defaultValue":0,"label":"Lien Type","options":[{"value":0,"label":"All"},{"value":1,"label":"UCC"},{"value":2,"label":"EFS"},{"value":3,"label":"Title 71"}]}],"myWorkQueueFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Approved"},{"value":2,"label":"Pending Online Payment"},{"value":3,"label":"Pending Review"},{"value":4,"label":"Pending Print and Mail"},{"value":5,"label":"Rejected"},{"value":6,"label":"Draft"}]},{"type":"select","name":"TYPE","defaultValue":0,"label":"Lien Type","options":[{"value":0,"label":"All"},{"value":1,"label":"UCC"},{"value":2,"label":"EFS"},{"value":3,"label":"Title 71"}]}]},{"label":"Copy Request","component":"copies","parameter":"copies","sourceTypeId":2001,"myRecordsSearch":false,"myWorkQueueSearch":false,"disabled":false,"allowedRoutes":["/forms-manager/","/queue/","/forms/"]},{"label":"Trademark","component":"Trademark","parameter":"trademark","sourceTypeId":810,"showRequestCertificate":true,"searchMustHaveOneOf":["search","EXPIRATION_DATE","FILING_DATE"],"allowEmptySearchTerm":true,"requestCertificateAlternateLabel":"Request Information","fileAmendmentButtonLabel":"Filing Actions","advancedSearchParameters":[{"type":"radio","name":"QUERY_TYPE_ID","defaultValue":1010,"options":[{"value":1010,"label":"Starts with"},{"value":1011,"label":"Contains"},{"value":1012,"label":" Word Contains"}]},{"type":"checkbox","name":"OWNER_SEARCH_YN","defaultValue":false,"label":"Search owners"},{"type":"radio","name":"SERVICE_MARK_YN","label":"Mark Type","defaultValue":"","options":[{"value":"","label":"All Marks"},{"value":"Y","label":"Service Mark"},{"value":"N","label":"Trademark"}]},{"type":"serverSelect","name":"STATUS_ID","optionsSrc":"TYPE_V|TRADEMARK_STATUS_TYPE","label":"Status","placeholder":"All","defaultValue":"0"},{"type":"select","name":"DESIGN_TYPE_ID","options":[{"value":0,"label":"All"},{"value":990,"label":"Words Only"},{"value":991,"label":"Design Only"},{"value":992,"label":"Words and Design"}],"label":"Design Type","defaultValue":"0"},{"type":"dateRange","name":"FILING_DATE","label":"Registered Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}},{"type":"dateRange","name":"EXPIRATION_DATE","label":"Expiration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}}]},{"label":"Business Info Request","component":"InfoRequests","parameter":"info-request","sourceTypeId":167,"allowedRoutes":["/forms-manager/","/queue/","/forms/"]},{"label":"Data Requests","component":"DataRequests","parameter":"data-request","sourceTypeId":0,"allowedRoutes":["/forms-manager/"]},{"label":"CRA","component":"CRA","parameter":"cra","sourceTypeId":157,"myRecordsSearch":false,"searchPlaceholder":"Search by name or registered agent number","allowedRoutes":["/forms-manager/","/forms/","/records/","/queue/","/search/"],"allowEmptySearchTerm":true,"fileAmendmentButtonLabel":"Filing Actions","advancedSearchParameters":[{"type":"radio","name":"QUERY_TYPE_ID","defaultValue":1010,"options":[{"value":1010,"label":"Starts with"},{"value":1011,"label":"Contains"},{"value":1012,"label":" Word Contains"}]},{"type":"dateRange","name":"CRA_DATE","label":"Registration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}},{"type":"select","name":"STATUS_ID","label":"Status","defaultValue":0,"options":[{"value":0,"label":"All"},{"value":121,"label":"Active"},{"value":122,"label":"Inactive"}]},{"type":"select","name":"AGENT_TYPE_ID","label":"Agent Type","defaultValue":0,"options":[{"value":0,"label":"All"},{"value":460,"label":"Registered Agent"},{"value":461,"label":"Commercial Registered Agent"}]}]},{"label":"Farm Bill","component":"FarmBill","parameter":"farm-bill","path":"/lists/farm-bill","sourceTypeId":0,"myRecordsSearch":false,"allowedRules":["/search/"],"disabled":true,"searchDescription":"To perform a search, enter a debtor name. Your search results may include: exact debtor name, variations of that name and any filing that includes your search criteria. Punctuation is ignored.\n\nYou can click on \"Advanced\" to refine your search. Under “Advanced” you can search by crop, year, county and SSN/FEIN. As a registered Farm Bill Buyer with the Montana Secretary of State’s office it is important to maintain the confidentiality of the information contained within the Farm Bill Master List. The Farm Bill Master List reflects personal data, such as Social Security Numbers, which are a key piece of personal identifiable information to assist you in determining the existence of a lien against a specific debtor. The distribution of this information beyond its intended purpose is strictly prohibited.\n\nThe debtor's tax identification number has been hidden for confidentiality reasons. You may continue to search on a tax ID number and return debtors that match your search criteria. The SSN/FEIN must be entered without dashes or spaces.","searchMustHaveOneOf":["search","UCC_FARM_PRODUCT_ID","COUNTY"],"searchPlaceholder":"Search by debtor name","advancedSearchParameters":[{"type":"ServerMultiComplete","label":"Product code name(s)","name":"UCC_FARM_PRODUCT_ID","defaultValue":"","optionsSrc":"UCC_FARM_PRODUCT_V"},{"type":"MultiComplete","label":"Year or Range of Years","name":"YEAR_NUM","optionsSrc":"years","startYear":"1968","defaultValue":[],"preMergeOptions":[{"value":"ALL","label":"All"}]},{"type":"serverSelect","label":"State","name":"STATE","defaultValue":"MONTANA","optionsSrc":"STATE"},{"type":"ServerMultiComplete","label":"County","name":"COUNTY","defaultValue":[],"optionsSrc":"COUNTY","overrideSubOptionsSrcFromParameterName":"STATE"},{"type":"checkbox","name":"TIN_SEARCH_YN","defaultValue":false,"label":"Tax Identification Number Search"},{"type":"checkbox","name":"TIN_SORT_YN","defaultValue":false,"label":"Unique ID Sort"}]}],"SYSTEM_NICKNAME":"Online Services Portal","PAYMENT_METHODS":[{"type":"bypass"},{"type":"iTransact"}],"PAYMENT_ALLOW_AMEX":true,"SYSTEM_ID_LABEL":"System Id","DOUBLE_COLUMN_PUBLIC_LOGIN":true,"INTERNAL_USER_MANAGEMENT":true,"ALLOW_PUBLIC_JSON_IMPORT":false,"MAX_FILE_UPLOAD_SIZE":10000000,"REFUND_TEXT":"","RETURN_TO_HOME_ON_LOGOUT":true,"CURRENT_SOS_NAME":"Christi Jacobsen","LOGO_FILENAME":"mt-sos-logo.png","LOGO_ALT":"Christi Jacobsen, Montana Secretary of State","LOGO_FULL_WIDTH":true,"HOME_HIDE_AUTH_HINT":true,"HOME_TITLE":"Montana Secretary of State","CUSTOM_TAB_TITLE":"Official Montana","HOME_SUBTITLE":"Online Business Services","ENTITY_NAME_CONSENT_DESCRIPTION":"","ALLOW_USER_PROFILE_EDITING":true,"COMPARE_FOREIGN_NAME_IN_ENTITY_NAME_VALIDATION":true,"FOREIGN_NAME_FIELD_NAME":"KIMA_PARENT_NAME_INFO","LOGIN_TITLE":"Montana Secretary of State Online Filing Portal Login","PUBLIC_LOGIN_LABEL":"Username","REVERSE_LOGIN_COLUMNS":true,"LOGIN_SEAL_FILENAME":"seal_white.png","SEPARATE_USERNAME_AND_EMAIL":true,"CREATE_ACCOUNT_BUTTON_ALIGN_LEFT":true,"CREATE_ACCOUNT_BUTTON_TEXT":"CREATE AN ACCOUNT","PASSWORD_CUSTOM_ERROR_TEXT":"The password must meet all requirements","ACCOUNT_CREATED_MESSAGE":"Please check your email to verify your account to login and allow a few minutes for this message to arrive. Check your junk/spam folders if you do not find the email in your inbox.","PUBLIC_LOGIN_PLACEHOLDER":" ","DISABLE_DEFAULT_PAYMENT_RADIO":true,"CUSTOM_RESET_PASSWORD_ERROR_MESSAGE":"Username invalid - no account found","PUBLIC_LOGIN_CREATE_DESCRIPTION":"### Existing User:\n\n  - Enter your username and password to login.  \n\n\n  #### - OR -  \n\n\n\n  - Forgot password? Click 'Reset Password' and follow the prompts.\n  - Forgot username? Click 'Forgot Username' and follow the prompts.  \n\n\n  ### New User:\n  ","LOGIN_HELP_LINK":"https://sosmt.gov/business/how-do-i/","LOGIN_HELP_LINK_TEXT":"Need Help?","FORGOT_USERNAME_TEXT":"Forgot Username?","LOGIN_ACTIVE_DIRECTORY_TEXT":"State User Login","MULTIPLE_LOGIN_METHODS":true,"HAS_ACTIVE_DIRECTORY_LOGIN":true,"RESET_PASSWORD_WITH_USERNAME":true,"DOWNLOAD_LINK":true,"SHOW_USERNAME_ACCOUNT_CREATE":true,"SHOW_SCROLL_DOWN_ARROW":true,"SHOW_ADDRESS_ACCOUNT_CREATE":true,"TWO_COLUMN_ACCOUNT_CREATE":true,"RESET_PASSWORD_TIP":"A link to change your password has been sent to your email. Please allow a few minutes for this message to arrive. Please check your junk/spam folders if you do not find the email in your inbox.","FORGOT_PASSWORD_LINK_TEXT":"Reset Password","PHONE_NUMBER_OPTIONAL_ACCOUNT_CREATE":true,"SHOW_REQUIRED_INDICATOR_ACCOUNT_CREATE":true,"PASSWORD_REQUIREMENTS_ACCOUNT_CREATE":"\n    <ul>\n      <li>MUST contain at least 8 characters (12+ recommended)</li>\n      <li>MUST contain at least one uppercase letter.</li>\n      <li>MUST contain at least one lowercase letter.</li>\n      <li>MUST contain at least one number.</li>\n      <li>MUST contain at least one special character (!”#$%&'()*+,-./:;<=>?</li>\n    </ul>\n  ","ALLOW_CERTIFICATION_REQUEST":true,"ALLOW_PUBLIC_CERTIFICATE_REQUEST":true,"ALLOW_COPY_REQUEST":false,"ALLOW_CORRECTION_STYLING":true,"HIDE_DEPRECATION_WARNING":false,"AMEND_ROUTE_PUBLIC":true,"SEAL_FILENAME":"seal.png","SHOPPING_CART":true,"ALLOW_PAYMENT_UPDATE_WITH_EMPTY_CART":true,"RA_EMAIL":true,"RA_WEBSITE":true,"RA_NO_DEFAULT_TYPE":true,"RA_ADDRESS_LABEL":"Street Address","RA_TYPE_SELECTION_DEFAULT":true,"RA_DEFAULT_TYPE":"460","RA_OVERRIDE_TYPE_WITH_DEFAULT":true,"RA_PRINCIPAL_ADDRESS_AMS":true,"UPLOAD_AND_SUBMIT_HIDE_IF_ONE_OPTION":true,"PAYMENT_PROCESSING_MESSAGE":"Your payment is processing - Do not close your browser or click the back button","CHECKOUT_BUTTON_WHEN_PROCESSING_TEXT":"Processing","EFS_CROP_PICKER_NONE_LABEL":"Lien Duration","DISALLOWED_WIZARD_PIECES":["FormationLocale"],"REPEATER_SHOW_EDIT_BUTTON":true,"DATA_REQUEST_PAGE_TITLE":"Data Requests and Subscriptions","DATA_REQUEST_SIDEBAR_LABEL":"Data Requests & Subscriptions","LOGIN_REDIRECTS_TO_EPASS":false,"LOGIN_REDIRECTS_TO_ACTIVE_DIRECTORY":true,"LOGIN_ACTIVE_DIRECTORY_LINK":true,"FETCH_EDIT_USER_LINK":false,"LISTS_FETCH_AVAILABLE_LISTS":true,"POST_WIZARD_SUBMIT_REDIRECT_URL":"/","PIN_REQUEST_ATTESTATIONS":true,"PIN_REQUEST_DESCRIPTION":"Click **Request PIN** to have a new PIN sent to the account holder's email address on file.","OWNERSHIP_REQUEST_DESCRIPTION":"To become an **authorized user** of this record, a current **AUTHORIZED USER** will need to grant you access. To request access, click **Request Access** below.","PIN_REQUEST_SUCCESS_MESSAGE":"The PIN you have requested for this entity has been sent to the email associated with your user account.  You should receive the PIN in approximately 3-5 minutes, depending on your email service provider.","APOSTILLE_HEADER_LABEL":"Verification Information","APOSTILLE_NUMBER_LABEL":"Apostille/Authentication","APOSTILLE_CITY_STATE_OVERRIDE":"HELENA, MT","APOSTILLE_FILING_DATE_LABEL":"Issue Date","APOSTILLE_CITY_STATE_IN_CERTIFIED":true,"NOTARY_EXISTING_FILING":true,"ALLOW_REVOKE_OWN_ACCESS_ONLY":false,"HIDE_CANCEL_ON_ONETIME_DATA_REQUESTS":true,"DATA_REQUESTS_IN_SHOPPING_CART":true,"WQ_ALLOW_EDIT_PENDING_PAYMENT":true,"WQ_CONFIRM_ON_DELETE":true,"WQ_DELETE_CONFIRM_MESSAGE":"Deleting this filing will forfeit any money already paid to the Secretary of State. This action is permanent and cannot be undone, are you sure you would like to delete?","PASS_ITEM_GUIDS_ON_CHECKOUT":true,"FORM_REVISION_HISTORY":true,"CHECKOUT_DISCLAIMER":"By entering your credit card and/or checking account information you (i) state that **you are an authorized user** of the credit card and/or electronic check and that the associated information entered (e.g., account holder name, account number, billing address) is accurate, (ii) **you authorize payment processor to charge the amount you have requested** to your credit card and/or funding account, and (iii) **acknowledge if a charge is declined or reversed you may also be assessed a customary charge** by the payment processor for such transactions.","FARM_BILL_SEARCH_CONFIDENTIAL":"As a registered Farm Bill Buyer with the Montana Secretary of State’s office it is important to maintain the confidentiality of the information contained within the Farm Bill Master List. The Farm Bill Master List reflects personal data, such as Social Security Numbers, which are a key piece of personal identifiable information to assist you in determining the existence of a lien against a specific debtor. The distribution of this information beyond its intended purpose is strictly prohibited.\n\n**The debtor's tax identification number has been hidden for confidentiality reasons. You may continue to search on a tax ID number and return debtors that match your search criteria. The SSN/FEIN must be entered without dashes or spaces.  If you need access to the tax identification number to clearly identify the debtor, please contact the UCC unit at (406) 444-3665.**","VIEW_HISTORY_BUTTON_ALT_TEXT":"View Filings","WIZARD_ERROR_TITLE_MESSAGE":"Form Error","FARM_BILL_SEARCH_INTERACTIVE":true,"USE_FARM_BILL_API":true,"DISALLOW_ASSIGN_SELF_AS_RA":true,"DISALLOW_ASSIGN_SELF_AS_PRINCIPAL":true,"USE_TRADEMARK_OWNER_VALIDATION":true,"USE_ALTERNATIVE_FOREIGN_ADDRESS_LABELS":true,"MY_RECEIPTS_FILTER":[{"type":"dateRange","name":"DATE_RANGE","label":"Date range","defaultValue":{"start":null,"end":null}},{"type":"text","name":"REF_NUM","defaultValue":"","label":"Reference Number"},{"type":"text","name":"RECEIPT_NUM","defaultValue":"","label":"Receipt Id"},{"type":"text","name":"AMOUNT","defaultValue":"","label":"Amount"},{"type":"select","name":"TYPE","defaultValue":"","label":"Payment Type","options":[{"value":"","label":"All"},{"value":"CC","label":"Credit Card"},{"value":"Check","label":"Check"}]}],"MY_RECEIPTS_SHOW_IN_SIDEBAR":true,"SHOW_MY_RECEIPTS_HELPER_TEXT":true,"MY_RECEIPTS_HELPER_LABEL":"About Receipt Search","MY_RECEIPTS_HELPER_TEXT":"You can search for receipts based on their descriptions, including the items paid for on the receipt. Use the filters to search for or filter specific information.","FARM_BILL_SUBLINK":{"label":"Farm Bill","component":"FarmBill","parameter":"farm-bill","path":"/lists/farm-bill","sourceTypeId":0,"myRecordsSearch":false,"allowedRules":["/search/"],"disabled":true,"searchDescription":"To perform a search, enter a debtor name. Your search results may include: exact debtor name, variations of that name and any filing that includes your search criteria. Punctuation is ignored.\n\nYou can click on \"Advanced\" to refine your search. Under “Advanced” you can search by crop, year, county and SSN/FEIN. As a registered Farm Bill Buyer with the Montana Secretary of State’s office it is important to maintain the confidentiality of the information contained within the Farm Bill Master List. The Farm Bill Master List reflects personal data, such as Social Security Numbers, which are a key piece of personal identifiable information to assist you in determining the existence of a lien against a specific debtor. The distribution of this information beyond its intended purpose is strictly prohibited.\n\nThe debtor's tax identification number has been hidden for confidentiality reasons. You may continue to search on a tax ID number and return debtors that match your search criteria. The SSN/FEIN must be entered without dashes or spaces.","searchMustHaveOneOf":["search","UCC_FARM_PRODUCT_ID","COUNTY"],"searchPlaceholder":"Search by debtor name","advancedSearchParameters":[{"type":"ServerMultiComplete","label":"Product code name(s)","name":"UCC_FARM_PRODUCT_ID","defaultValue":"","optionsSrc":"UCC_FARM_PRODUCT_V"},{"type":"MultiComplete","label":"Year or Range of Years","name":"YEAR_NUM","optionsSrc":"years","startYear":"1968","defaultValue":[],"preMergeOptions":[{"value":"ALL","label":"All"}]},{"type":"serverSelect","label":"State","name":"STATE","defaultValue":"MONTANA","optionsSrc":"STATE"},{"type":"ServerMultiComplete","label":"County","name":"COUNTY","defaultValue":[],"optionsSrc":"COUNTY","overrideSubOptionsSrcFromParameterName":"STATE"},{"type":"checkbox","name":"TIN_SEARCH_YN","defaultValue":false,"label":"Tax Identification Number Search"},{"type":"checkbox","name":"TIN_SORT_YN","defaultValue":false,"label":"Unique ID Sort"}]},"ALLOW_ADDRESS_VALIDATION_BYPASS_OPTION":true,"DEFAULT_ADDRESS_VALIDATION_BYPASS_OPTION_CHECKED":true}).SIGNATURE_DEFAULT_DATE ? Object.assign({}, value[i], { date: (0, _format2.default)(new Date(), 'MM/dd/yyyy') }) : value[i],
	              srcField: srcField,
	              multiple: multiple,
	              todayButton: todayButton,
	              showCapacity: showCapacity,
	              showOnBehalfOf: showOnBehalfOf,
	              capacityFreeText: capacityFreeText,
	              index: i
	            })
	          );
	        }) : _react2.default.createElement(
	          'span',
	          { className: 'field-error' },
	          'A Source Repeater and Source Field must be selected when requiring multiple signatures.'
	        ) : _react2.default.createElement(
	          _Field.DumbField,
	          { errorMessage: this.getErrorMessageByIndex(0) },
	          _react2.default.createElement(SignatureRow, {
	            label: '',
	            disabled: disabled || ((true) && correctionMode ? false : printMailRequired),
	            placeholder: placeholder,
	            onChange: this.setSingleSignature,
	            value: ({"NODE_ENV":"production","BUILD_DATE":"2025-08-27T15:15:31.687Z","BUILD_NUMBER":"Not Provided","GIT_VERSION":"v1.3.0-381-ga81e29b08","GIT_COMMIT_HASH":"a81e29b085c9268ffd96c78eb734365802722741","GIT_BRANCH":"beta","PUBLIC_URL":"","STATE_ABBR":"MT","STATE_NAME":"Montana","STATE_ORG_TITLE":"Secretary of State","LOGIN_HEADER_IMG_PATH":"","HOME_IMG_FILENAME":"montana.jpg","FAVICON_FILE_NAME":"favicon.ico","ALLOW_E_SIGN_ON_CORRECTIONS":true,"THIRD_PARTY_SIGNING_ALLOWED":false,"MY_ACCOUNT_SAVE_AND_CLOSE_BUTTON":true,"IE_DEPRECATED_MESSAGE":"Internet Explorer is not supported. Please select a supported browser below to access this website.","ADDITIONAL_ROUTES":{"dataRequests":true,"farmBill":true,"apostille":true,"externalHelp":"https://sosmt.gov/business/help-center/","systemAdministration":[{"title":"Saved Payments","parameter":"saved-payments","componentName":"SavedPayments"}]},"SUBROUTES":[{"label":"Business","component":"Business","parameter":"business","myWorkQueueSearch":false,"sourceTypeId":54,"searchMustHaveOneOf":["FILING_TYPE_ID","STATUS_ID","STATE","search"],"serverWebSearchDescription":true,"serverWorkQueueDescription":true,"serverMyRecordsDescription":true,"searchPlaceholder":"Search by name or filing number (X########)","allowEmptySearchTerm":true,"requestCertificateAlternateLabel":"Request Information","fileAmendmentButtonLabel":"Filing Actions","advancedSearchParameters":[{"type":"radio","name":"QUERY_TYPE_ID","defaultValue":1010,"options":[{"value":1010,"label":"Starts with"},{"value":1011,"label":"Contains"},{"value":1012,"label":" Word Contains"}]},{"type":"serverSelect","name":"FILING_TYPE_ID","optionsSrc":"FILING_TYPES","label":"Entity Type","placeholder":"All","defaultValue":"0"},{"type":"serverSelect","name":"FILING_SUBTYPE_ID","optionsSrc":"FILING_SUBTYPES","label":"Entity Subtype","overrideSubOptionsSrcFromParameterName":"FILING_TYPE_ID","placeholder":"All","defaultValue":"0"},{"type":"serverSelect","name":"STATUS_ID","optionsSrc":"FILING_STATUS_WITHOUT_ALL","label":"Status","placeholder":"All","defaultValue":"0"},{"type":"serverSelect","name":"STATE","optionsSrc":"STATE","label":"State","placeholder":"All","defaultValue":""},{"type":"serverSelect","name":"COUNTY","optionsSrc":"COUNTY_SUBOPTION","label":"County","overrideSubOptionsSrcFromParameterName":"STATE","placeholder":"All","defaultValue":""},{"type":"checkbox","name":"CRA_SEARCH_YN","defaultValue":false,"label":"Search by Registered Agent PID"},{"type":"dateRange","name":"FILING_DATE","label":"Registration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}},{"type":"dateRange","name":"EXPIRATION_DATE","label":"Expiration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}}],"myRecordsFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Active"},{"value":2,"label":"Inactive"},{"value":3,"label":"Pending"}]},{"type":"dateRange","name":"DATE_RANGE","label":"Date range","defaultValue":{"start":null,"end":null}}],"myWorkQueueFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Approved"},{"value":2,"label":"Pending Online Payment"},{"value":3,"label":"Pending Review"},{"value":4,"label":"Needs Correction"},{"value":5,"label":"Rejected"},{"value":6,"label":"Draft"}]},{"type":"dateRange","name":"DATE_RANGE","label":"Date range","defaultValue":{"start":null,"end":null}}]},{"label":"Notary","component":"Notary","parameter":"notary","sourceTypeId":850,"myWorkQueueSearch":false,"allowEmptySearchTerm":true,"requestCertificateAlternateLabel":"Download Certificate","fileAmendmentButtonLabel":"Filing Actions","hideNameRequestCertificate":true,"hideAddressRequestCertificate":true,"hideRecordUserManagment":true,"searchPlaceholder":"Search by name or commission number","searchMustHaveOneOf":["CITY","search","SERVICE_TYPE"],"advancedParametersStartOpen":true,"searchIsSortable":true,"advancedSearchParameters":[{"type":"radio","name":"STARTS_WITH_YN","defaultValue":false,"options":[{"value":true,"label":"Starts with"},{"value":false,"label":"Contains"}]},{"type":"checkbox","name":"ACTIVE_ONLY_YN","defaultValue":true,"label":"Active entities only"},{"type":"text","name":"CITY","defaultValue":"","label":"City"},{"type":"select","name":"SERVICE_TYPE","label":"Special Services Offered","defaultValue":0,"options":[{"value":0,"label":"(N/A)"},{"value":6165,"label":"In-Person Electronic Notarization (IPEN)"},{"value":6166,"label":"Remote Online Notarization (RON)"},{"value":6167,"label":"Mobile Notary Services"},{"value":6168,"label":"Remote Ink Notarization (RIN)"}]}]},{"label":"Apostille","component":"Apostille","parameter":"apostille","sourceTypeId":720,"myRecordsSearch":false,"myWorkQueueSearch":false,"disabled":false,"allowedRoutes":["/forms-manager/","/queue/","/forms/"]},{"label":"Liens","component":"UCC","parameter":"ucc","sourceTypeId":1999,"myRecordsSearch":true,"myWorkQueueSearch":true,"fileAmendmentButtonLabel":"Filing Actions","searchPlaceholder":"Search by name or file number","disabled":false,"serverWebSearchDescription":true,"myRecordsDescription":"","workQueueDescription":"","searchDescription":"","hideRecordUserManagment":true,"searchLiensCheckout":false,"advancedSearchParameters":[{"type":"radio","name":"STARTS_WITH_YN","defaultValue":false,"options":[{"value":true,"label":"Starts with"},{"value":false,"label":"Contains"}]},{"type":"select","name":"STATUS","defaultValue":"ALL","label":"Status","options":[{"value":"ACTIVE_UNLAPSED","label":"Active (unlapsed)"},{"value":"ACTIVE_LAPSED_UNLAPSED","label":"Active (lapsed and unlapsed)"}]},{"type":"text","name":"EXCLUDE_VALUES","label":"Exclude Debtor Names (comma separated list of names to exclude)","defaultValue":""},{"type":"dateRange","name":"FILING_DATE","label":"Financing Statement Date","defaultValue":{"start":null,"end":null}},{"type":"dateRange","name":"LAPSE_DATE","label":"Lapse Date","defaultValue":{"start":null,"end":null}},{"type":"text","name":"CITY","label":"Debtor City","defaultValue":""}],"myRecordsFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Approved"},{"value":2,"label":"Pending Online Payment"},{"value":3,"label":"Pending Review"}]},{"type":"select","name":"TYPE","defaultValue":0,"label":"Lien Type","options":[{"value":0,"label":"All"},{"value":1,"label":"UCC"},{"value":2,"label":"EFS"},{"value":3,"label":"Title 71"}]}],"myWorkQueueFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Approved"},{"value":2,"label":"Pending Online Payment"},{"value":3,"label":"Pending Review"},{"value":4,"label":"Pending Print and Mail"},{"value":5,"label":"Rejected"},{"value":6,"label":"Draft"}]},{"type":"select","name":"TYPE","defaultValue":0,"label":"Lien Type","options":[{"value":0,"label":"All"},{"value":1,"label":"UCC"},{"value":2,"label":"EFS"},{"value":3,"label":"Title 71"}]}]},{"label":"Copy Request","component":"copies","parameter":"copies","sourceTypeId":2001,"myRecordsSearch":false,"myWorkQueueSearch":false,"disabled":false,"allowedRoutes":["/forms-manager/","/queue/","/forms/"]},{"label":"Trademark","component":"Trademark","parameter":"trademark","sourceTypeId":810,"showRequestCertificate":true,"searchMustHaveOneOf":["search","EXPIRATION_DATE","FILING_DATE"],"allowEmptySearchTerm":true,"requestCertificateAlternateLabel":"Request Information","fileAmendmentButtonLabel":"Filing Actions","advancedSearchParameters":[{"type":"radio","name":"QUERY_TYPE_ID","defaultValue":1010,"options":[{"value":1010,"label":"Starts with"},{"value":1011,"label":"Contains"},{"value":1012,"label":" Word Contains"}]},{"type":"checkbox","name":"OWNER_SEARCH_YN","defaultValue":false,"label":"Search owners"},{"type":"radio","name":"SERVICE_MARK_YN","label":"Mark Type","defaultValue":"","options":[{"value":"","label":"All Marks"},{"value":"Y","label":"Service Mark"},{"value":"N","label":"Trademark"}]},{"type":"serverSelect","name":"STATUS_ID","optionsSrc":"TYPE_V|TRADEMARK_STATUS_TYPE","label":"Status","placeholder":"All","defaultValue":"0"},{"type":"select","name":"DESIGN_TYPE_ID","options":[{"value":0,"label":"All"},{"value":990,"label":"Words Only"},{"value":991,"label":"Design Only"},{"value":992,"label":"Words and Design"}],"label":"Design Type","defaultValue":"0"},{"type":"dateRange","name":"FILING_DATE","label":"Registered Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}},{"type":"dateRange","name":"EXPIRATION_DATE","label":"Expiration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}}]},{"label":"Business Info Request","component":"InfoRequests","parameter":"info-request","sourceTypeId":167,"allowedRoutes":["/forms-manager/","/queue/","/forms/"]},{"label":"Data Requests","component":"DataRequests","parameter":"data-request","sourceTypeId":0,"allowedRoutes":["/forms-manager/"]},{"label":"CRA","component":"CRA","parameter":"cra","sourceTypeId":157,"myRecordsSearch":false,"searchPlaceholder":"Search by name or registered agent number","allowedRoutes":["/forms-manager/","/forms/","/records/","/queue/","/search/"],"allowEmptySearchTerm":true,"fileAmendmentButtonLabel":"Filing Actions","advancedSearchParameters":[{"type":"radio","name":"QUERY_TYPE_ID","defaultValue":1010,"options":[{"value":1010,"label":"Starts with"},{"value":1011,"label":"Contains"},{"value":1012,"label":" Word Contains"}]},{"type":"dateRange","name":"CRA_DATE","label":"Registration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}},{"type":"select","name":"STATUS_ID","label":"Status","defaultValue":0,"options":[{"value":0,"label":"All"},{"value":121,"label":"Active"},{"value":122,"label":"Inactive"}]},{"type":"select","name":"AGENT_TYPE_ID","label":"Agent Type","defaultValue":0,"options":[{"value":0,"label":"All"},{"value":460,"label":"Registered Agent"},{"value":461,"label":"Commercial Registered Agent"}]}]},{"label":"Farm Bill","component":"FarmBill","parameter":"farm-bill","path":"/lists/farm-bill","sourceTypeId":0,"myRecordsSearch":false,"allowedRules":["/search/"],"disabled":true,"searchDescription":"To perform a search, enter a debtor name. Your search results may include: exact debtor name, variations of that name and any filing that includes your search criteria. Punctuation is ignored.\n\nYou can click on \"Advanced\" to refine your search. Under “Advanced” you can search by crop, year, county and SSN/FEIN. As a registered Farm Bill Buyer with the Montana Secretary of State’s office it is important to maintain the confidentiality of the information contained within the Farm Bill Master List. The Farm Bill Master List reflects personal data, such as Social Security Numbers, which are a key piece of personal identifiable information to assist you in determining the existence of a lien against a specific debtor. The distribution of this information beyond its intended purpose is strictly prohibited.\n\nThe debtor's tax identification number has been hidden for confidentiality reasons. You may continue to search on a tax ID number and return debtors that match your search criteria. The SSN/FEIN must be entered without dashes or spaces.","searchMustHaveOneOf":["search","UCC_FARM_PRODUCT_ID","COUNTY"],"searchPlaceholder":"Search by debtor name","advancedSearchParameters":[{"type":"ServerMultiComplete","label":"Product code name(s)","name":"UCC_FARM_PRODUCT_ID","defaultValue":"","optionsSrc":"UCC_FARM_PRODUCT_V"},{"type":"MultiComplete","label":"Year or Range of Years","name":"YEAR_NUM","optionsSrc":"years","startYear":"1968","defaultValue":[],"preMergeOptions":[{"value":"ALL","label":"All"}]},{"type":"serverSelect","label":"State","name":"STATE","defaultValue":"MONTANA","optionsSrc":"STATE"},{"type":"ServerMultiComplete","label":"County","name":"COUNTY","defaultValue":[],"optionsSrc":"COUNTY","overrideSubOptionsSrcFromParameterName":"STATE"},{"type":"checkbox","name":"TIN_SEARCH_YN","defaultValue":false,"label":"Tax Identification Number Search"},{"type":"checkbox","name":"TIN_SORT_YN","defaultValue":false,"label":"Unique ID Sort"}]}],"SYSTEM_NICKNAME":"Online Services Portal","PAYMENT_METHODS":[{"type":"bypass"},{"type":"iTransact"}],"PAYMENT_ALLOW_AMEX":true,"SYSTEM_ID_LABEL":"System Id","DOUBLE_COLUMN_PUBLIC_LOGIN":true,"INTERNAL_USER_MANAGEMENT":true,"ALLOW_PUBLIC_JSON_IMPORT":false,"MAX_FILE_UPLOAD_SIZE":10000000,"REFUND_TEXT":"","RETURN_TO_HOME_ON_LOGOUT":true,"CURRENT_SOS_NAME":"Christi Jacobsen","LOGO_FILENAME":"mt-sos-logo.png","LOGO_ALT":"Christi Jacobsen, Montana Secretary of State","LOGO_FULL_WIDTH":true,"HOME_HIDE_AUTH_HINT":true,"HOME_TITLE":"Montana Secretary of State","CUSTOM_TAB_TITLE":"Official Montana","HOME_SUBTITLE":"Online Business Services","ENTITY_NAME_CONSENT_DESCRIPTION":"","ALLOW_USER_PROFILE_EDITING":true,"COMPARE_FOREIGN_NAME_IN_ENTITY_NAME_VALIDATION":true,"FOREIGN_NAME_FIELD_NAME":"KIMA_PARENT_NAME_INFO","LOGIN_TITLE":"Montana Secretary of State Online Filing Portal Login","PUBLIC_LOGIN_LABEL":"Username","REVERSE_LOGIN_COLUMNS":true,"LOGIN_SEAL_FILENAME":"seal_white.png","SEPARATE_USERNAME_AND_EMAIL":true,"CREATE_ACCOUNT_BUTTON_ALIGN_LEFT":true,"CREATE_ACCOUNT_BUTTON_TEXT":"CREATE AN ACCOUNT","PASSWORD_CUSTOM_ERROR_TEXT":"The password must meet all requirements","ACCOUNT_CREATED_MESSAGE":"Please check your email to verify your account to login and allow a few minutes for this message to arrive. Check your junk/spam folders if you do not find the email in your inbox.","PUBLIC_LOGIN_PLACEHOLDER":" ","DISABLE_DEFAULT_PAYMENT_RADIO":true,"CUSTOM_RESET_PASSWORD_ERROR_MESSAGE":"Username invalid - no account found","PUBLIC_LOGIN_CREATE_DESCRIPTION":"### Existing User:\n\n  - Enter your username and password to login.  \n\n\n  #### - OR -  \n\n\n\n  - Forgot password? Click 'Reset Password' and follow the prompts.\n  - Forgot username? Click 'Forgot Username' and follow the prompts.  \n\n\n  ### New User:\n  ","LOGIN_HELP_LINK":"https://sosmt.gov/business/how-do-i/","LOGIN_HELP_LINK_TEXT":"Need Help?","FORGOT_USERNAME_TEXT":"Forgot Username?","LOGIN_ACTIVE_DIRECTORY_TEXT":"State User Login","MULTIPLE_LOGIN_METHODS":true,"HAS_ACTIVE_DIRECTORY_LOGIN":true,"RESET_PASSWORD_WITH_USERNAME":true,"DOWNLOAD_LINK":true,"SHOW_USERNAME_ACCOUNT_CREATE":true,"SHOW_SCROLL_DOWN_ARROW":true,"SHOW_ADDRESS_ACCOUNT_CREATE":true,"TWO_COLUMN_ACCOUNT_CREATE":true,"RESET_PASSWORD_TIP":"A link to change your password has been sent to your email. Please allow a few minutes for this message to arrive. Please check your junk/spam folders if you do not find the email in your inbox.","FORGOT_PASSWORD_LINK_TEXT":"Reset Password","PHONE_NUMBER_OPTIONAL_ACCOUNT_CREATE":true,"SHOW_REQUIRED_INDICATOR_ACCOUNT_CREATE":true,"PASSWORD_REQUIREMENTS_ACCOUNT_CREATE":"\n    <ul>\n      <li>MUST contain at least 8 characters (12+ recommended)</li>\n      <li>MUST contain at least one uppercase letter.</li>\n      <li>MUST contain at least one lowercase letter.</li>\n      <li>MUST contain at least one number.</li>\n      <li>MUST contain at least one special character (!”#$%&'()*+,-./:;<=>?</li>\n    </ul>\n  ","ALLOW_CERTIFICATION_REQUEST":true,"ALLOW_PUBLIC_CERTIFICATE_REQUEST":true,"ALLOW_COPY_REQUEST":false,"ALLOW_CORRECTION_STYLING":true,"HIDE_DEPRECATION_WARNING":false,"AMEND_ROUTE_PUBLIC":true,"SEAL_FILENAME":"seal.png","SHOPPING_CART":true,"ALLOW_PAYMENT_UPDATE_WITH_EMPTY_CART":true,"RA_EMAIL":true,"RA_WEBSITE":true,"RA_NO_DEFAULT_TYPE":true,"RA_ADDRESS_LABEL":"Street Address","RA_TYPE_SELECTION_DEFAULT":true,"RA_DEFAULT_TYPE":"460","RA_OVERRIDE_TYPE_WITH_DEFAULT":true,"RA_PRINCIPAL_ADDRESS_AMS":true,"UPLOAD_AND_SUBMIT_HIDE_IF_ONE_OPTION":true,"PAYMENT_PROCESSING_MESSAGE":"Your payment is processing - Do not close your browser or click the back button","CHECKOUT_BUTTON_WHEN_PROCESSING_TEXT":"Processing","EFS_CROP_PICKER_NONE_LABEL":"Lien Duration","DISALLOWED_WIZARD_PIECES":["FormationLocale"],"REPEATER_SHOW_EDIT_BUTTON":true,"DATA_REQUEST_PAGE_TITLE":"Data Requests and Subscriptions","DATA_REQUEST_SIDEBAR_LABEL":"Data Requests & Subscriptions","LOGIN_REDIRECTS_TO_EPASS":false,"LOGIN_REDIRECTS_TO_ACTIVE_DIRECTORY":true,"LOGIN_ACTIVE_DIRECTORY_LINK":true,"FETCH_EDIT_USER_LINK":false,"LISTS_FETCH_AVAILABLE_LISTS":true,"POST_WIZARD_SUBMIT_REDIRECT_URL":"/","PIN_REQUEST_ATTESTATIONS":true,"PIN_REQUEST_DESCRIPTION":"Click **Request PIN** to have a new PIN sent to the account holder's email address on file.","OWNERSHIP_REQUEST_DESCRIPTION":"To become an **authorized user** of this record, a current **AUTHORIZED USER** will need to grant you access. To request access, click **Request Access** below.","PIN_REQUEST_SUCCESS_MESSAGE":"The PIN you have requested for this entity has been sent to the email associated with your user account.  You should receive the PIN in approximately 3-5 minutes, depending on your email service provider.","APOSTILLE_HEADER_LABEL":"Verification Information","APOSTILLE_NUMBER_LABEL":"Apostille/Authentication","APOSTILLE_CITY_STATE_OVERRIDE":"HELENA, MT","APOSTILLE_FILING_DATE_LABEL":"Issue Date","APOSTILLE_CITY_STATE_IN_CERTIFIED":true,"NOTARY_EXISTING_FILING":true,"ALLOW_REVOKE_OWN_ACCESS_ONLY":false,"HIDE_CANCEL_ON_ONETIME_DATA_REQUESTS":true,"DATA_REQUESTS_IN_SHOPPING_CART":true,"WQ_ALLOW_EDIT_PENDING_PAYMENT":true,"WQ_CONFIRM_ON_DELETE":true,"WQ_DELETE_CONFIRM_MESSAGE":"Deleting this filing will forfeit any money already paid to the Secretary of State. This action is permanent and cannot be undone, are you sure you would like to delete?","PASS_ITEM_GUIDS_ON_CHECKOUT":true,"FORM_REVISION_HISTORY":true,"CHECKOUT_DISCLAIMER":"By entering your credit card and/or checking account information you (i) state that **you are an authorized user** of the credit card and/or electronic check and that the associated information entered (e.g., account holder name, account number, billing address) is accurate, (ii) **you authorize payment processor to charge the amount you have requested** to your credit card and/or funding account, and (iii) **acknowledge if a charge is declined or reversed you may also be assessed a customary charge** by the payment processor for such transactions.","FARM_BILL_SEARCH_CONFIDENTIAL":"As a registered Farm Bill Buyer with the Montana Secretary of State’s office it is important to maintain the confidentiality of the information contained within the Farm Bill Master List. The Farm Bill Master List reflects personal data, such as Social Security Numbers, which are a key piece of personal identifiable information to assist you in determining the existence of a lien against a specific debtor. The distribution of this information beyond its intended purpose is strictly prohibited.\n\n**The debtor's tax identification number has been hidden for confidentiality reasons. You may continue to search on a tax ID number and return debtors that match your search criteria. The SSN/FEIN must be entered without dashes or spaces.  If you need access to the tax identification number to clearly identify the debtor, please contact the UCC unit at (406) 444-3665.**","VIEW_HISTORY_BUTTON_ALT_TEXT":"View Filings","WIZARD_ERROR_TITLE_MESSAGE":"Form Error","FARM_BILL_SEARCH_INTERACTIVE":true,"USE_FARM_BILL_API":true,"DISALLOW_ASSIGN_SELF_AS_RA":true,"DISALLOW_ASSIGN_SELF_AS_PRINCIPAL":true,"USE_TRADEMARK_OWNER_VALIDATION":true,"USE_ALTERNATIVE_FOREIGN_ADDRESS_LABELS":true,"MY_RECEIPTS_FILTER":[{"type":"dateRange","name":"DATE_RANGE","label":"Date range","defaultValue":{"start":null,"end":null}},{"type":"text","name":"REF_NUM","defaultValue":"","label":"Reference Number"},{"type":"text","name":"RECEIPT_NUM","defaultValue":"","label":"Receipt Id"},{"type":"text","name":"AMOUNT","defaultValue":"","label":"Amount"},{"type":"select","name":"TYPE","defaultValue":"","label":"Payment Type","options":[{"value":"","label":"All"},{"value":"CC","label":"Credit Card"},{"value":"Check","label":"Check"}]}],"MY_RECEIPTS_SHOW_IN_SIDEBAR":true,"SHOW_MY_RECEIPTS_HELPER_TEXT":true,"MY_RECEIPTS_HELPER_LABEL":"About Receipt Search","MY_RECEIPTS_HELPER_TEXT":"You can search for receipts based on their descriptions, including the items paid for on the receipt. Use the filters to search for or filter specific information.","FARM_BILL_SUBLINK":{"label":"Farm Bill","component":"FarmBill","parameter":"farm-bill","path":"/lists/farm-bill","sourceTypeId":0,"myRecordsSearch":false,"allowedRules":["/search/"],"disabled":true,"searchDescription":"To perform a search, enter a debtor name. Your search results may include: exact debtor name, variations of that name and any filing that includes your search criteria. Punctuation is ignored.\n\nYou can click on \"Advanced\" to refine your search. Under “Advanced” you can search by crop, year, county and SSN/FEIN. As a registered Farm Bill Buyer with the Montana Secretary of State’s office it is important to maintain the confidentiality of the information contained within the Farm Bill Master List. The Farm Bill Master List reflects personal data, such as Social Security Numbers, which are a key piece of personal identifiable information to assist you in determining the existence of a lien against a specific debtor. The distribution of this information beyond its intended purpose is strictly prohibited.\n\nThe debtor's tax identification number has been hidden for confidentiality reasons. You may continue to search on a tax ID number and return debtors that match your search criteria. The SSN/FEIN must be entered without dashes or spaces.","searchMustHaveOneOf":["search","UCC_FARM_PRODUCT_ID","COUNTY"],"searchPlaceholder":"Search by debtor name","advancedSearchParameters":[{"type":"ServerMultiComplete","label":"Product code name(s)","name":"UCC_FARM_PRODUCT_ID","defaultValue":"","optionsSrc":"UCC_FARM_PRODUCT_V"},{"type":"MultiComplete","label":"Year or Range of Years","name":"YEAR_NUM","optionsSrc":"years","startYear":"1968","defaultValue":[],"preMergeOptions":[{"value":"ALL","label":"All"}]},{"type":"serverSelect","label":"State","name":"STATE","defaultValue":"MONTANA","optionsSrc":"STATE"},{"type":"ServerMultiComplete","label":"County","name":"COUNTY","defaultValue":[],"optionsSrc":"COUNTY","overrideSubOptionsSrcFromParameterName":"STATE"},{"type":"checkbox","name":"TIN_SEARCH_YN","defaultValue":false,"label":"Tax Identification Number Search"},{"type":"checkbox","name":"TIN_SORT_YN","defaultValue":false,"label":"Unique ID Sort"}]},"ALLOW_ADDRESS_VALIDATION_BYPASS_OPTION":true,"DEFAULT_ADDRESS_VALIDATION_BYPASS_OPTION_CHECKED":true}).SIGNATURE_DEFAULT_DATE ? Object.assign({}, value[0], { date: (0, _format2.default)(new Date(), 'MM/dd/yyyy') }) : value[0],
	            multiple: multiple,
	            todayButton: todayButton,
	            showCapacity: showCapacity,
	            showOnBehalfOf: showOnBehalfOf,
	            capacityFreeText: capacityFreeText,
	            index: 0
	          })
	        ),
	        this.getOuterErrors() == undefined || this.getOuterErrors().length == 1 && this.getOuterErrors()[0] === "" ? null : _react2.default.createElement(_Field.DumbField, { errorMessage: this.getOuterErrors() })
	      );
	    }
	  }]);
	
	  return Signatures;
	}(_react.Component);
	
	exports.default = (0, _reactRedux.connect)(function (state, props) {
	  var srcRepeater = state.wizard.wizard.fields[props.srcRepeater];
	  var srcField = srcRepeater ? state.wizard.wizard.fields[props.srcField] : null;
	  return {
	    srcRepeater: srcRepeater,
	    srcField: srcField,
	    printMailRequired: state.wizard.requirePrintMailMethod.size > 0,
	    correctionMode: state.wizard.correctionMode
	  };
	})(Signatures);
	
	var SignatureRow = function (_Component2) {
	  _inherits(SignatureRow, _Component2);
	
	  function SignatureRow() {
	    var _ref2;
	
	    var _temp2, _this3, _ret2;
	
	    _classCallCheck(this, SignatureRow);
	
	    for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
	      args[_key2] = arguments[_key2];
	    }
	
	    return _ret2 = (_temp2 = (_this3 = _possibleConstructorReturn(this, (_ref2 = SignatureRow.__proto__ || Object.getPrototypeOf(SignatureRow)).call.apply(_ref2, [this].concat(args))), _this3), _this3.bubbleValueToParent = function (sig) {
	      var _this3$props$value = _this3.props.value,
	          value = _this3$props$value === undefined ? {} : _this3$props$value;
	
	      _this3.props.onChange(Object.assign({}, value, { sig: sig }), _this3.props.index);
	    }, _this3.bubbleDateToParent = function (date) {
	      var _this3$props$value2 = _this3.props.value,
	          value = _this3$props$value2 === undefined ? {} : _this3$props$value2;
	
	      _this3.props.onChange(Object.assign({}, value, { date: date }), _this3.props.index);
	    }, _this3.bubbleByKey = function (v, key) {
	      var _this3$props$value3 = _this3.props.value,
	          value = _this3$props$value3 === undefined ? {} : _this3$props$value3;
	
	      _this3.props.onChange(Object.assign({}, value, _defineProperty({}, key, v), key === 'capacity' && (v === 'self' || v === '') ? { behalf: '' } : {}), _this3.props.index);
	    }, _temp2), _possibleConstructorReturn(_this3, _ret2);
	  }
	
	  _createClass(SignatureRow, [{
	    key: 'render',
	    value: function render() {
	      var _this4 = this;
	
	      var _props2 = this.props,
	          label = _props2.label,
	          _props2$value = _props2.value,
	          value = _props2$value === undefined ? {} : _props2$value,
	          placeholder = _props2.placeholder,
	          disabled = _props2.disabled,
	          multiple = _props2.multiple,
	          todayButton = _props2.todayButton,
	          showCapacity = _props2.showCapacity,
	          showOnBehalfOf = _props2.showOnBehalfOf,
	          capacityFreeText = _props2.capacityFreeText;
	
	      value.name = label;
	      return _react2.default.createElement(
	        'div',
	        { className: 'row signature-row' },
	        multiple && !showCapacity && _react2.default.createElement(
	          'div',
	          { className: 'col-sm-3 label' },
	          _react2.default.createElement(
	            'span',
	            null,
	            label
	          )
	        ),
	        showCapacity && _react2.default.createElement(
	          'div',
	          { className: 'col-sm-2' },
	          capacityFreeText ? _react2.default.createElement(_Form.TextInput, {
	            disabled: disabled,
	            width: '100%',
	            value: value.capacity,
	            onChange: function onChange(value) {
	              return _this4.bubbleByKey(value, 'capacity');
	            },
	            onBlur: _utilities.noop,
	            ariaLabel: SIGNATURE_CAPACITY_LABEL || "Signer's Capacity"
	          }) : _react2.default.createElement(_Form.Select, {
	            disabled: disabled,
	            value: value.capacity,
	            onChange: function onChange(value) {
	              _this4.bubbleByKey(value, "capacity");
	            },
	            onBlur: _utilities.noop,
	            options: [{ value: '', label: '[Select an option]' }, { value: 'self', label: "Self" }, { value: 'power_of_attorney', label: "Power of Attorney" }, { value: 'attorney_in_fact', label: "Attorney in Fact" }, { value: 'representative', label: "Personal Representative of an Estate" }, { value: 'executor', label: "Executor of an Estate" }],
	            ariaLabel: SIGNATURE_CAPACITY_LABEL || "Signer's Capacity"
	          })
	        ),
	        showCapacity && showOnBehalfOf && _react2.default.createElement(
	          'div',
	          { className: 'col-sm-3 ' + (multiple ? 'label' : '') },
	          multiple ? _react2.default.createElement(
	            'span',
	            null,
	            label
	          ) : _react2.default.createElement(_Form.TextInput, {
	            value: value.behalf,
	            disabled: disabled || !multiple && (value.capacity === 'self' || value.capacity === undefined || value.capacity === ''),
	            width: '100%',
	            placeholder: placeholder,
	            onChange: function onChange(v) {
	              return _this4.bubbleByKey(v, 'behalf');
	            },
	            onBlur: _utilities.noop,
	            ariaLabel: 'Signing on behalf of'
	          })
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'col-sm-' + (showCapacity ? showOnBehalfOf ? '3' : '5' : multiple ? '5' : '7') },
	          _react2.default.createElement(_Form.TextInput, {
	            value: value.sig,
	            disabled: disabled,
	            width: '100%',
	            placeholder: placeholder,
	            onChange: this.bubbleValueToParent,
	            onBlur: _utilities.noop,
	            ariaLabel: multiple ? 'Signature for ' + label : "Signature"
	          })
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'col-sm-' + (showCapacity ? '4' : multiple ? '4' : '5') },
	          _react2.default.createElement(_Form.DateInput, { value: value.date, disabled: disabled || ({"NODE_ENV":"production","BUILD_DATE":"2025-08-27T15:15:31.687Z","BUILD_NUMBER":"Not Provided","GIT_VERSION":"v1.3.0-381-ga81e29b08","GIT_COMMIT_HASH":"a81e29b085c9268ffd96c78eb734365802722741","GIT_BRANCH":"beta","PUBLIC_URL":"","STATE_ABBR":"MT","STATE_NAME":"Montana","STATE_ORG_TITLE":"Secretary of State","LOGIN_HEADER_IMG_PATH":"","HOME_IMG_FILENAME":"montana.jpg","FAVICON_FILE_NAME":"favicon.ico","ALLOW_E_SIGN_ON_CORRECTIONS":true,"THIRD_PARTY_SIGNING_ALLOWED":false,"MY_ACCOUNT_SAVE_AND_CLOSE_BUTTON":true,"IE_DEPRECATED_MESSAGE":"Internet Explorer is not supported. Please select a supported browser below to access this website.","ADDITIONAL_ROUTES":{"dataRequests":true,"farmBill":true,"apostille":true,"externalHelp":"https://sosmt.gov/business/help-center/","systemAdministration":[{"title":"Saved Payments","parameter":"saved-payments","componentName":"SavedPayments"}]},"SUBROUTES":[{"label":"Business","component":"Business","parameter":"business","myWorkQueueSearch":false,"sourceTypeId":54,"searchMustHaveOneOf":["FILING_TYPE_ID","STATUS_ID","STATE","search"],"serverWebSearchDescription":true,"serverWorkQueueDescription":true,"serverMyRecordsDescription":true,"searchPlaceholder":"Search by name or filing number (X########)","allowEmptySearchTerm":true,"requestCertificateAlternateLabel":"Request Information","fileAmendmentButtonLabel":"Filing Actions","advancedSearchParameters":[{"type":"radio","name":"QUERY_TYPE_ID","defaultValue":1010,"options":[{"value":1010,"label":"Starts with"},{"value":1011,"label":"Contains"},{"value":1012,"label":" Word Contains"}]},{"type":"serverSelect","name":"FILING_TYPE_ID","optionsSrc":"FILING_TYPES","label":"Entity Type","placeholder":"All","defaultValue":"0"},{"type":"serverSelect","name":"FILING_SUBTYPE_ID","optionsSrc":"FILING_SUBTYPES","label":"Entity Subtype","overrideSubOptionsSrcFromParameterName":"FILING_TYPE_ID","placeholder":"All","defaultValue":"0"},{"type":"serverSelect","name":"STATUS_ID","optionsSrc":"FILING_STATUS_WITHOUT_ALL","label":"Status","placeholder":"All","defaultValue":"0"},{"type":"serverSelect","name":"STATE","optionsSrc":"STATE","label":"State","placeholder":"All","defaultValue":""},{"type":"serverSelect","name":"COUNTY","optionsSrc":"COUNTY_SUBOPTION","label":"County","overrideSubOptionsSrcFromParameterName":"STATE","placeholder":"All","defaultValue":""},{"type":"checkbox","name":"CRA_SEARCH_YN","defaultValue":false,"label":"Search by Registered Agent PID"},{"type":"dateRange","name":"FILING_DATE","label":"Registration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}},{"type":"dateRange","name":"EXPIRATION_DATE","label":"Expiration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}}],"myRecordsFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Active"},{"value":2,"label":"Inactive"},{"value":3,"label":"Pending"}]},{"type":"dateRange","name":"DATE_RANGE","label":"Date range","defaultValue":{"start":null,"end":null}}],"myWorkQueueFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Approved"},{"value":2,"label":"Pending Online Payment"},{"value":3,"label":"Pending Review"},{"value":4,"label":"Needs Correction"},{"value":5,"label":"Rejected"},{"value":6,"label":"Draft"}]},{"type":"dateRange","name":"DATE_RANGE","label":"Date range","defaultValue":{"start":null,"end":null}}]},{"label":"Notary","component":"Notary","parameter":"notary","sourceTypeId":850,"myWorkQueueSearch":false,"allowEmptySearchTerm":true,"requestCertificateAlternateLabel":"Download Certificate","fileAmendmentButtonLabel":"Filing Actions","hideNameRequestCertificate":true,"hideAddressRequestCertificate":true,"hideRecordUserManagment":true,"searchPlaceholder":"Search by name or commission number","searchMustHaveOneOf":["CITY","search","SERVICE_TYPE"],"advancedParametersStartOpen":true,"searchIsSortable":true,"advancedSearchParameters":[{"type":"radio","name":"STARTS_WITH_YN","defaultValue":false,"options":[{"value":true,"label":"Starts with"},{"value":false,"label":"Contains"}]},{"type":"checkbox","name":"ACTIVE_ONLY_YN","defaultValue":true,"label":"Active entities only"},{"type":"text","name":"CITY","defaultValue":"","label":"City"},{"type":"select","name":"SERVICE_TYPE","label":"Special Services Offered","defaultValue":0,"options":[{"value":0,"label":"(N/A)"},{"value":6165,"label":"In-Person Electronic Notarization (IPEN)"},{"value":6166,"label":"Remote Online Notarization (RON)"},{"value":6167,"label":"Mobile Notary Services"},{"value":6168,"label":"Remote Ink Notarization (RIN)"}]}]},{"label":"Apostille","component":"Apostille","parameter":"apostille","sourceTypeId":720,"myRecordsSearch":false,"myWorkQueueSearch":false,"disabled":false,"allowedRoutes":["/forms-manager/","/queue/","/forms/"]},{"label":"Liens","component":"UCC","parameter":"ucc","sourceTypeId":1999,"myRecordsSearch":true,"myWorkQueueSearch":true,"fileAmendmentButtonLabel":"Filing Actions","searchPlaceholder":"Search by name or file number","disabled":false,"serverWebSearchDescription":true,"myRecordsDescription":"","workQueueDescription":"","searchDescription":"","hideRecordUserManagment":true,"searchLiensCheckout":false,"advancedSearchParameters":[{"type":"radio","name":"STARTS_WITH_YN","defaultValue":false,"options":[{"value":true,"label":"Starts with"},{"value":false,"label":"Contains"}]},{"type":"select","name":"STATUS","defaultValue":"ALL","label":"Status","options":[{"value":"ACTIVE_UNLAPSED","label":"Active (unlapsed)"},{"value":"ACTIVE_LAPSED_UNLAPSED","label":"Active (lapsed and unlapsed)"}]},{"type":"text","name":"EXCLUDE_VALUES","label":"Exclude Debtor Names (comma separated list of names to exclude)","defaultValue":""},{"type":"dateRange","name":"FILING_DATE","label":"Financing Statement Date","defaultValue":{"start":null,"end":null}},{"type":"dateRange","name":"LAPSE_DATE","label":"Lapse Date","defaultValue":{"start":null,"end":null}},{"type":"text","name":"CITY","label":"Debtor City","defaultValue":""}],"myRecordsFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Approved"},{"value":2,"label":"Pending Online Payment"},{"value":3,"label":"Pending Review"}]},{"type":"select","name":"TYPE","defaultValue":0,"label":"Lien Type","options":[{"value":0,"label":"All"},{"value":1,"label":"UCC"},{"value":2,"label":"EFS"},{"value":3,"label":"Title 71"}]}],"myWorkQueueFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Approved"},{"value":2,"label":"Pending Online Payment"},{"value":3,"label":"Pending Review"},{"value":4,"label":"Pending Print and Mail"},{"value":5,"label":"Rejected"},{"value":6,"label":"Draft"}]},{"type":"select","name":"TYPE","defaultValue":0,"label":"Lien Type","options":[{"value":0,"label":"All"},{"value":1,"label":"UCC"},{"value":2,"label":"EFS"},{"value":3,"label":"Title 71"}]}]},{"label":"Copy Request","component":"copies","parameter":"copies","sourceTypeId":2001,"myRecordsSearch":false,"myWorkQueueSearch":false,"disabled":false,"allowedRoutes":["/forms-manager/","/queue/","/forms/"]},{"label":"Trademark","component":"Trademark","parameter":"trademark","sourceTypeId":810,"showRequestCertificate":true,"searchMustHaveOneOf":["search","EXPIRATION_DATE","FILING_DATE"],"allowEmptySearchTerm":true,"requestCertificateAlternateLabel":"Request Information","fileAmendmentButtonLabel":"Filing Actions","advancedSearchParameters":[{"type":"radio","name":"QUERY_TYPE_ID","defaultValue":1010,"options":[{"value":1010,"label":"Starts with"},{"value":1011,"label":"Contains"},{"value":1012,"label":" Word Contains"}]},{"type":"checkbox","name":"OWNER_SEARCH_YN","defaultValue":false,"label":"Search owners"},{"type":"radio","name":"SERVICE_MARK_YN","label":"Mark Type","defaultValue":"","options":[{"value":"","label":"All Marks"},{"value":"Y","label":"Service Mark"},{"value":"N","label":"Trademark"}]},{"type":"serverSelect","name":"STATUS_ID","optionsSrc":"TYPE_V|TRADEMARK_STATUS_TYPE","label":"Status","placeholder":"All","defaultValue":"0"},{"type":"select","name":"DESIGN_TYPE_ID","options":[{"value":0,"label":"All"},{"value":990,"label":"Words Only"},{"value":991,"label":"Design Only"},{"value":992,"label":"Words and Design"}],"label":"Design Type","defaultValue":"0"},{"type":"dateRange","name":"FILING_DATE","label":"Registered Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}},{"type":"dateRange","name":"EXPIRATION_DATE","label":"Expiration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}}]},{"label":"Business Info Request","component":"InfoRequests","parameter":"info-request","sourceTypeId":167,"allowedRoutes":["/forms-manager/","/queue/","/forms/"]},{"label":"Data Requests","component":"DataRequests","parameter":"data-request","sourceTypeId":0,"allowedRoutes":["/forms-manager/"]},{"label":"CRA","component":"CRA","parameter":"cra","sourceTypeId":157,"myRecordsSearch":false,"searchPlaceholder":"Search by name or registered agent number","allowedRoutes":["/forms-manager/","/forms/","/records/","/queue/","/search/"],"allowEmptySearchTerm":true,"fileAmendmentButtonLabel":"Filing Actions","advancedSearchParameters":[{"type":"radio","name":"QUERY_TYPE_ID","defaultValue":1010,"options":[{"value":1010,"label":"Starts with"},{"value":1011,"label":"Contains"},{"value":1012,"label":" Word Contains"}]},{"type":"dateRange","name":"CRA_DATE","label":"Registration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}},{"type":"select","name":"STATUS_ID","label":"Status","defaultValue":0,"options":[{"value":0,"label":"All"},{"value":121,"label":"Active"},{"value":122,"label":"Inactive"}]},{"type":"select","name":"AGENT_TYPE_ID","label":"Agent Type","defaultValue":0,"options":[{"value":0,"label":"All"},{"value":460,"label":"Registered Agent"},{"value":461,"label":"Commercial Registered Agent"}]}]},{"label":"Farm Bill","component":"FarmBill","parameter":"farm-bill","path":"/lists/farm-bill","sourceTypeId":0,"myRecordsSearch":false,"allowedRules":["/search/"],"disabled":true,"searchDescription":"To perform a search, enter a debtor name. Your search results may include: exact debtor name, variations of that name and any filing that includes your search criteria. Punctuation is ignored.\n\nYou can click on \"Advanced\" to refine your search. Under “Advanced” you can search by crop, year, county and SSN/FEIN. As a registered Farm Bill Buyer with the Montana Secretary of State’s office it is important to maintain the confidentiality of the information contained within the Farm Bill Master List. The Farm Bill Master List reflects personal data, such as Social Security Numbers, which are a key piece of personal identifiable information to assist you in determining the existence of a lien against a specific debtor. The distribution of this information beyond its intended purpose is strictly prohibited.\n\nThe debtor's tax identification number has been hidden for confidentiality reasons. You may continue to search on a tax ID number and return debtors that match your search criteria. The SSN/FEIN must be entered without dashes or spaces.","searchMustHaveOneOf":["search","UCC_FARM_PRODUCT_ID","COUNTY"],"searchPlaceholder":"Search by debtor name","advancedSearchParameters":[{"type":"ServerMultiComplete","label":"Product code name(s)","name":"UCC_FARM_PRODUCT_ID","defaultValue":"","optionsSrc":"UCC_FARM_PRODUCT_V"},{"type":"MultiComplete","label":"Year or Range of Years","name":"YEAR_NUM","optionsSrc":"years","startYear":"1968","defaultValue":[],"preMergeOptions":[{"value":"ALL","label":"All"}]},{"type":"serverSelect","label":"State","name":"STATE","defaultValue":"MONTANA","optionsSrc":"STATE"},{"type":"ServerMultiComplete","label":"County","name":"COUNTY","defaultValue":[],"optionsSrc":"COUNTY","overrideSubOptionsSrcFromParameterName":"STATE"},{"type":"checkbox","name":"TIN_SEARCH_YN","defaultValue":false,"label":"Tax Identification Number Search"},{"type":"checkbox","name":"TIN_SORT_YN","defaultValue":false,"label":"Unique ID Sort"}]}],"SYSTEM_NICKNAME":"Online Services Portal","PAYMENT_METHODS":[{"type":"bypass"},{"type":"iTransact"}],"PAYMENT_ALLOW_AMEX":true,"SYSTEM_ID_LABEL":"System Id","DOUBLE_COLUMN_PUBLIC_LOGIN":true,"INTERNAL_USER_MANAGEMENT":true,"ALLOW_PUBLIC_JSON_IMPORT":false,"MAX_FILE_UPLOAD_SIZE":10000000,"REFUND_TEXT":"","RETURN_TO_HOME_ON_LOGOUT":true,"CURRENT_SOS_NAME":"Christi Jacobsen","LOGO_FILENAME":"mt-sos-logo.png","LOGO_ALT":"Christi Jacobsen, Montana Secretary of State","LOGO_FULL_WIDTH":true,"HOME_HIDE_AUTH_HINT":true,"HOME_TITLE":"Montana Secretary of State","CUSTOM_TAB_TITLE":"Official Montana","HOME_SUBTITLE":"Online Business Services","ENTITY_NAME_CONSENT_DESCRIPTION":"","ALLOW_USER_PROFILE_EDITING":true,"COMPARE_FOREIGN_NAME_IN_ENTITY_NAME_VALIDATION":true,"FOREIGN_NAME_FIELD_NAME":"KIMA_PARENT_NAME_INFO","LOGIN_TITLE":"Montana Secretary of State Online Filing Portal Login","PUBLIC_LOGIN_LABEL":"Username","REVERSE_LOGIN_COLUMNS":true,"LOGIN_SEAL_FILENAME":"seal_white.png","SEPARATE_USERNAME_AND_EMAIL":true,"CREATE_ACCOUNT_BUTTON_ALIGN_LEFT":true,"CREATE_ACCOUNT_BUTTON_TEXT":"CREATE AN ACCOUNT","PASSWORD_CUSTOM_ERROR_TEXT":"The password must meet all requirements","ACCOUNT_CREATED_MESSAGE":"Please check your email to verify your account to login and allow a few minutes for this message to arrive. Check your junk/spam folders if you do not find the email in your inbox.","PUBLIC_LOGIN_PLACEHOLDER":" ","DISABLE_DEFAULT_PAYMENT_RADIO":true,"CUSTOM_RESET_PASSWORD_ERROR_MESSAGE":"Username invalid - no account found","PUBLIC_LOGIN_CREATE_DESCRIPTION":"### Existing User:\n\n  - Enter your username and password to login.  \n\n\n  #### - OR -  \n\n\n\n  - Forgot password? Click 'Reset Password' and follow the prompts.\n  - Forgot username? Click 'Forgot Username' and follow the prompts.  \n\n\n  ### New User:\n  ","LOGIN_HELP_LINK":"https://sosmt.gov/business/how-do-i/","LOGIN_HELP_LINK_TEXT":"Need Help?","FORGOT_USERNAME_TEXT":"Forgot Username?","LOGIN_ACTIVE_DIRECTORY_TEXT":"State User Login","MULTIPLE_LOGIN_METHODS":true,"HAS_ACTIVE_DIRECTORY_LOGIN":true,"RESET_PASSWORD_WITH_USERNAME":true,"DOWNLOAD_LINK":true,"SHOW_USERNAME_ACCOUNT_CREATE":true,"SHOW_SCROLL_DOWN_ARROW":true,"SHOW_ADDRESS_ACCOUNT_CREATE":true,"TWO_COLUMN_ACCOUNT_CREATE":true,"RESET_PASSWORD_TIP":"A link to change your password has been sent to your email. Please allow a few minutes for this message to arrive. Please check your junk/spam folders if you do not find the email in your inbox.","FORGOT_PASSWORD_LINK_TEXT":"Reset Password","PHONE_NUMBER_OPTIONAL_ACCOUNT_CREATE":true,"SHOW_REQUIRED_INDICATOR_ACCOUNT_CREATE":true,"PASSWORD_REQUIREMENTS_ACCOUNT_CREATE":"\n    <ul>\n      <li>MUST contain at least 8 characters (12+ recommended)</li>\n      <li>MUST contain at least one uppercase letter.</li>\n      <li>MUST contain at least one lowercase letter.</li>\n      <li>MUST contain at least one number.</li>\n      <li>MUST contain at least one special character (!”#$%&'()*+,-./:;<=>?</li>\n    </ul>\n  ","ALLOW_CERTIFICATION_REQUEST":true,"ALLOW_PUBLIC_CERTIFICATE_REQUEST":true,"ALLOW_COPY_REQUEST":false,"ALLOW_CORRECTION_STYLING":true,"HIDE_DEPRECATION_WARNING":false,"AMEND_ROUTE_PUBLIC":true,"SEAL_FILENAME":"seal.png","SHOPPING_CART":true,"ALLOW_PAYMENT_UPDATE_WITH_EMPTY_CART":true,"RA_EMAIL":true,"RA_WEBSITE":true,"RA_NO_DEFAULT_TYPE":true,"RA_ADDRESS_LABEL":"Street Address","RA_TYPE_SELECTION_DEFAULT":true,"RA_DEFAULT_TYPE":"460","RA_OVERRIDE_TYPE_WITH_DEFAULT":true,"RA_PRINCIPAL_ADDRESS_AMS":true,"UPLOAD_AND_SUBMIT_HIDE_IF_ONE_OPTION":true,"PAYMENT_PROCESSING_MESSAGE":"Your payment is processing - Do not close your browser or click the back button","CHECKOUT_BUTTON_WHEN_PROCESSING_TEXT":"Processing","EFS_CROP_PICKER_NONE_LABEL":"Lien Duration","DISALLOWED_WIZARD_PIECES":["FormationLocale"],"REPEATER_SHOW_EDIT_BUTTON":true,"DATA_REQUEST_PAGE_TITLE":"Data Requests and Subscriptions","DATA_REQUEST_SIDEBAR_LABEL":"Data Requests & Subscriptions","LOGIN_REDIRECTS_TO_EPASS":false,"LOGIN_REDIRECTS_TO_ACTIVE_DIRECTORY":true,"LOGIN_ACTIVE_DIRECTORY_LINK":true,"FETCH_EDIT_USER_LINK":false,"LISTS_FETCH_AVAILABLE_LISTS":true,"POST_WIZARD_SUBMIT_REDIRECT_URL":"/","PIN_REQUEST_ATTESTATIONS":true,"PIN_REQUEST_DESCRIPTION":"Click **Request PIN** to have a new PIN sent to the account holder's email address on file.","OWNERSHIP_REQUEST_DESCRIPTION":"To become an **authorized user** of this record, a current **AUTHORIZED USER** will need to grant you access. To request access, click **Request Access** below.","PIN_REQUEST_SUCCESS_MESSAGE":"The PIN you have requested for this entity has been sent to the email associated with your user account.  You should receive the PIN in approximately 3-5 minutes, depending on your email service provider.","APOSTILLE_HEADER_LABEL":"Verification Information","APOSTILLE_NUMBER_LABEL":"Apostille/Authentication","APOSTILLE_CITY_STATE_OVERRIDE":"HELENA, MT","APOSTILLE_FILING_DATE_LABEL":"Issue Date","APOSTILLE_CITY_STATE_IN_CERTIFIED":true,"NOTARY_EXISTING_FILING":true,"ALLOW_REVOKE_OWN_ACCESS_ONLY":false,"HIDE_CANCEL_ON_ONETIME_DATA_REQUESTS":true,"DATA_REQUESTS_IN_SHOPPING_CART":true,"WQ_ALLOW_EDIT_PENDING_PAYMENT":true,"WQ_CONFIRM_ON_DELETE":true,"WQ_DELETE_CONFIRM_MESSAGE":"Deleting this filing will forfeit any money already paid to the Secretary of State. This action is permanent and cannot be undone, are you sure you would like to delete?","PASS_ITEM_GUIDS_ON_CHECKOUT":true,"FORM_REVISION_HISTORY":true,"CHECKOUT_DISCLAIMER":"By entering your credit card and/or checking account information you (i) state that **you are an authorized user** of the credit card and/or electronic check and that the associated information entered (e.g., account holder name, account number, billing address) is accurate, (ii) **you authorize payment processor to charge the amount you have requested** to your credit card and/or funding account, and (iii) **acknowledge if a charge is declined or reversed you may also be assessed a customary charge** by the payment processor for such transactions.","FARM_BILL_SEARCH_CONFIDENTIAL":"As a registered Farm Bill Buyer with the Montana Secretary of State’s office it is important to maintain the confidentiality of the information contained within the Farm Bill Master List. The Farm Bill Master List reflects personal data, such as Social Security Numbers, which are a key piece of personal identifiable information to assist you in determining the existence of a lien against a specific debtor. The distribution of this information beyond its intended purpose is strictly prohibited.\n\n**The debtor's tax identification number has been hidden for confidentiality reasons. You may continue to search on a tax ID number and return debtors that match your search criteria. The SSN/FEIN must be entered without dashes or spaces.  If you need access to the tax identification number to clearly identify the debtor, please contact the UCC unit at (406) 444-3665.**","VIEW_HISTORY_BUTTON_ALT_TEXT":"View Filings","WIZARD_ERROR_TITLE_MESSAGE":"Form Error","FARM_BILL_SEARCH_INTERACTIVE":true,"USE_FARM_BILL_API":true,"DISALLOW_ASSIGN_SELF_AS_RA":true,"DISALLOW_ASSIGN_SELF_AS_PRINCIPAL":true,"USE_TRADEMARK_OWNER_VALIDATION":true,"USE_ALTERNATIVE_FOREIGN_ADDRESS_LABELS":true,"MY_RECEIPTS_FILTER":[{"type":"dateRange","name":"DATE_RANGE","label":"Date range","defaultValue":{"start":null,"end":null}},{"type":"text","name":"REF_NUM","defaultValue":"","label":"Reference Number"},{"type":"text","name":"RECEIPT_NUM","defaultValue":"","label":"Receipt Id"},{"type":"text","name":"AMOUNT","defaultValue":"","label":"Amount"},{"type":"select","name":"TYPE","defaultValue":"","label":"Payment Type","options":[{"value":"","label":"All"},{"value":"CC","label":"Credit Card"},{"value":"Check","label":"Check"}]}],"MY_RECEIPTS_SHOW_IN_SIDEBAR":true,"SHOW_MY_RECEIPTS_HELPER_TEXT":true,"MY_RECEIPTS_HELPER_LABEL":"About Receipt Search","MY_RECEIPTS_HELPER_TEXT":"You can search for receipts based on their descriptions, including the items paid for on the receipt. Use the filters to search for or filter specific information.","FARM_BILL_SUBLINK":{"label":"Farm Bill","component":"FarmBill","parameter":"farm-bill","path":"/lists/farm-bill","sourceTypeId":0,"myRecordsSearch":false,"allowedRules":["/search/"],"disabled":true,"searchDescription":"To perform a search, enter a debtor name. Your search results may include: exact debtor name, variations of that name and any filing that includes your search criteria. Punctuation is ignored.\n\nYou can click on \"Advanced\" to refine your search. Under “Advanced” you can search by crop, year, county and SSN/FEIN. As a registered Farm Bill Buyer with the Montana Secretary of State’s office it is important to maintain the confidentiality of the information contained within the Farm Bill Master List. The Farm Bill Master List reflects personal data, such as Social Security Numbers, which are a key piece of personal identifiable information to assist you in determining the existence of a lien against a specific debtor. The distribution of this information beyond its intended purpose is strictly prohibited.\n\nThe debtor's tax identification number has been hidden for confidentiality reasons. You may continue to search on a tax ID number and return debtors that match your search criteria. The SSN/FEIN must be entered without dashes or spaces.","searchMustHaveOneOf":["search","UCC_FARM_PRODUCT_ID","COUNTY"],"searchPlaceholder":"Search by debtor name","advancedSearchParameters":[{"type":"ServerMultiComplete","label":"Product code name(s)","name":"UCC_FARM_PRODUCT_ID","defaultValue":"","optionsSrc":"UCC_FARM_PRODUCT_V"},{"type":"MultiComplete","label":"Year or Range of Years","name":"YEAR_NUM","optionsSrc":"years","startYear":"1968","defaultValue":[],"preMergeOptions":[{"value":"ALL","label":"All"}]},{"type":"serverSelect","label":"State","name":"STATE","defaultValue":"MONTANA","optionsSrc":"STATE"},{"type":"ServerMultiComplete","label":"County","name":"COUNTY","defaultValue":[],"optionsSrc":"COUNTY","overrideSubOptionsSrcFromParameterName":"STATE"},{"type":"checkbox","name":"TIN_SEARCH_YN","defaultValue":false,"label":"Tax Identification Number Search"},{"type":"checkbox","name":"TIN_SORT_YN","defaultValue":false,"label":"Unique ID Sort"}]},"ALLOW_ADDRESS_VALIDATION_BYPASS_OPTION":true,"DEFAULT_ADDRESS_VALIDATION_BYPASS_OPTION_CHECKED":true}).DISALLOW_SIGNATURE_DATE_CHANGE, todayButton: ({"NODE_ENV":"production","BUILD_DATE":"2025-08-27T15:15:31.687Z","BUILD_NUMBER":"Not Provided","GIT_VERSION":"v1.3.0-381-ga81e29b08","GIT_COMMIT_HASH":"a81e29b085c9268ffd96c78eb734365802722741","GIT_BRANCH":"beta","PUBLIC_URL":"","STATE_ABBR":"MT","STATE_NAME":"Montana","STATE_ORG_TITLE":"Secretary of State","LOGIN_HEADER_IMG_PATH":"","HOME_IMG_FILENAME":"montana.jpg","FAVICON_FILE_NAME":"favicon.ico","ALLOW_E_SIGN_ON_CORRECTIONS":true,"THIRD_PARTY_SIGNING_ALLOWED":false,"MY_ACCOUNT_SAVE_AND_CLOSE_BUTTON":true,"IE_DEPRECATED_MESSAGE":"Internet Explorer is not supported. Please select a supported browser below to access this website.","ADDITIONAL_ROUTES":{"dataRequests":true,"farmBill":true,"apostille":true,"externalHelp":"https://sosmt.gov/business/help-center/","systemAdministration":[{"title":"Saved Payments","parameter":"saved-payments","componentName":"SavedPayments"}]},"SUBROUTES":[{"label":"Business","component":"Business","parameter":"business","myWorkQueueSearch":false,"sourceTypeId":54,"searchMustHaveOneOf":["FILING_TYPE_ID","STATUS_ID","STATE","search"],"serverWebSearchDescription":true,"serverWorkQueueDescription":true,"serverMyRecordsDescription":true,"searchPlaceholder":"Search by name or filing number (X########)","allowEmptySearchTerm":true,"requestCertificateAlternateLabel":"Request Information","fileAmendmentButtonLabel":"Filing Actions","advancedSearchParameters":[{"type":"radio","name":"QUERY_TYPE_ID","defaultValue":1010,"options":[{"value":1010,"label":"Starts with"},{"value":1011,"label":"Contains"},{"value":1012,"label":" Word Contains"}]},{"type":"serverSelect","name":"FILING_TYPE_ID","optionsSrc":"FILING_TYPES","label":"Entity Type","placeholder":"All","defaultValue":"0"},{"type":"serverSelect","name":"FILING_SUBTYPE_ID","optionsSrc":"FILING_SUBTYPES","label":"Entity Subtype","overrideSubOptionsSrcFromParameterName":"FILING_TYPE_ID","placeholder":"All","defaultValue":"0"},{"type":"serverSelect","name":"STATUS_ID","optionsSrc":"FILING_STATUS_WITHOUT_ALL","label":"Status","placeholder":"All","defaultValue":"0"},{"type":"serverSelect","name":"STATE","optionsSrc":"STATE","label":"State","placeholder":"All","defaultValue":""},{"type":"serverSelect","name":"COUNTY","optionsSrc":"COUNTY_SUBOPTION","label":"County","overrideSubOptionsSrcFromParameterName":"STATE","placeholder":"All","defaultValue":""},{"type":"checkbox","name":"CRA_SEARCH_YN","defaultValue":false,"label":"Search by Registered Agent PID"},{"type":"dateRange","name":"FILING_DATE","label":"Registration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}},{"type":"dateRange","name":"EXPIRATION_DATE","label":"Expiration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}}],"myRecordsFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Active"},{"value":2,"label":"Inactive"},{"value":3,"label":"Pending"}]},{"type":"dateRange","name":"DATE_RANGE","label":"Date range","defaultValue":{"start":null,"end":null}}],"myWorkQueueFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Approved"},{"value":2,"label":"Pending Online Payment"},{"value":3,"label":"Pending Review"},{"value":4,"label":"Needs Correction"},{"value":5,"label":"Rejected"},{"value":6,"label":"Draft"}]},{"type":"dateRange","name":"DATE_RANGE","label":"Date range","defaultValue":{"start":null,"end":null}}]},{"label":"Notary","component":"Notary","parameter":"notary","sourceTypeId":850,"myWorkQueueSearch":false,"allowEmptySearchTerm":true,"requestCertificateAlternateLabel":"Download Certificate","fileAmendmentButtonLabel":"Filing Actions","hideNameRequestCertificate":true,"hideAddressRequestCertificate":true,"hideRecordUserManagment":true,"searchPlaceholder":"Search by name or commission number","searchMustHaveOneOf":["CITY","search","SERVICE_TYPE"],"advancedParametersStartOpen":true,"searchIsSortable":true,"advancedSearchParameters":[{"type":"radio","name":"STARTS_WITH_YN","defaultValue":false,"options":[{"value":true,"label":"Starts with"},{"value":false,"label":"Contains"}]},{"type":"checkbox","name":"ACTIVE_ONLY_YN","defaultValue":true,"label":"Active entities only"},{"type":"text","name":"CITY","defaultValue":"","label":"City"},{"type":"select","name":"SERVICE_TYPE","label":"Special Services Offered","defaultValue":0,"options":[{"value":0,"label":"(N/A)"},{"value":6165,"label":"In-Person Electronic Notarization (IPEN)"},{"value":6166,"label":"Remote Online Notarization (RON)"},{"value":6167,"label":"Mobile Notary Services"},{"value":6168,"label":"Remote Ink Notarization (RIN)"}]}]},{"label":"Apostille","component":"Apostille","parameter":"apostille","sourceTypeId":720,"myRecordsSearch":false,"myWorkQueueSearch":false,"disabled":false,"allowedRoutes":["/forms-manager/","/queue/","/forms/"]},{"label":"Liens","component":"UCC","parameter":"ucc","sourceTypeId":1999,"myRecordsSearch":true,"myWorkQueueSearch":true,"fileAmendmentButtonLabel":"Filing Actions","searchPlaceholder":"Search by name or file number","disabled":false,"serverWebSearchDescription":true,"myRecordsDescription":"","workQueueDescription":"","searchDescription":"","hideRecordUserManagment":true,"searchLiensCheckout":false,"advancedSearchParameters":[{"type":"radio","name":"STARTS_WITH_YN","defaultValue":false,"options":[{"value":true,"label":"Starts with"},{"value":false,"label":"Contains"}]},{"type":"select","name":"STATUS","defaultValue":"ALL","label":"Status","options":[{"value":"ACTIVE_UNLAPSED","label":"Active (unlapsed)"},{"value":"ACTIVE_LAPSED_UNLAPSED","label":"Active (lapsed and unlapsed)"}]},{"type":"text","name":"EXCLUDE_VALUES","label":"Exclude Debtor Names (comma separated list of names to exclude)","defaultValue":""},{"type":"dateRange","name":"FILING_DATE","label":"Financing Statement Date","defaultValue":{"start":null,"end":null}},{"type":"dateRange","name":"LAPSE_DATE","label":"Lapse Date","defaultValue":{"start":null,"end":null}},{"type":"text","name":"CITY","label":"Debtor City","defaultValue":""}],"myRecordsFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Approved"},{"value":2,"label":"Pending Online Payment"},{"value":3,"label":"Pending Review"}]},{"type":"select","name":"TYPE","defaultValue":0,"label":"Lien Type","options":[{"value":0,"label":"All"},{"value":1,"label":"UCC"},{"value":2,"label":"EFS"},{"value":3,"label":"Title 71"}]}],"myWorkQueueFilters":[{"type":"select","name":"STATUS","defaultValue":0,"label":"Status","options":[{"value":0,"label":"All"},{"value":1,"label":"Approved"},{"value":2,"label":"Pending Online Payment"},{"value":3,"label":"Pending Review"},{"value":4,"label":"Pending Print and Mail"},{"value":5,"label":"Rejected"},{"value":6,"label":"Draft"}]},{"type":"select","name":"TYPE","defaultValue":0,"label":"Lien Type","options":[{"value":0,"label":"All"},{"value":1,"label":"UCC"},{"value":2,"label":"EFS"},{"value":3,"label":"Title 71"}]}]},{"label":"Copy Request","component":"copies","parameter":"copies","sourceTypeId":2001,"myRecordsSearch":false,"myWorkQueueSearch":false,"disabled":false,"allowedRoutes":["/forms-manager/","/queue/","/forms/"]},{"label":"Trademark","component":"Trademark","parameter":"trademark","sourceTypeId":810,"showRequestCertificate":true,"searchMustHaveOneOf":["search","EXPIRATION_DATE","FILING_DATE"],"allowEmptySearchTerm":true,"requestCertificateAlternateLabel":"Request Information","fileAmendmentButtonLabel":"Filing Actions","advancedSearchParameters":[{"type":"radio","name":"QUERY_TYPE_ID","defaultValue":1010,"options":[{"value":1010,"label":"Starts with"},{"value":1011,"label":"Contains"},{"value":1012,"label":" Word Contains"}]},{"type":"checkbox","name":"OWNER_SEARCH_YN","defaultValue":false,"label":"Search owners"},{"type":"radio","name":"SERVICE_MARK_YN","label":"Mark Type","defaultValue":"","options":[{"value":"","label":"All Marks"},{"value":"Y","label":"Service Mark"},{"value":"N","label":"Trademark"}]},{"type":"serverSelect","name":"STATUS_ID","optionsSrc":"TYPE_V|TRADEMARK_STATUS_TYPE","label":"Status","placeholder":"All","defaultValue":"0"},{"type":"select","name":"DESIGN_TYPE_ID","options":[{"value":0,"label":"All"},{"value":990,"label":"Words Only"},{"value":991,"label":"Design Only"},{"value":992,"label":"Words and Design"}],"label":"Design Type","defaultValue":"0"},{"type":"dateRange","name":"FILING_DATE","label":"Registered Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}},{"type":"dateRange","name":"EXPIRATION_DATE","label":"Expiration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}}]},{"label":"Business Info Request","component":"InfoRequests","parameter":"info-request","sourceTypeId":167,"allowedRoutes":["/forms-manager/","/queue/","/forms/"]},{"label":"Data Requests","component":"DataRequests","parameter":"data-request","sourceTypeId":0,"allowedRoutes":["/forms-manager/"]},{"label":"CRA","component":"CRA","parameter":"cra","sourceTypeId":157,"myRecordsSearch":false,"searchPlaceholder":"Search by name or registered agent number","allowedRoutes":["/forms-manager/","/forms/","/records/","/queue/","/search/"],"allowEmptySearchTerm":true,"fileAmendmentButtonLabel":"Filing Actions","advancedSearchParameters":[{"type":"radio","name":"QUERY_TYPE_ID","defaultValue":1010,"options":[{"value":1010,"label":"Starts with"},{"value":1011,"label":"Contains"},{"value":1012,"label":" Word Contains"}]},{"type":"dateRange","name":"CRA_DATE","label":"Registration Date","startLabel":"Start Date","todayButton":true,"endLabel":"End Date","width":"30%","defaultValue":{"start":null,"end":null}},{"type":"select","name":"STATUS_ID","label":"Status","defaultValue":0,"options":[{"value":0,"label":"All"},{"value":121,"label":"Active"},{"value":122,"label":"Inactive"}]},{"type":"select","name":"AGENT_TYPE_ID","label":"Agent Type","defaultValue":0,"options":[{"value":0,"label":"All"},{"value":460,"label":"Registered Agent"},{"value":461,"label":"Commercial Registered Agent"}]}]},{"label":"Farm Bill","component":"FarmBill","parameter":"farm-bill","path":"/lists/farm-bill","sourceTypeId":0,"myRecordsSearch":false,"allowedRules":["/search/"],"disabled":true,"searchDescription":"To perform a search, enter a debtor name. Your search results may include: exact debtor name, variations of that name and any filing that includes your search criteria. Punctuation is ignored.\n\nYou can click on \"Advanced\" to refine your search. Under “Advanced” you can search by crop, year, county and SSN/FEIN. As a registered Farm Bill Buyer with the Montana Secretary of State’s office it is important to maintain the confidentiality of the information contained within the Farm Bill Master List. The Farm Bill Master List reflects personal data, such as Social Security Numbers, which are a key piece of personal identifiable information to assist you in determining the existence of a lien against a specific debtor. The distribution of this information beyond its intended purpose is strictly prohibited.\n\nThe debtor's tax identification number has been hidden for confidentiality reasons. You may continue to search on a tax ID number and return debtors that match your search criteria. The SSN/FEIN must be entered without dashes or spaces.","searchMustHaveOneOf":["search","UCC_FARM_PRODUCT_ID","COUNTY"],"searchPlaceholder":"Search by debtor name","advancedSearchParameters":[{"type":"ServerMultiComplete","label":"Product code name(s)","name":"UCC_FARM_PRODUCT_ID","defaultValue":"","optionsSrc":"UCC_FARM_PRODUCT_V"},{"type":"MultiComplete","label":"Year or Range of Years","name":"YEAR_NUM","optionsSrc":"years","startYear":"1968","defaultValue":[],"preMergeOptions":[{"value":"ALL","label":"All"}]},{"type":"serverSelect","label":"State","name":"STATE","defaultValue":"MONTANA","optionsSrc":"STATE"},{"type":"ServerMultiComplete","label":"County","name":"COUNTY","defaultValue":[],"optionsSrc":"COUNTY","overrideSubOptionsSrcFromParameterName":"STATE"},{"type":"checkbox","name":"TIN_SEARCH_YN","defaultValue":false,"label":"Tax Identification Number Search"},{"type":"checkbox","name":"TIN_SORT_YN","defaultValue":false,"label":"Unique ID Sort"}]}],"SYSTEM_NICKNAME":"Online Services Portal","PAYMENT_METHODS":[{"type":"bypass"},{"type":"iTransact"}],"PAYMENT_ALLOW_AMEX":true,"SYSTEM_ID_LABEL":"System Id","DOUBLE_COLUMN_PUBLIC_LOGIN":true,"INTERNAL_USER_MANAGEMENT":true,"ALLOW_PUBLIC_JSON_IMPORT":false,"MAX_FILE_UPLOAD_SIZE":10000000,"REFUND_TEXT":"","RETURN_TO_HOME_ON_LOGOUT":true,"CURRENT_SOS_NAME":"Christi Jacobsen","LOGO_FILENAME":"mt-sos-logo.png","LOGO_ALT":"Christi Jacobsen, Montana Secretary of State","LOGO_FULL_WIDTH":true,"HOME_HIDE_AUTH_HINT":true,"HOME_TITLE":"Montana Secretary of State","CUSTOM_TAB_TITLE":"Official Montana","HOME_SUBTITLE":"Online Business Services","ENTITY_NAME_CONSENT_DESCRIPTION":"","ALLOW_USER_PROFILE_EDITING":true,"COMPARE_FOREIGN_NAME_IN_ENTITY_NAME_VALIDATION":true,"FOREIGN_NAME_FIELD_NAME":"KIMA_PARENT_NAME_INFO","LOGIN_TITLE":"Montana Secretary of State Online Filing Portal Login","PUBLIC_LOGIN_LABEL":"Username","REVERSE_LOGIN_COLUMNS":true,"LOGIN_SEAL_FILENAME":"seal_white.png","SEPARATE_USERNAME_AND_EMAIL":true,"CREATE_ACCOUNT_BUTTON_ALIGN_LEFT":true,"CREATE_ACCOUNT_BUTTON_TEXT":"CREATE AN ACCOUNT","PASSWORD_CUSTOM_ERROR_TEXT":"The password must meet all requirements","ACCOUNT_CREATED_MESSAGE":"Please check your email to verify your account to login and allow a few minutes for this message to arrive. Check your junk/spam folders if you do not find the email in your inbox.","PUBLIC_LOGIN_PLACEHOLDER":" ","DISABLE_DEFAULT_PAYMENT_RADIO":true,"CUSTOM_RESET_PASSWORD_ERROR_MESSAGE":"Username invalid - no account found","PUBLIC_LOGIN_CREATE_DESCRIPTION":"### Existing User:\n\n  - Enter your username and password to login.  \n\n\n  #### - OR -  \n\n\n\n  - Forgot password? Click 'Reset Password' and follow the prompts.\n  - Forgot username? Click 'Forgot Username' and follow the prompts.  \n\n\n  ### New User:\n  ","LOGIN_HELP_LINK":"https://sosmt.gov/business/how-do-i/","LOGIN_HELP_LINK_TEXT":"Need Help?","FORGOT_USERNAME_TEXT":"Forgot Username?","LOGIN_ACTIVE_DIRECTORY_TEXT":"State User Login","MULTIPLE_LOGIN_METHODS":true,"HAS_ACTIVE_DIRECTORY_LOGIN":true,"RESET_PASSWORD_WITH_USERNAME":true,"DOWNLOAD_LINK":true,"SHOW_USERNAME_ACCOUNT_CREATE":true,"SHOW_SCROLL_DOWN_ARROW":true,"SHOW_ADDRESS_ACCOUNT_CREATE":true,"TWO_COLUMN_ACCOUNT_CREATE":true,"RESET_PASSWORD_TIP":"A link to change your password has been sent to your email. Please allow a few minutes for this message to arrive. Please check your junk/spam folders if you do not find the email in your inbox.","FORGOT_PASSWORD_LINK_TEXT":"Reset Password","PHONE_NUMBER_OPTIONAL_ACCOUNT_CREATE":true,"SHOW_REQUIRED_INDICATOR_ACCOUNT_CREATE":true,"PASSWORD_REQUIREMENTS_ACCOUNT_CREATE":"\n    <ul>\n      <li>MUST contain at least 8 characters (12+ recommended)</li>\n      <li>MUST contain at least one uppercase letter.</li>\n      <li>MUST contain at least one lowercase letter.</li>\n      <li>MUST contain at least one number.</li>\n      <li>MUST contain at least one special character (!”#$%&'()*+,-./:;<=>?</li>\n    </ul>\n  ","ALLOW_CERTIFICATION_REQUEST":true,"ALLOW_PUBLIC_CERTIFICATE_REQUEST":true,"ALLOW_COPY_REQUEST":false,"ALLOW_CORRECTION_STYLING":true,"HIDE_DEPRECATION_WARNING":false,"AMEND_ROUTE_PUBLIC":true,"SEAL_FILENAME":"seal.png","SHOPPING_CART":true,"ALLOW_PAYMENT_UPDATE_WITH_EMPTY_CART":true,"RA_EMAIL":true,"RA_WEBSITE":true,"RA_NO_DEFAULT_TYPE":true,"RA_ADDRESS_LABEL":"Street Address","RA_TYPE_SELECTION_DEFAULT":true,"RA_DEFAULT_TYPE":"460","RA_OVERRIDE_TYPE_WITH_DEFAULT":true,"RA_PRINCIPAL_ADDRESS_AMS":true,"UPLOAD_AND_SUBMIT_HIDE_IF_ONE_OPTION":true,"PAYMENT_PROCESSING_MESSAGE":"Your payment is processing - Do not close your browser or click the back button","CHECKOUT_BUTTON_WHEN_PROCESSING_TEXT":"Processing","EFS_CROP_PICKER_NONE_LABEL":"Lien Duration","DISALLOWED_WIZARD_PIECES":["FormationLocale"],"REPEATER_SHOW_EDIT_BUTTON":true,"DATA_REQUEST_PAGE_TITLE":"Data Requests and Subscriptions","DATA_REQUEST_SIDEBAR_LABEL":"Data Requests & Subscriptions","LOGIN_REDIRECTS_TO_EPASS":false,"LOGIN_REDIRECTS_TO_ACTIVE_DIRECTORY":true,"LOGIN_ACTIVE_DIRECTORY_LINK":true,"FETCH_EDIT_USER_LINK":false,"LISTS_FETCH_AVAILABLE_LISTS":true,"POST_WIZARD_SUBMIT_REDIRECT_URL":"/","PIN_REQUEST_ATTESTATIONS":true,"PIN_REQUEST_DESCRIPTION":"Click **Request PIN** to have a new PIN sent to the account holder's email address on file.","OWNERSHIP_REQUEST_DESCRIPTION":"To become an **authorized user** of this record, a current **AUTHORIZED USER** will need to grant you access. To request access, click **Request Access** below.","PIN_REQUEST_SUCCESS_MESSAGE":"The PIN you have requested for this entity has been sent to the email associated with your user account.  You should receive the PIN in approximately 3-5 minutes, depending on your email service provider.","APOSTILLE_HEADER_LABEL":"Verification Information","APOSTILLE_NUMBER_LABEL":"Apostille/Authentication","APOSTILLE_CITY_STATE_OVERRIDE":"HELENA, MT","APOSTILLE_FILING_DATE_LABEL":"Issue Date","APOSTILLE_CITY_STATE_IN_CERTIFIED":true,"NOTARY_EXISTING_FILING":true,"ALLOW_REVOKE_OWN_ACCESS_ONLY":false,"HIDE_CANCEL_ON_ONETIME_DATA_REQUESTS":true,"DATA_REQUESTS_IN_SHOPPING_CART":true,"WQ_ALLOW_EDIT_PENDING_PAYMENT":true,"WQ_CONFIRM_ON_DELETE":true,"WQ_DELETE_CONFIRM_MESSAGE":"Deleting this filing will forfeit any money already paid to the Secretary of State. This action is permanent and cannot be undone, are you sure you would like to delete?","PASS_ITEM_GUIDS_ON_CHECKOUT":true,"FORM_REVISION_HISTORY":true,"CHECKOUT_DISCLAIMER":"By entering your credit card and/or checking account information you (i) state that **you are an authorized user** of the credit card and/or electronic check and that the associated information entered (e.g., account holder name, account number, billing address) is accurate, (ii) **you authorize payment processor to charge the amount you have requested** to your credit card and/or funding account, and (iii) **acknowledge if a charge is declined or reversed you may also be assessed a customary charge** by the payment processor for such transactions.","FARM_BILL_SEARCH_CONFIDENTIAL":"As a registered Farm Bill Buyer with the Montana Secretary of State’s office it is important to maintain the confidentiality of the information contained within the Farm Bill Master List. The Farm Bill Master List reflects personal data, such as Social Security Numbers, which are a key piece of personal identifiable information to assist you in determining the existence of a lien against a specific debtor. The distribution of this information beyond its intended purpose is strictly prohibited.\n\n**The debtor's tax identification number has been hidden for confidentiality reasons. You may continue to search on a tax ID number and return debtors that match your search criteria. The SSN/FEIN must be entered without dashes or spaces.  If you need access to the tax identification number to clearly identify the debtor, please contact the UCC unit at (406) 444-3665.**","VIEW_HISTORY_BUTTON_ALT_TEXT":"View Filings","WIZARD_ERROR_TITLE_MESSAGE":"Form Error","FARM_BILL_SEARCH_INTERACTIVE":true,"USE_FARM_BILL_API":true,"DISALLOW_ASSIGN_SELF_AS_RA":true,"DISALLOW_ASSIGN_SELF_AS_PRINCIPAL":true,"USE_TRADEMARK_OWNER_VALIDATION":true,"USE_ALTERNATIVE_FOREIGN_ADDRESS_LABELS":true,"MY_RECEIPTS_FILTER":[{"type":"dateRange","name":"DATE_RANGE","label":"Date range","defaultValue":{"start":null,"end":null}},{"type":"text","name":"REF_NUM","defaultValue":"","label":"Reference Number"},{"type":"text","name":"RECEIPT_NUM","defaultValue":"","label":"Receipt Id"},{"type":"text","name":"AMOUNT","defaultValue":"","label":"Amount"},{"type":"select","name":"TYPE","defaultValue":"","label":"Payment Type","options":[{"value":"","label":"All"},{"value":"CC","label":"Credit Card"},{"value":"Check","label":"Check"}]}],"MY_RECEIPTS_SHOW_IN_SIDEBAR":true,"SHOW_MY_RECEIPTS_HELPER_TEXT":true,"MY_RECEIPTS_HELPER_LABEL":"About Receipt Search","MY_RECEIPTS_HELPER_TEXT":"You can search for receipts based on their descriptions, including the items paid for on the receipt. Use the filters to search for or filter specific information.","FARM_BILL_SUBLINK":{"label":"Farm Bill","component":"FarmBill","parameter":"farm-bill","path":"/lists/farm-bill","sourceTypeId":0,"myRecordsSearch":false,"allowedRules":["/search/"],"disabled":true,"searchDescription":"To perform a search, enter a debtor name. Your search results may include: exact debtor name, variations of that name and any filing that includes your search criteria. Punctuation is ignored.\n\nYou can click on \"Advanced\" to refine your search. Under “Advanced” you can search by crop, year, county and SSN/FEIN. As a registered Farm Bill Buyer with the Montana Secretary of State’s office it is important to maintain the confidentiality of the information contained within the Farm Bill Master List. The Farm Bill Master List reflects personal data, such as Social Security Numbers, which are a key piece of personal identifiable information to assist you in determining the existence of a lien against a specific debtor. The distribution of this information beyond its intended purpose is strictly prohibited.\n\nThe debtor's tax identification number has been hidden for confidentiality reasons. You may continue to search on a tax ID number and return debtors that match your search criteria. The SSN/FEIN must be entered without dashes or spaces.","searchMustHaveOneOf":["search","UCC_FARM_PRODUCT_ID","COUNTY"],"searchPlaceholder":"Search by debtor name","advancedSearchParameters":[{"type":"ServerMultiComplete","label":"Product code name(s)","name":"UCC_FARM_PRODUCT_ID","defaultValue":"","optionsSrc":"UCC_FARM_PRODUCT_V"},{"type":"MultiComplete","label":"Year or Range of Years","name":"YEAR_NUM","optionsSrc":"years","startYear":"1968","defaultValue":[],"preMergeOptions":[{"value":"ALL","label":"All"}]},{"type":"serverSelect","label":"State","name":"STATE","defaultValue":"MONTANA","optionsSrc":"STATE"},{"type":"ServerMultiComplete","label":"County","name":"COUNTY","defaultValue":[],"optionsSrc":"COUNTY","overrideSubOptionsSrcFromParameterName":"STATE"},{"type":"checkbox","name":"TIN_SEARCH_YN","defaultValue":false,"label":"Tax Identification Number Search"},{"type":"checkbox","name":"TIN_SORT_YN","defaultValue":false,"label":"Unique ID Sort"}]},"ALLOW_ADDRESS_VALIDATION_BYPASS_OPTION":true,"DEFAULT_ADDRESS_VALIDATION_BYPASS_OPTION_CHECKED":true}).DISALLOW_SIGNATURE_DATE_CHANGE ? null : todayButton, onChange: this.bubbleDateToParent, onBlur: _utilities.noop })
	        )
	      );
	    }
	  }]);
	
	  return SignatureRow;
	}(_react.Component);
	
	SignatureRow = (0, _reactRedux.connect)(function (state, props) {
	  var label = props.multiple ? new WizardClasses[props.srcField.fieldClass]().getHumanReadableValue(props.srcField, props.label) : '';
	  if (props.multiple && props.srcField.fieldClass === 'NameQualifiedOrg') {
	    label = new WizardClasses[props.srcField.fieldClass]().getHumanReadableSignatureValue(props.srcField, props.label);
	  }
	  return { label: label };
	})(SignatureRow);

/***/ },
/* 1165 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(7);
	
	var _UploadAccumulator = __webpack_require__(199);
	
	var _UploadAccumulator2 = _interopRequireDefault(_UploadAccumulator);
	
	var _Markdown = __webpack_require__(24);
	
	var _Markdown2 = _interopRequireDefault(_Markdown);
	
	var _Repeater = __webpack_require__(474);
	
	var _Repeater2 = _interopRequireDefault(_Repeater);
	
	var _staticFields = __webpack_require__(479);
	
	__webpack_require__(1476);
	
	var _shortid = __webpack_require__(22);
	
	var _shortid2 = _interopRequireDefault(_shortid);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var UPLOAD_AND_SUBMIT_HIDE_IF_ONE_OPTION = (true) || false;
	var THIRD_PARTY_SIGNING_ALLOWED = (false);
	
	var UploadAndSubmit = function (_Component) {
	  _inherits(UploadAndSubmit, _Component);
	
	  function UploadAndSubmit() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, UploadAndSubmit);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = UploadAndSubmit.__proto__ || Object.getPrototypeOf(UploadAndSubmit)).call.apply(_ref, [this].concat(args))), _this), _this.id = 'id-' + _shortid2.default.generate(), _this.select = function (method, e) {
	      _this.props.onChange(Object.assign({}, _this.props.value, { method: method }), e);
	    }, _this.setFiles = function (files, e) {
	      _this.props.onChange(Object.assign({}, _this.props.value, { files: files }));
	    }, _this.setSigners = function (signers, e) {
	      _this.props.onChange(Object.assign({}, _this.props.value, { signers: signers }));
	    }, _this.getShouldShowTabs = function () {
	      if (UPLOAD_AND_SUBMIT_HIDE_IF_ONE_OPTION && (!_this.props.allowOnline || !_this.props.allowPrint || _this.props.printMailRequired)) {
	        return false;
	      }
	      return true;
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(UploadAndSubmit, [{
	    key: 'renderThirdPartySigners',
	    value: function renderThirdPartySigners(isDisabled, method) {
	      var _this2 = this;
	
	      if (THIRD_PARTY_SIGNING_ALLOWED && this.props.allowSigners && this.props.thirdPartySigningAllowed) {
	        return _react2.default.createElement(Selectable, {
	          parentId: this.id,
	          controls: 'submit-panel-signers',
	          disabled: isDisabled,
	          selected: method === 'signer',
	          onClick: function onClick(e) {
	            _this2.select('signer', e);
	          },
	          title: this.props.signerTabLabel || 'Send for Signatures'
	        });
	      } else {
	        return null;
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this3 = this;
	
	      var _props = this.props,
	          allowMultipleSigners = _props.allowMultipleSigners,
	          allowOnline = _props.allowOnline,
	          allowPrint = _props.allowPrint,
	          canChangeCorrectionEntryType = _props.canChangeCorrectionEntryType,
	          canChangeEntryType = _props.canChangeEntryType,
	          correctionMode = _props.correctionMode,
	          disabled = _props.disabled,
	          errorMessage = _props.errorMessage,
	          fieldId = _props.fieldId,
	          mailInstructions = _props.mailInstructions,
	          onlineInstructions = _props.onlineInstructions,
	          onlineTabLabel = _props.onlineTabLabel,
	          printMailRequired = _props.printMailRequired,
	          printTabLabel = _props.printTabLabel,
	          readOnly = _props.readOnly,
	          signerInstructions = _props.signerInstructions,
	          template = _props.template,
	          value = _props.value;
	
	      var method = printMailRequired ? 'mail' : value.method;
	      var isDisabled = readOnly ? !(canChangeEntryType && !printMailRequired) : correctionMode ? canChangeCorrectionEntryType === false ? true : disabled : disabled;
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'upload-submit', id: this.id },
	        this.getShouldShowTabs() && _react2.default.createElement(
	          'div',
	          { className: 'selectables', role: 'tablist', 'aria-label': 'Filing Options' },
	          allowOnline && !printMailRequired && _react2.default.createElement(Selectable, {
	            parentId: this.id,
	            controls: 'submit-panel-online',
	            disabled: isDisabled || printMailRequired,
	            selected: method === 'online',
	            onClick: function onClick(e) {
	              _this3.select('online', e);
	            },
	            title: onlineTabLabel || 'File Online'
	          }),
	          allowPrint && _react2.default.createElement(Selectable, {
	            parentId: this.id,
	            controls: 'submit-panel-mail',
	            disabled: isDisabled,
	            selected: method === 'mail',
	            onClick: function onClick(e) {
	              _this3.select('mail', e);
	            },
	            title: printTabLabel || 'Print and Mail'
	          }),
	          this.renderThirdPartySigners(isDisabled, method)
	        ),
	        _react2.default.createElement(
	          'div',
	          null,
	          method === 'online' && _react2.default.createElement(OnlinePanel, {
	            disabled: disabled,
	            instructions: onlineInstructions,
	            value: value.files,
	            fieldId: fieldId,
	            errorMessage: errorMessage,
	            onChange: this.setFiles
	          }),
	          method === 'mail' && _react2.default.createElement(MailPanel, { disabled: disabled, instructions: mailInstructions }),
	          method === 'signer' && _react2.default.createElement(SignerPanel, {
	            disabled: disabled,
	            instructions: signerInstructions,
	            value: value.signers,
	            fieldId: fieldId,
	            errorMessage: errorMessage,
	            onChange: this.setFiles,
	            onRepeaterChange: this.setSigners,
	            template: template,
	            allowMultipleSigners: allowMultipleSigners
	          })
	        )
	      );
	    }
	  }]);
	
	  return UploadAndSubmit;
	}(_react.Component);
	
	exports.default = (0, _reactRedux.connect)(function (state) {
	  return {
	    canChangeCorrectionEntryType: state.wizard.canChangeCorrectionEntryType,
	    canChangeEntryType: state.wizard.canChangeEntryType,
	    correctionMode: state.wizard.correctionMode,
	    previewMode: state.wizard.preview,
	    printMailRequired: state.wizard.requirePrintMailMethod.size > 0,
	    readOnly: state.wizard.readOnly,
	    thirdPartySigningAllowed: state.wizard.thirdPartySigningAllowed
	  };
	})(UploadAndSubmit);
	
	var OnlinePanel = function (_Component2) {
	  _inherits(OnlinePanel, _Component2);
	
	  function OnlinePanel() {
	    _classCallCheck(this, OnlinePanel);
	
	    return _possibleConstructorReturn(this, (OnlinePanel.__proto__ || Object.getPrototypeOf(OnlinePanel)).apply(this, arguments));
	  }
	
	  _createClass(OnlinePanel, [{
	    key: 'render',
	    value: function render() {
	      var _props2 = this.props,
	          onChange = _props2.onChange,
	          value = _props2.value,
	          fieldId = _props2.fieldId,
	          errorMessage = _props2.errorMessage,
	          instructions = _props2.instructions,
	          disabled = _props2.disabled;
	
	      return _react2.default.createElement(
	        'div',
	        { id: 'submit-panel-online', className: 'no-outline', tabIndex: '0', role: 'tabpanel', 'aria-labelledby': 'submit-panel-online-tab' },
	        _react2.default.createElement(
	          Panel,
	          null,
	          _react2.default.createElement(_Markdown2.default, { source: instructions, className: 'markdown' }),
	          _react2.default.createElement(_UploadAccumulator2.default, {
	            disabled: disabled,
	            value: value,
	            parent: { type: 'UploadAndSubmit', id: fieldId },
	            errorMessage: errorMessage,
	            fieldId: fieldId,
	            onChange: onChange
	          })
	        )
	      );
	    }
	  }]);
	
	  return OnlinePanel;
	}(_react.Component);
	
	var MailPanel = function (_Component3) {
	  _inherits(MailPanel, _Component3);
	
	  function MailPanel() {
	    _classCallCheck(this, MailPanel);
	
	    return _possibleConstructorReturn(this, (MailPanel.__proto__ || Object.getPrototypeOf(MailPanel)).apply(this, arguments));
	  }
	
	  _createClass(MailPanel, [{
	    key: 'render',
	    value: function render() {
	      var _props3 = this.props,
	          instructions = _props3.instructions,
	          disabled = _props3.disabled;
	
	      return _react2.default.createElement(
	        'div',
	        { id: 'submit-panel-mail', className: 'no-outline', tabIndex: '0', role: 'tabpanel', 'aria-labelledby': 'submit-panel-mail-tab' },
	        _react2.default.createElement(
	          Panel,
	          null,
	          _react2.default.createElement(_Markdown2.default, { source: instructions, className: 'markdown' }),
	          _react2.default.createElement(_UploadAccumulator2.default, { disabled: disabled, viewOnly: true })
	        )
	      );
	    }
	  }]);
	
	  return MailPanel;
	}(_react.Component);
	
	var SignerPanel = function (_Component4) {
	  _inherits(SignerPanel, _Component4);
	
	  function SignerPanel() {
	    _classCallCheck(this, SignerPanel);
	
	    return _possibleConstructorReturn(this, (SignerPanel.__proto__ || Object.getPrototypeOf(SignerPanel)).apply(this, arguments));
	  }
	
	  _createClass(SignerPanel, [{
	    key: 'render',
	    value: function render() {
	      var _props4 = this.props,
	          allowMultipleSigners = _props4.allowMultipleSigners,
	          disabled = _props4.disabled,
	          errorMessage = _props4.errorMessage,
	          fieldId = _props4.fieldId,
	          instructions = _props4.instructions,
	          onChange = _props4.onChange,
	          onRepeaterChange = _props4.onRepeaterChange,
	          template = _props4.template,
	          _props4$value = _props4.value,
	          value = _props4$value === undefined ? [] : _props4$value;
	
	      return _react2.default.createElement(
	        'div',
	        { id: 'submit-panel-signers', className: 'no-outline', tabIndex: '0', role: 'tabpanel', 'aria-labelledby': 'submit-panel-signers-tab' },
	        _react2.default.createElement(
	          Panel,
	          null,
	          _react2.default.createElement(_Markdown2.default, { source: instructions, className: 'markdown' }),
	          _react2.default.createElement(_UploadAccumulator2.default, {
	            disabled: disabled,
	            value: value,
	            parent: { type: 'UploadAndSubmit', id: fieldId },
	            errorMessage: errorMessage,
	            fieldId: fieldId,
	            onChange: onChange
	          }),
	          _react2.default.createElement(
	            'div',
	            { className: 'repeater-wrapper' },
	            _react2.default.createElement(_Repeater2.default, {
	              template: [_staticFields.STATIC_FIELD_IDS.SIGNER_NAME, _staticFields.STATIC_FIELD_IDS.SIGNER_EMAIL].concat(_toConsumableArray(template)),
	              value: value,
	              onChange: onRepeaterChange,
	              addButtonLabel: 'Add Signer',
	              emptyRepeaterLabel: 'No signers have been added',
	              maxRepeaterRows: allowMultipleSigners ? undefined : 1
	            })
	          )
	        )
	      );
	    }
	  }]);
	
	  return SignerPanel;
	}(_react.Component);
	
	var Selectable = function (_Component5) {
	  _inherits(Selectable, _Component5);
	
	  function Selectable() {
	    var _ref2;
	
	    var _temp2, _this7, _ret2;
	
	    _classCallCheck(this, Selectable);
	
	    for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
	      args[_key2] = arguments[_key2];
	    }
	
	    return _ret2 = (_temp2 = (_this7 = _possibleConstructorReturn(this, (_ref2 = Selectable.__proto__ || Object.getPrototypeOf(Selectable)).call.apply(_ref2, [this].concat(args))), _this7), _this7.getTabs = function () {
	      return Array.from(document.querySelectorAll('#' + _this7.props.parentId + ' .selectable'));
	    }, _this7.keydownEventListener = function (event) {
	      var key = event.keyCode;
	      switch (key) {
	        case 35:
	          event.preventDefault();
	          _this7.focusLastTab();
	          break;
	        case 36:
	          event.preventDefault();
	          _this7.focusFirstTab();
	          break;
	        //up and down are handled to prevent page scroll
	        case 38:
	        case 40:
	          _this7.switchTabOnArrowPress(event);
	      }
	    }, _this7.keyupEventListener = function (event) {
	      var key = event.keyCode;
	      switch (key) {
	        case 37:
	        case 39:
	          _this7.switchTabOnArrowPress(event);
	          break;
	        case 13:
	        case 32:
	          _this7.activateTab(event.target);
	          break;
	      }
	    }, _this7.switchTabOnArrowPress = function (event) {
	      var tabs = _this7.getTabs();
	      var direction = {
	        37: -1,
	        39: 1
	      }[event.keyCode];
	      var pressed = event.keyCode;
	      if (direction) {
	        var currentTabIndex = tabs.findIndex(function (tab) {
	          return _this7.tab === tab;
	        });
	        var targetTab = tabs[currentTabIndex + direction];
	        if (targetTab) {
	          targetTab.focus();
	        } else if (pressed === 37) {
	          _this7.focusLastTab();
	        } else if (pressed === 39) {
	          _this7.focusFirstTab();
	        }
	      }
	    }, _this7.activateTab = function (tab, setFocus) {
	      setFocus = setFocus || true;
	      _this7.deactivateTabs();
	      tab.removeAttribute('tabindex');
	      tab.setAttribute('aria-selected', 'true');
	      if (setFocus) {
	        tab.focus();
	      }
	    }, _this7.deactivateTabs = function () {
	      var tabs = _this7.getTabs();
	      for (var t = 0; t < tabs.length; t++) {
	        tabs[t].setAttribute('tabindex', '-1');
	        tabs[t].setAttribute('aria-selected', 'false');
	      }
	    }, _this7.focusFirstTab = function () {
	      var tabs = _this7.getTabs();
	      tabs[0].focus();
	    }, _this7.focusLastTab = function () {
	      var tabs = _this7.getTabs();
	      tabs[tabs.length - 1].focus();
	    }, _temp2), _possibleConstructorReturn(_this7, _ret2);
	  }
	
	  _createClass(Selectable, [{
	    key: 'render',
	    value: function render() {
	      var _this8 = this;
	
	      var _props5 = this.props,
	          title = _props5.title,
	          selected = _props5.selected,
	          onClick = _props5.onClick,
	          disabled = _props5.disabled,
	          controls = _props5.controls;
	
	      return _react2.default.createElement(
	        'button',
	        {
	          ref: function ref(_ref3) {
	            return _this8.tab = _ref3;
	          },
	          disabled: disabled,
	          tabIndex: selected ? 0 : -1,
	          className: 'selectable ' + (selected ? 'selected' : '') + ' ' + (disabled ? 'disabled' : ''),
	          onClick: onClick,
	          'aria-selected': selected,
	          'aria-controls': controls,
	          role: 'tab',
	          id: controls + '-tab',
	          onKeyDown: this.keydownEventListener,
	          onKeyUp: this.keyupEventListener
	        },
	        _react2.default.createElement('div', { className: 'radio' }),
	        _react2.default.createElement(
	          'span',
	          { className: 'title' },
	          title
	        )
	      );
	    }
	  }]);
	
	  return Selectable;
	}(_react.Component);
	
	var Panel = function (_Component6) {
	  _inherits(Panel, _Component6);
	
	  function Panel() {
	    _classCallCheck(this, Panel);
	
	    return _possibleConstructorReturn(this, (Panel.__proto__ || Object.getPrototypeOf(Panel)).apply(this, arguments));
	  }
	
	  _createClass(Panel, [{
	    key: 'render',
	    value: function render() {
	      var _props6 = this.props,
	          children = _props6.children,
	          id = _props6.id;
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'panel', id: id },
	        children
	      );
	    }
	  }]);
	
	  return Panel;
	}(_react.Component);

/***/ },
/* 1166 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var MASKS = {
	  phone: {
	    name: "Phone number",
	    fn: "phone",
	    props: {}
	  },
	  onlyLetters: {
	    name: "Letter characters only",
	    fn: "onlyLetters",
	    props: {
	      allowedSpecialCharacters: { type: "text", value: '', label: "Allowed Special Characters" }
	    }
	  },
	  onlyNumbers: {
	    name: "Numeric characters only",
	    fn: "onlyNumbers",
	    props: {
	      commas: { type: "checkbox", value: false, label: "Separate numbers with commas" },
	      leadingZerosAllowed: { type: "checkbox", value: true, label: "Allow leading zeros" },
	      allowDecimal: { type: "checkbox", value: false, label: "Allow a decimal" }
	    }
	  },
	  fein: {
	    name: "Federal employer identification number",
	    fn: "fein",
	    props: {}
	  },
	  currency: {
	    name: "American currency",
	    fn: 'currency',
	    props: {
	      commas: { type: "checkbox", value: true, label: "Separate numbers with commas" }
	    }
	  },
	  maxStringLength: {
	    name: "Character Limit",
	    fn: 'maxStringLength',
	    props: {
	      max: { type: "text", value: 100, label: "Max number of characters allowed" }
	    }
	  },
	  onlyAscii: {
	    name: "Only allow ASCII characters 32 through 126",
	    fn: 'onlyAscii',
	    props: {}
	  },
	  zipCode: {
	    name: "ZIP code",
	    fn: 'zipCode',
	    props: {}
	  },
	  addressZipCode: {
	    name: "Address ZIP code",
	    fn: 'addressZipCode',
	    props: {}
	  },
	  social: {
	    name: "Social Security Number",
	    fn: 'social',
	    props: {}
	  },
	  allUpperCase: {
	    name: "Force uppercase text",
	    fn: 'allUpperCase',
	    props: {}
	  },
	  addressUpperCase: {
	    name: "Address force uppercase text",
	    fn: 'addressUpperCase',
	    props: {}
	  },
	  onlyAsciiConfirmFields: {
	    name: 'Only allow ASCII characters 32 through 126',
	    fn: 'onlyAsciiConfirmFields',
	    props: {}
	  },
	  time: {
	    name: '12-hour Time',
	    fn: 'time',
	    props: {}
	  }
	};
	exports.default = MASKS;

/***/ },
/* 1167 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	__webpack_require__(341);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(70);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _Routes = __webpack_require__(1046);
	
	var _Routes2 = _interopRequireDefault(_Routes);
	
	var _store = __webpack_require__(18);
	
	var _store2 = _interopRequireDefault(_store);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	_reactDom2.default.render(_react2.default.createElement(_Routes2.default, null), document.getElementById('root'));
	
	exports.default = _store2.default;

/***/ },
/* 1168 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.RadioGroup = exports.Radio = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _propTypes = __webpack_require__(20);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Radio = exports.Radio = function (_React$Component) {
	  _inherits(Radio, _React$Component);
	
	  function Radio() {
	    _classCallCheck(this, Radio);
	
	    return _possibleConstructorReturn(this, (Radio.__proto__ || Object.getPrototypeOf(Radio)).apply(this, arguments));
	  }
	
	  _createClass(Radio, [{
	    key: 'render',
	    value: function render() {
	      var _context$radioGroup = this.context.radioGroup,
	          name = _context$radioGroup.name,
	          selectedValue = _context$radioGroup.selectedValue,
	          onChange = _context$radioGroup.onChange;
	
	      var _props = this.props,
	          innerRef = _props.innerRef,
	          props = _objectWithoutProperties(_props, ['innerRef']);
	
	      var optional = {};
	      if (selectedValue !== undefined) {
	        optional.checked = this.props.value === selectedValue;
	      }
	      if (typeof onChange === 'function') {
	        optional.onChange = onChange.bind(null, this.props.value);
	      }
	      if (typeof innerRef === 'function') {
	        optional.ref = innerRef;
	      }
	      return _react2.default.createElement('input', Object.assign({}, props, {
	        type: 'radio',
	        name: name
	      }, optional));
	    }
	  }]);
	
	  return Radio;
	}(_react2.default.Component);
	
	;
	
	Radio.contextTypes = {
	  radioGroup: _propTypes2.default.object
	};
	
	var RadioGroup = exports.RadioGroup = function (_React$Component2) {
	  _inherits(RadioGroup, _React$Component2);
	
	  function RadioGroup() {
	    _classCallCheck(this, RadioGroup);
	
	    return _possibleConstructorReturn(this, (RadioGroup.__proto__ || Object.getPrototypeOf(RadioGroup)).apply(this, arguments));
	  }
	
	  _createClass(RadioGroup, [{
	    key: 'getChildContext',
	    value: function getChildContext() {
	      var _props2 = this.props,
	          name = _props2.name,
	          selectedValue = _props2.selectedValue,
	          onChange = _props2.onChange;
	
	      return {
	        radioGroup: {
	          name: name, selectedValue: selectedValue, onChange: onChange
	        }
	      };
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props3 = this.props,
	          Component = _props3.Component,
	          name = _props3.name,
	          selectedValue = _props3.selectedValue,
	          onChange = _props3.onChange,
	          children = _props3.children,
	          rest = _objectWithoutProperties(_props3, ['Component', 'name', 'selectedValue', 'onChange', 'children']);
	
	      return _react2.default.createElement(
	        Component,
	        rest,
	        children
	      );
	    }
	  }]);
	
	  return RadioGroup;
	}(_react2.default.Component);
	
	;
	
	RadioGroup.defaultProps = {
	  Component: "div"
	};
	
	RadioGroup.propTypes = {
	  name: _propTypes2.default.string,
	  selectedValue: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number, _propTypes2.default.bool]),
	  onChange: _propTypes2.default.func,
	  children: _propTypes2.default.node.isRequired,
	  Component: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.func, _propTypes2.default.object])
	};
	
	RadioGroup.childContextTypes = {
	  radioGroup: _propTypes2.default.object
	};

/***/ },
/* 1169 */
/***/ function(module, exports, __webpack_require__) {

	'use strict'
	
	var alphabetical = __webpack_require__(480)
	var decimal = __webpack_require__(200)
	
	module.exports = alphanumerical
	
	// Check if the given character code, or the character code at the first
	// character, is alphanumerical.
	function alphanumerical(character) {
	  return alphabetical(character) || decimal(character)
	}


/***/ },
/* 1170 */
/***/ function(module, exports) {

	'use strict';
	
	var hasToStringTag = typeof Symbol === 'function' && typeof Symbol.toStringTag === 'symbol';
	var toStr = Object.prototype.toString;
	
	var isStandardArguments = function isArguments(value) {
		if (hasToStringTag && value && typeof value === 'object' && Symbol.toStringTag in value) {
			return false;
		}
		return toStr.call(value) === '[object Arguments]';
	};
	
	var isLegacyArguments = function isArguments(value) {
		if (isStandardArguments(value)) {
			return true;
		}
		return value !== null &&
			typeof value === 'object' &&
			typeof value.length === 'number' &&
			value.length >= 0 &&
			toStr.call(value) !== '[object Array]' &&
			toStr.call(value.callee) === '[object Function]';
	};
	
	var supportsStandardArguments = (function () {
		return isStandardArguments(arguments);
	}());
	
	isStandardArguments.isLegacyArguments = isLegacyArguments; // for tests
	
	module.exports = supportsStandardArguments ? isStandardArguments : isLegacyArguments;


/***/ },
/* 1171 */
/***/ function(module, exports) {

	/*!
	 * Determine if an object is a Buffer
	 *
	 * @author   Feross Aboukhadijeh <https://feross.org>
	 * @license  MIT
	 */
	
	// The _isBuffer check is for Safari 5-7 support, because it's missing
	// Object.prototype.constructor. Remove this eventually
	module.exports = function (obj) {
	  return obj != null && (isBuffer(obj) || isSlowBuffer(obj) || !!obj._isBuffer)
	}
	
	function isBuffer (obj) {
	  return !!obj.constructor && typeof obj.constructor.isBuffer === 'function' && obj.constructor.isBuffer(obj)
	}
	
	// For Node v0.10 support. Remove this eventually.
	function isSlowBuffer (obj) {
	  return typeof obj.readFloatLE === 'function' && typeof obj.slice === 'function' && isBuffer(obj.slice(0, 0))
	}


/***/ },
/* 1172 */
/***/ function(module, exports) {

	'use strict';
	
	var getDay = Date.prototype.getDay;
	var tryDateObject = function tryDateGetDayCall(value) {
		try {
			getDay.call(value);
			return true;
		} catch (e) {
			return false;
		}
	};
	
	var toStr = Object.prototype.toString;
	var dateClass = '[object Date]';
	var hasToStringTag = typeof Symbol === 'function' && typeof Symbol.toStringTag === 'symbol';
	
	module.exports = function isDateObject(value) {
		if (typeof value !== 'object' || value === null) {
			return false;
		}
		return hasToStringTag ? tryDateObject(value) : toStr.call(value) === dateClass;
	};


/***/ },
/* 1173 */
/***/ function(module, exports) {

	'use strict'
	
	module.exports = hexadecimal
	
	// Check if the given character code, or the character code at the first
	// character, is hexadecimal.
	function hexadecimal(character) {
	  var code = typeof character === 'string' ? character.charCodeAt(0) : character
	
	  return (
	    (code >= 97 /* a */ && code <= 102) /* z */ ||
	    (code >= 65 /* A */ && code <= 70) /* Z */ ||
	    (code >= 48 /* A */ && code <= 57) /* Z */
	  )
	}


/***/ },
/* 1174 */
/***/ function(module, exports) {

	'use strict';
	var toString = Object.prototype.toString;
	
	module.exports = function (x) {
		var prototype;
		return toString.call(x) === '[object Object]' && (prototype = Object.getPrototypeOf(x), prototype === null || prototype === Object.getPrototypeOf({}));
	};


/***/ },
/* 1175 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var has = __webpack_require__(1042);
	var regexExec = RegExp.prototype.exec;
	var gOPD = Object.getOwnPropertyDescriptor;
	
	var tryRegexExecCall = function tryRegexExec(value) {
		try {
			var lastIndex = value.lastIndex;
			value.lastIndex = 0; // eslint-disable-line no-param-reassign
	
			regexExec.call(value);
			return true;
		} catch (e) {
			return false;
		} finally {
			value.lastIndex = lastIndex; // eslint-disable-line no-param-reassign
		}
	};
	var toStr = Object.prototype.toString;
	var regexClass = '[object RegExp]';
	var hasToStringTag = typeof Symbol === 'function' && typeof Symbol.toStringTag === 'symbol';
	
	module.exports = function isRegex(value) {
		if (!value || typeof value !== 'object') {
			return false;
		}
		if (!hasToStringTag) {
			return toStr.call(value) === regexClass;
		}
	
		var descriptor = gOPD(value, 'lastIndex');
		var hasLastIndexDataProperty = descriptor && has(descriptor, 'value');
		if (!hasLastIndexDataProperty) {
			return false;
		}
	
		return tryRegexExecCall(value);
	};


/***/ },
/* 1176 */
/***/ function(module, exports) {

	'use strict'
	
	module.exports = wordCharacter
	
	var fromCode = String.fromCharCode
	var re = /\w/
	
	// Check if the given character code, or the character code at the first
	// character, is a word character.
	function wordCharacter(character) {
	  return re.test(
	    typeof character === 'number' ? fromCode(character) : character.charAt(0)
	  )
	}


/***/ },
/* 1177 */
/***/ function(module, exports) {

	module.exports = {
		"AElig": "Æ",
		"AMP": "&",
		"Aacute": "Á",
		"Acirc": "Â",
		"Agrave": "À",
		"Aring": "Å",
		"Atilde": "Ã",
		"Auml": "Ä",
		"COPY": "©",
		"Ccedil": "Ç",
		"ETH": "Ð",
		"Eacute": "É",
		"Ecirc": "Ê",
		"Egrave": "È",
		"Euml": "Ë",
		"GT": ">",
		"Iacute": "Í",
		"Icirc": "Î",
		"Igrave": "Ì",
		"Iuml": "Ï",
		"LT": "<",
		"Ntilde": "Ñ",
		"Oacute": "Ó",
		"Ocirc": "Ô",
		"Ograve": "Ò",
		"Oslash": "Ø",
		"Otilde": "Õ",
		"Ouml": "Ö",
		"QUOT": "\"",
		"REG": "®",
		"THORN": "Þ",
		"Uacute": "Ú",
		"Ucirc": "Û",
		"Ugrave": "Ù",
		"Uuml": "Ü",
		"Yacute": "Ý",
		"aacute": "á",
		"acirc": "â",
		"acute": "´",
		"aelig": "æ",
		"agrave": "à",
		"amp": "&",
		"aring": "å",
		"atilde": "ã",
		"auml": "ä",
		"brvbar": "¦",
		"ccedil": "ç",
		"cedil": "¸",
		"cent": "¢",
		"copy": "©",
		"curren": "¤",
		"deg": "°",
		"divide": "÷",
		"eacute": "é",
		"ecirc": "ê",
		"egrave": "è",
		"eth": "ð",
		"euml": "ë",
		"frac12": "½",
		"frac14": "¼",
		"frac34": "¾",
		"gt": ">",
		"iacute": "í",
		"icirc": "î",
		"iexcl": "¡",
		"igrave": "ì",
		"iquest": "¿",
		"iuml": "ï",
		"laquo": "«",
		"lt": "<",
		"macr": "¯",
		"micro": "µ",
		"middot": "·",
		"nbsp": " ",
		"not": "¬",
		"ntilde": "ñ",
		"oacute": "ó",
		"ocirc": "ô",
		"ograve": "ò",
		"ordf": "ª",
		"ordm": "º",
		"oslash": "ø",
		"otilde": "õ",
		"ouml": "ö",
		"para": "¶",
		"plusmn": "±",
		"pound": "£",
		"quot": "\"",
		"raquo": "»",
		"reg": "®",
		"sect": "§",
		"shy": "­",
		"sup1": "¹",
		"sup2": "²",
		"sup3": "³",
		"szlig": "ß",
		"thorn": "þ",
		"times": "×",
		"uacute": "ú",
		"ucirc": "û",
		"ugrave": "ù",
		"uml": "¨",
		"uuml": "ü",
		"yacute": "ý",
		"yen": "¥",
		"yuml": "ÿ"
	};

/***/ },
/* 1178 */
/***/ function(module, exports) {

	module.exports = {
		"0": "�",
		"128": "€",
		"130": "‚",
		"131": "ƒ",
		"132": "„",
		"133": "…",
		"134": "†",
		"135": "‡",
		"136": "ˆ",
		"137": "‰",
		"138": "Š",
		"139": "‹",
		"140": "Œ",
		"142": "Ž",
		"145": "‘",
		"146": "’",
		"147": "“",
		"148": "”",
		"149": "•",
		"150": "–",
		"151": "—",
		"152": "˜",
		"153": "™",
		"154": "š",
		"155": "›",
		"156": "œ",
		"158": "ž",
		"159": "Ÿ"
	};

/***/ },
/* 1179 */
/***/ function(module, exports) {

	module.exports = [
		"address",
		"article",
		"aside",
		"base",
		"basefont",
		"blockquote",
		"body",
		"caption",
		"center",
		"col",
		"colgroup",
		"dd",
		"details",
		"dialog",
		"dir",
		"div",
		"dl",
		"dt",
		"fieldset",
		"figcaption",
		"figure",
		"footer",
		"form",
		"frame",
		"frameset",
		"h1",
		"h2",
		"h3",
		"h4",
		"h5",
		"h6",
		"head",
		"header",
		"hgroup",
		"hr",
		"html",
		"iframe",
		"legend",
		"li",
		"link",
		"main",
		"menu",
		"menuitem",
		"meta",
		"nav",
		"noframes",
		"ol",
		"optgroup",
		"option",
		"p",
		"param",
		"pre",
		"section",
		"source",
		"title",
		"summary",
		"table",
		"tbody",
		"td",
		"tfoot",
		"th",
		"thead",
		"title",
		"tr",
		"track",
		"ul"
	];

/***/ },
/* 1180 */
/***/ function(module, exports) {

	'use strict';
	
	var ms = {};
	
	function getItem (key) {
	  return key in ms ? ms[key] : null;
	}
	
	function setItem (key, value) {
	  ms[key] = value;
	  return true;
	}
	
	function removeItem (key) {
	  var found = key in ms;
	  if (found) {
	    return delete ms[key];
	  }
	  return false;
	}
	
	function clear () {
	  ms = {};
	  return true;
	}
	
	module.exports = {
	  getItem: getItem,
	  setItem: setItem,
	  removeItem: removeItem,
	  clear: clear
	};


/***/ },
/* 1181 */
/***/ function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {'use strict';
	
	var listeners = {};
	var listening = false;
	
	function listen () {
	  if (global.addEventListener) {
	    global.addEventListener('storage', change, false);
	  } else if (global.attachEvent) {
	    global.attachEvent('onstorage', change);
	  } else {
	    global.onstorage = change;
	  }
	}
	
	function change (e) {
	  if (!e) {
	    e = global.event;
	  }
	  var all = listeners[e.key];
	  if (all) {
	    all.forEach(fire);
	  }
	
	  function fire (listener) {
	    listener(JSON.parse(e.newValue), JSON.parse(e.oldValue), e.url || e.uri);
	  }
	}
	
	function on (key, fn) {
	  if (listeners[key]) {
	    listeners[key].push(fn);
	  } else {
	    listeners[key] = [fn];
	  }
	  if (listening === false) {
	    listen();
	  }
	}
	
	function off (key, fn) {
	  var ns = listeners[key];
	  if (ns.length > 1) {
	    ns.splice(ns.indexOf(fn), 1);
	  } else {
	    listeners[key] = [];
	  }
	}
	
	module.exports = {
	  on: on,
	  off: off
	};
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 1182 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global, module) {/**
	 * lodash (Custom Build) <https://lodash.com/>
	 * Build: `lodash modularize exports="npm" -o ./`
	 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
	 * Released under MIT license <https://lodash.com/license>
	 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
	 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
	 */
	
	/** Used as the size to enable large array optimizations. */
	var LARGE_ARRAY_SIZE = 200;
	
	/** Used to stand-in for `undefined` hash values. */
	var HASH_UNDEFINED = '__lodash_hash_undefined__';
	
	/** Used to compose bitmasks for comparison styles. */
	var UNORDERED_COMPARE_FLAG = 1,
	    PARTIAL_COMPARE_FLAG = 2;
	
	/** Used as references for various `Number` constants. */
	var MAX_SAFE_INTEGER = 9007199254740991;
	
	/** `Object#toString` result references. */
	var argsTag = '[object Arguments]',
	    arrayTag = '[object Array]',
	    boolTag = '[object Boolean]',
	    dateTag = '[object Date]',
	    errorTag = '[object Error]',
	    funcTag = '[object Function]',
	    genTag = '[object GeneratorFunction]',
	    mapTag = '[object Map]',
	    numberTag = '[object Number]',
	    objectTag = '[object Object]',
	    promiseTag = '[object Promise]',
	    regexpTag = '[object RegExp]',
	    setTag = '[object Set]',
	    stringTag = '[object String]',
	    symbolTag = '[object Symbol]',
	    weakMapTag = '[object WeakMap]';
	
	var arrayBufferTag = '[object ArrayBuffer]',
	    dataViewTag = '[object DataView]',
	    float32Tag = '[object Float32Array]',
	    float64Tag = '[object Float64Array]',
	    int8Tag = '[object Int8Array]',
	    int16Tag = '[object Int16Array]',
	    int32Tag = '[object Int32Array]',
	    uint8Tag = '[object Uint8Array]',
	    uint8ClampedTag = '[object Uint8ClampedArray]',
	    uint16Tag = '[object Uint16Array]',
	    uint32Tag = '[object Uint32Array]';
	
	/**
	 * Used to match `RegExp`
	 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
	 */
	var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
	
	/** Used to detect host constructors (Safari). */
	var reIsHostCtor = /^\[object .+?Constructor\]$/;
	
	/** Used to detect unsigned integer values. */
	var reIsUint = /^(?:0|[1-9]\d*)$/;
	
	/** Used to identify `toStringTag` values of typed arrays. */
	var typedArrayTags = {};
	typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
	typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
	typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
	typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
	typedArrayTags[uint32Tag] = true;
	typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
	typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
	typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
	typedArrayTags[errorTag] = typedArrayTags[funcTag] =
	typedArrayTags[mapTag] = typedArrayTags[numberTag] =
	typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
	typedArrayTags[setTag] = typedArrayTags[stringTag] =
	typedArrayTags[weakMapTag] = false;
	
	/** Detect free variable `global` from Node.js. */
	var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;
	
	/** Detect free variable `self`. */
	var freeSelf = typeof self == 'object' && self && self.Object === Object && self;
	
	/** Used as a reference to the global object. */
	var root = freeGlobal || freeSelf || Function('return this')();
	
	/** Detect free variable `exports`. */
	var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;
	
	/** Detect free variable `module`. */
	var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;
	
	/** Detect the popular CommonJS extension `module.exports`. */
	var moduleExports = freeModule && freeModule.exports === freeExports;
	
	/** Detect free variable `process` from Node.js. */
	var freeProcess = moduleExports && freeGlobal.process;
	
	/** Used to access faster Node.js helpers. */
	var nodeUtil = (function() {
	  try {
	    return freeProcess && freeProcess.binding('util');
	  } catch (e) {}
	}());
	
	/* Node.js helper references. */
	var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;
	
	/**
	 * A specialized version of `_.some` for arrays without support for iteratee
	 * shorthands.
	 *
	 * @private
	 * @param {Array} [array] The array to iterate over.
	 * @param {Function} predicate The function invoked per iteration.
	 * @returns {boolean} Returns `true` if any element passes the predicate check,
	 *  else `false`.
	 */
	function arraySome(array, predicate) {
	  var index = -1,
	      length = array ? array.length : 0;
	
	  while (++index < length) {
	    if (predicate(array[index], index, array)) {
	      return true;
	    }
	  }
	  return false;
	}
	
	/**
	 * The base implementation of `_.times` without support for iteratee shorthands
	 * or max array length checks.
	 *
	 * @private
	 * @param {number} n The number of times to invoke `iteratee`.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Array} Returns the array of results.
	 */
	function baseTimes(n, iteratee) {
	  var index = -1,
	      result = Array(n);
	
	  while (++index < n) {
	    result[index] = iteratee(index);
	  }
	  return result;
	}
	
	/**
	 * The base implementation of `_.unary` without support for storing metadata.
	 *
	 * @private
	 * @param {Function} func The function to cap arguments for.
	 * @returns {Function} Returns the new capped function.
	 */
	function baseUnary(func) {
	  return function(value) {
	    return func(value);
	  };
	}
	
	/**
	 * Gets the value at `key` of `object`.
	 *
	 * @private
	 * @param {Object} [object] The object to query.
	 * @param {string} key The key of the property to get.
	 * @returns {*} Returns the property value.
	 */
	function getValue(object, key) {
	  return object == null ? undefined : object[key];
	}
	
	/**
	 * Checks if `value` is a host object in IE < 9.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a host object, else `false`.
	 */
	function isHostObject(value) {
	  // Many host objects are `Object` objects that can coerce to strings
	  // despite having improperly defined `toString` methods.
	  var result = false;
	  if (value != null && typeof value.toString != 'function') {
	    try {
	      result = !!(value + '');
	    } catch (e) {}
	  }
	  return result;
	}
	
	/**
	 * Converts `map` to its key-value pairs.
	 *
	 * @private
	 * @param {Object} map The map to convert.
	 * @returns {Array} Returns the key-value pairs.
	 */
	function mapToArray(map) {
	  var index = -1,
	      result = Array(map.size);
	
	  map.forEach(function(value, key) {
	    result[++index] = [key, value];
	  });
	  return result;
	}
	
	/**
	 * Creates a unary function that invokes `func` with its argument transformed.
	 *
	 * @private
	 * @param {Function} func The function to wrap.
	 * @param {Function} transform The argument transform.
	 * @returns {Function} Returns the new function.
	 */
	function overArg(func, transform) {
	  return function(arg) {
	    return func(transform(arg));
	  };
	}
	
	/**
	 * Converts `set` to an array of its values.
	 *
	 * @private
	 * @param {Object} set The set to convert.
	 * @returns {Array} Returns the values.
	 */
	function setToArray(set) {
	  var index = -1,
	      result = Array(set.size);
	
	  set.forEach(function(value) {
	    result[++index] = value;
	  });
	  return result;
	}
	
	/** Used for built-in method references. */
	var arrayProto = Array.prototype,
	    funcProto = Function.prototype,
	    objectProto = Object.prototype;
	
	/** Used to detect overreaching core-js shims. */
	var coreJsData = root['__core-js_shared__'];
	
	/** Used to detect methods masquerading as native. */
	var maskSrcKey = (function() {
	  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
	  return uid ? ('Symbol(src)_1.' + uid) : '';
	}());
	
	/** Used to resolve the decompiled source of functions. */
	var funcToString = funcProto.toString;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var objectToString = objectProto.toString;
	
	/** Used to detect if a method is native. */
	var reIsNative = RegExp('^' +
	  funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
	  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
	);
	
	/** Built-in value references. */
	var Symbol = root.Symbol,
	    Uint8Array = root.Uint8Array,
	    propertyIsEnumerable = objectProto.propertyIsEnumerable,
	    splice = arrayProto.splice;
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeKeys = overArg(Object.keys, Object);
	
	/* Built-in method references that are verified to be native. */
	var DataView = getNative(root, 'DataView'),
	    Map = getNative(root, 'Map'),
	    Promise = getNative(root, 'Promise'),
	    Set = getNative(root, 'Set'),
	    WeakMap = getNative(root, 'WeakMap'),
	    nativeCreate = getNative(Object, 'create');
	
	/** Used to detect maps, sets, and weakmaps. */
	var dataViewCtorString = toSource(DataView),
	    mapCtorString = toSource(Map),
	    promiseCtorString = toSource(Promise),
	    setCtorString = toSource(Set),
	    weakMapCtorString = toSource(WeakMap);
	
	/** Used to convert symbols to primitives and strings. */
	var symbolProto = Symbol ? Symbol.prototype : undefined,
	    symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;
	
	/**
	 * Creates a hash object.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function Hash(entries) {
	  var index = -1,
	      length = entries ? entries.length : 0;
	
	  this.clear();
	  while (++index < length) {
	    var entry = entries[index];
	    this.set(entry[0], entry[1]);
	  }
	}
	
	/**
	 * Removes all key-value entries from the hash.
	 *
	 * @private
	 * @name clear
	 * @memberOf Hash
	 */
	function hashClear() {
	  this.__data__ = nativeCreate ? nativeCreate(null) : {};
	}
	
	/**
	 * Removes `key` and its value from the hash.
	 *
	 * @private
	 * @name delete
	 * @memberOf Hash
	 * @param {Object} hash The hash to modify.
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function hashDelete(key) {
	  return this.has(key) && delete this.__data__[key];
	}
	
	/**
	 * Gets the hash value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf Hash
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function hashGet(key) {
	  var data = this.__data__;
	  if (nativeCreate) {
	    var result = data[key];
	    return result === HASH_UNDEFINED ? undefined : result;
	  }
	  return hasOwnProperty.call(data, key) ? data[key] : undefined;
	}
	
	/**
	 * Checks if a hash value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf Hash
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function hashHas(key) {
	  var data = this.__data__;
	  return nativeCreate ? data[key] !== undefined : hasOwnProperty.call(data, key);
	}
	
	/**
	 * Sets the hash `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf Hash
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the hash instance.
	 */
	function hashSet(key, value) {
	  var data = this.__data__;
	  data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
	  return this;
	}
	
	// Add methods to `Hash`.
	Hash.prototype.clear = hashClear;
	Hash.prototype['delete'] = hashDelete;
	Hash.prototype.get = hashGet;
	Hash.prototype.has = hashHas;
	Hash.prototype.set = hashSet;
	
	/**
	 * Creates an list cache object.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function ListCache(entries) {
	  var index = -1,
	      length = entries ? entries.length : 0;
	
	  this.clear();
	  while (++index < length) {
	    var entry = entries[index];
	    this.set(entry[0], entry[1]);
	  }
	}
	
	/**
	 * Removes all key-value entries from the list cache.
	 *
	 * @private
	 * @name clear
	 * @memberOf ListCache
	 */
	function listCacheClear() {
	  this.__data__ = [];
	}
	
	/**
	 * Removes `key` and its value from the list cache.
	 *
	 * @private
	 * @name delete
	 * @memberOf ListCache
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function listCacheDelete(key) {
	  var data = this.__data__,
	      index = assocIndexOf(data, key);
	
	  if (index < 0) {
	    return false;
	  }
	  var lastIndex = data.length - 1;
	  if (index == lastIndex) {
	    data.pop();
	  } else {
	    splice.call(data, index, 1);
	  }
	  return true;
	}
	
	/**
	 * Gets the list cache value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf ListCache
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function listCacheGet(key) {
	  var data = this.__data__,
	      index = assocIndexOf(data, key);
	
	  return index < 0 ? undefined : data[index][1];
	}
	
	/**
	 * Checks if a list cache value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf ListCache
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function listCacheHas(key) {
	  return assocIndexOf(this.__data__, key) > -1;
	}
	
	/**
	 * Sets the list cache `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf ListCache
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the list cache instance.
	 */
	function listCacheSet(key, value) {
	  var data = this.__data__,
	      index = assocIndexOf(data, key);
	
	  if (index < 0) {
	    data.push([key, value]);
	  } else {
	    data[index][1] = value;
	  }
	  return this;
	}
	
	// Add methods to `ListCache`.
	ListCache.prototype.clear = listCacheClear;
	ListCache.prototype['delete'] = listCacheDelete;
	ListCache.prototype.get = listCacheGet;
	ListCache.prototype.has = listCacheHas;
	ListCache.prototype.set = listCacheSet;
	
	/**
	 * Creates a map cache object to store key-value pairs.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function MapCache(entries) {
	  var index = -1,
	      length = entries ? entries.length : 0;
	
	  this.clear();
	  while (++index < length) {
	    var entry = entries[index];
	    this.set(entry[0], entry[1]);
	  }
	}
	
	/**
	 * Removes all key-value entries from the map.
	 *
	 * @private
	 * @name clear
	 * @memberOf MapCache
	 */
	function mapCacheClear() {
	  this.__data__ = {
	    'hash': new Hash,
	    'map': new (Map || ListCache),
	    'string': new Hash
	  };
	}
	
	/**
	 * Removes `key` and its value from the map.
	 *
	 * @private
	 * @name delete
	 * @memberOf MapCache
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function mapCacheDelete(key) {
	  return getMapData(this, key)['delete'](key);
	}
	
	/**
	 * Gets the map value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf MapCache
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function mapCacheGet(key) {
	  return getMapData(this, key).get(key);
	}
	
	/**
	 * Checks if a map value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf MapCache
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function mapCacheHas(key) {
	  return getMapData(this, key).has(key);
	}
	
	/**
	 * Sets the map `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf MapCache
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the map cache instance.
	 */
	function mapCacheSet(key, value) {
	  getMapData(this, key).set(key, value);
	  return this;
	}
	
	// Add methods to `MapCache`.
	MapCache.prototype.clear = mapCacheClear;
	MapCache.prototype['delete'] = mapCacheDelete;
	MapCache.prototype.get = mapCacheGet;
	MapCache.prototype.has = mapCacheHas;
	MapCache.prototype.set = mapCacheSet;
	
	/**
	 *
	 * Creates an array cache object to store unique values.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [values] The values to cache.
	 */
	function SetCache(values) {
	  var index = -1,
	      length = values ? values.length : 0;
	
	  this.__data__ = new MapCache;
	  while (++index < length) {
	    this.add(values[index]);
	  }
	}
	
	/**
	 * Adds `value` to the array cache.
	 *
	 * @private
	 * @name add
	 * @memberOf SetCache
	 * @alias push
	 * @param {*} value The value to cache.
	 * @returns {Object} Returns the cache instance.
	 */
	function setCacheAdd(value) {
	  this.__data__.set(value, HASH_UNDEFINED);
	  return this;
	}
	
	/**
	 * Checks if `value` is in the array cache.
	 *
	 * @private
	 * @name has
	 * @memberOf SetCache
	 * @param {*} value The value to search for.
	 * @returns {number} Returns `true` if `value` is found, else `false`.
	 */
	function setCacheHas(value) {
	  return this.__data__.has(value);
	}
	
	// Add methods to `SetCache`.
	SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
	SetCache.prototype.has = setCacheHas;
	
	/**
	 * Creates a stack cache object to store key-value pairs.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function Stack(entries) {
	  this.__data__ = new ListCache(entries);
	}
	
	/**
	 * Removes all key-value entries from the stack.
	 *
	 * @private
	 * @name clear
	 * @memberOf Stack
	 */
	function stackClear() {
	  this.__data__ = new ListCache;
	}
	
	/**
	 * Removes `key` and its value from the stack.
	 *
	 * @private
	 * @name delete
	 * @memberOf Stack
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function stackDelete(key) {
	  return this.__data__['delete'](key);
	}
	
	/**
	 * Gets the stack value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf Stack
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function stackGet(key) {
	  return this.__data__.get(key);
	}
	
	/**
	 * Checks if a stack value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf Stack
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function stackHas(key) {
	  return this.__data__.has(key);
	}
	
	/**
	 * Sets the stack `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf Stack
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the stack cache instance.
	 */
	function stackSet(key, value) {
	  var cache = this.__data__;
	  if (cache instanceof ListCache) {
	    var pairs = cache.__data__;
	    if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
	      pairs.push([key, value]);
	      return this;
	    }
	    cache = this.__data__ = new MapCache(pairs);
	  }
	  cache.set(key, value);
	  return this;
	}
	
	// Add methods to `Stack`.
	Stack.prototype.clear = stackClear;
	Stack.prototype['delete'] = stackDelete;
	Stack.prototype.get = stackGet;
	Stack.prototype.has = stackHas;
	Stack.prototype.set = stackSet;
	
	/**
	 * Creates an array of the enumerable property names of the array-like `value`.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @param {boolean} inherited Specify returning inherited property names.
	 * @returns {Array} Returns the array of property names.
	 */
	function arrayLikeKeys(value, inherited) {
	  // Safari 8.1 makes `arguments.callee` enumerable in strict mode.
	  // Safari 9 makes `arguments.length` enumerable in strict mode.
	  var result = (isArray(value) || isArguments(value))
	    ? baseTimes(value.length, String)
	    : [];
	
	  var length = result.length,
	      skipIndexes = !!length;
	
	  for (var key in value) {
	    if ((inherited || hasOwnProperty.call(value, key)) &&
	        !(skipIndexes && (key == 'length' || isIndex(key, length)))) {
	      result.push(key);
	    }
	  }
	  return result;
	}
	
	/**
	 * Gets the index at which the `key` is found in `array` of key-value pairs.
	 *
	 * @private
	 * @param {Array} array The array to inspect.
	 * @param {*} key The key to search for.
	 * @returns {number} Returns the index of the matched value, else `-1`.
	 */
	function assocIndexOf(array, key) {
	  var length = array.length;
	  while (length--) {
	    if (eq(array[length][0], key)) {
	      return length;
	    }
	  }
	  return -1;
	}
	
	/**
	 * The base implementation of `getTag`.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @returns {string} Returns the `toStringTag`.
	 */
	function baseGetTag(value) {
	  return objectToString.call(value);
	}
	
	/**
	 * The base implementation of `_.isEqual` which supports partial comparisons
	 * and tracks traversed objects.
	 *
	 * @private
	 * @param {*} value The value to compare.
	 * @param {*} other The other value to compare.
	 * @param {Function} [customizer] The function to customize comparisons.
	 * @param {boolean} [bitmask] The bitmask of comparison flags.
	 *  The bitmask may be composed of the following flags:
	 *     1 - Unordered comparison
	 *     2 - Partial comparison
	 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
	 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	 */
	function baseIsEqual(value, other, customizer, bitmask, stack) {
	  if (value === other) {
	    return true;
	  }
	  if (value == null || other == null || (!isObject(value) && !isObjectLike(other))) {
	    return value !== value && other !== other;
	  }
	  return baseIsEqualDeep(value, other, baseIsEqual, customizer, bitmask, stack);
	}
	
	/**
	 * A specialized version of `baseIsEqual` for arrays and objects which performs
	 * deep comparisons and tracks traversed objects enabling objects with circular
	 * references to be compared.
	 *
	 * @private
	 * @param {Object} object The object to compare.
	 * @param {Object} other The other object to compare.
	 * @param {Function} equalFunc The function to determine equivalents of values.
	 * @param {Function} [customizer] The function to customize comparisons.
	 * @param {number} [bitmask] The bitmask of comparison flags. See `baseIsEqual`
	 *  for more details.
	 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
	 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	 */
	function baseIsEqualDeep(object, other, equalFunc, customizer, bitmask, stack) {
	  var objIsArr = isArray(object),
	      othIsArr = isArray(other),
	      objTag = arrayTag,
	      othTag = arrayTag;
	
	  if (!objIsArr) {
	    objTag = getTag(object);
	    objTag = objTag == argsTag ? objectTag : objTag;
	  }
	  if (!othIsArr) {
	    othTag = getTag(other);
	    othTag = othTag == argsTag ? objectTag : othTag;
	  }
	  var objIsObj = objTag == objectTag && !isHostObject(object),
	      othIsObj = othTag == objectTag && !isHostObject(other),
	      isSameTag = objTag == othTag;
	
	  if (isSameTag && !objIsObj) {
	    stack || (stack = new Stack);
	    return (objIsArr || isTypedArray(object))
	      ? equalArrays(object, other, equalFunc, customizer, bitmask, stack)
	      : equalByTag(object, other, objTag, equalFunc, customizer, bitmask, stack);
	  }
	  if (!(bitmask & PARTIAL_COMPARE_FLAG)) {
	    var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
	        othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');
	
	    if (objIsWrapped || othIsWrapped) {
	      var objUnwrapped = objIsWrapped ? object.value() : object,
	          othUnwrapped = othIsWrapped ? other.value() : other;
	
	      stack || (stack = new Stack);
	      return equalFunc(objUnwrapped, othUnwrapped, customizer, bitmask, stack);
	    }
	  }
	  if (!isSameTag) {
	    return false;
	  }
	  stack || (stack = new Stack);
	  return equalObjects(object, other, equalFunc, customizer, bitmask, stack);
	}
	
	/**
	 * The base implementation of `_.isNative` without bad shim checks.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a native function,
	 *  else `false`.
	 */
	function baseIsNative(value) {
	  if (!isObject(value) || isMasked(value)) {
	    return false;
	  }
	  var pattern = (isFunction(value) || isHostObject(value)) ? reIsNative : reIsHostCtor;
	  return pattern.test(toSource(value));
	}
	
	/**
	 * The base implementation of `_.isTypedArray` without Node.js optimizations.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
	 */
	function baseIsTypedArray(value) {
	  return isObjectLike(value) &&
	    isLength(value.length) && !!typedArrayTags[objectToString.call(value)];
	}
	
	/**
	 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 */
	function baseKeys(object) {
	  if (!isPrototype(object)) {
	    return nativeKeys(object);
	  }
	  var result = [];
	  for (var key in Object(object)) {
	    if (hasOwnProperty.call(object, key) && key != 'constructor') {
	      result.push(key);
	    }
	  }
	  return result;
	}
	
	/**
	 * A specialized version of `baseIsEqualDeep` for arrays with support for
	 * partial deep comparisons.
	 *
	 * @private
	 * @param {Array} array The array to compare.
	 * @param {Array} other The other array to compare.
	 * @param {Function} equalFunc The function to determine equivalents of values.
	 * @param {Function} customizer The function to customize comparisons.
	 * @param {number} bitmask The bitmask of comparison flags. See `baseIsEqual`
	 *  for more details.
	 * @param {Object} stack Tracks traversed `array` and `other` objects.
	 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
	 */
	function equalArrays(array, other, equalFunc, customizer, bitmask, stack) {
	  var isPartial = bitmask & PARTIAL_COMPARE_FLAG,
	      arrLength = array.length,
	      othLength = other.length;
	
	  if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
	    return false;
	  }
	  // Assume cyclic values are equal.
	  var stacked = stack.get(array);
	  if (stacked && stack.get(other)) {
	    return stacked == other;
	  }
	  var index = -1,
	      result = true,
	      seen = (bitmask & UNORDERED_COMPARE_FLAG) ? new SetCache : undefined;
	
	  stack.set(array, other);
	  stack.set(other, array);
	
	  // Ignore non-index properties.
	  while (++index < arrLength) {
	    var arrValue = array[index],
	        othValue = other[index];
	
	    if (customizer) {
	      var compared = isPartial
	        ? customizer(othValue, arrValue, index, other, array, stack)
	        : customizer(arrValue, othValue, index, array, other, stack);
	    }
	    if (compared !== undefined) {
	      if (compared) {
	        continue;
	      }
	      result = false;
	      break;
	    }
	    // Recursively compare arrays (susceptible to call stack limits).
	    if (seen) {
	      if (!arraySome(other, function(othValue, othIndex) {
	            if (!seen.has(othIndex) &&
	                (arrValue === othValue || equalFunc(arrValue, othValue, customizer, bitmask, stack))) {
	              return seen.add(othIndex);
	            }
	          })) {
	        result = false;
	        break;
	      }
	    } else if (!(
	          arrValue === othValue ||
	            equalFunc(arrValue, othValue, customizer, bitmask, stack)
	        )) {
	      result = false;
	      break;
	    }
	  }
	  stack['delete'](array);
	  stack['delete'](other);
	  return result;
	}
	
	/**
	 * A specialized version of `baseIsEqualDeep` for comparing objects of
	 * the same `toStringTag`.
	 *
	 * **Note:** This function only supports comparing values with tags of
	 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
	 *
	 * @private
	 * @param {Object} object The object to compare.
	 * @param {Object} other The other object to compare.
	 * @param {string} tag The `toStringTag` of the objects to compare.
	 * @param {Function} equalFunc The function to determine equivalents of values.
	 * @param {Function} customizer The function to customize comparisons.
	 * @param {number} bitmask The bitmask of comparison flags. See `baseIsEqual`
	 *  for more details.
	 * @param {Object} stack Tracks traversed `object` and `other` objects.
	 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	 */
	function equalByTag(object, other, tag, equalFunc, customizer, bitmask, stack) {
	  switch (tag) {
	    case dataViewTag:
	      if ((object.byteLength != other.byteLength) ||
	          (object.byteOffset != other.byteOffset)) {
	        return false;
	      }
	      object = object.buffer;
	      other = other.buffer;
	
	    case arrayBufferTag:
	      if ((object.byteLength != other.byteLength) ||
	          !equalFunc(new Uint8Array(object), new Uint8Array(other))) {
	        return false;
	      }
	      return true;
	
	    case boolTag:
	    case dateTag:
	    case numberTag:
	      // Coerce booleans to `1` or `0` and dates to milliseconds.
	      // Invalid dates are coerced to `NaN`.
	      return eq(+object, +other);
	
	    case errorTag:
	      return object.name == other.name && object.message == other.message;
	
	    case regexpTag:
	    case stringTag:
	      // Coerce regexes to strings and treat strings, primitives and objects,
	      // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
	      // for more details.
	      return object == (other + '');
	
	    case mapTag:
	      var convert = mapToArray;
	
	    case setTag:
	      var isPartial = bitmask & PARTIAL_COMPARE_FLAG;
	      convert || (convert = setToArray);
	
	      if (object.size != other.size && !isPartial) {
	        return false;
	      }
	      // Assume cyclic values are equal.
	      var stacked = stack.get(object);
	      if (stacked) {
	        return stacked == other;
	      }
	      bitmask |= UNORDERED_COMPARE_FLAG;
	
	      // Recursively compare objects (susceptible to call stack limits).
	      stack.set(object, other);
	      var result = equalArrays(convert(object), convert(other), equalFunc, customizer, bitmask, stack);
	      stack['delete'](object);
	      return result;
	
	    case symbolTag:
	      if (symbolValueOf) {
	        return symbolValueOf.call(object) == symbolValueOf.call(other);
	      }
	  }
	  return false;
	}
	
	/**
	 * A specialized version of `baseIsEqualDeep` for objects with support for
	 * partial deep comparisons.
	 *
	 * @private
	 * @param {Object} object The object to compare.
	 * @param {Object} other The other object to compare.
	 * @param {Function} equalFunc The function to determine equivalents of values.
	 * @param {Function} customizer The function to customize comparisons.
	 * @param {number} bitmask The bitmask of comparison flags. See `baseIsEqual`
	 *  for more details.
	 * @param {Object} stack Tracks traversed `object` and `other` objects.
	 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	 */
	function equalObjects(object, other, equalFunc, customizer, bitmask, stack) {
	  var isPartial = bitmask & PARTIAL_COMPARE_FLAG,
	      objProps = keys(object),
	      objLength = objProps.length,
	      othProps = keys(other),
	      othLength = othProps.length;
	
	  if (objLength != othLength && !isPartial) {
	    return false;
	  }
	  var index = objLength;
	  while (index--) {
	    var key = objProps[index];
	    if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) {
	      return false;
	    }
	  }
	  // Assume cyclic values are equal.
	  var stacked = stack.get(object);
	  if (stacked && stack.get(other)) {
	    return stacked == other;
	  }
	  var result = true;
	  stack.set(object, other);
	  stack.set(other, object);
	
	  var skipCtor = isPartial;
	  while (++index < objLength) {
	    key = objProps[index];
	    var objValue = object[key],
	        othValue = other[key];
	
	    if (customizer) {
	      var compared = isPartial
	        ? customizer(othValue, objValue, key, other, object, stack)
	        : customizer(objValue, othValue, key, object, other, stack);
	    }
	    // Recursively compare objects (susceptible to call stack limits).
	    if (!(compared === undefined
	          ? (objValue === othValue || equalFunc(objValue, othValue, customizer, bitmask, stack))
	          : compared
	        )) {
	      result = false;
	      break;
	    }
	    skipCtor || (skipCtor = key == 'constructor');
	  }
	  if (result && !skipCtor) {
	    var objCtor = object.constructor,
	        othCtor = other.constructor;
	
	    // Non `Object` object instances with different constructors are not equal.
	    if (objCtor != othCtor &&
	        ('constructor' in object && 'constructor' in other) &&
	        !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
	          typeof othCtor == 'function' && othCtor instanceof othCtor)) {
	      result = false;
	    }
	  }
	  stack['delete'](object);
	  stack['delete'](other);
	  return result;
	}
	
	/**
	 * Gets the data for `map`.
	 *
	 * @private
	 * @param {Object} map The map to query.
	 * @param {string} key The reference key.
	 * @returns {*} Returns the map data.
	 */
	function getMapData(map, key) {
	  var data = map.__data__;
	  return isKeyable(key)
	    ? data[typeof key == 'string' ? 'string' : 'hash']
	    : data.map;
	}
	
	/**
	 * Gets the native function at `key` of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {string} key The key of the method to get.
	 * @returns {*} Returns the function if it's native, else `undefined`.
	 */
	function getNative(object, key) {
	  var value = getValue(object, key);
	  return baseIsNative(value) ? value : undefined;
	}
	
	/**
	 * Gets the `toStringTag` of `value`.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @returns {string} Returns the `toStringTag`.
	 */
	var getTag = baseGetTag;
	
	// Fallback for data views, maps, sets, and weak maps in IE 11,
	// for data views in Edge < 14, and promises in Node.js.
	if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
	    (Map && getTag(new Map) != mapTag) ||
	    (Promise && getTag(Promise.resolve()) != promiseTag) ||
	    (Set && getTag(new Set) != setTag) ||
	    (WeakMap && getTag(new WeakMap) != weakMapTag)) {
	  getTag = function(value) {
	    var result = objectToString.call(value),
	        Ctor = result == objectTag ? value.constructor : undefined,
	        ctorString = Ctor ? toSource(Ctor) : undefined;
	
	    if (ctorString) {
	      switch (ctorString) {
	        case dataViewCtorString: return dataViewTag;
	        case mapCtorString: return mapTag;
	        case promiseCtorString: return promiseTag;
	        case setCtorString: return setTag;
	        case weakMapCtorString: return weakMapTag;
	      }
	    }
	    return result;
	  };
	}
	
	/**
	 * Checks if `value` is a valid array-like index.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
	 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
	 */
	function isIndex(value, length) {
	  length = length == null ? MAX_SAFE_INTEGER : length;
	  return !!length &&
	    (typeof value == 'number' || reIsUint.test(value)) &&
	    (value > -1 && value % 1 == 0 && value < length);
	}
	
	/**
	 * Checks if `value` is suitable for use as unique object key.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
	 */
	function isKeyable(value) {
	  var type = typeof value;
	  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
	    ? (value !== '__proto__')
	    : (value === null);
	}
	
	/**
	 * Checks if `func` has its source masked.
	 *
	 * @private
	 * @param {Function} func The function to check.
	 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
	 */
	function isMasked(func) {
	  return !!maskSrcKey && (maskSrcKey in func);
	}
	
	/**
	 * Checks if `value` is likely a prototype object.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
	 */
	function isPrototype(value) {
	  var Ctor = value && value.constructor,
	      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;
	
	  return value === proto;
	}
	
	/**
	 * Converts `func` to its source code.
	 *
	 * @private
	 * @param {Function} func The function to process.
	 * @returns {string} Returns the source code.
	 */
	function toSource(func) {
	  if (func != null) {
	    try {
	      return funcToString.call(func);
	    } catch (e) {}
	    try {
	      return (func + '');
	    } catch (e) {}
	  }
	  return '';
	}
	
	/**
	 * Performs a
	 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	 * comparison between two values to determine if they are equivalent.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to compare.
	 * @param {*} other The other value to compare.
	 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	 * @example
	 *
	 * var object = { 'a': 1 };
	 * var other = { 'a': 1 };
	 *
	 * _.eq(object, object);
	 * // => true
	 *
	 * _.eq(object, other);
	 * // => false
	 *
	 * _.eq('a', 'a');
	 * // => true
	 *
	 * _.eq('a', Object('a'));
	 * // => false
	 *
	 * _.eq(NaN, NaN);
	 * // => true
	 */
	function eq(value, other) {
	  return value === other || (value !== value && other !== other);
	}
	
	/**
	 * Checks if `value` is likely an `arguments` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
	 *  else `false`.
	 * @example
	 *
	 * _.isArguments(function() { return arguments; }());
	 * // => true
	 *
	 * _.isArguments([1, 2, 3]);
	 * // => false
	 */
	function isArguments(value) {
	  // Safari 8.1 makes `arguments.callee` enumerable in strict mode.
	  return isArrayLikeObject(value) && hasOwnProperty.call(value, 'callee') &&
	    (!propertyIsEnumerable.call(value, 'callee') || objectToString.call(value) == argsTag);
	}
	
	/**
	 * Checks if `value` is classified as an `Array` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
	 * @example
	 *
	 * _.isArray([1, 2, 3]);
	 * // => true
	 *
	 * _.isArray(document.body.children);
	 * // => false
	 *
	 * _.isArray('abc');
	 * // => false
	 *
	 * _.isArray(_.noop);
	 * // => false
	 */
	var isArray = Array.isArray;
	
	/**
	 * Checks if `value` is array-like. A value is considered array-like if it's
	 * not a function and has a `value.length` that's an integer greater than or
	 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
	 * @example
	 *
	 * _.isArrayLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isArrayLike(document.body.children);
	 * // => true
	 *
	 * _.isArrayLike('abc');
	 * // => true
	 *
	 * _.isArrayLike(_.noop);
	 * // => false
	 */
	function isArrayLike(value) {
	  return value != null && isLength(value.length) && !isFunction(value);
	}
	
	/**
	 * This method is like `_.isArrayLike` except that it also checks if `value`
	 * is an object.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an array-like object,
	 *  else `false`.
	 * @example
	 *
	 * _.isArrayLikeObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isArrayLikeObject(document.body.children);
	 * // => true
	 *
	 * _.isArrayLikeObject('abc');
	 * // => false
	 *
	 * _.isArrayLikeObject(_.noop);
	 * // => false
	 */
	function isArrayLikeObject(value) {
	  return isObjectLike(value) && isArrayLike(value);
	}
	
	/**
	 * This method is like `_.isEqual` except that it accepts `customizer` which
	 * is invoked to compare values. If `customizer` returns `undefined`, comparisons
	 * are handled by the method instead. The `customizer` is invoked with up to
	 * six arguments: (objValue, othValue [, index|key, object, other, stack]).
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to compare.
	 * @param {*} other The other value to compare.
	 * @param {Function} [customizer] The function to customize comparisons.
	 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	 * @example
	 *
	 * function isGreeting(value) {
	 *   return /^h(?:i|ello)$/.test(value);
	 * }
	 *
	 * function customizer(objValue, othValue) {
	 *   if (isGreeting(objValue) && isGreeting(othValue)) {
	 *     return true;
	 *   }
	 * }
	 *
	 * var array = ['hello', 'goodbye'];
	 * var other = ['hi', 'goodbye'];
	 *
	 * _.isEqualWith(array, other, customizer);
	 * // => true
	 */
	function isEqualWith(value, other, customizer) {
	  customizer = typeof customizer == 'function' ? customizer : undefined;
	  var result = customizer ? customizer(value, other) : undefined;
	  return result === undefined ? baseIsEqual(value, other, customizer) : !!result;
	}
	
	/**
	 * Checks if `value` is classified as a `Function` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
	 * @example
	 *
	 * _.isFunction(_);
	 * // => true
	 *
	 * _.isFunction(/abc/);
	 * // => false
	 */
	function isFunction(value) {
	  // The use of `Object#toString` avoids issues with the `typeof` operator
	  // in Safari 8-9 which returns 'object' for typed array and other constructors.
	  var tag = isObject(value) ? objectToString.call(value) : '';
	  return tag == funcTag || tag == genTag;
	}
	
	/**
	 * Checks if `value` is a valid array-like length.
	 *
	 * **Note:** This method is loosely based on
	 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
	 * @example
	 *
	 * _.isLength(3);
	 * // => true
	 *
	 * _.isLength(Number.MIN_VALUE);
	 * // => false
	 *
	 * _.isLength(Infinity);
	 * // => false
	 *
	 * _.isLength('3');
	 * // => false
	 */
	function isLength(value) {
	  return typeof value == 'number' &&
	    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
	}
	
	/**
	 * Checks if `value` is the
	 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
	 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
	 * @example
	 *
	 * _.isObject({});
	 * // => true
	 *
	 * _.isObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isObject(_.noop);
	 * // => true
	 *
	 * _.isObject(null);
	 * // => false
	 */
	function isObject(value) {
	  var type = typeof value;
	  return !!value && (type == 'object' || type == 'function');
	}
	
	/**
	 * Checks if `value` is object-like. A value is object-like if it's not `null`
	 * and has a `typeof` result of "object".
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
	 * @example
	 *
	 * _.isObjectLike({});
	 * // => true
	 *
	 * _.isObjectLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isObjectLike(_.noop);
	 * // => false
	 *
	 * _.isObjectLike(null);
	 * // => false
	 */
	function isObjectLike(value) {
	  return !!value && typeof value == 'object';
	}
	
	/**
	 * Checks if `value` is classified as a typed array.
	 *
	 * @static
	 * @memberOf _
	 * @since 3.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
	 * @example
	 *
	 * _.isTypedArray(new Uint8Array);
	 * // => true
	 *
	 * _.isTypedArray([]);
	 * // => false
	 */
	var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;
	
	/**
	 * Creates an array of the own enumerable property names of `object`.
	 *
	 * **Note:** Non-object values are coerced to objects. See the
	 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
	 * for more details.
	 *
	 * @static
	 * @since 0.1.0
	 * @memberOf _
	 * @category Object
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 * @example
	 *
	 * function Foo() {
	 *   this.a = 1;
	 *   this.b = 2;
	 * }
	 *
	 * Foo.prototype.c = 3;
	 *
	 * _.keys(new Foo);
	 * // => ['a', 'b'] (iteration order is not guaranteed)
	 *
	 * _.keys('hi');
	 * // => ['0', '1']
	 */
	function keys(object) {
	  return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
	}
	
	module.exports = isEqualWith;
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }()), __webpack_require__(154)(module)))

/***/ },
/* 1183 */
/***/ function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__(122),
	    root = __webpack_require__(69);
	
	/* Built-in method references that are verified to be native. */
	var DataView = getNative(root, 'DataView');
	
	module.exports = DataView;


/***/ },
/* 1184 */
/***/ function(module, exports, __webpack_require__) {

	var hashClear = __webpack_require__(1231),
	    hashDelete = __webpack_require__(1232),
	    hashGet = __webpack_require__(1233),
	    hashHas = __webpack_require__(1234),
	    hashSet = __webpack_require__(1235);
	
	/**
	 * Creates a hash object.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function Hash(entries) {
	  var index = -1,
	      length = entries == null ? 0 : entries.length;
	
	  this.clear();
	  while (++index < length) {
	    var entry = entries[index];
	    this.set(entry[0], entry[1]);
	  }
	}
	
	// Add methods to `Hash`.
	Hash.prototype.clear = hashClear;
	Hash.prototype['delete'] = hashDelete;
	Hash.prototype.get = hashGet;
	Hash.prototype.has = hashHas;
	Hash.prototype.set = hashSet;
	
	module.exports = Hash;


/***/ },
/* 1185 */
/***/ function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__(122),
	    root = __webpack_require__(69);
	
	/* Built-in method references that are verified to be native. */
	var Promise = getNative(root, 'Promise');
	
	module.exports = Promise;


/***/ },
/* 1186 */
/***/ function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__(122),
	    root = __webpack_require__(69);
	
	/* Built-in method references that are verified to be native. */
	var Set = getNative(root, 'Set');
	
	module.exports = Set;


/***/ },
/* 1187 */
/***/ function(module, exports, __webpack_require__) {

	var MapCache = __webpack_require__(310),
	    setCacheAdd = __webpack_require__(1254),
	    setCacheHas = __webpack_require__(1255);
	
	/**
	 *
	 * Creates an array cache object to store unique values.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [values] The values to cache.
	 */
	function SetCache(values) {
	  var index = -1,
	      length = values == null ? 0 : values.length;
	
	  this.__data__ = new MapCache;
	  while (++index < length) {
	    this.add(values[index]);
	  }
	}
	
	// Add methods to `SetCache`.
	SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
	SetCache.prototype.has = setCacheHas;
	
	module.exports = SetCache;


/***/ },
/* 1188 */
/***/ function(module, exports, __webpack_require__) {

	var root = __webpack_require__(69);
	
	/** Built-in value references. */
	var Uint8Array = root.Uint8Array;
	
	module.exports = Uint8Array;


/***/ },
/* 1189 */
/***/ function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__(122),
	    root = __webpack_require__(69);
	
	/* Built-in method references that are verified to be native. */
	var WeakMap = getNative(root, 'WeakMap');
	
	module.exports = WeakMap;


/***/ },
/* 1190 */
/***/ function(module, exports) {

	/**
	 * A specialized version of `_.filter` for arrays without support for
	 * iteratee shorthands.
	 *
	 * @private
	 * @param {Array} [array] The array to iterate over.
	 * @param {Function} predicate The function invoked per iteration.
	 * @returns {Array} Returns the new filtered array.
	 */
	function arrayFilter(array, predicate) {
	  var index = -1,
	      length = array == null ? 0 : array.length,
	      resIndex = 0,
	      result = [];
	
	  while (++index < length) {
	    var value = array[index];
	    if (predicate(value, index, array)) {
	      result[resIndex++] = value;
	    }
	  }
	  return result;
	}
	
	module.exports = arrayFilter;


/***/ },
/* 1191 */
/***/ function(module, exports, __webpack_require__) {

	var baseTimes = __webpack_require__(1213),
	    isArguments = __webpack_require__(499),
	    isArray = __webpack_require__(76),
	    isBuffer = __webpack_require__(500),
	    isIndex = __webpack_require__(490),
	    isTypedArray = __webpack_require__(503);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Creates an array of the enumerable property names of the array-like `value`.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @param {boolean} inherited Specify returning inherited property names.
	 * @returns {Array} Returns the array of property names.
	 */
	function arrayLikeKeys(value, inherited) {
	  var isArr = isArray(value),
	      isArg = !isArr && isArguments(value),
	      isBuff = !isArr && !isArg && isBuffer(value),
	      isType = !isArr && !isArg && !isBuff && isTypedArray(value),
	      skipIndexes = isArr || isArg || isBuff || isType,
	      result = skipIndexes ? baseTimes(value.length, String) : [],
	      length = result.length;
	
	  for (var key in value) {
	    if ((inherited || hasOwnProperty.call(value, key)) &&
	        !(skipIndexes && (
	           // Safari 9 has enumerable `arguments.length` in strict mode.
	           key == 'length' ||
	           // Node.js 0.10 has enumerable non-index properties on buffers.
	           (isBuff && (key == 'offset' || key == 'parent')) ||
	           // PhantomJS 2 has enumerable non-index properties on typed arrays.
	           (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
	           // Skip index properties.
	           isIndex(key, length)
	        ))) {
	      result.push(key);
	    }
	  }
	  return result;
	}
	
	module.exports = arrayLikeKeys;


/***/ },
/* 1192 */
/***/ function(module, exports) {

	/**
	 * Appends the elements of `values` to `array`.
	 *
	 * @private
	 * @param {Array} array The array to modify.
	 * @param {Array} values The values to append.
	 * @returns {Array} Returns `array`.
	 */
	function arrayPush(array, values) {
	  var index = -1,
	      length = values.length,
	      offset = array.length;
	
	  while (++index < length) {
	    array[offset + index] = values[index];
	  }
	  return array;
	}
	
	module.exports = arrayPush;


/***/ },
/* 1193 */
/***/ function(module, exports) {

	/**
	 * A specialized version of `_.some` for arrays without support for iteratee
	 * shorthands.
	 *
	 * @private
	 * @param {Array} [array] The array to iterate over.
	 * @param {Function} predicate The function invoked per iteration.
	 * @returns {boolean} Returns `true` if any element passes the predicate check,
	 *  else `false`.
	 */
	function arraySome(array, predicate) {
	  var index = -1,
	      length = array == null ? 0 : array.length;
	
	  while (++index < length) {
	    if (predicate(array[index], index, array)) {
	      return true;
	    }
	  }
	  return false;
	}
	
	module.exports = arraySome;


/***/ },
/* 1194 */
/***/ function(module, exports, __webpack_require__) {

	var baseForOwn = __webpack_require__(1196),
	    createBaseEach = __webpack_require__(1219);
	
	/**
	 * The base implementation of `_.forEach` without support for iteratee shorthands.
	 *
	 * @private
	 * @param {Array|Object} collection The collection to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Array|Object} Returns `collection`.
	 */
	var baseEach = createBaseEach(baseForOwn);
	
	module.exports = baseEach;


/***/ },
/* 1195 */
/***/ function(module, exports, __webpack_require__) {

	var createBaseFor = __webpack_require__(1220);
	
	/**
	 * The base implementation of `baseForOwn` which iterates over `object`
	 * properties returned by `keysFunc` and invokes `iteratee` for each property.
	 * Iteratee functions may exit iteration early by explicitly returning `false`.
	 *
	 * @private
	 * @param {Object} object The object to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @param {Function} keysFunc The function to get the keys of `object`.
	 * @returns {Object} Returns `object`.
	 */
	var baseFor = createBaseFor();
	
	module.exports = baseFor;


/***/ },
/* 1196 */
/***/ function(module, exports, __webpack_require__) {

	var baseFor = __webpack_require__(1195),
	    keys = __webpack_require__(314);
	
	/**
	 * The base implementation of `_.forOwn` without support for iteratee shorthands.
	 *
	 * @private
	 * @param {Object} object The object to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Object} Returns `object`.
	 */
	function baseForOwn(object, iteratee) {
	  return object && baseFor(object, iteratee, keys);
	}
	
	module.exports = baseForOwn;


/***/ },
/* 1197 */
/***/ function(module, exports, __webpack_require__) {

	var arrayPush = __webpack_require__(1192),
	    isArray = __webpack_require__(76);
	
	/**
	 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
	 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
	 * symbols of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {Function} keysFunc The function to get the keys of `object`.
	 * @param {Function} symbolsFunc The function to get the symbols of `object`.
	 * @returns {Array} Returns the array of property names and symbols.
	 */
	function baseGetAllKeys(object, keysFunc, symbolsFunc) {
	  var result = keysFunc(object);
	  return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
	}
	
	module.exports = baseGetAllKeys;


/***/ },
/* 1198 */
/***/ function(module, exports) {

	/**
	 * The base implementation of `_.hasIn` without support for deep paths.
	 *
	 * @private
	 * @param {Object} [object] The object to query.
	 * @param {Array|string} key The key to check.
	 * @returns {boolean} Returns `true` if `key` exists, else `false`.
	 */
	function baseHasIn(object, key) {
	  return object != null && key in Object(object);
	}
	
	module.exports = baseHasIn;


/***/ },
/* 1199 */
/***/ function(module, exports, __webpack_require__) {

	var baseGetTag = __webpack_require__(121),
	    isObjectLike = __webpack_require__(123);
	
	/** `Object#toString` result references. */
	var argsTag = '[object Arguments]';
	
	/**
	 * The base implementation of `_.isArguments`.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
	 */
	function baseIsArguments(value) {
	  return isObjectLike(value) && baseGetTag(value) == argsTag;
	}
	
	module.exports = baseIsArguments;


/***/ },
/* 1200 */
/***/ function(module, exports, __webpack_require__) {

	var Stack = __webpack_require__(482),
	    equalArrays = __webpack_require__(488),
	    equalByTag = __webpack_require__(1221),
	    equalObjects = __webpack_require__(1222),
	    getTag = __webpack_require__(1228),
	    isArray = __webpack_require__(76),
	    isBuffer = __webpack_require__(500),
	    isTypedArray = __webpack_require__(503);
	
	/** Used to compose bitmasks for value comparisons. */
	var COMPARE_PARTIAL_FLAG = 1;
	
	/** `Object#toString` result references. */
	var argsTag = '[object Arguments]',
	    arrayTag = '[object Array]',
	    objectTag = '[object Object]';
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * A specialized version of `baseIsEqual` for arrays and objects which performs
	 * deep comparisons and tracks traversed objects enabling objects with circular
	 * references to be compared.
	 *
	 * @private
	 * @param {Object} object The object to compare.
	 * @param {Object} other The other object to compare.
	 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	 * @param {Function} customizer The function to customize comparisons.
	 * @param {Function} equalFunc The function to determine equivalents of values.
	 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
	 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	 */
	function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
	  var objIsArr = isArray(object),
	      othIsArr = isArray(other),
	      objTag = objIsArr ? arrayTag : getTag(object),
	      othTag = othIsArr ? arrayTag : getTag(other);
	
	  objTag = objTag == argsTag ? objectTag : objTag;
	  othTag = othTag == argsTag ? objectTag : othTag;
	
	  var objIsObj = objTag == objectTag,
	      othIsObj = othTag == objectTag,
	      isSameTag = objTag == othTag;
	
	  if (isSameTag && isBuffer(object)) {
	    if (!isBuffer(other)) {
	      return false;
	    }
	    objIsArr = true;
	    objIsObj = false;
	  }
	  if (isSameTag && !objIsObj) {
	    stack || (stack = new Stack);
	    return (objIsArr || isTypedArray(object))
	      ? equalArrays(object, other, bitmask, customizer, equalFunc, stack)
	      : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
	  }
	  if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
	    var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
	        othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');
	
	    if (objIsWrapped || othIsWrapped) {
	      var objUnwrapped = objIsWrapped ? object.value() : object,
	          othUnwrapped = othIsWrapped ? other.value() : other;
	
	      stack || (stack = new Stack);
	      return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
	    }
	  }
	  if (!isSameTag) {
	    return false;
	  }
	  stack || (stack = new Stack);
	  return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
	}
	
	module.exports = baseIsEqualDeep;


/***/ },
/* 1201 */
/***/ function(module, exports, __webpack_require__) {

	var Stack = __webpack_require__(482),
	    baseIsEqual = __webpack_require__(485);
	
	/** Used to compose bitmasks for value comparisons. */
	var COMPARE_PARTIAL_FLAG = 1,
	    COMPARE_UNORDERED_FLAG = 2;
	
	/**
	 * The base implementation of `_.isMatch` without support for iteratee shorthands.
	 *
	 * @private
	 * @param {Object} object The object to inspect.
	 * @param {Object} source The object of property values to match.
	 * @param {Array} matchData The property names, values, and compare flags to match.
	 * @param {Function} [customizer] The function to customize comparisons.
	 * @returns {boolean} Returns `true` if `object` is a match, else `false`.
	 */
	function baseIsMatch(object, source, matchData, customizer) {
	  var index = matchData.length,
	      length = index,
	      noCustomizer = !customizer;
	
	  if (object == null) {
	    return !length;
	  }
	  object = Object(object);
	  while (index--) {
	    var data = matchData[index];
	    if ((noCustomizer && data[2])
	          ? data[1] !== object[data[0]]
	          : !(data[0] in object)
	        ) {
	      return false;
	    }
	  }
	  while (++index < length) {
	    data = matchData[index];
	    var key = data[0],
	        objValue = object[key],
	        srcValue = data[1];
	
	    if (noCustomizer && data[2]) {
	      if (objValue === undefined && !(key in object)) {
	        return false;
	      }
	    } else {
	      var stack = new Stack;
	      if (customizer) {
	        var result = customizer(objValue, srcValue, key, object, source, stack);
	      }
	      if (!(result === undefined
	            ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack)
	            : result
	          )) {
	        return false;
	      }
	    }
	  }
	  return true;
	}
	
	module.exports = baseIsMatch;


/***/ },
/* 1202 */
/***/ function(module, exports, __webpack_require__) {

	var isFunction = __webpack_require__(501),
	    isMasked = __webpack_require__(1237),
	    isObject = __webpack_require__(151),
	    toSource = __webpack_require__(494);
	
	/**
	 * Used to match `RegExp`
	 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
	 */
	var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
	
	/** Used to detect host constructors (Safari). */
	var reIsHostCtor = /^\[object .+?Constructor\]$/;
	
	/** Used for built-in method references. */
	var funcProto = Function.prototype,
	    objectProto = Object.prototype;
	
	/** Used to resolve the decompiled source of functions. */
	var funcToString = funcProto.toString;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/** Used to detect if a method is native. */
	var reIsNative = RegExp('^' +
	  funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
	  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
	);
	
	/**
	 * The base implementation of `_.isNative` without bad shim checks.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a native function,
	 *  else `false`.
	 */
	function baseIsNative(value) {
	  if (!isObject(value) || isMasked(value)) {
	    return false;
	  }
	  var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
	  return pattern.test(toSource(value));
	}
	
	module.exports = baseIsNative;


/***/ },
/* 1203 */
/***/ function(module, exports, __webpack_require__) {

	var baseGetTag = __webpack_require__(121),
	    isLength = __webpack_require__(313),
	    isObjectLike = __webpack_require__(123);
	
	/** `Object#toString` result references. */
	var argsTag = '[object Arguments]',
	    arrayTag = '[object Array]',
	    boolTag = '[object Boolean]',
	    dateTag = '[object Date]',
	    errorTag = '[object Error]',
	    funcTag = '[object Function]',
	    mapTag = '[object Map]',
	    numberTag = '[object Number]',
	    objectTag = '[object Object]',
	    regexpTag = '[object RegExp]',
	    setTag = '[object Set]',
	    stringTag = '[object String]',
	    weakMapTag = '[object WeakMap]';
	
	var arrayBufferTag = '[object ArrayBuffer]',
	    dataViewTag = '[object DataView]',
	    float32Tag = '[object Float32Array]',
	    float64Tag = '[object Float64Array]',
	    int8Tag = '[object Int8Array]',
	    int16Tag = '[object Int16Array]',
	    int32Tag = '[object Int32Array]',
	    uint8Tag = '[object Uint8Array]',
	    uint8ClampedTag = '[object Uint8ClampedArray]',
	    uint16Tag = '[object Uint16Array]',
	    uint32Tag = '[object Uint32Array]';
	
	/** Used to identify `toStringTag` values of typed arrays. */
	var typedArrayTags = {};
	typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
	typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
	typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
	typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
	typedArrayTags[uint32Tag] = true;
	typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
	typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
	typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
	typedArrayTags[errorTag] = typedArrayTags[funcTag] =
	typedArrayTags[mapTag] = typedArrayTags[numberTag] =
	typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
	typedArrayTags[setTag] = typedArrayTags[stringTag] =
	typedArrayTags[weakMapTag] = false;
	
	/**
	 * The base implementation of `_.isTypedArray` without Node.js optimizations.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
	 */
	function baseIsTypedArray(value) {
	  return isObjectLike(value) &&
	    isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
	}
	
	module.exports = baseIsTypedArray;


/***/ },
/* 1204 */
/***/ function(module, exports, __webpack_require__) {

	var baseMatches = __webpack_require__(1207),
	    baseMatchesProperty = __webpack_require__(1208),
	    identity = __webpack_require__(498),
	    isArray = __webpack_require__(76),
	    property = __webpack_require__(1267);
	
	/**
	 * The base implementation of `_.iteratee`.
	 *
	 * @private
	 * @param {*} [value=_.identity] The value to convert to an iteratee.
	 * @returns {Function} Returns the iteratee.
	 */
	function baseIteratee(value) {
	  // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
	  // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
	  if (typeof value == 'function') {
	    return value;
	  }
	  if (value == null) {
	    return identity;
	  }
	  if (typeof value == 'object') {
	    return isArray(value)
	      ? baseMatchesProperty(value[0], value[1])
	      : baseMatches(value);
	  }
	  return property(value);
	}
	
	module.exports = baseIteratee;


/***/ },
/* 1205 */
/***/ function(module, exports, __webpack_require__) {

	var isPrototype = __webpack_require__(1238),
	    nativeKeys = __webpack_require__(1251);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 */
	function baseKeys(object) {
	  if (!isPrototype(object)) {
	    return nativeKeys(object);
	  }
	  var result = [];
	  for (var key in Object(object)) {
	    if (hasOwnProperty.call(object, key) && key != 'constructor') {
	      result.push(key);
	    }
	  }
	  return result;
	}
	
	module.exports = baseKeys;


/***/ },
/* 1206 */
/***/ function(module, exports, __webpack_require__) {

	var baseEach = __webpack_require__(1194),
	    isArrayLike = __webpack_require__(312);
	
	/**
	 * The base implementation of `_.map` without support for iteratee shorthands.
	 *
	 * @private
	 * @param {Array|Object} collection The collection to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Array} Returns the new mapped array.
	 */
	function baseMap(collection, iteratee) {
	  var index = -1,
	      result = isArrayLike(collection) ? Array(collection.length) : [];
	
	  baseEach(collection, function(value, key, collection) {
	    result[++index] = iteratee(value, key, collection);
	  });
	  return result;
	}
	
	module.exports = baseMap;


/***/ },
/* 1207 */
/***/ function(module, exports, __webpack_require__) {

	var baseIsMatch = __webpack_require__(1201),
	    getMatchData = __webpack_require__(1224),
	    matchesStrictComparable = __webpack_require__(492);
	
	/**
	 * The base implementation of `_.matches` which doesn't clone `source`.
	 *
	 * @private
	 * @param {Object} source The object of property values to match.
	 * @returns {Function} Returns the new spec function.
	 */
	function baseMatches(source) {
	  var matchData = getMatchData(source);
	  if (matchData.length == 1 && matchData[0][2]) {
	    return matchesStrictComparable(matchData[0][0], matchData[0][1]);
	  }
	  return function(object) {
	    return object === source || baseIsMatch(object, source, matchData);
	  };
	}
	
	module.exports = baseMatches;


/***/ },
/* 1208 */
/***/ function(module, exports, __webpack_require__) {

	var baseIsEqual = __webpack_require__(485),
	    get = __webpack_require__(497),
	    hasIn = __webpack_require__(1263),
	    isKey = __webpack_require__(311),
	    isStrictComparable = __webpack_require__(491),
	    matchesStrictComparable = __webpack_require__(492),
	    toKey = __webpack_require__(206);
	
	/** Used to compose bitmasks for value comparisons. */
	var COMPARE_PARTIAL_FLAG = 1,
	    COMPARE_UNORDERED_FLAG = 2;
	
	/**
	 * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
	 *
	 * @private
	 * @param {string} path The path of the property to get.
	 * @param {*} srcValue The value to match.
	 * @returns {Function} Returns the new spec function.
	 */
	function baseMatchesProperty(path, srcValue) {
	  if (isKey(path) && isStrictComparable(srcValue)) {
	    return matchesStrictComparable(toKey(path), srcValue);
	  }
	  return function(object) {
	    var objValue = get(object, path);
	    return (objValue === undefined && objValue === srcValue)
	      ? hasIn(object, path)
	      : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
	  };
	}
	
	module.exports = baseMatchesProperty;


/***/ },
/* 1209 */
/***/ function(module, exports, __webpack_require__) {

	var arrayMap = __webpack_require__(483),
	    baseIteratee = __webpack_require__(1204),
	    baseMap = __webpack_require__(1206),
	    baseSortBy = __webpack_require__(1212),
	    baseUnary = __webpack_require__(486),
	    compareMultiple = __webpack_require__(1217),
	    identity = __webpack_require__(498);
	
	/**
	 * The base implementation of `_.orderBy` without param guards.
	 *
	 * @private
	 * @param {Array|Object} collection The collection to iterate over.
	 * @param {Function[]|Object[]|string[]} iteratees The iteratees to sort by.
	 * @param {string[]} orders The sort orders of `iteratees`.
	 * @returns {Array} Returns the new sorted array.
	 */
	function baseOrderBy(collection, iteratees, orders) {
	  var index = -1;
	  iteratees = arrayMap(iteratees.length ? iteratees : [identity], baseUnary(baseIteratee));
	
	  var result = baseMap(collection, function(value, key, collection) {
	    var criteria = arrayMap(iteratees, function(iteratee) {
	      return iteratee(value);
	    });
	    return { 'criteria': criteria, 'index': ++index, 'value': value };
	  });
	
	  return baseSortBy(result, function(object, other) {
	    return compareMultiple(object, other, orders);
	  });
	}
	
	module.exports = baseOrderBy;


/***/ },
/* 1210 */
/***/ function(module, exports) {

	/**
	 * The base implementation of `_.property` without support for deep paths.
	 *
	 * @private
	 * @param {string} key The key of the property to get.
	 * @returns {Function} Returns the new accessor function.
	 */
	function baseProperty(key) {
	  return function(object) {
	    return object == null ? undefined : object[key];
	  };
	}
	
	module.exports = baseProperty;


/***/ },
/* 1211 */
/***/ function(module, exports, __webpack_require__) {

	var baseGet = __webpack_require__(484);
	
	/**
	 * A specialized version of `baseProperty` which supports deep paths.
	 *
	 * @private
	 * @param {Array|string} path The path of the property to get.
	 * @returns {Function} Returns the new accessor function.
	 */
	function basePropertyDeep(path) {
	  return function(object) {
	    return baseGet(object, path);
	  };
	}
	
	module.exports = basePropertyDeep;


/***/ },
/* 1212 */
/***/ function(module, exports) {

	/**
	 * The base implementation of `_.sortBy` which uses `comparer` to define the
	 * sort order of `array` and replaces criteria objects with their corresponding
	 * values.
	 *
	 * @private
	 * @param {Array} array The array to sort.
	 * @param {Function} comparer The function to define sort order.
	 * @returns {Array} Returns `array`.
	 */
	function baseSortBy(array, comparer) {
	  var length = array.length;
	
	  array.sort(comparer);
	  while (length--) {
	    array[length] = array[length].value;
	  }
	  return array;
	}
	
	module.exports = baseSortBy;


/***/ },
/* 1213 */
/***/ function(module, exports) {

	/**
	 * The base implementation of `_.times` without support for iteratee shorthands
	 * or max array length checks.
	 *
	 * @private
	 * @param {number} n The number of times to invoke `iteratee`.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Array} Returns the array of results.
	 */
	function baseTimes(n, iteratee) {
	  var index = -1,
	      result = Array(n);
	
	  while (++index < n) {
	    result[index] = iteratee(index);
	  }
	  return result;
	}
	
	module.exports = baseTimes;


/***/ },
/* 1214 */
/***/ function(module, exports, __webpack_require__) {

	var Symbol = __webpack_require__(202),
	    arrayMap = __webpack_require__(483),
	    isArray = __webpack_require__(76),
	    isSymbol = __webpack_require__(152);
	
	/** Used as references for various `Number` constants. */
	var INFINITY = 1 / 0;
	
	/** Used to convert symbols to primitives and strings. */
	var symbolProto = Symbol ? Symbol.prototype : undefined,
	    symbolToString = symbolProto ? symbolProto.toString : undefined;
	
	/**
	 * The base implementation of `_.toString` which doesn't convert nullish
	 * values to empty strings.
	 *
	 * @private
	 * @param {*} value The value to process.
	 * @returns {string} Returns the string.
	 */
	function baseToString(value) {
	  // Exit early for strings to avoid a performance hit in some environments.
	  if (typeof value == 'string') {
	    return value;
	  }
	  if (isArray(value)) {
	    // Recursively convert values (susceptible to call stack limits).
	    return arrayMap(value, baseToString) + '';
	  }
	  if (isSymbol(value)) {
	    return symbolToString ? symbolToString.call(value) : '';
	  }
	  var result = (value + '');
	  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
	}
	
	module.exports = baseToString;


/***/ },
/* 1215 */
/***/ function(module, exports) {

	/**
	 * Checks if a `cache` value for `key` exists.
	 *
	 * @private
	 * @param {Object} cache The cache to query.
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function cacheHas(cache, key) {
	  return cache.has(key);
	}
	
	module.exports = cacheHas;


/***/ },
/* 1216 */
/***/ function(module, exports, __webpack_require__) {

	var isSymbol = __webpack_require__(152);
	
	/**
	 * Compares values to sort them in ascending order.
	 *
	 * @private
	 * @param {*} value The value to compare.
	 * @param {*} other The other value to compare.
	 * @returns {number} Returns the sort order indicator for `value`.
	 */
	function compareAscending(value, other) {
	  if (value !== other) {
	    var valIsDefined = value !== undefined,
	        valIsNull = value === null,
	        valIsReflexive = value === value,
	        valIsSymbol = isSymbol(value);
	
	    var othIsDefined = other !== undefined,
	        othIsNull = other === null,
	        othIsReflexive = other === other,
	        othIsSymbol = isSymbol(other);
	
	    if ((!othIsNull && !othIsSymbol && !valIsSymbol && value > other) ||
	        (valIsSymbol && othIsDefined && othIsReflexive && !othIsNull && !othIsSymbol) ||
	        (valIsNull && othIsDefined && othIsReflexive) ||
	        (!valIsDefined && othIsReflexive) ||
	        !valIsReflexive) {
	      return 1;
	    }
	    if ((!valIsNull && !valIsSymbol && !othIsSymbol && value < other) ||
	        (othIsSymbol && valIsDefined && valIsReflexive && !valIsNull && !valIsSymbol) ||
	        (othIsNull && valIsDefined && valIsReflexive) ||
	        (!othIsDefined && valIsReflexive) ||
	        !othIsReflexive) {
	      return -1;
	    }
	  }
	  return 0;
	}
	
	module.exports = compareAscending;


/***/ },
/* 1217 */
/***/ function(module, exports, __webpack_require__) {

	var compareAscending = __webpack_require__(1216);
	
	/**
	 * Used by `_.orderBy` to compare multiple properties of a value to another
	 * and stable sort them.
	 *
	 * If `orders` is unspecified, all values are sorted in ascending order. Otherwise,
	 * specify an order of "desc" for descending or "asc" for ascending sort order
	 * of corresponding values.
	 *
	 * @private
	 * @param {Object} object The object to compare.
	 * @param {Object} other The other object to compare.
	 * @param {boolean[]|string[]} orders The order to sort by for each property.
	 * @returns {number} Returns the sort order indicator for `object`.
	 */
	function compareMultiple(object, other, orders) {
	  var index = -1,
	      objCriteria = object.criteria,
	      othCriteria = other.criteria,
	      length = objCriteria.length,
	      ordersLength = orders.length;
	
	  while (++index < length) {
	    var result = compareAscending(objCriteria[index], othCriteria[index]);
	    if (result) {
	      if (index >= ordersLength) {
	        return result;
	      }
	      var order = orders[index];
	      return result * (order == 'desc' ? -1 : 1);
	    }
	  }
	  // Fixes an `Array#sort` bug in the JS engine embedded in Adobe applications
	  // that causes it, under certain circumstances, to provide the same value for
	  // `object` and `other`. See https://github.com/jashkenas/underscore/pull/1247
	  // for more details.
	  //
	  // This also ensures a stable sort in V8 and other engines.
	  // See https://bugs.chromium.org/p/v8/issues/detail?id=90 for more details.
	  return object.index - other.index;
	}
	
	module.exports = compareMultiple;


/***/ },
/* 1218 */
/***/ function(module, exports, __webpack_require__) {

	var root = __webpack_require__(69);
	
	/** Used to detect overreaching core-js shims. */
	var coreJsData = root['__core-js_shared__'];
	
	module.exports = coreJsData;


/***/ },
/* 1219 */
/***/ function(module, exports, __webpack_require__) {

	var isArrayLike = __webpack_require__(312);
	
	/**
	 * Creates a `baseEach` or `baseEachRight` function.
	 *
	 * @private
	 * @param {Function} eachFunc The function to iterate over a collection.
	 * @param {boolean} [fromRight] Specify iterating from right to left.
	 * @returns {Function} Returns the new base function.
	 */
	function createBaseEach(eachFunc, fromRight) {
	  return function(collection, iteratee) {
	    if (collection == null) {
	      return collection;
	    }
	    if (!isArrayLike(collection)) {
	      return eachFunc(collection, iteratee);
	    }
	    var length = collection.length,
	        index = fromRight ? length : -1,
	        iterable = Object(collection);
	
	    while ((fromRight ? index-- : ++index < length)) {
	      if (iteratee(iterable[index], index, iterable) === false) {
	        break;
	      }
	    }
	    return collection;
	  };
	}
	
	module.exports = createBaseEach;


/***/ },
/* 1220 */
/***/ function(module, exports) {

	/**
	 * Creates a base function for methods like `_.forIn` and `_.forOwn`.
	 *
	 * @private
	 * @param {boolean} [fromRight] Specify iterating from right to left.
	 * @returns {Function} Returns the new base function.
	 */
	function createBaseFor(fromRight) {
	  return function(object, iteratee, keysFunc) {
	    var index = -1,
	        iterable = Object(object),
	        props = keysFunc(object),
	        length = props.length;
	
	    while (length--) {
	      var key = props[fromRight ? length : ++index];
	      if (iteratee(iterable[key], key, iterable) === false) {
	        break;
	      }
	    }
	    return object;
	  };
	}
	
	module.exports = createBaseFor;


/***/ },
/* 1221 */
/***/ function(module, exports, __webpack_require__) {

	var Symbol = __webpack_require__(202),
	    Uint8Array = __webpack_require__(1188),
	    eq = __webpack_require__(496),
	    equalArrays = __webpack_require__(488),
	    mapToArray = __webpack_require__(1249),
	    setToArray = __webpack_require__(1256);
	
	/** Used to compose bitmasks for value comparisons. */
	var COMPARE_PARTIAL_FLAG = 1,
	    COMPARE_UNORDERED_FLAG = 2;
	
	/** `Object#toString` result references. */
	var boolTag = '[object Boolean]',
	    dateTag = '[object Date]',
	    errorTag = '[object Error]',
	    mapTag = '[object Map]',
	    numberTag = '[object Number]',
	    regexpTag = '[object RegExp]',
	    setTag = '[object Set]',
	    stringTag = '[object String]',
	    symbolTag = '[object Symbol]';
	
	var arrayBufferTag = '[object ArrayBuffer]',
	    dataViewTag = '[object DataView]';
	
	/** Used to convert symbols to primitives and strings. */
	var symbolProto = Symbol ? Symbol.prototype : undefined,
	    symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;
	
	/**
	 * A specialized version of `baseIsEqualDeep` for comparing objects of
	 * the same `toStringTag`.
	 *
	 * **Note:** This function only supports comparing values with tags of
	 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
	 *
	 * @private
	 * @param {Object} object The object to compare.
	 * @param {Object} other The other object to compare.
	 * @param {string} tag The `toStringTag` of the objects to compare.
	 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	 * @param {Function} customizer The function to customize comparisons.
	 * @param {Function} equalFunc The function to determine equivalents of values.
	 * @param {Object} stack Tracks traversed `object` and `other` objects.
	 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	 */
	function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
	  switch (tag) {
	    case dataViewTag:
	      if ((object.byteLength != other.byteLength) ||
	          (object.byteOffset != other.byteOffset)) {
	        return false;
	      }
	      object = object.buffer;
	      other = other.buffer;
	
	    case arrayBufferTag:
	      if ((object.byteLength != other.byteLength) ||
	          !equalFunc(new Uint8Array(object), new Uint8Array(other))) {
	        return false;
	      }
	      return true;
	
	    case boolTag:
	    case dateTag:
	    case numberTag:
	      // Coerce booleans to `1` or `0` and dates to milliseconds.
	      // Invalid dates are coerced to `NaN`.
	      return eq(+object, +other);
	
	    case errorTag:
	      return object.name == other.name && object.message == other.message;
	
	    case regexpTag:
	    case stringTag:
	      // Coerce regexes to strings and treat strings, primitives and objects,
	      // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
	      // for more details.
	      return object == (other + '');
	
	    case mapTag:
	      var convert = mapToArray;
	
	    case setTag:
	      var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
	      convert || (convert = setToArray);
	
	      if (object.size != other.size && !isPartial) {
	        return false;
	      }
	      // Assume cyclic values are equal.
	      var stacked = stack.get(object);
	      if (stacked) {
	        return stacked == other;
	      }
	      bitmask |= COMPARE_UNORDERED_FLAG;
	
	      // Recursively compare objects (susceptible to call stack limits).
	      stack.set(object, other);
	      var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
	      stack['delete'](object);
	      return result;
	
	    case symbolTag:
	      if (symbolValueOf) {
	        return symbolValueOf.call(object) == symbolValueOf.call(other);
	      }
	  }
	  return false;
	}
	
	module.exports = equalByTag;


/***/ },
/* 1222 */
/***/ function(module, exports, __webpack_require__) {

	var getAllKeys = __webpack_require__(1223);
	
	/** Used to compose bitmasks for value comparisons. */
	var COMPARE_PARTIAL_FLAG = 1;
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * A specialized version of `baseIsEqualDeep` for objects with support for
	 * partial deep comparisons.
	 *
	 * @private
	 * @param {Object} object The object to compare.
	 * @param {Object} other The other object to compare.
	 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	 * @param {Function} customizer The function to customize comparisons.
	 * @param {Function} equalFunc The function to determine equivalents of values.
	 * @param {Object} stack Tracks traversed `object` and `other` objects.
	 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	 */
	function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
	  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
	      objProps = getAllKeys(object),
	      objLength = objProps.length,
	      othProps = getAllKeys(other),
	      othLength = othProps.length;
	
	  if (objLength != othLength && !isPartial) {
	    return false;
	  }
	  var index = objLength;
	  while (index--) {
	    var key = objProps[index];
	    if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) {
	      return false;
	    }
	  }
	  // Assume cyclic values are equal.
	  var stacked = stack.get(object);
	  if (stacked && stack.get(other)) {
	    return stacked == other;
	  }
	  var result = true;
	  stack.set(object, other);
	  stack.set(other, object);
	
	  var skipCtor = isPartial;
	  while (++index < objLength) {
	    key = objProps[index];
	    var objValue = object[key],
	        othValue = other[key];
	
	    if (customizer) {
	      var compared = isPartial
	        ? customizer(othValue, objValue, key, other, object, stack)
	        : customizer(objValue, othValue, key, object, other, stack);
	    }
	    // Recursively compare objects (susceptible to call stack limits).
	    if (!(compared === undefined
	          ? (objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack))
	          : compared
	        )) {
	      result = false;
	      break;
	    }
	    skipCtor || (skipCtor = key == 'constructor');
	  }
	  if (result && !skipCtor) {
	    var objCtor = object.constructor,
	        othCtor = other.constructor;
	
	    // Non `Object` object instances with different constructors are not equal.
	    if (objCtor != othCtor &&
	        ('constructor' in object && 'constructor' in other) &&
	        !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
	          typeof othCtor == 'function' && othCtor instanceof othCtor)) {
	      result = false;
	    }
	  }
	  stack['delete'](object);
	  stack['delete'](other);
	  return result;
	}
	
	module.exports = equalObjects;


/***/ },
/* 1223 */
/***/ function(module, exports, __webpack_require__) {

	var baseGetAllKeys = __webpack_require__(1197),
	    getSymbols = __webpack_require__(1227),
	    keys = __webpack_require__(314);
	
	/**
	 * Creates an array of own enumerable property names and symbols of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names and symbols.
	 */
	function getAllKeys(object) {
	  return baseGetAllKeys(object, keys, getSymbols);
	}
	
	module.exports = getAllKeys;


/***/ },
/* 1224 */
/***/ function(module, exports, __webpack_require__) {

	var isStrictComparable = __webpack_require__(491),
	    keys = __webpack_require__(314);
	
	/**
	 * Gets the property names, values, and compare flags of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the match data of `object`.
	 */
	function getMatchData(object) {
	  var result = keys(object),
	      length = result.length;
	
	  while (length--) {
	    var key = result[length],
	        value = object[key];
	
	    result[length] = [key, value, isStrictComparable(value)];
	  }
	  return result;
	}
	
	module.exports = getMatchData;


/***/ },
/* 1225 */
/***/ function(module, exports, __webpack_require__) {

	var overArg = __webpack_require__(493);
	
	/** Built-in value references. */
	var getPrototype = overArg(Object.getPrototypeOf, Object);
	
	module.exports = getPrototype;


/***/ },
/* 1226 */
/***/ function(module, exports, __webpack_require__) {

	var Symbol = __webpack_require__(202);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var nativeObjectToString = objectProto.toString;
	
	/** Built-in value references. */
	var symToStringTag = Symbol ? Symbol.toStringTag : undefined;
	
	/**
	 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @returns {string} Returns the raw `toStringTag`.
	 */
	function getRawTag(value) {
	  var isOwn = hasOwnProperty.call(value, symToStringTag),
	      tag = value[symToStringTag];
	
	  try {
	    value[symToStringTag] = undefined;
	    var unmasked = true;
	  } catch (e) {}
	
	  var result = nativeObjectToString.call(value);
	  if (unmasked) {
	    if (isOwn) {
	      value[symToStringTag] = tag;
	    } else {
	      delete value[symToStringTag];
	    }
	  }
	  return result;
	}
	
	module.exports = getRawTag;


/***/ },
/* 1227 */
/***/ function(module, exports, __webpack_require__) {

	var arrayFilter = __webpack_require__(1190),
	    stubArray = __webpack_require__(1268);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Built-in value references. */
	var propertyIsEnumerable = objectProto.propertyIsEnumerable;
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeGetSymbols = Object.getOwnPropertySymbols;
	
	/**
	 * Creates an array of the own enumerable symbols of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of symbols.
	 */
	var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
	  if (object == null) {
	    return [];
	  }
	  object = Object(object);
	  return arrayFilter(nativeGetSymbols(object), function(symbol) {
	    return propertyIsEnumerable.call(object, symbol);
	  });
	};
	
	module.exports = getSymbols;


/***/ },
/* 1228 */
/***/ function(module, exports, __webpack_require__) {

	var DataView = __webpack_require__(1183),
	    Map = __webpack_require__(309),
	    Promise = __webpack_require__(1185),
	    Set = __webpack_require__(1186),
	    WeakMap = __webpack_require__(1189),
	    baseGetTag = __webpack_require__(121),
	    toSource = __webpack_require__(494);
	
	/** `Object#toString` result references. */
	var mapTag = '[object Map]',
	    objectTag = '[object Object]',
	    promiseTag = '[object Promise]',
	    setTag = '[object Set]',
	    weakMapTag = '[object WeakMap]';
	
	var dataViewTag = '[object DataView]';
	
	/** Used to detect maps, sets, and weakmaps. */
	var dataViewCtorString = toSource(DataView),
	    mapCtorString = toSource(Map),
	    promiseCtorString = toSource(Promise),
	    setCtorString = toSource(Set),
	    weakMapCtorString = toSource(WeakMap);
	
	/**
	 * Gets the `toStringTag` of `value`.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @returns {string} Returns the `toStringTag`.
	 */
	var getTag = baseGetTag;
	
	// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
	if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
	    (Map && getTag(new Map) != mapTag) ||
	    (Promise && getTag(Promise.resolve()) != promiseTag) ||
	    (Set && getTag(new Set) != setTag) ||
	    (WeakMap && getTag(new WeakMap) != weakMapTag)) {
	  getTag = function(value) {
	    var result = baseGetTag(value),
	        Ctor = result == objectTag ? value.constructor : undefined,
	        ctorString = Ctor ? toSource(Ctor) : '';
	
	    if (ctorString) {
	      switch (ctorString) {
	        case dataViewCtorString: return dataViewTag;
	        case mapCtorString: return mapTag;
	        case promiseCtorString: return promiseTag;
	        case setCtorString: return setTag;
	        case weakMapCtorString: return weakMapTag;
	      }
	    }
	    return result;
	  };
	}
	
	module.exports = getTag;


/***/ },
/* 1229 */
/***/ function(module, exports) {

	/**
	 * Gets the value at `key` of `object`.
	 *
	 * @private
	 * @param {Object} [object] The object to query.
	 * @param {string} key The key of the property to get.
	 * @returns {*} Returns the property value.
	 */
	function getValue(object, key) {
	  return object == null ? undefined : object[key];
	}
	
	module.exports = getValue;


/***/ },
/* 1230 */
/***/ function(module, exports, __webpack_require__) {

	var castPath = __webpack_require__(487),
	    isArguments = __webpack_require__(499),
	    isArray = __webpack_require__(76),
	    isIndex = __webpack_require__(490),
	    isLength = __webpack_require__(313),
	    toKey = __webpack_require__(206);
	
	/**
	 * Checks if `path` exists on `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {Array|string} path The path to check.
	 * @param {Function} hasFunc The function to check properties.
	 * @returns {boolean} Returns `true` if `path` exists, else `false`.
	 */
	function hasPath(object, path, hasFunc) {
	  path = castPath(path, object);
	
	  var index = -1,
	      length = path.length,
	      result = false;
	
	  while (++index < length) {
	    var key = toKey(path[index]);
	    if (!(result = object != null && hasFunc(object, key))) {
	      break;
	    }
	    object = object[key];
	  }
	  if (result || ++index != length) {
	    return result;
	  }
	  length = object == null ? 0 : object.length;
	  return !!length && isLength(length) && isIndex(key, length) &&
	    (isArray(object) || isArguments(object));
	}
	
	module.exports = hasPath;


/***/ },
/* 1231 */
/***/ function(module, exports, __webpack_require__) {

	var nativeCreate = __webpack_require__(205);
	
	/**
	 * Removes all key-value entries from the hash.
	 *
	 * @private
	 * @name clear
	 * @memberOf Hash
	 */
	function hashClear() {
	  this.__data__ = nativeCreate ? nativeCreate(null) : {};
	  this.size = 0;
	}
	
	module.exports = hashClear;


/***/ },
/* 1232 */
/***/ function(module, exports) {

	/**
	 * Removes `key` and its value from the hash.
	 *
	 * @private
	 * @name delete
	 * @memberOf Hash
	 * @param {Object} hash The hash to modify.
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function hashDelete(key) {
	  var result = this.has(key) && delete this.__data__[key];
	  this.size -= result ? 1 : 0;
	  return result;
	}
	
	module.exports = hashDelete;


/***/ },
/* 1233 */
/***/ function(module, exports, __webpack_require__) {

	var nativeCreate = __webpack_require__(205);
	
	/** Used to stand-in for `undefined` hash values. */
	var HASH_UNDEFINED = '__lodash_hash_undefined__';
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Gets the hash value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf Hash
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function hashGet(key) {
	  var data = this.__data__;
	  if (nativeCreate) {
	    var result = data[key];
	    return result === HASH_UNDEFINED ? undefined : result;
	  }
	  return hasOwnProperty.call(data, key) ? data[key] : undefined;
	}
	
	module.exports = hashGet;


/***/ },
/* 1234 */
/***/ function(module, exports, __webpack_require__) {

	var nativeCreate = __webpack_require__(205);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Checks if a hash value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf Hash
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function hashHas(key) {
	  var data = this.__data__;
	  return nativeCreate ? (data[key] !== undefined) : hasOwnProperty.call(data, key);
	}
	
	module.exports = hashHas;


/***/ },
/* 1235 */
/***/ function(module, exports, __webpack_require__) {

	var nativeCreate = __webpack_require__(205);
	
	/** Used to stand-in for `undefined` hash values. */
	var HASH_UNDEFINED = '__lodash_hash_undefined__';
	
	/**
	 * Sets the hash `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf Hash
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the hash instance.
	 */
	function hashSet(key, value) {
	  var data = this.__data__;
	  this.size += this.has(key) ? 0 : 1;
	  data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
	  return this;
	}
	
	module.exports = hashSet;


/***/ },
/* 1236 */
/***/ function(module, exports) {

	/**
	 * Checks if `value` is suitable for use as unique object key.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
	 */
	function isKeyable(value) {
	  var type = typeof value;
	  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
	    ? (value !== '__proto__')
	    : (value === null);
	}
	
	module.exports = isKeyable;


/***/ },
/* 1237 */
/***/ function(module, exports, __webpack_require__) {

	var coreJsData = __webpack_require__(1218);
	
	/** Used to detect methods masquerading as native. */
	var maskSrcKey = (function() {
	  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
	  return uid ? ('Symbol(src)_1.' + uid) : '';
	}());
	
	/**
	 * Checks if `func` has its source masked.
	 *
	 * @private
	 * @param {Function} func The function to check.
	 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
	 */
	function isMasked(func) {
	  return !!maskSrcKey && (maskSrcKey in func);
	}
	
	module.exports = isMasked;


/***/ },
/* 1238 */
/***/ function(module, exports) {

	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/**
	 * Checks if `value` is likely a prototype object.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
	 */
	function isPrototype(value) {
	  var Ctor = value && value.constructor,
	      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;
	
	  return value === proto;
	}
	
	module.exports = isPrototype;


/***/ },
/* 1239 */
/***/ function(module, exports) {

	/**
	 * Removes all key-value entries from the list cache.
	 *
	 * @private
	 * @name clear
	 * @memberOf ListCache
	 */
	function listCacheClear() {
	  this.__data__ = [];
	  this.size = 0;
	}
	
	module.exports = listCacheClear;


/***/ },
/* 1240 */
/***/ function(module, exports, __webpack_require__) {

	var assocIndexOf = __webpack_require__(203);
	
	/** Used for built-in method references. */
	var arrayProto = Array.prototype;
	
	/** Built-in value references. */
	var splice = arrayProto.splice;
	
	/**
	 * Removes `key` and its value from the list cache.
	 *
	 * @private
	 * @name delete
	 * @memberOf ListCache
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function listCacheDelete(key) {
	  var data = this.__data__,
	      index = assocIndexOf(data, key);
	
	  if (index < 0) {
	    return false;
	  }
	  var lastIndex = data.length - 1;
	  if (index == lastIndex) {
	    data.pop();
	  } else {
	    splice.call(data, index, 1);
	  }
	  --this.size;
	  return true;
	}
	
	module.exports = listCacheDelete;


/***/ },
/* 1241 */
/***/ function(module, exports, __webpack_require__) {

	var assocIndexOf = __webpack_require__(203);
	
	/**
	 * Gets the list cache value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf ListCache
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function listCacheGet(key) {
	  var data = this.__data__,
	      index = assocIndexOf(data, key);
	
	  return index < 0 ? undefined : data[index][1];
	}
	
	module.exports = listCacheGet;


/***/ },
/* 1242 */
/***/ function(module, exports, __webpack_require__) {

	var assocIndexOf = __webpack_require__(203);
	
	/**
	 * Checks if a list cache value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf ListCache
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function listCacheHas(key) {
	  return assocIndexOf(this.__data__, key) > -1;
	}
	
	module.exports = listCacheHas;


/***/ },
/* 1243 */
/***/ function(module, exports, __webpack_require__) {

	var assocIndexOf = __webpack_require__(203);
	
	/**
	 * Sets the list cache `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf ListCache
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the list cache instance.
	 */
	function listCacheSet(key, value) {
	  var data = this.__data__,
	      index = assocIndexOf(data, key);
	
	  if (index < 0) {
	    ++this.size;
	    data.push([key, value]);
	  } else {
	    data[index][1] = value;
	  }
	  return this;
	}
	
	module.exports = listCacheSet;


/***/ },
/* 1244 */
/***/ function(module, exports, __webpack_require__) {

	var Hash = __webpack_require__(1184),
	    ListCache = __webpack_require__(201),
	    Map = __webpack_require__(309);
	
	/**
	 * Removes all key-value entries from the map.
	 *
	 * @private
	 * @name clear
	 * @memberOf MapCache
	 */
	function mapCacheClear() {
	  this.size = 0;
	  this.__data__ = {
	    'hash': new Hash,
	    'map': new (Map || ListCache),
	    'string': new Hash
	  };
	}
	
	module.exports = mapCacheClear;


/***/ },
/* 1245 */
/***/ function(module, exports, __webpack_require__) {

	var getMapData = __webpack_require__(204);
	
	/**
	 * Removes `key` and its value from the map.
	 *
	 * @private
	 * @name delete
	 * @memberOf MapCache
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function mapCacheDelete(key) {
	  var result = getMapData(this, key)['delete'](key);
	  this.size -= result ? 1 : 0;
	  return result;
	}
	
	module.exports = mapCacheDelete;


/***/ },
/* 1246 */
/***/ function(module, exports, __webpack_require__) {

	var getMapData = __webpack_require__(204);
	
	/**
	 * Gets the map value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf MapCache
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function mapCacheGet(key) {
	  return getMapData(this, key).get(key);
	}
	
	module.exports = mapCacheGet;


/***/ },
/* 1247 */
/***/ function(module, exports, __webpack_require__) {

	var getMapData = __webpack_require__(204);
	
	/**
	 * Checks if a map value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf MapCache
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function mapCacheHas(key) {
	  return getMapData(this, key).has(key);
	}
	
	module.exports = mapCacheHas;


/***/ },
/* 1248 */
/***/ function(module, exports, __webpack_require__) {

	var getMapData = __webpack_require__(204);
	
	/**
	 * Sets the map `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf MapCache
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the map cache instance.
	 */
	function mapCacheSet(key, value) {
	  var data = getMapData(this, key),
	      size = data.size;
	
	  data.set(key, value);
	  this.size += data.size == size ? 0 : 1;
	  return this;
	}
	
	module.exports = mapCacheSet;


/***/ },
/* 1249 */
/***/ function(module, exports) {

	/**
	 * Converts `map` to its key-value pairs.
	 *
	 * @private
	 * @param {Object} map The map to convert.
	 * @returns {Array} Returns the key-value pairs.
	 */
	function mapToArray(map) {
	  var index = -1,
	      result = Array(map.size);
	
	  map.forEach(function(value, key) {
	    result[++index] = [key, value];
	  });
	  return result;
	}
	
	module.exports = mapToArray;


/***/ },
/* 1250 */
/***/ function(module, exports, __webpack_require__) {

	var memoize = __webpack_require__(1265);
	
	/** Used as the maximum memoize cache size. */
	var MAX_MEMOIZE_SIZE = 500;
	
	/**
	 * A specialized version of `_.memoize` which clears the memoized function's
	 * cache when it exceeds `MAX_MEMOIZE_SIZE`.
	 *
	 * @private
	 * @param {Function} func The function to have its output memoized.
	 * @returns {Function} Returns the new memoized function.
	 */
	function memoizeCapped(func) {
	  var result = memoize(func, function(key) {
	    if (cache.size === MAX_MEMOIZE_SIZE) {
	      cache.clear();
	    }
	    return key;
	  });
	
	  var cache = result.cache;
	  return result;
	}
	
	module.exports = memoizeCapped;


/***/ },
/* 1251 */
/***/ function(module, exports, __webpack_require__) {

	var overArg = __webpack_require__(493);
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeKeys = overArg(Object.keys, Object);
	
	module.exports = nativeKeys;


/***/ },
/* 1252 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var freeGlobal = __webpack_require__(489);
	
	/** Detect free variable `exports`. */
	var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;
	
	/** Detect free variable `module`. */
	var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;
	
	/** Detect the popular CommonJS extension `module.exports`. */
	var moduleExports = freeModule && freeModule.exports === freeExports;
	
	/** Detect free variable `process` from Node.js. */
	var freeProcess = moduleExports && freeGlobal.process;
	
	/** Used to access faster Node.js helpers. */
	var nodeUtil = (function() {
	  try {
	    // Use `util.types` for Node.js 10+.
	    var types = freeModule && freeModule.require && freeModule.require('util').types;
	
	    if (types) {
	      return types;
	    }
	
	    // Legacy `process.binding('util')` for Node.js < 10.
	    return freeProcess && freeProcess.binding && freeProcess.binding('util');
	  } catch (e) {}
	}());
	
	module.exports = nodeUtil;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(154)(module)))

/***/ },
/* 1253 */
/***/ function(module, exports) {

	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var nativeObjectToString = objectProto.toString;
	
	/**
	 * Converts `value` to a string using `Object.prototype.toString`.
	 *
	 * @private
	 * @param {*} value The value to convert.
	 * @returns {string} Returns the converted string.
	 */
	function objectToString(value) {
	  return nativeObjectToString.call(value);
	}
	
	module.exports = objectToString;


/***/ },
/* 1254 */
/***/ function(module, exports) {

	/** Used to stand-in for `undefined` hash values. */
	var HASH_UNDEFINED = '__lodash_hash_undefined__';
	
	/**
	 * Adds `value` to the array cache.
	 *
	 * @private
	 * @name add
	 * @memberOf SetCache
	 * @alias push
	 * @param {*} value The value to cache.
	 * @returns {Object} Returns the cache instance.
	 */
	function setCacheAdd(value) {
	  this.__data__.set(value, HASH_UNDEFINED);
	  return this;
	}
	
	module.exports = setCacheAdd;


/***/ },
/* 1255 */
/***/ function(module, exports) {

	/**
	 * Checks if `value` is in the array cache.
	 *
	 * @private
	 * @name has
	 * @memberOf SetCache
	 * @param {*} value The value to search for.
	 * @returns {number} Returns `true` if `value` is found, else `false`.
	 */
	function setCacheHas(value) {
	  return this.__data__.has(value);
	}
	
	module.exports = setCacheHas;


/***/ },
/* 1256 */
/***/ function(module, exports) {

	/**
	 * Converts `set` to an array of its values.
	 *
	 * @private
	 * @param {Object} set The set to convert.
	 * @returns {Array} Returns the values.
	 */
	function setToArray(set) {
	  var index = -1,
	      result = Array(set.size);
	
	  set.forEach(function(value) {
	    result[++index] = value;
	  });
	  return result;
	}
	
	module.exports = setToArray;


/***/ },
/* 1257 */
/***/ function(module, exports, __webpack_require__) {

	var ListCache = __webpack_require__(201);
	
	/**
	 * Removes all key-value entries from the stack.
	 *
	 * @private
	 * @name clear
	 * @memberOf Stack
	 */
	function stackClear() {
	  this.__data__ = new ListCache;
	  this.size = 0;
	}
	
	module.exports = stackClear;


/***/ },
/* 1258 */
/***/ function(module, exports) {

	/**
	 * Removes `key` and its value from the stack.
	 *
	 * @private
	 * @name delete
	 * @memberOf Stack
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function stackDelete(key) {
	  var data = this.__data__,
	      result = data['delete'](key);
	
	  this.size = data.size;
	  return result;
	}
	
	module.exports = stackDelete;


/***/ },
/* 1259 */
/***/ function(module, exports) {

	/**
	 * Gets the stack value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf Stack
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function stackGet(key) {
	  return this.__data__.get(key);
	}
	
	module.exports = stackGet;


/***/ },
/* 1260 */
/***/ function(module, exports) {

	/**
	 * Checks if a stack value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf Stack
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function stackHas(key) {
	  return this.__data__.has(key);
	}
	
	module.exports = stackHas;


/***/ },
/* 1261 */
/***/ function(module, exports, __webpack_require__) {

	var ListCache = __webpack_require__(201),
	    Map = __webpack_require__(309),
	    MapCache = __webpack_require__(310);
	
	/** Used as the size to enable large array optimizations. */
	var LARGE_ARRAY_SIZE = 200;
	
	/**
	 * Sets the stack `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf Stack
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the stack cache instance.
	 */
	function stackSet(key, value) {
	  var data = this.__data__;
	  if (data instanceof ListCache) {
	    var pairs = data.__data__;
	    if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
	      pairs.push([key, value]);
	      this.size = ++data.size;
	      return this;
	    }
	    data = this.__data__ = new MapCache(pairs);
	  }
	  data.set(key, value);
	  this.size = data.size;
	  return this;
	}
	
	module.exports = stackSet;


/***/ },
/* 1262 */
/***/ function(module, exports, __webpack_require__) {

	var memoizeCapped = __webpack_require__(1250);
	
	/** Used to match property names within property paths. */
	var rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
	
	/** Used to match backslashes in property paths. */
	var reEscapeChar = /\\(\\)?/g;
	
	/**
	 * Converts `string` to a property path array.
	 *
	 * @private
	 * @param {string} string The string to convert.
	 * @returns {Array} Returns the property path array.
	 */
	var stringToPath = memoizeCapped(function(string) {
	  var result = [];
	  if (string.charCodeAt(0) === 46 /* . */) {
	    result.push('');
	  }
	  string.replace(rePropName, function(match, number, quote, subString) {
	    result.push(quote ? subString.replace(reEscapeChar, '$1') : (number || match));
	  });
	  return result;
	});
	
	module.exports = stringToPath;


/***/ },
/* 1263 */
/***/ function(module, exports, __webpack_require__) {

	var baseHasIn = __webpack_require__(1198),
	    hasPath = __webpack_require__(1230);
	
	/**
	 * Checks if `path` is a direct or inherited property of `object`.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Object
	 * @param {Object} object The object to query.
	 * @param {Array|string} path The path to check.
	 * @returns {boolean} Returns `true` if `path` exists, else `false`.
	 * @example
	 *
	 * var object = _.create({ 'a': _.create({ 'b': 2 }) });
	 *
	 * _.hasIn(object, 'a');
	 * // => true
	 *
	 * _.hasIn(object, 'a.b');
	 * // => true
	 *
	 * _.hasIn(object, ['a', 'b']);
	 * // => true
	 *
	 * _.hasIn(object, 'b');
	 * // => false
	 */
	function hasIn(object, path) {
	  return object != null && hasPath(object, path, baseHasIn);
	}
	
	module.exports = hasIn;


/***/ },
/* 1264 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(global, module) {/**
	 * @license
	 * Lodash <https://lodash.com/>
	 * Copyright OpenJS Foundation and other contributors <https://openjsf.org/>
	 * Released under MIT license <https://lodash.com/license>
	 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
	 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
	 */
	;(function() {
	
	  /** Used as a safe reference for `undefined` in pre-ES5 environments. */
	  var undefined;
	
	  /** Used as the semantic version number. */
	  var VERSION = '4.17.15';
	
	  /** Used as the size to enable large array optimizations. */
	  var LARGE_ARRAY_SIZE = 200;
	
	  /** Error message constants. */
	  var CORE_ERROR_TEXT = 'Unsupported core-js use. Try https://npms.io/search?q=ponyfill.',
	      FUNC_ERROR_TEXT = 'Expected a function';
	
	  /** Used to stand-in for `undefined` hash values. */
	  var HASH_UNDEFINED = '__lodash_hash_undefined__';
	
	  /** Used as the maximum memoize cache size. */
	  var MAX_MEMOIZE_SIZE = 500;
	
	  /** Used as the internal argument placeholder. */
	  var PLACEHOLDER = '__lodash_placeholder__';
	
	  /** Used to compose bitmasks for cloning. */
	  var CLONE_DEEP_FLAG = 1,
	      CLONE_FLAT_FLAG = 2,
	      CLONE_SYMBOLS_FLAG = 4;
	
	  /** Used to compose bitmasks for value comparisons. */
	  var COMPARE_PARTIAL_FLAG = 1,
	      COMPARE_UNORDERED_FLAG = 2;
	
	  /** Used to compose bitmasks for function metadata. */
	  var WRAP_BIND_FLAG = 1,
	      WRAP_BIND_KEY_FLAG = 2,
	      WRAP_CURRY_BOUND_FLAG = 4,
	      WRAP_CURRY_FLAG = 8,
	      WRAP_CURRY_RIGHT_FLAG = 16,
	      WRAP_PARTIAL_FLAG = 32,
	      WRAP_PARTIAL_RIGHT_FLAG = 64,
	      WRAP_ARY_FLAG = 128,
	      WRAP_REARG_FLAG = 256,
	      WRAP_FLIP_FLAG = 512;
	
	  /** Used as default options for `_.truncate`. */
	  var DEFAULT_TRUNC_LENGTH = 30,
	      DEFAULT_TRUNC_OMISSION = '...';
	
	  /** Used to detect hot functions by number of calls within a span of milliseconds. */
	  var HOT_COUNT = 800,
	      HOT_SPAN = 16;
	
	  /** Used to indicate the type of lazy iteratees. */
	  var LAZY_FILTER_FLAG = 1,
	      LAZY_MAP_FLAG = 2,
	      LAZY_WHILE_FLAG = 3;
	
	  /** Used as references for various `Number` constants. */
	  var INFINITY = 1 / 0,
	      MAX_SAFE_INTEGER = 9007199254740991,
	      MAX_INTEGER = 1.7976931348623157e+308,
	      NAN = 0 / 0;
	
	  /** Used as references for the maximum length and index of an array. */
	  var MAX_ARRAY_LENGTH = 4294967295,
	      MAX_ARRAY_INDEX = MAX_ARRAY_LENGTH - 1,
	      HALF_MAX_ARRAY_LENGTH = MAX_ARRAY_LENGTH >>> 1;
	
	  /** Used to associate wrap methods with their bit flags. */
	  var wrapFlags = [
	    ['ary', WRAP_ARY_FLAG],
	    ['bind', WRAP_BIND_FLAG],
	    ['bindKey', WRAP_BIND_KEY_FLAG],
	    ['curry', WRAP_CURRY_FLAG],
	    ['curryRight', WRAP_CURRY_RIGHT_FLAG],
	    ['flip', WRAP_FLIP_FLAG],
	    ['partial', WRAP_PARTIAL_FLAG],
	    ['partialRight', WRAP_PARTIAL_RIGHT_FLAG],
	    ['rearg', WRAP_REARG_FLAG]
	  ];
	
	  /** `Object#toString` result references. */
	  var argsTag = '[object Arguments]',
	      arrayTag = '[object Array]',
	      asyncTag = '[object AsyncFunction]',
	      boolTag = '[object Boolean]',
	      dateTag = '[object Date]',
	      domExcTag = '[object DOMException]',
	      errorTag = '[object Error]',
	      funcTag = '[object Function]',
	      genTag = '[object GeneratorFunction]',
	      mapTag = '[object Map]',
	      numberTag = '[object Number]',
	      nullTag = '[object Null]',
	      objectTag = '[object Object]',
	      promiseTag = '[object Promise]',
	      proxyTag = '[object Proxy]',
	      regexpTag = '[object RegExp]',
	      setTag = '[object Set]',
	      stringTag = '[object String]',
	      symbolTag = '[object Symbol]',
	      undefinedTag = '[object Undefined]',
	      weakMapTag = '[object WeakMap]',
	      weakSetTag = '[object WeakSet]';
	
	  var arrayBufferTag = '[object ArrayBuffer]',
	      dataViewTag = '[object DataView]',
	      float32Tag = '[object Float32Array]',
	      float64Tag = '[object Float64Array]',
	      int8Tag = '[object Int8Array]',
	      int16Tag = '[object Int16Array]',
	      int32Tag = '[object Int32Array]',
	      uint8Tag = '[object Uint8Array]',
	      uint8ClampedTag = '[object Uint8ClampedArray]',
	      uint16Tag = '[object Uint16Array]',
	      uint32Tag = '[object Uint32Array]';
	
	  /** Used to match empty string literals in compiled template source. */
	  var reEmptyStringLeading = /\b__p \+= '';/g,
	      reEmptyStringMiddle = /\b(__p \+=) '' \+/g,
	      reEmptyStringTrailing = /(__e\(.*?\)|\b__t\)) \+\n'';/g;
	
	  /** Used to match HTML entities and HTML characters. */
	  var reEscapedHtml = /&(?:amp|lt|gt|quot|#39);/g,
	      reUnescapedHtml = /[&<>"']/g,
	      reHasEscapedHtml = RegExp(reEscapedHtml.source),
	      reHasUnescapedHtml = RegExp(reUnescapedHtml.source);
	
	  /** Used to match template delimiters. */
	  var reEscape = /<%-([\s\S]+?)%>/g,
	      reEvaluate = /<%([\s\S]+?)%>/g,
	      reInterpolate = /<%=([\s\S]+?)%>/g;
	
	  /** Used to match property names within property paths. */
	  var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
	      reIsPlainProp = /^\w*$/,
	      rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
	
	  /**
	   * Used to match `RegExp`
	   * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
	   */
	  var reRegExpChar = /[\\^$.*+?()[\]{}|]/g,
	      reHasRegExpChar = RegExp(reRegExpChar.source);
	
	  /** Used to match leading and trailing whitespace. */
	  var reTrim = /^\s+|\s+$/g,
	      reTrimStart = /^\s+/,
	      reTrimEnd = /\s+$/;
	
	  /** Used to match wrap detail comments. */
	  var reWrapComment = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/,
	      reWrapDetails = /\{\n\/\* \[wrapped with (.+)\] \*/,
	      reSplitDetails = /,? & /;
	
	  /** Used to match words composed of alphanumeric characters. */
	  var reAsciiWord = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g;
	
	  /** Used to match backslashes in property paths. */
	  var reEscapeChar = /\\(\\)?/g;
	
	  /**
	   * Used to match
	   * [ES template delimiters](http://ecma-international.org/ecma-262/7.0/#sec-template-literal-lexical-components).
	   */
	  var reEsTemplate = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g;
	
	  /** Used to match `RegExp` flags from their coerced string values. */
	  var reFlags = /\w*$/;
	
	  /** Used to detect bad signed hexadecimal string values. */
	  var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
	
	  /** Used to detect binary string values. */
	  var reIsBinary = /^0b[01]+$/i;
	
	  /** Used to detect host constructors (Safari). */
	  var reIsHostCtor = /^\[object .+?Constructor\]$/;
	
	  /** Used to detect octal string values. */
	  var reIsOctal = /^0o[0-7]+$/i;
	
	  /** Used to detect unsigned integer values. */
	  var reIsUint = /^(?:0|[1-9]\d*)$/;
	
	  /** Used to match Latin Unicode letters (excluding mathematical operators). */
	  var reLatin = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g;
	
	  /** Used to ensure capturing order of template delimiters. */
	  var reNoMatch = /($^)/;
	
	  /** Used to match unescaped characters in compiled string literals. */
	  var reUnescapedString = /['\n\r\u2028\u2029\\]/g;
	
	  /** Used to compose unicode character classes. */
	  var rsAstralRange = '\\ud800-\\udfff',
	      rsComboMarksRange = '\\u0300-\\u036f',
	      reComboHalfMarksRange = '\\ufe20-\\ufe2f',
	      rsComboSymbolsRange = '\\u20d0-\\u20ff',
	      rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange,
	      rsDingbatRange = '\\u2700-\\u27bf',
	      rsLowerRange = 'a-z\\xdf-\\xf6\\xf8-\\xff',
	      rsMathOpRange = '\\xac\\xb1\\xd7\\xf7',
	      rsNonCharRange = '\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf',
	      rsPunctuationRange = '\\u2000-\\u206f',
	      rsSpaceRange = ' \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000',
	      rsUpperRange = 'A-Z\\xc0-\\xd6\\xd8-\\xde',
	      rsVarRange = '\\ufe0e\\ufe0f',
	      rsBreakRange = rsMathOpRange + rsNonCharRange + rsPunctuationRange + rsSpaceRange;
	
	  /** Used to compose unicode capture groups. */
	  var rsApos = "['\u2019]",
	      rsAstral = '[' + rsAstralRange + ']',
	      rsBreak = '[' + rsBreakRange + ']',
	      rsCombo = '[' + rsComboRange + ']',
	      rsDigits = '\\d+',
	      rsDingbat = '[' + rsDingbatRange + ']',
	      rsLower = '[' + rsLowerRange + ']',
	      rsMisc = '[^' + rsAstralRange + rsBreakRange + rsDigits + rsDingbatRange + rsLowerRange + rsUpperRange + ']',
	      rsFitz = '\\ud83c[\\udffb-\\udfff]',
	      rsModifier = '(?:' + rsCombo + '|' + rsFitz + ')',
	      rsNonAstral = '[^' + rsAstralRange + ']',
	      rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}',
	      rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]',
	      rsUpper = '[' + rsUpperRange + ']',
	      rsZWJ = '\\u200d';
	
	  /** Used to compose unicode regexes. */
	  var rsMiscLower = '(?:' + rsLower + '|' + rsMisc + ')',
	      rsMiscUpper = '(?:' + rsUpper + '|' + rsMisc + ')',
	      rsOptContrLower = '(?:' + rsApos + '(?:d|ll|m|re|s|t|ve))?',
	      rsOptContrUpper = '(?:' + rsApos + '(?:D|LL|M|RE|S|T|VE))?',
	      reOptMod = rsModifier + '?',
	      rsOptVar = '[' + rsVarRange + ']?',
	      rsOptJoin = '(?:' + rsZWJ + '(?:' + [rsNonAstral, rsRegional, rsSurrPair].join('|') + ')' + rsOptVar + reOptMod + ')*',
	      rsOrdLower = '\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])',
	      rsOrdUpper = '\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])',
	      rsSeq = rsOptVar + reOptMod + rsOptJoin,
	      rsEmoji = '(?:' + [rsDingbat, rsRegional, rsSurrPair].join('|') + ')' + rsSeq,
	      rsSymbol = '(?:' + [rsNonAstral + rsCombo + '?', rsCombo, rsRegional, rsSurrPair, rsAstral].join('|') + ')';
	
	  /** Used to match apostrophes. */
	  var reApos = RegExp(rsApos, 'g');
	
	  /**
	   * Used to match [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks) and
	   * [combining diacritical marks for symbols](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks_for_Symbols).
	   */
	  var reComboMark = RegExp(rsCombo, 'g');
	
	  /** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */
	  var reUnicode = RegExp(rsFitz + '(?=' + rsFitz + ')|' + rsSymbol + rsSeq, 'g');
	
	  /** Used to match complex or compound words. */
	  var reUnicodeWord = RegExp([
	    rsUpper + '?' + rsLower + '+' + rsOptContrLower + '(?=' + [rsBreak, rsUpper, '$'].join('|') + ')',
	    rsMiscUpper + '+' + rsOptContrUpper + '(?=' + [rsBreak, rsUpper + rsMiscLower, '$'].join('|') + ')',
	    rsUpper + '?' + rsMiscLower + '+' + rsOptContrLower,
	    rsUpper + '+' + rsOptContrUpper,
	    rsOrdUpper,
	    rsOrdLower,
	    rsDigits,
	    rsEmoji
	  ].join('|'), 'g');
	
	  /** Used to detect strings with [zero-width joiners or code points from the astral planes](http://eev.ee/blog/2015/09/12/dark-corners-of-unicode/). */
	  var reHasUnicode = RegExp('[' + rsZWJ + rsAstralRange  + rsComboRange + rsVarRange + ']');
	
	  /** Used to detect strings that need a more robust regexp to match words. */
	  var reHasUnicodeWord = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;
	
	  /** Used to assign default `context` object properties. */
	  var contextProps = [
	    'Array', 'Buffer', 'DataView', 'Date', 'Error', 'Float32Array', 'Float64Array',
	    'Function', 'Int8Array', 'Int16Array', 'Int32Array', 'Map', 'Math', 'Object',
	    'Promise', 'RegExp', 'Set', 'String', 'Symbol', 'TypeError', 'Uint8Array',
	    'Uint8ClampedArray', 'Uint16Array', 'Uint32Array', 'WeakMap',
	    '_', 'clearTimeout', 'isFinite', 'parseInt', 'setTimeout'
	  ];
	
	  /** Used to make template sourceURLs easier to identify. */
	  var templateCounter = -1;
	
	  /** Used to identify `toStringTag` values of typed arrays. */
	  var typedArrayTags = {};
	  typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
	  typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
	  typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
	  typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
	  typedArrayTags[uint32Tag] = true;
	  typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
	  typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
	  typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
	  typedArrayTags[errorTag] = typedArrayTags[funcTag] =
	  typedArrayTags[mapTag] = typedArrayTags[numberTag] =
	  typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
	  typedArrayTags[setTag] = typedArrayTags[stringTag] =
	  typedArrayTags[weakMapTag] = false;
	
	  /** Used to identify `toStringTag` values supported by `_.clone`. */
	  var cloneableTags = {};
	  cloneableTags[argsTag] = cloneableTags[arrayTag] =
	  cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] =
	  cloneableTags[boolTag] = cloneableTags[dateTag] =
	  cloneableTags[float32Tag] = cloneableTags[float64Tag] =
	  cloneableTags[int8Tag] = cloneableTags[int16Tag] =
	  cloneableTags[int32Tag] = cloneableTags[mapTag] =
	  cloneableTags[numberTag] = cloneableTags[objectTag] =
	  cloneableTags[regexpTag] = cloneableTags[setTag] =
	  cloneableTags[stringTag] = cloneableTags[symbolTag] =
	  cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] =
	  cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
	  cloneableTags[errorTag] = cloneableTags[funcTag] =
	  cloneableTags[weakMapTag] = false;
	
	  /** Used to map Latin Unicode letters to basic Latin letters. */
	  var deburredLetters = {
	    // Latin-1 Supplement block.
	    '\xc0': 'A',  '\xc1': 'A', '\xc2': 'A', '\xc3': 'A', '\xc4': 'A', '\xc5': 'A',
	    '\xe0': 'a',  '\xe1': 'a', '\xe2': 'a', '\xe3': 'a', '\xe4': 'a', '\xe5': 'a',
	    '\xc7': 'C',  '\xe7': 'c',
	    '\xd0': 'D',  '\xf0': 'd',
	    '\xc8': 'E',  '\xc9': 'E', '\xca': 'E', '\xcb': 'E',
	    '\xe8': 'e',  '\xe9': 'e', '\xea': 'e', '\xeb': 'e',
	    '\xcc': 'I',  '\xcd': 'I', '\xce': 'I', '\xcf': 'I',
	    '\xec': 'i',  '\xed': 'i', '\xee': 'i', '\xef': 'i',
	    '\xd1': 'N',  '\xf1': 'n',
	    '\xd2': 'O',  '\xd3': 'O', '\xd4': 'O', '\xd5': 'O', '\xd6': 'O', '\xd8': 'O',
	    '\xf2': 'o',  '\xf3': 'o', '\xf4': 'o', '\xf5': 'o', '\xf6': 'o', '\xf8': 'o',
	    '\xd9': 'U',  '\xda': 'U', '\xdb': 'U', '\xdc': 'U',
	    '\xf9': 'u',  '\xfa': 'u', '\xfb': 'u', '\xfc': 'u',
	    '\xdd': 'Y',  '\xfd': 'y', '\xff': 'y',
	    '\xc6': 'Ae', '\xe6': 'ae',
	    '\xde': 'Th', '\xfe': 'th',
	    '\xdf': 'ss',
	    // Latin Extended-A block.
	    '\u0100': 'A',  '\u0102': 'A', '\u0104': 'A',
	    '\u0101': 'a',  '\u0103': 'a', '\u0105': 'a',
	    '\u0106': 'C',  '\u0108': 'C', '\u010a': 'C', '\u010c': 'C',
	    '\u0107': 'c',  '\u0109': 'c', '\u010b': 'c', '\u010d': 'c',
	    '\u010e': 'D',  '\u0110': 'D', '\u010f': 'd', '\u0111': 'd',
	    '\u0112': 'E',  '\u0114': 'E', '\u0116': 'E', '\u0118': 'E', '\u011a': 'E',
	    '\u0113': 'e',  '\u0115': 'e', '\u0117': 'e', '\u0119': 'e', '\u011b': 'e',
	    '\u011c': 'G',  '\u011e': 'G', '\u0120': 'G', '\u0122': 'G',
	    '\u011d': 'g',  '\u011f': 'g', '\u0121': 'g', '\u0123': 'g',
	    '\u0124': 'H',  '\u0126': 'H', '\u0125': 'h', '\u0127': 'h',
	    '\u0128': 'I',  '\u012a': 'I', '\u012c': 'I', '\u012e': 'I', '\u0130': 'I',
	    '\u0129': 'i',  '\u012b': 'i', '\u012d': 'i', '\u012f': 'i', '\u0131': 'i',
	    '\u0134': 'J',  '\u0135': 'j',
	    '\u0136': 'K',  '\u0137': 'k', '\u0138': 'k',
	    '\u0139': 'L',  '\u013b': 'L', '\u013d': 'L', '\u013f': 'L', '\u0141': 'L',
	    '\u013a': 'l',  '\u013c': 'l', '\u013e': 'l', '\u0140': 'l', '\u0142': 'l',
	    '\u0143': 'N',  '\u0145': 'N', '\u0147': 'N', '\u014a': 'N',
	    '\u0144': 'n',  '\u0146': 'n', '\u0148': 'n', '\u014b': 'n',
	    '\u014c': 'O',  '\u014e': 'O', '\u0150': 'O',
	    '\u014d': 'o',  '\u014f': 'o', '\u0151': 'o',
	    '\u0154': 'R',  '\u0156': 'R', '\u0158': 'R',
	    '\u0155': 'r',  '\u0157': 'r', '\u0159': 'r',
	    '\u015a': 'S',  '\u015c': 'S', '\u015e': 'S', '\u0160': 'S',
	    '\u015b': 's',  '\u015d': 's', '\u015f': 's', '\u0161': 's',
	    '\u0162': 'T',  '\u0164': 'T', '\u0166': 'T',
	    '\u0163': 't',  '\u0165': 't', '\u0167': 't',
	    '\u0168': 'U',  '\u016a': 'U', '\u016c': 'U', '\u016e': 'U', '\u0170': 'U', '\u0172': 'U',
	    '\u0169': 'u',  '\u016b': 'u', '\u016d': 'u', '\u016f': 'u', '\u0171': 'u', '\u0173': 'u',
	    '\u0174': 'W',  '\u0175': 'w',
	    '\u0176': 'Y',  '\u0177': 'y', '\u0178': 'Y',
	    '\u0179': 'Z',  '\u017b': 'Z', '\u017d': 'Z',
	    '\u017a': 'z',  '\u017c': 'z', '\u017e': 'z',
	    '\u0132': 'IJ', '\u0133': 'ij',
	    '\u0152': 'Oe', '\u0153': 'oe',
	    '\u0149': "'n", '\u017f': 's'
	  };
	
	  /** Used to map characters to HTML entities. */
	  var htmlEscapes = {
	    '&': '&amp;',
	    '<': '&lt;',
	    '>': '&gt;',
	    '"': '&quot;',
	    "'": '&#39;'
	  };
	
	  /** Used to map HTML entities to characters. */
	  var htmlUnescapes = {
	    '&amp;': '&',
	    '&lt;': '<',
	    '&gt;': '>',
	    '&quot;': '"',
	    '&#39;': "'"
	  };
	
	  /** Used to escape characters for inclusion in compiled string literals. */
	  var stringEscapes = {
	    '\\': '\\',
	    "'": "'",
	    '\n': 'n',
	    '\r': 'r',
	    '\u2028': 'u2028',
	    '\u2029': 'u2029'
	  };
	
	  /** Built-in method references without a dependency on `root`. */
	  var freeParseFloat = parseFloat,
	      freeParseInt = parseInt;
	
	  /** Detect free variable `global` from Node.js. */
	  var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;
	
	  /** Detect free variable `self`. */
	  var freeSelf = typeof self == 'object' && self && self.Object === Object && self;
	
	  /** Used as a reference to the global object. */
	  var root = freeGlobal || freeSelf || Function('return this')();
	
	  /** Detect free variable `exports`. */
	  var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;
	
	  /** Detect free variable `module`. */
	  var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;
	
	  /** Detect the popular CommonJS extension `module.exports`. */
	  var moduleExports = freeModule && freeModule.exports === freeExports;
	
	  /** Detect free variable `process` from Node.js. */
	  var freeProcess = moduleExports && freeGlobal.process;
	
	  /** Used to access faster Node.js helpers. */
	  var nodeUtil = (function() {
	    try {
	      // Use `util.types` for Node.js 10+.
	      var types = freeModule && freeModule.require && freeModule.require('util').types;
	
	      if (types) {
	        return types;
	      }
	
	      // Legacy `process.binding('util')` for Node.js < 10.
	      return freeProcess && freeProcess.binding && freeProcess.binding('util');
	    } catch (e) {}
	  }());
	
	  /* Node.js helper references. */
	  var nodeIsArrayBuffer = nodeUtil && nodeUtil.isArrayBuffer,
	      nodeIsDate = nodeUtil && nodeUtil.isDate,
	      nodeIsMap = nodeUtil && nodeUtil.isMap,
	      nodeIsRegExp = nodeUtil && nodeUtil.isRegExp,
	      nodeIsSet = nodeUtil && nodeUtil.isSet,
	      nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;
	
	  /*--------------------------------------------------------------------------*/
	
	  /**
	   * A faster alternative to `Function#apply`, this function invokes `func`
	   * with the `this` binding of `thisArg` and the arguments of `args`.
	   *
	   * @private
	   * @param {Function} func The function to invoke.
	   * @param {*} thisArg The `this` binding of `func`.
	   * @param {Array} args The arguments to invoke `func` with.
	   * @returns {*} Returns the result of `func`.
	   */
	  function apply(func, thisArg, args) {
	    switch (args.length) {
	      case 0: return func.call(thisArg);
	      case 1: return func.call(thisArg, args[0]);
	      case 2: return func.call(thisArg, args[0], args[1]);
	      case 3: return func.call(thisArg, args[0], args[1], args[2]);
	    }
	    return func.apply(thisArg, args);
	  }
	
	  /**
	   * A specialized version of `baseAggregator` for arrays.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} setter The function to set `accumulator` values.
	   * @param {Function} iteratee The iteratee to transform keys.
	   * @param {Object} accumulator The initial aggregated object.
	   * @returns {Function} Returns `accumulator`.
	   */
	  function arrayAggregator(array, setter, iteratee, accumulator) {
	    var index = -1,
	        length = array == null ? 0 : array.length;
	
	    while (++index < length) {
	      var value = array[index];
	      setter(accumulator, value, iteratee(value), array);
	    }
	    return accumulator;
	  }
	
	  /**
	   * A specialized version of `_.forEach` for arrays without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @returns {Array} Returns `array`.
	   */
	  function arrayEach(array, iteratee) {
	    var index = -1,
	        length = array == null ? 0 : array.length;
	
	    while (++index < length) {
	      if (iteratee(array[index], index, array) === false) {
	        break;
	      }
	    }
	    return array;
	  }
	
	  /**
	   * A specialized version of `_.forEachRight` for arrays without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @returns {Array} Returns `array`.
	   */
	  function arrayEachRight(array, iteratee) {
	    var length = array == null ? 0 : array.length;
	
	    while (length--) {
	      if (iteratee(array[length], length, array) === false) {
	        break;
	      }
	    }
	    return array;
	  }
	
	  /**
	   * A specialized version of `_.every` for arrays without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} predicate The function invoked per iteration.
	   * @returns {boolean} Returns `true` if all elements pass the predicate check,
	   *  else `false`.
	   */
	  function arrayEvery(array, predicate) {
	    var index = -1,
	        length = array == null ? 0 : array.length;
	
	    while (++index < length) {
	      if (!predicate(array[index], index, array)) {
	        return false;
	      }
	    }
	    return true;
	  }
	
	  /**
	   * A specialized version of `_.filter` for arrays without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} predicate The function invoked per iteration.
	   * @returns {Array} Returns the new filtered array.
	   */
	  function arrayFilter(array, predicate) {
	    var index = -1,
	        length = array == null ? 0 : array.length,
	        resIndex = 0,
	        result = [];
	
	    while (++index < length) {
	      var value = array[index];
	      if (predicate(value, index, array)) {
	        result[resIndex++] = value;
	      }
	    }
	    return result;
	  }
	
	  /**
	   * A specialized version of `_.includes` for arrays without support for
	   * specifying an index to search from.
	   *
	   * @private
	   * @param {Array} [array] The array to inspect.
	   * @param {*} target The value to search for.
	   * @returns {boolean} Returns `true` if `target` is found, else `false`.
	   */
	  function arrayIncludes(array, value) {
	    var length = array == null ? 0 : array.length;
	    return !!length && baseIndexOf(array, value, 0) > -1;
	  }
	
	  /**
	   * This function is like `arrayIncludes` except that it accepts a comparator.
	   *
	   * @private
	   * @param {Array} [array] The array to inspect.
	   * @param {*} target The value to search for.
	   * @param {Function} comparator The comparator invoked per element.
	   * @returns {boolean} Returns `true` if `target` is found, else `false`.
	   */
	  function arrayIncludesWith(array, value, comparator) {
	    var index = -1,
	        length = array == null ? 0 : array.length;
	
	    while (++index < length) {
	      if (comparator(value, array[index])) {
	        return true;
	      }
	    }
	    return false;
	  }
	
	  /**
	   * A specialized version of `_.map` for arrays without support for iteratee
	   * shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @returns {Array} Returns the new mapped array.
	   */
	  function arrayMap(array, iteratee) {
	    var index = -1,
	        length = array == null ? 0 : array.length,
	        result = Array(length);
	
	    while (++index < length) {
	      result[index] = iteratee(array[index], index, array);
	    }
	    return result;
	  }
	
	  /**
	   * Appends the elements of `values` to `array`.
	   *
	   * @private
	   * @param {Array} array The array to modify.
	   * @param {Array} values The values to append.
	   * @returns {Array} Returns `array`.
	   */
	  function arrayPush(array, values) {
	    var index = -1,
	        length = values.length,
	        offset = array.length;
	
	    while (++index < length) {
	      array[offset + index] = values[index];
	    }
	    return array;
	  }
	
	  /**
	   * A specialized version of `_.reduce` for arrays without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @param {*} [accumulator] The initial value.
	   * @param {boolean} [initAccum] Specify using the first element of `array` as
	   *  the initial value.
	   * @returns {*} Returns the accumulated value.
	   */
	  function arrayReduce(array, iteratee, accumulator, initAccum) {
	    var index = -1,
	        length = array == null ? 0 : array.length;
	
	    if (initAccum && length) {
	      accumulator = array[++index];
	    }
	    while (++index < length) {
	      accumulator = iteratee(accumulator, array[index], index, array);
	    }
	    return accumulator;
	  }
	
	  /**
	   * A specialized version of `_.reduceRight` for arrays without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @param {*} [accumulator] The initial value.
	   * @param {boolean} [initAccum] Specify using the last element of `array` as
	   *  the initial value.
	   * @returns {*} Returns the accumulated value.
	   */
	  function arrayReduceRight(array, iteratee, accumulator, initAccum) {
	    var length = array == null ? 0 : array.length;
	    if (initAccum && length) {
	      accumulator = array[--length];
	    }
	    while (length--) {
	      accumulator = iteratee(accumulator, array[length], length, array);
	    }
	    return accumulator;
	  }
	
	  /**
	   * A specialized version of `_.some` for arrays without support for iteratee
	   * shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} predicate The function invoked per iteration.
	   * @returns {boolean} Returns `true` if any element passes the predicate check,
	   *  else `false`.
	   */
	  function arraySome(array, predicate) {
	    var index = -1,
	        length = array == null ? 0 : array.length;
	
	    while (++index < length) {
	      if (predicate(array[index], index, array)) {
	        return true;
	      }
	    }
	    return false;
	  }
	
	  /**
	   * Gets the size of an ASCII `string`.
	   *
	   * @private
	   * @param {string} string The string inspect.
	   * @returns {number} Returns the string size.
	   */
	  var asciiSize = baseProperty('length');
	
	  /**
	   * Converts an ASCII `string` to an array.
	   *
	   * @private
	   * @param {string} string The string to convert.
	   * @returns {Array} Returns the converted array.
	   */
	  function asciiToArray(string) {
	    return string.split('');
	  }
	
	  /**
	   * Splits an ASCII `string` into an array of its words.
	   *
	   * @private
	   * @param {string} The string to inspect.
	   * @returns {Array} Returns the words of `string`.
	   */
	  function asciiWords(string) {
	    return string.match(reAsciiWord) || [];
	  }
	
	  /**
	   * The base implementation of methods like `_.findKey` and `_.findLastKey`,
	   * without support for iteratee shorthands, which iterates over `collection`
	   * using `eachFunc`.
	   *
	   * @private
	   * @param {Array|Object} collection The collection to inspect.
	   * @param {Function} predicate The function invoked per iteration.
	   * @param {Function} eachFunc The function to iterate over `collection`.
	   * @returns {*} Returns the found element or its key, else `undefined`.
	   */
	  function baseFindKey(collection, predicate, eachFunc) {
	    var result;
	    eachFunc(collection, function(value, key, collection) {
	      if (predicate(value, key, collection)) {
	        result = key;
	        return false;
	      }
	    });
	    return result;
	  }
	
	  /**
	   * The base implementation of `_.findIndex` and `_.findLastIndex` without
	   * support for iteratee shorthands.
	   *
	   * @private
	   * @param {Array} array The array to inspect.
	   * @param {Function} predicate The function invoked per iteration.
	   * @param {number} fromIndex The index to search from.
	   * @param {boolean} [fromRight] Specify iterating from right to left.
	   * @returns {number} Returns the index of the matched value, else `-1`.
	   */
	  function baseFindIndex(array, predicate, fromIndex, fromRight) {
	    var length = array.length,
	        index = fromIndex + (fromRight ? 1 : -1);
	
	    while ((fromRight ? index-- : ++index < length)) {
	      if (predicate(array[index], index, array)) {
	        return index;
	      }
	    }
	    return -1;
	  }
	
	  /**
	   * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
	   *
	   * @private
	   * @param {Array} array The array to inspect.
	   * @param {*} value The value to search for.
	   * @param {number} fromIndex The index to search from.
	   * @returns {number} Returns the index of the matched value, else `-1`.
	   */
	  function baseIndexOf(array, value, fromIndex) {
	    return value === value
	      ? strictIndexOf(array, value, fromIndex)
	      : baseFindIndex(array, baseIsNaN, fromIndex);
	  }
	
	  /**
	   * This function is like `baseIndexOf` except that it accepts a comparator.
	   *
	   * @private
	   * @param {Array} array The array to inspect.
	   * @param {*} value The value to search for.
	   * @param {number} fromIndex The index to search from.
	   * @param {Function} comparator The comparator invoked per element.
	   * @returns {number} Returns the index of the matched value, else `-1`.
	   */
	  function baseIndexOfWith(array, value, fromIndex, comparator) {
	    var index = fromIndex - 1,
	        length = array.length;
	
	    while (++index < length) {
	      if (comparator(array[index], value)) {
	        return index;
	      }
	    }
	    return -1;
	  }
	
	  /**
	   * The base implementation of `_.isNaN` without support for number objects.
	   *
	   * @private
	   * @param {*} value The value to check.
	   * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
	   */
	  function baseIsNaN(value) {
	    return value !== value;
	  }
	
	  /**
	   * The base implementation of `_.mean` and `_.meanBy` without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} array The array to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @returns {number} Returns the mean.
	   */
	  function baseMean(array, iteratee) {
	    var length = array == null ? 0 : array.length;
	    return length ? (baseSum(array, iteratee) / length) : NAN;
	  }
	
	  /**
	   * The base implementation of `_.property` without support for deep paths.
	   *
	   * @private
	   * @param {string} key The key of the property to get.
	   * @returns {Function} Returns the new accessor function.
	   */
	  function baseProperty(key) {
	    return function(object) {
	      return object == null ? undefined : object[key];
	    };
	  }
	
	  /**
	   * The base implementation of `_.propertyOf` without support for deep paths.
	   *
	   * @private
	   * @param {Object} object The object to query.
	   * @returns {Function} Returns the new accessor function.
	   */
	  function basePropertyOf(object) {
	    return function(key) {
	      return object == null ? undefined : object[key];
	    };
	  }
	
	  /**
	   * The base implementation of `_.reduce` and `_.reduceRight`, without support
	   * for iteratee shorthands, which iterates over `collection` using `eachFunc`.
	   *
	   * @private
	   * @param {Array|Object} collection The collection to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @param {*} accumulator The initial value.
	   * @param {boolean} initAccum Specify using the first or last element of
	   *  `collection` as the initial value.
	   * @param {Function} eachFunc The function to iterate over `collection`.
	   * @returns {*} Returns the accumulated value.
	   */
	  function baseReduce(collection, iteratee, accumulator, initAccum, eachFunc) {
	    eachFunc(collection, function(value, index, collection) {
	      accumulator = initAccum
	        ? (initAccum = false, value)
	        : iteratee(accumulator, value, index, collection);
	    });
	    return accumulator;
	  }
	
	  /**
	   * The base implementation of `_.sortBy` which uses `comparer` to define the
	   * sort order of `array` and replaces criteria objects with their corresponding
	   * values.
	   *
	   * @private
	   * @param {Array} array The array to sort.
	   * @param {Function} comparer The function to define sort order.
	   * @returns {Array} Returns `array`.
	   */
	  function baseSortBy(array, comparer) {
	    var length = array.length;
	
	    array.sort(comparer);
	    while (length--) {
	      array[length] = array[length].value;
	    }
	    return array;
	  }
	
	  /**
	   * The base implementation of `_.sum` and `_.sumBy` without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} array The array to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @returns {number} Returns the sum.
	   */
	  function baseSum(array, iteratee) {
	    var result,
	        index = -1,
	        length = array.length;
	
	    while (++index < length) {
	      var current = iteratee(array[index]);
	      if (current !== undefined) {
	        result = result === undefined ? current : (result + current);
	      }
	    }
	    return result;
	  }
	
	  /**
	   * The base implementation of `_.times` without support for iteratee shorthands
	   * or max array length checks.
	   *
	   * @private
	   * @param {number} n The number of times to invoke `iteratee`.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @returns {Array} Returns the array of results.
	   */
	  function baseTimes(n, iteratee) {
	    var index = -1,
	        result = Array(n);
	
	    while (++index < n) {
	      result[index] = iteratee(index);
	    }
	    return result;
	  }
	
	  /**
	   * The base implementation of `_.toPairs` and `_.toPairsIn` which creates an array
	   * of key-value pairs for `object` corresponding to the property names of `props`.
	   *
	   * @private
	   * @param {Object} object The object to query.
	   * @param {Array} props The property names to get values for.
	   * @returns {Object} Returns the key-value pairs.
	   */
	  function baseToPairs(object, props) {
	    return arrayMap(props, function(key) {
	      return [key, object[key]];
	    });
	  }
	
	  /**
	   * The base implementation of `_.unary` without support for storing metadata.
	   *
	   * @private
	   * @param {Function} func The function to cap arguments for.
	   * @returns {Function} Returns the new capped function.
	   */
	  function baseUnary(func) {
	    return function(value) {
	      return func(value);
	    };
	  }
	
	  /**
	   * The base implementation of `_.values` and `_.valuesIn` which creates an
	   * array of `object` property values corresponding to the property names
	   * of `props`.
	   *
	   * @private
	   * @param {Object} object The object to query.
	   * @param {Array} props The property names to get values for.
	   * @returns {Object} Returns the array of property values.
	   */
	  function baseValues(object, props) {
	    return arrayMap(props, function(key) {
	      return object[key];
	    });
	  }
	
	  /**
	   * Checks if a `cache` value for `key` exists.
	   *
	   * @private
	   * @param {Object} cache The cache to query.
	   * @param {string} key The key of the entry to check.
	   * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	   */
	  function cacheHas(cache, key) {
	    return cache.has(key);
	  }
	
	  /**
	   * Used by `_.trim` and `_.trimStart` to get the index of the first string symbol
	   * that is not found in the character symbols.
	   *
	   * @private
	   * @param {Array} strSymbols The string symbols to inspect.
	   * @param {Array} chrSymbols The character symbols to find.
	   * @returns {number} Returns the index of the first unmatched string symbol.
	   */
	  function charsStartIndex(strSymbols, chrSymbols) {
	    var index = -1,
	        length = strSymbols.length;
	
	    while (++index < length && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1) {}
	    return index;
	  }
	
	  /**
	   * Used by `_.trim` and `_.trimEnd` to get the index of the last string symbol
	   * that is not found in the character symbols.
	   *
	   * @private
	   * @param {Array} strSymbols The string symbols to inspect.
	   * @param {Array} chrSymbols The character symbols to find.
	   * @returns {number} Returns the index of the last unmatched string symbol.
	   */
	  function charsEndIndex(strSymbols, chrSymbols) {
	    var index = strSymbols.length;
	
	    while (index-- && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1) {}
	    return index;
	  }
	
	  /**
	   * Gets the number of `placeholder` occurrences in `array`.
	   *
	   * @private
	   * @param {Array} array The array to inspect.
	   * @param {*} placeholder The placeholder to search for.
	   * @returns {number} Returns the placeholder count.
	   */
	  function countHolders(array, placeholder) {
	    var length = array.length,
	        result = 0;
	
	    while (length--) {
	      if (array[length] === placeholder) {
	        ++result;
	      }
	    }
	    return result;
	  }
	
	  /**
	   * Used by `_.deburr` to convert Latin-1 Supplement and Latin Extended-A
	   * letters to basic Latin letters.
	   *
	   * @private
	   * @param {string} letter The matched letter to deburr.
	   * @returns {string} Returns the deburred letter.
	   */
	  var deburrLetter = basePropertyOf(deburredLetters);
	
	  /**
	   * Used by `_.escape` to convert characters to HTML entities.
	   *
	   * @private
	   * @param {string} chr The matched character to escape.
	   * @returns {string} Returns the escaped character.
	   */
	  var escapeHtmlChar = basePropertyOf(htmlEscapes);
	
	  /**
	   * Used by `_.template` to escape characters for inclusion in compiled string literals.
	   *
	   * @private
	   * @param {string} chr The matched character to escape.
	   * @returns {string} Returns the escaped character.
	   */
	  function escapeStringChar(chr) {
	    return '\\' + stringEscapes[chr];
	  }
	
	  /**
	   * Gets the value at `key` of `object`.
	   *
	   * @private
	   * @param {Object} [object] The object to query.
	   * @param {string} key The key of the property to get.
	   * @returns {*} Returns the property value.
	   */
	  function getValue(object, key) {
	    return object == null ? undefined : object[key];
	  }
	
	  /**
	   * Checks if `string` contains Unicode symbols.
	   *
	   * @private
	   * @param {string} string The string to inspect.
	   * @returns {boolean} Returns `true` if a symbol is found, else `false`.
	   */
	  function hasUnicode(string) {
	    return reHasUnicode.test(string);
	  }
	
	  /**
	   * Checks if `string` contains a word composed of Unicode symbols.
	   *
	   * @private
	   * @param {string} string The string to inspect.
	   * @returns {boolean} Returns `true` if a word is found, else `false`.
	   */
	  function hasUnicodeWord(string) {
	    return reHasUnicodeWord.test(string);
	  }
	
	  /**
	   * Converts `iterator` to an array.
	   *
	   * @private
	   * @param {Object} iterator The iterator to convert.
	   * @returns {Array} Returns the converted array.
	   */
	  function iteratorToArray(iterator) {
	    var data,
	        result = [];
	
	    while (!(data = iterator.next()).done) {
	      result.push(data.value);
	    }
	    return result;
	  }
	
	  /**
	   * Converts `map` to its key-value pairs.
	   *
	   * @private
	   * @param {Object} map The map to convert.
	   * @returns {Array} Returns the key-value pairs.
	   */
	  function mapToArray(map) {
	    var index = -1,
	        result = Array(map.size);
	
	    map.forEach(function(value, key) {
	      result[++index] = [key, value];
	    });
	    return result;
	  }
	
	  /**
	   * Creates a unary function that invokes `func` with its argument transformed.
	   *
	   * @private
	   * @param {Function} func The function to wrap.
	   * @param {Function} transform The argument transform.
	   * @returns {Function} Returns the new function.
	   */
	  function overArg(func, transform) {
	    return function(arg) {
	      return func(transform(arg));
	    };
	  }
	
	  /**
	   * Replaces all `placeholder` elements in `array` with an internal placeholder
	   * and returns an array of their indexes.
	   *
	   * @private
	   * @param {Array} array The array to modify.
	   * @param {*} placeholder The placeholder to replace.
	   * @returns {Array} Returns the new array of placeholder indexes.
	   */
	  function replaceHolders(array, placeholder) {
	    var index = -1,
	        length = array.length,
	        resIndex = 0,
	        result = [];
	
	    while (++index < length) {
	      var value = array[index];
	      if (value === placeholder || value === PLACEHOLDER) {
	        array[index] = PLACEHOLDER;
	        result[resIndex++] = index;
	      }
	    }
	    return result;
	  }
	
	  /**
	   * Converts `set` to an array of its values.
	   *
	   * @private
	   * @param {Object} set The set to convert.
	   * @returns {Array} Returns the values.
	   */
	  function setToArray(set) {
	    var index = -1,
	        result = Array(set.size);
	
	    set.forEach(function(value) {
	      result[++index] = value;
	    });
	    return result;
	  }
	
	  /**
	   * Converts `set` to its value-value pairs.
	   *
	   * @private
	   * @param {Object} set The set to convert.
	   * @returns {Array} Returns the value-value pairs.
	   */
	  function setToPairs(set) {
	    var index = -1,
	        result = Array(set.size);
	
	    set.forEach(function(value) {
	      result[++index] = [value, value];
	    });
	    return result;
	  }
	
	  /**
	   * A specialized version of `_.indexOf` which performs strict equality
	   * comparisons of values, i.e. `===`.
	   *
	   * @private
	   * @param {Array} array The array to inspect.
	   * @param {*} value The value to search for.
	   * @param {number} fromIndex The index to search from.
	   * @returns {number} Returns the index of the matched value, else `-1`.
	   */
	  function strictIndexOf(array, value, fromIndex) {
	    var index = fromIndex - 1,
	        length = array.length;
	
	    while (++index < length) {
	      if (array[index] === value) {
	        return index;
	      }
	    }
	    return -1;
	  }
	
	  /**
	   * A specialized version of `_.lastIndexOf` which performs strict equality
	   * comparisons of values, i.e. `===`.
	   *
	   * @private
	   * @param {Array} array The array to inspect.
	   * @param {*} value The value to search for.
	   * @param {number} fromIndex The index to search from.
	   * @returns {number} Returns the index of the matched value, else `-1`.
	   */
	  function strictLastIndexOf(array, value, fromIndex) {
	    var index = fromIndex + 1;
	    while (index--) {
	      if (array[index] === value) {
	        return index;
	      }
	    }
	    return index;
	  }
	
	  /**
	   * Gets the number of symbols in `string`.
	   *
	   * @private
	   * @param {string} string The string to inspect.
	   * @returns {number} Returns the string size.
	   */
	  function stringSize(string) {
	    return hasUnicode(string)
	      ? unicodeSize(string)
	      : asciiSize(string);
	  }
	
	  /**
	   * Converts `string` to an array.
	   *
	   * @private
	   * @param {string} string The string to convert.
	   * @returns {Array} Returns the converted array.
	   */
	  function stringToArray(string) {
	    return hasUnicode(string)
	      ? unicodeToArray(string)
	      : asciiToArray(string);
	  }
	
	  /**
	   * Used by `_.unescape` to convert HTML entities to characters.
	   *
	   * @private
	   * @param {string} chr The matched character to unescape.
	   * @returns {string} Returns the unescaped character.
	   */
	  var unescapeHtmlChar = basePropertyOf(htmlUnescapes);
	
	  /**
	   * Gets the size of a Unicode `string`.
	   *
	   * @private
	   * @param {string} string The string inspect.
	   * @returns {number} Returns the string size.
	   */
	  function unicodeSize(string) {
	    var result = reUnicode.lastIndex = 0;
	    while (reUnicode.test(string)) {
	      ++result;
	    }
	    return result;
	  }
	
	  /**
	   * Converts a Unicode `string` to an array.
	   *
	   * @private
	   * @param {string} string The string to convert.
	   * @returns {Array} Returns the converted array.
	   */
	  function unicodeToArray(string) {
	    return string.match(reUnicode) || [];
	  }
	
	  /**
	   * Splits a Unicode `string` into an array of its words.
	   *
	   * @private
	   * @param {string} The string to inspect.
	   * @returns {Array} Returns the words of `string`.
	   */
	  function unicodeWords(string) {
	    return string.match(reUnicodeWord) || [];
	  }
	
	  /*--------------------------------------------------------------------------*/
	
	  /**
	   * Create a new pristine `lodash` function using the `context` object.
	   *
	   * @static
	   * @memberOf _
	   * @since 1.1.0
	   * @category Util
	   * @param {Object} [context=root] The context object.
	   * @returns {Function} Returns a new `lodash` function.
	   * @example
	   *
	   * _.mixin({ 'foo': _.constant('foo') });
	   *
	   * var lodash = _.runInContext();
	   * lodash.mixin({ 'bar': lodash.constant('bar') });
	   *
	   * _.isFunction(_.foo);
	   * // => true
	   * _.isFunction(_.bar);
	   * // => false
	   *
	   * lodash.isFunction(lodash.foo);
	   * // => false
	   * lodash.isFunction(lodash.bar);
	   * // => true
	   *
	   * // Create a suped-up `defer` in Node.js.
	   * var defer = _.runInContext({ 'setTimeout': setImmediate }).defer;
	   */
	  var runInContext = (function runInContext(context) {
	    context = context == null ? root : _.defaults(root.Object(), context, _.pick(root, contextProps));
	
	    /** Built-in constructor references. */
	    var Array = context.Array,
	        Date = context.Date,
	        Error = context.Error,
	        Function = context.Function,
	        Math = context.Math,
	        Object = context.Object,
	        RegExp = context.RegExp,
	        String = context.String,
	        TypeError = context.TypeError;
	
	    /** Used for built-in method references. */
	    var arrayProto = Array.prototype,
	        funcProto = Function.prototype,
	        objectProto = Object.prototype;
	
	    /** Used to detect overreaching core-js shims. */
	    var coreJsData = context['__core-js_shared__'];
	
	    /** Used to resolve the decompiled source of functions. */
	    var funcToString = funcProto.toString;
	
	    /** Used to check objects for own properties. */
	    var hasOwnProperty = objectProto.hasOwnProperty;
	
	    /** Used to generate unique IDs. */
	    var idCounter = 0;
	
	    /** Used to detect methods masquerading as native. */
	    var maskSrcKey = (function() {
	      var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
	      return uid ? ('Symbol(src)_1.' + uid) : '';
	    }());
	
	    /**
	     * Used to resolve the
	     * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	     * of values.
	     */
	    var nativeObjectToString = objectProto.toString;
	
	    /** Used to infer the `Object` constructor. */
	    var objectCtorString = funcToString.call(Object);
	
	    /** Used to restore the original `_` reference in `_.noConflict`. */
	    var oldDash = root._;
	
	    /** Used to detect if a method is native. */
	    var reIsNative = RegExp('^' +
	      funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
	      .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
	    );
	
	    /** Built-in value references. */
	    var Buffer = moduleExports ? context.Buffer : undefined,
	        Symbol = context.Symbol,
	        Uint8Array = context.Uint8Array,
	        allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined,
	        getPrototype = overArg(Object.getPrototypeOf, Object),
	        objectCreate = Object.create,
	        propertyIsEnumerable = objectProto.propertyIsEnumerable,
	        splice = arrayProto.splice,
	        spreadableSymbol = Symbol ? Symbol.isConcatSpreadable : undefined,
	        symIterator = Symbol ? Symbol.iterator : undefined,
	        symToStringTag = Symbol ? Symbol.toStringTag : undefined;
	
	    var defineProperty = (function() {
	      try {
	        var func = getNative(Object, 'defineProperty');
	        func({}, '', {});
	        return func;
	      } catch (e) {}
	    }());
	
	    /** Mocked built-ins. */
	    var ctxClearTimeout = context.clearTimeout !== root.clearTimeout && context.clearTimeout,
	        ctxNow = Date && Date.now !== root.Date.now && Date.now,
	        ctxSetTimeout = context.setTimeout !== root.setTimeout && context.setTimeout;
	
	    /* Built-in method references for those with the same name as other `lodash` methods. */
	    var nativeCeil = Math.ceil,
	        nativeFloor = Math.floor,
	        nativeGetSymbols = Object.getOwnPropertySymbols,
	        nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined,
	        nativeIsFinite = context.isFinite,
	        nativeJoin = arrayProto.join,
	        nativeKeys = overArg(Object.keys, Object),
	        nativeMax = Math.max,
	        nativeMin = Math.min,
	        nativeNow = Date.now,
	        nativeParseInt = context.parseInt,
	        nativeRandom = Math.random,
	        nativeReverse = arrayProto.reverse;
	
	    /* Built-in method references that are verified to be native. */
	    var DataView = getNative(context, 'DataView'),
	        Map = getNative(context, 'Map'),
	        Promise = getNative(context, 'Promise'),
	        Set = getNative(context, 'Set'),
	        WeakMap = getNative(context, 'WeakMap'),
	        nativeCreate = getNative(Object, 'create');
	
	    /** Used to store function metadata. */
	    var metaMap = WeakMap && new WeakMap;
	
	    /** Used to lookup unminified function names. */
	    var realNames = {};
	
	    /** Used to detect maps, sets, and weakmaps. */
	    var dataViewCtorString = toSource(DataView),
	        mapCtorString = toSource(Map),
	        promiseCtorString = toSource(Promise),
	        setCtorString = toSource(Set),
	        weakMapCtorString = toSource(WeakMap);
	
	    /** Used to convert symbols to primitives and strings. */
	    var symbolProto = Symbol ? Symbol.prototype : undefined,
	        symbolValueOf = symbolProto ? symbolProto.valueOf : undefined,
	        symbolToString = symbolProto ? symbolProto.toString : undefined;
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates a `lodash` object which wraps `value` to enable implicit method
	     * chain sequences. Methods that operate on and return arrays, collections,
	     * and functions can be chained together. Methods that retrieve a single value
	     * or may return a primitive value will automatically end the chain sequence
	     * and return the unwrapped value. Otherwise, the value must be unwrapped
	     * with `_#value`.
	     *
	     * Explicit chain sequences, which must be unwrapped with `_#value`, may be
	     * enabled using `_.chain`.
	     *
	     * The execution of chained methods is lazy, that is, it's deferred until
	     * `_#value` is implicitly or explicitly called.
	     *
	     * Lazy evaluation allows several methods to support shortcut fusion.
	     * Shortcut fusion is an optimization to merge iteratee calls; this avoids
	     * the creation of intermediate arrays and can greatly reduce the number of
	     * iteratee executions. Sections of a chain sequence qualify for shortcut
	     * fusion if the section is applied to an array and iteratees accept only
	     * one argument. The heuristic for whether a section qualifies for shortcut
	     * fusion is subject to change.
	     *
	     * Chaining is supported in custom builds as long as the `_#value` method is
	     * directly or indirectly included in the build.
	     *
	     * In addition to lodash methods, wrappers have `Array` and `String` methods.
	     *
	     * The wrapper `Array` methods are:
	     * `concat`, `join`, `pop`, `push`, `shift`, `sort`, `splice`, and `unshift`
	     *
	     * The wrapper `String` methods are:
	     * `replace` and `split`
	     *
	     * The wrapper methods that support shortcut fusion are:
	     * `at`, `compact`, `drop`, `dropRight`, `dropWhile`, `filter`, `find`,
	     * `findLast`, `head`, `initial`, `last`, `map`, `reject`, `reverse`, `slice`,
	     * `tail`, `take`, `takeRight`, `takeRightWhile`, `takeWhile`, and `toArray`
	     *
	     * The chainable wrapper methods are:
	     * `after`, `ary`, `assign`, `assignIn`, `assignInWith`, `assignWith`, `at`,
	     * `before`, `bind`, `bindAll`, `bindKey`, `castArray`, `chain`, `chunk`,
	     * `commit`, `compact`, `concat`, `conforms`, `constant`, `countBy`, `create`,
	     * `curry`, `debounce`, `defaults`, `defaultsDeep`, `defer`, `delay`,
	     * `difference`, `differenceBy`, `differenceWith`, `drop`, `dropRight`,
	     * `dropRightWhile`, `dropWhile`, `extend`, `extendWith`, `fill`, `filter`,
	     * `flatMap`, `flatMapDeep`, `flatMapDepth`, `flatten`, `flattenDeep`,
	     * `flattenDepth`, `flip`, `flow`, `flowRight`, `fromPairs`, `functions`,
	     * `functionsIn`, `groupBy`, `initial`, `intersection`, `intersectionBy`,
	     * `intersectionWith`, `invert`, `invertBy`, `invokeMap`, `iteratee`, `keyBy`,
	     * `keys`, `keysIn`, `map`, `mapKeys`, `mapValues`, `matches`, `matchesProperty`,
	     * `memoize`, `merge`, `mergeWith`, `method`, `methodOf`, `mixin`, `negate`,
	     * `nthArg`, `omit`, `omitBy`, `once`, `orderBy`, `over`, `overArgs`,
	     * `overEvery`, `overSome`, `partial`, `partialRight`, `partition`, `pick`,
	     * `pickBy`, `plant`, `property`, `propertyOf`, `pull`, `pullAll`, `pullAllBy`,
	     * `pullAllWith`, `pullAt`, `push`, `range`, `rangeRight`, `rearg`, `reject`,
	     * `remove`, `rest`, `reverse`, `sampleSize`, `set`, `setWith`, `shuffle`,
	     * `slice`, `sort`, `sortBy`, `splice`, `spread`, `tail`, `take`, `takeRight`,
	     * `takeRightWhile`, `takeWhile`, `tap`, `throttle`, `thru`, `toArray`,
	     * `toPairs`, `toPairsIn`, `toPath`, `toPlainObject`, `transform`, `unary`,
	     * `union`, `unionBy`, `unionWith`, `uniq`, `uniqBy`, `uniqWith`, `unset`,
	     * `unshift`, `unzip`, `unzipWith`, `update`, `updateWith`, `values`,
	     * `valuesIn`, `without`, `wrap`, `xor`, `xorBy`, `xorWith`, `zip`,
	     * `zipObject`, `zipObjectDeep`, and `zipWith`
	     *
	     * The wrapper methods that are **not** chainable by default are:
	     * `add`, `attempt`, `camelCase`, `capitalize`, `ceil`, `clamp`, `clone`,
	     * `cloneDeep`, `cloneDeepWith`, `cloneWith`, `conformsTo`, `deburr`,
	     * `defaultTo`, `divide`, `each`, `eachRight`, `endsWith`, `eq`, `escape`,
	     * `escapeRegExp`, `every`, `find`, `findIndex`, `findKey`, `findLast`,
	     * `findLastIndex`, `findLastKey`, `first`, `floor`, `forEach`, `forEachRight`,
	     * `forIn`, `forInRight`, `forOwn`, `forOwnRight`, `get`, `gt`, `gte`, `has`,
	     * `hasIn`, `head`, `identity`, `includes`, `indexOf`, `inRange`, `invoke`,
	     * `isArguments`, `isArray`, `isArrayBuffer`, `isArrayLike`, `isArrayLikeObject`,
	     * `isBoolean`, `isBuffer`, `isDate`, `isElement`, `isEmpty`, `isEqual`,
	     * `isEqualWith`, `isError`, `isFinite`, `isFunction`, `isInteger`, `isLength`,
	     * `isMap`, `isMatch`, `isMatchWith`, `isNaN`, `isNative`, `isNil`, `isNull`,
	     * `isNumber`, `isObject`, `isObjectLike`, `isPlainObject`, `isRegExp`,
	     * `isSafeInteger`, `isSet`, `isString`, `isUndefined`, `isTypedArray`,
	     * `isWeakMap`, `isWeakSet`, `join`, `kebabCase`, `last`, `lastIndexOf`,
	     * `lowerCase`, `lowerFirst`, `lt`, `lte`, `max`, `maxBy`, `mean`, `meanBy`,
	     * `min`, `minBy`, `multiply`, `noConflict`, `noop`, `now`, `nth`, `pad`,
	     * `padEnd`, `padStart`, `parseInt`, `pop`, `random`, `reduce`, `reduceRight`,
	     * `repeat`, `result`, `round`, `runInContext`, `sample`, `shift`, `size`,
	     * `snakeCase`, `some`, `sortedIndex`, `sortedIndexBy`, `sortedLastIndex`,
	     * `sortedLastIndexBy`, `startCase`, `startsWith`, `stubArray`, `stubFalse`,
	     * `stubObject`, `stubString`, `stubTrue`, `subtract`, `sum`, `sumBy`,
	     * `template`, `times`, `toFinite`, `toInteger`, `toJSON`, `toLength`,
	     * `toLower`, `toNumber`, `toSafeInteger`, `toString`, `toUpper`, `trim`,
	     * `trimEnd`, `trimStart`, `truncate`, `unescape`, `uniqueId`, `upperCase`,
	     * `upperFirst`, `value`, and `words`
	     *
	     * @name _
	     * @constructor
	     * @category Seq
	     * @param {*} value The value to wrap in a `lodash` instance.
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * function square(n) {
	     *   return n * n;
	     * }
	     *
	     * var wrapped = _([1, 2, 3]);
	     *
	     * // Returns an unwrapped value.
	     * wrapped.reduce(_.add);
	     * // => 6
	     *
	     * // Returns a wrapped value.
	     * var squares = wrapped.map(square);
	     *
	     * _.isArray(squares);
	     * // => false
	     *
	     * _.isArray(squares.value());
	     * // => true
	     */
	    function lodash(value) {
	      if (isObjectLike(value) && !isArray(value) && !(value instanceof LazyWrapper)) {
	        if (value instanceof LodashWrapper) {
	          return value;
	        }
	        if (hasOwnProperty.call(value, '__wrapped__')) {
	          return wrapperClone(value);
	        }
	      }
	      return new LodashWrapper(value);
	    }
	
	    /**
	     * The base implementation of `_.create` without support for assigning
	     * properties to the created object.
	     *
	     * @private
	     * @param {Object} proto The object to inherit from.
	     * @returns {Object} Returns the new object.
	     */
	    var baseCreate = (function() {
	      function object() {}
	      return function(proto) {
	        if (!isObject(proto)) {
	          return {};
	        }
	        if (objectCreate) {
	          return objectCreate(proto);
	        }
	        object.prototype = proto;
	        var result = new object;
	        object.prototype = undefined;
	        return result;
	      };
	    }());
	
	    /**
	     * The function whose prototype chain sequence wrappers inherit from.
	     *
	     * @private
	     */
	    function baseLodash() {
	      // No operation performed.
	    }
	
	    /**
	     * The base constructor for creating `lodash` wrapper objects.
	     *
	     * @private
	     * @param {*} value The value to wrap.
	     * @param {boolean} [chainAll] Enable explicit method chain sequences.
	     */
	    function LodashWrapper(value, chainAll) {
	      this.__wrapped__ = value;
	      this.__actions__ = [];
	      this.__chain__ = !!chainAll;
	      this.__index__ = 0;
	      this.__values__ = undefined;
	    }
	
	    /**
	     * By default, the template delimiters used by lodash are like those in
	     * embedded Ruby (ERB) as well as ES2015 template strings. Change the
	     * following template settings to use alternative delimiters.
	     *
	     * @static
	     * @memberOf _
	     * @type {Object}
	     */
	    lodash.templateSettings = {
	
	      /**
	       * Used to detect `data` property values to be HTML-escaped.
	       *
	       * @memberOf _.templateSettings
	       * @type {RegExp}
	       */
	      'escape': reEscape,
	
	      /**
	       * Used to detect code to be evaluated.
	       *
	       * @memberOf _.templateSettings
	       * @type {RegExp}
	       */
	      'evaluate': reEvaluate,
	
	      /**
	       * Used to detect `data` property values to inject.
	       *
	       * @memberOf _.templateSettings
	       * @type {RegExp}
	       */
	      'interpolate': reInterpolate,
	
	      /**
	       * Used to reference the data object in the template text.
	       *
	       * @memberOf _.templateSettings
	       * @type {string}
	       */
	      'variable': '',
	
	      /**
	       * Used to import variables into the compiled template.
	       *
	       * @memberOf _.templateSettings
	       * @type {Object}
	       */
	      'imports': {
	
	        /**
	         * A reference to the `lodash` function.
	         *
	         * @memberOf _.templateSettings.imports
	         * @type {Function}
	         */
	        '_': lodash
	      }
	    };
	
	    // Ensure wrappers are instances of `baseLodash`.
	    lodash.prototype = baseLodash.prototype;
	    lodash.prototype.constructor = lodash;
	
	    LodashWrapper.prototype = baseCreate(baseLodash.prototype);
	    LodashWrapper.prototype.constructor = LodashWrapper;
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates a lazy wrapper object which wraps `value` to enable lazy evaluation.
	     *
	     * @private
	     * @constructor
	     * @param {*} value The value to wrap.
	     */
	    function LazyWrapper(value) {
	      this.__wrapped__ = value;
	      this.__actions__ = [];
	      this.__dir__ = 1;
	      this.__filtered__ = false;
	      this.__iteratees__ = [];
	      this.__takeCount__ = MAX_ARRAY_LENGTH;
	      this.__views__ = [];
	    }
	
	    /**
	     * Creates a clone of the lazy wrapper object.
	     *
	     * @private
	     * @name clone
	     * @memberOf LazyWrapper
	     * @returns {Object} Returns the cloned `LazyWrapper` object.
	     */
	    function lazyClone() {
	      var result = new LazyWrapper(this.__wrapped__);
	      result.__actions__ = copyArray(this.__actions__);
	      result.__dir__ = this.__dir__;
	      result.__filtered__ = this.__filtered__;
	      result.__iteratees__ = copyArray(this.__iteratees__);
	      result.__takeCount__ = this.__takeCount__;
	      result.__views__ = copyArray(this.__views__);
	      return result;
	    }
	
	    /**
	     * Reverses the direction of lazy iteration.
	     *
	     * @private
	     * @name reverse
	     * @memberOf LazyWrapper
	     * @returns {Object} Returns the new reversed `LazyWrapper` object.
	     */
	    function lazyReverse() {
	      if (this.__filtered__) {
	        var result = new LazyWrapper(this);
	        result.__dir__ = -1;
	        result.__filtered__ = true;
	      } else {
	        result = this.clone();
	        result.__dir__ *= -1;
	      }
	      return result;
	    }
	
	    /**
	     * Extracts the unwrapped value from its lazy wrapper.
	     *
	     * @private
	     * @name value
	     * @memberOf LazyWrapper
	     * @returns {*} Returns the unwrapped value.
	     */
	    function lazyValue() {
	      var array = this.__wrapped__.value(),
	          dir = this.__dir__,
	          isArr = isArray(array),
	          isRight = dir < 0,
	          arrLength = isArr ? array.length : 0,
	          view = getView(0, arrLength, this.__views__),
	          start = view.start,
	          end = view.end,
	          length = end - start,
	          index = isRight ? end : (start - 1),
	          iteratees = this.__iteratees__,
	          iterLength = iteratees.length,
	          resIndex = 0,
	          takeCount = nativeMin(length, this.__takeCount__);
	
	      if (!isArr || (!isRight && arrLength == length && takeCount == length)) {
	        return baseWrapperValue(array, this.__actions__);
	      }
	      var result = [];
	
	      outer:
	      while (length-- && resIndex < takeCount) {
	        index += dir;
	
	        var iterIndex = -1,
	            value = array[index];
	
	        while (++iterIndex < iterLength) {
	          var data = iteratees[iterIndex],
	              iteratee = data.iteratee,
	              type = data.type,
	              computed = iteratee(value);
	
	          if (type == LAZY_MAP_FLAG) {
	            value = computed;
	          } else if (!computed) {
	            if (type == LAZY_FILTER_FLAG) {
	              continue outer;
	            } else {
	              break outer;
	            }
	          }
	        }
	        result[resIndex++] = value;
	      }
	      return result;
	    }
	
	    // Ensure `LazyWrapper` is an instance of `baseLodash`.
	    LazyWrapper.prototype = baseCreate(baseLodash.prototype);
	    LazyWrapper.prototype.constructor = LazyWrapper;
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates a hash object.
	     *
	     * @private
	     * @constructor
	     * @param {Array} [entries] The key-value pairs to cache.
	     */
	    function Hash(entries) {
	      var index = -1,
	          length = entries == null ? 0 : entries.length;
	
	      this.clear();
	      while (++index < length) {
	        var entry = entries[index];
	        this.set(entry[0], entry[1]);
	      }
	    }
	
	    /**
	     * Removes all key-value entries from the hash.
	     *
	     * @private
	     * @name clear
	     * @memberOf Hash
	     */
	    function hashClear() {
	      this.__data__ = nativeCreate ? nativeCreate(null) : {};
	      this.size = 0;
	    }
	
	    /**
	     * Removes `key` and its value from the hash.
	     *
	     * @private
	     * @name delete
	     * @memberOf Hash
	     * @param {Object} hash The hash to modify.
	     * @param {string} key The key of the value to remove.
	     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	     */
	    function hashDelete(key) {
	      var result = this.has(key) && delete this.__data__[key];
	      this.size -= result ? 1 : 0;
	      return result;
	    }
	
	    /**
	     * Gets the hash value for `key`.
	     *
	     * @private
	     * @name get
	     * @memberOf Hash
	     * @param {string} key The key of the value to get.
	     * @returns {*} Returns the entry value.
	     */
	    function hashGet(key) {
	      var data = this.__data__;
	      if (nativeCreate) {
	        var result = data[key];
	        return result === HASH_UNDEFINED ? undefined : result;
	      }
	      return hasOwnProperty.call(data, key) ? data[key] : undefined;
	    }
	
	    /**
	     * Checks if a hash value for `key` exists.
	     *
	     * @private
	     * @name has
	     * @memberOf Hash
	     * @param {string} key The key of the entry to check.
	     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	     */
	    function hashHas(key) {
	      var data = this.__data__;
	      return nativeCreate ? (data[key] !== undefined) : hasOwnProperty.call(data, key);
	    }
	
	    /**
	     * Sets the hash `key` to `value`.
	     *
	     * @private
	     * @name set
	     * @memberOf Hash
	     * @param {string} key The key of the value to set.
	     * @param {*} value The value to set.
	     * @returns {Object} Returns the hash instance.
	     */
	    function hashSet(key, value) {
	      var data = this.__data__;
	      this.size += this.has(key) ? 0 : 1;
	      data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
	      return this;
	    }
	
	    // Add methods to `Hash`.
	    Hash.prototype.clear = hashClear;
	    Hash.prototype['delete'] = hashDelete;
	    Hash.prototype.get = hashGet;
	    Hash.prototype.has = hashHas;
	    Hash.prototype.set = hashSet;
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates an list cache object.
	     *
	     * @private
	     * @constructor
	     * @param {Array} [entries] The key-value pairs to cache.
	     */
	    function ListCache(entries) {
	      var index = -1,
	          length = entries == null ? 0 : entries.length;
	
	      this.clear();
	      while (++index < length) {
	        var entry = entries[index];
	        this.set(entry[0], entry[1]);
	      }
	    }
	
	    /**
	     * Removes all key-value entries from the list cache.
	     *
	     * @private
	     * @name clear
	     * @memberOf ListCache
	     */
	    function listCacheClear() {
	      this.__data__ = [];
	      this.size = 0;
	    }
	
	    /**
	     * Removes `key` and its value from the list cache.
	     *
	     * @private
	     * @name delete
	     * @memberOf ListCache
	     * @param {string} key The key of the value to remove.
	     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	     */
	    function listCacheDelete(key) {
	      var data = this.__data__,
	          index = assocIndexOf(data, key);
	
	      if (index < 0) {
	        return false;
	      }
	      var lastIndex = data.length - 1;
	      if (index == lastIndex) {
	        data.pop();
	      } else {
	        splice.call(data, index, 1);
	      }
	      --this.size;
	      return true;
	    }
	
	    /**
	     * Gets the list cache value for `key`.
	     *
	     * @private
	     * @name get
	     * @memberOf ListCache
	     * @param {string} key The key of the value to get.
	     * @returns {*} Returns the entry value.
	     */
	    function listCacheGet(key) {
	      var data = this.__data__,
	          index = assocIndexOf(data, key);
	
	      return index < 0 ? undefined : data[index][1];
	    }
	
	    /**
	     * Checks if a list cache value for `key` exists.
	     *
	     * @private
	     * @name has
	     * @memberOf ListCache
	     * @param {string} key The key of the entry to check.
	     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	     */
	    function listCacheHas(key) {
	      return assocIndexOf(this.__data__, key) > -1;
	    }
	
	    /**
	     * Sets the list cache `key` to `value`.
	     *
	     * @private
	     * @name set
	     * @memberOf ListCache
	     * @param {string} key The key of the value to set.
	     * @param {*} value The value to set.
	     * @returns {Object} Returns the list cache instance.
	     */
	    function listCacheSet(key, value) {
	      var data = this.__data__,
	          index = assocIndexOf(data, key);
	
	      if (index < 0) {
	        ++this.size;
	        data.push([key, value]);
	      } else {
	        data[index][1] = value;
	      }
	      return this;
	    }
	
	    // Add methods to `ListCache`.
	    ListCache.prototype.clear = listCacheClear;
	    ListCache.prototype['delete'] = listCacheDelete;
	    ListCache.prototype.get = listCacheGet;
	    ListCache.prototype.has = listCacheHas;
	    ListCache.prototype.set = listCacheSet;
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates a map cache object to store key-value pairs.
	     *
	     * @private
	     * @constructor
	     * @param {Array} [entries] The key-value pairs to cache.
	     */
	    function MapCache(entries) {
	      var index = -1,
	          length = entries == null ? 0 : entries.length;
	
	      this.clear();
	      while (++index < length) {
	        var entry = entries[index];
	        this.set(entry[0], entry[1]);
	      }
	    }
	
	    /**
	     * Removes all key-value entries from the map.
	     *
	     * @private
	     * @name clear
	     * @memberOf MapCache
	     */
	    function mapCacheClear() {
	      this.size = 0;
	      this.__data__ = {
	        'hash': new Hash,
	        'map': new (Map || ListCache),
	        'string': new Hash
	      };
	    }
	
	    /**
	     * Removes `key` and its value from the map.
	     *
	     * @private
	     * @name delete
	     * @memberOf MapCache
	     * @param {string} key The key of the value to remove.
	     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	     */
	    function mapCacheDelete(key) {
	      var result = getMapData(this, key)['delete'](key);
	      this.size -= result ? 1 : 0;
	      return result;
	    }
	
	    /**
	     * Gets the map value for `key`.
	     *
	     * @private
	     * @name get
	     * @memberOf MapCache
	     * @param {string} key The key of the value to get.
	     * @returns {*} Returns the entry value.
	     */
	    function mapCacheGet(key) {
	      return getMapData(this, key).get(key);
	    }
	
	    /**
	     * Checks if a map value for `key` exists.
	     *
	     * @private
	     * @name has
	     * @memberOf MapCache
	     * @param {string} key The key of the entry to check.
	     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	     */
	    function mapCacheHas(key) {
	      return getMapData(this, key).has(key);
	    }
	
	    /**
	     * Sets the map `key` to `value`.
	     *
	     * @private
	     * @name set
	     * @memberOf MapCache
	     * @param {string} key The key of the value to set.
	     * @param {*} value The value to set.
	     * @returns {Object} Returns the map cache instance.
	     */
	    function mapCacheSet(key, value) {
	      var data = getMapData(this, key),
	          size = data.size;
	
	      data.set(key, value);
	      this.size += data.size == size ? 0 : 1;
	      return this;
	    }
	
	    // Add methods to `MapCache`.
	    MapCache.prototype.clear = mapCacheClear;
	    MapCache.prototype['delete'] = mapCacheDelete;
	    MapCache.prototype.get = mapCacheGet;
	    MapCache.prototype.has = mapCacheHas;
	    MapCache.prototype.set = mapCacheSet;
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     *
	     * Creates an array cache object to store unique values.
	     *
	     * @private
	     * @constructor
	     * @param {Array} [values] The values to cache.
	     */
	    function SetCache(values) {
	      var index = -1,
	          length = values == null ? 0 : values.length;
	
	      this.__data__ = new MapCache;
	      while (++index < length) {
	        this.add(values[index]);
	      }
	    }
	
	    /**
	     * Adds `value` to the array cache.
	     *
	     * @private
	     * @name add
	     * @memberOf SetCache
	     * @alias push
	     * @param {*} value The value to cache.
	     * @returns {Object} Returns the cache instance.
	     */
	    function setCacheAdd(value) {
	      this.__data__.set(value, HASH_UNDEFINED);
	      return this;
	    }
	
	    /**
	     * Checks if `value` is in the array cache.
	     *
	     * @private
	     * @name has
	     * @memberOf SetCache
	     * @param {*} value The value to search for.
	     * @returns {number} Returns `true` if `value` is found, else `false`.
	     */
	    function setCacheHas(value) {
	      return this.__data__.has(value);
	    }
	
	    // Add methods to `SetCache`.
	    SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
	    SetCache.prototype.has = setCacheHas;
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates a stack cache object to store key-value pairs.
	     *
	     * @private
	     * @constructor
	     * @param {Array} [entries] The key-value pairs to cache.
	     */
	    function Stack(entries) {
	      var data = this.__data__ = new ListCache(entries);
	      this.size = data.size;
	    }
	
	    /**
	     * Removes all key-value entries from the stack.
	     *
	     * @private
	     * @name clear
	     * @memberOf Stack
	     */
	    function stackClear() {
	      this.__data__ = new ListCache;
	      this.size = 0;
	    }
	
	    /**
	     * Removes `key` and its value from the stack.
	     *
	     * @private
	     * @name delete
	     * @memberOf Stack
	     * @param {string} key The key of the value to remove.
	     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	     */
	    function stackDelete(key) {
	      var data = this.__data__,
	          result = data['delete'](key);
	
	      this.size = data.size;
	      return result;
	    }
	
	    /**
	     * Gets the stack value for `key`.
	     *
	     * @private
	     * @name get
	     * @memberOf Stack
	     * @param {string} key The key of the value to get.
	     * @returns {*} Returns the entry value.
	     */
	    function stackGet(key) {
	      return this.__data__.get(key);
	    }
	
	    /**
	     * Checks if a stack value for `key` exists.
	     *
	     * @private
	     * @name has
	     * @memberOf Stack
	     * @param {string} key The key of the entry to check.
	     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	     */
	    function stackHas(key) {
	      return this.__data__.has(key);
	    }
	
	    /**
	     * Sets the stack `key` to `value`.
	     *
	     * @private
	     * @name set
	     * @memberOf Stack
	     * @param {string} key The key of the value to set.
	     * @param {*} value The value to set.
	     * @returns {Object} Returns the stack cache instance.
	     */
	    function stackSet(key, value) {
	      var data = this.__data__;
	      if (data instanceof ListCache) {
	        var pairs = data.__data__;
	        if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
	          pairs.push([key, value]);
	          this.size = ++data.size;
	          return this;
	        }
	        data = this.__data__ = new MapCache(pairs);
	      }
	      data.set(key, value);
	      this.size = data.size;
	      return this;
	    }
	
	    // Add methods to `Stack`.
	    Stack.prototype.clear = stackClear;
	    Stack.prototype['delete'] = stackDelete;
	    Stack.prototype.get = stackGet;
	    Stack.prototype.has = stackHas;
	    Stack.prototype.set = stackSet;
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates an array of the enumerable property names of the array-like `value`.
	     *
	     * @private
	     * @param {*} value The value to query.
	     * @param {boolean} inherited Specify returning inherited property names.
	     * @returns {Array} Returns the array of property names.
	     */
	    function arrayLikeKeys(value, inherited) {
	      var isArr = isArray(value),
	          isArg = !isArr && isArguments(value),
	          isBuff = !isArr && !isArg && isBuffer(value),
	          isType = !isArr && !isArg && !isBuff && isTypedArray(value),
	          skipIndexes = isArr || isArg || isBuff || isType,
	          result = skipIndexes ? baseTimes(value.length, String) : [],
	          length = result.length;
	
	      for (var key in value) {
	        if ((inherited || hasOwnProperty.call(value, key)) &&
	            !(skipIndexes && (
	               // Safari 9 has enumerable `arguments.length` in strict mode.
	               key == 'length' ||
	               // Node.js 0.10 has enumerable non-index properties on buffers.
	               (isBuff && (key == 'offset' || key == 'parent')) ||
	               // PhantomJS 2 has enumerable non-index properties on typed arrays.
	               (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
	               // Skip index properties.
	               isIndex(key, length)
	            ))) {
	          result.push(key);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * A specialized version of `_.sample` for arrays.
	     *
	     * @private
	     * @param {Array} array The array to sample.
	     * @returns {*} Returns the random element.
	     */
	    function arraySample(array) {
	      var length = array.length;
	      return length ? array[baseRandom(0, length - 1)] : undefined;
	    }
	
	    /**
	     * A specialized version of `_.sampleSize` for arrays.
	     *
	     * @private
	     * @param {Array} array The array to sample.
	     * @param {number} n The number of elements to sample.
	     * @returns {Array} Returns the random elements.
	     */
	    function arraySampleSize(array, n) {
	      return shuffleSelf(copyArray(array), baseClamp(n, 0, array.length));
	    }
	
	    /**
	     * A specialized version of `_.shuffle` for arrays.
	     *
	     * @private
	     * @param {Array} array The array to shuffle.
	     * @returns {Array} Returns the new shuffled array.
	     */
	    function arrayShuffle(array) {
	      return shuffleSelf(copyArray(array));
	    }
	
	    /**
	     * This function is like `assignValue` except that it doesn't assign
	     * `undefined` values.
	     *
	     * @private
	     * @param {Object} object The object to modify.
	     * @param {string} key The key of the property to assign.
	     * @param {*} value The value to assign.
	     */
	    function assignMergeValue(object, key, value) {
	      if ((value !== undefined && !eq(object[key], value)) ||
	          (value === undefined && !(key in object))) {
	        baseAssignValue(object, key, value);
	      }
	    }
	
	    /**
	     * Assigns `value` to `key` of `object` if the existing value is not equivalent
	     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * for equality comparisons.
	     *
	     * @private
	     * @param {Object} object The object to modify.
	     * @param {string} key The key of the property to assign.
	     * @param {*} value The value to assign.
	     */
	    function assignValue(object, key, value) {
	      var objValue = object[key];
	      if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) ||
	          (value === undefined && !(key in object))) {
	        baseAssignValue(object, key, value);
	      }
	    }
	
	    /**
	     * Gets the index at which the `key` is found in `array` of key-value pairs.
	     *
	     * @private
	     * @param {Array} array The array to inspect.
	     * @param {*} key The key to search for.
	     * @returns {number} Returns the index of the matched value, else `-1`.
	     */
	    function assocIndexOf(array, key) {
	      var length = array.length;
	      while (length--) {
	        if (eq(array[length][0], key)) {
	          return length;
	        }
	      }
	      return -1;
	    }
	
	    /**
	     * Aggregates elements of `collection` on `accumulator` with keys transformed
	     * by `iteratee` and values set by `setter`.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} setter The function to set `accumulator` values.
	     * @param {Function} iteratee The iteratee to transform keys.
	     * @param {Object} accumulator The initial aggregated object.
	     * @returns {Function} Returns `accumulator`.
	     */
	    function baseAggregator(collection, setter, iteratee, accumulator) {
	      baseEach(collection, function(value, key, collection) {
	        setter(accumulator, value, iteratee(value), collection);
	      });
	      return accumulator;
	    }
	
	    /**
	     * The base implementation of `_.assign` without support for multiple sources
	     * or `customizer` functions.
	     *
	     * @private
	     * @param {Object} object The destination object.
	     * @param {Object} source The source object.
	     * @returns {Object} Returns `object`.
	     */
	    function baseAssign(object, source) {
	      return object && copyObject(source, keys(source), object);
	    }
	
	    /**
	     * The base implementation of `_.assignIn` without support for multiple sources
	     * or `customizer` functions.
	     *
	     * @private
	     * @param {Object} object The destination object.
	     * @param {Object} source The source object.
	     * @returns {Object} Returns `object`.
	     */
	    function baseAssignIn(object, source) {
	      return object && copyObject(source, keysIn(source), object);
	    }
	
	    /**
	     * The base implementation of `assignValue` and `assignMergeValue` without
	     * value checks.
	     *
	     * @private
	     * @param {Object} object The object to modify.
	     * @param {string} key The key of the property to assign.
	     * @param {*} value The value to assign.
	     */
	    function baseAssignValue(object, key, value) {
	      if (key == '__proto__' && defineProperty) {
	        defineProperty(object, key, {
	          'configurable': true,
	          'enumerable': true,
	          'value': value,
	          'writable': true
	        });
	      } else {
	        object[key] = value;
	      }
	    }
	
	    /**
	     * The base implementation of `_.at` without support for individual paths.
	     *
	     * @private
	     * @param {Object} object The object to iterate over.
	     * @param {string[]} paths The property paths to pick.
	     * @returns {Array} Returns the picked elements.
	     */
	    function baseAt(object, paths) {
	      var index = -1,
	          length = paths.length,
	          result = Array(length),
	          skip = object == null;
	
	      while (++index < length) {
	        result[index] = skip ? undefined : get(object, paths[index]);
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.clamp` which doesn't coerce arguments.
	     *
	     * @private
	     * @param {number} number The number to clamp.
	     * @param {number} [lower] The lower bound.
	     * @param {number} upper The upper bound.
	     * @returns {number} Returns the clamped number.
	     */
	    function baseClamp(number, lower, upper) {
	      if (number === number) {
	        if (upper !== undefined) {
	          number = number <= upper ? number : upper;
	        }
	        if (lower !== undefined) {
	          number = number >= lower ? number : lower;
	        }
	      }
	      return number;
	    }
	
	    /**
	     * The base implementation of `_.clone` and `_.cloneDeep` which tracks
	     * traversed objects.
	     *
	     * @private
	     * @param {*} value The value to clone.
	     * @param {boolean} bitmask The bitmask flags.
	     *  1 - Deep clone
	     *  2 - Flatten inherited properties
	     *  4 - Clone symbols
	     * @param {Function} [customizer] The function to customize cloning.
	     * @param {string} [key] The key of `value`.
	     * @param {Object} [object] The parent object of `value`.
	     * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
	     * @returns {*} Returns the cloned value.
	     */
	    function baseClone(value, bitmask, customizer, key, object, stack) {
	      var result,
	          isDeep = bitmask & CLONE_DEEP_FLAG,
	          isFlat = bitmask & CLONE_FLAT_FLAG,
	          isFull = bitmask & CLONE_SYMBOLS_FLAG;
	
	      if (customizer) {
	        result = object ? customizer(value, key, object, stack) : customizer(value);
	      }
	      if (result !== undefined) {
	        return result;
	      }
	      if (!isObject(value)) {
	        return value;
	      }
	      var isArr = isArray(value);
	      if (isArr) {
	        result = initCloneArray(value);
	        if (!isDeep) {
	          return copyArray(value, result);
	        }
	      } else {
	        var tag = getTag(value),
	            isFunc = tag == funcTag || tag == genTag;
	
	        if (isBuffer(value)) {
	          return cloneBuffer(value, isDeep);
	        }
	        if (tag == objectTag || tag == argsTag || (isFunc && !object)) {
	          result = (isFlat || isFunc) ? {} : initCloneObject(value);
	          if (!isDeep) {
	            return isFlat
	              ? copySymbolsIn(value, baseAssignIn(result, value))
	              : copySymbols(value, baseAssign(result, value));
	          }
	        } else {
	          if (!cloneableTags[tag]) {
	            return object ? value : {};
	          }
	          result = initCloneByTag(value, tag, isDeep);
	        }
	      }
	      // Check for circular references and return its corresponding clone.
	      stack || (stack = new Stack);
	      var stacked = stack.get(value);
	      if (stacked) {
	        return stacked;
	      }
	      stack.set(value, result);
	
	      if (isSet(value)) {
	        value.forEach(function(subValue) {
	          result.add(baseClone(subValue, bitmask, customizer, subValue, value, stack));
	        });
	      } else if (isMap(value)) {
	        value.forEach(function(subValue, key) {
	          result.set(key, baseClone(subValue, bitmask, customizer, key, value, stack));
	        });
	      }
	
	      var keysFunc = isFull
	        ? (isFlat ? getAllKeysIn : getAllKeys)
	        : (isFlat ? keysIn : keys);
	
	      var props = isArr ? undefined : keysFunc(value);
	      arrayEach(props || value, function(subValue, key) {
	        if (props) {
	          key = subValue;
	          subValue = value[key];
	        }
	        // Recursively populate clone (susceptible to call stack limits).
	        assignValue(result, key, baseClone(subValue, bitmask, customizer, key, value, stack));
	      });
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.conforms` which doesn't clone `source`.
	     *
	     * @private
	     * @param {Object} source The object of property predicates to conform to.
	     * @returns {Function} Returns the new spec function.
	     */
	    function baseConforms(source) {
	      var props = keys(source);
	      return function(object) {
	        return baseConformsTo(object, source, props);
	      };
	    }
	
	    /**
	     * The base implementation of `_.conformsTo` which accepts `props` to check.
	     *
	     * @private
	     * @param {Object} object The object to inspect.
	     * @param {Object} source The object of property predicates to conform to.
	     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
	     */
	    function baseConformsTo(object, source, props) {
	      var length = props.length;
	      if (object == null) {
	        return !length;
	      }
	      object = Object(object);
	      while (length--) {
	        var key = props[length],
	            predicate = source[key],
	            value = object[key];
	
	        if ((value === undefined && !(key in object)) || !predicate(value)) {
	          return false;
	        }
	      }
	      return true;
	    }
	
	    /**
	     * The base implementation of `_.delay` and `_.defer` which accepts `args`
	     * to provide to `func`.
	     *
	     * @private
	     * @param {Function} func The function to delay.
	     * @param {number} wait The number of milliseconds to delay invocation.
	     * @param {Array} args The arguments to provide to `func`.
	     * @returns {number|Object} Returns the timer id or timeout object.
	     */
	    function baseDelay(func, wait, args) {
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      return setTimeout(function() { func.apply(undefined, args); }, wait);
	    }
	
	    /**
	     * The base implementation of methods like `_.difference` without support
	     * for excluding multiple arrays or iteratee shorthands.
	     *
	     * @private
	     * @param {Array} array The array to inspect.
	     * @param {Array} values The values to exclude.
	     * @param {Function} [iteratee] The iteratee invoked per element.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new array of filtered values.
	     */
	    function baseDifference(array, values, iteratee, comparator) {
	      var index = -1,
	          includes = arrayIncludes,
	          isCommon = true,
	          length = array.length,
	          result = [],
	          valuesLength = values.length;
	
	      if (!length) {
	        return result;
	      }
	      if (iteratee) {
	        values = arrayMap(values, baseUnary(iteratee));
	      }
	      if (comparator) {
	        includes = arrayIncludesWith;
	        isCommon = false;
	      }
	      else if (values.length >= LARGE_ARRAY_SIZE) {
	        includes = cacheHas;
	        isCommon = false;
	        values = new SetCache(values);
	      }
	      outer:
	      while (++index < length) {
	        var value = array[index],
	            computed = iteratee == null ? value : iteratee(value);
	
	        value = (comparator || value !== 0) ? value : 0;
	        if (isCommon && computed === computed) {
	          var valuesIndex = valuesLength;
	          while (valuesIndex--) {
	            if (values[valuesIndex] === computed) {
	              continue outer;
	            }
	          }
	          result.push(value);
	        }
	        else if (!includes(values, computed, comparator)) {
	          result.push(value);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.forEach` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @returns {Array|Object} Returns `collection`.
	     */
	    var baseEach = createBaseEach(baseForOwn);
	
	    /**
	     * The base implementation of `_.forEachRight` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @returns {Array|Object} Returns `collection`.
	     */
	    var baseEachRight = createBaseEach(baseForOwnRight, true);
	
	    /**
	     * The base implementation of `_.every` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} predicate The function invoked per iteration.
	     * @returns {boolean} Returns `true` if all elements pass the predicate check,
	     *  else `false`
	     */
	    function baseEvery(collection, predicate) {
	      var result = true;
	      baseEach(collection, function(value, index, collection) {
	        result = !!predicate(value, index, collection);
	        return result;
	      });
	      return result;
	    }
	
	    /**
	     * The base implementation of methods like `_.max` and `_.min` which accepts a
	     * `comparator` to determine the extremum value.
	     *
	     * @private
	     * @param {Array} array The array to iterate over.
	     * @param {Function} iteratee The iteratee invoked per iteration.
	     * @param {Function} comparator The comparator used to compare values.
	     * @returns {*} Returns the extremum value.
	     */
	    function baseExtremum(array, iteratee, comparator) {
	      var index = -1,
	          length = array.length;
	
	      while (++index < length) {
	        var value = array[index],
	            current = iteratee(value);
	
	        if (current != null && (computed === undefined
	              ? (current === current && !isSymbol(current))
	              : comparator(current, computed)
	            )) {
	          var computed = current,
	              result = value;
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.fill` without an iteratee call guard.
	     *
	     * @private
	     * @param {Array} array The array to fill.
	     * @param {*} value The value to fill `array` with.
	     * @param {number} [start=0] The start position.
	     * @param {number} [end=array.length] The end position.
	     * @returns {Array} Returns `array`.
	     */
	    function baseFill(array, value, start, end) {
	      var length = array.length;
	
	      start = toInteger(start);
	      if (start < 0) {
	        start = -start > length ? 0 : (length + start);
	      }
	      end = (end === undefined || end > length) ? length : toInteger(end);
	      if (end < 0) {
	        end += length;
	      }
	      end = start > end ? 0 : toLength(end);
	      while (start < end) {
	        array[start++] = value;
	      }
	      return array;
	    }
	
	    /**
	     * The base implementation of `_.filter` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} predicate The function invoked per iteration.
	     * @returns {Array} Returns the new filtered array.
	     */
	    function baseFilter(collection, predicate) {
	      var result = [];
	      baseEach(collection, function(value, index, collection) {
	        if (predicate(value, index, collection)) {
	          result.push(value);
	        }
	      });
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.flatten` with support for restricting flattening.
	     *
	     * @private
	     * @param {Array} array The array to flatten.
	     * @param {number} depth The maximum recursion depth.
	     * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
	     * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
	     * @param {Array} [result=[]] The initial result value.
	     * @returns {Array} Returns the new flattened array.
	     */
	    function baseFlatten(array, depth, predicate, isStrict, result) {
	      var index = -1,
	          length = array.length;
	
	      predicate || (predicate = isFlattenable);
	      result || (result = []);
	
	      while (++index < length) {
	        var value = array[index];
	        if (depth > 0 && predicate(value)) {
	          if (depth > 1) {
	            // Recursively flatten arrays (susceptible to call stack limits).
	            baseFlatten(value, depth - 1, predicate, isStrict, result);
	          } else {
	            arrayPush(result, value);
	          }
	        } else if (!isStrict) {
	          result[result.length] = value;
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `baseForOwn` which iterates over `object`
	     * properties returned by `keysFunc` and invokes `iteratee` for each property.
	     * Iteratee functions may exit iteration early by explicitly returning `false`.
	     *
	     * @private
	     * @param {Object} object The object to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @param {Function} keysFunc The function to get the keys of `object`.
	     * @returns {Object} Returns `object`.
	     */
	    var baseFor = createBaseFor();
	
	    /**
	     * This function is like `baseFor` except that it iterates over properties
	     * in the opposite order.
	     *
	     * @private
	     * @param {Object} object The object to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @param {Function} keysFunc The function to get the keys of `object`.
	     * @returns {Object} Returns `object`.
	     */
	    var baseForRight = createBaseFor(true);
	
	    /**
	     * The base implementation of `_.forOwn` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Object} object The object to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @returns {Object} Returns `object`.
	     */
	    function baseForOwn(object, iteratee) {
	      return object && baseFor(object, iteratee, keys);
	    }
	
	    /**
	     * The base implementation of `_.forOwnRight` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Object} object The object to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @returns {Object} Returns `object`.
	     */
	    function baseForOwnRight(object, iteratee) {
	      return object && baseForRight(object, iteratee, keys);
	    }
	
	    /**
	     * The base implementation of `_.functions` which creates an array of
	     * `object` function property names filtered from `props`.
	     *
	     * @private
	     * @param {Object} object The object to inspect.
	     * @param {Array} props The property names to filter.
	     * @returns {Array} Returns the function names.
	     */
	    function baseFunctions(object, props) {
	      return arrayFilter(props, function(key) {
	        return isFunction(object[key]);
	      });
	    }
	
	    /**
	     * The base implementation of `_.get` without support for default values.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path of the property to get.
	     * @returns {*} Returns the resolved value.
	     */
	    function baseGet(object, path) {
	      path = castPath(path, object);
	
	      var index = 0,
	          length = path.length;
	
	      while (object != null && index < length) {
	        object = object[toKey(path[index++])];
	      }
	      return (index && index == length) ? object : undefined;
	    }
	
	    /**
	     * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
	     * `keysFunc` and `symbolsFunc` to get the enumerable property names and
	     * symbols of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {Function} keysFunc The function to get the keys of `object`.
	     * @param {Function} symbolsFunc The function to get the symbols of `object`.
	     * @returns {Array} Returns the array of property names and symbols.
	     */
	    function baseGetAllKeys(object, keysFunc, symbolsFunc) {
	      var result = keysFunc(object);
	      return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
	    }
	
	    /**
	     * The base implementation of `getTag` without fallbacks for buggy environments.
	     *
	     * @private
	     * @param {*} value The value to query.
	     * @returns {string} Returns the `toStringTag`.
	     */
	    function baseGetTag(value) {
	      if (value == null) {
	        return value === undefined ? undefinedTag : nullTag;
	      }
	      return (symToStringTag && symToStringTag in Object(value))
	        ? getRawTag(value)
	        : objectToString(value);
	    }
	
	    /**
	     * The base implementation of `_.gt` which doesn't coerce arguments.
	     *
	     * @private
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if `value` is greater than `other`,
	     *  else `false`.
	     */
	    function baseGt(value, other) {
	      return value > other;
	    }
	
	    /**
	     * The base implementation of `_.has` without support for deep paths.
	     *
	     * @private
	     * @param {Object} [object] The object to query.
	     * @param {Array|string} key The key to check.
	     * @returns {boolean} Returns `true` if `key` exists, else `false`.
	     */
	    function baseHas(object, key) {
	      return object != null && hasOwnProperty.call(object, key);
	    }
	
	    /**
	     * The base implementation of `_.hasIn` without support for deep paths.
	     *
	     * @private
	     * @param {Object} [object] The object to query.
	     * @param {Array|string} key The key to check.
	     * @returns {boolean} Returns `true` if `key` exists, else `false`.
	     */
	    function baseHasIn(object, key) {
	      return object != null && key in Object(object);
	    }
	
	    /**
	     * The base implementation of `_.inRange` which doesn't coerce arguments.
	     *
	     * @private
	     * @param {number} number The number to check.
	     * @param {number} start The start of the range.
	     * @param {number} end The end of the range.
	     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
	     */
	    function baseInRange(number, start, end) {
	      return number >= nativeMin(start, end) && number < nativeMax(start, end);
	    }
	
	    /**
	     * The base implementation of methods like `_.intersection`, without support
	     * for iteratee shorthands, that accepts an array of arrays to inspect.
	     *
	     * @private
	     * @param {Array} arrays The arrays to inspect.
	     * @param {Function} [iteratee] The iteratee invoked per element.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new array of shared values.
	     */
	    function baseIntersection(arrays, iteratee, comparator) {
	      var includes = comparator ? arrayIncludesWith : arrayIncludes,
	          length = arrays[0].length,
	          othLength = arrays.length,
	          othIndex = othLength,
	          caches = Array(othLength),
	          maxLength = Infinity,
	          result = [];
	
	      while (othIndex--) {
	        var array = arrays[othIndex];
	        if (othIndex && iteratee) {
	          array = arrayMap(array, baseUnary(iteratee));
	        }
	        maxLength = nativeMin(array.length, maxLength);
	        caches[othIndex] = !comparator && (iteratee || (length >= 120 && array.length >= 120))
	          ? new SetCache(othIndex && array)
	          : undefined;
	      }
	      array = arrays[0];
	
	      var index = -1,
	          seen = caches[0];
	
	      outer:
	      while (++index < length && result.length < maxLength) {
	        var value = array[index],
	            computed = iteratee ? iteratee(value) : value;
	
	        value = (comparator || value !== 0) ? value : 0;
	        if (!(seen
	              ? cacheHas(seen, computed)
	              : includes(result, computed, comparator)
	            )) {
	          othIndex = othLength;
	          while (--othIndex) {
	            var cache = caches[othIndex];
	            if (!(cache
	                  ? cacheHas(cache, computed)
	                  : includes(arrays[othIndex], computed, comparator))
	                ) {
	              continue outer;
	            }
	          }
	          if (seen) {
	            seen.push(computed);
	          }
	          result.push(value);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.invert` and `_.invertBy` which inverts
	     * `object` with values transformed by `iteratee` and set by `setter`.
	     *
	     * @private
	     * @param {Object} object The object to iterate over.
	     * @param {Function} setter The function to set `accumulator` values.
	     * @param {Function} iteratee The iteratee to transform values.
	     * @param {Object} accumulator The initial inverted object.
	     * @returns {Function} Returns `accumulator`.
	     */
	    function baseInverter(object, setter, iteratee, accumulator) {
	      baseForOwn(object, function(value, key, object) {
	        setter(accumulator, iteratee(value), key, object);
	      });
	      return accumulator;
	    }
	
	    /**
	     * The base implementation of `_.invoke` without support for individual
	     * method arguments.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path of the method to invoke.
	     * @param {Array} args The arguments to invoke the method with.
	     * @returns {*} Returns the result of the invoked method.
	     */
	    function baseInvoke(object, path, args) {
	      path = castPath(path, object);
	      object = parent(object, path);
	      var func = object == null ? object : object[toKey(last(path))];
	      return func == null ? undefined : apply(func, object, args);
	    }
	
	    /**
	     * The base implementation of `_.isArguments`.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
	     */
	    function baseIsArguments(value) {
	      return isObjectLike(value) && baseGetTag(value) == argsTag;
	    }
	
	    /**
	     * The base implementation of `_.isArrayBuffer` without Node.js optimizations.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
	     */
	    function baseIsArrayBuffer(value) {
	      return isObjectLike(value) && baseGetTag(value) == arrayBufferTag;
	    }
	
	    /**
	     * The base implementation of `_.isDate` without Node.js optimizations.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
	     */
	    function baseIsDate(value) {
	      return isObjectLike(value) && baseGetTag(value) == dateTag;
	    }
	
	    /**
	     * The base implementation of `_.isEqual` which supports partial comparisons
	     * and tracks traversed objects.
	     *
	     * @private
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @param {boolean} bitmask The bitmask flags.
	     *  1 - Unordered comparison
	     *  2 - Partial comparison
	     * @param {Function} [customizer] The function to customize comparisons.
	     * @param {Object} [stack] Tracks traversed `value` and `other` objects.
	     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	     */
	    function baseIsEqual(value, other, bitmask, customizer, stack) {
	      if (value === other) {
	        return true;
	      }
	      if (value == null || other == null || (!isObjectLike(value) && !isObjectLike(other))) {
	        return value !== value && other !== other;
	      }
	      return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
	    }
	
	    /**
	     * A specialized version of `baseIsEqual` for arrays and objects which performs
	     * deep comparisons and tracks traversed objects enabling objects with circular
	     * references to be compared.
	     *
	     * @private
	     * @param {Object} object The object to compare.
	     * @param {Object} other The other object to compare.
	     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	     * @param {Function} customizer The function to customize comparisons.
	     * @param {Function} equalFunc The function to determine equivalents of values.
	     * @param {Object} [stack] Tracks traversed `object` and `other` objects.
	     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	     */
	    function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
	      var objIsArr = isArray(object),
	          othIsArr = isArray(other),
	          objTag = objIsArr ? arrayTag : getTag(object),
	          othTag = othIsArr ? arrayTag : getTag(other);
	
	      objTag = objTag == argsTag ? objectTag : objTag;
	      othTag = othTag == argsTag ? objectTag : othTag;
	
	      var objIsObj = objTag == objectTag,
	          othIsObj = othTag == objectTag,
	          isSameTag = objTag == othTag;
	
	      if (isSameTag && isBuffer(object)) {
	        if (!isBuffer(other)) {
	          return false;
	        }
	        objIsArr = true;
	        objIsObj = false;
	      }
	      if (isSameTag && !objIsObj) {
	        stack || (stack = new Stack);
	        return (objIsArr || isTypedArray(object))
	          ? equalArrays(object, other, bitmask, customizer, equalFunc, stack)
	          : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
	      }
	      if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
	        var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
	            othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');
	
	        if (objIsWrapped || othIsWrapped) {
	          var objUnwrapped = objIsWrapped ? object.value() : object,
	              othUnwrapped = othIsWrapped ? other.value() : other;
	
	          stack || (stack = new Stack);
	          return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
	        }
	      }
	      if (!isSameTag) {
	        return false;
	      }
	      stack || (stack = new Stack);
	      return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
	    }
	
	    /**
	     * The base implementation of `_.isMap` without Node.js optimizations.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
	     */
	    function baseIsMap(value) {
	      return isObjectLike(value) && getTag(value) == mapTag;
	    }
	
	    /**
	     * The base implementation of `_.isMatch` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Object} object The object to inspect.
	     * @param {Object} source The object of property values to match.
	     * @param {Array} matchData The property names, values, and compare flags to match.
	     * @param {Function} [customizer] The function to customize comparisons.
	     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
	     */
	    function baseIsMatch(object, source, matchData, customizer) {
	      var index = matchData.length,
	          length = index,
	          noCustomizer = !customizer;
	
	      if (object == null) {
	        return !length;
	      }
	      object = Object(object);
	      while (index--) {
	        var data = matchData[index];
	        if ((noCustomizer && data[2])
	              ? data[1] !== object[data[0]]
	              : !(data[0] in object)
	            ) {
	          return false;
	        }
	      }
	      while (++index < length) {
	        data = matchData[index];
	        var key = data[0],
	            objValue = object[key],
	            srcValue = data[1];
	
	        if (noCustomizer && data[2]) {
	          if (objValue === undefined && !(key in object)) {
	            return false;
	          }
	        } else {
	          var stack = new Stack;
	          if (customizer) {
	            var result = customizer(objValue, srcValue, key, object, source, stack);
	          }
	          if (!(result === undefined
	                ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack)
	                : result
	              )) {
	            return false;
	          }
	        }
	      }
	      return true;
	    }
	
	    /**
	     * The base implementation of `_.isNative` without bad shim checks.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a native function,
	     *  else `false`.
	     */
	    function baseIsNative(value) {
	      if (!isObject(value) || isMasked(value)) {
	        return false;
	      }
	      var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
	      return pattern.test(toSource(value));
	    }
	
	    /**
	     * The base implementation of `_.isRegExp` without Node.js optimizations.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
	     */
	    function baseIsRegExp(value) {
	      return isObjectLike(value) && baseGetTag(value) == regexpTag;
	    }
	
	    /**
	     * The base implementation of `_.isSet` without Node.js optimizations.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
	     */
	    function baseIsSet(value) {
	      return isObjectLike(value) && getTag(value) == setTag;
	    }
	
	    /**
	     * The base implementation of `_.isTypedArray` without Node.js optimizations.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
	     */
	    function baseIsTypedArray(value) {
	      return isObjectLike(value) &&
	        isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
	    }
	
	    /**
	     * The base implementation of `_.iteratee`.
	     *
	     * @private
	     * @param {*} [value=_.identity] The value to convert to an iteratee.
	     * @returns {Function} Returns the iteratee.
	     */
	    function baseIteratee(value) {
	      // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
	      // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
	      if (typeof value == 'function') {
	        return value;
	      }
	      if (value == null) {
	        return identity;
	      }
	      if (typeof value == 'object') {
	        return isArray(value)
	          ? baseMatchesProperty(value[0], value[1])
	          : baseMatches(value);
	      }
	      return property(value);
	    }
	
	    /**
	     * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property names.
	     */
	    function baseKeys(object) {
	      if (!isPrototype(object)) {
	        return nativeKeys(object);
	      }
	      var result = [];
	      for (var key in Object(object)) {
	        if (hasOwnProperty.call(object, key) && key != 'constructor') {
	          result.push(key);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property names.
	     */
	    function baseKeysIn(object) {
	      if (!isObject(object)) {
	        return nativeKeysIn(object);
	      }
	      var isProto = isPrototype(object),
	          result = [];
	
	      for (var key in object) {
	        if (!(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) {
	          result.push(key);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.lt` which doesn't coerce arguments.
	     *
	     * @private
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if `value` is less than `other`,
	     *  else `false`.
	     */
	    function baseLt(value, other) {
	      return value < other;
	    }
	
	    /**
	     * The base implementation of `_.map` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @returns {Array} Returns the new mapped array.
	     */
	    function baseMap(collection, iteratee) {
	      var index = -1,
	          result = isArrayLike(collection) ? Array(collection.length) : [];
	
	      baseEach(collection, function(value, key, collection) {
	        result[++index] = iteratee(value, key, collection);
	      });
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.matches` which doesn't clone `source`.
	     *
	     * @private
	     * @param {Object} source The object of property values to match.
	     * @returns {Function} Returns the new spec function.
	     */
	    function baseMatches(source) {
	      var matchData = getMatchData(source);
	      if (matchData.length == 1 && matchData[0][2]) {
	        return matchesStrictComparable(matchData[0][0], matchData[0][1]);
	      }
	      return function(object) {
	        return object === source || baseIsMatch(object, source, matchData);
	      };
	    }
	
	    /**
	     * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
	     *
	     * @private
	     * @param {string} path The path of the property to get.
	     * @param {*} srcValue The value to match.
	     * @returns {Function} Returns the new spec function.
	     */
	    function baseMatchesProperty(path, srcValue) {
	      if (isKey(path) && isStrictComparable(srcValue)) {
	        return matchesStrictComparable(toKey(path), srcValue);
	      }
	      return function(object) {
	        var objValue = get(object, path);
	        return (objValue === undefined && objValue === srcValue)
	          ? hasIn(object, path)
	          : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
	      };
	    }
	
	    /**
	     * The base implementation of `_.merge` without support for multiple sources.
	     *
	     * @private
	     * @param {Object} object The destination object.
	     * @param {Object} source The source object.
	     * @param {number} srcIndex The index of `source`.
	     * @param {Function} [customizer] The function to customize merged values.
	     * @param {Object} [stack] Tracks traversed source values and their merged
	     *  counterparts.
	     */
	    function baseMerge(object, source, srcIndex, customizer, stack) {
	      if (object === source) {
	        return;
	      }
	      baseFor(source, function(srcValue, key) {
	        stack || (stack = new Stack);
	        if (isObject(srcValue)) {
	          baseMergeDeep(object, source, key, srcIndex, baseMerge, customizer, stack);
	        }
	        else {
	          var newValue = customizer
	            ? customizer(safeGet(object, key), srcValue, (key + ''), object, source, stack)
	            : undefined;
	
	          if (newValue === undefined) {
	            newValue = srcValue;
	          }
	          assignMergeValue(object, key, newValue);
	        }
	      }, keysIn);
	    }
	
	    /**
	     * A specialized version of `baseMerge` for arrays and objects which performs
	     * deep merges and tracks traversed objects enabling objects with circular
	     * references to be merged.
	     *
	     * @private
	     * @param {Object} object The destination object.
	     * @param {Object} source The source object.
	     * @param {string} key The key of the value to merge.
	     * @param {number} srcIndex The index of `source`.
	     * @param {Function} mergeFunc The function to merge values.
	     * @param {Function} [customizer] The function to customize assigned values.
	     * @param {Object} [stack] Tracks traversed source values and their merged
	     *  counterparts.
	     */
	    function baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
	      var objValue = safeGet(object, key),
	          srcValue = safeGet(source, key),
	          stacked = stack.get(srcValue);
	
	      if (stacked) {
	        assignMergeValue(object, key, stacked);
	        return;
	      }
	      var newValue = customizer
	        ? customizer(objValue, srcValue, (key + ''), object, source, stack)
	        : undefined;
	
	      var isCommon = newValue === undefined;
	
	      if (isCommon) {
	        var isArr = isArray(srcValue),
	            isBuff = !isArr && isBuffer(srcValue),
	            isTyped = !isArr && !isBuff && isTypedArray(srcValue);
	
	        newValue = srcValue;
	        if (isArr || isBuff || isTyped) {
	          if (isArray(objValue)) {
	            newValue = objValue;
	          }
	          else if (isArrayLikeObject(objValue)) {
	            newValue = copyArray(objValue);
	          }
	          else if (isBuff) {
	            isCommon = false;
	            newValue = cloneBuffer(srcValue, true);
	          }
	          else if (isTyped) {
	            isCommon = false;
	            newValue = cloneTypedArray(srcValue, true);
	          }
	          else {
	            newValue = [];
	          }
	        }
	        else if (isPlainObject(srcValue) || isArguments(srcValue)) {
	          newValue = objValue;
	          if (isArguments(objValue)) {
	            newValue = toPlainObject(objValue);
	          }
	          else if (!isObject(objValue) || isFunction(objValue)) {
	            newValue = initCloneObject(srcValue);
	          }
	        }
	        else {
	          isCommon = false;
	        }
	      }
	      if (isCommon) {
	        // Recursively merge objects and arrays (susceptible to call stack limits).
	        stack.set(srcValue, newValue);
	        mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
	        stack['delete'](srcValue);
	      }
	      assignMergeValue(object, key, newValue);
	    }
	
	    /**
	     * The base implementation of `_.nth` which doesn't coerce arguments.
	     *
	     * @private
	     * @param {Array} array The array to query.
	     * @param {number} n The index of the element to return.
	     * @returns {*} Returns the nth element of `array`.
	     */
	    function baseNth(array, n) {
	      var length = array.length;
	      if (!length) {
	        return;
	      }
	      n += n < 0 ? length : 0;
	      return isIndex(n, length) ? array[n] : undefined;
	    }
	
	    /**
	     * The base implementation of `_.orderBy` without param guards.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function[]|Object[]|string[]} iteratees The iteratees to sort by.
	     * @param {string[]} orders The sort orders of `iteratees`.
	     * @returns {Array} Returns the new sorted array.
	     */
	    function baseOrderBy(collection, iteratees, orders) {
	      var index = -1;
	      iteratees = arrayMap(iteratees.length ? iteratees : [identity], baseUnary(getIteratee()));
	
	      var result = baseMap(collection, function(value, key, collection) {
	        var criteria = arrayMap(iteratees, function(iteratee) {
	          return iteratee(value);
	        });
	        return { 'criteria': criteria, 'index': ++index, 'value': value };
	      });
	
	      return baseSortBy(result, function(object, other) {
	        return compareMultiple(object, other, orders);
	      });
	    }
	
	    /**
	     * The base implementation of `_.pick` without support for individual
	     * property identifiers.
	     *
	     * @private
	     * @param {Object} object The source object.
	     * @param {string[]} paths The property paths to pick.
	     * @returns {Object} Returns the new object.
	     */
	    function basePick(object, paths) {
	      return basePickBy(object, paths, function(value, path) {
	        return hasIn(object, path);
	      });
	    }
	
	    /**
	     * The base implementation of  `_.pickBy` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Object} object The source object.
	     * @param {string[]} paths The property paths to pick.
	     * @param {Function} predicate The function invoked per property.
	     * @returns {Object} Returns the new object.
	     */
	    function basePickBy(object, paths, predicate) {
	      var index = -1,
	          length = paths.length,
	          result = {};
	
	      while (++index < length) {
	        var path = paths[index],
	            value = baseGet(object, path);
	
	        if (predicate(value, path)) {
	          baseSet(result, castPath(path, object), value);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * A specialized version of `baseProperty` which supports deep paths.
	     *
	     * @private
	     * @param {Array|string} path The path of the property to get.
	     * @returns {Function} Returns the new accessor function.
	     */
	    function basePropertyDeep(path) {
	      return function(object) {
	        return baseGet(object, path);
	      };
	    }
	
	    /**
	     * The base implementation of `_.pullAllBy` without support for iteratee
	     * shorthands.
	     *
	     * @private
	     * @param {Array} array The array to modify.
	     * @param {Array} values The values to remove.
	     * @param {Function} [iteratee] The iteratee invoked per element.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns `array`.
	     */
	    function basePullAll(array, values, iteratee, comparator) {
	      var indexOf = comparator ? baseIndexOfWith : baseIndexOf,
	          index = -1,
	          length = values.length,
	          seen = array;
	
	      if (array === values) {
	        values = copyArray(values);
	      }
	      if (iteratee) {
	        seen = arrayMap(array, baseUnary(iteratee));
	      }
	      while (++index < length) {
	        var fromIndex = 0,
	            value = values[index],
	            computed = iteratee ? iteratee(value) : value;
	
	        while ((fromIndex = indexOf(seen, computed, fromIndex, comparator)) > -1) {
	          if (seen !== array) {
	            splice.call(seen, fromIndex, 1);
	          }
	          splice.call(array, fromIndex, 1);
	        }
	      }
	      return array;
	    }
	
	    /**
	     * The base implementation of `_.pullAt` without support for individual
	     * indexes or capturing the removed elements.
	     *
	     * @private
	     * @param {Array} array The array to modify.
	     * @param {number[]} indexes The indexes of elements to remove.
	     * @returns {Array} Returns `array`.
	     */
	    function basePullAt(array, indexes) {
	      var length = array ? indexes.length : 0,
	          lastIndex = length - 1;
	
	      while (length--) {
	        var index = indexes[length];
	        if (length == lastIndex || index !== previous) {
	          var previous = index;
	          if (isIndex(index)) {
	            splice.call(array, index, 1);
	          } else {
	            baseUnset(array, index);
	          }
	        }
	      }
	      return array;
	    }
	
	    /**
	     * The base implementation of `_.random` without support for returning
	     * floating-point numbers.
	     *
	     * @private
	     * @param {number} lower The lower bound.
	     * @param {number} upper The upper bound.
	     * @returns {number} Returns the random number.
	     */
	    function baseRandom(lower, upper) {
	      return lower + nativeFloor(nativeRandom() * (upper - lower + 1));
	    }
	
	    /**
	     * The base implementation of `_.range` and `_.rangeRight` which doesn't
	     * coerce arguments.
	     *
	     * @private
	     * @param {number} start The start of the range.
	     * @param {number} end The end of the range.
	     * @param {number} step The value to increment or decrement by.
	     * @param {boolean} [fromRight] Specify iterating from right to left.
	     * @returns {Array} Returns the range of numbers.
	     */
	    function baseRange(start, end, step, fromRight) {
	      var index = -1,
	          length = nativeMax(nativeCeil((end - start) / (step || 1)), 0),
	          result = Array(length);
	
	      while (length--) {
	        result[fromRight ? length : ++index] = start;
	        start += step;
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.repeat` which doesn't coerce arguments.
	     *
	     * @private
	     * @param {string} string The string to repeat.
	     * @param {number} n The number of times to repeat the string.
	     * @returns {string} Returns the repeated string.
	     */
	    function baseRepeat(string, n) {
	      var result = '';
	      if (!string || n < 1 || n > MAX_SAFE_INTEGER) {
	        return result;
	      }
	      // Leverage the exponentiation by squaring algorithm for a faster repeat.
	      // See https://en.wikipedia.org/wiki/Exponentiation_by_squaring for more details.
	      do {
	        if (n % 2) {
	          result += string;
	        }
	        n = nativeFloor(n / 2);
	        if (n) {
	          string += string;
	        }
	      } while (n);
	
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.rest` which doesn't validate or coerce arguments.
	     *
	     * @private
	     * @param {Function} func The function to apply a rest parameter to.
	     * @param {number} [start=func.length-1] The start position of the rest parameter.
	     * @returns {Function} Returns the new function.
	     */
	    function baseRest(func, start) {
	      return setToString(overRest(func, start, identity), func + '');
	    }
	
	    /**
	     * The base implementation of `_.sample`.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to sample.
	     * @returns {*} Returns the random element.
	     */
	    function baseSample(collection) {
	      return arraySample(values(collection));
	    }
	
	    /**
	     * The base implementation of `_.sampleSize` without param guards.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to sample.
	     * @param {number} n The number of elements to sample.
	     * @returns {Array} Returns the random elements.
	     */
	    function baseSampleSize(collection, n) {
	      var array = values(collection);
	      return shuffleSelf(array, baseClamp(n, 0, array.length));
	    }
	
	    /**
	     * The base implementation of `_.set`.
	     *
	     * @private
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The path of the property to set.
	     * @param {*} value The value to set.
	     * @param {Function} [customizer] The function to customize path creation.
	     * @returns {Object} Returns `object`.
	     */
	    function baseSet(object, path, value, customizer) {
	      if (!isObject(object)) {
	        return object;
	      }
	      path = castPath(path, object);
	
	      var index = -1,
	          length = path.length,
	          lastIndex = length - 1,
	          nested = object;
	
	      while (nested != null && ++index < length) {
	        var key = toKey(path[index]),
	            newValue = value;
	
	        if (index != lastIndex) {
	          var objValue = nested[key];
	          newValue = customizer ? customizer(objValue, key, nested) : undefined;
	          if (newValue === undefined) {
	            newValue = isObject(objValue)
	              ? objValue
	              : (isIndex(path[index + 1]) ? [] : {});
	          }
	        }
	        assignValue(nested, key, newValue);
	        nested = nested[key];
	      }
	      return object;
	    }
	
	    /**
	     * The base implementation of `setData` without support for hot loop shorting.
	     *
	     * @private
	     * @param {Function} func The function to associate metadata with.
	     * @param {*} data The metadata.
	     * @returns {Function} Returns `func`.
	     */
	    var baseSetData = !metaMap ? identity : function(func, data) {
	      metaMap.set(func, data);
	      return func;
	    };
	
	    /**
	     * The base implementation of `setToString` without support for hot loop shorting.
	     *
	     * @private
	     * @param {Function} func The function to modify.
	     * @param {Function} string The `toString` result.
	     * @returns {Function} Returns `func`.
	     */
	    var baseSetToString = !defineProperty ? identity : function(func, string) {
	      return defineProperty(func, 'toString', {
	        'configurable': true,
	        'enumerable': false,
	        'value': constant(string),
	        'writable': true
	      });
	    };
	
	    /**
	     * The base implementation of `_.shuffle`.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to shuffle.
	     * @returns {Array} Returns the new shuffled array.
	     */
	    function baseShuffle(collection) {
	      return shuffleSelf(values(collection));
	    }
	
	    /**
	     * The base implementation of `_.slice` without an iteratee call guard.
	     *
	     * @private
	     * @param {Array} array The array to slice.
	     * @param {number} [start=0] The start position.
	     * @param {number} [end=array.length] The end position.
	     * @returns {Array} Returns the slice of `array`.
	     */
	    function baseSlice(array, start, end) {
	      var index = -1,
	          length = array.length;
	
	      if (start < 0) {
	        start = -start > length ? 0 : (length + start);
	      }
	      end = end > length ? length : end;
	      if (end < 0) {
	        end += length;
	      }
	      length = start > end ? 0 : ((end - start) >>> 0);
	      start >>>= 0;
	
	      var result = Array(length);
	      while (++index < length) {
	        result[index] = array[index + start];
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.some` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} predicate The function invoked per iteration.
	     * @returns {boolean} Returns `true` if any element passes the predicate check,
	     *  else `false`.
	     */
	    function baseSome(collection, predicate) {
	      var result;
	
	      baseEach(collection, function(value, index, collection) {
	        result = predicate(value, index, collection);
	        return !result;
	      });
	      return !!result;
	    }
	
	    /**
	     * The base implementation of `_.sortedIndex` and `_.sortedLastIndex` which
	     * performs a binary search of `array` to determine the index at which `value`
	     * should be inserted into `array` in order to maintain its sort order.
	     *
	     * @private
	     * @param {Array} array The sorted array to inspect.
	     * @param {*} value The value to evaluate.
	     * @param {boolean} [retHighest] Specify returning the highest qualified index.
	     * @returns {number} Returns the index at which `value` should be inserted
	     *  into `array`.
	     */
	    function baseSortedIndex(array, value, retHighest) {
	      var low = 0,
	          high = array == null ? low : array.length;
	
	      if (typeof value == 'number' && value === value && high <= HALF_MAX_ARRAY_LENGTH) {
	        while (low < high) {
	          var mid = (low + high) >>> 1,
	              computed = array[mid];
	
	          if (computed !== null && !isSymbol(computed) &&
	              (retHighest ? (computed <= value) : (computed < value))) {
	            low = mid + 1;
	          } else {
	            high = mid;
	          }
	        }
	        return high;
	      }
	      return baseSortedIndexBy(array, value, identity, retHighest);
	    }
	
	    /**
	     * The base implementation of `_.sortedIndexBy` and `_.sortedLastIndexBy`
	     * which invokes `iteratee` for `value` and each element of `array` to compute
	     * their sort ranking. The iteratee is invoked with one argument; (value).
	     *
	     * @private
	     * @param {Array} array The sorted array to inspect.
	     * @param {*} value The value to evaluate.
	     * @param {Function} iteratee The iteratee invoked per element.
	     * @param {boolean} [retHighest] Specify returning the highest qualified index.
	     * @returns {number} Returns the index at which `value` should be inserted
	     *  into `array`.
	     */
	    function baseSortedIndexBy(array, value, iteratee, retHighest) {
	      value = iteratee(value);
	
	      var low = 0,
	          high = array == null ? 0 : array.length,
	          valIsNaN = value !== value,
	          valIsNull = value === null,
	          valIsSymbol = isSymbol(value),
	          valIsUndefined = value === undefined;
	
	      while (low < high) {
	        var mid = nativeFloor((low + high) / 2),
	            computed = iteratee(array[mid]),
	            othIsDefined = computed !== undefined,
	            othIsNull = computed === null,
	            othIsReflexive = computed === computed,
	            othIsSymbol = isSymbol(computed);
	
	        if (valIsNaN) {
	          var setLow = retHighest || othIsReflexive;
	        } else if (valIsUndefined) {
	          setLow = othIsReflexive && (retHighest || othIsDefined);
	        } else if (valIsNull) {
	          setLow = othIsReflexive && othIsDefined && (retHighest || !othIsNull);
	        } else if (valIsSymbol) {
	          setLow = othIsReflexive && othIsDefined && !othIsNull && (retHighest || !othIsSymbol);
	        } else if (othIsNull || othIsSymbol) {
	          setLow = false;
	        } else {
	          setLow = retHighest ? (computed <= value) : (computed < value);
	        }
	        if (setLow) {
	          low = mid + 1;
	        } else {
	          high = mid;
	        }
	      }
	      return nativeMin(high, MAX_ARRAY_INDEX);
	    }
	
	    /**
	     * The base implementation of `_.sortedUniq` and `_.sortedUniqBy` without
	     * support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array} array The array to inspect.
	     * @param {Function} [iteratee] The iteratee invoked per element.
	     * @returns {Array} Returns the new duplicate free array.
	     */
	    function baseSortedUniq(array, iteratee) {
	      var index = -1,
	          length = array.length,
	          resIndex = 0,
	          result = [];
	
	      while (++index < length) {
	        var value = array[index],
	            computed = iteratee ? iteratee(value) : value;
	
	        if (!index || !eq(computed, seen)) {
	          var seen = computed;
	          result[resIndex++] = value === 0 ? 0 : value;
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.toNumber` which doesn't ensure correct
	     * conversions of binary, hexadecimal, or octal string values.
	     *
	     * @private
	     * @param {*} value The value to process.
	     * @returns {number} Returns the number.
	     */
	    function baseToNumber(value) {
	      if (typeof value == 'number') {
	        return value;
	      }
	      if (isSymbol(value)) {
	        return NAN;
	      }
	      return +value;
	    }
	
	    /**
	     * The base implementation of `_.toString` which doesn't convert nullish
	     * values to empty strings.
	     *
	     * @private
	     * @param {*} value The value to process.
	     * @returns {string} Returns the string.
	     */
	    function baseToString(value) {
	      // Exit early for strings to avoid a performance hit in some environments.
	      if (typeof value == 'string') {
	        return value;
	      }
	      if (isArray(value)) {
	        // Recursively convert values (susceptible to call stack limits).
	        return arrayMap(value, baseToString) + '';
	      }
	      if (isSymbol(value)) {
	        return symbolToString ? symbolToString.call(value) : '';
	      }
	      var result = (value + '');
	      return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
	    }
	
	    /**
	     * The base implementation of `_.uniqBy` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array} array The array to inspect.
	     * @param {Function} [iteratee] The iteratee invoked per element.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new duplicate free array.
	     */
	    function baseUniq(array, iteratee, comparator) {
	      var index = -1,
	          includes = arrayIncludes,
	          length = array.length,
	          isCommon = true,
	          result = [],
	          seen = result;
	
	      if (comparator) {
	        isCommon = false;
	        includes = arrayIncludesWith;
	      }
	      else if (length >= LARGE_ARRAY_SIZE) {
	        var set = iteratee ? null : createSet(array);
	        if (set) {
	          return setToArray(set);
	        }
	        isCommon = false;
	        includes = cacheHas;
	        seen = new SetCache;
	      }
	      else {
	        seen = iteratee ? [] : result;
	      }
	      outer:
	      while (++index < length) {
	        var value = array[index],
	            computed = iteratee ? iteratee(value) : value;
	
	        value = (comparator || value !== 0) ? value : 0;
	        if (isCommon && computed === computed) {
	          var seenIndex = seen.length;
	          while (seenIndex--) {
	            if (seen[seenIndex] === computed) {
	              continue outer;
	            }
	          }
	          if (iteratee) {
	            seen.push(computed);
	          }
	          result.push(value);
	        }
	        else if (!includes(seen, computed, comparator)) {
	          if (seen !== result) {
	            seen.push(computed);
	          }
	          result.push(value);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.unset`.
	     *
	     * @private
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The property path to unset.
	     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
	     */
	    function baseUnset(object, path) {
	      path = castPath(path, object);
	      object = parent(object, path);
	      return object == null || delete object[toKey(last(path))];
	    }
	
	    /**
	     * The base implementation of `_.update`.
	     *
	     * @private
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The path of the property to update.
	     * @param {Function} updater The function to produce the updated value.
	     * @param {Function} [customizer] The function to customize path creation.
	     * @returns {Object} Returns `object`.
	     */
	    function baseUpdate(object, path, updater, customizer) {
	      return baseSet(object, path, updater(baseGet(object, path)), customizer);
	    }
	
	    /**
	     * The base implementation of methods like `_.dropWhile` and `_.takeWhile`
	     * without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array} array The array to query.
	     * @param {Function} predicate The function invoked per iteration.
	     * @param {boolean} [isDrop] Specify dropping elements instead of taking them.
	     * @param {boolean} [fromRight] Specify iterating from right to left.
	     * @returns {Array} Returns the slice of `array`.
	     */
	    function baseWhile(array, predicate, isDrop, fromRight) {
	      var length = array.length,
	          index = fromRight ? length : -1;
	
	      while ((fromRight ? index-- : ++index < length) &&
	        predicate(array[index], index, array)) {}
	
	      return isDrop
	        ? baseSlice(array, (fromRight ? 0 : index), (fromRight ? index + 1 : length))
	        : baseSlice(array, (fromRight ? index + 1 : 0), (fromRight ? length : index));
	    }
	
	    /**
	     * The base implementation of `wrapperValue` which returns the result of
	     * performing a sequence of actions on the unwrapped `value`, where each
	     * successive action is supplied the return value of the previous.
	     *
	     * @private
	     * @param {*} value The unwrapped value.
	     * @param {Array} actions Actions to perform to resolve the unwrapped value.
	     * @returns {*} Returns the resolved value.
	     */
	    function baseWrapperValue(value, actions) {
	      var result = value;
	      if (result instanceof LazyWrapper) {
	        result = result.value();
	      }
	      return arrayReduce(actions, function(result, action) {
	        return action.func.apply(action.thisArg, arrayPush([result], action.args));
	      }, result);
	    }
	
	    /**
	     * The base implementation of methods like `_.xor`, without support for
	     * iteratee shorthands, that accepts an array of arrays to inspect.
	     *
	     * @private
	     * @param {Array} arrays The arrays to inspect.
	     * @param {Function} [iteratee] The iteratee invoked per element.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new array of values.
	     */
	    function baseXor(arrays, iteratee, comparator) {
	      var length = arrays.length;
	      if (length < 2) {
	        return length ? baseUniq(arrays[0]) : [];
	      }
	      var index = -1,
	          result = Array(length);
	
	      while (++index < length) {
	        var array = arrays[index],
	            othIndex = -1;
	
	        while (++othIndex < length) {
	          if (othIndex != index) {
	            result[index] = baseDifference(result[index] || array, arrays[othIndex], iteratee, comparator);
	          }
	        }
	      }
	      return baseUniq(baseFlatten(result, 1), iteratee, comparator);
	    }
	
	    /**
	     * This base implementation of `_.zipObject` which assigns values using `assignFunc`.
	     *
	     * @private
	     * @param {Array} props The property identifiers.
	     * @param {Array} values The property values.
	     * @param {Function} assignFunc The function to assign values.
	     * @returns {Object} Returns the new object.
	     */
	    function baseZipObject(props, values, assignFunc) {
	      var index = -1,
	          length = props.length,
	          valsLength = values.length,
	          result = {};
	
	      while (++index < length) {
	        var value = index < valsLength ? values[index] : undefined;
	        assignFunc(result, props[index], value);
	      }
	      return result;
	    }
	
	    /**
	     * Casts `value` to an empty array if it's not an array like object.
	     *
	     * @private
	     * @param {*} value The value to inspect.
	     * @returns {Array|Object} Returns the cast array-like object.
	     */
	    function castArrayLikeObject(value) {
	      return isArrayLikeObject(value) ? value : [];
	    }
	
	    /**
	     * Casts `value` to `identity` if it's not a function.
	     *
	     * @private
	     * @param {*} value The value to inspect.
	     * @returns {Function} Returns cast function.
	     */
	    function castFunction(value) {
	      return typeof value == 'function' ? value : identity;
	    }
	
	    /**
	     * Casts `value` to a path array if it's not one.
	     *
	     * @private
	     * @param {*} value The value to inspect.
	     * @param {Object} [object] The object to query keys on.
	     * @returns {Array} Returns the cast property path array.
	     */
	    function castPath(value, object) {
	      if (isArray(value)) {
	        return value;
	      }
	      return isKey(value, object) ? [value] : stringToPath(toString(value));
	    }
	
	    /**
	     * A `baseRest` alias which can be replaced with `identity` by module
	     * replacement plugins.
	     *
	     * @private
	     * @type {Function}
	     * @param {Function} func The function to apply a rest parameter to.
	     * @returns {Function} Returns the new function.
	     */
	    var castRest = baseRest;
	
	    /**
	     * Casts `array` to a slice if it's needed.
	     *
	     * @private
	     * @param {Array} array The array to inspect.
	     * @param {number} start The start position.
	     * @param {number} [end=array.length] The end position.
	     * @returns {Array} Returns the cast slice.
	     */
	    function castSlice(array, start, end) {
	      var length = array.length;
	      end = end === undefined ? length : end;
	      return (!start && end >= length) ? array : baseSlice(array, start, end);
	    }
	
	    /**
	     * A simple wrapper around the global [`clearTimeout`](https://mdn.io/clearTimeout).
	     *
	     * @private
	     * @param {number|Object} id The timer id or timeout object of the timer to clear.
	     */
	    var clearTimeout = ctxClearTimeout || function(id) {
	      return root.clearTimeout(id);
	    };
	
	    /**
	     * Creates a clone of  `buffer`.
	     *
	     * @private
	     * @param {Buffer} buffer The buffer to clone.
	     * @param {boolean} [isDeep] Specify a deep clone.
	     * @returns {Buffer} Returns the cloned buffer.
	     */
	    function cloneBuffer(buffer, isDeep) {
	      if (isDeep) {
	        return buffer.slice();
	      }
	      var length = buffer.length,
	          result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);
	
	      buffer.copy(result);
	      return result;
	    }
	
	    /**
	     * Creates a clone of `arrayBuffer`.
	     *
	     * @private
	     * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
	     * @returns {ArrayBuffer} Returns the cloned array buffer.
	     */
	    function cloneArrayBuffer(arrayBuffer) {
	      var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
	      new Uint8Array(result).set(new Uint8Array(arrayBuffer));
	      return result;
	    }
	
	    /**
	     * Creates a clone of `dataView`.
	     *
	     * @private
	     * @param {Object} dataView The data view to clone.
	     * @param {boolean} [isDeep] Specify a deep clone.
	     * @returns {Object} Returns the cloned data view.
	     */
	    function cloneDataView(dataView, isDeep) {
	      var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
	      return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
	    }
	
	    /**
	     * Creates a clone of `regexp`.
	     *
	     * @private
	     * @param {Object} regexp The regexp to clone.
	     * @returns {Object} Returns the cloned regexp.
	     */
	    function cloneRegExp(regexp) {
	      var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
	      result.lastIndex = regexp.lastIndex;
	      return result;
	    }
	
	    /**
	     * Creates a clone of the `symbol` object.
	     *
	     * @private
	     * @param {Object} symbol The symbol object to clone.
	     * @returns {Object} Returns the cloned symbol object.
	     */
	    function cloneSymbol(symbol) {
	      return symbolValueOf ? Object(symbolValueOf.call(symbol)) : {};
	    }
	
	    /**
	     * Creates a clone of `typedArray`.
	     *
	     * @private
	     * @param {Object} typedArray The typed array to clone.
	     * @param {boolean} [isDeep] Specify a deep clone.
	     * @returns {Object} Returns the cloned typed array.
	     */
	    function cloneTypedArray(typedArray, isDeep) {
	      var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
	      return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
	    }
	
	    /**
	     * Compares values to sort them in ascending order.
	     *
	     * @private
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {number} Returns the sort order indicator for `value`.
	     */
	    function compareAscending(value, other) {
	      if (value !== other) {
	        var valIsDefined = value !== undefined,
	            valIsNull = value === null,
	            valIsReflexive = value === value,
	            valIsSymbol = isSymbol(value);
	
	        var othIsDefined = other !== undefined,
	            othIsNull = other === null,
	            othIsReflexive = other === other,
	            othIsSymbol = isSymbol(other);
	
	        if ((!othIsNull && !othIsSymbol && !valIsSymbol && value > other) ||
	            (valIsSymbol && othIsDefined && othIsReflexive && !othIsNull && !othIsSymbol) ||
	            (valIsNull && othIsDefined && othIsReflexive) ||
	            (!valIsDefined && othIsReflexive) ||
	            !valIsReflexive) {
	          return 1;
	        }
	        if ((!valIsNull && !valIsSymbol && !othIsSymbol && value < other) ||
	            (othIsSymbol && valIsDefined && valIsReflexive && !valIsNull && !valIsSymbol) ||
	            (othIsNull && valIsDefined && valIsReflexive) ||
	            (!othIsDefined && valIsReflexive) ||
	            !othIsReflexive) {
	          return -1;
	        }
	      }
	      return 0;
	    }
	
	    /**
	     * Used by `_.orderBy` to compare multiple properties of a value to another
	     * and stable sort them.
	     *
	     * If `orders` is unspecified, all values are sorted in ascending order. Otherwise,
	     * specify an order of "desc" for descending or "asc" for ascending sort order
	     * of corresponding values.
	     *
	     * @private
	     * @param {Object} object The object to compare.
	     * @param {Object} other The other object to compare.
	     * @param {boolean[]|string[]} orders The order to sort by for each property.
	     * @returns {number} Returns the sort order indicator for `object`.
	     */
	    function compareMultiple(object, other, orders) {
	      var index = -1,
	          objCriteria = object.criteria,
	          othCriteria = other.criteria,
	          length = objCriteria.length,
	          ordersLength = orders.length;
	
	      while (++index < length) {
	        var result = compareAscending(objCriteria[index], othCriteria[index]);
	        if (result) {
	          if (index >= ordersLength) {
	            return result;
	          }
	          var order = orders[index];
	          return result * (order == 'desc' ? -1 : 1);
	        }
	      }
	      // Fixes an `Array#sort` bug in the JS engine embedded in Adobe applications
	      // that causes it, under certain circumstances, to provide the same value for
	      // `object` and `other`. See https://github.com/jashkenas/underscore/pull/1247
	      // for more details.
	      //
	      // This also ensures a stable sort in V8 and other engines.
	      // See https://bugs.chromium.org/p/v8/issues/detail?id=90 for more details.
	      return object.index - other.index;
	    }
	
	    /**
	     * Creates an array that is the composition of partially applied arguments,
	     * placeholders, and provided arguments into a single array of arguments.
	     *
	     * @private
	     * @param {Array} args The provided arguments.
	     * @param {Array} partials The arguments to prepend to those provided.
	     * @param {Array} holders The `partials` placeholder indexes.
	     * @params {boolean} [isCurried] Specify composing for a curried function.
	     * @returns {Array} Returns the new array of composed arguments.
	     */
	    function composeArgs(args, partials, holders, isCurried) {
	      var argsIndex = -1,
	          argsLength = args.length,
	          holdersLength = holders.length,
	          leftIndex = -1,
	          leftLength = partials.length,
	          rangeLength = nativeMax(argsLength - holdersLength, 0),
	          result = Array(leftLength + rangeLength),
	          isUncurried = !isCurried;
	
	      while (++leftIndex < leftLength) {
	        result[leftIndex] = partials[leftIndex];
	      }
	      while (++argsIndex < holdersLength) {
	        if (isUncurried || argsIndex < argsLength) {
	          result[holders[argsIndex]] = args[argsIndex];
	        }
	      }
	      while (rangeLength--) {
	        result[leftIndex++] = args[argsIndex++];
	      }
	      return result;
	    }
	
	    /**
	     * This function is like `composeArgs` except that the arguments composition
	     * is tailored for `_.partialRight`.
	     *
	     * @private
	     * @param {Array} args The provided arguments.
	     * @param {Array} partials The arguments to append to those provided.
	     * @param {Array} holders The `partials` placeholder indexes.
	     * @params {boolean} [isCurried] Specify composing for a curried function.
	     * @returns {Array} Returns the new array of composed arguments.
	     */
	    function composeArgsRight(args, partials, holders, isCurried) {
	      var argsIndex = -1,
	          argsLength = args.length,
	          holdersIndex = -1,
	          holdersLength = holders.length,
	          rightIndex = -1,
	          rightLength = partials.length,
	          rangeLength = nativeMax(argsLength - holdersLength, 0),
	          result = Array(rangeLength + rightLength),
	          isUncurried = !isCurried;
	
	      while (++argsIndex < rangeLength) {
	        result[argsIndex] = args[argsIndex];
	      }
	      var offset = argsIndex;
	      while (++rightIndex < rightLength) {
	        result[offset + rightIndex] = partials[rightIndex];
	      }
	      while (++holdersIndex < holdersLength) {
	        if (isUncurried || argsIndex < argsLength) {
	          result[offset + holders[holdersIndex]] = args[argsIndex++];
	        }
	      }
	      return result;
	    }
	
	    /**
	     * Copies the values of `source` to `array`.
	     *
	     * @private
	     * @param {Array} source The array to copy values from.
	     * @param {Array} [array=[]] The array to copy values to.
	     * @returns {Array} Returns `array`.
	     */
	    function copyArray(source, array) {
	      var index = -1,
	          length = source.length;
	
	      array || (array = Array(length));
	      while (++index < length) {
	        array[index] = source[index];
	      }
	      return array;
	    }
	
	    /**
	     * Copies properties of `source` to `object`.
	     *
	     * @private
	     * @param {Object} source The object to copy properties from.
	     * @param {Array} props The property identifiers to copy.
	     * @param {Object} [object={}] The object to copy properties to.
	     * @param {Function} [customizer] The function to customize copied values.
	     * @returns {Object} Returns `object`.
	     */
	    function copyObject(source, props, object, customizer) {
	      var isNew = !object;
	      object || (object = {});
	
	      var index = -1,
	          length = props.length;
	
	      while (++index < length) {
	        var key = props[index];
	
	        var newValue = customizer
	          ? customizer(object[key], source[key], key, object, source)
	          : undefined;
	
	        if (newValue === undefined) {
	          newValue = source[key];
	        }
	        if (isNew) {
	          baseAssignValue(object, key, newValue);
	        } else {
	          assignValue(object, key, newValue);
	        }
	      }
	      return object;
	    }
	
	    /**
	     * Copies own symbols of `source` to `object`.
	     *
	     * @private
	     * @param {Object} source The object to copy symbols from.
	     * @param {Object} [object={}] The object to copy symbols to.
	     * @returns {Object} Returns `object`.
	     */
	    function copySymbols(source, object) {
	      return copyObject(source, getSymbols(source), object);
	    }
	
	    /**
	     * Copies own and inherited symbols of `source` to `object`.
	     *
	     * @private
	     * @param {Object} source The object to copy symbols from.
	     * @param {Object} [object={}] The object to copy symbols to.
	     * @returns {Object} Returns `object`.
	     */
	    function copySymbolsIn(source, object) {
	      return copyObject(source, getSymbolsIn(source), object);
	    }
	
	    /**
	     * Creates a function like `_.groupBy`.
	     *
	     * @private
	     * @param {Function} setter The function to set accumulator values.
	     * @param {Function} [initializer] The accumulator object initializer.
	     * @returns {Function} Returns the new aggregator function.
	     */
	    function createAggregator(setter, initializer) {
	      return function(collection, iteratee) {
	        var func = isArray(collection) ? arrayAggregator : baseAggregator,
	            accumulator = initializer ? initializer() : {};
	
	        return func(collection, setter, getIteratee(iteratee, 2), accumulator);
	      };
	    }
	
	    /**
	     * Creates a function like `_.assign`.
	     *
	     * @private
	     * @param {Function} assigner The function to assign values.
	     * @returns {Function} Returns the new assigner function.
	     */
	    function createAssigner(assigner) {
	      return baseRest(function(object, sources) {
	        var index = -1,
	            length = sources.length,
	            customizer = length > 1 ? sources[length - 1] : undefined,
	            guard = length > 2 ? sources[2] : undefined;
	
	        customizer = (assigner.length > 3 && typeof customizer == 'function')
	          ? (length--, customizer)
	          : undefined;
	
	        if (guard && isIterateeCall(sources[0], sources[1], guard)) {
	          customizer = length < 3 ? undefined : customizer;
	          length = 1;
	        }
	        object = Object(object);
	        while (++index < length) {
	          var source = sources[index];
	          if (source) {
	            assigner(object, source, index, customizer);
	          }
	        }
	        return object;
	      });
	    }
	
	    /**
	     * Creates a `baseEach` or `baseEachRight` function.
	     *
	     * @private
	     * @param {Function} eachFunc The function to iterate over a collection.
	     * @param {boolean} [fromRight] Specify iterating from right to left.
	     * @returns {Function} Returns the new base function.
	     */
	    function createBaseEach(eachFunc, fromRight) {
	      return function(collection, iteratee) {
	        if (collection == null) {
	          return collection;
	        }
	        if (!isArrayLike(collection)) {
	          return eachFunc(collection, iteratee);
	        }
	        var length = collection.length,
	            index = fromRight ? length : -1,
	            iterable = Object(collection);
	
	        while ((fromRight ? index-- : ++index < length)) {
	          if (iteratee(iterable[index], index, iterable) === false) {
	            break;
	          }
	        }
	        return collection;
	      };
	    }
	
	    /**
	     * Creates a base function for methods like `_.forIn` and `_.forOwn`.
	     *
	     * @private
	     * @param {boolean} [fromRight] Specify iterating from right to left.
	     * @returns {Function} Returns the new base function.
	     */
	    function createBaseFor(fromRight) {
	      return function(object, iteratee, keysFunc) {
	        var index = -1,
	            iterable = Object(object),
	            props = keysFunc(object),
	            length = props.length;
	
	        while (length--) {
	          var key = props[fromRight ? length : ++index];
	          if (iteratee(iterable[key], key, iterable) === false) {
	            break;
	          }
	        }
	        return object;
	      };
	    }
	
	    /**
	     * Creates a function that wraps `func` to invoke it with the optional `this`
	     * binding of `thisArg`.
	     *
	     * @private
	     * @param {Function} func The function to wrap.
	     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	     * @param {*} [thisArg] The `this` binding of `func`.
	     * @returns {Function} Returns the new wrapped function.
	     */
	    function createBind(func, bitmask, thisArg) {
	      var isBind = bitmask & WRAP_BIND_FLAG,
	          Ctor = createCtor(func);
	
	      function wrapper() {
	        var fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
	        return fn.apply(isBind ? thisArg : this, arguments);
	      }
	      return wrapper;
	    }
	
	    /**
	     * Creates a function like `_.lowerFirst`.
	     *
	     * @private
	     * @param {string} methodName The name of the `String` case method to use.
	     * @returns {Function} Returns the new case function.
	     */
	    function createCaseFirst(methodName) {
	      return function(string) {
	        string = toString(string);
	
	        var strSymbols = hasUnicode(string)
	          ? stringToArray(string)
	          : undefined;
	
	        var chr = strSymbols
	          ? strSymbols[0]
	          : string.charAt(0);
	
	        var trailing = strSymbols
	          ? castSlice(strSymbols, 1).join('')
	          : string.slice(1);
	
	        return chr[methodName]() + trailing;
	      };
	    }
	
	    /**
	     * Creates a function like `_.camelCase`.
	     *
	     * @private
	     * @param {Function} callback The function to combine each word.
	     * @returns {Function} Returns the new compounder function.
	     */
	    function createCompounder(callback) {
	      return function(string) {
	        return arrayReduce(words(deburr(string).replace(reApos, '')), callback, '');
	      };
	    }
	
	    /**
	     * Creates a function that produces an instance of `Ctor` regardless of
	     * whether it was invoked as part of a `new` expression or by `call` or `apply`.
	     *
	     * @private
	     * @param {Function} Ctor The constructor to wrap.
	     * @returns {Function} Returns the new wrapped function.
	     */
	    function createCtor(Ctor) {
	      return function() {
	        // Use a `switch` statement to work with class constructors. See
	        // http://ecma-international.org/ecma-262/7.0/#sec-ecmascript-function-objects-call-thisargument-argumentslist
	        // for more details.
	        var args = arguments;
	        switch (args.length) {
	          case 0: return new Ctor;
	          case 1: return new Ctor(args[0]);
	          case 2: return new Ctor(args[0], args[1]);
	          case 3: return new Ctor(args[0], args[1], args[2]);
	          case 4: return new Ctor(args[0], args[1], args[2], args[3]);
	          case 5: return new Ctor(args[0], args[1], args[2], args[3], args[4]);
	          case 6: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5]);
	          case 7: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5], args[6]);
	        }
	        var thisBinding = baseCreate(Ctor.prototype),
	            result = Ctor.apply(thisBinding, args);
	
	        // Mimic the constructor's `return` behavior.
	        // See https://es5.github.io/#x13.2.2 for more details.
	        return isObject(result) ? result : thisBinding;
	      };
	    }
	
	    /**
	     * Creates a function that wraps `func` to enable currying.
	     *
	     * @private
	     * @param {Function} func The function to wrap.
	     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	     * @param {number} arity The arity of `func`.
	     * @returns {Function} Returns the new wrapped function.
	     */
	    function createCurry(func, bitmask, arity) {
	      var Ctor = createCtor(func);
	
	      function wrapper() {
	        var length = arguments.length,
	            args = Array(length),
	            index = length,
	            placeholder = getHolder(wrapper);
	
	        while (index--) {
	          args[index] = arguments[index];
	        }
	        var holders = (length < 3 && args[0] !== placeholder && args[length - 1] !== placeholder)
	          ? []
	          : replaceHolders(args, placeholder);
	
	        length -= holders.length;
	        if (length < arity) {
	          return createRecurry(
	            func, bitmask, createHybrid, wrapper.placeholder, undefined,
	            args, holders, undefined, undefined, arity - length);
	        }
	        var fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
	        return apply(fn, this, args);
	      }
	      return wrapper;
	    }
	
	    /**
	     * Creates a `_.find` or `_.findLast` function.
	     *
	     * @private
	     * @param {Function} findIndexFunc The function to find the collection index.
	     * @returns {Function} Returns the new find function.
	     */
	    function createFind(findIndexFunc) {
	      return function(collection, predicate, fromIndex) {
	        var iterable = Object(collection);
	        if (!isArrayLike(collection)) {
	          var iteratee = getIteratee(predicate, 3);
	          collection = keys(collection);
	          predicate = function(key) { return iteratee(iterable[key], key, iterable); };
	        }
	        var index = findIndexFunc(collection, predicate, fromIndex);
	        return index > -1 ? iterable[iteratee ? collection[index] : index] : undefined;
	      };
	    }
	
	    /**
	     * Creates a `_.flow` or `_.flowRight` function.
	     *
	     * @private
	     * @param {boolean} [fromRight] Specify iterating from right to left.
	     * @returns {Function} Returns the new flow function.
	     */
	    function createFlow(fromRight) {
	      return flatRest(function(funcs) {
	        var length = funcs.length,
	            index = length,
	            prereq = LodashWrapper.prototype.thru;
	
	        if (fromRight) {
	          funcs.reverse();
	        }
	        while (index--) {
	          var func = funcs[index];
	          if (typeof func != 'function') {
	            throw new TypeError(FUNC_ERROR_TEXT);
	          }
	          if (prereq && !wrapper && getFuncName(func) == 'wrapper') {
	            var wrapper = new LodashWrapper([], true);
	          }
	        }
	        index = wrapper ? index : length;
	        while (++index < length) {
	          func = funcs[index];
	
	          var funcName = getFuncName(func),
	              data = funcName == 'wrapper' ? getData(func) : undefined;
	
	          if (data && isLaziable(data[0]) &&
	                data[1] == (WRAP_ARY_FLAG | WRAP_CURRY_FLAG | WRAP_PARTIAL_FLAG | WRAP_REARG_FLAG) &&
	                !data[4].length && data[9] == 1
	              ) {
	            wrapper = wrapper[getFuncName(data[0])].apply(wrapper, data[3]);
	          } else {
	            wrapper = (func.length == 1 && isLaziable(func))
	              ? wrapper[funcName]()
	              : wrapper.thru(func);
	          }
	        }
	        return function() {
	          var args = arguments,
	              value = args[0];
	
	          if (wrapper && args.length == 1 && isArray(value)) {
	            return wrapper.plant(value).value();
	          }
	          var index = 0,
	              result = length ? funcs[index].apply(this, args) : value;
	
	          while (++index < length) {
	            result = funcs[index].call(this, result);
	          }
	          return result;
	        };
	      });
	    }
	
	    /**
	     * Creates a function that wraps `func` to invoke it with optional `this`
	     * binding of `thisArg`, partial application, and currying.
	     *
	     * @private
	     * @param {Function|string} func The function or method name to wrap.
	     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	     * @param {*} [thisArg] The `this` binding of `func`.
	     * @param {Array} [partials] The arguments to prepend to those provided to
	     *  the new function.
	     * @param {Array} [holders] The `partials` placeholder indexes.
	     * @param {Array} [partialsRight] The arguments to append to those provided
	     *  to the new function.
	     * @param {Array} [holdersRight] The `partialsRight` placeholder indexes.
	     * @param {Array} [argPos] The argument positions of the new function.
	     * @param {number} [ary] The arity cap of `func`.
	     * @param {number} [arity] The arity of `func`.
	     * @returns {Function} Returns the new wrapped function.
	     */
	    function createHybrid(func, bitmask, thisArg, partials, holders, partialsRight, holdersRight, argPos, ary, arity) {
	      var isAry = bitmask & WRAP_ARY_FLAG,
	          isBind = bitmask & WRAP_BIND_FLAG,
	          isBindKey = bitmask & WRAP_BIND_KEY_FLAG,
	          isCurried = bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG),
	          isFlip = bitmask & WRAP_FLIP_FLAG,
	          Ctor = isBindKey ? undefined : createCtor(func);
	
	      function wrapper() {
	        var length = arguments.length,
	            args = Array(length),
	            index = length;
	
	        while (index--) {
	          args[index] = arguments[index];
	        }
	        if (isCurried) {
	          var placeholder = getHolder(wrapper),
	              holdersCount = countHolders(args, placeholder);
	        }
	        if (partials) {
	          args = composeArgs(args, partials, holders, isCurried);
	        }
	        if (partialsRight) {
	          args = composeArgsRight(args, partialsRight, holdersRight, isCurried);
	        }
	        length -= holdersCount;
	        if (isCurried && length < arity) {
	          var newHolders = replaceHolders(args, placeholder);
	          return createRecurry(
	            func, bitmask, createHybrid, wrapper.placeholder, thisArg,
	            args, newHolders, argPos, ary, arity - length
	          );
	        }
	        var thisBinding = isBind ? thisArg : this,
	            fn = isBindKey ? thisBinding[func] : func;
	
	        length = args.length;
	        if (argPos) {
	          args = reorder(args, argPos);
	        } else if (isFlip && length > 1) {
	          args.reverse();
	        }
	        if (isAry && ary < length) {
	          args.length = ary;
	        }
	        if (this && this !== root && this instanceof wrapper) {
	          fn = Ctor || createCtor(fn);
	        }
	        return fn.apply(thisBinding, args);
	      }
	      return wrapper;
	    }
	
	    /**
	     * Creates a function like `_.invertBy`.
	     *
	     * @private
	     * @param {Function} setter The function to set accumulator values.
	     * @param {Function} toIteratee The function to resolve iteratees.
	     * @returns {Function} Returns the new inverter function.
	     */
	    function createInverter(setter, toIteratee) {
	      return function(object, iteratee) {
	        return baseInverter(object, setter, toIteratee(iteratee), {});
	      };
	    }
	
	    /**
	     * Creates a function that performs a mathematical operation on two values.
	     *
	     * @private
	     * @param {Function} operator The function to perform the operation.
	     * @param {number} [defaultValue] The value used for `undefined` arguments.
	     * @returns {Function} Returns the new mathematical operation function.
	     */
	    function createMathOperation(operator, defaultValue) {
	      return function(value, other) {
	        var result;
	        if (value === undefined && other === undefined) {
	          return defaultValue;
	        }
	        if (value !== undefined) {
	          result = value;
	        }
	        if (other !== undefined) {
	          if (result === undefined) {
	            return other;
	          }
	          if (typeof value == 'string' || typeof other == 'string') {
	            value = baseToString(value);
	            other = baseToString(other);
	          } else {
	            value = baseToNumber(value);
	            other = baseToNumber(other);
	          }
	          result = operator(value, other);
	        }
	        return result;
	      };
	    }
	
	    /**
	     * Creates a function like `_.over`.
	     *
	     * @private
	     * @param {Function} arrayFunc The function to iterate over iteratees.
	     * @returns {Function} Returns the new over function.
	     */
	    function createOver(arrayFunc) {
	      return flatRest(function(iteratees) {
	        iteratees = arrayMap(iteratees, baseUnary(getIteratee()));
	        return baseRest(function(args) {
	          var thisArg = this;
	          return arrayFunc(iteratees, function(iteratee) {
	            return apply(iteratee, thisArg, args);
	          });
	        });
	      });
	    }
	
	    /**
	     * Creates the padding for `string` based on `length`. The `chars` string
	     * is truncated if the number of characters exceeds `length`.
	     *
	     * @private
	     * @param {number} length The padding length.
	     * @param {string} [chars=' '] The string used as padding.
	     * @returns {string} Returns the padding for `string`.
	     */
	    function createPadding(length, chars) {
	      chars = chars === undefined ? ' ' : baseToString(chars);
	
	      var charsLength = chars.length;
	      if (charsLength < 2) {
	        return charsLength ? baseRepeat(chars, length) : chars;
	      }
	      var result = baseRepeat(chars, nativeCeil(length / stringSize(chars)));
	      return hasUnicode(chars)
	        ? castSlice(stringToArray(result), 0, length).join('')
	        : result.slice(0, length);
	    }
	
	    /**
	     * Creates a function that wraps `func` to invoke it with the `this` binding
	     * of `thisArg` and `partials` prepended to the arguments it receives.
	     *
	     * @private
	     * @param {Function} func The function to wrap.
	     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	     * @param {*} thisArg The `this` binding of `func`.
	     * @param {Array} partials The arguments to prepend to those provided to
	     *  the new function.
	     * @returns {Function} Returns the new wrapped function.
	     */
	    function createPartial(func, bitmask, thisArg, partials) {
	      var isBind = bitmask & WRAP_BIND_FLAG,
	          Ctor = createCtor(func);
	
	      function wrapper() {
	        var argsIndex = -1,
	            argsLength = arguments.length,
	            leftIndex = -1,
	            leftLength = partials.length,
	            args = Array(leftLength + argsLength),
	            fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
	
	        while (++leftIndex < leftLength) {
	          args[leftIndex] = partials[leftIndex];
	        }
	        while (argsLength--) {
	          args[leftIndex++] = arguments[++argsIndex];
	        }
	        return apply(fn, isBind ? thisArg : this, args);
	      }
	      return wrapper;
	    }
	
	    /**
	     * Creates a `_.range` or `_.rangeRight` function.
	     *
	     * @private
	     * @param {boolean} [fromRight] Specify iterating from right to left.
	     * @returns {Function} Returns the new range function.
	     */
	    function createRange(fromRight) {
	      return function(start, end, step) {
	        if (step && typeof step != 'number' && isIterateeCall(start, end, step)) {
	          end = step = undefined;
	        }
	        // Ensure the sign of `-0` is preserved.
	        start = toFinite(start);
	        if (end === undefined) {
	          end = start;
	          start = 0;
	        } else {
	          end = toFinite(end);
	        }
	        step = step === undefined ? (start < end ? 1 : -1) : toFinite(step);
	        return baseRange(start, end, step, fromRight);
	      };
	    }
	
	    /**
	     * Creates a function that performs a relational operation on two values.
	     *
	     * @private
	     * @param {Function} operator The function to perform the operation.
	     * @returns {Function} Returns the new relational operation function.
	     */
	    function createRelationalOperation(operator) {
	      return function(value, other) {
	        if (!(typeof value == 'string' && typeof other == 'string')) {
	          value = toNumber(value);
	          other = toNumber(other);
	        }
	        return operator(value, other);
	      };
	    }
	
	    /**
	     * Creates a function that wraps `func` to continue currying.
	     *
	     * @private
	     * @param {Function} func The function to wrap.
	     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	     * @param {Function} wrapFunc The function to create the `func` wrapper.
	     * @param {*} placeholder The placeholder value.
	     * @param {*} [thisArg] The `this` binding of `func`.
	     * @param {Array} [partials] The arguments to prepend to those provided to
	     *  the new function.
	     * @param {Array} [holders] The `partials` placeholder indexes.
	     * @param {Array} [argPos] The argument positions of the new function.
	     * @param {number} [ary] The arity cap of `func`.
	     * @param {number} [arity] The arity of `func`.
	     * @returns {Function} Returns the new wrapped function.
	     */
	    function createRecurry(func, bitmask, wrapFunc, placeholder, thisArg, partials, holders, argPos, ary, arity) {
	      var isCurry = bitmask & WRAP_CURRY_FLAG,
	          newHolders = isCurry ? holders : undefined,
	          newHoldersRight = isCurry ? undefined : holders,
	          newPartials = isCurry ? partials : undefined,
	          newPartialsRight = isCurry ? undefined : partials;
	
	      bitmask |= (isCurry ? WRAP_PARTIAL_FLAG : WRAP_PARTIAL_RIGHT_FLAG);
	      bitmask &= ~(isCurry ? WRAP_PARTIAL_RIGHT_FLAG : WRAP_PARTIAL_FLAG);
	
	      if (!(bitmask & WRAP_CURRY_BOUND_FLAG)) {
	        bitmask &= ~(WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG);
	      }
	      var newData = [
	        func, bitmask, thisArg, newPartials, newHolders, newPartialsRight,
	        newHoldersRight, argPos, ary, arity
	      ];
	
	      var result = wrapFunc.apply(undefined, newData);
	      if (isLaziable(func)) {
	        setData(result, newData);
	      }
	      result.placeholder = placeholder;
	      return setWrapToString(result, func, bitmask);
	    }
	
	    /**
	     * Creates a function like `_.round`.
	     *
	     * @private
	     * @param {string} methodName The name of the `Math` method to use when rounding.
	     * @returns {Function} Returns the new round function.
	     */
	    function createRound(methodName) {
	      var func = Math[methodName];
	      return function(number, precision) {
	        number = toNumber(number);
	        precision = precision == null ? 0 : nativeMin(toInteger(precision), 292);
	        if (precision && nativeIsFinite(number)) {
	          // Shift with exponential notation to avoid floating-point issues.
	          // See [MDN](https://mdn.io/round#Examples) for more details.
	          var pair = (toString(number) + 'e').split('e'),
	              value = func(pair[0] + 'e' + (+pair[1] + precision));
	
	          pair = (toString(value) + 'e').split('e');
	          return +(pair[0] + 'e' + (+pair[1] - precision));
	        }
	        return func(number);
	      };
	    }
	
	    /**
	     * Creates a set object of `values`.
	     *
	     * @private
	     * @param {Array} values The values to add to the set.
	     * @returns {Object} Returns the new set.
	     */
	    var createSet = !(Set && (1 / setToArray(new Set([,-0]))[1]) == INFINITY) ? noop : function(values) {
	      return new Set(values);
	    };
	
	    /**
	     * Creates a `_.toPairs` or `_.toPairsIn` function.
	     *
	     * @private
	     * @param {Function} keysFunc The function to get the keys of a given object.
	     * @returns {Function} Returns the new pairs function.
	     */
	    function createToPairs(keysFunc) {
	      return function(object) {
	        var tag = getTag(object);
	        if (tag == mapTag) {
	          return mapToArray(object);
	        }
	        if (tag == setTag) {
	          return setToPairs(object);
	        }
	        return baseToPairs(object, keysFunc(object));
	      };
	    }
	
	    /**
	     * Creates a function that either curries or invokes `func` with optional
	     * `this` binding and partially applied arguments.
	     *
	     * @private
	     * @param {Function|string} func The function or method name to wrap.
	     * @param {number} bitmask The bitmask flags.
	     *    1 - `_.bind`
	     *    2 - `_.bindKey`
	     *    4 - `_.curry` or `_.curryRight` of a bound function
	     *    8 - `_.curry`
	     *   16 - `_.curryRight`
	     *   32 - `_.partial`
	     *   64 - `_.partialRight`
	     *  128 - `_.rearg`
	     *  256 - `_.ary`
	     *  512 - `_.flip`
	     * @param {*} [thisArg] The `this` binding of `func`.
	     * @param {Array} [partials] The arguments to be partially applied.
	     * @param {Array} [holders] The `partials` placeholder indexes.
	     * @param {Array} [argPos] The argument positions of the new function.
	     * @param {number} [ary] The arity cap of `func`.
	     * @param {number} [arity] The arity of `func`.
	     * @returns {Function} Returns the new wrapped function.
	     */
	    function createWrap(func, bitmask, thisArg, partials, holders, argPos, ary, arity) {
	      var isBindKey = bitmask & WRAP_BIND_KEY_FLAG;
	      if (!isBindKey && typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      var length = partials ? partials.length : 0;
	      if (!length) {
	        bitmask &= ~(WRAP_PARTIAL_FLAG | WRAP_PARTIAL_RIGHT_FLAG);
	        partials = holders = undefined;
	      }
	      ary = ary === undefined ? ary : nativeMax(toInteger(ary), 0);
	      arity = arity === undefined ? arity : toInteger(arity);
	      length -= holders ? holders.length : 0;
	
	      if (bitmask & WRAP_PARTIAL_RIGHT_FLAG) {
	        var partialsRight = partials,
	            holdersRight = holders;
	
	        partials = holders = undefined;
	      }
	      var data = isBindKey ? undefined : getData(func);
	
	      var newData = [
	        func, bitmask, thisArg, partials, holders, partialsRight, holdersRight,
	        argPos, ary, arity
	      ];
	
	      if (data) {
	        mergeData(newData, data);
	      }
	      func = newData[0];
	      bitmask = newData[1];
	      thisArg = newData[2];
	      partials = newData[3];
	      holders = newData[4];
	      arity = newData[9] = newData[9] === undefined
	        ? (isBindKey ? 0 : func.length)
	        : nativeMax(newData[9] - length, 0);
	
	      if (!arity && bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG)) {
	        bitmask &= ~(WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG);
	      }
	      if (!bitmask || bitmask == WRAP_BIND_FLAG) {
	        var result = createBind(func, bitmask, thisArg);
	      } else if (bitmask == WRAP_CURRY_FLAG || bitmask == WRAP_CURRY_RIGHT_FLAG) {
	        result = createCurry(func, bitmask, arity);
	      } else if ((bitmask == WRAP_PARTIAL_FLAG || bitmask == (WRAP_BIND_FLAG | WRAP_PARTIAL_FLAG)) && !holders.length) {
	        result = createPartial(func, bitmask, thisArg, partials);
	      } else {
	        result = createHybrid.apply(undefined, newData);
	      }
	      var setter = data ? baseSetData : setData;
	      return setWrapToString(setter(result, newData), func, bitmask);
	    }
	
	    /**
	     * Used by `_.defaults` to customize its `_.assignIn` use to assign properties
	     * of source objects to the destination object for all destination properties
	     * that resolve to `undefined`.
	     *
	     * @private
	     * @param {*} objValue The destination value.
	     * @param {*} srcValue The source value.
	     * @param {string} key The key of the property to assign.
	     * @param {Object} object The parent object of `objValue`.
	     * @returns {*} Returns the value to assign.
	     */
	    function customDefaultsAssignIn(objValue, srcValue, key, object) {
	      if (objValue === undefined ||
	          (eq(objValue, objectProto[key]) && !hasOwnProperty.call(object, key))) {
	        return srcValue;
	      }
	      return objValue;
	    }
	
	    /**
	     * Used by `_.defaultsDeep` to customize its `_.merge` use to merge source
	     * objects into destination objects that are passed thru.
	     *
	     * @private
	     * @param {*} objValue The destination value.
	     * @param {*} srcValue The source value.
	     * @param {string} key The key of the property to merge.
	     * @param {Object} object The parent object of `objValue`.
	     * @param {Object} source The parent object of `srcValue`.
	     * @param {Object} [stack] Tracks traversed source values and their merged
	     *  counterparts.
	     * @returns {*} Returns the value to assign.
	     */
	    function customDefaultsMerge(objValue, srcValue, key, object, source, stack) {
	      if (isObject(objValue) && isObject(srcValue)) {
	        // Recursively merge objects and arrays (susceptible to call stack limits).
	        stack.set(srcValue, objValue);
	        baseMerge(objValue, srcValue, undefined, customDefaultsMerge, stack);
	        stack['delete'](srcValue);
	      }
	      return objValue;
	    }
	
	    /**
	     * Used by `_.omit` to customize its `_.cloneDeep` use to only clone plain
	     * objects.
	     *
	     * @private
	     * @param {*} value The value to inspect.
	     * @param {string} key The key of the property to inspect.
	     * @returns {*} Returns the uncloned value or `undefined` to defer cloning to `_.cloneDeep`.
	     */
	    function customOmitClone(value) {
	      return isPlainObject(value) ? undefined : value;
	    }
	
	    /**
	     * A specialized version of `baseIsEqualDeep` for arrays with support for
	     * partial deep comparisons.
	     *
	     * @private
	     * @param {Array} array The array to compare.
	     * @param {Array} other The other array to compare.
	     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	     * @param {Function} customizer The function to customize comparisons.
	     * @param {Function} equalFunc The function to determine equivalents of values.
	     * @param {Object} stack Tracks traversed `array` and `other` objects.
	     * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
	     */
	    function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
	      var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
	          arrLength = array.length,
	          othLength = other.length;
	
	      if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
	        return false;
	      }
	      // Assume cyclic values are equal.
	      var stacked = stack.get(array);
	      if (stacked && stack.get(other)) {
	        return stacked == other;
	      }
	      var index = -1,
	          result = true,
	          seen = (bitmask & COMPARE_UNORDERED_FLAG) ? new SetCache : undefined;
	
	      stack.set(array, other);
	      stack.set(other, array);
	
	      // Ignore non-index properties.
	      while (++index < arrLength) {
	        var arrValue = array[index],
	            othValue = other[index];
	
	        if (customizer) {
	          var compared = isPartial
	            ? customizer(othValue, arrValue, index, other, array, stack)
	            : customizer(arrValue, othValue, index, array, other, stack);
	        }
	        if (compared !== undefined) {
	          if (compared) {
	            continue;
	          }
	          result = false;
	          break;
	        }
	        // Recursively compare arrays (susceptible to call stack limits).
	        if (seen) {
	          if (!arraySome(other, function(othValue, othIndex) {
	                if (!cacheHas(seen, othIndex) &&
	                    (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
	                  return seen.push(othIndex);
	                }
	              })) {
	            result = false;
	            break;
	          }
	        } else if (!(
	              arrValue === othValue ||
	                equalFunc(arrValue, othValue, bitmask, customizer, stack)
	            )) {
	          result = false;
	          break;
	        }
	      }
	      stack['delete'](array);
	      stack['delete'](other);
	      return result;
	    }
	
	    /**
	     * A specialized version of `baseIsEqualDeep` for comparing objects of
	     * the same `toStringTag`.
	     *
	     * **Note:** This function only supports comparing values with tags of
	     * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
	     *
	     * @private
	     * @param {Object} object The object to compare.
	     * @param {Object} other The other object to compare.
	     * @param {string} tag The `toStringTag` of the objects to compare.
	     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	     * @param {Function} customizer The function to customize comparisons.
	     * @param {Function} equalFunc The function to determine equivalents of values.
	     * @param {Object} stack Tracks traversed `object` and `other` objects.
	     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	     */
	    function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
	      switch (tag) {
	        case dataViewTag:
	          if ((object.byteLength != other.byteLength) ||
	              (object.byteOffset != other.byteOffset)) {
	            return false;
	          }
	          object = object.buffer;
	          other = other.buffer;
	
	        case arrayBufferTag:
	          if ((object.byteLength != other.byteLength) ||
	              !equalFunc(new Uint8Array(object), new Uint8Array(other))) {
	            return false;
	          }
	          return true;
	
	        case boolTag:
	        case dateTag:
	        case numberTag:
	          // Coerce booleans to `1` or `0` and dates to milliseconds.
	          // Invalid dates are coerced to `NaN`.
	          return eq(+object, +other);
	
	        case errorTag:
	          return object.name == other.name && object.message == other.message;
	
	        case regexpTag:
	        case stringTag:
	          // Coerce regexes to strings and treat strings, primitives and objects,
	          // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
	          // for more details.
	          return object == (other + '');
	
	        case mapTag:
	          var convert = mapToArray;
	
	        case setTag:
	          var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
	          convert || (convert = setToArray);
	
	          if (object.size != other.size && !isPartial) {
	            return false;
	          }
	          // Assume cyclic values are equal.
	          var stacked = stack.get(object);
	          if (stacked) {
	            return stacked == other;
	          }
	          bitmask |= COMPARE_UNORDERED_FLAG;
	
	          // Recursively compare objects (susceptible to call stack limits).
	          stack.set(object, other);
	          var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
	          stack['delete'](object);
	          return result;
	
	        case symbolTag:
	          if (symbolValueOf) {
	            return symbolValueOf.call(object) == symbolValueOf.call(other);
	          }
	      }
	      return false;
	    }
	
	    /**
	     * A specialized version of `baseIsEqualDeep` for objects with support for
	     * partial deep comparisons.
	     *
	     * @private
	     * @param {Object} object The object to compare.
	     * @param {Object} other The other object to compare.
	     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	     * @param {Function} customizer The function to customize comparisons.
	     * @param {Function} equalFunc The function to determine equivalents of values.
	     * @param {Object} stack Tracks traversed `object` and `other` objects.
	     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	     */
	    function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
	      var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
	          objProps = getAllKeys(object),
	          objLength = objProps.length,
	          othProps = getAllKeys(other),
	          othLength = othProps.length;
	
	      if (objLength != othLength && !isPartial) {
	        return false;
	      }
	      var index = objLength;
	      while (index--) {
	        var key = objProps[index];
	        if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) {
	          return false;
	        }
	      }
	      // Assume cyclic values are equal.
	      var stacked = stack.get(object);
	      if (stacked && stack.get(other)) {
	        return stacked == other;
	      }
	      var result = true;
	      stack.set(object, other);
	      stack.set(other, object);
	
	      var skipCtor = isPartial;
	      while (++index < objLength) {
	        key = objProps[index];
	        var objValue = object[key],
	            othValue = other[key];
	
	        if (customizer) {
	          var compared = isPartial
	            ? customizer(othValue, objValue, key, other, object, stack)
	            : customizer(objValue, othValue, key, object, other, stack);
	        }
	        // Recursively compare objects (susceptible to call stack limits).
	        if (!(compared === undefined
	              ? (objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack))
	              : compared
	            )) {
	          result = false;
	          break;
	        }
	        skipCtor || (skipCtor = key == 'constructor');
	      }
	      if (result && !skipCtor) {
	        var objCtor = object.constructor,
	            othCtor = other.constructor;
	
	        // Non `Object` object instances with different constructors are not equal.
	        if (objCtor != othCtor &&
	            ('constructor' in object && 'constructor' in other) &&
	            !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
	              typeof othCtor == 'function' && othCtor instanceof othCtor)) {
	          result = false;
	        }
	      }
	      stack['delete'](object);
	      stack['delete'](other);
	      return result;
	    }
	
	    /**
	     * A specialized version of `baseRest` which flattens the rest array.
	     *
	     * @private
	     * @param {Function} func The function to apply a rest parameter to.
	     * @returns {Function} Returns the new function.
	     */
	    function flatRest(func) {
	      return setToString(overRest(func, undefined, flatten), func + '');
	    }
	
	    /**
	     * Creates an array of own enumerable property names and symbols of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property names and symbols.
	     */
	    function getAllKeys(object) {
	      return baseGetAllKeys(object, keys, getSymbols);
	    }
	
	    /**
	     * Creates an array of own and inherited enumerable property names and
	     * symbols of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property names and symbols.
	     */
	    function getAllKeysIn(object) {
	      return baseGetAllKeys(object, keysIn, getSymbolsIn);
	    }
	
	    /**
	     * Gets metadata for `func`.
	     *
	     * @private
	     * @param {Function} func The function to query.
	     * @returns {*} Returns the metadata for `func`.
	     */
	    var getData = !metaMap ? noop : function(func) {
	      return metaMap.get(func);
	    };
	
	    /**
	     * Gets the name of `func`.
	     *
	     * @private
	     * @param {Function} func The function to query.
	     * @returns {string} Returns the function name.
	     */
	    function getFuncName(func) {
	      var result = (func.name + ''),
	          array = realNames[result],
	          length = hasOwnProperty.call(realNames, result) ? array.length : 0;
	
	      while (length--) {
	        var data = array[length],
	            otherFunc = data.func;
	        if (otherFunc == null || otherFunc == func) {
	          return data.name;
	        }
	      }
	      return result;
	    }
	
	    /**
	     * Gets the argument placeholder value for `func`.
	     *
	     * @private
	     * @param {Function} func The function to inspect.
	     * @returns {*} Returns the placeholder value.
	     */
	    function getHolder(func) {
	      var object = hasOwnProperty.call(lodash, 'placeholder') ? lodash : func;
	      return object.placeholder;
	    }
	
	    /**
	     * Gets the appropriate "iteratee" function. If `_.iteratee` is customized,
	     * this function returns the custom method, otherwise it returns `baseIteratee`.
	     * If arguments are provided, the chosen function is invoked with them and
	     * its result is returned.
	     *
	     * @private
	     * @param {*} [value] The value to convert to an iteratee.
	     * @param {number} [arity] The arity of the created iteratee.
	     * @returns {Function} Returns the chosen function or its result.
	     */
	    function getIteratee() {
	      var result = lodash.iteratee || iteratee;
	      result = result === iteratee ? baseIteratee : result;
	      return arguments.length ? result(arguments[0], arguments[1]) : result;
	    }
	
	    /**
	     * Gets the data for `map`.
	     *
	     * @private
	     * @param {Object} map The map to query.
	     * @param {string} key The reference key.
	     * @returns {*} Returns the map data.
	     */
	    function getMapData(map, key) {
	      var data = map.__data__;
	      return isKeyable(key)
	        ? data[typeof key == 'string' ? 'string' : 'hash']
	        : data.map;
	    }
	
	    /**
	     * Gets the property names, values, and compare flags of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the match data of `object`.
	     */
	    function getMatchData(object) {
	      var result = keys(object),
	          length = result.length;
	
	      while (length--) {
	        var key = result[length],
	            value = object[key];
	
	        result[length] = [key, value, isStrictComparable(value)];
	      }
	      return result;
	    }
	
	    /**
	     * Gets the native function at `key` of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {string} key The key of the method to get.
	     * @returns {*} Returns the function if it's native, else `undefined`.
	     */
	    function getNative(object, key) {
	      var value = getValue(object, key);
	      return baseIsNative(value) ? value : undefined;
	    }
	
	    /**
	     * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
	     *
	     * @private
	     * @param {*} value The value to query.
	     * @returns {string} Returns the raw `toStringTag`.
	     */
	    function getRawTag(value) {
	      var isOwn = hasOwnProperty.call(value, symToStringTag),
	          tag = value[symToStringTag];
	
	      try {
	        value[symToStringTag] = undefined;
	        var unmasked = true;
	      } catch (e) {}
	
	      var result = nativeObjectToString.call(value);
	      if (unmasked) {
	        if (isOwn) {
	          value[symToStringTag] = tag;
	        } else {
	          delete value[symToStringTag];
	        }
	      }
	      return result;
	    }
	
	    /**
	     * Creates an array of the own enumerable symbols of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of symbols.
	     */
	    var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
	      if (object == null) {
	        return [];
	      }
	      object = Object(object);
	      return arrayFilter(nativeGetSymbols(object), function(symbol) {
	        return propertyIsEnumerable.call(object, symbol);
	      });
	    };
	
	    /**
	     * Creates an array of the own and inherited enumerable symbols of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of symbols.
	     */
	    var getSymbolsIn = !nativeGetSymbols ? stubArray : function(object) {
	      var result = [];
	      while (object) {
	        arrayPush(result, getSymbols(object));
	        object = getPrototype(object);
	      }
	      return result;
	    };
	
	    /**
	     * Gets the `toStringTag` of `value`.
	     *
	     * @private
	     * @param {*} value The value to query.
	     * @returns {string} Returns the `toStringTag`.
	     */
	    var getTag = baseGetTag;
	
	    // Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
	    if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
	        (Map && getTag(new Map) != mapTag) ||
	        (Promise && getTag(Promise.resolve()) != promiseTag) ||
	        (Set && getTag(new Set) != setTag) ||
	        (WeakMap && getTag(new WeakMap) != weakMapTag)) {
	      getTag = function(value) {
	        var result = baseGetTag(value),
	            Ctor = result == objectTag ? value.constructor : undefined,
	            ctorString = Ctor ? toSource(Ctor) : '';
	
	        if (ctorString) {
	          switch (ctorString) {
	            case dataViewCtorString: return dataViewTag;
	            case mapCtorString: return mapTag;
	            case promiseCtorString: return promiseTag;
	            case setCtorString: return setTag;
	            case weakMapCtorString: return weakMapTag;
	          }
	        }
	        return result;
	      };
	    }
	
	    /**
	     * Gets the view, applying any `transforms` to the `start` and `end` positions.
	     *
	     * @private
	     * @param {number} start The start of the view.
	     * @param {number} end The end of the view.
	     * @param {Array} transforms The transformations to apply to the view.
	     * @returns {Object} Returns an object containing the `start` and `end`
	     *  positions of the view.
	     */
	    function getView(start, end, transforms) {
	      var index = -1,
	          length = transforms.length;
	
	      while (++index < length) {
	        var data = transforms[index],
	            size = data.size;
	
	        switch (data.type) {
	          case 'drop':      start += size; break;
	          case 'dropRight': end -= size; break;
	          case 'take':      end = nativeMin(end, start + size); break;
	          case 'takeRight': start = nativeMax(start, end - size); break;
	        }
	      }
	      return { 'start': start, 'end': end };
	    }
	
	    /**
	     * Extracts wrapper details from the `source` body comment.
	     *
	     * @private
	     * @param {string} source The source to inspect.
	     * @returns {Array} Returns the wrapper details.
	     */
	    function getWrapDetails(source) {
	      var match = source.match(reWrapDetails);
	      return match ? match[1].split(reSplitDetails) : [];
	    }
	
	    /**
	     * Checks if `path` exists on `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path to check.
	     * @param {Function} hasFunc The function to check properties.
	     * @returns {boolean} Returns `true` if `path` exists, else `false`.
	     */
	    function hasPath(object, path, hasFunc) {
	      path = castPath(path, object);
	
	      var index = -1,
	          length = path.length,
	          result = false;
	
	      while (++index < length) {
	        var key = toKey(path[index]);
	        if (!(result = object != null && hasFunc(object, key))) {
	          break;
	        }
	        object = object[key];
	      }
	      if (result || ++index != length) {
	        return result;
	      }
	      length = object == null ? 0 : object.length;
	      return !!length && isLength(length) && isIndex(key, length) &&
	        (isArray(object) || isArguments(object));
	    }
	
	    /**
	     * Initializes an array clone.
	     *
	     * @private
	     * @param {Array} array The array to clone.
	     * @returns {Array} Returns the initialized clone.
	     */
	    function initCloneArray(array) {
	      var length = array.length,
	          result = new array.constructor(length);
	
	      // Add properties assigned by `RegExp#exec`.
	      if (length && typeof array[0] == 'string' && hasOwnProperty.call(array, 'index')) {
	        result.index = array.index;
	        result.input = array.input;
	      }
	      return result;
	    }
	
	    /**
	     * Initializes an object clone.
	     *
	     * @private
	     * @param {Object} object The object to clone.
	     * @returns {Object} Returns the initialized clone.
	     */
	    function initCloneObject(object) {
	      return (typeof object.constructor == 'function' && !isPrototype(object))
	        ? baseCreate(getPrototype(object))
	        : {};
	    }
	
	    /**
	     * Initializes an object clone based on its `toStringTag`.
	     *
	     * **Note:** This function only supports cloning values with tags of
	     * `Boolean`, `Date`, `Error`, `Map`, `Number`, `RegExp`, `Set`, or `String`.
	     *
	     * @private
	     * @param {Object} object The object to clone.
	     * @param {string} tag The `toStringTag` of the object to clone.
	     * @param {boolean} [isDeep] Specify a deep clone.
	     * @returns {Object} Returns the initialized clone.
	     */
	    function initCloneByTag(object, tag, isDeep) {
	      var Ctor = object.constructor;
	      switch (tag) {
	        case arrayBufferTag:
	          return cloneArrayBuffer(object);
	
	        case boolTag:
	        case dateTag:
	          return new Ctor(+object);
	
	        case dataViewTag:
	          return cloneDataView(object, isDeep);
	
	        case float32Tag: case float64Tag:
	        case int8Tag: case int16Tag: case int32Tag:
	        case uint8Tag: case uint8ClampedTag: case uint16Tag: case uint32Tag:
	          return cloneTypedArray(object, isDeep);
	
	        case mapTag:
	          return new Ctor;
	
	        case numberTag:
	        case stringTag:
	          return new Ctor(object);
	
	        case regexpTag:
	          return cloneRegExp(object);
	
	        case setTag:
	          return new Ctor;
	
	        case symbolTag:
	          return cloneSymbol(object);
	      }
	    }
	
	    /**
	     * Inserts wrapper `details` in a comment at the top of the `source` body.
	     *
	     * @private
	     * @param {string} source The source to modify.
	     * @returns {Array} details The details to insert.
	     * @returns {string} Returns the modified source.
	     */
	    function insertWrapDetails(source, details) {
	      var length = details.length;
	      if (!length) {
	        return source;
	      }
	      var lastIndex = length - 1;
	      details[lastIndex] = (length > 1 ? '& ' : '') + details[lastIndex];
	      details = details.join(length > 2 ? ', ' : ' ');
	      return source.replace(reWrapComment, '{\n/* [wrapped with ' + details + '] */\n');
	    }
	
	    /**
	     * Checks if `value` is a flattenable `arguments` object or array.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
	     */
	    function isFlattenable(value) {
	      return isArray(value) || isArguments(value) ||
	        !!(spreadableSymbol && value && value[spreadableSymbol]);
	    }
	
	    /**
	     * Checks if `value` is a valid array-like index.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
	     * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
	     */
	    function isIndex(value, length) {
	      var type = typeof value;
	      length = length == null ? MAX_SAFE_INTEGER : length;
	
	      return !!length &&
	        (type == 'number' ||
	          (type != 'symbol' && reIsUint.test(value))) &&
	            (value > -1 && value % 1 == 0 && value < length);
	    }
	
	    /**
	     * Checks if the given arguments are from an iteratee call.
	     *
	     * @private
	     * @param {*} value The potential iteratee value argument.
	     * @param {*} index The potential iteratee index or key argument.
	     * @param {*} object The potential iteratee object argument.
	     * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
	     *  else `false`.
	     */
	    function isIterateeCall(value, index, object) {
	      if (!isObject(object)) {
	        return false;
	      }
	      var type = typeof index;
	      if (type == 'number'
	            ? (isArrayLike(object) && isIndex(index, object.length))
	            : (type == 'string' && index in object)
	          ) {
	        return eq(object[index], value);
	      }
	      return false;
	    }
	
	    /**
	     * Checks if `value` is a property name and not a property path.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @param {Object} [object] The object to query keys on.
	     * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
	     */
	    function isKey(value, object) {
	      if (isArray(value)) {
	        return false;
	      }
	      var type = typeof value;
	      if (type == 'number' || type == 'symbol' || type == 'boolean' ||
	          value == null || isSymbol(value)) {
	        return true;
	      }
	      return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
	        (object != null && value in Object(object));
	    }
	
	    /**
	     * Checks if `value` is suitable for use as unique object key.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
	     */
	    function isKeyable(value) {
	      var type = typeof value;
	      return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
	        ? (value !== '__proto__')
	        : (value === null);
	    }
	
	    /**
	     * Checks if `func` has a lazy counterpart.
	     *
	     * @private
	     * @param {Function} func The function to check.
	     * @returns {boolean} Returns `true` if `func` has a lazy counterpart,
	     *  else `false`.
	     */
	    function isLaziable(func) {
	      var funcName = getFuncName(func),
	          other = lodash[funcName];
	
	      if (typeof other != 'function' || !(funcName in LazyWrapper.prototype)) {
	        return false;
	      }
	      if (func === other) {
	        return true;
	      }
	      var data = getData(other);
	      return !!data && func === data[0];
	    }
	
	    /**
	     * Checks if `func` has its source masked.
	     *
	     * @private
	     * @param {Function} func The function to check.
	     * @returns {boolean} Returns `true` if `func` is masked, else `false`.
	     */
	    function isMasked(func) {
	      return !!maskSrcKey && (maskSrcKey in func);
	    }
	
	    /**
	     * Checks if `func` is capable of being masked.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `func` is maskable, else `false`.
	     */
	    var isMaskable = coreJsData ? isFunction : stubFalse;
	
	    /**
	     * Checks if `value` is likely a prototype object.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
	     */
	    function isPrototype(value) {
	      var Ctor = value && value.constructor,
	          proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;
	
	      return value === proto;
	    }
	
	    /**
	     * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` if suitable for strict
	     *  equality comparisons, else `false`.
	     */
	    function isStrictComparable(value) {
	      return value === value && !isObject(value);
	    }
	
	    /**
	     * A specialized version of `matchesProperty` for source values suitable
	     * for strict equality comparisons, i.e. `===`.
	     *
	     * @private
	     * @param {string} key The key of the property to get.
	     * @param {*} srcValue The value to match.
	     * @returns {Function} Returns the new spec function.
	     */
	    function matchesStrictComparable(key, srcValue) {
	      return function(object) {
	        if (object == null) {
	          return false;
	        }
	        return object[key] === srcValue &&
	          (srcValue !== undefined || (key in Object(object)));
	      };
	    }
	
	    /**
	     * A specialized version of `_.memoize` which clears the memoized function's
	     * cache when it exceeds `MAX_MEMOIZE_SIZE`.
	     *
	     * @private
	     * @param {Function} func The function to have its output memoized.
	     * @returns {Function} Returns the new memoized function.
	     */
	    function memoizeCapped(func) {
	      var result = memoize(func, function(key) {
	        if (cache.size === MAX_MEMOIZE_SIZE) {
	          cache.clear();
	        }
	        return key;
	      });
	
	      var cache = result.cache;
	      return result;
	    }
	
	    /**
	     * Merges the function metadata of `source` into `data`.
	     *
	     * Merging metadata reduces the number of wrappers used to invoke a function.
	     * This is possible because methods like `_.bind`, `_.curry`, and `_.partial`
	     * may be applied regardless of execution order. Methods like `_.ary` and
	     * `_.rearg` modify function arguments, making the order in which they are
	     * executed important, preventing the merging of metadata. However, we make
	     * an exception for a safe combined case where curried functions have `_.ary`
	     * and or `_.rearg` applied.
	     *
	     * @private
	     * @param {Array} data The destination metadata.
	     * @param {Array} source The source metadata.
	     * @returns {Array} Returns `data`.
	     */
	    function mergeData(data, source) {
	      var bitmask = data[1],
	          srcBitmask = source[1],
	          newBitmask = bitmask | srcBitmask,
	          isCommon = newBitmask < (WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG | WRAP_ARY_FLAG);
	
	      var isCombo =
	        ((srcBitmask == WRAP_ARY_FLAG) && (bitmask == WRAP_CURRY_FLAG)) ||
	        ((srcBitmask == WRAP_ARY_FLAG) && (bitmask == WRAP_REARG_FLAG) && (data[7].length <= source[8])) ||
	        ((srcBitmask == (WRAP_ARY_FLAG | WRAP_REARG_FLAG)) && (source[7].length <= source[8]) && (bitmask == WRAP_CURRY_FLAG));
	
	      // Exit early if metadata can't be merged.
	      if (!(isCommon || isCombo)) {
	        return data;
	      }
	      // Use source `thisArg` if available.
	      if (srcBitmask & WRAP_BIND_FLAG) {
	        data[2] = source[2];
	        // Set when currying a bound function.
	        newBitmask |= bitmask & WRAP_BIND_FLAG ? 0 : WRAP_CURRY_BOUND_FLAG;
	      }
	      // Compose partial arguments.
	      var value = source[3];
	      if (value) {
	        var partials = data[3];
	        data[3] = partials ? composeArgs(partials, value, source[4]) : value;
	        data[4] = partials ? replaceHolders(data[3], PLACEHOLDER) : source[4];
	      }
	      // Compose partial right arguments.
	      value = source[5];
	      if (value) {
	        partials = data[5];
	        data[5] = partials ? composeArgsRight(partials, value, source[6]) : value;
	        data[6] = partials ? replaceHolders(data[5], PLACEHOLDER) : source[6];
	      }
	      // Use source `argPos` if available.
	      value = source[7];
	      if (value) {
	        data[7] = value;
	      }
	      // Use source `ary` if it's smaller.
	      if (srcBitmask & WRAP_ARY_FLAG) {
	        data[8] = data[8] == null ? source[8] : nativeMin(data[8], source[8]);
	      }
	      // Use source `arity` if one is not provided.
	      if (data[9] == null) {
	        data[9] = source[9];
	      }
	      // Use source `func` and merge bitmasks.
	      data[0] = source[0];
	      data[1] = newBitmask;
	
	      return data;
	    }
	
	    /**
	     * This function is like
	     * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
	     * except that it includes inherited enumerable properties.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property names.
	     */
	    function nativeKeysIn(object) {
	      var result = [];
	      if (object != null) {
	        for (var key in Object(object)) {
	          result.push(key);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * Converts `value` to a string using `Object.prototype.toString`.
	     *
	     * @private
	     * @param {*} value The value to convert.
	     * @returns {string} Returns the converted string.
	     */
	    function objectToString(value) {
	      return nativeObjectToString.call(value);
	    }
	
	    /**
	     * A specialized version of `baseRest` which transforms the rest array.
	     *
	     * @private
	     * @param {Function} func The function to apply a rest parameter to.
	     * @param {number} [start=func.length-1] The start position of the rest parameter.
	     * @param {Function} transform The rest array transform.
	     * @returns {Function} Returns the new function.
	     */
	    function overRest(func, start, transform) {
	      start = nativeMax(start === undefined ? (func.length - 1) : start, 0);
	      return function() {
	        var args = arguments,
	            index = -1,
	            length = nativeMax(args.length - start, 0),
	            array = Array(length);
	
	        while (++index < length) {
	          array[index] = args[start + index];
	        }
	        index = -1;
	        var otherArgs = Array(start + 1);
	        while (++index < start) {
	          otherArgs[index] = args[index];
	        }
	        otherArgs[start] = transform(array);
	        return apply(func, this, otherArgs);
	      };
	    }
	
	    /**
	     * Gets the parent value at `path` of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {Array} path The path to get the parent value of.
	     * @returns {*} Returns the parent value.
	     */
	    function parent(object, path) {
	      return path.length < 2 ? object : baseGet(object, baseSlice(path, 0, -1));
	    }
	
	    /**
	     * Reorder `array` according to the specified indexes where the element at
	     * the first index is assigned as the first element, the element at
	     * the second index is assigned as the second element, and so on.
	     *
	     * @private
	     * @param {Array} array The array to reorder.
	     * @param {Array} indexes The arranged array indexes.
	     * @returns {Array} Returns `array`.
	     */
	    function reorder(array, indexes) {
	      var arrLength = array.length,
	          length = nativeMin(indexes.length, arrLength),
	          oldArray = copyArray(array);
	
	      while (length--) {
	        var index = indexes[length];
	        array[length] = isIndex(index, arrLength) ? oldArray[index] : undefined;
	      }
	      return array;
	    }
	
	    /**
	     * Gets the value at `key`, unless `key` is "__proto__" or "constructor".
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {string} key The key of the property to get.
	     * @returns {*} Returns the property value.
	     */
	    function safeGet(object, key) {
	      if (key === 'constructor' && typeof object[key] === 'function') {
	        return;
	      }
	
	      if (key == '__proto__') {
	        return;
	      }
	
	      return object[key];
	    }
	
	    /**
	     * Sets metadata for `func`.
	     *
	     * **Note:** If this function becomes hot, i.e. is invoked a lot in a short
	     * period of time, it will trip its breaker and transition to an identity
	     * function to avoid garbage collection pauses in V8. See
	     * [V8 issue 2070](https://bugs.chromium.org/p/v8/issues/detail?id=2070)
	     * for more details.
	     *
	     * @private
	     * @param {Function} func The function to associate metadata with.
	     * @param {*} data The metadata.
	     * @returns {Function} Returns `func`.
	     */
	    var setData = shortOut(baseSetData);
	
	    /**
	     * A simple wrapper around the global [`setTimeout`](https://mdn.io/setTimeout).
	     *
	     * @private
	     * @param {Function} func The function to delay.
	     * @param {number} wait The number of milliseconds to delay invocation.
	     * @returns {number|Object} Returns the timer id or timeout object.
	     */
	    var setTimeout = ctxSetTimeout || function(func, wait) {
	      return root.setTimeout(func, wait);
	    };
	
	    /**
	     * Sets the `toString` method of `func` to return `string`.
	     *
	     * @private
	     * @param {Function} func The function to modify.
	     * @param {Function} string The `toString` result.
	     * @returns {Function} Returns `func`.
	     */
	    var setToString = shortOut(baseSetToString);
	
	    /**
	     * Sets the `toString` method of `wrapper` to mimic the source of `reference`
	     * with wrapper details in a comment at the top of the source body.
	     *
	     * @private
	     * @param {Function} wrapper The function to modify.
	     * @param {Function} reference The reference function.
	     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	     * @returns {Function} Returns `wrapper`.
	     */
	    function setWrapToString(wrapper, reference, bitmask) {
	      var source = (reference + '');
	      return setToString(wrapper, insertWrapDetails(source, updateWrapDetails(getWrapDetails(source), bitmask)));
	    }
	
	    /**
	     * Creates a function that'll short out and invoke `identity` instead
	     * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
	     * milliseconds.
	     *
	     * @private
	     * @param {Function} func The function to restrict.
	     * @returns {Function} Returns the new shortable function.
	     */
	    function shortOut(func) {
	      var count = 0,
	          lastCalled = 0;
	
	      return function() {
	        var stamp = nativeNow(),
	            remaining = HOT_SPAN - (stamp - lastCalled);
	
	        lastCalled = stamp;
	        if (remaining > 0) {
	          if (++count >= HOT_COUNT) {
	            return arguments[0];
	          }
	        } else {
	          count = 0;
	        }
	        return func.apply(undefined, arguments);
	      };
	    }
	
	    /**
	     * A specialized version of `_.shuffle` which mutates and sets the size of `array`.
	     *
	     * @private
	     * @param {Array} array The array to shuffle.
	     * @param {number} [size=array.length] The size of `array`.
	     * @returns {Array} Returns `array`.
	     */
	    function shuffleSelf(array, size) {
	      var index = -1,
	          length = array.length,
	          lastIndex = length - 1;
	
	      size = size === undefined ? length : size;
	      while (++index < size) {
	        var rand = baseRandom(index, lastIndex),
	            value = array[rand];
	
	        array[rand] = array[index];
	        array[index] = value;
	      }
	      array.length = size;
	      return array;
	    }
	
	    /**
	     * Converts `string` to a property path array.
	     *
	     * @private
	     * @param {string} string The string to convert.
	     * @returns {Array} Returns the property path array.
	     */
	    var stringToPath = memoizeCapped(function(string) {
	      var result = [];
	      if (string.charCodeAt(0) === 46 /* . */) {
	        result.push('');
	      }
	      string.replace(rePropName, function(match, number, quote, subString) {
	        result.push(quote ? subString.replace(reEscapeChar, '$1') : (number || match));
	      });
	      return result;
	    });
	
	    /**
	     * Converts `value` to a string key if it's not a string or symbol.
	     *
	     * @private
	     * @param {*} value The value to inspect.
	     * @returns {string|symbol} Returns the key.
	     */
	    function toKey(value) {
	      if (typeof value == 'string' || isSymbol(value)) {
	        return value;
	      }
	      var result = (value + '');
	      return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
	    }
	
	    /**
	     * Converts `func` to its source code.
	     *
	     * @private
	     * @param {Function} func The function to convert.
	     * @returns {string} Returns the source code.
	     */
	    function toSource(func) {
	      if (func != null) {
	        try {
	          return funcToString.call(func);
	        } catch (e) {}
	        try {
	          return (func + '');
	        } catch (e) {}
	      }
	      return '';
	    }
	
	    /**
	     * Updates wrapper `details` based on `bitmask` flags.
	     *
	     * @private
	     * @returns {Array} details The details to modify.
	     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	     * @returns {Array} Returns `details`.
	     */
	    function updateWrapDetails(details, bitmask) {
	      arrayEach(wrapFlags, function(pair) {
	        var value = '_.' + pair[0];
	        if ((bitmask & pair[1]) && !arrayIncludes(details, value)) {
	          details.push(value);
	        }
	      });
	      return details.sort();
	    }
	
	    /**
	     * Creates a clone of `wrapper`.
	     *
	     * @private
	     * @param {Object} wrapper The wrapper to clone.
	     * @returns {Object} Returns the cloned wrapper.
	     */
	    function wrapperClone(wrapper) {
	      if (wrapper instanceof LazyWrapper) {
	        return wrapper.clone();
	      }
	      var result = new LodashWrapper(wrapper.__wrapped__, wrapper.__chain__);
	      result.__actions__ = copyArray(wrapper.__actions__);
	      result.__index__  = wrapper.__index__;
	      result.__values__ = wrapper.__values__;
	      return result;
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates an array of elements split into groups the length of `size`.
	     * If `array` can't be split evenly, the final chunk will be the remaining
	     * elements.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to process.
	     * @param {number} [size=1] The length of each chunk
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Array} Returns the new array of chunks.
	     * @example
	     *
	     * _.chunk(['a', 'b', 'c', 'd'], 2);
	     * // => [['a', 'b'], ['c', 'd']]
	     *
	     * _.chunk(['a', 'b', 'c', 'd'], 3);
	     * // => [['a', 'b', 'c'], ['d']]
	     */
	    function chunk(array, size, guard) {
	      if ((guard ? isIterateeCall(array, size, guard) : size === undefined)) {
	        size = 1;
	      } else {
	        size = nativeMax(toInteger(size), 0);
	      }
	      var length = array == null ? 0 : array.length;
	      if (!length || size < 1) {
	        return [];
	      }
	      var index = 0,
	          resIndex = 0,
	          result = Array(nativeCeil(length / size));
	
	      while (index < length) {
	        result[resIndex++] = baseSlice(array, index, (index += size));
	      }
	      return result;
	    }
	
	    /**
	     * Creates an array with all falsey values removed. The values `false`, `null`,
	     * `0`, `""`, `undefined`, and `NaN` are falsey.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to compact.
	     * @returns {Array} Returns the new array of filtered values.
	     * @example
	     *
	     * _.compact([0, 1, false, 2, '', 3]);
	     * // => [1, 2, 3]
	     */
	    function compact(array) {
	      var index = -1,
	          length = array == null ? 0 : array.length,
	          resIndex = 0,
	          result = [];
	
	      while (++index < length) {
	        var value = array[index];
	        if (value) {
	          result[resIndex++] = value;
	        }
	      }
	      return result;
	    }
	
	    /**
	     * Creates a new array concatenating `array` with any additional arrays
	     * and/or values.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to concatenate.
	     * @param {...*} [values] The values to concatenate.
	     * @returns {Array} Returns the new concatenated array.
	     * @example
	     *
	     * var array = [1];
	     * var other = _.concat(array, 2, [3], [[4]]);
	     *
	     * console.log(other);
	     * // => [1, 2, 3, [4]]
	     *
	     * console.log(array);
	     * // => [1]
	     */
	    function concat() {
	      var length = arguments.length;
	      if (!length) {
	        return [];
	      }
	      var args = Array(length - 1),
	          array = arguments[0],
	          index = length;
	
	      while (index--) {
	        args[index - 1] = arguments[index];
	      }
	      return arrayPush(isArray(array) ? copyArray(array) : [array], baseFlatten(args, 1));
	    }
	
	    /**
	     * Creates an array of `array` values not included in the other given arrays
	     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * for equality comparisons. The order and references of result values are
	     * determined by the first array.
	     *
	     * **Note:** Unlike `_.pullAll`, this method returns a new array.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {...Array} [values] The values to exclude.
	     * @returns {Array} Returns the new array of filtered values.
	     * @see _.without, _.xor
	     * @example
	     *
	     * _.difference([2, 1], [2, 3]);
	     * // => [1]
	     */
	    var difference = baseRest(function(array, values) {
	      return isArrayLikeObject(array)
	        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true))
	        : [];
	    });
	
	    /**
	     * This method is like `_.difference` except that it accepts `iteratee` which
	     * is invoked for each element of `array` and `values` to generate the criterion
	     * by which they're compared. The order and references of result values are
	     * determined by the first array. The iteratee is invoked with one argument:
	     * (value).
	     *
	     * **Note:** Unlike `_.pullAllBy`, this method returns a new array.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {...Array} [values] The values to exclude.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {Array} Returns the new array of filtered values.
	     * @example
	     *
	     * _.differenceBy([2.1, 1.2], [2.3, 3.4], Math.floor);
	     * // => [1.2]
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.differenceBy([{ 'x': 2 }, { 'x': 1 }], [{ 'x': 1 }], 'x');
	     * // => [{ 'x': 2 }]
	     */
	    var differenceBy = baseRest(function(array, values) {
	      var iteratee = last(values);
	      if (isArrayLikeObject(iteratee)) {
	        iteratee = undefined;
	      }
	      return isArrayLikeObject(array)
	        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), getIteratee(iteratee, 2))
	        : [];
	    });
	
	    /**
	     * This method is like `_.difference` except that it accepts `comparator`
	     * which is invoked to compare elements of `array` to `values`. The order and
	     * references of result values are determined by the first array. The comparator
	     * is invoked with two arguments: (arrVal, othVal).
	     *
	     * **Note:** Unlike `_.pullAllWith`, this method returns a new array.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {...Array} [values] The values to exclude.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new array of filtered values.
	     * @example
	     *
	     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
	     *
	     * _.differenceWith(objects, [{ 'x': 1, 'y': 2 }], _.isEqual);
	     * // => [{ 'x': 2, 'y': 1 }]
	     */
	    var differenceWith = baseRest(function(array, values) {
	      var comparator = last(values);
	      if (isArrayLikeObject(comparator)) {
	        comparator = undefined;
	      }
	      return isArrayLikeObject(array)
	        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), undefined, comparator)
	        : [];
	    });
	
	    /**
	     * Creates a slice of `array` with `n` elements dropped from the beginning.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.5.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {number} [n=1] The number of elements to drop.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.drop([1, 2, 3]);
	     * // => [2, 3]
	     *
	     * _.drop([1, 2, 3], 2);
	     * // => [3]
	     *
	     * _.drop([1, 2, 3], 5);
	     * // => []
	     *
	     * _.drop([1, 2, 3], 0);
	     * // => [1, 2, 3]
	     */
	    function drop(array, n, guard) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return [];
	      }
	      n = (guard || n === undefined) ? 1 : toInteger(n);
	      return baseSlice(array, n < 0 ? 0 : n, length);
	    }
	
	    /**
	     * Creates a slice of `array` with `n` elements dropped from the end.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {number} [n=1] The number of elements to drop.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.dropRight([1, 2, 3]);
	     * // => [1, 2]
	     *
	     * _.dropRight([1, 2, 3], 2);
	     * // => [1]
	     *
	     * _.dropRight([1, 2, 3], 5);
	     * // => []
	     *
	     * _.dropRight([1, 2, 3], 0);
	     * // => [1, 2, 3]
	     */
	    function dropRight(array, n, guard) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return [];
	      }
	      n = (guard || n === undefined) ? 1 : toInteger(n);
	      n = length - n;
	      return baseSlice(array, 0, n < 0 ? 0 : n);
	    }
	
	    /**
	     * Creates a slice of `array` excluding elements dropped from the end.
	     * Elements are dropped until `predicate` returns falsey. The predicate is
	     * invoked with three arguments: (value, index, array).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'active': true },
	     *   { 'user': 'fred',    'active': false },
	     *   { 'user': 'pebbles', 'active': false }
	     * ];
	     *
	     * _.dropRightWhile(users, function(o) { return !o.active; });
	     * // => objects for ['barney']
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.dropRightWhile(users, { 'user': 'pebbles', 'active': false });
	     * // => objects for ['barney', 'fred']
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.dropRightWhile(users, ['active', false]);
	     * // => objects for ['barney']
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.dropRightWhile(users, 'active');
	     * // => objects for ['barney', 'fred', 'pebbles']
	     */
	    function dropRightWhile(array, predicate) {
	      return (array && array.length)
	        ? baseWhile(array, getIteratee(predicate, 3), true, true)
	        : [];
	    }
	
	    /**
	     * Creates a slice of `array` excluding elements dropped from the beginning.
	     * Elements are dropped until `predicate` returns falsey. The predicate is
	     * invoked with three arguments: (value, index, array).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'active': false },
	     *   { 'user': 'fred',    'active': false },
	     *   { 'user': 'pebbles', 'active': true }
	     * ];
	     *
	     * _.dropWhile(users, function(o) { return !o.active; });
	     * // => objects for ['pebbles']
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.dropWhile(users, { 'user': 'barney', 'active': false });
	     * // => objects for ['fred', 'pebbles']
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.dropWhile(users, ['active', false]);
	     * // => objects for ['pebbles']
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.dropWhile(users, 'active');
	     * // => objects for ['barney', 'fred', 'pebbles']
	     */
	    function dropWhile(array, predicate) {
	      return (array && array.length)
	        ? baseWhile(array, getIteratee(predicate, 3), true)
	        : [];
	    }
	
	    /**
	     * Fills elements of `array` with `value` from `start` up to, but not
	     * including, `end`.
	     *
	     * **Note:** This method mutates `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.2.0
	     * @category Array
	     * @param {Array} array The array to fill.
	     * @param {*} value The value to fill `array` with.
	     * @param {number} [start=0] The start position.
	     * @param {number} [end=array.length] The end position.
	     * @returns {Array} Returns `array`.
	     * @example
	     *
	     * var array = [1, 2, 3];
	     *
	     * _.fill(array, 'a');
	     * console.log(array);
	     * // => ['a', 'a', 'a']
	     *
	     * _.fill(Array(3), 2);
	     * // => [2, 2, 2]
	     *
	     * _.fill([4, 6, 8, 10], '*', 1, 3);
	     * // => [4, '*', '*', 10]
	     */
	    function fill(array, value, start, end) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return [];
	      }
	      if (start && typeof start != 'number' && isIterateeCall(array, value, start)) {
	        start = 0;
	        end = length;
	      }
	      return baseFill(array, value, start, end);
	    }
	
	    /**
	     * This method is like `_.find` except that it returns the index of the first
	     * element `predicate` returns truthy for instead of the element itself.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.1.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @param {number} [fromIndex=0] The index to search from.
	     * @returns {number} Returns the index of the found element, else `-1`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'active': false },
	     *   { 'user': 'fred',    'active': false },
	     *   { 'user': 'pebbles', 'active': true }
	     * ];
	     *
	     * _.findIndex(users, function(o) { return o.user == 'barney'; });
	     * // => 0
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.findIndex(users, { 'user': 'fred', 'active': false });
	     * // => 1
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.findIndex(users, ['active', false]);
	     * // => 0
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.findIndex(users, 'active');
	     * // => 2
	     */
	    function findIndex(array, predicate, fromIndex) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return -1;
	      }
	      var index = fromIndex == null ? 0 : toInteger(fromIndex);
	      if (index < 0) {
	        index = nativeMax(length + index, 0);
	      }
	      return baseFindIndex(array, getIteratee(predicate, 3), index);
	    }
	
	    /**
	     * This method is like `_.findIndex` except that it iterates over elements
	     * of `collection` from right to left.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @param {number} [fromIndex=array.length-1] The index to search from.
	     * @returns {number} Returns the index of the found element, else `-1`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'active': true },
	     *   { 'user': 'fred',    'active': false },
	     *   { 'user': 'pebbles', 'active': false }
	     * ];
	     *
	     * _.findLastIndex(users, function(o) { return o.user == 'pebbles'; });
	     * // => 2
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.findLastIndex(users, { 'user': 'barney', 'active': true });
	     * // => 0
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.findLastIndex(users, ['active', false]);
	     * // => 2
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.findLastIndex(users, 'active');
	     * // => 0
	     */
	    function findLastIndex(array, predicate, fromIndex) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return -1;
	      }
	      var index = length - 1;
	      if (fromIndex !== undefined) {
	        index = toInteger(fromIndex);
	        index = fromIndex < 0
	          ? nativeMax(length + index, 0)
	          : nativeMin(index, length - 1);
	      }
	      return baseFindIndex(array, getIteratee(predicate, 3), index, true);
	    }
	
	    /**
	     * Flattens `array` a single level deep.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to flatten.
	     * @returns {Array} Returns the new flattened array.
	     * @example
	     *
	     * _.flatten([1, [2, [3, [4]], 5]]);
	     * // => [1, 2, [3, [4]], 5]
	     */
	    function flatten(array) {
	      var length = array == null ? 0 : array.length;
	      return length ? baseFlatten(array, 1) : [];
	    }
	
	    /**
	     * Recursively flattens `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to flatten.
	     * @returns {Array} Returns the new flattened array.
	     * @example
	     *
	     * _.flattenDeep([1, [2, [3, [4]], 5]]);
	     * // => [1, 2, 3, 4, 5]
	     */
	    function flattenDeep(array) {
	      var length = array == null ? 0 : array.length;
	      return length ? baseFlatten(array, INFINITY) : [];
	    }
	
	    /**
	     * Recursively flatten `array` up to `depth` times.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.4.0
	     * @category Array
	     * @param {Array} array The array to flatten.
	     * @param {number} [depth=1] The maximum recursion depth.
	     * @returns {Array} Returns the new flattened array.
	     * @example
	     *
	     * var array = [1, [2, [3, [4]], 5]];
	     *
	     * _.flattenDepth(array, 1);
	     * // => [1, 2, [3, [4]], 5]
	     *
	     * _.flattenDepth(array, 2);
	     * // => [1, 2, 3, [4], 5]
	     */
	    function flattenDepth(array, depth) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return [];
	      }
	      depth = depth === undefined ? 1 : toInteger(depth);
	      return baseFlatten(array, depth);
	    }
	
	    /**
	     * The inverse of `_.toPairs`; this method returns an object composed
	     * from key-value `pairs`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} pairs The key-value pairs.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * _.fromPairs([['a', 1], ['b', 2]]);
	     * // => { 'a': 1, 'b': 2 }
	     */
	    function fromPairs(pairs) {
	      var index = -1,
	          length = pairs == null ? 0 : pairs.length,
	          result = {};
	
	      while (++index < length) {
	        var pair = pairs[index];
	        result[pair[0]] = pair[1];
	      }
	      return result;
	    }
	
	    /**
	     * Gets the first element of `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @alias first
	     * @category Array
	     * @param {Array} array The array to query.
	     * @returns {*} Returns the first element of `array`.
	     * @example
	     *
	     * _.head([1, 2, 3]);
	     * // => 1
	     *
	     * _.head([]);
	     * // => undefined
	     */
	    function head(array) {
	      return (array && array.length) ? array[0] : undefined;
	    }
	
	    /**
	     * Gets the index at which the first occurrence of `value` is found in `array`
	     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * for equality comparisons. If `fromIndex` is negative, it's used as the
	     * offset from the end of `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {*} value The value to search for.
	     * @param {number} [fromIndex=0] The index to search from.
	     * @returns {number} Returns the index of the matched value, else `-1`.
	     * @example
	     *
	     * _.indexOf([1, 2, 1, 2], 2);
	     * // => 1
	     *
	     * // Search from the `fromIndex`.
	     * _.indexOf([1, 2, 1, 2], 2, 2);
	     * // => 3
	     */
	    function indexOf(array, value, fromIndex) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return -1;
	      }
	      var index = fromIndex == null ? 0 : toInteger(fromIndex);
	      if (index < 0) {
	        index = nativeMax(length + index, 0);
	      }
	      return baseIndexOf(array, value, index);
	    }
	
	    /**
	     * Gets all but the last element of `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.initial([1, 2, 3]);
	     * // => [1, 2]
	     */
	    function initial(array) {
	      var length = array == null ? 0 : array.length;
	      return length ? baseSlice(array, 0, -1) : [];
	    }
	
	    /**
	     * Creates an array of unique values that are included in all given arrays
	     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * for equality comparisons. The order and references of result values are
	     * determined by the first array.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @returns {Array} Returns the new array of intersecting values.
	     * @example
	     *
	     * _.intersection([2, 1], [2, 3]);
	     * // => [2]
	     */
	    var intersection = baseRest(function(arrays) {
	      var mapped = arrayMap(arrays, castArrayLikeObject);
	      return (mapped.length && mapped[0] === arrays[0])
	        ? baseIntersection(mapped)
	        : [];
	    });
	
	    /**
	     * This method is like `_.intersection` except that it accepts `iteratee`
	     * which is invoked for each element of each `arrays` to generate the criterion
	     * by which they're compared. The order and references of result values are
	     * determined by the first array. The iteratee is invoked with one argument:
	     * (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {Array} Returns the new array of intersecting values.
	     * @example
	     *
	     * _.intersectionBy([2.1, 1.2], [2.3, 3.4], Math.floor);
	     * // => [2.1]
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.intersectionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
	     * // => [{ 'x': 1 }]
	     */
	    var intersectionBy = baseRest(function(arrays) {
	      var iteratee = last(arrays),
	          mapped = arrayMap(arrays, castArrayLikeObject);
	
	      if (iteratee === last(mapped)) {
	        iteratee = undefined;
	      } else {
	        mapped.pop();
	      }
	      return (mapped.length && mapped[0] === arrays[0])
	        ? baseIntersection(mapped, getIteratee(iteratee, 2))
	        : [];
	    });
	
	    /**
	     * This method is like `_.intersection` except that it accepts `comparator`
	     * which is invoked to compare elements of `arrays`. The order and references
	     * of result values are determined by the first array. The comparator is
	     * invoked with two arguments: (arrVal, othVal).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new array of intersecting values.
	     * @example
	     *
	     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
	     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
	     *
	     * _.intersectionWith(objects, others, _.isEqual);
	     * // => [{ 'x': 1, 'y': 2 }]
	     */
	    var intersectionWith = baseRest(function(arrays) {
	      var comparator = last(arrays),
	          mapped = arrayMap(arrays, castArrayLikeObject);
	
	      comparator = typeof comparator == 'function' ? comparator : undefined;
	      if (comparator) {
	        mapped.pop();
	      }
	      return (mapped.length && mapped[0] === arrays[0])
	        ? baseIntersection(mapped, undefined, comparator)
	        : [];
	    });
	
	    /**
	     * Converts all elements in `array` into a string separated by `separator`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to convert.
	     * @param {string} [separator=','] The element separator.
	     * @returns {string} Returns the joined string.
	     * @example
	     *
	     * _.join(['a', 'b', 'c'], '~');
	     * // => 'a~b~c'
	     */
	    function join(array, separator) {
	      return array == null ? '' : nativeJoin.call(array, separator);
	    }
	
	    /**
	     * Gets the last element of `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @returns {*} Returns the last element of `array`.
	     * @example
	     *
	     * _.last([1, 2, 3]);
	     * // => 3
	     */
	    function last(array) {
	      var length = array == null ? 0 : array.length;
	      return length ? array[length - 1] : undefined;
	    }
	
	    /**
	     * This method is like `_.indexOf` except that it iterates over elements of
	     * `array` from right to left.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {*} value The value to search for.
	     * @param {number} [fromIndex=array.length-1] The index to search from.
	     * @returns {number} Returns the index of the matched value, else `-1`.
	     * @example
	     *
	     * _.lastIndexOf([1, 2, 1, 2], 2);
	     * // => 3
	     *
	     * // Search from the `fromIndex`.
	     * _.lastIndexOf([1, 2, 1, 2], 2, 2);
	     * // => 1
	     */
	    function lastIndexOf(array, value, fromIndex) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return -1;
	      }
	      var index = length;
	      if (fromIndex !== undefined) {
	        index = toInteger(fromIndex);
	        index = index < 0 ? nativeMax(length + index, 0) : nativeMin(index, length - 1);
	      }
	      return value === value
	        ? strictLastIndexOf(array, value, index)
	        : baseFindIndex(array, baseIsNaN, index, true);
	    }
	
	    /**
	     * Gets the element at index `n` of `array`. If `n` is negative, the nth
	     * element from the end is returned.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.11.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {number} [n=0] The index of the element to return.
	     * @returns {*} Returns the nth element of `array`.
	     * @example
	     *
	     * var array = ['a', 'b', 'c', 'd'];
	     *
	     * _.nth(array, 1);
	     * // => 'b'
	     *
	     * _.nth(array, -2);
	     * // => 'c';
	     */
	    function nth(array, n) {
	      return (array && array.length) ? baseNth(array, toInteger(n)) : undefined;
	    }
	
	    /**
	     * Removes all given values from `array` using
	     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * for equality comparisons.
	     *
	     * **Note:** Unlike `_.without`, this method mutates `array`. Use `_.remove`
	     * to remove elements from an array by predicate.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @param {...*} [values] The values to remove.
	     * @returns {Array} Returns `array`.
	     * @example
	     *
	     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
	     *
	     * _.pull(array, 'a', 'c');
	     * console.log(array);
	     * // => ['b', 'b']
	     */
	    var pull = baseRest(pullAll);
	
	    /**
	     * This method is like `_.pull` except that it accepts an array of values to remove.
	     *
	     * **Note:** Unlike `_.difference`, this method mutates `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @param {Array} values The values to remove.
	     * @returns {Array} Returns `array`.
	     * @example
	     *
	     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
	     *
	     * _.pullAll(array, ['a', 'c']);
	     * console.log(array);
	     * // => ['b', 'b']
	     */
	    function pullAll(array, values) {
	      return (array && array.length && values && values.length)
	        ? basePullAll(array, values)
	        : array;
	    }
	
	    /**
	     * This method is like `_.pullAll` except that it accepts `iteratee` which is
	     * invoked for each element of `array` and `values` to generate the criterion
	     * by which they're compared. The iteratee is invoked with one argument: (value).
	     *
	     * **Note:** Unlike `_.differenceBy`, this method mutates `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @param {Array} values The values to remove.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {Array} Returns `array`.
	     * @example
	     *
	     * var array = [{ 'x': 1 }, { 'x': 2 }, { 'x': 3 }, { 'x': 1 }];
	     *
	     * _.pullAllBy(array, [{ 'x': 1 }, { 'x': 3 }], 'x');
	     * console.log(array);
	     * // => [{ 'x': 2 }]
	     */
	    function pullAllBy(array, values, iteratee) {
	      return (array && array.length && values && values.length)
	        ? basePullAll(array, values, getIteratee(iteratee, 2))
	        : array;
	    }
	
	    /**
	     * This method is like `_.pullAll` except that it accepts `comparator` which
	     * is invoked to compare elements of `array` to `values`. The comparator is
	     * invoked with two arguments: (arrVal, othVal).
	     *
	     * **Note:** Unlike `_.differenceWith`, this method mutates `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.6.0
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @param {Array} values The values to remove.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns `array`.
	     * @example
	     *
	     * var array = [{ 'x': 1, 'y': 2 }, { 'x': 3, 'y': 4 }, { 'x': 5, 'y': 6 }];
	     *
	     * _.pullAllWith(array, [{ 'x': 3, 'y': 4 }], _.isEqual);
	     * console.log(array);
	     * // => [{ 'x': 1, 'y': 2 }, { 'x': 5, 'y': 6 }]
	     */
	    function pullAllWith(array, values, comparator) {
	      return (array && array.length && values && values.length)
	        ? basePullAll(array, values, undefined, comparator)
	        : array;
	    }
	
	    /**
	     * Removes elements from `array` corresponding to `indexes` and returns an
	     * array of removed elements.
	     *
	     * **Note:** Unlike `_.at`, this method mutates `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @param {...(number|number[])} [indexes] The indexes of elements to remove.
	     * @returns {Array} Returns the new array of removed elements.
	     * @example
	     *
	     * var array = ['a', 'b', 'c', 'd'];
	     * var pulled = _.pullAt(array, [1, 3]);
	     *
	     * console.log(array);
	     * // => ['a', 'c']
	     *
	     * console.log(pulled);
	     * // => ['b', 'd']
	     */
	    var pullAt = flatRest(function(array, indexes) {
	      var length = array == null ? 0 : array.length,
	          result = baseAt(array, indexes);
	
	      basePullAt(array, arrayMap(indexes, function(index) {
	        return isIndex(index, length) ? +index : index;
	      }).sort(compareAscending));
	
	      return result;
	    });
	
	    /**
	     * Removes all elements from `array` that `predicate` returns truthy for
	     * and returns an array of the removed elements. The predicate is invoked
	     * with three arguments: (value, index, array).
	     *
	     * **Note:** Unlike `_.filter`, this method mutates `array`. Use `_.pull`
	     * to pull elements from an array by value.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the new array of removed elements.
	     * @example
	     *
	     * var array = [1, 2, 3, 4];
	     * var evens = _.remove(array, function(n) {
	     *   return n % 2 == 0;
	     * });
	     *
	     * console.log(array);
	     * // => [1, 3]
	     *
	     * console.log(evens);
	     * // => [2, 4]
	     */
	    function remove(array, predicate) {
	      var result = [];
	      if (!(array && array.length)) {
	        return result;
	      }
	      var index = -1,
	          indexes = [],
	          length = array.length;
	
	      predicate = getIteratee(predicate, 3);
	      while (++index < length) {
	        var value = array[index];
	        if (predicate(value, index, array)) {
	          result.push(value);
	          indexes.push(index);
	        }
	      }
	      basePullAt(array, indexes);
	      return result;
	    }
	
	    /**
	     * Reverses `array` so that the first element becomes the last, the second
	     * element becomes the second to last, and so on.
	     *
	     * **Note:** This method mutates `array` and is based on
	     * [`Array#reverse`](https://mdn.io/Array/reverse).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @returns {Array} Returns `array`.
	     * @example
	     *
	     * var array = [1, 2, 3];
	     *
	     * _.reverse(array);
	     * // => [3, 2, 1]
	     *
	     * console.log(array);
	     * // => [3, 2, 1]
	     */
	    function reverse(array) {
	      return array == null ? array : nativeReverse.call(array);
	    }
	
	    /**
	     * Creates a slice of `array` from `start` up to, but not including, `end`.
	     *
	     * **Note:** This method is used instead of
	     * [`Array#slice`](https://mdn.io/Array/slice) to ensure dense arrays are
	     * returned.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to slice.
	     * @param {number} [start=0] The start position.
	     * @param {number} [end=array.length] The end position.
	     * @returns {Array} Returns the slice of `array`.
	     */
	    function slice(array, start, end) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return [];
	      }
	      if (end && typeof end != 'number' && isIterateeCall(array, start, end)) {
	        start = 0;
	        end = length;
	      }
	      else {
	        start = start == null ? 0 : toInteger(start);
	        end = end === undefined ? length : toInteger(end);
	      }
	      return baseSlice(array, start, end);
	    }
	
	    /**
	     * Uses a binary search to determine the lowest index at which `value`
	     * should be inserted into `array` in order to maintain its sort order.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The sorted array to inspect.
	     * @param {*} value The value to evaluate.
	     * @returns {number} Returns the index at which `value` should be inserted
	     *  into `array`.
	     * @example
	     *
	     * _.sortedIndex([30, 50], 40);
	     * // => 1
	     */
	    function sortedIndex(array, value) {
	      return baseSortedIndex(array, value);
	    }
	
	    /**
	     * This method is like `_.sortedIndex` except that it accepts `iteratee`
	     * which is invoked for `value` and each element of `array` to compute their
	     * sort ranking. The iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The sorted array to inspect.
	     * @param {*} value The value to evaluate.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {number} Returns the index at which `value` should be inserted
	     *  into `array`.
	     * @example
	     *
	     * var objects = [{ 'x': 4 }, { 'x': 5 }];
	     *
	     * _.sortedIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
	     * // => 0
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.sortedIndexBy(objects, { 'x': 4 }, 'x');
	     * // => 0
	     */
	    function sortedIndexBy(array, value, iteratee) {
	      return baseSortedIndexBy(array, value, getIteratee(iteratee, 2));
	    }
	
	    /**
	     * This method is like `_.indexOf` except that it performs a binary
	     * search on a sorted `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {*} value The value to search for.
	     * @returns {number} Returns the index of the matched value, else `-1`.
	     * @example
	     *
	     * _.sortedIndexOf([4, 5, 5, 5, 6], 5);
	     * // => 1
	     */
	    function sortedIndexOf(array, value) {
	      var length = array == null ? 0 : array.length;
	      if (length) {
	        var index = baseSortedIndex(array, value);
	        if (index < length && eq(array[index], value)) {
	          return index;
	        }
	      }
	      return -1;
	    }
	
	    /**
	     * This method is like `_.sortedIndex` except that it returns the highest
	     * index at which `value` should be inserted into `array` in order to
	     * maintain its sort order.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The sorted array to inspect.
	     * @param {*} value The value to evaluate.
	     * @returns {number} Returns the index at which `value` should be inserted
	     *  into `array`.
	     * @example
	     *
	     * _.sortedLastIndex([4, 5, 5, 5, 6], 5);
	     * // => 4
	     */
	    function sortedLastIndex(array, value) {
	      return baseSortedIndex(array, value, true);
	    }
	
	    /**
	     * This method is like `_.sortedLastIndex` except that it accepts `iteratee`
	     * which is invoked for `value` and each element of `array` to compute their
	     * sort ranking. The iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The sorted array to inspect.
	     * @param {*} value The value to evaluate.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {number} Returns the index at which `value` should be inserted
	     *  into `array`.
	     * @example
	     *
	     * var objects = [{ 'x': 4 }, { 'x': 5 }];
	     *
	     * _.sortedLastIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
	     * // => 1
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.sortedLastIndexBy(objects, { 'x': 4 }, 'x');
	     * // => 1
	     */
	    function sortedLastIndexBy(array, value, iteratee) {
	      return baseSortedIndexBy(array, value, getIteratee(iteratee, 2), true);
	    }
	
	    /**
	     * This method is like `_.lastIndexOf` except that it performs a binary
	     * search on a sorted `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {*} value The value to search for.
	     * @returns {number} Returns the index of the matched value, else `-1`.
	     * @example
	     *
	     * _.sortedLastIndexOf([4, 5, 5, 5, 6], 5);
	     * // => 3
	     */
	    function sortedLastIndexOf(array, value) {
	      var length = array == null ? 0 : array.length;
	      if (length) {
	        var index = baseSortedIndex(array, value, true) - 1;
	        if (eq(array[index], value)) {
	          return index;
	        }
	      }
	      return -1;
	    }
	
	    /**
	     * This method is like `_.uniq` except that it's designed and optimized
	     * for sorted arrays.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @returns {Array} Returns the new duplicate free array.
	     * @example
	     *
	     * _.sortedUniq([1, 1, 2]);
	     * // => [1, 2]
	     */
	    function sortedUniq(array) {
	      return (array && array.length)
	        ? baseSortedUniq(array)
	        : [];
	    }
	
	    /**
	     * This method is like `_.uniqBy` except that it's designed and optimized
	     * for sorted arrays.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {Function} [iteratee] The iteratee invoked per element.
	     * @returns {Array} Returns the new duplicate free array.
	     * @example
	     *
	     * _.sortedUniqBy([1.1, 1.2, 2.3, 2.4], Math.floor);
	     * // => [1.1, 2.3]
	     */
	    function sortedUniqBy(array, iteratee) {
	      return (array && array.length)
	        ? baseSortedUniq(array, getIteratee(iteratee, 2))
	        : [];
	    }
	
	    /**
	     * Gets all but the first element of `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.tail([1, 2, 3]);
	     * // => [2, 3]
	     */
	    function tail(array) {
	      var length = array == null ? 0 : array.length;
	      return length ? baseSlice(array, 1, length) : [];
	    }
	
	    /**
	     * Creates a slice of `array` with `n` elements taken from the beginning.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {number} [n=1] The number of elements to take.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.take([1, 2, 3]);
	     * // => [1]
	     *
	     * _.take([1, 2, 3], 2);
	     * // => [1, 2]
	     *
	     * _.take([1, 2, 3], 5);
	     * // => [1, 2, 3]
	     *
	     * _.take([1, 2, 3], 0);
	     * // => []
	     */
	    function take(array, n, guard) {
	      if (!(array && array.length)) {
	        return [];
	      }
	      n = (guard || n === undefined) ? 1 : toInteger(n);
	      return baseSlice(array, 0, n < 0 ? 0 : n);
	    }
	
	    /**
	     * Creates a slice of `array` with `n` elements taken from the end.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {number} [n=1] The number of elements to take.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.takeRight([1, 2, 3]);
	     * // => [3]
	     *
	     * _.takeRight([1, 2, 3], 2);
	     * // => [2, 3]
	     *
	     * _.takeRight([1, 2, 3], 5);
	     * // => [1, 2, 3]
	     *
	     * _.takeRight([1, 2, 3], 0);
	     * // => []
	     */
	    function takeRight(array, n, guard) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return [];
	      }
	      n = (guard || n === undefined) ? 1 : toInteger(n);
	      n = length - n;
	      return baseSlice(array, n < 0 ? 0 : n, length);
	    }
	
	    /**
	     * Creates a slice of `array` with elements taken from the end. Elements are
	     * taken until `predicate` returns falsey. The predicate is invoked with
	     * three arguments: (value, index, array).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'active': true },
	     *   { 'user': 'fred',    'active': false },
	     *   { 'user': 'pebbles', 'active': false }
	     * ];
	     *
	     * _.takeRightWhile(users, function(o) { return !o.active; });
	     * // => objects for ['fred', 'pebbles']
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.takeRightWhile(users, { 'user': 'pebbles', 'active': false });
	     * // => objects for ['pebbles']
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.takeRightWhile(users, ['active', false]);
	     * // => objects for ['fred', 'pebbles']
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.takeRightWhile(users, 'active');
	     * // => []
	     */
	    function takeRightWhile(array, predicate) {
	      return (array && array.length)
	        ? baseWhile(array, getIteratee(predicate, 3), false, true)
	        : [];
	    }
	
	    /**
	     * Creates a slice of `array` with elements taken from the beginning. Elements
	     * are taken until `predicate` returns falsey. The predicate is invoked with
	     * three arguments: (value, index, array).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'active': false },
	     *   { 'user': 'fred',    'active': false },
	     *   { 'user': 'pebbles', 'active': true }
	     * ];
	     *
	     * _.takeWhile(users, function(o) { return !o.active; });
	     * // => objects for ['barney', 'fred']
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.takeWhile(users, { 'user': 'barney', 'active': false });
	     * // => objects for ['barney']
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.takeWhile(users, ['active', false]);
	     * // => objects for ['barney', 'fred']
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.takeWhile(users, 'active');
	     * // => []
	     */
	    function takeWhile(array, predicate) {
	      return (array && array.length)
	        ? baseWhile(array, getIteratee(predicate, 3))
	        : [];
	    }
	
	    /**
	     * Creates an array of unique values, in order, from all given arrays using
	     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * for equality comparisons.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @returns {Array} Returns the new array of combined values.
	     * @example
	     *
	     * _.union([2], [1, 2]);
	     * // => [2, 1]
	     */
	    var union = baseRest(function(arrays) {
	      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true));
	    });
	
	    /**
	     * This method is like `_.union` except that it accepts `iteratee` which is
	     * invoked for each element of each `arrays` to generate the criterion by
	     * which uniqueness is computed. Result values are chosen from the first
	     * array in which the value occurs. The iteratee is invoked with one argument:
	     * (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {Array} Returns the new array of combined values.
	     * @example
	     *
	     * _.unionBy([2.1], [1.2, 2.3], Math.floor);
	     * // => [2.1, 1.2]
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.unionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
	     * // => [{ 'x': 1 }, { 'x': 2 }]
	     */
	    var unionBy = baseRest(function(arrays) {
	      var iteratee = last(arrays);
	      if (isArrayLikeObject(iteratee)) {
	        iteratee = undefined;
	      }
	      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), getIteratee(iteratee, 2));
	    });
	
	    /**
	     * This method is like `_.union` except that it accepts `comparator` which
	     * is invoked to compare elements of `arrays`. Result values are chosen from
	     * the first array in which the value occurs. The comparator is invoked
	     * with two arguments: (arrVal, othVal).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new array of combined values.
	     * @example
	     *
	     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
	     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
	     *
	     * _.unionWith(objects, others, _.isEqual);
	     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
	     */
	    var unionWith = baseRest(function(arrays) {
	      var comparator = last(arrays);
	      comparator = typeof comparator == 'function' ? comparator : undefined;
	      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), undefined, comparator);
	    });
	
	    /**
	     * Creates a duplicate-free version of an array, using
	     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * for equality comparisons, in which only the first occurrence of each element
	     * is kept. The order of result values is determined by the order they occur
	     * in the array.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @returns {Array} Returns the new duplicate free array.
	     * @example
	     *
	     * _.uniq([2, 1, 2]);
	     * // => [2, 1]
	     */
	    function uniq(array) {
	      return (array && array.length) ? baseUniq(array) : [];
	    }
	
	    /**
	     * This method is like `_.uniq` except that it accepts `iteratee` which is
	     * invoked for each element in `array` to generate the criterion by which
	     * uniqueness is computed. The order of result values is determined by the
	     * order they occur in the array. The iteratee is invoked with one argument:
	     * (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {Array} Returns the new duplicate free array.
	     * @example
	     *
	     * _.uniqBy([2.1, 1.2, 2.3], Math.floor);
	     * // => [2.1, 1.2]
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.uniqBy([{ 'x': 1 }, { 'x': 2 }, { 'x': 1 }], 'x');
	     * // => [{ 'x': 1 }, { 'x': 2 }]
	     */
	    function uniqBy(array, iteratee) {
	      return (array && array.length) ? baseUniq(array, getIteratee(iteratee, 2)) : [];
	    }
	
	    /**
	     * This method is like `_.uniq` except that it accepts `comparator` which
	     * is invoked to compare elements of `array`. The order of result values is
	     * determined by the order they occur in the array.The comparator is invoked
	     * with two arguments: (arrVal, othVal).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new duplicate free array.
	     * @example
	     *
	     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 2 }];
	     *
	     * _.uniqWith(objects, _.isEqual);
	     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }]
	     */
	    function uniqWith(array, comparator) {
	      comparator = typeof comparator == 'function' ? comparator : undefined;
	      return (array && array.length) ? baseUniq(array, undefined, comparator) : [];
	    }
	
	    /**
	     * This method is like `_.zip` except that it accepts an array of grouped
	     * elements and creates an array regrouping the elements to their pre-zip
	     * configuration.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.2.0
	     * @category Array
	     * @param {Array} array The array of grouped elements to process.
	     * @returns {Array} Returns the new array of regrouped elements.
	     * @example
	     *
	     * var zipped = _.zip(['a', 'b'], [1, 2], [true, false]);
	     * // => [['a', 1, true], ['b', 2, false]]
	     *
	     * _.unzip(zipped);
	     * // => [['a', 'b'], [1, 2], [true, false]]
	     */
	    function unzip(array) {
	      if (!(array && array.length)) {
	        return [];
	      }
	      var length = 0;
	      array = arrayFilter(array, function(group) {
	        if (isArrayLikeObject(group)) {
	          length = nativeMax(group.length, length);
	          return true;
	        }
	      });
	      return baseTimes(length, function(index) {
	        return arrayMap(array, baseProperty(index));
	      });
	    }
	
	    /**
	     * This method is like `_.unzip` except that it accepts `iteratee` to specify
	     * how regrouped values should be combined. The iteratee is invoked with the
	     * elements of each group: (...group).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.8.0
	     * @category Array
	     * @param {Array} array The array of grouped elements to process.
	     * @param {Function} [iteratee=_.identity] The function to combine
	     *  regrouped values.
	     * @returns {Array} Returns the new array of regrouped elements.
	     * @example
	     *
	     * var zipped = _.zip([1, 2], [10, 20], [100, 200]);
	     * // => [[1, 10, 100], [2, 20, 200]]
	     *
	     * _.unzipWith(zipped, _.add);
	     * // => [3, 30, 300]
	     */
	    function unzipWith(array, iteratee) {
	      if (!(array && array.length)) {
	        return [];
	      }
	      var result = unzip(array);
	      if (iteratee == null) {
	        return result;
	      }
	      return arrayMap(result, function(group) {
	        return apply(iteratee, undefined, group);
	      });
	    }
	
	    /**
	     * Creates an array excluding all given values using
	     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * for equality comparisons.
	     *
	     * **Note:** Unlike `_.pull`, this method returns a new array.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {...*} [values] The values to exclude.
	     * @returns {Array} Returns the new array of filtered values.
	     * @see _.difference, _.xor
	     * @example
	     *
	     * _.without([2, 1, 2, 3], 1, 2);
	     * // => [3]
	     */
	    var without = baseRest(function(array, values) {
	      return isArrayLikeObject(array)
	        ? baseDifference(array, values)
	        : [];
	    });
	
	    /**
	     * Creates an array of unique values that is the
	     * [symmetric difference](https://en.wikipedia.org/wiki/Symmetric_difference)
	     * of the given arrays. The order of result values is determined by the order
	     * they occur in the arrays.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.4.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @returns {Array} Returns the new array of filtered values.
	     * @see _.difference, _.without
	     * @example
	     *
	     * _.xor([2, 1], [2, 3]);
	     * // => [1, 3]
	     */
	    var xor = baseRest(function(arrays) {
	      return baseXor(arrayFilter(arrays, isArrayLikeObject));
	    });
	
	    /**
	     * This method is like `_.xor` except that it accepts `iteratee` which is
	     * invoked for each element of each `arrays` to generate the criterion by
	     * which by which they're compared. The order of result values is determined
	     * by the order they occur in the arrays. The iteratee is invoked with one
	     * argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {Array} Returns the new array of filtered values.
	     * @example
	     *
	     * _.xorBy([2.1, 1.2], [2.3, 3.4], Math.floor);
	     * // => [1.2, 3.4]
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.xorBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
	     * // => [{ 'x': 2 }]
	     */
	    var xorBy = baseRest(function(arrays) {
	      var iteratee = last(arrays);
	      if (isArrayLikeObject(iteratee)) {
	        iteratee = undefined;
	      }
	      return baseXor(arrayFilter(arrays, isArrayLikeObject), getIteratee(iteratee, 2));
	    });
	
	    /**
	     * This method is like `_.xor` except that it accepts `comparator` which is
	     * invoked to compare elements of `arrays`. The order of result values is
	     * determined by the order they occur in the arrays. The comparator is invoked
	     * with two arguments: (arrVal, othVal).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new array of filtered values.
	     * @example
	     *
	     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
	     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
	     *
	     * _.xorWith(objects, others, _.isEqual);
	     * // => [{ 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
	     */
	    var xorWith = baseRest(function(arrays) {
	      var comparator = last(arrays);
	      comparator = typeof comparator == 'function' ? comparator : undefined;
	      return baseXor(arrayFilter(arrays, isArrayLikeObject), undefined, comparator);
	    });
	
	    /**
	     * Creates an array of grouped elements, the first of which contains the
	     * first elements of the given arrays, the second of which contains the
	     * second elements of the given arrays, and so on.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to process.
	     * @returns {Array} Returns the new array of grouped elements.
	     * @example
	     *
	     * _.zip(['a', 'b'], [1, 2], [true, false]);
	     * // => [['a', 1, true], ['b', 2, false]]
	     */
	    var zip = baseRest(unzip);
	
	    /**
	     * This method is like `_.fromPairs` except that it accepts two arrays,
	     * one of property identifiers and one of corresponding values.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.4.0
	     * @category Array
	     * @param {Array} [props=[]] The property identifiers.
	     * @param {Array} [values=[]] The property values.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * _.zipObject(['a', 'b'], [1, 2]);
	     * // => { 'a': 1, 'b': 2 }
	     */
	    function zipObject(props, values) {
	      return baseZipObject(props || [], values || [], assignValue);
	    }
	
	    /**
	     * This method is like `_.zipObject` except that it supports property paths.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.1.0
	     * @category Array
	     * @param {Array} [props=[]] The property identifiers.
	     * @param {Array} [values=[]] The property values.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * _.zipObjectDeep(['a.b[0].c', 'a.b[1].d'], [1, 2]);
	     * // => { 'a': { 'b': [{ 'c': 1 }, { 'd': 2 }] } }
	     */
	    function zipObjectDeep(props, values) {
	      return baseZipObject(props || [], values || [], baseSet);
	    }
	
	    /**
	     * This method is like `_.zip` except that it accepts `iteratee` to specify
	     * how grouped values should be combined. The iteratee is invoked with the
	     * elements of each group: (...group).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.8.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to process.
	     * @param {Function} [iteratee=_.identity] The function to combine
	     *  grouped values.
	     * @returns {Array} Returns the new array of grouped elements.
	     * @example
	     *
	     * _.zipWith([1, 2], [10, 20], [100, 200], function(a, b, c) {
	     *   return a + b + c;
	     * });
	     * // => [111, 222]
	     */
	    var zipWith = baseRest(function(arrays) {
	      var length = arrays.length,
	          iteratee = length > 1 ? arrays[length - 1] : undefined;
	
	      iteratee = typeof iteratee == 'function' ? (arrays.pop(), iteratee) : undefined;
	      return unzipWith(arrays, iteratee);
	    });
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates a `lodash` wrapper instance that wraps `value` with explicit method
	     * chain sequences enabled. The result of such sequences must be unwrapped
	     * with `_#value`.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.3.0
	     * @category Seq
	     * @param {*} value The value to wrap.
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'age': 36 },
	     *   { 'user': 'fred',    'age': 40 },
	     *   { 'user': 'pebbles', 'age': 1 }
	     * ];
	     *
	     * var youngest = _
	     *   .chain(users)
	     *   .sortBy('age')
	     *   .map(function(o) {
	     *     return o.user + ' is ' + o.age;
	     *   })
	     *   .head()
	     *   .value();
	     * // => 'pebbles is 1'
	     */
	    function chain(value) {
	      var result = lodash(value);
	      result.__chain__ = true;
	      return result;
	    }
	
	    /**
	     * This method invokes `interceptor` and returns `value`. The interceptor
	     * is invoked with one argument; (value). The purpose of this method is to
	     * "tap into" a method chain sequence in order to modify intermediate results.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Seq
	     * @param {*} value The value to provide to `interceptor`.
	     * @param {Function} interceptor The function to invoke.
	     * @returns {*} Returns `value`.
	     * @example
	     *
	     * _([1, 2, 3])
	     *  .tap(function(array) {
	     *    // Mutate input array.
	     *    array.pop();
	     *  })
	     *  .reverse()
	     *  .value();
	     * // => [2, 1]
	     */
	    function tap(value, interceptor) {
	      interceptor(value);
	      return value;
	    }
	
	    /**
	     * This method is like `_.tap` except that it returns the result of `interceptor`.
	     * The purpose of this method is to "pass thru" values replacing intermediate
	     * results in a method chain sequence.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Seq
	     * @param {*} value The value to provide to `interceptor`.
	     * @param {Function} interceptor The function to invoke.
	     * @returns {*} Returns the result of `interceptor`.
	     * @example
	     *
	     * _('  abc  ')
	     *  .chain()
	     *  .trim()
	     *  .thru(function(value) {
	     *    return [value];
	     *  })
	     *  .value();
	     * // => ['abc']
	     */
	    function thru(value, interceptor) {
	      return interceptor(value);
	    }
	
	    /**
	     * This method is the wrapper version of `_.at`.
	     *
	     * @name at
	     * @memberOf _
	     * @since 1.0.0
	     * @category Seq
	     * @param {...(string|string[])} [paths] The property paths to pick.
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
	     *
	     * _(object).at(['a[0].b.c', 'a[1]']).value();
	     * // => [3, 4]
	     */
	    var wrapperAt = flatRest(function(paths) {
	      var length = paths.length,
	          start = length ? paths[0] : 0,
	          value = this.__wrapped__,
	          interceptor = function(object) { return baseAt(object, paths); };
	
	      if (length > 1 || this.__actions__.length ||
	          !(value instanceof LazyWrapper) || !isIndex(start)) {
	        return this.thru(interceptor);
	      }
	      value = value.slice(start, +start + (length ? 1 : 0));
	      value.__actions__.push({
	        'func': thru,
	        'args': [interceptor],
	        'thisArg': undefined
	      });
	      return new LodashWrapper(value, this.__chain__).thru(function(array) {
	        if (length && !array.length) {
	          array.push(undefined);
	        }
	        return array;
	      });
	    });
	
	    /**
	     * Creates a `lodash` wrapper instance with explicit method chain sequences enabled.
	     *
	     * @name chain
	     * @memberOf _
	     * @since 0.1.0
	     * @category Seq
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney', 'age': 36 },
	     *   { 'user': 'fred',   'age': 40 }
	     * ];
	     *
	     * // A sequence without explicit chaining.
	     * _(users).head();
	     * // => { 'user': 'barney', 'age': 36 }
	     *
	     * // A sequence with explicit chaining.
	     * _(users)
	     *   .chain()
	     *   .head()
	     *   .pick('user')
	     *   .value();
	     * // => { 'user': 'barney' }
	     */
	    function wrapperChain() {
	      return chain(this);
	    }
	
	    /**
	     * Executes the chain sequence and returns the wrapped result.
	     *
	     * @name commit
	     * @memberOf _
	     * @since 3.2.0
	     * @category Seq
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * var array = [1, 2];
	     * var wrapped = _(array).push(3);
	     *
	     * console.log(array);
	     * // => [1, 2]
	     *
	     * wrapped = wrapped.commit();
	     * console.log(array);
	     * // => [1, 2, 3]
	     *
	     * wrapped.last();
	     * // => 3
	     *
	     * console.log(array);
	     * // => [1, 2, 3]
	     */
	    function wrapperCommit() {
	      return new LodashWrapper(this.value(), this.__chain__);
	    }
	
	    /**
	     * Gets the next value on a wrapped object following the
	     * [iterator protocol](https://mdn.io/iteration_protocols#iterator).
	     *
	     * @name next
	     * @memberOf _
	     * @since 4.0.0
	     * @category Seq
	     * @returns {Object} Returns the next iterator value.
	     * @example
	     *
	     * var wrapped = _([1, 2]);
	     *
	     * wrapped.next();
	     * // => { 'done': false, 'value': 1 }
	     *
	     * wrapped.next();
	     * // => { 'done': false, 'value': 2 }
	     *
	     * wrapped.next();
	     * // => { 'done': true, 'value': undefined }
	     */
	    function wrapperNext() {
	      if (this.__values__ === undefined) {
	        this.__values__ = toArray(this.value());
	      }
	      var done = this.__index__ >= this.__values__.length,
	          value = done ? undefined : this.__values__[this.__index__++];
	
	      return { 'done': done, 'value': value };
	    }
	
	    /**
	     * Enables the wrapper to be iterable.
	     *
	     * @name Symbol.iterator
	     * @memberOf _
	     * @since 4.0.0
	     * @category Seq
	     * @returns {Object} Returns the wrapper object.
	     * @example
	     *
	     * var wrapped = _([1, 2]);
	     *
	     * wrapped[Symbol.iterator]() === wrapped;
	     * // => true
	     *
	     * Array.from(wrapped);
	     * // => [1, 2]
	     */
	    function wrapperToIterator() {
	      return this;
	    }
	
	    /**
	     * Creates a clone of the chain sequence planting `value` as the wrapped value.
	     *
	     * @name plant
	     * @memberOf _
	     * @since 3.2.0
	     * @category Seq
	     * @param {*} value The value to plant.
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * function square(n) {
	     *   return n * n;
	     * }
	     *
	     * var wrapped = _([1, 2]).map(square);
	     * var other = wrapped.plant([3, 4]);
	     *
	     * other.value();
	     * // => [9, 16]
	     *
	     * wrapped.value();
	     * // => [1, 4]
	     */
	    function wrapperPlant(value) {
	      var result,
	          parent = this;
	
	      while (parent instanceof baseLodash) {
	        var clone = wrapperClone(parent);
	        clone.__index__ = 0;
	        clone.__values__ = undefined;
	        if (result) {
	          previous.__wrapped__ = clone;
	        } else {
	          result = clone;
	        }
	        var previous = clone;
	        parent = parent.__wrapped__;
	      }
	      previous.__wrapped__ = value;
	      return result;
	    }
	
	    /**
	     * This method is the wrapper version of `_.reverse`.
	     *
	     * **Note:** This method mutates the wrapped array.
	     *
	     * @name reverse
	     * @memberOf _
	     * @since 0.1.0
	     * @category Seq
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * var array = [1, 2, 3];
	     *
	     * _(array).reverse().value()
	     * // => [3, 2, 1]
	     *
	     * console.log(array);
	     * // => [3, 2, 1]
	     */
	    function wrapperReverse() {
	      var value = this.__wrapped__;
	      if (value instanceof LazyWrapper) {
	        var wrapped = value;
	        if (this.__actions__.length) {
	          wrapped = new LazyWrapper(this);
	        }
	        wrapped = wrapped.reverse();
	        wrapped.__actions__.push({
	          'func': thru,
	          'args': [reverse],
	          'thisArg': undefined
	        });
	        return new LodashWrapper(wrapped, this.__chain__);
	      }
	      return this.thru(reverse);
	    }
	
	    /**
	     * Executes the chain sequence to resolve the unwrapped value.
	     *
	     * @name value
	     * @memberOf _
	     * @since 0.1.0
	     * @alias toJSON, valueOf
	     * @category Seq
	     * @returns {*} Returns the resolved unwrapped value.
	     * @example
	     *
	     * _([1, 2, 3]).value();
	     * // => [1, 2, 3]
	     */
	    function wrapperValue() {
	      return baseWrapperValue(this.__wrapped__, this.__actions__);
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates an object composed of keys generated from the results of running
	     * each element of `collection` thru `iteratee`. The corresponding value of
	     * each key is the number of times the key was returned by `iteratee`. The
	     * iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.5.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
	     * @returns {Object} Returns the composed aggregate object.
	     * @example
	     *
	     * _.countBy([6.1, 4.2, 6.3], Math.floor);
	     * // => { '4': 1, '6': 2 }
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.countBy(['one', 'two', 'three'], 'length');
	     * // => { '3': 2, '5': 1 }
	     */
	    var countBy = createAggregator(function(result, value, key) {
	      if (hasOwnProperty.call(result, key)) {
	        ++result[key];
	      } else {
	        baseAssignValue(result, key, 1);
	      }
	    });
	
	    /**
	     * Checks if `predicate` returns truthy for **all** elements of `collection`.
	     * Iteration is stopped once `predicate` returns falsey. The predicate is
	     * invoked with three arguments: (value, index|key, collection).
	     *
	     * **Note:** This method returns `true` for
	     * [empty collections](https://en.wikipedia.org/wiki/Empty_set) because
	     * [everything is true](https://en.wikipedia.org/wiki/Vacuous_truth) of
	     * elements of empty collections.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {boolean} Returns `true` if all elements pass the predicate check,
	     *  else `false`.
	     * @example
	     *
	     * _.every([true, 1, null, 'yes'], Boolean);
	     * // => false
	     *
	     * var users = [
	     *   { 'user': 'barney', 'age': 36, 'active': false },
	     *   { 'user': 'fred',   'age': 40, 'active': false }
	     * ];
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.every(users, { 'user': 'barney', 'active': false });
	     * // => false
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.every(users, ['active', false]);
	     * // => true
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.every(users, 'active');
	     * // => false
	     */
	    function every(collection, predicate, guard) {
	      var func = isArray(collection) ? arrayEvery : baseEvery;
	      if (guard && isIterateeCall(collection, predicate, guard)) {
	        predicate = undefined;
	      }
	      return func(collection, getIteratee(predicate, 3));
	    }
	
	    /**
	     * Iterates over elements of `collection`, returning an array of all elements
	     * `predicate` returns truthy for. The predicate is invoked with three
	     * arguments: (value, index|key, collection).
	     *
	     * **Note:** Unlike `_.remove`, this method returns a new array.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the new filtered array.
	     * @see _.reject
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney', 'age': 36, 'active': true },
	     *   { 'user': 'fred',   'age': 40, 'active': false }
	     * ];
	     *
	     * _.filter(users, function(o) { return !o.active; });
	     * // => objects for ['fred']
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.filter(users, { 'age': 36, 'active': true });
	     * // => objects for ['barney']
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.filter(users, ['active', false]);
	     * // => objects for ['fred']
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.filter(users, 'active');
	     * // => objects for ['barney']
	     */
	    function filter(collection, predicate) {
	      var func = isArray(collection) ? arrayFilter : baseFilter;
	      return func(collection, getIteratee(predicate, 3));
	    }
	
	    /**
	     * Iterates over elements of `collection`, returning the first element
	     * `predicate` returns truthy for. The predicate is invoked with three
	     * arguments: (value, index|key, collection).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to inspect.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @param {number} [fromIndex=0] The index to search from.
	     * @returns {*} Returns the matched element, else `undefined`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'age': 36, 'active': true },
	     *   { 'user': 'fred',    'age': 40, 'active': false },
	     *   { 'user': 'pebbles', 'age': 1,  'active': true }
	     * ];
	     *
	     * _.find(users, function(o) { return o.age < 40; });
	     * // => object for 'barney'
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.find(users, { 'age': 1, 'active': true });
	     * // => object for 'pebbles'
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.find(users, ['active', false]);
	     * // => object for 'fred'
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.find(users, 'active');
	     * // => object for 'barney'
	     */
	    var find = createFind(findIndex);
	
	    /**
	     * This method is like `_.find` except that it iterates over elements of
	     * `collection` from right to left.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to inspect.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @param {number} [fromIndex=collection.length-1] The index to search from.
	     * @returns {*} Returns the matched element, else `undefined`.
	     * @example
	     *
	     * _.findLast([1, 2, 3, 4], function(n) {
	     *   return n % 2 == 1;
	     * });
	     * // => 3
	     */
	    var findLast = createFind(findLastIndex);
	
	    /**
	     * Creates a flattened array of values by running each element in `collection`
	     * thru `iteratee` and flattening the mapped results. The iteratee is invoked
	     * with three arguments: (value, index|key, collection).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the new flattened array.
	     * @example
	     *
	     * function duplicate(n) {
	     *   return [n, n];
	     * }
	     *
	     * _.flatMap([1, 2], duplicate);
	     * // => [1, 1, 2, 2]
	     */
	    function flatMap(collection, iteratee) {
	      return baseFlatten(map(collection, iteratee), 1);
	    }
	
	    /**
	     * This method is like `_.flatMap` except that it recursively flattens the
	     * mapped results.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.7.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the new flattened array.
	     * @example
	     *
	     * function duplicate(n) {
	     *   return [[[n, n]]];
	     * }
	     *
	     * _.flatMapDeep([1, 2], duplicate);
	     * // => [1, 1, 2, 2]
	     */
	    function flatMapDeep(collection, iteratee) {
	      return baseFlatten(map(collection, iteratee), INFINITY);
	    }
	
	    /**
	     * This method is like `_.flatMap` except that it recursively flattens the
	     * mapped results up to `depth` times.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.7.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @param {number} [depth=1] The maximum recursion depth.
	     * @returns {Array} Returns the new flattened array.
	     * @example
	     *
	     * function duplicate(n) {
	     *   return [[[n, n]]];
	     * }
	     *
	     * _.flatMapDepth([1, 2], duplicate, 2);
	     * // => [[1, 1], [2, 2]]
	     */
	    function flatMapDepth(collection, iteratee, depth) {
	      depth = depth === undefined ? 1 : toInteger(depth);
	      return baseFlatten(map(collection, iteratee), depth);
	    }
	
	    /**
	     * Iterates over elements of `collection` and invokes `iteratee` for each element.
	     * The iteratee is invoked with three arguments: (value, index|key, collection).
	     * Iteratee functions may exit iteration early by explicitly returning `false`.
	     *
	     * **Note:** As with other "Collections" methods, objects with a "length"
	     * property are iterated like arrays. To avoid this behavior use `_.forIn`
	     * or `_.forOwn` for object iteration.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @alias each
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Array|Object} Returns `collection`.
	     * @see _.forEachRight
	     * @example
	     *
	     * _.forEach([1, 2], function(value) {
	     *   console.log(value);
	     * });
	     * // => Logs `1` then `2`.
	     *
	     * _.forEach({ 'a': 1, 'b': 2 }, function(value, key) {
	     *   console.log(key);
	     * });
	     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
	     */
	    function forEach(collection, iteratee) {
	      var func = isArray(collection) ? arrayEach : baseEach;
	      return func(collection, getIteratee(iteratee, 3));
	    }
	
	    /**
	     * This method is like `_.forEach` except that it iterates over elements of
	     * `collection` from right to left.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @alias eachRight
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Array|Object} Returns `collection`.
	     * @see _.forEach
	     * @example
	     *
	     * _.forEachRight([1, 2], function(value) {
	     *   console.log(value);
	     * });
	     * // => Logs `2` then `1`.
	     */
	    function forEachRight(collection, iteratee) {
	      var func = isArray(collection) ? arrayEachRight : baseEachRight;
	      return func(collection, getIteratee(iteratee, 3));
	    }
	
	    /**
	     * Creates an object composed of keys generated from the results of running
	     * each element of `collection` thru `iteratee`. The order of grouped values
	     * is determined by the order they occur in `collection`. The corresponding
	     * value of each key is an array of elements responsible for generating the
	     * key. The iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
	     * @returns {Object} Returns the composed aggregate object.
	     * @example
	     *
	     * _.groupBy([6.1, 4.2, 6.3], Math.floor);
	     * // => { '4': [4.2], '6': [6.1, 6.3] }
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.groupBy(['one', 'two', 'three'], 'length');
	     * // => { '3': ['one', 'two'], '5': ['three'] }
	     */
	    var groupBy = createAggregator(function(result, value, key) {
	      if (hasOwnProperty.call(result, key)) {
	        result[key].push(value);
	      } else {
	        baseAssignValue(result, key, [value]);
	      }
	    });
	
	    /**
	     * Checks if `value` is in `collection`. If `collection` is a string, it's
	     * checked for a substring of `value`, otherwise
	     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * is used for equality comparisons. If `fromIndex` is negative, it's used as
	     * the offset from the end of `collection`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to inspect.
	     * @param {*} value The value to search for.
	     * @param {number} [fromIndex=0] The index to search from.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
	     * @returns {boolean} Returns `true` if `value` is found, else `false`.
	     * @example
	     *
	     * _.includes([1, 2, 3], 1);
	     * // => true
	     *
	     * _.includes([1, 2, 3], 1, 2);
	     * // => false
	     *
	     * _.includes({ 'a': 1, 'b': 2 }, 1);
	     * // => true
	     *
	     * _.includes('abcd', 'bc');
	     * // => true
	     */
	    function includes(collection, value, fromIndex, guard) {
	      collection = isArrayLike(collection) ? collection : values(collection);
	      fromIndex = (fromIndex && !guard) ? toInteger(fromIndex) : 0;
	
	      var length = collection.length;
	      if (fromIndex < 0) {
	        fromIndex = nativeMax(length + fromIndex, 0);
	      }
	      return isString(collection)
	        ? (fromIndex <= length && collection.indexOf(value, fromIndex) > -1)
	        : (!!length && baseIndexOf(collection, value, fromIndex) > -1);
	    }
	
	    /**
	     * Invokes the method at `path` of each element in `collection`, returning
	     * an array of the results of each invoked method. Any additional arguments
	     * are provided to each invoked method. If `path` is a function, it's invoked
	     * for, and `this` bound to, each element in `collection`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Array|Function|string} path The path of the method to invoke or
	     *  the function invoked per iteration.
	     * @param {...*} [args] The arguments to invoke each method with.
	     * @returns {Array} Returns the array of results.
	     * @example
	     *
	     * _.invokeMap([[5, 1, 7], [3, 2, 1]], 'sort');
	     * // => [[1, 5, 7], [1, 2, 3]]
	     *
	     * _.invokeMap([123, 456], String.prototype.split, '');
	     * // => [['1', '2', '3'], ['4', '5', '6']]
	     */
	    var invokeMap = baseRest(function(collection, path, args) {
	      var index = -1,
	          isFunc = typeof path == 'function',
	          result = isArrayLike(collection) ? Array(collection.length) : [];
	
	      baseEach(collection, function(value) {
	        result[++index] = isFunc ? apply(path, value, args) : baseInvoke(value, path, args);
	      });
	      return result;
	    });
	
	    /**
	     * Creates an object composed of keys generated from the results of running
	     * each element of `collection` thru `iteratee`. The corresponding value of
	     * each key is the last element responsible for generating the key. The
	     * iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
	     * @returns {Object} Returns the composed aggregate object.
	     * @example
	     *
	     * var array = [
	     *   { 'dir': 'left', 'code': 97 },
	     *   { 'dir': 'right', 'code': 100 }
	     * ];
	     *
	     * _.keyBy(array, function(o) {
	     *   return String.fromCharCode(o.code);
	     * });
	     * // => { 'a': { 'dir': 'left', 'code': 97 }, 'd': { 'dir': 'right', 'code': 100 } }
	     *
	     * _.keyBy(array, 'dir');
	     * // => { 'left': { 'dir': 'left', 'code': 97 }, 'right': { 'dir': 'right', 'code': 100 } }
	     */
	    var keyBy = createAggregator(function(result, value, key) {
	      baseAssignValue(result, key, value);
	    });
	
	    /**
	     * Creates an array of values by running each element in `collection` thru
	     * `iteratee`. The iteratee is invoked with three arguments:
	     * (value, index|key, collection).
	     *
	     * Many lodash methods are guarded to work as iteratees for methods like
	     * `_.every`, `_.filter`, `_.map`, `_.mapValues`, `_.reject`, and `_.some`.
	     *
	     * The guarded methods are:
	     * `ary`, `chunk`, `curry`, `curryRight`, `drop`, `dropRight`, `every`,
	     * `fill`, `invert`, `parseInt`, `random`, `range`, `rangeRight`, `repeat`,
	     * `sampleSize`, `slice`, `some`, `sortBy`, `split`, `take`, `takeRight`,
	     * `template`, `trim`, `trimEnd`, `trimStart`, and `words`
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the new mapped array.
	     * @example
	     *
	     * function square(n) {
	     *   return n * n;
	     * }
	     *
	     * _.map([4, 8], square);
	     * // => [16, 64]
	     *
	     * _.map({ 'a': 4, 'b': 8 }, square);
	     * // => [16, 64] (iteration order is not guaranteed)
	     *
	     * var users = [
	     *   { 'user': 'barney' },
	     *   { 'user': 'fred' }
	     * ];
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.map(users, 'user');
	     * // => ['barney', 'fred']
	     */
	    function map(collection, iteratee) {
	      var func = isArray(collection) ? arrayMap : baseMap;
	      return func(collection, getIteratee(iteratee, 3));
	    }
	
	    /**
	     * This method is like `_.sortBy` except that it allows specifying the sort
	     * orders of the iteratees to sort by. If `orders` is unspecified, all values
	     * are sorted in ascending order. Otherwise, specify an order of "desc" for
	     * descending or "asc" for ascending sort order of corresponding values.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Array[]|Function[]|Object[]|string[]} [iteratees=[_.identity]]
	     *  The iteratees to sort by.
	     * @param {string[]} [orders] The sort orders of `iteratees`.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
	     * @returns {Array} Returns the new sorted array.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'fred',   'age': 48 },
	     *   { 'user': 'barney', 'age': 34 },
	     *   { 'user': 'fred',   'age': 40 },
	     *   { 'user': 'barney', 'age': 36 }
	     * ];
	     *
	     * // Sort by `user` in ascending order and by `age` in descending order.
	     * _.orderBy(users, ['user', 'age'], ['asc', 'desc']);
	     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 40]]
	     */
	    function orderBy(collection, iteratees, orders, guard) {
	      if (collection == null) {
	        return [];
	      }
	      if (!isArray(iteratees)) {
	        iteratees = iteratees == null ? [] : [iteratees];
	      }
	      orders = guard ? undefined : orders;
	      if (!isArray(orders)) {
	        orders = orders == null ? [] : [orders];
	      }
	      return baseOrderBy(collection, iteratees, orders);
	    }
	
	    /**
	     * Creates an array of elements split into two groups, the first of which
	     * contains elements `predicate` returns truthy for, the second of which
	     * contains elements `predicate` returns falsey for. The predicate is
	     * invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the array of grouped elements.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'age': 36, 'active': false },
	     *   { 'user': 'fred',    'age': 40, 'active': true },
	     *   { 'user': 'pebbles', 'age': 1,  'active': false }
	     * ];
	     *
	     * _.partition(users, function(o) { return o.active; });
	     * // => objects for [['fred'], ['barney', 'pebbles']]
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.partition(users, { 'age': 1, 'active': false });
	     * // => objects for [['pebbles'], ['barney', 'fred']]
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.partition(users, ['active', false]);
	     * // => objects for [['barney', 'pebbles'], ['fred']]
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.partition(users, 'active');
	     * // => objects for [['fred'], ['barney', 'pebbles']]
	     */
	    var partition = createAggregator(function(result, value, key) {
	      result[key ? 0 : 1].push(value);
	    }, function() { return [[], []]; });
	
	    /**
	     * Reduces `collection` to a value which is the accumulated result of running
	     * each element in `collection` thru `iteratee`, where each successive
	     * invocation is supplied the return value of the previous. If `accumulator`
	     * is not given, the first element of `collection` is used as the initial
	     * value. The iteratee is invoked with four arguments:
	     * (accumulator, value, index|key, collection).
	     *
	     * Many lodash methods are guarded to work as iteratees for methods like
	     * `_.reduce`, `_.reduceRight`, and `_.transform`.
	     *
	     * The guarded methods are:
	     * `assign`, `defaults`, `defaultsDeep`, `includes`, `merge`, `orderBy`,
	     * and `sortBy`
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @param {*} [accumulator] The initial value.
	     * @returns {*} Returns the accumulated value.
	     * @see _.reduceRight
	     * @example
	     *
	     * _.reduce([1, 2], function(sum, n) {
	     *   return sum + n;
	     * }, 0);
	     * // => 3
	     *
	     * _.reduce({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
	     *   (result[value] || (result[value] = [])).push(key);
	     *   return result;
	     * }, {});
	     * // => { '1': ['a', 'c'], '2': ['b'] } (iteration order is not guaranteed)
	     */
	    function reduce(collection, iteratee, accumulator) {
	      var func = isArray(collection) ? arrayReduce : baseReduce,
	          initAccum = arguments.length < 3;
	
	      return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEach);
	    }
	
	    /**
	     * This method is like `_.reduce` except that it iterates over elements of
	     * `collection` from right to left.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @param {*} [accumulator] The initial value.
	     * @returns {*} Returns the accumulated value.
	     * @see _.reduce
	     * @example
	     *
	     * var array = [[0, 1], [2, 3], [4, 5]];
	     *
	     * _.reduceRight(array, function(flattened, other) {
	     *   return flattened.concat(other);
	     * }, []);
	     * // => [4, 5, 2, 3, 0, 1]
	     */
	    function reduceRight(collection, iteratee, accumulator) {
	      var func = isArray(collection) ? arrayReduceRight : baseReduce,
	          initAccum = arguments.length < 3;
	
	      return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEachRight);
	    }
	
	    /**
	     * The opposite of `_.filter`; this method returns the elements of `collection`
	     * that `predicate` does **not** return truthy for.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the new filtered array.
	     * @see _.filter
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney', 'age': 36, 'active': false },
	     *   { 'user': 'fred',   'age': 40, 'active': true }
	     * ];
	     *
	     * _.reject(users, function(o) { return !o.active; });
	     * // => objects for ['fred']
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.reject(users, { 'age': 40, 'active': true });
	     * // => objects for ['barney']
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.reject(users, ['active', false]);
	     * // => objects for ['fred']
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.reject(users, 'active');
	     * // => objects for ['barney']
	     */
	    function reject(collection, predicate) {
	      var func = isArray(collection) ? arrayFilter : baseFilter;
	      return func(collection, negate(getIteratee(predicate, 3)));
	    }
	
	    /**
	     * Gets a random element from `collection`.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to sample.
	     * @returns {*} Returns the random element.
	     * @example
	     *
	     * _.sample([1, 2, 3, 4]);
	     * // => 2
	     */
	    function sample(collection) {
	      var func = isArray(collection) ? arraySample : baseSample;
	      return func(collection);
	    }
	
	    /**
	     * Gets `n` random elements at unique keys from `collection` up to the
	     * size of `collection`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to sample.
	     * @param {number} [n=1] The number of elements to sample.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Array} Returns the random elements.
	     * @example
	     *
	     * _.sampleSize([1, 2, 3], 2);
	     * // => [3, 1]
	     *
	     * _.sampleSize([1, 2, 3], 4);
	     * // => [2, 3, 1]
	     */
	    function sampleSize(collection, n, guard) {
	      if ((guard ? isIterateeCall(collection, n, guard) : n === undefined)) {
	        n = 1;
	      } else {
	        n = toInteger(n);
	      }
	      var func = isArray(collection) ? arraySampleSize : baseSampleSize;
	      return func(collection, n);
	    }
	
	    /**
	     * Creates an array of shuffled values, using a version of the
	     * [Fisher-Yates shuffle](https://en.wikipedia.org/wiki/Fisher-Yates_shuffle).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to shuffle.
	     * @returns {Array} Returns the new shuffled array.
	     * @example
	     *
	     * _.shuffle([1, 2, 3, 4]);
	     * // => [4, 1, 3, 2]
	     */
	    function shuffle(collection) {
	      var func = isArray(collection) ? arrayShuffle : baseShuffle;
	      return func(collection);
	    }
	
	    /**
	     * Gets the size of `collection` by returning its length for array-like
	     * values or the number of own enumerable string keyed properties for objects.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to inspect.
	     * @returns {number} Returns the collection size.
	     * @example
	     *
	     * _.size([1, 2, 3]);
	     * // => 3
	     *
	     * _.size({ 'a': 1, 'b': 2 });
	     * // => 2
	     *
	     * _.size('pebbles');
	     * // => 7
	     */
	    function size(collection) {
	      if (collection == null) {
	        return 0;
	      }
	      if (isArrayLike(collection)) {
	        return isString(collection) ? stringSize(collection) : collection.length;
	      }
	      var tag = getTag(collection);
	      if (tag == mapTag || tag == setTag) {
	        return collection.size;
	      }
	      return baseKeys(collection).length;
	    }
	
	    /**
	     * Checks if `predicate` returns truthy for **any** element of `collection`.
	     * Iteration is stopped once `predicate` returns truthy. The predicate is
	     * invoked with three arguments: (value, index|key, collection).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {boolean} Returns `true` if any element passes the predicate check,
	     *  else `false`.
	     * @example
	     *
	     * _.some([null, 0, 'yes', false], Boolean);
	     * // => true
	     *
	     * var users = [
	     *   { 'user': 'barney', 'active': true },
	     *   { 'user': 'fred',   'active': false }
	     * ];
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.some(users, { 'user': 'barney', 'active': false });
	     * // => false
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.some(users, ['active', false]);
	     * // => true
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.some(users, 'active');
	     * // => true
	     */
	    function some(collection, predicate, guard) {
	      var func = isArray(collection) ? arraySome : baseSome;
	      if (guard && isIterateeCall(collection, predicate, guard)) {
	        predicate = undefined;
	      }
	      return func(collection, getIteratee(predicate, 3));
	    }
	
	    /**
	     * Creates an array of elements, sorted in ascending order by the results of
	     * running each element in a collection thru each iteratee. This method
	     * performs a stable sort, that is, it preserves the original sort order of
	     * equal elements. The iteratees are invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {...(Function|Function[])} [iteratees=[_.identity]]
	     *  The iteratees to sort by.
	     * @returns {Array} Returns the new sorted array.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'fred',   'age': 48 },
	     *   { 'user': 'barney', 'age': 36 },
	     *   { 'user': 'fred',   'age': 40 },
	     *   { 'user': 'barney', 'age': 34 }
	     * ];
	     *
	     * _.sortBy(users, [function(o) { return o.user; }]);
	     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 40]]
	     *
	     * _.sortBy(users, ['user', 'age']);
	     * // => objects for [['barney', 34], ['barney', 36], ['fred', 40], ['fred', 48]]
	     */
	    var sortBy = baseRest(function(collection, iteratees) {
	      if (collection == null) {
	        return [];
	      }
	      var length = iteratees.length;
	      if (length > 1 && isIterateeCall(collection, iteratees[0], iteratees[1])) {
	        iteratees = [];
	      } else if (length > 2 && isIterateeCall(iteratees[0], iteratees[1], iteratees[2])) {
	        iteratees = [iteratees[0]];
	      }
	      return baseOrderBy(collection, baseFlatten(iteratees, 1), []);
	    });
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Gets the timestamp of the number of milliseconds that have elapsed since
	     * the Unix epoch (1 January 1970 00:00:00 UTC).
	     *
	     * @static
	     * @memberOf _
	     * @since 2.4.0
	     * @category Date
	     * @returns {number} Returns the timestamp.
	     * @example
	     *
	     * _.defer(function(stamp) {
	     *   console.log(_.now() - stamp);
	     * }, _.now());
	     * // => Logs the number of milliseconds it took for the deferred invocation.
	     */
	    var now = ctxNow || function() {
	      return root.Date.now();
	    };
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * The opposite of `_.before`; this method creates a function that invokes
	     * `func` once it's called `n` or more times.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {number} n The number of calls before `func` is invoked.
	     * @param {Function} func The function to restrict.
	     * @returns {Function} Returns the new restricted function.
	     * @example
	     *
	     * var saves = ['profile', 'settings'];
	     *
	     * var done = _.after(saves.length, function() {
	     *   console.log('done saving!');
	     * });
	     *
	     * _.forEach(saves, function(type) {
	     *   asyncSave({ 'type': type, 'complete': done });
	     * });
	     * // => Logs 'done saving!' after the two async saves have completed.
	     */
	    function after(n, func) {
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      n = toInteger(n);
	      return function() {
	        if (--n < 1) {
	          return func.apply(this, arguments);
	        }
	      };
	    }
	
	    /**
	     * Creates a function that invokes `func`, with up to `n` arguments,
	     * ignoring any additional arguments.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Function
	     * @param {Function} func The function to cap arguments for.
	     * @param {number} [n=func.length] The arity cap.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Function} Returns the new capped function.
	     * @example
	     *
	     * _.map(['6', '8', '10'], _.ary(parseInt, 1));
	     * // => [6, 8, 10]
	     */
	    function ary(func, n, guard) {
	      n = guard ? undefined : n;
	      n = (func && n == null) ? func.length : n;
	      return createWrap(func, WRAP_ARY_FLAG, undefined, undefined, undefined, undefined, n);
	    }
	
	    /**
	     * Creates a function that invokes `func`, with the `this` binding and arguments
	     * of the created function, while it's called less than `n` times. Subsequent
	     * calls to the created function return the result of the last `func` invocation.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Function
	     * @param {number} n The number of calls at which `func` is no longer invoked.
	     * @param {Function} func The function to restrict.
	     * @returns {Function} Returns the new restricted function.
	     * @example
	     *
	     * jQuery(element).on('click', _.before(5, addContactToList));
	     * // => Allows adding up to 4 contacts to the list.
	     */
	    function before(n, func) {
	      var result;
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      n = toInteger(n);
	      return function() {
	        if (--n > 0) {
	          result = func.apply(this, arguments);
	        }
	        if (n <= 1) {
	          func = undefined;
	        }
	        return result;
	      };
	    }
	
	    /**
	     * Creates a function that invokes `func` with the `this` binding of `thisArg`
	     * and `partials` prepended to the arguments it receives.
	     *
	     * The `_.bind.placeholder` value, which defaults to `_` in monolithic builds,
	     * may be used as a placeholder for partially applied arguments.
	     *
	     * **Note:** Unlike native `Function#bind`, this method doesn't set the "length"
	     * property of bound functions.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {Function} func The function to bind.
	     * @param {*} thisArg The `this` binding of `func`.
	     * @param {...*} [partials] The arguments to be partially applied.
	     * @returns {Function} Returns the new bound function.
	     * @example
	     *
	     * function greet(greeting, punctuation) {
	     *   return greeting + ' ' + this.user + punctuation;
	     * }
	     *
	     * var object = { 'user': 'fred' };
	     *
	     * var bound = _.bind(greet, object, 'hi');
	     * bound('!');
	     * // => 'hi fred!'
	     *
	     * // Bound with placeholders.
	     * var bound = _.bind(greet, object, _, '!');
	     * bound('hi');
	     * // => 'hi fred!'
	     */
	    var bind = baseRest(function(func, thisArg, partials) {
	      var bitmask = WRAP_BIND_FLAG;
	      if (partials.length) {
	        var holders = replaceHolders(partials, getHolder(bind));
	        bitmask |= WRAP_PARTIAL_FLAG;
	      }
	      return createWrap(func, bitmask, thisArg, partials, holders);
	    });
	
	    /**
	     * Creates a function that invokes the method at `object[key]` with `partials`
	     * prepended to the arguments it receives.
	     *
	     * This method differs from `_.bind` by allowing bound functions to reference
	     * methods that may be redefined or don't yet exist. See
	     * [Peter Michaux's article](http://peter.michaux.ca/articles/lazy-function-definition-pattern)
	     * for more details.
	     *
	     * The `_.bindKey.placeholder` value, which defaults to `_` in monolithic
	     * builds, may be used as a placeholder for partially applied arguments.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.10.0
	     * @category Function
	     * @param {Object} object The object to invoke the method on.
	     * @param {string} key The key of the method.
	     * @param {...*} [partials] The arguments to be partially applied.
	     * @returns {Function} Returns the new bound function.
	     * @example
	     *
	     * var object = {
	     *   'user': 'fred',
	     *   'greet': function(greeting, punctuation) {
	     *     return greeting + ' ' + this.user + punctuation;
	     *   }
	     * };
	     *
	     * var bound = _.bindKey(object, 'greet', 'hi');
	     * bound('!');
	     * // => 'hi fred!'
	     *
	     * object.greet = function(greeting, punctuation) {
	     *   return greeting + 'ya ' + this.user + punctuation;
	     * };
	     *
	     * bound('!');
	     * // => 'hiya fred!'
	     *
	     * // Bound with placeholders.
	     * var bound = _.bindKey(object, 'greet', _, '!');
	     * bound('hi');
	     * // => 'hiya fred!'
	     */
	    var bindKey = baseRest(function(object, key, partials) {
	      var bitmask = WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG;
	      if (partials.length) {
	        var holders = replaceHolders(partials, getHolder(bindKey));
	        bitmask |= WRAP_PARTIAL_FLAG;
	      }
	      return createWrap(key, bitmask, object, partials, holders);
	    });
	
	    /**
	     * Creates a function that accepts arguments of `func` and either invokes
	     * `func` returning its result, if at least `arity` number of arguments have
	     * been provided, or returns a function that accepts the remaining `func`
	     * arguments, and so on. The arity of `func` may be specified if `func.length`
	     * is not sufficient.
	     *
	     * The `_.curry.placeholder` value, which defaults to `_` in monolithic builds,
	     * may be used as a placeholder for provided arguments.
	     *
	     * **Note:** This method doesn't set the "length" property of curried functions.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Function
	     * @param {Function} func The function to curry.
	     * @param {number} [arity=func.length] The arity of `func`.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Function} Returns the new curried function.
	     * @example
	     *
	     * var abc = function(a, b, c) {
	     *   return [a, b, c];
	     * };
	     *
	     * var curried = _.curry(abc);
	     *
	     * curried(1)(2)(3);
	     * // => [1, 2, 3]
	     *
	     * curried(1, 2)(3);
	     * // => [1, 2, 3]
	     *
	     * curried(1, 2, 3);
	     * // => [1, 2, 3]
	     *
	     * // Curried with placeholders.
	     * curried(1)(_, 3)(2);
	     * // => [1, 2, 3]
	     */
	    function curry(func, arity, guard) {
	      arity = guard ? undefined : arity;
	      var result = createWrap(func, WRAP_CURRY_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
	      result.placeholder = curry.placeholder;
	      return result;
	    }
	
	    /**
	     * This method is like `_.curry` except that arguments are applied to `func`
	     * in the manner of `_.partialRight` instead of `_.partial`.
	     *
	     * The `_.curryRight.placeholder` value, which defaults to `_` in monolithic
	     * builds, may be used as a placeholder for provided arguments.
	     *
	     * **Note:** This method doesn't set the "length" property of curried functions.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Function
	     * @param {Function} func The function to curry.
	     * @param {number} [arity=func.length] The arity of `func`.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Function} Returns the new curried function.
	     * @example
	     *
	     * var abc = function(a, b, c) {
	     *   return [a, b, c];
	     * };
	     *
	     * var curried = _.curryRight(abc);
	     *
	     * curried(3)(2)(1);
	     * // => [1, 2, 3]
	     *
	     * curried(2, 3)(1);
	     * // => [1, 2, 3]
	     *
	     * curried(1, 2, 3);
	     * // => [1, 2, 3]
	     *
	     * // Curried with placeholders.
	     * curried(3)(1, _)(2);
	     * // => [1, 2, 3]
	     */
	    function curryRight(func, arity, guard) {
	      arity = guard ? undefined : arity;
	      var result = createWrap(func, WRAP_CURRY_RIGHT_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
	      result.placeholder = curryRight.placeholder;
	      return result;
	    }
	
	    /**
	     * Creates a debounced function that delays invoking `func` until after `wait`
	     * milliseconds have elapsed since the last time the debounced function was
	     * invoked. The debounced function comes with a `cancel` method to cancel
	     * delayed `func` invocations and a `flush` method to immediately invoke them.
	     * Provide `options` to indicate whether `func` should be invoked on the
	     * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
	     * with the last arguments provided to the debounced function. Subsequent
	     * calls to the debounced function return the result of the last `func`
	     * invocation.
	     *
	     * **Note:** If `leading` and `trailing` options are `true`, `func` is
	     * invoked on the trailing edge of the timeout only if the debounced function
	     * is invoked more than once during the `wait` timeout.
	     *
	     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
	     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
	     *
	     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
	     * for details over the differences between `_.debounce` and `_.throttle`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {Function} func The function to debounce.
	     * @param {number} [wait=0] The number of milliseconds to delay.
	     * @param {Object} [options={}] The options object.
	     * @param {boolean} [options.leading=false]
	     *  Specify invoking on the leading edge of the timeout.
	     * @param {number} [options.maxWait]
	     *  The maximum time `func` is allowed to be delayed before it's invoked.
	     * @param {boolean} [options.trailing=true]
	     *  Specify invoking on the trailing edge of the timeout.
	     * @returns {Function} Returns the new debounced function.
	     * @example
	     *
	     * // Avoid costly calculations while the window size is in flux.
	     * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
	     *
	     * // Invoke `sendMail` when clicked, debouncing subsequent calls.
	     * jQuery(element).on('click', _.debounce(sendMail, 300, {
	     *   'leading': true,
	     *   'trailing': false
	     * }));
	     *
	     * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
	     * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
	     * var source = new EventSource('/stream');
	     * jQuery(source).on('message', debounced);
	     *
	     * // Cancel the trailing debounced invocation.
	     * jQuery(window).on('popstate', debounced.cancel);
	     */
	    function debounce(func, wait, options) {
	      var lastArgs,
	          lastThis,
	          maxWait,
	          result,
	          timerId,
	          lastCallTime,
	          lastInvokeTime = 0,
	          leading = false,
	          maxing = false,
	          trailing = true;
	
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      wait = toNumber(wait) || 0;
	      if (isObject(options)) {
	        leading = !!options.leading;
	        maxing = 'maxWait' in options;
	        maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
	        trailing = 'trailing' in options ? !!options.trailing : trailing;
	      }
	
	      function invokeFunc(time) {
	        var args = lastArgs,
	            thisArg = lastThis;
	
	        lastArgs = lastThis = undefined;
	        lastInvokeTime = time;
	        result = func.apply(thisArg, args);
	        return result;
	      }
	
	      function leadingEdge(time) {
	        // Reset any `maxWait` timer.
	        lastInvokeTime = time;
	        // Start the timer for the trailing edge.
	        timerId = setTimeout(timerExpired, wait);
	        // Invoke the leading edge.
	        return leading ? invokeFunc(time) : result;
	      }
	
	      function remainingWait(time) {
	        var timeSinceLastCall = time - lastCallTime,
	            timeSinceLastInvoke = time - lastInvokeTime,
	            timeWaiting = wait - timeSinceLastCall;
	
	        return maxing
	          ? nativeMin(timeWaiting, maxWait - timeSinceLastInvoke)
	          : timeWaiting;
	      }
	
	      function shouldInvoke(time) {
	        var timeSinceLastCall = time - lastCallTime,
	            timeSinceLastInvoke = time - lastInvokeTime;
	
	        // Either this is the first call, activity has stopped and we're at the
	        // trailing edge, the system time has gone backwards and we're treating
	        // it as the trailing edge, or we've hit the `maxWait` limit.
	        return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
	          (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
	      }
	
	      function timerExpired() {
	        var time = now();
	        if (shouldInvoke(time)) {
	          return trailingEdge(time);
	        }
	        // Restart the timer.
	        timerId = setTimeout(timerExpired, remainingWait(time));
	      }
	
	      function trailingEdge(time) {
	        timerId = undefined;
	
	        // Only invoke if we have `lastArgs` which means `func` has been
	        // debounced at least once.
	        if (trailing && lastArgs) {
	          return invokeFunc(time);
	        }
	        lastArgs = lastThis = undefined;
	        return result;
	      }
	
	      function cancel() {
	        if (timerId !== undefined) {
	          clearTimeout(timerId);
	        }
	        lastInvokeTime = 0;
	        lastArgs = lastCallTime = lastThis = timerId = undefined;
	      }
	
	      function flush() {
	        return timerId === undefined ? result : trailingEdge(now());
	      }
	
	      function debounced() {
	        var time = now(),
	            isInvoking = shouldInvoke(time);
	
	        lastArgs = arguments;
	        lastThis = this;
	        lastCallTime = time;
	
	        if (isInvoking) {
	          if (timerId === undefined) {
	            return leadingEdge(lastCallTime);
	          }
	          if (maxing) {
	            // Handle invocations in a tight loop.
	            clearTimeout(timerId);
	            timerId = setTimeout(timerExpired, wait);
	            return invokeFunc(lastCallTime);
	          }
	        }
	        if (timerId === undefined) {
	          timerId = setTimeout(timerExpired, wait);
	        }
	        return result;
	      }
	      debounced.cancel = cancel;
	      debounced.flush = flush;
	      return debounced;
	    }
	
	    /**
	     * Defers invoking the `func` until the current call stack has cleared. Any
	     * additional arguments are provided to `func` when it's invoked.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {Function} func The function to defer.
	     * @param {...*} [args] The arguments to invoke `func` with.
	     * @returns {number} Returns the timer id.
	     * @example
	     *
	     * _.defer(function(text) {
	     *   console.log(text);
	     * }, 'deferred');
	     * // => Logs 'deferred' after one millisecond.
	     */
	    var defer = baseRest(function(func, args) {
	      return baseDelay(func, 1, args);
	    });
	
	    /**
	     * Invokes `func` after `wait` milliseconds. Any additional arguments are
	     * provided to `func` when it's invoked.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {Function} func The function to delay.
	     * @param {number} wait The number of milliseconds to delay invocation.
	     * @param {...*} [args] The arguments to invoke `func` with.
	     * @returns {number} Returns the timer id.
	     * @example
	     *
	     * _.delay(function(text) {
	     *   console.log(text);
	     * }, 1000, 'later');
	     * // => Logs 'later' after one second.
	     */
	    var delay = baseRest(function(func, wait, args) {
	      return baseDelay(func, toNumber(wait) || 0, args);
	    });
	
	    /**
	     * Creates a function that invokes `func` with arguments reversed.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Function
	     * @param {Function} func The function to flip arguments for.
	     * @returns {Function} Returns the new flipped function.
	     * @example
	     *
	     * var flipped = _.flip(function() {
	     *   return _.toArray(arguments);
	     * });
	     *
	     * flipped('a', 'b', 'c', 'd');
	     * // => ['d', 'c', 'b', 'a']
	     */
	    function flip(func) {
	      return createWrap(func, WRAP_FLIP_FLAG);
	    }
	
	    /**
	     * Creates a function that memoizes the result of `func`. If `resolver` is
	     * provided, it determines the cache key for storing the result based on the
	     * arguments provided to the memoized function. By default, the first argument
	     * provided to the memoized function is used as the map cache key. The `func`
	     * is invoked with the `this` binding of the memoized function.
	     *
	     * **Note:** The cache is exposed as the `cache` property on the memoized
	     * function. Its creation may be customized by replacing the `_.memoize.Cache`
	     * constructor with one whose instances implement the
	     * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
	     * method interface of `clear`, `delete`, `get`, `has`, and `set`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {Function} func The function to have its output memoized.
	     * @param {Function} [resolver] The function to resolve the cache key.
	     * @returns {Function} Returns the new memoized function.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': 2 };
	     * var other = { 'c': 3, 'd': 4 };
	     *
	     * var values = _.memoize(_.values);
	     * values(object);
	     * // => [1, 2]
	     *
	     * values(other);
	     * // => [3, 4]
	     *
	     * object.a = 2;
	     * values(object);
	     * // => [1, 2]
	     *
	     * // Modify the result cache.
	     * values.cache.set(object, ['a', 'b']);
	     * values(object);
	     * // => ['a', 'b']
	     *
	     * // Replace `_.memoize.Cache`.
	     * _.memoize.Cache = WeakMap;
	     */
	    function memoize(func, resolver) {
	      if (typeof func != 'function' || (resolver != null && typeof resolver != 'function')) {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      var memoized = function() {
	        var args = arguments,
	            key = resolver ? resolver.apply(this, args) : args[0],
	            cache = memoized.cache;
	
	        if (cache.has(key)) {
	          return cache.get(key);
	        }
	        var result = func.apply(this, args);
	        memoized.cache = cache.set(key, result) || cache;
	        return result;
	      };
	      memoized.cache = new (memoize.Cache || MapCache);
	      return memoized;
	    }
	
	    // Expose `MapCache`.
	    memoize.Cache = MapCache;
	
	    /**
	     * Creates a function that negates the result of the predicate `func`. The
	     * `func` predicate is invoked with the `this` binding and arguments of the
	     * created function.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Function
	     * @param {Function} predicate The predicate to negate.
	     * @returns {Function} Returns the new negated function.
	     * @example
	     *
	     * function isEven(n) {
	     *   return n % 2 == 0;
	     * }
	     *
	     * _.filter([1, 2, 3, 4, 5, 6], _.negate(isEven));
	     * // => [1, 3, 5]
	     */
	    function negate(predicate) {
	      if (typeof predicate != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      return function() {
	        var args = arguments;
	        switch (args.length) {
	          case 0: return !predicate.call(this);
	          case 1: return !predicate.call(this, args[0]);
	          case 2: return !predicate.call(this, args[0], args[1]);
	          case 3: return !predicate.call(this, args[0], args[1], args[2]);
	        }
	        return !predicate.apply(this, args);
	      };
	    }
	
	    /**
	     * Creates a function that is restricted to invoking `func` once. Repeat calls
	     * to the function return the value of the first invocation. The `func` is
	     * invoked with the `this` binding and arguments of the created function.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {Function} func The function to restrict.
	     * @returns {Function} Returns the new restricted function.
	     * @example
	     *
	     * var initialize = _.once(createApplication);
	     * initialize();
	     * initialize();
	     * // => `createApplication` is invoked once
	     */
	    function once(func) {
	      return before(2, func);
	    }
	
	    /**
	     * Creates a function that invokes `func` with its arguments transformed.
	     *
	     * @static
	     * @since 4.0.0
	     * @memberOf _
	     * @category Function
	     * @param {Function} func The function to wrap.
	     * @param {...(Function|Function[])} [transforms=[_.identity]]
	     *  The argument transforms.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * function doubled(n) {
	     *   return n * 2;
	     * }
	     *
	     * function square(n) {
	     *   return n * n;
	     * }
	     *
	     * var func = _.overArgs(function(x, y) {
	     *   return [x, y];
	     * }, [square, doubled]);
	     *
	     * func(9, 3);
	     * // => [81, 6]
	     *
	     * func(10, 5);
	     * // => [100, 10]
	     */
	    var overArgs = castRest(function(func, transforms) {
	      transforms = (transforms.length == 1 && isArray(transforms[0]))
	        ? arrayMap(transforms[0], baseUnary(getIteratee()))
	        : arrayMap(baseFlatten(transforms, 1), baseUnary(getIteratee()));
	
	      var funcsLength = transforms.length;
	      return baseRest(function(args) {
	        var index = -1,
	            length = nativeMin(args.length, funcsLength);
	
	        while (++index < length) {
	          args[index] = transforms[index].call(this, args[index]);
	        }
	        return apply(func, this, args);
	      });
	    });
	
	    /**
	     * Creates a function that invokes `func` with `partials` prepended to the
	     * arguments it receives. This method is like `_.bind` except it does **not**
	     * alter the `this` binding.
	     *
	     * The `_.partial.placeholder` value, which defaults to `_` in monolithic
	     * builds, may be used as a placeholder for partially applied arguments.
	     *
	     * **Note:** This method doesn't set the "length" property of partially
	     * applied functions.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.2.0
	     * @category Function
	     * @param {Function} func The function to partially apply arguments to.
	     * @param {...*} [partials] The arguments to be partially applied.
	     * @returns {Function} Returns the new partially applied function.
	     * @example
	     *
	     * function greet(greeting, name) {
	     *   return greeting + ' ' + name;
	     * }
	     *
	     * var sayHelloTo = _.partial(greet, 'hello');
	     * sayHelloTo('fred');
	     * // => 'hello fred'
	     *
	     * // Partially applied with placeholders.
	     * var greetFred = _.partial(greet, _, 'fred');
	     * greetFred('hi');
	     * // => 'hi fred'
	     */
	    var partial = baseRest(function(func, partials) {
	      var holders = replaceHolders(partials, getHolder(partial));
	      return createWrap(func, WRAP_PARTIAL_FLAG, undefined, partials, holders);
	    });
	
	    /**
	     * This method is like `_.partial` except that partially applied arguments
	     * are appended to the arguments it receives.
	     *
	     * The `_.partialRight.placeholder` value, which defaults to `_` in monolithic
	     * builds, may be used as a placeholder for partially applied arguments.
	     *
	     * **Note:** This method doesn't set the "length" property of partially
	     * applied functions.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.0.0
	     * @category Function
	     * @param {Function} func The function to partially apply arguments to.
	     * @param {...*} [partials] The arguments to be partially applied.
	     * @returns {Function} Returns the new partially applied function.
	     * @example
	     *
	     * function greet(greeting, name) {
	     *   return greeting + ' ' + name;
	     * }
	     *
	     * var greetFred = _.partialRight(greet, 'fred');
	     * greetFred('hi');
	     * // => 'hi fred'
	     *
	     * // Partially applied with placeholders.
	     * var sayHelloTo = _.partialRight(greet, 'hello', _);
	     * sayHelloTo('fred');
	     * // => 'hello fred'
	     */
	    var partialRight = baseRest(function(func, partials) {
	      var holders = replaceHolders(partials, getHolder(partialRight));
	      return createWrap(func, WRAP_PARTIAL_RIGHT_FLAG, undefined, partials, holders);
	    });
	
	    /**
	     * Creates a function that invokes `func` with arguments arranged according
	     * to the specified `indexes` where the argument value at the first index is
	     * provided as the first argument, the argument value at the second index is
	     * provided as the second argument, and so on.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Function
	     * @param {Function} func The function to rearrange arguments for.
	     * @param {...(number|number[])} indexes The arranged argument indexes.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var rearged = _.rearg(function(a, b, c) {
	     *   return [a, b, c];
	     * }, [2, 0, 1]);
	     *
	     * rearged('b', 'c', 'a')
	     * // => ['a', 'b', 'c']
	     */
	    var rearg = flatRest(function(func, indexes) {
	      return createWrap(func, WRAP_REARG_FLAG, undefined, undefined, undefined, indexes);
	    });
	
	    /**
	     * Creates a function that invokes `func` with the `this` binding of the
	     * created function and arguments from `start` and beyond provided as
	     * an array.
	     *
	     * **Note:** This method is based on the
	     * [rest parameter](https://mdn.io/rest_parameters).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Function
	     * @param {Function} func The function to apply a rest parameter to.
	     * @param {number} [start=func.length-1] The start position of the rest parameter.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var say = _.rest(function(what, names) {
	     *   return what + ' ' + _.initial(names).join(', ') +
	     *     (_.size(names) > 1 ? ', & ' : '') + _.last(names);
	     * });
	     *
	     * say('hello', 'fred', 'barney', 'pebbles');
	     * // => 'hello fred, barney, & pebbles'
	     */
	    function rest(func, start) {
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      start = start === undefined ? start : toInteger(start);
	      return baseRest(func, start);
	    }
	
	    /**
	     * Creates a function that invokes `func` with the `this` binding of the
	     * create function and an array of arguments much like
	     * [`Function#apply`](http://www.ecma-international.org/ecma-262/7.0/#sec-function.prototype.apply).
	     *
	     * **Note:** This method is based on the
	     * [spread operator](https://mdn.io/spread_operator).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.2.0
	     * @category Function
	     * @param {Function} func The function to spread arguments over.
	     * @param {number} [start=0] The start position of the spread.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var say = _.spread(function(who, what) {
	     *   return who + ' says ' + what;
	     * });
	     *
	     * say(['fred', 'hello']);
	     * // => 'fred says hello'
	     *
	     * var numbers = Promise.all([
	     *   Promise.resolve(40),
	     *   Promise.resolve(36)
	     * ]);
	     *
	     * numbers.then(_.spread(function(x, y) {
	     *   return x + y;
	     * }));
	     * // => a Promise of 76
	     */
	    function spread(func, start) {
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      start = start == null ? 0 : nativeMax(toInteger(start), 0);
	      return baseRest(function(args) {
	        var array = args[start],
	            otherArgs = castSlice(args, 0, start);
	
	        if (array) {
	          arrayPush(otherArgs, array);
	        }
	        return apply(func, this, otherArgs);
	      });
	    }
	
	    /**
	     * Creates a throttled function that only invokes `func` at most once per
	     * every `wait` milliseconds. The throttled function comes with a `cancel`
	     * method to cancel delayed `func` invocations and a `flush` method to
	     * immediately invoke them. Provide `options` to indicate whether `func`
	     * should be invoked on the leading and/or trailing edge of the `wait`
	     * timeout. The `func` is invoked with the last arguments provided to the
	     * throttled function. Subsequent calls to the throttled function return the
	     * result of the last `func` invocation.
	     *
	     * **Note:** If `leading` and `trailing` options are `true`, `func` is
	     * invoked on the trailing edge of the timeout only if the throttled function
	     * is invoked more than once during the `wait` timeout.
	     *
	     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
	     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
	     *
	     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
	     * for details over the differences between `_.throttle` and `_.debounce`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {Function} func The function to throttle.
	     * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
	     * @param {Object} [options={}] The options object.
	     * @param {boolean} [options.leading=true]
	     *  Specify invoking on the leading edge of the timeout.
	     * @param {boolean} [options.trailing=true]
	     *  Specify invoking on the trailing edge of the timeout.
	     * @returns {Function} Returns the new throttled function.
	     * @example
	     *
	     * // Avoid excessively updating the position while scrolling.
	     * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
	     *
	     * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
	     * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
	     * jQuery(element).on('click', throttled);
	     *
	     * // Cancel the trailing throttled invocation.
	     * jQuery(window).on('popstate', throttled.cancel);
	     */
	    function throttle(func, wait, options) {
	      var leading = true,
	          trailing = true;
	
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      if (isObject(options)) {
	        leading = 'leading' in options ? !!options.leading : leading;
	        trailing = 'trailing' in options ? !!options.trailing : trailing;
	      }
	      return debounce(func, wait, {
	        'leading': leading,
	        'maxWait': wait,
	        'trailing': trailing
	      });
	    }
	
	    /**
	     * Creates a function that accepts up to one argument, ignoring any
	     * additional arguments.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Function
	     * @param {Function} func The function to cap arguments for.
	     * @returns {Function} Returns the new capped function.
	     * @example
	     *
	     * _.map(['6', '8', '10'], _.unary(parseInt));
	     * // => [6, 8, 10]
	     */
	    function unary(func) {
	      return ary(func, 1);
	    }
	
	    /**
	     * Creates a function that provides `value` to `wrapper` as its first
	     * argument. Any additional arguments provided to the function are appended
	     * to those provided to the `wrapper`. The wrapper is invoked with the `this`
	     * binding of the created function.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {*} value The value to wrap.
	     * @param {Function} [wrapper=identity] The wrapper function.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var p = _.wrap(_.escape, function(func, text) {
	     *   return '<p>' + func(text) + '</p>';
	     * });
	     *
	     * p('fred, barney, & pebbles');
	     * // => '<p>fred, barney, &amp; pebbles</p>'
	     */
	    function wrap(value, wrapper) {
	      return partial(castFunction(wrapper), value);
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Casts `value` as an array if it's not one.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.4.0
	     * @category Lang
	     * @param {*} value The value to inspect.
	     * @returns {Array} Returns the cast array.
	     * @example
	     *
	     * _.castArray(1);
	     * // => [1]
	     *
	     * _.castArray({ 'a': 1 });
	     * // => [{ 'a': 1 }]
	     *
	     * _.castArray('abc');
	     * // => ['abc']
	     *
	     * _.castArray(null);
	     * // => [null]
	     *
	     * _.castArray(undefined);
	     * // => [undefined]
	     *
	     * _.castArray();
	     * // => []
	     *
	     * var array = [1, 2, 3];
	     * console.log(_.castArray(array) === array);
	     * // => true
	     */
	    function castArray() {
	      if (!arguments.length) {
	        return [];
	      }
	      var value = arguments[0];
	      return isArray(value) ? value : [value];
	    }
	
	    /**
	     * Creates a shallow clone of `value`.
	     *
	     * **Note:** This method is loosely based on the
	     * [structured clone algorithm](https://mdn.io/Structured_clone_algorithm)
	     * and supports cloning arrays, array buffers, booleans, date objects, maps,
	     * numbers, `Object` objects, regexes, sets, strings, symbols, and typed
	     * arrays. The own enumerable properties of `arguments` objects are cloned
	     * as plain objects. An empty object is returned for uncloneable values such
	     * as error objects, functions, DOM nodes, and WeakMaps.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to clone.
	     * @returns {*} Returns the cloned value.
	     * @see _.cloneDeep
	     * @example
	     *
	     * var objects = [{ 'a': 1 }, { 'b': 2 }];
	     *
	     * var shallow = _.clone(objects);
	     * console.log(shallow[0] === objects[0]);
	     * // => true
	     */
	    function clone(value) {
	      return baseClone(value, CLONE_SYMBOLS_FLAG);
	    }
	
	    /**
	     * This method is like `_.clone` except that it accepts `customizer` which
	     * is invoked to produce the cloned value. If `customizer` returns `undefined`,
	     * cloning is handled by the method instead. The `customizer` is invoked with
	     * up to four arguments; (value [, index|key, object, stack]).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to clone.
	     * @param {Function} [customizer] The function to customize cloning.
	     * @returns {*} Returns the cloned value.
	     * @see _.cloneDeepWith
	     * @example
	     *
	     * function customizer(value) {
	     *   if (_.isElement(value)) {
	     *     return value.cloneNode(false);
	     *   }
	     * }
	     *
	     * var el = _.cloneWith(document.body, customizer);
	     *
	     * console.log(el === document.body);
	     * // => false
	     * console.log(el.nodeName);
	     * // => 'BODY'
	     * console.log(el.childNodes.length);
	     * // => 0
	     */
	    function cloneWith(value, customizer) {
	      customizer = typeof customizer == 'function' ? customizer : undefined;
	      return baseClone(value, CLONE_SYMBOLS_FLAG, customizer);
	    }
	
	    /**
	     * This method is like `_.clone` except that it recursively clones `value`.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.0.0
	     * @category Lang
	     * @param {*} value The value to recursively clone.
	     * @returns {*} Returns the deep cloned value.
	     * @see _.clone
	     * @example
	     *
	     * var objects = [{ 'a': 1 }, { 'b': 2 }];
	     *
	     * var deep = _.cloneDeep(objects);
	     * console.log(deep[0] === objects[0]);
	     * // => false
	     */
	    function cloneDeep(value) {
	      return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG);
	    }
	
	    /**
	     * This method is like `_.cloneWith` except that it recursively clones `value`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to recursively clone.
	     * @param {Function} [customizer] The function to customize cloning.
	     * @returns {*} Returns the deep cloned value.
	     * @see _.cloneWith
	     * @example
	     *
	     * function customizer(value) {
	     *   if (_.isElement(value)) {
	     *     return value.cloneNode(true);
	     *   }
	     * }
	     *
	     * var el = _.cloneDeepWith(document.body, customizer);
	     *
	     * console.log(el === document.body);
	     * // => false
	     * console.log(el.nodeName);
	     * // => 'BODY'
	     * console.log(el.childNodes.length);
	     * // => 20
	     */
	    function cloneDeepWith(value, customizer) {
	      customizer = typeof customizer == 'function' ? customizer : undefined;
	      return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG, customizer);
	    }
	
	    /**
	     * Checks if `object` conforms to `source` by invoking the predicate
	     * properties of `source` with the corresponding property values of `object`.
	     *
	     * **Note:** This method is equivalent to `_.conforms` when `source` is
	     * partially applied.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.14.0
	     * @category Lang
	     * @param {Object} object The object to inspect.
	     * @param {Object} source The object of property predicates to conform to.
	     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': 2 };
	     *
	     * _.conformsTo(object, { 'b': function(n) { return n > 1; } });
	     * // => true
	     *
	     * _.conformsTo(object, { 'b': function(n) { return n > 2; } });
	     * // => false
	     */
	    function conformsTo(object, source) {
	      return source == null || baseConformsTo(object, source, keys(source));
	    }
	
	    /**
	     * Performs a
	     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * comparison between two values to determine if they are equivalent.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	     * @example
	     *
	     * var object = { 'a': 1 };
	     * var other = { 'a': 1 };
	     *
	     * _.eq(object, object);
	     * // => true
	     *
	     * _.eq(object, other);
	     * // => false
	     *
	     * _.eq('a', 'a');
	     * // => true
	     *
	     * _.eq('a', Object('a'));
	     * // => false
	     *
	     * _.eq(NaN, NaN);
	     * // => true
	     */
	    function eq(value, other) {
	      return value === other || (value !== value && other !== other);
	    }
	
	    /**
	     * Checks if `value` is greater than `other`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.9.0
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if `value` is greater than `other`,
	     *  else `false`.
	     * @see _.lt
	     * @example
	     *
	     * _.gt(3, 1);
	     * // => true
	     *
	     * _.gt(3, 3);
	     * // => false
	     *
	     * _.gt(1, 3);
	     * // => false
	     */
	    var gt = createRelationalOperation(baseGt);
	
	    /**
	     * Checks if `value` is greater than or equal to `other`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.9.0
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if `value` is greater than or equal to
	     *  `other`, else `false`.
	     * @see _.lte
	     * @example
	     *
	     * _.gte(3, 1);
	     * // => true
	     *
	     * _.gte(3, 3);
	     * // => true
	     *
	     * _.gte(1, 3);
	     * // => false
	     */
	    var gte = createRelationalOperation(function(value, other) {
	      return value >= other;
	    });
	
	    /**
	     * Checks if `value` is likely an `arguments` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
	     *  else `false`.
	     * @example
	     *
	     * _.isArguments(function() { return arguments; }());
	     * // => true
	     *
	     * _.isArguments([1, 2, 3]);
	     * // => false
	     */
	    var isArguments = baseIsArguments(function() { return arguments; }()) ? baseIsArguments : function(value) {
	      return isObjectLike(value) && hasOwnProperty.call(value, 'callee') &&
	        !propertyIsEnumerable.call(value, 'callee');
	    };
	
	    /**
	     * Checks if `value` is classified as an `Array` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an array, else `false`.
	     * @example
	     *
	     * _.isArray([1, 2, 3]);
	     * // => true
	     *
	     * _.isArray(document.body.children);
	     * // => false
	     *
	     * _.isArray('abc');
	     * // => false
	     *
	     * _.isArray(_.noop);
	     * // => false
	     */
	    var isArray = Array.isArray;
	
	    /**
	     * Checks if `value` is classified as an `ArrayBuffer` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.3.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
	     * @example
	     *
	     * _.isArrayBuffer(new ArrayBuffer(2));
	     * // => true
	     *
	     * _.isArrayBuffer(new Array(2));
	     * // => false
	     */
	    var isArrayBuffer = nodeIsArrayBuffer ? baseUnary(nodeIsArrayBuffer) : baseIsArrayBuffer;
	
	    /**
	     * Checks if `value` is array-like. A value is considered array-like if it's
	     * not a function and has a `value.length` that's an integer greater than or
	     * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
	     * @example
	     *
	     * _.isArrayLike([1, 2, 3]);
	     * // => true
	     *
	     * _.isArrayLike(document.body.children);
	     * // => true
	     *
	     * _.isArrayLike('abc');
	     * // => true
	     *
	     * _.isArrayLike(_.noop);
	     * // => false
	     */
	    function isArrayLike(value) {
	      return value != null && isLength(value.length) && !isFunction(value);
	    }
	
	    /**
	     * This method is like `_.isArrayLike` except that it also checks if `value`
	     * is an object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an array-like object,
	     *  else `false`.
	     * @example
	     *
	     * _.isArrayLikeObject([1, 2, 3]);
	     * // => true
	     *
	     * _.isArrayLikeObject(document.body.children);
	     * // => true
	     *
	     * _.isArrayLikeObject('abc');
	     * // => false
	     *
	     * _.isArrayLikeObject(_.noop);
	     * // => false
	     */
	    function isArrayLikeObject(value) {
	      return isObjectLike(value) && isArrayLike(value);
	    }
	
	    /**
	     * Checks if `value` is classified as a boolean primitive or object.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a boolean, else `false`.
	     * @example
	     *
	     * _.isBoolean(false);
	     * // => true
	     *
	     * _.isBoolean(null);
	     * // => false
	     */
	    function isBoolean(value) {
	      return value === true || value === false ||
	        (isObjectLike(value) && baseGetTag(value) == boolTag);
	    }
	
	    /**
	     * Checks if `value` is a buffer.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.3.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
	     * @example
	     *
	     * _.isBuffer(new Buffer(2));
	     * // => true
	     *
	     * _.isBuffer(new Uint8Array(2));
	     * // => false
	     */
	    var isBuffer = nativeIsBuffer || stubFalse;
	
	    /**
	     * Checks if `value` is classified as a `Date` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
	     * @example
	     *
	     * _.isDate(new Date);
	     * // => true
	     *
	     * _.isDate('Mon April 23 2012');
	     * // => false
	     */
	    var isDate = nodeIsDate ? baseUnary(nodeIsDate) : baseIsDate;
	
	    /**
	     * Checks if `value` is likely a DOM element.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a DOM element, else `false`.
	     * @example
	     *
	     * _.isElement(document.body);
	     * // => true
	     *
	     * _.isElement('<body>');
	     * // => false
	     */
	    function isElement(value) {
	      return isObjectLike(value) && value.nodeType === 1 && !isPlainObject(value);
	    }
	
	    /**
	     * Checks if `value` is an empty object, collection, map, or set.
	     *
	     * Objects are considered empty if they have no own enumerable string keyed
	     * properties.
	     *
	     * Array-like values such as `arguments` objects, arrays, buffers, strings, or
	     * jQuery-like collections are considered empty if they have a `length` of `0`.
	     * Similarly, maps and sets are considered empty if they have a `size` of `0`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is empty, else `false`.
	     * @example
	     *
	     * _.isEmpty(null);
	     * // => true
	     *
	     * _.isEmpty(true);
	     * // => true
	     *
	     * _.isEmpty(1);
	     * // => true
	     *
	     * _.isEmpty([1, 2, 3]);
	     * // => false
	     *
	     * _.isEmpty({ 'a': 1 });
	     * // => false
	     */
	    function isEmpty(value) {
	      if (value == null) {
	        return true;
	      }
	      if (isArrayLike(value) &&
	          (isArray(value) || typeof value == 'string' || typeof value.splice == 'function' ||
	            isBuffer(value) || isTypedArray(value) || isArguments(value))) {
	        return !value.length;
	      }
	      var tag = getTag(value);
	      if (tag == mapTag || tag == setTag) {
	        return !value.size;
	      }
	      if (isPrototype(value)) {
	        return !baseKeys(value).length;
	      }
	      for (var key in value) {
	        if (hasOwnProperty.call(value, key)) {
	          return false;
	        }
	      }
	      return true;
	    }
	
	    /**
	     * Performs a deep comparison between two values to determine if they are
	     * equivalent.
	     *
	     * **Note:** This method supports comparing arrays, array buffers, booleans,
	     * date objects, error objects, maps, numbers, `Object` objects, regexes,
	     * sets, strings, symbols, and typed arrays. `Object` objects are compared
	     * by their own, not inherited, enumerable properties. Functions and DOM
	     * nodes are compared by strict equality, i.e. `===`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	     * @example
	     *
	     * var object = { 'a': 1 };
	     * var other = { 'a': 1 };
	     *
	     * _.isEqual(object, other);
	     * // => true
	     *
	     * object === other;
	     * // => false
	     */
	    function isEqual(value, other) {
	      return baseIsEqual(value, other);
	    }
	
	    /**
	     * This method is like `_.isEqual` except that it accepts `customizer` which
	     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
	     * are handled by the method instead. The `customizer` is invoked with up to
	     * six arguments: (objValue, othValue [, index|key, object, other, stack]).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @param {Function} [customizer] The function to customize comparisons.
	     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	     * @example
	     *
	     * function isGreeting(value) {
	     *   return /^h(?:i|ello)$/.test(value);
	     * }
	     *
	     * function customizer(objValue, othValue) {
	     *   if (isGreeting(objValue) && isGreeting(othValue)) {
	     *     return true;
	     *   }
	     * }
	     *
	     * var array = ['hello', 'goodbye'];
	     * var other = ['hi', 'goodbye'];
	     *
	     * _.isEqualWith(array, other, customizer);
	     * // => true
	     */
	    function isEqualWith(value, other, customizer) {
	      customizer = typeof customizer == 'function' ? customizer : undefined;
	      var result = customizer ? customizer(value, other) : undefined;
	      return result === undefined ? baseIsEqual(value, other, undefined, customizer) : !!result;
	    }
	
	    /**
	     * Checks if `value` is an `Error`, `EvalError`, `RangeError`, `ReferenceError`,
	     * `SyntaxError`, `TypeError`, or `URIError` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an error object, else `false`.
	     * @example
	     *
	     * _.isError(new Error);
	     * // => true
	     *
	     * _.isError(Error);
	     * // => false
	     */
	    function isError(value) {
	      if (!isObjectLike(value)) {
	        return false;
	      }
	      var tag = baseGetTag(value);
	      return tag == errorTag || tag == domExcTag ||
	        (typeof value.message == 'string' && typeof value.name == 'string' && !isPlainObject(value));
	    }
	
	    /**
	     * Checks if `value` is a finite primitive number.
	     *
	     * **Note:** This method is based on
	     * [`Number.isFinite`](https://mdn.io/Number/isFinite).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a finite number, else `false`.
	     * @example
	     *
	     * _.isFinite(3);
	     * // => true
	     *
	     * _.isFinite(Number.MIN_VALUE);
	     * // => true
	     *
	     * _.isFinite(Infinity);
	     * // => false
	     *
	     * _.isFinite('3');
	     * // => false
	     */
	    function isFinite(value) {
	      return typeof value == 'number' && nativeIsFinite(value);
	    }
	
	    /**
	     * Checks if `value` is classified as a `Function` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a function, else `false`.
	     * @example
	     *
	     * _.isFunction(_);
	     * // => true
	     *
	     * _.isFunction(/abc/);
	     * // => false
	     */
	    function isFunction(value) {
	      if (!isObject(value)) {
	        return false;
	      }
	      // The use of `Object#toString` avoids issues with the `typeof` operator
	      // in Safari 9 which returns 'object' for typed arrays and other constructors.
	      var tag = baseGetTag(value);
	      return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
	    }
	
	    /**
	     * Checks if `value` is an integer.
	     *
	     * **Note:** This method is based on
	     * [`Number.isInteger`](https://mdn.io/Number/isInteger).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an integer, else `false`.
	     * @example
	     *
	     * _.isInteger(3);
	     * // => true
	     *
	     * _.isInteger(Number.MIN_VALUE);
	     * // => false
	     *
	     * _.isInteger(Infinity);
	     * // => false
	     *
	     * _.isInteger('3');
	     * // => false
	     */
	    function isInteger(value) {
	      return typeof value == 'number' && value == toInteger(value);
	    }
	
	    /**
	     * Checks if `value` is a valid array-like length.
	     *
	     * **Note:** This method is loosely based on
	     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
	     * @example
	     *
	     * _.isLength(3);
	     * // => true
	     *
	     * _.isLength(Number.MIN_VALUE);
	     * // => false
	     *
	     * _.isLength(Infinity);
	     * // => false
	     *
	     * _.isLength('3');
	     * // => false
	     */
	    function isLength(value) {
	      return typeof value == 'number' &&
	        value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
	    }
	
	    /**
	     * Checks if `value` is the
	     * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
	     * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an object, else `false`.
	     * @example
	     *
	     * _.isObject({});
	     * // => true
	     *
	     * _.isObject([1, 2, 3]);
	     * // => true
	     *
	     * _.isObject(_.noop);
	     * // => true
	     *
	     * _.isObject(null);
	     * // => false
	     */
	    function isObject(value) {
	      var type = typeof value;
	      return value != null && (type == 'object' || type == 'function');
	    }
	
	    /**
	     * Checks if `value` is object-like. A value is object-like if it's not `null`
	     * and has a `typeof` result of "object".
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
	     * @example
	     *
	     * _.isObjectLike({});
	     * // => true
	     *
	     * _.isObjectLike([1, 2, 3]);
	     * // => true
	     *
	     * _.isObjectLike(_.noop);
	     * // => false
	     *
	     * _.isObjectLike(null);
	     * // => false
	     */
	    function isObjectLike(value) {
	      return value != null && typeof value == 'object';
	    }
	
	    /**
	     * Checks if `value` is classified as a `Map` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.3.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
	     * @example
	     *
	     * _.isMap(new Map);
	     * // => true
	     *
	     * _.isMap(new WeakMap);
	     * // => false
	     */
	    var isMap = nodeIsMap ? baseUnary(nodeIsMap) : baseIsMap;
	
	    /**
	     * Performs a partial deep comparison between `object` and `source` to
	     * determine if `object` contains equivalent property values.
	     *
	     * **Note:** This method is equivalent to `_.matches` when `source` is
	     * partially applied.
	     *
	     * Partial comparisons will match empty array and empty object `source`
	     * values against any array or object value, respectively. See `_.isEqual`
	     * for a list of supported value comparisons.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Lang
	     * @param {Object} object The object to inspect.
	     * @param {Object} source The object of property values to match.
	     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': 2 };
	     *
	     * _.isMatch(object, { 'b': 2 });
	     * // => true
	     *
	     * _.isMatch(object, { 'b': 1 });
	     * // => false
	     */
	    function isMatch(object, source) {
	      return object === source || baseIsMatch(object, source, getMatchData(source));
	    }
	
	    /**
	     * This method is like `_.isMatch` except that it accepts `customizer` which
	     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
	     * are handled by the method instead. The `customizer` is invoked with five
	     * arguments: (objValue, srcValue, index|key, object, source).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {Object} object The object to inspect.
	     * @param {Object} source The object of property values to match.
	     * @param {Function} [customizer] The function to customize comparisons.
	     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
	     * @example
	     *
	     * function isGreeting(value) {
	     *   return /^h(?:i|ello)$/.test(value);
	     * }
	     *
	     * function customizer(objValue, srcValue) {
	     *   if (isGreeting(objValue) && isGreeting(srcValue)) {
	     *     return true;
	     *   }
	     * }
	     *
	     * var object = { 'greeting': 'hello' };
	     * var source = { 'greeting': 'hi' };
	     *
	     * _.isMatchWith(object, source, customizer);
	     * // => true
	     */
	    function isMatchWith(object, source, customizer) {
	      customizer = typeof customizer == 'function' ? customizer : undefined;
	      return baseIsMatch(object, source, getMatchData(source), customizer);
	    }
	
	    /**
	     * Checks if `value` is `NaN`.
	     *
	     * **Note:** This method is based on
	     * [`Number.isNaN`](https://mdn.io/Number/isNaN) and is not the same as
	     * global [`isNaN`](https://mdn.io/isNaN) which returns `true` for
	     * `undefined` and other non-number values.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
	     * @example
	     *
	     * _.isNaN(NaN);
	     * // => true
	     *
	     * _.isNaN(new Number(NaN));
	     * // => true
	     *
	     * isNaN(undefined);
	     * // => true
	     *
	     * _.isNaN(undefined);
	     * // => false
	     */
	    function isNaN(value) {
	      // An `NaN` primitive is the only value that is not equal to itself.
	      // Perform the `toStringTag` check first to avoid errors with some
	      // ActiveX objects in IE.
	      return isNumber(value) && value != +value;
	    }
	
	    /**
	     * Checks if `value` is a pristine native function.
	     *
	     * **Note:** This method can't reliably detect native functions in the presence
	     * of the core-js package because core-js circumvents this kind of detection.
	     * Despite multiple requests, the core-js maintainer has made it clear: any
	     * attempt to fix the detection will be obstructed. As a result, we're left
	     * with little choice but to throw an error. Unfortunately, this also affects
	     * packages, like [babel-polyfill](https://www.npmjs.com/package/babel-polyfill),
	     * which rely on core-js.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a native function,
	     *  else `false`.
	     * @example
	     *
	     * _.isNative(Array.prototype.push);
	     * // => true
	     *
	     * _.isNative(_);
	     * // => false
	     */
	    function isNative(value) {
	      if (isMaskable(value)) {
	        throw new Error(CORE_ERROR_TEXT);
	      }
	      return baseIsNative(value);
	    }
	
	    /**
	     * Checks if `value` is `null`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is `null`, else `false`.
	     * @example
	     *
	     * _.isNull(null);
	     * // => true
	     *
	     * _.isNull(void 0);
	     * // => false
	     */
	    function isNull(value) {
	      return value === null;
	    }
	
	    /**
	     * Checks if `value` is `null` or `undefined`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is nullish, else `false`.
	     * @example
	     *
	     * _.isNil(null);
	     * // => true
	     *
	     * _.isNil(void 0);
	     * // => true
	     *
	     * _.isNil(NaN);
	     * // => false
	     */
	    function isNil(value) {
	      return value == null;
	    }
	
	    /**
	     * Checks if `value` is classified as a `Number` primitive or object.
	     *
	     * **Note:** To exclude `Infinity`, `-Infinity`, and `NaN`, which are
	     * classified as numbers, use the `_.isFinite` method.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a number, else `false`.
	     * @example
	     *
	     * _.isNumber(3);
	     * // => true
	     *
	     * _.isNumber(Number.MIN_VALUE);
	     * // => true
	     *
	     * _.isNumber(Infinity);
	     * // => true
	     *
	     * _.isNumber('3');
	     * // => false
	     */
	    function isNumber(value) {
	      return typeof value == 'number' ||
	        (isObjectLike(value) && baseGetTag(value) == numberTag);
	    }
	
	    /**
	     * Checks if `value` is a plain object, that is, an object created by the
	     * `Object` constructor or one with a `[[Prototype]]` of `null`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.8.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     * }
	     *
	     * _.isPlainObject(new Foo);
	     * // => false
	     *
	     * _.isPlainObject([1, 2, 3]);
	     * // => false
	     *
	     * _.isPlainObject({ 'x': 0, 'y': 0 });
	     * // => true
	     *
	     * _.isPlainObject(Object.create(null));
	     * // => true
	     */
	    function isPlainObject(value) {
	      if (!isObjectLike(value) || baseGetTag(value) != objectTag) {
	        return false;
	      }
	      var proto = getPrototype(value);
	      if (proto === null) {
	        return true;
	      }
	      var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
	      return typeof Ctor == 'function' && Ctor instanceof Ctor &&
	        funcToString.call(Ctor) == objectCtorString;
	    }
	
	    /**
	     * Checks if `value` is classified as a `RegExp` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
	     * @example
	     *
	     * _.isRegExp(/abc/);
	     * // => true
	     *
	     * _.isRegExp('/abc/');
	     * // => false
	     */
	    var isRegExp = nodeIsRegExp ? baseUnary(nodeIsRegExp) : baseIsRegExp;
	
	    /**
	     * Checks if `value` is a safe integer. An integer is safe if it's an IEEE-754
	     * double precision number which isn't the result of a rounded unsafe integer.
	     *
	     * **Note:** This method is based on
	     * [`Number.isSafeInteger`](https://mdn.io/Number/isSafeInteger).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a safe integer, else `false`.
	     * @example
	     *
	     * _.isSafeInteger(3);
	     * // => true
	     *
	     * _.isSafeInteger(Number.MIN_VALUE);
	     * // => false
	     *
	     * _.isSafeInteger(Infinity);
	     * // => false
	     *
	     * _.isSafeInteger('3');
	     * // => false
	     */
	    function isSafeInteger(value) {
	      return isInteger(value) && value >= -MAX_SAFE_INTEGER && value <= MAX_SAFE_INTEGER;
	    }
	
	    /**
	     * Checks if `value` is classified as a `Set` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.3.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
	     * @example
	     *
	     * _.isSet(new Set);
	     * // => true
	     *
	     * _.isSet(new WeakSet);
	     * // => false
	     */
	    var isSet = nodeIsSet ? baseUnary(nodeIsSet) : baseIsSet;
	
	    /**
	     * Checks if `value` is classified as a `String` primitive or object.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a string, else `false`.
	     * @example
	     *
	     * _.isString('abc');
	     * // => true
	     *
	     * _.isString(1);
	     * // => false
	     */
	    function isString(value) {
	      return typeof value == 'string' ||
	        (!isArray(value) && isObjectLike(value) && baseGetTag(value) == stringTag);
	    }
	
	    /**
	     * Checks if `value` is classified as a `Symbol` primitive or object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
	     * @example
	     *
	     * _.isSymbol(Symbol.iterator);
	     * // => true
	     *
	     * _.isSymbol('abc');
	     * // => false
	     */
	    function isSymbol(value) {
	      return typeof value == 'symbol' ||
	        (isObjectLike(value) && baseGetTag(value) == symbolTag);
	    }
	
	    /**
	     * Checks if `value` is classified as a typed array.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
	     * @example
	     *
	     * _.isTypedArray(new Uint8Array);
	     * // => true
	     *
	     * _.isTypedArray([]);
	     * // => false
	     */
	    var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;
	
	    /**
	     * Checks if `value` is `undefined`.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is `undefined`, else `false`.
	     * @example
	     *
	     * _.isUndefined(void 0);
	     * // => true
	     *
	     * _.isUndefined(null);
	     * // => false
	     */
	    function isUndefined(value) {
	      return value === undefined;
	    }
	
	    /**
	     * Checks if `value` is classified as a `WeakMap` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.3.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a weak map, else `false`.
	     * @example
	     *
	     * _.isWeakMap(new WeakMap);
	     * // => true
	     *
	     * _.isWeakMap(new Map);
	     * // => false
	     */
	    function isWeakMap(value) {
	      return isObjectLike(value) && getTag(value) == weakMapTag;
	    }
	
	    /**
	     * Checks if `value` is classified as a `WeakSet` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.3.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a weak set, else `false`.
	     * @example
	     *
	     * _.isWeakSet(new WeakSet);
	     * // => true
	     *
	     * _.isWeakSet(new Set);
	     * // => false
	     */
	    function isWeakSet(value) {
	      return isObjectLike(value) && baseGetTag(value) == weakSetTag;
	    }
	
	    /**
	     * Checks if `value` is less than `other`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.9.0
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if `value` is less than `other`,
	     *  else `false`.
	     * @see _.gt
	     * @example
	     *
	     * _.lt(1, 3);
	     * // => true
	     *
	     * _.lt(3, 3);
	     * // => false
	     *
	     * _.lt(3, 1);
	     * // => false
	     */
	    var lt = createRelationalOperation(baseLt);
	
	    /**
	     * Checks if `value` is less than or equal to `other`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.9.0
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if `value` is less than or equal to
	     *  `other`, else `false`.
	     * @see _.gte
	     * @example
	     *
	     * _.lte(1, 3);
	     * // => true
	     *
	     * _.lte(3, 3);
	     * // => true
	     *
	     * _.lte(3, 1);
	     * // => false
	     */
	    var lte = createRelationalOperation(function(value, other) {
	      return value <= other;
	    });
	
	    /**
	     * Converts `value` to an array.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to convert.
	     * @returns {Array} Returns the converted array.
	     * @example
	     *
	     * _.toArray({ 'a': 1, 'b': 2 });
	     * // => [1, 2]
	     *
	     * _.toArray('abc');
	     * // => ['a', 'b', 'c']
	     *
	     * _.toArray(1);
	     * // => []
	     *
	     * _.toArray(null);
	     * // => []
	     */
	    function toArray(value) {
	      if (!value) {
	        return [];
	      }
	      if (isArrayLike(value)) {
	        return isString(value) ? stringToArray(value) : copyArray(value);
	      }
	      if (symIterator && value[symIterator]) {
	        return iteratorToArray(value[symIterator]());
	      }
	      var tag = getTag(value),
	          func = tag == mapTag ? mapToArray : (tag == setTag ? setToArray : values);
	
	      return func(value);
	    }
	
	    /**
	     * Converts `value` to a finite number.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.12.0
	     * @category Lang
	     * @param {*} value The value to convert.
	     * @returns {number} Returns the converted number.
	     * @example
	     *
	     * _.toFinite(3.2);
	     * // => 3.2
	     *
	     * _.toFinite(Number.MIN_VALUE);
	     * // => 5e-324
	     *
	     * _.toFinite(Infinity);
	     * // => 1.7976931348623157e+308
	     *
	     * _.toFinite('3.2');
	     * // => 3.2
	     */
	    function toFinite(value) {
	      if (!value) {
	        return value === 0 ? value : 0;
	      }
	      value = toNumber(value);
	      if (value === INFINITY || value === -INFINITY) {
	        var sign = (value < 0 ? -1 : 1);
	        return sign * MAX_INTEGER;
	      }
	      return value === value ? value : 0;
	    }
	
	    /**
	     * Converts `value` to an integer.
	     *
	     * **Note:** This method is loosely based on
	     * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to convert.
	     * @returns {number} Returns the converted integer.
	     * @example
	     *
	     * _.toInteger(3.2);
	     * // => 3
	     *
	     * _.toInteger(Number.MIN_VALUE);
	     * // => 0
	     *
	     * _.toInteger(Infinity);
	     * // => 1.7976931348623157e+308
	     *
	     * _.toInteger('3.2');
	     * // => 3
	     */
	    function toInteger(value) {
	      var result = toFinite(value),
	          remainder = result % 1;
	
	      return result === result ? (remainder ? result - remainder : result) : 0;
	    }
	
	    /**
	     * Converts `value` to an integer suitable for use as the length of an
	     * array-like object.
	     *
	     * **Note:** This method is based on
	     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to convert.
	     * @returns {number} Returns the converted integer.
	     * @example
	     *
	     * _.toLength(3.2);
	     * // => 3
	     *
	     * _.toLength(Number.MIN_VALUE);
	     * // => 0
	     *
	     * _.toLength(Infinity);
	     * // => 4294967295
	     *
	     * _.toLength('3.2');
	     * // => 3
	     */
	    function toLength(value) {
	      return value ? baseClamp(toInteger(value), 0, MAX_ARRAY_LENGTH) : 0;
	    }
	
	    /**
	     * Converts `value` to a number.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to process.
	     * @returns {number} Returns the number.
	     * @example
	     *
	     * _.toNumber(3.2);
	     * // => 3.2
	     *
	     * _.toNumber(Number.MIN_VALUE);
	     * // => 5e-324
	     *
	     * _.toNumber(Infinity);
	     * // => Infinity
	     *
	     * _.toNumber('3.2');
	     * // => 3.2
	     */
	    function toNumber(value) {
	      if (typeof value == 'number') {
	        return value;
	      }
	      if (isSymbol(value)) {
	        return NAN;
	      }
	      if (isObject(value)) {
	        var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
	        value = isObject(other) ? (other + '') : other;
	      }
	      if (typeof value != 'string') {
	        return value === 0 ? value : +value;
	      }
	      value = value.replace(reTrim, '');
	      var isBinary = reIsBinary.test(value);
	      return (isBinary || reIsOctal.test(value))
	        ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
	        : (reIsBadHex.test(value) ? NAN : +value);
	    }
	
	    /**
	     * Converts `value` to a plain object flattening inherited enumerable string
	     * keyed properties of `value` to own properties of the plain object.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Lang
	     * @param {*} value The value to convert.
	     * @returns {Object} Returns the converted plain object.
	     * @example
	     *
	     * function Foo() {
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.assign({ 'a': 1 }, new Foo);
	     * // => { 'a': 1, 'b': 2 }
	     *
	     * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
	     * // => { 'a': 1, 'b': 2, 'c': 3 }
	     */
	    function toPlainObject(value) {
	      return copyObject(value, keysIn(value));
	    }
	
	    /**
	     * Converts `value` to a safe integer. A safe integer can be compared and
	     * represented correctly.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to convert.
	     * @returns {number} Returns the converted integer.
	     * @example
	     *
	     * _.toSafeInteger(3.2);
	     * // => 3
	     *
	     * _.toSafeInteger(Number.MIN_VALUE);
	     * // => 0
	     *
	     * _.toSafeInteger(Infinity);
	     * // => 9007199254740991
	     *
	     * _.toSafeInteger('3.2');
	     * // => 3
	     */
	    function toSafeInteger(value) {
	      return value
	        ? baseClamp(toInteger(value), -MAX_SAFE_INTEGER, MAX_SAFE_INTEGER)
	        : (value === 0 ? value : 0);
	    }
	
	    /**
	     * Converts `value` to a string. An empty string is returned for `null`
	     * and `undefined` values. The sign of `-0` is preserved.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to convert.
	     * @returns {string} Returns the converted string.
	     * @example
	     *
	     * _.toString(null);
	     * // => ''
	     *
	     * _.toString(-0);
	     * // => '-0'
	     *
	     * _.toString([1, 2, 3]);
	     * // => '1,2,3'
	     */
	    function toString(value) {
	      return value == null ? '' : baseToString(value);
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Assigns own enumerable string keyed properties of source objects to the
	     * destination object. Source objects are applied from left to right.
	     * Subsequent sources overwrite property assignments of previous sources.
	     *
	     * **Note:** This method mutates `object` and is loosely based on
	     * [`Object.assign`](https://mdn.io/Object/assign).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.10.0
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} [sources] The source objects.
	     * @returns {Object} Returns `object`.
	     * @see _.assignIn
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     * }
	     *
	     * function Bar() {
	     *   this.c = 3;
	     * }
	     *
	     * Foo.prototype.b = 2;
	     * Bar.prototype.d = 4;
	     *
	     * _.assign({ 'a': 0 }, new Foo, new Bar);
	     * // => { 'a': 1, 'c': 3 }
	     */
	    var assign = createAssigner(function(object, source) {
	      if (isPrototype(source) || isArrayLike(source)) {
	        copyObject(source, keys(source), object);
	        return;
	      }
	      for (var key in source) {
	        if (hasOwnProperty.call(source, key)) {
	          assignValue(object, key, source[key]);
	        }
	      }
	    });
	
	    /**
	     * This method is like `_.assign` except that it iterates over own and
	     * inherited source properties.
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @alias extend
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} [sources] The source objects.
	     * @returns {Object} Returns `object`.
	     * @see _.assign
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     * }
	     *
	     * function Bar() {
	     *   this.c = 3;
	     * }
	     *
	     * Foo.prototype.b = 2;
	     * Bar.prototype.d = 4;
	     *
	     * _.assignIn({ 'a': 0 }, new Foo, new Bar);
	     * // => { 'a': 1, 'b': 2, 'c': 3, 'd': 4 }
	     */
	    var assignIn = createAssigner(function(object, source) {
	      copyObject(source, keysIn(source), object);
	    });
	
	    /**
	     * This method is like `_.assignIn` except that it accepts `customizer`
	     * which is invoked to produce the assigned values. If `customizer` returns
	     * `undefined`, assignment is handled by the method instead. The `customizer`
	     * is invoked with five arguments: (objValue, srcValue, key, object, source).
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @alias extendWith
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} sources The source objects.
	     * @param {Function} [customizer] The function to customize assigned values.
	     * @returns {Object} Returns `object`.
	     * @see _.assignWith
	     * @example
	     *
	     * function customizer(objValue, srcValue) {
	     *   return _.isUndefined(objValue) ? srcValue : objValue;
	     * }
	     *
	     * var defaults = _.partialRight(_.assignInWith, customizer);
	     *
	     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
	     * // => { 'a': 1, 'b': 2 }
	     */
	    var assignInWith = createAssigner(function(object, source, srcIndex, customizer) {
	      copyObject(source, keysIn(source), object, customizer);
	    });
	
	    /**
	     * This method is like `_.assign` except that it accepts `customizer`
	     * which is invoked to produce the assigned values. If `customizer` returns
	     * `undefined`, assignment is handled by the method instead. The `customizer`
	     * is invoked with five arguments: (objValue, srcValue, key, object, source).
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} sources The source objects.
	     * @param {Function} [customizer] The function to customize assigned values.
	     * @returns {Object} Returns `object`.
	     * @see _.assignInWith
	     * @example
	     *
	     * function customizer(objValue, srcValue) {
	     *   return _.isUndefined(objValue) ? srcValue : objValue;
	     * }
	     *
	     * var defaults = _.partialRight(_.assignWith, customizer);
	     *
	     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
	     * // => { 'a': 1, 'b': 2 }
	     */
	    var assignWith = createAssigner(function(object, source, srcIndex, customizer) {
	      copyObject(source, keys(source), object, customizer);
	    });
	
	    /**
	     * Creates an array of values corresponding to `paths` of `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.0.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {...(string|string[])} [paths] The property paths to pick.
	     * @returns {Array} Returns the picked values.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
	     *
	     * _.at(object, ['a[0].b.c', 'a[1]']);
	     * // => [3, 4]
	     */
	    var at = flatRest(baseAt);
	
	    /**
	     * Creates an object that inherits from the `prototype` object. If a
	     * `properties` object is given, its own enumerable string keyed properties
	     * are assigned to the created object.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.3.0
	     * @category Object
	     * @param {Object} prototype The object to inherit from.
	     * @param {Object} [properties] The properties to assign to the object.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * function Shape() {
	     *   this.x = 0;
	     *   this.y = 0;
	     * }
	     *
	     * function Circle() {
	     *   Shape.call(this);
	     * }
	     *
	     * Circle.prototype = _.create(Shape.prototype, {
	     *   'constructor': Circle
	     * });
	     *
	     * var circle = new Circle;
	     * circle instanceof Circle;
	     * // => true
	     *
	     * circle instanceof Shape;
	     * // => true
	     */
	    function create(prototype, properties) {
	      var result = baseCreate(prototype);
	      return properties == null ? result : baseAssign(result, properties);
	    }
	
	    /**
	     * Assigns own and inherited enumerable string keyed properties of source
	     * objects to the destination object for all destination properties that
	     * resolve to `undefined`. Source objects are applied from left to right.
	     * Once a property is set, additional values of the same property are ignored.
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} [sources] The source objects.
	     * @returns {Object} Returns `object`.
	     * @see _.defaultsDeep
	     * @example
	     *
	     * _.defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
	     * // => { 'a': 1, 'b': 2 }
	     */
	    var defaults = baseRest(function(object, sources) {
	      object = Object(object);
	
	      var index = -1;
	      var length = sources.length;
	      var guard = length > 2 ? sources[2] : undefined;
	
	      if (guard && isIterateeCall(sources[0], sources[1], guard)) {
	        length = 1;
	      }
	
	      while (++index < length) {
	        var source = sources[index];
	        var props = keysIn(source);
	        var propsIndex = -1;
	        var propsLength = props.length;
	
	        while (++propsIndex < propsLength) {
	          var key = props[propsIndex];
	          var value = object[key];
	
	          if (value === undefined ||
	              (eq(value, objectProto[key]) && !hasOwnProperty.call(object, key))) {
	            object[key] = source[key];
	          }
	        }
	      }
	
	      return object;
	    });
	
	    /**
	     * This method is like `_.defaults` except that it recursively assigns
	     * default properties.
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.10.0
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} [sources] The source objects.
	     * @returns {Object} Returns `object`.
	     * @see _.defaults
	     * @example
	     *
	     * _.defaultsDeep({ 'a': { 'b': 2 } }, { 'a': { 'b': 1, 'c': 3 } });
	     * // => { 'a': { 'b': 2, 'c': 3 } }
	     */
	    var defaultsDeep = baseRest(function(args) {
	      args.push(undefined, customDefaultsMerge);
	      return apply(mergeWith, undefined, args);
	    });
	
	    /**
	     * This method is like `_.find` except that it returns the key of the first
	     * element `predicate` returns truthy for instead of the element itself.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.1.0
	     * @category Object
	     * @param {Object} object The object to inspect.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {string|undefined} Returns the key of the matched element,
	     *  else `undefined`.
	     * @example
	     *
	     * var users = {
	     *   'barney':  { 'age': 36, 'active': true },
	     *   'fred':    { 'age': 40, 'active': false },
	     *   'pebbles': { 'age': 1,  'active': true }
	     * };
	     *
	     * _.findKey(users, function(o) { return o.age < 40; });
	     * // => 'barney' (iteration order is not guaranteed)
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.findKey(users, { 'age': 1, 'active': true });
	     * // => 'pebbles'
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.findKey(users, ['active', false]);
	     * // => 'fred'
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.findKey(users, 'active');
	     * // => 'barney'
	     */
	    function findKey(object, predicate) {
	      return baseFindKey(object, getIteratee(predicate, 3), baseForOwn);
	    }
	
	    /**
	     * This method is like `_.findKey` except that it iterates over elements of
	     * a collection in the opposite order.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Object
	     * @param {Object} object The object to inspect.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {string|undefined} Returns the key of the matched element,
	     *  else `undefined`.
	     * @example
	     *
	     * var users = {
	     *   'barney':  { 'age': 36, 'active': true },
	     *   'fred':    { 'age': 40, 'active': false },
	     *   'pebbles': { 'age': 1,  'active': true }
	     * };
	     *
	     * _.findLastKey(users, function(o) { return o.age < 40; });
	     * // => returns 'pebbles' assuming `_.findKey` returns 'barney'
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.findLastKey(users, { 'age': 36, 'active': true });
	     * // => 'barney'
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.findLastKey(users, ['active', false]);
	     * // => 'fred'
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.findLastKey(users, 'active');
	     * // => 'pebbles'
	     */
	    function findLastKey(object, predicate) {
	      return baseFindKey(object, getIteratee(predicate, 3), baseForOwnRight);
	    }
	
	    /**
	     * Iterates over own and inherited enumerable string keyed properties of an
	     * object and invokes `iteratee` for each property. The iteratee is invoked
	     * with three arguments: (value, key, object). Iteratee functions may exit
	     * iteration early by explicitly returning `false`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.3.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Object} Returns `object`.
	     * @see _.forInRight
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.forIn(new Foo, function(value, key) {
	     *   console.log(key);
	     * });
	     * // => Logs 'a', 'b', then 'c' (iteration order is not guaranteed).
	     */
	    function forIn(object, iteratee) {
	      return object == null
	        ? object
	        : baseFor(object, getIteratee(iteratee, 3), keysIn);
	    }
	
	    /**
	     * This method is like `_.forIn` except that it iterates over properties of
	     * `object` in the opposite order.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Object} Returns `object`.
	     * @see _.forIn
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.forInRight(new Foo, function(value, key) {
	     *   console.log(key);
	     * });
	     * // => Logs 'c', 'b', then 'a' assuming `_.forIn` logs 'a', 'b', then 'c'.
	     */
	    function forInRight(object, iteratee) {
	      return object == null
	        ? object
	        : baseForRight(object, getIteratee(iteratee, 3), keysIn);
	    }
	
	    /**
	     * Iterates over own enumerable string keyed properties of an object and
	     * invokes `iteratee` for each property. The iteratee is invoked with three
	     * arguments: (value, key, object). Iteratee functions may exit iteration
	     * early by explicitly returning `false`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.3.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Object} Returns `object`.
	     * @see _.forOwnRight
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.forOwn(new Foo, function(value, key) {
	     *   console.log(key);
	     * });
	     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
	     */
	    function forOwn(object, iteratee) {
	      return object && baseForOwn(object, getIteratee(iteratee, 3));
	    }
	
	    /**
	     * This method is like `_.forOwn` except that it iterates over properties of
	     * `object` in the opposite order.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Object} Returns `object`.
	     * @see _.forOwn
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.forOwnRight(new Foo, function(value, key) {
	     *   console.log(key);
	     * });
	     * // => Logs 'b' then 'a' assuming `_.forOwn` logs 'a' then 'b'.
	     */
	    function forOwnRight(object, iteratee) {
	      return object && baseForOwnRight(object, getIteratee(iteratee, 3));
	    }
	
	    /**
	     * Creates an array of function property names from own enumerable properties
	     * of `object`.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to inspect.
	     * @returns {Array} Returns the function names.
	     * @see _.functionsIn
	     * @example
	     *
	     * function Foo() {
	     *   this.a = _.constant('a');
	     *   this.b = _.constant('b');
	     * }
	     *
	     * Foo.prototype.c = _.constant('c');
	     *
	     * _.functions(new Foo);
	     * // => ['a', 'b']
	     */
	    function functions(object) {
	      return object == null ? [] : baseFunctions(object, keys(object));
	    }
	
	    /**
	     * Creates an array of function property names from own and inherited
	     * enumerable properties of `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The object to inspect.
	     * @returns {Array} Returns the function names.
	     * @see _.functions
	     * @example
	     *
	     * function Foo() {
	     *   this.a = _.constant('a');
	     *   this.b = _.constant('b');
	     * }
	     *
	     * Foo.prototype.c = _.constant('c');
	     *
	     * _.functionsIn(new Foo);
	     * // => ['a', 'b', 'c']
	     */
	    function functionsIn(object) {
	      return object == null ? [] : baseFunctions(object, keysIn(object));
	    }
	
	    /**
	     * Gets the value at `path` of `object`. If the resolved value is
	     * `undefined`, the `defaultValue` is returned in its place.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.7.0
	     * @category Object
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path of the property to get.
	     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
	     * @returns {*} Returns the resolved value.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
	     *
	     * _.get(object, 'a[0].b.c');
	     * // => 3
	     *
	     * _.get(object, ['a', '0', 'b', 'c']);
	     * // => 3
	     *
	     * _.get(object, 'a.b.c', 'default');
	     * // => 'default'
	     */
	    function get(object, path, defaultValue) {
	      var result = object == null ? undefined : baseGet(object, path);
	      return result === undefined ? defaultValue : result;
	    }
	
	    /**
	     * Checks if `path` is a direct property of `object`.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path to check.
	     * @returns {boolean} Returns `true` if `path` exists, else `false`.
	     * @example
	     *
	     * var object = { 'a': { 'b': 2 } };
	     * var other = _.create({ 'a': _.create({ 'b': 2 }) });
	     *
	     * _.has(object, 'a');
	     * // => true
	     *
	     * _.has(object, 'a.b');
	     * // => true
	     *
	     * _.has(object, ['a', 'b']);
	     * // => true
	     *
	     * _.has(other, 'a');
	     * // => false
	     */
	    function has(object, path) {
	      return object != null && hasPath(object, path, baseHas);
	    }
	
	    /**
	     * Checks if `path` is a direct or inherited property of `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path to check.
	     * @returns {boolean} Returns `true` if `path` exists, else `false`.
	     * @example
	     *
	     * var object = _.create({ 'a': _.create({ 'b': 2 }) });
	     *
	     * _.hasIn(object, 'a');
	     * // => true
	     *
	     * _.hasIn(object, 'a.b');
	     * // => true
	     *
	     * _.hasIn(object, ['a', 'b']);
	     * // => true
	     *
	     * _.hasIn(object, 'b');
	     * // => false
	     */
	    function hasIn(object, path) {
	      return object != null && hasPath(object, path, baseHasIn);
	    }
	
	    /**
	     * Creates an object composed of the inverted keys and values of `object`.
	     * If `object` contains duplicate values, subsequent values overwrite
	     * property assignments of previous values.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.7.0
	     * @category Object
	     * @param {Object} object The object to invert.
	     * @returns {Object} Returns the new inverted object.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': 2, 'c': 1 };
	     *
	     * _.invert(object);
	     * // => { '1': 'c', '2': 'b' }
	     */
	    var invert = createInverter(function(result, value, key) {
	      if (value != null &&
	          typeof value.toString != 'function') {
	        value = nativeObjectToString.call(value);
	      }
	
	      result[value] = key;
	    }, constant(identity));
	
	    /**
	     * This method is like `_.invert` except that the inverted object is generated
	     * from the results of running each element of `object` thru `iteratee`. The
	     * corresponding inverted value of each inverted key is an array of keys
	     * responsible for generating the inverted value. The iteratee is invoked
	     * with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.1.0
	     * @category Object
	     * @param {Object} object The object to invert.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {Object} Returns the new inverted object.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': 2, 'c': 1 };
	     *
	     * _.invertBy(object);
	     * // => { '1': ['a', 'c'], '2': ['b'] }
	     *
	     * _.invertBy(object, function(value) {
	     *   return 'group' + value;
	     * });
	     * // => { 'group1': ['a', 'c'], 'group2': ['b'] }
	     */
	    var invertBy = createInverter(function(result, value, key) {
	      if (value != null &&
	          typeof value.toString != 'function') {
	        value = nativeObjectToString.call(value);
	      }
	
	      if (hasOwnProperty.call(result, value)) {
	        result[value].push(key);
	      } else {
	        result[value] = [key];
	      }
	    }, getIteratee);
	
	    /**
	     * Invokes the method at `path` of `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path of the method to invoke.
	     * @param {...*} [args] The arguments to invoke the method with.
	     * @returns {*} Returns the result of the invoked method.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c': [1, 2, 3, 4] } }] };
	     *
	     * _.invoke(object, 'a[0].b.c.slice', 1, 3);
	     * // => [2, 3]
	     */
	    var invoke = baseRest(baseInvoke);
	
	    /**
	     * Creates an array of the own enumerable property names of `object`.
	     *
	     * **Note:** Non-object values are coerced to objects. See the
	     * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
	     * for more details.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property names.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.keys(new Foo);
	     * // => ['a', 'b'] (iteration order is not guaranteed)
	     *
	     * _.keys('hi');
	     * // => ['0', '1']
	     */
	    function keys(object) {
	      return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
	    }
	
	    /**
	     * Creates an array of the own and inherited enumerable property names of `object`.
	     *
	     * **Note:** Non-object values are coerced to objects.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Object
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property names.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.keysIn(new Foo);
	     * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
	     */
	    function keysIn(object) {
	      return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
	    }
	
	    /**
	     * The opposite of `_.mapValues`; this method creates an object with the
	     * same values as `object` and keys generated by running each own enumerable
	     * string keyed property of `object` thru `iteratee`. The iteratee is invoked
	     * with three arguments: (value, key, object).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.8.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Object} Returns the new mapped object.
	     * @see _.mapValues
	     * @example
	     *
	     * _.mapKeys({ 'a': 1, 'b': 2 }, function(value, key) {
	     *   return key + value;
	     * });
	     * // => { 'a1': 1, 'b2': 2 }
	     */
	    function mapKeys(object, iteratee) {
	      var result = {};
	      iteratee = getIteratee(iteratee, 3);
	
	      baseForOwn(object, function(value, key, object) {
	        baseAssignValue(result, iteratee(value, key, object), value);
	      });
	      return result;
	    }
	
	    /**
	     * Creates an object with the same keys as `object` and values generated
	     * by running each own enumerable string keyed property of `object` thru
	     * `iteratee`. The iteratee is invoked with three arguments:
	     * (value, key, object).
	     *
	     * @static
	     * @memberOf _
	     * @since 2.4.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Object} Returns the new mapped object.
	     * @see _.mapKeys
	     * @example
	     *
	     * var users = {
	     *   'fred':    { 'user': 'fred',    'age': 40 },
	     *   'pebbles': { 'user': 'pebbles', 'age': 1 }
	     * };
	     *
	     * _.mapValues(users, function(o) { return o.age; });
	     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.mapValues(users, 'age');
	     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
	     */
	    function mapValues(object, iteratee) {
	      var result = {};
	      iteratee = getIteratee(iteratee, 3);
	
	      baseForOwn(object, function(value, key, object) {
	        baseAssignValue(result, key, iteratee(value, key, object));
	      });
	      return result;
	    }
	
	    /**
	     * This method is like `_.assign` except that it recursively merges own and
	     * inherited enumerable string keyed properties of source objects into the
	     * destination object. Source properties that resolve to `undefined` are
	     * skipped if a destination value exists. Array and plain object properties
	     * are merged recursively. Other objects and value types are overridden by
	     * assignment. Source objects are applied from left to right. Subsequent
	     * sources overwrite property assignments of previous sources.
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.5.0
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} [sources] The source objects.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * var object = {
	     *   'a': [{ 'b': 2 }, { 'd': 4 }]
	     * };
	     *
	     * var other = {
	     *   'a': [{ 'c': 3 }, { 'e': 5 }]
	     * };
	     *
	     * _.merge(object, other);
	     * // => { 'a': [{ 'b': 2, 'c': 3 }, { 'd': 4, 'e': 5 }] }
	     */
	    var merge = createAssigner(function(object, source, srcIndex) {
	      baseMerge(object, source, srcIndex);
	    });
	
	    /**
	     * This method is like `_.merge` except that it accepts `customizer` which
	     * is invoked to produce the merged values of the destination and source
	     * properties. If `customizer` returns `undefined`, merging is handled by the
	     * method instead. The `customizer` is invoked with six arguments:
	     * (objValue, srcValue, key, object, source, stack).
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} sources The source objects.
	     * @param {Function} customizer The function to customize assigned values.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * function customizer(objValue, srcValue) {
	     *   if (_.isArray(objValue)) {
	     *     return objValue.concat(srcValue);
	     *   }
	     * }
	     *
	     * var object = { 'a': [1], 'b': [2] };
	     * var other = { 'a': [3], 'b': [4] };
	     *
	     * _.mergeWith(object, other, customizer);
	     * // => { 'a': [1, 3], 'b': [2, 4] }
	     */
	    var mergeWith = createAssigner(function(object, source, srcIndex, customizer) {
	      baseMerge(object, source, srcIndex, customizer);
	    });
	
	    /**
	     * The opposite of `_.pick`; this method creates an object composed of the
	     * own and inherited enumerable property paths of `object` that are not omitted.
	     *
	     * **Note:** This method is considerably slower than `_.pick`.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The source object.
	     * @param {...(string|string[])} [paths] The property paths to omit.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': '2', 'c': 3 };
	     *
	     * _.omit(object, ['a', 'c']);
	     * // => { 'b': '2' }
	     */
	    var omit = flatRest(function(object, paths) {
	      var result = {};
	      if (object == null) {
	        return result;
	      }
	      var isDeep = false;
	      paths = arrayMap(paths, function(path) {
	        path = castPath(path, object);
	        isDeep || (isDeep = path.length > 1);
	        return path;
	      });
	      copyObject(object, getAllKeysIn(object), result);
	      if (isDeep) {
	        result = baseClone(result, CLONE_DEEP_FLAG | CLONE_FLAT_FLAG | CLONE_SYMBOLS_FLAG, customOmitClone);
	      }
	      var length = paths.length;
	      while (length--) {
	        baseUnset(result, paths[length]);
	      }
	      return result;
	    });
	
	    /**
	     * The opposite of `_.pickBy`; this method creates an object composed of
	     * the own and inherited enumerable string keyed properties of `object` that
	     * `predicate` doesn't return truthy for. The predicate is invoked with two
	     * arguments: (value, key).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The source object.
	     * @param {Function} [predicate=_.identity] The function invoked per property.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': '2', 'c': 3 };
	     *
	     * _.omitBy(object, _.isNumber);
	     * // => { 'b': '2' }
	     */
	    function omitBy(object, predicate) {
	      return pickBy(object, negate(getIteratee(predicate)));
	    }
	
	    /**
	     * Creates an object composed of the picked `object` properties.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The source object.
	     * @param {...(string|string[])} [paths] The property paths to pick.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': '2', 'c': 3 };
	     *
	     * _.pick(object, ['a', 'c']);
	     * // => { 'a': 1, 'c': 3 }
	     */
	    var pick = flatRest(function(object, paths) {
	      return object == null ? {} : basePick(object, paths);
	    });
	
	    /**
	     * Creates an object composed of the `object` properties `predicate` returns
	     * truthy for. The predicate is invoked with two arguments: (value, key).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The source object.
	     * @param {Function} [predicate=_.identity] The function invoked per property.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': '2', 'c': 3 };
	     *
	     * _.pickBy(object, _.isNumber);
	     * // => { 'a': 1, 'c': 3 }
	     */
	    function pickBy(object, predicate) {
	      if (object == null) {
	        return {};
	      }
	      var props = arrayMap(getAllKeysIn(object), function(prop) {
	        return [prop];
	      });
	      predicate = getIteratee(predicate);
	      return basePickBy(object, props, function(value, path) {
	        return predicate(value, path[0]);
	      });
	    }
	
	    /**
	     * This method is like `_.get` except that if the resolved value is a
	     * function it's invoked with the `this` binding of its parent object and
	     * its result is returned.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path of the property to resolve.
	     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
	     * @returns {*} Returns the resolved value.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c1': 3, 'c2': _.constant(4) } }] };
	     *
	     * _.result(object, 'a[0].b.c1');
	     * // => 3
	     *
	     * _.result(object, 'a[0].b.c2');
	     * // => 4
	     *
	     * _.result(object, 'a[0].b.c3', 'default');
	     * // => 'default'
	     *
	     * _.result(object, 'a[0].b.c3', _.constant('default'));
	     * // => 'default'
	     */
	    function result(object, path, defaultValue) {
	      path = castPath(path, object);
	
	      var index = -1,
	          length = path.length;
	
	      // Ensure the loop is entered when path is empty.
	      if (!length) {
	        length = 1;
	        object = undefined;
	      }
	      while (++index < length) {
	        var value = object == null ? undefined : object[toKey(path[index])];
	        if (value === undefined) {
	          index = length;
	          value = defaultValue;
	        }
	        object = isFunction(value) ? value.call(object) : value;
	      }
	      return object;
	    }
	
	    /**
	     * Sets the value at `path` of `object`. If a portion of `path` doesn't exist,
	     * it's created. Arrays are created for missing index properties while objects
	     * are created for all other missing properties. Use `_.setWith` to customize
	     * `path` creation.
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.7.0
	     * @category Object
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The path of the property to set.
	     * @param {*} value The value to set.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
	     *
	     * _.set(object, 'a[0].b.c', 4);
	     * console.log(object.a[0].b.c);
	     * // => 4
	     *
	     * _.set(object, ['x', '0', 'y', 'z'], 5);
	     * console.log(object.x[0].y.z);
	     * // => 5
	     */
	    function set(object, path, value) {
	      return object == null ? object : baseSet(object, path, value);
	    }
	
	    /**
	     * This method is like `_.set` except that it accepts `customizer` which is
	     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
	     * path creation is handled by the method instead. The `customizer` is invoked
	     * with three arguments: (nsValue, key, nsObject).
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The path of the property to set.
	     * @param {*} value The value to set.
	     * @param {Function} [customizer] The function to customize assigned values.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * var object = {};
	     *
	     * _.setWith(object, '[0][1]', 'a', Object);
	     * // => { '0': { '1': 'a' } }
	     */
	    function setWith(object, path, value, customizer) {
	      customizer = typeof customizer == 'function' ? customizer : undefined;
	      return object == null ? object : baseSet(object, path, value, customizer);
	    }
	
	    /**
	     * Creates an array of own enumerable string keyed-value pairs for `object`
	     * which can be consumed by `_.fromPairs`. If `object` is a map or set, its
	     * entries are returned.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @alias entries
	     * @category Object
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the key-value pairs.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.toPairs(new Foo);
	     * // => [['a', 1], ['b', 2]] (iteration order is not guaranteed)
	     */
	    var toPairs = createToPairs(keys);
	
	    /**
	     * Creates an array of own and inherited enumerable string keyed-value pairs
	     * for `object` which can be consumed by `_.fromPairs`. If `object` is a map
	     * or set, its entries are returned.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @alias entriesIn
	     * @category Object
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the key-value pairs.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.toPairsIn(new Foo);
	     * // => [['a', 1], ['b', 2], ['c', 3]] (iteration order is not guaranteed)
	     */
	    var toPairsIn = createToPairs(keysIn);
	
	    /**
	     * An alternative to `_.reduce`; this method transforms `object` to a new
	     * `accumulator` object which is the result of running each of its own
	     * enumerable string keyed properties thru `iteratee`, with each invocation
	     * potentially mutating the `accumulator` object. If `accumulator` is not
	     * provided, a new object with the same `[[Prototype]]` will be used. The
	     * iteratee is invoked with four arguments: (accumulator, value, key, object).
	     * Iteratee functions may exit iteration early by explicitly returning `false`.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.3.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @param {*} [accumulator] The custom accumulator value.
	     * @returns {*} Returns the accumulated value.
	     * @example
	     *
	     * _.transform([2, 3, 4], function(result, n) {
	     *   result.push(n *= n);
	     *   return n % 2 == 0;
	     * }, []);
	     * // => [4, 9]
	     *
	     * _.transform({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
	     *   (result[value] || (result[value] = [])).push(key);
	     * }, {});
	     * // => { '1': ['a', 'c'], '2': ['b'] }
	     */
	    function transform(object, iteratee, accumulator) {
	      var isArr = isArray(object),
	          isArrLike = isArr || isBuffer(object) || isTypedArray(object);
	
	      iteratee = getIteratee(iteratee, 4);
	      if (accumulator == null) {
	        var Ctor = object && object.constructor;
	        if (isArrLike) {
	          accumulator = isArr ? new Ctor : [];
	        }
	        else if (isObject(object)) {
	          accumulator = isFunction(Ctor) ? baseCreate(getPrototype(object)) : {};
	        }
	        else {
	          accumulator = {};
	        }
	      }
	      (isArrLike ? arrayEach : baseForOwn)(object, function(value, index, object) {
	        return iteratee(accumulator, value, index, object);
	      });
	      return accumulator;
	    }
	
	    /**
	     * Removes the property at `path` of `object`.
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The path of the property to unset.
	     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c': 7 } }] };
	     * _.unset(object, 'a[0].b.c');
	     * // => true
	     *
	     * console.log(object);
	     * // => { 'a': [{ 'b': {} }] };
	     *
	     * _.unset(object, ['a', '0', 'b', 'c']);
	     * // => true
	     *
	     * console.log(object);
	     * // => { 'a': [{ 'b': {} }] };
	     */
	    function unset(object, path) {
	      return object == null ? true : baseUnset(object, path);
	    }
	
	    /**
	     * This method is like `_.set` except that accepts `updater` to produce the
	     * value to set. Use `_.updateWith` to customize `path` creation. The `updater`
	     * is invoked with one argument: (value).
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.6.0
	     * @category Object
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The path of the property to set.
	     * @param {Function} updater The function to produce the updated value.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
	     *
	     * _.update(object, 'a[0].b.c', function(n) { return n * n; });
	     * console.log(object.a[0].b.c);
	     * // => 9
	     *
	     * _.update(object, 'x[0].y.z', function(n) { return n ? n + 1 : 0; });
	     * console.log(object.x[0].y.z);
	     * // => 0
	     */
	    function update(object, path, updater) {
	      return object == null ? object : baseUpdate(object, path, castFunction(updater));
	    }
	
	    /**
	     * This method is like `_.update` except that it accepts `customizer` which is
	     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
	     * path creation is handled by the method instead. The `customizer` is invoked
	     * with three arguments: (nsValue, key, nsObject).
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.6.0
	     * @category Object
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The path of the property to set.
	     * @param {Function} updater The function to produce the updated value.
	     * @param {Function} [customizer] The function to customize assigned values.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * var object = {};
	     *
	     * _.updateWith(object, '[0][1]', _.constant('a'), Object);
	     * // => { '0': { '1': 'a' } }
	     */
	    function updateWith(object, path, updater, customizer) {
	      customizer = typeof customizer == 'function' ? customizer : undefined;
	      return object == null ? object : baseUpdate(object, path, castFunction(updater), customizer);
	    }
	
	    /**
	     * Creates an array of the own enumerable string keyed property values of `object`.
	     *
	     * **Note:** Non-object values are coerced to objects.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property values.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.values(new Foo);
	     * // => [1, 2] (iteration order is not guaranteed)
	     *
	     * _.values('hi');
	     * // => ['h', 'i']
	     */
	    function values(object) {
	      return object == null ? [] : baseValues(object, keys(object));
	    }
	
	    /**
	     * Creates an array of the own and inherited enumerable string keyed property
	     * values of `object`.
	     *
	     * **Note:** Non-object values are coerced to objects.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Object
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property values.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.valuesIn(new Foo);
	     * // => [1, 2, 3] (iteration order is not guaranteed)
	     */
	    function valuesIn(object) {
	      return object == null ? [] : baseValues(object, keysIn(object));
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Clamps `number` within the inclusive `lower` and `upper` bounds.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Number
	     * @param {number} number The number to clamp.
	     * @param {number} [lower] The lower bound.
	     * @param {number} upper The upper bound.
	     * @returns {number} Returns the clamped number.
	     * @example
	     *
	     * _.clamp(-10, -5, 5);
	     * // => -5
	     *
	     * _.clamp(10, -5, 5);
	     * // => 5
	     */
	    function clamp(number, lower, upper) {
	      if (upper === undefined) {
	        upper = lower;
	        lower = undefined;
	      }
	      if (upper !== undefined) {
	        upper = toNumber(upper);
	        upper = upper === upper ? upper : 0;
	      }
	      if (lower !== undefined) {
	        lower = toNumber(lower);
	        lower = lower === lower ? lower : 0;
	      }
	      return baseClamp(toNumber(number), lower, upper);
	    }
	
	    /**
	     * Checks if `n` is between `start` and up to, but not including, `end`. If
	     * `end` is not specified, it's set to `start` with `start` then set to `0`.
	     * If `start` is greater than `end` the params are swapped to support
	     * negative ranges.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.3.0
	     * @category Number
	     * @param {number} number The number to check.
	     * @param {number} [start=0] The start of the range.
	     * @param {number} end The end of the range.
	     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
	     * @see _.range, _.rangeRight
	     * @example
	     *
	     * _.inRange(3, 2, 4);
	     * // => true
	     *
	     * _.inRange(4, 8);
	     * // => true
	     *
	     * _.inRange(4, 2);
	     * // => false
	     *
	     * _.inRange(2, 2);
	     * // => false
	     *
	     * _.inRange(1.2, 2);
	     * // => true
	     *
	     * _.inRange(5.2, 4);
	     * // => false
	     *
	     * _.inRange(-3, -2, -6);
	     * // => true
	     */
	    function inRange(number, start, end) {
	      start = toFinite(start);
	      if (end === undefined) {
	        end = start;
	        start = 0;
	      } else {
	        end = toFinite(end);
	      }
	      number = toNumber(number);
	      return baseInRange(number, start, end);
	    }
	
	    /**
	     * Produces a random number between the inclusive `lower` and `upper` bounds.
	     * If only one argument is provided a number between `0` and the given number
	     * is returned. If `floating` is `true`, or either `lower` or `upper` are
	     * floats, a floating-point number is returned instead of an integer.
	     *
	     * **Note:** JavaScript follows the IEEE-754 standard for resolving
	     * floating-point values which can produce unexpected results.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.7.0
	     * @category Number
	     * @param {number} [lower=0] The lower bound.
	     * @param {number} [upper=1] The upper bound.
	     * @param {boolean} [floating] Specify returning a floating-point number.
	     * @returns {number} Returns the random number.
	     * @example
	     *
	     * _.random(0, 5);
	     * // => an integer between 0 and 5
	     *
	     * _.random(5);
	     * // => also an integer between 0 and 5
	     *
	     * _.random(5, true);
	     * // => a floating-point number between 0 and 5
	     *
	     * _.random(1.2, 5.2);
	     * // => a floating-point number between 1.2 and 5.2
	     */
	    function random(lower, upper, floating) {
	      if (floating && typeof floating != 'boolean' && isIterateeCall(lower, upper, floating)) {
	        upper = floating = undefined;
	      }
	      if (floating === undefined) {
	        if (typeof upper == 'boolean') {
	          floating = upper;
	          upper = undefined;
	        }
	        else if (typeof lower == 'boolean') {
	          floating = lower;
	          lower = undefined;
	        }
	      }
	      if (lower === undefined && upper === undefined) {
	        lower = 0;
	        upper = 1;
	      }
	      else {
	        lower = toFinite(lower);
	        if (upper === undefined) {
	          upper = lower;
	          lower = 0;
	        } else {
	          upper = toFinite(upper);
	        }
	      }
	      if (lower > upper) {
	        var temp = lower;
	        lower = upper;
	        upper = temp;
	      }
	      if (floating || lower % 1 || upper % 1) {
	        var rand = nativeRandom();
	        return nativeMin(lower + (rand * (upper - lower + freeParseFloat('1e-' + ((rand + '').length - 1)))), upper);
	      }
	      return baseRandom(lower, upper);
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Converts `string` to [camel case](https://en.wikipedia.org/wiki/CamelCase).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the camel cased string.
	     * @example
	     *
	     * _.camelCase('Foo Bar');
	     * // => 'fooBar'
	     *
	     * _.camelCase('--foo-bar--');
	     * // => 'fooBar'
	     *
	     * _.camelCase('__FOO_BAR__');
	     * // => 'fooBar'
	     */
	    var camelCase = createCompounder(function(result, word, index) {
	      word = word.toLowerCase();
	      return result + (index ? capitalize(word) : word);
	    });
	
	    /**
	     * Converts the first character of `string` to upper case and the remaining
	     * to lower case.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to capitalize.
	     * @returns {string} Returns the capitalized string.
	     * @example
	     *
	     * _.capitalize('FRED');
	     * // => 'Fred'
	     */
	    function capitalize(string) {
	      return upperFirst(toString(string).toLowerCase());
	    }
	
	    /**
	     * Deburrs `string` by converting
	     * [Latin-1 Supplement](https://en.wikipedia.org/wiki/Latin-1_Supplement_(Unicode_block)#Character_table)
	     * and [Latin Extended-A](https://en.wikipedia.org/wiki/Latin_Extended-A)
	     * letters to basic Latin letters and removing
	     * [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to deburr.
	     * @returns {string} Returns the deburred string.
	     * @example
	     *
	     * _.deburr('déjà vu');
	     * // => 'deja vu'
	     */
	    function deburr(string) {
	      string = toString(string);
	      return string && string.replace(reLatin, deburrLetter).replace(reComboMark, '');
	    }
	
	    /**
	     * Checks if `string` ends with the given target string.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to inspect.
	     * @param {string} [target] The string to search for.
	     * @param {number} [position=string.length] The position to search up to.
	     * @returns {boolean} Returns `true` if `string` ends with `target`,
	     *  else `false`.
	     * @example
	     *
	     * _.endsWith('abc', 'c');
	     * // => true
	     *
	     * _.endsWith('abc', 'b');
	     * // => false
	     *
	     * _.endsWith('abc', 'b', 2);
	     * // => true
	     */
	    function endsWith(string, target, position) {
	      string = toString(string);
	      target = baseToString(target);
	
	      var length = string.length;
	      position = position === undefined
	        ? length
	        : baseClamp(toInteger(position), 0, length);
	
	      var end = position;
	      position -= target.length;
	      return position >= 0 && string.slice(position, end) == target;
	    }
	
	    /**
	     * Converts the characters "&", "<", ">", '"', and "'" in `string` to their
	     * corresponding HTML entities.
	     *
	     * **Note:** No other characters are escaped. To escape additional
	     * characters use a third-party library like [_he_](https://mths.be/he).
	     *
	     * Though the ">" character is escaped for symmetry, characters like
	     * ">" and "/" don't need escaping in HTML and have no special meaning
	     * unless they're part of a tag or unquoted attribute value. See
	     * [Mathias Bynens's article](https://mathiasbynens.be/notes/ambiguous-ampersands)
	     * (under "semi-related fun fact") for more details.
	     *
	     * When working with HTML you should always
	     * [quote attribute values](http://wonko.com/post/html-escaping) to reduce
	     * XSS vectors.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category String
	     * @param {string} [string=''] The string to escape.
	     * @returns {string} Returns the escaped string.
	     * @example
	     *
	     * _.escape('fred, barney, & pebbles');
	     * // => 'fred, barney, &amp; pebbles'
	     */
	    function escape(string) {
	      string = toString(string);
	      return (string && reHasUnescapedHtml.test(string))
	        ? string.replace(reUnescapedHtml, escapeHtmlChar)
	        : string;
	    }
	
	    /**
	     * Escapes the `RegExp` special characters "^", "$", "\", ".", "*", "+",
	     * "?", "(", ")", "[", "]", "{", "}", and "|" in `string`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to escape.
	     * @returns {string} Returns the escaped string.
	     * @example
	     *
	     * _.escapeRegExp('[lodash](https://lodash.com/)');
	     * // => '\[lodash\]\(https://lodash\.com/\)'
	     */
	    function escapeRegExp(string) {
	      string = toString(string);
	      return (string && reHasRegExpChar.test(string))
	        ? string.replace(reRegExpChar, '\\$&')
	        : string;
	    }
	
	    /**
	     * Converts `string` to
	     * [kebab case](https://en.wikipedia.org/wiki/Letter_case#Special_case_styles).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the kebab cased string.
	     * @example
	     *
	     * _.kebabCase('Foo Bar');
	     * // => 'foo-bar'
	     *
	     * _.kebabCase('fooBar');
	     * // => 'foo-bar'
	     *
	     * _.kebabCase('__FOO_BAR__');
	     * // => 'foo-bar'
	     */
	    var kebabCase = createCompounder(function(result, word, index) {
	      return result + (index ? '-' : '') + word.toLowerCase();
	    });
	
	    /**
	     * Converts `string`, as space separated words, to lower case.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the lower cased string.
	     * @example
	     *
	     * _.lowerCase('--Foo-Bar--');
	     * // => 'foo bar'
	     *
	     * _.lowerCase('fooBar');
	     * // => 'foo bar'
	     *
	     * _.lowerCase('__FOO_BAR__');
	     * // => 'foo bar'
	     */
	    var lowerCase = createCompounder(function(result, word, index) {
	      return result + (index ? ' ' : '') + word.toLowerCase();
	    });
	
	    /**
	     * Converts the first character of `string` to lower case.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the converted string.
	     * @example
	     *
	     * _.lowerFirst('Fred');
	     * // => 'fred'
	     *
	     * _.lowerFirst('FRED');
	     * // => 'fRED'
	     */
	    var lowerFirst = createCaseFirst('toLowerCase');
	
	    /**
	     * Pads `string` on the left and right sides if it's shorter than `length`.
	     * Padding characters are truncated if they can't be evenly divided by `length`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to pad.
	     * @param {number} [length=0] The padding length.
	     * @param {string} [chars=' '] The string used as padding.
	     * @returns {string} Returns the padded string.
	     * @example
	     *
	     * _.pad('abc', 8);
	     * // => '  abc   '
	     *
	     * _.pad('abc', 8, '_-');
	     * // => '_-abc_-_'
	     *
	     * _.pad('abc', 3);
	     * // => 'abc'
	     */
	    function pad(string, length, chars) {
	      string = toString(string);
	      length = toInteger(length);
	
	      var strLength = length ? stringSize(string) : 0;
	      if (!length || strLength >= length) {
	        return string;
	      }
	      var mid = (length - strLength) / 2;
	      return (
	        createPadding(nativeFloor(mid), chars) +
	        string +
	        createPadding(nativeCeil(mid), chars)
	      );
	    }
	
	    /**
	     * Pads `string` on the right side if it's shorter than `length`. Padding
	     * characters are truncated if they exceed `length`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to pad.
	     * @param {number} [length=0] The padding length.
	     * @param {string} [chars=' '] The string used as padding.
	     * @returns {string} Returns the padded string.
	     * @example
	     *
	     * _.padEnd('abc', 6);
	     * // => 'abc   '
	     *
	     * _.padEnd('abc', 6, '_-');
	     * // => 'abc_-_'
	     *
	     * _.padEnd('abc', 3);
	     * // => 'abc'
	     */
	    function padEnd(string, length, chars) {
	      string = toString(string);
	      length = toInteger(length);
	
	      var strLength = length ? stringSize(string) : 0;
	      return (length && strLength < length)
	        ? (string + createPadding(length - strLength, chars))
	        : string;
	    }
	
	    /**
	     * Pads `string` on the left side if it's shorter than `length`. Padding
	     * characters are truncated if they exceed `length`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to pad.
	     * @param {number} [length=0] The padding length.
	     * @param {string} [chars=' '] The string used as padding.
	     * @returns {string} Returns the padded string.
	     * @example
	     *
	     * _.padStart('abc', 6);
	     * // => '   abc'
	     *
	     * _.padStart('abc', 6, '_-');
	     * // => '_-_abc'
	     *
	     * _.padStart('abc', 3);
	     * // => 'abc'
	     */
	    function padStart(string, length, chars) {
	      string = toString(string);
	      length = toInteger(length);
	
	      var strLength = length ? stringSize(string) : 0;
	      return (length && strLength < length)
	        ? (createPadding(length - strLength, chars) + string)
	        : string;
	    }
	
	    /**
	     * Converts `string` to an integer of the specified radix. If `radix` is
	     * `undefined` or `0`, a `radix` of `10` is used unless `value` is a
	     * hexadecimal, in which case a `radix` of `16` is used.
	     *
	     * **Note:** This method aligns with the
	     * [ES5 implementation](https://es5.github.io/#x15.1.2.2) of `parseInt`.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.1.0
	     * @category String
	     * @param {string} string The string to convert.
	     * @param {number} [radix=10] The radix to interpret `value` by.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {number} Returns the converted integer.
	     * @example
	     *
	     * _.parseInt('08');
	     * // => 8
	     *
	     * _.map(['6', '08', '10'], _.parseInt);
	     * // => [6, 8, 10]
	     */
	    function parseInt(string, radix, guard) {
	      if (guard || radix == null) {
	        radix = 0;
	      } else if (radix) {
	        radix = +radix;
	      }
	      return nativeParseInt(toString(string).replace(reTrimStart, ''), radix || 0);
	    }
	
	    /**
	     * Repeats the given string `n` times.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to repeat.
	     * @param {number} [n=1] The number of times to repeat the string.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {string} Returns the repeated string.
	     * @example
	     *
	     * _.repeat('*', 3);
	     * // => '***'
	     *
	     * _.repeat('abc', 2);
	     * // => 'abcabc'
	     *
	     * _.repeat('abc', 0);
	     * // => ''
	     */
	    function repeat(string, n, guard) {
	      if ((guard ? isIterateeCall(string, n, guard) : n === undefined)) {
	        n = 1;
	      } else {
	        n = toInteger(n);
	      }
	      return baseRepeat(toString(string), n);
	    }
	
	    /**
	     * Replaces matches for `pattern` in `string` with `replacement`.
	     *
	     * **Note:** This method is based on
	     * [`String#replace`](https://mdn.io/String/replace).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to modify.
	     * @param {RegExp|string} pattern The pattern to replace.
	     * @param {Function|string} replacement The match replacement.
	     * @returns {string} Returns the modified string.
	     * @example
	     *
	     * _.replace('Hi Fred', 'Fred', 'Barney');
	     * // => 'Hi Barney'
	     */
	    function replace() {
	      var args = arguments,
	          string = toString(args[0]);
	
	      return args.length < 3 ? string : string.replace(args[1], args[2]);
	    }
	
	    /**
	     * Converts `string` to
	     * [snake case](https://en.wikipedia.org/wiki/Snake_case).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the snake cased string.
	     * @example
	     *
	     * _.snakeCase('Foo Bar');
	     * // => 'foo_bar'
	     *
	     * _.snakeCase('fooBar');
	     * // => 'foo_bar'
	     *
	     * _.snakeCase('--FOO-BAR--');
	     * // => 'foo_bar'
	     */
	    var snakeCase = createCompounder(function(result, word, index) {
	      return result + (index ? '_' : '') + word.toLowerCase();
	    });
	
	    /**
	     * Splits `string` by `separator`.
	     *
	     * **Note:** This method is based on
	     * [`String#split`](https://mdn.io/String/split).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to split.
	     * @param {RegExp|string} separator The separator pattern to split by.
	     * @param {number} [limit] The length to truncate results to.
	     * @returns {Array} Returns the string segments.
	     * @example
	     *
	     * _.split('a-b-c', '-', 2);
	     * // => ['a', 'b']
	     */
	    function split(string, separator, limit) {
	      if (limit && typeof limit != 'number' && isIterateeCall(string, separator, limit)) {
	        separator = limit = undefined;
	      }
	      limit = limit === undefined ? MAX_ARRAY_LENGTH : limit >>> 0;
	      if (!limit) {
	        return [];
	      }
	      string = toString(string);
	      if (string && (
	            typeof separator == 'string' ||
	            (separator != null && !isRegExp(separator))
	          )) {
	        separator = baseToString(separator);
	        if (!separator && hasUnicode(string)) {
	          return castSlice(stringToArray(string), 0, limit);
	        }
	      }
	      return string.split(separator, limit);
	    }
	
	    /**
	     * Converts `string` to
	     * [start case](https://en.wikipedia.org/wiki/Letter_case#Stylistic_or_specialised_usage).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.1.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the start cased string.
	     * @example
	     *
	     * _.startCase('--foo-bar--');
	     * // => 'Foo Bar'
	     *
	     * _.startCase('fooBar');
	     * // => 'Foo Bar'
	     *
	     * _.startCase('__FOO_BAR__');
	     * // => 'FOO BAR'
	     */
	    var startCase = createCompounder(function(result, word, index) {
	      return result + (index ? ' ' : '') + upperFirst(word);
	    });
	
	    /**
	     * Checks if `string` starts with the given target string.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to inspect.
	     * @param {string} [target] The string to search for.
	     * @param {number} [position=0] The position to search from.
	     * @returns {boolean} Returns `true` if `string` starts with `target`,
	     *  else `false`.
	     * @example
	     *
	     * _.startsWith('abc', 'a');
	     * // => true
	     *
	     * _.startsWith('abc', 'b');
	     * // => false
	     *
	     * _.startsWith('abc', 'b', 1);
	     * // => true
	     */
	    function startsWith(string, target, position) {
	      string = toString(string);
	      position = position == null
	        ? 0
	        : baseClamp(toInteger(position), 0, string.length);
	
	      target = baseToString(target);
	      return string.slice(position, position + target.length) == target;
	    }
	
	    /**
	     * Creates a compiled template function that can interpolate data properties
	     * in "interpolate" delimiters, HTML-escape interpolated data properties in
	     * "escape" delimiters, and execute JavaScript in "evaluate" delimiters. Data
	     * properties may be accessed as free variables in the template. If a setting
	     * object is given, it takes precedence over `_.templateSettings` values.
	     *
	     * **Note:** In the development build `_.template` utilizes
	     * [sourceURLs](http://www.html5rocks.com/en/tutorials/developertools/sourcemaps/#toc-sourceurl)
	     * for easier debugging.
	     *
	     * For more information on precompiling templates see
	     * [lodash's custom builds documentation](https://lodash.com/custom-builds).
	     *
	     * For more information on Chrome extension sandboxes see
	     * [Chrome's extensions documentation](https://developer.chrome.com/extensions/sandboxingEval).
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category String
	     * @param {string} [string=''] The template string.
	     * @param {Object} [options={}] The options object.
	     * @param {RegExp} [options.escape=_.templateSettings.escape]
	     *  The HTML "escape" delimiter.
	     * @param {RegExp} [options.evaluate=_.templateSettings.evaluate]
	     *  The "evaluate" delimiter.
	     * @param {Object} [options.imports=_.templateSettings.imports]
	     *  An object to import into the template as free variables.
	     * @param {RegExp} [options.interpolate=_.templateSettings.interpolate]
	     *  The "interpolate" delimiter.
	     * @param {string} [options.sourceURL='lodash.templateSources[n]']
	     *  The sourceURL of the compiled template.
	     * @param {string} [options.variable='obj']
	     *  The data object variable name.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Function} Returns the compiled template function.
	     * @example
	     *
	     * // Use the "interpolate" delimiter to create a compiled template.
	     * var compiled = _.template('hello <%= user %>!');
	     * compiled({ 'user': 'fred' });
	     * // => 'hello fred!'
	     *
	     * // Use the HTML "escape" delimiter to escape data property values.
	     * var compiled = _.template('<b><%- value %></b>');
	     * compiled({ 'value': '<script>' });
	     * // => '<b>&lt;script&gt;</b>'
	     *
	     * // Use the "evaluate" delimiter to execute JavaScript and generate HTML.
	     * var compiled = _.template('<% _.forEach(users, function(user) { %><li><%- user %></li><% }); %>');
	     * compiled({ 'users': ['fred', 'barney'] });
	     * // => '<li>fred</li><li>barney</li>'
	     *
	     * // Use the internal `print` function in "evaluate" delimiters.
	     * var compiled = _.template('<% print("hello " + user); %>!');
	     * compiled({ 'user': 'barney' });
	     * // => 'hello barney!'
	     *
	     * // Use the ES template literal delimiter as an "interpolate" delimiter.
	     * // Disable support by replacing the "interpolate" delimiter.
	     * var compiled = _.template('hello ${ user }!');
	     * compiled({ 'user': 'pebbles' });
	     * // => 'hello pebbles!'
	     *
	     * // Use backslashes to treat delimiters as plain text.
	     * var compiled = _.template('<%= "\\<%- value %\\>" %>');
	     * compiled({ 'value': 'ignored' });
	     * // => '<%- value %>'
	     *
	     * // Use the `imports` option to import `jQuery` as `jq`.
	     * var text = '<% jq.each(users, function(user) { %><li><%- user %></li><% }); %>';
	     * var compiled = _.template(text, { 'imports': { 'jq': jQuery } });
	     * compiled({ 'users': ['fred', 'barney'] });
	     * // => '<li>fred</li><li>barney</li>'
	     *
	     * // Use the `sourceURL` option to specify a custom sourceURL for the template.
	     * var compiled = _.template('hello <%= user %>!', { 'sourceURL': '/basic/greeting.jst' });
	     * compiled(data);
	     * // => Find the source of "greeting.jst" under the Sources tab or Resources panel of the web inspector.
	     *
	     * // Use the `variable` option to ensure a with-statement isn't used in the compiled template.
	     * var compiled = _.template('hi <%= data.user %>!', { 'variable': 'data' });
	     * compiled.source;
	     * // => function(data) {
	     * //   var __t, __p = '';
	     * //   __p += 'hi ' + ((__t = ( data.user )) == null ? '' : __t) + '!';
	     * //   return __p;
	     * // }
	     *
	     * // Use custom template delimiters.
	     * _.templateSettings.interpolate = /{{([\s\S]+?)}}/g;
	     * var compiled = _.template('hello {{ user }}!');
	     * compiled({ 'user': 'mustache' });
	     * // => 'hello mustache!'
	     *
	     * // Use the `source` property to inline compiled templates for meaningful
	     * // line numbers in error messages and stack traces.
	     * fs.writeFileSync(path.join(process.cwd(), 'jst.js'), '\
	     *   var JST = {\
	     *     "main": ' + _.template(mainText).source + '\
	     *   };\
	     * ');
	     */
	    function template(string, options, guard) {
	      // Based on John Resig's `tmpl` implementation
	      // (http://ejohn.org/blog/javascript-micro-templating/)
	      // and Laura Doktorova's doT.js (https://github.com/olado/doT).
	      var settings = lodash.templateSettings;
	
	      if (guard && isIterateeCall(string, options, guard)) {
	        options = undefined;
	      }
	      string = toString(string);
	      options = assignInWith({}, options, settings, customDefaultsAssignIn);
	
	      var imports = assignInWith({}, options.imports, settings.imports, customDefaultsAssignIn),
	          importsKeys = keys(imports),
	          importsValues = baseValues(imports, importsKeys);
	
	      var isEscaping,
	          isEvaluating,
	          index = 0,
	          interpolate = options.interpolate || reNoMatch,
	          source = "__p += '";
	
	      // Compile the regexp to match each delimiter.
	      var reDelimiters = RegExp(
	        (options.escape || reNoMatch).source + '|' +
	        interpolate.source + '|' +
	        (interpolate === reInterpolate ? reEsTemplate : reNoMatch).source + '|' +
	        (options.evaluate || reNoMatch).source + '|$'
	      , 'g');
	
	      // Use a sourceURL for easier debugging.
	      // The sourceURL gets injected into the source that's eval-ed, so be careful
	      // with lookup (in case of e.g. prototype pollution), and strip newlines if any.
	      // A newline wouldn't be a valid sourceURL anyway, and it'd enable code injection.
	      var sourceURL = '//# sourceURL=' +
	        (hasOwnProperty.call(options, 'sourceURL')
	          ? (options.sourceURL + '').replace(/[\r\n]/g, ' ')
	          : ('lodash.templateSources[' + (++templateCounter) + ']')
	        ) + '\n';
	
	      string.replace(reDelimiters, function(match, escapeValue, interpolateValue, esTemplateValue, evaluateValue, offset) {
	        interpolateValue || (interpolateValue = esTemplateValue);
	
	        // Escape characters that can't be included in string literals.
	        source += string.slice(index, offset).replace(reUnescapedString, escapeStringChar);
	
	        // Replace delimiters with snippets.
	        if (escapeValue) {
	          isEscaping = true;
	          source += "' +\n__e(" + escapeValue + ") +\n'";
	        }
	        if (evaluateValue) {
	          isEvaluating = true;
	          source += "';\n" + evaluateValue + ";\n__p += '";
	        }
	        if (interpolateValue) {
	          source += "' +\n((__t = (" + interpolateValue + ")) == null ? '' : __t) +\n'";
	        }
	        index = offset + match.length;
	
	        // The JS engine embedded in Adobe products needs `match` returned in
	        // order to produce the correct `offset` value.
	        return match;
	      });
	
	      source += "';\n";
	
	      // If `variable` is not specified wrap a with-statement around the generated
	      // code to add the data object to the top of the scope chain.
	      // Like with sourceURL, we take care to not check the option's prototype,
	      // as this configuration is a code injection vector.
	      var variable = hasOwnProperty.call(options, 'variable') && options.variable;
	      if (!variable) {
	        source = 'with (obj) {\n' + source + '\n}\n';
	      }
	      // Cleanup code by stripping empty strings.
	      source = (isEvaluating ? source.replace(reEmptyStringLeading, '') : source)
	        .replace(reEmptyStringMiddle, '$1')
	        .replace(reEmptyStringTrailing, '$1;');
	
	      // Frame code as the function body.
	      source = 'function(' + (variable || 'obj') + ') {\n' +
	        (variable
	          ? ''
	          : 'obj || (obj = {});\n'
	        ) +
	        "var __t, __p = ''" +
	        (isEscaping
	           ? ', __e = _.escape'
	           : ''
	        ) +
	        (isEvaluating
	          ? ', __j = Array.prototype.join;\n' +
	            "function print() { __p += __j.call(arguments, '') }\n"
	          : ';\n'
	        ) +
	        source +
	        'return __p\n}';
	
	      var result = attempt(function() {
	        return Function(importsKeys, sourceURL + 'return ' + source)
	          .apply(undefined, importsValues);
	      });
	
	      // Provide the compiled function's source by its `toString` method or
	      // the `source` property as a convenience for inlining compiled templates.
	      result.source = source;
	      if (isError(result)) {
	        throw result;
	      }
	      return result;
	    }
	
	    /**
	     * Converts `string`, as a whole, to lower case just like
	     * [String#toLowerCase](https://mdn.io/toLowerCase).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the lower cased string.
	     * @example
	     *
	     * _.toLower('--Foo-Bar--');
	     * // => '--foo-bar--'
	     *
	     * _.toLower('fooBar');
	     * // => 'foobar'
	     *
	     * _.toLower('__FOO_BAR__');
	     * // => '__foo_bar__'
	     */
	    function toLower(value) {
	      return toString(value).toLowerCase();
	    }
	
	    /**
	     * Converts `string`, as a whole, to upper case just like
	     * [String#toUpperCase](https://mdn.io/toUpperCase).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the upper cased string.
	     * @example
	     *
	     * _.toUpper('--foo-bar--');
	     * // => '--FOO-BAR--'
	     *
	     * _.toUpper('fooBar');
	     * // => 'FOOBAR'
	     *
	     * _.toUpper('__foo_bar__');
	     * // => '__FOO_BAR__'
	     */
	    function toUpper(value) {
	      return toString(value).toUpperCase();
	    }
	
	    /**
	     * Removes leading and trailing whitespace or specified characters from `string`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to trim.
	     * @param {string} [chars=whitespace] The characters to trim.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {string} Returns the trimmed string.
	     * @example
	     *
	     * _.trim('  abc  ');
	     * // => 'abc'
	     *
	     * _.trim('-_-abc-_-', '_-');
	     * // => 'abc'
	     *
	     * _.map(['  foo  ', '  bar  '], _.trim);
	     * // => ['foo', 'bar']
	     */
	    function trim(string, chars, guard) {
	      string = toString(string);
	      if (string && (guard || chars === undefined)) {
	        return string.replace(reTrim, '');
	      }
	      if (!string || !(chars = baseToString(chars))) {
	        return string;
	      }
	      var strSymbols = stringToArray(string),
	          chrSymbols = stringToArray(chars),
	          start = charsStartIndex(strSymbols, chrSymbols),
	          end = charsEndIndex(strSymbols, chrSymbols) + 1;
	
	      return castSlice(strSymbols, start, end).join('');
	    }
	
	    /**
	     * Removes trailing whitespace or specified characters from `string`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to trim.
	     * @param {string} [chars=whitespace] The characters to trim.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {string} Returns the trimmed string.
	     * @example
	     *
	     * _.trimEnd('  abc  ');
	     * // => '  abc'
	     *
	     * _.trimEnd('-_-abc-_-', '_-');
	     * // => '-_-abc'
	     */
	    function trimEnd(string, chars, guard) {
	      string = toString(string);
	      if (string && (guard || chars === undefined)) {
	        return string.replace(reTrimEnd, '');
	      }
	      if (!string || !(chars = baseToString(chars))) {
	        return string;
	      }
	      var strSymbols = stringToArray(string),
	          end = charsEndIndex(strSymbols, stringToArray(chars)) + 1;
	
	      return castSlice(strSymbols, 0, end).join('');
	    }
	
	    /**
	     * Removes leading whitespace or specified characters from `string`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to trim.
	     * @param {string} [chars=whitespace] The characters to trim.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {string} Returns the trimmed string.
	     * @example
	     *
	     * _.trimStart('  abc  ');
	     * // => 'abc  '
	     *
	     * _.trimStart('-_-abc-_-', '_-');
	     * // => 'abc-_-'
	     */
	    function trimStart(string, chars, guard) {
	      string = toString(string);
	      if (string && (guard || chars === undefined)) {
	        return string.replace(reTrimStart, '');
	      }
	      if (!string || !(chars = baseToString(chars))) {
	        return string;
	      }
	      var strSymbols = stringToArray(string),
	          start = charsStartIndex(strSymbols, stringToArray(chars));
	
	      return castSlice(strSymbols, start).join('');
	    }
	
	    /**
	     * Truncates `string` if it's longer than the given maximum string length.
	     * The last characters of the truncated string are replaced with the omission
	     * string which defaults to "...".
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to truncate.
	     * @param {Object} [options={}] The options object.
	     * @param {number} [options.length=30] The maximum string length.
	     * @param {string} [options.omission='...'] The string to indicate text is omitted.
	     * @param {RegExp|string} [options.separator] The separator pattern to truncate to.
	     * @returns {string} Returns the truncated string.
	     * @example
	     *
	     * _.truncate('hi-diddly-ho there, neighborino');
	     * // => 'hi-diddly-ho there, neighbo...'
	     *
	     * _.truncate('hi-diddly-ho there, neighborino', {
	     *   'length': 24,
	     *   'separator': ' '
	     * });
	     * // => 'hi-diddly-ho there,...'
	     *
	     * _.truncate('hi-diddly-ho there, neighborino', {
	     *   'length': 24,
	     *   'separator': /,? +/
	     * });
	     * // => 'hi-diddly-ho there...'
	     *
	     * _.truncate('hi-diddly-ho there, neighborino', {
	     *   'omission': ' [...]'
	     * });
	     * // => 'hi-diddly-ho there, neig [...]'
	     */
	    function truncate(string, options) {
	      var length = DEFAULT_TRUNC_LENGTH,
	          omission = DEFAULT_TRUNC_OMISSION;
	
	      if (isObject(options)) {
	        var separator = 'separator' in options ? options.separator : separator;
	        length = 'length' in options ? toInteger(options.length) : length;
	        omission = 'omission' in options ? baseToString(options.omission) : omission;
	      }
	      string = toString(string);
	
	      var strLength = string.length;
	      if (hasUnicode(string)) {
	        var strSymbols = stringToArray(string);
	        strLength = strSymbols.length;
	      }
	      if (length >= strLength) {
	        return string;
	      }
	      var end = length - stringSize(omission);
	      if (end < 1) {
	        return omission;
	      }
	      var result = strSymbols
	        ? castSlice(strSymbols, 0, end).join('')
	        : string.slice(0, end);
	
	      if (separator === undefined) {
	        return result + omission;
	      }
	      if (strSymbols) {
	        end += (result.length - end);
	      }
	      if (isRegExp(separator)) {
	        if (string.slice(end).search(separator)) {
	          var match,
	              substring = result;
	
	          if (!separator.global) {
	            separator = RegExp(separator.source, toString(reFlags.exec(separator)) + 'g');
	          }
	          separator.lastIndex = 0;
	          while ((match = separator.exec(substring))) {
	            var newEnd = match.index;
	          }
	          result = result.slice(0, newEnd === undefined ? end : newEnd);
	        }
	      } else if (string.indexOf(baseToString(separator), end) != end) {
	        var index = result.lastIndexOf(separator);
	        if (index > -1) {
	          result = result.slice(0, index);
	        }
	      }
	      return result + omission;
	    }
	
	    /**
	     * The inverse of `_.escape`; this method converts the HTML entities
	     * `&amp;`, `&lt;`, `&gt;`, `&quot;`, and `&#39;` in `string` to
	     * their corresponding characters.
	     *
	     * **Note:** No other HTML entities are unescaped. To unescape additional
	     * HTML entities use a third-party library like [_he_](https://mths.be/he).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.6.0
	     * @category String
	     * @param {string} [string=''] The string to unescape.
	     * @returns {string} Returns the unescaped string.
	     * @example
	     *
	     * _.unescape('fred, barney, &amp; pebbles');
	     * // => 'fred, barney, & pebbles'
	     */
	    function unescape(string) {
	      string = toString(string);
	      return (string && reHasEscapedHtml.test(string))
	        ? string.replace(reEscapedHtml, unescapeHtmlChar)
	        : string;
	    }
	
	    /**
	     * Converts `string`, as space separated words, to upper case.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the upper cased string.
	     * @example
	     *
	     * _.upperCase('--foo-bar');
	     * // => 'FOO BAR'
	     *
	     * _.upperCase('fooBar');
	     * // => 'FOO BAR'
	     *
	     * _.upperCase('__foo_bar__');
	     * // => 'FOO BAR'
	     */
	    var upperCase = createCompounder(function(result, word, index) {
	      return result + (index ? ' ' : '') + word.toUpperCase();
	    });
	
	    /**
	     * Converts the first character of `string` to upper case.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the converted string.
	     * @example
	     *
	     * _.upperFirst('fred');
	     * // => 'Fred'
	     *
	     * _.upperFirst('FRED');
	     * // => 'FRED'
	     */
	    var upperFirst = createCaseFirst('toUpperCase');
	
	    /**
	     * Splits `string` into an array of its words.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to inspect.
	     * @param {RegExp|string} [pattern] The pattern to match words.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Array} Returns the words of `string`.
	     * @example
	     *
	     * _.words('fred, barney, & pebbles');
	     * // => ['fred', 'barney', 'pebbles']
	     *
	     * _.words('fred, barney, & pebbles', /[^, ]+/g);
	     * // => ['fred', 'barney', '&', 'pebbles']
	     */
	    function words(string, pattern, guard) {
	      string = toString(string);
	      pattern = guard ? undefined : pattern;
	
	      if (pattern === undefined) {
	        return hasUnicodeWord(string) ? unicodeWords(string) : asciiWords(string);
	      }
	      return string.match(pattern) || [];
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Attempts to invoke `func`, returning either the result or the caught error
	     * object. Any additional arguments are provided to `func` when it's invoked.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Util
	     * @param {Function} func The function to attempt.
	     * @param {...*} [args] The arguments to invoke `func` with.
	     * @returns {*} Returns the `func` result or error object.
	     * @example
	     *
	     * // Avoid throwing errors for invalid selectors.
	     * var elements = _.attempt(function(selector) {
	     *   return document.querySelectorAll(selector);
	     * }, '>_>');
	     *
	     * if (_.isError(elements)) {
	     *   elements = [];
	     * }
	     */
	    var attempt = baseRest(function(func, args) {
	      try {
	        return apply(func, undefined, args);
	      } catch (e) {
	        return isError(e) ? e : new Error(e);
	      }
	    });
	
	    /**
	     * Binds methods of an object to the object itself, overwriting the existing
	     * method.
	     *
	     * **Note:** This method doesn't set the "length" property of bound functions.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Util
	     * @param {Object} object The object to bind and assign the bound methods to.
	     * @param {...(string|string[])} methodNames The object method names to bind.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * var view = {
	     *   'label': 'docs',
	     *   'click': function() {
	     *     console.log('clicked ' + this.label);
	     *   }
	     * };
	     *
	     * _.bindAll(view, ['click']);
	     * jQuery(element).on('click', view.click);
	     * // => Logs 'clicked docs' when clicked.
	     */
	    var bindAll = flatRest(function(object, methodNames) {
	      arrayEach(methodNames, function(key) {
	        key = toKey(key);
	        baseAssignValue(object, key, bind(object[key], object));
	      });
	      return object;
	    });
	
	    /**
	     * Creates a function that iterates over `pairs` and invokes the corresponding
	     * function of the first predicate to return truthy. The predicate-function
	     * pairs are invoked with the `this` binding and arguments of the created
	     * function.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {Array} pairs The predicate-function pairs.
	     * @returns {Function} Returns the new composite function.
	     * @example
	     *
	     * var func = _.cond([
	     *   [_.matches({ 'a': 1 }),           _.constant('matches A')],
	     *   [_.conforms({ 'b': _.isNumber }), _.constant('matches B')],
	     *   [_.stubTrue,                      _.constant('no match')]
	     * ]);
	     *
	     * func({ 'a': 1, 'b': 2 });
	     * // => 'matches A'
	     *
	     * func({ 'a': 0, 'b': 1 });
	     * // => 'matches B'
	     *
	     * func({ 'a': '1', 'b': '2' });
	     * // => 'no match'
	     */
	    function cond(pairs) {
	      var length = pairs == null ? 0 : pairs.length,
	          toIteratee = getIteratee();
	
	      pairs = !length ? [] : arrayMap(pairs, function(pair) {
	        if (typeof pair[1] != 'function') {
	          throw new TypeError(FUNC_ERROR_TEXT);
	        }
	        return [toIteratee(pair[0]), pair[1]];
	      });
	
	      return baseRest(function(args) {
	        var index = -1;
	        while (++index < length) {
	          var pair = pairs[index];
	          if (apply(pair[0], this, args)) {
	            return apply(pair[1], this, args);
	          }
	        }
	      });
	    }
	
	    /**
	     * Creates a function that invokes the predicate properties of `source` with
	     * the corresponding property values of a given object, returning `true` if
	     * all predicates return truthy, else `false`.
	     *
	     * **Note:** The created function is equivalent to `_.conformsTo` with
	     * `source` partially applied.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {Object} source The object of property predicates to conform to.
	     * @returns {Function} Returns the new spec function.
	     * @example
	     *
	     * var objects = [
	     *   { 'a': 2, 'b': 1 },
	     *   { 'a': 1, 'b': 2 }
	     * ];
	     *
	     * _.filter(objects, _.conforms({ 'b': function(n) { return n > 1; } }));
	     * // => [{ 'a': 1, 'b': 2 }]
	     */
	    function conforms(source) {
	      return baseConforms(baseClone(source, CLONE_DEEP_FLAG));
	    }
	
	    /**
	     * Creates a function that returns `value`.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.4.0
	     * @category Util
	     * @param {*} value The value to return from the new function.
	     * @returns {Function} Returns the new constant function.
	     * @example
	     *
	     * var objects = _.times(2, _.constant({ 'a': 1 }));
	     *
	     * console.log(objects);
	     * // => [{ 'a': 1 }, { 'a': 1 }]
	     *
	     * console.log(objects[0] === objects[1]);
	     * // => true
	     */
	    function constant(value) {
	      return function() {
	        return value;
	      };
	    }
	
	    /**
	     * Checks `value` to determine whether a default value should be returned in
	     * its place. The `defaultValue` is returned if `value` is `NaN`, `null`,
	     * or `undefined`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.14.0
	     * @category Util
	     * @param {*} value The value to check.
	     * @param {*} defaultValue The default value.
	     * @returns {*} Returns the resolved value.
	     * @example
	     *
	     * _.defaultTo(1, 10);
	     * // => 1
	     *
	     * _.defaultTo(undefined, 10);
	     * // => 10
	     */
	    function defaultTo(value, defaultValue) {
	      return (value == null || value !== value) ? defaultValue : value;
	    }
	
	    /**
	     * Creates a function that returns the result of invoking the given functions
	     * with the `this` binding of the created function, where each successive
	     * invocation is supplied the return value of the previous.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Util
	     * @param {...(Function|Function[])} [funcs] The functions to invoke.
	     * @returns {Function} Returns the new composite function.
	     * @see _.flowRight
	     * @example
	     *
	     * function square(n) {
	     *   return n * n;
	     * }
	     *
	     * var addSquare = _.flow([_.add, square]);
	     * addSquare(1, 2);
	     * // => 9
	     */
	    var flow = createFlow();
	
	    /**
	     * This method is like `_.flow` except that it creates a function that
	     * invokes the given functions from right to left.
	     *
	     * @static
	     * @since 3.0.0
	     * @memberOf _
	     * @category Util
	     * @param {...(Function|Function[])} [funcs] The functions to invoke.
	     * @returns {Function} Returns the new composite function.
	     * @see _.flow
	     * @example
	     *
	     * function square(n) {
	     *   return n * n;
	     * }
	     *
	     * var addSquare = _.flowRight([square, _.add]);
	     * addSquare(1, 2);
	     * // => 9
	     */
	    var flowRight = createFlow(true);
	
	    /**
	     * This method returns the first argument it receives.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Util
	     * @param {*} value Any value.
	     * @returns {*} Returns `value`.
	     * @example
	     *
	     * var object = { 'a': 1 };
	     *
	     * console.log(_.identity(object) === object);
	     * // => true
	     */
	    function identity(value) {
	      return value;
	    }
	
	    /**
	     * Creates a function that invokes `func` with the arguments of the created
	     * function. If `func` is a property name, the created function returns the
	     * property value for a given element. If `func` is an array or object, the
	     * created function returns `true` for elements that contain the equivalent
	     * source properties, otherwise it returns `false`.
	     *
	     * @static
	     * @since 4.0.0
	     * @memberOf _
	     * @category Util
	     * @param {*} [func=_.identity] The value to convert to a callback.
	     * @returns {Function} Returns the callback.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney', 'age': 36, 'active': true },
	     *   { 'user': 'fred',   'age': 40, 'active': false }
	     * ];
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.filter(users, _.iteratee({ 'user': 'barney', 'active': true }));
	     * // => [{ 'user': 'barney', 'age': 36, 'active': true }]
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.filter(users, _.iteratee(['user', 'fred']));
	     * // => [{ 'user': 'fred', 'age': 40 }]
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.map(users, _.iteratee('user'));
	     * // => ['barney', 'fred']
	     *
	     * // Create custom iteratee shorthands.
	     * _.iteratee = _.wrap(_.iteratee, function(iteratee, func) {
	     *   return !_.isRegExp(func) ? iteratee(func) : function(string) {
	     *     return func.test(string);
	     *   };
	     * });
	     *
	     * _.filter(['abc', 'def'], /ef/);
	     * // => ['def']
	     */
	    function iteratee(func) {
	      return baseIteratee(typeof func == 'function' ? func : baseClone(func, CLONE_DEEP_FLAG));
	    }
	
	    /**
	     * Creates a function that performs a partial deep comparison between a given
	     * object and `source`, returning `true` if the given object has equivalent
	     * property values, else `false`.
	     *
	     * **Note:** The created function is equivalent to `_.isMatch` with `source`
	     * partially applied.
	     *
	     * Partial comparisons will match empty array and empty object `source`
	     * values against any array or object value, respectively. See `_.isEqual`
	     * for a list of supported value comparisons.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Util
	     * @param {Object} source The object of property values to match.
	     * @returns {Function} Returns the new spec function.
	     * @example
	     *
	     * var objects = [
	     *   { 'a': 1, 'b': 2, 'c': 3 },
	     *   { 'a': 4, 'b': 5, 'c': 6 }
	     * ];
	     *
	     * _.filter(objects, _.matches({ 'a': 4, 'c': 6 }));
	     * // => [{ 'a': 4, 'b': 5, 'c': 6 }]
	     */
	    function matches(source) {
	      return baseMatches(baseClone(source, CLONE_DEEP_FLAG));
	    }
	
	    /**
	     * Creates a function that performs a partial deep comparison between the
	     * value at `path` of a given object to `srcValue`, returning `true` if the
	     * object value is equivalent, else `false`.
	     *
	     * **Note:** Partial comparisons will match empty array and empty object
	     * `srcValue` values against any array or object value, respectively. See
	     * `_.isEqual` for a list of supported value comparisons.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.2.0
	     * @category Util
	     * @param {Array|string} path The path of the property to get.
	     * @param {*} srcValue The value to match.
	     * @returns {Function} Returns the new spec function.
	     * @example
	     *
	     * var objects = [
	     *   { 'a': 1, 'b': 2, 'c': 3 },
	     *   { 'a': 4, 'b': 5, 'c': 6 }
	     * ];
	     *
	     * _.find(objects, _.matchesProperty('a', 4));
	     * // => { 'a': 4, 'b': 5, 'c': 6 }
	     */
	    function matchesProperty(path, srcValue) {
	      return baseMatchesProperty(path, baseClone(srcValue, CLONE_DEEP_FLAG));
	    }
	
	    /**
	     * Creates a function that invokes the method at `path` of a given object.
	     * Any additional arguments are provided to the invoked method.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.7.0
	     * @category Util
	     * @param {Array|string} path The path of the method to invoke.
	     * @param {...*} [args] The arguments to invoke the method with.
	     * @returns {Function} Returns the new invoker function.
	     * @example
	     *
	     * var objects = [
	     *   { 'a': { 'b': _.constant(2) } },
	     *   { 'a': { 'b': _.constant(1) } }
	     * ];
	     *
	     * _.map(objects, _.method('a.b'));
	     * // => [2, 1]
	     *
	     * _.map(objects, _.method(['a', 'b']));
	     * // => [2, 1]
	     */
	    var method = baseRest(function(path, args) {
	      return function(object) {
	        return baseInvoke(object, path, args);
	      };
	    });
	
	    /**
	     * The opposite of `_.method`; this method creates a function that invokes
	     * the method at a given path of `object`. Any additional arguments are
	     * provided to the invoked method.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.7.0
	     * @category Util
	     * @param {Object} object The object to query.
	     * @param {...*} [args] The arguments to invoke the method with.
	     * @returns {Function} Returns the new invoker function.
	     * @example
	     *
	     * var array = _.times(3, _.constant),
	     *     object = { 'a': array, 'b': array, 'c': array };
	     *
	     * _.map(['a[2]', 'c[0]'], _.methodOf(object));
	     * // => [2, 0]
	     *
	     * _.map([['a', '2'], ['c', '0']], _.methodOf(object));
	     * // => [2, 0]
	     */
	    var methodOf = baseRest(function(object, args) {
	      return function(path) {
	        return baseInvoke(object, path, args);
	      };
	    });
	
	    /**
	     * Adds all own enumerable string keyed function properties of a source
	     * object to the destination object. If `object` is a function, then methods
	     * are added to its prototype as well.
	     *
	     * **Note:** Use `_.runInContext` to create a pristine `lodash` function to
	     * avoid conflicts caused by modifying the original.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Util
	     * @param {Function|Object} [object=lodash] The destination object.
	     * @param {Object} source The object of functions to add.
	     * @param {Object} [options={}] The options object.
	     * @param {boolean} [options.chain=true] Specify whether mixins are chainable.
	     * @returns {Function|Object} Returns `object`.
	     * @example
	     *
	     * function vowels(string) {
	     *   return _.filter(string, function(v) {
	     *     return /[aeiou]/i.test(v);
	     *   });
	     * }
	     *
	     * _.mixin({ 'vowels': vowels });
	     * _.vowels('fred');
	     * // => ['e']
	     *
	     * _('fred').vowels().value();
	     * // => ['e']
	     *
	     * _.mixin({ 'vowels': vowels }, { 'chain': false });
	     * _('fred').vowels();
	     * // => ['e']
	     */
	    function mixin(object, source, options) {
	      var props = keys(source),
	          methodNames = baseFunctions(source, props);
	
	      if (options == null &&
	          !(isObject(source) && (methodNames.length || !props.length))) {
	        options = source;
	        source = object;
	        object = this;
	        methodNames = baseFunctions(source, keys(source));
	      }
	      var chain = !(isObject(options) && 'chain' in options) || !!options.chain,
	          isFunc = isFunction(object);
	
	      arrayEach(methodNames, function(methodName) {
	        var func = source[methodName];
	        object[methodName] = func;
	        if (isFunc) {
	          object.prototype[methodName] = function() {
	            var chainAll = this.__chain__;
	            if (chain || chainAll) {
	              var result = object(this.__wrapped__),
	                  actions = result.__actions__ = copyArray(this.__actions__);
	
	              actions.push({ 'func': func, 'args': arguments, 'thisArg': object });
	              result.__chain__ = chainAll;
	              return result;
	            }
	            return func.apply(object, arrayPush([this.value()], arguments));
	          };
	        }
	      });
	
	      return object;
	    }
	
	    /**
	     * Reverts the `_` variable to its previous value and returns a reference to
	     * the `lodash` function.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Util
	     * @returns {Function} Returns the `lodash` function.
	     * @example
	     *
	     * var lodash = _.noConflict();
	     */
	    function noConflict() {
	      if (root._ === this) {
	        root._ = oldDash;
	      }
	      return this;
	    }
	
	    /**
	     * This method returns `undefined`.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.3.0
	     * @category Util
	     * @example
	     *
	     * _.times(2, _.noop);
	     * // => [undefined, undefined]
	     */
	    function noop() {
	      // No operation performed.
	    }
	
	    /**
	     * Creates a function that gets the argument at index `n`. If `n` is negative,
	     * the nth argument from the end is returned.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {number} [n=0] The index of the argument to return.
	     * @returns {Function} Returns the new pass-thru function.
	     * @example
	     *
	     * var func = _.nthArg(1);
	     * func('a', 'b', 'c', 'd');
	     * // => 'b'
	     *
	     * var func = _.nthArg(-2);
	     * func('a', 'b', 'c', 'd');
	     * // => 'c'
	     */
	    function nthArg(n) {
	      n = toInteger(n);
	      return baseRest(function(args) {
	        return baseNth(args, n);
	      });
	    }
	
	    /**
	     * Creates a function that invokes `iteratees` with the arguments it receives
	     * and returns their results.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {...(Function|Function[])} [iteratees=[_.identity]]
	     *  The iteratees to invoke.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var func = _.over([Math.max, Math.min]);
	     *
	     * func(1, 2, 3, 4);
	     * // => [4, 1]
	     */
	    var over = createOver(arrayMap);
	
	    /**
	     * Creates a function that checks if **all** of the `predicates` return
	     * truthy when invoked with the arguments it receives.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {...(Function|Function[])} [predicates=[_.identity]]
	     *  The predicates to check.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var func = _.overEvery([Boolean, isFinite]);
	     *
	     * func('1');
	     * // => true
	     *
	     * func(null);
	     * // => false
	     *
	     * func(NaN);
	     * // => false
	     */
	    var overEvery = createOver(arrayEvery);
	
	    /**
	     * Creates a function that checks if **any** of the `predicates` return
	     * truthy when invoked with the arguments it receives.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {...(Function|Function[])} [predicates=[_.identity]]
	     *  The predicates to check.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var func = _.overSome([Boolean, isFinite]);
	     *
	     * func('1');
	     * // => true
	     *
	     * func(null);
	     * // => true
	     *
	     * func(NaN);
	     * // => false
	     */
	    var overSome = createOver(arraySome);
	
	    /**
	     * Creates a function that returns the value at `path` of a given object.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.4.0
	     * @category Util
	     * @param {Array|string} path The path of the property to get.
	     * @returns {Function} Returns the new accessor function.
	     * @example
	     *
	     * var objects = [
	     *   { 'a': { 'b': 2 } },
	     *   { 'a': { 'b': 1 } }
	     * ];
	     *
	     * _.map(objects, _.property('a.b'));
	     * // => [2, 1]
	     *
	     * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
	     * // => [1, 2]
	     */
	    function property(path) {
	      return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
	    }
	
	    /**
	     * The opposite of `_.property`; this method creates a function that returns
	     * the value at a given path of `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Util
	     * @param {Object} object The object to query.
	     * @returns {Function} Returns the new accessor function.
	     * @example
	     *
	     * var array = [0, 1, 2],
	     *     object = { 'a': array, 'b': array, 'c': array };
	     *
	     * _.map(['a[2]', 'c[0]'], _.propertyOf(object));
	     * // => [2, 0]
	     *
	     * _.map([['a', '2'], ['c', '0']], _.propertyOf(object));
	     * // => [2, 0]
	     */
	    function propertyOf(object) {
	      return function(path) {
	        return object == null ? undefined : baseGet(object, path);
	      };
	    }
	
	    /**
	     * Creates an array of numbers (positive and/or negative) progressing from
	     * `start` up to, but not including, `end`. A step of `-1` is used if a negative
	     * `start` is specified without an `end` or `step`. If `end` is not specified,
	     * it's set to `start` with `start` then set to `0`.
	     *
	     * **Note:** JavaScript follows the IEEE-754 standard for resolving
	     * floating-point values which can produce unexpected results.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Util
	     * @param {number} [start=0] The start of the range.
	     * @param {number} end The end of the range.
	     * @param {number} [step=1] The value to increment or decrement by.
	     * @returns {Array} Returns the range of numbers.
	     * @see _.inRange, _.rangeRight
	     * @example
	     *
	     * _.range(4);
	     * // => [0, 1, 2, 3]
	     *
	     * _.range(-4);
	     * // => [0, -1, -2, -3]
	     *
	     * _.range(1, 5);
	     * // => [1, 2, 3, 4]
	     *
	     * _.range(0, 20, 5);
	     * // => [0, 5, 10, 15]
	     *
	     * _.range(0, -4, -1);
	     * // => [0, -1, -2, -3]
	     *
	     * _.range(1, 4, 0);
	     * // => [1, 1, 1]
	     *
	     * _.range(0);
	     * // => []
	     */
	    var range = createRange();
	
	    /**
	     * This method is like `_.range` except that it populates values in
	     * descending order.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {number} [start=0] The start of the range.
	     * @param {number} end The end of the range.
	     * @param {number} [step=1] The value to increment or decrement by.
	     * @returns {Array} Returns the range of numbers.
	     * @see _.inRange, _.range
	     * @example
	     *
	     * _.rangeRight(4);
	     * // => [3, 2, 1, 0]
	     *
	     * _.rangeRight(-4);
	     * // => [-3, -2, -1, 0]
	     *
	     * _.rangeRight(1, 5);
	     * // => [4, 3, 2, 1]
	     *
	     * _.rangeRight(0, 20, 5);
	     * // => [15, 10, 5, 0]
	     *
	     * _.rangeRight(0, -4, -1);
	     * // => [-3, -2, -1, 0]
	     *
	     * _.rangeRight(1, 4, 0);
	     * // => [1, 1, 1]
	     *
	     * _.rangeRight(0);
	     * // => []
	     */
	    var rangeRight = createRange(true);
	
	    /**
	     * This method returns a new empty array.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.13.0
	     * @category Util
	     * @returns {Array} Returns the new empty array.
	     * @example
	     *
	     * var arrays = _.times(2, _.stubArray);
	     *
	     * console.log(arrays);
	     * // => [[], []]
	     *
	     * console.log(arrays[0] === arrays[1]);
	     * // => false
	     */
	    function stubArray() {
	      return [];
	    }
	
	    /**
	     * This method returns `false`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.13.0
	     * @category Util
	     * @returns {boolean} Returns `false`.
	     * @example
	     *
	     * _.times(2, _.stubFalse);
	     * // => [false, false]
	     */
	    function stubFalse() {
	      return false;
	    }
	
	    /**
	     * This method returns a new empty object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.13.0
	     * @category Util
	     * @returns {Object} Returns the new empty object.
	     * @example
	     *
	     * var objects = _.times(2, _.stubObject);
	     *
	     * console.log(objects);
	     * // => [{}, {}]
	     *
	     * console.log(objects[0] === objects[1]);
	     * // => false
	     */
	    function stubObject() {
	      return {};
	    }
	
	    /**
	     * This method returns an empty string.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.13.0
	     * @category Util
	     * @returns {string} Returns the empty string.
	     * @example
	     *
	     * _.times(2, _.stubString);
	     * // => ['', '']
	     */
	    function stubString() {
	      return '';
	    }
	
	    /**
	     * This method returns `true`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.13.0
	     * @category Util
	     * @returns {boolean} Returns `true`.
	     * @example
	     *
	     * _.times(2, _.stubTrue);
	     * // => [true, true]
	     */
	    function stubTrue() {
	      return true;
	    }
	
	    /**
	     * Invokes the iteratee `n` times, returning an array of the results of
	     * each invocation. The iteratee is invoked with one argument; (index).
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Util
	     * @param {number} n The number of times to invoke `iteratee`.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the array of results.
	     * @example
	     *
	     * _.times(3, String);
	     * // => ['0', '1', '2']
	     *
	     *  _.times(4, _.constant(0));
	     * // => [0, 0, 0, 0]
	     */
	    function times(n, iteratee) {
	      n = toInteger(n);
	      if (n < 1 || n > MAX_SAFE_INTEGER) {
	        return [];
	      }
	      var index = MAX_ARRAY_LENGTH,
	          length = nativeMin(n, MAX_ARRAY_LENGTH);
	
	      iteratee = getIteratee(iteratee);
	      n -= MAX_ARRAY_LENGTH;
	
	      var result = baseTimes(length, iteratee);
	      while (++index < n) {
	        iteratee(index);
	      }
	      return result;
	    }
	
	    /**
	     * Converts `value` to a property path array.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {*} value The value to convert.
	     * @returns {Array} Returns the new property path array.
	     * @example
	     *
	     * _.toPath('a.b.c');
	     * // => ['a', 'b', 'c']
	     *
	     * _.toPath('a[0].b.c');
	     * // => ['a', '0', 'b', 'c']
	     */
	    function toPath(value) {
	      if (isArray(value)) {
	        return arrayMap(value, toKey);
	      }
	      return isSymbol(value) ? [value] : copyArray(stringToPath(toString(value)));
	    }
	
	    /**
	     * Generates a unique ID. If `prefix` is given, the ID is appended to it.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Util
	     * @param {string} [prefix=''] The value to prefix the ID with.
	     * @returns {string} Returns the unique ID.
	     * @example
	     *
	     * _.uniqueId('contact_');
	     * // => 'contact_104'
	     *
	     * _.uniqueId();
	     * // => '105'
	     */
	    function uniqueId(prefix) {
	      var id = ++idCounter;
	      return toString(prefix) + id;
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Adds two numbers.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.4.0
	     * @category Math
	     * @param {number} augend The first number in an addition.
	     * @param {number} addend The second number in an addition.
	     * @returns {number} Returns the total.
	     * @example
	     *
	     * _.add(6, 4);
	     * // => 10
	     */
	    var add = createMathOperation(function(augend, addend) {
	      return augend + addend;
	    }, 0);
	
	    /**
	     * Computes `number` rounded up to `precision`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.10.0
	     * @category Math
	     * @param {number} number The number to round up.
	     * @param {number} [precision=0] The precision to round up to.
	     * @returns {number} Returns the rounded up number.
	     * @example
	     *
	     * _.ceil(4.006);
	     * // => 5
	     *
	     * _.ceil(6.004, 2);
	     * // => 6.01
	     *
	     * _.ceil(6040, -2);
	     * // => 6100
	     */
	    var ceil = createRound('ceil');
	
	    /**
	     * Divide two numbers.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.7.0
	     * @category Math
	     * @param {number} dividend The first number in a division.
	     * @param {number} divisor The second number in a division.
	     * @returns {number} Returns the quotient.
	     * @example
	     *
	     * _.divide(6, 4);
	     * // => 1.5
	     */
	    var divide = createMathOperation(function(dividend, divisor) {
	      return dividend / divisor;
	    }, 1);
	
	    /**
	     * Computes `number` rounded down to `precision`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.10.0
	     * @category Math
	     * @param {number} number The number to round down.
	     * @param {number} [precision=0] The precision to round down to.
	     * @returns {number} Returns the rounded down number.
	     * @example
	     *
	     * _.floor(4.006);
	     * // => 4
	     *
	     * _.floor(0.046, 2);
	     * // => 0.04
	     *
	     * _.floor(4060, -2);
	     * // => 4000
	     */
	    var floor = createRound('floor');
	
	    /**
	     * Computes the maximum value of `array`. If `array` is empty or falsey,
	     * `undefined` is returned.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @returns {*} Returns the maximum value.
	     * @example
	     *
	     * _.max([4, 2, 8, 6]);
	     * // => 8
	     *
	     * _.max([]);
	     * // => undefined
	     */
	    function max(array) {
	      return (array && array.length)
	        ? baseExtremum(array, identity, baseGt)
	        : undefined;
	    }
	
	    /**
	     * This method is like `_.max` except that it accepts `iteratee` which is
	     * invoked for each element in `array` to generate the criterion by which
	     * the value is ranked. The iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {*} Returns the maximum value.
	     * @example
	     *
	     * var objects = [{ 'n': 1 }, { 'n': 2 }];
	     *
	     * _.maxBy(objects, function(o) { return o.n; });
	     * // => { 'n': 2 }
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.maxBy(objects, 'n');
	     * // => { 'n': 2 }
	     */
	    function maxBy(array, iteratee) {
	      return (array && array.length)
	        ? baseExtremum(array, getIteratee(iteratee, 2), baseGt)
	        : undefined;
	    }
	
	    /**
	     * Computes the mean of the values in `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @returns {number} Returns the mean.
	     * @example
	     *
	     * _.mean([4, 2, 8, 6]);
	     * // => 5
	     */
	    function mean(array) {
	      return baseMean(array, identity);
	    }
	
	    /**
	     * This method is like `_.mean` except that it accepts `iteratee` which is
	     * invoked for each element in `array` to generate the value to be averaged.
	     * The iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.7.0
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {number} Returns the mean.
	     * @example
	     *
	     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
	     *
	     * _.meanBy(objects, function(o) { return o.n; });
	     * // => 5
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.meanBy(objects, 'n');
	     * // => 5
	     */
	    function meanBy(array, iteratee) {
	      return baseMean(array, getIteratee(iteratee, 2));
	    }
	
	    /**
	     * Computes the minimum value of `array`. If `array` is empty or falsey,
	     * `undefined` is returned.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @returns {*} Returns the minimum value.
	     * @example
	     *
	     * _.min([4, 2, 8, 6]);
	     * // => 2
	     *
	     * _.min([]);
	     * // => undefined
	     */
	    function min(array) {
	      return (array && array.length)
	        ? baseExtremum(array, identity, baseLt)
	        : undefined;
	    }
	
	    /**
	     * This method is like `_.min` except that it accepts `iteratee` which is
	     * invoked for each element in `array` to generate the criterion by which
	     * the value is ranked. The iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {*} Returns the minimum value.
	     * @example
	     *
	     * var objects = [{ 'n': 1 }, { 'n': 2 }];
	     *
	     * _.minBy(objects, function(o) { return o.n; });
	     * // => { 'n': 1 }
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.minBy(objects, 'n');
	     * // => { 'n': 1 }
	     */
	    function minBy(array, iteratee) {
	      return (array && array.length)
	        ? baseExtremum(array, getIteratee(iteratee, 2), baseLt)
	        : undefined;
	    }
	
	    /**
	     * Multiply two numbers.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.7.0
	     * @category Math
	     * @param {number} multiplier The first number in a multiplication.
	     * @param {number} multiplicand The second number in a multiplication.
	     * @returns {number} Returns the product.
	     * @example
	     *
	     * _.multiply(6, 4);
	     * // => 24
	     */
	    var multiply = createMathOperation(function(multiplier, multiplicand) {
	      return multiplier * multiplicand;
	    }, 1);
	
	    /**
	     * Computes `number` rounded to `precision`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.10.0
	     * @category Math
	     * @param {number} number The number to round.
	     * @param {number} [precision=0] The precision to round to.
	     * @returns {number} Returns the rounded number.
	     * @example
	     *
	     * _.round(4.006);
	     * // => 4
	     *
	     * _.round(4.006, 2);
	     * // => 4.01
	     *
	     * _.round(4060, -2);
	     * // => 4100
	     */
	    var round = createRound('round');
	
	    /**
	     * Subtract two numbers.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Math
	     * @param {number} minuend The first number in a subtraction.
	     * @param {number} subtrahend The second number in a subtraction.
	     * @returns {number} Returns the difference.
	     * @example
	     *
	     * _.subtract(6, 4);
	     * // => 2
	     */
	    var subtract = createMathOperation(function(minuend, subtrahend) {
	      return minuend - subtrahend;
	    }, 0);
	
	    /**
	     * Computes the sum of the values in `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.4.0
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @returns {number} Returns the sum.
	     * @example
	     *
	     * _.sum([4, 2, 8, 6]);
	     * // => 20
	     */
	    function sum(array) {
	      return (array && array.length)
	        ? baseSum(array, identity)
	        : 0;
	    }
	
	    /**
	     * This method is like `_.sum` except that it accepts `iteratee` which is
	     * invoked for each element in `array` to generate the value to be summed.
	     * The iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {number} Returns the sum.
	     * @example
	     *
	     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
	     *
	     * _.sumBy(objects, function(o) { return o.n; });
	     * // => 20
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.sumBy(objects, 'n');
	     * // => 20
	     */
	    function sumBy(array, iteratee) {
	      return (array && array.length)
	        ? baseSum(array, getIteratee(iteratee, 2))
	        : 0;
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    // Add methods that return wrapped values in chain sequences.
	    lodash.after = after;
	    lodash.ary = ary;
	    lodash.assign = assign;
	    lodash.assignIn = assignIn;
	    lodash.assignInWith = assignInWith;
	    lodash.assignWith = assignWith;
	    lodash.at = at;
	    lodash.before = before;
	    lodash.bind = bind;
	    lodash.bindAll = bindAll;
	    lodash.bindKey = bindKey;
	    lodash.castArray = castArray;
	    lodash.chain = chain;
	    lodash.chunk = chunk;
	    lodash.compact = compact;
	    lodash.concat = concat;
	    lodash.cond = cond;
	    lodash.conforms = conforms;
	    lodash.constant = constant;
	    lodash.countBy = countBy;
	    lodash.create = create;
	    lodash.curry = curry;
	    lodash.curryRight = curryRight;
	    lodash.debounce = debounce;
	    lodash.defaults = defaults;
	    lodash.defaultsDeep = defaultsDeep;
	    lodash.defer = defer;
	    lodash.delay = delay;
	    lodash.difference = difference;
	    lodash.differenceBy = differenceBy;
	    lodash.differenceWith = differenceWith;
	    lodash.drop = drop;
	    lodash.dropRight = dropRight;
	    lodash.dropRightWhile = dropRightWhile;
	    lodash.dropWhile = dropWhile;
	    lodash.fill = fill;
	    lodash.filter = filter;
	    lodash.flatMap = flatMap;
	    lodash.flatMapDeep = flatMapDeep;
	    lodash.flatMapDepth = flatMapDepth;
	    lodash.flatten = flatten;
	    lodash.flattenDeep = flattenDeep;
	    lodash.flattenDepth = flattenDepth;
	    lodash.flip = flip;
	    lodash.flow = flow;
	    lodash.flowRight = flowRight;
	    lodash.fromPairs = fromPairs;
	    lodash.functions = functions;
	    lodash.functionsIn = functionsIn;
	    lodash.groupBy = groupBy;
	    lodash.initial = initial;
	    lodash.intersection = intersection;
	    lodash.intersectionBy = intersectionBy;
	    lodash.intersectionWith = intersectionWith;
	    lodash.invert = invert;
	    lodash.invertBy = invertBy;
	    lodash.invokeMap = invokeMap;
	    lodash.iteratee = iteratee;
	    lodash.keyBy = keyBy;
	    lodash.keys = keys;
	    lodash.keysIn = keysIn;
	    lodash.map = map;
	    lodash.mapKeys = mapKeys;
	    lodash.mapValues = mapValues;
	    lodash.matches = matches;
	    lodash.matchesProperty = matchesProperty;
	    lodash.memoize = memoize;
	    lodash.merge = merge;
	    lodash.mergeWith = mergeWith;
	    lodash.method = method;
	    lodash.methodOf = methodOf;
	    lodash.mixin = mixin;
	    lodash.negate = negate;
	    lodash.nthArg = nthArg;
	    lodash.omit = omit;
	    lodash.omitBy = omitBy;
	    lodash.once = once;
	    lodash.orderBy = orderBy;
	    lodash.over = over;
	    lodash.overArgs = overArgs;
	    lodash.overEvery = overEvery;
	    lodash.overSome = overSome;
	    lodash.partial = partial;
	    lodash.partialRight = partialRight;
	    lodash.partition = partition;
	    lodash.pick = pick;
	    lodash.pickBy = pickBy;
	    lodash.property = property;
	    lodash.propertyOf = propertyOf;
	    lodash.pull = pull;
	    lodash.pullAll = pullAll;
	    lodash.pullAllBy = pullAllBy;
	    lodash.pullAllWith = pullAllWith;
	    lodash.pullAt = pullAt;
	    lodash.range = range;
	    lodash.rangeRight = rangeRight;
	    lodash.rearg = rearg;
	    lodash.reject = reject;
	    lodash.remove = remove;
	    lodash.rest = rest;
	    lodash.reverse = reverse;
	    lodash.sampleSize = sampleSize;
	    lodash.set = set;
	    lodash.setWith = setWith;
	    lodash.shuffle = shuffle;
	    lodash.slice = slice;
	    lodash.sortBy = sortBy;
	    lodash.sortedUniq = sortedUniq;
	    lodash.sortedUniqBy = sortedUniqBy;
	    lodash.split = split;
	    lodash.spread = spread;
	    lodash.tail = tail;
	    lodash.take = take;
	    lodash.takeRight = takeRight;
	    lodash.takeRightWhile = takeRightWhile;
	    lodash.takeWhile = takeWhile;
	    lodash.tap = tap;
	    lodash.throttle = throttle;
	    lodash.thru = thru;
	    lodash.toArray = toArray;
	    lodash.toPairs = toPairs;
	    lodash.toPairsIn = toPairsIn;
	    lodash.toPath = toPath;
	    lodash.toPlainObject = toPlainObject;
	    lodash.transform = transform;
	    lodash.unary = unary;
	    lodash.union = union;
	    lodash.unionBy = unionBy;
	    lodash.unionWith = unionWith;
	    lodash.uniq = uniq;
	    lodash.uniqBy = uniqBy;
	    lodash.uniqWith = uniqWith;
	    lodash.unset = unset;
	    lodash.unzip = unzip;
	    lodash.unzipWith = unzipWith;
	    lodash.update = update;
	    lodash.updateWith = updateWith;
	    lodash.values = values;
	    lodash.valuesIn = valuesIn;
	    lodash.without = without;
	    lodash.words = words;
	    lodash.wrap = wrap;
	    lodash.xor = xor;
	    lodash.xorBy = xorBy;
	    lodash.xorWith = xorWith;
	    lodash.zip = zip;
	    lodash.zipObject = zipObject;
	    lodash.zipObjectDeep = zipObjectDeep;
	    lodash.zipWith = zipWith;
	
	    // Add aliases.
	    lodash.entries = toPairs;
	    lodash.entriesIn = toPairsIn;
	    lodash.extend = assignIn;
	    lodash.extendWith = assignInWith;
	
	    // Add methods to `lodash.prototype`.
	    mixin(lodash, lodash);
	
	    /*------------------------------------------------------------------------*/
	
	    // Add methods that return unwrapped values in chain sequences.
	    lodash.add = add;
	    lodash.attempt = attempt;
	    lodash.camelCase = camelCase;
	    lodash.capitalize = capitalize;
	    lodash.ceil = ceil;
	    lodash.clamp = clamp;
	    lodash.clone = clone;
	    lodash.cloneDeep = cloneDeep;
	    lodash.cloneDeepWith = cloneDeepWith;
	    lodash.cloneWith = cloneWith;
	    lodash.conformsTo = conformsTo;
	    lodash.deburr = deburr;
	    lodash.defaultTo = defaultTo;
	    lodash.divide = divide;
	    lodash.endsWith = endsWith;
	    lodash.eq = eq;
	    lodash.escape = escape;
	    lodash.escapeRegExp = escapeRegExp;
	    lodash.every = every;
	    lodash.find = find;
	    lodash.findIndex = findIndex;
	    lodash.findKey = findKey;
	    lodash.findLast = findLast;
	    lodash.findLastIndex = findLastIndex;
	    lodash.findLastKey = findLastKey;
	    lodash.floor = floor;
	    lodash.forEach = forEach;
	    lodash.forEachRight = forEachRight;
	    lodash.forIn = forIn;
	    lodash.forInRight = forInRight;
	    lodash.forOwn = forOwn;
	    lodash.forOwnRight = forOwnRight;
	    lodash.get = get;
	    lodash.gt = gt;
	    lodash.gte = gte;
	    lodash.has = has;
	    lodash.hasIn = hasIn;
	    lodash.head = head;
	    lodash.identity = identity;
	    lodash.includes = includes;
	    lodash.indexOf = indexOf;
	    lodash.inRange = inRange;
	    lodash.invoke = invoke;
	    lodash.isArguments = isArguments;
	    lodash.isArray = isArray;
	    lodash.isArrayBuffer = isArrayBuffer;
	    lodash.isArrayLike = isArrayLike;
	    lodash.isArrayLikeObject = isArrayLikeObject;
	    lodash.isBoolean = isBoolean;
	    lodash.isBuffer = isBuffer;
	    lodash.isDate = isDate;
	    lodash.isElement = isElement;
	    lodash.isEmpty = isEmpty;
	    lodash.isEqual = isEqual;
	    lodash.isEqualWith = isEqualWith;
	    lodash.isError = isError;
	    lodash.isFinite = isFinite;
	    lodash.isFunction = isFunction;
	    lodash.isInteger = isInteger;
	    lodash.isLength = isLength;
	    lodash.isMap = isMap;
	    lodash.isMatch = isMatch;
	    lodash.isMatchWith = isMatchWith;
	    lodash.isNaN = isNaN;
	    lodash.isNative = isNative;
	    lodash.isNil = isNil;
	    lodash.isNull = isNull;
	    lodash.isNumber = isNumber;
	    lodash.isObject = isObject;
	    lodash.isObjectLike = isObjectLike;
	    lodash.isPlainObject = isPlainObject;
	    lodash.isRegExp = isRegExp;
	    lodash.isSafeInteger = isSafeInteger;
	    lodash.isSet = isSet;
	    lodash.isString = isString;
	    lodash.isSymbol = isSymbol;
	    lodash.isTypedArray = isTypedArray;
	    lodash.isUndefined = isUndefined;
	    lodash.isWeakMap = isWeakMap;
	    lodash.isWeakSet = isWeakSet;
	    lodash.join = join;
	    lodash.kebabCase = kebabCase;
	    lodash.last = last;
	    lodash.lastIndexOf = lastIndexOf;
	    lodash.lowerCase = lowerCase;
	    lodash.lowerFirst = lowerFirst;
	    lodash.lt = lt;
	    lodash.lte = lte;
	    lodash.max = max;
	    lodash.maxBy = maxBy;
	    lodash.mean = mean;
	    lodash.meanBy = meanBy;
	    lodash.min = min;
	    lodash.minBy = minBy;
	    lodash.stubArray = stubArray;
	    lodash.stubFalse = stubFalse;
	    lodash.stubObject = stubObject;
	    lodash.stubString = stubString;
	    lodash.stubTrue = stubTrue;
	    lodash.multiply = multiply;
	    lodash.nth = nth;
	    lodash.noConflict = noConflict;
	    lodash.noop = noop;
	    lodash.now = now;
	    lodash.pad = pad;
	    lodash.padEnd = padEnd;
	    lodash.padStart = padStart;
	    lodash.parseInt = parseInt;
	    lodash.random = random;
	    lodash.reduce = reduce;
	    lodash.reduceRight = reduceRight;
	    lodash.repeat = repeat;
	    lodash.replace = replace;
	    lodash.result = result;
	    lodash.round = round;
	    lodash.runInContext = runInContext;
	    lodash.sample = sample;
	    lodash.size = size;
	    lodash.snakeCase = snakeCase;
	    lodash.some = some;
	    lodash.sortedIndex = sortedIndex;
	    lodash.sortedIndexBy = sortedIndexBy;
	    lodash.sortedIndexOf = sortedIndexOf;
	    lodash.sortedLastIndex = sortedLastIndex;
	    lodash.sortedLastIndexBy = sortedLastIndexBy;
	    lodash.sortedLastIndexOf = sortedLastIndexOf;
	    lodash.startCase = startCase;
	    lodash.startsWith = startsWith;
	    lodash.subtract = subtract;
	    lodash.sum = sum;
	    lodash.sumBy = sumBy;
	    lodash.template = template;
	    lodash.times = times;
	    lodash.toFinite = toFinite;
	    lodash.toInteger = toInteger;
	    lodash.toLength = toLength;
	    lodash.toLower = toLower;
	    lodash.toNumber = toNumber;
	    lodash.toSafeInteger = toSafeInteger;
	    lodash.toString = toString;
	    lodash.toUpper = toUpper;
	    lodash.trim = trim;
	    lodash.trimEnd = trimEnd;
	    lodash.trimStart = trimStart;
	    lodash.truncate = truncate;
	    lodash.unescape = unescape;
	    lodash.uniqueId = uniqueId;
	    lodash.upperCase = upperCase;
	    lodash.upperFirst = upperFirst;
	
	    // Add aliases.
	    lodash.each = forEach;
	    lodash.eachRight = forEachRight;
	    lodash.first = head;
	
	    mixin(lodash, (function() {
	      var source = {};
	      baseForOwn(lodash, function(func, methodName) {
	        if (!hasOwnProperty.call(lodash.prototype, methodName)) {
	          source[methodName] = func;
	        }
	      });
	      return source;
	    }()), { 'chain': false });
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * The semantic version number.
	     *
	     * @static
	     * @memberOf _
	     * @type {string}
	     */
	    lodash.VERSION = VERSION;
	
	    // Assign default placeholders.
	    arrayEach(['bind', 'bindKey', 'curry', 'curryRight', 'partial', 'partialRight'], function(methodName) {
	      lodash[methodName].placeholder = lodash;
	    });
	
	    // Add `LazyWrapper` methods for `_.drop` and `_.take` variants.
	    arrayEach(['drop', 'take'], function(methodName, index) {
	      LazyWrapper.prototype[methodName] = function(n) {
	        n = n === undefined ? 1 : nativeMax(toInteger(n), 0);
	
	        var result = (this.__filtered__ && !index)
	          ? new LazyWrapper(this)
	          : this.clone();
	
	        if (result.__filtered__) {
	          result.__takeCount__ = nativeMin(n, result.__takeCount__);
	        } else {
	          result.__views__.push({
	            'size': nativeMin(n, MAX_ARRAY_LENGTH),
	            'type': methodName + (result.__dir__ < 0 ? 'Right' : '')
	          });
	        }
	        return result;
	      };
	
	      LazyWrapper.prototype[methodName + 'Right'] = function(n) {
	        return this.reverse()[methodName](n).reverse();
	      };
	    });
	
	    // Add `LazyWrapper` methods that accept an `iteratee` value.
	    arrayEach(['filter', 'map', 'takeWhile'], function(methodName, index) {
	      var type = index + 1,
	          isFilter = type == LAZY_FILTER_FLAG || type == LAZY_WHILE_FLAG;
	
	      LazyWrapper.prototype[methodName] = function(iteratee) {
	        var result = this.clone();
	        result.__iteratees__.push({
	          'iteratee': getIteratee(iteratee, 3),
	          'type': type
	        });
	        result.__filtered__ = result.__filtered__ || isFilter;
	        return result;
	      };
	    });
	
	    // Add `LazyWrapper` methods for `_.head` and `_.last`.
	    arrayEach(['head', 'last'], function(methodName, index) {
	      var takeName = 'take' + (index ? 'Right' : '');
	
	      LazyWrapper.prototype[methodName] = function() {
	        return this[takeName](1).value()[0];
	      };
	    });
	
	    // Add `LazyWrapper` methods for `_.initial` and `_.tail`.
	    arrayEach(['initial', 'tail'], function(methodName, index) {
	      var dropName = 'drop' + (index ? '' : 'Right');
	
	      LazyWrapper.prototype[methodName] = function() {
	        return this.__filtered__ ? new LazyWrapper(this) : this[dropName](1);
	      };
	    });
	
	    LazyWrapper.prototype.compact = function() {
	      return this.filter(identity);
	    };
	
	    LazyWrapper.prototype.find = function(predicate) {
	      return this.filter(predicate).head();
	    };
	
	    LazyWrapper.prototype.findLast = function(predicate) {
	      return this.reverse().find(predicate);
	    };
	
	    LazyWrapper.prototype.invokeMap = baseRest(function(path, args) {
	      if (typeof path == 'function') {
	        return new LazyWrapper(this);
	      }
	      return this.map(function(value) {
	        return baseInvoke(value, path, args);
	      });
	    });
	
	    LazyWrapper.prototype.reject = function(predicate) {
	      return this.filter(negate(getIteratee(predicate)));
	    };
	
	    LazyWrapper.prototype.slice = function(start, end) {
	      start = toInteger(start);
	
	      var result = this;
	      if (result.__filtered__ && (start > 0 || end < 0)) {
	        return new LazyWrapper(result);
	      }
	      if (start < 0) {
	        result = result.takeRight(-start);
	      } else if (start) {
	        result = result.drop(start);
	      }
	      if (end !== undefined) {
	        end = toInteger(end);
	        result = end < 0 ? result.dropRight(-end) : result.take(end - start);
	      }
	      return result;
	    };
	
	    LazyWrapper.prototype.takeRightWhile = function(predicate) {
	      return this.reverse().takeWhile(predicate).reverse();
	    };
	
	    LazyWrapper.prototype.toArray = function() {
	      return this.take(MAX_ARRAY_LENGTH);
	    };
	
	    // Add `LazyWrapper` methods to `lodash.prototype`.
	    baseForOwn(LazyWrapper.prototype, function(func, methodName) {
	      var checkIteratee = /^(?:filter|find|map|reject)|While$/.test(methodName),
	          isTaker = /^(?:head|last)$/.test(methodName),
	          lodashFunc = lodash[isTaker ? ('take' + (methodName == 'last' ? 'Right' : '')) : methodName],
	          retUnwrapped = isTaker || /^find/.test(methodName);
	
	      if (!lodashFunc) {
	        return;
	      }
	      lodash.prototype[methodName] = function() {
	        var value = this.__wrapped__,
	            args = isTaker ? [1] : arguments,
	            isLazy = value instanceof LazyWrapper,
	            iteratee = args[0],
	            useLazy = isLazy || isArray(value);
	
	        var interceptor = function(value) {
	          var result = lodashFunc.apply(lodash, arrayPush([value], args));
	          return (isTaker && chainAll) ? result[0] : result;
	        };
	
	        if (useLazy && checkIteratee && typeof iteratee == 'function' && iteratee.length != 1) {
	          // Avoid lazy use if the iteratee has a "length" value other than `1`.
	          isLazy = useLazy = false;
	        }
	        var chainAll = this.__chain__,
	            isHybrid = !!this.__actions__.length,
	            isUnwrapped = retUnwrapped && !chainAll,
	            onlyLazy = isLazy && !isHybrid;
	
	        if (!retUnwrapped && useLazy) {
	          value = onlyLazy ? value : new LazyWrapper(this);
	          var result = func.apply(value, args);
	          result.__actions__.push({ 'func': thru, 'args': [interceptor], 'thisArg': undefined });
	          return new LodashWrapper(result, chainAll);
	        }
	        if (isUnwrapped && onlyLazy) {
	          return func.apply(this, args);
	        }
	        result = this.thru(interceptor);
	        return isUnwrapped ? (isTaker ? result.value()[0] : result.value()) : result;
	      };
	    });
	
	    // Add `Array` methods to `lodash.prototype`.
	    arrayEach(['pop', 'push', 'shift', 'sort', 'splice', 'unshift'], function(methodName) {
	      var func = arrayProto[methodName],
	          chainName = /^(?:push|sort|unshift)$/.test(methodName) ? 'tap' : 'thru',
	          retUnwrapped = /^(?:pop|shift)$/.test(methodName);
	
	      lodash.prototype[methodName] = function() {
	        var args = arguments;
	        if (retUnwrapped && !this.__chain__) {
	          var value = this.value();
	          return func.apply(isArray(value) ? value : [], args);
	        }
	        return this[chainName](function(value) {
	          return func.apply(isArray(value) ? value : [], args);
	        });
	      };
	    });
	
	    // Map minified method names to their real names.
	    baseForOwn(LazyWrapper.prototype, function(func, methodName) {
	      var lodashFunc = lodash[methodName];
	      if (lodashFunc) {
	        var key = lodashFunc.name + '';
	        if (!hasOwnProperty.call(realNames, key)) {
	          realNames[key] = [];
	        }
	        realNames[key].push({ 'name': methodName, 'func': lodashFunc });
	      }
	    });
	
	    realNames[createHybrid(undefined, WRAP_BIND_KEY_FLAG).name] = [{
	      'name': 'wrapper',
	      'func': undefined
	    }];
	
	    // Add methods to `LazyWrapper`.
	    LazyWrapper.prototype.clone = lazyClone;
	    LazyWrapper.prototype.reverse = lazyReverse;
	    LazyWrapper.prototype.value = lazyValue;
	
	    // Add chain sequence methods to the `lodash` wrapper.
	    lodash.prototype.at = wrapperAt;
	    lodash.prototype.chain = wrapperChain;
	    lodash.prototype.commit = wrapperCommit;
	    lodash.prototype.next = wrapperNext;
	    lodash.prototype.plant = wrapperPlant;
	    lodash.prototype.reverse = wrapperReverse;
	    lodash.prototype.toJSON = lodash.prototype.valueOf = lodash.prototype.value = wrapperValue;
	
	    // Add lazy aliases.
	    lodash.prototype.first = lodash.prototype.head;
	
	    if (symIterator) {
	      lodash.prototype[symIterator] = wrapperToIterator;
	    }
	    return lodash;
	  });
	
	  /*--------------------------------------------------------------------------*/
	
	  // Export lodash.
	  var _ = runInContext();
	
	  // Some AMD build optimizers, like r.js, check for condition patterns like:
	  if (true) {
	    // Expose Lodash on the global object to prevent errors when Lodash is
	    // loaded by a script tag in the presence of an AMD loader.
	    // See http://requirejs.org/docs/errors.html#mismatch for more details.
	    // Use `_.noConflict` to remove Lodash from the global object.
	    root._ = _;
	
	    // Define as an anonymous module so, through path mapping, it can be
	    // referenced as the "underscore" module.
	    !(__WEBPACK_AMD_DEFINE_RESULT__ = function() {
	      return _;
	    }.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  }
	  // Check for `exports` after `define` in case a build optimizer adds it.
	  else if (freeModule) {
	    // Export for Node.js.
	    (freeModule.exports = _)._ = _;
	    // Export for CommonJS support.
	    freeExports._ = _;
	  }
	  else {
	    // Export to the global object.
	    root._ = _;
	  }
	}.call(this));
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }()), __webpack_require__(154)(module)))

/***/ },
/* 1265 */
/***/ function(module, exports, __webpack_require__) {

	var MapCache = __webpack_require__(310);
	
	/** Error message constants. */
	var FUNC_ERROR_TEXT = 'Expected a function';
	
	/**
	 * Creates a function that memoizes the result of `func`. If `resolver` is
	 * provided, it determines the cache key for storing the result based on the
	 * arguments provided to the memoized function. By default, the first argument
	 * provided to the memoized function is used as the map cache key. The `func`
	 * is invoked with the `this` binding of the memoized function.
	 *
	 * **Note:** The cache is exposed as the `cache` property on the memoized
	 * function. Its creation may be customized by replacing the `_.memoize.Cache`
	 * constructor with one whose instances implement the
	 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
	 * method interface of `clear`, `delete`, `get`, `has`, and `set`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Function
	 * @param {Function} func The function to have its output memoized.
	 * @param {Function} [resolver] The function to resolve the cache key.
	 * @returns {Function} Returns the new memoized function.
	 * @example
	 *
	 * var object = { 'a': 1, 'b': 2 };
	 * var other = { 'c': 3, 'd': 4 };
	 *
	 * var values = _.memoize(_.values);
	 * values(object);
	 * // => [1, 2]
	 *
	 * values(other);
	 * // => [3, 4]
	 *
	 * object.a = 2;
	 * values(object);
	 * // => [1, 2]
	 *
	 * // Modify the result cache.
	 * values.cache.set(object, ['a', 'b']);
	 * values(object);
	 * // => ['a', 'b']
	 *
	 * // Replace `_.memoize.Cache`.
	 * _.memoize.Cache = WeakMap;
	 */
	function memoize(func, resolver) {
	  if (typeof func != 'function' || (resolver != null && typeof resolver != 'function')) {
	    throw new TypeError(FUNC_ERROR_TEXT);
	  }
	  var memoized = function() {
	    var args = arguments,
	        key = resolver ? resolver.apply(this, args) : args[0],
	        cache = memoized.cache;
	
	    if (cache.has(key)) {
	      return cache.get(key);
	    }
	    var result = func.apply(this, args);
	    memoized.cache = cache.set(key, result) || cache;
	    return result;
	  };
	  memoized.cache = new (memoize.Cache || MapCache);
	  return memoized;
	}
	
	// Expose `MapCache`.
	memoize.Cache = MapCache;
	
	module.exports = memoize;


/***/ },
/* 1266 */
/***/ function(module, exports, __webpack_require__) {

	var root = __webpack_require__(69);
	
	/**
	 * Gets the timestamp of the number of milliseconds that have elapsed since
	 * the Unix epoch (1 January 1970 00:00:00 UTC).
	 *
	 * @static
	 * @memberOf _
	 * @since 2.4.0
	 * @category Date
	 * @returns {number} Returns the timestamp.
	 * @example
	 *
	 * _.defer(function(stamp) {
	 *   console.log(_.now() - stamp);
	 * }, _.now());
	 * // => Logs the number of milliseconds it took for the deferred invocation.
	 */
	var now = function() {
	  return root.Date.now();
	};
	
	module.exports = now;


/***/ },
/* 1267 */
/***/ function(module, exports, __webpack_require__) {

	var baseProperty = __webpack_require__(1210),
	    basePropertyDeep = __webpack_require__(1211),
	    isKey = __webpack_require__(311),
	    toKey = __webpack_require__(206);
	
	/**
	 * Creates a function that returns the value at `path` of a given object.
	 *
	 * @static
	 * @memberOf _
	 * @since 2.4.0
	 * @category Util
	 * @param {Array|string} path The path of the property to get.
	 * @returns {Function} Returns the new accessor function.
	 * @example
	 *
	 * var objects = [
	 *   { 'a': { 'b': 2 } },
	 *   { 'a': { 'b': 1 } }
	 * ];
	 *
	 * _.map(objects, _.property('a.b'));
	 * // => [2, 1]
	 *
	 * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
	 * // => [1, 2]
	 */
	function property(path) {
	  return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
	}
	
	module.exports = property;


/***/ },
/* 1268 */
/***/ function(module, exports) {

	/**
	 * This method returns a new empty array.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.13.0
	 * @category Util
	 * @returns {Array} Returns the new empty array.
	 * @example
	 *
	 * var arrays = _.times(2, _.stubArray);
	 *
	 * console.log(arrays);
	 * // => [[], []]
	 *
	 * console.log(arrays[0] === arrays[1]);
	 * // => false
	 */
	function stubArray() {
	  return [];
	}
	
	module.exports = stubArray;


/***/ },
/* 1269 */
/***/ function(module, exports) {

	/**
	 * This method returns `false`.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.13.0
	 * @category Util
	 * @returns {boolean} Returns `false`.
	 * @example
	 *
	 * _.times(2, _.stubFalse);
	 * // => [false, false]
	 */
	function stubFalse() {
	  return false;
	}
	
	module.exports = stubFalse;


/***/ },
/* 1270 */
/***/ function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(151),
	    isSymbol = __webpack_require__(152);
	
	/** Used as references for various `Number` constants. */
	var NAN = 0 / 0;
	
	/** Used to match leading and trailing whitespace. */
	var reTrim = /^\s+|\s+$/g;
	
	/** Used to detect bad signed hexadecimal string values. */
	var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
	
	/** Used to detect binary string values. */
	var reIsBinary = /^0b[01]+$/i;
	
	/** Used to detect octal string values. */
	var reIsOctal = /^0o[0-7]+$/i;
	
	/** Built-in method references without a dependency on `root`. */
	var freeParseInt = parseInt;
	
	/**
	 * Converts `value` to a number.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to process.
	 * @returns {number} Returns the number.
	 * @example
	 *
	 * _.toNumber(3.2);
	 * // => 3.2
	 *
	 * _.toNumber(Number.MIN_VALUE);
	 * // => 5e-324
	 *
	 * _.toNumber(Infinity);
	 * // => Infinity
	 *
	 * _.toNumber('3.2');
	 * // => 3.2
	 */
	function toNumber(value) {
	  if (typeof value == 'number') {
	    return value;
	  }
	  if (isSymbol(value)) {
	    return NAN;
	  }
	  if (isObject(value)) {
	    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
	    value = isObject(other) ? (other + '') : other;
	  }
	  if (typeof value != 'string') {
	    return value === 0 ? value : +value;
	  }
	  value = value.replace(reTrim, '');
	  var isBinary = reIsBinary.test(value);
	  return (isBinary || reIsOctal.test(value))
	    ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
	    : (reIsBadHex.test(value) ? NAN : +value);
	}
	
	module.exports = toNumber;


/***/ },
/* 1271 */
/***/ function(module, exports, __webpack_require__) {

	var baseToString = __webpack_require__(1214);
	
	/**
	 * Converts `value` to a string. An empty string is returned for `null`
	 * and `undefined` values. The sign of `-0` is preserved.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to convert.
	 * @returns {string} Returns the converted string.
	 * @example
	 *
	 * _.toString(null);
	 * // => ''
	 *
	 * _.toString(-0);
	 * // => '-0'
	 *
	 * _.toString([1, 2, 3]);
	 * // => '1,2,3'
	 */
	function toString(value) {
	  return value == null ? '' : baseToString(value);
	}
	
	module.exports = toString;


/***/ },
/* 1272 */
/***/ function(module, exports) {

	'use strict'
	
	module.exports = escapes
	
	var defaults = [
	  '\\',
	  '`',
	  '*',
	  '{',
	  '}',
	  '[',
	  ']',
	  '(',
	  ')',
	  '#',
	  '+',
	  '-',
	  '.',
	  '!',
	  '_',
	  '>'
	]
	
	var gfm = defaults.concat(['~', '|'])
	
	var commonmark = gfm.concat([
	  '\n',
	  '"',
	  '$',
	  '%',
	  '&',
	  "'",
	  ',',
	  '/',
	  ':',
	  ';',
	  '<',
	  '=',
	  '?',
	  '@',
	  '^'
	])
	
	escapes.default = defaults
	escapes.gfm = gfm
	escapes.commonmark = commonmark
	
	// Get markdown escapes.
	function escapes(options) {
	  var settings = options || {}
	
	  if (settings.commonmark) {
	    return commonmark
	  }
	
	  return settings.gfm ? gfm : defaults
	}


/***/ },
/* 1273 */
/***/ function(module, exports, __webpack_require__) {

	var visitWithParents = __webpack_require__(1488);
	
	function addListMetadata() {
	  return function (ast) {
	    visitWithParents(ast, 'list', function (listNode, parents) {
	      var depth = 0, i, n;
	      for (i = 0, n = parents.length; i < n; i++) {
	        if (parents[i].type === 'list') depth += 1;
	      }
	      for (i = 0, n = listNode.children.length; i < n; i++) {
	        var child = listNode.children[i];
	        child.index = i;
	        child.ordered = listNode.ordered;
	      }
	      listNode.depth = depth;
	    });
	    return ast;
	  };
	}
	
	module.exports = addListMetadata;


/***/ },
/* 1274 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {'use strict';var React=__webpack_require__(1),_inheritsLoose=__webpack_require__(156),PropTypes=__webpack_require__(20),warning=__webpack_require__(214);function _interopDefaultLegacy(e){return e&&typeof e==='object'&&'default'in e?e:{'default':e}}var React__default=/*#__PURE__*/_interopDefaultLegacy(React);var _inheritsLoose__default=/*#__PURE__*/_interopDefaultLegacy(_inheritsLoose);var PropTypes__default=/*#__PURE__*/_interopDefaultLegacy(PropTypes);var warning__default=/*#__PURE__*/_interopDefaultLegacy(warning);var MAX_SIGNED_31_BIT_INT = 1073741823;
	var commonjsGlobal = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : {};
	
	function getUniqueId() {
	  var key = '__global_unique_id__';
	  return commonjsGlobal[key] = (commonjsGlobal[key] || 0) + 1;
	}
	
	function objectIs(x, y) {
	  if (x === y) {
	    return x !== 0 || 1 / x === 1 / y;
	  } else {
	    return x !== x && y !== y;
	  }
	}
	
	function createEventEmitter(value) {
	  var handlers = [];
	  return {
	    on: function on(handler) {
	      handlers.push(handler);
	    },
	    off: function off(handler) {
	      handlers = handlers.filter(function (h) {
	        return h !== handler;
	      });
	    },
	    get: function get() {
	      return value;
	    },
	    set: function set(newValue, changedBits) {
	      value = newValue;
	      handlers.forEach(function (handler) {
	        return handler(value, changedBits);
	      });
	    }
	  };
	}
	
	function onlyChild(children) {
	  return Array.isArray(children) ? children[0] : children;
	}
	
	function createReactContext(defaultValue, calculateChangedBits) {
	  var _Provider$childContex, _Consumer$contextType;
	
	  var contextProp = '__create-react-context-' + getUniqueId() + '__';
	
	  var Provider = /*#__PURE__*/function (_Component) {
	    _inheritsLoose__default['default'](Provider, _Component);
	
	    function Provider() {
	      var _this;
	
	      _this = _Component.apply(this, arguments) || this;
	      _this.emitter = createEventEmitter(_this.props.value);
	      return _this;
	    }
	
	    var _proto = Provider.prototype;
	
	    _proto.getChildContext = function getChildContext() {
	      var _ref;
	
	      return _ref = {}, _ref[contextProp] = this.emitter, _ref;
	    };
	
	    _proto.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	      if (this.props.value !== nextProps.value) {
	        var oldValue = this.props.value;
	        var newValue = nextProps.value;
	        var changedBits;
	
	        if (objectIs(oldValue, newValue)) {
	          changedBits = 0;
	        } else {
	          changedBits = typeof calculateChangedBits === 'function' ? calculateChangedBits(oldValue, newValue) : MAX_SIGNED_31_BIT_INT;
	
	          if (false) {
	            warning__default['default']((changedBits & MAX_SIGNED_31_BIT_INT) === changedBits, 'calculateChangedBits: Expected the return value to be a ' + '31-bit integer. Instead received: ' + changedBits);
	          }
	
	          changedBits |= 0;
	
	          if (changedBits !== 0) {
	            this.emitter.set(nextProps.value, changedBits);
	          }
	        }
	      }
	    };
	
	    _proto.render = function render() {
	      return this.props.children;
	    };
	
	    return Provider;
	  }(React.Component);
	
	  Provider.childContextTypes = (_Provider$childContex = {}, _Provider$childContex[contextProp] = PropTypes__default['default'].object.isRequired, _Provider$childContex);
	
	  var Consumer = /*#__PURE__*/function (_Component2) {
	    _inheritsLoose__default['default'](Consumer, _Component2);
	
	    function Consumer() {
	      var _this2;
	
	      _this2 = _Component2.apply(this, arguments) || this;
	      _this2.state = {
	        value: _this2.getValue()
	      };
	
	      _this2.onUpdate = function (newValue, changedBits) {
	        var observedBits = _this2.observedBits | 0;
	
	        if ((observedBits & changedBits) !== 0) {
	          _this2.setState({
	            value: _this2.getValue()
	          });
	        }
	      };
	
	      return _this2;
	    }
	
	    var _proto2 = Consumer.prototype;
	
	    _proto2.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	      var observedBits = nextProps.observedBits;
	      this.observedBits = observedBits === undefined || observedBits === null ? MAX_SIGNED_31_BIT_INT : observedBits;
	    };
	
	    _proto2.componentDidMount = function componentDidMount() {
	      if (this.context[contextProp]) {
	        this.context[contextProp].on(this.onUpdate);
	      }
	
	      var observedBits = this.props.observedBits;
	      this.observedBits = observedBits === undefined || observedBits === null ? MAX_SIGNED_31_BIT_INT : observedBits;
	    };
	
	    _proto2.componentWillUnmount = function componentWillUnmount() {
	      if (this.context[contextProp]) {
	        this.context[contextProp].off(this.onUpdate);
	      }
	    };
	
	    _proto2.getValue = function getValue() {
	      if (this.context[contextProp]) {
	        return this.context[contextProp].get();
	      } else {
	        return defaultValue;
	      }
	    };
	
	    _proto2.render = function render() {
	      return onlyChild(this.props.children)(this.state.value);
	    };
	
	    return Consumer;
	  }(React.Component);
	
	  Consumer.contextTypes = (_Consumer$contextType = {}, _Consumer$contextType[contextProp] = PropTypes__default['default'].object, _Consumer$contextType);
	  return {
	    Provider: Provider,
	    Consumer: Consumer
	  };
	}var index = React__default['default'].createContext || createReactContext;module.exports=index;
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 1275 */
/***/ function(module, exports) {

	/**
	 * Generate URL-friendly unique ID. This method use non-secure predictable
	 * random generator with bigger collision probability.
	 *
	 * @param {string} alphabet Symbols to be used in ID.
	 * @param {number} [size=21] The number of symbols in ID.
	 *
	 * @return {string} Random string.
	 *
	 * @example
	 * const nanoid = require('nanoid/non-secure')
	 * model.id = nanoid() //=> "Uakgb_J5m9g-0JDMbcJqL"
	 *
	 * @name nonSecure
	 * @function
	 */
	module.exports = function (alphabet, size) {
	  size = size || 21
	  var id = ''
	  // Compact alternative for `for (var i = 0; i < size; i++)`
	  while (size--) {
	    // `| 0` is compact and faster alternative for `Math.floor()`
	    id += alphabet[Math.random() * alphabet.length | 0]
	  }
	  return id
	}


/***/ },
/* 1276 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Buffer) {'use strict';
	
	var crypto = __webpack_require__(831);
	
	/**
	 * Exported function
	 *
	 * Options:
	 *
	 *  - `algorithm` hash algo to be used by this instance: *'sha1', 'md5'
	 *  - `excludeValues` {true|*false} hash object keys, values ignored
	 *  - `encoding` hash encoding, supports 'buffer', '*hex', 'binary', 'base64'
	 *  - `ignoreUnknown` {true|*false} ignore unknown object types
	 *  - `replacer` optional function that replaces values before hashing
	 *  - `respectFunctionProperties` {*true|false} consider function properties when hashing
	 *  - `respectFunctionNames` {*true|false} consider 'name' property of functions for hashing
	 *  - `respectType` {*true|false} Respect special properties (prototype, constructor)
	 *    when hashing to distinguish between types
	 *  - `unorderedArrays` {true|*false} Sort all arrays before hashing
	 *  - `unorderedSets` {*true|false} Sort `Set` and `Map` instances before hashing
	 *  * = default
	 *
	 * @param {object} object value to hash
	 * @param {object} options hashing options
	 * @return {string} hash value
	 * @api public
	 */
	exports = module.exports = objectHash;
	
	function objectHash(object, options){
	  options = applyDefaults(object, options);
	
	  return hash(object, options);
	}
	
	/**
	 * Exported sugar methods
	 *
	 * @param {object} object value to hash
	 * @return {string} hash value
	 * @api public
	 */
	exports.sha1 = function(object){
	  return objectHash(object);
	};
	exports.keys = function(object){
	  return objectHash(object, {excludeValues: true, algorithm: 'sha1', encoding: 'hex'});
	};
	exports.MD5 = function(object){
	  return objectHash(object, {algorithm: 'md5', encoding: 'hex'});
	};
	exports.keysMD5 = function(object){
	  return objectHash(object, {algorithm: 'md5', encoding: 'hex', excludeValues: true});
	};
	
	// Internals
	var hashes = crypto.getHashes ? crypto.getHashes().slice() : ['sha1', 'md5'];
	hashes.push('passthrough');
	var encodings = ['buffer', 'hex', 'binary', 'base64'];
	
	function applyDefaults(object, options){
	  options = options || {};
	  options.algorithm = options.algorithm || 'sha1';
	  options.encoding = options.encoding || 'hex';
	  options.excludeValues = options.excludeValues ? true : false;
	  options.algorithm = options.algorithm.toLowerCase();
	  options.encoding = options.encoding.toLowerCase();
	  options.ignoreUnknown = options.ignoreUnknown !== true ? false : true; // default to false
	  options.respectType = options.respectType === false ? false : true; // default to true
	  options.respectFunctionNames = options.respectFunctionNames === false ? false : true;
	  options.respectFunctionProperties = options.respectFunctionProperties === false ? false : true;
	  options.unorderedArrays = options.unorderedArrays !== true ? false : true; // default to false
	  options.unorderedSets = options.unorderedSets === false ? false : true; // default to false
	  options.unorderedObjects = options.unorderedObjects === false ? false : true; // default to true
	  options.replacer = options.replacer || undefined;
	  options.excludeKeys = options.excludeKeys || undefined;
	
	  if(typeof object === 'undefined') {
	    throw new Error('Object argument required.');
	  }
	
	  // if there is a case-insensitive match in the hashes list, accept it
	  // (i.e. SHA256 for sha256)
	  for (var i = 0; i < hashes.length; ++i) {
	    if (hashes[i].toLowerCase() === options.algorithm.toLowerCase()) {
	      options.algorithm = hashes[i];
	    }
	  }
	
	  if(hashes.indexOf(options.algorithm) === -1){
	    throw new Error('Algorithm "' + options.algorithm + '"  not supported. ' +
	      'supported values: ' + hashes.join(', '));
	  }
	
	  if(encodings.indexOf(options.encoding) === -1 &&
	     options.algorithm !== 'passthrough'){
	    throw new Error('Encoding "' + options.encoding + '"  not supported. ' +
	      'supported values: ' + encodings.join(', '));
	  }
	
	  return options;
	}
	
	/** Check if the given function is a native function */
	function isNativeFunction(f) {
	  if ((typeof f) !== 'function') {
	    return false;
	  }
	  var exp = /^function\s+\w*\s*\(\s*\)\s*{\s+\[native code\]\s+}$/i;
	  return exp.exec(Function.prototype.toString.call(f)) != null;
	}
	
	function hash(object, options) {
	  var hashingStream;
	
	  if (options.algorithm !== 'passthrough') {
	    hashingStream = crypto.createHash(options.algorithm);
	  } else {
	    hashingStream = new PassThrough();
	  }
	
	  if (typeof hashingStream.write === 'undefined') {
	    hashingStream.write = hashingStream.update;
	    hashingStream.end   = hashingStream.update;
	  }
	
	  var hasher = typeHasher(options, hashingStream);
	  hasher.dispatch(object);
	  if (!hashingStream.update)
	    hashingStream.end('')
	
	  if (hashingStream.digest) {
	    return hashingStream.digest(options.encoding === 'buffer' ? undefined : options.encoding);
	  }
	
	  var buf = hashingStream.read();
	  if (options.encoding === 'buffer') {
	    return buf;
	  }
	
	  return buf.toString(options.encoding);
	}
	
	/**
	 * Expose streaming API
	 *
	 * @param {object} object  Value to serialize
	 * @param {object} options  Options, as for hash()
	 * @param {object} stream  A stream to write the serializiation to
	 * @api public
	 */
	exports.writeToStream = function(object, options, stream) {
	  if (typeof stream === 'undefined') {
	    stream = options;
	    options = {};
	  }
	
	  options = applyDefaults(object, options);
	
	  return typeHasher(options, stream).dispatch(object);
	};
	
	function typeHasher(options, writeTo, context){
	  context = context || [];
	  var write = function(str) {
	    if (writeTo.update)
	      return writeTo.update(str, 'utf8');
	    else
	      return writeTo.write(str, 'utf8');
	  }
	
	  return {
	    dispatch: function(value){
	      if (options.replacer) {
	        value = options.replacer(value);
	      }
	
	      var type = typeof value;
	      if (value === null) {
	        type = 'null';
	      }
	
	      //console.log("[DEBUG] Dispatch: ", value, "->", type, " -> ", "_" + type);
	
	      return this['_' + type](value);
	    },
	    _object: function(object) {
	      var pattern = (/\[object (.*)\]/i);
	      var objString = Object.prototype.toString.call(object);
	      var objType = pattern.exec(objString);
	      if (!objType) { // object type did not match [object ...]
	        objType = 'unknown:[' + objString + ']';
	      } else {
	        objType = objType[1]; // take only the class name
	      }
	
	      objType = objType.toLowerCase();
	
	      var objectNumber = null;
	
	      if ((objectNumber = context.indexOf(object)) >= 0) {
	        return this.dispatch('[CIRCULAR:' + objectNumber + ']');
	      } else {
	        context.push(object);
	      }
	
	      if (typeof Buffer !== 'undefined' && Buffer.isBuffer && Buffer.isBuffer(object)) {
	        write('buffer:');
	        return write(object);
	      }
	
	      if(objType !== 'object' && objType !== 'function') {
	        if(this['_' + objType]) {
	          this['_' + objType](object);
	        } else if (options.ignoreUnknown) {
	          return write('[' + objType + ']');
	        } else {
	          throw new Error('Unknown object type "' + objType + '"');
	        }
	      }else{
	        var keys = Object.keys(object);
	        if (options.unorderedObjects) {
	          keys = keys.sort();
	        }
	        // Make sure to incorporate special properties, so
	        // Types with different prototypes will produce
	        // a different hash and objects derived from
	        // different functions (`new Foo`, `new Bar`) will
	        // produce different hashes.
	        // We never do this for native functions since some
	        // seem to break because of that.
	        if (options.respectType !== false && !isNativeFunction(object)) {
	          keys.splice(0, 0, 'prototype', '__proto__', 'constructor');
	        }
	
	        if (options.excludeKeys) {
	          keys = keys.filter(function(key) { return !options.excludeKeys(key); });
	        }
	
	        write('object:' + keys.length + ':');
	        var self = this;
	        return keys.forEach(function(key){
	          self.dispatch(key);
	          write(':');
	          if(!options.excludeValues) {
	            self.dispatch(object[key]);
	          }
	          write(',');
	        });
	      }
	    },
	    _array: function(arr, unordered){
	      unordered = typeof unordered !== 'undefined' ? unordered :
	        options.unorderedArrays !== false; // default to options.unorderedArrays
	
	      var self = this;
	      write('array:' + arr.length + ':');
	      if (!unordered || arr.length <= 1) {
	        return arr.forEach(function(entry) {
	          return self.dispatch(entry);
	        });
	      }
	
	      // the unordered case is a little more complicated:
	      // since there is no canonical ordering on objects,
	      // i.e. {a:1} < {a:2} and {a:1} > {a:2} are both false,
	      // we first serialize each entry using a PassThrough stream
	      // before sorting.
	      // also: we can’t use the same context array for all entries
	      // since the order of hashing should *not* matter. instead,
	      // we keep track of the additions to a copy of the context array
	      // and add all of them to the global context array when we’re done
	      var contextAdditions = [];
	      var entries = arr.map(function(entry) {
	        var strm = new PassThrough();
	        var localContext = context.slice(); // make copy
	        var hasher = typeHasher(options, strm, localContext);
	        hasher.dispatch(entry);
	        // take only what was added to localContext and append it to contextAdditions
	        contextAdditions = contextAdditions.concat(localContext.slice(context.length));
	        return strm.read().toString();
	      });
	      context = context.concat(contextAdditions);
	      entries.sort();
	      return this._array(entries, false);
	    },
	    _date: function(date){
	      return write('date:' + date.toJSON());
	    },
	    _symbol: function(sym){
	      return write('symbol:' + sym.toString());
	    },
	    _error: function(err){
	      return write('error:' + err.toString());
	    },
	    _boolean: function(bool){
	      return write('bool:' + bool.toString());
	    },
	    _string: function(string){
	      write('string:' + string.length + ':');
	      write(string.toString());
	    },
	    _function: function(fn){
	      write('fn:');
	      if (isNativeFunction(fn)) {
	        this.dispatch('[native]');
	      } else {
	        this.dispatch(fn.toString());
	      }
	
	      if (options.respectFunctionNames !== false) {
	        // Make sure we can still distinguish native functions
	        // by their name, otherwise String and Function will
	        // have the same hash
	        this.dispatch("function-name:" + String(fn.name));
	      }
	
	      if (options.respectFunctionProperties) {
	        this._object(fn);
	      }
	    },
	    _number: function(number){
	      return write('number:' + number.toString());
	    },
	    _xml: function(xml){
	      return write('xml:' + xml.toString());
	    },
	    _null: function() {
	      return write('Null');
	    },
	    _undefined: function() {
	      return write('Undefined');
	    },
	    _regexp: function(regex){
	      return write('regex:' + regex.toString());
	    },
	    _uint8array: function(arr){
	      write('uint8array:');
	      return this.dispatch(Array.prototype.slice.call(arr));
	    },
	    _uint8clampedarray: function(arr){
	      write('uint8clampedarray:');
	      return this.dispatch(Array.prototype.slice.call(arr));
	    },
	    _int8array: function(arr){
	      write('uint8array:');
	      return this.dispatch(Array.prototype.slice.call(arr));
	    },
	    _uint16array: function(arr){
	      write('uint16array:');
	      return this.dispatch(Array.prototype.slice.call(arr));
	    },
	    _int16array: function(arr){
	      write('uint16array:');
	      return this.dispatch(Array.prototype.slice.call(arr));
	    },
	    _uint32array: function(arr){
	      write('uint32array:');
	      return this.dispatch(Array.prototype.slice.call(arr));
	    },
	    _int32array: function(arr){
	      write('uint32array:');
	      return this.dispatch(Array.prototype.slice.call(arr));
	    },
	    _float32array: function(arr){
	      write('float32array:');
	      return this.dispatch(Array.prototype.slice.call(arr));
	    },
	    _float64array: function(arr){
	      write('float64array:');
	      return this.dispatch(Array.prototype.slice.call(arr));
	    },
	    _arraybuffer: function(arr){
	      write('arraybuffer:');
	      return this.dispatch(new Uint8Array(arr));
	    },
	    _url: function(url) {
	      return write('url:' + url.toString(), 'utf8');
	    },
	    _map: function(map) {
	      write('map:');
	      var arr = Array.from(map);
	      return this._array(arr, options.unorderedSets !== false);
	    },
	    _set: function(set) {
	      write('set:');
	      var arr = Array.from(set);
	      return this._array(arr, options.unorderedSets !== false);
	    },
	    _blob: function() {
	      if (options.ignoreUnknown) {
	        return write('[blob]');
	      }
	
	      throw Error('Hashing Blob objects is currently not supported\n' +
	        '(see https://github.com/puleos/object-hash/issues/26)\n' +
	        'Use "options.replacer" or "options.ignoreUnknown"\n');
	    },
	    _domwindow: function() { return write('domwindow'); },
	    /* Node.js standard native objects */
	    _process: function() { return write('process'); },
	    _timer: function() { return write('timer'); },
	    _pipe: function() { return write('pipe'); },
	    _tcp: function() { return write('tcp'); },
	    _udp: function() { return write('udp'); },
	    _tty: function() { return write('tty'); },
	    _statwatcher: function() { return write('statwatcher'); },
	    _securecontext: function() { return write('securecontext'); },
	    _connection: function() { return write('connection'); },
	    _zlib: function() { return write('zlib'); },
	    _context: function() { return write('context'); },
	    _nodescript: function() { return write('nodescript'); },
	    _httpparser: function() { return write('httpparser'); },
	    _dataview: function() { return write('dataview'); },
	    _signal: function() { return write('signal'); },
	    _fsevent: function() { return write('fsevent'); },
	    _tlswrap: function() { return write('tlswrap'); }
	  };
	}
	
	// Mini-implementation of stream.PassThrough
	// We are far from having need for the full implementation, and we can
	// make assumptions like "many writes, then only one final read"
	// and we can ignore encoding specifics
	function PassThrough() {
	  return {
	    buf: '',
	
	    write: function(b) {
	      this.buf += b;
	    },
	
	    end: function(b) {
	      this.buf += b;
	    },
	
	    read: function() {
	      return this.buf;
	    }
	  };
	}
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(31).Buffer))

/***/ },
/* 1277 */
/***/ function(module, exports) {

	'use strict';
	
	// http://www.ecma-international.org/ecma-262/6.0/#sec-object.is
	
	var numberIsNaN = function (value) {
		return value !== value;
	};
	
	module.exports = function is(a, b) {
		if (a === 0 && b === 0) {
			return 1 / a === 1 / b;
		}
		if (a === b) {
			return true;
		}
		if (numberIsNaN(a) && numberIsNaN(b)) {
			return true;
		}
		return false;
	};
	


/***/ },
/* 1278 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var keysShim;
	if (!Object.keys) {
		// modified from https://github.com/es-shims/es5-shim
		var has = Object.prototype.hasOwnProperty;
		var toStr = Object.prototype.toString;
		var isArgs = __webpack_require__(505); // eslint-disable-line global-require
		var isEnumerable = Object.prototype.propertyIsEnumerable;
		var hasDontEnumBug = !isEnumerable.call({ toString: null }, 'toString');
		var hasProtoEnumBug = isEnumerable.call(function () {}, 'prototype');
		var dontEnums = [
			'toString',
			'toLocaleString',
			'valueOf',
			'hasOwnProperty',
			'isPrototypeOf',
			'propertyIsEnumerable',
			'constructor'
		];
		var equalsConstructorPrototype = function (o) {
			var ctor = o.constructor;
			return ctor && ctor.prototype === o;
		};
		var excludedKeys = {
			$applicationCache: true,
			$console: true,
			$external: true,
			$frame: true,
			$frameElement: true,
			$frames: true,
			$innerHeight: true,
			$innerWidth: true,
			$onmozfullscreenchange: true,
			$onmozfullscreenerror: true,
			$outerHeight: true,
			$outerWidth: true,
			$pageXOffset: true,
			$pageYOffset: true,
			$parent: true,
			$scrollLeft: true,
			$scrollTop: true,
			$scrollX: true,
			$scrollY: true,
			$self: true,
			$webkitIndexedDB: true,
			$webkitStorageInfo: true,
			$window: true
		};
		var hasAutomationEqualityBug = (function () {
			/* global window */
			if (typeof window === 'undefined') { return false; }
			for (var k in window) {
				try {
					if (!excludedKeys['$' + k] && has.call(window, k) && window[k] !== null && typeof window[k] === 'object') {
						try {
							equalsConstructorPrototype(window[k]);
						} catch (e) {
							return true;
						}
					}
				} catch (e) {
					return true;
				}
			}
			return false;
		}());
		var equalsConstructorPrototypeIfNotBuggy = function (o) {
			/* global window */
			if (typeof window === 'undefined' || !hasAutomationEqualityBug) {
				return equalsConstructorPrototype(o);
			}
			try {
				return equalsConstructorPrototype(o);
			} catch (e) {
				return false;
			}
		};
	
		keysShim = function keys(object) {
			var isObject = object !== null && typeof object === 'object';
			var isFunction = toStr.call(object) === '[object Function]';
			var isArguments = isArgs(object);
			var isString = isObject && toStr.call(object) === '[object String]';
			var theKeys = [];
	
			if (!isObject && !isFunction && !isArguments) {
				throw new TypeError('Object.keys called on a non-object');
			}
	
			var skipProto = hasProtoEnumBug && isFunction;
			if (isString && object.length > 0 && !has.call(object, 0)) {
				for (var i = 0; i < object.length; ++i) {
					theKeys.push(String(i));
				}
			}
	
			if (isArguments && object.length > 0) {
				for (var j = 0; j < object.length; ++j) {
					theKeys.push(String(j));
				}
			} else {
				for (var name in object) {
					if (!(skipProto && name === 'prototype') && has.call(object, name)) {
						theKeys.push(String(name));
					}
				}
			}
	
			if (hasDontEnumBug) {
				var skipConstructor = equalsConstructorPrototypeIfNotBuggy(object);
	
				for (var k = 0; k < dontEnums.length; ++k) {
					if (!(skipConstructor && dontEnums[k] === 'constructor') && has.call(object, dontEnums[k])) {
						theKeys.push(dontEnums[k]);
					}
				}
			}
			return theKeys;
		};
	}
	module.exports = keysShim;


/***/ },
/* 1279 */
/***/ function(module, exports) {

	'use strict'
	
	/* eslint-env browser */
	
	var el
	
	var semicolon = 59 //  ';'
	
	module.exports = decodeEntity
	
	function decodeEntity(characters) {
	  var entity = '&' + characters + ';'
	  var char
	
	  el = el || document.createElement('i')
	  el.innerHTML = entity
	  char = el.textContent
	
	  // Some entities do not require the closing semicolon (`&not` - for instance),
	  // which leads to situations where parsing the assumed entity of &notit; will
	  // result in the string `¬it;`.  When we encounter a trailing semicolon after
	  // parsing and the entity to decode was not a semicolon (`&semi;`), we can
	  // assume that the matching was incomplete
	  if (char.charCodeAt(char.length - 1) === semicolon && characters !== 'semi') {
	    return false
	  }
	
	  // If the decoded string is equal to the input, the entity was not valid
	  return char === entity ? false : char
	}


/***/ },
/* 1280 */
/***/ function(module, exports, __webpack_require__) {

	var isarray = __webpack_require__(1281)
	
	/**
	 * Expose `pathToRegexp`.
	 */
	module.exports = pathToRegexp
	module.exports.parse = parse
	module.exports.compile = compile
	module.exports.tokensToFunction = tokensToFunction
	module.exports.tokensToRegExp = tokensToRegExp
	
	/**
	 * The main path matching regexp utility.
	 *
	 * @type {RegExp}
	 */
	var PATH_REGEXP = new RegExp([
	  // Match escaped characters that would otherwise appear in future matches.
	  // This allows the user to escape special characters that won't transform.
	  '(\\\\.)',
	  // Match Express-style parameters and un-named parameters with a prefix
	  // and optional suffixes. Matches appear as:
	  //
	  // "/:test(\\d+)?" => ["/", "test", "\d+", undefined, "?", undefined]
	  // "/route(\\d+)"  => [undefined, undefined, undefined, "\d+", undefined, undefined]
	  // "/*"            => ["/", undefined, undefined, undefined, undefined, "*"]
	  '([\\/.])?(?:(?:\\:(\\w+)(?:\\(((?:\\\\.|[^\\\\()])+)\\))?|\\(((?:\\\\.|[^\\\\()])+)\\))([+*?])?|(\\*))'
	].join('|'), 'g')
	
	/**
	 * Parse a string for the raw tokens.
	 *
	 * @param  {string}  str
	 * @param  {Object=} options
	 * @return {!Array}
	 */
	function parse (str, options) {
	  var tokens = []
	  var key = 0
	  var index = 0
	  var path = ''
	  var defaultDelimiter = options && options.delimiter || '/'
	  var res
	
	  while ((res = PATH_REGEXP.exec(str)) != null) {
	    var m = res[0]
	    var escaped = res[1]
	    var offset = res.index
	    path += str.slice(index, offset)
	    index = offset + m.length
	
	    // Ignore already escaped sequences.
	    if (escaped) {
	      path += escaped[1]
	      continue
	    }
	
	    var next = str[index]
	    var prefix = res[2]
	    var name = res[3]
	    var capture = res[4]
	    var group = res[5]
	    var modifier = res[6]
	    var asterisk = res[7]
	
	    // Push the current path onto the tokens.
	    if (path) {
	      tokens.push(path)
	      path = ''
	    }
	
	    var partial = prefix != null && next != null && next !== prefix
	    var repeat = modifier === '+' || modifier === '*'
	    var optional = modifier === '?' || modifier === '*'
	    var delimiter = res[2] || defaultDelimiter
	    var pattern = capture || group
	
	    tokens.push({
	      name: name || key++,
	      prefix: prefix || '',
	      delimiter: delimiter,
	      optional: optional,
	      repeat: repeat,
	      partial: partial,
	      asterisk: !!asterisk,
	      pattern: pattern ? escapeGroup(pattern) : (asterisk ? '.*' : '[^' + escapeString(delimiter) + ']+?')
	    })
	  }
	
	  // Match any characters still remaining.
	  if (index < str.length) {
	    path += str.substr(index)
	  }
	
	  // If the path exists, push it onto the end.
	  if (path) {
	    tokens.push(path)
	  }
	
	  return tokens
	}
	
	/**
	 * Compile a string to a template function for the path.
	 *
	 * @param  {string}             str
	 * @param  {Object=}            options
	 * @return {!function(Object=, Object=)}
	 */
	function compile (str, options) {
	  return tokensToFunction(parse(str, options), options)
	}
	
	/**
	 * Prettier encoding of URI path segments.
	 *
	 * @param  {string}
	 * @return {string}
	 */
	function encodeURIComponentPretty (str) {
	  return encodeURI(str).replace(/[\/?#]/g, function (c) {
	    return '%' + c.charCodeAt(0).toString(16).toUpperCase()
	  })
	}
	
	/**
	 * Encode the asterisk parameter. Similar to `pretty`, but allows slashes.
	 *
	 * @param  {string}
	 * @return {string}
	 */
	function encodeAsterisk (str) {
	  return encodeURI(str).replace(/[?#]/g, function (c) {
	    return '%' + c.charCodeAt(0).toString(16).toUpperCase()
	  })
	}
	
	/**
	 * Expose a method for transforming tokens into the path function.
	 */
	function tokensToFunction (tokens, options) {
	  // Compile all the tokens into regexps.
	  var matches = new Array(tokens.length)
	
	  // Compile all the patterns before compilation.
	  for (var i = 0; i < tokens.length; i++) {
	    if (typeof tokens[i] === 'object') {
	      matches[i] = new RegExp('^(?:' + tokens[i].pattern + ')$', flags(options))
	    }
	  }
	
	  return function (obj, opts) {
	    var path = ''
	    var data = obj || {}
	    var options = opts || {}
	    var encode = options.pretty ? encodeURIComponentPretty : encodeURIComponent
	
	    for (var i = 0; i < tokens.length; i++) {
	      var token = tokens[i]
	
	      if (typeof token === 'string') {
	        path += token
	
	        continue
	      }
	
	      var value = data[token.name]
	      var segment
	
	      if (value == null) {
	        if (token.optional) {
	          // Prepend partial segment prefixes.
	          if (token.partial) {
	            path += token.prefix
	          }
	
	          continue
	        } else {
	          throw new TypeError('Expected "' + token.name + '" to be defined')
	        }
	      }
	
	      if (isarray(value)) {
	        if (!token.repeat) {
	          throw new TypeError('Expected "' + token.name + '" to not repeat, but received `' + JSON.stringify(value) + '`')
	        }
	
	        if (value.length === 0) {
	          if (token.optional) {
	            continue
	          } else {
	            throw new TypeError('Expected "' + token.name + '" to not be empty')
	          }
	        }
	
	        for (var j = 0; j < value.length; j++) {
	          segment = encode(value[j])
	
	          if (!matches[i].test(segment)) {
	            throw new TypeError('Expected all "' + token.name + '" to match "' + token.pattern + '", but received `' + JSON.stringify(segment) + '`')
	          }
	
	          path += (j === 0 ? token.prefix : token.delimiter) + segment
	        }
	
	        continue
	      }
	
	      segment = token.asterisk ? encodeAsterisk(value) : encode(value)
	
	      if (!matches[i].test(segment)) {
	        throw new TypeError('Expected "' + token.name + '" to match "' + token.pattern + '", but received "' + segment + '"')
	      }
	
	      path += token.prefix + segment
	    }
	
	    return path
	  }
	}
	
	/**
	 * Escape a regular expression string.
	 *
	 * @param  {string} str
	 * @return {string}
	 */
	function escapeString (str) {
	  return str.replace(/([.+*?=^!:${}()[\]|\/\\])/g, '\\$1')
	}
	
	/**
	 * Escape the capturing group by escaping special characters and meaning.
	 *
	 * @param  {string} group
	 * @return {string}
	 */
	function escapeGroup (group) {
	  return group.replace(/([=!:$\/()])/g, '\\$1')
	}
	
	/**
	 * Attach the keys as a property of the regexp.
	 *
	 * @param  {!RegExp} re
	 * @param  {Array}   keys
	 * @return {!RegExp}
	 */
	function attachKeys (re, keys) {
	  re.keys = keys
	  return re
	}
	
	/**
	 * Get the flags for a regexp from the options.
	 *
	 * @param  {Object} options
	 * @return {string}
	 */
	function flags (options) {
	  return options && options.sensitive ? '' : 'i'
	}
	
	/**
	 * Pull out keys from a regexp.
	 *
	 * @param  {!RegExp} path
	 * @param  {!Array}  keys
	 * @return {!RegExp}
	 */
	function regexpToRegexp (path, keys) {
	  // Use a negative lookahead to match only capturing groups.
	  var groups = path.source.match(/\((?!\?)/g)
	
	  if (groups) {
	    for (var i = 0; i < groups.length; i++) {
	      keys.push({
	        name: i,
	        prefix: null,
	        delimiter: null,
	        optional: false,
	        repeat: false,
	        partial: false,
	        asterisk: false,
	        pattern: null
	      })
	    }
	  }
	
	  return attachKeys(path, keys)
	}
	
	/**
	 * Transform an array into a regexp.
	 *
	 * @param  {!Array}  path
	 * @param  {Array}   keys
	 * @param  {!Object} options
	 * @return {!RegExp}
	 */
	function arrayToRegexp (path, keys, options) {
	  var parts = []
	
	  for (var i = 0; i < path.length; i++) {
	    parts.push(pathToRegexp(path[i], keys, options).source)
	  }
	
	  var regexp = new RegExp('(?:' + parts.join('|') + ')', flags(options))
	
	  return attachKeys(regexp, keys)
	}
	
	/**
	 * Create a path regexp from string input.
	 *
	 * @param  {string}  path
	 * @param  {!Array}  keys
	 * @param  {!Object} options
	 * @return {!RegExp}
	 */
	function stringToRegexp (path, keys, options) {
	  return tokensToRegExp(parse(path, options), keys, options)
	}
	
	/**
	 * Expose a function for taking tokens and returning a RegExp.
	 *
	 * @param  {!Array}          tokens
	 * @param  {(Array|Object)=} keys
	 * @param  {Object=}         options
	 * @return {!RegExp}
	 */
	function tokensToRegExp (tokens, keys, options) {
	  if (!isarray(keys)) {
	    options = /** @type {!Object} */ (keys || options)
	    keys = []
	  }
	
	  options = options || {}
	
	  var strict = options.strict
	  var end = options.end !== false
	  var route = ''
	
	  // Iterate over the tokens and create our regexp string.
	  for (var i = 0; i < tokens.length; i++) {
	    var token = tokens[i]
	
	    if (typeof token === 'string') {
	      route += escapeString(token)
	    } else {
	      var prefix = escapeString(token.prefix)
	      var capture = '(?:' + token.pattern + ')'
	
	      keys.push(token)
	
	      if (token.repeat) {
	        capture += '(?:' + prefix + capture + ')*'
	      }
	
	      if (token.optional) {
	        if (!token.partial) {
	          capture = '(?:' + prefix + '(' + capture + '))?'
	        } else {
	          capture = prefix + '(' + capture + ')?'
	        }
	      } else {
	        capture = prefix + '(' + capture + ')'
	      }
	
	      route += capture
	    }
	  }
	
	  var delimiter = escapeString(options.delimiter || '/')
	  var endsWithDelimiter = route.slice(-delimiter.length) === delimiter
	
	  // In non-strict mode we allow a slash at the end of match. If the path to
	  // match already ends with a slash, we remove it for consistency. The slash
	  // is valid at the end of a path match, not in the middle. This is important
	  // in non-ending mode, where "/test/" shouldn't match "/test//route".
	  if (!strict) {
	    route = (endsWithDelimiter ? route.slice(0, -delimiter.length) : route) + '(?:' + delimiter + '(?=$))?'
	  }
	
	  if (end) {
	    route += '$'
	  } else {
	    // In non-ending mode, we need the capturing groups to match as much as
	    // possible by using a positive lookahead to the end or next path segment.
	    route += strict && endsWithDelimiter ? '' : '(?=' + delimiter + '|$)'
	  }
	
	  return attachKeys(new RegExp('^' + route, flags(options)), keys)
	}
	
	/**
	 * Normalize the given path string, returning a regular expression.
	 *
	 * An empty array can be passed in for the keys, which will hold the
	 * placeholder key descriptions. For example, using `/user/:id`, `keys` will
	 * contain `[{ name: 'id', delimiter: '/', optional: false, repeat: false }]`.
	 *
	 * @param  {(string|RegExp|Array)} path
	 * @param  {(Array|Object)=}       keys
	 * @param  {Object=}               options
	 * @return {!RegExp}
	 */
	function pathToRegexp (path, keys, options) {
	  if (!isarray(keys)) {
	    options = /** @type {!Object} */ (keys || options)
	    keys = []
	  }
	
	  options = options || {}
	
	  if (path instanceof RegExp) {
	    return regexpToRegexp(path, /** @type {!Array} */ (keys))
	  }
	
	  if (isarray(path)) {
	    return arrayToRegexp(/** @type {!Array} */ (path), /** @type {!Array} */ (keys), options)
	  }
	
	  return stringToRegexp(/** @type {string} */ (path), /** @type {!Array} */ (keys), options)
	}


/***/ },
/* 1281 */
/***/ function(module, exports) {

	module.exports = Array.isArray || function (arr) {
	  return Object.prototype.toString.call(arr) == '[object Array]';
	};


/***/ },
/* 1282 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Buffer) {module.exports = function(crypto) {
	  function pbkdf2(password, salt, iterations, keylen, digest, callback) {
	    if ('function' === typeof digest) {
	      callback = digest
	      digest = undefined
	    }
	
	    if ('function' !== typeof callback)
	      throw new Error('No callback provided to pbkdf2')
	
	    setTimeout(function() {
	      var result
	
	      try {
	        result = pbkdf2Sync(password, salt, iterations, keylen, digest)
	      } catch (e) {
	        return callback(e)
	      }
	
	      callback(undefined, result)
	    })
	  }
	
	  function pbkdf2Sync(password, salt, iterations, keylen, digest) {
	    if ('number' !== typeof iterations)
	      throw new TypeError('Iterations not a number')
	
	    if (iterations < 0)
	      throw new TypeError('Bad iterations')
	
	    if ('number' !== typeof keylen)
	      throw new TypeError('Key length not a number')
	
	    if (keylen < 0)
	      throw new TypeError('Bad key length')
	
	    digest = digest || 'sha1'
	
	    if (!Buffer.isBuffer(password)) password = new Buffer(password)
	    if (!Buffer.isBuffer(salt)) salt = new Buffer(salt)
	
	    var hLen, l = 1, r, T
	    var DK = new Buffer(keylen)
	    var block1 = new Buffer(salt.length + 4)
	    salt.copy(block1, 0, 0, salt.length)
	
	    for (var i = 1; i <= l; i++) {
	      block1.writeUInt32BE(i, salt.length)
	
	      var U = crypto.createHmac(digest, password).update(block1).digest()
	
	      if (!hLen) {
	        hLen = U.length
	        T = new Buffer(hLen)
	        l = Math.ceil(keylen / hLen)
	        r = keylen - (l - 1) * hLen
	
	        if (keylen > (Math.pow(2, 32) - 1) * hLen)
	          throw new TypeError('keylen exceeds maximum length')
	      }
	
	      U.copy(T, 0, 0, hLen)
	
	      for (var j = 1; j < iterations; j++) {
	        U = crypto.createHmac(digest, password).update(U).digest()
	
	        for (var k = 0; k < hLen; k++) {
	          T[k] ^= U[k]
	        }
	      }
	
	      var destPos = (i - 1) * hLen
	      var len = (i == l ? r : hLen)
	      T.copy(DK, destPos, 0, len)
	    }
	
	    return DK
	  }
	
	  return {
	    pbkdf2: pbkdf2,
	    pbkdf2Sync: pbkdf2Sync
	  }
	}
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(31).Buffer))

/***/ },
/* 1283 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {// Generated by CoffeeScript 1.12.2
	(function() {
	  var getNanoSeconds, hrtime, loadTime, moduleLoadTime, nodeLoadTime, upTime;
	
	  if ((typeof performance !== "undefined" && performance !== null) && performance.now) {
	    module.exports = function() {
	      return performance.now();
	    };
	  } else if ((typeof process !== "undefined" && process !== null) && process.hrtime) {
	    module.exports = function() {
	      return (getNanoSeconds() - nodeLoadTime) / 1e6;
	    };
	    hrtime = process.hrtime;
	    getNanoSeconds = function() {
	      var hr;
	      hr = hrtime();
	      return hr[0] * 1e9 + hr[1];
	    };
	    moduleLoadTime = getNanoSeconds();
	    upTime = process.uptime() * 1e9;
	    nodeLoadTime = moduleLoadTime - upTime;
	  } else if (Date.now) {
	    module.exports = function() {
	      return Date.now() - loadTime;
	    };
	    loadTime = Date.now();
	  } else {
	    module.exports = function() {
	      return new Date().getTime() - loadTime;
	    };
	    loadTime = new Date().getTime();
	  }
	
	}).call(this);
	
	//# sourceMappingURL=performance-now.js.map
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(77)))

/***/ },
/* 1284 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {/**!
	 * @fileOverview Kickass library to create and place poppers near their reference elements.
	 * @version 1.16.1
	 * @license
	 * Copyright (c) 2016 Federico Zivolo and contributors
	 *
	 * Permission is hereby granted, free of charge, to any person obtaining a copy
	 * of this software and associated documentation files (the "Software"), to deal
	 * in the Software without restriction, including without limitation the rights
	 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
	 * copies of the Software, and to permit persons to whom the Software is
	 * furnished to do so, subject to the following conditions:
	 *
	 * The above copyright notice and this permission notice shall be included in all
	 * copies or substantial portions of the Software.
	 *
	 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
	 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
	 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
	 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
	 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
	 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
	 * SOFTWARE.
	 */
	(function (global, factory) {
		 true ? module.exports = factory() :
		typeof define === 'function' && define.amd ? define(factory) :
		(global.Popper = factory());
	}(this, (function () { 'use strict';
	
	var isBrowser = typeof window !== 'undefined' && typeof document !== 'undefined' && typeof navigator !== 'undefined';
	
	var timeoutDuration = function () {
	  var longerTimeoutBrowsers = ['Edge', 'Trident', 'Firefox'];
	  for (var i = 0; i < longerTimeoutBrowsers.length; i += 1) {
	    if (isBrowser && navigator.userAgent.indexOf(longerTimeoutBrowsers[i]) >= 0) {
	      return 1;
	    }
	  }
	  return 0;
	}();
	
	function microtaskDebounce(fn) {
	  var called = false;
	  return function () {
	    if (called) {
	      return;
	    }
	    called = true;
	    window.Promise.resolve().then(function () {
	      called = false;
	      fn();
	    });
	  };
	}
	
	function taskDebounce(fn) {
	  var scheduled = false;
	  return function () {
	    if (!scheduled) {
	      scheduled = true;
	      setTimeout(function () {
	        scheduled = false;
	        fn();
	      }, timeoutDuration);
	    }
	  };
	}
	
	var supportsMicroTasks = isBrowser && window.Promise;
	
	/**
	* Create a debounced version of a method, that's asynchronously deferred
	* but called in the minimum time possible.
	*
	* @method
	* @memberof Popper.Utils
	* @argument {Function} fn
	* @returns {Function}
	*/
	var debounce = supportsMicroTasks ? microtaskDebounce : taskDebounce;
	
	/**
	 * Check if the given variable is a function
	 * @method
	 * @memberof Popper.Utils
	 * @argument {Any} functionToCheck - variable to check
	 * @returns {Boolean} answer to: is a function?
	 */
	function isFunction(functionToCheck) {
	  var getType = {};
	  return functionToCheck && getType.toString.call(functionToCheck) === '[object Function]';
	}
	
	/**
	 * Get CSS computed property of the given element
	 * @method
	 * @memberof Popper.Utils
	 * @argument {Eement} element
	 * @argument {String} property
	 */
	function getStyleComputedProperty(element, property) {
	  if (element.nodeType !== 1) {
	    return [];
	  }
	  // NOTE: 1 DOM access here
	  var window = element.ownerDocument.defaultView;
	  var css = window.getComputedStyle(element, null);
	  return property ? css[property] : css;
	}
	
	/**
	 * Returns the parentNode or the host of the element
	 * @method
	 * @memberof Popper.Utils
	 * @argument {Element} element
	 * @returns {Element} parent
	 */
	function getParentNode(element) {
	  if (element.nodeName === 'HTML') {
	    return element;
	  }
	  return element.parentNode || element.host;
	}
	
	/**
	 * Returns the scrolling parent of the given element
	 * @method
	 * @memberof Popper.Utils
	 * @argument {Element} element
	 * @returns {Element} scroll parent
	 */
	function getScrollParent(element) {
	  // Return body, `getScroll` will take care to get the correct `scrollTop` from it
	  if (!element) {
	    return document.body;
	  }
	
	  switch (element.nodeName) {
	    case 'HTML':
	    case 'BODY':
	      return element.ownerDocument.body;
	    case '#document':
	      return element.body;
	  }
	
	  // Firefox want us to check `-x` and `-y` variations as well
	
	  var _getStyleComputedProp = getStyleComputedProperty(element),
	      overflow = _getStyleComputedProp.overflow,
	      overflowX = _getStyleComputedProp.overflowX,
	      overflowY = _getStyleComputedProp.overflowY;
	
	  if (/(auto|scroll|overlay)/.test(overflow + overflowY + overflowX)) {
	    return element;
	  }
	
	  return getScrollParent(getParentNode(element));
	}
	
	/**
	 * Returns the reference node of the reference object, or the reference object itself.
	 * @method
	 * @memberof Popper.Utils
	 * @param {Element|Object} reference - the reference element (the popper will be relative to this)
	 * @returns {Element} parent
	 */
	function getReferenceNode(reference) {
	  return reference && reference.referenceNode ? reference.referenceNode : reference;
	}
	
	var isIE11 = isBrowser && !!(window.MSInputMethodContext && document.documentMode);
	var isIE10 = isBrowser && /MSIE 10/.test(navigator.userAgent);
	
	/**
	 * Determines if the browser is Internet Explorer
	 * @method
	 * @memberof Popper.Utils
	 * @param {Number} version to check
	 * @returns {Boolean} isIE
	 */
	function isIE(version) {
	  if (version === 11) {
	    return isIE11;
	  }
	  if (version === 10) {
	    return isIE10;
	  }
	  return isIE11 || isIE10;
	}
	
	/**
	 * Returns the offset parent of the given element
	 * @method
	 * @memberof Popper.Utils
	 * @argument {Element} element
	 * @returns {Element} offset parent
	 */
	function getOffsetParent(element) {
	  if (!element) {
	    return document.documentElement;
	  }
	
	  var noOffsetParent = isIE(10) ? document.body : null;
	
	  // NOTE: 1 DOM access here
	  var offsetParent = element.offsetParent || null;
	  // Skip hidden elements which don't have an offsetParent
	  while (offsetParent === noOffsetParent && element.nextElementSibling) {
	    offsetParent = (element = element.nextElementSibling).offsetParent;
	  }
	
	  var nodeName = offsetParent && offsetParent.nodeName;
	
	  if (!nodeName || nodeName === 'BODY' || nodeName === 'HTML') {
	    return element ? element.ownerDocument.documentElement : document.documentElement;
	  }
	
	  // .offsetParent will return the closest TH, TD or TABLE in case
	  // no offsetParent is present, I hate this job...
	  if (['TH', 'TD', 'TABLE'].indexOf(offsetParent.nodeName) !== -1 && getStyleComputedProperty(offsetParent, 'position') === 'static') {
	    return getOffsetParent(offsetParent);
	  }
	
	  return offsetParent;
	}
	
	function isOffsetContainer(element) {
	  var nodeName = element.nodeName;
	
	  if (nodeName === 'BODY') {
	    return false;
	  }
	  return nodeName === 'HTML' || getOffsetParent(element.firstElementChild) === element;
	}
	
	/**
	 * Finds the root node (document, shadowDOM root) of the given element
	 * @method
	 * @memberof Popper.Utils
	 * @argument {Element} node
	 * @returns {Element} root node
	 */
	function getRoot(node) {
	  if (node.parentNode !== null) {
	    return getRoot(node.parentNode);
	  }
	
	  return node;
	}
	
	/**
	 * Finds the offset parent common to the two provided nodes
	 * @method
	 * @memberof Popper.Utils
	 * @argument {Element} element1
	 * @argument {Element} element2
	 * @returns {Element} common offset parent
	 */
	function findCommonOffsetParent(element1, element2) {
	  // This check is needed to avoid errors in case one of the elements isn't defined for any reason
	  if (!element1 || !element1.nodeType || !element2 || !element2.nodeType) {
	    return document.documentElement;
	  }
	
	  // Here we make sure to give as "start" the element that comes first in the DOM
	  var order = element1.compareDocumentPosition(element2) & Node.DOCUMENT_POSITION_FOLLOWING;
	  var start = order ? element1 : element2;
	  var end = order ? element2 : element1;
	
	  // Get common ancestor container
	  var range = document.createRange();
	  range.setStart(start, 0);
	  range.setEnd(end, 0);
	  var commonAncestorContainer = range.commonAncestorContainer;
	
	  // Both nodes are inside #document
	
	  if (element1 !== commonAncestorContainer && element2 !== commonAncestorContainer || start.contains(end)) {
	    if (isOffsetContainer(commonAncestorContainer)) {
	      return commonAncestorContainer;
	    }
	
	    return getOffsetParent(commonAncestorContainer);
	  }
	
	  // one of the nodes is inside shadowDOM, find which one
	  var element1root = getRoot(element1);
	  if (element1root.host) {
	    return findCommonOffsetParent(element1root.host, element2);
	  } else {
	    return findCommonOffsetParent(element1, getRoot(element2).host);
	  }
	}
	
	/**
	 * Gets the scroll value of the given element in the given side (top and left)
	 * @method
	 * @memberof Popper.Utils
	 * @argument {Element} element
	 * @argument {String} side `top` or `left`
	 * @returns {number} amount of scrolled pixels
	 */
	function getScroll(element) {
	  var side = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'top';
	
	  var upperSide = side === 'top' ? 'scrollTop' : 'scrollLeft';
	  var nodeName = element.nodeName;
	
	  if (nodeName === 'BODY' || nodeName === 'HTML') {
	    var html = element.ownerDocument.documentElement;
	    var scrollingElement = element.ownerDocument.scrollingElement || html;
	    return scrollingElement[upperSide];
	  }
	
	  return element[upperSide];
	}
	
	/*
	 * Sum or subtract the element scroll values (left and top) from a given rect object
	 * @method
	 * @memberof Popper.Utils
	 * @param {Object} rect - Rect object you want to change
	 * @param {HTMLElement} element - The element from the function reads the scroll values
	 * @param {Boolean} subtract - set to true if you want to subtract the scroll values
	 * @return {Object} rect - The modifier rect object
	 */
	function includeScroll(rect, element) {
	  var subtract = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
	
	  var scrollTop = getScroll(element, 'top');
	  var scrollLeft = getScroll(element, 'left');
	  var modifier = subtract ? -1 : 1;
	  rect.top += scrollTop * modifier;
	  rect.bottom += scrollTop * modifier;
	  rect.left += scrollLeft * modifier;
	  rect.right += scrollLeft * modifier;
	  return rect;
	}
	
	/*
	 * Helper to detect borders of a given element
	 * @method
	 * @memberof Popper.Utils
	 * @param {CSSStyleDeclaration} styles
	 * Result of `getStyleComputedProperty` on the given element
	 * @param {String} axis - `x` or `y`
	 * @return {number} borders - The borders size of the given axis
	 */
	
	function getBordersSize(styles, axis) {
	  var sideA = axis === 'x' ? 'Left' : 'Top';
	  var sideB = sideA === 'Left' ? 'Right' : 'Bottom';
	
	  return parseFloat(styles['border' + sideA + 'Width']) + parseFloat(styles['border' + sideB + 'Width']);
	}
	
	function getSize(axis, body, html, computedStyle) {
	  return Math.max(body['offset' + axis], body['scroll' + axis], html['client' + axis], html['offset' + axis], html['scroll' + axis], isIE(10) ? parseInt(html['offset' + axis]) + parseInt(computedStyle['margin' + (axis === 'Height' ? 'Top' : 'Left')]) + parseInt(computedStyle['margin' + (axis === 'Height' ? 'Bottom' : 'Right')]) : 0);
	}
	
	function getWindowSizes(document) {
	  var body = document.body;
	  var html = document.documentElement;
	  var computedStyle = isIE(10) && getComputedStyle(html);
	
	  return {
	    height: getSize('Height', body, html, computedStyle),
	    width: getSize('Width', body, html, computedStyle)
	  };
	}
	
	var classCallCheck = function (instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	};
	
	var createClass = function () {
	  function defineProperties(target, props) {
	    for (var i = 0; i < props.length; i++) {
	      var descriptor = props[i];
	      descriptor.enumerable = descriptor.enumerable || false;
	      descriptor.configurable = true;
	      if ("value" in descriptor) descriptor.writable = true;
	      Object.defineProperty(target, descriptor.key, descriptor);
	    }
	  }
	
	  return function (Constructor, protoProps, staticProps) {
	    if (protoProps) defineProperties(Constructor.prototype, protoProps);
	    if (staticProps) defineProperties(Constructor, staticProps);
	    return Constructor;
	  };
	}();
	
	
	
	
	
	var defineProperty = function (obj, key, value) {
	  if (key in obj) {
	    Object.defineProperty(obj, key, {
	      value: value,
	      enumerable: true,
	      configurable: true,
	      writable: true
	    });
	  } else {
	    obj[key] = value;
	  }
	
	  return obj;
	};
	
	var _extends = Object.assign || function (target) {
	  for (var i = 1; i < arguments.length; i++) {
	    var source = arguments[i];
	
	    for (var key in source) {
	      if (Object.prototype.hasOwnProperty.call(source, key)) {
	        target[key] = source[key];
	      }
	    }
	  }
	
	  return target;
	};
	
	/**
	 * Given element offsets, generate an output similar to getBoundingClientRect
	 * @method
	 * @memberof Popper.Utils
	 * @argument {Object} offsets
	 * @returns {Object} ClientRect like output
	 */
	function getClientRect(offsets) {
	  return _extends({}, offsets, {
	    right: offsets.left + offsets.width,
	    bottom: offsets.top + offsets.height
	  });
	}
	
	/**
	 * Get bounding client rect of given element
	 * @method
	 * @memberof Popper.Utils
	 * @param {HTMLElement} element
	 * @return {Object} client rect
	 */
	function getBoundingClientRect(element) {
	  var rect = {};
	
	  // IE10 10 FIX: Please, don't ask, the element isn't
	  // considered in DOM in some circumstances...
	  // This isn't reproducible in IE10 compatibility mode of IE11
	  try {
	    if (isIE(10)) {
	      rect = element.getBoundingClientRect();
	      var scrollTop = getScroll(element, 'top');
	      var scrollLeft = getScroll(element, 'left');
	      rect.top += scrollTop;
	      rect.left += scrollLeft;
	      rect.bottom += scrollTop;
	      rect.right += scrollLeft;
	    } else {
	      rect = element.getBoundingClientRect();
	    }
	  } catch (e) {}
	
	  var result = {
	    left: rect.left,
	    top: rect.top,
	    width: rect.right - rect.left,
	    height: rect.bottom - rect.top
	  };
	
	  // subtract scrollbar size from sizes
	  var sizes = element.nodeName === 'HTML' ? getWindowSizes(element.ownerDocument) : {};
	  var width = sizes.width || element.clientWidth || result.width;
	  var height = sizes.height || element.clientHeight || result.height;
	
	  var horizScrollbar = element.offsetWidth - width;
	  var vertScrollbar = element.offsetHeight - height;
	
	  // if an hypothetical scrollbar is detected, we must be sure it's not a `border`
	  // we make this check conditional for performance reasons
	  if (horizScrollbar || vertScrollbar) {
	    var styles = getStyleComputedProperty(element);
	    horizScrollbar -= getBordersSize(styles, 'x');
	    vertScrollbar -= getBordersSize(styles, 'y');
	
	    result.width -= horizScrollbar;
	    result.height -= vertScrollbar;
	  }
	
	  return getClientRect(result);
	}
	
	function getOffsetRectRelativeToArbitraryNode(children, parent) {
	  var fixedPosition = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
	
	  var isIE10 = isIE(10);
	  var isHTML = parent.nodeName === 'HTML';
	  var childrenRect = getBoundingClientRect(children);
	  var parentRect = getBoundingClientRect(parent);
	  var scrollParent = getScrollParent(children);
	
	  var styles = getStyleComputedProperty(parent);
	  var borderTopWidth = parseFloat(styles.borderTopWidth);
	  var borderLeftWidth = parseFloat(styles.borderLeftWidth);
	
	  // In cases where the parent is fixed, we must ignore negative scroll in offset calc
	  if (fixedPosition && isHTML) {
	    parentRect.top = Math.max(parentRect.top, 0);
	    parentRect.left = Math.max(parentRect.left, 0);
	  }
	  var offsets = getClientRect({
	    top: childrenRect.top - parentRect.top - borderTopWidth,
	    left: childrenRect.left - parentRect.left - borderLeftWidth,
	    width: childrenRect.width,
	    height: childrenRect.height
	  });
	  offsets.marginTop = 0;
	  offsets.marginLeft = 0;
	
	  // Subtract margins of documentElement in case it's being used as parent
	  // we do this only on HTML because it's the only element that behaves
	  // differently when margins are applied to it. The margins are included in
	  // the box of the documentElement, in the other cases not.
	  if (!isIE10 && isHTML) {
	    var marginTop = parseFloat(styles.marginTop);
	    var marginLeft = parseFloat(styles.marginLeft);
	
	    offsets.top -= borderTopWidth - marginTop;
	    offsets.bottom -= borderTopWidth - marginTop;
	    offsets.left -= borderLeftWidth - marginLeft;
	    offsets.right -= borderLeftWidth - marginLeft;
	
	    // Attach marginTop and marginLeft because in some circumstances we may need them
	    offsets.marginTop = marginTop;
	    offsets.marginLeft = marginLeft;
	  }
	
	  if (isIE10 && !fixedPosition ? parent.contains(scrollParent) : parent === scrollParent && scrollParent.nodeName !== 'BODY') {
	    offsets = includeScroll(offsets, parent);
	  }
	
	  return offsets;
	}
	
	function getViewportOffsetRectRelativeToArtbitraryNode(element) {
	  var excludeScroll = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	
	  var html = element.ownerDocument.documentElement;
	  var relativeOffset = getOffsetRectRelativeToArbitraryNode(element, html);
	  var width = Math.max(html.clientWidth, window.innerWidth || 0);
	  var height = Math.max(html.clientHeight, window.innerHeight || 0);
	
	  var scrollTop = !excludeScroll ? getScroll(html) : 0;
	  var scrollLeft = !excludeScroll ? getScroll(html, 'left') : 0;
	
	  var offset = {
	    top: scrollTop - relativeOffset.top + relativeOffset.marginTop,
	    left: scrollLeft - relativeOffset.left + relativeOffset.marginLeft,
	    width: width,
	    height: height
	  };
	
	  return getClientRect(offset);
	}
	
	/**
	 * Check if the given element is fixed or is inside a fixed parent
	 * @method
	 * @memberof Popper.Utils
	 * @argument {Element} element
	 * @argument {Element} customContainer
	 * @returns {Boolean} answer to "isFixed?"
	 */
	function isFixed(element) {
	  var nodeName = element.nodeName;
	  if (nodeName === 'BODY' || nodeName === 'HTML') {
	    return false;
	  }
	  if (getStyleComputedProperty(element, 'position') === 'fixed') {
	    return true;
	  }
	  var parentNode = getParentNode(element);
	  if (!parentNode) {
	    return false;
	  }
	  return isFixed(parentNode);
	}
	
	/**
	 * Finds the first parent of an element that has a transformed property defined
	 * @method
	 * @memberof Popper.Utils
	 * @argument {Element} element
	 * @returns {Element} first transformed parent or documentElement
	 */
	
	function getFixedPositionOffsetParent(element) {
	  // This check is needed to avoid errors in case one of the elements isn't defined for any reason
	  if (!element || !element.parentElement || isIE()) {
	    return document.documentElement;
	  }
	  var el = element.parentElement;
	  while (el && getStyleComputedProperty(el, 'transform') === 'none') {
	    el = el.parentElement;
	  }
	  return el || document.documentElement;
	}
	
	/**
	 * Computed the boundaries limits and return them
	 * @method
	 * @memberof Popper.Utils
	 * @param {HTMLElement} popper
	 * @param {HTMLElement} reference
	 * @param {number} padding
	 * @param {HTMLElement} boundariesElement - Element used to define the boundaries
	 * @param {Boolean} fixedPosition - Is in fixed position mode
	 * @returns {Object} Coordinates of the boundaries
	 */
	function getBoundaries(popper, reference, padding, boundariesElement) {
	  var fixedPosition = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;
	
	  // NOTE: 1 DOM access here
	
	  var boundaries = { top: 0, left: 0 };
	  var offsetParent = fixedPosition ? getFixedPositionOffsetParent(popper) : findCommonOffsetParent(popper, getReferenceNode(reference));
	
	  // Handle viewport case
	  if (boundariesElement === 'viewport') {
	    boundaries = getViewportOffsetRectRelativeToArtbitraryNode(offsetParent, fixedPosition);
	  } else {
	    // Handle other cases based on DOM element used as boundaries
	    var boundariesNode = void 0;
	    if (boundariesElement === 'scrollParent') {
	      boundariesNode = getScrollParent(getParentNode(reference));
	      if (boundariesNode.nodeName === 'BODY') {
	        boundariesNode = popper.ownerDocument.documentElement;
	      }
	    } else if (boundariesElement === 'window') {
	      boundariesNode = popper.ownerDocument.documentElement;
	    } else {
	      boundariesNode = boundariesElement;
	    }
	
	    var offsets = getOffsetRectRelativeToArbitraryNode(boundariesNode, offsetParent, fixedPosition);
	
	    // In case of HTML, we need a different computation
	    if (boundariesNode.nodeName === 'HTML' && !isFixed(offsetParent)) {
	      var _getWindowSizes = getWindowSizes(popper.ownerDocument),
	          height = _getWindowSizes.height,
	          width = _getWindowSizes.width;
	
	      boundaries.top += offsets.top - offsets.marginTop;
	      boundaries.bottom = height + offsets.top;
	      boundaries.left += offsets.left - offsets.marginLeft;
	      boundaries.right = width + offsets.left;
	    } else {
	      // for all the other DOM elements, this one is good
	      boundaries = offsets;
	    }
	  }
	
	  // Add paddings
	  padding = padding || 0;
	  var isPaddingNumber = typeof padding === 'number';
	  boundaries.left += isPaddingNumber ? padding : padding.left || 0;
	  boundaries.top += isPaddingNumber ? padding : padding.top || 0;
	  boundaries.right -= isPaddingNumber ? padding : padding.right || 0;
	  boundaries.bottom -= isPaddingNumber ? padding : padding.bottom || 0;
	
	  return boundaries;
	}
	
	function getArea(_ref) {
	  var width = _ref.width,
	      height = _ref.height;
	
	  return width * height;
	}
	
	/**
	 * Utility used to transform the `auto` placement to the placement with more
	 * available space.
	 * @method
	 * @memberof Popper.Utils
	 * @argument {Object} data - The data object generated by update method
	 * @argument {Object} options - Modifiers configuration and options
	 * @returns {Object} The data object, properly modified
	 */
	function computeAutoPlacement(placement, refRect, popper, reference, boundariesElement) {
	  var padding = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : 0;
	
	  if (placement.indexOf('auto') === -1) {
	    return placement;
	  }
	
	  var boundaries = getBoundaries(popper, reference, padding, boundariesElement);
	
	  var rects = {
	    top: {
	      width: boundaries.width,
	      height: refRect.top - boundaries.top
	    },
	    right: {
	      width: boundaries.right - refRect.right,
	      height: boundaries.height
	    },
	    bottom: {
	      width: boundaries.width,
	      height: boundaries.bottom - refRect.bottom
	    },
	    left: {
	      width: refRect.left - boundaries.left,
	      height: boundaries.height
	    }
	  };
	
	  var sortedAreas = Object.keys(rects).map(function (key) {
	    return _extends({
	      key: key
	    }, rects[key], {
	      area: getArea(rects[key])
	    });
	  }).sort(function (a, b) {
	    return b.area - a.area;
	  });
	
	  var filteredAreas = sortedAreas.filter(function (_ref2) {
	    var width = _ref2.width,
	        height = _ref2.height;
	    return width >= popper.clientWidth && height >= popper.clientHeight;
	  });
	
	  var computedPlacement = filteredAreas.length > 0 ? filteredAreas[0].key : sortedAreas[0].key;
	
	  var variation = placement.split('-')[1];
	
	  return computedPlacement + (variation ? '-' + variation : '');
	}
	
	/**
	 * Get offsets to the reference element
	 * @method
	 * @memberof Popper.Utils
	 * @param {Object} state
	 * @param {Element} popper - the popper element
	 * @param {Element} reference - the reference element (the popper will be relative to this)
	 * @param {Element} fixedPosition - is in fixed position mode
	 * @returns {Object} An object containing the offsets which will be applied to the popper
	 */
	function getReferenceOffsets(state, popper, reference) {
	  var fixedPosition = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
	
	  var commonOffsetParent = fixedPosition ? getFixedPositionOffsetParent(popper) : findCommonOffsetParent(popper, getReferenceNode(reference));
	  return getOffsetRectRelativeToArbitraryNode(reference, commonOffsetParent, fixedPosition);
	}
	
	/**
	 * Get the outer sizes of the given element (offset size + margins)
	 * @method
	 * @memberof Popper.Utils
	 * @argument {Element} element
	 * @returns {Object} object containing width and height properties
	 */
	function getOuterSizes(element) {
	  var window = element.ownerDocument.defaultView;
	  var styles = window.getComputedStyle(element);
	  var x = parseFloat(styles.marginTop || 0) + parseFloat(styles.marginBottom || 0);
	  var y = parseFloat(styles.marginLeft || 0) + parseFloat(styles.marginRight || 0);
	  var result = {
	    width: element.offsetWidth + y,
	    height: element.offsetHeight + x
	  };
	  return result;
	}
	
	/**
	 * Get the opposite placement of the given one
	 * @method
	 * @memberof Popper.Utils
	 * @argument {String} placement
	 * @returns {String} flipped placement
	 */
	function getOppositePlacement(placement) {
	  var hash = { left: 'right', right: 'left', bottom: 'top', top: 'bottom' };
	  return placement.replace(/left|right|bottom|top/g, function (matched) {
	    return hash[matched];
	  });
	}
	
	/**
	 * Get offsets to the popper
	 * @method
	 * @memberof Popper.Utils
	 * @param {Object} position - CSS position the Popper will get applied
	 * @param {HTMLElement} popper - the popper element
	 * @param {Object} referenceOffsets - the reference offsets (the popper will be relative to this)
	 * @param {String} placement - one of the valid placement options
	 * @returns {Object} popperOffsets - An object containing the offsets which will be applied to the popper
	 */
	function getPopperOffsets(popper, referenceOffsets, placement) {
	  placement = placement.split('-')[0];
	
	  // Get popper node sizes
	  var popperRect = getOuterSizes(popper);
	
	  // Add position, width and height to our offsets object
	  var popperOffsets = {
	    width: popperRect.width,
	    height: popperRect.height
	  };
	
	  // depending by the popper placement we have to compute its offsets slightly differently
	  var isHoriz = ['right', 'left'].indexOf(placement) !== -1;
	  var mainSide = isHoriz ? 'top' : 'left';
	  var secondarySide = isHoriz ? 'left' : 'top';
	  var measurement = isHoriz ? 'height' : 'width';
	  var secondaryMeasurement = !isHoriz ? 'height' : 'width';
	
	  popperOffsets[mainSide] = referenceOffsets[mainSide] + referenceOffsets[measurement] / 2 - popperRect[measurement] / 2;
	  if (placement === secondarySide) {
	    popperOffsets[secondarySide] = referenceOffsets[secondarySide] - popperRect[secondaryMeasurement];
	  } else {
	    popperOffsets[secondarySide] = referenceOffsets[getOppositePlacement(secondarySide)];
	  }
	
	  return popperOffsets;
	}
	
	/**
	 * Mimics the `find` method of Array
	 * @method
	 * @memberof Popper.Utils
	 * @argument {Array} arr
	 * @argument prop
	 * @argument value
	 * @returns index or -1
	 */
	function find(arr, check) {
	  // use native find if supported
	  if (Array.prototype.find) {
	    return arr.find(check);
	  }
	
	  // use `filter` to obtain the same behavior of `find`
	  return arr.filter(check)[0];
	}
	
	/**
	 * Return the index of the matching object
	 * @method
	 * @memberof Popper.Utils
	 * @argument {Array} arr
	 * @argument prop
	 * @argument value
	 * @returns index or -1
	 */
	function findIndex(arr, prop, value) {
	  // use native findIndex if supported
	  if (Array.prototype.findIndex) {
	    return arr.findIndex(function (cur) {
	      return cur[prop] === value;
	    });
	  }
	
	  // use `find` + `indexOf` if `findIndex` isn't supported
	  var match = find(arr, function (obj) {
	    return obj[prop] === value;
	  });
	  return arr.indexOf(match);
	}
	
	/**
	 * Loop trough the list of modifiers and run them in order,
	 * each of them will then edit the data object.
	 * @method
	 * @memberof Popper.Utils
	 * @param {dataObject} data
	 * @param {Array} modifiers
	 * @param {String} ends - Optional modifier name used as stopper
	 * @returns {dataObject}
	 */
	function runModifiers(modifiers, data, ends) {
	  var modifiersToRun = ends === undefined ? modifiers : modifiers.slice(0, findIndex(modifiers, 'name', ends));
	
	  modifiersToRun.forEach(function (modifier) {
	    if (modifier['function']) {
	      // eslint-disable-line dot-notation
	      console.warn('`modifier.function` is deprecated, use `modifier.fn`!');
	    }
	    var fn = modifier['function'] || modifier.fn; // eslint-disable-line dot-notation
	    if (modifier.enabled && isFunction(fn)) {
	      // Add properties to offsets to make them a complete clientRect object
	      // we do this before each modifier to make sure the previous one doesn't
	      // mess with these values
	      data.offsets.popper = getClientRect(data.offsets.popper);
	      data.offsets.reference = getClientRect(data.offsets.reference);
	
	      data = fn(data, modifier);
	    }
	  });
	
	  return data;
	}
	
	/**
	 * Updates the position of the popper, computing the new offsets and applying
	 * the new style.<br />
	 * Prefer `scheduleUpdate` over `update` because of performance reasons.
	 * @method
	 * @memberof Popper
	 */
	function update() {
	  // if popper is destroyed, don't perform any further update
	  if (this.state.isDestroyed) {
	    return;
	  }
	
	  var data = {
	    instance: this,
	    styles: {},
	    arrowStyles: {},
	    attributes: {},
	    flipped: false,
	    offsets: {}
	  };
	
	  // compute reference element offsets
	  data.offsets.reference = getReferenceOffsets(this.state, this.popper, this.reference, this.options.positionFixed);
	
	  // compute auto placement, store placement inside the data object,
	  // modifiers will be able to edit `placement` if needed
	  // and refer to originalPlacement to know the original value
	  data.placement = computeAutoPlacement(this.options.placement, data.offsets.reference, this.popper, this.reference, this.options.modifiers.flip.boundariesElement, this.options.modifiers.flip.padding);
	
	  // store the computed placement inside `originalPlacement`
	  data.originalPlacement = data.placement;
	
	  data.positionFixed = this.options.positionFixed;
	
	  // compute the popper offsets
	  data.offsets.popper = getPopperOffsets(this.popper, data.offsets.reference, data.placement);
	
	  data.offsets.popper.position = this.options.positionFixed ? 'fixed' : 'absolute';
	
	  // run the modifiers
	  data = runModifiers(this.modifiers, data);
	
	  // the first `update` will call `onCreate` callback
	  // the other ones will call `onUpdate` callback
	  if (!this.state.isCreated) {
	    this.state.isCreated = true;
	    this.options.onCreate(data);
	  } else {
	    this.options.onUpdate(data);
	  }
	}
	
	/**
	 * Helper used to know if the given modifier is enabled.
	 * @method
	 * @memberof Popper.Utils
	 * @returns {Boolean}
	 */
	function isModifierEnabled(modifiers, modifierName) {
	  return modifiers.some(function (_ref) {
	    var name = _ref.name,
	        enabled = _ref.enabled;
	    return enabled && name === modifierName;
	  });
	}
	
	/**
	 * Get the prefixed supported property name
	 * @method
	 * @memberof Popper.Utils
	 * @argument {String} property (camelCase)
	 * @returns {String} prefixed property (camelCase or PascalCase, depending on the vendor prefix)
	 */
	function getSupportedPropertyName(property) {
	  var prefixes = [false, 'ms', 'Webkit', 'Moz', 'O'];
	  var upperProp = property.charAt(0).toUpperCase() + property.slice(1);
	
	  for (var i = 0; i < prefixes.length; i++) {
	    var prefix = prefixes[i];
	    var toCheck = prefix ? '' + prefix + upperProp : property;
	    if (typeof document.body.style[toCheck] !== 'undefined') {
	      return toCheck;
	    }
	  }
	  return null;
	}
	
	/**
	 * Destroys the popper.
	 * @method
	 * @memberof Popper
	 */
	function destroy() {
	  this.state.isDestroyed = true;
	
	  // touch DOM only if `applyStyle` modifier is enabled
	  if (isModifierEnabled(this.modifiers, 'applyStyle')) {
	    this.popper.removeAttribute('x-placement');
	    this.popper.style.position = '';
	    this.popper.style.top = '';
	    this.popper.style.left = '';
	    this.popper.style.right = '';
	    this.popper.style.bottom = '';
	    this.popper.style.willChange = '';
	    this.popper.style[getSupportedPropertyName('transform')] = '';
	  }
	
	  this.disableEventListeners();
	
	  // remove the popper if user explicitly asked for the deletion on destroy
	  // do not use `remove` because IE11 doesn't support it
	  if (this.options.removeOnDestroy) {
	    this.popper.parentNode.removeChild(this.popper);
	  }
	  return this;
	}
	
	/**
	 * Get the window associated with the element
	 * @argument {Element} element
	 * @returns {Window}
	 */
	function getWindow(element) {
	  var ownerDocument = element.ownerDocument;
	  return ownerDocument ? ownerDocument.defaultView : window;
	}
	
	function attachToScrollParents(scrollParent, event, callback, scrollParents) {
	  var isBody = scrollParent.nodeName === 'BODY';
	  var target = isBody ? scrollParent.ownerDocument.defaultView : scrollParent;
	  target.addEventListener(event, callback, { passive: true });
	
	  if (!isBody) {
	    attachToScrollParents(getScrollParent(target.parentNode), event, callback, scrollParents);
	  }
	  scrollParents.push(target);
	}
	
	/**
	 * Setup needed event listeners used to update the popper position
	 * @method
	 * @memberof Popper.Utils
	 * @private
	 */
	function setupEventListeners(reference, options, state, updateBound) {
	  // Resize event listener on window
	  state.updateBound = updateBound;
	  getWindow(reference).addEventListener('resize', state.updateBound, { passive: true });
	
	  // Scroll event listener on scroll parents
	  var scrollElement = getScrollParent(reference);
	  attachToScrollParents(scrollElement, 'scroll', state.updateBound, state.scrollParents);
	  state.scrollElement = scrollElement;
	  state.eventsEnabled = true;
	
	  return state;
	}
	
	/**
	 * It will add resize/scroll events and start recalculating
	 * position of the popper element when they are triggered.
	 * @method
	 * @memberof Popper
	 */
	function enableEventListeners() {
	  if (!this.state.eventsEnabled) {
	    this.state = setupEventListeners(this.reference, this.options, this.state, this.scheduleUpdate);
	  }
	}
	
	/**
	 * Remove event listeners used to update the popper position
	 * @method
	 * @memberof Popper.Utils
	 * @private
	 */
	function removeEventListeners(reference, state) {
	  // Remove resize event listener on window
	  getWindow(reference).removeEventListener('resize', state.updateBound);
	
	  // Remove scroll event listener on scroll parents
	  state.scrollParents.forEach(function (target) {
	    target.removeEventListener('scroll', state.updateBound);
	  });
	
	  // Reset state
	  state.updateBound = null;
	  state.scrollParents = [];
	  state.scrollElement = null;
	  state.eventsEnabled = false;
	  return state;
	}
	
	/**
	 * It will remove resize/scroll events and won't recalculate popper position
	 * when they are triggered. It also won't trigger `onUpdate` callback anymore,
	 * unless you call `update` method manually.
	 * @method
	 * @memberof Popper
	 */
	function disableEventListeners() {
	  if (this.state.eventsEnabled) {
	    cancelAnimationFrame(this.scheduleUpdate);
	    this.state = removeEventListeners(this.reference, this.state);
	  }
	}
	
	/**
	 * Tells if a given input is a number
	 * @method
	 * @memberof Popper.Utils
	 * @param {*} input to check
	 * @return {Boolean}
	 */
	function isNumeric(n) {
	  return n !== '' && !isNaN(parseFloat(n)) && isFinite(n);
	}
	
	/**
	 * Set the style to the given popper
	 * @method
	 * @memberof Popper.Utils
	 * @argument {Element} element - Element to apply the style to
	 * @argument {Object} styles
	 * Object with a list of properties and values which will be applied to the element
	 */
	function setStyles(element, styles) {
	  Object.keys(styles).forEach(function (prop) {
	    var unit = '';
	    // add unit if the value is numeric and is one of the following
	    if (['width', 'height', 'top', 'right', 'bottom', 'left'].indexOf(prop) !== -1 && isNumeric(styles[prop])) {
	      unit = 'px';
	    }
	    element.style[prop] = styles[prop] + unit;
	  });
	}
	
	/**
	 * Set the attributes to the given popper
	 * @method
	 * @memberof Popper.Utils
	 * @argument {Element} element - Element to apply the attributes to
	 * @argument {Object} styles
	 * Object with a list of properties and values which will be applied to the element
	 */
	function setAttributes(element, attributes) {
	  Object.keys(attributes).forEach(function (prop) {
	    var value = attributes[prop];
	    if (value !== false) {
	      element.setAttribute(prop, attributes[prop]);
	    } else {
	      element.removeAttribute(prop);
	    }
	  });
	}
	
	/**
	 * @function
	 * @memberof Modifiers
	 * @argument {Object} data - The data object generated by `update` method
	 * @argument {Object} data.styles - List of style properties - values to apply to popper element
	 * @argument {Object} data.attributes - List of attribute properties - values to apply to popper element
	 * @argument {Object} options - Modifiers configuration and options
	 * @returns {Object} The same data object
	 */
	function applyStyle(data) {
	  // any property present in `data.styles` will be applied to the popper,
	  // in this way we can make the 3rd party modifiers add custom styles to it
	  // Be aware, modifiers could override the properties defined in the previous
	  // lines of this modifier!
	  setStyles(data.instance.popper, data.styles);
	
	  // any property present in `data.attributes` will be applied to the popper,
	  // they will be set as HTML attributes of the element
	  setAttributes(data.instance.popper, data.attributes);
	
	  // if arrowElement is defined and arrowStyles has some properties
	  if (data.arrowElement && Object.keys(data.arrowStyles).length) {
	    setStyles(data.arrowElement, data.arrowStyles);
	  }
	
	  return data;
	}
	
	/**
	 * Set the x-placement attribute before everything else because it could be used
	 * to add margins to the popper margins needs to be calculated to get the
	 * correct popper offsets.
	 * @method
	 * @memberof Popper.modifiers
	 * @param {HTMLElement} reference - The reference element used to position the popper
	 * @param {HTMLElement} popper - The HTML element used as popper
	 * @param {Object} options - Popper.js options
	 */
	function applyStyleOnLoad(reference, popper, options, modifierOptions, state) {
	  // compute reference element offsets
	  var referenceOffsets = getReferenceOffsets(state, popper, reference, options.positionFixed);
	
	  // compute auto placement, store placement inside the data object,
	  // modifiers will be able to edit `placement` if needed
	  // and refer to originalPlacement to know the original value
	  var placement = computeAutoPlacement(options.placement, referenceOffsets, popper, reference, options.modifiers.flip.boundariesElement, options.modifiers.flip.padding);
	
	  popper.setAttribute('x-placement', placement);
	
	  // Apply `position` to popper before anything else because
	  // without the position applied we can't guarantee correct computations
	  setStyles(popper, { position: options.positionFixed ? 'fixed' : 'absolute' });
	
	  return options;
	}
	
	/**
	 * @function
	 * @memberof Popper.Utils
	 * @argument {Object} data - The data object generated by `update` method
	 * @argument {Boolean} shouldRound - If the offsets should be rounded at all
	 * @returns {Object} The popper's position offsets rounded
	 *
	 * The tale of pixel-perfect positioning. It's still not 100% perfect, but as
	 * good as it can be within reason.
	 * Discussion here: https://github.com/FezVrasta/popper.js/pull/715
	 *
	 * Low DPI screens cause a popper to be blurry if not using full pixels (Safari
	 * as well on High DPI screens).
	 *
	 * Firefox prefers no rounding for positioning and does not have blurriness on
	 * high DPI screens.
	 *
	 * Only horizontal placement and left/right values need to be considered.
	 */
	function getRoundedOffsets(data, shouldRound) {
	  var _data$offsets = data.offsets,
	      popper = _data$offsets.popper,
	      reference = _data$offsets.reference;
	  var round = Math.round,
	      floor = Math.floor;
	
	  var noRound = function noRound(v) {
	    return v;
	  };
	
	  var referenceWidth = round(reference.width);
	  var popperWidth = round(popper.width);
	
	  var isVertical = ['left', 'right'].indexOf(data.placement) !== -1;
	  var isVariation = data.placement.indexOf('-') !== -1;
	  var sameWidthParity = referenceWidth % 2 === popperWidth % 2;
	  var bothOddWidth = referenceWidth % 2 === 1 && popperWidth % 2 === 1;
	
	  var horizontalToInteger = !shouldRound ? noRound : isVertical || isVariation || sameWidthParity ? round : floor;
	  var verticalToInteger = !shouldRound ? noRound : round;
	
	  return {
	    left: horizontalToInteger(bothOddWidth && !isVariation && shouldRound ? popper.left - 1 : popper.left),
	    top: verticalToInteger(popper.top),
	    bottom: verticalToInteger(popper.bottom),
	    right: horizontalToInteger(popper.right)
	  };
	}
	
	var isFirefox = isBrowser && /Firefox/i.test(navigator.userAgent);
	
	/**
	 * @function
	 * @memberof Modifiers
	 * @argument {Object} data - The data object generated by `update` method
	 * @argument {Object} options - Modifiers configuration and options
	 * @returns {Object} The data object, properly modified
	 */
	function computeStyle(data, options) {
	  var x = options.x,
	      y = options.y;
	  var popper = data.offsets.popper;
	
	  // Remove this legacy support in Popper.js v2
	
	  var legacyGpuAccelerationOption = find(data.instance.modifiers, function (modifier) {
	    return modifier.name === 'applyStyle';
	  }).gpuAcceleration;
	  if (legacyGpuAccelerationOption !== undefined) {
	    console.warn('WARNING: `gpuAcceleration` option moved to `computeStyle` modifier and will not be supported in future versions of Popper.js!');
	  }
	  var gpuAcceleration = legacyGpuAccelerationOption !== undefined ? legacyGpuAccelerationOption : options.gpuAcceleration;
	
	  var offsetParent = getOffsetParent(data.instance.popper);
	  var offsetParentRect = getBoundingClientRect(offsetParent);
	
	  // Styles
	  var styles = {
	    position: popper.position
	  };
	
	  var offsets = getRoundedOffsets(data, window.devicePixelRatio < 2 || !isFirefox);
	
	  var sideA = x === 'bottom' ? 'top' : 'bottom';
	  var sideB = y === 'right' ? 'left' : 'right';
	
	  // if gpuAcceleration is set to `true` and transform is supported,
	  //  we use `translate3d` to apply the position to the popper we
	  // automatically use the supported prefixed version if needed
	  var prefixedProperty = getSupportedPropertyName('transform');
	
	  // now, let's make a step back and look at this code closely (wtf?)
	  // If the content of the popper grows once it's been positioned, it
	  // may happen that the popper gets misplaced because of the new content
	  // overflowing its reference element
	  // To avoid this problem, we provide two options (x and y), which allow
	  // the consumer to define the offset origin.
	  // If we position a popper on top of a reference element, we can set
	  // `x` to `top` to make the popper grow towards its top instead of
	  // its bottom.
	  var left = void 0,
	      top = void 0;
	  if (sideA === 'bottom') {
	    // when offsetParent is <html> the positioning is relative to the bottom of the screen (excluding the scrollbar)
	    // and not the bottom of the html element
	    if (offsetParent.nodeName === 'HTML') {
	      top = -offsetParent.clientHeight + offsets.bottom;
	    } else {
	      top = -offsetParentRect.height + offsets.bottom;
	    }
	  } else {
	    top = offsets.top;
	  }
	  if (sideB === 'right') {
	    if (offsetParent.nodeName === 'HTML') {
	      left = -offsetParent.clientWidth + offsets.right;
	    } else {
	      left = -offsetParentRect.width + offsets.right;
	    }
	  } else {
	    left = offsets.left;
	  }
	  if (gpuAcceleration && prefixedProperty) {
	    styles[prefixedProperty] = 'translate3d(' + left + 'px, ' + top + 'px, 0)';
	    styles[sideA] = 0;
	    styles[sideB] = 0;
	    styles.willChange = 'transform';
	  } else {
	    // othwerise, we use the standard `top`, `left`, `bottom` and `right` properties
	    var invertTop = sideA === 'bottom' ? -1 : 1;
	    var invertLeft = sideB === 'right' ? -1 : 1;
	    styles[sideA] = top * invertTop;
	    styles[sideB] = left * invertLeft;
	    styles.willChange = sideA + ', ' + sideB;
	  }
	
	  // Attributes
	  var attributes = {
	    'x-placement': data.placement
	  };
	
	  // Update `data` attributes, styles and arrowStyles
	  data.attributes = _extends({}, attributes, data.attributes);
	  data.styles = _extends({}, styles, data.styles);
	  data.arrowStyles = _extends({}, data.offsets.arrow, data.arrowStyles);
	
	  return data;
	}
	
	/**
	 * Helper used to know if the given modifier depends from another one.<br />
	 * It checks if the needed modifier is listed and enabled.
	 * @method
	 * @memberof Popper.Utils
	 * @param {Array} modifiers - list of modifiers
	 * @param {String} requestingName - name of requesting modifier
	 * @param {String} requestedName - name of requested modifier
	 * @returns {Boolean}
	 */
	function isModifierRequired(modifiers, requestingName, requestedName) {
	  var requesting = find(modifiers, function (_ref) {
	    var name = _ref.name;
	    return name === requestingName;
	  });
	
	  var isRequired = !!requesting && modifiers.some(function (modifier) {
	    return modifier.name === requestedName && modifier.enabled && modifier.order < requesting.order;
	  });
	
	  if (!isRequired) {
	    var _requesting = '`' + requestingName + '`';
	    var requested = '`' + requestedName + '`';
	    console.warn(requested + ' modifier is required by ' + _requesting + ' modifier in order to work, be sure to include it before ' + _requesting + '!');
	  }
	  return isRequired;
	}
	
	/**
	 * @function
	 * @memberof Modifiers
	 * @argument {Object} data - The data object generated by update method
	 * @argument {Object} options - Modifiers configuration and options
	 * @returns {Object} The data object, properly modified
	 */
	function arrow(data, options) {
	  var _data$offsets$arrow;
	
	  // arrow depends on keepTogether in order to work
	  if (!isModifierRequired(data.instance.modifiers, 'arrow', 'keepTogether')) {
	    return data;
	  }
	
	  var arrowElement = options.element;
	
	  // if arrowElement is a string, suppose it's a CSS selector
	  if (typeof arrowElement === 'string') {
	    arrowElement = data.instance.popper.querySelector(arrowElement);
	
	    // if arrowElement is not found, don't run the modifier
	    if (!arrowElement) {
	      return data;
	    }
	  } else {
	    // if the arrowElement isn't a query selector we must check that the
	    // provided DOM node is child of its popper node
	    if (!data.instance.popper.contains(arrowElement)) {
	      console.warn('WARNING: `arrow.element` must be child of its popper element!');
	      return data;
	    }
	  }
	
	  var placement = data.placement.split('-')[0];
	  var _data$offsets = data.offsets,
	      popper = _data$offsets.popper,
	      reference = _data$offsets.reference;
	
	  var isVertical = ['left', 'right'].indexOf(placement) !== -1;
	
	  var len = isVertical ? 'height' : 'width';
	  var sideCapitalized = isVertical ? 'Top' : 'Left';
	  var side = sideCapitalized.toLowerCase();
	  var altSide = isVertical ? 'left' : 'top';
	  var opSide = isVertical ? 'bottom' : 'right';
	  var arrowElementSize = getOuterSizes(arrowElement)[len];
	
	  //
	  // extends keepTogether behavior making sure the popper and its
	  // reference have enough pixels in conjunction
	  //
	
	  // top/left side
	  if (reference[opSide] - arrowElementSize < popper[side]) {
	    data.offsets.popper[side] -= popper[side] - (reference[opSide] - arrowElementSize);
	  }
	  // bottom/right side
	  if (reference[side] + arrowElementSize > popper[opSide]) {
	    data.offsets.popper[side] += reference[side] + arrowElementSize - popper[opSide];
	  }
	  data.offsets.popper = getClientRect(data.offsets.popper);
	
	  // compute center of the popper
	  var center = reference[side] + reference[len] / 2 - arrowElementSize / 2;
	
	  // Compute the sideValue using the updated popper offsets
	  // take popper margin in account because we don't have this info available
	  var css = getStyleComputedProperty(data.instance.popper);
	  var popperMarginSide = parseFloat(css['margin' + sideCapitalized]);
	  var popperBorderSide = parseFloat(css['border' + sideCapitalized + 'Width']);
	  var sideValue = center - data.offsets.popper[side] - popperMarginSide - popperBorderSide;
	
	  // prevent arrowElement from being placed not contiguously to its popper
	  sideValue = Math.max(Math.min(popper[len] - arrowElementSize, sideValue), 0);
	
	  data.arrowElement = arrowElement;
	  data.offsets.arrow = (_data$offsets$arrow = {}, defineProperty(_data$offsets$arrow, side, Math.round(sideValue)), defineProperty(_data$offsets$arrow, altSide, ''), _data$offsets$arrow);
	
	  return data;
	}
	
	/**
	 * Get the opposite placement variation of the given one
	 * @method
	 * @memberof Popper.Utils
	 * @argument {String} placement variation
	 * @returns {String} flipped placement variation
	 */
	function getOppositeVariation(variation) {
	  if (variation === 'end') {
	    return 'start';
	  } else if (variation === 'start') {
	    return 'end';
	  }
	  return variation;
	}
	
	/**
	 * List of accepted placements to use as values of the `placement` option.<br />
	 * Valid placements are:
	 * - `auto`
	 * - `top`
	 * - `right`
	 * - `bottom`
	 * - `left`
	 *
	 * Each placement can have a variation from this list:
	 * - `-start`
	 * - `-end`
	 *
	 * Variations are interpreted easily if you think of them as the left to right
	 * written languages. Horizontally (`top` and `bottom`), `start` is left and `end`
	 * is right.<br />
	 * Vertically (`left` and `right`), `start` is top and `end` is bottom.
	 *
	 * Some valid examples are:
	 * - `top-end` (on top of reference, right aligned)
	 * - `right-start` (on right of reference, top aligned)
	 * - `bottom` (on bottom, centered)
	 * - `auto-end` (on the side with more space available, alignment depends by placement)
	 *
	 * @static
	 * @type {Array}
	 * @enum {String}
	 * @readonly
	 * @method placements
	 * @memberof Popper
	 */
	var placements = ['auto-start', 'auto', 'auto-end', 'top-start', 'top', 'top-end', 'right-start', 'right', 'right-end', 'bottom-end', 'bottom', 'bottom-start', 'left-end', 'left', 'left-start'];
	
	// Get rid of `auto` `auto-start` and `auto-end`
	var validPlacements = placements.slice(3);
	
	/**
	 * Given an initial placement, returns all the subsequent placements
	 * clockwise (or counter-clockwise).
	 *
	 * @method
	 * @memberof Popper.Utils
	 * @argument {String} placement - A valid placement (it accepts variations)
	 * @argument {Boolean} counter - Set to true to walk the placements counterclockwise
	 * @returns {Array} placements including their variations
	 */
	function clockwise(placement) {
	  var counter = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	
	  var index = validPlacements.indexOf(placement);
	  var arr = validPlacements.slice(index + 1).concat(validPlacements.slice(0, index));
	  return counter ? arr.reverse() : arr;
	}
	
	var BEHAVIORS = {
	  FLIP: 'flip',
	  CLOCKWISE: 'clockwise',
	  COUNTERCLOCKWISE: 'counterclockwise'
	};
	
	/**
	 * @function
	 * @memberof Modifiers
	 * @argument {Object} data - The data object generated by update method
	 * @argument {Object} options - Modifiers configuration and options
	 * @returns {Object} The data object, properly modified
	 */
	function flip(data, options) {
	  // if `inner` modifier is enabled, we can't use the `flip` modifier
	  if (isModifierEnabled(data.instance.modifiers, 'inner')) {
	    return data;
	  }
	
	  if (data.flipped && data.placement === data.originalPlacement) {
	    // seems like flip is trying to loop, probably there's not enough space on any of the flippable sides
	    return data;
	  }
	
	  var boundaries = getBoundaries(data.instance.popper, data.instance.reference, options.padding, options.boundariesElement, data.positionFixed);
	
	  var placement = data.placement.split('-')[0];
	  var placementOpposite = getOppositePlacement(placement);
	  var variation = data.placement.split('-')[1] || '';
	
	  var flipOrder = [];
	
	  switch (options.behavior) {
	    case BEHAVIORS.FLIP:
	      flipOrder = [placement, placementOpposite];
	      break;
	    case BEHAVIORS.CLOCKWISE:
	      flipOrder = clockwise(placement);
	      break;
	    case BEHAVIORS.COUNTERCLOCKWISE:
	      flipOrder = clockwise(placement, true);
	      break;
	    default:
	      flipOrder = options.behavior;
	  }
	
	  flipOrder.forEach(function (step, index) {
	    if (placement !== step || flipOrder.length === index + 1) {
	      return data;
	    }
	
	    placement = data.placement.split('-')[0];
	    placementOpposite = getOppositePlacement(placement);
	
	    var popperOffsets = data.offsets.popper;
	    var refOffsets = data.offsets.reference;
	
	    // using floor because the reference offsets may contain decimals we are not going to consider here
	    var floor = Math.floor;
	    var overlapsRef = placement === 'left' && floor(popperOffsets.right) > floor(refOffsets.left) || placement === 'right' && floor(popperOffsets.left) < floor(refOffsets.right) || placement === 'top' && floor(popperOffsets.bottom) > floor(refOffsets.top) || placement === 'bottom' && floor(popperOffsets.top) < floor(refOffsets.bottom);
	
	    var overflowsLeft = floor(popperOffsets.left) < floor(boundaries.left);
	    var overflowsRight = floor(popperOffsets.right) > floor(boundaries.right);
	    var overflowsTop = floor(popperOffsets.top) < floor(boundaries.top);
	    var overflowsBottom = floor(popperOffsets.bottom) > floor(boundaries.bottom);
	
	    var overflowsBoundaries = placement === 'left' && overflowsLeft || placement === 'right' && overflowsRight || placement === 'top' && overflowsTop || placement === 'bottom' && overflowsBottom;
	
	    // flip the variation if required
	    var isVertical = ['top', 'bottom'].indexOf(placement) !== -1;
	
	    // flips variation if reference element overflows boundaries
	    var flippedVariationByRef = !!options.flipVariations && (isVertical && variation === 'start' && overflowsLeft || isVertical && variation === 'end' && overflowsRight || !isVertical && variation === 'start' && overflowsTop || !isVertical && variation === 'end' && overflowsBottom);
	
	    // flips variation if popper content overflows boundaries
	    var flippedVariationByContent = !!options.flipVariationsByContent && (isVertical && variation === 'start' && overflowsRight || isVertical && variation === 'end' && overflowsLeft || !isVertical && variation === 'start' && overflowsBottom || !isVertical && variation === 'end' && overflowsTop);
	
	    var flippedVariation = flippedVariationByRef || flippedVariationByContent;
	
	    if (overlapsRef || overflowsBoundaries || flippedVariation) {
	      // this boolean to detect any flip loop
	      data.flipped = true;
	
	      if (overlapsRef || overflowsBoundaries) {
	        placement = flipOrder[index + 1];
	      }
	
	      if (flippedVariation) {
	        variation = getOppositeVariation(variation);
	      }
	
	      data.placement = placement + (variation ? '-' + variation : '');
	
	      // this object contains `position`, we want to preserve it along with
	      // any additional property we may add in the future
	      data.offsets.popper = _extends({}, data.offsets.popper, getPopperOffsets(data.instance.popper, data.offsets.reference, data.placement));
	
	      data = runModifiers(data.instance.modifiers, data, 'flip');
	    }
	  });
	  return data;
	}
	
	/**
	 * @function
	 * @memberof Modifiers
	 * @argument {Object} data - The data object generated by update method
	 * @argument {Object} options - Modifiers configuration and options
	 * @returns {Object} The data object, properly modified
	 */
	function keepTogether(data) {
	  var _data$offsets = data.offsets,
	      popper = _data$offsets.popper,
	      reference = _data$offsets.reference;
	
	  var placement = data.placement.split('-')[0];
	  var floor = Math.floor;
	  var isVertical = ['top', 'bottom'].indexOf(placement) !== -1;
	  var side = isVertical ? 'right' : 'bottom';
	  var opSide = isVertical ? 'left' : 'top';
	  var measurement = isVertical ? 'width' : 'height';
	
	  if (popper[side] < floor(reference[opSide])) {
	    data.offsets.popper[opSide] = floor(reference[opSide]) - popper[measurement];
	  }
	  if (popper[opSide] > floor(reference[side])) {
	    data.offsets.popper[opSide] = floor(reference[side]);
	  }
	
	  return data;
	}
	
	/**
	 * Converts a string containing value + unit into a px value number
	 * @function
	 * @memberof {modifiers~offset}
	 * @private
	 * @argument {String} str - Value + unit string
	 * @argument {String} measurement - `height` or `width`
	 * @argument {Object} popperOffsets
	 * @argument {Object} referenceOffsets
	 * @returns {Number|String}
	 * Value in pixels, or original string if no values were extracted
	 */
	function toValue(str, measurement, popperOffsets, referenceOffsets) {
	  // separate value from unit
	  var split = str.match(/((?:\-|\+)?\d*\.?\d*)(.*)/);
	  var value = +split[1];
	  var unit = split[2];
	
	  // If it's not a number it's an operator, I guess
	  if (!value) {
	    return str;
	  }
	
	  if (unit.indexOf('%') === 0) {
	    var element = void 0;
	    switch (unit) {
	      case '%p':
	        element = popperOffsets;
	        break;
	      case '%':
	      case '%r':
	      default:
	        element = referenceOffsets;
	    }
	
	    var rect = getClientRect(element);
	    return rect[measurement] / 100 * value;
	  } else if (unit === 'vh' || unit === 'vw') {
	    // if is a vh or vw, we calculate the size based on the viewport
	    var size = void 0;
	    if (unit === 'vh') {
	      size = Math.max(document.documentElement.clientHeight, window.innerHeight || 0);
	    } else {
	      size = Math.max(document.documentElement.clientWidth, window.innerWidth || 0);
	    }
	    return size / 100 * value;
	  } else {
	    // if is an explicit pixel unit, we get rid of the unit and keep the value
	    // if is an implicit unit, it's px, and we return just the value
	    return value;
	  }
	}
	
	/**
	 * Parse an `offset` string to extrapolate `x` and `y` numeric offsets.
	 * @function
	 * @memberof {modifiers~offset}
	 * @private
	 * @argument {String} offset
	 * @argument {Object} popperOffsets
	 * @argument {Object} referenceOffsets
	 * @argument {String} basePlacement
	 * @returns {Array} a two cells array with x and y offsets in numbers
	 */
	function parseOffset(offset, popperOffsets, referenceOffsets, basePlacement) {
	  var offsets = [0, 0];
	
	  // Use height if placement is left or right and index is 0 otherwise use width
	  // in this way the first offset will use an axis and the second one
	  // will use the other one
	  var useHeight = ['right', 'left'].indexOf(basePlacement) !== -1;
	
	  // Split the offset string to obtain a list of values and operands
	  // The regex addresses values with the plus or minus sign in front (+10, -20, etc)
	  var fragments = offset.split(/(\+|\-)/).map(function (frag) {
	    return frag.trim();
	  });
	
	  // Detect if the offset string contains a pair of values or a single one
	  // they could be separated by comma or space
	  var divider = fragments.indexOf(find(fragments, function (frag) {
	    return frag.search(/,|\s/) !== -1;
	  }));
	
	  if (fragments[divider] && fragments[divider].indexOf(',') === -1) {
	    console.warn('Offsets separated by white space(s) are deprecated, use a comma (,) instead.');
	  }
	
	  // If divider is found, we divide the list of values and operands to divide
	  // them by ofset X and Y.
	  var splitRegex = /\s*,\s*|\s+/;
	  var ops = divider !== -1 ? [fragments.slice(0, divider).concat([fragments[divider].split(splitRegex)[0]]), [fragments[divider].split(splitRegex)[1]].concat(fragments.slice(divider + 1))] : [fragments];
	
	  // Convert the values with units to absolute pixels to allow our computations
	  ops = ops.map(function (op, index) {
	    // Most of the units rely on the orientation of the popper
	    var measurement = (index === 1 ? !useHeight : useHeight) ? 'height' : 'width';
	    var mergeWithPrevious = false;
	    return op
	    // This aggregates any `+` or `-` sign that aren't considered operators
	    // e.g.: 10 + +5 => [10, +, +5]
	    .reduce(function (a, b) {
	      if (a[a.length - 1] === '' && ['+', '-'].indexOf(b) !== -1) {
	        a[a.length - 1] = b;
	        mergeWithPrevious = true;
	        return a;
	      } else if (mergeWithPrevious) {
	        a[a.length - 1] += b;
	        mergeWithPrevious = false;
	        return a;
	      } else {
	        return a.concat(b);
	      }
	    }, [])
	    // Here we convert the string values into number values (in px)
	    .map(function (str) {
	      return toValue(str, measurement, popperOffsets, referenceOffsets);
	    });
	  });
	
	  // Loop trough the offsets arrays and execute the operations
	  ops.forEach(function (op, index) {
	    op.forEach(function (frag, index2) {
	      if (isNumeric(frag)) {
	        offsets[index] += frag * (op[index2 - 1] === '-' ? -1 : 1);
	      }
	    });
	  });
	  return offsets;
	}
	
	/**
	 * @function
	 * @memberof Modifiers
	 * @argument {Object} data - The data object generated by update method
	 * @argument {Object} options - Modifiers configuration and options
	 * @argument {Number|String} options.offset=0
	 * The offset value as described in the modifier description
	 * @returns {Object} The data object, properly modified
	 */
	function offset(data, _ref) {
	  var offset = _ref.offset;
	  var placement = data.placement,
	      _data$offsets = data.offsets,
	      popper = _data$offsets.popper,
	      reference = _data$offsets.reference;
	
	  var basePlacement = placement.split('-')[0];
	
	  var offsets = void 0;
	  if (isNumeric(+offset)) {
	    offsets = [+offset, 0];
	  } else {
	    offsets = parseOffset(offset, popper, reference, basePlacement);
	  }
	
	  if (basePlacement === 'left') {
	    popper.top += offsets[0];
	    popper.left -= offsets[1];
	  } else if (basePlacement === 'right') {
	    popper.top += offsets[0];
	    popper.left += offsets[1];
	  } else if (basePlacement === 'top') {
	    popper.left += offsets[0];
	    popper.top -= offsets[1];
	  } else if (basePlacement === 'bottom') {
	    popper.left += offsets[0];
	    popper.top += offsets[1];
	  }
	
	  data.popper = popper;
	  return data;
	}
	
	/**
	 * @function
	 * @memberof Modifiers
	 * @argument {Object} data - The data object generated by `update` method
	 * @argument {Object} options - Modifiers configuration and options
	 * @returns {Object} The data object, properly modified
	 */
	function preventOverflow(data, options) {
	  var boundariesElement = options.boundariesElement || getOffsetParent(data.instance.popper);
	
	  // If offsetParent is the reference element, we really want to
	  // go one step up and use the next offsetParent as reference to
	  // avoid to make this modifier completely useless and look like broken
	  if (data.instance.reference === boundariesElement) {
	    boundariesElement = getOffsetParent(boundariesElement);
	  }
	
	  // NOTE: DOM access here
	  // resets the popper's position so that the document size can be calculated excluding
	  // the size of the popper element itself
	  var transformProp = getSupportedPropertyName('transform');
	  var popperStyles = data.instance.popper.style; // assignment to help minification
	  var top = popperStyles.top,
	      left = popperStyles.left,
	      transform = popperStyles[transformProp];
	
	  popperStyles.top = '';
	  popperStyles.left = '';
	  popperStyles[transformProp] = '';
	
	  var boundaries = getBoundaries(data.instance.popper, data.instance.reference, options.padding, boundariesElement, data.positionFixed);
	
	  // NOTE: DOM access here
	  // restores the original style properties after the offsets have been computed
	  popperStyles.top = top;
	  popperStyles.left = left;
	  popperStyles[transformProp] = transform;
	
	  options.boundaries = boundaries;
	
	  var order = options.priority;
	  var popper = data.offsets.popper;
	
	  var check = {
	    primary: function primary(placement) {
	      var value = popper[placement];
	      if (popper[placement] < boundaries[placement] && !options.escapeWithReference) {
	        value = Math.max(popper[placement], boundaries[placement]);
	      }
	      return defineProperty({}, placement, value);
	    },
	    secondary: function secondary(placement) {
	      var mainSide = placement === 'right' ? 'left' : 'top';
	      var value = popper[mainSide];
	      if (popper[placement] > boundaries[placement] && !options.escapeWithReference) {
	        value = Math.min(popper[mainSide], boundaries[placement] - (placement === 'right' ? popper.width : popper.height));
	      }
	      return defineProperty({}, mainSide, value);
	    }
	  };
	
	  order.forEach(function (placement) {
	    var side = ['left', 'top'].indexOf(placement) !== -1 ? 'primary' : 'secondary';
	    popper = _extends({}, popper, check[side](placement));
	  });
	
	  data.offsets.popper = popper;
	
	  return data;
	}
	
	/**
	 * @function
	 * @memberof Modifiers
	 * @argument {Object} data - The data object generated by `update` method
	 * @argument {Object} options - Modifiers configuration and options
	 * @returns {Object} The data object, properly modified
	 */
	function shift(data) {
	  var placement = data.placement;
	  var basePlacement = placement.split('-')[0];
	  var shiftvariation = placement.split('-')[1];
	
	  // if shift shiftvariation is specified, run the modifier
	  if (shiftvariation) {
	    var _data$offsets = data.offsets,
	        reference = _data$offsets.reference,
	        popper = _data$offsets.popper;
	
	    var isVertical = ['bottom', 'top'].indexOf(basePlacement) !== -1;
	    var side = isVertical ? 'left' : 'top';
	    var measurement = isVertical ? 'width' : 'height';
	
	    var shiftOffsets = {
	      start: defineProperty({}, side, reference[side]),
	      end: defineProperty({}, side, reference[side] + reference[measurement] - popper[measurement])
	    };
	
	    data.offsets.popper = _extends({}, popper, shiftOffsets[shiftvariation]);
	  }
	
	  return data;
	}
	
	/**
	 * @function
	 * @memberof Modifiers
	 * @argument {Object} data - The data object generated by update method
	 * @argument {Object} options - Modifiers configuration and options
	 * @returns {Object} The data object, properly modified
	 */
	function hide(data) {
	  if (!isModifierRequired(data.instance.modifiers, 'hide', 'preventOverflow')) {
	    return data;
	  }
	
	  var refRect = data.offsets.reference;
	  var bound = find(data.instance.modifiers, function (modifier) {
	    return modifier.name === 'preventOverflow';
	  }).boundaries;
	
	  if (refRect.bottom < bound.top || refRect.left > bound.right || refRect.top > bound.bottom || refRect.right < bound.left) {
	    // Avoid unnecessary DOM access if visibility hasn't changed
	    if (data.hide === true) {
	      return data;
	    }
	
	    data.hide = true;
	    data.attributes['x-out-of-boundaries'] = '';
	  } else {
	    // Avoid unnecessary DOM access if visibility hasn't changed
	    if (data.hide === false) {
	      return data;
	    }
	
	    data.hide = false;
	    data.attributes['x-out-of-boundaries'] = false;
	  }
	
	  return data;
	}
	
	/**
	 * @function
	 * @memberof Modifiers
	 * @argument {Object} data - The data object generated by `update` method
	 * @argument {Object} options - Modifiers configuration and options
	 * @returns {Object} The data object, properly modified
	 */
	function inner(data) {
	  var placement = data.placement;
	  var basePlacement = placement.split('-')[0];
	  var _data$offsets = data.offsets,
	      popper = _data$offsets.popper,
	      reference = _data$offsets.reference;
	
	  var isHoriz = ['left', 'right'].indexOf(basePlacement) !== -1;
	
	  var subtractLength = ['top', 'left'].indexOf(basePlacement) === -1;
	
	  popper[isHoriz ? 'left' : 'top'] = reference[basePlacement] - (subtractLength ? popper[isHoriz ? 'width' : 'height'] : 0);
	
	  data.placement = getOppositePlacement(placement);
	  data.offsets.popper = getClientRect(popper);
	
	  return data;
	}
	
	/**
	 * Modifier function, each modifier can have a function of this type assigned
	 * to its `fn` property.<br />
	 * These functions will be called on each update, this means that you must
	 * make sure they are performant enough to avoid performance bottlenecks.
	 *
	 * @function ModifierFn
	 * @argument {dataObject} data - The data object generated by `update` method
	 * @argument {Object} options - Modifiers configuration and options
	 * @returns {dataObject} The data object, properly modified
	 */
	
	/**
	 * Modifiers are plugins used to alter the behavior of your poppers.<br />
	 * Popper.js uses a set of 9 modifiers to provide all the basic functionalities
	 * needed by the library.
	 *
	 * Usually you don't want to override the `order`, `fn` and `onLoad` props.
	 * All the other properties are configurations that could be tweaked.
	 * @namespace modifiers
	 */
	var modifiers = {
	  /**
	   * Modifier used to shift the popper on the start or end of its reference
	   * element.<br />
	   * It will read the variation of the `placement` property.<br />
	   * It can be one either `-end` or `-start`.
	   * @memberof modifiers
	   * @inner
	   */
	  shift: {
	    /** @prop {number} order=100 - Index used to define the order of execution */
	    order: 100,
	    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
	    enabled: true,
	    /** @prop {ModifierFn} */
	    fn: shift
	  },
	
	  /**
	   * The `offset` modifier can shift your popper on both its axis.
	   *
	   * It accepts the following units:
	   * - `px` or unit-less, interpreted as pixels
	   * - `%` or `%r`, percentage relative to the length of the reference element
	   * - `%p`, percentage relative to the length of the popper element
	   * - `vw`, CSS viewport width unit
	   * - `vh`, CSS viewport height unit
	   *
	   * For length is intended the main axis relative to the placement of the popper.<br />
	   * This means that if the placement is `top` or `bottom`, the length will be the
	   * `width`. In case of `left` or `right`, it will be the `height`.
	   *
	   * You can provide a single value (as `Number` or `String`), or a pair of values
	   * as `String` divided by a comma or one (or more) white spaces.<br />
	   * The latter is a deprecated method because it leads to confusion and will be
	   * removed in v2.<br />
	   * Additionally, it accepts additions and subtractions between different units.
	   * Note that multiplications and divisions aren't supported.
	   *
	   * Valid examples are:
	   * ```
	   * 10
	   * '10%'
	   * '10, 10'
	   * '10%, 10'
	   * '10 + 10%'
	   * '10 - 5vh + 3%'
	   * '-10px + 5vh, 5px - 6%'
	   * ```
	   * > **NB**: If you desire to apply offsets to your poppers in a way that may make them overlap
	   * > with their reference element, unfortunately, you will have to disable the `flip` modifier.
	   * > You can read more on this at this [issue](https://github.com/FezVrasta/popper.js/issues/373).
	   *
	   * @memberof modifiers
	   * @inner
	   */
	  offset: {
	    /** @prop {number} order=200 - Index used to define the order of execution */
	    order: 200,
	    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
	    enabled: true,
	    /** @prop {ModifierFn} */
	    fn: offset,
	    /** @prop {Number|String} offset=0
	     * The offset value as described in the modifier description
	     */
	    offset: 0
	  },
	
	  /**
	   * Modifier used to prevent the popper from being positioned outside the boundary.
	   *
	   * A scenario exists where the reference itself is not within the boundaries.<br />
	   * We can say it has "escaped the boundaries" — or just "escaped".<br />
	   * In this case we need to decide whether the popper should either:
	   *
	   * - detach from the reference and remain "trapped" in the boundaries, or
	   * - if it should ignore the boundary and "escape with its reference"
	   *
	   * When `escapeWithReference` is set to`true` and reference is completely
	   * outside its boundaries, the popper will overflow (or completely leave)
	   * the boundaries in order to remain attached to the edge of the reference.
	   *
	   * @memberof modifiers
	   * @inner
	   */
	  preventOverflow: {
	    /** @prop {number} order=300 - Index used to define the order of execution */
	    order: 300,
	    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
	    enabled: true,
	    /** @prop {ModifierFn} */
	    fn: preventOverflow,
	    /**
	     * @prop {Array} [priority=['left','right','top','bottom']]
	     * Popper will try to prevent overflow following these priorities by default,
	     * then, it could overflow on the left and on top of the `boundariesElement`
	     */
	    priority: ['left', 'right', 'top', 'bottom'],
	    /**
	     * @prop {number} padding=5
	     * Amount of pixel used to define a minimum distance between the boundaries
	     * and the popper. This makes sure the popper always has a little padding
	     * between the edges of its container
	     */
	    padding: 5,
	    /**
	     * @prop {String|HTMLElement} boundariesElement='scrollParent'
	     * Boundaries used by the modifier. Can be `scrollParent`, `window`,
	     * `viewport` or any DOM element.
	     */
	    boundariesElement: 'scrollParent'
	  },
	
	  /**
	   * Modifier used to make sure the reference and its popper stay near each other
	   * without leaving any gap between the two. Especially useful when the arrow is
	   * enabled and you want to ensure that it points to its reference element.
	   * It cares only about the first axis. You can still have poppers with margin
	   * between the popper and its reference element.
	   * @memberof modifiers
	   * @inner
	   */
	  keepTogether: {
	    /** @prop {number} order=400 - Index used to define the order of execution */
	    order: 400,
	    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
	    enabled: true,
	    /** @prop {ModifierFn} */
	    fn: keepTogether
	  },
	
	  /**
	   * This modifier is used to move the `arrowElement` of the popper to make
	   * sure it is positioned between the reference element and its popper element.
	   * It will read the outer size of the `arrowElement` node to detect how many
	   * pixels of conjunction are needed.
	   *
	   * It has no effect if no `arrowElement` is provided.
	   * @memberof modifiers
	   * @inner
	   */
	  arrow: {
	    /** @prop {number} order=500 - Index used to define the order of execution */
	    order: 500,
	    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
	    enabled: true,
	    /** @prop {ModifierFn} */
	    fn: arrow,
	    /** @prop {String|HTMLElement} element='[x-arrow]' - Selector or node used as arrow */
	    element: '[x-arrow]'
	  },
	
	  /**
	   * Modifier used to flip the popper's placement when it starts to overlap its
	   * reference element.
	   *
	   * Requires the `preventOverflow` modifier before it in order to work.
	   *
	   * **NOTE:** this modifier will interrupt the current update cycle and will
	   * restart it if it detects the need to flip the placement.
	   * @memberof modifiers
	   * @inner
	   */
	  flip: {
	    /** @prop {number} order=600 - Index used to define the order of execution */
	    order: 600,
	    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
	    enabled: true,
	    /** @prop {ModifierFn} */
	    fn: flip,
	    /**
	     * @prop {String|Array} behavior='flip'
	     * The behavior used to change the popper's placement. It can be one of
	     * `flip`, `clockwise`, `counterclockwise` or an array with a list of valid
	     * placements (with optional variations)
	     */
	    behavior: 'flip',
	    /**
	     * @prop {number} padding=5
	     * The popper will flip if it hits the edges of the `boundariesElement`
	     */
	    padding: 5,
	    /**
	     * @prop {String|HTMLElement} boundariesElement='viewport'
	     * The element which will define the boundaries of the popper position.
	     * The popper will never be placed outside of the defined boundaries
	     * (except if `keepTogether` is enabled)
	     */
	    boundariesElement: 'viewport',
	    /**
	     * @prop {Boolean} flipVariations=false
	     * The popper will switch placement variation between `-start` and `-end` when
	     * the reference element overlaps its boundaries.
	     *
	     * The original placement should have a set variation.
	     */
	    flipVariations: false,
	    /**
	     * @prop {Boolean} flipVariationsByContent=false
	     * The popper will switch placement variation between `-start` and `-end` when
	     * the popper element overlaps its reference boundaries.
	     *
	     * The original placement should have a set variation.
	     */
	    flipVariationsByContent: false
	  },
	
	  /**
	   * Modifier used to make the popper flow toward the inner of the reference element.
	   * By default, when this modifier is disabled, the popper will be placed outside
	   * the reference element.
	   * @memberof modifiers
	   * @inner
	   */
	  inner: {
	    /** @prop {number} order=700 - Index used to define the order of execution */
	    order: 700,
	    /** @prop {Boolean} enabled=false - Whether the modifier is enabled or not */
	    enabled: false,
	    /** @prop {ModifierFn} */
	    fn: inner
	  },
	
	  /**
	   * Modifier used to hide the popper when its reference element is outside of the
	   * popper boundaries. It will set a `x-out-of-boundaries` attribute which can
	   * be used to hide with a CSS selector the popper when its reference is
	   * out of boundaries.
	   *
	   * Requires the `preventOverflow` modifier before it in order to work.
	   * @memberof modifiers
	   * @inner
	   */
	  hide: {
	    /** @prop {number} order=800 - Index used to define the order of execution */
	    order: 800,
	    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
	    enabled: true,
	    /** @prop {ModifierFn} */
	    fn: hide
	  },
	
	  /**
	   * Computes the style that will be applied to the popper element to gets
	   * properly positioned.
	   *
	   * Note that this modifier will not touch the DOM, it just prepares the styles
	   * so that `applyStyle` modifier can apply it. This separation is useful
	   * in case you need to replace `applyStyle` with a custom implementation.
	   *
	   * This modifier has `850` as `order` value to maintain backward compatibility
	   * with previous versions of Popper.js. Expect the modifiers ordering method
	   * to change in future major versions of the library.
	   *
	   * @memberof modifiers
	   * @inner
	   */
	  computeStyle: {
	    /** @prop {number} order=850 - Index used to define the order of execution */
	    order: 850,
	    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
	    enabled: true,
	    /** @prop {ModifierFn} */
	    fn: computeStyle,
	    /**
	     * @prop {Boolean} gpuAcceleration=true
	     * If true, it uses the CSS 3D transformation to position the popper.
	     * Otherwise, it will use the `top` and `left` properties
	     */
	    gpuAcceleration: true,
	    /**
	     * @prop {string} [x='bottom']
	     * Where to anchor the X axis (`bottom` or `top`). AKA X offset origin.
	     * Change this if your popper should grow in a direction different from `bottom`
	     */
	    x: 'bottom',
	    /**
	     * @prop {string} [x='left']
	     * Where to anchor the Y axis (`left` or `right`). AKA Y offset origin.
	     * Change this if your popper should grow in a direction different from `right`
	     */
	    y: 'right'
	  },
	
	  /**
	   * Applies the computed styles to the popper element.
	   *
	   * All the DOM manipulations are limited to this modifier. This is useful in case
	   * you want to integrate Popper.js inside a framework or view library and you
	   * want to delegate all the DOM manipulations to it.
	   *
	   * Note that if you disable this modifier, you must make sure the popper element
	   * has its position set to `absolute` before Popper.js can do its work!
	   *
	   * Just disable this modifier and define your own to achieve the desired effect.
	   *
	   * @memberof modifiers
	   * @inner
	   */
	  applyStyle: {
	    /** @prop {number} order=900 - Index used to define the order of execution */
	    order: 900,
	    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
	    enabled: true,
	    /** @prop {ModifierFn} */
	    fn: applyStyle,
	    /** @prop {Function} */
	    onLoad: applyStyleOnLoad,
	    /**
	     * @deprecated since version 1.10.0, the property moved to `computeStyle` modifier
	     * @prop {Boolean} gpuAcceleration=true
	     * If true, it uses the CSS 3D transformation to position the popper.
	     * Otherwise, it will use the `top` and `left` properties
	     */
	    gpuAcceleration: undefined
	  }
	};
	
	/**
	 * The `dataObject` is an object containing all the information used by Popper.js.
	 * This object is passed to modifiers and to the `onCreate` and `onUpdate` callbacks.
	 * @name dataObject
	 * @property {Object} data.instance The Popper.js instance
	 * @property {String} data.placement Placement applied to popper
	 * @property {String} data.originalPlacement Placement originally defined on init
	 * @property {Boolean} data.flipped True if popper has been flipped by flip modifier
	 * @property {Boolean} data.hide True if the reference element is out of boundaries, useful to know when to hide the popper
	 * @property {HTMLElement} data.arrowElement Node used as arrow by arrow modifier
	 * @property {Object} data.styles Any CSS property defined here will be applied to the popper. It expects the JavaScript nomenclature (eg. `marginBottom`)
	 * @property {Object} data.arrowStyles Any CSS property defined here will be applied to the popper arrow. It expects the JavaScript nomenclature (eg. `marginBottom`)
	 * @property {Object} data.boundaries Offsets of the popper boundaries
	 * @property {Object} data.offsets The measurements of popper, reference and arrow elements
	 * @property {Object} data.offsets.popper `top`, `left`, `width`, `height` values
	 * @property {Object} data.offsets.reference `top`, `left`, `width`, `height` values
	 * @property {Object} data.offsets.arrow] `top` and `left` offsets, only one of them will be different from 0
	 */
	
	/**
	 * Default options provided to Popper.js constructor.<br />
	 * These can be overridden using the `options` argument of Popper.js.<br />
	 * To override an option, simply pass an object with the same
	 * structure of the `options` object, as the 3rd argument. For example:
	 * ```
	 * new Popper(ref, pop, {
	 *   modifiers: {
	 *     preventOverflow: { enabled: false }
	 *   }
	 * })
	 * ```
	 * @type {Object}
	 * @static
	 * @memberof Popper
	 */
	var Defaults = {
	  /**
	   * Popper's placement.
	   * @prop {Popper.placements} placement='bottom'
	   */
	  placement: 'bottom',
	
	  /**
	   * Set this to true if you want popper to position it self in 'fixed' mode
	   * @prop {Boolean} positionFixed=false
	   */
	  positionFixed: false,
	
	  /**
	   * Whether events (resize, scroll) are initially enabled.
	   * @prop {Boolean} eventsEnabled=true
	   */
	  eventsEnabled: true,
	
	  /**
	   * Set to true if you want to automatically remove the popper when
	   * you call the `destroy` method.
	   * @prop {Boolean} removeOnDestroy=false
	   */
	  removeOnDestroy: false,
	
	  /**
	   * Callback called when the popper is created.<br />
	   * By default, it is set to no-op.<br />
	   * Access Popper.js instance with `data.instance`.
	   * @prop {onCreate}
	   */
	  onCreate: function onCreate() {},
	
	  /**
	   * Callback called when the popper is updated. This callback is not called
	   * on the initialization/creation of the popper, but only on subsequent
	   * updates.<br />
	   * By default, it is set to no-op.<br />
	   * Access Popper.js instance with `data.instance`.
	   * @prop {onUpdate}
	   */
	  onUpdate: function onUpdate() {},
	
	  /**
	   * List of modifiers used to modify the offsets before they are applied to the popper.
	   * They provide most of the functionalities of Popper.js.
	   * @prop {modifiers}
	   */
	  modifiers: modifiers
	};
	
	/**
	 * @callback onCreate
	 * @param {dataObject} data
	 */
	
	/**
	 * @callback onUpdate
	 * @param {dataObject} data
	 */
	
	// Utils
	// Methods
	var Popper = function () {
	  /**
	   * Creates a new Popper.js instance.
	   * @class Popper
	   * @param {Element|referenceObject} reference - The reference element used to position the popper
	   * @param {Element} popper - The HTML / XML element used as the popper
	   * @param {Object} options - Your custom options to override the ones defined in [Defaults](#defaults)
	   * @return {Object} instance - The generated Popper.js instance
	   */
	  function Popper(reference, popper) {
	    var _this = this;
	
	    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	    classCallCheck(this, Popper);
	
	    this.scheduleUpdate = function () {
	      return requestAnimationFrame(_this.update);
	    };
	
	    // make update() debounced, so that it only runs at most once-per-tick
	    this.update = debounce(this.update.bind(this));
	
	    // with {} we create a new object with the options inside it
	    this.options = _extends({}, Popper.Defaults, options);
	
	    // init state
	    this.state = {
	      isDestroyed: false,
	      isCreated: false,
	      scrollParents: []
	    };
	
	    // get reference and popper elements (allow jQuery wrappers)
	    this.reference = reference && reference.jquery ? reference[0] : reference;
	    this.popper = popper && popper.jquery ? popper[0] : popper;
	
	    // Deep merge modifiers options
	    this.options.modifiers = {};
	    Object.keys(_extends({}, Popper.Defaults.modifiers, options.modifiers)).forEach(function (name) {
	      _this.options.modifiers[name] = _extends({}, Popper.Defaults.modifiers[name] || {}, options.modifiers ? options.modifiers[name] : {});
	    });
	
	    // Refactoring modifiers' list (Object => Array)
	    this.modifiers = Object.keys(this.options.modifiers).map(function (name) {
	      return _extends({
	        name: name
	      }, _this.options.modifiers[name]);
	    })
	    // sort the modifiers by order
	    .sort(function (a, b) {
	      return a.order - b.order;
	    });
	
	    // modifiers have the ability to execute arbitrary code when Popper.js get inited
	    // such code is executed in the same order of its modifier
	    // they could add new properties to their options configuration
	    // BE AWARE: don't add options to `options.modifiers.name` but to `modifierOptions`!
	    this.modifiers.forEach(function (modifierOptions) {
	      if (modifierOptions.enabled && isFunction(modifierOptions.onLoad)) {
	        modifierOptions.onLoad(_this.reference, _this.popper, _this.options, modifierOptions, _this.state);
	      }
	    });
	
	    // fire the first update to position the popper in the right place
	    this.update();
	
	    var eventsEnabled = this.options.eventsEnabled;
	    if (eventsEnabled) {
	      // setup event listeners, they will take care of update the position in specific situations
	      this.enableEventListeners();
	    }
	
	    this.state.eventsEnabled = eventsEnabled;
	  }
	
	  // We can't use class properties because they don't get listed in the
	  // class prototype and break stuff like Sinon stubs
	
	
	  createClass(Popper, [{
	    key: 'update',
	    value: function update$$1() {
	      return update.call(this);
	    }
	  }, {
	    key: 'destroy',
	    value: function destroy$$1() {
	      return destroy.call(this);
	    }
	  }, {
	    key: 'enableEventListeners',
	    value: function enableEventListeners$$1() {
	      return enableEventListeners.call(this);
	    }
	  }, {
	    key: 'disableEventListeners',
	    value: function disableEventListeners$$1() {
	      return disableEventListeners.call(this);
	    }
	
	    /**
	     * Schedules an update. It will run on the next UI update available.
	     * @method scheduleUpdate
	     * @memberof Popper
	     */
	
	
	    /**
	     * Collection of utilities useful when writing custom modifiers.
	     * Starting from version 1.7, this method is available only if you
	     * include `popper-utils.js` before `popper.js`.
	     *
	     * **DEPRECATION**: This way to access PopperUtils is deprecated
	     * and will be removed in v2! Use the PopperUtils module directly instead.
	     * Due to the high instability of the methods contained in Utils, we can't
	     * guarantee them to follow semver. Use them at your own risk!
	     * @static
	     * @private
	     * @type {Object}
	     * @deprecated since version 1.8
	     * @member Utils
	     * @memberof Popper
	     */
	
	  }]);
	  return Popper;
	}();
	
	/**
	 * The `referenceObject` is an object that provides an interface compatible with Popper.js
	 * and lets you use it as replacement of a real DOM node.<br />
	 * You can use this method to position a popper relatively to a set of coordinates
	 * in case you don't have a DOM node to use as reference.
	 *
	 * ```
	 * new Popper(referenceObject, popperNode);
	 * ```
	 *
	 * NB: This feature isn't supported in Internet Explorer 10.
	 * @name referenceObject
	 * @property {Function} data.getBoundingClientRect
	 * A function that returns a set of coordinates compatible with the native `getBoundingClientRect` method.
	 * @property {number} data.clientWidth
	 * An ES6 getter that will return the width of the virtual reference element.
	 * @property {number} data.clientHeight
	 * An ES6 getter that will return the height of the virtual reference element.
	 */
	
	
	Popper.Utils = (typeof window !== 'undefined' ? window : global).PopperUtils;
	Popper.placements = placements;
	Popper.Defaults = Defaults;
	
	return Popper;
	
	})));
	//# sourceMappingURL=popper.js.map
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 1285 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	//This file contains the ES6 extensions to the core Promises/A+ API
	
	var Promise = __webpack_require__(507);
	
	module.exports = Promise;
	
	/* Static Functions */
	
	var TRUE = valuePromise(true);
	var FALSE = valuePromise(false);
	var NULL = valuePromise(null);
	var UNDEFINED = valuePromise(undefined);
	var ZERO = valuePromise(0);
	var EMPTYSTRING = valuePromise('');
	
	function valuePromise(value) {
	  var p = new Promise(Promise._61);
	  p._81 = 1;
	  p._65 = value;
	  return p;
	}
	Promise.resolve = function (value) {
	  if (value instanceof Promise) return value;
	
	  if (value === null) return NULL;
	  if (value === undefined) return UNDEFINED;
	  if (value === true) return TRUE;
	  if (value === false) return FALSE;
	  if (value === 0) return ZERO;
	  if (value === '') return EMPTYSTRING;
	
	  if (typeof value === 'object' || typeof value === 'function') {
	    try {
	      var then = value.then;
	      if (typeof then === 'function') {
	        return new Promise(then.bind(value));
	      }
	    } catch (ex) {
	      return new Promise(function (resolve, reject) {
	        reject(ex);
	      });
	    }
	  }
	  return valuePromise(value);
	};
	
	Promise.all = function (arr) {
	  var args = Array.prototype.slice.call(arr);
	
	  return new Promise(function (resolve, reject) {
	    if (args.length === 0) return resolve([]);
	    var remaining = args.length;
	    function res(i, val) {
	      if (val && (typeof val === 'object' || typeof val === 'function')) {
	        if (val instanceof Promise && val.then === Promise.prototype.then) {
	          while (val._81 === 3) {
	            val = val._65;
	          }
	          if (val._81 === 1) return res(i, val._65);
	          if (val._81 === 2) reject(val._65);
	          val.then(function (val) {
	            res(i, val);
	          }, reject);
	          return;
	        } else {
	          var then = val.then;
	          if (typeof then === 'function') {
	            var p = new Promise(then.bind(val));
	            p.then(function (val) {
	              res(i, val);
	            }, reject);
	            return;
	          }
	        }
	      }
	      args[i] = val;
	      if (--remaining === 0) {
	        resolve(args);
	      }
	    }
	    for (var i = 0; i < args.length; i++) {
	      res(i, args[i]);
	    }
	  });
	};
	
	Promise.reject = function (value) {
	  return new Promise(function (resolve, reject) {
	    reject(value);
	  });
	};
	
	Promise.race = function (values) {
	  return new Promise(function (resolve, reject) {
	    values.forEach(function(value){
	      Promise.resolve(value).then(resolve, reject);
	    });
	  });
	};
	
	/* Prototype Methods */
	
	Promise.prototype['catch'] = function (onRejected) {
	  return this.then(null, onRejected);
	};


/***/ },
/* 1286 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var Promise = __webpack_require__(507);
	
	var DEFAULT_WHITELIST = [
	  ReferenceError,
	  TypeError,
	  RangeError
	];
	
	var enabled = false;
	exports.disable = disable;
	function disable() {
	  enabled = false;
	  Promise._10 = null;
	  Promise._97 = null;
	}
	
	exports.enable = enable;
	function enable(options) {
	  options = options || {};
	  if (enabled) disable();
	  enabled = true;
	  var id = 0;
	  var displayId = 0;
	  var rejections = {};
	  Promise._10 = function (promise) {
	    if (
	      promise._81 === 2 && // IS REJECTED
	      rejections[promise._72]
	    ) {
	      if (rejections[promise._72].logged) {
	        onHandled(promise._72);
	      } else {
	        clearTimeout(rejections[promise._72].timeout);
	      }
	      delete rejections[promise._72];
	    }
	  };
	  Promise._97 = function (promise, err) {
	    if (promise._45 === 0) { // not yet handled
	      promise._72 = id++;
	      rejections[promise._72] = {
	        displayId: null,
	        error: err,
	        timeout: setTimeout(
	          onUnhandled.bind(null, promise._72),
	          // For reference errors and type errors, this almost always
	          // means the programmer made a mistake, so log them after just
	          // 100ms
	          // otherwise, wait 2 seconds to see if they get handled
	          matchWhitelist(err, DEFAULT_WHITELIST)
	            ? 100
	            : 2000
	        ),
	        logged: false
	      };
	    }
	  };
	  function onUnhandled(id) {
	    if (
	      options.allRejections ||
	      matchWhitelist(
	        rejections[id].error,
	        options.whitelist || DEFAULT_WHITELIST
	      )
	    ) {
	      rejections[id].displayId = displayId++;
	      if (options.onUnhandled) {
	        rejections[id].logged = true;
	        options.onUnhandled(
	          rejections[id].displayId,
	          rejections[id].error
	        );
	      } else {
	        rejections[id].logged = true;
	        logError(
	          rejections[id].displayId,
	          rejections[id].error
	        );
	      }
	    }
	  }
	  function onHandled(id) {
	    if (rejections[id].logged) {
	      if (options.onHandled) {
	        options.onHandled(rejections[id].displayId, rejections[id].error);
	      } else if (!rejections[id].onUnhandled) {
	        console.warn(
	          'Promise Rejection Handled (id: ' + rejections[id].displayId + '):'
	        );
	        console.warn(
	          '  This means you can ignore any previous messages of the form "Possible Unhandled Promise Rejection" with id ' +
	          rejections[id].displayId + '.'
	        );
	      }
	    }
	  }
	}
	
	function logError(id, error) {
	  console.warn('Possible Unhandled Promise Rejection (id: ' + id + '):');
	  var errStr = (error && (error.stack || error)) + '';
	  errStr.split('\n').forEach(function (line) {
	    console.warn('  ' + line);
	  });
	}
	
	function matchWhitelist(error, list) {
	  return list.some(function (cls) {
	    return error instanceof cls;
	  });
	}

/***/ },
/* 1287 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';
	
	var ReactPropTypesSecret = __webpack_require__(1288);
	
	function emptyFunction() {}
	function emptyFunctionWithReset() {}
	emptyFunctionWithReset.resetWarningCache = emptyFunction;
	
	module.exports = function() {
	  function shim(props, propName, componentName, location, propFullName, secret) {
	    if (secret === ReactPropTypesSecret) {
	      // It is still safe when called from React.
	      return;
	    }
	    var err = new Error(
	      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
	      'Use PropTypes.checkPropTypes() to call them. ' +
	      'Read more at http://fb.me/use-check-prop-types'
	    );
	    err.name = 'Invariant Violation';
	    throw err;
	  };
	  shim.isRequired = shim;
	  function getShim() {
	    return shim;
	  };
	  // Important!
	  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
	  var ReactPropTypes = {
	    array: shim,
	    bool: shim,
	    func: shim,
	    number: shim,
	    object: shim,
	    string: shim,
	    symbol: shim,
	
	    any: shim,
	    arrayOf: getShim,
	    element: shim,
	    elementType: shim,
	    instanceOf: getShim,
	    node: shim,
	    objectOf: getShim,
	    oneOf: getShim,
	    oneOfType: getShim,
	    shape: getShim,
	    exact: getShim,
	
	    checkPropTypes: emptyFunctionWithReset,
	    resetWarningCache: emptyFunction
	  };
	
	  ReactPropTypes.PropTypes = ReactPropTypes;
	
	  return ReactPropTypes;
	};


/***/ },
/* 1288 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';
	
	var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';
	
	module.exports = ReactPropTypesSecret;


/***/ },
/* 1289 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {var now = __webpack_require__(1283)
	  , root = typeof window === 'undefined' ? global : window
	  , vendors = ['moz', 'webkit']
	  , suffix = 'AnimationFrame'
	  , raf = root['request' + suffix]
	  , caf = root['cancel' + suffix] || root['cancelRequest' + suffix]
	
	for(var i = 0; !raf && i < vendors.length; i++) {
	  raf = root[vendors[i] + 'Request' + suffix]
	  caf = root[vendors[i] + 'Cancel' + suffix]
	      || root[vendors[i] + 'CancelRequest' + suffix]
	}
	
	// Some versions of FF have rAF but not cAF
	if(!raf || !caf) {
	  var last = 0
	    , id = 0
	    , queue = []
	    , frameDuration = 1000 / 60
	
	  raf = function(callback) {
	    if(queue.length === 0) {
	      var _now = now()
	        , next = Math.max(0, frameDuration - (_now - last))
	      last = next + _now
	      setTimeout(function() {
	        var cp = queue.slice(0)
	        // Clear queue here to prevent
	        // callbacks from appending listeners
	        // to the current frame's queue
	        queue.length = 0
	        for(var i = 0; i < cp.length; i++) {
	          if(!cp[i].cancelled) {
	            try{
	              cp[i].callback(last)
	            } catch(e) {
	              setTimeout(function() { throw e }, 0)
	            }
	          }
	        }
	      }, Math.round(next))
	    }
	    queue.push({
	      handle: ++id,
	      callback: callback,
	      cancelled: false
	    })
	    return id
	  }
	
	  caf = function(handle) {
	    for(var i = 0; i < queue.length; i++) {
	      if(queue[i].handle === handle) {
	        queue[i].cancelled = true
	      }
	    }
	  }
	}
	
	module.exports = function(fn) {
	  // Wrap in a new function to prevent
	  // `cancel` potentially being assigned
	  // to the native rAF function
	  return raf.call(root, fn)
	}
	module.exports.cancel = function() {
	  caf.apply(root, arguments)
	}
	module.exports.polyfill = function(object) {
	  if (!object) {
	    object = root;
	  }
	  object.requestAnimationFrame = raf
	  object.cancelAnimationFrame = caf
	}
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 1290 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {!function(e,t){ true?t(exports,__webpack_require__(1),__webpack_require__(20),__webpack_require__(349),__webpack_require__(274),__webpack_require__(43),__webpack_require__(33),__webpack_require__(261),__webpack_require__(181),__webpack_require__(74),__webpack_require__(138),__webpack_require__(112),__webpack_require__(263),__webpack_require__(441),__webpack_require__(439),__webpack_require__(192),__webpack_require__(442),__webpack_require__(282),__webpack_require__(443),__webpack_require__(414),__webpack_require__(412),__webpack_require__(409),__webpack_require__(270),__webpack_require__(269),__webpack_require__(273),__webpack_require__(413),__webpack_require__(271),__webpack_require__(416),__webpack_require__(272),__webpack_require__(434),__webpack_require__(432),__webpack_require__(430),__webpack_require__(189),__webpack_require__(433),__webpack_require__(435),__webpack_require__(428),__webpack_require__(427),__webpack_require__(84),__webpack_require__(264),__webpack_require__(265),__webpack_require__(266),__webpack_require__(116),__webpack_require__(75),__webpack_require__(142),__webpack_require__(190),__webpack_require__(191),__webpack_require__(184),__webpack_require__(268),__webpack_require__(185),__webpack_require__(275),__webpack_require__(114),__webpack_require__(276),__webpack_require__(279),__webpack_require__(277),__webpack_require__(186),__webpack_require__(187),__webpack_require__(424),__webpack_require__(3),__webpack_require__(429),__webpack_require__(280),__webpack_require__(1291),__webpack_require__(1322)):"function"==typeof define&&define.amd?define(["exports","react","prop-types","classnames","date-fns/isDate","date-fns/isValid","date-fns/format","date-fns/addMinutes","date-fns/addHours","date-fns/addDays","date-fns/addWeeks","date-fns/addMonths","date-fns/addYears","date-fns/subMinutes","date-fns/subHours","date-fns/subDays","date-fns/subWeeks","date-fns/subMonths","date-fns/subYears","date-fns/getSeconds","date-fns/getMinutes","date-fns/getHours","date-fns/getDay","date-fns/getDate","date-fns/getWeek","date-fns/getMonth","date-fns/getQuarter","date-fns/getYear","date-fns/getTime","date-fns/setSeconds","date-fns/setMinutes","date-fns/setHours","date-fns/setMonth","date-fns/setQuarter","date-fns/setYear","date-fns/min","date-fns/max","date-fns/differenceInCalendarDays","date-fns/differenceInCalendarMonths","date-fns/differenceInCalendarWeeks","date-fns/differenceInCalendarYears","date-fns/startOfDay","date-fns/startOfWeek","date-fns/startOfMonth","date-fns/startOfQuarter","date-fns/startOfYear","date-fns/endOfDay","date-fns/endOfWeek","date-fns/endOfMonth","date-fns/isEqual","date-fns/isSameDay","date-fns/isSameMonth","date-fns/isSameYear","date-fns/isSameQuarter","date-fns/isAfter","date-fns/isBefore","date-fns/isWithinInterval","date-fns/toDate","date-fns/parse","date-fns/parseISO","react-onclickoutside","react-popper"],t):t((e=e||self).DatePicker={},e.React,e.PropTypes,e.classNames,e.isDate,e.isValidDate,e.format,e.addMinutes,e.addHours,e.utils,e.utils$1,e.addMonths,e.addYears,e.subMinutes,e.subHours,e.subDays,e.subWeeks,e.subMonths,e.subYears,e.getSeconds,e.getMinutes,e.getHours,e.getDay,e.getDate,e.dfgetWeek,e.getMonth,e.getQuarter,e.getYear,e.getTime,e.setSeconds,e.setMinutes,e.setHours,e.utils$2,e.utils$3,e.setYear,e.min,e.max,e.differenceInCalendarDays,e.differenceInCalendarMonths,e.differenceInCalendarWeeks,e.differenceInCalendarYears,e.startOfDay,e.startOfWeek,e.startOfMonth,e.startOfQuarter,e.startOfYear,e.endOfDay,e.endOfWeek,e.endOfMonth,e.dfIsEqual,e.dfIsSameDay,e.dfIsSameMonth,e.dfIsSameYear,e.dfIsSameQuarter,e.isAfter,e.isBefore,e.isWithinInterval,e.toDate,e.parse,e.parseISO,e.onClickOutside,e.ReactPopper)}(this,(function(e,t,r,n,a,o,s,p,i,c,l,d,u,h,f,m,y,v,w,D,k,g,b,C,_,O,S,P,M,E,N,Y,x,T,I,L,j,F,q,W,R,A,B,H,K,Q,V,U,$,z,G,J,X,Z,ee,te,re,ne,ae,oe,se,pe){"use strict";function ie(e){return(ie="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e})(e)}function ce(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}function le(e,t){for(var r=0;r<t.length;r++){var n=t[r];n.enumerable=n.enumerable||!1,n.configurable=!0,"value"in n&&(n.writable=!0),Object.defineProperty(e,n.key,n)}}function de(e,t,r){return t&&le(e.prototype,t),r&&le(e,r),e}function ue(e,t,r){return t in e?Object.defineProperty(e,t,{value:r,enumerable:!0,configurable:!0,writable:!0}):e[t]=r,e}function he(){return(he=Object.assign||function(e){for(var t=1;t<arguments.length;t++){var r=arguments[t];for(var n in r)Object.prototype.hasOwnProperty.call(r,n)&&(e[n]=r[n])}return e}).apply(this,arguments)}function fe(e,t){var r=Object.keys(e);if(Object.getOwnPropertySymbols){var n=Object.getOwnPropertySymbols(e);t&&(n=n.filter((function(t){return Object.getOwnPropertyDescriptor(e,t).enumerable}))),r.push.apply(r,n)}return r}function me(e){for(var t=1;t<arguments.length;t++){var r=null!=arguments[t]?arguments[t]:{};t%2?fe(Object(r),!0).forEach((function(t){ue(e,t,r[t])})):Object.getOwnPropertyDescriptors?Object.defineProperties(e,Object.getOwnPropertyDescriptors(r)):fe(Object(r)).forEach((function(t){Object.defineProperty(e,t,Object.getOwnPropertyDescriptor(r,t))}))}return e}function ye(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function");e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,writable:!0,configurable:!0}}),t&&we(e,t)}function ve(e){return(ve=Object.setPrototypeOf?Object.getPrototypeOf:function(e){return e.__proto__||Object.getPrototypeOf(e)})(e)}function we(e,t){return(we=Object.setPrototypeOf||function(e,t){return e.__proto__=t,e})(e,t)}function De(e){if(void 0===e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return e}function ke(e,t){return!t||"object"!=typeof t&&"function"!=typeof t?De(e):t}function ge(e){var t=function(){if("undefined"==typeof Reflect||!Reflect.construct)return!1;if(Reflect.construct.sham)return!1;if("function"==typeof Proxy)return!0;try{return Date.prototype.toString.call(Reflect.construct(Date,[],(function(){}))),!0}catch(e){return!1}}();return function(){var r,n=ve(e);if(t){var a=ve(this).constructor;r=Reflect.construct(n,arguments,a)}else r=n.apply(this,arguments);return ke(this,r)}}function be(e,t){switch(e){case"P":return t.date({width:"short"});case"PP":return t.date({width:"medium"});case"PPP":return t.date({width:"long"});case"PPPP":default:return t.date({width:"full"})}}function Ce(e,t){switch(e){case"p":return t.time({width:"short"});case"pp":return t.time({width:"medium"});case"ppp":return t.time({width:"long"});case"pppp":default:return t.time({width:"full"})}}t=t&&Object.prototype.hasOwnProperty.call(t,"default")?t.default:t,r=r&&Object.prototype.hasOwnProperty.call(r,"default")?r.default:r,n=n&&Object.prototype.hasOwnProperty.call(n,"default")?n.default:n,a=a&&Object.prototype.hasOwnProperty.call(a,"default")?a.default:a,o=o&&Object.prototype.hasOwnProperty.call(o,"default")?o.default:o,s=s&&Object.prototype.hasOwnProperty.call(s,"default")?s.default:s,p=p&&Object.prototype.hasOwnProperty.call(p,"default")?p.default:p,i=i&&Object.prototype.hasOwnProperty.call(i,"default")?i.default:i,c=c&&Object.prototype.hasOwnProperty.call(c,"default")?c.default:c,l=l&&Object.prototype.hasOwnProperty.call(l,"default")?l.default:l,d=d&&Object.prototype.hasOwnProperty.call(d,"default")?d.default:d,u=u&&Object.prototype.hasOwnProperty.call(u,"default")?u.default:u,h=h&&Object.prototype.hasOwnProperty.call(h,"default")?h.default:h,f=f&&Object.prototype.hasOwnProperty.call(f,"default")?f.default:f,m=m&&Object.prototype.hasOwnProperty.call(m,"default")?m.default:m,y=y&&Object.prototype.hasOwnProperty.call(y,"default")?y.default:y,v=v&&Object.prototype.hasOwnProperty.call(v,"default")?v.default:v,w=w&&Object.prototype.hasOwnProperty.call(w,"default")?w.default:w,D=D&&Object.prototype.hasOwnProperty.call(D,"default")?D.default:D,k=k&&Object.prototype.hasOwnProperty.call(k,"default")?k.default:k,g=g&&Object.prototype.hasOwnProperty.call(g,"default")?g.default:g,b=b&&Object.prototype.hasOwnProperty.call(b,"default")?b.default:b,C=C&&Object.prototype.hasOwnProperty.call(C,"default")?C.default:C,_=_&&Object.prototype.hasOwnProperty.call(_,"default")?_.default:_,O=O&&Object.prototype.hasOwnProperty.call(O,"default")?O.default:O,S=S&&Object.prototype.hasOwnProperty.call(S,"default")?S.default:S,P=P&&Object.prototype.hasOwnProperty.call(P,"default")?P.default:P,M=M&&Object.prototype.hasOwnProperty.call(M,"default")?M.default:M,E=E&&Object.prototype.hasOwnProperty.call(E,"default")?E.default:E,N=N&&Object.prototype.hasOwnProperty.call(N,"default")?N.default:N,Y=Y&&Object.prototype.hasOwnProperty.call(Y,"default")?Y.default:Y,x=x&&Object.prototype.hasOwnProperty.call(x,"default")?x.default:x,T=T&&Object.prototype.hasOwnProperty.call(T,"default")?T.default:T,I=I&&Object.prototype.hasOwnProperty.call(I,"default")?I.default:I,L=L&&Object.prototype.hasOwnProperty.call(L,"default")?L.default:L,j=j&&Object.prototype.hasOwnProperty.call(j,"default")?j.default:j,F=F&&Object.prototype.hasOwnProperty.call(F,"default")?F.default:F,q=q&&Object.prototype.hasOwnProperty.call(q,"default")?q.default:q,W=W&&Object.prototype.hasOwnProperty.call(W,"default")?W.default:W,R=R&&Object.prototype.hasOwnProperty.call(R,"default")?R.default:R,A=A&&Object.prototype.hasOwnProperty.call(A,"default")?A.default:A,B=B&&Object.prototype.hasOwnProperty.call(B,"default")?B.default:B,H=H&&Object.prototype.hasOwnProperty.call(H,"default")?H.default:H,K=K&&Object.prototype.hasOwnProperty.call(K,"default")?K.default:K,Q=Q&&Object.prototype.hasOwnProperty.call(Q,"default")?Q.default:Q,V=V&&Object.prototype.hasOwnProperty.call(V,"default")?V.default:V,U=U&&Object.prototype.hasOwnProperty.call(U,"default")?U.default:U,$=$&&Object.prototype.hasOwnProperty.call($,"default")?$.default:$,z=z&&Object.prototype.hasOwnProperty.call(z,"default")?z.default:z,G=G&&Object.prototype.hasOwnProperty.call(G,"default")?G.default:G,J=J&&Object.prototype.hasOwnProperty.call(J,"default")?J.default:J,X=X&&Object.prototype.hasOwnProperty.call(X,"default")?X.default:X,Z=Z&&Object.prototype.hasOwnProperty.call(Z,"default")?Z.default:Z,ee=ee&&Object.prototype.hasOwnProperty.call(ee,"default")?ee.default:ee,te=te&&Object.prototype.hasOwnProperty.call(te,"default")?te.default:te,re=re&&Object.prototype.hasOwnProperty.call(re,"default")?re.default:re,ne=ne&&Object.prototype.hasOwnProperty.call(ne,"default")?ne.default:ne,ae=ae&&Object.prototype.hasOwnProperty.call(ae,"default")?ae.default:ae,oe=oe&&Object.prototype.hasOwnProperty.call(oe,"default")?oe.default:oe,se=se&&Object.prototype.hasOwnProperty.call(se,"default")?se.default:se;var _e={p:Ce,P:function(e,t){var r,n=e.match(/(P+)(p+)?/),a=n[1],o=n[2];if(!o)return be(e,t);switch(a){case"P":r=t.dateTime({width:"short"});break;case"PP":r=t.dateTime({width:"medium"});break;case"PPP":r=t.dateTime({width:"long"});break;case"PPPP":default:r=t.dateTime({width:"full"})}return r.replace("{{date}}",be(a,t)).replace("{{time}}",Ce(o,t))}},Oe=/P+p+|P+|p+|''|'(''|[^'])+('|$)|./g;function Se(e){var t=e?"string"==typeof e||e instanceof String?oe(e):ne(e):new Date;return Me(t)?t:null}function Pe(e,t,r,n){var a=null,o=Ke(r)||He(),p=!0;return Array.isArray(t)?(t.forEach((function(t){var r=ae(e,t,new Date,{locale:o});n&&(p=Me(r)&&e===s(r,t,{awareOfUnicodeTokens:!0})),Me(r)&&p&&(a=r)})),a):(a=ae(e,t,new Date,{locale:o}),n?p=Me(a)&&e===s(a,t,{awareOfUnicodeTokens:!0}):Me(a)||(t=t.match(Oe).map((function(e){var t=e[0];return"p"===t||"P"===t?o?(0,_e[t])(e,o.formatLong):t:e})).join(""),e.length>0&&(a=ae(e,t.slice(0,e.length),new Date)),Me(a)||(a=new Date(e))),Me(a)&&p?a:null)}function Me(e){return o(e)&&ee(e,new Date("1/1/1000"))}function Ee(e,t,r){if("en"===r)return s(e,t,{awareOfUnicodeTokens:!0});var n=Ke(r);return r&&!n&&console.warn('A locale object was not found for the provided string ["'.concat(r,'"].')),!n&&He()&&Ke(He())&&(n=Ke(He())),s(e,t,{locale:n||null,awareOfUnicodeTokens:!0})}function Ne(e,t){var r=t.hour,n=void 0===r?0:r,a=t.minute,o=void 0===a?0:a,s=t.second;return Y(N(E(e,void 0===s?0:s),o),n)}function Ye(e,t){var r=t&&Ke(t)||He()&&Ke(He());return _(e,r?{locale:r}:null)}function xe(e,t){return Ee(e,"ddd",t)}function Te(e){return A(e)}function Ie(e,t){var r=Ke(t||He());return B(e,{locale:r})}function Le(e){return H(e)}function je(e){return K(e)}function Fe(e,t){return e&&t?X(e,t):!e&&!t}function qe(e,t){return e&&t?J(e,t):!e&&!t}function We(e,t){return e&&t?Z(e,t):!e&&!t}function Re(e,t){return e&&t?G(e,t):!e&&!t}function Ae(e,t){return e&&t?z(e,t):!e&&!t}function Be(e,t,r){var n,a=A(t),o=V(r);try{n=re(e,{start:a,end:o})}catch(e){n=!1}return n}function He(){return("undefined"!=typeof window?window:global).__localeId__}function Ke(e){if("string"==typeof e){var t="undefined"!=typeof window?window:global;return t.__localeData__?t.__localeData__[e]:null}return e}function Qe(e,t){return Ee(x(Se(),e),"LLLL",t)}function Ve(e,t){return Ee(x(Se(),e),"LLL",t)}function Ue(e,t){return Ee(T(Se(),e),"QQQ",t)}function $e(e){var t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{},r=t.minDate,n=t.maxDate,a=t.excludeDates,o=t.includeDates,s=t.filterDate;return et(e,{minDate:r,maxDate:n})||a&&a.some((function(t){return Re(e,t)}))||o&&!o.some((function(t){return Re(e,t)}))||s&&!s(Se(e))||!1}function ze(e){var t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{},r=t.excludeDates;return r&&r.some((function(t){return Re(e,t)}))||!1}function Ge(e){var t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{},r=t.minDate,n=t.maxDate,a=t.excludeDates,o=t.includeDates,s=t.filterDate;return et(e,{minDate:r,maxDate:n})||a&&a.some((function(t){return qe(e,t)}))||o&&!o.some((function(t){return qe(e,t)}))||s&&!s(Se(e))||!1}function Je(e,t,r,n){var a=P(e),o=O(e),s=P(t),p=O(t),i=P(n);return a===s&&a===i?o<=r&&r<=p:a<s?i===a&&o<=r||i===s&&p>=r||i<s&&i>a:void 0}function Xe(e){var t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{},r=t.minDate,n=t.maxDate,a=t.excludeDates,o=t.includeDates,s=t.filterDate;return et(e,{minDate:r,maxDate:n})||a&&a.some((function(t){return We(e,t)}))||o&&!o.some((function(t){return We(e,t)}))||s&&!s(Se(e))||!1}function Ze(e,t,r,n){var a=P(e),o=S(e),s=P(t),p=S(t),i=P(n);return a===s&&a===i?o<=r&&r<=p:a<s?i===a&&o<=r||i===s&&p>=r||i<s&&i>a:void 0}function et(e){var t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{},r=t.minDate,n=t.maxDate;return r&&F(e,r)<0||n&&F(e,n)>0}function tt(e,t){for(var r=t.length,n=0;n<r;n++)if(g(t[n])===g(e)&&k(t[n])===k(e))return!0;return!1}function rt(e,t){var r=t.minTime,n=t.maxTime;if(!r||!n)throw new Error("Both minTime and maxTime props required");var a,o=Se(),s=Y(N(o,k(e)),g(e)),p=Y(N(o,k(r)),g(r)),i=Y(N(o,k(n)),g(n));try{a=!re(s,{start:p,end:i})}catch(e){a=!1}return a}function nt(e){var t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{},r=t.minDate,n=t.includeDates,a=v(e,1);return r&&q(r,a)>0||n&&n.every((function(e){return q(e,a)>0}))||!1}function at(e){var t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{},r=t.maxDate,n=t.includeDates,a=d(e,1);return r&&q(a,r)>0||n&&n.every((function(e){return q(a,e)>0}))||!1}function ot(e){var t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{},r=t.minDate,n=t.includeDates,a=w(e,1);return r&&R(r,a)>0||n&&n.every((function(e){return R(e,a)>0}))||!1}function st(e){var t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{},r=t.maxDate,n=t.includeDates,a=u(e,1);return r&&R(a,r)>0||n&&n.every((function(e){return R(a,e)>0}))||!1}function pt(e){var t=e.minDate,r=e.includeDates;if(r&&t){var n=r.filter((function(e){return F(e,t)>=0}));return L(n)}return r?L(r):t}function it(e){var t=e.maxDate,r=e.includeDates;if(r&&t){var n=r.filter((function(e){return F(e,t)<=0}));return j(n)}return r?j(r):t}function ct(){for(var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:[],t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:"react-datepicker__day--highlighted",r=new Map,n=0,o=e.length;n<o;n++){var s=e[n];if(a(s)){var p=Ee(s,"MM.dd.yyyy"),i=r.get(p)||[];i.includes(t)||(i.push(t),r.set(p,i))}else if("object"===ie(s)){var c=Object.keys(s),l=c[0],d=s[c[0]];if("string"==typeof l&&d.constructor===Array)for(var u=0,h=d.length;u<h;u++){var f=Ee(d[u],"MM.dd.yyyy"),m=r.get(f)||[];m.includes(l)||(m.push(l),r.set(f,m))}}}return r}function lt(e,t,r,n,a){for(var o=a.length,s=[],c=0;c<o;c++){var l=p(i(e,g(a[c])),k(a[c])),d=p(e,(r+1)*n);ee(l,t)&&te(l,d)&&s.push(a[c])}return s}function dt(e){return e<10?"0".concat(e):"".concat(e)}function ut(e,t,r,n){for(var a=[],o=0;o<2*t+1;o++){var s=e+t-o,p=!0;r&&(p=P(r)<=s),n&&p&&(p=P(n)>=s),p&&a.push(s)}return a}var ht=se(function(e){ye(a,e);var r=ge(a);function a(e){var n;ce(this,a),ue(De(n=r.call(this,e)),"renderOptions",(function(){var e=n.props.year,r=n.state.yearsList.map((function(r){return t.createElement("div",{className:e===r?"react-datepicker__year-option react-datepicker__year-option--selected_year":"react-datepicker__year-option",key:r,onClick:n.onChange.bind(De(n),r)},e===r?t.createElement("span",{className:"react-datepicker__year-option--selected"},"✓"):"",r)})),a=n.props.minDate?P(n.props.minDate):null,o=n.props.maxDate?P(n.props.maxDate):null;return o&&n.state.yearsList.find((function(e){return e===o}))||r.unshift(t.createElement("div",{className:"react-datepicker__year-option",key:"upcoming",onClick:n.incrementYears},t.createElement("a",{className:"react-datepicker__navigation react-datepicker__navigation--years react-datepicker__navigation--years-upcoming"}))),a&&n.state.yearsList.find((function(e){return e===a}))||r.push(t.createElement("div",{className:"react-datepicker__year-option",key:"previous",onClick:n.decrementYears},t.createElement("a",{className:"react-datepicker__navigation react-datepicker__navigation--years react-datepicker__navigation--years-previous"}))),r})),ue(De(n),"onChange",(function(e){n.props.onChange(e)})),ue(De(n),"handleClickOutside",(function(){n.props.onCancel()})),ue(De(n),"shiftYears",(function(e){var t=n.state.yearsList.map((function(t){return t+e}));n.setState({yearsList:t})})),ue(De(n),"incrementYears",(function(){return n.shiftYears(1)})),ue(De(n),"decrementYears",(function(){return n.shiftYears(-1)}));var o=e.yearDropdownItemNumber,s=e.scrollableYearDropdown,p=o||(s?10:5);return n.state={yearsList:ut(n.props.year,p,n.props.minDate,n.props.maxDate)},n}return de(a,[{key:"render",value:function(){var e=n({"react-datepicker__year-dropdown":!0,"react-datepicker__year-dropdown--scrollable":this.props.scrollableYearDropdown});return t.createElement("div",{className:e},this.renderOptions())}}]),a}(t.Component)),ft=function(e){ye(n,e);var r=ge(n);function n(){var e;ce(this,n);for(var a=arguments.length,o=new Array(a),s=0;s<a;s++)o[s]=arguments[s];return ue(De(e=r.call.apply(r,[this].concat(o))),"state",{dropdownVisible:!1}),ue(De(e),"renderSelectOptions",(function(){for(var r=e.props.minDate?P(e.props.minDate):1900,n=e.props.maxDate?P(e.props.maxDate):2100,a=[],o=r;o<=n;o++)a.push(t.createElement("option",{key:o,value:o},o));return a})),ue(De(e),"onSelectChange",(function(t){e.onChange(t.target.value)})),ue(De(e),"renderSelectMode",(function(){return t.createElement("select",{value:e.props.year,className:"react-datepicker__year-select",onChange:e.onSelectChange},e.renderSelectOptions())})),ue(De(e),"renderReadView",(function(r){return t.createElement("div",{key:"read",style:{visibility:r?"visible":"hidden"},className:"react-datepicker__year-read-view",onClick:function(t){return e.toggleDropdown(t)}},t.createElement("span",{className:"react-datepicker__year-read-view--down-arrow"}),t.createElement("span",{className:"react-datepicker__year-read-view--selected-year"},e.props.year))})),ue(De(e),"renderDropdown",(function(){return t.createElement(ht,{key:"dropdown",year:e.props.year,onChange:e.onChange,onCancel:e.toggleDropdown,minDate:e.props.minDate,maxDate:e.props.maxDate,scrollableYearDropdown:e.props.scrollableYearDropdown,yearDropdownItemNumber:e.props.yearDropdownItemNumber})})),ue(De(e),"renderScrollMode",(function(){var t=e.state.dropdownVisible,r=[e.renderReadView(!t)];return t&&r.unshift(e.renderDropdown()),r})),ue(De(e),"onChange",(function(t){e.toggleDropdown(),t!==e.props.year&&e.props.onChange(t)})),ue(De(e),"toggleDropdown",(function(t){e.setState({dropdownVisible:!e.state.dropdownVisible},(function(){e.props.adjustDateOnChange&&e.handleYearChange(e.props.date,t)}))})),ue(De(e),"handleYearChange",(function(t,r){e.onSelect(t,r),e.setOpen()})),ue(De(e),"onSelect",(function(t,r){e.props.onSelect&&e.props.onSelect(t,r)})),ue(De(e),"setOpen",(function(){e.props.setOpen&&e.props.setOpen(!0)})),e}return de(n,[{key:"render",value:function(){var e;switch(this.props.dropdownMode){case"scroll":e=this.renderScrollMode();break;case"select":e=this.renderSelectMode()}return t.createElement("div",{className:"react-datepicker__year-dropdown-container react-datepicker__year-dropdown-container--".concat(this.props.dropdownMode)},e)}}]),n}(t.Component),mt=se(function(e){ye(n,e);var r=ge(n);function n(){var e;ce(this,n);for(var a=arguments.length,o=new Array(a),s=0;s<a;s++)o[s]=arguments[s];return ue(De(e=r.call.apply(r,[this].concat(o))),"renderOptions",(function(){return e.props.monthNames.map((function(r,n){return t.createElement("div",{className:e.props.month===n?"react-datepicker__month-option react-datepicker__month-option--selected_month":"react-datepicker__month-option",key:r,onClick:e.onChange.bind(De(e),n)},e.props.month===n?t.createElement("span",{className:"react-datepicker__month-option--selected"},"✓"):"",r)}))})),ue(De(e),"onChange",(function(t){return e.props.onChange(t)})),ue(De(e),"handleClickOutside",(function(){return e.props.onCancel()})),e}return de(n,[{key:"render",value:function(){return t.createElement("div",{className:"react-datepicker__month-dropdown"},this.renderOptions())}}]),n}(t.Component)),yt=function(e){ye(n,e);var r=ge(n);function n(){var e;ce(this,n);for(var a=arguments.length,o=new Array(a),s=0;s<a;s++)o[s]=arguments[s];return ue(De(e=r.call.apply(r,[this].concat(o))),"state",{dropdownVisible:!1}),ue(De(e),"renderSelectOptions",(function(e){return e.map((function(e,r){return t.createElement("option",{key:r,value:r},e)}))})),ue(De(e),"renderSelectMode",(function(r){return t.createElement("select",{value:e.props.month,className:"react-datepicker__month-select",onChange:function(t){return e.onChange(t.target.value)}},e.renderSelectOptions(r))})),ue(De(e),"renderReadView",(function(r,n){return t.createElement("div",{key:"read",style:{visibility:r?"visible":"hidden"},className:"react-datepicker__month-read-view",onClick:e.toggleDropdown},t.createElement("span",{className:"react-datepicker__month-read-view--down-arrow"}),t.createElement("span",{className:"react-datepicker__month-read-view--selected-month"},n[e.props.month]))})),ue(De(e),"renderDropdown",(function(r){return t.createElement(mt,{key:"dropdown",month:e.props.month,monthNames:r,onChange:e.onChange,onCancel:e.toggleDropdown})})),ue(De(e),"renderScrollMode",(function(t){var r=e.state.dropdownVisible,n=[e.renderReadView(!r,t)];return r&&n.unshift(e.renderDropdown(t)),n})),ue(De(e),"onChange",(function(t){e.toggleDropdown(),t!==e.props.month&&e.props.onChange(t)})),ue(De(e),"toggleDropdown",(function(){return e.setState({dropdownVisible:!e.state.dropdownVisible})})),e}return de(n,[{key:"render",value:function(){var e,r=this,n=[0,1,2,3,4,5,6,7,8,9,10,11].map(this.props.useShortMonthInDropdown?function(e){return Ve(e,r.props.locale)}:function(e){return Qe(e,r.props.locale)});switch(this.props.dropdownMode){case"scroll":e=this.renderScrollMode(n);break;case"select":e=this.renderSelectMode(n)}return t.createElement("div",{className:"react-datepicker__month-dropdown-container react-datepicker__month-dropdown-container--".concat(this.props.dropdownMode)},e)}}]),n}(t.Component);function vt(e,t){for(var r=[],n=Le(e),a=Le(t);!ee(n,a);)r.push(Se(n)),n=d(n,1);return r}var wt=se(function(e){ye(a,e);var r=ge(a);function a(e){var n;return ce(this,a),ue(De(n=r.call(this,e)),"renderOptions",(function(){return n.state.monthYearsList.map((function(e){var r=M(e),a=Fe(n.props.date,e)&&qe(n.props.date,e);return t.createElement("div",{className:a?"react-datepicker__month-year-option --selected_month-year":"react-datepicker__month-year-option",key:r,onClick:n.onChange.bind(De(n),r)},a?t.createElement("span",{className:"react-datepicker__month-year-option--selected"},"✓"):"",Ee(e,n.props.dateFormat))}))})),ue(De(n),"onChange",(function(e){return n.props.onChange(e)})),ue(De(n),"handleClickOutside",(function(){n.props.onCancel()})),n.state={monthYearsList:vt(n.props.minDate,n.props.maxDate)},n}return de(a,[{key:"render",value:function(){var e=n({"react-datepicker__month-year-dropdown":!0,"react-datepicker__month-year-dropdown--scrollable":this.props.scrollableMonthYearDropdown});return t.createElement("div",{className:e},this.renderOptions())}}]),a}(t.Component)),Dt=function(e){ye(n,e);var r=ge(n);function n(){var e;ce(this,n);for(var a=arguments.length,o=new Array(a),s=0;s<a;s++)o[s]=arguments[s];return ue(De(e=r.call.apply(r,[this].concat(o))),"state",{dropdownVisible:!1}),ue(De(e),"renderSelectOptions",(function(){for(var r=Le(e.props.minDate),n=Le(e.props.maxDate),a=[];!ee(r,n);){var o=M(r);a.push(t.createElement("option",{key:o,value:o},Ee(r,e.props.dateFormat,e.props.locale))),r=d(r,1)}return a})),ue(De(e),"onSelectChange",(function(t){e.onChange(t.target.value)})),ue(De(e),"renderSelectMode",(function(){return t.createElement("select",{value:M(Le(e.props.date)),className:"react-datepicker__month-year-select",onChange:e.onSelectChange},e.renderSelectOptions())})),ue(De(e),"renderReadView",(function(r){var n=Ee(e.props.date,e.props.dateFormat,e.props.locale);return t.createElement("div",{key:"read",style:{visibility:r?"visible":"hidden"},className:"react-datepicker__month-year-read-view",onClick:function(t){return e.toggleDropdown(t)}},t.createElement("span",{className:"react-datepicker__month-year-read-view--down-arrow"}),t.createElement("span",{className:"react-datepicker__month-year-read-view--selected-month-year"},n))})),ue(De(e),"renderDropdown",(function(){return t.createElement(wt,{key:"dropdown",date:e.props.date,dateFormat:e.props.dateFormat,onChange:e.onChange,onCancel:e.toggleDropdown,minDate:e.props.minDate,maxDate:e.props.maxDate,scrollableMonthYearDropdown:e.props.scrollableMonthYearDropdown})})),ue(De(e),"renderScrollMode",(function(){var t=e.state.dropdownVisible,r=[e.renderReadView(!t)];return t&&r.unshift(e.renderDropdown()),r})),ue(De(e),"onChange",(function(t){e.toggleDropdown();var r=Se(parseInt(t));Fe(e.props.date,r)&&qe(e.props.date,r)||e.props.onChange(r)})),ue(De(e),"toggleDropdown",(function(){return e.setState({dropdownVisible:!e.state.dropdownVisible})})),e}return de(n,[{key:"render",value:function(){var e;switch(this.props.dropdownMode){case"scroll":e=this.renderScrollMode();break;case"select":e=this.renderSelectMode()}return t.createElement("div",{className:"react-datepicker__month-year-dropdown-container react-datepicker__month-year-dropdown-container--".concat(this.props.dropdownMode)},e)}}]),n}(t.Component),kt=function(e){ye(a,e);var r=ge(a);function a(){var e;ce(this,a);for(var o=arguments.length,s=new Array(o),p=0;p<o;p++)s[p]=arguments[p];return ue(De(e=r.call.apply(r,[this].concat(s))),"dayEl",t.createRef()),ue(De(e),"handleClick",(function(t){!e.isDisabled()&&e.props.onClick&&e.props.onClick(t)})),ue(De(e),"handleMouseEnter",(function(t){!e.isDisabled()&&e.props.onMouseEnter&&e.props.onMouseEnter(t)})),ue(De(e),"handleOnKeyDown",(function(t){" "===t.key&&(t.preventDefault(),t.key="Enter"),e.props.handleOnKeyDown(t)})),ue(De(e),"isSameDay",(function(t){return Re(e.props.day,t)})),ue(De(e),"isKeyboardSelected",(function(){return!e.props.disabledKeyboardNavigation&&!e.props.inline&&!e.isSameDay(e.props.selected)&&e.isSameDay(e.props.preSelection)})),ue(De(e),"isDisabled",(function(){return $e(e.props.day,e.props)})),ue(De(e),"isExcluded",(function(){return ze(e.props.day,e.props)})),ue(De(e),"getHighLightedClass",(function(t){var r=e.props,n=r.day,a=r.highlightDates;if(!a)return!1;var o=Ee(n,"MM.dd.yyyy");return a.get(o)})),ue(De(e),"isInRange",(function(){var t=e.props,r=t.day,n=t.startDate,a=t.endDate;return!(!n||!a)&&Be(r,n,a)})),ue(De(e),"isInSelectingRange",(function(){var t=e.props,r=t.day,n=t.selectsStart,a=t.selectsEnd,o=t.selectingDate,s=t.startDate,p=t.endDate;return!(!n&&!a||!o||e.isDisabled())&&(n&&p&&(te(o,p)||Ae(o,p))?Be(r,o,p):!(!a||!s||!ee(o,s)&&!Ae(o,s))&&Be(r,s,o))})),ue(De(e),"isSelectingRangeStart",(function(){if(!e.isInSelectingRange())return!1;var t=e.props,r=t.day,n=t.selectingDate,a=t.startDate;return Re(r,t.selectsStart?n:a)})),ue(De(e),"isSelectingRangeEnd",(function(){if(!e.isInSelectingRange())return!1;var t=e.props,r=t.day,n=t.selectingDate,a=t.endDate;return Re(r,t.selectsEnd?n:a)})),ue(De(e),"isRangeStart",(function(){var t=e.props,r=t.day,n=t.startDate,a=t.endDate;return!(!n||!a)&&Re(n,r)})),ue(De(e),"isRangeEnd",(function(){var t=e.props,r=t.day,n=t.startDate,a=t.endDate;return!(!n||!a)&&Re(a,r)})),ue(De(e),"isWeekend",(function(){var t=b(e.props.day);return 0===t||6===t})),ue(De(e),"isOutsideMonth",(function(){return void 0!==e.props.month&&e.props.month!==O(e.props.day)})),ue(De(e),"getClassNames",(function(t){var r=e.props.dayClassName?e.props.dayClassName(t):void 0;return n("react-datepicker__day",r,"react-datepicker__day--"+xe(e.props.day),{"react-datepicker__day--disabled":e.isDisabled(),"react-datepicker__day--excluded":e.isExcluded(),"react-datepicker__day--selected":e.isSameDay(e.props.selected),"react-datepicker__day--keyboard-selected":e.isKeyboardSelected(),"react-datepicker__day--range-start":e.isRangeStart(),"react-datepicker__day--range-end":e.isRangeEnd(),"react-datepicker__day--in-range":e.isInRange(),"react-datepicker__day--in-selecting-range":e.isInSelectingRange(),"react-datepicker__day--selecting-range-start":e.isSelectingRangeStart(),"react-datepicker__day--selecting-range-end":e.isSelectingRangeEnd(),"react-datepicker__day--today":e.isSameDay(Se()),"react-datepicker__day--weekend":e.isWeekend(),"react-datepicker__day--outside-month":e.isOutsideMonth()},e.getHighLightedClass("react-datepicker__day--highlighted"))})),ue(De(e),"getAriaLabel",(function(){var t=e.props,r=t.day,n=t.ariaLabelPrefixWhenEnabled,a=void 0===n?"Choose":n,o=t.ariaLabelPrefixWhenDisabled,s=void 0===o?"Not available":o,p=e.isDisabled()||e.isExcluded()?s:a;return"".concat(p," ").concat(Ee(r,"PPPP"))})),ue(De(e),"getTabIndex",(function(t,r){var n=t||e.props.selected,a=r||e.props.preSelection;return e.isKeyboardSelected()||e.isSameDay(n)&&Re(a,n)?0:-1})),ue(De(e),"handleFocusDay",(function(){var t=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{},r=!1;0===e.getTabIndex()&&!t.isInputFocused&&e.isSameDay(e.props.preSelection)&&(document.activeElement&&document.activeElement!==document.body||(r=!0),e.props.containerRef&&e.props.containerRef.current&&e.props.containerRef.current.contains(document.activeElement)&&document.activeElement.classList.contains("react-datepicker__day")&&(r=!0)),r&&e.dayEl.current.focus()})),ue(De(e),"render",(function(){return t.createElement("div",{ref:e.dayEl,className:e.getClassNames(e.props.day),onKeyDown:e.handleOnKeyDown,onClick:e.handleClick,onMouseEnter:e.handleMouseEnter,tabIndex:e.getTabIndex(),"aria-label":e.getAriaLabel(),role:"button","aria-disabled":e.isDisabled()},e.props.renderDayContents?e.props.renderDayContents(C(e.props.day),e.props.day):C(e.props.day))})),e}return de(a,[{key:"componentDidMount",value:function(){this.handleFocusDay()}},{key:"componentDidUpdate",value:function(e){this.handleFocusDay(e)}}]),a}(t.Component),gt=function(e){ye(a,e);var r=ge(a);function a(){var e;ce(this,a);for(var t=arguments.length,n=new Array(t),o=0;o<t;o++)n[o]=arguments[o];return ue(De(e=r.call.apply(r,[this].concat(n))),"handleClick",(function(t){e.props.onClick&&e.props.onClick(t)})),e}return de(a,[{key:"render",value:function(){var e=this.props,r=e.weekNumber,a=e.ariaLabelPrefix,o=void 0===a?"week ":a,s={"react-datepicker__week-number":!0,"react-datepicker__week-number--clickable":!!e.onClick};return t.createElement("div",{className:n(s),"aria-label":"".concat(o," ").concat(this.props.weekNumber),onClick:this.handleClick},r)}}]),a}(t.Component),bt=function(e){ye(n,e);var r=ge(n);function n(){var e;ce(this,n);for(var a=arguments.length,o=new Array(a),s=0;s<a;s++)o[s]=arguments[s];return ue(De(e=r.call.apply(r,[this].concat(o))),"handleDayClick",(function(t,r){e.props.onDayClick&&e.props.onDayClick(t,r)})),ue(De(e),"handleDayMouseEnter",(function(t){e.props.onDayMouseEnter&&e.props.onDayMouseEnter(t)})),ue(De(e),"handleWeekClick",(function(t,r,n){"function"==typeof e.props.onWeekSelect&&e.props.onWeekSelect(t,r,n),e.props.shouldCloseOnSelect&&e.props.setOpen(!1)})),ue(De(e),"formatWeekNumber",(function(t){return e.props.formatWeekNumber?e.props.formatWeekNumber(t):Ye(t,e.props.locale)})),ue(De(e),"renderDays",(function(){var r=Ie(e.props.day,e.props.locale),n=[],a=e.formatWeekNumber(r);if(e.props.showWeekNumber){var o=e.props.onWeekSelect?e.handleWeekClick.bind(De(e),r,a):void 0;n.push(t.createElement(gt,{key:"W",weekNumber:a,onClick:o,ariaLabelPrefix:e.props.ariaLabelPrefix}))}return n.concat([0,1,2,3,4,5,6].map((function(n){var a=c(r,n);return t.createElement(kt,{ariaLabelPrefixWhenEnabled:e.props.chooseDayAriaLabelPrefix,ariaLabelPrefixWhenDisabled:e.props.disabledDayAriaLabelPrefix,key:a.valueOf(),day:a,month:e.props.month,onClick:e.handleDayClick.bind(De(e),a),onMouseEnter:e.handleDayMouseEnter.bind(De(e),a),minDate:e.props.minDate,maxDate:e.props.maxDate,excludeDates:e.props.excludeDates,includeDates:e.props.includeDates,inline:e.props.inline,highlightDates:e.props.highlightDates,selectingDate:e.props.selectingDate,filterDate:e.props.filterDate,preSelection:e.props.preSelection,selected:e.props.selected,selectsStart:e.props.selectsStart,selectsEnd:e.props.selectsEnd,startDate:e.props.startDate,endDate:e.props.endDate,dayClassName:e.props.dayClassName,renderDayContents:e.props.renderDayContents,disabledKeyboardNavigation:e.props.disabledKeyboardNavigation,handleOnKeyDown:e.props.handleOnKeyDown,isInputFocused:e.props.isInputFocused,containerRef:e.props.containerRef})})))})),e}return de(n,[{key:"render",value:function(){return t.createElement("div",{className:"react-datepicker__week"},this.renderDays())}}],[{key:"defaultProps",get:function(){return{shouldCloseOnSelect:!0}}}]),n}(t.Component),Ct=function(e){ye(a,e);var r=ge(a);function a(){var e;ce(this,a);for(var o=arguments.length,s=new Array(o),p=0;p<o;p++)s[p]=arguments[p];return ue(De(e=r.call.apply(r,[this].concat(s))),"handleDayClick",(function(t,r){e.props.onDayClick&&e.props.onDayClick(t,r,e.props.orderInDisplay)})),ue(De(e),"handleDayMouseEnter",(function(t){e.props.onDayMouseEnter&&e.props.onDayMouseEnter(t)})),ue(De(e),"handleMouseLeave",(function(){e.props.onMouseLeave&&e.props.onMouseLeave()})),ue(De(e),"isRangeStartMonth",(function(t){var r=e.props,n=r.day,a=r.startDate,o=r.endDate;return!(!a||!o)&&qe(x(n,t),a)})),ue(De(e),"isRangeStartQuarter",(function(t){var r=e.props,n=r.day,a=r.startDate,o=r.endDate;return!(!a||!o)&&We(T(n,t),a)})),ue(De(e),"isRangeEndMonth",(function(t){var r=e.props,n=r.day,a=r.startDate,o=r.endDate;return!(!a||!o)&&qe(x(n,t),o)})),ue(De(e),"isRangeEndQuarter",(function(t){var r=e.props,n=r.day,a=r.startDate,o=r.endDate;return!(!a||!o)&&We(T(n,t),o)})),ue(De(e),"isWeekInMonth",(function(t){var r=e.props.day,n=c(t,6);return qe(t,r)||qe(n,r)})),ue(De(e),"renderWeeks",(function(){for(var r=[],n=e.props.fixedHeight,a=Ie(Le(e.props.day),e.props.locale),o=0,s=!1;r.push(t.createElement(bt,{ariaLabelPrefix:e.props.weekAriaLabelPrefix,chooseDayAriaLabelPrefix:e.props.chooseDayAriaLabelPrefix,disabledDayAriaLabelPrefix:e.props.disabledDayAriaLabelPrefix,key:o,day:a,month:O(e.props.day),onDayClick:e.handleDayClick,onDayMouseEnter:e.handleDayMouseEnter,onWeekSelect:e.props.onWeekSelect,formatWeekNumber:e.props.formatWeekNumber,locale:e.props.locale,minDate:e.props.minDate,maxDate:e.props.maxDate,excludeDates:e.props.excludeDates,includeDates:e.props.includeDates,inline:e.props.inline,highlightDates:e.props.highlightDates,selectingDate:e.props.selectingDate,filterDate:e.props.filterDate,preSelection:e.props.preSelection,selected:e.props.selected,selectsStart:e.props.selectsStart,selectsEnd:e.props.selectsEnd,showWeekNumber:e.props.showWeekNumbers,startDate:e.props.startDate,endDate:e.props.endDate,dayClassName:e.props.dayClassName,setOpen:e.props.setOpen,shouldCloseOnSelect:e.props.shouldCloseOnSelect,disabledKeyboardNavigation:e.props.disabledKeyboardNavigation,renderDayContents:e.props.renderDayContents,handleOnKeyDown:e.props.handleOnKeyDown,isInputFocused:e.props.isInputFocused,containerRef:e.props.containerRef})),!s;){o++,a=l(a,1);var p=n&&o>=6,i=!n&&!e.isWeekInMonth(a);if(p||i){if(!e.props.peekNextMonth)break;s=!0}}return r})),ue(De(e),"onMonthClick",(function(t,r){e.handleDayClick(Le(x(e.props.day,r)),t)})),ue(De(e),"onQuarterClick",(function(t,r){e.handleDayClick(je(T(e.props.day,r)),t)})),ue(De(e),"getMonthClassNames",(function(t){var r=e.props,a=r.day,o=r.startDate,s=r.endDate,p=r.selected,i=r.minDate,c=r.maxDate;return n("react-datepicker__month-text","react-datepicker__month-".concat(t),{"react-datepicker__month--disabled":(i||c)&&Ge(x(a,t),e.props),"react-datepicker__month--selected":O(a)===t&&P(a)===P(p),"react-datepicker__month--in-range":Je(o,s,t,a),"react-datepicker__month--range-start":e.isRangeStartMonth(t),"react-datepicker__month--range-end":e.isRangeEndMonth(t)})})),ue(De(e),"getQuarterClassNames",(function(t){var r=e.props,a=r.day,o=r.startDate,s=r.endDate,p=r.selected,i=r.minDate,c=r.maxDate;return n("react-datepicker__quarter-text","react-datepicker__quarter-".concat(t),{"react-datepicker__quarter--disabled":(i||c)&&Xe(T(a,t),e.props),"react-datepicker__quarter--selected":S(a)===t&&P(a)===P(p),"react-datepicker__quarter--in-range":Ze(o,s,t,a),"react-datepicker__quarter--range-start":e.isRangeStartQuarter(t),"react-datepicker__quarter--range-end":e.isRangeEndQuarter(t)})})),ue(De(e),"renderMonths",(function(){var r=e.props,n=r.showFullMonthYearPicker,a=r.locale;return[[0,1,2],[3,4,5],[6,7,8],[9,10,11]].map((function(r,o){return t.createElement("div",{className:"react-datepicker__month-wrapper",key:o},r.map((function(r,o){return t.createElement("div",{key:o,onClick:function(t){e.onMonthClick(t,r)},className:e.getMonthClassNames(r)},n?Qe(r,a):Ve(r,a))})))}))})),ue(De(e),"renderQuarters",(function(){return t.createElement("div",{className:"react-datepicker__quarter-wrapper"},[1,2,3,4].map((function(r,n){return t.createElement("div",{key:n,onClick:function(t){e.onQuarterClick(t,r)},className:e.getQuarterClassNames(r)},Ue(r,e.props.locale))})))})),ue(De(e),"getClassNames",(function(){var t=e.props,r=t.selectingDate,a=t.selectsStart,o=t.selectsEnd,s=t.showMonthYearPicker,p=t.showQuarterYearPicker;return n("react-datepicker__month",{"react-datepicker__month--selecting-range":r&&(a||o)},{"react-datepicker__monthPicker":s},{"react-datepicker__quarterPicker":p})})),e}return de(a,[{key:"render",value:function(){var e=this.props,r=e.showMonthYearPicker,n=e.showQuarterYearPicker,a=e.day,o=e.ariaLabelPrefix,s=void 0===o?"month ":o;return t.createElement("div",{className:this.getClassNames(),onMouseLeave:this.handleMouseLeave,"aria-label":"".concat(s," ").concat(Ee(a,"yyyy-MM"))},r?this.renderMonths():n?this.renderQuarters():this.renderWeeks())}}]),a}(t.Component),_t=function(e){ye(n,e);var r=ge(n);function n(){var e;ce(this,n);for(var a=arguments.length,o=new Array(a),s=0;s<a;s++)o[s]=arguments[s];return ue(De(e=r.call.apply(r,[this].concat(o))),"state",{height:null}),ue(De(e),"handleClick",(function(t){(e.props.minTime||e.props.maxTime)&&rt(t,e.props)||e.props.excludeTimes&&tt(t,e.props.excludeTimes)||e.props.includeTimes&&!tt(t,e.props.includeTimes)||e.props.onChange(t)})),ue(De(e),"liClasses",(function(t,r,n){var a=["react-datepicker__time-list-item",e.props.timeClassName?e.props.timeClassName(t,r,n):void 0];return e.props.selected&&r===g(t)&&n===k(t)&&a.push("react-datepicker__time-list-item--selected"),((e.props.minTime||e.props.maxTime)&&rt(t,e.props)||e.props.excludeTimes&&tt(t,e.props.excludeTimes)||e.props.includeTimes&&!tt(t,e.props.includeTimes))&&a.push("react-datepicker__time-list-item--disabled"),e.props.injectTimes&&(60*g(t)+k(t))%e.props.intervals!=0&&a.push("react-datepicker__time-list-item--injected"),a.join(" ")})),ue(De(e),"renderTimes",(function(){for(var r=[],n=e.props.format?e.props.format:"p",a=e.props.intervals,o=e.props.selected||e.props.openToDate||Se(),s=g(o),i=k(o),c=Te(Se()),l=1440/a,d=e.props.injectTimes&&e.props.injectTimes.sort((function(e,t){return e-t})),u=0;u<l;u++){var h=p(c,u*a);if(r.push(h),d){var f=lt(c,h,u,a,d);r=r.concat(f)}}return r.map((function(r,a){return t.createElement("li",{key:a,onClick:e.handleClick.bind(De(e),r),className:e.liClasses(r,s,i),ref:function(t){s===g(r)&&i>=k(r)&&(e.centerLi=t)}},Ee(r,n,e.props.locale))}))})),e}return de(n,[{key:"componentDidMount",value:function(){this.list.scrollTop=n.calcCenterPosition(this.props.monthRef?this.props.monthRef.clientHeight-this.header.clientHeight:this.list.clientHeight,this.centerLi),this.props.monthRef&&this.header&&this.setState({height:this.props.monthRef.clientHeight-this.header.clientHeight})}},{key:"render",value:function(){var e=this,r=this.state.height;return t.createElement("div",{className:"react-datepicker__time-container ".concat(this.props.todayButton?"react-datepicker__time-container--with-today-button":"")},t.createElement("div",{className:"react-datepicker__header react-datepicker__header--time",ref:function(t){e.header=t}},t.createElement("div",{className:"react-datepicker-time__header"},this.props.timeCaption)),t.createElement("div",{className:"react-datepicker__time"},t.createElement("div",{className:"react-datepicker__time-box"},t.createElement("ul",{className:"react-datepicker__time-list",ref:function(t){e.list=t},style:r?{height:r}:{}},this.renderTimes()))))}}],[{key:"defaultProps",get:function(){return{intervals:30,onTimeChange:function(){},todayButton:null,timeCaption:"Time"}}}]),n}(t.Component);ue(_t,"calcCenterPosition",(function(e,t){return t.offsetTop-(e/2-t.clientHeight/2)}));var Ot=function(e){ye(n,e);var r=ge(n);function n(e){var t;return ce(this,n),ue(De(t=r.call(this,e)),"handleYearClick",(function(e,r){t.props.onDayClick&&t.props.onDayClick(e,r)})),ue(De(t),"onYearClick",(function(e,r){var n;t.handleYearClick((n=I(t.props.date,r),Q(n)),e)})),t}return de(n,[{key:"render",value:function(){for(var e=this,r=[],n=this.props.date,a=function(n,a){r.push(t.createElement("div",{onClick:function(t){e.onYearClick(t,n)},className:"react-datepicker__year-container-text",key:n},n))},o=P(n)-11,s=0;o<=P(n);o++,s++)a(o);return t.createElement("div",{className:"react-datepicker__year-container"},r)}}]),n}(t.Component),St=function(e){ye(n,e);var r=ge(n);function n(e){var a;return ce(this,n),ue(De(a=r.call(this,e)),"onTimeChange",(function(e){a.setState({time:e});var t=new Date;t.setHours(e.split(":")[0]),t.setMinutes(e.split(":")[1]),a.props.onChange(t)})),ue(De(a),"renderTimeInput",(function(){var e=a.state.time,r=a.props,n=r.timeString,o=r.customTimeInput;return o?t.cloneElement(o,{value:e,onChange:a.onTimeChange}):t.createElement("input",{type:"time",className:"react-datepicker-time__input",placeholder:"Time",name:"time-input",required:!0,value:e,onChange:function(e){a.onTimeChange(e.target.value||n)}})})),a.state={time:a.props.timeString},a}return de(n,[{key:"render",value:function(){return t.createElement("div",{className:"react-datepicker__input-time-container"},t.createElement("div",{className:"react-datepicker-time__caption"},this.props.timeInputLabel),t.createElement("div",{className:"react-datepicker-time__input-container"},t.createElement("div",{className:"react-datepicker-time__input"},this.renderTimeInput())))}}]),n}(t.Component);function Pt(e){var r=e.className,n=e.children,a=e.showPopperArrow,o=e.arrowProps,s=void 0===o?{}:o;return t.createElement("div",{className:r},a&&t.createElement("div",he({className:"react-datepicker__triangle"},s)),n)}var Mt=["react-datepicker__year-select","react-datepicker__month-select","react-datepicker__month-year-select"],Et=function(e){ye(a,e);var r=ge(a);function a(e){var o;return ce(this,a),ue(De(o=r.call(this,e)),"handleClickOutside",(function(e){o.props.onClickOutside(e)})),ue(De(o),"setClickOutsideRef",(function(){return o.containerRef.current})),ue(De(o),"handleDropdownFocus",(function(e){(function(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{},t=(e.className||"").split(/\s+/);return Mt.some((function(e){return t.indexOf(e)>=0}))})(e.target)&&o.props.onDropdownFocus()})),ue(De(o),"getDateInView",(function(){var e=o.props,t=e.preSelection,r=e.selected,n=e.openToDate,a=pt(o.props),s=it(o.props),p=Se(),i=n||r||t;return i||(a&&te(p,a)?a:s&&ee(p,s)?s:p)})),ue(De(o),"increaseMonth",(function(){o.setState((function(e){var t=e.date;return{date:d(t,1)}}),(function(){return o.handleMonthChange(o.state.date)}))})),ue(De(o),"decreaseMonth",(function(){o.setState((function(e){var t=e.date;return{date:v(t,1)}}),(function(){return o.handleMonthChange(o.state.date)}))})),ue(De(o),"handleDayClick",(function(e,t,r){return o.props.onSelect(e,t,r)})),ue(De(o),"handleDayMouseEnter",(function(e){o.setState({selectingDate:e}),o.props.onDayMouseEnter&&o.props.onDayMouseEnter(e)})),ue(De(o),"handleMonthMouseLeave",(function(){o.setState({selectingDate:null}),o.props.onMonthMouseLeave&&o.props.onMonthMouseLeave()})),ue(De(o),"handleYearChange",(function(e){o.props.onYearChange&&o.props.onYearChange(e)})),ue(De(o),"handleMonthChange",(function(e){o.props.onMonthChange&&o.props.onMonthChange(e),o.props.adjustDateOnChange&&(o.props.onSelect&&o.props.onSelect(e),o.props.setOpen&&o.props.setOpen(!0)),o.props.setPreSelection&&o.props.setPreSelection(e)})),ue(De(o),"handleMonthYearChange",(function(e){o.handleYearChange(e),o.handleMonthChange(e)})),ue(De(o),"changeYear",(function(e){o.setState((function(t){var r=t.date;return{date:I(r,e)}}),(function(){return o.handleYearChange(o.state.date)}))})),ue(De(o),"changeMonth",(function(e){o.setState((function(t){var r=t.date;return{date:x(r,e)}}),(function(){return o.handleMonthChange(o.state.date)}))})),ue(De(o),"changeMonthYear",(function(e){o.setState((function(t){var r=t.date;return{date:I(x(r,O(e)),P(e))}}),(function(){return o.handleMonthYearChange(o.state.date)}))})),ue(De(o),"header",(function(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:o.state.date,r=Ie(e,o.props.locale),a=[];return o.props.showWeekNumbers&&a.push(t.createElement("div",{key:"W",className:"react-datepicker__day-name"},o.props.weekLabel||"#")),a.concat([0,1,2,3,4,5,6].map((function(e){var a=c(r,e),s=o.formatWeekday(a,o.props.locale),p=o.props.weekDayClassName?o.props.weekDayClassName(a):void 0;return t.createElement("div",{key:e,className:n("react-datepicker__day-name",p)},s)})))})),ue(De(o),"formatWeekday",(function(e,t){return o.props.formatWeekDay?function(e,t,r){return t(Ee(e,"EEEE",r))}(e,o.props.formatWeekDay,t):o.props.useWeekdaysShort?function(e,t){return Ee(e,"EEE",t)}(e,t):function(e,t){return Ee(e,"EEEEEE",t)}(e,t)})),ue(De(o),"decreaseYear",(function(){o.setState((function(e){var t=e.date;return{date:w(t,o.props.showYearPicker?11:1)}}),(function(){return o.handleYearChange(o.state.date)}))})),ue(De(o),"renderPreviousButton",(function(){if(!o.props.renderCustomHeader){var e=o.props.showMonthYearPicker?ot(o.state.date,o.props):nt(o.state.date,o.props);if((o.props.forceShowMonthNavigation||o.props.showDisabledMonthNavigation||!e)&&!o.props.showTimeSelectOnly){var r=["react-datepicker__navigation","react-datepicker__navigation--previous"],n=o.decreaseMonth;(o.props.showMonthYearPicker||o.props.showQuarterYearPicker||o.props.showYearPicker)&&(n=o.decreaseYear),e&&o.props.showDisabledMonthNavigation&&(r.push("react-datepicker__navigation--previous--disabled"),n=null);var a=o.props.showMonthYearPicker||o.props.showQuarterYearPicker,s=o.props,p=s.previousMonthAriaLabel,i=void 0===p?"Previous Month":p,c=s.previousYearAriaLabel,l=void 0===c?"Previous Year":c;return t.createElement("button",{type:"button",className:r.join(" "),onClick:n,"aria-label":a?l:i},a?o.props.previousYearButtonLabel:o.props.previousMonthButtonLabel)}}})),ue(De(o),"increaseYear",(function(){o.setState((function(e){var t=e.date;return{date:u(t,o.props.showYearPicker?11:1)}}),(function(){return o.handleYearChange(o.state.date)}))})),ue(De(o),"renderNextButton",(function(){if(!o.props.renderCustomHeader){var e=o.props.showMonthYearPicker?st(o.state.date,o.props):at(o.state.date,o.props);if((o.props.forceShowMonthNavigation||o.props.showDisabledMonthNavigation||!e)&&!o.props.showTimeSelectOnly){var r=["react-datepicker__navigation","react-datepicker__navigation--next"];o.props.showTimeSelect&&r.push("react-datepicker__navigation--next--with-time"),o.props.todayButton&&r.push("react-datepicker__navigation--next--with-today-button");var n=o.increaseMonth;(o.props.showMonthYearPicker||o.props.showQuarterYearPicker||o.props.showYearPicker)&&(n=o.increaseYear),e&&o.props.showDisabledMonthNavigation&&(r.push("react-datepicker__navigation--next--disabled"),n=null);var a=o.props.showMonthYearPicker||o.props.showQuarterYearPicker,s=o.props,p=s.nextMonthAriaLabel,i=void 0===p?"Next Month":p,c=s.nextYearAriaLabel,l=void 0===c?"Next Year":c;return t.createElement("button",{type:"button",className:r.join(" "),onClick:n,"aria-label":a?l:i},a?o.props.nextYearButtonLabel:o.props.nextMonthButtonLabel)}}})),ue(De(o),"renderCurrentMonth",(function(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:o.state.date,r=["react-datepicker__current-month"];return o.props.showYearDropdown&&r.push("react-datepicker__current-month--hasYearDropdown"),o.props.showMonthDropdown&&r.push("react-datepicker__current-month--hasMonthDropdown"),o.props.showMonthYearDropdown&&r.push("react-datepicker__current-month--hasMonthYearDropdown"),t.createElement("div",{className:r.join(" ")},Ee(e,o.props.dateFormat,o.props.locale))})),ue(De(o),"renderYearDropdown",(function(){var e=arguments.length>0&&void 0!==arguments[0]&&arguments[0];if(o.props.showYearDropdown&&!e)return t.createElement(ft,{adjustDateOnChange:o.props.adjustDateOnChange,date:o.state.date,onSelect:o.props.onSelect,setOpen:o.props.setOpen,dropdownMode:o.props.dropdownMode,onChange:o.changeYear,minDate:o.props.minDate,maxDate:o.props.maxDate,year:P(o.state.date),scrollableYearDropdown:o.props.scrollableYearDropdown,yearDropdownItemNumber:o.props.yearDropdownItemNumber})})),ue(De(o),"renderMonthDropdown",(function(){var e=arguments.length>0&&void 0!==arguments[0]&&arguments[0];if(o.props.showMonthDropdown&&!e)return t.createElement(yt,{dropdownMode:o.props.dropdownMode,locale:o.props.locale,onChange:o.changeMonth,month:O(o.state.date),useShortMonthInDropdown:o.props.useShortMonthInDropdown})})),ue(De(o),"renderMonthYearDropdown",(function(){var e=arguments.length>0&&void 0!==arguments[0]&&arguments[0];if(o.props.showMonthYearDropdown&&!e)return t.createElement(Dt,{dropdownMode:o.props.dropdownMode,locale:o.props.locale,dateFormat:o.props.dateFormat,onChange:o.changeMonthYear,minDate:o.props.minDate,maxDate:o.props.maxDate,date:o.state.date,scrollableMonthYearDropdown:o.props.scrollableMonthYearDropdown})})),ue(De(o),"renderTodayButton",(function(){if(o.props.todayButton&&!o.props.showTimeSelectOnly)return t.createElement("div",{className:"react-datepicker__today-button",onClick:function(e){return o.props.onSelect(A(Se()),e)}},o.props.todayButton)})),ue(De(o),"renderDefaultHeader",(function(e){var r=e.monthDate,n=e.i;return t.createElement("div",{className:"react-datepicker__header"},o.renderCurrentMonth(r),t.createElement("div",{className:"react-datepicker__header__dropdown react-datepicker__header__dropdown--".concat(o.props.dropdownMode),onFocus:o.handleDropdownFocus},o.renderMonthDropdown(0!==n),o.renderMonthYearDropdown(0!==n),o.renderYearDropdown(0!==n)),t.createElement("div",{className:"react-datepicker__day-names"},o.header(r)))})),ue(De(o),"renderCustomHeader",(function(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{},r=e.monthDate,n=e.i;if(0!==n&&void 0!==n)return null;var a=nt(o.state.date,o.props),s=at(o.state.date,o.props),p=ot(o.state.date,o.props),i=st(o.state.date,o.props),c=!o.props.showMonthYearPicker&&!o.props.showQuarterYearPicker&&!o.props.showYearPicker;return t.createElement("div",{className:"react-datepicker__header react-datepicker__header--custom",onFocus:o.props.onDropdownFocus},o.props.renderCustomHeader(me(me({},o.state),{},{changeMonth:o.changeMonth,changeYear:o.changeYear,decreaseMonth:o.decreaseMonth,increaseMonth:o.increaseMonth,decreaseYear:o.decreaseYear,increaseYear:o.increaseYear,prevMonthButtonDisabled:a,nextMonthButtonDisabled:s,prevYearButtonDisabled:p,nextYearButtonDisabled:i})),c&&t.createElement("div",{className:"react-datepicker__day-names"},o.header(r)))})),ue(De(o),"renderYearHeader",(function(){return t.createElement("div",{className:"react-datepicker__header react-datepicker-year-header"},o.props.showYearPicker?"".concat(P(o.state.date)-11," - ").concat(P(o.state.date)):P(o.state.date))})),ue(De(o),"renderHeader",(function(e){switch(!0){case void 0!==o.props.renderCustomHeader:return o.renderCustomHeader(e);case o.props.showMonthYearPicker||o.props.showQuarterYearPicker||o.props.showYearPicker:return o.renderYearHeader(e);default:return o.renderDefaultHeader(e)}})),ue(De(o),"renderMonths",(function(){if(!o.props.showTimeSelectOnly&&!o.props.showYearPicker){for(var e=[],r=o.props.showPreviousMonths?o.props.monthsShown-1:0,n=v(o.state.date,r),a=0;a<o.props.monthsShown;++a){var s=a-o.props.monthSelectedIn,p=d(n,s),i="month-".concat(a);e.push(t.createElement("div",{key:i,ref:function(e){o.monthContainer=e},className:"react-datepicker__month-container"},o.renderHeader({monthDate:p,i:a}),t.createElement(Ct,{chooseDayAriaLabelPrefix:o.props.chooseDayAriaLabelPrefix,disabledDayAriaLabelPrefix:o.props.disabledDayAriaLabelPrefix,weekAriaLabelPrefix:o.props.weekAriaLabelPrefix,onChange:o.changeMonthYear,day:p,dayClassName:o.props.dayClassName,monthClassName:o.props.monthClassName,onDayClick:o.handleDayClick,handleOnKeyDown:o.props.handleOnKeyDown,onDayMouseEnter:o.handleDayMouseEnter,onMouseLeave:o.handleMonthMouseLeave,onWeekSelect:o.props.onWeekSelect,orderInDisplay:a,formatWeekNumber:o.props.formatWeekNumber,locale:o.props.locale,minDate:o.props.minDate,maxDate:o.props.maxDate,excludeDates:o.props.excludeDates,highlightDates:o.props.highlightDates,selectingDate:o.state.selectingDate,includeDates:o.props.includeDates,inline:o.props.inline,fixedHeight:o.props.fixedHeight,filterDate:o.props.filterDate,preSelection:o.props.preSelection,selected:o.props.selected,selectsStart:o.props.selectsStart,selectsEnd:o.props.selectsEnd,showWeekNumbers:o.props.showWeekNumbers,startDate:o.props.startDate,endDate:o.props.endDate,peekNextMonth:o.props.peekNextMonth,setOpen:o.props.setOpen,shouldCloseOnSelect:o.props.shouldCloseOnSelect,renderDayContents:o.props.renderDayContents,disabledKeyboardNavigation:o.props.disabledKeyboardNavigation,showMonthYearPicker:o.props.showMonthYearPicker,showFullMonthYearPicker:o.props.showFullMonthYearPicker,showYearPicker:o.props.showYearPicker,showQuarterYearPicker:o.props.showQuarterYearPicker,isInputFocused:o.props.isInputFocused,containerRef:o.containerRef})))}return e}})),ue(De(o),"renderYears",(function(){if(!o.props.showTimeSelectOnly)return o.props.showYearPicker?t.createElement("div",{className:"react-datepicker__year"},o.renderHeader(),t.createElement(Ot,{onDayClick:o.handleDayClick,date:o.state.date})):void 0})),ue(De(o),"renderTimeSection",(function(){if(o.props.showTimeSelect&&(o.state.monthContainer||o.props.showTimeSelectOnly))return t.createElement(_t,{selected:o.props.selected,openToDate:o.props.openToDate,onChange:o.props.onTimeChange,timeClassName:o.props.timeClassName,format:o.props.timeFormat,includeTimes:o.props.includeTimes,intervals:o.props.timeIntervals,minTime:o.props.minTime,maxTime:o.props.maxTime,excludeTimes:o.props.excludeTimes,timeCaption:o.props.timeCaption,todayButton:o.props.todayButton,showMonthDropdown:o.props.showMonthDropdown,showMonthYearDropdown:o.props.showMonthYearDropdown,showYearDropdown:o.props.showYearDropdown,withPortal:o.props.withPortal,monthRef:o.state.monthContainer,injectTimes:o.props.injectTimes,locale:o.props.locale})})),ue(De(o),"renderInputTimeSection",(function(){var e=new Date(o.props.selected),r="".concat(dt(e.getHours()),":").concat(dt(e.getMinutes()));if(o.props.showTimeInput)return t.createElement(St,{timeString:r,timeInputLabel:o.props.timeInputLabel,onChange:o.props.onTimeChange,customTimeInput:o.props.customTimeInput})})),o.containerRef=t.createRef(),o.state={date:o.getDateInView(),selectingDate:null,monthContainer:null},o}return de(a,null,[{key:"defaultProps",get:function(){return{onDropdownFocus:function(){},monthsShown:1,monthSelectedIn:0,forceShowMonthNavigation:!1,timeCaption:"Time",previousYearButtonLabel:"Previous Year",nextYearButtonLabel:"Next Year",previousMonthButtonLabel:"Previous Month",nextMonthButtonLabel:"Next Month",customTimeInput:null}}}]),de(a,[{key:"componentDidMount",value:function(){var e=this;this.props.showTimeSelect&&(this.assignMonthContainer=void e.setState({monthContainer:e.monthContainer}))}},{key:"componentDidUpdate",value:function(e){this.props.preSelection&&!Re(this.props.preSelection,e.preSelection)?this.setState({date:this.props.preSelection}):this.props.openToDate&&!Re(this.props.openToDate,e.openToDate)&&this.setState({date:this.props.openToDate})}},{key:"render",value:function(){var e=this.props.container||Pt;return t.createElement("div",{ref:this.containerRef},t.createElement(e,{className:n("react-datepicker",this.props.className,{"react-datepicker--time-only":this.props.showTimeSelectOnly}),showPopperArrow:this.props.showPopperArrow},this.renderPreviousButton(),this.renderNextButton(),this.renderMonths(),this.renderYears(),this.renderTodayButton(),this.renderTimeSection(),this.renderInputTimeSection(),this.props.children))}}]),a}(t.Component),Nt=function(e){return!e.disabled&&-1!==e.tabIndex},Yt=function(e){ye(n,e);var r=ge(n);function n(e){var a;return ce(this,n),ue(De(a=r.call(this,e)),"getTabChildren",(function(){return Array.prototype.slice.call(a.tabLoopRef.current.querySelectorAll("[tabindex], a, button, input, select, textarea"),1,-1).filter(Nt)})),ue(De(a),"handleFocusStart",(function(e){var t=a.getTabChildren();t&&t.length>1&&t[t.length-1].focus()})),ue(De(a),"handleFocusEnd",(function(e){var t=a.getTabChildren();t&&t.length>1&&t[0].focus()})),a.tabLoopRef=t.createRef(),a}return de(n,null,[{key:"defaultProps",get:function(){return{enableTabLoop:!0}}}]),de(n,[{key:"render",value:function(){return this.props.enableTabLoop?t.createElement("div",{className:"react-datepicker__tab-loop",ref:this.tabLoopRef},t.createElement("div",{className:"react-datepicker__tab-loop__start",tabIndex:"0",onFocus:this.handleFocusStart}),this.props.children,t.createElement("div",{className:"react-datepicker__tab-loop__end",tabIndex:"0",onFocus:this.handleFocusEnd})):this.props.children}}]),n}(t.Component),xt=function(e){ye(a,e);var r=ge(a);function a(){return ce(this,a),r.apply(this,arguments)}return de(a,[{key:"render",value:function(){var e,r=this.props,a=r.className,o=r.wrapperClassName,s=r.hidePopper,p=r.popperComponent,i=r.popperModifiers,c=r.popperPlacement,l=r.popperProps,d=r.targetComponent,u=r.enableTabLoop,h=r.popperOnKeyDown;if(!s){var f=n("react-datepicker-popper",a);e=t.createElement(pe.Popper,he({modifiers:i,placement:c},l),(function(e){var r=e.ref,n=e.style,a=e.placement,o=e.arrowProps;return t.createElement(Yt,{enableTabLoop:u},t.createElement("div",he({ref:r,style:n},{className:f,"data-placement":a,onKeyDown:h}),t.cloneElement(p,{arrowProps:o})))}))}this.props.popperContainer&&(e=t.createElement(this.props.popperContainer,{},e));var m=n("react-datepicker-wrapper",o);return t.createElement(pe.Manager,{className:"react-datepicker-manager"},t.createElement(pe.Reference,null,(function(e){var r=e.ref;return t.createElement("div",{ref:r,className:m},d)})),e)}}],[{key:"defaultProps",get:function(){return{hidePopper:!0,popperModifiers:{preventOverflow:{enabled:!0,escapeWithReference:!0,boundariesElement:"viewport"}},popperProps:{},popperPlacement:"bottom-start"}}}]),a}(t.Component),Tt=se(Et);var It=function(e){ye(o,e);var r=ge(o);function o(e){var s;return ce(this,o),ue(De(s=r.call(this,e)),"getPreSelection",(function(){return s.props.openToDate?s.props.openToDate:s.props.selectsEnd&&s.props.startDate?s.props.startDate:s.props.selectsStart&&s.props.endDate?s.props.endDate:Se()})),ue(De(s),"calcInitialState",(function(){var e=s.getPreSelection(),t=pt(s.props),r=it(s.props),n=t&&te(e,t)?t:r&&ee(e,r)?r:e;return{open:s.props.startOpen||!1,preventFocus:!1,preSelection:s.props.selected?s.props.selected:n,highlightDates:ct(s.props.highlightDates),focused:!1}})),ue(De(s),"clearPreventFocusTimeout",(function(){s.preventFocusTimeout&&clearTimeout(s.preventFocusTimeout)})),ue(De(s),"setFocus",(function(){s.input&&s.input.focus&&s.input.focus()})),ue(De(s),"setBlur",(function(){s.input&&s.input.blur&&s.input.blur(),s.cancelFocusInput()})),ue(De(s),"setOpen",(function(e){var t=arguments.length>1&&void 0!==arguments[1]&&arguments[1];s.setState({open:e,preSelection:e&&s.state.open?s.state.preSelection:s.calcInitialState().preSelection,lastPreSelectChange:jt},(function(){e||s.setState((function(e){return{focused:!!t&&e.focused}}),(function(){!t&&s.setBlur(),s.setState({inputValue:null})}))}))})),ue(De(s),"inputOk",(function(){return a(s.state.preSelection)})),ue(De(s),"isCalendarOpen",(function(){return void 0===s.props.open?s.state.open&&!s.props.disabled&&!s.props.readOnly:s.props.open})),ue(De(s),"handleFocus",(function(e){s.state.preventFocus||(s.props.onFocus(e),s.props.preventOpenOnFocus||s.props.readOnly||s.setOpen(!0)),s.setState({focused:!0})})),ue(De(s),"cancelFocusInput",(function(){clearTimeout(s.inputFocusTimeout),s.inputFocusTimeout=null})),ue(De(s),"deferFocusInput",(function(){s.cancelFocusInput(),s.inputFocusTimeout=setTimeout((function(){return s.setFocus()}),1)})),ue(De(s),"handleDropdownFocus",(function(){s.cancelFocusInput()})),ue(De(s),"handleBlur",(function(e){(!s.state.open||s.props.withPortal||s.props.showTimeInput)&&s.props.onBlur(e),s.setState({focused:!1})})),ue(De(s),"handleCalendarClickOutside",(function(e){s.props.inline||s.setOpen(!1),s.props.onClickOutside(e),s.props.withPortal&&e.preventDefault()})),ue(De(s),"handleChange",(function(){for(var e=arguments.length,t=new Array(e),r=0;r<e;r++)t[r]=arguments[r];var n=t[0];if(!s.props.onChangeRaw||(s.props.onChangeRaw.apply(De(s),t),"function"==typeof n.isDefaultPrevented&&!n.isDefaultPrevented())){s.setState({inputValue:n.target.value,lastPreSelectChange:Lt});var a=Pe(n.target.value,s.props.dateFormat,s.props.locale,s.props.strictParsing);!a&&n.target.value||s.setSelected(a,n,!0)}})),ue(De(s),"handleSelect",(function(e,t,r){s.setState({preventFocus:!0},(function(){return s.preventFocusTimeout=setTimeout((function(){return s.setState({preventFocus:!1})}),50),s.preventFocusTimeout})),s.setSelected(e,t,!1,r),!s.props.shouldCloseOnSelect||s.props.showTimeSelect?s.setPreSelection(e):s.props.inline||s.setOpen(!1)})),ue(De(s),"setSelected",(function(e,t,r,n){var a=e;null!==a&&$e(a,s.props)||(Ae(s.props.selected,a)&&!s.props.allowSameDay||(null!==a&&(!s.props.selected||r&&(s.props.showTimeSelect||s.props.showTimeSelectOnly||s.props.showTimeInput)||(a=Ne(a,{hour:g(s.props.selected),minute:k(s.props.selected),second:D(s.props.selected)})),s.props.inline||s.setState({preSelection:a}),s.props.inline&&s.props.monthsShown>1&&!s.props.inlineFocusSelectedMonth&&s.setState({monthSelectedIn:n})),s.props.onChange(a,t)),s.props.onSelect(a,t),r||s.setState({inputValue:null}))})),ue(De(s),"setPreSelection",(function(e){var t=void 0!==s.props.minDate,r=void 0!==s.props.maxDate,n=!0;e&&(t&&r?n=Be(e,s.props.minDate,s.props.maxDate):t?n=ee(e,s.props.minDate):r&&(n=te(e,s.props.maxDate))),n&&s.setState({preSelection:e})})),ue(De(s),"handleTimeChange",(function(e){var t=Ne(s.props.selected?s.props.selected:s.getPreSelection(),{hour:g(e),minute:k(e)});s.setState({preSelection:t}),s.props.onChange(t),s.props.shouldCloseOnSelect&&s.setOpen(!1),s.props.showTimeInput&&s.setOpen(!0),s.setState({inputValue:null})})),ue(De(s),"onInputClick",(function(){s.props.disabled||s.props.readOnly||s.setOpen(!0),s.props.onInputClick()})),ue(De(s),"onInputKeyDown",(function(e){s.props.onKeyDown(e);var t=e.key;if(s.state.open||s.props.inline||s.props.preventOpenOnFocus){if(s.state.open){if("ArrowDown"===t||"ArrowUp"===t){e.preventDefault();var r=s.calendar.componentNode&&s.calendar.componentNode.querySelector('.react-datepicker__day[tabindex="0"]');return void(r&&r.focus())}var n=Se(s.state.preSelection);"Enter"===t?(e.preventDefault(),s.inputOk()&&s.state.lastPreSelectChange===jt?(s.handleSelect(n,e),!s.props.shouldCloseOnSelect&&s.setPreSelection(n)):s.setOpen(!1)):"Escape"===t&&(e.preventDefault(),s.setOpen(!1)),s.inputOk()||s.props.onInputError({code:1,msg:"Date input not valid."})}}else"ArrowDown"!==t&&"ArrowUp"!==t&&"Enter"!==t||s.onInputClick()})),ue(De(s),"onDayKeyDown",(function(e){s.props.onKeyDown(e);var t=e.key,r=Se(s.state.preSelection);if("Enter"===t)e.preventDefault(),s.handleSelect(r,e),!s.props.shouldCloseOnSelect&&s.setPreSelection(r);else if("Escape"===t)e.preventDefault(),s.setOpen(!1),s.inputOk()||s.props.onInputError({code:1,msg:"Date input not valid."});else if(!s.props.disabledKeyboardNavigation){var n;switch(t){case"ArrowLeft":n=m(r,1);break;case"ArrowRight":n=c(r,1);break;case"ArrowUp":n=y(r,1);break;case"ArrowDown":n=l(r,1);break;case"PageUp":n=v(r,1);break;case"PageDown":n=d(r,1);break;case"Home":n=w(r,1);break;case"End":n=u(r,1)}if(!n)return void(s.props.onInputError&&s.props.onInputError({code:1,msg:"Date input not valid."}));e.preventDefault(),s.setState({lastPreSelectChange:jt}),s.props.adjustDateOnChange&&s.setSelected(n),s.setPreSelection(n)}})),ue(De(s),"onPopperKeyDown",(function(e){"Escape"===e.key&&(e.preventDefault(),s.setState({preventFocus:!0},(function(){s.setOpen(!1),setTimeout((function(){s.setFocus(),s.setState({preventFocus:!1})}))})))})),ue(De(s),"onClearClick",(function(e){e&&e.preventDefault&&e.preventDefault(),s.props.onChange(null,e),s.setState({inputValue:null})})),ue(De(s),"clear",(function(){s.onClearClick()})),ue(De(s),"renderCalendar",(function(){return s.props.inline||s.isCalendarOpen()?t.createElement(Tt,{ref:function(e){s.calendar=e},locale:s.props.locale,chooseDayAriaLabelPrefix:s.props.chooseDayAriaLabelPrefix,disabledDayAriaLabelPrefix:s.props.disabledDayAriaLabelPrefix,weekAriaLabelPrefix:s.props.weekAriaLabelPrefix,adjustDateOnChange:s.props.adjustDateOnChange,setOpen:s.setOpen,shouldCloseOnSelect:s.props.shouldCloseOnSelect,dateFormat:s.props.dateFormatCalendar,useWeekdaysShort:s.props.useWeekdaysShort,formatWeekDay:s.props.formatWeekDay,dropdownMode:s.props.dropdownMode,selected:s.props.selected,preSelection:s.state.preSelection,onSelect:s.handleSelect,onWeekSelect:s.props.onWeekSelect,openToDate:s.props.openToDate,minDate:s.props.minDate,maxDate:s.props.maxDate,selectsStart:s.props.selectsStart,selectsEnd:s.props.selectsEnd,startDate:s.props.startDate,endDate:s.props.endDate,excludeDates:s.props.excludeDates,filterDate:s.props.filterDate,onClickOutside:s.handleCalendarClickOutside,formatWeekNumber:s.props.formatWeekNumber,highlightDates:s.state.highlightDates,includeDates:s.props.includeDates,includeTimes:s.props.includeTimes,injectTimes:s.props.injectTimes,inline:s.props.inline,peekNextMonth:s.props.peekNextMonth,showMonthDropdown:s.props.showMonthDropdown,showPreviousMonths:s.props.showPreviousMonths,useShortMonthInDropdown:s.props.useShortMonthInDropdown,showMonthYearDropdown:s.props.showMonthYearDropdown,showWeekNumbers:s.props.showWeekNumbers,showYearDropdown:s.props.showYearDropdown,withPortal:s.props.withPortal,forceShowMonthNavigation:s.props.forceShowMonthNavigation,showDisabledMonthNavigation:s.props.showDisabledMonthNavigation,scrollableYearDropdown:s.props.scrollableYearDropdown,scrollableMonthYearDropdown:s.props.scrollableMonthYearDropdown,todayButton:s.props.todayButton,weekLabel:s.props.weekLabel,outsideClickIgnoreClass:"react-datepicker-ignore-onclickoutside",fixedHeight:s.props.fixedHeight,monthsShown:s.props.monthsShown,monthSelectedIn:s.state.monthSelectedIn,onDropdownFocus:s.handleDropdownFocus,onMonthChange:s.props.onMonthChange,onYearChange:s.props.onYearChange,dayClassName:s.props.dayClassName,weekDayClassName:s.props.weekDayClassName,monthClassName:s.props.monthClassName,timeClassName:s.props.timeClassName,showTimeSelect:s.props.showTimeSelect,showTimeSelectOnly:s.props.showTimeSelectOnly,onTimeChange:s.handleTimeChange,timeFormat:s.props.timeFormat,timeIntervals:s.props.timeIntervals,minTime:s.props.minTime,maxTime:s.props.maxTime,excludeTimes:s.props.excludeTimes,timeCaption:s.props.timeCaption,className:s.props.calendarClassName,container:s.props.calendarContainer,yearDropdownItemNumber:s.props.yearDropdownItemNumber,previousMonthButtonLabel:s.props.previousMonthButtonLabel,nextMonthButtonLabel:s.props.nextMonthButtonLabel,previousYearButtonLabel:s.props.previousYearButtonLabel,nextYearButtonLabel:s.props.nextYearButtonLabel,timeInputLabel:s.props.timeInputLabel,disabledKeyboardNavigation:s.props.disabledKeyboardNavigation,renderCustomHeader:s.props.renderCustomHeader,popperProps:s.props.popperProps,renderDayContents:s.props.renderDayContents,onDayMouseEnter:s.props.onDayMouseEnter,onMonthMouseLeave:s.props.onMonthMouseLeave,showTimeInput:s.props.showTimeInput,showMonthYearPicker:s.props.showMonthYearPicker,showFullMonthYearPicker:s.props.showFullMonthYearPicker,showYearPicker:s.props.showYearPicker,showQuarterYearPicker:s.props.showQuarterYearPicker,showPopperArrow:s.props.showPopperArrow,excludeScrollbar:s.props.excludeScrollbar,handleOnKeyDown:s.onDayKeyDown,isInputFocused:s.state.focused,customTimeInput:s.props.customTimeInput,setPreSelection:s.setPreSelection},s.props.children):null})),ue(De(s),"renderDateInput",(function(){var e,r,a,o,p,i=n(s.props.className,ue({},"react-datepicker-ignore-onclickoutside",s.state.open)),c=s.props.customInput||t.createElement("input",{type:"text"}),l=s.props.customInputRef||"ref",d="string"==typeof s.props.value?s.props.value:"string"==typeof s.state.inputValue?s.state.inputValue:(r=s.props.selected,a=s.props,o=a.dateFormat,p=a.locale,r&&Ee(r,Array.isArray(o)?o[0]:o,p)||"");return t.cloneElement(c,(ue(e={},l,(function(e){s.input=e})),ue(e,"value",d),ue(e,"onBlur",s.handleBlur),ue(e,"onChange",s.handleChange),ue(e,"onClick",s.onInputClick),ue(e,"onFocus",s.handleFocus),ue(e,"onKeyDown",s.onInputKeyDown),ue(e,"id",s.props.id),ue(e,"name",s.props.name),ue(e,"autoFocus",s.props.autoFocus),ue(e,"placeholder",s.props.placeholderText),ue(e,"disabled",s.props.disabled),ue(e,"autoComplete",s.props.autoComplete),ue(e,"className",n(c.props.className,i)),ue(e,"title",s.props.title),ue(e,"readOnly",s.props.readOnly),ue(e,"required",s.props.required),ue(e,"tabIndex",s.props.tabIndex),ue(e,"aria-labelledby",s.props.ariaLabelledBy),e))})),ue(De(s),"renderClearButton",(function(){var e=s.props,r=e.isClearable,n=e.selected,a=e.clearButtonTitle,o=e.ariaLabelClose,p=void 0===o?"Close":o;return r&&null!=n?t.createElement("button",{type:"button",className:"react-datepicker__close-icon","aria-label":p,onClick:s.onClearClick,title:a,tabIndex:-1}):null})),s.state=s.calcInitialState(),s}return de(o,null,[{key:"defaultProps",get:function(){return{allowSameDay:!1,dateFormat:"MM/dd/yyyy",dateFormatCalendar:"LLLL yyyy",onChange:function(){},disabled:!1,disabledKeyboardNavigation:!1,dropdownMode:"scroll",onFocus:function(){},onBlur:function(){},onKeyDown:function(){},onInputClick:function(){},onSelect:function(){},onClickOutside:function(){},onMonthChange:function(){},onCalendarOpen:function(){},onCalendarClose:function(){},preventOpenOnFocus:!1,onYearChange:function(){},onInputError:function(){},monthsShown:1,readOnly:!1,withPortal:!1,shouldCloseOnSelect:!0,showTimeSelect:!1,showTimeInput:!1,showPreviousMonths:!1,showMonthYearPicker:!1,showFullMonthYearPicker:!1,showYearPicker:!1,showQuarterYearPicker:!1,strictParsing:!1,timeIntervals:30,timeCaption:"Time",previousMonthButtonLabel:"Previous Month",nextMonthButtonLabel:"Next Month",previousYearButtonLabel:"Previous Year",nextYearButtonLabel:"Next Year",timeInputLabel:"Time",enableTabLoop:!0,renderDayContents:function(e){return e},inlineFocusSelectedMonth:!1,showPopperArrow:!0,excludeScrollbar:!0,customTimeInput:null}}}]),de(o,[{key:"componentDidUpdate",value:function(e,t){var r,n;e.inline&&(r=e.selected,n=this.props.selected,r&&n?O(r)!==O(n)||P(r)!==P(n):r!==n)&&this.setPreSelection(this.props.selected),void 0!==this.state.monthSelectedIn&&e.monthsShown!==this.props.monthsShown&&this.setState({monthSelectedIn:0}),e.highlightDates!==this.props.highlightDates&&this.setState({highlightDates:ct(this.props.highlightDates)}),t.focused||Ae(e.selected,this.props.selected)||this.setState({inputValue:null}),t.open!==this.state.open&&(!1===t.open&&!0===this.state.open&&this.props.onCalendarOpen(),!0===t.open&&!1===this.state.open&&this.props.onCalendarClose())}},{key:"componentWillUnmount",value:function(){this.clearPreventFocusTimeout()}},{key:"render",value:function(){var e=this.renderCalendar();return this.props.inline&&!this.props.withPortal?e:this.props.withPortal?t.createElement("div",null,this.props.inline?null:t.createElement("div",{className:"react-datepicker__input-container"},this.renderDateInput(),this.renderClearButton()),this.state.open||this.props.inline?t.createElement("div",{className:"react-datepicker__portal"},e):null):t.createElement(xt,{className:this.props.popperClassName,wrapperClassName:this.props.wrapperClassName,hidePopper:!this.isCalendarOpen(),popperModifiers:this.props.popperModifiers,targetComponent:t.createElement("div",{className:"react-datepicker__input-container"},this.renderDateInput(),this.renderClearButton()),popperContainer:this.props.popperContainer,popperComponent:e,popperPlacement:this.props.popperPlacement,popperProps:this.props.popperProps,popperOnKeyDown:this.onPopperKeyDown,enableTabLoop:this.props.enableTabLoop})}}]),o}(t.Component),Lt="input",jt="navigate";e.CalendarContainer=Pt,e.default=It,e.getDefaultLocale=He,e.registerLocale=function(e,t){var r="undefined"!=typeof window?window:global;r.__localeData__||(r.__localeData__={}),r.__localeData__[e]=t},e.setDefaultLocale=function(e){("undefined"!=typeof window?window:global).__localeId__=e},Object.defineProperty(e,"__esModule",{value:!0})}));
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 1291 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	var react = __webpack_require__(1);
	var reactDom = __webpack_require__(70);
	
	function _inheritsLoose(subClass, superClass) {
	  subClass.prototype = Object.create(superClass.prototype);
	  subClass.prototype.constructor = subClass;
	  subClass.__proto__ = superClass;
	}
	
	function _objectWithoutProperties(source, excluded) {
	  if (source == null) return {};
	  var target = {};
	  var sourceKeys = Object.keys(source);
	  var key, i;
	
	  for (i = 0; i < sourceKeys.length; i++) {
	    key = sourceKeys[i];
	    if (excluded.indexOf(key) >= 0) continue;
	    target[key] = source[key];
	  }
	
	  if (Object.getOwnPropertySymbols) {
	    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
	
	    for (i = 0; i < sourceSymbolKeys.length; i++) {
	      key = sourceSymbolKeys[i];
	      if (excluded.indexOf(key) >= 0) continue;
	      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
	      target[key] = source[key];
	    }
	  }
	
	  return target;
	}
	
	/**
	 * Check whether some DOM node is our Component's node.
	 */
	function isNodeFound(current, componentNode, ignoreClass) {
	  if (current === componentNode) {
	    return true;
	  } // SVG <use/> elements do not technically reside in the rendered DOM, so
	  // they do not have classList directly, but they offer a link to their
	  // corresponding element, which can have classList. This extra check is for
	  // that case.
	  // See: http://www.w3.org/TR/SVG11/struct.html#InterfaceSVGUseElement
	  // Discussion: https://github.com/Pomax/react-onclickoutside/pull/17
	
	
	  if (current.correspondingElement) {
	    return current.correspondingElement.classList.contains(ignoreClass);
	  }
	
	  return current.classList.contains(ignoreClass);
	}
	/**
	 * Try to find our node in a hierarchy of nodes, returning the document
	 * node as highest node if our node is not found in the path up.
	 */
	
	function findHighest(current, componentNode, ignoreClass) {
	  if (current === componentNode) {
	    return true;
	  } // If source=local then this event came from 'somewhere'
	  // inside and should be ignored. We could handle this with
	  // a layered approach, too, but that requires going back to
	  // thinking in terms of Dom node nesting, running counter
	  // to React's 'you shouldn't care about the DOM' philosophy.
	
	
	  while (current.parentNode) {
	    if (isNodeFound(current, componentNode, ignoreClass)) {
	      return true;
	    }
	
	    current = current.parentNode;
	  }
	
	  return current;
	}
	/**
	 * Check if the browser scrollbar was clicked
	 */
	
	function clickedScrollbar(evt) {
	  return document.documentElement.clientWidth <= evt.clientX || document.documentElement.clientHeight <= evt.clientY;
	}
	
	// ideally will get replaced with external dep
	// when rafrex/detect-passive-events#4 and rafrex/detect-passive-events#5 get merged in
	var testPassiveEventSupport = function testPassiveEventSupport() {
	  if (typeof window === 'undefined' || typeof window.addEventListener !== 'function') {
	    return;
	  }
	
	  var passive = false;
	  var options = Object.defineProperty({}, 'passive', {
	    get: function get() {
	      passive = true;
	    }
	  });
	
	  var noop = function noop() {};
	
	  window.addEventListener('testPassiveEventSupport', noop, options);
	  window.removeEventListener('testPassiveEventSupport', noop, options);
	  return passive;
	};
	
	function autoInc(seed) {
	  if (seed === void 0) {
	    seed = 0;
	  }
	
	  return function () {
	    return ++seed;
	  };
	}
	
	var uid = autoInc();
	
	var passiveEventSupport;
	var handlersMap = {};
	var enabledInstances = {};
	var touchEvents = ['touchstart', 'touchmove'];
	var IGNORE_CLASS_NAME = 'ignore-react-onclickoutside';
	/**
	 * Options for addEventHandler and removeEventHandler
	 */
	
	function getEventHandlerOptions(instance, eventName) {
	  var handlerOptions = null;
	  var isTouchEvent = touchEvents.indexOf(eventName) !== -1;
	
	  if (isTouchEvent && passiveEventSupport) {
	    handlerOptions = {
	      passive: !instance.props.preventDefault
	    };
	  }
	
	  return handlerOptions;
	}
	/**
	 * This function generates the HOC function that you'll use
	 * in order to impart onOutsideClick listening to an
	 * arbitrary component. It gets called at the end of the
	 * bootstrapping code to yield an instance of the
	 * onClickOutsideHOC function defined inside setupHOC().
	 */
	
	
	function onClickOutsideHOC(WrappedComponent, config) {
	  var _class, _temp;
	
	  var componentName = WrappedComponent.displayName || WrappedComponent.name || 'Component';
	  return _temp = _class =
	  /*#__PURE__*/
	  function (_Component) {
	    _inheritsLoose(onClickOutside, _Component);
	
	    function onClickOutside(props) {
	      var _this;
	
	      _this = _Component.call(this, props) || this;
	
	      _this.__outsideClickHandler = function (event) {
	        if (typeof _this.__clickOutsideHandlerProp === 'function') {
	          _this.__clickOutsideHandlerProp(event);
	
	          return;
	        }
	
	        var instance = _this.getInstance();
	
	        if (typeof instance.props.handleClickOutside === 'function') {
	          instance.props.handleClickOutside(event);
	          return;
	        }
	
	        if (typeof instance.handleClickOutside === 'function') {
	          instance.handleClickOutside(event);
	          return;
	        }
	
	        throw new Error("WrappedComponent: " + componentName + " lacks a handleClickOutside(event) function for processing outside click events.");
	      };
	
	      _this.__getComponentNode = function () {
	        var instance = _this.getInstance();
	
	        if (config && typeof config.setClickOutsideRef === 'function') {
	          return config.setClickOutsideRef()(instance);
	        }
	
	        if (typeof instance.setClickOutsideRef === 'function') {
	          return instance.setClickOutsideRef();
	        }
	
	        return reactDom.findDOMNode(instance);
	      };
	
	      _this.enableOnClickOutside = function () {
	        if (typeof document === 'undefined' || enabledInstances[_this._uid]) {
	          return;
	        }
	
	        if (typeof passiveEventSupport === 'undefined') {
	          passiveEventSupport = testPassiveEventSupport();
	        }
	
	        enabledInstances[_this._uid] = true;
	        var events = _this.props.eventTypes;
	
	        if (!events.forEach) {
	          events = [events];
	        }
	
	        handlersMap[_this._uid] = function (event) {
	          if (_this.componentNode === null) return;
	
	          if (_this.props.preventDefault) {
	            event.preventDefault();
	          }
	
	          if (_this.props.stopPropagation) {
	            event.stopPropagation();
	          }
	
	          if (_this.props.excludeScrollbar && clickedScrollbar(event)) return;
	          var current = event.target;
	
	          if (findHighest(current, _this.componentNode, _this.props.outsideClickIgnoreClass) !== document) {
	            return;
	          }
	
	          _this.__outsideClickHandler(event);
	        };
	
	        events.forEach(function (eventName) {
	          document.addEventListener(eventName, handlersMap[_this._uid], getEventHandlerOptions(_this, eventName));
	        });
	      };
	
	      _this.disableOnClickOutside = function () {
	        delete enabledInstances[_this._uid];
	        var fn = handlersMap[_this._uid];
	
	        if (fn && typeof document !== 'undefined') {
	          var events = _this.props.eventTypes;
	
	          if (!events.forEach) {
	            events = [events];
	          }
	
	          events.forEach(function (eventName) {
	            return document.removeEventListener(eventName, fn, getEventHandlerOptions(_this, eventName));
	          });
	          delete handlersMap[_this._uid];
	        }
	      };
	
	      _this.getRef = function (ref) {
	        return _this.instanceRef = ref;
	      };
	
	      _this._uid = uid();
	      return _this;
	    }
	    /**
	     * Access the WrappedComponent's instance.
	     */
	
	
	    var _proto = onClickOutside.prototype;
	
	    _proto.getInstance = function getInstance() {
	      if (!WrappedComponent.prototype.isReactComponent) {
	        return this;
	      }
	
	      var ref = this.instanceRef;
	      return ref.getInstance ? ref.getInstance() : ref;
	    };
	
	    /**
	     * Add click listeners to the current document,
	     * linked to this component's state.
	     */
	    _proto.componentDidMount = function componentDidMount() {
	      // If we are in an environment without a DOM such
	      // as shallow rendering or snapshots then we exit
	      // early to prevent any unhandled errors being thrown.
	      if (typeof document === 'undefined' || !document.createElement) {
	        return;
	      }
	
	      var instance = this.getInstance();
	
	      if (config && typeof config.handleClickOutside === 'function') {
	        this.__clickOutsideHandlerProp = config.handleClickOutside(instance);
	
	        if (typeof this.__clickOutsideHandlerProp !== 'function') {
	          throw new Error("WrappedComponent: " + componentName + " lacks a function for processing outside click events specified by the handleClickOutside config option.");
	        }
	      }
	
	      this.componentNode = this.__getComponentNode(); // return early so we dont initiate onClickOutside
	
	      if (this.props.disableOnClickOutside) return;
	      this.enableOnClickOutside();
	    };
	
	    _proto.componentDidUpdate = function componentDidUpdate() {
	      this.componentNode = this.__getComponentNode();
	    };
	    /**
	     * Remove all document's event listeners for this component
	     */
	
	
	    _proto.componentWillUnmount = function componentWillUnmount() {
	      this.disableOnClickOutside();
	    };
	    /**
	     * Can be called to explicitly enable event listening
	     * for clicks and touches outside of this element.
	     */
	
	
	    /**
	     * Pass-through render
	     */
	    _proto.render = function render() {
	      // eslint-disable-next-line no-unused-vars
	      var _props = this.props,
	          excludeScrollbar = _props.excludeScrollbar,
	          props = _objectWithoutProperties(_props, ["excludeScrollbar"]);
	
	      if (WrappedComponent.prototype.isReactComponent) {
	        props.ref = this.getRef;
	      } else {
	        props.wrappedRef = this.getRef;
	      }
	
	      props.disableOnClickOutside = this.disableOnClickOutside;
	      props.enableOnClickOutside = this.enableOnClickOutside;
	      return react.createElement(WrappedComponent, props);
	    };
	
	    return onClickOutside;
	  }(react.Component), _class.displayName = "OnClickOutside(" + componentName + ")", _class.defaultProps = {
	    eventTypes: ['mousedown', 'touchstart'],
	    excludeScrollbar: config && config.excludeScrollbar || false,
	    outsideClickIgnoreClass: IGNORE_CLASS_NAME,
	    preventDefault: false,
	    stopPropagation: false
	  }, _class.getClass = function () {
	    return WrappedComponent.getClass ? WrappedComponent.getClass() : WrappedComponent;
	  }, _temp;
	}
	
	exports.IGNORE_CLASS_NAME = IGNORE_CLASS_NAME;
	exports['default'] = onClickOutsideHOC;


/***/ },
/* 1292 */
/***/ function(module, exports, __webpack_require__) {

	/** @license React v16.8.6
	 * react-dom.production.min.js
	 *
	 * Copyright (c) Facebook, Inc. and its affiliates.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	/*
	 Modernizr 3.0.0pre (Custom Build) | MIT
	*/
	'use strict';var aa=__webpack_require__(1),n=__webpack_require__(207),r=__webpack_require__(1416);function ba(a,b,c,d,e,f,g,h){if(!a){a=void 0;if(void 0===b)a=Error("Minified exception occurred; use the non-minified dev environment for the full error message and additional helpful warnings.");else{var l=[c,d,e,f,g,h],k=0;a=Error(b.replace(/%s/g,function(){return l[k++]}));a.name="Invariant Violation"}a.framesToPop=1;throw a;}}
	function x(a){for(var b=arguments.length-1,c="https://reactjs.org/docs/error-decoder.html?invariant="+a,d=0;d<b;d++)c+="&args[]="+encodeURIComponent(arguments[d+1]);ba(!1,"Minified React error #"+a+"; visit %s for the full message or use the non-minified dev environment for full errors and additional helpful warnings. ",c)}aa?void 0:x("227");function ca(a,b,c,d,e,f,g,h,l){var k=Array.prototype.slice.call(arguments,3);try{b.apply(c,k)}catch(m){this.onError(m)}}
	var da=!1,ea=null,fa=!1,ha=null,ia={onError:function(a){da=!0;ea=a}};function ja(a,b,c,d,e,f,g,h,l){da=!1;ea=null;ca.apply(ia,arguments)}function ka(a,b,c,d,e,f,g,h,l){ja.apply(this,arguments);if(da){if(da){var k=ea;da=!1;ea=null}else x("198"),k=void 0;fa||(fa=!0,ha=k)}}var la=null,ma={};
	function na(){if(la)for(var a in ma){var b=ma[a],c=la.indexOf(a);-1<c?void 0:x("96",a);if(!oa[c]){b.extractEvents?void 0:x("97",a);oa[c]=b;c=b.eventTypes;for(var d in c){var e=void 0;var f=c[d],g=b,h=d;pa.hasOwnProperty(h)?x("99",h):void 0;pa[h]=f;var l=f.phasedRegistrationNames;if(l){for(e in l)l.hasOwnProperty(e)&&qa(l[e],g,h);e=!0}else f.registrationName?(qa(f.registrationName,g,h),e=!0):e=!1;e?void 0:x("98",d,a)}}}}
	function qa(a,b,c){ra[a]?x("100",a):void 0;ra[a]=b;sa[a]=b.eventTypes[c].dependencies}var oa=[],pa={},ra={},sa={},ta=null,ua=null,va=null;function wa(a,b,c){var d=a.type||"unknown-event";a.currentTarget=va(c);ka(d,b,void 0,a);a.currentTarget=null}function xa(a,b){null==b?x("30"):void 0;if(null==a)return b;if(Array.isArray(a)){if(Array.isArray(b))return a.push.apply(a,b),a;a.push(b);return a}return Array.isArray(b)?[a].concat(b):[a,b]}
	function ya(a,b,c){Array.isArray(a)?a.forEach(b,c):a&&b.call(c,a)}var za=null;function Aa(a){if(a){var b=a._dispatchListeners,c=a._dispatchInstances;if(Array.isArray(b))for(var d=0;d<b.length&&!a.isPropagationStopped();d++)wa(a,b[d],c[d]);else b&&wa(a,b,c);a._dispatchListeners=null;a._dispatchInstances=null;a.isPersistent()||a.constructor.release(a)}}
	var Ba={injectEventPluginOrder:function(a){la?x("101"):void 0;la=Array.prototype.slice.call(a);na()},injectEventPluginsByName:function(a){var b=!1,c;for(c in a)if(a.hasOwnProperty(c)){var d=a[c];ma.hasOwnProperty(c)&&ma[c]===d||(ma[c]?x("102",c):void 0,ma[c]=d,b=!0)}b&&na()}};
	function Ca(a,b){var c=a.stateNode;if(!c)return null;var d=ta(c);if(!d)return null;c=d[b];a:switch(b){case "onClick":case "onClickCapture":case "onDoubleClick":case "onDoubleClickCapture":case "onMouseDown":case "onMouseDownCapture":case "onMouseMove":case "onMouseMoveCapture":case "onMouseUp":case "onMouseUpCapture":(d=!d.disabled)||(a=a.type,d=!("button"===a||"input"===a||"select"===a||"textarea"===a));a=!d;break a;default:a=!1}if(a)return null;c&&"function"!==typeof c?x("231",b,typeof c):void 0;
	return c}function Da(a){null!==a&&(za=xa(za,a));a=za;za=null;if(a&&(ya(a,Aa),za?x("95"):void 0,fa))throw a=ha,fa=!1,ha=null,a;}var Ea=Math.random().toString(36).slice(2),Fa="__reactInternalInstance$"+Ea,Ga="__reactEventHandlers$"+Ea;function Ha(a){if(a[Fa])return a[Fa];for(;!a[Fa];)if(a.parentNode)a=a.parentNode;else return null;a=a[Fa];return 5===a.tag||6===a.tag?a:null}function Ia(a){a=a[Fa];return!a||5!==a.tag&&6!==a.tag?null:a}
	function Ja(a){if(5===a.tag||6===a.tag)return a.stateNode;x("33")}function Ka(a){return a[Ga]||null}function La(a){do a=a.return;while(a&&5!==a.tag);return a?a:null}function Ma(a,b,c){if(b=Ca(a,c.dispatchConfig.phasedRegistrationNames[b]))c._dispatchListeners=xa(c._dispatchListeners,b),c._dispatchInstances=xa(c._dispatchInstances,a)}
	function Na(a){if(a&&a.dispatchConfig.phasedRegistrationNames){for(var b=a._targetInst,c=[];b;)c.push(b),b=La(b);for(b=c.length;0<b--;)Ma(c[b],"captured",a);for(b=0;b<c.length;b++)Ma(c[b],"bubbled",a)}}function Oa(a,b,c){a&&c&&c.dispatchConfig.registrationName&&(b=Ca(a,c.dispatchConfig.registrationName))&&(c._dispatchListeners=xa(c._dispatchListeners,b),c._dispatchInstances=xa(c._dispatchInstances,a))}function Pa(a){a&&a.dispatchConfig.registrationName&&Oa(a._targetInst,null,a)}
	function Qa(a){ya(a,Na)}var Ra=!("undefined"===typeof window||!window.document||!window.document.createElement);function Sa(a,b){var c={};c[a.toLowerCase()]=b.toLowerCase();c["Webkit"+a]="webkit"+b;c["Moz"+a]="moz"+b;return c}var Ta={animationend:Sa("Animation","AnimationEnd"),animationiteration:Sa("Animation","AnimationIteration"),animationstart:Sa("Animation","AnimationStart"),transitionend:Sa("Transition","TransitionEnd")},Ua={},Va={};
	Ra&&(Va=document.createElement("div").style,"AnimationEvent"in window||(delete Ta.animationend.animation,delete Ta.animationiteration.animation,delete Ta.animationstart.animation),"TransitionEvent"in window||delete Ta.transitionend.transition);function Wa(a){if(Ua[a])return Ua[a];if(!Ta[a])return a;var b=Ta[a],c;for(c in b)if(b.hasOwnProperty(c)&&c in Va)return Ua[a]=b[c];return a}
	var Xa=Wa("animationend"),Ya=Wa("animationiteration"),Za=Wa("animationstart"),$a=Wa("transitionend"),ab="abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange seeked seeking stalled suspend timeupdate volumechange waiting".split(" "),bb=null,cb=null,db=null;
	function eb(){if(db)return db;var a,b=cb,c=b.length,d,e="value"in bb?bb.value:bb.textContent,f=e.length;for(a=0;a<c&&b[a]===e[a];a++);var g=c-a;for(d=1;d<=g&&b[c-d]===e[f-d];d++);return db=e.slice(a,1<d?1-d:void 0)}function fb(){return!0}function gb(){return!1}
	function y(a,b,c,d){this.dispatchConfig=a;this._targetInst=b;this.nativeEvent=c;a=this.constructor.Interface;for(var e in a)a.hasOwnProperty(e)&&((b=a[e])?this[e]=b(c):"target"===e?this.target=d:this[e]=c[e]);this.isDefaultPrevented=(null!=c.defaultPrevented?c.defaultPrevented:!1===c.returnValue)?fb:gb;this.isPropagationStopped=gb;return this}
	n(y.prototype,{preventDefault:function(){this.defaultPrevented=!0;var a=this.nativeEvent;a&&(a.preventDefault?a.preventDefault():"unknown"!==typeof a.returnValue&&(a.returnValue=!1),this.isDefaultPrevented=fb)},stopPropagation:function(){var a=this.nativeEvent;a&&(a.stopPropagation?a.stopPropagation():"unknown"!==typeof a.cancelBubble&&(a.cancelBubble=!0),this.isPropagationStopped=fb)},persist:function(){this.isPersistent=fb},isPersistent:gb,destructor:function(){var a=this.constructor.Interface,
	b;for(b in a)this[b]=null;this.nativeEvent=this._targetInst=this.dispatchConfig=null;this.isPropagationStopped=this.isDefaultPrevented=gb;this._dispatchInstances=this._dispatchListeners=null}});y.Interface={type:null,target:null,currentTarget:function(){return null},eventPhase:null,bubbles:null,cancelable:null,timeStamp:function(a){return a.timeStamp||Date.now()},defaultPrevented:null,isTrusted:null};
	y.extend=function(a){function b(){}function c(){return d.apply(this,arguments)}var d=this;b.prototype=d.prototype;var e=new b;n(e,c.prototype);c.prototype=e;c.prototype.constructor=c;c.Interface=n({},d.Interface,a);c.extend=d.extend;hb(c);return c};hb(y);function ib(a,b,c,d){if(this.eventPool.length){var e=this.eventPool.pop();this.call(e,a,b,c,d);return e}return new this(a,b,c,d)}function jb(a){a instanceof this?void 0:x("279");a.destructor();10>this.eventPool.length&&this.eventPool.push(a)}
	function hb(a){a.eventPool=[];a.getPooled=ib;a.release=jb}var kb=y.extend({data:null}),lb=y.extend({data:null}),mb=[9,13,27,32],nb=Ra&&"CompositionEvent"in window,ob=null;Ra&&"documentMode"in document&&(ob=document.documentMode);
	var pb=Ra&&"TextEvent"in window&&!ob,qb=Ra&&(!nb||ob&&8<ob&&11>=ob),rb=String.fromCharCode(32),sb={beforeInput:{phasedRegistrationNames:{bubbled:"onBeforeInput",captured:"onBeforeInputCapture"},dependencies:["compositionend","keypress","textInput","paste"]},compositionEnd:{phasedRegistrationNames:{bubbled:"onCompositionEnd",captured:"onCompositionEndCapture"},dependencies:"blur compositionend keydown keypress keyup mousedown".split(" ")},compositionStart:{phasedRegistrationNames:{bubbled:"onCompositionStart",
	captured:"onCompositionStartCapture"},dependencies:"blur compositionstart keydown keypress keyup mousedown".split(" ")},compositionUpdate:{phasedRegistrationNames:{bubbled:"onCompositionUpdate",captured:"onCompositionUpdateCapture"},dependencies:"blur compositionupdate keydown keypress keyup mousedown".split(" ")}},tb=!1;
	function ub(a,b){switch(a){case "keyup":return-1!==mb.indexOf(b.keyCode);case "keydown":return 229!==b.keyCode;case "keypress":case "mousedown":case "blur":return!0;default:return!1}}function vb(a){a=a.detail;return"object"===typeof a&&"data"in a?a.data:null}var wb=!1;function xb(a,b){switch(a){case "compositionend":return vb(b);case "keypress":if(32!==b.which)return null;tb=!0;return rb;case "textInput":return a=b.data,a===rb&&tb?null:a;default:return null}}
	function yb(a,b){if(wb)return"compositionend"===a||!nb&&ub(a,b)?(a=eb(),db=cb=bb=null,wb=!1,a):null;switch(a){case "paste":return null;case "keypress":if(!(b.ctrlKey||b.altKey||b.metaKey)||b.ctrlKey&&b.altKey){if(b.char&&1<b.char.length)return b.char;if(b.which)return String.fromCharCode(b.which)}return null;case "compositionend":return qb&&"ko"!==b.locale?null:b.data;default:return null}}
	var zb={eventTypes:sb,extractEvents:function(a,b,c,d){var e=void 0;var f=void 0;if(nb)b:{switch(a){case "compositionstart":e=sb.compositionStart;break b;case "compositionend":e=sb.compositionEnd;break b;case "compositionupdate":e=sb.compositionUpdate;break b}e=void 0}else wb?ub(a,c)&&(e=sb.compositionEnd):"keydown"===a&&229===c.keyCode&&(e=sb.compositionStart);e?(qb&&"ko"!==c.locale&&(wb||e!==sb.compositionStart?e===sb.compositionEnd&&wb&&(f=eb()):(bb=d,cb="value"in bb?bb.value:bb.textContent,wb=
	!0)),e=kb.getPooled(e,b,c,d),f?e.data=f:(f=vb(c),null!==f&&(e.data=f)),Qa(e),f=e):f=null;(a=pb?xb(a,c):yb(a,c))?(b=lb.getPooled(sb.beforeInput,b,c,d),b.data=a,Qa(b)):b=null;return null===f?b:null===b?f:[f,b]}},Ab=null,Bb=null,Cb=null;function Db(a){if(a=ua(a)){"function"!==typeof Ab?x("280"):void 0;var b=ta(a.stateNode);Ab(a.stateNode,a.type,b)}}function Eb(a){Bb?Cb?Cb.push(a):Cb=[a]:Bb=a}function Fb(){if(Bb){var a=Bb,b=Cb;Cb=Bb=null;Db(a);if(b)for(a=0;a<b.length;a++)Db(b[a])}}
	function Gb(a,b){return a(b)}function Hb(a,b,c){return a(b,c)}function Ib(){}var Jb=!1;function Kb(a,b){if(Jb)return a(b);Jb=!0;try{return Gb(a,b)}finally{if(Jb=!1,null!==Bb||null!==Cb)Ib(),Fb()}}var Lb={color:!0,date:!0,datetime:!0,"datetime-local":!0,email:!0,month:!0,number:!0,password:!0,range:!0,search:!0,tel:!0,text:!0,time:!0,url:!0,week:!0};function Mb(a){var b=a&&a.nodeName&&a.nodeName.toLowerCase();return"input"===b?!!Lb[a.type]:"textarea"===b?!0:!1}
	function Nb(a){a=a.target||a.srcElement||window;a.correspondingUseElement&&(a=a.correspondingUseElement);return 3===a.nodeType?a.parentNode:a}function Ob(a){if(!Ra)return!1;a="on"+a;var b=a in document;b||(b=document.createElement("div"),b.setAttribute(a,"return;"),b="function"===typeof b[a]);return b}function Pb(a){var b=a.type;return(a=a.nodeName)&&"input"===a.toLowerCase()&&("checkbox"===b||"radio"===b)}
	function Qb(a){var b=Pb(a)?"checked":"value",c=Object.getOwnPropertyDescriptor(a.constructor.prototype,b),d=""+a[b];if(!a.hasOwnProperty(b)&&"undefined"!==typeof c&&"function"===typeof c.get&&"function"===typeof c.set){var e=c.get,f=c.set;Object.defineProperty(a,b,{configurable:!0,get:function(){return e.call(this)},set:function(a){d=""+a;f.call(this,a)}});Object.defineProperty(a,b,{enumerable:c.enumerable});return{getValue:function(){return d},setValue:function(a){d=""+a},stopTracking:function(){a._valueTracker=
	null;delete a[b]}}}}function Rb(a){a._valueTracker||(a._valueTracker=Qb(a))}function Sb(a){if(!a)return!1;var b=a._valueTracker;if(!b)return!0;var c=b.getValue();var d="";a&&(d=Pb(a)?a.checked?"true":"false":a.value);a=d;return a!==c?(b.setValue(a),!0):!1}var Tb=aa.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;Tb.hasOwnProperty("ReactCurrentDispatcher")||(Tb.ReactCurrentDispatcher={current:null});
	var Ub=/^(.*)[\\\/]/,z="function"===typeof Symbol&&Symbol.for,Vb=z?Symbol.for("react.element"):60103,Wb=z?Symbol.for("react.portal"):60106,Xb=z?Symbol.for("react.fragment"):60107,Yb=z?Symbol.for("react.strict_mode"):60108,Zb=z?Symbol.for("react.profiler"):60114,$b=z?Symbol.for("react.provider"):60109,ac=z?Symbol.for("react.context"):60110,bc=z?Symbol.for("react.concurrent_mode"):60111,cc=z?Symbol.for("react.forward_ref"):60112,dc=z?Symbol.for("react.suspense"):60113,ec=z?Symbol.for("react.memo"):
	60115,fc=z?Symbol.for("react.lazy"):60116,gc="function"===typeof Symbol&&Symbol.iterator;function hc(a){if(null===a||"object"!==typeof a)return null;a=gc&&a[gc]||a["@@iterator"];return"function"===typeof a?a:null}
	function ic(a){if(null==a)return null;if("function"===typeof a)return a.displayName||a.name||null;if("string"===typeof a)return a;switch(a){case bc:return"ConcurrentMode";case Xb:return"Fragment";case Wb:return"Portal";case Zb:return"Profiler";case Yb:return"StrictMode";case dc:return"Suspense"}if("object"===typeof a)switch(a.$$typeof){case ac:return"Context.Consumer";case $b:return"Context.Provider";case cc:var b=a.render;b=b.displayName||b.name||"";return a.displayName||(""!==b?"ForwardRef("+b+
	")":"ForwardRef");case ec:return ic(a.type);case fc:if(a=1===a._status?a._result:null)return ic(a)}return null}function jc(a){var b="";do{a:switch(a.tag){case 3:case 4:case 6:case 7:case 10:case 9:var c="";break a;default:var d=a._debugOwner,e=a._debugSource,f=ic(a.type);c=null;d&&(c=ic(d.type));d=f;f="";e?f=" (at "+e.fileName.replace(Ub,"")+":"+e.lineNumber+")":c&&(f=" (created by "+c+")");c="\n    in "+(d||"Unknown")+f}b+=c;a=a.return}while(a);return b}
	var kc=/^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/,lc=Object.prototype.hasOwnProperty,mc={},nc={};
	function oc(a){if(lc.call(nc,a))return!0;if(lc.call(mc,a))return!1;if(kc.test(a))return nc[a]=!0;mc[a]=!0;return!1}function pc(a,b,c,d){if(null!==c&&0===c.type)return!1;switch(typeof b){case "function":case "symbol":return!0;case "boolean":if(d)return!1;if(null!==c)return!c.acceptsBooleans;a=a.toLowerCase().slice(0,5);return"data-"!==a&&"aria-"!==a;default:return!1}}
	function qc(a,b,c,d){if(null===b||"undefined"===typeof b||pc(a,b,c,d))return!0;if(d)return!1;if(null!==c)switch(c.type){case 3:return!b;case 4:return!1===b;case 5:return isNaN(b);case 6:return isNaN(b)||1>b}return!1}function C(a,b,c,d,e){this.acceptsBooleans=2===b||3===b||4===b;this.attributeName=d;this.attributeNamespace=e;this.mustUseProperty=c;this.propertyName=a;this.type=b}var D={};
	"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a){D[a]=new C(a,0,!1,a,null)});[["acceptCharset","accept-charset"],["className","class"],["htmlFor","for"],["httpEquiv","http-equiv"]].forEach(function(a){var b=a[0];D[b]=new C(b,1,!1,a[1],null)});["contentEditable","draggable","spellCheck","value"].forEach(function(a){D[a]=new C(a,2,!1,a.toLowerCase(),null)});
	["autoReverse","externalResourcesRequired","focusable","preserveAlpha"].forEach(function(a){D[a]=new C(a,2,!1,a,null)});"allowFullScreen async autoFocus autoPlay controls default defer disabled formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a){D[a]=new C(a,3,!1,a.toLowerCase(),null)});["checked","multiple","muted","selected"].forEach(function(a){D[a]=new C(a,3,!0,a,null)});
	["capture","download"].forEach(function(a){D[a]=new C(a,4,!1,a,null)});["cols","rows","size","span"].forEach(function(a){D[a]=new C(a,6,!1,a,null)});["rowSpan","start"].forEach(function(a){D[a]=new C(a,5,!1,a.toLowerCase(),null)});var rc=/[\-:]([a-z])/g;function sc(a){return a[1].toUpperCase()}
	"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a){var b=a.replace(rc,
	sc);D[b]=new C(b,1,!1,a,null)});"xlink:actuate xlink:arcrole xlink:href xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a){var b=a.replace(rc,sc);D[b]=new C(b,1,!1,a,"http://www.w3.org/1999/xlink")});["xml:base","xml:lang","xml:space"].forEach(function(a){var b=a.replace(rc,sc);D[b]=new C(b,1,!1,a,"http://www.w3.org/XML/1998/namespace")});["tabIndex","crossOrigin"].forEach(function(a){D[a]=new C(a,1,!1,a.toLowerCase(),null)});
	function tc(a,b,c,d){var e=D.hasOwnProperty(b)?D[b]:null;var f=null!==e?0===e.type:d?!1:!(2<b.length)||"o"!==b[0]&&"O"!==b[0]||"n"!==b[1]&&"N"!==b[1]?!1:!0;f||(qc(b,c,e,d)&&(c=null),d||null===e?oc(b)&&(null===c?a.removeAttribute(b):a.setAttribute(b,""+c)):e.mustUseProperty?a[e.propertyName]=null===c?3===e.type?!1:"":c:(b=e.attributeName,d=e.attributeNamespace,null===c?a.removeAttribute(b):(e=e.type,c=3===e||4===e&&!0===c?"":""+c,d?a.setAttributeNS(d,b,c):a.setAttribute(b,c))))}
	function uc(a){switch(typeof a){case "boolean":case "number":case "object":case "string":case "undefined":return a;default:return""}}function vc(a,b){var c=b.checked;return n({},b,{defaultChecked:void 0,defaultValue:void 0,value:void 0,checked:null!=c?c:a._wrapperState.initialChecked})}
	function wc(a,b){var c=null==b.defaultValue?"":b.defaultValue,d=null!=b.checked?b.checked:b.defaultChecked;c=uc(null!=b.value?b.value:c);a._wrapperState={initialChecked:d,initialValue:c,controlled:"checkbox"===b.type||"radio"===b.type?null!=b.checked:null!=b.value}}function xc(a,b){b=b.checked;null!=b&&tc(a,"checked",b,!1)}
	function yc(a,b){xc(a,b);var c=uc(b.value),d=b.type;if(null!=c)if("number"===d){if(0===c&&""===a.value||a.value!=c)a.value=""+c}else a.value!==""+c&&(a.value=""+c);else if("submit"===d||"reset"===d){a.removeAttribute("value");return}b.hasOwnProperty("value")?zc(a,b.type,c):b.hasOwnProperty("defaultValue")&&zc(a,b.type,uc(b.defaultValue));null==b.checked&&null!=b.defaultChecked&&(a.defaultChecked=!!b.defaultChecked)}
	function Ac(a,b,c){if(b.hasOwnProperty("value")||b.hasOwnProperty("defaultValue")){var d=b.type;if(!("submit"!==d&&"reset"!==d||void 0!==b.value&&null!==b.value))return;b=""+a._wrapperState.initialValue;c||b===a.value||(a.value=b);a.defaultValue=b}c=a.name;""!==c&&(a.name="");a.defaultChecked=!a.defaultChecked;a.defaultChecked=!!a._wrapperState.initialChecked;""!==c&&(a.name=c)}
	function zc(a,b,c){if("number"!==b||a.ownerDocument.activeElement!==a)null==c?a.defaultValue=""+a._wrapperState.initialValue:a.defaultValue!==""+c&&(a.defaultValue=""+c)}var Bc={change:{phasedRegistrationNames:{bubbled:"onChange",captured:"onChangeCapture"},dependencies:"blur change click focus input keydown keyup selectionchange".split(" ")}};function Cc(a,b,c){a=y.getPooled(Bc.change,a,b,c);a.type="change";Eb(c);Qa(a);return a}var Dc=null,Ec=null;function Fc(a){Da(a)}
	function Gc(a){var b=Ja(a);if(Sb(b))return a}function Hc(a,b){if("change"===a)return b}var Ic=!1;Ra&&(Ic=Ob("input")&&(!document.documentMode||9<document.documentMode));function Jc(){Dc&&(Dc.detachEvent("onpropertychange",Kc),Ec=Dc=null)}function Kc(a){"value"===a.propertyName&&Gc(Ec)&&(a=Cc(Ec,a,Nb(a)),Kb(Fc,a))}function Lc(a,b,c){"focus"===a?(Jc(),Dc=b,Ec=c,Dc.attachEvent("onpropertychange",Kc)):"blur"===a&&Jc()}function Mc(a){if("selectionchange"===a||"keyup"===a||"keydown"===a)return Gc(Ec)}
	function Nc(a,b){if("click"===a)return Gc(b)}function Oc(a,b){if("input"===a||"change"===a)return Gc(b)}
	var Pc={eventTypes:Bc,_isInputEventSupported:Ic,extractEvents:function(a,b,c,d){var e=b?Ja(b):window,f=void 0,g=void 0,h=e.nodeName&&e.nodeName.toLowerCase();"select"===h||"input"===h&&"file"===e.type?f=Hc:Mb(e)?Ic?f=Oc:(f=Mc,g=Lc):(h=e.nodeName)&&"input"===h.toLowerCase()&&("checkbox"===e.type||"radio"===e.type)&&(f=Nc);if(f&&(f=f(a,b)))return Cc(f,c,d);g&&g(a,e,b);"blur"===a&&(a=e._wrapperState)&&a.controlled&&"number"===e.type&&zc(e,"number",e.value)}},Qc=y.extend({view:null,detail:null}),Rc={Alt:"altKey",
	Control:"ctrlKey",Meta:"metaKey",Shift:"shiftKey"};function Sc(a){var b=this.nativeEvent;return b.getModifierState?b.getModifierState(a):(a=Rc[a])?!!b[a]:!1}function Tc(){return Sc}
	var Uc=0,Vc=0,Wc=!1,Xc=!1,Yc=Qc.extend({screenX:null,screenY:null,clientX:null,clientY:null,pageX:null,pageY:null,ctrlKey:null,shiftKey:null,altKey:null,metaKey:null,getModifierState:Tc,button:null,buttons:null,relatedTarget:function(a){return a.relatedTarget||(a.fromElement===a.srcElement?a.toElement:a.fromElement)},movementX:function(a){if("movementX"in a)return a.movementX;var b=Uc;Uc=a.screenX;return Wc?"mousemove"===a.type?a.screenX-b:0:(Wc=!0,0)},movementY:function(a){if("movementY"in a)return a.movementY;
	var b=Vc;Vc=a.screenY;return Xc?"mousemove"===a.type?a.screenY-b:0:(Xc=!0,0)}}),Zc=Yc.extend({pointerId:null,width:null,height:null,pressure:null,tangentialPressure:null,tiltX:null,tiltY:null,twist:null,pointerType:null,isPrimary:null}),$c={mouseEnter:{registrationName:"onMouseEnter",dependencies:["mouseout","mouseover"]},mouseLeave:{registrationName:"onMouseLeave",dependencies:["mouseout","mouseover"]},pointerEnter:{registrationName:"onPointerEnter",dependencies:["pointerout","pointerover"]},pointerLeave:{registrationName:"onPointerLeave",
	dependencies:["pointerout","pointerover"]}},ad={eventTypes:$c,extractEvents:function(a,b,c,d){var e="mouseover"===a||"pointerover"===a,f="mouseout"===a||"pointerout"===a;if(e&&(c.relatedTarget||c.fromElement)||!f&&!e)return null;e=d.window===d?d:(e=d.ownerDocument)?e.defaultView||e.parentWindow:window;f?(f=b,b=(b=c.relatedTarget||c.toElement)?Ha(b):null):f=null;if(f===b)return null;var g=void 0,h=void 0,l=void 0,k=void 0;if("mouseout"===a||"mouseover"===a)g=Yc,h=$c.mouseLeave,l=$c.mouseEnter,k="mouse";
	else if("pointerout"===a||"pointerover"===a)g=Zc,h=$c.pointerLeave,l=$c.pointerEnter,k="pointer";var m=null==f?e:Ja(f);e=null==b?e:Ja(b);a=g.getPooled(h,f,c,d);a.type=k+"leave";a.target=m;a.relatedTarget=e;c=g.getPooled(l,b,c,d);c.type=k+"enter";c.target=e;c.relatedTarget=m;d=b;if(f&&d)a:{b=f;e=d;k=0;for(g=b;g;g=La(g))k++;g=0;for(l=e;l;l=La(l))g++;for(;0<k-g;)b=La(b),k--;for(;0<g-k;)e=La(e),g--;for(;k--;){if(b===e||b===e.alternate)break a;b=La(b);e=La(e)}b=null}else b=null;e=b;for(b=[];f&&f!==e;){k=
	f.alternate;if(null!==k&&k===e)break;b.push(f);f=La(f)}for(f=[];d&&d!==e;){k=d.alternate;if(null!==k&&k===e)break;f.push(d);d=La(d)}for(d=0;d<b.length;d++)Oa(b[d],"bubbled",a);for(d=f.length;0<d--;)Oa(f[d],"captured",c);return[a,c]}};function bd(a,b){return a===b&&(0!==a||1/a===1/b)||a!==a&&b!==b}var cd=Object.prototype.hasOwnProperty;
	function dd(a,b){if(bd(a,b))return!0;if("object"!==typeof a||null===a||"object"!==typeof b||null===b)return!1;var c=Object.keys(a),d=Object.keys(b);if(c.length!==d.length)return!1;for(d=0;d<c.length;d++)if(!cd.call(b,c[d])||!bd(a[c[d]],b[c[d]]))return!1;return!0}function ed(a){var b=a;if(a.alternate)for(;b.return;)b=b.return;else{if(0!==(b.effectTag&2))return 1;for(;b.return;)if(b=b.return,0!==(b.effectTag&2))return 1}return 3===b.tag?2:3}function fd(a){2!==ed(a)?x("188"):void 0}
	function gd(a){var b=a.alternate;if(!b)return b=ed(a),3===b?x("188"):void 0,1===b?null:a;for(var c=a,d=b;;){var e=c.return,f=e?e.alternate:null;if(!e||!f)break;if(e.child===f.child){for(var g=e.child;g;){if(g===c)return fd(e),a;if(g===d)return fd(e),b;g=g.sibling}x("188")}if(c.return!==d.return)c=e,d=f;else{g=!1;for(var h=e.child;h;){if(h===c){g=!0;c=e;d=f;break}if(h===d){g=!0;d=e;c=f;break}h=h.sibling}if(!g){for(h=f.child;h;){if(h===c){g=!0;c=f;d=e;break}if(h===d){g=!0;d=f;c=e;break}h=h.sibling}g?
	void 0:x("189")}}c.alternate!==d?x("190"):void 0}3!==c.tag?x("188"):void 0;return c.stateNode.current===c?a:b}function hd(a){a=gd(a);if(!a)return null;for(var b=a;;){if(5===b.tag||6===b.tag)return b;if(b.child)b.child.return=b,b=b.child;else{if(b===a)break;for(;!b.sibling;){if(!b.return||b.return===a)return null;b=b.return}b.sibling.return=b.return;b=b.sibling}}return null}
	var id=y.extend({animationName:null,elapsedTime:null,pseudoElement:null}),jd=y.extend({clipboardData:function(a){return"clipboardData"in a?a.clipboardData:window.clipboardData}}),kd=Qc.extend({relatedTarget:null});function ld(a){var b=a.keyCode;"charCode"in a?(a=a.charCode,0===a&&13===b&&(a=13)):a=b;10===a&&(a=13);return 32<=a||13===a?a:0}
	var md={Esc:"Escape",Spacebar:" ",Left:"ArrowLeft",Up:"ArrowUp",Right:"ArrowRight",Down:"ArrowDown",Del:"Delete",Win:"OS",Menu:"ContextMenu",Apps:"ContextMenu",Scroll:"ScrollLock",MozPrintableKey:"Unidentified"},nd={8:"Backspace",9:"Tab",12:"Clear",13:"Enter",16:"Shift",17:"Control",18:"Alt",19:"Pause",20:"CapsLock",27:"Escape",32:" ",33:"PageUp",34:"PageDown",35:"End",36:"Home",37:"ArrowLeft",38:"ArrowUp",39:"ArrowRight",40:"ArrowDown",45:"Insert",46:"Delete",112:"F1",113:"F2",114:"F3",115:"F4",
	116:"F5",117:"F6",118:"F7",119:"F8",120:"F9",121:"F10",122:"F11",123:"F12",144:"NumLock",145:"ScrollLock",224:"Meta"},od=Qc.extend({key:function(a){if(a.key){var b=md[a.key]||a.key;if("Unidentified"!==b)return b}return"keypress"===a.type?(a=ld(a),13===a?"Enter":String.fromCharCode(a)):"keydown"===a.type||"keyup"===a.type?nd[a.keyCode]||"Unidentified":""},location:null,ctrlKey:null,shiftKey:null,altKey:null,metaKey:null,repeat:null,locale:null,getModifierState:Tc,charCode:function(a){return"keypress"===
	a.type?ld(a):0},keyCode:function(a){return"keydown"===a.type||"keyup"===a.type?a.keyCode:0},which:function(a){return"keypress"===a.type?ld(a):"keydown"===a.type||"keyup"===a.type?a.keyCode:0}}),pd=Yc.extend({dataTransfer:null}),qd=Qc.extend({touches:null,targetTouches:null,changedTouches:null,altKey:null,metaKey:null,ctrlKey:null,shiftKey:null,getModifierState:Tc}),rd=y.extend({propertyName:null,elapsedTime:null,pseudoElement:null}),sd=Yc.extend({deltaX:function(a){return"deltaX"in a?a.deltaX:"wheelDeltaX"in
	a?-a.wheelDeltaX:0},deltaY:function(a){return"deltaY"in a?a.deltaY:"wheelDeltaY"in a?-a.wheelDeltaY:"wheelDelta"in a?-a.wheelDelta:0},deltaZ:null,deltaMode:null}),td=[["abort","abort"],[Xa,"animationEnd"],[Ya,"animationIteration"],[Za,"animationStart"],["canplay","canPlay"],["canplaythrough","canPlayThrough"],["drag","drag"],["dragenter","dragEnter"],["dragexit","dragExit"],["dragleave","dragLeave"],["dragover","dragOver"],["durationchange","durationChange"],["emptied","emptied"],["encrypted","encrypted"],
	["ended","ended"],["error","error"],["gotpointercapture","gotPointerCapture"],["load","load"],["loadeddata","loadedData"],["loadedmetadata","loadedMetadata"],["loadstart","loadStart"],["lostpointercapture","lostPointerCapture"],["mousemove","mouseMove"],["mouseout","mouseOut"],["mouseover","mouseOver"],["playing","playing"],["pointermove","pointerMove"],["pointerout","pointerOut"],["pointerover","pointerOver"],["progress","progress"],["scroll","scroll"],["seeking","seeking"],["stalled","stalled"],
	["suspend","suspend"],["timeupdate","timeUpdate"],["toggle","toggle"],["touchmove","touchMove"],[$a,"transitionEnd"],["waiting","waiting"],["wheel","wheel"]],ud={},vd={};function wd(a,b){var c=a[0];a=a[1];var d="on"+(a[0].toUpperCase()+a.slice(1));b={phasedRegistrationNames:{bubbled:d,captured:d+"Capture"},dependencies:[c],isInteractive:b};ud[a]=b;vd[c]=b}
	[["blur","blur"],["cancel","cancel"],["click","click"],["close","close"],["contextmenu","contextMenu"],["copy","copy"],["cut","cut"],["auxclick","auxClick"],["dblclick","doubleClick"],["dragend","dragEnd"],["dragstart","dragStart"],["drop","drop"],["focus","focus"],["input","input"],["invalid","invalid"],["keydown","keyDown"],["keypress","keyPress"],["keyup","keyUp"],["mousedown","mouseDown"],["mouseup","mouseUp"],["paste","paste"],["pause","pause"],["play","play"],["pointercancel","pointerCancel"],
	["pointerdown","pointerDown"],["pointerup","pointerUp"],["ratechange","rateChange"],["reset","reset"],["seeked","seeked"],["submit","submit"],["touchcancel","touchCancel"],["touchend","touchEnd"],["touchstart","touchStart"],["volumechange","volumeChange"]].forEach(function(a){wd(a,!0)});td.forEach(function(a){wd(a,!1)});
	var xd={eventTypes:ud,isInteractiveTopLevelEventType:function(a){a=vd[a];return void 0!==a&&!0===a.isInteractive},extractEvents:function(a,b,c,d){var e=vd[a];if(!e)return null;switch(a){case "keypress":if(0===ld(c))return null;case "keydown":case "keyup":a=od;break;case "blur":case "focus":a=kd;break;case "click":if(2===c.button)return null;case "auxclick":case "dblclick":case "mousedown":case "mousemove":case "mouseup":case "mouseout":case "mouseover":case "contextmenu":a=Yc;break;case "drag":case "dragend":case "dragenter":case "dragexit":case "dragleave":case "dragover":case "dragstart":case "drop":a=
	pd;break;case "touchcancel":case "touchend":case "touchmove":case "touchstart":a=qd;break;case Xa:case Ya:case Za:a=id;break;case $a:a=rd;break;case "scroll":a=Qc;break;case "wheel":a=sd;break;case "copy":case "cut":case "paste":a=jd;break;case "gotpointercapture":case "lostpointercapture":case "pointercancel":case "pointerdown":case "pointermove":case "pointerout":case "pointerover":case "pointerup":a=Zc;break;default:a=y}b=a.getPooled(e,b,c,d);Qa(b);return b}},yd=xd.isInteractiveTopLevelEventType,
	zd=[];function Ad(a){var b=a.targetInst,c=b;do{if(!c){a.ancestors.push(c);break}var d;for(d=c;d.return;)d=d.return;d=3!==d.tag?null:d.stateNode.containerInfo;if(!d)break;a.ancestors.push(c);c=Ha(d)}while(c);for(c=0;c<a.ancestors.length;c++){b=a.ancestors[c];var e=Nb(a.nativeEvent);d=a.topLevelType;for(var f=a.nativeEvent,g=null,h=0;h<oa.length;h++){var l=oa[h];l&&(l=l.extractEvents(d,b,f,e))&&(g=xa(g,l))}Da(g)}}var Bd=!0;
	function E(a,b){if(!b)return null;var c=(yd(a)?Cd:Dd).bind(null,a);b.addEventListener(a,c,!1)}function Ed(a,b){if(!b)return null;var c=(yd(a)?Cd:Dd).bind(null,a);b.addEventListener(a,c,!0)}function Cd(a,b){Hb(Dd,a,b)}
	function Dd(a,b){if(Bd){var c=Nb(b);c=Ha(c);null===c||"number"!==typeof c.tag||2===ed(c)||(c=null);if(zd.length){var d=zd.pop();d.topLevelType=a;d.nativeEvent=b;d.targetInst=c;a=d}else a={topLevelType:a,nativeEvent:b,targetInst:c,ancestors:[]};try{Kb(Ad,a)}finally{a.topLevelType=null,a.nativeEvent=null,a.targetInst=null,a.ancestors.length=0,10>zd.length&&zd.push(a)}}}var Fd={},Gd=0,Hd="_reactListenersID"+(""+Math.random()).slice(2);
	function Id(a){Object.prototype.hasOwnProperty.call(a,Hd)||(a[Hd]=Gd++,Fd[a[Hd]]={});return Fd[a[Hd]]}function Jd(a){a=a||("undefined"!==typeof document?document:void 0);if("undefined"===typeof a)return null;try{return a.activeElement||a.body}catch(b){return a.body}}function Kd(a){for(;a&&a.firstChild;)a=a.firstChild;return a}
	function Ld(a,b){var c=Kd(a);a=0;for(var d;c;){if(3===c.nodeType){d=a+c.textContent.length;if(a<=b&&d>=b)return{node:c,offset:b-a};a=d}a:{for(;c;){if(c.nextSibling){c=c.nextSibling;break a}c=c.parentNode}c=void 0}c=Kd(c)}}function Md(a,b){return a&&b?a===b?!0:a&&3===a.nodeType?!1:b&&3===b.nodeType?Md(a,b.parentNode):"contains"in a?a.contains(b):a.compareDocumentPosition?!!(a.compareDocumentPosition(b)&16):!1:!1}
	function Nd(){for(var a=window,b=Jd();b instanceof a.HTMLIFrameElement;){try{var c="string"===typeof b.contentWindow.location.href}catch(d){c=!1}if(c)a=b.contentWindow;else break;b=Jd(a.document)}return b}function Od(a){var b=a&&a.nodeName&&a.nodeName.toLowerCase();return b&&("input"===b&&("text"===a.type||"search"===a.type||"tel"===a.type||"url"===a.type||"password"===a.type)||"textarea"===b||"true"===a.contentEditable)}
	function Pd(){var a=Nd();if(Od(a)){if("selectionStart"in a)var b={start:a.selectionStart,end:a.selectionEnd};else a:{b=(b=a.ownerDocument)&&b.defaultView||window;var c=b.getSelection&&b.getSelection();if(c&&0!==c.rangeCount){b=c.anchorNode;var d=c.anchorOffset,e=c.focusNode;c=c.focusOffset;try{b.nodeType,e.nodeType}catch(A){b=null;break a}var f=0,g=-1,h=-1,l=0,k=0,m=a,p=null;b:for(;;){for(var t;;){m!==b||0!==d&&3!==m.nodeType||(g=f+d);m!==e||0!==c&&3!==m.nodeType||(h=f+c);3===m.nodeType&&(f+=m.nodeValue.length);
	if(null===(t=m.firstChild))break;p=m;m=t}for(;;){if(m===a)break b;p===b&&++l===d&&(g=f);p===e&&++k===c&&(h=f);if(null!==(t=m.nextSibling))break;m=p;p=m.parentNode}m=t}b=-1===g||-1===h?null:{start:g,end:h}}else b=null}b=b||{start:0,end:0}}else b=null;return{focusedElem:a,selectionRange:b}}
	function Qd(a){var b=Nd(),c=a.focusedElem,d=a.selectionRange;if(b!==c&&c&&c.ownerDocument&&Md(c.ownerDocument.documentElement,c)){if(null!==d&&Od(c))if(b=d.start,a=d.end,void 0===a&&(a=b),"selectionStart"in c)c.selectionStart=b,c.selectionEnd=Math.min(a,c.value.length);else if(a=(b=c.ownerDocument||document)&&b.defaultView||window,a.getSelection){a=a.getSelection();var e=c.textContent.length,f=Math.min(d.start,e);d=void 0===d.end?f:Math.min(d.end,e);!a.extend&&f>d&&(e=d,d=f,f=e);e=Ld(c,f);var g=Ld(c,
	d);e&&g&&(1!==a.rangeCount||a.anchorNode!==e.node||a.anchorOffset!==e.offset||a.focusNode!==g.node||a.focusOffset!==g.offset)&&(b=b.createRange(),b.setStart(e.node,e.offset),a.removeAllRanges(),f>d?(a.addRange(b),a.extend(g.node,g.offset)):(b.setEnd(g.node,g.offset),a.addRange(b)))}b=[];for(a=c;a=a.parentNode;)1===a.nodeType&&b.push({element:a,left:a.scrollLeft,top:a.scrollTop});"function"===typeof c.focus&&c.focus();for(c=0;c<b.length;c++)a=b[c],a.element.scrollLeft=a.left,a.element.scrollTop=a.top}}
	var Rd=Ra&&"documentMode"in document&&11>=document.documentMode,Sd={select:{phasedRegistrationNames:{bubbled:"onSelect",captured:"onSelectCapture"},dependencies:"blur contextmenu dragend focus keydown keyup mousedown mouseup selectionchange".split(" ")}},Td=null,Ud=null,Vd=null,Wd=!1;
	function Xd(a,b){var c=b.window===b?b.document:9===b.nodeType?b:b.ownerDocument;if(Wd||null==Td||Td!==Jd(c))return null;c=Td;"selectionStart"in c&&Od(c)?c={start:c.selectionStart,end:c.selectionEnd}:(c=(c.ownerDocument&&c.ownerDocument.defaultView||window).getSelection(),c={anchorNode:c.anchorNode,anchorOffset:c.anchorOffset,focusNode:c.focusNode,focusOffset:c.focusOffset});return Vd&&dd(Vd,c)?null:(Vd=c,a=y.getPooled(Sd.select,Ud,a,b),a.type="select",a.target=Td,Qa(a),a)}
	var Yd={eventTypes:Sd,extractEvents:function(a,b,c,d){var e=d.window===d?d.document:9===d.nodeType?d:d.ownerDocument,f;if(!(f=!e)){a:{e=Id(e);f=sa.onSelect;for(var g=0;g<f.length;g++){var h=f[g];if(!e.hasOwnProperty(h)||!e[h]){e=!1;break a}}e=!0}f=!e}if(f)return null;e=b?Ja(b):window;switch(a){case "focus":if(Mb(e)||"true"===e.contentEditable)Td=e,Ud=b,Vd=null;break;case "blur":Vd=Ud=Td=null;break;case "mousedown":Wd=!0;break;case "contextmenu":case "mouseup":case "dragend":return Wd=!1,Xd(c,d);case "selectionchange":if(Rd)break;
	case "keydown":case "keyup":return Xd(c,d)}return null}};Ba.injectEventPluginOrder("ResponderEventPlugin SimpleEventPlugin EnterLeaveEventPlugin ChangeEventPlugin SelectEventPlugin BeforeInputEventPlugin".split(" "));ta=Ka;ua=Ia;va=Ja;Ba.injectEventPluginsByName({SimpleEventPlugin:xd,EnterLeaveEventPlugin:ad,ChangeEventPlugin:Pc,SelectEventPlugin:Yd,BeforeInputEventPlugin:zb});function Zd(a){var b="";aa.Children.forEach(a,function(a){null!=a&&(b+=a)});return b}
	function $d(a,b){a=n({children:void 0},b);if(b=Zd(b.children))a.children=b;return a}function ae(a,b,c,d){a=a.options;if(b){b={};for(var e=0;e<c.length;e++)b["$"+c[e]]=!0;for(c=0;c<a.length;c++)e=b.hasOwnProperty("$"+a[c].value),a[c].selected!==e&&(a[c].selected=e),e&&d&&(a[c].defaultSelected=!0)}else{c=""+uc(c);b=null;for(e=0;e<a.length;e++){if(a[e].value===c){a[e].selected=!0;d&&(a[e].defaultSelected=!0);return}null!==b||a[e].disabled||(b=a[e])}null!==b&&(b.selected=!0)}}
	function be(a,b){null!=b.dangerouslySetInnerHTML?x("91"):void 0;return n({},b,{value:void 0,defaultValue:void 0,children:""+a._wrapperState.initialValue})}function ce(a,b){var c=b.value;null==c&&(c=b.defaultValue,b=b.children,null!=b&&(null!=c?x("92"):void 0,Array.isArray(b)&&(1>=b.length?void 0:x("93"),b=b[0]),c=b),null==c&&(c=""));a._wrapperState={initialValue:uc(c)}}
	function de(a,b){var c=uc(b.value),d=uc(b.defaultValue);null!=c&&(c=""+c,c!==a.value&&(a.value=c),null==b.defaultValue&&a.defaultValue!==c&&(a.defaultValue=c));null!=d&&(a.defaultValue=""+d)}function ee(a){var b=a.textContent;b===a._wrapperState.initialValue&&(a.value=b)}var fe={html:"http://www.w3.org/1999/xhtml",mathml:"http://www.w3.org/1998/Math/MathML",svg:"http://www.w3.org/2000/svg"};
	function ge(a){switch(a){case "svg":return"http://www.w3.org/2000/svg";case "math":return"http://www.w3.org/1998/Math/MathML";default:return"http://www.w3.org/1999/xhtml"}}function he(a,b){return null==a||"http://www.w3.org/1999/xhtml"===a?ge(b):"http://www.w3.org/2000/svg"===a&&"foreignObject"===b?"http://www.w3.org/1999/xhtml":a}
	var ie=void 0,je=function(a){return"undefined"!==typeof MSApp&&MSApp.execUnsafeLocalFunction?function(b,c,d,e){MSApp.execUnsafeLocalFunction(function(){return a(b,c,d,e)})}:a}(function(a,b){if(a.namespaceURI!==fe.svg||"innerHTML"in a)a.innerHTML=b;else{ie=ie||document.createElement("div");ie.innerHTML="<svg>"+b+"</svg>";for(b=ie.firstChild;a.firstChild;)a.removeChild(a.firstChild);for(;b.firstChild;)a.appendChild(b.firstChild)}});
	function ke(a,b){if(b){var c=a.firstChild;if(c&&c===a.lastChild&&3===c.nodeType){c.nodeValue=b;return}}a.textContent=b}
	var le={animationIterationCount:!0,borderImageOutset:!0,borderImageSlice:!0,borderImageWidth:!0,boxFlex:!0,boxFlexGroup:!0,boxOrdinalGroup:!0,columnCount:!0,columns:!0,flex:!0,flexGrow:!0,flexPositive:!0,flexShrink:!0,flexNegative:!0,flexOrder:!0,gridArea:!0,gridRow:!0,gridRowEnd:!0,gridRowSpan:!0,gridRowStart:!0,gridColumn:!0,gridColumnEnd:!0,gridColumnSpan:!0,gridColumnStart:!0,fontWeight:!0,lineClamp:!0,lineHeight:!0,opacity:!0,order:!0,orphans:!0,tabSize:!0,widows:!0,zIndex:!0,zoom:!0,fillOpacity:!0,
	floodOpacity:!0,stopOpacity:!0,strokeDasharray:!0,strokeDashoffset:!0,strokeMiterlimit:!0,strokeOpacity:!0,strokeWidth:!0},me=["Webkit","ms","Moz","O"];Object.keys(le).forEach(function(a){me.forEach(function(b){b=b+a.charAt(0).toUpperCase()+a.substring(1);le[b]=le[a]})});function ne(a,b,c){return null==b||"boolean"===typeof b||""===b?"":c||"number"!==typeof b||0===b||le.hasOwnProperty(a)&&le[a]?(""+b).trim():b+"px"}
	function oe(a,b){a=a.style;for(var c in b)if(b.hasOwnProperty(c)){var d=0===c.indexOf("--"),e=ne(c,b[c],d);"float"===c&&(c="cssFloat");d?a.setProperty(c,e):a[c]=e}}var pe=n({menuitem:!0},{area:!0,base:!0,br:!0,col:!0,embed:!0,hr:!0,img:!0,input:!0,keygen:!0,link:!0,meta:!0,param:!0,source:!0,track:!0,wbr:!0});
	function qe(a,b){b&&(pe[a]&&(null!=b.children||null!=b.dangerouslySetInnerHTML?x("137",a,""):void 0),null!=b.dangerouslySetInnerHTML&&(null!=b.children?x("60"):void 0,"object"===typeof b.dangerouslySetInnerHTML&&"__html"in b.dangerouslySetInnerHTML?void 0:x("61")),null!=b.style&&"object"!==typeof b.style?x("62",""):void 0)}
	function re(a,b){if(-1===a.indexOf("-"))return"string"===typeof b.is;switch(a){case "annotation-xml":case "color-profile":case "font-face":case "font-face-src":case "font-face-uri":case "font-face-format":case "font-face-name":case "missing-glyph":return!1;default:return!0}}
	function se(a,b){a=9===a.nodeType||11===a.nodeType?a:a.ownerDocument;var c=Id(a);b=sa[b];for(var d=0;d<b.length;d++){var e=b[d];if(!c.hasOwnProperty(e)||!c[e]){switch(e){case "scroll":Ed("scroll",a);break;case "focus":case "blur":Ed("focus",a);Ed("blur",a);c.blur=!0;c.focus=!0;break;case "cancel":case "close":Ob(e)&&Ed(e,a);break;case "invalid":case "submit":case "reset":break;default:-1===ab.indexOf(e)&&E(e,a)}c[e]=!0}}}function te(){}var ue=null,ve=null;
	function we(a,b){switch(a){case "button":case "input":case "select":case "textarea":return!!b.autoFocus}return!1}function xe(a,b){return"textarea"===a||"option"===a||"noscript"===a||"string"===typeof b.children||"number"===typeof b.children||"object"===typeof b.dangerouslySetInnerHTML&&null!==b.dangerouslySetInnerHTML&&null!=b.dangerouslySetInnerHTML.__html}
	var ye="function"===typeof setTimeout?setTimeout:void 0,ze="function"===typeof clearTimeout?clearTimeout:void 0,Ae=r.unstable_scheduleCallback,Be=r.unstable_cancelCallback;
	function Ce(a,b,c,d,e){a[Ga]=e;"input"===c&&"radio"===e.type&&null!=e.name&&xc(a,e);re(c,d);d=re(c,e);for(var f=0;f<b.length;f+=2){var g=b[f],h=b[f+1];"style"===g?oe(a,h):"dangerouslySetInnerHTML"===g?je(a,h):"children"===g?ke(a,h):tc(a,g,h,d)}switch(c){case "input":yc(a,e);break;case "textarea":de(a,e);break;case "select":b=a._wrapperState.wasMultiple,a._wrapperState.wasMultiple=!!e.multiple,c=e.value,null!=c?ae(a,!!e.multiple,c,!1):b!==!!e.multiple&&(null!=e.defaultValue?ae(a,!!e.multiple,e.defaultValue,
	!0):ae(a,!!e.multiple,e.multiple?[]:"",!1))}}function De(a){for(a=a.nextSibling;a&&1!==a.nodeType&&3!==a.nodeType;)a=a.nextSibling;return a}function Ee(a){for(a=a.firstChild;a&&1!==a.nodeType&&3!==a.nodeType;)a=a.nextSibling;return a}new Set;var Fe=[],Ge=-1;function F(a){0>Ge||(a.current=Fe[Ge],Fe[Ge]=null,Ge--)}function G(a,b){Ge++;Fe[Ge]=a.current;a.current=b}var He={},H={current:He},I={current:!1},Ie=He;
	function Je(a,b){var c=a.type.contextTypes;if(!c)return He;var d=a.stateNode;if(d&&d.__reactInternalMemoizedUnmaskedChildContext===b)return d.__reactInternalMemoizedMaskedChildContext;var e={},f;for(f in c)e[f]=b[f];d&&(a=a.stateNode,a.__reactInternalMemoizedUnmaskedChildContext=b,a.__reactInternalMemoizedMaskedChildContext=e);return e}function J(a){a=a.childContextTypes;return null!==a&&void 0!==a}function Ke(a){F(I,a);F(H,a)}function Le(a){F(I,a);F(H,a)}
	function Me(a,b,c){H.current!==He?x("168"):void 0;G(H,b,a);G(I,c,a)}function Ne(a,b,c){var d=a.stateNode;a=b.childContextTypes;if("function"!==typeof d.getChildContext)return c;d=d.getChildContext();for(var e in d)e in a?void 0:x("108",ic(b)||"Unknown",e);return n({},c,d)}function Oe(a){var b=a.stateNode;b=b&&b.__reactInternalMemoizedMergedChildContext||He;Ie=H.current;G(H,b,a);G(I,I.current,a);return!0}
	function Pe(a,b,c){var d=a.stateNode;d?void 0:x("169");c?(b=Ne(a,b,Ie),d.__reactInternalMemoizedMergedChildContext=b,F(I,a),F(H,a),G(H,b,a)):F(I,a);G(I,c,a)}var Qe=null,Re=null;function Se(a){return function(b){try{return a(b)}catch(c){}}}
	function Te(a){if("undefined"===typeof __REACT_DEVTOOLS_GLOBAL_HOOK__)return!1;var b=__REACT_DEVTOOLS_GLOBAL_HOOK__;if(b.isDisabled||!b.supportsFiber)return!0;try{var c=b.inject(a);Qe=Se(function(a){return b.onCommitFiberRoot(c,a)});Re=Se(function(a){return b.onCommitFiberUnmount(c,a)})}catch(d){}return!0}
	function Ue(a,b,c,d){this.tag=a;this.key=c;this.sibling=this.child=this.return=this.stateNode=this.type=this.elementType=null;this.index=0;this.ref=null;this.pendingProps=b;this.contextDependencies=this.memoizedState=this.updateQueue=this.memoizedProps=null;this.mode=d;this.effectTag=0;this.lastEffect=this.firstEffect=this.nextEffect=null;this.childExpirationTime=this.expirationTime=0;this.alternate=null}function K(a,b,c,d){return new Ue(a,b,c,d)}
	function Ve(a){a=a.prototype;return!(!a||!a.isReactComponent)}function We(a){if("function"===typeof a)return Ve(a)?1:0;if(void 0!==a&&null!==a){a=a.$$typeof;if(a===cc)return 11;if(a===ec)return 14}return 2}
	function Xe(a,b){var c=a.alternate;null===c?(c=K(a.tag,b,a.key,a.mode),c.elementType=a.elementType,c.type=a.type,c.stateNode=a.stateNode,c.alternate=a,a.alternate=c):(c.pendingProps=b,c.effectTag=0,c.nextEffect=null,c.firstEffect=null,c.lastEffect=null);c.childExpirationTime=a.childExpirationTime;c.expirationTime=a.expirationTime;c.child=a.child;c.memoizedProps=a.memoizedProps;c.memoizedState=a.memoizedState;c.updateQueue=a.updateQueue;c.contextDependencies=a.contextDependencies;c.sibling=a.sibling;
	c.index=a.index;c.ref=a.ref;return c}
	function Ye(a,b,c,d,e,f){var g=2;d=a;if("function"===typeof a)Ve(a)&&(g=1);else if("string"===typeof a)g=5;else a:switch(a){case Xb:return Ze(c.children,e,f,b);case bc:return $e(c,e|3,f,b);case Yb:return $e(c,e|2,f,b);case Zb:return a=K(12,c,b,e|4),a.elementType=Zb,a.type=Zb,a.expirationTime=f,a;case dc:return a=K(13,c,b,e),a.elementType=dc,a.type=dc,a.expirationTime=f,a;default:if("object"===typeof a&&null!==a)switch(a.$$typeof){case $b:g=10;break a;case ac:g=9;break a;case cc:g=11;break a;case ec:g=
	14;break a;case fc:g=16;d=null;break a}x("130",null==a?a:typeof a,"")}b=K(g,c,b,e);b.elementType=a;b.type=d;b.expirationTime=f;return b}function Ze(a,b,c,d){a=K(7,a,d,b);a.expirationTime=c;return a}function $e(a,b,c,d){a=K(8,a,d,b);b=0===(b&1)?Yb:bc;a.elementType=b;a.type=b;a.expirationTime=c;return a}function af(a,b,c){a=K(6,a,null,b);a.expirationTime=c;return a}
	function bf(a,b,c){b=K(4,null!==a.children?a.children:[],a.key,b);b.expirationTime=c;b.stateNode={containerInfo:a.containerInfo,pendingChildren:null,implementation:a.implementation};return b}function cf(a,b){a.didError=!1;var c=a.earliestPendingTime;0===c?a.earliestPendingTime=a.latestPendingTime=b:c<b?a.earliestPendingTime=b:a.latestPendingTime>b&&(a.latestPendingTime=b);df(b,a)}
	function ef(a,b){a.didError=!1;if(0===b)a.earliestPendingTime=0,a.latestPendingTime=0,a.earliestSuspendedTime=0,a.latestSuspendedTime=0,a.latestPingedTime=0;else{b<a.latestPingedTime&&(a.latestPingedTime=0);var c=a.latestPendingTime;0!==c&&(c>b?a.earliestPendingTime=a.latestPendingTime=0:a.earliestPendingTime>b&&(a.earliestPendingTime=a.latestPendingTime));c=a.earliestSuspendedTime;0===c?cf(a,b):b<a.latestSuspendedTime?(a.earliestSuspendedTime=0,a.latestSuspendedTime=0,a.latestPingedTime=0,cf(a,b)):
	b>c&&cf(a,b)}df(0,a)}function ff(a,b){a.didError=!1;a.latestPingedTime>=b&&(a.latestPingedTime=0);var c=a.earliestPendingTime,d=a.latestPendingTime;c===b?a.earliestPendingTime=d===b?a.latestPendingTime=0:d:d===b&&(a.latestPendingTime=c);c=a.earliestSuspendedTime;d=a.latestSuspendedTime;0===c?a.earliestSuspendedTime=a.latestSuspendedTime=b:c<b?a.earliestSuspendedTime=b:d>b&&(a.latestSuspendedTime=b);df(b,a)}
	function gf(a,b){var c=a.earliestPendingTime;a=a.earliestSuspendedTime;c>b&&(b=c);a>b&&(b=a);return b}function df(a,b){var c=b.earliestSuspendedTime,d=b.latestSuspendedTime,e=b.earliestPendingTime,f=b.latestPingedTime;e=0!==e?e:f;0===e&&(0===a||d<a)&&(e=d);a=e;0!==a&&c>a&&(a=c);b.nextExpirationTimeToWorkOn=e;b.expirationTime=a}function L(a,b){if(a&&a.defaultProps){b=n({},b);a=a.defaultProps;for(var c in a)void 0===b[c]&&(b[c]=a[c])}return b}
	function hf(a){var b=a._result;switch(a._status){case 1:return b;case 2:throw b;case 0:throw b;default:a._status=0;b=a._ctor;b=b();b.then(function(b){0===a._status&&(b=b.default,a._status=1,a._result=b)},function(b){0===a._status&&(a._status=2,a._result=b)});switch(a._status){case 1:return a._result;case 2:throw a._result;}a._result=b;throw b;}}var jf=(new aa.Component).refs;
	function kf(a,b,c,d){b=a.memoizedState;c=c(d,b);c=null===c||void 0===c?b:n({},b,c);a.memoizedState=c;d=a.updateQueue;null!==d&&0===a.expirationTime&&(d.baseState=c)}
	var tf={isMounted:function(a){return(a=a._reactInternalFiber)?2===ed(a):!1},enqueueSetState:function(a,b,c){a=a._reactInternalFiber;var d=lf();d=mf(d,a);var e=nf(d);e.payload=b;void 0!==c&&null!==c&&(e.callback=c);of();pf(a,e);qf(a,d)},enqueueReplaceState:function(a,b,c){a=a._reactInternalFiber;var d=lf();d=mf(d,a);var e=nf(d);e.tag=rf;e.payload=b;void 0!==c&&null!==c&&(e.callback=c);of();pf(a,e);qf(a,d)},enqueueForceUpdate:function(a,b){a=a._reactInternalFiber;var c=lf();c=mf(c,a);var d=nf(c);d.tag=
	sf;void 0!==b&&null!==b&&(d.callback=b);of();pf(a,d);qf(a,c)}};function uf(a,b,c,d,e,f,g){a=a.stateNode;return"function"===typeof a.shouldComponentUpdate?a.shouldComponentUpdate(d,f,g):b.prototype&&b.prototype.isPureReactComponent?!dd(c,d)||!dd(e,f):!0}
	function vf(a,b,c){var d=!1,e=He;var f=b.contextType;"object"===typeof f&&null!==f?f=M(f):(e=J(b)?Ie:H.current,d=b.contextTypes,f=(d=null!==d&&void 0!==d)?Je(a,e):He);b=new b(c,f);a.memoizedState=null!==b.state&&void 0!==b.state?b.state:null;b.updater=tf;a.stateNode=b;b._reactInternalFiber=a;d&&(a=a.stateNode,a.__reactInternalMemoizedUnmaskedChildContext=e,a.__reactInternalMemoizedMaskedChildContext=f);return b}
	function wf(a,b,c,d){a=b.state;"function"===typeof b.componentWillReceiveProps&&b.componentWillReceiveProps(c,d);"function"===typeof b.UNSAFE_componentWillReceiveProps&&b.UNSAFE_componentWillReceiveProps(c,d);b.state!==a&&tf.enqueueReplaceState(b,b.state,null)}
	function xf(a,b,c,d){var e=a.stateNode;e.props=c;e.state=a.memoizedState;e.refs=jf;var f=b.contextType;"object"===typeof f&&null!==f?e.context=M(f):(f=J(b)?Ie:H.current,e.context=Je(a,f));f=a.updateQueue;null!==f&&(yf(a,f,c,e,d),e.state=a.memoizedState);f=b.getDerivedStateFromProps;"function"===typeof f&&(kf(a,b,f,c),e.state=a.memoizedState);"function"===typeof b.getDerivedStateFromProps||"function"===typeof e.getSnapshotBeforeUpdate||"function"!==typeof e.UNSAFE_componentWillMount&&"function"!==
	typeof e.componentWillMount||(b=e.state,"function"===typeof e.componentWillMount&&e.componentWillMount(),"function"===typeof e.UNSAFE_componentWillMount&&e.UNSAFE_componentWillMount(),b!==e.state&&tf.enqueueReplaceState(e,e.state,null),f=a.updateQueue,null!==f&&(yf(a,f,c,e,d),e.state=a.memoizedState));"function"===typeof e.componentDidMount&&(a.effectTag|=4)}var zf=Array.isArray;
	function Af(a,b,c){a=c.ref;if(null!==a&&"function"!==typeof a&&"object"!==typeof a){if(c._owner){c=c._owner;var d=void 0;c&&(1!==c.tag?x("309"):void 0,d=c.stateNode);d?void 0:x("147",a);var e=""+a;if(null!==b&&null!==b.ref&&"function"===typeof b.ref&&b.ref._stringRef===e)return b.ref;b=function(a){var b=d.refs;b===jf&&(b=d.refs={});null===a?delete b[e]:b[e]=a};b._stringRef=e;return b}"string"!==typeof a?x("284"):void 0;c._owner?void 0:x("290",a)}return a}
	function Bf(a,b){"textarea"!==a.type&&x("31","[object Object]"===Object.prototype.toString.call(b)?"object with keys {"+Object.keys(b).join(", ")+"}":b,"")}
	function Cf(a){function b(b,c){if(a){var d=b.lastEffect;null!==d?(d.nextEffect=c,b.lastEffect=c):b.firstEffect=b.lastEffect=c;c.nextEffect=null;c.effectTag=8}}function c(c,d){if(!a)return null;for(;null!==d;)b(c,d),d=d.sibling;return null}function d(a,b){for(a=new Map;null!==b;)null!==b.key?a.set(b.key,b):a.set(b.index,b),b=b.sibling;return a}function e(a,b,c){a=Xe(a,b,c);a.index=0;a.sibling=null;return a}function f(b,c,d){b.index=d;if(!a)return c;d=b.alternate;if(null!==d)return d=d.index,d<c?(b.effectTag=
	2,c):d;b.effectTag=2;return c}function g(b){a&&null===b.alternate&&(b.effectTag=2);return b}function h(a,b,c,d){if(null===b||6!==b.tag)return b=af(c,a.mode,d),b.return=a,b;b=e(b,c,d);b.return=a;return b}function l(a,b,c,d){if(null!==b&&b.elementType===c.type)return d=e(b,c.props,d),d.ref=Af(a,b,c),d.return=a,d;d=Ye(c.type,c.key,c.props,null,a.mode,d);d.ref=Af(a,b,c);d.return=a;return d}function k(a,b,c,d){if(null===b||4!==b.tag||b.stateNode.containerInfo!==c.containerInfo||b.stateNode.implementation!==
	c.implementation)return b=bf(c,a.mode,d),b.return=a,b;b=e(b,c.children||[],d);b.return=a;return b}function m(a,b,c,d,f){if(null===b||7!==b.tag)return b=Ze(c,a.mode,d,f),b.return=a,b;b=e(b,c,d);b.return=a;return b}function p(a,b,c){if("string"===typeof b||"number"===typeof b)return b=af(""+b,a.mode,c),b.return=a,b;if("object"===typeof b&&null!==b){switch(b.$$typeof){case Vb:return c=Ye(b.type,b.key,b.props,null,a.mode,c),c.ref=Af(a,null,b),c.return=a,c;case Wb:return b=bf(b,a.mode,c),b.return=a,b}if(zf(b)||
	hc(b))return b=Ze(b,a.mode,c,null),b.return=a,b;Bf(a,b)}return null}function t(a,b,c,d){var e=null!==b?b.key:null;if("string"===typeof c||"number"===typeof c)return null!==e?null:h(a,b,""+c,d);if("object"===typeof c&&null!==c){switch(c.$$typeof){case Vb:return c.key===e?c.type===Xb?m(a,b,c.props.children,d,e):l(a,b,c,d):null;case Wb:return c.key===e?k(a,b,c,d):null}if(zf(c)||hc(c))return null!==e?null:m(a,b,c,d,null);Bf(a,c)}return null}function A(a,b,c,d,e){if("string"===typeof d||"number"===typeof d)return a=
	a.get(c)||null,h(b,a,""+d,e);if("object"===typeof d&&null!==d){switch(d.$$typeof){case Vb:return a=a.get(null===d.key?c:d.key)||null,d.type===Xb?m(b,a,d.props.children,e,d.key):l(b,a,d,e);case Wb:return a=a.get(null===d.key?c:d.key)||null,k(b,a,d,e)}if(zf(d)||hc(d))return a=a.get(c)||null,m(b,a,d,e,null);Bf(b,d)}return null}function v(e,g,h,k){for(var l=null,m=null,q=g,u=g=0,B=null;null!==q&&u<h.length;u++){q.index>u?(B=q,q=null):B=q.sibling;var w=t(e,q,h[u],k);if(null===w){null===q&&(q=B);break}a&&
	q&&null===w.alternate&&b(e,q);g=f(w,g,u);null===m?l=w:m.sibling=w;m=w;q=B}if(u===h.length)return c(e,q),l;if(null===q){for(;u<h.length;u++)if(q=p(e,h[u],k))g=f(q,g,u),null===m?l=q:m.sibling=q,m=q;return l}for(q=d(e,q);u<h.length;u++)if(B=A(q,e,u,h[u],k))a&&null!==B.alternate&&q.delete(null===B.key?u:B.key),g=f(B,g,u),null===m?l=B:m.sibling=B,m=B;a&&q.forEach(function(a){return b(e,a)});return l}function R(e,g,h,k){var l=hc(h);"function"!==typeof l?x("150"):void 0;h=l.call(h);null==h?x("151"):void 0;
	for(var m=l=null,q=g,u=g=0,B=null,w=h.next();null!==q&&!w.done;u++,w=h.next()){q.index>u?(B=q,q=null):B=q.sibling;var v=t(e,q,w.value,k);if(null===v){q||(q=B);break}a&&q&&null===v.alternate&&b(e,q);g=f(v,g,u);null===m?l=v:m.sibling=v;m=v;q=B}if(w.done)return c(e,q),l;if(null===q){for(;!w.done;u++,w=h.next())w=p(e,w.value,k),null!==w&&(g=f(w,g,u),null===m?l=w:m.sibling=w,m=w);return l}for(q=d(e,q);!w.done;u++,w=h.next())w=A(q,e,u,w.value,k),null!==w&&(a&&null!==w.alternate&&q.delete(null===w.key?u:
	w.key),g=f(w,g,u),null===m?l=w:m.sibling=w,m=w);a&&q.forEach(function(a){return b(e,a)});return l}return function(a,d,f,h){var k="object"===typeof f&&null!==f&&f.type===Xb&&null===f.key;k&&(f=f.props.children);var l="object"===typeof f&&null!==f;if(l)switch(f.$$typeof){case Vb:a:{l=f.key;for(k=d;null!==k;){if(k.key===l)if(7===k.tag?f.type===Xb:k.elementType===f.type){c(a,k.sibling);d=e(k,f.type===Xb?f.props.children:f.props,h);d.ref=Af(a,k,f);d.return=a;a=d;break a}else{c(a,k);break}else b(a,k);k=
	k.sibling}f.type===Xb?(d=Ze(f.props.children,a.mode,h,f.key),d.return=a,a=d):(h=Ye(f.type,f.key,f.props,null,a.mode,h),h.ref=Af(a,d,f),h.return=a,a=h)}return g(a);case Wb:a:{for(k=f.key;null!==d;){if(d.key===k)if(4===d.tag&&d.stateNode.containerInfo===f.containerInfo&&d.stateNode.implementation===f.implementation){c(a,d.sibling);d=e(d,f.children||[],h);d.return=a;a=d;break a}else{c(a,d);break}else b(a,d);d=d.sibling}d=bf(f,a.mode,h);d.return=a;a=d}return g(a)}if("string"===typeof f||"number"===typeof f)return f=
	""+f,null!==d&&6===d.tag?(c(a,d.sibling),d=e(d,f,h),d.return=a,a=d):(c(a,d),d=af(f,a.mode,h),d.return=a,a=d),g(a);if(zf(f))return v(a,d,f,h);if(hc(f))return R(a,d,f,h);l&&Bf(a,f);if("undefined"===typeof f&&!k)switch(a.tag){case 1:case 0:h=a.type,x("152",h.displayName||h.name||"Component")}return c(a,d)}}var Df=Cf(!0),Ef=Cf(!1),Ff={},N={current:Ff},Gf={current:Ff},Hf={current:Ff};function If(a){a===Ff?x("174"):void 0;return a}
	function Jf(a,b){G(Hf,b,a);G(Gf,a,a);G(N,Ff,a);var c=b.nodeType;switch(c){case 9:case 11:b=(b=b.documentElement)?b.namespaceURI:he(null,"");break;default:c=8===c?b.parentNode:b,b=c.namespaceURI||null,c=c.tagName,b=he(b,c)}F(N,a);G(N,b,a)}function Kf(a){F(N,a);F(Gf,a);F(Hf,a)}function Lf(a){If(Hf.current);var b=If(N.current);var c=he(b,a.type);b!==c&&(G(Gf,a,a),G(N,c,a))}function Mf(a){Gf.current===a&&(F(N,a),F(Gf,a))}
	var Nf=0,Of=2,Pf=4,Qf=8,Rf=16,Sf=32,Tf=64,Uf=128,Vf=Tb.ReactCurrentDispatcher,Wf=0,Xf=null,O=null,P=null,Yf=null,Q=null,Zf=null,$f=0,ag=null,bg=0,cg=!1,dg=null,eg=0;function fg(){x("321")}function gg(a,b){if(null===b)return!1;for(var c=0;c<b.length&&c<a.length;c++)if(!bd(a[c],b[c]))return!1;return!0}
	function hg(a,b,c,d,e,f){Wf=f;Xf=b;P=null!==a?a.memoizedState:null;Vf.current=null===P?ig:jg;b=c(d,e);if(cg){do cg=!1,eg+=1,P=null!==a?a.memoizedState:null,Zf=Yf,ag=Q=O=null,Vf.current=jg,b=c(d,e);while(cg);dg=null;eg=0}Vf.current=kg;a=Xf;a.memoizedState=Yf;a.expirationTime=$f;a.updateQueue=ag;a.effectTag|=bg;a=null!==O&&null!==O.next;Wf=0;Zf=Q=Yf=P=O=Xf=null;$f=0;ag=null;bg=0;a?x("300"):void 0;return b}function lg(){Vf.current=kg;Wf=0;Zf=Q=Yf=P=O=Xf=null;$f=0;ag=null;bg=0;cg=!1;dg=null;eg=0}
	function mg(){var a={memoizedState:null,baseState:null,queue:null,baseUpdate:null,next:null};null===Q?Yf=Q=a:Q=Q.next=a;return Q}function ng(){if(null!==Zf)Q=Zf,Zf=Q.next,O=P,P=null!==O?O.next:null;else{null===P?x("310"):void 0;O=P;var a={memoizedState:O.memoizedState,baseState:O.baseState,queue:O.queue,baseUpdate:O.baseUpdate,next:null};Q=null===Q?Yf=a:Q.next=a;P=O.next}return Q}function og(a,b){return"function"===typeof b?b(a):b}
	function pg(a){var b=ng(),c=b.queue;null===c?x("311"):void 0;c.lastRenderedReducer=a;if(0<eg){var d=c.dispatch;if(null!==dg){var e=dg.get(c);if(void 0!==e){dg.delete(c);var f=b.memoizedState;do f=a(f,e.action),e=e.next;while(null!==e);bd(f,b.memoizedState)||(qg=!0);b.memoizedState=f;b.baseUpdate===c.last&&(b.baseState=f);c.lastRenderedState=f;return[f,d]}}return[b.memoizedState,d]}d=c.last;var g=b.baseUpdate;f=b.baseState;null!==g?(null!==d&&(d.next=null),d=g.next):d=null!==d?d.next:null;if(null!==
	d){var h=e=null,l=d,k=!1;do{var m=l.expirationTime;m<Wf?(k||(k=!0,h=g,e=f),m>$f&&($f=m)):f=l.eagerReducer===a?l.eagerState:a(f,l.action);g=l;l=l.next}while(null!==l&&l!==d);k||(h=g,e=f);bd(f,b.memoizedState)||(qg=!0);b.memoizedState=f;b.baseUpdate=h;b.baseState=e;c.lastRenderedState=f}return[b.memoizedState,c.dispatch]}
	function rg(a,b,c,d){a={tag:a,create:b,destroy:c,deps:d,next:null};null===ag?(ag={lastEffect:null},ag.lastEffect=a.next=a):(b=ag.lastEffect,null===b?ag.lastEffect=a.next=a:(c=b.next,b.next=a,a.next=c,ag.lastEffect=a));return a}function sg(a,b,c,d){var e=mg();bg|=a;e.memoizedState=rg(b,c,void 0,void 0===d?null:d)}
	function tg(a,b,c,d){var e=ng();d=void 0===d?null:d;var f=void 0;if(null!==O){var g=O.memoizedState;f=g.destroy;if(null!==d&&gg(d,g.deps)){rg(Nf,c,f,d);return}}bg|=a;e.memoizedState=rg(b,c,f,d)}function ug(a,b){if("function"===typeof b)return a=a(),b(a),function(){b(null)};if(null!==b&&void 0!==b)return a=a(),b.current=a,function(){b.current=null}}function vg(){}
	function wg(a,b,c){25>eg?void 0:x("301");var d=a.alternate;if(a===Xf||null!==d&&d===Xf)if(cg=!0,a={expirationTime:Wf,action:c,eagerReducer:null,eagerState:null,next:null},null===dg&&(dg=new Map),c=dg.get(b),void 0===c)dg.set(b,a);else{for(b=c;null!==b.next;)b=b.next;b.next=a}else{of();var e=lf();e=mf(e,a);var f={expirationTime:e,action:c,eagerReducer:null,eagerState:null,next:null},g=b.last;if(null===g)f.next=f;else{var h=g.next;null!==h&&(f.next=h);g.next=f}b.last=f;if(0===a.expirationTime&&(null===
	d||0===d.expirationTime)&&(d=b.lastRenderedReducer,null!==d))try{var l=b.lastRenderedState,k=d(l,c);f.eagerReducer=d;f.eagerState=k;if(bd(k,l))return}catch(m){}finally{}qf(a,e)}}
	var kg={readContext:M,useCallback:fg,useContext:fg,useEffect:fg,useImperativeHandle:fg,useLayoutEffect:fg,useMemo:fg,useReducer:fg,useRef:fg,useState:fg,useDebugValue:fg},ig={readContext:M,useCallback:function(a,b){mg().memoizedState=[a,void 0===b?null:b];return a},useContext:M,useEffect:function(a,b){return sg(516,Uf|Tf,a,b)},useImperativeHandle:function(a,b,c){c=null!==c&&void 0!==c?c.concat([a]):null;return sg(4,Pf|Sf,ug.bind(null,b,a),c)},useLayoutEffect:function(a,b){return sg(4,Pf|Sf,a,b)},
	useMemo:function(a,b){var c=mg();b=void 0===b?null:b;a=a();c.memoizedState=[a,b];return a},useReducer:function(a,b,c){var d=mg();b=void 0!==c?c(b):b;d.memoizedState=d.baseState=b;a=d.queue={last:null,dispatch:null,lastRenderedReducer:a,lastRenderedState:b};a=a.dispatch=wg.bind(null,Xf,a);return[d.memoizedState,a]},useRef:function(a){var b=mg();a={current:a};return b.memoizedState=a},useState:function(a){var b=mg();"function"===typeof a&&(a=a());b.memoizedState=b.baseState=a;a=b.queue={last:null,dispatch:null,
	lastRenderedReducer:og,lastRenderedState:a};a=a.dispatch=wg.bind(null,Xf,a);return[b.memoizedState,a]},useDebugValue:vg},jg={readContext:M,useCallback:function(a,b){var c=ng();b=void 0===b?null:b;var d=c.memoizedState;if(null!==d&&null!==b&&gg(b,d[1]))return d[0];c.memoizedState=[a,b];return a},useContext:M,useEffect:function(a,b){return tg(516,Uf|Tf,a,b)},useImperativeHandle:function(a,b,c){c=null!==c&&void 0!==c?c.concat([a]):null;return tg(4,Pf|Sf,ug.bind(null,b,a),c)},useLayoutEffect:function(a,
	b){return tg(4,Pf|Sf,a,b)},useMemo:function(a,b){var c=ng();b=void 0===b?null:b;var d=c.memoizedState;if(null!==d&&null!==b&&gg(b,d[1]))return d[0];a=a();c.memoizedState=[a,b];return a},useReducer:pg,useRef:function(){return ng().memoizedState},useState:function(a){return pg(og,a)},useDebugValue:vg},xg=null,yg=null,zg=!1;
	function Ag(a,b){var c=K(5,null,null,0);c.elementType="DELETED";c.type="DELETED";c.stateNode=b;c.return=a;c.effectTag=8;null!==a.lastEffect?(a.lastEffect.nextEffect=c,a.lastEffect=c):a.firstEffect=a.lastEffect=c}function Bg(a,b){switch(a.tag){case 5:var c=a.type;b=1!==b.nodeType||c.toLowerCase()!==b.nodeName.toLowerCase()?null:b;return null!==b?(a.stateNode=b,!0):!1;case 6:return b=""===a.pendingProps||3!==b.nodeType?null:b,null!==b?(a.stateNode=b,!0):!1;case 13:return!1;default:return!1}}
	function Cg(a){if(zg){var b=yg;if(b){var c=b;if(!Bg(a,b)){b=De(c);if(!b||!Bg(a,b)){a.effectTag|=2;zg=!1;xg=a;return}Ag(xg,c)}xg=a;yg=Ee(b)}else a.effectTag|=2,zg=!1,xg=a}}function Dg(a){for(a=a.return;null!==a&&5!==a.tag&&3!==a.tag&&18!==a.tag;)a=a.return;xg=a}function Eg(a){if(a!==xg)return!1;if(!zg)return Dg(a),zg=!0,!1;var b=a.type;if(5!==a.tag||"head"!==b&&"body"!==b&&!xe(b,a.memoizedProps))for(b=yg;b;)Ag(a,b),b=De(b);Dg(a);yg=xg?De(a.stateNode):null;return!0}function Fg(){yg=xg=null;zg=!1}
	var Gg=Tb.ReactCurrentOwner,qg=!1;function S(a,b,c,d){b.child=null===a?Ef(b,null,c,d):Df(b,a.child,c,d)}function Hg(a,b,c,d,e){c=c.render;var f=b.ref;Ig(b,e);d=hg(a,b,c,d,f,e);if(null!==a&&!qg)return b.updateQueue=a.updateQueue,b.effectTag&=-517,a.expirationTime<=e&&(a.expirationTime=0),Jg(a,b,e);b.effectTag|=1;S(a,b,d,e);return b.child}
	function Kg(a,b,c,d,e,f){if(null===a){var g=c.type;if("function"===typeof g&&!Ve(g)&&void 0===g.defaultProps&&null===c.compare&&void 0===c.defaultProps)return b.tag=15,b.type=g,Lg(a,b,g,d,e,f);a=Ye(c.type,null,d,null,b.mode,f);a.ref=b.ref;a.return=b;return b.child=a}g=a.child;if(e<f&&(e=g.memoizedProps,c=c.compare,c=null!==c?c:dd,c(e,d)&&a.ref===b.ref))return Jg(a,b,f);b.effectTag|=1;a=Xe(g,d,f);a.ref=b.ref;a.return=b;return b.child=a}
	function Lg(a,b,c,d,e,f){return null!==a&&dd(a.memoizedProps,d)&&a.ref===b.ref&&(qg=!1,e<f)?Jg(a,b,f):Mg(a,b,c,d,f)}function Ng(a,b){var c=b.ref;if(null===a&&null!==c||null!==a&&a.ref!==c)b.effectTag|=128}function Mg(a,b,c,d,e){var f=J(c)?Ie:H.current;f=Je(b,f);Ig(b,e);c=hg(a,b,c,d,f,e);if(null!==a&&!qg)return b.updateQueue=a.updateQueue,b.effectTag&=-517,a.expirationTime<=e&&(a.expirationTime=0),Jg(a,b,e);b.effectTag|=1;S(a,b,c,e);return b.child}
	function Og(a,b,c,d,e){if(J(c)){var f=!0;Oe(b)}else f=!1;Ig(b,e);if(null===b.stateNode)null!==a&&(a.alternate=null,b.alternate=null,b.effectTag|=2),vf(b,c,d,e),xf(b,c,d,e),d=!0;else if(null===a){var g=b.stateNode,h=b.memoizedProps;g.props=h;var l=g.context,k=c.contextType;"object"===typeof k&&null!==k?k=M(k):(k=J(c)?Ie:H.current,k=Je(b,k));var m=c.getDerivedStateFromProps,p="function"===typeof m||"function"===typeof g.getSnapshotBeforeUpdate;p||"function"!==typeof g.UNSAFE_componentWillReceiveProps&&
	"function"!==typeof g.componentWillReceiveProps||(h!==d||l!==k)&&wf(b,g,d,k);Pg=!1;var t=b.memoizedState;l=g.state=t;var A=b.updateQueue;null!==A&&(yf(b,A,d,g,e),l=b.memoizedState);h!==d||t!==l||I.current||Pg?("function"===typeof m&&(kf(b,c,m,d),l=b.memoizedState),(h=Pg||uf(b,c,h,d,t,l,k))?(p||"function"!==typeof g.UNSAFE_componentWillMount&&"function"!==typeof g.componentWillMount||("function"===typeof g.componentWillMount&&g.componentWillMount(),"function"===typeof g.UNSAFE_componentWillMount&&
	g.UNSAFE_componentWillMount()),"function"===typeof g.componentDidMount&&(b.effectTag|=4)):("function"===typeof g.componentDidMount&&(b.effectTag|=4),b.memoizedProps=d,b.memoizedState=l),g.props=d,g.state=l,g.context=k,d=h):("function"===typeof g.componentDidMount&&(b.effectTag|=4),d=!1)}else g=b.stateNode,h=b.memoizedProps,g.props=b.type===b.elementType?h:L(b.type,h),l=g.context,k=c.contextType,"object"===typeof k&&null!==k?k=M(k):(k=J(c)?Ie:H.current,k=Je(b,k)),m=c.getDerivedStateFromProps,(p="function"===
	typeof m||"function"===typeof g.getSnapshotBeforeUpdate)||"function"!==typeof g.UNSAFE_componentWillReceiveProps&&"function"!==typeof g.componentWillReceiveProps||(h!==d||l!==k)&&wf(b,g,d,k),Pg=!1,l=b.memoizedState,t=g.state=l,A=b.updateQueue,null!==A&&(yf(b,A,d,g,e),t=b.memoizedState),h!==d||l!==t||I.current||Pg?("function"===typeof m&&(kf(b,c,m,d),t=b.memoizedState),(m=Pg||uf(b,c,h,d,l,t,k))?(p||"function"!==typeof g.UNSAFE_componentWillUpdate&&"function"!==typeof g.componentWillUpdate||("function"===
	typeof g.componentWillUpdate&&g.componentWillUpdate(d,t,k),"function"===typeof g.UNSAFE_componentWillUpdate&&g.UNSAFE_componentWillUpdate(d,t,k)),"function"===typeof g.componentDidUpdate&&(b.effectTag|=4),"function"===typeof g.getSnapshotBeforeUpdate&&(b.effectTag|=256)):("function"!==typeof g.componentDidUpdate||h===a.memoizedProps&&l===a.memoizedState||(b.effectTag|=4),"function"!==typeof g.getSnapshotBeforeUpdate||h===a.memoizedProps&&l===a.memoizedState||(b.effectTag|=256),b.memoizedProps=d,b.memoizedState=
	t),g.props=d,g.state=t,g.context=k,d=m):("function"!==typeof g.componentDidUpdate||h===a.memoizedProps&&l===a.memoizedState||(b.effectTag|=4),"function"!==typeof g.getSnapshotBeforeUpdate||h===a.memoizedProps&&l===a.memoizedState||(b.effectTag|=256),d=!1);return Qg(a,b,c,d,f,e)}
	function Qg(a,b,c,d,e,f){Ng(a,b);var g=0!==(b.effectTag&64);if(!d&&!g)return e&&Pe(b,c,!1),Jg(a,b,f);d=b.stateNode;Gg.current=b;var h=g&&"function"!==typeof c.getDerivedStateFromError?null:d.render();b.effectTag|=1;null!==a&&g?(b.child=Df(b,a.child,null,f),b.child=Df(b,null,h,f)):S(a,b,h,f);b.memoizedState=d.state;e&&Pe(b,c,!0);return b.child}function Rg(a){var b=a.stateNode;b.pendingContext?Me(a,b.pendingContext,b.pendingContext!==b.context):b.context&&Me(a,b.context,!1);Jf(a,b.containerInfo)}
	function Sg(a,b,c){var d=b.mode,e=b.pendingProps,f=b.memoizedState;if(0===(b.effectTag&64)){f=null;var g=!1}else f={timedOutAt:null!==f?f.timedOutAt:0},g=!0,b.effectTag&=-65;if(null===a)if(g){var h=e.fallback;a=Ze(null,d,0,null);0===(b.mode&1)&&(a.child=null!==b.memoizedState?b.child.child:b.child);d=Ze(h,d,c,null);a.sibling=d;c=a;c.return=d.return=b}else c=d=Ef(b,null,e.children,c);else null!==a.memoizedState?(d=a.child,h=d.sibling,g?(c=e.fallback,e=Xe(d,d.pendingProps,0),0===(b.mode&1)&&(g=null!==
	b.memoizedState?b.child.child:b.child,g!==d.child&&(e.child=g)),d=e.sibling=Xe(h,c,h.expirationTime),c=e,e.childExpirationTime=0,c.return=d.return=b):c=d=Df(b,d.child,e.children,c)):(h=a.child,g?(g=e.fallback,e=Ze(null,d,0,null),e.child=h,0===(b.mode&1)&&(e.child=null!==b.memoizedState?b.child.child:b.child),d=e.sibling=Ze(g,d,c,null),d.effectTag|=2,c=e,e.childExpirationTime=0,c.return=d.return=b):d=c=Df(b,h,e.children,c)),b.stateNode=a.stateNode;b.memoizedState=f;b.child=c;return d}
	function Jg(a,b,c){null!==a&&(b.contextDependencies=a.contextDependencies);if(b.childExpirationTime<c)return null;null!==a&&b.child!==a.child?x("153"):void 0;if(null!==b.child){a=b.child;c=Xe(a,a.pendingProps,a.expirationTime);b.child=c;for(c.return=b;null!==a.sibling;)a=a.sibling,c=c.sibling=Xe(a,a.pendingProps,a.expirationTime),c.return=b;c.sibling=null}return b.child}
	function Tg(a,b,c){var d=b.expirationTime;if(null!==a)if(a.memoizedProps!==b.pendingProps||I.current)qg=!0;else{if(d<c){qg=!1;switch(b.tag){case 3:Rg(b);Fg();break;case 5:Lf(b);break;case 1:J(b.type)&&Oe(b);break;case 4:Jf(b,b.stateNode.containerInfo);break;case 10:Ug(b,b.memoizedProps.value);break;case 13:if(null!==b.memoizedState){d=b.child.childExpirationTime;if(0!==d&&d>=c)return Sg(a,b,c);b=Jg(a,b,c);return null!==b?b.sibling:null}}return Jg(a,b,c)}}else qg=!1;b.expirationTime=0;switch(b.tag){case 2:d=
	b.elementType;null!==a&&(a.alternate=null,b.alternate=null,b.effectTag|=2);a=b.pendingProps;var e=Je(b,H.current);Ig(b,c);e=hg(null,b,d,a,e,c);b.effectTag|=1;if("object"===typeof e&&null!==e&&"function"===typeof e.render&&void 0===e.$$typeof){b.tag=1;lg();if(J(d)){var f=!0;Oe(b)}else f=!1;b.memoizedState=null!==e.state&&void 0!==e.state?e.state:null;var g=d.getDerivedStateFromProps;"function"===typeof g&&kf(b,d,g,a);e.updater=tf;b.stateNode=e;e._reactInternalFiber=b;xf(b,d,a,c);b=Qg(null,b,d,!0,f,
	c)}else b.tag=0,S(null,b,e,c),b=b.child;return b;case 16:e=b.elementType;null!==a&&(a.alternate=null,b.alternate=null,b.effectTag|=2);f=b.pendingProps;a=hf(e);b.type=a;e=b.tag=We(a);f=L(a,f);g=void 0;switch(e){case 0:g=Mg(null,b,a,f,c);break;case 1:g=Og(null,b,a,f,c);break;case 11:g=Hg(null,b,a,f,c);break;case 14:g=Kg(null,b,a,L(a.type,f),d,c);break;default:x("306",a,"")}return g;case 0:return d=b.type,e=b.pendingProps,e=b.elementType===d?e:L(d,e),Mg(a,b,d,e,c);case 1:return d=b.type,e=b.pendingProps,
	e=b.elementType===d?e:L(d,e),Og(a,b,d,e,c);case 3:Rg(b);d=b.updateQueue;null===d?x("282"):void 0;e=b.memoizedState;e=null!==e?e.element:null;yf(b,d,b.pendingProps,null,c);d=b.memoizedState.element;if(d===e)Fg(),b=Jg(a,b,c);else{e=b.stateNode;if(e=(null===a||null===a.child)&&e.hydrate)yg=Ee(b.stateNode.containerInfo),xg=b,e=zg=!0;e?(b.effectTag|=2,b.child=Ef(b,null,d,c)):(S(a,b,d,c),Fg());b=b.child}return b;case 5:return Lf(b),null===a&&Cg(b),d=b.type,e=b.pendingProps,f=null!==a?a.memoizedProps:null,
	g=e.children,xe(d,e)?g=null:null!==f&&xe(d,f)&&(b.effectTag|=16),Ng(a,b),1!==c&&b.mode&1&&e.hidden?(b.expirationTime=b.childExpirationTime=1,b=null):(S(a,b,g,c),b=b.child),b;case 6:return null===a&&Cg(b),null;case 13:return Sg(a,b,c);case 4:return Jf(b,b.stateNode.containerInfo),d=b.pendingProps,null===a?b.child=Df(b,null,d,c):S(a,b,d,c),b.child;case 11:return d=b.type,e=b.pendingProps,e=b.elementType===d?e:L(d,e),Hg(a,b,d,e,c);case 7:return S(a,b,b.pendingProps,c),b.child;case 8:return S(a,b,b.pendingProps.children,
	c),b.child;case 12:return S(a,b,b.pendingProps.children,c),b.child;case 10:a:{d=b.type._context;e=b.pendingProps;g=b.memoizedProps;f=e.value;Ug(b,f);if(null!==g){var h=g.value;f=bd(h,f)?0:("function"===typeof d._calculateChangedBits?d._calculateChangedBits(h,f):1073741823)|0;if(0===f){if(g.children===e.children&&!I.current){b=Jg(a,b,c);break a}}else for(h=b.child,null!==h&&(h.return=b);null!==h;){var l=h.contextDependencies;if(null!==l){g=h.child;for(var k=l.first;null!==k;){if(k.context===d&&0!==
	(k.observedBits&f)){1===h.tag&&(k=nf(c),k.tag=sf,pf(h,k));h.expirationTime<c&&(h.expirationTime=c);k=h.alternate;null!==k&&k.expirationTime<c&&(k.expirationTime=c);k=c;for(var m=h.return;null!==m;){var p=m.alternate;if(m.childExpirationTime<k)m.childExpirationTime=k,null!==p&&p.childExpirationTime<k&&(p.childExpirationTime=k);else if(null!==p&&p.childExpirationTime<k)p.childExpirationTime=k;else break;m=m.return}l.expirationTime<c&&(l.expirationTime=c);break}k=k.next}}else g=10===h.tag?h.type===b.type?
	null:h.child:h.child;if(null!==g)g.return=h;else for(g=h;null!==g;){if(g===b){g=null;break}h=g.sibling;if(null!==h){h.return=g.return;g=h;break}g=g.return}h=g}}S(a,b,e.children,c);b=b.child}return b;case 9:return e=b.type,f=b.pendingProps,d=f.children,Ig(b,c),e=M(e,f.unstable_observedBits),d=d(e),b.effectTag|=1,S(a,b,d,c),b.child;case 14:return e=b.type,f=L(e,b.pendingProps),f=L(e.type,f),Kg(a,b,e,f,d,c);case 15:return Lg(a,b,b.type,b.pendingProps,d,c);case 17:return d=b.type,e=b.pendingProps,e=b.elementType===
	d?e:L(d,e),null!==a&&(a.alternate=null,b.alternate=null,b.effectTag|=2),b.tag=1,J(d)?(a=!0,Oe(b)):a=!1,Ig(b,c),vf(b,d,e,c),xf(b,d,e,c),Qg(null,b,d,!0,a,c)}x("156")}var Vg={current:null},Wg=null,Xg=null,Yg=null;function Ug(a,b){var c=a.type._context;G(Vg,c._currentValue,a);c._currentValue=b}function Zg(a){var b=Vg.current;F(Vg,a);a.type._context._currentValue=b}function Ig(a,b){Wg=a;Yg=Xg=null;var c=a.contextDependencies;null!==c&&c.expirationTime>=b&&(qg=!0);a.contextDependencies=null}
	function M(a,b){if(Yg!==a&&!1!==b&&0!==b){if("number"!==typeof b||1073741823===b)Yg=a,b=1073741823;b={context:a,observedBits:b,next:null};null===Xg?(null===Wg?x("308"):void 0,Xg=b,Wg.contextDependencies={first:b,expirationTime:0}):Xg=Xg.next=b}return a._currentValue}var $g=0,rf=1,sf=2,ah=3,Pg=!1;function bh(a){return{baseState:a,firstUpdate:null,lastUpdate:null,firstCapturedUpdate:null,lastCapturedUpdate:null,firstEffect:null,lastEffect:null,firstCapturedEffect:null,lastCapturedEffect:null}}
	function ch(a){return{baseState:a.baseState,firstUpdate:a.firstUpdate,lastUpdate:a.lastUpdate,firstCapturedUpdate:null,lastCapturedUpdate:null,firstEffect:null,lastEffect:null,firstCapturedEffect:null,lastCapturedEffect:null}}function nf(a){return{expirationTime:a,tag:$g,payload:null,callback:null,next:null,nextEffect:null}}function dh(a,b){null===a.lastUpdate?a.firstUpdate=a.lastUpdate=b:(a.lastUpdate.next=b,a.lastUpdate=b)}
	function pf(a,b){var c=a.alternate;if(null===c){var d=a.updateQueue;var e=null;null===d&&(d=a.updateQueue=bh(a.memoizedState))}else d=a.updateQueue,e=c.updateQueue,null===d?null===e?(d=a.updateQueue=bh(a.memoizedState),e=c.updateQueue=bh(c.memoizedState)):d=a.updateQueue=ch(e):null===e&&(e=c.updateQueue=ch(d));null===e||d===e?dh(d,b):null===d.lastUpdate||null===e.lastUpdate?(dh(d,b),dh(e,b)):(dh(d,b),e.lastUpdate=b)}
	function eh(a,b){var c=a.updateQueue;c=null===c?a.updateQueue=bh(a.memoizedState):fh(a,c);null===c.lastCapturedUpdate?c.firstCapturedUpdate=c.lastCapturedUpdate=b:(c.lastCapturedUpdate.next=b,c.lastCapturedUpdate=b)}function fh(a,b){var c=a.alternate;null!==c&&b===c.updateQueue&&(b=a.updateQueue=ch(b));return b}
	function gh(a,b,c,d,e,f){switch(c.tag){case rf:return a=c.payload,"function"===typeof a?a.call(f,d,e):a;case ah:a.effectTag=a.effectTag&-2049|64;case $g:a=c.payload;e="function"===typeof a?a.call(f,d,e):a;if(null===e||void 0===e)break;return n({},d,e);case sf:Pg=!0}return d}
	function yf(a,b,c,d,e){Pg=!1;b=fh(a,b);for(var f=b.baseState,g=null,h=0,l=b.firstUpdate,k=f;null!==l;){var m=l.expirationTime;m<e?(null===g&&(g=l,f=k),h<m&&(h=m)):(k=gh(a,b,l,k,c,d),null!==l.callback&&(a.effectTag|=32,l.nextEffect=null,null===b.lastEffect?b.firstEffect=b.lastEffect=l:(b.lastEffect.nextEffect=l,b.lastEffect=l)));l=l.next}m=null;for(l=b.firstCapturedUpdate;null!==l;){var p=l.expirationTime;p<e?(null===m&&(m=l,null===g&&(f=k)),h<p&&(h=p)):(k=gh(a,b,l,k,c,d),null!==l.callback&&(a.effectTag|=
	32,l.nextEffect=null,null===b.lastCapturedEffect?b.firstCapturedEffect=b.lastCapturedEffect=l:(b.lastCapturedEffect.nextEffect=l,b.lastCapturedEffect=l)));l=l.next}null===g&&(b.lastUpdate=null);null===m?b.lastCapturedUpdate=null:a.effectTag|=32;null===g&&null===m&&(f=k);b.baseState=f;b.firstUpdate=g;b.firstCapturedUpdate=m;a.expirationTime=h;a.memoizedState=k}
	function hh(a,b,c){null!==b.firstCapturedUpdate&&(null!==b.lastUpdate&&(b.lastUpdate.next=b.firstCapturedUpdate,b.lastUpdate=b.lastCapturedUpdate),b.firstCapturedUpdate=b.lastCapturedUpdate=null);ih(b.firstEffect,c);b.firstEffect=b.lastEffect=null;ih(b.firstCapturedEffect,c);b.firstCapturedEffect=b.lastCapturedEffect=null}function ih(a,b){for(;null!==a;){var c=a.callback;if(null!==c){a.callback=null;var d=b;"function"!==typeof c?x("191",c):void 0;c.call(d)}a=a.nextEffect}}
	function jh(a,b){return{value:a,source:b,stack:jc(b)}}function kh(a){a.effectTag|=4}var lh=void 0,mh=void 0,nh=void 0,oh=void 0;lh=function(a,b){for(var c=b.child;null!==c;){if(5===c.tag||6===c.tag)a.appendChild(c.stateNode);else if(4!==c.tag&&null!==c.child){c.child.return=c;c=c.child;continue}if(c===b)break;for(;null===c.sibling;){if(null===c.return||c.return===b)return;c=c.return}c.sibling.return=c.return;c=c.sibling}};mh=function(){};
	nh=function(a,b,c,d,e){var f=a.memoizedProps;if(f!==d){var g=b.stateNode;If(N.current);a=null;switch(c){case "input":f=vc(g,f);d=vc(g,d);a=[];break;case "option":f=$d(g,f);d=$d(g,d);a=[];break;case "select":f=n({},f,{value:void 0});d=n({},d,{value:void 0});a=[];break;case "textarea":f=be(g,f);d=be(g,d);a=[];break;default:"function"!==typeof f.onClick&&"function"===typeof d.onClick&&(g.onclick=te)}qe(c,d);g=c=void 0;var h=null;for(c in f)if(!d.hasOwnProperty(c)&&f.hasOwnProperty(c)&&null!=f[c])if("style"===
	c){var l=f[c];for(g in l)l.hasOwnProperty(g)&&(h||(h={}),h[g]="")}else"dangerouslySetInnerHTML"!==c&&"children"!==c&&"suppressContentEditableWarning"!==c&&"suppressHydrationWarning"!==c&&"autoFocus"!==c&&(ra.hasOwnProperty(c)?a||(a=[]):(a=a||[]).push(c,null));for(c in d){var k=d[c];l=null!=f?f[c]:void 0;if(d.hasOwnProperty(c)&&k!==l&&(null!=k||null!=l))if("style"===c)if(l){for(g in l)!l.hasOwnProperty(g)||k&&k.hasOwnProperty(g)||(h||(h={}),h[g]="");for(g in k)k.hasOwnProperty(g)&&l[g]!==k[g]&&(h||
	(h={}),h[g]=k[g])}else h||(a||(a=[]),a.push(c,h)),h=k;else"dangerouslySetInnerHTML"===c?(k=k?k.__html:void 0,l=l?l.__html:void 0,null!=k&&l!==k&&(a=a||[]).push(c,""+k)):"children"===c?l===k||"string"!==typeof k&&"number"!==typeof k||(a=a||[]).push(c,""+k):"suppressContentEditableWarning"!==c&&"suppressHydrationWarning"!==c&&(ra.hasOwnProperty(c)?(null!=k&&se(e,c),a||l===k||(a=[])):(a=a||[]).push(c,k))}h&&(a=a||[]).push("style",h);e=a;(b.updateQueue=e)&&kh(b)}};oh=function(a,b,c,d){c!==d&&kh(b)};
	var ph="function"===typeof WeakSet?WeakSet:Set;function qh(a,b){var c=b.source,d=b.stack;null===d&&null!==c&&(d=jc(c));null!==c&&ic(c.type);b=b.value;null!==a&&1===a.tag&&ic(a.type);try{console.error(b)}catch(e){setTimeout(function(){throw e;})}}function rh(a){var b=a.ref;if(null!==b)if("function"===typeof b)try{b(null)}catch(c){sh(a,c)}else b.current=null}
	function th(a,b,c){c=c.updateQueue;c=null!==c?c.lastEffect:null;if(null!==c){var d=c=c.next;do{if((d.tag&a)!==Nf){var e=d.destroy;d.destroy=void 0;void 0!==e&&e()}(d.tag&b)!==Nf&&(e=d.create,d.destroy=e());d=d.next}while(d!==c)}}
	function uh(a,b){for(var c=a;;){if(5===c.tag){var d=c.stateNode;if(b)d.style.display="none";else{d=c.stateNode;var e=c.memoizedProps.style;e=void 0!==e&&null!==e&&e.hasOwnProperty("display")?e.display:null;d.style.display=ne("display",e)}}else if(6===c.tag)c.stateNode.nodeValue=b?"":c.memoizedProps;else if(13===c.tag&&null!==c.memoizedState){d=c.child.sibling;d.return=c;c=d;continue}else if(null!==c.child){c.child.return=c;c=c.child;continue}if(c===a)break;for(;null===c.sibling;){if(null===c.return||
	c.return===a)return;c=c.return}c.sibling.return=c.return;c=c.sibling}}
	function vh(a){"function"===typeof Re&&Re(a);switch(a.tag){case 0:case 11:case 14:case 15:var b=a.updateQueue;if(null!==b&&(b=b.lastEffect,null!==b)){var c=b=b.next;do{var d=c.destroy;if(void 0!==d){var e=a;try{d()}catch(f){sh(e,f)}}c=c.next}while(c!==b)}break;case 1:rh(a);b=a.stateNode;if("function"===typeof b.componentWillUnmount)try{b.props=a.memoizedProps,b.state=a.memoizedState,b.componentWillUnmount()}catch(f){sh(a,f)}break;case 5:rh(a);break;case 4:wh(a)}}
	function xh(a){return 5===a.tag||3===a.tag||4===a.tag}
	function yh(a){a:{for(var b=a.return;null!==b;){if(xh(b)){var c=b;break a}b=b.return}x("160");c=void 0}var d=b=void 0;switch(c.tag){case 5:b=c.stateNode;d=!1;break;case 3:b=c.stateNode.containerInfo;d=!0;break;case 4:b=c.stateNode.containerInfo;d=!0;break;default:x("161")}c.effectTag&16&&(ke(b,""),c.effectTag&=-17);a:b:for(c=a;;){for(;null===c.sibling;){if(null===c.return||xh(c.return)){c=null;break a}c=c.return}c.sibling.return=c.return;for(c=c.sibling;5!==c.tag&&6!==c.tag&&18!==c.tag;){if(c.effectTag&
	2)continue b;if(null===c.child||4===c.tag)continue b;else c.child.return=c,c=c.child}if(!(c.effectTag&2)){c=c.stateNode;break a}}for(var e=a;;){if(5===e.tag||6===e.tag)if(c)if(d){var f=b,g=e.stateNode,h=c;8===f.nodeType?f.parentNode.insertBefore(g,h):f.insertBefore(g,h)}else b.insertBefore(e.stateNode,c);else d?(g=b,h=e.stateNode,8===g.nodeType?(f=g.parentNode,f.insertBefore(h,g)):(f=g,f.appendChild(h)),g=g._reactRootContainer,null!==g&&void 0!==g||null!==f.onclick||(f.onclick=te)):b.appendChild(e.stateNode);
	else if(4!==e.tag&&null!==e.child){e.child.return=e;e=e.child;continue}if(e===a)break;for(;null===e.sibling;){if(null===e.return||e.return===a)return;e=e.return}e.sibling.return=e.return;e=e.sibling}}
	function wh(a){for(var b=a,c=!1,d=void 0,e=void 0;;){if(!c){c=b.return;a:for(;;){null===c?x("160"):void 0;switch(c.tag){case 5:d=c.stateNode;e=!1;break a;case 3:d=c.stateNode.containerInfo;e=!0;break a;case 4:d=c.stateNode.containerInfo;e=!0;break a}c=c.return}c=!0}if(5===b.tag||6===b.tag){a:for(var f=b,g=f;;)if(vh(g),null!==g.child&&4!==g.tag)g.child.return=g,g=g.child;else{if(g===f)break;for(;null===g.sibling;){if(null===g.return||g.return===f)break a;g=g.return}g.sibling.return=g.return;g=g.sibling}e?
	(f=d,g=b.stateNode,8===f.nodeType?f.parentNode.removeChild(g):f.removeChild(g)):d.removeChild(b.stateNode)}else if(4===b.tag){if(null!==b.child){d=b.stateNode.containerInfo;e=!0;b.child.return=b;b=b.child;continue}}else if(vh(b),null!==b.child){b.child.return=b;b=b.child;continue}if(b===a)break;for(;null===b.sibling;){if(null===b.return||b.return===a)return;b=b.return;4===b.tag&&(c=!1)}b.sibling.return=b.return;b=b.sibling}}
	function zh(a,b){switch(b.tag){case 0:case 11:case 14:case 15:th(Pf,Qf,b);break;case 1:break;case 5:var c=b.stateNode;if(null!=c){var d=b.memoizedProps;a=null!==a?a.memoizedProps:d;var e=b.type,f=b.updateQueue;b.updateQueue=null;null!==f&&Ce(c,f,e,a,d,b)}break;case 6:null===b.stateNode?x("162"):void 0;b.stateNode.nodeValue=b.memoizedProps;break;case 3:break;case 12:break;case 13:c=b.memoizedState;d=void 0;a=b;null===c?d=!1:(d=!0,a=b.child,0===c.timedOutAt&&(c.timedOutAt=lf()));null!==a&&uh(a,d);c=
	b.updateQueue;if(null!==c){b.updateQueue=null;var g=b.stateNode;null===g&&(g=b.stateNode=new ph);c.forEach(function(a){var c=Ah.bind(null,b,a);g.has(a)||(g.add(a),a.then(c,c))})}break;case 17:break;default:x("163")}}var Bh="function"===typeof WeakMap?WeakMap:Map;function Ch(a,b,c){c=nf(c);c.tag=ah;c.payload={element:null};var d=b.value;c.callback=function(){Dh(d);qh(a,b)};return c}
	function Eh(a,b,c){c=nf(c);c.tag=ah;var d=a.type.getDerivedStateFromError;if("function"===typeof d){var e=b.value;c.payload=function(){return d(e)}}var f=a.stateNode;null!==f&&"function"===typeof f.componentDidCatch&&(c.callback=function(){"function"!==typeof d&&(null===Fh?Fh=new Set([this]):Fh.add(this));var c=b.value,e=b.stack;qh(a,b);this.componentDidCatch(c,{componentStack:null!==e?e:""})});return c}
	function Gh(a){switch(a.tag){case 1:J(a.type)&&Ke(a);var b=a.effectTag;return b&2048?(a.effectTag=b&-2049|64,a):null;case 3:return Kf(a),Le(a),b=a.effectTag,0!==(b&64)?x("285"):void 0,a.effectTag=b&-2049|64,a;case 5:return Mf(a),null;case 13:return b=a.effectTag,b&2048?(a.effectTag=b&-2049|64,a):null;case 18:return null;case 4:return Kf(a),null;case 10:return Zg(a),null;default:return null}}
	var Hh=Tb.ReactCurrentDispatcher,Ih=Tb.ReactCurrentOwner,Jh=1073741822,Kh=!1,T=null,Lh=null,U=0,Mh=-1,Nh=!1,V=null,Oh=!1,Ph=null,Qh=null,Rh=null,Fh=null;function Sh(){if(null!==T)for(var a=T.return;null!==a;){var b=a;switch(b.tag){case 1:var c=b.type.childContextTypes;null!==c&&void 0!==c&&Ke(b);break;case 3:Kf(b);Le(b);break;case 5:Mf(b);break;case 4:Kf(b);break;case 10:Zg(b)}a=a.return}Lh=null;U=0;Mh=-1;Nh=!1;T=null}
	function Th(){for(;null!==V;){var a=V.effectTag;a&16&&ke(V.stateNode,"");if(a&128){var b=V.alternate;null!==b&&(b=b.ref,null!==b&&("function"===typeof b?b(null):b.current=null))}switch(a&14){case 2:yh(V);V.effectTag&=-3;break;case 6:yh(V);V.effectTag&=-3;zh(V.alternate,V);break;case 4:zh(V.alternate,V);break;case 8:a=V,wh(a),a.return=null,a.child=null,a.memoizedState=null,a.updateQueue=null,a=a.alternate,null!==a&&(a.return=null,a.child=null,a.memoizedState=null,a.updateQueue=null)}V=V.nextEffect}}
	function Uh(){for(;null!==V;){if(V.effectTag&256)a:{var a=V.alternate,b=V;switch(b.tag){case 0:case 11:case 15:th(Of,Nf,b);break a;case 1:if(b.effectTag&256&&null!==a){var c=a.memoizedProps,d=a.memoizedState;a=b.stateNode;b=a.getSnapshotBeforeUpdate(b.elementType===b.type?c:L(b.type,c),d);a.__reactInternalSnapshotBeforeUpdate=b}break a;case 3:case 5:case 6:case 4:case 17:break a;default:x("163")}}V=V.nextEffect}}
	function Vh(a,b){for(;null!==V;){var c=V.effectTag;if(c&36){var d=V.alternate,e=V,f=b;switch(e.tag){case 0:case 11:case 15:th(Rf,Sf,e);break;case 1:var g=e.stateNode;if(e.effectTag&4)if(null===d)g.componentDidMount();else{var h=e.elementType===e.type?d.memoizedProps:L(e.type,d.memoizedProps);g.componentDidUpdate(h,d.memoizedState,g.__reactInternalSnapshotBeforeUpdate)}d=e.updateQueue;null!==d&&hh(e,d,g,f);break;case 3:d=e.updateQueue;if(null!==d){g=null;if(null!==e.child)switch(e.child.tag){case 5:g=
	e.child.stateNode;break;case 1:g=e.child.stateNode}hh(e,d,g,f)}break;case 5:f=e.stateNode;null===d&&e.effectTag&4&&we(e.type,e.memoizedProps)&&f.focus();break;case 6:break;case 4:break;case 12:break;case 13:break;case 17:break;default:x("163")}}c&128&&(e=V.ref,null!==e&&(f=V.stateNode,"function"===typeof e?e(f):e.current=f));c&512&&(Ph=a);V=V.nextEffect}}
	function Wh(a,b){Rh=Qh=Ph=null;var c=W;W=!0;do{if(b.effectTag&512){var d=!1,e=void 0;try{var f=b;th(Uf,Nf,f);th(Nf,Tf,f)}catch(g){d=!0,e=g}d&&sh(b,e)}b=b.nextEffect}while(null!==b);W=c;c=a.expirationTime;0!==c&&Xh(a,c);X||W||Yh(1073741823,!1)}function of(){null!==Qh&&Be(Qh);null!==Rh&&Rh()}
	function Zh(a,b){Oh=Kh=!0;a.current===b?x("177"):void 0;var c=a.pendingCommitExpirationTime;0===c?x("261"):void 0;a.pendingCommitExpirationTime=0;var d=b.expirationTime,e=b.childExpirationTime;ef(a,e>d?e:d);Ih.current=null;d=void 0;1<b.effectTag?null!==b.lastEffect?(b.lastEffect.nextEffect=b,d=b.firstEffect):d=b:d=b.firstEffect;ue=Bd;ve=Pd();Bd=!1;for(V=d;null!==V;){e=!1;var f=void 0;try{Uh()}catch(h){e=!0,f=h}e&&(null===V?x("178"):void 0,sh(V,f),null!==V&&(V=V.nextEffect))}for(V=d;null!==V;){e=!1;
	f=void 0;try{Th()}catch(h){e=!0,f=h}e&&(null===V?x("178"):void 0,sh(V,f),null!==V&&(V=V.nextEffect))}Qd(ve);ve=null;Bd=!!ue;ue=null;a.current=b;for(V=d;null!==V;){e=!1;f=void 0;try{Vh(a,c)}catch(h){e=!0,f=h}e&&(null===V?x("178"):void 0,sh(V,f),null!==V&&(V=V.nextEffect))}if(null!==d&&null!==Ph){var g=Wh.bind(null,a,d);Qh=r.unstable_runWithPriority(r.unstable_NormalPriority,function(){return Ae(g)});Rh=g}Kh=Oh=!1;"function"===typeof Qe&&Qe(b.stateNode);c=b.expirationTime;b=b.childExpirationTime;b=
	b>c?b:c;0===b&&(Fh=null);$h(a,b)}
	function ai(a){for(;;){var b=a.alternate,c=a.return,d=a.sibling;if(0===(a.effectTag&1024)){T=a;a:{var e=b;b=a;var f=U;var g=b.pendingProps;switch(b.tag){case 2:break;case 16:break;case 15:case 0:break;case 1:J(b.type)&&Ke(b);break;case 3:Kf(b);Le(b);g=b.stateNode;g.pendingContext&&(g.context=g.pendingContext,g.pendingContext=null);if(null===e||null===e.child)Eg(b),b.effectTag&=-3;mh(b);break;case 5:Mf(b);var h=If(Hf.current);f=b.type;if(null!==e&&null!=b.stateNode)nh(e,b,f,g,h),e.ref!==b.ref&&(b.effectTag|=
	128);else if(g){var l=If(N.current);if(Eg(b)){g=b;e=g.stateNode;var k=g.type,m=g.memoizedProps,p=h;e[Fa]=g;e[Ga]=m;f=void 0;h=k;switch(h){case "iframe":case "object":E("load",e);break;case "video":case "audio":for(k=0;k<ab.length;k++)E(ab[k],e);break;case "source":E("error",e);break;case "img":case "image":case "link":E("error",e);E("load",e);break;case "form":E("reset",e);E("submit",e);break;case "details":E("toggle",e);break;case "input":wc(e,m);E("invalid",e);se(p,"onChange");break;case "select":e._wrapperState=
	{wasMultiple:!!m.multiple};E("invalid",e);se(p,"onChange");break;case "textarea":ce(e,m),E("invalid",e),se(p,"onChange")}qe(h,m);k=null;for(f in m)m.hasOwnProperty(f)&&(l=m[f],"children"===f?"string"===typeof l?e.textContent!==l&&(k=["children",l]):"number"===typeof l&&e.textContent!==""+l&&(k=["children",""+l]):ra.hasOwnProperty(f)&&null!=l&&se(p,f));switch(h){case "input":Rb(e);Ac(e,m,!0);break;case "textarea":Rb(e);ee(e,m);break;case "select":case "option":break;default:"function"===typeof m.onClick&&
	(e.onclick=te)}f=k;g.updateQueue=f;g=null!==f?!0:!1;g&&kh(b)}else{m=b;p=f;e=g;k=9===h.nodeType?h:h.ownerDocument;l===fe.html&&(l=ge(p));l===fe.html?"script"===p?(e=k.createElement("div"),e.innerHTML="<script>\x3c/script>",k=e.removeChild(e.firstChild)):"string"===typeof e.is?k=k.createElement(p,{is:e.is}):(k=k.createElement(p),"select"===p&&(p=k,e.multiple?p.multiple=!0:e.size&&(p.size=e.size))):k=k.createElementNS(l,p);e=k;e[Fa]=m;e[Ga]=g;lh(e,b,!1,!1);p=e;k=f;m=g;var t=h,A=re(k,m);switch(k){case "iframe":case "object":E("load",
	p);h=m;break;case "video":case "audio":for(h=0;h<ab.length;h++)E(ab[h],p);h=m;break;case "source":E("error",p);h=m;break;case "img":case "image":case "link":E("error",p);E("load",p);h=m;break;case "form":E("reset",p);E("submit",p);h=m;break;case "details":E("toggle",p);h=m;break;case "input":wc(p,m);h=vc(p,m);E("invalid",p);se(t,"onChange");break;case "option":h=$d(p,m);break;case "select":p._wrapperState={wasMultiple:!!m.multiple};h=n({},m,{value:void 0});E("invalid",p);se(t,"onChange");break;case "textarea":ce(p,
	m);h=be(p,m);E("invalid",p);se(t,"onChange");break;default:h=m}qe(k,h);l=void 0;var v=k,R=p,u=h;for(l in u)if(u.hasOwnProperty(l)){var q=u[l];"style"===l?oe(R,q):"dangerouslySetInnerHTML"===l?(q=q?q.__html:void 0,null!=q&&je(R,q)):"children"===l?"string"===typeof q?("textarea"!==v||""!==q)&&ke(R,q):"number"===typeof q&&ke(R,""+q):"suppressContentEditableWarning"!==l&&"suppressHydrationWarning"!==l&&"autoFocus"!==l&&(ra.hasOwnProperty(l)?null!=q&&se(t,l):null!=q&&tc(R,l,q,A))}switch(k){case "input":Rb(p);
	Ac(p,m,!1);break;case "textarea":Rb(p);ee(p,m);break;case "option":null!=m.value&&p.setAttribute("value",""+uc(m.value));break;case "select":h=p;h.multiple=!!m.multiple;p=m.value;null!=p?ae(h,!!m.multiple,p,!1):null!=m.defaultValue&&ae(h,!!m.multiple,m.defaultValue,!0);break;default:"function"===typeof h.onClick&&(p.onclick=te)}(g=we(f,g))&&kh(b);b.stateNode=e}null!==b.ref&&(b.effectTag|=128)}else null===b.stateNode?x("166"):void 0;break;case 6:e&&null!=b.stateNode?oh(e,b,e.memoizedProps,g):("string"!==
	typeof g&&(null===b.stateNode?x("166"):void 0),e=If(Hf.current),If(N.current),Eg(b)?(g=b,f=g.stateNode,e=g.memoizedProps,f[Fa]=g,(g=f.nodeValue!==e)&&kh(b)):(f=b,g=(9===e.nodeType?e:e.ownerDocument).createTextNode(g),g[Fa]=b,f.stateNode=g));break;case 11:break;case 13:g=b.memoizedState;if(0!==(b.effectTag&64)){b.expirationTime=f;T=b;break a}g=null!==g;f=null!==e&&null!==e.memoizedState;null!==e&&!g&&f&&(e=e.child.sibling,null!==e&&(h=b.firstEffect,null!==h?(b.firstEffect=e,e.nextEffect=h):(b.firstEffect=
	b.lastEffect=e,e.nextEffect=null),e.effectTag=8));if(g||f)b.effectTag|=4;break;case 7:break;case 8:break;case 12:break;case 4:Kf(b);mh(b);break;case 10:Zg(b);break;case 9:break;case 14:break;case 17:J(b.type)&&Ke(b);break;case 18:break;default:x("156")}T=null}b=a;if(1===U||1!==b.childExpirationTime){g=0;for(f=b.child;null!==f;)e=f.expirationTime,h=f.childExpirationTime,e>g&&(g=e),h>g&&(g=h),f=f.sibling;b.childExpirationTime=g}if(null!==T)return T;null!==c&&0===(c.effectTag&1024)&&(null===c.firstEffect&&
	(c.firstEffect=a.firstEffect),null!==a.lastEffect&&(null!==c.lastEffect&&(c.lastEffect.nextEffect=a.firstEffect),c.lastEffect=a.lastEffect),1<a.effectTag&&(null!==c.lastEffect?c.lastEffect.nextEffect=a:c.firstEffect=a,c.lastEffect=a))}else{a=Gh(a,U);if(null!==a)return a.effectTag&=1023,a;null!==c&&(c.firstEffect=c.lastEffect=null,c.effectTag|=1024)}if(null!==d)return d;if(null!==c)a=c;else break}return null}
	function bi(a){var b=Tg(a.alternate,a,U);a.memoizedProps=a.pendingProps;null===b&&(b=ai(a));Ih.current=null;return b}
	function ci(a,b){Kh?x("243"):void 0;of();Kh=!0;var c=Hh.current;Hh.current=kg;var d=a.nextExpirationTimeToWorkOn;if(d!==U||a!==Lh||null===T)Sh(),Lh=a,U=d,T=Xe(Lh.current,null,U),a.pendingCommitExpirationTime=0;var e=!1;do{try{if(b)for(;null!==T&&!di();)T=bi(T);else for(;null!==T;)T=bi(T)}catch(u){if(Yg=Xg=Wg=null,lg(),null===T)e=!0,Dh(u);else{null===T?x("271"):void 0;var f=T,g=f.return;if(null===g)e=!0,Dh(u);else{a:{var h=a,l=g,k=f,m=u;g=U;k.effectTag|=1024;k.firstEffect=k.lastEffect=null;if(null!==
	m&&"object"===typeof m&&"function"===typeof m.then){var p=m;m=l;var t=-1,A=-1;do{if(13===m.tag){var v=m.alternate;if(null!==v&&(v=v.memoizedState,null!==v)){A=10*(1073741822-v.timedOutAt);break}v=m.pendingProps.maxDuration;if("number"===typeof v)if(0>=v)t=0;else if(-1===t||v<t)t=v}m=m.return}while(null!==m);m=l;do{if(v=13===m.tag)v=void 0===m.memoizedProps.fallback?!1:null===m.memoizedState;if(v){l=m.updateQueue;null===l?(l=new Set,l.add(p),m.updateQueue=l):l.add(p);if(0===(m.mode&1)){m.effectTag|=
	64;k.effectTag&=-1957;1===k.tag&&(null===k.alternate?k.tag=17:(g=nf(1073741823),g.tag=sf,pf(k,g)));k.expirationTime=1073741823;break a}k=h;l=g;var R=k.pingCache;null===R?(R=k.pingCache=new Bh,v=new Set,R.set(p,v)):(v=R.get(p),void 0===v&&(v=new Set,R.set(p,v)));v.has(l)||(v.add(l),k=ei.bind(null,k,p,l),p.then(k,k));-1===t?h=1073741823:(-1===A&&(A=10*(1073741822-gf(h,g))-5E3),h=A+t);0<=h&&Mh<h&&(Mh=h);m.effectTag|=2048;m.expirationTime=g;break a}m=m.return}while(null!==m);m=Error((ic(k.type)||"A React component")+
	" suspended while rendering, but no fallback UI was specified.\n\nAdd a <Suspense fallback=...> component higher in the tree to provide a loading indicator or placeholder to display."+jc(k))}Nh=!0;m=jh(m,k);h=l;do{switch(h.tag){case 3:h.effectTag|=2048;h.expirationTime=g;g=Ch(h,m,g);eh(h,g);break a;case 1:if(t=m,A=h.type,k=h.stateNode,0===(h.effectTag&64)&&("function"===typeof A.getDerivedStateFromError||null!==k&&"function"===typeof k.componentDidCatch&&(null===Fh||!Fh.has(k)))){h.effectTag|=2048;
	h.expirationTime=g;g=Eh(h,t,g);eh(h,g);break a}}h=h.return}while(null!==h)}T=ai(f);continue}}}break}while(1);Kh=!1;Hh.current=c;Yg=Xg=Wg=null;lg();if(e)Lh=null,a.finishedWork=null;else if(null!==T)a.finishedWork=null;else{c=a.current.alternate;null===c?x("281"):void 0;Lh=null;if(Nh){e=a.latestPendingTime;f=a.latestSuspendedTime;g=a.latestPingedTime;if(0!==e&&e<d||0!==f&&f<d||0!==g&&g<d){ff(a,d);fi(a,c,d,a.expirationTime,-1);return}if(!a.didError&&b){a.didError=!0;d=a.nextExpirationTimeToWorkOn=d;
	b=a.expirationTime=1073741823;fi(a,c,d,b,-1);return}}b&&-1!==Mh?(ff(a,d),b=10*(1073741822-gf(a,d)),b<Mh&&(Mh=b),b=10*(1073741822-lf()),b=Mh-b,fi(a,c,d,a.expirationTime,0>b?0:b)):(a.pendingCommitExpirationTime=d,a.finishedWork=c)}}
	function sh(a,b){for(var c=a.return;null!==c;){switch(c.tag){case 1:var d=c.stateNode;if("function"===typeof c.type.getDerivedStateFromError||"function"===typeof d.componentDidCatch&&(null===Fh||!Fh.has(d))){a=jh(b,a);a=Eh(c,a,1073741823);pf(c,a);qf(c,1073741823);return}break;case 3:a=jh(b,a);a=Ch(c,a,1073741823);pf(c,a);qf(c,1073741823);return}c=c.return}3===a.tag&&(c=jh(b,a),c=Ch(a,c,1073741823),pf(a,c),qf(a,1073741823))}
	function mf(a,b){var c=r.unstable_getCurrentPriorityLevel(),d=void 0;if(0===(b.mode&1))d=1073741823;else if(Kh&&!Oh)d=U;else{switch(c){case r.unstable_ImmediatePriority:d=1073741823;break;case r.unstable_UserBlockingPriority:d=1073741822-10*(((1073741822-a+15)/10|0)+1);break;case r.unstable_NormalPriority:d=1073741822-25*(((1073741822-a+500)/25|0)+1);break;case r.unstable_LowPriority:case r.unstable_IdlePriority:d=1;break;default:x("313")}null!==Lh&&d===U&&--d}c===r.unstable_UserBlockingPriority&&
	(0===gi||d<gi)&&(gi=d);return d}function ei(a,b,c){var d=a.pingCache;null!==d&&d.delete(b);if(null!==Lh&&U===c)Lh=null;else if(b=a.earliestSuspendedTime,d=a.latestSuspendedTime,0!==b&&c<=b&&c>=d){a.didError=!1;b=a.latestPingedTime;if(0===b||b>c)a.latestPingedTime=c;df(c,a);c=a.expirationTime;0!==c&&Xh(a,c)}}function Ah(a,b){var c=a.stateNode;null!==c&&c.delete(b);b=lf();b=mf(b,a);a=hi(a,b);null!==a&&(cf(a,b),b=a.expirationTime,0!==b&&Xh(a,b))}
	function hi(a,b){a.expirationTime<b&&(a.expirationTime=b);var c=a.alternate;null!==c&&c.expirationTime<b&&(c.expirationTime=b);var d=a.return,e=null;if(null===d&&3===a.tag)e=a.stateNode;else for(;null!==d;){c=d.alternate;d.childExpirationTime<b&&(d.childExpirationTime=b);null!==c&&c.childExpirationTime<b&&(c.childExpirationTime=b);if(null===d.return&&3===d.tag){e=d.stateNode;break}d=d.return}return e}
	function qf(a,b){a=hi(a,b);null!==a&&(!Kh&&0!==U&&b>U&&Sh(),cf(a,b),Kh&&!Oh&&Lh===a||Xh(a,a.expirationTime),ii>ji&&(ii=0,x("185")))}function ki(a,b,c,d,e){return r.unstable_runWithPriority(r.unstable_ImmediatePriority,function(){return a(b,c,d,e)})}var li=null,Y=null,mi=0,ni=void 0,W=!1,oi=null,Z=0,gi=0,pi=!1,qi=null,X=!1,ri=!1,si=null,ti=r.unstable_now(),ui=1073741822-(ti/10|0),vi=ui,ji=50,ii=0,wi=null;function xi(){ui=1073741822-((r.unstable_now()-ti)/10|0)}
	function yi(a,b){if(0!==mi){if(b<mi)return;null!==ni&&r.unstable_cancelCallback(ni)}mi=b;a=r.unstable_now()-ti;ni=r.unstable_scheduleCallback(zi,{timeout:10*(1073741822-b)-a})}function fi(a,b,c,d,e){a.expirationTime=d;0!==e||di()?0<e&&(a.timeoutHandle=ye(Ai.bind(null,a,b,c),e)):(a.pendingCommitExpirationTime=c,a.finishedWork=b)}function Ai(a,b,c){a.pendingCommitExpirationTime=c;a.finishedWork=b;xi();vi=ui;Bi(a,c)}function $h(a,b){a.expirationTime=b;a.finishedWork=null}
	function lf(){if(W)return vi;Ci();if(0===Z||1===Z)xi(),vi=ui;return vi}function Xh(a,b){null===a.nextScheduledRoot?(a.expirationTime=b,null===Y?(li=Y=a,a.nextScheduledRoot=a):(Y=Y.nextScheduledRoot=a,Y.nextScheduledRoot=li)):b>a.expirationTime&&(a.expirationTime=b);W||(X?ri&&(oi=a,Z=1073741823,Di(a,1073741823,!1)):1073741823===b?Yh(1073741823,!1):yi(a,b))}
	function Ci(){var a=0,b=null;if(null!==Y)for(var c=Y,d=li;null!==d;){var e=d.expirationTime;if(0===e){null===c||null===Y?x("244"):void 0;if(d===d.nextScheduledRoot){li=Y=d.nextScheduledRoot=null;break}else if(d===li)li=e=d.nextScheduledRoot,Y.nextScheduledRoot=e,d.nextScheduledRoot=null;else if(d===Y){Y=c;Y.nextScheduledRoot=li;d.nextScheduledRoot=null;break}else c.nextScheduledRoot=d.nextScheduledRoot,d.nextScheduledRoot=null;d=c.nextScheduledRoot}else{e>a&&(a=e,b=d);if(d===Y)break;if(1073741823===
	a)break;c=d;d=d.nextScheduledRoot}}oi=b;Z=a}var Ei=!1;function di(){return Ei?!0:r.unstable_shouldYield()?Ei=!0:!1}function zi(){try{if(!di()&&null!==li){xi();var a=li;do{var b=a.expirationTime;0!==b&&ui<=b&&(a.nextExpirationTimeToWorkOn=ui);a=a.nextScheduledRoot}while(a!==li)}Yh(0,!0)}finally{Ei=!1}}
	function Yh(a,b){Ci();if(b)for(xi(),vi=ui;null!==oi&&0!==Z&&a<=Z&&!(Ei&&ui>Z);)Di(oi,Z,ui>Z),Ci(),xi(),vi=ui;else for(;null!==oi&&0!==Z&&a<=Z;)Di(oi,Z,!1),Ci();b&&(mi=0,ni=null);0!==Z&&yi(oi,Z);ii=0;wi=null;if(null!==si)for(a=si,si=null,b=0;b<a.length;b++){var c=a[b];try{c._onComplete()}catch(d){pi||(pi=!0,qi=d)}}if(pi)throw a=qi,qi=null,pi=!1,a;}function Bi(a,b){W?x("253"):void 0;oi=a;Z=b;Di(a,b,!1);Yh(1073741823,!1)}
	function Di(a,b,c){W?x("245"):void 0;W=!0;if(c){var d=a.finishedWork;null!==d?Fi(a,d,b):(a.finishedWork=null,d=a.timeoutHandle,-1!==d&&(a.timeoutHandle=-1,ze(d)),ci(a,c),d=a.finishedWork,null!==d&&(di()?a.finishedWork=d:Fi(a,d,b)))}else d=a.finishedWork,null!==d?Fi(a,d,b):(a.finishedWork=null,d=a.timeoutHandle,-1!==d&&(a.timeoutHandle=-1,ze(d)),ci(a,c),d=a.finishedWork,null!==d&&Fi(a,d,b));W=!1}
	function Fi(a,b,c){var d=a.firstBatch;if(null!==d&&d._expirationTime>=c&&(null===si?si=[d]:si.push(d),d._defer)){a.finishedWork=b;a.expirationTime=0;return}a.finishedWork=null;a===wi?ii++:(wi=a,ii=0);r.unstable_runWithPriority(r.unstable_ImmediatePriority,function(){Zh(a,b)})}function Dh(a){null===oi?x("246"):void 0;oi.expirationTime=0;pi||(pi=!0,qi=a)}function Gi(a,b){var c=X;X=!0;try{return a(b)}finally{(X=c)||W||Yh(1073741823,!1)}}
	function Hi(a,b){if(X&&!ri){ri=!0;try{return a(b)}finally{ri=!1}}return a(b)}function Ii(a,b,c){X||W||0===gi||(Yh(gi,!1),gi=0);var d=X;X=!0;try{return r.unstable_runWithPriority(r.unstable_UserBlockingPriority,function(){return a(b,c)})}finally{(X=d)||W||Yh(1073741823,!1)}}
	function Ji(a,b,c,d,e){var f=b.current;a:if(c){c=c._reactInternalFiber;b:{2===ed(c)&&1===c.tag?void 0:x("170");var g=c;do{switch(g.tag){case 3:g=g.stateNode.context;break b;case 1:if(J(g.type)){g=g.stateNode.__reactInternalMemoizedMergedChildContext;break b}}g=g.return}while(null!==g);x("171");g=void 0}if(1===c.tag){var h=c.type;if(J(h)){c=Ne(c,h,g);break a}}c=g}else c=He;null===b.context?b.context=c:b.pendingContext=c;b=e;e=nf(d);e.payload={element:a};b=void 0===b?null:b;null!==b&&(e.callback=b);
	of();pf(f,e);qf(f,d);return d}function Ki(a,b,c,d){var e=b.current,f=lf();e=mf(f,e);return Ji(a,b,c,e,d)}function Li(a){a=a.current;if(!a.child)return null;switch(a.child.tag){case 5:return a.child.stateNode;default:return a.child.stateNode}}function Mi(a,b,c){var d=3<arguments.length&&void 0!==arguments[3]?arguments[3]:null;return{$$typeof:Wb,key:null==d?null:""+d,children:a,containerInfo:b,implementation:c}}
	Ab=function(a,b,c){switch(b){case "input":yc(a,c);b=c.name;if("radio"===c.type&&null!=b){for(c=a;c.parentNode;)c=c.parentNode;c=c.querySelectorAll("input[name="+JSON.stringify(""+b)+'][type="radio"]');for(b=0;b<c.length;b++){var d=c[b];if(d!==a&&d.form===a.form){var e=Ka(d);e?void 0:x("90");Sb(d);yc(d,e)}}}break;case "textarea":de(a,c);break;case "select":b=c.value,null!=b&&ae(a,!!c.multiple,b,!1)}};
	function Ni(a){var b=1073741822-25*(((1073741822-lf()+500)/25|0)+1);b>=Jh&&(b=Jh-1);this._expirationTime=Jh=b;this._root=a;this._callbacks=this._next=null;this._hasChildren=this._didComplete=!1;this._children=null;this._defer=!0}Ni.prototype.render=function(a){this._defer?void 0:x("250");this._hasChildren=!0;this._children=a;var b=this._root._internalRoot,c=this._expirationTime,d=new Oi;Ji(a,b,null,c,d._onCommit);return d};
	Ni.prototype.then=function(a){if(this._didComplete)a();else{var b=this._callbacks;null===b&&(b=this._callbacks=[]);b.push(a)}};
	Ni.prototype.commit=function(){var a=this._root._internalRoot,b=a.firstBatch;this._defer&&null!==b?void 0:x("251");if(this._hasChildren){var c=this._expirationTime;if(b!==this){this._hasChildren&&(c=this._expirationTime=b._expirationTime,this.render(this._children));for(var d=null,e=b;e!==this;)d=e,e=e._next;null===d?x("251"):void 0;d._next=e._next;this._next=b;a.firstBatch=this}this._defer=!1;Bi(a,c);b=this._next;this._next=null;b=a.firstBatch=b;null!==b&&b._hasChildren&&b.render(b._children)}else this._next=
	null,this._defer=!1};Ni.prototype._onComplete=function(){if(!this._didComplete){this._didComplete=!0;var a=this._callbacks;if(null!==a)for(var b=0;b<a.length;b++)(0,a[b])()}};function Oi(){this._callbacks=null;this._didCommit=!1;this._onCommit=this._onCommit.bind(this)}Oi.prototype.then=function(a){if(this._didCommit)a();else{var b=this._callbacks;null===b&&(b=this._callbacks=[]);b.push(a)}};
	Oi.prototype._onCommit=function(){if(!this._didCommit){this._didCommit=!0;var a=this._callbacks;if(null!==a)for(var b=0;b<a.length;b++){var c=a[b];"function"!==typeof c?x("191",c):void 0;c()}}};
	function Pi(a,b,c){b=K(3,null,null,b?3:0);a={current:b,containerInfo:a,pendingChildren:null,pingCache:null,earliestPendingTime:0,latestPendingTime:0,earliestSuspendedTime:0,latestSuspendedTime:0,latestPingedTime:0,didError:!1,pendingCommitExpirationTime:0,finishedWork:null,timeoutHandle:-1,context:null,pendingContext:null,hydrate:c,nextExpirationTimeToWorkOn:0,expirationTime:0,firstBatch:null,nextScheduledRoot:null};this._internalRoot=b.stateNode=a}
	Pi.prototype.render=function(a,b){var c=this._internalRoot,d=new Oi;b=void 0===b?null:b;null!==b&&d.then(b);Ki(a,c,null,d._onCommit);return d};Pi.prototype.unmount=function(a){var b=this._internalRoot,c=new Oi;a=void 0===a?null:a;null!==a&&c.then(a);Ki(null,b,null,c._onCommit);return c};Pi.prototype.legacy_renderSubtreeIntoContainer=function(a,b,c){var d=this._internalRoot,e=new Oi;c=void 0===c?null:c;null!==c&&e.then(c);Ki(b,d,a,e._onCommit);return e};
	Pi.prototype.createBatch=function(){var a=new Ni(this),b=a._expirationTime,c=this._internalRoot,d=c.firstBatch;if(null===d)c.firstBatch=a,a._next=null;else{for(c=null;null!==d&&d._expirationTime>=b;)c=d,d=d._next;a._next=d;null!==c&&(c._next=a)}return a};function Qi(a){return!(!a||1!==a.nodeType&&9!==a.nodeType&&11!==a.nodeType&&(8!==a.nodeType||" react-mount-point-unstable "!==a.nodeValue))}Gb=Gi;Hb=Ii;Ib=function(){W||0===gi||(Yh(gi,!1),gi=0)};
	function Ri(a,b){b||(b=a?9===a.nodeType?a.documentElement:a.firstChild:null,b=!(!b||1!==b.nodeType||!b.hasAttribute("data-reactroot")));if(!b)for(var c;c=a.lastChild;)a.removeChild(c);return new Pi(a,!1,b)}
	function Si(a,b,c,d,e){var f=c._reactRootContainer;if(f){if("function"===typeof e){var g=e;e=function(){var a=Li(f._internalRoot);g.call(a)}}null!=a?f.legacy_renderSubtreeIntoContainer(a,b,e):f.render(b,e)}else{f=c._reactRootContainer=Ri(c,d);if("function"===typeof e){var h=e;e=function(){var a=Li(f._internalRoot);h.call(a)}}Hi(function(){null!=a?f.legacy_renderSubtreeIntoContainer(a,b,e):f.render(b,e)})}return Li(f._internalRoot)}
	function Ti(a,b){var c=2<arguments.length&&void 0!==arguments[2]?arguments[2]:null;Qi(b)?void 0:x("200");return Mi(a,b,null,c)}
	var Vi={createPortal:Ti,findDOMNode:function(a){if(null==a)return null;if(1===a.nodeType)return a;var b=a._reactInternalFiber;void 0===b&&("function"===typeof a.render?x("188"):x("268",Object.keys(a)));a=hd(b);a=null===a?null:a.stateNode;return a},hydrate:function(a,b,c){Qi(b)?void 0:x("200");return Si(null,a,b,!0,c)},render:function(a,b,c){Qi(b)?void 0:x("200");return Si(null,a,b,!1,c)},unstable_renderSubtreeIntoContainer:function(a,b,c,d){Qi(c)?void 0:x("200");null==a||void 0===a._reactInternalFiber?
	x("38"):void 0;return Si(a,b,c,!1,d)},unmountComponentAtNode:function(a){Qi(a)?void 0:x("40");return a._reactRootContainer?(Hi(function(){Si(null,null,a,!1,function(){a._reactRootContainer=null})}),!0):!1},unstable_createPortal:function(){return Ti.apply(void 0,arguments)},unstable_batchedUpdates:Gi,unstable_interactiveUpdates:Ii,flushSync:function(a,b){W?x("187"):void 0;var c=X;X=!0;try{return ki(a,b)}finally{X=c,Yh(1073741823,!1)}},unstable_createRoot:Ui,unstable_flushControlled:function(a){var b=
	X;X=!0;try{ki(a)}finally{(X=b)||W||Yh(1073741823,!1)}},__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED:{Events:[Ia,Ja,Ka,Ba.injectEventPluginsByName,pa,Qa,function(a){ya(a,Pa)},Eb,Fb,Dd,Da]}};function Ui(a,b){Qi(a)?void 0:x("299","unstable_createRoot");return new Pi(a,!0,null!=b&&!0===b.hydrate)}
	(function(a){var b=a.findFiberByHostInstance;return Te(n({},a,{overrideProps:null,currentDispatcherRef:Tb.ReactCurrentDispatcher,findHostInstanceByFiber:function(a){a=hd(a);return null===a?null:a.stateNode},findFiberByHostInstance:function(a){return b?b(a):null}}))})({findFiberByHostInstance:Ha,bundleType:0,version:"16.8.6",rendererPackageName:"react-dom"});var Wi={default:Vi},Xi=Wi&&Vi||Wi;module.exports=Xi.default||Xi;


/***/ },
/* 1293 */
/***/ function(module, exports) {

	'use strict';
	
	var isArray = Array.isArray;
	var keyList = Object.keys;
	var hasProp = Object.prototype.hasOwnProperty;
	var hasElementType = typeof Element !== 'undefined';
	
	function equal(a, b) {
	  // fast-deep-equal index.js 2.0.1
	  if (a === b) return true;
	
	  if (a && b && typeof a == 'object' && typeof b == 'object') {
	    var arrA = isArray(a)
	      , arrB = isArray(b)
	      , i
	      , length
	      , key;
	
	    if (arrA && arrB) {
	      length = a.length;
	      if (length != b.length) return false;
	      for (i = length; i-- !== 0;)
	        if (!equal(a[i], b[i])) return false;
	      return true;
	    }
	
	    if (arrA != arrB) return false;
	
	    var dateA = a instanceof Date
	      , dateB = b instanceof Date;
	    if (dateA != dateB) return false;
	    if (dateA && dateB) return a.getTime() == b.getTime();
	
	    var regexpA = a instanceof RegExp
	      , regexpB = b instanceof RegExp;
	    if (regexpA != regexpB) return false;
	    if (regexpA && regexpB) return a.toString() == b.toString();
	
	    var keys = keyList(a);
	    length = keys.length;
	
	    if (length !== keyList(b).length)
	      return false;
	
	    for (i = length; i-- !== 0;)
	      if (!hasProp.call(b, keys[i])) return false;
	    // end fast-deep-equal
	
	    // start react-fast-compare
	    // custom handling for DOM elements
	    if (hasElementType && a instanceof Element && b instanceof Element)
	      return a === b;
	
	    // custom handling for React
	    for (i = length; i-- !== 0;) {
	      key = keys[i];
	      if (key === '_owner' && a.$$typeof) {
	        // React-specific: avoid traversing React elements' _owner.
	        //  _owner contains circular references
	        // and is not needed when comparing the actual elements (and not their owners)
	        // .$$typeof and ._store on just reasonable markers of a react element
	        continue;
	      } else {
	        // all other properties should be traversed as usual
	        if (!equal(a[key], b[key])) return false;
	      }
	    }
	    // end react-fast-compare
	
	    // fast-deep-equal index.js 2.0.1
	    return true;
	  }
	
	  return a !== a && b !== b;
	}
	// end fast-deep-equal
	
	module.exports = function exportedEqual(a, b) {
	  try {
	    return equal(a, b);
	  } catch (error) {
	    if ((error.message && error.message.match(/stack|recursion/i)) || (error.number === -2146828260)) {
	      // warn on circular references, don't crash
	      // browsers give this different errors name and messages:
	      // chrome/safari: "RangeError", "Maximum call stack size exceeded"
	      // firefox: "InternalError", too much recursion"
	      // edge: "Error", "Out of stack space"
	      console.warn('Warning: react-fast-compare does not handle circular references.', error.name, error.message);
	      return false;
	    }
	    // some other error. we should definitely know about these
	    throw error;
	  }
	};


/***/ },
/* 1294 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {exports.__esModule = true;
	exports.warn = exports.requestAnimationFrame = exports.reducePropsToState = exports.mapStateOnServer = exports.handleClientStateChange = exports.convertReactPropstoHtmlAttributes = undefined;
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _objectAssign = __webpack_require__(207);
	
	var _objectAssign2 = _interopRequireDefault(_objectAssign);
	
	var _HelmetConstants = __webpack_require__(508);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var encodeSpecialCharacters = function encodeSpecialCharacters(str) {
	    var encode = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
	
	    if (encode === false) {
	        return String(str);
	    }
	
	    return String(str).replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;").replace(/'/g, "&#x27;");
	};
	
	var getTitleFromPropsList = function getTitleFromPropsList(propsList) {
	    var innermostTitle = getInnermostProperty(propsList, _HelmetConstants.TAG_NAMES.TITLE);
	    var innermostTemplate = getInnermostProperty(propsList, _HelmetConstants.HELMET_PROPS.TITLE_TEMPLATE);
	
	    if (innermostTemplate && innermostTitle) {
	        // use function arg to avoid need to escape $ characters
	        return innermostTemplate.replace(/%s/g, function () {
	            return innermostTitle;
	        });
	    }
	
	    var innermostDefaultTitle = getInnermostProperty(propsList, _HelmetConstants.HELMET_PROPS.DEFAULT_TITLE);
	
	    return innermostTitle || innermostDefaultTitle || undefined;
	};
	
	var getOnChangeClientState = function getOnChangeClientState(propsList) {
	    return getInnermostProperty(propsList, _HelmetConstants.HELMET_PROPS.ON_CHANGE_CLIENT_STATE) || function () {};
	};
	
	var getAttributesFromPropsList = function getAttributesFromPropsList(tagType, propsList) {
	    return propsList.filter(function (props) {
	        return typeof props[tagType] !== "undefined";
	    }).map(function (props) {
	        return props[tagType];
	    }).reduce(function (tagAttrs, current) {
	        return _extends({}, tagAttrs, current);
	    }, {});
	};
	
	var getBaseTagFromPropsList = function getBaseTagFromPropsList(primaryAttributes, propsList) {
	    return propsList.filter(function (props) {
	        return typeof props[_HelmetConstants.TAG_NAMES.BASE] !== "undefined";
	    }).map(function (props) {
	        return props[_HelmetConstants.TAG_NAMES.BASE];
	    }).reverse().reduce(function (innermostBaseTag, tag) {
	        if (!innermostBaseTag.length) {
	            var keys = Object.keys(tag);
	
	            for (var i = 0; i < keys.length; i++) {
	                var attributeKey = keys[i];
	                var lowerCaseAttributeKey = attributeKey.toLowerCase();
	
	                if (primaryAttributes.indexOf(lowerCaseAttributeKey) !== -1 && tag[lowerCaseAttributeKey]) {
	                    return innermostBaseTag.concat(tag);
	                }
	            }
	        }
	
	        return innermostBaseTag;
	    }, []);
	};
	
	var getTagsFromPropsList = function getTagsFromPropsList(tagName, primaryAttributes, propsList) {
	    // Calculate list of tags, giving priority innermost component (end of the propslist)
	    var approvedSeenTags = {};
	
	    return propsList.filter(function (props) {
	        if (Array.isArray(props[tagName])) {
	            return true;
	        }
	        if (typeof props[tagName] !== "undefined") {
	            warn("Helmet: " + tagName + " should be of type \"Array\". Instead found type \"" + _typeof(props[tagName]) + "\"");
	        }
	        return false;
	    }).map(function (props) {
	        return props[tagName];
	    }).reverse().reduce(function (approvedTags, instanceTags) {
	        var instanceSeenTags = {};
	
	        instanceTags.filter(function (tag) {
	            var primaryAttributeKey = void 0;
	            var keys = Object.keys(tag);
	            for (var i = 0; i < keys.length; i++) {
	                var attributeKey = keys[i];
	                var lowerCaseAttributeKey = attributeKey.toLowerCase();
	
	                // Special rule with link tags, since rel and href are both primary tags, rel takes priority
	                if (primaryAttributes.indexOf(lowerCaseAttributeKey) !== -1 && !(primaryAttributeKey === _HelmetConstants.TAG_PROPERTIES.REL && tag[primaryAttributeKey].toLowerCase() === "canonical") && !(lowerCaseAttributeKey === _HelmetConstants.TAG_PROPERTIES.REL && tag[lowerCaseAttributeKey].toLowerCase() === "stylesheet")) {
	                    primaryAttributeKey = lowerCaseAttributeKey;
	                }
	                // Special case for innerHTML which doesn't work lowercased
	                if (primaryAttributes.indexOf(attributeKey) !== -1 && (attributeKey === _HelmetConstants.TAG_PROPERTIES.INNER_HTML || attributeKey === _HelmetConstants.TAG_PROPERTIES.CSS_TEXT || attributeKey === _HelmetConstants.TAG_PROPERTIES.ITEM_PROP)) {
	                    primaryAttributeKey = attributeKey;
	                }
	            }
	
	            if (!primaryAttributeKey || !tag[primaryAttributeKey]) {
	                return false;
	            }
	
	            var value = tag[primaryAttributeKey].toLowerCase();
	
	            if (!approvedSeenTags[primaryAttributeKey]) {
	                approvedSeenTags[primaryAttributeKey] = {};
	            }
	
	            if (!instanceSeenTags[primaryAttributeKey]) {
	                instanceSeenTags[primaryAttributeKey] = {};
	            }
	
	            if (!approvedSeenTags[primaryAttributeKey][value]) {
	                instanceSeenTags[primaryAttributeKey][value] = true;
	                return true;
	            }
	
	            return false;
	        }).reverse().forEach(function (tag) {
	            return approvedTags.push(tag);
	        });
	
	        // Update seen tags with tags from this instance
	        var keys = Object.keys(instanceSeenTags);
	        for (var i = 0; i < keys.length; i++) {
	            var attributeKey = keys[i];
	            var tagUnion = (0, _objectAssign2.default)({}, approvedSeenTags[attributeKey], instanceSeenTags[attributeKey]);
	
	            approvedSeenTags[attributeKey] = tagUnion;
	        }
	
	        return approvedTags;
	    }, []).reverse();
	};
	
	var getInnermostProperty = function getInnermostProperty(propsList, property) {
	    for (var i = propsList.length - 1; i >= 0; i--) {
	        var props = propsList[i];
	
	        if (props.hasOwnProperty(property)) {
	            return props[property];
	        }
	    }
	
	    return null;
	};
	
	var reducePropsToState = function reducePropsToState(propsList) {
	    return {
	        baseTag: getBaseTagFromPropsList([_HelmetConstants.TAG_PROPERTIES.HREF], propsList),
	        bodyAttributes: getAttributesFromPropsList(_HelmetConstants.ATTRIBUTE_NAMES.BODY, propsList),
	        defer: getInnermostProperty(propsList, _HelmetConstants.HELMET_PROPS.DEFER),
	        encode: getInnermostProperty(propsList, _HelmetConstants.HELMET_PROPS.ENCODE_SPECIAL_CHARACTERS),
	        htmlAttributes: getAttributesFromPropsList(_HelmetConstants.ATTRIBUTE_NAMES.HTML, propsList),
	        linkTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.LINK, [_HelmetConstants.TAG_PROPERTIES.REL, _HelmetConstants.TAG_PROPERTIES.HREF], propsList),
	        metaTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.META, [_HelmetConstants.TAG_PROPERTIES.NAME, _HelmetConstants.TAG_PROPERTIES.CHARSET, _HelmetConstants.TAG_PROPERTIES.HTTPEQUIV, _HelmetConstants.TAG_PROPERTIES.PROPERTY, _HelmetConstants.TAG_PROPERTIES.ITEM_PROP], propsList),
	        noscriptTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.NOSCRIPT, [_HelmetConstants.TAG_PROPERTIES.INNER_HTML], propsList),
	        onChangeClientState: getOnChangeClientState(propsList),
	        scriptTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.SCRIPT, [_HelmetConstants.TAG_PROPERTIES.SRC, _HelmetConstants.TAG_PROPERTIES.INNER_HTML], propsList),
	        styleTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.STYLE, [_HelmetConstants.TAG_PROPERTIES.CSS_TEXT], propsList),
	        title: getTitleFromPropsList(propsList),
	        titleAttributes: getAttributesFromPropsList(_HelmetConstants.ATTRIBUTE_NAMES.TITLE, propsList)
	    };
	};
	
	var rafPolyfill = function () {
	    var clock = Date.now();
	
	    return function (callback) {
	        var currentTime = Date.now();
	
	        if (currentTime - clock > 16) {
	            clock = currentTime;
	            callback(currentTime);
	        } else {
	            setTimeout(function () {
	                rafPolyfill(callback);
	            }, 0);
	        }
	    };
	}();
	
	var cafPolyfill = function cafPolyfill(id) {
	    return clearTimeout(id);
	};
	
	var requestAnimationFrame = typeof window !== "undefined" ? window.requestAnimationFrame || window.webkitRequestAnimationFrame || window.mozRequestAnimationFrame || rafPolyfill : global.requestAnimationFrame || rafPolyfill;
	
	var cancelAnimationFrame = typeof window !== "undefined" ? window.cancelAnimationFrame || window.webkitCancelAnimationFrame || window.mozCancelAnimationFrame || cafPolyfill : global.cancelAnimationFrame || cafPolyfill;
	
	var warn = function warn(msg) {
	    return console && typeof console.warn === "function" && console.warn(msg);
	};
	
	var _helmetCallback = null;
	
	var handleClientStateChange = function handleClientStateChange(newState) {
	    if (_helmetCallback) {
	        cancelAnimationFrame(_helmetCallback);
	    }
	
	    if (newState.defer) {
	        _helmetCallback = requestAnimationFrame(function () {
	            commitTagChanges(newState, function () {
	                _helmetCallback = null;
	            });
	        });
	    } else {
	        commitTagChanges(newState);
	        _helmetCallback = null;
	    }
	};
	
	var commitTagChanges = function commitTagChanges(newState, cb) {
	    var baseTag = newState.baseTag,
	        bodyAttributes = newState.bodyAttributes,
	        htmlAttributes = newState.htmlAttributes,
	        linkTags = newState.linkTags,
	        metaTags = newState.metaTags,
	        noscriptTags = newState.noscriptTags,
	        onChangeClientState = newState.onChangeClientState,
	        scriptTags = newState.scriptTags,
	        styleTags = newState.styleTags,
	        title = newState.title,
	        titleAttributes = newState.titleAttributes;
	
	    updateAttributes(_HelmetConstants.TAG_NAMES.BODY, bodyAttributes);
	    updateAttributes(_HelmetConstants.TAG_NAMES.HTML, htmlAttributes);
	
	    updateTitle(title, titleAttributes);
	
	    var tagUpdates = {
	        baseTag: updateTags(_HelmetConstants.TAG_NAMES.BASE, baseTag),
	        linkTags: updateTags(_HelmetConstants.TAG_NAMES.LINK, linkTags),
	        metaTags: updateTags(_HelmetConstants.TAG_NAMES.META, metaTags),
	        noscriptTags: updateTags(_HelmetConstants.TAG_NAMES.NOSCRIPT, noscriptTags),
	        scriptTags: updateTags(_HelmetConstants.TAG_NAMES.SCRIPT, scriptTags),
	        styleTags: updateTags(_HelmetConstants.TAG_NAMES.STYLE, styleTags)
	    };
	
	    var addedTags = {};
	    var removedTags = {};
	
	    Object.keys(tagUpdates).forEach(function (tagType) {
	        var _tagUpdates$tagType = tagUpdates[tagType],
	            newTags = _tagUpdates$tagType.newTags,
	            oldTags = _tagUpdates$tagType.oldTags;
	
	
	        if (newTags.length) {
	            addedTags[tagType] = newTags;
	        }
	        if (oldTags.length) {
	            removedTags[tagType] = tagUpdates[tagType].oldTags;
	        }
	    });
	
	    cb && cb();
	
	    onChangeClientState(newState, addedTags, removedTags);
	};
	
	var flattenArray = function flattenArray(possibleArray) {
	    return Array.isArray(possibleArray) ? possibleArray.join("") : possibleArray;
	};
	
	var updateTitle = function updateTitle(title, attributes) {
	    if (typeof title !== "undefined" && document.title !== title) {
	        document.title = flattenArray(title);
	    }
	
	    updateAttributes(_HelmetConstants.TAG_NAMES.TITLE, attributes);
	};
	
	var updateAttributes = function updateAttributes(tagName, attributes) {
	    var elementTag = document.getElementsByTagName(tagName)[0];
	
	    if (!elementTag) {
	        return;
	    }
	
	    var helmetAttributeString = elementTag.getAttribute(_HelmetConstants.HELMET_ATTRIBUTE);
	    var helmetAttributes = helmetAttributeString ? helmetAttributeString.split(",") : [];
	    var attributesToRemove = [].concat(helmetAttributes);
	    var attributeKeys = Object.keys(attributes);
	
	    for (var i = 0; i < attributeKeys.length; i++) {
	        var attribute = attributeKeys[i];
	        var value = attributes[attribute] || "";
	
	        if (elementTag.getAttribute(attribute) !== value) {
	            elementTag.setAttribute(attribute, value);
	        }
	
	        if (helmetAttributes.indexOf(attribute) === -1) {
	            helmetAttributes.push(attribute);
	        }
	
	        var indexToSave = attributesToRemove.indexOf(attribute);
	        if (indexToSave !== -1) {
	            attributesToRemove.splice(indexToSave, 1);
	        }
	    }
	
	    for (var _i = attributesToRemove.length - 1; _i >= 0; _i--) {
	        elementTag.removeAttribute(attributesToRemove[_i]);
	    }
	
	    if (helmetAttributes.length === attributesToRemove.length) {
	        elementTag.removeAttribute(_HelmetConstants.HELMET_ATTRIBUTE);
	    } else if (elementTag.getAttribute(_HelmetConstants.HELMET_ATTRIBUTE) !== attributeKeys.join(",")) {
	        elementTag.setAttribute(_HelmetConstants.HELMET_ATTRIBUTE, attributeKeys.join(","));
	    }
	};
	
	var updateTags = function updateTags(type, tags) {
	    var headElement = document.head || document.querySelector(_HelmetConstants.TAG_NAMES.HEAD);
	    var tagNodes = headElement.querySelectorAll(type + "[" + _HelmetConstants.HELMET_ATTRIBUTE + "]");
	    var oldTags = Array.prototype.slice.call(tagNodes);
	    var newTags = [];
	    var indexToDelete = void 0;
	
	    if (tags && tags.length) {
	        tags.forEach(function (tag) {
	            var newElement = document.createElement(type);
	
	            for (var attribute in tag) {
	                if (tag.hasOwnProperty(attribute)) {
	                    if (attribute === _HelmetConstants.TAG_PROPERTIES.INNER_HTML) {
	                        newElement.innerHTML = tag.innerHTML;
	                    } else if (attribute === _HelmetConstants.TAG_PROPERTIES.CSS_TEXT) {
	                        if (newElement.styleSheet) {
	                            newElement.styleSheet.cssText = tag.cssText;
	                        } else {
	                            newElement.appendChild(document.createTextNode(tag.cssText));
	                        }
	                    } else {
	                        var value = typeof tag[attribute] === "undefined" ? "" : tag[attribute];
	                        newElement.setAttribute(attribute, value);
	                    }
	                }
	            }
	
	            newElement.setAttribute(_HelmetConstants.HELMET_ATTRIBUTE, "true");
	
	            // Remove a duplicate tag from domTagstoRemove, so it isn't cleared.
	            if (oldTags.some(function (existingTag, index) {
	                indexToDelete = index;
	                return newElement.isEqualNode(existingTag);
	            })) {
	                oldTags.splice(indexToDelete, 1);
	            } else {
	                newTags.push(newElement);
	            }
	        });
	    }
	
	    oldTags.forEach(function (tag) {
	        return tag.parentNode.removeChild(tag);
	    });
	    newTags.forEach(function (tag) {
	        return headElement.appendChild(tag);
	    });
	
	    return {
	        oldTags: oldTags,
	        newTags: newTags
	    };
	};
	
	var generateElementAttributesAsString = function generateElementAttributesAsString(attributes) {
	    return Object.keys(attributes).reduce(function (str, key) {
	        var attr = typeof attributes[key] !== "undefined" ? key + "=\"" + attributes[key] + "\"" : "" + key;
	        return str ? str + " " + attr : attr;
	    }, "");
	};
	
	var generateTitleAsString = function generateTitleAsString(type, title, attributes, encode) {
	    var attributeString = generateElementAttributesAsString(attributes);
	    var flattenedTitle = flattenArray(title);
	    return attributeString ? "<" + type + " " + _HelmetConstants.HELMET_ATTRIBUTE + "=\"true\" " + attributeString + ">" + encodeSpecialCharacters(flattenedTitle, encode) + "</" + type + ">" : "<" + type + " " + _HelmetConstants.HELMET_ATTRIBUTE + "=\"true\">" + encodeSpecialCharacters(flattenedTitle, encode) + "</" + type + ">";
	};
	
	var generateTagsAsString = function generateTagsAsString(type, tags, encode) {
	    return tags.reduce(function (str, tag) {
	        var attributeHtml = Object.keys(tag).filter(function (attribute) {
	            return !(attribute === _HelmetConstants.TAG_PROPERTIES.INNER_HTML || attribute === _HelmetConstants.TAG_PROPERTIES.CSS_TEXT);
	        }).reduce(function (string, attribute) {
	            var attr = typeof tag[attribute] === "undefined" ? attribute : attribute + "=\"" + encodeSpecialCharacters(tag[attribute], encode) + "\"";
	            return string ? string + " " + attr : attr;
	        }, "");
	
	        var tagContent = tag.innerHTML || tag.cssText || "";
	
	        var isSelfClosing = _HelmetConstants.SELF_CLOSING_TAGS.indexOf(type) === -1;
	
	        return str + "<" + type + " " + _HelmetConstants.HELMET_ATTRIBUTE + "=\"true\" " + attributeHtml + (isSelfClosing ? "/>" : ">" + tagContent + "</" + type + ">");
	    }, "");
	};
	
	var convertElementAttributestoReactProps = function convertElementAttributestoReactProps(attributes) {
	    var initProps = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	    return Object.keys(attributes).reduce(function (obj, key) {
	        obj[_HelmetConstants.REACT_TAG_MAP[key] || key] = attributes[key];
	        return obj;
	    }, initProps);
	};
	
	var convertReactPropstoHtmlAttributes = function convertReactPropstoHtmlAttributes(props) {
	    var initAttributes = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	    return Object.keys(props).reduce(function (obj, key) {
	        obj[_HelmetConstants.HTML_TAG_MAP[key] || key] = props[key];
	        return obj;
	    }, initAttributes);
	};
	
	var generateTitleAsReactComponent = function generateTitleAsReactComponent(type, title, attributes) {
	    var _initProps;
	
	    // assigning into an array to define toString function on it
	    var initProps = (_initProps = {
	        key: title
	    }, _initProps[_HelmetConstants.HELMET_ATTRIBUTE] = true, _initProps);
	    var props = convertElementAttributestoReactProps(attributes, initProps);
	
	    return [_react2.default.createElement(_HelmetConstants.TAG_NAMES.TITLE, props, title)];
	};
	
	var generateTagsAsReactComponent = function generateTagsAsReactComponent(type, tags) {
	    return tags.map(function (tag, i) {
	        var _mappedTag;
	
	        var mappedTag = (_mappedTag = {
	            key: i
	        }, _mappedTag[_HelmetConstants.HELMET_ATTRIBUTE] = true, _mappedTag);
	
	        Object.keys(tag).forEach(function (attribute) {
	            var mappedAttribute = _HelmetConstants.REACT_TAG_MAP[attribute] || attribute;
	
	            if (mappedAttribute === _HelmetConstants.TAG_PROPERTIES.INNER_HTML || mappedAttribute === _HelmetConstants.TAG_PROPERTIES.CSS_TEXT) {
	                var content = tag.innerHTML || tag.cssText;
	                mappedTag.dangerouslySetInnerHTML = { __html: content };
	            } else {
	                mappedTag[mappedAttribute] = tag[attribute];
	            }
	        });
	
	        return _react2.default.createElement(type, mappedTag);
	    });
	};
	
	var getMethodsForTag = function getMethodsForTag(type, tags, encode) {
	    switch (type) {
	        case _HelmetConstants.TAG_NAMES.TITLE:
	            return {
	                toComponent: function toComponent() {
	                    return generateTitleAsReactComponent(type, tags.title, tags.titleAttributes, encode);
	                },
	                toString: function toString() {
	                    return generateTitleAsString(type, tags.title, tags.titleAttributes, encode);
	                }
	            };
	        case _HelmetConstants.ATTRIBUTE_NAMES.BODY:
	        case _HelmetConstants.ATTRIBUTE_NAMES.HTML:
	            return {
	                toComponent: function toComponent() {
	                    return convertElementAttributestoReactProps(tags);
	                },
	                toString: function toString() {
	                    return generateElementAttributesAsString(tags);
	                }
	            };
	        default:
	            return {
	                toComponent: function toComponent() {
	                    return generateTagsAsReactComponent(type, tags);
	                },
	                toString: function toString() {
	                    return generateTagsAsString(type, tags, encode);
	                }
	            };
	    }
	};
	
	var mapStateOnServer = function mapStateOnServer(_ref) {
	    var baseTag = _ref.baseTag,
	        bodyAttributes = _ref.bodyAttributes,
	        encode = _ref.encode,
	        htmlAttributes = _ref.htmlAttributes,
	        linkTags = _ref.linkTags,
	        metaTags = _ref.metaTags,
	        noscriptTags = _ref.noscriptTags,
	        scriptTags = _ref.scriptTags,
	        styleTags = _ref.styleTags,
	        _ref$title = _ref.title,
	        title = _ref$title === undefined ? "" : _ref$title,
	        titleAttributes = _ref.titleAttributes;
	    return {
	        base: getMethodsForTag(_HelmetConstants.TAG_NAMES.BASE, baseTag, encode),
	        bodyAttributes: getMethodsForTag(_HelmetConstants.ATTRIBUTE_NAMES.BODY, bodyAttributes, encode),
	        htmlAttributes: getMethodsForTag(_HelmetConstants.ATTRIBUTE_NAMES.HTML, htmlAttributes, encode),
	        link: getMethodsForTag(_HelmetConstants.TAG_NAMES.LINK, linkTags, encode),
	        meta: getMethodsForTag(_HelmetConstants.TAG_NAMES.META, metaTags, encode),
	        noscript: getMethodsForTag(_HelmetConstants.TAG_NAMES.NOSCRIPT, noscriptTags, encode),
	        script: getMethodsForTag(_HelmetConstants.TAG_NAMES.SCRIPT, scriptTags, encode),
	        style: getMethodsForTag(_HelmetConstants.TAG_NAMES.STYLE, styleTags, encode),
	        title: getMethodsForTag(_HelmetConstants.TAG_NAMES.TITLE, { title: title, titleAttributes: titleAttributes }, encode)
	    };
	};
	
	exports.convertReactPropstoHtmlAttributes = convertReactPropstoHtmlAttributes;
	exports.handleClientStateChange = handleClientStateChange;
	exports.mapStateOnServer = mapStateOnServer;
	exports.reducePropsToState = reducePropsToState;
	exports.requestAnimationFrame = requestAnimationFrame;
	exports.warn = warn;
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 1295 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _inputRange = __webpack_require__(1297);
	
	var _inputRange2 = _interopRequireDefault(_inputRange);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @ignore
	 * @typedef {Object} ClientRect
	 * @property {number} height
	 * @property {number} left
	 * @property {number} top
	 * @property {number} width
	 */
	
	/**
	 * @typedef {Object} InputRangeClassNames
	 * @property {string} activeTrack
	 * @property {string} disabledInputRange
	 * @property {string} inputRange
	 * @property {string} labelContainer
	 * @property {string} maxLabel
	 * @property {string} minLabel
	 * @property {string} slider
	 * @property {string} sliderContainer
	 * @property {string} track
	 * @property {string} valueLabel
	 */
	
	/**
	 * @typedef {Function} LabelFormatter
	 * @param {number} value
	 * @param {string} type
	 * @return {string}
	 */
	
	/**
	 * @ignore
	 * @typedef {Object} Point
	 * @property {number} x
	 * @property {number} y
	 */
	
	/**
	 * @typedef {Object} Range
	 * @property {number} min - Min value
	 * @property {number} max - Max value
	 */
	
	exports.default = _inputRange2.default;
	module.exports = exports['default'];
	//# sourceMappingURL=index.js.map

/***/ },
/* 1296 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	/**
	* Default CSS class names
	* @ignore
	* @type {InputRangeClassNames}
	*/
	var DEFAULT_CLASS_NAMES = {
	  activeTrack: 'input-range__track input-range__track--active',
	  disabledInputRange: 'input-range input-range--disabled',
	  inputRange: 'input-range',
	  labelContainer: 'input-range__label-container',
	  maxLabel: 'input-range__label input-range__label--max',
	  minLabel: 'input-range__label input-range__label--min',
	  slider: 'input-range__slider',
	  sliderContainer: 'input-range__slider-container',
	  track: 'input-range__track input-range__track--background',
	  valueLabel: 'input-range__label input-range__label--value'
	};
	
	exports.default = DEFAULT_CLASS_NAMES;
	module.exports = exports['default'];
	//# sourceMappingURL=default-class-names.js.map

/***/ },
/* 1297 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _desc, _value, _class;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(20);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _autobindDecorator = __webpack_require__(229);
	
	var _autobindDecorator2 = _interopRequireDefault(_autobindDecorator);
	
	var _valueTransformer = __webpack_require__(1303);
	
	var valueTransformer = _interopRequireWildcard(_valueTransformer);
	
	var _defaultClassNames = __webpack_require__(1296);
	
	var _defaultClassNames2 = _interopRequireDefault(_defaultClassNames);
	
	var _label = __webpack_require__(509);
	
	var _label2 = _interopRequireDefault(_label);
	
	var _rangePropType = __webpack_require__(1299);
	
	var _rangePropType2 = _interopRequireDefault(_rangePropType);
	
	var _valuePropType = __webpack_require__(1302);
	
	var _valuePropType2 = _interopRequireDefault(_valuePropType);
	
	var _slider = __webpack_require__(1300);
	
	var _slider2 = _interopRequireDefault(_slider);
	
	var _track = __webpack_require__(1301);
	
	var _track2 = _interopRequireDefault(_track);
	
	var _utils = __webpack_require__(210);
	
	var _keyCodes = __webpack_require__(1298);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
	  var desc = {};
	  Object['ke' + 'ys'](descriptor).forEach(function (key) {
	    desc[key] = descriptor[key];
	  });
	  desc.enumerable = !!desc.enumerable;
	  desc.configurable = !!desc.configurable;
	
	  if ('value' in desc || desc.initializer) {
	    desc.writable = true;
	  }
	
	  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
	    return decorator(target, property, desc) || desc;
	  }, desc);
	
	  if (context && desc.initializer !== void 0) {
	    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
	    desc.initializer = undefined;
	  }
	
	  if (desc.initializer === void 0) {
	    Object['define' + 'Property'](target, property, desc);
	    desc = null;
	  }
	
	  return desc;
	}
	
	/**
	 * A React component that allows users to input numeric values within a range
	 * by dragging its sliders.
	 */
	var InputRange = (_class = function (_React$Component) {
	  _inherits(InputRange, _React$Component);
	
	  _createClass(InputRange, null, [{
	    key: 'propTypes',
	
	    /**
	     * @ignore
	     * @override
	     * @return {Object}
	     */
	    get: function get() {
	      return {
	        ariaLabelledby: _propTypes2.default.string,
	        ariaControls: _propTypes2.default.string,
	        classNames: _propTypes2.default.objectOf(_propTypes2.default.string),
	        disabled: _propTypes2.default.bool,
	        formatLabel: _propTypes2.default.func,
	        maxValue: _rangePropType2.default,
	        minValue: _rangePropType2.default,
	        name: _propTypes2.default.string,
	        onChangeStart: _propTypes2.default.func,
	        onChange: _propTypes2.default.func.isRequired,
	        onChangeComplete: _propTypes2.default.func,
	        step: _propTypes2.default.number,
	        value: _valuePropType2.default
	      };
	    }
	
	    /**
	     * @ignore
	     * @override
	     * @return {Object}
	     */
	
	  }, {
	    key: 'defaultProps',
	    get: function get() {
	      return {
	        classNames: _defaultClassNames2.default,
	        disabled: false,
	        maxValue: 10,
	        minValue: 0,
	        step: 1
	      };
	    }
	
	    /**
	     * @param {Object} props
	     * @param {string} [props.ariaLabelledby]
	     * @param {string} [props.ariaControls]
	     * @param {InputRangeClassNames} [props.classNames]
	     * @param {boolean} [props.disabled = false]
	     * @param {Function} [props.formatLabel]
	     * @param {number|Range} [props.maxValue = 10]
	     * @param {number|Range} [props.minValue = 0]
	     * @param {string} [props.name]
	     * @param {string} props.onChange
	     * @param {Function} [props.onChangeComplete]
	     * @param {Function} [props.onChangeStart]
	     * @param {number} [props.step = 1]
	     * @param {number|Range} props.value
	     */
	
	  }]);
	
	  function InputRange(props) {
	    _classCallCheck(this, InputRange);
	
	    /**
	     * @private
	     * @type {?number}
	     */
	    var _this = _possibleConstructorReturn(this, (InputRange.__proto__ || Object.getPrototypeOf(InputRange)).call(this, props));
	
	    _this.startValue = null;
	
	    /**
	     * @private
	     * @type {?Component}
	     */
	    _this.node = null;
	
	    /**
	     * @private
	     * @type {?Component}
	     */
	    _this.trackNode = null;
	    return _this;
	  }
	
	  /**
	   * @ignore
	   * @override
	   * @return {void}
	   */
	
	
	  _createClass(InputRange, [{
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      this.removeDocumentMouseUpListener();
	      this.removeDocumentTouchEndListener();
	    }
	
	    /**
	     * Return the CSS class name of the component
	     * @private
	     * @return {string}
	     */
	
	  }, {
	    key: 'getComponentClassName',
	    value: function getComponentClassName() {
	      if (!this.props.disabled) {
	        return this.props.classNames.inputRange;
	      }
	
	      return this.props.classNames.disabledInputRange;
	    }
	
	    /**
	     * Return the bounding rect of the track
	     * @private
	     * @return {ClientRect}
	     */
	
	  }, {
	    key: 'getTrackClientRect',
	    value: function getTrackClientRect() {
	      return this.trackNode.getClientRect();
	    }
	
	    /**
	     * Return the slider key closest to a point
	     * @private
	     * @param {Point} position
	     * @return {string}
	     */
	
	  }, {
	    key: 'getKeyByPosition',
	    value: function getKeyByPosition(position) {
	      var values = valueTransformer.getValueFromProps(this.props, this.isMultiValue());
	      var positions = valueTransformer.getPositionsFromValues(values, this.props.minValue, this.props.maxValue, this.getTrackClientRect());
	
	      if (this.isMultiValue()) {
	        var distanceToMin = (0, _utils.distanceTo)(position, positions.min);
	        var distanceToMax = (0, _utils.distanceTo)(position, positions.max);
	
	        if (distanceToMin < distanceToMax) {
	          return 'min';
	        }
	      }
	
	      return 'max';
	    }
	
	    /**
	     * Return all the slider keys
	     * @private
	     * @return {string[]}
	     */
	
	  }, {
	    key: 'getKeys',
	    value: function getKeys() {
	      if (this.isMultiValue()) {
	        return ['min', 'max'];
	      }
	
	      return ['max'];
	    }
	
	    /**
	     * Return true if the difference between the new and the current value is
	     * greater or equal to the step amount of the component
	     * @private
	     * @param {Range} values
	     * @return {boolean}
	     */
	
	  }, {
	    key: 'hasStepDifference',
	    value: function hasStepDifference(values) {
	      var currentValues = valueTransformer.getValueFromProps(this.props, this.isMultiValue());
	
	      return (0, _utils.length)(values.min, currentValues.min) >= this.props.step || (0, _utils.length)(values.max, currentValues.max) >= this.props.step;
	    }
	
	    /**
	     * Return true if the component accepts a min and max value
	     * @private
	     * @return {boolean}
	     */
	
	  }, {
	    key: 'isMultiValue',
	    value: function isMultiValue() {
	      return (0, _utils.isObject)(this.props.value);
	    }
	
	    /**
	     * Return true if the range is within the max and min value of the component
	     * @private
	     * @param {Range} values
	     * @return {boolean}
	     */
	
	  }, {
	    key: 'isWithinRange',
	    value: function isWithinRange(values) {
	      if (this.isMultiValue()) {
	        return values.min >= this.props.minValue && values.max <= this.props.maxValue && values.min < values.max;
	      }
	
	      return values.max >= this.props.minValue && values.max <= this.props.maxValue;
	    }
	
	    /**
	     * Return true if the new value should trigger a render
	     * @private
	     * @param {Range} values
	     * @return {boolean}
	     */
	
	  }, {
	    key: 'shouldUpdate',
	    value: function shouldUpdate(values) {
	      return this.isWithinRange(values) && this.hasStepDifference(values);
	    }
	
	    /**
	     * Update the position of a slider
	     * @private
	     * @param {string} key
	     * @param {Point} position
	     * @return {void}
	     */
	
	  }, {
	    key: 'updatePosition',
	    value: function updatePosition(key, position) {
	      var values = valueTransformer.getValueFromProps(this.props, this.isMultiValue());
	      var positions = valueTransformer.getPositionsFromValues(values, this.props.minValue, this.props.maxValue, this.getTrackClientRect());
	
	      positions[key] = position;
	
	      this.updatePositions(positions);
	    }
	
	    /**
	     * Update the positions of multiple sliders
	     * @private
	     * @param {Object} positions
	     * @param {Point} positions.min
	     * @param {Point} positions.max
	     * @return {void}
	     */
	
	  }, {
	    key: 'updatePositions',
	    value: function updatePositions(positions) {
	      var values = {
	        min: valueTransformer.getValueFromPosition(positions.min, this.props.minValue, this.props.maxValue, this.getTrackClientRect()),
	        max: valueTransformer.getValueFromPosition(positions.max, this.props.minValue, this.props.maxValue, this.getTrackClientRect())
	      };
	
	      var transformedValues = {
	        min: valueTransformer.getStepValueFromValue(values.min, this.props.step),
	        max: valueTransformer.getStepValueFromValue(values.max, this.props.step)
	      };
	
	      this.updateValues(transformedValues);
	    }
	
	    /**
	     * Update the value of a slider
	     * @private
	     * @param {string} key
	     * @param {number} value
	     * @return {void}
	     */
	
	  }, {
	    key: 'updateValue',
	    value: function updateValue(key, value) {
	      var values = valueTransformer.getValueFromProps(this.props, this.isMultiValue());
	
	      values[key] = value;
	
	      this.updateValues(values);
	    }
	
	    /**
	     * Update the values of multiple sliders
	     * @private
	     * @param {Range|number} values
	     * @return {void}
	     */
	
	  }, {
	    key: 'updateValues',
	    value: function updateValues(values) {
	      if (!this.shouldUpdate(values)) {
	        return;
	      }
	
	      this.props.onChange(this.isMultiValue() ? values : values.max);
	    }
	
	    /**
	     * Increment the value of a slider by key name
	     * @private
	     * @param {string} key
	     * @return {void}
	     */
	
	  }, {
	    key: 'incrementValue',
	    value: function incrementValue(key) {
	      var values = valueTransformer.getValueFromProps(this.props, this.isMultiValue());
	      var value = values[key] + this.props.step;
	
	      this.updateValue(key, value);
	    }
	
	    /**
	     * Decrement the value of a slider by key name
	     * @private
	     * @param {string} key
	     * @return {void}
	     */
	
	  }, {
	    key: 'decrementValue',
	    value: function decrementValue(key) {
	      var values = valueTransformer.getValueFromProps(this.props, this.isMultiValue());
	      var value = values[key] - this.props.step;
	
	      this.updateValue(key, value);
	    }
	
	    /**
	     * Listen to mouseup event
	     * @private
	     * @return {void}
	     */
	
	  }, {
	    key: 'addDocumentMouseUpListener',
	    value: function addDocumentMouseUpListener() {
	      this.removeDocumentMouseUpListener();
	      this.node.ownerDocument.addEventListener('mouseup', this.handleMouseUp);
	    }
	
	    /**
	     * Listen to touchend event
	     * @private
	     * @return {void}
	     */
	
	  }, {
	    key: 'addDocumentTouchEndListener',
	    value: function addDocumentTouchEndListener() {
	      this.removeDocumentTouchEndListener();
	      this.node.ownerDocument.addEventListener('touchend', this.handleTouchEnd);
	    }
	
	    /**
	     * Stop listening to mouseup event
	     * @private
	     * @return {void}
	     */
	
	  }, {
	    key: 'removeDocumentMouseUpListener',
	    value: function removeDocumentMouseUpListener() {
	      this.node.ownerDocument.removeEventListener('mouseup', this.handleMouseUp);
	    }
	
	    /**
	     * Stop listening to touchend event
	     * @private
	     * @return {void}
	     */
	
	  }, {
	    key: 'removeDocumentTouchEndListener',
	    value: function removeDocumentTouchEndListener() {
	      this.node.ownerDocument.removeEventListener('touchend', this.handleTouchEnd);
	    }
	
	    /**
	     * Handle any "mousemove" event received by the slider
	     * @private
	     * @param {SyntheticEvent} event
	     * @param {string} key
	     * @return {void}
	     */
	
	  }, {
	    key: 'handleSliderDrag',
	    value: function handleSliderDrag(event, key) {
	      var _this2 = this;
	
	      if (this.props.disabled) {
	        return;
	      }
	
	      var position = valueTransformer.getPositionFromEvent(event, this.getTrackClientRect());
	
	      requestAnimationFrame(function () {
	        return _this2.updatePosition(key, position);
	      });
	    }
	
	    /**
	     * Handle any "keydown" event received by the slider
	     * @private
	     * @param {SyntheticEvent} event
	     * @param {string} key
	     * @return {void}
	     */
	
	  }, {
	    key: 'handleSliderKeyDown',
	    value: function handleSliderKeyDown(event, key) {
	      if (this.props.disabled) {
	        return;
	      }
	
	      switch (event.keyCode) {
	        case _keyCodes.LEFT_ARROW:
	        case _keyCodes.DOWN_ARROW:
	          event.preventDefault();
	          this.decrementValue(key);
	          break;
	
	        case _keyCodes.RIGHT_ARROW:
	        case _keyCodes.UP_ARROW:
	          event.preventDefault();
	          this.incrementValue(key);
	          break;
	
	        default:
	          break;
	      }
	    }
	
	    /**
	     * Handle any "mousedown" event received by the track
	     * @private
	     * @param {SyntheticEvent} event
	     * @param {Point} position
	     * @return {void}
	     */
	
	  }, {
	    key: 'handleTrackMouseDown',
	    value: function handleTrackMouseDown(event, position) {
	      if (this.props.disabled) {
	        return;
	      }
	
	      event.preventDefault();
	
	      this.updatePosition(this.getKeyByPosition(position), position);
	    }
	
	    /**
	     * Handle the start of any mouse/touch event
	     * @private
	     * @return {void}
	     */
	
	  }, {
	    key: 'handleInteractionStart',
	    value: function handleInteractionStart() {
	      if (this.props.onChangeStart) {
	        this.props.onChangeStart(this.props.value);
	      }
	
	      if (this.props.onChangeComplete && !(0, _utils.isDefined)(this.startValue)) {
	        this.startValue = this.props.value;
	      }
	    }
	
	    /**
	     * Handle the end of any mouse/touch event
	     * @private
	     * @return {void}
	     */
	
	  }, {
	    key: 'handleInteractionEnd',
	    value: function handleInteractionEnd() {
	      if (!this.props.onChangeComplete || !(0, _utils.isDefined)(this.startValue)) {
	        return;
	      }
	
	      if (this.startValue !== this.props.value) {
	        this.props.onChangeComplete(this.props.value);
	      }
	
	      this.startValue = null;
	    }
	
	    /**
	     * Handle any "keydown" event received by the component
	     * @private
	     * @param {SyntheticEvent} event
	     * @return {void}
	     */
	
	  }, {
	    key: 'handleKeyDown',
	    value: function handleKeyDown(event) {
	      this.handleInteractionStart(event);
	    }
	
	    /**
	     * Handle any "keyup" event received by the component
	     * @private
	     * @param {SyntheticEvent} event
	     * @return {void}
	     */
	
	  }, {
	    key: 'handleKeyUp',
	    value: function handleKeyUp(event) {
	      this.handleInteractionEnd(event);
	    }
	
	    /**
	     * Handle any "mousedown" event received by the component
	     * @private
	     * @param {SyntheticEvent} event
	     * @return {void}
	     */
	
	  }, {
	    key: 'handleMouseDown',
	    value: function handleMouseDown(event) {
	      this.handleInteractionStart(event);
	      this.addDocumentMouseUpListener();
	    }
	
	    /**
	     * Handle any "mouseup" event received by the component
	     * @private
	     * @param {SyntheticEvent} event
	     */
	
	  }, {
	    key: 'handleMouseUp',
	    value: function handleMouseUp(event) {
	      this.handleInteractionEnd(event);
	      this.removeDocumentMouseUpListener();
	    }
	
	    /**
	     * Handle any "touchstart" event received by the component
	     * @private
	     * @param {SyntheticEvent} event
	     * @return {void}
	     */
	
	  }, {
	    key: 'handleTouchStart',
	    value: function handleTouchStart(event) {
	      this.handleInteractionStart(event);
	      this.addDocumentTouchEndListener();
	    }
	
	    /**
	     * Handle any "touchend" event received by the component
	     * @private
	     * @param {SyntheticEvent} event
	     */
	
	  }, {
	    key: 'handleTouchEnd',
	    value: function handleTouchEnd(event) {
	      this.handleInteractionEnd(event);
	      this.removeDocumentTouchEndListener();
	    }
	
	    /**
	     * Return JSX of sliders
	     * @private
	     * @return {JSX.Element}
	     */
	
	  }, {
	    key: 'renderSliders',
	    value: function renderSliders() {
	      var _this3 = this;
	
	      var values = valueTransformer.getValueFromProps(this.props, this.isMultiValue());
	      var percentages = valueTransformer.getPercentagesFromValues(values, this.props.minValue, this.props.maxValue);
	
	      return this.getKeys().map(function (key) {
	        var value = values[key];
	        var percentage = percentages[key];
	
	        var _props = _this3.props,
	            maxValue = _props.maxValue,
	            minValue = _props.minValue;
	
	
	        if (key === 'min') {
	          maxValue = values.max;
	        } else {
	          minValue = values.min;
	        }
	
	        var slider = _react2.default.createElement(_slider2.default, {
	          ariaLabelledby: _this3.props.ariaLabelledby,
	          ariaControls: _this3.props.ariaControls,
	          classNames: _this3.props.classNames,
	          formatLabel: _this3.props.formatLabel,
	          key: key,
	          maxValue: maxValue,
	          minValue: minValue,
	          onSliderDrag: _this3.handleSliderDrag,
	          onSliderKeyDown: _this3.handleSliderKeyDown,
	          percentage: percentage,
	          type: key,
	          value: value });
	
	        return slider;
	      });
	    }
	
	    /**
	     * Return JSX of hidden inputs
	     * @private
	     * @return {JSX.Element}
	     */
	
	  }, {
	    key: 'renderHiddenInputs',
	    value: function renderHiddenInputs() {
	      var _this4 = this;
	
	      if (!this.props.name) {
	        return [];
	      }
	
	      var isMultiValue = this.isMultiValue();
	      var values = valueTransformer.getValueFromProps(this.props, isMultiValue);
	
	      return this.getKeys().map(function (key) {
	        var value = values[key];
	        var name = isMultiValue ? '' + _this4.props.name + (0, _utils.captialize)(key) : _this4.props.name;
	
	        return _react2.default.createElement('input', { key: key, type: 'hidden', name: name, value: value });
	      });
	    }
	
	    /**
	     * @ignore
	     * @override
	     * @return {JSX.Element}
	     */
	
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this5 = this;
	
	      var componentClassName = this.getComponentClassName();
	      var values = valueTransformer.getValueFromProps(this.props, this.isMultiValue());
	      var percentages = valueTransformer.getPercentagesFromValues(values, this.props.minValue, this.props.maxValue);
	
	      return _react2.default.createElement(
	        'div',
	        {
	          'aria-disabled': this.props.disabled,
	          ref: function ref(node) {
	            _this5.node = node;
	          },
	          className: componentClassName,
	          onKeyDown: this.handleKeyDown,
	          onKeyUp: this.handleKeyUp,
	          onMouseDown: this.handleMouseDown,
	          onTouchStart: this.handleTouchStart },
	        _react2.default.createElement(
	          _label2.default,
	          {
	            classNames: this.props.classNames,
	            formatLabel: this.props.formatLabel,
	            type: 'min' },
	          this.props.minValue
	        ),
	        _react2.default.createElement(
	          _track2.default,
	          {
	            classNames: this.props.classNames,
	            ref: function ref(trackNode) {
	              _this5.trackNode = trackNode;
	            },
	            percentages: percentages,
	            onTrackMouseDown: this.handleTrackMouseDown },
	          this.renderSliders()
	        ),
	        _react2.default.createElement(
	          _label2.default,
	          {
	            classNames: this.props.classNames,
	            formatLabel: this.props.formatLabel,
	            type: 'max' },
	          this.props.maxValue
	        ),
	        this.renderHiddenInputs()
	      );
	    }
	  }]);
	
	  return InputRange;
	}(_react2.default.Component), (_applyDecoratedDescriptor(_class.prototype, 'handleSliderDrag', [_autobindDecorator2.default], Object.getOwnPropertyDescriptor(_class.prototype, 'handleSliderDrag'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'handleSliderKeyDown', [_autobindDecorator2.default], Object.getOwnPropertyDescriptor(_class.prototype, 'handleSliderKeyDown'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'handleTrackMouseDown', [_autobindDecorator2.default], Object.getOwnPropertyDescriptor(_class.prototype, 'handleTrackMouseDown'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'handleInteractionStart', [_autobindDecorator2.default], Object.getOwnPropertyDescriptor(_class.prototype, 'handleInteractionStart'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'handleInteractionEnd', [_autobindDecorator2.default], Object.getOwnPropertyDescriptor(_class.prototype, 'handleInteractionEnd'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'handleKeyDown', [_autobindDecorator2.default], Object.getOwnPropertyDescriptor(_class.prototype, 'handleKeyDown'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'handleKeyUp', [_autobindDecorator2.default], Object.getOwnPropertyDescriptor(_class.prototype, 'handleKeyUp'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'handleMouseDown', [_autobindDecorator2.default], Object.getOwnPropertyDescriptor(_class.prototype, 'handleMouseDown'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'handleMouseUp', [_autobindDecorator2.default], Object.getOwnPropertyDescriptor(_class.prototype, 'handleMouseUp'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'handleTouchStart', [_autobindDecorator2.default], Object.getOwnPropertyDescriptor(_class.prototype, 'handleTouchStart'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'handleTouchEnd', [_autobindDecorator2.default], Object.getOwnPropertyDescriptor(_class.prototype, 'handleTouchEnd'), _class.prototype)), _class);
	exports.default = InputRange;
	module.exports = exports['default'];
	//# sourceMappingURL=input-range.js.map

/***/ },
/* 1298 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	/** @ignore */
	var DOWN_ARROW = exports.DOWN_ARROW = 40;
	
	/** @ignore */
	var LEFT_ARROW = exports.LEFT_ARROW = 37;
	
	/** @ignore */
	var RIGHT_ARROW = exports.RIGHT_ARROW = 39;
	
	/** @ignore */
	var UP_ARROW = exports.UP_ARROW = 38;
	//# sourceMappingURL=key-codes.js.map

/***/ },
/* 1299 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = rangePropType;
	
	var _utils = __webpack_require__(210);
	
	/**
	 * @ignore
	 * @param {Object} props - React component props
	 * @return {?Error} Return Error if validation fails
	 */
	function rangePropType(props) {
	  var maxValue = props.maxValue,
	      minValue = props.minValue;
	
	
	  if (!(0, _utils.isNumber)(minValue) || !(0, _utils.isNumber)(maxValue)) {
	    return new Error('"minValue" and "maxValue" must be a number');
	  }
	
	  if (minValue >= maxValue) {
	    return new Error('"minValue" must be smaller than "maxValue"');
	  }
	}
	module.exports = exports['default'];
	//# sourceMappingURL=range-prop-type.js.map

/***/ },
/* 1300 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _desc, _value, _class;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(20);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _autobindDecorator = __webpack_require__(229);
	
	var _autobindDecorator2 = _interopRequireDefault(_autobindDecorator);
	
	var _label = __webpack_require__(509);
	
	var _label2 = _interopRequireDefault(_label);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
	  var desc = {};
	  Object['ke' + 'ys'](descriptor).forEach(function (key) {
	    desc[key] = descriptor[key];
	  });
	  desc.enumerable = !!desc.enumerable;
	  desc.configurable = !!desc.configurable;
	
	  if ('value' in desc || desc.initializer) {
	    desc.writable = true;
	  }
	
	  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
	    return decorator(target, property, desc) || desc;
	  }, desc);
	
	  if (context && desc.initializer !== void 0) {
	    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
	    desc.initializer = undefined;
	  }
	
	  if (desc.initializer === void 0) {
	    Object['define' + 'Property'](target, property, desc);
	    desc = null;
	  }
	
	  return desc;
	}
	
	/**
	 * @ignore
	 */
	var Slider = (_class = function (_React$Component) {
	  _inherits(Slider, _React$Component);
	
	  _createClass(Slider, null, [{
	    key: 'propTypes',
	
	    /**
	     * Accepted propTypes of Slider
	     * @override
	     * @return {Object}
	     * @property {Function} ariaLabelledby
	     * @property {Function} ariaControls
	     * @property {Function} className
	     * @property {Function} formatLabel
	     * @property {Function} maxValue
	     * @property {Function} minValue
	     * @property {Function} onSliderDrag
	     * @property {Function} onSliderKeyDown
	     * @property {Function} percentage
	     * @property {Function} type
	     * @property {Function} value
	     */
	    get: function get() {
	      return {
	        ariaLabelledby: _propTypes2.default.string,
	        ariaControls: _propTypes2.default.string,
	        classNames: _propTypes2.default.objectOf(_propTypes2.default.string).isRequired,
	        formatLabel: _propTypes2.default.func,
	        maxValue: _propTypes2.default.number,
	        minValue: _propTypes2.default.number,
	        onSliderDrag: _propTypes2.default.func.isRequired,
	        onSliderKeyDown: _propTypes2.default.func.isRequired,
	        percentage: _propTypes2.default.number.isRequired,
	        type: _propTypes2.default.string.isRequired,
	        value: _propTypes2.default.number.isRequired
	      };
	    }
	
	    /**
	     * @param {Object} props
	     * @param {string} [props.ariaLabelledby]
	     * @param {string} [props.ariaControls]
	     * @param {InputRangeClassNames} props.classNames
	     * @param {Function} [props.formatLabel]
	     * @param {number} [props.maxValue]
	     * @param {number} [props.minValue]
	     * @param {Function} props.onSliderKeyDown
	     * @param {Function} props.onSliderDrag
	     * @param {number} props.percentage
	     * @param {number} props.type
	     * @param {number} props.value
	     */
	
	  }]);
	
	  function Slider(props) {
	    _classCallCheck(this, Slider);
	
	    /**
	     * @private
	     * @type {?Component}
	     */
	    var _this = _possibleConstructorReturn(this, (Slider.__proto__ || Object.getPrototypeOf(Slider)).call(this, props));
	
	    _this.node = null;
	    return _this;
	  }
	
	  /**
	   * @ignore
	   * @override
	   * @return {void}
	   */
	
	
	  _createClass(Slider, [{
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      this.removeDocumentMouseMoveListener();
	      this.removeDocumentMouseUpListener();
	      this.removeDocumentTouchEndListener();
	      this.removeDocumentTouchMoveListener();
	    }
	
	    /**
	     * @private
	     * @return {Object}
	     */
	
	  }, {
	    key: 'getStyle',
	    value: function getStyle() {
	      var perc = (this.props.percentage || 0) * 100;
	      var style = {
	        position: 'absolute',
	        left: perc + '%'
	      };
	
	      return style;
	    }
	
	    /**
	     * Listen to mousemove event
	     * @private
	     * @return {void}
	     */
	
	  }, {
	    key: 'addDocumentMouseMoveListener',
	    value: function addDocumentMouseMoveListener() {
	      this.removeDocumentMouseMoveListener();
	      this.node.ownerDocument.addEventListener('mousemove', this.handleMouseMove);
	    }
	
	    /**
	     * Listen to mouseup event
	     * @private
	     * @return {void}
	     */
	
	  }, {
	    key: 'addDocumentMouseUpListener',
	    value: function addDocumentMouseUpListener() {
	      this.removeDocumentMouseUpListener();
	      this.node.ownerDocument.addEventListener('mouseup', this.handleMouseUp);
	    }
	
	    /**
	     * Listen to touchmove event
	     * @private
	     * @return {void}
	     */
	
	  }, {
	    key: 'addDocumentTouchMoveListener',
	    value: function addDocumentTouchMoveListener() {
	      this.removeDocumentTouchMoveListener();
	      this.node.ownerDocument.addEventListener('touchmove', this.handleTouchMove);
	    }
	
	    /**
	     * Listen to touchend event
	     * @private
	     * @return {void}
	     */
	
	  }, {
	    key: 'addDocumentTouchEndListener',
	    value: function addDocumentTouchEndListener() {
	      this.removeDocumentTouchEndListener();
	      this.node.ownerDocument.addEventListener('touchend', this.handleTouchEnd);
	    }
	
	    /**
	     * @private
	     * @return {void}
	     */
	
	  }, {
	    key: 'removeDocumentMouseMoveListener',
	    value: function removeDocumentMouseMoveListener() {
	      this.node.ownerDocument.removeEventListener('mousemove', this.handleMouseMove);
	    }
	
	    /**
	     * @private
	     * @return {void}
	     */
	
	  }, {
	    key: 'removeDocumentMouseUpListener',
	    value: function removeDocumentMouseUpListener() {
	      this.node.ownerDocument.removeEventListener('mouseup', this.handleMouseUp);
	    }
	
	    /**
	     * @private
	     * @return {void}
	     */
	
	  }, {
	    key: 'removeDocumentTouchMoveListener',
	    value: function removeDocumentTouchMoveListener() {
	      this.node.ownerDocument.removeEventListener('touchmove', this.handleTouchMove);
	    }
	
	    /**
	     * @private
	     * @return {void}
	     */
	
	  }, {
	    key: 'removeDocumentTouchEndListener',
	    value: function removeDocumentTouchEndListener() {
	      this.node.ownerDocument.removeEventListener('touchend', this.handleTouchEnd);
	    }
	
	    /**
	     * @private
	     * @return {void}
	     */
	
	  }, {
	    key: 'handleMouseDown',
	    value: function handleMouseDown() {
	      this.addDocumentMouseMoveListener();
	      this.addDocumentMouseUpListener();
	    }
	
	    /**
	     * @private
	     * @return {void}
	     */
	
	  }, {
	    key: 'handleMouseUp',
	    value: function handleMouseUp() {
	      this.removeDocumentMouseMoveListener();
	      this.removeDocumentMouseUpListener();
	    }
	
	    /**
	     * @private
	     * @param {SyntheticEvent} event
	     * @return {void}
	     */
	
	  }, {
	    key: 'handleMouseMove',
	    value: function handleMouseMove(event) {
	      this.props.onSliderDrag(event, this.props.type);
	    }
	
	    /**
	     * @private
	     * @return {void}
	     */
	
	  }, {
	    key: 'handleTouchStart',
	    value: function handleTouchStart() {
	      this.addDocumentTouchEndListener();
	      this.addDocumentTouchMoveListener();
	    }
	
	    /**
	     * @private
	     * @param {SyntheticEvent} event
	     * @return {void}
	     */
	
	  }, {
	    key: 'handleTouchMove',
	    value: function handleTouchMove(event) {
	      this.props.onSliderDrag(event, this.props.type);
	    }
	
	    /**
	     * @private
	     * @return {void}
	     */
	
	  }, {
	    key: 'handleTouchEnd',
	    value: function handleTouchEnd() {
	      this.removeDocumentTouchMoveListener();
	      this.removeDocumentTouchEndListener();
	    }
	
	    /**
	     * @private
	     * @param {SyntheticEvent} event
	     * @return {void}
	     */
	
	  }, {
	    key: 'handleKeyDown',
	    value: function handleKeyDown(event) {
	      this.props.onSliderKeyDown(event, this.props.type);
	    }
	
	    /**
	     * @override
	     * @return {JSX.Element}
	     */
	
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var style = this.getStyle();
	
	      return _react2.default.createElement(
	        'span',
	        {
	          className: this.props.classNames.sliderContainer,
	          ref: function ref(node) {
	            _this2.node = node;
	          },
	          style: style },
	        _react2.default.createElement(
	          _label2.default,
	          {
	            classNames: this.props.classNames,
	            formatLabel: this.props.formatLabel,
	            type: 'value' },
	          this.props.value
	        ),
	        _react2.default.createElement('div', {
	          'aria-labelledby': this.props.ariaLabelledby,
	          'aria-controls': this.props.ariaControls,
	          'aria-valuemax': this.props.maxValue,
	          'aria-valuemin': this.props.minValue,
	          'aria-valuenow': this.props.value,
	          className: this.props.classNames.slider,
	          draggable: 'false',
	          onKeyDown: this.handleKeyDown,
	          onMouseDown: this.handleMouseDown,
	          onTouchStart: this.handleTouchStart,
	          role: 'slider',
	          tabIndex: '0' })
	      );
	    }
	  }]);
	
	  return Slider;
	}(_react2.default.Component), (_applyDecoratedDescriptor(_class.prototype, 'handleMouseDown', [_autobindDecorator2.default], Object.getOwnPropertyDescriptor(_class.prototype, 'handleMouseDown'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'handleMouseUp', [_autobindDecorator2.default], Object.getOwnPropertyDescriptor(_class.prototype, 'handleMouseUp'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'handleMouseMove', [_autobindDecorator2.default], Object.getOwnPropertyDescriptor(_class.prototype, 'handleMouseMove'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'handleTouchStart', [_autobindDecorator2.default], Object.getOwnPropertyDescriptor(_class.prototype, 'handleTouchStart'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'handleTouchMove', [_autobindDecorator2.default], Object.getOwnPropertyDescriptor(_class.prototype, 'handleTouchMove'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'handleTouchEnd', [_autobindDecorator2.default], Object.getOwnPropertyDescriptor(_class.prototype, 'handleTouchEnd'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'handleKeyDown', [_autobindDecorator2.default], Object.getOwnPropertyDescriptor(_class.prototype, 'handleKeyDown'), _class.prototype)), _class);
	exports.default = Slider;
	module.exports = exports['default'];
	//# sourceMappingURL=slider.js.map

/***/ },
/* 1301 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _desc, _value, _class;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(20);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _autobindDecorator = __webpack_require__(229);
	
	var _autobindDecorator2 = _interopRequireDefault(_autobindDecorator);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
	  var desc = {};
	  Object['ke' + 'ys'](descriptor).forEach(function (key) {
	    desc[key] = descriptor[key];
	  });
	  desc.enumerable = !!desc.enumerable;
	  desc.configurable = !!desc.configurable;
	
	  if ('value' in desc || desc.initializer) {
	    desc.writable = true;
	  }
	
	  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
	    return decorator(target, property, desc) || desc;
	  }, desc);
	
	  if (context && desc.initializer !== void 0) {
	    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
	    desc.initializer = undefined;
	  }
	
	  if (desc.initializer === void 0) {
	    Object['define' + 'Property'](target, property, desc);
	    desc = null;
	  }
	
	  return desc;
	}
	
	/**
	 * @ignore
	 */
	var Track = (_class = function (_React$Component) {
	  _inherits(Track, _React$Component);
	
	  _createClass(Track, null, [{
	    key: 'propTypes',
	
	    /**
	     * @override
	     * @return {Object}
	     * @property {Function} children
	     * @property {Function} classNames
	     * @property {Function} onTrackMouseDown
	     * @property {Function} percentages
	     */
	    get: function get() {
	      return {
	        children: _propTypes2.default.node.isRequired,
	        classNames: _propTypes2.default.objectOf(_propTypes2.default.string).isRequired,
	        onTrackMouseDown: _propTypes2.default.func.isRequired,
	        percentages: _propTypes2.default.objectOf(_propTypes2.default.number).isRequired
	      };
	    }
	
	    /**
	     * @param {Object} props
	     * @param {InputRangeClassNames} props.classNames
	     * @param {Function} props.onTrackMouseDown
	     * @param {number} props.percentages
	     */
	
	  }]);
	
	  function Track(props) {
	    _classCallCheck(this, Track);
	
	    /**
	     * @private
	     * @type {?Component}
	     */
	    var _this = _possibleConstructorReturn(this, (Track.__proto__ || Object.getPrototypeOf(Track)).call(this, props));
	
	    _this.node = null;
	    return _this;
	  }
	
	  /**
	   * @private
	   * @return {ClientRect}
	   */
	
	
	  _createClass(Track, [{
	    key: 'getClientRect',
	    value: function getClientRect() {
	      return this.node.getBoundingClientRect();
	    }
	
	    /**
	     * @private
	     * @return {Object} CSS styles
	     */
	
	  }, {
	    key: 'getActiveTrackStyle',
	    value: function getActiveTrackStyle() {
	      var width = (this.props.percentages.max - this.props.percentages.min) * 100 + '%';
	      var left = this.props.percentages.min * 100 + '%';
	
	      return { left: left, width: width };
	    }
	
	    /**
	     * @private
	     * @param {SyntheticEvent} event - User event
	     */
	
	  }, {
	    key: 'handleMouseDown',
	    value: function handleMouseDown(event) {
	      var clientX = event.touches ? event.touches[0].clientX : event.clientX;
	      var trackClientRect = this.getClientRect();
	      var position = {
	        x: clientX - trackClientRect.left,
	        y: 0
	      };
	
	      this.props.onTrackMouseDown(event, position);
	    }
	
	    /**
	     * @private
	     * @param {SyntheticEvent} event - User event
	     */
	
	  }, {
	    key: 'handleTouchStart',
	    value: function handleTouchStart(event) {
	      event.preventDefault();
	
	      this.handleMouseDown(event);
	    }
	
	    /**
	     * @override
	     * @return {JSX.Element}
	     */
	
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var activeTrackStyle = this.getActiveTrackStyle();
	
	      return _react2.default.createElement(
	        'div',
	        {
	          className: this.props.classNames.track,
	          onMouseDown: this.handleMouseDown,
	          onTouchStart: this.handleTouchStart,
	          ref: function ref(node) {
	            _this2.node = node;
	          } },
	        _react2.default.createElement('div', {
	          style: activeTrackStyle,
	          className: this.props.classNames.activeTrack }),
	        this.props.children
	      );
	    }
	  }]);
	
	  return Track;
	}(_react2.default.Component), (_applyDecoratedDescriptor(_class.prototype, 'handleMouseDown', [_autobindDecorator2.default], Object.getOwnPropertyDescriptor(_class.prototype, 'handleMouseDown'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'handleTouchStart', [_autobindDecorator2.default], Object.getOwnPropertyDescriptor(_class.prototype, 'handleTouchStart'), _class.prototype)), _class);
	exports.default = Track;
	module.exports = exports['default'];
	//# sourceMappingURL=track.js.map

/***/ },
/* 1302 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = valuePropType;
	
	var _utils = __webpack_require__(210);
	
	/**
	 * @ignore
	 * @param {Object} props
	 * @return {?Error} Return Error if validation fails
	 */
	function valuePropType(props, propName) {
	  var maxValue = props.maxValue,
	      minValue = props.minValue;
	
	  var value = props[propName];
	
	  if (!(0, _utils.isNumber)(value) && (!(0, _utils.isObject)(value) || !(0, _utils.isNumber)(value.min) || !(0, _utils.isNumber)(value.max))) {
	    return new Error('"' + propName + '" must be a number or a range object');
	  }
	
	  if ((0, _utils.isNumber)(value) && (value < minValue || value > maxValue)) {
	    return new Error('"' + propName + '" must be in between "minValue" and "maxValue"');
	  }
	
	  if ((0, _utils.isObject)(value) && (value.min < minValue || value.min > maxValue || value.max < minValue || value.max > maxValue)) {
	    return new Error('"' + propName + '" must be in between "minValue" and "maxValue"');
	  }
	}
	module.exports = exports['default'];
	//# sourceMappingURL=value-prop-type.js.map

/***/ },
/* 1303 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.getPercentageFromPosition = getPercentageFromPosition;
	exports.getValueFromPosition = getValueFromPosition;
	exports.getValueFromProps = getValueFromProps;
	exports.getPercentageFromValue = getPercentageFromValue;
	exports.getPercentagesFromValues = getPercentagesFromValues;
	exports.getPositionFromValue = getPositionFromValue;
	exports.getPositionsFromValues = getPositionsFromValues;
	exports.getPositionFromEvent = getPositionFromEvent;
	exports.getStepValueFromValue = getStepValueFromValue;
	
	var _utils = __webpack_require__(210);
	
	/**
	 * Convert a point into a percentage value
	 * @ignore
	 * @param {Point} position
	 * @param {ClientRect} clientRect
	 * @return {number} Percentage value
	 */
	function getPercentageFromPosition(position, clientRect) {
	  var length = clientRect.width;
	  var sizePerc = position.x / length;
	
	  return sizePerc || 0;
	}
	
	/**
	 * Convert a point into a model value
	 * @ignore
	 * @param {Point} position
	 * @param {number} minValue
	 * @param {number} maxValue
	 * @param {ClientRect} clientRect
	 * @return {number}
	 */
	function getValueFromPosition(position, minValue, maxValue, clientRect) {
	  var sizePerc = getPercentageFromPosition(position, clientRect);
	  var valueDiff = maxValue - minValue;
	
	  return minValue + valueDiff * sizePerc;
	}
	
	/**
	 * Convert props into a range value
	 * @ignore
	 * @param {Object} props
	 * @param {boolean} isMultiValue
	 * @return {Range}
	 */
	function getValueFromProps(props, isMultiValue) {
	  if (isMultiValue) {
	    return _extends({}, props.value);
	  }
	
	  return {
	    min: props.minValue,
	    max: props.value
	  };
	}
	
	/**
	 * Convert a model value into a percentage value
	 * @ignore
	 * @param {number} value
	 * @param {number} minValue
	 * @param {number} maxValue
	 * @return {number}
	 */
	function getPercentageFromValue(value, minValue, maxValue) {
	  var validValue = (0, _utils.clamp)(value, minValue, maxValue);
	  var valueDiff = maxValue - minValue;
	  var valuePerc = (validValue - minValue) / valueDiff;
	
	  return valuePerc || 0;
	}
	
	/**
	 * Convert model values into percentage values
	 * @ignore
	 * @param {Range} values
	 * @param {number} minValue
	 * @param {number} maxValue
	 * @return {Range}
	 */
	function getPercentagesFromValues(values, minValue, maxValue) {
	  return {
	    min: getPercentageFromValue(values.min, minValue, maxValue),
	    max: getPercentageFromValue(values.max, minValue, maxValue)
	  };
	}
	
	/**
	 * Convert a value into a point
	 * @ignore
	 * @param {number} value
	 * @param {number} minValue
	 * @param {number} maxValue
	 * @param {ClientRect} clientRect
	 * @return {Point} Position
	 */
	function getPositionFromValue(value, minValue, maxValue, clientRect) {
	  var length = clientRect.width;
	  var valuePerc = getPercentageFromValue(value, minValue, maxValue);
	  var positionValue = valuePerc * length;
	
	  return {
	    x: positionValue,
	    y: 0
	  };
	}
	
	/**
	 * Convert a range of values into points
	 * @ignore
	 * @param {Range} values
	 * @param {number} minValue
	 * @param {number} maxValue
	 * @param {ClientRect} clientRect
	 * @return {Range}
	 */
	function getPositionsFromValues(values, minValue, maxValue, clientRect) {
	  return {
	    min: getPositionFromValue(values.min, minValue, maxValue, clientRect),
	    max: getPositionFromValue(values.max, minValue, maxValue, clientRect)
	  };
	}
	
	/**
	 * Convert an event into a point
	 * @ignore
	 * @param {Event} event
	 * @param {ClientRect} clientRect
	 * @return {Point}
	 */
	function getPositionFromEvent(event, clientRect) {
	  var length = clientRect.width;
	
	  var _ref = event.touches ? event.touches[0] : event,
	      clientX = _ref.clientX;
	
	  return {
	    x: (0, _utils.clamp)(clientX - clientRect.left, 0, length),
	    y: 0
	  };
	}
	
	/**
	 * Convert a value into a step value
	 * @ignore
	 * @param {number} value
	 * @param {number} valuePerStep
	 * @return {number}
	 */
	function getStepValueFromValue(value, valuePerStep) {
	  return Math.round(value / valuePerStep) * valuePerStep;
	}
	//# sourceMappingURL=value-transformer.js.map

/***/ },
/* 1304 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = captialize;
	/**
	 * Captialize a string
	 * @ignore
	 * @param {string} string
	 * @return {string}
	 */
	function captialize(string) {
	  return string.charAt(0).toUpperCase() + string.slice(1);
	}
	module.exports = exports["default"];
	//# sourceMappingURL=captialize.js.map

/***/ },
/* 1305 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = clamp;
	/**
	 * Clamp a value between a min and max value
	 * @ignore
	 * @param {number} value
	 * @param {number} min
	 * @param {number} max
	 * @return {number}
	 */
	function clamp(value, min, max) {
	  return Math.min(Math.max(value, min), max);
	}
	module.exports = exports["default"];
	//# sourceMappingURL=clamp.js.map

/***/ },
/* 1306 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = distanceTo;
	/**
	 * Calculate the distance between pointA and pointB
	 * @ignore
	 * @param {Point} pointA
	 * @param {Point} pointB
	 * @return {number} Distance
	 */
	function distanceTo(pointA, pointB) {
	  var xDiff = Math.pow(pointB.x - pointA.x, 2);
	  var yDiff = Math.pow(pointB.y - pointA.y, 2);
	
	  return Math.sqrt(xDiff + yDiff);
	}
	module.exports = exports["default"];
	//# sourceMappingURL=distance-to.js.map

/***/ },
/* 1307 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isDefined;
	/**
	 * Check if a value is defined
	 * @ignore
	 * @param {*} value
	 * @return {boolean}
	 */
	function isDefined(value) {
	  return value !== undefined && value !== null;
	}
	module.exports = exports["default"];
	//# sourceMappingURL=is-defined.js.map

/***/ },
/* 1308 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isNumber;
	/**
	 * Check if a value is a number
	 * @ignore
	 * @param {*} value
	 * @return {boolean}
	 */
	function isNumber(value) {
	  return typeof value === 'number';
	}
	module.exports = exports['default'];
	//# sourceMappingURL=is-number.js.map

/***/ },
/* 1309 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	exports.default = isObject;
	/**
	 * Check if a value is an object
	 * @ignore
	 * @param {*} value
	 * @return {boolean}
	 */
	function isObject(value) {
	  return value !== null && (typeof value === 'undefined' ? 'undefined' : _typeof(value)) === 'object';
	}
	module.exports = exports['default'];
	//# sourceMappingURL=is-object.js.map

/***/ },
/* 1310 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = length;
	/**
	 * Calculate the absolute difference between two numbers
	 * @ignore
	 * @param {number} numA
	 * @param {number} numB
	 * @return {number}
	 */
	function length(numA, numB) {
	  return Math.abs(numA - numB);
	}
	module.exports = exports["default"];
	//# sourceMappingURL=length.js.map

/***/ },
/* 1311 */
/***/ function(module, exports) {

	/** @license React v16.13.1
	 * react-is.production.min.js
	 *
	 * Copyright (c) Facebook, Inc. and its affiliates.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';var b="function"===typeof Symbol&&Symbol.for,c=b?Symbol.for("react.element"):60103,d=b?Symbol.for("react.portal"):60106,e=b?Symbol.for("react.fragment"):60107,f=b?Symbol.for("react.strict_mode"):60108,g=b?Symbol.for("react.profiler"):60114,h=b?Symbol.for("react.provider"):60109,k=b?Symbol.for("react.context"):60110,l=b?Symbol.for("react.async_mode"):60111,m=b?Symbol.for("react.concurrent_mode"):60111,n=b?Symbol.for("react.forward_ref"):60112,p=b?Symbol.for("react.suspense"):60113,q=b?
	Symbol.for("react.suspense_list"):60120,r=b?Symbol.for("react.memo"):60115,t=b?Symbol.for("react.lazy"):60116,v=b?Symbol.for("react.block"):60121,w=b?Symbol.for("react.fundamental"):60117,x=b?Symbol.for("react.responder"):60118,y=b?Symbol.for("react.scope"):60119;
	function z(a){if("object"===typeof a&&null!==a){var u=a.$$typeof;switch(u){case c:switch(a=a.type,a){case l:case m:case e:case g:case f:case p:return a;default:switch(a=a&&a.$$typeof,a){case k:case n:case t:case r:case h:return a;default:return u}}case d:return u}}}function A(a){return z(a)===m}exports.AsyncMode=l;exports.ConcurrentMode=m;exports.ContextConsumer=k;exports.ContextProvider=h;exports.Element=c;exports.ForwardRef=n;exports.Fragment=e;exports.Lazy=t;exports.Memo=r;exports.Portal=d;
	exports.Profiler=g;exports.StrictMode=f;exports.Suspense=p;exports.isAsyncMode=function(a){return A(a)||z(a)===l};exports.isConcurrentMode=A;exports.isContextConsumer=function(a){return z(a)===k};exports.isContextProvider=function(a){return z(a)===h};exports.isElement=function(a){return"object"===typeof a&&null!==a&&a.$$typeof===c};exports.isForwardRef=function(a){return z(a)===n};exports.isFragment=function(a){return z(a)===e};exports.isLazy=function(a){return z(a)===t};
	exports.isMemo=function(a){return z(a)===r};exports.isPortal=function(a){return z(a)===d};exports.isProfiler=function(a){return z(a)===g};exports.isStrictMode=function(a){return z(a)===f};exports.isSuspense=function(a){return z(a)===p};
	exports.isValidElementType=function(a){return"string"===typeof a||"function"===typeof a||a===e||a===m||a===g||a===f||a===p||a===q||"object"===typeof a&&null!==a&&(a.$$typeof===t||a.$$typeof===r||a.$$typeof===h||a.$$typeof===k||a.$$typeof===n||a.$$typeof===w||a.$$typeof===x||a.$$typeof===y||a.$$typeof===v)};exports.typeOf=z;


/***/ },
/* 1312 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var React = __webpack_require__(1);
	var xtend = __webpack_require__(79);
	
	function astToReact(node, options) {
	  var parent = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	  var index = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;
	
	  var renderer = options.renderers[node.type];
	
	  var pos = node.position.start;
	  var key = [node.type, pos.line, pos.column].join('-');
	
	  if (node.type === 'text') {
	    return renderer ? renderer(node.value, key) : node.value;
	  }
	
	  if (typeof renderer !== 'function' && typeof renderer !== 'string' && !isReactFragment(renderer)) {
	    throw new Error('Renderer for type `' + node.type + '` not defined or is not renderable');
	  }
	
	  var nodeProps = getNodeProps(node, key, options, renderer, parent, index);
	
	  return React.createElement(renderer, nodeProps, nodeProps.children || resolveChildren() || undefined);
	
	  function resolveChildren() {
	    return node.children && node.children.map(function (childNode, i) {
	      return astToReact(childNode, options, { node: node, props: nodeProps }, i);
	    });
	  }
	}
	
	function isReactFragment(renderer) {
	  return React.Fragment && React.Fragment === renderer;
	}
	
	// eslint-disable-next-line max-params, complexity
	function getNodeProps(node, key, opts, renderer, parent, index) {
	  var props = { key: key };
	
	  var isTagRenderer = typeof renderer === 'string';
	
	  // `sourcePos` is true if the user wants source information (line/column info from markdown source)
	  if (opts.sourcePos && node.position) {
	    props['data-sourcepos'] = flattenPosition(node.position);
	  }
	
	  if (opts.rawSourcePos && !isTagRenderer) {
	    props.sourcePosition = node.position;
	  }
	
	  // If `includeNodeIndex` is true, pass node index info to all non-tag renderers
	  if (opts.includeNodeIndex && parent.node && parent.node.children && !isTagRenderer) {
	    props.index = parent.node.children.indexOf(node);
	    props.parentChildCount = parent.node.children.length;
	  }
	
	  var ref = node.identifier !== null && node.identifier !== undefined ? opts.definitions[node.identifier] || {} : null;
	
	  switch (node.type) {
	    case 'root':
	      assignDefined(props, { className: opts.className });
	      break;
	    case 'heading':
	      props.level = node.depth;
	      break;
	    case 'list':
	      props.start = node.start;
	      props.ordered = node.ordered;
	      props.tight = !node.loose;
	      props.depth = node.depth;
	      break;
	    case 'listItem':
	      props.checked = node.checked;
	      props.tight = !node.loose;
	      props.ordered = node.ordered;
	      props.index = node.index;
	      props.children = (props.tight ? unwrapParagraphs(node) : node.children).map(function (childNode, i) {
	        return astToReact(childNode, opts, { node: node, props: props }, i);
	      });
	      break;
	    case 'definition':
	      assignDefined(props, { identifier: node.identifier, title: node.title, url: node.url });
	      break;
	    case 'code':
	      assignDefined(props, { language: node.lang && node.lang.split(/\s/, 1)[0] });
	      break;
	    case 'inlineCode':
	      props.children = node.value;
	      props.inline = true;
	      break;
	    case 'link':
	      assignDefined(props, {
	        title: node.title || undefined,
	        target: typeof opts.linkTarget === 'function' ? opts.linkTarget(node.url, node.children, node.title) : opts.linkTarget,
	        href: opts.transformLinkUri ? opts.transformLinkUri(node.url, node.children, node.title) : node.url
	      });
	      break;
	    case 'image':
	      assignDefined(props, {
	        alt: node.alt || undefined,
	        title: node.title || undefined,
	        src: opts.transformImageUri ? opts.transformImageUri(node.url, node.children, node.title, node.alt) : node.url
	      });
	      break;
	    case 'linkReference':
	      assignDefined(props, xtend(ref, {
	        href: opts.transformLinkUri ? opts.transformLinkUri(ref.href) : ref.href
	      }));
	      break;
	    case 'imageReference':
	      assignDefined(props, {
	        src: opts.transformImageUri && ref.href ? opts.transformImageUri(ref.href, node.children, ref.title, node.alt) : ref.href,
	        title: ref.title || undefined,
	        alt: node.alt || undefined
	      });
	      break;
	    case 'table':
	    case 'tableHead':
	    case 'tableBody':
	      props.columnAlignment = node.align;
	      break;
	    case 'tableRow':
	      props.isHeader = parent.node.type === 'tableHead';
	      props.columnAlignment = parent.props.columnAlignment;
	      break;
	    case 'tableCell':
	      assignDefined(props, {
	        isHeader: parent.props.isHeader,
	        align: parent.props.columnAlignment[index]
	      });
	      break;
	    case 'virtualHtml':
	      props.tag = node.tag;
	      break;
	    case 'html':
	      // @todo find a better way than this
	      props.isBlock = node.position.start.line !== node.position.end.line;
	      props.escapeHtml = opts.escapeHtml;
	      props.skipHtml = opts.skipHtml;
	      break;
	    default:
	      assignDefined(props, xtend(node, {
	        type: undefined,
	        position: undefined,
	        children: undefined
	      }));
	  }
	
	  if (!isTagRenderer && node.value) {
	    props.value = node.value;
	  }
	
	  return props;
	}
	
	function assignDefined(target, attrs) {
	  for (var key in attrs) {
	    if (typeof attrs[key] !== 'undefined') {
	      target[key] = attrs[key];
	    }
	  }
	}
	
	function flattenPosition(pos) {
	  return [pos.start.line, ':', pos.start.column, '-', pos.end.line, ':', pos.end.column].map(String).join('');
	}
	
	function unwrapParagraphs(node) {
	  return node.children.reduce(function (array, child) {
	    return array.concat(child.type === 'paragraph' ? child.children || [] : [child]);
	  }, []);
	}
	
	module.exports = astToReact;

/***/ },
/* 1313 */
/***/ function(module, exports) {

	'use strict';
	
	module.exports = function getDefinitions(node) {
	  var defs = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	  return (node.children || []).reduce(function (definitions, child) {
	    if (child.type === 'definition') {
	      definitions[child.identifier] = {
	        href: child.url,
	        title: child.title
	      };
	    }
	
	    return getDefinitions(child, definitions);
	  }, defs);
	};

/***/ },
/* 1314 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var visit = __webpack_require__(215);
	
	exports.ofType = function (types, mode) {
	  return function (node) {
	    types.forEach(function (type) {
	      return visit(node, type, disallow, true);
	    });
	    return node;
	  };
	
	  function disallow(node, index, parent) {
	    if (parent) {
	      untangle(node, index, parent, mode);
	    }
	  }
	};
	
	exports.ifNotMatch = function (allowNode, mode) {
	  return function (node) {
	    visit(node, disallow, true);
	    return node;
	  };
	
	  function disallow(node, index, parent) {
	    if (parent && !allowNode(node, index, parent)) {
	      untangle(node, index, parent, mode);
	    }
	  }
	};
	
	function untangle(node, index, parent, mode) {
	  if (mode === 'remove') {
	    parent.children.splice(index, 1);
	  } else if (mode === 'unwrap') {
	    var args = [index, 1];
	
	    if (node.children) {
	      args = args.concat(node.children);
	    }
	
	    Array.prototype.splice.apply(parent.children, args);
	  }
	}

/***/ },
/* 1315 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Naive, simple plugin to match inline nodes without attributes
	 * This allows say <strong>foo</strong>, but not <strong class="very">foo</strong>
	 * For proper HTML support, you'll want a different plugin
	 **/
	var visit = __webpack_require__(215);
	
	var type = 'virtualHtml';
	var selfClosingRe = /^<(area|base|br|col|embed|hr|img|input|keygen|link|meta|param|source|track|wbr)\s*\/?>$/i;
	var simpleTagRe = /^<(\/?)([a-z]+)\s*>$/;
	
	module.exports = function (tree) {
	  var open = void 0;
	  var currentParent = void 0;
	  visit(tree, 'html', function (node, index, parent) {
	    if (currentParent !== parent) {
	      open = [];
	      currentParent = parent;
	    }
	
	    var selfClosing = getSelfClosing(node);
	    if (selfClosing) {
	      parent.children.splice(index, 1, {
	        type: type,
	        tag: selfClosing,
	        position: node.position
	      });
	      return true;
	    }
	
	    var current = getSimpleTag(node, parent);
	    if (!current) {
	      return true;
	    }
	
	    var matching = findAndPull(open, current.tag);
	
	    if (matching) {
	      parent.children.splice(index, 0, virtual(current, matching, parent));
	    } else if (!current.opening) {
	      open.push(current);
	    }
	
	    return true;
	  }, true // Iterate in reverse
	  );
	
	  return tree;
	};
	
	function findAndPull(open, matchingTag) {
	  var i = open.length;
	  while (i--) {
	    if (open[i].tag === matchingTag) {
	      return open.splice(i, 1)[0];
	    }
	  }
	
	  return false;
	}
	
	function getSimpleTag(node, parent) {
	  var match = node.value.match(simpleTagRe);
	  return match ? { tag: match[2], opening: !match[1], node: node } : false;
	}
	
	function getSelfClosing(node) {
	  var match = node.value.match(selfClosingRe);
	  return match ? match[1] : false;
	}
	
	function virtual(fromNode, toNode, parent) {
	  var fromIndex = parent.children.indexOf(fromNode.node);
	  var toIndex = parent.children.indexOf(toNode.node);
	
	  var extracted = parent.children.splice(fromIndex, toIndex - fromIndex + 1);
	  var children = extracted.slice(1, -1);
	  return {
	    type: type,
	    children: children,
	    tag: fromNode.tag,
	    position: {
	      start: fromNode.node.position.start,
	      end: toNode.node.position.end,
	      indent: []
	    }
	  };
	}

/***/ },
/* 1316 */
/***/ function(module, exports, __webpack_require__) {

	/* eslint-disable react/prop-types, react/no-multi-comp */
	'use strict';
	
	var xtend = __webpack_require__(79);
	var React = __webpack_require__(1);
	var createElement = React.createElement;
	
	module.exports = {
	  root: 'div',
	  break: 'br',
	  paragraph: 'p',
	  emphasis: 'em',
	  strong: 'strong',
	  thematicBreak: 'hr',
	  blockquote: 'blockquote',
	  delete: 'del',
	  link: 'a',
	  image: 'img',
	  linkReference: 'a',
	  imageReference: 'img',
	  table: SimpleRenderer.bind(null, 'table'),
	  tableHead: SimpleRenderer.bind(null, 'thead'),
	  tableBody: SimpleRenderer.bind(null, 'tbody'),
	  tableRow: SimpleRenderer.bind(null, 'tr'),
	  tableCell: TableCell,
	
	  list: List,
	  listItem: ListItem,
	  definition: NullRenderer,
	  heading: Heading,
	  inlineCode: InlineCode,
	  code: CodeBlock,
	  html: Html,
	  virtualHtml: VirtualHtml
	};
	
	function SimpleRenderer(tag, props) {
	  return createElement(tag, getCoreProps(props), props.children);
	}
	
	function TableCell(props) {
	  var style = props.align ? { textAlign: props.align } : undefined;
	  var coreProps = getCoreProps(props);
	  return createElement(props.isHeader ? 'th' : 'td', style ? xtend({ style: style }, coreProps) : coreProps, props.children);
	}
	
	function Heading(props) {
	  return createElement('h' + props.level, getCoreProps(props), props.children);
	}
	
	function List(props) {
	  var attrs = getCoreProps(props);
	  if (props.start !== null && props.start !== 1) {
	    attrs.start = props.start.toString();
	  }
	
	  return createElement(props.ordered ? 'ol' : 'ul', attrs, props.children);
	}
	
	function ListItem(props) {
	  var checkbox = null;
	  if (props.checked !== null) {
	    var checked = props.checked;
	    checkbox = createElement('input', { type: 'checkbox', checked: checked, readOnly: true });
	  }
	
	  return createElement('li', getCoreProps(props), checkbox, props.children);
	}
	
	function CodeBlock(props) {
	  var className = props.language && 'language-' + props.language;
	  var code = createElement('code', className ? { className: className } : null, props.value);
	  return createElement('pre', getCoreProps(props), code);
	}
	
	function InlineCode(props) {
	  return createElement('code', getCoreProps(props), props.children);
	}
	
	function Html(props) {
	  if (props.skipHtml) {
	    return null;
	  }
	
	  var tag = props.isBlock ? 'div' : 'span';
	  if (props.escapeHtml) {
	    // @todo when fiber lands, we can simply render props.value
	    return createElement(tag, null, props.value);
	  }
	
	  var nodeProps = { dangerouslySetInnerHTML: { __html: props.value } };
	  return createElement(tag, nodeProps);
	}
	
	function VirtualHtml(props) {
	  return createElement(props.tag, getCoreProps(props), props.children);
	}
	
	function NullRenderer() {
	  return null;
	}
	
	function getCoreProps(props) {
	  return props['data-sourcepos'] ? { 'data-sourcepos': props['data-sourcepos'] } : {};
	}

/***/ },
/* 1317 */
/***/ function(module, exports) {

	'use strict';
	
	var protocols = ['http', 'https', 'mailto', 'tel'];
	
	module.exports = function uriTransformer(uri) {
	  var url = (uri || '').trim();
	  var first = url.charAt(0);
	
	  if (first === '#' || first === '/') {
	    return url;
	  }
	
	  var colon = url.indexOf(':');
	  if (colon === -1) {
	    return url;
	  }
	
	  var length = protocols.length;
	  var index = -1;
	
	  while (++index < length) {
	    var protocol = protocols[index];
	
	    if (colon === protocol.length && url.slice(0, protocol.length) === protocol) {
	      return url;
	    }
	  }
	
	  index = url.indexOf('?');
	  if (index !== -1 && colon > index) {
	    return url;
	  }
	
	  index = url.indexOf('#');
	  if (index !== -1 && colon > index) {
	    return url;
	  }
	
	  // eslint-disable-next-line no-script-url
	  return 'javascript:void(0)';
	};

/***/ },
/* 1318 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var visit = __webpack_require__(215);
	
	module.exports = function (node) {
	  visit(node, 'table', wrap);
	  return node;
	};
	
	function wrap(table) {
	  var children = table.children;
	  table.children = [{
	    type: 'tableHead',
	    align: table.align,
	    children: [children[0]],
	    position: children[0].position
	  }];
	  if (children.length > 1) {
	    table.children.push({
	      type: 'tableBody',
	      align: table.align,
	      children: children.slice(1),
	      position: {
	        start: children[1].position.start,
	        end: children[children.length - 1].position.end
	      }
	    });
	  }
	}

/***/ },
/* 1319 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = generateOutsideCheck;
	/**
	 * Check whether some DOM node is our Component's node.
	 */
	function isNodeFound(current, componentNode, ignoreClass) {
	  if (current === componentNode) {
	    return true;
	  }
	  // SVG <use/> elements do not technically reside in the rendered DOM, so
	  // they do not have classList directly, but they offer a link to their
	  // corresponding element, which can have classList. This extra check is for
	  // that case.
	  // See: http://www.w3.org/TR/SVG11/struct.html#InterfaceSVGUseElement
	  // Discussion: https://github.com/Pomax/react-onclickoutside/pull/17
	  if (current.correspondingElement) {
	    return current.correspondingElement.classList.contains(ignoreClass);
	  }
	  return current.classList.contains(ignoreClass);
	}
	
	/**
	 * Try to find our node in a hierarchy of nodes, returning the document
	 * node as highest node if our node is not found in the path up.
	 */
	function findHighest(current, componentNode, ignoreClass) {
	  if (current === componentNode) {
	    return true;
	  }
	
	  // If source=local then this event came from 'somewhere'
	  // inside and should be ignored. We could handle this with
	  // a layered approach, too, but that requires going back to
	  // thinking in terms of Dom node nesting, running counter
	  // to React's 'you shouldn't care about the DOM' philosophy.
	  while (current.parentNode) {
	    if (isNodeFound(current, componentNode, ignoreClass)) {
	      return true;
	    }
	    current = current.parentNode;
	  }
	  return current;
	}
	
	/**
	 * Check if the browser scrollbar was clicked
	 */
	function clickedScrollbar(evt) {
	  return document.documentElement.clientWidth <= evt.clientX || document.documentElement.clientHeight <= evt.clientY;
	}
	
	/**
	 * Generate the event handler that checks whether a clicked DOM node
	 * is inside of, or lives outside of, our Component's node tree.
	 */
	function generateOutsideCheck(componentNode, eventHandler, ignoreClass, excludeScrollbar, preventDefault, stopPropagation) {
	  return function (evt) {
	    if (preventDefault) {
	      evt.preventDefault();
	    }
	    if (stopPropagation) {
	      evt.stopPropagation();
	    }
	    var current = evt.target;
	    if (excludeScrollbar && clickedScrollbar(evt) || findHighest(current, componentNode, ignoreClass) !== document) {
	      return;
	    }
	    eventHandler(evt);
	  };
	}

/***/ },
/* 1320 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(106);
	
	var _interopRequireDefault = __webpack_require__(37);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = Popper;
	exports.placements = exports.InnerPopper = void 0;
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(157));
	
	var _extends2 = _interopRequireDefault(__webpack_require__(125));
	
	var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(217));
	
	var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(156));
	
	var _defineProperty2 = _interopRequireDefault(__webpack_require__(218));
	
	var _deepEqual = _interopRequireDefault(__webpack_require__(65));
	
	var React = _interopRequireWildcard(__webpack_require__(1));
	
	var _popper = _interopRequireDefault(__webpack_require__(1284));
	
	var _Manager = __webpack_require__(316);
	
	var _utils = __webpack_require__(511);
	
	var initialStyle = {
	  position: 'absolute',
	  top: 0,
	  left: 0,
	  opacity: 0,
	  pointerEvents: 'none'
	};
	var initialArrowStyle = {};
	
	var InnerPopper =
	/*#__PURE__*/
	function (_React$Component) {
	  (0, _inheritsLoose2.default)(InnerPopper, _React$Component);
	
	  function InnerPopper() {
	    var _this;
	
	    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "state", {
	      data: undefined,
	      placement: undefined
	    });
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "popperInstance", void 0);
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "popperNode", null);
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "arrowNode", null);
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "setPopperNode", function (popperNode) {
	      if (!popperNode || _this.popperNode === popperNode) return;
	      (0, _utils.setRef)(_this.props.innerRef, popperNode);
	      _this.popperNode = popperNode;
	
	      _this.updatePopperInstance();
	    });
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "setArrowNode", function (arrowNode) {
	      _this.arrowNode = arrowNode;
	    });
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "updateStateModifier", {
	      enabled: true,
	      order: 900,
	      fn: function fn(data) {
	        var placement = data.placement;
	
	        _this.setState({
	          data: data,
	          placement: placement
	        });
	
	        return data;
	      }
	    });
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "getOptions", function () {
	      return {
	        placement: _this.props.placement,
	        eventsEnabled: _this.props.eventsEnabled,
	        positionFixed: _this.props.positionFixed,
	        modifiers: (0, _extends2.default)({}, _this.props.modifiers, {
	          arrow: (0, _extends2.default)({}, _this.props.modifiers && _this.props.modifiers.arrow, {
	            enabled: !!_this.arrowNode,
	            element: _this.arrowNode
	          }),
	          applyStyle: {
	            enabled: false
	          },
	          updateStateModifier: _this.updateStateModifier
	        })
	      };
	    });
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "getPopperStyle", function () {
	      return !_this.popperNode || !_this.state.data ? initialStyle : (0, _extends2.default)({
	        position: _this.state.data.offsets.popper.position
	      }, _this.state.data.styles);
	    });
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "getPopperPlacement", function () {
	      return !_this.state.data ? undefined : _this.state.placement;
	    });
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "getArrowStyle", function () {
	      return !_this.arrowNode || !_this.state.data ? initialArrowStyle : _this.state.data.arrowStyles;
	    });
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "getOutOfBoundariesState", function () {
	      return _this.state.data ? _this.state.data.hide : undefined;
	    });
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "destroyPopperInstance", function () {
	      if (!_this.popperInstance) return;
	
	      _this.popperInstance.destroy();
	
	      _this.popperInstance = null;
	    });
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "updatePopperInstance", function () {
	      _this.destroyPopperInstance();
	
	      var _assertThisInitialize = (0, _assertThisInitialized2.default)(_this),
	          popperNode = _assertThisInitialize.popperNode;
	
	      var referenceElement = _this.props.referenceElement;
	      if (!referenceElement || !popperNode) return;
	      _this.popperInstance = new _popper.default(referenceElement, popperNode, _this.getOptions());
	    });
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "scheduleUpdate", function () {
	      if (_this.popperInstance) {
	        _this.popperInstance.scheduleUpdate();
	      }
	    });
	    return _this;
	  }
	
	  var _proto = InnerPopper.prototype;
	
	  _proto.componentDidUpdate = function componentDidUpdate(prevProps, prevState) {
	    // If the Popper.js options have changed, update the instance (destroy + create)
	    if (this.props.placement !== prevProps.placement || this.props.referenceElement !== prevProps.referenceElement || this.props.positionFixed !== prevProps.positionFixed || !(0, _deepEqual.default)(this.props.modifiers, prevProps.modifiers, {
	      strict: true
	    })) {
	      // develop only check that modifiers isn't being updated needlessly
	      if (false) {
	        if (this.props.modifiers !== prevProps.modifiers && this.props.modifiers != null && prevProps.modifiers != null && (0, _utils.shallowEqual)(this.props.modifiers, prevProps.modifiers)) {
	          console.warn("'modifiers' prop reference updated even though all values appear the same.\nConsider memoizing the 'modifiers' object to avoid needless rendering.");
	        }
	      }
	
	      this.updatePopperInstance();
	    } else if (this.props.eventsEnabled !== prevProps.eventsEnabled && this.popperInstance) {
	      this.props.eventsEnabled ? this.popperInstance.enableEventListeners() : this.popperInstance.disableEventListeners();
	    } // A placement difference in state means popper determined a new placement
	    // apart from the props value. By the time the popper element is rendered with
	    // the new position Popper has already measured it, if the place change triggers
	    // a size change it will result in a misaligned popper. So we schedule an update to be sure.
	
	
	    if (prevState.placement !== this.state.placement) {
	      this.scheduleUpdate();
	    }
	  };
	
	  _proto.componentWillUnmount = function componentWillUnmount() {
	    (0, _utils.setRef)(this.props.innerRef, null);
	    this.destroyPopperInstance();
	  };
	
	  _proto.render = function render() {
	    return (0, _utils.unwrapArray)(this.props.children)({
	      ref: this.setPopperNode,
	      style: this.getPopperStyle(),
	      placement: this.getPopperPlacement(),
	      outOfBoundaries: this.getOutOfBoundariesState(),
	      scheduleUpdate: this.scheduleUpdate,
	      arrowProps: {
	        ref: this.setArrowNode,
	        style: this.getArrowStyle()
	      }
	    });
	  };
	
	  return InnerPopper;
	}(React.Component);
	
	exports.InnerPopper = InnerPopper;
	(0, _defineProperty2.default)(InnerPopper, "defaultProps", {
	  placement: 'bottom',
	  eventsEnabled: true,
	  referenceElement: undefined,
	  positionFixed: false
	});
	var placements = _popper.default.placements;
	exports.placements = placements;
	
	function Popper(_ref) {
	  var referenceElement = _ref.referenceElement,
	      props = (0, _objectWithoutPropertiesLoose2.default)(_ref, ["referenceElement"]);
	  return React.createElement(_Manager.ManagerReferenceNodeContext.Consumer, null, function (referenceNode) {
	    return React.createElement(InnerPopper, (0, _extends2.default)({
	      referenceElement: referenceElement !== undefined ? referenceElement : referenceNode
	    }, props));
	  });
	}

/***/ },
/* 1321 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(106);
	
	var _interopRequireDefault = __webpack_require__(37);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = Reference;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(125));
	
	var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(217));
	
	var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(156));
	
	var _defineProperty2 = _interopRequireDefault(__webpack_require__(218));
	
	var React = _interopRequireWildcard(__webpack_require__(1));
	
	var _warning = _interopRequireDefault(__webpack_require__(543));
	
	var _Manager = __webpack_require__(316);
	
	var _utils = __webpack_require__(511);
	
	var InnerReference =
	/*#__PURE__*/
	function (_React$Component) {
	  (0, _inheritsLoose2.default)(InnerReference, _React$Component);
	
	  function InnerReference() {
	    var _this;
	
	    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "refHandler", function (node) {
	      (0, _utils.setRef)(_this.props.innerRef, node);
	      (0, _utils.safeInvoke)(_this.props.setReferenceNode, node);
	    });
	    return _this;
	  }
	
	  var _proto = InnerReference.prototype;
	
	  _proto.componentWillUnmount = function componentWillUnmount() {
	    (0, _utils.setRef)(this.props.innerRef, null);
	  };
	
	  _proto.render = function render() {
	    (0, _warning.default)(Boolean(this.props.setReferenceNode), '`Reference` should not be used outside of a `Manager` component.');
	    return (0, _utils.unwrapArray)(this.props.children)({
	      ref: this.refHandler
	    });
	  };
	
	  return InnerReference;
	}(React.Component);
	
	function Reference(props) {
	  return React.createElement(_Manager.ManagerReferenceNodeSetterContext.Consumer, null, function (setReferenceNode) {
	    return React.createElement(InnerReference, (0, _extends2.default)({
	      setReferenceNode: setReferenceNode
	    }, props));
	  });
	}

/***/ },
/* 1322 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(37);
	
	var _interopRequireWildcard = __webpack_require__(106);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "Popper", {
	  enumerable: true,
	  get: function get() {
	    return _Popper.default;
	  }
	});
	Object.defineProperty(exports, "placements", {
	  enumerable: true,
	  get: function get() {
	    return _Popper.placements;
	  }
	});
	Object.defineProperty(exports, "Manager", {
	  enumerable: true,
	  get: function get() {
	    return _Manager.default;
	  }
	});
	Object.defineProperty(exports, "Reference", {
	  enumerable: true,
	  get: function get() {
	    return _Reference.default;
	  }
	});
	
	var _Popper = _interopRequireWildcard(__webpack_require__(1320));
	
	var _Manager = _interopRequireDefault(__webpack_require__(316));
	
	var _Reference = _interopRequireDefault(__webpack_require__(1321));

/***/ },
/* 1323 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(70);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _propTypes = __webpack_require__(20);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // This file is a fallback for a consumer who is not yet on React 16
	// as createPortal was introduced in React 16
	
	var Portal = function (_React$Component) {
	  _inherits(Portal, _React$Component);
	
	  function Portal() {
	    _classCallCheck(this, Portal);
	
	    return _possibleConstructorReturn(this, (Portal.__proto__ || Object.getPrototypeOf(Portal)).apply(this, arguments));
	  }
	
	  _createClass(Portal, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.renderPortal();
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate(props) {
	      this.renderPortal();
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      _reactDom2.default.unmountComponentAtNode(this.defaultNode || this.props.node);
	      if (this.defaultNode) {
	        document.body.removeChild(this.defaultNode);
	      }
	      this.defaultNode = null;
	      this.portal = null;
	    }
	  }, {
	    key: 'renderPortal',
	    value: function renderPortal(props) {
	      if (!this.props.node && !this.defaultNode) {
	        this.defaultNode = document.createElement('div');
	        document.body.appendChild(this.defaultNode);
	      }
	
	      var children = this.props.children;
	      // https://gist.github.com/jimfb/d99e0678e9da715ccf6454961ef04d1b
	      if (typeof this.props.children.type === 'function') {
	        children = _react2.default.cloneElement(this.props.children);
	      }
	
	      this.portal = _reactDom2.default.unstable_renderSubtreeIntoContainer(this, children, this.props.node || this.defaultNode);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return null;
	    }
	  }]);
	
	  return Portal;
	}(_react2.default.Component);
	
	exports.default = Portal;
	
	
	Portal.propTypes = {
	  children: _propTypes2.default.node.isRequired,
	  node: _propTypes2.default.any
	};

/***/ },
/* 1324 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(20);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactDom = __webpack_require__(70);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _utils = __webpack_require__(1327);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Portal = function (_React$Component) {
	  _inherits(Portal, _React$Component);
	
	  function Portal() {
	    _classCallCheck(this, Portal);
	
	    return _possibleConstructorReturn(this, (Portal.__proto__ || Object.getPrototypeOf(Portal)).apply(this, arguments));
	  }
	
	  _createClass(Portal, [{
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      if (this.defaultNode) {
	        document.body.removeChild(this.defaultNode);
	      }
	      this.defaultNode = null;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      if (!_utils.canUseDOM) {
	        return null;
	      }
	      if (!this.props.node && !this.defaultNode) {
	        this.defaultNode = document.createElement('div');
	        document.body.appendChild(this.defaultNode);
	      }
	      return _reactDom2.default.createPortal(this.props.children, this.props.node || this.defaultNode);
	    }
	  }]);
	
	  return Portal;
	}(_react2.default.Component);
	
	Portal.propTypes = {
	  children: _propTypes2.default.node.isRequired,
	  node: _propTypes2.default.any
	};
	
	exports.default = Portal;

/***/ },
/* 1325 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(20);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _PortalCompat = __webpack_require__(512);
	
	var _PortalCompat2 = _interopRequireDefault(_PortalCompat);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var KEYCODES = {
	  ESCAPE: 27
	};
	
	var PortalWithState = function (_React$Component) {
	  _inherits(PortalWithState, _React$Component);
	
	  function PortalWithState(props) {
	    _classCallCheck(this, PortalWithState);
	
	    var _this = _possibleConstructorReturn(this, (PortalWithState.__proto__ || Object.getPrototypeOf(PortalWithState)).call(this, props));
	
	    _this.portalNode = null;
	    _this.state = { active: !!props.defaultOpen };
	    _this.openPortal = _this.openPortal.bind(_this);
	    _this.closePortal = _this.closePortal.bind(_this);
	    _this.wrapWithPortal = _this.wrapWithPortal.bind(_this);
	    _this.handleOutsideMouseClick = _this.handleOutsideMouseClick.bind(_this);
	    _this.handleKeydown = _this.handleKeydown.bind(_this);
	    return _this;
	  }
	
	  _createClass(PortalWithState, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      if (this.props.closeOnEsc) {
	        document.addEventListener('keydown', this.handleKeydown);
	      }
	      if (this.props.closeOnOutsideClick) {
	        document.addEventListener('click', this.handleOutsideMouseClick);
	      }
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      if (this.props.closeOnEsc) {
	        document.removeEventListener('keydown', this.handleKeydown);
	      }
	      if (this.props.closeOnOutsideClick) {
	        document.removeEventListener('click', this.handleOutsideMouseClick);
	      }
	    }
	  }, {
	    key: 'openPortal',
	    value: function openPortal(e) {
	      if (this.state.active) {
	        return;
	      }
	      if (e && e.nativeEvent) {
	        e.nativeEvent.stopImmediatePropagation();
	      }
	      this.setState({ active: true }, this.props.onOpen);
	    }
	  }, {
	    key: 'closePortal',
	    value: function closePortal() {
	      if (!this.state.active) {
	        return;
	      }
	      this.setState({ active: false }, this.props.onClose);
	    }
	  }, {
	    key: 'wrapWithPortal',
	    value: function wrapWithPortal(children) {
	      var _this2 = this;
	
	      if (!this.state.active) {
	        return null;
	      }
	      return _react2.default.createElement(
	        _PortalCompat2.default,
	        {
	          node: this.props.node,
	          key: 'react-portal',
	          ref: function ref(portalNode) {
	            return _this2.portalNode = portalNode;
	          }
	        },
	        children
	      );
	    }
	  }, {
	    key: 'handleOutsideMouseClick',
	    value: function handleOutsideMouseClick(e) {
	      if (!this.state.active) {
	        return;
	      }
	      var root = this.portalNode && (this.portalNode.props.node || this.portalNode.defaultNode);
	      if (!root || root.contains(e.target) || e.button && e.button !== 0) {
	        return;
	      }
	      this.closePortal();
	    }
	  }, {
	    key: 'handleKeydown',
	    value: function handleKeydown(e) {
	      if (e.keyCode === KEYCODES.ESCAPE && this.state.active) {
	        this.closePortal();
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return this.props.children({
	        openPortal: this.openPortal,
	        closePortal: this.closePortal,
	        portal: this.wrapWithPortal,
	        isOpen: this.state.active
	      });
	    }
	  }]);
	
	  return PortalWithState;
	}(_react2.default.Component);
	
	PortalWithState.propTypes = {
	  children: _propTypes2.default.func.isRequired,
	  defaultOpen: _propTypes2.default.bool,
	  node: _propTypes2.default.any,
	  closeOnEsc: _propTypes2.default.bool,
	  closeOnOutsideClick: _propTypes2.default.bool,
	  onOpen: _propTypes2.default.func,
	  onClose: _propTypes2.default.func
	};
	
	PortalWithState.defaultProps = {
	  onOpen: function onOpen() {},
	  onClose: function onClose() {}
	};
	
	exports.default = PortalWithState;

/***/ },
/* 1326 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.PortalWithState = exports.Portal = undefined;
	
	var _PortalCompat = __webpack_require__(512);
	
	var _PortalCompat2 = _interopRequireDefault(_PortalCompat);
	
	var _PortalWithState = __webpack_require__(1325);
	
	var _PortalWithState2 = _interopRequireDefault(_PortalWithState);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.Portal = _PortalCompat2.default;
	exports.PortalWithState = _PortalWithState2.default;

/***/ },
/* 1327 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var canUseDOM = exports.canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);

/***/ },
/* 1328 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _d3Ease = __webpack_require__(890);
	
	var ease = _interopRequireWildcard(_d3Ease);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	exports.default = {
	  linear: ease.easeLinear,
	  quad: ease.easeQuad,
	  quadIn: ease.easeQuadIn,
	  quadOut: ease.easeQuadOut,
	  quadInOut: ease.easeQuadInOut,
	  cubic: ease.easeCubic,
	  cubicIn: ease.easeCubicIn,
	  cubicOut: ease.easeCubicOut,
	  cubicInOut: ease.easeCubicInOut,
	  poly: ease.easePoly,
	  polyIn: ease.easePolyIn,
	  polyOut: ease.easePolyOut,
	  polyInOut: ease.easePolyInOut,
	  sin: ease.easeSin,
	  sinIn: ease.easeSinIn,
	  sinOut: ease.easeSinOut,
	  sinInOut: ease.easeSinInOut,
	  exp: ease.easeExp,
	  expIn: ease.easeExpIn,
	  expOut: ease.easeExpOut,
	  expInOut: ease.easeExpInOut,
	  circle: ease.easeCircle,
	  circleIn: ease.easeCircleIn,
	  circleOut: ease.easeCircleOut,
	  circleInOut: ease.easeCircleInOut,
	  bounce: ease.easeBounce,
	  bounceIn: ease.easeBounceIn,
	  bounceOut: ease.easeBounceOut,
	  bounceInOut: ease.easeBounceInOut,
	  back: ease.easeBack,
	  backIn: ease.easeBackIn,
	  backOut: ease.easeBackOut,
	  backInOut: ease.easeBackInOut,
	  elastic: ease.easeElastic,
	  elasticIn: ease.easeElasticIn,
	  elasticOut: ease.easeElasticOut,
	  elasticInOut: ease.easeElasticInOut
	};
	//# sourceMappingURL=easing.js.map

/***/ },
/* 1329 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _propTypes = __webpack_require__(20);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var Radio = (function (_React$Component) {
	  _inherits(Radio, _React$Component);
	
	  function Radio() {
	    _classCallCheck(this, Radio);
	
	    _get(Object.getPrototypeOf(Radio.prototype), 'constructor', this).apply(this, arguments);
	  }
	
	  _createClass(Radio, [{
	    key: 'render',
	    value: function render() {
	      var _context$radioGroup = this.context.radioGroup;
	      var name = _context$radioGroup.name;
	      var selectedValue = _context$radioGroup.selectedValue;
	      var onChange = _context$radioGroup.onChange;
	
	      var optional = {};
	      if (selectedValue !== undefined) {
	        optional.checked = this.props.value === selectedValue;
	      }
	      if (typeof onChange === 'function') {
	        optional.onChange = onChange.bind(null, this.props.value);
	      }
	
	      return _react2['default'].createElement('input', _extends({}, this.props, {
	        type: 'radio',
	        name: name
	      }, optional));
	    }
	  }]);
	
	  return Radio;
	})(_react2['default'].Component);
	
	exports.Radio = Radio;
	;
	
	Radio.contextTypes = {
	  radioGroup: _propTypes2['default'].object
	};
	
	var RadioGroup = (function (_React$Component2) {
	  _inherits(RadioGroup, _React$Component2);
	
	  function RadioGroup() {
	    _classCallCheck(this, RadioGroup);
	
	    _get(Object.getPrototypeOf(RadioGroup.prototype), 'constructor', this).apply(this, arguments);
	  }
	
	  _createClass(RadioGroup, [{
	    key: 'getChildContext',
	    value: function getChildContext() {
	      var _props = this.props;
	      var name = _props.name;
	      var selectedValue = _props.selectedValue;
	      var onChange = _props.onChange;
	
	      return {
	        radioGroup: {
	          name: name, selectedValue: selectedValue, onChange: onChange
	        }
	      };
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props2 = this.props;
	      var Component = _props2.Component;
	      var name = _props2.name;
	      var selectedValue = _props2.selectedValue;
	      var onChange = _props2.onChange;
	      var children = _props2.children;
	
	      var rest = _objectWithoutProperties(_props2, ['Component', 'name', 'selectedValue', 'onChange', 'children']);
	
	      return _react2['default'].createElement(
	        Component,
	        rest,
	        children
	      );
	    }
	  }]);
	
	  return RadioGroup;
	})(_react2['default'].Component);
	
	exports.RadioGroup = RadioGroup;
	;
	
	RadioGroup.defaultProps = {
	  Component: "div"
	};
	
	RadioGroup.propTypes = {
	  name: _propTypes2['default'].string,
	  selectedValue: _propTypes2['default'].oneOfType([_propTypes2['default'].string, _propTypes2['default'].number, _propTypes2['default'].bool]),
	  onChange: _propTypes2['default'].func,
	  children: _propTypes2['default'].node.isRequired,
	  Component: _propTypes2['default'].oneOfType([_propTypes2['default'].string, _propTypes2['default'].func, _propTypes2['default'].object])
	};
	
	RadioGroup.childContextTypes = {
	  radioGroup: _propTypes2['default'].object
	};

/***/ },
/* 1330 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(37);
	
	var _interopRequireWildcard = __webpack_require__(106);
	
	exports.__esModule = true;
	exports["default"] = void 0;
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(20));
	
	var _Context = __webpack_require__(104);
	
	var _Subscription = _interopRequireDefault(__webpack_require__(318));
	
	function Provider(_ref) {
	  var store = _ref.store,
	      context = _ref.context,
	      children = _ref.children;
	  var contextValue = (0, _react.useMemo)(function () {
	    var subscription = new _Subscription["default"](store);
	    subscription.onStateChange = subscription.notifyNestedSubs;
	    return {
	      store: store,
	      subscription: subscription
	    };
	  }, [store]);
	  var previousState = (0, _react.useMemo)(function () {
	    return store.getState();
	  }, [store]);
	  (0, _react.useEffect)(function () {
	    var subscription = contextValue.subscription;
	    subscription.trySubscribe();
	
	    if (previousState !== store.getState()) {
	      subscription.notifyNestedSubs();
	    }
	
	    return function () {
	      subscription.tryUnsubscribe();
	      subscription.onStateChange = null;
	    };
	  }, [contextValue, previousState]);
	  var Context = context || _Context.ReactReduxContext;
	  return /*#__PURE__*/_react["default"].createElement(Context.Provider, {
	    value: contextValue
	  }, children);
	}
	
	if (false) {
	  Provider.propTypes = {
	    store: _propTypes["default"].shape({
	      subscribe: _propTypes["default"].func.isRequired,
	      dispatch: _propTypes["default"].func.isRequired,
	      getState: _propTypes["default"].func.isRequired
	    }),
	    context: _propTypes["default"].object,
	    children: _propTypes["default"].any
	  };
	}
	
	var _default = Provider;
	exports["default"] = _default;

/***/ },
/* 1331 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(37);
	
	exports.__esModule = true;
	exports.createConnect = createConnect;
	exports["default"] = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(125));
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(157));
	
	var _connectAdvanced = _interopRequireDefault(__webpack_require__(513));
	
	var _shallowEqual = _interopRequireDefault(__webpack_require__(518));
	
	var _mapDispatchToProps = _interopRequireDefault(__webpack_require__(1332));
	
	var _mapStateToProps = _interopRequireDefault(__webpack_require__(1333));
	
	var _mergeProps = _interopRequireDefault(__webpack_require__(1334));
	
	var _selectorFactory = _interopRequireDefault(__webpack_require__(1335));
	
	/*
	  connect is a facade over connectAdvanced. It turns its args into a compatible
	  selectorFactory, which has the signature:
	
	    (dispatch, options) => (nextState, nextOwnProps) => nextFinalProps
	  
	  connect passes its args to connectAdvanced as options, which will in turn pass them to
	  selectorFactory each time a Connect component instance is instantiated or hot reloaded.
	
	  selectorFactory returns a final props selector from its mapStateToProps,
	  mapStateToPropsFactories, mapDispatchToProps, mapDispatchToPropsFactories, mergeProps,
	  mergePropsFactories, and pure args.
	
	  The resulting final props selector is called by the Connect component instance whenever
	  it receives new props or store state.
	 */
	function match(arg, factories, name) {
	  for (var i = factories.length - 1; i >= 0; i--) {
	    var result = factories[i](arg);
	    if (result) return result;
	  }
	
	  return function (dispatch, options) {
	    throw new Error("Invalid value of type " + typeof arg + " for " + name + " argument when connecting component " + options.wrappedComponentName + ".");
	  };
	}
	
	function strictEqual(a, b) {
	  return a === b;
	} // createConnect with default args builds the 'official' connect behavior. Calling it with
	// different options opens up some testing and extensibility scenarios
	
	
	function createConnect(_temp) {
	  var _ref = _temp === void 0 ? {} : _temp,
	      _ref$connectHOC = _ref.connectHOC,
	      connectHOC = _ref$connectHOC === void 0 ? _connectAdvanced["default"] : _ref$connectHOC,
	      _ref$mapStateToPropsF = _ref.mapStateToPropsFactories,
	      mapStateToPropsFactories = _ref$mapStateToPropsF === void 0 ? _mapStateToProps["default"] : _ref$mapStateToPropsF,
	      _ref$mapDispatchToPro = _ref.mapDispatchToPropsFactories,
	      mapDispatchToPropsFactories = _ref$mapDispatchToPro === void 0 ? _mapDispatchToProps["default"] : _ref$mapDispatchToPro,
	      _ref$mergePropsFactor = _ref.mergePropsFactories,
	      mergePropsFactories = _ref$mergePropsFactor === void 0 ? _mergeProps["default"] : _ref$mergePropsFactor,
	      _ref$selectorFactory = _ref.selectorFactory,
	      selectorFactory = _ref$selectorFactory === void 0 ? _selectorFactory["default"] : _ref$selectorFactory;
	
	  return function connect(mapStateToProps, mapDispatchToProps, mergeProps, _ref2) {
	    if (_ref2 === void 0) {
	      _ref2 = {};
	    }
	
	    var _ref3 = _ref2,
	        _ref3$pure = _ref3.pure,
	        pure = _ref3$pure === void 0 ? true : _ref3$pure,
	        _ref3$areStatesEqual = _ref3.areStatesEqual,
	        areStatesEqual = _ref3$areStatesEqual === void 0 ? strictEqual : _ref3$areStatesEqual,
	        _ref3$areOwnPropsEqua = _ref3.areOwnPropsEqual,
	        areOwnPropsEqual = _ref3$areOwnPropsEqua === void 0 ? _shallowEqual["default"] : _ref3$areOwnPropsEqua,
	        _ref3$areStatePropsEq = _ref3.areStatePropsEqual,
	        areStatePropsEqual = _ref3$areStatePropsEq === void 0 ? _shallowEqual["default"] : _ref3$areStatePropsEq,
	        _ref3$areMergedPropsE = _ref3.areMergedPropsEqual,
	        areMergedPropsEqual = _ref3$areMergedPropsE === void 0 ? _shallowEqual["default"] : _ref3$areMergedPropsE,
	        extraOptions = (0, _objectWithoutPropertiesLoose2["default"])(_ref3, ["pure", "areStatesEqual", "areOwnPropsEqual", "areStatePropsEqual", "areMergedPropsEqual"]);
	    var initMapStateToProps = match(mapStateToProps, mapStateToPropsFactories, 'mapStateToProps');
	    var initMapDispatchToProps = match(mapDispatchToProps, mapDispatchToPropsFactories, 'mapDispatchToProps');
	    var initMergeProps = match(mergeProps, mergePropsFactories, 'mergeProps');
	    return connectHOC(selectorFactory, (0, _extends2["default"])({
	      // used in error messages
	      methodName: 'connect',
	      // used to compute Connect's displayName from the wrapped component's displayName.
	      getDisplayName: function getDisplayName(name) {
	        return "Connect(" + name + ")";
	      },
	      // if mapStateToProps is falsy, the Connect component doesn't subscribe to store state changes
	      shouldHandleStateChanges: Boolean(mapStateToProps),
	      // passed through to selectorFactory
	      initMapStateToProps: initMapStateToProps,
	      initMapDispatchToProps: initMapDispatchToProps,
	      initMergeProps: initMergeProps,
	      pure: pure,
	      areStatesEqual: areStatesEqual,
	      areOwnPropsEqual: areOwnPropsEqual,
	      areStatePropsEqual: areStatePropsEqual,
	      areMergedPropsEqual: areMergedPropsEqual
	    }, extraOptions));
	  };
	}
	
	var _default = /*#__PURE__*/createConnect();
	
	exports["default"] = _default;

/***/ },
/* 1332 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.whenMapDispatchToPropsIsFunction = whenMapDispatchToPropsIsFunction;
	exports.whenMapDispatchToPropsIsMissing = whenMapDispatchToPropsIsMissing;
	exports.whenMapDispatchToPropsIsObject = whenMapDispatchToPropsIsObject;
	exports["default"] = void 0;
	
	var _redux = __webpack_require__(321);
	
	var _wrapMapToProps = __webpack_require__(514);
	
	function whenMapDispatchToPropsIsFunction(mapDispatchToProps) {
	  return typeof mapDispatchToProps === 'function' ? (0, _wrapMapToProps.wrapMapToPropsFunc)(mapDispatchToProps, 'mapDispatchToProps') : undefined;
	}
	
	function whenMapDispatchToPropsIsMissing(mapDispatchToProps) {
	  return !mapDispatchToProps ? (0, _wrapMapToProps.wrapMapToPropsConstant)(function (dispatch) {
	    return {
	      dispatch: dispatch
	    };
	  }) : undefined;
	}
	
	function whenMapDispatchToPropsIsObject(mapDispatchToProps) {
	  return mapDispatchToProps && typeof mapDispatchToProps === 'object' ? (0, _wrapMapToProps.wrapMapToPropsConstant)(function (dispatch) {
	    return (0, _redux.bindActionCreators)(mapDispatchToProps, dispatch);
	  }) : undefined;
	}
	
	var _default = [whenMapDispatchToPropsIsFunction, whenMapDispatchToPropsIsMissing, whenMapDispatchToPropsIsObject];
	exports["default"] = _default;

/***/ },
/* 1333 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.whenMapStateToPropsIsFunction = whenMapStateToPropsIsFunction;
	exports.whenMapStateToPropsIsMissing = whenMapStateToPropsIsMissing;
	exports["default"] = void 0;
	
	var _wrapMapToProps = __webpack_require__(514);
	
	function whenMapStateToPropsIsFunction(mapStateToProps) {
	  return typeof mapStateToProps === 'function' ? (0, _wrapMapToProps.wrapMapToPropsFunc)(mapStateToProps, 'mapStateToProps') : undefined;
	}
	
	function whenMapStateToPropsIsMissing(mapStateToProps) {
	  return !mapStateToProps ? (0, _wrapMapToProps.wrapMapToPropsConstant)(function () {
	    return {};
	  }) : undefined;
	}
	
	var _default = [whenMapStateToPropsIsFunction, whenMapStateToPropsIsMissing];
	exports["default"] = _default;

/***/ },
/* 1334 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(37);
	
	exports.__esModule = true;
	exports.defaultMergeProps = defaultMergeProps;
	exports.wrapMergePropsFunc = wrapMergePropsFunc;
	exports.whenMergePropsIsFunction = whenMergePropsIsFunction;
	exports.whenMergePropsIsOmitted = whenMergePropsIsOmitted;
	exports["default"] = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(125));
	
	var _verifyPlainObject = _interopRequireDefault(__webpack_require__(520));
	
	function defaultMergeProps(stateProps, dispatchProps, ownProps) {
	  return (0, _extends2["default"])({}, ownProps, stateProps, dispatchProps);
	}
	
	function wrapMergePropsFunc(mergeProps) {
	  return function initMergePropsProxy(dispatch, _ref) {
	    var displayName = _ref.displayName,
	        pure = _ref.pure,
	        areMergedPropsEqual = _ref.areMergedPropsEqual;
	    var hasRunOnce = false;
	    var mergedProps;
	    return function mergePropsProxy(stateProps, dispatchProps, ownProps) {
	      var nextMergedProps = mergeProps(stateProps, dispatchProps, ownProps);
	
	      if (hasRunOnce) {
	        if (!pure || !areMergedPropsEqual(nextMergedProps, mergedProps)) mergedProps = nextMergedProps;
	      } else {
	        hasRunOnce = true;
	        mergedProps = nextMergedProps;
	        if (false) (0, _verifyPlainObject["default"])(mergedProps, displayName, 'mergeProps');
	      }
	
	      return mergedProps;
	    };
	  };
	}
	
	function whenMergePropsIsFunction(mergeProps) {
	  return typeof mergeProps === 'function' ? wrapMergePropsFunc(mergeProps) : undefined;
	}
	
	function whenMergePropsIsOmitted(mergeProps) {
	  return !mergeProps ? function () {
	    return defaultMergeProps;
	  } : undefined;
	}
	
	var _default = [whenMergePropsIsFunction, whenMergePropsIsOmitted];
	exports["default"] = _default;

/***/ },
/* 1335 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(37);
	
	exports.__esModule = true;
	exports.impureFinalPropsSelectorFactory = impureFinalPropsSelectorFactory;
	exports.pureFinalPropsSelectorFactory = pureFinalPropsSelectorFactory;
	exports["default"] = finalPropsSelectorFactory;
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(157));
	
	var _verifySubselectors = _interopRequireDefault(__webpack_require__(1336));
	
	function impureFinalPropsSelectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch) {
	  return function impureFinalPropsSelector(state, ownProps) {
	    return mergeProps(mapStateToProps(state, ownProps), mapDispatchToProps(dispatch, ownProps), ownProps);
	  };
	}
	
	function pureFinalPropsSelectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, _ref) {
	  var areStatesEqual = _ref.areStatesEqual,
	      areOwnPropsEqual = _ref.areOwnPropsEqual,
	      areStatePropsEqual = _ref.areStatePropsEqual;
	  var hasRunAtLeastOnce = false;
	  var state;
	  var ownProps;
	  var stateProps;
	  var dispatchProps;
	  var mergedProps;
	
	  function handleFirstCall(firstState, firstOwnProps) {
	    state = firstState;
	    ownProps = firstOwnProps;
	    stateProps = mapStateToProps(state, ownProps);
	    dispatchProps = mapDispatchToProps(dispatch, ownProps);
	    mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
	    hasRunAtLeastOnce = true;
	    return mergedProps;
	  }
	
	  function handleNewPropsAndNewState() {
	    stateProps = mapStateToProps(state, ownProps);
	    if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);
	    mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
	    return mergedProps;
	  }
	
	  function handleNewProps() {
	    if (mapStateToProps.dependsOnOwnProps) stateProps = mapStateToProps(state, ownProps);
	    if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);
	    mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
	    return mergedProps;
	  }
	
	  function handleNewState() {
	    var nextStateProps = mapStateToProps(state, ownProps);
	    var statePropsChanged = !areStatePropsEqual(nextStateProps, stateProps);
	    stateProps = nextStateProps;
	    if (statePropsChanged) mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
	    return mergedProps;
	  }
	
	  function handleSubsequentCalls(nextState, nextOwnProps) {
	    var propsChanged = !areOwnPropsEqual(nextOwnProps, ownProps);
	    var stateChanged = !areStatesEqual(nextState, state);
	    state = nextState;
	    ownProps = nextOwnProps;
	    if (propsChanged && stateChanged) return handleNewPropsAndNewState();
	    if (propsChanged) return handleNewProps();
	    if (stateChanged) return handleNewState();
	    return mergedProps;
	  }
	
	  return function pureFinalPropsSelector(nextState, nextOwnProps) {
	    return hasRunAtLeastOnce ? handleSubsequentCalls(nextState, nextOwnProps) : handleFirstCall(nextState, nextOwnProps);
	  };
	} // TODO: Add more comments
	// If pure is true, the selector returned by selectorFactory will memoize its results,
	// allowing connectAdvanced's shouldComponentUpdate to return false if final
	// props have not changed. If false, the selector will always return a new
	// object and shouldComponentUpdate will always return true.
	
	
	function finalPropsSelectorFactory(dispatch, _ref2) {
	  var initMapStateToProps = _ref2.initMapStateToProps,
	      initMapDispatchToProps = _ref2.initMapDispatchToProps,
	      initMergeProps = _ref2.initMergeProps,
	      options = (0, _objectWithoutPropertiesLoose2["default"])(_ref2, ["initMapStateToProps", "initMapDispatchToProps", "initMergeProps"]);
	  var mapStateToProps = initMapStateToProps(dispatch, options);
	  var mapDispatchToProps = initMapDispatchToProps(dispatch, options);
	  var mergeProps = initMergeProps(dispatch, options);
	
	  if (false) {
	    (0, _verifySubselectors["default"])(mapStateToProps, mapDispatchToProps, mergeProps, options.displayName);
	  }
	
	  var selectorFactory = options.pure ? pureFinalPropsSelectorFactory : impureFinalPropsSelectorFactory;
	  return selectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, options);
	}

/***/ },
/* 1336 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(37);
	
	exports.__esModule = true;
	exports["default"] = verifySubselectors;
	
	var _warning = _interopRequireDefault(__webpack_require__(521));
	
	function verify(selector, methodName, displayName) {
	  if (!selector) {
	    throw new Error("Unexpected value for " + methodName + " in " + displayName + ".");
	  } else if (methodName === 'mapStateToProps' || methodName === 'mapDispatchToProps') {
	    if (!Object.prototype.hasOwnProperty.call(selector, 'dependsOnOwnProps')) {
	      (0, _warning["default"])("The selector for " + methodName + " of " + displayName + " did not specify a value for dependsOnOwnProps.");
	    }
	  }
	}
	
	function verifySubselectors(mapStateToProps, mapDispatchToProps, mergeProps, displayName) {
	  verify(mapStateToProps, 'mapStateToProps', displayName);
	  verify(mapDispatchToProps, 'mapDispatchToProps', displayName);
	  verify(mergeProps, 'mergeProps', displayName);
	}

/***/ },
/* 1337 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.createDispatchHook = createDispatchHook;
	exports.useDispatch = void 0;
	
	var _Context = __webpack_require__(104);
	
	var _useStore = __webpack_require__(516);
	
	/**
	 * Hook factory, which creates a `useDispatch` hook bound to a given context.
	 *
	 * @param {React.Context} [context=ReactReduxContext] Context passed to your `<Provider>`.
	 * @returns {Function} A `useDispatch` hook bound to the specified context.
	 */
	function createDispatchHook(context) {
	  if (context === void 0) {
	    context = _Context.ReactReduxContext;
	  }
	
	  var useStore = context === _Context.ReactReduxContext ? _useStore.useStore : (0, _useStore.createStoreHook)(context);
	  return function useDispatch() {
	    var store = useStore();
	    return store.dispatch;
	  };
	}
	/**
	 * A hook to access the redux `dispatch` function.
	 *
	 * @returns {any|function} redux store's `dispatch` function
	 *
	 * @example
	 *
	 * import React, { useCallback } from 'react'
	 * import { useDispatch } from 'react-redux'
	 *
	 * export const CounterComponent = ({ value }) => {
	 *   const dispatch = useDispatch()
	 *   const increaseCounter = useCallback(() => dispatch({ type: 'increase-counter' }), [])
	 *   return (
	 *     <div>
	 *       <span>{value}</span>
	 *       <button onClick={increaseCounter}>Increase counter</button>
	 *     </div>
	 *   )
	 * }
	 */
	
	
	var useDispatch = /*#__PURE__*/createDispatchHook();
	exports.useDispatch = useDispatch;

/***/ },
/* 1338 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(37);
	
	exports.__esModule = true;
	exports.createSelectorHook = createSelectorHook;
	exports.useSelector = void 0;
	
	var _react = __webpack_require__(1);
	
	var _useReduxContext2 = __webpack_require__(515);
	
	var _Subscription = _interopRequireDefault(__webpack_require__(318));
	
	var _useIsomorphicLayoutEffect = __webpack_require__(519);
	
	var _Context = __webpack_require__(104);
	
	var refEquality = function refEquality(a, b) {
	  return a === b;
	};
	
	function useSelectorWithStoreAndSubscription(selector, equalityFn, store, contextSub) {
	  var _useReducer = (0, _react.useReducer)(function (s) {
	    return s + 1;
	  }, 0),
	      forceRender = _useReducer[1];
	
	  var subscription = (0, _react.useMemo)(function () {
	    return new _Subscription["default"](store, contextSub);
	  }, [store, contextSub]);
	  var latestSubscriptionCallbackError = (0, _react.useRef)();
	  var latestSelector = (0, _react.useRef)();
	  var latestStoreState = (0, _react.useRef)();
	  var latestSelectedState = (0, _react.useRef)();
	  var storeState = store.getState();
	  var selectedState;
	
	  try {
	    if (selector !== latestSelector.current || storeState !== latestStoreState.current || latestSubscriptionCallbackError.current) {
	      selectedState = selector(storeState);
	    } else {
	      selectedState = latestSelectedState.current;
	    }
	  } catch (err) {
	    if (latestSubscriptionCallbackError.current) {
	      err.message += "\nThe error may be correlated with this previous error:\n" + latestSubscriptionCallbackError.current.stack + "\n\n";
	    }
	
	    throw err;
	  }
	
	  (0, _useIsomorphicLayoutEffect.useIsomorphicLayoutEffect)(function () {
	    latestSelector.current = selector;
	    latestStoreState.current = storeState;
	    latestSelectedState.current = selectedState;
	    latestSubscriptionCallbackError.current = undefined;
	  });
	  (0, _useIsomorphicLayoutEffect.useIsomorphicLayoutEffect)(function () {
	    function checkForUpdates() {
	      try {
	        var newSelectedState = latestSelector.current(store.getState());
	
	        if (equalityFn(newSelectedState, latestSelectedState.current)) {
	          return;
	        }
	
	        latestSelectedState.current = newSelectedState;
	      } catch (err) {
	        // we ignore all errors here, since when the component
	        // is re-rendered, the selectors are called again, and
	        // will throw again, if neither props nor store state
	        // changed
	        latestSubscriptionCallbackError.current = err;
	      }
	
	      forceRender();
	    }
	
	    subscription.onStateChange = checkForUpdates;
	    subscription.trySubscribe();
	    checkForUpdates();
	    return function () {
	      return subscription.tryUnsubscribe();
	    };
	  }, [store, subscription]);
	  return selectedState;
	}
	/**
	 * Hook factory, which creates a `useSelector` hook bound to a given context.
	 *
	 * @param {React.Context} [context=ReactReduxContext] Context passed to your `<Provider>`.
	 * @returns {Function} A `useSelector` hook bound to the specified context.
	 */
	
	
	function createSelectorHook(context) {
	  if (context === void 0) {
	    context = _Context.ReactReduxContext;
	  }
	
	  var useReduxContext = context === _Context.ReactReduxContext ? _useReduxContext2.useReduxContext : function () {
	    return (0, _react.useContext)(context);
	  };
	  return function useSelector(selector, equalityFn) {
	    if (equalityFn === void 0) {
	      equalityFn = refEquality;
	    }
	
	    if (false) {
	      throw new Error("You must pass a selector to useSelector");
	    }
	
	    var _useReduxContext = useReduxContext(),
	        store = _useReduxContext.store,
	        contextSub = _useReduxContext.subscription;
	
	    var selectedState = useSelectorWithStoreAndSubscription(selector, equalityFn, store, contextSub);
	    (0, _react.useDebugValue)(selectedState);
	    return selectedState;
	  };
	}
	/**
	 * A hook to access the redux store's state. This hook takes a selector function
	 * as an argument. The selector is called with the store state.
	 *
	 * This hook takes an optional equality comparison function as the second parameter
	 * that allows you to customize the way the selected state is compared to determine
	 * whether the component needs to be re-rendered.
	 *
	 * @param {Function} selector the selector function
	 * @param {Function=} equalityFn the function that will be used to determine equality
	 *
	 * @returns {any} the selected state
	 *
	 * @example
	 *
	 * import React from 'react'
	 * import { useSelector } from 'react-redux'
	 *
	 * export const CounterComponent = () => {
	 *   const counter = useSelector(state => state.counter)
	 *   return <div>{counter}</div>
	 * }
	 */
	
	
	var useSelector = /*#__PURE__*/createSelectorHook();
	exports.useSelector = useSelector;

/***/ },
/* 1339 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports["default"] = isPlainObject;
	
	/**
	 * @param {any} obj The object to inspect.
	 * @returns {boolean} True if the argument appears to be a plain object.
	 */
	function isPlainObject(obj) {
	  if (typeof obj !== 'object' || obj === null) return false;
	  var proto = Object.getPrototypeOf(obj);
	  if (proto === null) return true;
	  var baseProto = proto;
	
	  while (Object.getPrototypeOf(baseProto) !== null) {
	    baseProto = Object.getPrototypeOf(baseProto);
	  }
	
	  return proto === baseProto;
	}

/***/ },
/* 1340 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.unstable_batchedUpdates = void 0;
	
	var _reactDom = __webpack_require__(70);
	
	exports.unstable_batchedUpdates = _reactDom.unstable_batchedUpdates;

/***/ },
/* 1341 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";function _interopDefault(e){return e&&"object"==typeof e&&"default"in e?e.default:e}Object.defineProperty(exports,"__esModule",{value:!0});var reactRouter=__webpack_require__(212),React=_interopDefault(__webpack_require__(1)),history=__webpack_require__(288);__webpack_require__(20),__webpack_require__(214);var invariant=_interopDefault(__webpack_require__(325));function _extends(){return(_extends=Object.assign||function(e){for(var t=1;t<arguments.length;t++){var r=arguments[t];for(var o in r)Object.prototype.hasOwnProperty.call(r,o)&&(e[o]=r[o])}return e}).apply(this,arguments)}function _inheritsLoose(e,t){e.prototype=Object.create(t.prototype),(e.prototype.constructor=e).__proto__=t}function _objectWithoutPropertiesLoose(e,t){if(null==e)return{};var r,o,n={},a=Object.keys(e);for(o=0;o<a.length;o++)r=a[o],0<=t.indexOf(r)||(n[r]=e[r]);return n}var BrowserRouter=function(n){function e(){for(var e,t=arguments.length,r=new Array(t),o=0;o<t;o++)r[o]=arguments[o];return(e=n.call.apply(n,[this].concat(r))||this).history=history.createBrowserHistory(e.props),e}return _inheritsLoose(e,n),e.prototype.render=function(){return React.createElement(reactRouter.Router,{history:this.history,children:this.props.children})},e}(React.Component),HashRouter=function(n){function e(){for(var e,t=arguments.length,r=new Array(t),o=0;o<t;o++)r[o]=arguments[o];return(e=n.call.apply(n,[this].concat(r))||this).history=history.createHashHistory(e.props),e}return _inheritsLoose(e,n),e.prototype.render=function(){return React.createElement(reactRouter.Router,{history:this.history,children:this.props.children})},e}(React.Component),resolveToLocation=function(e,t){return"function"==typeof e?e(t):e},normalizeToLocation=function(e,t){return"string"==typeof e?history.createLocation(e,null,null,t):e},forwardRefShim=function(e){return e},forwardRef=React.forwardRef;function isModifiedEvent(e){return!!(e.metaKey||e.altKey||e.ctrlKey||e.shiftKey)}void 0===forwardRef&&(forwardRef=forwardRefShim);var LinkAnchor=forwardRef(function(e,t){var r=e.innerRef,o=e.navigate,n=e.onClick,a=_objectWithoutPropertiesLoose(e,["innerRef","navigate","onClick"]),i=a.target,c=_extends({},a,{onClick:function(t){try{n&&n(t)}catch(e){throw t.preventDefault(),e}t.defaultPrevented||0!==t.button||i&&"_self"!==i||isModifiedEvent(t)||(t.preventDefault(),o())}});return c.ref=forwardRefShim!==forwardRef&&t||r,React.createElement("a",c)}),Link=forwardRef(function(e,a){var t=e.component,i=void 0===t?LinkAnchor:t,c=e.replace,u=e.to,s=e.innerRef,f=_objectWithoutPropertiesLoose(e,["component","replace","to","innerRef"]);return React.createElement(reactRouter.__RouterContext.Consumer,null,function(t){t||invariant(!1);var r=t.history,e=normalizeToLocation(resolveToLocation(u,t.location),t.location),o=e?r.createHref(e):"",n=_extends({},f,{href:o,navigate:function(){var e=resolveToLocation(u,t.location);(c?r.replace:r.push)(e)}});return forwardRefShim!==forwardRef?n.ref=a||s:n.innerRef=s,React.createElement(i,n)})}),forwardRefShim$1=function(e){return e},forwardRef$1=React.forwardRef;function joinClassnames(){for(var e=arguments.length,t=new Array(e),r=0;r<e;r++)t[r]=arguments[r];return t.filter(function(e){return e}).join(" ")}void 0===forwardRef$1&&(forwardRef$1=forwardRefShim$1);var NavLink=forwardRef$1(function(e,f){var t=e["aria-current"],l=void 0===t?"page":t,r=e.activeClassName,p=void 0===r?"active":r,R=e.activeStyle,h=e.className,d=e.exact,y=e.isActive,m=e.location,v=e.sensitive,b=e.strict,w=e.style,x=e.to,g=e.innerRef,P=_objectWithoutPropertiesLoose(e,["aria-current","activeClassName","activeStyle","className","exact","isActive","location","sensitive","strict","style","to","innerRef"]);return React.createElement(reactRouter.__RouterContext.Consumer,null,function(e){e||invariant(!1);var t=m||e.location,r=normalizeToLocation(resolveToLocation(x,t),t),o=r.pathname,n=o&&o.replace(/([.+*?=^!:${}()[\]|/\\])/g,"\\$1"),a=n?reactRouter.matchPath(t.pathname,{path:n,exact:d,sensitive:v,strict:b}):null,i=!!(y?y(a,t):a),c=i?joinClassnames(h,p):h,u=i?_extends({},w,{},R):w,s=_extends({"aria-current":i&&l||null,className:c,style:u,to:r},P);return forwardRefShim$1!==forwardRef$1?s.ref=f||g:s.innerRef=g,React.createElement(Link,s)})});Object.defineProperty(exports,"MemoryRouter",{enumerable:!0,get:function(){return reactRouter.MemoryRouter}}),Object.defineProperty(exports,"Prompt",{enumerable:!0,get:function(){return reactRouter.Prompt}}),Object.defineProperty(exports,"Redirect",{enumerable:!0,get:function(){return reactRouter.Redirect}}),Object.defineProperty(exports,"Route",{enumerable:!0,get:function(){return reactRouter.Route}}),Object.defineProperty(exports,"Router",{enumerable:!0,get:function(){return reactRouter.Router}}),Object.defineProperty(exports,"StaticRouter",{enumerable:!0,get:function(){return reactRouter.StaticRouter}}),Object.defineProperty(exports,"Switch",{enumerable:!0,get:function(){return reactRouter.Switch}}),Object.defineProperty(exports,"generatePath",{enumerable:!0,get:function(){return reactRouter.generatePath}}),Object.defineProperty(exports,"matchPath",{enumerable:!0,get:function(){return reactRouter.matchPath}}),Object.defineProperty(exports,"useHistory",{enumerable:!0,get:function(){return reactRouter.useHistory}}),Object.defineProperty(exports,"useLocation",{enumerable:!0,get:function(){return reactRouter.useLocation}}),Object.defineProperty(exports,"useParams",{enumerable:!0,get:function(){return reactRouter.useParams}}),Object.defineProperty(exports,"useRouteMatch",{enumerable:!0,get:function(){return reactRouter.useRouteMatch}}),Object.defineProperty(exports,"withRouter",{enumerable:!0,get:function(){return reactRouter.withRouter}}),exports.BrowserRouter=BrowserRouter,exports.HashRouter=HashRouter,exports.Link=Link,exports.NavLink=NavLink;
	//# sourceMappingURL=react-router-dom.min.js.map


/***/ },
/* 1342 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";function _interopDefault(t){return t&&"object"==typeof t&&"default"in t?t.default:t}Object.defineProperty(exports,"__esModule",{value:!0});var React=_interopDefault(__webpack_require__(1));__webpack_require__(20);var history=__webpack_require__(288);__webpack_require__(214);var createContext=_interopDefault(__webpack_require__(1274)),invariant=_interopDefault(__webpack_require__(325)),pathToRegexp=_interopDefault(__webpack_require__(1280));__webpack_require__(211);var hoistStatics=_interopDefault(__webpack_require__(447));function _extends(){return(_extends=Object.assign||function(t){for(var e=1;e<arguments.length;e++){var n=arguments[e];for(var o in n)Object.prototype.hasOwnProperty.call(n,o)&&(t[o]=n[o])}return t}).apply(this,arguments)}function _inheritsLoose(t,e){t.prototype=Object.create(e.prototype),(t.prototype.constructor=t).__proto__=e}function _objectWithoutPropertiesLoose(t,e){if(null==t)return{};var n,o,r={},a=Object.keys(t);for(o=0;o<a.length;o++)n=a[o],0<=e.indexOf(n)||(r[n]=t[n]);return r}var createNamedContext=function(t){var e=createContext();return e.displayName=t,e},historyContext=createNamedContext("Router-History"),createNamedContext$1=function(t){var e=createContext();return e.displayName=t,e},context=createNamedContext$1("Router"),Router=function(n){function t(t){var e;return(e=n.call(this,t)||this).state={location:t.history.location},e._isMounted=!1,e._pendingLocation=null,t.staticContext||(e.unlisten=t.history.listen(function(t){e._isMounted?e.setState({location:t}):e._pendingLocation=t})),e}_inheritsLoose(t,n),t.computeRootMatch=function(t){return{path:"/",url:"/",params:{},isExact:"/"===t}};var e=t.prototype;return e.componentDidMount=function(){this._isMounted=!0,this._pendingLocation&&this.setState({location:this._pendingLocation})},e.componentWillUnmount=function(){this.unlisten&&this.unlisten()},e.render=function(){return React.createElement(context.Provider,{value:{history:this.props.history,location:this.state.location,match:t.computeRootMatch(this.state.location.pathname),staticContext:this.props.staticContext}},React.createElement(historyContext.Provider,{children:this.props.children||null,value:this.props.history}))},t}(React.Component),MemoryRouter=function(r){function t(){for(var t,e=arguments.length,n=new Array(e),o=0;o<e;o++)n[o]=arguments[o];return(t=r.call.apply(r,[this].concat(n))||this).history=history.createMemoryHistory(t.props),t}return _inheritsLoose(t,r),t.prototype.render=function(){return React.createElement(Router,{history:this.history,children:this.props.children})},t}(React.Component),Lifecycle=function(t){function e(){return t.apply(this,arguments)||this}_inheritsLoose(e,t);var n=e.prototype;return n.componentDidMount=function(){this.props.onMount&&this.props.onMount.call(this,this)},n.componentDidUpdate=function(t){this.props.onUpdate&&this.props.onUpdate.call(this,this,t)},n.componentWillUnmount=function(){this.props.onUnmount&&this.props.onUnmount.call(this,this)},n.render=function(){return null},e}(React.Component);function Prompt(t){var o=t.message,e=t.when,r=void 0===e||e;return React.createElement(context.Consumer,null,function(t){if(t||invariant(!1),!r||t.staticContext)return null;var n=t.history.block;return React.createElement(Lifecycle,{onMount:function(t){t.release=n(o)},onUpdate:function(t,e){e.message!==o&&(t.release(),t.release=n(o))},onUnmount:function(t){t.release()},message:o})})}var cache={},cacheLimit=1e4,cacheCount=0;function compilePath(t){if(cache[t])return cache[t];var e=pathToRegexp.compile(t);return cacheCount<cacheLimit&&(cache[t]=e,cacheCount++),e}function generatePath(t,e){return void 0===t&&(t="/"),void 0===e&&(e={}),"/"===t?t:compilePath(t)(e,{pretty:!0})}function Redirect(t){var a=t.computedMatch,i=t.to,e=t.push,c=void 0!==e&&e;return React.createElement(context.Consumer,null,function(t){t||invariant(!1);var e=t.history,n=t.staticContext,o=c?e.push:e.replace,r=history.createLocation(a?"string"==typeof i?generatePath(i,a.params):_extends({},i,{pathname:generatePath(i.pathname,a.params)}):i);return n?(o(r),null):React.createElement(Lifecycle,{onMount:function(){o(r)},onUpdate:function(t,e){var n=history.createLocation(e.to);history.locationsAreEqual(n,_extends({},r,{key:n.key}))||o(r)},to:i})})}var cache$1={},cacheLimit$1=1e4,cacheCount$1=0;function compilePath$1(t,e){var n=""+e.end+e.strict+e.sensitive,o=cache$1[n]||(cache$1[n]={});if(o[t])return o[t];var r=[],a={regexp:pathToRegexp(t,r,e),keys:r};return cacheCount$1<cacheLimit$1&&(o[t]=a,cacheCount$1++),a}function matchPath(u,t){void 0===t&&(t={}),"string"!=typeof t&&!Array.isArray(t)||(t={path:t});var e=t,n=e.path,o=e.exact,p=void 0!==o&&o,r=e.strict,h=void 0!==r&&r,a=e.sensitive,l=void 0!==a&&a;return[].concat(n).reduce(function(t,e){if(!e&&""!==e)return null;if(t)return t;var n=compilePath$1(e,{end:p,strict:h,sensitive:l}),o=n.regexp,r=n.keys,a=o.exec(u);if(!a)return null;var i=a[0],c=a.slice(1),s=u===i;return p&&!s?null:{path:e,url:"/"===e&&""===i?"/":i,isExact:s,params:r.reduce(function(t,e,n){return t[e.name]=c[n],t},{})}},null)}var Route=function(t){function e(){return t.apply(this,arguments)||this}return _inheritsLoose(e,t),e.prototype.render=function(){var c=this;return React.createElement(context.Consumer,null,function(t){t||invariant(!1);var e=c.props.location||t.location,n=_extends({},t,{location:e,match:c.props.computedMatch?c.props.computedMatch:c.props.path?matchPath(e.pathname,c.props):t.match}),o=c.props,r=o.children,a=o.component,i=o.render;return Array.isArray(r)&&0===r.length&&(r=null),React.createElement(context.Provider,{value:n},n.match?r?"function"==typeof r?r(n):r:a?React.createElement(a,n):i?i(n):null:"function"==typeof r?r(n):null)})},e}(React.Component);function addLeadingSlash(t){return"/"===t.charAt(0)?t:"/"+t}function addBasename(t,e){return t?_extends({},e,{pathname:addLeadingSlash(t)+e.pathname}):e}function stripBasename(t,e){if(!t)return e;var n=addLeadingSlash(t);return 0!==e.pathname.indexOf(n)?e:_extends({},e,{pathname:e.pathname.substr(n.length)})}function createURL(t){return"string"==typeof t?t:history.createPath(t)}function staticHandler(t){return function(){invariant(!1)}}function noop(){}var StaticRouter=function(r){function t(){for(var e,t=arguments.length,n=new Array(t),o=0;o<t;o++)n[o]=arguments[o];return(e=r.call.apply(r,[this].concat(n))||this).handlePush=function(t){return e.navigateTo(t,"PUSH")},e.handleReplace=function(t){return e.navigateTo(t,"REPLACE")},e.handleListen=function(){return noop},e.handleBlock=function(){return noop},e}_inheritsLoose(t,r);var e=t.prototype;return e.navigateTo=function(t,e){var n=this.props,o=n.basename,r=void 0===o?"":o,a=n.context,i=void 0===a?{}:a;i.action=e,i.location=addBasename(r,history.createLocation(t)),i.url=createURL(i.location)},e.render=function(){var t=this.props,e=t.basename,n=void 0===e?"":e,o=t.context,r=void 0===o?{}:o,a=t.location,i=void 0===a?"/":a,c=_objectWithoutPropertiesLoose(t,["basename","context","location"]),s={createHref:function(t){return addLeadingSlash(n+createURL(t))},action:"POP",location:stripBasename(n,history.createLocation(i)),push:this.handlePush,replace:this.handleReplace,go:staticHandler(),goBack:staticHandler(),goForward:staticHandler(),listen:this.handleListen,block:this.handleBlock};return React.createElement(Router,_extends({},c,{history:s,staticContext:r}))},t}(React.Component),Switch=function(t){function e(){return t.apply(this,arguments)||this}return _inheritsLoose(e,t),e.prototype.render=function(){var t=this;return React.createElement(context.Consumer,null,function(n){n||invariant(!1);var o,r,a=t.props.location||n.location;return React.Children.forEach(t.props.children,function(t){if(null==r&&React.isValidElement(t)){var e=(o=t).props.path||t.props.from;r=e?matchPath(a.pathname,_extends({},t.props,{path:e})):n.match}}),r?React.cloneElement(o,{location:a,computedMatch:r}):null})},e}(React.Component);function withRouter(o){function t(t){var e=t.wrappedComponentRef,n=_objectWithoutPropertiesLoose(t,["wrappedComponentRef"]);return React.createElement(context.Consumer,null,function(t){return t||invariant(!1),React.createElement(o,_extends({},n,t,{ref:e}))})}var e="withRouter("+(o.displayName||o.name)+")";return t.displayName=e,t.WrappedComponent=o,hoistStatics(t,o)}var useContext=React.useContext;function useHistory(){return useContext(historyContext)}function useLocation(){return useContext(context).location}function useParams(){var t=useContext(context).match;return t?t.params:{}}function useRouteMatch(t){var e=useLocation(),n=useContext(context).match;return t?matchPath(e.pathname,t):n}exports.MemoryRouter=MemoryRouter,exports.Prompt=Prompt,exports.Redirect=Redirect,exports.Route=Route,exports.Router=Router,exports.StaticRouter=StaticRouter,exports.Switch=Switch,exports.__HistoryContext=historyContext,exports.__RouterContext=context,exports.generatePath=generatePath,exports.matchPath=matchPath,exports.useHistory=useHistory,exports.useLocation=useLocation,exports.useParams=useParams,exports.useRouteMatch=useRouteMatch,exports.withRouter=withRouter;
	//# sourceMappingURL=react-router.min.js.map


/***/ },
/* 1343 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Animate = exports.easings = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(20);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _raf = __webpack_require__(1289);
	
	var _raf2 = _interopRequireDefault(_raf);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* eslint-disable no-restricted-syntax, react/forbid-prop-types */
	
	
	var easings = exports.easings = {
	  // Cubic
	  easeInCubic: 'cubic-bezier(0.550, 0.055, 0.675, 0.190)',
	  easeOutCubic: 'cubic-bezier(0.215, 0.610, 0.355, 1.000)',
	  easeInOutCubic: 'cubic-bezier(0.645, 0.045, 0.355, 1.000)',
	
	  // Circ
	  easeInCirc: 'cubic-bezier(0.600, 0.040, 0.980, 0.335)',
	  easeOutCirc: 'cubic-bezier(0.075, 0.820, 0.165, 1.000)',
	  easeInOutCirc: 'cubic-bezier(0.785, 0.135, 0.150, 0.860)',
	
	  // Expo
	  easeInExpo: 'cubic-bezier(0.950, 0.050, 0.795, 0.035)',
	  easeOutExpo: 'cubic-bezier(0.190, 1.000, 0.220, 1.000)',
	  easeInOutExpo: 'cubic-bezier(1.000, 0.000, 0.000, 1.000)',
	
	  // Quad
	  easeInQuad: 'cubic-bezier(0.550, 0.085, 0.680, 0.530)',
	  easeOutQuad: 'cubic-bezier(0.250, 0.460, 0.450, 0.940)',
	  easeInOutQuad: 'cubic-bezier(0.455, 0.030, 0.515, 0.955)',
	
	  // Quart
	  easeInQuart: 'cubic-bezier(0.895, 0.030, 0.685, 0.220)',
	  easeOutQuart: 'cubic-bezier(0.165, 0.840, 0.440, 1.000)',
	  easeInOutQuart: 'cubic-bezier(0.770, 0.000, 0.175, 1.000)',
	
	  // Quint
	  easeInQuint: 'cubic-bezier(0.755, 0.050, 0.855, 0.060)',
	  easeOutQuint: 'cubic-bezier(0.230, 1.000, 0.320, 1.000)',
	  easeInOutQuint: 'cubic-bezier(0.860, 0.000, 0.070, 1.000)',
	
	  // Sine
	  easeInSine: 'cubic-bezier(0.470, 0.000, 0.745, 0.715)',
	  easeOutSine: 'cubic-bezier(0.390, 0.575, 0.565, 1.000)',
	  easeInOutSine: 'cubic-bezier(0.445, 0.050, 0.550, 0.950)',
	
	  // Back
	  easeInBack: 'cubic-bezier(0.600, -0.280, 0.735, 0.045)',
	  easeOutBack: 'cubic-bezier(0.175,  0.885, 0.320, 1.275)',
	  easeInOutBack: 'cubic-bezier(0.680, -0.550, 0.265, 1.550)'
	};
	
	var Animate = exports.Animate = function (_React$Component) {
	  _inherits(Animate, _React$Component);
	
	  function Animate(props) {
	    _classCallCheck(this, Animate);
	
	    var _this = _possibleConstructorReturn(this, (Animate.__proto__ || Object.getPrototypeOf(Animate)).call(this, props));
	
	    _initialiseProps.call(_this);
	
	    var _this$props = _this.props,
	        show = _this$props.show,
	        preMount = _this$props.preMount,
	        transitionOnMount = _this$props.transitionOnMount,
	        start = _this$props.start,
	        enter = _this$props.enter;
	
	
	    _this.stage = false;
	    _this.stageStyles = {};
	    _this.transitioning = false;
	
	    _this.state = {
	      mountContent: preMount || show,
	      currentStyle: transitionOnMount ? start : enter,
	      styleOverrides: {}
	    };
	    return _this;
	  }
	
	  _createClass(Animate, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _props = this.props,
	          transitionOnMount = _props.transitionOnMount,
	          show = _props.show,
	          enter = _props.enter;
	
	      if (transitionOnMount && show) {
	        this.transition('enter', enter);
	      }
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate(oldProps) {
	      var _props2 = this.props,
	          show = _props2.show,
	          enter = _props2.enter,
	          leave = _props2.leave,
	          start = _props2.start,
	          stage = this.stage;
	
	
	      if (show) {
	        // Entering
	        if (!oldProps.show) {
	          if (stage === 'leave') {
	            return this.transition('clean');
	          }
	          if (enter) {
	            return this.transition('enter', enter);
	          }
	          return this.transition('clean');
	        }
	        // Did Enter
	        if (stage === 'didEnter') {
	          return this.transition('clean');
	        }
	      } else if (oldProps.show) {
	        // Leaving
	        return this.transition('leave', leave || start);
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _props3 = this.props,
	          Comp = _props3.component,
	          children = _props3.children,
	          originalShow = _props3.show,
	          easing = _props3.easing,
	          duration = _props3.duration,
	          transitionProperty = _props3.transitionProperty,
	          stayMounted = _props3.stayMounted,
	          transitionOnMount = _props3.transitionOnMount,
	          show = _props3.show,
	          style = _props3.style,
	          leave = _props3.leave,
	          enter = _props3.enter,
	          innerRef = _props3.innerRef,
	          onFinish = _props3.onFinish,
	          preMount = _props3.preMount,
	          rest = _objectWithoutProperties(_props3, ['component', 'children', 'show', 'easing', 'duration', 'transitionProperty', 'stayMounted', 'transitionOnMount', 'show', 'style', 'leave', 'enter', 'innerRef', 'onFinish', 'preMount']);
	
	      var _state = this.state,
	          mountContent = _state.mountContent,
	          currentStyle = _state.currentStyle,
	          styleOverrides = _state.styleOverrides;
	
	      return mountContent ? _react2.default.createElement(
	        Comp,
	        _extends({
	          ref: function ref(el) {
	            _this2.handleRef(el);
	            if (innerRef) {
	              innerRef(el);
	            }
	          },
	          onTransitionEnd: this.transitionEnd,
	          style: this.makeStyles(currentStyle, styleOverrides)
	        }, rest),
	        children
	      ) : null;
	    }
	  }]);
	
	  return Animate;
	}(_react2.default.Component);
	
	// I'll let someone smarter than me figure out how to do this ;)
	
	// export class AnimateGroup extends React.Component {
	//   constructor (props) {
	//     super(props)
	
	//     const { data } = props
	
	//     this.nodes = this.makeNodes(data)
	//   }
	//   componentDidUpdate () {
	//     const { data } = this.props
	
	//     const newNodes = this.makeNodes(data)
	
	//     let needsUpdate
	
	//     if (newNodes.some(node => !this.nodes.find(d => d.key === node.key))) {
	//       needsUpdate = 'diff'
	//     }
	
	//     if (needsUpdate) {
	//       console.log(needsUpdate, newNodes, this.nodes)
	//       this.nodes = this.updateNodes(newNodes)
	//       this.forceUpdate()
	//     }
	//   }
	//   makeNodes = data => {
	//     const { getKey } = this.props
	
	//     return data.map(datum => ({
	//       key: getKey(datum),
	//       data: datum,
	//       show: true,
	//     }))
	//   }
	//   updateNodes = next => {
	//     const nodes = []
	
	//     this.nodes.forEach(node => {
	//       if (next.find(d => d.key === node.key)) {
	//         return
	//       }
	//       exiting.push({
	//         ...node,
	//         show: false,
	//       })
	//     })
	
	//     return [...next, ...exiting]
	//   }
	//   removeNode = node => {
	//     this.nodes = this.nodes.filter(d => d.key !== node.key)
	//     this.forceUpdate()
	//   }
	//   render () {
	//     const {
	//       data,
	//       getKey,
	//       children,
	//       render,
	//       start,
	//       enter,
	//       update,
	//       leave,
	//       duration,
	//       easing,
	//       ...rest
	//     } = this.props
	//     return (
	//       <React.Fragment>
	//         {this.nodes.map((node, i) => (
	//           <Animate
	//             key={node.key}
	//             show={node.show}
	//             start={typeof start === 'function' ? start(node.data, node.key, i) : start}
	//             enter={typeof enter === 'function' ? enter(node.data, node.key, i) : enter}
	//             update={typeof update === 'function' ? update(node.data, node.key, i) : update}
	//             leave={typeof leave === 'function' ? leave(node.data, node.key, i) : leave}
	//             onFinish={() => {
	//               if (!node.show) {
	//                 this.removeNode(node)
	//               }
	//             }}
	//             {...rest}
	//           >
	//             {(render || children)(node.data)}
	//           </Animate>
	//         ))}
	//       </React.Fragment>
	//     )
	//   }
	// }
	
	// function mergeNodes (left, right) {
	//   let nodes = []
	
	//   let lastRightIndex = 0
	
	//   left.forEach(l => {
	//     const index = right.findIndex(r => r.key === l.key)
	//     if (index === -1) {
	//       return nodes.push(l)
	//     }
	//     nodes = [...nodes, ...right.slice(lastRightIndex, index)]
	//     lastRightIndex = index
	//   })
	
	//   return nodes
	// }
	
	
	Animate.easings = easings;
	Animate.propTypes = {
	  component: _propTypes2.default.string,
	  show: _propTypes2.default.oneOfType([_propTypes2.default.bool, _propTypes2.default.number]),
	  easing: _propTypes2.default.string,
	  duration: _propTypes2.default.number,
	  preMount: _propTypes2.default.bool,
	  transitionProperty: _propTypes2.default.string,
	  stayMounted: _propTypes2.default.bool,
	  style: _propTypes2.default.object,
	  start: _propTypes2.default.object,
	  enter: _propTypes2.default.object,
	  leave: _propTypes2.default.object,
	  onFinish: _propTypes2.default.func,
	  transitionOnMount: _propTypes2.default.bool,
	  children: _propTypes2.default.node.isRequired
	};
	Animate.defaultProps = {
	  component: 'div',
	  show: true,
	  easing: 'easeOutQuad',
	  duration: 300,
	  transitionProperty: 'all',
	  preMount: false,
	  stayMounted: true,
	  transitionOnMount: false,
	  style: undefined,
	  start: undefined,
	  enter: undefined,
	  leave: undefined,
	  onFinish: function onFinish() {}
	};
	
	var _initialiseProps = function _initialiseProps() {
	  var _this3 = this;
	
	  this.ensureMounted = function () {
	    return new Promise(function (resolve) {
	      var check = function check() {
	        if (_this3.el) {
	          return resolve();
	        }
	        (0, _raf2.default)(function () {
	          _this3.setState({
	            mountContent: true
	          }, check);
	        });
	      };
	      check();
	    });
	  };
	
	  this.setCurrentStyle = function (style) {
	    return _this3.setState({
	      currentStyle: style
	    });
	  };
	
	  this.overrideStyle = function (style) {
	    return new Promise(function (resolve) {
	      var check = function check() {
	        _this3.setState({
	          styleOverrides: style
	        }, function () {
	          (0, _raf2.default)(function () {
	            if (Object.keys(style).some(function (key) {
	              return !_this3.el || _this3.el.style[key] !== style[key];
	            })) {
	              return check();
	            }
	            resolve();
	          });
	        });
	      };
	      check();
	    });
	  };
	
	  this.transition = function (stage) {
	    var styles = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	    var show = _this3.props.show;
	
	
	    _this3.stage = stage;
	    _this3.stageStyles = styles;
	    _this3.transitioning = true;
	
	    var wasAutoWidth = void 0;
	    var wasAutoHeight = void 0;
	    var isAutoWidth = void 0;
	    var isAutoHeight = void 0;
	    var isAutoChanged = void 0;
	
	    return Promise.resolve().then(function () {
	      if (show) {
	        return _this3.ensureMounted();
	      }
	    }).then(function () {
	      var _state2 = _this3.state,
	          currentStyle = _state2.currentStyle,
	          styleOverrides = _state2.styleOverrides;
	
	
	      var previousStyle = _this3.makeStyles(currentStyle, styleOverrides);
	      var nextStyle = _this3.makeStyles(styles);
	
	      wasAutoWidth = _this3.isProp(previousStyle, 'width', 'auto');
	      wasAutoHeight = _this3.isProp(previousStyle, 'height', 'auto');
	      isAutoWidth = _this3.isProp(nextStyle, 'width', 'auto');
	      isAutoHeight = _this3.isProp(nextStyle, 'height', 'auto');
	
	      var isAutoWidthChanged = wasAutoWidth !== isAutoWidth;
	      var isAutoHeightChanged = wasAutoHeight !== isAutoHeight;
	      isAutoChanged = isAutoWidthChanged || isAutoHeightChanged;
	
	      if (isAutoChanged) {
	        // First we have to make sure we are measuring an
	        // inline-block element that is overflow hidden, otherwise measurements
	        // can get very inaccurate
	
	        return _this3.overrideStyle({
	          display: 'block',
	          overflow: 'hidden'
	        }).then(function () {
	          // Then we measure
	          var measurements = _this3.measure();
	          // Make sure overflow is hidden while we animate
	          return _this3.overrideStyle(_extends({}, isAutoWidthChanged ? { width: measurements.width + 'px' } : {}, isAutoHeightChanged ? { height: measurements.height + 'px' } : {}));
	        });
	      }
	    }).then(function () {
	      (0, _raf2.default)(function () {
	        _this3.setState(function (_ref) {
	          var styleOverrides = _ref.styleOverrides;
	
	          styleOverrides = isAutoChanged ? _extends({}, styleOverrides, wasAutoWidth ? { width: styles.width } : {}, wasAutoHeight ? { height: styles.height } : {}) : styleOverrides;
	
	          return {
	            mountContent: true,
	            currentStyle: styles,
	            styleOverrides: styleOverrides
	          };
	        }, function () {
	          // If no styles were applied, then we need to manually complete the transition
	          // TODO: this might also need to be done if the transitionProperty doesn't
	          // match any of the styles provided.
	          // if (!styles) {
	          //   this.completeTransition();
	          // }
	        });
	      });
	    });
	  };
	
	  this.transitionEnd = function (e) {
	    if (e) {
	      e.persist();
	
	      // Only handle transitionEnd for this element
	      if (e.target !== _this3.el) {
	        return;
	      }
	    }
	
	    // We have to debounce the action of stopping
	    // the "transition" state, since onTransitionEnd
	    // will fire more than once if there are multiple
	    // properties that were transitioned.
	
	    if (_this3.transitionRAF) {
	      _raf2.default.cancel(_this3.transitionRAF);
	    }
	    _this3.transitionRAF = (0, _raf2.default)(_this3.completeTransition);
	  };
	
	  this.completeTransition = function () {
	    var _props4 = _this3.props,
	        stayMounted = _props4.stayMounted,
	        onFinish = _props4.onFinish;
	
	
	    var shouldHide = _this3.stage === 'leave';
	    _this3.transitioning = false;
	    if (_this3.stage === 'enter') {
	      _this3.stage = 'didEnter';
	    } else if (_this3.stage === 'mount') {
	      _this3.stage = 'mounted';
	    } else {
	      _this3.stage = false;
	    }
	    _this3.setState({
	      mountContent: !(shouldHide && !stayMounted),
	      styleOverrides: {} // This is to make sure the auto/hidden overrides are gone
	    }, onFinish);
	  };
	
	  this.handleRef = function (el) {
	    _this3.el = el;
	  };
	
	  this.isProp = function (style, prop, value) {
	    return style[prop] === value;
	  };
	
	  this.measure = function () {
	    if (!_this3.el) {
	      return {};
	    }
	    return {
	      width: _this3.el.scrollWidth,
	      height: _this3.el.scrollHeight
	    };
	  };
	
	  this.makeStyles = function () {
	    var currentStyle = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	    var overrides = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	    var _props5 = _this3.props,
	        style = _props5.style,
	        transitionProperty = _props5.transitionProperty,
	        duration = _props5.duration,
	        easing = _props5.easing;
	
	
	    var resolvedEasing = easings[easing] || easing || 'ease-out';
	
	    return _extends({
	      transitionProperty: transitionProperty,
	      transitionDuration: duration + 'ms',
	      transitionTimingFunction: '' + resolvedEasing
	    }, style, currentStyle, overrides);
	  };
	};

/***/ },
/* 1344 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }
	
	var React = __webpack_require__(1);
	var React__default = _interopDefault(React);
	var shallowEqual = _interopDefault(__webpack_require__(1423));
	
	function _defineProperty(obj, key, value) {
	  if (key in obj) {
	    Object.defineProperty(obj, key, {
	      value: value,
	      enumerable: true,
	      configurable: true,
	      writable: true
	    });
	  } else {
	    obj[key] = value;
	  }
	
	  return obj;
	}
	
	function _inheritsLoose(subClass, superClass) {
	  subClass.prototype = Object.create(superClass.prototype);
	  subClass.prototype.constructor = subClass;
	  subClass.__proto__ = superClass;
	}
	
	var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
	function withSideEffect(reducePropsToState, handleStateChangeOnClient, mapStateOnServer) {
	  if (typeof reducePropsToState !== 'function') {
	    throw new Error('Expected reducePropsToState to be a function.');
	  }
	
	  if (typeof handleStateChangeOnClient !== 'function') {
	    throw new Error('Expected handleStateChangeOnClient to be a function.');
	  }
	
	  if (typeof mapStateOnServer !== 'undefined' && typeof mapStateOnServer !== 'function') {
	    throw new Error('Expected mapStateOnServer to either be undefined or a function.');
	  }
	
	  function getDisplayName(WrappedComponent) {
	    return WrappedComponent.displayName || WrappedComponent.name || 'Component';
	  }
	
	  return function wrap(WrappedComponent) {
	    if (typeof WrappedComponent !== 'function') {
	      throw new Error('Expected WrappedComponent to be a React component.');
	    }
	
	    var mountedInstances = [];
	    var state;
	
	    function emitChange() {
	      state = reducePropsToState(mountedInstances.map(function (instance) {
	        return instance.props;
	      }));
	
	      if (SideEffect.canUseDOM) {
	        handleStateChangeOnClient(state);
	      } else if (mapStateOnServer) {
	        state = mapStateOnServer(state);
	      }
	    }
	
	    var SideEffect =
	    /*#__PURE__*/
	    function (_Component) {
	      _inheritsLoose(SideEffect, _Component);
	
	      function SideEffect() {
	        return _Component.apply(this, arguments) || this;
	      }
	
	      // Try to use displayName of wrapped component
	      // Expose canUseDOM so tests can monkeypatch it
	      SideEffect.peek = function peek() {
	        return state;
	      };
	
	      SideEffect.rewind = function rewind() {
	        if (SideEffect.canUseDOM) {
	          throw new Error('You may only call rewind() on the server. Call peek() to read the current state.');
	        }
	
	        var recordedState = state;
	        state = undefined;
	        mountedInstances = [];
	        return recordedState;
	      };
	
	      var _proto = SideEffect.prototype;
	
	      _proto.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
	        return !shallowEqual(nextProps, this.props);
	      };
	
	      _proto.componentWillMount = function componentWillMount() {
	        mountedInstances.push(this);
	        emitChange();
	      };
	
	      _proto.componentDidUpdate = function componentDidUpdate() {
	        emitChange();
	      };
	
	      _proto.componentWillUnmount = function componentWillUnmount() {
	        var index = mountedInstances.indexOf(this);
	        mountedInstances.splice(index, 1);
	        emitChange();
	      };
	
	      _proto.render = function render() {
	        return React__default.createElement(WrappedComponent, this.props);
	      };
	
	      return SideEffect;
	    }(React.Component);
	
	    _defineProperty(SideEffect, "displayName", "SideEffect(" + getDisplayName(WrappedComponent) + ")");
	
	    _defineProperty(SideEffect, "canUseDOM", canUseDOM);
	
	    return SideEffect;
	  };
	}
	
	module.exports = withSideEffect;


/***/ },
/* 1345 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function (target) {
	  target.prototype.isCustomEvent = function (ele) {
	    var event = this.state.event;
	
	    return event || !!ele.getAttribute('data-event');
	  };
	
	  /* Bind listener for custom event */
	  target.prototype.customBindListener = function (ele) {
	    var _this = this;
	
	    var _state = this.state,
	        event = _state.event,
	        eventOff = _state.eventOff;
	
	    var dataEvent = ele.getAttribute('data-event') || event;
	    var dataEventOff = ele.getAttribute('data-event-off') || eventOff;
	
	    dataEvent.split(' ').forEach(function (event) {
	      ele.removeEventListener(event, customListener);
	      customListener = checkStatus.bind(_this, dataEventOff);
	      ele.addEventListener(event, customListener, false);
	    });
	    if (dataEventOff) {
	      dataEventOff.split(' ').forEach(function (event) {
	        ele.removeEventListener(event, _this.hideTooltip);
	        ele.addEventListener(event, _this.hideTooltip, false);
	      });
	    }
	  };
	
	  /* Unbind listener for custom event */
	  target.prototype.customUnbindListener = function (ele) {
	    var _state2 = this.state,
	        event = _state2.event,
	        eventOff = _state2.eventOff;
	
	    var dataEvent = event || ele.getAttribute('data-event');
	    var dataEventOff = eventOff || ele.getAttribute('data-event-off');
	
	    ele.removeEventListener(dataEvent, customListener);
	    if (dataEventOff) ele.removeEventListener(dataEventOff, this.hideTooltip);
	  };
	};
	
	/**
	 * Custom events to control showing and hiding of tooltip
	 *
	 * @attributes
	 * - `event` {String}
	 * - `eventOff` {String}
	 */
	
	var checkStatus = function checkStatus(dataEventOff, e) {
	  var show = this.state.show;
	  var id = this.props.id;
	
	  var dataIsCapture = e.currentTarget.getAttribute('data-iscapture');
	  var isCapture = dataIsCapture && dataIsCapture === 'true' || this.props.isCapture;
	  var currentItem = e.currentTarget.getAttribute('currentItem');
	
	  if (!isCapture) e.stopPropagation();
	  if (show && currentItem === 'true') {
	    if (!dataEventOff) this.hideTooltip(e);
	  } else {
	    e.currentTarget.setAttribute('currentItem', 'true');
	    setUntargetItems(e.currentTarget, this.getTargetArray(id));
	    this.showTooltip(e);
	  }
	};
	
	var setUntargetItems = function setUntargetItems(currentTarget, targetArray) {
	  for (var i = 0; i < targetArray.length; i++) {
	    if (currentTarget !== targetArray[i]) {
	      targetArray[i].setAttribute('currentItem', 'false');
	    } else {
	      targetArray[i].setAttribute('currentItem', 'true');
	    }
	  }
	};
	
	var customListener = void 0;

/***/ },
/* 1346 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function (target) {
	  target.prototype.getEffect = function (currentTarget) {
	    var dataEffect = currentTarget.getAttribute('data-effect');
	    return dataEffect || this.props.effect || 'float';
	  };
	};

/***/ },
/* 1347 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function (target) {
	  target.prototype.isCapture = function (currentTarget) {
	    var dataIsCapture = currentTarget.getAttribute('data-iscapture');
	    return dataIsCapture && dataIsCapture === 'true' || this.props.isCapture || false;
	  };
	};

/***/ },
/* 1348 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function (target) {
	  /**
	   * Hide all tooltip
	   * @trigger ReactTooltip.hide()
	   */
	  target.hide = function (target) {
	    dispatchGlobalEvent(_constant2.default.GLOBAL.HIDE, { target: target });
	  };
	
	  /**
	   * Rebuild all tooltip
	   * @trigger ReactTooltip.rebuild()
	   */
	  target.rebuild = function () {
	    dispatchGlobalEvent(_constant2.default.GLOBAL.REBUILD);
	  };
	
	  /**
	   * Show specific tooltip
	   * @trigger ReactTooltip.show()
	   */
	  target.show = function (target) {
	    dispatchGlobalEvent(_constant2.default.GLOBAL.SHOW, { target: target });
	  };
	
	  target.prototype.globalRebuild = function () {
	    if (this.mount) {
	      this.unbindListener();
	      this.bindListener();
	    }
	  };
	
	  target.prototype.globalShow = function (event) {
	    if (this.mount) {
	      // Create a fake event, specific show will limit the type to `solid`
	      // only `float` type cares e.clientX e.clientY
	      var e = { currentTarget: event.detail.target };
	      this.showTooltip(e, true);
	    }
	  };
	
	  target.prototype.globalHide = function (event) {
	    if (this.mount) {
	      var hasTarget = event && event.detail && event.detail.target && true || false;
	      this.hideTooltip({ currentTarget: hasTarget && event.detail.target }, hasTarget);
	    }
	  };
	};
	
	var _constant = __webpack_require__(522);
	
	var _constant2 = _interopRequireDefault(_constant);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var dispatchGlobalEvent = function dispatchGlobalEvent(eventName, opts) {
	  // Compatibale with IE
	  // @see http://stackoverflow.com/questions/26596123/internet-explorer-9-10-11-event-constructor-doesnt-work
	  var event = void 0;
	
	  if (typeof window.CustomEvent === 'function') {
	    event = new window.CustomEvent(eventName, { detail: opts });
	  } else {
	    event = document.createEvent('Event');
	    event.initEvent(eventName, false, true);
	    event.detail = opts;
	  }
	
	  window.dispatchEvent(event);
	}; /**
	    * Static methods for react-tooltip
	    */

/***/ },
/* 1349 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function (target) {
	  target.prototype.bindRemovalTracker = function () {
	    var _this = this;
	
	    var MutationObserver = getMutationObserverClass();
	    if (MutationObserver == null) return;
	
	    var observer = new MutationObserver(function (mutations) {
	      var _iteratorNormalCompletion = true;
	      var _didIteratorError = false;
	      var _iteratorError = undefined;
	
	      try {
	        for (var _iterator = mutations[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	          var mutation = _step.value;
	          var _iteratorNormalCompletion2 = true;
	          var _didIteratorError2 = false;
	          var _iteratorError2 = undefined;
	
	          try {
	            for (var _iterator2 = mutation.removedNodes[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
	              var element = _step2.value;
	
	              if (element === _this.state.currentTarget) {
	                _this.hideTooltip();
	                return;
	              }
	            }
	          } catch (err) {
	            _didIteratorError2 = true;
	            _iteratorError2 = err;
	          } finally {
	            try {
	              if (!_iteratorNormalCompletion2 && _iterator2.return) {
	                _iterator2.return();
	              }
	            } finally {
	              if (_didIteratorError2) {
	                throw _iteratorError2;
	              }
	            }
	          }
	        }
	      } catch (err) {
	        _didIteratorError = true;
	        _iteratorError = err;
	      } finally {
	        try {
	          if (!_iteratorNormalCompletion && _iterator.return) {
	            _iterator.return();
	          }
	        } finally {
	          if (_didIteratorError) {
	            throw _iteratorError;
	          }
	        }
	      }
	    });
	
	    observer.observe(window.document, { childList: true, subtree: true });
	
	    this.removalTracker = observer;
	  };
	
	  target.prototype.unbindRemovalTracker = function () {
	    if (this.removalTracker) {
	      this.removalTracker.disconnect();
	      this.removalTracker = null;
	    }
	  };
	};
	
	/**
	 * Tracking target removing from DOM.
	 * It's nessesary to hide tooltip when it's target disappears.
	 * Otherwise, the tooltip would be shown forever until another target
	 * is triggered.
	 *
	 * If MutationObserver is not available, this feature just doesn't work.
	 */
	
	// https://hacks.mozilla.org/2012/05/dom-mutationobserver-reacting-to-dom-changes-without-killing-browser-performance/
	var getMutationObserverClass = function getMutationObserverClass() {
	  return window.MutationObserver || window.WebKitMutationObserver || window.MozMutationObserver;
	};

/***/ },
/* 1350 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function (target) {
	  target.prototype.bindWindowEvents = function (resizeHide) {
	    // ReactTooltip.hide
	    window.removeEventListener(_constant2.default.GLOBAL.HIDE, this.globalHide);
	    window.addEventListener(_constant2.default.GLOBAL.HIDE, this.globalHide, false);
	
	    // ReactTooltip.rebuild
	    window.removeEventListener(_constant2.default.GLOBAL.REBUILD, this.globalRebuild);
	    window.addEventListener(_constant2.default.GLOBAL.REBUILD, this.globalRebuild, false);
	
	    // ReactTooltip.show
	    window.removeEventListener(_constant2.default.GLOBAL.SHOW, this.globalShow);
	    window.addEventListener(_constant2.default.GLOBAL.SHOW, this.globalShow, false);
	
	    // Resize
	    if (resizeHide) {
	      window.removeEventListener('resize', this.onWindowResize);
	      window.addEventListener('resize', this.onWindowResize, false);
	    }
	  };
	
	  target.prototype.unbindWindowEvents = function () {
	    window.removeEventListener(_constant2.default.GLOBAL.HIDE, this.globalHide);
	    window.removeEventListener(_constant2.default.GLOBAL.REBUILD, this.globalRebuild);
	    window.removeEventListener(_constant2.default.GLOBAL.SHOW, this.globalShow);
	    window.removeEventListener('resize', this.onWindowResize);
	  };
	
	  /**
	   * invoked by resize event of window
	   */
	  target.prototype.onWindowResize = function () {
	    if (!this.mount) return;
	    this.hideTooltip();
	  };
	};
	
	var _constant = __webpack_require__(522);
	
	var _constant2 = _interopRequireDefault(_constant);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 1351 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = '.__react_component_tooltip{border-radius:3px;display:inline-block;font-size:13px;left:-999em;opacity:0;padding:8px 21px;position:fixed;pointer-events:none;transition:opacity 0.3s ease-out;top:-999em;visibility:hidden;z-index:999}.__react_component_tooltip:before,.__react_component_tooltip:after{content:"";width:0;height:0;position:absolute}.__react_component_tooltip.show{opacity:0.9;margin-top:0px;margin-left:0px;visibility:visible}.__react_component_tooltip.type-dark{color:#fff;background-color:#222}.__react_component_tooltip.type-dark.place-top:after{border-top-color:#222;border-top-style:solid;border-top-width:6px}.__react_component_tooltip.type-dark.place-bottom:after{border-bottom-color:#222;border-bottom-style:solid;border-bottom-width:6px}.__react_component_tooltip.type-dark.place-left:after{border-left-color:#222;border-left-style:solid;border-left-width:6px}.__react_component_tooltip.type-dark.place-right:after{border-right-color:#222;border-right-style:solid;border-right-width:6px}.__react_component_tooltip.type-dark.border{border:1px solid #fff}.__react_component_tooltip.type-dark.border.place-top:before{border-top:8px solid #fff}.__react_component_tooltip.type-dark.border.place-bottom:before{border-bottom:8px solid #fff}.__react_component_tooltip.type-dark.border.place-left:before{border-left:8px solid #fff}.__react_component_tooltip.type-dark.border.place-right:before{border-right:8px solid #fff}.__react_component_tooltip.type-success{color:#fff;background-color:#8DC572}.__react_component_tooltip.type-success.place-top:after{border-top-color:#8DC572;border-top-style:solid;border-top-width:6px}.__react_component_tooltip.type-success.place-bottom:after{border-bottom-color:#8DC572;border-bottom-style:solid;border-bottom-width:6px}.__react_component_tooltip.type-success.place-left:after{border-left-color:#8DC572;border-left-style:solid;border-left-width:6px}.__react_component_tooltip.type-success.place-right:after{border-right-color:#8DC572;border-right-style:solid;border-right-width:6px}.__react_component_tooltip.type-success.border{border:1px solid #fff}.__react_component_tooltip.type-success.border.place-top:before{border-top:8px solid #fff}.__react_component_tooltip.type-success.border.place-bottom:before{border-bottom:8px solid #fff}.__react_component_tooltip.type-success.border.place-left:before{border-left:8px solid #fff}.__react_component_tooltip.type-success.border.place-right:before{border-right:8px solid #fff}.__react_component_tooltip.type-warning{color:#fff;background-color:#F0AD4E}.__react_component_tooltip.type-warning.place-top:after{border-top-color:#F0AD4E;border-top-style:solid;border-top-width:6px}.__react_component_tooltip.type-warning.place-bottom:after{border-bottom-color:#F0AD4E;border-bottom-style:solid;border-bottom-width:6px}.__react_component_tooltip.type-warning.place-left:after{border-left-color:#F0AD4E;border-left-style:solid;border-left-width:6px}.__react_component_tooltip.type-warning.place-right:after{border-right-color:#F0AD4E;border-right-style:solid;border-right-width:6px}.__react_component_tooltip.type-warning.border{border:1px solid #fff}.__react_component_tooltip.type-warning.border.place-top:before{border-top:8px solid #fff}.__react_component_tooltip.type-warning.border.place-bottom:before{border-bottom:8px solid #fff}.__react_component_tooltip.type-warning.border.place-left:before{border-left:8px solid #fff}.__react_component_tooltip.type-warning.border.place-right:before{border-right:8px solid #fff}.__react_component_tooltip.type-error{color:#fff;background-color:#BE6464}.__react_component_tooltip.type-error.place-top:after{border-top-color:#BE6464;border-top-style:solid;border-top-width:6px}.__react_component_tooltip.type-error.place-bottom:after{border-bottom-color:#BE6464;border-bottom-style:solid;border-bottom-width:6px}.__react_component_tooltip.type-error.place-left:after{border-left-color:#BE6464;border-left-style:solid;border-left-width:6px}.__react_component_tooltip.type-error.place-right:after{border-right-color:#BE6464;border-right-style:solid;border-right-width:6px}.__react_component_tooltip.type-error.border{border:1px solid #fff}.__react_component_tooltip.type-error.border.place-top:before{border-top:8px solid #fff}.__react_component_tooltip.type-error.border.place-bottom:before{border-bottom:8px solid #fff}.__react_component_tooltip.type-error.border.place-left:before{border-left:8px solid #fff}.__react_component_tooltip.type-error.border.place-right:before{border-right:8px solid #fff}.__react_component_tooltip.type-info{color:#fff;background-color:#337AB7}.__react_component_tooltip.type-info.place-top:after{border-top-color:#337AB7;border-top-style:solid;border-top-width:6px}.__react_component_tooltip.type-info.place-bottom:after{border-bottom-color:#337AB7;border-bottom-style:solid;border-bottom-width:6px}.__react_component_tooltip.type-info.place-left:after{border-left-color:#337AB7;border-left-style:solid;border-left-width:6px}.__react_component_tooltip.type-info.place-right:after{border-right-color:#337AB7;border-right-style:solid;border-right-width:6px}.__react_component_tooltip.type-info.border{border:1px solid #fff}.__react_component_tooltip.type-info.border.place-top:before{border-top:8px solid #fff}.__react_component_tooltip.type-info.border.place-bottom:before{border-bottom:8px solid #fff}.__react_component_tooltip.type-info.border.place-left:before{border-left:8px solid #fff}.__react_component_tooltip.type-info.border.place-right:before{border-right:8px solid #fff}.__react_component_tooltip.type-light{color:#222;background-color:#fff}.__react_component_tooltip.type-light.place-top:after{border-top-color:#fff;border-top-style:solid;border-top-width:6px}.__react_component_tooltip.type-light.place-bottom:after{border-bottom-color:#fff;border-bottom-style:solid;border-bottom-width:6px}.__react_component_tooltip.type-light.place-left:after{border-left-color:#fff;border-left-style:solid;border-left-width:6px}.__react_component_tooltip.type-light.place-right:after{border-right-color:#fff;border-right-style:solid;border-right-width:6px}.__react_component_tooltip.type-light.border{border:1px solid #222}.__react_component_tooltip.type-light.border.place-top:before{border-top:8px solid #222}.__react_component_tooltip.type-light.border.place-bottom:before{border-bottom:8px solid #222}.__react_component_tooltip.type-light.border.place-left:before{border-left:8px solid #222}.__react_component_tooltip.type-light.border.place-right:before{border-right:8px solid #222}.__react_component_tooltip.place-top{margin-top:-10px}.__react_component_tooltip.place-top:before{border-left:10px solid transparent;border-right:10px solid transparent;bottom:-8px;left:50%;margin-left:-10px}.__react_component_tooltip.place-top:after{border-left:8px solid transparent;border-right:8px solid transparent;bottom:-6px;left:50%;margin-left:-8px}.__react_component_tooltip.place-bottom{margin-top:10px}.__react_component_tooltip.place-bottom:before{border-left:10px solid transparent;border-right:10px solid transparent;top:-8px;left:50%;margin-left:-10px}.__react_component_tooltip.place-bottom:after{border-left:8px solid transparent;border-right:8px solid transparent;top:-6px;left:50%;margin-left:-8px}.__react_component_tooltip.place-left{margin-left:-10px}.__react_component_tooltip.place-left:before{border-top:6px solid transparent;border-bottom:6px solid transparent;right:-8px;top:50%;margin-top:-5px}.__react_component_tooltip.place-left:after{border-top:5px solid transparent;border-bottom:5px solid transparent;right:-6px;top:50%;margin-top:-4px}.__react_component_tooltip.place-right{margin-left:10px}.__react_component_tooltip.place-right:before{border-top:6px solid transparent;border-bottom:6px solid transparent;left:-8px;top:50%;margin-top:-5px}.__react_component_tooltip.place-right:after{border-top:5px solid transparent;border-bottom:5px solid transparent;left:-6px;top:50%;margin-top:-4px}.__react_component_tooltip .multi-line{display:block;padding:2px 0px;text-align:center}';

/***/ },
/* 1352 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.parseAria = parseAria;
	/**
	 * Support aria- and role in ReactTooltip
	 *
	 * @params props {Object}
	 * @return {Object}
	 */
	function parseAria(props) {
	  var ariaObj = {};
	  Object.keys(props).filter(function (prop) {
	    // aria-xxx and role is acceptable
	    return (/(^aria-\w+$|^role$)/.test(prop)
	    );
	  }).forEach(function (prop) {
	    ariaObj[prop] = props[prop];
	  });
	
	  return ariaObj;
	}

/***/ },
/* 1353 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function (e, target, node, place, effect, offset) {
	  var tipWidth = node.clientWidth;
	  var tipHeight = node.clientHeight;
	
	  var _getCurrentOffset = getCurrentOffset(e, target, effect),
	      mouseX = _getCurrentOffset.mouseX,
	      mouseY = _getCurrentOffset.mouseY;
	
	  var defaultOffset = getDefaultPosition(effect, target.clientWidth, target.clientHeight, tipWidth, tipHeight);
	
	  var _calculateOffset = calculateOffset(offset),
	      extraOffset_X = _calculateOffset.extraOffset_X,
	      extraOffset_Y = _calculateOffset.extraOffset_Y;
	
	  var windowWidth = window.innerWidth;
	  var windowHeight = window.innerHeight;
	
	  var _getParent = getParent(node),
	      parentTop = _getParent.parentTop,
	      parentLeft = _getParent.parentLeft;
	
	  // Get the edge offset of the tooltip
	
	
	  var getTipOffsetLeft = function getTipOffsetLeft(place) {
	    var offset_X = defaultOffset[place].l;
	    return mouseX + offset_X + extraOffset_X;
	  };
	  var getTipOffsetRight = function getTipOffsetRight(place) {
	    var offset_X = defaultOffset[place].r;
	    return mouseX + offset_X + extraOffset_X;
	  };
	  var getTipOffsetTop = function getTipOffsetTop(place) {
	    var offset_Y = defaultOffset[place].t;
	    return mouseY + offset_Y + extraOffset_Y;
	  };
	  var getTipOffsetBottom = function getTipOffsetBottom(place) {
	    var offset_Y = defaultOffset[place].b;
	    return mouseY + offset_Y + extraOffset_Y;
	  };
	
	  // Judge if the tooltip has over the window(screen)
	  var outsideVertical = function outsideVertical() {
	    var result = false;
	    var newPlace = void 0;
	    if (getTipOffsetTop('left') < 0 && getTipOffsetBottom('left') <= windowHeight && getTipOffsetBottom('bottom') <= windowHeight) {
	      result = true;
	      newPlace = 'bottom';
	    } else if (getTipOffsetBottom('left') > windowHeight && getTipOffsetTop('left') >= 0 && getTipOffsetTop('top') >= 0) {
	      result = true;
	      newPlace = 'top';
	    }
	    return { result: result, newPlace: newPlace };
	  };
	  var outsideLeft = function outsideLeft() {
	    var _outsideVertical = outsideVertical(),
	        result = _outsideVertical.result,
	        newPlace = _outsideVertical.newPlace; // Deal with vertical as first priority
	
	
	    if (result && outsideHorizontal().result) {
	      return { result: false }; // No need to change, if change to vertical will out of space
	    }
	    if (!result && getTipOffsetLeft('left') < 0 && getTipOffsetRight('right') <= windowWidth) {
	      result = true; // If vertical ok, but let out of side and right won't out of side
	      newPlace = 'right';
	    }
	    return { result: result, newPlace: newPlace };
	  };
	  var outsideRight = function outsideRight() {
	    var _outsideVertical2 = outsideVertical(),
	        result = _outsideVertical2.result,
	        newPlace = _outsideVertical2.newPlace;
	
	    if (result && outsideHorizontal().result) {
	      return { result: false }; // No need to change, if change to vertical will out of space
	    }
	    if (!result && getTipOffsetRight('right') > windowWidth && getTipOffsetLeft('left') >= 0) {
	      result = true;
	      newPlace = 'left';
	    }
	    return { result: result, newPlace: newPlace };
	  };
	
	  var outsideHorizontal = function outsideHorizontal() {
	    var result = false;
	    var newPlace = void 0;
	    if (getTipOffsetLeft('top') < 0 && getTipOffsetRight('top') <= windowWidth && getTipOffsetRight('right') <= windowWidth) {
	      result = true;
	      newPlace = 'right';
	    } else if (getTipOffsetRight('top') > windowWidth && getTipOffsetLeft('top') >= 0 && getTipOffsetLeft('left') >= 0) {
	      result = true;
	      newPlace = 'left';
	    }
	    return { result: result, newPlace: newPlace };
	  };
	  var outsideTop = function outsideTop() {
	    var _outsideHorizontal = outsideHorizontal(),
	        result = _outsideHorizontal.result,
	        newPlace = _outsideHorizontal.newPlace;
	
	    if (result && outsideVertical().result) {
	      return { result: false };
	    }
	    if (!result && getTipOffsetTop('top') < 0 && getTipOffsetBottom('bottom') <= windowHeight) {
	      result = true;
	      newPlace = 'bottom';
	    }
	    return { result: result, newPlace: newPlace };
	  };
	  var outsideBottom = function outsideBottom() {
	    var _outsideHorizontal2 = outsideHorizontal(),
	        result = _outsideHorizontal2.result,
	        newPlace = _outsideHorizontal2.newPlace;
	
	    if (result && outsideVertical().result) {
	      return { result: false };
	    }
	    if (!result && getTipOffsetBottom('bottom') > windowHeight && getTipOffsetTop('top') >= 0) {
	      result = true;
	      newPlace = 'top';
	    }
	    return { result: result, newPlace: newPlace };
	  };
	
	  // Return new state to change the placement to the reverse if possible
	  var outsideLeftResult = outsideLeft();
	  var outsideRightResult = outsideRight();
	  var outsideTopResult = outsideTop();
	  var outsideBottomResult = outsideBottom();
	
	  if (place === 'left' && outsideLeftResult.result) {
	    return {
	      isNewState: true,
	      newState: { place: outsideLeftResult.newPlace }
	    };
	  } else if (place === 'right' && outsideRightResult.result) {
	    return {
	      isNewState: true,
	      newState: { place: outsideRightResult.newPlace }
	    };
	  } else if (place === 'top' && outsideTopResult.result) {
	    return {
	      isNewState: true,
	      newState: { place: outsideTopResult.newPlace }
	    };
	  } else if (place === 'bottom' && outsideBottomResult.result) {
	    return {
	      isNewState: true,
	      newState: { place: outsideBottomResult.newPlace }
	    };
	  }
	
	  // Return tooltip offset position
	  return {
	    isNewState: false,
	    position: {
	      left: parseInt(getTipOffsetLeft(place) - parentLeft, 10),
	      top: parseInt(getTipOffsetTop(place) - parentTop, 10)
	    }
	  };
	};
	
	// Get current mouse offset
	var getCurrentOffset = function getCurrentOffset(e, currentTarget, effect) {
	  var boundingClientRect = currentTarget.getBoundingClientRect();
	  var targetTop = boundingClientRect.top;
	  var targetLeft = boundingClientRect.left;
	  var targetWidth = currentTarget.clientWidth;
	  var targetHeight = currentTarget.clientHeight;
	
	  if (effect === 'float') {
	    return {
	      mouseX: e.clientX,
	      mouseY: e.clientY
	    };
	  }
	  return {
	    mouseX: targetLeft + targetWidth / 2,
	    mouseY: targetTop + targetHeight / 2
	  };
	};
	
	// List all possibility of tooltip final offset
	// This is useful in judging if it is necessary for tooltip to switch position when out of window
	/**
	 * Calculate the position of tooltip
	 *
	 * @params
	 * - `e` {Event} the event of current mouse
	 * - `target` {Element} the currentTarget of the event
	 * - `node` {DOM} the react-tooltip object
	 * - `place` {String} top / right / bottom / left
	 * - `effect` {String} float / solid
	 * - `offset` {Object} the offset to default position
	 *
	 * @return {Object
	 * - `isNewState` {Bool} required
	 * - `newState` {Object}
	 * - `position` {OBject} {left: {Number}, top: {Number}}
	 */
	var getDefaultPosition = function getDefaultPosition(effect, targetWidth, targetHeight, tipWidth, tipHeight) {
	  var top = void 0;
	  var right = void 0;
	  var bottom = void 0;
	  var left = void 0;
	  var disToMouse = 3;
	  var triangleHeight = 2;
	  var cursorHeight = 12; // Optimize for float bottom only, cause the cursor will hide the tooltip
	
	  if (effect === 'float') {
	    top = {
	      l: -(tipWidth / 2),
	      r: tipWidth / 2,
	      t: -(tipHeight + disToMouse + triangleHeight),
	      b: -disToMouse
	    };
	    bottom = {
	      l: -(tipWidth / 2),
	      r: tipWidth / 2,
	      t: disToMouse + cursorHeight,
	      b: tipHeight + disToMouse + triangleHeight + cursorHeight
	    };
	    left = {
	      l: -(tipWidth + disToMouse + triangleHeight),
	      r: -disToMouse,
	      t: -(tipHeight / 2),
	      b: tipHeight / 2
	    };
	    right = {
	      l: disToMouse,
	      r: tipWidth + disToMouse + triangleHeight,
	      t: -(tipHeight / 2),
	      b: tipHeight / 2
	    };
	  } else if (effect === 'solid') {
	    top = {
	      l: -(tipWidth / 2),
	      r: tipWidth / 2,
	      t: -(targetHeight / 2 + tipHeight + triangleHeight),
	      b: -(targetHeight / 2)
	    };
	    bottom = {
	      l: -(tipWidth / 2),
	      r: tipWidth / 2,
	      t: targetHeight / 2,
	      b: targetHeight / 2 + tipHeight + triangleHeight
	    };
	    left = {
	      l: -(tipWidth + targetWidth / 2 + triangleHeight),
	      r: -(targetWidth / 2),
	      t: -(tipHeight / 2),
	      b: tipHeight / 2
	    };
	    right = {
	      l: targetWidth / 2,
	      r: tipWidth + targetWidth / 2 + triangleHeight,
	      t: -(tipHeight / 2),
	      b: tipHeight / 2
	    };
	  }
	
	  return { top: top, bottom: bottom, left: left, right: right };
	};
	
	// Consider additional offset into position calculation
	var calculateOffset = function calculateOffset(offset) {
	  var extraOffset_X = 0;
	  var extraOffset_Y = 0;
	
	  if (Object.prototype.toString.apply(offset) === '[object String]') {
	    offset = JSON.parse(offset.toString().replace(/\'/g, '\"'));
	  }
	  for (var key in offset) {
	    if (key === 'top') {
	      extraOffset_Y -= parseInt(offset[key], 10);
	    } else if (key === 'bottom') {
	      extraOffset_Y += parseInt(offset[key], 10);
	    } else if (key === 'left') {
	      extraOffset_X -= parseInt(offset[key], 10);
	    } else if (key === 'right') {
	      extraOffset_X += parseInt(offset[key], 10);
	    }
	  }
	
	  return { extraOffset_X: extraOffset_X, extraOffset_Y: extraOffset_Y };
	};
	
	// Get the offset of the parent elements
	var getParent = function getParent(currentTarget) {
	  var currentParent = currentTarget;
	  while (currentParent) {
	    if (window.getComputedStyle(currentParent).getPropertyValue('transform') !== 'none') break;
	    currentParent = currentParent.parentElement;
	  }
	
	  var parentTop = currentParent && currentParent.getBoundingClientRect().top || 0;
	  var parentLeft = currentParent && currentParent.getBoundingClientRect().left || 0;
	
	  return { parentTop: parentTop, parentLeft: parentLeft };
	};

/***/ },
/* 1354 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function (tip, children, getContent, multiline) {
	  if (children) return children;
	  if (getContent !== undefined && getContent !== null) return getContent; // getContent can be 0, '', etc.
	  if (getContent === null) return null; // Tip not exist and childern is null or undefined
	
	  var regexp = /<br\s*\/?>/;
	  if (!multiline || multiline === 'false' || !regexp.test(tip)) {
	    // No trim(), so that user can keep their input
	    return tip;
	  }
	
	  // Multiline tooltip content
	  return tip.split(regexp).map(function (d, i) {
	    return _react2.default.createElement(
	      'span',
	      { key: i, className: 'multi-line' },
	      d
	    );
	  });
	};
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 1355 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function (nodeList) {
	  var length = nodeList.length;
	  if (nodeList.hasOwnProperty) {
	    return Array.prototype.slice.call(nodeList);
	  }
	  return new Array(length).fill().map(function (index) {
	    return nodeList[index];
	  });
	};

/***/ },
/* 1356 */
/***/ function(module, exports, __webpack_require__) {

	/** @license React v16.8.6
	 * react.production.min.js
	 *
	 * Copyright (c) Facebook, Inc. and its affiliates.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';var k=__webpack_require__(207),n="function"===typeof Symbol&&Symbol.for,p=n?Symbol.for("react.element"):60103,q=n?Symbol.for("react.portal"):60106,r=n?Symbol.for("react.fragment"):60107,t=n?Symbol.for("react.strict_mode"):60108,u=n?Symbol.for("react.profiler"):60114,v=n?Symbol.for("react.provider"):60109,w=n?Symbol.for("react.context"):60110,x=n?Symbol.for("react.concurrent_mode"):60111,y=n?Symbol.for("react.forward_ref"):60112,z=n?Symbol.for("react.suspense"):60113,aa=n?Symbol.for("react.memo"):
	60115,ba=n?Symbol.for("react.lazy"):60116,A="function"===typeof Symbol&&Symbol.iterator;function ca(a,b,d,c,e,g,h,f){if(!a){a=void 0;if(void 0===b)a=Error("Minified exception occurred; use the non-minified dev environment for the full error message and additional helpful warnings.");else{var l=[d,c,e,g,h,f],m=0;a=Error(b.replace(/%s/g,function(){return l[m++]}));a.name="Invariant Violation"}a.framesToPop=1;throw a;}}
	function B(a){for(var b=arguments.length-1,d="https://reactjs.org/docs/error-decoder.html?invariant="+a,c=0;c<b;c++)d+="&args[]="+encodeURIComponent(arguments[c+1]);ca(!1,"Minified React error #"+a+"; visit %s for the full message or use the non-minified dev environment for full errors and additional helpful warnings. ",d)}var C={isMounted:function(){return!1},enqueueForceUpdate:function(){},enqueueReplaceState:function(){},enqueueSetState:function(){}},D={};
	function E(a,b,d){this.props=a;this.context=b;this.refs=D;this.updater=d||C}E.prototype.isReactComponent={};E.prototype.setState=function(a,b){"object"!==typeof a&&"function"!==typeof a&&null!=a?B("85"):void 0;this.updater.enqueueSetState(this,a,b,"setState")};E.prototype.forceUpdate=function(a){this.updater.enqueueForceUpdate(this,a,"forceUpdate")};function F(){}F.prototype=E.prototype;function G(a,b,d){this.props=a;this.context=b;this.refs=D;this.updater=d||C}var H=G.prototype=new F;
	H.constructor=G;k(H,E.prototype);H.isPureReactComponent=!0;var I={current:null},J={current:null},K=Object.prototype.hasOwnProperty,L={key:!0,ref:!0,__self:!0,__source:!0};
	function M(a,b,d){var c=void 0,e={},g=null,h=null;if(null!=b)for(c in void 0!==b.ref&&(h=b.ref),void 0!==b.key&&(g=""+b.key),b)K.call(b,c)&&!L.hasOwnProperty(c)&&(e[c]=b[c]);var f=arguments.length-2;if(1===f)e.children=d;else if(1<f){for(var l=Array(f),m=0;m<f;m++)l[m]=arguments[m+2];e.children=l}if(a&&a.defaultProps)for(c in f=a.defaultProps,f)void 0===e[c]&&(e[c]=f[c]);return{$$typeof:p,type:a,key:g,ref:h,props:e,_owner:J.current}}
	function da(a,b){return{$$typeof:p,type:a.type,key:b,ref:a.ref,props:a.props,_owner:a._owner}}function N(a){return"object"===typeof a&&null!==a&&a.$$typeof===p}function escape(a){var b={"=":"=0",":":"=2"};return"$"+(""+a).replace(/[=:]/g,function(a){return b[a]})}var O=/\/+/g,P=[];function Q(a,b,d,c){if(P.length){var e=P.pop();e.result=a;e.keyPrefix=b;e.func=d;e.context=c;e.count=0;return e}return{result:a,keyPrefix:b,func:d,context:c,count:0}}
	function R(a){a.result=null;a.keyPrefix=null;a.func=null;a.context=null;a.count=0;10>P.length&&P.push(a)}
	function S(a,b,d,c){var e=typeof a;if("undefined"===e||"boolean"===e)a=null;var g=!1;if(null===a)g=!0;else switch(e){case "string":case "number":g=!0;break;case "object":switch(a.$$typeof){case p:case q:g=!0}}if(g)return d(c,a,""===b?"."+T(a,0):b),1;g=0;b=""===b?".":b+":";if(Array.isArray(a))for(var h=0;h<a.length;h++){e=a[h];var f=b+T(e,h);g+=S(e,f,d,c)}else if(null===a||"object"!==typeof a?f=null:(f=A&&a[A]||a["@@iterator"],f="function"===typeof f?f:null),"function"===typeof f)for(a=f.call(a),h=
	0;!(e=a.next()).done;)e=e.value,f=b+T(e,h++),g+=S(e,f,d,c);else"object"===e&&(d=""+a,B("31","[object Object]"===d?"object with keys {"+Object.keys(a).join(", ")+"}":d,""));return g}function U(a,b,d){return null==a?0:S(a,"",b,d)}function T(a,b){return"object"===typeof a&&null!==a&&null!=a.key?escape(a.key):b.toString(36)}function ea(a,b){a.func.call(a.context,b,a.count++)}
	function fa(a,b,d){var c=a.result,e=a.keyPrefix;a=a.func.call(a.context,b,a.count++);Array.isArray(a)?V(a,c,d,function(a){return a}):null!=a&&(N(a)&&(a=da(a,e+(!a.key||b&&b.key===a.key?"":(""+a.key).replace(O,"$&/")+"/")+d)),c.push(a))}function V(a,b,d,c,e){var g="";null!=d&&(g=(""+d).replace(O,"$&/")+"/");b=Q(b,g,c,e);U(a,fa,b);R(b)}function W(){var a=I.current;null===a?B("321"):void 0;return a}
	var X={Children:{map:function(a,b,d){if(null==a)return a;var c=[];V(a,c,null,b,d);return c},forEach:function(a,b,d){if(null==a)return a;b=Q(null,null,b,d);U(a,ea,b);R(b)},count:function(a){return U(a,function(){return null},null)},toArray:function(a){var b=[];V(a,b,null,function(a){return a});return b},only:function(a){N(a)?void 0:B("143");return a}},createRef:function(){return{current:null}},Component:E,PureComponent:G,createContext:function(a,b){void 0===b&&(b=null);a={$$typeof:w,_calculateChangedBits:b,
	_currentValue:a,_currentValue2:a,_threadCount:0,Provider:null,Consumer:null};a.Provider={$$typeof:v,_context:a};return a.Consumer=a},forwardRef:function(a){return{$$typeof:y,render:a}},lazy:function(a){return{$$typeof:ba,_ctor:a,_status:-1,_result:null}},memo:function(a,b){return{$$typeof:aa,type:a,compare:void 0===b?null:b}},useCallback:function(a,b){return W().useCallback(a,b)},useContext:function(a,b){return W().useContext(a,b)},useEffect:function(a,b){return W().useEffect(a,b)},useImperativeHandle:function(a,
	b,d){return W().useImperativeHandle(a,b,d)},useDebugValue:function(){},useLayoutEffect:function(a,b){return W().useLayoutEffect(a,b)},useMemo:function(a,b){return W().useMemo(a,b)},useReducer:function(a,b,d){return W().useReducer(a,b,d)},useRef:function(a){return W().useRef(a)},useState:function(a){return W().useState(a)},Fragment:r,StrictMode:t,Suspense:z,createElement:M,cloneElement:function(a,b,d){null===a||void 0===a?B("267",a):void 0;var c=void 0,e=k({},a.props),g=a.key,h=a.ref,f=a._owner;if(null!=
	b){void 0!==b.ref&&(h=b.ref,f=J.current);void 0!==b.key&&(g=""+b.key);var l=void 0;a.type&&a.type.defaultProps&&(l=a.type.defaultProps);for(c in b)K.call(b,c)&&!L.hasOwnProperty(c)&&(e[c]=void 0===b[c]&&void 0!==l?l[c]:b[c])}c=arguments.length-2;if(1===c)e.children=d;else if(1<c){l=Array(c);for(var m=0;m<c;m++)l[m]=arguments[m+2];e.children=l}return{$$typeof:p,type:a.type,key:g,ref:h,props:e,_owner:f}},createFactory:function(a){var b=M.bind(null,a);b.type=a;return b},isValidElement:N,version:"16.8.6",
	unstable_ConcurrentMode:x,unstable_Profiler:u,__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED:{ReactCurrentDispatcher:I,ReactCurrentOwner:J,assign:k}},Y={default:X},Z=Y&&X||Y;module.exports=Z.default||Z;


/***/ },
/* 1357 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(105);


/***/ },
/* 1358 */
/***/ function(module, exports, __webpack_require__) {

	// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.
	
	// a passthrough stream.
	// basically just the most minimal sort of Transform stream.
	// Every written chunk gets output as-is.
	
	'use strict';
	
	module.exports = PassThrough;
	
	var Transform = __webpack_require__(524);
	
	/*<replacement>*/
	var util = Object.create(__webpack_require__(136));
	util.inherits = __webpack_require__(58);
	/*</replacement>*/
	
	util.inherits(PassThrough, Transform);
	
	function PassThrough(options) {
	  if (!(this instanceof PassThrough)) return new PassThrough(options);
	
	  Transform.call(this, options);
	}
	
	PassThrough.prototype._transform = function (chunk, encoding, cb) {
	  cb(null, chunk);
	};

/***/ },
/* 1359 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var Buffer = __webpack_require__(213).Buffer;
	var util = __webpack_require__(1525);
	
	function copyBuffer(src, target, offset) {
	  src.copy(target, offset);
	}
	
	module.exports = function () {
	  function BufferList() {
	    _classCallCheck(this, BufferList);
	
	    this.head = null;
	    this.tail = null;
	    this.length = 0;
	  }
	
	  BufferList.prototype.push = function push(v) {
	    var entry = { data: v, next: null };
	    if (this.length > 0) this.tail.next = entry;else this.head = entry;
	    this.tail = entry;
	    ++this.length;
	  };
	
	  BufferList.prototype.unshift = function unshift(v) {
	    var entry = { data: v, next: this.head };
	    if (this.length === 0) this.tail = entry;
	    this.head = entry;
	    ++this.length;
	  };
	
	  BufferList.prototype.shift = function shift() {
	    if (this.length === 0) return;
	    var ret = this.head.data;
	    if (this.length === 1) this.head = this.tail = null;else this.head = this.head.next;
	    --this.length;
	    return ret;
	  };
	
	  BufferList.prototype.clear = function clear() {
	    this.head = this.tail = null;
	    this.length = 0;
	  };
	
	  BufferList.prototype.join = function join(s) {
	    if (this.length === 0) return '';
	    var p = this.head;
	    var ret = '' + p.data;
	    while (p = p.next) {
	      ret += s + p.data;
	    }return ret;
	  };
	
	  BufferList.prototype.concat = function concat(n) {
	    if (this.length === 0) return Buffer.alloc(0);
	    if (this.length === 1) return this.head.data;
	    var ret = Buffer.allocUnsafe(n >>> 0);
	    var p = this.head;
	    var i = 0;
	    while (p) {
	      copyBuffer(p.data, ret, i);
	      i += p.data.length;
	      p = p.next;
	    }
	    return ret;
	  };
	
	  return BufferList;
	}();
	
	if (util && util.inspect && util.inspect.custom) {
	  module.exports.prototype[util.inspect.custom] = function () {
	    var obj = util.inspect({ length: this.length });
	    return this.constructor.name + ' ' + obj;
	  };
	}

/***/ },
/* 1360 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(320).PassThrough


/***/ },
/* 1361 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(320).Transform


/***/ },
/* 1362 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(319);


/***/ },
/* 1363 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	function createThunkMiddleware(extraArgument) {
	  return function (_ref) {
	    var dispatch = _ref.dispatch,
	        getState = _ref.getState;
	    return function (next) {
	      return function (action) {
	        if (typeof action === 'function') {
	          return action(dispatch, getState, extraArgument);
	        }
	
	        return next(action);
	      };
	    };
	  };
	}
	
	var thunk = createThunkMiddleware();
	thunk.withExtraArgument = createThunkMiddleware;
	
	exports['default'] = thunk;

/***/ },
/* 1364 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports['default'] = applyMiddleware;
	
	var _compose = __webpack_require__(527);
	
	var _compose2 = _interopRequireDefault(_compose);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	/**
	 * Creates a store enhancer that applies middleware to the dispatch method
	 * of the Redux store. This is handy for a variety of tasks, such as expressing
	 * asynchronous actions in a concise manner, or logging every action payload.
	 *
	 * See `redux-thunk` package as an example of the Redux middleware.
	 *
	 * Because middleware is potentially asynchronous, this should be the first
	 * store enhancer in the composition chain.
	 *
	 * Note that each middleware will be given the `dispatch` and `getState` functions
	 * as named arguments.
	 *
	 * @param {...Function} middlewares The middleware chain to be applied.
	 * @returns {Function} A store enhancer applying the middleware.
	 */
	function applyMiddleware() {
	  for (var _len = arguments.length, middlewares = Array(_len), _key = 0; _key < _len; _key++) {
	    middlewares[_key] = arguments[_key];
	  }
	
	  return function (createStore) {
	    return function (reducer, preloadedState, enhancer) {
	      var store = createStore(reducer, preloadedState, enhancer);
	      var _dispatch = store.dispatch;
	      var chain = [];
	
	      var middlewareAPI = {
	        getState: store.getState,
	        dispatch: function dispatch(action) {
	          return _dispatch(action);
	        }
	      };
	      chain = middlewares.map(function (middleware) {
	        return middleware(middlewareAPI);
	      });
	      _dispatch = _compose2['default'].apply(undefined, chain)(store.dispatch);
	
	      return _extends({}, store, {
	        dispatch: _dispatch
	      });
	    };
	  };
	}

/***/ },
/* 1365 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports['default'] = bindActionCreators;
	function bindActionCreator(actionCreator, dispatch) {
	  return function () {
	    return dispatch(actionCreator.apply(undefined, arguments));
	  };
	}
	
	/**
	 * Turns an object whose values are action creators, into an object with the
	 * same keys, but with every function wrapped into a `dispatch` call so they
	 * may be invoked directly. This is just a convenience method, as you can call
	 * `store.dispatch(MyActionCreators.doSomething())` yourself just fine.
	 *
	 * For convenience, you can also pass a single function as the first argument,
	 * and get a function in return.
	 *
	 * @param {Function|Object} actionCreators An object whose values are action
	 * creator functions. One handy way to obtain it is to use ES6 `import * as`
	 * syntax. You may also pass a single function.
	 *
	 * @param {Function} dispatch The `dispatch` function available on your Redux
	 * store.
	 *
	 * @returns {Function|Object} The object mimicking the original object, but with
	 * every action creator wrapped into the `dispatch` call. If you passed a
	 * function as `actionCreators`, the return value will also be a single
	 * function.
	 */
	function bindActionCreators(actionCreators, dispatch) {
	  if (typeof actionCreators === 'function') {
	    return bindActionCreator(actionCreators, dispatch);
	  }
	
	  if (typeof actionCreators !== 'object' || actionCreators === null) {
	    throw new Error('bindActionCreators expected an object or a function, instead received ' + (actionCreators === null ? 'null' : typeof actionCreators) + '. ' + 'Did you write "import ActionCreators from" instead of "import * as ActionCreators from"?');
	  }
	
	  var keys = Object.keys(actionCreators);
	  var boundActionCreators = {};
	  for (var i = 0; i < keys.length; i++) {
	    var key = keys[i];
	    var actionCreator = actionCreators[key];
	    if (typeof actionCreator === 'function') {
	      boundActionCreators[key] = bindActionCreator(actionCreator, dispatch);
	    }
	  }
	  return boundActionCreators;
	}

/***/ },
/* 1366 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports['default'] = combineReducers;
	
	var _createStore = __webpack_require__(528);
	
	var _isPlainObject = __webpack_require__(502);
	
	var _isPlainObject2 = _interopRequireDefault(_isPlainObject);
	
	var _warning = __webpack_require__(529);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function getUndefinedStateErrorMessage(key, action) {
	  var actionType = action && action.type;
	  var actionName = actionType && '"' + actionType.toString() + '"' || 'an action';
	
	  return 'Given action ' + actionName + ', reducer "' + key + '" returned undefined. ' + 'To ignore an action, you must explicitly return the previous state. ' + 'If you want this reducer to hold no value, you can return null instead of undefined.';
	}
	
	function getUnexpectedStateShapeWarningMessage(inputState, reducers, action, unexpectedKeyCache) {
	  var reducerKeys = Object.keys(reducers);
	  var argumentName = action && action.type === _createStore.ActionTypes.INIT ? 'preloadedState argument passed to createStore' : 'previous state received by the reducer';
	
	  if (reducerKeys.length === 0) {
	    return 'Store does not have a valid reducer. Make sure the argument passed ' + 'to combineReducers is an object whose values are reducers.';
	  }
	
	  if (!(0, _isPlainObject2['default'])(inputState)) {
	    return 'The ' + argumentName + ' has unexpected type of "' + {}.toString.call(inputState).match(/\s([a-z|A-Z]+)/)[1] + '". Expected argument to be an object with the following ' + ('keys: "' + reducerKeys.join('", "') + '"');
	  }
	
	  var unexpectedKeys = Object.keys(inputState).filter(function (key) {
	    return !reducers.hasOwnProperty(key) && !unexpectedKeyCache[key];
	  });
	
	  unexpectedKeys.forEach(function (key) {
	    unexpectedKeyCache[key] = true;
	  });
	
	  if (unexpectedKeys.length > 0) {
	    return 'Unexpected ' + (unexpectedKeys.length > 1 ? 'keys' : 'key') + ' ' + ('"' + unexpectedKeys.join('", "') + '" found in ' + argumentName + '. ') + 'Expected to find one of the known reducer keys instead: ' + ('"' + reducerKeys.join('", "') + '". Unexpected keys will be ignored.');
	  }
	}
	
	function assertReducerShape(reducers) {
	  Object.keys(reducers).forEach(function (key) {
	    var reducer = reducers[key];
	    var initialState = reducer(undefined, { type: _createStore.ActionTypes.INIT });
	
	    if (typeof initialState === 'undefined') {
	      throw new Error('Reducer "' + key + '" returned undefined during initialization. ' + 'If the state passed to the reducer is undefined, you must ' + 'explicitly return the initial state. The initial state may ' + 'not be undefined. If you don\'t want to set a value for this reducer, ' + 'you can use null instead of undefined.');
	    }
	
	    var type = '@@redux/PROBE_UNKNOWN_ACTION_' + Math.random().toString(36).substring(7).split('').join('.');
	    if (typeof reducer(undefined, { type: type }) === 'undefined') {
	      throw new Error('Reducer "' + key + '" returned undefined when probed with a random type. ' + ('Don\'t try to handle ' + _createStore.ActionTypes.INIT + ' or other actions in "redux/*" ') + 'namespace. They are considered private. Instead, you must return the ' + 'current state for any unknown actions, unless it is undefined, ' + 'in which case you must return the initial state, regardless of the ' + 'action type. The initial state may not be undefined, but can be null.');
	    }
	  });
	}
	
	/**
	 * Turns an object whose values are different reducer functions, into a single
	 * reducer function. It will call every child reducer, and gather their results
	 * into a single state object, whose keys correspond to the keys of the passed
	 * reducer functions.
	 *
	 * @param {Object} reducers An object whose values correspond to different
	 * reducer functions that need to be combined into one. One handy way to obtain
	 * it is to use ES6 `import * as reducers` syntax. The reducers may never return
	 * undefined for any action. Instead, they should return their initial state
	 * if the state passed to them was undefined, and the current state for any
	 * unrecognized action.
	 *
	 * @returns {Function} A reducer function that invokes every reducer inside the
	 * passed object, and builds a state object with the same shape.
	 */
	function combineReducers(reducers) {
	  var reducerKeys = Object.keys(reducers);
	  var finalReducers = {};
	  for (var i = 0; i < reducerKeys.length; i++) {
	    var key = reducerKeys[i];
	
	    if (false) {
	      if (typeof reducers[key] === 'undefined') {
	        (0, _warning2['default'])('No reducer provided for key "' + key + '"');
	      }
	    }
	
	    if (typeof reducers[key] === 'function') {
	      finalReducers[key] = reducers[key];
	    }
	  }
	  var finalReducerKeys = Object.keys(finalReducers);
	
	  var unexpectedKeyCache = void 0;
	  if (false) {
	    unexpectedKeyCache = {};
	  }
	
	  var shapeAssertionError = void 0;
	  try {
	    assertReducerShape(finalReducers);
	  } catch (e) {
	    shapeAssertionError = e;
	  }
	
	  return function combination() {
	    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	    var action = arguments[1];
	
	    if (shapeAssertionError) {
	      throw shapeAssertionError;
	    }
	
	    if (false) {
	      var warningMessage = getUnexpectedStateShapeWarningMessage(state, finalReducers, action, unexpectedKeyCache);
	      if (warningMessage) {
	        (0, _warning2['default'])(warningMessage);
	      }
	    }
	
	    var hasChanged = false;
	    var nextState = {};
	    for (var _i = 0; _i < finalReducerKeys.length; _i++) {
	      var _key = finalReducerKeys[_i];
	      var reducer = finalReducers[_key];
	      var previousStateForKey = state[_key];
	      var nextStateForKey = reducer(previousStateForKey, action);
	      if (typeof nextStateForKey === 'undefined') {
	        var errorMessage = getUndefinedStateErrorMessage(_key, action);
	        throw new Error(errorMessage);
	      }
	      nextState[_key] = nextStateForKey;
	      hasChanged = hasChanged || nextStateForKey !== previousStateForKey;
	    }
	    return hasChanged ? nextState : state;
	  };
	}

/***/ },
/* 1367 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var define = __webpack_require__(285);
	var callBind = __webpack_require__(1022);
	
	var implementation = __webpack_require__(530);
	var getPolyfill = __webpack_require__(531);
	var shim = __webpack_require__(1368);
	
	var flagsBound = callBind(implementation);
	
	define(flagsBound, {
		getPolyfill: getPolyfill,
		implementation: implementation,
		shim: shim
	});
	
	module.exports = flagsBound;


/***/ },
/* 1368 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var supportsDescriptors = __webpack_require__(285).supportsDescriptors;
	var getPolyfill = __webpack_require__(531);
	var gOPD = Object.getOwnPropertyDescriptor;
	var defineProperty = Object.defineProperty;
	var TypeErr = TypeError;
	var getProto = Object.getPrototypeOf;
	var regex = /a/;
	
	module.exports = function shimFlags() {
		if (!supportsDescriptors || !getProto) {
			throw new TypeErr('RegExp.prototype.flags requires a true ES5 environment that supports property descriptors');
		}
		var polyfill = getPolyfill();
		var proto = getProto(regex);
		var descriptor = gOPD(proto, 'flags');
		if (!descriptor || descriptor.get !== polyfill) {
			defineProperty(proto, 'flags', {
				configurable: true,
				enumerable: false,
				get: polyfill
			});
		}
		return polyfill;
	};


/***/ },
/* 1369 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var unherit = __webpack_require__(1483);
	var xtend = __webpack_require__(79);
	var Parser = __webpack_require__(1379);
	
	module.exports = parse;
	parse.Parser = Parser;
	
	function parse(options) {
	  var Local = unherit(Parser);
	  Local.prototype.options = xtend(Local.prototype.options, this.data('settings'), options);
	  this.Parser = Local;
	}


/***/ },
/* 1370 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var xtend = __webpack_require__(79);
	var entities = __webpack_require__(315);
	
	module.exports = factory;
	
	/* Factory to create an entity decoder. */
	function factory(ctx) {
	  decoder.raw = decodeRaw;
	
	  return decoder;
	
	  /* Normalize `position` to add an `indent`. */
	  function normalize(position) {
	    var offsets = ctx.offset;
	    var line = position.line;
	    var result = [];
	
	    while (++line) {
	      if (!(line in offsets)) {
	        break;
	      }
	
	      result.push((offsets[line] || 0) + 1);
	    }
	
	    return {
	      start: position,
	      indent: result
	    };
	  }
	
	  /* Handle a warning.
	   * See https://github.com/wooorm/parse-entities
	   * for the warnings. */
	  function handleWarning(reason, position, code) {
	    if (code === 3) {
	      return;
	    }
	
	    ctx.file.message(reason, position);
	  }
	
	  /* Decode `value` (at `position`) into text-nodes. */
	  function decoder(value, position, handler) {
	    entities(value, {
	      position: normalize(position),
	      warning: handleWarning,
	      text: handler,
	      reference: handler,
	      textContext: ctx,
	      referenceContext: ctx
	    });
	  }
	
	  /* Decode `value` (at `position`) into a string. */
	  function decodeRaw(value, position, options) {
	    return entities(value, xtend(options, {
	      position: normalize(position),
	      warning: handleWarning
	    }));
	  }
	}


/***/ },
/* 1371 */
/***/ function(module, exports) {

	'use strict';
	
	module.exports = locate;
	
	function locate(value, fromIndex) {
	  var index = value.indexOf('\n', fromIndex);
	
	  while (index > fromIndex) {
	    if (value.charAt(index - 1) !== ' ') {
	      break;
	    }
	
	    index--;
	  }
	
	  return index;
	}


/***/ },
/* 1372 */
/***/ function(module, exports) {

	'use strict';
	
	module.exports = locate;
	
	function locate(value, fromIndex) {
	  return value.indexOf('`', fromIndex);
	}


/***/ },
/* 1373 */
/***/ function(module, exports) {

	'use strict';
	
	module.exports = locate;
	
	function locate(value, fromIndex) {
	  return value.indexOf('~~', fromIndex);
	}


/***/ },
/* 1374 */
/***/ function(module, exports) {

	'use strict';
	
	module.exports = locate;
	
	function locate(value, fromIndex) {
	  var asterisk = value.indexOf('*', fromIndex);
	  var underscore = value.indexOf('_', fromIndex);
	
	  if (underscore === -1) {
	    return asterisk;
	  }
	
	  if (asterisk === -1) {
	    return underscore;
	  }
	
	  return underscore < asterisk ? underscore : asterisk;
	}


/***/ },
/* 1375 */
/***/ function(module, exports) {

	'use strict';
	
	module.exports = locate;
	
	function locate(value, fromIndex) {
	  return value.indexOf('\\', fromIndex);
	}


/***/ },
/* 1376 */
/***/ function(module, exports) {

	'use strict';
	
	module.exports = locate;
	
	function locate(value, fromIndex) {
	  var asterisk = value.indexOf('**', fromIndex);
	  var underscore = value.indexOf('__', fromIndex);
	
	  if (underscore === -1) {
	    return asterisk;
	  }
	
	  if (asterisk === -1) {
	    return underscore;
	  }
	
	  return underscore < asterisk ? underscore : asterisk;
	}


/***/ },
/* 1377 */
/***/ function(module, exports) {

	'use strict';
	
	module.exports = locate;
	
	var PROTOCOLS = ['https://', 'http://', 'mailto:'];
	
	function locate(value, fromIndex) {
	  var length = PROTOCOLS.length;
	  var index = -1;
	  var min = -1;
	  var position;
	
	  if (!this.options.gfm) {
	    return -1;
	  }
	
	  while (++index < length) {
	    position = value.indexOf(PROTOCOLS[index], fromIndex);
	
	    if (position !== -1 && (position < min || min === -1)) {
	      min = position;
	    }
	  }
	
	  return min;
	}


/***/ },
/* 1378 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var xtend = __webpack_require__(79);
	var removePosition = __webpack_require__(1486);
	
	module.exports = parse;
	
	var C_NEWLINE = '\n';
	var EXPRESSION_LINE_BREAKS = /\r\n|\r/g;
	
	/* Parse the bound file. */
	function parse() {
	  var self = this;
	  var value = String(self.file);
	  var start = {line: 1, column: 1, offset: 0};
	  var content = xtend(start);
	  var node;
	
	  /* Clean non-unix newlines: `\r\n` and `\r` are all
	   * changed to `\n`.  This should not affect positional
	   * information. */
	  value = value.replace(EXPRESSION_LINE_BREAKS, C_NEWLINE);
	
	  if (value.charCodeAt(0) === 0xFEFF) {
	    value = value.slice(1);
	
	    content.column++;
	    content.offset++;
	  }
	
	  node = {
	    type: 'root',
	    children: self.tokenizeBlock(value, content),
	    position: {
	      start: start,
	      end: self.eof || xtend(start)
	    }
	  };
	
	  if (!self.options.position) {
	    removePosition(node, true);
	  }
	
	  return node;
	}


/***/ },
/* 1379 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var xtend = __webpack_require__(79);
	var toggle = __webpack_require__(1424);
	var vfileLocation = __webpack_require__(1517);
	var unescape = __webpack_require__(1407);
	var decode = __webpack_require__(1370);
	var tokenizer = __webpack_require__(1406);
	
	module.exports = Parser;
	
	function Parser(doc, file) {
	  this.file = file;
	  this.offset = {};
	  this.options = xtend(this.options);
	  this.setOptions({});
	
	  this.inList = false;
	  this.inBlock = false;
	  this.inLink = false;
	  this.atStart = true;
	
	  this.toOffset = vfileLocation(file).toOffset;
	  this.unescape = unescape(this, 'escape');
	  this.decode = decode(this);
	}
	
	var proto = Parser.prototype;
	
	/* Expose core. */
	proto.setOptions = __webpack_require__(1380);
	proto.parse = __webpack_require__(1378);
	
	/* Expose `defaults`. */
	proto.options = __webpack_require__(532);
	
	/* Enter and exit helpers. */
	proto.exitStart = toggle('atStart', true);
	proto.enterList = toggle('inList', false);
	proto.enterLink = toggle('inLink', false);
	proto.enterBlock = toggle('inBlock', false);
	
	/* Nodes that can interupt a paragraph:
	 *
	 * ```markdown
	 * A paragraph, followed by a thematic break.
	 * ___
	 * ```
	 *
	 * In the above example, the thematic break “interupts”
	 * the paragraph. */
	proto.interruptParagraph = [
	  ['thematicBreak'],
	  ['atxHeading'],
	  ['fencedCode'],
	  ['blockquote'],
	  ['html'],
	  ['setextHeading', {commonmark: false}],
	  ['definition', {commonmark: false}],
	  ['footnote', {commonmark: false}]
	];
	
	/* Nodes that can interupt a list:
	 *
	 * ```markdown
	 * - One
	 * ___
	 * ```
	 *
	 * In the above example, the thematic break “interupts”
	 * the list. */
	proto.interruptList = [
	  ['atxHeading', {pedantic: false}],
	  ['fencedCode', {pedantic: false}],
	  ['thematicBreak', {pedantic: false}],
	  ['definition', {commonmark: false}],
	  ['footnote', {commonmark: false}]
	];
	
	/* Nodes that can interupt a blockquote:
	 *
	 * ```markdown
	 * > A paragraph.
	 * ___
	 * ```
	 *
	 * In the above example, the thematic break “interupts”
	 * the blockquote. */
	proto.interruptBlockquote = [
	  ['indentedCode', {commonmark: true}],
	  ['fencedCode', {commonmark: true}],
	  ['atxHeading', {commonmark: true}],
	  ['setextHeading', {commonmark: true}],
	  ['thematicBreak', {commonmark: true}],
	  ['html', {commonmark: true}],
	  ['list', {commonmark: true}],
	  ['definition', {commonmark: false}],
	  ['footnote', {commonmark: false}]
	];
	
	/* Handlers. */
	proto.blockTokenizers = {
	  newline: __webpack_require__(1398),
	  indentedCode: __webpack_require__(1385),
	  fencedCode: __webpack_require__(1384),
	  blockquote: __webpack_require__(1382),
	  atxHeading: __webpack_require__(1392),
	  thematicBreak: __webpack_require__(1404),
	  list: __webpack_require__(1397),
	  setextHeading: __webpack_require__(1393),
	  html: __webpack_require__(1394),
	  footnote: __webpack_require__(1391),
	  definition: __webpack_require__(1387),
	  table: __webpack_require__(1402),
	  paragraph: __webpack_require__(1399)
	};
	
	proto.inlineTokenizers = {
	  escape: __webpack_require__(1390),
	  autoLink: __webpack_require__(1381),
	  url: __webpack_require__(1405),
	  html: __webpack_require__(1395),
	  link: __webpack_require__(1396),
	  reference: __webpack_require__(1400),
	  strong: __webpack_require__(1401),
	  emphasis: __webpack_require__(1389),
	  deletion: __webpack_require__(1388),
	  code: __webpack_require__(1386),
	  break: __webpack_require__(1383),
	  text: __webpack_require__(1403)
	};
	
	/* Expose precedence. */
	proto.blockMethods = keys(proto.blockTokenizers);
	proto.inlineMethods = keys(proto.inlineTokenizers);
	
	/* Tokenizers. */
	proto.tokenizeBlock = tokenizer('block');
	proto.tokenizeInline = tokenizer('inline');
	proto.tokenizeFactory = tokenizer;
	
	/* Get all keys in `value`. */
	function keys(value) {
	  var result = [];
	  var key;
	
	  for (key in value) {
	    result.push(key);
	  }
	
	  return result;
	}


/***/ },
/* 1380 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var xtend = __webpack_require__(79);
	var escapes = __webpack_require__(1272);
	var defaults = __webpack_require__(532);
	
	module.exports = setOptions;
	
	function setOptions(options) {
	  var self = this;
	  var current = self.options;
	  var key;
	  var value;
	
	  if (options == null) {
	    options = {};
	  } else if (typeof options === 'object') {
	    options = xtend(options);
	  } else {
	    throw new Error(
	      'Invalid value `' + options + '` ' +
	      'for setting `options`'
	    );
	  }
	
	  for (key in defaults) {
	    value = options[key];
	
	    if (value == null) {
	      value = current[key];
	    }
	
	    if (
	      (key !== 'blocks' && typeof value !== 'boolean') ||
	      (key === 'blocks' && typeof value !== 'object')
	    ) {
	      throw new Error('Invalid value `' + value + '` for setting `options.' + key + '`');
	    }
	
	    options[key] = value;
	  }
	
	  self.options = options;
	  self.escape = escapes(options);
	
	  return self;
	}


/***/ },
/* 1381 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var whitespace = __webpack_require__(50);
	var decode = __webpack_require__(315);
	var locate = __webpack_require__(534);
	
	module.exports = autoLink;
	autoLink.locator = locate;
	autoLink.notInLink = true;
	
	var C_LT = '<';
	var C_GT = '>';
	var C_AT_SIGN = '@';
	var C_SLASH = '/';
	var MAILTO = 'mailto:';
	var MAILTO_LENGTH = MAILTO.length;
	
	/* Tokenise a link. */
	function autoLink(eat, value, silent) {
	  var self;
	  var subvalue;
	  var length;
	  var index;
	  var queue;
	  var character;
	  var hasAtCharacter;
	  var link;
	  var now;
	  var content;
	  var tokenizers;
	  var exit;
	
	  if (value.charAt(0) !== C_LT) {
	    return;
	  }
	
	  self = this;
	  subvalue = '';
	  length = value.length;
	  index = 0;
	  queue = '';
	  hasAtCharacter = false;
	  link = '';
	
	  index++;
	  subvalue = C_LT;
	
	  while (index < length) {
	    character = value.charAt(index);
	
	    if (
	      whitespace(character) ||
	      character === C_GT ||
	      character === C_AT_SIGN ||
	      (character === ':' && value.charAt(index + 1) === C_SLASH)
	    ) {
	      break;
	    }
	
	    queue += character;
	    index++;
	  }
	
	  if (!queue) {
	    return;
	  }
	
	  link += queue;
	  queue = '';
	
	  character = value.charAt(index);
	  link += character;
	  index++;
	
	  if (character === C_AT_SIGN) {
	    hasAtCharacter = true;
	  } else {
	    if (
	      character !== ':' ||
	      value.charAt(index + 1) !== C_SLASH
	    ) {
	      return;
	    }
	
	    link += C_SLASH;
	    index++;
	  }
	
	  while (index < length) {
	    character = value.charAt(index);
	
	    if (whitespace(character) || character === C_GT) {
	      break;
	    }
	
	    queue += character;
	    index++;
	  }
	
	  character = value.charAt(index);
	
	  if (!queue || character !== C_GT) {
	    return;
	  }
	
	  /* istanbul ignore if - never used (yet) */
	  if (silent) {
	    return true;
	  }
	
	  link += queue;
	  content = link;
	  subvalue += link + character;
	  now = eat.now();
	  now.column++;
	  now.offset++;
	
	  if (hasAtCharacter) {
	    if (link.slice(0, MAILTO_LENGTH).toLowerCase() === MAILTO) {
	      content = content.substr(MAILTO_LENGTH);
	      now.column += MAILTO_LENGTH;
	      now.offset += MAILTO_LENGTH;
	    } else {
	      link = MAILTO + link;
	    }
	  }
	
	  /* Temporarily remove all tokenizers except text in autolinks. */
	  tokenizers = self.inlineTokenizers;
	  self.inlineTokenizers = {text: tokenizers.text};
	
	  exit = self.enterLink();
	
	  content = self.tokenizeInline(content, now);
	
	  self.inlineTokenizers = tokenizers;
	  exit();
	
	  return eat(subvalue)({
	    type: 'link',
	    title: null,
	    url: decode(link, {nonTerminated: false}),
	    children: content
	  });
	}


/***/ },
/* 1382 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var trim = __webpack_require__(124);
	var interrupt = __webpack_require__(322);
	
	module.exports = blockquote;
	
	var C_NEWLINE = '\n';
	var C_TAB = '\t';
	var C_SPACE = ' ';
	var C_GT = '>';
	
	/* Tokenise a blockquote. */
	function blockquote(eat, value, silent) {
	  var self = this;
	  var offsets = self.offset;
	  var tokenizers = self.blockTokenizers;
	  var interruptors = self.interruptBlockquote;
	  var now = eat.now();
	  var currentLine = now.line;
	  var length = value.length;
	  var values = [];
	  var contents = [];
	  var indents = [];
	  var add;
	  var index = 0;
	  var character;
	  var rest;
	  var nextIndex;
	  var content;
	  var line;
	  var startIndex;
	  var prefixed;
	  var exit;
	
	  while (index < length) {
	    character = value.charAt(index);
	
	    if (character !== C_SPACE && character !== C_TAB) {
	      break;
	    }
	
	    index++;
	  }
	
	  if (value.charAt(index) !== C_GT) {
	    return;
	  }
	
	  if (silent) {
	    return true;
	  }
	
	  index = 0;
	
	  while (index < length) {
	    nextIndex = value.indexOf(C_NEWLINE, index);
	    startIndex = index;
	    prefixed = false;
	
	    if (nextIndex === -1) {
	      nextIndex = length;
	    }
	
	    while (index < length) {
	      character = value.charAt(index);
	
	      if (character !== C_SPACE && character !== C_TAB) {
	        break;
	      }
	
	      index++;
	    }
	
	    if (value.charAt(index) === C_GT) {
	      index++;
	      prefixed = true;
	
	      if (value.charAt(index) === C_SPACE) {
	        index++;
	      }
	    } else {
	      index = startIndex;
	    }
	
	    content = value.slice(index, nextIndex);
	
	    if (!prefixed && !trim(content)) {
	      index = startIndex;
	      break;
	    }
	
	    if (!prefixed) {
	      rest = value.slice(index);
	
	      /* Check if the following code contains a possible
	       * block. */
	      if (interrupt(interruptors, tokenizers, self, [eat, rest, true])) {
	        break;
	      }
	    }
	
	    line = startIndex === index ? content : value.slice(startIndex, nextIndex);
	
	    indents.push(index - startIndex);
	    values.push(line);
	    contents.push(content);
	
	    index = nextIndex + 1;
	  }
	
	  index = -1;
	  length = indents.length;
	  add = eat(values.join(C_NEWLINE));
	
	  while (++index < length) {
	    offsets[currentLine] = (offsets[currentLine] || 0) + indents[index];
	    currentLine++;
	  }
	
	  exit = self.enterBlock();
	  contents = self.tokenizeBlock(contents.join(C_NEWLINE), now);
	  exit();
	
	  return add({
	    type: 'blockquote',
	    children: contents
	  });
	}


/***/ },
/* 1383 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var locate = __webpack_require__(1371);
	
	module.exports = hardBreak;
	hardBreak.locator = locate;
	
	var MIN_BREAK_LENGTH = 2;
	
	function hardBreak(eat, value, silent) {
	  var length = value.length;
	  var index = -1;
	  var queue = '';
	  var character;
	
	  while (++index < length) {
	    character = value.charAt(index);
	
	    if (character === '\n') {
	      if (index < MIN_BREAK_LENGTH) {
	        return;
	      }
	
	      /* istanbul ignore if - never used (yet) */
	      if (silent) {
	        return true;
	      }
	
	      queue += character;
	
	      return eat(queue)({type: 'break'});
	    }
	
	    if (character !== ' ') {
	      return;
	    }
	
	    queue += character;
	  }
	}


/***/ },
/* 1384 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var trim = __webpack_require__(326);
	
	module.exports = fencedCode;
	
	var C_NEWLINE = '\n';
	var C_TAB = '\t';
	var C_SPACE = ' ';
	var C_TILDE = '~';
	var C_TICK = '`';
	
	var MIN_FENCE_COUNT = 3;
	var CODE_INDENT_COUNT = 4;
	
	function fencedCode(eat, value, silent) {
	  var self = this;
	  var settings = self.options;
	  var length = value.length + 1;
	  var index = 0;
	  var subvalue = '';
	  var fenceCount;
	  var marker;
	  var character;
	  var flag;
	  var queue;
	  var content;
	  var exdentedContent;
	  var closing;
	  var exdentedClosing;
	  var indent;
	  var now;
	
	  if (!settings.gfm) {
	    return;
	  }
	
	  /* Eat initial spacing. */
	  while (index < length) {
	    character = value.charAt(index);
	
	    if (character !== C_SPACE && character !== C_TAB) {
	      break;
	    }
	
	    subvalue += character;
	    index++;
	  }
	
	  indent = index;
	
	  /* Eat the fence. */
	  character = value.charAt(index);
	
	  if (character !== C_TILDE && character !== C_TICK) {
	    return;
	  }
	
	  index++;
	  marker = character;
	  fenceCount = 1;
	  subvalue += character;
	
	  while (index < length) {
	    character = value.charAt(index);
	
	    if (character !== marker) {
	      break;
	    }
	
	    subvalue += character;
	    fenceCount++;
	    index++;
	  }
	
	  if (fenceCount < MIN_FENCE_COUNT) {
	    return;
	  }
	
	  /* Eat spacing before flag. */
	  while (index < length) {
	    character = value.charAt(index);
	
	    if (character !== C_SPACE && character !== C_TAB) {
	      break;
	    }
	
	    subvalue += character;
	    index++;
	  }
	
	  /* Eat flag. */
	  flag = '';
	  queue = '';
	
	  while (index < length) {
	    character = value.charAt(index);
	
	    if (
	      character === C_NEWLINE ||
	      character === C_TILDE ||
	      character === C_TICK
	    ) {
	      break;
	    }
	
	    if (character === C_SPACE || character === C_TAB) {
	      queue += character;
	    } else {
	      flag += queue + character;
	      queue = '';
	    }
	
	    index++;
	  }
	
	  character = value.charAt(index);
	
	  if (character && character !== C_NEWLINE) {
	    return;
	  }
	
	  if (silent) {
	    return true;
	  }
	
	  now = eat.now();
	  now.column += subvalue.length;
	  now.offset += subvalue.length;
	
	  subvalue += flag;
	  flag = self.decode.raw(self.unescape(flag), now);
	
	  if (queue) {
	    subvalue += queue;
	  }
	
	  queue = '';
	  closing = '';
	  exdentedClosing = '';
	  content = '';
	  exdentedContent = '';
	
	  /* Eat content. */
	  while (index < length) {
	    character = value.charAt(index);
	    content += closing;
	    exdentedContent += exdentedClosing;
	    closing = '';
	    exdentedClosing = '';
	
	    if (character !== C_NEWLINE) {
	      content += character;
	      exdentedClosing += character;
	      index++;
	      continue;
	    }
	
	    /* Add the newline to `subvalue` if its the first
	     * character.  Otherwise, add it to the `closing`
	     * queue. */
	    if (content) {
	      closing += character;
	      exdentedClosing += character;
	    } else {
	      subvalue += character;
	    }
	
	    queue = '';
	    index++;
	
	    while (index < length) {
	      character = value.charAt(index);
	
	      if (character !== C_SPACE) {
	        break;
	      }
	
	      queue += character;
	      index++;
	    }
	
	    closing += queue;
	    exdentedClosing += queue.slice(indent);
	
	    if (queue.length >= CODE_INDENT_COUNT) {
	      continue;
	    }
	
	    queue = '';
	
	    while (index < length) {
	      character = value.charAt(index);
	
	      if (character !== marker) {
	        break;
	      }
	
	      queue += character;
	      index++;
	    }
	
	    closing += queue;
	    exdentedClosing += queue;
	
	    if (queue.length < fenceCount) {
	      continue;
	    }
	
	    queue = '';
	
	    while (index < length) {
	      character = value.charAt(index);
	
	      if (character !== C_SPACE && character !== C_TAB) {
	        break;
	      }
	
	      closing += character;
	      exdentedClosing += character;
	      index++;
	    }
	
	    if (!character || character === C_NEWLINE) {
	      break;
	    }
	  }
	
	  subvalue += content + closing;
	
	  return eat(subvalue)({
	    type: 'code',
	    lang: flag || null,
	    value: trim(exdentedContent)
	  });
	}


/***/ },
/* 1385 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var repeat = __webpack_require__(324);
	var trim = __webpack_require__(326);
	
	module.exports = indentedCode;
	
	var C_NEWLINE = '\n';
	var C_TAB = '\t';
	var C_SPACE = ' ';
	
	var CODE_INDENT_COUNT = 4;
	var CODE_INDENT = repeat(C_SPACE, CODE_INDENT_COUNT);
	
	/* Tokenise indented code. */
	function indentedCode(eat, value, silent) {
	  var index = -1;
	  var length = value.length;
	  var subvalue = '';
	  var content = '';
	  var subvalueQueue = '';
	  var contentQueue = '';
	  var character;
	  var blankQueue;
	  var indent;
	
	  while (++index < length) {
	    character = value.charAt(index);
	
	    if (indent) {
	      indent = false;
	
	      subvalue += subvalueQueue;
	      content += contentQueue;
	      subvalueQueue = '';
	      contentQueue = '';
	
	      if (character === C_NEWLINE) {
	        subvalueQueue = character;
	        contentQueue = character;
	      } else {
	        subvalue += character;
	        content += character;
	
	        while (++index < length) {
	          character = value.charAt(index);
	
	          if (!character || character === C_NEWLINE) {
	            contentQueue = character;
	            subvalueQueue = character;
	            break;
	          }
	
	          subvalue += character;
	          content += character;
	        }
	      }
	    } else if (
	      character === C_SPACE &&
	      value.charAt(index + 1) === character &&
	      value.charAt(index + 2) === character &&
	      value.charAt(index + 3) === character
	    ) {
	      subvalueQueue += CODE_INDENT;
	      index += 3;
	      indent = true;
	    } else if (character === C_TAB) {
	      subvalueQueue += character;
	      indent = true;
	    } else {
	      blankQueue = '';
	
	      while (character === C_TAB || character === C_SPACE) {
	        blankQueue += character;
	        character = value.charAt(++index);
	      }
	
	      if (character !== C_NEWLINE) {
	        break;
	      }
	
	      subvalueQueue += blankQueue + character;
	      contentQueue += character;
	    }
	  }
	
	  if (content) {
	    if (silent) {
	      return true;
	    }
	
	    return eat(subvalue)({
	      type: 'code',
	      lang: null,
	      value: trim(content)
	    });
	  }
	}


/***/ },
/* 1386 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var whitespace = __webpack_require__(50);
	var locate = __webpack_require__(1372);
	
	module.exports = inlineCode;
	inlineCode.locator = locate;
	
	var C_TICK = '`';
	
	/* Tokenise inline code. */
	function inlineCode(eat, value, silent) {
	  var length = value.length;
	  var index = 0;
	  var queue = '';
	  var tickQueue = '';
	  var contentQueue;
	  var subqueue;
	  var count;
	  var openingCount;
	  var subvalue;
	  var character;
	  var found;
	  var next;
	
	  while (index < length) {
	    if (value.charAt(index) !== C_TICK) {
	      break;
	    }
	
	    queue += C_TICK;
	    index++;
	  }
	
	  if (!queue) {
	    return;
	  }
	
	  subvalue = queue;
	  openingCount = index;
	  queue = '';
	  next = value.charAt(index);
	  count = 0;
	
	  while (index < length) {
	    character = next;
	    next = value.charAt(index + 1);
	
	    if (character === C_TICK) {
	      count++;
	      tickQueue += character;
	    } else {
	      count = 0;
	      queue += character;
	    }
	
	    if (count && next !== C_TICK) {
	      if (count === openingCount) {
	        subvalue += queue + tickQueue;
	        found = true;
	        break;
	      }
	
	      queue += tickQueue;
	      tickQueue = '';
	    }
	
	    index++;
	  }
	
	  if (!found) {
	    if (openingCount % 2 !== 0) {
	      return;
	    }
	
	    queue = '';
	  }
	
	  /* istanbul ignore if - never used (yet) */
	  if (silent) {
	    return true;
	  }
	
	  contentQueue = '';
	  subqueue = '';
	  length = queue.length;
	  index = -1;
	
	  while (++index < length) {
	    character = queue.charAt(index);
	
	    if (whitespace(character)) {
	      subqueue += character;
	      continue;
	    }
	
	    if (subqueue) {
	      if (contentQueue) {
	        contentQueue += subqueue;
	      }
	
	      subqueue = '';
	    }
	
	    contentQueue += character;
	  }
	
	  return eat(subvalue)({
	    type: 'inlineCode',
	    value: contentQueue
	  });
	}


/***/ },
/* 1387 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var whitespace = __webpack_require__(50);
	var normalize = __webpack_require__(323);
	
	module.exports = definition;
	definition.notInList = true;
	definition.notInBlock = true;
	
	var C_DOUBLE_QUOTE = '"';
	var C_SINGLE_QUOTE = '\'';
	var C_BACKSLASH = '\\';
	var C_NEWLINE = '\n';
	var C_TAB = '\t';
	var C_SPACE = ' ';
	var C_BRACKET_OPEN = '[';
	var C_BRACKET_CLOSE = ']';
	var C_PAREN_OPEN = '(';
	var C_PAREN_CLOSE = ')';
	var C_COLON = ':';
	var C_LT = '<';
	var C_GT = '>';
	
	function definition(eat, value, silent) {
	  var self = this;
	  var commonmark = self.options.commonmark;
	  var index = 0;
	  var length = value.length;
	  var subvalue = '';
	  var beforeURL;
	  var beforeTitle;
	  var queue;
	  var character;
	  var test;
	  var identifier;
	  var url;
	  var title;
	
	  while (index < length) {
	    character = value.charAt(index);
	
	    if (character !== C_SPACE && character !== C_TAB) {
	      break;
	    }
	
	    subvalue += character;
	    index++;
	  }
	
	  character = value.charAt(index);
	
	  if (character !== C_BRACKET_OPEN) {
	    return;
	  }
	
	  index++;
	  subvalue += character;
	  queue = '';
	
	  while (index < length) {
	    character = value.charAt(index);
	
	    if (character === C_BRACKET_CLOSE) {
	      break;
	    } else if (character === C_BACKSLASH) {
	      queue += character;
	      index++;
	      character = value.charAt(index);
	    }
	
	    queue += character;
	    index++;
	  }
	
	  if (
	    !queue ||
	    value.charAt(index) !== C_BRACKET_CLOSE ||
	    value.charAt(index + 1) !== C_COLON
	  ) {
	    return;
	  }
	
	  identifier = queue;
	  subvalue += queue + C_BRACKET_CLOSE + C_COLON;
	  index = subvalue.length;
	  queue = '';
	
	  while (index < length) {
	    character = value.charAt(index);
	
	    if (
	      character !== C_TAB &&
	      character !== C_SPACE &&
	      character !== C_NEWLINE
	    ) {
	      break;
	    }
	
	    subvalue += character;
	    index++;
	  }
	
	  character = value.charAt(index);
	  queue = '';
	  beforeURL = subvalue;
	
	  if (character === C_LT) {
	    index++;
	
	    while (index < length) {
	      character = value.charAt(index);
	
	      if (!isEnclosedURLCharacter(character)) {
	        break;
	      }
	
	      queue += character;
	      index++;
	    }
	
	    character = value.charAt(index);
	
	    if (character === isEnclosedURLCharacter.delimiter) {
	      subvalue += C_LT + queue + character;
	      index++;
	    } else {
	      if (commonmark) {
	        return;
	      }
	
	      index -= queue.length + 1;
	      queue = '';
	    }
	  }
	
	  if (!queue) {
	    while (index < length) {
	      character = value.charAt(index);
	
	      if (!isUnclosedURLCharacter(character)) {
	        break;
	      }
	
	      queue += character;
	      index++;
	    }
	
	    subvalue += queue;
	  }
	
	  if (!queue) {
	    return;
	  }
	
	  url = queue;
	  queue = '';
	
	  while (index < length) {
	    character = value.charAt(index);
	
	    if (
	      character !== C_TAB &&
	      character !== C_SPACE &&
	      character !== C_NEWLINE
	    ) {
	      break;
	    }
	
	    queue += character;
	    index++;
	  }
	
	  character = value.charAt(index);
	  test = null;
	
	  if (character === C_DOUBLE_QUOTE) {
	    test = C_DOUBLE_QUOTE;
	  } else if (character === C_SINGLE_QUOTE) {
	    test = C_SINGLE_QUOTE;
	  } else if (character === C_PAREN_OPEN) {
	    test = C_PAREN_CLOSE;
	  }
	
	  if (!test) {
	    queue = '';
	    index = subvalue.length;
	  } else if (queue) {
	    subvalue += queue + character;
	    index = subvalue.length;
	    queue = '';
	
	    while (index < length) {
	      character = value.charAt(index);
	
	      if (character === test) {
	        break;
	      }
	
	      if (character === C_NEWLINE) {
	        index++;
	        character = value.charAt(index);
	
	        if (character === C_NEWLINE || character === test) {
	          return;
	        }
	
	        queue += C_NEWLINE;
	      }
	
	      queue += character;
	      index++;
	    }
	
	    character = value.charAt(index);
	
	    if (character !== test) {
	      return;
	    }
	
	    beforeTitle = subvalue;
	    subvalue += queue + character;
	    index++;
	    title = queue;
	    queue = '';
	  } else {
	    return;
	  }
	
	  while (index < length) {
	    character = value.charAt(index);
	
	    if (character !== C_TAB && character !== C_SPACE) {
	      break;
	    }
	
	    subvalue += character;
	    index++;
	  }
	
	  character = value.charAt(index);
	
	  if (!character || character === C_NEWLINE) {
	    if (silent) {
	      return true;
	    }
	
	    beforeURL = eat(beforeURL).test().end;
	    url = self.decode.raw(self.unescape(url), beforeURL, {nonTerminated: false});
	
	    if (title) {
	      beforeTitle = eat(beforeTitle).test().end;
	      title = self.decode.raw(self.unescape(title), beforeTitle);
	    }
	
	    return eat(subvalue)({
	      type: 'definition',
	      identifier: normalize(identifier),
	      title: title || null,
	      url: url
	    });
	  }
	}
	
	/* Check if `character` can be inside an enclosed URI. */
	function isEnclosedURLCharacter(character) {
	  return character !== C_GT &&
	    character !== C_BRACKET_OPEN &&
	    character !== C_BRACKET_CLOSE;
	}
	
	isEnclosedURLCharacter.delimiter = C_GT;
	
	/* Check if `character` can be inside an unclosed URI. */
	function isUnclosedURLCharacter(character) {
	  return character !== C_BRACKET_OPEN &&
	    character !== C_BRACKET_CLOSE &&
	    !whitespace(character);
	}


/***/ },
/* 1388 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var whitespace = __webpack_require__(50);
	var locate = __webpack_require__(1373);
	
	module.exports = strikethrough;
	strikethrough.locator = locate;
	
	var C_TILDE = '~';
	var DOUBLE = '~~';
	
	function strikethrough(eat, value, silent) {
	  var self = this;
	  var character = '';
	  var previous = '';
	  var preceding = '';
	  var subvalue = '';
	  var index;
	  var length;
	  var now;
	
	  if (
	    !self.options.gfm ||
	    value.charAt(0) !== C_TILDE ||
	    value.charAt(1) !== C_TILDE ||
	    whitespace(value.charAt(2))
	  ) {
	    return;
	  }
	
	  index = 1;
	  length = value.length;
	  now = eat.now();
	  now.column += 2;
	  now.offset += 2;
	
	  while (++index < length) {
	    character = value.charAt(index);
	
	    if (
	      character === C_TILDE &&
	      previous === C_TILDE &&
	      (!preceding || !whitespace(preceding))
	    ) {
	      /* istanbul ignore if - never used (yet) */
	      if (silent) {
	        return true;
	      }
	
	      return eat(DOUBLE + subvalue + DOUBLE)({
	        type: 'delete',
	        children: self.tokenizeInline(subvalue, now)
	      });
	    }
	
	    subvalue += previous;
	    preceding = previous;
	    previous = character;
	  }
	}


/***/ },
/* 1389 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var trim = __webpack_require__(124);
	var word = __webpack_require__(1176);
	var whitespace = __webpack_require__(50);
	var locate = __webpack_require__(1374);
	
	module.exports = emphasis;
	emphasis.locator = locate;
	
	var C_ASTERISK = '*';
	var C_UNDERSCORE = '_';
	
	function emphasis(eat, value, silent) {
	  var self = this;
	  var index = 0;
	  var character = value.charAt(index);
	  var now;
	  var pedantic;
	  var marker;
	  var queue;
	  var subvalue;
	  var length;
	  var prev;
	
	  if (character !== C_ASTERISK && character !== C_UNDERSCORE) {
	    return;
	  }
	
	  pedantic = self.options.pedantic;
	  subvalue = character;
	  marker = character;
	  length = value.length;
	  index++;
	  queue = '';
	  character = '';
	
	  if (pedantic && whitespace(value.charAt(index))) {
	    return;
	  }
	
	  while (index < length) {
	    prev = character;
	    character = value.charAt(index);
	
	    if (character === marker && (!pedantic || !whitespace(prev))) {
	      character = value.charAt(++index);
	
	      if (character !== marker) {
	        if (!trim(queue) || prev === marker) {
	          return;
	        }
	
	        if (!pedantic && marker === C_UNDERSCORE && word(character)) {
	          queue += marker;
	          continue;
	        }
	
	        /* istanbul ignore if - never used (yet) */
	        if (silent) {
	          return true;
	        }
	
	        now = eat.now();
	        now.column++;
	        now.offset++;
	
	        return eat(subvalue + queue + marker)({
	          type: 'emphasis',
	          children: self.tokenizeInline(queue, now)
	        });
	      }
	
	      queue += marker;
	    }
	
	    if (!pedantic && character === '\\') {
	      queue += character;
	      character = value.charAt(++index);
	    }
	
	    queue += character;
	    index++;
	  }
	}


/***/ },
/* 1390 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var locate = __webpack_require__(1375);
	
	module.exports = escape;
	escape.locator = locate;
	
	function escape(eat, value, silent) {
	  var self = this;
	  var character;
	  var node;
	
	  if (value.charAt(0) === '\\') {
	    character = value.charAt(1);
	
	    if (self.escape.indexOf(character) !== -1) {
	      /* istanbul ignore if - never used (yet) */
	      if (silent) {
	        return true;
	      }
	
	      if (character === '\n') {
	        node = {type: 'break'};
	      } else {
	        node = {
	          type: 'text',
	          value: character
	        };
	      }
	
	      return eat('\\' + character)(node);
	    }
	  }
	}


/***/ },
/* 1391 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var whitespace = __webpack_require__(50);
	var normalize = __webpack_require__(323);
	
	module.exports = footnoteDefinition;
	footnoteDefinition.notInList = true;
	footnoteDefinition.notInBlock = true;
	
	var C_BACKSLASH = '\\';
	var C_NEWLINE = '\n';
	var C_TAB = '\t';
	var C_SPACE = ' ';
	var C_BRACKET_OPEN = '[';
	var C_BRACKET_CLOSE = ']';
	var C_CARET = '^';
	var C_COLON = ':';
	
	var EXPRESSION_INITIAL_TAB = /^( {4}|\t)?/gm;
	
	function footnoteDefinition(eat, value, silent) {
	  var self = this;
	  var offsets = self.offset;
	  var index;
	  var length;
	  var subvalue;
	  var now;
	  var currentLine;
	  var content;
	  var queue;
	  var subqueue;
	  var character;
	  var identifier;
	  var add;
	  var exit;
	
	  if (!self.options.footnotes) {
	    return;
	  }
	
	  index = 0;
	  length = value.length;
	  subvalue = '';
	  now = eat.now();
	  currentLine = now.line;
	
	  while (index < length) {
	    character = value.charAt(index);
	
	    if (!whitespace(character)) {
	      break;
	    }
	
	    subvalue += character;
	    index++;
	  }
	
	  if (
	    value.charAt(index) !== C_BRACKET_OPEN ||
	    value.charAt(index + 1) !== C_CARET
	  ) {
	    return;
	  }
	
	  subvalue += C_BRACKET_OPEN + C_CARET;
	  index = subvalue.length;
	  queue = '';
	
	  while (index < length) {
	    character = value.charAt(index);
	
	    if (character === C_BRACKET_CLOSE) {
	      break;
	    } else if (character === C_BACKSLASH) {
	      queue += character;
	      index++;
	      character = value.charAt(index);
	    }
	
	    queue += character;
	    index++;
	  }
	
	  if (
	    !queue ||
	    value.charAt(index) !== C_BRACKET_CLOSE ||
	    value.charAt(index + 1) !== C_COLON
	  ) {
	    return;
	  }
	
	  if (silent) {
	    return true;
	  }
	
	  identifier = normalize(queue);
	  subvalue += queue + C_BRACKET_CLOSE + C_COLON;
	  index = subvalue.length;
	
	  while (index < length) {
	    character = value.charAt(index);
	
	    if (character !== C_TAB && character !== C_SPACE) {
	      break;
	    }
	
	    subvalue += character;
	    index++;
	  }
	
	  now.column += subvalue.length;
	  now.offset += subvalue.length;
	  queue = '';
	  content = '';
	  subqueue = '';
	
	  while (index < length) {
	    character = value.charAt(index);
	
	    if (character === C_NEWLINE) {
	      subqueue = character;
	      index++;
	
	      while (index < length) {
	        character = value.charAt(index);
	
	        if (character !== C_NEWLINE) {
	          break;
	        }
	
	        subqueue += character;
	        index++;
	      }
	
	      queue += subqueue;
	      subqueue = '';
	
	      while (index < length) {
	        character = value.charAt(index);
	
	        if (character !== C_SPACE) {
	          break;
	        }
	
	        subqueue += character;
	        index++;
	      }
	
	      if (subqueue.length === 0) {
	        break;
	      }
	
	      queue += subqueue;
	    }
	
	    if (queue) {
	      content += queue;
	      queue = '';
	    }
	
	    content += character;
	    index++;
	  }
	
	  subvalue += content;
	
	  content = content.replace(EXPRESSION_INITIAL_TAB, function (line) {
	    offsets[currentLine] = (offsets[currentLine] || 0) + line.length;
	    currentLine++;
	
	    return '';
	  });
	
	  add = eat(subvalue);
	
	  exit = self.enterBlock();
	  content = self.tokenizeBlock(content, now);
	  exit();
	
	  return add({
	    type: 'footnoteDefinition',
	    identifier: identifier,
	    children: content
	  });
	}


/***/ },
/* 1392 */
/***/ function(module, exports) {

	'use strict';
	
	module.exports = atxHeading;
	
	var C_NEWLINE = '\n';
	var C_TAB = '\t';
	var C_SPACE = ' ';
	var C_HASH = '#';
	
	var MAX_ATX_COUNT = 6;
	
	function atxHeading(eat, value, silent) {
	  var self = this;
	  var settings = self.options;
	  var length = value.length + 1;
	  var index = -1;
	  var now = eat.now();
	  var subvalue = '';
	  var content = '';
	  var character;
	  var queue;
	  var depth;
	
	  /* Eat initial spacing. */
	  while (++index < length) {
	    character = value.charAt(index);
	
	    if (character !== C_SPACE && character !== C_TAB) {
	      index--;
	      break;
	    }
	
	    subvalue += character;
	  }
	
	  /* Eat hashes. */
	  depth = 0;
	
	  while (++index <= length) {
	    character = value.charAt(index);
	
	    if (character !== C_HASH) {
	      index--;
	      break;
	    }
	
	    subvalue += character;
	    depth++;
	  }
	
	  if (depth > MAX_ATX_COUNT) {
	    return;
	  }
	
	  if (
	    !depth ||
	    (!settings.pedantic && value.charAt(index + 1) === C_HASH)
	  ) {
	    return;
	  }
	
	  length = value.length + 1;
	
	  /* Eat intermediate white-space. */
	  queue = '';
	
	  while (++index < length) {
	    character = value.charAt(index);
	
	    if (character !== C_SPACE && character !== C_TAB) {
	      index--;
	      break;
	    }
	
	    queue += character;
	  }
	
	  /* Exit when not in pedantic mode without spacing. */
	  if (
	    !settings.pedantic &&
	    queue.length === 0 &&
	    character &&
	    character !== C_NEWLINE
	  ) {
	    return;
	  }
	
	  if (silent) {
	    return true;
	  }
	
	  /* Eat content. */
	  subvalue += queue;
	  queue = '';
	  content = '';
	
	  while (++index < length) {
	    character = value.charAt(index);
	
	    if (!character || character === C_NEWLINE) {
	      break;
	    }
	
	    if (
	      character !== C_SPACE &&
	      character !== C_TAB &&
	      character !== C_HASH
	    ) {
	      content += queue + character;
	      queue = '';
	      continue;
	    }
	
	    while (character === C_SPACE || character === C_TAB) {
	      queue += character;
	      character = value.charAt(++index);
	    }
	
	    while (character === C_HASH) {
	      queue += character;
	      character = value.charAt(++index);
	    }
	
	    while (character === C_SPACE || character === C_TAB) {
	      queue += character;
	      character = value.charAt(++index);
	    }
	
	    index--;
	  }
	
	  now.column += subvalue.length;
	  now.offset += subvalue.length;
	  subvalue += content + queue;
	
	  return eat(subvalue)({
	    type: 'heading',
	    depth: depth,
	    children: self.tokenizeInline(content, now)
	  });
	}


/***/ },
/* 1393 */
/***/ function(module, exports) {

	'use strict';
	
	module.exports = setextHeading;
	
	var C_NEWLINE = '\n';
	var C_TAB = '\t';
	var C_SPACE = ' ';
	var C_EQUALS = '=';
	var C_DASH = '-';
	
	var MAX_HEADING_INDENT = 3;
	
	/* Map of characters which can be used to mark setext
	 * headers, mapping to their corresponding depth. */
	var SETEXT_MARKERS = {};
	
	SETEXT_MARKERS[C_EQUALS] = 1;
	SETEXT_MARKERS[C_DASH] = 2;
	
	function setextHeading(eat, value, silent) {
	  var self = this;
	  var now = eat.now();
	  var length = value.length;
	  var index = -1;
	  var subvalue = '';
	  var content;
	  var queue;
	  var character;
	  var marker;
	  var depth;
	
	  /* Eat initial indentation. */
	  while (++index < length) {
	    character = value.charAt(index);
	
	    if (character !== C_SPACE || index >= MAX_HEADING_INDENT) {
	      index--;
	      break;
	    }
	
	    subvalue += character;
	  }
	
	  /* Eat content. */
	  content = '';
	  queue = '';
	
	  while (++index < length) {
	    character = value.charAt(index);
	
	    if (character === C_NEWLINE) {
	      index--;
	      break;
	    }
	
	    if (character === C_SPACE || character === C_TAB) {
	      queue += character;
	    } else {
	      content += queue + character;
	      queue = '';
	    }
	  }
	
	  now.column += subvalue.length;
	  now.offset += subvalue.length;
	  subvalue += content + queue;
	
	  /* Ensure the content is followed by a newline and a
	   * valid marker. */
	  character = value.charAt(++index);
	  marker = value.charAt(++index);
	
	  if (character !== C_NEWLINE || !SETEXT_MARKERS[marker]) {
	    return;
	  }
	
	  subvalue += character;
	
	  /* Eat Setext-line. */
	  queue = marker;
	  depth = SETEXT_MARKERS[marker];
	
	  while (++index < length) {
	    character = value.charAt(index);
	
	    if (character !== marker) {
	      if (character !== C_NEWLINE) {
	        return;
	      }
	
	      index--;
	      break;
	    }
	
	    queue += character;
	  }
	
	  if (silent) {
	    return true;
	  }
	
	  return eat(subvalue + queue)({
	    type: 'heading',
	    depth: depth,
	    children: self.tokenizeInline(content, now)
	  });
	}


/***/ },
/* 1394 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var openCloseTag = __webpack_require__(536).openCloseTag;
	
	module.exports = blockHTML;
	
	var C_TAB = '\t';
	var C_SPACE = ' ';
	var C_NEWLINE = '\n';
	var C_LT = '<';
	
	function blockHTML(eat, value, silent) {
	  var self = this;
	  var blocks = self.options.blocks;
	  var length = value.length;
	  var index = 0;
	  var next;
	  var line;
	  var offset;
	  var character;
	  var count;
	  var sequence;
	  var subvalue;
	
	  var sequences = [
	    [/^<(script|pre|style)(?=(\s|>|$))/i, /<\/(script|pre|style)>/i, true],
	    [/^<!--/, /-->/, true],
	    [/^<\?/, /\?>/, true],
	    [/^<![A-Za-z]/, />/, true],
	    [/^<!\[CDATA\[/, /\]\]>/, true],
	    [new RegExp('^</?(' + blocks.join('|') + ')(?=(\\s|/?>|$))', 'i'), /^$/, true],
	    [new RegExp(openCloseTag.source + '\\s*$'), /^$/, false]
	  ];
	
	  /* Eat initial spacing. */
	  while (index < length) {
	    character = value.charAt(index);
	
	    if (character !== C_TAB && character !== C_SPACE) {
	      break;
	    }
	
	    index++;
	  }
	
	  if (value.charAt(index) !== C_LT) {
	    return;
	  }
	
	  next = value.indexOf(C_NEWLINE, index + 1);
	  next = next === -1 ? length : next;
	  line = value.slice(index, next);
	  offset = -1;
	  count = sequences.length;
	
	  while (++offset < count) {
	    if (sequences[offset][0].test(line)) {
	      sequence = sequences[offset];
	      break;
	    }
	  }
	
	  if (!sequence) {
	    return;
	  }
	
	  if (silent) {
	    return sequence[2];
	  }
	
	  index = next;
	
	  if (!sequence[1].test(line)) {
	    while (index < length) {
	      next = value.indexOf(C_NEWLINE, index + 1);
	      next = next === -1 ? length : next;
	      line = value.slice(index + 1, next);
	
	      if (sequence[1].test(line)) {
	        if (line) {
	          index = next;
	        }
	
	        break;
	      }
	
	      index = next;
	    }
	  }
	
	  subvalue = value.slice(0, index);
	
	  return eat(subvalue)({type: 'html', value: subvalue});
	}


/***/ },
/* 1395 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var alphabetical = __webpack_require__(480);
	var locate = __webpack_require__(534);
	var tag = __webpack_require__(536).tag;
	
	module.exports = inlineHTML;
	inlineHTML.locator = locate;
	
	var EXPRESSION_HTML_LINK_OPEN = /^<a /i;
	var EXPRESSION_HTML_LINK_CLOSE = /^<\/a>/i;
	
	function inlineHTML(eat, value, silent) {
	  var self = this;
	  var length = value.length;
	  var character;
	  var subvalue;
	
	  if (value.charAt(0) !== '<' || length < 3) {
	    return;
	  }
	
	  character = value.charAt(1);
	
	  if (
	    !alphabetical(character) &&
	    character !== '?' &&
	    character !== '!' &&
	    character !== '/'
	  ) {
	    return;
	  }
	
	  subvalue = value.match(tag);
	
	  if (!subvalue) {
	    return;
	  }
	
	  /* istanbul ignore if - not used yet. */
	  if (silent) {
	    return true;
	  }
	
	  subvalue = subvalue[0];
	
	  if (!self.inLink && EXPRESSION_HTML_LINK_OPEN.test(subvalue)) {
	    self.inLink = true;
	  } else if (self.inLink && EXPRESSION_HTML_LINK_CLOSE.test(subvalue)) {
	    self.inLink = false;
	  }
	
	  return eat(subvalue)({type: 'html', value: subvalue});
	}


/***/ },
/* 1396 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var whitespace = __webpack_require__(50);
	var locate = __webpack_require__(533);
	
	module.exports = link;
	link.locator = locate;
	
	var own = {}.hasOwnProperty;
	
	var C_BACKSLASH = '\\';
	var C_BRACKET_OPEN = '[';
	var C_BRACKET_CLOSE = ']';
	var C_PAREN_OPEN = '(';
	var C_PAREN_CLOSE = ')';
	var C_LT = '<';
	var C_GT = '>';
	var C_TICK = '`';
	var C_DOUBLE_QUOTE = '"';
	var C_SINGLE_QUOTE = '\'';
	
	/* Map of characters, which can be used to mark link
	 * and image titles. */
	var LINK_MARKERS = {};
	
	LINK_MARKERS[C_DOUBLE_QUOTE] = C_DOUBLE_QUOTE;
	LINK_MARKERS[C_SINGLE_QUOTE] = C_SINGLE_QUOTE;
	
	/* Map of characters, which can be used to mark link
	 * and image titles in commonmark-mode. */
	var COMMONMARK_LINK_MARKERS = {};
	
	COMMONMARK_LINK_MARKERS[C_DOUBLE_QUOTE] = C_DOUBLE_QUOTE;
	COMMONMARK_LINK_MARKERS[C_SINGLE_QUOTE] = C_SINGLE_QUOTE;
	COMMONMARK_LINK_MARKERS[C_PAREN_OPEN] = C_PAREN_CLOSE;
	
	function link(eat, value, silent) {
	  var self = this;
	  var subvalue = '';
	  var index = 0;
	  var character = value.charAt(0);
	  var pedantic = self.options.pedantic;
	  var commonmark = self.options.commonmark;
	  var gfm = self.options.gfm;
	  var closed;
	  var count;
	  var opening;
	  var beforeURL;
	  var beforeTitle;
	  var subqueue;
	  var hasMarker;
	  var markers;
	  var isImage;
	  var content;
	  var marker;
	  var length;
	  var title;
	  var depth;
	  var queue;
	  var url;
	  var now;
	  var exit;
	  var node;
	
	  /* Detect whether this is an image. */
	  if (character === '!') {
	    isImage = true;
	    subvalue = character;
	    character = value.charAt(++index);
	  }
	
	  /* Eat the opening. */
	  if (character !== C_BRACKET_OPEN) {
	    return;
	  }
	
	  /* Exit when this is a link and we’re already inside
	   * a link. */
	  if (!isImage && self.inLink) {
	    return;
	  }
	
	  subvalue += character;
	  queue = '';
	  index++;
	
	  /* Eat the content. */
	  length = value.length;
	  now = eat.now();
	  depth = 0;
	
	  now.column += index;
	  now.offset += index;
	
	  while (index < length) {
	    character = value.charAt(index);
	    subqueue = character;
	
	    if (character === C_TICK) {
	      /* Inline-code in link content. */
	      count = 1;
	
	      while (value.charAt(index + 1) === C_TICK) {
	        subqueue += character;
	        index++;
	        count++;
	      }
	
	      if (!opening) {
	        opening = count;
	      } else if (count >= opening) {
	        opening = 0;
	      }
	    } else if (character === C_BACKSLASH) {
	      /* Allow brackets to be escaped. */
	      index++;
	      subqueue += value.charAt(index);
	    /* In GFM mode, brackets in code still count.
	     * In all other modes, they don’t.  This empty
	     * block prevents the next statements are
	     * entered. */
	    } else if ((!opening || gfm) && character === C_BRACKET_OPEN) {
	      depth++;
	    } else if ((!opening || gfm) && character === C_BRACKET_CLOSE) {
	      if (depth) {
	        depth--;
	      } else {
	        /* Allow white-space between content and
	         * url in GFM mode. */
	        if (!pedantic) {
	          while (index < length) {
	            character = value.charAt(index + 1);
	
	            if (!whitespace(character)) {
	              break;
	            }
	
	            subqueue += character;
	            index++;
	          }
	        }
	
	        if (value.charAt(index + 1) !== C_PAREN_OPEN) {
	          return;
	        }
	
	        subqueue += C_PAREN_OPEN;
	        closed = true;
	        index++;
	
	        break;
	      }
	    }
	
	    queue += subqueue;
	    subqueue = '';
	    index++;
	  }
	
	  /* Eat the content closing. */
	  if (!closed) {
	    return;
	  }
	
	  content = queue;
	  subvalue += queue + subqueue;
	  index++;
	
	  /* Eat white-space. */
	  while (index < length) {
	    character = value.charAt(index);
	
	    if (!whitespace(character)) {
	      break;
	    }
	
	    subvalue += character;
	    index++;
	  }
	
	  /* Eat the URL. */
	  character = value.charAt(index);
	  markers = commonmark ? COMMONMARK_LINK_MARKERS : LINK_MARKERS;
	  queue = '';
	  beforeURL = subvalue;
	
	  if (character === C_LT) {
	    index++;
	    beforeURL += C_LT;
	
	    while (index < length) {
	      character = value.charAt(index);
	
	      if (character === C_GT) {
	        break;
	      }
	
	      if (commonmark && character === '\n') {
	        return;
	      }
	
	      queue += character;
	      index++;
	    }
	
	    if (value.charAt(index) !== C_GT) {
	      return;
	    }
	
	    subvalue += C_LT + queue + C_GT;
	    url = queue;
	    index++;
	  } else {
	    character = null;
	    subqueue = '';
	
	    while (index < length) {
	      character = value.charAt(index);
	
	      if (subqueue && own.call(markers, character)) {
	        break;
	      }
	
	      if (whitespace(character)) {
	        if (!pedantic) {
	          break;
	        }
	
	        subqueue += character;
	      } else {
	        if (character === C_PAREN_OPEN) {
	          depth++;
	        } else if (character === C_PAREN_CLOSE) {
	          if (depth === 0) {
	            break;
	          }
	
	          depth--;
	        }
	
	        queue += subqueue;
	        subqueue = '';
	
	        if (character === C_BACKSLASH) {
	          queue += C_BACKSLASH;
	          character = value.charAt(++index);
	        }
	
	        queue += character;
	      }
	
	      index++;
	    }
	
	    subvalue += queue;
	    url = queue;
	    index = subvalue.length;
	  }
	
	  /* Eat white-space. */
	  queue = '';
	
	  while (index < length) {
	    character = value.charAt(index);
	
	    if (!whitespace(character)) {
	      break;
	    }
	
	    queue += character;
	    index++;
	  }
	
	  character = value.charAt(index);
	  subvalue += queue;
	
	  /* Eat the title. */
	  if (queue && own.call(markers, character)) {
	    index++;
	    subvalue += character;
	    queue = '';
	    marker = markers[character];
	    beforeTitle = subvalue;
	
	    /* In commonmark-mode, things are pretty easy: the
	     * marker cannot occur inside the title.
	     *
	     * Non-commonmark does, however, support nested
	     * delimiters. */
	    if (commonmark) {
	      while (index < length) {
	        character = value.charAt(index);
	
	        if (character === marker) {
	          break;
	        }
	
	        if (character === C_BACKSLASH) {
	          queue += C_BACKSLASH;
	          character = value.charAt(++index);
	        }
	
	        index++;
	        queue += character;
	      }
	
	      character = value.charAt(index);
	
	      if (character !== marker) {
	        return;
	      }
	
	      title = queue;
	      subvalue += queue + character;
	      index++;
	
	      while (index < length) {
	        character = value.charAt(index);
	
	        if (!whitespace(character)) {
	          break;
	        }
	
	        subvalue += character;
	        index++;
	      }
	    } else {
	      subqueue = '';
	
	      while (index < length) {
	        character = value.charAt(index);
	
	        if (character === marker) {
	          if (hasMarker) {
	            queue += marker + subqueue;
	            subqueue = '';
	          }
	
	          hasMarker = true;
	        } else if (!hasMarker) {
	          queue += character;
	        } else if (character === C_PAREN_CLOSE) {
	          subvalue += queue + marker + subqueue;
	          title = queue;
	          break;
	        } else if (whitespace(character)) {
	          subqueue += character;
	        } else {
	          queue += marker + subqueue + character;
	          subqueue = '';
	          hasMarker = false;
	        }
	
	        index++;
	      }
	    }
	  }
	
	  if (value.charAt(index) !== C_PAREN_CLOSE) {
	    return;
	  }
	
	  /* istanbul ignore if - never used (yet) */
	  if (silent) {
	    return true;
	  }
	
	  subvalue += C_PAREN_CLOSE;
	
	  url = self.decode.raw(self.unescape(url), eat(beforeURL).test().end, {nonTerminated: false});
	
	  if (title) {
	    beforeTitle = eat(beforeTitle).test().end;
	    title = self.decode.raw(self.unescape(title), beforeTitle);
	  }
	
	  node = {
	    type: isImage ? 'image' : 'link',
	    title: title || null,
	    url: url
	  };
	
	  if (isImage) {
	    node.alt = self.decode.raw(self.unescape(content), now) || null;
	  } else {
	    exit = self.enterLink();
	    node.children = self.tokenizeInline(content, now);
	    exit();
	  }
	
	  return eat(subvalue)(node);
	}


/***/ },
/* 1397 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/* eslint-disable max-params */
	
	var trim = __webpack_require__(124);
	var repeat = __webpack_require__(324);
	var decimal = __webpack_require__(200);
	var getIndent = __webpack_require__(535);
	var removeIndent = __webpack_require__(1408);
	var interrupt = __webpack_require__(322);
	
	module.exports = list;
	
	var C_ASTERISK = '*';
	var C_UNDERSCORE = '_';
	var C_PLUS = '+';
	var C_DASH = '-';
	var C_DOT = '.';
	var C_SPACE = ' ';
	var C_NEWLINE = '\n';
	var C_TAB = '\t';
	var C_PAREN_CLOSE = ')';
	var C_X_LOWER = 'x';
	
	var TAB_SIZE = 4;
	var EXPRESSION_LOOSE_LIST_ITEM = /\n\n(?!\s*$)/;
	var EXPRESSION_TASK_ITEM = /^\[([ \t]|x|X)][ \t]/;
	var EXPRESSION_BULLET = /^([ \t]*)([*+-]|\d+[.)])( {1,4}(?! )| |\t|$|(?=\n))([^\n]*)/;
	var EXPRESSION_PEDANTIC_BULLET = /^([ \t]*)([*+-]|\d+[.)])([ \t]+)/;
	var EXPRESSION_INITIAL_INDENT = /^( {1,4}|\t)?/gm;
	
	/* Map of characters which can be used to mark
	 * list-items. */
	var LIST_UNORDERED_MARKERS = {};
	
	LIST_UNORDERED_MARKERS[C_ASTERISK] = true;
	LIST_UNORDERED_MARKERS[C_PLUS] = true;
	LIST_UNORDERED_MARKERS[C_DASH] = true;
	
	/* Map of characters which can be used to mark
	 * list-items after a digit. */
	var LIST_ORDERED_MARKERS = {};
	
	LIST_ORDERED_MARKERS[C_DOT] = true;
	
	/* Map of characters which can be used to mark
	 * list-items after a digit. */
	var LIST_ORDERED_COMMONMARK_MARKERS = {};
	
	LIST_ORDERED_COMMONMARK_MARKERS[C_DOT] = true;
	LIST_ORDERED_COMMONMARK_MARKERS[C_PAREN_CLOSE] = true;
	
	function list(eat, value, silent) {
	  var self = this;
	  var commonmark = self.options.commonmark;
	  var pedantic = self.options.pedantic;
	  var tokenizers = self.blockTokenizers;
	  var interuptors = self.interruptList;
	  var markers;
	  var index = 0;
	  var length = value.length;
	  var start = null;
	  var size = 0;
	  var queue;
	  var ordered;
	  var character;
	  var marker;
	  var nextIndex;
	  var startIndex;
	  var prefixed;
	  var currentMarker;
	  var content;
	  var line;
	  var prevEmpty;
	  var empty;
	  var items;
	  var allLines;
	  var emptyLines;
	  var item;
	  var enterTop;
	  var exitBlockquote;
	  var isLoose;
	  var node;
	  var now;
	  var end;
	  var indented;
	
	  while (index < length) {
	    character = value.charAt(index);
	
	    if (character === C_TAB) {
	      size += TAB_SIZE - (size % TAB_SIZE);
	    } else if (character === C_SPACE) {
	      size++;
	    } else {
	      break;
	    }
	
	    index++;
	  }
	
	  if (size >= TAB_SIZE) {
	    return;
	  }
	
	  character = value.charAt(index);
	
	  markers = commonmark ?
	    LIST_ORDERED_COMMONMARK_MARKERS :
	    LIST_ORDERED_MARKERS;
	
	  if (LIST_UNORDERED_MARKERS[character] === true) {
	    marker = character;
	    ordered = false;
	  } else {
	    ordered = true;
	    queue = '';
	
	    while (index < length) {
	      character = value.charAt(index);
	
	      if (!decimal(character)) {
	        break;
	      }
	
	      queue += character;
	      index++;
	    }
	
	    character = value.charAt(index);
	
	    if (!queue || markers[character] !== true) {
	      return;
	    }
	
	    start = parseInt(queue, 10);
	    marker = character;
	  }
	
	  character = value.charAt(++index);
	
	  if (character !== C_SPACE && character !== C_TAB) {
	    return;
	  }
	
	  if (silent) {
	    return true;
	  }
	
	  index = 0;
	  items = [];
	  allLines = [];
	  emptyLines = [];
	
	  while (index < length) {
	    nextIndex = value.indexOf(C_NEWLINE, index);
	    startIndex = index;
	    prefixed = false;
	    indented = false;
	
	    if (nextIndex === -1) {
	      nextIndex = length;
	    }
	
	    end = index + TAB_SIZE;
	    size = 0;
	
	    while (index < length) {
	      character = value.charAt(index);
	
	      if (character === C_TAB) {
	        size += TAB_SIZE - (size % TAB_SIZE);
	      } else if (character === C_SPACE) {
	        size++;
	      } else {
	        break;
	      }
	
	      index++;
	    }
	
	    if (size >= TAB_SIZE) {
	      indented = true;
	    }
	
	    if (item && size >= item.indent) {
	      indented = true;
	    }
	
	    character = value.charAt(index);
	    currentMarker = null;
	
	    if (!indented) {
	      if (LIST_UNORDERED_MARKERS[character] === true) {
	        currentMarker = character;
	        index++;
	        size++;
	      } else {
	        queue = '';
	
	        while (index < length) {
	          character = value.charAt(index);
	
	          if (!decimal(character)) {
	            break;
	          }
	
	          queue += character;
	          index++;
	        }
	
	        character = value.charAt(index);
	        index++;
	
	        if (queue && markers[character] === true) {
	          currentMarker = character;
	          size += queue.length + 1;
	        }
	      }
	
	      if (currentMarker) {
	        character = value.charAt(index);
	
	        if (character === C_TAB) {
	          size += TAB_SIZE - (size % TAB_SIZE);
	          index++;
	        } else if (character === C_SPACE) {
	          end = index + TAB_SIZE;
	
	          while (index < end) {
	            if (value.charAt(index) !== C_SPACE) {
	              break;
	            }
	
	            index++;
	            size++;
	          }
	
	          if (index === end && value.charAt(index) === C_SPACE) {
	            index -= TAB_SIZE - 1;
	            size -= TAB_SIZE - 1;
	          }
	        } else if (character !== C_NEWLINE && character !== '') {
	          currentMarker = null;
	        }
	      }
	    }
	
	    if (currentMarker) {
	      if (!pedantic && marker !== currentMarker) {
	        break;
	      }
	
	      prefixed = true;
	    } else {
	      if (!commonmark && !indented && value.charAt(startIndex) === C_SPACE) {
	        indented = true;
	      } else if (commonmark && item) {
	        indented = size >= item.indent || size > TAB_SIZE;
	      }
	
	      prefixed = false;
	      index = startIndex;
	    }
	
	    line = value.slice(startIndex, nextIndex);
	    content = startIndex === index ? line : value.slice(index, nextIndex);
	
	    if (
	      currentMarker === C_ASTERISK ||
	      currentMarker === C_UNDERSCORE ||
	      currentMarker === C_DASH
	    ) {
	      if (tokenizers.thematicBreak.call(self, eat, line, true)) {
	        break;
	      }
	    }
	
	    prevEmpty = empty;
	    empty = !trim(content).length;
	
	    if (indented && item) {
	      item.value = item.value.concat(emptyLines, line);
	      allLines = allLines.concat(emptyLines, line);
	      emptyLines = [];
	    } else if (prefixed) {
	      if (emptyLines.length !== 0) {
	        item.value.push('');
	        item.trail = emptyLines.concat();
	      }
	
	      item = {
	        value: [line],
	        indent: size,
	        trail: []
	      };
	
	      items.push(item);
	      allLines = allLines.concat(emptyLines, line);
	      emptyLines = [];
	    } else if (empty) {
	      if (prevEmpty) {
	        break;
	      }
	
	      emptyLines.push(line);
	    } else {
	      if (prevEmpty) {
	        break;
	      }
	
	      if (interrupt(interuptors, tokenizers, self, [eat, line, true])) {
	        break;
	      }
	
	      item.value = item.value.concat(emptyLines, line);
	      allLines = allLines.concat(emptyLines, line);
	      emptyLines = [];
	    }
	
	    index = nextIndex + 1;
	  }
	
	  node = eat(allLines.join(C_NEWLINE)).reset({
	    type: 'list',
	    ordered: ordered,
	    start: start,
	    loose: null,
	    children: []
	  });
	
	  enterTop = self.enterList();
	  exitBlockquote = self.enterBlock();
	  isLoose = false;
	  index = -1;
	  length = items.length;
	
	  while (++index < length) {
	    item = items[index].value.join(C_NEWLINE);
	    now = eat.now();
	
	    item = eat(item)(listItem(self, item, now), node);
	
	    if (item.loose) {
	      isLoose = true;
	    }
	
	    item = items[index].trail.join(C_NEWLINE);
	
	    if (index !== length - 1) {
	      item += C_NEWLINE;
	    }
	
	    eat(item);
	  }
	
	  enterTop();
	  exitBlockquote();
	
	  node.loose = isLoose;
	
	  return node;
	}
	
	function listItem(ctx, value, position) {
	  var offsets = ctx.offset;
	  var fn = ctx.options.pedantic ? pedanticListItem : normalListItem;
	  var checked = null;
	  var task;
	  var indent;
	
	  value = fn.apply(null, arguments);
	
	  if (ctx.options.gfm) {
	    task = value.match(EXPRESSION_TASK_ITEM);
	
	    if (task) {
	      indent = task[0].length;
	      checked = task[1].toLowerCase() === C_X_LOWER;
	      offsets[position.line] += indent;
	      value = value.slice(indent);
	    }
	  }
	
	  return {
	    type: 'listItem',
	    loose: EXPRESSION_LOOSE_LIST_ITEM.test(value) ||
	      value.charAt(value.length - 1) === C_NEWLINE,
	    checked: checked,
	    children: ctx.tokenizeBlock(value, position)
	  };
	}
	
	/* Create a list-item using overly simple mechanics. */
	function pedanticListItem(ctx, value, position) {
	  var offsets = ctx.offset;
	  var line = position.line;
	
	  /* Remove the list-item’s bullet. */
	  value = value.replace(EXPRESSION_PEDANTIC_BULLET, replacer);
	
	  /* The initial line was also matched by the below, so
	   * we reset the `line`. */
	  line = position.line;
	
	  return value.replace(EXPRESSION_INITIAL_INDENT, replacer);
	
	  /* A simple replacer which removed all matches,
	   * and adds their length to `offset`. */
	  function replacer($0) {
	    offsets[line] = (offsets[line] || 0) + $0.length;
	    line++;
	
	    return '';
	  }
	}
	
	/* Create a list-item using sane mechanics. */
	function normalListItem(ctx, value, position) {
	  var offsets = ctx.offset;
	  var line = position.line;
	  var max;
	  var bullet;
	  var rest;
	  var lines;
	  var trimmedLines;
	  var index;
	  var length;
	
	  /* Remove the list-item’s bullet. */
	  value = value.replace(EXPRESSION_BULLET, replacer);
	
	  lines = value.split(C_NEWLINE);
	
	  trimmedLines = removeIndent(value, getIndent(max).indent).split(C_NEWLINE);
	
	  /* We replaced the initial bullet with something
	   * else above, which was used to trick
	   * `removeIndentation` into removing some more
	   * characters when possible.  However, that could
	   * result in the initial line to be stripped more
	   * than it should be. */
	  trimmedLines[0] = rest;
	
	  offsets[line] = (offsets[line] || 0) + bullet.length;
	  line++;
	
	  index = 0;
	  length = lines.length;
	
	  while (++index < length) {
	    offsets[line] = (offsets[line] || 0) +
	      lines[index].length - trimmedLines[index].length;
	    line++;
	  }
	
	  return trimmedLines.join(C_NEWLINE);
	
	  function replacer($0, $1, $2, $3, $4) {
	    bullet = $1 + $2 + $3;
	    rest = $4;
	
	    /* Make sure that the first nine numbered list items
	     * can indent with an extra space.  That is, when
	     * the bullet did not receive an extra final space. */
	    if (Number($2) < 10 && bullet.length % 2 === 1) {
	      $2 = C_SPACE + $2;
	    }
	
	    max = $1 + repeat(C_SPACE, $2.length) + $3;
	
	    return max + rest;
	  }
	}


/***/ },
/* 1398 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var whitespace = __webpack_require__(50);
	
	module.exports = newline;
	
	/* Tokenise newline. */
	function newline(eat, value, silent) {
	  var character = value.charAt(0);
	  var length;
	  var subvalue;
	  var queue;
	  var index;
	
	  if (character !== '\n') {
	    return;
	  }
	
	  /* istanbul ignore if - never used (yet) */
	  if (silent) {
	    return true;
	  }
	
	  index = 1;
	  length = value.length;
	  subvalue = character;
	  queue = '';
	
	  while (index < length) {
	    character = value.charAt(index);
	
	    if (!whitespace(character)) {
	      break;
	    }
	
	    queue += character;
	
	    if (character === '\n') {
	      subvalue += queue;
	      queue = '';
	    }
	
	    index++;
	  }
	
	  eat(subvalue);
	}


/***/ },
/* 1399 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var trim = __webpack_require__(124);
	var decimal = __webpack_require__(200);
	var trimTrailingLines = __webpack_require__(326);
	var interrupt = __webpack_require__(322);
	
	module.exports = paragraph;
	
	var C_NEWLINE = '\n';
	var C_TAB = '\t';
	var C_SPACE = ' ';
	
	var TAB_SIZE = 4;
	
	/* Tokenise paragraph. */
	function paragraph(eat, value, silent) {
	  var self = this;
	  var settings = self.options;
	  var commonmark = settings.commonmark;
	  var gfm = settings.gfm;
	  var tokenizers = self.blockTokenizers;
	  var interruptors = self.interruptParagraph;
	  var index = value.indexOf(C_NEWLINE);
	  var length = value.length;
	  var position;
	  var subvalue;
	  var character;
	  var size;
	  var now;
	
	  while (index < length) {
	    /* Eat everything if there’s no following newline. */
	    if (index === -1) {
	      index = length;
	      break;
	    }
	
	    /* Stop if the next character is NEWLINE. */
	    if (value.charAt(index + 1) === C_NEWLINE) {
	      break;
	    }
	
	    /* In commonmark-mode, following indented lines
	     * are part of the paragraph. */
	    if (commonmark) {
	      size = 0;
	      position = index + 1;
	
	      while (position < length) {
	        character = value.charAt(position);
	
	        if (character === C_TAB) {
	          size = TAB_SIZE;
	          break;
	        } else if (character === C_SPACE) {
	          size++;
	        } else {
	          break;
	        }
	
	        position++;
	      }
	
	      if (size >= TAB_SIZE) {
	        index = value.indexOf(C_NEWLINE, index + 1);
	        continue;
	      }
	    }
	
	    subvalue = value.slice(index + 1);
	
	    /* Check if the following code contains a possible
	     * block. */
	    if (interrupt(interruptors, tokenizers, self, [eat, subvalue, true])) {
	      break;
	    }
	
	    /* Break if the following line starts a list, when
	     * already in a list, or when in commonmark, or when
	     * in gfm mode and the bullet is *not* numeric. */
	    if (
	      tokenizers.list.call(self, eat, subvalue, true) &&
	      (
	        self.inList ||
	        commonmark ||
	        (gfm && !decimal(trim.left(subvalue).charAt(0)))
	      )
	    ) {
	      break;
	    }
	
	    position = index;
	    index = value.indexOf(C_NEWLINE, index + 1);
	
	    if (index !== -1 && trim(value.slice(position, index)) === '') {
	      index = position;
	      break;
	    }
	  }
	
	  subvalue = value.slice(0, index);
	
	  if (trim(subvalue) === '') {
	    eat(subvalue);
	
	    return null;
	  }
	
	  /* istanbul ignore if - never used (yet) */
	  if (silent) {
	    return true;
	  }
	
	  now = eat.now();
	  subvalue = trimTrailingLines(subvalue);
	
	  return eat(subvalue)({
	    type: 'paragraph',
	    children: self.tokenizeInline(subvalue, now)
	  });
	}


/***/ },
/* 1400 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var whitespace = __webpack_require__(50);
	var locate = __webpack_require__(533);
	var normalize = __webpack_require__(323);
	
	module.exports = reference;
	reference.locator = locate;
	
	var T_LINK = 'link';
	var T_IMAGE = 'image';
	var T_FOOTNOTE = 'footnote';
	var REFERENCE_TYPE_SHORTCUT = 'shortcut';
	var REFERENCE_TYPE_COLLAPSED = 'collapsed';
	var REFERENCE_TYPE_FULL = 'full';
	var C_CARET = '^';
	var C_BACKSLASH = '\\';
	var C_BRACKET_OPEN = '[';
	var C_BRACKET_CLOSE = ']';
	
	function reference(eat, value, silent) {
	  var self = this;
	  var character = value.charAt(0);
	  var index = 0;
	  var length = value.length;
	  var subvalue = '';
	  var intro = '';
	  var type = T_LINK;
	  var referenceType = REFERENCE_TYPE_SHORTCUT;
	  var content;
	  var identifier;
	  var now;
	  var node;
	  var exit;
	  var queue;
	  var bracketed;
	  var depth;
	
	  /* Check whether we’re eating an image. */
	  if (character === '!') {
	    type = T_IMAGE;
	    intro = character;
	    character = value.charAt(++index);
	  }
	
	  if (character !== C_BRACKET_OPEN) {
	    return;
	  }
	
	  index++;
	  intro += character;
	  queue = '';
	
	  /* Check whether we’re eating a footnote. */
	  if (self.options.footnotes && value.charAt(index) === C_CARET) {
	    /* Exit if `![^` is found, so the `!` will be seen as text after this,
	     * and we’ll enter this function again when `[^` is found. */
	    if (type === T_IMAGE) {
	      return;
	    }
	
	    intro += C_CARET;
	    index++;
	    type = T_FOOTNOTE;
	  }
	
	  /* Eat the text. */
	  depth = 0;
	
	  while (index < length) {
	    character = value.charAt(index);
	
	    if (character === C_BRACKET_OPEN) {
	      bracketed = true;
	      depth++;
	    } else if (character === C_BRACKET_CLOSE) {
	      if (!depth) {
	        break;
	      }
	
	      depth--;
	    }
	
	    if (character === C_BACKSLASH) {
	      queue += C_BACKSLASH;
	      character = value.charAt(++index);
	    }
	
	    queue += character;
	    index++;
	  }
	
	  subvalue = queue;
	  content = queue;
	  character = value.charAt(index);
	
	  if (character !== C_BRACKET_CLOSE) {
	    return;
	  }
	
	  index++;
	  subvalue += character;
	  queue = '';
	
	  while (index < length) {
	    character = value.charAt(index);
	
	    if (!whitespace(character)) {
	      break;
	    }
	
	    queue += character;
	    index++;
	  }
	
	  character = value.charAt(index);
	
	  /* Inline footnotes cannot have an identifier. */
	  if (type !== T_FOOTNOTE && character === C_BRACKET_OPEN) {
	    identifier = '';
	    queue += character;
	    index++;
	
	    while (index < length) {
	      character = value.charAt(index);
	
	      if (character === C_BRACKET_OPEN || character === C_BRACKET_CLOSE) {
	        break;
	      }
	
	      if (character === C_BACKSLASH) {
	        identifier += C_BACKSLASH;
	        character = value.charAt(++index);
	      }
	
	      identifier += character;
	      index++;
	    }
	
	    character = value.charAt(index);
	
	    if (character === C_BRACKET_CLOSE) {
	      referenceType = identifier ? REFERENCE_TYPE_FULL : REFERENCE_TYPE_COLLAPSED;
	      queue += identifier + character;
	      index++;
	    } else {
	      identifier = '';
	    }
	
	    subvalue += queue;
	    queue = '';
	  } else {
	    if (!content) {
	      return;
	    }
	
	    identifier = content;
	  }
	
	  /* Brackets cannot be inside the identifier. */
	  if (referenceType !== REFERENCE_TYPE_FULL && bracketed) {
	    return;
	  }
	
	  subvalue = intro + subvalue;
	
	  if (type === T_LINK && self.inLink) {
	    return null;
	  }
	
	  /* istanbul ignore if - never used (yet) */
	  if (silent) {
	    return true;
	  }
	
	  if (type === T_FOOTNOTE && content.indexOf(' ') !== -1) {
	    return eat(subvalue)({
	      type: 'footnote',
	      children: this.tokenizeInline(content, eat.now())
	    });
	  }
	
	  now = eat.now();
	  now.column += intro.length;
	  now.offset += intro.length;
	  identifier = referenceType === REFERENCE_TYPE_FULL ? identifier : content;
	
	  node = {
	    type: type + 'Reference',
	    identifier: normalize(identifier)
	  };
	
	  if (type === T_LINK || type === T_IMAGE) {
	    node.referenceType = referenceType;
	  }
	
	  if (type === T_LINK) {
	    exit = self.enterLink();
	    node.children = self.tokenizeInline(content, now);
	    exit();
	  } else if (type === T_IMAGE) {
	    node.alt = self.decode.raw(self.unescape(content), now) || null;
	  }
	
	  return eat(subvalue)(node);
	}


/***/ },
/* 1401 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var trim = __webpack_require__(124);
	var whitespace = __webpack_require__(50);
	var locate = __webpack_require__(1376);
	
	module.exports = strong;
	strong.locator = locate;
	
	var C_ASTERISK = '*';
	var C_UNDERSCORE = '_';
	
	function strong(eat, value, silent) {
	  var self = this;
	  var index = 0;
	  var character = value.charAt(index);
	  var now;
	  var pedantic;
	  var marker;
	  var queue;
	  var subvalue;
	  var length;
	  var prev;
	
	  if (
	    (character !== C_ASTERISK && character !== C_UNDERSCORE) ||
	    value.charAt(++index) !== character
	  ) {
	    return;
	  }
	
	  pedantic = self.options.pedantic;
	  marker = character;
	  subvalue = marker + marker;
	  length = value.length;
	  index++;
	  queue = '';
	  character = '';
	
	  if (pedantic && whitespace(value.charAt(index))) {
	    return;
	  }
	
	  while (index < length) {
	    prev = character;
	    character = value.charAt(index);
	
	    if (
	      character === marker &&
	      value.charAt(index + 1) === marker &&
	      (!pedantic || !whitespace(prev))
	    ) {
	      character = value.charAt(index + 2);
	
	      if (character !== marker) {
	        if (!trim(queue)) {
	          return;
	        }
	
	        /* istanbul ignore if - never used (yet) */
	        if (silent) {
	          return true;
	        }
	
	        now = eat.now();
	        now.column += 2;
	        now.offset += 2;
	
	        return eat(subvalue + queue + subvalue)({
	          type: 'strong',
	          children: self.tokenizeInline(queue, now)
	        });
	      }
	    }
	
	    if (!pedantic && character === '\\') {
	      queue += character;
	      character = value.charAt(++index);
	    }
	
	    queue += character;
	    index++;
	  }
	}


/***/ },
/* 1402 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var whitespace = __webpack_require__(50);
	
	module.exports = table;
	
	var C_BACKSLASH = '\\';
	var C_TICK = '`';
	var C_DASH = '-';
	var C_PIPE = '|';
	var C_COLON = ':';
	var C_SPACE = ' ';
	var C_NEWLINE = '\n';
	var C_TAB = '\t';
	
	var MIN_TABLE_COLUMNS = 1;
	var MIN_TABLE_ROWS = 2;
	
	var TABLE_ALIGN_LEFT = 'left';
	var TABLE_ALIGN_CENTER = 'center';
	var TABLE_ALIGN_RIGHT = 'right';
	var TABLE_ALIGN_NONE = null;
	
	function table(eat, value, silent) {
	  var self = this;
	  var index;
	  var alignments;
	  var alignment;
	  var subvalue;
	  var row;
	  var length;
	  var lines;
	  var queue;
	  var character;
	  var hasDash;
	  var align;
	  var cell;
	  var preamble;
	  var count;
	  var opening;
	  var now;
	  var position;
	  var lineCount;
	  var line;
	  var rows;
	  var table;
	  var lineIndex;
	  var pipeIndex;
	  var first;
	
	  /* Exit when not in gfm-mode. */
	  if (!self.options.gfm) {
	    return;
	  }
	
	  /* Get the rows.
	   * Detecting tables soon is hard, so there are some
	   * checks for performance here, such as the minimum
	   * number of rows, and allowed characters in the
	   * alignment row. */
	  index = 0;
	  lineCount = 0;
	  length = value.length + 1;
	  lines = [];
	
	  while (index < length) {
	    lineIndex = value.indexOf(C_NEWLINE, index);
	    pipeIndex = value.indexOf(C_PIPE, index + 1);
	
	    if (lineIndex === -1) {
	      lineIndex = value.length;
	    }
	
	    if (pipeIndex === -1 || pipeIndex > lineIndex) {
	      if (lineCount < MIN_TABLE_ROWS) {
	        return;
	      }
	
	      break;
	    }
	
	    lines.push(value.slice(index, lineIndex));
	    lineCount++;
	    index = lineIndex + 1;
	  }
	
	  /* Parse the alignment row. */
	  subvalue = lines.join(C_NEWLINE);
	  alignments = lines.splice(1, 1)[0] || [];
	  index = 0;
	  length = alignments.length;
	  lineCount--;
	  alignment = false;
	  align = [];
	
	  while (index < length) {
	    character = alignments.charAt(index);
	
	    if (character === C_PIPE) {
	      hasDash = null;
	
	      if (alignment === false) {
	        if (first === false) {
	          return;
	        }
	      } else {
	        align.push(alignment);
	        alignment = false;
	      }
	
	      first = false;
	    } else if (character === C_DASH) {
	      hasDash = true;
	      alignment = alignment || TABLE_ALIGN_NONE;
	    } else if (character === C_COLON) {
	      if (alignment === TABLE_ALIGN_LEFT) {
	        alignment = TABLE_ALIGN_CENTER;
	      } else if (hasDash && alignment === TABLE_ALIGN_NONE) {
	        alignment = TABLE_ALIGN_RIGHT;
	      } else {
	        alignment = TABLE_ALIGN_LEFT;
	      }
	    } else if (!whitespace(character)) {
	      return;
	    }
	
	    index++;
	  }
	
	  if (alignment !== false) {
	    align.push(alignment);
	  }
	
	  /* Exit when without enough columns. */
	  if (align.length < MIN_TABLE_COLUMNS) {
	    return;
	  }
	
	  /* istanbul ignore if - never used (yet) */
	  if (silent) {
	    return true;
	  }
	
	  /* Parse the rows. */
	  position = -1;
	  rows = [];
	
	  table = eat(subvalue).reset({
	    type: 'table',
	    align: align,
	    children: rows
	  });
	
	  while (++position < lineCount) {
	    line = lines[position];
	    row = {type: 'tableRow', children: []};
	
	    /* Eat a newline character when this is not the
	     * first row. */
	    if (position) {
	      eat(C_NEWLINE);
	    }
	
	    /* Eat the row. */
	    eat(line).reset(row, table);
	
	    length = line.length + 1;
	    index = 0;
	    queue = '';
	    cell = '';
	    preamble = true;
	    count = null;
	    opening = null;
	
	    while (index < length) {
	      character = line.charAt(index);
	
	      if (character === C_TAB || character === C_SPACE) {
	        if (cell) {
	          queue += character;
	        } else {
	          eat(character);
	        }
	
	        index++;
	        continue;
	      }
	
	      if (character === '' || character === C_PIPE) {
	        if (preamble) {
	          eat(character);
	        } else {
	          if (character && opening) {
	            queue += character;
	            index++;
	            continue;
	          }
	
	          if ((cell || character) && !preamble) {
	            subvalue = cell;
	
	            if (queue.length > 1) {
	              if (character) {
	                subvalue += queue.slice(0, queue.length - 1);
	                queue = queue.charAt(queue.length - 1);
	              } else {
	                subvalue += queue;
	                queue = '';
	              }
	            }
	
	            now = eat.now();
	
	            eat(subvalue)({
	              type: 'tableCell',
	              children: self.tokenizeInline(cell, now)
	            }, row);
	          }
	
	          eat(queue + character);
	
	          queue = '';
	          cell = '';
	        }
	      } else {
	        if (queue) {
	          cell += queue;
	          queue = '';
	        }
	
	        cell += character;
	
	        if (character === C_BACKSLASH && index !== length - 2) {
	          cell += line.charAt(index + 1);
	          index++;
	        }
	
	        if (character === C_TICK) {
	          count = 1;
	
	          while (line.charAt(index + 1) === character) {
	            cell += character;
	            index++;
	            count++;
	          }
	
	          if (!opening) {
	            opening = count;
	          } else if (count >= opening) {
	            opening = 0;
	          }
	        }
	      }
	
	      preamble = false;
	      index++;
	    }
	
	    /* Eat the alignment row. */
	    if (!position) {
	      eat(C_NEWLINE + alignments);
	    }
	  }
	
	  return table;
	}


/***/ },
/* 1403 */
/***/ function(module, exports) {

	'use strict';
	
	module.exports = text;
	
	function text(eat, value, silent) {
	  var self = this;
	  var methods;
	  var tokenizers;
	  var index;
	  var length;
	  var subvalue;
	  var position;
	  var tokenizer;
	  var name;
	  var min;
	  var now;
	
	  /* istanbul ignore if - never used (yet) */
	  if (silent) {
	    return true;
	  }
	
	  methods = self.inlineMethods;
	  length = methods.length;
	  tokenizers = self.inlineTokenizers;
	  index = -1;
	  min = value.length;
	
	  while (++index < length) {
	    name = methods[index];
	
	    if (name === 'text' || !tokenizers[name]) {
	      continue;
	    }
	
	    tokenizer = tokenizers[name].locator;
	
	    if (!tokenizer) {
	      eat.file.fail('Missing locator: `' + name + '`');
	    }
	
	    position = tokenizer.call(self, value, 1);
	
	    if (position !== -1 && position < min) {
	      min = position;
	    }
	  }
	
	  subvalue = value.slice(0, min);
	  now = eat.now();
	
	  self.decode(subvalue, now, function (content, position, source) {
	    eat(source || content)({
	      type: 'text',
	      value: content
	    });
	  });
	}


/***/ },
/* 1404 */
/***/ function(module, exports) {

	'use strict';
	
	module.exports = thematicBreak;
	
	var C_NEWLINE = '\n';
	var C_TAB = '\t';
	var C_SPACE = ' ';
	var C_ASTERISK = '*';
	var C_UNDERSCORE = '_';
	var C_DASH = '-';
	
	var THEMATIC_BREAK_MARKER_COUNT = 3;
	
	function thematicBreak(eat, value, silent) {
	  var index = -1;
	  var length = value.length + 1;
	  var subvalue = '';
	  var character;
	  var marker;
	  var markerCount;
	  var queue;
	
	  while (++index < length) {
	    character = value.charAt(index);
	
	    if (character !== C_TAB && character !== C_SPACE) {
	      break;
	    }
	
	    subvalue += character;
	  }
	
	  if (
	    character !== C_ASTERISK &&
	    character !== C_DASH &&
	    character !== C_UNDERSCORE
	  ) {
	    return;
	  }
	
	  marker = character;
	  subvalue += character;
	  markerCount = 1;
	  queue = '';
	
	  while (++index < length) {
	    character = value.charAt(index);
	
	    if (character === marker) {
	      markerCount++;
	      subvalue += queue + marker;
	      queue = '';
	    } else if (character === C_SPACE) {
	      queue += character;
	    } else if (
	      markerCount >= THEMATIC_BREAK_MARKER_COUNT &&
	      (!character || character === C_NEWLINE)
	    ) {
	      subvalue += queue;
	
	      if (silent) {
	        return true;
	      }
	
	      return eat(subvalue)({type: 'thematicBreak'});
	    } else {
	      return;
	    }
	  }
	}


/***/ },
/* 1405 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var decode = __webpack_require__(315);
	var whitespace = __webpack_require__(50);
	var locate = __webpack_require__(1377);
	
	module.exports = url;
	url.locator = locate;
	url.notInLink = true;
	
	var C_BRACKET_OPEN = '[';
	var C_BRACKET_CLOSE = ']';
	var C_PAREN_OPEN = '(';
	var C_PAREN_CLOSE = ')';
	var C_LT = '<';
	var C_AT_SIGN = '@';
	
	var HTTP_PROTOCOL = 'http://';
	var HTTPS_PROTOCOL = 'https://';
	var MAILTO_PROTOCOL = 'mailto:';
	
	var PROTOCOLS = [
	  HTTP_PROTOCOL,
	  HTTPS_PROTOCOL,
	  MAILTO_PROTOCOL
	];
	
	var PROTOCOLS_LENGTH = PROTOCOLS.length;
	
	function url(eat, value, silent) {
	  var self = this;
	  var subvalue;
	  var content;
	  var character;
	  var index;
	  var position;
	  var protocol;
	  var match;
	  var length;
	  var queue;
	  var parenCount;
	  var nextCharacter;
	  var exit;
	
	  if (!self.options.gfm) {
	    return;
	  }
	
	  subvalue = '';
	  index = -1;
	  length = PROTOCOLS_LENGTH;
	
	  while (++index < length) {
	    protocol = PROTOCOLS[index];
	    match = value.slice(0, protocol.length);
	
	    if (match.toLowerCase() === protocol) {
	      subvalue = match;
	      break;
	    }
	  }
	
	  if (!subvalue) {
	    return;
	  }
	
	  index = subvalue.length;
	  length = value.length;
	  queue = '';
	  parenCount = 0;
	
	  while (index < length) {
	    character = value.charAt(index);
	
	    if (whitespace(character) || character === C_LT) {
	      break;
	    }
	
	    if (
	      character === '.' ||
	      character === ',' ||
	      character === ':' ||
	      character === ';' ||
	      character === '"' ||
	      character === '\'' ||
	      character === ')' ||
	      character === ']'
	    ) {
	      nextCharacter = value.charAt(index + 1);
	
	      if (!nextCharacter || whitespace(nextCharacter)) {
	        break;
	      }
	    }
	
	    if (character === C_PAREN_OPEN || character === C_BRACKET_OPEN) {
	      parenCount++;
	    }
	
	    if (character === C_PAREN_CLOSE || character === C_BRACKET_CLOSE) {
	      parenCount--;
	
	      if (parenCount < 0) {
	        break;
	      }
	    }
	
	    queue += character;
	    index++;
	  }
	
	  if (!queue) {
	    return;
	  }
	
	  subvalue += queue;
	  content = subvalue;
	
	  if (protocol === MAILTO_PROTOCOL) {
	    position = queue.indexOf(C_AT_SIGN);
	
	    if (position === -1 || position === length - 1) {
	      return;
	    }
	
	    content = content.substr(MAILTO_PROTOCOL.length);
	  }
	
	  /* istanbul ignore if - never used (yet) */
	  if (silent) {
	    return true;
	  }
	
	  exit = self.enterLink();
	  content = self.tokenizeInline(content, eat.now());
	  exit();
	
	  return eat(subvalue)({
	    type: 'link',
	    title: null,
	    url: decode(subvalue, {nonTerminated: false}),
	    children: content
	  });
	}


/***/ },
/* 1406 */
/***/ function(module, exports) {

	'use strict';
	
	module.exports = factory;
	
	var MERGEABLE_NODES = {
	  text: mergeText,
	  blockquote: mergeBlockquote
	};
	
	/* Check whether a node is mergeable with adjacent nodes. */
	function mergeable(node) {
	  var start;
	  var end;
	
	  if (node.type !== 'text' || !node.position) {
	    return true;
	  }
	
	  start = node.position.start;
	  end = node.position.end;
	
	  /* Only merge nodes which occupy the same size as their
	   * `value`. */
	  return start.line !== end.line ||
	      end.column - start.column === node.value.length;
	}
	
	/* Merge two text nodes: `node` into `prev`. */
	function mergeText(prev, node) {
	  prev.value += node.value;
	
	  return prev;
	}
	
	/* Merge two blockquotes: `node` into `prev`, unless in
	 * CommonMark mode. */
	function mergeBlockquote(prev, node) {
	  if (this.options.commonmark) {
	    return node;
	  }
	
	  prev.children = prev.children.concat(node.children);
	
	  return prev;
	}
	
	/* Construct a tokenizer.  This creates both
	 * `tokenizeInline` and `tokenizeBlock`. */
	function factory(type) {
	  return tokenize;
	
	  /* Tokenizer for a bound `type`. */
	  function tokenize(value, location) {
	    var self = this;
	    var offset = self.offset;
	    var tokens = [];
	    var methods = self[type + 'Methods'];
	    var tokenizers = self[type + 'Tokenizers'];
	    var line = location.line;
	    var column = location.column;
	    var index;
	    var length;
	    var method;
	    var name;
	    var matched;
	    var valueLength;
	
	    /* Trim white space only lines. */
	    if (!value) {
	      return tokens;
	    }
	
	    /* Expose on `eat`. */
	    eat.now = now;
	    eat.file = self.file;
	
	    /* Sync initial offset. */
	    updatePosition('');
	
	    /* Iterate over `value`, and iterate over all
	     * tokenizers.  When one eats something, re-iterate
	     * with the remaining value.  If no tokenizer eats,
	     * something failed (should not happen) and an
	     * exception is thrown. */
	    while (value) {
	      index = -1;
	      length = methods.length;
	      matched = false;
	
	      while (++index < length) {
	        name = methods[index];
	        method = tokenizers[name];
	
	        if (
	          method &&
	          /* istanbul ignore next */ (!method.onlyAtStart || self.atStart) &&
	          (!method.notInList || !self.inList) &&
	          (!method.notInBlock || !self.inBlock) &&
	          (!method.notInLink || !self.inLink)
	        ) {
	          valueLength = value.length;
	
	          method.apply(self, [eat, value]);
	
	          matched = valueLength !== value.length;
	
	          if (matched) {
	            break;
	          }
	        }
	      }
	
	      /* istanbul ignore if */
	      if (!matched) {
	        self.file.fail(new Error('Infinite loop'), eat.now());
	      }
	    }
	
	    self.eof = now();
	
	    return tokens;
	
	    /* Update line, column, and offset based on
	     * `value`. */
	    function updatePosition(subvalue) {
	      var lastIndex = -1;
	      var index = subvalue.indexOf('\n');
	
	      while (index !== -1) {
	        line++;
	        lastIndex = index;
	        index = subvalue.indexOf('\n', index + 1);
	      }
	
	      if (lastIndex === -1) {
	        column += subvalue.length;
	      } else {
	        column = subvalue.length - lastIndex;
	      }
	
	      if (line in offset) {
	        if (lastIndex !== -1) {
	          column += offset[line];
	        } else if (column <= offset[line]) {
	          column = offset[line] + 1;
	        }
	      }
	    }
	
	    /* Get offset.  Called before the first character is
	     * eaten to retrieve the range's offsets. */
	    function getOffset() {
	      var indentation = [];
	      var pos = line + 1;
	
	      /* Done.  Called when the last character is
	       * eaten to retrieve the range’s offsets. */
	      return function () {
	        var last = line + 1;
	
	        while (pos < last) {
	          indentation.push((offset[pos] || 0) + 1);
	
	          pos++;
	        }
	
	        return indentation;
	      };
	    }
	
	    /* Get the current position. */
	    function now() {
	      var pos = {line: line, column: column};
	
	      pos.offset = self.toOffset(pos);
	
	      return pos;
	    }
	
	    /* Store position information for a node. */
	    function Position(start) {
	      this.start = start;
	      this.end = now();
	    }
	
	    /* Throw when a value is incorrectly eaten.
	     * This shouldn’t happen but will throw on new,
	     * incorrect rules. */
	    function validateEat(subvalue) {
	      /* istanbul ignore if */
	      if (value.substring(0, subvalue.length) !== subvalue) {
	        /* Capture stack-trace. */
	        self.file.fail(
	          new Error(
	            'Incorrectly eaten value: please report this ' +
	            'warning on http://git.io/vg5Ft'
	          ),
	          now()
	        );
	      }
	    }
	
	    /* Mark position and patch `node.position`. */
	    function position() {
	      var before = now();
	
	      return update;
	
	      /* Add the position to a node. */
	      function update(node, indent) {
	        var prev = node.position;
	        var start = prev ? prev.start : before;
	        var combined = [];
	        var n = prev && prev.end.line;
	        var l = before.line;
	
	        node.position = new Position(start);
	
	        /* If there was already a `position`, this
	         * node was merged.  Fixing `start` wasn’t
	         * hard, but the indent is different.
	         * Especially because some information, the
	         * indent between `n` and `l` wasn’t
	         * tracked.  Luckily, that space is
	         * (should be?) empty, so we can safely
	         * check for it now. */
	        if (prev && indent && prev.indent) {
	          combined = prev.indent;
	
	          if (n < l) {
	            while (++n < l) {
	              combined.push((offset[n] || 0) + 1);
	            }
	
	            combined.push(before.column);
	          }
	
	          indent = combined.concat(indent);
	        }
	
	        node.position.indent = indent || [];
	
	        return node;
	      }
	    }
	
	    /* Add `node` to `parent`s children or to `tokens`.
	     * Performs merges where possible. */
	    function add(node, parent) {
	      var children = parent ? parent.children : tokens;
	      var prev = children[children.length - 1];
	
	      if (
	        prev &&
	        node.type === prev.type &&
	        node.type in MERGEABLE_NODES &&
	        mergeable(prev) &&
	        mergeable(node)
	      ) {
	        node = MERGEABLE_NODES[node.type].call(self, prev, node);
	      }
	
	      if (node !== prev) {
	        children.push(node);
	      }
	
	      if (self.atStart && tokens.length !== 0) {
	        self.exitStart();
	      }
	
	      return node;
	    }
	
	    /* Remove `subvalue` from `value`.
	     * `subvalue` must be at the start of `value`. */
	    function eat(subvalue) {
	      var indent = getOffset();
	      var pos = position();
	      var current = now();
	
	      validateEat(subvalue);
	
	      apply.reset = reset;
	      reset.test = test;
	      apply.test = test;
	
	      value = value.substring(subvalue.length);
	
	      updatePosition(subvalue);
	
	      indent = indent();
	
	      return apply;
	
	      /* Add the given arguments, add `position` to
	       * the returned node, and return the node. */
	      function apply(node, parent) {
	        return pos(add(pos(node), parent), indent);
	      }
	
	      /* Functions just like apply, but resets the
	       * content:  the line and column are reversed,
	       * and the eaten value is re-added.
	       * This is useful for nodes with a single
	       * type of content, such as lists and tables.
	       * See `apply` above for what parameters are
	       * expected. */
	      function reset() {
	        var node = apply.apply(null, arguments);
	
	        line = current.line;
	        column = current.column;
	        value = subvalue + value;
	
	        return node;
	      }
	
	      /* Test the position, after eating, and reverse
	       * to a not-eaten state. */
	      function test() {
	        var result = pos({});
	
	        line = current.line;
	        column = current.column;
	        value = subvalue + value;
	
	        return result.position;
	      }
	    }
	  }
	}


/***/ },
/* 1407 */
/***/ function(module, exports) {

	'use strict';
	
	module.exports = factory;
	
	/* Factory to de-escape a value, based on a list at `key`
	 * in `ctx`. */
	function factory(ctx, key) {
	  return unescape;
	
	  /* De-escape a string using the expression at `key`
	   * in `ctx`. */
	  function unescape(value) {
	    var prev = 0;
	    var index = value.indexOf('\\');
	    var escape = ctx[key];
	    var queue = [];
	    var character;
	
	    while (index !== -1) {
	      queue.push(value.slice(prev, index));
	      prev = index + 1;
	      character = value.charAt(prev);
	
	      /* If the following character is not a valid escape,
	       * add the slash. */
	      if (!character || escape.indexOf(character) === -1) {
	        queue.push('\\');
	      }
	
	      index = value.indexOf('\\', prev);
	    }
	
	    queue.push(value.slice(prev));
	
	    return queue.join('');
	  }
	}


/***/ },
/* 1408 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var trim = __webpack_require__(124);
	var repeat = __webpack_require__(324);
	var getIndent = __webpack_require__(535);
	
	module.exports = indentation;
	
	var C_SPACE = ' ';
	var C_NEWLINE = '\n';
	var C_TAB = '\t';
	
	/* Remove the minimum indent from every line in `value`.
	 * Supports both tab, spaced, and mixed indentation (as
	 * well as possible). */
	function indentation(value, maximum) {
	  var values = value.split(C_NEWLINE);
	  var position = values.length + 1;
	  var minIndent = Infinity;
	  var matrix = [];
	  var index;
	  var indentation;
	  var stops;
	  var padding;
	
	  values.unshift(repeat(C_SPACE, maximum) + '!');
	
	  while (position--) {
	    indentation = getIndent(values[position]);
	
	    matrix[position] = indentation.stops;
	
	    if (trim(values[position]).length === 0) {
	      continue;
	    }
	
	    if (indentation.indent) {
	      if (indentation.indent > 0 && indentation.indent < minIndent) {
	        minIndent = indentation.indent;
	      }
	    } else {
	      minIndent = Infinity;
	
	      break;
	    }
	  }
	
	  if (minIndent !== Infinity) {
	    position = values.length;
	
	    while (position--) {
	      stops = matrix[position];
	      index = minIndent;
	
	      while (index && !(index in stops)) {
	        index--;
	      }
	
	      if (
	        trim(values[position]).length !== 0 &&
	        minIndent &&
	        index !== minIndent
	      ) {
	        padding = C_TAB;
	      } else {
	        padding = '';
	      }
	
	      values[position] = padding + values[position].slice(
	        index in stops ? stops[index] + 1 : 0
	      );
	    }
	  }
	
	  values.shift();
	
	  return values.join(C_NEWLINE);
	}


/***/ },
/* 1409 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var path = __webpack_require__(506);
	
	function replaceExt(npath, ext) {
	  if (typeof npath !== 'string') {
	    return npath;
	  }
	
	  if (npath.length === 0) {
	    return npath;
	  }
	
	  var nFileName = path.basename(npath, path.extname(npath)) + ext;
	  return path.join(path.dirname(npath), nFileName);
	}
	
	module.exports = replaceExt;


/***/ },
/* 1410 */
/***/ function(module, exports) {

	"use strict";function isAbsolute(e){return"/"===e.charAt(0)}function spliceOne(e,t){for(var s=t,n=s+1,i=e.length;n<i;s+=1,n+=1)e[s]=e[n];e.pop()}function resolvePathname(e,t){void 0===t&&(t="");var s,n=e&&e.split("/")||[],i=t&&t.split("/")||[],l=e&&isAbsolute(e),r=t&&isAbsolute(t),o=l||r;if(e&&isAbsolute(e)?i=n:n.length&&(i.pop(),i=i.concat(n)),!i.length)return"/";if(i.length){var u=i[i.length-1];s="."===u||".."===u||""===u}else s=!1;for(var a=0,c=i.length;0<=c;c--){var f=i[c];"."===f?spliceOne(i,c):".."===f?(spliceOne(i,c),a++):a&&(spliceOne(i,c),a--)}if(!o)for(;a--;a)i.unshift("..");!o||""===i[0]||i[0]&&isAbsolute(i[0])||i.unshift("");var h=i.join("/");return s&&"/"!==h.substr(-1)&&(h+="/"),h}module.exports=resolvePathname;


/***/ },
/* 1411 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	if (true) {
	  module.exports = __webpack_require__(1410);
	} else {
	  module.exports = require('./cjs/resolve-pathname.js');
	}


/***/ },
/* 1412 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Buffer) {
	module.exports = ripemd160
	
	
	
	/*
	CryptoJS v3.1.2
	code.google.com/p/crypto-js
	(c) 2009-2013 by Jeff Mott. All rights reserved.
	code.google.com/p/crypto-js/wiki/License
	*/
	/** @preserve
	(c) 2012 by Cédric Mesnil. All rights reserved.
	
	Redistribution and use in source and binary forms, with or without modification, are permitted provided that the following conditions are met:
	
	    - Redistributions of source code must retain the above copyright notice, this list of conditions and the following disclaimer.
	    - Redistributions in binary form must reproduce the above copyright notice, this list of conditions and the following disclaimer in the documentation and/or other materials provided with the distribution.
	
	THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS" AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
	*/
	
	// Constants table
	var zl = [
	    0,  1,  2,  3,  4,  5,  6,  7,  8,  9, 10, 11, 12, 13, 14, 15,
	    7,  4, 13,  1, 10,  6, 15,  3, 12,  0,  9,  5,  2, 14, 11,  8,
	    3, 10, 14,  4,  9, 15,  8,  1,  2,  7,  0,  6, 13, 11,  5, 12,
	    1,  9, 11, 10,  0,  8, 12,  4, 13,  3,  7, 15, 14,  5,  6,  2,
	    4,  0,  5,  9,  7, 12,  2, 10, 14,  1,  3,  8, 11,  6, 15, 13];
	var zr = [
	    5, 14,  7,  0,  9,  2, 11,  4, 13,  6, 15,  8,  1, 10,  3, 12,
	    6, 11,  3,  7,  0, 13,  5, 10, 14, 15,  8, 12,  4,  9,  1,  2,
	    15,  5,  1,  3,  7, 14,  6,  9, 11,  8, 12,  2, 10,  0,  4, 13,
	    8,  6,  4,  1,  3, 11, 15,  0,  5, 12,  2, 13,  9,  7, 10, 14,
	    12, 15, 10,  4,  1,  5,  8,  7,  6,  2, 13, 14,  0,  3,  9, 11];
	var sl = [
	     11, 14, 15, 12,  5,  8,  7,  9, 11, 13, 14, 15,  6,  7,  9,  8,
	    7, 6,   8, 13, 11,  9,  7, 15,  7, 12, 15,  9, 11,  7, 13, 12,
	    11, 13,  6,  7, 14,  9, 13, 15, 14,  8, 13,  6,  5, 12,  7,  5,
	      11, 12, 14, 15, 14, 15,  9,  8,  9, 14,  5,  6,  8,  6,  5, 12,
	    9, 15,  5, 11,  6,  8, 13, 12,  5, 12, 13, 14, 11,  8,  5,  6 ];
	var sr = [
	    8,  9,  9, 11, 13, 15, 15,  5,  7,  7,  8, 11, 14, 14, 12,  6,
	    9, 13, 15,  7, 12,  8,  9, 11,  7,  7, 12,  7,  6, 15, 13, 11,
	    9,  7, 15, 11,  8,  6,  6, 14, 12, 13,  5, 14, 13, 13,  7,  5,
	    15,  5,  8, 11, 14, 14,  6, 14,  6,  9, 12,  9, 12,  5, 15,  8,
	    8,  5, 12,  9, 12,  5, 14,  6,  8, 13,  6,  5, 15, 13, 11, 11 ];
	
	var hl =  [ 0x00000000, 0x5A827999, 0x6ED9EBA1, 0x8F1BBCDC, 0xA953FD4E];
	var hr =  [ 0x50A28BE6, 0x5C4DD124, 0x6D703EF3, 0x7A6D76E9, 0x00000000];
	
	var bytesToWords = function (bytes) {
	  var words = [];
	  for (var i = 0, b = 0; i < bytes.length; i++, b += 8) {
	    words[b >>> 5] |= bytes[i] << (24 - b % 32);
	  }
	  return words;
	};
	
	var wordsToBytes = function (words) {
	  var bytes = [];
	  for (var b = 0; b < words.length * 32; b += 8) {
	    bytes.push((words[b >>> 5] >>> (24 - b % 32)) & 0xFF);
	  }
	  return bytes;
	};
	
	var processBlock = function (H, M, offset) {
	
	  // Swap endian
	  for (var i = 0; i < 16; i++) {
	    var offset_i = offset + i;
	    var M_offset_i = M[offset_i];
	
	    // Swap
	    M[offset_i] = (
	        (((M_offset_i << 8)  | (M_offset_i >>> 24)) & 0x00ff00ff) |
	        (((M_offset_i << 24) | (M_offset_i >>> 8))  & 0xff00ff00)
	    );
	  }
	
	  // Working variables
	  var al, bl, cl, dl, el;
	  var ar, br, cr, dr, er;
	
	  ar = al = H[0];
	  br = bl = H[1];
	  cr = cl = H[2];
	  dr = dl = H[3];
	  er = el = H[4];
	  // Computation
	  var t;
	  for (var i = 0; i < 80; i += 1) {
	    t = (al +  M[offset+zl[i]])|0;
	    if (i<16){
	        t +=  f1(bl,cl,dl) + hl[0];
	    } else if (i<32) {
	        t +=  f2(bl,cl,dl) + hl[1];
	    } else if (i<48) {
	        t +=  f3(bl,cl,dl) + hl[2];
	    } else if (i<64) {
	        t +=  f4(bl,cl,dl) + hl[3];
	    } else {// if (i<80) {
	        t +=  f5(bl,cl,dl) + hl[4];
	    }
	    t = t|0;
	    t =  rotl(t,sl[i]);
	    t = (t+el)|0;
	    al = el;
	    el = dl;
	    dl = rotl(cl, 10);
	    cl = bl;
	    bl = t;
	
	    t = (ar + M[offset+zr[i]])|0;
	    if (i<16){
	        t +=  f5(br,cr,dr) + hr[0];
	    } else if (i<32) {
	        t +=  f4(br,cr,dr) + hr[1];
	    } else if (i<48) {
	        t +=  f3(br,cr,dr) + hr[2];
	    } else if (i<64) {
	        t +=  f2(br,cr,dr) + hr[3];
	    } else {// if (i<80) {
	        t +=  f1(br,cr,dr) + hr[4];
	    }
	    t = t|0;
	    t =  rotl(t,sr[i]) ;
	    t = (t+er)|0;
	    ar = er;
	    er = dr;
	    dr = rotl(cr, 10);
	    cr = br;
	    br = t;
	  }
	  // Intermediate hash value
	  t    = (H[1] + cl + dr)|0;
	  H[1] = (H[2] + dl + er)|0;
	  H[2] = (H[3] + el + ar)|0;
	  H[3] = (H[4] + al + br)|0;
	  H[4] = (H[0] + bl + cr)|0;
	  H[0] =  t;
	};
	
	function f1(x, y, z) {
	  return ((x) ^ (y) ^ (z));
	}
	
	function f2(x, y, z) {
	  return (((x)&(y)) | ((~x)&(z)));
	}
	
	function f3(x, y, z) {
	  return (((x) | (~(y))) ^ (z));
	}
	
	function f4(x, y, z) {
	  return (((x) & (z)) | ((y)&(~(z))));
	}
	
	function f5(x, y, z) {
	  return ((x) ^ ((y) |(~(z))));
	}
	
	function rotl(x,n) {
	  return (x<<n) | (x>>>(32-n));
	}
	
	function ripemd160(message) {
	  var H = [0x67452301, 0xEFCDAB89, 0x98BADCFE, 0x10325476, 0xC3D2E1F0];
	
	  if (typeof message == 'string')
	    message = new Buffer(message, 'utf8');
	
	  var m = bytesToWords(message);
	
	  var nBitsLeft = message.length * 8;
	  var nBitsTotal = message.length * 8;
	
	  // Add padding
	  m[nBitsLeft >>> 5] |= 0x80 << (24 - nBitsLeft % 32);
	  m[(((nBitsLeft + 64) >>> 9) << 4) + 14] = (
	      (((nBitsTotal << 8)  | (nBitsTotal >>> 24)) & 0x00ff00ff) |
	      (((nBitsTotal << 24) | (nBitsTotal >>> 8))  & 0xff00ff00)
	  );
	
	  for (var i=0 ; i<m.length; i += 16) {
	    processBlock(H, m, i);
	  }
	
	  // Swap endian
	  for (var i = 0; i < 5; i++) {
	      // Shortcut
	    var H_i = H[i];
	
	    // Swap
	    H[i] = (((H_i << 8)  | (H_i >>> 24)) & 0x00ff00ff) |
	          (((H_i << 24) | (H_i >>> 8))  & 0xff00ff00);
	  }
	
	  var digestbytes = wordsToBytes(H);
	  return new Buffer(digestbytes);
	}
	
	
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(31).Buffer))

/***/ },
/* 1413 */
/***/ function(module, exports) {

	module.exports = {"neutralColor":"#e6e6e6","mediumNeutralColor":"#cccccc","darkNeutralColor":"#999999","darkerNeutralColor":"#949494","extraDarkNeutralColor":"#666666","lightNeutralColor":"#f2f2f2","tintedNeutralColor":"#d2d6e0","primaryColor":"#384971","darkPrimaryColor":"#2b334f","mediumPrimaryColor":"#313d5e","lightPrimaryColor":"#425a8a","extraLightPrimaryColor":"#7AAEF9","secondaryColor":"#25bdf5","darkAltColor":"#3f517e","lightAltColor":"#6179b6","extraLightAltColor":"#90a3d1","textOnPrimaryColor":"#fff","textOnNeutralColor":"#4d4d4d","textOnSecondaryColor":"#fff","textOnDangerColor":"#fff","textOnSuccessColor":"#fff","maxBodyWidth":"960px","headerHeight":"80px","footerHeight":"30px","mobileHeaderHeight":"50px","sidebarWidth":"200px","sidebarCollapsedWidth":"50px","drawerWidth":"350px","fontStack":"'Open Sans', sans-serif","bodyFontStack":"'Open Sans', sans-serif","titleFontStack":"'Open Sans', sans-serif","accentColor":"#f3c94f","inputFocusColor":"#25bdf5","deleteColor":"#cb2e2e","altDangerColor":"#d65050","darkDangerColor":"#a63a3a","lightDangerColor":"#ed3838","successColor":"#41be46","warningBackgroundColor":"#fbe584","warningForegroundColor":"#a37d1a","wizardWarningTextColor":"#e26d22","wizardValidBorderColor":"#9bdf8a","wizardInvalidBorderColor":"#f57979","highlightColor":"#ffeeaf","highlightDark":"#ffc700","infoColor":"#cdeeff","darkInfoColor":"#89c9ea","allyFocusColor":"#25bdf5","allyFocusOpacity":".3","backgroundImg":"\"../../common/img/backgrounds/north_dakota.jpg\"","bodyHeaderColor":"#e6e6e6","bodyHeaderTextColor":"#4d4d4d","bodyHeaderSublinkColor":"#555","sidebarHeaderColor":"#384971","textOnSidebarHeaderColor":"#fff","textOnSidebarColor":"#fff","sidebarGradLeft":"#2b334f","sidebarGradRight":"#425a8a","wizardSidebarGradLeft":"#6179b6","wizardSidebarGradRight":"#798ec1","wizardSidebarGradAngle":"100deg","sidebarLinkFlags":"false","sidebarLinkFlagColor":"#2b334f","homeImgShade":"true","homeFoldLinksBackground":"#6179b6","homeFoldLinksColor":"#fff","imgShadeColor":"#384971","homeImgCustomGradient":"false","homeSubtitleMargin":"0px","homeMessageBackground":"rgba(255, 255, 255, 0.1)","homeTitleFontSize":"10vh","homeTitleFontSizeMd":"6vh","homeShowBackground":"true","homeMainTextColor":"#fff","homeMessageTextColor":"#fff","homeCategoryCardBackground":"#fff","homeCategoryCardShowShadow":"true","homeCategoryCardHeaderBackground":"#f2f2f2","receiptBadgeOutlineColor":"#7AAEF9","receiptBadgeColor":"#6179b6","tableSelectedColor":"false"};

/***/ },
/* 1414 */
/***/ function(module, exports) {

	module.exports = {"neutralColor":"#e4e4e3","mediumNeutralColor":"#c9c7c4","darkNeutralColor":"#999794","extraDarkNeutralColor":"#666665","lightNeutralColor":"#eeeeec","tintedNeutralColor":"#e0dbd2","primaryColor":"#1C1C1C","darkPrimaryColor":"#000000","mediumPrimaryColor":"#262626","lightPrimaryColor":"#303030","extraLightPrimaryColor":"#3d3d3d","textOnPrimaryColor":"#fff","textOnNeutralColor":"#3d3c3b","secondaryColor":"#bfa44b","textOnSecondaryColor":"#fff","darkAltColor":"#7d7150","lightAltColor":"#e6cb73","inputFocusColor":"#25bdf5","accentColor":"#a29164","deleteColor":"#c01027","altDangerColor":"#c92a37","darkDangerColor":"#9c1a25","lightDangerColor":"#df2534","successColor":"#41be46","bodyHeaderColor":"#e4e4e3","bodyHeaderTextColor":"#3d3c3b","bodyHeaderSublinkColor":"#3d3c3b","sidebarGradLeft":"#000000","sidebarGradRight":"#1C1C1C","textOnSidebarColor":"#fff","wizardSidebarGradLeft":"#e6cb73","wizardSidebarGradRight":"#7d7150","wizardSidebarGradAngle":"210deg","wizardValidBorderColor":"#5add76","wizardInvalidBorderColor":"#ff6774","headerHeight":"60px","imgShadeColor":"#000000","tableSelectedColor":"#3d3d3d","backgroundImg":"\"../../common/img/backgrounds/montana.jpg\"","homeImgShade":"false","homeMessageBackground":"rgba(5, 5, 5, 0.14)","homeMessageTextColor":"#1C1C1C","homeTitleFontSize":"8vh","homeTitleFontSizeMd":"5vh","homeFoldLinksBackground":"#bfa44b","homeShowBackground":"false","homeMainTextColor":"#1C1C1C","homeCategoryCardBackground":"#e4e4e4","homeCategoryCardHeaderBackground":"#d1d1d1","homeCategoryCardShowShadow":"false"};

/***/ },
/* 1415 */
/***/ function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {/** @license React v0.13.6
	 * scheduler.production.min.js
	 *
	 * Copyright (c) Facebook, Inc. and its affiliates.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';Object.defineProperty(exports,"__esModule",{value:!0});var d=null,e=!1,g=3,k=-1,l=-1,m=!1,n=!1;function p(){if(!m){var a=d.expirationTime;n?q():n=!0;r(t,a)}}
	function u(){var a=d,b=d.next;if(d===b)d=null;else{var c=d.previous;d=c.next=b;b.previous=c}a.next=a.previous=null;c=a.callback;b=a.expirationTime;a=a.priorityLevel;var f=g,Q=l;g=a;l=b;try{var h=c()}finally{g=f,l=Q}if("function"===typeof h)if(h={callback:h,priorityLevel:a,expirationTime:b,next:null,previous:null},null===d)d=h.next=h.previous=h;else{c=null;a=d;do{if(a.expirationTime>=b){c=a;break}a=a.next}while(a!==d);null===c?c=d:c===d&&(d=h,p());b=c.previous;b.next=c.previous=h;h.next=c;h.previous=
	b}}function v(){if(-1===k&&null!==d&&1===d.priorityLevel){m=!0;try{do u();while(null!==d&&1===d.priorityLevel)}finally{m=!1,null!==d?p():n=!1}}}function t(a){m=!0;var b=e;e=a;try{if(a)for(;null!==d;){var c=exports.unstable_now();if(d.expirationTime<=c){do u();while(null!==d&&d.expirationTime<=c)}else break}else if(null!==d){do u();while(null!==d&&!w())}}finally{m=!1,e=b,null!==d?p():n=!1,v()}}
	var x=Date,y="function"===typeof setTimeout?setTimeout:void 0,z="function"===typeof clearTimeout?clearTimeout:void 0,A="function"===typeof requestAnimationFrame?requestAnimationFrame:void 0,B="function"===typeof cancelAnimationFrame?cancelAnimationFrame:void 0,C,D;function E(a){C=A(function(b){z(D);a(b)});D=y(function(){B(C);a(exports.unstable_now())},100)}
	if("object"===typeof performance&&"function"===typeof performance.now){var F=performance;exports.unstable_now=function(){return F.now()}}else exports.unstable_now=function(){return x.now()};var r,q,w,G=null;"undefined"!==typeof window?G=window:"undefined"!==typeof global&&(G=global);
	if(G&&G._schedMock){var H=G._schedMock;r=H[0];q=H[1];w=H[2];exports.unstable_now=H[3]}else if("undefined"===typeof window||"function"!==typeof MessageChannel){var I=null,J=function(a){if(null!==I)try{I(a)}finally{I=null}};r=function(a){null!==I?setTimeout(r,0,a):(I=a,setTimeout(J,0,!1))};q=function(){I=null};w=function(){return!1}}else{"undefined"!==typeof console&&("function"!==typeof A&&console.error("This browser doesn't support requestAnimationFrame. Make sure that you load a polyfill in older browsers. https://fb.me/react-polyfills"),
	"function"!==typeof B&&console.error("This browser doesn't support cancelAnimationFrame. Make sure that you load a polyfill in older browsers. https://fb.me/react-polyfills"));var K=null,L=!1,M=-1,N=!1,O=!1,P=0,R=33,S=33;w=function(){return P<=exports.unstable_now()};var T=new MessageChannel,U=T.port2;T.port1.onmessage=function(){L=!1;var a=K,b=M;K=null;M=-1;var c=exports.unstable_now(),f=!1;if(0>=P-c)if(-1!==b&&b<=c)f=!0;else{N||(N=!0,E(V));K=a;M=b;return}if(null!==a){O=!0;try{a(f)}finally{O=!1}}};
	var V=function(a){if(null!==K){E(V);var b=a-P+S;b<S&&R<S?(8>b&&(b=8),S=b<R?R:b):R=b;P=a+S;L||(L=!0,U.postMessage(void 0))}else N=!1};r=function(a,b){K=a;M=b;O||0>b?U.postMessage(void 0):N||(N=!0,E(V))};q=function(){K=null;L=!1;M=-1}}exports.unstable_ImmediatePriority=1;exports.unstable_UserBlockingPriority=2;exports.unstable_NormalPriority=3;exports.unstable_IdlePriority=5;exports.unstable_LowPriority=4;
	exports.unstable_runWithPriority=function(a,b){switch(a){case 1:case 2:case 3:case 4:case 5:break;default:a=3}var c=g,f=k;g=a;k=exports.unstable_now();try{return b()}finally{g=c,k=f,v()}};exports.unstable_next=function(a){switch(g){case 1:case 2:case 3:var b=3;break;default:b=g}var c=g,f=k;g=b;k=exports.unstable_now();try{return a()}finally{g=c,k=f,v()}};
	exports.unstable_scheduleCallback=function(a,b){var c=-1!==k?k:exports.unstable_now();if("object"===typeof b&&null!==b&&"number"===typeof b.timeout)b=c+b.timeout;else switch(g){case 1:b=c+-1;break;case 2:b=c+250;break;case 5:b=c+1073741823;break;case 4:b=c+1E4;break;default:b=c+5E3}a={callback:a,priorityLevel:g,expirationTime:b,next:null,previous:null};if(null===d)d=a.next=a.previous=a,p();else{c=null;var f=d;do{if(f.expirationTime>b){c=f;break}f=f.next}while(f!==d);null===c?c=d:c===d&&(d=a,p());
	b=c.previous;b.next=c.previous=a;a.next=c;a.previous=b}return a};exports.unstable_cancelCallback=function(a){var b=a.next;if(null!==b){if(b===a)d=null;else{a===d&&(d=b);var c=a.previous;c.next=b;b.previous=c}a.next=a.previous=null}};exports.unstable_wrapCallback=function(a){var b=g;return function(){var c=g,f=k;g=b;k=exports.unstable_now();try{return a.apply(this,arguments)}finally{g=c,k=f,v()}}};exports.unstable_getCurrentPriorityLevel=function(){return g};
	exports.unstable_shouldYield=function(){return!e&&(null!==d&&d.expirationTime<l||w())};exports.unstable_continueExecution=function(){null!==d&&p()};exports.unstable_pauseExecution=function(){};exports.unstable_getFirstCallbackNode=function(){return d};
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 1416 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	if (true) {
	  module.exports = __webpack_require__(1415);
	} else {
	  module.exports = require('./cjs/scheduler.development.js');
	}


/***/ },
/* 1417 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global, process) {(function (global, undefined) {
	    "use strict";
	
	    if (global.setImmediate) {
	        return;
	    }
	
	    var nextHandle = 1; // Spec says greater than zero
	    var tasksByHandle = {};
	    var currentlyRunningATask = false;
	    var doc = global.document;
	    var registerImmediate;
	
	    function setImmediate(callback) {
	      // Callback can either be a function or a string
	      if (typeof callback !== "function") {
	        callback = new Function("" + callback);
	      }
	      // Copy function arguments
	      var args = new Array(arguments.length - 1);
	      for (var i = 0; i < args.length; i++) {
	          args[i] = arguments[i + 1];
	      }
	      // Store and register the task
	      var task = { callback: callback, args: args };
	      tasksByHandle[nextHandle] = task;
	      registerImmediate(nextHandle);
	      return nextHandle++;
	    }
	
	    function clearImmediate(handle) {
	        delete tasksByHandle[handle];
	    }
	
	    function run(task) {
	        var callback = task.callback;
	        var args = task.args;
	        switch (args.length) {
	        case 0:
	            callback();
	            break;
	        case 1:
	            callback(args[0]);
	            break;
	        case 2:
	            callback(args[0], args[1]);
	            break;
	        case 3:
	            callback(args[0], args[1], args[2]);
	            break;
	        default:
	            callback.apply(undefined, args);
	            break;
	        }
	    }
	
	    function runIfPresent(handle) {
	        // From the spec: "Wait until any invocations of this algorithm started before this one have completed."
	        // So if we're currently running a task, we'll need to delay this invocation.
	        if (currentlyRunningATask) {
	            // Delay by doing a setTimeout. setImmediate was tried instead, but in Firefox 7 it generated a
	            // "too much recursion" error.
	            setTimeout(runIfPresent, 0, handle);
	        } else {
	            var task = tasksByHandle[handle];
	            if (task) {
	                currentlyRunningATask = true;
	                try {
	                    run(task);
	                } finally {
	                    clearImmediate(handle);
	                    currentlyRunningATask = false;
	                }
	            }
	        }
	    }
	
	    function installNextTickImplementation() {
	        registerImmediate = function(handle) {
	            process.nextTick(function () { runIfPresent(handle); });
	        };
	    }
	
	    function canUsePostMessage() {
	        // The test against `importScripts` prevents this implementation from being installed inside a web worker,
	        // where `global.postMessage` means something completely different and can't be used for this purpose.
	        if (global.postMessage && !global.importScripts) {
	            var postMessageIsAsynchronous = true;
	            var oldOnMessage = global.onmessage;
	            global.onmessage = function() {
	                postMessageIsAsynchronous = false;
	            };
	            global.postMessage("", "*");
	            global.onmessage = oldOnMessage;
	            return postMessageIsAsynchronous;
	        }
	    }
	
	    function installPostMessageImplementation() {
	        // Installs an event handler on `global` for the `message` event: see
	        // * https://developer.mozilla.org/en/DOM/window.postMessage
	        // * http://www.whatwg.org/specs/web-apps/current-work/multipage/comms.html#crossDocumentMessages
	
	        var messagePrefix = "setImmediate$" + Math.random() + "$";
	        var onGlobalMessage = function(event) {
	            if (event.source === global &&
	                typeof event.data === "string" &&
	                event.data.indexOf(messagePrefix) === 0) {
	                runIfPresent(+event.data.slice(messagePrefix.length));
	            }
	        };
	
	        if (global.addEventListener) {
	            global.addEventListener("message", onGlobalMessage, false);
	        } else {
	            global.attachEvent("onmessage", onGlobalMessage);
	        }
	
	        registerImmediate = function(handle) {
	            global.postMessage(messagePrefix + handle, "*");
	        };
	    }
	
	    function installMessageChannelImplementation() {
	        var channel = new MessageChannel();
	        channel.port1.onmessage = function(event) {
	            var handle = event.data;
	            runIfPresent(handle);
	        };
	
	        registerImmediate = function(handle) {
	            channel.port2.postMessage(handle);
	        };
	    }
	
	    function installReadyStateChangeImplementation() {
	        var html = doc.documentElement;
	        registerImmediate = function(handle) {
	            // Create a <script> element; its readystatechange event will be fired asynchronously once it is inserted
	            // into the document. Do so, thus queuing up the task. Remember to clean up once it's been called.
	            var script = doc.createElement("script");
	            script.onreadystatechange = function () {
	                runIfPresent(handle);
	                script.onreadystatechange = null;
	                html.removeChild(script);
	                script = null;
	            };
	            html.appendChild(script);
	        };
	    }
	
	    function installSetTimeoutImplementation() {
	        registerImmediate = function(handle) {
	            setTimeout(runIfPresent, 0, handle);
	        };
	    }
	
	    // If supported, we should attach to the prototype of global, since that is where setTimeout et al. live.
	    var attachTo = Object.getPrototypeOf && Object.getPrototypeOf(global);
	    attachTo = attachTo && attachTo.setTimeout ? attachTo : global;
	
	    // Don't get fooled by e.g. browserify environments.
	    if ({}.toString.call(global.process) === "[object process]") {
	        // For Node.js before 0.9
	        installNextTickImplementation();
	
	    } else if (canUsePostMessage()) {
	        // For non-IE10 modern browsers
	        installPostMessageImplementation();
	
	    } else if (global.MessageChannel) {
	        // For web workers, where supported
	        installMessageChannelImplementation();
	
	    } else if (doc && "onreadystatechange" in doc.createElement("script")) {
	        // For IE 6–8
	        installReadyStateChangeImplementation();
	
	    } else {
	        // For older browsers
	        installSetTimeoutImplementation();
	    }
	
	    attachTo.setImmediate = setImmediate;
	    attachTo.clearImmediate = clearImmediate;
	}(typeof self === "undefined" ? typeof global === "undefined" ? this : global : self));
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }()), __webpack_require__(77)))

/***/ },
/* 1418 */
/***/ function(module, exports) {

	module.exports = function (Buffer) {
	
	  //prototype class for hash functions
	  function Hash (blockSize, finalSize) {
	    this._block = new Buffer(blockSize) //new Uint32Array(blockSize/4)
	    this._finalSize = finalSize
	    this._blockSize = blockSize
	    this._len = 0
	    this._s = 0
	  }
	
	  Hash.prototype.init = function () {
	    this._s = 0
	    this._len = 0
	  }
	
	  Hash.prototype.update = function (data, enc) {
	    if ("string" === typeof data) {
	      enc = enc || "utf8"
	      data = new Buffer(data, enc)
	    }
	
	    var l = this._len += data.length
	    var s = this._s = (this._s || 0)
	    var f = 0
	    var buffer = this._block
	
	    while (s < l) {
	      var t = Math.min(data.length, f + this._blockSize - (s % this._blockSize))
	      var ch = (t - f)
	
	      for (var i = 0; i < ch; i++) {
	        buffer[(s % this._blockSize) + i] = data[i + f]
	      }
	
	      s += ch
	      f += ch
	
	      if ((s % this._blockSize) === 0) {
	        this._update(buffer)
	      }
	    }
	    this._s = s
	
	    return this
	  }
	
	  Hash.prototype.digest = function (enc) {
	    // Suppose the length of the message M, in bits, is l
	    var l = this._len * 8
	
	    // Append the bit 1 to the end of the message
	    this._block[this._len % this._blockSize] = 0x80
	
	    // and then k zero bits, where k is the smallest non-negative solution to the equation (l + 1 + k) === finalSize mod blockSize
	    this._block.fill(0, this._len % this._blockSize + 1)
	
	    if (l % (this._blockSize * 8) >= this._finalSize * 8) {
	      this._update(this._block)
	      this._block.fill(0)
	    }
	
	    // to this append the block which is equal to the number l written in binary
	    // TODO: handle case where l is > Math.pow(2, 29)
	    this._block.writeInt32BE(l, this._blockSize - 4)
	
	    var hash = this._update(this._block) || this._hash()
	
	    return enc ? hash.toString(enc) : hash
	  }
	
	  Hash.prototype._update = function () {
	    throw new Error('_update must be implemented by subclass')
	  }
	
	  return Hash
	}


/***/ },
/* 1419 */
/***/ function(module, exports, __webpack_require__) {

	var exports = module.exports = function (alg) {
	  var Alg = exports[alg]
	  if(!Alg) throw new Error(alg + ' is not supported (we accept pull requests)')
	  return new Alg()
	}
	
	var Buffer = __webpack_require__(31).Buffer
	var Hash   = __webpack_require__(1418)(Buffer)
	
	exports.sha1 = __webpack_require__(1420)(Buffer, Hash)
	exports.sha256 = __webpack_require__(1421)(Buffer, Hash)
	exports.sha512 = __webpack_require__(1422)(Buffer, Hash)


/***/ },
/* 1420 */
/***/ function(module, exports, __webpack_require__) {

	/*
	 * A JavaScript implementation of the Secure Hash Algorithm, SHA-1, as defined
	 * in FIPS PUB 180-1
	 * Version 2.1a Copyright Paul Johnston 2000 - 2002.
	 * Other contributors: Greg Holt, Andrew Kepert, Ydnar, Lostinet
	 * Distributed under the BSD License
	 * See http://pajhome.org.uk/crypt/md5 for details.
	 */
	
	var inherits = __webpack_require__(327).inherits
	
	module.exports = function (Buffer, Hash) {
	
	  var A = 0|0
	  var B = 4|0
	  var C = 8|0
	  var D = 12|0
	  var E = 16|0
	
	  var W = new (typeof Int32Array === 'undefined' ? Array : Int32Array)(80)
	
	  var POOL = []
	
	  function Sha1 () {
	    if(POOL.length)
	      return POOL.pop().init()
	
	    if(!(this instanceof Sha1)) return new Sha1()
	    this._w = W
	    Hash.call(this, 16*4, 14*4)
	
	    this._h = null
	    this.init()
	  }
	
	  inherits(Sha1, Hash)
	
	  Sha1.prototype.init = function () {
	    this._a = 0x67452301
	    this._b = 0xefcdab89
	    this._c = 0x98badcfe
	    this._d = 0x10325476
	    this._e = 0xc3d2e1f0
	
	    Hash.prototype.init.call(this)
	    return this
	  }
	
	  Sha1.prototype._POOL = POOL
	  Sha1.prototype._update = function (X) {
	
	    var a, b, c, d, e, _a, _b, _c, _d, _e
	
	    a = _a = this._a
	    b = _b = this._b
	    c = _c = this._c
	    d = _d = this._d
	    e = _e = this._e
	
	    var w = this._w
	
	    for(var j = 0; j < 80; j++) {
	      var W = w[j] = j < 16 ? X.readInt32BE(j*4)
	        : rol(w[j - 3] ^ w[j -  8] ^ w[j - 14] ^ w[j - 16], 1)
	
	      var t = add(
	        add(rol(a, 5), sha1_ft(j, b, c, d)),
	        add(add(e, W), sha1_kt(j))
	      )
	
	      e = d
	      d = c
	      c = rol(b, 30)
	      b = a
	      a = t
	    }
	
	    this._a = add(a, _a)
	    this._b = add(b, _b)
	    this._c = add(c, _c)
	    this._d = add(d, _d)
	    this._e = add(e, _e)
	  }
	
	  Sha1.prototype._hash = function () {
	    if(POOL.length < 100) POOL.push(this)
	    var H = new Buffer(20)
	    //console.log(this._a|0, this._b|0, this._c|0, this._d|0, this._e|0)
	    H.writeInt32BE(this._a|0, A)
	    H.writeInt32BE(this._b|0, B)
	    H.writeInt32BE(this._c|0, C)
	    H.writeInt32BE(this._d|0, D)
	    H.writeInt32BE(this._e|0, E)
	    return H
	  }
	
	  /*
	   * Perform the appropriate triplet combination function for the current
	   * iteration
	   */
	  function sha1_ft(t, b, c, d) {
	    if(t < 20) return (b & c) | ((~b) & d);
	    if(t < 40) return b ^ c ^ d;
	    if(t < 60) return (b & c) | (b & d) | (c & d);
	    return b ^ c ^ d;
	  }
	
	  /*
	   * Determine the appropriate additive constant for the current iteration
	   */
	  function sha1_kt(t) {
	    return (t < 20) ?  1518500249 : (t < 40) ?  1859775393 :
	           (t < 60) ? -1894007588 : -899497514;
	  }
	
	  /*
	   * Add integers, wrapping at 2^32. This uses 16-bit operations internally
	   * to work around bugs in some JS interpreters.
	   * //dominictarr: this is 10 years old, so maybe this can be dropped?)
	   *
	   */
	  function add(x, y) {
	    return (x + y ) | 0
	  //lets see how this goes on testling.
	  //  var lsw = (x & 0xFFFF) + (y & 0xFFFF);
	  //  var msw = (x >> 16) + (y >> 16) + (lsw >> 16);
	  //  return (msw << 16) | (lsw & 0xFFFF);
	  }
	
	  /*
	   * Bitwise rotate a 32-bit number to the left.
	   */
	  function rol(num, cnt) {
	    return (num << cnt) | (num >>> (32 - cnt));
	  }
	
	  return Sha1
	}


/***/ },
/* 1421 */
/***/ function(module, exports, __webpack_require__) {

	
	/**
	 * A JavaScript implementation of the Secure Hash Algorithm, SHA-256, as defined
	 * in FIPS 180-2
	 * Version 2.2-beta Copyright Angel Marin, Paul Johnston 2000 - 2009.
	 * Other contributors: Greg Holt, Andrew Kepert, Ydnar, Lostinet
	 *
	 */
	
	var inherits = __webpack_require__(327).inherits
	
	module.exports = function (Buffer, Hash) {
	
	  var K = [
	      0x428A2F98, 0x71374491, 0xB5C0FBCF, 0xE9B5DBA5,
	      0x3956C25B, 0x59F111F1, 0x923F82A4, 0xAB1C5ED5,
	      0xD807AA98, 0x12835B01, 0x243185BE, 0x550C7DC3,
	      0x72BE5D74, 0x80DEB1FE, 0x9BDC06A7, 0xC19BF174,
	      0xE49B69C1, 0xEFBE4786, 0x0FC19DC6, 0x240CA1CC,
	      0x2DE92C6F, 0x4A7484AA, 0x5CB0A9DC, 0x76F988DA,
	      0x983E5152, 0xA831C66D, 0xB00327C8, 0xBF597FC7,
	      0xC6E00BF3, 0xD5A79147, 0x06CA6351, 0x14292967,
	      0x27B70A85, 0x2E1B2138, 0x4D2C6DFC, 0x53380D13,
	      0x650A7354, 0x766A0ABB, 0x81C2C92E, 0x92722C85,
	      0xA2BFE8A1, 0xA81A664B, 0xC24B8B70, 0xC76C51A3,
	      0xD192E819, 0xD6990624, 0xF40E3585, 0x106AA070,
	      0x19A4C116, 0x1E376C08, 0x2748774C, 0x34B0BCB5,
	      0x391C0CB3, 0x4ED8AA4A, 0x5B9CCA4F, 0x682E6FF3,
	      0x748F82EE, 0x78A5636F, 0x84C87814, 0x8CC70208,
	      0x90BEFFFA, 0xA4506CEB, 0xBEF9A3F7, 0xC67178F2
	    ]
	
	  var W = new Array(64)
	
	  function Sha256() {
	    this.init()
	
	    this._w = W //new Array(64)
	
	    Hash.call(this, 16*4, 14*4)
	  }
	
	  inherits(Sha256, Hash)
	
	  Sha256.prototype.init = function () {
	
	    this._a = 0x6a09e667|0
	    this._b = 0xbb67ae85|0
	    this._c = 0x3c6ef372|0
	    this._d = 0xa54ff53a|0
	    this._e = 0x510e527f|0
	    this._f = 0x9b05688c|0
	    this._g = 0x1f83d9ab|0
	    this._h = 0x5be0cd19|0
	
	    this._len = this._s = 0
	
	    return this
	  }
	
	  function S (X, n) {
	    return (X >>> n) | (X << (32 - n));
	  }
	
	  function R (X, n) {
	    return (X >>> n);
	  }
	
	  function Ch (x, y, z) {
	    return ((x & y) ^ ((~x) & z));
	  }
	
	  function Maj (x, y, z) {
	    return ((x & y) ^ (x & z) ^ (y & z));
	  }
	
	  function Sigma0256 (x) {
	    return (S(x, 2) ^ S(x, 13) ^ S(x, 22));
	  }
	
	  function Sigma1256 (x) {
	    return (S(x, 6) ^ S(x, 11) ^ S(x, 25));
	  }
	
	  function Gamma0256 (x) {
	    return (S(x, 7) ^ S(x, 18) ^ R(x, 3));
	  }
	
	  function Gamma1256 (x) {
	    return (S(x, 17) ^ S(x, 19) ^ R(x, 10));
	  }
	
	  Sha256.prototype._update = function(M) {
	
	    var W = this._w
	    var a, b, c, d, e, f, g, h
	    var T1, T2
	
	    a = this._a | 0
	    b = this._b | 0
	    c = this._c | 0
	    d = this._d | 0
	    e = this._e | 0
	    f = this._f | 0
	    g = this._g | 0
	    h = this._h | 0
	
	    for (var j = 0; j < 64; j++) {
	      var w = W[j] = j < 16
	        ? M.readInt32BE(j * 4)
	        : Gamma1256(W[j - 2]) + W[j - 7] + Gamma0256(W[j - 15]) + W[j - 16]
	
	      T1 = h + Sigma1256(e) + Ch(e, f, g) + K[j] + w
	
	      T2 = Sigma0256(a) + Maj(a, b, c);
	      h = g; g = f; f = e; e = d + T1; d = c; c = b; b = a; a = T1 + T2;
	    }
	
	    this._a = (a + this._a) | 0
	    this._b = (b + this._b) | 0
	    this._c = (c + this._c) | 0
	    this._d = (d + this._d) | 0
	    this._e = (e + this._e) | 0
	    this._f = (f + this._f) | 0
	    this._g = (g + this._g) | 0
	    this._h = (h + this._h) | 0
	
	  };
	
	  Sha256.prototype._hash = function () {
	    var H = new Buffer(32)
	
	    H.writeInt32BE(this._a,  0)
	    H.writeInt32BE(this._b,  4)
	    H.writeInt32BE(this._c,  8)
	    H.writeInt32BE(this._d, 12)
	    H.writeInt32BE(this._e, 16)
	    H.writeInt32BE(this._f, 20)
	    H.writeInt32BE(this._g, 24)
	    H.writeInt32BE(this._h, 28)
	
	    return H
	  }
	
	  return Sha256
	
	}


/***/ },
/* 1422 */
/***/ function(module, exports, __webpack_require__) {

	var inherits = __webpack_require__(327).inherits
	
	module.exports = function (Buffer, Hash) {
	  var K = [
	    0x428a2f98, 0xd728ae22, 0x71374491, 0x23ef65cd,
	    0xb5c0fbcf, 0xec4d3b2f, 0xe9b5dba5, 0x8189dbbc,
	    0x3956c25b, 0xf348b538, 0x59f111f1, 0xb605d019,
	    0x923f82a4, 0xaf194f9b, 0xab1c5ed5, 0xda6d8118,
	    0xd807aa98, 0xa3030242, 0x12835b01, 0x45706fbe,
	    0x243185be, 0x4ee4b28c, 0x550c7dc3, 0xd5ffb4e2,
	    0x72be5d74, 0xf27b896f, 0x80deb1fe, 0x3b1696b1,
	    0x9bdc06a7, 0x25c71235, 0xc19bf174, 0xcf692694,
	    0xe49b69c1, 0x9ef14ad2, 0xefbe4786, 0x384f25e3,
	    0x0fc19dc6, 0x8b8cd5b5, 0x240ca1cc, 0x77ac9c65,
	    0x2de92c6f, 0x592b0275, 0x4a7484aa, 0x6ea6e483,
	    0x5cb0a9dc, 0xbd41fbd4, 0x76f988da, 0x831153b5,
	    0x983e5152, 0xee66dfab, 0xa831c66d, 0x2db43210,
	    0xb00327c8, 0x98fb213f, 0xbf597fc7, 0xbeef0ee4,
	    0xc6e00bf3, 0x3da88fc2, 0xd5a79147, 0x930aa725,
	    0x06ca6351, 0xe003826f, 0x14292967, 0x0a0e6e70,
	    0x27b70a85, 0x46d22ffc, 0x2e1b2138, 0x5c26c926,
	    0x4d2c6dfc, 0x5ac42aed, 0x53380d13, 0x9d95b3df,
	    0x650a7354, 0x8baf63de, 0x766a0abb, 0x3c77b2a8,
	    0x81c2c92e, 0x47edaee6, 0x92722c85, 0x1482353b,
	    0xa2bfe8a1, 0x4cf10364, 0xa81a664b, 0xbc423001,
	    0xc24b8b70, 0xd0f89791, 0xc76c51a3, 0x0654be30,
	    0xd192e819, 0xd6ef5218, 0xd6990624, 0x5565a910,
	    0xf40e3585, 0x5771202a, 0x106aa070, 0x32bbd1b8,
	    0x19a4c116, 0xb8d2d0c8, 0x1e376c08, 0x5141ab53,
	    0x2748774c, 0xdf8eeb99, 0x34b0bcb5, 0xe19b48a8,
	    0x391c0cb3, 0xc5c95a63, 0x4ed8aa4a, 0xe3418acb,
	    0x5b9cca4f, 0x7763e373, 0x682e6ff3, 0xd6b2b8a3,
	    0x748f82ee, 0x5defb2fc, 0x78a5636f, 0x43172f60,
	    0x84c87814, 0xa1f0ab72, 0x8cc70208, 0x1a6439ec,
	    0x90befffa, 0x23631e28, 0xa4506ceb, 0xde82bde9,
	    0xbef9a3f7, 0xb2c67915, 0xc67178f2, 0xe372532b,
	    0xca273ece, 0xea26619c, 0xd186b8c7, 0x21c0c207,
	    0xeada7dd6, 0xcde0eb1e, 0xf57d4f7f, 0xee6ed178,
	    0x06f067aa, 0x72176fba, 0x0a637dc5, 0xa2c898a6,
	    0x113f9804, 0xbef90dae, 0x1b710b35, 0x131c471b,
	    0x28db77f5, 0x23047d84, 0x32caab7b, 0x40c72493,
	    0x3c9ebe0a, 0x15c9bebc, 0x431d67c4, 0x9c100d4c,
	    0x4cc5d4be, 0xcb3e42b6, 0x597f299c, 0xfc657e2a,
	    0x5fcb6fab, 0x3ad6faec, 0x6c44198c, 0x4a475817
	  ]
	
	  var W = new Array(160)
	
	  function Sha512() {
	    this.init()
	    this._w = W
	
	    Hash.call(this, 128, 112)
	  }
	
	  inherits(Sha512, Hash)
	
	  Sha512.prototype.init = function () {
	
	    this._a = 0x6a09e667|0
	    this._b = 0xbb67ae85|0
	    this._c = 0x3c6ef372|0
	    this._d = 0xa54ff53a|0
	    this._e = 0x510e527f|0
	    this._f = 0x9b05688c|0
	    this._g = 0x1f83d9ab|0
	    this._h = 0x5be0cd19|0
	
	    this._al = 0xf3bcc908|0
	    this._bl = 0x84caa73b|0
	    this._cl = 0xfe94f82b|0
	    this._dl = 0x5f1d36f1|0
	    this._el = 0xade682d1|0
	    this._fl = 0x2b3e6c1f|0
	    this._gl = 0xfb41bd6b|0
	    this._hl = 0x137e2179|0
	
	    this._len = this._s = 0
	
	    return this
	  }
	
	  function S (X, Xl, n) {
	    return (X >>> n) | (Xl << (32 - n))
	  }
	
	  function Ch (x, y, z) {
	    return ((x & y) ^ ((~x) & z));
	  }
	
	  function Maj (x, y, z) {
	    return ((x & y) ^ (x & z) ^ (y & z));
	  }
	
	  Sha512.prototype._update = function(M) {
	
	    var W = this._w
	    var a, b, c, d, e, f, g, h
	    var al, bl, cl, dl, el, fl, gl, hl
	
	    a = this._a | 0
	    b = this._b | 0
	    c = this._c | 0
	    d = this._d | 0
	    e = this._e | 0
	    f = this._f | 0
	    g = this._g | 0
	    h = this._h | 0
	
	    al = this._al | 0
	    bl = this._bl | 0
	    cl = this._cl | 0
	    dl = this._dl | 0
	    el = this._el | 0
	    fl = this._fl | 0
	    gl = this._gl | 0
	    hl = this._hl | 0
	
	    for (var i = 0; i < 80; i++) {
	      var j = i * 2
	
	      var Wi, Wil
	
	      if (i < 16) {
	        Wi = W[j] = M.readInt32BE(j * 4)
	        Wil = W[j + 1] = M.readInt32BE(j * 4 + 4)
	
	      } else {
	        var x  = W[j - 15*2]
	        var xl = W[j - 15*2 + 1]
	        var gamma0  = S(x, xl, 1) ^ S(x, xl, 8) ^ (x >>> 7)
	        var gamma0l = S(xl, x, 1) ^ S(xl, x, 8) ^ S(xl, x, 7)
	
	        x  = W[j - 2*2]
	        xl = W[j - 2*2 + 1]
	        var gamma1  = S(x, xl, 19) ^ S(xl, x, 29) ^ (x >>> 6)
	        var gamma1l = S(xl, x, 19) ^ S(x, xl, 29) ^ S(xl, x, 6)
	
	        // W[i] = gamma0 + W[i - 7] + gamma1 + W[i - 16]
	        var Wi7  = W[j - 7*2]
	        var Wi7l = W[j - 7*2 + 1]
	
	        var Wi16  = W[j - 16*2]
	        var Wi16l = W[j - 16*2 + 1]
	
	        Wil = gamma0l + Wi7l
	        Wi  = gamma0  + Wi7 + ((Wil >>> 0) < (gamma0l >>> 0) ? 1 : 0)
	        Wil = Wil + gamma1l
	        Wi  = Wi  + gamma1  + ((Wil >>> 0) < (gamma1l >>> 0) ? 1 : 0)
	        Wil = Wil + Wi16l
	        Wi  = Wi  + Wi16 + ((Wil >>> 0) < (Wi16l >>> 0) ? 1 : 0)
	
	        W[j] = Wi
	        W[j + 1] = Wil
	      }
	
	      var maj = Maj(a, b, c)
	      var majl = Maj(al, bl, cl)
	
	      var sigma0h = S(a, al, 28) ^ S(al, a, 2) ^ S(al, a, 7)
	      var sigma0l = S(al, a, 28) ^ S(a, al, 2) ^ S(a, al, 7)
	      var sigma1h = S(e, el, 14) ^ S(e, el, 18) ^ S(el, e, 9)
	      var sigma1l = S(el, e, 14) ^ S(el, e, 18) ^ S(e, el, 9)
	
	      // t1 = h + sigma1 + ch + K[i] + W[i]
	      var Ki = K[j]
	      var Kil = K[j + 1]
	
	      var ch = Ch(e, f, g)
	      var chl = Ch(el, fl, gl)
	
	      var t1l = hl + sigma1l
	      var t1 = h + sigma1h + ((t1l >>> 0) < (hl >>> 0) ? 1 : 0)
	      t1l = t1l + chl
	      t1 = t1 + ch + ((t1l >>> 0) < (chl >>> 0) ? 1 : 0)
	      t1l = t1l + Kil
	      t1 = t1 + Ki + ((t1l >>> 0) < (Kil >>> 0) ? 1 : 0)
	      t1l = t1l + Wil
	      t1 = t1 + Wi + ((t1l >>> 0) < (Wil >>> 0) ? 1 : 0)
	
	      // t2 = sigma0 + maj
	      var t2l = sigma0l + majl
	      var t2 = sigma0h + maj + ((t2l >>> 0) < (sigma0l >>> 0) ? 1 : 0)
	
	      h  = g
	      hl = gl
	      g  = f
	      gl = fl
	      f  = e
	      fl = el
	      el = (dl + t1l) | 0
	      e  = (d + t1 + ((el >>> 0) < (dl >>> 0) ? 1 : 0)) | 0
	      d  = c
	      dl = cl
	      c  = b
	      cl = bl
	      b  = a
	      bl = al
	      al = (t1l + t2l) | 0
	      a  = (t1 + t2 + ((al >>> 0) < (t1l >>> 0) ? 1 : 0)) | 0
	    }
	
	    this._al = (this._al + al) | 0
	    this._bl = (this._bl + bl) | 0
	    this._cl = (this._cl + cl) | 0
	    this._dl = (this._dl + dl) | 0
	    this._el = (this._el + el) | 0
	    this._fl = (this._fl + fl) | 0
	    this._gl = (this._gl + gl) | 0
	    this._hl = (this._hl + hl) | 0
	
	    this._a = (this._a + a + ((this._al >>> 0) < (al >>> 0) ? 1 : 0)) | 0
	    this._b = (this._b + b + ((this._bl >>> 0) < (bl >>> 0) ? 1 : 0)) | 0
	    this._c = (this._c + c + ((this._cl >>> 0) < (cl >>> 0) ? 1 : 0)) | 0
	    this._d = (this._d + d + ((this._dl >>> 0) < (dl >>> 0) ? 1 : 0)) | 0
	    this._e = (this._e + e + ((this._el >>> 0) < (el >>> 0) ? 1 : 0)) | 0
	    this._f = (this._f + f + ((this._fl >>> 0) < (fl >>> 0) ? 1 : 0)) | 0
	    this._g = (this._g + g + ((this._gl >>> 0) < (gl >>> 0) ? 1 : 0)) | 0
	    this._h = (this._h + h + ((this._hl >>> 0) < (hl >>> 0) ? 1 : 0)) | 0
	  }
	
	  Sha512.prototype._hash = function () {
	    var H = new Buffer(64)
	
	    function writeInt64BE(h, l, offset) {
	      H.writeInt32BE(h, offset)
	      H.writeInt32BE(l, offset + 4)
	    }
	
	    writeInt64BE(this._a, this._al, 0)
	    writeInt64BE(this._b, this._bl, 8)
	    writeInt64BE(this._c, this._cl, 16)
	    writeInt64BE(this._d, this._dl, 24)
	    writeInt64BE(this._e, this._el, 32)
	    writeInt64BE(this._f, this._fl, 40)
	    writeInt64BE(this._g, this._gl, 48)
	    writeInt64BE(this._h, this._hl, 56)
	
	    return H
	  }
	
	  return Sha512
	
	}


/***/ },
/* 1423 */
/***/ function(module, exports) {

	//
	
	module.exports = function shallowEqual(objA, objB, compare, compareContext) {
	  var ret = compare ? compare.call(compareContext, objA, objB) : void 0;
	
	  if (ret !== void 0) {
	    return !!ret;
	  }
	
	  if (objA === objB) {
	    return true;
	  }
	
	  if (typeof objA !== "object" || !objA || typeof objB !== "object" || !objB) {
	    return false;
	  }
	
	  var keysA = Object.keys(objA);
	  var keysB = Object.keys(objB);
	
	  if (keysA.length !== keysB.length) {
	    return false;
	  }
	
	  var bHasOwnProperty = Object.prototype.hasOwnProperty.bind(objB);
	
	  // Test for A's keys different from B.
	  for (var idx = 0; idx < keysA.length; idx++) {
	    var key = keysA[idx];
	
	    if (!bHasOwnProperty(key)) {
	      return false;
	    }
	
	    var valueA = objA[key];
	    var valueB = objB[key];
	
	    ret = compare ? compare.call(compareContext, valueA, valueB, key) : void 0;
	
	    if (ret === false || (ret === void 0 && valueA !== valueB)) {
	      return false;
	    }
	  }
	
	  return true;
	};


/***/ },
/* 1424 */
/***/ function(module, exports) {

	'use strict'
	
	module.exports = factory
	
	// Construct a state `toggler`: a function which inverses `property` in context
	// based on its current value.
	// The by `toggler` returned function restores that value.
	function factory(key, state, ctx) {
	  return enter
	
	  function enter() {
	    var context = ctx || this
	    var current = context[key]
	
	    context[key] = !state
	
	    return exit
	
	    function exit() {
	      context[key] = current
	    }
	  }
	}


/***/ },
/* 1425 */
/***/ function(module, exports, __webpack_require__) {

	// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.
	
	module.exports = Stream;
	
	var EE = __webpack_require__(286).EventEmitter;
	var inherits = __webpack_require__(58);
	
	inherits(Stream, EE);
	Stream.Readable = __webpack_require__(320);
	Stream.Writable = __webpack_require__(1362);
	Stream.Duplex = __webpack_require__(1357);
	Stream.Transform = __webpack_require__(1361);
	Stream.PassThrough = __webpack_require__(1360);
	
	// Backwards-compat with node 0.4.x
	Stream.Stream = Stream;
	
	
	
	// old-style streams.  Note that the pipe method (the only relevant
	// part of this class) is overridden in the Readable class.
	
	function Stream() {
	  EE.call(this);
	}
	
	Stream.prototype.pipe = function(dest, options) {
	  var source = this;
	
	  function ondata(chunk) {
	    if (dest.writable) {
	      if (false === dest.write(chunk) && source.pause) {
	        source.pause();
	      }
	    }
	  }
	
	  source.on('data', ondata);
	
	  function ondrain() {
	    if (source.readable && source.resume) {
	      source.resume();
	    }
	  }
	
	  dest.on('drain', ondrain);
	
	  // If the 'end' option is not supplied, dest.end() will be called when
	  // source gets the 'end' or 'close' events.  Only dest.end() once.
	  if (!dest._isStdio && (!options || options.end !== false)) {
	    source.on('end', onend);
	    source.on('close', onclose);
	  }
	
	  var didOnEnd = false;
	  function onend() {
	    if (didOnEnd) return;
	    didOnEnd = true;
	
	    dest.end();
	  }
	
	
	  function onclose() {
	    if (didOnEnd) return;
	    didOnEnd = true;
	
	    if (typeof dest.destroy === 'function') dest.destroy();
	  }
	
	  // don't leave dangling pipes when there are errors.
	  function onerror(er) {
	    cleanup();
	    if (EE.listenerCount(this, 'error') === 0) {
	      throw er; // Unhandled stream error in pipe.
	    }
	  }
	
	  source.on('error', onerror);
	  dest.on('error', onerror);
	
	  // remove all the event listeners that were added.
	  function cleanup() {
	    source.removeListener('data', ondata);
	    dest.removeListener('drain', ondrain);
	
	    source.removeListener('end', onend);
	    source.removeListener('close', onclose);
	
	    source.removeListener('error', onerror);
	    dest.removeListener('error', onerror);
	
	    source.removeListener('end', cleanup);
	    source.removeListener('close', cleanup);
	
	    dest.removeListener('close', cleanup);
	  }
	
	  source.on('end', cleanup);
	  source.on('close', cleanup);
	
	  dest.on('close', cleanup);
	
	  dest.emit('pipe', source);
	
	  // Allow for unix-like usage: A.pipe(B).pipe(C)
	  return dest;
	};


/***/ },
/* 1426 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(835);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(11)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/lib/loader.js!./bootstrap-grid.scss", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/lib/loader.js!./bootstrap-grid.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 1427 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(836);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(11)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../node_modules/css-loader/index.js!../../../node_modules/sass-loader/lib/loader.js!./global.scss", function() {
				var newContent = require("!!../../../node_modules/css-loader/index.js!../../../node_modules/sass-loader/lib/loader.js!./global.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 1428 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(837);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(11)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../node_modules/css-loader/index.js!../../../node_modules/sass-loader/lib/loader.js!./sos-icons.scss", function() {
				var newContent = require("!!../../../node_modules/css-loader/index.js!../../../node_modules/sass-loader/lib/loader.js!./sos-icons.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 1429 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(838);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(11)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../node_modules/css-loader/index.js!../../../node_modules/sass-loader/lib/loader.js!./ActionButton.scss", function() {
				var newContent = require("!!../../../node_modules/css-loader/index.js!../../../node_modules/sass-loader/lib/loader.js!./ActionButton.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 1430 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(839);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(11)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../node_modules/css-loader/index.js!../../../node_modules/sass-loader/lib/loader.js!./AddCategoryCard.scss", function() {
				var newContent = require("!!../../../node_modules/css-loader/index.js!../../../node_modules/sass-loader/lib/loader.js!./AddCategoryCard.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 1431 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(840);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(11)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../node_modules/css-loader/index.js!../../../node_modules/sass-loader/lib/loader.js!./Cart.scss", function() {
				var newContent = require("!!../../../node_modules/css-loader/index.js!../../../node_modules/sass-loader/lib/loader.js!./Cart.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 1432 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(841);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(11)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../node_modules/css-loader/index.js!../../../node_modules/sass-loader/lib/loader.js!./Certificate.scss", function() {
				var newContent = require("!!../../../node_modules/css-loader/index.js!../../../node_modules/sass-loader/lib/loader.js!./Certificate.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 1433 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(842);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(11)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../node_modules/css-loader/index.js!../../../node_modules/sass-loader/lib/loader.js!./RequestCertificate.scss", function() {
				var newContent = require("!!../../../node_modules/css-loader/index.js!../../../node_modules/sass-loader/lib/loader.js!./RequestCertificate.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 1434 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(843);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(11)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../node_modules/css-loader/index.js!../../../node_modules/sass-loader/lib/loader.js!./Checkout.scss", function() {
				var newContent = require("!!../../../node_modules/css-loader/index.js!../../../node_modules/sass-loader/lib/loader.js!./Checkout.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 1435 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(844);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(11)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../node_modules/css-loader/index.js!../../../node_modules/sass-loader/lib/loader.js!./Receipt.scss", function() {
				var newContent = require("!!../../../node_modules/css-loader/index.js!../../../node_modules/sass-loader/lib/loader.js!./Receipt.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 1436 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(846);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(11)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../node_modules/css-loader/index.js!../../../node_modules/sass-loader/lib/loader.js!./DataRequests.scss", function() {
				var newContent = require("!!../../../node_modules/css-loader/index.js!../../../node_modules/sass-loader/lib/loader.js!./DataRequests.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 1437 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(847);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(11)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../node_modules/css-loader/index.js!../../../node_modules/sass-loader/lib/loader.js!./Designer2.scss", function() {
				var newContent = require("!!../../../node_modules/css-loader/index.js!../../../node_modules/sass-loader/lib/loader.js!./Designer2.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 1438 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(848);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(11)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../node_modules/css-loader/index.js!../../../node_modules/sass-loader/lib/loader.js!./DetailsList.scss", function() {
				var newContent = require("!!../../../node_modules/css-loader/index.js!../../../node_modules/sass-loader/lib/loader.js!./DetailsList.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 1439 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(849);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(11)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../node_modules/css-loader/index.js!../../../node_modules/sass-loader/lib/loader.js!./ExpandableCard.scss", function() {
				var newContent = require("!!../../../node_modules/css-loader/index.js!../../../node_modules/sass-loader/lib/loader.js!./ExpandableCard.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 1440 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(851);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(11)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../node_modules/css-loader/index.js!../../../node_modules/sass-loader/lib/loader.js!./FloatingMenu.scss", function() {
				var newContent = require("!!../../../node_modules/css-loader/index.js!../../../node_modules/sass-loader/lib/loader.js!./FloatingMenu.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 1441 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(852);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(11)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../node_modules/css-loader/index.js!../../../node_modules/sass-loader/lib/loader.js!./FormCard.scss", function() {
				var newContent = require("!!../../../node_modules/css-loader/index.js!../../../node_modules/sass-loader/lib/loader.js!./FormCard.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 1442 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(853);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(11)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../node_modules/css-loader/index.js!../../../node_modules/sass-loader/lib/loader.js!./FormManager.scss", function() {
				var newContent = require("!!../../../node_modules/css-loader/index.js!../../../node_modules/sass-loader/lib/loader.js!./FormManager.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 1443 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(854);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(11)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../node_modules/css-loader/index.js!../../../node_modules/sass-loader/lib/loader.js!./Forms.scss", function() {
				var newContent = require("!!../../../node_modules/css-loader/index.js!../../../node_modules/sass-loader/lib/loader.js!./Forms.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 1444 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(855);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(11)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../node_modules/css-loader/index.js!../../../node_modules/sass-loader/lib/loader.js!./FrequentPayor.scss", function() {
				var newContent = require("!!../../../node_modules/css-loader/index.js!../../../node_modules/sass-loader/lib/loader.js!./FrequentPayor.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 1445 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(857);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(11)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../node_modules/css-loader/index.js!../../../node_modules/sass-loader/lib/loader.js!./Home.scss", function() {
				var newContent = require("!!../../../node_modules/css-loader/index.js!../../../node_modules/sass-loader/lib/loader.js!./Home.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 1446 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(858);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(11)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../node_modules/css-loader/index.js!../../../node_modules/sass-loader/lib/loader.js!./ListBlock.scss", function() {
				var newContent = require("!!../../../node_modules/css-loader/index.js!../../../node_modules/sass-loader/lib/loader.js!./ListBlock.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 1447 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(859);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(11)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../node_modules/css-loader/index.js!../../../node_modules/sass-loader/lib/loader.js!./Lists.scss", function() {
				var newContent = require("!!../../../node_modules/css-loader/index.js!../../../node_modules/sass-loader/lib/loader.js!./Lists.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 1448 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(860);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(11)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../node_modules/css-loader/index.js!../../../node_modules/sass-loader/lib/loader.js!./Loaders.scss", function() {
				var newContent = require("!!../../../node_modules/css-loader/index.js!../../../node_modules/sass-loader/lib/loader.js!./Loaders.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 1449 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(861);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(11)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../node_modules/css-loader/index.js!../../../node_modules/sass-loader/lib/loader.js!./Migrate.scss", function() {
				var newContent = require("!!../../../node_modules/css-loader/index.js!../../../node_modules/sass-loader/lib/loader.js!./Migrate.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 1450 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(862);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(11)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../node_modules/css-loader/index.js!../../../node_modules/sass-loader/lib/loader.js!./Modal.scss", function() {
				var newContent = require("!!../../../node_modules/css-loader/index.js!../../../node_modules/sass-loader/lib/loader.js!./Modal.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 1451 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(863);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(11)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../node_modules/css-loader/index.js!../../../node_modules/sass-loader/lib/loader.js!./MyReceipts.scss", function() {
				var newContent = require("!!../../../node_modules/css-loader/index.js!../../../node_modules/sass-loader/lib/loader.js!./MyReceipts.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 1452 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(864);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(11)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../node_modules/css-loader/index.js!../../../node_modules/sass-loader/lib/loader.js!./ReportDownload.scss", function() {
				var newContent = require("!!../../../node_modules/css-loader/index.js!../../../node_modules/sass-loader/lib/loader.js!./ReportDownload.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 1453 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(865);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(11)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../node_modules/css-loader/index.js!../../../node_modules/sass-loader/lib/loader.js!./MyRecords.scss", function() {
				var newContent = require("!!../../../node_modules/css-loader/index.js!../../../node_modules/sass-loader/lib/loader.js!./MyRecords.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 1454 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(866);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(11)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../node_modules/css-loader/index.js!../../../node_modules/sass-loader/lib/loader.js!./MyWorkQueue.scss", function() {
				var newContent = require("!!../../../node_modules/css-loader/index.js!../../../node_modules/sass-loader/lib/loader.js!./MyWorkQueue.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 1455 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(867);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(11)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../node_modules/css-loader/index.js!../../../node_modules/sass-loader/lib/loader.js!./ReportsList.scss", function() {
				var newContent = require("!!../../../node_modules/css-loader/index.js!../../../node_modules/sass-loader/lib/loader.js!./ReportsList.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 1456 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(868);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(11)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../node_modules/css-loader/index.js!../../../node_modules/sass-loader/lib/loader.js!./NotFound.scss", function() {
				var newContent = require("!!../../../node_modules/css-loader/index.js!../../../node_modules/sass-loader/lib/loader.js!./NotFound.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 1457 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(869);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(11)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../node_modules/css-loader/index.js!../../../node_modules/sass-loader/lib/loader.js!./PageError.scss", function() {
				var newContent = require("!!../../../node_modules/css-loader/index.js!../../../node_modules/sass-loader/lib/loader.js!./PageError.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 1458 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(870);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(11)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../node_modules/css-loader/index.js!../../../node_modules/sass-loader/lib/loader.js!./Pager.scss", function() {
				var newContent = require("!!../../../node_modules/css-loader/index.js!../../../node_modules/sass-loader/lib/loader.js!./Pager.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 1459 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(871);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(11)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../node_modules/css-loader/index.js!../../../node_modules/sass-loader/lib/loader.js!./PayrocGenericModal.scss", function() {
				var newContent = require("!!../../../node_modules/css-loader/index.js!../../../node_modules/sass-loader/lib/loader.js!./PayrocGenericModal.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 1460 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(872);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(11)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../node_modules/css-loader/index.js!../../../node_modules/sass-loader/lib/loader.js!./PrintTable.scss", function() {
				var newContent = require("!!../../../node_modules/css-loader/index.js!../../../node_modules/sass-loader/lib/loader.js!./PrintTable.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 1461 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(873);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(11)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../node_modules/css-loader/index.js!../../../node_modules/sass-loader/lib/loader.js!./RecordHistory.scss", function() {
				var newContent = require("!!../../../node_modules/css-loader/index.js!../../../node_modules/sass-loader/lib/loader.js!./RecordHistory.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 1462 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(874);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(11)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../node_modules/css-loader/index.js!../../../node_modules/sass-loader/lib/loader.js!./ResultsDrawer.scss", function() {
				var newContent = require("!!../../../node_modules/css-loader/index.js!../../../node_modules/sass-loader/lib/loader.js!./ResultsDrawer.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 1463 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(875);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(11)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../node_modules/css-loader/index.js!../../../node_modules/sass-loader/lib/loader.js!./SavedPayments.scss", function() {
				var newContent = require("!!../../../node_modules/css-loader/index.js!../../../node_modules/sass-loader/lib/loader.js!./SavedPayments.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 1464 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(876);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(11)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../node_modules/css-loader/index.js!../../../node_modules/sass-loader/lib/loader.js!./Search.scss", function() {
				var newContent = require("!!../../../node_modules/css-loader/index.js!../../../node_modules/sass-loader/lib/loader.js!./Search.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 1465 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(877);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(11)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../node_modules/css-loader/index.js!../../../node_modules/sass-loader/lib/loader.js!./FabButton.scss", function() {
				var newContent = require("!!../../../node_modules/css-loader/index.js!../../../node_modules/sass-loader/lib/loader.js!./FabButton.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 1466 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(878);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(11)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/lib/loader.js!./Login.scss", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/lib/loader.js!./Login.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 1467 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(879);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(11)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../node_modules/css-loader/index.js!../../../node_modules/sass-loader/lib/loader.js!./Shell.scss", function() {
				var newContent = require("!!../../../node_modules/css-loader/index.js!../../../node_modules/sass-loader/lib/loader.js!./Shell.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 1468 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(880);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(11)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../node_modules/css-loader/index.js!../../../node_modules/sass-loader/lib/loader.js!./Signatures.scss", function() {
				var newContent = require("!!../../../node_modules/css-loader/index.js!../../../node_modules/sass-loader/lib/loader.js!./Signatures.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 1469 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(881);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(11)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../node_modules/css-loader/index.js!../../../node_modules/sass-loader/lib/loader.js!./SlidingPanel.scss", function() {
				var newContent = require("!!../../../node_modules/css-loader/index.js!../../../node_modules/sass-loader/lib/loader.js!./SlidingPanel.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 1470 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(882);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(11)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../node_modules/css-loader/index.js!../../../node_modules/sass-loader/lib/loader.js!./SystemAdmin.scss", function() {
				var newContent = require("!!../../../node_modules/css-loader/index.js!../../../node_modules/sass-loader/lib/loader.js!./SystemAdmin.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 1471 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(883);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(11)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../node_modules/css-loader/index.js!../../../node_modules/sass-loader/lib/loader.js!./Table.scss", function() {
				var newContent = require("!!../../../node_modules/css-loader/index.js!../../../node_modules/sass-loader/lib/loader.js!./Table.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 1472 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(884);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(11)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../node_modules/css-loader/index.js!../../../node_modules/sass-loader/lib/loader.js!./Toast.scss", function() {
				var newContent = require("!!../../../node_modules/css-loader/index.js!../../../node_modules/sass-loader/lib/loader.js!./Toast.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 1473 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(885);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(11)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../node_modules/css-loader/index.js!../../../node_modules/sass-loader/lib/loader.js!./UnsupportedBrowser.scss", function() {
				var newContent = require("!!../../../node_modules/css-loader/index.js!../../../node_modules/sass-loader/lib/loader.js!./UnsupportedBrowser.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 1474 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(886);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(11)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../node_modules/css-loader/index.js!../../../node_modules/sass-loader/lib/loader.js!./UserAccountEditor.scss", function() {
				var newContent = require("!!../../../node_modules/css-loader/index.js!../../../node_modules/sass-loader/lib/loader.js!./UserAccountEditor.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 1475 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(887);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(11)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../node_modules/css-loader/index.js!../../../node_modules/sass-loader/lib/loader.js!./Wizard.scss", function() {
				var newContent = require("!!../../../node_modules/css-loader/index.js!../../../node_modules/sass-loader/lib/loader.js!./Wizard.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 1476 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(888);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(11)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/lib/loader.js!./UploadAndSubmit.scss", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/lib/loader.js!./UploadAndSubmit.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 1477 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global, module) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _ponyfill = __webpack_require__(1478);
	
	var _ponyfill2 = _interopRequireDefault(_ponyfill);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var root; /* global window */
	
	
	if (typeof self !== 'undefined') {
	  root = self;
	} else if (typeof window !== 'undefined') {
	  root = window;
	} else if (typeof global !== 'undefined') {
	  root = global;
	} else if (true) {
	  root = module;
	} else {
	  root = Function('return this')();
	}
	
	var result = (0, _ponyfill2['default'])(root);
	exports['default'] = result;
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }()), __webpack_require__(154)(module)))

/***/ },
/* 1478 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports['default'] = symbolObservablePonyfill;
	function symbolObservablePonyfill(root) {
		var result;
		var _Symbol = root.Symbol;
	
		if (typeof _Symbol === 'function') {
			if (_Symbol.observable) {
				result = _Symbol.observable;
			} else {
				result = _Symbol('observable');
				_Symbol.observable = result;
			}
		} else {
			result = '@@observable';
		}
	
		return result;
	};

/***/ },
/* 1479 */
/***/ function(module, exports) {

	module.exports = function(el, options) {
	  options = options || {};
	
	  var elementDocument = el.ownerDocument || el;
	  var basicTabbables = [];
	  var orderedTabbables = [];
	
	  // A node is "available" if
	  // - it's computed style
	  var isUnavailable = createIsUnavailable(elementDocument);
	
	  var candidateSelectors = [
	    'input',
	    'select',
	    'a[href]',
	    'textarea',
	    'button',
	    '[tabindex]',
	  ];
	
	  var candidates = el.querySelectorAll(candidateSelectors.join(','));
	
	  if (options.includeContainer) {
	    var matches = Element.prototype.matches || Element.prototype.msMatchesSelector || Element.prototype.webkitMatchesSelector;
	
	    if (
	      candidateSelectors.some(function(candidateSelector) {
	        return matches.call(el, candidateSelector);
	      })
	    ) {
	      candidates = Array.prototype.slice.apply(candidates);
	      candidates.unshift(el);
	    }
	  }
	
	  var candidate, candidateIndexAttr, candidateIndex;
	  for (var i = 0, l = candidates.length; i < l; i++) {
	    candidate = candidates[i];
	    candidateIndexAttr = parseInt(candidate.getAttribute('tabindex'), 10)
	    candidateIndex = isNaN(candidateIndexAttr) ? candidate.tabIndex : candidateIndexAttr;
	
	    if (
	      candidateIndex < 0
	      || (candidate.tagName === 'INPUT' && candidate.type === 'hidden')
	      || candidate.disabled
	      || isUnavailable(candidate, elementDocument)
	    ) {
	      continue;
	    }
	
	    if (candidateIndex === 0) {
	      basicTabbables.push(candidate);
	    } else {
	      orderedTabbables.push({
	        index: i,
	        tabIndex: candidateIndex,
	        node: candidate,
	      });
	    }
	  }
	
	  var tabbableNodes = orderedTabbables
	    .sort(function(a, b) {
	      return a.tabIndex === b.tabIndex ? a.index - b.index : a.tabIndex - b.tabIndex;
	    })
	    .map(function(a) {
	      return a.node
	    });
	
	  Array.prototype.push.apply(tabbableNodes, basicTabbables);
	
	  return tabbableNodes;
	}
	
	function createIsUnavailable(elementDocument) {
	  // Node cache must be refreshed on every check, in case
	  // the content of the element has changed
	  var isOffCache = [];
	
	  // "off" means `display: none;`, as opposed to "hidden",
	  // which means `visibility: hidden;`. getComputedStyle
	  // accurately reflects visiblity in context but not
	  // "off" state, so we need to recursively check parents.
	
	  function isOff(node, nodeComputedStyle) {
	    if (node === elementDocument.documentElement) return false;
	
	    // Find the cached node (Array.prototype.find not available in IE9)
	    for (var i = 0, length = isOffCache.length; i < length; i++) {
	      if (isOffCache[i][0] === node) return isOffCache[i][1];
	    }
	
	    nodeComputedStyle = nodeComputedStyle || elementDocument.defaultView.getComputedStyle(node);
	
	    var result = false;
	
	    if (nodeComputedStyle.display === 'none') {
	      result = true;
	    } else if (node.parentNode) {
	      result = isOff(node.parentNode);
	    }
	
	    isOffCache.push([node, result]);
	
	    return result;
	  }
	
	  return function isUnavailable(node) {
	    if (node === elementDocument.documentElement) return false;
	
	    var computedStyle = elementDocument.defaultView.getComputedStyle(node);
	
	    if (isOff(node, computedStyle)) return true;
	
	    return computedStyle.visibility === 'hidden';
	  }
	}


/***/ },
/* 1480 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {var scope = (typeof global !== "undefined" && global) ||
	            (typeof self !== "undefined" && self) ||
	            window;
	var apply = Function.prototype.apply;
	
	// DOM APIs, for completeness
	
	exports.setTimeout = function() {
	  return new Timeout(apply.call(setTimeout, scope, arguments), clearTimeout);
	};
	exports.setInterval = function() {
	  return new Timeout(apply.call(setInterval, scope, arguments), clearInterval);
	};
	exports.clearTimeout =
	exports.clearInterval = function(timeout) {
	  if (timeout) {
	    timeout.close();
	  }
	};
	
	function Timeout(id, clearFn) {
	  this._id = id;
	  this._clearFn = clearFn;
	}
	Timeout.prototype.unref = Timeout.prototype.ref = function() {};
	Timeout.prototype.close = function() {
	  this._clearFn.call(scope, this._id);
	};
	
	// Does not start the time, just sets up the members needed.
	exports.enroll = function(item, msecs) {
	  clearTimeout(item._idleTimeoutId);
	  item._idleTimeout = msecs;
	};
	
	exports.unenroll = function(item) {
	  clearTimeout(item._idleTimeoutId);
	  item._idleTimeout = -1;
	};
	
	exports._unrefActive = exports.active = function(item) {
	  clearTimeout(item._idleTimeoutId);
	
	  var msecs = item._idleTimeout;
	  if (msecs >= 0) {
	    item._idleTimeoutId = setTimeout(function onTimeout() {
	      if (item._onTimeout)
	        item._onTimeout();
	    }, msecs);
	  }
	};
	
	// setimmediate attaches itself to the global object
	__webpack_require__(1417);
	// On some exotic environments, it's not clear which object `setimmediate` was
	// able to install onto.  Search each possibility in the same order as the
	// `setimmediate` library.
	exports.setImmediate = (typeof self !== "undefined" && self.setImmediate) ||
	                       (typeof global !== "undefined" && global.setImmediate) ||
	                       (this && this.setImmediate);
	exports.clearImmediate = (typeof self !== "undefined" && self.clearImmediate) ||
	                         (typeof global !== "undefined" && global.clearImmediate) ||
	                         (this && this.clearImmediate);
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 1481 */
/***/ function(module, exports, __webpack_require__) {

	'use strict'
	
	var wrap = __webpack_require__(1482)
	
	module.exports = trough
	
	trough.wrap = wrap
	
	var slice = [].slice
	
	// Create new middleware.
	function trough() {
	  var fns = []
	  var middleware = {}
	
	  middleware.run = run
	  middleware.use = use
	
	  return middleware
	
	  // Run `fns`.  Last argument must be a completion handler.
	  function run() {
	    var index = -1
	    var input = slice.call(arguments, 0, -1)
	    var done = arguments[arguments.length - 1]
	
	    if (typeof done !== 'function') {
	      throw new Error('Expected function as last argument, not ' + done)
	    }
	
	    next.apply(null, [null].concat(input))
	
	    // Run the next `fn`, if any.
	    function next(err) {
	      var fn = fns[++index]
	      var params = slice.call(arguments, 0)
	      var values = params.slice(1)
	      var length = input.length
	      var pos = -1
	
	      if (err) {
	        done(err)
	        return
	      }
	
	      // Copy non-nully input into values.
	      while (++pos < length) {
	        if (values[pos] === null || values[pos] === undefined) {
	          values[pos] = input[pos]
	        }
	      }
	
	      input = values
	
	      // Next or done.
	      if (fn) {
	        wrap(fn, next).apply(null, input)
	      } else {
	        done.apply(null, [null].concat(input))
	      }
	    }
	  }
	
	  // Add `fn` to the list.
	  function use(fn) {
	    if (typeof fn !== 'function') {
	      throw new Error('Expected `fn` to be a function, not ' + fn)
	    }
	
	    fns.push(fn)
	
	    return middleware
	  }
	}


/***/ },
/* 1482 */
/***/ function(module, exports) {

	'use strict'
	
	var slice = [].slice
	
	module.exports = wrap
	
	// Wrap `fn`.
	// Can be sync or async; return a promise, receive a completion handler, return
	// new values and errors.
	function wrap(fn, callback) {
	  var invoked
	
	  return wrapped
	
	  function wrapped() {
	    var params = slice.call(arguments, 0)
	    var callback = fn.length > params.length
	    var result
	
	    if (callback) {
	      params.push(done)
	    }
	
	    try {
	      result = fn.apply(null, params)
	    } catch (error) {
	      // Well, this is quite the pickle.
	      // `fn` received a callback and invoked it (thus continuing the pipeline),
	      // but later also threw an error.
	      // We’re not about to restart the pipeline again, so the only thing left
	      // to do is to throw the thing instead.
	      if (callback && invoked) {
	        throw error
	      }
	
	      return done(error)
	    }
	
	    if (!callback) {
	      if (result && typeof result.then === 'function') {
	        result.then(then, done)
	      } else if (result instanceof Error) {
	        done(result)
	      } else {
	        then(result)
	      }
	    }
	  }
	
	  // Invoke `next`, only once.
	  function done() {
	    if (!invoked) {
	      invoked = true
	
	      callback.apply(null, arguments)
	    }
	  }
	
	  // Invoke `done` with one value.
	  // Tracks if an error is passed, too.
	  function then(value) {
	    done(null, value)
	  }
	}


/***/ },
/* 1483 */
/***/ function(module, exports, __webpack_require__) {

	'use strict'
	
	var xtend = __webpack_require__(79)
	var inherits = __webpack_require__(58)
	
	module.exports = unherit
	
	// Create a custom constructor which can be modified without affecting the
	// original class.
	function unherit(Super) {
	  var result
	  var key
	  var value
	
	  inherits(Of, Super)
	  inherits(From, Of)
	
	  // Clone values.
	  result = Of.prototype
	
	  for (key in result) {
	    value = result[key]
	
	    if (value && typeof value === 'object') {
	      result[key] = 'concat' in value ? value.concat() : xtend(value)
	    }
	  }
	
	  return Of
	
	  // Constructor accepting a single argument, which itself is an `arguments`
	  // object.
	  function From(parameters) {
	    return Super.apply(this, parameters)
	  }
	
	  // Constructor accepting variadic arguments.
	  function Of() {
	    if (!(this instanceof Of)) {
	      return new From(arguments)
	    }
	
	    return Super.apply(this, arguments)
	  }
	}


/***/ },
/* 1484 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {'use strict'
	
	/* Dependencies. */
	var extend = __webpack_require__(1023)
	var bail = __webpack_require__(613)
	var vfile = __webpack_require__(1520)
	var trough = __webpack_require__(1481)
	var string = __webpack_require__(1522)
	var plain = __webpack_require__(1174)
	
	/* Expose a frozen processor. */
	module.exports = unified().freeze()
	
	var slice = [].slice
	var own = {}.hasOwnProperty
	
	/* Process pipeline. */
	var pipeline = trough()
	  .use(pipelineParse)
	  .use(pipelineRun)
	  .use(pipelineStringify)
	
	function pipelineParse(p, ctx) {
	  ctx.tree = p.parse(ctx.file)
	}
	
	function pipelineRun(p, ctx, next) {
	  p.run(ctx.tree, ctx.file, done)
	
	  function done(err, tree, file) {
	    if (err) {
	      next(err)
	    } else {
	      ctx.tree = tree
	      ctx.file = file
	      next()
	    }
	  }
	}
	
	function pipelineStringify(p, ctx) {
	  ctx.file.contents = p.stringify(ctx.tree, ctx.file)
	}
	
	/* Function to create the first processor. */
	function unified() {
	  var attachers = []
	  var transformers = trough()
	  var namespace = {}
	  var frozen = false
	  var freezeIndex = -1
	
	  /* Data management. */
	  processor.data = data
	
	  /* Lock. */
	  processor.freeze = freeze
	
	  /* Plug-ins. */
	  processor.attachers = attachers
	  processor.use = use
	
	  /* API. */
	  processor.parse = parse
	  processor.stringify = stringify
	  processor.run = run
	  processor.runSync = runSync
	  processor.process = process
	  processor.processSync = processSync
	
	  /* Expose. */
	  return processor
	
	  /* Create a new processor based on the processor
	   * in the current scope. */
	  function processor() {
	    var destination = unified()
	    var length = attachers.length
	    var index = -1
	
	    while (++index < length) {
	      destination.use.apply(null, attachers[index])
	    }
	
	    destination.data(extend(true, {}, namespace))
	
	    return destination
	  }
	
	  /* Freeze: used to signal a processor that has finished
	   * configuration.
	   *
	   * For example, take unified itself.  It’s frozen.
	   * Plug-ins should not be added to it.  Rather, it should
	   * be extended, by invoking it, before modifying it.
	   *
	   * In essence, always invoke this when exporting a
	   * processor. */
	  function freeze() {
	    var values
	    var plugin
	    var options
	    var transformer
	
	    if (frozen) {
	      return processor
	    }
	
	    while (++freezeIndex < attachers.length) {
	      values = attachers[freezeIndex]
	      plugin = values[0]
	      options = values[1]
	      transformer = null
	
	      if (options === false) {
	        continue
	      }
	
	      if (options === true) {
	        values[1] = undefined
	      }
	
	      transformer = plugin.apply(processor, values.slice(1))
	
	      if (typeof transformer === 'function') {
	        transformers.use(transformer)
	      }
	    }
	
	    frozen = true
	    freezeIndex = Infinity
	
	    return processor
	  }
	
	  /* Data management.
	   * Getter / setter for processor-specific informtion. */
	  function data(key, value) {
	    if (string(key)) {
	      /* Set `key`. */
	      if (arguments.length === 2) {
	        assertUnfrozen('data', frozen)
	
	        namespace[key] = value
	
	        return processor
	      }
	
	      /* Get `key`. */
	      return (own.call(namespace, key) && namespace[key]) || null
	    }
	
	    /* Set space. */
	    if (key) {
	      assertUnfrozen('data', frozen)
	      namespace = key
	      return processor
	    }
	
	    /* Get space. */
	    return namespace
	  }
	
	  /* Plug-in management.
	   *
	   * Pass it:
	   * *   an attacher and options,
	   * *   a preset,
	   * *   a list of presets, attachers, and arguments (list
	   *     of attachers and options). */
	  function use(value) {
	    var settings
	
	    assertUnfrozen('use', frozen)
	
	    if (value === null || value === undefined) {
	      /* Empty */
	    } else if (typeof value === 'function') {
	      addPlugin.apply(null, arguments)
	    } else if (typeof value === 'object') {
	      if ('length' in value) {
	        addList(value)
	      } else {
	        addPreset(value)
	      }
	    } else {
	      throw new Error('Expected usable value, not `' + value + '`')
	    }
	
	    if (settings) {
	      namespace.settings = extend(namespace.settings || {}, settings)
	    }
	
	    return processor
	
	    function addPreset(result) {
	      addList(result.plugins)
	
	      if (result.settings) {
	        settings = extend(settings || {}, result.settings)
	      }
	    }
	
	    function add(value) {
	      if (typeof value === 'function') {
	        addPlugin(value)
	      } else if (typeof value === 'object') {
	        if ('length' in value) {
	          addPlugin.apply(null, value)
	        } else {
	          addPreset(value)
	        }
	      } else {
	        throw new Error('Expected usable value, not `' + value + '`')
	      }
	    }
	
	    function addList(plugins) {
	      var length
	      var index
	
	      if (plugins === null || plugins === undefined) {
	        /* Empty */
	      } else if (typeof plugins === 'object' && 'length' in plugins) {
	        length = plugins.length
	        index = -1
	
	        while (++index < length) {
	          add(plugins[index])
	        }
	      } else {
	        throw new Error('Expected a list of plugins, not `' + plugins + '`')
	      }
	    }
	
	    function addPlugin(plugin, value) {
	      var entry = find(plugin)
	
	      if (entry) {
	        if (plain(entry[1]) && plain(value)) {
	          value = extend(entry[1], value)
	        }
	
	        entry[1] = value
	      } else {
	        attachers.push(slice.call(arguments))
	      }
	    }
	  }
	
	  function find(plugin) {
	    var length = attachers.length
	    var index = -1
	    var entry
	
	    while (++index < length) {
	      entry = attachers[index]
	
	      if (entry[0] === plugin) {
	        return entry
	      }
	    }
	  }
	
	  /* Parse a file (in string or VFile representation)
	   * into a Unist node using the `Parser` on the
	   * processor. */
	  function parse(doc) {
	    var file = vfile(doc)
	    var Parser
	
	    freeze()
	    Parser = processor.Parser
	    assertParser('parse', Parser)
	
	    if (newable(Parser)) {
	      return new Parser(String(file), file).parse()
	    }
	
	    return Parser(String(file), file) // eslint-disable-line new-cap
	  }
	
	  /* Run transforms on a Unist node representation of a file
	   * (in string or VFile representation), async. */
	  function run(node, file, cb) {
	    assertNode(node)
	    freeze()
	
	    if (!cb && typeof file === 'function') {
	      cb = file
	      file = null
	    }
	
	    if (!cb) {
	      return new Promise(executor)
	    }
	
	    executor(null, cb)
	
	    function executor(resolve, reject) {
	      transformers.run(node, vfile(file), done)
	
	      function done(err, tree, file) {
	        tree = tree || node
	        if (err) {
	          reject(err)
	        } else if (resolve) {
	          resolve(tree)
	        } else {
	          cb(null, tree, file)
	        }
	      }
	    }
	  }
	
	  /* Run transforms on a Unist node representation of a file
	   * (in string or VFile representation), sync. */
	  function runSync(node, file) {
	    var complete = false
	    var result
	
	    run(node, file, done)
	
	    assertDone('runSync', 'run', complete)
	
	    return result
	
	    function done(err, tree) {
	      complete = true
	      bail(err)
	      result = tree
	    }
	  }
	
	  /* Stringify a Unist node representation of a file
	   * (in string or VFile representation) into a string
	   * using the `Compiler` on the processor. */
	  function stringify(node, doc) {
	    var file = vfile(doc)
	    var Compiler
	
	    freeze()
	    Compiler = processor.Compiler
	    assertCompiler('stringify', Compiler)
	    assertNode(node)
	
	    if (newable(Compiler)) {
	      return new Compiler(node, file).compile()
	    }
	
	    return Compiler(node, file) // eslint-disable-line new-cap
	  }
	
	  /* Parse a file (in string or VFile representation)
	   * into a Unist node using the `Parser` on the processor,
	   * then run transforms on that node, and compile the
	   * resulting node using the `Compiler` on the processor,
	   * and store that result on the VFile. */
	  function process(doc, cb) {
	    freeze()
	    assertParser('process', processor.Parser)
	    assertCompiler('process', processor.Compiler)
	
	    if (!cb) {
	      return new Promise(executor)
	    }
	
	    executor(null, cb)
	
	    function executor(resolve, reject) {
	      var file = vfile(doc)
	
	      pipeline.run(processor, {file: file}, done)
	
	      function done(err) {
	        if (err) {
	          reject(err)
	        } else if (resolve) {
	          resolve(file)
	        } else {
	          cb(null, file)
	        }
	      }
	    }
	  }
	
	  /* Process the given document (in string or VFile
	   * representation), sync. */
	  function processSync(doc) {
	    var complete = false
	    var file
	
	    freeze()
	    assertParser('processSync', processor.Parser)
	    assertCompiler('processSync', processor.Compiler)
	    file = vfile(doc)
	
	    process(file, done)
	
	    assertDone('processSync', 'process', complete)
	
	    return file
	
	    function done(err) {
	      complete = true
	      bail(err)
	    }
	  }
	}
	
	/* Check if `func` is a constructor. */
	function newable(value) {
	  return typeof value === 'function' && keys(value.prototype)
	}
	
	/* Check if `value` is an object with keys. */
	function keys(value) {
	  var key
	  for (key in value) {
	    return true
	  }
	  return false
	}
	
	/* Assert a parser is available. */
	function assertParser(name, Parser) {
	  if (typeof Parser !== 'function') {
	    throw new Error('Cannot `' + name + '` without `Parser`')
	  }
	}
	
	/* Assert a compiler is available. */
	function assertCompiler(name, Compiler) {
	  if (typeof Compiler !== 'function') {
	    throw new Error('Cannot `' + name + '` without `Compiler`')
	  }
	}
	
	/* Assert the processor is not frozen. */
	function assertUnfrozen(name, frozen) {
	  if (frozen) {
	    throw new Error(
	      [
	        'Cannot invoke `' + name + '` on a frozen processor.\nCreate a new ',
	        'processor first, by invoking it: use `processor()` instead of ',
	        '`processor`.'
	      ].join('')
	    )
	  }
	}
	
	/* Assert `node` is a Unist node. */
	function assertNode(node) {
	  if (!node || !string(node.type)) {
	    throw new Error('Expected node, got `' + node + '`')
	  }
	}
	
	/* Assert that `complete` is `true`. */
	function assertDone(name, asyncName, complete) {
	  if (!complete) {
	    throw new Error(
	      '`' + name + '` finished async. Use `' + asyncName + '` instead'
	    )
	  }
	}
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(77)))

/***/ },
/* 1485 */
/***/ function(module, exports) {

	'use strict'
	
	module.exports = convert
	
	function convert(test) {
	  if (typeof test === 'string') {
	    return typeFactory(test)
	  }
	
	  if (test === null || test === undefined) {
	    return ok
	  }
	
	  if (typeof test === 'object') {
	    return ('length' in test ? anyFactory : matchesFactory)(test)
	  }
	
	  if (typeof test === 'function') {
	    return test
	  }
	
	  throw new Error('Expected function, string, or object as test')
	}
	
	function convertAll(tests) {
	  var results = []
	  var length = tests.length
	  var index = -1
	
	  while (++index < length) {
	    results[index] = convert(tests[index])
	  }
	
	  return results
	}
	
	// Utility assert each property in `test` is represented in `node`, and each
	// values are strictly equal.
	function matchesFactory(test) {
	  return matches
	
	  function matches(node) {
	    var key
	
	    for (key in test) {
	      if (node[key] !== test[key]) {
	        return false
	      }
	    }
	
	    return true
	  }
	}
	
	function anyFactory(tests) {
	  var checks = convertAll(tests)
	  var length = checks.length
	
	  return matches
	
	  function matches() {
	    var index = -1
	
	    while (++index < length) {
	      if (checks[index].apply(this, arguments)) {
	        return true
	      }
	    }
	
	    return false
	  }
	}
	
	// Utility to convert a string into a function which checks a given node’s type
	// for said string.
	function typeFactory(test) {
	  return type
	
	  function type(node) {
	    return Boolean(node && node.type === test)
	  }
	}
	
	// Utility to return true.
	function ok() {
	  return true
	}


/***/ },
/* 1486 */
/***/ function(module, exports, __webpack_require__) {

	'use strict'
	
	var visit = __webpack_require__(215)
	
	module.exports = removePosition
	
	function removePosition(node, force) {
	  visit(node, force ? hard : soft)
	  return node
	}
	
	function hard(node) {
	  delete node.position
	}
	
	function soft(node) {
	  node.position = undefined
	}


/***/ },
/* 1487 */
/***/ function(module, exports) {

	'use strict'
	
	var own = {}.hasOwnProperty
	
	module.exports = stringify
	
	function stringify(value) {
	  /* Nothing. */
	  if (!value || typeof value !== 'object') {
	    return null
	  }
	
	  /* Node. */
	  if (own.call(value, 'position') || own.call(value, 'type')) {
	    return position(value.position)
	  }
	
	  /* Position. */
	  if (own.call(value, 'start') || own.call(value, 'end')) {
	    return position(value)
	  }
	
	  /* Point. */
	  if (own.call(value, 'line') || own.call(value, 'column')) {
	    return point(value)
	  }
	
	  /* ? */
	  return null
	}
	
	function point(point) {
	  if (!point || typeof point !== 'object') {
	    point = {}
	  }
	
	  return index(point.line) + ':' + index(point.column)
	}
	
	function position(pos) {
	  if (!pos || typeof pos !== 'object') {
	    pos = {}
	  }
	
	  return point(pos.start) + '-' + point(pos.end)
	}
	
	function index(value) {
	  return value && typeof value === 'number' ? value : 1
	}


/***/ },
/* 1488 */
/***/ function(module, exports) {

	'use strict'
	
	/* Expose. */
	module.exports = visitParents
	
	/* Visit. */
	function visitParents(tree, type, visitor) {
	  var stack = []
	
	  if (typeof type === 'function') {
	    visitor = type
	    type = null
	  }
	
	  one(tree)
	
	  /* Visit a single node. */
	  function one(node) {
	    var result
	
	    if (!type || node.type === type) {
	      result = visitor(node, stack.concat())
	    }
	
	    if (node.children && result !== false) {
	      return all(node.children, node)
	    }
	
	    return result
	  }
	
	  /* Visit children in `parent`. */
	  function all(children, parent) {
	    var length = children.length
	    var index = -1
	    var child
	
	    stack.push(parent)
	
	    while (++index < length) {
	      child = children[index]
	
	      if (child && one(child) === false) {
	        return false
	      }
	    }
	
	    stack.pop()
	
	    return true
	  }
	}


/***/ },
/* 1489 */
/***/ function(module, exports, __webpack_require__) {

	'use strict'
	
	module.exports = visitParents
	
	var convert = __webpack_require__(1485)
	
	var CONTINUE = true
	var SKIP = 'skip'
	var EXIT = false
	
	visitParents.CONTINUE = CONTINUE
	visitParents.SKIP = SKIP
	visitParents.EXIT = EXIT
	
	function visitParents(tree, test, visitor, reverse) {
	  var is
	
	  if (typeof test === 'function' && typeof visitor !== 'function') {
	    reverse = visitor
	    visitor = test
	    test = null
	  }
	
	  is = convert(test)
	
	  one(tree, null, [])
	
	  // Visit a single node.
	  function one(node, index, parents) {
	    var result = []
	    var subresult
	
	    if (!test || is(node, index, parents[parents.length - 1] || null)) {
	      result = toResult(visitor(node, parents))
	
	      if (result[0] === EXIT) {
	        return result
	      }
	    }
	
	    if (node.children && result[0] !== SKIP) {
	      subresult = toResult(all(node.children, parents.concat(node)))
	      return subresult[0] === EXIT ? subresult : result
	    }
	
	    return result
	  }
	
	  // Visit children in `parent`.
	  function all(children, parents) {
	    var min = -1
	    var step = reverse ? -1 : 1
	    var index = (reverse ? children.length : min) + step
	    var result
	
	    while (index > min && index < children.length) {
	      result = one(children[index], index, parents)
	
	      if (result[0] === EXIT) {
	        return result
	      }
	
	      index = typeof result[1] === 'number' ? result[1] : index + step
	    }
	  }
	}
	
	function toResult(value) {
	  if (value !== null && typeof value === 'object' && 'length' in value) {
	    return value
	  }
	
	  if (typeof value === 'number') {
	    return [CONTINUE, value]
	  }
	
	  return [value]
	}


/***/ },
/* 1490 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/icomoon.b54e46ef.svg";

/***/ },
/* 1491 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/icomoon.4cebb9c0.ttf";

/***/ },
/* 1492 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/icomoon.f1f8eaa6.woff";

/***/ },
/* 1493 */
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ },
/* 1494 */
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ },
/* 1495 */
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ },
/* 1496 */
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ },
/* 1497 */
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ },
/* 1498 */
/***/ function(module, exports) {

	module.exports = "data:image/gif;base64,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"

/***/ },
/* 1499 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/seal.aee877da.png";

/***/ },
/* 1500 */
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ },
/* 1501 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/sos-logo.f609afea.png";

/***/ },
/* 1502 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/seal.7a6ff62c.png";

/***/ },
/* 1503 */
1500,
/* 1504 */
1501,
/* 1505 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/mt-sos-logo.a771ebbb.png";

/***/ },
/* 1506 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/seal.a5c56e2b.png";

/***/ },
/* 1507 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/seal_color.06891476.png";

/***/ },
/* 1508 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/seal_white.11347f21.png";

/***/ },
/* 1509 */
/***/ function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {
	/**
	 * Module exports.
	 */
	
	module.exports = deprecate;
	
	/**
	 * Mark that a method should not be used.
	 * Returns a modified function which warns once by default.
	 *
	 * If `localStorage.noDeprecation = true` is set, then it is a no-op.
	 *
	 * If `localStorage.throwDeprecation = true` is set, then deprecated functions
	 * will throw an Error when invoked.
	 *
	 * If `localStorage.traceDeprecation = true` is set, then deprecated functions
	 * will invoke `console.trace()` instead of `console.error()`.
	 *
	 * @param {Function} fn - the function to deprecate
	 * @param {String} msg - the string to print to the console when `fn` is invoked
	 * @returns {Function} a new "deprecated" version of `fn`
	 * @api public
	 */
	
	function deprecate (fn, msg) {
	  if (config('noDeprecation')) {
	    return fn;
	  }
	
	  var warned = false;
	  function deprecated() {
	    if (!warned) {
	      if (config('throwDeprecation')) {
	        throw new Error(msg);
	      } else if (config('traceDeprecation')) {
	        console.trace(msg);
	      } else {
	        console.warn(msg);
	      }
	      warned = true;
	    }
	    return fn.apply(this, arguments);
	  }
	
	  return deprecated;
	}
	
	/**
	 * Checks `localStorage` for boolean values for the given `name`.
	 *
	 * @param {String} name
	 * @returns {Boolean}
	 * @api private
	 */
	
	function config (name) {
	  // accessing global.localStorage can trigger a DOMException in sandboxed iframes
	  try {
	    if (!global.localStorage) return false;
	  } catch (_) {
	    return false;
	  }
	  var val = global.localStorage[name];
	  if (null == val) return false;
	  return String(val).toLowerCase() === 'true';
	}
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 1510 */
/***/ function(module, exports) {

	if (typeof Object.create === 'function') {
	  // implementation from standard node.js 'util' module
	  module.exports = function inherits(ctor, superCtor) {
	    ctor.super_ = superCtor
	    ctor.prototype = Object.create(superCtor.prototype, {
	      constructor: {
	        value: ctor,
	        enumerable: false,
	        writable: true,
	        configurable: true
	      }
	    });
	  };
	} else {
	  // old school shim for old browsers
	  module.exports = function inherits(ctor, superCtor) {
	    ctor.super_ = superCtor
	    var TempCtor = function () {}
	    TempCtor.prototype = superCtor.prototype
	    ctor.prototype = new TempCtor()
	    ctor.prototype.constructor = ctor
	  }
	}


/***/ },
/* 1511 */
/***/ function(module, exports) {

	module.exports = function isBuffer(arg) {
	  return arg && typeof arg === 'object'
	    && typeof arg.copy === 'function'
	    && typeof arg.fill === 'function'
	    && typeof arg.readUInt8 === 'function';
	}

/***/ },
/* 1512 */
/***/ function(module, exports, __webpack_require__) {

	var v1 = __webpack_require__(1513);
	var v4 = __webpack_require__(1514);
	
	var uuid = v4;
	uuid.v1 = v1;
	uuid.v4 = v4;
	
	module.exports = uuid;


/***/ },
/* 1513 */
/***/ function(module, exports, __webpack_require__) {

	var rng = __webpack_require__(542);
	var bytesToUuid = __webpack_require__(541);
	
	// **`v1()` - Generate time-based UUID**
	//
	// Inspired by https://github.com/LiosK/UUID.js
	// and http://docs.python.org/library/uuid.html
	
	var _nodeId;
	var _clockseq;
	
	// Previous uuid creation time
	var _lastMSecs = 0;
	var _lastNSecs = 0;
	
	// See https://github.com/uuidjs/uuid for API details
	function v1(options, buf, offset) {
	  var i = buf && offset || 0;
	  var b = buf || [];
	
	  options = options || {};
	  var node = options.node || _nodeId;
	  var clockseq = options.clockseq !== undefined ? options.clockseq : _clockseq;
	
	  // node and clockseq need to be initialized to random values if they're not
	  // specified.  We do this lazily to minimize issues related to insufficient
	  // system entropy.  See #189
	  if (node == null || clockseq == null) {
	    var seedBytes = rng();
	    if (node == null) {
	      // Per 4.5, create and 48-bit node id, (47 random bits + multicast bit = 1)
	      node = _nodeId = [
	        seedBytes[0] | 0x01,
	        seedBytes[1], seedBytes[2], seedBytes[3], seedBytes[4], seedBytes[5]
	      ];
	    }
	    if (clockseq == null) {
	      // Per 4.2.2, randomize (14 bit) clockseq
	      clockseq = _clockseq = (seedBytes[6] << 8 | seedBytes[7]) & 0x3fff;
	    }
	  }
	
	  // UUID timestamps are 100 nano-second units since the Gregorian epoch,
	  // (1582-10-15 00:00).  JSNumbers aren't precise enough for this, so
	  // time is handled internally as 'msecs' (integer milliseconds) and 'nsecs'
	  // (100-nanoseconds offset from msecs) since unix epoch, 1970-01-01 00:00.
	  var msecs = options.msecs !== undefined ? options.msecs : new Date().getTime();
	
	  // Per 4.2.1.2, use count of uuid's generated during the current clock
	  // cycle to simulate higher resolution clock
	  var nsecs = options.nsecs !== undefined ? options.nsecs : _lastNSecs + 1;
	
	  // Time since last uuid creation (in msecs)
	  var dt = (msecs - _lastMSecs) + (nsecs - _lastNSecs)/10000;
	
	  // Per 4.2.1.2, Bump clockseq on clock regression
	  if (dt < 0 && options.clockseq === undefined) {
	    clockseq = clockseq + 1 & 0x3fff;
	  }
	
	  // Reset nsecs if clock regresses (new clockseq) or we've moved onto a new
	  // time interval
	  if ((dt < 0 || msecs > _lastMSecs) && options.nsecs === undefined) {
	    nsecs = 0;
	  }
	
	  // Per 4.2.1.2 Throw error if too many uuids are requested
	  if (nsecs >= 10000) {
	    throw new Error('uuid.v1(): Can\'t create more than 10M uuids/sec');
	  }
	
	  _lastMSecs = msecs;
	  _lastNSecs = nsecs;
	  _clockseq = clockseq;
	
	  // Per 4.1.4 - Convert from unix epoch to Gregorian epoch
	  msecs += 12219292800000;
	
	  // `time_low`
	  var tl = ((msecs & 0xfffffff) * 10000 + nsecs) % 0x100000000;
	  b[i++] = tl >>> 24 & 0xff;
	  b[i++] = tl >>> 16 & 0xff;
	  b[i++] = tl >>> 8 & 0xff;
	  b[i++] = tl & 0xff;
	
	  // `time_mid`
	  var tmh = (msecs / 0x100000000 * 10000) & 0xfffffff;
	  b[i++] = tmh >>> 8 & 0xff;
	  b[i++] = tmh & 0xff;
	
	  // `time_high_and_version`
	  b[i++] = tmh >>> 24 & 0xf | 0x10; // include version
	  b[i++] = tmh >>> 16 & 0xff;
	
	  // `clock_seq_hi_and_reserved` (Per 4.2.2 - include variant)
	  b[i++] = clockseq >>> 8 | 0x80;
	
	  // `clock_seq_low`
	  b[i++] = clockseq & 0xff;
	
	  // `node`
	  for (var n = 0; n < 6; ++n) {
	    b[i + n] = node[n];
	  }
	
	  return buf ? buf : bytesToUuid(b);
	}
	
	module.exports = v1;


/***/ },
/* 1514 */
/***/ function(module, exports, __webpack_require__) {

	var rng = __webpack_require__(542);
	var bytesToUuid = __webpack_require__(541);
	
	function v4(options, buf, offset) {
	  var i = buf && offset || 0;
	
	  if (typeof(options) == 'string') {
	    buf = options === 'binary' ? new Array(16) : null;
	    options = null;
	  }
	  options = options || {};
	
	  var rnds = options.random || (options.rng || rng)();
	
	  // Per 4.4, set bits for version and `clock_seq_hi_and_reserved`
	  rnds[6] = (rnds[6] & 0x0f) | 0x40;
	  rnds[8] = (rnds[8] & 0x3f) | 0x80;
	
	  // Copy bytes to buffer, if provided
	  if (buf) {
	    for (var ii = 0; ii < 16; ++ii) {
	      buf[i + ii] = rnds[ii];
	    }
	  }
	
	  return buf || bytesToUuid(rnds);
	}
	
	module.exports = v4;


/***/ },
/* 1515 */
/***/ function(module, exports) {

	"use strict";function valueOf(e){return e.valueOf?e.valueOf():Object.prototype.valueOf.call(e)}function valueEqual(u,r){if(u===r)return!0;if(null==u||null==r)return!1;if(Array.isArray(u))return Array.isArray(r)&&u.length===r.length&&u.every(function(e,u){return valueEqual(e,r[u])});if("object"!=typeof u&&"object"!=typeof r)return!1;var e=valueOf(u),t=valueOf(r);return e!==u||t!==r?valueEqual(e,t):Object.keys(Object.assign({},u,r)).every(function(e){return valueEqual(u[e],r[e])})}module.exports=valueEqual;


/***/ },
/* 1516 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	if (true) {
	  module.exports = __webpack_require__(1515);
	} else {
	  module.exports = require('./cjs/value-equal.js');
	}


/***/ },
/* 1517 */
/***/ function(module, exports) {

	'use strict'
	
	module.exports = factory
	
	function factory(file) {
	  var contents = indices(String(file))
	
	  return {
	    toPosition: offsetToPositionFactory(contents),
	    toOffset: positionToOffsetFactory(contents)
	  }
	}
	
	// Factory to get the line and column-based `position` for `offset` in the bound
	// indices.
	function offsetToPositionFactory(indices) {
	  return offsetToPosition
	
	  // Get the line and column-based `position` for `offset` in the bound indices.
	  function offsetToPosition(offset) {
	    var index = -1
	    var length = indices.length
	
	    if (offset < 0) {
	      return {}
	    }
	
	    while (++index < length) {
	      if (indices[index] > offset) {
	        return {
	          line: index + 1,
	          column: offset - (indices[index - 1] || 0) + 1,
	          offset: offset
	        }
	      }
	    }
	
	    return {}
	  }
	}
	
	// Factory to get the `offset` for a line and column-based `position` in the
	// bound indices.
	function positionToOffsetFactory(indices) {
	  return positionToOffset
	
	  // Get the `offset` for a line and column-based `position` in the bound
	  // indices.
	  function positionToOffset(position) {
	    var line = position && position.line
	    var column = position && position.column
	
	    if (!isNaN(line) && !isNaN(column) && line - 1 in indices) {
	      return (indices[line - 2] || 0) + column - 1 || 0
	    }
	
	    return -1
	  }
	}
	
	// Get indices of line-breaks in `value`.
	function indices(value) {
	  var result = []
	  var index = value.indexOf('\n')
	
	  while (index !== -1) {
	    result.push(index + 1)
	    index = value.indexOf('\n', index + 1)
	  }
	
	  result.push(value.length + 1)
	
	  return result
	}


/***/ },
/* 1518 */
/***/ function(module, exports, __webpack_require__) {

	'use strict'
	
	var stringify = __webpack_require__(1487)
	
	module.exports = VMessage
	
	// Inherit from `Error#`.
	function VMessagePrototype() {}
	VMessagePrototype.prototype = Error.prototype
	VMessage.prototype = new VMessagePrototype()
	
	// Message properties.
	var proto = VMessage.prototype
	
	proto.file = ''
	proto.name = ''
	proto.reason = ''
	proto.message = ''
	proto.stack = ''
	proto.fatal = null
	proto.column = null
	proto.line = null
	
	// Construct a new VMessage.
	//
	// Note: We cannot invoke `Error` on the created context, as that adds readonly
	// `line` and `column` attributes on Safari 9, thus throwing and failing the
	// data.
	function VMessage(reason, position, origin) {
	  var parts
	  var range
	  var location
	
	  if (typeof position === 'string') {
	    origin = position
	    position = null
	  }
	
	  parts = parseOrigin(origin)
	  range = stringify(position) || '1:1'
	
	  location = {
	    start: {line: null, column: null},
	    end: {line: null, column: null}
	  }
	
	  // Node.
	  if (position && position.position) {
	    position = position.position
	  }
	
	  if (position) {
	    // Position.
	    if (position.start) {
	      location = position
	      position = position.start
	    } else {
	      // Point.
	      location.start = position
	    }
	  }
	
	  if (reason.stack) {
	    this.stack = reason.stack
	    reason = reason.message
	  }
	
	  this.message = reason
	  this.name = range
	  this.reason = reason
	  this.line = position ? position.line : null
	  this.column = position ? position.column : null
	  this.location = location
	  this.source = parts[0]
	  this.ruleId = parts[1]
	}
	
	function parseOrigin(origin) {
	  var result = [null, null]
	  var index
	
	  if (typeof origin === 'string') {
	    index = origin.indexOf(':')
	
	    if (index === -1) {
	      result[1] = origin
	    } else {
	      result[0] = origin.slice(0, index)
	      result[1] = origin.slice(index + 1)
	    }
	  }
	
	  return result
	}


/***/ },
/* 1519 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {'use strict';
	
	var path = __webpack_require__(506);
	var replace = __webpack_require__(1409);
	var buffer = __webpack_require__(1171);
	
	module.exports = VFile;
	
	var own = {}.hasOwnProperty;
	var proto = VFile.prototype;
	
	proto.toString = toString;
	
	/* Order of setting (least specific to most), we need this because
	 * otherwise `{stem: 'a', path: '~/b.js'}` would throw, as a path
	 * is needed before a stem can be set. */
	var order = [
	  'history',
	  'path',
	  'basename',
	  'stem',
	  'extname',
	  'dirname'
	];
	
	/* Construct a new file. */
	function VFile(options) {
	  var prop;
	  var index;
	  var length;
	
	  if (!options) {
	    options = {};
	  } else if (typeof options === 'string' || buffer(options)) {
	    options = {contents: options};
	  } else if ('message' in options && 'messages' in options) {
	    return options;
	  }
	
	  if (!(this instanceof VFile)) {
	    return new VFile(options);
	  }
	
	  this.data = {};
	  this.messages = [];
	  this.history = [];
	  this.cwd = process.cwd();
	
	  /* Set path related properties in the correct order. */
	  index = -1;
	  length = order.length;
	
	  while (++index < length) {
	    prop = order[index];
	
	    if (own.call(options, prop)) {
	      this[prop] = options[prop];
	    }
	  }
	
	  /* Set non-path related properties. */
	  for (prop in options) {
	    if (order.indexOf(prop) === -1) {
	      this[prop] = options[prop];
	    }
	  }
	}
	
	/* Access full path (`~/index.min.js`). */
	Object.defineProperty(proto, 'path', {
	  get: function () {
	    return this.history[this.history.length - 1];
	  },
	  set: function (path) {
	    assertNonEmpty(path, 'path');
	
	    if (path !== this.path) {
	      this.history.push(path);
	    }
	  }
	});
	
	/* Access parent path (`~`). */
	Object.defineProperty(proto, 'dirname', {
	  get: function () {
	    return typeof this.path === 'string' ? path.dirname(this.path) : undefined;
	  },
	  set: function (dirname) {
	    assertPath(this.path, 'dirname');
	    this.path = path.join(dirname || '', this.basename);
	  }
	});
	
	/* Access basename (`index.min.js`). */
	Object.defineProperty(proto, 'basename', {
	  get: function () {
	    return typeof this.path === 'string' ? path.basename(this.path) : undefined;
	  },
	  set: function (basename) {
	    assertNonEmpty(basename, 'basename');
	    assertPart(basename, 'basename');
	    this.path = path.join(this.dirname || '', basename);
	  }
	});
	
	/* Access extname (`.js`). */
	Object.defineProperty(proto, 'extname', {
	  get: function () {
	    return typeof this.path === 'string' ? path.extname(this.path) : undefined;
	  },
	  set: function (extname) {
	    var ext = extname || '';
	
	    assertPart(ext, 'extname');
	    assertPath(this.path, 'extname');
	
	    if (ext) {
	      if (ext.charAt(0) !== '.') {
	        throw new Error('`extname` must start with `.`');
	      }
	
	      if (ext.indexOf('.', 1) !== -1) {
	        throw new Error('`extname` cannot contain multiple dots');
	      }
	    }
	
	    this.path = replace(this.path, ext);
	  }
	});
	
	/* Access stem (`index.min`). */
	Object.defineProperty(proto, 'stem', {
	  get: function () {
	    return typeof this.path === 'string' ? path.basename(this.path, this.extname) : undefined;
	  },
	  set: function (stem) {
	    assertNonEmpty(stem, 'stem');
	    assertPart(stem, 'stem');
	    this.path = path.join(this.dirname || '', stem + (this.extname || ''));
	  }
	});
	
	/* Get the value of the file. */
	function toString(encoding) {
	  var value = this.contents || '';
	  return buffer(value) ? value.toString(encoding) : String(value);
	}
	
	/* Assert that `part` is not a path (i.e., does
	 * not contain `path.sep`). */
	function assertPart(part, name) {
	  if (part.indexOf(path.sep) !== -1) {
	    throw new Error('`' + name + '` cannot be a path: did not expect `' + path.sep + '`');
	  }
	}
	
	/* Assert that `part` is not empty. */
	function assertNonEmpty(part, name) {
	  if (!part) {
	    throw new Error('`' + name + '` cannot be empty');
	  }
	}
	
	/* Assert `path` exists. */
	function assertPath(path, name) {
	  if (!path) {
	    throw new Error('Setting `' + name + '` requires `path` to be set too');
	  }
	}
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(77)))

/***/ },
/* 1520 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var VMessage = __webpack_require__(1518);
	var VFile = __webpack_require__(1519);
	
	module.exports = VFile;
	
	var proto = VFile.prototype;
	
	proto.message = message;
	proto.info = info;
	proto.fail = fail;
	
	/* Slight backwards compatibility.  Remove in the future. */
	proto.warn = message;
	
	/* Create a message with `reason` at `position`.
	 * When an error is passed in as `reason`, copies the stack. */
	function message(reason, position, origin) {
	  var filePath = this.path;
	  var message = new VMessage(reason, position, origin);
	
	  if (filePath) {
	    message.name = filePath + ':' + message.name;
	    message.file = filePath;
	  }
	
	  message.fatal = false;
	
	  this.messages.push(message);
	
	  return message;
	}
	
	/* Fail. Creates a vmessage, associates it with the file,
	 * and throws it. */
	function fail() {
	  var message = this.message.apply(this, arguments);
	
	  message.fatal = true;
	
	  throw message;
	}
	
	/* Info. Creates a vmessage, associates it with the file,
	 * and marks the fatality as null. */
	function info() {
	  var message = this.message.apply(this, arguments);
	
	  message.fatal = null;
	
	  return message;
	}


/***/ },
/* 1521 */
/***/ function(module, exports) {

	(function(self) {
	  'use strict';
	
	  if (self.fetch) {
	    return
	  }
	
	  var support = {
	    searchParams: 'URLSearchParams' in self,
	    iterable: 'Symbol' in self && 'iterator' in Symbol,
	    blob: 'FileReader' in self && 'Blob' in self && (function() {
	      try {
	        new Blob()
	        return true
	      } catch(e) {
	        return false
	      }
	    })(),
	    formData: 'FormData' in self,
	    arrayBuffer: 'ArrayBuffer' in self
	  }
	
	  if (support.arrayBuffer) {
	    var viewClasses = [
	      '[object Int8Array]',
	      '[object Uint8Array]',
	      '[object Uint8ClampedArray]',
	      '[object Int16Array]',
	      '[object Uint16Array]',
	      '[object Int32Array]',
	      '[object Uint32Array]',
	      '[object Float32Array]',
	      '[object Float64Array]'
	    ]
	
	    var isDataView = function(obj) {
	      return obj && DataView.prototype.isPrototypeOf(obj)
	    }
	
	    var isArrayBufferView = ArrayBuffer.isView || function(obj) {
	      return obj && viewClasses.indexOf(Object.prototype.toString.call(obj)) > -1
	    }
	  }
	
	  function normalizeName(name) {
	    if (typeof name !== 'string') {
	      name = String(name)
	    }
	    if (/[^a-z0-9\-#$%&'*+.\^_`|~]/i.test(name)) {
	      throw new TypeError('Invalid character in header field name')
	    }
	    return name.toLowerCase()
	  }
	
	  function normalizeValue(value) {
	    if (typeof value !== 'string') {
	      value = String(value)
	    }
	    return value
	  }
	
	  // Build a destructive iterator for the value list
	  function iteratorFor(items) {
	    var iterator = {
	      next: function() {
	        var value = items.shift()
	        return {done: value === undefined, value: value}
	      }
	    }
	
	    if (support.iterable) {
	      iterator[Symbol.iterator] = function() {
	        return iterator
	      }
	    }
	
	    return iterator
	  }
	
	  function Headers(headers) {
	    this.map = {}
	
	    if (headers instanceof Headers) {
	      headers.forEach(function(value, name) {
	        this.append(name, value)
	      }, this)
	    } else if (Array.isArray(headers)) {
	      headers.forEach(function(header) {
	        this.append(header[0], header[1])
	      }, this)
	    } else if (headers) {
	      Object.getOwnPropertyNames(headers).forEach(function(name) {
	        this.append(name, headers[name])
	      }, this)
	    }
	  }
	
	  Headers.prototype.append = function(name, value) {
	    name = normalizeName(name)
	    value = normalizeValue(value)
	    var oldValue = this.map[name]
	    this.map[name] = oldValue ? oldValue+','+value : value
	  }
	
	  Headers.prototype['delete'] = function(name) {
	    delete this.map[normalizeName(name)]
	  }
	
	  Headers.prototype.get = function(name) {
	    name = normalizeName(name)
	    return this.has(name) ? this.map[name] : null
	  }
	
	  Headers.prototype.has = function(name) {
	    return this.map.hasOwnProperty(normalizeName(name))
	  }
	
	  Headers.prototype.set = function(name, value) {
	    this.map[normalizeName(name)] = normalizeValue(value)
	  }
	
	  Headers.prototype.forEach = function(callback, thisArg) {
	    for (var name in this.map) {
	      if (this.map.hasOwnProperty(name)) {
	        callback.call(thisArg, this.map[name], name, this)
	      }
	    }
	  }
	
	  Headers.prototype.keys = function() {
	    var items = []
	    this.forEach(function(value, name) { items.push(name) })
	    return iteratorFor(items)
	  }
	
	  Headers.prototype.values = function() {
	    var items = []
	    this.forEach(function(value) { items.push(value) })
	    return iteratorFor(items)
	  }
	
	  Headers.prototype.entries = function() {
	    var items = []
	    this.forEach(function(value, name) { items.push([name, value]) })
	    return iteratorFor(items)
	  }
	
	  if (support.iterable) {
	    Headers.prototype[Symbol.iterator] = Headers.prototype.entries
	  }
	
	  function consumed(body) {
	    if (body.bodyUsed) {
	      return Promise.reject(new TypeError('Already read'))
	    }
	    body.bodyUsed = true
	  }
	
	  function fileReaderReady(reader) {
	    return new Promise(function(resolve, reject) {
	      reader.onload = function() {
	        resolve(reader.result)
	      }
	      reader.onerror = function() {
	        reject(reader.error)
	      }
	    })
	  }
	
	  function readBlobAsArrayBuffer(blob) {
	    var reader = new FileReader()
	    var promise = fileReaderReady(reader)
	    reader.readAsArrayBuffer(blob)
	    return promise
	  }
	
	  function readBlobAsText(blob) {
	    var reader = new FileReader()
	    var promise = fileReaderReady(reader)
	    reader.readAsText(blob)
	    return promise
	  }
	
	  function readArrayBufferAsText(buf) {
	    var view = new Uint8Array(buf)
	    var chars = new Array(view.length)
	
	    for (var i = 0; i < view.length; i++) {
	      chars[i] = String.fromCharCode(view[i])
	    }
	    return chars.join('')
	  }
	
	  function bufferClone(buf) {
	    if (buf.slice) {
	      return buf.slice(0)
	    } else {
	      var view = new Uint8Array(buf.byteLength)
	      view.set(new Uint8Array(buf))
	      return view.buffer
	    }
	  }
	
	  function Body() {
	    this.bodyUsed = false
	
	    this._initBody = function(body) {
	      this._bodyInit = body
	      if (!body) {
	        this._bodyText = ''
	      } else if (typeof body === 'string') {
	        this._bodyText = body
	      } else if (support.blob && Blob.prototype.isPrototypeOf(body)) {
	        this._bodyBlob = body
	      } else if (support.formData && FormData.prototype.isPrototypeOf(body)) {
	        this._bodyFormData = body
	      } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
	        this._bodyText = body.toString()
	      } else if (support.arrayBuffer && support.blob && isDataView(body)) {
	        this._bodyArrayBuffer = bufferClone(body.buffer)
	        // IE 10-11 can't handle a DataView body.
	        this._bodyInit = new Blob([this._bodyArrayBuffer])
	      } else if (support.arrayBuffer && (ArrayBuffer.prototype.isPrototypeOf(body) || isArrayBufferView(body))) {
	        this._bodyArrayBuffer = bufferClone(body)
	      } else {
	        throw new Error('unsupported BodyInit type')
	      }
	
	      if (!this.headers.get('content-type')) {
	        if (typeof body === 'string') {
	          this.headers.set('content-type', 'text/plain;charset=UTF-8')
	        } else if (this._bodyBlob && this._bodyBlob.type) {
	          this.headers.set('content-type', this._bodyBlob.type)
	        } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
	          this.headers.set('content-type', 'application/x-www-form-urlencoded;charset=UTF-8')
	        }
	      }
	    }
	
	    if (support.blob) {
	      this.blob = function() {
	        var rejected = consumed(this)
	        if (rejected) {
	          return rejected
	        }
	
	        if (this._bodyBlob) {
	          return Promise.resolve(this._bodyBlob)
	        } else if (this._bodyArrayBuffer) {
	          return Promise.resolve(new Blob([this._bodyArrayBuffer]))
	        } else if (this._bodyFormData) {
	          throw new Error('could not read FormData body as blob')
	        } else {
	          return Promise.resolve(new Blob([this._bodyText]))
	        }
	      }
	
	      this.arrayBuffer = function() {
	        if (this._bodyArrayBuffer) {
	          return consumed(this) || Promise.resolve(this._bodyArrayBuffer)
	        } else {
	          return this.blob().then(readBlobAsArrayBuffer)
	        }
	      }
	    }
	
	    this.text = function() {
	      var rejected = consumed(this)
	      if (rejected) {
	        return rejected
	      }
	
	      if (this._bodyBlob) {
	        return readBlobAsText(this._bodyBlob)
	      } else if (this._bodyArrayBuffer) {
	        return Promise.resolve(readArrayBufferAsText(this._bodyArrayBuffer))
	      } else if (this._bodyFormData) {
	        throw new Error('could not read FormData body as text')
	      } else {
	        return Promise.resolve(this._bodyText)
	      }
	    }
	
	    if (support.formData) {
	      this.formData = function() {
	        return this.text().then(decode)
	      }
	    }
	
	    this.json = function() {
	      return this.text().then(JSON.parse)
	    }
	
	    return this
	  }
	
	  // HTTP methods whose capitalization should be normalized
	  var methods = ['DELETE', 'GET', 'HEAD', 'OPTIONS', 'POST', 'PUT']
	
	  function normalizeMethod(method) {
	    var upcased = method.toUpperCase()
	    return (methods.indexOf(upcased) > -1) ? upcased : method
	  }
	
	  function Request(input, options) {
	    options = options || {}
	    var body = options.body
	
	    if (input instanceof Request) {
	      if (input.bodyUsed) {
	        throw new TypeError('Already read')
	      }
	      this.url = input.url
	      this.credentials = input.credentials
	      if (!options.headers) {
	        this.headers = new Headers(input.headers)
	      }
	      this.method = input.method
	      this.mode = input.mode
	      if (!body && input._bodyInit != null) {
	        body = input._bodyInit
	        input.bodyUsed = true
	      }
	    } else {
	      this.url = String(input)
	    }
	
	    this.credentials = options.credentials || this.credentials || 'omit'
	    if (options.headers || !this.headers) {
	      this.headers = new Headers(options.headers)
	    }
	    this.method = normalizeMethod(options.method || this.method || 'GET')
	    this.mode = options.mode || this.mode || null
	    this.referrer = null
	
	    if ((this.method === 'GET' || this.method === 'HEAD') && body) {
	      throw new TypeError('Body not allowed for GET or HEAD requests')
	    }
	    this._initBody(body)
	  }
	
	  Request.prototype.clone = function() {
	    return new Request(this, { body: this._bodyInit })
	  }
	
	  function decode(body) {
	    var form = new FormData()
	    body.trim().split('&').forEach(function(bytes) {
	      if (bytes) {
	        var split = bytes.split('=')
	        var name = split.shift().replace(/\+/g, ' ')
	        var value = split.join('=').replace(/\+/g, ' ')
	        form.append(decodeURIComponent(name), decodeURIComponent(value))
	      }
	    })
	    return form
	  }
	
	  function parseHeaders(rawHeaders) {
	    var headers = new Headers()
	    // Replace instances of \r\n and \n followed by at least one space or horizontal tab with a space
	    // https://tools.ietf.org/html/rfc7230#section-3.2
	    var preProcessedHeaders = rawHeaders.replace(/\r?\n[\t ]+/g, ' ')
	    preProcessedHeaders.split(/\r?\n/).forEach(function(line) {
	      var parts = line.split(':')
	      var key = parts.shift().trim()
	      if (key) {
	        var value = parts.join(':').trim()
	        headers.append(key, value)
	      }
	    })
	    return headers
	  }
	
	  Body.call(Request.prototype)
	
	  function Response(bodyInit, options) {
	    if (!options) {
	      options = {}
	    }
	
	    this.type = 'default'
	    this.status = options.status === undefined ? 200 : options.status
	    this.ok = this.status >= 200 && this.status < 300
	    this.statusText = 'statusText' in options ? options.statusText : 'OK'
	    this.headers = new Headers(options.headers)
	    this.url = options.url || ''
	    this._initBody(bodyInit)
	  }
	
	  Body.call(Response.prototype)
	
	  Response.prototype.clone = function() {
	    return new Response(this._bodyInit, {
	      status: this.status,
	      statusText: this.statusText,
	      headers: new Headers(this.headers),
	      url: this.url
	    })
	  }
	
	  Response.error = function() {
	    var response = new Response(null, {status: 0, statusText: ''})
	    response.type = 'error'
	    return response
	  }
	
	  var redirectStatuses = [301, 302, 303, 307, 308]
	
	  Response.redirect = function(url, status) {
	    if (redirectStatuses.indexOf(status) === -1) {
	      throw new RangeError('Invalid status code')
	    }
	
	    return new Response(null, {status: status, headers: {location: url}})
	  }
	
	  self.Headers = Headers
	  self.Request = Request
	  self.Response = Response
	
	  self.fetch = function(input, init) {
	    return new Promise(function(resolve, reject) {
	      var request = new Request(input, init)
	      var xhr = new XMLHttpRequest()
	
	      xhr.onload = function() {
	        var options = {
	          status: xhr.status,
	          statusText: xhr.statusText,
	          headers: parseHeaders(xhr.getAllResponseHeaders() || '')
	        }
	        options.url = 'responseURL' in xhr ? xhr.responseURL : options.headers.get('X-Request-URL')
	        var body = 'response' in xhr ? xhr.response : xhr.responseText
	        resolve(new Response(body, options))
	      }
	
	      xhr.onerror = function() {
	        reject(new TypeError('Network request failed'))
	      }
	
	      xhr.ontimeout = function() {
	        reject(new TypeError('Network request failed'))
	      }
	
	      xhr.open(request.method, request.url, true)
	
	      if (request.credentials === 'include') {
	        xhr.withCredentials = true
	      } else if (request.credentials === 'omit') {
	        xhr.withCredentials = false
	      }
	
	      if ('responseType' in xhr && support.blob) {
	        xhr.responseType = 'blob'
	      }
	
	      request.headers.forEach(function(value, name) {
	        xhr.setRequestHeader(name, value)
	      })
	
	      xhr.send(typeof request._bodyInit === 'undefined' ? null : request._bodyInit)
	    })
	  }
	  self.fetch.polyfill = true
	})(typeof self !== 'undefined' ? self : this);


/***/ },
/* 1522 */
/***/ function(module, exports) {

	var toString = Object.prototype.toString
	
	module.exports = isString
	
	function isString(obj) {
	    return toString.call(obj) === "[object String]"
	}


/***/ },
/* 1523 */
/***/ function(module, exports) {

	/* (ignored) */

/***/ },
/* 1524 */
1523,
/* 1525 */
1523
/******/ ])));


// WEBPACK FOOTER //
// static/js/main.24647b0c.js